
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire6626"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire6626"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("7B2bR", function(module, exports) {

$parcel$export(module.exports, "Fragment", () => $587db01302e19550$export$ffb0004e005737fa, (v) => $587db01302e19550$export$ffb0004e005737fa = v);
$parcel$export(module.exports, "jsx", () => $587db01302e19550$export$34b9dba7ce09269b, (v) => $587db01302e19550$export$34b9dba7ce09269b = v);
$parcel$export(module.exports, "jsxs", () => $587db01302e19550$export$25062201e9e25d76, (v) => $587db01302e19550$export$25062201e9e25d76 = v);
/**
 * @license React
 * react-jsx-runtime.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $587db01302e19550$export$ffb0004e005737fa;
var $587db01302e19550$export$34b9dba7ce09269b;
var $587db01302e19550$export$25062201e9e25d76;
"use strict";

(function() {
    "use strict";
    var React = (parcelRequire("acw62"));
    // ATTENTION
    // When adding new symbols to this file,
    // Please consider also adding to 'react-devtools-shared/src/backend/ReactSymbols'
    // The Symbol used to tag the ReactElement-like types.
    var REACT_ELEMENT_TYPE = Symbol.for("react.element");
    var REACT_PORTAL_TYPE = Symbol.for("react.portal");
    var REACT_FRAGMENT_TYPE = Symbol.for("react.fragment");
    var REACT_STRICT_MODE_TYPE = Symbol.for("react.strict_mode");
    var REACT_PROFILER_TYPE = Symbol.for("react.profiler");
    var REACT_PROVIDER_TYPE = Symbol.for("react.provider");
    var REACT_CONTEXT_TYPE = Symbol.for("react.context");
    var REACT_FORWARD_REF_TYPE = Symbol.for("react.forward_ref");
    var REACT_SUSPENSE_TYPE = Symbol.for("react.suspense");
    var REACT_SUSPENSE_LIST_TYPE = Symbol.for("react.suspense_list");
    var REACT_MEMO_TYPE = Symbol.for("react.memo");
    var REACT_LAZY_TYPE = Symbol.for("react.lazy");
    var REACT_OFFSCREEN_TYPE = Symbol.for("react.offscreen");
    var MAYBE_ITERATOR_SYMBOL = Symbol.iterator;
    var FAUX_ITERATOR_SYMBOL = "@@iterator";
    function getIteratorFn(maybeIterable) {
        if (maybeIterable === null || typeof maybeIterable !== "object") return null;
        var maybeIterator = MAYBE_ITERATOR_SYMBOL && maybeIterable[MAYBE_ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL];
        if (typeof maybeIterator === "function") return maybeIterator;
        return null;
    }
    var ReactSharedInternals = React.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function error(format) {
        for(var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++)args[_key2 - 1] = arguments[_key2];
        printWarning("error", format, args);
    }
    function printWarning(level, format, args) {
        var ReactDebugCurrentFrame = ReactSharedInternals.ReactDebugCurrentFrame;
        var stack = ReactDebugCurrentFrame.getStackAddendum();
        if (stack !== "") {
            format += "%s";
            args = args.concat([
                stack
            ]);
        } // eslint-disable-next-line react-internal/safe-string-coercion
        var argsWithFormat = args.map(function(item) {
            return String(item);
        }); // Careful: RN currently depends on this prefix
        argsWithFormat.unshift("Warning: " + format); // We intentionally don't use spread (or .apply) directly because it
        // breaks IE9: https://github.com/facebook/react/issues/13610
        // eslint-disable-next-line react-internal/no-production-logging
        Function.prototype.apply.call(console[level], console, argsWithFormat);
    }
    // -----------------------------------------------------------------------------
    var enableScopeAPI = false; // Experimental Create Event Handle API.
    var enableCacheElement = false;
    var enableTransitionTracing = false; // No known bugs, but needs performance testing
    var enableLegacyHidden = false; // Enables unstable_avoidThisFallback feature in Fiber
    // stuff. Intended to enable React core members to more easily debug scheduling
    // issues in DEV builds.
    var enableDebugTracing = false; // Track which Fiber(s) schedule render work.
    var REACT_MODULE_REFERENCE;
    REACT_MODULE_REFERENCE = Symbol.for("react.module.reference");
    function isValidElementType(type) {
        if (typeof type === "string" || typeof type === "function") return true;
         // Note: typeof might be other than 'symbol' or 'number' (e.g. if it's a polyfill).
        if (type === REACT_FRAGMENT_TYPE || type === REACT_PROFILER_TYPE || enableDebugTracing || type === REACT_STRICT_MODE_TYPE || type === REACT_SUSPENSE_TYPE || type === REACT_SUSPENSE_LIST_TYPE || enableLegacyHidden || type === REACT_OFFSCREEN_TYPE || enableScopeAPI || enableCacheElement || enableTransitionTracing) return true;
        if (typeof type === "object" && type !== null) {
            if (type.$$typeof === REACT_LAZY_TYPE || type.$$typeof === REACT_MEMO_TYPE || type.$$typeof === REACT_PROVIDER_TYPE || type.$$typeof === REACT_CONTEXT_TYPE || type.$$typeof === REACT_FORWARD_REF_TYPE || // This needs to include all possible module reference object
            // types supported by any Flight configuration anywhere since
            // we don't know which Flight build this will end up being used
            // with.
            type.$$typeof === REACT_MODULE_REFERENCE || type.getModuleId !== undefined) return true;
        }
        return false;
    }
    function getWrappedName(outerType, innerType, wrapperName) {
        var displayName = outerType.displayName;
        if (displayName) return displayName;
        var functionName = innerType.displayName || innerType.name || "";
        return functionName !== "" ? wrapperName + "(" + functionName + ")" : wrapperName;
    } // Keep in sync with react-reconciler/getComponentNameFromFiber
    function getContextName(type) {
        return type.displayName || "Context";
    } // Note that the reconciler package should generally prefer to use getComponentNameFromFiber() instead.
    function getComponentNameFromType(type) {
        if (type == null) // Host root, text node or just invalid type.
        return null;
        if (typeof type.tag === "number") error("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue.");
        if (typeof type === "function") return type.displayName || type.name || null;
        if (typeof type === "string") return type;
        switch(type){
            case REACT_FRAGMENT_TYPE:
                return "Fragment";
            case REACT_PORTAL_TYPE:
                return "Portal";
            case REACT_PROFILER_TYPE:
                return "Profiler";
            case REACT_STRICT_MODE_TYPE:
                return "StrictMode";
            case REACT_SUSPENSE_TYPE:
                return "Suspense";
            case REACT_SUSPENSE_LIST_TYPE:
                return "SuspenseList";
        }
        if (typeof type === "object") switch(type.$$typeof){
            case REACT_CONTEXT_TYPE:
                var context = type;
                return getContextName(context) + ".Consumer";
            case REACT_PROVIDER_TYPE:
                var provider = type;
                return getContextName(provider._context) + ".Provider";
            case REACT_FORWARD_REF_TYPE:
                return getWrappedName(type, type.render, "ForwardRef");
            case REACT_MEMO_TYPE:
                var outerName = type.displayName || null;
                if (outerName !== null) return outerName;
                return getComponentNameFromType(type.type) || "Memo";
            case REACT_LAZY_TYPE:
                var lazyComponent = type;
                var payload = lazyComponent._payload;
                var init = lazyComponent._init;
                try {
                    return getComponentNameFromType(init(payload));
                } catch (x) {
                    return null;
                }
        }
        return null;
    }
    var assign = Object.assign;
    // Helpers to patch console.logs to avoid logging during side-effect free
    // replaying on render function. This currently only patches the object
    // lazily which won't cover if the log function was extracted eagerly.
    // We could also eagerly patch the method.
    var disabledDepth = 0;
    var prevLog;
    var prevInfo;
    var prevWarn;
    var prevError;
    var prevGroup;
    var prevGroupCollapsed;
    var prevGroupEnd;
    function disabledLog() {}
    disabledLog.__reactDisabledLog = true;
    function disableLogs() {
        if (disabledDepth === 0) {
            /* eslint-disable react-internal/no-production-logging */ prevLog = console.log;
            prevInfo = console.info;
            prevWarn = console.warn;
            prevError = console.error;
            prevGroup = console.group;
            prevGroupCollapsed = console.groupCollapsed;
            prevGroupEnd = console.groupEnd; // https://github.com/facebook/react/issues/19099
            var props = {
                configurable: true,
                enumerable: true,
                value: disabledLog,
                writable: true
            }; // $FlowFixMe Flow thinks console is immutable.
            Object.defineProperties(console, {
                info: props,
                log: props,
                warn: props,
                error: props,
                group: props,
                groupCollapsed: props,
                groupEnd: props
            });
        /* eslint-enable react-internal/no-production-logging */ }
        disabledDepth++;
    }
    function reenableLogs() {
        disabledDepth--;
        if (disabledDepth === 0) {
            /* eslint-disable react-internal/no-production-logging */ var props = {
                configurable: true,
                enumerable: true,
                writable: true
            }; // $FlowFixMe Flow thinks console is immutable.
            Object.defineProperties(console, {
                log: assign({}, props, {
                    value: prevLog
                }),
                info: assign({}, props, {
                    value: prevInfo
                }),
                warn: assign({}, props, {
                    value: prevWarn
                }),
                error: assign({}, props, {
                    value: prevError
                }),
                group: assign({}, props, {
                    value: prevGroup
                }),
                groupCollapsed: assign({}, props, {
                    value: prevGroupCollapsed
                }),
                groupEnd: assign({}, props, {
                    value: prevGroupEnd
                })
            });
        /* eslint-enable react-internal/no-production-logging */ }
        if (disabledDepth < 0) error("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
    }
    var ReactCurrentDispatcher = ReactSharedInternals.ReactCurrentDispatcher;
    var prefix;
    function describeBuiltInComponentFrame(name, source, ownerFn) {
        if (prefix === undefined) // Extract the VM specific prefix used by each line.
        try {
            throw Error();
        } catch (x) {
            var match = x.stack.trim().match(/\n( *(at )?)/);
            prefix = match && match[1] || "";
        }
         // We use the prefix to ensure our stacks line up with native stack frames.
        return "\n" + prefix + name;
    }
    var reentry = false;
    var componentFrameCache;
    var PossiblyWeakMap = typeof WeakMap === "function" ? WeakMap : Map;
    componentFrameCache = new PossiblyWeakMap();
    function describeNativeComponentFrame(fn, construct) {
        // If something asked for a stack inside a fake render, it should get ignored.
        if (!fn || reentry) return "";
        var frame = componentFrameCache.get(fn);
        if (frame !== undefined) return frame;
        var control;
        reentry = true;
        var previousPrepareStackTrace = Error.prepareStackTrace; // $FlowFixMe It does accept undefined.
        Error.prepareStackTrace = undefined;
        var previousDispatcher;
        previousDispatcher = ReactCurrentDispatcher.current; // Set the dispatcher in DEV because this might be call in the render function
        // for warnings.
        ReactCurrentDispatcher.current = null;
        disableLogs();
        try {
            // This should throw.
            if (construct) {
                // Something should be setting the props in the constructor.
                var Fake = function() {
                    throw Error();
                }; // $FlowFixMe
                Object.defineProperty(Fake.prototype, "props", {
                    set: function() {
                        // We use a throwing setter instead of frozen or non-writable props
                        // because that won't throw in a non-strict mode function.
                        throw Error();
                    }
                });
                if (typeof Reflect === "object" && Reflect.construct) {
                    // We construct a different control for this case to include any extra
                    // frames added by the construct call.
                    try {
                        Reflect.construct(Fake, []);
                    } catch (x) {
                        control = x;
                    }
                    Reflect.construct(fn, [], Fake);
                } else {
                    try {
                        Fake.call();
                    } catch (x) {
                        control = x;
                    }
                    fn.call(Fake.prototype);
                }
            } else {
                try {
                    throw Error();
                } catch (x) {
                    control = x;
                }
                fn();
            }
        } catch (sample) {
            // This is inlined manually because closure doesn't do it for us.
            if (sample && control && typeof sample.stack === "string") {
                // This extracts the first frame from the sample that isn't also in the control.
                // Skipping one frame that we assume is the frame that calls the two.
                var sampleLines = sample.stack.split("\n");
                var controlLines = control.stack.split("\n");
                var s = sampleLines.length - 1;
                var c = controlLines.length - 1;
                while(s >= 1 && c >= 0 && sampleLines[s] !== controlLines[c])// We expect at least one stack frame to be shared.
                // Typically this will be the root most one. However, stack frames may be
                // cut off due to maximum stack limits. In this case, one maybe cut off
                // earlier than the other. We assume that the sample is longer or the same
                // and there for cut off earlier. So we should find the root most frame in
                // the sample somewhere in the control.
                c--;
                for(; s >= 1 && c >= 0; s--, c--)// Next we find the first one that isn't the same which should be the
                // frame that called our sample function and the control.
                if (sampleLines[s] !== controlLines[c]) {
                    // In V8, the first line is describing the message but other VMs don't.
                    // If we're about to return the first line, and the control is also on the same
                    // line, that's a pretty good indicator that our sample threw at same line as
                    // the control. I.e. before we entered the sample frame. So we ignore this result.
                    // This can happen if you passed a class to function component, or non-function.
                    if (s !== 1 || c !== 1) do {
                        s--;
                        c--; // We may still have similar intermediate frames from the construct call.
                        // The next one that isn't the same should be our match though.
                        if (c < 0 || sampleLines[s] !== controlLines[c]) {
                            // V8 adds a "new" prefix for native classes. Let's remove it to make it prettier.
                            var _frame = "\n" + sampleLines[s].replace(" at new ", " at "); // If our component frame is labeled "<anonymous>"
                            // but we have a user-provided "displayName"
                            // splice it in to make the stack more readable.
                            if (fn.displayName && _frame.includes("<anonymous>")) _frame = _frame.replace("<anonymous>", fn.displayName);
                            if (typeof fn === "function") componentFrameCache.set(fn, _frame);
                            return _frame;
                        }
                    }while (s >= 1 && c >= 0);
                    break;
                }
            }
        } finally{
            reentry = false;
            ReactCurrentDispatcher.current = previousDispatcher;
            reenableLogs();
            Error.prepareStackTrace = previousPrepareStackTrace;
        } // Fallback to just using the name if we couldn't make it throw.
        var name = fn ? fn.displayName || fn.name : "";
        var syntheticFrame = name ? describeBuiltInComponentFrame(name) : "";
        if (typeof fn === "function") componentFrameCache.set(fn, syntheticFrame);
        return syntheticFrame;
    }
    function describeFunctionComponentFrame(fn, source, ownerFn) {
        return describeNativeComponentFrame(fn, false);
    }
    function shouldConstruct(Component) {
        var prototype = Component.prototype;
        return !!(prototype && prototype.isReactComponent);
    }
    function describeUnknownElementTypeFrameInDEV(type, source, ownerFn) {
        if (type == null) return "";
        if (typeof type === "function") return describeNativeComponentFrame(type, shouldConstruct(type));
        if (typeof type === "string") return describeBuiltInComponentFrame(type);
        switch(type){
            case REACT_SUSPENSE_TYPE:
                return describeBuiltInComponentFrame("Suspense");
            case REACT_SUSPENSE_LIST_TYPE:
                return describeBuiltInComponentFrame("SuspenseList");
        }
        if (typeof type === "object") switch(type.$$typeof){
            case REACT_FORWARD_REF_TYPE:
                return describeFunctionComponentFrame(type.render);
            case REACT_MEMO_TYPE:
                // Memo may contain any component type so we recursively resolve it.
                return describeUnknownElementTypeFrameInDEV(type.type, source, ownerFn);
            case REACT_LAZY_TYPE:
                var lazyComponent = type;
                var payload = lazyComponent._payload;
                var init = lazyComponent._init;
                try {
                    // Lazy may contain any component type so we recursively resolve it.
                    return describeUnknownElementTypeFrameInDEV(init(payload), source, ownerFn);
                } catch (x) {}
        }
        return "";
    }
    var hasOwnProperty = Object.prototype.hasOwnProperty;
    var loggedTypeFailures = {};
    var ReactDebugCurrentFrame = ReactSharedInternals.ReactDebugCurrentFrame;
    function setCurrentlyValidatingElement(element) {
        if (element) {
            var owner = element._owner;
            var stack = describeUnknownElementTypeFrameInDEV(element.type, element._source, owner ? owner.type : null);
            ReactDebugCurrentFrame.setExtraStackFrame(stack);
        } else ReactDebugCurrentFrame.setExtraStackFrame(null);
    }
    function checkPropTypes(typeSpecs, values, location, componentName, element) {
        // $FlowFixMe This is okay but Flow doesn't know it.
        var has = Function.call.bind(hasOwnProperty);
        for(var typeSpecName in typeSpecs)if (has(typeSpecs, typeSpecName)) {
            var error$1 = void 0; // Prop type validation may throw. In case they do, we don't want to
            // fail the render phase where it didn't fail before. So we log it.
            // After these have been cleaned up, we'll let them throw.
            try {
                // This is intentionally an invariant that gets caught. It's the same
                // behavior as without this statement except with a better message.
                if (typeof typeSpecs[typeSpecName] !== "function") {
                    // eslint-disable-next-line react-internal/prod-error-codes
                    var err = Error((componentName || "React class") + ": " + location + " type `" + typeSpecName + "` is invalid; " + "it must be a function, usually from the `prop-types` package, but received `" + typeof typeSpecs[typeSpecName] + "`." + "This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                    err.name = "Invariant Violation";
                    throw err;
                }
                error$1 = typeSpecs[typeSpecName](values, typeSpecName, componentName, location, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (ex) {
                error$1 = ex;
            }
            if (error$1 && !(error$1 instanceof Error)) {
                setCurrentlyValidatingElement(element);
                error("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", componentName || "React class", location, typeSpecName, typeof error$1);
                setCurrentlyValidatingElement(null);
            }
            if (error$1 instanceof Error && !(error$1.message in loggedTypeFailures)) {
                // Only monitor this failure once because there tends to be a lot of the
                // same error.
                loggedTypeFailures[error$1.message] = true;
                setCurrentlyValidatingElement(element);
                error("Failed %s type: %s", location, error$1.message);
                setCurrentlyValidatingElement(null);
            }
        }
    }
    var isArrayImpl = Array.isArray; // eslint-disable-next-line no-redeclare
    function isArray(a) {
        return isArrayImpl(a);
    }
    /*
 * The `'' + value` pattern (used in in perf-sensitive code) throws for Symbol
 * and Temporal.* types. See https://github.com/facebook/react/pull/22064.
 *
 * The functions in this module will throw an easier-to-understand,
 * easier-to-debug exception with a clear errors message message explaining the
 * problem. (Instead of a confusing exception thrown inside the implementation
 * of the `value` object).
 */ // $FlowFixMe only called in DEV, so void return is not possible.
    function typeName(value) {
        // toStringTag is needed for namespaced types like Temporal.Instant
        var hasToStringTag = typeof Symbol === "function" && Symbol.toStringTag;
        var type = hasToStringTag && value[Symbol.toStringTag] || value.constructor.name || "Object";
        return type;
    } // $FlowFixMe only called in DEV, so void return is not possible.
    function willCoercionThrow(value) {
        try {
            testStringCoercion(value);
            return false;
        } catch (e) {
            return true;
        }
    }
    function testStringCoercion(value) {
        // If you ended up here by following an exception call stack, here's what's
        // happened: you supplied an object or symbol value to React (as a prop, key,
        // DOM attribute, CSS property, string ref, etc.) and when React tried to
        // coerce it to a string using `'' + value`, an exception was thrown.
        //
        // The most common types that will cause this exception are `Symbol` instances
        // and Temporal objects like `Temporal.Instant`. But any object that has a
        // `valueOf` or `[Symbol.toPrimitive]` method that throws will also cause this
        // exception. (Library authors do this to prevent users from using built-in
        // numeric operators like `+` or comparison operators like `>=` because custom
        // methods are needed to perform accurate arithmetic or comparison.)
        //
        // To fix the problem, coerce this object or symbol value to a string before
        // passing it to React. The most reliable way is usually `String(value)`.
        //
        // To find which value is throwing, check the browser or debugger console.
        // Before this exception was thrown, there should be `console.error` output
        // that shows the type (Symbol, Temporal.PlainDate, etc.) that caused the
        // problem and how that type was used: key, atrribute, input value prop, etc.
        // In most cases, this console output also shows the component and its
        // ancestor components where the exception happened.
        //
        // eslint-disable-next-line react-internal/safe-string-coercion
        return "" + value;
    }
    function checkKeyStringCoercion(value) {
        if (willCoercionThrow(value)) {
            error("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", typeName(value));
            return testStringCoercion(value); // throw (to help callers find troubleshooting comments)
        }
    }
    var ReactCurrentOwner = ReactSharedInternals.ReactCurrentOwner;
    var RESERVED_PROPS = {
        key: true,
        ref: true,
        __self: true,
        __source: true
    };
    var specialPropKeyWarningShown;
    var specialPropRefWarningShown;
    var didWarnAboutStringRefs;
    didWarnAboutStringRefs = {};
    function hasValidRef(config) {
        if (hasOwnProperty.call(config, "ref")) {
            var getter = Object.getOwnPropertyDescriptor(config, "ref").get;
            if (getter && getter.isReactWarning) return false;
        }
        return config.ref !== undefined;
    }
    function hasValidKey(config) {
        if (hasOwnProperty.call(config, "key")) {
            var getter = Object.getOwnPropertyDescriptor(config, "key").get;
            if (getter && getter.isReactWarning) return false;
        }
        return config.key !== undefined;
    }
    function warnIfStringRefCannotBeAutoConverted(config, self) {
        if (typeof config.ref === "string" && ReactCurrentOwner.current && self && ReactCurrentOwner.current.stateNode !== self) {
            var componentName = getComponentNameFromType(ReactCurrentOwner.current.type);
            if (!didWarnAboutStringRefs[componentName]) {
                error('Component "%s" contains the string ref "%s". Support for string refs will be removed in a future major release. This case cannot be automatically converted to an arrow function. We ask you to manually fix this case by using useRef() or createRef() instead. Learn more about using refs safely here: https://reactjs.org/link/strict-mode-string-ref', getComponentNameFromType(ReactCurrentOwner.current.type), config.ref);
                didWarnAboutStringRefs[componentName] = true;
            }
        }
    }
    function defineKeyPropWarningGetter(props, displayName) {
        var warnAboutAccessingKey = function() {
            if (!specialPropKeyWarningShown) {
                specialPropKeyWarningShown = true;
                error("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", displayName);
            }
        };
        warnAboutAccessingKey.isReactWarning = true;
        Object.defineProperty(props, "key", {
            get: warnAboutAccessingKey,
            configurable: true
        });
    }
    function defineRefPropWarningGetter(props, displayName) {
        var warnAboutAccessingRef = function() {
            if (!specialPropRefWarningShown) {
                specialPropRefWarningShown = true;
                error("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", displayName);
            }
        };
        warnAboutAccessingRef.isReactWarning = true;
        Object.defineProperty(props, "ref", {
            get: warnAboutAccessingRef,
            configurable: true
        });
    }
    /**
 * Factory method to create a new React element. This no longer adheres to
 * the class pattern, so do not use new to call it. Also, instanceof check
 * will not work. Instead test $$typeof field against Symbol.for('react.element') to check
 * if something is a React Element.
 *
 * @param {*} type
 * @param {*} props
 * @param {*} key
 * @param {string|object} ref
 * @param {*} owner
 * @param {*} self A *temporary* helper to detect places where `this` is
 * different from the `owner` when React.createElement is called, so that we
 * can warn. We want to get rid of owner and replace string `ref`s with arrow
 * functions, and as long as `this` and owner are the same, there will be no
 * change in behavior.
 * @param {*} source An annotation object (added by a transpiler or otherwise)
 * indicating filename, line number, and/or other information.
 * @internal
 */ var ReactElement = function(type, key, ref, self, source, owner, props) {
        var element = {
            // This tag allows us to uniquely identify this as a React Element
            $$typeof: REACT_ELEMENT_TYPE,
            // Built-in properties that belong on the element
            type: type,
            key: key,
            ref: ref,
            props: props,
            // Record the component responsible for creating this element.
            _owner: owner
        };
        // The validation flag is currently mutative. We put it on
        // an external backing store so that we can freeze the whole object.
        // This can be replaced with a WeakMap once they are implemented in
        // commonly used development environments.
        element._store = {}; // To make comparing ReactElements easier for testing purposes, we make
        // the validation flag non-enumerable (where possible, which should
        // include every environment we run tests in), so the test framework
        // ignores it.
        Object.defineProperty(element._store, "validated", {
            configurable: false,
            enumerable: false,
            writable: true,
            value: false
        }); // self and source are DEV only properties.
        Object.defineProperty(element, "_self", {
            configurable: false,
            enumerable: false,
            writable: false,
            value: self
        }); // Two elements created in two different places should be considered
        // equal for testing purposes and therefore we hide it from enumeration.
        Object.defineProperty(element, "_source", {
            configurable: false,
            enumerable: false,
            writable: false,
            value: source
        });
        if (Object.freeze) {
            Object.freeze(element.props);
            Object.freeze(element);
        }
        return element;
    };
    /**
 * https://github.com/reactjs/rfcs/pull/107
 * @param {*} type
 * @param {object} props
 * @param {string} key
 */ function jsxDEV(type, config, maybeKey, source, self) {
        var propName; // Reserved names are extracted
        var props = {};
        var key = null;
        var ref = null; // Currently, key can be spread in as a prop. This causes a potential
        // issue if key is also explicitly declared (ie. <div {...props} key="Hi" />
        // or <div key="Hi" {...props} /> ). We want to deprecate key spread,
        // but as an intermediary step, we will use jsxDEV for everything except
        // <div {...props} key="Hi" />, because we aren't currently able to tell if
        // key is explicitly declared to be undefined or not.
        if (maybeKey !== undefined) {
            checkKeyStringCoercion(maybeKey);
            key = "" + maybeKey;
        }
        if (hasValidKey(config)) {
            checkKeyStringCoercion(config.key);
            key = "" + config.key;
        }
        if (hasValidRef(config)) {
            ref = config.ref;
            warnIfStringRefCannotBeAutoConverted(config, self);
        } // Remaining properties are added to a new props object
        for(propName in config)if (hasOwnProperty.call(config, propName) && !RESERVED_PROPS.hasOwnProperty(propName)) props[propName] = config[propName];
         // Resolve default props
        if (type && type.defaultProps) {
            var defaultProps = type.defaultProps;
            for(propName in defaultProps)if (props[propName] === undefined) props[propName] = defaultProps[propName];
        }
        if (key || ref) {
            var displayName = typeof type === "function" ? type.displayName || type.name || "Unknown" : type;
            if (key) defineKeyPropWarningGetter(props, displayName);
            if (ref) defineRefPropWarningGetter(props, displayName);
        }
        return ReactElement(type, key, ref, self, source, ReactCurrentOwner.current, props);
    }
    var ReactCurrentOwner$1 = ReactSharedInternals.ReactCurrentOwner;
    var ReactDebugCurrentFrame$1 = ReactSharedInternals.ReactDebugCurrentFrame;
    function setCurrentlyValidatingElement$1(element) {
        if (element) {
            var owner = element._owner;
            var stack = describeUnknownElementTypeFrameInDEV(element.type, element._source, owner ? owner.type : null);
            ReactDebugCurrentFrame$1.setExtraStackFrame(stack);
        } else ReactDebugCurrentFrame$1.setExtraStackFrame(null);
    }
    var propTypesMisspellWarningShown;
    propTypesMisspellWarningShown = false;
    /**
 * Verifies the object is a ReactElement.
 * See https://reactjs.org/docs/react-api.html#isvalidelement
 * @param {?object} object
 * @return {boolean} True if `object` is a ReactElement.
 * @final
 */ function isValidElement(object) {
        return typeof object === "object" && object !== null && object.$$typeof === REACT_ELEMENT_TYPE;
    }
    function getDeclarationErrorAddendum() {
        if (ReactCurrentOwner$1.current) {
            var name = getComponentNameFromType(ReactCurrentOwner$1.current.type);
            if (name) return "\n\nCheck the render method of `" + name + "`.";
        }
        return "";
    }
    function getSourceInfoErrorAddendum(source) {
        if (source !== undefined) {
            var fileName = source.fileName.replace(/^.*[\\\/]/, "");
            var lineNumber = source.lineNumber;
            return "\n\nCheck your code at " + fileName + ":" + lineNumber + ".";
        }
        return "";
    }
    /**
 * Warn if there's no key explicitly set on dynamic arrays of children or
 * object keys are not valid. This allows us to keep track of children between
 * updates.
 */ var ownerHasKeyUseWarning = {};
    function getCurrentComponentErrorInfo(parentType) {
        var info = getDeclarationErrorAddendum();
        if (!info) {
            var parentName = typeof parentType === "string" ? parentType : parentType.displayName || parentType.name;
            if (parentName) info = "\n\nCheck the top-level render call using <" + parentName + ">.";
        }
        return info;
    }
    /**
 * Warn if the element doesn't have an explicit key assigned to it.
 * This element is in an array. The array could grow and shrink or be
 * reordered. All children that haven't already been validated are required to
 * have a "key" property assigned to it. Error statuses are cached so a warning
 * will only be shown once.
 *
 * @internal
 * @param {ReactElement} element Element that requires a key.
 * @param {*} parentType element's parent's type.
 */ function validateExplicitKey(element, parentType) {
        if (!element._store || element._store.validated || element.key != null) return;
        element._store.validated = true;
        var currentComponentErrorInfo = getCurrentComponentErrorInfo(parentType);
        if (ownerHasKeyUseWarning[currentComponentErrorInfo]) return;
        ownerHasKeyUseWarning[currentComponentErrorInfo] = true; // Usually the current owner is the offender, but if it accepts children as a
        // property, it may be the creator of the child that's responsible for
        // assigning it a key.
        var childOwner = "";
        if (element && element._owner && element._owner !== ReactCurrentOwner$1.current) // Give the component that originally created this child.
        childOwner = " It was passed a child from " + getComponentNameFromType(element._owner.type) + ".";
        setCurrentlyValidatingElement$1(element);
        error('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', currentComponentErrorInfo, childOwner);
        setCurrentlyValidatingElement$1(null);
    }
    /**
 * Ensure that every element either is passed in a static location, in an
 * array with an explicit keys property defined, or in an object literal
 * with valid key property.
 *
 * @internal
 * @param {ReactNode} node Statically passed child of any type.
 * @param {*} parentType node's parent's type.
 */ function validateChildKeys(node, parentType) {
        if (typeof node !== "object") return;
        if (isArray(node)) for(var i = 0; i < node.length; i++){
            var child = node[i];
            if (isValidElement(child)) validateExplicitKey(child, parentType);
        }
        else if (isValidElement(node)) // This element was passed in a valid location.
        {
            if (node._store) node._store.validated = true;
        } else if (node) {
            var iteratorFn = getIteratorFn(node);
            if (typeof iteratorFn === "function") // Entry iterators used to provide implicit keys,
            // but now we print a separate warning for them later.
            {
                if (iteratorFn !== node.entries) {
                    var iterator = iteratorFn.call(node);
                    var step;
                    while(!(step = iterator.next()).done)if (isValidElement(step.value)) validateExplicitKey(step.value, parentType);
                }
            }
        }
    }
    /**
 * Given an element, validate that its props follow the propTypes definition,
 * provided by the type.
 *
 * @param {ReactElement} element
 */ function validatePropTypes(element) {
        var type = element.type;
        if (type === null || type === undefined || typeof type === "string") return;
        var propTypes;
        if (typeof type === "function") propTypes = type.propTypes;
        else if (typeof type === "object" && (type.$$typeof === REACT_FORWARD_REF_TYPE || // Note: Memo only checks outer props here.
        // Inner props are checked in the reconciler.
        type.$$typeof === REACT_MEMO_TYPE)) propTypes = type.propTypes;
        else return;
        if (propTypes) {
            // Intentionally inside to avoid triggering lazy initializers:
            var name = getComponentNameFromType(type);
            checkPropTypes(propTypes, element.props, "prop", name, element);
        } else if (type.PropTypes !== undefined && !propTypesMisspellWarningShown) {
            propTypesMisspellWarningShown = true; // Intentionally inside to avoid triggering lazy initializers:
            var _name = getComponentNameFromType(type);
            error("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", _name || "Unknown");
        }
        if (typeof type.getDefaultProps === "function" && !type.getDefaultProps.isReactClassApproved) error("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
    }
    /**
 * Given a fragment, validate that it can only be provided with fragment props
 * @param {ReactElement} fragment
 */ function validateFragmentProps(fragment) {
        var keys = Object.keys(fragment.props);
        for(var i = 0; i < keys.length; i++){
            var key = keys[i];
            if (key !== "children" && key !== "key") {
                setCurrentlyValidatingElement$1(fragment);
                error("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", key);
                setCurrentlyValidatingElement$1(null);
                break;
            }
        }
        if (fragment.ref !== null) {
            setCurrentlyValidatingElement$1(fragment);
            error("Invalid attribute `ref` supplied to `React.Fragment`.");
            setCurrentlyValidatingElement$1(null);
        }
    }
    function jsxWithValidation(type, props, key, isStaticChildren, source, self) {
        var validType = isValidElementType(type); // We warn in this case but don't throw. We expect the element creation to
        // succeed and there will likely be errors in render.
        if (!validType) {
            var info = "";
            if (type === undefined || typeof type === "object" && type !== null && Object.keys(type).length === 0) info += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.";
            var sourceInfo = getSourceInfoErrorAddendum(source);
            if (sourceInfo) info += sourceInfo;
            else info += getDeclarationErrorAddendum();
            var typeString;
            if (type === null) typeString = "null";
            else if (isArray(type)) typeString = "array";
            else if (type !== undefined && type.$$typeof === REACT_ELEMENT_TYPE) {
                typeString = "<" + (getComponentNameFromType(type.type) || "Unknown") + " />";
                info = " Did you accidentally export a JSX literal instead of a component?";
            } else typeString = typeof type;
            error("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", typeString, info);
        }
        var element = jsxDEV(type, props, key, source, self); // The result can be nullish if a mock or a custom function is used.
        // TODO: Drop this when these are no longer allowed as the type argument.
        if (element == null) return element;
         // Skip key warning if the type isn't valid since our key validation logic
        // doesn't expect a non-string/function type and can throw confusing errors.
        // We don't want exception behavior to differ between dev and prod.
        // (Rendering will throw with a helpful message and as soon as the type is
        // fixed, the key warnings will appear.)
        if (validType) {
            var children = props.children;
            if (children !== undefined) {
                if (isStaticChildren) {
                    if (isArray(children)) {
                        for(var i = 0; i < children.length; i++)validateChildKeys(children[i], type);
                        if (Object.freeze) Object.freeze(children);
                    } else error("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
                } else validateChildKeys(children, type);
            }
        }
        if (type === REACT_FRAGMENT_TYPE) validateFragmentProps(element);
        else validatePropTypes(element);
        return element;
    } // These two functions exist to still get child warnings in dev
    // even with the prod transform. This means that jsxDEV is purely
    // opt-in behavior for better messages but that we won't stop
    // giving you warnings if you use production apis.
    function jsxWithValidationStatic(type, props, key) {
        return jsxWithValidation(type, props, key, true);
    }
    function jsxWithValidationDynamic(type, props, key) {
        return jsxWithValidation(type, props, key, false);
    }
    var jsx = jsxWithValidationDynamic; // we may want to special case jsxs internally to take advantage of static children.
    // for now we can ship identical prod functions
    var jsxs = jsxWithValidationStatic;
    $587db01302e19550$export$ffb0004e005737fa = REACT_FRAGMENT_TYPE;
    $587db01302e19550$export$34b9dba7ce09269b = jsx;
    $587db01302e19550$export$25062201e9e25d76 = jsxs;
})();

});
parcelRegister("acw62", function(module, exports) {
"use strict";

module.exports = (parcelRequire("jWQW9"));

});
parcelRegister("jWQW9", function(module, exports) {
/**
 * @license React
 * react.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ "use strict";
(function() {
    "use strict";
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ !== "undefined" && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart === "function") __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart(new Error());
    var ReactVersion = "18.2.0";
    // ATTENTION
    // When adding new symbols to this file,
    // Please consider also adding to 'react-devtools-shared/src/backend/ReactSymbols'
    // The Symbol used to tag the ReactElement-like types.
    var REACT_ELEMENT_TYPE = Symbol.for("react.element");
    var REACT_PORTAL_TYPE = Symbol.for("react.portal");
    var REACT_FRAGMENT_TYPE = Symbol.for("react.fragment");
    var REACT_STRICT_MODE_TYPE = Symbol.for("react.strict_mode");
    var REACT_PROFILER_TYPE = Symbol.for("react.profiler");
    var REACT_PROVIDER_TYPE = Symbol.for("react.provider");
    var REACT_CONTEXT_TYPE = Symbol.for("react.context");
    var REACT_FORWARD_REF_TYPE = Symbol.for("react.forward_ref");
    var REACT_SUSPENSE_TYPE = Symbol.for("react.suspense");
    var REACT_SUSPENSE_LIST_TYPE = Symbol.for("react.suspense_list");
    var REACT_MEMO_TYPE = Symbol.for("react.memo");
    var REACT_LAZY_TYPE = Symbol.for("react.lazy");
    var REACT_OFFSCREEN_TYPE = Symbol.for("react.offscreen");
    var MAYBE_ITERATOR_SYMBOL = Symbol.iterator;
    var FAUX_ITERATOR_SYMBOL = "@@iterator";
    function getIteratorFn(maybeIterable) {
        if (maybeIterable === null || typeof maybeIterable !== "object") return null;
        var maybeIterator = MAYBE_ITERATOR_SYMBOL && maybeIterable[MAYBE_ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL];
        if (typeof maybeIterator === "function") return maybeIterator;
        return null;
    }
    /**
 * Keeps track of the current dispatcher.
 */ var ReactCurrentDispatcher = {
        /**
   * @internal
   * @type {ReactComponent}
   */ current: null
    };
    /**
 * Keeps track of the current batch's configuration such as how long an update
 * should suspend for if it needs to.
 */ var ReactCurrentBatchConfig = {
        transition: null
    };
    var ReactCurrentActQueue = {
        current: null,
        // Used to reproduce behavior of `batchedUpdates` in legacy mode.
        isBatchingLegacy: false,
        didScheduleLegacyUpdate: false
    };
    /**
 * Keeps track of the current owner.
 *
 * The current owner is the component who should own any components that are
 * currently being constructed.
 */ var ReactCurrentOwner = {
        /**
   * @internal
   * @type {ReactComponent}
   */ current: null
    };
    var ReactDebugCurrentFrame = {};
    var currentExtraStackFrame = null;
    function setExtraStackFrame(stack) {
        currentExtraStackFrame = stack;
    }
    ReactDebugCurrentFrame.setExtraStackFrame = function(stack) {
        currentExtraStackFrame = stack;
    }; // Stack implementation injected by the current renderer.
    ReactDebugCurrentFrame.getCurrentStack = null;
    ReactDebugCurrentFrame.getStackAddendum = function() {
        var stack = ""; // Add an extra top frame while an element is being validated
        if (currentExtraStackFrame) stack += currentExtraStackFrame;
         // Delegate to the injected renderer-specific implementation
        var impl = ReactDebugCurrentFrame.getCurrentStack;
        if (impl) stack += impl() || "";
        return stack;
    };
    // -----------------------------------------------------------------------------
    var enableScopeAPI = false; // Experimental Create Event Handle API.
    var enableCacheElement = false;
    var enableTransitionTracing = false; // No known bugs, but needs performance testing
    var enableLegacyHidden = false; // Enables unstable_avoidThisFallback feature in Fiber
    // stuff. Intended to enable React core members to more easily debug scheduling
    // issues in DEV builds.
    var enableDebugTracing = false; // Track which Fiber(s) schedule render work.
    var ReactSharedInternals = {
        ReactCurrentDispatcher: ReactCurrentDispatcher,
        ReactCurrentBatchConfig: ReactCurrentBatchConfig,
        ReactCurrentOwner: ReactCurrentOwner
    };
    ReactSharedInternals.ReactDebugCurrentFrame = ReactDebugCurrentFrame;
    ReactSharedInternals.ReactCurrentActQueue = ReactCurrentActQueue;
    // by calls to these methods by a Babel plugin.
    //
    // In PROD (or in packages without access to React internals),
    // they are left as they are instead.
    function warn(format) {
        for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)args[_key - 1] = arguments[_key];
        printWarning("warn", format, args);
    }
    function error(format) {
        for(var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++)args[_key2 - 1] = arguments[_key2];
        printWarning("error", format, args);
    }
    function printWarning(level, format, args) {
        var ReactDebugCurrentFrame = ReactSharedInternals.ReactDebugCurrentFrame;
        var stack = ReactDebugCurrentFrame.getStackAddendum();
        if (stack !== "") {
            format += "%s";
            args = args.concat([
                stack
            ]);
        } // eslint-disable-next-line react-internal/safe-string-coercion
        var argsWithFormat = args.map(function(item) {
            return String(item);
        }); // Careful: RN currently depends on this prefix
        argsWithFormat.unshift("Warning: " + format); // We intentionally don't use spread (or .apply) directly because it
        // breaks IE9: https://github.com/facebook/react/issues/13610
        // eslint-disable-next-line react-internal/no-production-logging
        Function.prototype.apply.call(console[level], console, argsWithFormat);
    }
    var didWarnStateUpdateForUnmountedComponent = {};
    function warnNoop(publicInstance, callerName) {
        var _constructor = publicInstance.constructor;
        var componentName = _constructor && (_constructor.displayName || _constructor.name) || "ReactClass";
        var warningKey = componentName + "." + callerName;
        if (didWarnStateUpdateForUnmountedComponent[warningKey]) return;
        error("Can't call %s on a component that is not yet mounted. This is a no-op, but it might indicate a bug in your application. Instead, assign to `this.state` directly or define a `state = {};` class property with the desired state in the %s component.", callerName, componentName);
        didWarnStateUpdateForUnmountedComponent[warningKey] = true;
    }
    /**
 * This is the abstract API for an update queue.
 */ var ReactNoopUpdateQueue = {
        /**
   * Checks whether or not this composite component is mounted.
   * @param {ReactClass} publicInstance The instance we want to test.
   * @return {boolean} True if mounted, false otherwise.
   * @protected
   * @final
   */ isMounted: function(publicInstance) {
            return false;
        },
        /**
   * Forces an update. This should only be invoked when it is known with
   * certainty that we are **not** in a DOM transaction.
   *
   * You may want to call this when you know that some deeper aspect of the
   * component's state has changed but `setState` was not called.
   *
   * This will not invoke `shouldComponentUpdate`, but it will invoke
   * `componentWillUpdate` and `componentDidUpdate`.
   *
   * @param {ReactClass} publicInstance The instance that should rerender.
   * @param {?function} callback Called after component is updated.
   * @param {?string} callerName name of the calling function in the public API.
   * @internal
   */ enqueueForceUpdate: function(publicInstance, callback, callerName) {
            warnNoop(publicInstance, "forceUpdate");
        },
        /**
   * Replaces all of the state. Always use this or `setState` to mutate state.
   * You should treat `this.state` as immutable.
   *
   * There is no guarantee that `this.state` will be immediately updated, so
   * accessing `this.state` after calling this method may return the old value.
   *
   * @param {ReactClass} publicInstance The instance that should rerender.
   * @param {object} completeState Next state.
   * @param {?function} callback Called after component is updated.
   * @param {?string} callerName name of the calling function in the public API.
   * @internal
   */ enqueueReplaceState: function(publicInstance, completeState, callback, callerName) {
            warnNoop(publicInstance, "replaceState");
        },
        /**
   * Sets a subset of the state. This only exists because _pendingState is
   * internal. This provides a merging strategy that is not available to deep
   * properties which is confusing. TODO: Expose pendingState or don't use it
   * during the merge.
   *
   * @param {ReactClass} publicInstance The instance that should rerender.
   * @param {object} partialState Next partial state to be merged with state.
   * @param {?function} callback Called after component is updated.
   * @param {?string} Name of the calling function in the public API.
   * @internal
   */ enqueueSetState: function(publicInstance, partialState, callback, callerName) {
            warnNoop(publicInstance, "setState");
        }
    };
    var assign = Object.assign;
    var emptyObject = {};
    Object.freeze(emptyObject);
    /**
 * Base class helpers for the updating state of a component.
 */ function Component(props, context, updater) {
        this.props = props;
        this.context = context; // If a component has string refs, we will assign a different object later.
        this.refs = emptyObject; // We initialize the default updater but the real one gets injected by the
        // renderer.
        this.updater = updater || ReactNoopUpdateQueue;
    }
    Component.prototype.isReactComponent = {};
    /**
 * Sets a subset of the state. Always use this to mutate
 * state. You should treat `this.state` as immutable.
 *
 * There is no guarantee that `this.state` will be immediately updated, so
 * accessing `this.state` after calling this method may return the old value.
 *
 * There is no guarantee that calls to `setState` will run synchronously,
 * as they may eventually be batched together.  You can provide an optional
 * callback that will be executed when the call to setState is actually
 * completed.
 *
 * When a function is provided to setState, it will be called at some point in
 * the future (not synchronously). It will be called with the up to date
 * component arguments (state, props, context). These values can be different
 * from this.* because your function may be called after receiveProps but before
 * shouldComponentUpdate, and this new state, props, and context will not yet be
 * assigned to this.
 *
 * @param {object|function} partialState Next partial state or function to
 *        produce next partial state to be merged with current state.
 * @param {?function} callback Called after state is updated.
 * @final
 * @protected
 */ Component.prototype.setState = function(partialState, callback) {
        if (typeof partialState !== "object" && typeof partialState !== "function" && partialState != null) throw new Error("setState(...): takes an object of state variables to update or a function which returns an object of state variables.");
        this.updater.enqueueSetState(this, partialState, callback, "setState");
    };
    /**
 * Forces an update. This should only be invoked when it is known with
 * certainty that we are **not** in a DOM transaction.
 *
 * You may want to call this when you know that some deeper aspect of the
 * component's state has changed but `setState` was not called.
 *
 * This will not invoke `shouldComponentUpdate`, but it will invoke
 * `componentWillUpdate` and `componentDidUpdate`.
 *
 * @param {?function} callback Called after update is complete.
 * @final
 * @protected
 */ Component.prototype.forceUpdate = function(callback) {
        this.updater.enqueueForceUpdate(this, callback, "forceUpdate");
    };
    var deprecatedAPIs = {
        isMounted: [
            "isMounted",
            "Instead, make sure to clean up subscriptions and pending requests in componentWillUnmount to prevent memory leaks."
        ],
        replaceState: [
            "replaceState",
            "Refactor your code to use setState instead (see https://github.com/facebook/react/issues/3236)."
        ]
    };
    var defineDeprecationWarning = function(methodName, info) {
        Object.defineProperty(Component.prototype, methodName, {
            get: function() {
                warn("%s(...) is deprecated in plain JavaScript React classes. %s", info[0], info[1]);
                return undefined;
            }
        });
    };
    for(var fnName in deprecatedAPIs)if (deprecatedAPIs.hasOwnProperty(fnName)) defineDeprecationWarning(fnName, deprecatedAPIs[fnName]);
    function ComponentDummy() {}
    ComponentDummy.prototype = Component.prototype;
    /**
 * Convenience component with default shallow equality check for sCU.
 */ function PureComponent(props, context, updater) {
        this.props = props;
        this.context = context; // If a component has string refs, we will assign a different object later.
        this.refs = emptyObject;
        this.updater = updater || ReactNoopUpdateQueue;
    }
    var pureComponentPrototype = PureComponent.prototype = new ComponentDummy();
    pureComponentPrototype.constructor = PureComponent; // Avoid an extra prototype jump for these methods.
    assign(pureComponentPrototype, Component.prototype);
    pureComponentPrototype.isPureReactComponent = true;
    // an immutable object with a single mutable value
    function createRef() {
        var refObject = {
            current: null
        };
        Object.seal(refObject);
        return refObject;
    }
    var isArrayImpl = Array.isArray; // eslint-disable-next-line no-redeclare
    function isArray(a) {
        return isArrayImpl(a);
    }
    /*
 * The `'' + value` pattern (used in in perf-sensitive code) throws for Symbol
 * and Temporal.* types. See https://github.com/facebook/react/pull/22064.
 *
 * The functions in this module will throw an easier-to-understand,
 * easier-to-debug exception with a clear errors message message explaining the
 * problem. (Instead of a confusing exception thrown inside the implementation
 * of the `value` object).
 */ // $FlowFixMe only called in DEV, so void return is not possible.
    function typeName(value) {
        // toStringTag is needed for namespaced types like Temporal.Instant
        var hasToStringTag = typeof Symbol === "function" && Symbol.toStringTag;
        var type = hasToStringTag && value[Symbol.toStringTag] || value.constructor.name || "Object";
        return type;
    } // $FlowFixMe only called in DEV, so void return is not possible.
    function willCoercionThrow(value) {
        try {
            testStringCoercion(value);
            return false;
        } catch (e) {
            return true;
        }
    }
    function testStringCoercion(value) {
        // If you ended up here by following an exception call stack, here's what's
        // happened: you supplied an object or symbol value to React (as a prop, key,
        // DOM attribute, CSS property, string ref, etc.) and when React tried to
        // coerce it to a string using `'' + value`, an exception was thrown.
        //
        // The most common types that will cause this exception are `Symbol` instances
        // and Temporal objects like `Temporal.Instant`. But any object that has a
        // `valueOf` or `[Symbol.toPrimitive]` method that throws will also cause this
        // exception. (Library authors do this to prevent users from using built-in
        // numeric operators like `+` or comparison operators like `>=` because custom
        // methods are needed to perform accurate arithmetic or comparison.)
        //
        // To fix the problem, coerce this object or symbol value to a string before
        // passing it to React. The most reliable way is usually `String(value)`.
        //
        // To find which value is throwing, check the browser or debugger console.
        // Before this exception was thrown, there should be `console.error` output
        // that shows the type (Symbol, Temporal.PlainDate, etc.) that caused the
        // problem and how that type was used: key, atrribute, input value prop, etc.
        // In most cases, this console output also shows the component and its
        // ancestor components where the exception happened.
        //
        // eslint-disable-next-line react-internal/safe-string-coercion
        return "" + value;
    }
    function checkKeyStringCoercion(value) {
        if (willCoercionThrow(value)) {
            error("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", typeName(value));
            return testStringCoercion(value); // throw (to help callers find troubleshooting comments)
        }
    }
    function getWrappedName(outerType, innerType, wrapperName) {
        var displayName = outerType.displayName;
        if (displayName) return displayName;
        var functionName = innerType.displayName || innerType.name || "";
        return functionName !== "" ? wrapperName + "(" + functionName + ")" : wrapperName;
    } // Keep in sync with react-reconciler/getComponentNameFromFiber
    function getContextName(type) {
        return type.displayName || "Context";
    } // Note that the reconciler package should generally prefer to use getComponentNameFromFiber() instead.
    function getComponentNameFromType(type) {
        if (type == null) // Host root, text node or just invalid type.
        return null;
        if (typeof type.tag === "number") error("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue.");
        if (typeof type === "function") return type.displayName || type.name || null;
        if (typeof type === "string") return type;
        switch(type){
            case REACT_FRAGMENT_TYPE:
                return "Fragment";
            case REACT_PORTAL_TYPE:
                return "Portal";
            case REACT_PROFILER_TYPE:
                return "Profiler";
            case REACT_STRICT_MODE_TYPE:
                return "StrictMode";
            case REACT_SUSPENSE_TYPE:
                return "Suspense";
            case REACT_SUSPENSE_LIST_TYPE:
                return "SuspenseList";
        }
        if (typeof type === "object") switch(type.$$typeof){
            case REACT_CONTEXT_TYPE:
                var context = type;
                return getContextName(context) + ".Consumer";
            case REACT_PROVIDER_TYPE:
                var provider = type;
                return getContextName(provider._context) + ".Provider";
            case REACT_FORWARD_REF_TYPE:
                return getWrappedName(type, type.render, "ForwardRef");
            case REACT_MEMO_TYPE:
                var outerName = type.displayName || null;
                if (outerName !== null) return outerName;
                return getComponentNameFromType(type.type) || "Memo";
            case REACT_LAZY_TYPE:
                var lazyComponent = type;
                var payload = lazyComponent._payload;
                var init = lazyComponent._init;
                try {
                    return getComponentNameFromType(init(payload));
                } catch (x) {
                    return null;
                }
        }
        return null;
    }
    var hasOwnProperty = Object.prototype.hasOwnProperty;
    var RESERVED_PROPS = {
        key: true,
        ref: true,
        __self: true,
        __source: true
    };
    var specialPropKeyWarningShown, specialPropRefWarningShown, didWarnAboutStringRefs;
    didWarnAboutStringRefs = {};
    function hasValidRef(config) {
        if (hasOwnProperty.call(config, "ref")) {
            var getter = Object.getOwnPropertyDescriptor(config, "ref").get;
            if (getter && getter.isReactWarning) return false;
        }
        return config.ref !== undefined;
    }
    function hasValidKey(config) {
        if (hasOwnProperty.call(config, "key")) {
            var getter = Object.getOwnPropertyDescriptor(config, "key").get;
            if (getter && getter.isReactWarning) return false;
        }
        return config.key !== undefined;
    }
    function defineKeyPropWarningGetter(props, displayName) {
        var warnAboutAccessingKey = function() {
            if (!specialPropKeyWarningShown) {
                specialPropKeyWarningShown = true;
                error("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", displayName);
            }
        };
        warnAboutAccessingKey.isReactWarning = true;
        Object.defineProperty(props, "key", {
            get: warnAboutAccessingKey,
            configurable: true
        });
    }
    function defineRefPropWarningGetter(props, displayName) {
        var warnAboutAccessingRef = function() {
            if (!specialPropRefWarningShown) {
                specialPropRefWarningShown = true;
                error("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", displayName);
            }
        };
        warnAboutAccessingRef.isReactWarning = true;
        Object.defineProperty(props, "ref", {
            get: warnAboutAccessingRef,
            configurable: true
        });
    }
    function warnIfStringRefCannotBeAutoConverted(config) {
        if (typeof config.ref === "string" && ReactCurrentOwner.current && config.__self && ReactCurrentOwner.current.stateNode !== config.__self) {
            var componentName = getComponentNameFromType(ReactCurrentOwner.current.type);
            if (!didWarnAboutStringRefs[componentName]) {
                error('Component "%s" contains the string ref "%s". Support for string refs will be removed in a future major release. This case cannot be automatically converted to an arrow function. We ask you to manually fix this case by using useRef() or createRef() instead. Learn more about using refs safely here: https://reactjs.org/link/strict-mode-string-ref', componentName, config.ref);
                didWarnAboutStringRefs[componentName] = true;
            }
        }
    }
    /**
 * Factory method to create a new React element. This no longer adheres to
 * the class pattern, so do not use new to call it. Also, instanceof check
 * will not work. Instead test $$typeof field against Symbol.for('react.element') to check
 * if something is a React Element.
 *
 * @param {*} type
 * @param {*} props
 * @param {*} key
 * @param {string|object} ref
 * @param {*} owner
 * @param {*} self A *temporary* helper to detect places where `this` is
 * different from the `owner` when React.createElement is called, so that we
 * can warn. We want to get rid of owner and replace string `ref`s with arrow
 * functions, and as long as `this` and owner are the same, there will be no
 * change in behavior.
 * @param {*} source An annotation object (added by a transpiler or otherwise)
 * indicating filename, line number, and/or other information.
 * @internal
 */ var ReactElement = function(type, key, ref, self, source, owner, props) {
        var element = {
            // This tag allows us to uniquely identify this as a React Element
            $$typeof: REACT_ELEMENT_TYPE,
            // Built-in properties that belong on the element
            type: type,
            key: key,
            ref: ref,
            props: props,
            // Record the component responsible for creating this element.
            _owner: owner
        };
        // The validation flag is currently mutative. We put it on
        // an external backing store so that we can freeze the whole object.
        // This can be replaced with a WeakMap once they are implemented in
        // commonly used development environments.
        element._store = {}; // To make comparing ReactElements easier for testing purposes, we make
        // the validation flag non-enumerable (where possible, which should
        // include every environment we run tests in), so the test framework
        // ignores it.
        Object.defineProperty(element._store, "validated", {
            configurable: false,
            enumerable: false,
            writable: true,
            value: false
        }); // self and source are DEV only properties.
        Object.defineProperty(element, "_self", {
            configurable: false,
            enumerable: false,
            writable: false,
            value: self
        }); // Two elements created in two different places should be considered
        // equal for testing purposes and therefore we hide it from enumeration.
        Object.defineProperty(element, "_source", {
            configurable: false,
            enumerable: false,
            writable: false,
            value: source
        });
        if (Object.freeze) {
            Object.freeze(element.props);
            Object.freeze(element);
        }
        return element;
    };
    /**
 * Create and return a new ReactElement of the given type.
 * See https://reactjs.org/docs/react-api.html#createelement
 */ function createElement(type, config, children) {
        var propName; // Reserved names are extracted
        var props = {};
        var key = null;
        var ref = null;
        var self = null;
        var source = null;
        if (config != null) {
            if (hasValidRef(config)) {
                ref = config.ref;
                warnIfStringRefCannotBeAutoConverted(config);
            }
            if (hasValidKey(config)) {
                checkKeyStringCoercion(config.key);
                key = "" + config.key;
            }
            self = config.__self === undefined ? null : config.__self;
            source = config.__source === undefined ? null : config.__source; // Remaining properties are added to a new props object
            for(propName in config)if (hasOwnProperty.call(config, propName) && !RESERVED_PROPS.hasOwnProperty(propName)) props[propName] = config[propName];
        } // Children can be more than one argument, and those are transferred onto
        // the newly allocated props object.
        var childrenLength = arguments.length - 2;
        if (childrenLength === 1) props.children = children;
        else if (childrenLength > 1) {
            var childArray = Array(childrenLength);
            for(var i = 0; i < childrenLength; i++)childArray[i] = arguments[i + 2];
            if (Object.freeze) Object.freeze(childArray);
            props.children = childArray;
        } // Resolve default props
        if (type && type.defaultProps) {
            var defaultProps = type.defaultProps;
            for(propName in defaultProps)if (props[propName] === undefined) props[propName] = defaultProps[propName];
        }
        if (key || ref) {
            var displayName = typeof type === "function" ? type.displayName || type.name || "Unknown" : type;
            if (key) defineKeyPropWarningGetter(props, displayName);
            if (ref) defineRefPropWarningGetter(props, displayName);
        }
        return ReactElement(type, key, ref, self, source, ReactCurrentOwner.current, props);
    }
    function cloneAndReplaceKey(oldElement, newKey) {
        var newElement = ReactElement(oldElement.type, newKey, oldElement.ref, oldElement._self, oldElement._source, oldElement._owner, oldElement.props);
        return newElement;
    }
    /**
 * Clone and return a new ReactElement using element as the starting point.
 * See https://reactjs.org/docs/react-api.html#cloneelement
 */ function cloneElement(element, config, children) {
        if (element === null || element === undefined) throw new Error("React.cloneElement(...): The argument must be a React element, but you passed " + element + ".");
        var propName; // Original props are copied
        var props = assign({}, element.props); // Reserved names are extracted
        var key = element.key;
        var ref = element.ref; // Self is preserved since the owner is preserved.
        var self = element._self; // Source is preserved since cloneElement is unlikely to be targeted by a
        // transpiler, and the original source is probably a better indicator of the
        // true owner.
        var source = element._source; // Owner will be preserved, unless ref is overridden
        var owner = element._owner;
        if (config != null) {
            if (hasValidRef(config)) {
                // Silently steal the ref from the parent.
                ref = config.ref;
                owner = ReactCurrentOwner.current;
            }
            if (hasValidKey(config)) {
                checkKeyStringCoercion(config.key);
                key = "" + config.key;
            } // Remaining properties override existing props
            var defaultProps;
            if (element.type && element.type.defaultProps) defaultProps = element.type.defaultProps;
            for(propName in config)if (hasOwnProperty.call(config, propName) && !RESERVED_PROPS.hasOwnProperty(propName)) {
                if (config[propName] === undefined && defaultProps !== undefined) // Resolve default props
                props[propName] = defaultProps[propName];
                else props[propName] = config[propName];
            }
        } // Children can be more than one argument, and those are transferred onto
        // the newly allocated props object.
        var childrenLength = arguments.length - 2;
        if (childrenLength === 1) props.children = children;
        else if (childrenLength > 1) {
            var childArray = Array(childrenLength);
            for(var i = 0; i < childrenLength; i++)childArray[i] = arguments[i + 2];
            props.children = childArray;
        }
        return ReactElement(element.type, key, ref, self, source, owner, props);
    }
    /**
 * Verifies the object is a ReactElement.
 * See https://reactjs.org/docs/react-api.html#isvalidelement
 * @param {?object} object
 * @return {boolean} True if `object` is a ReactElement.
 * @final
 */ function isValidElement(object) {
        return typeof object === "object" && object !== null && object.$$typeof === REACT_ELEMENT_TYPE;
    }
    var SEPARATOR = ".";
    var SUBSEPARATOR = ":";
    /**
 * Escape and wrap key so it is safe to use as a reactid
 *
 * @param {string} key to be escaped.
 * @return {string} the escaped key.
 */ function escape(key) {
        var escapeRegex = /[=:]/g;
        var escaperLookup = {
            "=": "=0",
            ":": "=2"
        };
        var escapedString = key.replace(escapeRegex, function(match) {
            return escaperLookup[match];
        });
        return "$" + escapedString;
    }
    /**
 * TODO: Test that a single child and an array with one item have the same key
 * pattern.
 */ var didWarnAboutMaps = false;
    var userProvidedKeyEscapeRegex = /\/+/g;
    function escapeUserProvidedKey(text) {
        return text.replace(userProvidedKeyEscapeRegex, "$&/");
    }
    /**
 * Generate a key string that identifies a element within a set.
 *
 * @param {*} element A element that could contain a manual key.
 * @param {number} index Index that is used if a manual key is not provided.
 * @return {string}
 */ function getElementKey(element, index) {
        // Do some typechecking here since we call this blindly. We want to ensure
        // that we don't block potential future ES APIs.
        if (typeof element === "object" && element !== null && element.key != null) {
            checkKeyStringCoercion(element.key);
            return escape("" + element.key);
        } // Implicit key determined by the index in the set
        return index.toString(36);
    }
    function mapIntoArray(children, array, escapedPrefix, nameSoFar, callback) {
        var type = typeof children;
        if (type === "undefined" || type === "boolean") // All of the above are perceived as null.
        children = null;
        var invokeCallback = false;
        if (children === null) invokeCallback = true;
        else switch(type){
            case "string":
            case "number":
                invokeCallback = true;
                break;
            case "object":
                switch(children.$$typeof){
                    case REACT_ELEMENT_TYPE:
                    case REACT_PORTAL_TYPE:
                        invokeCallback = true;
                }
        }
        if (invokeCallback) {
            var _child = children;
            var mappedChild = callback(_child); // If it's the only child, treat the name as if it was wrapped in an array
            // so that it's consistent if the number of children grows:
            var childKey = nameSoFar === "" ? SEPARATOR + getElementKey(_child, 0) : nameSoFar;
            if (isArray(mappedChild)) {
                var escapedChildKey = "";
                if (childKey != null) escapedChildKey = escapeUserProvidedKey(childKey) + "/";
                mapIntoArray(mappedChild, array, escapedChildKey, "", function(c) {
                    return c;
                });
            } else if (mappedChild != null) {
                if (isValidElement(mappedChild)) {
                    // The `if` statement here prevents auto-disabling of the safe
                    // coercion ESLint rule, so we must manually disable it below.
                    // $FlowFixMe Flow incorrectly thinks React.Portal doesn't have a key
                    if (mappedChild.key && (!_child || _child.key !== mappedChild.key)) checkKeyStringCoercion(mappedChild.key);
                    mappedChild = cloneAndReplaceKey(mappedChild, // traverseAllChildren used to do for objects as children
                    escapedPrefix + (mappedChild.key && (!_child || _child.key !== mappedChild.key) ? // eslint-disable-next-line react-internal/safe-string-coercion
                    escapeUserProvidedKey("" + mappedChild.key) + "/" : "") + childKey);
                }
                array.push(mappedChild);
            }
            return 1;
        }
        var child;
        var nextName;
        var subtreeCount = 0; // Count of children found in the current subtree.
        var nextNamePrefix = nameSoFar === "" ? SEPARATOR : nameSoFar + SUBSEPARATOR;
        if (isArray(children)) for(var i = 0; i < children.length; i++){
            child = children[i];
            nextName = nextNamePrefix + getElementKey(child, i);
            subtreeCount += mapIntoArray(child, array, escapedPrefix, nextName, callback);
        }
        else {
            var iteratorFn = getIteratorFn(children);
            if (typeof iteratorFn === "function") {
                var iterableChildren = children;
                // Warn about using Maps as children
                if (iteratorFn === iterableChildren.entries) {
                    if (!didWarnAboutMaps) warn("Using Maps as children is not supported. Use an array of keyed ReactElements instead.");
                    didWarnAboutMaps = true;
                }
                var iterator = iteratorFn.call(iterableChildren);
                var step;
                var ii = 0;
                while(!(step = iterator.next()).done){
                    child = step.value;
                    nextName = nextNamePrefix + getElementKey(child, ii++);
                    subtreeCount += mapIntoArray(child, array, escapedPrefix, nextName, callback);
                }
            } else if (type === "object") {
                // eslint-disable-next-line react-internal/safe-string-coercion
                var childrenString = String(children);
                throw new Error("Objects are not valid as a React child (found: " + (childrenString === "[object Object]" ? "object with keys {" + Object.keys(children).join(", ") + "}" : childrenString) + "). " + "If you meant to render a collection of children, use an array " + "instead.");
            }
        }
        return subtreeCount;
    }
    /**
 * Maps children that are typically specified as `props.children`.
 *
 * See https://reactjs.org/docs/react-api.html#reactchildrenmap
 *
 * The provided mapFunction(child, index) will be called for each
 * leaf child.
 *
 * @param {?*} children Children tree container.
 * @param {function(*, int)} func The map function.
 * @param {*} context Context for mapFunction.
 * @return {object} Object containing the ordered map of results.
 */ function mapChildren(children, func, context) {
        if (children == null) return children;
        var result = [];
        var count = 0;
        mapIntoArray(children, result, "", "", function(child) {
            return func.call(context, child, count++);
        });
        return result;
    }
    /**
 * Count the number of children that are typically specified as
 * `props.children`.
 *
 * See https://reactjs.org/docs/react-api.html#reactchildrencount
 *
 * @param {?*} children Children tree container.
 * @return {number} The number of children.
 */ function countChildren(children) {
        var n = 0;
        mapChildren(children, function() {
            n++; // Don't return anything
        });
        return n;
    }
    /**
 * Iterates through children that are typically specified as `props.children`.
 *
 * See https://reactjs.org/docs/react-api.html#reactchildrenforeach
 *
 * The provided forEachFunc(child, index) will be called for each
 * leaf child.
 *
 * @param {?*} children Children tree container.
 * @param {function(*, int)} forEachFunc
 * @param {*} forEachContext Context for forEachContext.
 */ function forEachChildren(children, forEachFunc, forEachContext) {
        mapChildren(children, function() {
            forEachFunc.apply(this, arguments); // Don't return anything.
        }, forEachContext);
    }
    /**
 * Flatten a children object (typically specified as `props.children`) and
 * return an array with appropriately re-keyed children.
 *
 * See https://reactjs.org/docs/react-api.html#reactchildrentoarray
 */ function toArray(children) {
        return mapChildren(children, function(child) {
            return child;
        }) || [];
    }
    /**
 * Returns the first child in a collection of children and verifies that there
 * is only one child in the collection.
 *
 * See https://reactjs.org/docs/react-api.html#reactchildrenonly
 *
 * The current implementation of this function assumes that a single child gets
 * passed without a wrapper, but the purpose of this helper function is to
 * abstract away the particular structure of children.
 *
 * @param {?object} children Child collection structure.
 * @return {ReactElement} The first and only `ReactElement` contained in the
 * structure.
 */ function onlyChild(children) {
        if (!isValidElement(children)) throw new Error("React.Children.only expected to receive a single React element child.");
        return children;
    }
    function createContext(defaultValue) {
        // TODO: Second argument used to be an optional `calculateChangedBits`
        // function. Warn to reserve for future use?
        var context = {
            $$typeof: REACT_CONTEXT_TYPE,
            // As a workaround to support multiple concurrent renderers, we categorize
            // some renderers as primary and others as secondary. We only expect
            // there to be two concurrent renderers at most: React Native (primary) and
            // Fabric (secondary); React DOM (primary) and React ART (secondary).
            // Secondary renderers store their context values on separate fields.
            _currentValue: defaultValue,
            _currentValue2: defaultValue,
            // Used to track how many concurrent renderers this context currently
            // supports within in a single renderer. Such as parallel server rendering.
            _threadCount: 0,
            // These are circular
            Provider: null,
            Consumer: null,
            // Add these to use same hidden class in VM as ServerContext
            _defaultValue: null,
            _globalName: null
        };
        context.Provider = {
            $$typeof: REACT_PROVIDER_TYPE,
            _context: context
        };
        var hasWarnedAboutUsingNestedContextConsumers = false;
        var hasWarnedAboutUsingConsumerProvider = false;
        var hasWarnedAboutDisplayNameOnConsumer = false;
        // A separate object, but proxies back to the original context object for
        // backwards compatibility. It has a different $$typeof, so we can properly
        // warn for the incorrect usage of Context as a Consumer.
        var Consumer = {
            $$typeof: REACT_CONTEXT_TYPE,
            _context: context
        }; // $FlowFixMe: Flow complains about not setting a value, which is intentional here
        Object.defineProperties(Consumer, {
            Provider: {
                get: function() {
                    if (!hasWarnedAboutUsingConsumerProvider) {
                        hasWarnedAboutUsingConsumerProvider = true;
                        error("Rendering <Context.Consumer.Provider> is not supported and will be removed in a future major release. Did you mean to render <Context.Provider> instead?");
                    }
                    return context.Provider;
                },
                set: function(_Provider) {
                    context.Provider = _Provider;
                }
            },
            _currentValue: {
                get: function() {
                    return context._currentValue;
                },
                set: function(_currentValue) {
                    context._currentValue = _currentValue;
                }
            },
            _currentValue2: {
                get: function() {
                    return context._currentValue2;
                },
                set: function(_currentValue2) {
                    context._currentValue2 = _currentValue2;
                }
            },
            _threadCount: {
                get: function() {
                    return context._threadCount;
                },
                set: function(_threadCount) {
                    context._threadCount = _threadCount;
                }
            },
            Consumer: {
                get: function() {
                    if (!hasWarnedAboutUsingNestedContextConsumers) {
                        hasWarnedAboutUsingNestedContextConsumers = true;
                        error("Rendering <Context.Consumer.Consumer> is not supported and will be removed in a future major release. Did you mean to render <Context.Consumer> instead?");
                    }
                    return context.Consumer;
                }
            },
            displayName: {
                get: function() {
                    return context.displayName;
                },
                set: function(displayName) {
                    if (!hasWarnedAboutDisplayNameOnConsumer) {
                        warn("Setting `displayName` on Context.Consumer has no effect. You should set it directly on the context with Context.displayName = '%s'.", displayName);
                        hasWarnedAboutDisplayNameOnConsumer = true;
                    }
                }
            }
        }); // $FlowFixMe: Flow complains about missing properties because it doesn't understand defineProperty
        context.Consumer = Consumer;
        context._currentRenderer = null;
        context._currentRenderer2 = null;
        return context;
    }
    var Uninitialized = -1;
    var Pending = 0;
    var Resolved = 1;
    var Rejected = 2;
    function lazyInitializer(payload) {
        if (payload._status === Uninitialized) {
            var ctor = payload._result;
            var thenable = ctor(); // Transition to the next state.
            // This might throw either because it's missing or throws. If so, we treat it
            // as still uninitialized and try again next time. Which is the same as what
            // happens if the ctor or any wrappers processing the ctor throws. This might
            // end up fixing it if the resolution was a concurrency bug.
            thenable.then(function(moduleObject) {
                if (payload._status === Pending || payload._status === Uninitialized) {
                    // Transition to the next state.
                    var resolved = payload;
                    resolved._status = Resolved;
                    resolved._result = moduleObject;
                }
            }, function(error) {
                if (payload._status === Pending || payload._status === Uninitialized) {
                    // Transition to the next state.
                    var rejected = payload;
                    rejected._status = Rejected;
                    rejected._result = error;
                }
            });
            if (payload._status === Uninitialized) {
                // In case, we're still uninitialized, then we're waiting for the thenable
                // to resolve. Set it as pending in the meantime.
                var pending = payload;
                pending._status = Pending;
                pending._result = thenable;
            }
        }
        if (payload._status === Resolved) {
            var moduleObject = payload._result;
            if (moduleObject === undefined) error("lazy: Expected the result of a dynamic import() call. Instead received: %s\n\nYour code should look like: \n  const MyComponent = lazy(() => import('./MyComponent'))\n\nDid you accidentally put curly braces around the import?", moduleObject);
            if (!("default" in moduleObject)) error("lazy: Expected the result of a dynamic import() call. Instead received: %s\n\nYour code should look like: \n  const MyComponent = lazy(() => import('./MyComponent'))", moduleObject);
            return moduleObject.default;
        } else throw payload._result;
    }
    function lazy(ctor) {
        var payload = {
            // We use these fields to store the result.
            _status: Uninitialized,
            _result: ctor
        };
        var lazyType = {
            $$typeof: REACT_LAZY_TYPE,
            _payload: payload,
            _init: lazyInitializer
        };
        // In production, this would just set it on the object.
        var defaultProps;
        var propTypes; // $FlowFixMe
        Object.defineProperties(lazyType, {
            defaultProps: {
                configurable: true,
                get: function() {
                    return defaultProps;
                },
                set: function(newDefaultProps) {
                    error("React.lazy(...): It is not supported to assign `defaultProps` to a lazy component import. Either specify them where the component is defined, or create a wrapping component around it.");
                    defaultProps = newDefaultProps; // Match production behavior more closely:
                    // $FlowFixMe
                    Object.defineProperty(lazyType, "defaultProps", {
                        enumerable: true
                    });
                }
            },
            propTypes: {
                configurable: true,
                get: function() {
                    return propTypes;
                },
                set: function(newPropTypes) {
                    error("React.lazy(...): It is not supported to assign `propTypes` to a lazy component import. Either specify them where the component is defined, or create a wrapping component around it.");
                    propTypes = newPropTypes; // Match production behavior more closely:
                    // $FlowFixMe
                    Object.defineProperty(lazyType, "propTypes", {
                        enumerable: true
                    });
                }
            }
        });
        return lazyType;
    }
    function forwardRef(render) {
        if (render != null && render.$$typeof === REACT_MEMO_TYPE) error("forwardRef requires a render function but received a `memo` component. Instead of forwardRef(memo(...)), use memo(forwardRef(...)).");
        else if (typeof render !== "function") error("forwardRef requires a render function but was given %s.", render === null ? "null" : typeof render);
        else if (render.length !== 0 && render.length !== 2) error("forwardRef render functions accept exactly two parameters: props and ref. %s", render.length === 1 ? "Did you forget to use the ref parameter?" : "Any additional parameter will be undefined.");
        if (render != null) {
            if (render.defaultProps != null || render.propTypes != null) error("forwardRef render functions do not support propTypes or defaultProps. Did you accidentally pass a React component?");
        }
        var elementType = {
            $$typeof: REACT_FORWARD_REF_TYPE,
            render: render
        };
        var ownName;
        Object.defineProperty(elementType, "displayName", {
            enumerable: false,
            configurable: true,
            get: function() {
                return ownName;
            },
            set: function(name) {
                ownName = name; // The inner component shouldn't inherit this display name in most cases,
                // because the component may be used elsewhere.
                // But it's nice for anonymous functions to inherit the name,
                // so that our component-stack generation logic will display their frames.
                // An anonymous function generally suggests a pattern like:
                //   React.forwardRef((props, ref) => {...});
                // This kind of inner function is not used elsewhere so the side effect is okay.
                if (!render.name && !render.displayName) render.displayName = name;
            }
        });
        return elementType;
    }
    var REACT_MODULE_REFERENCE;
    REACT_MODULE_REFERENCE = Symbol.for("react.module.reference");
    function isValidElementType(type) {
        if (typeof type === "string" || typeof type === "function") return true;
         // Note: typeof might be other than 'symbol' or 'number' (e.g. if it's a polyfill).
        if (type === REACT_FRAGMENT_TYPE || type === REACT_PROFILER_TYPE || enableDebugTracing || type === REACT_STRICT_MODE_TYPE || type === REACT_SUSPENSE_TYPE || type === REACT_SUSPENSE_LIST_TYPE || enableLegacyHidden || type === REACT_OFFSCREEN_TYPE || enableScopeAPI || enableCacheElement || enableTransitionTracing) return true;
        if (typeof type === "object" && type !== null) {
            if (type.$$typeof === REACT_LAZY_TYPE || type.$$typeof === REACT_MEMO_TYPE || type.$$typeof === REACT_PROVIDER_TYPE || type.$$typeof === REACT_CONTEXT_TYPE || type.$$typeof === REACT_FORWARD_REF_TYPE || // This needs to include all possible module reference object
            // types supported by any Flight configuration anywhere since
            // we don't know which Flight build this will end up being used
            // with.
            type.$$typeof === REACT_MODULE_REFERENCE || type.getModuleId !== undefined) return true;
        }
        return false;
    }
    function memo(type, compare) {
        if (!isValidElementType(type)) error("memo: The first argument must be a component. Instead received: %s", type === null ? "null" : typeof type);
        var elementType = {
            $$typeof: REACT_MEMO_TYPE,
            type: type,
            compare: compare === undefined ? null : compare
        };
        var ownName;
        Object.defineProperty(elementType, "displayName", {
            enumerable: false,
            configurable: true,
            get: function() {
                return ownName;
            },
            set: function(name) {
                ownName = name; // The inner component shouldn't inherit this display name in most cases,
                // because the component may be used elsewhere.
                // But it's nice for anonymous functions to inherit the name,
                // so that our component-stack generation logic will display their frames.
                // An anonymous function generally suggests a pattern like:
                //   React.memo((props) => {...});
                // This kind of inner function is not used elsewhere so the side effect is okay.
                if (!type.name && !type.displayName) type.displayName = name;
            }
        });
        return elementType;
    }
    function resolveDispatcher() {
        var dispatcher = ReactCurrentDispatcher.current;
        if (dispatcher === null) error("Invalid hook call. Hooks can only be called inside of the body of a function component. This could happen for one of the following reasons:\n1. You might have mismatching versions of React and the renderer (such as React DOM)\n2. You might be breaking the Rules of Hooks\n3. You might have more than one copy of React in the same app\nSee https://reactjs.org/link/invalid-hook-call for tips about how to debug and fix this problem.");
        // intentionally don't throw our own error because this is in a hot path.
        // Also helps ensure this is inlined.
        return dispatcher;
    }
    function useContext(Context) {
        var dispatcher = resolveDispatcher();
        // TODO: add a more generic warning for invalid values.
        if (Context._context !== undefined) {
            var realContext = Context._context; // Don't deduplicate because this legitimately causes bugs
            // and nobody should be using this in existing code.
            if (realContext.Consumer === Context) error("Calling useContext(Context.Consumer) is not supported, may cause bugs, and will be removed in a future major release. Did you mean to call useContext(Context) instead?");
            else if (realContext.Provider === Context) error("Calling useContext(Context.Provider) is not supported. Did you mean to call useContext(Context) instead?");
        }
        return dispatcher.useContext(Context);
    }
    function useState(initialState) {
        var dispatcher = resolveDispatcher();
        return dispatcher.useState(initialState);
    }
    function useReducer(reducer, initialArg, init) {
        var dispatcher = resolveDispatcher();
        return dispatcher.useReducer(reducer, initialArg, init);
    }
    function useRef(initialValue) {
        var dispatcher = resolveDispatcher();
        return dispatcher.useRef(initialValue);
    }
    function useEffect(create, deps) {
        var dispatcher = resolveDispatcher();
        return dispatcher.useEffect(create, deps);
    }
    function useInsertionEffect(create, deps) {
        var dispatcher = resolveDispatcher();
        return dispatcher.useInsertionEffect(create, deps);
    }
    function useLayoutEffect(create, deps) {
        var dispatcher = resolveDispatcher();
        return dispatcher.useLayoutEffect(create, deps);
    }
    function useCallback(callback, deps) {
        var dispatcher = resolveDispatcher();
        return dispatcher.useCallback(callback, deps);
    }
    function useMemo(create, deps) {
        var dispatcher = resolveDispatcher();
        return dispatcher.useMemo(create, deps);
    }
    function useImperativeHandle(ref, create, deps) {
        var dispatcher = resolveDispatcher();
        return dispatcher.useImperativeHandle(ref, create, deps);
    }
    function useDebugValue(value, formatterFn) {
        var dispatcher = resolveDispatcher();
        return dispatcher.useDebugValue(value, formatterFn);
    }
    function useTransition() {
        var dispatcher = resolveDispatcher();
        return dispatcher.useTransition();
    }
    function useDeferredValue(value) {
        var dispatcher = resolveDispatcher();
        return dispatcher.useDeferredValue(value);
    }
    function useId() {
        var dispatcher = resolveDispatcher();
        return dispatcher.useId();
    }
    function useSyncExternalStore(subscribe, getSnapshot, getServerSnapshot) {
        var dispatcher = resolveDispatcher();
        return dispatcher.useSyncExternalStore(subscribe, getSnapshot, getServerSnapshot);
    }
    // Helpers to patch console.logs to avoid logging during side-effect free
    // replaying on render function. This currently only patches the object
    // lazily which won't cover if the log function was extracted eagerly.
    // We could also eagerly patch the method.
    var disabledDepth = 0;
    var prevLog;
    var prevInfo;
    var prevWarn;
    var prevError;
    var prevGroup;
    var prevGroupCollapsed;
    var prevGroupEnd;
    function disabledLog() {}
    disabledLog.__reactDisabledLog = true;
    function disableLogs() {
        if (disabledDepth === 0) {
            /* eslint-disable react-internal/no-production-logging */ prevLog = console.log;
            prevInfo = console.info;
            prevWarn = console.warn;
            prevError = console.error;
            prevGroup = console.group;
            prevGroupCollapsed = console.groupCollapsed;
            prevGroupEnd = console.groupEnd; // https://github.com/facebook/react/issues/19099
            var props = {
                configurable: true,
                enumerable: true,
                value: disabledLog,
                writable: true
            }; // $FlowFixMe Flow thinks console is immutable.
            Object.defineProperties(console, {
                info: props,
                log: props,
                warn: props,
                error: props,
                group: props,
                groupCollapsed: props,
                groupEnd: props
            });
        /* eslint-enable react-internal/no-production-logging */ }
        disabledDepth++;
    }
    function reenableLogs() {
        disabledDepth--;
        if (disabledDepth === 0) {
            /* eslint-disable react-internal/no-production-logging */ var props = {
                configurable: true,
                enumerable: true,
                writable: true
            }; // $FlowFixMe Flow thinks console is immutable.
            Object.defineProperties(console, {
                log: assign({}, props, {
                    value: prevLog
                }),
                info: assign({}, props, {
                    value: prevInfo
                }),
                warn: assign({}, props, {
                    value: prevWarn
                }),
                error: assign({}, props, {
                    value: prevError
                }),
                group: assign({}, props, {
                    value: prevGroup
                }),
                groupCollapsed: assign({}, props, {
                    value: prevGroupCollapsed
                }),
                groupEnd: assign({}, props, {
                    value: prevGroupEnd
                })
            });
        /* eslint-enable react-internal/no-production-logging */ }
        if (disabledDepth < 0) error("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
    }
    var ReactCurrentDispatcher$1 = ReactSharedInternals.ReactCurrentDispatcher;
    var prefix;
    function describeBuiltInComponentFrame(name, source, ownerFn) {
        if (prefix === undefined) // Extract the VM specific prefix used by each line.
        try {
            throw Error();
        } catch (x) {
            var match = x.stack.trim().match(/\n( *(at )?)/);
            prefix = match && match[1] || "";
        }
         // We use the prefix to ensure our stacks line up with native stack frames.
        return "\n" + prefix + name;
    }
    var reentry = false;
    var componentFrameCache;
    var PossiblyWeakMap = typeof WeakMap === "function" ? WeakMap : Map;
    componentFrameCache = new PossiblyWeakMap();
    function describeNativeComponentFrame(fn, construct) {
        // If something asked for a stack inside a fake render, it should get ignored.
        if (!fn || reentry) return "";
        var frame = componentFrameCache.get(fn);
        if (frame !== undefined) return frame;
        var control;
        reentry = true;
        var previousPrepareStackTrace = Error.prepareStackTrace; // $FlowFixMe It does accept undefined.
        Error.prepareStackTrace = undefined;
        var previousDispatcher;
        previousDispatcher = ReactCurrentDispatcher$1.current; // Set the dispatcher in DEV because this might be call in the render function
        // for warnings.
        ReactCurrentDispatcher$1.current = null;
        disableLogs();
        try {
            // This should throw.
            if (construct) {
                // Something should be setting the props in the constructor.
                var Fake = function() {
                    throw Error();
                }; // $FlowFixMe
                Object.defineProperty(Fake.prototype, "props", {
                    set: function() {
                        // We use a throwing setter instead of frozen or non-writable props
                        // because that won't throw in a non-strict mode function.
                        throw Error();
                    }
                });
                if (typeof Reflect === "object" && Reflect.construct) {
                    // We construct a different control for this case to include any extra
                    // frames added by the construct call.
                    try {
                        Reflect.construct(Fake, []);
                    } catch (x) {
                        control = x;
                    }
                    Reflect.construct(fn, [], Fake);
                } else {
                    try {
                        Fake.call();
                    } catch (x) {
                        control = x;
                    }
                    fn.call(Fake.prototype);
                }
            } else {
                try {
                    throw Error();
                } catch (x) {
                    control = x;
                }
                fn();
            }
        } catch (sample) {
            // This is inlined manually because closure doesn't do it for us.
            if (sample && control && typeof sample.stack === "string") {
                // This extracts the first frame from the sample that isn't also in the control.
                // Skipping one frame that we assume is the frame that calls the two.
                var sampleLines = sample.stack.split("\n");
                var controlLines = control.stack.split("\n");
                var s = sampleLines.length - 1;
                var c = controlLines.length - 1;
                while(s >= 1 && c >= 0 && sampleLines[s] !== controlLines[c])// We expect at least one stack frame to be shared.
                // Typically this will be the root most one. However, stack frames may be
                // cut off due to maximum stack limits. In this case, one maybe cut off
                // earlier than the other. We assume that the sample is longer or the same
                // and there for cut off earlier. So we should find the root most frame in
                // the sample somewhere in the control.
                c--;
                for(; s >= 1 && c >= 0; s--, c--)// Next we find the first one that isn't the same which should be the
                // frame that called our sample function and the control.
                if (sampleLines[s] !== controlLines[c]) {
                    // In V8, the first line is describing the message but other VMs don't.
                    // If we're about to return the first line, and the control is also on the same
                    // line, that's a pretty good indicator that our sample threw at same line as
                    // the control. I.e. before we entered the sample frame. So we ignore this result.
                    // This can happen if you passed a class to function component, or non-function.
                    if (s !== 1 || c !== 1) do {
                        s--;
                        c--; // We may still have similar intermediate frames from the construct call.
                        // The next one that isn't the same should be our match though.
                        if (c < 0 || sampleLines[s] !== controlLines[c]) {
                            // V8 adds a "new" prefix for native classes. Let's remove it to make it prettier.
                            var _frame = "\n" + sampleLines[s].replace(" at new ", " at "); // If our component frame is labeled "<anonymous>"
                            // but we have a user-provided "displayName"
                            // splice it in to make the stack more readable.
                            if (fn.displayName && _frame.includes("<anonymous>")) _frame = _frame.replace("<anonymous>", fn.displayName);
                            if (typeof fn === "function") componentFrameCache.set(fn, _frame);
                            return _frame;
                        }
                    }while (s >= 1 && c >= 0);
                    break;
                }
            }
        } finally{
            reentry = false;
            ReactCurrentDispatcher$1.current = previousDispatcher;
            reenableLogs();
            Error.prepareStackTrace = previousPrepareStackTrace;
        } // Fallback to just using the name if we couldn't make it throw.
        var name = fn ? fn.displayName || fn.name : "";
        var syntheticFrame = name ? describeBuiltInComponentFrame(name) : "";
        if (typeof fn === "function") componentFrameCache.set(fn, syntheticFrame);
        return syntheticFrame;
    }
    function describeFunctionComponentFrame(fn, source, ownerFn) {
        return describeNativeComponentFrame(fn, false);
    }
    function shouldConstruct(Component) {
        var prototype = Component.prototype;
        return !!(prototype && prototype.isReactComponent);
    }
    function describeUnknownElementTypeFrameInDEV(type, source, ownerFn) {
        if (type == null) return "";
        if (typeof type === "function") return describeNativeComponentFrame(type, shouldConstruct(type));
        if (typeof type === "string") return describeBuiltInComponentFrame(type);
        switch(type){
            case REACT_SUSPENSE_TYPE:
                return describeBuiltInComponentFrame("Suspense");
            case REACT_SUSPENSE_LIST_TYPE:
                return describeBuiltInComponentFrame("SuspenseList");
        }
        if (typeof type === "object") switch(type.$$typeof){
            case REACT_FORWARD_REF_TYPE:
                return describeFunctionComponentFrame(type.render);
            case REACT_MEMO_TYPE:
                // Memo may contain any component type so we recursively resolve it.
                return describeUnknownElementTypeFrameInDEV(type.type, source, ownerFn);
            case REACT_LAZY_TYPE:
                var lazyComponent = type;
                var payload = lazyComponent._payload;
                var init = lazyComponent._init;
                try {
                    // Lazy may contain any component type so we recursively resolve it.
                    return describeUnknownElementTypeFrameInDEV(init(payload), source, ownerFn);
                } catch (x) {}
        }
        return "";
    }
    var loggedTypeFailures = {};
    var ReactDebugCurrentFrame$1 = ReactSharedInternals.ReactDebugCurrentFrame;
    function setCurrentlyValidatingElement(element) {
        if (element) {
            var owner = element._owner;
            var stack = describeUnknownElementTypeFrameInDEV(element.type, element._source, owner ? owner.type : null);
            ReactDebugCurrentFrame$1.setExtraStackFrame(stack);
        } else ReactDebugCurrentFrame$1.setExtraStackFrame(null);
    }
    function checkPropTypes(typeSpecs, values, location, componentName, element) {
        // $FlowFixMe This is okay but Flow doesn't know it.
        var has = Function.call.bind(hasOwnProperty);
        for(var typeSpecName in typeSpecs)if (has(typeSpecs, typeSpecName)) {
            var error$1 = void 0; // Prop type validation may throw. In case they do, we don't want to
            // fail the render phase where it didn't fail before. So we log it.
            // After these have been cleaned up, we'll let them throw.
            try {
                // This is intentionally an invariant that gets caught. It's the same
                // behavior as without this statement except with a better message.
                if (typeof typeSpecs[typeSpecName] !== "function") {
                    // eslint-disable-next-line react-internal/prod-error-codes
                    var err = Error((componentName || "React class") + ": " + location + " type `" + typeSpecName + "` is invalid; " + "it must be a function, usually from the `prop-types` package, but received `" + typeof typeSpecs[typeSpecName] + "`." + "This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                    err.name = "Invariant Violation";
                    throw err;
                }
                error$1 = typeSpecs[typeSpecName](values, typeSpecName, componentName, location, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (ex) {
                error$1 = ex;
            }
            if (error$1 && !(error$1 instanceof Error)) {
                setCurrentlyValidatingElement(element);
                error("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", componentName || "React class", location, typeSpecName, typeof error$1);
                setCurrentlyValidatingElement(null);
            }
            if (error$1 instanceof Error && !(error$1.message in loggedTypeFailures)) {
                // Only monitor this failure once because there tends to be a lot of the
                // same error.
                loggedTypeFailures[error$1.message] = true;
                setCurrentlyValidatingElement(element);
                error("Failed %s type: %s", location, error$1.message);
                setCurrentlyValidatingElement(null);
            }
        }
    }
    function setCurrentlyValidatingElement$1(element) {
        if (element) {
            var owner = element._owner;
            var stack = describeUnknownElementTypeFrameInDEV(element.type, element._source, owner ? owner.type : null);
            setExtraStackFrame(stack);
        } else setExtraStackFrame(null);
    }
    var propTypesMisspellWarningShown;
    propTypesMisspellWarningShown = false;
    function getDeclarationErrorAddendum() {
        if (ReactCurrentOwner.current) {
            var name = getComponentNameFromType(ReactCurrentOwner.current.type);
            if (name) return "\n\nCheck the render method of `" + name + "`.";
        }
        return "";
    }
    function getSourceInfoErrorAddendum(source) {
        if (source !== undefined) {
            var fileName = source.fileName.replace(/^.*[\\\/]/, "");
            var lineNumber = source.lineNumber;
            return "\n\nCheck your code at " + fileName + ":" + lineNumber + ".";
        }
        return "";
    }
    function getSourceInfoErrorAddendumForProps(elementProps) {
        if (elementProps !== null && elementProps !== undefined) return getSourceInfoErrorAddendum(elementProps.__source);
        return "";
    }
    /**
 * Warn if there's no key explicitly set on dynamic arrays of children or
 * object keys are not valid. This allows us to keep track of children between
 * updates.
 */ var ownerHasKeyUseWarning = {};
    function getCurrentComponentErrorInfo(parentType) {
        var info = getDeclarationErrorAddendum();
        if (!info) {
            var parentName = typeof parentType === "string" ? parentType : parentType.displayName || parentType.name;
            if (parentName) info = "\n\nCheck the top-level render call using <" + parentName + ">.";
        }
        return info;
    }
    /**
 * Warn if the element doesn't have an explicit key assigned to it.
 * This element is in an array. The array could grow and shrink or be
 * reordered. All children that haven't already been validated are required to
 * have a "key" property assigned to it. Error statuses are cached so a warning
 * will only be shown once.
 *
 * @internal
 * @param {ReactElement} element Element that requires a key.
 * @param {*} parentType element's parent's type.
 */ function validateExplicitKey(element, parentType) {
        if (!element._store || element._store.validated || element.key != null) return;
        element._store.validated = true;
        var currentComponentErrorInfo = getCurrentComponentErrorInfo(parentType);
        if (ownerHasKeyUseWarning[currentComponentErrorInfo]) return;
        ownerHasKeyUseWarning[currentComponentErrorInfo] = true; // Usually the current owner is the offender, but if it accepts children as a
        // property, it may be the creator of the child that's responsible for
        // assigning it a key.
        var childOwner = "";
        if (element && element._owner && element._owner !== ReactCurrentOwner.current) // Give the component that originally created this child.
        childOwner = " It was passed a child from " + getComponentNameFromType(element._owner.type) + ".";
        setCurrentlyValidatingElement$1(element);
        error('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', currentComponentErrorInfo, childOwner);
        setCurrentlyValidatingElement$1(null);
    }
    /**
 * Ensure that every element either is passed in a static location, in an
 * array with an explicit keys property defined, or in an object literal
 * with valid key property.
 *
 * @internal
 * @param {ReactNode} node Statically passed child of any type.
 * @param {*} parentType node's parent's type.
 */ function validateChildKeys(node, parentType) {
        if (typeof node !== "object") return;
        if (isArray(node)) for(var i = 0; i < node.length; i++){
            var child = node[i];
            if (isValidElement(child)) validateExplicitKey(child, parentType);
        }
        else if (isValidElement(node)) // This element was passed in a valid location.
        {
            if (node._store) node._store.validated = true;
        } else if (node) {
            var iteratorFn = getIteratorFn(node);
            if (typeof iteratorFn === "function") // Entry iterators used to provide implicit keys,
            // but now we print a separate warning for them later.
            {
                if (iteratorFn !== node.entries) {
                    var iterator = iteratorFn.call(node);
                    var step;
                    while(!(step = iterator.next()).done)if (isValidElement(step.value)) validateExplicitKey(step.value, parentType);
                }
            }
        }
    }
    /**
 * Given an element, validate that its props follow the propTypes definition,
 * provided by the type.
 *
 * @param {ReactElement} element
 */ function validatePropTypes(element) {
        var type = element.type;
        if (type === null || type === undefined || typeof type === "string") return;
        var propTypes;
        if (typeof type === "function") propTypes = type.propTypes;
        else if (typeof type === "object" && (type.$$typeof === REACT_FORWARD_REF_TYPE || // Note: Memo only checks outer props here.
        // Inner props are checked in the reconciler.
        type.$$typeof === REACT_MEMO_TYPE)) propTypes = type.propTypes;
        else return;
        if (propTypes) {
            // Intentionally inside to avoid triggering lazy initializers:
            var name = getComponentNameFromType(type);
            checkPropTypes(propTypes, element.props, "prop", name, element);
        } else if (type.PropTypes !== undefined && !propTypesMisspellWarningShown) {
            propTypesMisspellWarningShown = true; // Intentionally inside to avoid triggering lazy initializers:
            var _name = getComponentNameFromType(type);
            error("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", _name || "Unknown");
        }
        if (typeof type.getDefaultProps === "function" && !type.getDefaultProps.isReactClassApproved) error("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
    }
    /**
 * Given a fragment, validate that it can only be provided with fragment props
 * @param {ReactElement} fragment
 */ function validateFragmentProps(fragment) {
        var keys = Object.keys(fragment.props);
        for(var i = 0; i < keys.length; i++){
            var key = keys[i];
            if (key !== "children" && key !== "key") {
                setCurrentlyValidatingElement$1(fragment);
                error("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", key);
                setCurrentlyValidatingElement$1(null);
                break;
            }
        }
        if (fragment.ref !== null) {
            setCurrentlyValidatingElement$1(fragment);
            error("Invalid attribute `ref` supplied to `React.Fragment`.");
            setCurrentlyValidatingElement$1(null);
        }
    }
    function createElementWithValidation(type, props, children) {
        var validType = isValidElementType(type); // We warn in this case but don't throw. We expect the element creation to
        // succeed and there will likely be errors in render.
        if (!validType) {
            var info = "";
            if (type === undefined || typeof type === "object" && type !== null && Object.keys(type).length === 0) info += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.";
            var sourceInfo = getSourceInfoErrorAddendumForProps(props);
            if (sourceInfo) info += sourceInfo;
            else info += getDeclarationErrorAddendum();
            var typeString;
            if (type === null) typeString = "null";
            else if (isArray(type)) typeString = "array";
            else if (type !== undefined && type.$$typeof === REACT_ELEMENT_TYPE) {
                typeString = "<" + (getComponentNameFromType(type.type) || "Unknown") + " />";
                info = " Did you accidentally export a JSX literal instead of a component?";
            } else typeString = typeof type;
            error("React.createElement: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", typeString, info);
        }
        var element = createElement.apply(this, arguments); // The result can be nullish if a mock or a custom function is used.
        // TODO: Drop this when these are no longer allowed as the type argument.
        if (element == null) return element;
         // Skip key warning if the type isn't valid since our key validation logic
        // doesn't expect a non-string/function type and can throw confusing errors.
        // We don't want exception behavior to differ between dev and prod.
        // (Rendering will throw with a helpful message and as soon as the type is
        // fixed, the key warnings will appear.)
        if (validType) for(var i = 2; i < arguments.length; i++)validateChildKeys(arguments[i], type);
        if (type === REACT_FRAGMENT_TYPE) validateFragmentProps(element);
        else validatePropTypes(element);
        return element;
    }
    var didWarnAboutDeprecatedCreateFactory = false;
    function createFactoryWithValidation(type) {
        var validatedFactory = createElementWithValidation.bind(null, type);
        validatedFactory.type = type;
        if (!didWarnAboutDeprecatedCreateFactory) {
            didWarnAboutDeprecatedCreateFactory = true;
            warn("React.createFactory() is deprecated and will be removed in a future major release. Consider using JSX or use React.createElement() directly instead.");
        } // Legacy hook: remove it
        Object.defineProperty(validatedFactory, "type", {
            enumerable: false,
            get: function() {
                warn("Factory.type is deprecated. Access the class directly before passing it to createFactory.");
                Object.defineProperty(this, "type", {
                    value: type
                });
                return type;
            }
        });
        return validatedFactory;
    }
    function cloneElementWithValidation(element, props, children) {
        var newElement = cloneElement.apply(this, arguments);
        for(var i = 2; i < arguments.length; i++)validateChildKeys(arguments[i], newElement.type);
        validatePropTypes(newElement);
        return newElement;
    }
    function startTransition(scope, options) {
        var prevTransition = ReactCurrentBatchConfig.transition;
        ReactCurrentBatchConfig.transition = {};
        var currentTransition = ReactCurrentBatchConfig.transition;
        ReactCurrentBatchConfig.transition._updatedFibers = new Set();
        try {
            scope();
        } finally{
            ReactCurrentBatchConfig.transition = prevTransition;
            if (prevTransition === null && currentTransition._updatedFibers) {
                var updatedFibersCount = currentTransition._updatedFibers.size;
                if (updatedFibersCount > 10) warn("Detected a large number of updates inside startTransition. If this is due to a subscription please re-write it to use React provided hooks. Otherwise concurrent mode guarantees are off the table.");
                currentTransition._updatedFibers.clear();
            }
        }
    }
    var didWarnAboutMessageChannel = false;
    var enqueueTaskImpl = null;
    function enqueueTask(task) {
        if (enqueueTaskImpl === null) try {
            // read require off the module object to get around the bundlers.
            // we don't want them to detect a require and bundle a Node polyfill.
            var requireString = ("require" + Math.random()).slice(0, 7);
            var nodeRequire = module && module[requireString]; // assuming we're in node, let's try to get node's
            // version of setImmediate, bypassing fake timers if any.
            enqueueTaskImpl = nodeRequire.call(module, "timers").setImmediate;
        } catch (_err) {
            // we're in a browser
            // we can't use regular timers because they may still be faked
            // so we try MessageChannel+postMessage instead
            enqueueTaskImpl = function(callback) {
                if (didWarnAboutMessageChannel === false) {
                    didWarnAboutMessageChannel = true;
                    if (typeof MessageChannel === "undefined") error("This browser does not have a MessageChannel implementation, so enqueuing tasks via await act(async () => ...) will fail. Please file an issue at https://github.com/facebook/react/issues if you encounter this warning.");
                }
                var channel = new MessageChannel();
                channel.port1.onmessage = callback;
                channel.port2.postMessage(undefined);
            };
        }
        return enqueueTaskImpl(task);
    }
    var actScopeDepth = 0;
    var didWarnNoAwaitAct = false;
    function act(callback) {
        // `act` calls can be nested, so we track the depth. This represents the
        // number of `act` scopes on the stack.
        var prevActScopeDepth = actScopeDepth;
        actScopeDepth++;
        if (ReactCurrentActQueue.current === null) // This is the outermost `act` scope. Initialize the queue. The reconciler
        // will detect the queue and use it instead of Scheduler.
        ReactCurrentActQueue.current = [];
        var prevIsBatchingLegacy = ReactCurrentActQueue.isBatchingLegacy;
        var result;
        try {
            // Used to reproduce behavior of `batchedUpdates` in legacy mode. Only
            // set to `true` while the given callback is executed, not for updates
            // triggered during an async event, because this is how the legacy
            // implementation of `act` behaved.
            ReactCurrentActQueue.isBatchingLegacy = true;
            result = callback(); // Replicate behavior of original `act` implementation in legacy mode,
            // which flushed updates immediately after the scope function exits, even
            // if it's an async function.
            if (!prevIsBatchingLegacy && ReactCurrentActQueue.didScheduleLegacyUpdate) {
                var queue = ReactCurrentActQueue.current;
                if (queue !== null) {
                    ReactCurrentActQueue.didScheduleLegacyUpdate = false;
                    flushActQueue(queue);
                }
            }
        } catch (error) {
            popActScope(prevActScopeDepth);
            throw error;
        } finally{
            ReactCurrentActQueue.isBatchingLegacy = prevIsBatchingLegacy;
        }
        if (result !== null && typeof result === "object" && typeof result.then === "function") {
            var thenableResult = result; // The callback is an async function (i.e. returned a promise). Wait
            // for it to resolve before exiting the current scope.
            var wasAwaited = false;
            var thenable = {
                then: function(resolve, reject) {
                    wasAwaited = true;
                    thenableResult.then(function(returnValue) {
                        popActScope(prevActScopeDepth);
                        if (actScopeDepth === 0) // We've exited the outermost act scope. Recursively flush the
                        // queue until there's no remaining work.
                        recursivelyFlushAsyncActWork(returnValue, resolve, reject);
                        else resolve(returnValue);
                    }, function(error) {
                        // The callback threw an error.
                        popActScope(prevActScopeDepth);
                        reject(error);
                    });
                }
            };
            if (!didWarnNoAwaitAct && typeof Promise !== "undefined") // eslint-disable-next-line no-undef
            Promise.resolve().then(function() {}).then(function() {
                if (!wasAwaited) {
                    didWarnNoAwaitAct = true;
                    error("You called act(async () => ...) without await. This could lead to unexpected testing behaviour, interleaving multiple act calls and mixing their scopes. You should - await act(async () => ...);");
                }
            });
            return thenable;
        } else {
            var returnValue = result; // The callback is not an async function. Exit the current scope
            // immediately, without awaiting.
            popActScope(prevActScopeDepth);
            if (actScopeDepth === 0) {
                // Exiting the outermost act scope. Flush the queue.
                var _queue = ReactCurrentActQueue.current;
                if (_queue !== null) {
                    flushActQueue(_queue);
                    ReactCurrentActQueue.current = null;
                } // Return a thenable. If the user awaits it, we'll flush again in
                // case additional work was scheduled by a microtask.
                var _thenable = {
                    then: function(resolve, reject) {
                        // Confirm we haven't re-entered another `act` scope, in case
                        // the user does something weird like await the thenable
                        // multiple times.
                        if (ReactCurrentActQueue.current === null) {
                            // Recursively flush the queue until there's no remaining work.
                            ReactCurrentActQueue.current = [];
                            recursivelyFlushAsyncActWork(returnValue, resolve, reject);
                        } else resolve(returnValue);
                    }
                };
                return _thenable;
            } else {
                // Since we're inside a nested `act` scope, the returned thenable
                // immediately resolves. The outer scope will flush the queue.
                var _thenable2 = {
                    then: function(resolve, reject) {
                        resolve(returnValue);
                    }
                };
                return _thenable2;
            }
        }
    }
    function popActScope(prevActScopeDepth) {
        if (prevActScopeDepth !== actScopeDepth - 1) error("You seem to have overlapping act() calls, this is not supported. Be sure to await previous act() calls before making a new one. ");
        actScopeDepth = prevActScopeDepth;
    }
    function recursivelyFlushAsyncActWork(returnValue, resolve, reject) {
        var queue = ReactCurrentActQueue.current;
        if (queue !== null) try {
            flushActQueue(queue);
            enqueueTask(function() {
                if (queue.length === 0) {
                    // No additional work was scheduled. Finish.
                    ReactCurrentActQueue.current = null;
                    resolve(returnValue);
                } else // Keep flushing work until there's none left.
                recursivelyFlushAsyncActWork(returnValue, resolve, reject);
            });
        } catch (error) {
            reject(error);
        }
        else resolve(returnValue);
    }
    var isFlushing = false;
    function flushActQueue(queue) {
        if (!isFlushing) {
            // Prevent re-entrance.
            isFlushing = true;
            var i = 0;
            try {
                for(; i < queue.length; i++){
                    var callback = queue[i];
                    do callback = callback(true);
                    while (callback !== null);
                }
                queue.length = 0;
            } catch (error) {
                // If something throws, leave the remaining callbacks on the queue.
                queue = queue.slice(i + 1);
                throw error;
            } finally{
                isFlushing = false;
            }
        }
    }
    var createElement$1 = createElementWithValidation;
    var cloneElement$1 = cloneElementWithValidation;
    var createFactory = createFactoryWithValidation;
    var Children = {
        map: mapChildren,
        forEach: forEachChildren,
        count: countChildren,
        toArray: toArray,
        only: onlyChild
    };
    exports.Children = Children;
    exports.Component = Component;
    exports.Fragment = REACT_FRAGMENT_TYPE;
    exports.Profiler = REACT_PROFILER_TYPE;
    exports.PureComponent = PureComponent;
    exports.StrictMode = REACT_STRICT_MODE_TYPE;
    exports.Suspense = REACT_SUSPENSE_TYPE;
    exports.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED = ReactSharedInternals;
    exports.cloneElement = cloneElement$1;
    exports.createContext = createContext;
    exports.createElement = createElement$1;
    exports.createFactory = createFactory;
    exports.createRef = createRef;
    exports.forwardRef = forwardRef;
    exports.isValidElement = isValidElement;
    exports.lazy = lazy;
    exports.memo = memo;
    exports.startTransition = startTransition;
    exports.unstable_act = act;
    exports.useCallback = useCallback;
    exports.useContext = useContext;
    exports.useDebugValue = useDebugValue;
    exports.useDeferredValue = useDeferredValue;
    exports.useEffect = useEffect;
    exports.useId = useId;
    exports.useImperativeHandle = useImperativeHandle;
    exports.useInsertionEffect = useInsertionEffect;
    exports.useLayoutEffect = useLayoutEffect;
    exports.useMemo = useMemo;
    exports.useReducer = useReducer;
    exports.useRef = useRef;
    exports.useState = useState;
    exports.useSyncExternalStore = useSyncExternalStore;
    exports.useTransition = useTransition;
    exports.version = ReactVersion;
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ !== "undefined" && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop === "function") __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop(new Error());
})();

});



parcelRegister("1u0KT", function(module, exports) {
"use strict";
function $11492dca620dcaa5$var$checkDCE() {
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === "undefined" || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== "function") return;
    var err;
    // This branch is unreachable because this function is only called
    // in production, but the condition is true only in development.
    // Therefore if the branch is still here, dead code elimination wasn't
    // properly applied.
    // Don't change the message. React DevTools relies on it. Also make sure
    // this message doesn't occur elsewhere in this function, or it will cause
    // a false positive.
    throw new Error("^_^");
}

module.exports = (parcelRequire("3y30c"));

});
parcelRegister("3y30c", function(module, exports) {

$parcel$export(module.exports, "__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED", () => $2956e04298bc31b1$export$ae55be85d98224ed, (v) => $2956e04298bc31b1$export$ae55be85d98224ed = v);
$parcel$export(module.exports, "createPortal", () => $2956e04298bc31b1$export$d39a5bbd09211389, (v) => $2956e04298bc31b1$export$d39a5bbd09211389 = v);
$parcel$export(module.exports, "createRoot", () => $2956e04298bc31b1$export$882461b6382ed46c, (v) => $2956e04298bc31b1$export$882461b6382ed46c = v);
$parcel$export(module.exports, "findDOMNode", () => $2956e04298bc31b1$export$466bfc07425424d5, (v) => $2956e04298bc31b1$export$466bfc07425424d5 = v);
$parcel$export(module.exports, "flushSync", () => $2956e04298bc31b1$export$cd75ccfd720a3cd4, (v) => $2956e04298bc31b1$export$cd75ccfd720a3cd4 = v);
$parcel$export(module.exports, "hydrate", () => $2956e04298bc31b1$export$fa8d919ba61d84db, (v) => $2956e04298bc31b1$export$fa8d919ba61d84db = v);
$parcel$export(module.exports, "hydrateRoot", () => $2956e04298bc31b1$export$757ceba2d55c277e, (v) => $2956e04298bc31b1$export$757ceba2d55c277e = v);
$parcel$export(module.exports, "render", () => $2956e04298bc31b1$export$b3890eb0ae9dca99, (v) => $2956e04298bc31b1$export$b3890eb0ae9dca99 = v);
$parcel$export(module.exports, "unmountComponentAtNode", () => $2956e04298bc31b1$export$502457920280e6be, (v) => $2956e04298bc31b1$export$502457920280e6be = v);
$parcel$export(module.exports, "unstable_batchedUpdates", () => $2956e04298bc31b1$export$c78a37762a8d58e1, (v) => $2956e04298bc31b1$export$c78a37762a8d58e1 = v);
$parcel$export(module.exports, "unstable_renderSubtreeIntoContainer", () => $2956e04298bc31b1$export$dc54d992c10e8a18, (v) => $2956e04298bc31b1$export$dc54d992c10e8a18 = v);
$parcel$export(module.exports, "version", () => $2956e04298bc31b1$export$83d89fbfd8236492, (v) => $2956e04298bc31b1$export$83d89fbfd8236492 = v);
/**
 * @license React
 * react-dom.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $2956e04298bc31b1$export$ae55be85d98224ed;
var $2956e04298bc31b1$export$d39a5bbd09211389;
var $2956e04298bc31b1$export$882461b6382ed46c;
var $2956e04298bc31b1$export$466bfc07425424d5;
var $2956e04298bc31b1$export$cd75ccfd720a3cd4;
var $2956e04298bc31b1$export$fa8d919ba61d84db;
var $2956e04298bc31b1$export$757ceba2d55c277e;
var $2956e04298bc31b1$export$b3890eb0ae9dca99;
var $2956e04298bc31b1$export$502457920280e6be;
var $2956e04298bc31b1$export$c78a37762a8d58e1;
var $2956e04298bc31b1$export$dc54d992c10e8a18;
var $2956e04298bc31b1$export$83d89fbfd8236492;
"use strict";


(function() {
    "use strict";
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ !== "undefined" && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart === "function") __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart(new Error());
    var React = (parcelRequire("acw62"));
    var Scheduler = (parcelRequire("fO90s"));
    var ReactSharedInternals = React.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    var suppressWarning = false;
    function setSuppressWarning(newSuppressWarning) {
        suppressWarning = newSuppressWarning;
    } // In DEV, calls to console.warn and console.error get replaced
    // by calls to these methods by a Babel plugin.
    //
    // In PROD (or in packages without access to React internals),
    // they are left as they are instead.
    function warn(format) {
        if (!suppressWarning) {
            for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)args[_key - 1] = arguments[_key];
            printWarning("warn", format, args);
        }
    }
    function error(format) {
        if (!suppressWarning) {
            for(var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++)args[_key2 - 1] = arguments[_key2];
            printWarning("error", format, args);
        }
    }
    function printWarning(level, format, args) {
        var ReactDebugCurrentFrame = ReactSharedInternals.ReactDebugCurrentFrame;
        var stack = ReactDebugCurrentFrame.getStackAddendum();
        if (stack !== "") {
            format += "%s";
            args = args.concat([
                stack
            ]);
        } // eslint-disable-next-line react-internal/safe-string-coercion
        var argsWithFormat = args.map(function(item) {
            return String(item);
        }); // Careful: RN currently depends on this prefix
        argsWithFormat.unshift("Warning: " + format); // We intentionally don't use spread (or .apply) directly because it
        // breaks IE9: https://github.com/facebook/react/issues/13610
        // eslint-disable-next-line react-internal/no-production-logging
        Function.prototype.apply.call(console[level], console, argsWithFormat);
    }
    var FunctionComponent = 0;
    var ClassComponent = 1;
    var IndeterminateComponent = 2; // Before we know whether it is function or class
    var HostRoot = 3; // Root of a host tree. Could be nested inside another node.
    var HostPortal = 4; // A subtree. Could be an entry point to a different renderer.
    var HostComponent = 5;
    var HostText = 6;
    var Fragment = 7;
    var Mode = 8;
    var ContextConsumer = 9;
    var ContextProvider = 10;
    var ForwardRef = 11;
    var Profiler = 12;
    var SuspenseComponent = 13;
    var MemoComponent = 14;
    var SimpleMemoComponent = 15;
    var LazyComponent = 16;
    var IncompleteClassComponent = 17;
    var DehydratedFragment = 18;
    var SuspenseListComponent = 19;
    var ScopeComponent = 21;
    var OffscreenComponent = 22;
    var LegacyHiddenComponent = 23;
    var CacheComponent = 24;
    var TracingMarkerComponent = 25;
    // -----------------------------------------------------------------------------
    var enableClientRenderFallbackOnTextMismatch = true; // TODO: Need to review this code one more time before landing
    // the react-reconciler package.
    var enableNewReconciler = false; // Support legacy Primer support on internal FB www
    var enableLazyContextPropagation = false; // FB-only usage. The new API has different semantics.
    var enableLegacyHidden = false; // Enables unstable_avoidThisFallback feature in Fiber
    var enableSuspenseAvoidThisFallback = false; // Enables unstable_avoidThisFallback feature in Fizz
    // React DOM Chopping Block
    //
    // Similar to main Chopping Block but only flags related to React DOM. These are
    // grouped because we will likely batch all of them into a single major release.
    // -----------------------------------------------------------------------------
    // Disable support for comment nodes as React DOM containers. Already disabled
    // in open source, but www codebase still relies on it. Need to remove.
    var disableCommentsAsDOMContainers = true; // Disable javascript: URL strings in href for XSS protection.
    // and client rendering, mostly to allow JSX attributes to apply to the custom
    // element's object properties instead of only HTML attributes.
    // https://github.com/facebook/react/issues/11347
    var enableCustomElementPropertySupport = false; // Disables children for <textarea> elements
    var warnAboutStringRefs = false; // -----------------------------------------------------------------------------
    // Debugging and DevTools
    // -----------------------------------------------------------------------------
    // Adds user timing marks for e.g. state updates, suspense, and work loop stuff,
    // for an experimental timeline tool.
    var enableSchedulingProfiler = true; // Helps identify side effects in render-phase lifecycle hooks and setState
    var enableProfilerTimer = true; // Record durations for commit and passive effects phases.
    var enableProfilerCommitHooks = true; // Phase param passed to onRender callback differentiates between an "update" and a "cascading-update".
    var allNativeEvents = new Set();
    /**
 * Mapping from registration name to event name
 */ var registrationNameDependencies = {};
    /**
 * Mapping from lowercase registration names to the properly cased version,
 * used to warn in the case of missing event handlers. Available
 * only in true.
 * @type {Object}
 */ var possibleRegistrationNames = {}; // Trust the developer to only use possibleRegistrationNames in true
    function registerTwoPhaseEvent(registrationName, dependencies) {
        registerDirectEvent(registrationName, dependencies);
        registerDirectEvent(registrationName + "Capture", dependencies);
    }
    function registerDirectEvent(registrationName, dependencies) {
        if (registrationNameDependencies[registrationName]) error("EventRegistry: More than one plugin attempted to publish the same registration name, `%s`.", registrationName);
        registrationNameDependencies[registrationName] = dependencies;
        var lowerCasedName = registrationName.toLowerCase();
        possibleRegistrationNames[lowerCasedName] = registrationName;
        if (registrationName === "onDoubleClick") possibleRegistrationNames.ondblclick = registrationName;
        for(var i = 0; i < dependencies.length; i++)allNativeEvents.add(dependencies[i]);
    }
    var canUseDOM = !!(typeof window !== "undefined" && typeof window.document !== "undefined" && typeof window.document.createElement !== "undefined");
    var hasOwnProperty = Object.prototype.hasOwnProperty;
    /*
 * The `'' + value` pattern (used in in perf-sensitive code) throws for Symbol
 * and Temporal.* types. See https://github.com/facebook/react/pull/22064.
 *
 * The functions in this module will throw an easier-to-understand,
 * easier-to-debug exception with a clear errors message message explaining the
 * problem. (Instead of a confusing exception thrown inside the implementation
 * of the `value` object).
 */ // $FlowFixMe only called in DEV, so void return is not possible.
    function typeName(value) {
        // toStringTag is needed for namespaced types like Temporal.Instant
        var hasToStringTag = typeof Symbol === "function" && Symbol.toStringTag;
        var type = hasToStringTag && value[Symbol.toStringTag] || value.constructor.name || "Object";
        return type;
    } // $FlowFixMe only called in DEV, so void return is not possible.
    function willCoercionThrow(value) {
        try {
            testStringCoercion(value);
            return false;
        } catch (e) {
            return true;
        }
    }
    function testStringCoercion(value) {
        // If you ended up here by following an exception call stack, here's what's
        // happened: you supplied an object or symbol value to React (as a prop, key,
        // DOM attribute, CSS property, string ref, etc.) and when React tried to
        // coerce it to a string using `'' + value`, an exception was thrown.
        //
        // The most common types that will cause this exception are `Symbol` instances
        // and Temporal objects like `Temporal.Instant`. But any object that has a
        // `valueOf` or `[Symbol.toPrimitive]` method that throws will also cause this
        // exception. (Library authors do this to prevent users from using built-in
        // numeric operators like `+` or comparison operators like `>=` because custom
        // methods are needed to perform accurate arithmetic or comparison.)
        //
        // To fix the problem, coerce this object or symbol value to a string before
        // passing it to React. The most reliable way is usually `String(value)`.
        //
        // To find which value is throwing, check the browser or debugger console.
        // Before this exception was thrown, there should be `console.error` output
        // that shows the type (Symbol, Temporal.PlainDate, etc.) that caused the
        // problem and how that type was used: key, atrribute, input value prop, etc.
        // In most cases, this console output also shows the component and its
        // ancestor components where the exception happened.
        //
        // eslint-disable-next-line react-internal/safe-string-coercion
        return "" + value;
    }
    function checkAttributeStringCoercion(value, attributeName) {
        if (willCoercionThrow(value)) {
            error("The provided `%s` attribute is an unsupported type %s. This value must be coerced to a string before before using it here.", attributeName, typeName(value));
            return testStringCoercion(value); // throw (to help callers find troubleshooting comments)
        }
    }
    function checkKeyStringCoercion(value) {
        if (willCoercionThrow(value)) {
            error("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", typeName(value));
            return testStringCoercion(value); // throw (to help callers find troubleshooting comments)
        }
    }
    function checkPropStringCoercion(value, propName) {
        if (willCoercionThrow(value)) {
            error("The provided `%s` prop is an unsupported type %s. This value must be coerced to a string before before using it here.", propName, typeName(value));
            return testStringCoercion(value); // throw (to help callers find troubleshooting comments)
        }
    }
    function checkCSSPropertyStringCoercion(value, propName) {
        if (willCoercionThrow(value)) {
            error("The provided `%s` CSS property is an unsupported type %s. This value must be coerced to a string before before using it here.", propName, typeName(value));
            return testStringCoercion(value); // throw (to help callers find troubleshooting comments)
        }
    }
    function checkHtmlStringCoercion(value) {
        if (willCoercionThrow(value)) {
            error("The provided HTML markup uses a value of unsupported type %s. This value must be coerced to a string before before using it here.", typeName(value));
            return testStringCoercion(value); // throw (to help callers find troubleshooting comments)
        }
    }
    function checkFormFieldValueStringCoercion(value) {
        if (willCoercionThrow(value)) {
            error("Form field values (value, checked, defaultValue, or defaultChecked props) must be strings, not %s. This value must be coerced to a string before before using it here.", typeName(value));
            return testStringCoercion(value); // throw (to help callers find troubleshooting comments)
        }
    }
    // A reserved attribute.
    // It is handled by React separately and shouldn't be written to the DOM.
    var RESERVED = 0; // A simple string attribute.
    // Attributes that aren't in the filter are presumed to have this type.
    var STRING = 1; // A string attribute that accepts booleans in React. In HTML, these are called
    // "enumerated" attributes with "true" and "false" as possible values.
    // When true, it should be set to a "true" string.
    // When false, it should be set to a "false" string.
    var BOOLEANISH_STRING = 2; // A real boolean attribute.
    // When true, it should be present (set either to an empty string or its name).
    // When false, it should be omitted.
    var BOOLEAN = 3; // An attribute that can be used as a flag as well as with a value.
    // When true, it should be present (set either to an empty string or its name).
    // When false, it should be omitted.
    // For any other value, should be present with that value.
    var OVERLOADED_BOOLEAN = 4; // An attribute that must be numeric or parse as a numeric.
    // When falsy, it should be removed.
    var NUMERIC = 5; // An attribute that must be positive numeric or parse as a positive numeric.
    // When falsy, it should be removed.
    var POSITIVE_NUMERIC = 6;
    /* eslint-disable max-len */ var ATTRIBUTE_NAME_START_CHAR = ":A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD";
    /* eslint-enable max-len */ var ATTRIBUTE_NAME_CHAR = ATTRIBUTE_NAME_START_CHAR + "\\-.0-9\\u00B7\\u0300-\\u036F\\u203F-\\u2040";
    var VALID_ATTRIBUTE_NAME_REGEX = new RegExp("^[" + ATTRIBUTE_NAME_START_CHAR + "][" + ATTRIBUTE_NAME_CHAR + "]*$");
    var illegalAttributeNameCache = {};
    var validatedAttributeNameCache = {};
    function isAttributeNameSafe(attributeName) {
        if (hasOwnProperty.call(validatedAttributeNameCache, attributeName)) return true;
        if (hasOwnProperty.call(illegalAttributeNameCache, attributeName)) return false;
        if (VALID_ATTRIBUTE_NAME_REGEX.test(attributeName)) {
            validatedAttributeNameCache[attributeName] = true;
            return true;
        }
        illegalAttributeNameCache[attributeName] = true;
        error("Invalid attribute name: `%s`", attributeName);
        return false;
    }
    function shouldIgnoreAttribute(name, propertyInfo, isCustomComponentTag) {
        if (propertyInfo !== null) return propertyInfo.type === RESERVED;
        if (isCustomComponentTag) return false;
        if (name.length > 2 && (name[0] === "o" || name[0] === "O") && (name[1] === "n" || name[1] === "N")) return true;
        return false;
    }
    function shouldRemoveAttributeWithWarning(name, value, propertyInfo, isCustomComponentTag) {
        if (propertyInfo !== null && propertyInfo.type === RESERVED) return false;
        switch(typeof value){
            case "function":
            case "symbol":
                // eslint-disable-line
                return true;
            case "boolean":
                if (isCustomComponentTag) return false;
                if (propertyInfo !== null) return !propertyInfo.acceptsBooleans;
                else {
                    var prefix = name.toLowerCase().slice(0, 5);
                    return prefix !== "data-" && prefix !== "aria-";
                }
            default:
                return false;
        }
    }
    function shouldRemoveAttribute(name, value, propertyInfo, isCustomComponentTag) {
        if (value === null || typeof value === "undefined") return true;
        if (shouldRemoveAttributeWithWarning(name, value, propertyInfo, isCustomComponentTag)) return true;
        if (isCustomComponentTag) return false;
        if (propertyInfo !== null) switch(propertyInfo.type){
            case BOOLEAN:
                return !value;
            case OVERLOADED_BOOLEAN:
                return value === false;
            case NUMERIC:
                return isNaN(value);
            case POSITIVE_NUMERIC:
                return isNaN(value) || value < 1;
        }
        return false;
    }
    function getPropertyInfo(name) {
        return properties.hasOwnProperty(name) ? properties[name] : null;
    }
    function PropertyInfoRecord(name, type, mustUseProperty, attributeName, attributeNamespace, sanitizeURL, removeEmptyString) {
        this.acceptsBooleans = type === BOOLEANISH_STRING || type === BOOLEAN || type === OVERLOADED_BOOLEAN;
        this.attributeName = attributeName;
        this.attributeNamespace = attributeNamespace;
        this.mustUseProperty = mustUseProperty;
        this.propertyName = name;
        this.type = type;
        this.sanitizeURL = sanitizeURL;
        this.removeEmptyString = removeEmptyString;
    } // When adding attributes to this list, be sure to also add them to
    // the `possibleStandardNames` module to ensure casing and incorrect
    // name warnings.
    var properties = {}; // These props are reserved by React. They shouldn't be written to the DOM.
    var reservedProps = [
        "children",
        "dangerouslySetInnerHTML",
        // elements (not just inputs). Now that ReactDOMInput assigns to the
        // defaultValue property -- do we need this?
        "defaultValue",
        "defaultChecked",
        "innerHTML",
        "suppressContentEditableWarning",
        "suppressHydrationWarning",
        "style"
    ];
    reservedProps.forEach(function(name) {
        properties[name] = new PropertyInfoRecord(name, RESERVED, false, name, null, false, false);
    }); // A few React string attributes have a different name.
    // This is a mapping from React prop names to the attribute names.
    [
        [
            "acceptCharset",
            "accept-charset"
        ],
        [
            "className",
            "class"
        ],
        [
            "htmlFor",
            "for"
        ],
        [
            "httpEquiv",
            "http-equiv"
        ]
    ].forEach(function(_ref) {
        var name = _ref[0], attributeName = _ref[1];
        properties[name] = new PropertyInfoRecord(name, STRING, false, attributeName, null, false, false);
    }); // These are "enumerated" HTML attributes that accept "true" and "false".
    // In React, we let users pass `true` and `false` even though technically
    // these aren't boolean attributes (they are coerced to strings).
    [
        "contentEditable",
        "draggable",
        "spellCheck",
        "value"
    ].forEach(function(name) {
        properties[name] = new PropertyInfoRecord(name, BOOLEANISH_STRING, false, name.toLowerCase(), null, false, false);
    }); // These are "enumerated" SVG attributes that accept "true" and "false".
    // In React, we let users pass `true` and `false` even though technically
    // these aren't boolean attributes (they are coerced to strings).
    // Since these are SVG attributes, their attribute names are case-sensitive.
    [
        "autoReverse",
        "externalResourcesRequired",
        "focusable",
        "preserveAlpha"
    ].forEach(function(name) {
        properties[name] = new PropertyInfoRecord(name, BOOLEANISH_STRING, false, name, null, false, false);
    }); // These are HTML boolean attributes.
    [
        "allowFullScreen",
        "async",
        // on the client side because the browsers are inconsistent. Instead we call focus().
        "autoFocus",
        "autoPlay",
        "controls",
        "default",
        "defer",
        "disabled",
        "disablePictureInPicture",
        "disableRemotePlayback",
        "formNoValidate",
        "hidden",
        "loop",
        "noModule",
        "noValidate",
        "open",
        "playsInline",
        "readOnly",
        "required",
        "reversed",
        "scoped",
        "seamless",
        "itemScope"
    ].forEach(function(name) {
        properties[name] = new PropertyInfoRecord(name, BOOLEAN, false, name.toLowerCase(), null, false, false);
    }); // These are the few React props that we set as DOM properties
    // rather than attributes. These are all booleans.
    [
        "checked",
        // disabled with `removeAttribute`. We have special logic for handling this.
        "multiple",
        "muted",
        "selected" // NOTE: if you add a camelCased prop to this list,
    ].forEach(function(name) {
        properties[name] = new PropertyInfoRecord(name, BOOLEAN, true, name, null, false, false);
    }); // These are HTML attributes that are "overloaded booleans": they behave like
    // booleans, but can also accept a string value.
    [
        "capture",
        "download" // NOTE: if you add a camelCased prop to this list,
    ].forEach(function(name) {
        properties[name] = new PropertyInfoRecord(name, OVERLOADED_BOOLEAN, false, name, null, false, false);
    }); // These are HTML attributes that must be positive numbers.
    [
        "cols",
        "rows",
        "size",
        "span" // NOTE: if you add a camelCased prop to this list,
    ].forEach(function(name) {
        properties[name] = new PropertyInfoRecord(name, POSITIVE_NUMERIC, false, name, null, false, false);
    }); // These are HTML attributes that must be numbers.
    [
        "rowSpan",
        "start"
    ].forEach(function(name) {
        properties[name] = new PropertyInfoRecord(name, NUMERIC, false, name.toLowerCase(), null, false, false);
    });
    var CAMELIZE = /[\-\:]([a-z])/g;
    var capitalize = function(token) {
        return token[1].toUpperCase();
    }; // This is a list of all SVG attributes that need special casing, namespacing,
    // or boolean value assignment. Regular attributes that just accept strings
    // and have the same names are omitted, just like in the HTML attribute filter.
    // Some of these attributes can be hard to find. This list was created by
    // scraping the MDN documentation.
    [
        "accent-height",
        "alignment-baseline",
        "arabic-form",
        "baseline-shift",
        "cap-height",
        "clip-path",
        "clip-rule",
        "color-interpolation",
        "color-interpolation-filters",
        "color-profile",
        "color-rendering",
        "dominant-baseline",
        "enable-background",
        "fill-opacity",
        "fill-rule",
        "flood-color",
        "flood-opacity",
        "font-family",
        "font-size",
        "font-size-adjust",
        "font-stretch",
        "font-style",
        "font-variant",
        "font-weight",
        "glyph-name",
        "glyph-orientation-horizontal",
        "glyph-orientation-vertical",
        "horiz-adv-x",
        "horiz-origin-x",
        "image-rendering",
        "letter-spacing",
        "lighting-color",
        "marker-end",
        "marker-mid",
        "marker-start",
        "overline-position",
        "overline-thickness",
        "paint-order",
        "panose-1",
        "pointer-events",
        "rendering-intent",
        "shape-rendering",
        "stop-color",
        "stop-opacity",
        "strikethrough-position",
        "strikethrough-thickness",
        "stroke-dasharray",
        "stroke-dashoffset",
        "stroke-linecap",
        "stroke-linejoin",
        "stroke-miterlimit",
        "stroke-opacity",
        "stroke-width",
        "text-anchor",
        "text-decoration",
        "text-rendering",
        "underline-position",
        "underline-thickness",
        "unicode-bidi",
        "unicode-range",
        "units-per-em",
        "v-alphabetic",
        "v-hanging",
        "v-ideographic",
        "v-mathematical",
        "vector-effect",
        "vert-adv-y",
        "vert-origin-x",
        "vert-origin-y",
        "word-spacing",
        "writing-mode",
        "xmlns:xlink",
        "x-height" // NOTE: if you add a camelCased prop to this list,
    ].forEach(function(attributeName) {
        var name = attributeName.replace(CAMELIZE, capitalize);
        properties[name] = new PropertyInfoRecord(name, STRING, false, attributeName, null, false, false);
    }); // String SVG attributes with the xlink namespace.
    [
        "xlink:actuate",
        "xlink:arcrole",
        "xlink:role",
        "xlink:show",
        "xlink:title",
        "xlink:type" // NOTE: if you add a camelCased prop to this list,
    ].forEach(function(attributeName) {
        var name = attributeName.replace(CAMELIZE, capitalize);
        properties[name] = new PropertyInfoRecord(name, STRING, false, attributeName, "http://www.w3.org/1999/xlink", false, false);
    }); // String SVG attributes with the xml namespace.
    [
        "xml:base",
        "xml:lang",
        "xml:space" // NOTE: if you add a camelCased prop to this list,
    ].forEach(function(attributeName) {
        var name = attributeName.replace(CAMELIZE, capitalize);
        properties[name] = new PropertyInfoRecord(name, STRING, false, attributeName, "http://www.w3.org/XML/1998/namespace", false, false);
    }); // These attribute exists both in HTML and SVG.
    // The attribute name is case-sensitive in SVG so we can't just use
    // the React name like we do for attributes that exist only in HTML.
    [
        "tabIndex",
        "crossOrigin"
    ].forEach(function(attributeName) {
        properties[attributeName] = new PropertyInfoRecord(attributeName, STRING, false, attributeName.toLowerCase(), null, false, false);
    }); // These attributes accept URLs. These must not allow javascript: URLS.
    // These will also need to accept Trusted Types object in the future.
    var xlinkHref = "xlinkHref";
    properties[xlinkHref] = new PropertyInfoRecord("xlinkHref", STRING, false, "xlink:href", "http://www.w3.org/1999/xlink", true, false);
    [
        "src",
        "href",
        "action",
        "formAction"
    ].forEach(function(attributeName) {
        properties[attributeName] = new PropertyInfoRecord(attributeName, STRING, false, attributeName.toLowerCase(), null, true, true);
    });
    // and any newline or tab are filtered out as if they're not part of the URL.
    // https://url.spec.whatwg.org/#url-parsing
    // Tab or newline are defined as \r\n\t:
    // https://infra.spec.whatwg.org/#ascii-tab-or-newline
    // A C0 control is a code point in the range \u0000 NULL to \u001F
    // INFORMATION SEPARATOR ONE, inclusive:
    // https://infra.spec.whatwg.org/#c0-control-or-space
    /* eslint-disable max-len */ var isJavaScriptProtocol = /^[\u0000-\u001F ]*j[\r\n\t]*a[\r\n\t]*v[\r\n\t]*a[\r\n\t]*s[\r\n\t]*c[\r\n\t]*r[\r\n\t]*i[\r\n\t]*p[\r\n\t]*t[\r\n\t]*\:/i;
    var didWarn = false;
    function sanitizeURL(url) {
        if (!didWarn && isJavaScriptProtocol.test(url)) {
            didWarn = true;
            error("A future version of React will block javascript: URLs as a security precaution. Use event handlers instead if you can. If you need to generate unsafe HTML try using dangerouslySetInnerHTML instead. React was passed %s.", JSON.stringify(url));
        }
    }
    /**
 * Get the value for a property on a node. Only used in DEV for SSR validation.
 * The "expected" argument is used as a hint of what the expected value is.
 * Some properties have multiple equivalent values.
 */ function getValueForProperty(node, name, expected, propertyInfo) {
        if (propertyInfo.mustUseProperty) {
            var propertyName = propertyInfo.propertyName;
            return node[propertyName];
        } else {
            checkAttributeStringCoercion(expected, name);
            if (propertyInfo.sanitizeURL) // If we haven't fully disabled javascript: URLs, and if
            // the hydration is successful of a javascript: URL, we
            // still want to warn on the client.
            // eslint-disable-next-line react-internal/safe-string-coercion
            sanitizeURL("" + expected);
            var attributeName = propertyInfo.attributeName;
            var stringValue = null;
            if (propertyInfo.type === OVERLOADED_BOOLEAN) {
                if (node.hasAttribute(attributeName)) {
                    var value = node.getAttribute(attributeName);
                    if (value === "") return true;
                    if (shouldRemoveAttribute(name, expected, propertyInfo, false)) return value;
                     // eslint-disable-next-line react-internal/safe-string-coercion
                    if (value === "" + expected) return expected;
                    return value;
                }
            } else if (node.hasAttribute(attributeName)) {
                if (shouldRemoveAttribute(name, expected, propertyInfo, false)) // We had an attribute but shouldn't have had one, so read it
                // for the error message.
                return node.getAttribute(attributeName);
                if (propertyInfo.type === BOOLEAN) // If this was a boolean, it doesn't matter what the value is
                // the fact that we have it is the same as the expected.
                return expected;
                 // Even if this property uses a namespace we use getAttribute
                // because we assume its namespaced name is the same as our config.
                // To use getAttributeNS we need the local name which we don't have
                // in our config atm.
                stringValue = node.getAttribute(attributeName);
            }
            if (shouldRemoveAttribute(name, expected, propertyInfo, false)) return stringValue === null ? expected : stringValue; // eslint-disable-next-line react-internal/safe-string-coercion
            else if (stringValue === "" + expected) return expected;
            else return stringValue;
        }
    }
    /**
 * Get the value for a attribute on a node. Only used in DEV for SSR validation.
 * The third argument is used as a hint of what the expected value is. Some
 * attributes have multiple equivalent values.
 */ function getValueForAttribute(node, name, expected, isCustomComponentTag) {
        if (!isAttributeNameSafe(name)) return;
        if (!node.hasAttribute(name)) return expected === undefined ? undefined : null;
        var value = node.getAttribute(name);
        checkAttributeStringCoercion(expected, name);
        if (value === "" + expected) return expected;
        return value;
    }
    /**
 * Sets the value for a property on a node.
 *
 * @param {DOMElement} node
 * @param {string} name
 * @param {*} value
 */ function setValueForProperty(node, name, value, isCustomComponentTag) {
        var propertyInfo = getPropertyInfo(name);
        if (shouldIgnoreAttribute(name, propertyInfo, isCustomComponentTag)) return;
        if (shouldRemoveAttribute(name, value, propertyInfo, isCustomComponentTag)) value = null;
        if (isCustomComponentTag || propertyInfo === null) {
            if (isAttributeNameSafe(name)) {
                var _attributeName = name;
                if (value === null) node.removeAttribute(_attributeName);
                else {
                    checkAttributeStringCoercion(value, name);
                    node.setAttribute(_attributeName, "" + value);
                }
            }
            return;
        }
        var mustUseProperty = propertyInfo.mustUseProperty;
        if (mustUseProperty) {
            var propertyName = propertyInfo.propertyName;
            if (value === null) {
                var type = propertyInfo.type;
                node[propertyName] = type === BOOLEAN ? false : "";
            } else // Contrary to `setAttribute`, object properties are properly
            // `toString`ed by IE8/9.
            node[propertyName] = value;
            return;
        } // The rest are treated as attributes with special cases.
        var attributeName = propertyInfo.attributeName, attributeNamespace = propertyInfo.attributeNamespace;
        if (value === null) node.removeAttribute(attributeName);
        else {
            var _type = propertyInfo.type;
            var attributeValue;
            if (_type === BOOLEAN || _type === OVERLOADED_BOOLEAN && value === true) // If attribute type is boolean, we know for sure it won't be an execution sink
            // and we won't require Trusted Type here.
            attributeValue = "";
            else {
                checkAttributeStringCoercion(value, attributeName);
                attributeValue = "" + value;
                if (propertyInfo.sanitizeURL) sanitizeURL(attributeValue.toString());
            }
            if (attributeNamespace) node.setAttributeNS(attributeNamespace, attributeName, attributeValue);
            else node.setAttribute(attributeName, attributeValue);
        }
    }
    // ATTENTION
    // When adding new symbols to this file,
    // Please consider also adding to 'react-devtools-shared/src/backend/ReactSymbols'
    // The Symbol used to tag the ReactElement-like types.
    var REACT_ELEMENT_TYPE = Symbol.for("react.element");
    var REACT_PORTAL_TYPE = Symbol.for("react.portal");
    var REACT_FRAGMENT_TYPE = Symbol.for("react.fragment");
    var REACT_STRICT_MODE_TYPE = Symbol.for("react.strict_mode");
    var REACT_PROFILER_TYPE = Symbol.for("react.profiler");
    var REACT_PROVIDER_TYPE = Symbol.for("react.provider");
    var REACT_CONTEXT_TYPE = Symbol.for("react.context");
    var REACT_FORWARD_REF_TYPE = Symbol.for("react.forward_ref");
    var REACT_SUSPENSE_TYPE = Symbol.for("react.suspense");
    var REACT_SUSPENSE_LIST_TYPE = Symbol.for("react.suspense_list");
    var REACT_MEMO_TYPE = Symbol.for("react.memo");
    var REACT_LAZY_TYPE = Symbol.for("react.lazy");
    var REACT_SCOPE_TYPE = Symbol.for("react.scope");
    var REACT_DEBUG_TRACING_MODE_TYPE = Symbol.for("react.debug_trace_mode");
    var REACT_OFFSCREEN_TYPE = Symbol.for("react.offscreen");
    var REACT_LEGACY_HIDDEN_TYPE = Symbol.for("react.legacy_hidden");
    var REACT_CACHE_TYPE = Symbol.for("react.cache");
    var REACT_TRACING_MARKER_TYPE = Symbol.for("react.tracing_marker");
    var MAYBE_ITERATOR_SYMBOL = Symbol.iterator;
    var FAUX_ITERATOR_SYMBOL = "@@iterator";
    function getIteratorFn(maybeIterable) {
        if (maybeIterable === null || typeof maybeIterable !== "object") return null;
        var maybeIterator = MAYBE_ITERATOR_SYMBOL && maybeIterable[MAYBE_ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL];
        if (typeof maybeIterator === "function") return maybeIterator;
        return null;
    }
    var assign = Object.assign;
    // Helpers to patch console.logs to avoid logging during side-effect free
    // replaying on render function. This currently only patches the object
    // lazily which won't cover if the log function was extracted eagerly.
    // We could also eagerly patch the method.
    var disabledDepth = 0;
    var prevLog;
    var prevInfo;
    var prevWarn;
    var prevError;
    var prevGroup;
    var prevGroupCollapsed;
    var prevGroupEnd;
    function disabledLog() {}
    disabledLog.__reactDisabledLog = true;
    function disableLogs() {
        if (disabledDepth === 0) {
            /* eslint-disable react-internal/no-production-logging */ prevLog = console.log;
            prevInfo = console.info;
            prevWarn = console.warn;
            prevError = console.error;
            prevGroup = console.group;
            prevGroupCollapsed = console.groupCollapsed;
            prevGroupEnd = console.groupEnd; // https://github.com/facebook/react/issues/19099
            var props = {
                configurable: true,
                enumerable: true,
                value: disabledLog,
                writable: true
            }; // $FlowFixMe Flow thinks console is immutable.
            Object.defineProperties(console, {
                info: props,
                log: props,
                warn: props,
                error: props,
                group: props,
                groupCollapsed: props,
                groupEnd: props
            });
        /* eslint-enable react-internal/no-production-logging */ }
        disabledDepth++;
    }
    function reenableLogs() {
        disabledDepth--;
        if (disabledDepth === 0) {
            /* eslint-disable react-internal/no-production-logging */ var props = {
                configurable: true,
                enumerable: true,
                writable: true
            }; // $FlowFixMe Flow thinks console is immutable.
            Object.defineProperties(console, {
                log: assign({}, props, {
                    value: prevLog
                }),
                info: assign({}, props, {
                    value: prevInfo
                }),
                warn: assign({}, props, {
                    value: prevWarn
                }),
                error: assign({}, props, {
                    value: prevError
                }),
                group: assign({}, props, {
                    value: prevGroup
                }),
                groupCollapsed: assign({}, props, {
                    value: prevGroupCollapsed
                }),
                groupEnd: assign({}, props, {
                    value: prevGroupEnd
                })
            });
        /* eslint-enable react-internal/no-production-logging */ }
        if (disabledDepth < 0) error("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
    }
    var ReactCurrentDispatcher = ReactSharedInternals.ReactCurrentDispatcher;
    var prefix;
    function describeBuiltInComponentFrame(name, source, ownerFn) {
        if (prefix === undefined) // Extract the VM specific prefix used by each line.
        try {
            throw Error();
        } catch (x) {
            var match = x.stack.trim().match(/\n( *(at )?)/);
            prefix = match && match[1] || "";
        }
         // We use the prefix to ensure our stacks line up with native stack frames.
        return "\n" + prefix + name;
    }
    var reentry = false;
    var componentFrameCache;
    var PossiblyWeakMap = typeof WeakMap === "function" ? WeakMap : Map;
    componentFrameCache = new PossiblyWeakMap();
    function describeNativeComponentFrame(fn, construct) {
        // If something asked for a stack inside a fake render, it should get ignored.
        if (!fn || reentry) return "";
        var frame = componentFrameCache.get(fn);
        if (frame !== undefined) return frame;
        var control;
        reentry = true;
        var previousPrepareStackTrace = Error.prepareStackTrace; // $FlowFixMe It does accept undefined.
        Error.prepareStackTrace = undefined;
        var previousDispatcher;
        previousDispatcher = ReactCurrentDispatcher.current; // Set the dispatcher in DEV because this might be call in the render function
        // for warnings.
        ReactCurrentDispatcher.current = null;
        disableLogs();
        try {
            // This should throw.
            if (construct) {
                // Something should be setting the props in the constructor.
                var Fake = function() {
                    throw Error();
                }; // $FlowFixMe
                Object.defineProperty(Fake.prototype, "props", {
                    set: function() {
                        // We use a throwing setter instead of frozen or non-writable props
                        // because that won't throw in a non-strict mode function.
                        throw Error();
                    }
                });
                if (typeof Reflect === "object" && Reflect.construct) {
                    // We construct a different control for this case to include any extra
                    // frames added by the construct call.
                    try {
                        Reflect.construct(Fake, []);
                    } catch (x) {
                        control = x;
                    }
                    Reflect.construct(fn, [], Fake);
                } else {
                    try {
                        Fake.call();
                    } catch (x) {
                        control = x;
                    }
                    fn.call(Fake.prototype);
                }
            } else {
                try {
                    throw Error();
                } catch (x) {
                    control = x;
                }
                fn();
            }
        } catch (sample) {
            // This is inlined manually because closure doesn't do it for us.
            if (sample && control && typeof sample.stack === "string") {
                // This extracts the first frame from the sample that isn't also in the control.
                // Skipping one frame that we assume is the frame that calls the two.
                var sampleLines = sample.stack.split("\n");
                var controlLines = control.stack.split("\n");
                var s = sampleLines.length - 1;
                var c = controlLines.length - 1;
                while(s >= 1 && c >= 0 && sampleLines[s] !== controlLines[c])// We expect at least one stack frame to be shared.
                // Typically this will be the root most one. However, stack frames may be
                // cut off due to maximum stack limits. In this case, one maybe cut off
                // earlier than the other. We assume that the sample is longer or the same
                // and there for cut off earlier. So we should find the root most frame in
                // the sample somewhere in the control.
                c--;
                for(; s >= 1 && c >= 0; s--, c--)// Next we find the first one that isn't the same which should be the
                // frame that called our sample function and the control.
                if (sampleLines[s] !== controlLines[c]) {
                    // In V8, the first line is describing the message but other VMs don't.
                    // If we're about to return the first line, and the control is also on the same
                    // line, that's a pretty good indicator that our sample threw at same line as
                    // the control. I.e. before we entered the sample frame. So we ignore this result.
                    // This can happen if you passed a class to function component, or non-function.
                    if (s !== 1 || c !== 1) do {
                        s--;
                        c--; // We may still have similar intermediate frames from the construct call.
                        // The next one that isn't the same should be our match though.
                        if (c < 0 || sampleLines[s] !== controlLines[c]) {
                            // V8 adds a "new" prefix for native classes. Let's remove it to make it prettier.
                            var _frame = "\n" + sampleLines[s].replace(" at new ", " at "); // If our component frame is labeled "<anonymous>"
                            // but we have a user-provided "displayName"
                            // splice it in to make the stack more readable.
                            if (fn.displayName && _frame.includes("<anonymous>")) _frame = _frame.replace("<anonymous>", fn.displayName);
                            if (typeof fn === "function") componentFrameCache.set(fn, _frame);
                            return _frame;
                        }
                    }while (s >= 1 && c >= 0);
                    break;
                }
            }
        } finally{
            reentry = false;
            ReactCurrentDispatcher.current = previousDispatcher;
            reenableLogs();
            Error.prepareStackTrace = previousPrepareStackTrace;
        } // Fallback to just using the name if we couldn't make it throw.
        var name = fn ? fn.displayName || fn.name : "";
        var syntheticFrame = name ? describeBuiltInComponentFrame(name) : "";
        if (typeof fn === "function") componentFrameCache.set(fn, syntheticFrame);
        return syntheticFrame;
    }
    function describeClassComponentFrame(ctor, source, ownerFn) {
        return describeNativeComponentFrame(ctor, true);
    }
    function describeFunctionComponentFrame(fn, source, ownerFn) {
        return describeNativeComponentFrame(fn, false);
    }
    function shouldConstruct(Component) {
        var prototype = Component.prototype;
        return !!(prototype && prototype.isReactComponent);
    }
    function describeUnknownElementTypeFrameInDEV(type, source, ownerFn) {
        if (type == null) return "";
        if (typeof type === "function") return describeNativeComponentFrame(type, shouldConstruct(type));
        if (typeof type === "string") return describeBuiltInComponentFrame(type);
        switch(type){
            case REACT_SUSPENSE_TYPE:
                return describeBuiltInComponentFrame("Suspense");
            case REACT_SUSPENSE_LIST_TYPE:
                return describeBuiltInComponentFrame("SuspenseList");
        }
        if (typeof type === "object") switch(type.$$typeof){
            case REACT_FORWARD_REF_TYPE:
                return describeFunctionComponentFrame(type.render);
            case REACT_MEMO_TYPE:
                // Memo may contain any component type so we recursively resolve it.
                return describeUnknownElementTypeFrameInDEV(type.type, source, ownerFn);
            case REACT_LAZY_TYPE:
                var lazyComponent = type;
                var payload = lazyComponent._payload;
                var init = lazyComponent._init;
                try {
                    // Lazy may contain any component type so we recursively resolve it.
                    return describeUnknownElementTypeFrameInDEV(init(payload), source, ownerFn);
                } catch (x) {}
        }
        return "";
    }
    function describeFiber(fiber) {
        var owner = fiber._debugOwner ? fiber._debugOwner.type : null;
        var source = fiber._debugSource;
        switch(fiber.tag){
            case HostComponent:
                return describeBuiltInComponentFrame(fiber.type);
            case LazyComponent:
                return describeBuiltInComponentFrame("Lazy");
            case SuspenseComponent:
                return describeBuiltInComponentFrame("Suspense");
            case SuspenseListComponent:
                return describeBuiltInComponentFrame("SuspenseList");
            case FunctionComponent:
            case IndeterminateComponent:
            case SimpleMemoComponent:
                return describeFunctionComponentFrame(fiber.type);
            case ForwardRef:
                return describeFunctionComponentFrame(fiber.type.render);
            case ClassComponent:
                return describeClassComponentFrame(fiber.type);
            default:
                return "";
        }
    }
    function getStackByFiberInDevAndProd(workInProgress) {
        try {
            var info = "";
            var node = workInProgress;
            do {
                info += describeFiber(node);
                node = node.return;
            }while (node);
            return info;
        } catch (x) {
            return "\nError generating stack: " + x.message + "\n" + x.stack;
        }
    }
    function getWrappedName(outerType, innerType, wrapperName) {
        var displayName = outerType.displayName;
        if (displayName) return displayName;
        var functionName = innerType.displayName || innerType.name || "";
        return functionName !== "" ? wrapperName + "(" + functionName + ")" : wrapperName;
    } // Keep in sync with react-reconciler/getComponentNameFromFiber
    function getContextName(type) {
        return type.displayName || "Context";
    } // Note that the reconciler package should generally prefer to use getComponentNameFromFiber() instead.
    function getComponentNameFromType(type) {
        if (type == null) // Host root, text node or just invalid type.
        return null;
        if (typeof type.tag === "number") error("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue.");
        if (typeof type === "function") return type.displayName || type.name || null;
        if (typeof type === "string") return type;
        switch(type){
            case REACT_FRAGMENT_TYPE:
                return "Fragment";
            case REACT_PORTAL_TYPE:
                return "Portal";
            case REACT_PROFILER_TYPE:
                return "Profiler";
            case REACT_STRICT_MODE_TYPE:
                return "StrictMode";
            case REACT_SUSPENSE_TYPE:
                return "Suspense";
            case REACT_SUSPENSE_LIST_TYPE:
                return "SuspenseList";
        }
        if (typeof type === "object") switch(type.$$typeof){
            case REACT_CONTEXT_TYPE:
                var context = type;
                return getContextName(context) + ".Consumer";
            case REACT_PROVIDER_TYPE:
                var provider = type;
                return getContextName(provider._context) + ".Provider";
            case REACT_FORWARD_REF_TYPE:
                return getWrappedName(type, type.render, "ForwardRef");
            case REACT_MEMO_TYPE:
                var outerName = type.displayName || null;
                if (outerName !== null) return outerName;
                return getComponentNameFromType(type.type) || "Memo";
            case REACT_LAZY_TYPE:
                var lazyComponent = type;
                var payload = lazyComponent._payload;
                var init = lazyComponent._init;
                try {
                    return getComponentNameFromType(init(payload));
                } catch (x) {
                    return null;
                }
        }
        return null;
    }
    function getWrappedName$1(outerType, innerType, wrapperName) {
        var functionName = innerType.displayName || innerType.name || "";
        return outerType.displayName || (functionName !== "" ? wrapperName + "(" + functionName + ")" : wrapperName);
    } // Keep in sync with shared/getComponentNameFromType
    function getContextName$1(type) {
        return type.displayName || "Context";
    }
    function getComponentNameFromFiber(fiber) {
        var tag = fiber.tag, type = fiber.type;
        switch(tag){
            case CacheComponent:
                return "Cache";
            case ContextConsumer:
                var context = type;
                return getContextName$1(context) + ".Consumer";
            case ContextProvider:
                var provider = type;
                return getContextName$1(provider._context) + ".Provider";
            case DehydratedFragment:
                return "DehydratedFragment";
            case ForwardRef:
                return getWrappedName$1(type, type.render, "ForwardRef");
            case Fragment:
                return "Fragment";
            case HostComponent:
                // Host component type is the display name (e.g. "div", "View")
                return type;
            case HostPortal:
                return "Portal";
            case HostRoot:
                return "Root";
            case HostText:
                return "Text";
            case LazyComponent:
                // Name comes from the type in this case; we don't have a tag.
                return getComponentNameFromType(type);
            case Mode:
                if (type === REACT_STRICT_MODE_TYPE) // Don't be less specific than shared/getComponentNameFromType
                return "StrictMode";
                return "Mode";
            case OffscreenComponent:
                return "Offscreen";
            case Profiler:
                return "Profiler";
            case ScopeComponent:
                return "Scope";
            case SuspenseComponent:
                return "Suspense";
            case SuspenseListComponent:
                return "SuspenseList";
            case TracingMarkerComponent:
                return "TracingMarker";
            // The display name for this tags come from the user-provided type:
            case ClassComponent:
            case FunctionComponent:
            case IncompleteClassComponent:
            case IndeterminateComponent:
            case MemoComponent:
            case SimpleMemoComponent:
                if (typeof type === "function") return type.displayName || type.name || null;
                if (typeof type === "string") return type;
                break;
        }
        return null;
    }
    var ReactDebugCurrentFrame = ReactSharedInternals.ReactDebugCurrentFrame;
    var current = null;
    var isRendering = false;
    function getCurrentFiberOwnerNameInDevOrNull() {
        if (current === null) return null;
        var owner = current._debugOwner;
        if (owner !== null && typeof owner !== "undefined") return getComponentNameFromFiber(owner);
        return null;
    }
    function getCurrentFiberStackInDev() {
        if (current === null) return "";
         // Safe because if current fiber exists, we are reconciling,
        // and it is guaranteed to be the work-in-progress version.
        return getStackByFiberInDevAndProd(current);
    }
    function resetCurrentFiber() {
        ReactDebugCurrentFrame.getCurrentStack = null;
        current = null;
        isRendering = false;
    }
    function setCurrentFiber(fiber) {
        ReactDebugCurrentFrame.getCurrentStack = fiber === null ? null : getCurrentFiberStackInDev;
        current = fiber;
        isRendering = false;
    }
    function getCurrentFiber() {
        return current;
    }
    function setIsRendering(rendering) {
        isRendering = rendering;
    }
    // Flow does not allow string concatenation of most non-string types. To work
    // around this limitation, we use an opaque type that can only be obtained by
    // passing the value through getToStringValue first.
    function toString(value) {
        // The coercion safety check is performed in getToStringValue().
        // eslint-disable-next-line react-internal/safe-string-coercion
        return "" + value;
    }
    function getToStringValue(value) {
        switch(typeof value){
            case "boolean":
            case "number":
            case "string":
            case "undefined":
                return value;
            case "object":
                checkFormFieldValueStringCoercion(value);
                return value;
            default:
                // function, symbol are assigned as empty strings
                return "";
        }
    }
    var hasReadOnlyValue = {
        button: true,
        checkbox: true,
        image: true,
        hidden: true,
        radio: true,
        reset: true,
        submit: true
    };
    function checkControlledValueProps(tagName, props) {
        if (!(hasReadOnlyValue[props.type] || props.onChange || props.onInput || props.readOnly || props.disabled || props.value == null)) error("You provided a `value` prop to a form field without an `onChange` handler. This will render a read-only field. If the field should be mutable use `defaultValue`. Otherwise, set either `onChange` or `readOnly`.");
        if (!(props.onChange || props.readOnly || props.disabled || props.checked == null)) error("You provided a `checked` prop to a form field without an `onChange` handler. This will render a read-only field. If the field should be mutable use `defaultChecked`. Otherwise, set either `onChange` or `readOnly`.");
    }
    function isCheckable(elem) {
        var type = elem.type;
        var nodeName = elem.nodeName;
        return nodeName && nodeName.toLowerCase() === "input" && (type === "checkbox" || type === "radio");
    }
    function getTracker(node) {
        return node._valueTracker;
    }
    function detachTracker(node) {
        node._valueTracker = null;
    }
    function getValueFromNode(node) {
        var value = "";
        if (!node) return value;
        if (isCheckable(node)) value = node.checked ? "true" : "false";
        else value = node.value;
        return value;
    }
    function trackValueOnNode(node) {
        var valueField = isCheckable(node) ? "checked" : "value";
        var descriptor = Object.getOwnPropertyDescriptor(node.constructor.prototype, valueField);
        checkFormFieldValueStringCoercion(node[valueField]);
        var currentValue = "" + node[valueField]; // if someone has already defined a value or Safari, then bail
        // and don't track value will cause over reporting of changes,
        // but it's better then a hard failure
        // (needed for certain tests that spyOn input values and Safari)
        if (node.hasOwnProperty(valueField) || typeof descriptor === "undefined" || typeof descriptor.get !== "function" || typeof descriptor.set !== "function") return;
        var get = descriptor.get, set = descriptor.set;
        Object.defineProperty(node, valueField, {
            configurable: true,
            get: function() {
                return get.call(this);
            },
            set: function(value) {
                checkFormFieldValueStringCoercion(value);
                currentValue = "" + value;
                set.call(this, value);
            }
        }); // We could've passed this the first time
        // but it triggers a bug in IE11 and Edge 14/15.
        // Calling defineProperty() again should be equivalent.
        // https://github.com/facebook/react/issues/11768
        Object.defineProperty(node, valueField, {
            enumerable: descriptor.enumerable
        });
        var tracker = {
            getValue: function() {
                return currentValue;
            },
            setValue: function(value) {
                checkFormFieldValueStringCoercion(value);
                currentValue = "" + value;
            },
            stopTracking: function() {
                detachTracker(node);
                delete node[valueField];
            }
        };
        return tracker;
    }
    function track(node) {
        if (getTracker(node)) return;
         // TODO: Once it's just Fiber we can move this to node._wrapperState
        node._valueTracker = trackValueOnNode(node);
    }
    function updateValueIfChanged(node) {
        if (!node) return false;
        var tracker = getTracker(node); // if there is no tracker at this point it's unlikely
        // that trying again will succeed
        if (!tracker) return true;
        var lastValue = tracker.getValue();
        var nextValue = getValueFromNode(node);
        if (nextValue !== lastValue) {
            tracker.setValue(nextValue);
            return true;
        }
        return false;
    }
    function getActiveElement(doc) {
        doc = doc || (typeof document !== "undefined" ? document : undefined);
        if (typeof doc === "undefined") return null;
        try {
            return doc.activeElement || doc.body;
        } catch (e) {
            return doc.body;
        }
    }
    var didWarnValueDefaultValue = false;
    var didWarnCheckedDefaultChecked = false;
    var didWarnControlledToUncontrolled = false;
    var didWarnUncontrolledToControlled = false;
    function isControlled(props) {
        var usesChecked = props.type === "checkbox" || props.type === "radio";
        return usesChecked ? props.checked != null : props.value != null;
    }
    /**
 * Implements an <input> host component that allows setting these optional
 * props: `checked`, `value`, `defaultChecked`, and `defaultValue`.
 *
 * If `checked` or `value` are not supplied (or null/undefined), user actions
 * that affect the checked state or value will trigger updates to the element.
 *
 * If they are supplied (and not null/undefined), the rendered element will not
 * trigger updates to the element. Instead, the props must change in order for
 * the rendered element to be updated.
 *
 * The rendered element will be initialized as unchecked (or `defaultChecked`)
 * with an empty value (or `defaultValue`).
 *
 * See http://www.w3.org/TR/2012/WD-html5-20121025/the-input-element.html
 */ function getHostProps(element, props) {
        var node = element;
        var checked = props.checked;
        var hostProps = assign({}, props, {
            defaultChecked: undefined,
            defaultValue: undefined,
            value: undefined,
            checked: checked != null ? checked : node._wrapperState.initialChecked
        });
        return hostProps;
    }
    function initWrapperState(element, props) {
        checkControlledValueProps("input", props);
        if (props.checked !== undefined && props.defaultChecked !== undefined && !didWarnCheckedDefaultChecked) {
            error("%s contains an input of type %s with both checked and defaultChecked props. Input elements must be either controlled or uncontrolled (specify either the checked prop, or the defaultChecked prop, but not both). Decide between using a controlled or uncontrolled input element and remove one of these props. More info: https://reactjs.org/link/controlled-components", getCurrentFiberOwnerNameInDevOrNull() || "A component", props.type);
            didWarnCheckedDefaultChecked = true;
        }
        if (props.value !== undefined && props.defaultValue !== undefined && !didWarnValueDefaultValue) {
            error("%s contains an input of type %s with both value and defaultValue props. Input elements must be either controlled or uncontrolled (specify either the value prop, or the defaultValue prop, but not both). Decide between using a controlled or uncontrolled input element and remove one of these props. More info: https://reactjs.org/link/controlled-components", getCurrentFiberOwnerNameInDevOrNull() || "A component", props.type);
            didWarnValueDefaultValue = true;
        }
        var node = element;
        var defaultValue = props.defaultValue == null ? "" : props.defaultValue;
        node._wrapperState = {
            initialChecked: props.checked != null ? props.checked : props.defaultChecked,
            initialValue: getToStringValue(props.value != null ? props.value : defaultValue),
            controlled: isControlled(props)
        };
    }
    function updateChecked(element, props) {
        var node = element;
        var checked = props.checked;
        if (checked != null) setValueForProperty(node, "checked", checked, false);
    }
    function updateWrapper(element, props) {
        var node = element;
        var controlled = isControlled(props);
        if (!node._wrapperState.controlled && controlled && !didWarnUncontrolledToControlled) {
            error("A component is changing an uncontrolled input to be controlled. This is likely caused by the value changing from undefined to a defined value, which should not happen. Decide between using a controlled or uncontrolled input element for the lifetime of the component. More info: https://reactjs.org/link/controlled-components");
            didWarnUncontrolledToControlled = true;
        }
        if (node._wrapperState.controlled && !controlled && !didWarnControlledToUncontrolled) {
            error("A component is changing a controlled input to be uncontrolled. This is likely caused by the value changing from a defined to undefined, which should not happen. Decide between using a controlled or uncontrolled input element for the lifetime of the component. More info: https://reactjs.org/link/controlled-components");
            didWarnControlledToUncontrolled = true;
        }
        updateChecked(element, props);
        var value = getToStringValue(props.value);
        var type = props.type;
        if (value != null) {
            if (type === "number") {
                if (value === 0 && node.value === "" || // We explicitly want to coerce to number here if possible.
                // eslint-disable-next-line
                node.value != value) node.value = toString(value);
            } else if (node.value !== toString(value)) node.value = toString(value);
        } else if (type === "submit" || type === "reset") {
            // Submit/reset inputs need the attribute removed completely to avoid
            // blank-text buttons.
            node.removeAttribute("value");
            return;
        }
        // When syncing the value attribute, the value comes from a cascade of
        // properties:
        //  1. The value React property
        //  2. The defaultValue React property
        //  3. Otherwise there should be no change
        if (props.hasOwnProperty("value")) setDefaultValue(node, props.type, value);
        else if (props.hasOwnProperty("defaultValue")) setDefaultValue(node, props.type, getToStringValue(props.defaultValue));
        // When syncing the checked attribute, it only changes when it needs
        // to be removed, such as transitioning from a checkbox into a text input
        if (props.checked == null && props.defaultChecked != null) node.defaultChecked = !!props.defaultChecked;
    }
    function postMountWrapper(element, props, isHydrating) {
        var node = element; // Do not assign value if it is already set. This prevents user text input
        // from being lost during SSR hydration.
        if (props.hasOwnProperty("value") || props.hasOwnProperty("defaultValue")) {
            var type = props.type;
            var isButton = type === "submit" || type === "reset"; // Avoid setting value attribute on submit/reset inputs as it overrides the
            // default value provided by the browser. See: #12872
            if (isButton && (props.value === undefined || props.value === null)) return;
            var initialValue = toString(node._wrapperState.initialValue); // Do not assign value if it is already set. This prevents user text input
            // from being lost during SSR hydration.
            if (!isHydrating) // When syncing the value attribute, the value property should use
            // the wrapperState._initialValue property. This uses:
            //
            //   1. The value React property when present
            //   2. The defaultValue React property when present
            //   3. An empty string
            {
                if (initialValue !== node.value) node.value = initialValue;
            }
            // Otherwise, the value attribute is synchronized to the property,
            // so we assign defaultValue to the same thing as the value property
            // assignment step above.
            node.defaultValue = initialValue;
        } // Normally, we'd just do `node.checked = node.checked` upon initial mount, less this bug
        // this is needed to work around a chrome bug where setting defaultChecked
        // will sometimes influence the value of checked (even after detachment).
        // Reference: https://bugs.chromium.org/p/chromium/issues/detail?id=608416
        // We need to temporarily unset name to avoid disrupting radio button groups.
        var name = node.name;
        if (name !== "") node.name = "";
        // When syncing the checked attribute, both the checked property and
        // attribute are assigned at the same time using defaultChecked. This uses:
        //
        //   1. The checked React property when present
        //   2. The defaultChecked React property when present
        //   3. Otherwise, false
        node.defaultChecked = !node.defaultChecked;
        node.defaultChecked = !!node._wrapperState.initialChecked;
        if (name !== "") node.name = name;
    }
    function restoreControlledState(element, props) {
        var node = element;
        updateWrapper(node, props);
        updateNamedCousins(node, props);
    }
    function updateNamedCousins(rootNode, props) {
        var name = props.name;
        if (props.type === "radio" && name != null) {
            var queryRoot = rootNode;
            while(queryRoot.parentNode)queryRoot = queryRoot.parentNode;
             // If `rootNode.form` was non-null, then we could try `form.elements`,
            checkAttributeStringCoercion(name, "name");
            var group = queryRoot.querySelectorAll("input[name=" + JSON.stringify("" + name) + '][type="radio"]');
            for(var i = 0; i < group.length; i++){
                var otherNode = group[i];
                if (otherNode === rootNode || otherNode.form !== rootNode.form) continue;
                 // This will throw if radio buttons rendered by different copies of React
                // and the same name are rendered into the same form (same as #1939).
                // That's probably okay; we don't support it just as we don't support
                // mixing React radio buttons with non-React ones.
                var otherProps = getFiberCurrentPropsFromNode(otherNode);
                if (!otherProps) throw new Error("ReactDOMInput: Mixing React and non-React radio inputs with the same `name` is not supported.");
                 // We need update the tracked value on the named cousin since the value
                // was changed but the input saw no event or value set
                updateValueIfChanged(otherNode); // If this is a controlled radio button group, forcing the input that
                // was previously checked to update will cause it to be come re-checked
                // as appropriate.
                updateWrapper(otherNode, otherProps);
            }
        }
    } // In Chrome, assigning defaultValue to certain input types triggers input validation.
    // For number inputs, the display value loses trailing decimal points. For email inputs,
    // Chrome raises "The specified value <x> is not a valid email address".
    //
    // Here we check to see if the defaultValue has actually changed, avoiding these problems
    // when the user is inputting text
    //
    // https://github.com/facebook/react/issues/7253
    function setDefaultValue(node, type, value) {
        if (type !== "number" || getActiveElement(node.ownerDocument) !== node) {
            if (value == null) node.defaultValue = toString(node._wrapperState.initialValue);
            else if (node.defaultValue !== toString(value)) node.defaultValue = toString(value);
        }
    }
    var didWarnSelectedSetOnOption = false;
    var didWarnInvalidChild = false;
    var didWarnInvalidInnerHTML = false;
    /**
 * Implements an <option> host component that warns when `selected` is set.
 */ function validateProps(element, props) {
        // If a value is not provided, then the children must be simple.
        if (props.value == null) {
            if (typeof props.children === "object" && props.children !== null) React.Children.forEach(props.children, function(child) {
                if (child == null) return;
                if (typeof child === "string" || typeof child === "number") return;
                if (!didWarnInvalidChild) {
                    didWarnInvalidChild = true;
                    error("Cannot infer the option value of complex children. Pass a `value` prop or use a plain string as children to <option>.");
                }
            });
            else if (props.dangerouslySetInnerHTML != null) {
                if (!didWarnInvalidInnerHTML) {
                    didWarnInvalidInnerHTML = true;
                    error("Pass a `value` prop if you set dangerouslyInnerHTML so React knows which value should be selected.");
                }
            }
        } // TODO: Remove support for `selected` in <option>.
        if (props.selected != null && !didWarnSelectedSetOnOption) {
            error("Use the `defaultValue` or `value` props on <select> instead of setting `selected` on <option>.");
            didWarnSelectedSetOnOption = true;
        }
    }
    function postMountWrapper$1(element, props) {
        // value="" should make a value attribute (#6219)
        if (props.value != null) element.setAttribute("value", toString(getToStringValue(props.value)));
    }
    var isArrayImpl = Array.isArray; // eslint-disable-next-line no-redeclare
    function isArray(a) {
        return isArrayImpl(a);
    }
    var didWarnValueDefaultValue$1;
    didWarnValueDefaultValue$1 = false;
    function getDeclarationErrorAddendum() {
        var ownerName = getCurrentFiberOwnerNameInDevOrNull();
        if (ownerName) return "\n\nCheck the render method of `" + ownerName + "`.";
        return "";
    }
    var valuePropNames = [
        "value",
        "defaultValue"
    ];
    /**
 * Validation function for `value` and `defaultValue`.
 */ function checkSelectPropTypes(props) {
        checkControlledValueProps("select", props);
        for(var i = 0; i < valuePropNames.length; i++){
            var propName = valuePropNames[i];
            if (props[propName] == null) continue;
            var propNameIsArray = isArray(props[propName]);
            if (props.multiple && !propNameIsArray) error("The `%s` prop supplied to <select> must be an array if `multiple` is true.%s", propName, getDeclarationErrorAddendum());
            else if (!props.multiple && propNameIsArray) error("The `%s` prop supplied to <select> must be a scalar value if `multiple` is false.%s", propName, getDeclarationErrorAddendum());
        }
    }
    function updateOptions(node, multiple, propValue, setDefaultSelected) {
        var options = node.options;
        if (multiple) {
            var selectedValues = propValue;
            var selectedValue = {};
            for(var i = 0; i < selectedValues.length; i++)// Prefix to avoid chaos with special keys.
            selectedValue["$" + selectedValues[i]] = true;
            for(var _i = 0; _i < options.length; _i++){
                var selected = selectedValue.hasOwnProperty("$" + options[_i].value);
                if (options[_i].selected !== selected) options[_i].selected = selected;
                if (selected && setDefaultSelected) options[_i].defaultSelected = true;
            }
        } else {
            // Do not set `select.value` as exact behavior isn't consistent across all
            // browsers for all cases.
            var _selectedValue = toString(getToStringValue(propValue));
            var defaultSelected = null;
            for(var _i2 = 0; _i2 < options.length; _i2++){
                if (options[_i2].value === _selectedValue) {
                    options[_i2].selected = true;
                    if (setDefaultSelected) options[_i2].defaultSelected = true;
                    return;
                }
                if (defaultSelected === null && !options[_i2].disabled) defaultSelected = options[_i2];
            }
            if (defaultSelected !== null) defaultSelected.selected = true;
        }
    }
    /**
 * Implements a <select> host component that allows optionally setting the
 * props `value` and `defaultValue`. If `multiple` is false, the prop must be a
 * stringable. If `multiple` is true, the prop must be an array of stringables.
 *
 * If `value` is not supplied (or null/undefined), user actions that change the
 * selected option will trigger updates to the rendered options.
 *
 * If it is supplied (and not null/undefined), the rendered options will not
 * update in response to user actions. Instead, the `value` prop must change in
 * order for the rendered options to update.
 *
 * If `defaultValue` is provided, any options with the supplied values will be
 * selected.
 */ function getHostProps$1(element, props) {
        return assign({}, props, {
            value: undefined
        });
    }
    function initWrapperState$1(element, props) {
        var node = element;
        checkSelectPropTypes(props);
        node._wrapperState = {
            wasMultiple: !!props.multiple
        };
        if (props.value !== undefined && props.defaultValue !== undefined && !didWarnValueDefaultValue$1) {
            error("Select elements must be either controlled or uncontrolled (specify either the value prop, or the defaultValue prop, but not both). Decide between using a controlled or uncontrolled select element and remove one of these props. More info: https://reactjs.org/link/controlled-components");
            didWarnValueDefaultValue$1 = true;
        }
    }
    function postMountWrapper$2(element, props) {
        var node = element;
        node.multiple = !!props.multiple;
        var value = props.value;
        if (value != null) updateOptions(node, !!props.multiple, value, false);
        else if (props.defaultValue != null) updateOptions(node, !!props.multiple, props.defaultValue, true);
    }
    function postUpdateWrapper(element, props) {
        var node = element;
        var wasMultiple = node._wrapperState.wasMultiple;
        node._wrapperState.wasMultiple = !!props.multiple;
        var value = props.value;
        if (value != null) updateOptions(node, !!props.multiple, value, false);
        else if (wasMultiple !== !!props.multiple) {
            // For simplicity, reapply `defaultValue` if `multiple` is toggled.
            if (props.defaultValue != null) updateOptions(node, !!props.multiple, props.defaultValue, true);
            else // Revert the select back to its default unselected state.
            updateOptions(node, !!props.multiple, props.multiple ? [] : "", false);
        }
    }
    function restoreControlledState$1(element, props) {
        var node = element;
        var value = props.value;
        if (value != null) updateOptions(node, !!props.multiple, value, false);
    }
    var didWarnValDefaultVal = false;
    /**
 * Implements a <textarea> host component that allows setting `value`, and
 * `defaultValue`. This differs from the traditional DOM API because value is
 * usually set as PCDATA children.
 *
 * If `value` is not supplied (or null/undefined), user actions that affect the
 * value will trigger updates to the element.
 *
 * If `value` is supplied (and not null/undefined), the rendered element will
 * not trigger updates to the element. Instead, the `value` prop must change in
 * order for the rendered element to be updated.
 *
 * The rendered element will be initialized with an empty value, the prop
 * `defaultValue` if specified, or the children content (deprecated).
 */ function getHostProps$2(element, props) {
        var node = element;
        if (props.dangerouslySetInnerHTML != null) throw new Error("`dangerouslySetInnerHTML` does not make sense on <textarea>.");
         // Always set children to the same thing. In IE9, the selection range will
        // get reset if `textContent` is mutated.  We could add a check in setTextContent
        // to only set the value if/when the value differs from the node value (which would
        // completely solve this IE9 bug), but Sebastian+Sophie seemed to like this
        // solution. The value can be a boolean or object so that's why it's forced
        // to be a string.
        var hostProps = assign({}, props, {
            value: undefined,
            defaultValue: undefined,
            children: toString(node._wrapperState.initialValue)
        });
        return hostProps;
    }
    function initWrapperState$2(element, props) {
        var node = element;
        checkControlledValueProps("textarea", props);
        if (props.value !== undefined && props.defaultValue !== undefined && !didWarnValDefaultVal) {
            error("%s contains a textarea with both value and defaultValue props. Textarea elements must be either controlled or uncontrolled (specify either the value prop, or the defaultValue prop, but not both). Decide between using a controlled or uncontrolled textarea and remove one of these props. More info: https://reactjs.org/link/controlled-components", getCurrentFiberOwnerNameInDevOrNull() || "A component");
            didWarnValDefaultVal = true;
        }
        var initialValue = props.value; // Only bother fetching default value if we're going to use it
        if (initialValue == null) {
            var children = props.children, defaultValue = props.defaultValue;
            if (children != null) {
                error("Use the `defaultValue` or `value` props instead of setting children on <textarea>.");
                if (defaultValue != null) throw new Error("If you supply `defaultValue` on a <textarea>, do not pass children.");
                if (isArray(children)) {
                    if (children.length > 1) throw new Error("<textarea> can only have at most one child.");
                    children = children[0];
                }
                defaultValue = children;
            }
            if (defaultValue == null) defaultValue = "";
            initialValue = defaultValue;
        }
        node._wrapperState = {
            initialValue: getToStringValue(initialValue)
        };
    }
    function updateWrapper$1(element, props) {
        var node = element;
        var value = getToStringValue(props.value);
        var defaultValue = getToStringValue(props.defaultValue);
        if (value != null) {
            // Cast `value` to a string to ensure the value is set correctly. While
            // browsers typically do this as necessary, jsdom doesn't.
            var newValue = toString(value); // To avoid side effects (such as losing text selection), only set value if changed
            if (newValue !== node.value) node.value = newValue;
            if (props.defaultValue == null && node.defaultValue !== newValue) node.defaultValue = newValue;
        }
        if (defaultValue != null) node.defaultValue = toString(defaultValue);
    }
    function postMountWrapper$3(element, props) {
        var node = element; // This is in postMount because we need access to the DOM node, which is not
        // available until after the component has mounted.
        var textContent = node.textContent; // Only set node.value if textContent is equal to the expected
        // initial value. In IE10/IE11 there is a bug where the placeholder attribute
        // will populate textContent as well.
        // https://developer.microsoft.com/microsoft-edge/platform/issues/101525/
        if (textContent === node._wrapperState.initialValue) {
            if (textContent !== "" && textContent !== null) node.value = textContent;
        }
    }
    function restoreControlledState$2(element, props) {
        // DOM component is still mounted; update
        updateWrapper$1(element, props);
    }
    var HTML_NAMESPACE = "http://www.w3.org/1999/xhtml";
    var MATH_NAMESPACE = "http://www.w3.org/1998/Math/MathML";
    var SVG_NAMESPACE = "http://www.w3.org/2000/svg"; // Assumes there is no parent namespace.
    function getIntrinsicNamespace(type) {
        switch(type){
            case "svg":
                return SVG_NAMESPACE;
            case "math":
                return MATH_NAMESPACE;
            default:
                return HTML_NAMESPACE;
        }
    }
    function getChildNamespace(parentNamespace, type) {
        if (parentNamespace == null || parentNamespace === HTML_NAMESPACE) // No (or default) parent namespace: potential entry point.
        return getIntrinsicNamespace(type);
        if (parentNamespace === SVG_NAMESPACE && type === "foreignObject") // We're leaving SVG.
        return HTML_NAMESPACE;
         // By default, pass namespace below.
        return parentNamespace;
    }
    /* globals MSApp */ /**
 * Create a function which has 'unsafe' privileges (required by windows8 apps)
 */ var createMicrosoftUnsafeLocalFunction = function(func) {
        if (typeof MSApp !== "undefined" && MSApp.execUnsafeLocalFunction) return function(arg0, arg1, arg2, arg3) {
            MSApp.execUnsafeLocalFunction(function() {
                return func(arg0, arg1, arg2, arg3);
            });
        };
        else return func;
    };
    var reusableSVGContainer;
    /**
 * Set the innerHTML property of a node
 *
 * @param {DOMElement} node
 * @param {string} html
 * @internal
 */ var setInnerHTML = createMicrosoftUnsafeLocalFunction(function(node, html) {
        if (node.namespaceURI === SVG_NAMESPACE) {
            if (!("innerHTML" in node)) {
                // IE does not have innerHTML for SVG nodes, so instead we inject the
                // new markup in a temp node and then move the child nodes across into
                // the target node
                reusableSVGContainer = reusableSVGContainer || document.createElement("div");
                reusableSVGContainer.innerHTML = "<svg>" + html.valueOf().toString() + "</svg>";
                var svgNode = reusableSVGContainer.firstChild;
                while(node.firstChild)node.removeChild(node.firstChild);
                while(svgNode.firstChild)node.appendChild(svgNode.firstChild);
                return;
            }
        }
        node.innerHTML = html;
    });
    /**
 * HTML nodeType values that represent the type of the node
 */ var ELEMENT_NODE = 1;
    var TEXT_NODE = 3;
    var COMMENT_NODE = 8;
    var DOCUMENT_NODE = 9;
    var DOCUMENT_FRAGMENT_NODE = 11;
    /**
 * Set the textContent property of a node. For text updates, it's faster
 * to set the `nodeValue` of the Text node directly instead of using
 * `.textContent` which will remove the existing node and create a new one.
 *
 * @param {DOMElement} node
 * @param {string} text
 * @internal
 */ var setTextContent = function(node, text) {
        if (text) {
            var firstChild = node.firstChild;
            if (firstChild && firstChild === node.lastChild && firstChild.nodeType === TEXT_NODE) {
                firstChild.nodeValue = text;
                return;
            }
        }
        node.textContent = text;
    };
    // List derived from Gecko source code:
    // https://github.com/mozilla/gecko-dev/blob/4e638efc71/layout/style/test/property_database.js
    var shorthandToLonghand = {
        animation: [
            "animationDelay",
            "animationDirection",
            "animationDuration",
            "animationFillMode",
            "animationIterationCount",
            "animationName",
            "animationPlayState",
            "animationTimingFunction"
        ],
        background: [
            "backgroundAttachment",
            "backgroundClip",
            "backgroundColor",
            "backgroundImage",
            "backgroundOrigin",
            "backgroundPositionX",
            "backgroundPositionY",
            "backgroundRepeat",
            "backgroundSize"
        ],
        backgroundPosition: [
            "backgroundPositionX",
            "backgroundPositionY"
        ],
        border: [
            "borderBottomColor",
            "borderBottomStyle",
            "borderBottomWidth",
            "borderImageOutset",
            "borderImageRepeat",
            "borderImageSlice",
            "borderImageSource",
            "borderImageWidth",
            "borderLeftColor",
            "borderLeftStyle",
            "borderLeftWidth",
            "borderRightColor",
            "borderRightStyle",
            "borderRightWidth",
            "borderTopColor",
            "borderTopStyle",
            "borderTopWidth"
        ],
        borderBlockEnd: [
            "borderBlockEndColor",
            "borderBlockEndStyle",
            "borderBlockEndWidth"
        ],
        borderBlockStart: [
            "borderBlockStartColor",
            "borderBlockStartStyle",
            "borderBlockStartWidth"
        ],
        borderBottom: [
            "borderBottomColor",
            "borderBottomStyle",
            "borderBottomWidth"
        ],
        borderColor: [
            "borderBottomColor",
            "borderLeftColor",
            "borderRightColor",
            "borderTopColor"
        ],
        borderImage: [
            "borderImageOutset",
            "borderImageRepeat",
            "borderImageSlice",
            "borderImageSource",
            "borderImageWidth"
        ],
        borderInlineEnd: [
            "borderInlineEndColor",
            "borderInlineEndStyle",
            "borderInlineEndWidth"
        ],
        borderInlineStart: [
            "borderInlineStartColor",
            "borderInlineStartStyle",
            "borderInlineStartWidth"
        ],
        borderLeft: [
            "borderLeftColor",
            "borderLeftStyle",
            "borderLeftWidth"
        ],
        borderRadius: [
            "borderBottomLeftRadius",
            "borderBottomRightRadius",
            "borderTopLeftRadius",
            "borderTopRightRadius"
        ],
        borderRight: [
            "borderRightColor",
            "borderRightStyle",
            "borderRightWidth"
        ],
        borderStyle: [
            "borderBottomStyle",
            "borderLeftStyle",
            "borderRightStyle",
            "borderTopStyle"
        ],
        borderTop: [
            "borderTopColor",
            "borderTopStyle",
            "borderTopWidth"
        ],
        borderWidth: [
            "borderBottomWidth",
            "borderLeftWidth",
            "borderRightWidth",
            "borderTopWidth"
        ],
        columnRule: [
            "columnRuleColor",
            "columnRuleStyle",
            "columnRuleWidth"
        ],
        columns: [
            "columnCount",
            "columnWidth"
        ],
        flex: [
            "flexBasis",
            "flexGrow",
            "flexShrink"
        ],
        flexFlow: [
            "flexDirection",
            "flexWrap"
        ],
        font: [
            "fontFamily",
            "fontFeatureSettings",
            "fontKerning",
            "fontLanguageOverride",
            "fontSize",
            "fontSizeAdjust",
            "fontStretch",
            "fontStyle",
            "fontVariant",
            "fontVariantAlternates",
            "fontVariantCaps",
            "fontVariantEastAsian",
            "fontVariantLigatures",
            "fontVariantNumeric",
            "fontVariantPosition",
            "fontWeight",
            "lineHeight"
        ],
        fontVariant: [
            "fontVariantAlternates",
            "fontVariantCaps",
            "fontVariantEastAsian",
            "fontVariantLigatures",
            "fontVariantNumeric",
            "fontVariantPosition"
        ],
        gap: [
            "columnGap",
            "rowGap"
        ],
        grid: [
            "gridAutoColumns",
            "gridAutoFlow",
            "gridAutoRows",
            "gridTemplateAreas",
            "gridTemplateColumns",
            "gridTemplateRows"
        ],
        gridArea: [
            "gridColumnEnd",
            "gridColumnStart",
            "gridRowEnd",
            "gridRowStart"
        ],
        gridColumn: [
            "gridColumnEnd",
            "gridColumnStart"
        ],
        gridColumnGap: [
            "columnGap"
        ],
        gridGap: [
            "columnGap",
            "rowGap"
        ],
        gridRow: [
            "gridRowEnd",
            "gridRowStart"
        ],
        gridRowGap: [
            "rowGap"
        ],
        gridTemplate: [
            "gridTemplateAreas",
            "gridTemplateColumns",
            "gridTemplateRows"
        ],
        listStyle: [
            "listStyleImage",
            "listStylePosition",
            "listStyleType"
        ],
        margin: [
            "marginBottom",
            "marginLeft",
            "marginRight",
            "marginTop"
        ],
        marker: [
            "markerEnd",
            "markerMid",
            "markerStart"
        ],
        mask: [
            "maskClip",
            "maskComposite",
            "maskImage",
            "maskMode",
            "maskOrigin",
            "maskPositionX",
            "maskPositionY",
            "maskRepeat",
            "maskSize"
        ],
        maskPosition: [
            "maskPositionX",
            "maskPositionY"
        ],
        outline: [
            "outlineColor",
            "outlineStyle",
            "outlineWidth"
        ],
        overflow: [
            "overflowX",
            "overflowY"
        ],
        padding: [
            "paddingBottom",
            "paddingLeft",
            "paddingRight",
            "paddingTop"
        ],
        placeContent: [
            "alignContent",
            "justifyContent"
        ],
        placeItems: [
            "alignItems",
            "justifyItems"
        ],
        placeSelf: [
            "alignSelf",
            "justifySelf"
        ],
        textDecoration: [
            "textDecorationColor",
            "textDecorationLine",
            "textDecorationStyle"
        ],
        textEmphasis: [
            "textEmphasisColor",
            "textEmphasisStyle"
        ],
        transition: [
            "transitionDelay",
            "transitionDuration",
            "transitionProperty",
            "transitionTimingFunction"
        ],
        wordWrap: [
            "overflowWrap"
        ]
    };
    /**
 * CSS properties which accept numbers but are not in units of "px".
 */ var isUnitlessNumber = {
        animationIterationCount: true,
        aspectRatio: true,
        borderImageOutset: true,
        borderImageSlice: true,
        borderImageWidth: true,
        boxFlex: true,
        boxFlexGroup: true,
        boxOrdinalGroup: true,
        columnCount: true,
        columns: true,
        flex: true,
        flexGrow: true,
        flexPositive: true,
        flexShrink: true,
        flexNegative: true,
        flexOrder: true,
        gridArea: true,
        gridRow: true,
        gridRowEnd: true,
        gridRowSpan: true,
        gridRowStart: true,
        gridColumn: true,
        gridColumnEnd: true,
        gridColumnSpan: true,
        gridColumnStart: true,
        fontWeight: true,
        lineClamp: true,
        lineHeight: true,
        opacity: true,
        order: true,
        orphans: true,
        tabSize: true,
        widows: true,
        zIndex: true,
        zoom: true,
        // SVG-related properties
        fillOpacity: true,
        floodOpacity: true,
        stopOpacity: true,
        strokeDasharray: true,
        strokeDashoffset: true,
        strokeMiterlimit: true,
        strokeOpacity: true,
        strokeWidth: true
    };
    /**
 * @param {string} prefix vendor-specific prefix, eg: Webkit
 * @param {string} key style name, eg: transitionDuration
 * @return {string} style name prefixed with `prefix`, properly camelCased, eg:
 * WebkitTransitionDuration
 */ function prefixKey(prefix, key) {
        return prefix + key.charAt(0).toUpperCase() + key.substring(1);
    }
    /**
 * Support style names that may come passed in prefixed by adding permutations
 * of vendor prefixes.
 */ var prefixes = [
        "Webkit",
        "ms",
        "Moz",
        "O"
    ]; // Using Object.keys here, or else the vanilla for-in loop makes IE8 go into an
    // infinite loop, because it iterates over the newly added props too.
    Object.keys(isUnitlessNumber).forEach(function(prop) {
        prefixes.forEach(function(prefix) {
            isUnitlessNumber[prefixKey(prefix, prop)] = isUnitlessNumber[prop];
        });
    });
    /**
 * Convert a value into the proper css writable value. The style name `name`
 * should be logical (no hyphens), as specified
 * in `CSSProperty.isUnitlessNumber`.
 *
 * @param {string} name CSS property name such as `topMargin`.
 * @param {*} value CSS property value such as `10px`.
 * @return {string} Normalized style value with dimensions applied.
 */ function dangerousStyleValue(name, value, isCustomProperty) {
        // Note that we've removed escapeTextForBrowser() calls here since the
        // whole string will be escaped when the attribute is injected into
        // the markup. If you provide unsafe user data here they can inject
        // arbitrary CSS which may be problematic (I couldn't repro this):
        // https://www.owasp.org/index.php/XSS_Filter_Evasion_Cheat_Sheet
        // http://www.thespanner.co.uk/2007/11/26/ultimate-xss-css-injection/
        // This is not an XSS hole but instead a potential CSS injection issue
        // which has lead to a greater discussion about how we're going to
        // trust URLs moving forward. See #2115901
        var isEmpty = value == null || typeof value === "boolean" || value === "";
        if (isEmpty) return "";
        if (!isCustomProperty && typeof value === "number" && value !== 0 && !(isUnitlessNumber.hasOwnProperty(name) && isUnitlessNumber[name])) return value + "px"; // Presumes implicit 'px' suffix for unitless numbers
        checkCSSPropertyStringCoercion(value, name);
        return ("" + value).trim();
    }
    var uppercasePattern = /([A-Z])/g;
    var msPattern = /^ms-/;
    /**
 * Hyphenates a camelcased CSS property name, for example:
 *
 *   > hyphenateStyleName('backgroundColor')
 *   < "background-color"
 *   > hyphenateStyleName('MozTransition')
 *   < "-moz-transition"
 *   > hyphenateStyleName('msTransition')
 *   < "-ms-transition"
 *
 * As Modernizr suggests (http://modernizr.com/docs/#prefixed), an `ms` prefix
 * is converted to `-ms-`.
 */ function hyphenateStyleName(name) {
        return name.replace(uppercasePattern, "-$1").toLowerCase().replace(msPattern, "-ms-");
    }
    var warnValidStyle = function() {};
    // 'msTransform' is correct, but the other prefixes should be capitalized
    var badVendoredStyleNamePattern = /^(?:webkit|moz|o)[A-Z]/;
    var msPattern$1 = /^-ms-/;
    var hyphenPattern = /-(.)/g; // style values shouldn't contain a semicolon
    var badStyleValueWithSemicolonPattern = /;\s*$/;
    var warnedStyleNames = {};
    var warnedStyleValues = {};
    var warnedForNaNValue = false;
    var warnedForInfinityValue = false;
    var camelize = function(string) {
        return string.replace(hyphenPattern, function(_, character) {
            return character.toUpperCase();
        });
    };
    var warnHyphenatedStyleName = function(name) {
        if (warnedStyleNames.hasOwnProperty(name) && warnedStyleNames[name]) return;
        warnedStyleNames[name] = true;
        error("Unsupported style property %s. Did you mean %s?", name, // (http://www.andismith.com/blog/2012/02/modernizr-prefixed/), an `-ms` prefix
        // is converted to lowercase `ms`.
        camelize(name.replace(msPattern$1, "ms-")));
    };
    var warnBadVendoredStyleName = function(name) {
        if (warnedStyleNames.hasOwnProperty(name) && warnedStyleNames[name]) return;
        warnedStyleNames[name] = true;
        error("Unsupported vendor-prefixed style property %s. Did you mean %s?", name, name.charAt(0).toUpperCase() + name.slice(1));
    };
    var warnStyleValueWithSemicolon = function(name, value) {
        if (warnedStyleValues.hasOwnProperty(value) && warnedStyleValues[value]) return;
        warnedStyleValues[value] = true;
        error('Style property values shouldn\'t contain a semicolon. Try "%s: %s" instead.', name, value.replace(badStyleValueWithSemicolonPattern, ""));
    };
    var warnStyleValueIsNaN = function(name, value) {
        if (warnedForNaNValue) return;
        warnedForNaNValue = true;
        error("`NaN` is an invalid value for the `%s` css style property.", name);
    };
    var warnStyleValueIsInfinity = function(name, value) {
        if (warnedForInfinityValue) return;
        warnedForInfinityValue = true;
        error("`Infinity` is an invalid value for the `%s` css style property.", name);
    };
    warnValidStyle = function(name, value) {
        if (name.indexOf("-") > -1) warnHyphenatedStyleName(name);
        else if (badVendoredStyleNamePattern.test(name)) warnBadVendoredStyleName(name);
        else if (badStyleValueWithSemicolonPattern.test(value)) warnStyleValueWithSemicolon(name, value);
        if (typeof value === "number") {
            if (isNaN(value)) warnStyleValueIsNaN(name, value);
            else if (!isFinite(value)) warnStyleValueIsInfinity(name, value);
        }
    };
    var warnValidStyle$1 = warnValidStyle;
    /**
 * Operations for dealing with CSS properties.
 */ /**
 * This creates a string that is expected to be equivalent to the style
 * attribute generated by server-side rendering. It by-passes warnings and
 * security checks so it's not safe to use this value for anything other than
 * comparison. It is only used in DEV for SSR validation.
 */ function createDangerousStringForStyles(styles) {
        var serialized = "";
        var delimiter = "";
        for(var styleName in styles){
            if (!styles.hasOwnProperty(styleName)) continue;
            var styleValue = styles[styleName];
            if (styleValue != null) {
                var isCustomProperty = styleName.indexOf("--") === 0;
                serialized += delimiter + (isCustomProperty ? styleName : hyphenateStyleName(styleName)) + ":";
                serialized += dangerousStyleValue(styleName, styleValue, isCustomProperty);
                delimiter = ";";
            }
        }
        return serialized || null;
    }
    /**
 * Sets the value for multiple styles on a node.  If a value is specified as
 * '' (empty string), the corresponding style property will be unset.
 *
 * @param {DOMElement} node
 * @param {object} styles
 */ function setValueForStyles(node, styles) {
        var style = node.style;
        for(var styleName in styles){
            if (!styles.hasOwnProperty(styleName)) continue;
            var isCustomProperty = styleName.indexOf("--") === 0;
            if (!isCustomProperty) warnValidStyle$1(styleName, styles[styleName]);
            var styleValue = dangerousStyleValue(styleName, styles[styleName], isCustomProperty);
            if (styleName === "float") styleName = "cssFloat";
            if (isCustomProperty) style.setProperty(styleName, styleValue);
            else style[styleName] = styleValue;
        }
    }
    function isValueEmpty(value) {
        return value == null || typeof value === "boolean" || value === "";
    }
    /**
 * Given {color: 'red', overflow: 'hidden'} returns {
 *   color: 'color',
 *   overflowX: 'overflow',
 *   overflowY: 'overflow',
 * }. This can be read as "the overflowY property was set by the overflow
 * shorthand". That is, the values are the property that each was derived from.
 */ function expandShorthandMap(styles) {
        var expanded = {};
        for(var key in styles){
            var longhands = shorthandToLonghand[key] || [
                key
            ];
            for(var i = 0; i < longhands.length; i++)expanded[longhands[i]] = key;
        }
        return expanded;
    }
    /**
 * When mixing shorthand and longhand property names, we warn during updates if
 * we expect an incorrect result to occur. In particular, we warn for:
 *
 * Updating a shorthand property (longhand gets overwritten):
 *   {font: 'foo', fontVariant: 'bar'} -> {font: 'baz', fontVariant: 'bar'}
 *   becomes .style.font = 'baz'
 * Removing a shorthand property (longhand gets lost too):
 *   {font: 'foo', fontVariant: 'bar'} -> {fontVariant: 'bar'}
 *   becomes .style.font = ''
 * Removing a longhand property (should revert to shorthand; doesn't):
 *   {font: 'foo', fontVariant: 'bar'} -> {font: 'foo'}
 *   becomes .style.fontVariant = ''
 */ function validateShorthandPropertyCollisionInDev(styleUpdates, nextStyles) {
        if (!nextStyles) return;
        var expandedUpdates = expandShorthandMap(styleUpdates);
        var expandedStyles = expandShorthandMap(nextStyles);
        var warnedAbout = {};
        for(var key in expandedUpdates){
            var originalKey = expandedUpdates[key];
            var correctOriginalKey = expandedStyles[key];
            if (correctOriginalKey && originalKey !== correctOriginalKey) {
                var warningKey = originalKey + "," + correctOriginalKey;
                if (warnedAbout[warningKey]) continue;
                warnedAbout[warningKey] = true;
                error("%s a style property during rerender (%s) when a conflicting property is set (%s) can lead to styling bugs. To avoid this, don't mix shorthand and non-shorthand properties for the same value; instead, replace the shorthand with separate values.", isValueEmpty(styleUpdates[originalKey]) ? "Removing" : "Updating", originalKey, correctOriginalKey);
            }
        }
    }
    // For HTML, certain tags should omit their close tag. We keep a list for
    // those special-case tags.
    var omittedCloseTags = {
        area: true,
        base: true,
        br: true,
        col: true,
        embed: true,
        hr: true,
        img: true,
        input: true,
        keygen: true,
        link: true,
        meta: true,
        param: true,
        source: true,
        track: true,
        wbr: true // NOTE: menuitem's close tag should be omitted, but that causes problems.
    };
    // `omittedCloseTags` except that `menuitem` should still have its closing tag.
    var voidElementTags = assign({
        menuitem: true
    }, omittedCloseTags);
    var HTML = "__html";
    function assertValidProps(tag, props) {
        if (!props) return;
         // Note the use of `==` which checks for null or undefined.
        if (voidElementTags[tag]) {
            if (props.children != null || props.dangerouslySetInnerHTML != null) throw new Error(tag + " is a void element tag and must neither have `children` nor " + "use `dangerouslySetInnerHTML`.");
        }
        if (props.dangerouslySetInnerHTML != null) {
            if (props.children != null) throw new Error("Can only set one of `children` or `props.dangerouslySetInnerHTML`.");
            if (typeof props.dangerouslySetInnerHTML !== "object" || !(HTML in props.dangerouslySetInnerHTML)) throw new Error("`props.dangerouslySetInnerHTML` must be in the form `{__html: ...}`. Please visit https://reactjs.org/link/dangerously-set-inner-html for more information.");
        }
        if (!props.suppressContentEditableWarning && props.contentEditable && props.children != null) error("A component is `contentEditable` and contains `children` managed by React. It is now your responsibility to guarantee that none of those nodes are unexpectedly modified or duplicated. This is probably not intentional.");
        if (props.style != null && typeof props.style !== "object") throw new Error("The `style` prop expects a mapping from style properties to values, not a string. For example, style={{marginRight: spacing + 'em'}} when using JSX.");
    }
    function isCustomComponent(tagName, props) {
        if (tagName.indexOf("-") === -1) return typeof props.is === "string";
        switch(tagName){
            // These are reserved SVG and MathML elements.
            // We don't mind this list too much because we expect it to never grow.
            // The alternative is to track the namespace in a few places which is convoluted.
            // https://w3c.github.io/webcomponents/spec/custom/#custom-elements-core-concepts
            case "annotation-xml":
            case "color-profile":
            case "font-face":
            case "font-face-src":
            case "font-face-uri":
            case "font-face-format":
            case "font-face-name":
            case "missing-glyph":
                return false;
            default:
                return true;
        }
    }
    // When adding attributes to the HTML or SVG allowed attribute list, be sure to
    // also add them to this module to ensure casing and incorrect name
    // warnings.
    var possibleStandardNames = {
        // HTML
        accept: "accept",
        acceptcharset: "acceptCharset",
        "accept-charset": "acceptCharset",
        accesskey: "accessKey",
        action: "action",
        allowfullscreen: "allowFullScreen",
        alt: "alt",
        as: "as",
        async: "async",
        autocapitalize: "autoCapitalize",
        autocomplete: "autoComplete",
        autocorrect: "autoCorrect",
        autofocus: "autoFocus",
        autoplay: "autoPlay",
        autosave: "autoSave",
        capture: "capture",
        cellpadding: "cellPadding",
        cellspacing: "cellSpacing",
        challenge: "challenge",
        charset: "charSet",
        checked: "checked",
        children: "children",
        cite: "cite",
        class: "className",
        classid: "classID",
        classname: "className",
        cols: "cols",
        colspan: "colSpan",
        content: "content",
        contenteditable: "contentEditable",
        contextmenu: "contextMenu",
        controls: "controls",
        controlslist: "controlsList",
        coords: "coords",
        crossorigin: "crossOrigin",
        dangerouslysetinnerhtml: "dangerouslySetInnerHTML",
        data: "data",
        datetime: "dateTime",
        default: "default",
        defaultchecked: "defaultChecked",
        defaultvalue: "defaultValue",
        defer: "defer",
        dir: "dir",
        disabled: "disabled",
        disablepictureinpicture: "disablePictureInPicture",
        disableremoteplayback: "disableRemotePlayback",
        download: "download",
        draggable: "draggable",
        enctype: "encType",
        enterkeyhint: "enterKeyHint",
        for: "htmlFor",
        form: "form",
        formmethod: "formMethod",
        formaction: "formAction",
        formenctype: "formEncType",
        formnovalidate: "formNoValidate",
        formtarget: "formTarget",
        frameborder: "frameBorder",
        headers: "headers",
        height: "height",
        hidden: "hidden",
        high: "high",
        href: "href",
        hreflang: "hrefLang",
        htmlfor: "htmlFor",
        httpequiv: "httpEquiv",
        "http-equiv": "httpEquiv",
        icon: "icon",
        id: "id",
        imagesizes: "imageSizes",
        imagesrcset: "imageSrcSet",
        innerhtml: "innerHTML",
        inputmode: "inputMode",
        integrity: "integrity",
        is: "is",
        itemid: "itemID",
        itemprop: "itemProp",
        itemref: "itemRef",
        itemscope: "itemScope",
        itemtype: "itemType",
        keyparams: "keyParams",
        keytype: "keyType",
        kind: "kind",
        label: "label",
        lang: "lang",
        list: "list",
        loop: "loop",
        low: "low",
        manifest: "manifest",
        marginwidth: "marginWidth",
        marginheight: "marginHeight",
        max: "max",
        maxlength: "maxLength",
        media: "media",
        mediagroup: "mediaGroup",
        method: "method",
        min: "min",
        minlength: "minLength",
        multiple: "multiple",
        muted: "muted",
        name: "name",
        nomodule: "noModule",
        nonce: "nonce",
        novalidate: "noValidate",
        open: "open",
        optimum: "optimum",
        pattern: "pattern",
        placeholder: "placeholder",
        playsinline: "playsInline",
        poster: "poster",
        preload: "preload",
        profile: "profile",
        radiogroup: "radioGroup",
        readonly: "readOnly",
        referrerpolicy: "referrerPolicy",
        rel: "rel",
        required: "required",
        reversed: "reversed",
        role: "role",
        rows: "rows",
        rowspan: "rowSpan",
        sandbox: "sandbox",
        scope: "scope",
        scoped: "scoped",
        scrolling: "scrolling",
        seamless: "seamless",
        selected: "selected",
        shape: "shape",
        size: "size",
        sizes: "sizes",
        span: "span",
        spellcheck: "spellCheck",
        src: "src",
        srcdoc: "srcDoc",
        srclang: "srcLang",
        srcset: "srcSet",
        start: "start",
        step: "step",
        style: "style",
        summary: "summary",
        tabindex: "tabIndex",
        target: "target",
        title: "title",
        type: "type",
        usemap: "useMap",
        value: "value",
        width: "width",
        wmode: "wmode",
        wrap: "wrap",
        // SVG
        about: "about",
        accentheight: "accentHeight",
        "accent-height": "accentHeight",
        accumulate: "accumulate",
        additive: "additive",
        alignmentbaseline: "alignmentBaseline",
        "alignment-baseline": "alignmentBaseline",
        allowreorder: "allowReorder",
        alphabetic: "alphabetic",
        amplitude: "amplitude",
        arabicform: "arabicForm",
        "arabic-form": "arabicForm",
        ascent: "ascent",
        attributename: "attributeName",
        attributetype: "attributeType",
        autoreverse: "autoReverse",
        azimuth: "azimuth",
        basefrequency: "baseFrequency",
        baselineshift: "baselineShift",
        "baseline-shift": "baselineShift",
        baseprofile: "baseProfile",
        bbox: "bbox",
        begin: "begin",
        bias: "bias",
        by: "by",
        calcmode: "calcMode",
        capheight: "capHeight",
        "cap-height": "capHeight",
        clip: "clip",
        clippath: "clipPath",
        "clip-path": "clipPath",
        clippathunits: "clipPathUnits",
        cliprule: "clipRule",
        "clip-rule": "clipRule",
        color: "color",
        colorinterpolation: "colorInterpolation",
        "color-interpolation": "colorInterpolation",
        colorinterpolationfilters: "colorInterpolationFilters",
        "color-interpolation-filters": "colorInterpolationFilters",
        colorprofile: "colorProfile",
        "color-profile": "colorProfile",
        colorrendering: "colorRendering",
        "color-rendering": "colorRendering",
        contentscripttype: "contentScriptType",
        contentstyletype: "contentStyleType",
        cursor: "cursor",
        cx: "cx",
        cy: "cy",
        d: "d",
        datatype: "datatype",
        decelerate: "decelerate",
        descent: "descent",
        diffuseconstant: "diffuseConstant",
        direction: "direction",
        display: "display",
        divisor: "divisor",
        dominantbaseline: "dominantBaseline",
        "dominant-baseline": "dominantBaseline",
        dur: "dur",
        dx: "dx",
        dy: "dy",
        edgemode: "edgeMode",
        elevation: "elevation",
        enablebackground: "enableBackground",
        "enable-background": "enableBackground",
        end: "end",
        exponent: "exponent",
        externalresourcesrequired: "externalResourcesRequired",
        fill: "fill",
        fillopacity: "fillOpacity",
        "fill-opacity": "fillOpacity",
        fillrule: "fillRule",
        "fill-rule": "fillRule",
        filter: "filter",
        filterres: "filterRes",
        filterunits: "filterUnits",
        floodopacity: "floodOpacity",
        "flood-opacity": "floodOpacity",
        floodcolor: "floodColor",
        "flood-color": "floodColor",
        focusable: "focusable",
        fontfamily: "fontFamily",
        "font-family": "fontFamily",
        fontsize: "fontSize",
        "font-size": "fontSize",
        fontsizeadjust: "fontSizeAdjust",
        "font-size-adjust": "fontSizeAdjust",
        fontstretch: "fontStretch",
        "font-stretch": "fontStretch",
        fontstyle: "fontStyle",
        "font-style": "fontStyle",
        fontvariant: "fontVariant",
        "font-variant": "fontVariant",
        fontweight: "fontWeight",
        "font-weight": "fontWeight",
        format: "format",
        from: "from",
        fx: "fx",
        fy: "fy",
        g1: "g1",
        g2: "g2",
        glyphname: "glyphName",
        "glyph-name": "glyphName",
        glyphorientationhorizontal: "glyphOrientationHorizontal",
        "glyph-orientation-horizontal": "glyphOrientationHorizontal",
        glyphorientationvertical: "glyphOrientationVertical",
        "glyph-orientation-vertical": "glyphOrientationVertical",
        glyphref: "glyphRef",
        gradienttransform: "gradientTransform",
        gradientunits: "gradientUnits",
        hanging: "hanging",
        horizadvx: "horizAdvX",
        "horiz-adv-x": "horizAdvX",
        horizoriginx: "horizOriginX",
        "horiz-origin-x": "horizOriginX",
        ideographic: "ideographic",
        imagerendering: "imageRendering",
        "image-rendering": "imageRendering",
        in2: "in2",
        in: "in",
        inlist: "inlist",
        intercept: "intercept",
        k1: "k1",
        k2: "k2",
        k3: "k3",
        k4: "k4",
        k: "k",
        kernelmatrix: "kernelMatrix",
        kernelunitlength: "kernelUnitLength",
        kerning: "kerning",
        keypoints: "keyPoints",
        keysplines: "keySplines",
        keytimes: "keyTimes",
        lengthadjust: "lengthAdjust",
        letterspacing: "letterSpacing",
        "letter-spacing": "letterSpacing",
        lightingcolor: "lightingColor",
        "lighting-color": "lightingColor",
        limitingconeangle: "limitingConeAngle",
        local: "local",
        markerend: "markerEnd",
        "marker-end": "markerEnd",
        markerheight: "markerHeight",
        markermid: "markerMid",
        "marker-mid": "markerMid",
        markerstart: "markerStart",
        "marker-start": "markerStart",
        markerunits: "markerUnits",
        markerwidth: "markerWidth",
        mask: "mask",
        maskcontentunits: "maskContentUnits",
        maskunits: "maskUnits",
        mathematical: "mathematical",
        mode: "mode",
        numoctaves: "numOctaves",
        offset: "offset",
        opacity: "opacity",
        operator: "operator",
        order: "order",
        orient: "orient",
        orientation: "orientation",
        origin: "origin",
        overflow: "overflow",
        overlineposition: "overlinePosition",
        "overline-position": "overlinePosition",
        overlinethickness: "overlineThickness",
        "overline-thickness": "overlineThickness",
        paintorder: "paintOrder",
        "paint-order": "paintOrder",
        panose1: "panose1",
        "panose-1": "panose1",
        pathlength: "pathLength",
        patterncontentunits: "patternContentUnits",
        patterntransform: "patternTransform",
        patternunits: "patternUnits",
        pointerevents: "pointerEvents",
        "pointer-events": "pointerEvents",
        points: "points",
        pointsatx: "pointsAtX",
        pointsaty: "pointsAtY",
        pointsatz: "pointsAtZ",
        prefix: "prefix",
        preservealpha: "preserveAlpha",
        preserveaspectratio: "preserveAspectRatio",
        primitiveunits: "primitiveUnits",
        property: "property",
        r: "r",
        radius: "radius",
        refx: "refX",
        refy: "refY",
        renderingintent: "renderingIntent",
        "rendering-intent": "renderingIntent",
        repeatcount: "repeatCount",
        repeatdur: "repeatDur",
        requiredextensions: "requiredExtensions",
        requiredfeatures: "requiredFeatures",
        resource: "resource",
        restart: "restart",
        result: "result",
        results: "results",
        rotate: "rotate",
        rx: "rx",
        ry: "ry",
        scale: "scale",
        security: "security",
        seed: "seed",
        shaperendering: "shapeRendering",
        "shape-rendering": "shapeRendering",
        slope: "slope",
        spacing: "spacing",
        specularconstant: "specularConstant",
        specularexponent: "specularExponent",
        speed: "speed",
        spreadmethod: "spreadMethod",
        startoffset: "startOffset",
        stddeviation: "stdDeviation",
        stemh: "stemh",
        stemv: "stemv",
        stitchtiles: "stitchTiles",
        stopcolor: "stopColor",
        "stop-color": "stopColor",
        stopopacity: "stopOpacity",
        "stop-opacity": "stopOpacity",
        strikethroughposition: "strikethroughPosition",
        "strikethrough-position": "strikethroughPosition",
        strikethroughthickness: "strikethroughThickness",
        "strikethrough-thickness": "strikethroughThickness",
        string: "string",
        stroke: "stroke",
        strokedasharray: "strokeDasharray",
        "stroke-dasharray": "strokeDasharray",
        strokedashoffset: "strokeDashoffset",
        "stroke-dashoffset": "strokeDashoffset",
        strokelinecap: "strokeLinecap",
        "stroke-linecap": "strokeLinecap",
        strokelinejoin: "strokeLinejoin",
        "stroke-linejoin": "strokeLinejoin",
        strokemiterlimit: "strokeMiterlimit",
        "stroke-miterlimit": "strokeMiterlimit",
        strokewidth: "strokeWidth",
        "stroke-width": "strokeWidth",
        strokeopacity: "strokeOpacity",
        "stroke-opacity": "strokeOpacity",
        suppresscontenteditablewarning: "suppressContentEditableWarning",
        suppresshydrationwarning: "suppressHydrationWarning",
        surfacescale: "surfaceScale",
        systemlanguage: "systemLanguage",
        tablevalues: "tableValues",
        targetx: "targetX",
        targety: "targetY",
        textanchor: "textAnchor",
        "text-anchor": "textAnchor",
        textdecoration: "textDecoration",
        "text-decoration": "textDecoration",
        textlength: "textLength",
        textrendering: "textRendering",
        "text-rendering": "textRendering",
        to: "to",
        transform: "transform",
        typeof: "typeof",
        u1: "u1",
        u2: "u2",
        underlineposition: "underlinePosition",
        "underline-position": "underlinePosition",
        underlinethickness: "underlineThickness",
        "underline-thickness": "underlineThickness",
        unicode: "unicode",
        unicodebidi: "unicodeBidi",
        "unicode-bidi": "unicodeBidi",
        unicoderange: "unicodeRange",
        "unicode-range": "unicodeRange",
        unitsperem: "unitsPerEm",
        "units-per-em": "unitsPerEm",
        unselectable: "unselectable",
        valphabetic: "vAlphabetic",
        "v-alphabetic": "vAlphabetic",
        values: "values",
        vectoreffect: "vectorEffect",
        "vector-effect": "vectorEffect",
        version: "version",
        vertadvy: "vertAdvY",
        "vert-adv-y": "vertAdvY",
        vertoriginx: "vertOriginX",
        "vert-origin-x": "vertOriginX",
        vertoriginy: "vertOriginY",
        "vert-origin-y": "vertOriginY",
        vhanging: "vHanging",
        "v-hanging": "vHanging",
        videographic: "vIdeographic",
        "v-ideographic": "vIdeographic",
        viewbox: "viewBox",
        viewtarget: "viewTarget",
        visibility: "visibility",
        vmathematical: "vMathematical",
        "v-mathematical": "vMathematical",
        vocab: "vocab",
        widths: "widths",
        wordspacing: "wordSpacing",
        "word-spacing": "wordSpacing",
        writingmode: "writingMode",
        "writing-mode": "writingMode",
        x1: "x1",
        x2: "x2",
        x: "x",
        xchannelselector: "xChannelSelector",
        xheight: "xHeight",
        "x-height": "xHeight",
        xlinkactuate: "xlinkActuate",
        "xlink:actuate": "xlinkActuate",
        xlinkarcrole: "xlinkArcrole",
        "xlink:arcrole": "xlinkArcrole",
        xlinkhref: "xlinkHref",
        "xlink:href": "xlinkHref",
        xlinkrole: "xlinkRole",
        "xlink:role": "xlinkRole",
        xlinkshow: "xlinkShow",
        "xlink:show": "xlinkShow",
        xlinktitle: "xlinkTitle",
        "xlink:title": "xlinkTitle",
        xlinktype: "xlinkType",
        "xlink:type": "xlinkType",
        xmlbase: "xmlBase",
        "xml:base": "xmlBase",
        xmllang: "xmlLang",
        "xml:lang": "xmlLang",
        xmlns: "xmlns",
        "xml:space": "xmlSpace",
        xmlnsxlink: "xmlnsXlink",
        "xmlns:xlink": "xmlnsXlink",
        xmlspace: "xmlSpace",
        y1: "y1",
        y2: "y2",
        y: "y",
        ychannelselector: "yChannelSelector",
        z: "z",
        zoomandpan: "zoomAndPan"
    };
    var ariaProperties = {
        "aria-current": 0,
        // state
        "aria-description": 0,
        "aria-details": 0,
        "aria-disabled": 0,
        // state
        "aria-hidden": 0,
        // state
        "aria-invalid": 0,
        // state
        "aria-keyshortcuts": 0,
        "aria-label": 0,
        "aria-roledescription": 0,
        // Widget Attributes
        "aria-autocomplete": 0,
        "aria-checked": 0,
        "aria-expanded": 0,
        "aria-haspopup": 0,
        "aria-level": 0,
        "aria-modal": 0,
        "aria-multiline": 0,
        "aria-multiselectable": 0,
        "aria-orientation": 0,
        "aria-placeholder": 0,
        "aria-pressed": 0,
        "aria-readonly": 0,
        "aria-required": 0,
        "aria-selected": 0,
        "aria-sort": 0,
        "aria-valuemax": 0,
        "aria-valuemin": 0,
        "aria-valuenow": 0,
        "aria-valuetext": 0,
        // Live Region Attributes
        "aria-atomic": 0,
        "aria-busy": 0,
        "aria-live": 0,
        "aria-relevant": 0,
        // Drag-and-Drop Attributes
        "aria-dropeffect": 0,
        "aria-grabbed": 0,
        // Relationship Attributes
        "aria-activedescendant": 0,
        "aria-colcount": 0,
        "aria-colindex": 0,
        "aria-colspan": 0,
        "aria-controls": 0,
        "aria-describedby": 0,
        "aria-errormessage": 0,
        "aria-flowto": 0,
        "aria-labelledby": 0,
        "aria-owns": 0,
        "aria-posinset": 0,
        "aria-rowcount": 0,
        "aria-rowindex": 0,
        "aria-rowspan": 0,
        "aria-setsize": 0
    };
    var warnedProperties = {};
    var rARIA = new RegExp("^(aria)-[" + ATTRIBUTE_NAME_CHAR + "]*$");
    var rARIACamel = new RegExp("^(aria)[A-Z][" + ATTRIBUTE_NAME_CHAR + "]*$");
    function validateProperty(tagName, name) {
        if (hasOwnProperty.call(warnedProperties, name) && warnedProperties[name]) return true;
        if (rARIACamel.test(name)) {
            var ariaName = "aria-" + name.slice(4).toLowerCase();
            var correctName = ariaProperties.hasOwnProperty(ariaName) ? ariaName : null; // If this is an aria-* attribute, but is not listed in the known DOM
            // DOM properties, then it is an invalid aria-* attribute.
            if (correctName == null) {
                error("Invalid ARIA attribute `%s`. ARIA attributes follow the pattern aria-* and must be lowercase.", name);
                warnedProperties[name] = true;
                return true;
            } // aria-* attributes should be lowercase; suggest the lowercase version.
            if (name !== correctName) {
                error("Invalid ARIA attribute `%s`. Did you mean `%s`?", name, correctName);
                warnedProperties[name] = true;
                return true;
            }
        }
        if (rARIA.test(name)) {
            var lowerCasedName = name.toLowerCase();
            var standardName = ariaProperties.hasOwnProperty(lowerCasedName) ? lowerCasedName : null; // If this is an aria-* attribute, but is not listed in the known DOM
            // DOM properties, then it is an invalid aria-* attribute.
            if (standardName == null) {
                warnedProperties[name] = true;
                return false;
            } // aria-* attributes should be lowercase; suggest the lowercase version.
            if (name !== standardName) {
                error("Unknown ARIA attribute `%s`. Did you mean `%s`?", name, standardName);
                warnedProperties[name] = true;
                return true;
            }
        }
        return true;
    }
    function warnInvalidARIAProps(type, props) {
        var invalidProps = [];
        for(var key in props){
            var isValid = validateProperty(type, key);
            if (!isValid) invalidProps.push(key);
        }
        var unknownPropString = invalidProps.map(function(prop) {
            return "`" + prop + "`";
        }).join(", ");
        if (invalidProps.length === 1) error("Invalid aria prop %s on <%s> tag. For details, see https://reactjs.org/link/invalid-aria-props", unknownPropString, type);
        else if (invalidProps.length > 1) error("Invalid aria props %s on <%s> tag. For details, see https://reactjs.org/link/invalid-aria-props", unknownPropString, type);
    }
    function validateProperties(type, props) {
        if (isCustomComponent(type, props)) return;
        warnInvalidARIAProps(type, props);
    }
    var didWarnValueNull = false;
    function validateProperties$1(type, props) {
        if (type !== "input" && type !== "textarea" && type !== "select") return;
        if (props != null && props.value === null && !didWarnValueNull) {
            didWarnValueNull = true;
            if (type === "select" && props.multiple) error("`value` prop on `%s` should not be null. Consider using an empty array when `multiple` is set to `true` to clear the component or `undefined` for uncontrolled components.", type);
            else error("`value` prop on `%s` should not be null. Consider using an empty string to clear the component or `undefined` for uncontrolled components.", type);
        }
    }
    var validateProperty$1 = function() {};
    var warnedProperties$1 = {};
    var EVENT_NAME_REGEX = /^on./;
    var INVALID_EVENT_NAME_REGEX = /^on[^A-Z]/;
    var rARIA$1 = new RegExp("^(aria)-[" + ATTRIBUTE_NAME_CHAR + "]*$");
    var rARIACamel$1 = new RegExp("^(aria)[A-Z][" + ATTRIBUTE_NAME_CHAR + "]*$");
    validateProperty$1 = function(tagName, name, value, eventRegistry) {
        if (hasOwnProperty.call(warnedProperties$1, name) && warnedProperties$1[name]) return true;
        var lowerCasedName = name.toLowerCase();
        if (lowerCasedName === "onfocusin" || lowerCasedName === "onfocusout") {
            error("React uses onFocus and onBlur instead of onFocusIn and onFocusOut. All React events are normalized to bubble, so onFocusIn and onFocusOut are not needed/supported by React.");
            warnedProperties$1[name] = true;
            return true;
        } // We can't rely on the event system being injected on the server.
        if (eventRegistry != null) {
            var registrationNameDependencies = eventRegistry.registrationNameDependencies, possibleRegistrationNames = eventRegistry.possibleRegistrationNames;
            if (registrationNameDependencies.hasOwnProperty(name)) return true;
            var registrationName = possibleRegistrationNames.hasOwnProperty(lowerCasedName) ? possibleRegistrationNames[lowerCasedName] : null;
            if (registrationName != null) {
                error("Invalid event handler property `%s`. Did you mean `%s`?", name, registrationName);
                warnedProperties$1[name] = true;
                return true;
            }
            if (EVENT_NAME_REGEX.test(name)) {
                error("Unknown event handler property `%s`. It will be ignored.", name);
                warnedProperties$1[name] = true;
                return true;
            }
        } else if (EVENT_NAME_REGEX.test(name)) {
            // If no event plugins have been injected, we are in a server environment.
            // So we can't tell if the event name is correct for sure, but we can filter
            // out known bad ones like `onclick`. We can't suggest a specific replacement though.
            if (INVALID_EVENT_NAME_REGEX.test(name)) error("Invalid event handler property `%s`. React events use the camelCase naming convention, for example `onClick`.", name);
            warnedProperties$1[name] = true;
            return true;
        } // Let the ARIA attribute hook validate ARIA attributes
        if (rARIA$1.test(name) || rARIACamel$1.test(name)) return true;
        if (lowerCasedName === "innerhtml") {
            error("Directly setting property `innerHTML` is not permitted. For more information, lookup documentation on `dangerouslySetInnerHTML`.");
            warnedProperties$1[name] = true;
            return true;
        }
        if (lowerCasedName === "aria") {
            error("The `aria` attribute is reserved for future use in React. Pass individual `aria-` attributes instead.");
            warnedProperties$1[name] = true;
            return true;
        }
        if (lowerCasedName === "is" && value !== null && value !== undefined && typeof value !== "string") {
            error("Received a `%s` for a string attribute `is`. If this is expected, cast the value to a string.", typeof value);
            warnedProperties$1[name] = true;
            return true;
        }
        if (typeof value === "number" && isNaN(value)) {
            error("Received NaN for the `%s` attribute. If this is expected, cast the value to a string.", name);
            warnedProperties$1[name] = true;
            return true;
        }
        var propertyInfo = getPropertyInfo(name);
        var isReserved = propertyInfo !== null && propertyInfo.type === RESERVED; // Known attributes should match the casing specified in the property config.
        if (possibleStandardNames.hasOwnProperty(lowerCasedName)) {
            var standardName = possibleStandardNames[lowerCasedName];
            if (standardName !== name) {
                error("Invalid DOM property `%s`. Did you mean `%s`?", name, standardName);
                warnedProperties$1[name] = true;
                return true;
            }
        } else if (!isReserved && name !== lowerCasedName) {
            // Unknown attributes should have lowercase casing since that's how they
            // will be cased anyway with server rendering.
            error("React does not recognize the `%s` prop on a DOM element. If you intentionally want it to appear in the DOM as a custom attribute, spell it as lowercase `%s` instead. If you accidentally passed it from a parent component, remove it from the DOM element.", name, lowerCasedName);
            warnedProperties$1[name] = true;
            return true;
        }
        if (typeof value === "boolean" && shouldRemoveAttributeWithWarning(name, value, propertyInfo, false)) {
            if (value) error('Received `%s` for a non-boolean attribute `%s`.\n\nIf you want to write it to the DOM, pass a string instead: %s="%s" or %s={value.toString()}.', value, name, name, value, name);
            else error('Received `%s` for a non-boolean attribute `%s`.\n\nIf you want to write it to the DOM, pass a string instead: %s="%s" or %s={value.toString()}.\n\nIf you used to conditionally omit it with %s={condition && value}, pass %s={condition ? value : undefined} instead.', value, name, name, value, name, name, name);
            warnedProperties$1[name] = true;
            return true;
        } // Now that we've validated casing, do not validate
        // data types for reserved props
        if (isReserved) return true;
         // Warn when a known attribute is a bad type
        if (shouldRemoveAttributeWithWarning(name, value, propertyInfo, false)) {
            warnedProperties$1[name] = true;
            return false;
        } // Warn when passing the strings 'false' or 'true' into a boolean prop
        if ((value === "false" || value === "true") && propertyInfo !== null && propertyInfo.type === BOOLEAN) {
            error("Received the string `%s` for the boolean attribute `%s`. %s Did you mean %s={%s}?", value, name, value === "false" ? "The browser will interpret it as a truthy value." : 'Although this works, it will not work as expected if you pass the string "false".', name, value);
            warnedProperties$1[name] = true;
            return true;
        }
        return true;
    };
    var warnUnknownProperties = function(type, props, eventRegistry) {
        var unknownProps = [];
        for(var key in props){
            var isValid = validateProperty$1(type, key, props[key], eventRegistry);
            if (!isValid) unknownProps.push(key);
        }
        var unknownPropString = unknownProps.map(function(prop) {
            return "`" + prop + "`";
        }).join(", ");
        if (unknownProps.length === 1) error("Invalid value for prop %s on <%s> tag. Either remove it from the element, or pass a string or number value to keep it in the DOM. For details, see https://reactjs.org/link/attribute-behavior ", unknownPropString, type);
        else if (unknownProps.length > 1) error("Invalid values for props %s on <%s> tag. Either remove them from the element, or pass a string or number value to keep them in the DOM. For details, see https://reactjs.org/link/attribute-behavior ", unknownPropString, type);
    };
    function validateProperties$2(type, props, eventRegistry) {
        if (isCustomComponent(type, props)) return;
        warnUnknownProperties(type, props, eventRegistry);
    }
    var IS_EVENT_HANDLE_NON_MANAGED_NODE = 1;
    var IS_NON_DELEGATED = 2;
    var IS_CAPTURE_PHASE = 4;
    // set to LEGACY_FB_SUPPORT. LEGACY_FB_SUPPORT only gets set when
    // we call willDeferLaterForLegacyFBSupport, thus not bailing out
    // will result in endless cycles like an infinite loop.
    // We also don't want to defer during event replaying.
    var SHOULD_NOT_PROCESS_POLYFILL_EVENT_PLUGINS = IS_EVENT_HANDLE_NON_MANAGED_NODE | IS_NON_DELEGATED | IS_CAPTURE_PHASE;
    // This exists to avoid circular dependency between ReactDOMEventReplaying
    // and DOMPluginEventSystem.
    var currentReplayingEvent = null;
    function setReplayingEvent(event) {
        if (currentReplayingEvent !== null) error("Expected currently replaying event to be null. This error is likely caused by a bug in React. Please file an issue.");
        currentReplayingEvent = event;
    }
    function resetReplayingEvent() {
        if (currentReplayingEvent === null) error("Expected currently replaying event to not be null. This error is likely caused by a bug in React. Please file an issue.");
        currentReplayingEvent = null;
    }
    function isReplayingEvent(event) {
        return event === currentReplayingEvent;
    }
    /**
 * Gets the target node from a native browser event by accounting for
 * inconsistencies in browser DOM APIs.
 *
 * @param {object} nativeEvent Native browser event.
 * @return {DOMEventTarget} Target node.
 */ function getEventTarget(nativeEvent) {
        // Fallback to nativeEvent.srcElement for IE9
        // https://github.com/facebook/react/issues/12506
        var target = nativeEvent.target || nativeEvent.srcElement || window; // Normalize SVG <use> element events #4963
        if (target.correspondingUseElement) target = target.correspondingUseElement;
         // Safari may fire events on text nodes (Node.TEXT_NODE is 3).
        // @see http://www.quirksmode.org/js/events_properties.html
        return target.nodeType === TEXT_NODE ? target.parentNode : target;
    }
    var restoreImpl = null;
    var restoreTarget = null;
    var restoreQueue = null;
    function restoreStateOfTarget(target) {
        // We perform this translation at the end of the event loop so that we
        // always receive the correct fiber here
        var internalInstance = getInstanceFromNode(target);
        if (!internalInstance) // Unmounted
        return;
        if (typeof restoreImpl !== "function") throw new Error("setRestoreImplementation() needs to be called to handle a target for controlled events. This error is likely caused by a bug in React. Please file an issue.");
        var stateNode = internalInstance.stateNode; // Guard against Fiber being unmounted.
        if (stateNode) {
            var _props = getFiberCurrentPropsFromNode(stateNode);
            restoreImpl(internalInstance.stateNode, internalInstance.type, _props);
        }
    }
    function setRestoreImplementation(impl) {
        restoreImpl = impl;
    }
    function enqueueStateRestore(target) {
        if (restoreTarget) {
            if (restoreQueue) restoreQueue.push(target);
            else restoreQueue = [
                target
            ];
        } else restoreTarget = target;
    }
    function needsStateRestore() {
        return restoreTarget !== null || restoreQueue !== null;
    }
    function restoreStateIfNeeded() {
        if (!restoreTarget) return;
        var target = restoreTarget;
        var queuedTargets = restoreQueue;
        restoreTarget = null;
        restoreQueue = null;
        restoreStateOfTarget(target);
        if (queuedTargets) for(var i = 0; i < queuedTargets.length; i++)restoreStateOfTarget(queuedTargets[i]);
    }
    // the renderer. Such as when we're dispatching events or if third party
    // libraries need to call batchedUpdates. Eventually, this API will go away when
    // everything is batched by default. We'll then have a similar API to opt-out of
    // scheduled work and instead do synchronous work.
    // Defaults
    var batchedUpdatesImpl = function(fn, bookkeeping) {
        return fn(bookkeeping);
    };
    var flushSyncImpl = function() {};
    var isInsideEventHandler = false;
    function finishEventHandler() {
        // Here we wait until all updates have propagated, which is important
        // when using controlled components within layers:
        // https://github.com/facebook/react/issues/1698
        // Then we restore state of any controlled component.
        var controlledComponentsHavePendingUpdates = needsStateRestore();
        if (controlledComponentsHavePendingUpdates) {
            // If a controlled event was fired, we may need to restore the state of
            // the DOM node back to the controlled value. This is necessary when React
            // bails out of the update without touching the DOM.
            // TODO: Restore state in the microtask, after the discrete updates flush,
            // instead of early flushing them here.
            flushSyncImpl();
            restoreStateIfNeeded();
        }
    }
    function batchedUpdates(fn, a, b) {
        if (isInsideEventHandler) // If we are currently inside another batch, we need to wait until it
        // fully completes before restoring state.
        return fn(a, b);
        isInsideEventHandler = true;
        try {
            return batchedUpdatesImpl(fn, a, b);
        } finally{
            isInsideEventHandler = false;
            finishEventHandler();
        }
    } // TODO: Replace with flushSync
    function setBatchingImplementation(_batchedUpdatesImpl, _discreteUpdatesImpl, _flushSyncImpl) {
        batchedUpdatesImpl = _batchedUpdatesImpl;
        flushSyncImpl = _flushSyncImpl;
    }
    function isInteractive(tag) {
        return tag === "button" || tag === "input" || tag === "select" || tag === "textarea";
    }
    function shouldPreventMouseEvent(name, type, props) {
        switch(name){
            case "onClick":
            case "onClickCapture":
            case "onDoubleClick":
            case "onDoubleClickCapture":
            case "onMouseDown":
            case "onMouseDownCapture":
            case "onMouseMove":
            case "onMouseMoveCapture":
            case "onMouseUp":
            case "onMouseUpCapture":
            case "onMouseEnter":
                return !!(props.disabled && isInteractive(type));
            default:
                return false;
        }
    }
    /**
 * @param {object} inst The instance, which is the source of events.
 * @param {string} registrationName Name of listener (e.g. `onClick`).
 * @return {?function} The stored callback.
 */ function getListener(inst, registrationName) {
        var stateNode = inst.stateNode;
        if (stateNode === null) // Work in progress (ex: onload events in incremental mode).
        return null;
        var props = getFiberCurrentPropsFromNode(stateNode);
        if (props === null) // Work in progress.
        return null;
        var listener = props[registrationName];
        if (shouldPreventMouseEvent(registrationName, inst.type, props)) return null;
        if (listener && typeof listener !== "function") throw new Error("Expected `" + registrationName + "` listener to be a function, instead got a value of `" + typeof listener + "` type.");
        return listener;
    }
    var passiveBrowserEventsSupported = false; // Check if browser support events with passive listeners
    // https://developer.mozilla.org/en-US/docs/Web/API/EventTarget/addEventListener#Safely_detecting_option_support
    if (canUseDOM) try {
        var options = {}; // $FlowFixMe: Ignore Flow complaining about needing a value
        Object.defineProperty(options, "passive", {
            get: function() {
                passiveBrowserEventsSupported = true;
            }
        });
        window.addEventListener("test", options, options);
        window.removeEventListener("test", options, options);
    } catch (e) {
        passiveBrowserEventsSupported = false;
    }
    function invokeGuardedCallbackProd(name, func, context, a, b, c, d, e, f) {
        var funcArgs = Array.prototype.slice.call(arguments, 3);
        try {
            func.apply(context, funcArgs);
        } catch (error) {
            this.onError(error);
        }
    }
    var invokeGuardedCallbackImpl = invokeGuardedCallbackProd;
    // In DEV mode, we swap out invokeGuardedCallback for a special version
    // that plays more nicely with the browser's DevTools. The idea is to preserve
    // "Pause on exceptions" behavior. Because React wraps all user-provided
    // functions in invokeGuardedCallback, and the production version of
    // invokeGuardedCallback uses a try-catch, all user exceptions are treated
    // like caught exceptions, and the DevTools won't pause unless the developer
    // takes the extra step of enabling pause on caught exceptions. This is
    // unintuitive, though, because even though React has caught the error, from
    // the developer's perspective, the error is uncaught.
    //
    // To preserve the expected "Pause on exceptions" behavior, we don't use a
    // try-catch in DEV. Instead, we synchronously dispatch a fake event to a fake
    // DOM node, and call the user-provided callback from inside an event handler
    // for that fake event. If the callback throws, the error is "captured" using
    // a global event handler. But because the error happens in a different
    // event loop context, it does not interrupt the normal program flow.
    // Effectively, this gives us try-catch behavior without actually using
    // try-catch. Neat!
    // Check that the browser supports the APIs we need to implement our special
    // DEV version of invokeGuardedCallback
    if (typeof window !== "undefined" && typeof window.dispatchEvent === "function" && typeof document !== "undefined" && typeof document.createEvent === "function") {
        var fakeNode = document.createElement("react");
        invokeGuardedCallbackImpl = function invokeGuardedCallbackDev(name, func, context, a, b, c, d, e, f) {
            // If document doesn't exist we know for sure we will crash in this method
            // when we call document.createEvent(). However this can cause confusing
            // errors: https://github.com/facebook/create-react-app/issues/3482
            // So we preemptively throw with a better message instead.
            if (typeof document === "undefined" || document === null) throw new Error("The `document` global was defined when React was initialized, but is not defined anymore. This can happen in a test environment if a component schedules an update from an asynchronous callback, but the test has already finished running. To solve this, you can either unmount the component at the end of your test (and ensure that any asynchronous operations get canceled in `componentWillUnmount`), or you can change the test itself to be asynchronous.");
            var evt = document.createEvent("Event");
            var didCall = false; // Keeps track of whether the user-provided callback threw an error. We
            // set this to true at the beginning, then set it to false right after
            // calling the function. If the function errors, `didError` will never be
            // set to false. This strategy works even if the browser is flaky and
            // fails to call our global error handler, because it doesn't rely on
            // the error event at all.
            var didError = true; // Keeps track of the value of window.event so that we can reset it
            // during the callback to let user code access window.event in the
            // browsers that support it.
            var windowEvent = window.event; // Keeps track of the descriptor of window.event to restore it after event
            // dispatching: https://github.com/facebook/react/issues/13688
            var windowEventDescriptor = Object.getOwnPropertyDescriptor(window, "event");
            function restoreAfterDispatch() {
                // We immediately remove the callback from event listeners so that
                // nested `invokeGuardedCallback` calls do not clash. Otherwise, a
                // nested call would trigger the fake event handlers of any call higher
                // in the stack.
                fakeNode.removeEventListener(evtType, callCallback, false); // We check for window.hasOwnProperty('event') to prevent the
                // window.event assignment in both IE <= 10 as they throw an error
                // "Member not found" in strict mode, and in Firefox which does not
                // support window.event.
                if (typeof window.event !== "undefined" && window.hasOwnProperty("event")) window.event = windowEvent;
            } // Create an event handler for our fake event. We will synchronously
            // dispatch our fake event using `dispatchEvent`. Inside the handler, we
            // call the user-provided callback.
            var funcArgs = Array.prototype.slice.call(arguments, 3);
            function callCallback() {
                didCall = true;
                restoreAfterDispatch();
                func.apply(context, funcArgs);
                didError = false;
            } // Create a global error event handler. We use this to capture the value
            // that was thrown. It's possible that this error handler will fire more
            // than once; for example, if non-React code also calls `dispatchEvent`
            // and a handler for that event throws. We should be resilient to most of
            // those cases. Even if our error event handler fires more than once, the
            // last error event is always used. If the callback actually does error,
            // we know that the last error event is the correct one, because it's not
            // possible for anything else to have happened in between our callback
            // erroring and the code that follows the `dispatchEvent` call below. If
            // the callback doesn't error, but the error event was fired, we know to
            // ignore it because `didError` will be false, as described above.
            var error; // Use this to track whether the error event is ever called.
            var didSetError = false;
            var isCrossOriginError = false;
            function handleWindowError(event) {
                error = event.error;
                didSetError = true;
                if (error === null && event.colno === 0 && event.lineno === 0) isCrossOriginError = true;
                if (event.defaultPrevented) {
                    // Some other error handler has prevented default.
                    // Browsers silence the error report if this happens.
                    // We'll remember this to later decide whether to log it or not.
                    if (error != null && typeof error === "object") try {
                        error._suppressLogging = true;
                    } catch (inner) {}
                }
            } // Create a fake event type.
            var evtType = "react-" + (name ? name : "invokeguardedcallback"); // Attach our event handlers
            window.addEventListener("error", handleWindowError);
            fakeNode.addEventListener(evtType, callCallback, false); // Synchronously dispatch our fake event. If the user-provided function
            // errors, it will trigger our global error handler.
            evt.initEvent(evtType, false, false);
            fakeNode.dispatchEvent(evt);
            if (windowEventDescriptor) Object.defineProperty(window, "event", windowEventDescriptor);
            if (didCall && didError) {
                if (!didSetError) // The callback errored, but the error event never fired.
                // eslint-disable-next-line react-internal/prod-error-codes
                error = new Error("An error was thrown inside one of your components, but React doesn't know what it was. This is likely due to browser flakiness. React does its best to preserve the \"Pause on exceptions\" behavior of the DevTools, which requires some DEV-mode only tricks. It's possible that these don't work in your browser. Try triggering the error in production mode, or switching to a modern browser. If you suspect that this is actually an issue with React, please file an issue.");
                else if (isCrossOriginError) // eslint-disable-next-line react-internal/prod-error-codes
                error = new Error("A cross-origin error was thrown. React doesn't have access to the actual error object in development. See https://reactjs.org/link/crossorigin-error for more information.");
                this.onError(error);
            } // Remove our event listeners
            window.removeEventListener("error", handleWindowError);
            if (!didCall) {
                // Something went really wrong, and our event was not dispatched.
                // https://github.com/facebook/react/issues/16734
                // https://github.com/facebook/react/issues/16585
                // Fall back to the production implementation.
                restoreAfterDispatch();
                return invokeGuardedCallbackProd.apply(this, arguments);
            }
        };
    }
    var invokeGuardedCallbackImpl$1 = invokeGuardedCallbackImpl;
    var hasError = false;
    var caughtError = null; // Used by event system to capture/rethrow the first error.
    var hasRethrowError = false;
    var rethrowError = null;
    var reporter = {
        onError: function(error) {
            hasError = true;
            caughtError = error;
        }
    };
    /**
 * Call a function while guarding against errors that happens within it.
 * Returns an error if it throws, otherwise null.
 *
 * In production, this is implemented using a try-catch. The reason we don't
 * use a try-catch directly is so that we can swap out a different
 * implementation in DEV mode.
 *
 * @param {String} name of the guard to use for logging or debugging
 * @param {Function} func The function to invoke
 * @param {*} context The context to use when calling the function
 * @param {...*} args Arguments for function
 */ function invokeGuardedCallback(name, func, context, a, b, c, d, e, f) {
        hasError = false;
        caughtError = null;
        invokeGuardedCallbackImpl$1.apply(reporter, arguments);
    }
    /**
 * Same as invokeGuardedCallback, but instead of returning an error, it stores
 * it in a global so it can be rethrown by `rethrowCaughtError` later.
 * TODO: See if caughtError and rethrowError can be unified.
 *
 * @param {String} name of the guard to use for logging or debugging
 * @param {Function} func The function to invoke
 * @param {*} context The context to use when calling the function
 * @param {...*} args Arguments for function
 */ function invokeGuardedCallbackAndCatchFirstError(name, func, context, a, b, c, d, e, f) {
        invokeGuardedCallback.apply(this, arguments);
        if (hasError) {
            var error = clearCaughtError();
            if (!hasRethrowError) {
                hasRethrowError = true;
                rethrowError = error;
            }
        }
    }
    /**
 * During execution of guarded functions we will capture the first error which
 * we will rethrow to be handled by the top level error handler.
 */ function rethrowCaughtError() {
        if (hasRethrowError) {
            var error = rethrowError;
            hasRethrowError = false;
            rethrowError = null;
            throw error;
        }
    }
    function hasCaughtError() {
        return hasError;
    }
    function clearCaughtError() {
        if (hasError) {
            var error = caughtError;
            hasError = false;
            caughtError = null;
            return error;
        } else throw new Error("clearCaughtError was called but no error was captured. This error is likely caused by a bug in React. Please file an issue.");
    }
    /**
 * `ReactInstanceMap` maintains a mapping from a public facing stateful
 * instance (key) and the internal representation (value). This allows public
 * methods to accept the user facing instance as an argument and map them back
 * to internal methods.
 *
 * Note that this module is currently shared and assumed to be stateless.
 * If this becomes an actual Map, that will break.
 */ function get(key) {
        return key._reactInternals;
    }
    function has(key) {
        return key._reactInternals !== undefined;
    }
    function set(key, value) {
        key._reactInternals = value;
    }
    // Don't change these two values. They're used by React Dev Tools.
    var NoFlags = /*                      */ 0;
    var PerformedWork = /*                */ 1; // You can change the rest (and add more).
    var Placement = /*                    */ 2;
    var Update = /*                       */ 4;
    var ChildDeletion = /*                */ 16;
    var ContentReset = /*                 */ 32;
    var Callback = /*                     */ 64;
    var DidCapture = /*                   */ 128;
    var ForceClientRender = /*            */ 256;
    var Ref = /*                          */ 512;
    var Snapshot = /*                     */ 1024;
    var Passive = /*                      */ 2048;
    var Hydrating = /*                    */ 4096;
    var Visibility = /*                   */ 8192;
    var StoreConsistency = /*             */ 16384;
    var LifecycleEffectMask = Passive | Update | Callback | Ref | Snapshot | StoreConsistency; // Union of all commit flags (flags with the lifetime of a particular commit)
    var HostEffectMask = /*               */ 32767; // These are not really side effects, but we still reuse this field.
    var Incomplete = /*                   */ 32768;
    var ShouldCapture = /*                */ 65536;
    var ForceUpdateForLegacySuspense = /* */ 131072;
    var Forked = /*                       */ 1048576; // Static tags describe aspects of a fiber that are not specific to a render,
    // e.g. a fiber uses a passive effect (even if there are no updates on this particular render).
    // This enables us to defer more work in the unmount case,
    // since we can defer traversing the tree during layout to look for Passive effects,
    // and instead rely on the static flag as a signal that there may be cleanup work.
    var RefStatic = /*                    */ 2097152;
    var LayoutStatic = /*                 */ 4194304;
    var PassiveStatic = /*                */ 8388608; // These flags allow us to traverse to fibers that have effects on mount
    // without traversing the entire tree after every commit for
    // double invoking
    var MountLayoutDev = /*               */ 16777216;
    var MountPassiveDev = /*              */ 33554432; // Groups of flags that are used in the commit phase to skip over trees that
    // don't contain effects, by checking subtreeFlags.
    var BeforeMutationMask = // flag logic (see #20043)
    Update | Snapshot | 0;
    var MutationMask = Placement | Update | ChildDeletion | ContentReset | Ref | Hydrating | Visibility;
    var LayoutMask = Update | Callback | Ref | Visibility; // TODO: Split into PassiveMountMask and PassiveUnmountMask
    var PassiveMask = Passive | ChildDeletion; // Union of tags that don't get reset on clones.
    // This allows certain concepts to persist without recalculating them,
    // e.g. whether a subtree contains passive effects or portals.
    var StaticMask = LayoutStatic | PassiveStatic | RefStatic;
    var ReactCurrentOwner = ReactSharedInternals.ReactCurrentOwner;
    function getNearestMountedFiber(fiber) {
        var node = fiber;
        var nearestMounted = fiber;
        if (!fiber.alternate) {
            // If there is no alternate, this might be a new tree that isn't inserted
            // yet. If it is, then it will have a pending insertion effect on it.
            var nextNode = node;
            do {
                node = nextNode;
                if ((node.flags & (Placement | Hydrating)) !== NoFlags) // This is an insertion or in-progress hydration. The nearest possible
                // mounted fiber is the parent but we need to continue to figure out
                // if that one is still mounted.
                nearestMounted = node.return;
                nextNode = node.return;
            }while (nextNode);
        } else while(node.return)node = node.return;
        if (node.tag === HostRoot) // TODO: Check if this was a nested HostRoot when used with
        // renderContainerIntoSubtree.
        return nearestMounted;
         // If we didn't hit the root, that means that we're in an disconnected tree
        // that has been unmounted.
        return null;
    }
    function getSuspenseInstanceFromFiber(fiber) {
        if (fiber.tag === SuspenseComponent) {
            var suspenseState = fiber.memoizedState;
            if (suspenseState === null) {
                var current = fiber.alternate;
                if (current !== null) suspenseState = current.memoizedState;
            }
            if (suspenseState !== null) return suspenseState.dehydrated;
        }
        return null;
    }
    function getContainerFromFiber(fiber) {
        return fiber.tag === HostRoot ? fiber.stateNode.containerInfo : null;
    }
    function isFiberMounted(fiber) {
        return getNearestMountedFiber(fiber) === fiber;
    }
    function isMounted(component) {
        var owner = ReactCurrentOwner.current;
        if (owner !== null && owner.tag === ClassComponent) {
            var ownerFiber = owner;
            var instance = ownerFiber.stateNode;
            if (!instance._warnedAboutRefsInRender) error("%s is accessing isMounted inside its render() function. render() should be a pure function of props and state. It should never access something that requires stale data from the previous render, such as refs. Move this logic to componentDidMount and componentDidUpdate instead.", getComponentNameFromFiber(ownerFiber) || "A component");
            instance._warnedAboutRefsInRender = true;
        }
        var fiber = get(component);
        if (!fiber) return false;
        return getNearestMountedFiber(fiber) === fiber;
    }
    function assertIsMounted(fiber) {
        if (getNearestMountedFiber(fiber) !== fiber) throw new Error("Unable to find node on an unmounted component.");
    }
    function findCurrentFiberUsingSlowPath(fiber) {
        var alternate = fiber.alternate;
        if (!alternate) {
            // If there is no alternate, then we only need to check if it is mounted.
            var nearestMounted = getNearestMountedFiber(fiber);
            if (nearestMounted === null) throw new Error("Unable to find node on an unmounted component.");
            if (nearestMounted !== fiber) return null;
            return fiber;
        } // If we have two possible branches, we'll walk backwards up to the root
        // to see what path the root points to. On the way we may hit one of the
        // special cases and we'll deal with them.
        var a = fiber;
        var b = alternate;
        while(true){
            var parentA = a.return;
            if (parentA === null) break;
            var parentB = parentA.alternate;
            if (parentB === null) {
                // There is no alternate. This is an unusual case. Currently, it only
                // happens when a Suspense component is hidden. An extra fragment fiber
                // is inserted in between the Suspense fiber and its children. Skip
                // over this extra fragment fiber and proceed to the next parent.
                var nextParent = parentA.return;
                if (nextParent !== null) {
                    a = b = nextParent;
                    continue;
                } // If there's no parent, we're at the root.
                break;
            } // If both copies of the parent fiber point to the same child, we can
            // assume that the child is current. This happens when we bailout on low
            // priority: the bailed out fiber's child reuses the current child.
            if (parentA.child === parentB.child) {
                var child = parentA.child;
                while(child){
                    if (child === a) {
                        // We've determined that A is the current branch.
                        assertIsMounted(parentA);
                        return fiber;
                    }
                    if (child === b) {
                        // We've determined that B is the current branch.
                        assertIsMounted(parentA);
                        return alternate;
                    }
                    child = child.sibling;
                } // We should never have an alternate for any mounting node. So the only
                // way this could possibly happen is if this was unmounted, if at all.
                throw new Error("Unable to find node on an unmounted component.");
            }
            if (a.return !== b.return) {
                // The return pointer of A and the return pointer of B point to different
                // fibers. We assume that return pointers never criss-cross, so A must
                // belong to the child set of A.return, and B must belong to the child
                // set of B.return.
                a = parentA;
                b = parentB;
            } else {
                // The return pointers point to the same fiber. We'll have to use the
                // default, slow path: scan the child sets of each parent alternate to see
                // which child belongs to which set.
                //
                // Search parent A's child set
                var didFindChild = false;
                var _child = parentA.child;
                while(_child){
                    if (_child === a) {
                        didFindChild = true;
                        a = parentA;
                        b = parentB;
                        break;
                    }
                    if (_child === b) {
                        didFindChild = true;
                        b = parentA;
                        a = parentB;
                        break;
                    }
                    _child = _child.sibling;
                }
                if (!didFindChild) {
                    // Search parent B's child set
                    _child = parentB.child;
                    while(_child){
                        if (_child === a) {
                            didFindChild = true;
                            a = parentB;
                            b = parentA;
                            break;
                        }
                        if (_child === b) {
                            didFindChild = true;
                            b = parentB;
                            a = parentA;
                            break;
                        }
                        _child = _child.sibling;
                    }
                    if (!didFindChild) throw new Error("Child was not found in either parent set. This indicates a bug in React related to the return pointer. Please file an issue.");
                }
            }
            if (a.alternate !== b) throw new Error("Return fibers should always be each others' alternates. This error is likely caused by a bug in React. Please file an issue.");
        } // If the root is not a host container, we're in a disconnected tree. I.e.
        // unmounted.
        if (a.tag !== HostRoot) throw new Error("Unable to find node on an unmounted component.");
        if (a.stateNode.current === a) // We've determined that A is the current branch.
        return fiber;
         // Otherwise B has to be current branch.
        return alternate;
    }
    function findCurrentHostFiber(parent) {
        var currentParent = findCurrentFiberUsingSlowPath(parent);
        return currentParent !== null ? findCurrentHostFiberImpl(currentParent) : null;
    }
    function findCurrentHostFiberImpl(node) {
        // Next we'll drill down this component to find the first HostComponent/Text.
        if (node.tag === HostComponent || node.tag === HostText) return node;
        var child = node.child;
        while(child !== null){
            var match = findCurrentHostFiberImpl(child);
            if (match !== null) return match;
            child = child.sibling;
        }
        return null;
    }
    function findCurrentHostFiberWithNoPortals(parent) {
        var currentParent = findCurrentFiberUsingSlowPath(parent);
        return currentParent !== null ? findCurrentHostFiberWithNoPortalsImpl(currentParent) : null;
    }
    function findCurrentHostFiberWithNoPortalsImpl(node) {
        // Next we'll drill down this component to find the first HostComponent/Text.
        if (node.tag === HostComponent || node.tag === HostText) return node;
        var child = node.child;
        while(child !== null){
            if (child.tag !== HostPortal) {
                var match = findCurrentHostFiberWithNoPortalsImpl(child);
                if (match !== null) return match;
            }
            child = child.sibling;
        }
        return null;
    }
    // This module only exists as an ESM wrapper around the external CommonJS
    var scheduleCallback = Scheduler.unstable_scheduleCallback;
    var cancelCallback = Scheduler.unstable_cancelCallback;
    var shouldYield = Scheduler.unstable_shouldYield;
    var requestPaint = Scheduler.unstable_requestPaint;
    var now = Scheduler.unstable_now;
    var getCurrentPriorityLevel = Scheduler.unstable_getCurrentPriorityLevel;
    var ImmediatePriority = Scheduler.unstable_ImmediatePriority;
    var UserBlockingPriority = Scheduler.unstable_UserBlockingPriority;
    var NormalPriority = Scheduler.unstable_NormalPriority;
    var LowPriority = Scheduler.unstable_LowPriority;
    var IdlePriority = Scheduler.unstable_IdlePriority;
    // this doesn't actually exist on the scheduler, but it *does*
    // on scheduler/unstable_mock, which we'll need for internal testing
    var unstable_yieldValue = Scheduler.unstable_yieldValue;
    var unstable_setDisableYieldValue = Scheduler.unstable_setDisableYieldValue;
    var rendererID = null;
    var injectedHook = null;
    var injectedProfilingHooks = null;
    var hasLoggedError = false;
    var isDevToolsPresent = typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ !== "undefined";
    function injectInternals(internals) {
        if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === "undefined") // No DevTools
        return false;
        var hook = __REACT_DEVTOOLS_GLOBAL_HOOK__;
        if (hook.isDisabled) // This isn't a real property on the hook, but it can be set to opt out
        // of DevTools integration and associated warnings and logs.
        // https://github.com/facebook/react/issues/3877
        return true;
        if (!hook.supportsFiber) {
            error("The installed version of React DevTools is too old and will not work with the current version of React. Please update React DevTools. https://reactjs.org/link/react-devtools");
            return true;
        }
        try {
            if (enableSchedulingProfiler) // Conditionally inject these hooks only if Timeline profiler is supported by this build.
            // This gives DevTools a way to feature detect that isn't tied to version number
            // (since profiling and timeline are controlled by different feature flags).
            internals = assign({}, internals, {
                getLaneLabelMap: getLaneLabelMap,
                injectProfilingHooks: injectProfilingHooks
            });
            rendererID = hook.inject(internals); // We have successfully injected, so now it is safe to set up hooks.
            injectedHook = hook;
        } catch (err) {
            error("React instrumentation encountered an error: %s.", err);
        }
        if (hook.checkDCE) // This is the real DevTools.
        return true;
        else // This is likely a hook installed by Fast Refresh runtime.
        return false;
    }
    function onScheduleRoot(root, children) {
        if (injectedHook && typeof injectedHook.onScheduleFiberRoot === "function") try {
            injectedHook.onScheduleFiberRoot(rendererID, root, children);
        } catch (err) {
            if (!hasLoggedError) {
                hasLoggedError = true;
                error("React instrumentation encountered an error: %s", err);
            }
        }
    }
    function onCommitRoot(root, eventPriority) {
        if (injectedHook && typeof injectedHook.onCommitFiberRoot === "function") try {
            var didError = (root.current.flags & DidCapture) === DidCapture;
            if (enableProfilerTimer) {
                var schedulerPriority;
                switch(eventPriority){
                    case DiscreteEventPriority:
                        schedulerPriority = ImmediatePriority;
                        break;
                    case ContinuousEventPriority:
                        schedulerPriority = UserBlockingPriority;
                        break;
                    case DefaultEventPriority:
                        schedulerPriority = NormalPriority;
                        break;
                    case IdleEventPriority:
                        schedulerPriority = IdlePriority;
                        break;
                    default:
                        schedulerPriority = NormalPriority;
                        break;
                }
                injectedHook.onCommitFiberRoot(rendererID, root, schedulerPriority, didError);
            } else injectedHook.onCommitFiberRoot(rendererID, root, undefined, didError);
        } catch (err) {
            if (!hasLoggedError) {
                hasLoggedError = true;
                error("React instrumentation encountered an error: %s", err);
            }
        }
    }
    function onPostCommitRoot(root) {
        if (injectedHook && typeof injectedHook.onPostCommitFiberRoot === "function") try {
            injectedHook.onPostCommitFiberRoot(rendererID, root);
        } catch (err) {
            if (!hasLoggedError) {
                hasLoggedError = true;
                error("React instrumentation encountered an error: %s", err);
            }
        }
    }
    function onCommitUnmount(fiber) {
        if (injectedHook && typeof injectedHook.onCommitFiberUnmount === "function") try {
            injectedHook.onCommitFiberUnmount(rendererID, fiber);
        } catch (err) {
            if (!hasLoggedError) {
                hasLoggedError = true;
                error("React instrumentation encountered an error: %s", err);
            }
        }
    }
    function setIsStrictModeForDevtools(newIsStrictMode) {
        if (typeof unstable_yieldValue === "function") {
            // We're in a test because Scheduler.unstable_yieldValue only exists
            // in SchedulerMock. To reduce the noise in strict mode tests,
            // suppress warnings and disable scheduler yielding during the double render
            unstable_setDisableYieldValue(newIsStrictMode);
            setSuppressWarning(newIsStrictMode);
        }
        if (injectedHook && typeof injectedHook.setStrictMode === "function") try {
            injectedHook.setStrictMode(rendererID, newIsStrictMode);
        } catch (err) {
            if (!hasLoggedError) {
                hasLoggedError = true;
                error("React instrumentation encountered an error: %s", err);
            }
        }
    } // Profiler API hooks
    function injectProfilingHooks(profilingHooks) {
        injectedProfilingHooks = profilingHooks;
    }
    function getLaneLabelMap() {
        var map = new Map();
        var lane = 1;
        for(var index = 0; index < TotalLanes; index++){
            var label = getLabelForLane(lane);
            map.set(lane, label);
            lane *= 2;
        }
        return map;
    }
    function markCommitStarted(lanes) {
        if (injectedProfilingHooks !== null && typeof injectedProfilingHooks.markCommitStarted === "function") injectedProfilingHooks.markCommitStarted(lanes);
    }
    function markCommitStopped() {
        if (injectedProfilingHooks !== null && typeof injectedProfilingHooks.markCommitStopped === "function") injectedProfilingHooks.markCommitStopped();
    }
    function markComponentRenderStarted(fiber) {
        if (injectedProfilingHooks !== null && typeof injectedProfilingHooks.markComponentRenderStarted === "function") injectedProfilingHooks.markComponentRenderStarted(fiber);
    }
    function markComponentRenderStopped() {
        if (injectedProfilingHooks !== null && typeof injectedProfilingHooks.markComponentRenderStopped === "function") injectedProfilingHooks.markComponentRenderStopped();
    }
    function markComponentPassiveEffectMountStarted(fiber) {
        if (injectedProfilingHooks !== null && typeof injectedProfilingHooks.markComponentPassiveEffectMountStarted === "function") injectedProfilingHooks.markComponentPassiveEffectMountStarted(fiber);
    }
    function markComponentPassiveEffectMountStopped() {
        if (injectedProfilingHooks !== null && typeof injectedProfilingHooks.markComponentPassiveEffectMountStopped === "function") injectedProfilingHooks.markComponentPassiveEffectMountStopped();
    }
    function markComponentPassiveEffectUnmountStarted(fiber) {
        if (injectedProfilingHooks !== null && typeof injectedProfilingHooks.markComponentPassiveEffectUnmountStarted === "function") injectedProfilingHooks.markComponentPassiveEffectUnmountStarted(fiber);
    }
    function markComponentPassiveEffectUnmountStopped() {
        if (injectedProfilingHooks !== null && typeof injectedProfilingHooks.markComponentPassiveEffectUnmountStopped === "function") injectedProfilingHooks.markComponentPassiveEffectUnmountStopped();
    }
    function markComponentLayoutEffectMountStarted(fiber) {
        if (injectedProfilingHooks !== null && typeof injectedProfilingHooks.markComponentLayoutEffectMountStarted === "function") injectedProfilingHooks.markComponentLayoutEffectMountStarted(fiber);
    }
    function markComponentLayoutEffectMountStopped() {
        if (injectedProfilingHooks !== null && typeof injectedProfilingHooks.markComponentLayoutEffectMountStopped === "function") injectedProfilingHooks.markComponentLayoutEffectMountStopped();
    }
    function markComponentLayoutEffectUnmountStarted(fiber) {
        if (injectedProfilingHooks !== null && typeof injectedProfilingHooks.markComponentLayoutEffectUnmountStarted === "function") injectedProfilingHooks.markComponentLayoutEffectUnmountStarted(fiber);
    }
    function markComponentLayoutEffectUnmountStopped() {
        if (injectedProfilingHooks !== null && typeof injectedProfilingHooks.markComponentLayoutEffectUnmountStopped === "function") injectedProfilingHooks.markComponentLayoutEffectUnmountStopped();
    }
    function markComponentErrored(fiber, thrownValue, lanes) {
        if (injectedProfilingHooks !== null && typeof injectedProfilingHooks.markComponentErrored === "function") injectedProfilingHooks.markComponentErrored(fiber, thrownValue, lanes);
    }
    function markComponentSuspended(fiber, wakeable, lanes) {
        if (injectedProfilingHooks !== null && typeof injectedProfilingHooks.markComponentSuspended === "function") injectedProfilingHooks.markComponentSuspended(fiber, wakeable, lanes);
    }
    function markLayoutEffectsStarted(lanes) {
        if (injectedProfilingHooks !== null && typeof injectedProfilingHooks.markLayoutEffectsStarted === "function") injectedProfilingHooks.markLayoutEffectsStarted(lanes);
    }
    function markLayoutEffectsStopped() {
        if (injectedProfilingHooks !== null && typeof injectedProfilingHooks.markLayoutEffectsStopped === "function") injectedProfilingHooks.markLayoutEffectsStopped();
    }
    function markPassiveEffectsStarted(lanes) {
        if (injectedProfilingHooks !== null && typeof injectedProfilingHooks.markPassiveEffectsStarted === "function") injectedProfilingHooks.markPassiveEffectsStarted(lanes);
    }
    function markPassiveEffectsStopped() {
        if (injectedProfilingHooks !== null && typeof injectedProfilingHooks.markPassiveEffectsStopped === "function") injectedProfilingHooks.markPassiveEffectsStopped();
    }
    function markRenderStarted(lanes) {
        if (injectedProfilingHooks !== null && typeof injectedProfilingHooks.markRenderStarted === "function") injectedProfilingHooks.markRenderStarted(lanes);
    }
    function markRenderYielded() {
        if (injectedProfilingHooks !== null && typeof injectedProfilingHooks.markRenderYielded === "function") injectedProfilingHooks.markRenderYielded();
    }
    function markRenderStopped() {
        if (injectedProfilingHooks !== null && typeof injectedProfilingHooks.markRenderStopped === "function") injectedProfilingHooks.markRenderStopped();
    }
    function markRenderScheduled(lane) {
        if (injectedProfilingHooks !== null && typeof injectedProfilingHooks.markRenderScheduled === "function") injectedProfilingHooks.markRenderScheduled(lane);
    }
    function markForceUpdateScheduled(fiber, lane) {
        if (injectedProfilingHooks !== null && typeof injectedProfilingHooks.markForceUpdateScheduled === "function") injectedProfilingHooks.markForceUpdateScheduled(fiber, lane);
    }
    function markStateUpdateScheduled(fiber, lane) {
        if (injectedProfilingHooks !== null && typeof injectedProfilingHooks.markStateUpdateScheduled === "function") injectedProfilingHooks.markStateUpdateScheduled(fiber, lane);
    }
    var NoMode = /*                         */ 0; // TODO: Remove ConcurrentMode by reading from the root tag instead
    var ConcurrentMode = /*                 */ 1;
    var ProfileMode = /*                    */ 2;
    var StrictLegacyMode = /*               */ 8;
    var StrictEffectsMode = /*              */ 16;
    // TODO: This is pretty well supported by browsers. Maybe we can drop it.
    var clz32 = Math.clz32 ? Math.clz32 : clz32Fallback; // Count leading zeros.
    // Based on:
    // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Math/clz32
    var log = Math.log;
    var LN2 = Math.LN2;
    function clz32Fallback(x) {
        var asUint = x >>> 0;
        if (asUint === 0) return 32;
        return 31 - (log(asUint) / LN2 | 0) | 0;
    }
    // If those values are changed that package should be rebuilt and redeployed.
    var TotalLanes = 31;
    var NoLanes = /*                        */ 0;
    var NoLane = /*                          */ 0;
    var SyncLane = /*                        */ 1;
    var InputContinuousHydrationLane = /*    */ 2;
    var InputContinuousLane = /*             */ 4;
    var DefaultHydrationLane = /*            */ 8;
    var DefaultLane = /*                     */ 16;
    var TransitionHydrationLane = /*                */ 32;
    var TransitionLanes = /*                       */ 4194240;
    var TransitionLane1 = /*                        */ 64;
    var TransitionLane2 = /*                        */ 128;
    var TransitionLane3 = /*                        */ 256;
    var TransitionLane4 = /*                        */ 512;
    var TransitionLane5 = /*                        */ 1024;
    var TransitionLane6 = /*                        */ 2048;
    var TransitionLane7 = /*                        */ 4096;
    var TransitionLane8 = /*                        */ 8192;
    var TransitionLane9 = /*                        */ 16384;
    var TransitionLane10 = /*                       */ 32768;
    var TransitionLane11 = /*                       */ 65536;
    var TransitionLane12 = /*                       */ 131072;
    var TransitionLane13 = /*                       */ 262144;
    var TransitionLane14 = /*                       */ 524288;
    var TransitionLane15 = /*                       */ 1048576;
    var TransitionLane16 = /*                       */ 2097152;
    var RetryLanes = /*                            */ 130023424;
    var RetryLane1 = /*                             */ 4194304;
    var RetryLane2 = /*                             */ 8388608;
    var RetryLane3 = /*                             */ 16777216;
    var RetryLane4 = /*                             */ 33554432;
    var RetryLane5 = /*                             */ 67108864;
    var SomeRetryLane = RetryLane1;
    var SelectiveHydrationLane = /*          */ 134217728;
    var NonIdleLanes = /*                          */ 268435455;
    var IdleHydrationLane = /*               */ 268435456;
    var IdleLane = /*                        */ 536870912;
    var OffscreenLane = /*                   */ 1073741824; // This function is used for the experimental timeline (react-devtools-timeline)
    // It should be kept in sync with the Lanes values above.
    function getLabelForLane(lane) {
        if (lane & SyncLane) return "Sync";
        if (lane & InputContinuousHydrationLane) return "InputContinuousHydration";
        if (lane & InputContinuousLane) return "InputContinuous";
        if (lane & DefaultHydrationLane) return "DefaultHydration";
        if (lane & DefaultLane) return "Default";
        if (lane & TransitionHydrationLane) return "TransitionHydration";
        if (lane & TransitionLanes) return "Transition";
        if (lane & RetryLanes) return "Retry";
        if (lane & SelectiveHydrationLane) return "SelectiveHydration";
        if (lane & IdleHydrationLane) return "IdleHydration";
        if (lane & IdleLane) return "Idle";
        if (lane & OffscreenLane) return "Offscreen";
    }
    var NoTimestamp = -1;
    var nextTransitionLane = TransitionLane1;
    var nextRetryLane = RetryLane1;
    function getHighestPriorityLanes(lanes) {
        switch(getHighestPriorityLane(lanes)){
            case SyncLane:
                return SyncLane;
            case InputContinuousHydrationLane:
                return InputContinuousHydrationLane;
            case InputContinuousLane:
                return InputContinuousLane;
            case DefaultHydrationLane:
                return DefaultHydrationLane;
            case DefaultLane:
                return DefaultLane;
            case TransitionHydrationLane:
                return TransitionHydrationLane;
            case TransitionLane1:
            case TransitionLane2:
            case TransitionLane3:
            case TransitionLane4:
            case TransitionLane5:
            case TransitionLane6:
            case TransitionLane7:
            case TransitionLane8:
            case TransitionLane9:
            case TransitionLane10:
            case TransitionLane11:
            case TransitionLane12:
            case TransitionLane13:
            case TransitionLane14:
            case TransitionLane15:
            case TransitionLane16:
                return lanes & TransitionLanes;
            case RetryLane1:
            case RetryLane2:
            case RetryLane3:
            case RetryLane4:
            case RetryLane5:
                return lanes & RetryLanes;
            case SelectiveHydrationLane:
                return SelectiveHydrationLane;
            case IdleHydrationLane:
                return IdleHydrationLane;
            case IdleLane:
                return IdleLane;
            case OffscreenLane:
                return OffscreenLane;
            default:
                error("Should have found matching lanes. This is a bug in React.");
                return lanes;
        }
    }
    function getNextLanes(root, wipLanes) {
        // Early bailout if there's no pending work left.
        var pendingLanes = root.pendingLanes;
        if (pendingLanes === NoLanes) return NoLanes;
        var nextLanes = NoLanes;
        var suspendedLanes = root.suspendedLanes;
        var pingedLanes = root.pingedLanes; // Do not work on any idle work until all the non-idle work has finished,
        // even if the work is suspended.
        var nonIdlePendingLanes = pendingLanes & NonIdleLanes;
        if (nonIdlePendingLanes !== NoLanes) {
            var nonIdleUnblockedLanes = nonIdlePendingLanes & ~suspendedLanes;
            if (nonIdleUnblockedLanes !== NoLanes) nextLanes = getHighestPriorityLanes(nonIdleUnblockedLanes);
            else {
                var nonIdlePingedLanes = nonIdlePendingLanes & pingedLanes;
                if (nonIdlePingedLanes !== NoLanes) nextLanes = getHighestPriorityLanes(nonIdlePingedLanes);
            }
        } else {
            // The only remaining work is Idle.
            var unblockedLanes = pendingLanes & ~suspendedLanes;
            if (unblockedLanes !== NoLanes) nextLanes = getHighestPriorityLanes(unblockedLanes);
            else if (pingedLanes !== NoLanes) nextLanes = getHighestPriorityLanes(pingedLanes);
        }
        if (nextLanes === NoLanes) // This should only be reachable if we're suspended
        // TODO: Consider warning in this path if a fallback timer is not scheduled.
        return NoLanes;
         // If we're already in the middle of a render, switching lanes will interrupt
        // it and we'll lose our progress. We should only do this if the new lanes are
        // higher priority.
        if (wipLanes !== NoLanes && wipLanes !== nextLanes && // If we already suspended with a delay, then interrupting is fine. Don't
        // bother waiting until the root is complete.
        (wipLanes & suspendedLanes) === NoLanes) {
            var nextLane = getHighestPriorityLane(nextLanes);
            var wipLane = getHighestPriorityLane(wipLanes);
            if (// one. This works because the bits decrease in priority as you go left.
            nextLane >= wipLane || // Default priority updates should not interrupt transition updates. The
            // only difference between default updates and transition updates is that
            // default updates do not support refresh transitions.
            nextLane === DefaultLane && (wipLane & TransitionLanes) !== NoLanes) // Keep working on the existing in-progress tree. Do not interrupt.
            return wipLanes;
        }
        if ((nextLanes & InputContinuousLane) !== NoLanes) // When updates are sync by default, we entangle continuous priority updates
        // and default updates, so they render in the same batch. The only reason
        // they use separate lanes is because continuous updates should interrupt
        // transitions, but default updates should not.
        nextLanes |= pendingLanes & DefaultLane;
         // Check for entangled lanes and add them to the batch.
        //
        // A lane is said to be entangled with another when it's not allowed to render
        // in a batch that does not also include the other lane. Typically we do this
        // when multiple updates have the same source, and we only want to respond to
        // the most recent event from that source.
        //
        // Note that we apply entanglements *after* checking for partial work above.
        // This means that if a lane is entangled during an interleaved event while
        // it's already rendering, we won't interrupt it. This is intentional, since
        // entanglement is usually "best effort": we'll try our best to render the
        // lanes in the same batch, but it's not worth throwing out partially
        // completed work in order to do it.
        // TODO: Reconsider this. The counter-argument is that the partial work
        // represents an intermediate state, which we don't want to show to the user.
        // And by spending extra time finishing it, we're increasing the amount of
        // time it takes to show the final state, which is what they are actually
        // waiting for.
        //
        // For those exceptions where entanglement is semantically important, like
        // useMutableSource, we should ensure that there is no partial work at the
        // time we apply the entanglement.
        var entangledLanes = root.entangledLanes;
        if (entangledLanes !== NoLanes) {
            var entanglements = root.entanglements;
            var lanes = nextLanes & entangledLanes;
            while(lanes > 0){
                var index = pickArbitraryLaneIndex(lanes);
                var lane = 1 << index;
                nextLanes |= entanglements[index];
                lanes &= ~lane;
            }
        }
        return nextLanes;
    }
    function getMostRecentEventTime(root, lanes) {
        var eventTimes = root.eventTimes;
        var mostRecentEventTime = NoTimestamp;
        while(lanes > 0){
            var index = pickArbitraryLaneIndex(lanes);
            var lane = 1 << index;
            var eventTime = eventTimes[index];
            if (eventTime > mostRecentEventTime) mostRecentEventTime = eventTime;
            lanes &= ~lane;
        }
        return mostRecentEventTime;
    }
    function computeExpirationTime(lane, currentTime) {
        switch(lane){
            case SyncLane:
            case InputContinuousHydrationLane:
            case InputContinuousLane:
                // User interactions should expire slightly more quickly.
                //
                // NOTE: This is set to the corresponding constant as in Scheduler.js.
                // When we made it larger, a product metric in www regressed, suggesting
                // there's a user interaction that's being starved by a series of
                // synchronous updates. If that theory is correct, the proper solution is
                // to fix the starvation. However, this scenario supports the idea that
                // expiration times are an important safeguard when starvation
                // does happen.
                return currentTime + 250;
            case DefaultHydrationLane:
            case DefaultLane:
            case TransitionHydrationLane:
            case TransitionLane1:
            case TransitionLane2:
            case TransitionLane3:
            case TransitionLane4:
            case TransitionLane5:
            case TransitionLane6:
            case TransitionLane7:
            case TransitionLane8:
            case TransitionLane9:
            case TransitionLane10:
            case TransitionLane11:
            case TransitionLane12:
            case TransitionLane13:
            case TransitionLane14:
            case TransitionLane15:
            case TransitionLane16:
                return currentTime + 5000;
            case RetryLane1:
            case RetryLane2:
            case RetryLane3:
            case RetryLane4:
            case RetryLane5:
                // TODO: Retries should be allowed to expire if they are CPU bound for
                // too long, but when I made this change it caused a spike in browser
                // crashes. There must be some other underlying bug; not super urgent but
                // ideally should figure out why and fix it. Unfortunately we don't have
                // a repro for the crashes, only detected via production metrics.
                return NoTimestamp;
            case SelectiveHydrationLane:
            case IdleHydrationLane:
            case IdleLane:
            case OffscreenLane:
                // Anything idle priority or lower should never expire.
                return NoTimestamp;
            default:
                error("Should have found matching lanes. This is a bug in React.");
                return NoTimestamp;
        }
    }
    function markStarvedLanesAsExpired(root, currentTime) {
        // TODO: This gets called every time we yield. We can optimize by storing
        // the earliest expiration time on the root. Then use that to quickly bail out
        // of this function.
        var pendingLanes = root.pendingLanes;
        var suspendedLanes = root.suspendedLanes;
        var pingedLanes = root.pingedLanes;
        var expirationTimes = root.expirationTimes; // Iterate through the pending lanes and check if we've reached their
        // expiration time. If so, we'll assume the update is being starved and mark
        // it as expired to force it to finish.
        var lanes = pendingLanes;
        while(lanes > 0){
            var index = pickArbitraryLaneIndex(lanes);
            var lane = 1 << index;
            var expirationTime = expirationTimes[index];
            if (expirationTime === NoTimestamp) // Found a pending lane with no expiration time. If it's not suspended, or
            // if it's pinged, assume it's CPU-bound. Compute a new expiration time
            // using the current time.
            {
                if ((lane & suspendedLanes) === NoLanes || (lane & pingedLanes) !== NoLanes) // Assumes timestamps are monotonically increasing.
                expirationTimes[index] = computeExpirationTime(lane, currentTime);
            } else if (expirationTime <= currentTime) // This lane expired
            root.expiredLanes |= lane;
            lanes &= ~lane;
        }
    } // This returns the highest priority pending lanes regardless of whether they
    // are suspended.
    function getHighestPriorityPendingLanes(root) {
        return getHighestPriorityLanes(root.pendingLanes);
    }
    function getLanesToRetrySynchronouslyOnError(root) {
        var everythingButOffscreen = root.pendingLanes & ~OffscreenLane;
        if (everythingButOffscreen !== NoLanes) return everythingButOffscreen;
        if (everythingButOffscreen & OffscreenLane) return OffscreenLane;
        return NoLanes;
    }
    function includesSyncLane(lanes) {
        return (lanes & SyncLane) !== NoLanes;
    }
    function includesNonIdleWork(lanes) {
        return (lanes & NonIdleLanes) !== NoLanes;
    }
    function includesOnlyRetries(lanes) {
        return (lanes & RetryLanes) === lanes;
    }
    function includesOnlyNonUrgentLanes(lanes) {
        var UrgentLanes = SyncLane | InputContinuousLane | DefaultLane;
        return (lanes & UrgentLanes) === NoLanes;
    }
    function includesOnlyTransitions(lanes) {
        return (lanes & TransitionLanes) === lanes;
    }
    function includesBlockingLane(root, lanes) {
        var SyncDefaultLanes = InputContinuousHydrationLane | InputContinuousLane | DefaultHydrationLane | DefaultLane;
        return (lanes & SyncDefaultLanes) !== NoLanes;
    }
    function includesExpiredLane(root, lanes) {
        // This is a separate check from includesBlockingLane because a lane can
        // expire after a render has already started.
        return (lanes & root.expiredLanes) !== NoLanes;
    }
    function isTransitionLane(lane) {
        return (lane & TransitionLanes) !== NoLanes;
    }
    function claimNextTransitionLane() {
        // Cycle through the lanes, assigning each new transition to the next lane.
        // In most cases, this means every transition gets its own lane, until we
        // run out of lanes and cycle back to the beginning.
        var lane = nextTransitionLane;
        nextTransitionLane <<= 1;
        if ((nextTransitionLane & TransitionLanes) === NoLanes) nextTransitionLane = TransitionLane1;
        return lane;
    }
    function claimNextRetryLane() {
        var lane = nextRetryLane;
        nextRetryLane <<= 1;
        if ((nextRetryLane & RetryLanes) === NoLanes) nextRetryLane = RetryLane1;
        return lane;
    }
    function getHighestPriorityLane(lanes) {
        return lanes & -lanes;
    }
    function pickArbitraryLane(lanes) {
        // This wrapper function gets inlined. Only exists so to communicate that it
        // doesn't matter which bit is selected; you can pick any bit without
        // affecting the algorithms where its used. Here I'm using
        // getHighestPriorityLane because it requires the fewest operations.
        return getHighestPriorityLane(lanes);
    }
    function pickArbitraryLaneIndex(lanes) {
        return 31 - clz32(lanes);
    }
    function laneToIndex(lane) {
        return pickArbitraryLaneIndex(lane);
    }
    function includesSomeLane(a, b) {
        return (a & b) !== NoLanes;
    }
    function isSubsetOfLanes(set, subset) {
        return (set & subset) === subset;
    }
    function mergeLanes(a, b) {
        return a | b;
    }
    function removeLanes(set, subset) {
        return set & ~subset;
    }
    function intersectLanes(a, b) {
        return a & b;
    } // Seems redundant, but it changes the type from a single lane (used for
    // updates) to a group of lanes (used for flushing work).
    function laneToLanes(lane) {
        return lane;
    }
    function higherPriorityLane(a, b) {
        // This works because the bit ranges decrease in priority as you go left.
        return a !== NoLane && a < b ? a : b;
    }
    function createLaneMap(initial) {
        // Intentionally pushing one by one.
        // https://v8.dev/blog/elements-kinds#avoid-creating-holes
        var laneMap = [];
        for(var i = 0; i < TotalLanes; i++)laneMap.push(initial);
        return laneMap;
    }
    function markRootUpdated(root, updateLane, eventTime) {
        root.pendingLanes |= updateLane; // If there are any suspended transitions, it's possible this new update
        // could unblock them. Clear the suspended lanes so that we can try rendering
        // them again.
        //
        // TODO: We really only need to unsuspend only lanes that are in the
        // `subtreeLanes` of the updated fiber, or the update lanes of the return
        // path. This would exclude suspended updates in an unrelated sibling tree,
        // since there's no way for this update to unblock it.
        //
        // We don't do this if the incoming update is idle, because we never process
        // idle updates until after all the regular updates have finished; there's no
        // way it could unblock a transition.
        if (updateLane !== IdleLane) {
            root.suspendedLanes = NoLanes;
            root.pingedLanes = NoLanes;
        }
        var eventTimes = root.eventTimes;
        var index = laneToIndex(updateLane); // We can always overwrite an existing timestamp because we prefer the most
        // recent event, and we assume time is monotonically increasing.
        eventTimes[index] = eventTime;
    }
    function markRootSuspended(root, suspendedLanes) {
        root.suspendedLanes |= suspendedLanes;
        root.pingedLanes &= ~suspendedLanes; // The suspended lanes are no longer CPU-bound. Clear their expiration times.
        var expirationTimes = root.expirationTimes;
        var lanes = suspendedLanes;
        while(lanes > 0){
            var index = pickArbitraryLaneIndex(lanes);
            var lane = 1 << index;
            expirationTimes[index] = NoTimestamp;
            lanes &= ~lane;
        }
    }
    function markRootPinged(root, pingedLanes, eventTime) {
        root.pingedLanes |= root.suspendedLanes & pingedLanes;
    }
    function markRootFinished(root, remainingLanes) {
        var noLongerPendingLanes = root.pendingLanes & ~remainingLanes;
        root.pendingLanes = remainingLanes; // Let's try everything again
        root.suspendedLanes = NoLanes;
        root.pingedLanes = NoLanes;
        root.expiredLanes &= remainingLanes;
        root.mutableReadLanes &= remainingLanes;
        root.entangledLanes &= remainingLanes;
        var entanglements = root.entanglements;
        var eventTimes = root.eventTimes;
        var expirationTimes = root.expirationTimes; // Clear the lanes that no longer have pending work
        var lanes = noLongerPendingLanes;
        while(lanes > 0){
            var index = pickArbitraryLaneIndex(lanes);
            var lane = 1 << index;
            entanglements[index] = NoLanes;
            eventTimes[index] = NoTimestamp;
            expirationTimes[index] = NoTimestamp;
            lanes &= ~lane;
        }
    }
    function markRootEntangled(root, entangledLanes) {
        // In addition to entangling each of the given lanes with each other, we also
        // have to consider _transitive_ entanglements. For each lane that is already
        // entangled with *any* of the given lanes, that lane is now transitively
        // entangled with *all* the given lanes.
        //
        // Translated: If C is entangled with A, then entangling A with B also
        // entangles C with B.
        //
        // If this is hard to grasp, it might help to intentionally break this
        // function and look at the tests that fail in ReactTransition-test.js. Try
        // commenting out one of the conditions below.
        var rootEntangledLanes = root.entangledLanes |= entangledLanes;
        var entanglements = root.entanglements;
        var lanes = rootEntangledLanes;
        while(lanes){
            var index = pickArbitraryLaneIndex(lanes);
            var lane = 1 << index;
            if (lane & entangledLanes | // Is this lane transitively entangled with the newly entangled lanes?
            entanglements[index] & entangledLanes) entanglements[index] |= entangledLanes;
            lanes &= ~lane;
        }
    }
    function getBumpedLaneForHydration(root, renderLanes) {
        var renderLane = getHighestPriorityLane(renderLanes);
        var lane;
        switch(renderLane){
            case InputContinuousLane:
                lane = InputContinuousHydrationLane;
                break;
            case DefaultLane:
                lane = DefaultHydrationLane;
                break;
            case TransitionLane1:
            case TransitionLane2:
            case TransitionLane3:
            case TransitionLane4:
            case TransitionLane5:
            case TransitionLane6:
            case TransitionLane7:
            case TransitionLane8:
            case TransitionLane9:
            case TransitionLane10:
            case TransitionLane11:
            case TransitionLane12:
            case TransitionLane13:
            case TransitionLane14:
            case TransitionLane15:
            case TransitionLane16:
            case RetryLane1:
            case RetryLane2:
            case RetryLane3:
            case RetryLane4:
            case RetryLane5:
                lane = TransitionHydrationLane;
                break;
            case IdleLane:
                lane = IdleHydrationLane;
                break;
            default:
                // Everything else is already either a hydration lane, or shouldn't
                // be retried at a hydration lane.
                lane = NoLane;
                break;
        } // Check if the lane we chose is suspended. If so, that indicates that we
        // already attempted and failed to hydrate at that level. Also check if we're
        // already rendering that lane, which is rare but could happen.
        if ((lane & (root.suspendedLanes | renderLanes)) !== NoLane) // Give up trying to hydrate and fall back to client render.
        return NoLane;
        return lane;
    }
    function addFiberToLanesMap(root, fiber, lanes) {
        if (!isDevToolsPresent) return;
        var pendingUpdatersLaneMap = root.pendingUpdatersLaneMap;
        while(lanes > 0){
            var index = laneToIndex(lanes);
            var lane = 1 << index;
            var updaters = pendingUpdatersLaneMap[index];
            updaters.add(fiber);
            lanes &= ~lane;
        }
    }
    function movePendingFibersToMemoized(root, lanes) {
        if (!isDevToolsPresent) return;
        var pendingUpdatersLaneMap = root.pendingUpdatersLaneMap;
        var memoizedUpdaters = root.memoizedUpdaters;
        while(lanes > 0){
            var index = laneToIndex(lanes);
            var lane = 1 << index;
            var updaters = pendingUpdatersLaneMap[index];
            if (updaters.size > 0) {
                updaters.forEach(function(fiber) {
                    var alternate = fiber.alternate;
                    if (alternate === null || !memoizedUpdaters.has(alternate)) memoizedUpdaters.add(fiber);
                });
                updaters.clear();
            }
            lanes &= ~lane;
        }
    }
    function getTransitionsForLanes(root, lanes) {
        return null;
    }
    var DiscreteEventPriority = SyncLane;
    var ContinuousEventPriority = InputContinuousLane;
    var DefaultEventPriority = DefaultLane;
    var IdleEventPriority = IdleLane;
    var currentUpdatePriority = NoLane;
    function getCurrentUpdatePriority() {
        return currentUpdatePriority;
    }
    function setCurrentUpdatePriority(newPriority) {
        currentUpdatePriority = newPriority;
    }
    function runWithPriority(priority, fn) {
        var previousPriority = currentUpdatePriority;
        try {
            currentUpdatePriority = priority;
            return fn();
        } finally{
            currentUpdatePriority = previousPriority;
        }
    }
    function higherEventPriority(a, b) {
        return a !== 0 && a < b ? a : b;
    }
    function lowerEventPriority(a, b) {
        return a === 0 || a > b ? a : b;
    }
    function isHigherEventPriority(a, b) {
        return a !== 0 && a < b;
    }
    function lanesToEventPriority(lanes) {
        var lane = getHighestPriorityLane(lanes);
        if (!isHigherEventPriority(DiscreteEventPriority, lane)) return DiscreteEventPriority;
        if (!isHigherEventPriority(ContinuousEventPriority, lane)) return ContinuousEventPriority;
        if (includesNonIdleWork(lane)) return DefaultEventPriority;
        return IdleEventPriority;
    }
    // This is imported by the event replaying implementation in React DOM. It's
    // in a separate file to break a circular dependency between the renderer and
    // the reconciler.
    function isRootDehydrated(root) {
        var currentState = root.current.memoizedState;
        return currentState.isDehydrated;
    }
    var _attemptSynchronousHydration;
    function setAttemptSynchronousHydration(fn) {
        _attemptSynchronousHydration = fn;
    }
    function attemptSynchronousHydration(fiber) {
        _attemptSynchronousHydration(fiber);
    }
    var attemptContinuousHydration;
    function setAttemptContinuousHydration(fn) {
        attemptContinuousHydration = fn;
    }
    var attemptHydrationAtCurrentPriority;
    function setAttemptHydrationAtCurrentPriority(fn) {
        attemptHydrationAtCurrentPriority = fn;
    }
    var getCurrentUpdatePriority$1;
    function setGetCurrentUpdatePriority(fn) {
        getCurrentUpdatePriority$1 = fn;
    }
    var attemptHydrationAtPriority;
    function setAttemptHydrationAtPriority(fn) {
        attemptHydrationAtPriority = fn;
    } // TODO: Upgrade this definition once we're on a newer version of Flow that
    // has this definition built-in.
    var hasScheduledReplayAttempt = false; // The queue of discrete events to be replayed.
    var queuedDiscreteEvents = []; // Indicates if any continuous event targets are non-null for early bailout.
    // if the last target was dehydrated.
    var queuedFocus = null;
    var queuedDrag = null;
    var queuedMouse = null; // For pointer events there can be one latest event per pointerId.
    var queuedPointers = new Map();
    var queuedPointerCaptures = new Map(); // We could consider replaying selectionchange and touchmoves too.
    var queuedExplicitHydrationTargets = [];
    var discreteReplayableEvents = [
        "mousedown",
        "mouseup",
        "touchcancel",
        "touchend",
        "touchstart",
        "auxclick",
        "dblclick",
        "pointercancel",
        "pointerdown",
        "pointerup",
        "dragend",
        "dragstart",
        "drop",
        "compositionend",
        "compositionstart",
        "keydown",
        "keypress",
        "keyup",
        "input",
        "textInput",
        "copy",
        "cut",
        "paste",
        "click",
        "change",
        "contextmenu",
        "reset",
        "submit"
    ];
    function isDiscreteEventThatRequiresHydration(eventType) {
        return discreteReplayableEvents.indexOf(eventType) > -1;
    }
    function createQueuedReplayableEvent(blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent) {
        return {
            blockedOn: blockedOn,
            domEventName: domEventName,
            eventSystemFlags: eventSystemFlags,
            nativeEvent: nativeEvent,
            targetContainers: [
                targetContainer
            ]
        };
    }
    function clearIfContinuousEvent(domEventName, nativeEvent) {
        switch(domEventName){
            case "focusin":
            case "focusout":
                queuedFocus = null;
                break;
            case "dragenter":
            case "dragleave":
                queuedDrag = null;
                break;
            case "mouseover":
            case "mouseout":
                queuedMouse = null;
                break;
            case "pointerover":
            case "pointerout":
                var pointerId = nativeEvent.pointerId;
                queuedPointers.delete(pointerId);
                break;
            case "gotpointercapture":
            case "lostpointercapture":
                var _pointerId = nativeEvent.pointerId;
                queuedPointerCaptures.delete(_pointerId);
                break;
        }
    }
    function accumulateOrCreateContinuousQueuedReplayableEvent(existingQueuedEvent, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent) {
        if (existingQueuedEvent === null || existingQueuedEvent.nativeEvent !== nativeEvent) {
            var queuedEvent = createQueuedReplayableEvent(blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent);
            if (blockedOn !== null) {
                var _fiber2 = getInstanceFromNode(blockedOn);
                if (_fiber2 !== null) // Attempt to increase the priority of this target.
                attemptContinuousHydration(_fiber2);
            }
            return queuedEvent;
        } // If we have already queued this exact event, then it's because
        // the different event systems have different DOM event listeners.
        // We can accumulate the flags, and the targetContainers, and
        // store a single event to be replayed.
        existingQueuedEvent.eventSystemFlags |= eventSystemFlags;
        var targetContainers = existingQueuedEvent.targetContainers;
        if (targetContainer !== null && targetContainers.indexOf(targetContainer) === -1) targetContainers.push(targetContainer);
        return existingQueuedEvent;
    }
    function queueIfContinuousEvent(blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent) {
        // These set relatedTarget to null because the replayed event will be treated as if we
        // moved from outside the window (no target) onto the target once it hydrates.
        // Instead of mutating we could clone the event.
        switch(domEventName){
            case "focusin":
                var focusEvent = nativeEvent;
                queuedFocus = accumulateOrCreateContinuousQueuedReplayableEvent(queuedFocus, blockedOn, domEventName, eventSystemFlags, targetContainer, focusEvent);
                return true;
            case "dragenter":
                var dragEvent = nativeEvent;
                queuedDrag = accumulateOrCreateContinuousQueuedReplayableEvent(queuedDrag, blockedOn, domEventName, eventSystemFlags, targetContainer, dragEvent);
                return true;
            case "mouseover":
                var mouseEvent = nativeEvent;
                queuedMouse = accumulateOrCreateContinuousQueuedReplayableEvent(queuedMouse, blockedOn, domEventName, eventSystemFlags, targetContainer, mouseEvent);
                return true;
            case "pointerover":
                var pointerEvent = nativeEvent;
                var pointerId = pointerEvent.pointerId;
                queuedPointers.set(pointerId, accumulateOrCreateContinuousQueuedReplayableEvent(queuedPointers.get(pointerId) || null, blockedOn, domEventName, eventSystemFlags, targetContainer, pointerEvent));
                return true;
            case "gotpointercapture":
                var _pointerEvent = nativeEvent;
                var _pointerId2 = _pointerEvent.pointerId;
                queuedPointerCaptures.set(_pointerId2, accumulateOrCreateContinuousQueuedReplayableEvent(queuedPointerCaptures.get(_pointerId2) || null, blockedOn, domEventName, eventSystemFlags, targetContainer, _pointerEvent));
                return true;
        }
        return false;
    } // Check if this target is unblocked. Returns true if it's unblocked.
    function attemptExplicitHydrationTarget(queuedTarget) {
        // TODO: This function shares a lot of logic with findInstanceBlockingEvent.
        // Try to unify them. It's a bit tricky since it would require two return
        // values.
        var targetInst = getClosestInstanceFromNode(queuedTarget.target);
        if (targetInst !== null) {
            var nearestMounted = getNearestMountedFiber(targetInst);
            if (nearestMounted !== null) {
                var tag = nearestMounted.tag;
                if (tag === SuspenseComponent) {
                    var instance = getSuspenseInstanceFromFiber(nearestMounted);
                    if (instance !== null) {
                        // We're blocked on hydrating this boundary.
                        // Increase its priority.
                        queuedTarget.blockedOn = instance;
                        attemptHydrationAtPriority(queuedTarget.priority, function() {
                            attemptHydrationAtCurrentPriority(nearestMounted);
                        });
                        return;
                    }
                } else if (tag === HostRoot) {
                    var root = nearestMounted.stateNode;
                    if (isRootDehydrated(root)) {
                        queuedTarget.blockedOn = getContainerFromFiber(nearestMounted); // We don't currently have a way to increase the priority of
                        // a root other than sync.
                        return;
                    }
                }
            }
        }
        queuedTarget.blockedOn = null;
    }
    function queueExplicitHydrationTarget(target) {
        // TODO: This will read the priority if it's dispatched by the React
        // event system but not native events. Should read window.event.type, like
        // we do for updates (getCurrentEventPriority).
        var updatePriority = getCurrentUpdatePriority$1();
        var queuedTarget = {
            blockedOn: null,
            target: target,
            priority: updatePriority
        };
        var i = 0;
        for(; i < queuedExplicitHydrationTargets.length; i++){
            // Stop once we hit the first target with lower priority than
            if (!isHigherEventPriority(updatePriority, queuedExplicitHydrationTargets[i].priority)) break;
        }
        queuedExplicitHydrationTargets.splice(i, 0, queuedTarget);
        if (i === 0) attemptExplicitHydrationTarget(queuedTarget);
    }
    function attemptReplayContinuousQueuedEvent(queuedEvent) {
        if (queuedEvent.blockedOn !== null) return false;
        var targetContainers = queuedEvent.targetContainers;
        while(targetContainers.length > 0){
            var targetContainer = targetContainers[0];
            var nextBlockedOn = findInstanceBlockingEvent(queuedEvent.domEventName, queuedEvent.eventSystemFlags, targetContainer, queuedEvent.nativeEvent);
            if (nextBlockedOn === null) {
                var nativeEvent = queuedEvent.nativeEvent;
                var nativeEventClone = new nativeEvent.constructor(nativeEvent.type, nativeEvent);
                setReplayingEvent(nativeEventClone);
                nativeEvent.target.dispatchEvent(nativeEventClone);
                resetReplayingEvent();
            } else {
                // We're still blocked. Try again later.
                var _fiber3 = getInstanceFromNode(nextBlockedOn);
                if (_fiber3 !== null) attemptContinuousHydration(_fiber3);
                queuedEvent.blockedOn = nextBlockedOn;
                return false;
            } // This target container was successfully dispatched. Try the next.
            targetContainers.shift();
        }
        return true;
    }
    function attemptReplayContinuousQueuedEventInMap(queuedEvent, key, map) {
        if (attemptReplayContinuousQueuedEvent(queuedEvent)) map.delete(key);
    }
    function replayUnblockedEvents() {
        hasScheduledReplayAttempt = false;
        if (queuedFocus !== null && attemptReplayContinuousQueuedEvent(queuedFocus)) queuedFocus = null;
        if (queuedDrag !== null && attemptReplayContinuousQueuedEvent(queuedDrag)) queuedDrag = null;
        if (queuedMouse !== null && attemptReplayContinuousQueuedEvent(queuedMouse)) queuedMouse = null;
        queuedPointers.forEach(attemptReplayContinuousQueuedEventInMap);
        queuedPointerCaptures.forEach(attemptReplayContinuousQueuedEventInMap);
    }
    function scheduleCallbackIfUnblocked(queuedEvent, unblocked) {
        if (queuedEvent.blockedOn === unblocked) {
            queuedEvent.blockedOn = null;
            if (!hasScheduledReplayAttempt) {
                hasScheduledReplayAttempt = true; // Schedule a callback to attempt replaying as many events as are
                // now unblocked. This first might not actually be unblocked yet.
                // We could check it early to avoid scheduling an unnecessary callback.
                Scheduler.unstable_scheduleCallback(Scheduler.unstable_NormalPriority, replayUnblockedEvents);
            }
        }
    }
    function retryIfBlockedOn(unblocked) {
        // Mark anything that was blocked on this as no longer blocked
        // and eligible for a replay.
        if (queuedDiscreteEvents.length > 0) {
            scheduleCallbackIfUnblocked(queuedDiscreteEvents[0], unblocked); // This is a exponential search for each boundary that commits. I think it's
            // worth it because we expect very few discrete events to queue up and once
            // we are actually fully unblocked it will be fast to replay them.
            for(var i = 1; i < queuedDiscreteEvents.length; i++){
                var queuedEvent = queuedDiscreteEvents[i];
                if (queuedEvent.blockedOn === unblocked) queuedEvent.blockedOn = null;
            }
        }
        if (queuedFocus !== null) scheduleCallbackIfUnblocked(queuedFocus, unblocked);
        if (queuedDrag !== null) scheduleCallbackIfUnblocked(queuedDrag, unblocked);
        if (queuedMouse !== null) scheduleCallbackIfUnblocked(queuedMouse, unblocked);
        var unblock = function(queuedEvent) {
            return scheduleCallbackIfUnblocked(queuedEvent, unblocked);
        };
        queuedPointers.forEach(unblock);
        queuedPointerCaptures.forEach(unblock);
        for(var _i = 0; _i < queuedExplicitHydrationTargets.length; _i++){
            var queuedTarget = queuedExplicitHydrationTargets[_i];
            if (queuedTarget.blockedOn === unblocked) queuedTarget.blockedOn = null;
        }
        while(queuedExplicitHydrationTargets.length > 0){
            var nextExplicitTarget = queuedExplicitHydrationTargets[0];
            if (nextExplicitTarget.blockedOn !== null) break;
            else {
                attemptExplicitHydrationTarget(nextExplicitTarget);
                if (nextExplicitTarget.blockedOn === null) // We're unblocked.
                queuedExplicitHydrationTargets.shift();
            }
        }
    }
    var ReactCurrentBatchConfig = ReactSharedInternals.ReactCurrentBatchConfig; // TODO: can we stop exporting these?
    var _enabled = true; // This is exported in FB builds for use by legacy FB layer infra.
    // We'd like to remove this but it's not clear if this is safe.
    function setEnabled(enabled) {
        _enabled = !!enabled;
    }
    function isEnabled() {
        return _enabled;
    }
    function createEventListenerWrapperWithPriority(targetContainer, domEventName, eventSystemFlags) {
        var eventPriority = getEventPriority(domEventName);
        var listenerWrapper;
        switch(eventPriority){
            case DiscreteEventPriority:
                listenerWrapper = dispatchDiscreteEvent;
                break;
            case ContinuousEventPriority:
                listenerWrapper = dispatchContinuousEvent;
                break;
            case DefaultEventPriority:
            default:
                listenerWrapper = dispatchEvent;
                break;
        }
        return listenerWrapper.bind(null, domEventName, eventSystemFlags, targetContainer);
    }
    function dispatchDiscreteEvent(domEventName, eventSystemFlags, container, nativeEvent) {
        var previousPriority = getCurrentUpdatePriority();
        var prevTransition = ReactCurrentBatchConfig.transition;
        ReactCurrentBatchConfig.transition = null;
        try {
            setCurrentUpdatePriority(DiscreteEventPriority);
            dispatchEvent(domEventName, eventSystemFlags, container, nativeEvent);
        } finally{
            setCurrentUpdatePriority(previousPriority);
            ReactCurrentBatchConfig.transition = prevTransition;
        }
    }
    function dispatchContinuousEvent(domEventName, eventSystemFlags, container, nativeEvent) {
        var previousPriority = getCurrentUpdatePriority();
        var prevTransition = ReactCurrentBatchConfig.transition;
        ReactCurrentBatchConfig.transition = null;
        try {
            setCurrentUpdatePriority(ContinuousEventPriority);
            dispatchEvent(domEventName, eventSystemFlags, container, nativeEvent);
        } finally{
            setCurrentUpdatePriority(previousPriority);
            ReactCurrentBatchConfig.transition = prevTransition;
        }
    }
    function dispatchEvent(domEventName, eventSystemFlags, targetContainer, nativeEvent) {
        if (!_enabled) return;
        dispatchEventWithEnableCapturePhaseSelectiveHydrationWithoutDiscreteEventReplay(domEventName, eventSystemFlags, targetContainer, nativeEvent);
    }
    function dispatchEventWithEnableCapturePhaseSelectiveHydrationWithoutDiscreteEventReplay(domEventName, eventSystemFlags, targetContainer, nativeEvent) {
        var blockedOn = findInstanceBlockingEvent(domEventName, eventSystemFlags, targetContainer, nativeEvent);
        if (blockedOn === null) {
            dispatchEventForPluginEventSystem(domEventName, eventSystemFlags, nativeEvent, return_targetInst, targetContainer);
            clearIfContinuousEvent(domEventName, nativeEvent);
            return;
        }
        if (queueIfContinuousEvent(blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent)) {
            nativeEvent.stopPropagation();
            return;
        } // We need to clear only if we didn't queue because
        // queueing is accumulative.
        clearIfContinuousEvent(domEventName, nativeEvent);
        if (eventSystemFlags & IS_CAPTURE_PHASE && isDiscreteEventThatRequiresHydration(domEventName)) {
            while(blockedOn !== null){
                var fiber = getInstanceFromNode(blockedOn);
                if (fiber !== null) attemptSynchronousHydration(fiber);
                var nextBlockedOn = findInstanceBlockingEvent(domEventName, eventSystemFlags, targetContainer, nativeEvent);
                if (nextBlockedOn === null) dispatchEventForPluginEventSystem(domEventName, eventSystemFlags, nativeEvent, return_targetInst, targetContainer);
                if (nextBlockedOn === blockedOn) break;
                blockedOn = nextBlockedOn;
            }
            if (blockedOn !== null) nativeEvent.stopPropagation();
            return;
        } // This is not replayable so we'll invoke it but without a target,
        // in case the event system needs to trace it.
        dispatchEventForPluginEventSystem(domEventName, eventSystemFlags, nativeEvent, null, targetContainer);
    }
    var return_targetInst = null; // Returns a SuspenseInstance or Container if it's blocked.
    // The return_targetInst field above is conceptually part of the return value.
    function findInstanceBlockingEvent(domEventName, eventSystemFlags, targetContainer, nativeEvent) {
        // TODO: Warn if _enabled is false.
        return_targetInst = null;
        var nativeEventTarget = getEventTarget(nativeEvent);
        var targetInst = getClosestInstanceFromNode(nativeEventTarget);
        if (targetInst !== null) {
            var nearestMounted = getNearestMountedFiber(targetInst);
            if (nearestMounted === null) // This tree has been unmounted already. Dispatch without a target.
            targetInst = null;
            else {
                var tag = nearestMounted.tag;
                if (tag === SuspenseComponent) {
                    var instance = getSuspenseInstanceFromFiber(nearestMounted);
                    if (instance !== null) // Queue the event to be replayed later. Abort dispatching since we
                    // don't want this event dispatched twice through the event system.
                    // TODO: If this is the first discrete event in the queue. Schedule an increased
                    // priority for this boundary.
                    return instance;
                     // This shouldn't happen, something went wrong but to avoid blocking
                    // the whole system, dispatch the event without a target.
                    // TODO: Warn.
                    targetInst = null;
                } else if (tag === HostRoot) {
                    var root = nearestMounted.stateNode;
                    if (isRootDehydrated(root)) // If this happens during a replay something went wrong and it might block
                    // the whole system.
                    return getContainerFromFiber(nearestMounted);
                    targetInst = null;
                } else if (nearestMounted !== targetInst) // If we get an event (ex: img onload) before committing that
                // component's mount, ignore it for now (that is, treat it as if it was an
                // event on a non-React tree). We might also consider queueing events and
                // dispatching them after the mount.
                targetInst = null;
            }
        }
        return_targetInst = targetInst; // We're not blocked on anything.
        return null;
    }
    function getEventPriority(domEventName) {
        switch(domEventName){
            // Used by SimpleEventPlugin:
            case "cancel":
            case "click":
            case "close":
            case "contextmenu":
            case "copy":
            case "cut":
            case "auxclick":
            case "dblclick":
            case "dragend":
            case "dragstart":
            case "drop":
            case "focusin":
            case "focusout":
            case "input":
            case "invalid":
            case "keydown":
            case "keypress":
            case "keyup":
            case "mousedown":
            case "mouseup":
            case "paste":
            case "pause":
            case "play":
            case "pointercancel":
            case "pointerdown":
            case "pointerup":
            case "ratechange":
            case "reset":
            case "resize":
            case "seeked":
            case "submit":
            case "touchcancel":
            case "touchend":
            case "touchstart":
            case "volumechange":
            // eslint-disable-next-line no-fallthrough
            case "change":
            case "selectionchange":
            case "textInput":
            case "compositionstart":
            case "compositionend":
            case "compositionupdate":
            // eslint-disable-next-line no-fallthrough
            case "beforeblur":
            case "afterblur":
            // eslint-disable-next-line no-fallthrough
            case "beforeinput":
            case "blur":
            case "fullscreenchange":
            case "focus":
            case "hashchange":
            case "popstate":
            case "select":
            case "selectstart":
                return DiscreteEventPriority;
            case "drag":
            case "dragenter":
            case "dragexit":
            case "dragleave":
            case "dragover":
            case "mousemove":
            case "mouseout":
            case "mouseover":
            case "pointermove":
            case "pointerout":
            case "pointerover":
            case "scroll":
            case "toggle":
            case "touchmove":
            case "wheel":
            // eslint-disable-next-line no-fallthrough
            case "mouseenter":
            case "mouseleave":
            case "pointerenter":
            case "pointerleave":
                return ContinuousEventPriority;
            case "message":
                // We might be in the Scheduler callback.
                // Eventually this mechanism will be replaced by a check
                // of the current priority on the native scheduler.
                var schedulerPriority = getCurrentPriorityLevel();
                switch(schedulerPriority){
                    case ImmediatePriority:
                        return DiscreteEventPriority;
                    case UserBlockingPriority:
                        return ContinuousEventPriority;
                    case NormalPriority:
                    case LowPriority:
                        // TODO: Handle LowSchedulerPriority, somehow. Maybe the same lane as hydration.
                        return DefaultEventPriority;
                    case IdlePriority:
                        return IdleEventPriority;
                    default:
                        return DefaultEventPriority;
                }
            default:
                return DefaultEventPriority;
        }
    }
    function addEventBubbleListener(target, eventType, listener) {
        target.addEventListener(eventType, listener, false);
        return listener;
    }
    function addEventCaptureListener(target, eventType, listener) {
        target.addEventListener(eventType, listener, true);
        return listener;
    }
    function addEventCaptureListenerWithPassiveFlag(target, eventType, listener, passive) {
        target.addEventListener(eventType, listener, {
            capture: true,
            passive: passive
        });
        return listener;
    }
    function addEventBubbleListenerWithPassiveFlag(target, eventType, listener, passive) {
        target.addEventListener(eventType, listener, {
            passive: passive
        });
        return listener;
    }
    /**
 * These variables store information about text content of a target node,
 * allowing comparison of content before and after a given event.
 *
 * Identify the node where selection currently begins, then observe
 * both its text content and its current position in the DOM. Since the
 * browser may natively replace the target node during composition, we can
 * use its position to find its replacement.
 *
 *
 */ var root = null;
    var startText = null;
    var fallbackText = null;
    function initialize(nativeEventTarget) {
        root = nativeEventTarget;
        startText = getText();
        return true;
    }
    function reset() {
        root = null;
        startText = null;
        fallbackText = null;
    }
    function getData() {
        if (fallbackText) return fallbackText;
        var start;
        var startValue = startText;
        var startLength = startValue.length;
        var end;
        var endValue = getText();
        var endLength = endValue.length;
        for(start = 0; start < startLength; start++){
            if (startValue[start] !== endValue[start]) break;
        }
        var minEnd = startLength - start;
        for(end = 1; end <= minEnd; end++){
            if (startValue[startLength - end] !== endValue[endLength - end]) break;
        }
        var sliceTail = end > 1 ? 1 - end : undefined;
        fallbackText = endValue.slice(start, sliceTail);
        return fallbackText;
    }
    function getText() {
        if ("value" in root) return root.value;
        return root.textContent;
    }
    /**
 * `charCode` represents the actual "character code" and is safe to use with
 * `String.fromCharCode`. As such, only keys that correspond to printable
 * characters produce a valid `charCode`, the only exception to this is Enter.
 * The Tab-key is considered non-printable and does not have a `charCode`,
 * presumably because it does not produce a tab-character in browsers.
 *
 * @param {object} nativeEvent Native browser event.
 * @return {number} Normalized `charCode` property.
 */ function getEventCharCode(nativeEvent) {
        var charCode;
        var keyCode = nativeEvent.keyCode;
        if ("charCode" in nativeEvent) {
            charCode = nativeEvent.charCode; // FF does not set `charCode` for the Enter-key, check against `keyCode`.
            if (charCode === 0 && keyCode === 13) charCode = 13;
        } else // IE8 does not implement `charCode`, but `keyCode` has the correct value.
        charCode = keyCode;
         // IE and Edge (on Windows) and Chrome / Safari (on Windows and Linux)
        // report Enter as charCode 10 when ctrl is pressed.
        if (charCode === 10) charCode = 13;
         // Some non-printable keys are reported in `charCode`/`keyCode`, discard them.
        // Must not discard the (non-)printable Enter-key.
        if (charCode >= 32 || charCode === 13) return charCode;
        return 0;
    }
    function functionThatReturnsTrue() {
        return true;
    }
    function functionThatReturnsFalse() {
        return false;
    } // This is intentionally a factory so that we have different returned constructors.
    // If we had a single constructor, it would be megamorphic and engines would deopt.
    function createSyntheticEvent(Interface) {
        /**
   * Synthetic events are dispatched by event plugins, typically in response to a
   * top-level event delegation handler.
   *
   * These systems should generally use pooling to reduce the frequency of garbage
   * collection. The system should check `isPersistent` to determine whether the
   * event should be released into the pool after being dispatched. Users that
   * need a persisted event should invoke `persist`.
   *
   * Synthetic events (and subclasses) implement the DOM Level 3 Events API by
   * normalizing browser quirks. Subclasses do not necessarily have to implement a
   * DOM interface; custom application-specific events can also subclass this.
   */ function SyntheticBaseEvent(reactName, reactEventType, targetInst, nativeEvent, nativeEventTarget) {
            this._reactName = reactName;
            this._targetInst = targetInst;
            this.type = reactEventType;
            this.nativeEvent = nativeEvent;
            this.target = nativeEventTarget;
            this.currentTarget = null;
            for(var _propName in Interface){
                if (!Interface.hasOwnProperty(_propName)) continue;
                var normalize = Interface[_propName];
                if (normalize) this[_propName] = normalize(nativeEvent);
                else this[_propName] = nativeEvent[_propName];
            }
            var defaultPrevented = nativeEvent.defaultPrevented != null ? nativeEvent.defaultPrevented : nativeEvent.returnValue === false;
            if (defaultPrevented) this.isDefaultPrevented = functionThatReturnsTrue;
            else this.isDefaultPrevented = functionThatReturnsFalse;
            this.isPropagationStopped = functionThatReturnsFalse;
            return this;
        }
        assign(SyntheticBaseEvent.prototype, {
            preventDefault: function() {
                this.defaultPrevented = true;
                var event = this.nativeEvent;
                if (!event) return;
                if (event.preventDefault) event.preventDefault(); // $FlowFixMe - flow is not aware of `unknown` in IE
                else if (typeof event.returnValue !== "unknown") event.returnValue = false;
                this.isDefaultPrevented = functionThatReturnsTrue;
            },
            stopPropagation: function() {
                var event = this.nativeEvent;
                if (!event) return;
                if (event.stopPropagation) event.stopPropagation(); // $FlowFixMe - flow is not aware of `unknown` in IE
                else if (typeof event.cancelBubble !== "unknown") // The ChangeEventPlugin registers a "propertychange" event for
                // IE. This event does not support bubbling or cancelling, and
                // any references to cancelBubble throw "Member not found".  A
                // typeof check of "unknown" circumvents this issue (and is also
                // IE specific).
                event.cancelBubble = true;
                this.isPropagationStopped = functionThatReturnsTrue;
            },
            /**
     * We release all dispatched `SyntheticEvent`s after each event loop, adding
     * them back into the pool. This allows a way to hold onto a reference that
     * won't be added back into the pool.
     */ persist: function() {},
            /**
     * Checks if this event should be released back into the pool.
     *
     * @return {boolean} True if this should not be released, false otherwise.
     */ isPersistent: functionThatReturnsTrue
        });
        return SyntheticBaseEvent;
    }
    /**
 * @interface Event
 * @see http://www.w3.org/TR/DOM-Level-3-Events/
 */ var EventInterface = {
        eventPhase: 0,
        bubbles: 0,
        cancelable: 0,
        timeStamp: function(event) {
            return event.timeStamp || Date.now();
        },
        defaultPrevented: 0,
        isTrusted: 0
    };
    var SyntheticEvent = createSyntheticEvent(EventInterface);
    var UIEventInterface = assign({}, EventInterface, {
        view: 0,
        detail: 0
    });
    var SyntheticUIEvent = createSyntheticEvent(UIEventInterface);
    var lastMovementX;
    var lastMovementY;
    var lastMouseEvent;
    function updateMouseMovementPolyfillState(event) {
        if (event !== lastMouseEvent) {
            if (lastMouseEvent && event.type === "mousemove") {
                lastMovementX = event.screenX - lastMouseEvent.screenX;
                lastMovementY = event.screenY - lastMouseEvent.screenY;
            } else {
                lastMovementX = 0;
                lastMovementY = 0;
            }
            lastMouseEvent = event;
        }
    }
    /**
 * @interface MouseEvent
 * @see http://www.w3.org/TR/DOM-Level-3-Events/
 */ var MouseEventInterface = assign({}, UIEventInterface, {
        screenX: 0,
        screenY: 0,
        clientX: 0,
        clientY: 0,
        pageX: 0,
        pageY: 0,
        ctrlKey: 0,
        shiftKey: 0,
        altKey: 0,
        metaKey: 0,
        getModifierState: getEventModifierState,
        button: 0,
        buttons: 0,
        relatedTarget: function(event) {
            if (event.relatedTarget === undefined) return event.fromElement === event.srcElement ? event.toElement : event.fromElement;
            return event.relatedTarget;
        },
        movementX: function(event) {
            if ("movementX" in event) return event.movementX;
            updateMouseMovementPolyfillState(event);
            return lastMovementX;
        },
        movementY: function(event) {
            if ("movementY" in event) return event.movementY;
             // Don't need to call updateMouseMovementPolyfillState() here
            // because it's guaranteed to have already run when movementX
            // was copied.
            return lastMovementY;
        }
    });
    var SyntheticMouseEvent = createSyntheticEvent(MouseEventInterface);
    /**
 * @interface DragEvent
 * @see http://www.w3.org/TR/DOM-Level-3-Events/
 */ var DragEventInterface = assign({}, MouseEventInterface, {
        dataTransfer: 0
    });
    var SyntheticDragEvent = createSyntheticEvent(DragEventInterface);
    /**
 * @interface FocusEvent
 * @see http://www.w3.org/TR/DOM-Level-3-Events/
 */ var FocusEventInterface = assign({}, UIEventInterface, {
        relatedTarget: 0
    });
    var SyntheticFocusEvent = createSyntheticEvent(FocusEventInterface);
    /**
 * @interface Event
 * @see http://www.w3.org/TR/css3-animations/#AnimationEvent-interface
 * @see https://developer.mozilla.org/en-US/docs/Web/API/AnimationEvent
 */ var AnimationEventInterface = assign({}, EventInterface, {
        animationName: 0,
        elapsedTime: 0,
        pseudoElement: 0
    });
    var SyntheticAnimationEvent = createSyntheticEvent(AnimationEventInterface);
    /**
 * @interface Event
 * @see http://www.w3.org/TR/clipboard-apis/
 */ var ClipboardEventInterface = assign({}, EventInterface, {
        clipboardData: function(event) {
            return "clipboardData" in event ? event.clipboardData : window.clipboardData;
        }
    });
    var SyntheticClipboardEvent = createSyntheticEvent(ClipboardEventInterface);
    /**
 * @interface Event
 * @see http://www.w3.org/TR/DOM-Level-3-Events/#events-compositionevents
 */ var CompositionEventInterface = assign({}, EventInterface, {
        data: 0
    });
    var SyntheticCompositionEvent = createSyntheticEvent(CompositionEventInterface);
    /**
 * @interface Event
 * @see http://www.w3.org/TR/2013/WD-DOM-Level-3-Events-20131105
 *      /#events-inputevents
 */ // Happens to share the same list for now.
    var SyntheticInputEvent = SyntheticCompositionEvent;
    /**
 * Normalization of deprecated HTML5 `key` values
 * @see https://developer.mozilla.org/en-US/docs/Web/API/KeyboardEvent#Key_names
 */ var normalizeKey = {
        Esc: "Escape",
        Spacebar: " ",
        Left: "ArrowLeft",
        Up: "ArrowUp",
        Right: "ArrowRight",
        Down: "ArrowDown",
        Del: "Delete",
        Win: "OS",
        Menu: "ContextMenu",
        Apps: "ContextMenu",
        Scroll: "ScrollLock",
        MozPrintableKey: "Unidentified"
    };
    /**
 * Translation from legacy `keyCode` to HTML5 `key`
 * Only special keys supported, all others depend on keyboard layout or browser
 * @see https://developer.mozilla.org/en-US/docs/Web/API/KeyboardEvent#Key_names
 */ var translateToKey = {
        "8": "Backspace",
        "9": "Tab",
        "12": "Clear",
        "13": "Enter",
        "16": "Shift",
        "17": "Control",
        "18": "Alt",
        "19": "Pause",
        "20": "CapsLock",
        "27": "Escape",
        "32": " ",
        "33": "PageUp",
        "34": "PageDown",
        "35": "End",
        "36": "Home",
        "37": "ArrowLeft",
        "38": "ArrowUp",
        "39": "ArrowRight",
        "40": "ArrowDown",
        "45": "Insert",
        "46": "Delete",
        "112": "F1",
        "113": "F2",
        "114": "F3",
        "115": "F4",
        "116": "F5",
        "117": "F6",
        "118": "F7",
        "119": "F8",
        "120": "F9",
        "121": "F10",
        "122": "F11",
        "123": "F12",
        "144": "NumLock",
        "145": "ScrollLock",
        "224": "Meta"
    };
    /**
 * @param {object} nativeEvent Native browser event.
 * @return {string} Normalized `key` property.
 */ function getEventKey(nativeEvent) {
        if (nativeEvent.key) {
            // Normalize inconsistent values reported by browsers due to
            // implementations of a working draft specification.
            // FireFox implements `key` but returns `MozPrintableKey` for all
            // printable characters (normalized to `Unidentified`), ignore it.
            var key = normalizeKey[nativeEvent.key] || nativeEvent.key;
            if (key !== "Unidentified") return key;
        } // Browser does not implement `key`, polyfill as much of it as we can.
        if (nativeEvent.type === "keypress") {
            var charCode = getEventCharCode(nativeEvent); // The enter-key is technically both printable and non-printable and can
            // thus be captured by `keypress`, no other non-printable key should.
            return charCode === 13 ? "Enter" : String.fromCharCode(charCode);
        }
        if (nativeEvent.type === "keydown" || nativeEvent.type === "keyup") // While user keyboard layout determines the actual meaning of each
        // `keyCode` value, almost all function keys have a universal value.
        return translateToKey[nativeEvent.keyCode] || "Unidentified";
        return "";
    }
    /**
 * Translation from modifier key to the associated property in the event.
 * @see http://www.w3.org/TR/DOM-Level-3-Events/#keys-Modifiers
 */ var modifierKeyToProp = {
        Alt: "altKey",
        Control: "ctrlKey",
        Meta: "metaKey",
        Shift: "shiftKey"
    }; // Older browsers (Safari <= 10, iOS Safari <= 10.2) do not support
    // getModifierState. If getModifierState is not supported, we map it to a set of
    // modifier keys exposed by the event. In this case, Lock-keys are not supported.
    function modifierStateGetter(keyArg) {
        var syntheticEvent = this;
        var nativeEvent = syntheticEvent.nativeEvent;
        if (nativeEvent.getModifierState) return nativeEvent.getModifierState(keyArg);
        var keyProp = modifierKeyToProp[keyArg];
        return keyProp ? !!nativeEvent[keyProp] : false;
    }
    function getEventModifierState(nativeEvent) {
        return modifierStateGetter;
    }
    /**
 * @interface KeyboardEvent
 * @see http://www.w3.org/TR/DOM-Level-3-Events/
 */ var KeyboardEventInterface = assign({}, UIEventInterface, {
        key: getEventKey,
        code: 0,
        location: 0,
        ctrlKey: 0,
        shiftKey: 0,
        altKey: 0,
        metaKey: 0,
        repeat: 0,
        locale: 0,
        getModifierState: getEventModifierState,
        // Legacy Interface
        charCode: function(event) {
            // `charCode` is the result of a KeyPress event and represents the value of
            // the actual printable character.
            // KeyPress is deprecated, but its replacement is not yet final and not
            // implemented in any major browser. Only KeyPress has charCode.
            if (event.type === "keypress") return getEventCharCode(event);
            return 0;
        },
        keyCode: function(event) {
            // `keyCode` is the result of a KeyDown/Up event and represents the value of
            // physical keyboard key.
            // The actual meaning of the value depends on the users' keyboard layout
            // which cannot be detected. Assuming that it is a US keyboard layout
            // provides a surprisingly accurate mapping for US and European users.
            // Due to this, it is left to the user to implement at this time.
            if (event.type === "keydown" || event.type === "keyup") return event.keyCode;
            return 0;
        },
        which: function(event) {
            // `which` is an alias for either `keyCode` or `charCode` depending on the
            // type of the event.
            if (event.type === "keypress") return getEventCharCode(event);
            if (event.type === "keydown" || event.type === "keyup") return event.keyCode;
            return 0;
        }
    });
    var SyntheticKeyboardEvent = createSyntheticEvent(KeyboardEventInterface);
    /**
 * @interface PointerEvent
 * @see http://www.w3.org/TR/pointerevents/
 */ var PointerEventInterface = assign({}, MouseEventInterface, {
        pointerId: 0,
        width: 0,
        height: 0,
        pressure: 0,
        tangentialPressure: 0,
        tiltX: 0,
        tiltY: 0,
        twist: 0,
        pointerType: 0,
        isPrimary: 0
    });
    var SyntheticPointerEvent = createSyntheticEvent(PointerEventInterface);
    /**
 * @interface TouchEvent
 * @see http://www.w3.org/TR/touch-events/
 */ var TouchEventInterface = assign({}, UIEventInterface, {
        touches: 0,
        targetTouches: 0,
        changedTouches: 0,
        altKey: 0,
        metaKey: 0,
        ctrlKey: 0,
        shiftKey: 0,
        getModifierState: getEventModifierState
    });
    var SyntheticTouchEvent = createSyntheticEvent(TouchEventInterface);
    /**
 * @interface Event
 * @see http://www.w3.org/TR/2009/WD-css3-transitions-20090320/#transition-events-
 * @see https://developer.mozilla.org/en-US/docs/Web/API/TransitionEvent
 */ var TransitionEventInterface = assign({}, EventInterface, {
        propertyName: 0,
        elapsedTime: 0,
        pseudoElement: 0
    });
    var SyntheticTransitionEvent = createSyntheticEvent(TransitionEventInterface);
    /**
 * @interface WheelEvent
 * @see http://www.w3.org/TR/DOM-Level-3-Events/
 */ var WheelEventInterface = assign({}, MouseEventInterface, {
        deltaX: function(event) {
            return "deltaX" in event ? event.deltaX : "wheelDeltaX" in event ? -event.wheelDeltaX : 0;
        },
        deltaY: function(event) {
            return "deltaY" in event ? event.deltaY : "wheelDeltaY" in event ? -event.wheelDeltaY : "wheelDelta" in event ? -event.wheelDelta : 0;
        },
        deltaZ: 0,
        // Browsers without "deltaMode" is reporting in raw wheel delta where one
        // notch on the scroll is always +/- 120, roughly equivalent to pixels.
        // A good approximation of DOM_DELTA_LINE (1) is 5% of viewport size or
        // ~40 pixels, for DOM_DELTA_SCREEN (2) it is 87.5% of viewport size.
        deltaMode: 0
    });
    var SyntheticWheelEvent = createSyntheticEvent(WheelEventInterface);
    var END_KEYCODES = [
        9,
        13,
        27,
        32
    ]; // Tab, Return, Esc, Space
    var START_KEYCODE = 229;
    var canUseCompositionEvent = canUseDOM && "CompositionEvent" in window;
    var documentMode = null;
    if (canUseDOM && "documentMode" in document) documentMode = document.documentMode;
     // Webkit offers a very useful `textInput` event that can be used to
    // directly represent `beforeInput`. The IE `textinput` event is not as
    // useful, so we don't use it.
    var canUseTextInputEvent = canUseDOM && "TextEvent" in window && !documentMode; // In IE9+, we have access to composition events, but the data supplied
    // by the native compositionend event may be incorrect. Japanese ideographic
    // spaces, for instance (\u3000) are not recorded correctly.
    var useFallbackCompositionData = canUseDOM && (!canUseCompositionEvent || documentMode && documentMode > 8 && documentMode <= 11);
    var SPACEBAR_CODE = 32;
    var SPACEBAR_CHAR = String.fromCharCode(SPACEBAR_CODE);
    function registerEvents() {
        registerTwoPhaseEvent("onBeforeInput", [
            "compositionend",
            "keypress",
            "textInput",
            "paste"
        ]);
        registerTwoPhaseEvent("onCompositionEnd", [
            "compositionend",
            "focusout",
            "keydown",
            "keypress",
            "keyup",
            "mousedown"
        ]);
        registerTwoPhaseEvent("onCompositionStart", [
            "compositionstart",
            "focusout",
            "keydown",
            "keypress",
            "keyup",
            "mousedown"
        ]);
        registerTwoPhaseEvent("onCompositionUpdate", [
            "compositionupdate",
            "focusout",
            "keydown",
            "keypress",
            "keyup",
            "mousedown"
        ]);
    } // Track whether we've ever handled a keypress on the space key.
    var hasSpaceKeypress = false;
    /**
 * Return whether a native keypress event is assumed to be a command.
 * This is required because Firefox fires `keypress` events for key commands
 * (cut, copy, select-all, etc.) even though no character is inserted.
 */ function isKeypressCommand(nativeEvent) {
        return (nativeEvent.ctrlKey || nativeEvent.altKey || nativeEvent.metaKey) && // ctrlKey && altKey is equivalent to AltGr, and is not a command.
        !(nativeEvent.ctrlKey && nativeEvent.altKey);
    }
    /**
 * Translate native top level events into event types.
 */ function getCompositionEventType(domEventName) {
        switch(domEventName){
            case "compositionstart":
                return "onCompositionStart";
            case "compositionend":
                return "onCompositionEnd";
            case "compositionupdate":
                return "onCompositionUpdate";
        }
    }
    /**
 * Does our fallback best-guess model think this event signifies that
 * composition has begun?
 */ function isFallbackCompositionStart(domEventName, nativeEvent) {
        return domEventName === "keydown" && nativeEvent.keyCode === START_KEYCODE;
    }
    /**
 * Does our fallback mode think that this event is the end of composition?
 */ function isFallbackCompositionEnd(domEventName, nativeEvent) {
        switch(domEventName){
            case "keyup":
                // Command keys insert or clear IME input.
                return END_KEYCODES.indexOf(nativeEvent.keyCode) !== -1;
            case "keydown":
                // Expect IME keyCode on each keydown. If we get any other
                // code we must have exited earlier.
                return nativeEvent.keyCode !== START_KEYCODE;
            case "keypress":
            case "mousedown":
            case "focusout":
                // Events are not possible without cancelling IME.
                return true;
            default:
                return false;
        }
    }
    /**
 * Google Input Tools provides composition data via a CustomEvent,
 * with the `data` property populated in the `detail` object. If this
 * is available on the event object, use it. If not, this is a plain
 * composition event and we have nothing special to extract.
 *
 * @param {object} nativeEvent
 * @return {?string}
 */ function getDataFromCustomEvent(nativeEvent) {
        var detail = nativeEvent.detail;
        if (typeof detail === "object" && "data" in detail) return detail.data;
        return null;
    }
    /**
 * Check if a composition event was triggered by Korean IME.
 * Our fallback mode does not work well with IE's Korean IME,
 * so just use native composition events when Korean IME is used.
 * Although CompositionEvent.locale property is deprecated,
 * it is available in IE, where our fallback mode is enabled.
 *
 * @param {object} nativeEvent
 * @return {boolean}
 */ function isUsingKoreanIME(nativeEvent) {
        return nativeEvent.locale === "ko";
    } // Track the current IME composition status, if any.
    var isComposing = false;
    /**
 * @return {?object} A SyntheticCompositionEvent.
 */ function extractCompositionEvent(dispatchQueue, domEventName, targetInst, nativeEvent, nativeEventTarget) {
        var eventType;
        var fallbackData;
        if (canUseCompositionEvent) eventType = getCompositionEventType(domEventName);
        else if (!isComposing) {
            if (isFallbackCompositionStart(domEventName, nativeEvent)) eventType = "onCompositionStart";
        } else if (isFallbackCompositionEnd(domEventName, nativeEvent)) eventType = "onCompositionEnd";
        if (!eventType) return null;
        if (useFallbackCompositionData && !isUsingKoreanIME(nativeEvent)) {
            // The current composition is stored statically and must not be
            // overwritten while composition continues.
            if (!isComposing && eventType === "onCompositionStart") isComposing = initialize(nativeEventTarget);
            else if (eventType === "onCompositionEnd") {
                if (isComposing) fallbackData = getData();
            }
        }
        var listeners = accumulateTwoPhaseListeners(targetInst, eventType);
        if (listeners.length > 0) {
            var event = new SyntheticCompositionEvent(eventType, domEventName, null, nativeEvent, nativeEventTarget);
            dispatchQueue.push({
                event: event,
                listeners: listeners
            });
            if (fallbackData) // Inject data generated from fallback path into the synthetic event.
            // This matches the property of native CompositionEventInterface.
            event.data = fallbackData;
            else {
                var customData = getDataFromCustomEvent(nativeEvent);
                if (customData !== null) event.data = customData;
            }
        }
    }
    function getNativeBeforeInputChars(domEventName, nativeEvent) {
        switch(domEventName){
            case "compositionend":
                return getDataFromCustomEvent(nativeEvent);
            case "keypress":
                /**
       * If native `textInput` events are available, our goal is to make
       * use of them. However, there is a special case: the spacebar key.
       * In Webkit, preventing default on a spacebar `textInput` event
       * cancels character insertion, but it *also* causes the browser
       * to fall back to its default spacebar behavior of scrolling the
       * page.
       *
       * Tracking at:
       * https://code.google.com/p/chromium/issues/detail?id=355103
       *
       * To avoid this issue, use the keypress event as if no `textInput`
       * event is available.
       */ var which = nativeEvent.which;
                if (which !== SPACEBAR_CODE) return null;
                hasSpaceKeypress = true;
                return SPACEBAR_CHAR;
            case "textInput":
                // Record the characters to be added to the DOM.
                var chars = nativeEvent.data; // If it's a spacebar character, assume that we have already handled
                // it at the keypress level and bail immediately. Android Chrome
                // doesn't give us keycodes, so we need to ignore it.
                if (chars === SPACEBAR_CHAR && hasSpaceKeypress) return null;
                return chars;
            default:
                // For other native event types, do nothing.
                return null;
        }
    }
    /**
 * For browsers that do not provide the `textInput` event, extract the
 * appropriate string to use for SyntheticInputEvent.
 */ function getFallbackBeforeInputChars(domEventName, nativeEvent) {
        // If we are currently composing (IME) and using a fallback to do so,
        // try to extract the composed characters from the fallback object.
        // If composition event is available, we extract a string only at
        // compositionevent, otherwise extract it at fallback events.
        if (isComposing) {
            if (domEventName === "compositionend" || !canUseCompositionEvent && isFallbackCompositionEnd(domEventName, nativeEvent)) {
                var chars = getData();
                reset();
                isComposing = false;
                return chars;
            }
            return null;
        }
        switch(domEventName){
            case "paste":
                // If a paste event occurs after a keypress, throw out the input
                // chars. Paste events should not lead to BeforeInput events.
                return null;
            case "keypress":
                /**
       * As of v27, Firefox may fire keypress events even when no character
       * will be inserted. A few possibilities:
       *
       * - `which` is `0`. Arrow keys, Esc key, etc.
       *
       * - `which` is the pressed key code, but no char is available.
       *   Ex: 'AltGr + d` in Polish. There is no modified character for
       *   this key combination and no character is inserted into the
       *   document, but FF fires the keypress for char code `100` anyway.
       *   No `input` event will occur.
       *
       * - `which` is the pressed key code, but a command combination is
       *   being used. Ex: `Cmd+C`. No character is inserted, and no
       *   `input` event will occur.
       */ if (!isKeypressCommand(nativeEvent)) {
                    // IE fires the `keypress` event when a user types an emoji via
                    // Touch keyboard of Windows.  In such a case, the `char` property
                    // holds an emoji character like `\uD83D\uDE0A`.  Because its length
                    // is 2, the property `which` does not represent an emoji correctly.
                    // In such a case, we directly return the `char` property instead of
                    // using `which`.
                    if (nativeEvent.char && nativeEvent.char.length > 1) return nativeEvent.char;
                    else if (nativeEvent.which) return String.fromCharCode(nativeEvent.which);
                }
                return null;
            case "compositionend":
                return useFallbackCompositionData && !isUsingKoreanIME(nativeEvent) ? null : nativeEvent.data;
            default:
                return null;
        }
    }
    /**
 * Extract a SyntheticInputEvent for `beforeInput`, based on either native
 * `textInput` or fallback behavior.
 *
 * @return {?object} A SyntheticInputEvent.
 */ function extractBeforeInputEvent(dispatchQueue, domEventName, targetInst, nativeEvent, nativeEventTarget) {
        var chars;
        if (canUseTextInputEvent) chars = getNativeBeforeInputChars(domEventName, nativeEvent);
        else chars = getFallbackBeforeInputChars(domEventName, nativeEvent);
         // If no characters are being inserted, no BeforeInput event should
        // be fired.
        if (!chars) return null;
        var listeners = accumulateTwoPhaseListeners(targetInst, "onBeforeInput");
        if (listeners.length > 0) {
            var event = new SyntheticInputEvent("onBeforeInput", "beforeinput", null, nativeEvent, nativeEventTarget);
            dispatchQueue.push({
                event: event,
                listeners: listeners
            });
            event.data = chars;
        }
    }
    /**
 * Create an `onBeforeInput` event to match
 * http://www.w3.org/TR/2013/WD-DOM-Level-3-Events-20131105/#events-inputevents.
 *
 * This event plugin is based on the native `textInput` event
 * available in Chrome, Safari, Opera, and IE. This event fires after
 * `onKeyPress` and `onCompositionEnd`, but before `onInput`.
 *
 * `beforeInput` is spec'd but not implemented in any browsers, and
 * the `input` event does not provide any useful information about what has
 * actually been added, contrary to the spec. Thus, `textInput` is the best
 * available event to identify the characters that have actually been inserted
 * into the target node.
 *
 * This plugin is also responsible for emitting `composition` events, thus
 * allowing us to share composition fallback code for both `beforeInput` and
 * `composition` event types.
 */ function extractEvents(dispatchQueue, domEventName, targetInst, nativeEvent, nativeEventTarget, eventSystemFlags, targetContainer) {
        extractCompositionEvent(dispatchQueue, domEventName, targetInst, nativeEvent, nativeEventTarget);
        extractBeforeInputEvent(dispatchQueue, domEventName, targetInst, nativeEvent, nativeEventTarget);
    }
    /**
 * @see http://www.whatwg.org/specs/web-apps/current-work/multipage/the-input-element.html#input-type-attr-summary
 */ var supportedInputTypes = {
        color: true,
        date: true,
        datetime: true,
        "datetime-local": true,
        email: true,
        month: true,
        number: true,
        password: true,
        range: true,
        search: true,
        tel: true,
        text: true,
        time: true,
        url: true,
        week: true
    };
    function isTextInputElement(elem) {
        var nodeName = elem && elem.nodeName && elem.nodeName.toLowerCase();
        if (nodeName === "input") return !!supportedInputTypes[elem.type];
        if (nodeName === "textarea") return true;
        return false;
    }
    /**
 * Checks if an event is supported in the current execution environment.
 *
 * NOTE: This will not work correctly for non-generic events such as `change`,
 * `reset`, `load`, `error`, and `select`.
 *
 * Borrows from Modernizr.
 *
 * @param {string} eventNameSuffix Event name, e.g. "click".
 * @return {boolean} True if the event is supported.
 * @internal
 * @license Modernizr 3.0.0pre (Custom Build) | MIT
 */ function isEventSupported(eventNameSuffix) {
        if (!canUseDOM) return false;
        var eventName = "on" + eventNameSuffix;
        var isSupported = eventName in document;
        if (!isSupported) {
            var element = document.createElement("div");
            element.setAttribute(eventName, "return;");
            isSupported = typeof element[eventName] === "function";
        }
        return isSupported;
    }
    function registerEvents$1() {
        registerTwoPhaseEvent("onChange", [
            "change",
            "click",
            "focusin",
            "focusout",
            "input",
            "keydown",
            "keyup",
            "selectionchange"
        ]);
    }
    function createAndAccumulateChangeEvent(dispatchQueue, inst, nativeEvent, target) {
        // Flag this event loop as needing state restore.
        enqueueStateRestore(target);
        var listeners = accumulateTwoPhaseListeners(inst, "onChange");
        if (listeners.length > 0) {
            var event = new SyntheticEvent("onChange", "change", null, nativeEvent, target);
            dispatchQueue.push({
                event: event,
                listeners: listeners
            });
        }
    }
    /**
 * For IE shims
 */ var activeElement = null;
    var activeElementInst = null;
    /**
 * SECTION: handle `change` event
 */ function shouldUseChangeEvent(elem) {
        var nodeName = elem.nodeName && elem.nodeName.toLowerCase();
        return nodeName === "select" || nodeName === "input" && elem.type === "file";
    }
    function manualDispatchChangeEvent(nativeEvent) {
        var dispatchQueue = [];
        createAndAccumulateChangeEvent(dispatchQueue, activeElementInst, nativeEvent, getEventTarget(nativeEvent)); // If change and propertychange bubbled, we'd just bind to it like all the
        // other events and have it go through ReactBrowserEventEmitter. Since it
        // doesn't, we manually listen for the events and so we have to enqueue and
        // process the abstract event manually.
        //
        // Batching is necessary here in order to ensure that all event handlers run
        // before the next rerender (including event handlers attached to ancestor
        // elements instead of directly on the input). Without this, controlled
        // components don't work properly in conjunction with event bubbling because
        // the component is rerendered and the value reverted before all the event
        // handlers can run. See https://github.com/facebook/react/issues/708.
        batchedUpdates(runEventInBatch, dispatchQueue);
    }
    function runEventInBatch(dispatchQueue) {
        processDispatchQueue(dispatchQueue, 0);
    }
    function getInstIfValueChanged(targetInst) {
        var targetNode = getNodeFromInstance(targetInst);
        if (updateValueIfChanged(targetNode)) return targetInst;
    }
    function getTargetInstForChangeEvent(domEventName, targetInst) {
        if (domEventName === "change") return targetInst;
    }
    /**
 * SECTION: handle `input` event
 */ var isInputEventSupported = false;
    if (canUseDOM) // IE9 claims to support the input event but fails to trigger it when
    // deleting text, so we ignore its input events.
    isInputEventSupported = isEventSupported("input") && (!document.documentMode || document.documentMode > 9);
    /**
 * (For IE <=9) Starts tracking propertychange events on the passed-in element
 * and override the value property so that we can distinguish user events from
 * value changes in JS.
 */ function startWatchingForValueChange(target, targetInst) {
        activeElement = target;
        activeElementInst = targetInst;
        activeElement.attachEvent("onpropertychange", handlePropertyChange);
    }
    /**
 * (For IE <=9) Removes the event listeners from the currently-tracked element,
 * if any exists.
 */ function stopWatchingForValueChange() {
        if (!activeElement) return;
        activeElement.detachEvent("onpropertychange", handlePropertyChange);
        activeElement = null;
        activeElementInst = null;
    }
    /**
 * (For IE <=9) Handles a propertychange event, sending a `change` event if
 * the value of the active element has changed.
 */ function handlePropertyChange(nativeEvent) {
        if (nativeEvent.propertyName !== "value") return;
        if (getInstIfValueChanged(activeElementInst)) manualDispatchChangeEvent(nativeEvent);
    }
    function handleEventsForInputEventPolyfill(domEventName, target, targetInst) {
        if (domEventName === "focusin") {
            // In IE9, propertychange fires for most input events but is buggy and
            // doesn't fire when text is deleted, but conveniently, selectionchange
            // appears to fire in all of the remaining cases so we catch those and
            // forward the event if the value has changed
            // In either case, we don't want to call the event handler if the value
            // is changed from JS so we redefine a setter for `.value` that updates
            // our activeElementValue variable, allowing us to ignore those changes
            //
            // stopWatching() should be a noop here but we call it just in case we
            // missed a blur event somehow.
            stopWatchingForValueChange();
            startWatchingForValueChange(target, targetInst);
        } else if (domEventName === "focusout") stopWatchingForValueChange();
    } // For IE8 and IE9.
    function getTargetInstForInputEventPolyfill(domEventName, targetInst) {
        if (domEventName === "selectionchange" || domEventName === "keyup" || domEventName === "keydown") // On the selectionchange event, the target is just document which isn't
        // helpful for us so just check activeElement instead.
        //
        // 99% of the time, keydown and keyup aren't necessary. IE8 fails to fire
        // propertychange on the first input event after setting `value` from a
        // script and fires only keydown, keypress, keyup. Catching keyup usually
        // gets it and catching keydown lets us fire an event for the first
        // keystroke if user does a key repeat (it'll be a little delayed: right
        // before the second keystroke). Other input methods (e.g., paste) seem to
        // fire selectionchange normally.
        return getInstIfValueChanged(activeElementInst);
    }
    /**
 * SECTION: handle `click` event
 */ function shouldUseClickEvent(elem) {
        // Use the `click` event to detect changes to checkbox and radio inputs.
        // This approach works across all browsers, whereas `change` does not fire
        // until `blur` in IE8.
        var nodeName = elem.nodeName;
        return nodeName && nodeName.toLowerCase() === "input" && (elem.type === "checkbox" || elem.type === "radio");
    }
    function getTargetInstForClickEvent(domEventName, targetInst) {
        if (domEventName === "click") return getInstIfValueChanged(targetInst);
    }
    function getTargetInstForInputOrChangeEvent(domEventName, targetInst) {
        if (domEventName === "input" || domEventName === "change") return getInstIfValueChanged(targetInst);
    }
    function handleControlledInputBlur(node) {
        var state = node._wrapperState;
        if (!state || !state.controlled || node.type !== "number") return;
        // If controlled, assign the value attribute to the current value on blur
        setDefaultValue(node, "number", node.value);
    }
    /**
 * This plugin creates an `onChange` event that normalizes change events
 * across form elements. This event fires at a time when it's possible to
 * change the element's value without seeing a flicker.
 *
 * Supported elements are:
 * - input (see `isTextInputElement`)
 * - textarea
 * - select
 */ function extractEvents$1(dispatchQueue, domEventName, targetInst, nativeEvent, nativeEventTarget, eventSystemFlags, targetContainer) {
        var targetNode = targetInst ? getNodeFromInstance(targetInst) : window;
        var getTargetInstFunc, handleEventFunc;
        if (shouldUseChangeEvent(targetNode)) getTargetInstFunc = getTargetInstForChangeEvent;
        else if (isTextInputElement(targetNode)) {
            if (isInputEventSupported) getTargetInstFunc = getTargetInstForInputOrChangeEvent;
            else {
                getTargetInstFunc = getTargetInstForInputEventPolyfill;
                handleEventFunc = handleEventsForInputEventPolyfill;
            }
        } else if (shouldUseClickEvent(targetNode)) getTargetInstFunc = getTargetInstForClickEvent;
        if (getTargetInstFunc) {
            var inst = getTargetInstFunc(domEventName, targetInst);
            if (inst) {
                createAndAccumulateChangeEvent(dispatchQueue, inst, nativeEvent, nativeEventTarget);
                return;
            }
        }
        if (handleEventFunc) handleEventFunc(domEventName, targetNode, targetInst);
         // When blurring, set the value attribute for number inputs
        if (domEventName === "focusout") handleControlledInputBlur(targetNode);
    }
    function registerEvents$2() {
        registerDirectEvent("onMouseEnter", [
            "mouseout",
            "mouseover"
        ]);
        registerDirectEvent("onMouseLeave", [
            "mouseout",
            "mouseover"
        ]);
        registerDirectEvent("onPointerEnter", [
            "pointerout",
            "pointerover"
        ]);
        registerDirectEvent("onPointerLeave", [
            "pointerout",
            "pointerover"
        ]);
    }
    /**
 * For almost every interaction we care about, there will be both a top-level
 * `mouseover` and `mouseout` event that occurs. Only use `mouseout` so that
 * we do not extract duplicate events. However, moving the mouse into the
 * browser from outside will not fire a `mouseout` event. In this case, we use
 * the `mouseover` top-level event.
 */ function extractEvents$2(dispatchQueue, domEventName, targetInst, nativeEvent, nativeEventTarget, eventSystemFlags, targetContainer) {
        var isOverEvent = domEventName === "mouseover" || domEventName === "pointerover";
        var isOutEvent = domEventName === "mouseout" || domEventName === "pointerout";
        if (isOverEvent && !isReplayingEvent(nativeEvent)) {
            // If this is an over event with a target, we might have already dispatched
            // the event in the out event of the other target. If this is replayed,
            // then it's because we couldn't dispatch against this target previously
            // so we have to do it now instead.
            var related = nativeEvent.relatedTarget || nativeEvent.fromElement;
            if (related) {
                // If the related node is managed by React, we can assume that we have
                // already dispatched the corresponding events during its mouseout.
                if (getClosestInstanceFromNode(related) || isContainerMarkedAsRoot(related)) return;
            }
        }
        if (!isOutEvent && !isOverEvent) // Must not be a mouse or pointer in or out - ignoring.
        return;
        var win; // TODO: why is this nullable in the types but we read from it?
        if (nativeEventTarget.window === nativeEventTarget) // `nativeEventTarget` is probably a window object.
        win = nativeEventTarget;
        else {
            // TODO: Figure out why `ownerDocument` is sometimes undefined in IE8.
            var doc = nativeEventTarget.ownerDocument;
            if (doc) win = doc.defaultView || doc.parentWindow;
            else win = window;
        }
        var from;
        var to;
        if (isOutEvent) {
            var _related = nativeEvent.relatedTarget || nativeEvent.toElement;
            from = targetInst;
            to = _related ? getClosestInstanceFromNode(_related) : null;
            if (to !== null) {
                var nearestMounted = getNearestMountedFiber(to);
                if (to !== nearestMounted || to.tag !== HostComponent && to.tag !== HostText) to = null;
            }
        } else {
            // Moving to a node from outside the window.
            from = null;
            to = targetInst;
        }
        if (from === to) // Nothing pertains to our managed components.
        return;
        var SyntheticEventCtor = SyntheticMouseEvent;
        var leaveEventType = "onMouseLeave";
        var enterEventType = "onMouseEnter";
        var eventTypePrefix = "mouse";
        if (domEventName === "pointerout" || domEventName === "pointerover") {
            SyntheticEventCtor = SyntheticPointerEvent;
            leaveEventType = "onPointerLeave";
            enterEventType = "onPointerEnter";
            eventTypePrefix = "pointer";
        }
        var fromNode = from == null ? win : getNodeFromInstance(from);
        var toNode = to == null ? win : getNodeFromInstance(to);
        var leave = new SyntheticEventCtor(leaveEventType, eventTypePrefix + "leave", from, nativeEvent, nativeEventTarget);
        leave.target = fromNode;
        leave.relatedTarget = toNode;
        var enter = null; // We should only process this nativeEvent if we are processing
        // the first ancestor. Next time, we will ignore the event.
        var nativeTargetInst = getClosestInstanceFromNode(nativeEventTarget);
        if (nativeTargetInst === targetInst) {
            var enterEvent = new SyntheticEventCtor(enterEventType, eventTypePrefix + "enter", to, nativeEvent, nativeEventTarget);
            enterEvent.target = toNode;
            enterEvent.relatedTarget = fromNode;
            enter = enterEvent;
        }
        accumulateEnterLeaveTwoPhaseListeners(dispatchQueue, leave, enter, from, to);
    }
    /**
 * inlined Object.is polyfill to avoid requiring consumers ship their own
 * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
 */ function is(x, y) {
        return x === y && (x !== 0 || 1 / x === 1 / y) || x !== x && y !== y // eslint-disable-line no-self-compare
        ;
    }
    var objectIs = typeof Object.is === "function" ? Object.is : is;
    /**
 * Performs equality by iterating through keys on an object and returning false
 * when any key has values which are not strictly equal between the arguments.
 * Returns true when the values of all keys are strictly equal.
 */ function shallowEqual(objA, objB) {
        if (objectIs(objA, objB)) return true;
        if (typeof objA !== "object" || objA === null || typeof objB !== "object" || objB === null) return false;
        var keysA = Object.keys(objA);
        var keysB = Object.keys(objB);
        if (keysA.length !== keysB.length) return false;
         // Test for A's keys different from B.
        for(var i = 0; i < keysA.length; i++){
            var currentKey = keysA[i];
            if (!hasOwnProperty.call(objB, currentKey) || !objectIs(objA[currentKey], objB[currentKey])) return false;
        }
        return true;
    }
    /**
 * Given any node return the first leaf node without children.
 *
 * @param {DOMElement|DOMTextNode} node
 * @return {DOMElement|DOMTextNode}
 */ function getLeafNode(node) {
        while(node && node.firstChild)node = node.firstChild;
        return node;
    }
    /**
 * Get the next sibling within a container. This will walk up the
 * DOM if a node's siblings have been exhausted.
 *
 * @param {DOMElement|DOMTextNode} node
 * @return {?DOMElement|DOMTextNode}
 */ function getSiblingNode(node) {
        while(node){
            if (node.nextSibling) return node.nextSibling;
            node = node.parentNode;
        }
    }
    /**
 * Get object describing the nodes which contain characters at offset.
 *
 * @param {DOMElement|DOMTextNode} root
 * @param {number} offset
 * @return {?object}
 */ function getNodeForCharacterOffset(root, offset) {
        var node = getLeafNode(root);
        var nodeStart = 0;
        var nodeEnd = 0;
        while(node){
            if (node.nodeType === TEXT_NODE) {
                nodeEnd = nodeStart + node.textContent.length;
                if (nodeStart <= offset && nodeEnd >= offset) return {
                    node: node,
                    offset: offset - nodeStart
                };
                nodeStart = nodeEnd;
            }
            node = getLeafNode(getSiblingNode(node));
        }
    }
    /**
 * @param {DOMElement} outerNode
 * @return {?object}
 */ function getOffsets(outerNode) {
        var ownerDocument = outerNode.ownerDocument;
        var win = ownerDocument && ownerDocument.defaultView || window;
        var selection = win.getSelection && win.getSelection();
        if (!selection || selection.rangeCount === 0) return null;
        var anchorNode = selection.anchorNode, anchorOffset = selection.anchorOffset, focusNode = selection.focusNode, focusOffset = selection.focusOffset; // In Firefox, anchorNode and focusNode can be "anonymous divs", e.g. the
        // up/down buttons on an <input type="number">. Anonymous divs do not seem to
        // expose properties, triggering a "Permission denied error" if any of its
        // properties are accessed. The only seemingly possible way to avoid erroring
        // is to access a property that typically works for non-anonymous divs and
        // catch any error that may otherwise arise. See
        // https://bugzilla.mozilla.org/show_bug.cgi?id=208427
        try {
            /* eslint-disable no-unused-expressions */ anchorNode.nodeType;
            focusNode.nodeType;
        /* eslint-enable no-unused-expressions */ } catch (e) {
            return null;
        }
        return getModernOffsetsFromPoints(outerNode, anchorNode, anchorOffset, focusNode, focusOffset);
    }
    /**
 * Returns {start, end} where `start` is the character/codepoint index of
 * (anchorNode, anchorOffset) within the textContent of `outerNode`, and
 * `end` is the index of (focusNode, focusOffset).
 *
 * Returns null if you pass in garbage input but we should probably just crash.
 *
 * Exported only for testing.
 */ function getModernOffsetsFromPoints(outerNode, anchorNode, anchorOffset, focusNode, focusOffset) {
        var length = 0;
        var start = -1;
        var end = -1;
        var indexWithinAnchor = 0;
        var indexWithinFocus = 0;
        var node = outerNode;
        var parentNode = null;
        outer: while(true){
            var next = null;
            while(true){
                if (node === anchorNode && (anchorOffset === 0 || node.nodeType === TEXT_NODE)) start = length + anchorOffset;
                if (node === focusNode && (focusOffset === 0 || node.nodeType === TEXT_NODE)) end = length + focusOffset;
                if (node.nodeType === TEXT_NODE) length += node.nodeValue.length;
                if ((next = node.firstChild) === null) break;
                 // Moving from `node` to its first child `next`.
                parentNode = node;
                node = next;
            }
            while(true){
                if (node === outerNode) break outer;
                if (parentNode === anchorNode && ++indexWithinAnchor === anchorOffset) start = length;
                if (parentNode === focusNode && ++indexWithinFocus === focusOffset) end = length;
                if ((next = node.nextSibling) !== null) break;
                node = parentNode;
                parentNode = node.parentNode;
            } // Moving from `node` to its next sibling `next`.
            node = next;
        }
        if (start === -1 || end === -1) // This should never happen. (Would happen if the anchor/focus nodes aren't
        // actually inside the passed-in node.)
        return null;
        return {
            start: start,
            end: end
        };
    }
    /**
 * In modern non-IE browsers, we can support both forward and backward
 * selections.
 *
 * Note: IE10+ supports the Selection object, but it does not support
 * the `extend` method, which means that even in modern IE, it's not possible
 * to programmatically create a backward selection. Thus, for all IE
 * versions, we use the old IE API to create our selections.
 *
 * @param {DOMElement|DOMTextNode} node
 * @param {object} offsets
 */ function setOffsets(node, offsets) {
        var doc = node.ownerDocument || document;
        var win = doc && doc.defaultView || window; // Edge fails with "Object expected" in some scenarios.
        // (For instance: TinyMCE editor used in a list component that supports pasting to add more,
        // fails when pasting 100+ items)
        if (!win.getSelection) return;
        var selection = win.getSelection();
        var length = node.textContent.length;
        var start = Math.min(offsets.start, length);
        var end = offsets.end === undefined ? start : Math.min(offsets.end, length); // IE 11 uses modern selection, but doesn't support the extend method.
        // Flip backward selections, so we can set with a single range.
        if (!selection.extend && start > end) {
            var temp = end;
            end = start;
            start = temp;
        }
        var startMarker = getNodeForCharacterOffset(node, start);
        var endMarker = getNodeForCharacterOffset(node, end);
        if (startMarker && endMarker) {
            if (selection.rangeCount === 1 && selection.anchorNode === startMarker.node && selection.anchorOffset === startMarker.offset && selection.focusNode === endMarker.node && selection.focusOffset === endMarker.offset) return;
            var range = doc.createRange();
            range.setStart(startMarker.node, startMarker.offset);
            selection.removeAllRanges();
            if (start > end) {
                selection.addRange(range);
                selection.extend(endMarker.node, endMarker.offset);
            } else {
                range.setEnd(endMarker.node, endMarker.offset);
                selection.addRange(range);
            }
        }
    }
    function isTextNode(node) {
        return node && node.nodeType === TEXT_NODE;
    }
    function containsNode(outerNode, innerNode) {
        if (!outerNode || !innerNode) return false;
        else if (outerNode === innerNode) return true;
        else if (isTextNode(outerNode)) return false;
        else if (isTextNode(innerNode)) return containsNode(outerNode, innerNode.parentNode);
        else if ("contains" in outerNode) return outerNode.contains(innerNode);
        else if (outerNode.compareDocumentPosition) return !!(outerNode.compareDocumentPosition(innerNode) & 16);
        else return false;
    }
    function isInDocument(node) {
        return node && node.ownerDocument && containsNode(node.ownerDocument.documentElement, node);
    }
    function isSameOriginFrame(iframe) {
        try {
            // Accessing the contentDocument of a HTMLIframeElement can cause the browser
            // to throw, e.g. if it has a cross-origin src attribute.
            // Safari will show an error in the console when the access results in "Blocked a frame with origin". e.g:
            // iframe.contentDocument.defaultView;
            // A safety way is to access one of the cross origin properties: Window or Location
            // Which might result in "SecurityError" DOM Exception and it is compatible to Safari.
            // https://html.spec.whatwg.org/multipage/browsers.html#integration-with-idl
            return typeof iframe.contentWindow.location.href === "string";
        } catch (err) {
            return false;
        }
    }
    function getActiveElementDeep() {
        var win = window;
        var element = getActiveElement();
        while(element instanceof win.HTMLIFrameElement){
            if (isSameOriginFrame(element)) win = element.contentWindow;
            else return element;
            element = getActiveElement(win.document);
        }
        return element;
    }
    /**
 * @ReactInputSelection: React input selection module. Based on Selection.js,
 * but modified to be suitable for react and has a couple of bug fixes (doesn't
 * assume buttons have range selections allowed).
 * Input selection module for React.
 */ /**
 * @hasSelectionCapabilities: we get the element types that support selection
 * from https://html.spec.whatwg.org/#do-not-apply, looking at `selectionStart`
 * and `selectionEnd` rows.
 */ function hasSelectionCapabilities(elem) {
        var nodeName = elem && elem.nodeName && elem.nodeName.toLowerCase();
        return nodeName && (nodeName === "input" && (elem.type === "text" || elem.type === "search" || elem.type === "tel" || elem.type === "url" || elem.type === "password") || nodeName === "textarea" || elem.contentEditable === "true");
    }
    function getSelectionInformation() {
        var focusedElem = getActiveElementDeep();
        return {
            focusedElem: focusedElem,
            selectionRange: hasSelectionCapabilities(focusedElem) ? getSelection(focusedElem) : null
        };
    }
    /**
 * @restoreSelection: If any selection information was potentially lost,
 * restore it. This is useful when performing operations that could remove dom
 * nodes and place them back in, resulting in focus being lost.
 */ function restoreSelection(priorSelectionInformation) {
        var curFocusedElem = getActiveElementDeep();
        var priorFocusedElem = priorSelectionInformation.focusedElem;
        var priorSelectionRange = priorSelectionInformation.selectionRange;
        if (curFocusedElem !== priorFocusedElem && isInDocument(priorFocusedElem)) {
            if (priorSelectionRange !== null && hasSelectionCapabilities(priorFocusedElem)) setSelection(priorFocusedElem, priorSelectionRange);
             // Focusing a node can change the scroll position, which is undesirable
            var ancestors = [];
            var ancestor = priorFocusedElem;
            while(ancestor = ancestor.parentNode)if (ancestor.nodeType === ELEMENT_NODE) ancestors.push({
                element: ancestor,
                left: ancestor.scrollLeft,
                top: ancestor.scrollTop
            });
            if (typeof priorFocusedElem.focus === "function") priorFocusedElem.focus();
            for(var i = 0; i < ancestors.length; i++){
                var info = ancestors[i];
                info.element.scrollLeft = info.left;
                info.element.scrollTop = info.top;
            }
        }
    }
    /**
 * @getSelection: Gets the selection bounds of a focused textarea, input or
 * contentEditable node.
 * -@input: Look up selection bounds of this input
 * -@return {start: selectionStart, end: selectionEnd}
 */ function getSelection(input) {
        var selection;
        if ("selectionStart" in input) // Modern browser with input or textarea.
        selection = {
            start: input.selectionStart,
            end: input.selectionEnd
        };
        else // Content editable or old IE textarea.
        selection = getOffsets(input);
        return selection || {
            start: 0,
            end: 0
        };
    }
    /**
 * @setSelection: Sets the selection bounds of a textarea or input and focuses
 * the input.
 * -@input     Set selection bounds of this input or textarea
 * -@offsets   Object of same form that is returned from get*
 */ function setSelection(input, offsets) {
        var start = offsets.start;
        var end = offsets.end;
        if (end === undefined) end = start;
        if ("selectionStart" in input) {
            input.selectionStart = start;
            input.selectionEnd = Math.min(end, input.value.length);
        } else setOffsets(input, offsets);
    }
    var skipSelectionChangeEvent = canUseDOM && "documentMode" in document && document.documentMode <= 11;
    function registerEvents$3() {
        registerTwoPhaseEvent("onSelect", [
            "focusout",
            "contextmenu",
            "dragend",
            "focusin",
            "keydown",
            "keyup",
            "mousedown",
            "mouseup",
            "selectionchange"
        ]);
    }
    var activeElement$1 = null;
    var activeElementInst$1 = null;
    var lastSelection = null;
    var mouseDown = false;
    /**
 * Get an object which is a unique representation of the current selection.
 *
 * The return value will not be consistent across nodes or browsers, but
 * two identical selections on the same node will return identical objects.
 */ function getSelection$1(node) {
        if ("selectionStart" in node && hasSelectionCapabilities(node)) return {
            start: node.selectionStart,
            end: node.selectionEnd
        };
        else {
            var win = node.ownerDocument && node.ownerDocument.defaultView || window;
            var selection = win.getSelection();
            return {
                anchorNode: selection.anchorNode,
                anchorOffset: selection.anchorOffset,
                focusNode: selection.focusNode,
                focusOffset: selection.focusOffset
            };
        }
    }
    /**
 * Get document associated with the event target.
 */ function getEventTargetDocument(eventTarget) {
        return eventTarget.window === eventTarget ? eventTarget.document : eventTarget.nodeType === DOCUMENT_NODE ? eventTarget : eventTarget.ownerDocument;
    }
    /**
 * Poll selection to see whether it's changed.
 *
 * @param {object} nativeEvent
 * @param {object} nativeEventTarget
 * @return {?SyntheticEvent}
 */ function constructSelectEvent(dispatchQueue, nativeEvent, nativeEventTarget) {
        // Ensure we have the right element, and that the user is not dragging a
        // selection (this matches native `select` event behavior). In HTML5, select
        // fires only on input and textarea thus if there's no focused element we
        // won't dispatch.
        var doc = getEventTargetDocument(nativeEventTarget);
        if (mouseDown || activeElement$1 == null || activeElement$1 !== getActiveElement(doc)) return;
         // Only fire when selection has actually changed.
        var currentSelection = getSelection$1(activeElement$1);
        if (!lastSelection || !shallowEqual(lastSelection, currentSelection)) {
            lastSelection = currentSelection;
            var listeners = accumulateTwoPhaseListeners(activeElementInst$1, "onSelect");
            if (listeners.length > 0) {
                var event = new SyntheticEvent("onSelect", "select", null, nativeEvent, nativeEventTarget);
                dispatchQueue.push({
                    event: event,
                    listeners: listeners
                });
                event.target = activeElement$1;
            }
        }
    }
    /**
 * This plugin creates an `onSelect` event that normalizes select events
 * across form elements.
 *
 * Supported elements are:
 * - input (see `isTextInputElement`)
 * - textarea
 * - contentEditable
 *
 * This differs from native browser implementations in the following ways:
 * - Fires on contentEditable fields as well as inputs.
 * - Fires for collapsed selection.
 * - Fires after user input.
 */ function extractEvents$3(dispatchQueue, domEventName, targetInst, nativeEvent, nativeEventTarget, eventSystemFlags, targetContainer) {
        var targetNode = targetInst ? getNodeFromInstance(targetInst) : window;
        switch(domEventName){
            // Track the input node that has focus.
            case "focusin":
                if (isTextInputElement(targetNode) || targetNode.contentEditable === "true") {
                    activeElement$1 = targetNode;
                    activeElementInst$1 = targetInst;
                    lastSelection = null;
                }
                break;
            case "focusout":
                activeElement$1 = null;
                activeElementInst$1 = null;
                lastSelection = null;
                break;
            // Don't fire the event while the user is dragging. This matches the
            // semantics of the native select event.
            case "mousedown":
                mouseDown = true;
                break;
            case "contextmenu":
            case "mouseup":
            case "dragend":
                mouseDown = false;
                constructSelectEvent(dispatchQueue, nativeEvent, nativeEventTarget);
                break;
            // Chrome and IE fire non-standard event when selection is changed (and
            // sometimes when it hasn't). IE's event fires out of order with respect
            // to key and input events on deletion, so we discard it.
            //
            // Firefox doesn't support selectionchange, so check selection status
            // after each key entry. The selection changes after keydown and before
            // keyup, but we check on keydown as well in the case of holding down a
            // key, when multiple keydown events are fired but only one keyup is.
            // This is also our approach for IE handling, for the reason above.
            case "selectionchange":
                if (skipSelectionChangeEvent) break;
            // falls through
            case "keydown":
            case "keyup":
                constructSelectEvent(dispatchQueue, nativeEvent, nativeEventTarget);
        }
    }
    /**
 * Generate a mapping of standard vendor prefixes using the defined style property and event name.
 *
 * @param {string} styleProp
 * @param {string} eventName
 * @returns {object}
 */ function makePrefixMap(styleProp, eventName) {
        var prefixes = {};
        prefixes[styleProp.toLowerCase()] = eventName.toLowerCase();
        prefixes["Webkit" + styleProp] = "webkit" + eventName;
        prefixes["Moz" + styleProp] = "moz" + eventName;
        return prefixes;
    }
    /**
 * A list of event names to a configurable list of vendor prefixes.
 */ var vendorPrefixes = {
        animationend: makePrefixMap("Animation", "AnimationEnd"),
        animationiteration: makePrefixMap("Animation", "AnimationIteration"),
        animationstart: makePrefixMap("Animation", "AnimationStart"),
        transitionend: makePrefixMap("Transition", "TransitionEnd")
    };
    /**
 * Event names that have already been detected and prefixed (if applicable).
 */ var prefixedEventNames = {};
    /**
 * Element to check for prefixes on.
 */ var style = {};
    /**
 * Bootstrap if a DOM exists.
 */ if (canUseDOM) {
        style = document.createElement("div").style; // On some platforms, in particular some releases of Android 4.x,
        // the un-prefixed "animation" and "transition" properties are defined on the
        // style object but the events that fire will still be prefixed, so we need
        // to check if the un-prefixed events are usable, and if not remove them from the map.
        if (!("AnimationEvent" in window)) {
            delete vendorPrefixes.animationend.animation;
            delete vendorPrefixes.animationiteration.animation;
            delete vendorPrefixes.animationstart.animation;
        } // Same as above
        if (!("TransitionEvent" in window)) delete vendorPrefixes.transitionend.transition;
    }
    /**
 * Attempts to determine the correct vendor prefixed event name.
 *
 * @param {string} eventName
 * @returns {string}
 */ function getVendorPrefixedEventName(eventName) {
        if (prefixedEventNames[eventName]) return prefixedEventNames[eventName];
        else if (!vendorPrefixes[eventName]) return eventName;
        var prefixMap = vendorPrefixes[eventName];
        for(var styleProp in prefixMap){
            if (prefixMap.hasOwnProperty(styleProp) && styleProp in style) return prefixedEventNames[eventName] = prefixMap[styleProp];
        }
        return eventName;
    }
    var ANIMATION_END = getVendorPrefixedEventName("animationend");
    var ANIMATION_ITERATION = getVendorPrefixedEventName("animationiteration");
    var ANIMATION_START = getVendorPrefixedEventName("animationstart");
    var TRANSITION_END = getVendorPrefixedEventName("transitionend");
    var topLevelEventsToReactNames = new Map(); // NOTE: Capitalization is important in this list!
    //
    // E.g. it needs "pointerDown", not "pointerdown".
    // This is because we derive both React name ("onPointerDown")
    // and DOM name ("pointerdown") from the same list.
    //
    // Exceptions that don't match this convention are listed separately.
    //
    // prettier-ignore
    var simpleEventPluginEvents = [
        "abort",
        "auxClick",
        "cancel",
        "canPlay",
        "canPlayThrough",
        "click",
        "close",
        "contextMenu",
        "copy",
        "cut",
        "drag",
        "dragEnd",
        "dragEnter",
        "dragExit",
        "dragLeave",
        "dragOver",
        "dragStart",
        "drop",
        "durationChange",
        "emptied",
        "encrypted",
        "ended",
        "error",
        "gotPointerCapture",
        "input",
        "invalid",
        "keyDown",
        "keyPress",
        "keyUp",
        "load",
        "loadedData",
        "loadedMetadata",
        "loadStart",
        "lostPointerCapture",
        "mouseDown",
        "mouseMove",
        "mouseOut",
        "mouseOver",
        "mouseUp",
        "paste",
        "pause",
        "play",
        "playing",
        "pointerCancel",
        "pointerDown",
        "pointerMove",
        "pointerOut",
        "pointerOver",
        "pointerUp",
        "progress",
        "rateChange",
        "reset",
        "resize",
        "seeked",
        "seeking",
        "stalled",
        "submit",
        "suspend",
        "timeUpdate",
        "touchCancel",
        "touchEnd",
        "touchStart",
        "volumeChange",
        "scroll",
        "toggle",
        "touchMove",
        "waiting",
        "wheel"
    ];
    function registerSimpleEvent(domEventName, reactName) {
        topLevelEventsToReactNames.set(domEventName, reactName);
        registerTwoPhaseEvent(reactName, [
            domEventName
        ]);
    }
    function registerSimpleEvents() {
        for(var i = 0; i < simpleEventPluginEvents.length; i++){
            var eventName = simpleEventPluginEvents[i];
            var domEventName = eventName.toLowerCase();
            var capitalizedEvent = eventName[0].toUpperCase() + eventName.slice(1);
            registerSimpleEvent(domEventName, "on" + capitalizedEvent);
        } // Special cases where event names don't match.
        registerSimpleEvent(ANIMATION_END, "onAnimationEnd");
        registerSimpleEvent(ANIMATION_ITERATION, "onAnimationIteration");
        registerSimpleEvent(ANIMATION_START, "onAnimationStart");
        registerSimpleEvent("dblclick", "onDoubleClick");
        registerSimpleEvent("focusin", "onFocus");
        registerSimpleEvent("focusout", "onBlur");
        registerSimpleEvent(TRANSITION_END, "onTransitionEnd");
    }
    function extractEvents$4(dispatchQueue, domEventName, targetInst, nativeEvent, nativeEventTarget, eventSystemFlags, targetContainer) {
        var reactName = topLevelEventsToReactNames.get(domEventName);
        if (reactName === undefined) return;
        var SyntheticEventCtor = SyntheticEvent;
        var reactEventType = domEventName;
        switch(domEventName){
            case "keypress":
                // Firefox creates a keypress event for function keys too. This removes
                // the unwanted keypress events. Enter is however both printable and
                // non-printable. One would expect Tab to be as well (but it isn't).
                if (getEventCharCode(nativeEvent) === 0) return;
            /* falls through */ case "keydown":
            case "keyup":
                SyntheticEventCtor = SyntheticKeyboardEvent;
                break;
            case "focusin":
                reactEventType = "focus";
                SyntheticEventCtor = SyntheticFocusEvent;
                break;
            case "focusout":
                reactEventType = "blur";
                SyntheticEventCtor = SyntheticFocusEvent;
                break;
            case "beforeblur":
            case "afterblur":
                SyntheticEventCtor = SyntheticFocusEvent;
                break;
            case "click":
                // Firefox creates a click event on right mouse clicks. This removes the
                // unwanted click events.
                if (nativeEvent.button === 2) return;
            /* falls through */ case "auxclick":
            case "dblclick":
            case "mousedown":
            case "mousemove":
            case "mouseup":
            /* falls through */ case "mouseout":
            case "mouseover":
            case "contextmenu":
                SyntheticEventCtor = SyntheticMouseEvent;
                break;
            case "drag":
            case "dragend":
            case "dragenter":
            case "dragexit":
            case "dragleave":
            case "dragover":
            case "dragstart":
            case "drop":
                SyntheticEventCtor = SyntheticDragEvent;
                break;
            case "touchcancel":
            case "touchend":
            case "touchmove":
            case "touchstart":
                SyntheticEventCtor = SyntheticTouchEvent;
                break;
            case ANIMATION_END:
            case ANIMATION_ITERATION:
            case ANIMATION_START:
                SyntheticEventCtor = SyntheticAnimationEvent;
                break;
            case TRANSITION_END:
                SyntheticEventCtor = SyntheticTransitionEvent;
                break;
            case "scroll":
                SyntheticEventCtor = SyntheticUIEvent;
                break;
            case "wheel":
                SyntheticEventCtor = SyntheticWheelEvent;
                break;
            case "copy":
            case "cut":
            case "paste":
                SyntheticEventCtor = SyntheticClipboardEvent;
                break;
            case "gotpointercapture":
            case "lostpointercapture":
            case "pointercancel":
            case "pointerdown":
            case "pointermove":
            case "pointerout":
            case "pointerover":
            case "pointerup":
                SyntheticEventCtor = SyntheticPointerEvent;
                break;
        }
        var inCapturePhase = (eventSystemFlags & IS_CAPTURE_PHASE) !== 0;
        // Some events don't bubble in the browser.
        // In the past, React has always bubbled them, but this can be surprising.
        // We're going to try aligning closer to the browser behavior by not bubbling
        // them in React either. We'll start by not bubbling onScroll, and then expand.
        var accumulateTargetOnly = !inCapturePhase && // TODO: ideally, we'd eventually add all events from
        // nonDelegatedEvents list in DOMPluginEventSystem.
        // Then we can remove this special list.
        // This is a breaking change that can wait until React 18.
        domEventName === "scroll";
        var _listeners = accumulateSinglePhaseListeners(targetInst, reactName, nativeEvent.type, inCapturePhase, accumulateTargetOnly);
        if (_listeners.length > 0) {
            // Intentionally create event lazily.
            var _event = new SyntheticEventCtor(reactName, reactEventType, null, nativeEvent, nativeEventTarget);
            dispatchQueue.push({
                event: _event,
                listeners: _listeners
            });
        }
    }
    // TODO: remove top-level side effect.
    registerSimpleEvents();
    registerEvents$2();
    registerEvents$1();
    registerEvents$3();
    registerEvents();
    function extractEvents$5(dispatchQueue, domEventName, targetInst, nativeEvent, nativeEventTarget, eventSystemFlags, targetContainer) {
        // TODO: we should remove the concept of a "SimpleEventPlugin".
        // This is the basic functionality of the event system. All
        // the other plugins are essentially polyfills. So the plugin
        // should probably be inlined somewhere and have its logic
        // be core the to event system. This would potentially allow
        // us to ship builds of React without the polyfilled plugins below.
        extractEvents$4(dispatchQueue, domEventName, targetInst, nativeEvent, nativeEventTarget, eventSystemFlags);
        var shouldProcessPolyfillPlugins = (eventSystemFlags & SHOULD_NOT_PROCESS_POLYFILL_EVENT_PLUGINS) === 0; // We don't process these events unless we are in the
        // event's native "bubble" phase, which means that we're
        // not in the capture phase. That's because we emulate
        // the capture phase here still. This is a trade-off,
        // because in an ideal world we would not emulate and use
        // the phases properly, like we do with the SimpleEvent
        // plugin. However, the plugins below either expect
        // emulation (EnterLeave) or use state localized to that
        // plugin (BeforeInput, Change, Select). The state in
        // these modules complicates things, as you'll essentially
        // get the case where the capture phase event might change
        // state, only for the following bubble event to come in
        // later and not trigger anything as the state now
        // invalidates the heuristics of the event plugin. We
        // could alter all these plugins to work in such ways, but
        // that might cause other unknown side-effects that we
        // can't foresee right now.
        if (shouldProcessPolyfillPlugins) {
            extractEvents$2(dispatchQueue, domEventName, targetInst, nativeEvent, nativeEventTarget);
            extractEvents$1(dispatchQueue, domEventName, targetInst, nativeEvent, nativeEventTarget);
            extractEvents$3(dispatchQueue, domEventName, targetInst, nativeEvent, nativeEventTarget);
            extractEvents(dispatchQueue, domEventName, targetInst, nativeEvent, nativeEventTarget);
        }
    } // List of events that need to be individually attached to media elements.
    var mediaEventTypes = [
        "abort",
        "canplay",
        "canplaythrough",
        "durationchange",
        "emptied",
        "encrypted",
        "ended",
        "error",
        "loadeddata",
        "loadedmetadata",
        "loadstart",
        "pause",
        "play",
        "playing",
        "progress",
        "ratechange",
        "resize",
        "seeked",
        "seeking",
        "stalled",
        "suspend",
        "timeupdate",
        "volumechange",
        "waiting"
    ]; // We should not delegate these events to the container, but rather
    // set them on the actual target element itself. This is primarily
    // because these events do not consistently bubble in the DOM.
    var nonDelegatedEvents = new Set([
        "cancel",
        "close",
        "invalid",
        "load",
        "scroll",
        "toggle"
    ].concat(mediaEventTypes));
    function executeDispatch(event, listener, currentTarget) {
        var type = event.type || "unknown-event";
        event.currentTarget = currentTarget;
        invokeGuardedCallbackAndCatchFirstError(type, listener, undefined, event);
        event.currentTarget = null;
    }
    function processDispatchQueueItemsInOrder(event, dispatchListeners, inCapturePhase) {
        var previousInstance;
        if (inCapturePhase) for(var i = dispatchListeners.length - 1; i >= 0; i--){
            var _dispatchListeners$i = dispatchListeners[i], instance = _dispatchListeners$i.instance, currentTarget = _dispatchListeners$i.currentTarget, listener = _dispatchListeners$i.listener;
            if (instance !== previousInstance && event.isPropagationStopped()) return;
            executeDispatch(event, listener, currentTarget);
            previousInstance = instance;
        }
        else for(var _i = 0; _i < dispatchListeners.length; _i++){
            var _dispatchListeners$_i = dispatchListeners[_i], _instance = _dispatchListeners$_i.instance, _currentTarget = _dispatchListeners$_i.currentTarget, _listener = _dispatchListeners$_i.listener;
            if (_instance !== previousInstance && event.isPropagationStopped()) return;
            executeDispatch(event, _listener, _currentTarget);
            previousInstance = _instance;
        }
    }
    function processDispatchQueue(dispatchQueue, eventSystemFlags) {
        var inCapturePhase = (eventSystemFlags & IS_CAPTURE_PHASE) !== 0;
        for(var i = 0; i < dispatchQueue.length; i++){
            var _dispatchQueue$i = dispatchQueue[i], event = _dispatchQueue$i.event, listeners = _dispatchQueue$i.listeners;
            processDispatchQueueItemsInOrder(event, listeners, inCapturePhase); //  event system doesn't use pooling.
        } // This would be a good time to rethrow if any of the event handlers threw.
        rethrowCaughtError();
    }
    function dispatchEventsForPlugins(domEventName, eventSystemFlags, nativeEvent, targetInst, targetContainer) {
        var nativeEventTarget = getEventTarget(nativeEvent);
        var dispatchQueue = [];
        extractEvents$5(dispatchQueue, domEventName, targetInst, nativeEvent, nativeEventTarget, eventSystemFlags);
        processDispatchQueue(dispatchQueue, eventSystemFlags);
    }
    function listenToNonDelegatedEvent(domEventName, targetElement) {
        if (!nonDelegatedEvents.has(domEventName)) error('Did not expect a listenToNonDelegatedEvent() call for "%s". This is a bug in React. Please file an issue.', domEventName);
        var isCapturePhaseListener = false;
        var listenerSet = getEventListenerSet(targetElement);
        var listenerSetKey = getListenerSetKey(domEventName, isCapturePhaseListener);
        if (!listenerSet.has(listenerSetKey)) {
            addTrappedEventListener(targetElement, domEventName, IS_NON_DELEGATED, isCapturePhaseListener);
            listenerSet.add(listenerSetKey);
        }
    }
    function listenToNativeEvent(domEventName, isCapturePhaseListener, target) {
        if (nonDelegatedEvents.has(domEventName) && !isCapturePhaseListener) error('Did not expect a listenToNativeEvent() call for "%s" in the bubble phase. This is a bug in React. Please file an issue.', domEventName);
        var eventSystemFlags = 0;
        if (isCapturePhaseListener) eventSystemFlags |= IS_CAPTURE_PHASE;
        addTrappedEventListener(target, domEventName, eventSystemFlags, isCapturePhaseListener);
    } // This is only used by createEventHandle when the
    var listeningMarker = "_reactListening" + Math.random().toString(36).slice(2);
    function listenToAllSupportedEvents(rootContainerElement) {
        if (!rootContainerElement[listeningMarker]) {
            rootContainerElement[listeningMarker] = true;
            allNativeEvents.forEach(function(domEventName) {
                // We handle selectionchange separately because it
                // doesn't bubble and needs to be on the document.
                if (domEventName !== "selectionchange") {
                    if (!nonDelegatedEvents.has(domEventName)) listenToNativeEvent(domEventName, false, rootContainerElement);
                    listenToNativeEvent(domEventName, true, rootContainerElement);
                }
            });
            var ownerDocument = rootContainerElement.nodeType === DOCUMENT_NODE ? rootContainerElement : rootContainerElement.ownerDocument;
            if (ownerDocument !== null) // The selectionchange event also needs deduplication
            // but it is attached to the document.
            {
                if (!ownerDocument[listeningMarker]) {
                    ownerDocument[listeningMarker] = true;
                    listenToNativeEvent("selectionchange", false, ownerDocument);
                }
            }
        }
    }
    function addTrappedEventListener(targetContainer, domEventName, eventSystemFlags, isCapturePhaseListener, isDeferredListenerForLegacyFBSupport) {
        var listener = createEventListenerWrapperWithPriority(targetContainer, domEventName, eventSystemFlags); // If passive option is not supported, then the event will be
        // active and not passive.
        var isPassiveListener = undefined;
        if (passiveBrowserEventsSupported) // Browsers introduced an intervention, making these events
        // passive by default on document. React doesn't bind them
        // to document anymore, but changing this now would undo
        // the performance wins from the change. So we emulate
        // the existing behavior manually on the roots now.
        // https://github.com/facebook/react/issues/19651
        {
            if (domEventName === "touchstart" || domEventName === "touchmove" || domEventName === "wheel") isPassiveListener = true;
        }
        targetContainer;
        var unsubscribeListener; // When legacyFBSupport is enabled, it's for when we
        if (isCapturePhaseListener) {
            if (isPassiveListener !== undefined) unsubscribeListener = addEventCaptureListenerWithPassiveFlag(targetContainer, domEventName, listener, isPassiveListener);
            else unsubscribeListener = addEventCaptureListener(targetContainer, domEventName, listener);
        } else if (isPassiveListener !== undefined) unsubscribeListener = addEventBubbleListenerWithPassiveFlag(targetContainer, domEventName, listener, isPassiveListener);
        else unsubscribeListener = addEventBubbleListener(targetContainer, domEventName, listener);
    }
    function isMatchingRootContainer(grandContainer, targetContainer) {
        return grandContainer === targetContainer || grandContainer.nodeType === COMMENT_NODE && grandContainer.parentNode === targetContainer;
    }
    function dispatchEventForPluginEventSystem(domEventName, eventSystemFlags, nativeEvent, targetInst, targetContainer) {
        var ancestorInst = targetInst;
        if ((eventSystemFlags & IS_EVENT_HANDLE_NON_MANAGED_NODE) === 0 && (eventSystemFlags & IS_NON_DELEGATED) === 0) {
            var targetContainerNode = targetContainer; // If we are using the legacy FB support flag, we
            if (targetInst !== null) {
                // The below logic attempts to work out if we need to change
                // the target fiber to a different ancestor. We had similar logic
                // in the legacy event system, except the big difference between
                // systems is that the modern event system now has an event listener
                // attached to each React Root and React Portal Root. Together,
                // the DOM nodes representing these roots are the "rootContainer".
                // To figure out which ancestor instance we should use, we traverse
                // up the fiber tree from the target instance and attempt to find
                // root boundaries that match that of our current "rootContainer".
                // If we find that "rootContainer", we find the parent fiber
                // sub-tree for that root and make that our ancestor instance.
                var node = targetInst;
                mainLoop: while(true){
                    if (node === null) return;
                    var nodeTag = node.tag;
                    if (nodeTag === HostRoot || nodeTag === HostPortal) {
                        var container = node.stateNode.containerInfo;
                        if (isMatchingRootContainer(container, targetContainerNode)) break;
                        if (nodeTag === HostPortal) {
                            // The target is a portal, but it's not the rootContainer we're looking for.
                            // Normally portals handle their own events all the way down to the root.
                            // So we should be able to stop now. However, we don't know if this portal
                            // was part of *our* root.
                            var grandNode = node.return;
                            while(grandNode !== null){
                                var grandTag = grandNode.tag;
                                if (grandTag === HostRoot || grandTag === HostPortal) {
                                    var grandContainer = grandNode.stateNode.containerInfo;
                                    if (isMatchingRootContainer(grandContainer, targetContainerNode)) // This is the rootContainer we're looking for and we found it as
                                    // a parent of the Portal. That means we can ignore it because the
                                    // Portal will bubble through to us.
                                    return;
                                }
                                grandNode = grandNode.return;
                            }
                        } // Now we need to find it's corresponding host fiber in the other
                        // tree. To do this we can use getClosestInstanceFromNode, but we
                        // need to validate that the fiber is a host instance, otherwise
                        // we need to traverse up through the DOM till we find the correct
                        // node that is from the other tree.
                        while(container !== null){
                            var parentNode = getClosestInstanceFromNode(container);
                            if (parentNode === null) return;
                            var parentTag = parentNode.tag;
                            if (parentTag === HostComponent || parentTag === HostText) {
                                node = ancestorInst = parentNode;
                                continue mainLoop;
                            }
                            container = container.parentNode;
                        }
                    }
                    node = node.return;
                }
            }
        }
        batchedUpdates(function() {
            return dispatchEventsForPlugins(domEventName, eventSystemFlags, nativeEvent, ancestorInst);
        });
    }
    function createDispatchListener(instance, listener, currentTarget) {
        return {
            instance: instance,
            listener: listener,
            currentTarget: currentTarget
        };
    }
    function accumulateSinglePhaseListeners(targetFiber, reactName, nativeEventType, inCapturePhase, accumulateTargetOnly, nativeEvent) {
        var captureName = reactName !== null ? reactName + "Capture" : null;
        var reactEventName = inCapturePhase ? captureName : reactName;
        var listeners = [];
        var instance = targetFiber;
        var lastHostComponent = null; // Accumulate all instances and listeners via the target -> root path.
        while(instance !== null){
            var _instance2 = instance, stateNode = _instance2.stateNode, tag = _instance2.tag; // Handle listeners that are on HostComponents (i.e. <div>)
            if (tag === HostComponent && stateNode !== null) {
                lastHostComponent = stateNode; // createEventHandle listeners
                if (reactEventName !== null) {
                    var listener = getListener(instance, reactEventName);
                    if (listener != null) listeners.push(createDispatchListener(instance, listener, lastHostComponent));
                }
            } // If we are only accumulating events for the target, then we don't
            // continue to propagate through the React fiber tree to find other
            // listeners.
            if (accumulateTargetOnly) break;
             // If we are processing the onBeforeBlur event, then we need to take
            instance = instance.return;
        }
        return listeners;
    } // We should only use this function for:
    // - BeforeInputEventPlugin
    // - ChangeEventPlugin
    // - SelectEventPlugin
    // This is because we only process these plugins
    // in the bubble phase, so we need to accumulate two
    // phase event listeners (via emulation).
    function accumulateTwoPhaseListeners(targetFiber, reactName) {
        var captureName = reactName + "Capture";
        var listeners = [];
        var instance = targetFiber; // Accumulate all instances and listeners via the target -> root path.
        while(instance !== null){
            var _instance3 = instance, stateNode = _instance3.stateNode, tag = _instance3.tag; // Handle listeners that are on HostComponents (i.e. <div>)
            if (tag === HostComponent && stateNode !== null) {
                var currentTarget = stateNode;
                var captureListener = getListener(instance, captureName);
                if (captureListener != null) listeners.unshift(createDispatchListener(instance, captureListener, currentTarget));
                var bubbleListener = getListener(instance, reactName);
                if (bubbleListener != null) listeners.push(createDispatchListener(instance, bubbleListener, currentTarget));
            }
            instance = instance.return;
        }
        return listeners;
    }
    function getParent(inst) {
        if (inst === null) return null;
        do inst = inst.return; // TODO: If this is a HostRoot we might want to bail out.
        while (inst && inst.tag !== HostComponent);
        if (inst) return inst;
        return null;
    }
    /**
 * Return the lowest common ancestor of A and B, or null if they are in
 * different trees.
 */ function getLowestCommonAncestor(instA, instB) {
        var nodeA = instA;
        var nodeB = instB;
        var depthA = 0;
        for(var tempA = nodeA; tempA; tempA = getParent(tempA))depthA++;
        var depthB = 0;
        for(var tempB = nodeB; tempB; tempB = getParent(tempB))depthB++;
         // If A is deeper, crawl up.
        while(depthA - depthB > 0){
            nodeA = getParent(nodeA);
            depthA--;
        } // If B is deeper, crawl up.
        while(depthB - depthA > 0){
            nodeB = getParent(nodeB);
            depthB--;
        } // Walk in lockstep until we find a match.
        var depth = depthA;
        while(depth--){
            if (nodeA === nodeB || nodeB !== null && nodeA === nodeB.alternate) return nodeA;
            nodeA = getParent(nodeA);
            nodeB = getParent(nodeB);
        }
        return null;
    }
    function accumulateEnterLeaveListenersForEvent(dispatchQueue, event, target, common, inCapturePhase) {
        var registrationName = event._reactName;
        var listeners = [];
        var instance = target;
        while(instance !== null){
            if (instance === common) break;
            var _instance4 = instance, alternate = _instance4.alternate, stateNode = _instance4.stateNode, tag = _instance4.tag;
            if (alternate !== null && alternate === common) break;
            if (tag === HostComponent && stateNode !== null) {
                var currentTarget = stateNode;
                if (inCapturePhase) {
                    var captureListener = getListener(instance, registrationName);
                    if (captureListener != null) listeners.unshift(createDispatchListener(instance, captureListener, currentTarget));
                } else if (!inCapturePhase) {
                    var bubbleListener = getListener(instance, registrationName);
                    if (bubbleListener != null) listeners.push(createDispatchListener(instance, bubbleListener, currentTarget));
                }
            }
            instance = instance.return;
        }
        if (listeners.length !== 0) dispatchQueue.push({
            event: event,
            listeners: listeners
        });
    } // We should only use this function for:
    // - EnterLeaveEventPlugin
    // This is because we only process this plugin
    // in the bubble phase, so we need to accumulate two
    // phase event listeners.
    function accumulateEnterLeaveTwoPhaseListeners(dispatchQueue, leaveEvent, enterEvent, from, to) {
        var common = from && to ? getLowestCommonAncestor(from, to) : null;
        if (from !== null) accumulateEnterLeaveListenersForEvent(dispatchQueue, leaveEvent, from, common, false);
        if (to !== null && enterEvent !== null) accumulateEnterLeaveListenersForEvent(dispatchQueue, enterEvent, to, common, true);
    }
    function getListenerSetKey(domEventName, capture) {
        return domEventName + "__" + (capture ? "capture" : "bubble");
    }
    var didWarnInvalidHydration = false;
    var DANGEROUSLY_SET_INNER_HTML = "dangerouslySetInnerHTML";
    var SUPPRESS_CONTENT_EDITABLE_WARNING = "suppressContentEditableWarning";
    var SUPPRESS_HYDRATION_WARNING = "suppressHydrationWarning";
    var AUTOFOCUS = "autoFocus";
    var CHILDREN = "children";
    var STYLE = "style";
    var HTML$1 = "__html";
    var warnedUnknownTags;
    var validatePropertiesInDevelopment;
    var warnForPropDifference;
    var warnForExtraAttributes;
    var warnForInvalidEventListener;
    var canDiffStyleForHydrationWarning;
    var normalizeHTML;
    warnedUnknownTags = {
        // There are working polyfills for <dialog>. Let people use it.
        dialog: true,
        // Electron ships a custom <webview> tag to display external web content in
        // an isolated frame and process.
        // This tag is not present in non Electron environments such as JSDom which
        // is often used for testing purposes.
        // @see https://electronjs.org/docs/api/webview-tag
        webview: true
    };
    validatePropertiesInDevelopment = function(type, props) {
        validateProperties(type, props);
        validateProperties$1(type, props);
        validateProperties$2(type, props, {
            registrationNameDependencies: registrationNameDependencies,
            possibleRegistrationNames: possibleRegistrationNames
        });
    }; // IE 11 parses & normalizes the style attribute as opposed to other
    // browsers. It adds spaces and sorts the properties in some
    // non-alphabetical order. Handling that would require sorting CSS
    // properties in the client & server versions or applying
    // `expectedStyle` to a temporary DOM node to read its `style` attribute
    // normalized. Since it only affects IE, we're skipping style warnings
    // in that browser completely in favor of doing all that work.
    // See https://github.com/facebook/react/issues/11807
    canDiffStyleForHydrationWarning = canUseDOM && !document.documentMode;
    warnForPropDifference = function(propName, serverValue, clientValue) {
        if (didWarnInvalidHydration) return;
        var normalizedClientValue = normalizeMarkupForTextOrAttribute(clientValue);
        var normalizedServerValue = normalizeMarkupForTextOrAttribute(serverValue);
        if (normalizedServerValue === normalizedClientValue) return;
        didWarnInvalidHydration = true;
        error("Prop `%s` did not match. Server: %s Client: %s", propName, JSON.stringify(normalizedServerValue), JSON.stringify(normalizedClientValue));
    };
    warnForExtraAttributes = function(attributeNames) {
        if (didWarnInvalidHydration) return;
        didWarnInvalidHydration = true;
        var names = [];
        attributeNames.forEach(function(name) {
            names.push(name);
        });
        error("Extra attributes from the server: %s", names);
    };
    warnForInvalidEventListener = function(registrationName, listener) {
        if (listener === false) error("Expected `%s` listener to be a function, instead got `false`.\n\nIf you used to conditionally omit it with %s={condition && value}, pass %s={condition ? value : undefined} instead.", registrationName, registrationName, registrationName);
        else error("Expected `%s` listener to be a function, instead got a value of `%s` type.", registrationName, typeof listener);
    }; // Parse the HTML and read it back to normalize the HTML string so that it
    // can be used for comparison.
    normalizeHTML = function(parent, html) {
        // We could have created a separate document here to avoid
        // re-initializing custom elements if they exist. But this breaks
        // how <noscript> is being handled. So we use the same document.
        // See the discussion in https://github.com/facebook/react/pull/11157.
        var testElement = parent.namespaceURI === HTML_NAMESPACE ? parent.ownerDocument.createElement(parent.tagName) : parent.ownerDocument.createElementNS(parent.namespaceURI, parent.tagName);
        testElement.innerHTML = html;
        return testElement.innerHTML;
    };
    // It also can turn \u0000 into \uFFFD inside attributes.
    // https://www.w3.org/TR/html5/single-page.html#preprocessing-the-input-stream
    // If we have a mismatch, it might be caused by that.
    // We will still patch up in this case but not fire the warning.
    var NORMALIZE_NEWLINES_REGEX = /\r\n?/g;
    var NORMALIZE_NULL_AND_REPLACEMENT_REGEX = /\u0000|\uFFFD/g;
    function normalizeMarkupForTextOrAttribute(markup) {
        checkHtmlStringCoercion(markup);
        var markupString = typeof markup === "string" ? markup : "" + markup;
        return markupString.replace(NORMALIZE_NEWLINES_REGEX, "\n").replace(NORMALIZE_NULL_AND_REPLACEMENT_REGEX, "");
    }
    function checkForUnmatchedText(serverText, clientText, isConcurrentMode, shouldWarnDev) {
        var normalizedClientText = normalizeMarkupForTextOrAttribute(clientText);
        var normalizedServerText = normalizeMarkupForTextOrAttribute(serverText);
        if (normalizedServerText === normalizedClientText) return;
        if (shouldWarnDev) {
            if (!didWarnInvalidHydration) {
                didWarnInvalidHydration = true;
                error('Text content did not match. Server: "%s" Client: "%s"', normalizedServerText, normalizedClientText);
            }
        }
        if (isConcurrentMode && enableClientRenderFallbackOnTextMismatch) // In concurrent roots, we throw when there's a text mismatch and revert to
        // client rendering, up to the nearest Suspense boundary.
        throw new Error("Text content does not match server-rendered HTML.");
    }
    function getOwnerDocumentFromRootContainer(rootContainerElement) {
        return rootContainerElement.nodeType === DOCUMENT_NODE ? rootContainerElement : rootContainerElement.ownerDocument;
    }
    function noop() {}
    function trapClickOnNonInteractiveElement(node) {
        // Mobile Safari does not fire properly bubble click events on
        // non-interactive elements, which means delegated click listeners do not
        // fire. The workaround for this bug involves attaching an empty click
        // listener on the target node.
        // https://www.quirksmode.org/blog/archives/2010/09/click_event_del.html
        // Just set it using the onclick property so that we don't have to manage any
        // bookkeeping for it. Not sure if we need to clear it when the listener is
        // removed.
        // TODO: Only do this for the relevant Safaris maybe?
        node.onclick = noop;
    }
    function setInitialDOMProperties(tag, domElement, rootContainerElement, nextProps, isCustomComponentTag) {
        for(var propKey in nextProps){
            if (!nextProps.hasOwnProperty(propKey)) continue;
            var nextProp = nextProps[propKey];
            if (propKey === STYLE) {
                if (nextProp) // Freeze the next style object so that we can assume it won't be
                // mutated. We have already warned for this in the past.
                Object.freeze(nextProp);
                setValueForStyles(domElement, nextProp);
            } else if (propKey === DANGEROUSLY_SET_INNER_HTML) {
                var nextHtml = nextProp ? nextProp[HTML$1] : undefined;
                if (nextHtml != null) setInnerHTML(domElement, nextHtml);
            } else if (propKey === CHILDREN) {
                if (typeof nextProp === "string") {
                    // Avoid setting initial textContent when the text is empty. In IE11 setting
                    // textContent on a <textarea> will cause the placeholder to not
                    // show within the <textarea> until it has been focused and blurred again.
                    // https://github.com/facebook/react/issues/6731#issuecomment-254874553
                    var canSetTextContent = tag !== "textarea" || nextProp !== "";
                    if (canSetTextContent) setTextContent(domElement, nextProp);
                } else if (typeof nextProp === "number") setTextContent(domElement, "" + nextProp);
            } else if (propKey === SUPPRESS_CONTENT_EDITABLE_WARNING || propKey === SUPPRESS_HYDRATION_WARNING) ;
            else if (propKey === AUTOFOCUS) ;
            else if (registrationNameDependencies.hasOwnProperty(propKey)) {
                if (nextProp != null) {
                    if (typeof nextProp !== "function") warnForInvalidEventListener(propKey, nextProp);
                    if (propKey === "onScroll") listenToNonDelegatedEvent("scroll", domElement);
                }
            } else if (nextProp != null) setValueForProperty(domElement, propKey, nextProp, isCustomComponentTag);
        }
    }
    function updateDOMProperties(domElement, updatePayload, wasCustomComponentTag, isCustomComponentTag) {
        // TODO: Handle wasCustomComponentTag
        for(var i = 0; i < updatePayload.length; i += 2){
            var propKey = updatePayload[i];
            var propValue = updatePayload[i + 1];
            if (propKey === STYLE) setValueForStyles(domElement, propValue);
            else if (propKey === DANGEROUSLY_SET_INNER_HTML) setInnerHTML(domElement, propValue);
            else if (propKey === CHILDREN) setTextContent(domElement, propValue);
            else setValueForProperty(domElement, propKey, propValue, isCustomComponentTag);
        }
    }
    function createElement(type, props, rootContainerElement, parentNamespace) {
        var isCustomComponentTag; // We create tags in the namespace of their parent container, except HTML
        // tags get no namespace.
        var ownerDocument = getOwnerDocumentFromRootContainer(rootContainerElement);
        var domElement;
        var namespaceURI = parentNamespace;
        if (namespaceURI === HTML_NAMESPACE) namespaceURI = getIntrinsicNamespace(type);
        if (namespaceURI === HTML_NAMESPACE) {
            isCustomComponentTag = isCustomComponent(type, props); // Should this check be gated by parent namespace? Not sure we want to
            // allow <SVG> or <mATH>.
            if (!isCustomComponentTag && type !== type.toLowerCase()) error("<%s /> is using incorrect casing. Use PascalCase for React components, or lowercase for HTML elements.", type);
            if (type === "script") {
                // Create the script via .innerHTML so its "parser-inserted" flag is
                // set to true and it does not execute
                var div = ownerDocument.createElement("div");
                div.innerHTML = "<script></script>"; // eslint-disable-line
                // This is guaranteed to yield a script element.
                var firstChild = div.firstChild;
                domElement = div.removeChild(firstChild);
            } else if (typeof props.is === "string") // $FlowIssue `createElement` should be updated for Web Components
            domElement = ownerDocument.createElement(type, {
                is: props.is
            });
            else {
                // Separate else branch instead of using `props.is || undefined` above because of a Firefox bug.
                // See discussion in https://github.com/facebook/react/pull/6896
                // and discussion in https://bugzilla.mozilla.org/show_bug.cgi?id=1276240
                domElement = ownerDocument.createElement(type); // Normally attributes are assigned in `setInitialDOMProperties`, however the `multiple` and `size`
                // attributes on `select`s needs to be added before `option`s are inserted.
                // This prevents:
                // - a bug where the `select` does not scroll to the correct option because singular
                //  `select` elements automatically pick the first item #13222
                // - a bug where the `select` set the first item as selected despite the `size` attribute #14239
                // See https://github.com/facebook/react/issues/13222
                // and https://github.com/facebook/react/issues/14239
                if (type === "select") {
                    var node = domElement;
                    if (props.multiple) node.multiple = true;
                    else if (props.size) // Setting a size greater than 1 causes a select to behave like `multiple=true`, where
                    // it is possible that no option is selected.
                    //
                    // This is only necessary when a select in "single selection mode".
                    node.size = props.size;
                }
            }
        } else domElement = ownerDocument.createElementNS(namespaceURI, type);
        if (namespaceURI === HTML_NAMESPACE) {
            if (!isCustomComponentTag && Object.prototype.toString.call(domElement) === "[object HTMLUnknownElement]" && !hasOwnProperty.call(warnedUnknownTags, type)) {
                warnedUnknownTags[type] = true;
                error("The tag <%s> is unrecognized in this browser. If you meant to render a React component, start its name with an uppercase letter.", type);
            }
        }
        return domElement;
    }
    function createTextNode(text, rootContainerElement) {
        return getOwnerDocumentFromRootContainer(rootContainerElement).createTextNode(text);
    }
    function setInitialProperties(domElement, tag, rawProps, rootContainerElement) {
        var isCustomComponentTag = isCustomComponent(tag, rawProps);
        validatePropertiesInDevelopment(tag, rawProps);
        var props;
        switch(tag){
            case "dialog":
                listenToNonDelegatedEvent("cancel", domElement);
                listenToNonDelegatedEvent("close", domElement);
                props = rawProps;
                break;
            case "iframe":
            case "object":
            case "embed":
                // We listen to this event in case to ensure emulated bubble
                // listeners still fire for the load event.
                listenToNonDelegatedEvent("load", domElement);
                props = rawProps;
                break;
            case "video":
            case "audio":
                // We listen to these events in case to ensure emulated bubble
                // listeners still fire for all the media events.
                for(var i = 0; i < mediaEventTypes.length; i++)listenToNonDelegatedEvent(mediaEventTypes[i], domElement);
                props = rawProps;
                break;
            case "source":
                // We listen to this event in case to ensure emulated bubble
                // listeners still fire for the error event.
                listenToNonDelegatedEvent("error", domElement);
                props = rawProps;
                break;
            case "img":
            case "image":
            case "link":
                // We listen to these events in case to ensure emulated bubble
                // listeners still fire for error and load events.
                listenToNonDelegatedEvent("error", domElement);
                listenToNonDelegatedEvent("load", domElement);
                props = rawProps;
                break;
            case "details":
                // We listen to this event in case to ensure emulated bubble
                // listeners still fire for the toggle event.
                listenToNonDelegatedEvent("toggle", domElement);
                props = rawProps;
                break;
            case "input":
                initWrapperState(domElement, rawProps);
                props = getHostProps(domElement, rawProps); // We listen to this event in case to ensure emulated bubble
                // listeners still fire for the invalid event.
                listenToNonDelegatedEvent("invalid", domElement);
                break;
            case "option":
                validateProps(domElement, rawProps);
                props = rawProps;
                break;
            case "select":
                initWrapperState$1(domElement, rawProps);
                props = getHostProps$1(domElement, rawProps); // We listen to this event in case to ensure emulated bubble
                // listeners still fire for the invalid event.
                listenToNonDelegatedEvent("invalid", domElement);
                break;
            case "textarea":
                initWrapperState$2(domElement, rawProps);
                props = getHostProps$2(domElement, rawProps); // We listen to this event in case to ensure emulated bubble
                // listeners still fire for the invalid event.
                listenToNonDelegatedEvent("invalid", domElement);
                break;
            default:
                props = rawProps;
        }
        assertValidProps(tag, props);
        setInitialDOMProperties(tag, domElement, rootContainerElement, props, isCustomComponentTag);
        switch(tag){
            case "input":
                // TODO: Make sure we check if this is still unmounted or do any clean
                // up necessary since we never stop tracking anymore.
                track(domElement);
                postMountWrapper(domElement, rawProps, false);
                break;
            case "textarea":
                // TODO: Make sure we check if this is still unmounted or do any clean
                // up necessary since we never stop tracking anymore.
                track(domElement);
                postMountWrapper$3(domElement);
                break;
            case "option":
                postMountWrapper$1(domElement, rawProps);
                break;
            case "select":
                postMountWrapper$2(domElement, rawProps);
                break;
            default:
                if (typeof props.onClick === "function") // TODO: This cast may not be sound for SVG, MathML or custom elements.
                trapClickOnNonInteractiveElement(domElement);
                break;
        }
    } // Calculate the diff between the two objects.
    function diffProperties(domElement, tag, lastRawProps, nextRawProps, rootContainerElement) {
        validatePropertiesInDevelopment(tag, nextRawProps);
        var updatePayload = null;
        var lastProps;
        var nextProps;
        switch(tag){
            case "input":
                lastProps = getHostProps(domElement, lastRawProps);
                nextProps = getHostProps(domElement, nextRawProps);
                updatePayload = [];
                break;
            case "select":
                lastProps = getHostProps$1(domElement, lastRawProps);
                nextProps = getHostProps$1(domElement, nextRawProps);
                updatePayload = [];
                break;
            case "textarea":
                lastProps = getHostProps$2(domElement, lastRawProps);
                nextProps = getHostProps$2(domElement, nextRawProps);
                updatePayload = [];
                break;
            default:
                lastProps = lastRawProps;
                nextProps = nextRawProps;
                if (typeof lastProps.onClick !== "function" && typeof nextProps.onClick === "function") // TODO: This cast may not be sound for SVG, MathML or custom elements.
                trapClickOnNonInteractiveElement(domElement);
                break;
        }
        assertValidProps(tag, nextProps);
        var propKey;
        var styleName;
        var styleUpdates = null;
        for(propKey in lastProps){
            if (nextProps.hasOwnProperty(propKey) || !lastProps.hasOwnProperty(propKey) || lastProps[propKey] == null) continue;
            if (propKey === STYLE) {
                var lastStyle = lastProps[propKey];
                for(styleName in lastStyle)if (lastStyle.hasOwnProperty(styleName)) {
                    if (!styleUpdates) styleUpdates = {};
                    styleUpdates[styleName] = "";
                }
            } else if (propKey === DANGEROUSLY_SET_INNER_HTML || propKey === CHILDREN) ;
            else if (propKey === SUPPRESS_CONTENT_EDITABLE_WARNING || propKey === SUPPRESS_HYDRATION_WARNING) ;
            else if (propKey === AUTOFOCUS) ;
            else if (registrationNameDependencies.hasOwnProperty(propKey)) // This is a special case. If any listener updates we need to ensure
            // that the "current" fiber pointer gets updated so we need a commit
            // to update this element.
            {
                if (!updatePayload) updatePayload = [];
            } else // For all other deleted properties we add it to the queue. We use
            // the allowed property list in the commit phase instead.
            (updatePayload = updatePayload || []).push(propKey, null);
        }
        for(propKey in nextProps){
            var nextProp = nextProps[propKey];
            var lastProp = lastProps != null ? lastProps[propKey] : undefined;
            if (!nextProps.hasOwnProperty(propKey) || nextProp === lastProp || nextProp == null && lastProp == null) continue;
            if (propKey === STYLE) {
                if (nextProp) // Freeze the next style object so that we can assume it won't be
                // mutated. We have already warned for this in the past.
                Object.freeze(nextProp);
                if (lastProp) {
                    // Unset styles on `lastProp` but not on `nextProp`.
                    for(styleName in lastProp)if (lastProp.hasOwnProperty(styleName) && (!nextProp || !nextProp.hasOwnProperty(styleName))) {
                        if (!styleUpdates) styleUpdates = {};
                        styleUpdates[styleName] = "";
                    }
                     // Update styles that changed since `lastProp`.
                    for(styleName in nextProp)if (nextProp.hasOwnProperty(styleName) && lastProp[styleName] !== nextProp[styleName]) {
                        if (!styleUpdates) styleUpdates = {};
                        styleUpdates[styleName] = nextProp[styleName];
                    }
                } else {
                    // Relies on `updateStylesByID` not mutating `styleUpdates`.
                    if (!styleUpdates) {
                        if (!updatePayload) updatePayload = [];
                        updatePayload.push(propKey, styleUpdates);
                    }
                    styleUpdates = nextProp;
                }
            } else if (propKey === DANGEROUSLY_SET_INNER_HTML) {
                var nextHtml = nextProp ? nextProp[HTML$1] : undefined;
                var lastHtml = lastProp ? lastProp[HTML$1] : undefined;
                if (nextHtml != null) {
                    if (lastHtml !== nextHtml) (updatePayload = updatePayload || []).push(propKey, nextHtml);
                }
            } else if (propKey === CHILDREN) {
                if (typeof nextProp === "string" || typeof nextProp === "number") (updatePayload = updatePayload || []).push(propKey, "" + nextProp);
            } else if (propKey === SUPPRESS_CONTENT_EDITABLE_WARNING || propKey === SUPPRESS_HYDRATION_WARNING) ;
            else if (registrationNameDependencies.hasOwnProperty(propKey)) {
                if (nextProp != null) {
                    // We eagerly listen to this even though we haven't committed yet.
                    if (typeof nextProp !== "function") warnForInvalidEventListener(propKey, nextProp);
                    if (propKey === "onScroll") listenToNonDelegatedEvent("scroll", domElement);
                }
                if (!updatePayload && lastProp !== nextProp) // This is a special case. If any listener updates we need to ensure
                // that the "current" props pointer gets updated so we need a commit
                // to update this element.
                updatePayload = [];
            } else // For any other property we always add it to the queue and then we
            // filter it out using the allowed property list during the commit.
            (updatePayload = updatePayload || []).push(propKey, nextProp);
        }
        if (styleUpdates) {
            validateShorthandPropertyCollisionInDev(styleUpdates, nextProps[STYLE]);
            (updatePayload = updatePayload || []).push(STYLE, styleUpdates);
        }
        return updatePayload;
    } // Apply the diff.
    function updateProperties(domElement, updatePayload, tag, lastRawProps, nextRawProps) {
        // Update checked *before* name.
        // In the middle of an update, it is possible to have multiple checked.
        // When a checked radio tries to change name, browser makes another radio's checked false.
        if (tag === "input" && nextRawProps.type === "radio" && nextRawProps.name != null) updateChecked(domElement, nextRawProps);
        var wasCustomComponentTag = isCustomComponent(tag, lastRawProps);
        var isCustomComponentTag = isCustomComponent(tag, nextRawProps); // Apply the diff.
        updateDOMProperties(domElement, updatePayload, wasCustomComponentTag, isCustomComponentTag); // TODO: Ensure that an update gets scheduled if any of the special props
        // changed.
        switch(tag){
            case "input":
                // Update the wrapper around inputs *after* updating props. This has to
                // happen after `updateDOMProperties`. Otherwise HTML5 input validations
                // raise warnings and prevent the new value from being assigned.
                updateWrapper(domElement, nextRawProps);
                break;
            case "textarea":
                updateWrapper$1(domElement, nextRawProps);
                break;
            case "select":
                // <select> value update needs to occur after <option> children
                // reconciliation
                postUpdateWrapper(domElement, nextRawProps);
                break;
        }
    }
    function getPossibleStandardName(propName) {
        var lowerCasedName = propName.toLowerCase();
        if (!possibleStandardNames.hasOwnProperty(lowerCasedName)) return null;
        return possibleStandardNames[lowerCasedName] || null;
    }
    function diffHydratedProperties(domElement, tag, rawProps, parentNamespace, rootContainerElement, isConcurrentMode, shouldWarnDev) {
        var isCustomComponentTag;
        var extraAttributeNames;
        isCustomComponentTag = isCustomComponent(tag, rawProps);
        validatePropertiesInDevelopment(tag, rawProps);
        switch(tag){
            case "dialog":
                listenToNonDelegatedEvent("cancel", domElement);
                listenToNonDelegatedEvent("close", domElement);
                break;
            case "iframe":
            case "object":
            case "embed":
                // We listen to this event in case to ensure emulated bubble
                // listeners still fire for the load event.
                listenToNonDelegatedEvent("load", domElement);
                break;
            case "video":
            case "audio":
                // We listen to these events in case to ensure emulated bubble
                // listeners still fire for all the media events.
                for(var i = 0; i < mediaEventTypes.length; i++)listenToNonDelegatedEvent(mediaEventTypes[i], domElement);
                break;
            case "source":
                // We listen to this event in case to ensure emulated bubble
                // listeners still fire for the error event.
                listenToNonDelegatedEvent("error", domElement);
                break;
            case "img":
            case "image":
            case "link":
                // We listen to these events in case to ensure emulated bubble
                // listeners still fire for error and load events.
                listenToNonDelegatedEvent("error", domElement);
                listenToNonDelegatedEvent("load", domElement);
                break;
            case "details":
                // We listen to this event in case to ensure emulated bubble
                // listeners still fire for the toggle event.
                listenToNonDelegatedEvent("toggle", domElement);
                break;
            case "input":
                initWrapperState(domElement, rawProps); // We listen to this event in case to ensure emulated bubble
                // listeners still fire for the invalid event.
                listenToNonDelegatedEvent("invalid", domElement);
                break;
            case "option":
                validateProps(domElement, rawProps);
                break;
            case "select":
                initWrapperState$1(domElement, rawProps); // We listen to this event in case to ensure emulated bubble
                // listeners still fire for the invalid event.
                listenToNonDelegatedEvent("invalid", domElement);
                break;
            case "textarea":
                initWrapperState$2(domElement, rawProps); // We listen to this event in case to ensure emulated bubble
                // listeners still fire for the invalid event.
                listenToNonDelegatedEvent("invalid", domElement);
                break;
        }
        assertValidProps(tag, rawProps);
        extraAttributeNames = new Set();
        var attributes = domElement.attributes;
        for(var _i = 0; _i < attributes.length; _i++){
            var name = attributes[_i].name.toLowerCase();
            switch(name){
                // Controlled attributes are not validated
                // TODO: Only ignore them on controlled tags.
                case "value":
                    break;
                case "checked":
                    break;
                case "selected":
                    break;
                default:
                    // Intentionally use the original name.
                    // See discussion in https://github.com/facebook/react/pull/10676.
                    extraAttributeNames.add(attributes[_i].name);
            }
        }
        var updatePayload = null;
        for(var propKey in rawProps){
            if (!rawProps.hasOwnProperty(propKey)) continue;
            var nextProp = rawProps[propKey];
            if (propKey === CHILDREN) {
                // For text content children we compare against textContent. This
                // might match additional HTML that is hidden when we read it using
                // textContent. E.g. "foo" will match "f<span>oo</span>" but that still
                // satisfies our requirement. Our requirement is not to produce perfect
                // HTML and attributes. Ideally we should preserve structure but it's
                // ok not to if the visible content is still enough to indicate what
                // even listeners these nodes might be wired up to.
                // TODO: Warn if there is more than a single textNode as a child.
                // TODO: Should we use domElement.firstChild.nodeValue to compare?
                if (typeof nextProp === "string") {
                    if (domElement.textContent !== nextProp) {
                        if (rawProps[SUPPRESS_HYDRATION_WARNING] !== true) checkForUnmatchedText(domElement.textContent, nextProp, isConcurrentMode, shouldWarnDev);
                        updatePayload = [
                            CHILDREN,
                            nextProp
                        ];
                    }
                } else if (typeof nextProp === "number") {
                    if (domElement.textContent !== "" + nextProp) {
                        if (rawProps[SUPPRESS_HYDRATION_WARNING] !== true) checkForUnmatchedText(domElement.textContent, nextProp, isConcurrentMode, shouldWarnDev);
                        updatePayload = [
                            CHILDREN,
                            "" + nextProp
                        ];
                    }
                }
            } else if (registrationNameDependencies.hasOwnProperty(propKey)) {
                if (nextProp != null) {
                    if (typeof nextProp !== "function") warnForInvalidEventListener(propKey, nextProp);
                    if (propKey === "onScroll") listenToNonDelegatedEvent("scroll", domElement);
                }
            } else if (shouldWarnDev && true && // Convince Flow we've calculated it (it's DEV-only in this method.)
            typeof isCustomComponentTag === "boolean") {
                // Validate that the properties correspond to their expected values.
                var serverValue = void 0;
                var propertyInfo = isCustomComponentTag && enableCustomElementPropertySupport ? null : getPropertyInfo(propKey);
                if (rawProps[SUPPRESS_HYDRATION_WARNING] === true) ;
                else if (propKey === SUPPRESS_CONTENT_EDITABLE_WARNING || propKey === SUPPRESS_HYDRATION_WARNING || // Controlled attributes are not validated
                // TODO: Only ignore them on controlled tags.
                propKey === "value" || propKey === "checked" || propKey === "selected") ;
                else if (propKey === DANGEROUSLY_SET_INNER_HTML) {
                    var serverHTML = domElement.innerHTML;
                    var nextHtml = nextProp ? nextProp[HTML$1] : undefined;
                    if (nextHtml != null) {
                        var expectedHTML = normalizeHTML(domElement, nextHtml);
                        if (expectedHTML !== serverHTML) warnForPropDifference(propKey, serverHTML, expectedHTML);
                    }
                } else if (propKey === STYLE) {
                    // $FlowFixMe - Should be inferred as not undefined.
                    extraAttributeNames.delete(propKey);
                    if (canDiffStyleForHydrationWarning) {
                        var expectedStyle = createDangerousStringForStyles(nextProp);
                        serverValue = domElement.getAttribute("style");
                        if (expectedStyle !== serverValue) warnForPropDifference(propKey, serverValue, expectedStyle);
                    }
                } else if (isCustomComponentTag && !enableCustomElementPropertySupport) {
                    // $FlowFixMe - Should be inferred as not undefined.
                    extraAttributeNames.delete(propKey.toLowerCase());
                    serverValue = getValueForAttribute(domElement, propKey, nextProp);
                    if (nextProp !== serverValue) warnForPropDifference(propKey, serverValue, nextProp);
                } else if (!shouldIgnoreAttribute(propKey, propertyInfo, isCustomComponentTag) && !shouldRemoveAttribute(propKey, nextProp, propertyInfo, isCustomComponentTag)) {
                    var isMismatchDueToBadCasing = false;
                    if (propertyInfo !== null) {
                        // $FlowFixMe - Should be inferred as not undefined.
                        extraAttributeNames.delete(propertyInfo.attributeName);
                        serverValue = getValueForProperty(domElement, propKey, nextProp, propertyInfo);
                    } else {
                        var ownNamespace = parentNamespace;
                        if (ownNamespace === HTML_NAMESPACE) ownNamespace = getIntrinsicNamespace(tag);
                        if (ownNamespace === HTML_NAMESPACE) // $FlowFixMe - Should be inferred as not undefined.
                        extraAttributeNames.delete(propKey.toLowerCase());
                        else {
                            var standardName = getPossibleStandardName(propKey);
                            if (standardName !== null && standardName !== propKey) {
                                // If an SVG prop is supplied with bad casing, it will
                                // be successfully parsed from HTML, but will produce a mismatch
                                // (and would be incorrectly rendered on the client).
                                // However, we already warn about bad casing elsewhere.
                                // So we'll skip the misleading extra mismatch warning in this case.
                                isMismatchDueToBadCasing = true; // $FlowFixMe - Should be inferred as not undefined.
                                extraAttributeNames.delete(standardName);
                            } // $FlowFixMe - Should be inferred as not undefined.
                            extraAttributeNames.delete(propKey);
                        }
                        serverValue = getValueForAttribute(domElement, propKey, nextProp);
                    }
                    var dontWarnCustomElement = enableCustomElementPropertySupport;
                    if (!dontWarnCustomElement && nextProp !== serverValue && !isMismatchDueToBadCasing) warnForPropDifference(propKey, serverValue, nextProp);
                }
            }
        }
        if (shouldWarnDev) {
            if (extraAttributeNames.size > 0 && rawProps[SUPPRESS_HYDRATION_WARNING] !== true) // $FlowFixMe - Should be inferred as not undefined.
            warnForExtraAttributes(extraAttributeNames);
        }
        switch(tag){
            case "input":
                // TODO: Make sure we check if this is still unmounted or do any clean
                // up necessary since we never stop tracking anymore.
                track(domElement);
                postMountWrapper(domElement, rawProps, true);
                break;
            case "textarea":
                // TODO: Make sure we check if this is still unmounted or do any clean
                // up necessary since we never stop tracking anymore.
                track(domElement);
                postMountWrapper$3(domElement);
                break;
            case "select":
            case "option":
                break;
            default:
                if (typeof rawProps.onClick === "function") // TODO: This cast may not be sound for SVG, MathML or custom elements.
                trapClickOnNonInteractiveElement(domElement);
                break;
        }
        return updatePayload;
    }
    function diffHydratedText(textNode, text, isConcurrentMode) {
        var isDifferent = textNode.nodeValue !== text;
        return isDifferent;
    }
    function warnForDeletedHydratableElement(parentNode, child) {
        if (didWarnInvalidHydration) return;
        didWarnInvalidHydration = true;
        error("Did not expect server HTML to contain a <%s> in <%s>.", child.nodeName.toLowerCase(), parentNode.nodeName.toLowerCase());
    }
    function warnForDeletedHydratableText(parentNode, child) {
        if (didWarnInvalidHydration) return;
        didWarnInvalidHydration = true;
        error('Did not expect server HTML to contain the text node "%s" in <%s>.', child.nodeValue, parentNode.nodeName.toLowerCase());
    }
    function warnForInsertedHydratedElement(parentNode, tag, props) {
        if (didWarnInvalidHydration) return;
        didWarnInvalidHydration = true;
        error("Expected server HTML to contain a matching <%s> in <%s>.", tag, parentNode.nodeName.toLowerCase());
    }
    function warnForInsertedHydratedText(parentNode, text) {
        if (text === "") // We expect to insert empty text nodes since they're not represented in
        // the HTML.
        // TODO: Remove this special case if we can just avoid inserting empty
        // text nodes.
        return;
        if (didWarnInvalidHydration) return;
        didWarnInvalidHydration = true;
        error('Expected server HTML to contain a matching text node for "%s" in <%s>.', text, parentNode.nodeName.toLowerCase());
    }
    function restoreControlledState$3(domElement, tag, props) {
        switch(tag){
            case "input":
                restoreControlledState(domElement, props);
                return;
            case "textarea":
                restoreControlledState$2(domElement, props);
                return;
            case "select":
                restoreControlledState$1(domElement, props);
                return;
        }
    }
    var validateDOMNesting = function() {};
    var updatedAncestorInfo = function() {};
    // This validation code was written based on the HTML5 parsing spec:
    // https://html.spec.whatwg.org/multipage/syntax.html#has-an-element-in-scope
    //
    // Note: this does not catch all invalid nesting, nor does it try to (as it's
    // not clear what practical benefit doing so provides); instead, we warn only
    // for cases where the parser will give a parse tree differing from what React
    // intended. For example, <b><div></div></b> is invalid but we don't warn
    // because it still parses correctly; we do warn for other cases like nested
    // <p> tags where the beginning of the second element implicitly closes the
    // first, causing a confusing mess.
    // https://html.spec.whatwg.org/multipage/syntax.html#special
    var specialTags = [
        "address",
        "applet",
        "area",
        "article",
        "aside",
        "base",
        "basefont",
        "bgsound",
        "blockquote",
        "body",
        "br",
        "button",
        "caption",
        "center",
        "col",
        "colgroup",
        "dd",
        "details",
        "dir",
        "div",
        "dl",
        "dt",
        "embed",
        "fieldset",
        "figcaption",
        "figure",
        "footer",
        "form",
        "frame",
        "frameset",
        "h1",
        "h2",
        "h3",
        "h4",
        "h5",
        "h6",
        "head",
        "header",
        "hgroup",
        "hr",
        "html",
        "iframe",
        "img",
        "input",
        "isindex",
        "li",
        "link",
        "listing",
        "main",
        "marquee",
        "menu",
        "menuitem",
        "meta",
        "nav",
        "noembed",
        "noframes",
        "noscript",
        "object",
        "ol",
        "p",
        "param",
        "plaintext",
        "pre",
        "script",
        "section",
        "select",
        "source",
        "style",
        "summary",
        "table",
        "tbody",
        "td",
        "template",
        "textarea",
        "tfoot",
        "th",
        "thead",
        "title",
        "tr",
        "track",
        "ul",
        "wbr",
        "xmp"
    ]; // https://html.spec.whatwg.org/multipage/syntax.html#has-an-element-in-scope
    var inScopeTags = [
        "applet",
        "caption",
        "html",
        "table",
        "td",
        "th",
        "marquee",
        "object",
        "template",
        // TODO: Distinguish by namespace here -- for <title>, including it here
        // errs on the side of fewer warnings
        "foreignObject",
        "desc",
        "title"
    ]; // https://html.spec.whatwg.org/multipage/syntax.html#has-an-element-in-button-scope
    var buttonScopeTags = inScopeTags.concat([
        "button"
    ]); // https://html.spec.whatwg.org/multipage/syntax.html#generate-implied-end-tags
    var impliedEndTags = [
        "dd",
        "dt",
        "li",
        "option",
        "optgroup",
        "p",
        "rp",
        "rt"
    ];
    var emptyAncestorInfo = {
        current: null,
        formTag: null,
        aTagInScope: null,
        buttonTagInScope: null,
        nobrTagInScope: null,
        pTagInButtonScope: null,
        listItemTagAutoclosing: null,
        dlItemTagAutoclosing: null
    };
    updatedAncestorInfo = function(oldInfo, tag) {
        var ancestorInfo = assign({}, oldInfo || emptyAncestorInfo);
        var info = {
            tag: tag
        };
        if (inScopeTags.indexOf(tag) !== -1) {
            ancestorInfo.aTagInScope = null;
            ancestorInfo.buttonTagInScope = null;
            ancestorInfo.nobrTagInScope = null;
        }
        if (buttonScopeTags.indexOf(tag) !== -1) ancestorInfo.pTagInButtonScope = null;
         // See rules for 'li', 'dd', 'dt' start tags in
        // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-inbody
        if (specialTags.indexOf(tag) !== -1 && tag !== "address" && tag !== "div" && tag !== "p") {
            ancestorInfo.listItemTagAutoclosing = null;
            ancestorInfo.dlItemTagAutoclosing = null;
        }
        ancestorInfo.current = info;
        if (tag === "form") ancestorInfo.formTag = info;
        if (tag === "a") ancestorInfo.aTagInScope = info;
        if (tag === "button") ancestorInfo.buttonTagInScope = info;
        if (tag === "nobr") ancestorInfo.nobrTagInScope = info;
        if (tag === "p") ancestorInfo.pTagInButtonScope = info;
        if (tag === "li") ancestorInfo.listItemTagAutoclosing = info;
        if (tag === "dd" || tag === "dt") ancestorInfo.dlItemTagAutoclosing = info;
        return ancestorInfo;
    };
    /**
   * Returns whether
   */ var isTagValidWithParent = function(tag, parentTag) {
        // First, let's check if we're in an unusual parsing mode...
        switch(parentTag){
            // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-inselect
            case "select":
                return tag === "option" || tag === "optgroup" || tag === "#text";
            case "optgroup":
                return tag === "option" || tag === "#text";
            // Strictly speaking, seeing an <option> doesn't mean we're in a <select>
            // but
            case "option":
                return tag === "#text";
            // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-intd
            // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-incaption
            // No special behavior since these rules fall back to "in body" mode for
            // all except special table nodes which cause bad parsing behavior anyway.
            // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-intr
            case "tr":
                return tag === "th" || tag === "td" || tag === "style" || tag === "script" || tag === "template";
            // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-intbody
            case "tbody":
            case "thead":
            case "tfoot":
                return tag === "tr" || tag === "style" || tag === "script" || tag === "template";
            // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-incolgroup
            case "colgroup":
                return tag === "col" || tag === "template";
            // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-intable
            case "table":
                return tag === "caption" || tag === "colgroup" || tag === "tbody" || tag === "tfoot" || tag === "thead" || tag === "style" || tag === "script" || tag === "template";
            // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-inhead
            case "head":
                return tag === "base" || tag === "basefont" || tag === "bgsound" || tag === "link" || tag === "meta" || tag === "title" || tag === "noscript" || tag === "noframes" || tag === "style" || tag === "script" || tag === "template";
            // https://html.spec.whatwg.org/multipage/semantics.html#the-html-element
            case "html":
                return tag === "head" || tag === "body" || tag === "frameset";
            case "frameset":
                return tag === "frame";
            case "#document":
                return tag === "html";
        } // Probably in the "in body" parsing mode, so we outlaw only tag combos
        // where the parsing rules cause implicit opens or closes to be added.
        // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-inbody
        switch(tag){
            case "h1":
            case "h2":
            case "h3":
            case "h4":
            case "h5":
            case "h6":
                return parentTag !== "h1" && parentTag !== "h2" && parentTag !== "h3" && parentTag !== "h4" && parentTag !== "h5" && parentTag !== "h6";
            case "rp":
            case "rt":
                return impliedEndTags.indexOf(parentTag) === -1;
            case "body":
            case "caption":
            case "col":
            case "colgroup":
            case "frameset":
            case "frame":
            case "head":
            case "html":
            case "tbody":
            case "td":
            case "tfoot":
            case "th":
            case "thead":
            case "tr":
                // These tags are only valid with a few parents that have special child
                // parsing rules -- if we're down here, then none of those matched and
                // so we allow it only if we don't know what the parent is, as all other
                // cases are invalid.
                return parentTag == null;
        }
        return true;
    };
    /**
   * Returns whether
   */ var findInvalidAncestorForTag = function(tag, ancestorInfo) {
        switch(tag){
            case "address":
            case "article":
            case "aside":
            case "blockquote":
            case "center":
            case "details":
            case "dialog":
            case "dir":
            case "div":
            case "dl":
            case "fieldset":
            case "figcaption":
            case "figure":
            case "footer":
            case "header":
            case "hgroup":
            case "main":
            case "menu":
            case "nav":
            case "ol":
            case "p":
            case "section":
            case "summary":
            case "ul":
            case "pre":
            case "listing":
            case "table":
            case "hr":
            case "xmp":
            case "h1":
            case "h2":
            case "h3":
            case "h4":
            case "h5":
            case "h6":
                return ancestorInfo.pTagInButtonScope;
            case "form":
                return ancestorInfo.formTag || ancestorInfo.pTagInButtonScope;
            case "li":
                return ancestorInfo.listItemTagAutoclosing;
            case "dd":
            case "dt":
                return ancestorInfo.dlItemTagAutoclosing;
            case "button":
                return ancestorInfo.buttonTagInScope;
            case "a":
                // Spec says something about storing a list of markers, but it sounds
                // equivalent to this check.
                return ancestorInfo.aTagInScope;
            case "nobr":
                return ancestorInfo.nobrTagInScope;
        }
        return null;
    };
    var didWarn$1 = {};
    validateDOMNesting = function(childTag, childText, ancestorInfo) {
        ancestorInfo = ancestorInfo || emptyAncestorInfo;
        var parentInfo = ancestorInfo.current;
        var parentTag = parentInfo && parentInfo.tag;
        if (childText != null) {
            if (childTag != null) error("validateDOMNesting: when childText is passed, childTag should be null");
            childTag = "#text";
        }
        var invalidParent = isTagValidWithParent(childTag, parentTag) ? null : parentInfo;
        var invalidAncestor = invalidParent ? null : findInvalidAncestorForTag(childTag, ancestorInfo);
        var invalidParentOrAncestor = invalidParent || invalidAncestor;
        if (!invalidParentOrAncestor) return;
        var ancestorTag = invalidParentOrAncestor.tag;
        var warnKey = !!invalidParent + "|" + childTag + "|" + ancestorTag;
        if (didWarn$1[warnKey]) return;
        didWarn$1[warnKey] = true;
        var tagDisplayName = childTag;
        var whitespaceInfo = "";
        if (childTag === "#text") {
            if (/\S/.test(childText)) tagDisplayName = "Text nodes";
            else {
                tagDisplayName = "Whitespace text nodes";
                whitespaceInfo = " Make sure you don't have any extra whitespace between tags on each line of your source code.";
            }
        } else tagDisplayName = "<" + childTag + ">";
        if (invalidParent) {
            var info = "";
            if (ancestorTag === "table" && childTag === "tr") info += " Add a <tbody>, <thead> or <tfoot> to your code to match the DOM tree generated by the browser.";
            error("validateDOMNesting(...): %s cannot appear as a child of <%s>.%s%s", tagDisplayName, ancestorTag, whitespaceInfo, info);
        } else error("validateDOMNesting(...): %s cannot appear as a descendant of <%s>.", tagDisplayName, ancestorTag);
    };
    var SUPPRESS_HYDRATION_WARNING$1 = "suppressHydrationWarning";
    var SUSPENSE_START_DATA = "$";
    var SUSPENSE_END_DATA = "/$";
    var SUSPENSE_PENDING_START_DATA = "$?";
    var SUSPENSE_FALLBACK_START_DATA = "$!";
    var STYLE$1 = "style";
    var eventsEnabled = null;
    var selectionInformation = null;
    function getRootHostContext(rootContainerInstance) {
        var type;
        var namespace;
        var nodeType = rootContainerInstance.nodeType;
        switch(nodeType){
            case DOCUMENT_NODE:
            case DOCUMENT_FRAGMENT_NODE:
                type = nodeType === DOCUMENT_NODE ? "#document" : "#fragment";
                var root = rootContainerInstance.documentElement;
                namespace = root ? root.namespaceURI : getChildNamespace(null, "");
                break;
            default:
                var container = nodeType === COMMENT_NODE ? rootContainerInstance.parentNode : rootContainerInstance;
                var ownNamespace = container.namespaceURI || null;
                type = container.tagName;
                namespace = getChildNamespace(ownNamespace, type);
                break;
        }
        var validatedTag = type.toLowerCase();
        var ancestorInfo = updatedAncestorInfo(null, validatedTag);
        return {
            namespace: namespace,
            ancestorInfo: ancestorInfo
        };
    }
    function getChildHostContext(parentHostContext, type, rootContainerInstance) {
        var parentHostContextDev = parentHostContext;
        var namespace = getChildNamespace(parentHostContextDev.namespace, type);
        var ancestorInfo = updatedAncestorInfo(parentHostContextDev.ancestorInfo, type);
        return {
            namespace: namespace,
            ancestorInfo: ancestorInfo
        };
    }
    function getPublicInstance(instance) {
        return instance;
    }
    function prepareForCommit(containerInfo) {
        eventsEnabled = isEnabled();
        selectionInformation = getSelectionInformation();
        var activeInstance = null;
        setEnabled(false);
        return activeInstance;
    }
    function resetAfterCommit(containerInfo) {
        restoreSelection(selectionInformation);
        setEnabled(eventsEnabled);
        eventsEnabled = null;
        selectionInformation = null;
    }
    function createInstance(type, props, rootContainerInstance, hostContext, internalInstanceHandle) {
        var parentNamespace;
        // TODO: take namespace into account when validating.
        var hostContextDev = hostContext;
        validateDOMNesting(type, null, hostContextDev.ancestorInfo);
        if (typeof props.children === "string" || typeof props.children === "number") {
            var string = "" + props.children;
            var ownAncestorInfo = updatedAncestorInfo(hostContextDev.ancestorInfo, type);
            validateDOMNesting(null, string, ownAncestorInfo);
        }
        parentNamespace = hostContextDev.namespace;
        var domElement = createElement(type, props, rootContainerInstance, parentNamespace);
        precacheFiberNode(internalInstanceHandle, domElement);
        updateFiberProps(domElement, props);
        return domElement;
    }
    function appendInitialChild(parentInstance, child) {
        parentInstance.appendChild(child);
    }
    function finalizeInitialChildren(domElement, type, props, rootContainerInstance, hostContext) {
        setInitialProperties(domElement, type, props, rootContainerInstance);
        switch(type){
            case "button":
            case "input":
            case "select":
            case "textarea":
                return !!props.autoFocus;
            case "img":
                return true;
            default:
                return false;
        }
    }
    function prepareUpdate(domElement, type, oldProps, newProps, rootContainerInstance, hostContext) {
        var hostContextDev = hostContext;
        if (typeof newProps.children !== typeof oldProps.children && (typeof newProps.children === "string" || typeof newProps.children === "number")) {
            var string = "" + newProps.children;
            var ownAncestorInfo = updatedAncestorInfo(hostContextDev.ancestorInfo, type);
            validateDOMNesting(null, string, ownAncestorInfo);
        }
        return diffProperties(domElement, type, oldProps, newProps);
    }
    function shouldSetTextContent(type, props) {
        return type === "textarea" || type === "noscript" || typeof props.children === "string" || typeof props.children === "number" || typeof props.dangerouslySetInnerHTML === "object" && props.dangerouslySetInnerHTML !== null && props.dangerouslySetInnerHTML.__html != null;
    }
    function createTextInstance(text, rootContainerInstance, hostContext, internalInstanceHandle) {
        var hostContextDev = hostContext;
        validateDOMNesting(null, text, hostContextDev.ancestorInfo);
        var textNode = createTextNode(text, rootContainerInstance);
        precacheFiberNode(internalInstanceHandle, textNode);
        return textNode;
    }
    function getCurrentEventPriority() {
        var currentEvent = window.event;
        if (currentEvent === undefined) return DefaultEventPriority;
        return getEventPriority(currentEvent.type);
    }
    // if a component just imports ReactDOM (e.g. for findDOMNode).
    // Some environments might not have setTimeout or clearTimeout.
    var scheduleTimeout = typeof setTimeout === "function" ? setTimeout : undefined;
    var cancelTimeout = typeof clearTimeout === "function" ? clearTimeout : undefined;
    var noTimeout = -1;
    var localPromise = typeof Promise === "function" ? Promise : undefined; // -------------------
    var scheduleMicrotask = typeof queueMicrotask === "function" ? queueMicrotask : typeof localPromise !== "undefined" ? function(callback) {
        return localPromise.resolve(null).then(callback).catch(handleErrorInNextTick);
    } : scheduleTimeout; // TODO: Determine the best fallback here.
    function handleErrorInNextTick(error) {
        setTimeout(function() {
            throw error;
        });
    } // -------------------
    function commitMount(domElement, type, newProps, internalInstanceHandle) {
        // Despite the naming that might imply otherwise, this method only
        // fires if there is an `Update` effect scheduled during mounting.
        // This happens if `finalizeInitialChildren` returns `true` (which it
        // does to implement the `autoFocus` attribute on the client). But
        // there are also other cases when this might happen (such as patching
        // up text content during hydration mismatch). So we'll check this again.
        switch(type){
            case "button":
            case "input":
            case "select":
            case "textarea":
                if (newProps.autoFocus) domElement.focus();
                return;
            case "img":
                if (newProps.src) domElement.src = newProps.src;
                return;
        }
    }
    function commitUpdate(domElement, updatePayload, type, oldProps, newProps, internalInstanceHandle) {
        // Apply the diff to the DOM node.
        updateProperties(domElement, updatePayload, type, oldProps, newProps); // Update the props handle so that we know which props are the ones with
        // with current event handlers.
        updateFiberProps(domElement, newProps);
    }
    function resetTextContent(domElement) {
        setTextContent(domElement, "");
    }
    function commitTextUpdate(textInstance, oldText, newText) {
        textInstance.nodeValue = newText;
    }
    function appendChild(parentInstance, child) {
        parentInstance.appendChild(child);
    }
    function appendChildToContainer(container, child) {
        var parentNode;
        if (container.nodeType === COMMENT_NODE) {
            parentNode = container.parentNode;
            parentNode.insertBefore(child, container);
        } else {
            parentNode = container;
            parentNode.appendChild(child);
        } // This container might be used for a portal.
        // If something inside a portal is clicked, that click should bubble
        // through the React tree. However, on Mobile Safari the click would
        // never bubble through the *DOM* tree unless an ancestor with onclick
        // event exists. So we wouldn't see it and dispatch it.
        // This is why we ensure that non React root containers have inline onclick
        // defined.
        // https://github.com/facebook/react/issues/11918
        var reactRootContainer = container._reactRootContainer;
        if ((reactRootContainer === null || reactRootContainer === undefined) && parentNode.onclick === null) // TODO: This cast may not be sound for SVG, MathML or custom elements.
        trapClickOnNonInteractiveElement(parentNode);
    }
    function insertBefore(parentInstance, child, beforeChild) {
        parentInstance.insertBefore(child, beforeChild);
    }
    function insertInContainerBefore(container, child, beforeChild) {
        if (container.nodeType === COMMENT_NODE) container.parentNode.insertBefore(child, beforeChild);
        else container.insertBefore(child, beforeChild);
    }
    function removeChild(parentInstance, child) {
        parentInstance.removeChild(child);
    }
    function removeChildFromContainer(container, child) {
        if (container.nodeType === COMMENT_NODE) container.parentNode.removeChild(child);
        else container.removeChild(child);
    }
    function clearSuspenseBoundary(parentInstance, suspenseInstance) {
        var node = suspenseInstance; // Delete all nodes within this suspense boundary.
        // There might be nested nodes so we need to keep track of how
        // deep we are and only break out when we're back on top.
        var depth = 0;
        do {
            var nextNode = node.nextSibling;
            parentInstance.removeChild(node);
            if (nextNode && nextNode.nodeType === COMMENT_NODE) {
                var data = nextNode.data;
                if (data === SUSPENSE_END_DATA) {
                    if (depth === 0) {
                        parentInstance.removeChild(nextNode); // Retry if any event replaying was blocked on this.
                        retryIfBlockedOn(suspenseInstance);
                        return;
                    } else depth--;
                } else if (data === SUSPENSE_START_DATA || data === SUSPENSE_PENDING_START_DATA || data === SUSPENSE_FALLBACK_START_DATA) depth++;
            }
            node = nextNode;
        }while (node); // TODO: Warn, we didn't find the end comment boundary.
        // Retry if any event replaying was blocked on this.
        retryIfBlockedOn(suspenseInstance);
    }
    function clearSuspenseBoundaryFromContainer(container, suspenseInstance) {
        if (container.nodeType === COMMENT_NODE) clearSuspenseBoundary(container.parentNode, suspenseInstance);
        else if (container.nodeType === ELEMENT_NODE) clearSuspenseBoundary(container, suspenseInstance);
         // Retry if any event replaying was blocked on this.
        retryIfBlockedOn(container);
    }
    function hideInstance(instance) {
        // TODO: Does this work for all element types? What about MathML? Should we
        // pass host context to this method?
        instance;
        var style = instance.style;
        if (typeof style.setProperty === "function") style.setProperty("display", "none", "important");
        else style.display = "none";
    }
    function hideTextInstance(textInstance) {
        textInstance.nodeValue = "";
    }
    function unhideInstance(instance, props) {
        instance;
        var styleProp = props[STYLE$1];
        var display = styleProp !== undefined && styleProp !== null && styleProp.hasOwnProperty("display") ? styleProp.display : null;
        instance.style.display = dangerousStyleValue("display", display);
    }
    function unhideTextInstance(textInstance, text) {
        textInstance.nodeValue = text;
    }
    function clearContainer(container) {
        if (container.nodeType === ELEMENT_NODE) container.textContent = "";
        else if (container.nodeType === DOCUMENT_NODE) {
            if (container.documentElement) container.removeChild(container.documentElement);
        }
    } // -------------------
    function canHydrateInstance(instance, type, props) {
        if (instance.nodeType !== ELEMENT_NODE || type.toLowerCase() !== instance.nodeName.toLowerCase()) return null;
         // This has now been refined to an element node.
        return instance;
    }
    function canHydrateTextInstance(instance, text) {
        if (text === "" || instance.nodeType !== TEXT_NODE) // Empty strings are not parsed by HTML so there won't be a correct match here.
        return null;
         // This has now been refined to a text node.
        return instance;
    }
    function canHydrateSuspenseInstance(instance) {
        if (instance.nodeType !== COMMENT_NODE) // Empty strings are not parsed by HTML so there won't be a correct match here.
        return null;
         // This has now been refined to a suspense node.
        return instance;
    }
    function isSuspenseInstancePending(instance) {
        return instance.data === SUSPENSE_PENDING_START_DATA;
    }
    function isSuspenseInstanceFallback(instance) {
        return instance.data === SUSPENSE_FALLBACK_START_DATA;
    }
    function getSuspenseInstanceFallbackErrorDetails(instance) {
        var dataset = instance.nextSibling && instance.nextSibling.dataset;
        var digest, message, stack;
        if (dataset) {
            digest = dataset.dgst;
            message = dataset.msg;
            stack = dataset.stck;
        }
        return {
            message: message,
            digest: digest,
            stack: stack
        };
    // const nextSibling = instance.nextSibling;
    // if (nextSibling) {
    //   const dataset = ((nextSibling: any): HTMLTemplateElement).dataset;
    //   value.message = dataset.msg;
    //   value.hash = dataset.hash;
    //   if (true) {
    //     value.stack = dataset.stack;
    //   }
    // }
    // return value;
    }
    function registerSuspenseInstanceRetry(instance, callback) {
        instance._reactRetry = callback;
    }
    function getNextHydratable(node) {
        // Skip non-hydratable nodes.
        for(; node != null; node = node.nextSibling){
            var nodeType = node.nodeType;
            if (nodeType === ELEMENT_NODE || nodeType === TEXT_NODE) break;
            if (nodeType === COMMENT_NODE) {
                var nodeData = node.data;
                if (nodeData === SUSPENSE_START_DATA || nodeData === SUSPENSE_FALLBACK_START_DATA || nodeData === SUSPENSE_PENDING_START_DATA) break;
                if (nodeData === SUSPENSE_END_DATA) return null;
            }
        }
        return node;
    }
    function getNextHydratableSibling(instance) {
        return getNextHydratable(instance.nextSibling);
    }
    function getFirstHydratableChild(parentInstance) {
        return getNextHydratable(parentInstance.firstChild);
    }
    function getFirstHydratableChildWithinContainer(parentContainer) {
        return getNextHydratable(parentContainer.firstChild);
    }
    function getFirstHydratableChildWithinSuspenseInstance(parentInstance) {
        return getNextHydratable(parentInstance.nextSibling);
    }
    function hydrateInstance(instance, type, props, rootContainerInstance, hostContext, internalInstanceHandle, shouldWarnDev) {
        precacheFiberNode(internalInstanceHandle, instance); // TODO: Possibly defer this until the commit phase where all the events
        // get attached.
        updateFiberProps(instance, props);
        var parentNamespace;
        var hostContextDev = hostContext;
        parentNamespace = hostContextDev.namespace;
        // when the legacy root API is removed.
        var isConcurrentMode = (internalInstanceHandle.mode & ConcurrentMode) !== NoMode;
        return diffHydratedProperties(instance, type, props, parentNamespace, rootContainerInstance, isConcurrentMode, shouldWarnDev);
    }
    function hydrateTextInstance(textInstance, text, internalInstanceHandle, shouldWarnDev) {
        precacheFiberNode(internalInstanceHandle, textInstance); // TODO: Temporary hack to check if we're in a concurrent root. We can delete
        // when the legacy root API is removed.
        var isConcurrentMode = (internalInstanceHandle.mode & ConcurrentMode) !== NoMode;
        return diffHydratedText(textInstance, text);
    }
    function hydrateSuspenseInstance(suspenseInstance, internalInstanceHandle) {
        precacheFiberNode(internalInstanceHandle, suspenseInstance);
    }
    function getNextHydratableInstanceAfterSuspenseInstance(suspenseInstance) {
        var node = suspenseInstance.nextSibling; // Skip past all nodes within this suspense boundary.
        // There might be nested nodes so we need to keep track of how
        // deep we are and only break out when we're back on top.
        var depth = 0;
        while(node){
            if (node.nodeType === COMMENT_NODE) {
                var data = node.data;
                if (data === SUSPENSE_END_DATA) {
                    if (depth === 0) return getNextHydratableSibling(node);
                    else depth--;
                } else if (data === SUSPENSE_START_DATA || data === SUSPENSE_FALLBACK_START_DATA || data === SUSPENSE_PENDING_START_DATA) depth++;
            }
            node = node.nextSibling;
        } // TODO: Warn, we didn't find the end comment boundary.
        return null;
    } // Returns the SuspenseInstance if this node is a direct child of a
    // SuspenseInstance. I.e. if its previous sibling is a Comment with
    // SUSPENSE_x_START_DATA. Otherwise, null.
    function getParentSuspenseInstance(targetInstance) {
        var node = targetInstance.previousSibling; // Skip past all nodes within this suspense boundary.
        // There might be nested nodes so we need to keep track of how
        // deep we are and only break out when we're back on top.
        var depth = 0;
        while(node){
            if (node.nodeType === COMMENT_NODE) {
                var data = node.data;
                if (data === SUSPENSE_START_DATA || data === SUSPENSE_FALLBACK_START_DATA || data === SUSPENSE_PENDING_START_DATA) {
                    if (depth === 0) return node;
                    else depth--;
                } else if (data === SUSPENSE_END_DATA) depth++;
            }
            node = node.previousSibling;
        }
        return null;
    }
    function commitHydratedContainer(container) {
        // Retry if any event replaying was blocked on this.
        retryIfBlockedOn(container);
    }
    function commitHydratedSuspenseInstance(suspenseInstance) {
        // Retry if any event replaying was blocked on this.
        retryIfBlockedOn(suspenseInstance);
    }
    function shouldDeleteUnhydratedTailInstances(parentType) {
        return parentType !== "head" && parentType !== "body";
    }
    function didNotMatchHydratedContainerTextInstance(parentContainer, textInstance, text, isConcurrentMode) {
        var shouldWarnDev = true;
        checkForUnmatchedText(textInstance.nodeValue, text, isConcurrentMode, shouldWarnDev);
    }
    function didNotMatchHydratedTextInstance(parentType, parentProps, parentInstance, textInstance, text, isConcurrentMode) {
        if (parentProps[SUPPRESS_HYDRATION_WARNING$1] !== true) {
            var shouldWarnDev = true;
            checkForUnmatchedText(textInstance.nodeValue, text, isConcurrentMode, shouldWarnDev);
        }
    }
    function didNotHydrateInstanceWithinContainer(parentContainer, instance) {
        if (instance.nodeType === ELEMENT_NODE) warnForDeletedHydratableElement(parentContainer, instance);
        else if (instance.nodeType === COMMENT_NODE) ;
        else warnForDeletedHydratableText(parentContainer, instance);
    }
    function didNotHydrateInstanceWithinSuspenseInstance(parentInstance, instance) {
        // $FlowFixMe: Only Element or Document can be parent nodes.
        var parentNode = parentInstance.parentNode;
        if (parentNode !== null) {
            if (instance.nodeType === ELEMENT_NODE) warnForDeletedHydratableElement(parentNode, instance);
            else if (instance.nodeType === COMMENT_NODE) ;
            else warnForDeletedHydratableText(parentNode, instance);
        }
    }
    function didNotHydrateInstance(parentType, parentProps, parentInstance, instance, isConcurrentMode) {
        if (isConcurrentMode || parentProps[SUPPRESS_HYDRATION_WARNING$1] !== true) {
            if (instance.nodeType === ELEMENT_NODE) warnForDeletedHydratableElement(parentInstance, instance);
            else if (instance.nodeType === COMMENT_NODE) ;
            else warnForDeletedHydratableText(parentInstance, instance);
        }
    }
    function didNotFindHydratableInstanceWithinContainer(parentContainer, type, props) {
        warnForInsertedHydratedElement(parentContainer, type);
    }
    function didNotFindHydratableTextInstanceWithinContainer(parentContainer, text) {
        warnForInsertedHydratedText(parentContainer, text);
    }
    function didNotFindHydratableInstanceWithinSuspenseInstance(parentInstance, type, props) {
        // $FlowFixMe: Only Element or Document can be parent nodes.
        var parentNode = parentInstance.parentNode;
        if (parentNode !== null) warnForInsertedHydratedElement(parentNode, type);
    }
    function didNotFindHydratableTextInstanceWithinSuspenseInstance(parentInstance, text) {
        // $FlowFixMe: Only Element or Document can be parent nodes.
        var parentNode = parentInstance.parentNode;
        if (parentNode !== null) warnForInsertedHydratedText(parentNode, text);
    }
    function didNotFindHydratableInstance(parentType, parentProps, parentInstance, type, props, isConcurrentMode) {
        if (isConcurrentMode || parentProps[SUPPRESS_HYDRATION_WARNING$1] !== true) warnForInsertedHydratedElement(parentInstance, type);
    }
    function didNotFindHydratableTextInstance(parentType, parentProps, parentInstance, text, isConcurrentMode) {
        if (isConcurrentMode || parentProps[SUPPRESS_HYDRATION_WARNING$1] !== true) warnForInsertedHydratedText(parentInstance, text);
    }
    function errorHydratingContainer(parentContainer) {
        // TODO: This gets logged by onRecoverableError, too, so we should be
        // able to remove it.
        error("An error occurred during hydration. The server HTML was replaced with client content in <%s>.", parentContainer.nodeName.toLowerCase());
    }
    function preparePortalMount(portalInstance) {
        listenToAllSupportedEvents(portalInstance);
    }
    var randomKey = Math.random().toString(36).slice(2);
    var internalInstanceKey = "__reactFiber$" + randomKey;
    var internalPropsKey = "__reactProps$" + randomKey;
    var internalContainerInstanceKey = "__reactContainer$" + randomKey;
    var internalEventHandlersKey = "__reactEvents$" + randomKey;
    var internalEventHandlerListenersKey = "__reactListeners$" + randomKey;
    var internalEventHandlesSetKey = "__reactHandles$" + randomKey;
    function detachDeletedInstance(node) {
        // TODO: This function is only called on host components. I don't think all of
        // these fields are relevant.
        delete node[internalInstanceKey];
        delete node[internalPropsKey];
        delete node[internalEventHandlersKey];
        delete node[internalEventHandlerListenersKey];
        delete node[internalEventHandlesSetKey];
    }
    function precacheFiberNode(hostInst, node) {
        node[internalInstanceKey] = hostInst;
    }
    function markContainerAsRoot(hostRoot, node) {
        node[internalContainerInstanceKey] = hostRoot;
    }
    function unmarkContainerAsRoot(node) {
        node[internalContainerInstanceKey] = null;
    }
    function isContainerMarkedAsRoot(node) {
        return !!node[internalContainerInstanceKey];
    } // Given a DOM node, return the closest HostComponent or HostText fiber ancestor.
    // If the target node is part of a hydrated or not yet rendered subtree, then
    // this may also return a SuspenseComponent or HostRoot to indicate that.
    // Conceptually the HostRoot fiber is a child of the Container node. So if you
    // pass the Container node as the targetNode, you will not actually get the
    // HostRoot back. To get to the HostRoot, you need to pass a child of it.
    // The same thing applies to Suspense boundaries.
    function getClosestInstanceFromNode(targetNode) {
        var targetInst = targetNode[internalInstanceKey];
        if (targetInst) // Don't return HostRoot or SuspenseComponent here.
        return targetInst;
         // If the direct event target isn't a React owned DOM node, we need to look
        // to see if one of its parents is a React owned DOM node.
        var parentNode = targetNode.parentNode;
        while(parentNode){
            // We'll check if this is a container root that could include
            // React nodes in the future. We need to check this first because
            // if we're a child of a dehydrated container, we need to first
            // find that inner container before moving on to finding the parent
            // instance. Note that we don't check this field on  the targetNode
            // itself because the fibers are conceptually between the container
            // node and the first child. It isn't surrounding the container node.
            // If it's not a container, we check if it's an instance.
            targetInst = parentNode[internalContainerInstanceKey] || parentNode[internalInstanceKey];
            if (targetInst) {
                // Since this wasn't the direct target of the event, we might have
                // stepped past dehydrated DOM nodes to get here. However they could
                // also have been non-React nodes. We need to answer which one.
                // If we the instance doesn't have any children, then there can't be
                // a nested suspense boundary within it. So we can use this as a fast
                // bailout. Most of the time, when people add non-React children to
                // the tree, it is using a ref to a child-less DOM node.
                // Normally we'd only need to check one of the fibers because if it
                // has ever gone from having children to deleting them or vice versa
                // it would have deleted the dehydrated boundary nested inside already.
                // However, since the HostRoot starts out with an alternate it might
                // have one on the alternate so we need to check in case this was a
                // root.
                var alternate = targetInst.alternate;
                if (targetInst.child !== null || alternate !== null && alternate.child !== null) {
                    // Next we need to figure out if the node that skipped past is
                    // nested within a dehydrated boundary and if so, which one.
                    var suspenseInstance = getParentSuspenseInstance(targetNode);
                    while(suspenseInstance !== null){
                        // We found a suspense instance. That means that we haven't
                        // hydrated it yet. Even though we leave the comments in the
                        // DOM after hydrating, and there are boundaries in the DOM
                        // that could already be hydrated, we wouldn't have found them
                        // through this pass since if the target is hydrated it would
                        // have had an internalInstanceKey on it.
                        // Let's get the fiber associated with the SuspenseComponent
                        // as the deepest instance.
                        var targetSuspenseInst = suspenseInstance[internalInstanceKey];
                        if (targetSuspenseInst) return targetSuspenseInst;
                         // If we don't find a Fiber on the comment, it might be because
                        // we haven't gotten to hydrate it yet. There might still be a
                        // parent boundary that hasn't above this one so we need to find
                        // the outer most that is known.
                        suspenseInstance = getParentSuspenseInstance(suspenseInstance); // If we don't find one, then that should mean that the parent
                    // host component also hasn't hydrated yet. We can return it
                    // below since it will bail out on the isMounted check later.
                    }
                }
                return targetInst;
            }
            targetNode = parentNode;
            parentNode = targetNode.parentNode;
        }
        return null;
    }
    /**
 * Given a DOM node, return the ReactDOMComponent or ReactDOMTextComponent
 * instance, or null if the node was not rendered by this React.
 */ function getInstanceFromNode(node) {
        var inst = node[internalInstanceKey] || node[internalContainerInstanceKey];
        if (inst) {
            if (inst.tag === HostComponent || inst.tag === HostText || inst.tag === SuspenseComponent || inst.tag === HostRoot) return inst;
            else return null;
        }
        return null;
    }
    /**
 * Given a ReactDOMComponent or ReactDOMTextComponent, return the corresponding
 * DOM node.
 */ function getNodeFromInstance(inst) {
        if (inst.tag === HostComponent || inst.tag === HostText) // In Fiber this, is just the state node right now. We assume it will be
        // a host component or host text.
        return inst.stateNode;
         // Without this first invariant, passing a non-DOM-component triggers the next
        // invariant for a missing parent, which is super confusing.
        throw new Error("getNodeFromInstance: Invalid argument.");
    }
    function getFiberCurrentPropsFromNode(node) {
        return node[internalPropsKey] || null;
    }
    function updateFiberProps(node, props) {
        node[internalPropsKey] = props;
    }
    function getEventListenerSet(node) {
        var elementListenerSet = node[internalEventHandlersKey];
        if (elementListenerSet === undefined) elementListenerSet = node[internalEventHandlersKey] = new Set();
        return elementListenerSet;
    }
    var loggedTypeFailures = {};
    var ReactDebugCurrentFrame$1 = ReactSharedInternals.ReactDebugCurrentFrame;
    function setCurrentlyValidatingElement(element) {
        if (element) {
            var owner = element._owner;
            var stack = describeUnknownElementTypeFrameInDEV(element.type, element._source, owner ? owner.type : null);
            ReactDebugCurrentFrame$1.setExtraStackFrame(stack);
        } else ReactDebugCurrentFrame$1.setExtraStackFrame(null);
    }
    function checkPropTypes(typeSpecs, values, location, componentName, element) {
        // $FlowFixMe This is okay but Flow doesn't know it.
        var has = Function.call.bind(hasOwnProperty);
        for(var typeSpecName in typeSpecs)if (has(typeSpecs, typeSpecName)) {
            var error$1 = void 0; // Prop type validation may throw. In case they do, we don't want to
            // fail the render phase where it didn't fail before. So we log it.
            // After these have been cleaned up, we'll let them throw.
            try {
                // This is intentionally an invariant that gets caught. It's the same
                // behavior as without this statement except with a better message.
                if (typeof typeSpecs[typeSpecName] !== "function") {
                    // eslint-disable-next-line react-internal/prod-error-codes
                    var err = Error((componentName || "React class") + ": " + location + " type `" + typeSpecName + "` is invalid; " + "it must be a function, usually from the `prop-types` package, but received `" + typeof typeSpecs[typeSpecName] + "`." + "This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                    err.name = "Invariant Violation";
                    throw err;
                }
                error$1 = typeSpecs[typeSpecName](values, typeSpecName, componentName, location, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (ex) {
                error$1 = ex;
            }
            if (error$1 && !(error$1 instanceof Error)) {
                setCurrentlyValidatingElement(element);
                error("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", componentName || "React class", location, typeSpecName, typeof error$1);
                setCurrentlyValidatingElement(null);
            }
            if (error$1 instanceof Error && !(error$1.message in loggedTypeFailures)) {
                // Only monitor this failure once because there tends to be a lot of the
                // same error.
                loggedTypeFailures[error$1.message] = true;
                setCurrentlyValidatingElement(element);
                error("Failed %s type: %s", location, error$1.message);
                setCurrentlyValidatingElement(null);
            }
        }
    }
    var valueStack = [];
    var fiberStack;
    fiberStack = [];
    var index = -1;
    function createCursor(defaultValue) {
        return {
            current: defaultValue
        };
    }
    function pop(cursor, fiber) {
        if (index < 0) {
            error("Unexpected pop.");
            return;
        }
        if (fiber !== fiberStack[index]) error("Unexpected Fiber popped.");
        cursor.current = valueStack[index];
        valueStack[index] = null;
        fiberStack[index] = null;
        index--;
    }
    function push(cursor, value, fiber) {
        index++;
        valueStack[index] = cursor.current;
        fiberStack[index] = fiber;
        cursor.current = value;
    }
    var warnedAboutMissingGetChildContext;
    warnedAboutMissingGetChildContext = {};
    var emptyContextObject = {};
    Object.freeze(emptyContextObject);
    var contextStackCursor = createCursor(emptyContextObject); // A cursor to a boolean indicating whether the context has changed.
    var didPerformWorkStackCursor = createCursor(false); // Keep track of the previous context object that was on the stack.
    // We use this to get access to the parent context after we have already
    // pushed the next context provider, and now need to merge their contexts.
    var previousContext = emptyContextObject;
    function getUnmaskedContext(workInProgress, Component, didPushOwnContextIfProvider) {
        if (didPushOwnContextIfProvider && isContextProvider(Component)) // If the fiber is a context provider itself, when we read its context
        // we may have already pushed its own child context on the stack. A context
        // provider should not "see" its own child context. Therefore we read the
        // previous (parent) context instead for a context provider.
        return previousContext;
        return contextStackCursor.current;
    }
    function cacheContext(workInProgress, unmaskedContext, maskedContext) {
        var instance = workInProgress.stateNode;
        instance.__reactInternalMemoizedUnmaskedChildContext = unmaskedContext;
        instance.__reactInternalMemoizedMaskedChildContext = maskedContext;
    }
    function getMaskedContext(workInProgress, unmaskedContext) {
        var type = workInProgress.type;
        var contextTypes = type.contextTypes;
        if (!contextTypes) return emptyContextObject;
         // Avoid recreating masked context unless unmasked context has changed.
        // Failing to do this will result in unnecessary calls to componentWillReceiveProps.
        // This may trigger infinite loops if componentWillReceiveProps calls setState.
        var instance = workInProgress.stateNode;
        if (instance && instance.__reactInternalMemoizedUnmaskedChildContext === unmaskedContext) return instance.__reactInternalMemoizedMaskedChildContext;
        var context = {};
        for(var key in contextTypes)context[key] = unmaskedContext[key];
        var name = getComponentNameFromFiber(workInProgress) || "Unknown";
        checkPropTypes(contextTypes, context, "context", name);
        // Context is created before the class component is instantiated so check for instance.
        if (instance) cacheContext(workInProgress, unmaskedContext, context);
        return context;
    }
    function hasContextChanged() {
        return didPerformWorkStackCursor.current;
    }
    function isContextProvider(type) {
        var childContextTypes = type.childContextTypes;
        return childContextTypes !== null && childContextTypes !== undefined;
    }
    function popContext(fiber) {
        pop(didPerformWorkStackCursor, fiber);
        pop(contextStackCursor, fiber);
    }
    function popTopLevelContextObject(fiber) {
        pop(didPerformWorkStackCursor, fiber);
        pop(contextStackCursor, fiber);
    }
    function pushTopLevelContextObject(fiber, context, didChange) {
        if (contextStackCursor.current !== emptyContextObject) throw new Error("Unexpected context found on stack. This error is likely caused by a bug in React. Please file an issue.");
        push(contextStackCursor, context, fiber);
        push(didPerformWorkStackCursor, didChange, fiber);
    }
    function processChildContext(fiber, type, parentContext) {
        var instance = fiber.stateNode;
        var childContextTypes = type.childContextTypes; // TODO (bvaughn) Replace this behavior with an invariant() in the future.
        // It has only been added in Fiber to match the (unintentional) behavior in Stack.
        if (typeof instance.getChildContext !== "function") {
            var componentName = getComponentNameFromFiber(fiber) || "Unknown";
            if (!warnedAboutMissingGetChildContext[componentName]) {
                warnedAboutMissingGetChildContext[componentName] = true;
                error("%s.childContextTypes is specified but there is no getChildContext() method on the instance. You can either define getChildContext() on %s or remove childContextTypes from it.", componentName, componentName);
            }
            return parentContext;
        }
        var childContext = instance.getChildContext();
        for(var contextKey in childContext){
            if (!(contextKey in childContextTypes)) throw new Error((getComponentNameFromFiber(fiber) || "Unknown") + '.getChildContext(): key "' + contextKey + '" is not defined in childContextTypes.');
        }
        var name = getComponentNameFromFiber(fiber) || "Unknown";
        checkPropTypes(childContextTypes, childContext, "child context", name);
        return assign({}, parentContext, childContext);
    }
    function pushContextProvider(workInProgress) {
        var instance = workInProgress.stateNode; // We push the context as early as possible to ensure stack integrity.
        // If the instance does not exist yet, we will push null at first,
        // and replace it on the stack later when invalidating the context.
        var memoizedMergedChildContext = instance && instance.__reactInternalMemoizedMergedChildContext || emptyContextObject; // Remember the parent context so we can merge with it later.
        // Inherit the parent's did-perform-work value to avoid inadvertently blocking updates.
        previousContext = contextStackCursor.current;
        push(contextStackCursor, memoizedMergedChildContext, workInProgress);
        push(didPerformWorkStackCursor, didPerformWorkStackCursor.current, workInProgress);
        return true;
    }
    function invalidateContextProvider(workInProgress, type, didChange) {
        var instance = workInProgress.stateNode;
        if (!instance) throw new Error("Expected to have an instance by this point. This error is likely caused by a bug in React. Please file an issue.");
        if (didChange) {
            // Merge parent and own context.
            // Skip this if we're not updating due to sCU.
            // This avoids unnecessarily recomputing memoized values.
            var mergedContext = processChildContext(workInProgress, type, previousContext);
            instance.__reactInternalMemoizedMergedChildContext = mergedContext; // Replace the old (or empty) context with the new one.
            // It is important to unwind the context in the reverse order.
            pop(didPerformWorkStackCursor, workInProgress);
            pop(contextStackCursor, workInProgress); // Now push the new context and mark that it has changed.
            push(contextStackCursor, mergedContext, workInProgress);
            push(didPerformWorkStackCursor, didChange, workInProgress);
        } else {
            pop(didPerformWorkStackCursor, workInProgress);
            push(didPerformWorkStackCursor, didChange, workInProgress);
        }
    }
    function findCurrentUnmaskedContext(fiber) {
        // Currently this is only used with renderSubtreeIntoContainer; not sure if it
        // makes sense elsewhere
        if (!isFiberMounted(fiber) || fiber.tag !== ClassComponent) throw new Error("Expected subtree parent to be a mounted class component. This error is likely caused by a bug in React. Please file an issue.");
        var node = fiber;
        do {
            switch(node.tag){
                case HostRoot:
                    return node.stateNode.context;
                case ClassComponent:
                    var Component = node.type;
                    if (isContextProvider(Component)) return node.stateNode.__reactInternalMemoizedMergedChildContext;
                    break;
            }
            node = node.return;
        }while (node !== null);
        throw new Error("Found unexpected detached subtree parent. This error is likely caused by a bug in React. Please file an issue.");
    }
    var LegacyRoot = 0;
    var ConcurrentRoot = 1;
    var syncQueue = null;
    var includesLegacySyncCallbacks = false;
    var isFlushingSyncQueue = false;
    function scheduleSyncCallback(callback) {
        // Push this callback into an internal queue. We'll flush these either in
        // the next tick, or earlier if something calls `flushSyncCallbackQueue`.
        if (syncQueue === null) syncQueue = [
            callback
        ];
        else // Push onto existing queue. Don't need to schedule a callback because
        // we already scheduled one when we created the queue.
        syncQueue.push(callback);
    }
    function scheduleLegacySyncCallback(callback) {
        includesLegacySyncCallbacks = true;
        scheduleSyncCallback(callback);
    }
    function flushSyncCallbacksOnlyInLegacyMode() {
        // Only flushes the queue if there's a legacy sync callback scheduled.
        // TODO: There's only a single type of callback: performSyncOnWorkOnRoot. So
        // it might make more sense for the queue to be a list of roots instead of a
        // list of generic callbacks. Then we can have two: one for legacy roots, one
        // for concurrent roots. And this method would only flush the legacy ones.
        if (includesLegacySyncCallbacks) flushSyncCallbacks();
    }
    function flushSyncCallbacks() {
        if (!isFlushingSyncQueue && syncQueue !== null) {
            // Prevent re-entrance.
            isFlushingSyncQueue = true;
            var i = 0;
            var previousUpdatePriority = getCurrentUpdatePriority();
            try {
                var isSync = true;
                var queue = syncQueue; // TODO: Is this necessary anymore? The only user code that runs in this
                // queue is in the render or commit phases.
                setCurrentUpdatePriority(DiscreteEventPriority);
                for(; i < queue.length; i++){
                    var callback = queue[i];
                    do callback = callback(isSync);
                    while (callback !== null);
                }
                syncQueue = null;
                includesLegacySyncCallbacks = false;
            } catch (error) {
                // If something throws, leave the remaining callbacks on the queue.
                if (syncQueue !== null) syncQueue = syncQueue.slice(i + 1);
                 // Resume flushing in the next tick
                scheduleCallback(ImmediatePriority, flushSyncCallbacks);
                throw error;
            } finally{
                setCurrentUpdatePriority(previousUpdatePriority);
                isFlushingSyncQueue = false;
            }
        }
        return null;
    }
    // TODO: Use the unified fiber stack module instead of this local one?
    // Intentionally not using it yet to derisk the initial implementation, because
    // the way we push/pop these values is a bit unusual. If there's a mistake, I'd
    // rather the ids be wrong than crash the whole reconciler.
    var forkStack = [];
    var forkStackIndex = 0;
    var treeForkProvider = null;
    var treeForkCount = 0;
    var idStack = [];
    var idStackIndex = 0;
    var treeContextProvider = null;
    var treeContextId = 1;
    var treeContextOverflow = "";
    function isForkedChild(workInProgress) {
        warnIfNotHydrating();
        return (workInProgress.flags & Forked) !== NoFlags;
    }
    function getForksAtLevel(workInProgress) {
        warnIfNotHydrating();
        return treeForkCount;
    }
    function getTreeId() {
        var overflow = treeContextOverflow;
        var idWithLeadingBit = treeContextId;
        var id = idWithLeadingBit & ~getLeadingBit(idWithLeadingBit);
        return id.toString(32) + overflow;
    }
    function pushTreeFork(workInProgress, totalChildren) {
        // This is called right after we reconcile an array (or iterator) of child
        // fibers, because that's the only place where we know how many children in
        // the whole set without doing extra work later, or storing addtional
        // information on the fiber.
        //
        // That's why this function is separate from pushTreeId — it's called during
        // the render phase of the fork parent, not the child, which is where we push
        // the other context values.
        //
        // In the Fizz implementation this is much simpler because the child is
        // rendered in the same callstack as the parent.
        //
        // It might be better to just add a `forks` field to the Fiber type. It would
        // make this module simpler.
        warnIfNotHydrating();
        forkStack[forkStackIndex++] = treeForkCount;
        forkStack[forkStackIndex++] = treeForkProvider;
        treeForkProvider = workInProgress;
        treeForkCount = totalChildren;
    }
    function pushTreeId(workInProgress, totalChildren, index) {
        warnIfNotHydrating();
        idStack[idStackIndex++] = treeContextId;
        idStack[idStackIndex++] = treeContextOverflow;
        idStack[idStackIndex++] = treeContextProvider;
        treeContextProvider = workInProgress;
        var baseIdWithLeadingBit = treeContextId;
        var baseOverflow = treeContextOverflow; // The leftmost 1 marks the end of the sequence, non-inclusive. It's not part
        // of the id; we use it to account for leading 0s.
        var baseLength = getBitLength(baseIdWithLeadingBit) - 1;
        var baseId = baseIdWithLeadingBit & ~(1 << baseLength);
        var slot = index + 1;
        var length = getBitLength(totalChildren) + baseLength; // 30 is the max length we can store without overflowing, taking into
        // consideration the leading 1 we use to mark the end of the sequence.
        if (length > 30) {
            // We overflowed the bitwise-safe range. Fall back to slower algorithm.
            // This branch assumes the length of the base id is greater than 5; it won't
            // work for smaller ids, because you need 5 bits per character.
            //
            // We encode the id in multiple steps: first the base id, then the
            // remaining digits.
            //
            // Each 5 bit sequence corresponds to a single base 32 character. So for
            // example, if the current id is 23 bits long, we can convert 20 of those
            // bits into a string of 4 characters, with 3 bits left over.
            //
            // First calculate how many bits in the base id represent a complete
            // sequence of characters.
            var numberOfOverflowBits = baseLength - baseLength % 5; // Then create a bitmask that selects only those bits.
            var newOverflowBits = (1 << numberOfOverflowBits) - 1; // Select the bits, and convert them to a base 32 string.
            var newOverflow = (baseId & newOverflowBits).toString(32); // Now we can remove those bits from the base id.
            var restOfBaseId = baseId >> numberOfOverflowBits;
            var restOfBaseLength = baseLength - numberOfOverflowBits; // Finally, encode the rest of the bits using the normal algorithm. Because
            // we made more room, this time it won't overflow.
            var restOfLength = getBitLength(totalChildren) + restOfBaseLength;
            var restOfNewBits = slot << restOfBaseLength;
            var id = restOfNewBits | restOfBaseId;
            var overflow = newOverflow + baseOverflow;
            treeContextId = 1 << restOfLength | id;
            treeContextOverflow = overflow;
        } else {
            // Normal path
            var newBits = slot << baseLength;
            var _id = newBits | baseId;
            var _overflow = baseOverflow;
            treeContextId = 1 << length | _id;
            treeContextOverflow = _overflow;
        }
    }
    function pushMaterializedTreeId(workInProgress) {
        warnIfNotHydrating(); // This component materialized an id. This will affect any ids that appear
        // in its children.
        var returnFiber = workInProgress.return;
        if (returnFiber !== null) {
            var numberOfForks = 1;
            var slotIndex = 0;
            pushTreeFork(workInProgress, numberOfForks);
            pushTreeId(workInProgress, numberOfForks, slotIndex);
        }
    }
    function getBitLength(number) {
        return 32 - clz32(number);
    }
    function getLeadingBit(id) {
        return 1 << getBitLength(id) - 1;
    }
    function popTreeContext(workInProgress) {
        // Restore the previous values.
        // This is a bit more complicated than other context-like modules in Fiber
        // because the same Fiber may appear on the stack multiple times and for
        // different reasons. We have to keep popping until the work-in-progress is
        // no longer at the top of the stack.
        while(workInProgress === treeForkProvider){
            treeForkProvider = forkStack[--forkStackIndex];
            forkStack[forkStackIndex] = null;
            treeForkCount = forkStack[--forkStackIndex];
            forkStack[forkStackIndex] = null;
        }
        while(workInProgress === treeContextProvider){
            treeContextProvider = idStack[--idStackIndex];
            idStack[idStackIndex] = null;
            treeContextOverflow = idStack[--idStackIndex];
            idStack[idStackIndex] = null;
            treeContextId = idStack[--idStackIndex];
            idStack[idStackIndex] = null;
        }
    }
    function getSuspendedTreeContext() {
        warnIfNotHydrating();
        if (treeContextProvider !== null) return {
            id: treeContextId,
            overflow: treeContextOverflow
        };
        else return null;
    }
    function restoreSuspendedTreeContext(workInProgress, suspendedContext) {
        warnIfNotHydrating();
        idStack[idStackIndex++] = treeContextId;
        idStack[idStackIndex++] = treeContextOverflow;
        idStack[idStackIndex++] = treeContextProvider;
        treeContextId = suspendedContext.id;
        treeContextOverflow = suspendedContext.overflow;
        treeContextProvider = workInProgress;
    }
    function warnIfNotHydrating() {
        if (!getIsHydrating()) error("Expected to be hydrating. This is a bug in React. Please file an issue.");
    }
    // This may have been an insertion or a hydration.
    var hydrationParentFiber = null;
    var nextHydratableInstance = null;
    var isHydrating = false; // This flag allows for warning supression when we expect there to be mismatches
    // due to earlier mismatches or a suspended fiber.
    var didSuspendOrErrorDEV = false; // Hydration errors that were thrown inside this boundary
    var hydrationErrors = null;
    function warnIfHydrating() {
        if (isHydrating) error("We should not be hydrating here. This is a bug in React. Please file a bug.");
    }
    function markDidThrowWhileHydratingDEV() {
        didSuspendOrErrorDEV = true;
    }
    function didSuspendOrErrorWhileHydratingDEV() {
        return didSuspendOrErrorDEV;
    }
    function enterHydrationState(fiber) {
        var parentInstance = fiber.stateNode.containerInfo;
        nextHydratableInstance = getFirstHydratableChildWithinContainer(parentInstance);
        hydrationParentFiber = fiber;
        isHydrating = true;
        hydrationErrors = null;
        didSuspendOrErrorDEV = false;
        return true;
    }
    function reenterHydrationStateFromDehydratedSuspenseInstance(fiber, suspenseInstance, treeContext) {
        nextHydratableInstance = getFirstHydratableChildWithinSuspenseInstance(suspenseInstance);
        hydrationParentFiber = fiber;
        isHydrating = true;
        hydrationErrors = null;
        didSuspendOrErrorDEV = false;
        if (treeContext !== null) restoreSuspendedTreeContext(fiber, treeContext);
        return true;
    }
    function warnUnhydratedInstance(returnFiber, instance) {
        switch(returnFiber.tag){
            case HostRoot:
                didNotHydrateInstanceWithinContainer(returnFiber.stateNode.containerInfo, instance);
                break;
            case HostComponent:
                var isConcurrentMode = (returnFiber.mode & ConcurrentMode) !== NoMode;
                didNotHydrateInstance(returnFiber.type, returnFiber.memoizedProps, returnFiber.stateNode, instance, isConcurrentMode);
                break;
            case SuspenseComponent:
                var suspenseState = returnFiber.memoizedState;
                if (suspenseState.dehydrated !== null) didNotHydrateInstanceWithinSuspenseInstance(suspenseState.dehydrated, instance);
                break;
        }
    }
    function deleteHydratableInstance(returnFiber, instance) {
        warnUnhydratedInstance(returnFiber, instance);
        var childToDelete = createFiberFromHostInstanceForDeletion();
        childToDelete.stateNode = instance;
        childToDelete.return = returnFiber;
        var deletions = returnFiber.deletions;
        if (deletions === null) {
            returnFiber.deletions = [
                childToDelete
            ];
            returnFiber.flags |= ChildDeletion;
        } else deletions.push(childToDelete);
    }
    function warnNonhydratedInstance(returnFiber, fiber) {
        if (didSuspendOrErrorDEV) // Inside a boundary that already suspended. We're currently rendering the
        // siblings of a suspended node. The mismatch may be due to the missing
        // data, so it's probably a false positive.
        return;
        switch(returnFiber.tag){
            case HostRoot:
                var parentContainer = returnFiber.stateNode.containerInfo;
                switch(fiber.tag){
                    case HostComponent:
                        var type = fiber.type;
                        var props = fiber.pendingProps;
                        didNotFindHydratableInstanceWithinContainer(parentContainer, type);
                        break;
                    case HostText:
                        var text = fiber.pendingProps;
                        didNotFindHydratableTextInstanceWithinContainer(parentContainer, text);
                        break;
                }
                break;
            case HostComponent:
                var parentType = returnFiber.type;
                var parentProps = returnFiber.memoizedProps;
                var parentInstance = returnFiber.stateNode;
                switch(fiber.tag){
                    case HostComponent:
                        var _type = fiber.type;
                        var _props = fiber.pendingProps;
                        var isConcurrentMode = (returnFiber.mode & ConcurrentMode) !== NoMode;
                        didNotFindHydratableInstance(parentType, parentProps, parentInstance, _type, _props, isConcurrentMode);
                        break;
                    case HostText:
                        var _text = fiber.pendingProps;
                        var _isConcurrentMode = (returnFiber.mode & ConcurrentMode) !== NoMode;
                        didNotFindHydratableTextInstance(parentType, parentProps, parentInstance, _text, _isConcurrentMode);
                        break;
                }
                break;
            case SuspenseComponent:
                var suspenseState = returnFiber.memoizedState;
                var _parentInstance = suspenseState.dehydrated;
                if (_parentInstance !== null) switch(fiber.tag){
                    case HostComponent:
                        var _type2 = fiber.type;
                        var _props2 = fiber.pendingProps;
                        didNotFindHydratableInstanceWithinSuspenseInstance(_parentInstance, _type2);
                        break;
                    case HostText:
                        var _text2 = fiber.pendingProps;
                        didNotFindHydratableTextInstanceWithinSuspenseInstance(_parentInstance, _text2);
                        break;
                }
                break;
            default:
                return;
        }
    }
    function insertNonHydratedInstance(returnFiber, fiber) {
        fiber.flags = fiber.flags & ~Hydrating | Placement;
        warnNonhydratedInstance(returnFiber, fiber);
    }
    function tryHydrate(fiber, nextInstance) {
        switch(fiber.tag){
            case HostComponent:
                var type = fiber.type;
                var props = fiber.pendingProps;
                var instance = canHydrateInstance(nextInstance, type);
                if (instance !== null) {
                    fiber.stateNode = instance;
                    hydrationParentFiber = fiber;
                    nextHydratableInstance = getFirstHydratableChild(instance);
                    return true;
                }
                return false;
            case HostText:
                var text = fiber.pendingProps;
                var textInstance = canHydrateTextInstance(nextInstance, text);
                if (textInstance !== null) {
                    fiber.stateNode = textInstance;
                    hydrationParentFiber = fiber; // Text Instances don't have children so there's nothing to hydrate.
                    nextHydratableInstance = null;
                    return true;
                }
                return false;
            case SuspenseComponent:
                var suspenseInstance = canHydrateSuspenseInstance(nextInstance);
                if (suspenseInstance !== null) {
                    var suspenseState = {
                        dehydrated: suspenseInstance,
                        treeContext: getSuspendedTreeContext(),
                        retryLane: OffscreenLane
                    };
                    fiber.memoizedState = suspenseState; // Store the dehydrated fragment as a child fiber.
                    // This simplifies the code for getHostSibling and deleting nodes,
                    // since it doesn't have to consider all Suspense boundaries and
                    // check if they're dehydrated ones or not.
                    var dehydratedFragment = createFiberFromDehydratedFragment(suspenseInstance);
                    dehydratedFragment.return = fiber;
                    fiber.child = dehydratedFragment;
                    hydrationParentFiber = fiber; // While a Suspense Instance does have children, we won't step into
                    // it during the first pass. Instead, we'll reenter it later.
                    nextHydratableInstance = null;
                    return true;
                }
                return false;
            default:
                return false;
        }
    }
    function shouldClientRenderOnMismatch(fiber) {
        return (fiber.mode & ConcurrentMode) !== NoMode && (fiber.flags & DidCapture) === NoFlags;
    }
    function throwOnHydrationMismatch(fiber) {
        throw new Error("Hydration failed because the initial UI does not match what was rendered on the server.");
    }
    function tryToClaimNextHydratableInstance(fiber) {
        if (!isHydrating) return;
        var nextInstance = nextHydratableInstance;
        if (!nextInstance) {
            if (shouldClientRenderOnMismatch(fiber)) {
                warnNonhydratedInstance(hydrationParentFiber, fiber);
                throwOnHydrationMismatch();
            } // Nothing to hydrate. Make it an insertion.
            insertNonHydratedInstance(hydrationParentFiber, fiber);
            isHydrating = false;
            hydrationParentFiber = fiber;
            return;
        }
        var firstAttemptedInstance = nextInstance;
        if (!tryHydrate(fiber, nextInstance)) {
            if (shouldClientRenderOnMismatch(fiber)) {
                warnNonhydratedInstance(hydrationParentFiber, fiber);
                throwOnHydrationMismatch();
            } // If we can't hydrate this instance let's try the next one.
            // We use this as a heuristic. It's based on intuition and not data so it
            // might be flawed or unnecessary.
            nextInstance = getNextHydratableSibling(firstAttemptedInstance);
            var prevHydrationParentFiber = hydrationParentFiber;
            if (!nextInstance || !tryHydrate(fiber, nextInstance)) {
                // Nothing to hydrate. Make it an insertion.
                insertNonHydratedInstance(hydrationParentFiber, fiber);
                isHydrating = false;
                hydrationParentFiber = fiber;
                return;
            } // We matched the next one, we'll now assume that the first one was
            // superfluous and we'll delete it. Since we can't eagerly delete it
            // we'll have to schedule a deletion. To do that, this node needs a dummy
            // fiber associated with it.
            deleteHydratableInstance(prevHydrationParentFiber, firstAttemptedInstance);
        }
    }
    function prepareToHydrateHostInstance(fiber, rootContainerInstance, hostContext) {
        var instance = fiber.stateNode;
        var shouldWarnIfMismatchDev = !didSuspendOrErrorDEV;
        var updatePayload = hydrateInstance(instance, fiber.type, fiber.memoizedProps, rootContainerInstance, hostContext, fiber, shouldWarnIfMismatchDev); // TODO: Type this specific to this type of component.
        fiber.updateQueue = updatePayload; // If the update payload indicates that there is a change or if there
        // is a new ref we mark this as an update.
        if (updatePayload !== null) return true;
        return false;
    }
    function prepareToHydrateHostTextInstance(fiber) {
        var textInstance = fiber.stateNode;
        var textContent = fiber.memoizedProps;
        var shouldUpdate = hydrateTextInstance(textInstance, textContent, fiber);
        if (shouldUpdate) {
            // We assume that prepareToHydrateHostTextInstance is called in a context where the
            // hydration parent is the parent host component of this host text.
            var returnFiber = hydrationParentFiber;
            if (returnFiber !== null) switch(returnFiber.tag){
                case HostRoot:
                    var parentContainer = returnFiber.stateNode.containerInfo;
                    var isConcurrentMode = (returnFiber.mode & ConcurrentMode) !== NoMode;
                    didNotMatchHydratedContainerTextInstance(parentContainer, textInstance, textContent, isConcurrentMode);
                    break;
                case HostComponent:
                    var parentType = returnFiber.type;
                    var parentProps = returnFiber.memoizedProps;
                    var parentInstance = returnFiber.stateNode;
                    var _isConcurrentMode2 = (returnFiber.mode & ConcurrentMode) !== NoMode;
                    didNotMatchHydratedTextInstance(parentType, parentProps, parentInstance, textInstance, textContent, _isConcurrentMode2);
                    break;
            }
        }
        return shouldUpdate;
    }
    function prepareToHydrateHostSuspenseInstance(fiber) {
        var suspenseState = fiber.memoizedState;
        var suspenseInstance = suspenseState !== null ? suspenseState.dehydrated : null;
        if (!suspenseInstance) throw new Error("Expected to have a hydrated suspense instance. This error is likely caused by a bug in React. Please file an issue.");
        hydrateSuspenseInstance(suspenseInstance, fiber);
    }
    function skipPastDehydratedSuspenseInstance(fiber) {
        var suspenseState = fiber.memoizedState;
        var suspenseInstance = suspenseState !== null ? suspenseState.dehydrated : null;
        if (!suspenseInstance) throw new Error("Expected to have a hydrated suspense instance. This error is likely caused by a bug in React. Please file an issue.");
        return getNextHydratableInstanceAfterSuspenseInstance(suspenseInstance);
    }
    function popToNextHostParent(fiber) {
        var parent = fiber.return;
        while(parent !== null && parent.tag !== HostComponent && parent.tag !== HostRoot && parent.tag !== SuspenseComponent)parent = parent.return;
        hydrationParentFiber = parent;
    }
    function popHydrationState(fiber) {
        if (fiber !== hydrationParentFiber) // We're deeper than the current hydration context, inside an inserted
        // tree.
        return false;
        if (!isHydrating) {
            // If we're not currently hydrating but we're in a hydration context, then
            // we were an insertion and now need to pop up reenter hydration of our
            // siblings.
            popToNextHostParent(fiber);
            isHydrating = true;
            return false;
        } // If we have any remaining hydratable nodes, we need to delete them now.
        // We only do this deeper than head and body since they tend to have random
        // other nodes in them. We also ignore components with pure text content in
        // side of them. We also don't delete anything inside the root container.
        if (fiber.tag !== HostRoot && (fiber.tag !== HostComponent || shouldDeleteUnhydratedTailInstances(fiber.type) && !shouldSetTextContent(fiber.type, fiber.memoizedProps))) {
            var nextInstance = nextHydratableInstance;
            if (nextInstance) {
                if (shouldClientRenderOnMismatch(fiber)) {
                    warnIfUnhydratedTailNodes(fiber);
                    throwOnHydrationMismatch();
                } else while(nextInstance){
                    deleteHydratableInstance(fiber, nextInstance);
                    nextInstance = getNextHydratableSibling(nextInstance);
                }
            }
        }
        popToNextHostParent(fiber);
        if (fiber.tag === SuspenseComponent) nextHydratableInstance = skipPastDehydratedSuspenseInstance(fiber);
        else nextHydratableInstance = hydrationParentFiber ? getNextHydratableSibling(fiber.stateNode) : null;
        return true;
    }
    function hasUnhydratedTailNodes() {
        return isHydrating && nextHydratableInstance !== null;
    }
    function warnIfUnhydratedTailNodes(fiber) {
        var nextInstance = nextHydratableInstance;
        while(nextInstance){
            warnUnhydratedInstance(fiber, nextInstance);
            nextInstance = getNextHydratableSibling(nextInstance);
        }
    }
    function resetHydrationState() {
        hydrationParentFiber = null;
        nextHydratableInstance = null;
        isHydrating = false;
        didSuspendOrErrorDEV = false;
    }
    function upgradeHydrationErrorsToRecoverable() {
        if (hydrationErrors !== null) {
            // Successfully completed a forced client render. The errors that occurred
            // during the hydration attempt are now recovered. We will log them in
            // commit phase, once the entire tree has finished.
            queueRecoverableErrors(hydrationErrors);
            hydrationErrors = null;
        }
    }
    function getIsHydrating() {
        return isHydrating;
    }
    function queueHydrationError(error) {
        if (hydrationErrors === null) hydrationErrors = [
            error
        ];
        else hydrationErrors.push(error);
    }
    var ReactCurrentBatchConfig$1 = ReactSharedInternals.ReactCurrentBatchConfig;
    var NoTransition = null;
    function requestCurrentTransition() {
        return ReactCurrentBatchConfig$1.transition;
    }
    var ReactStrictModeWarnings = {
        recordUnsafeLifecycleWarnings: function(fiber, instance) {},
        flushPendingUnsafeLifecycleWarnings: function() {},
        recordLegacyContextWarning: function(fiber, instance) {},
        flushLegacyContextWarning: function() {},
        discardPendingWarnings: function() {}
    };
    var findStrictRoot = function(fiber) {
        var maybeStrictRoot = null;
        var node = fiber;
        while(node !== null){
            if (node.mode & StrictLegacyMode) maybeStrictRoot = node;
            node = node.return;
        }
        return maybeStrictRoot;
    };
    var setToSortedString = function(set) {
        var array = [];
        set.forEach(function(value) {
            array.push(value);
        });
        return array.sort().join(", ");
    };
    var pendingComponentWillMountWarnings = [];
    var pendingUNSAFE_ComponentWillMountWarnings = [];
    var pendingComponentWillReceivePropsWarnings = [];
    var pendingUNSAFE_ComponentWillReceivePropsWarnings = [];
    var pendingComponentWillUpdateWarnings = [];
    var pendingUNSAFE_ComponentWillUpdateWarnings = []; // Tracks components we have already warned about.
    var didWarnAboutUnsafeLifecycles = new Set();
    ReactStrictModeWarnings.recordUnsafeLifecycleWarnings = function(fiber, instance) {
        // Dedupe strategy: Warn once per component.
        if (didWarnAboutUnsafeLifecycles.has(fiber.type)) return;
        if (typeof instance.componentWillMount === "function" && // Don't warn about react-lifecycles-compat polyfilled components.
        instance.componentWillMount.__suppressDeprecationWarning !== true) pendingComponentWillMountWarnings.push(fiber);
        if (fiber.mode & StrictLegacyMode && typeof instance.UNSAFE_componentWillMount === "function") pendingUNSAFE_ComponentWillMountWarnings.push(fiber);
        if (typeof instance.componentWillReceiveProps === "function" && instance.componentWillReceiveProps.__suppressDeprecationWarning !== true) pendingComponentWillReceivePropsWarnings.push(fiber);
        if (fiber.mode & StrictLegacyMode && typeof instance.UNSAFE_componentWillReceiveProps === "function") pendingUNSAFE_ComponentWillReceivePropsWarnings.push(fiber);
        if (typeof instance.componentWillUpdate === "function" && instance.componentWillUpdate.__suppressDeprecationWarning !== true) pendingComponentWillUpdateWarnings.push(fiber);
        if (fiber.mode & StrictLegacyMode && typeof instance.UNSAFE_componentWillUpdate === "function") pendingUNSAFE_ComponentWillUpdateWarnings.push(fiber);
    };
    ReactStrictModeWarnings.flushPendingUnsafeLifecycleWarnings = function() {
        // We do an initial pass to gather component names
        var componentWillMountUniqueNames = new Set();
        if (pendingComponentWillMountWarnings.length > 0) {
            pendingComponentWillMountWarnings.forEach(function(fiber) {
                componentWillMountUniqueNames.add(getComponentNameFromFiber(fiber) || "Component");
                didWarnAboutUnsafeLifecycles.add(fiber.type);
            });
            pendingComponentWillMountWarnings = [];
        }
        var UNSAFE_componentWillMountUniqueNames = new Set();
        if (pendingUNSAFE_ComponentWillMountWarnings.length > 0) {
            pendingUNSAFE_ComponentWillMountWarnings.forEach(function(fiber) {
                UNSAFE_componentWillMountUniqueNames.add(getComponentNameFromFiber(fiber) || "Component");
                didWarnAboutUnsafeLifecycles.add(fiber.type);
            });
            pendingUNSAFE_ComponentWillMountWarnings = [];
        }
        var componentWillReceivePropsUniqueNames = new Set();
        if (pendingComponentWillReceivePropsWarnings.length > 0) {
            pendingComponentWillReceivePropsWarnings.forEach(function(fiber) {
                componentWillReceivePropsUniqueNames.add(getComponentNameFromFiber(fiber) || "Component");
                didWarnAboutUnsafeLifecycles.add(fiber.type);
            });
            pendingComponentWillReceivePropsWarnings = [];
        }
        var UNSAFE_componentWillReceivePropsUniqueNames = new Set();
        if (pendingUNSAFE_ComponentWillReceivePropsWarnings.length > 0) {
            pendingUNSAFE_ComponentWillReceivePropsWarnings.forEach(function(fiber) {
                UNSAFE_componentWillReceivePropsUniqueNames.add(getComponentNameFromFiber(fiber) || "Component");
                didWarnAboutUnsafeLifecycles.add(fiber.type);
            });
            pendingUNSAFE_ComponentWillReceivePropsWarnings = [];
        }
        var componentWillUpdateUniqueNames = new Set();
        if (pendingComponentWillUpdateWarnings.length > 0) {
            pendingComponentWillUpdateWarnings.forEach(function(fiber) {
                componentWillUpdateUniqueNames.add(getComponentNameFromFiber(fiber) || "Component");
                didWarnAboutUnsafeLifecycles.add(fiber.type);
            });
            pendingComponentWillUpdateWarnings = [];
        }
        var UNSAFE_componentWillUpdateUniqueNames = new Set();
        if (pendingUNSAFE_ComponentWillUpdateWarnings.length > 0) {
            pendingUNSAFE_ComponentWillUpdateWarnings.forEach(function(fiber) {
                UNSAFE_componentWillUpdateUniqueNames.add(getComponentNameFromFiber(fiber) || "Component");
                didWarnAboutUnsafeLifecycles.add(fiber.type);
            });
            pendingUNSAFE_ComponentWillUpdateWarnings = [];
        } // Finally, we flush all the warnings
        // UNSAFE_ ones before the deprecated ones, since they'll be 'louder'
        if (UNSAFE_componentWillMountUniqueNames.size > 0) {
            var sortedNames = setToSortedString(UNSAFE_componentWillMountUniqueNames);
            error("Using UNSAFE_componentWillMount in strict mode is not recommended and may indicate bugs in your code. See https://reactjs.org/link/unsafe-component-lifecycles for details.\n\n* Move code with side effects to componentDidMount, and set initial state in the constructor.\n\nPlease update the following components: %s", sortedNames);
        }
        if (UNSAFE_componentWillReceivePropsUniqueNames.size > 0) {
            var _sortedNames = setToSortedString(UNSAFE_componentWillReceivePropsUniqueNames);
            error("Using UNSAFE_componentWillReceiveProps in strict mode is not recommended and may indicate bugs in your code. See https://reactjs.org/link/unsafe-component-lifecycles for details.\n\n* Move data fetching code or side effects to componentDidUpdate.\n* If you're updating state whenever props change, refactor your code to use memoization techniques or move it to static getDerivedStateFromProps. Learn more at: https://reactjs.org/link/derived-state\n\nPlease update the following components: %s", _sortedNames);
        }
        if (UNSAFE_componentWillUpdateUniqueNames.size > 0) {
            var _sortedNames2 = setToSortedString(UNSAFE_componentWillUpdateUniqueNames);
            error("Using UNSAFE_componentWillUpdate in strict mode is not recommended and may indicate bugs in your code. See https://reactjs.org/link/unsafe-component-lifecycles for details.\n\n* Move data fetching code or side effects to componentDidUpdate.\n\nPlease update the following components: %s", _sortedNames2);
        }
        if (componentWillMountUniqueNames.size > 0) {
            var _sortedNames3 = setToSortedString(componentWillMountUniqueNames);
            warn("componentWillMount has been renamed, and is not recommended for use. See https://reactjs.org/link/unsafe-component-lifecycles for details.\n\n* Move code with side effects to componentDidMount, and set initial state in the constructor.\n* Rename componentWillMount to UNSAFE_componentWillMount to suppress this warning in non-strict mode. In React 18.x, only the UNSAFE_ name will work. To rename all deprecated lifecycles to their new names, you can run `npx react-codemod rename-unsafe-lifecycles` in your project source folder.\n\nPlease update the following components: %s", _sortedNames3);
        }
        if (componentWillReceivePropsUniqueNames.size > 0) {
            var _sortedNames4 = setToSortedString(componentWillReceivePropsUniqueNames);
            warn("componentWillReceiveProps has been renamed, and is not recommended for use. See https://reactjs.org/link/unsafe-component-lifecycles for details.\n\n* Move data fetching code or side effects to componentDidUpdate.\n* If you're updating state whenever props change, refactor your code to use memoization techniques or move it to static getDerivedStateFromProps. Learn more at: https://reactjs.org/link/derived-state\n* Rename componentWillReceiveProps to UNSAFE_componentWillReceiveProps to suppress this warning in non-strict mode. In React 18.x, only the UNSAFE_ name will work. To rename all deprecated lifecycles to their new names, you can run `npx react-codemod rename-unsafe-lifecycles` in your project source folder.\n\nPlease update the following components: %s", _sortedNames4);
        }
        if (componentWillUpdateUniqueNames.size > 0) {
            var _sortedNames5 = setToSortedString(componentWillUpdateUniqueNames);
            warn("componentWillUpdate has been renamed, and is not recommended for use. See https://reactjs.org/link/unsafe-component-lifecycles for details.\n\n* Move data fetching code or side effects to componentDidUpdate.\n* Rename componentWillUpdate to UNSAFE_componentWillUpdate to suppress this warning in non-strict mode. In React 18.x, only the UNSAFE_ name will work. To rename all deprecated lifecycles to their new names, you can run `npx react-codemod rename-unsafe-lifecycles` in your project source folder.\n\nPlease update the following components: %s", _sortedNames5);
        }
    };
    var pendingLegacyContextWarning = new Map(); // Tracks components we have already warned about.
    var didWarnAboutLegacyContext = new Set();
    ReactStrictModeWarnings.recordLegacyContextWarning = function(fiber, instance) {
        var strictRoot = findStrictRoot(fiber);
        if (strictRoot === null) {
            error("Expected to find a StrictMode component in a strict mode tree. This error is likely caused by a bug in React. Please file an issue.");
            return;
        } // Dedup strategy: Warn once per component.
        if (didWarnAboutLegacyContext.has(fiber.type)) return;
        var warningsForRoot = pendingLegacyContextWarning.get(strictRoot);
        if (fiber.type.contextTypes != null || fiber.type.childContextTypes != null || instance !== null && typeof instance.getChildContext === "function") {
            if (warningsForRoot === undefined) {
                warningsForRoot = [];
                pendingLegacyContextWarning.set(strictRoot, warningsForRoot);
            }
            warningsForRoot.push(fiber);
        }
    };
    ReactStrictModeWarnings.flushLegacyContextWarning = function() {
        pendingLegacyContextWarning.forEach(function(fiberArray, strictRoot) {
            if (fiberArray.length === 0) return;
            var firstFiber = fiberArray[0];
            var uniqueNames = new Set();
            fiberArray.forEach(function(fiber) {
                uniqueNames.add(getComponentNameFromFiber(fiber) || "Component");
                didWarnAboutLegacyContext.add(fiber.type);
            });
            var sortedNames = setToSortedString(uniqueNames);
            try {
                setCurrentFiber(firstFiber);
                error("Legacy context API has been detected within a strict-mode tree.\n\nThe old API will be supported in all 16.x releases, but applications using it should migrate to the new version.\n\nPlease update the following components: %s\n\nLearn more about this warning here: https://reactjs.org/link/legacy-context", sortedNames);
            } finally{
                resetCurrentFiber();
            }
        });
    };
    ReactStrictModeWarnings.discardPendingWarnings = function() {
        pendingComponentWillMountWarnings = [];
        pendingUNSAFE_ComponentWillMountWarnings = [];
        pendingComponentWillReceivePropsWarnings = [];
        pendingUNSAFE_ComponentWillReceivePropsWarnings = [];
        pendingComponentWillUpdateWarnings = [];
        pendingUNSAFE_ComponentWillUpdateWarnings = [];
        pendingLegacyContextWarning = new Map();
    };
    function resolveDefaultProps(Component, baseProps) {
        if (Component && Component.defaultProps) {
            // Resolve default props. Taken from ReactElement
            var props = assign({}, baseProps);
            var defaultProps = Component.defaultProps;
            for(var propName in defaultProps)if (props[propName] === undefined) props[propName] = defaultProps[propName];
            return props;
        }
        return baseProps;
    }
    var valueCursor = createCursor(null);
    var rendererSigil;
    // Use this to detect multiple renderers using the same context
    rendererSigil = {};
    var currentlyRenderingFiber = null;
    var lastContextDependency = null;
    var lastFullyObservedContext = null;
    var isDisallowedContextReadInDEV = false;
    function resetContextDependencies() {
        // This is called right before React yields execution, to ensure `readContext`
        // cannot be called outside the render phase.
        currentlyRenderingFiber = null;
        lastContextDependency = null;
        lastFullyObservedContext = null;
        isDisallowedContextReadInDEV = false;
    }
    function enterDisallowedContextReadInDEV() {
        isDisallowedContextReadInDEV = true;
    }
    function exitDisallowedContextReadInDEV() {
        isDisallowedContextReadInDEV = false;
    }
    function pushProvider(providerFiber, context, nextValue) {
        push(valueCursor, context._currentValue, providerFiber);
        context._currentValue = nextValue;
        if (context._currentRenderer !== undefined && context._currentRenderer !== null && context._currentRenderer !== rendererSigil) error("Detected multiple renderers concurrently rendering the same context provider. This is currently unsupported.");
        context._currentRenderer = rendererSigil;
    }
    function popProvider(context, providerFiber) {
        var currentValue = valueCursor.current;
        pop(valueCursor, providerFiber);
        context._currentValue = currentValue;
    }
    function scheduleContextWorkOnParentPath(parent, renderLanes, propagationRoot) {
        // Update the child lanes of all the ancestors, including the alternates.
        var node = parent;
        while(node !== null){
            var alternate = node.alternate;
            if (!isSubsetOfLanes(node.childLanes, renderLanes)) {
                node.childLanes = mergeLanes(node.childLanes, renderLanes);
                if (alternate !== null) alternate.childLanes = mergeLanes(alternate.childLanes, renderLanes);
            } else if (alternate !== null && !isSubsetOfLanes(alternate.childLanes, renderLanes)) alternate.childLanes = mergeLanes(alternate.childLanes, renderLanes);
            if (node === propagationRoot) break;
            node = node.return;
        }
        if (node !== propagationRoot) error("Expected to find the propagation root when scheduling context work. This error is likely caused by a bug in React. Please file an issue.");
    }
    function propagateContextChange(workInProgress, context, renderLanes) {
        propagateContextChange_eager(workInProgress, context, renderLanes);
    }
    function propagateContextChange_eager(workInProgress, context, renderLanes) {
        var fiber = workInProgress.child;
        if (fiber !== null) // Set the return pointer of the child to the work-in-progress fiber.
        fiber.return = workInProgress;
        while(fiber !== null){
            var nextFiber = void 0; // Visit this fiber.
            var list = fiber.dependencies;
            if (list !== null) {
                nextFiber = fiber.child;
                var dependency = list.firstContext;
                while(dependency !== null){
                    // Check if the context matches.
                    if (dependency.context === context) {
                        // Match! Schedule an update on this fiber.
                        if (fiber.tag === ClassComponent) {
                            // Schedule a force update on the work-in-progress.
                            var lane = pickArbitraryLane(renderLanes);
                            var update = createUpdate(NoTimestamp, lane);
                            update.tag = ForceUpdate; // TODO: Because we don't have a work-in-progress, this will add the
                            // update to the current fiber, too, which means it will persist even if
                            // this render is thrown away. Since it's a race condition, not sure it's
                            // worth fixing.
                            // Inlined `enqueueUpdate` to remove interleaved update check
                            var updateQueue = fiber.updateQueue;
                            if (updateQueue === null) ;
                            else {
                                var sharedQueue = updateQueue.shared;
                                var pending = sharedQueue.pending;
                                if (pending === null) // This is the first update. Create a circular list.
                                update.next = update;
                                else {
                                    update.next = pending.next;
                                    pending.next = update;
                                }
                                sharedQueue.pending = update;
                            }
                        }
                        fiber.lanes = mergeLanes(fiber.lanes, renderLanes);
                        var alternate = fiber.alternate;
                        if (alternate !== null) alternate.lanes = mergeLanes(alternate.lanes, renderLanes);
                        scheduleContextWorkOnParentPath(fiber.return, renderLanes, workInProgress); // Mark the updated lanes on the list, too.
                        list.lanes = mergeLanes(list.lanes, renderLanes); // Since we already found a match, we can stop traversing the
                        break;
                    }
                    dependency = dependency.next;
                }
            } else if (fiber.tag === ContextProvider) // Don't scan deeper if this is a matching provider
            nextFiber = fiber.type === workInProgress.type ? null : fiber.child;
            else if (fiber.tag === DehydratedFragment) {
                // If a dehydrated suspense boundary is in this subtree, we don't know
                // if it will have any context consumers in it. The best we can do is
                // mark it as having updates.
                var parentSuspense = fiber.return;
                if (parentSuspense === null) throw new Error("We just came from a parent so we must have had a parent. This is a bug in React.");
                parentSuspense.lanes = mergeLanes(parentSuspense.lanes, renderLanes);
                var _alternate = parentSuspense.alternate;
                if (_alternate !== null) _alternate.lanes = mergeLanes(_alternate.lanes, renderLanes);
                 // This is intentionally passing this fiber as the parent
                // because we want to schedule this fiber as having work
                // on its children. We'll use the childLanes on
                // this fiber to indicate that a context has changed.
                scheduleContextWorkOnParentPath(parentSuspense, renderLanes, workInProgress);
                nextFiber = fiber.sibling;
            } else // Traverse down.
            nextFiber = fiber.child;
            if (nextFiber !== null) // Set the return pointer of the child to the work-in-progress fiber.
            nextFiber.return = fiber;
            else {
                // No child. Traverse to next sibling.
                nextFiber = fiber;
                while(nextFiber !== null){
                    if (nextFiber === workInProgress) {
                        // We're back to the root of this subtree. Exit.
                        nextFiber = null;
                        break;
                    }
                    var sibling = nextFiber.sibling;
                    if (sibling !== null) {
                        // Set the return pointer of the sibling to the work-in-progress fiber.
                        sibling.return = nextFiber.return;
                        nextFiber = sibling;
                        break;
                    } // No more siblings. Traverse up.
                    nextFiber = nextFiber.return;
                }
            }
            fiber = nextFiber;
        }
    }
    function prepareToReadContext(workInProgress, renderLanes) {
        currentlyRenderingFiber = workInProgress;
        lastContextDependency = null;
        lastFullyObservedContext = null;
        var dependencies = workInProgress.dependencies;
        if (dependencies !== null) {
            var firstContext = dependencies.firstContext;
            if (firstContext !== null) {
                if (includesSomeLane(dependencies.lanes, renderLanes)) // Context list has a pending update. Mark that this fiber performed work.
                markWorkInProgressReceivedUpdate();
                 // Reset the work-in-progress list
                dependencies.firstContext = null;
            }
        }
    }
    function readContext(context) {
        // This warning would fire if you read context inside a Hook like useMemo.
        // Unlike the class check below, it's not enforced in production for perf.
        if (isDisallowedContextReadInDEV) error("Context can only be read while React is rendering. In classes, you can read it in the render method or getDerivedStateFromProps. In function components, you can read it directly in the function body, but not inside Hooks like useReducer() or useMemo().");
        var value = context._currentValue;
        if (lastFullyObservedContext === context) ;
        else {
            var contextItem = {
                context: context,
                memoizedValue: value,
                next: null
            };
            if (lastContextDependency === null) {
                if (currentlyRenderingFiber === null) throw new Error("Context can only be read while React is rendering. In classes, you can read it in the render method or getDerivedStateFromProps. In function components, you can read it directly in the function body, but not inside Hooks like useReducer() or useMemo().");
                 // This is the first dependency for this component. Create a new list.
                lastContextDependency = contextItem;
                currentlyRenderingFiber.dependencies = {
                    lanes: NoLanes,
                    firstContext: contextItem
                };
            } else // Append a new context item.
            lastContextDependency = lastContextDependency.next = contextItem;
        }
        return value;
    }
    // render. When this render exits, either because it finishes or because it is
    // interrupted, the interleaved updates will be transferred onto the main part
    // of the queue.
    var concurrentQueues = null;
    function pushConcurrentUpdateQueue(queue) {
        if (concurrentQueues === null) concurrentQueues = [
            queue
        ];
        else concurrentQueues.push(queue);
    }
    function finishQueueingConcurrentUpdates() {
        // Transfer the interleaved updates onto the main queue. Each queue has a
        // `pending` field and an `interleaved` field. When they are not null, they
        // point to the last node in a circular linked list. We need to append the
        // interleaved list to the end of the pending list by joining them into a
        // single, circular list.
        if (concurrentQueues !== null) {
            for(var i = 0; i < concurrentQueues.length; i++){
                var queue = concurrentQueues[i];
                var lastInterleavedUpdate = queue.interleaved;
                if (lastInterleavedUpdate !== null) {
                    queue.interleaved = null;
                    var firstInterleavedUpdate = lastInterleavedUpdate.next;
                    var lastPendingUpdate = queue.pending;
                    if (lastPendingUpdate !== null) {
                        var firstPendingUpdate = lastPendingUpdate.next;
                        lastPendingUpdate.next = firstInterleavedUpdate;
                        lastInterleavedUpdate.next = firstPendingUpdate;
                    }
                    queue.pending = lastInterleavedUpdate;
                }
            }
            concurrentQueues = null;
        }
    }
    function enqueueConcurrentHookUpdate(fiber, queue, update, lane) {
        var interleaved = queue.interleaved;
        if (interleaved === null) {
            // This is the first update. Create a circular list.
            update.next = update; // At the end of the current render, this queue's interleaved updates will
            // be transferred to the pending queue.
            pushConcurrentUpdateQueue(queue);
        } else {
            update.next = interleaved.next;
            interleaved.next = update;
        }
        queue.interleaved = update;
        return markUpdateLaneFromFiberToRoot(fiber, lane);
    }
    function enqueueConcurrentHookUpdateAndEagerlyBailout(fiber, queue, update, lane) {
        var interleaved = queue.interleaved;
        if (interleaved === null) {
            // This is the first update. Create a circular list.
            update.next = update; // At the end of the current render, this queue's interleaved updates will
            // be transferred to the pending queue.
            pushConcurrentUpdateQueue(queue);
        } else {
            update.next = interleaved.next;
            interleaved.next = update;
        }
        queue.interleaved = update;
    }
    function enqueueConcurrentClassUpdate(fiber, queue, update, lane) {
        var interleaved = queue.interleaved;
        if (interleaved === null) {
            // This is the first update. Create a circular list.
            update.next = update; // At the end of the current render, this queue's interleaved updates will
            // be transferred to the pending queue.
            pushConcurrentUpdateQueue(queue);
        } else {
            update.next = interleaved.next;
            interleaved.next = update;
        }
        queue.interleaved = update;
        return markUpdateLaneFromFiberToRoot(fiber, lane);
    }
    function enqueueConcurrentRenderForLane(fiber, lane) {
        return markUpdateLaneFromFiberToRoot(fiber, lane);
    } // Calling this function outside this module should only be done for backwards
    // compatibility and should always be accompanied by a warning.
    var unsafe_markUpdateLaneFromFiberToRoot = markUpdateLaneFromFiberToRoot;
    function markUpdateLaneFromFiberToRoot(sourceFiber, lane) {
        // Update the source fiber's lanes
        sourceFiber.lanes = mergeLanes(sourceFiber.lanes, lane);
        var alternate = sourceFiber.alternate;
        if (alternate !== null) alternate.lanes = mergeLanes(alternate.lanes, lane);
        if (alternate === null && (sourceFiber.flags & (Placement | Hydrating)) !== NoFlags) warnAboutUpdateOnNotYetMountedFiberInDEV(sourceFiber);
        var node = sourceFiber;
        var parent = sourceFiber.return;
        while(parent !== null){
            parent.childLanes = mergeLanes(parent.childLanes, lane);
            alternate = parent.alternate;
            if (alternate !== null) alternate.childLanes = mergeLanes(alternate.childLanes, lane);
            else if ((parent.flags & (Placement | Hydrating)) !== NoFlags) warnAboutUpdateOnNotYetMountedFiberInDEV(sourceFiber);
            node = parent;
            parent = parent.return;
        }
        if (node.tag === HostRoot) {
            var root = node.stateNode;
            return root;
        } else return null;
    }
    var UpdateState = 0;
    var ReplaceState = 1;
    var ForceUpdate = 2;
    var CaptureUpdate = 3; // Global state that is reset at the beginning of calling `processUpdateQueue`.
    // It should only be read right after calling `processUpdateQueue`, via
    // `checkHasForceUpdateAfterProcessing`.
    var hasForceUpdate = false;
    var didWarnUpdateInsideUpdate;
    var currentlyProcessingQueue;
    didWarnUpdateInsideUpdate = false;
    currentlyProcessingQueue = null;
    function initializeUpdateQueue(fiber) {
        var queue = {
            baseState: fiber.memoizedState,
            firstBaseUpdate: null,
            lastBaseUpdate: null,
            shared: {
                pending: null,
                interleaved: null,
                lanes: NoLanes
            },
            effects: null
        };
        fiber.updateQueue = queue;
    }
    function cloneUpdateQueue(current, workInProgress) {
        // Clone the update queue from current. Unless it's already a clone.
        var queue = workInProgress.updateQueue;
        var currentQueue = current.updateQueue;
        if (queue === currentQueue) {
            var clone = {
                baseState: currentQueue.baseState,
                firstBaseUpdate: currentQueue.firstBaseUpdate,
                lastBaseUpdate: currentQueue.lastBaseUpdate,
                shared: currentQueue.shared,
                effects: currentQueue.effects
            };
            workInProgress.updateQueue = clone;
        }
    }
    function createUpdate(eventTime, lane) {
        var update = {
            eventTime: eventTime,
            lane: lane,
            tag: UpdateState,
            payload: null,
            callback: null,
            next: null
        };
        return update;
    }
    function enqueueUpdate(fiber, update, lane) {
        var updateQueue = fiber.updateQueue;
        if (updateQueue === null) // Only occurs if the fiber has been unmounted.
        return null;
        var sharedQueue = updateQueue.shared;
        if (currentlyProcessingQueue === sharedQueue && !didWarnUpdateInsideUpdate) {
            error("An update (setState, replaceState, or forceUpdate) was scheduled from inside an update function. Update functions should be pure, with zero side-effects. Consider using componentDidUpdate or a callback.");
            didWarnUpdateInsideUpdate = true;
        }
        if (isUnsafeClassRenderPhaseUpdate()) {
            // This is an unsafe render phase update. Add directly to the update
            // queue so we can process it immediately during the current render.
            var pending = sharedQueue.pending;
            if (pending === null) // This is the first update. Create a circular list.
            update.next = update;
            else {
                update.next = pending.next;
                pending.next = update;
            }
            sharedQueue.pending = update; // Update the childLanes even though we're most likely already rendering
            // this fiber. This is for backwards compatibility in the case where you
            // update a different component during render phase than the one that is
            // currently renderings (a pattern that is accompanied by a warning).
            return unsafe_markUpdateLaneFromFiberToRoot(fiber, lane);
        } else return enqueueConcurrentClassUpdate(fiber, sharedQueue, update, lane);
    }
    function entangleTransitions(root, fiber, lane) {
        var updateQueue = fiber.updateQueue;
        if (updateQueue === null) // Only occurs if the fiber has been unmounted.
        return;
        var sharedQueue = updateQueue.shared;
        if (isTransitionLane(lane)) {
            var queueLanes = sharedQueue.lanes; // If any entangled lanes are no longer pending on the root, then they must
            // have finished. We can remove them from the shared queue, which represents
            // a superset of the actually pending lanes. In some cases we may entangle
            // more than we need to, but that's OK. In fact it's worse if we *don't*
            // entangle when we should.
            queueLanes = intersectLanes(queueLanes, root.pendingLanes); // Entangle the new transition lane with the other transition lanes.
            var newQueueLanes = mergeLanes(queueLanes, lane);
            sharedQueue.lanes = newQueueLanes; // Even if queue.lanes already include lane, we don't know for certain if
            // the lane finished since the last time we entangled it. So we need to
            // entangle it again, just to be sure.
            markRootEntangled(root, newQueueLanes);
        }
    }
    function enqueueCapturedUpdate(workInProgress, capturedUpdate) {
        // Captured updates are updates that are thrown by a child during the render
        // phase. They should be discarded if the render is aborted. Therefore,
        // we should only put them on the work-in-progress queue, not the current one.
        var queue = workInProgress.updateQueue; // Check if the work-in-progress queue is a clone.
        var current = workInProgress.alternate;
        if (current !== null) {
            var currentQueue = current.updateQueue;
            if (queue === currentQueue) {
                // The work-in-progress queue is the same as current. This happens when
                // we bail out on a parent fiber that then captures an error thrown by
                // a child. Since we want to append the update only to the work-in
                // -progress queue, we need to clone the updates. We usually clone during
                // processUpdateQueue, but that didn't happen in this case because we
                // skipped over the parent when we bailed out.
                var newFirst = null;
                var newLast = null;
                var firstBaseUpdate = queue.firstBaseUpdate;
                if (firstBaseUpdate !== null) {
                    // Loop through the updates and clone them.
                    var update = firstBaseUpdate;
                    do {
                        var clone = {
                            eventTime: update.eventTime,
                            lane: update.lane,
                            tag: update.tag,
                            payload: update.payload,
                            callback: update.callback,
                            next: null
                        };
                        if (newLast === null) newFirst = newLast = clone;
                        else {
                            newLast.next = clone;
                            newLast = clone;
                        }
                        update = update.next;
                    }while (update !== null); // Append the captured update the end of the cloned list.
                    if (newLast === null) newFirst = newLast = capturedUpdate;
                    else {
                        newLast.next = capturedUpdate;
                        newLast = capturedUpdate;
                    }
                } else // There are no base updates.
                newFirst = newLast = capturedUpdate;
                queue = {
                    baseState: currentQueue.baseState,
                    firstBaseUpdate: newFirst,
                    lastBaseUpdate: newLast,
                    shared: currentQueue.shared,
                    effects: currentQueue.effects
                };
                workInProgress.updateQueue = queue;
                return;
            }
        } // Append the update to the end of the list.
        var lastBaseUpdate = queue.lastBaseUpdate;
        if (lastBaseUpdate === null) queue.firstBaseUpdate = capturedUpdate;
        else lastBaseUpdate.next = capturedUpdate;
        queue.lastBaseUpdate = capturedUpdate;
    }
    function getStateFromUpdate(workInProgress, queue, update, prevState, nextProps, instance) {
        switch(update.tag){
            case ReplaceState:
                var payload = update.payload;
                if (typeof payload === "function") {
                    enterDisallowedContextReadInDEV();
                    var nextState = payload.call(instance, prevState, nextProps);
                    if (workInProgress.mode & StrictLegacyMode) {
                        setIsStrictModeForDevtools(true);
                        try {
                            payload.call(instance, prevState, nextProps);
                        } finally{
                            setIsStrictModeForDevtools(false);
                        }
                    }
                    exitDisallowedContextReadInDEV();
                    return nextState;
                } // State object
                return payload;
            case CaptureUpdate:
                workInProgress.flags = workInProgress.flags & ~ShouldCapture | DidCapture;
            // Intentional fallthrough
            case UpdateState:
                var _payload = update.payload;
                var partialState;
                if (typeof _payload === "function") {
                    enterDisallowedContextReadInDEV();
                    partialState = _payload.call(instance, prevState, nextProps);
                    if (workInProgress.mode & StrictLegacyMode) {
                        setIsStrictModeForDevtools(true);
                        try {
                            _payload.call(instance, prevState, nextProps);
                        } finally{
                            setIsStrictModeForDevtools(false);
                        }
                    }
                    exitDisallowedContextReadInDEV();
                } else // Partial state object
                partialState = _payload;
                if (partialState === null || partialState === undefined) // Null and undefined are treated as no-ops.
                return prevState;
                 // Merge the partial state and the previous state.
                return assign({}, prevState, partialState);
            case ForceUpdate:
                hasForceUpdate = true;
                return prevState;
        }
        return prevState;
    }
    function processUpdateQueue(workInProgress, props, instance, renderLanes) {
        // This is always non-null on a ClassComponent or HostRoot
        var queue = workInProgress.updateQueue;
        hasForceUpdate = false;
        currentlyProcessingQueue = queue.shared;
        var firstBaseUpdate = queue.firstBaseUpdate;
        var lastBaseUpdate = queue.lastBaseUpdate; // Check if there are pending updates. If so, transfer them to the base queue.
        var pendingQueue = queue.shared.pending;
        if (pendingQueue !== null) {
            queue.shared.pending = null; // The pending queue is circular. Disconnect the pointer between first
            // and last so that it's non-circular.
            var lastPendingUpdate = pendingQueue;
            var firstPendingUpdate = lastPendingUpdate.next;
            lastPendingUpdate.next = null; // Append pending updates to base queue
            if (lastBaseUpdate === null) firstBaseUpdate = firstPendingUpdate;
            else lastBaseUpdate.next = firstPendingUpdate;
            lastBaseUpdate = lastPendingUpdate; // If there's a current queue, and it's different from the base queue, then
            // we need to transfer the updates to that queue, too. Because the base
            // queue is a singly-linked list with no cycles, we can append to both
            // lists and take advantage of structural sharing.
            // TODO: Pass `current` as argument
            var current = workInProgress.alternate;
            if (current !== null) {
                // This is always non-null on a ClassComponent or HostRoot
                var currentQueue = current.updateQueue;
                var currentLastBaseUpdate = currentQueue.lastBaseUpdate;
                if (currentLastBaseUpdate !== lastBaseUpdate) {
                    if (currentLastBaseUpdate === null) currentQueue.firstBaseUpdate = firstPendingUpdate;
                    else currentLastBaseUpdate.next = firstPendingUpdate;
                    currentQueue.lastBaseUpdate = lastPendingUpdate;
                }
            }
        } // These values may change as we process the queue.
        if (firstBaseUpdate !== null) {
            // Iterate through the list of updates to compute the result.
            var newState = queue.baseState; // TODO: Don't need to accumulate this. Instead, we can remove renderLanes
            // from the original lanes.
            var newLanes = NoLanes;
            var newBaseState = null;
            var newFirstBaseUpdate = null;
            var newLastBaseUpdate = null;
            var update = firstBaseUpdate;
            do {
                var updateLane = update.lane;
                var updateEventTime = update.eventTime;
                if (!isSubsetOfLanes(renderLanes, updateLane)) {
                    // Priority is insufficient. Skip this update. If this is the first
                    // skipped update, the previous update/state is the new base
                    // update/state.
                    var clone = {
                        eventTime: updateEventTime,
                        lane: updateLane,
                        tag: update.tag,
                        payload: update.payload,
                        callback: update.callback,
                        next: null
                    };
                    if (newLastBaseUpdate === null) {
                        newFirstBaseUpdate = newLastBaseUpdate = clone;
                        newBaseState = newState;
                    } else newLastBaseUpdate = newLastBaseUpdate.next = clone;
                     // Update the remaining priority in the queue.
                    newLanes = mergeLanes(newLanes, updateLane);
                } else {
                    // This update does have sufficient priority.
                    if (newLastBaseUpdate !== null) {
                        var _clone = {
                            eventTime: updateEventTime,
                            // This update is going to be committed so we never want uncommit
                            // it. Using NoLane works because 0 is a subset of all bitmasks, so
                            // this will never be skipped by the check above.
                            lane: NoLane,
                            tag: update.tag,
                            payload: update.payload,
                            callback: update.callback,
                            next: null
                        };
                        newLastBaseUpdate = newLastBaseUpdate.next = _clone;
                    } // Process this update.
                    newState = getStateFromUpdate(workInProgress, queue, update, newState, props, instance);
                    var callback = update.callback;
                    if (callback !== null && // If the update was already committed, we should not queue its
                    // callback again.
                    update.lane !== NoLane) {
                        workInProgress.flags |= Callback;
                        var effects = queue.effects;
                        if (effects === null) queue.effects = [
                            update
                        ];
                        else effects.push(update);
                    }
                }
                update = update.next;
                if (update === null) {
                    pendingQueue = queue.shared.pending;
                    if (pendingQueue === null) break;
                    else {
                        // An update was scheduled from inside a reducer. Add the new
                        // pending updates to the end of the list and keep processing.
                        var _lastPendingUpdate = pendingQueue; // Intentionally unsound. Pending updates form a circular list, but we
                        // unravel them when transferring them to the base queue.
                        var _firstPendingUpdate = _lastPendingUpdate.next;
                        _lastPendingUpdate.next = null;
                        update = _firstPendingUpdate;
                        queue.lastBaseUpdate = _lastPendingUpdate;
                        queue.shared.pending = null;
                    }
                }
            }while (true);
            if (newLastBaseUpdate === null) newBaseState = newState;
            queue.baseState = newBaseState;
            queue.firstBaseUpdate = newFirstBaseUpdate;
            queue.lastBaseUpdate = newLastBaseUpdate; // Interleaved updates are stored on a separate queue. We aren't going to
            // process them during this render, but we do need to track which lanes
            // are remaining.
            var lastInterleaved = queue.shared.interleaved;
            if (lastInterleaved !== null) {
                var interleaved = lastInterleaved;
                do {
                    newLanes = mergeLanes(newLanes, interleaved.lane);
                    interleaved = interleaved.next;
                }while (interleaved !== lastInterleaved);
            } else if (firstBaseUpdate === null) // `queue.lanes` is used for entangling transitions. We can set it back to
            // zero once the queue is empty.
            queue.shared.lanes = NoLanes;
             // Set the remaining expiration time to be whatever is remaining in the queue.
            // This should be fine because the only two other things that contribute to
            // expiration time are props and context. We're already in the middle of the
            // begin phase by the time we start processing the queue, so we've already
            // dealt with the props. Context in components that specify
            // shouldComponentUpdate is tricky; but we'll have to account for
            // that regardless.
            markSkippedUpdateLanes(newLanes);
            workInProgress.lanes = newLanes;
            workInProgress.memoizedState = newState;
        }
        currentlyProcessingQueue = null;
    }
    function callCallback(callback, context) {
        if (typeof callback !== "function") throw new Error("Invalid argument passed as callback. Expected a function. Instead " + ("received: " + callback));
        callback.call(context);
    }
    function resetHasForceUpdateBeforeProcessing() {
        hasForceUpdate = false;
    }
    function checkHasForceUpdateAfterProcessing() {
        return hasForceUpdate;
    }
    function commitUpdateQueue(finishedWork, finishedQueue, instance) {
        // Commit the effects
        var effects = finishedQueue.effects;
        finishedQueue.effects = null;
        if (effects !== null) for(var i = 0; i < effects.length; i++){
            var effect = effects[i];
            var callback = effect.callback;
            if (callback !== null) {
                effect.callback = null;
                callCallback(callback, instance);
            }
        }
    }
    var fakeInternalInstance = {}; // React.Component uses a shared frozen object by default.
    // We'll use it to determine whether we need to initialize legacy refs.
    var emptyRefsObject = new React.Component().refs;
    var didWarnAboutStateAssignmentForComponent;
    var didWarnAboutUninitializedState;
    var didWarnAboutGetSnapshotBeforeUpdateWithoutDidUpdate;
    var didWarnAboutLegacyLifecyclesAndDerivedState;
    var didWarnAboutUndefinedDerivedState;
    var warnOnUndefinedDerivedState;
    var warnOnInvalidCallback;
    var didWarnAboutDirectlyAssigningPropsToState;
    var didWarnAboutContextTypeAndContextTypes;
    var didWarnAboutInvalidateContextType;
    didWarnAboutStateAssignmentForComponent = new Set();
    didWarnAboutUninitializedState = new Set();
    didWarnAboutGetSnapshotBeforeUpdateWithoutDidUpdate = new Set();
    didWarnAboutLegacyLifecyclesAndDerivedState = new Set();
    didWarnAboutDirectlyAssigningPropsToState = new Set();
    didWarnAboutUndefinedDerivedState = new Set();
    didWarnAboutContextTypeAndContextTypes = new Set();
    didWarnAboutInvalidateContextType = new Set();
    var didWarnOnInvalidCallback = new Set();
    warnOnInvalidCallback = function(callback, callerName) {
        if (callback === null || typeof callback === "function") return;
        var key = callerName + "_" + callback;
        if (!didWarnOnInvalidCallback.has(key)) {
            didWarnOnInvalidCallback.add(key);
            error("%s(...): Expected the last optional `callback` argument to be a function. Instead received: %s.", callerName, callback);
        }
    };
    warnOnUndefinedDerivedState = function(type, partialState) {
        if (partialState === undefined) {
            var componentName = getComponentNameFromType(type) || "Component";
            if (!didWarnAboutUndefinedDerivedState.has(componentName)) {
                didWarnAboutUndefinedDerivedState.add(componentName);
                error("%s.getDerivedStateFromProps(): A valid state object (or null) must be returned. You have returned undefined.", componentName);
            }
        }
    }; // This is so gross but it's at least non-critical and can be removed if
    // it causes problems. This is meant to give a nicer error message for
    // ReactDOM15.unstable_renderSubtreeIntoContainer(reactDOM16Component,
    // ...)) which otherwise throws a "_processChildContext is not a function"
    // exception.
    Object.defineProperty(fakeInternalInstance, "_processChildContext", {
        enumerable: false,
        value: function() {
            throw new Error("_processChildContext is not available in React 16+. This likely means you have multiple copies of React and are attempting to nest a React 15 tree inside a React 16 tree using unstable_renderSubtreeIntoContainer, which isn't supported. Try to make sure you have only one copy of React (and ideally, switch to ReactDOM.createPortal).");
        }
    });
    Object.freeze(fakeInternalInstance);
    function applyDerivedStateFromProps(workInProgress, ctor, getDerivedStateFromProps, nextProps) {
        var prevState = workInProgress.memoizedState;
        var partialState = getDerivedStateFromProps(nextProps, prevState);
        if (workInProgress.mode & StrictLegacyMode) {
            setIsStrictModeForDevtools(true);
            try {
                // Invoke the function an extra time to help detect side-effects.
                partialState = getDerivedStateFromProps(nextProps, prevState);
            } finally{
                setIsStrictModeForDevtools(false);
            }
        }
        warnOnUndefinedDerivedState(ctor, partialState);
        var memoizedState = partialState === null || partialState === undefined ? prevState : assign({}, prevState, partialState);
        workInProgress.memoizedState = memoizedState; // Once the update queue is empty, persist the derived state onto the
        // base state.
        if (workInProgress.lanes === NoLanes) {
            // Queue is always non-null for classes
            var updateQueue = workInProgress.updateQueue;
            updateQueue.baseState = memoizedState;
        }
    }
    var classComponentUpdater = {
        isMounted: isMounted,
        enqueueSetState: function(inst, payload, callback) {
            var fiber = get(inst);
            var eventTime = requestEventTime();
            var lane = requestUpdateLane(fiber);
            var update = createUpdate(eventTime, lane);
            update.payload = payload;
            if (callback !== undefined && callback !== null) {
                warnOnInvalidCallback(callback, "setState");
                update.callback = callback;
            }
            var root = enqueueUpdate(fiber, update, lane);
            if (root !== null) {
                scheduleUpdateOnFiber(root, fiber, lane, eventTime);
                entangleTransitions(root, fiber, lane);
            }
            markStateUpdateScheduled(fiber, lane);
        },
        enqueueReplaceState: function(inst, payload, callback) {
            var fiber = get(inst);
            var eventTime = requestEventTime();
            var lane = requestUpdateLane(fiber);
            var update = createUpdate(eventTime, lane);
            update.tag = ReplaceState;
            update.payload = payload;
            if (callback !== undefined && callback !== null) {
                warnOnInvalidCallback(callback, "replaceState");
                update.callback = callback;
            }
            var root = enqueueUpdate(fiber, update, lane);
            if (root !== null) {
                scheduleUpdateOnFiber(root, fiber, lane, eventTime);
                entangleTransitions(root, fiber, lane);
            }
            markStateUpdateScheduled(fiber, lane);
        },
        enqueueForceUpdate: function(inst, callback) {
            var fiber = get(inst);
            var eventTime = requestEventTime();
            var lane = requestUpdateLane(fiber);
            var update = createUpdate(eventTime, lane);
            update.tag = ForceUpdate;
            if (callback !== undefined && callback !== null) {
                warnOnInvalidCallback(callback, "forceUpdate");
                update.callback = callback;
            }
            var root = enqueueUpdate(fiber, update, lane);
            if (root !== null) {
                scheduleUpdateOnFiber(root, fiber, lane, eventTime);
                entangleTransitions(root, fiber, lane);
            }
            markForceUpdateScheduled(fiber, lane);
        }
    };
    function checkShouldComponentUpdate(workInProgress, ctor, oldProps, newProps, oldState, newState, nextContext) {
        var instance = workInProgress.stateNode;
        if (typeof instance.shouldComponentUpdate === "function") {
            var shouldUpdate = instance.shouldComponentUpdate(newProps, newState, nextContext);
            if (workInProgress.mode & StrictLegacyMode) {
                setIsStrictModeForDevtools(true);
                try {
                    // Invoke the function an extra time to help detect side-effects.
                    shouldUpdate = instance.shouldComponentUpdate(newProps, newState, nextContext);
                } finally{
                    setIsStrictModeForDevtools(false);
                }
            }
            if (shouldUpdate === undefined) error("%s.shouldComponentUpdate(): Returned undefined instead of a boolean value. Make sure to return true or false.", getComponentNameFromType(ctor) || "Component");
            return shouldUpdate;
        }
        if (ctor.prototype && ctor.prototype.isPureReactComponent) return !shallowEqual(oldProps, newProps) || !shallowEqual(oldState, newState);
        return true;
    }
    function checkClassInstance(workInProgress, ctor, newProps) {
        var instance = workInProgress.stateNode;
        var name = getComponentNameFromType(ctor) || "Component";
        var renderPresent = instance.render;
        if (!renderPresent) {
            if (ctor.prototype && typeof ctor.prototype.render === "function") error("%s(...): No `render` method found on the returned component instance: did you accidentally return an object from the constructor?", name);
            else error("%s(...): No `render` method found on the returned component instance: you may have forgotten to define `render`.", name);
        }
        if (instance.getInitialState && !instance.getInitialState.isReactClassApproved && !instance.state) error("getInitialState was defined on %s, a plain JavaScript class. This is only supported for classes created using React.createClass. Did you mean to define a state property instead?", name);
        if (instance.getDefaultProps && !instance.getDefaultProps.isReactClassApproved) error("getDefaultProps was defined on %s, a plain JavaScript class. This is only supported for classes created using React.createClass. Use a static property to define defaultProps instead.", name);
        if (instance.propTypes) error("propTypes was defined as an instance property on %s. Use a static property to define propTypes instead.", name);
        if (instance.contextType) error("contextType was defined as an instance property on %s. Use a static property to define contextType instead.", name);
        if (instance.contextTypes) error("contextTypes was defined as an instance property on %s. Use a static property to define contextTypes instead.", name);
        if (ctor.contextType && ctor.contextTypes && !didWarnAboutContextTypeAndContextTypes.has(ctor)) {
            didWarnAboutContextTypeAndContextTypes.add(ctor);
            error("%s declares both contextTypes and contextType static properties. The legacy contextTypes property will be ignored.", name);
        }
        if (typeof instance.componentShouldUpdate === "function") error("%s has a method called componentShouldUpdate(). Did you mean shouldComponentUpdate()? The name is phrased as a question because the function is expected to return a value.", name);
        if (ctor.prototype && ctor.prototype.isPureReactComponent && typeof instance.shouldComponentUpdate !== "undefined") error("%s has a method called shouldComponentUpdate(). shouldComponentUpdate should not be used when extending React.PureComponent. Please extend React.Component if shouldComponentUpdate is used.", getComponentNameFromType(ctor) || "A pure component");
        if (typeof instance.componentDidUnmount === "function") error("%s has a method called componentDidUnmount(). But there is no such lifecycle method. Did you mean componentWillUnmount()?", name);
        if (typeof instance.componentDidReceiveProps === "function") error("%s has a method called componentDidReceiveProps(). But there is no such lifecycle method. If you meant to update the state in response to changing props, use componentWillReceiveProps(). If you meant to fetch data or run side-effects or mutations after React has updated the UI, use componentDidUpdate().", name);
        if (typeof instance.componentWillRecieveProps === "function") error("%s has a method called componentWillRecieveProps(). Did you mean componentWillReceiveProps()?", name);
        if (typeof instance.UNSAFE_componentWillRecieveProps === "function") error("%s has a method called UNSAFE_componentWillRecieveProps(). Did you mean UNSAFE_componentWillReceiveProps()?", name);
        var hasMutatedProps = instance.props !== newProps;
        if (instance.props !== undefined && hasMutatedProps) error("%s(...): When calling super() in `%s`, make sure to pass up the same props that your component's constructor was passed.", name, name);
        if (instance.defaultProps) error("Setting defaultProps as an instance property on %s is not supported and will be ignored. Instead, define defaultProps as a static property on %s.", name, name);
        if (typeof instance.getSnapshotBeforeUpdate === "function" && typeof instance.componentDidUpdate !== "function" && !didWarnAboutGetSnapshotBeforeUpdateWithoutDidUpdate.has(ctor)) {
            didWarnAboutGetSnapshotBeforeUpdateWithoutDidUpdate.add(ctor);
            error("%s: getSnapshotBeforeUpdate() should be used with componentDidUpdate(). This component defines getSnapshotBeforeUpdate() only.", getComponentNameFromType(ctor));
        }
        if (typeof instance.getDerivedStateFromProps === "function") error("%s: getDerivedStateFromProps() is defined as an instance method and will be ignored. Instead, declare it as a static method.", name);
        if (typeof instance.getDerivedStateFromError === "function") error("%s: getDerivedStateFromError() is defined as an instance method and will be ignored. Instead, declare it as a static method.", name);
        if (typeof ctor.getSnapshotBeforeUpdate === "function") error("%s: getSnapshotBeforeUpdate() is defined as a static method and will be ignored. Instead, declare it as an instance method.", name);
        var _state = instance.state;
        if (_state && (typeof _state !== "object" || isArray(_state))) error("%s.state: must be set to an object or null", name);
        if (typeof instance.getChildContext === "function" && typeof ctor.childContextTypes !== "object") error("%s.getChildContext(): childContextTypes must be defined in order to use getChildContext().", name);
    }
    function adoptClassInstance(workInProgress, instance) {
        instance.updater = classComponentUpdater;
        workInProgress.stateNode = instance; // The instance needs access to the fiber so that it can schedule updates
        set(instance, workInProgress);
        instance._reactInternalInstance = fakeInternalInstance;
    }
    function constructClassInstance(workInProgress, ctor, props) {
        var isLegacyContextConsumer = false;
        var unmaskedContext = emptyContextObject;
        var context = emptyContextObject;
        var contextType = ctor.contextType;
        if ("contextType" in ctor) {
            var isValid = contextType === null || contextType !== undefined && contextType.$$typeof === REACT_CONTEXT_TYPE && contextType._context === undefined; // Not a <Context.Consumer>
            if (!isValid && !didWarnAboutInvalidateContextType.has(ctor)) {
                didWarnAboutInvalidateContextType.add(ctor);
                var addendum = "";
                if (contextType === undefined) addendum = " However, it is set to undefined. This can be caused by a typo or by mixing up named and default imports. This can also happen due to a circular dependency, so try moving the createContext() call to a separate file.";
                else if (typeof contextType !== "object") addendum = " However, it is set to a " + typeof contextType + ".";
                else if (contextType.$$typeof === REACT_PROVIDER_TYPE) addendum = " Did you accidentally pass the Context.Provider instead?";
                else if (contextType._context !== undefined) // <Context.Consumer>
                addendum = " Did you accidentally pass the Context.Consumer instead?";
                else addendum = " However, it is set to an object with keys {" + Object.keys(contextType).join(", ") + "}.";
                error("%s defines an invalid contextType. contextType should point to the Context object returned by React.createContext().%s", getComponentNameFromType(ctor) || "Component", addendum);
            }
        }
        if (typeof contextType === "object" && contextType !== null) context = readContext(contextType);
        else {
            unmaskedContext = getUnmaskedContext(workInProgress, ctor, true);
            var contextTypes = ctor.contextTypes;
            isLegacyContextConsumer = contextTypes !== null && contextTypes !== undefined;
            context = isLegacyContextConsumer ? getMaskedContext(workInProgress, unmaskedContext) : emptyContextObject;
        }
        var instance = new ctor(props, context); // Instantiate twice to help detect side-effects.
        if (workInProgress.mode & StrictLegacyMode) {
            setIsStrictModeForDevtools(true);
            try {
                instance = new ctor(props, context); // eslint-disable-line no-new
            } finally{
                setIsStrictModeForDevtools(false);
            }
        }
        var state = workInProgress.memoizedState = instance.state !== null && instance.state !== undefined ? instance.state : null;
        adoptClassInstance(workInProgress, instance);
        if (typeof ctor.getDerivedStateFromProps === "function" && state === null) {
            var componentName = getComponentNameFromType(ctor) || "Component";
            if (!didWarnAboutUninitializedState.has(componentName)) {
                didWarnAboutUninitializedState.add(componentName);
                error("`%s` uses `getDerivedStateFromProps` but its initial state is %s. This is not recommended. Instead, define the initial state by assigning an object to `this.state` in the constructor of `%s`. This ensures that `getDerivedStateFromProps` arguments have a consistent shape.", componentName, instance.state === null ? "null" : "undefined", componentName);
            }
        } // If new component APIs are defined, "unsafe" lifecycles won't be called.
        // Warn about these lifecycles if they are present.
        // Don't warn about react-lifecycles-compat polyfilled methods though.
        if (typeof ctor.getDerivedStateFromProps === "function" || typeof instance.getSnapshotBeforeUpdate === "function") {
            var foundWillMountName = null;
            var foundWillReceivePropsName = null;
            var foundWillUpdateName = null;
            if (typeof instance.componentWillMount === "function" && instance.componentWillMount.__suppressDeprecationWarning !== true) foundWillMountName = "componentWillMount";
            else if (typeof instance.UNSAFE_componentWillMount === "function") foundWillMountName = "UNSAFE_componentWillMount";
            if (typeof instance.componentWillReceiveProps === "function" && instance.componentWillReceiveProps.__suppressDeprecationWarning !== true) foundWillReceivePropsName = "componentWillReceiveProps";
            else if (typeof instance.UNSAFE_componentWillReceiveProps === "function") foundWillReceivePropsName = "UNSAFE_componentWillReceiveProps";
            if (typeof instance.componentWillUpdate === "function" && instance.componentWillUpdate.__suppressDeprecationWarning !== true) foundWillUpdateName = "componentWillUpdate";
            else if (typeof instance.UNSAFE_componentWillUpdate === "function") foundWillUpdateName = "UNSAFE_componentWillUpdate";
            if (foundWillMountName !== null || foundWillReceivePropsName !== null || foundWillUpdateName !== null) {
                var _componentName = getComponentNameFromType(ctor) || "Component";
                var newApiName = typeof ctor.getDerivedStateFromProps === "function" ? "getDerivedStateFromProps()" : "getSnapshotBeforeUpdate()";
                if (!didWarnAboutLegacyLifecyclesAndDerivedState.has(_componentName)) {
                    didWarnAboutLegacyLifecyclesAndDerivedState.add(_componentName);
                    error("Unsafe legacy lifecycles will not be called for components using new component APIs.\n\n%s uses %s but also contains the following legacy lifecycles:%s%s%s\n\nThe above lifecycles should be removed. Learn more about this warning here:\nhttps://reactjs.org/link/unsafe-component-lifecycles", _componentName, newApiName, foundWillMountName !== null ? "\n  " + foundWillMountName : "", foundWillReceivePropsName !== null ? "\n  " + foundWillReceivePropsName : "", foundWillUpdateName !== null ? "\n  " + foundWillUpdateName : "");
                }
            }
        }
        // ReactFiberContext usually updates this cache but can't for newly-created instances.
        if (isLegacyContextConsumer) cacheContext(workInProgress, unmaskedContext, context);
        return instance;
    }
    function callComponentWillMount(workInProgress, instance) {
        var oldState = instance.state;
        if (typeof instance.componentWillMount === "function") instance.componentWillMount();
        if (typeof instance.UNSAFE_componentWillMount === "function") instance.UNSAFE_componentWillMount();
        if (oldState !== instance.state) {
            error("%s.componentWillMount(): Assigning directly to this.state is deprecated (except inside a component's constructor). Use setState instead.", getComponentNameFromFiber(workInProgress) || "Component");
            classComponentUpdater.enqueueReplaceState(instance, instance.state, null);
        }
    }
    function callComponentWillReceiveProps(workInProgress, instance, newProps, nextContext) {
        var oldState = instance.state;
        if (typeof instance.componentWillReceiveProps === "function") instance.componentWillReceiveProps(newProps, nextContext);
        if (typeof instance.UNSAFE_componentWillReceiveProps === "function") instance.UNSAFE_componentWillReceiveProps(newProps, nextContext);
        if (instance.state !== oldState) {
            var componentName = getComponentNameFromFiber(workInProgress) || "Component";
            if (!didWarnAboutStateAssignmentForComponent.has(componentName)) {
                didWarnAboutStateAssignmentForComponent.add(componentName);
                error("%s.componentWillReceiveProps(): Assigning directly to this.state is deprecated (except inside a component's constructor). Use setState instead.", componentName);
            }
            classComponentUpdater.enqueueReplaceState(instance, instance.state, null);
        }
    } // Invokes the mount life-cycles on a previously never rendered instance.
    function mountClassInstance(workInProgress, ctor, newProps, renderLanes) {
        checkClassInstance(workInProgress, ctor, newProps);
        var instance = workInProgress.stateNode;
        instance.props = newProps;
        instance.state = workInProgress.memoizedState;
        instance.refs = emptyRefsObject;
        initializeUpdateQueue(workInProgress);
        var contextType = ctor.contextType;
        if (typeof contextType === "object" && contextType !== null) instance.context = readContext(contextType);
        else {
            var unmaskedContext = getUnmaskedContext(workInProgress, ctor, true);
            instance.context = getMaskedContext(workInProgress, unmaskedContext);
        }
        if (instance.state === newProps) {
            var componentName = getComponentNameFromType(ctor) || "Component";
            if (!didWarnAboutDirectlyAssigningPropsToState.has(componentName)) {
                didWarnAboutDirectlyAssigningPropsToState.add(componentName);
                error("%s: It is not recommended to assign props directly to state because updates to props won't be reflected in state. In most cases, it is better to use props directly.", componentName);
            }
        }
        if (workInProgress.mode & StrictLegacyMode) ReactStrictModeWarnings.recordLegacyContextWarning(workInProgress, instance);
        ReactStrictModeWarnings.recordUnsafeLifecycleWarnings(workInProgress, instance);
        instance.state = workInProgress.memoizedState;
        var getDerivedStateFromProps = ctor.getDerivedStateFromProps;
        if (typeof getDerivedStateFromProps === "function") {
            applyDerivedStateFromProps(workInProgress, ctor, getDerivedStateFromProps, newProps);
            instance.state = workInProgress.memoizedState;
        } // In order to support react-lifecycles-compat polyfilled components,
        // Unsafe lifecycles should not be invoked for components using the new APIs.
        if (typeof ctor.getDerivedStateFromProps !== "function" && typeof instance.getSnapshotBeforeUpdate !== "function" && (typeof instance.UNSAFE_componentWillMount === "function" || typeof instance.componentWillMount === "function")) {
            callComponentWillMount(workInProgress, instance); // If we had additional state updates during this life-cycle, let's
            // process them now.
            processUpdateQueue(workInProgress, newProps, instance, renderLanes);
            instance.state = workInProgress.memoizedState;
        }
        if (typeof instance.componentDidMount === "function") {
            var fiberFlags = Update;
            fiberFlags |= LayoutStatic;
            if ((workInProgress.mode & StrictEffectsMode) !== NoMode) fiberFlags |= MountLayoutDev;
            workInProgress.flags |= fiberFlags;
        }
    }
    function resumeMountClassInstance(workInProgress, ctor, newProps, renderLanes) {
        var instance = workInProgress.stateNode;
        var oldProps = workInProgress.memoizedProps;
        instance.props = oldProps;
        var oldContext = instance.context;
        var contextType = ctor.contextType;
        var nextContext = emptyContextObject;
        if (typeof contextType === "object" && contextType !== null) nextContext = readContext(contextType);
        else {
            var nextLegacyUnmaskedContext = getUnmaskedContext(workInProgress, ctor, true);
            nextContext = getMaskedContext(workInProgress, nextLegacyUnmaskedContext);
        }
        var getDerivedStateFromProps = ctor.getDerivedStateFromProps;
        var hasNewLifecycles = typeof getDerivedStateFromProps === "function" || typeof instance.getSnapshotBeforeUpdate === "function"; // Note: During these life-cycles, instance.props/instance.state are what
        // ever the previously attempted to render - not the "current". However,
        // during componentDidUpdate we pass the "current" props.
        // In order to support react-lifecycles-compat polyfilled components,
        // Unsafe lifecycles should not be invoked for components using the new APIs.
        if (!hasNewLifecycles && (typeof instance.UNSAFE_componentWillReceiveProps === "function" || typeof instance.componentWillReceiveProps === "function")) {
            if (oldProps !== newProps || oldContext !== nextContext) callComponentWillReceiveProps(workInProgress, instance, newProps, nextContext);
        }
        resetHasForceUpdateBeforeProcessing();
        var oldState = workInProgress.memoizedState;
        var newState = instance.state = oldState;
        processUpdateQueue(workInProgress, newProps, instance, renderLanes);
        newState = workInProgress.memoizedState;
        if (oldProps === newProps && oldState === newState && !hasContextChanged() && !checkHasForceUpdateAfterProcessing()) {
            // If an update was already in progress, we should schedule an Update
            // effect even though we're bailing out, so that cWU/cDU are called.
            if (typeof instance.componentDidMount === "function") {
                var fiberFlags = Update;
                fiberFlags |= LayoutStatic;
                if ((workInProgress.mode & StrictEffectsMode) !== NoMode) fiberFlags |= MountLayoutDev;
                workInProgress.flags |= fiberFlags;
            }
            return false;
        }
        if (typeof getDerivedStateFromProps === "function") {
            applyDerivedStateFromProps(workInProgress, ctor, getDerivedStateFromProps, newProps);
            newState = workInProgress.memoizedState;
        }
        var shouldUpdate = checkHasForceUpdateAfterProcessing() || checkShouldComponentUpdate(workInProgress, ctor, oldProps, newProps, oldState, newState, nextContext);
        if (shouldUpdate) {
            // In order to support react-lifecycles-compat polyfilled components,
            // Unsafe lifecycles should not be invoked for components using the new APIs.
            if (!hasNewLifecycles && (typeof instance.UNSAFE_componentWillMount === "function" || typeof instance.componentWillMount === "function")) {
                if (typeof instance.componentWillMount === "function") instance.componentWillMount();
                if (typeof instance.UNSAFE_componentWillMount === "function") instance.UNSAFE_componentWillMount();
            }
            if (typeof instance.componentDidMount === "function") {
                var _fiberFlags = Update;
                _fiberFlags |= LayoutStatic;
                if ((workInProgress.mode & StrictEffectsMode) !== NoMode) _fiberFlags |= MountLayoutDev;
                workInProgress.flags |= _fiberFlags;
            }
        } else {
            // If an update was already in progress, we should schedule an Update
            // effect even though we're bailing out, so that cWU/cDU are called.
            if (typeof instance.componentDidMount === "function") {
                var _fiberFlags2 = Update;
                _fiberFlags2 |= LayoutStatic;
                if ((workInProgress.mode & StrictEffectsMode) !== NoMode) _fiberFlags2 |= MountLayoutDev;
                workInProgress.flags |= _fiberFlags2;
            } // If shouldComponentUpdate returned false, we should still update the
            // memoized state to indicate that this work can be reused.
            workInProgress.memoizedProps = newProps;
            workInProgress.memoizedState = newState;
        } // Update the existing instance's state, props, and context pointers even
        // if shouldComponentUpdate returns false.
        instance.props = newProps;
        instance.state = newState;
        instance.context = nextContext;
        return shouldUpdate;
    } // Invokes the update life-cycles and returns false if it shouldn't rerender.
    function updateClassInstance(current, workInProgress, ctor, newProps, renderLanes) {
        var instance = workInProgress.stateNode;
        cloneUpdateQueue(current, workInProgress);
        var unresolvedOldProps = workInProgress.memoizedProps;
        var oldProps = workInProgress.type === workInProgress.elementType ? unresolvedOldProps : resolveDefaultProps(workInProgress.type, unresolvedOldProps);
        instance.props = oldProps;
        var unresolvedNewProps = workInProgress.pendingProps;
        var oldContext = instance.context;
        var contextType = ctor.contextType;
        var nextContext = emptyContextObject;
        if (typeof contextType === "object" && contextType !== null) nextContext = readContext(contextType);
        else {
            var nextUnmaskedContext = getUnmaskedContext(workInProgress, ctor, true);
            nextContext = getMaskedContext(workInProgress, nextUnmaskedContext);
        }
        var getDerivedStateFromProps = ctor.getDerivedStateFromProps;
        var hasNewLifecycles = typeof getDerivedStateFromProps === "function" || typeof instance.getSnapshotBeforeUpdate === "function"; // Note: During these life-cycles, instance.props/instance.state are what
        // ever the previously attempted to render - not the "current". However,
        // during componentDidUpdate we pass the "current" props.
        // In order to support react-lifecycles-compat polyfilled components,
        // Unsafe lifecycles should not be invoked for components using the new APIs.
        if (!hasNewLifecycles && (typeof instance.UNSAFE_componentWillReceiveProps === "function" || typeof instance.componentWillReceiveProps === "function")) {
            if (unresolvedOldProps !== unresolvedNewProps || oldContext !== nextContext) callComponentWillReceiveProps(workInProgress, instance, newProps, nextContext);
        }
        resetHasForceUpdateBeforeProcessing();
        var oldState = workInProgress.memoizedState;
        var newState = instance.state = oldState;
        processUpdateQueue(workInProgress, newProps, instance, renderLanes);
        newState = workInProgress.memoizedState;
        if (unresolvedOldProps === unresolvedNewProps && oldState === newState && !hasContextChanged() && !checkHasForceUpdateAfterProcessing() && !enableLazyContextPropagation) {
            // If an update was already in progress, we should schedule an Update
            // effect even though we're bailing out, so that cWU/cDU are called.
            if (typeof instance.componentDidUpdate === "function") {
                if (unresolvedOldProps !== current.memoizedProps || oldState !== current.memoizedState) workInProgress.flags |= Update;
            }
            if (typeof instance.getSnapshotBeforeUpdate === "function") {
                if (unresolvedOldProps !== current.memoizedProps || oldState !== current.memoizedState) workInProgress.flags |= Snapshot;
            }
            return false;
        }
        if (typeof getDerivedStateFromProps === "function") {
            applyDerivedStateFromProps(workInProgress, ctor, getDerivedStateFromProps, newProps);
            newState = workInProgress.memoizedState;
        }
        var shouldUpdate = checkHasForceUpdateAfterProcessing() || checkShouldComponentUpdate(workInProgress, ctor, oldProps, newProps, oldState, newState, nextContext) || // TODO: In some cases, we'll end up checking if context has changed twice,
        // both before and after `shouldComponentUpdate` has been called. Not ideal,
        // but I'm loath to refactor this function. This only happens for memoized
        // components so it's not that common.
        enableLazyContextPropagation;
        if (shouldUpdate) {
            // In order to support react-lifecycles-compat polyfilled components,
            // Unsafe lifecycles should not be invoked for components using the new APIs.
            if (!hasNewLifecycles && (typeof instance.UNSAFE_componentWillUpdate === "function" || typeof instance.componentWillUpdate === "function")) {
                if (typeof instance.componentWillUpdate === "function") instance.componentWillUpdate(newProps, newState, nextContext);
                if (typeof instance.UNSAFE_componentWillUpdate === "function") instance.UNSAFE_componentWillUpdate(newProps, newState, nextContext);
            }
            if (typeof instance.componentDidUpdate === "function") workInProgress.flags |= Update;
            if (typeof instance.getSnapshotBeforeUpdate === "function") workInProgress.flags |= Snapshot;
        } else {
            // If an update was already in progress, we should schedule an Update
            // effect even though we're bailing out, so that cWU/cDU are called.
            if (typeof instance.componentDidUpdate === "function") {
                if (unresolvedOldProps !== current.memoizedProps || oldState !== current.memoizedState) workInProgress.flags |= Update;
            }
            if (typeof instance.getSnapshotBeforeUpdate === "function") {
                if (unresolvedOldProps !== current.memoizedProps || oldState !== current.memoizedState) workInProgress.flags |= Snapshot;
            } // If shouldComponentUpdate returned false, we should still update the
            // memoized props/state to indicate that this work can be reused.
            workInProgress.memoizedProps = newProps;
            workInProgress.memoizedState = newState;
        } // Update the existing instance's state, props, and context pointers even
        // if shouldComponentUpdate returns false.
        instance.props = newProps;
        instance.state = newState;
        instance.context = nextContext;
        return shouldUpdate;
    }
    var didWarnAboutMaps;
    var didWarnAboutGenerators;
    var didWarnAboutStringRefs;
    var ownerHasKeyUseWarning;
    var ownerHasFunctionTypeWarning;
    var warnForMissingKey = function(child, returnFiber) {};
    didWarnAboutMaps = false;
    didWarnAboutGenerators = false;
    didWarnAboutStringRefs = {};
    /**
   * Warn if there's no key explicitly set on dynamic arrays of children or
   * object keys are not valid. This allows us to keep track of children between
   * updates.
   */ ownerHasKeyUseWarning = {};
    ownerHasFunctionTypeWarning = {};
    warnForMissingKey = function(child, returnFiber) {
        if (child === null || typeof child !== "object") return;
        if (!child._store || child._store.validated || child.key != null) return;
        if (typeof child._store !== "object") throw new Error("React Component in warnForMissingKey should have a _store. This error is likely caused by a bug in React. Please file an issue.");
        child._store.validated = true;
        var componentName = getComponentNameFromFiber(returnFiber) || "Component";
        if (ownerHasKeyUseWarning[componentName]) return;
        ownerHasKeyUseWarning[componentName] = true;
        error('Each child in a list should have a unique "key" prop. See https://reactjs.org/link/warning-keys for more information.');
    };
    function coerceRef(returnFiber, current, element) {
        var mixedRef = element.ref;
        if (mixedRef !== null && typeof mixedRef !== "function" && typeof mixedRef !== "object") {
            // TODO: Clean this up once we turn on the string ref warning for
            // everyone, because the strict mode case will no longer be relevant
            if ((returnFiber.mode & StrictLegacyMode || warnAboutStringRefs) && // We warn in ReactElement.js if owner and self are equal for string refs
            // because these cannot be automatically converted to an arrow function
            // using a codemod. Therefore, we don't have to warn about string refs again.
            !(element._owner && element._self && element._owner.stateNode !== element._self)) {
                var componentName = getComponentNameFromFiber(returnFiber) || "Component";
                if (!didWarnAboutStringRefs[componentName]) {
                    error('A string ref, "%s", has been found within a strict mode tree. String refs are a source of potential bugs and should be avoided. We recommend using useRef() or createRef() instead. Learn more about using refs safely here: https://reactjs.org/link/strict-mode-string-ref', mixedRef);
                    didWarnAboutStringRefs[componentName] = true;
                }
            }
            if (element._owner) {
                var owner = element._owner;
                var inst;
                if (owner) {
                    var ownerFiber = owner;
                    if (ownerFiber.tag !== ClassComponent) throw new Error("Function components cannot have string refs. We recommend using useRef() instead. Learn more about using refs safely here: https://reactjs.org/link/strict-mode-string-ref");
                    inst = ownerFiber.stateNode;
                }
                if (!inst) throw new Error("Missing owner for string ref " + mixedRef + ". This error is likely caused by a " + "bug in React. Please file an issue.");
                 // Assigning this to a const so Flow knows it won't change in the closure
                var resolvedInst = inst;
                checkPropStringCoercion(mixedRef, "ref");
                var stringRef = "" + mixedRef; // Check if previous string ref matches new string ref
                if (current !== null && current.ref !== null && typeof current.ref === "function" && current.ref._stringRef === stringRef) return current.ref;
                var ref = function(value) {
                    var refs = resolvedInst.refs;
                    if (refs === emptyRefsObject) // This is a lazy pooled frozen object, so we need to initialize.
                    refs = resolvedInst.refs = {};
                    if (value === null) delete refs[stringRef];
                    else refs[stringRef] = value;
                };
                ref._stringRef = stringRef;
                return ref;
            } else {
                if (typeof mixedRef !== "string") throw new Error("Expected ref to be a function, a string, an object returned by React.createRef(), or null.");
                if (!element._owner) throw new Error("Element ref was specified as a string (" + mixedRef + ") but no owner was set. This could happen for one of" + " the following reasons:\n" + "1. You may be adding a ref to a function component\n" + "2. You may be adding a ref to a component that was not created inside a component's render method\n" + "3. You have multiple copies of React loaded\n" + "See https://reactjs.org/link/refs-must-have-owner for more information.");
            }
        }
        return mixedRef;
    }
    function throwOnInvalidObjectType(returnFiber, newChild) {
        var childString = Object.prototype.toString.call(newChild);
        throw new Error("Objects are not valid as a React child (found: " + (childString === "[object Object]" ? "object with keys {" + Object.keys(newChild).join(", ") + "}" : childString) + "). " + "If you meant to render a collection of children, use an array " + "instead.");
    }
    function warnOnFunctionType(returnFiber) {
        var componentName = getComponentNameFromFiber(returnFiber) || "Component";
        if (ownerHasFunctionTypeWarning[componentName]) return;
        ownerHasFunctionTypeWarning[componentName] = true;
        error("Functions are not valid as a React child. This may happen if you return a Component instead of <Component /> from render. Or maybe you meant to call this function rather than return it.");
    }
    function resolveLazy(lazyType) {
        var payload = lazyType._payload;
        var init = lazyType._init;
        return init(payload);
    } // This wrapper function exists because I expect to clone the code in each path
    // to be able to optimize each path individually by branching early. This needs
    // a compiler or we can do it manually. Helpers that don't need this branching
    // live outside of this function.
    function ChildReconciler(shouldTrackSideEffects) {
        function deleteChild(returnFiber, childToDelete) {
            if (!shouldTrackSideEffects) // Noop.
            return;
            var deletions = returnFiber.deletions;
            if (deletions === null) {
                returnFiber.deletions = [
                    childToDelete
                ];
                returnFiber.flags |= ChildDeletion;
            } else deletions.push(childToDelete);
        }
        function deleteRemainingChildren(returnFiber, currentFirstChild) {
            if (!shouldTrackSideEffects) // Noop.
            return null;
             // TODO: For the shouldClone case, this could be micro-optimized a bit by
            // assuming that after the first child we've already added everything.
            var childToDelete = currentFirstChild;
            while(childToDelete !== null){
                deleteChild(returnFiber, childToDelete);
                childToDelete = childToDelete.sibling;
            }
            return null;
        }
        function mapRemainingChildren(returnFiber, currentFirstChild) {
            // Add the remaining children to a temporary map so that we can find them by
            // keys quickly. Implicit (null) keys get added to this set with their index
            // instead.
            var existingChildren = new Map();
            var existingChild = currentFirstChild;
            while(existingChild !== null){
                if (existingChild.key !== null) existingChildren.set(existingChild.key, existingChild);
                else existingChildren.set(existingChild.index, existingChild);
                existingChild = existingChild.sibling;
            }
            return existingChildren;
        }
        function useFiber(fiber, pendingProps) {
            // We currently set sibling to null and index to 0 here because it is easy
            // to forget to do before returning it. E.g. for the single child case.
            var clone = createWorkInProgress(fiber, pendingProps);
            clone.index = 0;
            clone.sibling = null;
            return clone;
        }
        function placeChild(newFiber, lastPlacedIndex, newIndex) {
            newFiber.index = newIndex;
            if (!shouldTrackSideEffects) {
                // During hydration, the useId algorithm needs to know which fibers are
                // part of a list of children (arrays, iterators).
                newFiber.flags |= Forked;
                return lastPlacedIndex;
            }
            var current = newFiber.alternate;
            if (current !== null) {
                var oldIndex = current.index;
                if (oldIndex < lastPlacedIndex) {
                    // This is a move.
                    newFiber.flags |= Placement;
                    return lastPlacedIndex;
                } else // This item can stay in place.
                return oldIndex;
            } else {
                // This is an insertion.
                newFiber.flags |= Placement;
                return lastPlacedIndex;
            }
        }
        function placeSingleChild(newFiber) {
            // This is simpler for the single child case. We only need to do a
            // placement for inserting new children.
            if (shouldTrackSideEffects && newFiber.alternate === null) newFiber.flags |= Placement;
            return newFiber;
        }
        function updateTextNode(returnFiber, current, textContent, lanes) {
            if (current === null || current.tag !== HostText) {
                // Insert
                var created = createFiberFromText(textContent, returnFiber.mode, lanes);
                created.return = returnFiber;
                return created;
            } else {
                // Update
                var existing = useFiber(current, textContent);
                existing.return = returnFiber;
                return existing;
            }
        }
        function updateElement(returnFiber, current, element, lanes) {
            var elementType = element.type;
            if (elementType === REACT_FRAGMENT_TYPE) return updateFragment(returnFiber, current, element.props.children, lanes, element.key);
            if (current !== null) {
                if (current.elementType === elementType || isCompatibleFamilyForHotReloading(current, element) || // Lazy types should reconcile their resolved type.
                // We need to do this after the Hot Reloading check above,
                // because hot reloading has different semantics than prod because
                // it doesn't resuspend. So we can't let the call below suspend.
                typeof elementType === "object" && elementType !== null && elementType.$$typeof === REACT_LAZY_TYPE && resolveLazy(elementType) === current.type) {
                    // Move based on index
                    var existing = useFiber(current, element.props);
                    existing.ref = coerceRef(returnFiber, current, element);
                    existing.return = returnFiber;
                    existing._debugSource = element._source;
                    existing._debugOwner = element._owner;
                    return existing;
                }
            } // Insert
            var created = createFiberFromElement(element, returnFiber.mode, lanes);
            created.ref = coerceRef(returnFiber, current, element);
            created.return = returnFiber;
            return created;
        }
        function updatePortal(returnFiber, current, portal, lanes) {
            if (current === null || current.tag !== HostPortal || current.stateNode.containerInfo !== portal.containerInfo || current.stateNode.implementation !== portal.implementation) {
                // Insert
                var created = createFiberFromPortal(portal, returnFiber.mode, lanes);
                created.return = returnFiber;
                return created;
            } else {
                // Update
                var existing = useFiber(current, portal.children || []);
                existing.return = returnFiber;
                return existing;
            }
        }
        function updateFragment(returnFiber, current, fragment, lanes, key) {
            if (current === null || current.tag !== Fragment) {
                // Insert
                var created = createFiberFromFragment(fragment, returnFiber.mode, lanes, key);
                created.return = returnFiber;
                return created;
            } else {
                // Update
                var existing = useFiber(current, fragment);
                existing.return = returnFiber;
                return existing;
            }
        }
        function createChild(returnFiber, newChild, lanes) {
            if (typeof newChild === "string" && newChild !== "" || typeof newChild === "number") {
                // Text nodes don't have keys. If the previous node is implicitly keyed
                // we can continue to replace it without aborting even if it is not a text
                // node.
                var created = createFiberFromText("" + newChild, returnFiber.mode, lanes);
                created.return = returnFiber;
                return created;
            }
            if (typeof newChild === "object" && newChild !== null) {
                switch(newChild.$$typeof){
                    case REACT_ELEMENT_TYPE:
                        var _created = createFiberFromElement(newChild, returnFiber.mode, lanes);
                        _created.ref = coerceRef(returnFiber, null, newChild);
                        _created.return = returnFiber;
                        return _created;
                    case REACT_PORTAL_TYPE:
                        var _created2 = createFiberFromPortal(newChild, returnFiber.mode, lanes);
                        _created2.return = returnFiber;
                        return _created2;
                    case REACT_LAZY_TYPE:
                        var payload = newChild._payload;
                        var init = newChild._init;
                        return createChild(returnFiber, init(payload), lanes);
                }
                if (isArray(newChild) || getIteratorFn(newChild)) {
                    var _created3 = createFiberFromFragment(newChild, returnFiber.mode, lanes, null);
                    _created3.return = returnFiber;
                    return _created3;
                }
                throwOnInvalidObjectType(returnFiber, newChild);
            }
            if (typeof newChild === "function") warnOnFunctionType(returnFiber);
            return null;
        }
        function updateSlot(returnFiber, oldFiber, newChild, lanes) {
            // Update the fiber if the keys match, otherwise return null.
            var key = oldFiber !== null ? oldFiber.key : null;
            if (typeof newChild === "string" && newChild !== "" || typeof newChild === "number") {
                // Text nodes don't have keys. If the previous node is implicitly keyed
                // we can continue to replace it without aborting even if it is not a text
                // node.
                if (key !== null) return null;
                return updateTextNode(returnFiber, oldFiber, "" + newChild, lanes);
            }
            if (typeof newChild === "object" && newChild !== null) {
                switch(newChild.$$typeof){
                    case REACT_ELEMENT_TYPE:
                        if (newChild.key === key) return updateElement(returnFiber, oldFiber, newChild, lanes);
                        else return null;
                    case REACT_PORTAL_TYPE:
                        if (newChild.key === key) return updatePortal(returnFiber, oldFiber, newChild, lanes);
                        else return null;
                    case REACT_LAZY_TYPE:
                        var payload = newChild._payload;
                        var init = newChild._init;
                        return updateSlot(returnFiber, oldFiber, init(payload), lanes);
                }
                if (isArray(newChild) || getIteratorFn(newChild)) {
                    if (key !== null) return null;
                    return updateFragment(returnFiber, oldFiber, newChild, lanes, null);
                }
                throwOnInvalidObjectType(returnFiber, newChild);
            }
            if (typeof newChild === "function") warnOnFunctionType(returnFiber);
            return null;
        }
        function updateFromMap(existingChildren, returnFiber, newIdx, newChild, lanes) {
            if (typeof newChild === "string" && newChild !== "" || typeof newChild === "number") {
                // Text nodes don't have keys, so we neither have to check the old nor
                // new node for the key. If both are text nodes, they match.
                var matchedFiber = existingChildren.get(newIdx) || null;
                return updateTextNode(returnFiber, matchedFiber, "" + newChild, lanes);
            }
            if (typeof newChild === "object" && newChild !== null) {
                switch(newChild.$$typeof){
                    case REACT_ELEMENT_TYPE:
                        var _matchedFiber = existingChildren.get(newChild.key === null ? newIdx : newChild.key) || null;
                        return updateElement(returnFiber, _matchedFiber, newChild, lanes);
                    case REACT_PORTAL_TYPE:
                        var _matchedFiber2 = existingChildren.get(newChild.key === null ? newIdx : newChild.key) || null;
                        return updatePortal(returnFiber, _matchedFiber2, newChild, lanes);
                    case REACT_LAZY_TYPE:
                        var payload = newChild._payload;
                        var init = newChild._init;
                        return updateFromMap(existingChildren, returnFiber, newIdx, init(payload), lanes);
                }
                if (isArray(newChild) || getIteratorFn(newChild)) {
                    var _matchedFiber3 = existingChildren.get(newIdx) || null;
                    return updateFragment(returnFiber, _matchedFiber3, newChild, lanes, null);
                }
                throwOnInvalidObjectType(returnFiber, newChild);
            }
            if (typeof newChild === "function") warnOnFunctionType(returnFiber);
            return null;
        }
        /**
   * Warns if there is a duplicate or missing key
   */ function warnOnInvalidKey(child, knownKeys, returnFiber) {
            if (typeof child !== "object" || child === null) return knownKeys;
            switch(child.$$typeof){
                case REACT_ELEMENT_TYPE:
                case REACT_PORTAL_TYPE:
                    warnForMissingKey(child, returnFiber);
                    var key = child.key;
                    if (typeof key !== "string") break;
                    if (knownKeys === null) {
                        knownKeys = new Set();
                        knownKeys.add(key);
                        break;
                    }
                    if (!knownKeys.has(key)) {
                        knownKeys.add(key);
                        break;
                    }
                    error("Encountered two children with the same key, `%s`. Keys should be unique so that components maintain their identity across updates. Non-unique keys may cause children to be duplicated and/or omitted \u2014 the behavior is unsupported and could change in a future version.", key);
                    break;
                case REACT_LAZY_TYPE:
                    var payload = child._payload;
                    var init = child._init;
                    warnOnInvalidKey(init(payload), knownKeys, returnFiber);
                    break;
            }
            return knownKeys;
        }
        function reconcileChildrenArray(returnFiber, currentFirstChild, newChildren, lanes) {
            // First, validate keys.
            var knownKeys = null;
            for(var i = 0; i < newChildren.length; i++){
                var child = newChildren[i];
                knownKeys = warnOnInvalidKey(child, knownKeys, returnFiber);
            }
            var resultingFirstChild = null;
            var previousNewFiber = null;
            var oldFiber = currentFirstChild;
            var lastPlacedIndex = 0;
            var newIdx = 0;
            var nextOldFiber = null;
            for(; oldFiber !== null && newIdx < newChildren.length; newIdx++){
                if (oldFiber.index > newIdx) {
                    nextOldFiber = oldFiber;
                    oldFiber = null;
                } else nextOldFiber = oldFiber.sibling;
                var newFiber = updateSlot(returnFiber, oldFiber, newChildren[newIdx], lanes);
                if (newFiber === null) {
                    // TODO: This breaks on empty slots like null children. That's
                    // unfortunate because it triggers the slow path all the time. We need
                    // a better way to communicate whether this was a miss or null,
                    // boolean, undefined, etc.
                    if (oldFiber === null) oldFiber = nextOldFiber;
                    break;
                }
                if (shouldTrackSideEffects) {
                    if (oldFiber && newFiber.alternate === null) // We matched the slot, but we didn't reuse the existing fiber, so we
                    // need to delete the existing child.
                    deleteChild(returnFiber, oldFiber);
                }
                lastPlacedIndex = placeChild(newFiber, lastPlacedIndex, newIdx);
                if (previousNewFiber === null) // TODO: Move out of the loop. This only happens for the first run.
                resultingFirstChild = newFiber;
                else // TODO: Defer siblings if we're not at the right index for this slot.
                // I.e. if we had null values before, then we want to defer this
                // for each null value. However, we also don't want to call updateSlot
                // with the previous one.
                previousNewFiber.sibling = newFiber;
                previousNewFiber = newFiber;
                oldFiber = nextOldFiber;
            }
            if (newIdx === newChildren.length) {
                // We've reached the end of the new children. We can delete the rest.
                deleteRemainingChildren(returnFiber, oldFiber);
                if (getIsHydrating()) {
                    var numberOfForks = newIdx;
                    pushTreeFork(returnFiber, numberOfForks);
                }
                return resultingFirstChild;
            }
            if (oldFiber === null) {
                // If we don't have any more existing children we can choose a fast path
                // since the rest will all be insertions.
                for(; newIdx < newChildren.length; newIdx++){
                    var _newFiber = createChild(returnFiber, newChildren[newIdx], lanes);
                    if (_newFiber === null) continue;
                    lastPlacedIndex = placeChild(_newFiber, lastPlacedIndex, newIdx);
                    if (previousNewFiber === null) // TODO: Move out of the loop. This only happens for the first run.
                    resultingFirstChild = _newFiber;
                    else previousNewFiber.sibling = _newFiber;
                    previousNewFiber = _newFiber;
                }
                if (getIsHydrating()) {
                    var _numberOfForks = newIdx;
                    pushTreeFork(returnFiber, _numberOfForks);
                }
                return resultingFirstChild;
            } // Add all children to a key map for quick lookups.
            var existingChildren = mapRemainingChildren(returnFiber, oldFiber); // Keep scanning and use the map to restore deleted items as moves.
            for(; newIdx < newChildren.length; newIdx++){
                var _newFiber2 = updateFromMap(existingChildren, returnFiber, newIdx, newChildren[newIdx], lanes);
                if (_newFiber2 !== null) {
                    if (shouldTrackSideEffects) {
                        if (_newFiber2.alternate !== null) // The new fiber is a work in progress, but if there exists a
                        // current, that means that we reused the fiber. We need to delete
                        // it from the child list so that we don't add it to the deletion
                        // list.
                        existingChildren.delete(_newFiber2.key === null ? newIdx : _newFiber2.key);
                    }
                    lastPlacedIndex = placeChild(_newFiber2, lastPlacedIndex, newIdx);
                    if (previousNewFiber === null) resultingFirstChild = _newFiber2;
                    else previousNewFiber.sibling = _newFiber2;
                    previousNewFiber = _newFiber2;
                }
            }
            if (shouldTrackSideEffects) // Any existing children that weren't consumed above were deleted. We need
            // to add them to the deletion list.
            existingChildren.forEach(function(child) {
                return deleteChild(returnFiber, child);
            });
            if (getIsHydrating()) {
                var _numberOfForks2 = newIdx;
                pushTreeFork(returnFiber, _numberOfForks2);
            }
            return resultingFirstChild;
        }
        function reconcileChildrenIterator(returnFiber, currentFirstChild, newChildrenIterable, lanes) {
            // This is the same implementation as reconcileChildrenArray(),
            // but using the iterator instead.
            var iteratorFn = getIteratorFn(newChildrenIterable);
            if (typeof iteratorFn !== "function") throw new Error("An object is not an iterable. This error is likely caused by a bug in React. Please file an issue.");
            // We don't support rendering Generators because it's a mutation.
            // See https://github.com/facebook/react/issues/12995
            if (typeof Symbol === "function" && // $FlowFixMe Flow doesn't know about toStringTag
            newChildrenIterable[Symbol.toStringTag] === "Generator") {
                if (!didWarnAboutGenerators) error("Using Generators as children is unsupported and will likely yield unexpected results because enumerating a generator mutates it. You may convert it to an array with `Array.from()` or the `[...spread]` operator before rendering. Keep in mind you might need to polyfill these features for older browsers.");
                didWarnAboutGenerators = true;
            } // Warn about using Maps as children
            if (newChildrenIterable.entries === iteratorFn) {
                if (!didWarnAboutMaps) error("Using Maps as children is not supported. Use an array of keyed ReactElements instead.");
                didWarnAboutMaps = true;
            } // First, validate keys.
            // We'll get a different iterator later for the main pass.
            var _newChildren = iteratorFn.call(newChildrenIterable);
            if (_newChildren) {
                var knownKeys = null;
                var _step = _newChildren.next();
                for(; !_step.done; _step = _newChildren.next()){
                    var child = _step.value;
                    knownKeys = warnOnInvalidKey(child, knownKeys, returnFiber);
                }
            }
            var newChildren = iteratorFn.call(newChildrenIterable);
            if (newChildren == null) throw new Error("An iterable object provided no iterator.");
            var resultingFirstChild = null;
            var previousNewFiber = null;
            var oldFiber = currentFirstChild;
            var lastPlacedIndex = 0;
            var newIdx = 0;
            var nextOldFiber = null;
            var step = newChildren.next();
            for(; oldFiber !== null && !step.done; newIdx++, step = newChildren.next()){
                if (oldFiber.index > newIdx) {
                    nextOldFiber = oldFiber;
                    oldFiber = null;
                } else nextOldFiber = oldFiber.sibling;
                var newFiber = updateSlot(returnFiber, oldFiber, step.value, lanes);
                if (newFiber === null) {
                    // TODO: This breaks on empty slots like null children. That's
                    // unfortunate because it triggers the slow path all the time. We need
                    // a better way to communicate whether this was a miss or null,
                    // boolean, undefined, etc.
                    if (oldFiber === null) oldFiber = nextOldFiber;
                    break;
                }
                if (shouldTrackSideEffects) {
                    if (oldFiber && newFiber.alternate === null) // We matched the slot, but we didn't reuse the existing fiber, so we
                    // need to delete the existing child.
                    deleteChild(returnFiber, oldFiber);
                }
                lastPlacedIndex = placeChild(newFiber, lastPlacedIndex, newIdx);
                if (previousNewFiber === null) // TODO: Move out of the loop. This only happens for the first run.
                resultingFirstChild = newFiber;
                else // TODO: Defer siblings if we're not at the right index for this slot.
                // I.e. if we had null values before, then we want to defer this
                // for each null value. However, we also don't want to call updateSlot
                // with the previous one.
                previousNewFiber.sibling = newFiber;
                previousNewFiber = newFiber;
                oldFiber = nextOldFiber;
            }
            if (step.done) {
                // We've reached the end of the new children. We can delete the rest.
                deleteRemainingChildren(returnFiber, oldFiber);
                if (getIsHydrating()) {
                    var numberOfForks = newIdx;
                    pushTreeFork(returnFiber, numberOfForks);
                }
                return resultingFirstChild;
            }
            if (oldFiber === null) {
                // If we don't have any more existing children we can choose a fast path
                // since the rest will all be insertions.
                for(; !step.done; newIdx++, step = newChildren.next()){
                    var _newFiber3 = createChild(returnFiber, step.value, lanes);
                    if (_newFiber3 === null) continue;
                    lastPlacedIndex = placeChild(_newFiber3, lastPlacedIndex, newIdx);
                    if (previousNewFiber === null) // TODO: Move out of the loop. This only happens for the first run.
                    resultingFirstChild = _newFiber3;
                    else previousNewFiber.sibling = _newFiber3;
                    previousNewFiber = _newFiber3;
                }
                if (getIsHydrating()) {
                    var _numberOfForks3 = newIdx;
                    pushTreeFork(returnFiber, _numberOfForks3);
                }
                return resultingFirstChild;
            } // Add all children to a key map for quick lookups.
            var existingChildren = mapRemainingChildren(returnFiber, oldFiber); // Keep scanning and use the map to restore deleted items as moves.
            for(; !step.done; newIdx++, step = newChildren.next()){
                var _newFiber4 = updateFromMap(existingChildren, returnFiber, newIdx, step.value, lanes);
                if (_newFiber4 !== null) {
                    if (shouldTrackSideEffects) {
                        if (_newFiber4.alternate !== null) // The new fiber is a work in progress, but if there exists a
                        // current, that means that we reused the fiber. We need to delete
                        // it from the child list so that we don't add it to the deletion
                        // list.
                        existingChildren.delete(_newFiber4.key === null ? newIdx : _newFiber4.key);
                    }
                    lastPlacedIndex = placeChild(_newFiber4, lastPlacedIndex, newIdx);
                    if (previousNewFiber === null) resultingFirstChild = _newFiber4;
                    else previousNewFiber.sibling = _newFiber4;
                    previousNewFiber = _newFiber4;
                }
            }
            if (shouldTrackSideEffects) // Any existing children that weren't consumed above were deleted. We need
            // to add them to the deletion list.
            existingChildren.forEach(function(child) {
                return deleteChild(returnFiber, child);
            });
            if (getIsHydrating()) {
                var _numberOfForks4 = newIdx;
                pushTreeFork(returnFiber, _numberOfForks4);
            }
            return resultingFirstChild;
        }
        function reconcileSingleTextNode(returnFiber, currentFirstChild, textContent, lanes) {
            // There's no need to check for keys on text nodes since we don't have a
            // way to define them.
            if (currentFirstChild !== null && currentFirstChild.tag === HostText) {
                // We already have an existing node so let's just update it and delete
                // the rest.
                deleteRemainingChildren(returnFiber, currentFirstChild.sibling);
                var existing = useFiber(currentFirstChild, textContent);
                existing.return = returnFiber;
                return existing;
            } // The existing first child is not a text node so we need to create one
            // and delete the existing ones.
            deleteRemainingChildren(returnFiber, currentFirstChild);
            var created = createFiberFromText(textContent, returnFiber.mode, lanes);
            created.return = returnFiber;
            return created;
        }
        function reconcileSingleElement(returnFiber, currentFirstChild, element, lanes) {
            var key = element.key;
            var child = currentFirstChild;
            while(child !== null){
                // TODO: If key === null and child.key === null, then this only applies to
                // the first item in the list.
                if (child.key === key) {
                    var elementType = element.type;
                    if (elementType === REACT_FRAGMENT_TYPE) {
                        if (child.tag === Fragment) {
                            deleteRemainingChildren(returnFiber, child.sibling);
                            var existing = useFiber(child, element.props.children);
                            existing.return = returnFiber;
                            existing._debugSource = element._source;
                            existing._debugOwner = element._owner;
                            return existing;
                        }
                    } else if (child.elementType === elementType || isCompatibleFamilyForHotReloading(child, element) || // Lazy types should reconcile their resolved type.
                    // We need to do this after the Hot Reloading check above,
                    // because hot reloading has different semantics than prod because
                    // it doesn't resuspend. So we can't let the call below suspend.
                    typeof elementType === "object" && elementType !== null && elementType.$$typeof === REACT_LAZY_TYPE && resolveLazy(elementType) === child.type) {
                        deleteRemainingChildren(returnFiber, child.sibling);
                        var _existing = useFiber(child, element.props);
                        _existing.ref = coerceRef(returnFiber, child, element);
                        _existing.return = returnFiber;
                        _existing._debugSource = element._source;
                        _existing._debugOwner = element._owner;
                        return _existing;
                    }
                     // Didn't match.
                    deleteRemainingChildren(returnFiber, child);
                    break;
                } else deleteChild(returnFiber, child);
                child = child.sibling;
            }
            if (element.type === REACT_FRAGMENT_TYPE) {
                var created = createFiberFromFragment(element.props.children, returnFiber.mode, lanes, element.key);
                created.return = returnFiber;
                return created;
            } else {
                var _created4 = createFiberFromElement(element, returnFiber.mode, lanes);
                _created4.ref = coerceRef(returnFiber, currentFirstChild, element);
                _created4.return = returnFiber;
                return _created4;
            }
        }
        function reconcileSinglePortal(returnFiber, currentFirstChild, portal, lanes) {
            var key = portal.key;
            var child = currentFirstChild;
            while(child !== null){
                // TODO: If key === null and child.key === null, then this only applies to
                // the first item in the list.
                if (child.key === key) {
                    if (child.tag === HostPortal && child.stateNode.containerInfo === portal.containerInfo && child.stateNode.implementation === portal.implementation) {
                        deleteRemainingChildren(returnFiber, child.sibling);
                        var existing = useFiber(child, portal.children || []);
                        existing.return = returnFiber;
                        return existing;
                    } else {
                        deleteRemainingChildren(returnFiber, child);
                        break;
                    }
                } else deleteChild(returnFiber, child);
                child = child.sibling;
            }
            var created = createFiberFromPortal(portal, returnFiber.mode, lanes);
            created.return = returnFiber;
            return created;
        } // This API will tag the children with the side-effect of the reconciliation
        // itself. They will be added to the side-effect list as we pass through the
        // children and the parent.
        function reconcileChildFibers(returnFiber, currentFirstChild, newChild, lanes) {
            // This function is not recursive.
            // If the top level item is an array, we treat it as a set of children,
            // not as a fragment. Nested arrays on the other hand will be treated as
            // fragment nodes. Recursion happens at the normal flow.
            // Handle top level unkeyed fragments as if they were arrays.
            // This leads to an ambiguity between <>{[...]}</> and <>...</>.
            // We treat the ambiguous cases above the same.
            var isUnkeyedTopLevelFragment = typeof newChild === "object" && newChild !== null && newChild.type === REACT_FRAGMENT_TYPE && newChild.key === null;
            if (isUnkeyedTopLevelFragment) newChild = newChild.props.children;
             // Handle object types
            if (typeof newChild === "object" && newChild !== null) {
                switch(newChild.$$typeof){
                    case REACT_ELEMENT_TYPE:
                        return placeSingleChild(reconcileSingleElement(returnFiber, currentFirstChild, newChild, lanes));
                    case REACT_PORTAL_TYPE:
                        return placeSingleChild(reconcileSinglePortal(returnFiber, currentFirstChild, newChild, lanes));
                    case REACT_LAZY_TYPE:
                        var payload = newChild._payload;
                        var init = newChild._init; // TODO: This function is supposed to be non-recursive.
                        return reconcileChildFibers(returnFiber, currentFirstChild, init(payload), lanes);
                }
                if (isArray(newChild)) return reconcileChildrenArray(returnFiber, currentFirstChild, newChild, lanes);
                if (getIteratorFn(newChild)) return reconcileChildrenIterator(returnFiber, currentFirstChild, newChild, lanes);
                throwOnInvalidObjectType(returnFiber, newChild);
            }
            if (typeof newChild === "string" && newChild !== "" || typeof newChild === "number") return placeSingleChild(reconcileSingleTextNode(returnFiber, currentFirstChild, "" + newChild, lanes));
            if (typeof newChild === "function") warnOnFunctionType(returnFiber);
            return deleteRemainingChildren(returnFiber, currentFirstChild);
        }
        return reconcileChildFibers;
    }
    var reconcileChildFibers = ChildReconciler(true);
    var mountChildFibers = ChildReconciler(false);
    function cloneChildFibers(current, workInProgress) {
        if (current !== null && workInProgress.child !== current.child) throw new Error("Resuming work not yet implemented.");
        if (workInProgress.child === null) return;
        var currentChild = workInProgress.child;
        var newChild = createWorkInProgress(currentChild, currentChild.pendingProps);
        workInProgress.child = newChild;
        newChild.return = workInProgress;
        while(currentChild.sibling !== null){
            currentChild = currentChild.sibling;
            newChild = newChild.sibling = createWorkInProgress(currentChild, currentChild.pendingProps);
            newChild.return = workInProgress;
        }
        newChild.sibling = null;
    } // Reset a workInProgress child set to prepare it for a second pass.
    function resetChildFibers(workInProgress, lanes) {
        var child = workInProgress.child;
        while(child !== null){
            resetWorkInProgress(child, lanes);
            child = child.sibling;
        }
    }
    var NO_CONTEXT = {};
    var contextStackCursor$1 = createCursor(NO_CONTEXT);
    var contextFiberStackCursor = createCursor(NO_CONTEXT);
    var rootInstanceStackCursor = createCursor(NO_CONTEXT);
    function requiredContext(c) {
        if (c === NO_CONTEXT) throw new Error("Expected host context to exist. This error is likely caused by a bug in React. Please file an issue.");
        return c;
    }
    function getRootHostContainer() {
        var rootInstance = requiredContext(rootInstanceStackCursor.current);
        return rootInstance;
    }
    function pushHostContainer(fiber, nextRootInstance) {
        // Push current root instance onto the stack;
        // This allows us to reset root when portals are popped.
        push(rootInstanceStackCursor, nextRootInstance, fiber); // Track the context and the Fiber that provided it.
        // This enables us to pop only Fibers that provide unique contexts.
        push(contextFiberStackCursor, fiber, fiber); // Finally, we need to push the host context to the stack.
        // However, we can't just call getRootHostContext() and push it because
        // we'd have a different number of entries on the stack depending on
        // whether getRootHostContext() throws somewhere in renderer code or not.
        // So we push an empty value first. This lets us safely unwind on errors.
        push(contextStackCursor$1, NO_CONTEXT, fiber);
        var nextRootContext = getRootHostContext(nextRootInstance); // Now that we know this function doesn't throw, replace it.
        pop(contextStackCursor$1, fiber);
        push(contextStackCursor$1, nextRootContext, fiber);
    }
    function popHostContainer(fiber) {
        pop(contextStackCursor$1, fiber);
        pop(contextFiberStackCursor, fiber);
        pop(rootInstanceStackCursor, fiber);
    }
    function getHostContext() {
        var context = requiredContext(contextStackCursor$1.current);
        return context;
    }
    function pushHostContext(fiber) {
        var rootInstance = requiredContext(rootInstanceStackCursor.current);
        var context = requiredContext(contextStackCursor$1.current);
        var nextContext = getChildHostContext(context, fiber.type); // Don't push this Fiber's context unless it's unique.
        if (context === nextContext) return;
         // Track the context and the Fiber that provided it.
        // This enables us to pop only Fibers that provide unique contexts.
        push(contextFiberStackCursor, fiber, fiber);
        push(contextStackCursor$1, nextContext, fiber);
    }
    function popHostContext(fiber) {
        // Do not pop unless this Fiber provided the current context.
        // pushHostContext() only pushes Fibers that provide unique contexts.
        if (contextFiberStackCursor.current !== fiber) return;
        pop(contextStackCursor$1, fiber);
        pop(contextFiberStackCursor, fiber);
    }
    var DefaultSuspenseContext = 0; // The Suspense Context is split into two parts. The lower bits is
    // inherited deeply down the subtree. The upper bits only affect
    // this immediate suspense boundary and gets reset each new
    // boundary or suspense list.
    var SubtreeSuspenseContextMask = 1; // Subtree Flags:
    // InvisibleParentSuspenseContext indicates that one of our parent Suspense
    // boundaries is not currently showing visible main content.
    // Either because it is already showing a fallback or is not mounted at all.
    // We can use this to determine if it is desirable to trigger a fallback at
    // the parent. If not, then we might need to trigger undesirable boundaries
    // and/or suspend the commit to avoid hiding the parent content.
    var InvisibleParentSuspenseContext = 1; // Shallow Flags:
    // ForceSuspenseFallback can be used by SuspenseList to force newly added
    // items into their fallback state during one of the render passes.
    var ForceSuspenseFallback = 2;
    var suspenseStackCursor = createCursor(DefaultSuspenseContext);
    function hasSuspenseContext(parentContext, flag) {
        return (parentContext & flag) !== 0;
    }
    function setDefaultShallowSuspenseContext(parentContext) {
        return parentContext & SubtreeSuspenseContextMask;
    }
    function setShallowSuspenseContext(parentContext, shallowContext) {
        return parentContext & SubtreeSuspenseContextMask | shallowContext;
    }
    function addSubtreeSuspenseContext(parentContext, subtreeContext) {
        return parentContext | subtreeContext;
    }
    function pushSuspenseContext(fiber, newContext) {
        push(suspenseStackCursor, newContext, fiber);
    }
    function popSuspenseContext(fiber) {
        pop(suspenseStackCursor, fiber);
    }
    function shouldCaptureSuspense(workInProgress, hasInvisibleParent) {
        // If it was the primary children that just suspended, capture and render the
        // fallback. Otherwise, don't capture and bubble to the next boundary.
        var nextState = workInProgress.memoizedState;
        if (nextState !== null) {
            if (nextState.dehydrated !== null) // A dehydrated boundary always captures.
            return true;
            return false;
        }
        var props = workInProgress.memoizedProps; // Regular boundaries always capture.
        return true;
    }
    function findFirstSuspended(row) {
        var node = row;
        while(node !== null){
            if (node.tag === SuspenseComponent) {
                var state = node.memoizedState;
                if (state !== null) {
                    var dehydrated = state.dehydrated;
                    if (dehydrated === null || isSuspenseInstancePending(dehydrated) || isSuspenseInstanceFallback(dehydrated)) return node;
                }
            } else if (node.tag === SuspenseListComponent && // revealOrder undefined can't be trusted because it don't
            // keep track of whether it suspended or not.
            node.memoizedProps.revealOrder !== undefined) {
                var didSuspend = (node.flags & DidCapture) !== NoFlags;
                if (didSuspend) return node;
            } else if (node.child !== null) {
                node.child.return = node;
                node = node.child;
                continue;
            }
            if (node === row) return null;
            while(node.sibling === null){
                if (node.return === null || node.return === row) return null;
                node = node.return;
            }
            node.sibling.return = node.return;
            node = node.sibling;
        }
        return null;
    }
    var NoFlags$1 = /*   */ 0; // Represents whether effect should fire.
    var HasEffect = /* */ 1; // Represents the phase in which the effect (not the clean-up) fires.
    var Insertion = /*  */ 2;
    var Layout = /*    */ 4;
    var Passive$1 = /*   */ 8;
    // and should be reset before starting a new render.
    // This tracks which mutable sources need to be reset after a render.
    var workInProgressSources = [];
    function resetWorkInProgressVersions() {
        for(var i = 0; i < workInProgressSources.length; i++){
            var mutableSource = workInProgressSources[i];
            mutableSource._workInProgressVersionPrimary = null;
        }
        workInProgressSources.length = 0;
    }
    // This ensures that the version used for server rendering matches the one
    // that is eventually read during hydration.
    // If they don't match there's a potential tear and a full deopt render is required.
    function registerMutableSourceForHydration(root, mutableSource) {
        var getVersion = mutableSource._getVersion;
        var version = getVersion(mutableSource._source); // TODO Clear this data once all pending hydration work is finished.
        // Retaining it forever may interfere with GC.
        if (root.mutableSourceEagerHydrationData == null) root.mutableSourceEagerHydrationData = [
            mutableSource,
            version
        ];
        else root.mutableSourceEagerHydrationData.push(mutableSource, version);
    }
    var ReactCurrentDispatcher$1 = ReactSharedInternals.ReactCurrentDispatcher, ReactCurrentBatchConfig$2 = ReactSharedInternals.ReactCurrentBatchConfig;
    var didWarnAboutMismatchedHooksForComponent;
    var didWarnUncachedGetSnapshot;
    didWarnAboutMismatchedHooksForComponent = new Set();
    // These are set right before calling the component.
    var renderLanes = NoLanes; // The work-in-progress fiber. I've named it differently to distinguish it from
    // the work-in-progress hook.
    var currentlyRenderingFiber$1 = null; // Hooks are stored as a linked list on the fiber's memoizedState field. The
    // current hook list is the list that belongs to the current fiber. The
    // work-in-progress hook list is a new list that will be added to the
    // work-in-progress fiber.
    var currentHook = null;
    var workInProgressHook = null; // Whether an update was scheduled at any point during the render phase. This
    // does not get reset if we do another render pass; only when we're completely
    // finished evaluating this component. This is an optimization so we know
    // whether we need to clear render phase updates after a throw.
    var didScheduleRenderPhaseUpdate = false; // Where an update was scheduled only during the current render pass. This
    // gets reset after each attempt.
    // TODO: Maybe there's some way to consolidate this with
    // `didScheduleRenderPhaseUpdate`. Or with `numberOfReRenders`.
    var didScheduleRenderPhaseUpdateDuringThisPass = false; // Counts the number of useId hooks in this component.
    var localIdCounter = 0; // Used for ids that are generated completely client-side (i.e. not during
    // hydration). This counter is global, so client ids are not stable across
    // render attempts.
    var globalClientIdCounter = 0;
    var RE_RENDER_LIMIT = 25; // In DEV, this is the name of the currently executing primitive hook
    var currentHookNameInDev = null; // In DEV, this list ensures that hooks are called in the same order between renders.
    // The list stores the order of hooks used during the initial render (mount).
    // Subsequent renders (updates) reference this list.
    var hookTypesDev = null;
    var hookTypesUpdateIndexDev = -1; // In DEV, this tracks whether currently rendering component needs to ignore
    // the dependencies for Hooks that need them (e.g. useEffect or useMemo).
    // When true, such Hooks will always be "remounted". Only used during hot reload.
    var ignorePreviousDependencies = false;
    function mountHookTypesDev() {
        var hookName = currentHookNameInDev;
        if (hookTypesDev === null) hookTypesDev = [
            hookName
        ];
        else hookTypesDev.push(hookName);
    }
    function updateHookTypesDev() {
        var hookName = currentHookNameInDev;
        if (hookTypesDev !== null) {
            hookTypesUpdateIndexDev++;
            if (hookTypesDev[hookTypesUpdateIndexDev] !== hookName) warnOnHookMismatchInDev(hookName);
        }
    }
    function checkDepsAreArrayDev(deps) {
        if (deps !== undefined && deps !== null && !isArray(deps)) // Verify deps, but only on mount to avoid extra checks.
        // It's unlikely their type would change as usually you define them inline.
        error("%s received a final argument that is not an array (instead, received `%s`). When specified, the final argument must be an array.", currentHookNameInDev, typeof deps);
    }
    function warnOnHookMismatchInDev(currentHookName) {
        var componentName = getComponentNameFromFiber(currentlyRenderingFiber$1);
        if (!didWarnAboutMismatchedHooksForComponent.has(componentName)) {
            didWarnAboutMismatchedHooksForComponent.add(componentName);
            if (hookTypesDev !== null) {
                var table = "";
                var secondColumnStart = 30;
                for(var i = 0; i <= hookTypesUpdateIndexDev; i++){
                    var oldHookName = hookTypesDev[i];
                    var newHookName = i === hookTypesUpdateIndexDev ? currentHookName : oldHookName;
                    var row = i + 1 + ". " + oldHookName; // Extra space so second column lines up
                    // lol @ IE not supporting String#repeat
                    while(row.length < secondColumnStart)row += " ";
                    row += newHookName + "\n";
                    table += row;
                }
                error("React has detected a change in the order of Hooks called by %s. This will lead to bugs and errors if not fixed. For more information, read the Rules of Hooks: https://reactjs.org/link/rules-of-hooks\n\n   Previous render            Next render\n   ------------------------------------------------------\n%s   ^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^\n", componentName, table);
            }
        }
    }
    function throwInvalidHookError() {
        throw new Error("Invalid hook call. Hooks can only be called inside of the body of a function component. This could happen for one of the following reasons:\n1. You might have mismatching versions of React and the renderer (such as React DOM)\n2. You might be breaking the Rules of Hooks\n3. You might have more than one copy of React in the same app\nSee https://reactjs.org/link/invalid-hook-call for tips about how to debug and fix this problem.");
    }
    function areHookInputsEqual(nextDeps, prevDeps) {
        if (ignorePreviousDependencies) // Only true when this component is being hot reloaded.
        return false;
        if (prevDeps === null) {
            error("%s received a final argument during this render, but not during the previous render. Even though the final argument is optional, its type cannot change between renders.", currentHookNameInDev);
            return false;
        }
        // Don't bother comparing lengths in prod because these arrays should be
        // passed inline.
        if (nextDeps.length !== prevDeps.length) error("The final argument passed to %s changed size between renders. The order and size of this array must remain constant.\n\nPrevious: %s\nIncoming: %s", currentHookNameInDev, "[" + prevDeps.join(", ") + "]", "[" + nextDeps.join(", ") + "]");
        for(var i = 0; i < prevDeps.length && i < nextDeps.length; i++){
            if (objectIs(nextDeps[i], prevDeps[i])) continue;
            return false;
        }
        return true;
    }
    function renderWithHooks(current, workInProgress, Component, props, secondArg, nextRenderLanes) {
        renderLanes = nextRenderLanes;
        currentlyRenderingFiber$1 = workInProgress;
        hookTypesDev = current !== null ? current._debugHookTypes : null;
        hookTypesUpdateIndexDev = -1; // Used for hot reloading:
        ignorePreviousDependencies = current !== null && current.type !== workInProgress.type;
        workInProgress.memoizedState = null;
        workInProgress.updateQueue = null;
        workInProgress.lanes = NoLanes; // The following should have already been reset
        if (current !== null && current.memoizedState !== null) ReactCurrentDispatcher$1.current = HooksDispatcherOnUpdateInDEV;
        else if (hookTypesDev !== null) // This dispatcher handles an edge case where a component is updating,
        // but no stateful hooks have been used.
        // We want to match the production code behavior (which will use HooksDispatcherOnMount),
        // but with the extra DEV validation to ensure hooks ordering hasn't changed.
        // This dispatcher does that.
        ReactCurrentDispatcher$1.current = HooksDispatcherOnMountWithHookTypesInDEV;
        else ReactCurrentDispatcher$1.current = HooksDispatcherOnMountInDEV;
        var children = Component(props, secondArg); // Check if there was a render phase update
        if (didScheduleRenderPhaseUpdateDuringThisPass) {
            // Keep rendering in a loop for as long as render phase updates continue to
            // be scheduled. Use a counter to prevent infinite loops.
            var numberOfReRenders = 0;
            do {
                didScheduleRenderPhaseUpdateDuringThisPass = false;
                localIdCounter = 0;
                if (numberOfReRenders >= RE_RENDER_LIMIT) throw new Error("Too many re-renders. React limits the number of renders to prevent an infinite loop.");
                numberOfReRenders += 1;
                // Even when hot reloading, allow dependencies to stabilize
                // after first render to prevent infinite render phase updates.
                ignorePreviousDependencies = false;
                currentHook = null;
                workInProgressHook = null;
                workInProgress.updateQueue = null;
                // Also validate hook order for cascading updates.
                hookTypesUpdateIndexDev = -1;
                ReactCurrentDispatcher$1.current = HooksDispatcherOnRerenderInDEV;
                children = Component(props, secondArg);
            }while (didScheduleRenderPhaseUpdateDuringThisPass);
        } // We can assume the previous dispatcher is always this one, since we set it
        // at the beginning of the render phase and there's no re-entrance.
        ReactCurrentDispatcher$1.current = ContextOnlyDispatcher;
        workInProgress._debugHookTypes = hookTypesDev;
        // hookTypesDev could catch more cases (e.g. context) but only in DEV bundles.
        var didRenderTooFewHooks = currentHook !== null && currentHook.next !== null;
        renderLanes = NoLanes;
        currentlyRenderingFiber$1 = null;
        currentHook = null;
        workInProgressHook = null;
        currentHookNameInDev = null;
        hookTypesDev = null;
        hookTypesUpdateIndexDev = -1; // Confirm that a static flag was not added or removed since the last
        // render. If this fires, it suggests that we incorrectly reset the static
        // flags in some other part of the codebase. This has happened before, for
        // example, in the SuspenseList implementation.
        if (current !== null && (current.flags & StaticMask) !== (workInProgress.flags & StaticMask) && // Disable this warning in legacy mode, because legacy Suspense is weird
        // and creates false positives. To make this work in legacy mode, we'd
        // need to mark fibers that commit in an incomplete state, somehow. For
        // now I'll disable the warning that most of the bugs that would trigger
        // it are either exclusive to concurrent mode or exist in both.
        (current.mode & ConcurrentMode) !== NoMode) error("Internal React error: Expected static flag was missing. Please notify the React team.");
        didScheduleRenderPhaseUpdate = false; // This is reset by checkDidRenderIdHook
        // localIdCounter = 0;
        if (didRenderTooFewHooks) throw new Error("Rendered fewer hooks than expected. This may be caused by an accidental early return statement.");
        return children;
    }
    function checkDidRenderIdHook() {
        // This should be called immediately after every renderWithHooks call.
        // Conceptually, it's part of the return value of renderWithHooks; it's only a
        // separate function to avoid using an array tuple.
        var didRenderIdHook = localIdCounter !== 0;
        localIdCounter = 0;
        return didRenderIdHook;
    }
    function bailoutHooks(current, workInProgress, lanes) {
        workInProgress.updateQueue = current.updateQueue; // TODO: Don't need to reset the flags here, because they're reset in the
        // complete phase (bubbleProperties).
        if ((workInProgress.mode & StrictEffectsMode) !== NoMode) workInProgress.flags &= ~(MountPassiveDev | MountLayoutDev | Passive | Update);
        else workInProgress.flags &= ~(Passive | Update);
        current.lanes = removeLanes(current.lanes, lanes);
    }
    function resetHooksAfterThrow() {
        // We can assume the previous dispatcher is always this one, since we set it
        // at the beginning of the render phase and there's no re-entrance.
        ReactCurrentDispatcher$1.current = ContextOnlyDispatcher;
        if (didScheduleRenderPhaseUpdate) {
            // There were render phase updates. These are only valid for this render
            // phase, which we are now aborting. Remove the updates from the queues so
            // they do not persist to the next render. Do not remove updates from hooks
            // that weren't processed.
            //
            // Only reset the updates from the queue if it has a clone. If it does
            // not have a clone, that means it wasn't processed, and the updates were
            // scheduled before we entered the render phase.
            var hook = currentlyRenderingFiber$1.memoizedState;
            while(hook !== null){
                var queue = hook.queue;
                if (queue !== null) queue.pending = null;
                hook = hook.next;
            }
            didScheduleRenderPhaseUpdate = false;
        }
        renderLanes = NoLanes;
        currentlyRenderingFiber$1 = null;
        currentHook = null;
        workInProgressHook = null;
        hookTypesDev = null;
        hookTypesUpdateIndexDev = -1;
        currentHookNameInDev = null;
        isUpdatingOpaqueValueInRenderPhase = false;
        didScheduleRenderPhaseUpdateDuringThisPass = false;
        localIdCounter = 0;
    }
    function mountWorkInProgressHook() {
        var hook = {
            memoizedState: null,
            baseState: null,
            baseQueue: null,
            queue: null,
            next: null
        };
        if (workInProgressHook === null) // This is the first hook in the list
        currentlyRenderingFiber$1.memoizedState = workInProgressHook = hook;
        else // Append to the end of the list
        workInProgressHook = workInProgressHook.next = hook;
        return workInProgressHook;
    }
    function updateWorkInProgressHook() {
        // This function is used both for updates and for re-renders triggered by a
        // render phase update. It assumes there is either a current hook we can
        // clone, or a work-in-progress hook from a previous render pass that we can
        // use as a base. When we reach the end of the base list, we must switch to
        // the dispatcher used for mounts.
        var nextCurrentHook;
        if (currentHook === null) {
            var current = currentlyRenderingFiber$1.alternate;
            if (current !== null) nextCurrentHook = current.memoizedState;
            else nextCurrentHook = null;
        } else nextCurrentHook = currentHook.next;
        var nextWorkInProgressHook;
        if (workInProgressHook === null) nextWorkInProgressHook = currentlyRenderingFiber$1.memoizedState;
        else nextWorkInProgressHook = workInProgressHook.next;
        if (nextWorkInProgressHook !== null) {
            // There's already a work-in-progress. Reuse it.
            workInProgressHook = nextWorkInProgressHook;
            nextWorkInProgressHook = workInProgressHook.next;
            currentHook = nextCurrentHook;
        } else {
            // Clone from the current hook.
            if (nextCurrentHook === null) throw new Error("Rendered more hooks than during the previous render.");
            currentHook = nextCurrentHook;
            var newHook = {
                memoizedState: currentHook.memoizedState,
                baseState: currentHook.baseState,
                baseQueue: currentHook.baseQueue,
                queue: currentHook.queue,
                next: null
            };
            if (workInProgressHook === null) // This is the first hook in the list.
            currentlyRenderingFiber$1.memoizedState = workInProgressHook = newHook;
            else // Append to the end of the list.
            workInProgressHook = workInProgressHook.next = newHook;
        }
        return workInProgressHook;
    }
    function createFunctionComponentUpdateQueue() {
        return {
            lastEffect: null,
            stores: null
        };
    }
    function basicStateReducer(state, action) {
        // $FlowFixMe: Flow doesn't like mixed types
        return typeof action === "function" ? action(state) : action;
    }
    function mountReducer(reducer, initialArg, init) {
        var hook = mountWorkInProgressHook();
        var initialState;
        if (init !== undefined) initialState = init(initialArg);
        else initialState = initialArg;
        hook.memoizedState = hook.baseState = initialState;
        var queue = {
            pending: null,
            interleaved: null,
            lanes: NoLanes,
            dispatch: null,
            lastRenderedReducer: reducer,
            lastRenderedState: initialState
        };
        hook.queue = queue;
        var dispatch = queue.dispatch = dispatchReducerAction.bind(null, currentlyRenderingFiber$1, queue);
        return [
            hook.memoizedState,
            dispatch
        ];
    }
    function updateReducer(reducer, initialArg, init) {
        var hook = updateWorkInProgressHook();
        var queue = hook.queue;
        if (queue === null) throw new Error("Should have a queue. This is likely a bug in React. Please file an issue.");
        queue.lastRenderedReducer = reducer;
        var current = currentHook; // The last rebase update that is NOT part of the base state.
        var baseQueue = current.baseQueue; // The last pending update that hasn't been processed yet.
        var pendingQueue = queue.pending;
        if (pendingQueue !== null) {
            // We have new updates that haven't been processed yet.
            // We'll add them to the base queue.
            if (baseQueue !== null) {
                // Merge the pending queue and the base queue.
                var baseFirst = baseQueue.next;
                var pendingFirst = pendingQueue.next;
                baseQueue.next = pendingFirst;
                pendingQueue.next = baseFirst;
            }
            if (current.baseQueue !== baseQueue) // Internal invariant that should never happen, but feasibly could in
            // the future if we implement resuming, or some form of that.
            error("Internal error: Expected work-in-progress queue to be a clone. This is a bug in React.");
            current.baseQueue = baseQueue = pendingQueue;
            queue.pending = null;
        }
        if (baseQueue !== null) {
            // We have a queue to process.
            var first = baseQueue.next;
            var newState = current.baseState;
            var newBaseState = null;
            var newBaseQueueFirst = null;
            var newBaseQueueLast = null;
            var update = first;
            do {
                var updateLane = update.lane;
                if (!isSubsetOfLanes(renderLanes, updateLane)) {
                    // Priority is insufficient. Skip this update. If this is the first
                    // skipped update, the previous update/state is the new base
                    // update/state.
                    var clone = {
                        lane: updateLane,
                        action: update.action,
                        hasEagerState: update.hasEagerState,
                        eagerState: update.eagerState,
                        next: null
                    };
                    if (newBaseQueueLast === null) {
                        newBaseQueueFirst = newBaseQueueLast = clone;
                        newBaseState = newState;
                    } else newBaseQueueLast = newBaseQueueLast.next = clone;
                     // Update the remaining priority in the queue.
                    // TODO: Don't need to accumulate this. Instead, we can remove
                    // renderLanes from the original lanes.
                    currentlyRenderingFiber$1.lanes = mergeLanes(currentlyRenderingFiber$1.lanes, updateLane);
                    markSkippedUpdateLanes(updateLane);
                } else {
                    // This update does have sufficient priority.
                    if (newBaseQueueLast !== null) {
                        var _clone = {
                            // This update is going to be committed so we never want uncommit
                            // it. Using NoLane works because 0 is a subset of all bitmasks, so
                            // this will never be skipped by the check above.
                            lane: NoLane,
                            action: update.action,
                            hasEagerState: update.hasEagerState,
                            eagerState: update.eagerState,
                            next: null
                        };
                        newBaseQueueLast = newBaseQueueLast.next = _clone;
                    } // Process this update.
                    if (update.hasEagerState) // If this update is a state update (not a reducer) and was processed eagerly,
                    // we can use the eagerly computed state
                    newState = update.eagerState;
                    else {
                        var action = update.action;
                        newState = reducer(newState, action);
                    }
                }
                update = update.next;
            }while (update !== null && update !== first);
            if (newBaseQueueLast === null) newBaseState = newState;
            else newBaseQueueLast.next = newBaseQueueFirst;
             // Mark that the fiber performed work, but only if the new state is
            // different from the current state.
            if (!objectIs(newState, hook.memoizedState)) markWorkInProgressReceivedUpdate();
            hook.memoizedState = newState;
            hook.baseState = newBaseState;
            hook.baseQueue = newBaseQueueLast;
            queue.lastRenderedState = newState;
        } // Interleaved updates are stored on a separate queue. We aren't going to
        // process them during this render, but we do need to track which lanes
        // are remaining.
        var lastInterleaved = queue.interleaved;
        if (lastInterleaved !== null) {
            var interleaved = lastInterleaved;
            do {
                var interleavedLane = interleaved.lane;
                currentlyRenderingFiber$1.lanes = mergeLanes(currentlyRenderingFiber$1.lanes, interleavedLane);
                markSkippedUpdateLanes(interleavedLane);
                interleaved = interleaved.next;
            }while (interleaved !== lastInterleaved);
        } else if (baseQueue === null) // `queue.lanes` is used for entangling transitions. We can set it back to
        // zero once the queue is empty.
        queue.lanes = NoLanes;
        var dispatch = queue.dispatch;
        return [
            hook.memoizedState,
            dispatch
        ];
    }
    function rerenderReducer(reducer, initialArg, init) {
        var hook = updateWorkInProgressHook();
        var queue = hook.queue;
        if (queue === null) throw new Error("Should have a queue. This is likely a bug in React. Please file an issue.");
        queue.lastRenderedReducer = reducer; // This is a re-render. Apply the new render phase updates to the previous
        // work-in-progress hook.
        var dispatch = queue.dispatch;
        var lastRenderPhaseUpdate = queue.pending;
        var newState = hook.memoizedState;
        if (lastRenderPhaseUpdate !== null) {
            // The queue doesn't persist past this render pass.
            queue.pending = null;
            var firstRenderPhaseUpdate = lastRenderPhaseUpdate.next;
            var update = firstRenderPhaseUpdate;
            do {
                // Process this render phase update. We don't have to check the
                // priority because it will always be the same as the current
                // render's.
                var action = update.action;
                newState = reducer(newState, action);
                update = update.next;
            }while (update !== firstRenderPhaseUpdate); // Mark that the fiber performed work, but only if the new state is
            // different from the current state.
            if (!objectIs(newState, hook.memoizedState)) markWorkInProgressReceivedUpdate();
            hook.memoizedState = newState; // Don't persist the state accumulated from the render phase updates to
            // the base state unless the queue is empty.
            // TODO: Not sure if this is the desired semantics, but it's what we
            // do for gDSFP. I can't remember why.
            if (hook.baseQueue === null) hook.baseState = newState;
            queue.lastRenderedState = newState;
        }
        return [
            newState,
            dispatch
        ];
    }
    function mountMutableSource(source, getSnapshot, subscribe) {
        return undefined;
    }
    function updateMutableSource(source, getSnapshot, subscribe) {
        return undefined;
    }
    function mountSyncExternalStore(subscribe, getSnapshot, getServerSnapshot) {
        var fiber = currentlyRenderingFiber$1;
        var hook = mountWorkInProgressHook();
        var nextSnapshot;
        var isHydrating = getIsHydrating();
        if (isHydrating) {
            if (getServerSnapshot === undefined) throw new Error("Missing getServerSnapshot, which is required for server-rendered content. Will revert to client rendering.");
            nextSnapshot = getServerSnapshot();
            if (!didWarnUncachedGetSnapshot) {
                if (nextSnapshot !== getServerSnapshot()) {
                    error("The result of getServerSnapshot should be cached to avoid an infinite loop");
                    didWarnUncachedGetSnapshot = true;
                }
            }
        } else {
            nextSnapshot = getSnapshot();
            if (!didWarnUncachedGetSnapshot) {
                var cachedSnapshot = getSnapshot();
                if (!objectIs(nextSnapshot, cachedSnapshot)) {
                    error("The result of getSnapshot should be cached to avoid an infinite loop");
                    didWarnUncachedGetSnapshot = true;
                }
            }
            // Right before committing, we will walk the tree and check if any of the
            // stores were mutated.
            //
            // We won't do this if we're hydrating server-rendered content, because if
            // the content is stale, it's already visible anyway. Instead we'll patch
            // it up in a passive effect.
            var root = getWorkInProgressRoot();
            if (root === null) throw new Error("Expected a work-in-progress root. This is a bug in React. Please file an issue.");
            if (!includesBlockingLane(root, renderLanes)) pushStoreConsistencyCheck(fiber, getSnapshot, nextSnapshot);
        } // Read the current snapshot from the store on every render. This breaks the
        // normal rules of React, and only works because store updates are
        // always synchronous.
        hook.memoizedState = nextSnapshot;
        var inst = {
            value: nextSnapshot,
            getSnapshot: getSnapshot
        };
        hook.queue = inst; // Schedule an effect to subscribe to the store.
        mountEffect(subscribeToStore.bind(null, fiber, inst, subscribe), [
            subscribe
        ]); // Schedule an effect to update the mutable instance fields. We will update
        // this whenever subscribe, getSnapshot, or value changes. Because there's no
        // clean-up function, and we track the deps correctly, we can call pushEffect
        // directly, without storing any additional state. For the same reason, we
        // don't need to set a static flag, either.
        // TODO: We can move this to the passive phase once we add a pre-commit
        // consistency check. See the next comment.
        fiber.flags |= Passive;
        pushEffect(HasEffect | Passive$1, updateStoreInstance.bind(null, fiber, inst, nextSnapshot, getSnapshot), undefined, null);
        return nextSnapshot;
    }
    function updateSyncExternalStore(subscribe, getSnapshot, getServerSnapshot) {
        var fiber = currentlyRenderingFiber$1;
        var hook = updateWorkInProgressHook(); // Read the current snapshot from the store on every render. This breaks the
        // normal rules of React, and only works because store updates are
        // always synchronous.
        var nextSnapshot = getSnapshot();
        if (!didWarnUncachedGetSnapshot) {
            var cachedSnapshot = getSnapshot();
            if (!objectIs(nextSnapshot, cachedSnapshot)) {
                error("The result of getSnapshot should be cached to avoid an infinite loop");
                didWarnUncachedGetSnapshot = true;
            }
        }
        var prevSnapshot = hook.memoizedState;
        var snapshotChanged = !objectIs(prevSnapshot, nextSnapshot);
        if (snapshotChanged) {
            hook.memoizedState = nextSnapshot;
            markWorkInProgressReceivedUpdate();
        }
        var inst = hook.queue;
        updateEffect(subscribeToStore.bind(null, fiber, inst, subscribe), [
            subscribe
        ]); // Whenever getSnapshot or subscribe changes, we need to check in the
        // commit phase if there was an interleaved mutation. In concurrent mode
        // this can happen all the time, but even in synchronous mode, an earlier
        // effect may have mutated the store.
        if (inst.getSnapshot !== getSnapshot || snapshotChanged || // Check if the susbcribe function changed. We can save some memory by
        // checking whether we scheduled a subscription effect above.
        workInProgressHook !== null && workInProgressHook.memoizedState.tag & HasEffect) {
            fiber.flags |= Passive;
            pushEffect(HasEffect | Passive$1, updateStoreInstance.bind(null, fiber, inst, nextSnapshot, getSnapshot), undefined, null); // Unless we're rendering a blocking lane, schedule a consistency check.
            // Right before committing, we will walk the tree and check if any of the
            // stores were mutated.
            var root = getWorkInProgressRoot();
            if (root === null) throw new Error("Expected a work-in-progress root. This is a bug in React. Please file an issue.");
            if (!includesBlockingLane(root, renderLanes)) pushStoreConsistencyCheck(fiber, getSnapshot, nextSnapshot);
        }
        return nextSnapshot;
    }
    function pushStoreConsistencyCheck(fiber, getSnapshot, renderedSnapshot) {
        fiber.flags |= StoreConsistency;
        var check = {
            getSnapshot: getSnapshot,
            value: renderedSnapshot
        };
        var componentUpdateQueue = currentlyRenderingFiber$1.updateQueue;
        if (componentUpdateQueue === null) {
            componentUpdateQueue = createFunctionComponentUpdateQueue();
            currentlyRenderingFiber$1.updateQueue = componentUpdateQueue;
            componentUpdateQueue.stores = [
                check
            ];
        } else {
            var stores = componentUpdateQueue.stores;
            if (stores === null) componentUpdateQueue.stores = [
                check
            ];
            else stores.push(check);
        }
    }
    function updateStoreInstance(fiber, inst, nextSnapshot, getSnapshot) {
        // These are updated in the passive phase
        inst.value = nextSnapshot;
        inst.getSnapshot = getSnapshot; // Something may have been mutated in between render and commit. This could
        // have been in an event that fired before the passive effects, or it could
        // have been in a layout effect. In that case, we would have used the old
        // snapsho and getSnapshot values to bail out. We need to check one more time.
        if (checkIfSnapshotChanged(inst)) // Force a re-render.
        forceStoreRerender(fiber);
    }
    function subscribeToStore(fiber, inst, subscribe) {
        var handleStoreChange = function() {
            // The store changed. Check if the snapshot changed since the last time we
            // read from the store.
            if (checkIfSnapshotChanged(inst)) // Force a re-render.
            forceStoreRerender(fiber);
        }; // Subscribe to the store and return a clean-up function.
        return subscribe(handleStoreChange);
    }
    function checkIfSnapshotChanged(inst) {
        var latestGetSnapshot = inst.getSnapshot;
        var prevValue = inst.value;
        try {
            var nextValue = latestGetSnapshot();
            return !objectIs(prevValue, nextValue);
        } catch (error) {
            return true;
        }
    }
    function forceStoreRerender(fiber) {
        var root = enqueueConcurrentRenderForLane(fiber, SyncLane);
        if (root !== null) scheduleUpdateOnFiber(root, fiber, SyncLane, NoTimestamp);
    }
    function mountState(initialState) {
        var hook = mountWorkInProgressHook();
        if (typeof initialState === "function") // $FlowFixMe: Flow doesn't like mixed types
        initialState = initialState();
        hook.memoizedState = hook.baseState = initialState;
        var queue = {
            pending: null,
            interleaved: null,
            lanes: NoLanes,
            dispatch: null,
            lastRenderedReducer: basicStateReducer,
            lastRenderedState: initialState
        };
        hook.queue = queue;
        var dispatch = queue.dispatch = dispatchSetState.bind(null, currentlyRenderingFiber$1, queue);
        return [
            hook.memoizedState,
            dispatch
        ];
    }
    function updateState(initialState) {
        return updateReducer(basicStateReducer);
    }
    function rerenderState(initialState) {
        return rerenderReducer(basicStateReducer);
    }
    function pushEffect(tag, create, destroy, deps) {
        var effect = {
            tag: tag,
            create: create,
            destroy: destroy,
            deps: deps,
            // Circular
            next: null
        };
        var componentUpdateQueue = currentlyRenderingFiber$1.updateQueue;
        if (componentUpdateQueue === null) {
            componentUpdateQueue = createFunctionComponentUpdateQueue();
            currentlyRenderingFiber$1.updateQueue = componentUpdateQueue;
            componentUpdateQueue.lastEffect = effect.next = effect;
        } else {
            var lastEffect = componentUpdateQueue.lastEffect;
            if (lastEffect === null) componentUpdateQueue.lastEffect = effect.next = effect;
            else {
                var firstEffect = lastEffect.next;
                lastEffect.next = effect;
                effect.next = firstEffect;
                componentUpdateQueue.lastEffect = effect;
            }
        }
        return effect;
    }
    function mountRef(initialValue) {
        var hook = mountWorkInProgressHook();
        var _ref2 = {
            current: initialValue
        };
        hook.memoizedState = _ref2;
        return _ref2;
    }
    function updateRef(initialValue) {
        var hook = updateWorkInProgressHook();
        return hook.memoizedState;
    }
    function mountEffectImpl(fiberFlags, hookFlags, create, deps) {
        var hook = mountWorkInProgressHook();
        var nextDeps = deps === undefined ? null : deps;
        currentlyRenderingFiber$1.flags |= fiberFlags;
        hook.memoizedState = pushEffect(HasEffect | hookFlags, create, undefined, nextDeps);
    }
    function updateEffectImpl(fiberFlags, hookFlags, create, deps) {
        var hook = updateWorkInProgressHook();
        var nextDeps = deps === undefined ? null : deps;
        var destroy = undefined;
        if (currentHook !== null) {
            var prevEffect = currentHook.memoizedState;
            destroy = prevEffect.destroy;
            if (nextDeps !== null) {
                var prevDeps = prevEffect.deps;
                if (areHookInputsEqual(nextDeps, prevDeps)) {
                    hook.memoizedState = pushEffect(hookFlags, create, destroy, nextDeps);
                    return;
                }
            }
        }
        currentlyRenderingFiber$1.flags |= fiberFlags;
        hook.memoizedState = pushEffect(HasEffect | hookFlags, create, destroy, nextDeps);
    }
    function mountEffect(create, deps) {
        if ((currentlyRenderingFiber$1.mode & StrictEffectsMode) !== NoMode) return mountEffectImpl(MountPassiveDev | Passive | PassiveStatic, Passive$1, create, deps);
        else return mountEffectImpl(Passive | PassiveStatic, Passive$1, create, deps);
    }
    function updateEffect(create, deps) {
        return updateEffectImpl(Passive, Passive$1, create, deps);
    }
    function mountInsertionEffect(create, deps) {
        return mountEffectImpl(Update, Insertion, create, deps);
    }
    function updateInsertionEffect(create, deps) {
        return updateEffectImpl(Update, Insertion, create, deps);
    }
    function mountLayoutEffect(create, deps) {
        var fiberFlags = Update;
        fiberFlags |= LayoutStatic;
        if ((currentlyRenderingFiber$1.mode & StrictEffectsMode) !== NoMode) fiberFlags |= MountLayoutDev;
        return mountEffectImpl(fiberFlags, Layout, create, deps);
    }
    function updateLayoutEffect(create, deps) {
        return updateEffectImpl(Update, Layout, create, deps);
    }
    function imperativeHandleEffect(create, ref) {
        if (typeof ref === "function") {
            var refCallback = ref;
            var _inst = create();
            refCallback(_inst);
            return function() {
                refCallback(null);
            };
        } else if (ref !== null && ref !== undefined) {
            var refObject = ref;
            if (!refObject.hasOwnProperty("current")) error("Expected useImperativeHandle() first argument to either be a ref callback or React.createRef() object. Instead received: %s.", "an object with keys {" + Object.keys(refObject).join(", ") + "}");
            var _inst2 = create();
            refObject.current = _inst2;
            return function() {
                refObject.current = null;
            };
        }
    }
    function mountImperativeHandle(ref, create, deps) {
        if (typeof create !== "function") error("Expected useImperativeHandle() second argument to be a function that creates a handle. Instead received: %s.", create !== null ? typeof create : "null");
        var effectDeps = deps !== null && deps !== undefined ? deps.concat([
            ref
        ]) : null;
        var fiberFlags = Update;
        fiberFlags |= LayoutStatic;
        if ((currentlyRenderingFiber$1.mode & StrictEffectsMode) !== NoMode) fiberFlags |= MountLayoutDev;
        return mountEffectImpl(fiberFlags, Layout, imperativeHandleEffect.bind(null, create, ref), effectDeps);
    }
    function updateImperativeHandle(ref, create, deps) {
        if (typeof create !== "function") error("Expected useImperativeHandle() second argument to be a function that creates a handle. Instead received: %s.", create !== null ? typeof create : "null");
        var effectDeps = deps !== null && deps !== undefined ? deps.concat([
            ref
        ]) : null;
        return updateEffectImpl(Update, Layout, imperativeHandleEffect.bind(null, create, ref), effectDeps);
    }
    function mountDebugValue(value, formatterFn) {
    // The react-debug-hooks package injects its own implementation
    // so that e.g. DevTools can display custom hook values.
    }
    var updateDebugValue = mountDebugValue;
    function mountCallback(callback, deps) {
        var hook = mountWorkInProgressHook();
        var nextDeps = deps === undefined ? null : deps;
        hook.memoizedState = [
            callback,
            nextDeps
        ];
        return callback;
    }
    function updateCallback(callback, deps) {
        var hook = updateWorkInProgressHook();
        var nextDeps = deps === undefined ? null : deps;
        var prevState = hook.memoizedState;
        if (prevState !== null) {
            if (nextDeps !== null) {
                var prevDeps = prevState[1];
                if (areHookInputsEqual(nextDeps, prevDeps)) return prevState[0];
            }
        }
        hook.memoizedState = [
            callback,
            nextDeps
        ];
        return callback;
    }
    function mountMemo(nextCreate, deps) {
        var hook = mountWorkInProgressHook();
        var nextDeps = deps === undefined ? null : deps;
        var nextValue = nextCreate();
        hook.memoizedState = [
            nextValue,
            nextDeps
        ];
        return nextValue;
    }
    function updateMemo(nextCreate, deps) {
        var hook = updateWorkInProgressHook();
        var nextDeps = deps === undefined ? null : deps;
        var prevState = hook.memoizedState;
        if (prevState !== null) // Assume these are defined. If they're not, areHookInputsEqual will warn.
        {
            if (nextDeps !== null) {
                var prevDeps = prevState[1];
                if (areHookInputsEqual(nextDeps, prevDeps)) return prevState[0];
            }
        }
        var nextValue = nextCreate();
        hook.memoizedState = [
            nextValue,
            nextDeps
        ];
        return nextValue;
    }
    function mountDeferredValue(value) {
        var hook = mountWorkInProgressHook();
        hook.memoizedState = value;
        return value;
    }
    function updateDeferredValue(value) {
        var hook = updateWorkInProgressHook();
        var resolvedCurrentHook = currentHook;
        var prevValue = resolvedCurrentHook.memoizedState;
        return updateDeferredValueImpl(hook, prevValue, value);
    }
    function rerenderDeferredValue(value) {
        var hook = updateWorkInProgressHook();
        if (currentHook === null) {
            // This is a rerender during a mount.
            hook.memoizedState = value;
            return value;
        } else {
            // This is a rerender during an update.
            var prevValue = currentHook.memoizedState;
            return updateDeferredValueImpl(hook, prevValue, value);
        }
    }
    function updateDeferredValueImpl(hook, prevValue, value) {
        var shouldDeferValue = !includesOnlyNonUrgentLanes(renderLanes);
        if (shouldDeferValue) {
            // This is an urgent update. If the value has changed, keep using the
            // previous value and spawn a deferred render to update it later.
            if (!objectIs(value, prevValue)) {
                // Schedule a deferred render
                var deferredLane = claimNextTransitionLane();
                currentlyRenderingFiber$1.lanes = mergeLanes(currentlyRenderingFiber$1.lanes, deferredLane);
                markSkippedUpdateLanes(deferredLane); // Set this to true to indicate that the rendered value is inconsistent
                // from the latest value. The name "baseState" doesn't really match how we
                // use it because we're reusing a state hook field instead of creating a
                // new one.
                hook.baseState = true;
            } // Reuse the previous value
            return prevValue;
        } else {
            // This is not an urgent update, so we can use the latest value regardless
            // of what it is. No need to defer it.
            // However, if we're currently inside a spawned render, then we need to mark
            // this as an update to prevent the fiber from bailing out.
            //
            // `baseState` is true when the current value is different from the rendered
            // value. The name doesn't really match how we use it because we're reusing
            // a state hook field instead of creating a new one.
            if (hook.baseState) {
                // Flip this back to false.
                hook.baseState = false;
                markWorkInProgressReceivedUpdate();
            }
            hook.memoizedState = value;
            return value;
        }
    }
    function startTransition(setPending, callback, options) {
        var previousPriority = getCurrentUpdatePriority();
        setCurrentUpdatePriority(higherEventPriority(previousPriority, ContinuousEventPriority));
        setPending(true);
        var prevTransition = ReactCurrentBatchConfig$2.transition;
        ReactCurrentBatchConfig$2.transition = {};
        var currentTransition = ReactCurrentBatchConfig$2.transition;
        ReactCurrentBatchConfig$2.transition._updatedFibers = new Set();
        try {
            setPending(false);
            callback();
        } finally{
            setCurrentUpdatePriority(previousPriority);
            ReactCurrentBatchConfig$2.transition = prevTransition;
            if (prevTransition === null && currentTransition._updatedFibers) {
                var updatedFibersCount = currentTransition._updatedFibers.size;
                if (updatedFibersCount > 10) warn("Detected a large number of updates inside startTransition. If this is due to a subscription please re-write it to use React provided hooks. Otherwise concurrent mode guarantees are off the table.");
                currentTransition._updatedFibers.clear();
            }
        }
    }
    function mountTransition() {
        var _mountState = mountState(false), isPending = _mountState[0], setPending = _mountState[1]; // The `start` method never changes.
        var start = startTransition.bind(null, setPending);
        var hook = mountWorkInProgressHook();
        hook.memoizedState = start;
        return [
            isPending,
            start
        ];
    }
    function updateTransition() {
        var _updateState = updateState(), isPending = _updateState[0];
        var hook = updateWorkInProgressHook();
        var start = hook.memoizedState;
        return [
            isPending,
            start
        ];
    }
    function rerenderTransition() {
        var _rerenderState = rerenderState(), isPending = _rerenderState[0];
        var hook = updateWorkInProgressHook();
        var start = hook.memoizedState;
        return [
            isPending,
            start
        ];
    }
    var isUpdatingOpaqueValueInRenderPhase = false;
    function getIsUpdatingOpaqueValueInRenderPhaseInDEV() {
        return isUpdatingOpaqueValueInRenderPhase;
    }
    function mountId() {
        var hook = mountWorkInProgressHook();
        var root = getWorkInProgressRoot(); // TODO: In Fizz, id generation is specific to each server config. Maybe we
        // should do this in Fiber, too? Deferring this decision for now because
        // there's no other place to store the prefix except for an internal field on
        // the public createRoot object, which the fiber tree does not currently have
        // a reference to.
        var identifierPrefix = root.identifierPrefix;
        var id;
        if (getIsHydrating()) {
            var treeId = getTreeId(); // Use a captial R prefix for server-generated ids.
            id = ":" + identifierPrefix + "R" + treeId; // Unless this is the first id at this level, append a number at the end
            // that represents the position of this useId hook among all the useId
            // hooks for this fiber.
            var localId = localIdCounter++;
            if (localId > 0) id += "H" + localId.toString(32);
            id += ":";
        } else {
            // Use a lowercase r prefix for client-generated ids.
            var globalClientId = globalClientIdCounter++;
            id = ":" + identifierPrefix + "r" + globalClientId.toString(32) + ":";
        }
        hook.memoizedState = id;
        return id;
    }
    function updateId() {
        var hook = updateWorkInProgressHook();
        var id = hook.memoizedState;
        return id;
    }
    function dispatchReducerAction(fiber, queue, action) {
        if (typeof arguments[3] === "function") error("State updates from the useState() and useReducer() Hooks don't support the second callback argument. To execute a side effect after rendering, declare it in the component body with useEffect().");
        var lane = requestUpdateLane(fiber);
        var update = {
            lane: lane,
            action: action,
            hasEagerState: false,
            eagerState: null,
            next: null
        };
        if (isRenderPhaseUpdate(fiber)) enqueueRenderPhaseUpdate(queue, update);
        else {
            var root = enqueueConcurrentHookUpdate(fiber, queue, update, lane);
            if (root !== null) {
                var eventTime = requestEventTime();
                scheduleUpdateOnFiber(root, fiber, lane, eventTime);
                entangleTransitionUpdate(root, queue, lane);
            }
        }
        markUpdateInDevTools(fiber, lane);
    }
    function dispatchSetState(fiber, queue, action) {
        if (typeof arguments[3] === "function") error("State updates from the useState() and useReducer() Hooks don't support the second callback argument. To execute a side effect after rendering, declare it in the component body with useEffect().");
        var lane = requestUpdateLane(fiber);
        var update = {
            lane: lane,
            action: action,
            hasEagerState: false,
            eagerState: null,
            next: null
        };
        if (isRenderPhaseUpdate(fiber)) enqueueRenderPhaseUpdate(queue, update);
        else {
            var alternate = fiber.alternate;
            if (fiber.lanes === NoLanes && (alternate === null || alternate.lanes === NoLanes)) {
                // The queue is currently empty, which means we can eagerly compute the
                // next state before entering the render phase. If the new state is the
                // same as the current state, we may be able to bail out entirely.
                var lastRenderedReducer = queue.lastRenderedReducer;
                if (lastRenderedReducer !== null) {
                    var prevDispatcher;
                    prevDispatcher = ReactCurrentDispatcher$1.current;
                    ReactCurrentDispatcher$1.current = InvalidNestedHooksDispatcherOnUpdateInDEV;
                    try {
                        var currentState = queue.lastRenderedState;
                        var eagerState = lastRenderedReducer(currentState, action); // Stash the eagerly computed state, and the reducer used to compute
                        // it, on the update object. If the reducer hasn't changed by the
                        // time we enter the render phase, then the eager state can be used
                        // without calling the reducer again.
                        update.hasEagerState = true;
                        update.eagerState = eagerState;
                        if (objectIs(eagerState, currentState)) {
                            // Fast path. We can bail out without scheduling React to re-render.
                            // It's still possible that we'll need to rebase this update later,
                            // if the component re-renders for a different reason and by that
                            // time the reducer has changed.
                            // TODO: Do we still need to entangle transitions in this case?
                            enqueueConcurrentHookUpdateAndEagerlyBailout(fiber, queue, update, lane);
                            return;
                        }
                    } catch (error) {} finally{
                        ReactCurrentDispatcher$1.current = prevDispatcher;
                    }
                }
            }
            var root = enqueueConcurrentHookUpdate(fiber, queue, update, lane);
            if (root !== null) {
                var eventTime = requestEventTime();
                scheduleUpdateOnFiber(root, fiber, lane, eventTime);
                entangleTransitionUpdate(root, queue, lane);
            }
        }
        markUpdateInDevTools(fiber, lane);
    }
    function isRenderPhaseUpdate(fiber) {
        var alternate = fiber.alternate;
        return fiber === currentlyRenderingFiber$1 || alternate !== null && alternate === currentlyRenderingFiber$1;
    }
    function enqueueRenderPhaseUpdate(queue, update) {
        // This is a render phase update. Stash it in a lazily-created map of
        // queue -> linked list of updates. After this render pass, we'll restart
        // and apply the stashed updates on top of the work-in-progress hook.
        didScheduleRenderPhaseUpdateDuringThisPass = didScheduleRenderPhaseUpdate = true;
        var pending = queue.pending;
        if (pending === null) // This is the first update. Create a circular list.
        update.next = update;
        else {
            update.next = pending.next;
            pending.next = update;
        }
        queue.pending = update;
    } // TODO: Move to ReactFiberConcurrentUpdates?
    function entangleTransitionUpdate(root, queue, lane) {
        if (isTransitionLane(lane)) {
            var queueLanes = queue.lanes; // If any entangled lanes are no longer pending on the root, then they
            // must have finished. We can remove them from the shared queue, which
            // represents a superset of the actually pending lanes. In some cases we
            // may entangle more than we need to, but that's OK. In fact it's worse if
            // we *don't* entangle when we should.
            queueLanes = intersectLanes(queueLanes, root.pendingLanes); // Entangle the new transition lane with the other transition lanes.
            var newQueueLanes = mergeLanes(queueLanes, lane);
            queue.lanes = newQueueLanes; // Even if queue.lanes already include lane, we don't know for certain if
            // the lane finished since the last time we entangled it. So we need to
            // entangle it again, just to be sure.
            markRootEntangled(root, newQueueLanes);
        }
    }
    function markUpdateInDevTools(fiber, lane, action) {
        markStateUpdateScheduled(fiber, lane);
    }
    var ContextOnlyDispatcher = {
        readContext: readContext,
        useCallback: throwInvalidHookError,
        useContext: throwInvalidHookError,
        useEffect: throwInvalidHookError,
        useImperativeHandle: throwInvalidHookError,
        useInsertionEffect: throwInvalidHookError,
        useLayoutEffect: throwInvalidHookError,
        useMemo: throwInvalidHookError,
        useReducer: throwInvalidHookError,
        useRef: throwInvalidHookError,
        useState: throwInvalidHookError,
        useDebugValue: throwInvalidHookError,
        useDeferredValue: throwInvalidHookError,
        useTransition: throwInvalidHookError,
        useMutableSource: throwInvalidHookError,
        useSyncExternalStore: throwInvalidHookError,
        useId: throwInvalidHookError,
        unstable_isNewReconciler: enableNewReconciler
    };
    var HooksDispatcherOnMountInDEV = null;
    var HooksDispatcherOnMountWithHookTypesInDEV = null;
    var HooksDispatcherOnUpdateInDEV = null;
    var HooksDispatcherOnRerenderInDEV = null;
    var InvalidNestedHooksDispatcherOnMountInDEV = null;
    var InvalidNestedHooksDispatcherOnUpdateInDEV = null;
    var InvalidNestedHooksDispatcherOnRerenderInDEV = null;
    var warnInvalidContextAccess = function() {
        error("Context can only be read while React is rendering. In classes, you can read it in the render method or getDerivedStateFromProps. In function components, you can read it directly in the function body, but not inside Hooks like useReducer() or useMemo().");
    };
    var warnInvalidHookAccess = function() {
        error("Do not call Hooks inside useEffect(...), useMemo(...), or other built-in Hooks. You can only call Hooks at the top level of your React function. For more information, see https://reactjs.org/link/rules-of-hooks");
    };
    HooksDispatcherOnMountInDEV = {
        readContext: function(context) {
            return readContext(context);
        },
        useCallback: function(callback, deps) {
            currentHookNameInDev = "useCallback";
            mountHookTypesDev();
            checkDepsAreArrayDev(deps);
            return mountCallback(callback, deps);
        },
        useContext: function(context) {
            currentHookNameInDev = "useContext";
            mountHookTypesDev();
            return readContext(context);
        },
        useEffect: function(create, deps) {
            currentHookNameInDev = "useEffect";
            mountHookTypesDev();
            checkDepsAreArrayDev(deps);
            return mountEffect(create, deps);
        },
        useImperativeHandle: function(ref, create, deps) {
            currentHookNameInDev = "useImperativeHandle";
            mountHookTypesDev();
            checkDepsAreArrayDev(deps);
            return mountImperativeHandle(ref, create, deps);
        },
        useInsertionEffect: function(create, deps) {
            currentHookNameInDev = "useInsertionEffect";
            mountHookTypesDev();
            checkDepsAreArrayDev(deps);
            return mountInsertionEffect(create, deps);
        },
        useLayoutEffect: function(create, deps) {
            currentHookNameInDev = "useLayoutEffect";
            mountHookTypesDev();
            checkDepsAreArrayDev(deps);
            return mountLayoutEffect(create, deps);
        },
        useMemo: function(create, deps) {
            currentHookNameInDev = "useMemo";
            mountHookTypesDev();
            checkDepsAreArrayDev(deps);
            var prevDispatcher = ReactCurrentDispatcher$1.current;
            ReactCurrentDispatcher$1.current = InvalidNestedHooksDispatcherOnMountInDEV;
            try {
                return mountMemo(create, deps);
            } finally{
                ReactCurrentDispatcher$1.current = prevDispatcher;
            }
        },
        useReducer: function(reducer, initialArg, init) {
            currentHookNameInDev = "useReducer";
            mountHookTypesDev();
            var prevDispatcher = ReactCurrentDispatcher$1.current;
            ReactCurrentDispatcher$1.current = InvalidNestedHooksDispatcherOnMountInDEV;
            try {
                return mountReducer(reducer, initialArg, init);
            } finally{
                ReactCurrentDispatcher$1.current = prevDispatcher;
            }
        },
        useRef: function(initialValue) {
            currentHookNameInDev = "useRef";
            mountHookTypesDev();
            return mountRef(initialValue);
        },
        useState: function(initialState) {
            currentHookNameInDev = "useState";
            mountHookTypesDev();
            var prevDispatcher = ReactCurrentDispatcher$1.current;
            ReactCurrentDispatcher$1.current = InvalidNestedHooksDispatcherOnMountInDEV;
            try {
                return mountState(initialState);
            } finally{
                ReactCurrentDispatcher$1.current = prevDispatcher;
            }
        },
        useDebugValue: function(value, formatterFn) {
            currentHookNameInDev = "useDebugValue";
            mountHookTypesDev();
            return mountDebugValue();
        },
        useDeferredValue: function(value) {
            currentHookNameInDev = "useDeferredValue";
            mountHookTypesDev();
            return mountDeferredValue(value);
        },
        useTransition: function() {
            currentHookNameInDev = "useTransition";
            mountHookTypesDev();
            return mountTransition();
        },
        useMutableSource: function(source, getSnapshot, subscribe) {
            currentHookNameInDev = "useMutableSource";
            mountHookTypesDev();
            return mountMutableSource();
        },
        useSyncExternalStore: function(subscribe, getSnapshot, getServerSnapshot) {
            currentHookNameInDev = "useSyncExternalStore";
            mountHookTypesDev();
            return mountSyncExternalStore(subscribe, getSnapshot, getServerSnapshot);
        },
        useId: function() {
            currentHookNameInDev = "useId";
            mountHookTypesDev();
            return mountId();
        },
        unstable_isNewReconciler: enableNewReconciler
    };
    HooksDispatcherOnMountWithHookTypesInDEV = {
        readContext: function(context) {
            return readContext(context);
        },
        useCallback: function(callback, deps) {
            currentHookNameInDev = "useCallback";
            updateHookTypesDev();
            return mountCallback(callback, deps);
        },
        useContext: function(context) {
            currentHookNameInDev = "useContext";
            updateHookTypesDev();
            return readContext(context);
        },
        useEffect: function(create, deps) {
            currentHookNameInDev = "useEffect";
            updateHookTypesDev();
            return mountEffect(create, deps);
        },
        useImperativeHandle: function(ref, create, deps) {
            currentHookNameInDev = "useImperativeHandle";
            updateHookTypesDev();
            return mountImperativeHandle(ref, create, deps);
        },
        useInsertionEffect: function(create, deps) {
            currentHookNameInDev = "useInsertionEffect";
            updateHookTypesDev();
            return mountInsertionEffect(create, deps);
        },
        useLayoutEffect: function(create, deps) {
            currentHookNameInDev = "useLayoutEffect";
            updateHookTypesDev();
            return mountLayoutEffect(create, deps);
        },
        useMemo: function(create, deps) {
            currentHookNameInDev = "useMemo";
            updateHookTypesDev();
            var prevDispatcher = ReactCurrentDispatcher$1.current;
            ReactCurrentDispatcher$1.current = InvalidNestedHooksDispatcherOnMountInDEV;
            try {
                return mountMemo(create, deps);
            } finally{
                ReactCurrentDispatcher$1.current = prevDispatcher;
            }
        },
        useReducer: function(reducer, initialArg, init) {
            currentHookNameInDev = "useReducer";
            updateHookTypesDev();
            var prevDispatcher = ReactCurrentDispatcher$1.current;
            ReactCurrentDispatcher$1.current = InvalidNestedHooksDispatcherOnMountInDEV;
            try {
                return mountReducer(reducer, initialArg, init);
            } finally{
                ReactCurrentDispatcher$1.current = prevDispatcher;
            }
        },
        useRef: function(initialValue) {
            currentHookNameInDev = "useRef";
            updateHookTypesDev();
            return mountRef(initialValue);
        },
        useState: function(initialState) {
            currentHookNameInDev = "useState";
            updateHookTypesDev();
            var prevDispatcher = ReactCurrentDispatcher$1.current;
            ReactCurrentDispatcher$1.current = InvalidNestedHooksDispatcherOnMountInDEV;
            try {
                return mountState(initialState);
            } finally{
                ReactCurrentDispatcher$1.current = prevDispatcher;
            }
        },
        useDebugValue: function(value, formatterFn) {
            currentHookNameInDev = "useDebugValue";
            updateHookTypesDev();
            return mountDebugValue();
        },
        useDeferredValue: function(value) {
            currentHookNameInDev = "useDeferredValue";
            updateHookTypesDev();
            return mountDeferredValue(value);
        },
        useTransition: function() {
            currentHookNameInDev = "useTransition";
            updateHookTypesDev();
            return mountTransition();
        },
        useMutableSource: function(source, getSnapshot, subscribe) {
            currentHookNameInDev = "useMutableSource";
            updateHookTypesDev();
            return mountMutableSource();
        },
        useSyncExternalStore: function(subscribe, getSnapshot, getServerSnapshot) {
            currentHookNameInDev = "useSyncExternalStore";
            updateHookTypesDev();
            return mountSyncExternalStore(subscribe, getSnapshot, getServerSnapshot);
        },
        useId: function() {
            currentHookNameInDev = "useId";
            updateHookTypesDev();
            return mountId();
        },
        unstable_isNewReconciler: enableNewReconciler
    };
    HooksDispatcherOnUpdateInDEV = {
        readContext: function(context) {
            return readContext(context);
        },
        useCallback: function(callback, deps) {
            currentHookNameInDev = "useCallback";
            updateHookTypesDev();
            return updateCallback(callback, deps);
        },
        useContext: function(context) {
            currentHookNameInDev = "useContext";
            updateHookTypesDev();
            return readContext(context);
        },
        useEffect: function(create, deps) {
            currentHookNameInDev = "useEffect";
            updateHookTypesDev();
            return updateEffect(create, deps);
        },
        useImperativeHandle: function(ref, create, deps) {
            currentHookNameInDev = "useImperativeHandle";
            updateHookTypesDev();
            return updateImperativeHandle(ref, create, deps);
        },
        useInsertionEffect: function(create, deps) {
            currentHookNameInDev = "useInsertionEffect";
            updateHookTypesDev();
            return updateInsertionEffect(create, deps);
        },
        useLayoutEffect: function(create, deps) {
            currentHookNameInDev = "useLayoutEffect";
            updateHookTypesDev();
            return updateLayoutEffect(create, deps);
        },
        useMemo: function(create, deps) {
            currentHookNameInDev = "useMemo";
            updateHookTypesDev();
            var prevDispatcher = ReactCurrentDispatcher$1.current;
            ReactCurrentDispatcher$1.current = InvalidNestedHooksDispatcherOnUpdateInDEV;
            try {
                return updateMemo(create, deps);
            } finally{
                ReactCurrentDispatcher$1.current = prevDispatcher;
            }
        },
        useReducer: function(reducer, initialArg, init) {
            currentHookNameInDev = "useReducer";
            updateHookTypesDev();
            var prevDispatcher = ReactCurrentDispatcher$1.current;
            ReactCurrentDispatcher$1.current = InvalidNestedHooksDispatcherOnUpdateInDEV;
            try {
                return updateReducer(reducer, initialArg, init);
            } finally{
                ReactCurrentDispatcher$1.current = prevDispatcher;
            }
        },
        useRef: function(initialValue) {
            currentHookNameInDev = "useRef";
            updateHookTypesDev();
            return updateRef();
        },
        useState: function(initialState) {
            currentHookNameInDev = "useState";
            updateHookTypesDev();
            var prevDispatcher = ReactCurrentDispatcher$1.current;
            ReactCurrentDispatcher$1.current = InvalidNestedHooksDispatcherOnUpdateInDEV;
            try {
                return updateState(initialState);
            } finally{
                ReactCurrentDispatcher$1.current = prevDispatcher;
            }
        },
        useDebugValue: function(value, formatterFn) {
            currentHookNameInDev = "useDebugValue";
            updateHookTypesDev();
            return updateDebugValue();
        },
        useDeferredValue: function(value) {
            currentHookNameInDev = "useDeferredValue";
            updateHookTypesDev();
            return updateDeferredValue(value);
        },
        useTransition: function() {
            currentHookNameInDev = "useTransition";
            updateHookTypesDev();
            return updateTransition();
        },
        useMutableSource: function(source, getSnapshot, subscribe) {
            currentHookNameInDev = "useMutableSource";
            updateHookTypesDev();
            return updateMutableSource();
        },
        useSyncExternalStore: function(subscribe, getSnapshot, getServerSnapshot) {
            currentHookNameInDev = "useSyncExternalStore";
            updateHookTypesDev();
            return updateSyncExternalStore(subscribe, getSnapshot);
        },
        useId: function() {
            currentHookNameInDev = "useId";
            updateHookTypesDev();
            return updateId();
        },
        unstable_isNewReconciler: enableNewReconciler
    };
    HooksDispatcherOnRerenderInDEV = {
        readContext: function(context) {
            return readContext(context);
        },
        useCallback: function(callback, deps) {
            currentHookNameInDev = "useCallback";
            updateHookTypesDev();
            return updateCallback(callback, deps);
        },
        useContext: function(context) {
            currentHookNameInDev = "useContext";
            updateHookTypesDev();
            return readContext(context);
        },
        useEffect: function(create, deps) {
            currentHookNameInDev = "useEffect";
            updateHookTypesDev();
            return updateEffect(create, deps);
        },
        useImperativeHandle: function(ref, create, deps) {
            currentHookNameInDev = "useImperativeHandle";
            updateHookTypesDev();
            return updateImperativeHandle(ref, create, deps);
        },
        useInsertionEffect: function(create, deps) {
            currentHookNameInDev = "useInsertionEffect";
            updateHookTypesDev();
            return updateInsertionEffect(create, deps);
        },
        useLayoutEffect: function(create, deps) {
            currentHookNameInDev = "useLayoutEffect";
            updateHookTypesDev();
            return updateLayoutEffect(create, deps);
        },
        useMemo: function(create, deps) {
            currentHookNameInDev = "useMemo";
            updateHookTypesDev();
            var prevDispatcher = ReactCurrentDispatcher$1.current;
            ReactCurrentDispatcher$1.current = InvalidNestedHooksDispatcherOnRerenderInDEV;
            try {
                return updateMemo(create, deps);
            } finally{
                ReactCurrentDispatcher$1.current = prevDispatcher;
            }
        },
        useReducer: function(reducer, initialArg, init) {
            currentHookNameInDev = "useReducer";
            updateHookTypesDev();
            var prevDispatcher = ReactCurrentDispatcher$1.current;
            ReactCurrentDispatcher$1.current = InvalidNestedHooksDispatcherOnRerenderInDEV;
            try {
                return rerenderReducer(reducer, initialArg, init);
            } finally{
                ReactCurrentDispatcher$1.current = prevDispatcher;
            }
        },
        useRef: function(initialValue) {
            currentHookNameInDev = "useRef";
            updateHookTypesDev();
            return updateRef();
        },
        useState: function(initialState) {
            currentHookNameInDev = "useState";
            updateHookTypesDev();
            var prevDispatcher = ReactCurrentDispatcher$1.current;
            ReactCurrentDispatcher$1.current = InvalidNestedHooksDispatcherOnRerenderInDEV;
            try {
                return rerenderState(initialState);
            } finally{
                ReactCurrentDispatcher$1.current = prevDispatcher;
            }
        },
        useDebugValue: function(value, formatterFn) {
            currentHookNameInDev = "useDebugValue";
            updateHookTypesDev();
            return updateDebugValue();
        },
        useDeferredValue: function(value) {
            currentHookNameInDev = "useDeferredValue";
            updateHookTypesDev();
            return rerenderDeferredValue(value);
        },
        useTransition: function() {
            currentHookNameInDev = "useTransition";
            updateHookTypesDev();
            return rerenderTransition();
        },
        useMutableSource: function(source, getSnapshot, subscribe) {
            currentHookNameInDev = "useMutableSource";
            updateHookTypesDev();
            return updateMutableSource();
        },
        useSyncExternalStore: function(subscribe, getSnapshot, getServerSnapshot) {
            currentHookNameInDev = "useSyncExternalStore";
            updateHookTypesDev();
            return updateSyncExternalStore(subscribe, getSnapshot);
        },
        useId: function() {
            currentHookNameInDev = "useId";
            updateHookTypesDev();
            return updateId();
        },
        unstable_isNewReconciler: enableNewReconciler
    };
    InvalidNestedHooksDispatcherOnMountInDEV = {
        readContext: function(context) {
            warnInvalidContextAccess();
            return readContext(context);
        },
        useCallback: function(callback, deps) {
            currentHookNameInDev = "useCallback";
            warnInvalidHookAccess();
            mountHookTypesDev();
            return mountCallback(callback, deps);
        },
        useContext: function(context) {
            currentHookNameInDev = "useContext";
            warnInvalidHookAccess();
            mountHookTypesDev();
            return readContext(context);
        },
        useEffect: function(create, deps) {
            currentHookNameInDev = "useEffect";
            warnInvalidHookAccess();
            mountHookTypesDev();
            return mountEffect(create, deps);
        },
        useImperativeHandle: function(ref, create, deps) {
            currentHookNameInDev = "useImperativeHandle";
            warnInvalidHookAccess();
            mountHookTypesDev();
            return mountImperativeHandle(ref, create, deps);
        },
        useInsertionEffect: function(create, deps) {
            currentHookNameInDev = "useInsertionEffect";
            warnInvalidHookAccess();
            mountHookTypesDev();
            return mountInsertionEffect(create, deps);
        },
        useLayoutEffect: function(create, deps) {
            currentHookNameInDev = "useLayoutEffect";
            warnInvalidHookAccess();
            mountHookTypesDev();
            return mountLayoutEffect(create, deps);
        },
        useMemo: function(create, deps) {
            currentHookNameInDev = "useMemo";
            warnInvalidHookAccess();
            mountHookTypesDev();
            var prevDispatcher = ReactCurrentDispatcher$1.current;
            ReactCurrentDispatcher$1.current = InvalidNestedHooksDispatcherOnMountInDEV;
            try {
                return mountMemo(create, deps);
            } finally{
                ReactCurrentDispatcher$1.current = prevDispatcher;
            }
        },
        useReducer: function(reducer, initialArg, init) {
            currentHookNameInDev = "useReducer";
            warnInvalidHookAccess();
            mountHookTypesDev();
            var prevDispatcher = ReactCurrentDispatcher$1.current;
            ReactCurrentDispatcher$1.current = InvalidNestedHooksDispatcherOnMountInDEV;
            try {
                return mountReducer(reducer, initialArg, init);
            } finally{
                ReactCurrentDispatcher$1.current = prevDispatcher;
            }
        },
        useRef: function(initialValue) {
            currentHookNameInDev = "useRef";
            warnInvalidHookAccess();
            mountHookTypesDev();
            return mountRef(initialValue);
        },
        useState: function(initialState) {
            currentHookNameInDev = "useState";
            warnInvalidHookAccess();
            mountHookTypesDev();
            var prevDispatcher = ReactCurrentDispatcher$1.current;
            ReactCurrentDispatcher$1.current = InvalidNestedHooksDispatcherOnMountInDEV;
            try {
                return mountState(initialState);
            } finally{
                ReactCurrentDispatcher$1.current = prevDispatcher;
            }
        },
        useDebugValue: function(value, formatterFn) {
            currentHookNameInDev = "useDebugValue";
            warnInvalidHookAccess();
            mountHookTypesDev();
            return mountDebugValue();
        },
        useDeferredValue: function(value) {
            currentHookNameInDev = "useDeferredValue";
            warnInvalidHookAccess();
            mountHookTypesDev();
            return mountDeferredValue(value);
        },
        useTransition: function() {
            currentHookNameInDev = "useTransition";
            warnInvalidHookAccess();
            mountHookTypesDev();
            return mountTransition();
        },
        useMutableSource: function(source, getSnapshot, subscribe) {
            currentHookNameInDev = "useMutableSource";
            warnInvalidHookAccess();
            mountHookTypesDev();
            return mountMutableSource();
        },
        useSyncExternalStore: function(subscribe, getSnapshot, getServerSnapshot) {
            currentHookNameInDev = "useSyncExternalStore";
            warnInvalidHookAccess();
            mountHookTypesDev();
            return mountSyncExternalStore(subscribe, getSnapshot, getServerSnapshot);
        },
        useId: function() {
            currentHookNameInDev = "useId";
            warnInvalidHookAccess();
            mountHookTypesDev();
            return mountId();
        },
        unstable_isNewReconciler: enableNewReconciler
    };
    InvalidNestedHooksDispatcherOnUpdateInDEV = {
        readContext: function(context) {
            warnInvalidContextAccess();
            return readContext(context);
        },
        useCallback: function(callback, deps) {
            currentHookNameInDev = "useCallback";
            warnInvalidHookAccess();
            updateHookTypesDev();
            return updateCallback(callback, deps);
        },
        useContext: function(context) {
            currentHookNameInDev = "useContext";
            warnInvalidHookAccess();
            updateHookTypesDev();
            return readContext(context);
        },
        useEffect: function(create, deps) {
            currentHookNameInDev = "useEffect";
            warnInvalidHookAccess();
            updateHookTypesDev();
            return updateEffect(create, deps);
        },
        useImperativeHandle: function(ref, create, deps) {
            currentHookNameInDev = "useImperativeHandle";
            warnInvalidHookAccess();
            updateHookTypesDev();
            return updateImperativeHandle(ref, create, deps);
        },
        useInsertionEffect: function(create, deps) {
            currentHookNameInDev = "useInsertionEffect";
            warnInvalidHookAccess();
            updateHookTypesDev();
            return updateInsertionEffect(create, deps);
        },
        useLayoutEffect: function(create, deps) {
            currentHookNameInDev = "useLayoutEffect";
            warnInvalidHookAccess();
            updateHookTypesDev();
            return updateLayoutEffect(create, deps);
        },
        useMemo: function(create, deps) {
            currentHookNameInDev = "useMemo";
            warnInvalidHookAccess();
            updateHookTypesDev();
            var prevDispatcher = ReactCurrentDispatcher$1.current;
            ReactCurrentDispatcher$1.current = InvalidNestedHooksDispatcherOnUpdateInDEV;
            try {
                return updateMemo(create, deps);
            } finally{
                ReactCurrentDispatcher$1.current = prevDispatcher;
            }
        },
        useReducer: function(reducer, initialArg, init) {
            currentHookNameInDev = "useReducer";
            warnInvalidHookAccess();
            updateHookTypesDev();
            var prevDispatcher = ReactCurrentDispatcher$1.current;
            ReactCurrentDispatcher$1.current = InvalidNestedHooksDispatcherOnUpdateInDEV;
            try {
                return updateReducer(reducer, initialArg, init);
            } finally{
                ReactCurrentDispatcher$1.current = prevDispatcher;
            }
        },
        useRef: function(initialValue) {
            currentHookNameInDev = "useRef";
            warnInvalidHookAccess();
            updateHookTypesDev();
            return updateRef();
        },
        useState: function(initialState) {
            currentHookNameInDev = "useState";
            warnInvalidHookAccess();
            updateHookTypesDev();
            var prevDispatcher = ReactCurrentDispatcher$1.current;
            ReactCurrentDispatcher$1.current = InvalidNestedHooksDispatcherOnUpdateInDEV;
            try {
                return updateState(initialState);
            } finally{
                ReactCurrentDispatcher$1.current = prevDispatcher;
            }
        },
        useDebugValue: function(value, formatterFn) {
            currentHookNameInDev = "useDebugValue";
            warnInvalidHookAccess();
            updateHookTypesDev();
            return updateDebugValue();
        },
        useDeferredValue: function(value) {
            currentHookNameInDev = "useDeferredValue";
            warnInvalidHookAccess();
            updateHookTypesDev();
            return updateDeferredValue(value);
        },
        useTransition: function() {
            currentHookNameInDev = "useTransition";
            warnInvalidHookAccess();
            updateHookTypesDev();
            return updateTransition();
        },
        useMutableSource: function(source, getSnapshot, subscribe) {
            currentHookNameInDev = "useMutableSource";
            warnInvalidHookAccess();
            updateHookTypesDev();
            return updateMutableSource();
        },
        useSyncExternalStore: function(subscribe, getSnapshot, getServerSnapshot) {
            currentHookNameInDev = "useSyncExternalStore";
            warnInvalidHookAccess();
            updateHookTypesDev();
            return updateSyncExternalStore(subscribe, getSnapshot);
        },
        useId: function() {
            currentHookNameInDev = "useId";
            warnInvalidHookAccess();
            updateHookTypesDev();
            return updateId();
        },
        unstable_isNewReconciler: enableNewReconciler
    };
    InvalidNestedHooksDispatcherOnRerenderInDEV = {
        readContext: function(context) {
            warnInvalidContextAccess();
            return readContext(context);
        },
        useCallback: function(callback, deps) {
            currentHookNameInDev = "useCallback";
            warnInvalidHookAccess();
            updateHookTypesDev();
            return updateCallback(callback, deps);
        },
        useContext: function(context) {
            currentHookNameInDev = "useContext";
            warnInvalidHookAccess();
            updateHookTypesDev();
            return readContext(context);
        },
        useEffect: function(create, deps) {
            currentHookNameInDev = "useEffect";
            warnInvalidHookAccess();
            updateHookTypesDev();
            return updateEffect(create, deps);
        },
        useImperativeHandle: function(ref, create, deps) {
            currentHookNameInDev = "useImperativeHandle";
            warnInvalidHookAccess();
            updateHookTypesDev();
            return updateImperativeHandle(ref, create, deps);
        },
        useInsertionEffect: function(create, deps) {
            currentHookNameInDev = "useInsertionEffect";
            warnInvalidHookAccess();
            updateHookTypesDev();
            return updateInsertionEffect(create, deps);
        },
        useLayoutEffect: function(create, deps) {
            currentHookNameInDev = "useLayoutEffect";
            warnInvalidHookAccess();
            updateHookTypesDev();
            return updateLayoutEffect(create, deps);
        },
        useMemo: function(create, deps) {
            currentHookNameInDev = "useMemo";
            warnInvalidHookAccess();
            updateHookTypesDev();
            var prevDispatcher = ReactCurrentDispatcher$1.current;
            ReactCurrentDispatcher$1.current = InvalidNestedHooksDispatcherOnUpdateInDEV;
            try {
                return updateMemo(create, deps);
            } finally{
                ReactCurrentDispatcher$1.current = prevDispatcher;
            }
        },
        useReducer: function(reducer, initialArg, init) {
            currentHookNameInDev = "useReducer";
            warnInvalidHookAccess();
            updateHookTypesDev();
            var prevDispatcher = ReactCurrentDispatcher$1.current;
            ReactCurrentDispatcher$1.current = InvalidNestedHooksDispatcherOnUpdateInDEV;
            try {
                return rerenderReducer(reducer, initialArg, init);
            } finally{
                ReactCurrentDispatcher$1.current = prevDispatcher;
            }
        },
        useRef: function(initialValue) {
            currentHookNameInDev = "useRef";
            warnInvalidHookAccess();
            updateHookTypesDev();
            return updateRef();
        },
        useState: function(initialState) {
            currentHookNameInDev = "useState";
            warnInvalidHookAccess();
            updateHookTypesDev();
            var prevDispatcher = ReactCurrentDispatcher$1.current;
            ReactCurrentDispatcher$1.current = InvalidNestedHooksDispatcherOnUpdateInDEV;
            try {
                return rerenderState(initialState);
            } finally{
                ReactCurrentDispatcher$1.current = prevDispatcher;
            }
        },
        useDebugValue: function(value, formatterFn) {
            currentHookNameInDev = "useDebugValue";
            warnInvalidHookAccess();
            updateHookTypesDev();
            return updateDebugValue();
        },
        useDeferredValue: function(value) {
            currentHookNameInDev = "useDeferredValue";
            warnInvalidHookAccess();
            updateHookTypesDev();
            return rerenderDeferredValue(value);
        },
        useTransition: function() {
            currentHookNameInDev = "useTransition";
            warnInvalidHookAccess();
            updateHookTypesDev();
            return rerenderTransition();
        },
        useMutableSource: function(source, getSnapshot, subscribe) {
            currentHookNameInDev = "useMutableSource";
            warnInvalidHookAccess();
            updateHookTypesDev();
            return updateMutableSource();
        },
        useSyncExternalStore: function(subscribe, getSnapshot, getServerSnapshot) {
            currentHookNameInDev = "useSyncExternalStore";
            warnInvalidHookAccess();
            updateHookTypesDev();
            return updateSyncExternalStore(subscribe, getSnapshot);
        },
        useId: function() {
            currentHookNameInDev = "useId";
            warnInvalidHookAccess();
            updateHookTypesDev();
            return updateId();
        },
        unstable_isNewReconciler: enableNewReconciler
    };
    var now$1 = Scheduler.unstable_now;
    var commitTime = 0;
    var layoutEffectStartTime = -1;
    var profilerStartTime = -1;
    var passiveEffectStartTime = -1;
    /**
 * Tracks whether the current update was a nested/cascading update (scheduled from a layout effect).
 *
 * The overall sequence is:
 *   1. render
 *   2. commit (and call `onRender`, `onCommit`)
 *   3. check for nested updates
 *   4. flush passive effects (and call `onPostCommit`)
 *
 * Nested updates are identified in step 3 above,
 * but step 4 still applies to the work that was just committed.
 * We use two flags to track nested updates then:
 * one tracks whether the upcoming update is a nested update,
 * and the other tracks whether the current update was a nested update.
 * The first value gets synced to the second at the start of the render phase.
 */ var currentUpdateIsNested = false;
    var nestedUpdateScheduled = false;
    function isCurrentUpdateNested() {
        return currentUpdateIsNested;
    }
    function markNestedUpdateScheduled() {
        nestedUpdateScheduled = true;
    }
    function resetNestedUpdateFlag() {
        currentUpdateIsNested = false;
        nestedUpdateScheduled = false;
    }
    function syncNestedUpdateFlag() {
        currentUpdateIsNested = nestedUpdateScheduled;
        nestedUpdateScheduled = false;
    }
    function getCommitTime() {
        return commitTime;
    }
    function recordCommitTime() {
        commitTime = now$1();
    }
    function startProfilerTimer(fiber) {
        profilerStartTime = now$1();
        if (fiber.actualStartTime < 0) fiber.actualStartTime = now$1();
    }
    function stopProfilerTimerIfRunning(fiber) {
        profilerStartTime = -1;
    }
    function stopProfilerTimerIfRunningAndRecordDelta(fiber, overrideBaseTime) {
        if (profilerStartTime >= 0) {
            var elapsedTime = now$1() - profilerStartTime;
            fiber.actualDuration += elapsedTime;
            if (overrideBaseTime) fiber.selfBaseDuration = elapsedTime;
            profilerStartTime = -1;
        }
    }
    function recordLayoutEffectDuration(fiber) {
        if (layoutEffectStartTime >= 0) {
            var elapsedTime = now$1() - layoutEffectStartTime;
            layoutEffectStartTime = -1; // Store duration on the next nearest Profiler ancestor
            // Or the root (for the DevTools Profiler to read)
            var parentFiber = fiber.return;
            while(parentFiber !== null){
                switch(parentFiber.tag){
                    case HostRoot:
                        var root = parentFiber.stateNode;
                        root.effectDuration += elapsedTime;
                        return;
                    case Profiler:
                        var parentStateNode = parentFiber.stateNode;
                        parentStateNode.effectDuration += elapsedTime;
                        return;
                }
                parentFiber = parentFiber.return;
            }
        }
    }
    function recordPassiveEffectDuration(fiber) {
        if (passiveEffectStartTime >= 0) {
            var elapsedTime = now$1() - passiveEffectStartTime;
            passiveEffectStartTime = -1; // Store duration on the next nearest Profiler ancestor
            // Or the root (for the DevTools Profiler to read)
            var parentFiber = fiber.return;
            while(parentFiber !== null){
                switch(parentFiber.tag){
                    case HostRoot:
                        var root = parentFiber.stateNode;
                        if (root !== null) root.passiveEffectDuration += elapsedTime;
                        return;
                    case Profiler:
                        var parentStateNode = parentFiber.stateNode;
                        if (parentStateNode !== null) // Detached fibers have their state node cleared out.
                        // In this case, the return pointer is also cleared out,
                        // so we won't be able to report the time spent in this Profiler's subtree.
                        parentStateNode.passiveEffectDuration += elapsedTime;
                        return;
                }
                parentFiber = parentFiber.return;
            }
        }
    }
    function startLayoutEffectTimer() {
        layoutEffectStartTime = now$1();
    }
    function startPassiveEffectTimer() {
        passiveEffectStartTime = now$1();
    }
    function transferActualDuration(fiber) {
        // Transfer time spent rendering these children so we don't lose it
        // after we rerender. This is used as a helper in special cases
        // where we should count the work of multiple passes.
        var child = fiber.child;
        while(child){
            fiber.actualDuration += child.actualDuration;
            child = child.sibling;
        }
    }
    function createCapturedValueAtFiber(value, source) {
        // If the value is an error, call this function immediately after it is thrown
        // so the stack is accurate.
        return {
            value: value,
            source: source,
            stack: getStackByFiberInDevAndProd(source),
            digest: null
        };
    }
    function createCapturedValue(value, digest, stack) {
        return {
            value: value,
            source: null,
            stack: stack != null ? stack : null,
            digest: digest != null ? digest : null
        };
    }
    // This module is forked in different environments.
    // By default, return `true` to log errors to the console.
    // Forks can return `false` if this isn't desirable.
    function showErrorDialog(boundary, errorInfo) {
        return true;
    }
    function logCapturedError(boundary, errorInfo) {
        try {
            var logError = showErrorDialog(boundary, errorInfo); // Allow injected showErrorDialog() to prevent default console.error logging.
            // This enables renderers like ReactNative to better manage redbox behavior.
            if (logError === false) return;
            var error = errorInfo.value;
            var source = errorInfo.source;
            var stack = errorInfo.stack;
            var componentStack = stack !== null ? stack : ""; // Browsers support silencing uncaught errors by calling
            // `preventDefault()` in window `error` handler.
            // We record this information as an expando on the error.
            if (error != null && error._suppressLogging) {
                if (boundary.tag === ClassComponent) // The error is recoverable and was silenced.
                // Ignore it and don't print the stack addendum.
                // This is handy for testing error boundaries without noise.
                return;
                 // The error is fatal. Since the silencing might have
                // been accidental, we'll surface it anyway.
                // However, the browser would have silenced the original error
                // so we'll print it first, and then print the stack addendum.
                console["error"](error); // Don't transform to our wrapper
            // For a more detailed description of this block, see:
            // https://github.com/facebook/react/pull/13384
            }
            var componentName = source ? getComponentNameFromFiber(source) : null;
            var componentNameMessage = componentName ? "The above error occurred in the <" + componentName + "> component:" : "The above error occurred in one of your React components:";
            var errorBoundaryMessage;
            if (boundary.tag === HostRoot) errorBoundaryMessage = "Consider adding an error boundary to your tree to customize error handling behavior.\nVisit https://reactjs.org/link/error-boundaries to learn more about error boundaries.";
            else {
                var errorBoundaryName = getComponentNameFromFiber(boundary) || "Anonymous";
                errorBoundaryMessage = "React will try to recreate this component tree from scratch " + ("using the error boundary you provided, " + errorBoundaryName + ".");
            }
            var combinedMessage = componentNameMessage + "\n" + componentStack + "\n\n" + ("" + errorBoundaryMessage); // In development, we provide our own message with just the component stack.
            // We don't include the original error message and JS stack because the browser
            // has already printed it. Even if the application swallows the error, it is still
            // displayed by the browser thanks to the DEV-only fake event trick in ReactErrorUtils.
            console["error"](combinedMessage); // Don't transform to our wrapper
        } catch (e) {
            // This method must not throw, or React internal state will get messed up.
            // If console.error is overridden, or logCapturedError() shows a dialog that throws,
            // we want to report this error outside of the normal stack as a last resort.
            // https://github.com/facebook/react/issues/13188
            setTimeout(function() {
                throw e;
            });
        }
    }
    var PossiblyWeakMap$1 = typeof WeakMap === "function" ? WeakMap : Map;
    function createRootErrorUpdate(fiber, errorInfo, lane) {
        var update = createUpdate(NoTimestamp, lane); // Unmount the root by rendering null.
        update.tag = CaptureUpdate; // Caution: React DevTools currently depends on this property
        // being called "element".
        update.payload = {
            element: null
        };
        var error = errorInfo.value;
        update.callback = function() {
            onUncaughtError(error);
            logCapturedError(fiber, errorInfo);
        };
        return update;
    }
    function createClassErrorUpdate(fiber, errorInfo, lane) {
        var update = createUpdate(NoTimestamp, lane);
        update.tag = CaptureUpdate;
        var getDerivedStateFromError = fiber.type.getDerivedStateFromError;
        if (typeof getDerivedStateFromError === "function") {
            var error$1 = errorInfo.value;
            update.payload = function() {
                return getDerivedStateFromError(error$1);
            };
            update.callback = function() {
                markFailedErrorBoundaryForHotReloading(fiber);
                logCapturedError(fiber, errorInfo);
            };
        }
        var inst = fiber.stateNode;
        if (inst !== null && typeof inst.componentDidCatch === "function") update.callback = function callback() {
            markFailedErrorBoundaryForHotReloading(fiber);
            logCapturedError(fiber, errorInfo);
            if (typeof getDerivedStateFromError !== "function") // To preserve the preexisting retry behavior of error boundaries,
            // we keep track of which ones already failed during this batch.
            // This gets reset before we yield back to the browser.
            // TODO: Warn in strict mode if getDerivedStateFromError is
            // not defined.
            markLegacyErrorBoundaryAsFailed(this);
            var error$1 = errorInfo.value;
            var stack = errorInfo.stack;
            this.componentDidCatch(error$1, {
                componentStack: stack !== null ? stack : ""
            });
            if (typeof getDerivedStateFromError !== "function") // If componentDidCatch is the only error boundary method defined,
            // then it needs to call setState to recover from errors.
            // If no state update is scheduled then the boundary will swallow the error.
            {
                if (!includesSomeLane(fiber.lanes, SyncLane)) error("%s: Error boundaries should implement getDerivedStateFromError(). In that method, return a state update to display an error message or fallback UI.", getComponentNameFromFiber(fiber) || "Unknown");
            }
        };
        return update;
    }
    function attachPingListener(root, wakeable, lanes) {
        // Attach a ping listener
        //
        // The data might resolve before we have a chance to commit the fallback. Or,
        // in the case of a refresh, we'll never commit a fallback. So we need to
        // attach a listener now. When it resolves ("pings"), we can decide whether to
        // try rendering the tree again.
        //
        // Only attach a listener if one does not already exist for the lanes
        // we're currently rendering (which acts like a "thread ID" here).
        //
        // We only need to do this in concurrent mode. Legacy Suspense always
        // commits fallbacks synchronously, so there are no pings.
        var pingCache = root.pingCache;
        var threadIDs;
        if (pingCache === null) {
            pingCache = root.pingCache = new PossiblyWeakMap$1();
            threadIDs = new Set();
            pingCache.set(wakeable, threadIDs);
        } else {
            threadIDs = pingCache.get(wakeable);
            if (threadIDs === undefined) {
                threadIDs = new Set();
                pingCache.set(wakeable, threadIDs);
            }
        }
        if (!threadIDs.has(lanes)) {
            // Memoize using the thread ID to prevent redundant listeners.
            threadIDs.add(lanes);
            var ping = pingSuspendedRoot.bind(null, root, wakeable, lanes);
            if (isDevToolsPresent) // If we have pending work still, restore the original updaters
            restorePendingUpdaters(root, lanes);
            wakeable.then(ping, ping);
        }
    }
    function attachRetryListener(suspenseBoundary, root, wakeable, lanes) {
        // Retry listener
        //
        // If the fallback does commit, we need to attach a different type of
        // listener. This one schedules an update on the Suspense boundary to turn
        // the fallback state off.
        //
        // Stash the wakeable on the boundary fiber so we can access it in the
        // commit phase.
        //
        // When the wakeable resolves, we'll attempt to render the boundary
        // again ("retry").
        var wakeables = suspenseBoundary.updateQueue;
        if (wakeables === null) {
            var updateQueue = new Set();
            updateQueue.add(wakeable);
            suspenseBoundary.updateQueue = updateQueue;
        } else wakeables.add(wakeable);
    }
    function resetSuspendedComponent(sourceFiber, rootRenderLanes) {
        // A legacy mode Suspense quirk, only relevant to hook components.
        var tag = sourceFiber.tag;
        if ((sourceFiber.mode & ConcurrentMode) === NoMode && (tag === FunctionComponent || tag === ForwardRef || tag === SimpleMemoComponent)) {
            var currentSource = sourceFiber.alternate;
            if (currentSource) {
                sourceFiber.updateQueue = currentSource.updateQueue;
                sourceFiber.memoizedState = currentSource.memoizedState;
                sourceFiber.lanes = currentSource.lanes;
            } else {
                sourceFiber.updateQueue = null;
                sourceFiber.memoizedState = null;
            }
        }
    }
    function getNearestSuspenseBoundaryToCapture(returnFiber) {
        var node = returnFiber;
        do {
            if (node.tag === SuspenseComponent && shouldCaptureSuspense(node)) return node;
             // This boundary already captured during this render. Continue to the next
            // boundary.
            node = node.return;
        }while (node !== null);
        return null;
    }
    function markSuspenseBoundaryShouldCapture(suspenseBoundary, returnFiber, sourceFiber, root, rootRenderLanes) {
        // This marks a Suspense boundary so that when we're unwinding the stack,
        // it captures the suspended "exception" and does a second (fallback) pass.
        if ((suspenseBoundary.mode & ConcurrentMode) === NoMode) {
            // Legacy Mode Suspense
            //
            // If the boundary is in legacy mode, we should *not*
            // suspend the commit. Pretend as if the suspended component rendered
            // null and keep rendering. When the Suspense boundary completes,
            // we'll do a second pass to render the fallback.
            if (suspenseBoundary === returnFiber) // Special case where we suspended while reconciling the children of
            // a Suspense boundary's inner Offscreen wrapper fiber. This happens
            // when a React.lazy component is a direct child of a
            // Suspense boundary.
            //
            // Suspense boundaries are implemented as multiple fibers, but they
            // are a single conceptual unit. The legacy mode behavior where we
            // pretend the suspended fiber committed as `null` won't work,
            // because in this case the "suspended" fiber is the inner
            // Offscreen wrapper.
            //
            // Because the contents of the boundary haven't started rendering
            // yet (i.e. nothing in the tree has partially rendered) we can
            // switch to the regular, concurrent mode behavior: mark the
            // boundary with ShouldCapture and enter the unwind phase.
            suspenseBoundary.flags |= ShouldCapture;
            else {
                suspenseBoundary.flags |= DidCapture;
                sourceFiber.flags |= ForceUpdateForLegacySuspense; // We're going to commit this fiber even though it didn't complete.
                // But we shouldn't call any lifecycle methods or callbacks. Remove
                // all lifecycle effect tags.
                sourceFiber.flags &= ~(LifecycleEffectMask | Incomplete);
                if (sourceFiber.tag === ClassComponent) {
                    var currentSourceFiber = sourceFiber.alternate;
                    if (currentSourceFiber === null) // This is a new mount. Change the tag so it's not mistaken for a
                    // completed class component. For example, we should not call
                    // componentWillUnmount if it is deleted.
                    sourceFiber.tag = IncompleteClassComponent;
                    else {
                        // When we try rendering again, we should not reuse the current fiber,
                        // since it's known to be in an inconsistent state. Use a force update to
                        // prevent a bail out.
                        var update = createUpdate(NoTimestamp, SyncLane);
                        update.tag = ForceUpdate;
                        enqueueUpdate(sourceFiber, update, SyncLane);
                    }
                } // The source fiber did not complete. Mark it with Sync priority to
                // indicate that it still has pending work.
                sourceFiber.lanes = mergeLanes(sourceFiber.lanes, SyncLane);
            }
            return suspenseBoundary;
        } // Confirmed that the boundary is in a concurrent mode tree. Continue
        // with the normal suspend path.
        //
        // After this we'll use a set of heuristics to determine whether this
        // render pass will run to completion or restart or "suspend" the commit.
        // The actual logic for this is spread out in different places.
        //
        // This first principle is that if we're going to suspend when we complete
        // a root, then we should also restart if we get an update or ping that
        // might unsuspend it, and vice versa. The only reason to suspend is
        // because you think you might want to restart before committing. However,
        // it doesn't make sense to restart only while in the period we're suspended.
        //
        // Restarting too aggressively is also not good because it starves out any
        // intermediate loading state. So we use heuristics to determine when.
        // Suspense Heuristics
        //
        // If nothing threw a Promise or all the same fallbacks are already showing,
        // then don't suspend/restart.
        //
        // If this is an initial render of a new tree of Suspense boundaries and
        // those trigger a fallback, then don't suspend/restart. We want to ensure
        // that we can show the initial loading state as quickly as possible.
        //
        // If we hit a "Delayed" case, such as when we'd switch from content back into
        // a fallback, then we should always suspend/restart. Transitions apply
        // to this case. If none is defined, JND is used instead.
        //
        // If we're already showing a fallback and it gets "retried", allowing us to show
        // another level, but there's still an inner boundary that would show a fallback,
        // then we suspend/restart for 500ms since the last time we showed a fallback
        // anywhere in the tree. This effectively throttles progressive loading into a
        // consistent train of commits. This also gives us an opportunity to restart to
        // get to the completed state slightly earlier.
        //
        // If there's ambiguity due to batching it's resolved in preference of:
        // 1) "delayed", 2) "initial render", 3) "retry".
        //
        // We want to ensure that a "busy" state doesn't get force committed. We want to
        // ensure that new initial loading states can commit as soon as possible.
        suspenseBoundary.flags |= ShouldCapture; // TODO: I think we can remove this, since we now use `DidCapture` in
        // the begin phase to prevent an early bailout.
        suspenseBoundary.lanes = rootRenderLanes;
        return suspenseBoundary;
    }
    function throwException(root, returnFiber, sourceFiber, value, rootRenderLanes) {
        // The source fiber did not complete.
        sourceFiber.flags |= Incomplete;
        if (isDevToolsPresent) // If we have pending work still, restore the original updaters
        restorePendingUpdaters(root, rootRenderLanes);
        if (value !== null && typeof value === "object" && typeof value.then === "function") {
            // This is a wakeable. The component suspended.
            var wakeable = value;
            resetSuspendedComponent(sourceFiber);
            if (getIsHydrating() && sourceFiber.mode & ConcurrentMode) markDidThrowWhileHydratingDEV();
            var suspenseBoundary = getNearestSuspenseBoundaryToCapture(returnFiber);
            if (suspenseBoundary !== null) {
                suspenseBoundary.flags &= ~ForceClientRender;
                markSuspenseBoundaryShouldCapture(suspenseBoundary, returnFiber, sourceFiber, root, rootRenderLanes); // We only attach ping listeners in concurrent mode. Legacy Suspense always
                // commits fallbacks synchronously, so there are no pings.
                if (suspenseBoundary.mode & ConcurrentMode) attachPingListener(root, wakeable, rootRenderLanes);
                attachRetryListener(suspenseBoundary, root, wakeable);
                return;
            } else {
                // No boundary was found. Unless this is a sync update, this is OK.
                // We can suspend and wait for more data to arrive.
                if (!includesSyncLane(rootRenderLanes)) {
                    // This is not a sync update. Suspend. Since we're not activating a
                    // Suspense boundary, this will unwind all the way to the root without
                    // performing a second pass to render a fallback. (This is arguably how
                    // refresh transitions should work, too, since we're not going to commit
                    // the fallbacks anyway.)
                    //
                    // This case also applies to initial hydration.
                    attachPingListener(root, wakeable, rootRenderLanes);
                    renderDidSuspendDelayIfPossible();
                    return;
                } // This is a sync/discrete update. We treat this case like an error
                // because discrete renders are expected to produce a complete tree
                // synchronously to maintain consistency with external state.
                var uncaughtSuspenseError = new Error("A component suspended while responding to synchronous input. This will cause the UI to be replaced with a loading indicator. To fix, updates that suspend should be wrapped with startTransition."); // If we're outside a transition, fall through to the regular error path.
                // The error will be caught by the nearest suspense boundary.
                value = uncaughtSuspenseError;
            }
        } else // This is a regular error, not a Suspense wakeable.
        if (getIsHydrating() && sourceFiber.mode & ConcurrentMode) {
            markDidThrowWhileHydratingDEV();
            var _suspenseBoundary = getNearestSuspenseBoundaryToCapture(returnFiber); // If the error was thrown during hydration, we may be able to recover by
            // discarding the dehydrated content and switching to a client render.
            // Instead of surfacing the error, find the nearest Suspense boundary
            // and render it again without hydration.
            if (_suspenseBoundary !== null) {
                if ((_suspenseBoundary.flags & ShouldCapture) === NoFlags) // Set a flag to indicate that we should try rendering the normal
                // children again, not the fallback.
                _suspenseBoundary.flags |= ForceClientRender;
                markSuspenseBoundaryShouldCapture(_suspenseBoundary, returnFiber, sourceFiber, root, rootRenderLanes); // Even though the user may not be affected by this error, we should
                // still log it so it can be fixed.
                queueHydrationError(createCapturedValueAtFiber(value, sourceFiber));
                return;
            }
        }
        value = createCapturedValueAtFiber(value, sourceFiber);
        renderDidError(value); // We didn't find a boundary that could handle this type of exception. Start
        // over and traverse parent path again, this time treating the exception
        // as an error.
        var workInProgress = returnFiber;
        do {
            switch(workInProgress.tag){
                case HostRoot:
                    var _errorInfo = value;
                    workInProgress.flags |= ShouldCapture;
                    var lane = pickArbitraryLane(rootRenderLanes);
                    workInProgress.lanes = mergeLanes(workInProgress.lanes, lane);
                    var update = createRootErrorUpdate(workInProgress, _errorInfo, lane);
                    enqueueCapturedUpdate(workInProgress, update);
                    return;
                case ClassComponent:
                    // Capture and retry
                    var errorInfo = value;
                    var ctor = workInProgress.type;
                    var instance = workInProgress.stateNode;
                    if ((workInProgress.flags & DidCapture) === NoFlags && (typeof ctor.getDerivedStateFromError === "function" || instance !== null && typeof instance.componentDidCatch === "function" && !isAlreadyFailedLegacyErrorBoundary(instance))) {
                        workInProgress.flags |= ShouldCapture;
                        var _lane = pickArbitraryLane(rootRenderLanes);
                        workInProgress.lanes = mergeLanes(workInProgress.lanes, _lane); // Schedule the error boundary to re-render using updated state
                        var _update = createClassErrorUpdate(workInProgress, errorInfo, _lane);
                        enqueueCapturedUpdate(workInProgress, _update);
                        return;
                    }
                    break;
            }
            workInProgress = workInProgress.return;
        }while (workInProgress !== null);
    }
    function getSuspendedCache() {
        return null;
    }
    var ReactCurrentOwner$1 = ReactSharedInternals.ReactCurrentOwner;
    var didReceiveUpdate = false;
    var didWarnAboutBadClass;
    var didWarnAboutModulePatternComponent;
    var didWarnAboutContextTypeOnFunctionComponent;
    var didWarnAboutGetDerivedStateOnFunctionComponent;
    var didWarnAboutFunctionRefs;
    var didWarnAboutReassigningProps;
    var didWarnAboutRevealOrder;
    var didWarnAboutTailOptions;
    didWarnAboutBadClass = {};
    didWarnAboutModulePatternComponent = {};
    didWarnAboutContextTypeOnFunctionComponent = {};
    didWarnAboutGetDerivedStateOnFunctionComponent = {};
    didWarnAboutFunctionRefs = {};
    didWarnAboutReassigningProps = false;
    didWarnAboutRevealOrder = {};
    didWarnAboutTailOptions = {};
    function reconcileChildren(current, workInProgress, nextChildren, renderLanes) {
        if (current === null) // If this is a fresh new component that hasn't been rendered yet, we
        // won't update its child set by applying minimal side-effects. Instead,
        // we will add them all to the child before it gets rendered. That means
        // we can optimize this reconciliation pass by not tracking side-effects.
        workInProgress.child = mountChildFibers(workInProgress, null, nextChildren, renderLanes);
        else // If the current child is the same as the work in progress, it means that
        // we haven't yet started any work on these children. Therefore, we use
        // the clone algorithm to create a copy of all the current children.
        // If we had any progressed work already, that is invalid at this point so
        // let's throw it out.
        workInProgress.child = reconcileChildFibers(workInProgress, current.child, nextChildren, renderLanes);
    }
    function forceUnmountCurrentAndReconcile(current, workInProgress, nextChildren, renderLanes) {
        // This function is fork of reconcileChildren. It's used in cases where we
        // want to reconcile without matching against the existing set. This has the
        // effect of all current children being unmounted; even if the type and key
        // are the same, the old child is unmounted and a new child is created.
        //
        // To do this, we're going to go through the reconcile algorithm twice. In
        // the first pass, we schedule a deletion for all the current children by
        // passing null.
        workInProgress.child = reconcileChildFibers(workInProgress, current.child, null, renderLanes); // In the second pass, we mount the new children. The trick here is that we
        // pass null in place of where we usually pass the current child set. This has
        // the effect of remounting all children regardless of whether their
        // identities match.
        workInProgress.child = reconcileChildFibers(workInProgress, null, nextChildren, renderLanes);
    }
    function updateForwardRef(current, workInProgress, Component, nextProps, renderLanes) {
        if (workInProgress.type !== workInProgress.elementType) {
            // Lazy component props can't be validated in createElement
            // because they're only guaranteed to be resolved here.
            var innerPropTypes = Component.propTypes;
            if (innerPropTypes) checkPropTypes(innerPropTypes, nextProps, "prop", getComponentNameFromType(Component));
        }
        var render = Component.render;
        var ref = workInProgress.ref; // The rest is a fork of updateFunctionComponent
        var nextChildren;
        var hasId;
        prepareToReadContext(workInProgress, renderLanes);
        markComponentRenderStarted(workInProgress);
        ReactCurrentOwner$1.current = workInProgress;
        setIsRendering(true);
        nextChildren = renderWithHooks(current, workInProgress, render, nextProps, ref, renderLanes);
        hasId = checkDidRenderIdHook();
        if (workInProgress.mode & StrictLegacyMode) {
            setIsStrictModeForDevtools(true);
            try {
                nextChildren = renderWithHooks(current, workInProgress, render, nextProps, ref, renderLanes);
                hasId = checkDidRenderIdHook();
            } finally{
                setIsStrictModeForDevtools(false);
            }
        }
        setIsRendering(false);
        markComponentRenderStopped();
        if (current !== null && !didReceiveUpdate) {
            bailoutHooks(current, workInProgress, renderLanes);
            return bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
        }
        if (getIsHydrating() && hasId) pushMaterializedTreeId(workInProgress);
         // React DevTools reads this flag.
        workInProgress.flags |= PerformedWork;
        reconcileChildren(current, workInProgress, nextChildren, renderLanes);
        return workInProgress.child;
    }
    function updateMemoComponent(current, workInProgress, Component, nextProps, renderLanes) {
        if (current === null) {
            var type = Component.type;
            if (isSimpleFunctionComponent(type) && Component.compare === null && // SimpleMemoComponent codepath doesn't resolve outer props either.
            Component.defaultProps === undefined) {
                var resolvedType = type;
                resolvedType = resolveFunctionForHotReloading(type);
                // and with only the default shallow comparison, we upgrade it
                // to a SimpleMemoComponent to allow fast path updates.
                workInProgress.tag = SimpleMemoComponent;
                workInProgress.type = resolvedType;
                validateFunctionComponentInDev(workInProgress, type);
                return updateSimpleMemoComponent(current, workInProgress, resolvedType, nextProps, renderLanes);
            }
            var innerPropTypes = type.propTypes;
            if (innerPropTypes) // Inner memo component props aren't currently validated in createElement.
            // We could move it there, but we'd still need this for lazy code path.
            checkPropTypes(innerPropTypes, nextProps, "prop", getComponentNameFromType(type));
            var child = createFiberFromTypeAndProps(Component.type, null, nextProps, workInProgress, workInProgress.mode, renderLanes);
            child.ref = workInProgress.ref;
            child.return = workInProgress;
            workInProgress.child = child;
            return child;
        }
        var _type = Component.type;
        var _innerPropTypes = _type.propTypes;
        if (_innerPropTypes) // Inner memo component props aren't currently validated in createElement.
        // We could move it there, but we'd still need this for lazy code path.
        checkPropTypes(_innerPropTypes, nextProps, "prop", getComponentNameFromType(_type));
        var currentChild = current.child; // This is always exactly one child
        var hasScheduledUpdateOrContext = checkScheduledUpdateOrContext(current, renderLanes);
        if (!hasScheduledUpdateOrContext) {
            // This will be the props with resolved defaultProps,
            // unlike current.memoizedProps which will be the unresolved ones.
            var prevProps = currentChild.memoizedProps; // Default to shallow comparison
            var compare = Component.compare;
            compare = compare !== null ? compare : shallowEqual;
            if (compare(prevProps, nextProps) && current.ref === workInProgress.ref) return bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
        } // React DevTools reads this flag.
        workInProgress.flags |= PerformedWork;
        var newChild = createWorkInProgress(currentChild, nextProps);
        newChild.ref = workInProgress.ref;
        newChild.return = workInProgress;
        workInProgress.child = newChild;
        return newChild;
    }
    function updateSimpleMemoComponent(current, workInProgress, Component, nextProps, renderLanes) {
        if (workInProgress.type !== workInProgress.elementType) {
            // Lazy component props can't be validated in createElement
            // because they're only guaranteed to be resolved here.
            var outerMemoType = workInProgress.elementType;
            if (outerMemoType.$$typeof === REACT_LAZY_TYPE) {
                // We warn when you define propTypes on lazy()
                // so let's just skip over it to find memo() outer wrapper.
                // Inner props for memo are validated later.
                var lazyComponent = outerMemoType;
                var payload = lazyComponent._payload;
                var init = lazyComponent._init;
                try {
                    outerMemoType = init(payload);
                } catch (x) {
                    outerMemoType = null;
                } // Inner propTypes will be validated in the function component path.
                var outerPropTypes = outerMemoType && outerMemoType.propTypes;
                if (outerPropTypes) checkPropTypes(outerPropTypes, nextProps, "prop", getComponentNameFromType(outerMemoType));
            }
        }
        if (current !== null) {
            var prevProps = current.memoizedProps;
            if (shallowEqual(prevProps, nextProps) && current.ref === workInProgress.ref && workInProgress.type === current.type) {
                didReceiveUpdate = false; // The props are shallowly equal. Reuse the previous props object, like we
                // would during a normal fiber bailout.
                //
                // We don't have strong guarantees that the props object is referentially
                // equal during updates where we can't bail out anyway — like if the props
                // are shallowly equal, but there's a local state or context update in the
                // same batch.
                //
                // However, as a principle, we should aim to make the behavior consistent
                // across different ways of memoizing a component. For example, React.memo
                // has a different internal Fiber layout if you pass a normal function
                // component (SimpleMemoComponent) versus if you pass a different type
                // like forwardRef (MemoComponent). But this is an implementation detail.
                // Wrapping a component in forwardRef (or React.lazy, etc) shouldn't
                // affect whether the props object is reused during a bailout.
                workInProgress.pendingProps = nextProps = prevProps;
                if (!checkScheduledUpdateOrContext(current, renderLanes)) {
                    // The pending lanes were cleared at the beginning of beginWork. We're
                    // about to bail out, but there might be other lanes that weren't
                    // included in the current render. Usually, the priority level of the
                    // remaining updates is accumulated during the evaluation of the
                    // component (i.e. when processing the update queue). But since since
                    // we're bailing out early *without* evaluating the component, we need
                    // to account for it here, too. Reset to the value of the current fiber.
                    // NOTE: This only applies to SimpleMemoComponent, not MemoComponent,
                    // because a MemoComponent fiber does not have hooks or an update queue;
                    // rather, it wraps around an inner component, which may or may not
                    // contains hooks.
                    // TODO: Move the reset at in beginWork out of the common path so that
                    // this is no longer necessary.
                    workInProgress.lanes = current.lanes;
                    return bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
                } else if ((current.flags & ForceUpdateForLegacySuspense) !== NoFlags) // This is a special case that only exists for legacy mode.
                // See https://github.com/facebook/react/pull/19216.
                didReceiveUpdate = true;
            }
        }
        return updateFunctionComponent(current, workInProgress, Component, nextProps, renderLanes);
    }
    function updateOffscreenComponent(current, workInProgress, renderLanes) {
        var nextProps = workInProgress.pendingProps;
        var nextChildren = nextProps.children;
        var prevState = current !== null ? current.memoizedState : null;
        if (nextProps.mode === "hidden" || enableLegacyHidden) {
            // Rendering a hidden tree.
            if ((workInProgress.mode & ConcurrentMode) === NoMode) {
                // In legacy sync mode, don't defer the subtree. Render it now.
                // TODO: Consider how Offscreen should work with transitions in the future
                var nextState = {
                    baseLanes: NoLanes,
                    cachePool: null,
                    transitions: null
                };
                workInProgress.memoizedState = nextState;
                pushRenderLanes(workInProgress, renderLanes);
            } else if (!includesSomeLane(renderLanes, OffscreenLane)) {
                var spawnedCachePool = null; // We're hidden, and we're not rendering at Offscreen. We will bail out
                // and resume this tree later.
                var nextBaseLanes;
                if (prevState !== null) {
                    var prevBaseLanes = prevState.baseLanes;
                    nextBaseLanes = mergeLanes(prevBaseLanes, renderLanes);
                } else nextBaseLanes = renderLanes;
                 // Schedule this fiber to re-render at offscreen priority. Then bailout.
                workInProgress.lanes = workInProgress.childLanes = laneToLanes(OffscreenLane);
                var _nextState = {
                    baseLanes: nextBaseLanes,
                    cachePool: spawnedCachePool,
                    transitions: null
                };
                workInProgress.memoizedState = _nextState;
                workInProgress.updateQueue = null;
                // to avoid a push/pop misalignment.
                pushRenderLanes(workInProgress, nextBaseLanes);
                return null;
            } else {
                // This is the second render. The surrounding visible content has already
                // committed. Now we resume rendering the hidden tree.
                // Rendering at offscreen, so we can clear the base lanes.
                var _nextState2 = {
                    baseLanes: NoLanes,
                    cachePool: null,
                    transitions: null
                };
                workInProgress.memoizedState = _nextState2; // Push the lanes that were skipped when we bailed out.
                var subtreeRenderLanes = prevState !== null ? prevState.baseLanes : renderLanes;
                pushRenderLanes(workInProgress, subtreeRenderLanes);
            }
        } else {
            // Rendering a visible tree.
            var _subtreeRenderLanes;
            if (prevState !== null) {
                // We're going from hidden -> visible.
                _subtreeRenderLanes = mergeLanes(prevState.baseLanes, renderLanes);
                workInProgress.memoizedState = null;
            } else // We weren't previously hidden, and we still aren't, so there's nothing
            // special to do. Need to push to the stack regardless, though, to avoid
            // a push/pop misalignment.
            _subtreeRenderLanes = renderLanes;
            pushRenderLanes(workInProgress, _subtreeRenderLanes);
        }
        reconcileChildren(current, workInProgress, nextChildren, renderLanes);
        return workInProgress.child;
    } // Note: These happen to have identical begin phases, for now. We shouldn't hold
    function updateFragment(current, workInProgress, renderLanes) {
        var nextChildren = workInProgress.pendingProps;
        reconcileChildren(current, workInProgress, nextChildren, renderLanes);
        return workInProgress.child;
    }
    function updateMode(current, workInProgress, renderLanes) {
        var nextChildren = workInProgress.pendingProps.children;
        reconcileChildren(current, workInProgress, nextChildren, renderLanes);
        return workInProgress.child;
    }
    function updateProfiler(current, workInProgress, renderLanes) {
        workInProgress.flags |= Update;
        // Reset effect durations for the next eventual effect phase.
        // These are reset during render to allow the DevTools commit hook a chance to read them,
        var stateNode = workInProgress.stateNode;
        stateNode.effectDuration = 0;
        stateNode.passiveEffectDuration = 0;
        var nextProps = workInProgress.pendingProps;
        var nextChildren = nextProps.children;
        reconcileChildren(current, workInProgress, nextChildren, renderLanes);
        return workInProgress.child;
    }
    function markRef(current, workInProgress) {
        var ref = workInProgress.ref;
        if (current === null && ref !== null || current !== null && current.ref !== ref) {
            // Schedule a Ref effect
            workInProgress.flags |= Ref;
            workInProgress.flags |= RefStatic;
        }
    }
    function updateFunctionComponent(current, workInProgress, Component, nextProps, renderLanes) {
        if (workInProgress.type !== workInProgress.elementType) {
            // Lazy component props can't be validated in createElement
            // because they're only guaranteed to be resolved here.
            var innerPropTypes = Component.propTypes;
            if (innerPropTypes) checkPropTypes(innerPropTypes, nextProps, "prop", getComponentNameFromType(Component));
        }
        var context;
        var unmaskedContext = getUnmaskedContext(workInProgress, Component, true);
        context = getMaskedContext(workInProgress, unmaskedContext);
        var nextChildren;
        var hasId;
        prepareToReadContext(workInProgress, renderLanes);
        markComponentRenderStarted(workInProgress);
        ReactCurrentOwner$1.current = workInProgress;
        setIsRendering(true);
        nextChildren = renderWithHooks(current, workInProgress, Component, nextProps, context, renderLanes);
        hasId = checkDidRenderIdHook();
        if (workInProgress.mode & StrictLegacyMode) {
            setIsStrictModeForDevtools(true);
            try {
                nextChildren = renderWithHooks(current, workInProgress, Component, nextProps, context, renderLanes);
                hasId = checkDidRenderIdHook();
            } finally{
                setIsStrictModeForDevtools(false);
            }
        }
        setIsRendering(false);
        markComponentRenderStopped();
        if (current !== null && !didReceiveUpdate) {
            bailoutHooks(current, workInProgress, renderLanes);
            return bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
        }
        if (getIsHydrating() && hasId) pushMaterializedTreeId(workInProgress);
         // React DevTools reads this flag.
        workInProgress.flags |= PerformedWork;
        reconcileChildren(current, workInProgress, nextChildren, renderLanes);
        return workInProgress.child;
    }
    function updateClassComponent(current, workInProgress, Component, nextProps, renderLanes) {
        // This is used by DevTools to force a boundary to error.
        switch(shouldError(workInProgress)){
            case false:
                var _instance = workInProgress.stateNode;
                var ctor = workInProgress.type; // TODO This way of resetting the error boundary state is a hack.
                // Is there a better way to do this?
                var tempInstance = new ctor(workInProgress.memoizedProps, _instance.context);
                var state = tempInstance.state;
                _instance.updater.enqueueSetState(_instance, state, null);
                break;
            case true:
                workInProgress.flags |= DidCapture;
                workInProgress.flags |= ShouldCapture; // eslint-disable-next-line react-internal/prod-error-codes
                var error$1 = new Error("Simulated error coming from DevTools");
                var lane = pickArbitraryLane(renderLanes);
                workInProgress.lanes = mergeLanes(workInProgress.lanes, lane); // Schedule the error boundary to re-render using updated state
                var update = createClassErrorUpdate(workInProgress, createCapturedValueAtFiber(error$1, workInProgress), lane);
                enqueueCapturedUpdate(workInProgress, update);
                break;
        }
        if (workInProgress.type !== workInProgress.elementType) {
            // Lazy component props can't be validated in createElement
            // because they're only guaranteed to be resolved here.
            var innerPropTypes = Component.propTypes;
            if (innerPropTypes) checkPropTypes(innerPropTypes, nextProps, "prop", getComponentNameFromType(Component));
        }
        // During mounting we don't know the child context yet as the instance doesn't exist.
        // We will invalidate the child context in finishClassComponent() right after rendering.
        var hasContext;
        if (isContextProvider(Component)) {
            hasContext = true;
            pushContextProvider(workInProgress);
        } else hasContext = false;
        prepareToReadContext(workInProgress, renderLanes);
        var instance = workInProgress.stateNode;
        var shouldUpdate;
        if (instance === null) {
            resetSuspendedCurrentOnMountInLegacyMode(current, workInProgress); // In the initial pass we might need to construct the instance.
            constructClassInstance(workInProgress, Component, nextProps);
            mountClassInstance(workInProgress, Component, nextProps, renderLanes);
            shouldUpdate = true;
        } else if (current === null) // In a resume, we'll already have an instance we can reuse.
        shouldUpdate = resumeMountClassInstance(workInProgress, Component, nextProps, renderLanes);
        else shouldUpdate = updateClassInstance(current, workInProgress, Component, nextProps, renderLanes);
        var nextUnitOfWork = finishClassComponent(current, workInProgress, Component, shouldUpdate, hasContext, renderLanes);
        var inst = workInProgress.stateNode;
        if (shouldUpdate && inst.props !== nextProps) {
            if (!didWarnAboutReassigningProps) error("It looks like %s is reassigning its own `this.props` while rendering. This is not supported and can lead to confusing bugs.", getComponentNameFromFiber(workInProgress) || "a component");
            didWarnAboutReassigningProps = true;
        }
        return nextUnitOfWork;
    }
    function finishClassComponent(current, workInProgress, Component, shouldUpdate, hasContext, renderLanes) {
        // Refs should update even if shouldComponentUpdate returns false
        markRef(current, workInProgress);
        var didCaptureError = (workInProgress.flags & DidCapture) !== NoFlags;
        if (!shouldUpdate && !didCaptureError) {
            // Context providers should defer to sCU for rendering
            if (hasContext) invalidateContextProvider(workInProgress, Component, false);
            return bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
        }
        var instance = workInProgress.stateNode; // Rerender
        ReactCurrentOwner$1.current = workInProgress;
        var nextChildren;
        if (didCaptureError && typeof Component.getDerivedStateFromError !== "function") {
            // If we captured an error, but getDerivedStateFromError is not defined,
            // unmount all the children. componentDidCatch will schedule an update to
            // re-render a fallback. This is temporary until we migrate everyone to
            // the new API.
            // TODO: Warn in a future release.
            nextChildren = null;
            stopProfilerTimerIfRunning();
        } else {
            markComponentRenderStarted(workInProgress);
            setIsRendering(true);
            nextChildren = instance.render();
            if (workInProgress.mode & StrictLegacyMode) {
                setIsStrictModeForDevtools(true);
                try {
                    instance.render();
                } finally{
                    setIsStrictModeForDevtools(false);
                }
            }
            setIsRendering(false);
            markComponentRenderStopped();
        } // React DevTools reads this flag.
        workInProgress.flags |= PerformedWork;
        if (current !== null && didCaptureError) // If we're recovering from an error, reconcile without reusing any of
        // the existing children. Conceptually, the normal children and the children
        // that are shown on error are two different sets, so we shouldn't reuse
        // normal children even if their identities match.
        forceUnmountCurrentAndReconcile(current, workInProgress, nextChildren, renderLanes);
        else reconcileChildren(current, workInProgress, nextChildren, renderLanes);
         // Memoize state using the values we just used to render.
        // TODO: Restructure so we never read values from the instance.
        workInProgress.memoizedState = instance.state; // The context might have changed so we need to recalculate it.
        if (hasContext) invalidateContextProvider(workInProgress, Component, true);
        return workInProgress.child;
    }
    function pushHostRootContext(workInProgress) {
        var root = workInProgress.stateNode;
        if (root.pendingContext) pushTopLevelContextObject(workInProgress, root.pendingContext, root.pendingContext !== root.context);
        else if (root.context) // Should always be set
        pushTopLevelContextObject(workInProgress, root.context, false);
        pushHostContainer(workInProgress, root.containerInfo);
    }
    function updateHostRoot(current, workInProgress, renderLanes) {
        pushHostRootContext(workInProgress);
        if (current === null) throw new Error("Should have a current fiber. This is a bug in React.");
        var nextProps = workInProgress.pendingProps;
        var prevState = workInProgress.memoizedState;
        var prevChildren = prevState.element;
        cloneUpdateQueue(current, workInProgress);
        processUpdateQueue(workInProgress, nextProps, null, renderLanes);
        var nextState = workInProgress.memoizedState;
        var root = workInProgress.stateNode;
        // being called "element".
        var nextChildren = nextState.element;
        if (prevState.isDehydrated) {
            // This is a hydration root whose shell has not yet hydrated. We should
            // attempt to hydrate.
            // Flip isDehydrated to false to indicate that when this render
            // finishes, the root will no longer be dehydrated.
            var overrideState = {
                element: nextChildren,
                isDehydrated: false,
                cache: nextState.cache,
                pendingSuspenseBoundaries: nextState.pendingSuspenseBoundaries,
                transitions: nextState.transitions
            };
            var updateQueue = workInProgress.updateQueue; // `baseState` can always be the last state because the root doesn't
            // have reducer functions so it doesn't need rebasing.
            updateQueue.baseState = overrideState;
            workInProgress.memoizedState = overrideState;
            if (workInProgress.flags & ForceClientRender) {
                // Something errored during a previous attempt to hydrate the shell, so we
                // forced a client render.
                var recoverableError = createCapturedValueAtFiber(new Error("There was an error while hydrating. Because the error happened outside of a Suspense boundary, the entire root will switch to client rendering."), workInProgress);
                return mountHostRootWithoutHydrating(current, workInProgress, nextChildren, renderLanes, recoverableError);
            } else if (nextChildren !== prevChildren) {
                var _recoverableError = createCapturedValueAtFiber(new Error("This root received an early update, before anything was able hydrate. Switched the entire root to client rendering."), workInProgress);
                return mountHostRootWithoutHydrating(current, workInProgress, nextChildren, renderLanes, _recoverableError);
            } else {
                // The outermost shell has not hydrated yet. Start hydrating.
                enterHydrationState(workInProgress);
                var child = mountChildFibers(workInProgress, null, nextChildren, renderLanes);
                workInProgress.child = child;
                var node = child;
                while(node){
                    // Mark each child as hydrating. This is a fast path to know whether this
                    // tree is part of a hydrating tree. This is used to determine if a child
                    // node has fully mounted yet, and for scheduling event replaying.
                    // Conceptually this is similar to Placement in that a new subtree is
                    // inserted into the React tree here. It just happens to not need DOM
                    // mutations because it already exists.
                    node.flags = node.flags & ~Placement | Hydrating;
                    node = node.sibling;
                }
            }
        } else {
            // Root is not dehydrated. Either this is a client-only root, or it
            // already hydrated.
            resetHydrationState();
            if (nextChildren === prevChildren) return bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
            reconcileChildren(current, workInProgress, nextChildren, renderLanes);
        }
        return workInProgress.child;
    }
    function mountHostRootWithoutHydrating(current, workInProgress, nextChildren, renderLanes, recoverableError) {
        // Revert to client rendering.
        resetHydrationState();
        queueHydrationError(recoverableError);
        workInProgress.flags |= ForceClientRender;
        reconcileChildren(current, workInProgress, nextChildren, renderLanes);
        return workInProgress.child;
    }
    function updateHostComponent(current, workInProgress, renderLanes) {
        pushHostContext(workInProgress);
        if (current === null) tryToClaimNextHydratableInstance(workInProgress);
        var type = workInProgress.type;
        var nextProps = workInProgress.pendingProps;
        var prevProps = current !== null ? current.memoizedProps : null;
        var nextChildren = nextProps.children;
        var isDirectTextChild = shouldSetTextContent(type, nextProps);
        if (isDirectTextChild) // We special case a direct text child of a host node. This is a common
        // case. We won't handle it as a reified child. We will instead handle
        // this in the host environment that also has access to this prop. That
        // avoids allocating another HostText fiber and traversing it.
        nextChildren = null;
        else if (prevProps !== null && shouldSetTextContent(type, prevProps)) // If we're switching from a direct text child to a normal child, or to
        // empty, we need to schedule the text content to be reset.
        workInProgress.flags |= ContentReset;
        markRef(current, workInProgress);
        reconcileChildren(current, workInProgress, nextChildren, renderLanes);
        return workInProgress.child;
    }
    function updateHostText(current, workInProgress) {
        if (current === null) tryToClaimNextHydratableInstance(workInProgress);
         // Nothing to do here. This is terminal. We'll do the completion step
        // immediately after.
        return null;
    }
    function mountLazyComponent(_current, workInProgress, elementType, renderLanes) {
        resetSuspendedCurrentOnMountInLegacyMode(_current, workInProgress);
        var props = workInProgress.pendingProps;
        var lazyComponent = elementType;
        var payload = lazyComponent._payload;
        var init = lazyComponent._init;
        var Component = init(payload); // Store the unwrapped component in the type.
        workInProgress.type = Component;
        var resolvedTag = workInProgress.tag = resolveLazyComponentTag(Component);
        var resolvedProps = resolveDefaultProps(Component, props);
        var child;
        switch(resolvedTag){
            case FunctionComponent:
                validateFunctionComponentInDev(workInProgress, Component);
                workInProgress.type = Component = resolveFunctionForHotReloading(Component);
                child = updateFunctionComponent(null, workInProgress, Component, resolvedProps, renderLanes);
                return child;
            case ClassComponent:
                workInProgress.type = Component = resolveClassForHotReloading(Component);
                child = updateClassComponent(null, workInProgress, Component, resolvedProps, renderLanes);
                return child;
            case ForwardRef:
                workInProgress.type = Component = resolveForwardRefForHotReloading(Component);
                child = updateForwardRef(null, workInProgress, Component, resolvedProps, renderLanes);
                return child;
            case MemoComponent:
                if (workInProgress.type !== workInProgress.elementType) {
                    var outerPropTypes = Component.propTypes;
                    if (outerPropTypes) checkPropTypes(outerPropTypes, resolvedProps, "prop", getComponentNameFromType(Component));
                }
                child = updateMemoComponent(null, workInProgress, Component, resolveDefaultProps(Component.type, resolvedProps), renderLanes);
                return child;
        }
        var hint = "";
        if (Component !== null && typeof Component === "object" && Component.$$typeof === REACT_LAZY_TYPE) hint = " Did you wrap a component in React.lazy() more than once?";
        // because the fact that it's a separate type of work is an
        // implementation detail.
        throw new Error("Element type is invalid. Received a promise that resolves to: " + Component + ". " + ("Lazy element type must resolve to a class or function." + hint));
    }
    function mountIncompleteClassComponent(_current, workInProgress, Component, nextProps, renderLanes) {
        resetSuspendedCurrentOnMountInLegacyMode(_current, workInProgress); // Promote the fiber to a class and try rendering again.
        workInProgress.tag = ClassComponent; // The rest of this function is a fork of `updateClassComponent`
        // Push context providers early to prevent context stack mismatches.
        // During mounting we don't know the child context yet as the instance doesn't exist.
        // We will invalidate the child context in finishClassComponent() right after rendering.
        var hasContext;
        if (isContextProvider(Component)) {
            hasContext = true;
            pushContextProvider(workInProgress);
        } else hasContext = false;
        prepareToReadContext(workInProgress, renderLanes);
        constructClassInstance(workInProgress, Component, nextProps);
        mountClassInstance(workInProgress, Component, nextProps, renderLanes);
        return finishClassComponent(null, workInProgress, Component, true, hasContext, renderLanes);
    }
    function mountIndeterminateComponent(_current, workInProgress, Component, renderLanes) {
        resetSuspendedCurrentOnMountInLegacyMode(_current, workInProgress);
        var props = workInProgress.pendingProps;
        var context;
        var unmaskedContext = getUnmaskedContext(workInProgress, Component, false);
        context = getMaskedContext(workInProgress, unmaskedContext);
        prepareToReadContext(workInProgress, renderLanes);
        var value;
        var hasId;
        markComponentRenderStarted(workInProgress);
        if (Component.prototype && typeof Component.prototype.render === "function") {
            var componentName = getComponentNameFromType(Component) || "Unknown";
            if (!didWarnAboutBadClass[componentName]) {
                error("The <%s /> component appears to have a render method, but doesn't extend React.Component. This is likely to cause errors. Change %s to extend React.Component instead.", componentName, componentName);
                didWarnAboutBadClass[componentName] = true;
            }
        }
        if (workInProgress.mode & StrictLegacyMode) ReactStrictModeWarnings.recordLegacyContextWarning(workInProgress, null);
        setIsRendering(true);
        ReactCurrentOwner$1.current = workInProgress;
        value = renderWithHooks(null, workInProgress, Component, props, context, renderLanes);
        hasId = checkDidRenderIdHook();
        setIsRendering(false);
        markComponentRenderStopped();
        workInProgress.flags |= PerformedWork;
        // Support for module components is deprecated and is removed behind a flag.
        // Whether or not it would crash later, we want to show a good message in DEV first.
        if (typeof value === "object" && value !== null && typeof value.render === "function" && value.$$typeof === undefined) {
            var _componentName = getComponentNameFromType(Component) || "Unknown";
            if (!didWarnAboutModulePatternComponent[_componentName]) {
                error("The <%s /> component appears to be a function component that returns a class instance. Change %s to a class that extends React.Component instead. If you can't use a class try assigning the prototype on the function as a workaround. `%s.prototype = React.Component.prototype`. Don't use an arrow function since it cannot be called with `new` by React.", _componentName, _componentName, _componentName);
                didWarnAboutModulePatternComponent[_componentName] = true;
            }
        }
        if (// Eventually we'll delete this branch altogether.
        typeof value === "object" && value !== null && typeof value.render === "function" && value.$$typeof === undefined) {
            var _componentName2 = getComponentNameFromType(Component) || "Unknown";
            if (!didWarnAboutModulePatternComponent[_componentName2]) {
                error("The <%s /> component appears to be a function component that returns a class instance. Change %s to a class that extends React.Component instead. If you can't use a class try assigning the prototype on the function as a workaround. `%s.prototype = React.Component.prototype`. Don't use an arrow function since it cannot be called with `new` by React.", _componentName2, _componentName2, _componentName2);
                didWarnAboutModulePatternComponent[_componentName2] = true;
            }
            workInProgress.tag = ClassComponent; // Throw out any hooks that were used.
            workInProgress.memoizedState = null;
            workInProgress.updateQueue = null; // Push context providers early to prevent context stack mismatches.
            // During mounting we don't know the child context yet as the instance doesn't exist.
            // We will invalidate the child context in finishClassComponent() right after rendering.
            var hasContext = false;
            if (isContextProvider(Component)) {
                hasContext = true;
                pushContextProvider(workInProgress);
            } else hasContext = false;
            workInProgress.memoizedState = value.state !== null && value.state !== undefined ? value.state : null;
            initializeUpdateQueue(workInProgress);
            adoptClassInstance(workInProgress, value);
            mountClassInstance(workInProgress, Component, props, renderLanes);
            return finishClassComponent(null, workInProgress, Component, true, hasContext, renderLanes);
        } else {
            // Proceed under the assumption that this is a function component
            workInProgress.tag = FunctionComponent;
            if (workInProgress.mode & StrictLegacyMode) {
                setIsStrictModeForDevtools(true);
                try {
                    value = renderWithHooks(null, workInProgress, Component, props, context, renderLanes);
                    hasId = checkDidRenderIdHook();
                } finally{
                    setIsStrictModeForDevtools(false);
                }
            }
            if (getIsHydrating() && hasId) pushMaterializedTreeId(workInProgress);
            reconcileChildren(null, workInProgress, value, renderLanes);
            validateFunctionComponentInDev(workInProgress, Component);
            return workInProgress.child;
        }
    }
    function validateFunctionComponentInDev(workInProgress, Component) {
        if (Component) {
            if (Component.childContextTypes) error("%s(...): childContextTypes cannot be defined on a function component.", Component.displayName || Component.name || "Component");
        }
        if (workInProgress.ref !== null) {
            var info = "";
            var ownerName = getCurrentFiberOwnerNameInDevOrNull();
            if (ownerName) info += "\n\nCheck the render method of `" + ownerName + "`.";
            var warningKey = ownerName || "";
            var debugSource = workInProgress._debugSource;
            if (debugSource) warningKey = debugSource.fileName + ":" + debugSource.lineNumber;
            if (!didWarnAboutFunctionRefs[warningKey]) {
                didWarnAboutFunctionRefs[warningKey] = true;
                error("Function components cannot be given refs. Attempts to access this ref will fail. Did you mean to use React.forwardRef()?%s", info);
            }
        }
        if (typeof Component.getDerivedStateFromProps === "function") {
            var _componentName3 = getComponentNameFromType(Component) || "Unknown";
            if (!didWarnAboutGetDerivedStateOnFunctionComponent[_componentName3]) {
                error("%s: Function components do not support getDerivedStateFromProps.", _componentName3);
                didWarnAboutGetDerivedStateOnFunctionComponent[_componentName3] = true;
            }
        }
        if (typeof Component.contextType === "object" && Component.contextType !== null) {
            var _componentName4 = getComponentNameFromType(Component) || "Unknown";
            if (!didWarnAboutContextTypeOnFunctionComponent[_componentName4]) {
                error("%s: Function components do not support contextType.", _componentName4);
                didWarnAboutContextTypeOnFunctionComponent[_componentName4] = true;
            }
        }
    }
    var SUSPENDED_MARKER = {
        dehydrated: null,
        treeContext: null,
        retryLane: NoLane
    };
    function mountSuspenseOffscreenState(renderLanes) {
        return {
            baseLanes: renderLanes,
            cachePool: getSuspendedCache(),
            transitions: null
        };
    }
    function updateSuspenseOffscreenState(prevOffscreenState, renderLanes) {
        var cachePool = null;
        return {
            baseLanes: mergeLanes(prevOffscreenState.baseLanes, renderLanes),
            cachePool: cachePool,
            transitions: prevOffscreenState.transitions
        };
    } // TODO: Probably should inline this back
    function shouldRemainOnFallback(suspenseContext, current, workInProgress, renderLanes) {
        // If we're already showing a fallback, there are cases where we need to
        // remain on that fallback regardless of whether the content has resolved.
        // For example, SuspenseList coordinates when nested content appears.
        if (current !== null) {
            var suspenseState = current.memoizedState;
            if (suspenseState === null) // Currently showing content. Don't hide it, even if ForceSuspenseFallback
            // is true. More precise name might be "ForceRemainSuspenseFallback".
            // Note: This is a factoring smell. Can't remain on a fallback if there's
            // no fallback to remain on.
            return false;
        } // Not currently showing content. Consult the Suspense context.
        return hasSuspenseContext(suspenseContext, ForceSuspenseFallback);
    }
    function getRemainingWorkInPrimaryTree(current, renderLanes) {
        // TODO: Should not remove render lanes that were pinged during this render
        return removeLanes(current.childLanes, renderLanes);
    }
    function updateSuspenseComponent(current, workInProgress, renderLanes) {
        var nextProps = workInProgress.pendingProps; // This is used by DevTools to force a boundary to suspend.
        if (shouldSuspend(workInProgress)) workInProgress.flags |= DidCapture;
        var suspenseContext = suspenseStackCursor.current;
        var showFallback = false;
        var didSuspend = (workInProgress.flags & DidCapture) !== NoFlags;
        if (didSuspend || shouldRemainOnFallback(suspenseContext, current)) {
            // Something in this boundary's subtree already suspended. Switch to
            // rendering the fallback children.
            showFallback = true;
            workInProgress.flags &= ~DidCapture;
        } else // Attempting the main content
        if (current === null || current.memoizedState !== null) suspenseContext = addSubtreeSuspenseContext(suspenseContext, InvisibleParentSuspenseContext);
        suspenseContext = setDefaultShallowSuspenseContext(suspenseContext);
        pushSuspenseContext(workInProgress, suspenseContext); // OK, the next part is confusing. We're about to reconcile the Suspense
        // boundary's children. This involves some custom reconciliation logic. Two
        // main reasons this is so complicated.
        //
        // First, Legacy Mode has different semantics for backwards compatibility. The
        // primary tree will commit in an inconsistent state, so when we do the
        // second pass to render the fallback, we do some exceedingly, uh, clever
        // hacks to make that not totally break. Like transferring effects and
        // deletions from hidden tree. In Concurrent Mode, it's much simpler,
        // because we bailout on the primary tree completely and leave it in its old
        // state, no effects. Same as what we do for Offscreen (except that
        // Offscreen doesn't have the first render pass).
        //
        // Second is hydration. During hydration, the Suspense fiber has a slightly
        // different layout, where the child points to a dehydrated fragment, which
        // contains the DOM rendered by the server.
        //
        // Third, even if you set all that aside, Suspense is like error boundaries in
        // that we first we try to render one tree, and if that fails, we render again
        // and switch to a different tree. Like a try/catch block. So we have to track
        // which branch we're currently rendering. Ideally we would model this using
        // a stack.
        if (current === null) {
            // Initial mount
            // Special path for hydration
            // If we're currently hydrating, try to hydrate this boundary.
            tryToClaimNextHydratableInstance(workInProgress); // This could've been a dehydrated suspense component.
            var suspenseState = workInProgress.memoizedState;
            if (suspenseState !== null) {
                var dehydrated = suspenseState.dehydrated;
                if (dehydrated !== null) return mountDehydratedSuspenseComponent(workInProgress, dehydrated);
            }
            var nextPrimaryChildren = nextProps.children;
            var nextFallbackChildren = nextProps.fallback;
            if (showFallback) {
                var fallbackFragment = mountSuspenseFallbackChildren(workInProgress, nextPrimaryChildren, nextFallbackChildren, renderLanes);
                var primaryChildFragment = workInProgress.child;
                primaryChildFragment.memoizedState = mountSuspenseOffscreenState(renderLanes);
                workInProgress.memoizedState = SUSPENDED_MARKER;
                return fallbackFragment;
            } else return mountSuspensePrimaryChildren(workInProgress, nextPrimaryChildren);
        } else {
            // This is an update.
            // Special path for hydration
            var prevState = current.memoizedState;
            if (prevState !== null) {
                var _dehydrated = prevState.dehydrated;
                if (_dehydrated !== null) return updateDehydratedSuspenseComponent(current, workInProgress, didSuspend, nextProps, _dehydrated, prevState, renderLanes);
            }
            if (showFallback) {
                var _nextFallbackChildren = nextProps.fallback;
                var _nextPrimaryChildren = nextProps.children;
                var fallbackChildFragment = updateSuspenseFallbackChildren(current, workInProgress, _nextPrimaryChildren, _nextFallbackChildren, renderLanes);
                var _primaryChildFragment2 = workInProgress.child;
                var prevOffscreenState = current.child.memoizedState;
                _primaryChildFragment2.memoizedState = prevOffscreenState === null ? mountSuspenseOffscreenState(renderLanes) : updateSuspenseOffscreenState(prevOffscreenState, renderLanes);
                _primaryChildFragment2.childLanes = getRemainingWorkInPrimaryTree(current, renderLanes);
                workInProgress.memoizedState = SUSPENDED_MARKER;
                return fallbackChildFragment;
            } else {
                var _nextPrimaryChildren2 = nextProps.children;
                var _primaryChildFragment3 = updateSuspensePrimaryChildren(current, workInProgress, _nextPrimaryChildren2, renderLanes);
                workInProgress.memoizedState = null;
                return _primaryChildFragment3;
            }
        }
    }
    function mountSuspensePrimaryChildren(workInProgress, primaryChildren, renderLanes) {
        var mode = workInProgress.mode;
        var primaryChildProps = {
            mode: "visible",
            children: primaryChildren
        };
        var primaryChildFragment = mountWorkInProgressOffscreenFiber(primaryChildProps, mode);
        primaryChildFragment.return = workInProgress;
        workInProgress.child = primaryChildFragment;
        return primaryChildFragment;
    }
    function mountSuspenseFallbackChildren(workInProgress, primaryChildren, fallbackChildren, renderLanes) {
        var mode = workInProgress.mode;
        var progressedPrimaryFragment = workInProgress.child;
        var primaryChildProps = {
            mode: "hidden",
            children: primaryChildren
        };
        var primaryChildFragment;
        var fallbackChildFragment;
        if ((mode & ConcurrentMode) === NoMode && progressedPrimaryFragment !== null) {
            // In legacy mode, we commit the primary tree as if it successfully
            // completed, even though it's in an inconsistent state.
            primaryChildFragment = progressedPrimaryFragment;
            primaryChildFragment.childLanes = NoLanes;
            primaryChildFragment.pendingProps = primaryChildProps;
            if (workInProgress.mode & ProfileMode) {
                // Reset the durations from the first pass so they aren't included in the
                // final amounts. This seems counterintuitive, since we're intentionally
                // not measuring part of the render phase, but this makes it match what we
                // do in Concurrent Mode.
                primaryChildFragment.actualDuration = 0;
                primaryChildFragment.actualStartTime = -1;
                primaryChildFragment.selfBaseDuration = 0;
                primaryChildFragment.treeBaseDuration = 0;
            }
            fallbackChildFragment = createFiberFromFragment(fallbackChildren, mode, renderLanes, null);
        } else {
            primaryChildFragment = mountWorkInProgressOffscreenFiber(primaryChildProps, mode);
            fallbackChildFragment = createFiberFromFragment(fallbackChildren, mode, renderLanes, null);
        }
        primaryChildFragment.return = workInProgress;
        fallbackChildFragment.return = workInProgress;
        primaryChildFragment.sibling = fallbackChildFragment;
        workInProgress.child = primaryChildFragment;
        return fallbackChildFragment;
    }
    function mountWorkInProgressOffscreenFiber(offscreenProps, mode, renderLanes) {
        // The props argument to `createFiberFromOffscreen` is `any` typed, so we use
        // this wrapper function to constrain it.
        return createFiberFromOffscreen(offscreenProps, mode, NoLanes, null);
    }
    function updateWorkInProgressOffscreenFiber(current, offscreenProps) {
        // The props argument to `createWorkInProgress` is `any` typed, so we use this
        // wrapper function to constrain it.
        return createWorkInProgress(current, offscreenProps);
    }
    function updateSuspensePrimaryChildren(current, workInProgress, primaryChildren, renderLanes) {
        var currentPrimaryChildFragment = current.child;
        var currentFallbackChildFragment = currentPrimaryChildFragment.sibling;
        var primaryChildFragment = updateWorkInProgressOffscreenFiber(currentPrimaryChildFragment, {
            mode: "visible",
            children: primaryChildren
        });
        if ((workInProgress.mode & ConcurrentMode) === NoMode) primaryChildFragment.lanes = renderLanes;
        primaryChildFragment.return = workInProgress;
        primaryChildFragment.sibling = null;
        if (currentFallbackChildFragment !== null) {
            // Delete the fallback child fragment
            var deletions = workInProgress.deletions;
            if (deletions === null) {
                workInProgress.deletions = [
                    currentFallbackChildFragment
                ];
                workInProgress.flags |= ChildDeletion;
            } else deletions.push(currentFallbackChildFragment);
        }
        workInProgress.child = primaryChildFragment;
        return primaryChildFragment;
    }
    function updateSuspenseFallbackChildren(current, workInProgress, primaryChildren, fallbackChildren, renderLanes) {
        var mode = workInProgress.mode;
        var currentPrimaryChildFragment = current.child;
        var currentFallbackChildFragment = currentPrimaryChildFragment.sibling;
        var primaryChildProps = {
            mode: "hidden",
            children: primaryChildren
        };
        var primaryChildFragment;
        if (// completed, even though it's in an inconsistent state.
        (mode & ConcurrentMode) === NoMode && // Make sure we're on the second pass, i.e. the primary child fragment was
        // already cloned. In legacy mode, the only case where this isn't true is
        // when DevTools forces us to display a fallback; we skip the first render
        // pass entirely and go straight to rendering the fallback. (In Concurrent
        // Mode, SuspenseList can also trigger this scenario, but this is a legacy-
        // only codepath.)
        workInProgress.child !== currentPrimaryChildFragment) {
            var progressedPrimaryFragment = workInProgress.child;
            primaryChildFragment = progressedPrimaryFragment;
            primaryChildFragment.childLanes = NoLanes;
            primaryChildFragment.pendingProps = primaryChildProps;
            if (workInProgress.mode & ProfileMode) {
                // Reset the durations from the first pass so they aren't included in the
                // final amounts. This seems counterintuitive, since we're intentionally
                // not measuring part of the render phase, but this makes it match what we
                // do in Concurrent Mode.
                primaryChildFragment.actualDuration = 0;
                primaryChildFragment.actualStartTime = -1;
                primaryChildFragment.selfBaseDuration = currentPrimaryChildFragment.selfBaseDuration;
                primaryChildFragment.treeBaseDuration = currentPrimaryChildFragment.treeBaseDuration;
            } // The fallback fiber was added as a deletion during the first pass.
            // However, since we're going to remain on the fallback, we no longer want
            // to delete it.
            workInProgress.deletions = null;
        } else {
            primaryChildFragment = updateWorkInProgressOffscreenFiber(currentPrimaryChildFragment, primaryChildProps); // Since we're reusing a current tree, we need to reuse the flags, too.
            // (We don't do this in legacy mode, because in legacy mode we don't re-use
            // the current tree; see previous branch.)
            primaryChildFragment.subtreeFlags = currentPrimaryChildFragment.subtreeFlags & StaticMask;
        }
        var fallbackChildFragment;
        if (currentFallbackChildFragment !== null) fallbackChildFragment = createWorkInProgress(currentFallbackChildFragment, fallbackChildren);
        else {
            fallbackChildFragment = createFiberFromFragment(fallbackChildren, mode, renderLanes, null); // Needs a placement effect because the parent (the Suspense boundary) already
            // mounted but this is a new fiber.
            fallbackChildFragment.flags |= Placement;
        }
        fallbackChildFragment.return = workInProgress;
        primaryChildFragment.return = workInProgress;
        primaryChildFragment.sibling = fallbackChildFragment;
        workInProgress.child = primaryChildFragment;
        return fallbackChildFragment;
    }
    function retrySuspenseComponentWithoutHydrating(current, workInProgress, renderLanes, recoverableError) {
        // Falling back to client rendering. Because this has performance
        // implications, it's considered a recoverable error, even though the user
        // likely won't observe anything wrong with the UI.
        //
        // The error is passed in as an argument to enforce that every caller provide
        // a custom message, or explicitly opt out (currently the only path that opts
        // out is legacy mode; every concurrent path provides an error).
        if (recoverableError !== null) queueHydrationError(recoverableError);
         // This will add the old fiber to the deletion list
        reconcileChildFibers(workInProgress, current.child, null, renderLanes); // We're now not suspended nor dehydrated.
        var nextProps = workInProgress.pendingProps;
        var primaryChildren = nextProps.children;
        var primaryChildFragment = mountSuspensePrimaryChildren(workInProgress, primaryChildren); // Needs a placement effect because the parent (the Suspense boundary) already
        // mounted but this is a new fiber.
        primaryChildFragment.flags |= Placement;
        workInProgress.memoizedState = null;
        return primaryChildFragment;
    }
    function mountSuspenseFallbackAfterRetryWithoutHydrating(current, workInProgress, primaryChildren, fallbackChildren, renderLanes) {
        var fiberMode = workInProgress.mode;
        var primaryChildProps = {
            mode: "visible",
            children: primaryChildren
        };
        var primaryChildFragment = mountWorkInProgressOffscreenFiber(primaryChildProps, fiberMode);
        var fallbackChildFragment = createFiberFromFragment(fallbackChildren, fiberMode, renderLanes, null); // Needs a placement effect because the parent (the Suspense
        // boundary) already mounted but this is a new fiber.
        fallbackChildFragment.flags |= Placement;
        primaryChildFragment.return = workInProgress;
        fallbackChildFragment.return = workInProgress;
        primaryChildFragment.sibling = fallbackChildFragment;
        workInProgress.child = primaryChildFragment;
        if ((workInProgress.mode & ConcurrentMode) !== NoMode) // We will have dropped the effect list which contains the
        // deletion. We need to reconcile to delete the current child.
        reconcileChildFibers(workInProgress, current.child, null, renderLanes);
        return fallbackChildFragment;
    }
    function mountDehydratedSuspenseComponent(workInProgress, suspenseInstance, renderLanes) {
        // During the first pass, we'll bail out and not drill into the children.
        // Instead, we'll leave the content in place and try to hydrate it later.
        if ((workInProgress.mode & ConcurrentMode) === NoMode) {
            error("Cannot hydrate Suspense in legacy mode. Switch from ReactDOM.hydrate(element, container) to ReactDOMClient.hydrateRoot(container, <App />).render(element) or remove the Suspense components from the server rendered components.");
            workInProgress.lanes = laneToLanes(SyncLane);
        } else if (isSuspenseInstanceFallback(suspenseInstance)) // This is a client-only boundary. Since we won't get any content from the server
        // for this, we need to schedule that at a higher priority based on when it would
        // have timed out. In theory we could render it in this pass but it would have the
        // wrong priority associated with it and will prevent hydration of parent path.
        // Instead, we'll leave work left on it to render it in a separate commit.
        // TODO This time should be the time at which the server rendered response that is
        // a parent to this boundary was displayed. However, since we currently don't have
        // a protocol to transfer that time, we'll just estimate it by using the current
        // time. This will mean that Suspense timeouts are slightly shifted to later than
        // they should be.
        // Schedule a normal pri update to render this content.
        workInProgress.lanes = laneToLanes(DefaultHydrationLane);
        else // We'll continue hydrating the rest at offscreen priority since we'll already
        // be showing the right content coming from the server, it is no rush.
        workInProgress.lanes = laneToLanes(OffscreenLane);
        return null;
    }
    function updateDehydratedSuspenseComponent(current, workInProgress, didSuspend, nextProps, suspenseInstance, suspenseState, renderLanes) {
        if (!didSuspend) {
            // This is the first render pass. Attempt to hydrate.
            // We should never be hydrating at this point because it is the first pass,
            // but after we've already committed once.
            warnIfHydrating();
            if ((workInProgress.mode & ConcurrentMode) === NoMode) return retrySuspenseComponentWithoutHydrating(current, workInProgress, renderLanes, // required — every concurrent mode path that causes hydration to
            // de-opt to client rendering should have an error message.
            null);
            if (isSuspenseInstanceFallback(suspenseInstance)) {
                // This boundary is in a permanent fallback state. In this case, we'll never
                // get an update and we'll never be able to hydrate the final content. Let's just try the
                // client side render instead.
                var digest, message, stack;
                var _getSuspenseInstanceF = getSuspenseInstanceFallbackErrorDetails(suspenseInstance);
                digest = _getSuspenseInstanceF.digest;
                message = _getSuspenseInstanceF.message;
                stack = _getSuspenseInstanceF.stack;
                var error;
                if (message) // eslint-disable-next-line react-internal/prod-error-codes
                error = new Error(message);
                else error = new Error("The server could not finish this Suspense boundary, likely due to an error during server rendering. Switched to client rendering.");
                var capturedValue = createCapturedValue(error, digest, stack);
                return retrySuspenseComponentWithoutHydrating(current, workInProgress, renderLanes, capturedValue);
            }
            // any context has changed, we need to treat is as if the input might have changed.
            var hasContextChanged = includesSomeLane(renderLanes, current.childLanes);
            if (didReceiveUpdate || hasContextChanged) {
                // This boundary has changed since the first render. This means that we are now unable to
                // hydrate it. We might still be able to hydrate it using a higher priority lane.
                var root = getWorkInProgressRoot();
                if (root !== null) {
                    var attemptHydrationAtLane = getBumpedLaneForHydration(root, renderLanes);
                    if (attemptHydrationAtLane !== NoLane && attemptHydrationAtLane !== suspenseState.retryLane) {
                        // Intentionally mutating since this render will get interrupted. This
                        // is one of the very rare times where we mutate the current tree
                        // during the render phase.
                        suspenseState.retryLane = attemptHydrationAtLane; // TODO: Ideally this would inherit the event time of the current render
                        var eventTime = NoTimestamp;
                        enqueueConcurrentRenderForLane(current, attemptHydrationAtLane);
                        scheduleUpdateOnFiber(root, current, attemptHydrationAtLane, eventTime);
                    }
                } // If we have scheduled higher pri work above, this will probably just abort the render
                // since we now have higher priority work, but in case it doesn't, we need to prepare to
                // render something, if we time out. Even if that requires us to delete everything and
                // skip hydration.
                // Delay having to do this as long as the suspense timeout allows us.
                renderDidSuspendDelayIfPossible();
                var _capturedValue = createCapturedValue(new Error("This Suspense boundary received an update before it finished hydrating. This caused the boundary to switch to client rendering. The usual way to fix this is to wrap the original update in startTransition."));
                return retrySuspenseComponentWithoutHydrating(current, workInProgress, renderLanes, _capturedValue);
            } else if (isSuspenseInstancePending(suspenseInstance)) {
                // This component is still pending more data from the server, so we can't hydrate its
                // content. We treat it as if this component suspended itself. It might seem as if
                // we could just try to render it client-side instead. However, this will perform a
                // lot of unnecessary work and is unlikely to complete since it often will suspend
                // on missing data anyway. Additionally, the server might be able to render more
                // than we can on the client yet. In that case we'd end up with more fallback states
                // on the client than if we just leave it alone. If the server times out or errors
                // these should update this boundary to the permanent Fallback state instead.
                // Mark it as having captured (i.e. suspended).
                workInProgress.flags |= DidCapture; // Leave the child in place. I.e. the dehydrated fragment.
                workInProgress.child = current.child; // Register a callback to retry this boundary once the server has sent the result.
                var retry = retryDehydratedSuspenseBoundary.bind(null, current);
                registerSuspenseInstanceRetry(suspenseInstance, retry);
                return null;
            } else {
                // This is the first attempt.
                reenterHydrationStateFromDehydratedSuspenseInstance(workInProgress, suspenseInstance, suspenseState.treeContext);
                var primaryChildren = nextProps.children;
                var primaryChildFragment = mountSuspensePrimaryChildren(workInProgress, primaryChildren); // Mark the children as hydrating. This is a fast path to know whether this
                // tree is part of a hydrating tree. This is used to determine if a child
                // node has fully mounted yet, and for scheduling event replaying.
                // Conceptually this is similar to Placement in that a new subtree is
                // inserted into the React tree here. It just happens to not need DOM
                // mutations because it already exists.
                primaryChildFragment.flags |= Hydrating;
                return primaryChildFragment;
            }
        } else {
            // This is the second render pass. We already attempted to hydrated, but
            // something either suspended or errored.
            if (workInProgress.flags & ForceClientRender) {
                // Something errored during hydration. Try again without hydrating.
                workInProgress.flags &= ~ForceClientRender;
                var _capturedValue2 = createCapturedValue(new Error("There was an error while hydrating this Suspense boundary. Switched to client rendering."));
                return retrySuspenseComponentWithoutHydrating(current, workInProgress, renderLanes, _capturedValue2);
            } else if (workInProgress.memoizedState !== null) {
                // Something suspended and we should still be in dehydrated mode.
                // Leave the existing child in place.
                workInProgress.child = current.child; // The dehydrated completion pass expects this flag to be there
                // but the normal suspense pass doesn't.
                workInProgress.flags |= DidCapture;
                return null;
            } else {
                // Suspended but we should no longer be in dehydrated mode.
                // Therefore we now have to render the fallback.
                var nextPrimaryChildren = nextProps.children;
                var nextFallbackChildren = nextProps.fallback;
                var fallbackChildFragment = mountSuspenseFallbackAfterRetryWithoutHydrating(current, workInProgress, nextPrimaryChildren, nextFallbackChildren, renderLanes);
                var _primaryChildFragment4 = workInProgress.child;
                _primaryChildFragment4.memoizedState = mountSuspenseOffscreenState(renderLanes);
                workInProgress.memoizedState = SUSPENDED_MARKER;
                return fallbackChildFragment;
            }
        }
    }
    function scheduleSuspenseWorkOnFiber(fiber, renderLanes, propagationRoot) {
        fiber.lanes = mergeLanes(fiber.lanes, renderLanes);
        var alternate = fiber.alternate;
        if (alternate !== null) alternate.lanes = mergeLanes(alternate.lanes, renderLanes);
        scheduleContextWorkOnParentPath(fiber.return, renderLanes, propagationRoot);
    }
    function propagateSuspenseContextChange(workInProgress, firstChild, renderLanes) {
        // Mark any Suspense boundaries with fallbacks as having work to do.
        // If they were previously forced into fallbacks, they may now be able
        // to unblock.
        var node = firstChild;
        while(node !== null){
            if (node.tag === SuspenseComponent) {
                var state = node.memoizedState;
                if (state !== null) scheduleSuspenseWorkOnFiber(node, renderLanes, workInProgress);
            } else if (node.tag === SuspenseListComponent) // If the tail is hidden there might not be an Suspense boundaries
            // to schedule work on. In this case we have to schedule it on the
            // list itself.
            // We don't have to traverse to the children of the list since
            // the list will propagate the change when it rerenders.
            scheduleSuspenseWorkOnFiber(node, renderLanes, workInProgress);
            else if (node.child !== null) {
                node.child.return = node;
                node = node.child;
                continue;
            }
            if (node === workInProgress) return;
            while(node.sibling === null){
                if (node.return === null || node.return === workInProgress) return;
                node = node.return;
            }
            node.sibling.return = node.return;
            node = node.sibling;
        }
    }
    function findLastContentRow(firstChild) {
        // This is going to find the last row among these children that is already
        // showing content on the screen, as opposed to being in fallback state or
        // new. If a row has multiple Suspense boundaries, any of them being in the
        // fallback state, counts as the whole row being in a fallback state.
        // Note that the "rows" will be workInProgress, but any nested children
        // will still be current since we haven't rendered them yet. The mounted
        // order may not be the same as the new order. We use the new order.
        var row = firstChild;
        var lastContentRow = null;
        while(row !== null){
            var currentRow = row.alternate; // New rows can't be content rows.
            if (currentRow !== null && findFirstSuspended(currentRow) === null) lastContentRow = row;
            row = row.sibling;
        }
        return lastContentRow;
    }
    function validateRevealOrder(revealOrder) {
        if (revealOrder !== undefined && revealOrder !== "forwards" && revealOrder !== "backwards" && revealOrder !== "together" && !didWarnAboutRevealOrder[revealOrder]) {
            didWarnAboutRevealOrder[revealOrder] = true;
            if (typeof revealOrder === "string") switch(revealOrder.toLowerCase()){
                case "together":
                case "forwards":
                case "backwards":
                    error('"%s" is not a valid value for revealOrder on <SuspenseList />. Use lowercase "%s" instead.', revealOrder, revealOrder.toLowerCase());
                    break;
                case "forward":
                case "backward":
                    error('"%s" is not a valid value for revealOrder on <SuspenseList />. React uses the -s suffix in the spelling. Use "%ss" instead.', revealOrder, revealOrder.toLowerCase());
                    break;
                default:
                    error('"%s" is not a supported revealOrder on <SuspenseList />. Did you mean "together", "forwards" or "backwards"?', revealOrder);
                    break;
            }
            else error('%s is not a supported value for revealOrder on <SuspenseList />. Did you mean "together", "forwards" or "backwards"?', revealOrder);
        }
    }
    function validateTailOptions(tailMode, revealOrder) {
        if (tailMode !== undefined && !didWarnAboutTailOptions[tailMode]) {
            if (tailMode !== "collapsed" && tailMode !== "hidden") {
                didWarnAboutTailOptions[tailMode] = true;
                error('"%s" is not a supported value for tail on <SuspenseList />. Did you mean "collapsed" or "hidden"?', tailMode);
            } else if (revealOrder !== "forwards" && revealOrder !== "backwards") {
                didWarnAboutTailOptions[tailMode] = true;
                error('<SuspenseList tail="%s" /> is only valid if revealOrder is "forwards" or "backwards". Did you mean to specify revealOrder="forwards"?', tailMode);
            }
        }
    }
    function validateSuspenseListNestedChild(childSlot, index) {
        var isAnArray = isArray(childSlot);
        var isIterable = !isAnArray && typeof getIteratorFn(childSlot) === "function";
        if (isAnArray || isIterable) {
            var type = isAnArray ? "array" : "iterable";
            error("A nested %s was passed to row #%s in <SuspenseList />. Wrap it in an additional SuspenseList to configure its revealOrder: <SuspenseList revealOrder=...> ... <SuspenseList revealOrder=...>{%s}</SuspenseList> ... </SuspenseList>", type, index, type);
            return false;
        }
        return true;
    }
    function validateSuspenseListChildren(children, revealOrder) {
        if ((revealOrder === "forwards" || revealOrder === "backwards") && children !== undefined && children !== null && children !== false) {
            if (isArray(children)) for(var i = 0; i < children.length; i++){
                if (!validateSuspenseListNestedChild(children[i], i)) return;
            }
            else {
                var iteratorFn = getIteratorFn(children);
                if (typeof iteratorFn === "function") {
                    var childrenIterator = iteratorFn.call(children);
                    if (childrenIterator) {
                        var step = childrenIterator.next();
                        var _i = 0;
                        for(; !step.done; step = childrenIterator.next()){
                            if (!validateSuspenseListNestedChild(step.value, _i)) return;
                            _i++;
                        }
                    }
                } else error('A single row was passed to a <SuspenseList revealOrder="%s" />. This is not useful since it needs multiple rows. Did you mean to pass multiple children or an array?', revealOrder);
            }
        }
    }
    function initSuspenseListRenderState(workInProgress, isBackwards, tail, lastContentRow, tailMode) {
        var renderState = workInProgress.memoizedState;
        if (renderState === null) workInProgress.memoizedState = {
            isBackwards: isBackwards,
            rendering: null,
            renderingStartTime: 0,
            last: lastContentRow,
            tail: tail,
            tailMode: tailMode
        };
        else {
            // We can reuse the existing object from previous renders.
            renderState.isBackwards = isBackwards;
            renderState.rendering = null;
            renderState.renderingStartTime = 0;
            renderState.last = lastContentRow;
            renderState.tail = tail;
            renderState.tailMode = tailMode;
        }
    } // This can end up rendering this component multiple passes.
    // The first pass splits the children fibers into two sets. A head and tail.
    // We first render the head. If anything is in fallback state, we do another
    // pass through beginWork to rerender all children (including the tail) with
    // the force suspend context. If the first render didn't have anything in
    // in fallback state. Then we render each row in the tail one-by-one.
    // That happens in the completeWork phase without going back to beginWork.
    function updateSuspenseListComponent(current, workInProgress, renderLanes) {
        var nextProps = workInProgress.pendingProps;
        var revealOrder = nextProps.revealOrder;
        var tailMode = nextProps.tail;
        var newChildren = nextProps.children;
        validateRevealOrder(revealOrder);
        validateTailOptions(tailMode, revealOrder);
        validateSuspenseListChildren(newChildren, revealOrder);
        reconcileChildren(current, workInProgress, newChildren, renderLanes);
        var suspenseContext = suspenseStackCursor.current;
        var shouldForceFallback = hasSuspenseContext(suspenseContext, ForceSuspenseFallback);
        if (shouldForceFallback) {
            suspenseContext = setShallowSuspenseContext(suspenseContext, ForceSuspenseFallback);
            workInProgress.flags |= DidCapture;
        } else {
            var didSuspendBefore = current !== null && (current.flags & DidCapture) !== NoFlags;
            if (didSuspendBefore) // If we previously forced a fallback, we need to schedule work
            // on any nested boundaries to let them know to try to render
            // again. This is the same as context updating.
            propagateSuspenseContextChange(workInProgress, workInProgress.child, renderLanes);
            suspenseContext = setDefaultShallowSuspenseContext(suspenseContext);
        }
        pushSuspenseContext(workInProgress, suspenseContext);
        if ((workInProgress.mode & ConcurrentMode) === NoMode) // In legacy mode, SuspenseList doesn't work so we just
        // use make it a noop by treating it as the default revealOrder.
        workInProgress.memoizedState = null;
        else switch(revealOrder){
            case "forwards":
                var lastContentRow = findLastContentRow(workInProgress.child);
                var tail;
                if (lastContentRow === null) {
                    // The whole list is part of the tail.
                    // TODO: We could fast path by just rendering the tail now.
                    tail = workInProgress.child;
                    workInProgress.child = null;
                } else {
                    // Disconnect the tail rows after the content row.
                    // We're going to render them separately later.
                    tail = lastContentRow.sibling;
                    lastContentRow.sibling = null;
                }
                initSuspenseListRenderState(workInProgress, false, tail, lastContentRow, tailMode);
                break;
            case "backwards":
                // We're going to find the first row that has existing content.
                // At the same time we're going to reverse the list of everything
                // we pass in the meantime. That's going to be our tail in reverse
                // order.
                var _tail = null;
                var row = workInProgress.child;
                workInProgress.child = null;
                while(row !== null){
                    var currentRow = row.alternate; // New rows can't be content rows.
                    if (currentRow !== null && findFirstSuspended(currentRow) === null) {
                        // This is the beginning of the main content.
                        workInProgress.child = row;
                        break;
                    }
                    var nextRow = row.sibling;
                    row.sibling = _tail;
                    _tail = row;
                    row = nextRow;
                } // TODO: If workInProgress.child is null, we can continue on the tail immediately.
                initSuspenseListRenderState(workInProgress, true, _tail, null, tailMode);
                break;
            case "together":
                initSuspenseListRenderState(workInProgress, false, null, null, undefined);
                break;
            default:
                // The default reveal order is the same as not having
                // a boundary.
                workInProgress.memoizedState = null;
        }
        return workInProgress.child;
    }
    function updatePortalComponent(current, workInProgress, renderLanes) {
        pushHostContainer(workInProgress, workInProgress.stateNode.containerInfo);
        var nextChildren = workInProgress.pendingProps;
        if (current === null) // Portals are special because we don't append the children during mount
        // but at commit. Therefore we need to track insertions which the normal
        // flow doesn't do during mount. This doesn't happen at the root because
        // the root always starts with a "current" with a null child.
        // TODO: Consider unifying this with how the root works.
        workInProgress.child = reconcileChildFibers(workInProgress, null, nextChildren, renderLanes);
        else reconcileChildren(current, workInProgress, nextChildren, renderLanes);
        return workInProgress.child;
    }
    var hasWarnedAboutUsingNoValuePropOnContextProvider = false;
    function updateContextProvider(current, workInProgress, renderLanes) {
        var providerType = workInProgress.type;
        var context = providerType._context;
        var newProps = workInProgress.pendingProps;
        var oldProps = workInProgress.memoizedProps;
        var newValue = newProps.value;
        if (!("value" in newProps)) {
            if (!hasWarnedAboutUsingNoValuePropOnContextProvider) {
                hasWarnedAboutUsingNoValuePropOnContextProvider = true;
                error("The `value` prop is required for the `<Context.Provider>`. Did you misspell it or forget to pass it?");
            }
        }
        var providerPropTypes = workInProgress.type.propTypes;
        if (providerPropTypes) checkPropTypes(providerPropTypes, newProps, "prop", "Context.Provider");
        pushProvider(workInProgress, context, newValue);
        if (oldProps !== null) {
            var oldValue = oldProps.value;
            if (objectIs(oldValue, newValue)) {
                // No change. Bailout early if children are the same.
                if (oldProps.children === newProps.children && !hasContextChanged()) return bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
            } else // The context value changed. Search for matching consumers and schedule
            // them to update.
            propagateContextChange(workInProgress, context, renderLanes);
        }
        var newChildren = newProps.children;
        reconcileChildren(current, workInProgress, newChildren, renderLanes);
        return workInProgress.child;
    }
    var hasWarnedAboutUsingContextAsConsumer = false;
    function updateContextConsumer(current, workInProgress, renderLanes) {
        var context = workInProgress.type; // The logic below for Context differs depending on PROD or DEV mode. In
        if (context._context === undefined) {
            // This may be because it's a Context (rather than a Consumer).
            // Or it may be because it's older React where they're the same thing.
            // We only want to warn if we're sure it's a new React.
            if (context !== context.Consumer) {
                if (!hasWarnedAboutUsingContextAsConsumer) {
                    hasWarnedAboutUsingContextAsConsumer = true;
                    error("Rendering <Context> directly is not supported and will be removed in a future major release. Did you mean to render <Context.Consumer> instead?");
                }
            }
        } else context = context._context;
        var newProps = workInProgress.pendingProps;
        var render = newProps.children;
        if (typeof render !== "function") error("A context consumer was rendered with multiple children, or a child that isn't a function. A context consumer expects a single child that is a function. If you did pass a function, make sure there is no trailing or leading whitespace around it.");
        prepareToReadContext(workInProgress, renderLanes);
        var newValue = readContext(context);
        markComponentRenderStarted(workInProgress);
        var newChildren;
        ReactCurrentOwner$1.current = workInProgress;
        setIsRendering(true);
        newChildren = render(newValue);
        setIsRendering(false);
        markComponentRenderStopped();
        workInProgress.flags |= PerformedWork;
        reconcileChildren(current, workInProgress, newChildren, renderLanes);
        return workInProgress.child;
    }
    function markWorkInProgressReceivedUpdate() {
        didReceiveUpdate = true;
    }
    function resetSuspendedCurrentOnMountInLegacyMode(current, workInProgress) {
        if ((workInProgress.mode & ConcurrentMode) === NoMode) {
            if (current !== null) {
                // A lazy component only mounts if it suspended inside a non-
                // concurrent tree, in an inconsistent state. We want to treat it like
                // a new mount, even though an empty version of it already committed.
                // Disconnect the alternate pointers.
                current.alternate = null;
                workInProgress.alternate = null; // Since this is conceptually a new fiber, schedule a Placement effect
                workInProgress.flags |= Placement;
            }
        }
    }
    function bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes) {
        if (current !== null) // Reuse previous dependencies
        workInProgress.dependencies = current.dependencies;
        // Don't update "base" render times for bailouts.
        stopProfilerTimerIfRunning();
        markSkippedUpdateLanes(workInProgress.lanes); // Check if the children have any pending work.
        if (!includesSomeLane(renderLanes, workInProgress.childLanes)) return null;
         // This fiber doesn't have work, but its subtree does. Clone the child
        // fibers and continue.
        cloneChildFibers(current, workInProgress);
        return workInProgress.child;
    }
    function remountFiber(current, oldWorkInProgress, newWorkInProgress) {
        var returnFiber = oldWorkInProgress.return;
        if (returnFiber === null) // eslint-disable-next-line react-internal/prod-error-codes
        throw new Error("Cannot swap the root fiber.");
         // Disconnect from the old current.
        // It will get deleted.
        current.alternate = null;
        oldWorkInProgress.alternate = null; // Connect to the new tree.
        newWorkInProgress.index = oldWorkInProgress.index;
        newWorkInProgress.sibling = oldWorkInProgress.sibling;
        newWorkInProgress.return = oldWorkInProgress.return;
        newWorkInProgress.ref = oldWorkInProgress.ref; // Replace the child/sibling pointers above it.
        if (oldWorkInProgress === returnFiber.child) returnFiber.child = newWorkInProgress;
        else {
            var prevSibling = returnFiber.child;
            if (prevSibling === null) // eslint-disable-next-line react-internal/prod-error-codes
            throw new Error("Expected parent to have a child.");
            while(prevSibling.sibling !== oldWorkInProgress){
                prevSibling = prevSibling.sibling;
                if (prevSibling === null) // eslint-disable-next-line react-internal/prod-error-codes
                throw new Error("Expected to find the previous sibling.");
            }
            prevSibling.sibling = newWorkInProgress;
        } // Delete the old fiber and place the new one.
        // Since the old fiber is disconnected, we have to schedule it manually.
        var deletions = returnFiber.deletions;
        if (deletions === null) {
            returnFiber.deletions = [
                current
            ];
            returnFiber.flags |= ChildDeletion;
        } else deletions.push(current);
        newWorkInProgress.flags |= Placement; // Restart work from the new fiber.
        return newWorkInProgress;
    }
    function checkScheduledUpdateOrContext(current, renderLanes) {
        // Before performing an early bailout, we must check if there are pending
        // updates or context.
        var updateLanes = current.lanes;
        if (includesSomeLane(updateLanes, renderLanes)) return true;
         // No pending update, but because context is propagated lazily, we need
        return false;
    }
    function attemptEarlyBailoutIfNoScheduledUpdate(current, workInProgress, renderLanes) {
        // This fiber does not have any pending work. Bailout without entering
        // the begin phase. There's still some bookkeeping we that needs to be done
        // in this optimized path, mostly pushing stuff onto the stack.
        switch(workInProgress.tag){
            case HostRoot:
                pushHostRootContext(workInProgress);
                var root = workInProgress.stateNode;
                resetHydrationState();
                break;
            case HostComponent:
                pushHostContext(workInProgress);
                break;
            case ClassComponent:
                var Component = workInProgress.type;
                if (isContextProvider(Component)) pushContextProvider(workInProgress);
                break;
            case HostPortal:
                pushHostContainer(workInProgress, workInProgress.stateNode.containerInfo);
                break;
            case ContextProvider:
                var newValue = workInProgress.memoizedProps.value;
                var context = workInProgress.type._context;
                pushProvider(workInProgress, context, newValue);
                break;
            case Profiler:
                // Profiler should only call onRender when one of its descendants actually rendered.
                var hasChildWork = includesSomeLane(renderLanes, workInProgress.childLanes);
                if (hasChildWork) workInProgress.flags |= Update;
                // Reset effect durations for the next eventual effect phase.
                // These are reset during render to allow the DevTools commit hook a chance to read them,
                var stateNode = workInProgress.stateNode;
                stateNode.effectDuration = 0;
                stateNode.passiveEffectDuration = 0;
                break;
            case SuspenseComponent:
                var state = workInProgress.memoizedState;
                if (state !== null) {
                    if (state.dehydrated !== null) {
                        pushSuspenseContext(workInProgress, setDefaultShallowSuspenseContext(suspenseStackCursor.current)); // We know that this component will suspend again because if it has
                        // been unsuspended it has committed as a resolved Suspense component.
                        // If it needs to be retried, it should have work scheduled on it.
                        workInProgress.flags |= DidCapture; // We should never render the children of a dehydrated boundary until we
                        // upgrade it. We return null instead of bailoutOnAlreadyFinishedWork.
                        return null;
                    } // If this boundary is currently timed out, we need to decide
                    // whether to retry the primary children, or to skip over it and
                    // go straight to the fallback. Check the priority of the primary
                    // child fragment.
                    var primaryChildFragment = workInProgress.child;
                    var primaryChildLanes = primaryChildFragment.childLanes;
                    if (includesSomeLane(renderLanes, primaryChildLanes)) // The primary children have pending work. Use the normal path
                    // to attempt to render the primary children again.
                    return updateSuspenseComponent(current, workInProgress, renderLanes);
                    else {
                        // The primary child fragment does not have pending work marked
                        // on it
                        pushSuspenseContext(workInProgress, setDefaultShallowSuspenseContext(suspenseStackCursor.current)); // The primary children do not have pending work with sufficient
                        // priority. Bailout.
                        var child = bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
                        if (child !== null) // The fallback children have pending work. Skip over the
                        // primary children and work on the fallback.
                        return child.sibling;
                        else // Note: We can return `null` here because we already checked
                        // whether there were nested context consumers, via the call to
                        // `bailoutOnAlreadyFinishedWork` above.
                        return null;
                    }
                } else pushSuspenseContext(workInProgress, setDefaultShallowSuspenseContext(suspenseStackCursor.current));
                break;
            case SuspenseListComponent:
                var didSuspendBefore = (current.flags & DidCapture) !== NoFlags;
                var _hasChildWork = includesSomeLane(renderLanes, workInProgress.childLanes);
                if (didSuspendBefore) {
                    if (_hasChildWork) // If something was in fallback state last time, and we have all the
                    // same children then we're still in progressive loading state.
                    // Something might get unblocked by state updates or retries in the
                    // tree which will affect the tail. So we need to use the normal
                    // path to compute the correct tail.
                    return updateSuspenseListComponent(current, workInProgress, renderLanes);
                     // If none of the children had any work, that means that none of
                    // them got retried so they'll still be blocked in the same way
                    // as before. We can fast bail out.
                    workInProgress.flags |= DidCapture;
                } // If nothing suspended before and we're rendering the same children,
                // then the tail doesn't matter. Anything new that suspends will work
                // in the "together" mode, so we can continue from the state we had.
                var renderState = workInProgress.memoizedState;
                if (renderState !== null) {
                    // Reset to the "together" mode in case we've started a different
                    // update in the past but didn't complete it.
                    renderState.rendering = null;
                    renderState.tail = null;
                    renderState.lastEffect = null;
                }
                pushSuspenseContext(workInProgress, suspenseStackCursor.current);
                if (_hasChildWork) break;
                else // If none of the children had any work, that means that none of
                // them got retried so they'll still be blocked in the same way
                // as before. We can fast bail out.
                return null;
            case OffscreenComponent:
            case LegacyHiddenComponent:
                // Need to check if the tree still needs to be deferred. This is
                // almost identical to the logic used in the normal update path,
                // so we'll just enter that. The only difference is we'll bail out
                // at the next level instead of this one, because the child props
                // have not changed. Which is fine.
                // TODO: Probably should refactor `beginWork` to split the bailout
                // path from the normal path. I'm tempted to do a labeled break here
                // but I won't :)
                workInProgress.lanes = NoLanes;
                return updateOffscreenComponent(current, workInProgress, renderLanes);
        }
        return bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
    }
    function beginWork(current, workInProgress, renderLanes) {
        if (workInProgress._debugNeedsRemount && current !== null) // This will restart the begin phase with a new fiber.
        return remountFiber(current, workInProgress, createFiberFromTypeAndProps(workInProgress.type, workInProgress.key, workInProgress.pendingProps, workInProgress._debugOwner || null, workInProgress.mode, workInProgress.lanes));
        if (current !== null) {
            var oldProps = current.memoizedProps;
            var newProps = workInProgress.pendingProps;
            if (oldProps !== newProps || hasContextChanged() || workInProgress.type !== current.type) // If props or context changed, mark the fiber as having performed work.
            // This may be unset if the props are determined to be equal later (memo).
            didReceiveUpdate = true;
            else {
                // Neither props nor legacy context changes. Check if there's a pending
                // update or context change.
                var hasScheduledUpdateOrContext = checkScheduledUpdateOrContext(current, renderLanes);
                if (!hasScheduledUpdateOrContext && // If this is the second pass of an error or suspense boundary, there
                // may not be work scheduled on `current`, so we check for this flag.
                (workInProgress.flags & DidCapture) === NoFlags) {
                    // No pending updates or context. Bail out now.
                    didReceiveUpdate = false;
                    return attemptEarlyBailoutIfNoScheduledUpdate(current, workInProgress, renderLanes);
                }
                if ((current.flags & ForceUpdateForLegacySuspense) !== NoFlags) // This is a special case that only exists for legacy mode.
                // See https://github.com/facebook/react/pull/19216.
                didReceiveUpdate = true;
                else // An update was scheduled on this fiber, but there are no new props
                // nor legacy context. Set this to false. If an update queue or context
                // consumer produces a changed value, it will set this to true. Otherwise,
                // the component will assume the children have not changed and bail out.
                didReceiveUpdate = false;
            }
        } else {
            didReceiveUpdate = false;
            if (getIsHydrating() && isForkedChild(workInProgress)) {
                // Check if this child belongs to a list of muliple children in
                // its parent.
                //
                // In a true multi-threaded implementation, we would render children on
                // parallel threads. This would represent the beginning of a new render
                // thread for this subtree.
                //
                // We only use this for id generation during hydration, which is why the
                // logic is located in this special branch.
                var slotIndex = workInProgress.index;
                var numberOfForks = getForksAtLevel();
                pushTreeId(workInProgress, numberOfForks, slotIndex);
            }
        } // Before entering the begin phase, clear pending update priority.
        // TODO: This assumes that we're about to evaluate the component and process
        // the update queue. However, there's an exception: SimpleMemoComponent
        // sometimes bails out later in the begin phase. This indicates that we should
        // move this assignment out of the common path and into each branch.
        workInProgress.lanes = NoLanes;
        switch(workInProgress.tag){
            case IndeterminateComponent:
                return mountIndeterminateComponent(current, workInProgress, workInProgress.type, renderLanes);
            case LazyComponent:
                var elementType = workInProgress.elementType;
                return mountLazyComponent(current, workInProgress, elementType, renderLanes);
            case FunctionComponent:
                var Component = workInProgress.type;
                var unresolvedProps = workInProgress.pendingProps;
                var resolvedProps = workInProgress.elementType === Component ? unresolvedProps : resolveDefaultProps(Component, unresolvedProps);
                return updateFunctionComponent(current, workInProgress, Component, resolvedProps, renderLanes);
            case ClassComponent:
                var _Component = workInProgress.type;
                var _unresolvedProps = workInProgress.pendingProps;
                var _resolvedProps = workInProgress.elementType === _Component ? _unresolvedProps : resolveDefaultProps(_Component, _unresolvedProps);
                return updateClassComponent(current, workInProgress, _Component, _resolvedProps, renderLanes);
            case HostRoot:
                return updateHostRoot(current, workInProgress, renderLanes);
            case HostComponent:
                return updateHostComponent(current, workInProgress, renderLanes);
            case HostText:
                return updateHostText(current, workInProgress);
            case SuspenseComponent:
                return updateSuspenseComponent(current, workInProgress, renderLanes);
            case HostPortal:
                return updatePortalComponent(current, workInProgress, renderLanes);
            case ForwardRef:
                var type = workInProgress.type;
                var _unresolvedProps2 = workInProgress.pendingProps;
                var _resolvedProps2 = workInProgress.elementType === type ? _unresolvedProps2 : resolveDefaultProps(type, _unresolvedProps2);
                return updateForwardRef(current, workInProgress, type, _resolvedProps2, renderLanes);
            case Fragment:
                return updateFragment(current, workInProgress, renderLanes);
            case Mode:
                return updateMode(current, workInProgress, renderLanes);
            case Profiler:
                return updateProfiler(current, workInProgress, renderLanes);
            case ContextProvider:
                return updateContextProvider(current, workInProgress, renderLanes);
            case ContextConsumer:
                return updateContextConsumer(current, workInProgress, renderLanes);
            case MemoComponent:
                var _type2 = workInProgress.type;
                var _unresolvedProps3 = workInProgress.pendingProps; // Resolve outer props first, then resolve inner props.
                var _resolvedProps3 = resolveDefaultProps(_type2, _unresolvedProps3);
                if (workInProgress.type !== workInProgress.elementType) {
                    var outerPropTypes = _type2.propTypes;
                    if (outerPropTypes) checkPropTypes(outerPropTypes, _resolvedProps3, "prop", getComponentNameFromType(_type2));
                }
                _resolvedProps3 = resolveDefaultProps(_type2.type, _resolvedProps3);
                return updateMemoComponent(current, workInProgress, _type2, _resolvedProps3, renderLanes);
            case SimpleMemoComponent:
                return updateSimpleMemoComponent(current, workInProgress, workInProgress.type, workInProgress.pendingProps, renderLanes);
            case IncompleteClassComponent:
                var _Component2 = workInProgress.type;
                var _unresolvedProps4 = workInProgress.pendingProps;
                var _resolvedProps4 = workInProgress.elementType === _Component2 ? _unresolvedProps4 : resolveDefaultProps(_Component2, _unresolvedProps4);
                return mountIncompleteClassComponent(current, workInProgress, _Component2, _resolvedProps4, renderLanes);
            case SuspenseListComponent:
                return updateSuspenseListComponent(current, workInProgress, renderLanes);
            case ScopeComponent:
                break;
            case OffscreenComponent:
                return updateOffscreenComponent(current, workInProgress, renderLanes);
        }
        throw new Error("Unknown unit of work tag (" + workInProgress.tag + "). This error is likely caused by a bug in " + "React. Please file an issue.");
    }
    function markUpdate(workInProgress) {
        // Tag the fiber with an update effect. This turns a Placement into
        // a PlacementAndUpdate.
        workInProgress.flags |= Update;
    }
    function markRef$1(workInProgress) {
        workInProgress.flags |= Ref;
        workInProgress.flags |= RefStatic;
    }
    var appendAllChildren;
    var updateHostContainer;
    var updateHostComponent$1;
    var updateHostText$1;
    // Mutation mode
    appendAllChildren = function(parent, workInProgress, needsVisibilityToggle, isHidden) {
        // We only have the top Fiber that was created but we need recurse down its
        // children to find all the terminal nodes.
        var node = workInProgress.child;
        while(node !== null){
            if (node.tag === HostComponent || node.tag === HostText) appendInitialChild(parent, node.stateNode);
            else if (node.tag === HostPortal) ;
            else if (node.child !== null) {
                node.child.return = node;
                node = node.child;
                continue;
            }
            if (node === workInProgress) return;
            while(node.sibling === null){
                if (node.return === null || node.return === workInProgress) return;
                node = node.return;
            }
            node.sibling.return = node.return;
            node = node.sibling;
        }
    };
    updateHostContainer = function(current, workInProgress) {};
    updateHostComponent$1 = function(current, workInProgress, type, newProps, rootContainerInstance) {
        // If we have an alternate, that means this is an update and we need to
        // schedule a side-effect to do the updates.
        var oldProps = current.memoizedProps;
        if (oldProps === newProps) // In mutation mode, this is sufficient for a bailout because
        // we won't touch this node even if children changed.
        return;
         // If we get updated because one of our children updated, we don't
        // have newProps so we'll have to reuse them.
        // TODO: Split the update API as separate for the props vs. children.
        // Even better would be if children weren't special cased at all tho.
        var instance = workInProgress.stateNode;
        var currentHostContext = getHostContext(); // TODO: Experiencing an error where oldProps is null. Suggests a host
        // component is hitting the resume path. Figure out why. Possibly
        // related to `hidden`.
        var updatePayload = prepareUpdate(instance, type, oldProps, newProps, rootContainerInstance, currentHostContext); // TODO: Type this specific to this type of component.
        workInProgress.updateQueue = updatePayload; // If the update payload indicates that there is a change or if there
        // is a new ref we mark this as an update. All the work is done in commitWork.
        if (updatePayload) markUpdate(workInProgress);
    };
    updateHostText$1 = function(current, workInProgress, oldText, newText) {
        // If the text differs, mark it as an update. All the work in done in commitWork.
        if (oldText !== newText) markUpdate(workInProgress);
    };
    function cutOffTailIfNeeded(renderState, hasRenderedATailFallback) {
        if (getIsHydrating()) // If we're hydrating, we should consume as many items as we can
        // so we don't leave any behind.
        return;
        switch(renderState.tailMode){
            case "hidden":
                // Any insertions at the end of the tail list after this point
                // should be invisible. If there are already mounted boundaries
                // anything before them are not considered for collapsing.
                // Therefore we need to go through the whole tail to find if
                // there are any.
                var tailNode = renderState.tail;
                var lastTailNode = null;
                while(tailNode !== null){
                    if (tailNode.alternate !== null) lastTailNode = tailNode;
                    tailNode = tailNode.sibling;
                } // Next we're simply going to delete all insertions after the
                // last rendered item.
                if (lastTailNode === null) // All remaining items in the tail are insertions.
                renderState.tail = null;
                else // Detach the insertion after the last node that was already
                // inserted.
                lastTailNode.sibling = null;
                break;
            case "collapsed":
                // Any insertions at the end of the tail list after this point
                // should be invisible. If there are already mounted boundaries
                // anything before them are not considered for collapsing.
                // Therefore we need to go through the whole tail to find if
                // there are any.
                var _tailNode = renderState.tail;
                var _lastTailNode = null;
                while(_tailNode !== null){
                    if (_tailNode.alternate !== null) _lastTailNode = _tailNode;
                    _tailNode = _tailNode.sibling;
                } // Next we're simply going to delete all insertions after the
                // last rendered item.
                if (_lastTailNode === null) {
                    // All remaining items in the tail are insertions.
                    if (!hasRenderedATailFallback && renderState.tail !== null) // We suspended during the head. We want to show at least one
                    // row at the tail. So we'll keep on and cut off the rest.
                    renderState.tail.sibling = null;
                    else renderState.tail = null;
                } else // Detach the insertion after the last node that was already
                // inserted.
                _lastTailNode.sibling = null;
                break;
        }
    }
    function bubbleProperties(completedWork) {
        var didBailout = completedWork.alternate !== null && completedWork.alternate.child === completedWork.child;
        var newChildLanes = NoLanes;
        var subtreeFlags = NoFlags;
        if (!didBailout) {
            // Bubble up the earliest expiration time.
            if ((completedWork.mode & ProfileMode) !== NoMode) {
                // In profiling mode, resetChildExpirationTime is also used to reset
                // profiler durations.
                var actualDuration = completedWork.actualDuration;
                var treeBaseDuration = completedWork.selfBaseDuration;
                var child = completedWork.child;
                while(child !== null){
                    newChildLanes = mergeLanes(newChildLanes, mergeLanes(child.lanes, child.childLanes));
                    subtreeFlags |= child.subtreeFlags;
                    subtreeFlags |= child.flags; // When a fiber is cloned, its actualDuration is reset to 0. This value will
                    // only be updated if work is done on the fiber (i.e. it doesn't bailout).
                    // When work is done, it should bubble to the parent's actualDuration. If
                    // the fiber has not been cloned though, (meaning no work was done), then
                    // this value will reflect the amount of time spent working on a previous
                    // render. In that case it should not bubble. We determine whether it was
                    // cloned by comparing the child pointer.
                    actualDuration += child.actualDuration;
                    treeBaseDuration += child.treeBaseDuration;
                    child = child.sibling;
                }
                completedWork.actualDuration = actualDuration;
                completedWork.treeBaseDuration = treeBaseDuration;
            } else {
                var _child = completedWork.child;
                while(_child !== null){
                    newChildLanes = mergeLanes(newChildLanes, mergeLanes(_child.lanes, _child.childLanes));
                    subtreeFlags |= _child.subtreeFlags;
                    subtreeFlags |= _child.flags; // Update the return pointer so the tree is consistent. This is a code
                    // smell because it assumes the commit phase is never concurrent with
                    // the render phase. Will address during refactor to alternate model.
                    _child.return = completedWork;
                    _child = _child.sibling;
                }
            }
            completedWork.subtreeFlags |= subtreeFlags;
        } else {
            // Bubble up the earliest expiration time.
            if ((completedWork.mode & ProfileMode) !== NoMode) {
                // In profiling mode, resetChildExpirationTime is also used to reset
                // profiler durations.
                var _treeBaseDuration = completedWork.selfBaseDuration;
                var _child2 = completedWork.child;
                while(_child2 !== null){
                    newChildLanes = mergeLanes(newChildLanes, mergeLanes(_child2.lanes, _child2.childLanes)); // "Static" flags share the lifetime of the fiber/hook they belong to,
                    // so we should bubble those up even during a bailout. All the other
                    // flags have a lifetime only of a single render + commit, so we should
                    // ignore them.
                    subtreeFlags |= _child2.subtreeFlags & StaticMask;
                    subtreeFlags |= _child2.flags & StaticMask;
                    _treeBaseDuration += _child2.treeBaseDuration;
                    _child2 = _child2.sibling;
                }
                completedWork.treeBaseDuration = _treeBaseDuration;
            } else {
                var _child3 = completedWork.child;
                while(_child3 !== null){
                    newChildLanes = mergeLanes(newChildLanes, mergeLanes(_child3.lanes, _child3.childLanes)); // "Static" flags share the lifetime of the fiber/hook they belong to,
                    // so we should bubble those up even during a bailout. All the other
                    // flags have a lifetime only of a single render + commit, so we should
                    // ignore them.
                    subtreeFlags |= _child3.subtreeFlags & StaticMask;
                    subtreeFlags |= _child3.flags & StaticMask; // Update the return pointer so the tree is consistent. This is a code
                    // smell because it assumes the commit phase is never concurrent with
                    // the render phase. Will address during refactor to alternate model.
                    _child3.return = completedWork;
                    _child3 = _child3.sibling;
                }
            }
            completedWork.subtreeFlags |= subtreeFlags;
        }
        completedWork.childLanes = newChildLanes;
        return didBailout;
    }
    function completeDehydratedSuspenseBoundary(current, workInProgress, nextState) {
        if (hasUnhydratedTailNodes() && (workInProgress.mode & ConcurrentMode) !== NoMode && (workInProgress.flags & DidCapture) === NoFlags) {
            warnIfUnhydratedTailNodes(workInProgress);
            resetHydrationState();
            workInProgress.flags |= ForceClientRender | Incomplete | ShouldCapture;
            return false;
        }
        var wasHydrated = popHydrationState(workInProgress);
        if (nextState !== null && nextState.dehydrated !== null) {
            // We might be inside a hydration state the first time we're picking up this
            // Suspense boundary, and also after we've reentered it for further hydration.
            if (current === null) {
                if (!wasHydrated) throw new Error("A dehydrated suspense component was completed without a hydrated node. This is probably a bug in React.");
                prepareToHydrateHostSuspenseInstance(workInProgress);
                bubbleProperties(workInProgress);
                if ((workInProgress.mode & ProfileMode) !== NoMode) {
                    var isTimedOutSuspense = nextState !== null;
                    if (isTimedOutSuspense) {
                        // Don't count time spent in a timed out Suspense subtree as part of the base duration.
                        var primaryChildFragment = workInProgress.child;
                        if (primaryChildFragment !== null) // $FlowFixMe Flow doesn't support type casting in combination with the -= operator
                        workInProgress.treeBaseDuration -= primaryChildFragment.treeBaseDuration;
                    }
                }
                return false;
            } else {
                // We might have reentered this boundary to hydrate it. If so, we need to reset the hydration
                // state since we're now exiting out of it. popHydrationState doesn't do that for us.
                resetHydrationState();
                if ((workInProgress.flags & DidCapture) === NoFlags) // This boundary did not suspend so it's now hydrated and unsuspended.
                workInProgress.memoizedState = null;
                 // If nothing suspended, we need to schedule an effect to mark this boundary
                // as having hydrated so events know that they're free to be invoked.
                // It's also a signal to replay events and the suspense callback.
                // If something suspended, schedule an effect to attach retry listeners.
                // So we might as well always mark this.
                workInProgress.flags |= Update;
                bubbleProperties(workInProgress);
                if ((workInProgress.mode & ProfileMode) !== NoMode) {
                    var _isTimedOutSuspense = nextState !== null;
                    if (_isTimedOutSuspense) {
                        // Don't count time spent in a timed out Suspense subtree as part of the base duration.
                        var _primaryChildFragment = workInProgress.child;
                        if (_primaryChildFragment !== null) // $FlowFixMe Flow doesn't support type casting in combination with the -= operator
                        workInProgress.treeBaseDuration -= _primaryChildFragment.treeBaseDuration;
                    }
                }
                return false;
            }
        } else {
            // Successfully completed this tree. If this was a forced client render,
            // there may have been recoverable errors during first hydration
            // attempt. If so, add them to a queue so we can log them in the
            // commit phase.
            upgradeHydrationErrorsToRecoverable(); // Fall through to normal Suspense path
            return true;
        }
    }
    function completeWork(current, workInProgress, renderLanes) {
        var newProps = workInProgress.pendingProps; // Note: This intentionally doesn't check if we're hydrating because comparing
        // to the current tree provider fiber is just as fast and less error-prone.
        // Ideally we would have a special version of the work loop only
        // for hydration.
        popTreeContext(workInProgress);
        switch(workInProgress.tag){
            case IndeterminateComponent:
            case LazyComponent:
            case SimpleMemoComponent:
            case FunctionComponent:
            case ForwardRef:
            case Fragment:
            case Mode:
            case Profiler:
            case ContextConsumer:
            case MemoComponent:
                bubbleProperties(workInProgress);
                return null;
            case ClassComponent:
                var Component = workInProgress.type;
                if (isContextProvider(Component)) popContext(workInProgress);
                bubbleProperties(workInProgress);
                return null;
            case HostRoot:
                var fiberRoot = workInProgress.stateNode;
                popHostContainer(workInProgress);
                popTopLevelContextObject(workInProgress);
                resetWorkInProgressVersions();
                if (fiberRoot.pendingContext) {
                    fiberRoot.context = fiberRoot.pendingContext;
                    fiberRoot.pendingContext = null;
                }
                if (current === null || current.child === null) {
                    // If we hydrated, pop so that we can delete any remaining children
                    // that weren't hydrated.
                    var wasHydrated = popHydrationState(workInProgress);
                    if (wasHydrated) // If we hydrated, then we'll need to schedule an update for
                    // the commit side-effects on the root.
                    markUpdate(workInProgress);
                    else if (current !== null) {
                        var prevState = current.memoizedState;
                        if (!prevState.isDehydrated || // Check if we reverted to client rendering (e.g. due to an error)
                        (workInProgress.flags & ForceClientRender) !== NoFlags) {
                            // Schedule an effect to clear this container at the start of the
                            // next commit. This handles the case of React rendering into a
                            // container with previous children. It's also safe to do for
                            // updates too, because current.child would only be null if the
                            // previous render was null (so the container would already
                            // be empty).
                            workInProgress.flags |= Snapshot; // If this was a forced client render, there may have been
                            // recoverable errors during first hydration attempt. If so, add
                            // them to a queue so we can log them in the commit phase.
                            upgradeHydrationErrorsToRecoverable();
                        }
                    }
                }
                updateHostContainer(current, workInProgress);
                bubbleProperties(workInProgress);
                return null;
            case HostComponent:
                popHostContext(workInProgress);
                var rootContainerInstance = getRootHostContainer();
                var type = workInProgress.type;
                if (current !== null && workInProgress.stateNode != null) {
                    updateHostComponent$1(current, workInProgress, type, newProps, rootContainerInstance);
                    if (current.ref !== workInProgress.ref) markRef$1(workInProgress);
                } else {
                    if (!newProps) {
                        if (workInProgress.stateNode === null) throw new Error("We must have new props for new mounts. This error is likely caused by a bug in React. Please file an issue.");
                         // This can happen when we abort work.
                        bubbleProperties(workInProgress);
                        return null;
                    }
                    var currentHostContext = getHostContext(); // TODO: Move createInstance to beginWork and keep it on a context
                    // "stack" as the parent. Then append children as we go in beginWork
                    // or completeWork depending on whether we want to add them top->down or
                    // bottom->up. Top->down is faster in IE11.
                    var _wasHydrated = popHydrationState(workInProgress);
                    if (_wasHydrated) // TODO: Move this and createInstance step into the beginPhase
                    // to consolidate.
                    {
                        if (prepareToHydrateHostInstance(workInProgress, rootContainerInstance, currentHostContext)) // If changes to the hydrated node need to be applied at the
                        // commit-phase we mark this as such.
                        markUpdate(workInProgress);
                    } else {
                        var instance = createInstance(type, newProps, rootContainerInstance, currentHostContext, workInProgress);
                        appendAllChildren(instance, workInProgress, false, false);
                        workInProgress.stateNode = instance; // Certain renderers require commit-time effects for initial mount.
                        // (eg DOM renderer supports auto-focus for certain elements).
                        // Make sure such renderers get scheduled for later work.
                        if (finalizeInitialChildren(instance, type, newProps, rootContainerInstance)) markUpdate(workInProgress);
                    }
                    if (workInProgress.ref !== null) // If there is a ref on a host node we need to schedule a callback
                    markRef$1(workInProgress);
                }
                bubbleProperties(workInProgress);
                return null;
            case HostText:
                var newText = newProps;
                if (current && workInProgress.stateNode != null) {
                    var oldText = current.memoizedProps; // If we have an alternate, that means this is an update and we need
                    // to schedule a side-effect to do the updates.
                    updateHostText$1(current, workInProgress, oldText, newText);
                } else {
                    if (typeof newText !== "string") {
                        if (workInProgress.stateNode === null) throw new Error("We must have new props for new mounts. This error is likely caused by a bug in React. Please file an issue.");
                         // This can happen when we abort work.
                    }
                    var _rootContainerInstance = getRootHostContainer();
                    var _currentHostContext = getHostContext();
                    var _wasHydrated2 = popHydrationState(workInProgress);
                    if (_wasHydrated2) {
                        if (prepareToHydrateHostTextInstance(workInProgress)) markUpdate(workInProgress);
                    } else workInProgress.stateNode = createTextInstance(newText, _rootContainerInstance, _currentHostContext, workInProgress);
                }
                bubbleProperties(workInProgress);
                return null;
            case SuspenseComponent:
                popSuspenseContext(workInProgress);
                var nextState = workInProgress.memoizedState; // Special path for dehydrated boundaries. We may eventually move this
                // to its own fiber type so that we can add other kinds of hydration
                // boundaries that aren't associated with a Suspense tree. In anticipation
                // of such a refactor, all the hydration logic is contained in
                // this branch.
                if (current === null || current.memoizedState !== null && current.memoizedState.dehydrated !== null) {
                    var fallthroughToNormalSuspensePath = completeDehydratedSuspenseBoundary(current, workInProgress, nextState);
                    if (!fallthroughToNormalSuspensePath) {
                        if (workInProgress.flags & ShouldCapture) // Special case. There were remaining unhydrated nodes. We treat
                        // this as a mismatch. Revert to client rendering.
                        return workInProgress;
                        else // Did not finish hydrating, either because this is the initial
                        // render or because something suspended.
                        return null;
                    } // Continue with the normal Suspense path.
                }
                if ((workInProgress.flags & DidCapture) !== NoFlags) {
                    // Something suspended. Re-render with the fallback children.
                    workInProgress.lanes = renderLanes; // Do not reset the effect list.
                    if ((workInProgress.mode & ProfileMode) !== NoMode) transferActualDuration(workInProgress);
                     // Don't bubble properties in this case.
                    return workInProgress;
                }
                var nextDidTimeout = nextState !== null;
                var prevDidTimeout = current !== null && current.memoizedState !== null;
                // a passive effect, which is when we process the transitions
                if (nextDidTimeout !== prevDidTimeout) // an effect to toggle the subtree's visibility. When we switch from
                // fallback -> primary, the inner Offscreen fiber schedules this effect
                // as part of its normal complete phase. But when we switch from
                // primary -> fallback, the inner Offscreen fiber does not have a complete
                // phase. So we need to schedule its effect here.
                //
                // We also use this flag to connect/disconnect the effects, but the same
                // logic applies: when re-connecting, the Offscreen fiber's complete
                // phase will handle scheduling the effect. It's only when the fallback
                // is active that we have to do anything special.
                {
                    if (nextDidTimeout) {
                        var _offscreenFiber2 = workInProgress.child;
                        _offscreenFiber2.flags |= Visibility; // TODO: This will still suspend a synchronous tree if anything
                        // in the concurrent tree already suspended during this render.
                        // This is a known bug.
                        if ((workInProgress.mode & ConcurrentMode) !== NoMode) {
                            // TODO: Move this back to throwException because this is too late
                            // if this is a large tree which is common for initial loads. We
                            // don't know if we should restart a render or not until we get
                            // this marker, and this is too late.
                            // If this render already had a ping or lower pri updates,
                            // and this is the first time we know we're going to suspend we
                            // should be able to immediately restart from within throwException.
                            var hasInvisibleChildContext = current === null && (workInProgress.memoizedProps.unstable_avoidThisFallback !== true || !enableSuspenseAvoidThisFallback);
                            if (hasInvisibleChildContext || hasSuspenseContext(suspenseStackCursor.current, InvisibleParentSuspenseContext)) // If this was in an invisible tree or a new render, then showing
                            // this boundary is ok.
                            renderDidSuspend();
                            else // Otherwise, we're going to have to hide content so we should
                            // suspend for longer if possible.
                            renderDidSuspendDelayIfPossible();
                        }
                    }
                }
                var wakeables = workInProgress.updateQueue;
                if (wakeables !== null) // Schedule an effect to attach a retry listener to the promise.
                // TODO: Move to passive phase
                workInProgress.flags |= Update;
                bubbleProperties(workInProgress);
                if ((workInProgress.mode & ProfileMode) !== NoMode) {
                    if (nextDidTimeout) {
                        // Don't count time spent in a timed out Suspense subtree as part of the base duration.
                        var primaryChildFragment = workInProgress.child;
                        if (primaryChildFragment !== null) // $FlowFixMe Flow doesn't support type casting in combination with the -= operator
                        workInProgress.treeBaseDuration -= primaryChildFragment.treeBaseDuration;
                    }
                }
                return null;
            case HostPortal:
                popHostContainer(workInProgress);
                updateHostContainer(current, workInProgress);
                if (current === null) preparePortalMount(workInProgress.stateNode.containerInfo);
                bubbleProperties(workInProgress);
                return null;
            case ContextProvider:
                // Pop provider fiber
                var context = workInProgress.type._context;
                popProvider(context, workInProgress);
                bubbleProperties(workInProgress);
                return null;
            case IncompleteClassComponent:
                // Same as class component case. I put it down here so that the tags are
                // sequential to ensure this switch is compiled to a jump table.
                var _Component = workInProgress.type;
                if (isContextProvider(_Component)) popContext(workInProgress);
                bubbleProperties(workInProgress);
                return null;
            case SuspenseListComponent:
                popSuspenseContext(workInProgress);
                var renderState = workInProgress.memoizedState;
                if (renderState === null) {
                    // We're running in the default, "independent" mode.
                    // We don't do anything in this mode.
                    bubbleProperties(workInProgress);
                    return null;
                }
                var didSuspendAlready = (workInProgress.flags & DidCapture) !== NoFlags;
                var renderedTail = renderState.rendering;
                if (renderedTail === null) {
                    // We just rendered the head.
                    if (!didSuspendAlready) {
                        // This is the first pass. We need to figure out if anything is still
                        // suspended in the rendered set.
                        // If new content unsuspended, but there's still some content that
                        // didn't. Then we need to do a second pass that forces everything
                        // to keep showing their fallbacks.
                        // We might be suspended if something in this render pass suspended, or
                        // something in the previous committed pass suspended. Otherwise,
                        // there's no chance so we can skip the expensive call to
                        // findFirstSuspended.
                        var cannotBeSuspended = renderHasNotSuspendedYet() && (current === null || (current.flags & DidCapture) === NoFlags);
                        if (!cannotBeSuspended) {
                            var row = workInProgress.child;
                            while(row !== null){
                                var suspended = findFirstSuspended(row);
                                if (suspended !== null) {
                                    didSuspendAlready = true;
                                    workInProgress.flags |= DidCapture;
                                    cutOffTailIfNeeded(renderState, false); // If this is a newly suspended tree, it might not get committed as
                                    // part of the second pass. In that case nothing will subscribe to
                                    // its thenables. Instead, we'll transfer its thenables to the
                                    // SuspenseList so that it can retry if they resolve.
                                    // There might be multiple of these in the list but since we're
                                    // going to wait for all of them anyway, it doesn't really matter
                                    // which ones gets to ping. In theory we could get clever and keep
                                    // track of how many dependencies remain but it gets tricky because
                                    // in the meantime, we can add/remove/change items and dependencies.
                                    // We might bail out of the loop before finding any but that
                                    // doesn't matter since that means that the other boundaries that
                                    // we did find already has their listeners attached.
                                    var newThenables = suspended.updateQueue;
                                    if (newThenables !== null) {
                                        workInProgress.updateQueue = newThenables;
                                        workInProgress.flags |= Update;
                                    } // Rerender the whole list, but this time, we'll force fallbacks
                                    // to stay in place.
                                    // Reset the effect flags before doing the second pass since that's now invalid.
                                    // Reset the child fibers to their original state.
                                    workInProgress.subtreeFlags = NoFlags;
                                    resetChildFibers(workInProgress, renderLanes); // Set up the Suspense Context to force suspense and immediately
                                    // rerender the children.
                                    pushSuspenseContext(workInProgress, setShallowSuspenseContext(suspenseStackCursor.current, ForceSuspenseFallback)); // Don't bubble properties in this case.
                                    return workInProgress.child;
                                }
                                row = row.sibling;
                            }
                        }
                        if (renderState.tail !== null && now() > getRenderTargetTime()) {
                            // We have already passed our CPU deadline but we still have rows
                            // left in the tail. We'll just give up further attempts to render
                            // the main content and only render fallbacks.
                            workInProgress.flags |= DidCapture;
                            didSuspendAlready = true;
                            cutOffTailIfNeeded(renderState, false); // Since nothing actually suspended, there will nothing to ping this
                            // to get it started back up to attempt the next item. While in terms
                            // of priority this work has the same priority as this current render,
                            // it's not part of the same transition once the transition has
                            // committed. If it's sync, we still want to yield so that it can be
                            // painted. Conceptually, this is really the same as pinging.
                            // We can use any RetryLane even if it's the one currently rendering
                            // since we're leaving it behind on this node.
                            workInProgress.lanes = SomeRetryLane;
                        }
                    } else cutOffTailIfNeeded(renderState, false);
                     // Next we're going to render the tail.
                } else {
                    // Append the rendered row to the child list.
                    if (!didSuspendAlready) {
                        var _suspended = findFirstSuspended(renderedTail);
                        if (_suspended !== null) {
                            workInProgress.flags |= DidCapture;
                            didSuspendAlready = true; // Ensure we transfer the update queue to the parent so that it doesn't
                            // get lost if this row ends up dropped during a second pass.
                            var _newThenables = _suspended.updateQueue;
                            if (_newThenables !== null) {
                                workInProgress.updateQueue = _newThenables;
                                workInProgress.flags |= Update;
                            }
                            cutOffTailIfNeeded(renderState, true); // This might have been modified.
                            if (renderState.tail === null && renderState.tailMode === "hidden" && !renderedTail.alternate && !getIsHydrating() // We don't cut it if we're hydrating.
                            ) {
                                // We're done.
                                bubbleProperties(workInProgress);
                                return null;
                            }
                        } else if (// time we have to render. So rendering one more row would likely
                        // exceed it.
                        now() * 2 - renderState.renderingStartTime > getRenderTargetTime() && renderLanes !== OffscreenLane) {
                            // We have now passed our CPU deadline and we'll just give up further
                            // attempts to render the main content and only render fallbacks.
                            // The assumption is that this is usually faster.
                            workInProgress.flags |= DidCapture;
                            didSuspendAlready = true;
                            cutOffTailIfNeeded(renderState, false); // Since nothing actually suspended, there will nothing to ping this
                            // to get it started back up to attempt the next item. While in terms
                            // of priority this work has the same priority as this current render,
                            // it's not part of the same transition once the transition has
                            // committed. If it's sync, we still want to yield so that it can be
                            // painted. Conceptually, this is really the same as pinging.
                            // We can use any RetryLane even if it's the one currently rendering
                            // since we're leaving it behind on this node.
                            workInProgress.lanes = SomeRetryLane;
                        }
                    }
                    if (renderState.isBackwards) {
                        // The effect list of the backwards tail will have been added
                        // to the end. This breaks the guarantee that life-cycles fire in
                        // sibling order but that isn't a strong guarantee promised by React.
                        // Especially since these might also just pop in during future commits.
                        // Append to the beginning of the list.
                        renderedTail.sibling = workInProgress.child;
                        workInProgress.child = renderedTail;
                    } else {
                        var previousSibling = renderState.last;
                        if (previousSibling !== null) previousSibling.sibling = renderedTail;
                        else workInProgress.child = renderedTail;
                        renderState.last = renderedTail;
                    }
                }
                if (renderState.tail !== null) {
                    // We still have tail rows to render.
                    // Pop a row.
                    var next = renderState.tail;
                    renderState.rendering = next;
                    renderState.tail = next.sibling;
                    renderState.renderingStartTime = now();
                    next.sibling = null; // Restore the context.
                    // TODO: We can probably just avoid popping it instead and only
                    // setting it the first time we go from not suspended to suspended.
                    var suspenseContext = suspenseStackCursor.current;
                    if (didSuspendAlready) suspenseContext = setShallowSuspenseContext(suspenseContext, ForceSuspenseFallback);
                    else suspenseContext = setDefaultShallowSuspenseContext(suspenseContext);
                    pushSuspenseContext(workInProgress, suspenseContext); // Do a pass over the next row.
                    // Don't bubble properties in this case.
                    return next;
                }
                bubbleProperties(workInProgress);
                return null;
            case ScopeComponent:
                break;
            case OffscreenComponent:
            case LegacyHiddenComponent:
                popRenderLanes(workInProgress);
                var _nextState = workInProgress.memoizedState;
                var nextIsHidden = _nextState !== null;
                if (current !== null) {
                    var _prevState = current.memoizedState;
                    var prevIsHidden = _prevState !== null;
                    if (prevIsHidden !== nextIsHidden && !enableLegacyHidden) workInProgress.flags |= Visibility;
                }
                if (!nextIsHidden || (workInProgress.mode & ConcurrentMode) === NoMode) bubbleProperties(workInProgress);
                else // Don't bubble properties for hidden children unless we're rendering
                // at offscreen priority.
                if (includesSomeLane(subtreeRenderLanes, OffscreenLane)) {
                    bubbleProperties(workInProgress);
                    // Check if there was an insertion or update in the hidden subtree.
                    // If so, we need to hide those nodes in the commit phase, so
                    // schedule a visibility effect.
                    if (workInProgress.subtreeFlags & (Placement | Update)) workInProgress.flags |= Visibility;
                }
                return null;
            case CacheComponent:
                return null;
            case TracingMarkerComponent:
                return null;
        }
        throw new Error("Unknown unit of work tag (" + workInProgress.tag + "). This error is likely caused by a bug in " + "React. Please file an issue.");
    }
    function unwindWork(current, workInProgress, renderLanes) {
        // Note: This intentionally doesn't check if we're hydrating because comparing
        // to the current tree provider fiber is just as fast and less error-prone.
        // Ideally we would have a special version of the work loop only
        // for hydration.
        popTreeContext(workInProgress);
        switch(workInProgress.tag){
            case ClassComponent:
                var Component = workInProgress.type;
                if (isContextProvider(Component)) popContext(workInProgress);
                var flags = workInProgress.flags;
                if (flags & ShouldCapture) {
                    workInProgress.flags = flags & ~ShouldCapture | DidCapture;
                    if ((workInProgress.mode & ProfileMode) !== NoMode) transferActualDuration(workInProgress);
                    return workInProgress;
                }
                return null;
            case HostRoot:
                var root = workInProgress.stateNode;
                popHostContainer(workInProgress);
                popTopLevelContextObject(workInProgress);
                resetWorkInProgressVersions();
                var _flags = workInProgress.flags;
                if ((_flags & ShouldCapture) !== NoFlags && (_flags & DidCapture) === NoFlags) {
                    // There was an error during render that wasn't captured by a suspense
                    // boundary. Do a second pass on the root to unmount the children.
                    workInProgress.flags = _flags & ~ShouldCapture | DidCapture;
                    return workInProgress;
                } // We unwound to the root without completing it. Exit.
                return null;
            case HostComponent:
                // TODO: popHydrationState
                popHostContext(workInProgress);
                return null;
            case SuspenseComponent:
                popSuspenseContext(workInProgress);
                var suspenseState = workInProgress.memoizedState;
                if (suspenseState !== null && suspenseState.dehydrated !== null) {
                    if (workInProgress.alternate === null) throw new Error("Threw in newly mounted dehydrated component. This is likely a bug in React. Please file an issue.");
                    resetHydrationState();
                }
                var _flags2 = workInProgress.flags;
                if (_flags2 & ShouldCapture) {
                    workInProgress.flags = _flags2 & ~ShouldCapture | DidCapture; // Captured a suspense effect. Re-render the boundary.
                    if ((workInProgress.mode & ProfileMode) !== NoMode) transferActualDuration(workInProgress);
                    return workInProgress;
                }
                return null;
            case SuspenseListComponent:
                popSuspenseContext(workInProgress); // SuspenseList doesn't actually catch anything. It should've been
                // caught by a nested boundary. If not, it should bubble through.
                return null;
            case HostPortal:
                popHostContainer(workInProgress);
                return null;
            case ContextProvider:
                var context = workInProgress.type._context;
                popProvider(context, workInProgress);
                return null;
            case OffscreenComponent:
            case LegacyHiddenComponent:
                popRenderLanes(workInProgress);
                return null;
            case CacheComponent:
                return null;
            default:
                return null;
        }
    }
    function unwindInterruptedWork(current, interruptedWork, renderLanes) {
        // Note: This intentionally doesn't check if we're hydrating because comparing
        // to the current tree provider fiber is just as fast and less error-prone.
        // Ideally we would have a special version of the work loop only
        // for hydration.
        popTreeContext(interruptedWork);
        switch(interruptedWork.tag){
            case ClassComponent:
                var childContextTypes = interruptedWork.type.childContextTypes;
                if (childContextTypes !== null && childContextTypes !== undefined) popContext(interruptedWork);
                break;
            case HostRoot:
                var root = interruptedWork.stateNode;
                popHostContainer(interruptedWork);
                popTopLevelContextObject(interruptedWork);
                resetWorkInProgressVersions();
                break;
            case HostComponent:
                popHostContext(interruptedWork);
                break;
            case HostPortal:
                popHostContainer(interruptedWork);
                break;
            case SuspenseComponent:
                popSuspenseContext(interruptedWork);
                break;
            case SuspenseListComponent:
                popSuspenseContext(interruptedWork);
                break;
            case ContextProvider:
                var context = interruptedWork.type._context;
                popProvider(context, interruptedWork);
                break;
            case OffscreenComponent:
            case LegacyHiddenComponent:
                popRenderLanes(interruptedWork);
                break;
        }
    }
    var didWarnAboutUndefinedSnapshotBeforeUpdate = null;
    didWarnAboutUndefinedSnapshotBeforeUpdate = new Set();
    // Allows us to avoid traversing the return path to find the nearest Offscreen ancestor.
    // Only used when enableSuspenseLayoutEffectSemantics is enabled.
    var offscreenSubtreeIsHidden = false;
    var offscreenSubtreeWasHidden = false;
    var PossiblyWeakSet = typeof WeakSet === "function" ? WeakSet : Set;
    var nextEffect = null; // Used for Profiling builds to track updaters.
    var inProgressLanes = null;
    var inProgressRoot = null;
    function reportUncaughtErrorInDEV(error) {
        invokeGuardedCallback(null, function() {
            throw error;
        });
        clearCaughtError();
    }
    var callComponentWillUnmountWithTimer = function(current, instance) {
        instance.props = current.memoizedProps;
        instance.state = current.memoizedState;
        if (current.mode & ProfileMode) try {
            startLayoutEffectTimer();
            instance.componentWillUnmount();
        } finally{
            recordLayoutEffectDuration(current);
        }
        else instance.componentWillUnmount();
    }; // Capture errors so they don't interrupt mounting.
    function safelyCallCommitHookLayoutEffectListMount(current, nearestMountedAncestor) {
        try {
            commitHookEffectListMount(Layout, current);
        } catch (error) {
            captureCommitPhaseError(current, nearestMountedAncestor, error);
        }
    } // Capture errors so they don't interrupt unmounting.
    function safelyCallComponentWillUnmount(current, nearestMountedAncestor, instance) {
        try {
            callComponentWillUnmountWithTimer(current, instance);
        } catch (error) {
            captureCommitPhaseError(current, nearestMountedAncestor, error);
        }
    } // Capture errors so they don't interrupt mounting.
    function safelyCallComponentDidMount(current, nearestMountedAncestor, instance) {
        try {
            instance.componentDidMount();
        } catch (error) {
            captureCommitPhaseError(current, nearestMountedAncestor, error);
        }
    } // Capture errors so they don't interrupt mounting.
    function safelyAttachRef(current, nearestMountedAncestor) {
        try {
            commitAttachRef(current);
        } catch (error) {
            captureCommitPhaseError(current, nearestMountedAncestor, error);
        }
    }
    function safelyDetachRef(current, nearestMountedAncestor) {
        var ref = current.ref;
        if (ref !== null) {
            if (typeof ref === "function") {
                var retVal;
                try {
                    if (enableProfilerTimer && enableProfilerCommitHooks && current.mode & ProfileMode) try {
                        startLayoutEffectTimer();
                        retVal = ref(null);
                    } finally{
                        recordLayoutEffectDuration(current);
                    }
                    else retVal = ref(null);
                } catch (error) {
                    captureCommitPhaseError(current, nearestMountedAncestor, error);
                }
                if (typeof retVal === "function") error("Unexpected return value from a callback ref in %s. A callback ref should not return a function.", getComponentNameFromFiber(current));
            } else ref.current = null;
        }
    }
    function safelyCallDestroy(current, nearestMountedAncestor, destroy) {
        try {
            destroy();
        } catch (error) {
            captureCommitPhaseError(current, nearestMountedAncestor, error);
        }
    }
    var focusedInstanceHandle = null;
    var shouldFireAfterActiveInstanceBlur = false;
    function commitBeforeMutationEffects(root, firstChild) {
        focusedInstanceHandle = prepareForCommit(root.containerInfo);
        nextEffect = firstChild;
        commitBeforeMutationEffects_begin(); // We no longer need to track the active instance fiber
        var shouldFire = shouldFireAfterActiveInstanceBlur;
        shouldFireAfterActiveInstanceBlur = false;
        focusedInstanceHandle = null;
        return shouldFire;
    }
    function commitBeforeMutationEffects_begin() {
        while(nextEffect !== null){
            var fiber = nextEffect; // This phase is only used for beforeActiveInstanceBlur.
            var child = fiber.child;
            if ((fiber.subtreeFlags & BeforeMutationMask) !== NoFlags && child !== null) {
                child.return = fiber;
                nextEffect = child;
            } else commitBeforeMutationEffects_complete();
        }
    }
    function commitBeforeMutationEffects_complete() {
        while(nextEffect !== null){
            var fiber = nextEffect;
            setCurrentFiber(fiber);
            try {
                commitBeforeMutationEffectsOnFiber(fiber);
            } catch (error) {
                captureCommitPhaseError(fiber, fiber.return, error);
            }
            resetCurrentFiber();
            var sibling = fiber.sibling;
            if (sibling !== null) {
                sibling.return = fiber.return;
                nextEffect = sibling;
                return;
            }
            nextEffect = fiber.return;
        }
    }
    function commitBeforeMutationEffectsOnFiber(finishedWork) {
        var current = finishedWork.alternate;
        var flags = finishedWork.flags;
        if ((flags & Snapshot) !== NoFlags) {
            setCurrentFiber(finishedWork);
            switch(finishedWork.tag){
                case FunctionComponent:
                case ForwardRef:
                case SimpleMemoComponent:
                    break;
                case ClassComponent:
                    if (current !== null) {
                        var prevProps = current.memoizedProps;
                        var prevState = current.memoizedState;
                        var instance = finishedWork.stateNode; // We could update instance props and state here,
                        if (finishedWork.type === finishedWork.elementType && !didWarnAboutReassigningProps) {
                            if (instance.props !== finishedWork.memoizedProps) error("Expected %s props to match memoized props before getSnapshotBeforeUpdate. This might either be because of a bug in React, or because a component reassigns its own `this.props`. Please file an issue.", getComponentNameFromFiber(finishedWork) || "instance");
                            if (instance.state !== finishedWork.memoizedState) error("Expected %s state to match memoized state before getSnapshotBeforeUpdate. This might either be because of a bug in React, or because a component reassigns its own `this.state`. Please file an issue.", getComponentNameFromFiber(finishedWork) || "instance");
                        }
                        var snapshot = instance.getSnapshotBeforeUpdate(finishedWork.elementType === finishedWork.type ? prevProps : resolveDefaultProps(finishedWork.type, prevProps), prevState);
                        var didWarnSet = didWarnAboutUndefinedSnapshotBeforeUpdate;
                        if (snapshot === undefined && !didWarnSet.has(finishedWork.type)) {
                            didWarnSet.add(finishedWork.type);
                            error("%s.getSnapshotBeforeUpdate(): A snapshot value (or null) must be returned. You have returned undefined.", getComponentNameFromFiber(finishedWork));
                        }
                        instance.__reactInternalSnapshotBeforeUpdate = snapshot;
                    }
                    break;
                case HostRoot:
                    var root = finishedWork.stateNode;
                    clearContainer(root.containerInfo);
                    break;
                case HostComponent:
                case HostText:
                case HostPortal:
                case IncompleteClassComponent:
                    break;
                default:
                    throw new Error("This unit of work tag should not have side-effects. This error is likely caused by a bug in React. Please file an issue.");
            }
            resetCurrentFiber();
        }
    }
    function commitHookEffectListUnmount(flags, finishedWork, nearestMountedAncestor) {
        var updateQueue = finishedWork.updateQueue;
        var lastEffect = updateQueue !== null ? updateQueue.lastEffect : null;
        if (lastEffect !== null) {
            var firstEffect = lastEffect.next;
            var effect = firstEffect;
            do {
                if ((effect.tag & flags) === flags) {
                    // Unmount
                    var destroy = effect.destroy;
                    effect.destroy = undefined;
                    if (destroy !== undefined) {
                        if ((flags & Passive$1) !== NoFlags$1) markComponentPassiveEffectUnmountStarted(finishedWork);
                        else if ((flags & Layout) !== NoFlags$1) markComponentLayoutEffectUnmountStarted(finishedWork);
                        if ((flags & Insertion) !== NoFlags$1) setIsRunningInsertionEffect(true);
                        safelyCallDestroy(finishedWork, nearestMountedAncestor, destroy);
                        if ((flags & Insertion) !== NoFlags$1) setIsRunningInsertionEffect(false);
                        if ((flags & Passive$1) !== NoFlags$1) markComponentPassiveEffectUnmountStopped();
                        else if ((flags & Layout) !== NoFlags$1) markComponentLayoutEffectUnmountStopped();
                    }
                }
                effect = effect.next;
            }while (effect !== firstEffect);
        }
    }
    function commitHookEffectListMount(flags, finishedWork) {
        var updateQueue = finishedWork.updateQueue;
        var lastEffect = updateQueue !== null ? updateQueue.lastEffect : null;
        if (lastEffect !== null) {
            var firstEffect = lastEffect.next;
            var effect = firstEffect;
            do {
                if ((effect.tag & flags) === flags) {
                    if ((flags & Passive$1) !== NoFlags$1) markComponentPassiveEffectMountStarted(finishedWork);
                    else if ((flags & Layout) !== NoFlags$1) markComponentLayoutEffectMountStarted(finishedWork);
                    var create = effect.create;
                    if ((flags & Insertion) !== NoFlags$1) setIsRunningInsertionEffect(true);
                    effect.destroy = create();
                    if ((flags & Insertion) !== NoFlags$1) setIsRunningInsertionEffect(false);
                    if ((flags & Passive$1) !== NoFlags$1) markComponentPassiveEffectMountStopped();
                    else if ((flags & Layout) !== NoFlags$1) markComponentLayoutEffectMountStopped();
                    var destroy = effect.destroy;
                    if (destroy !== undefined && typeof destroy !== "function") {
                        var hookName = void 0;
                        if ((effect.tag & Layout) !== NoFlags) hookName = "useLayoutEffect";
                        else if ((effect.tag & Insertion) !== NoFlags) hookName = "useInsertionEffect";
                        else hookName = "useEffect";
                        var addendum = void 0;
                        if (destroy === null) addendum = " You returned null. If your effect does not require clean up, return undefined (or nothing).";
                        else if (typeof destroy.then === "function") addendum = "\n\nIt looks like you wrote " + hookName + "(async () => ...) or returned a Promise. " + "Instead, write the async function inside your effect " + "and call it immediately:\n\n" + hookName + "(() => {\n" + "  async function fetchData() {\n" + "    // You can await here\n" + "    const response = await MyAPI.getData(someId);\n" + "    // ...\n" + "  }\n" + "  fetchData();\n" + "}, [someId]); // Or [] if effect doesn't need props or state\n\n" + "Learn more about data fetching with Hooks: https://reactjs.org/link/hooks-data-fetching";
                        else addendum = " You returned: " + destroy;
                        error("%s must not return anything besides a function, which is used for clean-up.%s", hookName, addendum);
                    }
                }
                effect = effect.next;
            }while (effect !== firstEffect);
        }
    }
    function commitPassiveEffectDurations(finishedRoot, finishedWork) {
        // Only Profilers with work in their subtree will have an Update effect scheduled.
        if ((finishedWork.flags & Update) !== NoFlags) switch(finishedWork.tag){
            case Profiler:
                var passiveEffectDuration = finishedWork.stateNode.passiveEffectDuration;
                var _finishedWork$memoize = finishedWork.memoizedProps, id = _finishedWork$memoize.id, onPostCommit = _finishedWork$memoize.onPostCommit; // This value will still reflect the previous commit phase.
                // It does not get reset until the start of the next commit phase.
                var commitTime = getCommitTime();
                var phase = finishedWork.alternate === null ? "mount" : "update";
                if (isCurrentUpdateNested()) phase = "nested-update";
                if (typeof onPostCommit === "function") onPostCommit(id, phase, passiveEffectDuration, commitTime);
                 // Bubble times to the next nearest ancestor Profiler.
                // After we process that Profiler, we'll bubble further up.
                var parentFiber = finishedWork.return;
                outer: while(parentFiber !== null){
                    switch(parentFiber.tag){
                        case HostRoot:
                            var root = parentFiber.stateNode;
                            root.passiveEffectDuration += passiveEffectDuration;
                            break outer;
                        case Profiler:
                            var parentStateNode = parentFiber.stateNode;
                            parentStateNode.passiveEffectDuration += passiveEffectDuration;
                            break outer;
                    }
                    parentFiber = parentFiber.return;
                }
                break;
        }
    }
    function commitLayoutEffectOnFiber(finishedRoot, current, finishedWork, committedLanes) {
        if ((finishedWork.flags & LayoutMask) !== NoFlags) switch(finishedWork.tag){
            case FunctionComponent:
            case ForwardRef:
            case SimpleMemoComponent:
                if (!offscreenSubtreeWasHidden) {
                    // At this point layout effects have already been destroyed (during mutation phase).
                    // This is done to prevent sibling component effects from interfering with each other,
                    // e.g. a destroy function in one component should never override a ref set
                    // by a create function in another component during the same commit.
                    if (finishedWork.mode & ProfileMode) try {
                        startLayoutEffectTimer();
                        commitHookEffectListMount(Layout | HasEffect, finishedWork);
                    } finally{
                        recordLayoutEffectDuration(finishedWork);
                    }
                    else commitHookEffectListMount(Layout | HasEffect, finishedWork);
                }
                break;
            case ClassComponent:
                var instance = finishedWork.stateNode;
                if (finishedWork.flags & Update) {
                    if (!offscreenSubtreeWasHidden) {
                        if (current === null) {
                            if (finishedWork.type === finishedWork.elementType && !didWarnAboutReassigningProps) {
                                if (instance.props !== finishedWork.memoizedProps) error("Expected %s props to match memoized props before componentDidMount. This might either be because of a bug in React, or because a component reassigns its own `this.props`. Please file an issue.", getComponentNameFromFiber(finishedWork) || "instance");
                                if (instance.state !== finishedWork.memoizedState) error("Expected %s state to match memoized state before componentDidMount. This might either be because of a bug in React, or because a component reassigns its own `this.state`. Please file an issue.", getComponentNameFromFiber(finishedWork) || "instance");
                            }
                            if (finishedWork.mode & ProfileMode) try {
                                startLayoutEffectTimer();
                                instance.componentDidMount();
                            } finally{
                                recordLayoutEffectDuration(finishedWork);
                            }
                            else instance.componentDidMount();
                        } else {
                            var prevProps = finishedWork.elementType === finishedWork.type ? current.memoizedProps : resolveDefaultProps(finishedWork.type, current.memoizedProps);
                            var prevState = current.memoizedState; // We could update instance props and state here,
                            if (finishedWork.type === finishedWork.elementType && !didWarnAboutReassigningProps) {
                                if (instance.props !== finishedWork.memoizedProps) error("Expected %s props to match memoized props before componentDidUpdate. This might either be because of a bug in React, or because a component reassigns its own `this.props`. Please file an issue.", getComponentNameFromFiber(finishedWork) || "instance");
                                if (instance.state !== finishedWork.memoizedState) error("Expected %s state to match memoized state before componentDidUpdate. This might either be because of a bug in React, or because a component reassigns its own `this.state`. Please file an issue.", getComponentNameFromFiber(finishedWork) || "instance");
                            }
                            if (finishedWork.mode & ProfileMode) try {
                                startLayoutEffectTimer();
                                instance.componentDidUpdate(prevProps, prevState, instance.__reactInternalSnapshotBeforeUpdate);
                            } finally{
                                recordLayoutEffectDuration(finishedWork);
                            }
                            else instance.componentDidUpdate(prevProps, prevState, instance.__reactInternalSnapshotBeforeUpdate);
                        }
                    }
                } // TODO: I think this is now always non-null by the time it reaches the
                // commit phase. Consider removing the type check.
                var updateQueue = finishedWork.updateQueue;
                if (updateQueue !== null) {
                    if (finishedWork.type === finishedWork.elementType && !didWarnAboutReassigningProps) {
                        if (instance.props !== finishedWork.memoizedProps) error("Expected %s props to match memoized props before processing the update queue. This might either be because of a bug in React, or because a component reassigns its own `this.props`. Please file an issue.", getComponentNameFromFiber(finishedWork) || "instance");
                        if (instance.state !== finishedWork.memoizedState) error("Expected %s state to match memoized state before processing the update queue. This might either be because of a bug in React, or because a component reassigns its own `this.state`. Please file an issue.", getComponentNameFromFiber(finishedWork) || "instance");
                    }
                    // but instead we rely on them being set during last render.
                    // TODO: revisit this when we implement resuming.
                    commitUpdateQueue(finishedWork, updateQueue, instance);
                }
                break;
            case HostRoot:
                // TODO: I think this is now always non-null by the time it reaches the
                // commit phase. Consider removing the type check.
                var _updateQueue = finishedWork.updateQueue;
                if (_updateQueue !== null) {
                    var _instance = null;
                    if (finishedWork.child !== null) switch(finishedWork.child.tag){
                        case HostComponent:
                            _instance = getPublicInstance(finishedWork.child.stateNode);
                            break;
                        case ClassComponent:
                            _instance = finishedWork.child.stateNode;
                            break;
                    }
                    commitUpdateQueue(finishedWork, _updateQueue, _instance);
                }
                break;
            case HostComponent:
                var _instance2 = finishedWork.stateNode; // Renderers may schedule work to be done after host components are mounted
                // (eg DOM renderer may schedule auto-focus for inputs and form controls).
                // These effects should only be committed when components are first mounted,
                // aka when there is no current/alternate.
                if (current === null && finishedWork.flags & Update) {
                    var type = finishedWork.type;
                    var props = finishedWork.memoizedProps;
                    commitMount(_instance2, type, props);
                }
                break;
            case HostText:
                break;
            case HostPortal:
                break;
            case Profiler:
                var _finishedWork$memoize2 = finishedWork.memoizedProps, onCommit = _finishedWork$memoize2.onCommit, onRender = _finishedWork$memoize2.onRender;
                var effectDuration = finishedWork.stateNode.effectDuration;
                var commitTime = getCommitTime();
                var phase = current === null ? "mount" : "update";
                if (isCurrentUpdateNested()) phase = "nested-update";
                if (typeof onRender === "function") onRender(finishedWork.memoizedProps.id, phase, finishedWork.actualDuration, finishedWork.treeBaseDuration, finishedWork.actualStartTime, commitTime);
                if (typeof onCommit === "function") onCommit(finishedWork.memoizedProps.id, phase, effectDuration, commitTime);
                 // Schedule a passive effect for this Profiler to call onPostCommit hooks.
                // This effect should be scheduled even if there is no onPostCommit callback for this Profiler,
                // because the effect is also where times bubble to parent Profilers.
                enqueuePendingPassiveProfilerEffect(finishedWork); // Propagate layout effect durations to the next nearest Profiler ancestor.
                // Do not reset these values until the next render so DevTools has a chance to read them first.
                var parentFiber = finishedWork.return;
                outer: while(parentFiber !== null){
                    switch(parentFiber.tag){
                        case HostRoot:
                            var root = parentFiber.stateNode;
                            root.effectDuration += effectDuration;
                            break outer;
                        case Profiler:
                            var parentStateNode = parentFiber.stateNode;
                            parentStateNode.effectDuration += effectDuration;
                            break outer;
                    }
                    parentFiber = parentFiber.return;
                }
                break;
            case SuspenseComponent:
                commitSuspenseHydrationCallbacks(finishedRoot, finishedWork);
                break;
            case SuspenseListComponent:
            case IncompleteClassComponent:
            case ScopeComponent:
            case OffscreenComponent:
            case LegacyHiddenComponent:
            case TracingMarkerComponent:
                break;
            default:
                throw new Error("This unit of work tag should not have side-effects. This error is likely caused by a bug in React. Please file an issue.");
        }
        if (!offscreenSubtreeWasHidden) {
            if (finishedWork.flags & Ref) commitAttachRef(finishedWork);
        }
    }
    function reappearLayoutEffectsOnFiber(node) {
        // Turn on layout effects in a tree that previously disappeared.
        // TODO (Offscreen) Check: flags & LayoutStatic
        switch(node.tag){
            case FunctionComponent:
            case ForwardRef:
            case SimpleMemoComponent:
                if (node.mode & ProfileMode) try {
                    startLayoutEffectTimer();
                    safelyCallCommitHookLayoutEffectListMount(node, node.return);
                } finally{
                    recordLayoutEffectDuration(node);
                }
                else safelyCallCommitHookLayoutEffectListMount(node, node.return);
                break;
            case ClassComponent:
                var instance = node.stateNode;
                if (typeof instance.componentDidMount === "function") safelyCallComponentDidMount(node, node.return, instance);
                safelyAttachRef(node, node.return);
                break;
            case HostComponent:
                safelyAttachRef(node, node.return);
                break;
        }
    }
    function hideOrUnhideAllChildren(finishedWork, isHidden) {
        // Only hide or unhide the top-most host nodes.
        var hostSubtreeRoot = null;
        // We only have the top Fiber that was inserted but we need to recurse down its
        // children to find all the terminal nodes.
        var node = finishedWork;
        while(true){
            if (node.tag === HostComponent) {
                if (hostSubtreeRoot === null) {
                    hostSubtreeRoot = node;
                    try {
                        var instance = node.stateNode;
                        if (isHidden) hideInstance(instance);
                        else unhideInstance(node.stateNode, node.memoizedProps);
                    } catch (error) {
                        captureCommitPhaseError(finishedWork, finishedWork.return, error);
                    }
                }
            } else if (node.tag === HostText) {
                if (hostSubtreeRoot === null) try {
                    var _instance3 = node.stateNode;
                    if (isHidden) hideTextInstance(_instance3);
                    else unhideTextInstance(_instance3, node.memoizedProps);
                } catch (error) {
                    captureCommitPhaseError(finishedWork, finishedWork.return, error);
                }
            } else if ((node.tag === OffscreenComponent || node.tag === LegacyHiddenComponent) && node.memoizedState !== null && node !== finishedWork) ;
            else if (node.child !== null) {
                node.child.return = node;
                node = node.child;
                continue;
            }
            if (node === finishedWork) return;
            while(node.sibling === null){
                if (node.return === null || node.return === finishedWork) return;
                if (hostSubtreeRoot === node) hostSubtreeRoot = null;
                node = node.return;
            }
            if (hostSubtreeRoot === node) hostSubtreeRoot = null;
            node.sibling.return = node.return;
            node = node.sibling;
        }
    }
    function commitAttachRef(finishedWork) {
        var ref = finishedWork.ref;
        if (ref !== null) {
            var instance = finishedWork.stateNode;
            var instanceToUse;
            switch(finishedWork.tag){
                case HostComponent:
                    instanceToUse = getPublicInstance(instance);
                    break;
                default:
                    instanceToUse = instance;
            } // Moved outside to ensure DCE works with this flag
            if (typeof ref === "function") {
                var retVal;
                if (finishedWork.mode & ProfileMode) try {
                    startLayoutEffectTimer();
                    retVal = ref(instanceToUse);
                } finally{
                    recordLayoutEffectDuration(finishedWork);
                }
                else retVal = ref(instanceToUse);
                if (typeof retVal === "function") error("Unexpected return value from a callback ref in %s. A callback ref should not return a function.", getComponentNameFromFiber(finishedWork));
            } else {
                if (!ref.hasOwnProperty("current")) error("Unexpected ref object provided for %s. Use either a ref-setter function or React.createRef().", getComponentNameFromFiber(finishedWork));
                ref.current = instanceToUse;
            }
        }
    }
    function detachFiberMutation(fiber) {
        // Cut off the return pointer to disconnect it from the tree.
        // This enables us to detect and warn against state updates on an unmounted component.
        // It also prevents events from bubbling from within disconnected components.
        //
        // Ideally, we should also clear the child pointer of the parent alternate to let this
        // get GC:ed but we don't know which for sure which parent is the current
        // one so we'll settle for GC:ing the subtree of this child.
        // This child itself will be GC:ed when the parent updates the next time.
        //
        // Note that we can't clear child or sibling pointers yet.
        // They're needed for passive effects and for findDOMNode.
        // We defer those fields, and all other cleanup, to the passive phase (see detachFiberAfterEffects).
        //
        // Don't reset the alternate yet, either. We need that so we can detach the
        // alternate's fields in the passive phase. Clearing the return pointer is
        // sufficient for findDOMNode semantics.
        var alternate = fiber.alternate;
        if (alternate !== null) alternate.return = null;
        fiber.return = null;
    }
    function detachFiberAfterEffects(fiber) {
        var alternate = fiber.alternate;
        if (alternate !== null) {
            fiber.alternate = null;
            detachFiberAfterEffects(alternate);
        } // Note: Defensively using negation instead of < in case
        // Clear cyclical Fiber fields. This level alone is designed to roughly
        // approximate the planned Fiber refactor. In that world, `setState` will be
        // bound to a special "instance" object instead of a Fiber. The Instance
        // object will not have any of these fields. It will only be connected to
        // the fiber tree via a single link at the root. So if this level alone is
        // sufficient to fix memory issues, that bodes well for our plans.
        fiber.child = null;
        fiber.deletions = null;
        fiber.sibling = null; // The `stateNode` is cyclical because on host nodes it points to the host
        // tree, which has its own pointers to children, parents, and siblings.
        // The other host nodes also point back to fibers, so we should detach that
        // one, too.
        if (fiber.tag === HostComponent) {
            var hostInstance = fiber.stateNode;
            if (hostInstance !== null) detachDeletedInstance(hostInstance);
        }
        fiber.stateNode = null; // I'm intentionally not clearing the `return` field in this level. We
        fiber._debugOwner = null;
        // Theoretically, nothing in here should be necessary, because we already
        // disconnected the fiber from the tree. So even if something leaks this
        // particular fiber, it won't leak anything else
        //
        // The purpose of this branch is to be super aggressive so we can measure
        // if there's any difference in memory impact. If there is, that could
        // indicate a React leak we don't know about.
        fiber.return = null;
        fiber.dependencies = null;
        fiber.memoizedProps = null;
        fiber.memoizedState = null;
        fiber.pendingProps = null;
        fiber.stateNode = null; // TODO: Move to `commitPassiveUnmountInsideDeletedTreeOnFiber` instead.
        fiber.updateQueue = null;
    }
    function getHostParentFiber(fiber) {
        var parent = fiber.return;
        while(parent !== null){
            if (isHostParent(parent)) return parent;
            parent = parent.return;
        }
        throw new Error("Expected to find a host parent. This error is likely caused by a bug in React. Please file an issue.");
    }
    function isHostParent(fiber) {
        return fiber.tag === HostComponent || fiber.tag === HostRoot || fiber.tag === HostPortal;
    }
    function getHostSibling(fiber) {
        // We're going to search forward into the tree until we find a sibling host
        // node. Unfortunately, if multiple insertions are done in a row we have to
        // search past them. This leads to exponential search for the next sibling.
        // TODO: Find a more efficient way to do this.
        var node = fiber;
        siblings: while(true){
            // If we didn't find anything, let's try the next sibling.
            while(node.sibling === null){
                if (node.return === null || isHostParent(node.return)) // If we pop out of the root or hit the parent the fiber we are the
                // last sibling.
                return null;
                node = node.return;
            }
            node.sibling.return = node.return;
            node = node.sibling;
            while(node.tag !== HostComponent && node.tag !== HostText && node.tag !== DehydratedFragment){
                // If it is not host node and, we might have a host node inside it.
                // Try to search down until we find one.
                if (node.flags & Placement) continue siblings;
                 // If we don't have a child, try the siblings instead.
                // We also skip portals because they are not part of this host tree.
                if (node.child === null || node.tag === HostPortal) continue siblings;
                else {
                    node.child.return = node;
                    node = node.child;
                }
            } // Check if this host node is stable or about to be placed.
            if (!(node.flags & Placement)) // Found it!
            return node.stateNode;
        }
    }
    function commitPlacement(finishedWork) {
        var parentFiber = getHostParentFiber(finishedWork); // Note: these two variables *must* always be updated together.
        switch(parentFiber.tag){
            case HostComponent:
                var parent = parentFiber.stateNode;
                if (parentFiber.flags & ContentReset) {
                    // Reset the text content of the parent before doing any insertions
                    resetTextContent(parent); // Clear ContentReset from the effect tag
                    parentFiber.flags &= ~ContentReset;
                }
                var before = getHostSibling(finishedWork); // We only have the top Fiber that was inserted but we need to recurse down its
                // children to find all the terminal nodes.
                insertOrAppendPlacementNode(finishedWork, before, parent);
                break;
            case HostRoot:
            case HostPortal:
                var _parent = parentFiber.stateNode.containerInfo;
                var _before = getHostSibling(finishedWork);
                insertOrAppendPlacementNodeIntoContainer(finishedWork, _before, _parent);
                break;
            // eslint-disable-next-line-no-fallthrough
            default:
                throw new Error("Invalid host parent fiber. This error is likely caused by a bug in React. Please file an issue.");
        }
    }
    function insertOrAppendPlacementNodeIntoContainer(node, before, parent) {
        var tag = node.tag;
        var isHost = tag === HostComponent || tag === HostText;
        if (isHost) {
            var stateNode = node.stateNode;
            if (before) insertInContainerBefore(parent, stateNode, before);
            else appendChildToContainer(parent, stateNode);
        } else if (tag === HostPortal) ;
        else {
            var child = node.child;
            if (child !== null) {
                insertOrAppendPlacementNodeIntoContainer(child, before, parent);
                var sibling = child.sibling;
                while(sibling !== null){
                    insertOrAppendPlacementNodeIntoContainer(sibling, before, parent);
                    sibling = sibling.sibling;
                }
            }
        }
    }
    function insertOrAppendPlacementNode(node, before, parent) {
        var tag = node.tag;
        var isHost = tag === HostComponent || tag === HostText;
        if (isHost) {
            var stateNode = node.stateNode;
            if (before) insertBefore(parent, stateNode, before);
            else appendChild(parent, stateNode);
        } else if (tag === HostPortal) ;
        else {
            var child = node.child;
            if (child !== null) {
                insertOrAppendPlacementNode(child, before, parent);
                var sibling = child.sibling;
                while(sibling !== null){
                    insertOrAppendPlacementNode(sibling, before, parent);
                    sibling = sibling.sibling;
                }
            }
        }
    } // These are tracked on the stack as we recursively traverse a
    // deleted subtree.
    // TODO: Update these during the whole mutation phase, not just during
    // a deletion.
    var hostParent = null;
    var hostParentIsContainer = false;
    function commitDeletionEffects(root, returnFiber, deletedFiber) {
        // We only have the top Fiber that was deleted but we need to recurse down its
        // children to find all the terminal nodes.
        // Recursively delete all host nodes from the parent, detach refs, clean
        // up mounted layout effects, and call componentWillUnmount.
        // We only need to remove the topmost host child in each branch. But then we
        // still need to keep traversing to unmount effects, refs, and cWU. TODO: We
        // could split this into two separate traversals functions, where the second
        // one doesn't include any removeChild logic. This is maybe the same
        // function as "disappearLayoutEffects" (or whatever that turns into after
        // the layout phase is refactored to use recursion).
        // Before starting, find the nearest host parent on the stack so we know
        // which instance/container to remove the children from.
        // TODO: Instead of searching up the fiber return path on every deletion, we
        // can track the nearest host component on the JS stack as we traverse the
        // tree during the commit phase. This would make insertions faster, too.
        var parent = returnFiber;
        findParent: while(parent !== null){
            switch(parent.tag){
                case HostComponent:
                    hostParent = parent.stateNode;
                    hostParentIsContainer = false;
                    break findParent;
                case HostRoot:
                    hostParent = parent.stateNode.containerInfo;
                    hostParentIsContainer = true;
                    break findParent;
                case HostPortal:
                    hostParent = parent.stateNode.containerInfo;
                    hostParentIsContainer = true;
                    break findParent;
            }
            parent = parent.return;
        }
        if (hostParent === null) throw new Error("Expected to find a host parent. This error is likely caused by a bug in React. Please file an issue.");
        commitDeletionEffectsOnFiber(root, returnFiber, deletedFiber);
        hostParent = null;
        hostParentIsContainer = false;
        detachFiberMutation(deletedFiber);
    }
    function recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, parent) {
        // TODO: Use a static flag to skip trees that don't have unmount effects
        var child = parent.child;
        while(child !== null){
            commitDeletionEffectsOnFiber(finishedRoot, nearestMountedAncestor, child);
            child = child.sibling;
        }
    }
    function commitDeletionEffectsOnFiber(finishedRoot, nearestMountedAncestor, deletedFiber) {
        onCommitUnmount(deletedFiber); // The cases in this outer switch modify the stack before they traverse
        // into their subtree. There are simpler cases in the inner switch
        // that don't modify the stack.
        switch(deletedFiber.tag){
            case HostComponent:
                if (!offscreenSubtreeWasHidden) safelyDetachRef(deletedFiber, nearestMountedAncestor);
                 // Intentional fallthrough to next branch
            // eslint-disable-next-line-no-fallthrough
            case HostText:
                var prevHostParent = hostParent;
                var prevHostParentIsContainer = hostParentIsContainer;
                hostParent = null;
                recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
                hostParent = prevHostParent;
                hostParentIsContainer = prevHostParentIsContainer;
                if (hostParent !== null) {
                    // Now that all the child effects have unmounted, we can remove the
                    // node from the tree.
                    if (hostParentIsContainer) removeChildFromContainer(hostParent, deletedFiber.stateNode);
                    else removeChild(hostParent, deletedFiber.stateNode);
                }
                return;
            case DehydratedFragment:
                if (hostParent !== null) {
                    if (hostParentIsContainer) clearSuspenseBoundaryFromContainer(hostParent, deletedFiber.stateNode);
                    else clearSuspenseBoundary(hostParent, deletedFiber.stateNode);
                }
                return;
            case HostPortal:
                // When we go into a portal, it becomes the parent to remove from.
                var _prevHostParent = hostParent;
                var _prevHostParentIsContainer = hostParentIsContainer;
                hostParent = deletedFiber.stateNode.containerInfo;
                hostParentIsContainer = true;
                recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
                hostParent = _prevHostParent;
                hostParentIsContainer = _prevHostParentIsContainer;
                return;
            case FunctionComponent:
            case ForwardRef:
            case MemoComponent:
            case SimpleMemoComponent:
                if (!offscreenSubtreeWasHidden) {
                    var updateQueue = deletedFiber.updateQueue;
                    if (updateQueue !== null) {
                        var lastEffect = updateQueue.lastEffect;
                        if (lastEffect !== null) {
                            var firstEffect = lastEffect.next;
                            var effect = firstEffect;
                            do {
                                var _effect = effect, destroy = _effect.destroy, tag = _effect.tag;
                                if (destroy !== undefined) {
                                    if ((tag & Insertion) !== NoFlags$1) safelyCallDestroy(deletedFiber, nearestMountedAncestor, destroy);
                                    else if ((tag & Layout) !== NoFlags$1) {
                                        markComponentLayoutEffectUnmountStarted(deletedFiber);
                                        if (deletedFiber.mode & ProfileMode) {
                                            startLayoutEffectTimer();
                                            safelyCallDestroy(deletedFiber, nearestMountedAncestor, destroy);
                                            recordLayoutEffectDuration(deletedFiber);
                                        } else safelyCallDestroy(deletedFiber, nearestMountedAncestor, destroy);
                                        markComponentLayoutEffectUnmountStopped();
                                    }
                                }
                                effect = effect.next;
                            }while (effect !== firstEffect);
                        }
                    }
                }
                recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
                return;
            case ClassComponent:
                if (!offscreenSubtreeWasHidden) {
                    safelyDetachRef(deletedFiber, nearestMountedAncestor);
                    var instance = deletedFiber.stateNode;
                    if (typeof instance.componentWillUnmount === "function") safelyCallComponentWillUnmount(deletedFiber, nearestMountedAncestor, instance);
                }
                recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
                return;
            case ScopeComponent:
                recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
                return;
            case OffscreenComponent:
                if (deletedFiber.mode & ConcurrentMode) {
                    // If this offscreen component is hidden, we already unmounted it. Before
                    // deleting the children, track that it's already unmounted so that we
                    // don't attempt to unmount the effects again.
                    // TODO: If the tree is hidden, in most cases we should be able to skip
                    // over the nested children entirely. An exception is we haven't yet found
                    // the topmost host node to delete, which we already track on the stack.
                    // But the other case is portals, which need to be detached no matter how
                    // deeply they are nested. We should use a subtree flag to track whether a
                    // subtree includes a nested portal.
                    var prevOffscreenSubtreeWasHidden = offscreenSubtreeWasHidden;
                    offscreenSubtreeWasHidden = prevOffscreenSubtreeWasHidden || deletedFiber.memoizedState !== null;
                    recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
                    offscreenSubtreeWasHidden = prevOffscreenSubtreeWasHidden;
                } else recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
                break;
            default:
                recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
                return;
        }
    }
    function commitSuspenseCallback(finishedWork) {
        // TODO: Move this to passive phase
        var newState = finishedWork.memoizedState;
    }
    function commitSuspenseHydrationCallbacks(finishedRoot, finishedWork) {
        var newState = finishedWork.memoizedState;
        if (newState === null) {
            var current = finishedWork.alternate;
            if (current !== null) {
                var prevState = current.memoizedState;
                if (prevState !== null) {
                    var suspenseInstance = prevState.dehydrated;
                    if (suspenseInstance !== null) commitHydratedSuspenseInstance(suspenseInstance);
                }
            }
        }
    }
    function attachSuspenseRetryListeners(finishedWork) {
        // If this boundary just timed out, then it will have a set of wakeables.
        // For each wakeable, attach a listener so that when it resolves, React
        // attempts to re-render the boundary in the primary (pre-timeout) state.
        var wakeables = finishedWork.updateQueue;
        if (wakeables !== null) {
            finishedWork.updateQueue = null;
            var retryCache = finishedWork.stateNode;
            if (retryCache === null) retryCache = finishedWork.stateNode = new PossiblyWeakSet();
            wakeables.forEach(function(wakeable) {
                // Memoize using the boundary fiber to prevent redundant listeners.
                var retry = resolveRetryWakeable.bind(null, finishedWork, wakeable);
                if (!retryCache.has(wakeable)) {
                    retryCache.add(wakeable);
                    if (isDevToolsPresent) {
                        if (inProgressLanes !== null && inProgressRoot !== null) // If we have pending work still, associate the original updaters with it.
                        restorePendingUpdaters(inProgressRoot, inProgressLanes);
                        else throw Error("Expected finished root and lanes to be set. This is a bug in React.");
                    }
                    wakeable.then(retry, retry);
                }
            });
        }
    } // This function detects when a Suspense boundary goes from visible to hidden.
    function commitMutationEffects(root, finishedWork, committedLanes) {
        inProgressLanes = committedLanes;
        inProgressRoot = root;
        setCurrentFiber(finishedWork);
        commitMutationEffectsOnFiber(finishedWork, root);
        setCurrentFiber(finishedWork);
        inProgressLanes = null;
        inProgressRoot = null;
    }
    function recursivelyTraverseMutationEffects(root, parentFiber, lanes) {
        // Deletions effects can be scheduled on any fiber type. They need to happen
        // before the children effects hae fired.
        var deletions = parentFiber.deletions;
        if (deletions !== null) for(var i = 0; i < deletions.length; i++){
            var childToDelete = deletions[i];
            try {
                commitDeletionEffects(root, parentFiber, childToDelete);
            } catch (error) {
                captureCommitPhaseError(childToDelete, parentFiber, error);
            }
        }
        var prevDebugFiber = getCurrentFiber();
        if (parentFiber.subtreeFlags & MutationMask) {
            var child = parentFiber.child;
            while(child !== null){
                setCurrentFiber(child);
                commitMutationEffectsOnFiber(child, root);
                child = child.sibling;
            }
        }
        setCurrentFiber(prevDebugFiber);
    }
    function commitMutationEffectsOnFiber(finishedWork, root, lanes) {
        var current = finishedWork.alternate;
        var flags = finishedWork.flags; // The effect flag should be checked *after* we refine the type of fiber,
        // because the fiber tag is more specific. An exception is any flag related
        // to reconcilation, because those can be set on all fiber types.
        switch(finishedWork.tag){
            case FunctionComponent:
            case ForwardRef:
            case MemoComponent:
            case SimpleMemoComponent:
                recursivelyTraverseMutationEffects(root, finishedWork);
                commitReconciliationEffects(finishedWork);
                if (flags & Update) {
                    try {
                        commitHookEffectListUnmount(Insertion | HasEffect, finishedWork, finishedWork.return);
                        commitHookEffectListMount(Insertion | HasEffect, finishedWork);
                    } catch (error) {
                        captureCommitPhaseError(finishedWork, finishedWork.return, error);
                    } // Layout effects are destroyed during the mutation phase so that all
                    // destroy functions for all fibers are called before any create functions.
                    // This prevents sibling component effects from interfering with each other,
                    // e.g. a destroy function in one component should never override a ref set
                    // by a create function in another component during the same commit.
                    if (finishedWork.mode & ProfileMode) {
                        try {
                            startLayoutEffectTimer();
                            commitHookEffectListUnmount(Layout | HasEffect, finishedWork, finishedWork.return);
                        } catch (error) {
                            captureCommitPhaseError(finishedWork, finishedWork.return, error);
                        }
                        recordLayoutEffectDuration(finishedWork);
                    } else try {
                        commitHookEffectListUnmount(Layout | HasEffect, finishedWork, finishedWork.return);
                    } catch (error) {
                        captureCommitPhaseError(finishedWork, finishedWork.return, error);
                    }
                }
                return;
            case ClassComponent:
                recursivelyTraverseMutationEffects(root, finishedWork);
                commitReconciliationEffects(finishedWork);
                if (flags & Ref) {
                    if (current !== null) safelyDetachRef(current, current.return);
                }
                return;
            case HostComponent:
                recursivelyTraverseMutationEffects(root, finishedWork);
                commitReconciliationEffects(finishedWork);
                if (flags & Ref) {
                    if (current !== null) safelyDetachRef(current, current.return);
                }
                // TODO: ContentReset gets cleared by the children during the commit
                // phase. This is a refactor hazard because it means we must read
                // flags the flags after `commitReconciliationEffects` has already run;
                // the order matters. We should refactor so that ContentReset does not
                // rely on mutating the flag during commit. Like by setting a flag
                // during the render phase instead.
                if (finishedWork.flags & ContentReset) {
                    var instance = finishedWork.stateNode;
                    try {
                        resetTextContent(instance);
                    } catch (error) {
                        captureCommitPhaseError(finishedWork, finishedWork.return, error);
                    }
                }
                if (flags & Update) {
                    var _instance4 = finishedWork.stateNode;
                    if (_instance4 != null) {
                        // Commit the work prepared earlier.
                        var newProps = finishedWork.memoizedProps; // For hydration we reuse the update path but we treat the oldProps
                        // as the newProps. The updatePayload will contain the real change in
                        // this case.
                        var oldProps = current !== null ? current.memoizedProps : newProps;
                        var type = finishedWork.type; // TODO: Type the updateQueue to be specific to host components.
                        var updatePayload = finishedWork.updateQueue;
                        finishedWork.updateQueue = null;
                        if (updatePayload !== null) try {
                            commitUpdate(_instance4, updatePayload, type, oldProps, newProps, finishedWork);
                        } catch (error) {
                            captureCommitPhaseError(finishedWork, finishedWork.return, error);
                        }
                    }
                }
                return;
            case HostText:
                recursivelyTraverseMutationEffects(root, finishedWork);
                commitReconciliationEffects(finishedWork);
                if (flags & Update) {
                    if (finishedWork.stateNode === null) throw new Error("This should have a text node initialized. This error is likely caused by a bug in React. Please file an issue.");
                    var textInstance = finishedWork.stateNode;
                    var newText = finishedWork.memoizedProps; // For hydration we reuse the update path but we treat the oldProps
                    // as the newProps. The updatePayload will contain the real change in
                    // this case.
                    var oldText = current !== null ? current.memoizedProps : newText;
                    try {
                        commitTextUpdate(textInstance, oldText, newText);
                    } catch (error) {
                        captureCommitPhaseError(finishedWork, finishedWork.return, error);
                    }
                }
                return;
            case HostRoot:
                recursivelyTraverseMutationEffects(root, finishedWork);
                commitReconciliationEffects(finishedWork);
                if (flags & Update) {
                    if (current !== null) {
                        var prevRootState = current.memoizedState;
                        if (prevRootState.isDehydrated) try {
                            commitHydratedContainer(root.containerInfo);
                        } catch (error) {
                            captureCommitPhaseError(finishedWork, finishedWork.return, error);
                        }
                    }
                }
                return;
            case HostPortal:
                recursivelyTraverseMutationEffects(root, finishedWork);
                commitReconciliationEffects(finishedWork);
                return;
            case SuspenseComponent:
                recursivelyTraverseMutationEffects(root, finishedWork);
                commitReconciliationEffects(finishedWork);
                var offscreenFiber = finishedWork.child;
                if (offscreenFiber.flags & Visibility) {
                    var offscreenInstance = offscreenFiber.stateNode;
                    var newState = offscreenFiber.memoizedState;
                    var isHidden = newState !== null; // Track the current state on the Offscreen instance so we can
                    // read it during an event
                    offscreenInstance.isHidden = isHidden;
                    if (isHidden) {
                        var wasHidden = offscreenFiber.alternate !== null && offscreenFiber.alternate.memoizedState !== null;
                        if (!wasHidden) // TODO: Move to passive phase
                        markCommitTimeOfFallback();
                    }
                }
                if (flags & Update) {
                    try {
                        commitSuspenseCallback(finishedWork);
                    } catch (error) {
                        captureCommitPhaseError(finishedWork, finishedWork.return, error);
                    }
                    attachSuspenseRetryListeners(finishedWork);
                }
                return;
            case OffscreenComponent:
                var _wasHidden = current !== null && current.memoizedState !== null;
                if (finishedWork.mode & ConcurrentMode) {
                    // Before committing the children, track on the stack whether this
                    // offscreen subtree was already hidden, so that we don't unmount the
                    // effects again.
                    var prevOffscreenSubtreeWasHidden = offscreenSubtreeWasHidden;
                    offscreenSubtreeWasHidden = prevOffscreenSubtreeWasHidden || _wasHidden;
                    recursivelyTraverseMutationEffects(root, finishedWork);
                    offscreenSubtreeWasHidden = prevOffscreenSubtreeWasHidden;
                } else recursivelyTraverseMutationEffects(root, finishedWork);
                commitReconciliationEffects(finishedWork);
                if (flags & Visibility) {
                    var _offscreenInstance = finishedWork.stateNode;
                    var _newState = finishedWork.memoizedState;
                    var _isHidden = _newState !== null;
                    var offscreenBoundary = finishedWork; // Track the current state on the Offscreen instance so we can
                    // read it during an event
                    _offscreenInstance.isHidden = _isHidden;
                    if (_isHidden) {
                        if (!_wasHidden) {
                            if ((offscreenBoundary.mode & ConcurrentMode) !== NoMode) {
                                nextEffect = offscreenBoundary;
                                var offscreenChild = offscreenBoundary.child;
                                while(offscreenChild !== null){
                                    nextEffect = offscreenChild;
                                    disappearLayoutEffects_begin(offscreenChild);
                                    offscreenChild = offscreenChild.sibling;
                                }
                            }
                        }
                    }
                    // TODO: This needs to run whenever there's an insertion or update
                    // inside a hidden Offscreen tree.
                    hideOrUnhideAllChildren(offscreenBoundary, _isHidden);
                }
                return;
            case SuspenseListComponent:
                recursivelyTraverseMutationEffects(root, finishedWork);
                commitReconciliationEffects(finishedWork);
                if (flags & Update) attachSuspenseRetryListeners(finishedWork);
                return;
            case ScopeComponent:
                return;
            default:
                recursivelyTraverseMutationEffects(root, finishedWork);
                commitReconciliationEffects(finishedWork);
                return;
        }
    }
    function commitReconciliationEffects(finishedWork) {
        // Placement effects (insertions, reorders) can be scheduled on any fiber
        // type. They needs to happen after the children effects have fired, but
        // before the effects on this fiber have fired.
        var flags = finishedWork.flags;
        if (flags & Placement) {
            try {
                commitPlacement(finishedWork);
            } catch (error) {
                captureCommitPhaseError(finishedWork, finishedWork.return, error);
            } // Clear the "placement" from effect tag so that we know that this is
            // inserted, before any life-cycles like componentDidMount gets called.
            // TODO: findDOMNode doesn't rely on this any more but isMounted does
            // and isMounted is deprecated anyway so we should be able to kill this.
            finishedWork.flags &= ~Placement;
        }
        if (flags & Hydrating) finishedWork.flags &= ~Hydrating;
    }
    function commitLayoutEffects(finishedWork, root, committedLanes) {
        inProgressLanes = committedLanes;
        inProgressRoot = root;
        nextEffect = finishedWork;
        commitLayoutEffects_begin(finishedWork, root, committedLanes);
        inProgressLanes = null;
        inProgressRoot = null;
    }
    function commitLayoutEffects_begin(subtreeRoot, root, committedLanes) {
        // Suspense layout effects semantics don't change for legacy roots.
        var isModernRoot = (subtreeRoot.mode & ConcurrentMode) !== NoMode;
        while(nextEffect !== null){
            var fiber = nextEffect;
            var firstChild = fiber.child;
            if (fiber.tag === OffscreenComponent && isModernRoot) {
                // Keep track of the current Offscreen stack's state.
                var isHidden = fiber.memoizedState !== null;
                var newOffscreenSubtreeIsHidden = isHidden || offscreenSubtreeIsHidden;
                if (newOffscreenSubtreeIsHidden) {
                    // The Offscreen tree is hidden. Skip over its layout effects.
                    commitLayoutMountEffects_complete(subtreeRoot, root, committedLanes);
                    continue;
                } else {
                    // TODO (Offscreen) Also check: subtreeFlags & LayoutMask
                    var current = fiber.alternate;
                    var wasHidden = current !== null && current.memoizedState !== null;
                    var newOffscreenSubtreeWasHidden = wasHidden || offscreenSubtreeWasHidden;
                    var prevOffscreenSubtreeIsHidden = offscreenSubtreeIsHidden;
                    var prevOffscreenSubtreeWasHidden = offscreenSubtreeWasHidden; // Traverse the Offscreen subtree with the current Offscreen as the root.
                    offscreenSubtreeIsHidden = newOffscreenSubtreeIsHidden;
                    offscreenSubtreeWasHidden = newOffscreenSubtreeWasHidden;
                    if (offscreenSubtreeWasHidden && !prevOffscreenSubtreeWasHidden) {
                        // This is the root of a reappearing boundary. Turn its layout effects
                        // back on.
                        nextEffect = fiber;
                        reappearLayoutEffects_begin(fiber);
                    }
                    var child = firstChild;
                    while(child !== null){
                        nextEffect = child;
                        commitLayoutEffects_begin(child, root, committedLanes);
                        child = child.sibling;
                    } // Restore Offscreen state and resume in our-progress traversal.
                    nextEffect = fiber;
                    offscreenSubtreeIsHidden = prevOffscreenSubtreeIsHidden;
                    offscreenSubtreeWasHidden = prevOffscreenSubtreeWasHidden;
                    commitLayoutMountEffects_complete(subtreeRoot, root, committedLanes);
                    continue;
                }
            }
            if ((fiber.subtreeFlags & LayoutMask) !== NoFlags && firstChild !== null) {
                firstChild.return = fiber;
                nextEffect = firstChild;
            } else commitLayoutMountEffects_complete(subtreeRoot, root, committedLanes);
        }
    }
    function commitLayoutMountEffects_complete(subtreeRoot, root, committedLanes) {
        while(nextEffect !== null){
            var fiber = nextEffect;
            if ((fiber.flags & LayoutMask) !== NoFlags) {
                var current = fiber.alternate;
                setCurrentFiber(fiber);
                try {
                    commitLayoutEffectOnFiber(root, current, fiber, committedLanes);
                } catch (error) {
                    captureCommitPhaseError(fiber, fiber.return, error);
                }
                resetCurrentFiber();
            }
            if (fiber === subtreeRoot) {
                nextEffect = null;
                return;
            }
            var sibling = fiber.sibling;
            if (sibling !== null) {
                sibling.return = fiber.return;
                nextEffect = sibling;
                return;
            }
            nextEffect = fiber.return;
        }
    }
    function disappearLayoutEffects_begin(subtreeRoot) {
        while(nextEffect !== null){
            var fiber = nextEffect;
            var firstChild = fiber.child; // TODO (Offscreen) Check: flags & (RefStatic | LayoutStatic)
            switch(fiber.tag){
                case FunctionComponent:
                case ForwardRef:
                case MemoComponent:
                case SimpleMemoComponent:
                    if (fiber.mode & ProfileMode) try {
                        startLayoutEffectTimer();
                        commitHookEffectListUnmount(Layout, fiber, fiber.return);
                    } finally{
                        recordLayoutEffectDuration(fiber);
                    }
                    else commitHookEffectListUnmount(Layout, fiber, fiber.return);
                    break;
                case ClassComponent:
                    // TODO (Offscreen) Check: flags & RefStatic
                    safelyDetachRef(fiber, fiber.return);
                    var instance = fiber.stateNode;
                    if (typeof instance.componentWillUnmount === "function") safelyCallComponentWillUnmount(fiber, fiber.return, instance);
                    break;
                case HostComponent:
                    safelyDetachRef(fiber, fiber.return);
                    break;
                case OffscreenComponent:
                    // Check if this is a
                    var isHidden = fiber.memoizedState !== null;
                    if (isHidden) {
                        // Nested Offscreen tree is already hidden. Don't disappear
                        // its effects.
                        disappearLayoutEffects_complete(subtreeRoot);
                        continue;
                    }
                    break;
            } // TODO (Offscreen) Check: subtreeFlags & LayoutStatic
            if (firstChild !== null) {
                firstChild.return = fiber;
                nextEffect = firstChild;
            } else disappearLayoutEffects_complete(subtreeRoot);
        }
    }
    function disappearLayoutEffects_complete(subtreeRoot) {
        while(nextEffect !== null){
            var fiber = nextEffect;
            if (fiber === subtreeRoot) {
                nextEffect = null;
                return;
            }
            var sibling = fiber.sibling;
            if (sibling !== null) {
                sibling.return = fiber.return;
                nextEffect = sibling;
                return;
            }
            nextEffect = fiber.return;
        }
    }
    function reappearLayoutEffects_begin(subtreeRoot) {
        while(nextEffect !== null){
            var fiber = nextEffect;
            var firstChild = fiber.child;
            if (fiber.tag === OffscreenComponent) {
                var isHidden = fiber.memoizedState !== null;
                if (isHidden) {
                    // Nested Offscreen tree is still hidden. Don't re-appear its effects.
                    reappearLayoutEffects_complete(subtreeRoot);
                    continue;
                }
            } // TODO (Offscreen) Check: subtreeFlags & LayoutStatic
            if (firstChild !== null) {
                // This node may have been reused from a previous render, so we can't
                // assume its return pointer is correct.
                firstChild.return = fiber;
                nextEffect = firstChild;
            } else reappearLayoutEffects_complete(subtreeRoot);
        }
    }
    function reappearLayoutEffects_complete(subtreeRoot) {
        while(nextEffect !== null){
            var fiber = nextEffect; // TODO (Offscreen) Check: flags & LayoutStatic
            setCurrentFiber(fiber);
            try {
                reappearLayoutEffectsOnFiber(fiber);
            } catch (error) {
                captureCommitPhaseError(fiber, fiber.return, error);
            }
            resetCurrentFiber();
            if (fiber === subtreeRoot) {
                nextEffect = null;
                return;
            }
            var sibling = fiber.sibling;
            if (sibling !== null) {
                // This node may have been reused from a previous render, so we can't
                // assume its return pointer is correct.
                sibling.return = fiber.return;
                nextEffect = sibling;
                return;
            }
            nextEffect = fiber.return;
        }
    }
    function commitPassiveMountEffects(root, finishedWork, committedLanes, committedTransitions) {
        nextEffect = finishedWork;
        commitPassiveMountEffects_begin(finishedWork, root, committedLanes, committedTransitions);
    }
    function commitPassiveMountEffects_begin(subtreeRoot, root, committedLanes, committedTransitions) {
        while(nextEffect !== null){
            var fiber = nextEffect;
            var firstChild = fiber.child;
            if ((fiber.subtreeFlags & PassiveMask) !== NoFlags && firstChild !== null) {
                firstChild.return = fiber;
                nextEffect = firstChild;
            } else commitPassiveMountEffects_complete(subtreeRoot, root, committedLanes, committedTransitions);
        }
    }
    function commitPassiveMountEffects_complete(subtreeRoot, root, committedLanes, committedTransitions) {
        while(nextEffect !== null){
            var fiber = nextEffect;
            if ((fiber.flags & Passive) !== NoFlags) {
                setCurrentFiber(fiber);
                try {
                    commitPassiveMountOnFiber(root, fiber, committedLanes, committedTransitions);
                } catch (error) {
                    captureCommitPhaseError(fiber, fiber.return, error);
                }
                resetCurrentFiber();
            }
            if (fiber === subtreeRoot) {
                nextEffect = null;
                return;
            }
            var sibling = fiber.sibling;
            if (sibling !== null) {
                sibling.return = fiber.return;
                nextEffect = sibling;
                return;
            }
            nextEffect = fiber.return;
        }
    }
    function commitPassiveMountOnFiber(finishedRoot, finishedWork, committedLanes, committedTransitions) {
        switch(finishedWork.tag){
            case FunctionComponent:
            case ForwardRef:
            case SimpleMemoComponent:
                if (finishedWork.mode & ProfileMode) {
                    startPassiveEffectTimer();
                    try {
                        commitHookEffectListMount(Passive$1 | HasEffect, finishedWork);
                    } finally{
                        recordPassiveEffectDuration(finishedWork);
                    }
                } else commitHookEffectListMount(Passive$1 | HasEffect, finishedWork);
                break;
        }
    }
    function commitPassiveUnmountEffects(firstChild) {
        nextEffect = firstChild;
        commitPassiveUnmountEffects_begin();
    }
    function commitPassiveUnmountEffects_begin() {
        while(nextEffect !== null){
            var fiber = nextEffect;
            var child = fiber.child;
            if ((nextEffect.flags & ChildDeletion) !== NoFlags) {
                var deletions = fiber.deletions;
                if (deletions !== null) {
                    for(var i = 0; i < deletions.length; i++){
                        var fiberToDelete = deletions[i];
                        nextEffect = fiberToDelete;
                        commitPassiveUnmountEffectsInsideOfDeletedTree_begin(fiberToDelete, fiber);
                    }
                    // A fiber was deleted from this parent fiber, but it's still part of
                    // the previous (alternate) parent fiber's list of children. Because
                    // children are a linked list, an earlier sibling that's still alive
                    // will be connected to the deleted fiber via its `alternate`:
                    //
                    //   live fiber
                    //   --alternate--> previous live fiber
                    //   --sibling--> deleted fiber
                    //
                    // We can't disconnect `alternate` on nodes that haven't been deleted
                    // yet, but we can disconnect the `sibling` and `child` pointers.
                    var previousFiber = fiber.alternate;
                    if (previousFiber !== null) {
                        var detachedChild = previousFiber.child;
                        if (detachedChild !== null) {
                            previousFiber.child = null;
                            do {
                                var detachedSibling = detachedChild.sibling;
                                detachedChild.sibling = null;
                                detachedChild = detachedSibling;
                            }while (detachedChild !== null);
                        }
                    }
                    nextEffect = fiber;
                }
            }
            if ((fiber.subtreeFlags & PassiveMask) !== NoFlags && child !== null) {
                child.return = fiber;
                nextEffect = child;
            } else commitPassiveUnmountEffects_complete();
        }
    }
    function commitPassiveUnmountEffects_complete() {
        while(nextEffect !== null){
            var fiber = nextEffect;
            if ((fiber.flags & Passive) !== NoFlags) {
                setCurrentFiber(fiber);
                commitPassiveUnmountOnFiber(fiber);
                resetCurrentFiber();
            }
            var sibling = fiber.sibling;
            if (sibling !== null) {
                sibling.return = fiber.return;
                nextEffect = sibling;
                return;
            }
            nextEffect = fiber.return;
        }
    }
    function commitPassiveUnmountOnFiber(finishedWork) {
        switch(finishedWork.tag){
            case FunctionComponent:
            case ForwardRef:
            case SimpleMemoComponent:
                if (finishedWork.mode & ProfileMode) {
                    startPassiveEffectTimer();
                    commitHookEffectListUnmount(Passive$1 | HasEffect, finishedWork, finishedWork.return);
                    recordPassiveEffectDuration(finishedWork);
                } else commitHookEffectListUnmount(Passive$1 | HasEffect, finishedWork, finishedWork.return);
                break;
        }
    }
    function commitPassiveUnmountEffectsInsideOfDeletedTree_begin(deletedSubtreeRoot, nearestMountedAncestor) {
        while(nextEffect !== null){
            var fiber = nextEffect; // Deletion effects fire in parent -> child order
            // TODO: Check if fiber has a PassiveStatic flag
            setCurrentFiber(fiber);
            commitPassiveUnmountInsideDeletedTreeOnFiber(fiber, nearestMountedAncestor);
            resetCurrentFiber();
            var child = fiber.child; // TODO: Only traverse subtree if it has a PassiveStatic flag. (But, if we
            // do this, still need to handle `deletedTreeCleanUpLevel` correctly.)
            if (child !== null) {
                child.return = fiber;
                nextEffect = child;
            } else commitPassiveUnmountEffectsInsideOfDeletedTree_complete(deletedSubtreeRoot);
        }
    }
    function commitPassiveUnmountEffectsInsideOfDeletedTree_complete(deletedSubtreeRoot) {
        while(nextEffect !== null){
            var fiber = nextEffect;
            var sibling = fiber.sibling;
            var returnFiber = fiber.return;
            // Recursively traverse the entire deleted tree and clean up fiber fields.
            // This is more aggressive than ideal, and the long term goal is to only
            // have to detach the deleted tree at the root.
            detachFiberAfterEffects(fiber);
            if (fiber === deletedSubtreeRoot) {
                nextEffect = null;
                return;
            }
            if (sibling !== null) {
                sibling.return = returnFiber;
                nextEffect = sibling;
                return;
            }
            nextEffect = returnFiber;
        }
    }
    function commitPassiveUnmountInsideDeletedTreeOnFiber(current, nearestMountedAncestor) {
        switch(current.tag){
            case FunctionComponent:
            case ForwardRef:
            case SimpleMemoComponent:
                if (current.mode & ProfileMode) {
                    startPassiveEffectTimer();
                    commitHookEffectListUnmount(Passive$1, current, nearestMountedAncestor);
                    recordPassiveEffectDuration(current);
                } else commitHookEffectListUnmount(Passive$1, current, nearestMountedAncestor);
                break;
        }
    } // TODO: Reuse reappearLayoutEffects traversal here?
    function invokeLayoutEffectMountInDEV(fiber) {
        // We don't need to re-check StrictEffectsMode here.
        // This function is only called if that check has already passed.
        switch(fiber.tag){
            case FunctionComponent:
            case ForwardRef:
            case SimpleMemoComponent:
                try {
                    commitHookEffectListMount(Layout | HasEffect, fiber);
                } catch (error) {
                    captureCommitPhaseError(fiber, fiber.return, error);
                }
                break;
            case ClassComponent:
                var instance = fiber.stateNode;
                try {
                    instance.componentDidMount();
                } catch (error) {
                    captureCommitPhaseError(fiber, fiber.return, error);
                }
                break;
        }
    }
    function invokePassiveEffectMountInDEV(fiber) {
        // We don't need to re-check StrictEffectsMode here.
        // This function is only called if that check has already passed.
        switch(fiber.tag){
            case FunctionComponent:
            case ForwardRef:
            case SimpleMemoComponent:
                try {
                    commitHookEffectListMount(Passive$1 | HasEffect, fiber);
                } catch (error) {
                    captureCommitPhaseError(fiber, fiber.return, error);
                }
                break;
        }
    }
    function invokeLayoutEffectUnmountInDEV(fiber) {
        // We don't need to re-check StrictEffectsMode here.
        // This function is only called if that check has already passed.
        switch(fiber.tag){
            case FunctionComponent:
            case ForwardRef:
            case SimpleMemoComponent:
                try {
                    commitHookEffectListUnmount(Layout | HasEffect, fiber, fiber.return);
                } catch (error) {
                    captureCommitPhaseError(fiber, fiber.return, error);
                }
                break;
            case ClassComponent:
                var instance = fiber.stateNode;
                if (typeof instance.componentWillUnmount === "function") safelyCallComponentWillUnmount(fiber, fiber.return, instance);
                break;
        }
    }
    function invokePassiveEffectUnmountInDEV(fiber) {
        // We don't need to re-check StrictEffectsMode here.
        // This function is only called if that check has already passed.
        switch(fiber.tag){
            case FunctionComponent:
            case ForwardRef:
            case SimpleMemoComponent:
                try {
                    commitHookEffectListUnmount(Passive$1 | HasEffect, fiber, fiber.return);
                } catch (error) {
                    captureCommitPhaseError(fiber, fiber.return, error);
                }
        }
    }
    var COMPONENT_TYPE = 0;
    var HAS_PSEUDO_CLASS_TYPE = 1;
    var ROLE_TYPE = 2;
    var TEST_NAME_TYPE = 3;
    var TEXT_TYPE = 4;
    if (typeof Symbol === "function" && Symbol.for) {
        var symbolFor = Symbol.for;
        COMPONENT_TYPE = symbolFor("selector.component");
        HAS_PSEUDO_CLASS_TYPE = symbolFor("selector.has_pseudo_class");
        ROLE_TYPE = symbolFor("selector.role");
        TEST_NAME_TYPE = symbolFor("selector.test_id");
        TEXT_TYPE = symbolFor("selector.text");
    }
    var commitHooks = [];
    function onCommitRoot$1() {
        commitHooks.forEach(function(commitHook) {
            return commitHook();
        });
    }
    var ReactCurrentActQueue = ReactSharedInternals.ReactCurrentActQueue;
    function isLegacyActEnvironment(fiber) {
        // Legacy mode. We preserve the behavior of React 17's act. It assumes an
        // act environment whenever `jest` is defined, but you can still turn off
        // spurious warnings by setting IS_REACT_ACT_ENVIRONMENT explicitly
        // to false.
        var isReactActEnvironmentGlobal = typeof IS_REACT_ACT_ENVIRONMENT !== "undefined" ? IS_REACT_ACT_ENVIRONMENT : undefined; // $FlowExpectedError - Flow doesn't know about jest
        var jestIsDefined = typeof jest !== "undefined";
        return jestIsDefined && isReactActEnvironmentGlobal !== false;
    }
    function isConcurrentActEnvironment() {
        var isReactActEnvironmentGlobal = typeof IS_REACT_ACT_ENVIRONMENT !== "undefined" ? IS_REACT_ACT_ENVIRONMENT : undefined;
        if (!isReactActEnvironmentGlobal && ReactCurrentActQueue.current !== null) // TODO: Include link to relevant documentation page.
        error("The current testing environment is not configured to support act(...)");
        return isReactActEnvironmentGlobal;
    }
    var ceil = Math.ceil;
    var ReactCurrentDispatcher$2 = ReactSharedInternals.ReactCurrentDispatcher, ReactCurrentOwner$2 = ReactSharedInternals.ReactCurrentOwner, ReactCurrentBatchConfig$3 = ReactSharedInternals.ReactCurrentBatchConfig, ReactCurrentActQueue$1 = ReactSharedInternals.ReactCurrentActQueue;
    var NoContext = /*             */ 0;
    var BatchedContext = /*               */ 1;
    var RenderContext = /*                */ 2;
    var CommitContext = /*                */ 4;
    var RootInProgress = 0;
    var RootFatalErrored = 1;
    var RootErrored = 2;
    var RootSuspended = 3;
    var RootSuspendedWithDelay = 4;
    var RootCompleted = 5;
    var RootDidNotComplete = 6; // Describes where we are in the React execution stack
    var executionContext = NoContext; // The root we're working on
    var workInProgressRoot = null; // The fiber we're working on
    var workInProgress = null; // The lanes we're rendering
    var workInProgressRootRenderLanes = NoLanes; // Stack that allows components to change the render lanes for its subtree
    // This is a superset of the lanes we started working on at the root. The only
    // case where it's different from `workInProgressRootRenderLanes` is when we
    // enter a subtree that is hidden and needs to be unhidden: Suspense and
    // Offscreen component.
    //
    // Most things in the work loop should deal with workInProgressRootRenderLanes.
    // Most things in begin/complete phases should deal with subtreeRenderLanes.
    var subtreeRenderLanes = NoLanes;
    var subtreeRenderLanesCursor = createCursor(NoLanes); // Whether to root completed, errored, suspended, etc.
    var workInProgressRootExitStatus = RootInProgress; // A fatal error, if one is thrown
    var workInProgressRootFatalError = null; // "Included" lanes refer to lanes that were worked on during this render. It's
    // slightly different than `renderLanes` because `renderLanes` can change as you
    // enter and exit an Offscreen tree. This value is the combination of all render
    // lanes for the entire render phase.
    var workInProgressRootIncludedLanes = NoLanes; // The work left over by components that were visited during this render. Only
    // includes unprocessed updates, not work in bailed out children.
    var workInProgressRootSkippedLanes = NoLanes; // Lanes that were updated (in an interleaved event) during this render.
    var workInProgressRootInterleavedUpdatedLanes = NoLanes; // Lanes that were updated during the render phase (*not* an interleaved event).
    var workInProgressRootPingedLanes = NoLanes; // Errors that are thrown during the render phase.
    var workInProgressRootConcurrentErrors = null; // These are errors that we recovered from without surfacing them to the UI.
    // We will log them once the tree commits.
    var workInProgressRootRecoverableErrors = null; // The most recent time we committed a fallback. This lets us ensure a train
    // model where we don't commit new loading states in too quick succession.
    var globalMostRecentFallbackTime = 0;
    var FALLBACK_THROTTLE_MS = 500; // The absolute time for when we should start giving up on rendering
    // more and prefer CPU suspense heuristics instead.
    var workInProgressRootRenderTargetTime = Infinity; // How long a render is supposed to take before we start following CPU
    // suspense heuristics and opt out of rendering more content.
    var RENDER_TIMEOUT_MS = 500;
    var workInProgressTransitions = null;
    function resetRenderTimer() {
        workInProgressRootRenderTargetTime = now() + RENDER_TIMEOUT_MS;
    }
    function getRenderTargetTime() {
        return workInProgressRootRenderTargetTime;
    }
    var hasUncaughtError = false;
    var firstUncaughtError = null;
    var legacyErrorBoundariesThatAlreadyFailed = null; // Only used when enableProfilerNestedUpdateScheduledHook is true;
    var rootDoesHavePassiveEffects = false;
    var rootWithPendingPassiveEffects = null;
    var pendingPassiveEffectsLanes = NoLanes;
    var pendingPassiveProfilerEffects = [];
    var pendingPassiveTransitions = null; // Use these to prevent an infinite loop of nested updates
    var NESTED_UPDATE_LIMIT = 50;
    var nestedUpdateCount = 0;
    var rootWithNestedUpdates = null;
    var isFlushingPassiveEffects = false;
    var didScheduleUpdateDuringPassiveEffects = false;
    var NESTED_PASSIVE_UPDATE_LIMIT = 50;
    var nestedPassiveUpdateCount = 0;
    var rootWithPassiveNestedUpdates = null; // If two updates are scheduled within the same event, we should treat their
    // event times as simultaneous, even if the actual clock time has advanced
    // between the first and second call.
    var currentEventTime = NoTimestamp;
    var currentEventTransitionLane = NoLanes;
    var isRunningInsertionEffect = false;
    function getWorkInProgressRoot() {
        return workInProgressRoot;
    }
    function requestEventTime() {
        if ((executionContext & (RenderContext | CommitContext)) !== NoContext) // We're inside React, so it's fine to read the actual time.
        return now();
         // We're not inside React, so we may be in the middle of a browser event.
        if (currentEventTime !== NoTimestamp) // Use the same start time for all updates until we enter React again.
        return currentEventTime;
         // This is the first update since React yielded. Compute a new start time.
        currentEventTime = now();
        return currentEventTime;
    }
    function requestUpdateLane(fiber) {
        // Special cases
        var mode = fiber.mode;
        if ((mode & ConcurrentMode) === NoMode) return SyncLane;
        else if ((executionContext & RenderContext) !== NoContext && workInProgressRootRenderLanes !== NoLanes) // This is a render phase update. These are not officially supported. The
        // old behavior is to give this the same "thread" (lanes) as
        // whatever is currently rendering. So if you call `setState` on a component
        // that happens later in the same render, it will flush. Ideally, we want to
        // remove the special case and treat them as if they came from an
        // interleaved event. Regardless, this pattern is not officially supported.
        // This behavior is only a fallback. The flag only exists until we can roll
        // out the setState warning, since existing code might accidentally rely on
        // the current behavior.
        return pickArbitraryLane(workInProgressRootRenderLanes);
        var isTransition = requestCurrentTransition() !== NoTransition;
        if (isTransition) {
            if (ReactCurrentBatchConfig$3.transition !== null) {
                var transition = ReactCurrentBatchConfig$3.transition;
                if (!transition._updatedFibers) transition._updatedFibers = new Set();
                transition._updatedFibers.add(fiber);
            } // The algorithm for assigning an update to a lane should be stable for all
            // updates at the same priority within the same event. To do this, the
            // inputs to the algorithm must be the same.
            //
            // The trick we use is to cache the first of each of these inputs within an
            // event. Then reset the cached values once we can be sure the event is
            // over. Our heuristic for that is whenever we enter a concurrent work loop.
            if (currentEventTransitionLane === NoLane) // All transitions within the same event are assigned the same lane.
            currentEventTransitionLane = claimNextTransitionLane();
            return currentEventTransitionLane;
        } // Updates originating inside certain React methods, like flushSync, have
        // their priority set by tracking it with a context variable.
        //
        // The opaque type returned by the host config is internally a lane, so we can
        // use that directly.
        // TODO: Move this type conversion to the event priority module.
        var updateLane = getCurrentUpdatePriority();
        if (updateLane !== NoLane) return updateLane;
         // This update originated outside React. Ask the host environment for an
        // appropriate priority, based on the type of event.
        //
        // The opaque type returned by the host config is internally a lane, so we can
        // use that directly.
        // TODO: Move this type conversion to the event priority module.
        var eventLane = getCurrentEventPriority();
        return eventLane;
    }
    function requestRetryLane(fiber) {
        // This is a fork of `requestUpdateLane` designed specifically for Suspense
        // "retries" — a special update that attempts to flip a Suspense boundary
        // from its placeholder state to its primary/resolved state.
        // Special cases
        var mode = fiber.mode;
        if ((mode & ConcurrentMode) === NoMode) return SyncLane;
        return claimNextRetryLane();
    }
    function scheduleUpdateOnFiber(root, fiber, lane, eventTime) {
        checkForNestedUpdates();
        if (isRunningInsertionEffect) error("useInsertionEffect must not schedule updates.");
        if (isFlushingPassiveEffects) didScheduleUpdateDuringPassiveEffects = true;
        markRootUpdated(root, lane, eventTime);
        if ((executionContext & RenderContext) !== NoLanes && root === workInProgressRoot) // This update was dispatched during the render phase. This is a mistake
        // if the update originates from user space (with the exception of local
        // hook updates, which are handled differently and don't reach this
        // function), but there are some internal React features that use this as
        // an implementation detail, like selective hydration.
        warnAboutRenderPhaseUpdatesInDEV(fiber); // Track lanes that were updated during the render phase
        else {
            if (isDevToolsPresent) addFiberToLanesMap(root, fiber, lane);
            warnIfUpdatesNotWrappedWithActDEV(fiber);
            if (root === workInProgressRoot) {
                // Received an update to a tree that's in the middle of rendering. Mark
                // that there was an interleaved update work on this root. Unless the
                // `deferRenderPhaseUpdateToNextBatch` flag is off and this is a render
                // phase update. In that case, we don't treat render phase updates as if
                // they were interleaved, for backwards compat reasons.
                if ((executionContext & RenderContext) === NoContext) workInProgressRootInterleavedUpdatedLanes = mergeLanes(workInProgressRootInterleavedUpdatedLanes, lane);
                if (workInProgressRootExitStatus === RootSuspendedWithDelay) // The root already suspended with a delay, which means this render
                // definitely won't finish. Since we have a new update, let's mark it as
                // suspended now, right before marking the incoming update. This has the
                // effect of interrupting the current render and switching to the update.
                // TODO: Make sure this doesn't override pings that happen while we've
                // already started rendering.
                markRootSuspended$1(root, workInProgressRootRenderLanes);
            }
            ensureRootIsScheduled(root, eventTime);
            if (lane === SyncLane && executionContext === NoContext && (fiber.mode & ConcurrentMode) === NoMode && // Treat `act` as if it's inside `batchedUpdates`, even in legacy mode.
            !ReactCurrentActQueue$1.isBatchingLegacy) {
                // Flush the synchronous work now, unless we're already working or inside
                // a batch. This is intentionally inside scheduleUpdateOnFiber instead of
                // scheduleCallbackForFiber to preserve the ability to schedule a callback
                // without immediately flushing it. We only do this for user-initiated
                // updates, to preserve historical behavior of legacy mode.
                resetRenderTimer();
                flushSyncCallbacksOnlyInLegacyMode();
            }
        }
    }
    function scheduleInitialHydrationOnRoot(root, lane, eventTime) {
        // This is a special fork of scheduleUpdateOnFiber that is only used to
        // schedule the initial hydration of a root that has just been created. Most
        // of the stuff in scheduleUpdateOnFiber can be skipped.
        //
        // The main reason for this separate path, though, is to distinguish the
        // initial children from subsequent updates. In fully client-rendered roots
        // (createRoot instead of hydrateRoot), all top-level renders are modeled as
        // updates, but hydration roots are special because the initial render must
        // match what was rendered on the server.
        var current = root.current;
        current.lanes = lane;
        markRootUpdated(root, lane, eventTime);
        ensureRootIsScheduled(root, eventTime);
    }
    function isUnsafeClassRenderPhaseUpdate(fiber) {
        // Check if this is a render phase update. Only called by class components,
        // which special (deprecated) behavior for UNSAFE_componentWillReceive props.
        return(// decided not to enable it.
        (executionContext & RenderContext) !== NoContext);
    } // Use this function to schedule a task for a root. There's only one task per
    // root; if a task was already scheduled, we'll check to make sure the priority
    // of the existing task is the same as the priority of the next level that the
    // root has work on. This function is called on every update, and right before
    // exiting a task.
    function ensureRootIsScheduled(root, currentTime) {
        var existingCallbackNode = root.callbackNode; // Check if any lanes are being starved by other work. If so, mark them as
        // expired so we know to work on those next.
        markStarvedLanesAsExpired(root, currentTime); // Determine the next lanes to work on, and their priority.
        var nextLanes = getNextLanes(root, root === workInProgressRoot ? workInProgressRootRenderLanes : NoLanes);
        if (nextLanes === NoLanes) {
            // Special case: There's nothing to work on.
            if (existingCallbackNode !== null) cancelCallback$1(existingCallbackNode);
            root.callbackNode = null;
            root.callbackPriority = NoLane;
            return;
        } // We use the highest priority lane to represent the priority of the callback.
        var newCallbackPriority = getHighestPriorityLane(nextLanes); // Check if there's an existing task. We may be able to reuse it.
        var existingCallbackPriority = root.callbackPriority;
        if (existingCallbackPriority === newCallbackPriority && // Special case related to `act`. If the currently scheduled task is a
        // Scheduler task, rather than an `act` task, cancel it and re-scheduled
        // on the `act` queue.
        !(ReactCurrentActQueue$1.current !== null && existingCallbackNode !== fakeActCallbackNode)) {
            // If we're going to re-use an existing task, it needs to exist.
            // Assume that discrete update microtasks are non-cancellable and null.
            // TODO: Temporary until we confirm this warning is not fired.
            if (existingCallbackNode == null && existingCallbackPriority !== SyncLane) error("Expected scheduled callback to exist. This error is likely caused by a bug in React. Please file an issue.");
            return;
        }
        if (existingCallbackNode != null) // Cancel the existing callback. We'll schedule a new one below.
        cancelCallback$1(existingCallbackNode);
         // Schedule a new callback.
        var newCallbackNode;
        if (newCallbackPriority === SyncLane) {
            // Special case: Sync React callbacks are scheduled on a special
            // internal queue
            if (root.tag === LegacyRoot) {
                if (ReactCurrentActQueue$1.isBatchingLegacy !== null) ReactCurrentActQueue$1.didScheduleLegacyUpdate = true;
                scheduleLegacySyncCallback(performSyncWorkOnRoot.bind(null, root));
            } else scheduleSyncCallback(performSyncWorkOnRoot.bind(null, root));
            // Flush the queue in a microtask.
            if (ReactCurrentActQueue$1.current !== null) // Inside `act`, use our internal `act` queue so that these get flushed
            // at the end of the current scope even when using the sync version
            // of `act`.
            ReactCurrentActQueue$1.current.push(flushSyncCallbacks);
            else scheduleMicrotask(function() {
                // In Safari, appending an iframe forces microtasks to run.
                // https://github.com/facebook/react/issues/22459
                // We don't support running callbacks in the middle of render
                // or commit so we need to check against that.
                if ((executionContext & (RenderContext | CommitContext)) === NoContext) // Note that this would still prematurely flush the callbacks
                // if this happens outside render or commit phase (e.g. in an event).
                flushSyncCallbacks();
            });
            newCallbackNode = null;
        } else {
            var schedulerPriorityLevel;
            switch(lanesToEventPriority(nextLanes)){
                case DiscreteEventPriority:
                    schedulerPriorityLevel = ImmediatePriority;
                    break;
                case ContinuousEventPriority:
                    schedulerPriorityLevel = UserBlockingPriority;
                    break;
                case DefaultEventPriority:
                    schedulerPriorityLevel = NormalPriority;
                    break;
                case IdleEventPriority:
                    schedulerPriorityLevel = IdlePriority;
                    break;
                default:
                    schedulerPriorityLevel = NormalPriority;
                    break;
            }
            newCallbackNode = scheduleCallback$1(schedulerPriorityLevel, performConcurrentWorkOnRoot.bind(null, root));
        }
        root.callbackPriority = newCallbackPriority;
        root.callbackNode = newCallbackNode;
    } // This is the entry point for every concurrent task, i.e. anything that
    // goes through Scheduler.
    function performConcurrentWorkOnRoot(root, didTimeout) {
        resetNestedUpdateFlag();
        // event time. The next update will compute a new event time.
        currentEventTime = NoTimestamp;
        currentEventTransitionLane = NoLanes;
        if ((executionContext & (RenderContext | CommitContext)) !== NoContext) throw new Error("Should not already be working.");
         // Flush any pending passive effects before deciding which lanes to work on,
        // in case they schedule additional work.
        var originalCallbackNode = root.callbackNode;
        var didFlushPassiveEffects = flushPassiveEffects();
        if (didFlushPassiveEffects) {
            // Something in the passive effect phase may have canceled the current task.
            // Check if the task node for this root was changed.
            if (root.callbackNode !== originalCallbackNode) // The current task was canceled. Exit. We don't need to call
            // `ensureRootIsScheduled` because the check above implies either that
            // there's a new task, or that there's no remaining work on this root.
            return null;
        } // Determine the next lanes to work on, using the fields stored
        // on the root.
        var lanes = getNextLanes(root, root === workInProgressRoot ? workInProgressRootRenderLanes : NoLanes);
        if (lanes === NoLanes) // Defensive coding. This is never expected to happen.
        return null;
         // We disable time-slicing in some cases: if the work has been CPU-bound
        // for too long ("expired" work, to prevent starvation), or we're in
        // sync-updates-by-default mode.
        // TODO: We only check `didTimeout` defensively, to account for a Scheduler
        // bug we're still investigating. Once the bug in Scheduler is fixed,
        // we can remove this, since we track expiration ourselves.
        var shouldTimeSlice = !includesBlockingLane(root, lanes) && !includesExpiredLane(root, lanes) && !didTimeout;
        var exitStatus = shouldTimeSlice ? renderRootConcurrent(root, lanes) : renderRootSync(root, lanes);
        if (exitStatus !== RootInProgress) {
            if (exitStatus === RootErrored) {
                // If something threw an error, try rendering one more time. We'll
                // render synchronously to block concurrent data mutations, and we'll
                // includes all pending updates are included. If it still fails after
                // the second attempt, we'll give up and commit the resulting tree.
                var errorRetryLanes = getLanesToRetrySynchronouslyOnError(root);
                if (errorRetryLanes !== NoLanes) {
                    lanes = errorRetryLanes;
                    exitStatus = recoverFromConcurrentError(root, errorRetryLanes);
                }
            }
            if (exitStatus === RootFatalErrored) {
                var fatalError = workInProgressRootFatalError;
                prepareFreshStack(root, NoLanes);
                markRootSuspended$1(root, lanes);
                ensureRootIsScheduled(root, now());
                throw fatalError;
            }
            if (exitStatus === RootDidNotComplete) // The render unwound without completing the tree. This happens in special
            // cases where need to exit the current render without producing a
            // consistent tree or committing.
            //
            // This should only happen during a concurrent render, not a discrete or
            // synchronous update. We should have already checked for this when we
            // unwound the stack.
            markRootSuspended$1(root, lanes);
            else {
                // The render completed.
                // Check if this render may have yielded to a concurrent event, and if so,
                // confirm that any newly rendered stores are consistent.
                // TODO: It's possible that even a concurrent render may never have yielded
                // to the main thread, if it was fast enough, or if it expired. We could
                // skip the consistency check in that case, too.
                var renderWasConcurrent = !includesBlockingLane(root, lanes);
                var finishedWork = root.current.alternate;
                if (renderWasConcurrent && !isRenderConsistentWithExternalStores(finishedWork)) {
                    // A store was mutated in an interleaved event. Render again,
                    // synchronously, to block further mutations.
                    exitStatus = renderRootSync(root, lanes); // We need to check again if something threw
                    if (exitStatus === RootErrored) {
                        var _errorRetryLanes = getLanesToRetrySynchronouslyOnError(root);
                        if (_errorRetryLanes !== NoLanes) {
                            lanes = _errorRetryLanes;
                            exitStatus = recoverFromConcurrentError(root, _errorRetryLanes); // We assume the tree is now consistent because we didn't yield to any
                        // concurrent events.
                        }
                    }
                    if (exitStatus === RootFatalErrored) {
                        var _fatalError = workInProgressRootFatalError;
                        prepareFreshStack(root, NoLanes);
                        markRootSuspended$1(root, lanes);
                        ensureRootIsScheduled(root, now());
                        throw _fatalError;
                    }
                } // We now have a consistent tree. The next step is either to commit it,
                // or, if something suspended, wait to commit it after a timeout.
                root.finishedWork = finishedWork;
                root.finishedLanes = lanes;
                finishConcurrentRender(root, exitStatus, lanes);
            }
        }
        ensureRootIsScheduled(root, now());
        if (root.callbackNode === originalCallbackNode) // The task node scheduled for this root is the same one that's
        // currently executed. Need to return a continuation.
        return performConcurrentWorkOnRoot.bind(null, root);
        return null;
    }
    function recoverFromConcurrentError(root, errorRetryLanes) {
        // If an error occurred during hydration, discard server response and fall
        // back to client side render.
        // Before rendering again, save the errors from the previous attempt.
        var errorsFromFirstAttempt = workInProgressRootConcurrentErrors;
        if (isRootDehydrated(root)) {
            // The shell failed to hydrate. Set a flag to force a client rendering
            // during the next attempt. To do this, we call prepareFreshStack now
            // to create the root work-in-progress fiber. This is a bit weird in terms
            // of factoring, because it relies on renderRootSync not calling
            // prepareFreshStack again in the call below, which happens because the
            // root and lanes haven't changed.
            //
            // TODO: I think what we should do is set ForceClientRender inside
            // throwException, like we do for nested Suspense boundaries. The reason
            // it's here instead is so we can switch to the synchronous work loop, too.
            // Something to consider for a future refactor.
            var rootWorkInProgress = prepareFreshStack(root, errorRetryLanes);
            rootWorkInProgress.flags |= ForceClientRender;
            errorHydratingContainer(root.containerInfo);
        }
        var exitStatus = renderRootSync(root, errorRetryLanes);
        if (exitStatus !== RootErrored) {
            // Successfully finished rendering on retry
            // The errors from the failed first attempt have been recovered. Add
            // them to the collection of recoverable errors. We'll log them in the
            // commit phase.
            var errorsFromSecondAttempt = workInProgressRootRecoverableErrors;
            workInProgressRootRecoverableErrors = errorsFromFirstAttempt; // The errors from the second attempt should be queued after the errors
            // from the first attempt, to preserve the causal sequence.
            if (errorsFromSecondAttempt !== null) queueRecoverableErrors(errorsFromSecondAttempt);
        }
        return exitStatus;
    }
    function queueRecoverableErrors(errors) {
        if (workInProgressRootRecoverableErrors === null) workInProgressRootRecoverableErrors = errors;
        else workInProgressRootRecoverableErrors.push.apply(workInProgressRootRecoverableErrors, errors);
    }
    function finishConcurrentRender(root, exitStatus, lanes) {
        switch(exitStatus){
            case RootInProgress:
            case RootFatalErrored:
                throw new Error("Root did not complete. This is a bug in React.");
            // Flow knows about invariant, so it complains if I add a break
            // statement, but eslint doesn't know about invariant, so it complains
            // if I do. eslint-disable-next-line no-fallthrough
            case RootErrored:
                // We should have already attempted to retry this tree. If we reached
                // this point, it errored again. Commit it.
                commitRoot(root, workInProgressRootRecoverableErrors, workInProgressTransitions);
                break;
            case RootSuspended:
                markRootSuspended$1(root, lanes); // We have an acceptable loading state. We need to figure out if we
                // should immediately commit it or wait a bit.
                if (includesOnlyRetries(lanes) && // do not delay if we're inside an act() scope
                !shouldForceFlushFallbacksInDEV()) {
                    // This render only included retries, no updates. Throttle committing
                    // retries so that we don't show too many loading states too quickly.
                    var msUntilTimeout = globalMostRecentFallbackTime + FALLBACK_THROTTLE_MS - now(); // Don't bother with a very short suspense time.
                    if (msUntilTimeout > 10) {
                        var nextLanes = getNextLanes(root, NoLanes);
                        if (nextLanes !== NoLanes) break;
                        var suspendedLanes = root.suspendedLanes;
                        if (!isSubsetOfLanes(suspendedLanes, lanes)) {
                            // We should prefer to render the fallback of at the last
                            // suspended level. Ping the last suspended level to try
                            // rendering it again.
                            // FIXME: What if the suspended lanes are Idle? Should not restart.
                            var eventTime = requestEventTime();
                            markRootPinged(root, suspendedLanes);
                            break;
                        } // The render is suspended, it hasn't timed out, and there's no
                        // lower priority work to do. Instead of committing the fallback
                        // immediately, wait for more data to arrive.
                        root.timeoutHandle = scheduleTimeout(commitRoot.bind(null, root, workInProgressRootRecoverableErrors, workInProgressTransitions), msUntilTimeout);
                        break;
                    }
                } // The work expired. Commit immediately.
                commitRoot(root, workInProgressRootRecoverableErrors, workInProgressTransitions);
                break;
            case RootSuspendedWithDelay:
                markRootSuspended$1(root, lanes);
                if (includesOnlyTransitions(lanes)) break;
                if (!shouldForceFlushFallbacksInDEV()) {
                    // This is not a transition, but we did trigger an avoided state.
                    // Schedule a placeholder to display after a short delay, using the Just
                    // Noticeable Difference.
                    // TODO: Is the JND optimization worth the added complexity? If this is
                    // the only reason we track the event time, then probably not.
                    // Consider removing.
                    var mostRecentEventTime = getMostRecentEventTime(root, lanes);
                    var eventTimeMs = mostRecentEventTime;
                    var timeElapsedMs = now() - eventTimeMs;
                    var _msUntilTimeout = jnd(timeElapsedMs) - timeElapsedMs; // Don't bother with a very short suspense time.
                    if (_msUntilTimeout > 10) {
                        // Instead of committing the fallback immediately, wait for more data
                        // to arrive.
                        root.timeoutHandle = scheduleTimeout(commitRoot.bind(null, root, workInProgressRootRecoverableErrors, workInProgressTransitions), _msUntilTimeout);
                        break;
                    }
                } // Commit the placeholder.
                commitRoot(root, workInProgressRootRecoverableErrors, workInProgressTransitions);
                break;
            case RootCompleted:
                // The work completed. Ready to commit.
                commitRoot(root, workInProgressRootRecoverableErrors, workInProgressTransitions);
                break;
            default:
                throw new Error("Unknown root exit status.");
        }
    }
    function isRenderConsistentWithExternalStores(finishedWork) {
        // Search the rendered tree for external store reads, and check whether the
        // stores were mutated in a concurrent event. Intentionally using an iterative
        // loop instead of recursion so we can exit early.
        var node = finishedWork;
        while(true){
            if (node.flags & StoreConsistency) {
                var updateQueue = node.updateQueue;
                if (updateQueue !== null) {
                    var checks = updateQueue.stores;
                    if (checks !== null) for(var i = 0; i < checks.length; i++){
                        var check = checks[i];
                        var getSnapshot = check.getSnapshot;
                        var renderedValue = check.value;
                        try {
                            if (!objectIs(getSnapshot(), renderedValue)) // Found an inconsistent store.
                            return false;
                        } catch (error) {
                            // If `getSnapshot` throws, return `false`. This will schedule
                            // a re-render, and the error will be rethrown during render.
                            return false;
                        }
                    }
                }
            }
            var child = node.child;
            if (node.subtreeFlags & StoreConsistency && child !== null) {
                child.return = node;
                node = child;
                continue;
            }
            if (node === finishedWork) return true;
            while(node.sibling === null){
                if (node.return === null || node.return === finishedWork) return true;
                node = node.return;
            }
            node.sibling.return = node.return;
            node = node.sibling;
        } // Flow doesn't know this is unreachable, but eslint does
        // eslint-disable-next-line no-unreachable
        return true;
    }
    function markRootSuspended$1(root, suspendedLanes) {
        // When suspending, we should always exclude lanes that were pinged or (more
        // rarely, since we try to avoid it) updated during the render phase.
        // TODO: Lol maybe there's a better way to factor this besides this
        // obnoxiously named function :)
        suspendedLanes = removeLanes(suspendedLanes, workInProgressRootPingedLanes);
        suspendedLanes = removeLanes(suspendedLanes, workInProgressRootInterleavedUpdatedLanes);
        markRootSuspended(root, suspendedLanes);
    } // This is the entry point for synchronous tasks that don't go
    // through Scheduler
    function performSyncWorkOnRoot(root) {
        syncNestedUpdateFlag();
        if ((executionContext & (RenderContext | CommitContext)) !== NoContext) throw new Error("Should not already be working.");
        flushPassiveEffects();
        var lanes = getNextLanes(root, NoLanes);
        if (!includesSomeLane(lanes, SyncLane)) {
            // There's no remaining sync work left.
            ensureRootIsScheduled(root, now());
            return null;
        }
        var exitStatus = renderRootSync(root, lanes);
        if (root.tag !== LegacyRoot && exitStatus === RootErrored) {
            // If something threw an error, try rendering one more time. We'll render
            // synchronously to block concurrent data mutations, and we'll includes
            // all pending updates are included. If it still fails after the second
            // attempt, we'll give up and commit the resulting tree.
            var errorRetryLanes = getLanesToRetrySynchronouslyOnError(root);
            if (errorRetryLanes !== NoLanes) {
                lanes = errorRetryLanes;
                exitStatus = recoverFromConcurrentError(root, errorRetryLanes);
            }
        }
        if (exitStatus === RootFatalErrored) {
            var fatalError = workInProgressRootFatalError;
            prepareFreshStack(root, NoLanes);
            markRootSuspended$1(root, lanes);
            ensureRootIsScheduled(root, now());
            throw fatalError;
        }
        if (exitStatus === RootDidNotComplete) throw new Error("Root did not complete. This is a bug in React.");
         // We now have a consistent tree. Because this is a sync render, we
        // will commit it even if something suspended.
        var finishedWork = root.current.alternate;
        root.finishedWork = finishedWork;
        root.finishedLanes = lanes;
        commitRoot(root, workInProgressRootRecoverableErrors, workInProgressTransitions); // Before exiting, make sure there's a callback scheduled for the next
        // pending level.
        ensureRootIsScheduled(root, now());
        return null;
    }
    function flushRoot(root, lanes) {
        if (lanes !== NoLanes) {
            markRootEntangled(root, mergeLanes(lanes, SyncLane));
            ensureRootIsScheduled(root, now());
            if ((executionContext & (RenderContext | CommitContext)) === NoContext) {
                resetRenderTimer();
                flushSyncCallbacks();
            }
        }
    }
    function batchedUpdates$1(fn, a) {
        var prevExecutionContext = executionContext;
        executionContext |= BatchedContext;
        try {
            return fn(a);
        } finally{
            executionContext = prevExecutionContext; // If there were legacy sync updates, flush them at the end of the outer
            // most batchedUpdates-like method.
            if (executionContext === NoContext && // Treat `act` as if it's inside `batchedUpdates`, even in legacy mode.
            !ReactCurrentActQueue$1.isBatchingLegacy) {
                resetRenderTimer();
                flushSyncCallbacksOnlyInLegacyMode();
            }
        }
    }
    function discreteUpdates(fn, a, b, c, d) {
        var previousPriority = getCurrentUpdatePriority();
        var prevTransition = ReactCurrentBatchConfig$3.transition;
        try {
            ReactCurrentBatchConfig$3.transition = null;
            setCurrentUpdatePriority(DiscreteEventPriority);
            return fn(a, b, c, d);
        } finally{
            setCurrentUpdatePriority(previousPriority);
            ReactCurrentBatchConfig$3.transition = prevTransition;
            if (executionContext === NoContext) resetRenderTimer();
        }
    } // Overload the definition to the two valid signatures.
    // Warning, this opts-out of checking the function body.
    // eslint-disable-next-line no-redeclare
    function flushSync(fn) {
        // In legacy mode, we flush pending passive effects at the beginning of the
        // next event, not at the end of the previous one.
        if (rootWithPendingPassiveEffects !== null && rootWithPendingPassiveEffects.tag === LegacyRoot && (executionContext & (RenderContext | CommitContext)) === NoContext) flushPassiveEffects();
        var prevExecutionContext = executionContext;
        executionContext |= BatchedContext;
        var prevTransition = ReactCurrentBatchConfig$3.transition;
        var previousPriority = getCurrentUpdatePriority();
        try {
            ReactCurrentBatchConfig$3.transition = null;
            setCurrentUpdatePriority(DiscreteEventPriority);
            if (fn) return fn();
            else return undefined;
        } finally{
            setCurrentUpdatePriority(previousPriority);
            ReactCurrentBatchConfig$3.transition = prevTransition;
            executionContext = prevExecutionContext; // Flush the immediate callbacks that were scheduled during this batch.
            // Note that this will happen even if batchedUpdates is higher up
            // the stack.
            if ((executionContext & (RenderContext | CommitContext)) === NoContext) flushSyncCallbacks();
        }
    }
    function isAlreadyRendering() {
        // Used by the renderer to print a warning if certain APIs are called from
        // the wrong context.
        return (executionContext & (RenderContext | CommitContext)) !== NoContext;
    }
    function pushRenderLanes(fiber, lanes) {
        push(subtreeRenderLanesCursor, subtreeRenderLanes, fiber);
        subtreeRenderLanes = mergeLanes(subtreeRenderLanes, lanes);
        workInProgressRootIncludedLanes = mergeLanes(workInProgressRootIncludedLanes, lanes);
    }
    function popRenderLanes(fiber) {
        subtreeRenderLanes = subtreeRenderLanesCursor.current;
        pop(subtreeRenderLanesCursor, fiber);
    }
    function prepareFreshStack(root, lanes) {
        root.finishedWork = null;
        root.finishedLanes = NoLanes;
        var timeoutHandle = root.timeoutHandle;
        if (timeoutHandle !== noTimeout) {
            // The root previous suspended and scheduled a timeout to commit a fallback
            // state. Now that we have additional work, cancel the timeout.
            root.timeoutHandle = noTimeout; // $FlowFixMe Complains noTimeout is not a TimeoutID, despite the check above
            cancelTimeout(timeoutHandle);
        }
        if (workInProgress !== null) {
            var interruptedWork = workInProgress.return;
            while(interruptedWork !== null){
                var current = interruptedWork.alternate;
                unwindInterruptedWork(current, interruptedWork);
                interruptedWork = interruptedWork.return;
            }
        }
        workInProgressRoot = root;
        var rootWorkInProgress = createWorkInProgress(root.current, null);
        workInProgress = rootWorkInProgress;
        workInProgressRootRenderLanes = subtreeRenderLanes = workInProgressRootIncludedLanes = lanes;
        workInProgressRootExitStatus = RootInProgress;
        workInProgressRootFatalError = null;
        workInProgressRootSkippedLanes = NoLanes;
        workInProgressRootInterleavedUpdatedLanes = NoLanes;
        workInProgressRootPingedLanes = NoLanes;
        workInProgressRootConcurrentErrors = null;
        workInProgressRootRecoverableErrors = null;
        finishQueueingConcurrentUpdates();
        ReactStrictModeWarnings.discardPendingWarnings();
        return rootWorkInProgress;
    }
    function handleError(root, thrownValue) {
        do {
            var erroredWork = workInProgress;
            try {
                // Reset module-level state that was set during the render phase.
                resetContextDependencies();
                resetHooksAfterThrow();
                resetCurrentFiber(); // TODO: I found and added this missing line while investigating a
                // separate issue. Write a regression test using string refs.
                ReactCurrentOwner$2.current = null;
                if (erroredWork === null || erroredWork.return === null) {
                    // Expected to be working on a non-root fiber. This is a fatal error
                    // because there's no ancestor that can handle it; the root is
                    // supposed to capture all errors that weren't caught by an error
                    // boundary.
                    workInProgressRootExitStatus = RootFatalErrored;
                    workInProgressRootFatalError = thrownValue; // Set `workInProgress` to null. This represents advancing to the next
                    // sibling, or the parent if there are no siblings. But since the root
                    // has no siblings nor a parent, we set it to null. Usually this is
                    // handled by `completeUnitOfWork` or `unwindWork`, but since we're
                    // intentionally not calling those, we need set it here.
                    // TODO: Consider calling `unwindWork` to pop the contexts.
                    workInProgress = null;
                    return;
                }
                if (enableProfilerTimer && erroredWork.mode & ProfileMode) // Record the time spent rendering before an error was thrown. This
                // avoids inaccurate Profiler durations in the case of a
                // suspended render.
                stopProfilerTimerIfRunningAndRecordDelta(erroredWork, true);
                if (enableSchedulingProfiler) {
                    markComponentRenderStopped();
                    if (thrownValue !== null && typeof thrownValue === "object" && typeof thrownValue.then === "function") {
                        var wakeable = thrownValue;
                        markComponentSuspended(erroredWork, wakeable, workInProgressRootRenderLanes);
                    } else markComponentErrored(erroredWork, thrownValue, workInProgressRootRenderLanes);
                }
                throwException(root, erroredWork.return, erroredWork, thrownValue, workInProgressRootRenderLanes);
                completeUnitOfWork(erroredWork);
            } catch (yetAnotherThrownValue) {
                // Something in the return path also threw.
                thrownValue = yetAnotherThrownValue;
                if (workInProgress === erroredWork && erroredWork !== null) {
                    // If this boundary has already errored, then we had trouble processing
                    // the error. Bubble it to the next boundary.
                    erroredWork = erroredWork.return;
                    workInProgress = erroredWork;
                } else erroredWork = workInProgress;
                continue;
            } // Return to the normal work loop.
            return;
        }while (true);
    }
    function pushDispatcher() {
        var prevDispatcher = ReactCurrentDispatcher$2.current;
        ReactCurrentDispatcher$2.current = ContextOnlyDispatcher;
        if (prevDispatcher === null) // The React isomorphic package does not include a default dispatcher.
        // Instead the first renderer will lazily attach one, in order to give
        // nicer error messages.
        return ContextOnlyDispatcher;
        else return prevDispatcher;
    }
    function popDispatcher(prevDispatcher) {
        ReactCurrentDispatcher$2.current = prevDispatcher;
    }
    function markCommitTimeOfFallback() {
        globalMostRecentFallbackTime = now();
    }
    function markSkippedUpdateLanes(lane) {
        workInProgressRootSkippedLanes = mergeLanes(lane, workInProgressRootSkippedLanes);
    }
    function renderDidSuspend() {
        if (workInProgressRootExitStatus === RootInProgress) workInProgressRootExitStatus = RootSuspended;
    }
    function renderDidSuspendDelayIfPossible() {
        if (workInProgressRootExitStatus === RootInProgress || workInProgressRootExitStatus === RootSuspended || workInProgressRootExitStatus === RootErrored) workInProgressRootExitStatus = RootSuspendedWithDelay;
         // Check if there are updates that we skipped tree that might have unblocked
        // this render.
        if (workInProgressRoot !== null && (includesNonIdleWork(workInProgressRootSkippedLanes) || includesNonIdleWork(workInProgressRootInterleavedUpdatedLanes))) // Mark the current render as suspended so that we switch to working on
        // the updates that were skipped. Usually we only suspend at the end of
        // the render phase.
        // TODO: We should probably always mark the root as suspended immediately
        // (inside this function), since by suspending at the end of the render
        // phase introduces a potential mistake where we suspend lanes that were
        // pinged or updated while we were rendering.
        markRootSuspended$1(workInProgressRoot, workInProgressRootRenderLanes);
    }
    function renderDidError(error) {
        if (workInProgressRootExitStatus !== RootSuspendedWithDelay) workInProgressRootExitStatus = RootErrored;
        if (workInProgressRootConcurrentErrors === null) workInProgressRootConcurrentErrors = [
            error
        ];
        else workInProgressRootConcurrentErrors.push(error);
    } // Called during render to determine if anything has suspended.
    // Returns false if we're not sure.
    function renderHasNotSuspendedYet() {
        // If something errored or completed, we can't really be sure,
        // so those are false.
        return workInProgressRootExitStatus === RootInProgress;
    }
    function renderRootSync(root, lanes) {
        var prevExecutionContext = executionContext;
        executionContext |= RenderContext;
        var prevDispatcher = pushDispatcher(); // If the root or lanes have changed, throw out the existing stack
        // and prepare a fresh one. Otherwise we'll continue where we left off.
        if (workInProgressRoot !== root || workInProgressRootRenderLanes !== lanes) {
            if (isDevToolsPresent) {
                var memoizedUpdaters = root.memoizedUpdaters;
                if (memoizedUpdaters.size > 0) {
                    restorePendingUpdaters(root, workInProgressRootRenderLanes);
                    memoizedUpdaters.clear();
                } // At this point, move Fibers that scheduled the upcoming work from the Map to the Set.
                // If we bailout on this work, we'll move them back (like above).
                // It's important to move them now in case the work spawns more work at the same priority with different updaters.
                // That way we can keep the current update and future updates separate.
                movePendingFibersToMemoized(root, lanes);
            }
            workInProgressTransitions = getTransitionsForLanes();
            prepareFreshStack(root, lanes);
        }
        markRenderStarted(lanes);
        for(;;)try {
            workLoopSync();
            break;
        } catch (thrownValue) {
            handleError(root, thrownValue);
        }
        resetContextDependencies();
        executionContext = prevExecutionContext;
        popDispatcher(prevDispatcher);
        if (workInProgress !== null) // This is a sync render, so we should have finished the whole tree.
        throw new Error("Cannot commit an incomplete root. This error is likely caused by a bug in React. Please file an issue.");
        markRenderStopped();
        workInProgressRoot = null;
        workInProgressRootRenderLanes = NoLanes;
        return workInProgressRootExitStatus;
    } // The work loop is an extremely hot path. Tell Closure not to inline it.
    /** @noinline */ function workLoopSync() {
        // Already timed out, so perform work without checking if we need to yield.
        while(workInProgress !== null)performUnitOfWork(workInProgress);
    }
    function renderRootConcurrent(root, lanes) {
        var prevExecutionContext = executionContext;
        executionContext |= RenderContext;
        var prevDispatcher = pushDispatcher(); // If the root or lanes have changed, throw out the existing stack
        // and prepare a fresh one. Otherwise we'll continue where we left off.
        if (workInProgressRoot !== root || workInProgressRootRenderLanes !== lanes) {
            if (isDevToolsPresent) {
                var memoizedUpdaters = root.memoizedUpdaters;
                if (memoizedUpdaters.size > 0) {
                    restorePendingUpdaters(root, workInProgressRootRenderLanes);
                    memoizedUpdaters.clear();
                } // At this point, move Fibers that scheduled the upcoming work from the Map to the Set.
                // If we bailout on this work, we'll move them back (like above).
                // It's important to move them now in case the work spawns more work at the same priority with different updaters.
                // That way we can keep the current update and future updates separate.
                movePendingFibersToMemoized(root, lanes);
            }
            workInProgressTransitions = getTransitionsForLanes();
            resetRenderTimer();
            prepareFreshStack(root, lanes);
        }
        markRenderStarted(lanes);
        for(;;)try {
            workLoopConcurrent();
            break;
        } catch (thrownValue) {
            handleError(root, thrownValue);
        }
        resetContextDependencies();
        popDispatcher(prevDispatcher);
        executionContext = prevExecutionContext;
        if (workInProgress !== null) {
            markRenderYielded();
            return RootInProgress;
        } else {
            markRenderStopped();
            workInProgressRoot = null;
            workInProgressRootRenderLanes = NoLanes; // Return the final exit status.
            return workInProgressRootExitStatus;
        }
    }
    /** @noinline */ function workLoopConcurrent() {
        // Perform work until Scheduler asks us to yield
        while(workInProgress !== null && !shouldYield())performUnitOfWork(workInProgress);
    }
    function performUnitOfWork(unitOfWork) {
        // The current, flushed, state of this fiber is the alternate. Ideally
        // nothing should rely on this, but relying on it here means that we don't
        // need an additional field on the work in progress.
        var current = unitOfWork.alternate;
        setCurrentFiber(unitOfWork);
        var next;
        if ((unitOfWork.mode & ProfileMode) !== NoMode) {
            startProfilerTimer(unitOfWork);
            next = beginWork$1(current, unitOfWork, subtreeRenderLanes);
            stopProfilerTimerIfRunningAndRecordDelta(unitOfWork, true);
        } else next = beginWork$1(current, unitOfWork, subtreeRenderLanes);
        resetCurrentFiber();
        unitOfWork.memoizedProps = unitOfWork.pendingProps;
        if (next === null) // If this doesn't spawn new work, complete the current work.
        completeUnitOfWork(unitOfWork);
        else workInProgress = next;
        ReactCurrentOwner$2.current = null;
    }
    function completeUnitOfWork(unitOfWork) {
        // Attempt to complete the current unit of work, then move to the next
        // sibling. If there are no more siblings, return to the parent fiber.
        var completedWork = unitOfWork;
        do {
            // The current, flushed, state of this fiber is the alternate. Ideally
            // nothing should rely on this, but relying on it here means that we don't
            // need an additional field on the work in progress.
            var current = completedWork.alternate;
            var returnFiber = completedWork.return; // Check if the work completed or if something threw.
            if ((completedWork.flags & Incomplete) === NoFlags) {
                setCurrentFiber(completedWork);
                var next = void 0;
                if ((completedWork.mode & ProfileMode) === NoMode) next = completeWork(current, completedWork, subtreeRenderLanes);
                else {
                    startProfilerTimer(completedWork);
                    next = completeWork(current, completedWork, subtreeRenderLanes); // Update render duration assuming we didn't error.
                    stopProfilerTimerIfRunningAndRecordDelta(completedWork, false);
                }
                resetCurrentFiber();
                if (next !== null) {
                    // Completing this fiber spawned new work. Work on that next.
                    workInProgress = next;
                    return;
                }
            } else {
                // This fiber did not complete because something threw. Pop values off
                // the stack without entering the complete phase. If this is a boundary,
                // capture values if possible.
                var _next = unwindWork(current, completedWork); // Because this fiber did not complete, don't reset its lanes.
                if (_next !== null) {
                    // If completing this work spawned new work, do that next. We'll come
                    // back here again.
                    // Since we're restarting, remove anything that is not a host effect
                    // from the effect tag.
                    _next.flags &= HostEffectMask;
                    workInProgress = _next;
                    return;
                }
                if ((completedWork.mode & ProfileMode) !== NoMode) {
                    // Record the render duration for the fiber that errored.
                    stopProfilerTimerIfRunningAndRecordDelta(completedWork, false); // Include the time spent working on failed children before continuing.
                    var actualDuration = completedWork.actualDuration;
                    var child = completedWork.child;
                    while(child !== null){
                        actualDuration += child.actualDuration;
                        child = child.sibling;
                    }
                    completedWork.actualDuration = actualDuration;
                }
                if (returnFiber !== null) {
                    // Mark the parent fiber as incomplete and clear its subtree flags.
                    returnFiber.flags |= Incomplete;
                    returnFiber.subtreeFlags = NoFlags;
                    returnFiber.deletions = null;
                } else {
                    // We've unwound all the way to the root.
                    workInProgressRootExitStatus = RootDidNotComplete;
                    workInProgress = null;
                    return;
                }
            }
            var siblingFiber = completedWork.sibling;
            if (siblingFiber !== null) {
                // If there is more work to do in this returnFiber, do that next.
                workInProgress = siblingFiber;
                return;
            } // Otherwise, return to the parent
            completedWork = returnFiber; // Update the next thing we're working on in case something throws.
            workInProgress = completedWork;
        }while (completedWork !== null); // We've reached the root.
        if (workInProgressRootExitStatus === RootInProgress) workInProgressRootExitStatus = RootCompleted;
    }
    function commitRoot(root, recoverableErrors, transitions) {
        // TODO: This no longer makes any sense. We already wrap the mutation and
        // layout phases. Should be able to remove.
        var previousUpdateLanePriority = getCurrentUpdatePriority();
        var prevTransition = ReactCurrentBatchConfig$3.transition;
        try {
            ReactCurrentBatchConfig$3.transition = null;
            setCurrentUpdatePriority(DiscreteEventPriority);
            commitRootImpl(root, recoverableErrors, transitions, previousUpdateLanePriority);
        } finally{
            ReactCurrentBatchConfig$3.transition = prevTransition;
            setCurrentUpdatePriority(previousUpdateLanePriority);
        }
        return null;
    }
    function commitRootImpl(root, recoverableErrors, transitions, renderPriorityLevel) {
        do // `flushPassiveEffects` will call `flushSyncUpdateQueue` at the end, which
        // means `flushPassiveEffects` will sometimes result in additional
        // passive effects. So we need to keep flushing in a loop until there are
        // no more pending effects.
        // TODO: Might be better if `flushPassiveEffects` did not automatically
        // flush synchronous work at the end, to avoid factoring hazards like this.
        flushPassiveEffects();
        while (rootWithPendingPassiveEffects !== null);
        flushRenderPhaseStrictModeWarningsInDEV();
        if ((executionContext & (RenderContext | CommitContext)) !== NoContext) throw new Error("Should not already be working.");
        var finishedWork = root.finishedWork;
        var lanes = root.finishedLanes;
        markCommitStarted(lanes);
        if (finishedWork === null) {
            markCommitStopped();
            return null;
        } else if (lanes === NoLanes) error("root.finishedLanes should not be empty during a commit. This is a bug in React.");
        root.finishedWork = null;
        root.finishedLanes = NoLanes;
        if (finishedWork === root.current) throw new Error("Cannot commit the same tree as before. This error is likely caused by a bug in React. Please file an issue.");
         // commitRoot never returns a continuation; it always finishes synchronously.
        // So we can clear these now to allow a new callback to be scheduled.
        root.callbackNode = null;
        root.callbackPriority = NoLane; // Update the first and last pending times on this root. The new first
        // pending time is whatever is left on the root fiber.
        var remainingLanes = mergeLanes(finishedWork.lanes, finishedWork.childLanes);
        markRootFinished(root, remainingLanes);
        if (root === workInProgressRoot) {
            // We can reset these now that they are finished.
            workInProgressRoot = null;
            workInProgress = null;
            workInProgressRootRenderLanes = NoLanes;
        } // If there are pending passive effects, schedule a callback to process them.
        // Do this as early as possible, so it is queued before anything else that
        // might get scheduled in the commit phase. (See #16714.)
        // TODO: Delete all other places that schedule the passive effect callback
        // They're redundant.
        if ((finishedWork.subtreeFlags & PassiveMask) !== NoFlags || (finishedWork.flags & PassiveMask) !== NoFlags) {
            if (!rootDoesHavePassiveEffects) {
                rootDoesHavePassiveEffects = true;
                // to store it in pendingPassiveTransitions until they get processed
                // We need to pass this through as an argument to commitRoot
                // because workInProgressTransitions might have changed between
                // the previous render and commit if we throttle the commit
                // with setTimeout
                pendingPassiveTransitions = transitions;
                scheduleCallback$1(NormalPriority, function() {
                    flushPassiveEffects(); // This render triggered passive effects: release the root cache pool
                    // *after* passive effects fire to avoid freeing a cache pool that may
                    // be referenced by a node in the tree (HostRoot, Cache boundary etc)
                    return null;
                });
            }
        } // Check if there are any effects in the whole tree.
        // TODO: This is left over from the effect list implementation, where we had
        // to check for the existence of `firstEffect` to satisfy Flow. I think the
        // only other reason this optimization exists is because it affects profiling.
        // Reconsider whether this is necessary.
        var subtreeHasEffects = (finishedWork.subtreeFlags & (BeforeMutationMask | MutationMask | LayoutMask | PassiveMask)) !== NoFlags;
        var rootHasEffect = (finishedWork.flags & (BeforeMutationMask | MutationMask | LayoutMask | PassiveMask)) !== NoFlags;
        if (subtreeHasEffects || rootHasEffect) {
            var prevTransition = ReactCurrentBatchConfig$3.transition;
            ReactCurrentBatchConfig$3.transition = null;
            var previousPriority = getCurrentUpdatePriority();
            setCurrentUpdatePriority(DiscreteEventPriority);
            var prevExecutionContext = executionContext;
            executionContext |= CommitContext; // Reset this to null before calling lifecycles
            ReactCurrentOwner$2.current = null; // The commit phase is broken into several sub-phases. We do a separate pass
            // of the effect list for each phase: all mutation effects come before all
            // layout effects, and so on.
            // The first phase a "before mutation" phase. We use this phase to read the
            // state of the host tree right before we mutate it. This is where
            // getSnapshotBeforeUpdate is called.
            var shouldFireAfterActiveInstanceBlur = commitBeforeMutationEffects(root, finishedWork);
            // Mark the current commit time to be shared by all Profilers in this
            // batch. This enables them to be grouped later.
            recordCommitTime();
            commitMutationEffects(root, finishedWork, lanes);
            resetAfterCommit(root.containerInfo); // The work-in-progress tree is now the current tree. This must come after
            // the mutation phase, so that the previous tree is still current during
            // componentWillUnmount, but before the layout phase, so that the finished
            // work is current during componentDidMount/Update.
            root.current = finishedWork; // The next phase is the layout phase, where we call effects that read
            markLayoutEffectsStarted(lanes);
            commitLayoutEffects(finishedWork, root, lanes);
            markLayoutEffectsStopped();
            // opportunity to paint.
            requestPaint();
            executionContext = prevExecutionContext; // Reset the priority to the previous non-sync value.
            setCurrentUpdatePriority(previousPriority);
            ReactCurrentBatchConfig$3.transition = prevTransition;
        } else {
            // No effects.
            root.current = finishedWork; // Measure these anyway so the flamegraph explicitly shows that there were
            recordCommitTime();
        }
        var rootDidHavePassiveEffects = rootDoesHavePassiveEffects;
        if (rootDoesHavePassiveEffects) {
            // This commit has passive effects. Stash a reference to them. But don't
            // schedule a callback until after flushing layout work.
            rootDoesHavePassiveEffects = false;
            rootWithPendingPassiveEffects = root;
            pendingPassiveEffectsLanes = lanes;
        } else {
            nestedPassiveUpdateCount = 0;
            rootWithPassiveNestedUpdates = null;
        } // Read this again, since an effect might have updated it
        remainingLanes = root.pendingLanes; // Check if there's remaining work on this root
        // TODO: This is part of the `componentDidCatch` implementation. Its purpose
        // is to detect whether something might have called setState inside
        // `componentDidCatch`. The mechanism is known to be flawed because `setState`
        // inside `componentDidCatch` is itself flawed — that's why we recommend
        // `getDerivedStateFromError` instead. However, it could be improved by
        // checking if remainingLanes includes Sync work, instead of whether there's
        // any work remaining at all (which would also include stuff like Suspense
        // retries or transitions). It's been like this for a while, though, so fixing
        // it probably isn't that urgent.
        if (remainingLanes === NoLanes) // If there's no remaining work, we can clear the set of already failed
        // error boundaries.
        legacyErrorBoundariesThatAlreadyFailed = null;
        if (!rootDidHavePassiveEffects) commitDoubleInvokeEffectsInDEV(root.current, false);
        onCommitRoot(finishedWork.stateNode, renderPriorityLevel);
        if (isDevToolsPresent) root.memoizedUpdaters.clear();
        onCommitRoot$1();
        // additional work on this root is scheduled.
        ensureRootIsScheduled(root, now());
        if (recoverableErrors !== null) {
            // There were errors during this render, but recovered from them without
            // needing to surface it to the UI. We log them here.
            var onRecoverableError = root.onRecoverableError;
            for(var i = 0; i < recoverableErrors.length; i++){
                var recoverableError = recoverableErrors[i];
                var componentStack = recoverableError.stack;
                var digest = recoverableError.digest;
                onRecoverableError(recoverableError.value, {
                    componentStack: componentStack,
                    digest: digest
                });
            }
        }
        if (hasUncaughtError) {
            hasUncaughtError = false;
            var error$1 = firstUncaughtError;
            firstUncaughtError = null;
            throw error$1;
        } // If the passive effects are the result of a discrete render, flush them
        // synchronously at the end of the current task so that the result is
        // immediately observable. Otherwise, we assume that they are not
        // order-dependent and do not need to be observed by external systems, so we
        // can wait until after paint.
        // TODO: We can optimize this by not scheduling the callback earlier. Since we
        // currently schedule the callback in multiple places, will wait until those
        // are consolidated.
        if (includesSomeLane(pendingPassiveEffectsLanes, SyncLane) && root.tag !== LegacyRoot) flushPassiveEffects();
         // Read this again, since a passive effect might have updated it
        remainingLanes = root.pendingLanes;
        if (includesSomeLane(remainingLanes, SyncLane)) {
            markNestedUpdateScheduled();
            // finishing. If there are too many, it indicates an infinite update loop.
            if (root === rootWithNestedUpdates) nestedUpdateCount++;
            else {
                nestedUpdateCount = 0;
                rootWithNestedUpdates = root;
            }
        } else nestedUpdateCount = 0;
         // If layout work was scheduled, flush it now.
        flushSyncCallbacks();
        markCommitStopped();
        return null;
    }
    function flushPassiveEffects() {
        // Returns whether passive effects were flushed.
        // TODO: Combine this check with the one in flushPassiveEFfectsImpl. We should
        // probably just combine the two functions. I believe they were only separate
        // in the first place because we used to wrap it with
        // `Scheduler.runWithPriority`, which accepts a function. But now we track the
        // priority within React itself, so we can mutate the variable directly.
        if (rootWithPendingPassiveEffects !== null) {
            var renderPriority = lanesToEventPriority(pendingPassiveEffectsLanes);
            var priority = lowerEventPriority(DefaultEventPriority, renderPriority);
            var prevTransition = ReactCurrentBatchConfig$3.transition;
            var previousPriority = getCurrentUpdatePriority();
            try {
                ReactCurrentBatchConfig$3.transition = null;
                setCurrentUpdatePriority(priority);
                return flushPassiveEffectsImpl();
            } finally{
                setCurrentUpdatePriority(previousPriority);
                ReactCurrentBatchConfig$3.transition = prevTransition; // Once passive effects have run for the tree - giving components a
            }
        }
        return false;
    }
    function enqueuePendingPassiveProfilerEffect(fiber) {
        pendingPassiveProfilerEffects.push(fiber);
        if (!rootDoesHavePassiveEffects) {
            rootDoesHavePassiveEffects = true;
            scheduleCallback$1(NormalPriority, function() {
                flushPassiveEffects();
                return null;
            });
        }
    }
    function flushPassiveEffectsImpl() {
        if (rootWithPendingPassiveEffects === null) return false;
         // Cache and clear the transitions flag
        var transitions = pendingPassiveTransitions;
        pendingPassiveTransitions = null;
        var root = rootWithPendingPassiveEffects;
        var lanes = pendingPassiveEffectsLanes;
        rootWithPendingPassiveEffects = null; // TODO: This is sometimes out of sync with rootWithPendingPassiveEffects.
        // Figure out why and fix it. It's not causing any known issues (probably
        // because it's only used for profiling), but it's a refactor hazard.
        pendingPassiveEffectsLanes = NoLanes;
        if ((executionContext & (RenderContext | CommitContext)) !== NoContext) throw new Error("Cannot flush passive effects while already rendering.");
        isFlushingPassiveEffects = true;
        didScheduleUpdateDuringPassiveEffects = false;
        markPassiveEffectsStarted(lanes);
        var prevExecutionContext = executionContext;
        executionContext |= CommitContext;
        commitPassiveUnmountEffects(root.current);
        commitPassiveMountEffects(root, root.current, lanes, transitions); // TODO: Move to commitPassiveMountEffects
        var profilerEffects = pendingPassiveProfilerEffects;
        pendingPassiveProfilerEffects = [];
        for(var i = 0; i < profilerEffects.length; i++){
            var _fiber = profilerEffects[i];
            commitPassiveEffectDurations(root, _fiber);
        }
        markPassiveEffectsStopped();
        commitDoubleInvokeEffectsInDEV(root.current, true);
        executionContext = prevExecutionContext;
        flushSyncCallbacks();
        // If additional passive effects were scheduled, increment a counter. If this
        // exceeds the limit, we'll fire a warning.
        if (didScheduleUpdateDuringPassiveEffects) {
            if (root === rootWithPassiveNestedUpdates) nestedPassiveUpdateCount++;
            else {
                nestedPassiveUpdateCount = 0;
                rootWithPassiveNestedUpdates = root;
            }
        } else nestedPassiveUpdateCount = 0;
        isFlushingPassiveEffects = false;
        didScheduleUpdateDuringPassiveEffects = false;
        onPostCommitRoot(root);
        var stateNode = root.current.stateNode;
        stateNode.effectDuration = 0;
        stateNode.passiveEffectDuration = 0;
        return true;
    }
    function isAlreadyFailedLegacyErrorBoundary(instance) {
        return legacyErrorBoundariesThatAlreadyFailed !== null && legacyErrorBoundariesThatAlreadyFailed.has(instance);
    }
    function markLegacyErrorBoundaryAsFailed(instance) {
        if (legacyErrorBoundariesThatAlreadyFailed === null) legacyErrorBoundariesThatAlreadyFailed = new Set([
            instance
        ]);
        else legacyErrorBoundariesThatAlreadyFailed.add(instance);
    }
    function prepareToThrowUncaughtError(error) {
        if (!hasUncaughtError) {
            hasUncaughtError = true;
            firstUncaughtError = error;
        }
    }
    var onUncaughtError = prepareToThrowUncaughtError;
    function captureCommitPhaseErrorOnRoot(rootFiber, sourceFiber, error) {
        var errorInfo = createCapturedValueAtFiber(error, sourceFiber);
        var update = createRootErrorUpdate(rootFiber, errorInfo, SyncLane);
        var root = enqueueUpdate(rootFiber, update, SyncLane);
        var eventTime = requestEventTime();
        if (root !== null) {
            markRootUpdated(root, SyncLane, eventTime);
            ensureRootIsScheduled(root, eventTime);
        }
    }
    function captureCommitPhaseError(sourceFiber, nearestMountedAncestor, error$1) {
        reportUncaughtErrorInDEV(error$1);
        setIsRunningInsertionEffect(false);
        if (sourceFiber.tag === HostRoot) {
            // Error was thrown at the root. There is no parent, so the root
            // itself should capture it.
            captureCommitPhaseErrorOnRoot(sourceFiber, sourceFiber, error$1);
            return;
        }
        var fiber = null;
        fiber = nearestMountedAncestor;
        while(fiber !== null){
            if (fiber.tag === HostRoot) {
                captureCommitPhaseErrorOnRoot(fiber, sourceFiber, error$1);
                return;
            } else if (fiber.tag === ClassComponent) {
                var ctor = fiber.type;
                var instance = fiber.stateNode;
                if (typeof ctor.getDerivedStateFromError === "function" || typeof instance.componentDidCatch === "function" && !isAlreadyFailedLegacyErrorBoundary(instance)) {
                    var errorInfo = createCapturedValueAtFiber(error$1, sourceFiber);
                    var update = createClassErrorUpdate(fiber, errorInfo, SyncLane);
                    var root = enqueueUpdate(fiber, update, SyncLane);
                    var eventTime = requestEventTime();
                    if (root !== null) {
                        markRootUpdated(root, SyncLane, eventTime);
                        ensureRootIsScheduled(root, eventTime);
                    }
                    return;
                }
            }
            fiber = fiber.return;
        }
        // TODO: Until we re-land skipUnmountedBoundaries (see #20147), this warning
        // will fire for errors that are thrown by destroy functions inside deleted
        // trees. What it should instead do is propagate the error to the parent of
        // the deleted tree. In the meantime, do not add this warning to the
        // allowlist; this is only for our internal use.
        error("Internal React error: Attempted to capture a commit phase error inside a detached tree. This indicates a bug in React. Likely causes include deleting the same fiber more than once, committing an already-finished tree, or an inconsistent return pointer.\n\nError message:\n\n%s", error$1);
    }
    function pingSuspendedRoot(root, wakeable, pingedLanes) {
        var pingCache = root.pingCache;
        if (pingCache !== null) // The wakeable resolved, so we no longer need to memoize, because it will
        // never be thrown again.
        pingCache.delete(wakeable);
        var eventTime = requestEventTime();
        markRootPinged(root, pingedLanes);
        warnIfSuspenseResolutionNotWrappedWithActDEV(root);
        if (workInProgressRoot === root && isSubsetOfLanes(workInProgressRootRenderLanes, pingedLanes)) {
            // Received a ping at the same priority level at which we're currently
            // rendering. We might want to restart this render. This should mirror
            // the logic of whether or not a root suspends once it completes.
            // TODO: If we're rendering sync either due to Sync, Batched or expired,
            // we should probably never restart.
            // If we're suspended with delay, or if it's a retry, we'll always suspend
            // so we can always restart.
            if (workInProgressRootExitStatus === RootSuspendedWithDelay || workInProgressRootExitStatus === RootSuspended && includesOnlyRetries(workInProgressRootRenderLanes) && now() - globalMostRecentFallbackTime < FALLBACK_THROTTLE_MS) // Restart from the root.
            prepareFreshStack(root, NoLanes);
            else // Even though we can't restart right now, we might get an
            // opportunity later. So we mark this render as having a ping.
            workInProgressRootPingedLanes = mergeLanes(workInProgressRootPingedLanes, pingedLanes);
        }
        ensureRootIsScheduled(root, eventTime);
    }
    function retryTimedOutBoundary(boundaryFiber, retryLane) {
        // The boundary fiber (a Suspense component or SuspenseList component)
        // previously was rendered in its fallback state. One of the promises that
        // suspended it has resolved, which means at least part of the tree was
        // likely unblocked. Try rendering again, at a new lanes.
        if (retryLane === NoLane) // TODO: Assign this to `suspenseState.retryLane`? to avoid
        // unnecessary entanglement?
        retryLane = requestRetryLane(boundaryFiber);
         // TODO: Special case idle priority?
        var eventTime = requestEventTime();
        var root = enqueueConcurrentRenderForLane(boundaryFiber, retryLane);
        if (root !== null) {
            markRootUpdated(root, retryLane, eventTime);
            ensureRootIsScheduled(root, eventTime);
        }
    }
    function retryDehydratedSuspenseBoundary(boundaryFiber) {
        var suspenseState = boundaryFiber.memoizedState;
        var retryLane = NoLane;
        if (suspenseState !== null) retryLane = suspenseState.retryLane;
        retryTimedOutBoundary(boundaryFiber, retryLane);
    }
    function resolveRetryWakeable(boundaryFiber, wakeable) {
        var retryLane = NoLane; // Default
        var retryCache;
        switch(boundaryFiber.tag){
            case SuspenseComponent:
                retryCache = boundaryFiber.stateNode;
                var suspenseState = boundaryFiber.memoizedState;
                if (suspenseState !== null) retryLane = suspenseState.retryLane;
                break;
            case SuspenseListComponent:
                retryCache = boundaryFiber.stateNode;
                break;
            default:
                throw new Error("Pinged unknown suspense boundary type. This is probably a bug in React.");
        }
        if (retryCache !== null) // The wakeable resolved, so we no longer need to memoize, because it will
        // never be thrown again.
        retryCache.delete(wakeable);
        retryTimedOutBoundary(boundaryFiber, retryLane);
    } // Computes the next Just Noticeable Difference (JND) boundary.
    // The theory is that a person can't tell the difference between small differences in time.
    // Therefore, if we wait a bit longer than necessary that won't translate to a noticeable
    // difference in the experience. However, waiting for longer might mean that we can avoid
    // showing an intermediate loading state. The longer we have already waited, the harder it
    // is to tell small differences in time. Therefore, the longer we've already waited,
    // the longer we can wait additionally. At some point we have to give up though.
    // We pick a train model where the next boundary commits at a consistent schedule.
    // These particular numbers are vague estimates. We expect to adjust them based on research.
    function jnd(timeElapsed) {
        return timeElapsed < 120 ? 120 : timeElapsed < 480 ? 480 : timeElapsed < 1080 ? 1080 : timeElapsed < 1920 ? 1920 : timeElapsed < 3000 ? 3000 : timeElapsed < 4320 ? 4320 : ceil(timeElapsed / 1960) * 1960;
    }
    function checkForNestedUpdates() {
        if (nestedUpdateCount > NESTED_UPDATE_LIMIT) {
            nestedUpdateCount = 0;
            rootWithNestedUpdates = null;
            throw new Error("Maximum update depth exceeded. This can happen when a component repeatedly calls setState inside componentWillUpdate or componentDidUpdate. React limits the number of nested updates to prevent infinite loops.");
        }
        if (nestedPassiveUpdateCount > NESTED_PASSIVE_UPDATE_LIMIT) {
            nestedPassiveUpdateCount = 0;
            rootWithPassiveNestedUpdates = null;
            error("Maximum update depth exceeded. This can happen when a component calls setState inside useEffect, but useEffect either doesn't have a dependency array, or one of the dependencies changes on every render.");
        }
    }
    function flushRenderPhaseStrictModeWarningsInDEV() {
        ReactStrictModeWarnings.flushLegacyContextWarning();
        ReactStrictModeWarnings.flushPendingUnsafeLifecycleWarnings();
    }
    function commitDoubleInvokeEffectsInDEV(fiber, hasPassiveEffects) {
        // TODO (StrictEffects) Should we set a marker on the root if it contains strict effects
        // so we don't traverse unnecessarily? similar to subtreeFlags but just at the root level.
        // Maybe not a big deal since this is DEV only behavior.
        setCurrentFiber(fiber);
        invokeEffectsInDev(fiber, MountLayoutDev, invokeLayoutEffectUnmountInDEV);
        if (hasPassiveEffects) invokeEffectsInDev(fiber, MountPassiveDev, invokePassiveEffectUnmountInDEV);
        invokeEffectsInDev(fiber, MountLayoutDev, invokeLayoutEffectMountInDEV);
        if (hasPassiveEffects) invokeEffectsInDev(fiber, MountPassiveDev, invokePassiveEffectMountInDEV);
        resetCurrentFiber();
    }
    function invokeEffectsInDev(firstChild, fiberFlags, invokeEffectFn) {
        // We don't need to re-check StrictEffectsMode here.
        // This function is only called if that check has already passed.
        var current = firstChild;
        var subtreeRoot = null;
        while(current !== null){
            var primarySubtreeFlag = current.subtreeFlags & fiberFlags;
            if (current !== subtreeRoot && current.child !== null && primarySubtreeFlag !== NoFlags) current = current.child;
            else {
                if ((current.flags & fiberFlags) !== NoFlags) invokeEffectFn(current);
                if (current.sibling !== null) current = current.sibling;
                else current = subtreeRoot = current.return;
            }
        }
    }
    var didWarnStateUpdateForNotYetMountedComponent = null;
    function warnAboutUpdateOnNotYetMountedFiberInDEV(fiber) {
        if ((executionContext & RenderContext) !== NoContext) // We let the other warning about render phase updates deal with this one.
        return;
        if (!(fiber.mode & ConcurrentMode)) return;
        var tag = fiber.tag;
        if (tag !== IndeterminateComponent && tag !== HostRoot && tag !== ClassComponent && tag !== FunctionComponent && tag !== ForwardRef && tag !== MemoComponent && tag !== SimpleMemoComponent) // Only warn for user-defined components, not internal ones like Suspense.
        return;
         // We show the whole stack but dedupe on the top component's name because
        // the problematic code almost always lies inside that component.
        var componentName = getComponentNameFromFiber(fiber) || "ReactComponent";
        if (didWarnStateUpdateForNotYetMountedComponent !== null) {
            if (didWarnStateUpdateForNotYetMountedComponent.has(componentName)) return;
            didWarnStateUpdateForNotYetMountedComponent.add(componentName);
        } else didWarnStateUpdateForNotYetMountedComponent = new Set([
            componentName
        ]);
        var previousFiber = current;
        try {
            setCurrentFiber(fiber);
            error("Can't perform a React state update on a component that hasn't mounted yet. This indicates that you have a side-effect in your render function that asynchronously later calls tries to update the component. Move this work to useEffect instead.");
        } finally{
            if (previousFiber) setCurrentFiber(fiber);
            else resetCurrentFiber();
        }
    }
    var beginWork$1;
    var dummyFiber = null;
    beginWork$1 = function(current, unitOfWork, lanes) {
        // If a component throws an error, we replay it again in a synchronously
        // dispatched event, so that the debugger will treat it as an uncaught
        // error See ReactErrorUtils for more information.
        // Before entering the begin phase, copy the work-in-progress onto a dummy
        // fiber. If beginWork throws, we'll use this to reset the state.
        var originalWorkInProgressCopy = assignFiberPropertiesInDEV(dummyFiber, unitOfWork);
        try {
            return beginWork(current, unitOfWork, lanes);
        } catch (originalError) {
            if (didSuspendOrErrorWhileHydratingDEV() || originalError !== null && typeof originalError === "object" && typeof originalError.then === "function") // Don't replay promises.
            // Don't replay errors if we are hydrating and have already suspended or handled an error
            throw originalError;
             // Keep this code in sync with handleError; any changes here must have
            // corresponding changes there.
            resetContextDependencies();
            resetHooksAfterThrow(); // Don't reset current debug fiber, since we're about to work on the
            // same fiber again.
            // Unwind the failed stack frame
            unwindInterruptedWork(current, unitOfWork); // Restore the original properties of the fiber.
            assignFiberPropertiesInDEV(unitOfWork, originalWorkInProgressCopy);
            if (unitOfWork.mode & ProfileMode) // Reset the profiler timer.
            startProfilerTimer(unitOfWork);
             // Run beginWork again.
            invokeGuardedCallback(null, beginWork, null, current, unitOfWork, lanes);
            if (hasCaughtError()) {
                var replayError = clearCaughtError();
                if (typeof replayError === "object" && replayError !== null && replayError._suppressLogging && typeof originalError === "object" && originalError !== null && !originalError._suppressLogging) // If suppressed, let the flag carry over to the original error which is the one we'll rethrow.
                originalError._suppressLogging = true;
            } // We always throw the original error in case the second render pass is not idempotent.
            // This can happen if a memoized function or CommonJS module doesn't throw after first invocation.
            throw originalError;
        }
    };
    var didWarnAboutUpdateInRender = false;
    var didWarnAboutUpdateInRenderForAnotherComponent;
    didWarnAboutUpdateInRenderForAnotherComponent = new Set();
    function warnAboutRenderPhaseUpdatesInDEV(fiber) {
        if (isRendering && !getIsUpdatingOpaqueValueInRenderPhaseInDEV()) switch(fiber.tag){
            case FunctionComponent:
            case ForwardRef:
            case SimpleMemoComponent:
                var renderingComponentName = workInProgress && getComponentNameFromFiber(workInProgress) || "Unknown"; // Dedupe by the rendering component because it's the one that needs to be fixed.
                var dedupeKey = renderingComponentName;
                if (!didWarnAboutUpdateInRenderForAnotherComponent.has(dedupeKey)) {
                    didWarnAboutUpdateInRenderForAnotherComponent.add(dedupeKey);
                    var setStateComponentName = getComponentNameFromFiber(fiber) || "Unknown";
                    error("Cannot update a component (`%s`) while rendering a different component (`%s`). To locate the bad setState() call inside `%s`, follow the stack trace as described in https://reactjs.org/link/setstate-in-render", setStateComponentName, renderingComponentName, renderingComponentName);
                }
                break;
            case ClassComponent:
                if (!didWarnAboutUpdateInRender) {
                    error("Cannot update during an existing state transition (such as within `render`). Render methods should be a pure function of props and state.");
                    didWarnAboutUpdateInRender = true;
                }
                break;
        }
    }
    function restorePendingUpdaters(root, lanes) {
        if (isDevToolsPresent) {
            var memoizedUpdaters = root.memoizedUpdaters;
            memoizedUpdaters.forEach(function(schedulingFiber) {
                addFiberToLanesMap(root, schedulingFiber, lanes);
            }); // This function intentionally does not clear memoized updaters.
        // Those may still be relevant to the current commit
        // and a future one (e.g. Suspense).
        }
    }
    var fakeActCallbackNode = {};
    function scheduleCallback$1(priorityLevel, callback) {
        // If we're currently inside an `act` scope, bypass Scheduler and push to
        // the `act` queue instead.
        var actQueue = ReactCurrentActQueue$1.current;
        if (actQueue !== null) {
            actQueue.push(callback);
            return fakeActCallbackNode;
        } else return scheduleCallback(priorityLevel, callback);
    }
    function cancelCallback$1(callbackNode) {
        if (callbackNode === fakeActCallbackNode) return;
         // In production, always call Scheduler. This function will be stripped out.
        return cancelCallback(callbackNode);
    }
    function shouldForceFlushFallbacksInDEV() {
        // Never force flush in production. This function should get stripped out.
        return ReactCurrentActQueue$1.current !== null;
    }
    function warnIfUpdatesNotWrappedWithActDEV(fiber) {
        if (fiber.mode & ConcurrentMode) {
            if (!isConcurrentActEnvironment()) // Not in an act environment. No need to warn.
            return;
        } else {
            // Legacy mode has additional cases where we suppress a warning.
            if (!isLegacyActEnvironment()) // Not in an act environment. No need to warn.
            return;
            if (executionContext !== NoContext) // Legacy mode doesn't warn if the update is batched, i.e.
            // batchedUpdates or flushSync.
            return;
            if (fiber.tag !== FunctionComponent && fiber.tag !== ForwardRef && fiber.tag !== SimpleMemoComponent) // For backwards compatibility with pre-hooks code, legacy mode only
            // warns for updates that originate from a hook.
            return;
        }
        if (ReactCurrentActQueue$1.current === null) {
            var previousFiber = current;
            try {
                setCurrentFiber(fiber);
                error("An update to %s inside a test was not wrapped in act(...).\n\nWhen testing, code that causes React state updates should be wrapped into act(...):\n\nact(() => {\n  /* fire events that update state */\n});\n/* assert on the output */\n\nThis ensures that you're testing the behavior the user would see in the browser. Learn more at https://reactjs.org/link/wrap-tests-with-act", getComponentNameFromFiber(fiber));
            } finally{
                if (previousFiber) setCurrentFiber(fiber);
                else resetCurrentFiber();
            }
        }
    }
    function warnIfSuspenseResolutionNotWrappedWithActDEV(root) {
        if (root.tag !== LegacyRoot && isConcurrentActEnvironment() && ReactCurrentActQueue$1.current === null) error("A suspended resource finished loading inside a test, but the event was not wrapped in act(...).\n\nWhen testing, code that resolves suspended data should be wrapped into act(...):\n\nact(() => {\n  /* finish loading suspended data */\n});\n/* assert on the output */\n\nThis ensures that you're testing the behavior the user would see in the browser. Learn more at https://reactjs.org/link/wrap-tests-with-act");
    }
    function setIsRunningInsertionEffect(isRunning) {
        isRunningInsertionEffect = isRunning;
    }
    /* eslint-disable react-internal/prod-error-codes */ var resolveFamily = null; // $FlowFixMe Flow gets confused by a WeakSet feature check below.
    var failedBoundaries = null;
    var setRefreshHandler = function(handler) {
        resolveFamily = handler;
    };
    function resolveFunctionForHotReloading(type) {
        if (resolveFamily === null) // Hot reloading is disabled.
        return type;
        var family = resolveFamily(type);
        if (family === undefined) return type;
         // Use the latest known implementation.
        return family.current;
    }
    function resolveClassForHotReloading(type) {
        // No implementation differences.
        return resolveFunctionForHotReloading(type);
    }
    function resolveForwardRefForHotReloading(type) {
        if (resolveFamily === null) // Hot reloading is disabled.
        return type;
        var family = resolveFamily(type);
        if (family === undefined) {
            // Check if we're dealing with a real forwardRef. Don't want to crash early.
            if (type !== null && type !== undefined && typeof type.render === "function") {
                // ForwardRef is special because its resolved .type is an object,
                // but it's possible that we only have its inner render function in the map.
                // If that inner render function is different, we'll build a new forwardRef type.
                var currentRender = resolveFunctionForHotReloading(type.render);
                if (type.render !== currentRender) {
                    var syntheticType = {
                        $$typeof: REACT_FORWARD_REF_TYPE,
                        render: currentRender
                    };
                    if (type.displayName !== undefined) syntheticType.displayName = type.displayName;
                    return syntheticType;
                }
            }
            return type;
        } // Use the latest known implementation.
        return family.current;
    }
    function isCompatibleFamilyForHotReloading(fiber, element) {
        if (resolveFamily === null) // Hot reloading is disabled.
        return false;
        var prevType = fiber.elementType;
        var nextType = element.type; // If we got here, we know types aren't === equal.
        var needsCompareFamilies = false;
        var $$typeofNextType = typeof nextType === "object" && nextType !== null ? nextType.$$typeof : null;
        switch(fiber.tag){
            case ClassComponent:
                if (typeof nextType === "function") needsCompareFamilies = true;
                break;
            case FunctionComponent:
                if (typeof nextType === "function") needsCompareFamilies = true;
                else if ($$typeofNextType === REACT_LAZY_TYPE) // We don't know the inner type yet.
                // We're going to assume that the lazy inner type is stable,
                // and so it is sufficient to avoid reconciling it away.
                // We're not going to unwrap or actually use the new lazy type.
                needsCompareFamilies = true;
                break;
            case ForwardRef:
                if ($$typeofNextType === REACT_FORWARD_REF_TYPE) needsCompareFamilies = true;
                else if ($$typeofNextType === REACT_LAZY_TYPE) needsCompareFamilies = true;
                break;
            case MemoComponent:
            case SimpleMemoComponent:
                if ($$typeofNextType === REACT_MEMO_TYPE) // TODO: if it was but can no longer be simple,
                // we shouldn't set this.
                needsCompareFamilies = true;
                else if ($$typeofNextType === REACT_LAZY_TYPE) needsCompareFamilies = true;
                break;
            default:
                return false;
        } // Check if both types have a family and it's the same one.
        if (needsCompareFamilies) {
            // Note: memo() and forwardRef() we'll compare outer rather than inner type.
            // This means both of them need to be registered to preserve state.
            // If we unwrapped and compared the inner types for wrappers instead,
            // then we would risk falsely saying two separate memo(Foo)
            // calls are equivalent because they wrap the same Foo function.
            var prevFamily = resolveFamily(prevType);
            if (prevFamily !== undefined && prevFamily === resolveFamily(nextType)) return true;
        }
        return false;
    }
    function markFailedErrorBoundaryForHotReloading(fiber) {
        if (resolveFamily === null) // Hot reloading is disabled.
        return;
        if (typeof WeakSet !== "function") return;
        if (failedBoundaries === null) failedBoundaries = new WeakSet();
        failedBoundaries.add(fiber);
    }
    var scheduleRefresh = function(root, update) {
        if (resolveFamily === null) // Hot reloading is disabled.
        return;
        var staleFamilies = update.staleFamilies, updatedFamilies = update.updatedFamilies;
        flushPassiveEffects();
        flushSync(function() {
            scheduleFibersWithFamiliesRecursively(root.current, updatedFamilies, staleFamilies);
        });
    };
    var scheduleRoot = function(root, element) {
        if (root.context !== emptyContextObject) // Super edge case: root has a legacy _renderSubtree context
        // but we don't know the parentComponent so we can't pass it.
        // Just ignore. We'll delete this with _renderSubtree code path later.
        return;
        flushPassiveEffects();
        flushSync(function() {
            updateContainer(element, root, null, null);
        });
    };
    function scheduleFibersWithFamiliesRecursively(fiber, updatedFamilies, staleFamilies) {
        var alternate = fiber.alternate, child = fiber.child, sibling = fiber.sibling, tag = fiber.tag, type = fiber.type;
        var candidateType = null;
        switch(tag){
            case FunctionComponent:
            case SimpleMemoComponent:
            case ClassComponent:
                candidateType = type;
                break;
            case ForwardRef:
                candidateType = type.render;
                break;
        }
        if (resolveFamily === null) throw new Error("Expected resolveFamily to be set during hot reload.");
        var needsRender = false;
        var needsRemount = false;
        if (candidateType !== null) {
            var family = resolveFamily(candidateType);
            if (family !== undefined) {
                if (staleFamilies.has(family)) needsRemount = true;
                else if (updatedFamilies.has(family)) {
                    if (tag === ClassComponent) needsRemount = true;
                    else needsRender = true;
                }
            }
        }
        if (failedBoundaries !== null) {
            if (failedBoundaries.has(fiber) || alternate !== null && failedBoundaries.has(alternate)) needsRemount = true;
        }
        if (needsRemount) fiber._debugNeedsRemount = true;
        if (needsRemount || needsRender) {
            var _root = enqueueConcurrentRenderForLane(fiber, SyncLane);
            if (_root !== null) scheduleUpdateOnFiber(_root, fiber, SyncLane, NoTimestamp);
        }
        if (child !== null && !needsRemount) scheduleFibersWithFamiliesRecursively(child, updatedFamilies, staleFamilies);
        if (sibling !== null) scheduleFibersWithFamiliesRecursively(sibling, updatedFamilies, staleFamilies);
    }
    var findHostInstancesForRefresh = function(root, families) {
        var hostInstances = new Set();
        var types = new Set(families.map(function(family) {
            return family.current;
        }));
        findHostInstancesForMatchingFibersRecursively(root.current, types, hostInstances);
        return hostInstances;
    };
    function findHostInstancesForMatchingFibersRecursively(fiber, types, hostInstances) {
        var child = fiber.child, sibling = fiber.sibling, tag = fiber.tag, type = fiber.type;
        var candidateType = null;
        switch(tag){
            case FunctionComponent:
            case SimpleMemoComponent:
            case ClassComponent:
                candidateType = type;
                break;
            case ForwardRef:
                candidateType = type.render;
                break;
        }
        var didMatch = false;
        if (candidateType !== null) {
            if (types.has(candidateType)) didMatch = true;
        }
        if (didMatch) // We have a match. This only drills down to the closest host components.
        // There's no need to search deeper because for the purpose of giving
        // visual feedback, "flashing" outermost parent rectangles is sufficient.
        findHostInstancesForFiberShallowly(fiber, hostInstances);
        else // If there's no match, maybe there will be one further down in the child tree.
        if (child !== null) findHostInstancesForMatchingFibersRecursively(child, types, hostInstances);
        if (sibling !== null) findHostInstancesForMatchingFibersRecursively(sibling, types, hostInstances);
    }
    function findHostInstancesForFiberShallowly(fiber, hostInstances) {
        var foundHostInstances = findChildHostInstancesForFiberShallowly(fiber, hostInstances);
        if (foundHostInstances) return;
         // If we didn't find any host children, fallback to closest host parent.
        var node = fiber;
        while(true){
            switch(node.tag){
                case HostComponent:
                    hostInstances.add(node.stateNode);
                    return;
                case HostPortal:
                    hostInstances.add(node.stateNode.containerInfo);
                    return;
                case HostRoot:
                    hostInstances.add(node.stateNode.containerInfo);
                    return;
            }
            if (node.return === null) throw new Error("Expected to reach root first.");
            node = node.return;
        }
    }
    function findChildHostInstancesForFiberShallowly(fiber, hostInstances) {
        var node = fiber;
        var foundHostInstances = false;
        while(true){
            if (node.tag === HostComponent) {
                // We got a match.
                foundHostInstances = true;
                hostInstances.add(node.stateNode); // There may still be more, so keep searching.
            } else if (node.child !== null) {
                node.child.return = node;
                node = node.child;
                continue;
            }
            if (node === fiber) return foundHostInstances;
            while(node.sibling === null){
                if (node.return === null || node.return === fiber) return foundHostInstances;
                node = node.return;
            }
            node.sibling.return = node.return;
            node = node.sibling;
        }
        return false;
    }
    var hasBadMapPolyfill;
    hasBadMapPolyfill = false;
    try {
        var nonExtensibleObject = Object.preventExtensions({});
        /* eslint-disable no-new */ new Map([
            [
                nonExtensibleObject,
                null
            ]
        ]);
        new Set([
            nonExtensibleObject
        ]);
    /* eslint-enable no-new */ } catch (e) {
        // TODO: Consider warning about bad polyfills
        hasBadMapPolyfill = true;
    }
    function FiberNode(tag, pendingProps, key, mode) {
        // Instance
        this.tag = tag;
        this.key = key;
        this.elementType = null;
        this.type = null;
        this.stateNode = null; // Fiber
        this.return = null;
        this.child = null;
        this.sibling = null;
        this.index = 0;
        this.ref = null;
        this.pendingProps = pendingProps;
        this.memoizedProps = null;
        this.updateQueue = null;
        this.memoizedState = null;
        this.dependencies = null;
        this.mode = mode; // Effects
        this.flags = NoFlags;
        this.subtreeFlags = NoFlags;
        this.deletions = null;
        this.lanes = NoLanes;
        this.childLanes = NoLanes;
        this.alternate = null;
        // Note: The following is done to avoid a v8 performance cliff.
        //
        // Initializing the fields below to smis and later updating them with
        // double values will cause Fibers to end up having separate shapes.
        // This behavior/bug has something to do with Object.preventExtension().
        // Fortunately this only impacts DEV builds.
        // Unfortunately it makes React unusably slow for some applications.
        // To work around this, initialize the fields below with doubles.
        //
        // Learn more about this here:
        // https://github.com/facebook/react/issues/14365
        // https://bugs.chromium.org/p/v8/issues/detail?id=8538
        this.actualDuration = Number.NaN;
        this.actualStartTime = Number.NaN;
        this.selfBaseDuration = Number.NaN;
        this.treeBaseDuration = Number.NaN; // It's okay to replace the initial doubles with smis after initialization.
        // This won't trigger the performance cliff mentioned above,
        // and it simplifies other profiler code (including DevTools).
        this.actualDuration = 0;
        this.actualStartTime = -1;
        this.selfBaseDuration = 0;
        this.treeBaseDuration = 0;
        // This isn't directly used but is handy for debugging internals:
        this._debugSource = null;
        this._debugOwner = null;
        this._debugNeedsRemount = false;
        this._debugHookTypes = null;
        if (!hasBadMapPolyfill && typeof Object.preventExtensions === "function") Object.preventExtensions(this);
    } // This is a constructor function, rather than a POJO constructor, still
    // please ensure we do the following:
    // 1) Nobody should add any instance methods on this. Instance methods can be
    //    more difficult to predict when they get optimized and they are almost
    //    never inlined properly in static compilers.
    // 2) Nobody should rely on `instanceof Fiber` for type testing. We should
    //    always know when it is a fiber.
    // 3) We might want to experiment with using numeric keys since they are easier
    //    to optimize in a non-JIT environment.
    // 4) We can easily go from a constructor to a createFiber object literal if that
    //    is faster.
    // 5) It should be easy to port this to a C struct and keep a C implementation
    //    compatible.
    var createFiber = function(tag, pendingProps, key, mode) {
        // $FlowFixMe: the shapes are exact here but Flow doesn't like constructors
        return new FiberNode(tag, pendingProps, key, mode);
    };
    function shouldConstruct$1(Component) {
        var prototype = Component.prototype;
        return !!(prototype && prototype.isReactComponent);
    }
    function isSimpleFunctionComponent(type) {
        return typeof type === "function" && !shouldConstruct$1(type) && type.defaultProps === undefined;
    }
    function resolveLazyComponentTag(Component) {
        if (typeof Component === "function") return shouldConstruct$1(Component) ? ClassComponent : FunctionComponent;
        else if (Component !== undefined && Component !== null) {
            var $$typeof = Component.$$typeof;
            if ($$typeof === REACT_FORWARD_REF_TYPE) return ForwardRef;
            if ($$typeof === REACT_MEMO_TYPE) return MemoComponent;
        }
        return IndeterminateComponent;
    } // This is used to create an alternate fiber to do work on.
    function createWorkInProgress(current, pendingProps) {
        var workInProgress = current.alternate;
        if (workInProgress === null) {
            // We use a double buffering pooling technique because we know that we'll
            // only ever need at most two versions of a tree. We pool the "other" unused
            // node that we're free to reuse. This is lazily created to avoid allocating
            // extra objects for things that are never updated. It also allow us to
            // reclaim the extra memory if needed.
            workInProgress = createFiber(current.tag, pendingProps, current.key, current.mode);
            workInProgress.elementType = current.elementType;
            workInProgress.type = current.type;
            workInProgress.stateNode = current.stateNode;
            // DEV-only fields
            workInProgress._debugSource = current._debugSource;
            workInProgress._debugOwner = current._debugOwner;
            workInProgress._debugHookTypes = current._debugHookTypes;
            workInProgress.alternate = current;
            current.alternate = workInProgress;
        } else {
            workInProgress.pendingProps = pendingProps; // Needed because Blocks store data on type.
            workInProgress.type = current.type; // We already have an alternate.
            // Reset the effect tag.
            workInProgress.flags = NoFlags; // The effects are no longer valid.
            workInProgress.subtreeFlags = NoFlags;
            workInProgress.deletions = null;
            // We intentionally reset, rather than copy, actualDuration & actualStartTime.
            // This prevents time from endlessly accumulating in new commits.
            // This has the downside of resetting values for different priority renders,
            // But works for yielding (the common case) and should support resuming.
            workInProgress.actualDuration = 0;
            workInProgress.actualStartTime = -1;
        } // Reset all effects except static ones.
        // Static effects are not specific to a render.
        workInProgress.flags = current.flags & StaticMask;
        workInProgress.childLanes = current.childLanes;
        workInProgress.lanes = current.lanes;
        workInProgress.child = current.child;
        workInProgress.memoizedProps = current.memoizedProps;
        workInProgress.memoizedState = current.memoizedState;
        workInProgress.updateQueue = current.updateQueue; // Clone the dependencies object. This is mutated during the render phase, so
        // it cannot be shared with the current fiber.
        var currentDependencies = current.dependencies;
        workInProgress.dependencies = currentDependencies === null ? null : {
            lanes: currentDependencies.lanes,
            firstContext: currentDependencies.firstContext
        }; // These will be overridden during the parent's reconciliation
        workInProgress.sibling = current.sibling;
        workInProgress.index = current.index;
        workInProgress.ref = current.ref;
        workInProgress.selfBaseDuration = current.selfBaseDuration;
        workInProgress.treeBaseDuration = current.treeBaseDuration;
        workInProgress._debugNeedsRemount = current._debugNeedsRemount;
        switch(workInProgress.tag){
            case IndeterminateComponent:
            case FunctionComponent:
            case SimpleMemoComponent:
                workInProgress.type = resolveFunctionForHotReloading(current.type);
                break;
            case ClassComponent:
                workInProgress.type = resolveClassForHotReloading(current.type);
                break;
            case ForwardRef:
                workInProgress.type = resolveForwardRefForHotReloading(current.type);
                break;
        }
        return workInProgress;
    } // Used to reuse a Fiber for a second pass.
    function resetWorkInProgress(workInProgress, renderLanes) {
        // This resets the Fiber to what createFiber or createWorkInProgress would
        // have set the values to before during the first pass. Ideally this wouldn't
        // be necessary but unfortunately many code paths reads from the workInProgress
        // when they should be reading from current and writing to workInProgress.
        // We assume pendingProps, index, key, ref, return are still untouched to
        // avoid doing another reconciliation.
        // Reset the effect flags but keep any Placement tags, since that's something
        // that child fiber is setting, not the reconciliation.
        workInProgress.flags &= StaticMask | Placement; // The effects are no longer valid.
        var current = workInProgress.alternate;
        if (current === null) {
            // Reset to createFiber's initial values.
            workInProgress.childLanes = NoLanes;
            workInProgress.lanes = renderLanes;
            workInProgress.child = null;
            workInProgress.subtreeFlags = NoFlags;
            workInProgress.memoizedProps = null;
            workInProgress.memoizedState = null;
            workInProgress.updateQueue = null;
            workInProgress.dependencies = null;
            workInProgress.stateNode = null;
            // Note: We don't reset the actualTime counts. It's useful to accumulate
            // actual time across multiple render passes.
            workInProgress.selfBaseDuration = 0;
            workInProgress.treeBaseDuration = 0;
        } else {
            // Reset to the cloned values that createWorkInProgress would've.
            workInProgress.childLanes = current.childLanes;
            workInProgress.lanes = current.lanes;
            workInProgress.child = current.child;
            workInProgress.subtreeFlags = NoFlags;
            workInProgress.deletions = null;
            workInProgress.memoizedProps = current.memoizedProps;
            workInProgress.memoizedState = current.memoizedState;
            workInProgress.updateQueue = current.updateQueue; // Needed because Blocks store data on type.
            workInProgress.type = current.type; // Clone the dependencies object. This is mutated during the render phase, so
            // it cannot be shared with the current fiber.
            var currentDependencies = current.dependencies;
            workInProgress.dependencies = currentDependencies === null ? null : {
                lanes: currentDependencies.lanes,
                firstContext: currentDependencies.firstContext
            };
            // Note: We don't reset the actualTime counts. It's useful to accumulate
            // actual time across multiple render passes.
            workInProgress.selfBaseDuration = current.selfBaseDuration;
            workInProgress.treeBaseDuration = current.treeBaseDuration;
        }
        return workInProgress;
    }
    function createHostRootFiber(tag, isStrictMode, concurrentUpdatesByDefaultOverride) {
        var mode;
        if (tag === ConcurrentRoot) {
            mode = ConcurrentMode;
            if (isStrictMode === true) {
                mode |= StrictLegacyMode;
                mode |= StrictEffectsMode;
            }
        } else mode = NoMode;
        if (isDevToolsPresent) // Always collect profile timings when DevTools are present.
        // This enables DevTools to start capturing timing at any point–
        // Without some nodes in the tree having empty base times.
        mode |= ProfileMode;
        return createFiber(HostRoot, null, null, mode);
    }
    function createFiberFromTypeAndProps(type, key, pendingProps, owner, mode, lanes) {
        var fiberTag = IndeterminateComponent; // The resolved type is set if we know what the final type will be. I.e. it's not lazy.
        var resolvedType = type;
        if (typeof type === "function") {
            if (shouldConstruct$1(type)) {
                fiberTag = ClassComponent;
                resolvedType = resolveClassForHotReloading(resolvedType);
            } else resolvedType = resolveFunctionForHotReloading(resolvedType);
        } else if (typeof type === "string") fiberTag = HostComponent;
        else getTag: switch(type){
            case REACT_FRAGMENT_TYPE:
                return createFiberFromFragment(pendingProps.children, mode, lanes, key);
            case REACT_STRICT_MODE_TYPE:
                fiberTag = Mode;
                mode |= StrictLegacyMode;
                if ((mode & ConcurrentMode) !== NoMode) // Strict effects should never run on legacy roots
                mode |= StrictEffectsMode;
                break;
            case REACT_PROFILER_TYPE:
                return createFiberFromProfiler(pendingProps, mode, lanes, key);
            case REACT_SUSPENSE_TYPE:
                return createFiberFromSuspense(pendingProps, mode, lanes, key);
            case REACT_SUSPENSE_LIST_TYPE:
                return createFiberFromSuspenseList(pendingProps, mode, lanes, key);
            case REACT_OFFSCREEN_TYPE:
                return createFiberFromOffscreen(pendingProps, mode, lanes, key);
            case REACT_LEGACY_HIDDEN_TYPE:
            // eslint-disable-next-line no-fallthrough
            case REACT_SCOPE_TYPE:
            // eslint-disable-next-line no-fallthrough
            case REACT_CACHE_TYPE:
            // eslint-disable-next-line no-fallthrough
            case REACT_TRACING_MARKER_TYPE:
            // eslint-disable-next-line no-fallthrough
            case REACT_DEBUG_TRACING_MODE_TYPE:
            // eslint-disable-next-line no-fallthrough
            default:
                if (typeof type === "object" && type !== null) switch(type.$$typeof){
                    case REACT_PROVIDER_TYPE:
                        fiberTag = ContextProvider;
                        break getTag;
                    case REACT_CONTEXT_TYPE:
                        // This is a consumer
                        fiberTag = ContextConsumer;
                        break getTag;
                    case REACT_FORWARD_REF_TYPE:
                        fiberTag = ForwardRef;
                        resolvedType = resolveForwardRefForHotReloading(resolvedType);
                        break getTag;
                    case REACT_MEMO_TYPE:
                        fiberTag = MemoComponent;
                        break getTag;
                    case REACT_LAZY_TYPE:
                        fiberTag = LazyComponent;
                        resolvedType = null;
                        break getTag;
                }
                var info = "";
                if (type === undefined || typeof type === "object" && type !== null && Object.keys(type).length === 0) info += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.";
                var ownerName = owner ? getComponentNameFromFiber(owner) : null;
                if (ownerName) info += "\n\nCheck the render method of `" + ownerName + "`.";
                throw new Error("Element type is invalid: expected a string (for built-in components) or a class/function (for composite components) " + ("but got: " + (type == null ? type : typeof type) + "." + info));
        }
        var fiber = createFiber(fiberTag, pendingProps, key, mode);
        fiber.elementType = type;
        fiber.type = resolvedType;
        fiber.lanes = lanes;
        fiber._debugOwner = owner;
        return fiber;
    }
    function createFiberFromElement(element, mode, lanes) {
        var owner = null;
        owner = element._owner;
        var type = element.type;
        var key = element.key;
        var pendingProps = element.props;
        var fiber = createFiberFromTypeAndProps(type, key, pendingProps, owner, mode, lanes);
        fiber._debugSource = element._source;
        fiber._debugOwner = element._owner;
        return fiber;
    }
    function createFiberFromFragment(elements, mode, lanes, key) {
        var fiber = createFiber(Fragment, elements, key, mode);
        fiber.lanes = lanes;
        return fiber;
    }
    function createFiberFromProfiler(pendingProps, mode, lanes, key) {
        if (typeof pendingProps.id !== "string") error('Profiler must specify an "id" of type `string` as a prop. Received the type `%s` instead.', typeof pendingProps.id);
        var fiber = createFiber(Profiler, pendingProps, key, mode | ProfileMode);
        fiber.elementType = REACT_PROFILER_TYPE;
        fiber.lanes = lanes;
        fiber.stateNode = {
            effectDuration: 0,
            passiveEffectDuration: 0
        };
        return fiber;
    }
    function createFiberFromSuspense(pendingProps, mode, lanes, key) {
        var fiber = createFiber(SuspenseComponent, pendingProps, key, mode);
        fiber.elementType = REACT_SUSPENSE_TYPE;
        fiber.lanes = lanes;
        return fiber;
    }
    function createFiberFromSuspenseList(pendingProps, mode, lanes, key) {
        var fiber = createFiber(SuspenseListComponent, pendingProps, key, mode);
        fiber.elementType = REACT_SUSPENSE_LIST_TYPE;
        fiber.lanes = lanes;
        return fiber;
    }
    function createFiberFromOffscreen(pendingProps, mode, lanes, key) {
        var fiber = createFiber(OffscreenComponent, pendingProps, key, mode);
        fiber.elementType = REACT_OFFSCREEN_TYPE;
        fiber.lanes = lanes;
        var primaryChildInstance = {
            isHidden: false
        };
        fiber.stateNode = primaryChildInstance;
        return fiber;
    }
    function createFiberFromText(content, mode, lanes) {
        var fiber = createFiber(HostText, content, null, mode);
        fiber.lanes = lanes;
        return fiber;
    }
    function createFiberFromHostInstanceForDeletion() {
        var fiber = createFiber(HostComponent, null, null, NoMode);
        fiber.elementType = "DELETED";
        return fiber;
    }
    function createFiberFromDehydratedFragment(dehydratedNode) {
        var fiber = createFiber(DehydratedFragment, null, null, NoMode);
        fiber.stateNode = dehydratedNode;
        return fiber;
    }
    function createFiberFromPortal(portal, mode, lanes) {
        var pendingProps = portal.children !== null ? portal.children : [];
        var fiber = createFiber(HostPortal, pendingProps, portal.key, mode);
        fiber.lanes = lanes;
        fiber.stateNode = {
            containerInfo: portal.containerInfo,
            pendingChildren: null,
            // Used by persistent updates
            implementation: portal.implementation
        };
        return fiber;
    } // Used for stashing WIP properties to replay failed work in DEV.
    function assignFiberPropertiesInDEV(target, source) {
        if (target === null) // This Fiber's initial properties will always be overwritten.
        // We only use a Fiber to ensure the same hidden class so DEV isn't slow.
        target = createFiber(IndeterminateComponent, null, null, NoMode);
         // This is intentionally written as a list of all properties.
        // We tried to use Object.assign() instead but this is called in
        // the hottest path, and Object.assign() was too slow:
        // https://github.com/facebook/react/issues/12502
        // This code is DEV-only so size is not a concern.
        target.tag = source.tag;
        target.key = source.key;
        target.elementType = source.elementType;
        target.type = source.type;
        target.stateNode = source.stateNode;
        target.return = source.return;
        target.child = source.child;
        target.sibling = source.sibling;
        target.index = source.index;
        target.ref = source.ref;
        target.pendingProps = source.pendingProps;
        target.memoizedProps = source.memoizedProps;
        target.updateQueue = source.updateQueue;
        target.memoizedState = source.memoizedState;
        target.dependencies = source.dependencies;
        target.mode = source.mode;
        target.flags = source.flags;
        target.subtreeFlags = source.subtreeFlags;
        target.deletions = source.deletions;
        target.lanes = source.lanes;
        target.childLanes = source.childLanes;
        target.alternate = source.alternate;
        target.actualDuration = source.actualDuration;
        target.actualStartTime = source.actualStartTime;
        target.selfBaseDuration = source.selfBaseDuration;
        target.treeBaseDuration = source.treeBaseDuration;
        target._debugSource = source._debugSource;
        target._debugOwner = source._debugOwner;
        target._debugNeedsRemount = source._debugNeedsRemount;
        target._debugHookTypes = source._debugHookTypes;
        return target;
    }
    function FiberRootNode(containerInfo, tag, hydrate, identifierPrefix, onRecoverableError) {
        this.tag = tag;
        this.containerInfo = containerInfo;
        this.pendingChildren = null;
        this.current = null;
        this.pingCache = null;
        this.finishedWork = null;
        this.timeoutHandle = noTimeout;
        this.context = null;
        this.pendingContext = null;
        this.callbackNode = null;
        this.callbackPriority = NoLane;
        this.eventTimes = createLaneMap(NoLanes);
        this.expirationTimes = createLaneMap(NoTimestamp);
        this.pendingLanes = NoLanes;
        this.suspendedLanes = NoLanes;
        this.pingedLanes = NoLanes;
        this.expiredLanes = NoLanes;
        this.mutableReadLanes = NoLanes;
        this.finishedLanes = NoLanes;
        this.entangledLanes = NoLanes;
        this.entanglements = createLaneMap(NoLanes);
        this.identifierPrefix = identifierPrefix;
        this.onRecoverableError = onRecoverableError;
        this.mutableSourceEagerHydrationData = null;
        this.effectDuration = 0;
        this.passiveEffectDuration = 0;
        this.memoizedUpdaters = new Set();
        var pendingUpdatersLaneMap = this.pendingUpdatersLaneMap = [];
        for(var _i = 0; _i < TotalLanes; _i++)pendingUpdatersLaneMap.push(new Set());
        switch(tag){
            case ConcurrentRoot:
                this._debugRootType = hydrate ? "hydrateRoot()" : "createRoot()";
                break;
            case LegacyRoot:
                this._debugRootType = hydrate ? "hydrate()" : "render()";
                break;
        }
    }
    function createFiberRoot(containerInfo, tag, hydrate, initialChildren, hydrationCallbacks, isStrictMode, concurrentUpdatesByDefaultOverride, // host config, but because they are passed in at runtime, we have to thread
    // them through the root constructor. Perhaps we should put them all into a
    // single type, like a DynamicHostConfig that is defined by the renderer.
    identifierPrefix, onRecoverableError, transitionCallbacks) {
        var root = new FiberRootNode(containerInfo, tag, hydrate, identifierPrefix, onRecoverableError);
        // stateNode is any.
        var uninitializedFiber = createHostRootFiber(tag, isStrictMode);
        root.current = uninitializedFiber;
        uninitializedFiber.stateNode = root;
        var _initialState = {
            element: initialChildren,
            isDehydrated: hydrate,
            cache: null,
            // not enabled yet
            transitions: null,
            pendingSuspenseBoundaries: null
        };
        uninitializedFiber.memoizedState = _initialState;
        initializeUpdateQueue(uninitializedFiber);
        return root;
    }
    var ReactVersion = "18.2.0";
    function createPortal(children, containerInfo, implementation) {
        var key = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;
        checkKeyStringCoercion(key);
        return {
            // This tag allow us to uniquely identify this as a React Portal
            $$typeof: REACT_PORTAL_TYPE,
            key: key == null ? null : "" + key,
            children: children,
            containerInfo: containerInfo,
            implementation: implementation
        };
    }
    var didWarnAboutNestedUpdates;
    var didWarnAboutFindNodeInStrictMode;
    didWarnAboutNestedUpdates = false;
    didWarnAboutFindNodeInStrictMode = {};
    function getContextForSubtree(parentComponent) {
        if (!parentComponent) return emptyContextObject;
        var fiber = get(parentComponent);
        var parentContext = findCurrentUnmaskedContext(fiber);
        if (fiber.tag === ClassComponent) {
            var Component = fiber.type;
            if (isContextProvider(Component)) return processChildContext(fiber, Component, parentContext);
        }
        return parentContext;
    }
    function findHostInstanceWithWarning(component, methodName) {
        var fiber = get(component);
        if (fiber === undefined) {
            if (typeof component.render === "function") throw new Error("Unable to find node on an unmounted component.");
            else {
                var keys = Object.keys(component).join(",");
                throw new Error("Argument appears to not be a ReactComponent. Keys: " + keys);
            }
        }
        var hostFiber = findCurrentHostFiber(fiber);
        if (hostFiber === null) return null;
        if (hostFiber.mode & StrictLegacyMode) {
            var componentName = getComponentNameFromFiber(fiber) || "Component";
            if (!didWarnAboutFindNodeInStrictMode[componentName]) {
                didWarnAboutFindNodeInStrictMode[componentName] = true;
                var previousFiber = current;
                try {
                    setCurrentFiber(hostFiber);
                    if (fiber.mode & StrictLegacyMode) error("%s is deprecated in StrictMode. %s was passed an instance of %s which is inside StrictMode. Instead, add a ref directly to the element you want to reference. Learn more about using refs safely here: https://reactjs.org/link/strict-mode-find-node", methodName, methodName, componentName);
                    else error("%s is deprecated in StrictMode. %s was passed an instance of %s which renders StrictMode children. Instead, add a ref directly to the element you want to reference. Learn more about using refs safely here: https://reactjs.org/link/strict-mode-find-node", methodName, methodName, componentName);
                } finally{
                    // Ideally this should reset to previous but this shouldn't be called in
                    // render and there's another warning for that anyway.
                    if (previousFiber) setCurrentFiber(previousFiber);
                    else resetCurrentFiber();
                }
            }
        }
        return hostFiber.stateNode;
    }
    function createContainer(containerInfo, tag, hydrationCallbacks, isStrictMode, concurrentUpdatesByDefaultOverride, identifierPrefix, onRecoverableError, transitionCallbacks) {
        var hydrate = false;
        var initialChildren = null;
        return createFiberRoot(containerInfo, tag, hydrate, initialChildren, hydrationCallbacks, isStrictMode, concurrentUpdatesByDefaultOverride, identifierPrefix, onRecoverableError);
    }
    function createHydrationContainer(initialChildren, callback, containerInfo, tag, hydrationCallbacks, isStrictMode, concurrentUpdatesByDefaultOverride, identifierPrefix, onRecoverableError, transitionCallbacks) {
        var hydrate = true;
        var root = createFiberRoot(containerInfo, tag, hydrate, initialChildren, hydrationCallbacks, isStrictMode, concurrentUpdatesByDefaultOverride, identifierPrefix, onRecoverableError); // TODO: Move this to FiberRoot constructor
        root.context = getContextForSubtree(null); // Schedule the initial render. In a hydration root, this is different from
        // a regular update because the initial render must match was was rendered
        // on the server.
        // NOTE: This update intentionally doesn't have a payload. We're only using
        // the update to schedule work on the root fiber (and, for legacy roots, to
        // enqueue the callback if one is provided).
        var current = root.current;
        var eventTime = requestEventTime();
        var lane = requestUpdateLane(current);
        var update = createUpdate(eventTime, lane);
        update.callback = callback !== undefined && callback !== null ? callback : null;
        enqueueUpdate(current, update, lane);
        scheduleInitialHydrationOnRoot(root, lane, eventTime);
        return root;
    }
    function updateContainer(element, container, parentComponent, callback) {
        onScheduleRoot(container, element);
        var current$1 = container.current;
        var eventTime = requestEventTime();
        var lane = requestUpdateLane(current$1);
        markRenderScheduled(lane);
        var context = getContextForSubtree(parentComponent);
        if (container.context === null) container.context = context;
        else container.pendingContext = context;
        if (isRendering && current !== null && !didWarnAboutNestedUpdates) {
            didWarnAboutNestedUpdates = true;
            error("Render methods should be a pure function of props and state; triggering nested component updates from render is not allowed. If necessary, trigger nested updates in componentDidUpdate.\n\nCheck the render method of %s.", getComponentNameFromFiber(current) || "Unknown");
        }
        var update = createUpdate(eventTime, lane); // Caution: React DevTools currently depends on this property
        // being called "element".
        update.payload = {
            element: element
        };
        callback = callback === undefined ? null : callback;
        if (callback !== null) {
            if (typeof callback !== "function") error("render(...): Expected the last optional `callback` argument to be a function. Instead received: %s.", callback);
            update.callback = callback;
        }
        var root = enqueueUpdate(current$1, update, lane);
        if (root !== null) {
            scheduleUpdateOnFiber(root, current$1, lane, eventTime);
            entangleTransitions(root, current$1, lane);
        }
        return lane;
    }
    function getPublicRootInstance(container) {
        var containerFiber = container.current;
        if (!containerFiber.child) return null;
        switch(containerFiber.child.tag){
            case HostComponent:
                return getPublicInstance(containerFiber.child.stateNode);
            default:
                return containerFiber.child.stateNode;
        }
    }
    function attemptSynchronousHydration$1(fiber) {
        switch(fiber.tag){
            case HostRoot:
                var root = fiber.stateNode;
                if (isRootDehydrated(root)) {
                    // Flush the first scheduled "update".
                    var lanes = getHighestPriorityPendingLanes(root);
                    flushRoot(root, lanes);
                }
                break;
            case SuspenseComponent:
                flushSync(function() {
                    var root = enqueueConcurrentRenderForLane(fiber, SyncLane);
                    if (root !== null) {
                        var eventTime = requestEventTime();
                        scheduleUpdateOnFiber(root, fiber, SyncLane, eventTime);
                    }
                }); // If we're still blocked after this, we need to increase
                // the priority of any promises resolving within this
                // boundary so that they next attempt also has higher pri.
                var retryLane = SyncLane;
                markRetryLaneIfNotHydrated(fiber, retryLane);
                break;
        }
    }
    function markRetryLaneImpl(fiber, retryLane) {
        var suspenseState = fiber.memoizedState;
        if (suspenseState !== null && suspenseState.dehydrated !== null) suspenseState.retryLane = higherPriorityLane(suspenseState.retryLane, retryLane);
    } // Increases the priority of thenables when they resolve within this boundary.
    function markRetryLaneIfNotHydrated(fiber, retryLane) {
        markRetryLaneImpl(fiber, retryLane);
        var alternate = fiber.alternate;
        if (alternate) markRetryLaneImpl(alternate, retryLane);
    }
    function attemptContinuousHydration$1(fiber) {
        if (fiber.tag !== SuspenseComponent) // We ignore HostRoots here because we can't increase
        // their priority and they should not suspend on I/O,
        // since you have to wrap anything that might suspend in
        // Suspense.
        return;
        var lane = SelectiveHydrationLane;
        var root = enqueueConcurrentRenderForLane(fiber, lane);
        if (root !== null) {
            var eventTime = requestEventTime();
            scheduleUpdateOnFiber(root, fiber, lane, eventTime);
        }
        markRetryLaneIfNotHydrated(fiber, lane);
    }
    function attemptHydrationAtCurrentPriority$1(fiber) {
        if (fiber.tag !== SuspenseComponent) // We ignore HostRoots here because we can't increase
        // their priority other than synchronously flush it.
        return;
        var lane = requestUpdateLane(fiber);
        var root = enqueueConcurrentRenderForLane(fiber, lane);
        if (root !== null) {
            var eventTime = requestEventTime();
            scheduleUpdateOnFiber(root, fiber, lane, eventTime);
        }
        markRetryLaneIfNotHydrated(fiber, lane);
    }
    function findHostInstanceWithNoPortals(fiber) {
        var hostFiber = findCurrentHostFiberWithNoPortals(fiber);
        if (hostFiber === null) return null;
        return hostFiber.stateNode;
    }
    var shouldErrorImpl = function(fiber) {
        return null;
    };
    function shouldError(fiber) {
        return shouldErrorImpl(fiber);
    }
    var shouldSuspendImpl = function(fiber) {
        return false;
    };
    function shouldSuspend(fiber) {
        return shouldSuspendImpl(fiber);
    }
    var overrideHookState = null;
    var overrideHookStateDeletePath = null;
    var overrideHookStateRenamePath = null;
    var overrideProps = null;
    var overridePropsDeletePath = null;
    var overridePropsRenamePath = null;
    var scheduleUpdate = null;
    var setErrorHandler = null;
    var setSuspenseHandler = null;
    var copyWithDeleteImpl = function(obj, path, index) {
        var key = path[index];
        var updated = isArray(obj) ? obj.slice() : assign({}, obj);
        if (index + 1 === path.length) {
            if (isArray(updated)) updated.splice(key, 1);
            else delete updated[key];
            return updated;
        } // $FlowFixMe number or string is fine here
        updated[key] = copyWithDeleteImpl(obj[key], path, index + 1);
        return updated;
    };
    var copyWithDelete = function(obj, path) {
        return copyWithDeleteImpl(obj, path, 0);
    };
    var copyWithRenameImpl = function(obj, oldPath, newPath, index) {
        var oldKey = oldPath[index];
        var updated = isArray(obj) ? obj.slice() : assign({}, obj);
        if (index + 1 === oldPath.length) {
            var newKey = newPath[index]; // $FlowFixMe number or string is fine here
            updated[newKey] = updated[oldKey];
            if (isArray(updated)) updated.splice(oldKey, 1);
            else delete updated[oldKey];
        } else // $FlowFixMe number or string is fine here
        updated[oldKey] = copyWithRenameImpl(obj[oldKey], oldPath, newPath, index + 1);
        return updated;
    };
    var copyWithRename = function(obj, oldPath, newPath) {
        if (oldPath.length !== newPath.length) {
            warn("copyWithRename() expects paths of the same length");
            return;
        } else {
            for(var i = 0; i < newPath.length - 1; i++)if (oldPath[i] !== newPath[i]) {
                warn("copyWithRename() expects paths to be the same except for the deepest key");
                return;
            }
        }
        return copyWithRenameImpl(obj, oldPath, newPath, 0);
    };
    var copyWithSetImpl = function(obj, path, index, value) {
        if (index >= path.length) return value;
        var key = path[index];
        var updated = isArray(obj) ? obj.slice() : assign({}, obj); // $FlowFixMe number or string is fine here
        updated[key] = copyWithSetImpl(obj[key], path, index + 1, value);
        return updated;
    };
    var copyWithSet = function(obj, path, value) {
        return copyWithSetImpl(obj, path, 0, value);
    };
    var findHook = function(fiber, id) {
        // For now, the "id" of stateful hooks is just the stateful hook index.
        // This may change in the future with e.g. nested hooks.
        var currentHook = fiber.memoizedState;
        while(currentHook !== null && id > 0){
            currentHook = currentHook.next;
            id--;
        }
        return currentHook;
    }; // Support DevTools editable values for useState and useReducer.
    overrideHookState = function(fiber, id, path, value) {
        var hook = findHook(fiber, id);
        if (hook !== null) {
            var newState = copyWithSet(hook.memoizedState, path, value);
            hook.memoizedState = newState;
            hook.baseState = newState; // We aren't actually adding an update to the queue,
            // because there is no update we can add for useReducer hooks that won't trigger an error.
            // (There's no appropriate action type for DevTools overrides.)
            // As a result though, React will see the scheduled update as a noop and bailout.
            // Shallow cloning props works as a workaround for now to bypass the bailout check.
            fiber.memoizedProps = assign({}, fiber.memoizedProps);
            var root = enqueueConcurrentRenderForLane(fiber, SyncLane);
            if (root !== null) scheduleUpdateOnFiber(root, fiber, SyncLane, NoTimestamp);
        }
    };
    overrideHookStateDeletePath = function(fiber, id, path) {
        var hook = findHook(fiber, id);
        if (hook !== null) {
            var newState = copyWithDelete(hook.memoizedState, path);
            hook.memoizedState = newState;
            hook.baseState = newState; // We aren't actually adding an update to the queue,
            // because there is no update we can add for useReducer hooks that won't trigger an error.
            // (There's no appropriate action type for DevTools overrides.)
            // As a result though, React will see the scheduled update as a noop and bailout.
            // Shallow cloning props works as a workaround for now to bypass the bailout check.
            fiber.memoizedProps = assign({}, fiber.memoizedProps);
            var root = enqueueConcurrentRenderForLane(fiber, SyncLane);
            if (root !== null) scheduleUpdateOnFiber(root, fiber, SyncLane, NoTimestamp);
        }
    };
    overrideHookStateRenamePath = function(fiber, id, oldPath, newPath) {
        var hook = findHook(fiber, id);
        if (hook !== null) {
            var newState = copyWithRename(hook.memoizedState, oldPath, newPath);
            hook.memoizedState = newState;
            hook.baseState = newState; // We aren't actually adding an update to the queue,
            // because there is no update we can add for useReducer hooks that won't trigger an error.
            // (There's no appropriate action type for DevTools overrides.)
            // As a result though, React will see the scheduled update as a noop and bailout.
            // Shallow cloning props works as a workaround for now to bypass the bailout check.
            fiber.memoizedProps = assign({}, fiber.memoizedProps);
            var root = enqueueConcurrentRenderForLane(fiber, SyncLane);
            if (root !== null) scheduleUpdateOnFiber(root, fiber, SyncLane, NoTimestamp);
        }
    }; // Support DevTools props for function components, forwardRef, memo, host components, etc.
    overrideProps = function(fiber, path, value) {
        fiber.pendingProps = copyWithSet(fiber.memoizedProps, path, value);
        if (fiber.alternate) fiber.alternate.pendingProps = fiber.pendingProps;
        var root = enqueueConcurrentRenderForLane(fiber, SyncLane);
        if (root !== null) scheduleUpdateOnFiber(root, fiber, SyncLane, NoTimestamp);
    };
    overridePropsDeletePath = function(fiber, path) {
        fiber.pendingProps = copyWithDelete(fiber.memoizedProps, path);
        if (fiber.alternate) fiber.alternate.pendingProps = fiber.pendingProps;
        var root = enqueueConcurrentRenderForLane(fiber, SyncLane);
        if (root !== null) scheduleUpdateOnFiber(root, fiber, SyncLane, NoTimestamp);
    };
    overridePropsRenamePath = function(fiber, oldPath, newPath) {
        fiber.pendingProps = copyWithRename(fiber.memoizedProps, oldPath, newPath);
        if (fiber.alternate) fiber.alternate.pendingProps = fiber.pendingProps;
        var root = enqueueConcurrentRenderForLane(fiber, SyncLane);
        if (root !== null) scheduleUpdateOnFiber(root, fiber, SyncLane, NoTimestamp);
    };
    scheduleUpdate = function(fiber) {
        var root = enqueueConcurrentRenderForLane(fiber, SyncLane);
        if (root !== null) scheduleUpdateOnFiber(root, fiber, SyncLane, NoTimestamp);
    };
    setErrorHandler = function(newShouldErrorImpl) {
        shouldErrorImpl = newShouldErrorImpl;
    };
    setSuspenseHandler = function(newShouldSuspendImpl) {
        shouldSuspendImpl = newShouldSuspendImpl;
    };
    function findHostInstanceByFiber(fiber) {
        var hostFiber = findCurrentHostFiber(fiber);
        if (hostFiber === null) return null;
        return hostFiber.stateNode;
    }
    function emptyFindFiberByHostInstance(instance) {
        return null;
    }
    function getCurrentFiberForDevTools() {
        return current;
    }
    function injectIntoDevTools(devToolsConfig) {
        var findFiberByHostInstance = devToolsConfig.findFiberByHostInstance;
        var ReactCurrentDispatcher = ReactSharedInternals.ReactCurrentDispatcher;
        return injectInternals({
            bundleType: devToolsConfig.bundleType,
            version: devToolsConfig.version,
            rendererPackageName: devToolsConfig.rendererPackageName,
            rendererConfig: devToolsConfig.rendererConfig,
            overrideHookState: overrideHookState,
            overrideHookStateDeletePath: overrideHookStateDeletePath,
            overrideHookStateRenamePath: overrideHookStateRenamePath,
            overrideProps: overrideProps,
            overridePropsDeletePath: overridePropsDeletePath,
            overridePropsRenamePath: overridePropsRenamePath,
            setErrorHandler: setErrorHandler,
            setSuspenseHandler: setSuspenseHandler,
            scheduleUpdate: scheduleUpdate,
            currentDispatcherRef: ReactCurrentDispatcher,
            findHostInstanceByFiber: findHostInstanceByFiber,
            findFiberByHostInstance: findFiberByHostInstance || emptyFindFiberByHostInstance,
            // React Refresh
            findHostInstancesForRefresh: findHostInstancesForRefresh,
            scheduleRefresh: scheduleRefresh,
            scheduleRoot: scheduleRoot,
            setRefreshHandler: setRefreshHandler,
            // Enables DevTools to append owner stacks to error messages in DEV mode.
            getCurrentFiber: getCurrentFiberForDevTools,
            // Enables DevTools to detect reconciler version rather than renderer version
            // which may not match for third party renderers.
            reconcilerVersion: ReactVersion
        });
    }
    /* global reportError */ var defaultOnRecoverableError = typeof reportError === "function" ? // emulating an uncaught JavaScript error.
    reportError : function(error) {
        // In older browsers and test environments, fallback to console.error.
        // eslint-disable-next-line react-internal/no-production-logging
        console["error"](error);
    };
    function ReactDOMRoot(internalRoot) {
        this._internalRoot = internalRoot;
    }
    ReactDOMHydrationRoot.prototype.render = ReactDOMRoot.prototype.render = function(children) {
        var root = this._internalRoot;
        if (root === null) throw new Error("Cannot update an unmounted root.");
        if (typeof arguments[1] === "function") error("render(...): does not support the second callback argument. To execute a side effect after rendering, declare it in a component body with useEffect().");
        else if (isValidContainer(arguments[1])) error("You passed a container to the second argument of root.render(...). You don't need to pass it again since you already passed it to create the root.");
        else if (typeof arguments[1] !== "undefined") error("You passed a second argument to root.render(...) but it only accepts one argument.");
        var container = root.containerInfo;
        if (container.nodeType !== COMMENT_NODE) {
            var hostInstance = findHostInstanceWithNoPortals(root.current);
            if (hostInstance) {
                if (hostInstance.parentNode !== container) error("render(...): It looks like the React-rendered content of the root container was removed without using React. This is not supported and will cause errors. Instead, call root.unmount() to empty a root's container.");
            }
        }
        updateContainer(children, root, null, null);
    };
    ReactDOMHydrationRoot.prototype.unmount = ReactDOMRoot.prototype.unmount = function() {
        if (typeof arguments[0] === "function") error("unmount(...): does not support a callback argument. To execute a side effect after rendering, declare it in a component body with useEffect().");
        var root = this._internalRoot;
        if (root !== null) {
            this._internalRoot = null;
            var container = root.containerInfo;
            if (isAlreadyRendering()) error("Attempted to synchronously unmount a root while React was already rendering. React cannot finish unmounting the root until the current render has completed, which may lead to a race condition.");
            flushSync(function() {
                updateContainer(null, root, null, null);
            });
            unmarkContainerAsRoot(container);
        }
    };
    function createRoot(container, options) {
        if (!isValidContainer(container)) throw new Error("createRoot(...): Target container is not a DOM element.");
        warnIfReactDOMContainerInDEV(container);
        var isStrictMode = false;
        var concurrentUpdatesByDefaultOverride = false;
        var identifierPrefix = "";
        var onRecoverableError = defaultOnRecoverableError;
        var transitionCallbacks = null;
        if (options !== null && options !== undefined) {
            if (options.hydrate) warn("hydrate through createRoot is deprecated. Use ReactDOMClient.hydrateRoot(container, <App />) instead.");
            else if (typeof options === "object" && options !== null && options.$$typeof === REACT_ELEMENT_TYPE) error("You passed a JSX element to createRoot. You probably meant to call root.render instead. Example usage:\n\n  let root = createRoot(domContainer);\n  root.render(<App />);");
            if (options.unstable_strictMode === true) isStrictMode = true;
            if (options.identifierPrefix !== undefined) identifierPrefix = options.identifierPrefix;
            if (options.onRecoverableError !== undefined) onRecoverableError = options.onRecoverableError;
            if (options.transitionCallbacks !== undefined) transitionCallbacks = options.transitionCallbacks;
        }
        var root = createContainer(container, ConcurrentRoot, null, isStrictMode, concurrentUpdatesByDefaultOverride, identifierPrefix, onRecoverableError);
        markContainerAsRoot(root.current, container);
        var rootContainerElement = container.nodeType === COMMENT_NODE ? container.parentNode : container;
        listenToAllSupportedEvents(rootContainerElement);
        return new ReactDOMRoot(root);
    }
    function ReactDOMHydrationRoot(internalRoot) {
        this._internalRoot = internalRoot;
    }
    function scheduleHydration(target) {
        if (target) queueExplicitHydrationTarget(target);
    }
    ReactDOMHydrationRoot.prototype.unstable_scheduleHydration = scheduleHydration;
    function hydrateRoot(container, initialChildren, options) {
        if (!isValidContainer(container)) throw new Error("hydrateRoot(...): Target container is not a DOM element.");
        warnIfReactDOMContainerInDEV(container);
        if (initialChildren === undefined) error("Must provide initial children as second argument to hydrateRoot. Example usage: hydrateRoot(domContainer, <App />)");
        // the hydration callbacks.
        var hydrationCallbacks = options != null ? options : null; // TODO: Delete this option
        var mutableSources = options != null && options.hydratedSources || null;
        var isStrictMode = false;
        var concurrentUpdatesByDefaultOverride = false;
        var identifierPrefix = "";
        var onRecoverableError = defaultOnRecoverableError;
        if (options !== null && options !== undefined) {
            if (options.unstable_strictMode === true) isStrictMode = true;
            if (options.identifierPrefix !== undefined) identifierPrefix = options.identifierPrefix;
            if (options.onRecoverableError !== undefined) onRecoverableError = options.onRecoverableError;
        }
        var root = createHydrationContainer(initialChildren, null, container, ConcurrentRoot, hydrationCallbacks, isStrictMode, concurrentUpdatesByDefaultOverride, identifierPrefix, onRecoverableError);
        markContainerAsRoot(root.current, container); // This can't be a comment node since hydration doesn't work on comment nodes anyway.
        listenToAllSupportedEvents(container);
        if (mutableSources) for(var i = 0; i < mutableSources.length; i++){
            var mutableSource = mutableSources[i];
            registerMutableSourceForHydration(root, mutableSource);
        }
        return new ReactDOMHydrationRoot(root);
    }
    function isValidContainer(node) {
        return !!(node && (node.nodeType === ELEMENT_NODE || node.nodeType === DOCUMENT_NODE || node.nodeType === DOCUMENT_FRAGMENT_NODE || !disableCommentsAsDOMContainers));
    } // TODO: Remove this function which also includes comment nodes.
    // We only use it in places that are currently more relaxed.
    function isValidContainerLegacy(node) {
        return !!(node && (node.nodeType === ELEMENT_NODE || node.nodeType === DOCUMENT_NODE || node.nodeType === DOCUMENT_FRAGMENT_NODE || node.nodeType === COMMENT_NODE && node.nodeValue === " react-mount-point-unstable "));
    }
    function warnIfReactDOMContainerInDEV(container) {
        if (container.nodeType === ELEMENT_NODE && container.tagName && container.tagName.toUpperCase() === "BODY") error("createRoot(): Creating roots directly with document.body is discouraged, since its children are often manipulated by third-party scripts and browser extensions. This may lead to subtle reconciliation issues. Try using a container element created for your app.");
        if (isContainerMarkedAsRoot(container)) {
            if (container._reactRootContainer) error("You are calling ReactDOMClient.createRoot() on a container that was previously passed to ReactDOM.render(). This is not supported.");
            else error("You are calling ReactDOMClient.createRoot() on a container that has already been passed to createRoot() before. Instead, call root.render() on the existing root instead if you want to update it.");
        }
    }
    var ReactCurrentOwner$3 = ReactSharedInternals.ReactCurrentOwner;
    var topLevelUpdateWarnings;
    topLevelUpdateWarnings = function(container) {
        if (container._reactRootContainer && container.nodeType !== COMMENT_NODE) {
            var hostInstance = findHostInstanceWithNoPortals(container._reactRootContainer.current);
            if (hostInstance) {
                if (hostInstance.parentNode !== container) error("render(...): It looks like the React-rendered content of this container was removed without using React. This is not supported and will cause errors. Instead, call ReactDOM.unmountComponentAtNode to empty a container.");
            }
        }
        var isRootRenderedBySomeReact = !!container._reactRootContainer;
        var rootEl = getReactRootElementInContainer(container);
        var hasNonRootReactChild = !!(rootEl && getInstanceFromNode(rootEl));
        if (hasNonRootReactChild && !isRootRenderedBySomeReact) error("render(...): Replacing React-rendered children with a new root component. If you intended to update the children of this node, you should instead have the existing children update their state and render the new components instead of calling ReactDOM.render.");
        if (container.nodeType === ELEMENT_NODE && container.tagName && container.tagName.toUpperCase() === "BODY") error("render(): Rendering components directly into document.body is discouraged, since its children are often manipulated by third-party scripts and browser extensions. This may lead to subtle reconciliation issues. Try rendering into a container element created for your app.");
    };
    function getReactRootElementInContainer(container) {
        if (!container) return null;
        if (container.nodeType === DOCUMENT_NODE) return container.documentElement;
        else return container.firstChild;
    }
    function noopOnRecoverableError() {
    // legacy API.
    }
    function legacyCreateRootFromDOMContainer(container, initialChildren, parentComponent, callback, isHydrationContainer) {
        if (isHydrationContainer) {
            if (typeof callback === "function") {
                var originalCallback = callback;
                callback = function() {
                    var instance = getPublicRootInstance(root);
                    originalCallback.call(instance);
                };
            }
            var root = createHydrationContainer(initialChildren, callback, container, LegacyRoot, null, false, false, "", noopOnRecoverableError);
            container._reactRootContainer = root;
            markContainerAsRoot(root.current, container);
            var rootContainerElement = container.nodeType === COMMENT_NODE ? container.parentNode : container;
            listenToAllSupportedEvents(rootContainerElement);
            flushSync();
            return root;
        } else {
            // First clear any existing content.
            var rootSibling;
            while(rootSibling = container.lastChild)container.removeChild(rootSibling);
            if (typeof callback === "function") {
                var _originalCallback = callback;
                callback = function() {
                    var instance = getPublicRootInstance(_root);
                    _originalCallback.call(instance);
                };
            }
            var _root = createContainer(container, LegacyRoot, null, false, false, "", noopOnRecoverableError);
            container._reactRootContainer = _root;
            markContainerAsRoot(_root.current, container);
            var _rootContainerElement = container.nodeType === COMMENT_NODE ? container.parentNode : container;
            listenToAllSupportedEvents(_rootContainerElement); // Initial mount should not be batched.
            flushSync(function() {
                updateContainer(initialChildren, _root, parentComponent, callback);
            });
            return _root;
        }
    }
    function warnOnInvalidCallback$1(callback, callerName) {
        if (callback !== null && typeof callback !== "function") error("%s(...): Expected the last optional `callback` argument to be a function. Instead received: %s.", callerName, callback);
    }
    function legacyRenderSubtreeIntoContainer(parentComponent, children, container, forceHydrate, callback) {
        topLevelUpdateWarnings(container);
        warnOnInvalidCallback$1(callback === undefined ? null : callback, "render");
        var maybeRoot = container._reactRootContainer;
        var root;
        if (!maybeRoot) // Initial mount
        root = legacyCreateRootFromDOMContainer(container, children, parentComponent, callback, forceHydrate);
        else {
            root = maybeRoot;
            if (typeof callback === "function") {
                var originalCallback = callback;
                callback = function() {
                    var instance = getPublicRootInstance(root);
                    originalCallback.call(instance);
                };
            } // Update
            updateContainer(children, root, parentComponent, callback);
        }
        return getPublicRootInstance(root);
    }
    function findDOMNode(componentOrElement) {
        var owner = ReactCurrentOwner$3.current;
        if (owner !== null && owner.stateNode !== null) {
            var warnedAboutRefsInRender = owner.stateNode._warnedAboutRefsInRender;
            if (!warnedAboutRefsInRender) error("%s is accessing findDOMNode inside its render(). render() should be a pure function of props and state. It should never access something that requires stale data from the previous render, such as refs. Move this logic to componentDidMount and componentDidUpdate instead.", getComponentNameFromType(owner.type) || "A component");
            owner.stateNode._warnedAboutRefsInRender = true;
        }
        if (componentOrElement == null) return null;
        if (componentOrElement.nodeType === ELEMENT_NODE) return componentOrElement;
        return findHostInstanceWithWarning(componentOrElement, "findDOMNode");
    }
    function hydrate(element, container, callback) {
        error("ReactDOM.hydrate is no longer supported in React 18. Use hydrateRoot instead. Until you switch to the new API, your app will behave as if it's running React 17. Learn more: https://reactjs.org/link/switch-to-createroot");
        if (!isValidContainerLegacy(container)) throw new Error("Target container is not a DOM element.");
        var isModernRoot = isContainerMarkedAsRoot(container) && container._reactRootContainer === undefined;
        if (isModernRoot) error("You are calling ReactDOM.hydrate() on a container that was previously passed to ReactDOMClient.createRoot(). This is not supported. Did you mean to call hydrateRoot(container, element)?");
        return legacyRenderSubtreeIntoContainer(null, element, container, true, callback);
    }
    function render(element, container, callback) {
        error("ReactDOM.render is no longer supported in React 18. Use createRoot instead. Until you switch to the new API, your app will behave as if it's running React 17. Learn more: https://reactjs.org/link/switch-to-createroot");
        if (!isValidContainerLegacy(container)) throw new Error("Target container is not a DOM element.");
        var isModernRoot = isContainerMarkedAsRoot(container) && container._reactRootContainer === undefined;
        if (isModernRoot) error("You are calling ReactDOM.render() on a container that was previously passed to ReactDOMClient.createRoot(). This is not supported. Did you mean to call root.render(element)?");
        return legacyRenderSubtreeIntoContainer(null, element, container, false, callback);
    }
    function unstable_renderSubtreeIntoContainer(parentComponent, element, containerNode, callback) {
        error("ReactDOM.unstable_renderSubtreeIntoContainer() is no longer supported in React 18. Consider using a portal instead. Until you switch to the createRoot API, your app will behave as if it's running React 17. Learn more: https://reactjs.org/link/switch-to-createroot");
        if (!isValidContainerLegacy(containerNode)) throw new Error("Target container is not a DOM element.");
        if (parentComponent == null || !has(parentComponent)) throw new Error("parentComponent must be a valid React Component");
        return legacyRenderSubtreeIntoContainer(parentComponent, element, containerNode, false, callback);
    }
    function unmountComponentAtNode(container) {
        if (!isValidContainerLegacy(container)) throw new Error("unmountComponentAtNode(...): Target container is not a DOM element.");
        var isModernRoot = isContainerMarkedAsRoot(container) && container._reactRootContainer === undefined;
        if (isModernRoot) error("You are calling ReactDOM.unmountComponentAtNode() on a container that was previously passed to ReactDOMClient.createRoot(). This is not supported. Did you mean to call root.unmount()?");
        if (container._reactRootContainer) {
            var rootEl = getReactRootElementInContainer(container);
            var renderedByDifferentReact = rootEl && !getInstanceFromNode(rootEl);
            if (renderedByDifferentReact) error("unmountComponentAtNode(): The node you're attempting to unmount was rendered by another copy of React.");
            flushSync(function() {
                legacyRenderSubtreeIntoContainer(null, null, container, false, function() {
                    // $FlowFixMe This should probably use `delete container._reactRootContainer`
                    container._reactRootContainer = null;
                    unmarkContainerAsRoot(container);
                });
            }); // If you call unmountComponentAtNode twice in quick succession, you'll
            // get `true` twice. That's probably fine?
            return true;
        } else {
            var _rootEl = getReactRootElementInContainer(container);
            var hasNonRootReactChild = !!(_rootEl && getInstanceFromNode(_rootEl)); // Check if the container itself is a React root node.
            var isContainerReactRoot = container.nodeType === ELEMENT_NODE && isValidContainerLegacy(container.parentNode) && !!container.parentNode._reactRootContainer;
            if (hasNonRootReactChild) error("unmountComponentAtNode(): The node you're attempting to unmount was rendered by React and is not a top-level container. %s", isContainerReactRoot ? "You may have accidentally passed in a React root node instead of its container." : "Instead, have the parent component update its state and rerender in order to remove this component.");
            return false;
        }
    }
    setAttemptSynchronousHydration(attemptSynchronousHydration$1);
    setAttemptContinuousHydration(attemptContinuousHydration$1);
    setAttemptHydrationAtCurrentPriority(attemptHydrationAtCurrentPriority$1);
    setGetCurrentUpdatePriority(getCurrentUpdatePriority);
    setAttemptHydrationAtPriority(runWithPriority);
    if (typeof Map !== "function" || // $FlowIssue Flow incorrectly thinks Map has no prototype
    Map.prototype == null || typeof Map.prototype.forEach !== "function" || typeof Set !== "function" || // $FlowIssue Flow incorrectly thinks Set has no prototype
    Set.prototype == null || typeof Set.prototype.clear !== "function" || typeof Set.prototype.forEach !== "function") error("React depends on Map and Set built-in types. Make sure that you load a polyfill in older browsers. https://reactjs.org/link/react-polyfills");
    setRestoreImplementation(restoreControlledState$3);
    setBatchingImplementation(batchedUpdates$1, discreteUpdates, flushSync);
    function createPortal$1(children, container) {
        var key = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
        if (!isValidContainer(container)) throw new Error("Target container is not a DOM element.");
         // TODO: pass ReactDOM portal implementation as third argument
        // $FlowFixMe The Flow type is opaque but there's no way to actually create it.
        return createPortal(children, container, null, key);
    }
    function renderSubtreeIntoContainer(parentComponent, element, containerNode, callback) {
        return unstable_renderSubtreeIntoContainer(parentComponent, element, containerNode, callback);
    }
    var Internals = {
        usingClientEntryPoint: false,
        // Keep in sync with ReactTestUtils.js.
        // This is an array for better minification.
        Events: [
            getInstanceFromNode,
            getNodeFromInstance,
            getFiberCurrentPropsFromNode,
            enqueueStateRestore,
            restoreStateIfNeeded,
            batchedUpdates$1
        ]
    };
    function createRoot$1(container, options) {
        if (!Internals.usingClientEntryPoint && true) error('You are importing createRoot from "react-dom" which is not supported. You should instead import it from "react-dom/client".');
        return createRoot(container, options);
    }
    function hydrateRoot$1(container, initialChildren, options) {
        if (!Internals.usingClientEntryPoint && true) error('You are importing hydrateRoot from "react-dom" which is not supported. You should instead import it from "react-dom/client".');
        return hydrateRoot(container, initialChildren, options);
    } // Overload the definition to the two valid signatures.
    // Warning, this opts-out of checking the function body.
    // eslint-disable-next-line no-redeclare
    function flushSync$1(fn) {
        if (isAlreadyRendering()) error("flushSync was called from inside a lifecycle method. React cannot flush when React is already rendering. Consider moving this call to a scheduler task or micro task.");
        return flushSync(fn);
    }
    var foundDevTools = injectIntoDevTools({
        findFiberByHostInstance: getClosestInstanceFromNode,
        bundleType: 1,
        version: ReactVersion,
        rendererPackageName: "react-dom"
    });
    if (!foundDevTools && canUseDOM && window.top === window.self) // If we're in Chrome or Firefox, provide a download link if not installed.
    {
        if (navigator.userAgent.indexOf("Chrome") > -1 && navigator.userAgent.indexOf("Edge") === -1 || navigator.userAgent.indexOf("Firefox") > -1) {
            var protocol = window.location.protocol; // Don't warn in exotic cases like chrome-extension://.
            if (/^(https?|file):$/.test(protocol)) // eslint-disable-next-line react-internal/no-production-logging
            console.info("%cDownload the React DevTools for a better development experience: https://reactjs.org/link/react-devtools" + (protocol === "file:" ? "\nYou might need to use a local HTTP server (instead of file://): https://reactjs.org/link/react-devtools-faq" : ""), "font-weight:bold");
        }
    }
    $2956e04298bc31b1$export$ae55be85d98224ed = Internals;
    $2956e04298bc31b1$export$d39a5bbd09211389 = createPortal$1;
    $2956e04298bc31b1$export$882461b6382ed46c = createRoot$1;
    $2956e04298bc31b1$export$466bfc07425424d5 = findDOMNode;
    $2956e04298bc31b1$export$cd75ccfd720a3cd4 = flushSync$1;
    $2956e04298bc31b1$export$fa8d919ba61d84db = hydrate;
    $2956e04298bc31b1$export$757ceba2d55c277e = hydrateRoot$1;
    $2956e04298bc31b1$export$b3890eb0ae9dca99 = render;
    $2956e04298bc31b1$export$502457920280e6be = unmountComponentAtNode;
    $2956e04298bc31b1$export$c78a37762a8d58e1 = batchedUpdates$1;
    $2956e04298bc31b1$export$dc54d992c10e8a18 = renderSubtreeIntoContainer;
    $2956e04298bc31b1$export$83d89fbfd8236492 = ReactVersion;
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ !== "undefined" && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop === "function") __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop(new Error());
})();

});
parcelRegister("fO90s", function(module, exports) {
"use strict";

module.exports = (parcelRequire("7jGsX"));

});
parcelRegister("7jGsX", function(module, exports) {

$parcel$export(module.exports, "unstable_now", () => $553b3f9a1c62156e$export$c4744153514ff05d, (v) => $553b3f9a1c62156e$export$c4744153514ff05d = v);
$parcel$export(module.exports, "unstable_IdlePriority", () => $553b3f9a1c62156e$export$3e506c1ccc9cc1a7, (v) => $553b3f9a1c62156e$export$3e506c1ccc9cc1a7 = v);
$parcel$export(module.exports, "unstable_ImmediatePriority", () => $553b3f9a1c62156e$export$e26fe2ed2fa76875, (v) => $553b3f9a1c62156e$export$e26fe2ed2fa76875 = v);
$parcel$export(module.exports, "unstable_LowPriority", () => $553b3f9a1c62156e$export$502329bbf4b505b1, (v) => $553b3f9a1c62156e$export$502329bbf4b505b1 = v);
$parcel$export(module.exports, "unstable_NormalPriority", () => $553b3f9a1c62156e$export$6e3807111c4874c4, (v) => $553b3f9a1c62156e$export$6e3807111c4874c4 = v);
$parcel$export(module.exports, "unstable_Profiling", () => $553b3f9a1c62156e$export$c27134553091fb3a, (v) => $553b3f9a1c62156e$export$c27134553091fb3a = v);
$parcel$export(module.exports, "unstable_UserBlockingPriority", () => $553b3f9a1c62156e$export$33ee1acdc04fd2a2, (v) => $553b3f9a1c62156e$export$33ee1acdc04fd2a2 = v);
$parcel$export(module.exports, "unstable_cancelCallback", () => $553b3f9a1c62156e$export$b00a404bbd5edef2, (v) => $553b3f9a1c62156e$export$b00a404bbd5edef2 = v);
$parcel$export(module.exports, "unstable_continueExecution", () => $553b3f9a1c62156e$export$8352ce38b91d0c62, (v) => $553b3f9a1c62156e$export$8352ce38b91d0c62 = v);
$parcel$export(module.exports, "unstable_forceFrameRate", () => $553b3f9a1c62156e$export$d66a1c1c77bd778b, (v) => $553b3f9a1c62156e$export$d66a1c1c77bd778b = v);
$parcel$export(module.exports, "unstable_getCurrentPriorityLevel", () => $553b3f9a1c62156e$export$d3dfb8e4810cb555, (v) => $553b3f9a1c62156e$export$d3dfb8e4810cb555 = v);
$parcel$export(module.exports, "unstable_getFirstCallbackNode", () => $553b3f9a1c62156e$export$839f9183b0465a69, (v) => $553b3f9a1c62156e$export$839f9183b0465a69 = v);
$parcel$export(module.exports, "unstable_next", () => $553b3f9a1c62156e$export$72fdf0e06517287b, (v) => $553b3f9a1c62156e$export$72fdf0e06517287b = v);
$parcel$export(module.exports, "unstable_pauseExecution", () => $553b3f9a1c62156e$export$4b844e58a3e414b4, (v) => $553b3f9a1c62156e$export$4b844e58a3e414b4 = v);
$parcel$export(module.exports, "unstable_requestPaint", () => $553b3f9a1c62156e$export$816d2913ae6b83b1, (v) => $553b3f9a1c62156e$export$816d2913ae6b83b1 = v);
$parcel$export(module.exports, "unstable_runWithPriority", () => $553b3f9a1c62156e$export$61bcfe829111a1d0, (v) => $553b3f9a1c62156e$export$61bcfe829111a1d0 = v);
$parcel$export(module.exports, "unstable_scheduleCallback", () => $553b3f9a1c62156e$export$7ee8c9beb337bc3f, (v) => $553b3f9a1c62156e$export$7ee8c9beb337bc3f = v);
$parcel$export(module.exports, "unstable_shouldYield", () => $553b3f9a1c62156e$export$b5836b71941fa3ed, (v) => $553b3f9a1c62156e$export$b5836b71941fa3ed = v);
$parcel$export(module.exports, "unstable_wrapCallback", () => $553b3f9a1c62156e$export$cf845f2c119da08a, (v) => $553b3f9a1c62156e$export$cf845f2c119da08a = v);
/**
 * @license React
 * scheduler.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $553b3f9a1c62156e$export$c4744153514ff05d;
var $553b3f9a1c62156e$export$3e506c1ccc9cc1a7;
var $553b3f9a1c62156e$export$e26fe2ed2fa76875;
var $553b3f9a1c62156e$export$502329bbf4b505b1;
var $553b3f9a1c62156e$export$6e3807111c4874c4;
var $553b3f9a1c62156e$export$c27134553091fb3a;
var $553b3f9a1c62156e$export$33ee1acdc04fd2a2;
var $553b3f9a1c62156e$export$b00a404bbd5edef2;
var $553b3f9a1c62156e$export$8352ce38b91d0c62;
var $553b3f9a1c62156e$export$d66a1c1c77bd778b;
var $553b3f9a1c62156e$export$d3dfb8e4810cb555;
var $553b3f9a1c62156e$export$839f9183b0465a69;
var $553b3f9a1c62156e$export$72fdf0e06517287b;
var $553b3f9a1c62156e$export$4b844e58a3e414b4;
var $553b3f9a1c62156e$export$816d2913ae6b83b1;
var $553b3f9a1c62156e$export$61bcfe829111a1d0;
var $553b3f9a1c62156e$export$7ee8c9beb337bc3f;
var $553b3f9a1c62156e$export$b5836b71941fa3ed;
var $553b3f9a1c62156e$export$cf845f2c119da08a;
"use strict";
(function() {
    "use strict";
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ !== "undefined" && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart === "function") __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart(new Error());
    var enableSchedulerDebugging = false;
    var enableProfiling = false;
    var frameYieldMs = 5;
    function push(heap, node) {
        var index = heap.length;
        heap.push(node);
        siftUp(heap, node, index);
    }
    function peek(heap) {
        return heap.length === 0 ? null : heap[0];
    }
    function pop(heap) {
        if (heap.length === 0) return null;
        var first = heap[0];
        var last = heap.pop();
        if (last !== first) {
            heap[0] = last;
            siftDown(heap, last, 0);
        }
        return first;
    }
    function siftUp(heap, node, i) {
        var index = i;
        while(index > 0){
            var parentIndex = index - 1 >>> 1;
            var parent = heap[parentIndex];
            if (compare(parent, node) > 0) {
                // The parent is larger. Swap positions.
                heap[parentIndex] = node;
                heap[index] = parent;
                index = parentIndex;
            } else // The parent is smaller. Exit.
            return;
        }
    }
    function siftDown(heap, node, i) {
        var index = i;
        var length = heap.length;
        var halfLength = length >>> 1;
        while(index < halfLength){
            var leftIndex = (index + 1) * 2 - 1;
            var left = heap[leftIndex];
            var rightIndex = leftIndex + 1;
            var right = heap[rightIndex]; // If the left or right node is smaller, swap with the smaller of those.
            if (compare(left, node) < 0) {
                if (rightIndex < length && compare(right, left) < 0) {
                    heap[index] = right;
                    heap[rightIndex] = node;
                    index = rightIndex;
                } else {
                    heap[index] = left;
                    heap[leftIndex] = node;
                    index = leftIndex;
                }
            } else if (rightIndex < length && compare(right, node) < 0) {
                heap[index] = right;
                heap[rightIndex] = node;
                index = rightIndex;
            } else // Neither child is smaller. Exit.
            return;
        }
    }
    function compare(a, b) {
        // Compare sort index first, then task id.
        var diff = a.sortIndex - b.sortIndex;
        return diff !== 0 ? diff : a.id - b.id;
    }
    // TODO: Use symbols?
    var ImmediatePriority = 1;
    var UserBlockingPriority = 2;
    var NormalPriority = 3;
    var LowPriority = 4;
    var IdlePriority = 5;
    function markTaskErrored(task, ms) {}
    /* eslint-disable no-var */ var hasPerformanceNow = typeof performance === "object" && typeof performance.now === "function";
    if (hasPerformanceNow) {
        var localPerformance = performance;
        $553b3f9a1c62156e$export$c4744153514ff05d = function() {
            return localPerformance.now();
        };
    } else {
        var localDate = Date;
        var initialTime = localDate.now();
        $553b3f9a1c62156e$export$c4744153514ff05d = function() {
            return localDate.now() - initialTime;
        };
    } // Max 31 bit integer. The max integer size in V8 for 32-bit systems.
    // Math.pow(2, 30) - 1
    // 0b111111111111111111111111111111
    var maxSigned31BitInt = 1073741823; // Times out immediately
    var IMMEDIATE_PRIORITY_TIMEOUT = -1; // Eventually times out
    var USER_BLOCKING_PRIORITY_TIMEOUT = 250;
    var NORMAL_PRIORITY_TIMEOUT = 5000;
    var LOW_PRIORITY_TIMEOUT = 10000; // Never times out
    var IDLE_PRIORITY_TIMEOUT = maxSigned31BitInt; // Tasks are stored on a min heap
    var taskQueue = [];
    var timerQueue = []; // Incrementing id counter. Used to maintain insertion order.
    var taskIdCounter = 1; // Pausing the scheduler is useful for debugging.
    var currentTask = null;
    var currentPriorityLevel = NormalPriority; // This is set while performing work, to prevent re-entrance.
    var isPerformingWork = false;
    var isHostCallbackScheduled = false;
    var isHostTimeoutScheduled = false; // Capture local references to native APIs, in case a polyfill overrides them.
    var localSetTimeout = typeof setTimeout === "function" ? setTimeout : null;
    var localClearTimeout = typeof clearTimeout === "function" ? clearTimeout : null;
    var localSetImmediate = typeof setImmediate !== "undefined" ? setImmediate : null; // IE and Node.js + jsdom
    var isInputPending = typeof navigator !== "undefined" && navigator.scheduling !== undefined && navigator.scheduling.isInputPending !== undefined ? navigator.scheduling.isInputPending.bind(navigator.scheduling) : null;
    function advanceTimers(currentTime) {
        // Check for tasks that are no longer delayed and add them to the queue.
        var timer = peek(timerQueue);
        while(timer !== null){
            if (timer.callback === null) // Timer was cancelled.
            pop(timerQueue);
            else if (timer.startTime <= currentTime) {
                // Timer fired. Transfer to the task queue.
                pop(timerQueue);
                timer.sortIndex = timer.expirationTime;
                push(taskQueue, timer);
            } else // Remaining timers are pending.
            return;
            timer = peek(timerQueue);
        }
    }
    function handleTimeout(currentTime) {
        isHostTimeoutScheduled = false;
        advanceTimers(currentTime);
        if (!isHostCallbackScheduled) {
            if (peek(taskQueue) !== null) {
                isHostCallbackScheduled = true;
                requestHostCallback(flushWork);
            } else {
                var firstTimer = peek(timerQueue);
                if (firstTimer !== null) requestHostTimeout(handleTimeout, firstTimer.startTime - currentTime);
            }
        }
    }
    function flushWork(hasTimeRemaining, initialTime) {
        isHostCallbackScheduled = false;
        if (isHostTimeoutScheduled) {
            // We scheduled a timeout but it's no longer needed. Cancel it.
            isHostTimeoutScheduled = false;
            cancelHostTimeout();
        }
        isPerformingWork = true;
        var previousPriorityLevel = currentPriorityLevel;
        try {
            if (enableProfiling) try {
                return workLoop(hasTimeRemaining, initialTime);
            } catch (error) {
                if (currentTask !== null) {
                    var currentTime = $553b3f9a1c62156e$export$c4744153514ff05d();
                    markTaskErrored(currentTask, currentTime);
                    currentTask.isQueued = false;
                }
                throw error;
            }
            else // No catch in prod code path.
            return workLoop(hasTimeRemaining, initialTime);
        } finally{
            currentTask = null;
            currentPriorityLevel = previousPriorityLevel;
            isPerformingWork = false;
        }
    }
    function workLoop(hasTimeRemaining, initialTime) {
        var currentTime = initialTime;
        advanceTimers(currentTime);
        currentTask = peek(taskQueue);
        while(currentTask !== null && !enableSchedulerDebugging){
            if (currentTask.expirationTime > currentTime && (!hasTimeRemaining || shouldYieldToHost())) break;
            var callback = currentTask.callback;
            if (typeof callback === "function") {
                currentTask.callback = null;
                currentPriorityLevel = currentTask.priorityLevel;
                var didUserCallbackTimeout = currentTask.expirationTime <= currentTime;
                var continuationCallback = callback(didUserCallbackTimeout);
                currentTime = $553b3f9a1c62156e$export$c4744153514ff05d();
                if (typeof continuationCallback === "function") currentTask.callback = continuationCallback;
                else if (currentTask === peek(taskQueue)) pop(taskQueue);
                advanceTimers(currentTime);
            } else pop(taskQueue);
            currentTask = peek(taskQueue);
        } // Return whether there's additional work
        if (currentTask !== null) return true;
        else {
            var firstTimer = peek(timerQueue);
            if (firstTimer !== null) requestHostTimeout(handleTimeout, firstTimer.startTime - currentTime);
            return false;
        }
    }
    function unstable_runWithPriority(priorityLevel, eventHandler) {
        switch(priorityLevel){
            case ImmediatePriority:
            case UserBlockingPriority:
            case NormalPriority:
            case LowPriority:
            case IdlePriority:
                break;
            default:
                priorityLevel = NormalPriority;
        }
        var previousPriorityLevel = currentPriorityLevel;
        currentPriorityLevel = priorityLevel;
        try {
            return eventHandler();
        } finally{
            currentPriorityLevel = previousPriorityLevel;
        }
    }
    function unstable_next(eventHandler) {
        var priorityLevel;
        switch(currentPriorityLevel){
            case ImmediatePriority:
            case UserBlockingPriority:
            case NormalPriority:
                // Shift down to normal priority
                priorityLevel = NormalPriority;
                break;
            default:
                // Anything lower than normal priority should remain at the current level.
                priorityLevel = currentPriorityLevel;
                break;
        }
        var previousPriorityLevel = currentPriorityLevel;
        currentPriorityLevel = priorityLevel;
        try {
            return eventHandler();
        } finally{
            currentPriorityLevel = previousPriorityLevel;
        }
    }
    function unstable_wrapCallback(callback) {
        var parentPriorityLevel = currentPriorityLevel;
        return function() {
            // This is a fork of runWithPriority, inlined for performance.
            var previousPriorityLevel = currentPriorityLevel;
            currentPriorityLevel = parentPriorityLevel;
            try {
                return callback.apply(this, arguments);
            } finally{
                currentPriorityLevel = previousPriorityLevel;
            }
        };
    }
    function unstable_scheduleCallback(priorityLevel, callback, options) {
        var currentTime = $553b3f9a1c62156e$export$c4744153514ff05d();
        var startTime;
        if (typeof options === "object" && options !== null) {
            var delay = options.delay;
            if (typeof delay === "number" && delay > 0) startTime = currentTime + delay;
            else startTime = currentTime;
        } else startTime = currentTime;
        var timeout;
        switch(priorityLevel){
            case ImmediatePriority:
                timeout = IMMEDIATE_PRIORITY_TIMEOUT;
                break;
            case UserBlockingPriority:
                timeout = USER_BLOCKING_PRIORITY_TIMEOUT;
                break;
            case IdlePriority:
                timeout = IDLE_PRIORITY_TIMEOUT;
                break;
            case LowPriority:
                timeout = LOW_PRIORITY_TIMEOUT;
                break;
            case NormalPriority:
            default:
                timeout = NORMAL_PRIORITY_TIMEOUT;
                break;
        }
        var expirationTime = startTime + timeout;
        var newTask = {
            id: taskIdCounter++,
            callback: callback,
            priorityLevel: priorityLevel,
            startTime: startTime,
            expirationTime: expirationTime,
            sortIndex: -1
        };
        if (startTime > currentTime) {
            // This is a delayed task.
            newTask.sortIndex = startTime;
            push(timerQueue, newTask);
            if (peek(taskQueue) === null && newTask === peek(timerQueue)) {
                // All tasks are delayed, and this is the task with the earliest delay.
                if (isHostTimeoutScheduled) // Cancel an existing timeout.
                cancelHostTimeout();
                else isHostTimeoutScheduled = true;
                 // Schedule a timeout.
                requestHostTimeout(handleTimeout, startTime - currentTime);
            }
        } else {
            newTask.sortIndex = expirationTime;
            push(taskQueue, newTask);
            // wait until the next time we yield.
            if (!isHostCallbackScheduled && !isPerformingWork) {
                isHostCallbackScheduled = true;
                requestHostCallback(flushWork);
            }
        }
        return newTask;
    }
    function unstable_pauseExecution() {}
    function unstable_continueExecution() {
        if (!isHostCallbackScheduled && !isPerformingWork) {
            isHostCallbackScheduled = true;
            requestHostCallback(flushWork);
        }
    }
    function unstable_getFirstCallbackNode() {
        return peek(taskQueue);
    }
    function unstable_cancelCallback(task) {
        // remove from the queue because you can't remove arbitrary nodes from an
        // array based heap, only the first one.)
        task.callback = null;
    }
    function unstable_getCurrentPriorityLevel() {
        return currentPriorityLevel;
    }
    var isMessageLoopRunning = false;
    var scheduledHostCallback = null;
    var taskTimeoutID = -1; // Scheduler periodically yields in case there is other work on the main
    // thread, like user events. By default, it yields multiple times per frame.
    // It does not attempt to align with frame boundaries, since most tasks don't
    // need to be frame aligned; for those that do, use requestAnimationFrame.
    var frameInterval = frameYieldMs;
    var startTime = -1;
    function shouldYieldToHost() {
        var timeElapsed = $553b3f9a1c62156e$export$c4744153514ff05d() - startTime;
        if (timeElapsed < frameInterval) // The main thread has only been blocked for a really short amount of time;
        // smaller than a single frame. Don't yield yet.
        return false;
         // The main thread has been blocked for a non-negligible amount of time. We
        return true;
    }
    function requestPaint() {}
    function forceFrameRate(fps) {
        if (fps < 0 || fps > 125) {
            // Using console['error'] to evade Babel and ESLint
            console["error"]("forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported");
            return;
        }
        if (fps > 0) frameInterval = Math.floor(1000 / fps);
        else // reset the framerate
        frameInterval = frameYieldMs;
    }
    var performWorkUntilDeadline = function() {
        if (scheduledHostCallback !== null) {
            var currentTime = $553b3f9a1c62156e$export$c4744153514ff05d(); // Keep track of the start time so we can measure how long the main thread
            // has been blocked.
            startTime = currentTime;
            var hasTimeRemaining = true; // If a scheduler task throws, exit the current browser task so the
            // error can be observed.
            //
            // Intentionally not using a try-catch, since that makes some debugging
            // techniques harder. Instead, if `scheduledHostCallback` errors, then
            // `hasMoreWork` will remain true, and we'll continue the work loop.
            var hasMoreWork = true;
            try {
                hasMoreWork = scheduledHostCallback(hasTimeRemaining, currentTime);
            } finally{
                if (hasMoreWork) // If there's more work, schedule the next message event at the end
                // of the preceding one.
                schedulePerformWorkUntilDeadline();
                else {
                    isMessageLoopRunning = false;
                    scheduledHostCallback = null;
                }
            }
        } else isMessageLoopRunning = false;
         // Yielding to the browser will give it a chance to paint, so we can
    };
    var schedulePerformWorkUntilDeadline;
    if (typeof localSetImmediate === "function") // Node.js and old IE.
    // There's a few reasons for why we prefer setImmediate.
    //
    // Unlike MessageChannel, it doesn't prevent a Node.js process from exiting.
    // (Even though this is a DOM fork of the Scheduler, you could get here
    // with a mix of Node.js 15+, which has a MessageChannel, and jsdom.)
    // https://github.com/facebook/react/issues/20756
    //
    // But also, it runs earlier which is the semantic we want.
    // If other browsers ever implement it, it's better to use it.
    // Although both of these would be inferior to native scheduling.
    schedulePerformWorkUntilDeadline = function() {
        localSetImmediate(performWorkUntilDeadline);
    };
    else if (typeof MessageChannel !== "undefined") {
        // DOM and Worker environments.
        // We prefer MessageChannel because of the 4ms setTimeout clamping.
        var channel = new MessageChannel();
        var port = channel.port2;
        channel.port1.onmessage = performWorkUntilDeadline;
        schedulePerformWorkUntilDeadline = function() {
            port.postMessage(null);
        };
    } else // We should only fallback here in non-browser environments.
    schedulePerformWorkUntilDeadline = function() {
        localSetTimeout(performWorkUntilDeadline, 0);
    };
    function requestHostCallback(callback) {
        scheduledHostCallback = callback;
        if (!isMessageLoopRunning) {
            isMessageLoopRunning = true;
            schedulePerformWorkUntilDeadline();
        }
    }
    function requestHostTimeout(callback, ms) {
        taskTimeoutID = localSetTimeout(function() {
            callback($553b3f9a1c62156e$export$c4744153514ff05d());
        }, ms);
    }
    function cancelHostTimeout() {
        localClearTimeout(taskTimeoutID);
        taskTimeoutID = -1;
    }
    var unstable_requestPaint = requestPaint;
    var unstable_Profiling = null;
    $553b3f9a1c62156e$export$3e506c1ccc9cc1a7 = IdlePriority;
    $553b3f9a1c62156e$export$e26fe2ed2fa76875 = ImmediatePriority;
    $553b3f9a1c62156e$export$502329bbf4b505b1 = LowPriority;
    $553b3f9a1c62156e$export$6e3807111c4874c4 = NormalPriority;
    $553b3f9a1c62156e$export$c27134553091fb3a = unstable_Profiling;
    $553b3f9a1c62156e$export$33ee1acdc04fd2a2 = UserBlockingPriority;
    $553b3f9a1c62156e$export$b00a404bbd5edef2 = unstable_cancelCallback;
    $553b3f9a1c62156e$export$8352ce38b91d0c62 = unstable_continueExecution;
    $553b3f9a1c62156e$export$d66a1c1c77bd778b = forceFrameRate;
    $553b3f9a1c62156e$export$d3dfb8e4810cb555 = unstable_getCurrentPriorityLevel;
    $553b3f9a1c62156e$export$839f9183b0465a69 = unstable_getFirstCallbackNode;
    $553b3f9a1c62156e$export$72fdf0e06517287b = unstable_next;
    $553b3f9a1c62156e$export$4b844e58a3e414b4 = unstable_pauseExecution;
    $553b3f9a1c62156e$export$816d2913ae6b83b1 = unstable_requestPaint;
    $553b3f9a1c62156e$export$61bcfe829111a1d0 = unstable_runWithPriority;
    $553b3f9a1c62156e$export$7ee8c9beb337bc3f = unstable_scheduleCallback;
    $553b3f9a1c62156e$export$b5836b71941fa3ed = shouldYieldToHost;
    $553b3f9a1c62156e$export$cf845f2c119da08a = unstable_wrapCallback;
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ !== "undefined" && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop === "function") __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop(new Error());
})();

});




parcelRegister("45fvw", function(module, exports) {
//! moment.js
//! version : 2.29.4
//! authors : Tim Wood, Iskren Chernev, Moment.js contributors
//! license : MIT
//! momentjs.com
(function(global, factory) {
    module.exports = factory();
})(this, function() {
    "use strict";
    var hookCallback;
    function hooks() {
        return hookCallback.apply(null, arguments);
    }
    // This is done to register the method called with moment()
    // without creating circular dependencies.
    function setHookCallback(callback) {
        hookCallback = callback;
    }
    function isArray(input) {
        return input instanceof Array || Object.prototype.toString.call(input) === "[object Array]";
    }
    function isObject(input) {
        // IE8 will treat undefined and null as object if it wasn't for
        // input != null
        return input != null && Object.prototype.toString.call(input) === "[object Object]";
    }
    function hasOwnProp(a, b) {
        return Object.prototype.hasOwnProperty.call(a, b);
    }
    function isObjectEmpty(obj) {
        if (Object.getOwnPropertyNames) return Object.getOwnPropertyNames(obj).length === 0;
        else {
            var k;
            for(k in obj){
                if (hasOwnProp(obj, k)) return false;
            }
            return true;
        }
    }
    function isUndefined(input) {
        return input === void 0;
    }
    function isNumber(input) {
        return typeof input === "number" || Object.prototype.toString.call(input) === "[object Number]";
    }
    function isDate(input) {
        return input instanceof Date || Object.prototype.toString.call(input) === "[object Date]";
    }
    function map(arr, fn) {
        var res = [], i, arrLen = arr.length;
        for(i = 0; i < arrLen; ++i)res.push(fn(arr[i], i));
        return res;
    }
    function extend(a, b) {
        for(var i in b)if (hasOwnProp(b, i)) a[i] = b[i];
        if (hasOwnProp(b, "toString")) a.toString = b.toString;
        if (hasOwnProp(b, "valueOf")) a.valueOf = b.valueOf;
        return a;
    }
    function createUTC(input, format, locale, strict) {
        return createLocalOrUTC(input, format, locale, strict, true).utc();
    }
    function defaultParsingFlags() {
        // We need to deep clone this object.
        return {
            empty: false,
            unusedTokens: [],
            unusedInput: [],
            overflow: -2,
            charsLeftOver: 0,
            nullInput: false,
            invalidEra: null,
            invalidMonth: null,
            invalidFormat: false,
            userInvalidated: false,
            iso: false,
            parsedDateParts: [],
            era: null,
            meridiem: null,
            rfc2822: false,
            weekdayMismatch: false
        };
    }
    function getParsingFlags(m) {
        if (m._pf == null) m._pf = defaultParsingFlags();
        return m._pf;
    }
    var some;
    if (Array.prototype.some) some = Array.prototype.some;
    else some = function(fun) {
        var t = Object(this), len = t.length >>> 0, i;
        for(i = 0; i < len; i++){
            if (i in t && fun.call(this, t[i], i, t)) return true;
        }
        return false;
    };
    function isValid(m) {
        if (m._isValid == null) {
            var flags = getParsingFlags(m), parsedParts = some.call(flags.parsedDateParts, function(i) {
                return i != null;
            }), isNowValid = !isNaN(m._d.getTime()) && flags.overflow < 0 && !flags.empty && !flags.invalidEra && !flags.invalidMonth && !flags.invalidWeekday && !flags.weekdayMismatch && !flags.nullInput && !flags.invalidFormat && !flags.userInvalidated && (!flags.meridiem || flags.meridiem && parsedParts);
            if (m._strict) isNowValid = isNowValid && flags.charsLeftOver === 0 && flags.unusedTokens.length === 0 && flags.bigHour === undefined;
            if (Object.isFrozen == null || !Object.isFrozen(m)) m._isValid = isNowValid;
            else return isNowValid;
        }
        return m._isValid;
    }
    function createInvalid(flags) {
        var m = createUTC(NaN);
        if (flags != null) extend(getParsingFlags(m), flags);
        else getParsingFlags(m).userInvalidated = true;
        return m;
    }
    // Plugins that add properties should also add the key here (null value),
    // so we can properly clone ourselves.
    var momentProperties = hooks.momentProperties = [], updateInProgress = false;
    function copyConfig(to, from) {
        var i, prop, val, momentPropertiesLen = momentProperties.length;
        if (!isUndefined(from._isAMomentObject)) to._isAMomentObject = from._isAMomentObject;
        if (!isUndefined(from._i)) to._i = from._i;
        if (!isUndefined(from._f)) to._f = from._f;
        if (!isUndefined(from._l)) to._l = from._l;
        if (!isUndefined(from._strict)) to._strict = from._strict;
        if (!isUndefined(from._tzm)) to._tzm = from._tzm;
        if (!isUndefined(from._isUTC)) to._isUTC = from._isUTC;
        if (!isUndefined(from._offset)) to._offset = from._offset;
        if (!isUndefined(from._pf)) to._pf = getParsingFlags(from);
        if (!isUndefined(from._locale)) to._locale = from._locale;
        if (momentPropertiesLen > 0) for(i = 0; i < momentPropertiesLen; i++){
            prop = momentProperties[i];
            val = from[prop];
            if (!isUndefined(val)) to[prop] = val;
        }
        return to;
    }
    // Moment prototype object
    function Moment(config) {
        copyConfig(this, config);
        this._d = new Date(config._d != null ? config._d.getTime() : NaN);
        if (!this.isValid()) this._d = new Date(NaN);
        // Prevent infinite loop in case updateOffset creates new moment
        // objects.
        if (updateInProgress === false) {
            updateInProgress = true;
            hooks.updateOffset(this);
            updateInProgress = false;
        }
    }
    function isMoment(obj) {
        return obj instanceof Moment || obj != null && obj._isAMomentObject != null;
    }
    function warn(msg) {
        if (hooks.suppressDeprecationWarnings === false && typeof console !== "undefined" && console.warn) console.warn("Deprecation warning: " + msg);
    }
    function deprecate(msg, fn) {
        var firstTime = true;
        return extend(function() {
            if (hooks.deprecationHandler != null) hooks.deprecationHandler(null, msg);
            if (firstTime) {
                var args = [], arg, i, key, argLen = arguments.length;
                for(i = 0; i < argLen; i++){
                    arg = "";
                    if (typeof arguments[i] === "object") {
                        arg += "\n[" + i + "] ";
                        for(key in arguments[0])if (hasOwnProp(arguments[0], key)) arg += key + ": " + arguments[0][key] + ", ";
                        arg = arg.slice(0, -2); // Remove trailing comma and space
                    } else arg = arguments[i];
                    args.push(arg);
                }
                warn(msg + "\nArguments: " + Array.prototype.slice.call(args).join("") + "\n" + new Error().stack);
                firstTime = false;
            }
            return fn.apply(this, arguments);
        }, fn);
    }
    var deprecations = {};
    function deprecateSimple(name, msg) {
        if (hooks.deprecationHandler != null) hooks.deprecationHandler(name, msg);
        if (!deprecations[name]) {
            warn(msg);
            deprecations[name] = true;
        }
    }
    hooks.suppressDeprecationWarnings = false;
    hooks.deprecationHandler = null;
    function isFunction(input) {
        return typeof Function !== "undefined" && input instanceof Function || Object.prototype.toString.call(input) === "[object Function]";
    }
    function set(config) {
        var prop, i;
        for(i in config)if (hasOwnProp(config, i)) {
            prop = config[i];
            if (isFunction(prop)) this[i] = prop;
            else this["_" + i] = prop;
        }
        this._config = config;
        // Lenient ordinal parsing accepts just a number in addition to
        // number + (possibly) stuff coming from _dayOfMonthOrdinalParse.
        // TODO: Remove "ordinalParse" fallback in next major release.
        this._dayOfMonthOrdinalParseLenient = new RegExp((this._dayOfMonthOrdinalParse.source || this._ordinalParse.source) + "|" + /\d{1,2}/.source);
    }
    function mergeConfigs(parentConfig, childConfig) {
        var res = extend({}, parentConfig), prop;
        for(prop in childConfig)if (hasOwnProp(childConfig, prop)) {
            if (isObject(parentConfig[prop]) && isObject(childConfig[prop])) {
                res[prop] = {};
                extend(res[prop], parentConfig[prop]);
                extend(res[prop], childConfig[prop]);
            } else if (childConfig[prop] != null) res[prop] = childConfig[prop];
            else delete res[prop];
        }
        for(prop in parentConfig)if (hasOwnProp(parentConfig, prop) && !hasOwnProp(childConfig, prop) && isObject(parentConfig[prop])) // make sure changes to properties don't modify parent config
        res[prop] = extend({}, res[prop]);
        return res;
    }
    function Locale(config) {
        if (config != null) this.set(config);
    }
    var keys;
    if (Object.keys) keys = Object.keys;
    else keys = function(obj) {
        var i, res = [];
        for(i in obj)if (hasOwnProp(obj, i)) res.push(i);
        return res;
    };
    var defaultCalendar = {
        sameDay: "[Today at] LT",
        nextDay: "[Tomorrow at] LT",
        nextWeek: "dddd [at] LT",
        lastDay: "[Yesterday at] LT",
        lastWeek: "[Last] dddd [at] LT",
        sameElse: "L"
    };
    function calendar(key, mom, now) {
        var output = this._calendar[key] || this._calendar["sameElse"];
        return isFunction(output) ? output.call(mom, now) : output;
    }
    function zeroFill(number, targetLength, forceSign) {
        var absNumber = "" + Math.abs(number), zerosToFill = targetLength - absNumber.length, sign = number >= 0;
        return (sign ? forceSign ? "+" : "" : "-") + Math.pow(10, Math.max(0, zerosToFill)).toString().substr(1) + absNumber;
    }
    var formattingTokens = /(\[[^\[]*\])|(\\)?([Hh]mm(ss)?|Mo|MM?M?M?|Do|DDDo|DD?D?D?|ddd?d?|do?|w[o|w]?|W[o|W]?|Qo?|N{1,5}|YYYYYY|YYYYY|YYYY|YY|y{2,4}|yo?|gg(ggg?)?|GG(GGG?)?|e|E|a|A|hh?|HH?|kk?|mm?|ss?|S{1,9}|x|X|zz?|ZZ?|.)/g, localFormattingTokens = /(\[[^\[]*\])|(\\)?(LTS|LT|LL?L?L?|l{1,4})/g, formatFunctions = {}, formatTokenFunctions = {};
    // token:    'M'
    // padded:   ['MM', 2]
    // ordinal:  'Mo'
    // callback: function () { this.month() + 1 }
    function addFormatToken(token, padded, ordinal, callback) {
        var func = callback;
        if (typeof callback === "string") func = function() {
            return this[callback]();
        };
        if (token) formatTokenFunctions[token] = func;
        if (padded) formatTokenFunctions[padded[0]] = function() {
            return zeroFill(func.apply(this, arguments), padded[1], padded[2]);
        };
        if (ordinal) formatTokenFunctions[ordinal] = function() {
            return this.localeData().ordinal(func.apply(this, arguments), token);
        };
    }
    function removeFormattingTokens(input) {
        if (input.match(/\[[\s\S]/)) return input.replace(/^\[|\]$/g, "");
        return input.replace(/\\/g, "");
    }
    function makeFormatFunction(format) {
        var array = format.match(formattingTokens), i, length;
        for(i = 0, length = array.length; i < length; i++)if (formatTokenFunctions[array[i]]) array[i] = formatTokenFunctions[array[i]];
        else array[i] = removeFormattingTokens(array[i]);
        return function(mom) {
            var output = "", i;
            for(i = 0; i < length; i++)output += isFunction(array[i]) ? array[i].call(mom, format) : array[i];
            return output;
        };
    }
    // format date using native date object
    function formatMoment(m, format) {
        if (!m.isValid()) return m.localeData().invalidDate();
        format = expandFormat(format, m.localeData());
        formatFunctions[format] = formatFunctions[format] || makeFormatFunction(format);
        return formatFunctions[format](m);
    }
    function expandFormat(format, locale) {
        var i = 5;
        function replaceLongDateFormatTokens(input) {
            return locale.longDateFormat(input) || input;
        }
        localFormattingTokens.lastIndex = 0;
        while(i >= 0 && localFormattingTokens.test(format)){
            format = format.replace(localFormattingTokens, replaceLongDateFormatTokens);
            localFormattingTokens.lastIndex = 0;
            i -= 1;
        }
        return format;
    }
    var defaultLongDateFormat = {
        LTS: "h:mm:ss A",
        LT: "h:mm A",
        L: "MM/DD/YYYY",
        LL: "MMMM D, YYYY",
        LLL: "MMMM D, YYYY h:mm A",
        LLLL: "dddd, MMMM D, YYYY h:mm A"
    };
    function longDateFormat(key) {
        var format = this._longDateFormat[key], formatUpper = this._longDateFormat[key.toUpperCase()];
        if (format || !formatUpper) return format;
        this._longDateFormat[key] = formatUpper.match(formattingTokens).map(function(tok) {
            if (tok === "MMMM" || tok === "MM" || tok === "DD" || tok === "dddd") return tok.slice(1);
            return tok;
        }).join("");
        return this._longDateFormat[key];
    }
    var defaultInvalidDate = "Invalid date";
    function invalidDate() {
        return this._invalidDate;
    }
    var defaultOrdinal = "%d", defaultDayOfMonthOrdinalParse = /\d{1,2}/;
    function ordinal(number) {
        return this._ordinal.replace("%d", number);
    }
    var defaultRelativeTime = {
        future: "in %s",
        past: "%s ago",
        s: "a few seconds",
        ss: "%d seconds",
        m: "a minute",
        mm: "%d minutes",
        h: "an hour",
        hh: "%d hours",
        d: "a day",
        dd: "%d days",
        w: "a week",
        ww: "%d weeks",
        M: "a month",
        MM: "%d months",
        y: "a year",
        yy: "%d years"
    };
    function relativeTime(number, withoutSuffix, string, isFuture) {
        var output = this._relativeTime[string];
        return isFunction(output) ? output(number, withoutSuffix, string, isFuture) : output.replace(/%d/i, number);
    }
    function pastFuture(diff, output) {
        var format = this._relativeTime[diff > 0 ? "future" : "past"];
        return isFunction(format) ? format(output) : format.replace(/%s/i, output);
    }
    var aliases = {};
    function addUnitAlias(unit, shorthand) {
        var lowerCase = unit.toLowerCase();
        aliases[lowerCase] = aliases[lowerCase + "s"] = aliases[shorthand] = unit;
    }
    function normalizeUnits(units) {
        return typeof units === "string" ? aliases[units] || aliases[units.toLowerCase()] : undefined;
    }
    function normalizeObjectUnits(inputObject) {
        var normalizedInput = {}, normalizedProp, prop;
        for(prop in inputObject)if (hasOwnProp(inputObject, prop)) {
            normalizedProp = normalizeUnits(prop);
            if (normalizedProp) normalizedInput[normalizedProp] = inputObject[prop];
        }
        return normalizedInput;
    }
    var priorities = {};
    function addUnitPriority(unit, priority) {
        priorities[unit] = priority;
    }
    function getPrioritizedUnits(unitsObj) {
        var units = [], u;
        for(u in unitsObj)if (hasOwnProp(unitsObj, u)) units.push({
            unit: u,
            priority: priorities[u]
        });
        units.sort(function(a, b) {
            return a.priority - b.priority;
        });
        return units;
    }
    function isLeapYear(year) {
        return year % 4 === 0 && year % 100 !== 0 || year % 400 === 0;
    }
    function absFloor(number) {
        if (number < 0) // -0 -> 0
        return Math.ceil(number) || 0;
        else return Math.floor(number);
    }
    function toInt(argumentForCoercion) {
        var coercedNumber = +argumentForCoercion, value = 0;
        if (coercedNumber !== 0 && isFinite(coercedNumber)) value = absFloor(coercedNumber);
        return value;
    }
    function makeGetSet(unit, keepTime) {
        return function(value) {
            if (value != null) {
                set$1(this, unit, value);
                hooks.updateOffset(this, keepTime);
                return this;
            } else return get(this, unit);
        };
    }
    function get(mom, unit) {
        return mom.isValid() ? mom._d["get" + (mom._isUTC ? "UTC" : "") + unit]() : NaN;
    }
    function set$1(mom, unit, value) {
        if (mom.isValid() && !isNaN(value)) {
            if (unit === "FullYear" && isLeapYear(mom.year()) && mom.month() === 1 && mom.date() === 29) {
                value = toInt(value);
                mom._d["set" + (mom._isUTC ? "UTC" : "") + unit](value, mom.month(), daysInMonth(value, mom.month()));
            } else mom._d["set" + (mom._isUTC ? "UTC" : "") + unit](value);
        }
    }
    // MOMENTS
    function stringGet(units) {
        units = normalizeUnits(units);
        if (isFunction(this[units])) return this[units]();
        return this;
    }
    function stringSet(units, value) {
        if (typeof units === "object") {
            units = normalizeObjectUnits(units);
            var prioritized = getPrioritizedUnits(units), i, prioritizedLen = prioritized.length;
            for(i = 0; i < prioritizedLen; i++)this[prioritized[i].unit](units[prioritized[i].unit]);
        } else {
            units = normalizeUnits(units);
            if (isFunction(this[units])) return this[units](value);
        }
        return this;
    }
    var match1 = /\d/, match2 = /\d\d/, match3 = /\d{3}/, match4 = /\d{4}/, match6 = /[+-]?\d{6}/, match1to2 = /\d\d?/, match3to4 = /\d\d\d\d?/, match5to6 = /\d\d\d\d\d\d?/, match1to3 = /\d{1,3}/, match1to4 = /\d{1,4}/, match1to6 = /[+-]?\d{1,6}/, matchUnsigned = /\d+/, matchSigned = /[+-]?\d+/, matchOffset = /Z|[+-]\d\d:?\d\d/gi, matchShortOffset = /Z|[+-]\d\d(?::?\d\d)?/gi, matchTimestamp = /[+-]?\d+(\.\d{1,3})?/, // any word (or two) characters or numbers including two/three word month in arabic.
    // includes scottish gaelic two word and hyphenated months
    matchWord = /[0-9]{0,256}['a-z\u00A0-\u05FF\u0700-\uD7FF\uF900-\uFDCF\uFDF0-\uFF07\uFF10-\uFFEF]{1,256}|[\u0600-\u06FF\/]{1,256}(\s*?[\u0600-\u06FF]{1,256}){1,2}/i, regexes;
    regexes = {};
    function addRegexToken(token, regex, strictRegex) {
        regexes[token] = isFunction(regex) ? regex : function(isStrict, localeData) {
            return isStrict && strictRegex ? strictRegex : regex;
        };
    }
    function getParseRegexForToken(token, config) {
        if (!hasOwnProp(regexes, token)) return new RegExp(unescapeFormat(token));
        return regexes[token](config._strict, config._locale);
    }
    // Code from http://stackoverflow.com/questions/3561493/is-there-a-regexp-escape-function-in-javascript
    function unescapeFormat(s) {
        return regexEscape(s.replace("\\", "").replace(/\\(\[)|\\(\])|\[([^\]\[]*)\]|\\(.)/g, function(matched, p1, p2, p3, p4) {
            return p1 || p2 || p3 || p4;
        }));
    }
    function regexEscape(s) {
        return s.replace(/[-\/\\^$*+?.()|[\]{}]/g, "\\$&");
    }
    var tokens = {};
    function addParseToken(token, callback) {
        var i, func = callback, tokenLen;
        if (typeof token === "string") token = [
            token
        ];
        if (isNumber(callback)) func = function(input, array) {
            array[callback] = toInt(input);
        };
        tokenLen = token.length;
        for(i = 0; i < tokenLen; i++)tokens[token[i]] = func;
    }
    function addWeekParseToken(token, callback) {
        addParseToken(token, function(input, array, config, token) {
            config._w = config._w || {};
            callback(input, config._w, config, token);
        });
    }
    function addTimeToArrayFromToken(token, input, config) {
        if (input != null && hasOwnProp(tokens, token)) tokens[token](input, config._a, config, token);
    }
    var YEAR = 0, MONTH = 1, DATE = 2, HOUR = 3, MINUTE = 4, SECOND = 5, MILLISECOND = 6, WEEK = 7, WEEKDAY = 8;
    function mod(n, x) {
        return (n % x + x) % x;
    }
    var indexOf;
    if (Array.prototype.indexOf) indexOf = Array.prototype.indexOf;
    else indexOf = function(o) {
        // I know
        var i;
        for(i = 0; i < this.length; ++i){
            if (this[i] === o) return i;
        }
        return -1;
    };
    function daysInMonth(year, month) {
        if (isNaN(year) || isNaN(month)) return NaN;
        var modMonth = mod(month, 12);
        year += (month - modMonth) / 12;
        return modMonth === 1 ? isLeapYear(year) ? 29 : 28 : 31 - modMonth % 7 % 2;
    }
    // FORMATTING
    addFormatToken("M", [
        "MM",
        2
    ], "Mo", function() {
        return this.month() + 1;
    });
    addFormatToken("MMM", 0, 0, function(format) {
        return this.localeData().monthsShort(this, format);
    });
    addFormatToken("MMMM", 0, 0, function(format) {
        return this.localeData().months(this, format);
    });
    // ALIASES
    addUnitAlias("month", "M");
    // PRIORITY
    addUnitPriority("month", 8);
    // PARSING
    addRegexToken("M", match1to2);
    addRegexToken("MM", match1to2, match2);
    addRegexToken("MMM", function(isStrict, locale) {
        return locale.monthsShortRegex(isStrict);
    });
    addRegexToken("MMMM", function(isStrict, locale) {
        return locale.monthsRegex(isStrict);
    });
    addParseToken([
        "M",
        "MM"
    ], function(input, array) {
        array[MONTH] = toInt(input) - 1;
    });
    addParseToken([
        "MMM",
        "MMMM"
    ], function(input, array, config, token) {
        var month = config._locale.monthsParse(input, token, config._strict);
        // if we didn't find a month name, mark the date as invalid.
        if (month != null) array[MONTH] = month;
        else getParsingFlags(config).invalidMonth = input;
    });
    // LOCALES
    var defaultLocaleMonths = "January_February_March_April_May_June_July_August_September_October_November_December".split("_"), defaultLocaleMonthsShort = "Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec".split("_"), MONTHS_IN_FORMAT = /D[oD]?(\[[^\[\]]*\]|\s)+MMMM?/, defaultMonthsShortRegex = matchWord, defaultMonthsRegex = matchWord;
    function localeMonths(m, format) {
        if (!m) return isArray(this._months) ? this._months : this._months["standalone"];
        return isArray(this._months) ? this._months[m.month()] : this._months[(this._months.isFormat || MONTHS_IN_FORMAT).test(format) ? "format" : "standalone"][m.month()];
    }
    function localeMonthsShort(m, format) {
        if (!m) return isArray(this._monthsShort) ? this._monthsShort : this._monthsShort["standalone"];
        return isArray(this._monthsShort) ? this._monthsShort[m.month()] : this._monthsShort[MONTHS_IN_FORMAT.test(format) ? "format" : "standalone"][m.month()];
    }
    function handleStrictParse(monthName, format, strict) {
        var i, ii, mom, llc = monthName.toLocaleLowerCase();
        if (!this._monthsParse) {
            // this is not used
            this._monthsParse = [];
            this._longMonthsParse = [];
            this._shortMonthsParse = [];
            for(i = 0; i < 12; ++i){
                mom = createUTC([
                    2000,
                    i
                ]);
                this._shortMonthsParse[i] = this.monthsShort(mom, "").toLocaleLowerCase();
                this._longMonthsParse[i] = this.months(mom, "").toLocaleLowerCase();
            }
        }
        if (strict) {
            if (format === "MMM") {
                ii = indexOf.call(this._shortMonthsParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._longMonthsParse, llc);
                return ii !== -1 ? ii : null;
            }
        } else if (format === "MMM") {
            ii = indexOf.call(this._shortMonthsParse, llc);
            if (ii !== -1) return ii;
            ii = indexOf.call(this._longMonthsParse, llc);
            return ii !== -1 ? ii : null;
        } else {
            ii = indexOf.call(this._longMonthsParse, llc);
            if (ii !== -1) return ii;
            ii = indexOf.call(this._shortMonthsParse, llc);
            return ii !== -1 ? ii : null;
        }
    }
    function localeMonthsParse(monthName, format, strict) {
        var i, mom, regex;
        if (this._monthsParseExact) return handleStrictParse.call(this, monthName, format, strict);
        if (!this._monthsParse) {
            this._monthsParse = [];
            this._longMonthsParse = [];
            this._shortMonthsParse = [];
        }
        // TODO: add sorting
        // Sorting makes sure if one month (or abbr) is a prefix of another
        // see sorting in computeMonthsParse
        for(i = 0; i < 12; i++){
            // make the regex if we don't have it already
            mom = createUTC([
                2000,
                i
            ]);
            if (strict && !this._longMonthsParse[i]) {
                this._longMonthsParse[i] = new RegExp("^" + this.months(mom, "").replace(".", "") + "$", "i");
                this._shortMonthsParse[i] = new RegExp("^" + this.monthsShort(mom, "").replace(".", "") + "$", "i");
            }
            if (!strict && !this._monthsParse[i]) {
                regex = "^" + this.months(mom, "") + "|^" + this.monthsShort(mom, "");
                this._monthsParse[i] = new RegExp(regex.replace(".", ""), "i");
            }
            // test the regex
            if (strict && format === "MMMM" && this._longMonthsParse[i].test(monthName)) return i;
            else if (strict && format === "MMM" && this._shortMonthsParse[i].test(monthName)) return i;
            else if (!strict && this._monthsParse[i].test(monthName)) return i;
        }
    }
    // MOMENTS
    function setMonth(mom, value) {
        var dayOfMonth;
        if (!mom.isValid()) // No op
        return mom;
        if (typeof value === "string") {
            if (/^\d+$/.test(value)) value = toInt(value);
            else {
                value = mom.localeData().monthsParse(value);
                // TODO: Another silent failure?
                if (!isNumber(value)) return mom;
            }
        }
        dayOfMonth = Math.min(mom.date(), daysInMonth(mom.year(), value));
        mom._d["set" + (mom._isUTC ? "UTC" : "") + "Month"](value, dayOfMonth);
        return mom;
    }
    function getSetMonth(value) {
        if (value != null) {
            setMonth(this, value);
            hooks.updateOffset(this, true);
            return this;
        } else return get(this, "Month");
    }
    function getDaysInMonth() {
        return daysInMonth(this.year(), this.month());
    }
    function monthsShortRegex(isStrict) {
        if (this._monthsParseExact) {
            if (!hasOwnProp(this, "_monthsRegex")) computeMonthsParse.call(this);
            if (isStrict) return this._monthsShortStrictRegex;
            else return this._monthsShortRegex;
        } else {
            if (!hasOwnProp(this, "_monthsShortRegex")) this._monthsShortRegex = defaultMonthsShortRegex;
            return this._monthsShortStrictRegex && isStrict ? this._monthsShortStrictRegex : this._monthsShortRegex;
        }
    }
    function monthsRegex(isStrict) {
        if (this._monthsParseExact) {
            if (!hasOwnProp(this, "_monthsRegex")) computeMonthsParse.call(this);
            if (isStrict) return this._monthsStrictRegex;
            else return this._monthsRegex;
        } else {
            if (!hasOwnProp(this, "_monthsRegex")) this._monthsRegex = defaultMonthsRegex;
            return this._monthsStrictRegex && isStrict ? this._monthsStrictRegex : this._monthsRegex;
        }
    }
    function computeMonthsParse() {
        function cmpLenRev(a, b) {
            return b.length - a.length;
        }
        var shortPieces = [], longPieces = [], mixedPieces = [], i, mom;
        for(i = 0; i < 12; i++){
            // make the regex if we don't have it already
            mom = createUTC([
                2000,
                i
            ]);
            shortPieces.push(this.monthsShort(mom, ""));
            longPieces.push(this.months(mom, ""));
            mixedPieces.push(this.months(mom, ""));
            mixedPieces.push(this.monthsShort(mom, ""));
        }
        // Sorting makes sure if one month (or abbr) is a prefix of another it
        // will match the longer piece.
        shortPieces.sort(cmpLenRev);
        longPieces.sort(cmpLenRev);
        mixedPieces.sort(cmpLenRev);
        for(i = 0; i < 12; i++){
            shortPieces[i] = regexEscape(shortPieces[i]);
            longPieces[i] = regexEscape(longPieces[i]);
        }
        for(i = 0; i < 24; i++)mixedPieces[i] = regexEscape(mixedPieces[i]);
        this._monthsRegex = new RegExp("^(" + mixedPieces.join("|") + ")", "i");
        this._monthsShortRegex = this._monthsRegex;
        this._monthsStrictRegex = new RegExp("^(" + longPieces.join("|") + ")", "i");
        this._monthsShortStrictRegex = new RegExp("^(" + shortPieces.join("|") + ")", "i");
    }
    // FORMATTING
    addFormatToken("Y", 0, 0, function() {
        var y = this.year();
        return y <= 9999 ? zeroFill(y, 4) : "+" + y;
    });
    addFormatToken(0, [
        "YY",
        2
    ], 0, function() {
        return this.year() % 100;
    });
    addFormatToken(0, [
        "YYYY",
        4
    ], 0, "year");
    addFormatToken(0, [
        "YYYYY",
        5
    ], 0, "year");
    addFormatToken(0, [
        "YYYYYY",
        6,
        true
    ], 0, "year");
    // ALIASES
    addUnitAlias("year", "y");
    // PRIORITIES
    addUnitPriority("year", 1);
    // PARSING
    addRegexToken("Y", matchSigned);
    addRegexToken("YY", match1to2, match2);
    addRegexToken("YYYY", match1to4, match4);
    addRegexToken("YYYYY", match1to6, match6);
    addRegexToken("YYYYYY", match1to6, match6);
    addParseToken([
        "YYYYY",
        "YYYYYY"
    ], YEAR);
    addParseToken("YYYY", function(input, array) {
        array[YEAR] = input.length === 2 ? hooks.parseTwoDigitYear(input) : toInt(input);
    });
    addParseToken("YY", function(input, array) {
        array[YEAR] = hooks.parseTwoDigitYear(input);
    });
    addParseToken("Y", function(input, array) {
        array[YEAR] = parseInt(input, 10);
    });
    // HELPERS
    function daysInYear(year) {
        return isLeapYear(year) ? 366 : 365;
    }
    // HOOKS
    hooks.parseTwoDigitYear = function(input) {
        return toInt(input) + (toInt(input) > 68 ? 1900 : 2000);
    };
    // MOMENTS
    var getSetYear = makeGetSet("FullYear", true);
    function getIsLeapYear() {
        return isLeapYear(this.year());
    }
    function createDate(y, m, d, h, M, s, ms) {
        // can't just apply() to create a date:
        // https://stackoverflow.com/q/181348
        var date;
        // the date constructor remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) {
            // preserve leap years using a full 400 year cycle, then reset
            date = new Date(y + 400, m, d, h, M, s, ms);
            if (isFinite(date.getFullYear())) date.setFullYear(y);
        } else date = new Date(y, m, d, h, M, s, ms);
        return date;
    }
    function createUTCDate(y) {
        var date, args;
        // the Date.UTC function remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) {
            args = Array.prototype.slice.call(arguments);
            // preserve leap years using a full 400 year cycle, then reset
            args[0] = y + 400;
            date = new Date(Date.UTC.apply(null, args));
            if (isFinite(date.getUTCFullYear())) date.setUTCFullYear(y);
        } else date = new Date(Date.UTC.apply(null, arguments));
        return date;
    }
    // start-of-first-week - start-of-year
    function firstWeekOffset(year, dow, doy) {
        var fwd = 7 + dow - doy, // first-week day local weekday -- which local weekday is fwd
        fwdlw = (7 + createUTCDate(year, 0, fwd).getUTCDay() - dow) % 7;
        return -fwdlw + fwd - 1;
    }
    // https://en.wikipedia.org/wiki/ISO_week_date#Calculating_a_date_given_the_year.2C_week_number_and_weekday
    function dayOfYearFromWeeks(year, week, weekday, dow, doy) {
        var localWeekday = (7 + weekday - dow) % 7, weekOffset = firstWeekOffset(year, dow, doy), dayOfYear = 1 + 7 * (week - 1) + localWeekday + weekOffset, resYear, resDayOfYear;
        if (dayOfYear <= 0) {
            resYear = year - 1;
            resDayOfYear = daysInYear(resYear) + dayOfYear;
        } else if (dayOfYear > daysInYear(year)) {
            resYear = year + 1;
            resDayOfYear = dayOfYear - daysInYear(year);
        } else {
            resYear = year;
            resDayOfYear = dayOfYear;
        }
        return {
            year: resYear,
            dayOfYear: resDayOfYear
        };
    }
    function weekOfYear(mom, dow, doy) {
        var weekOffset = firstWeekOffset(mom.year(), dow, doy), week = Math.floor((mom.dayOfYear() - weekOffset - 1) / 7) + 1, resWeek, resYear;
        if (week < 1) {
            resYear = mom.year() - 1;
            resWeek = week + weeksInYear(resYear, dow, doy);
        } else if (week > weeksInYear(mom.year(), dow, doy)) {
            resWeek = week - weeksInYear(mom.year(), dow, doy);
            resYear = mom.year() + 1;
        } else {
            resYear = mom.year();
            resWeek = week;
        }
        return {
            week: resWeek,
            year: resYear
        };
    }
    function weeksInYear(year, dow, doy) {
        var weekOffset = firstWeekOffset(year, dow, doy), weekOffsetNext = firstWeekOffset(year + 1, dow, doy);
        return (daysInYear(year) - weekOffset + weekOffsetNext) / 7;
    }
    // FORMATTING
    addFormatToken("w", [
        "ww",
        2
    ], "wo", "week");
    addFormatToken("W", [
        "WW",
        2
    ], "Wo", "isoWeek");
    // ALIASES
    addUnitAlias("week", "w");
    addUnitAlias("isoWeek", "W");
    // PRIORITIES
    addUnitPriority("week", 5);
    addUnitPriority("isoWeek", 5);
    // PARSING
    addRegexToken("w", match1to2);
    addRegexToken("ww", match1to2, match2);
    addRegexToken("W", match1to2);
    addRegexToken("WW", match1to2, match2);
    addWeekParseToken([
        "w",
        "ww",
        "W",
        "WW"
    ], function(input, week, config, token) {
        week[token.substr(0, 1)] = toInt(input);
    });
    // HELPERS
    // LOCALES
    function localeWeek(mom) {
        return weekOfYear(mom, this._week.dow, this._week.doy).week;
    }
    var defaultLocaleWeek = {
        dow: 0,
        doy: 6
    };
    function localeFirstDayOfWeek() {
        return this._week.dow;
    }
    function localeFirstDayOfYear() {
        return this._week.doy;
    }
    // MOMENTS
    function getSetWeek(input) {
        var week = this.localeData().week(this);
        return input == null ? week : this.add((input - week) * 7, "d");
    }
    function getSetISOWeek(input) {
        var week = weekOfYear(this, 1, 4).week;
        return input == null ? week : this.add((input - week) * 7, "d");
    }
    // FORMATTING
    addFormatToken("d", 0, "do", "day");
    addFormatToken("dd", 0, 0, function(format) {
        return this.localeData().weekdaysMin(this, format);
    });
    addFormatToken("ddd", 0, 0, function(format) {
        return this.localeData().weekdaysShort(this, format);
    });
    addFormatToken("dddd", 0, 0, function(format) {
        return this.localeData().weekdays(this, format);
    });
    addFormatToken("e", 0, 0, "weekday");
    addFormatToken("E", 0, 0, "isoWeekday");
    // ALIASES
    addUnitAlias("day", "d");
    addUnitAlias("weekday", "e");
    addUnitAlias("isoWeekday", "E");
    // PRIORITY
    addUnitPriority("day", 11);
    addUnitPriority("weekday", 11);
    addUnitPriority("isoWeekday", 11);
    // PARSING
    addRegexToken("d", match1to2);
    addRegexToken("e", match1to2);
    addRegexToken("E", match1to2);
    addRegexToken("dd", function(isStrict, locale) {
        return locale.weekdaysMinRegex(isStrict);
    });
    addRegexToken("ddd", function(isStrict, locale) {
        return locale.weekdaysShortRegex(isStrict);
    });
    addRegexToken("dddd", function(isStrict, locale) {
        return locale.weekdaysRegex(isStrict);
    });
    addWeekParseToken([
        "dd",
        "ddd",
        "dddd"
    ], function(input, week, config, token) {
        var weekday = config._locale.weekdaysParse(input, token, config._strict);
        // if we didn't get a weekday name, mark the date as invalid
        if (weekday != null) week.d = weekday;
        else getParsingFlags(config).invalidWeekday = input;
    });
    addWeekParseToken([
        "d",
        "e",
        "E"
    ], function(input, week, config, token) {
        week[token] = toInt(input);
    });
    // HELPERS
    function parseWeekday(input, locale) {
        if (typeof input !== "string") return input;
        if (!isNaN(input)) return parseInt(input, 10);
        input = locale.weekdaysParse(input);
        if (typeof input === "number") return input;
        return null;
    }
    function parseIsoWeekday(input, locale) {
        if (typeof input === "string") return locale.weekdaysParse(input) % 7 || 7;
        return isNaN(input) ? null : input;
    }
    // LOCALES
    function shiftWeekdays(ws, n) {
        return ws.slice(n, 7).concat(ws.slice(0, n));
    }
    var defaultLocaleWeekdays = "Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday".split("_"), defaultLocaleWeekdaysShort = "Sun_Mon_Tue_Wed_Thu_Fri_Sat".split("_"), defaultLocaleWeekdaysMin = "Su_Mo_Tu_We_Th_Fr_Sa".split("_"), defaultWeekdaysRegex = matchWord, defaultWeekdaysShortRegex = matchWord, defaultWeekdaysMinRegex = matchWord;
    function localeWeekdays(m, format) {
        var weekdays = isArray(this._weekdays) ? this._weekdays : this._weekdays[m && m !== true && this._weekdays.isFormat.test(format) ? "format" : "standalone"];
        return m === true ? shiftWeekdays(weekdays, this._week.dow) : m ? weekdays[m.day()] : weekdays;
    }
    function localeWeekdaysShort(m) {
        return m === true ? shiftWeekdays(this._weekdaysShort, this._week.dow) : m ? this._weekdaysShort[m.day()] : this._weekdaysShort;
    }
    function localeWeekdaysMin(m) {
        return m === true ? shiftWeekdays(this._weekdaysMin, this._week.dow) : m ? this._weekdaysMin[m.day()] : this._weekdaysMin;
    }
    function handleStrictParse$1(weekdayName, format, strict) {
        var i, ii, mom, llc = weekdayName.toLocaleLowerCase();
        if (!this._weekdaysParse) {
            this._weekdaysParse = [];
            this._shortWeekdaysParse = [];
            this._minWeekdaysParse = [];
            for(i = 0; i < 7; ++i){
                mom = createUTC([
                    2000,
                    1
                ]).day(i);
                this._minWeekdaysParse[i] = this.weekdaysMin(mom, "").toLocaleLowerCase();
                this._shortWeekdaysParse[i] = this.weekdaysShort(mom, "").toLocaleLowerCase();
                this._weekdaysParse[i] = this.weekdays(mom, "").toLocaleLowerCase();
            }
        }
        if (strict) {
            if (format === "dddd") {
                ii = indexOf.call(this._weekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else if (format === "ddd") {
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._minWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            }
        } else {
            if (format === "dddd") {
                ii = indexOf.call(this._weekdaysParse, llc);
                if (ii !== -1) return ii;
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                if (ii !== -1) return ii;
                ii = indexOf.call(this._minWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else if (format === "ddd") {
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                if (ii !== -1) return ii;
                ii = indexOf.call(this._weekdaysParse, llc);
                if (ii !== -1) return ii;
                ii = indexOf.call(this._minWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._minWeekdaysParse, llc);
                if (ii !== -1) return ii;
                ii = indexOf.call(this._weekdaysParse, llc);
                if (ii !== -1) return ii;
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            }
        }
    }
    function localeWeekdaysParse(weekdayName, format, strict) {
        var i, mom, regex;
        if (this._weekdaysParseExact) return handleStrictParse$1.call(this, weekdayName, format, strict);
        if (!this._weekdaysParse) {
            this._weekdaysParse = [];
            this._minWeekdaysParse = [];
            this._shortWeekdaysParse = [];
            this._fullWeekdaysParse = [];
        }
        for(i = 0; i < 7; i++){
            // make the regex if we don't have it already
            mom = createUTC([
                2000,
                1
            ]).day(i);
            if (strict && !this._fullWeekdaysParse[i]) {
                this._fullWeekdaysParse[i] = new RegExp("^" + this.weekdays(mom, "").replace(".", "\\.?") + "$", "i");
                this._shortWeekdaysParse[i] = new RegExp("^" + this.weekdaysShort(mom, "").replace(".", "\\.?") + "$", "i");
                this._minWeekdaysParse[i] = new RegExp("^" + this.weekdaysMin(mom, "").replace(".", "\\.?") + "$", "i");
            }
            if (!this._weekdaysParse[i]) {
                regex = "^" + this.weekdays(mom, "") + "|^" + this.weekdaysShort(mom, "") + "|^" + this.weekdaysMin(mom, "");
                this._weekdaysParse[i] = new RegExp(regex.replace(".", ""), "i");
            }
            // test the regex
            if (strict && format === "dddd" && this._fullWeekdaysParse[i].test(weekdayName)) return i;
            else if (strict && format === "ddd" && this._shortWeekdaysParse[i].test(weekdayName)) return i;
            else if (strict && format === "dd" && this._minWeekdaysParse[i].test(weekdayName)) return i;
            else if (!strict && this._weekdaysParse[i].test(weekdayName)) return i;
        }
    }
    // MOMENTS
    function getSetDayOfWeek(input) {
        if (!this.isValid()) return input != null ? this : NaN;
        var day = this._isUTC ? this._d.getUTCDay() : this._d.getDay();
        if (input != null) {
            input = parseWeekday(input, this.localeData());
            return this.add(input - day, "d");
        } else return day;
    }
    function getSetLocaleDayOfWeek(input) {
        if (!this.isValid()) return input != null ? this : NaN;
        var weekday = (this.day() + 7 - this.localeData()._week.dow) % 7;
        return input == null ? weekday : this.add(input - weekday, "d");
    }
    function getSetISODayOfWeek(input) {
        if (!this.isValid()) return input != null ? this : NaN;
        // behaves the same as moment#day except
        // as a getter, returns 7 instead of 0 (1-7 range instead of 0-6)
        // as a setter, sunday should belong to the previous week.
        if (input != null) {
            var weekday = parseIsoWeekday(input, this.localeData());
            return this.day(this.day() % 7 ? weekday : weekday - 7);
        } else return this.day() || 7;
    }
    function weekdaysRegex(isStrict) {
        if (this._weekdaysParseExact) {
            if (!hasOwnProp(this, "_weekdaysRegex")) computeWeekdaysParse.call(this);
            if (isStrict) return this._weekdaysStrictRegex;
            else return this._weekdaysRegex;
        } else {
            if (!hasOwnProp(this, "_weekdaysRegex")) this._weekdaysRegex = defaultWeekdaysRegex;
            return this._weekdaysStrictRegex && isStrict ? this._weekdaysStrictRegex : this._weekdaysRegex;
        }
    }
    function weekdaysShortRegex(isStrict) {
        if (this._weekdaysParseExact) {
            if (!hasOwnProp(this, "_weekdaysRegex")) computeWeekdaysParse.call(this);
            if (isStrict) return this._weekdaysShortStrictRegex;
            else return this._weekdaysShortRegex;
        } else {
            if (!hasOwnProp(this, "_weekdaysShortRegex")) this._weekdaysShortRegex = defaultWeekdaysShortRegex;
            return this._weekdaysShortStrictRegex && isStrict ? this._weekdaysShortStrictRegex : this._weekdaysShortRegex;
        }
    }
    function weekdaysMinRegex(isStrict) {
        if (this._weekdaysParseExact) {
            if (!hasOwnProp(this, "_weekdaysRegex")) computeWeekdaysParse.call(this);
            if (isStrict) return this._weekdaysMinStrictRegex;
            else return this._weekdaysMinRegex;
        } else {
            if (!hasOwnProp(this, "_weekdaysMinRegex")) this._weekdaysMinRegex = defaultWeekdaysMinRegex;
            return this._weekdaysMinStrictRegex && isStrict ? this._weekdaysMinStrictRegex : this._weekdaysMinRegex;
        }
    }
    function computeWeekdaysParse() {
        function cmpLenRev(a, b) {
            return b.length - a.length;
        }
        var minPieces = [], shortPieces = [], longPieces = [], mixedPieces = [], i, mom, minp, shortp, longp;
        for(i = 0; i < 7; i++){
            // make the regex if we don't have it already
            mom = createUTC([
                2000,
                1
            ]).day(i);
            minp = regexEscape(this.weekdaysMin(mom, ""));
            shortp = regexEscape(this.weekdaysShort(mom, ""));
            longp = regexEscape(this.weekdays(mom, ""));
            minPieces.push(minp);
            shortPieces.push(shortp);
            longPieces.push(longp);
            mixedPieces.push(minp);
            mixedPieces.push(shortp);
            mixedPieces.push(longp);
        }
        // Sorting makes sure if one weekday (or abbr) is a prefix of another it
        // will match the longer piece.
        minPieces.sort(cmpLenRev);
        shortPieces.sort(cmpLenRev);
        longPieces.sort(cmpLenRev);
        mixedPieces.sort(cmpLenRev);
        this._weekdaysRegex = new RegExp("^(" + mixedPieces.join("|") + ")", "i");
        this._weekdaysShortRegex = this._weekdaysRegex;
        this._weekdaysMinRegex = this._weekdaysRegex;
        this._weekdaysStrictRegex = new RegExp("^(" + longPieces.join("|") + ")", "i");
        this._weekdaysShortStrictRegex = new RegExp("^(" + shortPieces.join("|") + ")", "i");
        this._weekdaysMinStrictRegex = new RegExp("^(" + minPieces.join("|") + ")", "i");
    }
    // FORMATTING
    function hFormat() {
        return this.hours() % 12 || 12;
    }
    function kFormat() {
        return this.hours() || 24;
    }
    addFormatToken("H", [
        "HH",
        2
    ], 0, "hour");
    addFormatToken("h", [
        "hh",
        2
    ], 0, hFormat);
    addFormatToken("k", [
        "kk",
        2
    ], 0, kFormat);
    addFormatToken("hmm", 0, 0, function() {
        return "" + hFormat.apply(this) + zeroFill(this.minutes(), 2);
    });
    addFormatToken("hmmss", 0, 0, function() {
        return "" + hFormat.apply(this) + zeroFill(this.minutes(), 2) + zeroFill(this.seconds(), 2);
    });
    addFormatToken("Hmm", 0, 0, function() {
        return "" + this.hours() + zeroFill(this.minutes(), 2);
    });
    addFormatToken("Hmmss", 0, 0, function() {
        return "" + this.hours() + zeroFill(this.minutes(), 2) + zeroFill(this.seconds(), 2);
    });
    function meridiem(token, lowercase) {
        addFormatToken(token, 0, 0, function() {
            return this.localeData().meridiem(this.hours(), this.minutes(), lowercase);
        });
    }
    meridiem("a", true);
    meridiem("A", false);
    // ALIASES
    addUnitAlias("hour", "h");
    // PRIORITY
    addUnitPriority("hour", 13);
    // PARSING
    function matchMeridiem(isStrict, locale) {
        return locale._meridiemParse;
    }
    addRegexToken("a", matchMeridiem);
    addRegexToken("A", matchMeridiem);
    addRegexToken("H", match1to2);
    addRegexToken("h", match1to2);
    addRegexToken("k", match1to2);
    addRegexToken("HH", match1to2, match2);
    addRegexToken("hh", match1to2, match2);
    addRegexToken("kk", match1to2, match2);
    addRegexToken("hmm", match3to4);
    addRegexToken("hmmss", match5to6);
    addRegexToken("Hmm", match3to4);
    addRegexToken("Hmmss", match5to6);
    addParseToken([
        "H",
        "HH"
    ], HOUR);
    addParseToken([
        "k",
        "kk"
    ], function(input, array, config) {
        var kInput = toInt(input);
        array[HOUR] = kInput === 24 ? 0 : kInput;
    });
    addParseToken([
        "a",
        "A"
    ], function(input, array, config) {
        config._isPm = config._locale.isPM(input);
        config._meridiem = input;
    });
    addParseToken([
        "h",
        "hh"
    ], function(input, array, config) {
        array[HOUR] = toInt(input);
        getParsingFlags(config).bigHour = true;
    });
    addParseToken("hmm", function(input, array, config) {
        var pos = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos));
        array[MINUTE] = toInt(input.substr(pos));
        getParsingFlags(config).bigHour = true;
    });
    addParseToken("hmmss", function(input, array, config) {
        var pos1 = input.length - 4, pos2 = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos1));
        array[MINUTE] = toInt(input.substr(pos1, 2));
        array[SECOND] = toInt(input.substr(pos2));
        getParsingFlags(config).bigHour = true;
    });
    addParseToken("Hmm", function(input, array, config) {
        var pos = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos));
        array[MINUTE] = toInt(input.substr(pos));
    });
    addParseToken("Hmmss", function(input, array, config) {
        var pos1 = input.length - 4, pos2 = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos1));
        array[MINUTE] = toInt(input.substr(pos1, 2));
        array[SECOND] = toInt(input.substr(pos2));
    });
    // LOCALES
    function localeIsPM(input) {
        // IE8 Quirks Mode & IE7 Standards Mode do not allow accessing strings like arrays
        // Using charAt should be more compatible.
        return (input + "").toLowerCase().charAt(0) === "p";
    }
    var defaultLocaleMeridiemParse = /[ap]\.?m?\.?/i, // Setting the hour should keep the time, because the user explicitly
    // specified which hour they want. So trying to maintain the same hour (in
    // a new timezone) makes sense. Adding/subtracting hours does not follow
    // this rule.
    getSetHour = makeGetSet("Hours", true);
    function localeMeridiem(hours, minutes, isLower) {
        if (hours > 11) return isLower ? "pm" : "PM";
        else return isLower ? "am" : "AM";
    }
    var baseConfig = {
        calendar: defaultCalendar,
        longDateFormat: defaultLongDateFormat,
        invalidDate: defaultInvalidDate,
        ordinal: defaultOrdinal,
        dayOfMonthOrdinalParse: defaultDayOfMonthOrdinalParse,
        relativeTime: defaultRelativeTime,
        months: defaultLocaleMonths,
        monthsShort: defaultLocaleMonthsShort,
        week: defaultLocaleWeek,
        weekdays: defaultLocaleWeekdays,
        weekdaysMin: defaultLocaleWeekdaysMin,
        weekdaysShort: defaultLocaleWeekdaysShort,
        meridiemParse: defaultLocaleMeridiemParse
    };
    // internal storage for locale config files
    var locales = {}, localeFamilies = {}, globalLocale;
    function commonPrefix(arr1, arr2) {
        var i, minl = Math.min(arr1.length, arr2.length);
        for(i = 0; i < minl; i += 1){
            if (arr1[i] !== arr2[i]) return i;
        }
        return minl;
    }
    function normalizeLocale(key) {
        return key ? key.toLowerCase().replace("_", "-") : key;
    }
    // pick the locale from the array
    // try ['en-au', 'en-gb'] as 'en-au', 'en-gb', 'en', as in move through the list trying each
    // substring from most specific to least, but move to the next array item if it's a more specific variant than the current root
    function chooseLocale(names) {
        var i = 0, j, next, locale, split;
        while(i < names.length){
            split = normalizeLocale(names[i]).split("-");
            j = split.length;
            next = normalizeLocale(names[i + 1]);
            next = next ? next.split("-") : null;
            while(j > 0){
                locale = loadLocale(split.slice(0, j).join("-"));
                if (locale) return locale;
                if (next && next.length >= j && commonPrefix(split, next) >= j - 1) break;
                j--;
            }
            i++;
        }
        return globalLocale;
    }
    function isLocaleNameSane(name) {
        // Prevent names that look like filesystem paths, i.e contain '/' or '\'
        return name.match("^[^/\\\\]*$") != null;
    }
    function loadLocale(name) {
        var oldLocale = null, aliasedRequire;
        // TODO: Find a better way to register and load all the locales in Node
        if (locales[name] === undefined && true && module && module.exports && isLocaleNameSane(name)) try {
            oldLocale = globalLocale._abbr;
            aliasedRequire = undefined;
            aliasedRequire("./locale/" + name);
            getSetGlobalLocale(oldLocale);
        } catch (e) {
            // mark as not found to avoid repeating expensive file require call causing high CPU
            // when trying to find en-US, en_US, en-us for every format call
            locales[name] = null; // null means not found
        }
        return locales[name];
    }
    // This function will load locale and then set the global locale.  If
    // no arguments are passed in, it will simply return the current global
    // locale key.
    function getSetGlobalLocale(key, values) {
        var data;
        if (key) {
            if (isUndefined(values)) data = getLocale(key);
            else data = defineLocale(key, values);
            if (data) // moment.duration._locale = moment._locale = data;
            globalLocale = data;
            else if (typeof console !== "undefined" && console.warn) //warn user if arguments are passed but the locale could not be set
            console.warn("Locale " + key + " not found. Did you forget to load it?");
        }
        return globalLocale._abbr;
    }
    function defineLocale(name, config) {
        if (config !== null) {
            var locale, parentConfig = baseConfig;
            config.abbr = name;
            if (locales[name] != null) {
                deprecateSimple("defineLocaleOverride", "use moment.updateLocale(localeName, config) to change an existing locale. moment.defineLocale(localeName, config) should only be used for creating a new locale See http://momentjs.com/guides/#/warnings/define-locale/ for more info.");
                parentConfig = locales[name]._config;
            } else if (config.parentLocale != null) {
                if (locales[config.parentLocale] != null) parentConfig = locales[config.parentLocale]._config;
                else {
                    locale = loadLocale(config.parentLocale);
                    if (locale != null) parentConfig = locale._config;
                    else {
                        if (!localeFamilies[config.parentLocale]) localeFamilies[config.parentLocale] = [];
                        localeFamilies[config.parentLocale].push({
                            name: name,
                            config: config
                        });
                        return null;
                    }
                }
            }
            locales[name] = new Locale(mergeConfigs(parentConfig, config));
            if (localeFamilies[name]) localeFamilies[name].forEach(function(x) {
                defineLocale(x.name, x.config);
            });
            // backwards compat for now: also set the locale
            // make sure we set the locale AFTER all child locales have been
            // created, so we won't end up with the child locale set.
            getSetGlobalLocale(name);
            return locales[name];
        } else {
            // useful for testing
            delete locales[name];
            return null;
        }
    }
    function updateLocale(name, config) {
        if (config != null) {
            var locale, tmpLocale, parentConfig = baseConfig;
            if (locales[name] != null && locales[name].parentLocale != null) // Update existing child locale in-place to avoid memory-leaks
            locales[name].set(mergeConfigs(locales[name]._config, config));
            else {
                // MERGE
                tmpLocale = loadLocale(name);
                if (tmpLocale != null) parentConfig = tmpLocale._config;
                config = mergeConfigs(parentConfig, config);
                if (tmpLocale == null) // updateLocale is called for creating a new locale
                // Set abbr so it will have a name (getters return
                // undefined otherwise).
                config.abbr = name;
                locale = new Locale(config);
                locale.parentLocale = locales[name];
                locales[name] = locale;
            }
            // backwards compat for now: also set the locale
            getSetGlobalLocale(name);
        } else // pass null for config to unupdate, useful for tests
        if (locales[name] != null) {
            if (locales[name].parentLocale != null) {
                locales[name] = locales[name].parentLocale;
                if (name === getSetGlobalLocale()) getSetGlobalLocale(name);
            } else if (locales[name] != null) delete locales[name];
        }
        return locales[name];
    }
    // returns locale data
    function getLocale(key) {
        var locale;
        if (key && key._locale && key._locale._abbr) key = key._locale._abbr;
        if (!key) return globalLocale;
        if (!isArray(key)) {
            //short-circuit everything else
            locale = loadLocale(key);
            if (locale) return locale;
            key = [
                key
            ];
        }
        return chooseLocale(key);
    }
    function listLocales() {
        return keys(locales);
    }
    function checkOverflow(m) {
        var overflow, a = m._a;
        if (a && getParsingFlags(m).overflow === -2) {
            overflow = a[MONTH] < 0 || a[MONTH] > 11 ? MONTH : a[DATE] < 1 || a[DATE] > daysInMonth(a[YEAR], a[MONTH]) ? DATE : a[HOUR] < 0 || a[HOUR] > 24 || a[HOUR] === 24 && (a[MINUTE] !== 0 || a[SECOND] !== 0 || a[MILLISECOND] !== 0) ? HOUR : a[MINUTE] < 0 || a[MINUTE] > 59 ? MINUTE : a[SECOND] < 0 || a[SECOND] > 59 ? SECOND : a[MILLISECOND] < 0 || a[MILLISECOND] > 999 ? MILLISECOND : -1;
            if (getParsingFlags(m)._overflowDayOfYear && (overflow < YEAR || overflow > DATE)) overflow = DATE;
            if (getParsingFlags(m)._overflowWeeks && overflow === -1) overflow = WEEK;
            if (getParsingFlags(m)._overflowWeekday && overflow === -1) overflow = WEEKDAY;
            getParsingFlags(m).overflow = overflow;
        }
        return m;
    }
    // iso 8601 regex
    // 0000-00-00 0000-W00 or 0000-W00-0 + T + 00 or 00:00 or 00:00:00 or 00:00:00.000 + +00:00 or +0000 or +00)
    var extendedIsoRegex = /^\s*((?:[+-]\d{6}|\d{4})-(?:\d\d-\d\d|W\d\d-\d|W\d\d|\d\d\d|\d\d))(?:(T| )(\d\d(?::\d\d(?::\d\d(?:[.,]\d+)?)?)?)([+-]\d\d(?::?\d\d)?|\s*Z)?)?$/, basicIsoRegex = /^\s*((?:[+-]\d{6}|\d{4})(?:\d\d\d\d|W\d\d\d|W\d\d|\d\d\d|\d\d|))(?:(T| )(\d\d(?:\d\d(?:\d\d(?:[.,]\d+)?)?)?)([+-]\d\d(?::?\d\d)?|\s*Z)?)?$/, tzRegex = /Z|[+-]\d\d(?::?\d\d)?/, isoDates = [
        [
            "YYYYYY-MM-DD",
            /[+-]\d{6}-\d\d-\d\d/
        ],
        [
            "YYYY-MM-DD",
            /\d{4}-\d\d-\d\d/
        ],
        [
            "GGGG-[W]WW-E",
            /\d{4}-W\d\d-\d/
        ],
        [
            "GGGG-[W]WW",
            /\d{4}-W\d\d/,
            false
        ],
        [
            "YYYY-DDD",
            /\d{4}-\d{3}/
        ],
        [
            "YYYY-MM",
            /\d{4}-\d\d/,
            false
        ],
        [
            "YYYYYYMMDD",
            /[+-]\d{10}/
        ],
        [
            "YYYYMMDD",
            /\d{8}/
        ],
        [
            "GGGG[W]WWE",
            /\d{4}W\d{3}/
        ],
        [
            "GGGG[W]WW",
            /\d{4}W\d{2}/,
            false
        ],
        [
            "YYYYDDD",
            /\d{7}/
        ],
        [
            "YYYYMM",
            /\d{6}/,
            false
        ],
        [
            "YYYY",
            /\d{4}/,
            false
        ]
    ], // iso time formats and regexes
    isoTimes = [
        [
            "HH:mm:ss.SSSS",
            /\d\d:\d\d:\d\d\.\d+/
        ],
        [
            "HH:mm:ss,SSSS",
            /\d\d:\d\d:\d\d,\d+/
        ],
        [
            "HH:mm:ss",
            /\d\d:\d\d:\d\d/
        ],
        [
            "HH:mm",
            /\d\d:\d\d/
        ],
        [
            "HHmmss.SSSS",
            /\d\d\d\d\d\d\.\d+/
        ],
        [
            "HHmmss,SSSS",
            /\d\d\d\d\d\d,\d+/
        ],
        [
            "HHmmss",
            /\d\d\d\d\d\d/
        ],
        [
            "HHmm",
            /\d\d\d\d/
        ],
        [
            "HH",
            /\d\d/
        ]
    ], aspNetJsonRegex = /^\/?Date\((-?\d+)/i, // RFC 2822 regex: For details see https://tools.ietf.org/html/rfc2822#section-3.3
    rfc2822 = /^(?:(Mon|Tue|Wed|Thu|Fri|Sat|Sun),?\s)?(\d{1,2})\s(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)\s(\d{2,4})\s(\d\d):(\d\d)(?::(\d\d))?\s(?:(UT|GMT|[ECMP][SD]T)|([Zz])|([+-]\d{4}))$/, obsOffsets = {
        UT: 0,
        GMT: 0,
        EDT: -240,
        EST: -300,
        CDT: -300,
        CST: -360,
        MDT: -360,
        MST: -420,
        PDT: -420,
        PST: -480
    };
    // date from iso format
    function configFromISO(config) {
        var i, l, string = config._i, match = extendedIsoRegex.exec(string) || basicIsoRegex.exec(string), allowTime, dateFormat, timeFormat, tzFormat, isoDatesLen = isoDates.length, isoTimesLen = isoTimes.length;
        if (match) {
            getParsingFlags(config).iso = true;
            for(i = 0, l = isoDatesLen; i < l; i++)if (isoDates[i][1].exec(match[1])) {
                dateFormat = isoDates[i][0];
                allowTime = isoDates[i][2] !== false;
                break;
            }
            if (dateFormat == null) {
                config._isValid = false;
                return;
            }
            if (match[3]) {
                for(i = 0, l = isoTimesLen; i < l; i++)if (isoTimes[i][1].exec(match[3])) {
                    // match[2] should be 'T' or space
                    timeFormat = (match[2] || " ") + isoTimes[i][0];
                    break;
                }
                if (timeFormat == null) {
                    config._isValid = false;
                    return;
                }
            }
            if (!allowTime && timeFormat != null) {
                config._isValid = false;
                return;
            }
            if (match[4]) {
                if (tzRegex.exec(match[4])) tzFormat = "Z";
                else {
                    config._isValid = false;
                    return;
                }
            }
            config._f = dateFormat + (timeFormat || "") + (tzFormat || "");
            configFromStringAndFormat(config);
        } else config._isValid = false;
    }
    function extractFromRFC2822Strings(yearStr, monthStr, dayStr, hourStr, minuteStr, secondStr) {
        var result = [
            untruncateYear(yearStr),
            defaultLocaleMonthsShort.indexOf(monthStr),
            parseInt(dayStr, 10),
            parseInt(hourStr, 10),
            parseInt(minuteStr, 10)
        ];
        if (secondStr) result.push(parseInt(secondStr, 10));
        return result;
    }
    function untruncateYear(yearStr) {
        var year = parseInt(yearStr, 10);
        if (year <= 49) return 2000 + year;
        else if (year <= 999) return 1900 + year;
        return year;
    }
    function preprocessRFC2822(s) {
        // Remove comments and folding whitespace and replace multiple-spaces with a single space
        return s.replace(/\([^()]*\)|[\n\t]/g, " ").replace(/(\s\s+)/g, " ").replace(/^\s\s*/, "").replace(/\s\s*$/, "");
    }
    function checkWeekday(weekdayStr, parsedInput, config) {
        if (weekdayStr) {
            // TODO: Replace the vanilla JS Date object with an independent day-of-week check.
            var weekdayProvided = defaultLocaleWeekdaysShort.indexOf(weekdayStr), weekdayActual = new Date(parsedInput[0], parsedInput[1], parsedInput[2]).getDay();
            if (weekdayProvided !== weekdayActual) {
                getParsingFlags(config).weekdayMismatch = true;
                config._isValid = false;
                return false;
            }
        }
        return true;
    }
    function calculateOffset(obsOffset, militaryOffset, numOffset) {
        if (obsOffset) return obsOffsets[obsOffset];
        else if (militaryOffset) // the only allowed military tz is Z
        return 0;
        else {
            var hm = parseInt(numOffset, 10), m = hm % 100, h = (hm - m) / 100;
            return h * 60 + m;
        }
    }
    // date and time from ref 2822 format
    function configFromRFC2822(config) {
        var match = rfc2822.exec(preprocessRFC2822(config._i)), parsedArray;
        if (match) {
            parsedArray = extractFromRFC2822Strings(match[4], match[3], match[2], match[5], match[6], match[7]);
            if (!checkWeekday(match[1], parsedArray, config)) return;
            config._a = parsedArray;
            config._tzm = calculateOffset(match[8], match[9], match[10]);
            config._d = createUTCDate.apply(null, config._a);
            config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);
            getParsingFlags(config).rfc2822 = true;
        } else config._isValid = false;
    }
    // date from 1) ASP.NET, 2) ISO, 3) RFC 2822 formats, or 4) optional fallback if parsing isn't strict
    function configFromString(config) {
        var matched = aspNetJsonRegex.exec(config._i);
        if (matched !== null) {
            config._d = new Date(+matched[1]);
            return;
        }
        configFromISO(config);
        if (config._isValid === false) delete config._isValid;
        else return;
        configFromRFC2822(config);
        if (config._isValid === false) delete config._isValid;
        else return;
        if (config._strict) config._isValid = false;
        else // Final attempt, use Input Fallback
        hooks.createFromInputFallback(config);
    }
    hooks.createFromInputFallback = deprecate("value provided is not in a recognized RFC2822 or ISO format. moment construction falls back to js Date(), which is not reliable across all browsers and versions. Non RFC2822/ISO date formats are discouraged. Please refer to http://momentjs.com/guides/#/warnings/js-date/ for more info.", function(config) {
        config._d = new Date(config._i + (config._useUTC ? " UTC" : ""));
    });
    // Pick the first defined of two or three arguments.
    function defaults(a, b, c) {
        if (a != null) return a;
        if (b != null) return b;
        return c;
    }
    function currentDateArray(config) {
        // hooks is actually the exported moment object
        var nowValue = new Date(hooks.now());
        if (config._useUTC) return [
            nowValue.getUTCFullYear(),
            nowValue.getUTCMonth(),
            nowValue.getUTCDate()
        ];
        return [
            nowValue.getFullYear(),
            nowValue.getMonth(),
            nowValue.getDate()
        ];
    }
    // convert an array to a date.
    // the array should mirror the parameters below
    // note: all values past the year are optional and will default to the lowest possible value.
    // [year, month, day , hour, minute, second, millisecond]
    function configFromArray(config) {
        var i, date, input = [], currentDate, expectedWeekday, yearToUse;
        if (config._d) return;
        currentDate = currentDateArray(config);
        //compute day of the year from weeks and weekdays
        if (config._w && config._a[DATE] == null && config._a[MONTH] == null) dayOfYearFromWeekInfo(config);
        //if the day of the year is set, figure out what it is
        if (config._dayOfYear != null) {
            yearToUse = defaults(config._a[YEAR], currentDate[YEAR]);
            if (config._dayOfYear > daysInYear(yearToUse) || config._dayOfYear === 0) getParsingFlags(config)._overflowDayOfYear = true;
            date = createUTCDate(yearToUse, 0, config._dayOfYear);
            config._a[MONTH] = date.getUTCMonth();
            config._a[DATE] = date.getUTCDate();
        }
        // Default to current date.
        // * if no year, month, day of month are given, default to today
        // * if day of month is given, default month and year
        // * if month is given, default only year
        // * if year is given, don't default anything
        for(i = 0; i < 3 && config._a[i] == null; ++i)config._a[i] = input[i] = currentDate[i];
        // Zero out whatever was not defaulted, including time
        for(; i < 7; i++)config._a[i] = input[i] = config._a[i] == null ? i === 2 ? 1 : 0 : config._a[i];
        // Check for 24:00:00.000
        if (config._a[HOUR] === 24 && config._a[MINUTE] === 0 && config._a[SECOND] === 0 && config._a[MILLISECOND] === 0) {
            config._nextDay = true;
            config._a[HOUR] = 0;
        }
        config._d = (config._useUTC ? createUTCDate : createDate).apply(null, input);
        expectedWeekday = config._useUTC ? config._d.getUTCDay() : config._d.getDay();
        // Apply timezone offset from input. The actual utcOffset can be changed
        // with parseZone.
        if (config._tzm != null) config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);
        if (config._nextDay) config._a[HOUR] = 24;
        // check for mismatching day of week
        if (config._w && typeof config._w.d !== "undefined" && config._w.d !== expectedWeekday) getParsingFlags(config).weekdayMismatch = true;
    }
    function dayOfYearFromWeekInfo(config) {
        var w, weekYear, week, weekday, dow, doy, temp, weekdayOverflow, curWeek;
        w = config._w;
        if (w.GG != null || w.W != null || w.E != null) {
            dow = 1;
            doy = 4;
            // TODO: We need to take the current isoWeekYear, but that depends on
            // how we interpret now (local, utc, fixed offset). So create
            // a now version of current config (take local/utc/offset flags, and
            // create now).
            weekYear = defaults(w.GG, config._a[YEAR], weekOfYear(createLocal(), 1, 4).year);
            week = defaults(w.W, 1);
            weekday = defaults(w.E, 1);
            if (weekday < 1 || weekday > 7) weekdayOverflow = true;
        } else {
            dow = config._locale._week.dow;
            doy = config._locale._week.doy;
            curWeek = weekOfYear(createLocal(), dow, doy);
            weekYear = defaults(w.gg, config._a[YEAR], curWeek.year);
            // Default to current week.
            week = defaults(w.w, curWeek.week);
            if (w.d != null) {
                // weekday -- low day numbers are considered next week
                weekday = w.d;
                if (weekday < 0 || weekday > 6) weekdayOverflow = true;
            } else if (w.e != null) {
                // local weekday -- counting starts from beginning of week
                weekday = w.e + dow;
                if (w.e < 0 || w.e > 6) weekdayOverflow = true;
            } else // default to beginning of week
            weekday = dow;
        }
        if (week < 1 || week > weeksInYear(weekYear, dow, doy)) getParsingFlags(config)._overflowWeeks = true;
        else if (weekdayOverflow != null) getParsingFlags(config)._overflowWeekday = true;
        else {
            temp = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy);
            config._a[YEAR] = temp.year;
            config._dayOfYear = temp.dayOfYear;
        }
    }
    // constant that refers to the ISO standard
    hooks.ISO_8601 = function() {};
    // constant that refers to the RFC 2822 form
    hooks.RFC_2822 = function() {};
    // date from string and format string
    function configFromStringAndFormat(config) {
        // TODO: Move this to another part of the creation flow to prevent circular deps
        if (config._f === hooks.ISO_8601) {
            configFromISO(config);
            return;
        }
        if (config._f === hooks.RFC_2822) {
            configFromRFC2822(config);
            return;
        }
        config._a = [];
        getParsingFlags(config).empty = true;
        // This array is used to make a Date, either with `new Date` or `Date.UTC`
        var string = "" + config._i, i, parsedInput, tokens, token, skipped, stringLength = string.length, totalParsedInputLength = 0, era, tokenLen;
        tokens = expandFormat(config._f, config._locale).match(formattingTokens) || [];
        tokenLen = tokens.length;
        for(i = 0; i < tokenLen; i++){
            token = tokens[i];
            parsedInput = (string.match(getParseRegexForToken(token, config)) || [])[0];
            if (parsedInput) {
                skipped = string.substr(0, string.indexOf(parsedInput));
                if (skipped.length > 0) getParsingFlags(config).unusedInput.push(skipped);
                string = string.slice(string.indexOf(parsedInput) + parsedInput.length);
                totalParsedInputLength += parsedInput.length;
            }
            // don't parse if it's not a known token
            if (formatTokenFunctions[token]) {
                if (parsedInput) getParsingFlags(config).empty = false;
                else getParsingFlags(config).unusedTokens.push(token);
                addTimeToArrayFromToken(token, parsedInput, config);
            } else if (config._strict && !parsedInput) getParsingFlags(config).unusedTokens.push(token);
        }
        // add remaining unparsed input length to the string
        getParsingFlags(config).charsLeftOver = stringLength - totalParsedInputLength;
        if (string.length > 0) getParsingFlags(config).unusedInput.push(string);
        // clear _12h flag if hour is <= 12
        if (config._a[HOUR] <= 12 && getParsingFlags(config).bigHour === true && config._a[HOUR] > 0) getParsingFlags(config).bigHour = undefined;
        getParsingFlags(config).parsedDateParts = config._a.slice(0);
        getParsingFlags(config).meridiem = config._meridiem;
        // handle meridiem
        config._a[HOUR] = meridiemFixWrap(config._locale, config._a[HOUR], config._meridiem);
        // handle era
        era = getParsingFlags(config).era;
        if (era !== null) config._a[YEAR] = config._locale.erasConvertYear(era, config._a[YEAR]);
        configFromArray(config);
        checkOverflow(config);
    }
    function meridiemFixWrap(locale, hour, meridiem) {
        var isPm;
        if (meridiem == null) // nothing to do
        return hour;
        if (locale.meridiemHour != null) return locale.meridiemHour(hour, meridiem);
        else if (locale.isPM != null) {
            // Fallback
            isPm = locale.isPM(meridiem);
            if (isPm && hour < 12) hour += 12;
            if (!isPm && hour === 12) hour = 0;
            return hour;
        } else // this is not supposed to happen
        return hour;
    }
    // date from string and array of format strings
    function configFromStringAndArray(config) {
        var tempConfig, bestMoment, scoreToBeat, i, currentScore, validFormatFound, bestFormatIsValid = false, configfLen = config._f.length;
        if (configfLen === 0) {
            getParsingFlags(config).invalidFormat = true;
            config._d = new Date(NaN);
            return;
        }
        for(i = 0; i < configfLen; i++){
            currentScore = 0;
            validFormatFound = false;
            tempConfig = copyConfig({}, config);
            if (config._useUTC != null) tempConfig._useUTC = config._useUTC;
            tempConfig._f = config._f[i];
            configFromStringAndFormat(tempConfig);
            if (isValid(tempConfig)) validFormatFound = true;
            // if there is any input that was not parsed add a penalty for that format
            currentScore += getParsingFlags(tempConfig).charsLeftOver;
            //or tokens
            currentScore += getParsingFlags(tempConfig).unusedTokens.length * 10;
            getParsingFlags(tempConfig).score = currentScore;
            if (!bestFormatIsValid) {
                if (scoreToBeat == null || currentScore < scoreToBeat || validFormatFound) {
                    scoreToBeat = currentScore;
                    bestMoment = tempConfig;
                    if (validFormatFound) bestFormatIsValid = true;
                }
            } else if (currentScore < scoreToBeat) {
                scoreToBeat = currentScore;
                bestMoment = tempConfig;
            }
        }
        extend(config, bestMoment || tempConfig);
    }
    function configFromObject(config) {
        if (config._d) return;
        var i = normalizeObjectUnits(config._i), dayOrDate = i.day === undefined ? i.date : i.day;
        config._a = map([
            i.year,
            i.month,
            dayOrDate,
            i.hour,
            i.minute,
            i.second,
            i.millisecond
        ], function(obj) {
            return obj && parseInt(obj, 10);
        });
        configFromArray(config);
    }
    function createFromConfig(config) {
        var res = new Moment(checkOverflow(prepareConfig(config)));
        if (res._nextDay) {
            // Adding is smart enough around DST
            res.add(1, "d");
            res._nextDay = undefined;
        }
        return res;
    }
    function prepareConfig(config) {
        var input = config._i, format = config._f;
        config._locale = config._locale || getLocale(config._l);
        if (input === null || format === undefined && input === "") return createInvalid({
            nullInput: true
        });
        if (typeof input === "string") config._i = input = config._locale.preparse(input);
        if (isMoment(input)) return new Moment(checkOverflow(input));
        else if (isDate(input)) config._d = input;
        else if (isArray(format)) configFromStringAndArray(config);
        else if (format) configFromStringAndFormat(config);
        else configFromInput(config);
        if (!isValid(config)) config._d = null;
        return config;
    }
    function configFromInput(config) {
        var input = config._i;
        if (isUndefined(input)) config._d = new Date(hooks.now());
        else if (isDate(input)) config._d = new Date(input.valueOf());
        else if (typeof input === "string") configFromString(config);
        else if (isArray(input)) {
            config._a = map(input.slice(0), function(obj) {
                return parseInt(obj, 10);
            });
            configFromArray(config);
        } else if (isObject(input)) configFromObject(config);
        else if (isNumber(input)) // from milliseconds
        config._d = new Date(input);
        else hooks.createFromInputFallback(config);
    }
    function createLocalOrUTC(input, format, locale, strict, isUTC) {
        var c = {};
        if (format === true || format === false) {
            strict = format;
            format = undefined;
        }
        if (locale === true || locale === false) {
            strict = locale;
            locale = undefined;
        }
        if (isObject(input) && isObjectEmpty(input) || isArray(input) && input.length === 0) input = undefined;
        // object construction must be done this way.
        // https://github.com/moment/moment/issues/1423
        c._isAMomentObject = true;
        c._useUTC = c._isUTC = isUTC;
        c._l = locale;
        c._i = input;
        c._f = format;
        c._strict = strict;
        return createFromConfig(c);
    }
    function createLocal(input, format, locale, strict) {
        return createLocalOrUTC(input, format, locale, strict, false);
    }
    var prototypeMin = deprecate("moment().min is deprecated, use moment.max instead. http://momentjs.com/guides/#/warnings/min-max/", function() {
        var other = createLocal.apply(null, arguments);
        if (this.isValid() && other.isValid()) return other < this ? this : other;
        else return createInvalid();
    }), prototypeMax = deprecate("moment().max is deprecated, use moment.min instead. http://momentjs.com/guides/#/warnings/min-max/", function() {
        var other = createLocal.apply(null, arguments);
        if (this.isValid() && other.isValid()) return other > this ? this : other;
        else return createInvalid();
    });
    // Pick a moment m from moments so that m[fn](other) is true for all
    // other. This relies on the function fn to be transitive.
    //
    // moments should either be an array of moment objects or an array, whose
    // first element is an array of moment objects.
    function pickBy(fn, moments) {
        var res, i;
        if (moments.length === 1 && isArray(moments[0])) moments = moments[0];
        if (!moments.length) return createLocal();
        res = moments[0];
        for(i = 1; i < moments.length; ++i)if (!moments[i].isValid() || moments[i][fn](res)) res = moments[i];
        return res;
    }
    // TODO: Use [].sort instead?
    function min() {
        var args = [].slice.call(arguments, 0);
        return pickBy("isBefore", args);
    }
    function max() {
        var args = [].slice.call(arguments, 0);
        return pickBy("isAfter", args);
    }
    var now = function() {
        return Date.now ? Date.now() : +new Date();
    };
    var ordering = [
        "year",
        "quarter",
        "month",
        "week",
        "day",
        "hour",
        "minute",
        "second",
        "millisecond"
    ];
    function isDurationValid(m) {
        var key, unitHasDecimal = false, i, orderLen = ordering.length;
        for(key in m){
            if (hasOwnProp(m, key) && !(indexOf.call(ordering, key) !== -1 && (m[key] == null || !isNaN(m[key])))) return false;
        }
        for(i = 0; i < orderLen; ++i)if (m[ordering[i]]) {
            if (unitHasDecimal) return false; // only allow non-integers for smallest unit
            if (parseFloat(m[ordering[i]]) !== toInt(m[ordering[i]])) unitHasDecimal = true;
        }
        return true;
    }
    function isValid$1() {
        return this._isValid;
    }
    function createInvalid$1() {
        return createDuration(NaN);
    }
    function Duration(duration) {
        var normalizedInput = normalizeObjectUnits(duration), years = normalizedInput.year || 0, quarters = normalizedInput.quarter || 0, months = normalizedInput.month || 0, weeks = normalizedInput.week || normalizedInput.isoWeek || 0, days = normalizedInput.day || 0, hours = normalizedInput.hour || 0, minutes = normalizedInput.minute || 0, seconds = normalizedInput.second || 0, milliseconds = normalizedInput.millisecond || 0;
        this._isValid = isDurationValid(normalizedInput);
        // representation for dateAddRemove
        this._milliseconds = +milliseconds + seconds * 1e3 + // 1000
        minutes * 6e4 + // 1000 * 60
        hours * 3600000; //using 1000 * 60 * 60 instead of 36e5 to avoid floating point rounding errors https://github.com/moment/moment/issues/2978
        // Because of dateAddRemove treats 24 hours as different from a
        // day when working around DST, we need to store them separately
        this._days = +days + weeks * 7;
        // It is impossible to translate months into days without knowing
        // which months you are are talking about, so we have to store
        // it separately.
        this._months = +months + quarters * 3 + years * 12;
        this._data = {};
        this._locale = getLocale();
        this._bubble();
    }
    function isDuration(obj) {
        return obj instanceof Duration;
    }
    function absRound(number) {
        if (number < 0) return Math.round(-1 * number) * -1;
        else return Math.round(number);
    }
    // compare two arrays, return the number of differences
    function compareArrays(array1, array2, dontConvert) {
        var len = Math.min(array1.length, array2.length), lengthDiff = Math.abs(array1.length - array2.length), diffs = 0, i;
        for(i = 0; i < len; i++)if (dontConvert && array1[i] !== array2[i] || !dontConvert && toInt(array1[i]) !== toInt(array2[i])) diffs++;
        return diffs + lengthDiff;
    }
    // FORMATTING
    function offset(token, separator) {
        addFormatToken(token, 0, 0, function() {
            var offset = this.utcOffset(), sign = "+";
            if (offset < 0) {
                offset = -offset;
                sign = "-";
            }
            return sign + zeroFill(~~(offset / 60), 2) + separator + zeroFill(~~offset % 60, 2);
        });
    }
    offset("Z", ":");
    offset("ZZ", "");
    // PARSING
    addRegexToken("Z", matchShortOffset);
    addRegexToken("ZZ", matchShortOffset);
    addParseToken([
        "Z",
        "ZZ"
    ], function(input, array, config) {
        config._useUTC = true;
        config._tzm = offsetFromString(matchShortOffset, input);
    });
    // HELPERS
    // timezone chunker
    // '+10:00' > ['10',  '00']
    // '-1530'  > ['-15', '30']
    var chunkOffset = /([\+\-]|\d\d)/gi;
    function offsetFromString(matcher, string) {
        var matches = (string || "").match(matcher), chunk, parts, minutes;
        if (matches === null) return null;
        chunk = matches[matches.length - 1] || [];
        parts = (chunk + "").match(chunkOffset) || [
            "-",
            0,
            0
        ];
        minutes = +(parts[1] * 60) + toInt(parts[2]);
        return minutes === 0 ? 0 : parts[0] === "+" ? minutes : -minutes;
    }
    // Return a moment from input, that is local/utc/zone equivalent to model.
    function cloneWithOffset(input, model) {
        var res, diff;
        if (model._isUTC) {
            res = model.clone();
            diff = (isMoment(input) || isDate(input) ? input.valueOf() : createLocal(input).valueOf()) - res.valueOf();
            // Use low-level api, because this fn is low-level api.
            res._d.setTime(res._d.valueOf() + diff);
            hooks.updateOffset(res, false);
            return res;
        } else return createLocal(input).local();
    }
    function getDateOffset(m) {
        // On Firefox.24 Date#getTimezoneOffset returns a floating point.
        // https://github.com/moment/moment/pull/1871
        return -Math.round(m._d.getTimezoneOffset());
    }
    // HOOKS
    // This function will be called whenever a moment is mutated.
    // It is intended to keep the offset in sync with the timezone.
    hooks.updateOffset = function() {};
    // MOMENTS
    // keepLocalTime = true means only change the timezone, without
    // affecting the local hour. So 5:31:26 +0300 --[utcOffset(2, true)]-->
    // 5:31:26 +0200 It is possible that 5:31:26 doesn't exist with offset
    // +0200, so we adjust the time as needed, to be valid.
    //
    // Keeping the time actually adds/subtracts (one hour)
    // from the actual represented time. That is why we call updateOffset
    // a second time. In case it wants us to change the offset again
    // _changeInProgress == true case, then we have to adjust, because
    // there is no such time in the given timezone.
    function getSetOffset(input, keepLocalTime, keepMinutes) {
        var offset = this._offset || 0, localAdjust;
        if (!this.isValid()) return input != null ? this : NaN;
        if (input != null) {
            if (typeof input === "string") {
                input = offsetFromString(matchShortOffset, input);
                if (input === null) return this;
            } else if (Math.abs(input) < 16 && !keepMinutes) input = input * 60;
            if (!this._isUTC && keepLocalTime) localAdjust = getDateOffset(this);
            this._offset = input;
            this._isUTC = true;
            if (localAdjust != null) this.add(localAdjust, "m");
            if (offset !== input) {
                if (!keepLocalTime || this._changeInProgress) addSubtract(this, createDuration(input - offset, "m"), 1, false);
                else if (!this._changeInProgress) {
                    this._changeInProgress = true;
                    hooks.updateOffset(this, true);
                    this._changeInProgress = null;
                }
            }
            return this;
        } else return this._isUTC ? offset : getDateOffset(this);
    }
    function getSetZone(input, keepLocalTime) {
        if (input != null) {
            if (typeof input !== "string") input = -input;
            this.utcOffset(input, keepLocalTime);
            return this;
        } else return -this.utcOffset();
    }
    function setOffsetToUTC(keepLocalTime) {
        return this.utcOffset(0, keepLocalTime);
    }
    function setOffsetToLocal(keepLocalTime) {
        if (this._isUTC) {
            this.utcOffset(0, keepLocalTime);
            this._isUTC = false;
            if (keepLocalTime) this.subtract(getDateOffset(this), "m");
        }
        return this;
    }
    function setOffsetToParsedOffset() {
        if (this._tzm != null) this.utcOffset(this._tzm, false, true);
        else if (typeof this._i === "string") {
            var tZone = offsetFromString(matchOffset, this._i);
            if (tZone != null) this.utcOffset(tZone);
            else this.utcOffset(0, true);
        }
        return this;
    }
    function hasAlignedHourOffset(input) {
        if (!this.isValid()) return false;
        input = input ? createLocal(input).utcOffset() : 0;
        return (this.utcOffset() - input) % 60 === 0;
    }
    function isDaylightSavingTime() {
        return this.utcOffset() > this.clone().month(0).utcOffset() || this.utcOffset() > this.clone().month(5).utcOffset();
    }
    function isDaylightSavingTimeShifted() {
        if (!isUndefined(this._isDSTShifted)) return this._isDSTShifted;
        var c = {}, other;
        copyConfig(c, this);
        c = prepareConfig(c);
        if (c._a) {
            other = c._isUTC ? createUTC(c._a) : createLocal(c._a);
            this._isDSTShifted = this.isValid() && compareArrays(c._a, other.toArray()) > 0;
        } else this._isDSTShifted = false;
        return this._isDSTShifted;
    }
    function isLocal() {
        return this.isValid() ? !this._isUTC : false;
    }
    function isUtcOffset() {
        return this.isValid() ? this._isUTC : false;
    }
    function isUtc() {
        return this.isValid() ? this._isUTC && this._offset === 0 : false;
    }
    // ASP.NET json date format regex
    var aspNetRegex = /^(-|\+)?(?:(\d*)[. ])?(\d+):(\d+)(?::(\d+)(\.\d*)?)?$/, // from http://docs.closure-library.googlecode.com/git/closure_goog_date_date.js.source.html
    // somewhat more in line with 4.4.3.2 2004 spec, but allows decimal anywhere
    // and further modified to allow for strings containing both week and day
    isoRegex = /^(-|\+)?P(?:([-+]?[0-9,.]*)Y)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)W)?(?:([-+]?[0-9,.]*)D)?(?:T(?:([-+]?[0-9,.]*)H)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)S)?)?$/;
    function createDuration(input, key) {
        var duration = input, // matching against regexp is expensive, do it on demand
        match = null, sign, ret, diffRes;
        if (isDuration(input)) duration = {
            ms: input._milliseconds,
            d: input._days,
            M: input._months
        };
        else if (isNumber(input) || !isNaN(+input)) {
            duration = {};
            if (key) duration[key] = +input;
            else duration.milliseconds = +input;
        } else if (match = aspNetRegex.exec(input)) {
            sign = match[1] === "-" ? -1 : 1;
            duration = {
                y: 0,
                d: toInt(match[DATE]) * sign,
                h: toInt(match[HOUR]) * sign,
                m: toInt(match[MINUTE]) * sign,
                s: toInt(match[SECOND]) * sign,
                ms: toInt(absRound(match[MILLISECOND] * 1000)) * sign
            };
        } else if (match = isoRegex.exec(input)) {
            sign = match[1] === "-" ? -1 : 1;
            duration = {
                y: parseIso(match[2], sign),
                M: parseIso(match[3], sign),
                w: parseIso(match[4], sign),
                d: parseIso(match[5], sign),
                h: parseIso(match[6], sign),
                m: parseIso(match[7], sign),
                s: parseIso(match[8], sign)
            };
        } else if (duration == null) // checks for null or undefined
        duration = {};
        else if (typeof duration === "object" && ("from" in duration || "to" in duration)) {
            diffRes = momentsDifference(createLocal(duration.from), createLocal(duration.to));
            duration = {};
            duration.ms = diffRes.milliseconds;
            duration.M = diffRes.months;
        }
        ret = new Duration(duration);
        if (isDuration(input) && hasOwnProp(input, "_locale")) ret._locale = input._locale;
        if (isDuration(input) && hasOwnProp(input, "_isValid")) ret._isValid = input._isValid;
        return ret;
    }
    createDuration.fn = Duration.prototype;
    createDuration.invalid = createInvalid$1;
    function parseIso(inp, sign) {
        // We'd normally use ~~inp for this, but unfortunately it also
        // converts floats to ints.
        // inp may be undefined, so careful calling replace on it.
        var res = inp && parseFloat(inp.replace(",", "."));
        // apply sign while we're at it
        return (isNaN(res) ? 0 : res) * sign;
    }
    function positiveMomentsDifference(base, other) {
        var res = {};
        res.months = other.month() - base.month() + (other.year() - base.year()) * 12;
        if (base.clone().add(res.months, "M").isAfter(other)) --res.months;
        res.milliseconds = +other - +base.clone().add(res.months, "M");
        return res;
    }
    function momentsDifference(base, other) {
        var res;
        if (!(base.isValid() && other.isValid())) return {
            milliseconds: 0,
            months: 0
        };
        other = cloneWithOffset(other, base);
        if (base.isBefore(other)) res = positiveMomentsDifference(base, other);
        else {
            res = positiveMomentsDifference(other, base);
            res.milliseconds = -res.milliseconds;
            res.months = -res.months;
        }
        return res;
    }
    // TODO: remove 'name' arg after deprecation is removed
    function createAdder(direction, name) {
        return function(val, period) {
            var dur, tmp;
            //invert the arguments, but complain about it
            if (period !== null && !isNaN(+period)) {
                deprecateSimple(name, "moment()." + name + "(period, number) is deprecated. Please use moment()." + name + "(number, period). " + "See http://momentjs.com/guides/#/warnings/add-inverted-param/ for more info.");
                tmp = val;
                val = period;
                period = tmp;
            }
            dur = createDuration(val, period);
            addSubtract(this, dur, direction);
            return this;
        };
    }
    function addSubtract(mom, duration, isAdding, updateOffset) {
        var milliseconds = duration._milliseconds, days = absRound(duration._days), months = absRound(duration._months);
        if (!mom.isValid()) // No op
        return;
        updateOffset = updateOffset == null ? true : updateOffset;
        if (months) setMonth(mom, get(mom, "Month") + months * isAdding);
        if (days) set$1(mom, "Date", get(mom, "Date") + days * isAdding);
        if (milliseconds) mom._d.setTime(mom._d.valueOf() + milliseconds * isAdding);
        if (updateOffset) hooks.updateOffset(mom, days || months);
    }
    var add = createAdder(1, "add"), subtract = createAdder(-1, "subtract");
    function isString(input) {
        return typeof input === "string" || input instanceof String;
    }
    // type MomentInput = Moment | Date | string | number | (number | string)[] | MomentInputObject | void; // null | undefined
    function isMomentInput(input) {
        return isMoment(input) || isDate(input) || isString(input) || isNumber(input) || isNumberOrStringArray(input) || isMomentInputObject(input) || input === null || input === undefined;
    }
    function isMomentInputObject(input) {
        var objectTest = isObject(input) && !isObjectEmpty(input), propertyTest = false, properties = [
            "years",
            "year",
            "y",
            "months",
            "month",
            "M",
            "days",
            "day",
            "d",
            "dates",
            "date",
            "D",
            "hours",
            "hour",
            "h",
            "minutes",
            "minute",
            "m",
            "seconds",
            "second",
            "s",
            "milliseconds",
            "millisecond",
            "ms"
        ], i, property, propertyLen = properties.length;
        for(i = 0; i < propertyLen; i += 1){
            property = properties[i];
            propertyTest = propertyTest || hasOwnProp(input, property);
        }
        return objectTest && propertyTest;
    }
    function isNumberOrStringArray(input) {
        var arrayTest = isArray(input), dataTypeTest = false;
        if (arrayTest) dataTypeTest = input.filter(function(item) {
            return !isNumber(item) && isString(input);
        }).length === 0;
        return arrayTest && dataTypeTest;
    }
    function isCalendarSpec(input) {
        var objectTest = isObject(input) && !isObjectEmpty(input), propertyTest = false, properties = [
            "sameDay",
            "nextDay",
            "lastDay",
            "nextWeek",
            "lastWeek",
            "sameElse"
        ], i, property;
        for(i = 0; i < properties.length; i += 1){
            property = properties[i];
            propertyTest = propertyTest || hasOwnProp(input, property);
        }
        return objectTest && propertyTest;
    }
    function getCalendarFormat(myMoment, now) {
        var diff = myMoment.diff(now, "days", true);
        return diff < -6 ? "sameElse" : diff < -1 ? "lastWeek" : diff < 0 ? "lastDay" : diff < 1 ? "sameDay" : diff < 2 ? "nextDay" : diff < 7 ? "nextWeek" : "sameElse";
    }
    function calendar$1(time, formats) {
        // Support for single parameter, formats only overload to the calendar function
        if (arguments.length === 1) {
            if (!arguments[0]) {
                time = undefined;
                formats = undefined;
            } else if (isMomentInput(arguments[0])) {
                time = arguments[0];
                formats = undefined;
            } else if (isCalendarSpec(arguments[0])) {
                formats = arguments[0];
                time = undefined;
            }
        }
        // We want to compare the start of today, vs this.
        // Getting start-of-today depends on whether we're local/utc/offset or not.
        var now = time || createLocal(), sod = cloneWithOffset(now, this).startOf("day"), format = hooks.calendarFormat(this, sod) || "sameElse", output = formats && (isFunction(formats[format]) ? formats[format].call(this, now) : formats[format]);
        return this.format(output || this.localeData().calendar(format, this, createLocal(now)));
    }
    function clone() {
        return new Moment(this);
    }
    function isAfter(input, units) {
        var localInput = isMoment(input) ? input : createLocal(input);
        if (!(this.isValid() && localInput.isValid())) return false;
        units = normalizeUnits(units) || "millisecond";
        if (units === "millisecond") return this.valueOf() > localInput.valueOf();
        else return localInput.valueOf() < this.clone().startOf(units).valueOf();
    }
    function isBefore(input, units) {
        var localInput = isMoment(input) ? input : createLocal(input);
        if (!(this.isValid() && localInput.isValid())) return false;
        units = normalizeUnits(units) || "millisecond";
        if (units === "millisecond") return this.valueOf() < localInput.valueOf();
        else return this.clone().endOf(units).valueOf() < localInput.valueOf();
    }
    function isBetween(from, to, units, inclusivity) {
        var localFrom = isMoment(from) ? from : createLocal(from), localTo = isMoment(to) ? to : createLocal(to);
        if (!(this.isValid() && localFrom.isValid() && localTo.isValid())) return false;
        inclusivity = inclusivity || "()";
        return (inclusivity[0] === "(" ? this.isAfter(localFrom, units) : !this.isBefore(localFrom, units)) && (inclusivity[1] === ")" ? this.isBefore(localTo, units) : !this.isAfter(localTo, units));
    }
    function isSame(input, units) {
        var localInput = isMoment(input) ? input : createLocal(input), inputMs;
        if (!(this.isValid() && localInput.isValid())) return false;
        units = normalizeUnits(units) || "millisecond";
        if (units === "millisecond") return this.valueOf() === localInput.valueOf();
        else {
            inputMs = localInput.valueOf();
            return this.clone().startOf(units).valueOf() <= inputMs && inputMs <= this.clone().endOf(units).valueOf();
        }
    }
    function isSameOrAfter(input, units) {
        return this.isSame(input, units) || this.isAfter(input, units);
    }
    function isSameOrBefore(input, units) {
        return this.isSame(input, units) || this.isBefore(input, units);
    }
    function diff(input, units, asFloat) {
        var that, zoneDelta, output;
        if (!this.isValid()) return NaN;
        that = cloneWithOffset(input, this);
        if (!that.isValid()) return NaN;
        zoneDelta = (that.utcOffset() - this.utcOffset()) * 6e4;
        units = normalizeUnits(units);
        switch(units){
            case "year":
                output = monthDiff(this, that) / 12;
                break;
            case "month":
                output = monthDiff(this, that);
                break;
            case "quarter":
                output = monthDiff(this, that) / 3;
                break;
            case "second":
                output = (this - that) / 1e3;
                break; // 1000
            case "minute":
                output = (this - that) / 6e4;
                break; // 1000 * 60
            case "hour":
                output = (this - that) / 36e5;
                break; // 1000 * 60 * 60
            case "day":
                output = (this - that - zoneDelta) / 864e5;
                break; // 1000 * 60 * 60 * 24, negate dst
            case "week":
                output = (this - that - zoneDelta) / 6048e5;
                break; // 1000 * 60 * 60 * 24 * 7, negate dst
            default:
                output = this - that;
        }
        return asFloat ? output : absFloor(output);
    }
    function monthDiff(a, b) {
        if (a.date() < b.date()) // end-of-month calculations work correct when the start month has more
        // days than the end month.
        return -monthDiff(b, a);
        // difference in months
        var wholeMonthDiff = (b.year() - a.year()) * 12 + (b.month() - a.month()), // b is in (anchor - 1 month, anchor + 1 month)
        anchor = a.clone().add(wholeMonthDiff, "months"), anchor2, adjust;
        if (b - anchor < 0) {
            anchor2 = a.clone().add(wholeMonthDiff - 1, "months");
            // linear across the month
            adjust = (b - anchor) / (anchor - anchor2);
        } else {
            anchor2 = a.clone().add(wholeMonthDiff + 1, "months");
            // linear across the month
            adjust = (b - anchor) / (anchor2 - anchor);
        }
        //check for negative zero, return zero if negative zero
        return -(wholeMonthDiff + adjust) || 0;
    }
    hooks.defaultFormat = "YYYY-MM-DDTHH:mm:ssZ";
    hooks.defaultFormatUtc = "YYYY-MM-DDTHH:mm:ss[Z]";
    function toString() {
        return this.clone().locale("en").format("ddd MMM DD YYYY HH:mm:ss [GMT]ZZ");
    }
    function toISOString(keepOffset) {
        if (!this.isValid()) return null;
        var utc = keepOffset !== true, m = utc ? this.clone().utc() : this;
        if (m.year() < 0 || m.year() > 9999) return formatMoment(m, utc ? "YYYYYY-MM-DD[T]HH:mm:ss.SSS[Z]" : "YYYYYY-MM-DD[T]HH:mm:ss.SSSZ");
        if (isFunction(Date.prototype.toISOString)) {
            // native implementation is ~50x faster, use it when we can
            if (utc) return this.toDate().toISOString();
            else return new Date(this.valueOf() + this.utcOffset() * 60000).toISOString().replace("Z", formatMoment(m, "Z"));
        }
        return formatMoment(m, utc ? "YYYY-MM-DD[T]HH:mm:ss.SSS[Z]" : "YYYY-MM-DD[T]HH:mm:ss.SSSZ");
    }
    /**
     * Return a human readable representation of a moment that can
     * also be evaluated to get a new moment which is the same
     *
     * @link https://nodejs.org/dist/latest/docs/api/util.html#util_custom_inspect_function_on_objects
     */ function inspect() {
        if (!this.isValid()) return "moment.invalid(/* " + this._i + " */)";
        var func = "moment", zone = "", prefix, year, datetime, suffix;
        if (!this.isLocal()) {
            func = this.utcOffset() === 0 ? "moment.utc" : "moment.parseZone";
            zone = "Z";
        }
        prefix = "[" + func + '("]';
        year = 0 <= this.year() && this.year() <= 9999 ? "YYYY" : "YYYYYY";
        datetime = "-MM-DD[T]HH:mm:ss.SSS";
        suffix = zone + '[")]';
        return this.format(prefix + year + datetime + suffix);
    }
    function format(inputString) {
        if (!inputString) inputString = this.isUtc() ? hooks.defaultFormatUtc : hooks.defaultFormat;
        var output = formatMoment(this, inputString);
        return this.localeData().postformat(output);
    }
    function from(time, withoutSuffix) {
        if (this.isValid() && (isMoment(time) && time.isValid() || createLocal(time).isValid())) return createDuration({
            to: this,
            from: time
        }).locale(this.locale()).humanize(!withoutSuffix);
        else return this.localeData().invalidDate();
    }
    function fromNow(withoutSuffix) {
        return this.from(createLocal(), withoutSuffix);
    }
    function to(time, withoutSuffix) {
        if (this.isValid() && (isMoment(time) && time.isValid() || createLocal(time).isValid())) return createDuration({
            from: this,
            to: time
        }).locale(this.locale()).humanize(!withoutSuffix);
        else return this.localeData().invalidDate();
    }
    function toNow(withoutSuffix) {
        return this.to(createLocal(), withoutSuffix);
    }
    // If passed a locale key, it will set the locale for this
    // instance.  Otherwise, it will return the locale configuration
    // variables for this instance.
    function locale(key) {
        var newLocaleData;
        if (key === undefined) return this._locale._abbr;
        else {
            newLocaleData = getLocale(key);
            if (newLocaleData != null) this._locale = newLocaleData;
            return this;
        }
    }
    var lang = deprecate("moment().lang() is deprecated. Instead, use moment().localeData() to get the language configuration. Use moment().locale() to change languages.", function(key) {
        if (key === undefined) return this.localeData();
        else return this.locale(key);
    });
    function localeData() {
        return this._locale;
    }
    var MS_PER_SECOND = 1000, MS_PER_MINUTE = 60 * MS_PER_SECOND, MS_PER_HOUR = 60 * MS_PER_MINUTE, MS_PER_400_YEARS = 3506328 * MS_PER_HOUR;
    // actual modulo - handles negative numbers (for dates before 1970):
    function mod$1(dividend, divisor) {
        return (dividend % divisor + divisor) % divisor;
    }
    function localStartOfDate(y, m, d) {
        // the date constructor remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) // preserve leap years using a full 400 year cycle, then reset
        return new Date(y + 400, m, d) - MS_PER_400_YEARS;
        else return new Date(y, m, d).valueOf();
    }
    function utcStartOfDate(y, m, d) {
        // Date.UTC remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) // preserve leap years using a full 400 year cycle, then reset
        return Date.UTC(y + 400, m, d) - MS_PER_400_YEARS;
        else return Date.UTC(y, m, d);
    }
    function startOf(units) {
        var time, startOfDate;
        units = normalizeUnits(units);
        if (units === undefined || units === "millisecond" || !this.isValid()) return this;
        startOfDate = this._isUTC ? utcStartOfDate : localStartOfDate;
        switch(units){
            case "year":
                time = startOfDate(this.year(), 0, 1);
                break;
            case "quarter":
                time = startOfDate(this.year(), this.month() - this.month() % 3, 1);
                break;
            case "month":
                time = startOfDate(this.year(), this.month(), 1);
                break;
            case "week":
                time = startOfDate(this.year(), this.month(), this.date() - this.weekday());
                break;
            case "isoWeek":
                time = startOfDate(this.year(), this.month(), this.date() - (this.isoWeekday() - 1));
                break;
            case "day":
            case "date":
                time = startOfDate(this.year(), this.month(), this.date());
                break;
            case "hour":
                time = this._d.valueOf();
                time -= mod$1(time + (this._isUTC ? 0 : this.utcOffset() * MS_PER_MINUTE), MS_PER_HOUR);
                break;
            case "minute":
                time = this._d.valueOf();
                time -= mod$1(time, MS_PER_MINUTE);
                break;
            case "second":
                time = this._d.valueOf();
                time -= mod$1(time, MS_PER_SECOND);
                break;
        }
        this._d.setTime(time);
        hooks.updateOffset(this, true);
        return this;
    }
    function endOf(units) {
        var time, startOfDate;
        units = normalizeUnits(units);
        if (units === undefined || units === "millisecond" || !this.isValid()) return this;
        startOfDate = this._isUTC ? utcStartOfDate : localStartOfDate;
        switch(units){
            case "year":
                time = startOfDate(this.year() + 1, 0, 1) - 1;
                break;
            case "quarter":
                time = startOfDate(this.year(), this.month() - this.month() % 3 + 3, 1) - 1;
                break;
            case "month":
                time = startOfDate(this.year(), this.month() + 1, 1) - 1;
                break;
            case "week":
                time = startOfDate(this.year(), this.month(), this.date() - this.weekday() + 7) - 1;
                break;
            case "isoWeek":
                time = startOfDate(this.year(), this.month(), this.date() - (this.isoWeekday() - 1) + 7) - 1;
                break;
            case "day":
            case "date":
                time = startOfDate(this.year(), this.month(), this.date() + 1) - 1;
                break;
            case "hour":
                time = this._d.valueOf();
                time += MS_PER_HOUR - mod$1(time + (this._isUTC ? 0 : this.utcOffset() * MS_PER_MINUTE), MS_PER_HOUR) - 1;
                break;
            case "minute":
                time = this._d.valueOf();
                time += MS_PER_MINUTE - mod$1(time, MS_PER_MINUTE) - 1;
                break;
            case "second":
                time = this._d.valueOf();
                time += MS_PER_SECOND - mod$1(time, MS_PER_SECOND) - 1;
                break;
        }
        this._d.setTime(time);
        hooks.updateOffset(this, true);
        return this;
    }
    function valueOf() {
        return this._d.valueOf() - (this._offset || 0) * 60000;
    }
    function unix() {
        return Math.floor(this.valueOf() / 1000);
    }
    function toDate() {
        return new Date(this.valueOf());
    }
    function toArray() {
        var m = this;
        return [
            m.year(),
            m.month(),
            m.date(),
            m.hour(),
            m.minute(),
            m.second(),
            m.millisecond()
        ];
    }
    function toObject() {
        var m = this;
        return {
            years: m.year(),
            months: m.month(),
            date: m.date(),
            hours: m.hours(),
            minutes: m.minutes(),
            seconds: m.seconds(),
            milliseconds: m.milliseconds()
        };
    }
    function toJSON() {
        // new Date(NaN).toJSON() === null
        return this.isValid() ? this.toISOString() : null;
    }
    function isValid$2() {
        return isValid(this);
    }
    function parsingFlags() {
        return extend({}, getParsingFlags(this));
    }
    function invalidAt() {
        return getParsingFlags(this).overflow;
    }
    function creationData() {
        return {
            input: this._i,
            format: this._f,
            locale: this._locale,
            isUTC: this._isUTC,
            strict: this._strict
        };
    }
    addFormatToken("N", 0, 0, "eraAbbr");
    addFormatToken("NN", 0, 0, "eraAbbr");
    addFormatToken("NNN", 0, 0, "eraAbbr");
    addFormatToken("NNNN", 0, 0, "eraName");
    addFormatToken("NNNNN", 0, 0, "eraNarrow");
    addFormatToken("y", [
        "y",
        1
    ], "yo", "eraYear");
    addFormatToken("y", [
        "yy",
        2
    ], 0, "eraYear");
    addFormatToken("y", [
        "yyy",
        3
    ], 0, "eraYear");
    addFormatToken("y", [
        "yyyy",
        4
    ], 0, "eraYear");
    addRegexToken("N", matchEraAbbr);
    addRegexToken("NN", matchEraAbbr);
    addRegexToken("NNN", matchEraAbbr);
    addRegexToken("NNNN", matchEraName);
    addRegexToken("NNNNN", matchEraNarrow);
    addParseToken([
        "N",
        "NN",
        "NNN",
        "NNNN",
        "NNNNN"
    ], function(input, array, config, token) {
        var era = config._locale.erasParse(input, token, config._strict);
        if (era) getParsingFlags(config).era = era;
        else getParsingFlags(config).invalidEra = input;
    });
    addRegexToken("y", matchUnsigned);
    addRegexToken("yy", matchUnsigned);
    addRegexToken("yyy", matchUnsigned);
    addRegexToken("yyyy", matchUnsigned);
    addRegexToken("yo", matchEraYearOrdinal);
    addParseToken([
        "y",
        "yy",
        "yyy",
        "yyyy"
    ], YEAR);
    addParseToken([
        "yo"
    ], function(input, array, config, token) {
        var match;
        if (config._locale._eraYearOrdinalRegex) match = input.match(config._locale._eraYearOrdinalRegex);
        if (config._locale.eraYearOrdinalParse) array[YEAR] = config._locale.eraYearOrdinalParse(input, match);
        else array[YEAR] = parseInt(input, 10);
    });
    function localeEras(m, format) {
        var i, l, date, eras = this._eras || getLocale("en")._eras;
        for(i = 0, l = eras.length; i < l; ++i){
            switch(typeof eras[i].since){
                case "string":
                    // truncate time
                    date = hooks(eras[i].since).startOf("day");
                    eras[i].since = date.valueOf();
                    break;
            }
            switch(typeof eras[i].until){
                case "undefined":
                    eras[i].until = Infinity;
                    break;
                case "string":
                    // truncate time
                    date = hooks(eras[i].until).startOf("day").valueOf();
                    eras[i].until = date.valueOf();
                    break;
            }
        }
        return eras;
    }
    function localeErasParse(eraName, format, strict) {
        var i, l, eras = this.eras(), name, abbr, narrow;
        eraName = eraName.toUpperCase();
        for(i = 0, l = eras.length; i < l; ++i){
            name = eras[i].name.toUpperCase();
            abbr = eras[i].abbr.toUpperCase();
            narrow = eras[i].narrow.toUpperCase();
            if (strict) switch(format){
                case "N":
                case "NN":
                case "NNN":
                    if (abbr === eraName) return eras[i];
                    break;
                case "NNNN":
                    if (name === eraName) return eras[i];
                    break;
                case "NNNNN":
                    if (narrow === eraName) return eras[i];
                    break;
            }
            else if ([
                name,
                abbr,
                narrow
            ].indexOf(eraName) >= 0) return eras[i];
        }
    }
    function localeErasConvertYear(era, year) {
        var dir = era.since <= era.until ? 1 : -1;
        if (year === undefined) return hooks(era.since).year();
        else return hooks(era.since).year() + (year - era.offset) * dir;
    }
    function getEraName() {
        var i, l, val, eras = this.localeData().eras();
        for(i = 0, l = eras.length; i < l; ++i){
            // truncate time
            val = this.clone().startOf("day").valueOf();
            if (eras[i].since <= val && val <= eras[i].until) return eras[i].name;
            if (eras[i].until <= val && val <= eras[i].since) return eras[i].name;
        }
        return "";
    }
    function getEraNarrow() {
        var i, l, val, eras = this.localeData().eras();
        for(i = 0, l = eras.length; i < l; ++i){
            // truncate time
            val = this.clone().startOf("day").valueOf();
            if (eras[i].since <= val && val <= eras[i].until) return eras[i].narrow;
            if (eras[i].until <= val && val <= eras[i].since) return eras[i].narrow;
        }
        return "";
    }
    function getEraAbbr() {
        var i, l, val, eras = this.localeData().eras();
        for(i = 0, l = eras.length; i < l; ++i){
            // truncate time
            val = this.clone().startOf("day").valueOf();
            if (eras[i].since <= val && val <= eras[i].until) return eras[i].abbr;
            if (eras[i].until <= val && val <= eras[i].since) return eras[i].abbr;
        }
        return "";
    }
    function getEraYear() {
        var i, l, dir, val, eras = this.localeData().eras();
        for(i = 0, l = eras.length; i < l; ++i){
            dir = eras[i].since <= eras[i].until ? 1 : -1;
            // truncate time
            val = this.clone().startOf("day").valueOf();
            if (eras[i].since <= val && val <= eras[i].until || eras[i].until <= val && val <= eras[i].since) return (this.year() - hooks(eras[i].since).year()) * dir + eras[i].offset;
        }
        return this.year();
    }
    function erasNameRegex(isStrict) {
        if (!hasOwnProp(this, "_erasNameRegex")) computeErasParse.call(this);
        return isStrict ? this._erasNameRegex : this._erasRegex;
    }
    function erasAbbrRegex(isStrict) {
        if (!hasOwnProp(this, "_erasAbbrRegex")) computeErasParse.call(this);
        return isStrict ? this._erasAbbrRegex : this._erasRegex;
    }
    function erasNarrowRegex(isStrict) {
        if (!hasOwnProp(this, "_erasNarrowRegex")) computeErasParse.call(this);
        return isStrict ? this._erasNarrowRegex : this._erasRegex;
    }
    function matchEraAbbr(isStrict, locale) {
        return locale.erasAbbrRegex(isStrict);
    }
    function matchEraName(isStrict, locale) {
        return locale.erasNameRegex(isStrict);
    }
    function matchEraNarrow(isStrict, locale) {
        return locale.erasNarrowRegex(isStrict);
    }
    function matchEraYearOrdinal(isStrict, locale) {
        return locale._eraYearOrdinalRegex || matchUnsigned;
    }
    function computeErasParse() {
        var abbrPieces = [], namePieces = [], narrowPieces = [], mixedPieces = [], i, l, eras = this.eras();
        for(i = 0, l = eras.length; i < l; ++i){
            namePieces.push(regexEscape(eras[i].name));
            abbrPieces.push(regexEscape(eras[i].abbr));
            narrowPieces.push(regexEscape(eras[i].narrow));
            mixedPieces.push(regexEscape(eras[i].name));
            mixedPieces.push(regexEscape(eras[i].abbr));
            mixedPieces.push(regexEscape(eras[i].narrow));
        }
        this._erasRegex = new RegExp("^(" + mixedPieces.join("|") + ")", "i");
        this._erasNameRegex = new RegExp("^(" + namePieces.join("|") + ")", "i");
        this._erasAbbrRegex = new RegExp("^(" + abbrPieces.join("|") + ")", "i");
        this._erasNarrowRegex = new RegExp("^(" + narrowPieces.join("|") + ")", "i");
    }
    // FORMATTING
    addFormatToken(0, [
        "gg",
        2
    ], 0, function() {
        return this.weekYear() % 100;
    });
    addFormatToken(0, [
        "GG",
        2
    ], 0, function() {
        return this.isoWeekYear() % 100;
    });
    function addWeekYearFormatToken(token, getter) {
        addFormatToken(0, [
            token,
            token.length
        ], 0, getter);
    }
    addWeekYearFormatToken("gggg", "weekYear");
    addWeekYearFormatToken("ggggg", "weekYear");
    addWeekYearFormatToken("GGGG", "isoWeekYear");
    addWeekYearFormatToken("GGGGG", "isoWeekYear");
    // ALIASES
    addUnitAlias("weekYear", "gg");
    addUnitAlias("isoWeekYear", "GG");
    // PRIORITY
    addUnitPriority("weekYear", 1);
    addUnitPriority("isoWeekYear", 1);
    // PARSING
    addRegexToken("G", matchSigned);
    addRegexToken("g", matchSigned);
    addRegexToken("GG", match1to2, match2);
    addRegexToken("gg", match1to2, match2);
    addRegexToken("GGGG", match1to4, match4);
    addRegexToken("gggg", match1to4, match4);
    addRegexToken("GGGGG", match1to6, match6);
    addRegexToken("ggggg", match1to6, match6);
    addWeekParseToken([
        "gggg",
        "ggggg",
        "GGGG",
        "GGGGG"
    ], function(input, week, config, token) {
        week[token.substr(0, 2)] = toInt(input);
    });
    addWeekParseToken([
        "gg",
        "GG"
    ], function(input, week, config, token) {
        week[token] = hooks.parseTwoDigitYear(input);
    });
    // MOMENTS
    function getSetWeekYear(input) {
        return getSetWeekYearHelper.call(this, input, this.week(), this.weekday(), this.localeData()._week.dow, this.localeData()._week.doy);
    }
    function getSetISOWeekYear(input) {
        return getSetWeekYearHelper.call(this, input, this.isoWeek(), this.isoWeekday(), 1, 4);
    }
    function getISOWeeksInYear() {
        return weeksInYear(this.year(), 1, 4);
    }
    function getISOWeeksInISOWeekYear() {
        return weeksInYear(this.isoWeekYear(), 1, 4);
    }
    function getWeeksInYear() {
        var weekInfo = this.localeData()._week;
        return weeksInYear(this.year(), weekInfo.dow, weekInfo.doy);
    }
    function getWeeksInWeekYear() {
        var weekInfo = this.localeData()._week;
        return weeksInYear(this.weekYear(), weekInfo.dow, weekInfo.doy);
    }
    function getSetWeekYearHelper(input, week, weekday, dow, doy) {
        var weeksTarget;
        if (input == null) return weekOfYear(this, dow, doy).year;
        else {
            weeksTarget = weeksInYear(input, dow, doy);
            if (week > weeksTarget) week = weeksTarget;
            return setWeekAll.call(this, input, week, weekday, dow, doy);
        }
    }
    function setWeekAll(weekYear, week, weekday, dow, doy) {
        var dayOfYearData = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy), date = createUTCDate(dayOfYearData.year, 0, dayOfYearData.dayOfYear);
        this.year(date.getUTCFullYear());
        this.month(date.getUTCMonth());
        this.date(date.getUTCDate());
        return this;
    }
    // FORMATTING
    addFormatToken("Q", 0, "Qo", "quarter");
    // ALIASES
    addUnitAlias("quarter", "Q");
    // PRIORITY
    addUnitPriority("quarter", 7);
    // PARSING
    addRegexToken("Q", match1);
    addParseToken("Q", function(input, array) {
        array[MONTH] = (toInt(input) - 1) * 3;
    });
    // MOMENTS
    function getSetQuarter(input) {
        return input == null ? Math.ceil((this.month() + 1) / 3) : this.month((input - 1) * 3 + this.month() % 3);
    }
    // FORMATTING
    addFormatToken("D", [
        "DD",
        2
    ], "Do", "date");
    // ALIASES
    addUnitAlias("date", "D");
    // PRIORITY
    addUnitPriority("date", 9);
    // PARSING
    addRegexToken("D", match1to2);
    addRegexToken("DD", match1to2, match2);
    addRegexToken("Do", function(isStrict, locale) {
        // TODO: Remove "ordinalParse" fallback in next major release.
        return isStrict ? locale._dayOfMonthOrdinalParse || locale._ordinalParse : locale._dayOfMonthOrdinalParseLenient;
    });
    addParseToken([
        "D",
        "DD"
    ], DATE);
    addParseToken("Do", function(input, array) {
        array[DATE] = toInt(input.match(match1to2)[0]);
    });
    // MOMENTS
    var getSetDayOfMonth = makeGetSet("Date", true);
    // FORMATTING
    addFormatToken("DDD", [
        "DDDD",
        3
    ], "DDDo", "dayOfYear");
    // ALIASES
    addUnitAlias("dayOfYear", "DDD");
    // PRIORITY
    addUnitPriority("dayOfYear", 4);
    // PARSING
    addRegexToken("DDD", match1to3);
    addRegexToken("DDDD", match3);
    addParseToken([
        "DDD",
        "DDDD"
    ], function(input, array, config) {
        config._dayOfYear = toInt(input);
    });
    // HELPERS
    // MOMENTS
    function getSetDayOfYear(input) {
        var dayOfYear = Math.round((this.clone().startOf("day") - this.clone().startOf("year")) / 864e5) + 1;
        return input == null ? dayOfYear : this.add(input - dayOfYear, "d");
    }
    // FORMATTING
    addFormatToken("m", [
        "mm",
        2
    ], 0, "minute");
    // ALIASES
    addUnitAlias("minute", "m");
    // PRIORITY
    addUnitPriority("minute", 14);
    // PARSING
    addRegexToken("m", match1to2);
    addRegexToken("mm", match1to2, match2);
    addParseToken([
        "m",
        "mm"
    ], MINUTE);
    // MOMENTS
    var getSetMinute = makeGetSet("Minutes", false);
    // FORMATTING
    addFormatToken("s", [
        "ss",
        2
    ], 0, "second");
    // ALIASES
    addUnitAlias("second", "s");
    // PRIORITY
    addUnitPriority("second", 15);
    // PARSING
    addRegexToken("s", match1to2);
    addRegexToken("ss", match1to2, match2);
    addParseToken([
        "s",
        "ss"
    ], SECOND);
    // MOMENTS
    var getSetSecond = makeGetSet("Seconds", false);
    // FORMATTING
    addFormatToken("S", 0, 0, function() {
        return ~~(this.millisecond() / 100);
    });
    addFormatToken(0, [
        "SS",
        2
    ], 0, function() {
        return ~~(this.millisecond() / 10);
    });
    addFormatToken(0, [
        "SSS",
        3
    ], 0, "millisecond");
    addFormatToken(0, [
        "SSSS",
        4
    ], 0, function() {
        return this.millisecond() * 10;
    });
    addFormatToken(0, [
        "SSSSS",
        5
    ], 0, function() {
        return this.millisecond() * 100;
    });
    addFormatToken(0, [
        "SSSSSS",
        6
    ], 0, function() {
        return this.millisecond() * 1000;
    });
    addFormatToken(0, [
        "SSSSSSS",
        7
    ], 0, function() {
        return this.millisecond() * 10000;
    });
    addFormatToken(0, [
        "SSSSSSSS",
        8
    ], 0, function() {
        return this.millisecond() * 100000;
    });
    addFormatToken(0, [
        "SSSSSSSSS",
        9
    ], 0, function() {
        return this.millisecond() * 1000000;
    });
    // ALIASES
    addUnitAlias("millisecond", "ms");
    // PRIORITY
    addUnitPriority("millisecond", 16);
    // PARSING
    addRegexToken("S", match1to3, match1);
    addRegexToken("SS", match1to3, match2);
    addRegexToken("SSS", match1to3, match3);
    var token, getSetMillisecond;
    for(token = "SSSS"; token.length <= 9; token += "S")addRegexToken(token, matchUnsigned);
    function parseMs(input, array) {
        array[MILLISECOND] = toInt(("0." + input) * 1000);
    }
    for(token = "S"; token.length <= 9; token += "S")addParseToken(token, parseMs);
    getSetMillisecond = makeGetSet("Milliseconds", false);
    // FORMATTING
    addFormatToken("z", 0, 0, "zoneAbbr");
    addFormatToken("zz", 0, 0, "zoneName");
    // MOMENTS
    function getZoneAbbr() {
        return this._isUTC ? "UTC" : "";
    }
    function getZoneName() {
        return this._isUTC ? "Coordinated Universal Time" : "";
    }
    var proto = Moment.prototype;
    proto.add = add;
    proto.calendar = calendar$1;
    proto.clone = clone;
    proto.diff = diff;
    proto.endOf = endOf;
    proto.format = format;
    proto.from = from;
    proto.fromNow = fromNow;
    proto.to = to;
    proto.toNow = toNow;
    proto.get = stringGet;
    proto.invalidAt = invalidAt;
    proto.isAfter = isAfter;
    proto.isBefore = isBefore;
    proto.isBetween = isBetween;
    proto.isSame = isSame;
    proto.isSameOrAfter = isSameOrAfter;
    proto.isSameOrBefore = isSameOrBefore;
    proto.isValid = isValid$2;
    proto.lang = lang;
    proto.locale = locale;
    proto.localeData = localeData;
    proto.max = prototypeMax;
    proto.min = prototypeMin;
    proto.parsingFlags = parsingFlags;
    proto.set = stringSet;
    proto.startOf = startOf;
    proto.subtract = subtract;
    proto.toArray = toArray;
    proto.toObject = toObject;
    proto.toDate = toDate;
    proto.toISOString = toISOString;
    proto.inspect = inspect;
    if (typeof Symbol !== "undefined" && Symbol.for != null) proto[Symbol.for("nodejs.util.inspect.custom")] = function() {
        return "Moment<" + this.format() + ">";
    };
    proto.toJSON = toJSON;
    proto.toString = toString;
    proto.unix = unix;
    proto.valueOf = valueOf;
    proto.creationData = creationData;
    proto.eraName = getEraName;
    proto.eraNarrow = getEraNarrow;
    proto.eraAbbr = getEraAbbr;
    proto.eraYear = getEraYear;
    proto.year = getSetYear;
    proto.isLeapYear = getIsLeapYear;
    proto.weekYear = getSetWeekYear;
    proto.isoWeekYear = getSetISOWeekYear;
    proto.quarter = proto.quarters = getSetQuarter;
    proto.month = getSetMonth;
    proto.daysInMonth = getDaysInMonth;
    proto.week = proto.weeks = getSetWeek;
    proto.isoWeek = proto.isoWeeks = getSetISOWeek;
    proto.weeksInYear = getWeeksInYear;
    proto.weeksInWeekYear = getWeeksInWeekYear;
    proto.isoWeeksInYear = getISOWeeksInYear;
    proto.isoWeeksInISOWeekYear = getISOWeeksInISOWeekYear;
    proto.date = getSetDayOfMonth;
    proto.day = proto.days = getSetDayOfWeek;
    proto.weekday = getSetLocaleDayOfWeek;
    proto.isoWeekday = getSetISODayOfWeek;
    proto.dayOfYear = getSetDayOfYear;
    proto.hour = proto.hours = getSetHour;
    proto.minute = proto.minutes = getSetMinute;
    proto.second = proto.seconds = getSetSecond;
    proto.millisecond = proto.milliseconds = getSetMillisecond;
    proto.utcOffset = getSetOffset;
    proto.utc = setOffsetToUTC;
    proto.local = setOffsetToLocal;
    proto.parseZone = setOffsetToParsedOffset;
    proto.hasAlignedHourOffset = hasAlignedHourOffset;
    proto.isDST = isDaylightSavingTime;
    proto.isLocal = isLocal;
    proto.isUtcOffset = isUtcOffset;
    proto.isUtc = isUtc;
    proto.isUTC = isUtc;
    proto.zoneAbbr = getZoneAbbr;
    proto.zoneName = getZoneName;
    proto.dates = deprecate("dates accessor is deprecated. Use date instead.", getSetDayOfMonth);
    proto.months = deprecate("months accessor is deprecated. Use month instead", getSetMonth);
    proto.years = deprecate("years accessor is deprecated. Use year instead", getSetYear);
    proto.zone = deprecate("moment().zone is deprecated, use moment().utcOffset instead. http://momentjs.com/guides/#/warnings/zone/", getSetZone);
    proto.isDSTShifted = deprecate("isDSTShifted is deprecated. See http://momentjs.com/guides/#/warnings/dst-shifted/ for more information", isDaylightSavingTimeShifted);
    function createUnix(input) {
        return createLocal(input * 1000);
    }
    function createInZone() {
        return createLocal.apply(null, arguments).parseZone();
    }
    function preParsePostFormat(string) {
        return string;
    }
    var proto$1 = Locale.prototype;
    proto$1.calendar = calendar;
    proto$1.longDateFormat = longDateFormat;
    proto$1.invalidDate = invalidDate;
    proto$1.ordinal = ordinal;
    proto$1.preparse = preParsePostFormat;
    proto$1.postformat = preParsePostFormat;
    proto$1.relativeTime = relativeTime;
    proto$1.pastFuture = pastFuture;
    proto$1.set = set;
    proto$1.eras = localeEras;
    proto$1.erasParse = localeErasParse;
    proto$1.erasConvertYear = localeErasConvertYear;
    proto$1.erasAbbrRegex = erasAbbrRegex;
    proto$1.erasNameRegex = erasNameRegex;
    proto$1.erasNarrowRegex = erasNarrowRegex;
    proto$1.months = localeMonths;
    proto$1.monthsShort = localeMonthsShort;
    proto$1.monthsParse = localeMonthsParse;
    proto$1.monthsRegex = monthsRegex;
    proto$1.monthsShortRegex = monthsShortRegex;
    proto$1.week = localeWeek;
    proto$1.firstDayOfYear = localeFirstDayOfYear;
    proto$1.firstDayOfWeek = localeFirstDayOfWeek;
    proto$1.weekdays = localeWeekdays;
    proto$1.weekdaysMin = localeWeekdaysMin;
    proto$1.weekdaysShort = localeWeekdaysShort;
    proto$1.weekdaysParse = localeWeekdaysParse;
    proto$1.weekdaysRegex = weekdaysRegex;
    proto$1.weekdaysShortRegex = weekdaysShortRegex;
    proto$1.weekdaysMinRegex = weekdaysMinRegex;
    proto$1.isPM = localeIsPM;
    proto$1.meridiem = localeMeridiem;
    function get$1(format, index, field, setter) {
        var locale = getLocale(), utc = createUTC().set(setter, index);
        return locale[field](utc, format);
    }
    function listMonthsImpl(format, index, field) {
        if (isNumber(format)) {
            index = format;
            format = undefined;
        }
        format = format || "";
        if (index != null) return get$1(format, index, field, "month");
        var i, out = [];
        for(i = 0; i < 12; i++)out[i] = get$1(format, i, field, "month");
        return out;
    }
    // ()
    // (5)
    // (fmt, 5)
    // (fmt)
    // (true)
    // (true, 5)
    // (true, fmt, 5)
    // (true, fmt)
    function listWeekdaysImpl(localeSorted, format, index, field) {
        if (typeof localeSorted === "boolean") {
            if (isNumber(format)) {
                index = format;
                format = undefined;
            }
            format = format || "";
        } else {
            format = localeSorted;
            index = format;
            localeSorted = false;
            if (isNumber(format)) {
                index = format;
                format = undefined;
            }
            format = format || "";
        }
        var locale = getLocale(), shift = localeSorted ? locale._week.dow : 0, i, out = [];
        if (index != null) return get$1(format, (index + shift) % 7, field, "day");
        for(i = 0; i < 7; i++)out[i] = get$1(format, (i + shift) % 7, field, "day");
        return out;
    }
    function listMonths(format, index) {
        return listMonthsImpl(format, index, "months");
    }
    function listMonthsShort(format, index) {
        return listMonthsImpl(format, index, "monthsShort");
    }
    function listWeekdays(localeSorted, format, index) {
        return listWeekdaysImpl(localeSorted, format, index, "weekdays");
    }
    function listWeekdaysShort(localeSorted, format, index) {
        return listWeekdaysImpl(localeSorted, format, index, "weekdaysShort");
    }
    function listWeekdaysMin(localeSorted, format, index) {
        return listWeekdaysImpl(localeSorted, format, index, "weekdaysMin");
    }
    getSetGlobalLocale("en", {
        eras: [
            {
                since: "0001-01-01",
                until: Infinity,
                offset: 1,
                name: "Anno Domini",
                narrow: "AD",
                abbr: "AD"
            },
            {
                since: "0000-12-31",
                until: -Infinity,
                offset: 1,
                name: "Before Christ",
                narrow: "BC",
                abbr: "BC"
            }
        ],
        dayOfMonthOrdinalParse: /\d{1,2}(th|st|nd|rd)/,
        ordinal: function(number) {
            var b = number % 10, output = toInt(number % 100 / 10) === 1 ? "th" : b === 1 ? "st" : b === 2 ? "nd" : b === 3 ? "rd" : "th";
            return number + output;
        }
    });
    // Side effect imports
    hooks.lang = deprecate("moment.lang is deprecated. Use moment.locale instead.", getSetGlobalLocale);
    hooks.langData = deprecate("moment.langData is deprecated. Use moment.localeData instead.", getLocale);
    var mathAbs = Math.abs;
    function abs() {
        var data = this._data;
        this._milliseconds = mathAbs(this._milliseconds);
        this._days = mathAbs(this._days);
        this._months = mathAbs(this._months);
        data.milliseconds = mathAbs(data.milliseconds);
        data.seconds = mathAbs(data.seconds);
        data.minutes = mathAbs(data.minutes);
        data.hours = mathAbs(data.hours);
        data.months = mathAbs(data.months);
        data.years = mathAbs(data.years);
        return this;
    }
    function addSubtract$1(duration, input, value, direction) {
        var other = createDuration(input, value);
        duration._milliseconds += direction * other._milliseconds;
        duration._days += direction * other._days;
        duration._months += direction * other._months;
        return duration._bubble();
    }
    // supports only 2.0-style add(1, 's') or add(duration)
    function add$1(input, value) {
        return addSubtract$1(this, input, value, 1);
    }
    // supports only 2.0-style subtract(1, 's') or subtract(duration)
    function subtract$1(input, value) {
        return addSubtract$1(this, input, value, -1);
    }
    function absCeil(number) {
        if (number < 0) return Math.floor(number);
        else return Math.ceil(number);
    }
    function bubble() {
        var milliseconds = this._milliseconds, days = this._days, months = this._months, data = this._data, seconds, minutes, hours, years, monthsFromDays;
        // if we have a mix of positive and negative values, bubble down first
        // check: https://github.com/moment/moment/issues/2166
        if (!(milliseconds >= 0 && days >= 0 && months >= 0 || milliseconds <= 0 && days <= 0 && months <= 0)) {
            milliseconds += absCeil(monthsToDays(months) + days) * 864e5;
            days = 0;
            months = 0;
        }
        // The following code bubbles up values, see the tests for
        // examples of what that means.
        data.milliseconds = milliseconds % 1000;
        seconds = absFloor(milliseconds / 1000);
        data.seconds = seconds % 60;
        minutes = absFloor(seconds / 60);
        data.minutes = minutes % 60;
        hours = absFloor(minutes / 60);
        data.hours = hours % 24;
        days += absFloor(hours / 24);
        // convert days to months
        monthsFromDays = absFloor(daysToMonths(days));
        months += monthsFromDays;
        days -= absCeil(monthsToDays(monthsFromDays));
        // 12 months -> 1 year
        years = absFloor(months / 12);
        months %= 12;
        data.days = days;
        data.months = months;
        data.years = years;
        return this;
    }
    function daysToMonths(days) {
        // 400 years have 146097 days (taking into account leap year rules)
        // 400 years have 12 months === 4800
        return days * 4800 / 146097;
    }
    function monthsToDays(months) {
        // the reverse of daysToMonths
        return months * 146097 / 4800;
    }
    function as(units) {
        if (!this.isValid()) return NaN;
        var days, months, milliseconds = this._milliseconds;
        units = normalizeUnits(units);
        if (units === "month" || units === "quarter" || units === "year") {
            days = this._days + milliseconds / 864e5;
            months = this._months + daysToMonths(days);
            switch(units){
                case "month":
                    return months;
                case "quarter":
                    return months / 3;
                case "year":
                    return months / 12;
            }
        } else {
            // handle milliseconds separately because of floating point math errors (issue #1867)
            days = this._days + Math.round(monthsToDays(this._months));
            switch(units){
                case "week":
                    return days / 7 + milliseconds / 6048e5;
                case "day":
                    return days + milliseconds / 864e5;
                case "hour":
                    return days * 24 + milliseconds / 36e5;
                case "minute":
                    return days * 1440 + milliseconds / 6e4;
                case "second":
                    return days * 86400 + milliseconds / 1000;
                // Math.floor prevents floating point math errors here
                case "millisecond":
                    return Math.floor(days * 864e5) + milliseconds;
                default:
                    throw new Error("Unknown unit " + units);
            }
        }
    }
    // TODO: Use this.as('ms')?
    function valueOf$1() {
        if (!this.isValid()) return NaN;
        return this._milliseconds + this._days * 864e5 + this._months % 12 * 2592e6 + toInt(this._months / 12) * 31536e6;
    }
    function makeAs(alias) {
        return function() {
            return this.as(alias);
        };
    }
    var asMilliseconds = makeAs("ms"), asSeconds = makeAs("s"), asMinutes = makeAs("m"), asHours = makeAs("h"), asDays = makeAs("d"), asWeeks = makeAs("w"), asMonths = makeAs("M"), asQuarters = makeAs("Q"), asYears = makeAs("y");
    function clone$1() {
        return createDuration(this);
    }
    function get$2(units) {
        units = normalizeUnits(units);
        return this.isValid() ? this[units + "s"]() : NaN;
    }
    function makeGetter(name) {
        return function() {
            return this.isValid() ? this._data[name] : NaN;
        };
    }
    var milliseconds = makeGetter("milliseconds"), seconds = makeGetter("seconds"), minutes = makeGetter("minutes"), hours = makeGetter("hours"), days = makeGetter("days"), months = makeGetter("months"), years = makeGetter("years");
    function weeks() {
        return absFloor(this.days() / 7);
    }
    var round = Math.round, thresholds = {
        ss: 44,
        s: 45,
        m: 45,
        h: 22,
        d: 26,
        w: null,
        M: 11
    };
    // helper function for moment.fn.from, moment.fn.fromNow, and moment.duration.fn.humanize
    function substituteTimeAgo(string, number, withoutSuffix, isFuture, locale) {
        return locale.relativeTime(number || 1, !!withoutSuffix, string, isFuture);
    }
    function relativeTime$1(posNegDuration, withoutSuffix, thresholds, locale) {
        var duration = createDuration(posNegDuration).abs(), seconds = round(duration.as("s")), minutes = round(duration.as("m")), hours = round(duration.as("h")), days = round(duration.as("d")), months = round(duration.as("M")), weeks = round(duration.as("w")), years = round(duration.as("y")), a = seconds <= thresholds.ss && [
            "s",
            seconds
        ] || seconds < thresholds.s && [
            "ss",
            seconds
        ] || minutes <= 1 && [
            "m"
        ] || minutes < thresholds.m && [
            "mm",
            minutes
        ] || hours <= 1 && [
            "h"
        ] || hours < thresholds.h && [
            "hh",
            hours
        ] || days <= 1 && [
            "d"
        ] || days < thresholds.d && [
            "dd",
            days
        ];
        if (thresholds.w != null) a = a || weeks <= 1 && [
            "w"
        ] || weeks < thresholds.w && [
            "ww",
            weeks
        ];
        a = a || months <= 1 && [
            "M"
        ] || months < thresholds.M && [
            "MM",
            months
        ] || years <= 1 && [
            "y"
        ] || [
            "yy",
            years
        ];
        a[2] = withoutSuffix;
        a[3] = +posNegDuration > 0;
        a[4] = locale;
        return substituteTimeAgo.apply(null, a);
    }
    // This function allows you to set the rounding function for relative time strings
    function getSetRelativeTimeRounding(roundingFunction) {
        if (roundingFunction === undefined) return round;
        if (typeof roundingFunction === "function") {
            round = roundingFunction;
            return true;
        }
        return false;
    }
    // This function allows you to set a threshold for relative time strings
    function getSetRelativeTimeThreshold(threshold, limit) {
        if (thresholds[threshold] === undefined) return false;
        if (limit === undefined) return thresholds[threshold];
        thresholds[threshold] = limit;
        if (threshold === "s") thresholds.ss = limit - 1;
        return true;
    }
    function humanize(argWithSuffix, argThresholds) {
        if (!this.isValid()) return this.localeData().invalidDate();
        var withSuffix = false, th = thresholds, locale, output;
        if (typeof argWithSuffix === "object") {
            argThresholds = argWithSuffix;
            argWithSuffix = false;
        }
        if (typeof argWithSuffix === "boolean") withSuffix = argWithSuffix;
        if (typeof argThresholds === "object") {
            th = Object.assign({}, thresholds, argThresholds);
            if (argThresholds.s != null && argThresholds.ss == null) th.ss = argThresholds.s - 1;
        }
        locale = this.localeData();
        output = relativeTime$1(this, !withSuffix, th, locale);
        if (withSuffix) output = locale.pastFuture(+this, output);
        return locale.postformat(output);
    }
    var abs$1 = Math.abs;
    function sign(x) {
        return (x > 0) - (x < 0) || +x;
    }
    function toISOString$1() {
        // for ISO strings we do not use the normal bubbling rules:
        //  * milliseconds bubble up until they become hours
        //  * days do not bubble at all
        //  * months bubble up until they become years
        // This is because there is no context-free conversion between hours and days
        // (think of clock changes)
        // and also not between days and months (28-31 days per month)
        if (!this.isValid()) return this.localeData().invalidDate();
        var seconds = abs$1(this._milliseconds) / 1000, days = abs$1(this._days), months = abs$1(this._months), minutes, hours, years, s, total = this.asSeconds(), totalSign, ymSign, daysSign, hmsSign;
        if (!total) // this is the same as C#'s (Noda) and python (isodate)...
        // but not other JS (goog.date)
        return "P0D";
        // 3600 seconds -> 60 minutes -> 1 hour
        minutes = absFloor(seconds / 60);
        hours = absFloor(minutes / 60);
        seconds %= 60;
        minutes %= 60;
        // 12 months -> 1 year
        years = absFloor(months / 12);
        months %= 12;
        // inspired by https://github.com/dordille/moment-isoduration/blob/master/moment.isoduration.js
        s = seconds ? seconds.toFixed(3).replace(/\.?0+$/, "") : "";
        totalSign = total < 0 ? "-" : "";
        ymSign = sign(this._months) !== sign(total) ? "-" : "";
        daysSign = sign(this._days) !== sign(total) ? "-" : "";
        hmsSign = sign(this._milliseconds) !== sign(total) ? "-" : "";
        return totalSign + "P" + (years ? ymSign + years + "Y" : "") + (months ? ymSign + months + "M" : "") + (days ? daysSign + days + "D" : "") + (hours || minutes || seconds ? "T" : "") + (hours ? hmsSign + hours + "H" : "") + (minutes ? hmsSign + minutes + "M" : "") + (seconds ? hmsSign + s + "S" : "");
    }
    var proto$2 = Duration.prototype;
    proto$2.isValid = isValid$1;
    proto$2.abs = abs;
    proto$2.add = add$1;
    proto$2.subtract = subtract$1;
    proto$2.as = as;
    proto$2.asMilliseconds = asMilliseconds;
    proto$2.asSeconds = asSeconds;
    proto$2.asMinutes = asMinutes;
    proto$2.asHours = asHours;
    proto$2.asDays = asDays;
    proto$2.asWeeks = asWeeks;
    proto$2.asMonths = asMonths;
    proto$2.asQuarters = asQuarters;
    proto$2.asYears = asYears;
    proto$2.valueOf = valueOf$1;
    proto$2._bubble = bubble;
    proto$2.clone = clone$1;
    proto$2.get = get$2;
    proto$2.milliseconds = milliseconds;
    proto$2.seconds = seconds;
    proto$2.minutes = minutes;
    proto$2.hours = hours;
    proto$2.days = days;
    proto$2.weeks = weeks;
    proto$2.months = months;
    proto$2.years = years;
    proto$2.humanize = humanize;
    proto$2.toISOString = toISOString$1;
    proto$2.toString = toISOString$1;
    proto$2.toJSON = toISOString$1;
    proto$2.locale = locale;
    proto$2.localeData = localeData;
    proto$2.toIsoString = deprecate("toIsoString() is deprecated. Please use toISOString() instead (notice the capitals)", toISOString$1);
    proto$2.lang = lang;
    // FORMATTING
    addFormatToken("X", 0, 0, "unix");
    addFormatToken("x", 0, 0, "valueOf");
    // PARSING
    addRegexToken("x", matchSigned);
    addRegexToken("X", matchTimestamp);
    addParseToken("X", function(input, array, config) {
        config._d = new Date(parseFloat(input) * 1000);
    });
    addParseToken("x", function(input, array, config) {
        config._d = new Date(toInt(input));
    });
    //! moment.js
    hooks.version = "2.29.4";
    setHookCallback(createLocal);
    hooks.fn = proto;
    hooks.min = min;
    hooks.max = max;
    hooks.now = now;
    hooks.utc = createUTC;
    hooks.unix = createUnix;
    hooks.months = listMonths;
    hooks.isDate = isDate;
    hooks.locale = getSetGlobalLocale;
    hooks.invalid = createInvalid;
    hooks.duration = createDuration;
    hooks.isMoment = isMoment;
    hooks.weekdays = listWeekdays;
    hooks.parseZone = createInZone;
    hooks.localeData = getLocale;
    hooks.isDuration = isDuration;
    hooks.monthsShort = listMonthsShort;
    hooks.weekdaysMin = listWeekdaysMin;
    hooks.defineLocale = defineLocale;
    hooks.updateLocale = updateLocale;
    hooks.locales = listLocales;
    hooks.weekdaysShort = listWeekdaysShort;
    hooks.normalizeUnits = normalizeUnits;
    hooks.relativeTimeRounding = getSetRelativeTimeRounding;
    hooks.relativeTimeThreshold = getSetRelativeTimeThreshold;
    hooks.calendarFormat = getCalendarFormat;
    hooks.prototype = proto;
    // currently HTML5 input type only supports 24-hour formats
    hooks.HTML5_FMT = {
        DATETIME_LOCAL: "YYYY-MM-DDTHH:mm",
        DATETIME_LOCAL_SECONDS: "YYYY-MM-DDTHH:mm:ss",
        DATETIME_LOCAL_MS: "YYYY-MM-DDTHH:mm:ss.SSS",
        DATE: "YYYY-MM-DD",
        TIME: "HH:mm",
        TIME_SECONDS: "HH:mm:ss",
        TIME_MS: "HH:mm:ss.SSS",
        WEEK: "GGGG-[W]WW",
        MONTH: "YYYY-MM"
    };
    return hooks;
});

});

parcelRegister("c9Z8w", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 
var $4jPKB = parcelRequire("4jPKB");
// By explicitly using `prop-types` you are opting into new development behavior.
// http://fb.me/prop-types-in-prod
var $8da5bfbbed271cd7$var$throwOnDirectAccess = true;

module.exports = (parcelRequire("eGxWZ"))($4jPKB.isElement, $8da5bfbbed271cd7$var$throwOnDirectAccess);

});
parcelRegister("4jPKB", function(module, exports) {
"use strict";

module.exports = (parcelRequire("hkVY4"));

});
parcelRegister("hkVY4", function(module, exports) {

$parcel$export(module.exports, "AsyncMode", () => $c9f145267881427c$export$2b8d127b894957b9, (v) => $c9f145267881427c$export$2b8d127b894957b9 = v);
$parcel$export(module.exports, "ConcurrentMode", () => $c9f145267881427c$export$cea3a54a6425200c, (v) => $c9f145267881427c$export$cea3a54a6425200c = v);
$parcel$export(module.exports, "ContextConsumer", () => $c9f145267881427c$export$a7c73072b1a182ae, (v) => $c9f145267881427c$export$a7c73072b1a182ae = v);
$parcel$export(module.exports, "ContextProvider", () => $c9f145267881427c$export$9f27bc3417b4524d, (v) => $c9f145267881427c$export$9f27bc3417b4524d = v);
$parcel$export(module.exports, "Element", () => $c9f145267881427c$export$db77ccec0bb4ccac, (v) => $c9f145267881427c$export$db77ccec0bb4ccac = v);
$parcel$export(module.exports, "ForwardRef", () => $c9f145267881427c$export$8392c0c9d3dcbd35, (v) => $c9f145267881427c$export$8392c0c9d3dcbd35 = v);
$parcel$export(module.exports, "Fragment", () => $c9f145267881427c$export$ffb0004e005737fa, (v) => $c9f145267881427c$export$ffb0004e005737fa = v);
$parcel$export(module.exports, "Lazy", () => $c9f145267881427c$export$b624eff549462981, (v) => $c9f145267881427c$export$b624eff549462981 = v);
$parcel$export(module.exports, "Memo", () => $c9f145267881427c$export$7897aa7841a5380c, (v) => $c9f145267881427c$export$7897aa7841a5380c = v);
$parcel$export(module.exports, "Portal", () => $c9f145267881427c$export$602eac185826482c, (v) => $c9f145267881427c$export$602eac185826482c = v);
$parcel$export(module.exports, "Profiler", () => $c9f145267881427c$export$e2c29f18771995cb, (v) => $c9f145267881427c$export$e2c29f18771995cb = v);
$parcel$export(module.exports, "StrictMode", () => $c9f145267881427c$export$5f8d39834fd61797, (v) => $c9f145267881427c$export$5f8d39834fd61797 = v);
$parcel$export(module.exports, "Suspense", () => $c9f145267881427c$export$74bf444e3cd11ea5, (v) => $c9f145267881427c$export$74bf444e3cd11ea5 = v);
$parcel$export(module.exports, "isAsyncMode", () => $c9f145267881427c$export$92387174baf9b227, (v) => $c9f145267881427c$export$92387174baf9b227 = v);
$parcel$export(module.exports, "isConcurrentMode", () => $c9f145267881427c$export$ec112efeb987d9c6, (v) => $c9f145267881427c$export$ec112efeb987d9c6 = v);
$parcel$export(module.exports, "isContextConsumer", () => $c9f145267881427c$export$b706b080d889d2c9, (v) => $c9f145267881427c$export$b706b080d889d2c9 = v);
$parcel$export(module.exports, "isContextProvider", () => $c9f145267881427c$export$5be5a87408f70ddc, (v) => $c9f145267881427c$export$5be5a87408f70ddc = v);
$parcel$export(module.exports, "isElement", () => $c9f145267881427c$export$45a5e7f76e0caa8d, (v) => $c9f145267881427c$export$45a5e7f76e0caa8d = v);
$parcel$export(module.exports, "isForwardRef", () => $c9f145267881427c$export$455c2e768291efa6, (v) => $c9f145267881427c$export$455c2e768291efa6 = v);
$parcel$export(module.exports, "isFragment", () => $c9f145267881427c$export$9522e17588c12572, (v) => $c9f145267881427c$export$9522e17588c12572 = v);
$parcel$export(module.exports, "isLazy", () => $c9f145267881427c$export$2110ac352bb060b9, (v) => $c9f145267881427c$export$2110ac352bb060b9 = v);
$parcel$export(module.exports, "isMemo", () => $c9f145267881427c$export$56885ab8b9c456ab, (v) => $c9f145267881427c$export$56885ab8b9c456ab = v);
$parcel$export(module.exports, "isPortal", () => $c9f145267881427c$export$d927fcb6adf8f9de, (v) => $c9f145267881427c$export$d927fcb6adf8f9de = v);
$parcel$export(module.exports, "isProfiler", () => $c9f145267881427c$export$b82d16f27459e05a, (v) => $c9f145267881427c$export$b82d16f27459e05a = v);
$parcel$export(module.exports, "isStrictMode", () => $c9f145267881427c$export$522c17b4f5e123e8, (v) => $c9f145267881427c$export$522c17b4f5e123e8 = v);
$parcel$export(module.exports, "isSuspense", () => $c9f145267881427c$export$1aabd8a0274ecfd6, (v) => $c9f145267881427c$export$1aabd8a0274ecfd6 = v);
$parcel$export(module.exports, "isValidElementType", () => $c9f145267881427c$export$9b621391a187a31a, (v) => $c9f145267881427c$export$9b621391a187a31a = v);
$parcel$export(module.exports, "typeOf", () => $c9f145267881427c$export$f5bbd400c2f4426f, (v) => $c9f145267881427c$export$f5bbd400c2f4426f = v);
/** @license React v16.13.1
 * react-is.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $c9f145267881427c$export$2b8d127b894957b9;
var $c9f145267881427c$export$cea3a54a6425200c;
var $c9f145267881427c$export$a7c73072b1a182ae;
var $c9f145267881427c$export$9f27bc3417b4524d;
var $c9f145267881427c$export$db77ccec0bb4ccac;
var $c9f145267881427c$export$8392c0c9d3dcbd35;
var $c9f145267881427c$export$ffb0004e005737fa;
var $c9f145267881427c$export$b624eff549462981;
var $c9f145267881427c$export$7897aa7841a5380c;
var $c9f145267881427c$export$602eac185826482c;
var $c9f145267881427c$export$e2c29f18771995cb;
var $c9f145267881427c$export$5f8d39834fd61797;
var $c9f145267881427c$export$74bf444e3cd11ea5;
var $c9f145267881427c$export$92387174baf9b227;
var $c9f145267881427c$export$ec112efeb987d9c6;
var $c9f145267881427c$export$b706b080d889d2c9;
var $c9f145267881427c$export$5be5a87408f70ddc;
var $c9f145267881427c$export$45a5e7f76e0caa8d;
var $c9f145267881427c$export$455c2e768291efa6;
var $c9f145267881427c$export$9522e17588c12572;
var $c9f145267881427c$export$2110ac352bb060b9;
var $c9f145267881427c$export$56885ab8b9c456ab;
var $c9f145267881427c$export$d927fcb6adf8f9de;
var $c9f145267881427c$export$b82d16f27459e05a;
var $c9f145267881427c$export$522c17b4f5e123e8;
var $c9f145267881427c$export$1aabd8a0274ecfd6;
var $c9f145267881427c$export$9b621391a187a31a;
var $c9f145267881427c$export$f5bbd400c2f4426f;
"use strict";
(function() {
    "use strict";
    // The Symbol used to tag the ReactElement-like types. If there is no native Symbol
    // nor polyfill, then a plain number is used for performance.
    var hasSymbol = typeof Symbol === "function" && Symbol.for;
    var REACT_ELEMENT_TYPE = hasSymbol ? Symbol.for("react.element") : 0xeac7;
    var REACT_PORTAL_TYPE = hasSymbol ? Symbol.for("react.portal") : 0xeaca;
    var REACT_FRAGMENT_TYPE = hasSymbol ? Symbol.for("react.fragment") : 0xeacb;
    var REACT_STRICT_MODE_TYPE = hasSymbol ? Symbol.for("react.strict_mode") : 0xeacc;
    var REACT_PROFILER_TYPE = hasSymbol ? Symbol.for("react.profiler") : 0xead2;
    var REACT_PROVIDER_TYPE = hasSymbol ? Symbol.for("react.provider") : 0xeacd;
    var REACT_CONTEXT_TYPE = hasSymbol ? Symbol.for("react.context") : 0xeace; // TODO: We don't use AsyncMode or ConcurrentMode anymore. They were temporary
    // (unstable) APIs that have been removed. Can we remove the symbols?
    var REACT_ASYNC_MODE_TYPE = hasSymbol ? Symbol.for("react.async_mode") : 0xeacf;
    var REACT_CONCURRENT_MODE_TYPE = hasSymbol ? Symbol.for("react.concurrent_mode") : 0xeacf;
    var REACT_FORWARD_REF_TYPE = hasSymbol ? Symbol.for("react.forward_ref") : 0xead0;
    var REACT_SUSPENSE_TYPE = hasSymbol ? Symbol.for("react.suspense") : 0xead1;
    var REACT_SUSPENSE_LIST_TYPE = hasSymbol ? Symbol.for("react.suspense_list") : 0xead8;
    var REACT_MEMO_TYPE = hasSymbol ? Symbol.for("react.memo") : 0xead3;
    var REACT_LAZY_TYPE = hasSymbol ? Symbol.for("react.lazy") : 0xead4;
    var REACT_BLOCK_TYPE = hasSymbol ? Symbol.for("react.block") : 0xead9;
    var REACT_FUNDAMENTAL_TYPE = hasSymbol ? Symbol.for("react.fundamental") : 0xead5;
    var REACT_RESPONDER_TYPE = hasSymbol ? Symbol.for("react.responder") : 0xead6;
    var REACT_SCOPE_TYPE = hasSymbol ? Symbol.for("react.scope") : 0xead7;
    function isValidElementType(type) {
        return typeof type === "string" || typeof type === "function" || // Note: its typeof might be other than 'symbol' or 'number' if it's a polyfill.
        type === REACT_FRAGMENT_TYPE || type === REACT_CONCURRENT_MODE_TYPE || type === REACT_PROFILER_TYPE || type === REACT_STRICT_MODE_TYPE || type === REACT_SUSPENSE_TYPE || type === REACT_SUSPENSE_LIST_TYPE || typeof type === "object" && type !== null && (type.$$typeof === REACT_LAZY_TYPE || type.$$typeof === REACT_MEMO_TYPE || type.$$typeof === REACT_PROVIDER_TYPE || type.$$typeof === REACT_CONTEXT_TYPE || type.$$typeof === REACT_FORWARD_REF_TYPE || type.$$typeof === REACT_FUNDAMENTAL_TYPE || type.$$typeof === REACT_RESPONDER_TYPE || type.$$typeof === REACT_SCOPE_TYPE || type.$$typeof === REACT_BLOCK_TYPE);
    }
    function typeOf(object) {
        if (typeof object === "object" && object !== null) {
            var $$typeof = object.$$typeof;
            switch($$typeof){
                case REACT_ELEMENT_TYPE:
                    var type = object.type;
                    switch(type){
                        case REACT_ASYNC_MODE_TYPE:
                        case REACT_CONCURRENT_MODE_TYPE:
                        case REACT_FRAGMENT_TYPE:
                        case REACT_PROFILER_TYPE:
                        case REACT_STRICT_MODE_TYPE:
                        case REACT_SUSPENSE_TYPE:
                            return type;
                        default:
                            var $$typeofType = type && type.$$typeof;
                            switch($$typeofType){
                                case REACT_CONTEXT_TYPE:
                                case REACT_FORWARD_REF_TYPE:
                                case REACT_LAZY_TYPE:
                                case REACT_MEMO_TYPE:
                                case REACT_PROVIDER_TYPE:
                                    return $$typeofType;
                                default:
                                    return $$typeof;
                            }
                    }
                case REACT_PORTAL_TYPE:
                    return $$typeof;
            }
        }
        return undefined;
    } // AsyncMode is deprecated along with isAsyncMode
    var AsyncMode = REACT_ASYNC_MODE_TYPE;
    var ConcurrentMode = REACT_CONCURRENT_MODE_TYPE;
    var ContextConsumer = REACT_CONTEXT_TYPE;
    var ContextProvider = REACT_PROVIDER_TYPE;
    var Element = REACT_ELEMENT_TYPE;
    var ForwardRef = REACT_FORWARD_REF_TYPE;
    var Fragment = REACT_FRAGMENT_TYPE;
    var Lazy = REACT_LAZY_TYPE;
    var Memo = REACT_MEMO_TYPE;
    var Portal = REACT_PORTAL_TYPE;
    var Profiler = REACT_PROFILER_TYPE;
    var StrictMode = REACT_STRICT_MODE_TYPE;
    var Suspense = REACT_SUSPENSE_TYPE;
    var hasWarnedAboutDeprecatedIsAsyncMode = false; // AsyncMode should be deprecated
    function isAsyncMode(object) {
        if (!hasWarnedAboutDeprecatedIsAsyncMode) {
            hasWarnedAboutDeprecatedIsAsyncMode = true; // Using console['warn'] to evade Babel and ESLint
            console["warn"]("The ReactIs.isAsyncMode() alias has been deprecated, and will be removed in React 17+. Update your code to use ReactIs.isConcurrentMode() instead. It has the exact same API.");
        }
        return isConcurrentMode(object) || typeOf(object) === REACT_ASYNC_MODE_TYPE;
    }
    function isConcurrentMode(object) {
        return typeOf(object) === REACT_CONCURRENT_MODE_TYPE;
    }
    function isContextConsumer(object) {
        return typeOf(object) === REACT_CONTEXT_TYPE;
    }
    function isContextProvider(object) {
        return typeOf(object) === REACT_PROVIDER_TYPE;
    }
    function isElement(object) {
        return typeof object === "object" && object !== null && object.$$typeof === REACT_ELEMENT_TYPE;
    }
    function isForwardRef(object) {
        return typeOf(object) === REACT_FORWARD_REF_TYPE;
    }
    function isFragment(object) {
        return typeOf(object) === REACT_FRAGMENT_TYPE;
    }
    function isLazy(object) {
        return typeOf(object) === REACT_LAZY_TYPE;
    }
    function isMemo(object) {
        return typeOf(object) === REACT_MEMO_TYPE;
    }
    function isPortal(object) {
        return typeOf(object) === REACT_PORTAL_TYPE;
    }
    function isProfiler(object) {
        return typeOf(object) === REACT_PROFILER_TYPE;
    }
    function isStrictMode(object) {
        return typeOf(object) === REACT_STRICT_MODE_TYPE;
    }
    function isSuspense(object) {
        return typeOf(object) === REACT_SUSPENSE_TYPE;
    }
    $c9f145267881427c$export$2b8d127b894957b9 = AsyncMode;
    $c9f145267881427c$export$cea3a54a6425200c = ConcurrentMode;
    $c9f145267881427c$export$a7c73072b1a182ae = ContextConsumer;
    $c9f145267881427c$export$9f27bc3417b4524d = ContextProvider;
    $c9f145267881427c$export$db77ccec0bb4ccac = Element;
    $c9f145267881427c$export$8392c0c9d3dcbd35 = ForwardRef;
    $c9f145267881427c$export$ffb0004e005737fa = Fragment;
    $c9f145267881427c$export$b624eff549462981 = Lazy;
    $c9f145267881427c$export$7897aa7841a5380c = Memo;
    $c9f145267881427c$export$602eac185826482c = Portal;
    $c9f145267881427c$export$e2c29f18771995cb = Profiler;
    $c9f145267881427c$export$5f8d39834fd61797 = StrictMode;
    $c9f145267881427c$export$74bf444e3cd11ea5 = Suspense;
    $c9f145267881427c$export$92387174baf9b227 = isAsyncMode;
    $c9f145267881427c$export$ec112efeb987d9c6 = isConcurrentMode;
    $c9f145267881427c$export$b706b080d889d2c9 = isContextConsumer;
    $c9f145267881427c$export$5be5a87408f70ddc = isContextProvider;
    $c9f145267881427c$export$45a5e7f76e0caa8d = isElement;
    $c9f145267881427c$export$455c2e768291efa6 = isForwardRef;
    $c9f145267881427c$export$9522e17588c12572 = isFragment;
    $c9f145267881427c$export$2110ac352bb060b9 = isLazy;
    $c9f145267881427c$export$56885ab8b9c456ab = isMemo;
    $c9f145267881427c$export$d927fcb6adf8f9de = isPortal;
    $c9f145267881427c$export$b82d16f27459e05a = isProfiler;
    $c9f145267881427c$export$522c17b4f5e123e8 = isStrictMode;
    $c9f145267881427c$export$1aabd8a0274ecfd6 = isSuspense;
    $c9f145267881427c$export$9b621391a187a31a = isValidElementType;
    $c9f145267881427c$export$f5bbd400c2f4426f = typeOf;
})();

});


parcelRegister("eGxWZ", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ "use strict";

var $4jPKB = parcelRequire("4jPKB");

var $8coUR = parcelRequire("8coUR");

var $kZO5c = parcelRequire("kZO5c");

var $fQsEq = parcelRequire("fQsEq");

var $gwROR = parcelRequire("gwROR");
var $ab0f52c9db6f842e$var$printWarning = function() {};
$ab0f52c9db6f842e$var$printWarning = function(text) {
    var message = "Warning: " + text;
    if (typeof console !== "undefined") console.error(message);
    try {
        // --- Welcome to debugging React ---
        // This error was thrown as a convenience so that you can use this stack
        // to find the callsite that caused this warning to fire.
        throw new Error(message);
    } catch (x) {}
};
function $ab0f52c9db6f842e$var$emptyFunctionThatReturnsNull() {
    return null;
}
module.exports = function(isValidElement, throwOnDirectAccess) {
    /* global Symbol */ var ITERATOR_SYMBOL = typeof Symbol === "function" && Symbol.iterator;
    var FAUX_ITERATOR_SYMBOL = "@@iterator"; // Before Symbol spec.
    /**
   * Returns the iterator method function contained on the iterable object.
   *
   * Be sure to invoke the function with the iterable as context:
   *
   *     var iteratorFn = getIteratorFn(myIterable);
   *     if (iteratorFn) {
   *       var iterator = iteratorFn.call(myIterable);
   *       ...
   *     }
   *
   * @param {?object} maybeIterable
   * @return {?function}
   */ function getIteratorFn(maybeIterable) {
        var iteratorFn = maybeIterable && (ITERATOR_SYMBOL && maybeIterable[ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL]);
        if (typeof iteratorFn === "function") return iteratorFn;
    }
    /**
   * Collection of methods that allow declaration and validation of props that are
   * supplied to React components. Example usage:
   *
   *   var Props = require('ReactPropTypes');
   *   var MyArticle = React.createClass({
   *     propTypes: {
   *       // An optional string prop named "description".
   *       description: Props.string,
   *
   *       // A required enum prop named "category".
   *       category: Props.oneOf(['News','Photos']).isRequired,
   *
   *       // A prop named "dialog" that requires an instance of Dialog.
   *       dialog: Props.instanceOf(Dialog).isRequired
   *     },
   *     render: function() { ... }
   *   });
   *
   * A more formal specification of how these methods are used:
   *
   *   type := array|bool|func|object|number|string|oneOf([...])|instanceOf(...)
   *   decl := ReactPropTypes.{type}(.isRequired)?
   *
   * Each and every declaration produces a function with the same signature. This
   * allows the creation of custom validation functions. For example:
   *
   *  var MyLink = React.createClass({
   *    propTypes: {
   *      // An optional string or URI prop named "href".
   *      href: function(props, propName, componentName) {
   *        var propValue = props[propName];
   *        if (propValue != null && typeof propValue !== 'string' &&
   *            !(propValue instanceof URI)) {
   *          return new Error(
   *            'Expected a string or an URI for ' + propName + ' in ' +
   *            componentName
   *          );
   *        }
   *      }
   *    },
   *    render: function() {...}
   *  });
   *
   * @internal
   */ var ANONYMOUS = "<<anonymous>>";
    // Important!
    // Keep this list in sync with production version in `./factoryWithThrowingShims.js`.
    var ReactPropTypes = {
        array: createPrimitiveTypeChecker("array"),
        bigint: createPrimitiveTypeChecker("bigint"),
        bool: createPrimitiveTypeChecker("boolean"),
        func: createPrimitiveTypeChecker("function"),
        number: createPrimitiveTypeChecker("number"),
        object: createPrimitiveTypeChecker("object"),
        string: createPrimitiveTypeChecker("string"),
        symbol: createPrimitiveTypeChecker("symbol"),
        any: createAnyTypeChecker(),
        arrayOf: createArrayOfTypeChecker,
        element: createElementTypeChecker(),
        elementType: createElementTypeTypeChecker(),
        instanceOf: createInstanceTypeChecker,
        node: createNodeChecker(),
        objectOf: createObjectOfTypeChecker,
        oneOf: createEnumTypeChecker,
        oneOfType: createUnionTypeChecker,
        shape: createShapeTypeChecker,
        exact: createStrictShapeTypeChecker
    };
    /**
   * inlined Object.is polyfill to avoid requiring consumers ship their own
   * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
   */ /*eslint-disable no-self-compare*/ function is(x, y) {
        // SameValue algorithm
        if (x === y) // Steps 1-5, 7-10
        // Steps 6.b-6.e: +0 != -0
        return x !== 0 || 1 / x === 1 / y;
        else // Step 6.a: NaN == NaN
        return x !== x && y !== y;
    }
    /*eslint-enable no-self-compare*/ /**
   * We use an Error-like object for backward compatibility as people may call
   * PropTypes directly and inspect their output. However, we don't use real
   * Errors anymore. We don't inspect their stack anyway, and creating them
   * is prohibitively expensive if they are created too often, such as what
   * happens in oneOfType() for any type before the one that matched.
   */ function PropTypeError(message, data) {
        this.message = message;
        this.data = data && typeof data === "object" ? data : {};
        this.stack = "";
    }
    // Make `instanceof Error` still work for returned errors.
    PropTypeError.prototype = Error.prototype;
    function createChainableTypeChecker(validate) {
        var manualPropTypeCallCache = {};
        var manualPropTypeWarningCount = 0;
        function checkType(isRequired, props, propName, componentName, location, propFullName, secret) {
            componentName = componentName || ANONYMOUS;
            propFullName = propFullName || propName;
            if (secret !== $kZO5c) {
                if (throwOnDirectAccess) {
                    // New behavior only for users of `prop-types` package
                    var err = new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use `PropTypes.checkPropTypes()` to call them. Read more at http://fb.me/use-check-prop-types");
                    err.name = "Invariant Violation";
                    throw err;
                } else if (typeof console !== "undefined") {
                    // Old behavior for people using React.PropTypes
                    var cacheKey = componentName + ":" + propName;
                    if (!manualPropTypeCallCache[cacheKey] && // Avoid spamming the console because they are often not actionable except for lib authors
                    manualPropTypeWarningCount < 3) {
                        $ab0f52c9db6f842e$var$printWarning("You are manually calling a React.PropTypes validation function for the `" + propFullName + "` prop on `" + componentName + "`. This is deprecated " + "and will throw in the standalone `prop-types` package. " + "You may be seeing this warning due to a third-party PropTypes " + "library. See https://fb.me/react-warning-dont-call-proptypes " + "for details.");
                        manualPropTypeCallCache[cacheKey] = true;
                        manualPropTypeWarningCount++;
                    }
                }
            }
            if (props[propName] == null) {
                if (isRequired) {
                    if (props[propName] === null) return new PropTypeError("The " + location + " `" + propFullName + "` is marked as required " + ("in `" + componentName + "`, but its value is `null`."));
                    return new PropTypeError("The " + location + " `" + propFullName + "` is marked as required in " + ("`" + componentName + "`, but its value is `undefined`."));
                }
                return null;
            } else return validate(props, propName, componentName, location, propFullName);
        }
        var chainedCheckType = checkType.bind(null, false);
        chainedCheckType.isRequired = checkType.bind(null, true);
        return chainedCheckType;
    }
    function createPrimitiveTypeChecker(expectedType) {
        function validate(props, propName, componentName, location, propFullName, secret) {
            var propValue = props[propName];
            var propType = getPropType(propValue);
            if (propType !== expectedType) {
                // `propValue` being instance of, say, date/regexp, pass the 'object'
                // check, but we can offer a more precise error message here rather than
                // 'of type `object`'.
                var preciseType = getPreciseType(propValue);
                return new PropTypeError("Invalid " + location + " `" + propFullName + "` of type " + ("`" + preciseType + "` supplied to `" + componentName + "`, expected ") + ("`" + expectedType + "`."), {
                    expectedType: expectedType
                });
            }
            return null;
        }
        return createChainableTypeChecker(validate);
    }
    function createAnyTypeChecker() {
        return createChainableTypeChecker($ab0f52c9db6f842e$var$emptyFunctionThatReturnsNull);
    }
    function createArrayOfTypeChecker(typeChecker) {
        function validate(props, propName, componentName, location, propFullName) {
            if (typeof typeChecker !== "function") return new PropTypeError("Property `" + propFullName + "` of component `" + componentName + "` has invalid PropType notation inside arrayOf.");
            var propValue = props[propName];
            if (!Array.isArray(propValue)) {
                var propType = getPropType(propValue);
                return new PropTypeError("Invalid " + location + " `" + propFullName + "` of type " + ("`" + propType + "` supplied to `" + componentName + "`, expected an array."));
            }
            for(var i = 0; i < propValue.length; i++){
                var error = typeChecker(propValue, i, componentName, location, propFullName + "[" + i + "]", $kZO5c);
                if (error instanceof Error) return error;
            }
            return null;
        }
        return createChainableTypeChecker(validate);
    }
    function createElementTypeChecker() {
        function validate(props, propName, componentName, location, propFullName) {
            var propValue = props[propName];
            if (!isValidElement(propValue)) {
                var propType = getPropType(propValue);
                return new PropTypeError("Invalid " + location + " `" + propFullName + "` of type " + ("`" + propType + "` supplied to `" + componentName + "`, expected a single ReactElement."));
            }
            return null;
        }
        return createChainableTypeChecker(validate);
    }
    function createElementTypeTypeChecker() {
        function validate(props, propName, componentName, location, propFullName) {
            var propValue = props[propName];
            if (!$4jPKB.isValidElementType(propValue)) {
                var propType = getPropType(propValue);
                return new PropTypeError("Invalid " + location + " `" + propFullName + "` of type " + ("`" + propType + "` supplied to `" + componentName + "`, expected a single ReactElement type."));
            }
            return null;
        }
        return createChainableTypeChecker(validate);
    }
    function createInstanceTypeChecker(expectedClass) {
        function validate(props, propName, componentName, location, propFullName) {
            if (!(props[propName] instanceof expectedClass)) {
                var expectedClassName = expectedClass.name || ANONYMOUS;
                var actualClassName = getClassName(props[propName]);
                return new PropTypeError("Invalid " + location + " `" + propFullName + "` of type " + ("`" + actualClassName + "` supplied to `" + componentName + "`, expected ") + ("instance of `" + expectedClassName + "`."));
            }
            return null;
        }
        return createChainableTypeChecker(validate);
    }
    function createEnumTypeChecker(expectedValues) {
        if (!Array.isArray(expectedValues)) {
            {
                if (arguments.length > 1) $ab0f52c9db6f842e$var$printWarning("Invalid arguments supplied to oneOf, expected an array, got " + arguments.length + " arguments. " + "A common mistake is to write oneOf(x, y, z) instead of oneOf([x, y, z]).");
                else $ab0f52c9db6f842e$var$printWarning("Invalid argument supplied to oneOf, expected an array.");
            }
            return $ab0f52c9db6f842e$var$emptyFunctionThatReturnsNull;
        }
        function validate(props, propName, componentName, location, propFullName) {
            var propValue = props[propName];
            for(var i = 0; i < expectedValues.length; i++){
                if (is(propValue, expectedValues[i])) return null;
            }
            var valuesString = JSON.stringify(expectedValues, function replacer(key, value) {
                var type = getPreciseType(value);
                if (type === "symbol") return String(value);
                return value;
            });
            return new PropTypeError("Invalid " + location + " `" + propFullName + "` of value `" + String(propValue) + "` " + ("supplied to `" + componentName + "`, expected one of " + valuesString + "."));
        }
        return createChainableTypeChecker(validate);
    }
    function createObjectOfTypeChecker(typeChecker) {
        function validate(props, propName, componentName, location, propFullName) {
            if (typeof typeChecker !== "function") return new PropTypeError("Property `" + propFullName + "` of component `" + componentName + "` has invalid PropType notation inside objectOf.");
            var propValue = props[propName];
            var propType = getPropType(propValue);
            if (propType !== "object") return new PropTypeError("Invalid " + location + " `" + propFullName + "` of type " + ("`" + propType + "` supplied to `" + componentName + "`, expected an object."));
            for(var key in propValue)if ($fQsEq(propValue, key)) {
                var error = typeChecker(propValue, key, componentName, location, propFullName + "." + key, $kZO5c);
                if (error instanceof Error) return error;
            }
            return null;
        }
        return createChainableTypeChecker(validate);
    }
    function createUnionTypeChecker(arrayOfTypeCheckers) {
        if (!Array.isArray(arrayOfTypeCheckers)) {
            $ab0f52c9db6f842e$var$printWarning("Invalid argument supplied to oneOfType, expected an instance of array.");
            return $ab0f52c9db6f842e$var$emptyFunctionThatReturnsNull;
        }
        for(var i = 0; i < arrayOfTypeCheckers.length; i++){
            var checker = arrayOfTypeCheckers[i];
            if (typeof checker !== "function") {
                $ab0f52c9db6f842e$var$printWarning("Invalid argument supplied to oneOfType. Expected an array of check functions, but received " + getPostfixForTypeWarning(checker) + " at index " + i + ".");
                return $ab0f52c9db6f842e$var$emptyFunctionThatReturnsNull;
            }
        }
        function validate(props, propName, componentName, location, propFullName) {
            var expectedTypes = [];
            for(var i = 0; i < arrayOfTypeCheckers.length; i++){
                var checker = arrayOfTypeCheckers[i];
                var checkerResult = checker(props, propName, componentName, location, propFullName, $kZO5c);
                if (checkerResult == null) return null;
                if (checkerResult.data && $fQsEq(checkerResult.data, "expectedType")) expectedTypes.push(checkerResult.data.expectedType);
            }
            var expectedTypesMessage = expectedTypes.length > 0 ? ", expected one of type [" + expectedTypes.join(", ") + "]" : "";
            return new PropTypeError("Invalid " + location + " `" + propFullName + "` supplied to " + ("`" + componentName + "`" + expectedTypesMessage + "."));
        }
        return createChainableTypeChecker(validate);
    }
    function createNodeChecker() {
        function validate(props, propName, componentName, location, propFullName) {
            if (!isNode(props[propName])) return new PropTypeError("Invalid " + location + " `" + propFullName + "` supplied to " + ("`" + componentName + "`, expected a ReactNode."));
            return null;
        }
        return createChainableTypeChecker(validate);
    }
    function invalidValidatorError(componentName, location, propFullName, key, type) {
        return new PropTypeError((componentName || "React class") + ": " + location + " type `" + propFullName + "." + key + "` is invalid; " + "it must be a function, usually from the `prop-types` package, but received `" + type + "`.");
    }
    function createShapeTypeChecker(shapeTypes) {
        function validate(props, propName, componentName, location, propFullName) {
            var propValue = props[propName];
            var propType = getPropType(propValue);
            if (propType !== "object") return new PropTypeError("Invalid " + location + " `" + propFullName + "` of type `" + propType + "` " + ("supplied to `" + componentName + "`, expected `object`."));
            for(var key in shapeTypes){
                var checker = shapeTypes[key];
                if (typeof checker !== "function") return invalidValidatorError(componentName, location, propFullName, key, getPreciseType(checker));
                var error = checker(propValue, key, componentName, location, propFullName + "." + key, $kZO5c);
                if (error) return error;
            }
            return null;
        }
        return createChainableTypeChecker(validate);
    }
    function createStrictShapeTypeChecker(shapeTypes) {
        function validate(props, propName, componentName, location, propFullName) {
            var propValue = props[propName];
            var propType = getPropType(propValue);
            if (propType !== "object") return new PropTypeError("Invalid " + location + " `" + propFullName + "` of type `" + propType + "` " + ("supplied to `" + componentName + "`, expected `object`."));
            // We need to check all keys in case some are required but missing from props.
            var allKeys = $8coUR({}, props[propName], shapeTypes);
            for(var key in allKeys){
                var checker = shapeTypes[key];
                if ($fQsEq(shapeTypes, key) && typeof checker !== "function") return invalidValidatorError(componentName, location, propFullName, key, getPreciseType(checker));
                if (!checker) return new PropTypeError("Invalid " + location + " `" + propFullName + "` key `" + key + "` supplied to `" + componentName + "`." + "\nBad object: " + JSON.stringify(props[propName], null, "  ") + "\nValid keys: " + JSON.stringify(Object.keys(shapeTypes), null, "  "));
                var error = checker(propValue, key, componentName, location, propFullName + "." + key, $kZO5c);
                if (error) return error;
            }
            return null;
        }
        return createChainableTypeChecker(validate);
    }
    function isNode(propValue) {
        switch(typeof propValue){
            case "number":
            case "string":
            case "undefined":
                return true;
            case "boolean":
                return !propValue;
            case "object":
                if (Array.isArray(propValue)) return propValue.every(isNode);
                if (propValue === null || isValidElement(propValue)) return true;
                var iteratorFn = getIteratorFn(propValue);
                if (iteratorFn) {
                    var iterator = iteratorFn.call(propValue);
                    var step;
                    if (iteratorFn !== propValue.entries) while(!(step = iterator.next()).done){
                        if (!isNode(step.value)) return false;
                    }
                    else // Iterator will provide entry [k,v] tuples rather than values.
                    while(!(step = iterator.next()).done){
                        var entry = step.value;
                        if (entry) {
                            if (!isNode(entry[1])) return false;
                        }
                    }
                } else return false;
                return true;
            default:
                return false;
        }
    }
    function isSymbol(propType, propValue) {
        // Native Symbol.
        if (propType === "symbol") return true;
        // falsy value can't be a Symbol
        if (!propValue) return false;
        // 19.4.3.5 Symbol.prototype[@@toStringTag] === 'Symbol'
        if (propValue["@@toStringTag"] === "Symbol") return true;
        // Fallback for non-spec compliant Symbols which are polyfilled.
        if (typeof Symbol === "function" && propValue instanceof Symbol) return true;
        return false;
    }
    // Equivalent of `typeof` but with special handling for array and regexp.
    function getPropType(propValue) {
        var propType = typeof propValue;
        if (Array.isArray(propValue)) return "array";
        if (propValue instanceof RegExp) // Old webkits (at least until Android 4.0) return 'function' rather than
        // 'object' for typeof a RegExp. We'll normalize this here so that /bla/
        // passes PropTypes.object.
        return "object";
        if (isSymbol(propType, propValue)) return "symbol";
        return propType;
    }
    // This handles more types than `getPropType`. Only used for error messages.
    // See `createPrimitiveTypeChecker`.
    function getPreciseType(propValue) {
        if (typeof propValue === "undefined" || propValue === null) return "" + propValue;
        var propType = getPropType(propValue);
        if (propType === "object") {
            if (propValue instanceof Date) return "date";
            else if (propValue instanceof RegExp) return "regexp";
        }
        return propType;
    }
    // Returns a string that is postfixed to a warning about an invalid type.
    // For example, "undefined" or "of type array"
    function getPostfixForTypeWarning(value) {
        var type = getPreciseType(value);
        switch(type){
            case "array":
            case "object":
                return "an " + type;
            case "boolean":
            case "date":
            case "regexp":
                return "a " + type;
            default:
                return type;
        }
    }
    // Returns class name of the object, if any.
    function getClassName(propValue) {
        if (!propValue.constructor || !propValue.constructor.name) return ANONYMOUS;
        return propValue.constructor.name;
    }
    ReactPropTypes.checkPropTypes = $gwROR;
    ReactPropTypes.resetWarningCache = $gwROR.resetWarningCache;
    ReactPropTypes.PropTypes = ReactPropTypes;
    return ReactPropTypes;
};

});
parcelRegister("8coUR", function(module, exports) {
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/ "use strict";
/* eslint-disable no-unused-vars */ var $5f82c58e3d599bd6$var$getOwnPropertySymbols = Object.getOwnPropertySymbols;
var $5f82c58e3d599bd6$var$hasOwnProperty = Object.prototype.hasOwnProperty;
var $5f82c58e3d599bd6$var$propIsEnumerable = Object.prototype.propertyIsEnumerable;
function $5f82c58e3d599bd6$var$toObject(val) {
    if (val === null || val === undefined) throw new TypeError("Object.assign cannot be called with null or undefined");
    return Object(val);
}
function $5f82c58e3d599bd6$var$shouldUseNative() {
    try {
        if (!Object.assign) return false;
        // Detect buggy property enumeration order in older V8 versions.
        // https://bugs.chromium.org/p/v8/issues/detail?id=4118
        var test1 = new String("abc"); // eslint-disable-line no-new-wrappers
        test1[5] = "de";
        if (Object.getOwnPropertyNames(test1)[0] === "5") return false;
        // https://bugs.chromium.org/p/v8/issues/detail?id=3056
        var test2 = {};
        for(var i = 0; i < 10; i++)test2["_" + String.fromCharCode(i)] = i;
        var order2 = Object.getOwnPropertyNames(test2).map(function(n) {
            return test2[n];
        });
        if (order2.join("") !== "0123456789") return false;
        // https://bugs.chromium.org/p/v8/issues/detail?id=3056
        var test3 = {};
        "abcdefghijklmnopqrst".split("").forEach(function(letter) {
            test3[letter] = letter;
        });
        if (Object.keys(Object.assign({}, test3)).join("") !== "abcdefghijklmnopqrst") return false;
        return true;
    } catch (err) {
        // We don't expect any of the above to throw, but better to be safe.
        return false;
    }
}
module.exports = $5f82c58e3d599bd6$var$shouldUseNative() ? Object.assign : function(target, source) {
    var from;
    var to = $5f82c58e3d599bd6$var$toObject(target);
    var symbols;
    for(var s = 1; s < arguments.length; s++){
        from = Object(arguments[s]);
        for(var key in from)if ($5f82c58e3d599bd6$var$hasOwnProperty.call(from, key)) to[key] = from[key];
        if ($5f82c58e3d599bd6$var$getOwnPropertySymbols) {
            symbols = $5f82c58e3d599bd6$var$getOwnPropertySymbols(from);
            for(var i = 0; i < symbols.length; i++)if ($5f82c58e3d599bd6$var$propIsEnumerable.call(from, symbols[i])) to[symbols[i]] = from[symbols[i]];
        }
    }
    return to;
};

});

parcelRegister("kZO5c", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ "use strict";
var $f4905a8b274aa381$var$ReactPropTypesSecret = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
module.exports = $f4905a8b274aa381$var$ReactPropTypesSecret;

});

parcelRegister("fQsEq", function(module, exports) {
module.exports = Function.call.bind(Object.prototype.hasOwnProperty);

});

parcelRegister("gwROR", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ "use strict";
var $c08961ea4c03f601$var$printWarning = function() {};

var $kZO5c = parcelRequire("kZO5c");
var $c08961ea4c03f601$var$loggedTypeFailures = {};

var $fQsEq = parcelRequire("fQsEq");
$c08961ea4c03f601$var$printWarning = function(text) {
    var message = "Warning: " + text;
    if (typeof console !== "undefined") console.error(message);
    try {
        // --- Welcome to debugging React ---
        // This error was thrown as a convenience so that you can use this stack
        // to find the callsite that caused this warning to fire.
        throw new Error(message);
    } catch (x) {}
};
/**
 * Assert that the values match with the type specs.
 * Error messages are memorized and will only be shown once.
 *
 * @param {object} typeSpecs Map of name to a ReactPropType
 * @param {object} values Runtime values that need to be type-checked
 * @param {string} location e.g. "prop", "context", "child context"
 * @param {string} componentName Name of the component for error messages.
 * @param {?Function} getStack Returns the component stack.
 * @private
 */ function $c08961ea4c03f601$var$checkPropTypes(typeSpecs, values, location, componentName, getStack) {
    for(var typeSpecName in typeSpecs)if ($fQsEq(typeSpecs, typeSpecName)) {
        var error;
        // Prop type validation may throw. In case they do, we don't want to
        // fail the render phase where it didn't fail before. So we log it.
        // After these have been cleaned up, we'll let them throw.
        try {
            // This is intentionally an invariant that gets caught. It's the same
            // behavior as without this statement except with a better message.
            if (typeof typeSpecs[typeSpecName] !== "function") {
                var err = Error((componentName || "React class") + ": " + location + " type `" + typeSpecName + "` is invalid; " + "it must be a function, usually from the `prop-types` package, but received `" + typeof typeSpecs[typeSpecName] + "`." + "This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                err.name = "Invariant Violation";
                throw err;
            }
            error = typeSpecs[typeSpecName](values, typeSpecName, componentName, location, null, $kZO5c);
        } catch (ex) {
            error = ex;
        }
        if (error && !(error instanceof Error)) $c08961ea4c03f601$var$printWarning((componentName || "React class") + ": type specification of " + location + " `" + typeSpecName + "` is invalid; the type checker " + "function must return `null` or an `Error` but returned a " + typeof error + ". " + "You may have forgotten to pass an argument to the type checker " + "creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and " + "shape all require an argument).");
        if (error instanceof Error && !(error.message in $c08961ea4c03f601$var$loggedTypeFailures)) {
            // Only monitor this failure once because there tends to be a lot of the
            // same error.
            $c08961ea4c03f601$var$loggedTypeFailures[error.message] = true;
            var stack = getStack ? getStack() : "";
            $c08961ea4c03f601$var$printWarning("Failed " + location + " type: " + error.message + (stack != null ? stack : ""));
        }
    }
}
/**
 * Resets warning cache when testing.
 *
 * @private
 */ $c08961ea4c03f601$var$checkPropTypes.resetWarningCache = function() {
    $c08961ea4c03f601$var$loggedTypeFailures = {};
};
module.exports = $c08961ea4c03f601$var$checkPropTypes;

});



parcelRegister("7we3r", function(module, exports) {
"use strict";

var $gKvUL = parcelRequire("gKvUL");

var $jJbMR = parcelRequire("jJbMR");

var $ewFRw = parcelRequire("ewFRw");

var $lk5EI = parcelRequire("lk5EI");

var $lJY4v = parcelRequire("lJY4v");
/**
 * Create an instance of Axios
 *
 * @param {Object} defaultConfig The default config for the instance
 * @return {Axios} A new instance of Axios
 */ function $57966c7e0affc4cb$var$createInstance(defaultConfig) {
    var context = new $ewFRw(defaultConfig);
    var instance = $jJbMR($ewFRw.prototype.request, context);
    // Copy axios.prototype to instance
    $gKvUL.extend(instance, $ewFRw.prototype, context);
    // Copy context to instance
    $gKvUL.extend(instance, context);
    return instance;
}
// Create the default instance to be exported
var $57966c7e0affc4cb$var$axios = $57966c7e0affc4cb$var$createInstance($lJY4v);
// Expose Axios class to allow class inheritance
$57966c7e0affc4cb$var$axios.Axios = $ewFRw;
// Factory for creating new instances
$57966c7e0affc4cb$var$axios.create = function create(instanceConfig) {
    return $57966c7e0affc4cb$var$createInstance($lk5EI($57966c7e0affc4cb$var$axios.defaults, instanceConfig));
};

// Expose Cancel & CancelToken
$57966c7e0affc4cb$var$axios.Cancel = (parcelRequire("4Tkeq"));

$57966c7e0affc4cb$var$axios.CancelToken = (parcelRequire("lAKPy"));

$57966c7e0affc4cb$var$axios.isCancel = (parcelRequire("7L4QX"));
// Expose all/spread
$57966c7e0affc4cb$var$axios.all = function all(promises) {
    return Promise.all(promises);
};

$57966c7e0affc4cb$var$axios.spread = (parcelRequire("JEeti"));

// Expose isAxiosError
$57966c7e0affc4cb$var$axios.isAxiosError = (parcelRequire("dxy9O"));
module.exports = $57966c7e0affc4cb$var$axios;
// Allow use of default import syntax in TypeScript
module.exports.default = $57966c7e0affc4cb$var$axios;

});
parcelRegister("gKvUL", function(module, exports) {
"use strict";

var $jJbMR = parcelRequire("jJbMR");
// utils is a library of generic helper functions non-specific to axios
var $c319b2c832c2914a$var$toString = Object.prototype.toString;
/**
 * Determine if a value is an Array
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an Array, otherwise false
 */ function $c319b2c832c2914a$var$isArray(val) {
    return $c319b2c832c2914a$var$toString.call(val) === "[object Array]";
}
/**
 * Determine if a value is undefined
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if the value is undefined, otherwise false
 */ function $c319b2c832c2914a$var$isUndefined(val) {
    return typeof val === "undefined";
}
/**
 * Determine if a value is a Buffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Buffer, otherwise false
 */ function $c319b2c832c2914a$var$isBuffer(val) {
    return val !== null && !$c319b2c832c2914a$var$isUndefined(val) && val.constructor !== null && !$c319b2c832c2914a$var$isUndefined(val.constructor) && typeof val.constructor.isBuffer === "function" && val.constructor.isBuffer(val);
}
/**
 * Determine if a value is an ArrayBuffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an ArrayBuffer, otherwise false
 */ function $c319b2c832c2914a$var$isArrayBuffer(val) {
    return $c319b2c832c2914a$var$toString.call(val) === "[object ArrayBuffer]";
}
/**
 * Determine if a value is a FormData
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an FormData, otherwise false
 */ function $c319b2c832c2914a$var$isFormData(val) {
    return typeof FormData !== "undefined" && val instanceof FormData;
}
/**
 * Determine if a value is a view on an ArrayBuffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a view on an ArrayBuffer, otherwise false
 */ function $c319b2c832c2914a$var$isArrayBufferView(val) {
    var result;
    if (typeof ArrayBuffer !== "undefined" && ArrayBuffer.isView) result = ArrayBuffer.isView(val);
    else result = val && val.buffer && val.buffer instanceof ArrayBuffer;
    return result;
}
/**
 * Determine if a value is a String
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a String, otherwise false
 */ function $c319b2c832c2914a$var$isString(val) {
    return typeof val === "string";
}
/**
 * Determine if a value is a Number
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Number, otherwise false
 */ function $c319b2c832c2914a$var$isNumber(val) {
    return typeof val === "number";
}
/**
 * Determine if a value is an Object
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an Object, otherwise false
 */ function $c319b2c832c2914a$var$isObject(val) {
    return val !== null && typeof val === "object";
}
/**
 * Determine if a value is a plain Object
 *
 * @param {Object} val The value to test
 * @return {boolean} True if value is a plain Object, otherwise false
 */ function $c319b2c832c2914a$var$isPlainObject(val) {
    if ($c319b2c832c2914a$var$toString.call(val) !== "[object Object]") return false;
    var prototype = Object.getPrototypeOf(val);
    return prototype === null || prototype === Object.prototype;
}
/**
 * Determine if a value is a Date
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Date, otherwise false
 */ function $c319b2c832c2914a$var$isDate(val) {
    return $c319b2c832c2914a$var$toString.call(val) === "[object Date]";
}
/**
 * Determine if a value is a File
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a File, otherwise false
 */ function $c319b2c832c2914a$var$isFile(val) {
    return $c319b2c832c2914a$var$toString.call(val) === "[object File]";
}
/**
 * Determine if a value is a Blob
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Blob, otherwise false
 */ function $c319b2c832c2914a$var$isBlob(val) {
    return $c319b2c832c2914a$var$toString.call(val) === "[object Blob]";
}
/**
 * Determine if a value is a Function
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Function, otherwise false
 */ function $c319b2c832c2914a$var$isFunction(val) {
    return $c319b2c832c2914a$var$toString.call(val) === "[object Function]";
}
/**
 * Determine if a value is a Stream
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Stream, otherwise false
 */ function $c319b2c832c2914a$var$isStream(val) {
    return $c319b2c832c2914a$var$isObject(val) && $c319b2c832c2914a$var$isFunction(val.pipe);
}
/**
 * Determine if a value is a URLSearchParams object
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a URLSearchParams object, otherwise false
 */ function $c319b2c832c2914a$var$isURLSearchParams(val) {
    return typeof URLSearchParams !== "undefined" && val instanceof URLSearchParams;
}
/**
 * Trim excess whitespace off the beginning and end of a string
 *
 * @param {String} str The String to trim
 * @returns {String} The String freed of excess whitespace
 */ function $c319b2c832c2914a$var$trim(str) {
    return str.trim ? str.trim() : str.replace(/^\s+|\s+$/g, "");
}
/**
 * Determine if we're running in a standard browser environment
 *
 * This allows axios to run in a web worker, and react-native.
 * Both environments support XMLHttpRequest, but not fully standard globals.
 *
 * web workers:
 *  typeof window -> undefined
 *  typeof document -> undefined
 *
 * react-native:
 *  navigator.product -> 'ReactNative'
 * nativescript
 *  navigator.product -> 'NativeScript' or 'NS'
 */ function $c319b2c832c2914a$var$isStandardBrowserEnv() {
    if (typeof navigator !== "undefined" && (navigator.product === "ReactNative" || navigator.product === "NativeScript" || navigator.product === "NS")) return false;
    return typeof window !== "undefined" && typeof document !== "undefined";
}
/**
 * Iterate over an Array or an Object invoking a function for each item.
 *
 * If `obj` is an Array callback will be called passing
 * the value, index, and complete array for each item.
 *
 * If 'obj' is an Object callback will be called passing
 * the value, key, and complete object for each property.
 *
 * @param {Object|Array} obj The object to iterate
 * @param {Function} fn The callback to invoke for each item
 */ function $c319b2c832c2914a$var$forEach(obj, fn) {
    // Don't bother if no value provided
    if (obj === null || typeof obj === "undefined") return;
    // Force an array if not already something iterable
    if (typeof obj !== "object") /*eslint no-param-reassign:0*/ obj = [
        obj
    ];
    if ($c319b2c832c2914a$var$isArray(obj)) // Iterate over array values
    for(var i = 0, l = obj.length; i < l; i++)fn.call(null, obj[i], i, obj);
    else {
        // Iterate over object keys
        for(var key in obj)if (Object.prototype.hasOwnProperty.call(obj, key)) fn.call(null, obj[key], key, obj);
    }
}
/**
 * Accepts varargs expecting each argument to be an object, then
 * immutably merges the properties of each object and returns result.
 *
 * When multiple objects contain the same key the later object in
 * the arguments list will take precedence.
 *
 * Example:
 *
 * ```js
 * var result = merge({foo: 123}, {foo: 456});
 * console.log(result.foo); // outputs 456
 * ```
 *
 * @param {Object} obj1 Object to merge
 * @returns {Object} Result of all merge properties
 */ function $c319b2c832c2914a$var$merge() {
    var result = {};
    function assignValue(val, key) {
        if ($c319b2c832c2914a$var$isPlainObject(result[key]) && $c319b2c832c2914a$var$isPlainObject(val)) result[key] = $c319b2c832c2914a$var$merge(result[key], val);
        else if ($c319b2c832c2914a$var$isPlainObject(val)) result[key] = $c319b2c832c2914a$var$merge({}, val);
        else if ($c319b2c832c2914a$var$isArray(val)) result[key] = val.slice();
        else result[key] = val;
    }
    for(var i = 0, l = arguments.length; i < l; i++)$c319b2c832c2914a$var$forEach(arguments[i], assignValue);
    return result;
}
/**
 * Extends object a by mutably adding to it the properties of object b.
 *
 * @param {Object} a The object to be extended
 * @param {Object} b The object to copy properties from
 * @param {Object} thisArg The object to bind function to
 * @return {Object} The resulting value of object a
 */ function $c319b2c832c2914a$var$extend(a, b, thisArg) {
    $c319b2c832c2914a$var$forEach(b, function assignValue(val, key) {
        if (thisArg && typeof val === "function") a[key] = $jJbMR(val, thisArg);
        else a[key] = val;
    });
    return a;
}
/**
 * Remove byte order marker. This catches EF BB BF (the UTF-8 BOM)
 *
 * @param {string} content with BOM
 * @return {string} content value without BOM
 */ function $c319b2c832c2914a$var$stripBOM(content) {
    if (content.charCodeAt(0) === 0xFEFF) content = content.slice(1);
    return content;
}
module.exports = {
    isArray: $c319b2c832c2914a$var$isArray,
    isArrayBuffer: $c319b2c832c2914a$var$isArrayBuffer,
    isBuffer: $c319b2c832c2914a$var$isBuffer,
    isFormData: $c319b2c832c2914a$var$isFormData,
    isArrayBufferView: $c319b2c832c2914a$var$isArrayBufferView,
    isString: $c319b2c832c2914a$var$isString,
    isNumber: $c319b2c832c2914a$var$isNumber,
    isObject: $c319b2c832c2914a$var$isObject,
    isPlainObject: $c319b2c832c2914a$var$isPlainObject,
    isUndefined: $c319b2c832c2914a$var$isUndefined,
    isDate: $c319b2c832c2914a$var$isDate,
    isFile: $c319b2c832c2914a$var$isFile,
    isBlob: $c319b2c832c2914a$var$isBlob,
    isFunction: $c319b2c832c2914a$var$isFunction,
    isStream: $c319b2c832c2914a$var$isStream,
    isURLSearchParams: $c319b2c832c2914a$var$isURLSearchParams,
    isStandardBrowserEnv: $c319b2c832c2914a$var$isStandardBrowserEnv,
    forEach: $c319b2c832c2914a$var$forEach,
    merge: $c319b2c832c2914a$var$merge,
    extend: $c319b2c832c2914a$var$extend,
    trim: $c319b2c832c2914a$var$trim,
    stripBOM: $c319b2c832c2914a$var$stripBOM
};

});
parcelRegister("jJbMR", function(module, exports) {
"use strict";
module.exports = function bind(fn, thisArg) {
    return function wrap() {
        var args = new Array(arguments.length);
        for(var i = 0; i < args.length; i++)args[i] = arguments[i];
        return fn.apply(thisArg, args);
    };
};

});


parcelRegister("ewFRw", function(module, exports) {
"use strict";

var $gKvUL = parcelRequire("gKvUL");

var $cbIsf = parcelRequire("cbIsf");

var $83RYu = parcelRequire("83RYu");

var $dlZEJ = parcelRequire("dlZEJ");

var $lk5EI = parcelRequire("lk5EI");

var $bv3QM = parcelRequire("bv3QM");
var $a93486d2307f31c3$var$validators = $bv3QM.validators;
/**
 * Create a new instance of Axios
 *
 * @param {Object} instanceConfig The default config for the instance
 */ function $a93486d2307f31c3$var$Axios(instanceConfig) {
    this.defaults = instanceConfig;
    this.interceptors = {
        request: new $83RYu(),
        response: new $83RYu()
    };
}
/**
 * Dispatch a request
 *
 * @param {Object} config The config specific for this request (merged with this.defaults)
 */ $a93486d2307f31c3$var$Axios.prototype.request = function request(config) {
    /*eslint no-param-reassign:0*/ // Allow for axios('example/url'[, config]) a la fetch API
    if (typeof config === "string") {
        config = arguments[1] || {};
        config.url = arguments[0];
    } else config = config || {};
    config = $lk5EI(this.defaults, config);
    // Set config.method
    if (config.method) config.method = config.method.toLowerCase();
    else if (this.defaults.method) config.method = this.defaults.method.toLowerCase();
    else config.method = "get";
    var transitional = config.transitional;
    if (transitional !== undefined) $bv3QM.assertOptions(transitional, {
        silentJSONParsing: $a93486d2307f31c3$var$validators.transitional($a93486d2307f31c3$var$validators.boolean, "1.0.0"),
        forcedJSONParsing: $a93486d2307f31c3$var$validators.transitional($a93486d2307f31c3$var$validators.boolean, "1.0.0"),
        clarifyTimeoutError: $a93486d2307f31c3$var$validators.transitional($a93486d2307f31c3$var$validators.boolean, "1.0.0")
    }, false);
    // filter out skipped interceptors
    var requestInterceptorChain = [];
    var synchronousRequestInterceptors = true;
    this.interceptors.request.forEach(function unshiftRequestInterceptors(interceptor) {
        if (typeof interceptor.runWhen === "function" && interceptor.runWhen(config) === false) return;
        synchronousRequestInterceptors = synchronousRequestInterceptors && interceptor.synchronous;
        requestInterceptorChain.unshift(interceptor.fulfilled, interceptor.rejected);
    });
    var responseInterceptorChain = [];
    this.interceptors.response.forEach(function pushResponseInterceptors(interceptor) {
        responseInterceptorChain.push(interceptor.fulfilled, interceptor.rejected);
    });
    var promise;
    if (!synchronousRequestInterceptors) {
        var chain = [
            $dlZEJ,
            undefined
        ];
        Array.prototype.unshift.apply(chain, requestInterceptorChain);
        chain = chain.concat(responseInterceptorChain);
        promise = Promise.resolve(config);
        while(chain.length)promise = promise.then(chain.shift(), chain.shift());
        return promise;
    }
    var newConfig = config;
    while(requestInterceptorChain.length){
        var onFulfilled = requestInterceptorChain.shift();
        var onRejected = requestInterceptorChain.shift();
        try {
            newConfig = onFulfilled(newConfig);
        } catch (error) {
            onRejected(error);
            break;
        }
    }
    try {
        promise = $dlZEJ(newConfig);
    } catch (error) {
        return Promise.reject(error);
    }
    while(responseInterceptorChain.length)promise = promise.then(responseInterceptorChain.shift(), responseInterceptorChain.shift());
    return promise;
};
$a93486d2307f31c3$var$Axios.prototype.getUri = function getUri(config) {
    config = $lk5EI(this.defaults, config);
    return $cbIsf(config.url, config.params, config.paramsSerializer).replace(/^\?/, "");
};
// Provide aliases for supported request methods
$gKvUL.forEach([
    "delete",
    "get",
    "head",
    "options"
], function forEachMethodNoData(method) {
    /*eslint func-names:0*/ $a93486d2307f31c3$var$Axios.prototype[method] = function(url, config) {
        return this.request($lk5EI(config || {}, {
            method: method,
            url: url,
            data: (config || {}).data
        }));
    };
});
$gKvUL.forEach([
    "post",
    "put",
    "patch"
], function forEachMethodWithData(method) {
    /*eslint func-names:0*/ $a93486d2307f31c3$var$Axios.prototype[method] = function(url, data, config) {
        return this.request($lk5EI(config || {}, {
            method: method,
            url: url,
            data: data
        }));
    };
});
module.exports = $a93486d2307f31c3$var$Axios;

});
parcelRegister("cbIsf", function(module, exports) {
"use strict";

var $gKvUL = parcelRequire("gKvUL");
function $8df8fedf1c1e4428$var$encode(val) {
    return encodeURIComponent(val).replace(/%3A/gi, ":").replace(/%24/g, "$").replace(/%2C/gi, ",").replace(/%20/g, "+").replace(/%5B/gi, "[").replace(/%5D/gi, "]");
}
/**
 * Build a URL by appending params to the end
 *
 * @param {string} url The base of the url (e.g., http://www.google.com)
 * @param {object} [params] The params to be appended
 * @returns {string} The formatted url
 */ module.exports = function buildURL(url, params, paramsSerializer) {
    /*eslint no-param-reassign:0*/ if (!params) return url;
    var serializedParams;
    if (paramsSerializer) serializedParams = paramsSerializer(params);
    else if ($gKvUL.isURLSearchParams(params)) serializedParams = params.toString();
    else {
        var parts = [];
        $gKvUL.forEach(params, function serialize(val, key) {
            if (val === null || typeof val === "undefined") return;
            if ($gKvUL.isArray(val)) key = key + "[]";
            else val = [
                val
            ];
            $gKvUL.forEach(val, function parseValue(v) {
                if ($gKvUL.isDate(v)) v = v.toISOString();
                else if ($gKvUL.isObject(v)) v = JSON.stringify(v);
                parts.push($8df8fedf1c1e4428$var$encode(key) + "=" + $8df8fedf1c1e4428$var$encode(v));
            });
        });
        serializedParams = parts.join("&");
    }
    if (serializedParams) {
        var hashmarkIndex = url.indexOf("#");
        if (hashmarkIndex !== -1) url = url.slice(0, hashmarkIndex);
        url += (url.indexOf("?") === -1 ? "?" : "&") + serializedParams;
    }
    return url;
};

});

parcelRegister("83RYu", function(module, exports) {
"use strict";

var $gKvUL = parcelRequire("gKvUL");
function $5de878cd737ef277$var$InterceptorManager() {
    this.handlers = [];
}
/**
 * Add a new interceptor to the stack
 *
 * @param {Function} fulfilled The function to handle `then` for a `Promise`
 * @param {Function} rejected The function to handle `reject` for a `Promise`
 *
 * @return {Number} An ID used to remove interceptor later
 */ $5de878cd737ef277$var$InterceptorManager.prototype.use = function use(fulfilled, rejected, options) {
    this.handlers.push({
        fulfilled: fulfilled,
        rejected: rejected,
        synchronous: options ? options.synchronous : false,
        runWhen: options ? options.runWhen : null
    });
    return this.handlers.length - 1;
};
/**
 * Remove an interceptor from the stack
 *
 * @param {Number} id The ID that was returned by `use`
 */ $5de878cd737ef277$var$InterceptorManager.prototype.eject = function eject(id) {
    if (this.handlers[id]) this.handlers[id] = null;
};
/**
 * Iterate over all the registered interceptors
 *
 * This method is particularly useful for skipping over any
 * interceptors that may have become `null` calling `eject`.
 *
 * @param {Function} fn The function to call for each interceptor
 */ $5de878cd737ef277$var$InterceptorManager.prototype.forEach = function forEach(fn) {
    $gKvUL.forEach(this.handlers, function forEachHandler(h) {
        if (h !== null) fn(h);
    });
};
module.exports = $5de878cd737ef277$var$InterceptorManager;

});

parcelRegister("dlZEJ", function(module, exports) {
"use strict";

var $gKvUL = parcelRequire("gKvUL");

var $7YJ0v = parcelRequire("7YJ0v");

var $7L4QX = parcelRequire("7L4QX");

var $lJY4v = parcelRequire("lJY4v");
/**
 * Throws a `Cancel` if cancellation has been requested.
 */ function $9b8d10189805ccc0$var$throwIfCancellationRequested(config) {
    if (config.cancelToken) config.cancelToken.throwIfRequested();
}
/**
 * Dispatch a request to the server using the configured adapter.
 *
 * @param {object} config The config that is to be used for the request
 * @returns {Promise} The Promise to be fulfilled
 */ module.exports = function dispatchRequest(config) {
    $9b8d10189805ccc0$var$throwIfCancellationRequested(config);
    // Ensure headers exist
    config.headers = config.headers || {};
    // Transform request data
    config.data = $7YJ0v.call(config, config.data, config.headers, config.transformRequest);
    // Flatten headers
    config.headers = $gKvUL.merge(config.headers.common || {}, config.headers[config.method] || {}, config.headers);
    $gKvUL.forEach([
        "delete",
        "get",
        "head",
        "post",
        "put",
        "patch",
        "common"
    ], function cleanHeaderConfig(method) {
        delete config.headers[method];
    });
    var adapter = config.adapter || $lJY4v.adapter;
    return adapter(config).then(function onAdapterResolution(response) {
        $9b8d10189805ccc0$var$throwIfCancellationRequested(config);
        // Transform response data
        response.data = $7YJ0v.call(config, response.data, response.headers, config.transformResponse);
        return response;
    }, function onAdapterRejection(reason) {
        if (!$7L4QX(reason)) {
            $9b8d10189805ccc0$var$throwIfCancellationRequested(config);
            // Transform response data
            if (reason && reason.response) reason.response.data = $7YJ0v.call(config, reason.response.data, reason.response.headers, config.transformResponse);
        }
        return Promise.reject(reason);
    });
};

});
parcelRegister("7YJ0v", function(module, exports) {
"use strict";

var $gKvUL = parcelRequire("gKvUL");

var $lJY4v = parcelRequire("lJY4v");
/**
 * Transform the data for a request or a response
 *
 * @param {Object|String} data The data to be transformed
 * @param {Array} headers The headers for the request or response
 * @param {Array|Function} fns A single function or Array of functions
 * @returns {*} The resulting transformed data
 */ module.exports = function transformData(data, headers, fns) {
    var context = this || $lJY4v;
    /*eslint no-param-reassign:0*/ $gKvUL.forEach(fns, function transform(fn) {
        data = fn.call(context, data, headers);
    });
    return data;
};

});
parcelRegister("lJY4v", function(module, exports) {

var $hPtJY = parcelRequire("hPtJY");
"use strict";

var $gKvUL = parcelRequire("gKvUL");

var $kiL6T = parcelRequire("kiL6T");

var $8v8A7 = parcelRequire("8v8A7");
var $fd3c65eeb28abd71$var$DEFAULT_CONTENT_TYPE = {
    "Content-Type": "application/x-www-form-urlencoded"
};
function $fd3c65eeb28abd71$var$setContentTypeIfUnset(headers, value) {
    if (!$gKvUL.isUndefined(headers) && $gKvUL.isUndefined(headers["Content-Type"])) headers["Content-Type"] = value;
}


function $fd3c65eeb28abd71$var$getDefaultAdapter() {
    var adapter;
    if (typeof XMLHttpRequest !== "undefined") // For browsers use XHR adapter
    adapter = (parcelRequire("at5cb"));
    else if (typeof $hPtJY !== "undefined" && Object.prototype.toString.call($hPtJY) === "[object process]") // For node use HTTP adapter
    adapter = (parcelRequire("at5cb"));
    return adapter;
}
function $fd3c65eeb28abd71$var$stringifySafely(rawValue, parser, encoder) {
    if ($gKvUL.isString(rawValue)) try {
        (parser || JSON.parse)(rawValue);
        return $gKvUL.trim(rawValue);
    } catch (e) {
        if (e.name !== "SyntaxError") throw e;
    }
    return (encoder || JSON.stringify)(rawValue);
}
var $fd3c65eeb28abd71$var$defaults = {
    transitional: {
        silentJSONParsing: true,
        forcedJSONParsing: true,
        clarifyTimeoutError: false
    },
    adapter: $fd3c65eeb28abd71$var$getDefaultAdapter(),
    transformRequest: [
        function transformRequest(data, headers) {
            $kiL6T(headers, "Accept");
            $kiL6T(headers, "Content-Type");
            if ($gKvUL.isFormData(data) || $gKvUL.isArrayBuffer(data) || $gKvUL.isBuffer(data) || $gKvUL.isStream(data) || $gKvUL.isFile(data) || $gKvUL.isBlob(data)) return data;
            if ($gKvUL.isArrayBufferView(data)) return data.buffer;
            if ($gKvUL.isURLSearchParams(data)) {
                $fd3c65eeb28abd71$var$setContentTypeIfUnset(headers, "application/x-www-form-urlencoded;charset=utf-8");
                return data.toString();
            }
            if ($gKvUL.isObject(data) || headers && headers["Content-Type"] === "application/json") {
                $fd3c65eeb28abd71$var$setContentTypeIfUnset(headers, "application/json");
                return $fd3c65eeb28abd71$var$stringifySafely(data);
            }
            return data;
        }
    ],
    transformResponse: [
        function transformResponse(data) {
            var transitional = this.transitional;
            var silentJSONParsing = transitional && transitional.silentJSONParsing;
            var forcedJSONParsing = transitional && transitional.forcedJSONParsing;
            var strictJSONParsing = !silentJSONParsing && this.responseType === "json";
            if (strictJSONParsing || forcedJSONParsing && $gKvUL.isString(data) && data.length) try {
                return JSON.parse(data);
            } catch (e) {
                if (strictJSONParsing) {
                    if (e.name === "SyntaxError") throw $8v8A7(e, this, "E_JSON_PARSE");
                    throw e;
                }
            }
            return data;
        }
    ],
    /**
   * A timeout in milliseconds to abort a request. If set to 0 (default) a
   * timeout is not created.
   */ timeout: 0,
    xsrfCookieName: "XSRF-TOKEN",
    xsrfHeaderName: "X-XSRF-TOKEN",
    maxContentLength: -1,
    maxBodyLength: -1,
    validateStatus: function validateStatus(status) {
        return status >= 200 && status < 300;
    }
};
$fd3c65eeb28abd71$var$defaults.headers = {
    common: {
        "Accept": "application/json, text/plain, */*"
    }
};
$gKvUL.forEach([
    "delete",
    "get",
    "head"
], function forEachMethodNoData(method) {
    $fd3c65eeb28abd71$var$defaults.headers[method] = {};
});
$gKvUL.forEach([
    "post",
    "put",
    "patch"
], function forEachMethodWithData(method) {
    $fd3c65eeb28abd71$var$defaults.headers[method] = $gKvUL.merge($fd3c65eeb28abd71$var$DEFAULT_CONTENT_TYPE);
});
module.exports = $fd3c65eeb28abd71$var$defaults;

});
parcelRegister("hPtJY", function(module, exports) {
// shim for using process in browser
var $cfae44f0dfdf62c0$var$process = module.exports = {};
// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.
var $cfae44f0dfdf62c0$var$cachedSetTimeout;
var $cfae44f0dfdf62c0$var$cachedClearTimeout;
function $cfae44f0dfdf62c0$var$defaultSetTimout() {
    throw new Error("setTimeout has not been defined");
}
function $cfae44f0dfdf62c0$var$defaultClearTimeout() {
    throw new Error("clearTimeout has not been defined");
}
(function() {
    try {
        if (typeof setTimeout === "function") $cfae44f0dfdf62c0$var$cachedSetTimeout = setTimeout;
        else $cfae44f0dfdf62c0$var$cachedSetTimeout = $cfae44f0dfdf62c0$var$defaultSetTimout;
    } catch (e) {
        $cfae44f0dfdf62c0$var$cachedSetTimeout = $cfae44f0dfdf62c0$var$defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === "function") $cfae44f0dfdf62c0$var$cachedClearTimeout = clearTimeout;
        else $cfae44f0dfdf62c0$var$cachedClearTimeout = $cfae44f0dfdf62c0$var$defaultClearTimeout;
    } catch (e) {
        $cfae44f0dfdf62c0$var$cachedClearTimeout = $cfae44f0dfdf62c0$var$defaultClearTimeout;
    }
})();
function $cfae44f0dfdf62c0$var$runTimeout(fun) {
    if ($cfae44f0dfdf62c0$var$cachedSetTimeout === setTimeout) //normal enviroments in sane situations
    return setTimeout(fun, 0);
    // if setTimeout wasn't available but was latter defined
    if (($cfae44f0dfdf62c0$var$cachedSetTimeout === $cfae44f0dfdf62c0$var$defaultSetTimout || !$cfae44f0dfdf62c0$var$cachedSetTimeout) && setTimeout) {
        $cfae44f0dfdf62c0$var$cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $cfae44f0dfdf62c0$var$cachedSetTimeout(fun, 0);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return $cfae44f0dfdf62c0$var$cachedSetTimeout.call(null, fun, 0);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return $cfae44f0dfdf62c0$var$cachedSetTimeout.call(this, fun, 0);
        }
    }
}
function $cfae44f0dfdf62c0$var$runClearTimeout(marker) {
    if ($cfae44f0dfdf62c0$var$cachedClearTimeout === clearTimeout) //normal enviroments in sane situations
    return clearTimeout(marker);
    // if clearTimeout wasn't available but was latter defined
    if (($cfae44f0dfdf62c0$var$cachedClearTimeout === $cfae44f0dfdf62c0$var$defaultClearTimeout || !$cfae44f0dfdf62c0$var$cachedClearTimeout) && clearTimeout) {
        $cfae44f0dfdf62c0$var$cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $cfae44f0dfdf62c0$var$cachedClearTimeout(marker);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return $cfae44f0dfdf62c0$var$cachedClearTimeout.call(null, marker);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return $cfae44f0dfdf62c0$var$cachedClearTimeout.call(this, marker);
        }
    }
}
var $cfae44f0dfdf62c0$var$queue = [];
var $cfae44f0dfdf62c0$var$draining = false;
var $cfae44f0dfdf62c0$var$currentQueue;
var $cfae44f0dfdf62c0$var$queueIndex = -1;
function $cfae44f0dfdf62c0$var$cleanUpNextTick() {
    if (!$cfae44f0dfdf62c0$var$draining || !$cfae44f0dfdf62c0$var$currentQueue) return;
    $cfae44f0dfdf62c0$var$draining = false;
    if ($cfae44f0dfdf62c0$var$currentQueue.length) $cfae44f0dfdf62c0$var$queue = $cfae44f0dfdf62c0$var$currentQueue.concat($cfae44f0dfdf62c0$var$queue);
    else $cfae44f0dfdf62c0$var$queueIndex = -1;
    if ($cfae44f0dfdf62c0$var$queue.length) $cfae44f0dfdf62c0$var$drainQueue();
}
function $cfae44f0dfdf62c0$var$drainQueue() {
    if ($cfae44f0dfdf62c0$var$draining) return;
    var timeout = $cfae44f0dfdf62c0$var$runTimeout($cfae44f0dfdf62c0$var$cleanUpNextTick);
    $cfae44f0dfdf62c0$var$draining = true;
    var len = $cfae44f0dfdf62c0$var$queue.length;
    while(len){
        $cfae44f0dfdf62c0$var$currentQueue = $cfae44f0dfdf62c0$var$queue;
        $cfae44f0dfdf62c0$var$queue = [];
        while(++$cfae44f0dfdf62c0$var$queueIndex < len)if ($cfae44f0dfdf62c0$var$currentQueue) $cfae44f0dfdf62c0$var$currentQueue[$cfae44f0dfdf62c0$var$queueIndex].run();
        $cfae44f0dfdf62c0$var$queueIndex = -1;
        len = $cfae44f0dfdf62c0$var$queue.length;
    }
    $cfae44f0dfdf62c0$var$currentQueue = null;
    $cfae44f0dfdf62c0$var$draining = false;
    $cfae44f0dfdf62c0$var$runClearTimeout(timeout);
}
$cfae44f0dfdf62c0$var$process.nextTick = function(fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) for(var i = 1; i < arguments.length; i++)args[i - 1] = arguments[i];
    $cfae44f0dfdf62c0$var$queue.push(new $cfae44f0dfdf62c0$var$Item(fun, args));
    if ($cfae44f0dfdf62c0$var$queue.length === 1 && !$cfae44f0dfdf62c0$var$draining) $cfae44f0dfdf62c0$var$runTimeout($cfae44f0dfdf62c0$var$drainQueue);
};
// v8 likes predictible objects
function $cfae44f0dfdf62c0$var$Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
$cfae44f0dfdf62c0$var$Item.prototype.run = function() {
    this.fun.apply(null, this.array);
};
$cfae44f0dfdf62c0$var$process.title = "browser";
$cfae44f0dfdf62c0$var$process.browser = true;
$cfae44f0dfdf62c0$var$process.env = {};
$cfae44f0dfdf62c0$var$process.argv = [];
$cfae44f0dfdf62c0$var$process.version = ""; // empty string to avoid regexp issues
$cfae44f0dfdf62c0$var$process.versions = {};
function $cfae44f0dfdf62c0$var$noop() {}
$cfae44f0dfdf62c0$var$process.on = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.addListener = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.once = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.off = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.removeListener = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.removeAllListeners = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.emit = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.prependListener = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.prependOnceListener = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.listeners = function(name) {
    return [];
};
$cfae44f0dfdf62c0$var$process.binding = function(name) {
    throw new Error("process.binding is not supported");
};
$cfae44f0dfdf62c0$var$process.cwd = function() {
    return "/";
};
$cfae44f0dfdf62c0$var$process.chdir = function(dir) {
    throw new Error("process.chdir is not supported");
};
$cfae44f0dfdf62c0$var$process.umask = function() {
    return 0;
};

});

parcelRegister("kiL6T", function(module, exports) {
"use strict";

var $gKvUL = parcelRequire("gKvUL");
module.exports = function normalizeHeaderName(headers, normalizedName) {
    $gKvUL.forEach(headers, function processHeader(value, name) {
        if (name !== normalizedName && name.toUpperCase() === normalizedName.toUpperCase()) {
            headers[normalizedName] = value;
            delete headers[name];
        }
    });
};

});

parcelRegister("8v8A7", function(module, exports) {
"use strict";
/**
 * Update an Error with the specified config, error code, and response.
 *
 * @param {Error} error The error to update.
 * @param {Object} config The config.
 * @param {string} [code] The error code (for example, 'ECONNABORTED').
 * @param {Object} [request] The request.
 * @param {Object} [response] The response.
 * @returns {Error} The error.
 */ module.exports = function enhanceError(error, config, code, request, response) {
    error.config = config;
    if (code) error.code = code;
    error.request = request;
    error.response = response;
    error.isAxiosError = true;
    error.toJSON = function toJSON() {
        return {
            // Standard
            message: this.message,
            name: this.name,
            // Microsoft
            description: this.description,
            number: this.number,
            // Mozilla
            fileName: this.fileName,
            lineNumber: this.lineNumber,
            columnNumber: this.columnNumber,
            stack: this.stack,
            // Axios
            config: this.config,
            code: this.code
        };
    };
    return error;
};

});

parcelRegister("at5cb", function(module, exports) {
"use strict";

var $gKvUL = parcelRequire("gKvUL");

var $kk0E9 = parcelRequire("kk0E9");

var $8JRzs = parcelRequire("8JRzs");

var $cbIsf = parcelRequire("cbIsf");

var $7GD7a = parcelRequire("7GD7a");

var $lDriZ = parcelRequire("lDriZ");

var $889er = parcelRequire("889er");

var $kjF3e = parcelRequire("kjF3e");
module.exports = function xhrAdapter(config) {
    return new Promise(function dispatchXhrRequest(resolve, reject) {
        var requestData = config.data;
        var requestHeaders = config.headers;
        var responseType = config.responseType;
        if ($gKvUL.isFormData(requestData)) delete requestHeaders["Content-Type"]; // Let the browser set it
        var request = new XMLHttpRequest();
        // HTTP basic authentication
        if (config.auth) {
            var username = config.auth.username || "";
            var password = config.auth.password ? unescape(encodeURIComponent(config.auth.password)) : "";
            requestHeaders.Authorization = "Basic " + btoa(username + ":" + password);
        }
        var fullPath = $7GD7a(config.baseURL, config.url);
        request.open(config.method.toUpperCase(), $cbIsf(fullPath, config.params, config.paramsSerializer), true);
        // Set the request timeout in MS
        request.timeout = config.timeout;
        function onloadend() {
            if (!request) return;
            // Prepare the response
            var responseHeaders = "getAllResponseHeaders" in request ? $lDriZ(request.getAllResponseHeaders()) : null;
            var responseData = !responseType || responseType === "text" || responseType === "json" ? request.responseText : request.response;
            var response = {
                data: responseData,
                status: request.status,
                statusText: request.statusText,
                headers: responseHeaders,
                config: config,
                request: request
            };
            $kk0E9(resolve, reject, response);
            // Clean up request
            request = null;
        }
        if ("onloadend" in request) // Use onloadend if available
        request.onloadend = onloadend;
        else // Listen for ready state to emulate onloadend
        request.onreadystatechange = function handleLoad() {
            if (!request || request.readyState !== 4) return;
            // The request errored out and we didn't get a response, this will be
            // handled by onerror instead
            // With one exception: request that using file: protocol, most browsers
            // will return status as 0 even though it's a successful request
            if (request.status === 0 && !(request.responseURL && request.responseURL.indexOf("file:") === 0)) return;
            // readystate handler is calling before onerror or ontimeout handlers,
            // so we should call onloadend on the next 'tick'
            setTimeout(onloadend);
        };
        // Handle browser request cancellation (as opposed to a manual cancellation)
        request.onabort = function handleAbort() {
            if (!request) return;
            reject($kjF3e("Request aborted", config, "ECONNABORTED", request));
            // Clean up request
            request = null;
        };
        // Handle low level network errors
        request.onerror = function handleError() {
            // Real errors are hidden from us by the browser
            // onerror should only fire if it's a network error
            reject($kjF3e("Network Error", config, null, request));
            // Clean up request
            request = null;
        };
        // Handle timeout
        request.ontimeout = function handleTimeout() {
            var timeoutErrorMessage = "timeout of " + config.timeout + "ms exceeded";
            if (config.timeoutErrorMessage) timeoutErrorMessage = config.timeoutErrorMessage;
            reject($kjF3e(timeoutErrorMessage, config, config.transitional && config.transitional.clarifyTimeoutError ? "ETIMEDOUT" : "ECONNABORTED", request));
            // Clean up request
            request = null;
        };
        // Add xsrf header
        // This is only done if running in a standard browser environment.
        // Specifically not if we're in a web worker, or react-native.
        if ($gKvUL.isStandardBrowserEnv()) {
            // Add xsrf header
            var xsrfValue = (config.withCredentials || $889er(fullPath)) && config.xsrfCookieName ? $8JRzs.read(config.xsrfCookieName) : undefined;
            if (xsrfValue) requestHeaders[config.xsrfHeaderName] = xsrfValue;
        }
        // Add headers to the request
        if ("setRequestHeader" in request) $gKvUL.forEach(requestHeaders, function setRequestHeader(val, key) {
            if (typeof requestData === "undefined" && key.toLowerCase() === "content-type") // Remove Content-Type if data is undefined
            delete requestHeaders[key];
            else // Otherwise add header to the request
            request.setRequestHeader(key, val);
        });
        // Add withCredentials to request if needed
        if (!$gKvUL.isUndefined(config.withCredentials)) request.withCredentials = !!config.withCredentials;
        // Add responseType to request if needed
        if (responseType && responseType !== "json") request.responseType = config.responseType;
        // Handle progress if needed
        if (typeof config.onDownloadProgress === "function") request.addEventListener("progress", config.onDownloadProgress);
        // Not all browsers support upload events
        if (typeof config.onUploadProgress === "function" && request.upload) request.upload.addEventListener("progress", config.onUploadProgress);
        if (config.cancelToken) // Handle cancellation
        config.cancelToken.promise.then(function onCanceled(cancel) {
            if (!request) return;
            request.abort();
            reject(cancel);
            // Clean up request
            request = null;
        });
        if (!requestData) requestData = null;
        // Send the request
        request.send(requestData);
    });
};

});
parcelRegister("kk0E9", function(module, exports) {
"use strict";

var $kjF3e = parcelRequire("kjF3e");
/**
 * Resolve or reject a Promise based on response status.
 *
 * @param {Function} resolve A function that resolves the promise.
 * @param {Function} reject A function that rejects the promise.
 * @param {object} response The response.
 */ module.exports = function settle(resolve, reject, response) {
    var validateStatus = response.config.validateStatus;
    if (!response.status || !validateStatus || validateStatus(response.status)) resolve(response);
    else reject($kjF3e("Request failed with status code " + response.status, response.config, null, response.request, response));
};

});
parcelRegister("kjF3e", function(module, exports) {
"use strict";

var $8v8A7 = parcelRequire("8v8A7");
/**
 * Create an Error with the specified message, config, error code, request and response.
 *
 * @param {string} message The error message.
 * @param {Object} config The config.
 * @param {string} [code] The error code (for example, 'ECONNABORTED').
 * @param {Object} [request] The request.
 * @param {Object} [response] The response.
 * @returns {Error} The created error.
 */ module.exports = function createError(message, config, code, request, response) {
    var error = new Error(message);
    return $8v8A7(error, config, code, request, response);
};

});


parcelRegister("8JRzs", function(module, exports) {
"use strict";

var $gKvUL = parcelRequire("gKvUL");
module.exports = $gKvUL.isStandardBrowserEnv() ? // Standard browser envs support document.cookie
function standardBrowserEnv() {
    return {
        write: function write(name, value, expires, path, domain, secure) {
            var cookie = [];
            cookie.push(name + "=" + encodeURIComponent(value));
            if ($gKvUL.isNumber(expires)) cookie.push("expires=" + new Date(expires).toGMTString());
            if ($gKvUL.isString(path)) cookie.push("path=" + path);
            if ($gKvUL.isString(domain)) cookie.push("domain=" + domain);
            if (secure === true) cookie.push("secure");
            document.cookie = cookie.join("; ");
        },
        read: function read(name) {
            var match = document.cookie.match(new RegExp("(^|;\\s*)(" + name + ")=([^;]*)"));
            return match ? decodeURIComponent(match[3]) : null;
        },
        remove: function remove(name) {
            this.write(name, "", Date.now() - 86400000);
        }
    };
}() : // Non standard browser env (web workers, react-native) lack needed support.
function nonStandardBrowserEnv() {
    return {
        write: function write() {},
        read: function read() {
            return null;
        },
        remove: function remove() {}
    };
}();

});

parcelRegister("7GD7a", function(module, exports) {
"use strict";

var $ckHwb = parcelRequire("ckHwb");

var $fE4ul = parcelRequire("fE4ul");
/**
 * Creates a new URL by combining the baseURL with the requestedURL,
 * only when the requestedURL is not already an absolute URL.
 * If the requestURL is absolute, this function returns the requestedURL untouched.
 *
 * @param {string} baseURL The base URL
 * @param {string} requestedURL Absolute or relative URL to combine
 * @returns {string} The combined full path
 */ module.exports = function buildFullPath(baseURL, requestedURL) {
    if (baseURL && !$ckHwb(requestedURL)) return $fE4ul(baseURL, requestedURL);
    return requestedURL;
};

});
parcelRegister("ckHwb", function(module, exports) {
"use strict";
/**
 * Determines whether the specified URL is absolute
 *
 * @param {string} url The URL to test
 * @returns {boolean} True if the specified URL is absolute, otherwise false
 */ module.exports = function isAbsoluteURL(url) {
    // A URL is considered absolute if it begins with "<scheme>://" or "//" (protocol-relative URL).
    // RFC 3986 defines scheme name as a sequence of characters beginning with a letter and followed
    // by any combination of letters, digits, plus, period, or hyphen.
    return /^([a-z][a-z\d\+\-\.]*:)?\/\//i.test(url);
};

});

parcelRegister("fE4ul", function(module, exports) {
"use strict";
/**
 * Creates a new URL by combining the specified URLs
 *
 * @param {string} baseURL The base URL
 * @param {string} relativeURL The relative URL
 * @returns {string} The combined URL
 */ module.exports = function combineURLs(baseURL, relativeURL) {
    return relativeURL ? baseURL.replace(/\/+$/, "") + "/" + relativeURL.replace(/^\/+/, "") : baseURL;
};

});


parcelRegister("lDriZ", function(module, exports) {
"use strict";

var $gKvUL = parcelRequire("gKvUL");
// Headers whose duplicates are ignored by node
// c.f. https://nodejs.org/api/http.html#http_message_headers
var $fc026bbf9ee156f1$var$ignoreDuplicateOf = [
    "age",
    "authorization",
    "content-length",
    "content-type",
    "etag",
    "expires",
    "from",
    "host",
    "if-modified-since",
    "if-unmodified-since",
    "last-modified",
    "location",
    "max-forwards",
    "proxy-authorization",
    "referer",
    "retry-after",
    "user-agent"
];
/**
 * Parse headers into an object
 *
 * ```
 * Date: Wed, 27 Aug 2014 08:58:49 GMT
 * Content-Type: application/json
 * Connection: keep-alive
 * Transfer-Encoding: chunked
 * ```
 *
 * @param {String} headers Headers needing to be parsed
 * @returns {Object} Headers parsed into an object
 */ module.exports = function parseHeaders(headers) {
    var parsed = {};
    var key;
    var val;
    var i;
    if (!headers) return parsed;
    $gKvUL.forEach(headers.split("\n"), function parser(line) {
        i = line.indexOf(":");
        key = $gKvUL.trim(line.substr(0, i)).toLowerCase();
        val = $gKvUL.trim(line.substr(i + 1));
        if (key) {
            if (parsed[key] && $fc026bbf9ee156f1$var$ignoreDuplicateOf.indexOf(key) >= 0) return;
            if (key === "set-cookie") parsed[key] = (parsed[key] ? parsed[key] : []).concat([
                val
            ]);
            else parsed[key] = parsed[key] ? parsed[key] + ", " + val : val;
        }
    });
    return parsed;
};

});

parcelRegister("889er", function(module, exports) {
"use strict";

var $gKvUL = parcelRequire("gKvUL");
module.exports = $gKvUL.isStandardBrowserEnv() ? // Standard browser envs have full support of the APIs needed to test
// whether the request URL is of the same origin as current location.
function standardBrowserEnv() {
    var msie = /(msie|trident)/i.test(navigator.userAgent);
    var urlParsingNode = document.createElement("a");
    var originURL;
    /**
    * Parse a URL to discover it's components
    *
    * @param {String} url The URL to be parsed
    * @returns {Object}
    */ function resolveURL(url) {
        var href = url;
        if (msie) {
            // IE needs attribute set twice to normalize properties
            urlParsingNode.setAttribute("href", href);
            href = urlParsingNode.href;
        }
        urlParsingNode.setAttribute("href", href);
        // urlParsingNode provides the UrlUtils interface - http://url.spec.whatwg.org/#urlutils
        return {
            href: urlParsingNode.href,
            protocol: urlParsingNode.protocol ? urlParsingNode.protocol.replace(/:$/, "") : "",
            host: urlParsingNode.host,
            search: urlParsingNode.search ? urlParsingNode.search.replace(/^\?/, "") : "",
            hash: urlParsingNode.hash ? urlParsingNode.hash.replace(/^#/, "") : "",
            hostname: urlParsingNode.hostname,
            port: urlParsingNode.port,
            pathname: urlParsingNode.pathname.charAt(0) === "/" ? urlParsingNode.pathname : "/" + urlParsingNode.pathname
        };
    }
    originURL = resolveURL(window.location.href);
    /**
    * Determine if a URL shares the same origin as the current location
    *
    * @param {String} requestURL The URL to test
    * @returns {boolean} True if URL shares the same origin, otherwise false
    */ return function isURLSameOrigin(requestURL) {
        var parsed = $gKvUL.isString(requestURL) ? resolveURL(requestURL) : requestURL;
        return parsed.protocol === originURL.protocol && parsed.host === originURL.host;
    };
}() : // Non standard browser envs (web workers, react-native) lack needed support.
function nonStandardBrowserEnv() {
    return function isURLSameOrigin() {
        return true;
    };
}();

});




parcelRegister("7L4QX", function(module, exports) {
"use strict";
module.exports = function isCancel(value) {
    return !!(value && value.__CANCEL__);
};

});


parcelRegister("lk5EI", function(module, exports) {
"use strict";

var $gKvUL = parcelRequire("gKvUL");
/**
 * Config-specific merge-function which creates a new config-object
 * by merging two configuration objects together.
 *
 * @param {Object} config1
 * @param {Object} config2
 * @returns {Object} New object resulting from merging config2 to config1
 */ module.exports = function mergeConfig(config1, config2) {
    // eslint-disable-next-line no-param-reassign
    config2 = config2 || {};
    var config = {};
    var valueFromConfig2Keys = [
        "url",
        "method",
        "data"
    ];
    var mergeDeepPropertiesKeys = [
        "headers",
        "auth",
        "proxy",
        "params"
    ];
    var defaultToConfig2Keys = [
        "baseURL",
        "transformRequest",
        "transformResponse",
        "paramsSerializer",
        "timeout",
        "timeoutMessage",
        "withCredentials",
        "adapter",
        "responseType",
        "xsrfCookieName",
        "xsrfHeaderName",
        "onUploadProgress",
        "onDownloadProgress",
        "decompress",
        "maxContentLength",
        "maxBodyLength",
        "maxRedirects",
        "transport",
        "httpAgent",
        "httpsAgent",
        "cancelToken",
        "socketPath",
        "responseEncoding"
    ];
    var directMergeKeys = [
        "validateStatus"
    ];
    function getMergedValue(target, source) {
        if ($gKvUL.isPlainObject(target) && $gKvUL.isPlainObject(source)) return $gKvUL.merge(target, source);
        else if ($gKvUL.isPlainObject(source)) return $gKvUL.merge({}, source);
        else if ($gKvUL.isArray(source)) return source.slice();
        return source;
    }
    function mergeDeepProperties(prop) {
        if (!$gKvUL.isUndefined(config2[prop])) config[prop] = getMergedValue(config1[prop], config2[prop]);
        else if (!$gKvUL.isUndefined(config1[prop])) config[prop] = getMergedValue(undefined, config1[prop]);
    }
    $gKvUL.forEach(valueFromConfig2Keys, function valueFromConfig2(prop) {
        if (!$gKvUL.isUndefined(config2[prop])) config[prop] = getMergedValue(undefined, config2[prop]);
    });
    $gKvUL.forEach(mergeDeepPropertiesKeys, mergeDeepProperties);
    $gKvUL.forEach(defaultToConfig2Keys, function defaultToConfig2(prop) {
        if (!$gKvUL.isUndefined(config2[prop])) config[prop] = getMergedValue(undefined, config2[prop]);
        else if (!$gKvUL.isUndefined(config1[prop])) config[prop] = getMergedValue(undefined, config1[prop]);
    });
    $gKvUL.forEach(directMergeKeys, function merge(prop) {
        if (prop in config2) config[prop] = getMergedValue(config1[prop], config2[prop]);
        else if (prop in config1) config[prop] = getMergedValue(undefined, config1[prop]);
    });
    var axiosKeys = valueFromConfig2Keys.concat(mergeDeepPropertiesKeys).concat(defaultToConfig2Keys).concat(directMergeKeys);
    var otherKeys = Object.keys(config1).concat(Object.keys(config2)).filter(function filterAxiosKeys(key) {
        return axiosKeys.indexOf(key) === -1;
    });
    $gKvUL.forEach(otherKeys, mergeDeepProperties);
    return config;
};

});

parcelRegister("bv3QM", function(module, exports) {
"use strict";

var $bgdCC = parcelRequire("bgdCC");
var $85f59389941e7907$var$validators = {};
// eslint-disable-next-line func-names
[
    "object",
    "boolean",
    "number",
    "function",
    "string",
    "symbol"
].forEach(function(type, i) {
    $85f59389941e7907$var$validators[type] = function validator(thing) {
        return typeof thing === type || "a" + (i < 1 ? "n " : " ") + type;
    };
});
var $85f59389941e7907$var$deprecatedWarnings = {};
var $85f59389941e7907$var$currentVerArr = $bgdCC.version.split(".");
/**
 * Compare package versions
 * @param {string} version
 * @param {string?} thanVersion
 * @returns {boolean}
 */ function $85f59389941e7907$var$isOlderVersion(version, thanVersion) {
    var pkgVersionArr = thanVersion ? thanVersion.split(".") : $85f59389941e7907$var$currentVerArr;
    var destVer = version.split(".");
    for(var i = 0; i < 3; i++){
        if (pkgVersionArr[i] > destVer[i]) return true;
        else if (pkgVersionArr[i] < destVer[i]) return false;
    }
    return false;
}
/**
 * Transitional option validator
 * @param {function|boolean?} validator
 * @param {string?} version
 * @param {string} message
 * @returns {function}
 */ $85f59389941e7907$var$validators.transitional = function transitional(validator, version, message) {
    var isDeprecated = version && $85f59389941e7907$var$isOlderVersion(version);
    function formatMessage(opt, desc) {
        return "[Axios v" + $bgdCC.version + "] Transitional option '" + opt + "'" + desc + (message ? ". " + message : "");
    }
    // eslint-disable-next-line func-names
    return function(value, opt, opts) {
        if (validator === false) throw new Error(formatMessage(opt, " has been removed in " + version));
        if (isDeprecated && !$85f59389941e7907$var$deprecatedWarnings[opt]) {
            $85f59389941e7907$var$deprecatedWarnings[opt] = true;
            // eslint-disable-next-line no-console
            console.warn(formatMessage(opt, " has been deprecated since v" + version + " and will be removed in the near future"));
        }
        return validator ? validator(value, opt, opts) : true;
    };
};
/**
 * Assert object's properties type
 * @param {object} options
 * @param {object} schema
 * @param {boolean?} allowUnknown
 */ function $85f59389941e7907$var$assertOptions(options, schema, allowUnknown) {
    if (typeof options !== "object") throw new TypeError("options must be an object");
    var keys = Object.keys(options);
    var i = keys.length;
    while(i-- > 0){
        var opt = keys[i];
        var validator = schema[opt];
        if (validator) {
            var value = options[opt];
            var result = value === undefined || validator(value, opt, options);
            if (result !== true) throw new TypeError("option " + opt + " must be " + result);
            continue;
        }
        if (allowUnknown !== true) throw Error("Unknown option " + opt);
    }
}
module.exports = {
    isOlderVersion: $85f59389941e7907$var$isOlderVersion,
    assertOptions: $85f59389941e7907$var$assertOptions,
    validators: $85f59389941e7907$var$validators
};

});
parcelRegister("bgdCC", function(module, exports) {
module.exports = JSON.parse('{"name":"axios","version":"0.21.4","description":"Promise based HTTP client for the browser and node.js","main":"index.js","scripts":{"test":"grunt test","start":"node ./sandbox/server.js","build":"NODE_ENV=production grunt build","preversion":"npm test","version":"npm run build && grunt version && git add -A dist && git add CHANGELOG.md bower.json package.json","postversion":"git push && git push --tags","examples":"node ./examples/server.js","coveralls":"cat coverage/lcov.info | ./node_modules/coveralls/bin/coveralls.js","fix":"eslint --fix lib/**/*.js"},"repository":{"type":"git","url":"https://github.com/axios/axios.git"},"keywords":["xhr","http","ajax","promise","node"],"author":"Matt Zabriskie","license":"MIT","bugs":{"url":"https://github.com/axios/axios/issues"},"homepage":"https://axios-http.com","devDependencies":{"coveralls":"^3.0.0","es6-promise":"^4.2.4","grunt":"^1.3.0","grunt-banner":"^0.6.0","grunt-cli":"^1.2.0","grunt-contrib-clean":"^1.1.0","grunt-contrib-watch":"^1.0.0","grunt-eslint":"^23.0.0","grunt-karma":"^4.0.0","grunt-mocha-test":"^0.13.3","grunt-ts":"^6.0.0-beta.19","grunt-webpack":"^4.0.2","istanbul-instrumenter-loader":"^1.0.0","jasmine-core":"^2.4.1","karma":"^6.3.2","karma-chrome-launcher":"^3.1.0","karma-firefox-launcher":"^2.1.0","karma-jasmine":"^1.1.1","karma-jasmine-ajax":"^0.1.13","karma-safari-launcher":"^1.0.0","karma-sauce-launcher":"^4.3.6","karma-sinon":"^1.0.5","karma-sourcemap-loader":"^0.3.8","karma-webpack":"^4.0.2","load-grunt-tasks":"^3.5.2","minimist":"^1.2.0","mocha":"^8.2.1","sinon":"^4.5.0","terser-webpack-plugin":"^4.2.3","typescript":"^4.0.5","url-search-params":"^0.10.0","webpack":"^4.44.2","webpack-dev-server":"^3.11.0"},"browser":{"./lib/adapters/http.js":"./lib/adapters/xhr.js"},"jsdelivr":"dist/axios.min.js","unpkg":"dist/axios.min.js","typings":"./index.d.ts","dependencies":{"follow-redirects":"^1.14.0"},"bundlesize":[{"path":"./dist/axios.min.js","threshold":"5kB"}]}');

});



parcelRegister("4Tkeq", function(module, exports) {
"use strict";
/**
 * A `Cancel` is an object that is thrown when an operation is canceled.
 *
 * @class
 * @param {string=} message The message.
 */ function $38fbfe0afbd5bf1e$var$Cancel(message) {
    this.message = message;
}
$38fbfe0afbd5bf1e$var$Cancel.prototype.toString = function toString() {
    return "Cancel" + (this.message ? ": " + this.message : "");
};
$38fbfe0afbd5bf1e$var$Cancel.prototype.__CANCEL__ = true;
module.exports = $38fbfe0afbd5bf1e$var$Cancel;

});

parcelRegister("lAKPy", function(module, exports) {
"use strict";

var $4Tkeq = parcelRequire("4Tkeq");
/**
 * A `CancelToken` is an object that can be used to request cancellation of an operation.
 *
 * @class
 * @param {Function} executor The executor function.
 */ function $fb81495929d8a282$var$CancelToken(executor) {
    if (typeof executor !== "function") throw new TypeError("executor must be a function.");
    var resolvePromise;
    this.promise = new Promise(function promiseExecutor(resolve) {
        resolvePromise = resolve;
    });
    var token = this;
    executor(function cancel(message) {
        if (token.reason) // Cancellation has already been requested
        return;
        token.reason = new $4Tkeq(message);
        resolvePromise(token.reason);
    });
}
/**
 * Throws a `Cancel` if cancellation has been requested.
 */ $fb81495929d8a282$var$CancelToken.prototype.throwIfRequested = function throwIfRequested() {
    if (this.reason) throw this.reason;
};
/**
 * Returns an object that contains a new `CancelToken` and a function that, when called,
 * cancels the `CancelToken`.
 */ $fb81495929d8a282$var$CancelToken.source = function source() {
    var cancel;
    var token = new $fb81495929d8a282$var$CancelToken(function executor(c) {
        cancel = c;
    });
    return {
        token: token,
        cancel: cancel
    };
};
module.exports = $fb81495929d8a282$var$CancelToken;

});

parcelRegister("JEeti", function(module, exports) {
"use strict";
/**
 * Syntactic sugar for invoking a function and expanding an array for arguments.
 *
 * Common use case would be to use `Function.prototype.apply`.
 *
 *  ```js
 *  function f(x, y, z) {}
 *  var args = [1, 2, 3];
 *  f.apply(null, args);
 *  ```
 *
 * With `spread` this example can be re-written.
 *
 *  ```js
 *  spread(function(x, y, z) {})([1, 2, 3]);
 *  ```
 *
 * @param {Function} callback
 * @returns {Function}
 */ module.exports = function spread(callback) {
    return function wrap(arr) {
        return callback.apply(null, arr);
    };
};

});

parcelRegister("dxy9O", function(module, exports) {
"use strict";
/**
 * Determines whether the payload is an error thrown by Axios
 *
 * @param {*} payload The value to test
 * @returns {boolean} True if the payload is an error thrown by Axios, otherwise false
 */ module.exports = function isAxiosError(payload) {
    return typeof payload === "object" && payload.isAxiosError === true;
};

});


parcelRegister("4f362", function(module, exports) {

$parcel$export(module.exports, "createAtom", () => createAtom);
$parcel$export(module.exports, "observable", () => observable);
$parcel$export(module.exports, "isObservableObject", () => isObservableObject);
$parcel$export(module.exports, "isObservableArray", () => isObservableArray);
$parcel$export(module.exports, "isObservableMap", () => isObservableMap);
$parcel$export(module.exports, "computed", () => computed);
$parcel$export(module.exports, "ObservableMap", () => ObservableMap);
$parcel$export(module.exports, "_allowStateChanges", () => allowStateChanges);
$parcel$export(module.exports, "untracked", () => untracked);
$parcel$export(module.exports, "_getGlobalState", () => getGlobalState);
$parcel$export(module.exports, "getDependencyTree", () => getDependencyTree);
$parcel$export(module.exports, "Reaction", () => Reaction);
$parcel$export(module.exports, "action", () => action);
$parcel$export(module.exports, "_allowStateChangesInsideComputed", () => runInAction);
$parcel$export(module.exports, "reaction", () => reaction);
$parcel$export(module.exports, "getAtom", () => getAtom);
$parcel$export(module.exports, "configure", () => configure);
$parcel$export(module.exports, "_interceptReads", () => interceptReads);
$parcel$export(module.exports, "_getAdministration", () => getAdministration);
$parcel$export(module.exports, "intercept", () => intercept);
$parcel$export(module.exports, "isComputedProp", () => isComputedProp);
$parcel$export(module.exports, "isObservableProp", () => isObservableProp);
$parcel$export(module.exports, "values", () => values);
$parcel$export(module.exports, "entries", () => entries);
$parcel$export(module.exports, "set", () => set);
$parcel$export(module.exports, "defineProperty", () => apiDefineProperty);
$parcel$export(module.exports, "observe", () => observe);
$parcel$export(module.exports, "toJS", () => toJS);
$parcel$export(module.exports, "when", () => when);
$parcel$export(module.exports, "makeObservable", () => makeObservable);
$parcel$export(module.exports, "runInAction", () => runInAction);
var niceErrors = {
    0: "Invalid value for configuration 'enforceActions', expected 'never', 'always' or 'observed'",
    1: function _(annotationType, key) {
        return "Cannot apply '" + annotationType + "' to '" + key.toString() + "': Field not found.";
    },
    /*
  2(prop) {
      return `invalid decorator for '${prop.toString()}'`
  },
  3(prop) {
      return `Cannot decorate '${prop.toString()}': action can only be used on properties with a function value.`
  },
  4(prop) {
      return `Cannot decorate '${prop.toString()}': computed can only be used on getter properties.`
  },
  */ 5: "'keys()' can only be used on observable objects, arrays, sets and maps",
    6: "'values()' can only be used on observable objects, arrays, sets and maps",
    7: "'entries()' can only be used on observable objects, arrays and maps",
    8: "'set()' can only be used on observable objects, arrays and maps",
    9: "'remove()' can only be used on observable objects, arrays and maps",
    10: "'has()' can only be used on observable objects, arrays and maps",
    11: "'get()' can only be used on observable objects, arrays and maps",
    12: "Invalid annotation",
    13: "Dynamic observable objects cannot be frozen. If you're passing observables to 3rd party component/function that calls Object.freeze, pass copy instead: toJS(observable)",
    14: "Intercept handlers should return nothing or a change object",
    15: "Observable arrays cannot be frozen. If you're passing observables to 3rd party component/function that calls Object.freeze, pass copy instead: toJS(observable)",
    16: "Modification exception: the internal structure of an observable array was changed.",
    17: function _(index, length) {
        return "[mobx.array] Index out of bounds, " + index + " is larger than " + length;
    },
    18: "mobx.map requires Map polyfill for the current browser. Check babel-polyfill or core-js/es6/map.js",
    19: function _(other) {
        return "Cannot initialize from classes that inherit from Map: " + other.constructor.name;
    },
    20: function _(other) {
        return "Cannot initialize map from " + other;
    },
    21: function _(dataStructure) {
        return "Cannot convert to map from '" + dataStructure + "'";
    },
    22: "mobx.set requires Set polyfill for the current browser. Check babel-polyfill or core-js/es6/set.js",
    23: "It is not possible to get index atoms from arrays",
    24: function _(thing) {
        return "Cannot obtain administration from " + thing;
    },
    25: function _(property, name) {
        return "the entry '" + property + "' does not exist in the observable map '" + name + "'";
    },
    26: "please specify a property",
    27: function _(property, name) {
        return "no observable property '" + property.toString() + "' found on the observable object '" + name + "'";
    },
    28: function _(thing) {
        return "Cannot obtain atom from " + thing;
    },
    29: "Expecting some object",
    30: "invalid action stack. did you forget to finish an action?",
    31: "missing option for computed: get",
    32: function _(name, derivation) {
        return "Cycle detected in computation " + name + ": " + derivation;
    },
    33: function _(name) {
        return "The setter of computed value '" + name + "' is trying to update itself. Did you intend to update an _observable_ value, instead of the computed property?";
    },
    34: function _(name) {
        return "[ComputedValue '" + name + "'] It is not possible to assign a new value to a computed value.";
    },
    35: "There are multiple, different versions of MobX active. Make sure MobX is loaded only once or use `configure({ isolateGlobalState: true })`",
    36: "isolateGlobalState should be called before MobX is running any reactions",
    37: function _(method) {
        return "[mobx] `observableArray." + method + "()` mutates the array in-place, which is not allowed inside a derivation. Use `array.slice()." + method + "()` instead";
    },
    38: "'ownKeys()' can only be used on observable objects",
    39: "'defineProperty()' can only be used on observable objects"
};
var errors = niceErrors;
function die(error) {
    for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)args[_key - 1] = arguments[_key];
    var e = typeof error === "string" ? error : errors[error];
    if (typeof e === "function") e = e.apply(null, args);
    throw new Error("[MobX] " + e);
    throw new Error(typeof error === "number" ? "[MobX] minified error nr: " + error + (args.length ? " " + args.map(String).join(",") : "") + ". Find the full error at: https://github.com/mobxjs/mobx/blob/main/packages/mobx/src/errors.ts" : "[MobX] " + error);
}
var mockGlobal = {};
function getGlobal() {
    if (typeof globalThis !== "undefined") return globalThis;
    if (typeof window !== "undefined") return window;
    if (typeof $parcel$global !== "undefined") return $parcel$global;
    if (typeof self !== "undefined") return self;
    return mockGlobal;
}
// We shorten anything used > 5 times
var assign = Object.assign;
var getDescriptor = Object.getOwnPropertyDescriptor;
var defineProperty = Object.defineProperty;
var objectPrototype = Object.prototype;
var EMPTY_ARRAY = [];
Object.freeze(EMPTY_ARRAY);
var EMPTY_OBJECT = {};
Object.freeze(EMPTY_OBJECT);
var hasProxy = typeof Proxy !== "undefined";
var plainObjectString = /*#__PURE__*/ Object.toString();
function assertProxies() {
    if (!hasProxy) die("`Proxy` objects are not available in the current environment. Please configure MobX to enable a fallback implementation.`");
}
function warnAboutProxyRequirement(msg) {
    if (0, globalState.verifyProxies) die("MobX is currently configured to be able to run in ES5 mode, but in ES5 MobX won't be able to " + msg);
}
function getNextId() {
    return ++globalState.mobxGuid;
}
/**
 * Makes sure that the provided function is invoked at most once.
 */ function once(func) {
    var invoked = false;
    return function() {
        if (invoked) return;
        invoked = true;
        return func.apply(this, arguments);
    };
}
var noop = function noop() {};
function isFunction(fn) {
    return typeof fn === "function";
}
function isStringish(value) {
    var t = typeof value;
    switch(t){
        case "string":
        case "symbol":
        case "number":
            return true;
    }
    return false;
}
function isObject(value) {
    return value !== null && typeof value === "object";
}
function isPlainObject(value) {
    if (!isObject(value)) return false;
    var proto = Object.getPrototypeOf(value);
    if (proto == null) return true;
    var protoConstructor = Object.hasOwnProperty.call(proto, "constructor") && proto.constructor;
    return typeof protoConstructor === "function" && protoConstructor.toString() === plainObjectString;
}
// https://stackoverflow.com/a/37865170
function isGenerator(obj) {
    var constructor = obj == null ? void 0 : obj.constructor;
    if (!constructor) return false;
    if ("GeneratorFunction" === constructor.name || "GeneratorFunction" === constructor.displayName) return true;
    return false;
}
function addHiddenProp(object, propName, value) {
    defineProperty(object, propName, {
        enumerable: false,
        writable: true,
        configurable: true,
        value: value
    });
}
function addHiddenFinalProp(object, propName, value) {
    defineProperty(object, propName, {
        enumerable: false,
        writable: false,
        configurable: true,
        value: value
    });
}
function createInstanceofPredicate(name, theClass) {
    var propName = "isMobX" + name;
    theClass.prototype[propName] = true;
    return function(x) {
        return isObject(x) && x[propName] === true;
    };
}
function isES6Map(thing) {
    return thing instanceof Map;
}
function isES6Set(thing) {
    return thing instanceof Set;
}
var hasGetOwnPropertySymbols = typeof Object.getOwnPropertySymbols !== "undefined";
/**
 * Returns the following: own enumerable keys and symbols.
 */ function getPlainObjectKeys(object) {
    var keys = Object.keys(object);
    // Not supported in IE, so there are not going to be symbol props anyway...
    if (!hasGetOwnPropertySymbols) return keys;
    var symbols = Object.getOwnPropertySymbols(object);
    if (!symbols.length) return keys;
    return [].concat(keys, symbols.filter(function(s) {
        return objectPrototype.propertyIsEnumerable.call(object, s);
    }));
}
// From Immer utils
// Returns all own keys, including non-enumerable and symbolic
var ownKeys = typeof Reflect !== "undefined" && Reflect.ownKeys ? Reflect.ownKeys : hasGetOwnPropertySymbols ? function(obj) {
    return Object.getOwnPropertyNames(obj).concat(Object.getOwnPropertySymbols(obj));
} : /* istanbul ignore next */ Object.getOwnPropertyNames;
function stringifyKey(key) {
    if (typeof key === "string") return key;
    if (typeof key === "symbol") return key.toString();
    return new String(key).toString();
}
function toPrimitive(value) {
    return value === null ? null : typeof value === "object" ? "" + value : value;
}
function hasProp(target, prop) {
    return objectPrototype.hasOwnProperty.call(target, prop);
}
// From Immer utils
var getOwnPropertyDescriptors = Object.getOwnPropertyDescriptors || function getOwnPropertyDescriptors(target) {
    // Polyfill needed for Hermes and IE, see https://github.com/facebook/hermes/issues/274
    var res = {};
    // Note: without polyfill for ownKeys, symbols won't be picked up
    ownKeys(target).forEach(function(key) {
        res[key] = getDescriptor(target, key);
    });
    return res;
};
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor);
    }
}
function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function _extends() {
    _extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _inheritsLoose(subClass, superClass) {
    subClass.prototype = Object.create(superClass.prototype);
    subClass.prototype.constructor = subClass;
    _setPrototypeOf(subClass, superClass);
}
function _setPrototypeOf(o, p) {
    _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _setPrototypeOf(o, p);
}
function _assertThisInitialized(self1) {
    if (self1 === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self1;
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _createForOfIteratorHelperLoose(o, allowArrayLike) {
    var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
    if (it) return (it = it.call(o)).next.bind(it);
    if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
        if (it) o = it;
        var i = 0;
        return function() {
            if (i >= o.length) return {
                done: true
            };
            return {
                done: false,
                value: o[i++]
            };
        };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _toPrimitive(input, hint) {
    if (typeof input !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if (typeof res !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
function _toPropertyKey(arg) {
    var key = _toPrimitive(arg, "string");
    return typeof key === "symbol" ? key : String(key);
}
var storedAnnotationsSymbol = /*#__PURE__*/ Symbol("mobx-stored-annotations");
/**
 * Creates a function that acts as
 * - decorator
 * - annotation object
 */ function createDecoratorAnnotation(annotation) {
    function decorator(target, property) {
        if (is20223Decorator(property)) return annotation.decorate_20223_(target, property);
        else storeAnnotation(target, property, annotation);
    }
    return Object.assign(decorator, annotation);
}
/**
 * Stores annotation to prototype,
 * so it can be inspected later by `makeObservable` called from constructor
 */ function storeAnnotation(prototype, key, annotation) {
    if (!hasProp(prototype, storedAnnotationsSymbol)) addHiddenProp(prototype, storedAnnotationsSymbol, _extends({}, prototype[storedAnnotationsSymbol]));
    // @override must override something
    if (isOverride(annotation) && !hasProp(prototype[storedAnnotationsSymbol], key)) {
        var fieldName = prototype.constructor.name + ".prototype." + key.toString();
        die("'" + fieldName + "' is decorated with 'override', " + "but no such decorated member was found on prototype.");
    }
    // Cannot re-decorate
    assertNotDecorated(prototype, annotation, key);
    // Ignore override
    if (!isOverride(annotation)) prototype[storedAnnotationsSymbol][key] = annotation;
}
function assertNotDecorated(prototype, annotation, key) {
    if (!isOverride(annotation) && hasProp(prototype[storedAnnotationsSymbol], key)) {
        var fieldName = prototype.constructor.name + ".prototype." + key.toString();
        var currentAnnotationType = prototype[storedAnnotationsSymbol][key].annotationType_;
        var requestedAnnotationType = annotation.annotationType_;
        die("Cannot apply '@" + requestedAnnotationType + "' to '" + fieldName + "':" + ("\nThe field is already decorated with '@" + currentAnnotationType + "'.") + "\nRe-decorating fields is not allowed." + "\nUse '@override' decorator for methods overridden by subclass.");
    }
}
/**
 * Collects annotations from prototypes and stores them on target (instance)
 */ function collectStoredAnnotations(target) {
    if (!hasProp(target, storedAnnotationsSymbol)) // if (__DEV__ && !target[storedAnnotationsSymbol]) {
    //     die(
    //         `No annotations were passed to makeObservable, but no decorated members have been found either`
    //     )
    // }
    // We need a copy as we will remove annotation from the list once it's applied.
    addHiddenProp(target, storedAnnotationsSymbol, _extends({}, target[storedAnnotationsSymbol]));
    return target[storedAnnotationsSymbol];
}
function is20223Decorator(context) {
    return typeof context == "object" && typeof context["kind"] == "string";
}
function assert20223DecoratorType(context, types) {
    if (!types.includes(context.kind)) die("The decorator applied to '" + String(context.name) + "' cannot be used on a " + context.kind + " element");
}
var $mobx = /*#__PURE__*/ Symbol("mobx administration");
var Atom = /*#__PURE__*/ function() {
    // for effective unobserving. BaseAtom has true, for extra optimization, so its onBecomeUnobserved never gets called, because it's not needed
    /**
   * Create a new atom. For debugging purposes it is recommended to give it a name.
   * The onBecomeObserved and onBecomeUnobserved callbacks can be used for resource management.
   */ function Atom(name_) {
        if (name_ === void 0) name_ = "Atom@" + getNextId();
        this.name_ = void 0;
        this.isPendingUnobservation_ = false;
        this.isBeingObserved_ = false;
        this.observers_ = new Set();
        this.diffValue_ = 0;
        this.lastAccessedBy_ = 0;
        this.lowestObserverState_ = IDerivationState_.NOT_TRACKING_;
        this.onBOL = void 0;
        this.onBUOL = void 0;
        this.name_ = name_;
    }
    // onBecomeObservedListeners
    var _proto = Atom.prototype;
    _proto.onBO = function onBO() {
        if (this.onBOL) this.onBOL.forEach(function(listener) {
            return listener();
        });
    };
    _proto.onBUO = function onBUO() {
        if (this.onBUOL) this.onBUOL.forEach(function(listener) {
            return listener();
        });
    } /**
   * Invoke this method to notify mobx that your atom has been used somehow.
   * Returns true if there is currently a reactive context.
   */ ;
    _proto.reportObserved = function reportObserved$1() {
        return reportObserved(this);
    } /**
   * Invoke this method _after_ this method has changed to signal mobx that all its observers should invalidate.
   */ ;
    _proto.reportChanged = function reportChanged() {
        startBatch();
        propagateChanged(this);
        endBatch();
    };
    _proto.toString = function toString() {
        return this.name_;
    };
    return Atom;
}();
var isAtom = /*#__PURE__*/ createInstanceofPredicate("Atom", Atom);
function createAtom(name, onBecomeObservedHandler, onBecomeUnobservedHandler) {
    if (onBecomeObservedHandler === void 0) onBecomeObservedHandler = noop;
    if (onBecomeUnobservedHandler === void 0) onBecomeUnobservedHandler = noop;
    var atom = new Atom(name);
    // default `noop` listener will not initialize the hook Set
    if (onBecomeObservedHandler !== noop) onBecomeObserved(atom, onBecomeObservedHandler);
    if (onBecomeUnobservedHandler !== noop) onBecomeUnobserved(atom, onBecomeUnobservedHandler);
    return atom;
}
function identityComparer(a, b) {
    return a === b;
}
function structuralComparer(a, b) {
    return deepEqual(a, b);
}
function shallowComparer(a, b) {
    return deepEqual(a, b, 1);
}
function defaultComparer(a, b) {
    if (Object.is) return Object.is(a, b);
    return a === b ? a !== 0 || 1 / a === 1 / b : a !== a && b !== b;
}
var comparer = {
    identity: identityComparer,
    structural: structuralComparer,
    "default": defaultComparer,
    shallow: shallowComparer
};
function deepEnhancer(v, _, name) {
    // it is an observable already, done
    if (isObservable(v)) return v;
    // something that can be converted and mutated?
    if (Array.isArray(v)) return observable.array(v, {
        name: name
    });
    if (isPlainObject(v)) return observable.object(v, undefined, {
        name: name
    });
    if (isES6Map(v)) return observable.map(v, {
        name: name
    });
    if (isES6Set(v)) return observable.set(v, {
        name: name
    });
    if (typeof v === "function" && !isAction(v) && !isFlow(v)) {
        if (isGenerator(v)) return flow(v);
        else return autoAction(name, v);
    }
    return v;
}
function shallowEnhancer(v, _, name) {
    if (v === undefined || v === null) return v;
    if (isObservableObject(v) || isObservableArray(v) || isObservableMap(v) || isObservableSet(v)) return v;
    if (Array.isArray(v)) return observable.array(v, {
        name: name,
        deep: false
    });
    if (isPlainObject(v)) return observable.object(v, undefined, {
        name: name,
        deep: false
    });
    if (isES6Map(v)) return observable.map(v, {
        name: name,
        deep: false
    });
    if (isES6Set(v)) return observable.set(v, {
        name: name,
        deep: false
    });
    die("The shallow modifier / decorator can only used in combination with arrays, objects, maps and sets");
}
function referenceEnhancer(newValue) {
    // never turn into an observable
    return newValue;
}
function refStructEnhancer(v, oldValue) {
    if (isObservable(v)) die("observable.struct should not be used with observable values");
    if (deepEqual(v, oldValue)) return oldValue;
    return v;
}
var OVERRIDE = "override";
var override = /*#__PURE__*/ createDecoratorAnnotation({
    annotationType_: OVERRIDE,
    make_: make_,
    extend_: extend_,
    decorate_20223_: decorate_20223_
});
function isOverride(annotation) {
    return annotation.annotationType_ === OVERRIDE;
}
function make_(adm, key) {
    // Must not be plain object
    if (0, adm.isPlainObject_) die("Cannot apply '" + this.annotationType_ + "' to '" + adm.name_ + "." + key.toString() + "':" + ("\n'" + this.annotationType_ + "' cannot be used on plain objects."));
    // Must override something
    if (!hasProp(adm.appliedAnnotations_, key)) die("'" + adm.name_ + "." + key.toString() + "' is annotated with '" + this.annotationType_ + "', " + "but no such annotated member was found on prototype.");
    return 0 /* MakeResult.Cancel */ ;
}
function extend_(adm, key, descriptor, proxyTrap) {
    die("'" + this.annotationType_ + "' can only be used with 'makeObservable'");
}
function decorate_20223_(desc, context) {
    console.warn("'" + this.annotationType_ + "' cannot be used with decorators - this is a no-op");
}
function createActionAnnotation(name, options) {
    return {
        annotationType_: name,
        options_: options,
        make_: make_$1,
        extend_: extend_$1,
        decorate_20223_: decorate_20223_$1
    };
}
function make_$1(adm, key, descriptor, source) {
    var _this$options_;
    // bound
    if ((_this$options_ = this.options_) != null && _this$options_.bound) return this.extend_(adm, key, descriptor, false) === null ? 0 /* MakeResult.Cancel */  : 1 /* MakeResult.Break */ ;
    // own
    if (source === adm.target_) return this.extend_(adm, key, descriptor, false) === null ? 0 /* MakeResult.Cancel */  : 2 /* MakeResult.Continue */ ;
    // prototype
    if (isAction(descriptor.value)) // A prototype could have been annotated already by other constructor,
    // rest of the proto chain must be annotated already
    return 1 /* MakeResult.Break */ ;
    var actionDescriptor = createActionDescriptor(adm, this, key, descriptor, false);
    defineProperty(source, key, actionDescriptor);
    return 2 /* MakeResult.Continue */ ;
}
function extend_$1(adm, key, descriptor, proxyTrap) {
    var actionDescriptor = createActionDescriptor(adm, this, key, descriptor);
    return adm.defineProperty_(key, actionDescriptor, proxyTrap);
}
function decorate_20223_$1(mthd, context) {
    assert20223DecoratorType(context, [
        "method",
        "field"
    ]);
    var kind = context.kind, name = context.name, addInitializer = context.addInitializer;
    var ann = this;
    var _createAction = function _createAction(m) {
        var _ann$options_$name, _ann$options_, _ann$options_$autoAct, _ann$options_2;
        return createAction((_ann$options_$name = (_ann$options_ = ann.options_) == null ? void 0 : _ann$options_.name) != null ? _ann$options_$name : name.toString(), m, (_ann$options_$autoAct = (_ann$options_2 = ann.options_) == null ? void 0 : _ann$options_2.autoAction) != null ? _ann$options_$autoAct : false);
    };
    // Backwards/Legacy behavior, expects makeObservable(this)
    if (kind == "field") {
        addInitializer(function() {
            storeAnnotation(this, name, ann);
        });
        return;
    }
    if (kind == "method") {
        var _this$options_2;
        if (!isAction(mthd)) mthd = _createAction(mthd);
        if ((_this$options_2 = this.options_) != null && _this$options_2.bound) addInitializer(function() {
            var self1 = this;
            var bound = self1[name].bind(self1);
            bound.isMobxAction = true;
            self1[name] = bound;
        });
        return mthd;
    }
    die("Cannot apply '" + ann.annotationType_ + "' to '" + String(name) + "' (kind: " + kind + "):" + ("\n'" + ann.annotationType_ + "' can only be used on properties with a function value."));
}
function assertActionDescriptor(adm, _ref, key, _ref2) {
    var annotationType_ = _ref.annotationType_;
    var value = _ref2.value;
    if (!isFunction(value)) die("Cannot apply '" + annotationType_ + "' to '" + adm.name_ + "." + key.toString() + "':" + ("\n'" + annotationType_ + "' can only be used on properties with a function value."));
}
function createActionDescriptor(adm, annotation, key, descriptor, // provides ability to disable safeDescriptors for prototypes
safeDescriptors) {
    var _annotation$options_, _annotation$options_$, _annotation$options_2, _annotation$options_$2, _annotation$options_3, _annotation$options_4, _adm$proxy_2;
    if (safeDescriptors === void 0) safeDescriptors = globalState.safeDescriptors;
    assertActionDescriptor(adm, annotation, key, descriptor);
    var value = descriptor.value;
    if ((_annotation$options_ = annotation.options_) != null && _annotation$options_.bound) {
        var _adm$proxy_;
        value = value.bind((_adm$proxy_ = adm.proxy_) != null ? _adm$proxy_ : adm.target_);
    }
    return {
        value: createAction((_annotation$options_$ = (_annotation$options_2 = annotation.options_) == null ? void 0 : _annotation$options_2.name) != null ? _annotation$options_$ : key.toString(), value, (_annotation$options_$2 = (_annotation$options_3 = annotation.options_) == null ? void 0 : _annotation$options_3.autoAction) != null ? _annotation$options_$2 : false, // https://github.com/mobxjs/mobx/discussions/3140
        (_annotation$options_4 = annotation.options_) != null && _annotation$options_4.bound ? (_adm$proxy_2 = adm.proxy_) != null ? _adm$proxy_2 : adm.target_ : undefined),
        // Non-configurable for classes
        // prevents accidental field redefinition in subclass
        configurable: safeDescriptors ? adm.isPlainObject_ : true,
        // https://github.com/mobxjs/mobx/pull/2641#issuecomment-737292058
        enumerable: false,
        // Non-obsevable, therefore non-writable
        // Also prevents rewriting in subclass constructor
        writable: safeDescriptors ? false : true
    };
}
function createFlowAnnotation(name, options) {
    return {
        annotationType_: name,
        options_: options,
        make_: make_$2,
        extend_: extend_$2,
        decorate_20223_: decorate_20223_$2
    };
}
function make_$2(adm, key, descriptor, source) {
    var _this$options_;
    // own
    if (source === adm.target_) return this.extend_(adm, key, descriptor, false) === null ? 0 /* MakeResult.Cancel */  : 2 /* MakeResult.Continue */ ;
    // prototype
    // bound - must annotate protos to support super.flow()
    if ((_this$options_ = this.options_) != null && _this$options_.bound && (!hasProp(adm.target_, key) || !isFlow(adm.target_[key]))) {
        if (this.extend_(adm, key, descriptor, false) === null) return 0 /* MakeResult.Cancel */ ;
    }
    if (isFlow(descriptor.value)) // A prototype could have been annotated already by other constructor,
    // rest of the proto chain must be annotated already
    return 1 /* MakeResult.Break */ ;
    var flowDescriptor = createFlowDescriptor(adm, this, key, descriptor, false, false);
    defineProperty(source, key, flowDescriptor);
    return 2 /* MakeResult.Continue */ ;
}
function extend_$2(adm, key, descriptor, proxyTrap) {
    var _this$options_2;
    var flowDescriptor = createFlowDescriptor(adm, this, key, descriptor, (_this$options_2 = this.options_) == null ? void 0 : _this$options_2.bound);
    return adm.defineProperty_(key, flowDescriptor, proxyTrap);
}
function decorate_20223_$2(mthd, context) {
    var _this$options_3;
    assert20223DecoratorType(context, [
        "method"
    ]);
    var name = context.name, addInitializer = context.addInitializer;
    if (!isFlow(mthd)) mthd = flow(mthd);
    if ((_this$options_3 = this.options_) != null && _this$options_3.bound) addInitializer(function() {
        var self1 = this;
        var bound = self1[name].bind(self1);
        bound.isMobXFlow = true;
        self1[name] = bound;
    });
    return mthd;
}
function assertFlowDescriptor(adm, _ref, key, _ref2) {
    var annotationType_ = _ref.annotationType_;
    var value = _ref2.value;
    if (!isFunction(value)) die("Cannot apply '" + annotationType_ + "' to '" + adm.name_ + "." + key.toString() + "':" + ("\n'" + annotationType_ + "' can only be used on properties with a generator function value."));
}
function createFlowDescriptor(adm, annotation, key, descriptor, bound, // provides ability to disable safeDescriptors for prototypes
safeDescriptors) {
    if (safeDescriptors === void 0) safeDescriptors = globalState.safeDescriptors;
    assertFlowDescriptor(adm, annotation, key, descriptor);
    var value = descriptor.value;
    // In case of flow.bound, the descriptor can be from already annotated prototype
    if (!isFlow(value)) value = flow(value);
    if (bound) {
        var _adm$proxy_;
        // We do not keep original function around, so we bind the existing flow
        value = value.bind((_adm$proxy_ = adm.proxy_) != null ? _adm$proxy_ : adm.target_);
        // This is normally set by `flow`, but `bind` returns new function...
        value.isMobXFlow = true;
    }
    return {
        value: value,
        // Non-configurable for classes
        // prevents accidental field redefinition in subclass
        configurable: safeDescriptors ? adm.isPlainObject_ : true,
        // https://github.com/mobxjs/mobx/pull/2641#issuecomment-737292058
        enumerable: false,
        // Non-obsevable, therefore non-writable
        // Also prevents rewriting in subclass constructor
        writable: safeDescriptors ? false : true
    };
}
function createComputedAnnotation(name, options) {
    return {
        annotationType_: name,
        options_: options,
        make_: make_$3,
        extend_: extend_$3,
        decorate_20223_: decorate_20223_$3
    };
}
function make_$3(adm, key, descriptor) {
    return this.extend_(adm, key, descriptor, false) === null ? 0 /* MakeResult.Cancel */  : 1 /* MakeResult.Break */ ;
}
function extend_$3(adm, key, descriptor, proxyTrap) {
    assertComputedDescriptor(adm, this, key, descriptor);
    return adm.defineComputedProperty_(key, _extends({}, this.options_, {
        get: descriptor.get,
        set: descriptor.set
    }), proxyTrap);
}
function decorate_20223_$3(get, context) {
    assert20223DecoratorType(context, [
        "getter"
    ]);
    var ann = this;
    var key = context.name, addInitializer = context.addInitializer;
    addInitializer(function() {
        var adm = asObservableObject(this)[$mobx];
        var options = _extends({}, ann.options_, {
            get: get,
            context: this
        });
        options.name || (options.name = adm.name_ + "." + key.toString());
        adm.values_.set(key, new ComputedValue(options));
    });
    return function() {
        return this[$mobx].getObservablePropValue_(key);
    };
}
function assertComputedDescriptor(adm, _ref, key, _ref2) {
    var annotationType_ = _ref.annotationType_;
    var get = _ref2.get;
    if (!get) die("Cannot apply '" + annotationType_ + "' to '" + adm.name_ + "." + key.toString() + "':" + ("\n'" + annotationType_ + "' can only be used on getter(+setter) properties."));
}
function createObservableAnnotation(name, options) {
    return {
        annotationType_: name,
        options_: options,
        make_: make_$4,
        extend_: extend_$4,
        decorate_20223_: decorate_20223_$4
    };
}
function make_$4(adm, key, descriptor) {
    return this.extend_(adm, key, descriptor, false) === null ? 0 /* MakeResult.Cancel */  : 1 /* MakeResult.Break */ ;
}
function extend_$4(adm, key, descriptor, proxyTrap) {
    var _this$options_$enhanc, _this$options_;
    assertObservableDescriptor(adm, this, key, descriptor);
    return adm.defineObservableProperty_(key, descriptor.value, (_this$options_$enhanc = (_this$options_ = this.options_) == null ? void 0 : _this$options_.enhancer) != null ? _this$options_$enhanc : deepEnhancer, proxyTrap);
}
function decorate_20223_$4(desc, context) {
    if (context.kind === "field") throw die("Please use `@observable accessor " + String(context.name) + "` instead of `@observable " + String(context.name) + "`");
    assert20223DecoratorType(context, [
        "accessor"
    ]);
    var ann = this;
    var kind = context.kind, name = context.name;
    // The laziness here is not ideal... It's a workaround to how 2022.3 Decorators are implemented:
    //   `addInitializer` callbacks are executed _before_ any accessors are defined (instead of the ideal-for-us right after each).
    //   This means that, if we were to do our stuff in an `addInitializer`, we'd attempt to read a private slot
    //   before it has been initialized. The runtime doesn't like that and throws a `Cannot read private member
    //   from an object whose class did not declare it` error.
    // TODO: it seems that this will not be required anymore in the final version of the spec
    // See TODO: link
    var initializedObjects = new WeakSet();
    function initializeObservable(target, value) {
        var _ann$options_$enhance, _ann$options_;
        var adm = asObservableObject(target)[$mobx];
        var observable = new ObservableValue(value, (_ann$options_$enhance = (_ann$options_ = ann.options_) == null ? void 0 : _ann$options_.enhancer) != null ? _ann$options_$enhance : deepEnhancer, adm.name_ + "." + name.toString(), false);
        adm.values_.set(name, observable);
        initializedObjects.add(target);
    }
    if (kind == "accessor") return {
        get: function get() {
            if (!initializedObjects.has(this)) initializeObservable(this, desc.get.call(this));
            return this[$mobx].getObservablePropValue_(name);
        },
        set: function set(value) {
            if (!initializedObjects.has(this)) initializeObservable(this, value);
            return this[$mobx].setObservablePropValue_(name, value);
        },
        init: function init(value) {
            if (!initializedObjects.has(this)) initializeObservable(this, value);
            return value;
        }
    };
    return;
}
function assertObservableDescriptor(adm, _ref, key, descriptor) {
    var annotationType_ = _ref.annotationType_;
    if (!("value" in descriptor)) die("Cannot apply '" + annotationType_ + "' to '" + adm.name_ + "." + key.toString() + "':" + ("\n'" + annotationType_ + "' cannot be used on getter/setter properties"));
}
var AUTO = "true";
var autoAnnotation = /*#__PURE__*/ createAutoAnnotation();
function createAutoAnnotation(options) {
    return {
        annotationType_: AUTO,
        options_: options,
        make_: make_$5,
        extend_: extend_$5,
        decorate_20223_: decorate_20223_$5
    };
}
function make_$5(adm, key, descriptor, source) {
    var _this$options_3, _this$options_4;
    // getter -> computed
    if (descriptor.get) return computed.make_(adm, key, descriptor, source);
    // lone setter -> action setter
    if (descriptor.set) {
        // TODO make action applicable to setter and delegate to action.make_
        var set = createAction(key.toString(), descriptor.set);
        // own
        if (source === adm.target_) return adm.defineProperty_(key, {
            configurable: globalState.safeDescriptors ? adm.isPlainObject_ : true,
            set: set
        }) === null ? 0 /* MakeResult.Cancel */  : 2 /* MakeResult.Continue */ ;
        // proto
        defineProperty(source, key, {
            configurable: true,
            set: set
        });
        return 2 /* MakeResult.Continue */ ;
    }
    // function on proto -> autoAction/flow
    if (source !== adm.target_ && typeof descriptor.value === "function") {
        var _this$options_2;
        if (isGenerator(descriptor.value)) {
            var _this$options_;
            var flowAnnotation = (_this$options_ = this.options_) != null && _this$options_.autoBind ? flow.bound : flow;
            return flowAnnotation.make_(adm, key, descriptor, source);
        }
        var actionAnnotation = (_this$options_2 = this.options_) != null && _this$options_2.autoBind ? autoAction.bound : autoAction;
        return actionAnnotation.make_(adm, key, descriptor, source);
    }
    // other -> observable
    // Copy props from proto as well, see test:
    // "decorate should work with Object.create"
    var observableAnnotation = ((_this$options_3 = this.options_) == null ? void 0 : _this$options_3.deep) === false ? observable.ref : observable;
    // if function respect autoBind option
    if (typeof descriptor.value === "function" && (_this$options_4 = this.options_) != null && _this$options_4.autoBind) {
        var _adm$proxy_;
        descriptor.value = descriptor.value.bind((_adm$proxy_ = adm.proxy_) != null ? _adm$proxy_ : adm.target_);
    }
    return observableAnnotation.make_(adm, key, descriptor, source);
}
function extend_$5(adm, key, descriptor, proxyTrap) {
    var _this$options_5, _this$options_6;
    // getter -> computed
    if (descriptor.get) return computed.extend_(adm, key, descriptor, proxyTrap);
    // lone setter -> action setter
    if (descriptor.set) // TODO make action applicable to setter and delegate to action.extend_
    return adm.defineProperty_(key, {
        configurable: globalState.safeDescriptors ? adm.isPlainObject_ : true,
        set: createAction(key.toString(), descriptor.set)
    }, proxyTrap);
    // other -> observable
    // if function respect autoBind option
    if (typeof descriptor.value === "function" && (_this$options_5 = this.options_) != null && _this$options_5.autoBind) {
        var _adm$proxy_2;
        descriptor.value = descriptor.value.bind((_adm$proxy_2 = adm.proxy_) != null ? _adm$proxy_2 : adm.target_);
    }
    var observableAnnotation = ((_this$options_6 = this.options_) == null ? void 0 : _this$options_6.deep) === false ? observable.ref : observable;
    return observableAnnotation.extend_(adm, key, descriptor, proxyTrap);
}
function decorate_20223_$5(desc, context) {
    die("'" + this.annotationType_ + "' cannot be used as a decorator");
}
var OBSERVABLE = "observable";
var OBSERVABLE_REF = "observable.ref";
var OBSERVABLE_SHALLOW = "observable.shallow";
var OBSERVABLE_STRUCT = "observable.struct";
// Predefined bags of create observable options, to avoid allocating temporarily option objects
// in the majority of cases
var defaultCreateObservableOptions = {
    deep: true,
    name: undefined,
    defaultDecorator: undefined,
    proxy: true
};
Object.freeze(defaultCreateObservableOptions);
function asCreateObservableOptions(thing) {
    return thing || defaultCreateObservableOptions;
}
var observableAnnotation = /*#__PURE__*/ createObservableAnnotation(OBSERVABLE);
var observableRefAnnotation = /*#__PURE__*/ createObservableAnnotation(OBSERVABLE_REF, {
    enhancer: referenceEnhancer
});
var observableShallowAnnotation = /*#__PURE__*/ createObservableAnnotation(OBSERVABLE_SHALLOW, {
    enhancer: shallowEnhancer
});
var observableStructAnnotation = /*#__PURE__*/ createObservableAnnotation(OBSERVABLE_STRUCT, {
    enhancer: refStructEnhancer
});
var observableDecoratorAnnotation = /*#__PURE__*/ createDecoratorAnnotation(observableAnnotation);
function getEnhancerFromOptions(options) {
    return options.deep === true ? deepEnhancer : options.deep === false ? referenceEnhancer : getEnhancerFromAnnotation(options.defaultDecorator);
}
function getAnnotationFromOptions(options) {
    var _options$defaultDecor;
    return options ? (_options$defaultDecor = options.defaultDecorator) != null ? _options$defaultDecor : createAutoAnnotation(options) : undefined;
}
function getEnhancerFromAnnotation(annotation) {
    var _annotation$options_$, _annotation$options_;
    return !annotation ? deepEnhancer : (_annotation$options_$ = (_annotation$options_ = annotation.options_) == null ? void 0 : _annotation$options_.enhancer) != null ? _annotation$options_$ : deepEnhancer;
}
/**
 * Turns an object, array or function into a reactive structure.
 * @param v the value which should become observable.
 */ function createObservable(v, arg2, arg3) {
    // @observable someProp; (2022.3 Decorators)
    if (is20223Decorator(arg2)) return observableAnnotation.decorate_20223_(v, arg2);
    // @observable someProp;
    if (isStringish(arg2)) {
        storeAnnotation(v, arg2, observableAnnotation);
        return;
    }
    // already observable - ignore
    if (isObservable(v)) return v;
    // plain object
    if (isPlainObject(v)) return observable.object(v, arg2, arg3);
    // Array
    if (Array.isArray(v)) return observable.array(v, arg2);
    // Map
    if (isES6Map(v)) return observable.map(v, arg2);
    // Set
    if (isES6Set(v)) return observable.set(v, arg2);
    // other object - ignore
    if (typeof v === "object" && v !== null) return v;
    // anything else
    return observable.box(v, arg2);
}
assign(createObservable, observableDecoratorAnnotation);
var observableFactories = {
    box: function box(value, options) {
        var o = asCreateObservableOptions(options);
        return new ObservableValue(value, getEnhancerFromOptions(o), o.name, true, o.equals);
    },
    array: function array(initialValues, options) {
        var o = asCreateObservableOptions(options);
        return (globalState.useProxies === false || o.proxy === false ? createLegacyArray : createObservableArray)(initialValues, getEnhancerFromOptions(o), o.name);
    },
    map: function map(initialValues, options) {
        var o = asCreateObservableOptions(options);
        return new ObservableMap(initialValues, getEnhancerFromOptions(o), o.name);
    },
    set: function set(initialValues, options) {
        var o = asCreateObservableOptions(options);
        return new ObservableSet(initialValues, getEnhancerFromOptions(o), o.name);
    },
    object: function object(props, decorators, options) {
        return initObservable(function() {
            return extendObservable(globalState.useProxies === false || (options == null ? void 0 : options.proxy) === false ? asObservableObject({}, options) : asDynamicObservableObject({}, options), props, decorators);
        });
    },
    ref: /*#__PURE__*/ createDecoratorAnnotation(observableRefAnnotation),
    shallow: /*#__PURE__*/ createDecoratorAnnotation(observableShallowAnnotation),
    deep: observableDecoratorAnnotation,
    struct: /*#__PURE__*/ createDecoratorAnnotation(observableStructAnnotation)
};
// eslint-disable-next-line
var observable = /*#__PURE__*/ assign(createObservable, observableFactories);
var COMPUTED = "computed";
var COMPUTED_STRUCT = "computed.struct";
var computedAnnotation = /*#__PURE__*/ createComputedAnnotation(COMPUTED);
var computedStructAnnotation = /*#__PURE__*/ createComputedAnnotation(COMPUTED_STRUCT, {
    equals: comparer.structural
});
/**
 * Decorator for class properties: @computed get value() { return expr; }.
 * For legacy purposes also invokable as ES5 observable created: `computed(() => expr)`;
 */ var computed = function computed(arg1, arg2) {
    if (is20223Decorator(arg2)) // @computed (2022.3 Decorators)
    return computedAnnotation.decorate_20223_(arg1, arg2);
    if (isStringish(arg2)) // @computed
    return storeAnnotation(arg1, arg2, computedAnnotation);
    if (isPlainObject(arg1)) // @computed({ options })
    return createDecoratorAnnotation(createComputedAnnotation(COMPUTED, arg1));
    if (!isFunction(arg1)) die("First argument to `computed` should be an expression.");
    if (isFunction(arg2)) die("A setter as second argument is no longer supported, use `{ set: fn }` option instead");
    var opts = isPlainObject(arg2) ? arg2 : {};
    opts.get = arg1;
    opts.name || (opts.name = arg1.name || ""); /* for generated name */ 
    return new ComputedValue(opts);
};
Object.assign(computed, computedAnnotation);
computed.struct = /*#__PURE__*/ createDecoratorAnnotation(computedStructAnnotation);
var _getDescriptor$config, _getDescriptor;
// we don't use globalState for these in order to avoid possible issues with multiple
// mobx versions
var currentActionId = 0;
var nextActionId = 1;
var isFunctionNameConfigurable = (_getDescriptor$config = (_getDescriptor = /*#__PURE__*/ getDescriptor(function() {}, "name")) == null ? void 0 : _getDescriptor.configurable) != null ? _getDescriptor$config : false;
// we can safely recycle this object
var tmpNameDescriptor = {
    value: "action",
    configurable: true,
    writable: false,
    enumerable: false
};
function createAction(actionName, fn, autoAction, ref) {
    if (autoAction === void 0) autoAction = false;
    if (!isFunction(fn)) die("`action` can only be invoked on functions");
    if (typeof actionName !== "string" || !actionName) die("actions should have valid names, got: '" + actionName + "'");
    function res() {
        return executeAction(actionName, autoAction, fn, ref || this, arguments);
    }
    res.isMobxAction = true;
    res.toString = function() {
        return fn.toString();
    };
    if (isFunctionNameConfigurable) {
        tmpNameDescriptor.value = actionName;
        defineProperty(res, "name", tmpNameDescriptor);
    }
    return res;
}
function executeAction(actionName, canRunAsDerivation, fn, scope, args) {
    var runInfo = _startAction(actionName, canRunAsDerivation, scope, args);
    try {
        return fn.apply(scope, args);
    } catch (err) {
        runInfo.error_ = err;
        throw err;
    } finally{
        _endAction(runInfo);
    }
}
function _startAction(actionName, canRunAsDerivation, // true for autoAction
scope, args) {
    var notifySpy_ = isSpyEnabled() && !!actionName;
    var startTime_ = 0;
    if (notifySpy_) {
        startTime_ = Date.now();
        var flattenedArgs = args ? Array.from(args) : EMPTY_ARRAY;
        spyReportStart({
            type: ACTION,
            name: actionName,
            object: scope,
            arguments: flattenedArgs
        });
    }
    var prevDerivation_ = globalState.trackingDerivation;
    var runAsAction = !canRunAsDerivation || !prevDerivation_;
    startBatch();
    var prevAllowStateChanges_ = globalState.allowStateChanges; // by default preserve previous allow
    if (runAsAction) {
        untrackedStart();
        prevAllowStateChanges_ = allowStateChangesStart(true);
    }
    var prevAllowStateReads_ = allowStateReadsStart(true);
    var runInfo = {
        runAsAction_: runAsAction,
        prevDerivation_: prevDerivation_,
        prevAllowStateChanges_: prevAllowStateChanges_,
        prevAllowStateReads_: prevAllowStateReads_,
        notifySpy_: notifySpy_,
        startTime_: startTime_,
        actionId_: nextActionId++,
        parentActionId_: currentActionId
    };
    currentActionId = runInfo.actionId_;
    return runInfo;
}
function _endAction(runInfo) {
    if (currentActionId !== runInfo.actionId_) die(30);
    currentActionId = runInfo.parentActionId_;
    if (runInfo.error_ !== undefined) globalState.suppressReactionErrors = true;
    allowStateChangesEnd(runInfo.prevAllowStateChanges_);
    allowStateReadsEnd(runInfo.prevAllowStateReads_);
    endBatch();
    if (runInfo.runAsAction_) untrackedEnd(runInfo.prevDerivation_);
    if (0, runInfo.notifySpy_) spyReportEnd({
        time: Date.now() - runInfo.startTime_
    });
    globalState.suppressReactionErrors = false;
}
function allowStateChanges(allowStateChanges, func) {
    var prev = allowStateChangesStart(allowStateChanges);
    try {
        return func();
    } finally{
        allowStateChangesEnd(prev);
    }
}
function allowStateChangesStart(allowStateChanges) {
    var prev = globalState.allowStateChanges;
    globalState.allowStateChanges = allowStateChanges;
    return prev;
}
function allowStateChangesEnd(prev) {
    globalState.allowStateChanges = prev;
}
var _Symbol$toPrimitive;
var CREATE = "create";
_Symbol$toPrimitive = Symbol.toPrimitive;
var ObservableValue = /*#__PURE__*/ function(_Atom) {
    _inheritsLoose(ObservableValue, _Atom);
    function ObservableValue(value, enhancer, name_, notifySpy, equals) {
        var _this;
        if (name_ === void 0) name_ = "ObservableValue@" + getNextId();
        if (notifySpy === void 0) notifySpy = true;
        if (equals === void 0) equals = comparer["default"];
        _this = _Atom.call(this, name_) || this;
        _this.enhancer = void 0;
        _this.name_ = void 0;
        _this.equals = void 0;
        _this.hasUnreportedChange_ = false;
        _this.interceptors_ = void 0;
        _this.changeListeners_ = void 0;
        _this.value_ = void 0;
        _this.dehancer = void 0;
        _this.enhancer = enhancer;
        _this.name_ = name_;
        _this.equals = equals;
        _this.value_ = enhancer(value, undefined, name_);
        if (notifySpy && isSpyEnabled()) // only notify spy if this is a stand-alone observable
        spyReport({
            type: CREATE,
            object: _assertThisInitialized(_this),
            observableKind: "value",
            debugObjectName: _this.name_,
            newValue: "" + _this.value_
        });
        return _this;
    }
    var _proto = ObservableValue.prototype;
    _proto.dehanceValue = function dehanceValue(value) {
        if (this.dehancer !== undefined) return this.dehancer(value);
        return value;
    };
    _proto.set = function set(newValue) {
        var oldValue = this.value_;
        newValue = this.prepareNewValue_(newValue);
        if (newValue !== globalState.UNCHANGED) {
            var notifySpy = isSpyEnabled();
            if (notifySpy) spyReportStart({
                type: UPDATE,
                object: this,
                observableKind: "value",
                debugObjectName: this.name_,
                newValue: newValue,
                oldValue: oldValue
            });
            this.setNewValue_(newValue);
            if (notifySpy) spyReportEnd();
        }
    };
    _proto.prepareNewValue_ = function prepareNewValue_(newValue) {
        checkIfStateModificationsAreAllowed(this);
        if (hasInterceptors(this)) {
            var change = interceptChange(this, {
                object: this,
                type: UPDATE,
                newValue: newValue
            });
            if (!change) return globalState.UNCHANGED;
            newValue = change.newValue;
        }
        // apply modifier
        newValue = this.enhancer(newValue, this.value_, this.name_);
        return this.equals(this.value_, newValue) ? globalState.UNCHANGED : newValue;
    };
    _proto.setNewValue_ = function setNewValue_(newValue) {
        var oldValue = this.value_;
        this.value_ = newValue;
        this.reportChanged();
        if (hasListeners(this)) notifyListeners(this, {
            type: UPDATE,
            object: this,
            newValue: newValue,
            oldValue: oldValue
        });
    };
    _proto.get = function get() {
        this.reportObserved();
        return this.dehanceValue(this.value_);
    };
    _proto.intercept_ = function intercept_(handler) {
        return registerInterceptor(this, handler);
    };
    _proto.observe_ = function observe_(listener, fireImmediately) {
        if (fireImmediately) listener({
            observableKind: "value",
            debugObjectName: this.name_,
            object: this,
            type: UPDATE,
            newValue: this.value_,
            oldValue: undefined
        });
        return registerListener(this, listener);
    };
    _proto.raw = function raw() {
        // used by MST ot get undehanced value
        return this.value_;
    };
    _proto.toJSON = function toJSON() {
        return this.get();
    };
    _proto.toString = function toString() {
        return this.name_ + "[" + this.value_ + "]";
    };
    _proto.valueOf = function valueOf() {
        return toPrimitive(this.get());
    };
    _proto[_Symbol$toPrimitive] = function() {
        return this.valueOf();
    };
    return ObservableValue;
}(Atom);
var isObservableValue = /*#__PURE__*/ createInstanceofPredicate("ObservableValue", ObservableValue);
var _Symbol$toPrimitive$1;
/**
 * A node in the state dependency root that observes other nodes, and can be observed itself.
 *
 * ComputedValue will remember the result of the computation for the duration of the batch, or
 * while being observed.
 *
 * During this time it will recompute only when one of its direct dependencies changed,
 * but only when it is being accessed with `ComputedValue.get()`.
 *
 * Implementation description:
 * 1. First time it's being accessed it will compute and remember result
 *    give back remembered result until 2. happens
 * 2. First time any deep dependency change, propagate POSSIBLY_STALE to all observers, wait for 3.
 * 3. When it's being accessed, recompute if any shallow dependency changed.
 *    if result changed: propagate STALE to all observers, that were POSSIBLY_STALE from the last step.
 *    go to step 2. either way
 *
 * If at any point it's outside batch and it isn't observed: reset everything and go to 1.
 */ _Symbol$toPrimitive$1 = Symbol.toPrimitive;
var ComputedValue = /*#__PURE__*/ function() {
    // nodes we are looking at. Our value depends on these nodes
    // during tracking it's an array with new observed observers
    // to check for cycles
    // N.B: unminified as it is used by MST
    /**
   * Create a new computed value based on a function expression.
   *
   * The `name` property is for debug purposes only.
   *
   * The `equals` property specifies the comparer function to use to determine if a newly produced
   * value differs from the previous value. Two comparers are provided in the library; `defaultComparer`
   * compares based on identity comparison (===), and `structuralComparer` deeply compares the structure.
   * Structural comparison can be convenient if you always produce a new aggregated object and
   * don't want to notify observers if it is structurally the same.
   * This is useful for working with vectors, mouse coordinates etc.
   */ function ComputedValue(options) {
        this.dependenciesState_ = IDerivationState_.NOT_TRACKING_;
        this.observing_ = [];
        this.newObserving_ = null;
        this.isBeingObserved_ = false;
        this.isPendingUnobservation_ = false;
        this.observers_ = new Set();
        this.diffValue_ = 0;
        this.runId_ = 0;
        this.lastAccessedBy_ = 0;
        this.lowestObserverState_ = IDerivationState_.UP_TO_DATE_;
        this.unboundDepsCount_ = 0;
        this.value_ = new CaughtException(null);
        this.name_ = void 0;
        this.triggeredBy_ = void 0;
        this.isComputing_ = false;
        this.isRunningSetter_ = false;
        this.derivation = void 0;
        this.setter_ = void 0;
        this.isTracing_ = TraceMode.NONE;
        this.scope_ = void 0;
        this.equals_ = void 0;
        this.requiresReaction_ = void 0;
        this.keepAlive_ = void 0;
        this.onBOL = void 0;
        this.onBUOL = void 0;
        if (!options.get) die(31);
        this.derivation = options.get;
        this.name_ = options.name || "ComputedValue@" + getNextId();
        if (options.set) this.setter_ = createAction(this.name_ + "-setter", options.set);
        this.equals_ = options.equals || (options.compareStructural || options.struct ? comparer.structural : comparer["default"]);
        this.scope_ = options.context;
        this.requiresReaction_ = options.requiresReaction;
        this.keepAlive_ = !!options.keepAlive;
    }
    var _proto = ComputedValue.prototype;
    _proto.onBecomeStale_ = function onBecomeStale_() {
        propagateMaybeChanged(this);
    };
    _proto.onBO = function onBO() {
        if (this.onBOL) this.onBOL.forEach(function(listener) {
            return listener();
        });
    };
    _proto.onBUO = function onBUO() {
        if (this.onBUOL) this.onBUOL.forEach(function(listener) {
            return listener();
        });
    } /**
   * Returns the current value of this computed value.
   * Will evaluate its computation first if needed.
   */ ;
    _proto.get = function get() {
        if (this.isComputing_) die(32, this.name_, this.derivation);
        if (globalState.inBatch === 0 && // !globalState.trackingDerivatpion &&
        this.observers_.size === 0 && !this.keepAlive_) {
            if (shouldCompute(this)) {
                this.warnAboutUntrackedRead_();
                startBatch(); // See perf test 'computed memoization'
                this.value_ = this.computeValue_(false);
                endBatch();
            }
        } else {
            reportObserved(this);
            if (shouldCompute(this)) {
                var prevTrackingContext = globalState.trackingContext;
                if (this.keepAlive_ && !prevTrackingContext) globalState.trackingContext = this;
                if (this.trackAndCompute()) propagateChangeConfirmed(this);
                globalState.trackingContext = prevTrackingContext;
            }
        }
        var result = this.value_;
        if (isCaughtException(result)) throw result.cause;
        return result;
    };
    _proto.set = function set(value) {
        if (this.setter_) {
            if (this.isRunningSetter_) die(33, this.name_);
            this.isRunningSetter_ = true;
            try {
                this.setter_.call(this.scope_, value);
            } finally{
                this.isRunningSetter_ = false;
            }
        } else die(34, this.name_);
    };
    _proto.trackAndCompute = function trackAndCompute() {
        // N.B: unminified as it is used by MST
        var oldValue = this.value_;
        var wasSuspended = /* see #1208 */ this.dependenciesState_ === IDerivationState_.NOT_TRACKING_;
        var newValue = this.computeValue_(true);
        var changed = wasSuspended || isCaughtException(oldValue) || isCaughtException(newValue) || !this.equals_(oldValue, newValue);
        if (changed) {
            this.value_ = newValue;
            if (isSpyEnabled()) spyReport({
                observableKind: "computed",
                debugObjectName: this.name_,
                object: this.scope_,
                type: "update",
                oldValue: oldValue,
                newValue: newValue
            });
        }
        return changed;
    };
    _proto.computeValue_ = function computeValue_(track) {
        this.isComputing_ = true;
        // don't allow state changes during computation
        var prev = allowStateChangesStart(false);
        var res;
        if (track) res = trackDerivedFunction(this, this.derivation, this.scope_);
        else {
            if (globalState.disableErrorBoundaries === true) res = this.derivation.call(this.scope_);
            else try {
                res = this.derivation.call(this.scope_);
            } catch (e) {
                res = new CaughtException(e);
            }
        }
        allowStateChangesEnd(prev);
        this.isComputing_ = false;
        return res;
    };
    _proto.suspend_ = function suspend_() {
        if (!this.keepAlive_) {
            clearObserving(this);
            this.value_ = undefined; // don't hold on to computed value!
            if (this.isTracing_ !== TraceMode.NONE) console.log("[mobx.trace] Computed value '" + this.name_ + "' was suspended and it will recompute on the next access.");
        }
    };
    _proto.observe_ = function observe_(listener, fireImmediately) {
        var _this = this;
        var firstTime = true;
        var prevValue = undefined;
        return autorun(function() {
            // TODO: why is this in a different place than the spyReport() function? in all other observables it's called in the same place
            var newValue = _this.get();
            if (!firstTime || fireImmediately) {
                var prevU = untrackedStart();
                listener({
                    observableKind: "computed",
                    debugObjectName: _this.name_,
                    type: UPDATE,
                    object: _this,
                    newValue: newValue,
                    oldValue: prevValue
                });
                untrackedEnd(prevU);
            }
            firstTime = false;
            prevValue = newValue;
        });
    };
    _proto.warnAboutUntrackedRead_ = function warnAboutUntrackedRead_() {
        if (this.isTracing_ !== TraceMode.NONE) console.log("[mobx.trace] Computed value '" + this.name_ + "' is being read outside a reactive context. Doing a full recompute.");
        if (typeof this.requiresReaction_ === "boolean" ? this.requiresReaction_ : globalState.computedRequiresReaction) console.warn("[mobx] Computed value '" + this.name_ + "' is being read outside a reactive context. Doing a full recompute.");
    };
    _proto.toString = function toString() {
        return this.name_ + "[" + this.derivation.toString() + "]";
    };
    _proto.valueOf = function valueOf() {
        return toPrimitive(this.get());
    };
    _proto[_Symbol$toPrimitive$1] = function() {
        return this.valueOf();
    };
    return ComputedValue;
}();
var isComputedValue = /*#__PURE__*/ createInstanceofPredicate("ComputedValue", ComputedValue);
var IDerivationState_;
(function(IDerivationState_) {
    // before being run or (outside batch and not being observed)
    // at this point derivation is not holding any data about dependency tree
    IDerivationState_[IDerivationState_["NOT_TRACKING_"] = -1] = "NOT_TRACKING_";
    // no shallow dependency changed since last computation
    // won't recalculate derivation
    // this is what makes mobx fast
    IDerivationState_[IDerivationState_["UP_TO_DATE_"] = 0] = "UP_TO_DATE_";
    // some deep dependency changed, but don't know if shallow dependency changed
    // will require to check first if UP_TO_DATE or POSSIBLY_STALE
    // currently only ComputedValue will propagate POSSIBLY_STALE
    //
    // having this state is second big optimization:
    // don't have to recompute on every dependency change, but only when it's needed
    IDerivationState_[IDerivationState_["POSSIBLY_STALE_"] = 1] = "POSSIBLY_STALE_";
    // A shallow dependency has changed since last computation and the derivation
    // will need to recompute when it's needed next.
    IDerivationState_[IDerivationState_["STALE_"] = 2] = "STALE_";
})(IDerivationState_ || (IDerivationState_ = {}));
var TraceMode;
(function(TraceMode) {
    TraceMode[TraceMode["NONE"] = 0] = "NONE";
    TraceMode[TraceMode["LOG"] = 1] = "LOG";
    TraceMode[TraceMode["BREAK"] = 2] = "BREAK";
})(TraceMode || (TraceMode = {}));
var CaughtException = function CaughtException(cause) {
    this.cause = void 0;
    this.cause = cause;
// Empty
};
function isCaughtException(e) {
    return e instanceof CaughtException;
}
/**
 * Finds out whether any dependency of the derivation has actually changed.
 * If dependenciesState is 1 then it will recalculate dependencies,
 * if any dependency changed it will propagate it by changing dependenciesState to 2.
 *
 * By iterating over the dependencies in the same order that they were reported and
 * stopping on the first change, all the recalculations are only called for ComputedValues
 * that will be tracked by derivation. That is because we assume that if the first x
 * dependencies of the derivation doesn't change then the derivation should run the same way
 * up until accessing x-th dependency.
 */ function shouldCompute(derivation) {
    switch(derivation.dependenciesState_){
        case IDerivationState_.UP_TO_DATE_:
            return false;
        case IDerivationState_.NOT_TRACKING_:
        case IDerivationState_.STALE_:
            return true;
        case IDerivationState_.POSSIBLY_STALE_:
            // state propagation can occur outside of action/reactive context #2195
            var prevAllowStateReads = allowStateReadsStart(true);
            var prevUntracked = untrackedStart(); // no need for those computeds to be reported, they will be picked up in trackDerivedFunction.
            var obs = derivation.observing_, l = obs.length;
            for(var i = 0; i < l; i++){
                var obj = obs[i];
                if (isComputedValue(obj)) {
                    if (globalState.disableErrorBoundaries) obj.get();
                    else try {
                        obj.get();
                    } catch (e) {
                        // we are not interested in the value *or* exception at this moment, but if there is one, notify all
                        untrackedEnd(prevUntracked);
                        allowStateReadsEnd(prevAllowStateReads);
                        return true;
                    }
                    // if ComputedValue `obj` actually changed it will be computed and propagated to its observers.
                    // and `derivation` is an observer of `obj`
                    // invariantShouldCompute(derivation)
                    if (derivation.dependenciesState_ === IDerivationState_.STALE_) {
                        untrackedEnd(prevUntracked);
                        allowStateReadsEnd(prevAllowStateReads);
                        return true;
                    }
                }
            }
            changeDependenciesStateTo0(derivation);
            untrackedEnd(prevUntracked);
            allowStateReadsEnd(prevAllowStateReads);
            return false;
    }
}
function isComputingDerivation() {
    return globalState.trackingDerivation !== null; // filter out actions inside computations
}
function checkIfStateModificationsAreAllowed(atom) {
    var hasObservers = atom.observers_.size > 0;
    // Should not be possible to change observed state outside strict mode, except during initialization, see #563
    if (!globalState.allowStateChanges && (hasObservers || globalState.enforceActions === "always")) console.warn("[MobX] " + (globalState.enforceActions ? "Since strict-mode is enabled, changing (observed) observable values without using an action is not allowed. Tried to modify: " : "Side effects like changing state are not allowed at this point. Are you trying to modify state from, for example, a computed value or the render function of a React component? You can wrap side effects in 'runInAction' (or decorate functions with 'action') if needed. Tried to modify: ") + atom.name_);
}
function checkIfStateReadsAreAllowed(observable) {
    if (!globalState.allowStateReads && globalState.observableRequiresReaction) console.warn("[mobx] Observable '" + observable.name_ + "' being read outside a reactive context.");
}
/**
 * Executes the provided function `f` and tracks which observables are being accessed.
 * The tracking information is stored on the `derivation` object and the derivation is registered
 * as observer of any of the accessed observables.
 */ function trackDerivedFunction(derivation, f, context) {
    var prevAllowStateReads = allowStateReadsStart(true);
    // pre allocate array allocation + room for variation in deps
    // array will be trimmed by bindDependencies
    changeDependenciesStateTo0(derivation);
    derivation.newObserving_ = new Array(derivation.observing_.length + 100);
    derivation.unboundDepsCount_ = 0;
    derivation.runId_ = ++globalState.runId;
    var prevTracking = globalState.trackingDerivation;
    globalState.trackingDerivation = derivation;
    globalState.inBatch++;
    var result;
    if (globalState.disableErrorBoundaries === true) result = f.call(context);
    else try {
        result = f.call(context);
    } catch (e) {
        result = new CaughtException(e);
    }
    globalState.inBatch--;
    globalState.trackingDerivation = prevTracking;
    bindDependencies(derivation);
    warnAboutDerivationWithoutDependencies(derivation);
    allowStateReadsEnd(prevAllowStateReads);
    return result;
}
function warnAboutDerivationWithoutDependencies(derivation) {
    if (derivation.observing_.length !== 0) return;
    if (typeof derivation.requiresObservable_ === "boolean" ? derivation.requiresObservable_ : globalState.reactionRequiresObservable) console.warn("[mobx] Derivation '" + derivation.name_ + "' is created/updated without reading any observable value.");
}
/**
 * diffs newObserving with observing.
 * update observing to be newObserving with unique observables
 * notify observers that become observed/unobserved
 */ function bindDependencies(derivation) {
    // invariant(derivation.dependenciesState !== IDerivationState.NOT_TRACKING, "INTERNAL ERROR bindDependencies expects derivation.dependenciesState !== -1");
    var prevObserving = derivation.observing_;
    var observing = derivation.observing_ = derivation.newObserving_;
    var lowestNewObservingDerivationState = IDerivationState_.UP_TO_DATE_;
    // Go through all new observables and check diffValue: (this list can contain duplicates):
    //   0: first occurrence, change to 1 and keep it
    //   1: extra occurrence, drop it
    var i0 = 0, l = derivation.unboundDepsCount_;
    for(var i = 0; i < l; i++){
        var dep = observing[i];
        if (dep.diffValue_ === 0) {
            dep.diffValue_ = 1;
            if (i0 !== i) observing[i0] = dep;
            i0++;
        }
        // Upcast is 'safe' here, because if dep is IObservable, `dependenciesState` will be undefined,
        // not hitting the condition
        if (dep.dependenciesState_ > lowestNewObservingDerivationState) lowestNewObservingDerivationState = dep.dependenciesState_;
    }
    observing.length = i0;
    derivation.newObserving_ = null; // newObserving shouldn't be needed outside tracking (statement moved down to work around FF bug, see #614)
    // Go through all old observables and check diffValue: (it is unique after last bindDependencies)
    //   0: it's not in new observables, unobserve it
    //   1: it keeps being observed, don't want to notify it. change to 0
    l = prevObserving.length;
    while(l--){
        var _dep = prevObserving[l];
        if (_dep.diffValue_ === 0) removeObserver(_dep, derivation);
        _dep.diffValue_ = 0;
    }
    // Go through all new observables and check diffValue: (now it should be unique)
    //   0: it was set to 0 in last loop. don't need to do anything.
    //   1: it wasn't observed, let's observe it. set back to 0
    while(i0--){
        var _dep2 = observing[i0];
        if (_dep2.diffValue_ === 1) {
            _dep2.diffValue_ = 0;
            addObserver(_dep2, derivation);
        }
    }
    // Some new observed derivations may become stale during this derivation computation
    // so they have had no chance to propagate staleness (#916)
    if (lowestNewObservingDerivationState !== IDerivationState_.UP_TO_DATE_) {
        derivation.dependenciesState_ = lowestNewObservingDerivationState;
        derivation.onBecomeStale_();
    }
}
function clearObserving(derivation) {
    // invariant(globalState.inBatch > 0, "INTERNAL ERROR clearObserving should be called only inside batch");
    var obs = derivation.observing_;
    derivation.observing_ = [];
    var i = obs.length;
    while(i--)removeObserver(obs[i], derivation);
    derivation.dependenciesState_ = IDerivationState_.NOT_TRACKING_;
}
function untracked(action) {
    var prev = untrackedStart();
    try {
        return action();
    } finally{
        untrackedEnd(prev);
    }
}
function untrackedStart() {
    var prev = globalState.trackingDerivation;
    globalState.trackingDerivation = null;
    return prev;
}
function untrackedEnd(prev) {
    globalState.trackingDerivation = prev;
}
function allowStateReadsStart(allowStateReads) {
    var prev = globalState.allowStateReads;
    globalState.allowStateReads = allowStateReads;
    return prev;
}
function allowStateReadsEnd(prev) {
    globalState.allowStateReads = prev;
}
/**
 * needed to keep `lowestObserverState` correct. when changing from (2 or 1) to 0
 *
 */ function changeDependenciesStateTo0(derivation) {
    if (derivation.dependenciesState_ === IDerivationState_.UP_TO_DATE_) return;
    derivation.dependenciesState_ = IDerivationState_.UP_TO_DATE_;
    var obs = derivation.observing_;
    var i = obs.length;
    while(i--)obs[i].lowestObserverState_ = IDerivationState_.UP_TO_DATE_;
}
/**
 * These values will persist if global state is reset
 */ var persistentKeys = [
    "mobxGuid",
    "spyListeners",
    "enforceActions",
    "computedRequiresReaction",
    "reactionRequiresObservable",
    "observableRequiresReaction",
    "allowStateReads",
    "disableErrorBoundaries",
    "runId",
    "UNCHANGED",
    "useProxies"
];
var MobXGlobals = function MobXGlobals() {
    this.version = 6;
    this.UNCHANGED = {};
    this.trackingDerivation = null;
    this.trackingContext = null;
    this.runId = 0;
    this.mobxGuid = 0;
    this.inBatch = 0;
    this.pendingUnobservations = [];
    this.pendingReactions = [];
    this.isRunningReactions = false;
    this.allowStateChanges = false;
    this.allowStateReads = true;
    this.enforceActions = true;
    this.spyListeners = [];
    this.globalReactionErrorHandlers = [];
    this.computedRequiresReaction = false;
    this.reactionRequiresObservable = false;
    this.observableRequiresReaction = false;
    this.disableErrorBoundaries = false;
    this.suppressReactionErrors = false;
    this.useProxies = true;
    this.verifyProxies = false;
    this.safeDescriptors = true;
};
var canMergeGlobalState = true;
var isolateCalled = false;
var globalState = /*#__PURE__*/ function() {
    var global1 = /*#__PURE__*/ getGlobal();
    if (global1.__mobxInstanceCount > 0 && !global1.__mobxGlobals) canMergeGlobalState = false;
    if (global1.__mobxGlobals && global1.__mobxGlobals.version !== new MobXGlobals().version) canMergeGlobalState = false;
    if (!canMergeGlobalState) {
        // Because this is a IIFE we need to let isolateCalled a chance to change
        // so we run it after the event loop completed at least 1 iteration
        setTimeout(function() {
            if (!isolateCalled) die(35);
        }, 1);
        return new MobXGlobals();
    } else if (global1.__mobxGlobals) {
        global1.__mobxInstanceCount += 1;
        if (!global1.__mobxGlobals.UNCHANGED) global1.__mobxGlobals.UNCHANGED = {};
         // make merge backward compatible
        return global1.__mobxGlobals;
    } else {
        global1.__mobxInstanceCount = 1;
        return global1.__mobxGlobals = /*#__PURE__*/ new MobXGlobals();
    }
}();
function isolateGlobalState() {
    if (globalState.pendingReactions.length || globalState.inBatch || globalState.isRunningReactions) die(36);
    isolateCalled = true;
    if (canMergeGlobalState) {
        var global1 = getGlobal();
        if (--global1.__mobxInstanceCount === 0) global1.__mobxGlobals = undefined;
        globalState = new MobXGlobals();
    }
}
function getGlobalState() {
    return globalState;
}
/**
 * For testing purposes only; this will break the internal state of existing observables,
 * but can be used to get back at a stable state after throwing errors
 */ function resetGlobalState() {
    var defaultGlobals = new MobXGlobals();
    for(var key in defaultGlobals)if (persistentKeys.indexOf(key) === -1) globalState[key] = defaultGlobals[key];
    globalState.allowStateChanges = !globalState.enforceActions;
}
function hasObservers(observable) {
    return observable.observers_ && observable.observers_.size > 0;
}
function getObservers(observable) {
    return observable.observers_;
}
// function invariantObservers(observable: IObservable) {
//     const list = observable.observers
//     const map = observable.observersIndexes
//     const l = list.length
//     for (let i = 0; i < l; i++) {
//         const id = list[i].__mapid
//         if (i) {
//             invariant(map[id] === i, "INTERNAL ERROR maps derivation.__mapid to index in list") // for performance
//         } else {
//             invariant(!(id in map), "INTERNAL ERROR observer on index 0 shouldn't be held in map.") // for performance
//         }
//     }
//     invariant(
//         list.length === 0 || Object.keys(map).length === list.length - 1,
//         "INTERNAL ERROR there is no junk in map"
//     )
// }
function addObserver(observable, node) {
    // invariant(node.dependenciesState !== -1, "INTERNAL ERROR, can add only dependenciesState !== -1");
    // invariant(observable._observers.indexOf(node) === -1, "INTERNAL ERROR add already added node");
    // invariantObservers(observable);
    observable.observers_.add(node);
    if (observable.lowestObserverState_ > node.dependenciesState_) observable.lowestObserverState_ = node.dependenciesState_;
// invariantObservers(observable);
// invariant(observable._observers.indexOf(node) !== -1, "INTERNAL ERROR didn't add node");
}
function removeObserver(observable, node) {
    // invariant(globalState.inBatch > 0, "INTERNAL ERROR, remove should be called only inside batch");
    // invariant(observable._observers.indexOf(node) !== -1, "INTERNAL ERROR remove already removed node");
    // invariantObservers(observable);
    observable.observers_["delete"](node);
    if (observable.observers_.size === 0) // deleting last observer
    queueForUnobservation(observable);
// invariantObservers(observable);
// invariant(observable._observers.indexOf(node) === -1, "INTERNAL ERROR remove already removed node2");
}
function queueForUnobservation(observable) {
    if (observable.isPendingUnobservation_ === false) {
        // invariant(observable._observers.length === 0, "INTERNAL ERROR, should only queue for unobservation unobserved observables");
        observable.isPendingUnobservation_ = true;
        globalState.pendingUnobservations.push(observable);
    }
}
/**
 * Batch starts a transaction, at least for purposes of memoizing ComputedValues when nothing else does.
 * During a batch `onBecomeUnobserved` will be called at most once per observable.
 * Avoids unnecessary recalculations.
 */ function startBatch() {
    globalState.inBatch++;
}
function endBatch() {
    if (--globalState.inBatch === 0) {
        runReactions();
        // the batch is actually about to finish, all unobserving should happen here.
        var list = globalState.pendingUnobservations;
        for(var i = 0; i < list.length; i++){
            var observable = list[i];
            observable.isPendingUnobservation_ = false;
            if (observable.observers_.size === 0) {
                if (observable.isBeingObserved_) {
                    // if this observable had reactive observers, trigger the hooks
                    observable.isBeingObserved_ = false;
                    observable.onBUO();
                }
                if (observable instanceof ComputedValue) // computed values are automatically teared down when the last observer leaves
                // this process happens recursively, this computed might be the last observabe of another, etc..
                observable.suspend_();
            }
        }
        globalState.pendingUnobservations = [];
    }
}
function reportObserved(observable) {
    checkIfStateReadsAreAllowed(observable);
    var derivation = globalState.trackingDerivation;
    if (derivation !== null) {
        /**
     * Simple optimization, give each derivation run an unique id (runId)
     * Check if last time this observable was accessed the same runId is used
     * if this is the case, the relation is already known
     */ if (derivation.runId_ !== observable.lastAccessedBy_) {
            observable.lastAccessedBy_ = derivation.runId_;
            // Tried storing newObserving, or observing, or both as Set, but performance didn't come close...
            derivation.newObserving_[derivation.unboundDepsCount_++] = observable;
            if (!observable.isBeingObserved_ && globalState.trackingContext) {
                observable.isBeingObserved_ = true;
                observable.onBO();
            }
        }
        return observable.isBeingObserved_;
    } else if (observable.observers_.size === 0 && globalState.inBatch > 0) queueForUnobservation(observable);
    return false;
}
// function invariantLOS(observable: IObservable, msg: string) {
//     // it's expensive so better not run it in produciton. but temporarily helpful for testing
//     const min = getObservers(observable).reduce((a, b) => Math.min(a, b.dependenciesState), 2)
//     if (min >= observable.lowestObserverState) return // <- the only assumption about `lowestObserverState`
//     throw new Error(
//         "lowestObserverState is wrong for " +
//             msg +
//             " because " +
//             min +
//             " < " +
//             observable.lowestObserverState
//     )
// }
/**
 * NOTE: current propagation mechanism will in case of self reruning autoruns behave unexpectedly
 * It will propagate changes to observers from previous run
 * It's hard or maybe impossible (with reasonable perf) to get it right with current approach
 * Hopefully self reruning autoruns aren't a feature people should depend on
 * Also most basic use cases should be ok
 */ // Called by Atom when its value changes
function propagateChanged(observable) {
    // invariantLOS(observable, "changed start");
    if (observable.lowestObserverState_ === IDerivationState_.STALE_) return;
    observable.lowestObserverState_ = IDerivationState_.STALE_;
    // Ideally we use for..of here, but the downcompiled version is really slow...
    observable.observers_.forEach(function(d) {
        if (d.dependenciesState_ === IDerivationState_.UP_TO_DATE_) {
            if (d.isTracing_ !== TraceMode.NONE) logTraceInfo(d, observable);
            d.onBecomeStale_();
        }
        d.dependenciesState_ = IDerivationState_.STALE_;
    });
// invariantLOS(observable, "changed end");
}
// Called by ComputedValue when it recalculate and its value changed
function propagateChangeConfirmed(observable) {
    // invariantLOS(observable, "confirmed start");
    if (observable.lowestObserverState_ === IDerivationState_.STALE_) return;
    observable.lowestObserverState_ = IDerivationState_.STALE_;
    observable.observers_.forEach(function(d) {
        if (d.dependenciesState_ === IDerivationState_.POSSIBLY_STALE_) {
            d.dependenciesState_ = IDerivationState_.STALE_;
            if (d.isTracing_ !== TraceMode.NONE) logTraceInfo(d, observable);
        } else if (d.dependenciesState_ === IDerivationState_.UP_TO_DATE_ // this happens during computing of `d`, just keep lowestObserverState up to date.
        ) observable.lowestObserverState_ = IDerivationState_.UP_TO_DATE_;
    });
// invariantLOS(observable, "confirmed end");
}
// Used by computed when its dependency changed, but we don't wan't to immediately recompute.
function propagateMaybeChanged(observable) {
    // invariantLOS(observable, "maybe start");
    if (observable.lowestObserverState_ !== IDerivationState_.UP_TO_DATE_) return;
    observable.lowestObserverState_ = IDerivationState_.POSSIBLY_STALE_;
    observable.observers_.forEach(function(d) {
        if (d.dependenciesState_ === IDerivationState_.UP_TO_DATE_) {
            d.dependenciesState_ = IDerivationState_.POSSIBLY_STALE_;
            d.onBecomeStale_();
        }
    });
// invariantLOS(observable, "maybe end");
}
function logTraceInfo(derivation, observable) {
    console.log("[mobx.trace] '" + derivation.name_ + "' is invalidated due to a change in: '" + observable.name_ + "'");
    if (derivation.isTracing_ === TraceMode.BREAK) {
        var lines = [];
        printDepTree(getDependencyTree(derivation), lines, 1);
        // prettier-ignore
        new Function("debugger;\n/*\nTracing '" + derivation.name_ + "'\n\nYou are entering this break point because derivation '" + derivation.name_ + "' is being traced and '" + observable.name_ + "' is now forcing it to update.\nJust follow the stacktrace you should now see in the devtools to see precisely what piece of your code is causing this update\nThe stackframe you are looking for is at least ~6-8 stack-frames up.\n\n" + (derivation instanceof ComputedValue ? derivation.derivation.toString().replace(/[*]\//g, "/") : "") + "\n\nThe dependencies for this derivation are:\n\n" + lines.join("\n") + "\n*/\n    ")();
    }
}
function printDepTree(tree, lines, depth) {
    if (lines.length >= 1000) {
        lines.push("(and many more)");
        return;
    }
    lines.push("" + "	".repeat(depth - 1) + tree.name);
    if (tree.dependencies) tree.dependencies.forEach(function(child) {
        return printDepTree(child, lines, depth + 1);
    });
}
var Reaction = /*#__PURE__*/ function() {
    // nodes we are looking at. Our value depends on these nodes
    function Reaction(name_, onInvalidate_, errorHandler_, requiresObservable_) {
        if (name_ === void 0) name_ = "Reaction@" + getNextId();
        this.name_ = void 0;
        this.onInvalidate_ = void 0;
        this.errorHandler_ = void 0;
        this.requiresObservable_ = void 0;
        this.observing_ = [];
        this.newObserving_ = [];
        this.dependenciesState_ = IDerivationState_.NOT_TRACKING_;
        this.diffValue_ = 0;
        this.runId_ = 0;
        this.unboundDepsCount_ = 0;
        this.isDisposed_ = false;
        this.isScheduled_ = false;
        this.isTrackPending_ = false;
        this.isRunning_ = false;
        this.isTracing_ = TraceMode.NONE;
        this.name_ = name_;
        this.onInvalidate_ = onInvalidate_;
        this.errorHandler_ = errorHandler_;
        this.requiresObservable_ = requiresObservable_;
    }
    var _proto = Reaction.prototype;
    _proto.onBecomeStale_ = function onBecomeStale_() {
        this.schedule_();
    };
    _proto.schedule_ = function schedule_() {
        if (!this.isScheduled_) {
            this.isScheduled_ = true;
            globalState.pendingReactions.push(this);
            runReactions();
        }
    };
    _proto.isScheduled = function isScheduled() {
        return this.isScheduled_;
    } /**
   * internal, use schedule() if you intend to kick off a reaction
   */ ;
    _proto.runReaction_ = function runReaction_() {
        if (!this.isDisposed_) {
            startBatch();
            this.isScheduled_ = false;
            var prev = globalState.trackingContext;
            globalState.trackingContext = this;
            if (shouldCompute(this)) {
                this.isTrackPending_ = true;
                try {
                    this.onInvalidate_();
                    if ((0, this.isTrackPending_) && isSpyEnabled()) // onInvalidate didn't trigger track right away..
                    spyReport({
                        name: this.name_,
                        type: "scheduled-reaction"
                    });
                } catch (e) {
                    this.reportExceptionInDerivation_(e);
                }
            }
            globalState.trackingContext = prev;
            endBatch();
        }
    };
    _proto.track = function track(fn) {
        if (this.isDisposed_) return;
        startBatch();
        var notify = isSpyEnabled();
        var startTime;
        if (notify) {
            startTime = Date.now();
            spyReportStart({
                name: this.name_,
                type: "reaction"
            });
        }
        this.isRunning_ = true;
        var prevReaction = globalState.trackingContext; // reactions could create reactions...
        globalState.trackingContext = this;
        var result = trackDerivedFunction(this, fn, undefined);
        globalState.trackingContext = prevReaction;
        this.isRunning_ = false;
        this.isTrackPending_ = false;
        if (this.isDisposed_) // disposed during last run. Clean up everything that was bound after the dispose call.
        clearObserving(this);
        if (isCaughtException(result)) this.reportExceptionInDerivation_(result.cause);
        if (notify) spyReportEnd({
            time: Date.now() - startTime
        });
        endBatch();
    };
    _proto.reportExceptionInDerivation_ = function reportExceptionInDerivation_(error) {
        var _this = this;
        if (this.errorHandler_) {
            this.errorHandler_(error, this);
            return;
        }
        if (globalState.disableErrorBoundaries) throw error;
        var message = "[mobx] Encountered an uncaught exception that was thrown by a reaction or observer component, in: '" + this + "'";
        if (!globalState.suppressReactionErrors) console.error(message, error);
        else console.warn("[mobx] (error in reaction '" + this.name_ + "' suppressed, fix error of causing action below)");
         // prettier-ignore
        if (isSpyEnabled()) spyReport({
            type: "error",
            name: this.name_,
            message: message,
            error: "" + error
        });
        globalState.globalReactionErrorHandlers.forEach(function(f) {
            return f(error, _this);
        });
    };
    _proto.dispose = function dispose() {
        if (!this.isDisposed_) {
            this.isDisposed_ = true;
            if (!this.isRunning_) {
                // if disposed while running, clean up later. Maybe not optimal, but rare case
                startBatch();
                clearObserving(this);
                endBatch();
            }
        }
    };
    _proto.getDisposer_ = function getDisposer_(abortSignal) {
        var _this2 = this;
        var dispose = function dispose() {
            _this2.dispose();
            abortSignal == null || abortSignal.removeEventListener == null || abortSignal.removeEventListener("abort", dispose);
        };
        abortSignal == null || abortSignal.addEventListener == null || abortSignal.addEventListener("abort", dispose);
        dispose[$mobx] = this;
        return dispose;
    };
    _proto.toString = function toString() {
        return "Reaction[" + this.name_ + "]";
    };
    _proto.trace = function trace$1(enterBreakPoint) {
        if (enterBreakPoint === void 0) enterBreakPoint = false;
        trace(this, enterBreakPoint);
    };
    return Reaction;
}();
function onReactionError(handler) {
    globalState.globalReactionErrorHandlers.push(handler);
    return function() {
        var idx = globalState.globalReactionErrorHandlers.indexOf(handler);
        if (idx >= 0) globalState.globalReactionErrorHandlers.splice(idx, 1);
    };
}
/**
 * Magic number alert!
 * Defines within how many times a reaction is allowed to re-trigger itself
 * until it is assumed that this is gonna be a never ending loop...
 */ var MAX_REACTION_ITERATIONS = 100;
var reactionScheduler = function reactionScheduler(f) {
    return f();
};
function runReactions() {
    // Trampolining, if runReactions are already running, new reactions will be picked up
    if (globalState.inBatch > 0 || globalState.isRunningReactions) return;
    reactionScheduler(runReactionsHelper);
}
function runReactionsHelper() {
    globalState.isRunningReactions = true;
    var allReactions = globalState.pendingReactions;
    var iterations = 0;
    // While running reactions, new reactions might be triggered.
    // Hence we work with two variables and check whether
    // we converge to no remaining reactions after a while.
    while(allReactions.length > 0){
        if (++iterations === MAX_REACTION_ITERATIONS) {
            console.error("Reaction doesn't converge to a stable state after " + MAX_REACTION_ITERATIONS + " iterations." + (" Probably there is a cycle in the reactive function: " + allReactions[0]));
            allReactions.splice(0); // clear reactions
        }
        var remainingReactions = allReactions.splice(0);
        for(var i = 0, l = remainingReactions.length; i < l; i++)remainingReactions[i].runReaction_();
    }
    globalState.isRunningReactions = false;
}
var isReaction = /*#__PURE__*/ createInstanceofPredicate("Reaction", Reaction);
function setReactionScheduler(fn) {
    var baseScheduler = reactionScheduler;
    reactionScheduler = function reactionScheduler(f) {
        return fn(function() {
            return baseScheduler(f);
        });
    };
}
function isSpyEnabled() {
    return !!globalState.spyListeners.length;
}
function spyReport(event) {
    if (!globalState.spyListeners.length) return;
    var listeners = globalState.spyListeners;
    for(var i = 0, l = listeners.length; i < l; i++)listeners[i](event);
}
function spyReportStart(event) {
    var change = _extends({}, event, {
        spyReportStart: true
    });
    spyReport(change);
}
var END_EVENT = {
    type: "report-end",
    spyReportEnd: true
};
function spyReportEnd(change) {
    if (change) spyReport(_extends({}, change, {
        type: "report-end",
        spyReportEnd: true
    }));
    else spyReport(END_EVENT);
}
function spy(listener) {
    globalState.spyListeners.push(listener);
    return once(function() {
        globalState.spyListeners = globalState.spyListeners.filter(function(l) {
            return l !== listener;
        });
    });
}
var ACTION = "action";
var ACTION_BOUND = "action.bound";
var AUTOACTION = "autoAction";
var AUTOACTION_BOUND = "autoAction.bound";
var DEFAULT_ACTION_NAME = "<unnamed action>";
var actionAnnotation = /*#__PURE__*/ createActionAnnotation(ACTION);
var actionBoundAnnotation = /*#__PURE__*/ createActionAnnotation(ACTION_BOUND, {
    bound: true
});
var autoActionAnnotation = /*#__PURE__*/ createActionAnnotation(AUTOACTION, {
    autoAction: true
});
var autoActionBoundAnnotation = /*#__PURE__*/ createActionAnnotation(AUTOACTION_BOUND, {
    autoAction: true,
    bound: true
});
function createActionFactory(autoAction) {
    var res = function action(arg1, arg2) {
        // action(fn() {})
        if (isFunction(arg1)) return createAction(arg1.name || DEFAULT_ACTION_NAME, arg1, autoAction);
        // action("name", fn() {})
        if (isFunction(arg2)) return createAction(arg1, arg2, autoAction);
        // @action (2022.3 Decorators)
        if (is20223Decorator(arg2)) return (autoAction ? autoActionAnnotation : actionAnnotation).decorate_20223_(arg1, arg2);
        // @action
        if (isStringish(arg2)) return storeAnnotation(arg1, arg2, autoAction ? autoActionAnnotation : actionAnnotation);
        // action("name") & @action("name")
        if (isStringish(arg1)) return createDecoratorAnnotation(createActionAnnotation(autoAction ? AUTOACTION : ACTION, {
            name: arg1,
            autoAction: autoAction
        }));
        die("Invalid arguments for `action`");
    };
    return res;
}
var action = /*#__PURE__*/ createActionFactory(false);
Object.assign(action, actionAnnotation);
var autoAction = /*#__PURE__*/ createActionFactory(true);
Object.assign(autoAction, autoActionAnnotation);
action.bound = /*#__PURE__*/ createDecoratorAnnotation(actionBoundAnnotation);
autoAction.bound = /*#__PURE__*/ createDecoratorAnnotation(autoActionBoundAnnotation);
function runInAction(fn) {
    return executeAction(fn.name || DEFAULT_ACTION_NAME, false, fn, this, undefined);
}
function isAction(thing) {
    return isFunction(thing) && thing.isMobxAction === true;
}
/**
 * Creates a named reactive view and keeps it alive, so that the view is always
 * updated if one of the dependencies changes, even when the view is not further used by something else.
 * @param view The reactive view
 * @returns disposer function, which can be used to stop the view from being updated in the future.
 */ function autorun(view, opts) {
    var _opts$name, _opts, _opts2, _opts2$signal, _opts3;
    if (opts === void 0) opts = EMPTY_OBJECT;
    if (!isFunction(view)) die("Autorun expects a function as first argument");
    if (isAction(view)) die("Autorun does not accept actions since actions are untrackable");
    var name = (_opts$name = (_opts = opts) == null ? void 0 : _opts.name) != null ? _opts$name : view.name || "Autorun@" + getNextId();
    var runSync = !opts.scheduler && !opts.delay;
    var reaction;
    if (runSync) // normal autorun
    reaction = new Reaction(name, function() {
        this.track(reactionRunner);
    }, opts.onError, opts.requiresObservable);
    else {
        var scheduler = createSchedulerFromOptions(opts);
        // debounced autorun
        var isScheduled = false;
        reaction = new Reaction(name, function() {
            if (!isScheduled) {
                isScheduled = true;
                scheduler(function() {
                    isScheduled = false;
                    if (!reaction.isDisposed_) reaction.track(reactionRunner);
                });
            }
        }, opts.onError, opts.requiresObservable);
    }
    function reactionRunner() {
        view(reaction);
    }
    if (!((_opts2 = opts) != null && (_opts2$signal = _opts2.signal) != null && _opts2$signal.aborted)) reaction.schedule_();
    return reaction.getDisposer_((_opts3 = opts) == null ? void 0 : _opts3.signal);
}
var run = function run(f) {
    return f();
};
function createSchedulerFromOptions(opts) {
    return opts.scheduler ? opts.scheduler : opts.delay ? function(f) {
        return setTimeout(f, opts.delay);
    } : run;
}
function reaction(expression, effect, opts) {
    var _opts$name2, _opts4, _opts4$signal, _opts5;
    if (opts === void 0) opts = EMPTY_OBJECT;
    if (!isFunction(expression) || !isFunction(effect)) die("First and second argument to reaction should be functions");
    if (!isPlainObject(opts)) die("Third argument of reactions should be an object");
    var name = (_opts$name2 = opts.name) != null ? _opts$name2 : "Reaction@" + getNextId();
    var effectAction = action(name, opts.onError ? wrapErrorHandler(opts.onError, effect) : effect);
    var runSync = !opts.scheduler && !opts.delay;
    var scheduler = createSchedulerFromOptions(opts);
    var firstTime = true;
    var isScheduled = false;
    var value;
    var oldValue;
    var equals = opts.compareStructural ? comparer.structural : opts.equals || comparer["default"];
    var r = new Reaction(name, function() {
        if (firstTime || runSync) reactionRunner();
        else if (!isScheduled) {
            isScheduled = true;
            scheduler(reactionRunner);
        }
    }, opts.onError, opts.requiresObservable);
    function reactionRunner() {
        isScheduled = false;
        if (r.isDisposed_) return;
        var changed = false;
        r.track(function() {
            var nextValue = allowStateChanges(false, function() {
                return expression(r);
            });
            changed = firstTime || !equals(value, nextValue);
            oldValue = value;
            value = nextValue;
        });
        if (firstTime && opts.fireImmediately) effectAction(value, oldValue, r);
        else if (!firstTime && changed) effectAction(value, oldValue, r);
        firstTime = false;
    }
    if (!((_opts4 = opts) != null && (_opts4$signal = _opts4.signal) != null && _opts4$signal.aborted)) r.schedule_();
    return r.getDisposer_((_opts5 = opts) == null ? void 0 : _opts5.signal);
}
function wrapErrorHandler(errorHandler, baseFn) {
    return function() {
        try {
            return baseFn.apply(this, arguments);
        } catch (e) {
            errorHandler.call(this, e);
        }
    };
}
var ON_BECOME_OBSERVED = "onBO";
var ON_BECOME_UNOBSERVED = "onBUO";
function onBecomeObserved(thing, arg2, arg3) {
    return interceptHook(ON_BECOME_OBSERVED, thing, arg2, arg3);
}
function onBecomeUnobserved(thing, arg2, arg3) {
    return interceptHook(ON_BECOME_UNOBSERVED, thing, arg2, arg3);
}
function interceptHook(hook, thing, arg2, arg3) {
    var atom = typeof arg3 === "function" ? getAtom(thing, arg2) : getAtom(thing);
    var cb = isFunction(arg3) ? arg3 : arg2;
    var listenersKey = hook + "L";
    if (atom[listenersKey]) atom[listenersKey].add(cb);
    else atom[listenersKey] = new Set([
        cb
    ]);
    return function() {
        var hookListeners = atom[listenersKey];
        if (hookListeners) {
            hookListeners["delete"](cb);
            if (hookListeners.size === 0) delete atom[listenersKey];
        }
    };
}
var NEVER = "never";
var ALWAYS = "always";
var OBSERVED = "observed";
// const IF_AVAILABLE = "ifavailable"
function configure(options) {
    if (options.isolateGlobalState === true) isolateGlobalState();
    var useProxies = options.useProxies, enforceActions = options.enforceActions;
    if (useProxies !== undefined) globalState.useProxies = useProxies === ALWAYS ? true : useProxies === NEVER ? false : typeof Proxy !== "undefined";
    if (useProxies === "ifavailable") globalState.verifyProxies = true;
    if (enforceActions !== undefined) {
        var ea = enforceActions === ALWAYS ? ALWAYS : enforceActions === OBSERVED;
        globalState.enforceActions = ea;
        globalState.allowStateChanges = ea === true || ea === ALWAYS ? false : true;
    }
    [
        "computedRequiresReaction",
        "reactionRequiresObservable",
        "observableRequiresReaction",
        "disableErrorBoundaries",
        "safeDescriptors"
    ].forEach(function(key) {
        if (key in options) globalState[key] = !!options[key];
    });
    globalState.allowStateReads = !globalState.observableRequiresReaction;
    if (globalState.disableErrorBoundaries === true) console.warn("WARNING: Debug feature only. MobX will NOT recover from errors when `disableErrorBoundaries` is enabled.");
    if (options.reactionScheduler) setReactionScheduler(options.reactionScheduler);
}
function extendObservable(target, properties, annotations, options) {
    if (arguments.length > 4) die("'extendObservable' expected 2-4 arguments");
    if (typeof target !== "object") die("'extendObservable' expects an object as first argument");
    if (isObservableMap(target)) die("'extendObservable' should not be used on maps, use map.merge instead");
    if (!isPlainObject(properties)) die("'extendObservable' only accepts plain objects as second argument");
    if (isObservable(properties) || isObservable(annotations)) die("Extending an object with another observable (object) is not supported");
    // Pull descriptors first, so we don't have to deal with props added by administration ($mobx)
    var descriptors = getOwnPropertyDescriptors(properties);
    initObservable(function() {
        var adm = asObservableObject(target, options)[$mobx];
        ownKeys(descriptors).forEach(function(key) {
            adm.extend_(key, descriptors[key], // must pass "undefined" for { key: undefined }
            !annotations ? true : key in annotations ? annotations[key] : true);
        });
    });
    return target;
}
function getDependencyTree(thing, property) {
    return nodeToDependencyTree(getAtom(thing, property));
}
function nodeToDependencyTree(node) {
    var result = {
        name: node.name_
    };
    if (node.observing_ && node.observing_.length > 0) result.dependencies = unique(node.observing_).map(nodeToDependencyTree);
    return result;
}
function getObserverTree(thing, property) {
    return nodeToObserverTree(getAtom(thing, property));
}
function nodeToObserverTree(node) {
    var result = {
        name: node.name_
    };
    if (hasObservers(node)) result.observers = Array.from(getObservers(node)).map(nodeToObserverTree);
    return result;
}
function unique(list) {
    return Array.from(new Set(list));
}
var generatorId = 0;
function FlowCancellationError() {
    this.message = "FLOW_CANCELLED";
}
FlowCancellationError.prototype = /*#__PURE__*/ Object.create(Error.prototype);
function isFlowCancellationError(error) {
    return error instanceof FlowCancellationError;
}
var flowAnnotation = /*#__PURE__*/ createFlowAnnotation("flow");
var flowBoundAnnotation = /*#__PURE__*/ createFlowAnnotation("flow.bound", {
    bound: true
});
var flow = /*#__PURE__*/ Object.assign(function flow(arg1, arg2) {
    // @flow (2022.3 Decorators)
    if (is20223Decorator(arg2)) return flowAnnotation.decorate_20223_(arg1, arg2);
    // @flow
    if (isStringish(arg2)) return storeAnnotation(arg1, arg2, flowAnnotation);
    // flow(fn)
    if (arguments.length !== 1) die("Flow expects single argument with generator function");
    var generator = arg1;
    var name = generator.name || "<unnamed flow>";
    // Implementation based on https://github.com/tj/co/blob/master/index.js
    var res = function res() {
        var ctx = this;
        var args = arguments;
        var runId = ++generatorId;
        var gen = action(name + " - runid: " + runId + " - init", generator).apply(ctx, args);
        var rejector;
        var pendingPromise = undefined;
        var promise = new Promise(function(resolve, reject) {
            var stepId = 0;
            rejector = reject;
            function onFulfilled(res) {
                pendingPromise = undefined;
                var ret;
                try {
                    ret = action(name + " - runid: " + runId + " - yield " + stepId++, gen.next).call(gen, res);
                } catch (e) {
                    return reject(e);
                }
                next(ret);
            }
            function onRejected(err) {
                pendingPromise = undefined;
                var ret;
                try {
                    ret = action(name + " - runid: " + runId + " - yield " + stepId++, gen["throw"]).call(gen, err);
                } catch (e) {
                    return reject(e);
                }
                next(ret);
            }
            function next(ret) {
                if (isFunction(ret == null ? void 0 : ret.then)) {
                    // an async iterator
                    ret.then(next, reject);
                    return;
                }
                if (ret.done) return resolve(ret.value);
                pendingPromise = Promise.resolve(ret.value);
                return pendingPromise.then(onFulfilled, onRejected);
            }
            onFulfilled(undefined); // kick off the process
        });
        promise.cancel = action(name + " - runid: " + runId + " - cancel", function() {
            try {
                if (pendingPromise) cancelPromise(pendingPromise);
                // Finally block can return (or yield) stuff..
                var _res = gen["return"](undefined);
                // eat anything that promise would do, it's cancelled!
                var yieldedPromise = Promise.resolve(_res.value);
                yieldedPromise.then(noop, noop);
                cancelPromise(yieldedPromise); // maybe it can be cancelled :)
                // reject our original promise
                rejector(new FlowCancellationError());
            } catch (e) {
                rejector(e); // there could be a throwing finally block
            }
        });
        return promise;
    };
    res.isMobXFlow = true;
    return res;
}, flowAnnotation);
flow.bound = /*#__PURE__*/ createDecoratorAnnotation(flowBoundAnnotation);
function cancelPromise(promise) {
    if (isFunction(promise.cancel)) promise.cancel();
}
function flowResult(result) {
    return result; // just tricking TypeScript :)
}
function isFlow(fn) {
    return (fn == null ? void 0 : fn.isMobXFlow) === true;
}
function interceptReads(thing, propOrHandler, handler) {
    var target;
    if (isObservableMap(thing) || isObservableArray(thing) || isObservableValue(thing)) target = getAdministration(thing);
    else if (isObservableObject(thing)) {
        if (!isStringish(propOrHandler)) return die("InterceptReads can only be used with a specific property, not with an object in general");
        target = getAdministration(thing, propOrHandler);
    } else return die("Expected observable map, object or array as first array");
    if (target.dehancer !== undefined) return die("An intercept reader was already established");
    target.dehancer = typeof propOrHandler === "function" ? propOrHandler : handler;
    return function() {
        target.dehancer = undefined;
    };
}
function intercept(thing, propOrHandler, handler) {
    if (isFunction(handler)) return interceptProperty(thing, propOrHandler, handler);
    else return interceptInterceptable(thing, propOrHandler);
}
function interceptInterceptable(thing, handler) {
    return getAdministration(thing).intercept_(handler);
}
function interceptProperty(thing, property, handler) {
    return getAdministration(thing, property).intercept_(handler);
}
function _isComputed(value, property) {
    if (property === undefined) return isComputedValue(value);
    if (isObservableObject(value) === false) return false;
    if (!value[$mobx].values_.has(property)) return false;
    var atom = getAtom(value, property);
    return isComputedValue(atom);
}
function isComputed(value) {
    if (arguments.length > 1) return die("isComputed expects only 1 argument. Use isComputedProp to inspect the observability of a property");
    return _isComputed(value);
}
function isComputedProp(value, propName) {
    if (!isStringish(propName)) return die("isComputed expected a property name as second argument");
    return _isComputed(value, propName);
}
function _isObservable(value, property) {
    if (!value) return false;
    if (property !== undefined) {
        if (isObservableMap(value) || isObservableArray(value)) return die("isObservable(object, propertyName) is not supported for arrays and maps. Use map.has or array.length instead.");
        if (isObservableObject(value)) return value[$mobx].values_.has(property);
        return false;
    }
    // For first check, see #701
    return isObservableObject(value) || !!value[$mobx] || isAtom(value) || isReaction(value) || isComputedValue(value);
}
function isObservable(value) {
    if (arguments.length !== 1) die("isObservable expects only 1 argument. Use isObservableProp to inspect the observability of a property");
    return _isObservable(value);
}
function isObservableProp(value, propName) {
    if (!isStringish(propName)) return die("expected a property name as second argument");
    return _isObservable(value, propName);
}
function keys(obj) {
    if (isObservableObject(obj)) return obj[$mobx].keys_();
    if (isObservableMap(obj) || isObservableSet(obj)) return Array.from(obj.keys());
    if (isObservableArray(obj)) return obj.map(function(_, index) {
        return index;
    });
    die(5);
}
function values(obj) {
    if (isObservableObject(obj)) return keys(obj).map(function(key) {
        return obj[key];
    });
    if (isObservableMap(obj)) return keys(obj).map(function(key) {
        return obj.get(key);
    });
    if (isObservableSet(obj)) return Array.from(obj.values());
    if (isObservableArray(obj)) return obj.slice();
    die(6);
}
function entries(obj) {
    if (isObservableObject(obj)) return keys(obj).map(function(key) {
        return [
            key,
            obj[key]
        ];
    });
    if (isObservableMap(obj)) return keys(obj).map(function(key) {
        return [
            key,
            obj.get(key)
        ];
    });
    if (isObservableSet(obj)) return Array.from(obj.entries());
    if (isObservableArray(obj)) return obj.map(function(key, index) {
        return [
            index,
            key
        ];
    });
    die(7);
}
function set(obj, key, value) {
    if (arguments.length === 2 && !isObservableSet(obj)) {
        startBatch();
        var _values = key;
        try {
            for(var _key in _values)set(obj, _key, _values[_key]);
        } finally{
            endBatch();
        }
        return;
    }
    if (isObservableObject(obj)) obj[$mobx].set_(key, value);
    else if (isObservableMap(obj)) obj.set(key, value);
    else if (isObservableSet(obj)) obj.add(key);
    else if (isObservableArray(obj)) {
        if (typeof key !== "number") key = parseInt(key, 10);
        if (key < 0) die("Invalid index: '" + key + "'");
        startBatch();
        if (key >= obj.length) obj.length = key + 1;
        obj[key] = value;
        endBatch();
    } else die(8);
}
function remove(obj, key) {
    if (isObservableObject(obj)) obj[$mobx].delete_(key);
    else if (isObservableMap(obj)) obj["delete"](key);
    else if (isObservableSet(obj)) obj["delete"](key);
    else if (isObservableArray(obj)) {
        if (typeof key !== "number") key = parseInt(key, 10);
        obj.splice(key, 1);
    } else die(9);
}
function has(obj, key) {
    if (isObservableObject(obj)) return obj[$mobx].has_(key);
    else if (isObservableMap(obj)) return obj.has(key);
    else if (isObservableSet(obj)) return obj.has(key);
    else if (isObservableArray(obj)) return key >= 0 && key < obj.length;
    die(10);
}
function get(obj, key) {
    if (!has(obj, key)) return undefined;
    if (isObservableObject(obj)) return obj[$mobx].get_(key);
    else if (isObservableMap(obj)) return obj.get(key);
    else if (isObservableArray(obj)) return obj[key];
    die(11);
}
function apiDefineProperty(obj, key, descriptor) {
    if (isObservableObject(obj)) return obj[$mobx].defineProperty_(key, descriptor);
    die(39);
}
function apiOwnKeys(obj) {
    if (isObservableObject(obj)) return obj[$mobx].ownKeys_();
    die(38);
}
function observe(thing, propOrCb, cbOrFire, fireImmediately) {
    if (isFunction(cbOrFire)) return observeObservableProperty(thing, propOrCb, cbOrFire, fireImmediately);
    else return observeObservable(thing, propOrCb, cbOrFire);
}
function observeObservable(thing, listener, fireImmediately) {
    return getAdministration(thing).observe_(listener, fireImmediately);
}
function observeObservableProperty(thing, property, listener, fireImmediately) {
    return getAdministration(thing, property).observe_(listener, fireImmediately);
}
function cache(map, key, value) {
    map.set(key, value);
    return value;
}
function toJSHelper(source, __alreadySeen) {
    if (source == null || typeof source !== "object" || source instanceof Date || !isObservable(source)) return source;
    if (isObservableValue(source) || isComputedValue(source)) return toJSHelper(source.get(), __alreadySeen);
    if (__alreadySeen.has(source)) return __alreadySeen.get(source);
    if (isObservableArray(source)) {
        var res = cache(__alreadySeen, source, new Array(source.length));
        source.forEach(function(value, idx) {
            res[idx] = toJSHelper(value, __alreadySeen);
        });
        return res;
    }
    if (isObservableSet(source)) {
        var _res = cache(__alreadySeen, source, new Set());
        source.forEach(function(value) {
            _res.add(toJSHelper(value, __alreadySeen));
        });
        return _res;
    }
    if (isObservableMap(source)) {
        var _res2 = cache(__alreadySeen, source, new Map());
        source.forEach(function(value, key) {
            _res2.set(key, toJSHelper(value, __alreadySeen));
        });
        return _res2;
    } else {
        // must be observable object
        var _res3 = cache(__alreadySeen, source, {});
        apiOwnKeys(source).forEach(function(key) {
            if (objectPrototype.propertyIsEnumerable.call(source, key)) _res3[key] = toJSHelper(source[key], __alreadySeen);
        });
        return _res3;
    }
}
/**
 * Recursively converts an observable to it's non-observable native counterpart.
 * It does NOT recurse into non-observables, these are left as they are, even if they contain observables.
 * Computed and other non-enumerable properties are completely ignored.
 * Complex scenarios require custom solution, eg implementing `toJSON` or using `serializr` lib.
 */ function toJS(source, options) {
    if (options) die("toJS no longer supports options");
    return toJSHelper(source, new Map());
}
function trace() {
    var enterBreakPoint = false;
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
    if (typeof args[args.length - 1] === "boolean") enterBreakPoint = args.pop();
    var derivation = getAtomFromArgs(args);
    if (!derivation) return die("'trace(break?)' can only be used inside a tracked computed value or a Reaction. Consider passing in the computed value or reaction explicitly");
    if (derivation.isTracing_ === TraceMode.NONE) console.log("[mobx.trace] '" + derivation.name_ + "' tracing enabled");
    derivation.isTracing_ = enterBreakPoint ? TraceMode.BREAK : TraceMode.LOG;
}
function getAtomFromArgs(args) {
    switch(args.length){
        case 0:
            return globalState.trackingDerivation;
        case 1:
            return getAtom(args[0]);
        case 2:
            return getAtom(args[0], args[1]);
    }
}
/**
 * During a transaction no views are updated until the end of the transaction.
 * The transaction will be run synchronously nonetheless.
 *
 * @param action a function that updates some reactive state
 * @returns any value that was returned by the 'action' parameter.
 */ function transaction(action, thisArg) {
    if (thisArg === void 0) thisArg = undefined;
    startBatch();
    try {
        return action.apply(thisArg);
    } finally{
        endBatch();
    }
}
function when(predicate, arg1, arg2) {
    if (arguments.length === 1 || arg1 && typeof arg1 === "object") return whenPromise(predicate, arg1);
    return _when(predicate, arg1, arg2 || {});
}
function _when(predicate, effect, opts) {
    var timeoutHandle;
    if (typeof opts.timeout === "number") {
        var error = new Error("WHEN_TIMEOUT");
        timeoutHandle = setTimeout(function() {
            if (!disposer[$mobx].isDisposed_) {
                disposer();
                if (opts.onError) opts.onError(error);
                else throw error;
            }
        }, opts.timeout);
    }
    opts.name = opts.name || "When@" + getNextId();
    var effectAction = createAction(opts.name + "-effect", effect);
    // eslint-disable-next-line
    var disposer = autorun(function(r) {
        // predicate should not change state
        var cond = allowStateChanges(false, predicate);
        if (cond) {
            r.dispose();
            if (timeoutHandle) clearTimeout(timeoutHandle);
            effectAction();
        }
    }, opts);
    return disposer;
}
function whenPromise(predicate, opts) {
    var _opts$signal;
    if (opts && opts.onError) return die("the options 'onError' and 'promise' cannot be combined");
    if (opts != null && (_opts$signal = opts.signal) != null && _opts$signal.aborted) return Object.assign(Promise.reject(new Error("WHEN_ABORTED")), {
        cancel: function cancel() {
            return null;
        }
    });
    var cancel;
    var abort;
    var res = new Promise(function(resolve, reject) {
        var _opts$signal2;
        var disposer = _when(predicate, resolve, _extends({}, opts, {
            onError: reject
        }));
        cancel = function cancel() {
            disposer();
            reject(new Error("WHEN_CANCELLED"));
        };
        abort = function abort() {
            disposer();
            reject(new Error("WHEN_ABORTED"));
        };
        opts == null || (_opts$signal2 = opts.signal) == null || _opts$signal2.addEventListener == null || _opts$signal2.addEventListener("abort", abort);
    })["finally"](function() {
        var _opts$signal3;
        return opts == null ? void 0 : (_opts$signal3 = opts.signal) == null ? void 0 : _opts$signal3.removeEventListener == null ? void 0 : _opts$signal3.removeEventListener("abort", abort);
    });
    res.cancel = cancel;
    return res;
}
function getAdm(target) {
    return target[$mobx];
}
// Optimization: we don't need the intermediate objects and could have a completely custom administration for DynamicObjects,
// and skip either the internal values map, or the base object with its property descriptors!
var objectProxyTraps = {
    has: function has(target, name) {
        if (0, globalState.trackingDerivation) warnAboutProxyRequirement("detect new properties using the 'in' operator. Use 'has' from 'mobx' instead.");
        return getAdm(target).has_(name);
    },
    get: function get(target, name) {
        return getAdm(target).get_(name);
    },
    set: function set(target, name, value) {
        var _getAdm$set_;
        if (!isStringish(name)) return false;
        if (!getAdm(target).values_.has(name)) warnAboutProxyRequirement("add a new observable property through direct assignment. Use 'set' from 'mobx' instead.");
        // null (intercepted) -> true (success)
        return (_getAdm$set_ = getAdm(target).set_(name, value, true)) != null ? _getAdm$set_ : true;
    },
    deleteProperty: function deleteProperty(target, name) {
        var _getAdm$delete_;
        warnAboutProxyRequirement("delete properties from an observable object. Use 'remove' from 'mobx' instead.");
        if (!isStringish(name)) return false;
        // null (intercepted) -> true (success)
        return (_getAdm$delete_ = getAdm(target).delete_(name, true)) != null ? _getAdm$delete_ : true;
    },
    defineProperty: function defineProperty(target, name, descriptor) {
        var _getAdm$definePropert;
        warnAboutProxyRequirement("define property on an observable object. Use 'defineProperty' from 'mobx' instead.");
        // null (intercepted) -> true (success)
        return (_getAdm$definePropert = getAdm(target).defineProperty_(name, descriptor)) != null ? _getAdm$definePropert : true;
    },
    ownKeys: function ownKeys(target) {
        if (0, globalState.trackingDerivation) warnAboutProxyRequirement("iterate keys to detect added / removed properties. Use 'keys' from 'mobx' instead.");
        return getAdm(target).ownKeys_();
    },
    preventExtensions: function preventExtensions(target) {
        die(13);
    }
};
function asDynamicObservableObject(target, options) {
    var _target$$mobx, _target$$mobx$proxy_;
    assertProxies();
    target = asObservableObject(target, options);
    return (_target$$mobx$proxy_ = (_target$$mobx = target[$mobx]).proxy_) != null ? _target$$mobx$proxy_ : _target$$mobx.proxy_ = new Proxy(target, objectProxyTraps);
}
function hasInterceptors(interceptable) {
    return interceptable.interceptors_ !== undefined && interceptable.interceptors_.length > 0;
}
function registerInterceptor(interceptable, handler) {
    var interceptors = interceptable.interceptors_ || (interceptable.interceptors_ = []);
    interceptors.push(handler);
    return once(function() {
        var idx = interceptors.indexOf(handler);
        if (idx !== -1) interceptors.splice(idx, 1);
    });
}
function interceptChange(interceptable, change) {
    var prevU = untrackedStart();
    try {
        // Interceptor can modify the array, copy it to avoid concurrent modification, see #1950
        var interceptors = [].concat(interceptable.interceptors_ || []);
        for(var i = 0, l = interceptors.length; i < l; i++){
            change = interceptors[i](change);
            if (change && !change.type) die(14);
            if (!change) break;
        }
        return change;
    } finally{
        untrackedEnd(prevU);
    }
}
function hasListeners(listenable) {
    return listenable.changeListeners_ !== undefined && listenable.changeListeners_.length > 0;
}
function registerListener(listenable, handler) {
    var listeners = listenable.changeListeners_ || (listenable.changeListeners_ = []);
    listeners.push(handler);
    return once(function() {
        var idx = listeners.indexOf(handler);
        if (idx !== -1) listeners.splice(idx, 1);
    });
}
function notifyListeners(listenable, change) {
    var prevU = untrackedStart();
    var listeners = listenable.changeListeners_;
    if (!listeners) return;
    listeners = listeners.slice();
    for(var i = 0, l = listeners.length; i < l; i++)listeners[i](change);
    untrackedEnd(prevU);
}
function makeObservable(target, annotations, options) {
    initObservable(function() {
        var _annotations;
        var adm = asObservableObject(target, options)[$mobx];
        if (annotations && target[storedAnnotationsSymbol]) die("makeObservable second arg must be nullish when using decorators. Mixing @decorator syntax with annotations is not supported.");
        // Default to decorators
        (_annotations = annotations) != null ? _annotations : annotations = collectStoredAnnotations(target);
        // Annotate
        ownKeys(annotations).forEach(function(key) {
            return adm.make_(key, annotations[key]);
        });
    });
    return target;
}
// proto[keysSymbol] = new Set<PropertyKey>()
var keysSymbol = /*#__PURE__*/ Symbol("mobx-keys");
function makeAutoObservable(target, overrides, options) {
    if (!isPlainObject(target) && !isPlainObject(Object.getPrototypeOf(target))) die("'makeAutoObservable' can only be used for classes that don't have a superclass");
    if (isObservableObject(target)) die("makeAutoObservable can only be used on objects not already made observable");
    // Optimization: avoid visiting protos
    // Assumes that annotation.make_/.extend_ works the same for plain objects
    if (isPlainObject(target)) return extendObservable(target, target, overrides, options);
    initObservable(function() {
        var adm = asObservableObject(target, options)[$mobx];
        // Optimization: cache keys on proto
        // Assumes makeAutoObservable can be called only once per object and can't be used in subclass
        if (!target[keysSymbol]) {
            var proto = Object.getPrototypeOf(target);
            var keys = new Set([].concat(ownKeys(target), ownKeys(proto)));
            keys["delete"]("constructor");
            keys["delete"]($mobx);
            addHiddenProp(proto, keysSymbol, keys);
        }
        target[keysSymbol].forEach(function(key) {
            return adm.make_(key, // must pass "undefined" for { key: undefined }
            !overrides ? true : key in overrides ? overrides[key] : true);
        });
    });
    return target;
}
var SPLICE = "splice";
var UPDATE = "update";
var MAX_SPLICE_SIZE = 10000; // See e.g. https://github.com/mobxjs/mobx/issues/859
var arrayTraps = {
    get: function get(target, name) {
        var adm = target[$mobx];
        if (name === $mobx) return adm;
        if (name === "length") return adm.getArrayLength_();
        if (typeof name === "string" && !isNaN(name)) return adm.get_(parseInt(name));
        if (hasProp(arrayExtensions, name)) return arrayExtensions[name];
        return target[name];
    },
    set: function set(target, name, value) {
        var adm = target[$mobx];
        if (name === "length") adm.setArrayLength_(value);
        if (typeof name === "symbol" || isNaN(name)) target[name] = value;
        else // numeric string
        adm.set_(parseInt(name), value);
        return true;
    },
    preventExtensions: function preventExtensions() {
        die(15);
    }
};
var ObservableArrayAdministration = /*#__PURE__*/ function() {
    // this is the prop that gets proxied, so can't replace it!
    function ObservableArrayAdministration(name, enhancer, owned_, legacyMode_) {
        if (name === void 0) name = "ObservableArray@" + getNextId();
        this.owned_ = void 0;
        this.legacyMode_ = void 0;
        this.atom_ = void 0;
        this.values_ = [];
        this.interceptors_ = void 0;
        this.changeListeners_ = void 0;
        this.enhancer_ = void 0;
        this.dehancer = void 0;
        this.proxy_ = void 0;
        this.lastKnownLength_ = 0;
        this.owned_ = owned_;
        this.legacyMode_ = legacyMode_;
        this.atom_ = new Atom(name);
        this.enhancer_ = function(newV, oldV) {
            return enhancer(newV, oldV, name + "[..]");
        };
    }
    var _proto = ObservableArrayAdministration.prototype;
    _proto.dehanceValue_ = function dehanceValue_(value) {
        if (this.dehancer !== undefined) return this.dehancer(value);
        return value;
    };
    _proto.dehanceValues_ = function dehanceValues_(values) {
        if (this.dehancer !== undefined && values.length > 0) return values.map(this.dehancer);
        return values;
    };
    _proto.intercept_ = function intercept_(handler) {
        return registerInterceptor(this, handler);
    };
    _proto.observe_ = function observe_(listener, fireImmediately) {
        if (fireImmediately === void 0) fireImmediately = false;
        if (fireImmediately) listener({
            observableKind: "array",
            object: this.proxy_,
            debugObjectName: this.atom_.name_,
            type: "splice",
            index: 0,
            added: this.values_.slice(),
            addedCount: this.values_.length,
            removed: [],
            removedCount: 0
        });
        return registerListener(this, listener);
    };
    _proto.getArrayLength_ = function getArrayLength_() {
        this.atom_.reportObserved();
        return this.values_.length;
    };
    _proto.setArrayLength_ = function setArrayLength_(newLength) {
        if (typeof newLength !== "number" || isNaN(newLength) || newLength < 0) die("Out of range: " + newLength);
        var currentLength = this.values_.length;
        if (newLength === currentLength) return;
        else if (newLength > currentLength) {
            var newItems = new Array(newLength - currentLength);
            for(var i = 0; i < newLength - currentLength; i++)newItems[i] = undefined;
             // No Array.fill everywhere...
            this.spliceWithArray_(currentLength, 0, newItems);
        } else this.spliceWithArray_(newLength, currentLength - newLength);
    };
    _proto.updateArrayLength_ = function updateArrayLength_(oldLength, delta) {
        if (oldLength !== this.lastKnownLength_) die(16);
        this.lastKnownLength_ += delta;
        if (this.legacyMode_ && delta > 0) reserveArrayBuffer(oldLength + delta + 1);
    };
    _proto.spliceWithArray_ = function spliceWithArray_(index, deleteCount, newItems) {
        var _this = this;
        checkIfStateModificationsAreAllowed(this.atom_);
        var length = this.values_.length;
        if (index === undefined) index = 0;
        else if (index > length) index = length;
        else if (index < 0) index = Math.max(0, length + index);
        if (arguments.length === 1) deleteCount = length - index;
        else if (deleteCount === undefined || deleteCount === null) deleteCount = 0;
        else deleteCount = Math.max(0, Math.min(deleteCount, length - index));
        if (newItems === undefined) newItems = EMPTY_ARRAY;
        if (hasInterceptors(this)) {
            var change = interceptChange(this, {
                object: this.proxy_,
                type: SPLICE,
                index: index,
                removedCount: deleteCount,
                added: newItems
            });
            if (!change) return EMPTY_ARRAY;
            deleteCount = change.removedCount;
            newItems = change.added;
        }
        newItems = newItems.length === 0 ? newItems : newItems.map(function(v) {
            return _this.enhancer_(v, undefined);
        });
        this.legacyMode_;
        var lengthDelta = newItems.length - deleteCount;
        this.updateArrayLength_(length, lengthDelta); // checks if internal array wasn't modified
        var res = this.spliceItemsIntoValues_(index, deleteCount, newItems);
        if (deleteCount !== 0 || newItems.length !== 0) this.notifyArraySplice_(index, newItems, res);
        return this.dehanceValues_(res);
    };
    _proto.spliceItemsIntoValues_ = function spliceItemsIntoValues_(index, deleteCount, newItems) {
        if (newItems.length < MAX_SPLICE_SIZE) {
            var _this$values_;
            return (_this$values_ = this.values_).splice.apply(_this$values_, [
                index,
                deleteCount
            ].concat(newItems));
        } else {
            // The items removed by the splice
            var res = this.values_.slice(index, index + deleteCount);
            // The items that that should remain at the end of the array
            var oldItems = this.values_.slice(index + deleteCount);
            // New length is the previous length + addition count - deletion count
            this.values_.length += newItems.length - deleteCount;
            for(var i = 0; i < newItems.length; i++)this.values_[index + i] = newItems[i];
            for(var _i = 0; _i < oldItems.length; _i++)this.values_[index + newItems.length + _i] = oldItems[_i];
            return res;
        }
    };
    _proto.notifyArrayChildUpdate_ = function notifyArrayChildUpdate_(index, newValue, oldValue) {
        var notifySpy = !this.owned_ && isSpyEnabled();
        var notify = hasListeners(this);
        var change = notify || notifySpy ? {
            observableKind: "array",
            object: this.proxy_,
            type: UPDATE,
            debugObjectName: this.atom_.name_,
            index: index,
            newValue: newValue,
            oldValue: oldValue
        } : null;
        // The reason why this is on right hand side here (and not above), is this way the uglifier will drop it, but it won't
        // cause any runtime overhead in development mode without NODE_ENV set, unless spying is enabled
        if (notifySpy) spyReportStart(change);
        this.atom_.reportChanged();
        if (notify) notifyListeners(this, change);
        if (notifySpy) spyReportEnd();
    };
    _proto.notifyArraySplice_ = function notifyArraySplice_(index, added, removed) {
        var notifySpy = !this.owned_ && isSpyEnabled();
        var notify = hasListeners(this);
        var change = notify || notifySpy ? {
            observableKind: "array",
            object: this.proxy_,
            debugObjectName: this.atom_.name_,
            type: SPLICE,
            index: index,
            removed: removed,
            added: added,
            removedCount: removed.length,
            addedCount: added.length
        } : null;
        if (notifySpy) spyReportStart(change);
        this.atom_.reportChanged();
        // conform: https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/observe
        if (notify) notifyListeners(this, change);
        if (notifySpy) spyReportEnd();
    };
    _proto.get_ = function get_(index) {
        if (this.legacyMode_ && index >= this.values_.length) {
            console.warn("[mobx.array] Attempt to read an array index (" + index + ") that is out of bounds (" + this.values_.length + "). Please check length first. Out of bound indices will not be tracked by MobX");
            return undefined;
        }
        this.atom_.reportObserved();
        return this.dehanceValue_(this.values_[index]);
    };
    _proto.set_ = function set_(index, newValue) {
        var values = this.values_;
        if (this.legacyMode_ && index > values.length) // out of bounds
        die(17, index, values.length);
        if (index < values.length) {
            // update at index in range
            checkIfStateModificationsAreAllowed(this.atom_);
            var oldValue = values[index];
            if (hasInterceptors(this)) {
                var change = interceptChange(this, {
                    type: UPDATE,
                    object: this.proxy_,
                    index: index,
                    newValue: newValue
                });
                if (!change) return;
                newValue = change.newValue;
            }
            newValue = this.enhancer_(newValue, oldValue);
            var changed = newValue !== oldValue;
            if (changed) {
                values[index] = newValue;
                this.notifyArrayChildUpdate_(index, newValue, oldValue);
            }
        } else {
            // For out of bound index, we don't create an actual sparse array,
            // but rather fill the holes with undefined (same as setArrayLength_).
            // This could be considered a bug.
            var newItems = new Array(index + 1 - values.length);
            for(var i = 0; i < newItems.length - 1; i++)newItems[i] = undefined;
             // No Array.fill everywhere...
            newItems[newItems.length - 1] = newValue;
            this.spliceWithArray_(values.length, 0, newItems);
        }
    };
    return ObservableArrayAdministration;
}();
function createObservableArray(initialValues, enhancer, name, owned) {
    if (name === void 0) name = "ObservableArray@" + getNextId();
    if (owned === void 0) owned = false;
    assertProxies();
    return initObservable(function() {
        var adm = new ObservableArrayAdministration(name, enhancer, owned, false);
        addHiddenFinalProp(adm.values_, $mobx, adm);
        var proxy = new Proxy(adm.values_, arrayTraps);
        adm.proxy_ = proxy;
        if (initialValues && initialValues.length) adm.spliceWithArray_(0, 0, initialValues);
        return proxy;
    });
}
// eslint-disable-next-line
var arrayExtensions = {
    clear: function clear() {
        return this.splice(0);
    },
    replace: function replace(newItems) {
        var adm = this[$mobx];
        return adm.spliceWithArray_(0, adm.values_.length, newItems);
    },
    // Used by JSON.stringify
    toJSON: function toJSON() {
        return this.slice();
    },
    /*
   * functions that do alter the internal structure of the array, (based on lib.es6.d.ts)
   * since these functions alter the inner structure of the array, the have side effects.
   * Because the have side effects, they should not be used in computed function,
   * and for that reason the do not call dependencyState.notifyObserved
   */ splice: function splice(index, deleteCount) {
        for(var _len = arguments.length, newItems = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++)newItems[_key - 2] = arguments[_key];
        var adm = this[$mobx];
        switch(arguments.length){
            case 0:
                return [];
            case 1:
                return adm.spliceWithArray_(index);
            case 2:
                return adm.spliceWithArray_(index, deleteCount);
        }
        return adm.spliceWithArray_(index, deleteCount, newItems);
    },
    spliceWithArray: function spliceWithArray(index, deleteCount, newItems) {
        return this[$mobx].spliceWithArray_(index, deleteCount, newItems);
    },
    push: function push() {
        var adm = this[$mobx];
        for(var _len2 = arguments.length, items = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)items[_key2] = arguments[_key2];
        adm.spliceWithArray_(adm.values_.length, 0, items);
        return adm.values_.length;
    },
    pop: function pop() {
        return this.splice(Math.max(this[$mobx].values_.length - 1, 0), 1)[0];
    },
    shift: function shift() {
        return this.splice(0, 1)[0];
    },
    unshift: function unshift() {
        var adm = this[$mobx];
        for(var _len3 = arguments.length, items = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++)items[_key3] = arguments[_key3];
        adm.spliceWithArray_(0, 0, items);
        return adm.values_.length;
    },
    reverse: function reverse() {
        // reverse by default mutates in place before returning the result
        // which makes it both a 'derivation' and a 'mutation'.
        if (globalState.trackingDerivation) die(37, "reverse");
        this.replace(this.slice().reverse());
        return this;
    },
    sort: function sort() {
        // sort by default mutates in place before returning the result
        // which goes against all good practices. Let's not change the array in place!
        if (globalState.trackingDerivation) die(37, "sort");
        var copy = this.slice();
        copy.sort.apply(copy, arguments);
        this.replace(copy);
        return this;
    },
    remove: function remove(value) {
        var adm = this[$mobx];
        var idx = adm.dehanceValues_(adm.values_).indexOf(value);
        if (idx > -1) {
            this.splice(idx, 1);
            return true;
        }
        return false;
    }
};
/**
 * Wrap function from prototype
 * Without this, everything works as well, but this works
 * faster as everything works on unproxied values
 */ addArrayExtension("at", simpleFunc);
addArrayExtension("concat", simpleFunc);
addArrayExtension("flat", simpleFunc);
addArrayExtension("includes", simpleFunc);
addArrayExtension("indexOf", simpleFunc);
addArrayExtension("join", simpleFunc);
addArrayExtension("lastIndexOf", simpleFunc);
addArrayExtension("slice", simpleFunc);
addArrayExtension("toString", simpleFunc);
addArrayExtension("toLocaleString", simpleFunc);
addArrayExtension("toSorted", simpleFunc);
addArrayExtension("toSpliced", simpleFunc);
addArrayExtension("with", simpleFunc);
// map
addArrayExtension("every", mapLikeFunc);
addArrayExtension("filter", mapLikeFunc);
addArrayExtension("find", mapLikeFunc);
addArrayExtension("findIndex", mapLikeFunc);
addArrayExtension("findLast", mapLikeFunc);
addArrayExtension("findLastIndex", mapLikeFunc);
addArrayExtension("flatMap", mapLikeFunc);
addArrayExtension("forEach", mapLikeFunc);
addArrayExtension("map", mapLikeFunc);
addArrayExtension("some", mapLikeFunc);
addArrayExtension("toReversed", mapLikeFunc);
// reduce
addArrayExtension("reduce", reduceLikeFunc);
addArrayExtension("reduceRight", reduceLikeFunc);
function addArrayExtension(funcName, funcFactory) {
    if (typeof Array.prototype[funcName] === "function") arrayExtensions[funcName] = funcFactory(funcName);
}
// Report and delegate to dehanced array
function simpleFunc(funcName) {
    return function() {
        var adm = this[$mobx];
        adm.atom_.reportObserved();
        var dehancedValues = adm.dehanceValues_(adm.values_);
        return dehancedValues[funcName].apply(dehancedValues, arguments);
    };
}
// Make sure callbacks recieve correct array arg #2326
function mapLikeFunc(funcName) {
    return function(callback, thisArg) {
        var _this2 = this;
        var adm = this[$mobx];
        adm.atom_.reportObserved();
        var dehancedValues = adm.dehanceValues_(adm.values_);
        return dehancedValues[funcName](function(element, index) {
            return callback.call(thisArg, element, index, _this2);
        });
    };
}
// Make sure callbacks recieve correct array arg #2326
function reduceLikeFunc(funcName) {
    return function() {
        var _this3 = this;
        var adm = this[$mobx];
        adm.atom_.reportObserved();
        var dehancedValues = adm.dehanceValues_(adm.values_);
        // #2432 - reduce behavior depends on arguments.length
        var callback = arguments[0];
        arguments[0] = function(accumulator, currentValue, index) {
            return callback(accumulator, currentValue, index, _this3);
        };
        return dehancedValues[funcName].apply(dehancedValues, arguments);
    };
}
var isObservableArrayAdministration = /*#__PURE__*/ createInstanceofPredicate("ObservableArrayAdministration", ObservableArrayAdministration);
function isObservableArray(thing) {
    return isObject(thing) && isObservableArrayAdministration(thing[$mobx]);
}
var _Symbol$iterator, _Symbol$toStringTag;
var ObservableMapMarker = {};
var ADD = "add";
var DELETE = "delete";
// just extend Map? See also https://gist.github.com/nestharus/13b4d74f2ef4a2f4357dbd3fc23c1e54
// But: https://github.com/mobxjs/mobx/issues/1556
_Symbol$iterator = Symbol.iterator;
_Symbol$toStringTag = Symbol.toStringTag;
var ObservableMap = /*#__PURE__*/ function() {
    // hasMap, not hashMap >-).
    function ObservableMap(initialData, enhancer_, name_) {
        var _this = this;
        if (enhancer_ === void 0) enhancer_ = deepEnhancer;
        if (name_ === void 0) name_ = "ObservableMap@" + getNextId();
        this.enhancer_ = void 0;
        this.name_ = void 0;
        this[$mobx] = ObservableMapMarker;
        this.data_ = void 0;
        this.hasMap_ = void 0;
        this.keysAtom_ = void 0;
        this.interceptors_ = void 0;
        this.changeListeners_ = void 0;
        this.dehancer = void 0;
        this.enhancer_ = enhancer_;
        this.name_ = name_;
        if (!isFunction(Map)) die(18);
        initObservable(function() {
            _this.keysAtom_ = createAtom(_this.name_ + ".keys()");
            _this.data_ = new Map();
            _this.hasMap_ = new Map();
            if (initialData) _this.merge(initialData);
        });
    }
    var _proto = ObservableMap.prototype;
    _proto.has_ = function has_(key) {
        return this.data_.has(key);
    };
    _proto.has = function has(key) {
        var _this2 = this;
        if (!globalState.trackingDerivation) return this.has_(key);
        var entry = this.hasMap_.get(key);
        if (!entry) {
            var newEntry = entry = new ObservableValue(this.has_(key), referenceEnhancer, this.name_ + "." + stringifyKey(key) + "?", false);
            this.hasMap_.set(key, newEntry);
            onBecomeUnobserved(newEntry, function() {
                return _this2.hasMap_["delete"](key);
            });
        }
        return entry.get();
    };
    _proto.set = function set(key, value) {
        var hasKey = this.has_(key);
        if (hasInterceptors(this)) {
            var change = interceptChange(this, {
                type: hasKey ? UPDATE : ADD,
                object: this,
                newValue: value,
                name: key
            });
            if (!change) return this;
            value = change.newValue;
        }
        if (hasKey) this.updateValue_(key, value);
        else this.addValue_(key, value);
        return this;
    };
    _proto["delete"] = function _delete(key) {
        var _this3 = this;
        checkIfStateModificationsAreAllowed(this.keysAtom_);
        if (hasInterceptors(this)) {
            var change = interceptChange(this, {
                type: DELETE,
                object: this,
                name: key
            });
            if (!change) return false;
        }
        if (this.has_(key)) {
            var notifySpy = isSpyEnabled();
            var notify = hasListeners(this);
            var _change = notify || notifySpy ? {
                observableKind: "map",
                debugObjectName: this.name_,
                type: DELETE,
                object: this,
                oldValue: this.data_.get(key).value_,
                name: key
            } : null;
            if (notifySpy) spyReportStart(_change);
             // TODO fix type
            transaction(function() {
                var _this3$hasMap_$get;
                _this3.keysAtom_.reportChanged();
                (_this3$hasMap_$get = _this3.hasMap_.get(key)) == null || _this3$hasMap_$get.setNewValue_(false);
                var observable = _this3.data_.get(key);
                observable.setNewValue_(undefined);
                _this3.data_["delete"](key);
            });
            if (notify) notifyListeners(this, _change);
            if (notifySpy) spyReportEnd();
            return true;
        }
        return false;
    };
    _proto.updateValue_ = function updateValue_(key, newValue) {
        var observable = this.data_.get(key);
        newValue = observable.prepareNewValue_(newValue);
        if (newValue !== globalState.UNCHANGED) {
            var notifySpy = isSpyEnabled();
            var notify = hasListeners(this);
            var change = notify || notifySpy ? {
                observableKind: "map",
                debugObjectName: this.name_,
                type: UPDATE,
                object: this,
                oldValue: observable.value_,
                name: key,
                newValue: newValue
            } : null;
            if (notifySpy) spyReportStart(change);
             // TODO fix type
            observable.setNewValue_(newValue);
            if (notify) notifyListeners(this, change);
            if (notifySpy) spyReportEnd();
        }
    };
    _proto.addValue_ = function addValue_(key, newValue) {
        var _this4 = this;
        checkIfStateModificationsAreAllowed(this.keysAtom_);
        transaction(function() {
            var _this4$hasMap_$get;
            var observable = new ObservableValue(newValue, _this4.enhancer_, _this4.name_ + "." + stringifyKey(key), false);
            _this4.data_.set(key, observable);
            newValue = observable.value_; // value might have been changed
            (_this4$hasMap_$get = _this4.hasMap_.get(key)) == null || _this4$hasMap_$get.setNewValue_(true);
            _this4.keysAtom_.reportChanged();
        });
        var notifySpy = isSpyEnabled();
        var notify = hasListeners(this);
        var change = notify || notifySpy ? {
            observableKind: "map",
            debugObjectName: this.name_,
            type: ADD,
            object: this,
            name: key,
            newValue: newValue
        } : null;
        if (notifySpy) spyReportStart(change);
         // TODO fix type
        if (notify) notifyListeners(this, change);
        if (notifySpy) spyReportEnd();
    };
    _proto.get = function get(key) {
        if (this.has(key)) return this.dehanceValue_(this.data_.get(key).get());
        return this.dehanceValue_(undefined);
    };
    _proto.dehanceValue_ = function dehanceValue_(value) {
        if (this.dehancer !== undefined) return this.dehancer(value);
        return value;
    };
    _proto.keys = function keys() {
        this.keysAtom_.reportObserved();
        return this.data_.keys();
    };
    _proto.values = function values() {
        var self1 = this;
        var keys = this.keys();
        return makeIterable({
            next: function next() {
                var _keys$next = keys.next(), done = _keys$next.done, value = _keys$next.value;
                return {
                    done: done,
                    value: done ? undefined : self1.get(value)
                };
            }
        });
    };
    _proto.entries = function entries() {
        var self1 = this;
        var keys = this.keys();
        return makeIterable({
            next: function next() {
                var _keys$next2 = keys.next(), done = _keys$next2.done, value = _keys$next2.value;
                return {
                    done: done,
                    value: done ? undefined : [
                        value,
                        self1.get(value)
                    ]
                };
            }
        });
    };
    _proto[_Symbol$iterator] = function() {
        return this.entries();
    };
    _proto.forEach = function forEach(callback, thisArg) {
        for(var _iterator = _createForOfIteratorHelperLoose(this), _step; !(_step = _iterator()).done;){
            var _step$value = _step.value, key = _step$value[0], value = _step$value[1];
            callback.call(thisArg, value, key, this);
        }
    } /** Merge another object into this object, returns this. */ ;
    _proto.merge = function merge(other) {
        var _this5 = this;
        if (isObservableMap(other)) other = new Map(other);
        transaction(function() {
            if (isPlainObject(other)) getPlainObjectKeys(other).forEach(function(key) {
                return _this5.set(key, other[key]);
            });
            else if (Array.isArray(other)) other.forEach(function(_ref) {
                var key = _ref[0], value = _ref[1];
                return _this5.set(key, value);
            });
            else if (isES6Map(other)) {
                if (other.constructor !== Map) die(19, other);
                other.forEach(function(value, key) {
                    return _this5.set(key, value);
                });
            } else if (other !== null && other !== undefined) die(20, other);
        });
        return this;
    };
    _proto.clear = function clear() {
        var _this6 = this;
        transaction(function() {
            untracked(function() {
                for(var _iterator2 = _createForOfIteratorHelperLoose(_this6.keys()), _step2; !(_step2 = _iterator2()).done;){
                    var key = _step2.value;
                    _this6["delete"](key);
                }
            });
        });
    };
    _proto.replace = function replace(values) {
        var _this7 = this;
        // Implementation requirements:
        // - respect ordering of replacement map
        // - allow interceptors to run and potentially prevent individual operations
        // - don't recreate observables that already exist in original map (so we don't destroy existing subscriptions)
        // - don't _keysAtom.reportChanged if the keys of resulting map are indentical (order matters!)
        // - note that result map may differ from replacement map due to the interceptors
        transaction(function() {
            // Convert to map so we can do quick key lookups
            var replacementMap = convertToMap(values);
            var orderedData = new Map();
            // Used for optimization
            var keysReportChangedCalled = false;
            // Delete keys that don't exist in replacement map
            // if the key deletion is prevented by interceptor
            // add entry at the beginning of the result map
            for(var _iterator3 = _createForOfIteratorHelperLoose(_this7.data_.keys()), _step3; !(_step3 = _iterator3()).done;){
                var key = _step3.value;
                // Concurrently iterating/deleting keys
                // iterator should handle this correctly
                if (!replacementMap.has(key)) {
                    var deleted = _this7["delete"](key);
                    // Was the key removed?
                    if (deleted) // _keysAtom.reportChanged() was already called
                    keysReportChangedCalled = true;
                    else {
                        // Delete prevented by interceptor
                        var value = _this7.data_.get(key);
                        orderedData.set(key, value);
                    }
                }
            }
            // Merge entries
            for(var _iterator4 = _createForOfIteratorHelperLoose(replacementMap.entries()), _step4; !(_step4 = _iterator4()).done;){
                var _step4$value = _step4.value, _key = _step4$value[0], _value = _step4$value[1];
                // We will want to know whether a new key is added
                var keyExisted = _this7.data_.has(_key);
                // Add or update value
                _this7.set(_key, _value);
                // The addition could have been prevent by interceptor
                if (_this7.data_.has(_key)) {
                    // The update could have been prevented by interceptor
                    // and also we want to preserve existing values
                    // so use value from _data map (instead of replacement map)
                    var _value2 = _this7.data_.get(_key);
                    orderedData.set(_key, _value2);
                    // Was a new key added?
                    if (!keyExisted) // _keysAtom.reportChanged() was already called
                    keysReportChangedCalled = true;
                }
            }
            // Check for possible key order change
            if (!keysReportChangedCalled) {
                if (_this7.data_.size !== orderedData.size) // If size differs, keys are definitely modified
                _this7.keysAtom_.reportChanged();
                else {
                    var iter1 = _this7.data_.keys();
                    var iter2 = orderedData.keys();
                    var next1 = iter1.next();
                    var next2 = iter2.next();
                    while(!next1.done){
                        if (next1.value !== next2.value) {
                            _this7.keysAtom_.reportChanged();
                            break;
                        }
                        next1 = iter1.next();
                        next2 = iter2.next();
                    }
                }
            }
            // Use correctly ordered map
            _this7.data_ = orderedData;
        });
        return this;
    };
    _proto.toString = function toString() {
        return "[object ObservableMap]";
    };
    _proto.toJSON = function toJSON() {
        return Array.from(this);
    };
    /**
   * Observes this object. Triggers for the events 'add', 'update' and 'delete'.
   * See: https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/observe
   * for callback details
   */ _proto.observe_ = function observe_(listener, fireImmediately) {
        if (fireImmediately === true) die("`observe` doesn't support fireImmediately=true in combination with maps.");
        return registerListener(this, listener);
    };
    _proto.intercept_ = function intercept_(handler) {
        return registerInterceptor(this, handler);
    };
    _createClass(ObservableMap, [
        {
            key: "size",
            get: function get() {
                this.keysAtom_.reportObserved();
                return this.data_.size;
            }
        },
        {
            key: _Symbol$toStringTag,
            get: function get() {
                return "Map";
            }
        }
    ]);
    return ObservableMap;
}();
// eslint-disable-next-line
var isObservableMap = /*#__PURE__*/ createInstanceofPredicate("ObservableMap", ObservableMap);
function convertToMap(dataStructure) {
    if (isES6Map(dataStructure) || isObservableMap(dataStructure)) return dataStructure;
    else if (Array.isArray(dataStructure)) return new Map(dataStructure);
    else if (isPlainObject(dataStructure)) {
        var map = new Map();
        for(var key in dataStructure)map.set(key, dataStructure[key]);
        return map;
    } else return die(21, dataStructure);
}
var _Symbol$iterator$1, _Symbol$toStringTag$1;
var ObservableSetMarker = {};
_Symbol$iterator$1 = Symbol.iterator;
_Symbol$toStringTag$1 = Symbol.toStringTag;
var ObservableSet = /*#__PURE__*/ function() {
    function ObservableSet(initialData, enhancer, name_) {
        var _this = this;
        if (enhancer === void 0) enhancer = deepEnhancer;
        if (name_ === void 0) name_ = "ObservableSet@" + getNextId();
        this.name_ = void 0;
        this[$mobx] = ObservableSetMarker;
        this.data_ = new Set();
        this.atom_ = void 0;
        this.changeListeners_ = void 0;
        this.interceptors_ = void 0;
        this.dehancer = void 0;
        this.enhancer_ = void 0;
        this.name_ = name_;
        if (!isFunction(Set)) die(22);
        this.enhancer_ = function(newV, oldV) {
            return enhancer(newV, oldV, name_);
        };
        initObservable(function() {
            _this.atom_ = createAtom(_this.name_);
            if (initialData) _this.replace(initialData);
        });
    }
    var _proto = ObservableSet.prototype;
    _proto.dehanceValue_ = function dehanceValue_(value) {
        if (this.dehancer !== undefined) return this.dehancer(value);
        return value;
    };
    _proto.clear = function clear() {
        var _this2 = this;
        transaction(function() {
            untracked(function() {
                for(var _iterator = _createForOfIteratorHelperLoose(_this2.data_.values()), _step; !(_step = _iterator()).done;){
                    var value = _step.value;
                    _this2["delete"](value);
                }
            });
        });
    };
    _proto.forEach = function forEach(callbackFn, thisArg) {
        for(var _iterator2 = _createForOfIteratorHelperLoose(this), _step2; !(_step2 = _iterator2()).done;){
            var value = _step2.value;
            callbackFn.call(thisArg, value, value, this);
        }
    };
    _proto.add = function add(value) {
        var _this3 = this;
        checkIfStateModificationsAreAllowed(this.atom_);
        if (hasInterceptors(this)) {
            var change = interceptChange(this, {
                type: ADD,
                object: this,
                newValue: value
            });
            if (!change) return this;
        // ideally, value = change.value would be done here, so that values can be
        // changed by interceptor. Same applies for other Set and Map api's.
        }
        if (!this.has(value)) {
            transaction(function() {
                _this3.data_.add(_this3.enhancer_(value, undefined));
                _this3.atom_.reportChanged();
            });
            var notifySpy = isSpyEnabled();
            var notify = hasListeners(this);
            var _change = notify || notifySpy ? {
                observableKind: "set",
                debugObjectName: this.name_,
                type: ADD,
                object: this,
                newValue: value
            } : null;
            if (notifySpy && true) spyReportStart(_change);
            if (notify) notifyListeners(this, _change);
            if (notifySpy && true) spyReportEnd();
        }
        return this;
    };
    _proto["delete"] = function _delete(value) {
        var _this4 = this;
        if (hasInterceptors(this)) {
            var change = interceptChange(this, {
                type: DELETE,
                object: this,
                oldValue: value
            });
            if (!change) return false;
        }
        if (this.has(value)) {
            var notifySpy = isSpyEnabled();
            var notify = hasListeners(this);
            var _change2 = notify || notifySpy ? {
                observableKind: "set",
                debugObjectName: this.name_,
                type: DELETE,
                object: this,
                oldValue: value
            } : null;
            if (notifySpy && true) spyReportStart(_change2);
            transaction(function() {
                _this4.atom_.reportChanged();
                _this4.data_["delete"](value);
            });
            if (notify) notifyListeners(this, _change2);
            if (notifySpy && true) spyReportEnd();
            return true;
        }
        return false;
    };
    _proto.has = function has(value) {
        this.atom_.reportObserved();
        return this.data_.has(this.dehanceValue_(value));
    };
    _proto.entries = function entries() {
        var nextIndex = 0;
        var keys = Array.from(this.keys());
        var values = Array.from(this.values());
        return makeIterable({
            next: function next() {
                var index = nextIndex;
                nextIndex += 1;
                return index < values.length ? {
                    value: [
                        keys[index],
                        values[index]
                    ],
                    done: false
                } : {
                    done: true
                };
            }
        });
    };
    _proto.keys = function keys() {
        return this.values();
    };
    _proto.values = function values() {
        this.atom_.reportObserved();
        var self1 = this;
        var nextIndex = 0;
        var observableValues = Array.from(this.data_.values());
        return makeIterable({
            next: function next() {
                return nextIndex < observableValues.length ? {
                    value: self1.dehanceValue_(observableValues[nextIndex++]),
                    done: false
                } : {
                    done: true
                };
            }
        });
    };
    _proto.replace = function replace(other) {
        var _this5 = this;
        if (isObservableSet(other)) other = new Set(other);
        transaction(function() {
            if (Array.isArray(other)) {
                _this5.clear();
                other.forEach(function(value) {
                    return _this5.add(value);
                });
            } else if (isES6Set(other)) {
                _this5.clear();
                other.forEach(function(value) {
                    return _this5.add(value);
                });
            } else if (other !== null && other !== undefined) die("Cannot initialize set from " + other);
        });
        return this;
    };
    _proto.observe_ = function observe_(listener, fireImmediately) {
        // ... 'fireImmediately' could also be true?
        if (fireImmediately === true) die("`observe` doesn't support fireImmediately=true in combination with sets.");
        return registerListener(this, listener);
    };
    _proto.intercept_ = function intercept_(handler) {
        return registerInterceptor(this, handler);
    };
    _proto.toJSON = function toJSON() {
        return Array.from(this);
    };
    _proto.toString = function toString() {
        return "[object ObservableSet]";
    };
    _proto[_Symbol$iterator$1] = function() {
        return this.values();
    };
    _createClass(ObservableSet, [
        {
            key: "size",
            get: function get() {
                this.atom_.reportObserved();
                return this.data_.size;
            }
        },
        {
            key: _Symbol$toStringTag$1,
            get: function get() {
                return "Set";
            }
        }
    ]);
    return ObservableSet;
}();
// eslint-disable-next-line
var isObservableSet = /*#__PURE__*/ createInstanceofPredicate("ObservableSet", ObservableSet);
var descriptorCache = /*#__PURE__*/ Object.create(null);
var REMOVE = "remove";
var ObservableObjectAdministration = /*#__PURE__*/ function() {
    function ObservableObjectAdministration(target_, values_, name_, // Used anytime annotation is not explicitely provided
    defaultAnnotation_) {
        if (values_ === void 0) values_ = new Map();
        if (defaultAnnotation_ === void 0) defaultAnnotation_ = autoAnnotation;
        this.target_ = void 0;
        this.values_ = void 0;
        this.name_ = void 0;
        this.defaultAnnotation_ = void 0;
        this.keysAtom_ = void 0;
        this.changeListeners_ = void 0;
        this.interceptors_ = void 0;
        this.proxy_ = void 0;
        this.isPlainObject_ = void 0;
        this.appliedAnnotations_ = void 0;
        this.pendingKeys_ = void 0;
        this.target_ = target_;
        this.values_ = values_;
        this.name_ = name_;
        this.defaultAnnotation_ = defaultAnnotation_;
        this.keysAtom_ = new Atom(this.name_ + ".keys");
        // Optimization: we use this frequently
        this.isPlainObject_ = isPlainObject(this.target_);
        if (!isAnnotation(this.defaultAnnotation_)) die("defaultAnnotation must be valid annotation");
        // Prepare structure for tracking which fields were already annotated
        this.appliedAnnotations_ = {};
    }
    var _proto = ObservableObjectAdministration.prototype;
    _proto.getObservablePropValue_ = function getObservablePropValue_(key) {
        return this.values_.get(key).get();
    };
    _proto.setObservablePropValue_ = function setObservablePropValue_(key, newValue) {
        var observable = this.values_.get(key);
        if (observable instanceof ComputedValue) {
            observable.set(newValue);
            return true;
        }
        // intercept
        if (hasInterceptors(this)) {
            var change = interceptChange(this, {
                type: UPDATE,
                object: this.proxy_ || this.target_,
                name: key,
                newValue: newValue
            });
            if (!change) return null;
            newValue = change.newValue;
        }
        newValue = observable.prepareNewValue_(newValue);
        // notify spy & observers
        if (newValue !== globalState.UNCHANGED) {
            var notify = hasListeners(this);
            var notifySpy = isSpyEnabled();
            var _change = notify || notifySpy ? {
                type: UPDATE,
                observableKind: "object",
                debugObjectName: this.name_,
                object: this.proxy_ || this.target_,
                oldValue: observable.value_,
                name: key,
                newValue: newValue
            } : null;
            if (notifySpy) spyReportStart(_change);
            observable.setNewValue_(newValue);
            if (notify) notifyListeners(this, _change);
            if (notifySpy) spyReportEnd();
        }
        return true;
    };
    _proto.get_ = function get_(key) {
        if (globalState.trackingDerivation && !hasProp(this.target_, key)) // Key doesn't exist yet, subscribe for it in case it's added later
        this.has_(key);
        return this.target_[key];
    } /**
   * @param {PropertyKey} key
   * @param {any} value
   * @param {Annotation|boolean} annotation true - use default annotation, false - copy as is
   * @param {boolean} proxyTrap whether it's called from proxy trap
   * @returns {boolean|null} true on success, false on failure (proxyTrap + non-configurable), null when cancelled by interceptor
   */ ;
    _proto.set_ = function set_(key, value, proxyTrap) {
        if (proxyTrap === void 0) proxyTrap = false;
        // Don't use .has(key) - we care about own
        if (hasProp(this.target_, key)) {
            // Existing prop
            if (this.values_.has(key)) // Observable (can be intercepted)
            return this.setObservablePropValue_(key, value);
            else if (proxyTrap) // Non-observable - proxy
            return Reflect.set(this.target_, key, value);
            else {
                // Non-observable
                this.target_[key] = value;
                return true;
            }
        } else // New prop
        return this.extend_(key, {
            value: value,
            enumerable: true,
            writable: true,
            configurable: true
        }, this.defaultAnnotation_, proxyTrap);
    };
    _proto.has_ = function has_(key) {
        if (!globalState.trackingDerivation) // Skip key subscription outside derivation
        return key in this.target_;
        this.pendingKeys_ || (this.pendingKeys_ = new Map());
        var entry = this.pendingKeys_.get(key);
        if (!entry) {
            entry = new ObservableValue(key in this.target_, referenceEnhancer, this.name_ + "." + stringifyKey(key) + "?", false);
            this.pendingKeys_.set(key, entry);
        }
        return entry.get();
    } /**
   * @param {PropertyKey} key
   * @param {Annotation|boolean} annotation true - use default annotation, false - ignore prop
   */ ;
    _proto.make_ = function make_(key, annotation) {
        if (annotation === true) annotation = this.defaultAnnotation_;
        if (annotation === false) return;
        assertAnnotable(this, annotation, key);
        if (!(key in this.target_)) {
            var _this$target_$storedA;
            // Throw on missing key, except for decorators:
            // Decorator annotations are collected from whole prototype chain.
            // When called from super() some props may not exist yet.
            // However we don't have to worry about missing prop,
            // because the decorator must have been applied to something.
            if ((_this$target_$storedA = this.target_[storedAnnotationsSymbol]) != null && _this$target_$storedA[key]) return; // will be annotated by subclass constructor
            else die(1, annotation.annotationType_, this.name_ + "." + key.toString());
        }
        var source = this.target_;
        while(source && source !== objectPrototype){
            var descriptor = getDescriptor(source, key);
            if (descriptor) {
                var outcome = annotation.make_(this, key, descriptor, source);
                if (outcome === 0 /* MakeResult.Cancel */ ) return;
                if (outcome === 1 /* MakeResult.Break */ ) break;
            }
            source = Object.getPrototypeOf(source);
        }
        recordAnnotationApplied(this, annotation, key);
    } /**
   * @param {PropertyKey} key
   * @param {PropertyDescriptor} descriptor
   * @param {Annotation|boolean} annotation true - use default annotation, false - copy as is
   * @param {boolean} proxyTrap whether it's called from proxy trap
   * @returns {boolean|null} true on success, false on failure (proxyTrap + non-configurable), null when cancelled by interceptor
   */ ;
    _proto.extend_ = function extend_(key, descriptor, annotation, proxyTrap) {
        if (proxyTrap === void 0) proxyTrap = false;
        if (annotation === true) annotation = this.defaultAnnotation_;
        if (annotation === false) return this.defineProperty_(key, descriptor, proxyTrap);
        assertAnnotable(this, annotation, key);
        var outcome = annotation.extend_(this, key, descriptor, proxyTrap);
        if (outcome) recordAnnotationApplied(this, annotation, key);
        return outcome;
    } /**
   * @param {PropertyKey} key
   * @param {PropertyDescriptor} descriptor
   * @param {boolean} proxyTrap whether it's called from proxy trap
   * @returns {boolean|null} true on success, false on failure (proxyTrap + non-configurable), null when cancelled by interceptor
   */ ;
    _proto.defineProperty_ = function defineProperty_(key, descriptor, proxyTrap) {
        if (proxyTrap === void 0) proxyTrap = false;
        checkIfStateModificationsAreAllowed(this.keysAtom_);
        try {
            startBatch();
            // Delete
            var deleteOutcome = this.delete_(key);
            if (!deleteOutcome) // Failure or intercepted
            return deleteOutcome;
            // ADD interceptor
            if (hasInterceptors(this)) {
                var change = interceptChange(this, {
                    object: this.proxy_ || this.target_,
                    name: key,
                    type: ADD,
                    newValue: descriptor.value
                });
                if (!change) return null;
                var newValue = change.newValue;
                if (descriptor.value !== newValue) descriptor = _extends({}, descriptor, {
                    value: newValue
                });
            }
            // Define
            if (proxyTrap) {
                if (!Reflect.defineProperty(this.target_, key, descriptor)) return false;
            } else defineProperty(this.target_, key, descriptor);
            // Notify
            this.notifyPropertyAddition_(key, descriptor.value);
        } finally{
            endBatch();
        }
        return true;
    };
    _proto.defineObservableProperty_ = function defineObservableProperty_(key, value, enhancer, proxyTrap) {
        if (proxyTrap === void 0) proxyTrap = false;
        checkIfStateModificationsAreAllowed(this.keysAtom_);
        try {
            startBatch();
            // Delete
            var deleteOutcome = this.delete_(key);
            if (!deleteOutcome) // Failure or intercepted
            return deleteOutcome;
            // ADD interceptor
            if (hasInterceptors(this)) {
                var change = interceptChange(this, {
                    object: this.proxy_ || this.target_,
                    name: key,
                    type: ADD,
                    newValue: value
                });
                if (!change) return null;
                value = change.newValue;
            }
            var cachedDescriptor = getCachedObservablePropDescriptor(key);
            var descriptor = {
                configurable: globalState.safeDescriptors ? this.isPlainObject_ : true,
                enumerable: true,
                get: cachedDescriptor.get,
                set: cachedDescriptor.set
            };
            // Define
            if (proxyTrap) {
                if (!Reflect.defineProperty(this.target_, key, descriptor)) return false;
            } else defineProperty(this.target_, key, descriptor);
            var observable = new ObservableValue(value, enhancer, this.name_ + "." + key.toString(), false);
            this.values_.set(key, observable);
            // Notify (value possibly changed by ObservableValue)
            this.notifyPropertyAddition_(key, observable.value_);
        } finally{
            endBatch();
        }
        return true;
    };
    _proto.defineComputedProperty_ = function defineComputedProperty_(key, options, proxyTrap) {
        if (proxyTrap === void 0) proxyTrap = false;
        checkIfStateModificationsAreAllowed(this.keysAtom_);
        try {
            startBatch();
            // Delete
            var deleteOutcome = this.delete_(key);
            if (!deleteOutcome) // Failure or intercepted
            return deleteOutcome;
            // ADD interceptor
            if (hasInterceptors(this)) {
                var change = interceptChange(this, {
                    object: this.proxy_ || this.target_,
                    name: key,
                    type: ADD,
                    newValue: undefined
                });
                if (!change) return null;
            }
            options.name || (options.name = this.name_ + "." + key.toString());
            options.context = this.proxy_ || this.target_;
            var cachedDescriptor = getCachedObservablePropDescriptor(key);
            var descriptor = {
                configurable: globalState.safeDescriptors ? this.isPlainObject_ : true,
                enumerable: false,
                get: cachedDescriptor.get,
                set: cachedDescriptor.set
            };
            // Define
            if (proxyTrap) {
                if (!Reflect.defineProperty(this.target_, key, descriptor)) return false;
            } else defineProperty(this.target_, key, descriptor);
            this.values_.set(key, new ComputedValue(options));
            // Notify
            this.notifyPropertyAddition_(key, undefined);
        } finally{
            endBatch();
        }
        return true;
    } /**
   * @param {PropertyKey} key
   * @param {PropertyDescriptor} descriptor
   * @param {boolean} proxyTrap whether it's called from proxy trap
   * @returns {boolean|null} true on success, false on failure (proxyTrap + non-configurable), null when cancelled by interceptor
   */ ;
    _proto.delete_ = function delete_(key, proxyTrap) {
        if (proxyTrap === void 0) proxyTrap = false;
        checkIfStateModificationsAreAllowed(this.keysAtom_);
        // No such prop
        if (!hasProp(this.target_, key)) return true;
        // Intercept
        if (hasInterceptors(this)) {
            var change = interceptChange(this, {
                object: this.proxy_ || this.target_,
                name: key,
                type: REMOVE
            });
            // Cancelled
            if (!change) return null;
        }
        // Delete
        try {
            var _this$pendingKeys_, _this$pendingKeys_$ge;
            startBatch();
            var notify = hasListeners(this);
            var notifySpy = isSpyEnabled();
            var observable = this.values_.get(key);
            // Value needed for spies/listeners
            var value = undefined;
            // Optimization: don't pull the value unless we will need it
            if (!observable && (notify || notifySpy)) {
                var _getDescriptor;
                value = (_getDescriptor = getDescriptor(this.target_, key)) == null ? void 0 : _getDescriptor.value;
            }
            // delete prop (do first, may fail)
            if (proxyTrap) {
                if (!Reflect.deleteProperty(this.target_, key)) return false;
            } else delete this.target_[key];
            delete this.appliedAnnotations_[key];
            // Clear observable
            if (observable) {
                this.values_["delete"](key);
                // for computed, value is undefined
                if (observable instanceof ObservableValue) value = observable.value_;
                // Notify: autorun(() => obj[key]), see #1796
                propagateChanged(observable);
            }
            // Notify "keys/entries/values" observers
            this.keysAtom_.reportChanged();
            // Notify "has" observers
            // "in" as it may still exist in proto
            (_this$pendingKeys_ = this.pendingKeys_) == null || (_this$pendingKeys_$ge = _this$pendingKeys_.get(key)) == null || _this$pendingKeys_$ge.set(key in this.target_);
            // Notify spies/listeners
            if (notify || notifySpy) {
                var _change2 = {
                    type: REMOVE,
                    observableKind: "object",
                    object: this.proxy_ || this.target_,
                    debugObjectName: this.name_,
                    oldValue: value,
                    name: key
                };
                if (notifySpy) spyReportStart(_change2);
                if (notify) notifyListeners(this, _change2);
                if (notifySpy) spyReportEnd();
            }
        } finally{
            endBatch();
        }
        return true;
    } /**
   * Observes this object. Triggers for the events 'add', 'update' and 'delete'.
   * See: https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/observe
   * for callback details
   */ ;
    _proto.observe_ = function observe_(callback, fireImmediately) {
        if (fireImmediately === true) die("`observe` doesn't support the fire immediately property for observable objects.");
        return registerListener(this, callback);
    };
    _proto.intercept_ = function intercept_(handler) {
        return registerInterceptor(this, handler);
    };
    _proto.notifyPropertyAddition_ = function notifyPropertyAddition_(key, value) {
        var _this$pendingKeys_2, _this$pendingKeys_2$g;
        var notify = hasListeners(this);
        var notifySpy = isSpyEnabled();
        if (notify || notifySpy) {
            var change = notify || notifySpy ? {
                type: ADD,
                observableKind: "object",
                debugObjectName: this.name_,
                object: this.proxy_ || this.target_,
                name: key,
                newValue: value
            } : null;
            if (notifySpy) spyReportStart(change);
            if (notify) notifyListeners(this, change);
            if (notifySpy) spyReportEnd();
        }
        (_this$pendingKeys_2 = this.pendingKeys_) == null || (_this$pendingKeys_2$g = _this$pendingKeys_2.get(key)) == null || _this$pendingKeys_2$g.set(true);
        // Notify "keys/entries/values" observers
        this.keysAtom_.reportChanged();
    };
    _proto.ownKeys_ = function ownKeys_() {
        this.keysAtom_.reportObserved();
        return ownKeys(this.target_);
    };
    _proto.keys_ = function keys_() {
        // Returns enumerable && own, but unfortunately keysAtom will report on ANY key change.
        // There is no way to distinguish between Object.keys(object) and Reflect.ownKeys(object) - both are handled by ownKeys trap.
        // We can either over-report in Object.keys(object) or under-report in Reflect.ownKeys(object)
        // We choose to over-report in Object.keys(object), because:
        // - typically it's used with simple data objects
        // - when symbolic/non-enumerable keys are relevant Reflect.ownKeys works as expected
        this.keysAtom_.reportObserved();
        return Object.keys(this.target_);
    };
    return ObservableObjectAdministration;
}();
function asObservableObject(target, options) {
    var _options$name;
    if (options && isObservableObject(target)) die("Options can't be provided for already observable objects.");
    if (hasProp(target, $mobx)) {
        if (!(getAdministration(target) instanceof ObservableObjectAdministration)) die("Cannot convert '" + getDebugName(target) + "' into observable object:" + "\nThe target is already observable of different type." + "\nExtending builtins is not supported.");
        return target;
    }
    if (!Object.isExtensible(target)) die("Cannot make the designated object observable; it is not extensible");
    var name = (_options$name = options == null ? void 0 : options.name) != null ? _options$name : (isPlainObject(target) ? "ObservableObject" : target.constructor.name) + "@" + getNextId();
    var adm = new ObservableObjectAdministration(target, new Map(), String(name), getAnnotationFromOptions(options));
    addHiddenProp(target, $mobx, adm);
    return target;
}
var isObservableObjectAdministration = /*#__PURE__*/ createInstanceofPredicate("ObservableObjectAdministration", ObservableObjectAdministration);
function getCachedObservablePropDescriptor(key) {
    return descriptorCache[key] || (descriptorCache[key] = {
        get: function get() {
            return this[$mobx].getObservablePropValue_(key);
        },
        set: function set(value) {
            return this[$mobx].setObservablePropValue_(key, value);
        }
    });
}
function isObservableObject(thing) {
    if (isObject(thing)) return isObservableObjectAdministration(thing[$mobx]);
    return false;
}
function recordAnnotationApplied(adm, annotation, key) {
    var _adm$target_$storedAn;
    adm.appliedAnnotations_[key] = annotation;
    // Remove applied decorator annotation so we don't try to apply it again in subclass constructor
    (_adm$target_$storedAn = adm.target_[storedAnnotationsSymbol]) == null || delete _adm$target_$storedAn[key];
}
function assertAnnotable(adm, annotation, key) {
    // Valid annotation
    if (!isAnnotation(annotation)) die("Cannot annotate '" + adm.name_ + "." + key.toString() + "': Invalid annotation.");
    /*
  // Configurable, not sealed, not frozen
  // Possibly not needed, just a little better error then the one thrown by engine.
  // Cases where this would be useful the most (subclass field initializer) are not interceptable by this.
  if (__DEV__) {
      const configurable = getDescriptor(adm.target_, key)?.configurable
      const frozen = Object.isFrozen(adm.target_)
      const sealed = Object.isSealed(adm.target_)
      if (!configurable || frozen || sealed) {
          const fieldName = `${adm.name_}.${key.toString()}`
          const requestedAnnotationType = annotation.annotationType_
          let error = `Cannot apply '${requestedAnnotationType}' to '${fieldName}':`
          if (frozen) {
              error += `\nObject is frozen.`
          }
          if (sealed) {
              error += `\nObject is sealed.`
          }
          if (!configurable) {
              error += `\nproperty is not configurable.`
              // Mention only if caused by us to avoid confusion
              if (hasProp(adm.appliedAnnotations!, key)) {
                  error += `\nTo prevent accidental re-definition of a field by a subclass, `
                  error += `all annotated fields of non-plain objects (classes) are not configurable.`
              }
          }
          die(error)
      }
  }
  */ // Not annotated
    if (!isOverride(annotation) && hasProp(adm.appliedAnnotations_, key)) {
        var fieldName = adm.name_ + "." + key.toString();
        var currentAnnotationType = adm.appliedAnnotations_[key].annotationType_;
        var requestedAnnotationType = annotation.annotationType_;
        die("Cannot apply '" + requestedAnnotationType + "' to '" + fieldName + "':" + ("\nThe field is already annotated with '" + currentAnnotationType + "'.") + "\nRe-annotating fields is not allowed." + "\nUse 'override' annotation for methods overridden by subclass.");
    }
}
// Bug in safari 9.* (or iOS 9 safari mobile). See #364
var ENTRY_0 = /*#__PURE__*/ createArrayEntryDescriptor(0);
var safariPrototypeSetterInheritanceBug = /*#__PURE__*/ function() {
    var v = false;
    var p = {};
    Object.defineProperty(p, "0", {
        set: function set() {
            v = true;
        }
    });
    /*#__PURE__*/ Object.create(p)["0"] = 1;
    return v === false;
}();
/**
 * This array buffer contains two lists of properties, so that all arrays
 * can recycle their property definitions, which significantly improves performance of creating
 * properties on the fly.
 */ var OBSERVABLE_ARRAY_BUFFER_SIZE = 0;
// Typescript workaround to make sure ObservableArray extends Array
var StubArray = function StubArray() {};
function inherit(ctor, proto) {
    if (Object.setPrototypeOf) Object.setPrototypeOf(ctor.prototype, proto);
    else if (ctor.prototype.__proto__ !== undefined) ctor.prototype.__proto__ = proto;
    else ctor.prototype = proto;
}
inherit(StubArray, Array.prototype);
// Weex proto freeze protection was here,
// but it is unclear why the hack is need as MobX never changed the prototype
// anyway, so removed it in V6
var LegacyObservableArray = /*#__PURE__*/ function(_StubArray, _Symbol$toStringTag, _Symbol$iterator) {
    _inheritsLoose(LegacyObservableArray, _StubArray);
    function LegacyObservableArray(initialValues, enhancer, name, owned) {
        var _this;
        if (name === void 0) name = "ObservableArray@" + getNextId();
        if (owned === void 0) owned = false;
        _this = _StubArray.call(this) || this;
        initObservable(function() {
            var adm = new ObservableArrayAdministration(name, enhancer, owned, true);
            adm.proxy_ = _assertThisInitialized(_this);
            addHiddenFinalProp(_assertThisInitialized(_this), $mobx, adm);
            if (initialValues && initialValues.length) // @ts-ignore
            _this.spliceWithArray(0, 0, initialValues);
            if (safariPrototypeSetterInheritanceBug) // Seems that Safari won't use numeric prototype setter untill any * numeric property is
            // defined on the instance. After that it works fine, even if this property is deleted.
            Object.defineProperty(_assertThisInitialized(_this), "0", ENTRY_0);
        });
        return _this;
    }
    var _proto = LegacyObservableArray.prototype;
    _proto.concat = function concat() {
        this[$mobx].atom_.reportObserved();
        for(var _len = arguments.length, arrays = new Array(_len), _key = 0; _key < _len; _key++)arrays[_key] = arguments[_key];
        return Array.prototype.concat.apply(this.slice(), //@ts-ignore
        arrays.map(function(a) {
            return isObservableArray(a) ? a.slice() : a;
        }));
    };
    _proto[_Symbol$iterator] = function() {
        var self1 = this;
        var nextIndex = 0;
        return makeIterable({
            next: function next() {
                return nextIndex < self1.length ? {
                    value: self1[nextIndex++],
                    done: false
                } : {
                    done: true,
                    value: undefined
                };
            }
        });
    };
    _createClass(LegacyObservableArray, [
        {
            key: "length",
            get: function get() {
                return this[$mobx].getArrayLength_();
            },
            set: function set(newLength) {
                this[$mobx].setArrayLength_(newLength);
            }
        },
        {
            key: _Symbol$toStringTag,
            get: function get() {
                return "Array";
            }
        }
    ]);
    return LegacyObservableArray;
}(StubArray, Symbol.toStringTag, Symbol.iterator);
Object.entries(arrayExtensions).forEach(function(_ref) {
    var prop = _ref[0], fn = _ref[1];
    if (prop !== "concat") addHiddenProp(LegacyObservableArray.prototype, prop, fn);
});
function createArrayEntryDescriptor(index) {
    return {
        enumerable: false,
        configurable: true,
        get: function get() {
            return this[$mobx].get_(index);
        },
        set: function set(value) {
            this[$mobx].set_(index, value);
        }
    };
}
function createArrayBufferItem(index) {
    defineProperty(LegacyObservableArray.prototype, "" + index, createArrayEntryDescriptor(index));
}
function reserveArrayBuffer(max) {
    if (max > OBSERVABLE_ARRAY_BUFFER_SIZE) {
        for(var index = OBSERVABLE_ARRAY_BUFFER_SIZE; index < max + 100; index++)createArrayBufferItem(index);
        OBSERVABLE_ARRAY_BUFFER_SIZE = max;
    }
}
reserveArrayBuffer(1000);
function createLegacyArray(initialValues, enhancer, name) {
    return new LegacyObservableArray(initialValues, enhancer, name);
}
function getAtom(thing, property) {
    if (typeof thing === "object" && thing !== null) {
        if (isObservableArray(thing)) {
            if (property !== undefined) die(23);
            return thing[$mobx].atom_;
        }
        if (isObservableSet(thing)) return thing.atom_;
        if (isObservableMap(thing)) {
            if (property === undefined) return thing.keysAtom_;
            var observable = thing.data_.get(property) || thing.hasMap_.get(property);
            if (!observable) die(25, property, getDebugName(thing));
            return observable;
        }
        if (isObservableObject(thing)) {
            if (!property) return die(26);
            var _observable = thing[$mobx].values_.get(property);
            if (!_observable) die(27, property, getDebugName(thing));
            return _observable;
        }
        if (isAtom(thing) || isComputedValue(thing) || isReaction(thing)) return thing;
    } else if (isFunction(thing)) {
        if (isReaction(thing[$mobx])) // disposer function
        return thing[$mobx];
    }
    die(28);
}
function getAdministration(thing, property) {
    if (!thing) die(29);
    if (property !== undefined) return getAdministration(getAtom(thing, property));
    if (isAtom(thing) || isComputedValue(thing) || isReaction(thing)) return thing;
    if (isObservableMap(thing) || isObservableSet(thing)) return thing;
    if (thing[$mobx]) return thing[$mobx];
    die(24, thing);
}
function getDebugName(thing, property) {
    var named;
    if (property !== undefined) named = getAtom(thing, property);
    else if (isAction(thing)) return thing.name;
    else if (isObservableObject(thing) || isObservableMap(thing) || isObservableSet(thing)) named = getAdministration(thing);
    else // valid for arrays as well
    named = getAtom(thing);
    return named.name_;
}
/**
 * Helper function for initializing observable structures, it applies:
 * 1. allowStateChanges so we don't violate enforceActions.
 * 2. untracked so we don't accidentaly subscribe to anything observable accessed during init in case the observable is created inside derivation.
 * 3. batch to avoid state version updates
 */ function initObservable(cb) {
    var derivation = untrackedStart();
    var allowStateChanges = allowStateChangesStart(true);
    startBatch();
    try {
        return cb();
    } finally{
        endBatch();
        allowStateChangesEnd(allowStateChanges);
        untrackedEnd(derivation);
    }
}
var toString = objectPrototype.toString;
function deepEqual(a, b, depth) {
    if (depth === void 0) depth = -1;
    return eq(a, b, depth);
}
// Copied from https://github.com/jashkenas/underscore/blob/5c237a7c682fb68fd5378203f0bf22dce1624854/underscore.js#L1186-L1289
// Internal recursive comparison function for `isEqual`.
function eq(a, b, depth, aStack, bStack) {
    // Identical objects are equal. `0 === -0`, but they aren't identical.
    // See the [Harmony `egal` proposal](http://wiki.ecmascript.org/doku.php?id=harmony:egal).
    if (a === b) return a !== 0 || 1 / a === 1 / b;
    // `null` or `undefined` only equal to itself (strict comparison).
    if (a == null || b == null) return false;
    // `NaN`s are equivalent, but non-reflexive.
    if (a !== a) return b !== b;
    // Exhaust primitive checks
    var type = typeof a;
    if (type !== "function" && type !== "object" && typeof b != "object") return false;
    // Compare `[[Class]]` names.
    var className = toString.call(a);
    if (className !== toString.call(b)) return false;
    switch(className){
        // Strings, numbers, regular expressions, dates, and booleans are compared by value.
        case "[object RegExp]":
        // RegExps are coerced to strings for comparison (Note: '' + /a/i === '/a/i')
        case "[object String]":
            // Primitives and their corresponding object wrappers are equivalent; thus, `"5"` is
            // equivalent to `new String("5")`.
            return "" + a === "" + b;
        case "[object Number]":
            // `NaN`s are equivalent, but non-reflexive.
            // Object(NaN) is equivalent to NaN.
            if (+a !== +a) return +b !== +b;
            // An `egal` comparison is performed for other numeric values.
            return +a === 0 ? 1 / +a === 1 / b : +a === +b;
        case "[object Date]":
        case "[object Boolean]":
            // Coerce dates and booleans to numeric primitive values. Dates are compared by their
            // millisecond representations. Note that invalid dates with millisecond representations
            // of `NaN` are not equivalent.
            return +a === +b;
        case "[object Symbol]":
            return typeof Symbol !== "undefined" && Symbol.valueOf.call(a) === Symbol.valueOf.call(b);
        case "[object Map]":
        case "[object Set]":
            // Maps and Sets are unwrapped to arrays of entry-pairs, adding an incidental level.
            // Hide this extra level by increasing the depth.
            if (depth >= 0) depth++;
            break;
    }
    // Unwrap any wrapped objects.
    a = unwrap(a);
    b = unwrap(b);
    var areArrays = className === "[object Array]";
    if (!areArrays) {
        if (typeof a != "object" || typeof b != "object") return false;
        // Objects with different constructors are not equivalent, but `Object`s or `Array`s
        // from different frames are.
        var aCtor = a.constructor, bCtor = b.constructor;
        if (aCtor !== bCtor && !(isFunction(aCtor) && aCtor instanceof aCtor && isFunction(bCtor) && bCtor instanceof bCtor) && "constructor" in a && "constructor" in b) return false;
    }
    if (depth === 0) return false;
    else if (depth < 0) depth = -1;
    // Assume equality for cyclic structures. The algorithm for detecting cyclic
    // structures is adapted from ES 5.1 section 15.12.3, abstract operation `JO`.
    // Initializing stack of traversed objects.
    // It's done here since we only need them for objects and arrays comparison.
    aStack = aStack || [];
    bStack = bStack || [];
    var length = aStack.length;
    while(length--){
        // Linear search. Performance is inversely proportional to the number of
        // unique nested structures.
        if (aStack[length] === a) return bStack[length] === b;
    }
    // Add the first object to the stack of traversed objects.
    aStack.push(a);
    bStack.push(b);
    // Recursively compare objects and arrays.
    if (areArrays) {
        // Compare array lengths to determine if a deep comparison is necessary.
        length = a.length;
        if (length !== b.length) return false;
        // Deep compare the contents, ignoring non-numeric properties.
        while(length--){
            if (!eq(a[length], b[length], depth - 1, aStack, bStack)) return false;
        }
    } else {
        // Deep compare objects.
        var keys = Object.keys(a);
        var key;
        length = keys.length;
        // Ensure that both objects contain the same number of properties before comparing deep equality.
        if (Object.keys(b).length !== length) return false;
        while(length--){
            // Deep compare each member
            key = keys[length];
            if (!(hasProp(b, key) && eq(a[key], b[key], depth - 1, aStack, bStack))) return false;
        }
    }
    // Remove the first object from the stack of traversed objects.
    aStack.pop();
    bStack.pop();
    return true;
}
function unwrap(a) {
    if (isObservableArray(a)) return a.slice();
    if (isES6Map(a) || isObservableMap(a)) return Array.from(a.entries());
    if (isES6Set(a) || isObservableSet(a)) return Array.from(a.entries());
    return a;
}
function makeIterable(iterator) {
    iterator[Symbol.iterator] = getSelf;
    return iterator;
}
function getSelf() {
    return this;
}
function isAnnotation(thing) {
    return(// Can be function
    thing instanceof Object && typeof thing.annotationType_ === "string" && isFunction(thing.make_) && isFunction(thing.extend_));
}
/**
 * (c) Michel Weststrate 2015 - 2020
 * MIT Licensed
 *
 * Welcome to the mobx sources! To get a global overview of how MobX internally works,
 * this is a good place to start:
 * https://medium.com/@mweststrate/becoming-fully-reactive-an-in-depth-explanation-of-mobservable-55995262a254#.xvbh6qd74
 *
 * Source folders:
 * ===============
 *
 * - api/     Most of the public static methods exposed by the module can be found here.
 * - core/    Implementation of the MobX algorithm; atoms, derivations, reactions, dependency trees, optimizations. Cool stuff can be found here.
 * - types/   All the magic that is need to have observable objects, arrays and values is in this folder. Including the modifiers like `asFlat`.
 * - utils/   Utility stuff.
 *
 */ [
    "Symbol",
    "Map",
    "Set"
].forEach(function(m) {
    var g = getGlobal();
    if (typeof g[m] === "undefined") die("MobX requires global '" + m + "' to be available or polyfilled");
});
if (typeof __MOBX_DEVTOOLS_GLOBAL_HOOK__ === "object") // See: https://github.com/andykog/mobx-devtools/
__MOBX_DEVTOOLS_GLOBAL_HOOK__.injectMobx({
    spy: spy,
    extras: {
        getDebugName: getDebugName
    },
    $mobx: $mobx
});

});

parcelRegister("i56po", function(module, exports) {

$parcel$export(module.exports, "onSnapshot", () => onSnapshot);
$parcel$export(module.exports, "applySnapshot", () => applySnapshot);
$parcel$export(module.exports, "getParent", () => getParent);
$parcel$export(module.exports, "clone", () => clone);
$parcel$export(module.exports, "destroy", () => destroy);
$parcel$export(module.exports, "getEnv", () => getEnv);
$parcel$export(module.exports, "cast", () => cast);
$parcel$export(module.exports, "addMiddleware", () => addMiddleware);
$parcel$export(module.exports, "flow", () => flow);
$parcel$export(module.exports, "types", () => types);

var $4f362 = parcelRequire("4f362");

var $hPtJY = parcelRequire("hPtJY");
var livelinessChecking = "warn";
/**
 * Defines what MST should do when running into reads / writes to objects that have died.
 * By default it will print a warning.
 * Use the `"error"` option to easy debugging to see where the error was thrown and when the offending read / write took place
 *
 * @param mode `"warn"`, `"error"` or `"ignore"`
 */ function setLivelinessChecking(mode) {
    livelinessChecking = mode;
}
/**
 * Returns the current liveliness checking mode.
 *
 * @returns `"warn"`, `"error"` or `"ignore"`
 */ function getLivelinessChecking() {
    return livelinessChecking;
}
/**
 * @deprecated use setLivelinessChecking instead
 * @hidden
 *
 * Defines what MST should do when running into reads / writes to objects that have died.
 * By default it will print a warning.
 * Use the `"error"` option to easy debugging to see where the error was thrown and when the offending read / write took place
 *
 * @param mode `"warn"`, `"error"` or `"ignore"`
 */ function setLivelynessChecking(mode) {
    setLivelinessChecking(mode);
}
/**
 * @hidden
 */ var Hook;
(function(Hook) {
    Hook["afterCreate"] = "afterCreate";
    Hook["afterAttach"] = "afterAttach";
    Hook["afterCreationFinalization"] = "afterCreationFinalization";
    Hook["beforeDetach"] = "beforeDetach";
    Hook["beforeDestroy"] = "beforeDestroy";
})(Hook || (Hook = {}));
/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise */ var extendStatics = function(d, b) {
    extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    };
    return extendStatics(d, b);
};
function __extends(d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
function __rest(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function __generator(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
function __values(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function __read(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
/** @deprecated */ function __spread() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat(__read(arguments[i]));
    return ar;
}
/**
 * Returns the _actual_ type of the given tree node. (Or throws)
 *
 * @param object
 * @returns
 */ function getType(object) {
    assertIsStateTreeNode(object, 1);
    return getStateTreeNode(object).type;
}
/**
 * Returns the _declared_ type of the given sub property of an object, array or map.
 * In the case of arrays and maps the property name is optional and will be ignored.
 *
 * Example:
 * ```ts
 * const Box = types.model({ x: 0, y: 0 })
 * const box = Box.create()
 *
 * console.log(getChildType(box, "x").name) // 'number'
 * ```
 *
 * @param object
 * @param propertyName
 * @returns
 */ function getChildType(object, propertyName) {
    assertIsStateTreeNode(object, 1);
    return getStateTreeNode(object).getChildType(propertyName);
}
/**
 * Registers a function that will be invoked for each mutation that is applied to the provided model instance, or to any of its children.
 * See [patches](https://github.com/mobxjs/mobx-state-tree#patches) for more details. onPatch events are emitted immediately and will not await the end of a transaction.
 * Patches can be used to deeply observe a model tree.
 *
 * @param target the model instance from which to receive patches
 * @param callback the callback that is invoked for each patch. The reversePatch is a patch that would actually undo the emitted patch
 * @returns function to remove the listener
 */ function onPatch(target, callback) {
    // check all arguments
    assertIsStateTreeNode(target, 1);
    assertIsFunction(callback, 2);
    return getStateTreeNode(target).onPatch(callback);
}
/**
 * Registers a function that is invoked whenever a new snapshot for the given model instance is available.
 * The listener will only be fire at the end of the current MobX (trans)action.
 * See [snapshots](https://github.com/mobxjs/mobx-state-tree#snapshots) for more details.
 *
 * @param target
 * @param callback
 * @returns
 */ function onSnapshot(target, callback) {
    // check all arguments
    assertIsStateTreeNode(target, 1);
    assertIsFunction(callback, 2);
    return getStateTreeNode(target).onSnapshot(callback);
}
/**
 * Applies a JSON-patch to the given model instance or bails out if the patch couldn't be applied
 * See [patches](https://github.com/mobxjs/mobx-state-tree#patches) for more details.
 *
 * Can apply a single past, or an array of patches.
 *
 * @param target
 * @param patch
 * @returns
 */ function applyPatch(target, patch) {
    // check all arguments
    assertIsStateTreeNode(target, 1);
    assertArg(patch, function(p) {
        return typeof p === "object";
    }, "object or array", 2);
    getStateTreeNode(target).applyPatches(asArray(patch));
}
/**
 * Small abstraction around `onPatch` and `applyPatch`, attaches a patch listener to a tree and records all the patches.
 * Returns a recorder object with the following signature:
 *
 * Example:
 * ```ts
 * export interface IPatchRecorder {
 *      // the recorded patches
 *      patches: IJsonPatch[]
 *      // the inverse of the recorded patches
 *      inversePatches: IJsonPatch[]
 *      // true if currently recording
 *      recording: boolean
 *      // stop recording patches
 *      stop(): void
 *      // resume recording patches
 *      resume(): void
 *      // apply all the recorded patches on the given target (the original subject if omitted)
 *      replay(target?: IAnyStateTreeNode): void
 *      // reverse apply the recorded patches on the given target  (the original subject if omitted)
 *      // stops the recorder if not already stopped
 *      undo(): void
 * }
 * ```
 *
 * The optional filter function allows to skip recording certain patches.
 *
 * @param subject
 * @param filter
 * @returns
 */ function recordPatches(subject, filter) {
    // check all arguments
    assertIsStateTreeNode(subject, 1);
    var data = {
        patches: [],
        inversePatches: []
    };
    // we will generate the immutable copy of patches on demand for public consumption
    var publicData = {};
    var disposer;
    var recorder = {
        get recording () {
            return !!disposer;
        },
        get patches () {
            if (!publicData.patches) publicData.patches = data.patches.slice();
            return publicData.patches;
        },
        get reversedInversePatches () {
            if (!publicData.reversedInversePatches) publicData.reversedInversePatches = data.inversePatches.slice().reverse();
            return publicData.reversedInversePatches;
        },
        get inversePatches () {
            if (!publicData.inversePatches) publicData.inversePatches = data.inversePatches.slice();
            return publicData.inversePatches;
        },
        stop: function() {
            if (disposer) {
                disposer();
                disposer = undefined;
            }
        },
        resume: function() {
            if (disposer) return;
            disposer = onPatch(subject, function(patch, inversePatch) {
                // skip patches that are asked to be filtered if there's a filter in place
                if (filter && !filter(patch, inversePatch, getRunningActionContext())) return;
                data.patches.push(patch);
                data.inversePatches.push(inversePatch);
                // mark immutable public patches as dirty
                publicData.patches = undefined;
                publicData.inversePatches = undefined;
                publicData.reversedInversePatches = undefined;
            });
        },
        replay: function(target) {
            applyPatch(target || subject, data.patches);
        },
        undo: function(target) {
            applyPatch(target || subject, data.inversePatches.slice().reverse());
        }
    };
    recorder.resume();
    return recorder;
}
/**
 * The inverse of `unprotect`.
 *
 * @param target
 */ function protect(target) {
    // check all arguments
    assertIsStateTreeNode(target, 1);
    var node = getStateTreeNode(target);
    if (!node.isRoot) throw fail$1("`protect` can only be invoked on root nodes");
    node.isProtectionEnabled = true;
}
/**
 * By default it is not allowed to directly modify a model. Models can only be modified through actions.
 * However, in some cases you don't care about the advantages (like replayability, traceability, etc) this yields.
 * For example because you are building a PoC or don't have any middleware attached to your tree.
 *
 * In that case you can disable this protection by calling `unprotect` on the root of your tree.
 *
 * Example:
 * ```ts
 * const Todo = types.model({
 *     done: false
 * }).actions(self => ({
 *     toggle() {
 *         self.done = !self.done
 *     }
 * }))
 *
 * const todo = Todo.create()
 * todo.done = true // throws!
 * todo.toggle() // OK
 * unprotect(todo)
 * todo.done = false // OK
 * ```
 */ function unprotect(target) {
    // check all arguments
    assertIsStateTreeNode(target, 1);
    var node = getStateTreeNode(target);
    if (!node.isRoot) throw fail$1("`unprotect` can only be invoked on root nodes");
    node.isProtectionEnabled = false;
}
/**
 * Returns true if the object is in protected mode, @see protect
 */ function isProtected(target) {
    return getStateTreeNode(target).isProtected;
}
/**
 * Applies a snapshot to a given model instances. Patch and snapshot listeners will be invoked as usual.
 *
 * @param target
 * @param snapshot
 * @returns
 */ function applySnapshot(target, snapshot) {
    // check all arguments
    assertIsStateTreeNode(target, 1);
    return getStateTreeNode(target).applySnapshot(snapshot);
}
/**
 * Calculates a snapshot from the given model instance. The snapshot will always reflect the latest state but use
 * structural sharing where possible. Doesn't require MobX transactions to be completed.
 *
 * @param target
 * @param applyPostProcess If true (the default) then postProcessSnapshot gets applied.
 * @returns
 */ function getSnapshot(target, applyPostProcess) {
    if (applyPostProcess === void 0) applyPostProcess = true;
    // check all arguments
    assertIsStateTreeNode(target, 1);
    var node = getStateTreeNode(target);
    if (applyPostProcess) return node.snapshot;
    return freeze(node.type.getSnapshot(node, false));
}
/**
 * Given a model instance, returns `true` if the object has a parent, that is, is part of another object, map or array.
 *
 * @param target
 * @param depth How far should we look upward? 1 by default.
 * @returns
 */ function hasParent(target, depth) {
    if (depth === void 0) depth = 1;
    // check all arguments
    assertIsStateTreeNode(target, 1);
    assertIsNumber(depth, 2, 0);
    var parent = getStateTreeNode(target).parent;
    while(parent){
        if (--depth === 0) return true;
        parent = parent.parent;
    }
    return false;
}
/**
 * Returns the immediate parent of this object, or throws.
 *
 * Note that the immediate parent can be either an object, map or array, and
 * doesn't necessarily refer to the parent model.
 *
 * Please note that in child nodes access to the root is only possible
 * once the `afterAttach` hook has fired.
 *
 * @param target
 * @param depth How far should we look upward? 1 by default.
 * @returns
 */ function getParent(target, depth) {
    if (depth === void 0) depth = 1;
    // check all arguments
    assertIsStateTreeNode(target, 1);
    assertIsNumber(depth, 2, 0);
    var d = depth;
    var parent = getStateTreeNode(target).parent;
    while(parent){
        if (--d === 0) return parent.storedValue;
        parent = parent.parent;
    }
    throw fail$1("Failed to find the parent of " + getStateTreeNode(target) + " at depth " + depth);
}
/**
 * Given a model instance, returns `true` if the object has a parent of given type, that is, is part of another object, map or array
 *
 * @param target
 * @param type
 * @returns
 */ function hasParentOfType(target, type) {
    // check all arguments
    assertIsStateTreeNode(target, 1);
    assertIsType(type, 2);
    var parent = getStateTreeNode(target).parent;
    while(parent){
        if (type.is(parent.storedValue)) return true;
        parent = parent.parent;
    }
    return false;
}
/**
 * Returns the target's parent of a given type, or throws.
 *
 * @param target
 * @param type
 * @returns
 */ function getParentOfType(target, type) {
    // check all arguments
    assertIsStateTreeNode(target, 1);
    assertIsType(type, 2);
    var parent = getStateTreeNode(target).parent;
    while(parent){
        if (type.is(parent.storedValue)) return parent.storedValue;
        parent = parent.parent;
    }
    throw fail$1("Failed to find the parent of " + getStateTreeNode(target) + " of a given type");
}
/**
 * Given an object in a model tree, returns the root object of that tree.
 *
 * Please note that in child nodes access to the root is only possible
 * once the `afterAttach` hook has fired.
 *
 * @param target
 * @returns
 */ function getRoot(target) {
    // check all arguments
    assertIsStateTreeNode(target, 1);
    return getStateTreeNode(target).root.storedValue;
}
/**
 * Returns the path of the given object in the model tree
 *
 * @param target
 * @returns
 */ function getPath(target) {
    // check all arguments
    assertIsStateTreeNode(target, 1);
    return getStateTreeNode(target).path;
}
/**
 * Returns the path of the given object as unescaped string array.
 *
 * @param target
 * @returns
 */ function getPathParts(target) {
    // check all arguments
    assertIsStateTreeNode(target, 1);
    return splitJsonPath(getStateTreeNode(target).path);
}
/**
 * Returns true if the given object is the root of a model tree.
 *
 * @param target
 * @returns
 */ function isRoot(target) {
    // check all arguments
    assertIsStateTreeNode(target, 1);
    return getStateTreeNode(target).isRoot;
}
/**
 * Resolves a path relatively to a given object.
 * Returns undefined if no value can be found.
 *
 * @param target
 * @param path escaped json path
 * @returns
 */ function resolvePath(target, path) {
    // check all arguments
    assertIsStateTreeNode(target, 1);
    assertIsString(path, 2);
    var node = resolveNodeByPath(getStateTreeNode(target), path);
    return node ? node.value : undefined;
}
/**
 * Resolves a model instance given a root target, the type and the identifier you are searching for.
 * Returns undefined if no value can be found.
 *
 * @param type
 * @param target
 * @param identifier
 * @returns
 */ function resolveIdentifier(type, target, identifier) {
    // check all arguments
    assertIsType(type, 1);
    assertIsStateTreeNode(target, 2);
    assertIsValidIdentifier(identifier, 3);
    var node = getStateTreeNode(target).root.identifierCache.resolve(type, normalizeIdentifier(identifier));
    return node === null || node === void 0 ? void 0 : node.value;
}
/**
 * Returns the identifier of the target node.
 * This is the *string normalized* identifier, which might not match the type of the identifier attribute
 *
 * @param target
 * @returns
 */ function getIdentifier(target) {
    // check all arguments
    assertIsStateTreeNode(target, 1);
    return getStateTreeNode(target).identifier;
}
/**
 * Tests if a reference is valid (pointing to an existing node and optionally if alive) and returns such reference if the check passes,
 * else it returns undefined.
 *
 * @param getter Function to access the reference.
 * @param checkIfAlive true to also make sure the referenced node is alive (default), false to skip this check.
 * @returns
 */ function tryReference(getter, checkIfAlive) {
    if (checkIfAlive === void 0) checkIfAlive = true;
    try {
        var node = getter();
        if (node === undefined || node === null) return undefined;
        else if (isStateTreeNode(node)) {
            if (!checkIfAlive) return node;
            else return isAlive(node) ? node : undefined;
        } else throw fail$1("The reference to be checked is not one of node, null or undefined");
    } catch (e) {
        if (e instanceof InvalidReferenceError) return undefined;
        throw e;
    }
}
/**
 * Tests if a reference is valid (pointing to an existing node and optionally if alive) and returns if the check passes or not.
 *
 * @param getter Function to access the reference.
 * @param checkIfAlive true to also make sure the referenced node is alive (default), false to skip this check.
 * @returns
 */ function isValidReference(getter, checkIfAlive) {
    if (checkIfAlive === void 0) checkIfAlive = true;
    try {
        var node = getter();
        if (node === undefined || node === null) return false;
        else if (isStateTreeNode(node)) return checkIfAlive ? isAlive(node) : true;
        else throw fail$1("The reference to be checked is not one of node, null or undefined");
    } catch (e) {
        if (e instanceof InvalidReferenceError) return false;
        throw e;
    }
}
/**
 * Try to resolve a given path relative to a given node.
 *
 * @param target
 * @param path
 * @returns
 */ function tryResolve(target, path) {
    // check all arguments
    assertIsStateTreeNode(target, 1);
    assertIsString(path, 2);
    var node = resolveNodeByPath(getStateTreeNode(target), path, false);
    if (node === undefined) return undefined;
    try {
        return node.value;
    } catch (e) {
        // For what ever reason not resolvable (e.g. totally not existing path, or value that cannot be fetched)
        // see test / issue: 'try resolve doesn't work #686'
        return undefined;
    }
}
/**
 * Given two state tree nodes that are part of the same tree,
 * returns the shortest jsonpath needed to navigate from the one to the other
 *
 * @param base
 * @param target
 * @returns
 */ function getRelativePath(base, target) {
    // check all arguments
    assertIsStateTreeNode(base, 1);
    assertIsStateTreeNode(target, 2);
    return getRelativePathBetweenNodes(getStateTreeNode(base), getStateTreeNode(target));
}
/**
 * Returns a deep copy of the given state tree node as new tree.
 * Shorthand for `snapshot(x) = getType(x).create(getSnapshot(x))`
 *
 * _Tip: clone will create a literal copy, including the same identifiers. To modify identifiers etc. during cloning, don't use clone but take a snapshot of the tree, modify it, and create new instance_
 *
 * @param source
 * @param keepEnvironment indicates whether the clone should inherit the same environment (`true`, the default), or not have an environment (`false`). If an object is passed in as second argument, that will act as the environment for the cloned tree.
 * @returns
 */ function clone(source, keepEnvironment) {
    if (keepEnvironment === void 0) keepEnvironment = true;
    // check all arguments
    assertIsStateTreeNode(source, 1);
    var node = getStateTreeNode(source);
    return node.type.create(node.snapshot, keepEnvironment === true ? node.root.environment : keepEnvironment === false ? undefined : keepEnvironment); // it's an object or something else
}
/**
 * Removes a model element from the state tree, and let it live on as a new state tree
 */ function detach(target) {
    // check all arguments
    assertIsStateTreeNode(target, 1);
    getStateTreeNode(target).detach();
    return target;
}
/**
 * Removes a model element from the state tree, and mark it as end-of-life; the element should not be used anymore
 */ function destroy(target) {
    // check all arguments
    assertIsStateTreeNode(target, 1);
    var node = getStateTreeNode(target);
    if (node.isRoot) node.die();
    else node.parent.removeChild(node.subpath);
}
/**
 * Returns true if the given state tree node is not killed yet.
 * This means that the node is still a part of a tree, and that `destroy`
 * has not been called. If a node is not alive anymore, the only thing one can do with it
 * is requesting it's last path and snapshot
 *
 * @param target
 * @returns
 */ function isAlive(target) {
    // check all arguments
    assertIsStateTreeNode(target, 1);
    return getStateTreeNode(target).observableIsAlive;
}
/**
 * Use this utility to register a function that should be called whenever the
 * targeted state tree node is destroyed. This is a useful alternative to managing
 * cleanup methods yourself using the `beforeDestroy` hook.
 *
 * This methods returns the same disposer that was passed as argument.
 *
 * Example:
 * ```ts
 * const Todo = types.model({
 *   title: types.string
 * }).actions(self => ({
 *   afterCreate() {
 *     const autoSaveDisposer = reaction(
 *       () => getSnapshot(self),
 *       snapshot => sendSnapshotToServerSomehow(snapshot)
 *     )
 *     // stop sending updates to server if this
 *     // instance is destroyed
 *     addDisposer(self, autoSaveDisposer)
 *   }
 * }))
 * ```
 *
 * @param target
 * @param disposer
 * @returns The same disposer that was passed as argument
 */ function addDisposer(target, disposer) {
    // check all arguments
    assertIsStateTreeNode(target, 1);
    assertIsFunction(disposer, 2);
    var node = getStateTreeNode(target);
    node.addDisposer(disposer);
    return disposer;
}
/**
 * Returns the environment of the current state tree. For more info on environments,
 * see [Dependency injection](https://github.com/mobxjs/mobx-state-tree#dependency-injection)
 *
 * Please note that in child nodes access to the root is only possible
 * once the `afterAttach` hook has fired
 *
 * Returns an empty environment if the tree wasn't initialized with an environment
 *
 * @param target
 * @returns
 */ function getEnv(target) {
    // check all arguments
    assertIsStateTreeNode(target, 1);
    var node = getStateTreeNode(target);
    var env = node.root.environment;
    if (!env) return EMPTY_OBJECT;
    return env;
}
/**
 * Performs a depth first walk through a tree.
 */ function walk(target, processor) {
    // check all arguments
    assertIsStateTreeNode(target, 1);
    assertIsFunction(processor, 2);
    var node = getStateTreeNode(target);
    // tslint:disable-next-line:no_unused-variable
    node.getChildren().forEach(function(child) {
        if (isStateTreeNode(child.storedValue)) walk(child.storedValue, processor);
    });
    processor(node.storedValue);
}
/**
 * Returns a reflection of the model type properties and name for either a model type or model node.
 *
 * @param typeOrNode
 * @returns
 */ function getPropertyMembers(typeOrNode) {
    var type;
    if (isStateTreeNode(typeOrNode)) type = getType(typeOrNode);
    else type = typeOrNode;
    assertArg(type, function(t) {
        return isModelType(t);
    }, "model type or model instance", 1);
    return {
        name: type.name,
        properties: __assign({}, type.properties)
    };
}
/**
 * Returns a reflection of the model node, including name, properties, views, volatile state,
 * and actions. `flowActions` is also provided as a separate array of names for any action that
 * came from a flow generator as well.
 *
 * In the case where a model has two actions: `doSomething` and `doSomethingWithFlow`, where
 * `doSomethingWithFlow` is a flow generator, the `actions` array will contain both actions,
 * i.e. ["doSomething", "doSomethingWithFlow"], and the `flowActions` array will contain only
 * the flow action, i.e. ["doSomethingWithFlow"].
 *
 * @param target
 * @returns
 */ function getMembers(target) {
    var type = getStateTreeNode(target).type;
    var reflected = __assign(__assign({}, getPropertyMembers(type)), {
        actions: [],
        volatile: [],
        views: [],
        flowActions: []
    });
    var props = Object.getOwnPropertyNames(target);
    props.forEach(function(key) {
        if (key in reflected.properties) return;
        var descriptor = Object.getOwnPropertyDescriptor(target, key);
        if (descriptor.get) {
            if ((0, $4f362.isComputedProp)(target, key)) reflected.views.push(key);
            else reflected.volatile.push(key);
            return;
        }
        if (descriptor.value._isMSTAction === true) reflected.actions.push(key);
        if (descriptor.value._isFlowAction === true) reflected.flowActions.push(key);
        else if ((0, $4f362.isObservableProp)(target, key)) reflected.volatile.push(key);
        else reflected.views.push(key);
    });
    return reflected;
}
/**
 * Casts a node snapshot or instance type to an instance type so it can be assigned to a type instance.
 * Note that this is just a cast for the type system, this is, it won't actually convert a snapshot to an instance,
 * but just fool typescript into thinking so.
 * Either way, casting when outside an assignation operation won't compile.
 *
 * Example:
 * ```ts
 * const ModelA = types.model({
 *   n: types.number
 * }).actions(self => ({
 *   setN(aNumber: number) {
 *     self.n = aNumber
 *   }
 * }))
 *
 * const ModelB = types.model({
 *   innerModel: ModelA
 * }).actions(self => ({
 *   someAction() {
 *     // this will allow the compiler to assign a snapshot to the property
 *     self.innerModel = cast({ a: 5 })
 *   }
 * }))
 * ```
 *
 * @param snapshotOrInstance Snapshot or instance
 * @returns The same object cast as an instance
 */ function cast(snapshotOrInstance) {
    return snapshotOrInstance;
}
/**
 * Casts a node instance type to a snapshot type so it can be assigned to a type snapshot (e.g. to be used inside a create call).
 * Note that this is just a cast for the type system, this is, it won't actually convert an instance to a snapshot,
 * but just fool typescript into thinking so.
 *
 * Example:
 * ```ts
 * const ModelA = types.model({
 *   n: types.number
 * }).actions(self => ({
 *   setN(aNumber: number) {
 *     self.n = aNumber
 *   }
 * }))
 *
 * const ModelB = types.model({
 *   innerModel: ModelA
 * })
 *
 * const a = ModelA.create({ n: 5 });
 * // this will allow the compiler to use a model as if it were a snapshot
 * const b = ModelB.create({ innerModel: castToSnapshot(a)})
 * ```
 *
 * @param snapshotOrInstance Snapshot or instance
 * @returns The same object cast as an input (creation) snapshot
 */ function castToSnapshot(snapshotOrInstance) {
    return snapshotOrInstance;
}
/**
 * Casts a node instance type to a reference snapshot type so it can be assigned to a reference snapshot (e.g. to be used inside a create call).
 * Note that this is just a cast for the type system, this is, it won't actually convert an instance to a reference snapshot,
 * but just fool typescript into thinking so.
 *
 * Example:
 * ```ts
 * const ModelA = types.model({
 *   id: types.identifier,
 *   n: types.number
 * }).actions(self => ({
 *   setN(aNumber: number) {
 *     self.n = aNumber
 *   }
 * }))
 *
 * const ModelB = types.model({
 *   refA: types.reference(ModelA)
 * })
 *
 * const a = ModelA.create({ id: 'someId', n: 5 });
 * // this will allow the compiler to use a model as if it were a reference snapshot
 * const b = ModelB.create({ refA: castToReferenceSnapshot(a)})
 * ```
 *
 * @param instance Instance
 * @returns The same object cast as a reference snapshot (string or number)
 */ function castToReferenceSnapshot(instance) {
    return instance;
}
/**
 * Returns the unique node id (not to be confused with the instance identifier) for a
 * given instance.
 * This id is a number that is unique for each instance.
 *
 * @export
 * @param target
 * @returns
 */ function getNodeId(target) {
    assertIsStateTreeNode(target, 1);
    return getStateTreeNode(target).nodeId;
}
/**
 * @internal
 * @hidden
 */ var BaseNode = /** @class */ function() {
    function BaseNode(type, parent, subpath, environment) {
        Object.defineProperty(this, "type", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: type
        });
        Object.defineProperty(this, "environment", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: environment
        });
        Object.defineProperty(this, "_escapedSubpath", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "_subpath", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "_subpathUponDeath", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "_pathUponDeath", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "storedValue", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        }); // usually the same type as the value, but not always (such as with references)
        Object.defineProperty(this, "aliveAtom", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "_state", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: NodeLifeCycle.INITIALIZING
        });
        Object.defineProperty(this, "_hookSubscribers", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "_parent", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "pathAtom", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        this.environment = environment;
        this.baseSetParent(parent, subpath);
    }
    Object.defineProperty(BaseNode.prototype, "subpath", {
        get: function() {
            return this._subpath;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BaseNode.prototype, "subpathUponDeath", {
        get: function() {
            return this._subpathUponDeath;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BaseNode.prototype, "pathUponDeath", {
        get: function() {
            return this._pathUponDeath;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BaseNode.prototype, "value", {
        get: function() {
            return this.type.getValue(this);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BaseNode.prototype, "state", {
        get: function() {
            return this._state;
        },
        set: function(val) {
            var wasAlive = this.isAlive;
            this._state = val;
            var isAlive = this.isAlive;
            if (this.aliveAtom && wasAlive !== isAlive) this.aliveAtom.reportChanged();
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BaseNode.prototype, "fireInternalHook", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function(name) {
            if (this._hookSubscribers) this._hookSubscribers.emit(name, this, name);
        }
    });
    Object.defineProperty(BaseNode.prototype, "registerHook", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function(hook, hookHandler) {
            if (!this._hookSubscribers) this._hookSubscribers = new EventHandlers();
            return this._hookSubscribers.register(hook, hookHandler);
        }
    });
    Object.defineProperty(BaseNode.prototype, "parent", {
        get: function() {
            return this._parent;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BaseNode.prototype, "getReconciliationType", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function() {
            return this.type;
        }
    });
    Object.defineProperty(BaseNode.prototype, "baseSetParent", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function(parent, subpath) {
            this._parent = parent;
            this._subpath = subpath;
            this._escapedSubpath = undefined; // regenerate when needed
            if (this.pathAtom) this.pathAtom.reportChanged();
        }
    });
    Object.defineProperty(BaseNode.prototype, "path", {
        /*
         * Returns (escaped) path representation as string
         */ get: function() {
            return this.getEscapedPath(true);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BaseNode.prototype, "getEscapedPath", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function(reportObserved) {
            if (reportObserved) {
                if (!this.pathAtom) this.pathAtom = (0, $4f362.createAtom)("path");
                this.pathAtom.reportObserved();
            }
            if (!this.parent) return "";
            // regenerate escaped subpath if needed
            if (this._escapedSubpath === undefined) this._escapedSubpath = !this._subpath ? "" : escapeJsonPath(this._subpath);
            return this.parent.getEscapedPath(reportObserved) + "/" + this._escapedSubpath;
        }
    });
    Object.defineProperty(BaseNode.prototype, "isRoot", {
        get: function() {
            return this.parent === null;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BaseNode.prototype, "isAlive", {
        get: function() {
            return this.state !== NodeLifeCycle.DEAD;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BaseNode.prototype, "isDetaching", {
        get: function() {
            return this.state === NodeLifeCycle.DETACHING;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BaseNode.prototype, "observableIsAlive", {
        get: function() {
            if (!this.aliveAtom) this.aliveAtom = (0, $4f362.createAtom)("alive");
            this.aliveAtom.reportObserved();
            return this.isAlive;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BaseNode.prototype, "baseFinalizeCreation", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function(whenFinalized) {
            if (devMode()) {
                if (!this.isAlive) // istanbul ignore next
                throw fail("assertion failed: cannot finalize the creation of a node that is already dead");
            }
            // goal: afterCreate hooks runs depth-first. After attach runs parent first, so on afterAttach the parent has completed already
            if (this.state === NodeLifeCycle.CREATED) {
                if (this.parent) {
                    if (this.parent.state !== NodeLifeCycle.FINALIZED) // parent not ready yet, postpone
                    return;
                    this.fireHook(Hook.afterAttach);
                }
                this.state = NodeLifeCycle.FINALIZED;
                if (whenFinalized) whenFinalized();
            }
        }
    });
    Object.defineProperty(BaseNode.prototype, "baseFinalizeDeath", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function() {
            if (this._hookSubscribers) this._hookSubscribers.clearAll();
            this._subpathUponDeath = this._subpath;
            this._pathUponDeath = this.getEscapedPath(false);
            this.baseSetParent(null, "");
            this.state = NodeLifeCycle.DEAD;
        }
    });
    Object.defineProperty(BaseNode.prototype, "baseAboutToDie", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function() {
            this.fireHook(Hook.beforeDestroy);
        }
    });
    return BaseNode;
}();
/**
 * @internal
 * @hidden
 */ var ScalarNode = /** @class */ function(_super) {
    __extends(ScalarNode, _super);
    function ScalarNode(simpleType, parent, subpath, environment, initialSnapshot) {
        var _this = _super.call(this, simpleType, parent, subpath, environment) || this;
        try {
            _this.storedValue = simpleType.createNewInstance(initialSnapshot);
        } catch (e) {
            // short-cut to die the instance, to avoid the snapshot computed starting to throw...
            _this.state = NodeLifeCycle.DEAD;
            throw e;
        }
        _this.state = NodeLifeCycle.CREATED;
        // for scalar nodes there's no point in firing this event since it would fire on the constructor, before
        // anybody can actually register for/listen to it
        // this.fireHook(Hook.AfterCreate)
        _this.finalizeCreation();
        return _this;
    }
    Object.defineProperty(ScalarNode.prototype, "root", {
        get: function() {
            // future optimization: store root ref in the node and maintain it
            if (!this.parent) throw fail$1("This scalar node is not part of a tree");
            return this.parent.root;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ScalarNode.prototype, "setParent", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function(newParent, subpath) {
            var parentChanged = this.parent !== newParent;
            var subpathChanged = this.subpath !== subpath;
            if (!parentChanged && !subpathChanged) return;
            if (devMode()) {
                if (!subpath) // istanbul ignore next
                throw fail$1("assertion failed: subpath expected");
                if (!newParent) // istanbul ignore next
                throw fail$1("assertion failed: parent expected");
                if (parentChanged) // istanbul ignore next
                throw fail$1("assertion failed: scalar nodes cannot change their parent");
            }
            this.environment = undefined; // use parent's
            this.baseSetParent(this.parent, subpath);
        }
    });
    Object.defineProperty(ScalarNode.prototype, "snapshot", {
        get: function() {
            return freeze(this.getSnapshot());
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ScalarNode.prototype, "getSnapshot", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function() {
            return this.type.getSnapshot(this);
        }
    });
    Object.defineProperty(ScalarNode.prototype, "toString", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function() {
            var path = (this.isAlive ? this.path : this.pathUponDeath) || "<root>";
            return this.type.name + "@" + path + (this.isAlive ? "" : " [dead]");
        }
    });
    Object.defineProperty(ScalarNode.prototype, "die", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function() {
            if (!this.isAlive || this.state === NodeLifeCycle.DETACHING) return;
            this.aboutToDie();
            this.finalizeDeath();
        }
    });
    Object.defineProperty(ScalarNode.prototype, "finalizeCreation", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function() {
            this.baseFinalizeCreation();
        }
    });
    Object.defineProperty(ScalarNode.prototype, "aboutToDie", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function() {
            this.baseAboutToDie();
        }
    });
    Object.defineProperty(ScalarNode.prototype, "finalizeDeath", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function() {
            this.baseFinalizeDeath();
        }
    });
    Object.defineProperty(ScalarNode.prototype, "fireHook", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function(name) {
            this.fireInternalHook(name);
        }
    });
    return ScalarNode;
}(BaseNode);
ScalarNode.prototype.die = (0, $4f362.action)(ScalarNode.prototype.die);
var nextNodeId = 1;
var snapshotReactionOptions = {
    onError: function(e) {
        throw e;
    }
};
/**
 * @internal
 * @hidden
 */ var ObjectNode = /** @class */ function(_super) {
    __extends(ObjectNode, _super);
    function ObjectNode(complexType, parent, subpath, environment, initialValue) {
        var _this = _super.call(this, complexType, parent, subpath, environment) || this;
        Object.defineProperty(_this, "nodeId", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: ++nextNodeId
        });
        Object.defineProperty(_this, "identifierAttribute", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(_this, "identifier", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        }); // Identifier is always normalized to string, even if the identifier property isn't
        Object.defineProperty(_this, "unnormalizedIdentifier", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(_this, "identifierCache", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(_this, "isProtectionEnabled", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: true
        });
        Object.defineProperty(_this, "middlewares", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(_this, "hasSnapshotPostProcessor", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: false
        });
        Object.defineProperty(_this, "_applyPatches", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(_this, "_applySnapshot", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(_this, "_autoUnbox", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: true
        }); // unboxing is disabled when reading child nodes
        Object.defineProperty(_this, "_isRunningAction", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: false
        }); // only relevant for root
        Object.defineProperty(_this, "_hasSnapshotReaction", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: false
        });
        Object.defineProperty(_this, "_observableInstanceState", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: 0 /* UNINITIALIZED */ 
        });
        Object.defineProperty(_this, "_childNodes", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(_this, "_initialSnapshot", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(_this, "_cachedInitialSnapshot", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(_this, "_cachedInitialSnapshotCreated", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: false
        });
        Object.defineProperty(_this, "_snapshotComputed", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(_this, "_snapshotUponDeath", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        // #region internal event handling
        Object.defineProperty(_this, "_internalEvents", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        _this._snapshotComputed = (0, $4f362.computed)(function() {
            return freeze(_this.getSnapshot());
        });
        _this.unbox = _this.unbox.bind(_this);
        _this._initialSnapshot = freeze(initialValue);
        _this.identifierAttribute = complexType.identifierAttribute;
        if (!parent) _this.identifierCache = new IdentifierCache();
        _this._childNodes = complexType.initializeChildNodes(_this, _this._initialSnapshot);
        // identifier can not be changed during lifecycle of a node
        // so we safely can read it from initial snapshot
        _this.identifier = null;
        _this.unnormalizedIdentifier = null;
        if (_this.identifierAttribute && _this._initialSnapshot) {
            var id = _this._initialSnapshot[_this.identifierAttribute];
            if (id === undefined) {
                // try with the actual node if not (for optional identifiers)
                var childNode = _this._childNodes[_this.identifierAttribute];
                if (childNode) id = childNode.value;
            }
            if (typeof id !== "string" && typeof id !== "number") throw fail$1("Instance identifier '" + _this.identifierAttribute + "' for type '" + _this.type.name + "' must be a string or a number");
            // normalize internal identifier to string
            _this.identifier = normalizeIdentifier(id);
            _this.unnormalizedIdentifier = id;
        }
        if (!parent) _this.identifierCache.addNodeToCache(_this);
        else parent.root.identifierCache.addNodeToCache(_this);
        return _this;
    }
    Object.defineProperty(ObjectNode.prototype, "applyPatches", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function(patches) {
            this.createObservableInstanceIfNeeded();
            this._applyPatches(patches);
        }
    });
    Object.defineProperty(ObjectNode.prototype, "applySnapshot", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function(snapshot) {
            this.createObservableInstanceIfNeeded();
            this._applySnapshot(snapshot);
        }
    });
    Object.defineProperty(ObjectNode.prototype, "createObservableInstanceIfNeeded", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function(fireHooks) {
            if (fireHooks === void 0) fireHooks = true;
            if (this._observableInstanceState === 0 /* UNINITIALIZED */ ) this.createObservableInstance(fireHooks);
        }
    });
    Object.defineProperty(ObjectNode.prototype, "createObservableInstance", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function(fireHooks) {
            var e_1, _a, e_2, _b;
            if (fireHooks === void 0) fireHooks = true;
            if (devMode()) {
                if (this.state !== NodeLifeCycle.INITIALIZING) // istanbul ignore next
                throw fail$1("assertion failed: the creation of the observable instance must be done on the initializing phase");
            }
            this._observableInstanceState = 1 /* CREATING */ ;
            // make sure the parent chain is created as well
            // array with parent chain from parent to child
            var parentChain = [];
            var parent = this.parent;
            // for performance reasons we never go back further than the most direct
            // uninitialized parent
            // this is done to avoid traversing the whole tree to the root when using
            // the same reference again
            while(parent && parent._observableInstanceState === 0 /* UNINITIALIZED */ ){
                parentChain.unshift(parent);
                parent = parent.parent;
            }
            try {
                // initialize the uninitialized parent chain from parent to child
                for(var parentChain_1 = __values(parentChain), parentChain_1_1 = parentChain_1.next(); !parentChain_1_1.done; parentChain_1_1 = parentChain_1.next()){
                    var p = parentChain_1_1.value;
                    // delay firing hooks until after all parents have been created
                    p.createObservableInstanceIfNeeded(false);
                }
            } catch (e_1_1) {
                e_1 = {
                    error: e_1_1
                };
            } finally{
                try {
                    if (parentChain_1_1 && !parentChain_1_1.done && (_a = parentChain_1.return)) _a.call(parentChain_1);
                } finally{
                    if (e_1) throw e_1.error;
                }
            }
            var type = this.type;
            try {
                this.storedValue = type.createNewInstance(this._childNodes);
                this.preboot();
                this._isRunningAction = true;
                type.finalizeNewInstance(this, this.storedValue);
            } catch (e) {
                // short-cut to die the instance, to avoid the snapshot computed starting to throw...
                this.state = NodeLifeCycle.DEAD;
                throw e;
            } finally{
                this._isRunningAction = false;
            }
            this._observableInstanceState = 2 /* CREATED */ ;
            this._snapshotComputed.trackAndCompute();
            if (this.isRoot) this._addSnapshotReaction();
            this._childNodes = EMPTY_OBJECT;
            this.state = NodeLifeCycle.CREATED;
            if (fireHooks) {
                this.fireHook(Hook.afterCreate);
                // Note that the parent might not be finalized at this point
                // so afterAttach won't be called until later in that case
                this.finalizeCreation();
                try {
                    // fire the hooks of the parents that we created
                    for(var _c = __values(parentChain.reverse()), _d = _c.next(); !_d.done; _d = _c.next()){
                        var p = _d.value;
                        p.fireHook(Hook.afterCreate);
                        // This will call afterAttach on the child if necessary
                        p.finalizeCreation();
                    }
                } catch (e_2_1) {
                    e_2 = {
                        error: e_2_1
                    };
                } finally{
                    try {
                        if (_d && !_d.done && (_b = _c.return)) _b.call(_c);
                    } finally{
                        if (e_2) throw e_2.error;
                    }
                }
            }
        }
    });
    Object.defineProperty(ObjectNode.prototype, "root", {
        get: function() {
            var parent = this.parent;
            return parent ? parent.root : this;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ObjectNode.prototype, "clearParent", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function() {
            if (!this.parent) return;
            // detach if attached
            this.fireHook(Hook.beforeDetach);
            var previousState = this.state;
            this.state = NodeLifeCycle.DETACHING;
            var root = this.root;
            var newEnv = root.environment;
            var newIdCache = root.identifierCache.splitCache(this);
            try {
                this.parent.removeChild(this.subpath);
                this.baseSetParent(null, "");
                this.environment = newEnv;
                this.identifierCache = newIdCache;
            } finally{
                this.state = previousState;
            }
        }
    });
    Object.defineProperty(ObjectNode.prototype, "setParent", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function(newParent, subpath) {
            var parentChanged = newParent !== this.parent;
            var subpathChanged = subpath !== this.subpath;
            if (!parentChanged && !subpathChanged) return;
            if (devMode()) {
                if (!subpath) // istanbul ignore next
                throw fail$1("assertion failed: subpath expected");
                if (!newParent) // istanbul ignore next
                throw fail$1("assertion failed: new parent expected");
                if (this.parent && parentChanged) throw fail$1("A node cannot exists twice in the state tree. Failed to add " + this + " to path '" + newParent.path + "/" + subpath + "'.");
                if (!this.parent && newParent.root === this) throw fail$1("A state tree is not allowed to contain itself. Cannot assign " + this + " to path '" + newParent.path + "/" + subpath + "'");
                if (!this.parent && !!this.environment && this.environment !== newParent.root.environment) throw fail$1("A state tree cannot be made part of another state tree as long as their environments are different.");
            }
            if (parentChanged) {
                // attach to new parent
                this.environment = undefined; // will use root's
                newParent.root.identifierCache.mergeCache(this);
                this.baseSetParent(newParent, subpath);
                this.fireHook(Hook.afterAttach);
            } else if (subpathChanged) // moving to a new subpath on the same parent
            this.baseSetParent(this.parent, subpath);
        }
    });
    Object.defineProperty(ObjectNode.prototype, "fireHook", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function(name) {
            var _this = this;
            this.fireInternalHook(name);
            var fn = this.storedValue && typeof this.storedValue === "object" && this.storedValue[name];
            if (typeof fn === "function") {
                // we check for it to allow old mobx peer dependencies that don't have the method to work (even when still bugged)
                if (0, $4f362._allowStateChangesInsideComputed) (0, $4f362._allowStateChangesInsideComputed)(function() {
                    fn.apply(_this.storedValue);
                });
                else fn.apply(this.storedValue);
            }
        }
    });
    Object.defineProperty(ObjectNode.prototype, "snapshot", {
        // advantage of using computed for a snapshot is that nicely respects transactions etc.
        get: function() {
            if (this.hasSnapshotPostProcessor) this.createObservableInstanceIfNeeded();
            return this._snapshotComputed.get();
        },
        enumerable: false,
        configurable: true
    });
    // NOTE: we use this method to get snapshot without creating @computed overhead
    Object.defineProperty(ObjectNode.prototype, "getSnapshot", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function() {
            if (!this.isAlive) return this._snapshotUponDeath;
            return this._observableInstanceState === 2 /* CREATED */  ? this._getActualSnapshot() : this._getCachedInitialSnapshot();
        }
    });
    Object.defineProperty(ObjectNode.prototype, "_getActualSnapshot", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function() {
            return this.type.getSnapshot(this);
        }
    });
    Object.defineProperty(ObjectNode.prototype, "_getCachedInitialSnapshot", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function() {
            if (!this._cachedInitialSnapshotCreated) {
                var type = this.type;
                var childNodes = this._childNodes;
                var snapshot = this._initialSnapshot;
                this._cachedInitialSnapshot = type.processInitialSnapshot(childNodes, snapshot);
                this._cachedInitialSnapshotCreated = true;
            }
            return this._cachedInitialSnapshot;
        }
    });
    Object.defineProperty(ObjectNode.prototype, "isRunningAction", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function() {
            if (this._isRunningAction) return true;
            if (this.isRoot) return false;
            return this.parent.isRunningAction();
        }
    });
    Object.defineProperty(ObjectNode.prototype, "assertAlive", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function(context) {
            var livelinessChecking = getLivelinessChecking();
            if (!this.isAlive && livelinessChecking !== "ignore") {
                var error = this._getAssertAliveError(context);
                switch(livelinessChecking){
                    case "error":
                        throw fail$1(error);
                    case "warn":
                        warnError(error);
                }
            }
        }
    });
    Object.defineProperty(ObjectNode.prototype, "_getAssertAliveError", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function(context) {
            var escapedPath = this.getEscapedPath(false) || this.pathUponDeath || "";
            var subpath = context.subpath && escapeJsonPath(context.subpath) || "";
            var actionContext = context.actionContext || getCurrentActionContext();
            // try to use a real action context if possible since it includes the action name
            if (actionContext && actionContext.type !== "action" && actionContext.parentActionEvent) actionContext = actionContext.parentActionEvent;
            var actionFullPath = "";
            if (actionContext && actionContext.name != null) {
                // try to use the context, and if it not available use the node one
                var actionPath = actionContext && actionContext.context && getPath(actionContext.context) || escapedPath;
                actionFullPath = actionPath + "." + actionContext.name + "()";
            }
            return "You are trying to read or write to an object that is no longer part of a state tree. (Object type: '" + this.type.name + "', Path upon death: '" + escapedPath + "', Subpath: '" + subpath + "', Action: '" + actionFullPath + "'). Either detach nodes first, or don't use objects after removing / replacing them in the tree.";
        }
    });
    Object.defineProperty(ObjectNode.prototype, "getChildNode", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function(subpath) {
            this.assertAlive({
                subpath: subpath
            });
            this._autoUnbox = false;
            try {
                return this._observableInstanceState === 2 /* CREATED */  ? this.type.getChildNode(this, subpath) : this._childNodes[subpath];
            } finally{
                this._autoUnbox = true;
            }
        }
    });
    Object.defineProperty(ObjectNode.prototype, "getChildren", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function() {
            this.assertAlive(EMPTY_OBJECT);
            this._autoUnbox = false;
            try {
                return this._observableInstanceState === 2 /* CREATED */  ? this.type.getChildren(this) : convertChildNodesToArray(this._childNodes);
            } finally{
                this._autoUnbox = true;
            }
        }
    });
    Object.defineProperty(ObjectNode.prototype, "getChildType", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function(propertyName) {
            return this.type.getChildType(propertyName);
        }
    });
    Object.defineProperty(ObjectNode.prototype, "isProtected", {
        get: function() {
            return this.root.isProtectionEnabled;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ObjectNode.prototype, "assertWritable", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function(context) {
            this.assertAlive(context);
            if (!this.isRunningAction() && this.isProtected) throw fail$1("Cannot modify '" + this + "', the object is protected and can only be modified by using an action.");
        }
    });
    Object.defineProperty(ObjectNode.prototype, "removeChild", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function(subpath) {
            this.type.removeChild(this, subpath);
        }
    });
    // bound on the constructor
    Object.defineProperty(ObjectNode.prototype, "unbox", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function(childNode) {
            if (!childNode) return childNode;
            this.assertAlive({
                subpath: childNode.subpath || childNode.subpathUponDeath
            });
            return this._autoUnbox ? childNode.value : childNode;
        }
    });
    Object.defineProperty(ObjectNode.prototype, "toString", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function() {
            var path = (this.isAlive ? this.path : this.pathUponDeath) || "<root>";
            var identifier = this.identifier ? "(id: " + this.identifier + ")" : "";
            return this.type.name + "@" + path + identifier + (this.isAlive ? "" : " [dead]");
        }
    });
    Object.defineProperty(ObjectNode.prototype, "finalizeCreation", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function() {
            var _this = this;
            this.baseFinalizeCreation(function() {
                var e_3, _a;
                try {
                    for(var _b = __values(_this.getChildren()), _c = _b.next(); !_c.done; _c = _b.next()){
                        var child = _c.value;
                        child.finalizeCreation();
                    }
                } catch (e_3_1) {
                    e_3 = {
                        error: e_3_1
                    };
                } finally{
                    try {
                        if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                    } finally{
                        if (e_3) throw e_3.error;
                    }
                }
                _this.fireInternalHook(Hook.afterCreationFinalization);
            });
        }
    });
    Object.defineProperty(ObjectNode.prototype, "detach", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function() {
            if (!this.isAlive) throw fail$1("Error while detaching, node is not alive.");
            this.clearParent();
        }
    });
    Object.defineProperty(ObjectNode.prototype, "preboot", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function() {
            var self = this;
            this._applyPatches = createActionInvoker(this.storedValue, "@APPLY_PATCHES", function(patches) {
                patches.forEach(function(patch) {
                    if (!patch.path) {
                        self.type.applySnapshot(self, patch.value);
                        return;
                    }
                    var parts = splitJsonPath(patch.path);
                    var node = resolveNodeByPathParts(self, parts.slice(0, -1));
                    node.applyPatchLocally(parts[parts.length - 1], patch);
                });
            });
            this._applySnapshot = createActionInvoker(this.storedValue, "@APPLY_SNAPSHOT", function(snapshot) {
                // if the snapshot is the same as the current one, avoid performing a reconcile
                if (snapshot === self.snapshot) return;
                // else, apply it by calling the type logic
                return self.type.applySnapshot(self, snapshot);
            });
            addHiddenFinalProp(this.storedValue, "$treenode", this);
            addHiddenFinalProp(this.storedValue, "toJSON", toJSON);
        }
    });
    Object.defineProperty(ObjectNode.prototype, "die", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function() {
            if (!this.isAlive || this.state === NodeLifeCycle.DETACHING) return;
            this.aboutToDie();
            this.finalizeDeath();
        }
    });
    Object.defineProperty(ObjectNode.prototype, "aboutToDie", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function() {
            if (this._observableInstanceState === 0 /* UNINITIALIZED */ ) return;
            this.getChildren().forEach(function(node) {
                node.aboutToDie();
            });
            // beforeDestroy should run before the disposers since else we could end up in a situation where
            // a disposer added with addDisposer at this stage (beforeDestroy) is actually never released
            this.baseAboutToDie();
            this._internalEventsEmit("dispose" /* Dispose */ );
            this._internalEventsClear("dispose" /* Dispose */ );
        }
    });
    Object.defineProperty(ObjectNode.prototype, "finalizeDeath", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function() {
            // invariant: not called directly but from "die"
            this.getChildren().forEach(function(node) {
                node.finalizeDeath();
            });
            this.root.identifierCache.notifyDied(this);
            // "kill" the computed prop and just store the last snapshot
            var snapshot = this.snapshot;
            this._snapshotUponDeath = snapshot;
            this._internalEventsClearAll();
            this.baseFinalizeDeath();
        }
    });
    Object.defineProperty(ObjectNode.prototype, "onSnapshot", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function(onChange) {
            this._addSnapshotReaction();
            return this._internalEventsRegister("snapshot" /* Snapshot */ , onChange);
        }
    });
    Object.defineProperty(ObjectNode.prototype, "emitSnapshot", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function(snapshot) {
            this._internalEventsEmit("snapshot" /* Snapshot */ , snapshot);
        }
    });
    Object.defineProperty(ObjectNode.prototype, "onPatch", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function(handler) {
            return this._internalEventsRegister("patch" /* Patch */ , handler);
        }
    });
    Object.defineProperty(ObjectNode.prototype, "emitPatch", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function(basePatch, source) {
            if (this._internalEventsHasSubscribers("patch" /* Patch */ )) {
                var localizedPatch = extend({}, basePatch, {
                    path: source.path.substr(this.path.length) + "/" + basePatch.path // calculate the relative path of the patch
                });
                var _a = __read(splitPatch(localizedPatch), 2), patch = _a[0], reversePatch = _a[1];
                this._internalEventsEmit("patch" /* Patch */ , patch, reversePatch);
            }
            if (this.parent) this.parent.emitPatch(basePatch, source);
        }
    });
    Object.defineProperty(ObjectNode.prototype, "hasDisposer", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function(disposer) {
            return this._internalEventsHas("dispose" /* Dispose */ , disposer);
        }
    });
    Object.defineProperty(ObjectNode.prototype, "addDisposer", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function(disposer) {
            if (!this.hasDisposer(disposer)) {
                this._internalEventsRegister("dispose" /* Dispose */ , disposer, true);
                return;
            }
            throw fail$1("cannot add a disposer when it is already registered for execution");
        }
    });
    Object.defineProperty(ObjectNode.prototype, "removeDisposer", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function(disposer) {
            if (!this._internalEventsHas("dispose" /* Dispose */ , disposer)) throw fail$1("cannot remove a disposer which was never registered for execution");
            this._internalEventsUnregister("dispose" /* Dispose */ , disposer);
        }
    });
    Object.defineProperty(ObjectNode.prototype, "removeMiddleware", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function(middleware) {
            if (this.middlewares) {
                var index = this.middlewares.indexOf(middleware);
                if (index >= 0) this.middlewares.splice(index, 1);
            }
        }
    });
    Object.defineProperty(ObjectNode.prototype, "addMiddleWare", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function(handler, includeHooks) {
            var _this = this;
            if (includeHooks === void 0) includeHooks = true;
            var middleware = {
                handler: handler,
                includeHooks: includeHooks
            };
            if (!this.middlewares) this.middlewares = [
                middleware
            ];
            else this.middlewares.push(middleware);
            return function() {
                _this.removeMiddleware(middleware);
            };
        }
    });
    Object.defineProperty(ObjectNode.prototype, "applyPatchLocally", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function(subpath, patch) {
            this.assertWritable({
                subpath: subpath
            });
            this.createObservableInstanceIfNeeded();
            this.type.applyPatchLocally(this, subpath, patch);
        }
    });
    Object.defineProperty(ObjectNode.prototype, "_addSnapshotReaction", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function() {
            var _this = this;
            if (!this._hasSnapshotReaction) {
                var snapshotDisposer = (0, $4f362.reaction)(function() {
                    return _this.snapshot;
                }, function(snapshot) {
                    return _this.emitSnapshot(snapshot);
                }, snapshotReactionOptions);
                this.addDisposer(snapshotDisposer);
                this._hasSnapshotReaction = true;
            }
        }
    });
    // we proxy the methods to avoid creating an EventHandlers instance when it is not needed
    Object.defineProperty(ObjectNode.prototype, "_internalEventsHasSubscribers", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function(event) {
            return !!this._internalEvents && this._internalEvents.hasSubscribers(event);
        }
    });
    Object.defineProperty(ObjectNode.prototype, "_internalEventsRegister", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function(event, eventHandler, atTheBeginning) {
            if (atTheBeginning === void 0) atTheBeginning = false;
            if (!this._internalEvents) this._internalEvents = new EventHandlers();
            return this._internalEvents.register(event, eventHandler, atTheBeginning);
        }
    });
    Object.defineProperty(ObjectNode.prototype, "_internalEventsHas", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function(event, eventHandler) {
            return !!this._internalEvents && this._internalEvents.has(event, eventHandler);
        }
    });
    Object.defineProperty(ObjectNode.prototype, "_internalEventsUnregister", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function(event, eventHandler) {
            if (this._internalEvents) this._internalEvents.unregister(event, eventHandler);
        }
    });
    Object.defineProperty(ObjectNode.prototype, "_internalEventsEmit", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function(event) {
            var _a;
            var args = [];
            for(var _i = 1; _i < arguments.length; _i++)args[_i - 1] = arguments[_i];
            if (this._internalEvents) (_a = this._internalEvents).emit.apply(_a, __spread([
                event
            ], args));
        }
    });
    Object.defineProperty(ObjectNode.prototype, "_internalEventsClear", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function(event) {
            if (this._internalEvents) this._internalEvents.clear(event);
        }
    });
    Object.defineProperty(ObjectNode.prototype, "_internalEventsClearAll", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function() {
            if (this._internalEvents) this._internalEvents.clearAll();
        }
    });
    return ObjectNode;
}(BaseNode);
ObjectNode.prototype.createObservableInstance = (0, $4f362.action)(ObjectNode.prototype.createObservableInstance);
ObjectNode.prototype.detach = (0, $4f362.action)(ObjectNode.prototype.detach);
ObjectNode.prototype.die = (0, $4f362.action)(ObjectNode.prototype.die);
var _a;
/**
 * @internal
 * @hidden
 */ var TypeFlags;
(function(TypeFlags) {
    TypeFlags[TypeFlags["String"] = 1] = "String";
    TypeFlags[TypeFlags["Number"] = 2] = "Number";
    TypeFlags[TypeFlags["Boolean"] = 4] = "Boolean";
    TypeFlags[TypeFlags["Date"] = 8] = "Date";
    TypeFlags[TypeFlags["Literal"] = 16] = "Literal";
    TypeFlags[TypeFlags["Array"] = 32] = "Array";
    TypeFlags[TypeFlags["Map"] = 64] = "Map";
    TypeFlags[TypeFlags["Object"] = 128] = "Object";
    TypeFlags[TypeFlags["Frozen"] = 256] = "Frozen";
    TypeFlags[TypeFlags["Optional"] = 512] = "Optional";
    TypeFlags[TypeFlags["Reference"] = 1024] = "Reference";
    TypeFlags[TypeFlags["Identifier"] = 2048] = "Identifier";
    TypeFlags[TypeFlags["Late"] = 4096] = "Late";
    TypeFlags[TypeFlags["Refinement"] = 8192] = "Refinement";
    TypeFlags[TypeFlags["Union"] = 16384] = "Union";
    TypeFlags[TypeFlags["Null"] = 32768] = "Null";
    TypeFlags[TypeFlags["Undefined"] = 65536] = "Undefined";
    TypeFlags[TypeFlags["Integer"] = 131072] = "Integer";
    TypeFlags[TypeFlags["Custom"] = 262144] = "Custom";
    TypeFlags[TypeFlags["SnapshotProcessor"] = 524288] = "SnapshotProcessor";
    TypeFlags[TypeFlags["Lazy"] = 1048576] = "Lazy";
    TypeFlags[TypeFlags["Finite"] = 2097152] = "Finite";
    TypeFlags[TypeFlags["Float"] = 4194304] = "Float";
})(TypeFlags || (TypeFlags = {}));
/**
 * @internal
 * @hidden
 */ var cannotDetermineSubtype = "cannotDetermine";
/** @hidden */ var $type = Symbol("$type");
/**
 * A base type produces a MST node (Node in the state tree)
 *
 * @internal
 * @hidden
 */ var BaseType = /** @class */ function() {
    function BaseType(name) {
        Object.defineProperty(this, _a, {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        // these are just to make inner types avaialable to inherited classes
        Object.defineProperty(this, "C", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "S", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "T", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "N", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "isType", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: true
        });
        Object.defineProperty(this, "name", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        this.name = name;
    }
    Object.defineProperty(BaseType.prototype, "create", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function(snapshot, environment) {
            typecheckInternal(this, snapshot);
            return this.instantiate(null, "", environment, snapshot).value;
        }
    });
    Object.defineProperty(BaseType.prototype, "getSnapshot", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function(node, applyPostProcess) {
            // istanbul ignore next
            throw fail$1("unimplemented method");
        }
    });
    Object.defineProperty(BaseType.prototype, "isAssignableFrom", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function(type) {
            return type === this;
        }
    });
    Object.defineProperty(BaseType.prototype, "validate", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function(value, context) {
            var node = getStateTreeNodeSafe(value);
            if (node) {
                var valueType = getType(value);
                return this.isAssignableFrom(valueType) ? typeCheckSuccess() : typeCheckFailure(context, value);
            // it is tempting to compare snapshots, but in that case we should always clone on assignments...
            }
            return this.isValidSnapshot(value, context);
        }
    });
    Object.defineProperty(BaseType.prototype, "is", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function(thing) {
            return this.validate(thing, [
                {
                    path: "",
                    type: this
                }
            ]).length === 0;
        }
    });
    Object.defineProperty(BaseType.prototype, "Type", {
        get: function() {
            // istanbul ignore next
            throw fail$1("Factory.Type should not be actually called. It is just a Type signature that can be used at compile time with Typescript, by using `typeof type.Type`");
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BaseType.prototype, "TypeWithoutSTN", {
        get: function() {
            // istanbul ignore next
            throw fail$1("Factory.TypeWithoutSTN should not be actually called. It is just a Type signature that can be used at compile time with Typescript, by using `typeof type.TypeWithoutSTN`");
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BaseType.prototype, "SnapshotType", {
        get: function() {
            // istanbul ignore next
            throw fail$1("Factory.SnapshotType should not be actually called. It is just a Type signature that can be used at compile time with Typescript, by using `typeof type.SnapshotType`");
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BaseType.prototype, "CreationType", {
        get: function() {
            // istanbul ignore next
            throw fail$1("Factory.CreationType should not be actually called. It is just a Type signature that can be used at compile time with Typescript, by using `typeof type.CreationType`");
        },
        enumerable: false,
        configurable: true
    });
    return BaseType;
}();
_a = $type;
BaseType.prototype.create = (0, $4f362.action)(BaseType.prototype.create);
/**
 * A complex type produces a MST node (Node in the state tree)
 *
 * @internal
 * @hidden
 */ var ComplexType = /** @class */ function(_super) {
    __extends(ComplexType, _super);
    function ComplexType(name) {
        var _this = _super.call(this, name) || this;
        Object.defineProperty(_this, "identifierAttribute", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        return _this;
    }
    Object.defineProperty(ComplexType.prototype, "create", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function(snapshot, environment) {
            if (snapshot === void 0) snapshot = this.getDefaultSnapshot();
            return _super.prototype.create.call(this, snapshot, environment);
        }
    });
    Object.defineProperty(ComplexType.prototype, "getValue", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function(node) {
            node.createObservableInstanceIfNeeded();
            return node.storedValue;
        }
    });
    Object.defineProperty(ComplexType.prototype, "isMatchingSnapshotId", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function(current, snapshot) {
            return !current.identifierAttribute || current.identifier === normalizeIdentifier(snapshot[current.identifierAttribute]);
        }
    });
    Object.defineProperty(ComplexType.prototype, "tryToReconcileNode", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function(current, newValue) {
            if (current.isDetaching) return false;
            if (current.snapshot === newValue) // newValue is the current snapshot of the node, noop
            return true;
            if (isStateTreeNode(newValue) && getStateTreeNode(newValue) === current) // the current node is the same as the new one
            return true;
            if (current.type === this && isMutable(newValue) && !isStateTreeNode(newValue) && this.isMatchingSnapshotId(current, newValue)) {
                // the newValue has no node, so can be treated like a snapshot
                // we can reconcile
                current.applySnapshot(newValue);
                return true;
            }
            return false;
        }
    });
    Object.defineProperty(ComplexType.prototype, "reconcile", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function(current, newValue, parent, subpath) {
            var nodeReconciled = this.tryToReconcileNode(current, newValue);
            if (nodeReconciled) {
                current.setParent(parent, subpath);
                return current;
            }
            // current node cannot be recycled in any way
            current.die(); // noop if detaching
            // attempt to reuse the new one
            if (isStateTreeNode(newValue) && this.isAssignableFrom(getType(newValue))) {
                // newValue is a Node as well, move it here..
                var newNode = getStateTreeNode(newValue);
                newNode.setParent(parent, subpath);
                return newNode;
            }
            // nothing to do, we have to create a new node
            return this.instantiate(parent, subpath, undefined, newValue);
        }
    });
    Object.defineProperty(ComplexType.prototype, "getSubTypes", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function() {
            return null;
        }
    });
    return ComplexType;
}(BaseType);
ComplexType.prototype.create = (0, $4f362.action)(ComplexType.prototype.create);
/**
 * @internal
 * @hidden
 */ var SimpleType = /** @class */ function(_super) {
    __extends(SimpleType, _super);
    function SimpleType() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Object.defineProperty(SimpleType.prototype, "createNewInstance", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function(snapshot) {
            return snapshot;
        }
    });
    Object.defineProperty(SimpleType.prototype, "getValue", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function(node) {
            // if we ever find a case where scalar nodes can be accessed without iterating through its parent
            // uncomment this to make sure the parent chain is created when this is accessed
            // if (node.parent) {
            //     node.parent.createObservableInstanceIfNeeded()
            // }
            return node.storedValue;
        }
    });
    Object.defineProperty(SimpleType.prototype, "getSnapshot", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function(node) {
            return node.storedValue;
        }
    });
    Object.defineProperty(SimpleType.prototype, "reconcile", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function(current, newValue, parent, subpath) {
            // reconcile only if type and value are still the same, and only if the node is not detaching
            if (!current.isDetaching && current.type === this && current.storedValue === newValue) return current;
            var res = this.instantiate(parent, subpath, undefined, newValue);
            current.die(); // noop if detaching
            return res;
        }
    });
    Object.defineProperty(SimpleType.prototype, "getSubTypes", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function() {
            return null;
        }
    });
    return SimpleType;
}(BaseType);
/**
 * Returns if a given value represents a type.
 *
 * @param value Value to check.
 * @returns `true` if the value is a type.
 */ function isType(value) {
    return typeof value === "object" && value && value.isType === true;
}
/**
 * @internal
 * @hidden
 */ function assertIsType(type, argNumber) {
    assertArg(type, isType, "mobx-state-tree type", argNumber);
}
var runningActions = new Map();
/**
 * Note: Consider migrating to `createActionTrackingMiddleware2`, it is easier to use.
 *
 * Convenience utility to create action based middleware that supports async processes more easily.
 * All hooks are called for both synchronous and asynchronous actions. Except that either `onSuccess` or `onFail` is called
 *
 * The create middleware tracks the process of an action (assuming it passes the `filter`).
 * `onResume` can return any value, which will be passed as second argument to any other hook. This makes it possible to keep state during a process.
 *
 * See the `atomic` middleware for an example
 *
 * @param hooks
 * @returns
 */ function createActionTrackingMiddleware(hooks) {
    return function actionTrackingMiddleware(call, next, abort) {
        switch(call.type){
            case "action":
                if (!hooks.filter || hooks.filter(call) === true) {
                    var context = hooks.onStart(call);
                    hooks.onResume(call, context);
                    runningActions.set(call.id, {
                        call: call,
                        context: context,
                        async: false
                    });
                    try {
                        var res = next(call);
                        hooks.onSuspend(call, context);
                        if (runningActions.get(call.id).async === false) {
                            runningActions.delete(call.id);
                            hooks.onSuccess(call, context, res);
                        }
                        return res;
                    } catch (e) {
                        runningActions.delete(call.id);
                        hooks.onFail(call, context, e);
                        throw e;
                    }
                } else return next(call);
            case "flow_spawn":
                var root = runningActions.get(call.rootId);
                root.async = true;
                return next(call);
            case "flow_resume":
            case "flow_resume_error":
                var root = runningActions.get(call.rootId);
                hooks.onResume(call, root.context);
                try {
                    return next(call);
                } finally{
                    hooks.onSuspend(call, root.context);
                }
            case "flow_throw":
                var root = runningActions.get(call.rootId);
                runningActions.delete(call.rootId);
                hooks.onFail(call, root.context, call.args[0]);
                return next(call);
            case "flow_return":
                var root = runningActions.get(call.rootId);
                runningActions.delete(call.rootId);
                hooks.onSuccess(call, root.context, call.args[0]);
                return next(call);
        }
    };
}
var RunningAction = /** @class */ function() {
    function RunningAction(hooks, call) {
        Object.defineProperty(this, "hooks", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: hooks
        });
        Object.defineProperty(this, "call", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: call
        });
        Object.defineProperty(this, "flowsPending", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: 0
        });
        Object.defineProperty(this, "running", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: true
        });
        if (hooks) hooks.onStart(call);
    }
    Object.defineProperty(RunningAction.prototype, "finish", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function(error) {
            if (this.running) {
                this.running = false;
                if (this.hooks) this.hooks.onFinish(this.call, error);
            }
        }
    });
    Object.defineProperty(RunningAction.prototype, "incFlowsPending", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function() {
            this.flowsPending++;
        }
    });
    Object.defineProperty(RunningAction.prototype, "decFlowsPending", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function() {
            this.flowsPending--;
        }
    });
    Object.defineProperty(RunningAction.prototype, "hasFlowsPending", {
        get: function() {
            return this.flowsPending > 0;
        },
        enumerable: false,
        configurable: true
    });
    return RunningAction;
}();
/**
 * Convenience utility to create action based middleware that supports async processes more easily.
 * The flow is like this:
 * - for each action: if filter passes -> `onStart` -> (inner actions recursively) -> `onFinish`
 *
 * Example: if we had an action `a` that called inside an action `b1`, then `b2` the flow would be:
 * - `filter(a)`
 * - `onStart(a)`
 *   - `filter(b1)`
 *   - `onStart(b1)`
 *   - `onFinish(b1)`
 *   - `filter(b2)`
 *   - `onStart(b2)`
 *   - `onFinish(b2)`
 * - `onFinish(a)`
 *
 * The flow is the same no matter if the actions are sync or async.
 *
 * See the `atomic` middleware for an example
 *
 * @param hooks
 * @returns
 */ function createActionTrackingMiddleware2(middlewareHooks) {
    var runningActions = new Map();
    return function actionTrackingMiddleware(call, next) {
        // find parentRunningAction
        var parentRunningAction = call.parentActionEvent ? runningActions.get(call.parentActionEvent.id) : undefined;
        if (call.type === "action") {
            var newCall = __assign(__assign({}, call), {
                // make a shallow copy of the parent action env
                env: parentRunningAction && parentRunningAction.call.env,
                parentCall: parentRunningAction && parentRunningAction.call
            });
            var passesFilter = !middlewareHooks.filter || middlewareHooks.filter(newCall);
            var hooks = passesFilter ? middlewareHooks : undefined;
            var runningAction = new RunningAction(hooks, newCall);
            runningActions.set(call.id, runningAction);
            var res = void 0;
            try {
                res = next(call);
            } catch (e) {
                runningActions.delete(call.id);
                runningAction.finish(e);
                throw e;
            }
            // sync action finished
            if (!runningAction.hasFlowsPending) {
                runningActions.delete(call.id);
                runningAction.finish();
            }
            return res;
        } else {
            if (!parentRunningAction) return next(call);
            switch(call.type){
                case "flow_spawn":
                    parentRunningAction.incFlowsPending();
                    return next(call);
                case "flow_resume":
                case "flow_resume_error":
                    return next(call);
                case "flow_throw":
                    var error = call.args[0];
                    try {
                        return next(call);
                    } finally{
                        parentRunningAction.decFlowsPending();
                        if (!parentRunningAction.hasFlowsPending) {
                            runningActions.delete(call.parentActionEvent.id);
                            parentRunningAction.finish(error);
                        }
                    }
                case "flow_return":
                    try {
                        return next(call);
                    } finally{
                        parentRunningAction.decFlowsPending();
                        if (!parentRunningAction.hasFlowsPending) {
                            runningActions.delete(call.parentActionEvent.id);
                            parentRunningAction.finish();
                        }
                    }
            }
        }
    };
}
function serializeArgument(node, actionName, index, arg) {
    if (arg instanceof Date) return {
        $MST_DATE: arg.getTime()
    };
    if (isPrimitive(arg)) return arg;
    // We should not serialize MST nodes, even if we can, because we don't know if the receiving party can handle a raw snapshot instead of an
    // MST type instance. So if one wants to serialize a MST node that was pass in, either explitly pass: 1: an id, 2: a (relative) path, 3: a snapshot
    if (isStateTreeNode(arg)) return serializeTheUnserializable("[MSTNode: " + getType(arg).name + "]");
    if (typeof arg === "function") return serializeTheUnserializable("[function]");
    if (typeof arg === "object" && !isPlainObject(arg) && !isArray(arg)) return serializeTheUnserializable("[object " + (arg && arg.constructor && arg.constructor.name || "Complex Object") + "]");
    try {
        // Check if serializable, cycle free etc...
        // MWE: there must be a better way....
        JSON.stringify(arg); // or throws
        return arg;
    } catch (e) {
        return serializeTheUnserializable("" + e);
    }
}
function deserializeArgument(adm, value) {
    if (value && typeof value === "object" && "$MST_DATE" in value) return new Date(value["$MST_DATE"]);
    return value;
}
function serializeTheUnserializable(baseType) {
    return {
        $MST_UNSERIALIZABLE: true,
        type: baseType
    };
}
/**
 * Applies an action or a series of actions in a single MobX transaction.
 * Does not return any value
 * Takes an action description as produced by the `onAction` middleware.
 *
 * @param target
 * @param actions
 */ function applyAction(target, actions) {
    // check all arguments
    assertIsStateTreeNode(target, 1);
    assertArg(actions, function(a) {
        return typeof a === "object";
    }, "object or array", 2);
    (0, $4f362.runInAction)(function() {
        asArray(actions).forEach(function(action) {
            return baseApplyAction(target, action);
        });
    });
}
function baseApplyAction(target, action) {
    var resolvedTarget = tryResolve(target, action.path || "");
    if (!resolvedTarget) throw fail$1("Invalid action path: " + (action.path || ""));
    var node = getStateTreeNode(resolvedTarget);
    // Reserved functions
    if (action.name === "@APPLY_PATCHES") return applyPatch.call(null, resolvedTarget, action.args[0]);
    if (action.name === "@APPLY_SNAPSHOT") return applySnapshot.call(null, resolvedTarget, action.args[0]);
    if (!(typeof resolvedTarget[action.name] === "function")) throw fail$1("Action '" + action.name + "' does not exist in '" + node.path + "'");
    return resolvedTarget[action.name].apply(resolvedTarget, action.args ? action.args.map(function(v) {
        return deserializeArgument(node, v);
    }) : []);
}
/**
 * Small abstraction around `onAction` and `applyAction`, attaches an action listener to a tree and records all the actions emitted.
 * Returns an recorder object with the following signature:
 *
 * Example:
 * ```ts
 * export interface IActionRecorder {
 *      // the recorded actions
 *      actions: ISerializedActionCall[]
 *      // true if currently recording
 *      recording: boolean
 *      // stop recording actions
 *      stop(): void
 *      // resume recording actions
 *      resume(): void
 *      // apply all the recorded actions on the given object
 *      replay(target: IAnyStateTreeNode): void
 * }
 * ```
 *
 * The optional filter function allows to skip recording certain actions.
 *
 * @param subject
 * @returns
 */ function recordActions(subject, filter) {
    // check all arguments
    assertIsStateTreeNode(subject, 1);
    var actions = [];
    var listener = function(call) {
        var recordThis = filter ? filter(call, getRunningActionContext()) : true;
        if (recordThis) actions.push(call);
    };
    var disposer;
    var recorder = {
        actions: actions,
        get recording () {
            return !!disposer;
        },
        stop: function() {
            if (disposer) {
                disposer();
                disposer = undefined;
            }
        },
        resume: function() {
            if (disposer) return;
            disposer = onAction(subject, listener);
        },
        replay: function(target) {
            applyAction(target, actions);
        }
    };
    recorder.resume();
    return recorder;
}
/**
 * Registers a function that will be invoked for each action that is called on the provided model instance, or to any of its children.
 * See [actions](https://github.com/mobxjs/mobx-state-tree#actions) for more details. onAction events are emitted only for the outermost called action in the stack.
 * Action can also be intercepted by middleware using addMiddleware to change the function call before it will be run.
 *
 * Not all action arguments might be serializable. For unserializable arguments, a struct like `{ $MST_UNSERIALIZABLE: true, type: "someType" }` will be generated.
 * MST Nodes are considered non-serializable as well (they could be serialized as there snapshot, but it is uncertain whether an replaying party will be able to handle such a non-instantiated snapshot).
 * Rather, when using `onAction` middleware, one should consider in passing arguments which are 1: an id, 2: a (relative) path, or 3: a snapshot. Instead of a real MST node.
 *
 * Example:
 * ```ts
 * const Todo = types.model({
 *   task: types.string
 * })
 *
 * const TodoStore = types.model({
 *   todos: types.array(Todo)
 * }).actions(self => ({
 *   add(todo) {
 *     self.todos.push(todo);
 *   }
 * }))
 *
 * const s = TodoStore.create({ todos: [] })
 *
 * let disposer = onAction(s, (call) => {
 *   console.log(call);
 * })
 *
 * s.add({ task: "Grab a coffee" })
 * // Logs: { name: "add", path: "", args: [{ task: "Grab a coffee" }] }
 * ```
 *
 * @param target
 * @param listener
 * @param attachAfter (default false) fires the listener *after* the action has executed instead of before.
 * @returns
 */ function onAction(target, listener, attachAfter) {
    if (attachAfter === void 0) attachAfter = false;
    // check all arguments
    assertIsStateTreeNode(target, 1);
    if (devMode()) {
        if (!isRoot(target)) warnError("Warning: Attaching onAction listeners to non root nodes is dangerous: No events will be emitted for actions initiated higher up in the tree.");
        if (!isProtected(target)) warnError("Warning: Attaching onAction listeners to non protected nodes is dangerous: No events will be emitted for direct modifications without action.");
    }
    return addMiddleware(target, function handler(rawCall, next) {
        if (rawCall.type === "action" && rawCall.id === rawCall.rootId) {
            var sourceNode_1 = getStateTreeNode(rawCall.context);
            var info = {
                name: rawCall.name,
                path: getRelativePathBetweenNodes(getStateTreeNode(target), sourceNode_1),
                args: rawCall.args.map(function(arg, index) {
                    return serializeArgument(sourceNode_1, rawCall.name, index, arg);
                })
            };
            if (attachAfter) {
                var res = next(rawCall);
                listener(info);
                return res;
            } else {
                listener(info);
                return next(rawCall);
            }
        } else return next(rawCall);
    });
}
var nextActionId = 1;
var currentActionContext;
/**
 * @internal
 * @hidden
 */ function getCurrentActionContext() {
    return currentActionContext;
}
/**
 * @internal
 * @hidden
 */ function getNextActionId() {
    return nextActionId++;
}
// TODO: optimize away entire action context if there is no middleware in tree?
/**
 * @internal
 * @hidden
 */ function runWithActionContext(context, fn) {
    var node = getStateTreeNode(context.context);
    if (context.type === "action") node.assertAlive({
        actionContext: context
    });
    var baseIsRunningAction = node._isRunningAction;
    node._isRunningAction = true;
    var previousContext = currentActionContext;
    currentActionContext = context;
    try {
        return runMiddleWares(node, context, fn);
    } finally{
        currentActionContext = previousContext;
        node._isRunningAction = baseIsRunningAction;
    }
}
/**
 * @internal
 * @hidden
 */ function getParentActionContext(parentContext) {
    if (!parentContext) return undefined;
    if (parentContext.type === "action") return parentContext;
    return parentContext.parentActionEvent;
}
/**
 * @internal
 * @hidden
 */ function createActionInvoker(target, name, fn) {
    var res = function() {
        var id = getNextActionId();
        var parentContext = currentActionContext;
        var parentActionContext = getParentActionContext(parentContext);
        return runWithActionContext({
            type: "action",
            name: name,
            id: id,
            args: argsToArray(arguments),
            context: target,
            tree: getRoot(target),
            rootId: parentContext ? parentContext.rootId : id,
            parentId: parentContext ? parentContext.id : 0,
            allParentIds: parentContext ? __spread(parentContext.allParentIds, [
                parentContext.id
            ]) : [],
            parentEvent: parentContext,
            parentActionEvent: parentActionContext
        }, fn);
    };
    res._isMSTAction = true;
    res._isFlowAction = fn._isFlowAction;
    return res;
}
/**
 * Middleware can be used to intercept any action is invoked on the subtree where it is attached.
 * If a tree is protected (by default), this means that any mutation of the tree will pass through your middleware.
 *
 * For more details, see the [middleware docs](concepts/middleware.md)
 *
 * @param target Node to apply the middleware to.
 * @param middleware Middleware to apply.
 * @returns A callable function to dispose the middleware.
 */ function addMiddleware(target, handler, includeHooks) {
    if (includeHooks === void 0) includeHooks = true;
    var node = getStateTreeNode(target);
    if (devMode()) {
        if (!node.isProtectionEnabled) warnError("It is recommended to protect the state tree before attaching action middleware, as otherwise it cannot be guaranteed that all changes are passed through middleware. See `protect`");
    }
    return node.addMiddleWare(handler, includeHooks);
}
/**
 * Binds middleware to a specific action.
 *
 * Example:
 * ```ts
 * type.actions(self => {
 *   function takeA____() {
 *       self.toilet.donate()
 *       self.wipe()
 *       self.wipe()
 *       self.toilet.flush()
 *   }
 *   return {
 *     takeA____: decorate(atomic, takeA____)
 *   }
 * })
 * ```
 *
 * @param handler
 * @param fn
 * @param includeHooks
 * @returns The original function
 */ function decorate(handler, fn, includeHooks) {
    if (includeHooks === void 0) includeHooks = true;
    var middleware = {
        handler: handler,
        includeHooks: includeHooks
    };
    fn.$mst_middleware = fn.$mst_middleware || [];
    fn.$mst_middleware.push(middleware);
    return fn;
}
var CollectedMiddlewares = /** @class */ function() {
    function CollectedMiddlewares(node, fn) {
        Object.defineProperty(this, "arrayIndex", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: 0
        });
        Object.defineProperty(this, "inArrayIndex", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: 0
        });
        Object.defineProperty(this, "middlewares", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: []
        });
        // we just push middleware arrays into an array of arrays to avoid making copies
        if (fn.$mst_middleware) this.middlewares.push(fn.$mst_middleware);
        var n = node;
        // Find all middlewares. Optimization: cache this?
        while(n){
            if (n.middlewares) this.middlewares.push(n.middlewares);
            n = n.parent;
        }
    }
    Object.defineProperty(CollectedMiddlewares.prototype, "isEmpty", {
        get: function() {
            return this.middlewares.length <= 0;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CollectedMiddlewares.prototype, "getNextMiddleware", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function() {
            var array = this.middlewares[this.arrayIndex];
            if (!array) return undefined;
            var item = array[this.inArrayIndex++];
            if (!item) {
                this.arrayIndex++;
                this.inArrayIndex = 0;
                return this.getNextMiddleware();
            }
            return item;
        }
    });
    return CollectedMiddlewares;
}();
function runMiddleWares(node, baseCall, originalFn) {
    var middlewares = new CollectedMiddlewares(node, originalFn);
    // Short circuit
    if (middlewares.isEmpty) return (0, $4f362.action)(originalFn).apply(null, baseCall.args);
    var result = null;
    function runNextMiddleware(call) {
        var middleware = middlewares.getNextMiddleware();
        var handler = middleware && middleware.handler;
        if (!handler) return (0, $4f362.action)(originalFn).apply(null, call.args);
        // skip hooks if asked to
        if (!middleware.includeHooks && Hook[call.name]) return runNextMiddleware(call);
        var nextInvoked = false;
        function next(call2, callback) {
            nextInvoked = true;
            // the result can contain
            // - the non manipulated return value from an action
            // - the non manipulated abort value
            // - one of the above but manipulated through the callback function
            result = runNextMiddleware(call2);
            if (callback) result = callback(result);
        }
        var abortInvoked = false;
        function abort(value) {
            abortInvoked = true;
            // overwrite the result
            // can be manipulated through middlewares earlier in the queue using the callback fn
            result = value;
        }
        handler(call, next, abort);
        if (devMode()) {
            if (!nextInvoked && !abortInvoked) {
                var node2 = getStateTreeNode(call.tree);
                throw fail$1("Neither the next() nor the abort() callback within the middleware " + handler.name + ' for the action: "' + call.name + '" on the node: ' + node2.type.name + " was invoked.");
            } else if (nextInvoked && abortInvoked) {
                var node2 = getStateTreeNode(call.tree);
                throw fail$1("The next() and abort() callback within the middleware " + handler.name + ' for the action: "' + call.name + '" on the node: ' + node2.type.name + " were invoked.");
            }
        }
        return result;
    }
    return runNextMiddleware(baseCall);
}
/**
 * Returns the currently executing MST action context, or undefined if none.
 */ function getRunningActionContext() {
    var current = getCurrentActionContext();
    while(current && current.type !== "action")current = current.parentActionEvent;
    return current;
}
function _isActionContextThisOrChildOf(actionContext, sameOrParent, includeSame) {
    var parentId = typeof sameOrParent === "number" ? sameOrParent : sameOrParent.id;
    var current = includeSame ? actionContext : actionContext.parentActionEvent;
    while(current){
        if (current.id === parentId) return true;
        current = current.parentActionEvent;
    }
    return false;
}
/**
 * Returns if the given action context is a parent of this action context.
 */ function isActionContextChildOf(actionContext, parent) {
    return _isActionContextThisOrChildOf(actionContext, parent, false);
}
/**
 * Returns if the given action context is this or a parent of this action context.
 */ function isActionContextThisOrChildOf(actionContext, parentOrThis) {
    return _isActionContextThisOrChildOf(actionContext, parentOrThis, true);
}
function safeStringify(value) {
    try {
        return JSON.stringify(value);
    } catch (e) {
        // istanbul ignore next
        return "<Unserializable: " + e + ">";
    }
}
/**
 * @internal
 * @hidden
 */ function prettyPrintValue(value) {
    return typeof value === "function" ? "<function" + (value.name ? " " + value.name : "") + ">" : isStateTreeNode(value) ? "<" + value + ">" : "`" + safeStringify(value) + "`";
}
function shortenPrintValue(valueInString) {
    return valueInString.length < 280 ? valueInString : valueInString.substring(0, 272) + "......" + valueInString.substring(valueInString.length - 8);
}
function toErrorString(error) {
    var value = error.value;
    var type = error.context[error.context.length - 1].type;
    var fullPath = error.context.map(function(_a) {
        var path = _a.path;
        return path;
    }).filter(function(path) {
        return path.length > 0;
    }).join("/");
    var pathPrefix = fullPath.length > 0 ? 'at path "/' + fullPath + '" ' : "";
    var currentTypename = isStateTreeNode(value) ? "value of type " + getStateTreeNode(value).type.name + ":" : isPrimitive(value) ? "value" : "snapshot";
    var isSnapshotCompatible = type && isStateTreeNode(value) && type.is(getStateTreeNode(value).snapshot);
    return "" + pathPrefix + currentTypename + " " + prettyPrintValue(value) + " is not assignable " + (type ? "to type: `" + type.name + "`" : "") + (error.message ? " (" + error.message + ")" : "") + (type ? isPrimitiveType(type) || isPrimitive(value) ? "." : ", expected an instance of `" + type.name + "` or a snapshot like `" + type.describe() + "` instead." + (isSnapshotCompatible ? " (Note that a snapshot of the provided value is compatible with the targeted type)" : "") : ".");
}
/**
 * @internal
 * @hidden
 */ function getContextForPath(context, path, type) {
    return context.concat([
        {
            path: path,
            type: type
        }
    ]);
}
/**
 * @internal
 * @hidden
 */ function typeCheckSuccess() {
    return EMPTY_ARRAY;
}
/**
 * @internal
 * @hidden
 */ function typeCheckFailure(context, value, message) {
    return [
        {
            context: context,
            value: value,
            message: message
        }
    ];
}
/**
 * @internal
 * @hidden
 */ function flattenTypeErrors(errors) {
    return errors.reduce(function(a, i) {
        return a.concat(i);
    }, []);
}
// TODO; doublecheck: typecheck should only needed to be invoked from: type.create and array / map / value.property will change
/**
 * @internal
 * @hidden
 */ function typecheckInternal(type, value) {
    // runs typeChecking if it is in dev-mode or through a process.env.ENABLE_TYPE_CHECK flag
    if (isTypeCheckingEnabled()) typecheck(type, value);
}
/**
 * Run's the typechecker for the given type on the given value, which can be a snapshot or an instance.
 * Throws if the given value is not according the provided type specification.
 * Use this if you need typechecks even in a production build (by default all automatic runtime type checks will be skipped in production builds)
 *
 * @param type Type to check against.
 * @param value Value to be checked, either a snapshot or an instance.
 */ function typecheck(type, value) {
    var errors = type.validate(value, [
        {
            path: "",
            type: type
        }
    ]);
    if (errors.length > 0) throw fail$1(validationErrorsToString(type, value, errors));
}
function validationErrorsToString(type, value, errors) {
    if (errors.length === 0) return undefined;
    return "Error while converting " + shortenPrintValue(prettyPrintValue(value)) + " to `" + type.name + "`:\n\n    " + errors.map(toErrorString).join("\n    ");
}
var identifierCacheId = 0;
/**
 * @internal
 * @hidden
 */ var IdentifierCache = /** @class */ function() {
    function IdentifierCache() {
        Object.defineProperty(this, "cacheId", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: identifierCacheId++
        });
        // n.b. in cache all identifiers are normalized to strings
        Object.defineProperty(this, "cache", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (0, $4f362.observable).map()
        });
        // last time the cache (array) for a given time changed
        // n.b. it is not really the time, but just an integer that gets increased after each modification to the array
        Object.defineProperty(this, "lastCacheModificationPerId", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (0, $4f362.observable).map()
        });
    }
    Object.defineProperty(IdentifierCache.prototype, "updateLastCacheModificationPerId", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function(identifier) {
            var lcm = this.lastCacheModificationPerId.get(identifier);
            // we start at 1 since 0 means no update since cache creation
            this.lastCacheModificationPerId.set(identifier, lcm === undefined ? 1 : lcm + 1);
        }
    });
    Object.defineProperty(IdentifierCache.prototype, "getLastCacheModificationPerId", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function(identifier) {
            var modificationId = this.lastCacheModificationPerId.get(identifier) || 0;
            return this.cacheId + "-" + modificationId;
        }
    });
    Object.defineProperty(IdentifierCache.prototype, "addNodeToCache", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function(node, lastCacheUpdate) {
            if (lastCacheUpdate === void 0) lastCacheUpdate = true;
            if (node.identifierAttribute) {
                var identifier = node.identifier;
                if (!this.cache.has(identifier)) this.cache.set(identifier, (0, $4f362.observable).array([], mobxShallow));
                var set = this.cache.get(identifier);
                if (set.indexOf(node) !== -1) throw fail$1("Already registered");
                set.push(node);
                if (lastCacheUpdate) this.updateLastCacheModificationPerId(identifier);
            }
        }
    });
    Object.defineProperty(IdentifierCache.prototype, "mergeCache", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function(node) {
            var _this = this;
            (0, $4f362.values)(node.identifierCache.cache).forEach(function(nodes) {
                return nodes.forEach(function(child) {
                    _this.addNodeToCache(child);
                });
            });
        }
    });
    Object.defineProperty(IdentifierCache.prototype, "notifyDied", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function(node) {
            if (node.identifierAttribute) {
                var id = node.identifier;
                var set = this.cache.get(id);
                if (set) {
                    set.remove(node);
                    // remove empty sets from cache
                    if (!set.length) this.cache.delete(id);
                    this.updateLastCacheModificationPerId(node.identifier);
                }
            }
        }
    });
    Object.defineProperty(IdentifierCache.prototype, "splitCache", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function(splitNode) {
            var _this = this;
            var newCache = new IdentifierCache();
            // The slash is added here so we only match children of the splitNode. In version 5.1.8 and
            // earlier there was no trailing slash, so non children that started with the same path string
            // were being matched incorrectly.
            var basePath = splitNode.path + "/";
            (0, $4f362.entries)(this.cache).forEach(function(_a) {
                var _b = __read(_a, 2), id = _b[0], nodes = _b[1];
                var modified = false;
                for(var i = nodes.length - 1; i >= 0; i--){
                    var node = nodes[i];
                    if (node === splitNode || node.path.indexOf(basePath) === 0) {
                        newCache.addNodeToCache(node, false); // no need to update lastUpdated since it is a whole new cache
                        nodes.splice(i, 1);
                        // remove empty sets from cache
                        if (!nodes.length) _this.cache.delete(id);
                        modified = true;
                    }
                }
                if (modified) _this.updateLastCacheModificationPerId(id);
            });
            return newCache;
        }
    });
    Object.defineProperty(IdentifierCache.prototype, "has", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function(type, identifier) {
            var set = this.cache.get(identifier);
            if (!set) return false;
            return set.some(function(candidate) {
                return type.isAssignableFrom(candidate.type);
            });
        }
    });
    Object.defineProperty(IdentifierCache.prototype, "resolve", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function(type, identifier) {
            var set = this.cache.get(identifier);
            if (!set) return null;
            var matches = set.filter(function(candidate) {
                return type.isAssignableFrom(candidate.type);
            });
            switch(matches.length){
                case 0:
                    return null;
                case 1:
                    return matches[0];
                default:
                    throw fail$1("Cannot resolve a reference to type '" + type.name + "' with id: '" + identifier + "' unambigously, there are multiple candidates: " + matches.map(function(n) {
                        return n.path;
                    }).join(", "));
            }
        }
    });
    return IdentifierCache;
}();
/**
 * @internal
 * @hidden
 */ function createObjectNode(type, parent, subpath, environment, initialValue) {
    var existingNode = getStateTreeNodeSafe(initialValue);
    if (existingNode) {
        if (existingNode.parent) // istanbul ignore next
        throw fail$1("Cannot add an object to a state tree if it is already part of the same or another state tree. Tried to assign an object to '" + (parent ? parent.path : "") + "/" + subpath + "', but it lives already at '" + existingNode.path + "'");
        if (parent) existingNode.setParent(parent, subpath);
        // else it already has no parent since it is a pre-requisite
        return existingNode;
    }
    // not a node, a snapshot
    return new ObjectNode(type, parent, subpath, environment, initialValue);
}
/**
 * @internal
 * @hidden
 */ function createScalarNode(type, parent, subpath, environment, initialValue) {
    return new ScalarNode(type, parent, subpath, environment, initialValue);
}
/**
 * @internal
 * @hidden
 */ function isNode(value) {
    return value instanceof ScalarNode || value instanceof ObjectNode;
}
/**
 * @internal
 * @hidden
 */ var NodeLifeCycle;
(function(NodeLifeCycle) {
    NodeLifeCycle[NodeLifeCycle["INITIALIZING"] = 0] = "INITIALIZING";
    NodeLifeCycle[NodeLifeCycle["CREATED"] = 1] = "CREATED";
    NodeLifeCycle[NodeLifeCycle["FINALIZED"] = 2] = "FINALIZED";
    NodeLifeCycle[NodeLifeCycle["DETACHING"] = 3] = "DETACHING";
    NodeLifeCycle[NodeLifeCycle["DEAD"] = 4] = "DEAD"; // no coming back from this one
})(NodeLifeCycle || (NodeLifeCycle = {}));
/**
 * Returns true if the given value is a node in a state tree.
 * More precisely, that is, if the value is an instance of a
 * `types.model`, `types.array` or `types.map`.
 *
 * @param value
 * @returns true if the value is a state tree node.
 */ function isStateTreeNode(value) {
    return !!(value && value.$treenode);
}
/**
 * @internal
 * @hidden
 */ function assertIsStateTreeNode(value, argNumber) {
    assertArg(value, isStateTreeNode, "mobx-state-tree node", argNumber);
}
/**
 * @internal
 * @hidden
 */ function getStateTreeNode(value) {
    if (!isStateTreeNode(value)) // istanbul ignore next
    throw fail$1("Value " + value + " is no MST Node");
    return value.$treenode;
}
/**
 * @internal
 * @hidden
 */ function getStateTreeNodeSafe(value) {
    return value && value.$treenode || null;
}
/**
 * @internal
 * @hidden
 */ function toJSON() {
    return getStateTreeNode(this).snapshot;
}
var doubleDot = function(_) {
    return "..";
};
/**
 * @internal
 * @hidden
 */ function getRelativePathBetweenNodes(base, target) {
    // PRE condition target is (a child of) base!
    if (base.root !== target.root) throw fail$1("Cannot calculate relative path: objects '" + base + "' and '" + target + "' are not part of the same object tree");
    var baseParts = splitJsonPath(base.path);
    var targetParts = splitJsonPath(target.path);
    var common = 0;
    for(; common < baseParts.length; common++){
        if (baseParts[common] !== targetParts[common]) break;
    }
    // TODO: assert that no targetParts paths are "..", "." or ""!
    return baseParts.slice(common).map(doubleDot).join("/") + joinJsonPath(targetParts.slice(common));
}
/**
 * @internal
 * @hidden
 */ function resolveNodeByPath(base, path, failIfResolveFails) {
    if (failIfResolveFails === void 0) failIfResolveFails = true;
    return resolveNodeByPathParts(base, splitJsonPath(path), failIfResolveFails);
}
/**
 * @internal
 * @hidden
 */ function resolveNodeByPathParts(base, pathParts, failIfResolveFails) {
    if (failIfResolveFails === void 0) failIfResolveFails = true;
    var current = base;
    try {
        for(var i = 0; i < pathParts.length; i++){
            var part = pathParts[i];
            if (part === "..") {
                current = current.parent;
                if (current) continue; // not everything has a parent
            } else if (part === ".") continue;
            else if (current) {
                if (current instanceof ScalarNode) {
                    // check if the value of a scalar resolves to a state tree node (e.g. references)
                    // then we can continue resolving...
                    var value = current.value;
                    if (isStateTreeNode(value)) current = getStateTreeNode(value);
                }
                if (current instanceof ObjectNode) {
                    var subType = current.getChildType(part);
                    if (subType) {
                        current = current.getChildNode(part);
                        if (current) continue;
                    }
                }
            }
            throw fail$1("Could not resolve '" + part + "' in path '" + (joinJsonPath(pathParts.slice(0, i)) || "/") + "' while resolving '" + joinJsonPath(pathParts) + "'");
        }
    } catch (e) {
        if (!failIfResolveFails) return undefined;
        throw e;
    }
    return current;
}
/**
 * @internal
 * @hidden
 */ function convertChildNodesToArray(childNodes) {
    if (!childNodes) return EMPTY_ARRAY;
    var keys = Object.keys(childNodes);
    if (!keys.length) return EMPTY_ARRAY;
    var result = new Array(keys.length);
    keys.forEach(function(key, index) {
        result[index] = childNodes[key];
    });
    return result;
}
// based on: https://github.com/mobxjs/mobx-utils/blob/master/src/async-action.ts
/*
    All contents of this file are deprecated.

    The term `process` has been replaced with `flow` to avoid conflicts with the
    global `process` object.

    Refer to `flow.ts` for any further changes to this implementation.
*/ var DEPRECATION_MESSAGE = "See https://github.com/mobxjs/mobx-state-tree/issues/399 for more information. Note that the middleware event types starting with `process` now start with `flow`.";
/**
 * @hidden
 *
 * @deprecated has been renamed to `flow()`.
 * See https://github.com/mobxjs/mobx-state-tree/issues/399 for more information.
 * Note that the middleware event types starting with `process` now start with `flow`.
 *
 * @returns {Promise}
 */ function process$1(asyncAction) {
    deprecated("process", "`process()` has been renamed to `flow()`. " + DEPRECATION_MESSAGE);
    return flow(asyncAction);
}
var plainObjectString = Object.toString();
/**
 * @internal
 * @hidden
 */ var EMPTY_ARRAY = Object.freeze([]);
/**
 * @internal
 * @hidden
 */ var EMPTY_OBJECT = Object.freeze({});
/**
 * @internal
 * @hidden
 */ var mobxShallow = (0, $4f362._getGlobalState)().useProxies ? {
    deep: false
} : {
    deep: false,
    proxy: false
};
Object.freeze(mobxShallow);
/**
 * @internal
 * @hidden
 */ function fail$1(message) {
    if (message === void 0) message = "Illegal state";
    return new Error("[mobx-state-tree] " + message);
}
/**
 * @internal
 * @hidden
 */ function identity(_) {
    return _;
}
/**
 * @internal
 * @hidden
 */ var isInteger = Number.isInteger;
/**
 * @internal
 * @hidden
 */ function isFloat(val) {
    return Number(val) === val && val % 1 !== 0;
}
/**
 * @internal
 * @hidden
 */ function isFinite(val) {
    return Number.isFinite(val);
}
/**
 * @internal
 * @hidden
 */ function isArray(val) {
    return Array.isArray(val) || (0, $4f362.isObservableArray)(val);
}
/**
 * @internal
 * @hidden
 */ function asArray(val) {
    if (!val) return EMPTY_ARRAY;
    if (isArray(val)) return val;
    return [
        val
    ];
}
/**
 * @internal
 * @hidden
 */ function extend(a) {
    var b = [];
    for(var _i = 1; _i < arguments.length; _i++)b[_i - 1] = arguments[_i];
    for(var i = 0; i < b.length; i++){
        var current = b[i];
        for(var key in current)a[key] = current[key];
    }
    return a;
}
/**
 * @internal
 * @hidden
 */ function isPlainObject(value) {
    var _a;
    if (value === null || typeof value !== "object") return false;
    var proto = Object.getPrototypeOf(value);
    if (proto == null) return true;
    return ((_a = proto.constructor) === null || _a === void 0 ? void 0 : _a.toString()) === plainObjectString;
}
/**
 * @internal
 * @hidden
 */ function isMutable(value) {
    return value !== null && typeof value === "object" && !(value instanceof Date) && !(value instanceof RegExp);
}
/**
 * @internal
 * @hidden
 */ function isPrimitive(value, includeDate) {
    if (includeDate === void 0) includeDate = true;
    return value === null || value === undefined || typeof value === "string" || typeof value === "number" || typeof value === "boolean" || includeDate && value instanceof Date;
}
/**
 * @internal
 * @hidden
 * Freeze a value and return it (if not in production)
 */ function freeze(value) {
    if (!devMode()) return value;
    return isPrimitive(value) || (0, $4f362.isObservableArray)(value) ? value : Object.freeze(value);
}
/**
 * @internal
 * @hidden
 * Recursively freeze a value (if not in production)
 */ function deepFreeze(value) {
    if (!devMode()) return value;
    freeze(value);
    if (isPlainObject(value)) Object.keys(value).forEach(function(propKey) {
        if (!isPrimitive(value[propKey]) && !Object.isFrozen(value[propKey])) deepFreeze(value[propKey]);
    });
    return value;
}
/**
 * @internal
 * @hidden
 */ function isSerializable(value) {
    return typeof value !== "function";
}
/**
 * @internal
 * @hidden
 */ function defineProperty(object, key, descriptor) {
    (0, $4f362.isObservableObject)(object) ? (0, $4f362.defineProperty)(object, key, descriptor) : Object.defineProperty(object, key, descriptor);
}
/**
 * @internal
 * @hidden
 */ function addHiddenFinalProp(object, propName, value) {
    defineProperty(object, propName, {
        enumerable: false,
        writable: false,
        configurable: true,
        value: value
    });
}
/**
 * @internal
 * @hidden
 */ function addHiddenWritableProp(object, propName, value) {
    defineProperty(object, propName, {
        enumerable: false,
        writable: true,
        configurable: true,
        value: value
    });
}
/**
 * @internal
 * @hidden
 */ var EventHandler = /** @class */ function() {
    function EventHandler() {
        Object.defineProperty(this, "handlers", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: []
        });
    }
    Object.defineProperty(EventHandler.prototype, "hasSubscribers", {
        get: function() {
            return this.handlers.length > 0;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(EventHandler.prototype, "register", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function(fn, atTheBeginning) {
            var _this = this;
            if (atTheBeginning === void 0) atTheBeginning = false;
            if (atTheBeginning) this.handlers.unshift(fn);
            else this.handlers.push(fn);
            return function() {
                _this.unregister(fn);
            };
        }
    });
    Object.defineProperty(EventHandler.prototype, "has", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function(fn) {
            return this.handlers.indexOf(fn) >= 0;
        }
    });
    Object.defineProperty(EventHandler.prototype, "unregister", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function(fn) {
            var index = this.handlers.indexOf(fn);
            if (index >= 0) this.handlers.splice(index, 1);
        }
    });
    Object.defineProperty(EventHandler.prototype, "clear", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function() {
            this.handlers.length = 0;
        }
    });
    Object.defineProperty(EventHandler.prototype, "emit", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function() {
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            // make a copy just in case it changes
            var handlers = this.handlers.slice();
            handlers.forEach(function(f) {
                return f.apply(void 0, __spread(args));
            });
        }
    });
    return EventHandler;
}();
/**
 * @internal
 * @hidden
 */ var EventHandlers = /** @class */ function() {
    function EventHandlers() {
        Object.defineProperty(this, "eventHandlers", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
    }
    Object.defineProperty(EventHandlers.prototype, "hasSubscribers", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function(event) {
            var handler = this.eventHandlers && this.eventHandlers[event];
            return !!handler && handler.hasSubscribers;
        }
    });
    Object.defineProperty(EventHandlers.prototype, "register", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function(event, fn, atTheBeginning) {
            if (atTheBeginning === void 0) atTheBeginning = false;
            if (!this.eventHandlers) this.eventHandlers = {};
            var handler = this.eventHandlers[event];
            if (!handler) handler = this.eventHandlers[event] = new EventHandler();
            return handler.register(fn, atTheBeginning);
        }
    });
    Object.defineProperty(EventHandlers.prototype, "has", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function(event, fn) {
            var handler = this.eventHandlers && this.eventHandlers[event];
            return !!handler && handler.has(fn);
        }
    });
    Object.defineProperty(EventHandlers.prototype, "unregister", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function(event, fn) {
            var handler = this.eventHandlers && this.eventHandlers[event];
            if (handler) handler.unregister(fn);
        }
    });
    Object.defineProperty(EventHandlers.prototype, "clear", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function(event) {
            if (this.eventHandlers) delete this.eventHandlers[event];
        }
    });
    Object.defineProperty(EventHandlers.prototype, "clearAll", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function() {
            this.eventHandlers = undefined;
        }
    });
    Object.defineProperty(EventHandlers.prototype, "emit", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function(event) {
            var _a;
            var args = [];
            for(var _i = 1; _i < arguments.length; _i++)args[_i - 1] = arguments[_i];
            var handler = this.eventHandlers && this.eventHandlers[event];
            if (handler) (_a = handler).emit.apply(_a, __spread(args));
        }
    });
    return EventHandlers;
}();
/**
 * @internal
 * @hidden
 */ function argsToArray(args) {
    var res = new Array(args.length);
    for(var i = 0; i < args.length; i++)res[i] = args[i];
    return res;
}
/**
 * @internal
 * @hidden
 */ function stringStartsWith(str, beginning) {
    return str.indexOf(beginning) === 0;
}
/**
 * @internal
 * @hidden
 */ var deprecated = function(id, message) {
    // skip if running production
    if (!devMode()) return;
    // warn if hasn't been warned before
    if (deprecated.ids && !deprecated.ids.hasOwnProperty(id)) warnError("Deprecation warning: " + message);
    // mark as warned to avoid duplicate warn message
    if (deprecated.ids) deprecated.ids[id] = true;
};
deprecated.ids = {};
/**
 * @internal
 * @hidden
 */ function warnError(msg) {
    console.warn(new Error("[mobx-state-tree] " + msg));
}
/**
 * @internal
 * @hidden
 */ function isTypeCheckingEnabled() {
    return devMode() || typeof $hPtJY !== "undefined" && $hPtJY.env && false;
}
/**
 * @internal
 * @hidden
 */ function devMode() {
    return true;
}
/**
 * @internal
 * @hidden
 */ function assertArg(value, fn, typeName, argNumber) {
    if (devMode()) {
        if (!fn(value)) // istanbul ignore next
        throw fail$1("expected " + typeName + " as argument " + asArray(argNumber).join(" or ") + ", got " + value + " instead");
    }
}
/**
 * @internal
 * @hidden
 */ function assertIsFunction(value, argNumber) {
    assertArg(value, function(fn) {
        return typeof fn === "function";
    }, "function", argNumber);
}
/**
 * @internal
 * @hidden
 */ function assertIsNumber(value, argNumber, min, max) {
    assertArg(value, function(n) {
        return typeof n === "number";
    }, "number", argNumber);
    if (min !== undefined) assertArg(value, function(n) {
        return n >= min;
    }, "number greater than " + min, argNumber);
    if (max !== undefined) assertArg(value, function(n) {
        return n <= max;
    }, "number lesser than " + max, argNumber);
}
/**
 * @internal
 * @hidden
 */ function assertIsString(value, argNumber, canBeEmpty) {
    if (canBeEmpty === void 0) canBeEmpty = true;
    assertArg(value, function(s) {
        return typeof s === "string";
    }, "string", argNumber);
    if (!canBeEmpty) assertArg(value, function(s) {
        return s !== "";
    }, "not empty string", argNumber);
}
/**
 * @internal
 * @hidden
 */ function setImmediateWithFallback(fn) {
    if (typeof queueMicrotask === "function") queueMicrotask(fn);
    else if (typeof setImmediate === "function") setImmediate(fn);
    else setTimeout(fn, 1);
}
/**
 * See [asynchronous actions](concepts/async-actions.md).
 *
 * @returns The flow as a promise.
 */ function flow(generator) {
    return createFlowSpawner(generator.name, generator);
}
/**
 * @deprecated Not needed since TS3.6.
 * Used for TypeScript to make flows that return a promise return the actual promise result.
 *
 * @param val
 * @returns
 */ function castFlowReturn(val) {
    return val;
}
/**
 * @experimental
 * experimental api - might change on minor/patch releases
 *
 * Convert a promise-returning function to a generator-returning one.
 * This is intended to allow for usage of `yield*` in async actions to
 * retain the promise return type.
 *
 * Example:
 * ```ts
 * function getDataAsync(input: string): Promise<number> { ... }
 * const getDataGen = toGeneratorFunction(getDataAsync);
 *
 * const someModel.actions(self => ({
 *   someAction: flow(function*() {
 *     // value is typed as number
 *     const value = yield* getDataGen("input value");
 *     ...
 *   })
 * }))
 * ```
 */ function toGeneratorFunction(p) {
    return function() {
        var _i;
        var args = [];
        for(_i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
        return __generator(this, function(_a) {
            switch(_a.label){
                case 0:
                    return [
                        4 /*yield*/ ,
                        p.apply(void 0, __spread(args))
                    ];
                case 1:
                    return [
                        2 /*return*/ ,
                        _a.sent()
                    ];
            }
        });
    };
}
/**
 * @experimental
 * experimental api - might change on minor/patch releases
 *
 * Convert a promise to a generator yielding that promise
 * This is intended to allow for usage of `yield*` in async actions to
 * retain the promise return type.
 *
 * Example:
 * ```ts
 * function getDataAsync(input: string): Promise<number> { ... }
 *
 * const someModel.actions(self => ({
 *   someAction: flow(function*() {
 *     // value is typed as number
 *     const value = yield* toGenerator(getDataAsync("input value"));
 *     ...
 *   })
 * }))
 * ```
 */ function toGenerator(p) {
    return __generator(this, function(_a) {
        switch(_a.label){
            case 0:
                return [
                    4 /*yield*/ ,
                    p
                ];
            case 1:
                return [
                    2 /*return*/ ,
                    _a.sent()
                ];
        }
    });
}
/**
 * @internal
 * @hidden
 */ function createFlowSpawner(name, generator) {
    var spawner = function flowSpawner() {
        // Implementation based on https://github.com/tj/co/blob/master/index.js
        var runId = getNextActionId();
        var parentContext = getCurrentActionContext();
        if (!parentContext) throw fail$1("a mst flow must always have a parent context");
        var parentActionContext = getParentActionContext(parentContext);
        if (!parentActionContext) throw fail$1("a mst flow must always have a parent action context");
        var contextBase = {
            name: name,
            id: runId,
            tree: parentContext.tree,
            context: parentContext.context,
            parentId: parentContext.id,
            allParentIds: __spread(parentContext.allParentIds, [
                parentContext.id
            ]),
            rootId: parentContext.rootId,
            parentEvent: parentContext,
            parentActionEvent: parentActionContext
        };
        var args = arguments;
        function wrap(fn, type, arg) {
            fn.$mst_middleware = spawner.$mst_middleware; // pick up any middleware attached to the flow
            return runWithActionContext(__assign(__assign({}, contextBase), {
                type: type,
                args: [
                    arg
                ]
            }), fn);
        }
        return new Promise(function(resolve, reject) {
            var gen;
            var init = function asyncActionInit() {
                gen = generator.apply(null, arguments);
                onFulfilled(undefined); // kick off the flow
            };
            init.$mst_middleware = spawner.$mst_middleware;
            runWithActionContext(__assign(__assign({}, contextBase), {
                type: "flow_spawn",
                args: argsToArray(args)
            }), init);
            function onFulfilled(res) {
                var ret;
                try {
                    // prettier-ignore
                    var cancelError = wrap(function(r) {
                        ret = gen.next(r);
                    }, "flow_resume", res);
                    if (cancelError instanceof Error) ret = gen.throw(cancelError);
                } catch (e) {
                    // prettier-ignore
                    setImmediateWithFallback(function() {
                        wrap(function(r) {
                            reject(e);
                        }, "flow_throw", e);
                    });
                    return;
                }
                next(ret);
                return;
            }
            function onRejected(err) {
                var ret;
                try {
                    // prettier-ignore
                    wrap(function(r) {
                        ret = gen.throw(r);
                    }, "flow_resume_error", err); // or yieldError?
                } catch (e) {
                    // prettier-ignore
                    setImmediateWithFallback(function() {
                        wrap(function(r) {
                            reject(e);
                        }, "flow_throw", e);
                    });
                    return;
                }
                next(ret);
            }
            function next(ret) {
                if (ret.done) {
                    // prettier-ignore
                    setImmediateWithFallback(function() {
                        wrap(function(r) {
                            resolve(r);
                        }, "flow_return", ret.value);
                    });
                    return;
                }
                // TODO: support more type of values? See https://github.com/tj/co/blob/249bbdc72da24ae44076afd716349d2089b31c4c/index.js#L100
                if (!ret.value || typeof ret.value.then !== "function") // istanbul ignore next
                throw fail$1("Only promises can be yielded to `async`, got: " + ret);
                return ret.value.then(onFulfilled, onRejected);
            }
        });
    };
    spawner._isFlowAction = true;
    return spawner;
}
/**
 * @internal
 * @hidden
 */ function splitPatch(patch) {
    if (!("oldValue" in patch)) throw fail$1("Patches without `oldValue` field cannot be inversed");
    return [
        stripPatch(patch),
        invertPatch(patch)
    ];
}
/**
 * @internal
 * @hidden
 */ function stripPatch(patch) {
    // strips `oldvalue` information from the patch, so that it becomes a patch conform the json-patch spec
    // this removes the ability to undo the patch
    switch(patch.op){
        case "add":
            return {
                op: "add",
                path: patch.path,
                value: patch.value
            };
        case "remove":
            return {
                op: "remove",
                path: patch.path
            };
        case "replace":
            return {
                op: "replace",
                path: patch.path,
                value: patch.value
            };
    }
}
function invertPatch(patch) {
    switch(patch.op){
        case "add":
            return {
                op: "remove",
                path: patch.path
            };
        case "remove":
            return {
                op: "add",
                path: patch.path,
                value: patch.oldValue
            };
        case "replace":
            return {
                op: "replace",
                path: patch.path,
                value: patch.oldValue
            };
    }
}
/**
 * Simple simple check to check it is a number.
 */ function isNumber(x) {
    return typeof x === "number";
}
/**
 * Escape slashes and backslashes.
 *
 * http://tools.ietf.org/html/rfc6901
 */ function escapeJsonPath(path) {
    if (isNumber(path) === true) return "" + path;
    if (path.indexOf("/") === -1 && path.indexOf("~") === -1) return path;
    return path.replace(/~/g, "~0").replace(/\//g, "~1");
}
/**
 * Unescape slashes and backslashes.
 */ function unescapeJsonPath(path) {
    return path.replace(/~1/g, "/").replace(/~0/g, "~");
}
/**
 * Generates a json-path compliant json path from path parts.
 *
 * @param path
 * @returns
 */ function joinJsonPath(path) {
    // `/` refers to property with an empty name, while `` refers to root itself!
    if (path.length === 0) return "";
    var getPathStr = function(p) {
        return p.map(escapeJsonPath).join("/");
    };
    if (path[0] === "." || path[0] === "..") // relative
    return getPathStr(path);
    else // absolute
    return "/" + getPathStr(path);
}
/**
 * Splits and decodes a json path into several parts.
 *
 * @param path
 * @returns
 */ function splitJsonPath(path) {
    // `/` refers to property with an empty name, while `` refers to root itself!
    var parts = path.split("/").map(unescapeJsonPath);
    var valid = path === "" || path === "." || path === ".." || stringStartsWith(path, "/") || stringStartsWith(path, "./") || stringStartsWith(path, "../");
    if (!valid) throw fail$1("a json path must be either rooted, empty or relative, but got '" + path + "'");
    // '/a/b/c' -> ["a", "b", "c"]
    // '../../b/c' -> ["..", "..", "b", "c"]
    // '' -> []
    // '/' -> ['']
    // './a' -> [".", "a"]
    // /./a' -> [".", "a"] equivalent to './a'
    if (parts[0] === "") parts.shift();
    return parts;
}
/** @hidden */ var $preProcessorFailed = Symbol("$preProcessorFailed");
var SnapshotProcessor = /** @class */ function(_super) {
    __extends(SnapshotProcessor, _super);
    function SnapshotProcessor(_subtype, _processors, name) {
        var _this = _super.call(this, name || _subtype.name) || this;
        Object.defineProperty(_this, "_subtype", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: _subtype
        });
        Object.defineProperty(_this, "_processors", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: _processors
        });
        return _this;
    }
    Object.defineProperty(SnapshotProcessor.prototype, "flags", {
        get: function() {
            return this._subtype.flags | TypeFlags.SnapshotProcessor;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SnapshotProcessor.prototype, "describe", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function() {
            return "snapshotProcessor(" + this._subtype.describe() + ")";
        }
    });
    Object.defineProperty(SnapshotProcessor.prototype, "preProcessSnapshot", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function(sn) {
            if (this._processors.preProcessor) return this._processors.preProcessor.call(null, sn);
            return sn;
        }
    });
    Object.defineProperty(SnapshotProcessor.prototype, "preProcessSnapshotSafe", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function(sn) {
            try {
                return this.preProcessSnapshot(sn);
            } catch (e) {
                return $preProcessorFailed;
            }
        }
    });
    Object.defineProperty(SnapshotProcessor.prototype, "postProcessSnapshot", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function(sn, node) {
            if (this._processors.postProcessor) return this._processors.postProcessor.call(null, sn, node.storedValue);
            return sn;
        }
    });
    Object.defineProperty(SnapshotProcessor.prototype, "_fixNode", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function(node) {
            var _this = this;
            // the node has to use these methods rather than the original type ones
            proxyNodeTypeMethods(node.type, this, "create");
            if (node instanceof ObjectNode) node.hasSnapshotPostProcessor = !!this._processors.postProcessor;
            var oldGetSnapshot = node.getSnapshot;
            node.getSnapshot = function() {
                return _this.postProcessSnapshot(oldGetSnapshot.call(node), node);
            };
            if (!isUnionType(this._subtype)) node.getReconciliationType = function() {
                return _this;
            };
        }
    });
    Object.defineProperty(SnapshotProcessor.prototype, "instantiate", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function(parent, subpath, environment, initialValue) {
            var processedInitialValue = isStateTreeNode(initialValue) ? initialValue : this.preProcessSnapshot(initialValue);
            var node = this._subtype.instantiate(parent, subpath, environment, processedInitialValue);
            this._fixNode(node);
            return node;
        }
    });
    Object.defineProperty(SnapshotProcessor.prototype, "reconcile", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function(current, newValue, parent, subpath) {
            var node = this._subtype.reconcile(current, isStateTreeNode(newValue) ? newValue : this.preProcessSnapshot(newValue), parent, subpath);
            if (node !== current) this._fixNode(node);
            return node;
        }
    });
    Object.defineProperty(SnapshotProcessor.prototype, "getSnapshot", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function(node, applyPostProcess) {
            if (applyPostProcess === void 0) applyPostProcess = true;
            var sn = this._subtype.getSnapshot(node);
            return applyPostProcess ? this.postProcessSnapshot(sn, node) : sn;
        }
    });
    Object.defineProperty(SnapshotProcessor.prototype, "isValidSnapshot", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function(value, context) {
            var processedSn = this.preProcessSnapshotSafe(value);
            if (processedSn === $preProcessorFailed) return typeCheckFailure(context, value, "Failed to preprocess value");
            return this._subtype.validate(processedSn, context);
        }
    });
    Object.defineProperty(SnapshotProcessor.prototype, "getSubTypes", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function() {
            return this._subtype;
        }
    });
    Object.defineProperty(SnapshotProcessor.prototype, "is", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function(thing) {
            var value = isType(thing) ? this._subtype : isStateTreeNode(thing) ? getSnapshot(thing, false) : this.preProcessSnapshotSafe(thing);
            if (value === $preProcessorFailed) return false;
            return this._subtype.validate(value, [
                {
                    path: "",
                    type: this._subtype
                }
            ]).length === 0;
        }
    });
    Object.defineProperty(SnapshotProcessor.prototype, "isAssignableFrom", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function(type) {
            return this._subtype.isAssignableFrom(type);
        }
    });
    Object.defineProperty(SnapshotProcessor.prototype, "isMatchingSnapshotId", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function(current, snapshot) {
            if (!(this._subtype instanceof ComplexType)) return false;
            var processedSn = this.preProcessSnapshot(snapshot);
            return this._subtype.isMatchingSnapshotId(current, processedSn);
        }
    });
    return SnapshotProcessor;
}(BaseType);
function proxyNodeTypeMethods(nodeType, snapshotProcessorType) {
    var e_1, _a;
    var methods = [];
    for(var _i = 2; _i < arguments.length; _i++)methods[_i - 2] = arguments[_i];
    try {
        for(var methods_1 = __values(methods), methods_1_1 = methods_1.next(); !methods_1_1.done; methods_1_1 = methods_1.next()){
            var method = methods_1_1.value;
            nodeType[method] = snapshotProcessorType[method].bind(snapshotProcessorType);
        }
    } catch (e_1_1) {
        e_1 = {
            error: e_1_1
        };
    } finally{
        try {
            if (methods_1_1 && !methods_1_1.done && (_a = methods_1.return)) _a.call(methods_1);
        } finally{
            if (e_1) throw e_1.error;
        }
    }
}
/**
 * `types.snapshotProcessor` - Runs a pre/post snapshot processor before/after serializing a given type.
 *
 * Example:
 * ```ts
 * const Todo1 = types.model({ text: types.string })
 * // in the backend the text type must be null when empty
 * interface BackendTodo {
 *     text: string | null
 * }
 *
 * const Todo2 = types.snapshotProcessor(Todo1, {
 *     // from snapshot to instance
 *     preProcessor(snapshot: BackendTodo) {
 *         return {
 *             text: sn.text || "";
 *         }
 *     },
 *
 *     // from instance to snapshot
 *     postProcessor(snapshot, node): BackendTodo {
 *         return {
 *             text: !sn.text ? null : sn.text
 *         }
 *     }
 * })
 * ```
 *
 * @param type Type to run the processors over.
 * @param processors Processors to run.
 * @param name Type name, or undefined to inherit the inner type one.
 * @returns
 */ function snapshotProcessor(type, processors, name) {
    assertIsType(type, 1);
    if (devMode()) {
        if (processors.postProcessor && typeof processors.postProcessor !== "function") // istanbul ignore next
        throw fail("postSnapshotProcessor must be a function");
        if (processors.preProcessor && typeof processors.preProcessor !== "function") // istanbul ignore next
        throw fail("preSnapshotProcessor must be a function");
    }
    return new SnapshotProcessor(type, processors, name);
}
var needsIdentifierError = "Map.put can only be used to store complex values that have an identifier type attribute";
function tryCollectModelTypes(type, modelTypes) {
    var e_1, _a;
    var subtypes = type.getSubTypes();
    if (subtypes === cannotDetermineSubtype) return false;
    if (subtypes) {
        var subtypesArray = asArray(subtypes);
        try {
            for(var subtypesArray_1 = __values(subtypesArray), subtypesArray_1_1 = subtypesArray_1.next(); !subtypesArray_1_1.done; subtypesArray_1_1 = subtypesArray_1.next()){
                var subtype = subtypesArray_1_1.value;
                if (!tryCollectModelTypes(subtype, modelTypes)) return false;
            }
        } catch (e_1_1) {
            e_1 = {
                error: e_1_1
            };
        } finally{
            try {
                if (subtypesArray_1_1 && !subtypesArray_1_1.done && (_a = subtypesArray_1.return)) _a.call(subtypesArray_1);
            } finally{
                if (e_1) throw e_1.error;
            }
        }
    }
    if (type instanceof ModelType) modelTypes.push(type);
    return true;
}
/**
 * @internal
 * @hidden
 */ var MapIdentifierMode;
(function(MapIdentifierMode) {
    MapIdentifierMode[MapIdentifierMode["UNKNOWN"] = 0] = "UNKNOWN";
    MapIdentifierMode[MapIdentifierMode["YES"] = 1] = "YES";
    MapIdentifierMode[MapIdentifierMode["NO"] = 2] = "NO";
})(MapIdentifierMode || (MapIdentifierMode = {}));
var MSTMap = /** @class */ function(_super) {
    __extends(MSTMap, _super);
    function MSTMap(initialData, name) {
        return _super.call(this, initialData, (0, $4f362.observable).ref.enhancer, name) || this;
    }
    Object.defineProperty(MSTMap.prototype, "get", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function(key) {
            // maybe this is over-enthousiastic? normalize numeric keys to strings
            return _super.prototype.get.call(this, "" + key);
        }
    });
    Object.defineProperty(MSTMap.prototype, "has", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function(key) {
            return _super.prototype.has.call(this, "" + key);
        }
    });
    Object.defineProperty(MSTMap.prototype, "delete", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function(key) {
            return _super.prototype.delete.call(this, "" + key);
        }
    });
    Object.defineProperty(MSTMap.prototype, "set", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function(key, value) {
            return _super.prototype.set.call(this, "" + key, value);
        }
    });
    Object.defineProperty(MSTMap.prototype, "put", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function(value) {
            if (!value) throw fail$1("Map.put cannot be used to set empty values");
            if (isStateTreeNode(value)) {
                var node = getStateTreeNode(value);
                if (devMode()) {
                    if (!node.identifierAttribute) throw fail$1(needsIdentifierError);
                }
                if (node.identifier === null) throw fail$1(needsIdentifierError);
                this.set(node.identifier, value);
                return value;
            } else if (!isMutable(value)) throw fail$1("Map.put can only be used to store complex values");
            else {
                var mapNode = getStateTreeNode(this);
                var mapType = mapNode.type;
                if (mapType.identifierMode !== MapIdentifierMode.YES) throw fail$1(needsIdentifierError);
                var idAttr = mapType.mapIdentifierAttribute;
                var id = value[idAttr];
                if (!isValidIdentifier(id)) {
                    // try again but this time after creating a node for the value
                    // since it might be an optional identifier
                    var newNode = this.put(mapType.getChildType().create(value, mapNode.environment));
                    return this.put(getSnapshot(newNode));
                }
                var key = normalizeIdentifier(id);
                this.set(key, value);
                return this.get(key);
            }
        }
    });
    return MSTMap;
}((0, $4f362.ObservableMap));
/**
 * @internal
 * @hidden
 */ var MapType = /** @class */ function(_super) {
    __extends(MapType, _super);
    function MapType(name, _subType, hookInitializers) {
        if (hookInitializers === void 0) hookInitializers = [];
        var _this = _super.call(this, name) || this;
        Object.defineProperty(_this, "_subType", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: _subType
        });
        Object.defineProperty(_this, "identifierMode", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: MapIdentifierMode.UNKNOWN
        });
        Object.defineProperty(_this, "mapIdentifierAttribute", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: undefined
        });
        Object.defineProperty(_this, "flags", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: TypeFlags.Map
        });
        Object.defineProperty(_this, "hookInitializers", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: []
        });
        _this._determineIdentifierMode();
        _this.hookInitializers = hookInitializers;
        return _this;
    }
    Object.defineProperty(MapType.prototype, "hooks", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function(hooks) {
            var hookInitializers = this.hookInitializers.length > 0 ? this.hookInitializers.concat(hooks) : [
                hooks
            ];
            return new MapType(this.name, this._subType, hookInitializers);
        }
    });
    Object.defineProperty(MapType.prototype, "instantiate", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function(parent, subpath, environment, initialValue) {
            this._determineIdentifierMode();
            return createObjectNode(this, parent, subpath, environment, initialValue);
        }
    });
    Object.defineProperty(MapType.prototype, "_determineIdentifierMode", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function() {
            if (this.identifierMode !== MapIdentifierMode.UNKNOWN) return;
            var modelTypes = [];
            if (tryCollectModelTypes(this._subType, modelTypes)) {
                var identifierAttribute = modelTypes.reduce(function(current, type) {
                    if (!type.identifierAttribute) return current;
                    if (current && current !== type.identifierAttribute) throw fail$1("The objects in a map should all have the same identifier attribute, expected '" + current + "', but child of type '" + type.name + "' declared attribute '" + type.identifierAttribute + "' as identifier");
                    return type.identifierAttribute;
                }, undefined);
                if (identifierAttribute) {
                    this.identifierMode = MapIdentifierMode.YES;
                    this.mapIdentifierAttribute = identifierAttribute;
                } else this.identifierMode = MapIdentifierMode.NO;
            }
        }
    });
    Object.defineProperty(MapType.prototype, "initializeChildNodes", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function(objNode, initialSnapshot) {
            if (initialSnapshot === void 0) initialSnapshot = {};
            var subType = objNode.type._subType;
            var result = {};
            Object.keys(initialSnapshot).forEach(function(name) {
                result[name] = subType.instantiate(objNode, name, undefined, initialSnapshot[name]);
            });
            return result;
        }
    });
    Object.defineProperty(MapType.prototype, "createNewInstance", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function(childNodes) {
            return new MSTMap(childNodes, this.name);
        }
    });
    Object.defineProperty(MapType.prototype, "finalizeNewInstance", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function(node, instance) {
            (0, $4f362._interceptReads)(instance, node.unbox);
            var type = node.type;
            type.hookInitializers.forEach(function(initializer) {
                var hooks = initializer(instance);
                Object.keys(hooks).forEach(function(name) {
                    var hook = hooks[name];
                    var actionInvoker = createActionInvoker(instance, name, hook);
                    (!devMode() ? addHiddenFinalProp : addHiddenWritableProp)(instance, name, actionInvoker);
                });
            });
            (0, $4f362.intercept)(instance, this.willChange);
            (0, $4f362.observe)(instance, this.didChange);
        }
    });
    Object.defineProperty(MapType.prototype, "describe", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function() {
            return this.name;
        }
    });
    Object.defineProperty(MapType.prototype, "getChildren", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function(node) {
            // return (node.storedValue as ObservableMap<any>).values()
            return (0, $4f362.values)(node.storedValue);
        }
    });
    Object.defineProperty(MapType.prototype, "getChildNode", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function(node, key) {
            var childNode = node.storedValue.get("" + key);
            if (!childNode) throw fail$1("Not a child " + key);
            return childNode;
        }
    });
    Object.defineProperty(MapType.prototype, "willChange", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function(change) {
            var node = getStateTreeNode(change.object);
            var key = change.name;
            node.assertWritable({
                subpath: key
            });
            var mapType = node.type;
            var subType = mapType._subType;
            switch(change.type){
                case "update":
                    var newValue = change.newValue;
                    var oldValue = change.object.get(key);
                    if (newValue === oldValue) return null;
                    typecheckInternal(subType, newValue);
                    change.newValue = subType.reconcile(node.getChildNode(key), change.newValue, node, key);
                    mapType.processIdentifier(key, change.newValue);
                    break;
                case "add":
                    typecheckInternal(subType, change.newValue);
                    change.newValue = subType.instantiate(node, key, undefined, change.newValue);
                    mapType.processIdentifier(key, change.newValue);
                    break;
            }
            return change;
        }
    });
    Object.defineProperty(MapType.prototype, "processIdentifier", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function(expected, node) {
            if (this.identifierMode === MapIdentifierMode.YES && node instanceof ObjectNode) {
                var identifier = node.identifier;
                if (identifier !== expected) throw fail$1("A map of objects containing an identifier should always store the object under their own identifier. Trying to store key '" + identifier + "', but expected: '" + expected + "'");
            }
        }
    });
    Object.defineProperty(MapType.prototype, "getSnapshot", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function(node) {
            var res = {};
            node.getChildren().forEach(function(childNode) {
                res[childNode.subpath] = childNode.snapshot;
            });
            return res;
        }
    });
    Object.defineProperty(MapType.prototype, "processInitialSnapshot", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function(childNodes) {
            var processed = {};
            Object.keys(childNodes).forEach(function(key) {
                processed[key] = childNodes[key].getSnapshot();
            });
            return processed;
        }
    });
    Object.defineProperty(MapType.prototype, "didChange", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function(change) {
            var node = getStateTreeNode(change.object);
            switch(change.type){
                case "update":
                    return void node.emitPatch({
                        op: "replace",
                        path: escapeJsonPath(change.name),
                        value: change.newValue.snapshot,
                        oldValue: change.oldValue ? change.oldValue.snapshot : undefined
                    }, node);
                case "add":
                    return void node.emitPatch({
                        op: "add",
                        path: escapeJsonPath(change.name),
                        value: change.newValue.snapshot,
                        oldValue: undefined
                    }, node);
                case "delete":
                    // a node got deleted, get the old snapshot and make the node die
                    var oldSnapshot = change.oldValue.snapshot;
                    change.oldValue.die();
                    // emit the patch
                    return void node.emitPatch({
                        op: "remove",
                        path: escapeJsonPath(change.name),
                        oldValue: oldSnapshot
                    }, node);
            }
        }
    });
    Object.defineProperty(MapType.prototype, "applyPatchLocally", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function(node, subpath, patch) {
            var target = node.storedValue;
            switch(patch.op){
                case "add":
                case "replace":
                    target.set(subpath, patch.value);
                    break;
                case "remove":
                    target.delete(subpath);
                    break;
            }
        }
    });
    Object.defineProperty(MapType.prototype, "applySnapshot", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function(node, snapshot) {
            typecheckInternal(this, snapshot);
            var target = node.storedValue;
            var currentKeys = {};
            Array.from(target.keys()).forEach(function(key) {
                currentKeys[key] = false;
            });
            if (snapshot) // Don't use target.replace, as it will throw away all existing items first
            for(var key in snapshot){
                target.set(key, snapshot[key]);
                currentKeys["" + key] = true;
            }
            Object.keys(currentKeys).forEach(function(key) {
                if (currentKeys[key] === false) target.delete(key);
            });
        }
    });
    Object.defineProperty(MapType.prototype, "getChildType", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function() {
            return this._subType;
        }
    });
    Object.defineProperty(MapType.prototype, "isValidSnapshot", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function(value, context) {
            var _this = this;
            if (!isPlainObject(value)) return typeCheckFailure(context, value, "Value is not a plain object");
            return flattenTypeErrors(Object.keys(value).map(function(path) {
                return _this._subType.validate(value[path], getContextForPath(context, path, _this._subType));
            }));
        }
    });
    Object.defineProperty(MapType.prototype, "getDefaultSnapshot", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function() {
            return EMPTY_OBJECT;
        }
    });
    Object.defineProperty(MapType.prototype, "removeChild", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function(node, subpath) {
            node.storedValue.delete(subpath);
        }
    });
    return MapType;
}(ComplexType);
MapType.prototype.applySnapshot = (0, $4f362.action)(MapType.prototype.applySnapshot);
/**
 * `types.map` - Creates a key based collection type who's children are all of a uniform declared type.
 * If the type stored in a map has an identifier, it is mandatory to store the child under that identifier in the map.
 *
 * This type will always produce [observable maps](https://mobx.js.org/api.html#observablemap)
 *
 * Example:
 * ```ts
 * const Todo = types.model({
 *   id: types.identifier,
 *   task: types.string
 * })
 *
 * const TodoStore = types.model({
 *   todos: types.map(Todo)
 * })
 *
 * const s = TodoStore.create({ todos: {} })
 * unprotect(s)
 * s.todos.set(17, { task: "Grab coffee", id: 17 })
 * s.todos.put({ task: "Grab cookie", id: 18 }) // put will infer key from the identifier
 * console.log(s.todos.get(17).task) // prints: "Grab coffee"
 * ```
 *
 * @param subtype
 * @returns
 */ function map(subtype) {
    return new MapType("Map<string, " + subtype.name + ">", subtype);
}
/**
 * Returns if a given value represents a map type.
 *
 * @param type
 * @returns `true` if it is a map type.
 */ function isMapType(type) {
    return isType(type) && (type.flags & TypeFlags.Map) > 0;
}
/**
 * @internal
 * @hidden
 */ var ArrayType = /** @class */ function(_super) {
    __extends(ArrayType, _super);
    function ArrayType(name, _subType, hookInitializers) {
        if (hookInitializers === void 0) hookInitializers = [];
        var _this = _super.call(this, name) || this;
        Object.defineProperty(_this, "_subType", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: _subType
        });
        Object.defineProperty(_this, "flags", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: TypeFlags.Array
        });
        Object.defineProperty(_this, "hookInitializers", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: []
        });
        _this.hookInitializers = hookInitializers;
        return _this;
    }
    Object.defineProperty(ArrayType.prototype, "hooks", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function(hooks) {
            var hookInitializers = this.hookInitializers.length > 0 ? this.hookInitializers.concat(hooks) : [
                hooks
            ];
            return new ArrayType(this.name, this._subType, hookInitializers);
        }
    });
    Object.defineProperty(ArrayType.prototype, "instantiate", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function(parent, subpath, environment, initialValue) {
            return createObjectNode(this, parent, subpath, environment, initialValue);
        }
    });
    Object.defineProperty(ArrayType.prototype, "initializeChildNodes", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function(objNode, snapshot) {
            if (snapshot === void 0) snapshot = [];
            var subType = objNode.type._subType;
            var result = {};
            snapshot.forEach(function(item, index) {
                var subpath = "" + index;
                result[subpath] = subType.instantiate(objNode, subpath, undefined, item);
            });
            return result;
        }
    });
    Object.defineProperty(ArrayType.prototype, "createNewInstance", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function(childNodes) {
            var options = __assign(__assign({}, mobxShallow), {
                name: this.name
            });
            return (0, $4f362.observable).array(convertChildNodesToArray(childNodes), options);
        }
    });
    Object.defineProperty(ArrayType.prototype, "finalizeNewInstance", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function(node, instance) {
            (0, $4f362._getAdministration)(instance).dehancer = node.unbox;
            var type = node.type;
            type.hookInitializers.forEach(function(initializer) {
                var hooks = initializer(instance);
                Object.keys(hooks).forEach(function(name) {
                    var hook = hooks[name];
                    var actionInvoker = createActionInvoker(instance, name, hook);
                    (!devMode() ? addHiddenFinalProp : addHiddenWritableProp)(instance, name, actionInvoker);
                });
            });
            (0, $4f362.intercept)(instance, this.willChange);
            (0, $4f362.observe)(instance, this.didChange);
        }
    });
    Object.defineProperty(ArrayType.prototype, "describe", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function() {
            return this.name;
        }
    });
    Object.defineProperty(ArrayType.prototype, "getChildren", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function(node) {
            return node.storedValue.slice();
        }
    });
    Object.defineProperty(ArrayType.prototype, "getChildNode", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function(node, key) {
            var index = Number(key);
            if (index < node.storedValue.length) return node.storedValue[index];
            throw fail$1("Not a child: " + key);
        }
    });
    Object.defineProperty(ArrayType.prototype, "willChange", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function(change) {
            var node = getStateTreeNode(change.object);
            node.assertWritable({
                subpath: "" + change.index
            });
            var subType = node.type._subType;
            var childNodes = node.getChildren();
            switch(change.type){
                case "update":
                    if (change.newValue === change.object[change.index]) return null;
                    var updatedNodes = reconcileArrayChildren(node, subType, [
                        childNodes[change.index]
                    ], [
                        change.newValue
                    ], [
                        change.index
                    ]);
                    if (!updatedNodes) return null;
                    change.newValue = updatedNodes[0];
                    break;
                case "splice":
                    var index_1 = change.index, removedCount = change.removedCount, added = change.added;
                    var addedNodes = reconcileArrayChildren(node, subType, childNodes.slice(index_1, index_1 + removedCount), added, added.map(function(_, i) {
                        return index_1 + i;
                    }));
                    if (!addedNodes) return null;
                    change.added = addedNodes;
                    // update paths of remaining items
                    for(var i = index_1 + removedCount; i < childNodes.length; i++)childNodes[i].setParent(node, "" + (i + added.length - removedCount));
                    break;
            }
            return change;
        }
    });
    Object.defineProperty(ArrayType.prototype, "getSnapshot", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function(node) {
            return node.getChildren().map(function(childNode) {
                return childNode.snapshot;
            });
        }
    });
    Object.defineProperty(ArrayType.prototype, "processInitialSnapshot", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function(childNodes) {
            var processed = [];
            Object.keys(childNodes).forEach(function(key) {
                processed.push(childNodes[key].getSnapshot());
            });
            return processed;
        }
    });
    Object.defineProperty(ArrayType.prototype, "didChange", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function(change) {
            var node = getStateTreeNode(change.object);
            switch(change.type){
                case "update":
                    return void node.emitPatch({
                        op: "replace",
                        path: "" + change.index,
                        value: change.newValue.snapshot,
                        oldValue: change.oldValue ? change.oldValue.snapshot : undefined
                    }, node);
                case "splice":
                    for(var i = change.removedCount - 1; i >= 0; i--)node.emitPatch({
                        op: "remove",
                        path: "" + (change.index + i),
                        oldValue: change.removed[i].snapshot
                    }, node);
                    for(var i = 0; i < change.addedCount; i++)node.emitPatch({
                        op: "add",
                        path: "" + (change.index + i),
                        value: node.getChildNode("" + (change.index + i)).snapshot,
                        oldValue: undefined
                    }, node);
                    return;
            }
        }
    });
    Object.defineProperty(ArrayType.prototype, "applyPatchLocally", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function(node, subpath, patch) {
            var target = node.storedValue;
            var index = subpath === "-" ? target.length : Number(subpath);
            switch(patch.op){
                case "replace":
                    target[index] = patch.value;
                    break;
                case "add":
                    target.splice(index, 0, patch.value);
                    break;
                case "remove":
                    target.splice(index, 1);
                    break;
            }
        }
    });
    Object.defineProperty(ArrayType.prototype, "applySnapshot", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function(node, snapshot) {
            typecheckInternal(this, snapshot);
            var target = node.storedValue;
            target.replace(snapshot);
        }
    });
    Object.defineProperty(ArrayType.prototype, "getChildType", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function() {
            return this._subType;
        }
    });
    Object.defineProperty(ArrayType.prototype, "isValidSnapshot", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function(value, context) {
            var _this = this;
            if (!isArray(value)) return typeCheckFailure(context, value, "Value is not an array");
            return flattenTypeErrors(value.map(function(item, index) {
                return _this._subType.validate(item, getContextForPath(context, "" + index, _this._subType));
            }));
        }
    });
    Object.defineProperty(ArrayType.prototype, "getDefaultSnapshot", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function() {
            return EMPTY_ARRAY;
        }
    });
    Object.defineProperty(ArrayType.prototype, "removeChild", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function(node, subpath) {
            node.storedValue.splice(Number(subpath), 1);
        }
    });
    return ArrayType;
}(ComplexType);
ArrayType.prototype.applySnapshot = (0, $4f362.action)(ArrayType.prototype.applySnapshot);
/**
 * `types.array` - Creates an index based collection type who's children are all of a uniform declared type.
 *
 * This type will always produce [observable arrays](https://mobx.js.org/api.html#observablearray)
 *
 * Example:
 * ```ts
 * const Todo = types.model({
 *   task: types.string
 * })
 *
 * const TodoStore = types.model({
 *   todos: types.array(Todo)
 * })
 *
 * const s = TodoStore.create({ todos: [] })
 * unprotect(s) // needed to allow modifying outside of an action
 * s.todos.push({ task: "Grab coffee" })
 * console.log(s.todos[0]) // prints: "Grab coffee"
 * ```
 *
 * @param subtype
 * @returns
 */ function array(subtype) {
    assertIsType(subtype, 1);
    return new ArrayType(subtype.name + "[]", subtype);
}
function reconcileArrayChildren(parent, childType, oldNodes, newValues, newPaths) {
    var nothingChanged = true;
    for(var i = 0;; i++){
        var hasNewNode = i <= newValues.length - 1;
        var oldNode = oldNodes[i];
        var newValue = hasNewNode ? newValues[i] : undefined;
        var newPath = "" + newPaths[i];
        // for some reason, instead of newValue we got a node, fallback to the storedValue
        // TODO: https://github.com/mobxjs/mobx-state-tree/issues/340#issuecomment-325581681
        if (isNode(newValue)) newValue = newValue.storedValue;
        if (!oldNode && !hasNewNode) break;
        else if (!hasNewNode) {
            // new one does not exists
            nothingChanged = false;
            oldNodes.splice(i, 1);
            if (oldNode instanceof ObjectNode) // since it is going to be returned by pop/splice/shift better create it before killing it
            // so it doesn't end up in an undead state
            oldNode.createObservableInstanceIfNeeded();
            oldNode.die();
            i--;
        } else if (!oldNode) {
            // there is no old node, create it
            // check if already belongs to the same parent. if so, avoid pushing item in. only swapping can occur.
            if (isStateTreeNode(newValue) && getStateTreeNode(newValue).parent === parent) // this node is owned by this parent, but not in the reconcilable set, so it must be double
            throw fail$1("Cannot add an object to a state tree if it is already part of the same or another state tree. Tried to assign an object to '" + parent.path + "/" + newPath + "', but it lives already at '" + getStateTreeNode(newValue).path + "'");
            nothingChanged = false;
            var newNode = valueAsNode(childType, parent, newPath, newValue);
            oldNodes.splice(i, 0, newNode);
        } else if (areSame(oldNode, newValue)) // both are the same, reconcile
        oldNodes[i] = valueAsNode(childType, parent, newPath, newValue, oldNode);
        else {
            // nothing to do, try to reorder
            var oldMatch = undefined;
            // find a possible candidate to reuse
            for(var j = i; j < oldNodes.length; j++)if (areSame(oldNodes[j], newValue)) {
                oldMatch = oldNodes.splice(j, 1)[0];
                break;
            }
            nothingChanged = false;
            var newNode = valueAsNode(childType, parent, newPath, newValue, oldMatch);
            oldNodes.splice(i, 0, newNode);
        }
    }
    return nothingChanged ? null : oldNodes;
}
/**
 * Convert a value to a node at given parent and subpath. Attempts to reuse old node if possible and given.
 */ function valueAsNode(childType, parent, subpath, newValue, oldNode) {
    // ensure the value is valid-ish
    typecheckInternal(childType, newValue);
    function getNewNode() {
        // the new value has a MST node
        if (isStateTreeNode(newValue)) {
            var childNode = getStateTreeNode(newValue);
            childNode.assertAlive(EMPTY_OBJECT);
            // the node lives here
            if (childNode.parent !== null && childNode.parent === parent) {
                childNode.setParent(parent, subpath);
                return childNode;
            }
        }
        // there is old node and new one is a value/snapshot
        if (oldNode) return childType.reconcile(oldNode, newValue, parent, subpath);
        // nothing to do, create from scratch
        return childType.instantiate(parent, subpath, undefined, newValue);
    }
    var newNode = getNewNode();
    if (oldNode && oldNode !== newNode) {
        if (oldNode instanceof ObjectNode) // since it is going to be returned by pop/splice/shift better create it before killing it
        // so it doesn't end up in an undead state
        oldNode.createObservableInstanceIfNeeded();
        oldNode.die();
    }
    return newNode;
}
/**
 * Check if a node holds a value.
 */ function areSame(oldNode, newValue) {
    // never consider dead old nodes for reconciliation
    if (!oldNode.isAlive) return false;
    // the new value has the same node
    if (isStateTreeNode(newValue)) {
        var newNode = getStateTreeNode(newValue);
        return newNode.isAlive && newNode === oldNode;
    }
    // the provided value is the snapshot of the old node
    if (oldNode.snapshot === newValue) return true;
    // Non object nodes don't get reconciled
    if (!(oldNode instanceof ObjectNode)) return false;
    var oldNodeType = oldNode.getReconciliationType();
    // new value is a snapshot with the correct identifier
    return oldNode.identifier !== null && oldNode.identifierAttribute && isPlainObject(newValue) && oldNodeType.is(newValue) && oldNodeType.isMatchingSnapshotId(oldNode, newValue);
}
/**
 * Returns if a given value represents an array type.
 *
 * @param type
 * @returns `true` if the type is an array type.
 */ function isArrayType(type) {
    return isType(type) && (type.flags & TypeFlags.Array) > 0;
}
var PRE_PROCESS_SNAPSHOT = "preProcessSnapshot";
var POST_PROCESS_SNAPSHOT = "postProcessSnapshot";
function objectTypeToString() {
    return getStateTreeNode(this).toString();
}
var defaultObjectOptions = {
    name: "AnonymousModel",
    properties: {},
    initializers: EMPTY_ARRAY
};
function toPropertiesObject(declaredProps) {
    var keysList = Object.keys(declaredProps);
    var alreadySeenKeys = new Set();
    keysList.forEach(function(key) {
        if (alreadySeenKeys.has(key)) throw fail$1(key + " is declared twice in the model. Model should not contain the same keys");
        alreadySeenKeys.add(key);
    });
    // loop through properties and ensures that all items are types
    return keysList.reduce(function(props, key) {
        // warn if user intended a HOOK
        if (key in Hook) throw fail$1("Hook '" + key + "' was defined as property. Hooks should be defined as part of the actions");
        // the user intended to use a view
        var descriptor = Object.getOwnPropertyDescriptor(declaredProps, key);
        if ("get" in descriptor) throw fail$1("Getters are not supported as properties. Please use views instead");
        // undefined and null are not valid
        var value = descriptor.value;
        if (value === null || value === undefined) throw fail$1("The default value of an attribute cannot be null or undefined as the type cannot be inferred. Did you mean `types.maybe(someType)`?");
        else if (isPrimitive(value)) props[key] = optional(getPrimitiveFactoryFromValue(value), value);
        else if (value instanceof MapType) props[key] = optional(value, {});
        else if (value instanceof ArrayType) props[key] = optional(value, []);
        else if (isType(value)) ;
        else if (devMode() && typeof value === "function") throw fail$1("Invalid type definition for property '" + key + "', it looks like you passed a function. Did you forget to invoke it, or did you intend to declare a view / action?");
        else if (devMode() && typeof value === "object") throw fail$1("Invalid type definition for property '" + key + "', it looks like you passed an object. Try passing another model type or a types.frozen.");
        else throw fail$1("Invalid type definition for property '" + key + "', cannot infer a type from a value like '" + value + "' (" + typeof value + ")");
        return props;
    }, declaredProps);
}
/**
 * @internal
 * @hidden
 */ var ModelType = /** @class */ function(_super) {
    __extends(ModelType, _super);
    function ModelType(opts) {
        var _this = _super.call(this, opts.name || defaultObjectOptions.name) || this;
        Object.defineProperty(_this, "flags", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: TypeFlags.Object
        });
        /*
         * The original object definition
         */ Object.defineProperty(_this, "initializers", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(_this, "properties", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(_this, "preProcessor", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(_this, "postProcessor", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(_this, "propertyNames", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(_this, "named", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: function(name) {
                return _this.cloneAndEnhance({
                    name: name
                });
            }
        });
        Object.defineProperty(_this, "props", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: function(properties) {
                return _this.cloneAndEnhance({
                    properties: properties
                });
            }
        });
        Object.defineProperty(_this, "preProcessSnapshot", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: function(preProcessor) {
                var currentPreprocessor = _this.preProcessor;
                if (!currentPreprocessor) return _this.cloneAndEnhance({
                    preProcessor: preProcessor
                });
                else return _this.cloneAndEnhance({
                    preProcessor: function(snapshot) {
                        return currentPreprocessor(preProcessor(snapshot));
                    }
                });
            }
        });
        Object.defineProperty(_this, "postProcessSnapshot", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: function(postProcessor) {
                var currentPostprocessor = _this.postProcessor;
                if (!currentPostprocessor) return _this.cloneAndEnhance({
                    postProcessor: postProcessor
                });
                else return _this.cloneAndEnhance({
                    postProcessor: function(snapshot) {
                        return postProcessor(currentPostprocessor(snapshot));
                    }
                });
            }
        });
        Object.assign(_this, defaultObjectOptions, opts);
        // ensures that any default value gets converted to its related type
        _this.properties = toPropertiesObject(_this.properties);
        freeze(_this.properties); // make sure nobody messes with it
        _this.propertyNames = Object.keys(_this.properties);
        _this.identifierAttribute = _this._getIdentifierAttribute();
        return _this;
    }
    Object.defineProperty(ModelType.prototype, "_getIdentifierAttribute", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function() {
            var identifierAttribute = undefined;
            this.forAllProps(function(propName, propType) {
                if (propType.flags & TypeFlags.Identifier) {
                    if (identifierAttribute) throw fail$1("Cannot define property '" + propName + "' as object identifier, property '" + identifierAttribute + "' is already defined as identifier property");
                    identifierAttribute = propName;
                }
            });
            return identifierAttribute;
        }
    });
    Object.defineProperty(ModelType.prototype, "cloneAndEnhance", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function(opts) {
            return new ModelType({
                name: opts.name || this.name,
                properties: Object.assign({}, this.properties, opts.properties),
                initializers: this.initializers.concat(opts.initializers || []),
                preProcessor: opts.preProcessor || this.preProcessor,
                postProcessor: opts.postProcessor || this.postProcessor
            });
        }
    });
    Object.defineProperty(ModelType.prototype, "actions", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function(fn) {
            var _this = this;
            var actionInitializer = function(self) {
                _this.instantiateActions(self, fn(self));
                return self;
            };
            return this.cloneAndEnhance({
                initializers: [
                    actionInitializer
                ]
            });
        }
    });
    Object.defineProperty(ModelType.prototype, "instantiateActions", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function(self, actions) {
            // check if return is correct
            if (!isPlainObject(actions)) throw fail$1("actions initializer should return a plain object containing actions");
            // bind actions to the object created
            Object.keys(actions).forEach(function(name) {
                // warn if preprocessor was given
                if (name === PRE_PROCESS_SNAPSHOT) throw fail$1("Cannot define action '" + PRE_PROCESS_SNAPSHOT + "', it should be defined using 'type.preProcessSnapshot(fn)' instead");
                // warn if postprocessor was given
                if (name === POST_PROCESS_SNAPSHOT) throw fail$1("Cannot define action '" + POST_PROCESS_SNAPSHOT + "', it should be defined using 'type.postProcessSnapshot(fn)' instead");
                var action2 = actions[name];
                // apply hook composition
                var baseAction = self[name];
                if (name in Hook && baseAction) {
                    var specializedAction_1 = action2;
                    action2 = function() {
                        baseAction.apply(null, arguments);
                        specializedAction_1.apply(null, arguments);
                    };
                }
                // the goal of this is to make sure actions using "this" can call themselves,
                // while still allowing the middlewares to register them
                var middlewares = action2.$mst_middleware; // make sure middlewares are not lost
                var boundAction = action2.bind(actions);
                boundAction._isFlowAction = action2._isFlowAction || false;
                boundAction.$mst_middleware = middlewares;
                var actionInvoker = createActionInvoker(self, name, boundAction);
                actions[name] = actionInvoker;
                (!devMode() ? addHiddenFinalProp : addHiddenWritableProp)(self, name, actionInvoker);
            });
        }
    });
    Object.defineProperty(ModelType.prototype, "volatile", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function(fn) {
            var _this = this;
            if (typeof fn !== "function") throw fail$1("You passed an " + typeof fn + " to volatile state as an argument, when function is expected");
            var stateInitializer = function(self) {
                _this.instantiateVolatileState(self, fn(self));
                return self;
            };
            return this.cloneAndEnhance({
                initializers: [
                    stateInitializer
                ]
            });
        }
    });
    Object.defineProperty(ModelType.prototype, "instantiateVolatileState", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function(self, state) {
            // check views return
            if (!isPlainObject(state)) throw fail$1("volatile state initializer should return a plain object containing state");
            (0, $4f362.set)(self, state);
        }
    });
    Object.defineProperty(ModelType.prototype, "extend", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function(fn) {
            var _this = this;
            var initializer = function(self) {
                var _a = fn(self), actions = _a.actions, views = _a.views, state = _a.state, rest = __rest(_a, [
                    "actions",
                    "views",
                    "state"
                ]);
                for(var key in rest)throw fail$1("The `extend` function should return an object with a subset of the fields 'actions', 'views' and 'state'. Found invalid key '" + key + "'");
                if (state) _this.instantiateVolatileState(self, state);
                if (views) _this.instantiateViews(self, views);
                if (actions) _this.instantiateActions(self, actions);
                return self;
            };
            return this.cloneAndEnhance({
                initializers: [
                    initializer
                ]
            });
        }
    });
    Object.defineProperty(ModelType.prototype, "views", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function(fn) {
            var _this = this;
            var viewInitializer = function(self) {
                _this.instantiateViews(self, fn(self));
                return self;
            };
            return this.cloneAndEnhance({
                initializers: [
                    viewInitializer
                ]
            });
        }
    });
    Object.defineProperty(ModelType.prototype, "instantiateViews", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function(self, views) {
            // check views return
            if (!isPlainObject(views)) throw fail$1("views initializer should return a plain object containing views");
            Object.getOwnPropertyNames(views).forEach(function(key) {
                var _a;
                // is this a computed property?
                var descriptor = Object.getOwnPropertyDescriptor(views, key);
                if ("get" in descriptor) {
                    (0, $4f362.defineProperty)(self, key, descriptor);
                    (0, $4f362.makeObservable)(self, (_a = {}, _a[key] = (0, $4f362.computed), _a));
                } else if (typeof descriptor.value === "function") (!devMode() ? addHiddenFinalProp : addHiddenWritableProp)(self, key, descriptor.value);
                else throw fail$1("A view member should either be a function or getter based property");
            });
        }
    });
    Object.defineProperty(ModelType.prototype, "instantiate", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function(parent, subpath, environment, initialValue) {
            var value = isStateTreeNode(initialValue) ? initialValue : this.applySnapshotPreProcessor(initialValue);
            return createObjectNode(this, parent, subpath, environment, value);
        // Optimization: record all prop- view- and action names after first construction, and generate an optimal base class
        // that pre-reserves all these fields for fast object-member lookups
        }
    });
    Object.defineProperty(ModelType.prototype, "initializeChildNodes", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function(objNode, initialSnapshot) {
            if (initialSnapshot === void 0) initialSnapshot = {};
            var type = objNode.type;
            var result = {};
            type.forAllProps(function(name, childType) {
                result[name] = childType.instantiate(objNode, name, undefined, initialSnapshot[name]);
            });
            return result;
        }
    });
    Object.defineProperty(ModelType.prototype, "createNewInstance", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function(childNodes) {
            var options = __assign(__assign({}, mobxShallow), {
                name: this.name
            });
            return (0, $4f362.observable).object(childNodes, EMPTY_OBJECT, options);
        }
    });
    Object.defineProperty(ModelType.prototype, "finalizeNewInstance", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function(node, instance) {
            addHiddenFinalProp(instance, "toString", objectTypeToString);
            this.forAllProps(function(name) {
                (0, $4f362._interceptReads)(instance, name, node.unbox);
            });
            this.initializers.reduce(function(self, fn) {
                return fn(self);
            }, instance);
            (0, $4f362.intercept)(instance, this.willChange);
            (0, $4f362.observe)(instance, this.didChange);
        }
    });
    Object.defineProperty(ModelType.prototype, "willChange", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function(chg) {
            // TODO: mobx typings don't seem to take into account that newValue can be set even when removing a prop
            var change = chg;
            var node = getStateTreeNode(change.object);
            var subpath = change.name;
            node.assertWritable({
                subpath: subpath
            });
            var childType = node.type.properties[subpath];
            // only properties are typed, state are stored as-is references
            if (childType) {
                typecheckInternal(childType, change.newValue);
                change.newValue = childType.reconcile(node.getChildNode(subpath), change.newValue, node, subpath);
            }
            return change;
        }
    });
    Object.defineProperty(ModelType.prototype, "didChange", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function(chg) {
            // TODO: mobx typings don't seem to take into account that newValue can be set even when removing a prop
            var change = chg;
            var childNode = getStateTreeNode(change.object);
            var childType = childNode.type.properties[change.name];
            if (!childType) // don't emit patches for volatile state
            return;
            var oldChildValue = change.oldValue ? change.oldValue.snapshot : undefined;
            childNode.emitPatch({
                op: "replace",
                path: escapeJsonPath(change.name),
                value: change.newValue.snapshot,
                oldValue: oldChildValue
            }, childNode);
        }
    });
    Object.defineProperty(ModelType.prototype, "getChildren", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function(node) {
            var _this = this;
            var res = [];
            this.forAllProps(function(name) {
                res.push(_this.getChildNode(node, name));
            });
            return res;
        }
    });
    Object.defineProperty(ModelType.prototype, "getChildNode", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function(node, key) {
            var _a;
            if (!(key in this.properties)) throw fail$1("Not a value property: " + key);
            var adm = (0, $4f362._getAdministration)(node.storedValue, key);
            var childNode = (_a = adm.raw) === null || _a === void 0 ? void 0 : _a.call(adm);
            if (!childNode) throw fail$1("Node not available for property " + key);
            return childNode;
        }
    });
    Object.defineProperty(ModelType.prototype, "getSnapshot", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function(node, applyPostProcess) {
            var _this = this;
            if (applyPostProcess === void 0) applyPostProcess = true;
            var res = {};
            this.forAllProps(function(name, type) {
                try {
                    // TODO: FIXME, make sure the observable ref is used!
                    var atom = (0, $4f362.getAtom)(node.storedValue, name);
                    atom.reportObserved();
                } catch (e) {
                    throw fail$1(name + " property is declared twice");
                }
                res[name] = _this.getChildNode(node, name).snapshot;
            });
            if (applyPostProcess) return this.applySnapshotPostProcessor(res);
            return res;
        }
    });
    Object.defineProperty(ModelType.prototype, "processInitialSnapshot", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function(childNodes) {
            var processed = {};
            Object.keys(childNodes).forEach(function(key) {
                processed[key] = childNodes[key].getSnapshot();
            });
            return this.applySnapshotPostProcessor(processed);
        }
    });
    Object.defineProperty(ModelType.prototype, "applyPatchLocally", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function(node, subpath, patch) {
            if (!(patch.op === "replace" || patch.op === "add")) throw fail$1("object does not support operation " + patch.op);
            node.storedValue[subpath] = patch.value;
        }
    });
    Object.defineProperty(ModelType.prototype, "applySnapshot", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function(node, snapshot) {
            typecheckInternal(this, snapshot);
            var preProcessedSnapshot = this.applySnapshotPreProcessor(snapshot);
            this.forAllProps(function(name) {
                node.storedValue[name] = preProcessedSnapshot[name];
            });
        }
    });
    Object.defineProperty(ModelType.prototype, "applySnapshotPreProcessor", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function(snapshot) {
            var processor = this.preProcessor;
            return processor ? processor.call(null, snapshot) : snapshot;
        }
    });
    Object.defineProperty(ModelType.prototype, "applySnapshotPostProcessor", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function(snapshot) {
            var postProcessor = this.postProcessor;
            if (postProcessor) return postProcessor.call(null, snapshot);
            return snapshot;
        }
    });
    Object.defineProperty(ModelType.prototype, "getChildType", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function(propertyName) {
            assertIsString(propertyName, 1);
            return this.properties[propertyName];
        }
    });
    Object.defineProperty(ModelType.prototype, "isValidSnapshot", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function(value, context) {
            var _this = this;
            var snapshot = this.applySnapshotPreProcessor(value);
            if (!isPlainObject(snapshot)) return typeCheckFailure(context, snapshot, "Value is not a plain object");
            return flattenTypeErrors(this.propertyNames.map(function(key) {
                return _this.properties[key].validate(snapshot[key], getContextForPath(context, key, _this.properties[key]));
            }));
        }
    });
    Object.defineProperty(ModelType.prototype, "forAllProps", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function(fn) {
            var _this = this;
            this.propertyNames.forEach(function(key) {
                return fn(key, _this.properties[key]);
            });
        }
    });
    Object.defineProperty(ModelType.prototype, "describe", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function() {
            var _this = this;
            // optimization: cache
            return "{ " + this.propertyNames.map(function(key) {
                return key + ": " + _this.properties[key].describe();
            }).join("; ") + " }";
        }
    });
    Object.defineProperty(ModelType.prototype, "getDefaultSnapshot", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function() {
            return EMPTY_OBJECT;
        }
    });
    Object.defineProperty(ModelType.prototype, "removeChild", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function(node, subpath) {
            node.storedValue[subpath] = undefined;
        }
    });
    return ModelType;
}(ComplexType);
ModelType.prototype.applySnapshot = (0, $4f362.action)(ModelType.prototype.applySnapshot);
/**
 * `types.model` - Creates a new model type by providing a name, properties, volatile state and actions.
 *
 * See the [model type](/concepts/trees#creating-models) description or the [getting started](intro/getting-started.md#getting-started-1) tutorial.
 */ function model() {
    var args = [];
    for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
    if (devMode() && typeof args[0] !== "string" && args[1]) throw fail$1("Model creation failed. First argument must be a string when two arguments are provided");
    var name = typeof args[0] === "string" ? args.shift() : "AnonymousModel";
    var properties = args.shift() || {};
    return new ModelType({
        name: name,
        properties: properties
    });
}
/**
 * `types.compose` - Composes a new model from one or more existing model types.
 * This method can be invoked in two forms:
 * Given 2 or more model types, the types are composed into a new Type.
 * Given first parameter as a string and 2 or more model types,
 * the types are composed into a new Type with the given name
 */ function compose() {
    var args = [];
    for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
    // TODO: just join the base type names if no name is provided
    var hasTypename = typeof args[0] === "string";
    var typeName = hasTypename ? args[0] : "AnonymousModel";
    if (hasTypename) args.shift();
    // check all parameters
    if (devMode()) args.forEach(function(type, i) {
        assertArg(type, isModelType, "mobx-state-tree model type", hasTypename ? i + 2 : i + 1);
    });
    return args.reduce(function(prev, cur) {
        return prev.cloneAndEnhance({
            name: prev.name + "_" + cur.name,
            properties: cur.properties,
            initializers: cur.initializers,
            preProcessor: function(snapshot) {
                return cur.applySnapshotPreProcessor(prev.applySnapshotPreProcessor(snapshot));
            },
            postProcessor: function(snapshot) {
                return cur.applySnapshotPostProcessor(prev.applySnapshotPostProcessor(snapshot));
            }
        });
    }).named(typeName);
}
/**
 * Returns if a given value represents a model type.
 *
 * @param type
 * @returns
 */ function isModelType(type) {
    return isType(type) && (type.flags & TypeFlags.Object) > 0;
}
// TODO: implement CoreType using types.custom ?
/**
 * @internal
 * @hidden
 */ var CoreType = /** @class */ function(_super) {
    __extends(CoreType, _super);
    function CoreType(name, flags, checker, initializer) {
        if (initializer === void 0) initializer = identity;
        var _this = _super.call(this, name) || this;
        Object.defineProperty(_this, "flags", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: flags
        });
        Object.defineProperty(_this, "checker", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: checker
        });
        Object.defineProperty(_this, "initializer", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: initializer
        });
        _this.flags = flags;
        return _this;
    }
    Object.defineProperty(CoreType.prototype, "describe", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function() {
            return this.name;
        }
    });
    Object.defineProperty(CoreType.prototype, "instantiate", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function(parent, subpath, environment, initialValue) {
            return createScalarNode(this, parent, subpath, environment, initialValue);
        }
    });
    Object.defineProperty(CoreType.prototype, "createNewInstance", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function(snapshot) {
            return this.initializer(snapshot);
        }
    });
    Object.defineProperty(CoreType.prototype, "isValidSnapshot", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function(value, context) {
            if (isPrimitive(value) && this.checker(value)) return typeCheckSuccess();
            var typeName = this.name === "Date" ? "Date or a unix milliseconds timestamp" : this.name;
            return typeCheckFailure(context, value, "Value is not a " + typeName);
        }
    });
    return CoreType;
}(SimpleType);
/**
 * `types.string` - Creates a type that can only contain a string value.
 * This type is used for string values by default
 *
 * Example:
 * ```ts
 * const Person = types.model({
 *   firstName: types.string,
 *   lastName: "Doe"
 * })
 * ```
 */ // tslint:disable-next-line:variable-name
var string = new CoreType("string", TypeFlags.String, function(v) {
    return typeof v === "string";
});
/**
 * `types.number` - Creates a type that can only contain a numeric value.
 * This type is used for numeric values by default
 *
 * Example:
 * ```ts
 * const Vector = types.model({
 *   x: types.number,
 *   y: 1.5
 * })
 * ```
 */ // tslint:disable-next-line:variable-name
var number = new CoreType("number", TypeFlags.Number, function(v) {
    return typeof v === "number";
});
/**
 * `types.integer` - Creates a type that can only contain an integer value.
 *
 * Example:
 * ```ts
 * const Size = types.model({
 *   width: types.integer,
 *   height: 10
 * })
 * ```
 */ // tslint:disable-next-line:variable-name
var integer = new CoreType("integer", TypeFlags.Integer, function(v) {
    return isInteger(v);
});
/**
 * `types.float` - Creates a type that can only contain an float value.
 *
 * Example:
 * ```ts
 * const Size = types.model({
 *   width: types.float,
 *   height: 10
 * })
 * ```
 */ // tslint:disable-next-line:variable-name
var float = new CoreType("float", TypeFlags.Float, function(v) {
    return isFloat(v);
});
/**
 * `types.finite` - Creates a type that can only contain an finite value.
 *
 * Example:
 * ```ts
 * const Size = types.model({
 *   width: types.finite,
 *   height: 10
 * })
 * ```
 */ // tslint:disable-next-line:variable-name
var finite = new CoreType("finite", TypeFlags.Finite, function(v) {
    return isFinite(v);
});
/**
 * `types.boolean` - Creates a type that can only contain a boolean value.
 * This type is used for boolean values by default
 *
 * Example:
 * ```ts
 * const Thing = types.model({
 *   isCool: types.boolean,
 *   isAwesome: false
 * })
 * ```
 */ // tslint:disable-next-line:variable-name
var boolean = new CoreType("boolean", TypeFlags.Boolean, function(v) {
    return typeof v === "boolean";
});
/**
 * `types.null` - The type of the value `null`
 */ var nullType = new CoreType("null", TypeFlags.Null, function(v) {
    return v === null;
});
/**
 * `types.undefined` - The type of the value `undefined`
 */ var undefinedType = new CoreType("undefined", TypeFlags.Undefined, function(v) {
    return v === undefined;
});
var _DatePrimitive = new CoreType("Date", TypeFlags.Date, function(v) {
    return typeof v === "number" || v instanceof Date;
}, function(v) {
    return v instanceof Date ? v : new Date(v);
});
_DatePrimitive.getSnapshot = function(node) {
    return node.storedValue.getTime();
};
/**
 * `types.Date` - Creates a type that can only contain a javascript Date value.
 *
 * Example:
 * ```ts
 * const LogLine = types.model({
 *   timestamp: types.Date,
 * })
 *
 * LogLine.create({ timestamp: new Date() })
 * ```
 */ var DatePrimitive = _DatePrimitive;
/**
 * @internal
 * @hidden
 */ function getPrimitiveFactoryFromValue(value) {
    switch(typeof value){
        case "string":
            return string;
        case "number":
            return number; // In the future, isInteger(value) ? integer : number would be interesting, but would be too breaking for now
        case "boolean":
            return boolean;
        case "object":
            if (value instanceof Date) return DatePrimitive;
    }
    throw fail$1("Cannot determine primitive type from value " + value);
}
/**
 * Returns if a given value represents a primitive type.
 *
 * @param type
 * @returns
 */ function isPrimitiveType(type) {
    return isType(type) && (type.flags & (TypeFlags.String | TypeFlags.Number | TypeFlags.Integer | TypeFlags.Boolean | TypeFlags.Date)) > 0;
}
/**
 * @internal
 * @hidden
 */ var Literal = /** @class */ function(_super) {
    __extends(Literal, _super);
    function Literal(value) {
        var _this = _super.call(this, JSON.stringify(value)) || this;
        Object.defineProperty(_this, "value", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(_this, "flags", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: TypeFlags.Literal
        });
        _this.value = value;
        return _this;
    }
    Object.defineProperty(Literal.prototype, "instantiate", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function(parent, subpath, environment, initialValue) {
            return createScalarNode(this, parent, subpath, environment, initialValue);
        }
    });
    Object.defineProperty(Literal.prototype, "describe", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function() {
            return JSON.stringify(this.value);
        }
    });
    Object.defineProperty(Literal.prototype, "isValidSnapshot", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function(value, context) {
            if (isPrimitive(value) && value === this.value) return typeCheckSuccess();
            return typeCheckFailure(context, value, "Value is not a literal " + JSON.stringify(this.value));
        }
    });
    return Literal;
}(SimpleType);
/**
 * `types.literal` - The literal type will return a type that will match only the exact given type.
 * The given value must be a primitive, in order to be serialized to a snapshot correctly.
 * You can use literal to match exact strings for example the exact male or female string.
 *
 * Example:
 * ```ts
 * const Person = types.model({
 *     name: types.string,
 *     gender: types.union(types.literal('male'), types.literal('female'))
 * })
 * ```
 *
 * @param value The value to use in the strict equal check
 * @returns
 */ function literal(value) {
    // check that the given value is a primitive
    assertArg(value, isPrimitive, "primitive", 1);
    return new Literal(value);
}
/**
 * Returns if a given value represents a literal type.
 *
 * @param type
 * @returns
 */ function isLiteralType(type) {
    return isType(type) && (type.flags & TypeFlags.Literal) > 0;
}
var Refinement = /** @class */ function(_super) {
    __extends(Refinement, _super);
    function Refinement(name, _subtype, _predicate, _message) {
        var _this = _super.call(this, name) || this;
        Object.defineProperty(_this, "_subtype", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: _subtype
        });
        Object.defineProperty(_this, "_predicate", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: _predicate
        });
        Object.defineProperty(_this, "_message", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: _message
        });
        return _this;
    }
    Object.defineProperty(Refinement.prototype, "flags", {
        get: function() {
            return this._subtype.flags | TypeFlags.Refinement;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Refinement.prototype, "describe", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function() {
            return this.name;
        }
    });
    Object.defineProperty(Refinement.prototype, "instantiate", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function(parent, subpath, environment, initialValue) {
            // create the child type
            return this._subtype.instantiate(parent, subpath, environment, initialValue);
        }
    });
    Object.defineProperty(Refinement.prototype, "isAssignableFrom", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function(type) {
            return this._subtype.isAssignableFrom(type);
        }
    });
    Object.defineProperty(Refinement.prototype, "isValidSnapshot", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function(value, context) {
            var subtypeErrors = this._subtype.validate(value, context);
            if (subtypeErrors.length > 0) return subtypeErrors;
            var snapshot = isStateTreeNode(value) ? getStateTreeNode(value).snapshot : value;
            if (!this._predicate(snapshot)) return typeCheckFailure(context, value, this._message(value));
            return typeCheckSuccess();
        }
    });
    Object.defineProperty(Refinement.prototype, "reconcile", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function(current, newValue, parent, subpath) {
            return this._subtype.reconcile(current, newValue, parent, subpath);
        }
    });
    Object.defineProperty(Refinement.prototype, "getSubTypes", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function() {
            return this._subtype;
        }
    });
    return Refinement;
}(BaseType);
/**
 * `types.refinement` - Creates a type that is more specific than the base type, e.g. `types.refinement(types.string, value => value.length > 5)` to create a type of strings that can only be longer then 5.
 *
 * @param name
 * @param type
 * @param predicate
 * @returns
 */ function refinement() {
    var args = [];
    for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
    var name = typeof args[0] === "string" ? args.shift() : isType(args[0]) ? args[0].name : null;
    var type = args[0];
    var predicate = args[1];
    var message = args[2] ? args[2] : function(v) {
        return "Value does not respect the refinement predicate";
    };
    // ensures all parameters are correct
    assertIsType(type, [
        1,
        2
    ]);
    assertIsString(name, 1);
    assertIsFunction(predicate, [
        2,
        3
    ]);
    assertIsFunction(message, [
        3,
        4
    ]);
    return new Refinement(name, type, predicate, message);
}
/**
 * Returns if a given value is a refinement type.
 *
 * @param type
 * @returns
 */ function isRefinementType(type) {
    return (type.flags & TypeFlags.Refinement) > 0;
}
/**
 * `types.enumeration` - Can be used to create an string based enumeration.
 * (note: this methods is just sugar for a union of string literals)
 *
 * Example:
 * ```ts
 * const TrafficLight = types.model({
 *   color: types.enumeration("Color", ["Red", "Orange", "Green"])
 * })
 * ```
 *
 * @param name descriptive name of the enumeration (optional)
 * @param options possible values this enumeration can have
 * @returns
 */ function enumeration(name, options) {
    var realOptions = typeof name === "string" ? options : name;
    // check all options
    if (devMode()) realOptions.forEach(function(option, i) {
        assertIsString(option, i + 1);
    });
    var type = union.apply(void 0, __spread(realOptions.map(function(option) {
        return literal("" + option);
    })));
    if (typeof name === "string") type.name = name;
    return type;
}
/**
 * @internal
 * @hidden
 */ var Union = /** @class */ function(_super) {
    __extends(Union, _super);
    function Union(name, _types, options) {
        var _this = _super.call(this, name) || this;
        Object.defineProperty(_this, "_types", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: _types
        });
        Object.defineProperty(_this, "_dispatcher", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(_this, "_eager", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: true
        });
        options = __assign({
            eager: true,
            dispatcher: undefined
        }, options);
        _this._dispatcher = options.dispatcher;
        if (!options.eager) _this._eager = false;
        return _this;
    }
    Object.defineProperty(Union.prototype, "flags", {
        get: function() {
            var result = TypeFlags.Union;
            this._types.forEach(function(type) {
                result |= type.flags;
            });
            return result;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Union.prototype, "isAssignableFrom", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function(type) {
            return this._types.some(function(subType) {
                return subType.isAssignableFrom(type);
            });
        }
    });
    Object.defineProperty(Union.prototype, "describe", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function() {
            return "(" + this._types.map(function(factory) {
                return factory.describe();
            }).join(" | ") + ")";
        }
    });
    Object.defineProperty(Union.prototype, "instantiate", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function(parent, subpath, environment, initialValue) {
            var type = this.determineType(initialValue, undefined);
            if (!type) throw fail$1("No matching type for union " + this.describe()); // can happen in prod builds
            return type.instantiate(parent, subpath, environment, initialValue);
        }
    });
    Object.defineProperty(Union.prototype, "reconcile", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function(current, newValue, parent, subpath) {
            var type = this.determineType(newValue, current.getReconciliationType());
            if (!type) throw fail$1("No matching type for union " + this.describe()); // can happen in prod builds
            return type.reconcile(current, newValue, parent, subpath);
        }
    });
    Object.defineProperty(Union.prototype, "determineType", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function(value, reconcileCurrentType) {
            // try the dispatcher, if defined
            if (this._dispatcher) return this._dispatcher(value);
            // find the most accomodating type
            // if we are using reconciliation try the current node type first (fix for #1045)
            if (reconcileCurrentType) {
                if (reconcileCurrentType.is(value)) return reconcileCurrentType;
                return this._types.filter(function(t) {
                    return t !== reconcileCurrentType;
                }).find(function(type) {
                    return type.is(value);
                });
            } else return this._types.find(function(type) {
                return type.is(value);
            });
        }
    });
    Object.defineProperty(Union.prototype, "isValidSnapshot", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function(value, context) {
            if (this._dispatcher) return this._dispatcher(value).validate(value, context);
            var allErrors = [];
            var applicableTypes = 0;
            for(var i = 0; i < this._types.length; i++){
                var type = this._types[i];
                var errors = type.validate(value, context);
                if (errors.length === 0) {
                    if (this._eager) return typeCheckSuccess();
                    else applicableTypes++;
                } else allErrors.push(errors);
            }
            if (applicableTypes === 1) return typeCheckSuccess();
            return typeCheckFailure(context, value, "No type is applicable for the union").concat(flattenTypeErrors(allErrors));
        }
    });
    Object.defineProperty(Union.prototype, "getSubTypes", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function() {
            return this._types;
        }
    });
    return Union;
}(BaseType);
/**
 * `types.union` - Create a union of multiple types. If the correct type cannot be inferred unambiguously from a snapshot, provide a dispatcher function of the form `(snapshot) => Type`.
 *
 * @param optionsOrType
 * @param otherTypes
 * @returns
 */ function union(optionsOrType) {
    var otherTypes = [];
    for(var _i = 1; _i < arguments.length; _i++)otherTypes[_i - 1] = arguments[_i];
    var options = isType(optionsOrType) ? undefined : optionsOrType;
    var types = isType(optionsOrType) ? __spread([
        optionsOrType
    ], otherTypes) : otherTypes;
    var name = "(" + types.map(function(type) {
        return type.name;
    }).join(" | ") + ")";
    // check all options
    if (devMode()) {
        if (options) assertArg(options, function(o) {
            return isPlainObject(o);
        }, "object { eager?: boolean, dispatcher?: Function }", 1);
        types.forEach(function(type, i) {
            assertIsType(type, options ? i + 2 : i + 1);
        });
    }
    return new Union(name, types, options);
}
/**
 * Returns if a given value represents a union type.
 *
 * @param type
 * @returns
 */ function isUnionType(type) {
    return (type.flags & TypeFlags.Union) > 0;
}
/**
 * @hidden
 * @internal
 */ var OptionalValue = /** @class */ function(_super) {
    __extends(OptionalValue, _super);
    function OptionalValue(_subtype, _defaultValue, optionalValues) {
        var _this = _super.call(this, _subtype.name) || this;
        Object.defineProperty(_this, "_subtype", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: _subtype
        });
        Object.defineProperty(_this, "_defaultValue", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: _defaultValue
        });
        Object.defineProperty(_this, "optionalValues", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: optionalValues
        });
        return _this;
    }
    Object.defineProperty(OptionalValue.prototype, "flags", {
        get: function() {
            return this._subtype.flags | TypeFlags.Optional;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(OptionalValue.prototype, "describe", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function() {
            return this._subtype.describe() + "?";
        }
    });
    Object.defineProperty(OptionalValue.prototype, "instantiate", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function(parent, subpath, environment, initialValue) {
            if (this.optionalValues.indexOf(initialValue) >= 0) {
                var defaultInstanceOrSnapshot = this.getDefaultInstanceOrSnapshot();
                return this._subtype.instantiate(parent, subpath, environment, defaultInstanceOrSnapshot);
            }
            return this._subtype.instantiate(parent, subpath, environment, initialValue);
        }
    });
    Object.defineProperty(OptionalValue.prototype, "reconcile", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function(current, newValue, parent, subpath) {
            return this._subtype.reconcile(current, this.optionalValues.indexOf(newValue) < 0 && this._subtype.is(newValue) ? newValue : this.getDefaultInstanceOrSnapshot(), parent, subpath);
        }
    });
    Object.defineProperty(OptionalValue.prototype, "getDefaultInstanceOrSnapshot", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function() {
            var defaultInstanceOrSnapshot = typeof this._defaultValue === "function" ? this._defaultValue() : this._defaultValue;
            // while static values are already snapshots and checked on types.optional
            // generator functions must always be rechecked just in case
            if (typeof this._defaultValue === "function") typecheckInternal(this, defaultInstanceOrSnapshot);
            return defaultInstanceOrSnapshot;
        }
    });
    Object.defineProperty(OptionalValue.prototype, "isValidSnapshot", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function(value, context) {
            // defaulted values can be skipped
            if (this.optionalValues.indexOf(value) >= 0) return typeCheckSuccess();
            // bounce validation to the sub-type
            return this._subtype.validate(value, context);
        }
    });
    Object.defineProperty(OptionalValue.prototype, "isAssignableFrom", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function(type) {
            return this._subtype.isAssignableFrom(type);
        }
    });
    Object.defineProperty(OptionalValue.prototype, "getSubTypes", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function() {
            return this._subtype;
        }
    });
    return OptionalValue;
}(BaseType);
function checkOptionalPreconditions(type, defaultValueOrFunction) {
    // make sure we never pass direct instances
    if (typeof defaultValueOrFunction !== "function" && isStateTreeNode(defaultValueOrFunction)) throw fail$1("default value cannot be an instance, pass a snapshot or a function that creates an instance/snapshot instead");
    assertIsType(type, 1);
    if (devMode()) // we only check default values if they are passed directly
    // if they are generator functions they will be checked once they are generated
    // we don't check generator function results here to avoid generating a node just for type-checking purposes
    // which might generate side-effects
    {
        if (typeof defaultValueOrFunction !== "function") typecheckInternal(type, defaultValueOrFunction);
    }
}
/**
 * `types.optional` - Can be used to create a property with a default value.
 *
 * Depending on the third argument (`optionalValues`) there are two ways of operation:
 * - If the argument is not provided, then if a value is not provided in the snapshot (`undefined` or missing),
 *   it will default to the provided `defaultValue`
 * - If the argument is provided, then if the value in the snapshot matches one of the optional values inside the array then it will
 *   default to the provided `defaultValue`. Additionally, if one of the optional values inside the array is `undefined` then a missing
 *   property is also valid.
 *
 *   Note that it is also possible to include values of the same type as the intended subtype as optional values,
 *   in this case the optional value will be transformed into the `defaultValue` (e.g. `types.optional(types.string, "unnamed", [undefined, ""])`
 *   will transform the snapshot values `undefined` (and therefore missing) and empty strings into the string `"unnamed"` when it gets
 *   instantiated).
 *
 * If `defaultValue` is a function, the function will be invoked for every new instance.
 * Applying a snapshot in which the optional value is one of the optional values (or `undefined`/_not_ present if none are provided) causes the
 * value to be reset.
 *
 * Example:
 * ```ts
 * const Todo = types.model({
 *   title: types.string,
 *   subtitle1: types.optional(types.string, "", [null]),
 *   subtitle2: types.optional(types.string, "", [null, undefined]),
 *   done: types.optional(types.boolean, false),
 *   created: types.optional(types.Date, () => new Date()),
 * })
 *
 * // if done is missing / undefined it will become false
 * // if created is missing / undefined it will get a freshly generated timestamp
 * // if subtitle1 is null it will default to "", but it cannot be missing or undefined
 * // if subtitle2 is null or undefined it will default to ""; since it can be undefined it can also be missing
 * const todo = Todo.create({ title: "Get coffee", subtitle1: null })
 * ```
 *
 * @param type
 * @param defaultValueOrFunction
 * @param optionalValues an optional array with zero or more primitive values (string, number, boolean, null or undefined)
 *                       that will be converted into the default. `[ undefined ]` is assumed when none is provided
 * @returns
 */ function optional(type, defaultValueOrFunction, optionalValues) {
    checkOptionalPreconditions(type, defaultValueOrFunction);
    return new OptionalValue(type, defaultValueOrFunction, optionalValues ? optionalValues : undefinedAsOptionalValues);
}
var undefinedAsOptionalValues = [
    undefined
];
/**
 * Returns if a value represents an optional type.
 *
 * @template IT
 * @param type
 * @returns
 */ function isOptionalType(type) {
    return isType(type) && (type.flags & TypeFlags.Optional) > 0;
}
var optionalUndefinedType = optional(undefinedType, undefined);
var optionalNullType = optional(nullType, null);
/**
 * `types.maybe` - Maybe will make a type nullable, and also optional.
 * The value `undefined` will be used to represent nullability.
 *
 * @param type
 * @returns
 */ function maybe(type) {
    assertIsType(type, 1);
    return union(type, optionalUndefinedType);
}
/**
 * `types.maybeNull` - Maybe will make a type nullable, and also optional.
 * The value `null` will be used to represent no value.
 *
 * @param type
 * @returns
 */ function maybeNull(type) {
    assertIsType(type, 1);
    return union(type, optionalNullType);
}
var Late = /** @class */ function(_super) {
    __extends(Late, _super);
    function Late(name, _definition) {
        var _this = _super.call(this, name) || this;
        Object.defineProperty(_this, "_definition", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: _definition
        });
        Object.defineProperty(_this, "_subType", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        return _this;
    }
    Object.defineProperty(Late.prototype, "flags", {
        get: function() {
            return (this._subType ? this._subType.flags : 0) | TypeFlags.Late;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Late.prototype, "getSubType", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function(mustSucceed) {
            if (!this._subType) {
                var t = undefined;
                try {
                    t = this._definition();
                } catch (e) {
                    if (e instanceof ReferenceError) // can happen in strict ES5 code when a definition is self refering
                    t = undefined;
                    else throw e;
                }
                if (mustSucceed && t === undefined) throw fail$1("Late type seems to be used too early, the definition (still) returns undefined");
                if (t) {
                    if (devMode() && !isType(t)) throw fail$1("Failed to determine subtype, make sure types.late returns a type definition.");
                    this._subType = t;
                }
            }
            return this._subType;
        }
    });
    Object.defineProperty(Late.prototype, "instantiate", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function(parent, subpath, environment, initialValue) {
            return this.getSubType(true).instantiate(parent, subpath, environment, initialValue);
        }
    });
    Object.defineProperty(Late.prototype, "reconcile", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function(current, newValue, parent, subpath) {
            return this.getSubType(true).reconcile(current, newValue, parent, subpath);
        }
    });
    Object.defineProperty(Late.prototype, "describe", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function() {
            var t = this.getSubType(false);
            return t ? t.name : "<uknown late type>";
        }
    });
    Object.defineProperty(Late.prototype, "isValidSnapshot", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function(value, context) {
            var t = this.getSubType(false);
            if (!t) // See #916; the variable the definition closure is pointing to wasn't defined yet, so can't be evaluted yet here
            return typeCheckSuccess();
            return t.validate(value, context);
        }
    });
    Object.defineProperty(Late.prototype, "isAssignableFrom", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function(type) {
            var t = this.getSubType(false);
            return t ? t.isAssignableFrom(type) : false;
        }
    });
    Object.defineProperty(Late.prototype, "getSubTypes", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function() {
            var subtype = this.getSubType(false);
            return subtype ? subtype : cannotDetermineSubtype;
        }
    });
    return Late;
}(BaseType);
/**
 * `types.late` - Defines a type that gets implemented later. This is useful when you have to deal with circular dependencies.
 * Please notice that when defining circular dependencies TypeScript isn't smart enough to inference them.
 *
 * Example:
 * ```ts
 *   // TypeScript isn't smart enough to infer self referencing types.
 *  const Node = types.model({
 *       children: types.array(types.late((): IAnyModelType => Node)) // then typecast each array element to Instance<typeof Node>
 *  })
 * ```
 *
 * @param name The name to use for the type that will be returned.
 * @param type A function that returns the type that will be defined.
 * @returns
 */ function late(nameOrType, maybeType) {
    var name = typeof nameOrType === "string" ? nameOrType : "late(" + nameOrType.toString() + ")";
    var type = typeof nameOrType === "string" ? maybeType : nameOrType;
    // checks that the type is actually a late type
    if (devMode()) {
        if (!(typeof type === "function" && type.length === 0)) throw fail$1("Invalid late type, expected a function with zero arguments that returns a type, got: " + type);
    }
    return new Late(name, type);
}
/**
 * Returns if a given value represents a late type.
 *
 * @param type
 * @returns
 */ function isLateType(type) {
    return isType(type) && (type.flags & TypeFlags.Late) > 0;
}
function lazy(name, options) {
    // TODO: fix this unknown casting to be stricter
    return new Lazy(name, options);
}
/**
 * @internal
 * @hidden
 */ var Lazy = /** @class */ function(_super) {
    __extends(Lazy, _super);
    function Lazy(name, options) {
        var _this = _super.call(this, name) || this;
        Object.defineProperty(_this, "options", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: options
        });
        Object.defineProperty(_this, "flags", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: TypeFlags.Lazy
        });
        Object.defineProperty(_this, "loadedType", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: null
        });
        Object.defineProperty(_this, "pendingNodeList", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (0, $4f362.observable).array()
        });
        (0, $4f362.when)(function() {
            return _this.pendingNodeList.length > 0 && _this.pendingNodeList.some(function(node) {
                return node.isAlive && _this.options.shouldLoadPredicate(node.parent ? node.parent.value : null);
            });
        }, function() {
            _this.options.loadType().then((0, $4f362.action)(function(type) {
                _this.loadedType = type;
                _this.pendingNodeList.forEach(function(node) {
                    if (!node.parent) return;
                    if (!_this.loadedType) return;
                    node.parent.applyPatches([
                        {
                            op: "replace",
                            path: "/" + node.subpath,
                            value: node.snapshot
                        }
                    ]);
                });
            }));
        });
        return _this;
    }
    Object.defineProperty(Lazy.prototype, "describe", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function() {
            return "<lazy " + this.name + ">";
        }
    });
    Object.defineProperty(Lazy.prototype, "instantiate", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function(parent, subpath, environment, value) {
            var _this = this;
            if (this.loadedType) return this.loadedType.instantiate(parent, subpath, environment, value);
            var node = createScalarNode(this, parent, subpath, environment, deepFreeze(value));
            this.pendingNodeList.push(node);
            (0, $4f362.when)(function() {
                return !node.isAlive;
            }, function() {
                return _this.pendingNodeList.splice(_this.pendingNodeList.indexOf(node), 1);
            });
            return node;
        }
    });
    Object.defineProperty(Lazy.prototype, "isValidSnapshot", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function(value, context) {
            if (this.loadedType) return this.loadedType.validate(value, context);
            if (!isSerializable(value)) return typeCheckFailure(context, value, "Value is not serializable and cannot be lazy");
            return typeCheckSuccess();
        }
    });
    Object.defineProperty(Lazy.prototype, "reconcile", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function(current, value, parent, subpath) {
            if (this.loadedType) {
                current.die();
                return this.loadedType.instantiate(parent, subpath, parent.environment, value);
            }
            return _super.prototype.reconcile.call(this, current, value, parent, subpath);
        }
    });
    return Lazy;
}(SimpleType);
/**
 * @internal
 * @hidden
 */ var Frozen = /** @class */ function(_super) {
    __extends(Frozen, _super);
    function Frozen(subType) {
        var _this = _super.call(this, subType ? "frozen(" + subType.name + ")" : "frozen") || this;
        Object.defineProperty(_this, "subType", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: subType
        });
        Object.defineProperty(_this, "flags", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: TypeFlags.Frozen
        });
        return _this;
    }
    Object.defineProperty(Frozen.prototype, "describe", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function() {
            return "<any immutable value>";
        }
    });
    Object.defineProperty(Frozen.prototype, "instantiate", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function(parent, subpath, environment, value) {
            // create the node
            return createScalarNode(this, parent, subpath, environment, deepFreeze(value));
        }
    });
    Object.defineProperty(Frozen.prototype, "isValidSnapshot", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function(value, context) {
            if (!isSerializable(value)) return typeCheckFailure(context, value, "Value is not serializable and cannot be frozen");
            if (this.subType) return this.subType.validate(value, context);
            return typeCheckSuccess();
        }
    });
    return Frozen;
}(SimpleType);
var untypedFrozenInstance = new Frozen();
/**
 * `types.frozen` - Frozen can be used to store any value that is serializable in itself (that is valid JSON).
 * Frozen values need to be immutable or treated as if immutable. They need be serializable as well.
 * Values stored in frozen will snapshotted as-is by MST, and internal changes will not be tracked.
 *
 * This is useful to store complex, but immutable values like vectors etc. It can form a powerful bridge to parts of your application that should be immutable, or that assume data to be immutable.
 *
 * Note: if you want to store free-form state that is mutable, or not serializeable, consider using volatile state instead.
 *
 * Frozen properties can be defined in three different ways
 * 1. `types.frozen(SubType)` - provide a valid MST type and frozen will check if the provided data conforms the snapshot for that type
 * 2. `types.frozen({ someDefaultValue: true})` - provide a primitive value, object or array, and MST will infer the type from that object, and also make it the default value for the field
 * 3. `types.frozen<TypeScriptType>()` - provide a typescript type, to help in strongly typing the field (design time only)
 *
 * Example:
 * ```ts
 * const GameCharacter = types.model({
 *   name: string,
 *   location: types.frozen({ x: 0, y: 0})
 * })
 *
 * const hero = GameCharacter.create({
 *   name: "Mario",
 *   location: { x: 7, y: 4 }
 * })
 *
 * hero.location = { x: 10, y: 2 } // OK
 * hero.location.x = 7 // Not ok!
 * ```
 *
 * ```ts
 * type Point = { x: number, y: number }
 *    const Mouse = types.model({
 *         loc: types.frozen<Point>()
 *    })
 * ```
 *
 * @param defaultValueOrType
 * @returns
 */ function frozen(arg) {
    if (arguments.length === 0) return untypedFrozenInstance;
    else if (isType(arg)) return new Frozen(arg);
    else return optional(untypedFrozenInstance, arg);
}
/**
 * Returns if a given value represents a frozen type.
 *
 * @param type
 * @returns
 */ function isFrozenType(type) {
    return isType(type) && (type.flags & TypeFlags.Frozen) > 0;
}
function getInvalidationCause(hook) {
    switch(hook){
        case Hook.beforeDestroy:
            return "destroy";
        case Hook.beforeDetach:
            return "detach";
        default:
            return undefined;
    }
}
var StoredReference = /** @class */ function() {
    function StoredReference(value, targetType) {
        Object.defineProperty(this, "targetType", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: targetType
        });
        Object.defineProperty(this, "identifier", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "node", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "resolvedReference", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        if (isValidIdentifier(value)) this.identifier = value;
        else if (isStateTreeNode(value)) {
            var targetNode = getStateTreeNode(value);
            if (!targetNode.identifierAttribute) throw fail$1("Can only store references with a defined identifier attribute.");
            var id = targetNode.unnormalizedIdentifier;
            if (id === null || id === undefined) throw fail$1("Can only store references to tree nodes with a defined identifier.");
            this.identifier = id;
        } else throw fail$1("Can only store references to tree nodes or identifiers, got: '" + value + "'");
    }
    Object.defineProperty(StoredReference.prototype, "updateResolvedReference", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function(node) {
            var normalizedId = normalizeIdentifier(this.identifier);
            var root = node.root;
            var lastCacheModification = root.identifierCache.getLastCacheModificationPerId(normalizedId);
            if (!this.resolvedReference || this.resolvedReference.lastCacheModification !== lastCacheModification) {
                var targetType = this.targetType;
                // reference was initialized with the identifier of the target
                var target = root.identifierCache.resolve(targetType, normalizedId);
                if (!target) throw new InvalidReferenceError("[mobx-state-tree] Failed to resolve reference '" + this.identifier + "' to type '" + this.targetType.name + "' (from node: " + node.path + ")");
                this.resolvedReference = {
                    node: target,
                    lastCacheModification: lastCacheModification
                };
            }
        }
    });
    Object.defineProperty(StoredReference.prototype, "resolvedValue", {
        get: function() {
            this.updateResolvedReference(this.node);
            return this.resolvedReference.node.value;
        },
        enumerable: false,
        configurable: true
    });
    return StoredReference;
}();
/**
 * @internal
 * @hidden
 */ var InvalidReferenceError = /** @class */ function(_super) {
    __extends(InvalidReferenceError, _super);
    function InvalidReferenceError(m) {
        var _this = _super.call(this, m) || this;
        Object.setPrototypeOf(_this, InvalidReferenceError.prototype);
        return _this;
    }
    return InvalidReferenceError;
}(Error);
/**
 * @internal
 * @hidden
 */ var BaseReferenceType = /** @class */ function(_super) {
    __extends(BaseReferenceType, _super);
    function BaseReferenceType(targetType, onInvalidated) {
        var _this = _super.call(this, "reference(" + targetType.name + ")") || this;
        Object.defineProperty(_this, "targetType", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: targetType
        });
        Object.defineProperty(_this, "onInvalidated", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: onInvalidated
        });
        Object.defineProperty(_this, "flags", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: TypeFlags.Reference
        });
        return _this;
    }
    Object.defineProperty(BaseReferenceType.prototype, "describe", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function() {
            return this.name;
        }
    });
    Object.defineProperty(BaseReferenceType.prototype, "isAssignableFrom", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function(type) {
            return this.targetType.isAssignableFrom(type);
        }
    });
    Object.defineProperty(BaseReferenceType.prototype, "isValidSnapshot", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function(value, context) {
            return isValidIdentifier(value) ? typeCheckSuccess() : typeCheckFailure(context, value, "Value is not a valid identifier, which is a string or a number");
        }
    });
    Object.defineProperty(BaseReferenceType.prototype, "fireInvalidated", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function(cause, storedRefNode, referenceId, refTargetNode) {
            // to actually invalidate a reference we need an alive parent,
            // since it is a scalar value (immutable-ish) and we need to change it
            // from the parent
            var storedRefParentNode = storedRefNode.parent;
            if (!storedRefParentNode || !storedRefParentNode.isAlive) return;
            var storedRefParentValue = storedRefParentNode.storedValue;
            if (!storedRefParentValue) return;
            this.onInvalidated({
                cause: cause,
                parent: storedRefParentValue,
                invalidTarget: refTargetNode ? refTargetNode.storedValue : undefined,
                invalidId: referenceId,
                replaceRef: function(newRef) {
                    applyPatch(storedRefNode.root.storedValue, {
                        op: "replace",
                        value: newRef,
                        path: storedRefNode.path
                    });
                },
                removeRef: function() {
                    if (isModelType(storedRefParentNode.type)) this.replaceRef(undefined);
                    else applyPatch(storedRefNode.root.storedValue, {
                        op: "remove",
                        path: storedRefNode.path
                    });
                }
            });
        }
    });
    Object.defineProperty(BaseReferenceType.prototype, "addTargetNodeWatcher", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function(storedRefNode, referenceId) {
            var _this = this;
            // this will make sure the target node becomes created
            var refTargetValue = this.getValue(storedRefNode);
            if (!refTargetValue) return undefined;
            var refTargetNode = getStateTreeNode(refTargetValue);
            var hookHandler = function(_, refTargetNodeHook) {
                var cause = getInvalidationCause(refTargetNodeHook);
                if (!cause) return;
                _this.fireInvalidated(cause, storedRefNode, referenceId, refTargetNode);
            };
            var refTargetDetachHookDisposer = refTargetNode.registerHook(Hook.beforeDetach, hookHandler);
            var refTargetDestroyHookDisposer = refTargetNode.registerHook(Hook.beforeDestroy, hookHandler);
            return function() {
                refTargetDetachHookDisposer();
                refTargetDestroyHookDisposer();
            };
        }
    });
    Object.defineProperty(BaseReferenceType.prototype, "watchTargetNodeForInvalidations", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function(storedRefNode, identifier, customGetSet) {
            var _this = this;
            if (!this.onInvalidated) return;
            var onRefTargetDestroyedHookDisposer;
            // get rid of the watcher hook when the stored ref node is destroyed
            // detached is ignored since scalar nodes (where the reference resides) cannot be detached
            storedRefNode.registerHook(Hook.beforeDestroy, function() {
                if (onRefTargetDestroyedHookDisposer) onRefTargetDestroyedHookDisposer();
            });
            var startWatching = function(sync) {
                // re-create hook in case the stored ref gets reattached
                if (onRefTargetDestroyedHookDisposer) onRefTargetDestroyedHookDisposer();
                // make sure the target node is actually there and initialized
                var storedRefParentNode = storedRefNode.parent;
                var storedRefParentValue = storedRefParentNode && storedRefParentNode.storedValue;
                if (storedRefParentNode && storedRefParentNode.isAlive && storedRefParentValue) {
                    var refTargetNodeExists = void 0;
                    if (customGetSet) refTargetNodeExists = !!customGetSet.get(identifier, storedRefParentValue);
                    else refTargetNodeExists = storedRefNode.root.identifierCache.has(_this.targetType, normalizeIdentifier(identifier));
                    if (!refTargetNodeExists) // we cannot change the reference in sync mode
                    // since we are in the middle of a reconciliation/instantiation and the change would be overwritten
                    // for those cases just let the wrong reference be assigned and fail upon usage
                    // (like current references do)
                    // this means that effectively this code will only run when it is created from a snapshot
                    {
                        if (!sync) _this.fireInvalidated("invalidSnapshotReference", storedRefNode, identifier, null);
                    } else onRefTargetDestroyedHookDisposer = _this.addTargetNodeWatcher(storedRefNode, identifier);
                }
            };
            if (storedRefNode.state === NodeLifeCycle.FINALIZED) // already attached, so the whole tree is ready
            startWatching(true);
            else {
                if (!storedRefNode.isRoot) // start watching once the whole tree is ready
                storedRefNode.root.registerHook(Hook.afterCreationFinalization, function() {
                    // make sure to attach it so it can start listening
                    if (storedRefNode.parent) storedRefNode.parent.createObservableInstanceIfNeeded();
                });
                // start watching once the node is attached somewhere / parent changes
                storedRefNode.registerHook(Hook.afterAttach, function() {
                    startWatching(false);
                });
            }
        }
    });
    return BaseReferenceType;
}(SimpleType);
/**
 * @internal
 * @hidden
 */ var IdentifierReferenceType = /** @class */ function(_super) {
    __extends(IdentifierReferenceType, _super);
    function IdentifierReferenceType(targetType, onInvalidated) {
        return _super.call(this, targetType, onInvalidated) || this;
    }
    Object.defineProperty(IdentifierReferenceType.prototype, "getValue", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function(storedRefNode) {
            if (!storedRefNode.isAlive) return undefined;
            var storedRef = storedRefNode.storedValue;
            return storedRef.resolvedValue;
        }
    });
    Object.defineProperty(IdentifierReferenceType.prototype, "getSnapshot", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function(storedRefNode) {
            var ref = storedRefNode.storedValue;
            return ref.identifier;
        }
    });
    Object.defineProperty(IdentifierReferenceType.prototype, "instantiate", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function(parent, subpath, environment, initialValue) {
            var identifier = isStateTreeNode(initialValue) ? getIdentifier(initialValue) : initialValue;
            var storedRef = new StoredReference(initialValue, this.targetType);
            var storedRefNode = createScalarNode(this, parent, subpath, environment, storedRef);
            storedRef.node = storedRefNode;
            this.watchTargetNodeForInvalidations(storedRefNode, identifier, undefined);
            return storedRefNode;
        }
    });
    Object.defineProperty(IdentifierReferenceType.prototype, "reconcile", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function(current, newValue, parent, subpath) {
            if (!current.isDetaching && current.type === this) {
                var compareByValue = isStateTreeNode(newValue);
                var ref = current.storedValue;
                if (!compareByValue && ref.identifier === newValue || compareByValue && ref.resolvedValue === newValue) {
                    current.setParent(parent, subpath);
                    return current;
                }
            }
            var newNode = this.instantiate(parent, subpath, undefined, newValue);
            current.die(); // noop if detaching
            return newNode;
        }
    });
    return IdentifierReferenceType;
}(BaseReferenceType);
/**
 * @internal
 * @hidden
 */ var CustomReferenceType = /** @class */ function(_super) {
    __extends(CustomReferenceType, _super);
    function CustomReferenceType(targetType, options, onInvalidated) {
        var _this = _super.call(this, targetType, onInvalidated) || this;
        Object.defineProperty(_this, "options", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: options
        });
        return _this;
    }
    Object.defineProperty(CustomReferenceType.prototype, "getValue", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function(storedRefNode) {
            if (!storedRefNode.isAlive) return undefined;
            var referencedNode = this.options.get(storedRefNode.storedValue, storedRefNode.parent ? storedRefNode.parent.storedValue : null);
            return referencedNode;
        }
    });
    Object.defineProperty(CustomReferenceType.prototype, "getSnapshot", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function(storedRefNode) {
            return storedRefNode.storedValue;
        }
    });
    Object.defineProperty(CustomReferenceType.prototype, "instantiate", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function(parent, subpath, environment, newValue) {
            var identifier = isStateTreeNode(newValue) ? this.options.set(newValue, parent ? parent.storedValue : null) : newValue;
            var storedRefNode = createScalarNode(this, parent, subpath, environment, identifier);
            this.watchTargetNodeForInvalidations(storedRefNode, identifier, this.options);
            return storedRefNode;
        }
    });
    Object.defineProperty(CustomReferenceType.prototype, "reconcile", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function(current, newValue, parent, subpath) {
            var newIdentifier = isStateTreeNode(newValue) ? this.options.set(newValue, current ? current.storedValue : null) : newValue;
            if (!current.isDetaching && current.type === this && current.storedValue === newIdentifier) {
                current.setParent(parent, subpath);
                return current;
            }
            var newNode = this.instantiate(parent, subpath, undefined, newIdentifier);
            current.die(); // noop if detaching
            return newNode;
        }
    });
    return CustomReferenceType;
}(BaseReferenceType);
/**
 * `types.reference` - Creates a reference to another type, which should have defined an identifier.
 * See also the [reference and identifiers](https://github.com/mobxjs/mobx-state-tree#references-and-identifiers) section.
 */ function reference(subType, options) {
    assertIsType(subType, 1);
    if (devMode()) {
        if (arguments.length === 2 && typeof arguments[1] === "string") // istanbul ignore next
        throw fail$1("References with base path are no longer supported. Please remove the base path.");
    }
    var getSetOptions = options ? options : undefined;
    var onInvalidated = options ? options.onInvalidated : undefined;
    if (getSetOptions && (getSetOptions.get || getSetOptions.set)) {
        if (devMode()) {
            if (!getSetOptions.get || !getSetOptions.set) throw fail$1("reference options must either contain both a 'get' and a 'set' method or none of them");
        }
        return new CustomReferenceType(subType, {
            get: getSetOptions.get,
            set: getSetOptions.set
        }, onInvalidated);
    } else return new IdentifierReferenceType(subType, onInvalidated);
}
/**
 * Returns if a given value represents a reference type.
 *
 * @param type
 * @returns
 */ function isReferenceType(type) {
    return (type.flags & TypeFlags.Reference) > 0;
}
/**
 * `types.safeReference` - A safe reference is like a standard reference, except that it accepts the undefined value by default
 * and automatically sets itself to undefined (when the parent is a model) / removes itself from arrays and maps
 * when the reference it is pointing to gets detached/destroyed.
 *
 * The optional options parameter object accepts a parameter named `acceptsUndefined`, which is set to true by default, so it is suitable
 * for model properties.
 * When used inside collections (arrays/maps), it is recommended to set this option to false so it can't take undefined as value,
 * which is usually the desired in those cases.
 * Additionally, the optional options parameter object accepts a parameter named `onInvalidated`, which will be called when the reference target node that the reference is pointing to is about to be detached/destroyed
 *
 * Strictly speaking it is a `types.maybe(types.reference(X))` (when `acceptsUndefined` is set to true, the default) and
 * `types.reference(X)` (when `acceptsUndefined` is set to false), both of them with a customized `onInvalidated` option.
 *
 * @param subType
 * @param options
 * @returns
 */ function safeReference(subType, options) {
    var refType = reference(subType, __assign(__assign({}, options), {
        onInvalidated: function(ev) {
            if (options && options.onInvalidated) options.onInvalidated(ev);
            ev.removeRef();
        }
    }));
    if (options && options.acceptsUndefined === false) return refType;
    else return maybe(refType);
}
var BaseIdentifierType = /** @class */ function(_super) {
    __extends(BaseIdentifierType, _super);
    function BaseIdentifierType(name, validType) {
        var _this = _super.call(this, name) || this;
        Object.defineProperty(_this, "validType", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: validType
        });
        Object.defineProperty(_this, "flags", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: TypeFlags.Identifier
        });
        return _this;
    }
    Object.defineProperty(BaseIdentifierType.prototype, "instantiate", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function(parent, subpath, environment, initialValue) {
            if (!parent || !(parent.type instanceof ModelType)) throw fail$1("Identifier types can only be instantiated as direct child of a model type");
            return createScalarNode(this, parent, subpath, environment, initialValue);
        }
    });
    Object.defineProperty(BaseIdentifierType.prototype, "reconcile", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function(current, newValue, parent, subpath) {
            // we don't consider detaching here since identifier are scalar nodes, and scalar nodes cannot be detached
            if (current.storedValue !== newValue) throw fail$1("Tried to change identifier from '" + current.storedValue + "' to '" + newValue + "'. Changing identifiers is not allowed.");
            current.setParent(parent, subpath);
            return current;
        }
    });
    Object.defineProperty(BaseIdentifierType.prototype, "isValidSnapshot", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function(value, context) {
            if (typeof value !== this.validType) return typeCheckFailure(context, value, "Value is not a valid " + this.describe() + ", expected a " + this.validType);
            return typeCheckSuccess();
        }
    });
    return BaseIdentifierType;
}(SimpleType);
/**
 * @internal
 * @hidden
 */ var IdentifierType = /** @class */ function(_super) {
    __extends(IdentifierType, _super);
    function IdentifierType() {
        var _this = _super.call(this, "identifier", "string") || this;
        Object.defineProperty(_this, "flags", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: TypeFlags.Identifier
        });
        return _this;
    }
    Object.defineProperty(IdentifierType.prototype, "describe", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function() {
            return "identifier";
        }
    });
    return IdentifierType;
}(BaseIdentifierType);
/**
 * @internal
 * @hidden
 */ var IdentifierNumberType = /** @class */ function(_super) {
    __extends(IdentifierNumberType, _super);
    function IdentifierNumberType() {
        return _super.call(this, "identifierNumber", "number") || this;
    }
    Object.defineProperty(IdentifierNumberType.prototype, "getSnapshot", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function(node) {
            return node.storedValue;
        }
    });
    Object.defineProperty(IdentifierNumberType.prototype, "describe", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function() {
            return "identifierNumber";
        }
    });
    return IdentifierNumberType;
}(BaseIdentifierType);
/**
 * `types.identifier` - Identifiers are used to make references, lifecycle events and reconciling works.
 * Inside a state tree, for each type can exist only one instance for each given identifier.
 * For example there couldn't be 2 instances of user with id 1. If you need more, consider using references.
 * Identifier can be used only as type property of a model.
 * This type accepts as parameter the value type of the identifier field that can be either string or number.
 *
 * Example:
 * ```ts
 *  const Todo = types.model("Todo", {
 *      id: types.identifier,
 *      title: types.string
 *  })
 * ```
 *
 * @returns
 */ var identifier = new IdentifierType();
/**
 * `types.identifierNumber` - Similar to `types.identifier`. This one will serialize from / to a number when applying snapshots
 *
 * Example:
 * ```ts
 *  const Todo = types.model("Todo", {
 *      id: types.identifierNumber,
 *      title: types.string
 *  })
 * ```
 *
 * @returns
 */ var identifierNumber = new IdentifierNumberType();
/**
 * Returns if a given value represents an identifier type.
 *
 * @param type
 * @returns
 */ function isIdentifierType(type) {
    return isType(type) && (type.flags & TypeFlags.Identifier) > 0;
}
/**
 * @internal
 * @hidden
 */ function normalizeIdentifier(id) {
    return "" + id;
}
/**
 * @internal
 * @hidden
 */ function isValidIdentifier(id) {
    return typeof id === "string" || typeof id === "number";
}
/**
 * @internal
 * @hidden
 */ function assertIsValidIdentifier(id, argNumber) {
    assertArg(id, isValidIdentifier, "string or number (identifier)", argNumber);
}
/**
 * `types.custom` - Creates a custom type. Custom types can be used for arbitrary immutable values, that have a serializable representation. For example, to create your own Date representation, Decimal type etc.
 *
 * The signature of the options is:
 * ```ts
 * export interface CustomTypeOptions<S, T> {
 *     // Friendly name
 *     name: string
 *     // given a serialized value and environment, how to turn it into the target type
 *     fromSnapshot(snapshot: S, env: any): T
 *     // return the serialization of the current value
 *     toSnapshot(value: T): S
 *     // if true, this is a converted value, if false, it's a snapshot
 *     isTargetType(value: T | S): value is T
 *     // a non empty string is assumed to be a validation error
 *     getValidationMessage?(snapshot: S): string
 * }
 * ```
 *
 * Example:
 * ```ts
 * const DecimalPrimitive = types.custom<string, Decimal>({
 *     name: "Decimal",
 *     fromSnapshot(value: string) {
 *         return new Decimal(value)
 *     },
 *     toSnapshot(value: Decimal) {
 *         return value.toString()
 *     },
 *     isTargetType(value: string | Decimal): boolean {
 *         return value instanceof Decimal
 *     },
 *     getValidationMessage(value: string): string {
 *         if (/^-?\d+\.\d+$/.test(value)) return "" // OK
 *         return `'${value}' doesn't look like a valid decimal number`
 *     }
 * })
 *
 * const Wallet = types.model({
 *     balance: DecimalPrimitive
 * })
 * ```
 *
 * @param options
 * @returns
 */ function custom(options) {
    return new CustomType(options);
}
/**
 * @internal
 * @hidden
 */ var CustomType = /** @class */ function(_super) {
    __extends(CustomType, _super);
    function CustomType(options) {
        var _this = _super.call(this, options.name) || this;
        Object.defineProperty(_this, "options", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: options
        });
        Object.defineProperty(_this, "flags", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: TypeFlags.Custom
        });
        return _this;
    }
    Object.defineProperty(CustomType.prototype, "describe", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function() {
            return this.name;
        }
    });
    Object.defineProperty(CustomType.prototype, "isValidSnapshot", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function(value, context) {
            if (this.options.isTargetType(value)) return typeCheckSuccess();
            var typeError = this.options.getValidationMessage(value);
            if (typeError) return typeCheckFailure(context, value, "Invalid value for type '" + this.name + "': " + typeError);
            return typeCheckSuccess();
        }
    });
    Object.defineProperty(CustomType.prototype, "getSnapshot", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function(node) {
            return this.options.toSnapshot(node.storedValue);
        }
    });
    Object.defineProperty(CustomType.prototype, "instantiate", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function(parent, subpath, environment, initialValue) {
            var valueToStore = this.options.isTargetType(initialValue) ? initialValue : this.options.fromSnapshot(initialValue, parent && parent.root.environment);
            return createScalarNode(this, parent, subpath, environment, valueToStore);
        }
    });
    Object.defineProperty(CustomType.prototype, "reconcile", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function(current, value, parent, subpath) {
            var isSnapshot = !this.options.isTargetType(value);
            // in theory customs use scalar nodes which cannot be detached, but still...
            if (!current.isDetaching) {
                var unchanged = current.type === this && (isSnapshot ? value === current.snapshot : value === current.storedValue);
                if (unchanged) {
                    current.setParent(parent, subpath);
                    return current;
                }
            }
            var valueToStore = isSnapshot ? this.options.fromSnapshot(value, parent.root.environment) : value;
            var newNode = this.instantiate(parent, subpath, undefined, valueToStore);
            current.die(); // noop if detaching
            return newNode;
        }
    });
    return CustomType;
}(SimpleType);
// we import the types to re-export them inside types.
var types = {
    enumeration: enumeration,
    model: model,
    compose: compose,
    custom: custom,
    reference: reference,
    safeReference: safeReference,
    union: union,
    optional: optional,
    literal: literal,
    maybe: maybe,
    maybeNull: maybeNull,
    refinement: refinement,
    string: string,
    boolean: boolean,
    number: number,
    integer: integer,
    float: float,
    finite: finite,
    Date: DatePrimitive,
    map: map,
    array: array,
    frozen: frozen,
    identifier: identifier,
    identifierNumber: identifierNumber,
    late: late,
    lazy: lazy,
    undefined: undefinedType,
    null: nullType,
    snapshotProcessor: snapshotProcessor
};

});

parcelRegister("bsQZT", function(module, exports) {

$parcel$export(module.exports, "config", () => $ea55c13fedca4086$export$e506a1d27d1eaa20);
$parcel$export(module.exports, "isProductionEnvironment", () => $ea55c13fedca4086$export$9c0c5d1f8a7fb19a);
$parcel$export(module.exports, "isLocalDevelopmentEnvironment", () => $ea55c13fedca4086$export$b6f36105bc7c9408);
var $ea55c13fedca4086$export$76c40c36845e9385;
(function(EnvironmentType) {
    EnvironmentType["localDevelopment"] = "local development";
    EnvironmentType["development"] = "development";
    EnvironmentType["production"] = "production";
})($ea55c13fedca4086$export$76c40c36845e9385 || ($ea55c13fedca4086$export$76c40c36845e9385 = {}));


const $ea55c13fedca4086$export$e506a1d27d1eaa20 = $ea55c13fedca4086$export$9c0c5d1f8a7fb19a() ? (parcelRequire("7p6TI")).config : (parcelRequire("1Ag7U")).config;
function $ea55c13fedca4086$export$9c0c5d1f8a7fb19a() {
    return false;
}
function $ea55c13fedca4086$export$b6f36105bc7c9408() {
    return false;
}

});
parcelRegister("7p6TI", function(module, exports) {

$parcel$export(module.exports, "config", () => $7c4d5e69fdc49f7e$export$e506a1d27d1eaa20);
const $7c4d5e69fdc49f7e$export$e506a1d27d1eaa20 = {
    API_URL: "https://api.ogram.co/api/",
    API_GR_URL: "https://api-gr.ogram.co/api/",
    API_SA_URL: "https://api-sa.ogram.co/api/",
    USE_REAL_API: true,
    GOOGLE_API_KEY: "AIzaSyCcsLOyCRKa_PIH_DwVDEgs-s1EUWhOg1A",
    GOOGLE_AUTH_CLIENT_ID: "171301787568-i2djddid25but5oigoid80si3s743bdf.apps.googleusercontent.com",
    IOS_CLIENT_ID: "1004213687272-gcqsfhnek4iiq3j6fqdu603igb6m3dl8.apps.googleusercontent.com",
    FB_AUTH_CLIENT_ID: "640269856536676",
    SHOW_MESSAGES_TAB: false,
    STRIPE_PUBLISHABLE_KEY_UAE: "pk_live_51KyBhxHzf8fVSAwXr7mz3VkTBUl6eECw05CGrXQQkVkppXoSUwqQ4cnztXTjCu4fpNkM4LbXBnh1KIO0YOGwdC9H00c6pa96MB",
    STRIPE_PUBLISHABLE_KEY_GR: "pk_live_51M2r2QJz9c5KxSLgC0WAyoOUjhjSYiGSVL4ssqgJTXDv8xQmRdOJbQYF0sgql5RfvzBHCVqL2mCDfoDCPGGmw20i00m9nvaPSr",
    LEAN_APP_TOKEN: "8ce69dc8-627c-4e40-abbd-1042a40b61c9",
    LEAN_PAYMENT_DESTINATION_ID: "9a5b2b0b-390d-43a1-9a2f-8c699e669c06",
    FIREBASE_WEB_CONFIG: {
        apiKey: "AIzaSyB8WI2K1_g06BTxD711J_LE6omGEGrFtDY",
        vapidKey: "BDIoSfsOUXOCCMOgRHHEvfib0GiReHY4AXOl7JRgy9pkiMthllvevpuEjJgcAWbNdmZXVikKb22RLf9CKL3R5Q0",
        authDomain: "ogram-client.firebaseapp.com",
        projectId: "ogram-client",
        storageBucket: "ogram-client.appspot.com",
        messagingSenderId: "188726379320",
        appId: "1:188726379320:web:32bc95d9cd08ef528537cd",
        measurementId: "G-Y7VPTMJDYR"
    }
};

});

parcelRegister("1Ag7U", function(module, exports) {

$parcel$export(module.exports, "config", () => $f7814666a59cea4b$export$e506a1d27d1eaa20);

var $bsQZT = parcelRequire("bsQZT");
const $f7814666a59cea4b$export$e506a1d27d1eaa20 = {
    API_URL: (0, $bsQZT.isLocalDevelopmentEnvironment)() ? "http://localhost:8000/api/" : "https://dev.ogram.co/api/",
    API_GR_URL: (0, $bsQZT.isLocalDevelopmentEnvironment)() ? "http://localhost:8000/api/" : "https://dev-gr.ogram.co/api/",
    API_SA_URL: (0, $bsQZT.isLocalDevelopmentEnvironment)() ? "http://localhost:8000/api/" : "https://dev-sa.ogram.co/api/",
    USE_REAL_API: true,
    GOOGLE_API_KEY: "AIzaSyBTTfo5ohIS-E7DxdT5i9S-NjByrLV5XBY",
    GOOGLE_AUTH_CLIENT_ID: "171301787568-i2djddid25but5oigoid80si3s743bdf.apps.googleusercontent.com",
    IOS_CLIENT_ID: "1004213687272-gcqsfhnek4iiq3j6fqdu603igb6m3dl8.apps.googleusercontent.com",
    FB_AUTH_CLIENT_ID: "640269856536676",
    SHOW_MESSAGES_TAB: true,
    STRIPE_PUBLISHABLE_KEY_UAE: "pk_test_51KyBhxHzf8fVSAwXC6jdo69lJsORa7f52woJ8iFFGsYu4kcKKCbG0JMxYruVt1ZbOcBxNnhLWEZANvjpVhNgzYk900te4dZsrb",
    STRIPE_PUBLISHABLE_KEY_GR: "pk_test_51M2r2QJz9c5KxSLgXUHfpH3dXDLrx3vnEs5TS5VPZ1KLoXyYH9zzjxH5kGmnn4zbjKUDkX8IJWMd2XrQh29JPkk200L6lGjJUt",
    LEAN_APP_TOKEN: "220d863e-a1ae-4efe-a1c1-4b0a761ff910",
    LEAN_PAYMENT_DESTINATION_ID: "27d79ff2-702b-481b-944d-2779b2869858",
    FIREBASE_WEB_CONFIG: {
        apiKey: "AIzaSyB8WI2K1_g06BTxD711J_LE6omGEGrFtDY",
        vapidKey: "BIqhz1dCHsyj-iMNuhZs-6txzhyU4sLrv1uTPMn4kY2JwXUxuly5o7-eVMMmuUk_wREx72qZkI8anMhtTKrQ1z0",
        authDomain: "ogram-client.firebaseapp.com",
        projectId: "ogram-client",
        storageBucket: "ogram-client.appspot.com",
        messagingSenderId: "188726379320",
        appId: "1:188726379320:web:32bc95d9cd08ef528537cd",
        measurementId: "G-Y7VPTMJDYR"
    }
};

});


parcelRegister("cvSY8", function(module, exports) {

$parcel$export(module.exports, "dateTimestampInSeconds", () => dateTimestampInSeconds);
$parcel$export(module.exports, "timestampInSeconds", () => timestampInSeconds);
$parcel$export(module.exports, "browserPerformanceTimeOrigin", () => browserPerformanceTimeOrigin);

var $289ZW = parcelRequire("289ZW");

var $3bpJ1 = parcelRequire("3bpJ1");
// eslint-disable-next-line deprecation/deprecation
const WINDOW = (0, $3bpJ1.getGlobalObject)();
/**
 * An object that can return the current timestamp in seconds since the UNIX epoch.
 */ /**
 * A TimestampSource implementation for environments that do not support the Performance Web API natively.
 *
 * Note that this TimestampSource does not use a monotonic clock. A call to `nowSeconds` may return a timestamp earlier
 * than a previously returned value. We do not try to emulate a monotonic behavior in order to facilitate debugging. It
 * is more obvious to explain "why does my span have negative duration" than "why my spans have zero duration".
 */ const dateTimestampSource = {
    nowSeconds: ()=>Date.now() / 1000
};
/**
 * A partial definition of the [Performance Web API]{@link https://developer.mozilla.org/en-US/docs/Web/API/Performance}
 * for accessing a high-resolution monotonic clock.
 */ /**
 * Returns a wrapper around the native Performance API browser implementation, or undefined for browsers that do not
 * support the API.
 *
 * Wrapping the native API works around differences in behavior from different browsers.
 */ function getBrowserPerformance() {
    const { performance } = WINDOW;
    if (!performance || !performance.now) return undefined;
    // Replace performance.timeOrigin with our own timeOrigin based on Date.now().
    //
    // This is a partial workaround for browsers reporting performance.timeOrigin such that performance.timeOrigin +
    // performance.now() gives a date arbitrarily in the past.
    //
    // Additionally, computing timeOrigin in this way fills the gap for browsers where performance.timeOrigin is
    // undefined.
    //
    // The assumption that performance.timeOrigin + performance.now() ~= Date.now() is flawed, but we depend on it to
    // interact with data coming out of performance entries.
    //
    // Note that despite recommendations against it in the spec, browsers implement the Performance API with a clock that
    // might stop when the computer is asleep (and perhaps under other circumstances). Such behavior causes
    // performance.timeOrigin + performance.now() to have an arbitrary skew over Date.now(). In laptop computers, we have
    // observed skews that can be as long as days, weeks or months.
    //
    // See https://github.com/getsentry/sentry-javascript/issues/2590.
    //
    // BUG: despite our best intentions, this workaround has its limitations. It mostly addresses timings of pageload
    // transactions, but ignores the skew built up over time that can aversely affect timestamps of navigation
    // transactions of long-lived web pages.
    const timeOrigin = Date.now() - performance.now();
    return {
        now: ()=>performance.now(),
        timeOrigin: timeOrigin
    };
}
/**
 * Returns the native Performance API implementation from Node.js. Returns undefined in old Node.js versions that don't
 * implement the API.
 */ function getNodePerformance() {
    try {
        const perfHooks = (0, $289ZW.dynamicRequire)(module, "perf_hooks");
        return perfHooks.performance;
    } catch (_) {
        return undefined;
    }
}
/**
 * The Performance API implementation for the current platform, if available.
 */ const platformPerformance = (0, $289ZW.isNodeEnv)() ? getNodePerformance() : getBrowserPerformance();
const timestampSource = platformPerformance === undefined ? dateTimestampSource : {
    nowSeconds: ()=>(platformPerformance.timeOrigin + platformPerformance.now()) / 1000
};
/**
 * Returns a timestamp in seconds since the UNIX epoch using the Date API.
 */ const dateTimestampInSeconds = dateTimestampSource.nowSeconds.bind(dateTimestampSource);
/**
 * Returns a timestamp in seconds since the UNIX epoch using either the Performance or Date APIs, depending on the
 * availability of the Performance API.
 *
 * See `usingPerformanceAPI` to test whether the Performance API is used.
 *
 * BUG: Note that because of how browsers implement the Performance API, the clock might stop when the computer is
 * asleep. This creates a skew between `dateTimestampInSeconds` and `timestampInSeconds`. The
 * skew can grow to arbitrary amounts like days, weeks or months.
 * See https://github.com/getsentry/sentry-javascript/issues/2590.
 */ const timestampInSeconds = timestampSource.nowSeconds.bind(timestampSource);
/**
 * Re-exported with an old name for backwards-compatibility.
 * TODO (v8): Remove this
 *
 * @deprecated Use `timestampInSeconds` instead.
 */ const timestampWithMs = timestampInSeconds;
/**
 * A boolean that is true when timestampInSeconds uses the Performance API to produce monotonic timestamps.
 */ const usingPerformanceAPI = platformPerformance !== undefined;
/**
 * Internal helper to store what is the source of browserPerformanceTimeOrigin below. For debugging only.
 */ let _browserPerformanceTimeOriginMode;
/**
 * The number of milliseconds since the UNIX epoch. This value is only usable in a browser, and only when the
 * performance API is available.
 */ const browserPerformanceTimeOrigin = (()=>{
    // Unfortunately browsers may report an inaccurate time origin data, through either performance.timeOrigin or
    // performance.timing.navigationStart, which results in poor results in performance data. We only treat time origin
    // data as reliable if they are within a reasonable threshold of the current time.
    const { performance } = WINDOW;
    if (!performance || !performance.now) {
        _browserPerformanceTimeOriginMode = "none";
        return undefined;
    }
    const threshold = 3600000;
    const performanceNow = performance.now();
    const dateNow = Date.now();
    // if timeOrigin isn't available set delta to threshold so it isn't used
    const timeOriginDelta = performance.timeOrigin ? Math.abs(performance.timeOrigin + performanceNow - dateNow) : threshold;
    const timeOriginIsReliable = timeOriginDelta < threshold;
    // While performance.timing.navigationStart is deprecated in favor of performance.timeOrigin, performance.timeOrigin
    // is not as widely supported. Namely, performance.timeOrigin is undefined in Safari as of writing.
    // Also as of writing, performance.timing is not available in Web Workers in mainstream browsers, so it is not always
    // a valid fallback. In the absence of an initial time provided by the browser, fallback to the current time from the
    // Date API.
    // eslint-disable-next-line deprecation/deprecation
    const navigationStart = performance.timing && performance.timing.navigationStart;
    const hasNavigationStart = typeof navigationStart === "number";
    // if navigationStart isn't available set delta to threshold so it isn't used
    const navigationStartDelta = hasNavigationStart ? Math.abs(navigationStart + performanceNow - dateNow) : threshold;
    const navigationStartIsReliable = navigationStartDelta < threshold;
    if (timeOriginIsReliable || navigationStartIsReliable) {
        // Use the more reliable time origin
        if (timeOriginDelta <= navigationStartDelta) {
            _browserPerformanceTimeOriginMode = "timeOrigin";
            return performance.timeOrigin;
        } else {
            _browserPerformanceTimeOriginMode = "navigationStart";
            return navigationStart;
        }
    }
    // Either both timeOrigin and navigationStart are skewed or neither is available, fallback to Date.
    _browserPerformanceTimeOriginMode = "dateNow";
    return dateNow;
})();

});
parcelRegister("289ZW", function(module, exports) {

$parcel$export(module.exports, "isNodeEnv", () => isNodeEnv);
$parcel$export(module.exports, "dynamicRequire", () => dynamicRequire);
$parcel$export(module.exports, "loadModule", () => loadModule);

var $Wgg6o = parcelRequire("Wgg6o");

var $hPtJY = parcelRequire("hPtJY");
/**
 * NOTE: In order to avoid circular dependencies, if you add a function to this module and it needs to print something,
 * you must either a) use `console.log` rather than the logger, or b) put your function elsewhere.
 */ /**
 * Checks whether we're in the Node.js or Browser environment
 *
 * @returns Answer to given question
 */ function isNodeEnv() {
    // explicitly check for browser bundles as those can be optimized statically
    // by terser/rollup.
    return !(0, $Wgg6o.isBrowserBundle)() && Object.prototype.toString.call(typeof $hPtJY !== "undefined" ? $hPtJY : 0) === "[object process]";
}
/**
 * Requires a module which is protected against bundler minification.
 *
 * @param request The module path to resolve
 */ // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types, @typescript-eslint/no-explicit-any
function dynamicRequire(mod, request) {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    return mod.require(request);
}
/**
 * Helper for dynamically loading module that should work with linked dependencies.
 * The problem is that we _should_ be using `require(require.resolve(moduleName, { paths: [cwd()] }))`
 * However it's _not possible_ to do that with Webpack, as it has to know all the dependencies during
 * build time. `require.resolve` is also not available in any other way, so we cannot create,
 * a fake helper like we do with `dynamicRequire`.
 *
 * We always prefer to use local package, thus the value is not returned early from each `try/catch` block.
 * That is to mimic the behavior of `require.resolve` exactly.
 *
 * @param moduleName module name to require
 * @returns possibly required module
 */ function loadModule(moduleName) {
    let mod;
    try {
        mod = dynamicRequire(module, moduleName);
    } catch (e) {
    // no-empty
    }
    try {
        const { cwd } = dynamicRequire(module, "process");
        mod = dynamicRequire(module, `${cwd()}/node_modules/${moduleName}`);
    } catch (e) {
    // no-empty
    }
    return mod;
}

});
parcelRegister("Wgg6o", function(module, exports) {

$parcel$export(module.exports, "isBrowserBundle", () => $0af207894032bdf2$export$2928c40372e623c0);
$parcel$export(module.exports, "getSDKSource", () => $0af207894032bdf2$export$8ad33f488b1ab046);
/*
 * This module exists for optimizations in the build process through rollup and terser.  We define some global
 * constants, which can be overridden during build. By guarding certain pieces of code with functions that return these
 * constants, we can control whether or not they appear in the final bundle. (Any code guarded by a false condition will
 * never run, and will hence be dropped during treeshaking.) The two primary uses for this are stripping out calls to
 * `logger` and preventing node-related code from appearing in browser bundles.
 *
 * Attention:
 * This file should not be used to define constants/flags that are intended to be used for tree-shaking conducted by
 * users. These flags should live in their respective packages, as we identified user tooling (specifically webpack)
 * having issues tree-shaking these constants across package boundaries.
 * An example for this is the __SENTRY_DEBUG__ constant. It is declared in each package individually because we want
 * users to be able to shake away expressions that it guards.
 */ /**
 * Figures out if we're building a browser bundle.
 *
 * @returns true if this is a browser bundle build.
 */ function $0af207894032bdf2$export$2928c40372e623c0() {
    return typeof __SENTRY_BROWSER_BUNDLE__ !== "undefined" && !!__SENTRY_BROWSER_BUNDLE__;
}
/**
 * Get source of SDK.
 */ function $0af207894032bdf2$export$8ad33f488b1ab046() {
    // @ts-expect-error "npm" is injected by rollup during build process
    return "npm";
}

});


parcelRegister("3bpJ1", function(module, exports) {

$parcel$export(module.exports, "GLOBAL_OBJ", () => $25165aaf01761cfd$export$f1a6cdb1459e81d1);
$parcel$export(module.exports, "getGlobalObject", () => $25165aaf01761cfd$export$256479dc0cea61c4);
$parcel$export(module.exports, "getGlobalSingleton", () => $25165aaf01761cfd$export$7e223ec222791509);
/** Internal global with common properties and Sentry extensions  */ // The code below for 'isGlobalObj' and 'GLOBAL_OBJ' was copied from core-js before modification
// https://github.com/zloirock/core-js/blob/1b944df55282cdc99c90db5f49eb0b6eda2cc0a3/packages/core-js/internals/global.js
// core-js has the following licence:
//
// Copyright (c) 2014-2022 Denis Pushkarev
//
// Permission is hereby granted, free of charge, to any person obtaining a copy
// of this software and associated documentation files (the "Software"), to deal
// in the Software without restriction, including without limitation the rights
// to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
// copies of the Software, and to permit persons to whom the Software is
// furnished to do so, subject to the following conditions:
//
// The above copyright notice and this permission notice shall be included in
// all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
// AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
// LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
// OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
// THE SOFTWARE.
/** Returns 'obj' if it's the global object, otherwise returns undefined */ function $25165aaf01761cfd$var$isGlobalObj(obj) {
    return obj && obj.Math == Math ? obj : undefined;
}
/** Get's the global object for the current JavaScript runtime */ const $25165aaf01761cfd$export$f1a6cdb1459e81d1 = typeof globalThis == "object" && $25165aaf01761cfd$var$isGlobalObj(globalThis) || // eslint-disable-next-line no-restricted-globals
typeof window == "object" && $25165aaf01761cfd$var$isGlobalObj(window) || typeof self == "object" && $25165aaf01761cfd$var$isGlobalObj(self) || typeof $parcel$global == "object" && $25165aaf01761cfd$var$isGlobalObj($parcel$global) || function() {
    return this;
}() || {};
/**
 * @deprecated Use GLOBAL_OBJ instead or WINDOW from @sentry/browser. This will be removed in v8
 */ function $25165aaf01761cfd$export$256479dc0cea61c4() {
    return $25165aaf01761cfd$export$f1a6cdb1459e81d1;
}
/**
 * Returns a global singleton contained in the global `__SENTRY__` object.
 *
 * If the singleton doesn't already exist in `__SENTRY__`, it will be created using the given factory
 * function and added to the `__SENTRY__` object.
 *
 * @param name name of the global singleton on __SENTRY__
 * @param creator creator Factory function to create the singleton if it doesn't already exist on `__SENTRY__`
 * @param obj (Optional) The global object on which to look for `__SENTRY__`, if not `GLOBAL_OBJ`'s return value
 * @returns the singleton
 */ function $25165aaf01761cfd$export$7e223ec222791509(name, creator, obj) {
    const gbl = obj || $25165aaf01761cfd$export$f1a6cdb1459e81d1;
    const __SENTRY__ = gbl.__SENTRY__ = gbl.__SENTRY__ || {};
    const singleton = __SENTRY__[name] || (__SENTRY__[name] = creator());
    return singleton;
}

});


parcelRegister("3NuqQ", function(module, exports) {

$parcel$export(module.exports, "addExtensionMethods", () => addExtensionMethods);

var $gu0hs = parcelRequire("gu0hs");
var $cmFjP = parcelRequire("cmFjP");

var $289ZW = parcelRequire("289ZW");
/**
 * @private
 */ function _autoloadDatabaseIntegrations() {
    const carrier = (0, $cmFjP.getMainCarrier)();
    if (!carrier.__SENTRY__) return;
    const packageToIntegrationMapping = {
        mongodb () {
            const integration = (0, $289ZW.dynamicRequire)(module, "./node/integrations/mongo");
            return new integration.Mongo();
        },
        mongoose () {
            const integration = (0, $289ZW.dynamicRequire)(module, "./node/integrations/mongo");
            return new integration.Mongo();
        },
        mysql () {
            const integration = (0, $289ZW.dynamicRequire)(module, "./node/integrations/mysql");
            return new integration.Mysql();
        },
        pg () {
            const integration = (0, $289ZW.dynamicRequire)(module, "./node/integrations/postgres");
            return new integration.Postgres();
        }
    };
    const mappedPackages = Object.keys(packageToIntegrationMapping).filter((moduleName)=>!!(0, $289ZW.loadModule)(moduleName)).map((pkg)=>{
        try {
            return packageToIntegrationMapping[pkg]();
        } catch (e) {
            return undefined;
        }
    }).filter((p)=>p);
    if (mappedPackages.length > 0) carrier.__SENTRY__.integrations = [
        ...carrier.__SENTRY__.integrations || [],
        ...mappedPackages
    ];
}
/**
 * This patches the global object and injects the Tracing extensions methods
 */ function addExtensionMethods() {
    (0, $gu0hs.addTracingExtensions)();
    // Detect and automatically load specified integrations.
    if ((0, $289ZW.isNodeEnv)()) _autoloadDatabaseIntegrations();
}

});
parcelRegister("gu0hs", function(module, exports) {

$parcel$export(module.exports, "startIdleTransaction", () => $bfffaa6649a6ba90$export$479dbd817e392a4f);
$parcel$export(module.exports, "addTracingExtensions", () => $bfffaa6649a6ba90$export$653d0ef2bad9cdf9);

var $4g0Ct = parcelRequire("4g0Ct");

var $8IHa9 = parcelRequire("8IHa9");

var $cmFjP = parcelRequire("cmFjP");

var $54O61 = parcelRequire("54O61");

var $2EZoq = parcelRequire("2EZoq");

var $kJ1jU = parcelRequire("kJ1jU");

var $6Tqu0 = parcelRequire("6Tqu0");
/** Returns all trace headers that are currently on the top scope. */ function $bfffaa6649a6ba90$var$traceHeaders() {
    const scope = this.getScope();
    const span = scope.getSpan();
    return span ? {
        "sentry-trace": span.toTraceparent()
    } : {};
}
/**
 * Creates a new transaction and adds a sampling decision if it doesn't yet have one.
 *
 * The Hub.startTransaction method delegates to this method to do its work, passing the Hub instance in as `this`, as if
 * it had been called on the hub directly. Exists as a separate function so that it can be injected into the class as an
 * "extension method."
 *
 * @param this: The Hub starting the transaction
 * @param transactionContext: Data used to configure the transaction
 * @param CustomSamplingContext: Optional data to be provided to the `tracesSampler` function (if any)
 *
 * @returns The new transaction
 *
 * @see {@link Hub.startTransaction}
 */ function $bfffaa6649a6ba90$var$_startTransaction(transactionContext, customSamplingContext) {
    const client = this.getClient();
    const options = client && client.getOptions() || {};
    const configInstrumenter = options.instrumenter || "sentry";
    const transactionInstrumenter = transactionContext.instrumenter || "sentry";
    if (configInstrumenter !== transactionInstrumenter) {
        (0, $8IHa9.DEBUG_BUILD) && (0, $4g0Ct.logger).error(`A transaction was started with instrumenter=\`${transactionInstrumenter}\`, but the SDK is configured with the \`${configInstrumenter}\` instrumenter.
The transaction will not be sampled. Please use the ${configInstrumenter} instrumentation to start transactions.`);
        transactionContext.sampled = false;
    }
    let transaction = new (0, $6Tqu0.Transaction)(transactionContext, this);
    transaction = (0, $kJ1jU.sampleTransaction)(transaction, options, {
        parentSampled: transactionContext.parentSampled,
        transactionContext: transactionContext,
        ...customSamplingContext
    });
    if (transaction.sampled) transaction.initSpanRecorder(options._experiments && options._experiments.maxSpans);
    if (client && client.emit) client.emit("startTransaction", transaction);
    return transaction;
}
/**
 * Create new idle transaction.
 */ function $bfffaa6649a6ba90$export$479dbd817e392a4f(hub, transactionContext, idleTimeout, finalTimeout, onScope, customSamplingContext, heartbeatInterval) {
    const client = hub.getClient();
    const options = client && client.getOptions() || {};
    let transaction = new (0, $2EZoq.IdleTransaction)(transactionContext, hub, idleTimeout, finalTimeout, heartbeatInterval, onScope);
    transaction = (0, $kJ1jU.sampleTransaction)(transaction, options, {
        parentSampled: transactionContext.parentSampled,
        transactionContext: transactionContext,
        ...customSamplingContext
    });
    if (transaction.sampled) transaction.initSpanRecorder(options._experiments && options._experiments.maxSpans);
    if (client && client.emit) client.emit("startTransaction", transaction);
    return transaction;
}
/**
 * Adds tracing extensions to the global hub.
 */ function $bfffaa6649a6ba90$export$653d0ef2bad9cdf9() {
    const carrier = (0, $cmFjP.getMainCarrier)();
    if (!carrier.__SENTRY__) return;
    carrier.__SENTRY__.extensions = carrier.__SENTRY__.extensions || {};
    if (!carrier.__SENTRY__.extensions.startTransaction) carrier.__SENTRY__.extensions.startTransaction = $bfffaa6649a6ba90$var$_startTransaction;
    if (!carrier.__SENTRY__.extensions.traceHeaders) carrier.__SENTRY__.extensions.traceHeaders = $bfffaa6649a6ba90$var$traceHeaders;
    (0, $54O61.registerErrorInstrumentation)();
}

});
parcelRegister("4g0Ct", function(module, exports) {

$parcel$export(module.exports, "CONSOLE_LEVELS", () => $3199231328e69de5$export$2a2b1d2252a69ecb);
$parcel$export(module.exports, "originalConsoleMethods", () => $3199231328e69de5$export$77c4ce905194557b);
$parcel$export(module.exports, "consoleSandbox", () => $3199231328e69de5$export$cda52e2a8927a2ca);
$parcel$export(module.exports, "logger", () => $3199231328e69de5$export$af88d00dbe7f521);

var $eKZKa = parcelRequire("eKZKa");

var $3bpJ1 = parcelRequire("3bpJ1");
/** Prefix for logging strings */ const $3199231328e69de5$var$PREFIX = "Sentry Logger ";
const $3199231328e69de5$export$2a2b1d2252a69ecb = [
    "debug",
    "info",
    "warn",
    "error",
    "log",
    "assert",
    "trace"
];
/** This may be mutated by the console instrumentation. */ const $3199231328e69de5$export$77c4ce905194557b = {};
/** JSDoc */ /**
 * Temporarily disable sentry console instrumentations.
 *
 * @param callback The function to run against the original `console` messages
 * @returns The results of the callback
 */ function $3199231328e69de5$export$cda52e2a8927a2ca(callback) {
    if (!("console" in (0, $3bpJ1.GLOBAL_OBJ))) return callback();
    const console = (0, $3bpJ1.GLOBAL_OBJ).console;
    const wrappedFuncs = {};
    const wrappedLevels = Object.keys($3199231328e69de5$export$77c4ce905194557b);
    // Restore all wrapped console methods
    wrappedLevels.forEach((level)=>{
        const originalConsoleMethod = $3199231328e69de5$export$77c4ce905194557b[level];
        wrappedFuncs[level] = console[level];
        console[level] = originalConsoleMethod;
    });
    try {
        return callback();
    } finally{
        // Revert restoration to wrapped state
        wrappedLevels.forEach((level)=>{
            console[level] = wrappedFuncs[level];
        });
    }
}
function $3199231328e69de5$var$makeLogger() {
    let enabled = false;
    const logger = {
        enable: ()=>{
            enabled = true;
        },
        disable: ()=>{
            enabled = false;
        },
        isEnabled: ()=>enabled
    };
    if (0, $eKZKa.DEBUG_BUILD) $3199231328e69de5$export$2a2b1d2252a69ecb.forEach((name)=>{
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        logger[name] = (...args)=>{
            if (enabled) $3199231328e69de5$export$cda52e2a8927a2ca(()=>{
                (0, $3bpJ1.GLOBAL_OBJ).console[name](`${$3199231328e69de5$var$PREFIX}[${name}]:`, ...args);
            });
        };
    });
    else $3199231328e69de5$export$2a2b1d2252a69ecb.forEach((name)=>{
        logger[name] = ()=>undefined;
    });
    return logger;
}
const $3199231328e69de5$export$af88d00dbe7f521 = $3199231328e69de5$var$makeLogger();

});
parcelRegister("eKZKa", function(module, exports) {

$parcel$export(module.exports, "DEBUG_BUILD", () => $abe5418a531ee1d6$export$16a28057038b10ef);
/**
 * This serves as a build time flag that will be true by default, but false in non-debug builds or if users replace `__SENTRY_DEBUG__` in their generated code.
 *
 * ATTENTION: This constant must never cross package boundaries (i.e. be exported) to guarantee that it can be used for tree shaking.
 */ const $abe5418a531ee1d6$export$16a28057038b10ef = typeof __SENTRY_DEBUG__ === "undefined" || __SENTRY_DEBUG__;

});


parcelRegister("8IHa9", function(module, exports) {

$parcel$export(module.exports, "DEBUG_BUILD", () => $6593ea065203555e$export$16a28057038b10ef);
/**
 * This serves as a build time flag that will be true by default, but false in non-debug builds or if users replace `__SENTRY_DEBUG__` in their generated code.
 *
 * ATTENTION: This constant must never cross package boundaries (i.e. be exported) to guarantee that it can be used for tree shaking.
 */ const $6593ea065203555e$export$16a28057038b10ef = typeof __SENTRY_DEBUG__ === "undefined" || __SENTRY_DEBUG__;

});

parcelRegister("cmFjP", function(module, exports) {

$parcel$export(module.exports, "getMainCarrier", () => $9007972943bbf579$export$19eade501500c6c1);
$parcel$export(module.exports, "getCurrentHub", () => $9007972943bbf579$export$a07cdf6544bbd7c);

var $4g0Ct = parcelRequire("4g0Ct");
var $cvSY8 = parcelRequire("cvSY8");
var $3bpJ1 = parcelRequire("3bpJ1");
var $b1E2c = parcelRequire("b1E2c");

var $kfXMR = parcelRequire("kfXMR");

var $8IHa9 = parcelRequire("8IHa9");

var $coQoV = parcelRequire("coQoV");

var $oyvka = parcelRequire("oyvka");

var $9OAWn = parcelRequire("9OAWn");
/**
 * API compatibility version of this hub.
 *
 * WARNING: This number should only be increased when the global interface
 * changes and new methods are introduced.
 *
 * @hidden
 */ const $9007972943bbf579$export$24a86ef7798177e4 = parseFloat((0, $9OAWn.SDK_VERSION));
/**
 * Default maximum number of breadcrumbs added to an event. Can be overwritten
 * with {@link Options.maxBreadcrumbs}.
 */ const $9007972943bbf579$var$DEFAULT_BREADCRUMBS = 100;
/**
 * @inheritDoc
 */ class $9007972943bbf579$export$8c41bb232f1008b1 {
    /** Is a {@link Layer}[] containing the client and scope */ /** Contains the last event id of a captured event.  */ /**
   * Creates a new instance of the hub, will push one {@link Layer} into the
   * internal stack on creation.
   *
   * @param client bound to the hub.
   * @param scope bound to the hub.
   * @param version number, higher number means higher priority.
   */ constructor(client, scope = new (0, $coQoV.Scope)(), _version = $9007972943bbf579$export$24a86ef7798177e4){
        this._version = _version;
        this._stack = [
            {
                scope: scope
            }
        ];
        if (client) this.bindClient(client);
    }
    /**
   * @inheritDoc
   */ isOlderThan(version) {
        return this._version < version;
    }
    /**
   * @inheritDoc
   */ bindClient(client) {
        const top = this.getStackTop();
        top.client = client;
        if (client && client.setupIntegrations) client.setupIntegrations();
    }
    /**
   * @inheritDoc
   */ pushScope() {
        // We want to clone the content of prev scope
        const scope = (0, $coQoV.Scope).clone(this.getScope());
        this.getStack().push({
            client: this.getClient(),
            scope: scope
        });
        return scope;
    }
    /**
   * @inheritDoc
   */ popScope() {
        if (this.getStack().length <= 1) return false;
        return !!this.getStack().pop();
    }
    /**
   * @inheritDoc
   */ withScope(callback) {
        const scope = this.pushScope();
        try {
            callback(scope);
        } finally{
            this.popScope();
        }
    }
    /**
   * @inheritDoc
   */ getClient() {
        return this.getStackTop().client;
    }
    /** Returns the scope of the top stack. */ getScope() {
        return this.getStackTop().scope;
    }
    /** Returns the scope stack for domains or the process. */ getStack() {
        return this._stack;
    }
    /** Returns the topmost scope layer in the order domain > local > process. */ getStackTop() {
        return this._stack[this._stack.length - 1];
    }
    /**
   * @inheritDoc
   */ captureException(exception, hint) {
        const eventId = this._lastEventId = hint && hint.event_id ? hint.event_id : (0, $b1E2c.uuid4)();
        const syntheticException = new Error("Sentry syntheticException");
        this._withClient((client, scope)=>{
            client.captureException(exception, {
                originalException: exception,
                syntheticException: syntheticException,
                ...hint,
                event_id: eventId
            }, scope);
        });
        return eventId;
    }
    /**
   * @inheritDoc
   */ captureMessage(message, // eslint-disable-next-line deprecation/deprecation
    level, hint) {
        const eventId = this._lastEventId = hint && hint.event_id ? hint.event_id : (0, $b1E2c.uuid4)();
        const syntheticException = new Error(message);
        this._withClient((client, scope)=>{
            client.captureMessage(message, level, {
                originalException: message,
                syntheticException: syntheticException,
                ...hint,
                event_id: eventId
            }, scope);
        });
        return eventId;
    }
    /**
   * @inheritDoc
   */ captureEvent(event, hint) {
        const eventId = hint && hint.event_id ? hint.event_id : (0, $b1E2c.uuid4)();
        if (!event.type) this._lastEventId = eventId;
        this._withClient((client, scope)=>{
            client.captureEvent(event, {
                ...hint,
                event_id: eventId
            }, scope);
        });
        return eventId;
    }
    /**
   * @inheritDoc
   */ lastEventId() {
        return this._lastEventId;
    }
    /**
   * @inheritDoc
   */ addBreadcrumb(breadcrumb, hint) {
        const { scope: scope, client: client } = this.getStackTop();
        if (!client) return;
        const { beforeBreadcrumb: beforeBreadcrumb = null, maxBreadcrumbs: maxBreadcrumbs = $9007972943bbf579$var$DEFAULT_BREADCRUMBS } = client.getOptions && client.getOptions() || {};
        if (maxBreadcrumbs <= 0) return;
        const timestamp = (0, $cvSY8.dateTimestampInSeconds)();
        const mergedBreadcrumb = {
            timestamp: timestamp,
            ...breadcrumb
        };
        const finalBreadcrumb = beforeBreadcrumb ? (0, $4g0Ct.consoleSandbox)(()=>beforeBreadcrumb(mergedBreadcrumb, hint)) : mergedBreadcrumb;
        if (finalBreadcrumb === null) return;
        if (client.emit) client.emit("beforeAddBreadcrumb", finalBreadcrumb, hint);
        scope.addBreadcrumb(finalBreadcrumb, maxBreadcrumbs);
    }
    /**
   * @inheritDoc
   */ setUser(user) {
        this.getScope().setUser(user);
    }
    /**
   * @inheritDoc
   */ setTags(tags) {
        this.getScope().setTags(tags);
    }
    /**
   * @inheritDoc
   */ setExtras(extras) {
        this.getScope().setExtras(extras);
    }
    /**
   * @inheritDoc
   */ setTag(key, value) {
        this.getScope().setTag(key, value);
    }
    /**
   * @inheritDoc
   */ setExtra(key, extra) {
        this.getScope().setExtra(key, extra);
    }
    /**
   * @inheritDoc
   */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
    setContext(name, context) {
        this.getScope().setContext(name, context);
    }
    /**
   * @inheritDoc
   */ configureScope(callback) {
        const { scope: scope, client: client } = this.getStackTop();
        if (client) callback(scope);
    }
    /**
   * @inheritDoc
   */ run(callback) {
        const oldHub = $9007972943bbf579$export$4188a14ad302d1bc(this);
        try {
            callback(this);
        } finally{
            $9007972943bbf579$export$4188a14ad302d1bc(oldHub);
        }
    }
    /**
   * @inheritDoc
   */ getIntegration(integration) {
        const client = this.getClient();
        if (!client) return null;
        try {
            return client.getIntegration(integration);
        } catch (_oO) {
            (0, $8IHa9.DEBUG_BUILD) && (0, $4g0Ct.logger).warn(`Cannot retrieve integration ${integration.id} from the current Hub`);
            return null;
        }
    }
    /**
   * @inheritDoc
   */ startTransaction(context, customSamplingContext) {
        const result = this._callExtensionMethod("startTransaction", context, customSamplingContext);
        if ((0, $8IHa9.DEBUG_BUILD) && !result) {
            const client = this.getClient();
            if (!client) (0, $4g0Ct.logger).warn("Tracing extension 'startTransaction' is missing. You should 'init' the SDK before calling 'startTransaction'");
            else (0, $4g0Ct.logger).warn(`Tracing extension 'startTransaction' has not been added. Call 'addTracingExtensions' before calling 'init':
Sentry.addTracingExtensions();
Sentry.init({...});
`);
        }
        return result;
    }
    /**
   * @inheritDoc
   */ traceHeaders() {
        return this._callExtensionMethod("traceHeaders");
    }
    /**
   * @inheritDoc
   */ captureSession(endSession = false) {
        // both send the update and pull the session from the scope
        if (endSession) return this.endSession();
        // only send the update
        this._sendSessionUpdate();
    }
    /**
   * @inheritDoc
   */ endSession() {
        const layer = this.getStackTop();
        const scope = layer.scope;
        const session = scope.getSession();
        if (session) (0, $oyvka.closeSession)(session);
        this._sendSessionUpdate();
        // the session is over; take it off of the scope
        scope.setSession();
    }
    /**
   * @inheritDoc
   */ startSession(context) {
        const { scope: scope, client: client } = this.getStackTop();
        const { release: release, environment: environment = (0, $kfXMR.DEFAULT_ENVIRONMENT) } = client && client.getOptions() || {};
        // Will fetch userAgent if called from browser sdk
        const { userAgent: userAgent } = (0, $3bpJ1.GLOBAL_OBJ).navigator || {};
        const session = (0, $oyvka.makeSession)({
            release: release,
            environment: environment,
            user: scope.getUser(),
            ...userAgent && {
                userAgent: userAgent
            },
            ...context
        });
        // End existing session if there's one
        const currentSession = scope.getSession && scope.getSession();
        if (currentSession && currentSession.status === "ok") (0, $oyvka.updateSession)(currentSession, {
            status: "exited"
        });
        this.endSession();
        // Afterwards we set the new session on the scope
        scope.setSession(session);
        return session;
    }
    /**
   * Returns if default PII should be sent to Sentry and propagated in ourgoing requests
   * when Tracing is used.
   */ shouldSendDefaultPii() {
        const client = this.getClient();
        const options = client && client.getOptions();
        return Boolean(options && options.sendDefaultPii);
    }
    /**
   * Sends the current Session on the scope
   */ _sendSessionUpdate() {
        const { scope: scope, client: client } = this.getStackTop();
        const session = scope.getSession();
        if (session && client && client.captureSession) client.captureSession(session);
    }
    /**
   * Internal helper function to call a method on the top client if it exists.
   *
   * @param method The method to call on the client.
   * @param args Arguments to pass to the client function.
   */ _withClient(callback) {
        const { scope: scope, client: client } = this.getStackTop();
        if (client) callback(client, scope);
    }
    /**
   * Calls global extension method and binding current instance to the function call
   */ // @ts-expect-error Function lacks ending return statement and return type does not include 'undefined'. ts(2366)
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    _callExtensionMethod(method, ...args) {
        const carrier = $9007972943bbf579$export$19eade501500c6c1();
        const sentry = carrier.__SENTRY__;
        if (sentry && sentry.extensions && typeof sentry.extensions[method] === "function") return sentry.extensions[method].apply(this, args);
        (0, $8IHa9.DEBUG_BUILD) && (0, $4g0Ct.logger).warn(`Extension method ${method} couldn't be found, doing nothing.`);
    }
}
/**
 * Returns the global shim registry.
 *
 * FIXME: This function is problematic, because despite always returning a valid Carrier,
 * it has an optional `__SENTRY__` property, which then in turn requires us to always perform an unnecessary check
 * at the call-site. We always access the carrier through this function, so we can guarantee that `__SENTRY__` is there.
 **/ function $9007972943bbf579$export$19eade501500c6c1() {
    (0, $3bpJ1.GLOBAL_OBJ).__SENTRY__ = (0, $3bpJ1.GLOBAL_OBJ).__SENTRY__ || {
        extensions: {},
        hub: undefined
    };
    return 0, $3bpJ1.GLOBAL_OBJ;
}
/**
 * Replaces the current main hub with the passed one on the global object
 *
 * @returns The old replaced hub
 */ function $9007972943bbf579$export$4188a14ad302d1bc(hub) {
    const registry = $9007972943bbf579$export$19eade501500c6c1();
    const oldHub = $9007972943bbf579$export$bfa8a924a84a76b7(registry);
    $9007972943bbf579$export$849f05434e95d2f2(registry, hub);
    return oldHub;
}
/**
 * Returns the default hub instance.
 *
 * If a hub is already registered in the global carrier but this module
 * contains a more recent version, it replaces the registered version.
 * Otherwise, the currently registered hub will be returned.
 */ function $9007972943bbf579$export$a07cdf6544bbd7c() {
    // Get main carrier (global for every environment)
    const registry = $9007972943bbf579$export$19eade501500c6c1();
    if (registry.__SENTRY__ && registry.__SENTRY__.acs) {
        const hub = registry.__SENTRY__.acs.getCurrentHub();
        if (hub) return hub;
    }
    // Return hub that lives on a global object
    return $9007972943bbf579$var$getGlobalHub(registry);
}
function $9007972943bbf579$var$getGlobalHub(registry = $9007972943bbf579$export$19eade501500c6c1()) {
    // If there's no hub, or its an old API, assign a new one
    if (!$9007972943bbf579$var$hasHubOnCarrier(registry) || $9007972943bbf579$export$bfa8a924a84a76b7(registry).isOlderThan($9007972943bbf579$export$24a86ef7798177e4)) $9007972943bbf579$export$849f05434e95d2f2(registry, new $9007972943bbf579$export$8c41bb232f1008b1());
    // Return hub that lives on a global object
    return $9007972943bbf579$export$bfa8a924a84a76b7(registry);
}
/**
 * @private Private API with no semver guarantees!
 *
 * If the carrier does not contain a hub, a new hub is created with the global hub client and scope.
 */ function $9007972943bbf579$export$236689a79f5aa020(carrier, parent = $9007972943bbf579$var$getGlobalHub()) {
    // If there's no hub on current domain, or it's an old API, assign a new one
    if (!$9007972943bbf579$var$hasHubOnCarrier(carrier) || $9007972943bbf579$export$bfa8a924a84a76b7(carrier).isOlderThan($9007972943bbf579$export$24a86ef7798177e4)) {
        const globalHubTopStack = parent.getStackTop();
        $9007972943bbf579$export$849f05434e95d2f2(carrier, new $9007972943bbf579$export$8c41bb232f1008b1(globalHubTopStack.client, (0, $coQoV.Scope).clone(globalHubTopStack.scope)));
    }
}
/**
 * @private Private API with no semver guarantees!
 *
 * Sets the global async context strategy
 */ function $9007972943bbf579$export$774ae0e6b6e444ca(strategy) {
    // Get main carrier (global for every environment)
    const registry = $9007972943bbf579$export$19eade501500c6c1();
    registry.__SENTRY__ = registry.__SENTRY__ || {};
    registry.__SENTRY__.acs = strategy;
}
/**
 * Runs the supplied callback in its own async context. Async Context strategies are defined per SDK.
 *
 * @param callback The callback to run in its own async context
 * @param options Options to pass to the async context strategy
 * @returns The result of the callback
 */ function $9007972943bbf579$export$70d775fb1f267027(callback, options = {}) {
    const registry = $9007972943bbf579$export$19eade501500c6c1();
    if (registry.__SENTRY__ && registry.__SENTRY__.acs) return registry.__SENTRY__.acs.runWithAsyncContext(callback, options);
    // if there was no strategy, fallback to just calling the callback
    return callback();
}
/**
 * This will tell whether a carrier has a hub on it or not
 * @param carrier object
 */ function $9007972943bbf579$var$hasHubOnCarrier(carrier) {
    return !!(carrier && carrier.__SENTRY__ && carrier.__SENTRY__.hub);
}
/**
 * This will create a new {@link Hub} and add to the passed object on
 * __SENTRY__.hub.
 * @param carrier object
 * @hidden
 */ function $9007972943bbf579$export$bfa8a924a84a76b7(carrier) {
    return (0, $3bpJ1.getGlobalSingleton)("hub", ()=>new $9007972943bbf579$export$8c41bb232f1008b1(), carrier);
}
/**
 * This will set passed {@link Hub} on the passed object's __SENTRY__.hub attribute
 * @param carrier object
 * @param hub Hub
 * @returns A boolean indicating success or failure
 */ function $9007972943bbf579$export$849f05434e95d2f2(carrier, hub) {
    if (!carrier) return false;
    const __SENTRY__ = carrier.__SENTRY__ = carrier.__SENTRY__ || {};
    __SENTRY__.hub = hub;
    return true;
}

});
parcelRegister("b1E2c", function(module, exports) {

$parcel$export(module.exports, "uuid4", () => $806ed7b2edb8ea09$export$19f53698e68b2496);
$parcel$export(module.exports, "getEventDescription", () => $806ed7b2edb8ea09$export$4157119e2b157127);
$parcel$export(module.exports, "addExceptionTypeValue", () => $806ed7b2edb8ea09$export$f26508487bf83ee7);
$parcel$export(module.exports, "addExceptionMechanism", () => $806ed7b2edb8ea09$export$c69a9a0313b03bb1);
$parcel$export(module.exports, "checkOrSetAlreadyCaught", () => $806ed7b2edb8ea09$export$6de4ffac6a2f1098);
$parcel$export(module.exports, "arrayify", () => $806ed7b2edb8ea09$export$3131421a7d01b4fb);

var $jL8lq = parcelRequire("jL8lq");

var $91U3U = parcelRequire("91U3U");

var $3bpJ1 = parcelRequire("3bpJ1");
/**
 * UUID4 generator
 *
 * @returns string Generated UUID4.
 */ function $806ed7b2edb8ea09$export$19f53698e68b2496() {
    const gbl = (0, $3bpJ1.GLOBAL_OBJ);
    const crypto = gbl.crypto || gbl.msCrypto;
    let getRandomByte = ()=>Math.random() * 16;
    try {
        if (crypto && crypto.randomUUID) return crypto.randomUUID().replace(/-/g, "");
        if (crypto && crypto.getRandomValues) getRandomByte = ()=>crypto.getRandomValues(new Uint8Array(1))[0];
    } catch (_) {
    // some runtimes can crash invoking crypto
    // https://github.com/getsentry/sentry-javascript/issues/8935
    }
    // http://stackoverflow.com/questions/105034/how-to-create-a-guid-uuid-in-javascript/2117523#2117523
    // Concatenating the following numbers as strings results in '10000000100040008000100000000000'
    return "10000000100040008000100000000000".replace(/[018]/g, (c)=>// eslint-disable-next-line no-bitwise
        (c ^ (getRandomByte() & 15) >> c / 4).toString(16));
}
function $806ed7b2edb8ea09$var$getFirstException(event) {
    return event.exception && event.exception.values ? event.exception.values[0] : undefined;
}
/**
 * Extracts either message or type+value from an event that can be used for user-facing logs
 * @returns event's description
 */ function $806ed7b2edb8ea09$export$4157119e2b157127(event) {
    const { message: message, event_id: eventId } = event;
    if (message) return message;
    const firstException = $806ed7b2edb8ea09$var$getFirstException(event);
    if (firstException) {
        if (firstException.type && firstException.value) return `${firstException.type}: ${firstException.value}`;
        return firstException.type || firstException.value || eventId || "<unknown>";
    }
    return eventId || "<unknown>";
}
/**
 * Adds exception values, type and value to an synthetic Exception.
 * @param event The event to modify.
 * @param value Value of the exception.
 * @param type Type of the exception.
 * @hidden
 */ function $806ed7b2edb8ea09$export$f26508487bf83ee7(event, value, type) {
    const exception = event.exception = event.exception || {};
    const values = exception.values = exception.values || [];
    const firstException = values[0] = values[0] || {};
    if (!firstException.value) firstException.value = value || "";
    if (!firstException.type) firstException.type = type || "Error";
}
/**
 * Adds exception mechanism data to a given event. Uses defaults if the second parameter is not passed.
 *
 * @param event The event to modify.
 * @param newMechanism Mechanism data to add to the event.
 * @hidden
 */ function $806ed7b2edb8ea09$export$c69a9a0313b03bb1(event, newMechanism) {
    const firstException = $806ed7b2edb8ea09$var$getFirstException(event);
    if (!firstException) return;
    const defaultMechanism = {
        type: "generic",
        handled: true
    };
    const currentMechanism = firstException.mechanism;
    firstException.mechanism = {
        ...defaultMechanism,
        ...currentMechanism,
        ...newMechanism
    };
    if (newMechanism && "data" in newMechanism) {
        const mergedData = {
            ...currentMechanism && currentMechanism.data,
            ...newMechanism.data
        };
        firstException.mechanism.data = mergedData;
    }
}
// https://semver.org/#is-there-a-suggested-regular-expression-regex-to-check-a-semver-string
const $806ed7b2edb8ea09$var$SEMVER_REGEXP = /^(0|[1-9]\d*)\.(0|[1-9]\d*)\.(0|[1-9]\d*)(?:-((?:0|[1-9]\d*|\d*[a-zA-Z-][0-9a-zA-Z-]*)(?:\.(?:0|[1-9]\d*|\d*[a-zA-Z-][0-9a-zA-Z-]*))*))?(?:\+([0-9a-zA-Z-]+(?:\.[0-9a-zA-Z-]+)*))?$/;
/**
 * Represents Semantic Versioning object
 */ /**
 * Parses input into a SemVer interface
 * @param input string representation of a semver version
 */ function $806ed7b2edb8ea09$export$d364f2020ab30578(input) {
    const match = input.match($806ed7b2edb8ea09$var$SEMVER_REGEXP) || [];
    const major = parseInt(match[1], 10);
    const minor = parseInt(match[2], 10);
    const patch = parseInt(match[3], 10);
    return {
        buildmetadata: match[5],
        major: isNaN(major) ? undefined : major,
        minor: isNaN(minor) ? undefined : minor,
        patch: isNaN(patch) ? undefined : patch,
        prerelease: match[4]
    };
}
/**
 * This function adds context (pre/post/line) lines to the provided frame
 *
 * @param lines string[] containing all lines
 * @param frame StackFrame that will be mutated
 * @param linesOfContext number of context lines we want to add pre/post
 */ function $806ed7b2edb8ea09$export$ec2291bfc64632f0(lines, frame, linesOfContext = 5) {
    // When there is no line number in the frame, attaching context is nonsensical and will even break grouping
    if (frame.lineno === undefined) return;
    const maxLines = lines.length;
    const sourceLine = Math.max(Math.min(maxLines - 1, frame.lineno - 1), 0);
    frame.pre_context = lines.slice(Math.max(0, sourceLine - linesOfContext), sourceLine).map((line)=>(0, $91U3U.snipLine)(line, 0));
    frame.context_line = (0, $91U3U.snipLine)(lines[Math.min(maxLines - 1, sourceLine)], frame.colno || 0);
    frame.post_context = lines.slice(Math.min(sourceLine + 1, maxLines), sourceLine + 1 + linesOfContext).map((line)=>(0, $91U3U.snipLine)(line, 0));
}
/**
 * Checks whether or not we've already captured the given exception (note: not an identical exception - the very object
 * in question), and marks it captured if not.
 *
 * This is useful because it's possible for an error to get captured by more than one mechanism. After we intercept and
 * record an error, we rethrow it (assuming we've intercepted it before it's reached the top-level global handlers), so
 * that we don't interfere with whatever effects the error might have had were the SDK not there. At that point, because
 * the error has been rethrown, it's possible for it to bubble up to some other code we've instrumented. If it's not
 * caught after that, it will bubble all the way up to the global handlers (which of course we also instrument). This
 * function helps us ensure that even if we encounter the same error more than once, we only record it the first time we
 * see it.
 *
 * Note: It will ignore primitives (always return `false` and not mark them as seen), as properties can't be set on
 * them. {@link: Object.objectify} can be used on exceptions to convert any that are primitives into their equivalent
 * object wrapper forms so that this check will always work. However, because we need to flag the exact object which
 * will get rethrown, and because that rethrowing happens outside of the event processing pipeline, the objectification
 * must be done before the exception captured.
 *
 * @param A thrown exception to check or flag as having been seen
 * @returns `true` if the exception has already been captured, `false` if not (with the side effect of marking it seen)
 */ function $806ed7b2edb8ea09$export$6de4ffac6a2f1098(exception) {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    if (exception && exception.__sentry_captured__) return true;
    try {
        // set it this way rather than by assignment so that it's not ennumerable and therefore isn't recorded by the
        // `ExtraErrorData` integration
        (0, $jL8lq.addNonEnumerableProperty)(exception, "__sentry_captured__", true);
    } catch (err) {
    // `exception` is a primitive, so we can't mark it seen
    }
    return false;
}
/**
 * Checks whether the given input is already an array, and if it isn't, wraps it in one.
 *
 * @param maybeArray Input to turn into an array, if necessary
 * @returns The input, if already an array, or an array with the input as the only element, if not
 */ function $806ed7b2edb8ea09$export$3131421a7d01b4fb(maybeArray) {
    return Array.isArray(maybeArray) ? maybeArray : [
        maybeArray
    ];
}

});
parcelRegister("jL8lq", function(module, exports) {

$parcel$export(module.exports, "fill", () => $e628e125e878fd27$export$9563e054e6f787fb);
$parcel$export(module.exports, "markFunctionWrapped", () => $e628e125e878fd27$export$5c1499e2e5d010ae);
$parcel$export(module.exports, "addNonEnumerableProperty", () => $e628e125e878fd27$export$e73679ffaf56810e);
$parcel$export(module.exports, "getOriginalFunction", () => $e628e125e878fd27$export$e6cc1e135e2092e5);
$parcel$export(module.exports, "urlEncode", () => $e628e125e878fd27$export$9ef804feabbcbaf1);
$parcel$export(module.exports, "convertToPlainObject", () => $e628e125e878fd27$export$62ff257738bf57f5);
$parcel$export(module.exports, "extractExceptionKeysForMessage", () => $e628e125e878fd27$export$b0244d5063c0b61b);
$parcel$export(module.exports, "dropUndefinedKeys", () => $e628e125e878fd27$export$d25f2688db1bb433);

var $ibKgU = parcelRequire("ibKgU");

var $eKZKa = parcelRequire("eKZKa");

var $2zW56 = parcelRequire("2zW56");

var $4g0Ct = parcelRequire("4g0Ct");

var $91U3U = parcelRequire("91U3U");
/**
 * Replace a method in an object with a wrapped version of itself.
 *
 * @param source An object that contains a method to be wrapped.
 * @param name The name of the method to be wrapped.
 * @param replacementFactory A higher-order function that takes the original version of the given method and returns a
 * wrapped version. Note: The function returned by `replacementFactory` needs to be a non-arrow function, in order to
 * preserve the correct value of `this`, and the original method must be called using `origMethod.call(this, <other
 * args>)` or `origMethod.apply(this, [<other args>])` (rather than being called directly), again to preserve `this`.
 * @returns void
 */ function $e628e125e878fd27$export$9563e054e6f787fb(source, name, replacementFactory) {
    if (!(name in source)) return;
    const original = source[name];
    const wrapped = replacementFactory(original);
    // Make sure it's a function first, as we need to attach an empty prototype for `defineProperties` to work
    // otherwise it'll throw "TypeError: Object.defineProperties called on non-object"
    if (typeof wrapped === "function") $e628e125e878fd27$export$5c1499e2e5d010ae(wrapped, original);
    source[name] = wrapped;
}
/**
 * Defines a non-enumerable property on the given object.
 *
 * @param obj The object on which to set the property
 * @param name The name of the property to be set
 * @param value The value to which to set the property
 */ function $e628e125e878fd27$export$e73679ffaf56810e(obj, name, value) {
    try {
        Object.defineProperty(obj, name, {
            // enumerable: false, // the default, so we can save on bundle size by not explicitly setting it
            value: value,
            writable: true,
            configurable: true
        });
    } catch (o_O) {
        (0, $eKZKa.DEBUG_BUILD) && (0, $4g0Ct.logger).log(`Failed to add non-enumerable property "${name}" to object`, obj);
    }
}
/**
 * Remembers the original function on the wrapped function and
 * patches up the prototype.
 *
 * @param wrapped the wrapper function
 * @param original the original function that gets wrapped
 */ function $e628e125e878fd27$export$5c1499e2e5d010ae(wrapped, original) {
    try {
        const proto = original.prototype || {};
        wrapped.prototype = original.prototype = proto;
        $e628e125e878fd27$export$e73679ffaf56810e(wrapped, "__sentry_original__", original);
    } catch (o_O) {} // eslint-disable-line no-empty
}
/**
 * This extracts the original function if available.  See
 * `markFunctionWrapped` for more information.
 *
 * @param func the function to unwrap
 * @returns the unwrapped version of the function if available.
 */ function $e628e125e878fd27$export$e6cc1e135e2092e5(func) {
    return func.__sentry_original__;
}
/**
 * Encodes given object into url-friendly format
 *
 * @param object An object that contains serializable values
 * @returns string Encoded
 */ function $e628e125e878fd27$export$9ef804feabbcbaf1(object) {
    return Object.keys(object).map((key)=>`${encodeURIComponent(key)}=${encodeURIComponent(object[key])}`).join("&");
}
/**
 * Transforms any `Error` or `Event` into a plain object with all of their enumerable properties, and some of their
 * non-enumerable properties attached.
 *
 * @param value Initial source that we have to transform in order for it to be usable by the serializer
 * @returns An Event or Error turned into an object - or the value argurment itself, when value is neither an Event nor
 *  an Error.
 */ function $e628e125e878fd27$export$62ff257738bf57f5(value) {
    if ((0, $2zW56.isError)(value)) return {
        message: value.message,
        name: value.name,
        stack: value.stack,
        ...$e628e125e878fd27$var$getOwnProperties(value)
    };
    else if ((0, $2zW56.isEvent)(value)) {
        const newObj = {
            type: value.type,
            target: $e628e125e878fd27$var$serializeEventTarget(value.target),
            currentTarget: $e628e125e878fd27$var$serializeEventTarget(value.currentTarget),
            ...$e628e125e878fd27$var$getOwnProperties(value)
        };
        if (typeof CustomEvent !== "undefined" && (0, $2zW56.isInstanceOf)(value, CustomEvent)) newObj.detail = value.detail;
        return newObj;
    } else return value;
}
/** Creates a string representation of the target of an `Event` object */ function $e628e125e878fd27$var$serializeEventTarget(target) {
    try {
        return (0, $2zW56.isElement)(target) ? (0, $ibKgU.htmlTreeAsString)(target) : Object.prototype.toString.call(target);
    } catch (_oO) {
        return "<unknown>";
    }
}
/** Filters out all but an object's own properties */ function $e628e125e878fd27$var$getOwnProperties(obj) {
    if (typeof obj === "object" && obj !== null) {
        const extractedProps = {};
        for(const property in obj)if (Object.prototype.hasOwnProperty.call(obj, property)) extractedProps[property] = obj[property];
        return extractedProps;
    } else return {};
}
/**
 * Given any captured exception, extract its keys and create a sorted
 * and truncated list that will be used inside the event message.
 * eg. `Non-error exception captured with keys: foo, bar, baz`
 */ function $e628e125e878fd27$export$b0244d5063c0b61b(exception, maxLength = 40) {
    const keys = Object.keys($e628e125e878fd27$export$62ff257738bf57f5(exception));
    keys.sort();
    if (!keys.length) return "[object has no keys]";
    if (keys[0].length >= maxLength) return (0, $91U3U.truncate)(keys[0], maxLength);
    for(let includedKeys = keys.length; includedKeys > 0; includedKeys--){
        const serialized = keys.slice(0, includedKeys).join(", ");
        if (serialized.length > maxLength) continue;
        if (includedKeys === keys.length) return serialized;
        return (0, $91U3U.truncate)(serialized, maxLength);
    }
    return "";
}
/**
 * Given any object, return a new object having removed all fields whose value was `undefined`.
 * Works recursively on objects and arrays.
 *
 * Attention: This function keeps circular references in the returned object.
 */ function $e628e125e878fd27$export$d25f2688db1bb433(inputValue) {
    // This map keeps track of what already visited nodes map to.
    // Our Set - based memoBuilder doesn't work here because we want to the output object to have the same circular
    // references as the input object.
    const memoizationMap = new Map();
    // This function just proxies `_dropUndefinedKeys` to keep the `memoBuilder` out of this function's API
    return $e628e125e878fd27$var$_dropUndefinedKeys(inputValue, memoizationMap);
}
function $e628e125e878fd27$var$_dropUndefinedKeys(inputValue, memoizationMap) {
    if ((0, $2zW56.isPlainObject)(inputValue)) {
        // If this node has already been visited due to a circular reference, return the object it was mapped to in the new object
        const memoVal = memoizationMap.get(inputValue);
        if (memoVal !== undefined) return memoVal;
        const returnValue = {};
        // Store the mapping of this value in case we visit it again, in case of circular data
        memoizationMap.set(inputValue, returnValue);
        for (const key of Object.keys(inputValue))if (typeof inputValue[key] !== "undefined") returnValue[key] = $e628e125e878fd27$var$_dropUndefinedKeys(inputValue[key], memoizationMap);
        return returnValue;
    }
    if (Array.isArray(inputValue)) {
        // If this node has already been visited due to a circular reference, return the array it was mapped to in the new object
        const memoVal = memoizationMap.get(inputValue);
        if (memoVal !== undefined) return memoVal;
        const returnValue = [];
        // Store the mapping of this value in case we visit it again, in case of circular data
        memoizationMap.set(inputValue, returnValue);
        inputValue.forEach((item)=>{
            returnValue.push($e628e125e878fd27$var$_dropUndefinedKeys(item, memoizationMap));
        });
        return returnValue;
    }
    return inputValue;
}
/**
 * Ensure that something is an object.
 *
 * Turns `undefined` and `null` into `String`s and all other primitives into instances of their respective wrapper
 * classes (String, Boolean, Number, etc.). Acts as the identity function on non-primitives.
 *
 * @param wat The subject of the objectification
 * @returns A version of `wat` which can safely be used with `Object` class methods
 */ function $e628e125e878fd27$export$92b78acdbe066b6b(wat) {
    let objectified;
    switch(true){
        case wat === undefined || wat === null:
            objectified = new String(wat);
            break;
        // Though symbols and bigints do have wrapper classes (`Symbol` and `BigInt`, respectively), for whatever reason
        // those classes don't have constructors which can be used with the `new` keyword. We therefore need to cast each as
        // an object in order to wrap it.
        case typeof wat === "symbol" || typeof wat === "bigint":
            objectified = Object(wat);
            break;
        // this will catch the remaining primitives: `String`, `Number`, and `Boolean`
        case (0, $2zW56.isPrimitive)(wat):
            // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
            objectified = new wat.constructor(wat);
            break;
        // by process of elimination, at this point we know that `wat` must already be an object
        default:
            objectified = wat;
            break;
    }
    return objectified;
}

});
parcelRegister("ibKgU", function(module, exports) {

$parcel$export(module.exports, "htmlTreeAsString", () => $d3dd25a69ce66c78$export$5647df6b7814ac86);
$parcel$export(module.exports, "getLocationHref", () => $d3dd25a69ce66c78$export$1cfafeee2987818b);
$parcel$export(module.exports, "getDomElement", () => $d3dd25a69ce66c78$export$c660c1f3ab49225c);

var $2zW56 = parcelRequire("2zW56");

var $3bpJ1 = parcelRequire("3bpJ1");
// eslint-disable-next-line deprecation/deprecation
const $d3dd25a69ce66c78$var$WINDOW = (0, $3bpJ1.getGlobalObject)();
const $d3dd25a69ce66c78$var$DEFAULT_MAX_STRING_LENGTH = 80;
/**
 * Given a child DOM element, returns a query-selector statement describing that
 * and its ancestors
 * e.g. [HTMLElement] => body > div > input#foo.btn[name=baz]
 * @returns generated DOM path
 */ function $d3dd25a69ce66c78$export$5647df6b7814ac86(elem, options = {}) {
    if (!elem) return "<unknown>";
    // try/catch both:
    // - accessing event.target (see getsentry/raven-js#838, #768)
    // - `htmlTreeAsString` because it's complex, and just accessing the DOM incorrectly
    // - can throw an exception in some circumstances.
    try {
        let currentElem = elem;
        const MAX_TRAVERSE_HEIGHT = 5;
        const out = [];
        let height = 0;
        let len = 0;
        const separator = " > ";
        const sepLength = separator.length;
        let nextStr;
        const keyAttrs = Array.isArray(options) ? options : options.keyAttrs;
        const maxStringLength = !Array.isArray(options) && options.maxStringLength || $d3dd25a69ce66c78$var$DEFAULT_MAX_STRING_LENGTH;
        while(currentElem && height++ < MAX_TRAVERSE_HEIGHT){
            nextStr = $d3dd25a69ce66c78$var$_htmlElementAsString(currentElem, keyAttrs);
            // bail out if
            // - nextStr is the 'html' element
            // - the length of the string that would be created exceeds maxStringLength
            //   (ignore this limit if we are on the first iteration)
            if (nextStr === "html" || height > 1 && len + out.length * sepLength + nextStr.length >= maxStringLength) break;
            out.push(nextStr);
            len += nextStr.length;
            currentElem = currentElem.parentNode;
        }
        return out.reverse().join(separator);
    } catch (_oO) {
        return "<unknown>";
    }
}
/**
 * Returns a simple, query-selector representation of a DOM element
 * e.g. [HTMLElement] => input#foo.btn[name=baz]
 * @returns generated DOM path
 */ function $d3dd25a69ce66c78$var$_htmlElementAsString(el, keyAttrs) {
    const elem = el;
    const out = [];
    let className;
    let classes;
    let key;
    let attr;
    let i;
    if (!elem || !elem.tagName) return "";
    out.push(elem.tagName.toLowerCase());
    // Pairs of attribute keys defined in `serializeAttribute` and their values on element.
    const keyAttrPairs = keyAttrs && keyAttrs.length ? keyAttrs.filter((keyAttr)=>elem.getAttribute(keyAttr)).map((keyAttr)=>[
            keyAttr,
            elem.getAttribute(keyAttr)
        ]) : null;
    if (keyAttrPairs && keyAttrPairs.length) keyAttrPairs.forEach((keyAttrPair)=>{
        out.push(`[${keyAttrPair[0]}="${keyAttrPair[1]}"]`);
    });
    else {
        if (elem.id) out.push(`#${elem.id}`);
        // eslint-disable-next-line prefer-const
        className = elem.className;
        if (className && (0, $2zW56.isString)(className)) {
            classes = className.split(/\s+/);
            for(i = 0; i < classes.length; i++)out.push(`.${classes[i]}`);
        }
    }
    const allowedAttrs = [
        "aria-label",
        "type",
        "name",
        "title",
        "alt"
    ];
    for(i = 0; i < allowedAttrs.length; i++){
        key = allowedAttrs[i];
        attr = elem.getAttribute(key);
        if (attr) out.push(`[${key}="${attr}"]`);
    }
    return out.join("");
}
/**
 * A safe form of location.href
 */ function $d3dd25a69ce66c78$export$1cfafeee2987818b() {
    try {
        return $d3dd25a69ce66c78$var$WINDOW.document.location.href;
    } catch (oO) {
        return "";
    }
}
/**
 * Gets a DOM element by using document.querySelector.
 *
 * This wrapper will first check for the existance of the function before
 * actually calling it so that we don't have to take care of this check,
 * every time we want to access the DOM.
 *
 * Reason: DOM/querySelector is not available in all environments.
 *
 * We have to cast to any because utils can be consumed by a variety of environments,
 * and we don't want to break TS users. If you know what element will be selected by
 * `document.querySelector`, specify it as part of the generic call. For example,
 * `const element = getDomElement<Element>('selector');`
 *
 * @param selector the selector string passed on to document.querySelector
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function $d3dd25a69ce66c78$export$c660c1f3ab49225c(selector) {
    if ($d3dd25a69ce66c78$var$WINDOW.document && $d3dd25a69ce66c78$var$WINDOW.document.querySelector) return $d3dd25a69ce66c78$var$WINDOW.document.querySelector(selector);
    return null;
}

});
parcelRegister("2zW56", function(module, exports) {

$parcel$export(module.exports, "isError", () => $1e0be767ffa822d8$export$e6127cc7fe7395c3);
$parcel$export(module.exports, "isInstanceOf", () => $1e0be767ffa822d8$export$49034edbe6b62415);
$parcel$export(module.exports, "isErrorEvent", () => $1e0be767ffa822d8$export$9f9636d330b71954);
$parcel$export(module.exports, "isDOMError", () => $1e0be767ffa822d8$export$ef9e2056653f0c8e);
$parcel$export(module.exports, "isDOMException", () => $1e0be767ffa822d8$export$12e869b2a583f783);
$parcel$export(module.exports, "isString", () => $1e0be767ffa822d8$export$844ec244b1367d54);
$parcel$export(module.exports, "isPrimitive", () => $1e0be767ffa822d8$export$c3825b437cbdea5c);
$parcel$export(module.exports, "isPlainObject", () => $1e0be767ffa822d8$export$53b83ca8eaab0383);
$parcel$export(module.exports, "isEvent", () => $1e0be767ffa822d8$export$9671ea99bd126ace);
$parcel$export(module.exports, "isElement", () => $1e0be767ffa822d8$export$45a5e7f76e0caa8d);
$parcel$export(module.exports, "isRegExp", () => $1e0be767ffa822d8$export$49841c62b9eff15);
$parcel$export(module.exports, "isThenable", () => $1e0be767ffa822d8$export$f5b060c2914b97c8);
$parcel$export(module.exports, "isSyntheticEvent", () => $1e0be767ffa822d8$export$bc2894c7158efbac);
$parcel$export(module.exports, "isNaN", () => $1e0be767ffa822d8$export$c9f5652083b8129d);
$parcel$export(module.exports, "isVueViewModel", () => $1e0be767ffa822d8$export$7916fad0ebc23f48);
// eslint-disable-next-line @typescript-eslint/unbound-method
const $1e0be767ffa822d8$var$objectToString = Object.prototype.toString;
/**
 * Checks whether given value's type is one of a few Error or Error-like
 * {@link isError}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $1e0be767ffa822d8$export$e6127cc7fe7395c3(wat) {
    switch($1e0be767ffa822d8$var$objectToString.call(wat)){
        case "[object Error]":
        case "[object Exception]":
        case "[object DOMException]":
            return true;
        default:
            return $1e0be767ffa822d8$export$49034edbe6b62415(wat, Error);
    }
}
/**
 * Checks whether given value is an instance of the given built-in class.
 *
 * @param wat The value to be checked
 * @param className
 * @returns A boolean representing the result.
 */ function $1e0be767ffa822d8$var$isBuiltin(wat, className) {
    return $1e0be767ffa822d8$var$objectToString.call(wat) === `[object ${className}]`;
}
/**
 * Checks whether given value's type is ErrorEvent
 * {@link isErrorEvent}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $1e0be767ffa822d8$export$9f9636d330b71954(wat) {
    return $1e0be767ffa822d8$var$isBuiltin(wat, "ErrorEvent");
}
/**
 * Checks whether given value's type is DOMError
 * {@link isDOMError}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $1e0be767ffa822d8$export$ef9e2056653f0c8e(wat) {
    return $1e0be767ffa822d8$var$isBuiltin(wat, "DOMError");
}
/**
 * Checks whether given value's type is DOMException
 * {@link isDOMException}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $1e0be767ffa822d8$export$12e869b2a583f783(wat) {
    return $1e0be767ffa822d8$var$isBuiltin(wat, "DOMException");
}
/**
 * Checks whether given value's type is a string
 * {@link isString}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $1e0be767ffa822d8$export$844ec244b1367d54(wat) {
    return $1e0be767ffa822d8$var$isBuiltin(wat, "String");
}
/**
 * Checks whether given value is a primitive (undefined, null, number, boolean, string, bigint, symbol)
 * {@link isPrimitive}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $1e0be767ffa822d8$export$c3825b437cbdea5c(wat) {
    return wat === null || typeof wat !== "object" && typeof wat !== "function";
}
/**
 * Checks whether given value's type is an object literal
 * {@link isPlainObject}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $1e0be767ffa822d8$export$53b83ca8eaab0383(wat) {
    return $1e0be767ffa822d8$var$isBuiltin(wat, "Object");
}
/**
 * Checks whether given value's type is an Event instance
 * {@link isEvent}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $1e0be767ffa822d8$export$9671ea99bd126ace(wat) {
    return typeof Event !== "undefined" && $1e0be767ffa822d8$export$49034edbe6b62415(wat, Event);
}
/**
 * Checks whether given value's type is an Element instance
 * {@link isElement}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $1e0be767ffa822d8$export$45a5e7f76e0caa8d(wat) {
    return typeof Element !== "undefined" && $1e0be767ffa822d8$export$49034edbe6b62415(wat, Element);
}
/**
 * Checks whether given value's type is an regexp
 * {@link isRegExp}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $1e0be767ffa822d8$export$49841c62b9eff15(wat) {
    return $1e0be767ffa822d8$var$isBuiltin(wat, "RegExp");
}
/**
 * Checks whether given value has a then function.
 * @param wat A value to be checked.
 */ function $1e0be767ffa822d8$export$f5b060c2914b97c8(wat) {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    return Boolean(wat && wat.then && typeof wat.then === "function");
}
/**
 * Checks whether given value's type is a SyntheticEvent
 * {@link isSyntheticEvent}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $1e0be767ffa822d8$export$bc2894c7158efbac(wat) {
    return $1e0be767ffa822d8$export$53b83ca8eaab0383(wat) && "nativeEvent" in wat && "preventDefault" in wat && "stopPropagation" in wat;
}
/**
 * Checks whether given value is NaN
 * {@link isNaN}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $1e0be767ffa822d8$export$c9f5652083b8129d(wat) {
    return typeof wat === "number" && wat !== wat;
}
/**
 * Checks whether given value's type is an instance of provided constructor.
 * {@link isInstanceOf}.
 *
 * @param wat A value to be checked.
 * @param base A constructor to be used in a check.
 * @returns A boolean representing the result.
 */ function $1e0be767ffa822d8$export$49034edbe6b62415(wat, base) {
    try {
        return wat instanceof base;
    } catch (_e) {
        return false;
    }
}
/**
 * Checks whether given value's type is a Vue ViewModel.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $1e0be767ffa822d8$export$7916fad0ebc23f48(wat) {
    // Not using Object.prototype.toString because in Vue 3 it would read the instance's Symbol(Symbol.toStringTag) property.
    return !!(typeof wat === "object" && wat !== null && (wat.__isVue || wat._isVue));
}

});


parcelRegister("91U3U", function(module, exports) {

$parcel$export(module.exports, "truncate", () => $692fb1c9fae23fc3$export$6a506b36fdea397d);
$parcel$export(module.exports, "snipLine", () => $692fb1c9fae23fc3$export$4215662d762d6f9d);
$parcel$export(module.exports, "safeJoin", () => $692fb1c9fae23fc3$export$465e9d514283d4fd);
$parcel$export(module.exports, "stringMatchesSomePattern", () => $692fb1c9fae23fc3$export$a7a5ec66062ea5d);

var $2zW56 = parcelRequire("2zW56");
/**
 * Truncates given string to the maximum characters count
 *
 * @param str An object that contains serializable values
 * @param max Maximum number of characters in truncated string (0 = unlimited)
 * @returns string Encoded
 */ function $692fb1c9fae23fc3$export$6a506b36fdea397d(str, max = 0) {
    if (typeof str !== "string" || max === 0) return str;
    return str.length <= max ? str : `${str.slice(0, max)}...`;
}
/**
 * This is basically just `trim_line` from
 * https://github.com/getsentry/sentry/blob/master/src/sentry/lang/javascript/processor.py#L67
 *
 * @param str An object that contains serializable values
 * @param max Maximum number of characters in truncated string
 * @returns string Encoded
 */ function $692fb1c9fae23fc3$export$4215662d762d6f9d(line, colno) {
    let newLine = line;
    const lineLength = newLine.length;
    if (lineLength <= 150) return newLine;
    if (colno > lineLength) // eslint-disable-next-line no-param-reassign
    colno = lineLength;
    let start = Math.max(colno - 60, 0);
    if (start < 5) start = 0;
    let end = Math.min(start + 140, lineLength);
    if (end > lineLength - 5) end = lineLength;
    if (end === lineLength) start = Math.max(end - 140, 0);
    newLine = newLine.slice(start, end);
    if (start > 0) newLine = `'{snip} ${newLine}`;
    if (end < lineLength) newLine += " {snip}";
    return newLine;
}
/**
 * Join values in array
 * @param input array of values to be joined together
 * @param delimiter string to be placed in-between values
 * @returns Joined values
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function $692fb1c9fae23fc3$export$465e9d514283d4fd(input, delimiter) {
    if (!Array.isArray(input)) return "";
    const output = [];
    // eslint-disable-next-line @typescript-eslint/prefer-for-of
    for(let i = 0; i < input.length; i++){
        const value = input[i];
        try {
            // This is a hack to fix a Vue3-specific bug that causes an infinite loop of
            // console warnings. This happens when a Vue template is rendered with
            // an undeclared variable, which we try to stringify, ultimately causing
            // Vue to issue another warning which repeats indefinitely.
            // see: https://github.com/getsentry/sentry-javascript/pull/8981
            if ((0, $2zW56.isVueViewModel)(value)) output.push("[VueViewModel]");
            else output.push(String(value));
        } catch (e) {
            output.push("[value cannot be serialized]");
        }
    }
    return output.join(delimiter);
}
/**
 * Checks if the given value matches a regex or string
 *
 * @param value The string to test
 * @param pattern Either a regex or a string against which `value` will be matched
 * @param requireExactStringMatch If true, `value` must match `pattern` exactly. If false, `value` will match
 * `pattern` if it contains `pattern`. Only applies to string-type patterns.
 */ function $692fb1c9fae23fc3$export$cdded5b28a5f8c6d(value, pattern, requireExactStringMatch = false) {
    if (!(0, $2zW56.isString)(value)) return false;
    if ((0, $2zW56.isRegExp)(pattern)) return pattern.test(value);
    if ((0, $2zW56.isString)(pattern)) return requireExactStringMatch ? value === pattern : value.includes(pattern);
    return false;
}
/**
 * Test the given string against an array of strings and regexes. By default, string matching is done on a
 * substring-inclusion basis rather than a strict equality basis
 *
 * @param testString The string to test
 * @param patterns The patterns against which to test the string
 * @param requireExactStringMatch If true, `testString` must match one of the given string patterns exactly in order to
 * count. If false, `testString` will match a string pattern if it contains that pattern.
 * @returns
 */ function $692fb1c9fae23fc3$export$a7a5ec66062ea5d(testString, patterns = [], requireExactStringMatch = false) {
    return patterns.some((pattern)=>$692fb1c9fae23fc3$export$cdded5b28a5f8c6d(testString, pattern, requireExactStringMatch));
}

});



parcelRegister("kfXMR", function(module, exports) {

$parcel$export(module.exports, "DEFAULT_ENVIRONMENT", () => $ebf395d8a45b5e48$export$849dbeeeda01ae98);
const $ebf395d8a45b5e48$export$849dbeeeda01ae98 = "production";

});

parcelRegister("coQoV", function(module, exports) {

$parcel$export(module.exports, "Scope", () => $90705fab783f17f9$export$775b6bb06e53a214);

var $b1E2c = parcelRequire("b1E2c");
var $cvSY8 = parcelRequire("cvSY8");
var $2zW56 = parcelRequire("2zW56");

var $6T4Sa = parcelRequire("6T4Sa");

var $oyvka = parcelRequire("oyvka");
/**
 * Default value for maximum number of breadcrumbs added to an event.
 */ const $90705fab783f17f9$var$DEFAULT_MAX_BREADCRUMBS = 100;
/**
 * Holds additional event information. {@link Scope.applyToEvent} will be
 * called by the client before an event will be sent.
 */ class $90705fab783f17f9$export$775b6bb06e53a214 {
    /** Flag if notifying is happening. */ /** Callback for client to receive scope changes. */ /** Callback list that will be called after {@link applyToEvent}. */ /** Array of breadcrumbs. */ /** User */ /** Tags */ /** Extra */ /** Contexts */ /** Attachments */ /** Propagation Context for distributed tracing */ /**
   * A place to stash data which is needed at some point in the SDK's event processing pipeline but which shouldn't get
   * sent to Sentry
   */ /** Fingerprint */ /** Severity */ // eslint-disable-next-line deprecation/deprecation
    /** Transaction Name */ /** Span */ /** Session */ /** Request Mode Session Status */ // NOTE: Any field which gets added here should get added not only to the constructor but also to the `clone` method.
    constructor(){
        this._notifyingListeners = false;
        this._scopeListeners = [];
        this._eventProcessors = [];
        this._breadcrumbs = [];
        this._attachments = [];
        this._user = {};
        this._tags = {};
        this._extra = {};
        this._contexts = {};
        this._sdkProcessingMetadata = {};
        this._propagationContext = $90705fab783f17f9$var$generatePropagationContext();
    }
    /**
   * Inherit values from the parent scope.
   * @param scope to clone.
   */ static clone(scope) {
        const newScope = new $90705fab783f17f9$export$775b6bb06e53a214();
        if (scope) {
            newScope._breadcrumbs = [
                ...scope._breadcrumbs
            ];
            newScope._tags = {
                ...scope._tags
            };
            newScope._extra = {
                ...scope._extra
            };
            newScope._contexts = {
                ...scope._contexts
            };
            newScope._user = scope._user;
            newScope._level = scope._level;
            newScope._span = scope._span;
            newScope._session = scope._session;
            newScope._transactionName = scope._transactionName;
            newScope._fingerprint = scope._fingerprint;
            newScope._eventProcessors = [
                ...scope._eventProcessors
            ];
            newScope._requestSession = scope._requestSession;
            newScope._attachments = [
                ...scope._attachments
            ];
            newScope._sdkProcessingMetadata = {
                ...scope._sdkProcessingMetadata
            };
            newScope._propagationContext = {
                ...scope._propagationContext
            };
        }
        return newScope;
    }
    /**
   * Add internal on change listener. Used for sub SDKs that need to store the scope.
   * @hidden
   */ addScopeListener(callback) {
        this._scopeListeners.push(callback);
    }
    /**
   * @inheritDoc
   */ addEventProcessor(callback) {
        this._eventProcessors.push(callback);
        return this;
    }
    /**
   * @inheritDoc
   */ setUser(user) {
        this._user = user || {};
        if (this._session) (0, $oyvka.updateSession)(this._session, {
            user: user
        });
        this._notifyScopeListeners();
        return this;
    }
    /**
   * @inheritDoc
   */ getUser() {
        return this._user;
    }
    /**
   * @inheritDoc
   */ getRequestSession() {
        return this._requestSession;
    }
    /**
   * @inheritDoc
   */ setRequestSession(requestSession) {
        this._requestSession = requestSession;
        return this;
    }
    /**
   * @inheritDoc
   */ setTags(tags) {
        this._tags = {
            ...this._tags,
            ...tags
        };
        this._notifyScopeListeners();
        return this;
    }
    /**
   * @inheritDoc
   */ setTag(key, value) {
        this._tags = {
            ...this._tags,
            [key]: value
        };
        this._notifyScopeListeners();
        return this;
    }
    /**
   * @inheritDoc
   */ setExtras(extras) {
        this._extra = {
            ...this._extra,
            ...extras
        };
        this._notifyScopeListeners();
        return this;
    }
    /**
   * @inheritDoc
   */ setExtra(key, extra) {
        this._extra = {
            ...this._extra,
            [key]: extra
        };
        this._notifyScopeListeners();
        return this;
    }
    /**
   * @inheritDoc
   */ setFingerprint(fingerprint) {
        this._fingerprint = fingerprint;
        this._notifyScopeListeners();
        return this;
    }
    /**
   * @inheritDoc
   */ setLevel(// eslint-disable-next-line deprecation/deprecation
    level) {
        this._level = level;
        this._notifyScopeListeners();
        return this;
    }
    /**
   * @inheritDoc
   */ setTransactionName(name) {
        this._transactionName = name;
        this._notifyScopeListeners();
        return this;
    }
    /**
   * @inheritDoc
   */ setContext(key, context) {
        if (context === null) // eslint-disable-next-line @typescript-eslint/no-dynamic-delete
        delete this._contexts[key];
        else this._contexts[key] = context;
        this._notifyScopeListeners();
        return this;
    }
    /**
   * @inheritDoc
   */ setSpan(span) {
        this._span = span;
        this._notifyScopeListeners();
        return this;
    }
    /**
   * @inheritDoc
   */ getSpan() {
        return this._span;
    }
    /**
   * @inheritDoc
   */ getTransaction() {
        // Often, this span (if it exists at all) will be a transaction, but it's not guaranteed to be. Regardless, it will
        // have a pointer to the currently-active transaction.
        const span = this.getSpan();
        return span && span.transaction;
    }
    /**
   * @inheritDoc
   */ setSession(session) {
        if (!session) delete this._session;
        else this._session = session;
        this._notifyScopeListeners();
        return this;
    }
    /**
   * @inheritDoc
   */ getSession() {
        return this._session;
    }
    /**
   * @inheritDoc
   */ update(captureContext) {
        if (!captureContext) return this;
        if (typeof captureContext === "function") {
            const updatedScope = captureContext(this);
            return updatedScope instanceof $90705fab783f17f9$export$775b6bb06e53a214 ? updatedScope : this;
        }
        if (captureContext instanceof $90705fab783f17f9$export$775b6bb06e53a214) {
            this._tags = {
                ...this._tags,
                ...captureContext._tags
            };
            this._extra = {
                ...this._extra,
                ...captureContext._extra
            };
            this._contexts = {
                ...this._contexts,
                ...captureContext._contexts
            };
            if (captureContext._user && Object.keys(captureContext._user).length) this._user = captureContext._user;
            if (captureContext._level) this._level = captureContext._level;
            if (captureContext._fingerprint) this._fingerprint = captureContext._fingerprint;
            if (captureContext._requestSession) this._requestSession = captureContext._requestSession;
            if (captureContext._propagationContext) this._propagationContext = captureContext._propagationContext;
        } else if ((0, $2zW56.isPlainObject)(captureContext)) {
            // eslint-disable-next-line no-param-reassign
            captureContext;
            this._tags = {
                ...this._tags,
                ...captureContext.tags
            };
            this._extra = {
                ...this._extra,
                ...captureContext.extra
            };
            this._contexts = {
                ...this._contexts,
                ...captureContext.contexts
            };
            if (captureContext.user) this._user = captureContext.user;
            if (captureContext.level) this._level = captureContext.level;
            if (captureContext.fingerprint) this._fingerprint = captureContext.fingerprint;
            if (captureContext.requestSession) this._requestSession = captureContext.requestSession;
            if (captureContext.propagationContext) this._propagationContext = captureContext.propagationContext;
        }
        return this;
    }
    /**
   * @inheritDoc
   */ clear() {
        this._breadcrumbs = [];
        this._tags = {};
        this._extra = {};
        this._user = {};
        this._contexts = {};
        this._level = undefined;
        this._transactionName = undefined;
        this._fingerprint = undefined;
        this._requestSession = undefined;
        this._span = undefined;
        this._session = undefined;
        this._notifyScopeListeners();
        this._attachments = [];
        this._propagationContext = $90705fab783f17f9$var$generatePropagationContext();
        return this;
    }
    /**
   * @inheritDoc
   */ addBreadcrumb(breadcrumb, maxBreadcrumbs) {
        const maxCrumbs = typeof maxBreadcrumbs === "number" ? maxBreadcrumbs : $90705fab783f17f9$var$DEFAULT_MAX_BREADCRUMBS;
        // No data has been changed, so don't notify scope listeners
        if (maxCrumbs <= 0) return this;
        const mergedBreadcrumb = {
            timestamp: (0, $cvSY8.dateTimestampInSeconds)(),
            ...breadcrumb
        };
        const breadcrumbs = this._breadcrumbs;
        breadcrumbs.push(mergedBreadcrumb);
        this._breadcrumbs = breadcrumbs.length > maxCrumbs ? breadcrumbs.slice(-maxCrumbs) : breadcrumbs;
        this._notifyScopeListeners();
        return this;
    }
    /**
   * @inheritDoc
   */ getLastBreadcrumb() {
        return this._breadcrumbs[this._breadcrumbs.length - 1];
    }
    /**
   * @inheritDoc
   */ clearBreadcrumbs() {
        this._breadcrumbs = [];
        this._notifyScopeListeners();
        return this;
    }
    /**
   * @inheritDoc
   */ addAttachment(attachment) {
        this._attachments.push(attachment);
        return this;
    }
    /**
   * @inheritDoc
   */ getAttachments() {
        return this._attachments;
    }
    /**
   * @inheritDoc
   */ clearAttachments() {
        this._attachments = [];
        return this;
    }
    /**
   * Applies data from the scope to the event and runs all event processors on it.
   *
   * @param event Event
   * @param hint Object containing additional information about the original exception, for use by the event processors.
   * @hidden
   */ applyToEvent(event, hint = {}, additionalEventProcessors) {
        if (this._extra && Object.keys(this._extra).length) event.extra = {
            ...this._extra,
            ...event.extra
        };
        if (this._tags && Object.keys(this._tags).length) event.tags = {
            ...this._tags,
            ...event.tags
        };
        if (this._user && Object.keys(this._user).length) event.user = {
            ...this._user,
            ...event.user
        };
        if (this._contexts && Object.keys(this._contexts).length) event.contexts = {
            ...this._contexts,
            ...event.contexts
        };
        if (this._level) event.level = this._level;
        if (this._transactionName) event.transaction = this._transactionName;
        // We want to set the trace context for normal events only if there isn't already
        // a trace context on the event. There is a product feature in place where we link
        // errors with transaction and it relies on that.
        if (this._span) {
            event.contexts = {
                trace: this._span.getTraceContext(),
                ...event.contexts
            };
            const transaction = this._span.transaction;
            if (transaction) {
                event.sdkProcessingMetadata = {
                    dynamicSamplingContext: transaction.getDynamicSamplingContext(),
                    ...event.sdkProcessingMetadata
                };
                const transactionName = transaction.name;
                if (transactionName) event.tags = {
                    transaction: transactionName,
                    ...event.tags
                };
            }
        }
        this._applyFingerprint(event);
        const scopeBreadcrumbs = this._getBreadcrumbs();
        const breadcrumbs = [
            ...event.breadcrumbs || [],
            ...scopeBreadcrumbs
        ];
        event.breadcrumbs = breadcrumbs.length > 0 ? breadcrumbs : undefined;
        event.sdkProcessingMetadata = {
            ...event.sdkProcessingMetadata,
            ...this._sdkProcessingMetadata,
            propagationContext: this._propagationContext
        };
        // TODO (v8): Update this order to be: Global > Client > Scope
        return (0, $6T4Sa.notifyEventProcessors)([
            ...additionalEventProcessors || [],
            // eslint-disable-next-line deprecation/deprecation
            ...(0, $6T4Sa.getGlobalEventProcessors)(),
            ...this._eventProcessors
        ], event, hint);
    }
    /**
   * Add data which will be accessible during event processing but won't get sent to Sentry
   */ setSDKProcessingMetadata(newData) {
        this._sdkProcessingMetadata = {
            ...this._sdkProcessingMetadata,
            ...newData
        };
        return this;
    }
    /**
   * @inheritDoc
   */ setPropagationContext(context) {
        this._propagationContext = context;
        return this;
    }
    /**
   * @inheritDoc
   */ getPropagationContext() {
        return this._propagationContext;
    }
    /**
   * Get the breadcrumbs for this scope.
   */ _getBreadcrumbs() {
        return this._breadcrumbs;
    }
    /**
   * This will be called on every set call.
   */ _notifyScopeListeners() {
        // We need this check for this._notifyingListeners to be able to work on scope during updates
        // If this check is not here we'll produce endless recursion when something is done with the scope
        // during the callback.
        if (!this._notifyingListeners) {
            this._notifyingListeners = true;
            this._scopeListeners.forEach((callback)=>{
                callback(this);
            });
            this._notifyingListeners = false;
        }
    }
    /**
   * Applies fingerprint from the scope to the event if there's one,
   * uses message if there's one instead or get rid of empty fingerprint
   */ _applyFingerprint(event) {
        // Make sure it's an array first and we actually have something in place
        event.fingerprint = event.fingerprint ? (0, $b1E2c.arrayify)(event.fingerprint) : [];
        // If we have something on the scope, then merge it with event
        if (this._fingerprint) event.fingerprint = event.fingerprint.concat(this._fingerprint);
        // If we have no data at all, remove empty array default
        if (event.fingerprint && !event.fingerprint.length) delete event.fingerprint;
    }
}
function $90705fab783f17f9$var$generatePropagationContext() {
    return {
        traceId: (0, $b1E2c.uuid4)(),
        spanId: (0, $b1E2c.uuid4)().substring(16)
    };
}

});
parcelRegister("6T4Sa", function(module, exports) {

$parcel$export(module.exports, "getGlobalEventProcessors", () => $503ba8c00efa1d46$export$3c4238858b85e8ac);
$parcel$export(module.exports, "addGlobalEventProcessor", () => $503ba8c00efa1d46$export$8e4e25f54d456511);
$parcel$export(module.exports, "notifyEventProcessors", () => $503ba8c00efa1d46$export$bf2a096c3e883e79);

var $3bpJ1 = parcelRequire("3bpJ1");
var $2zW56 = parcelRequire("2zW56");
var $4g0Ct = parcelRequire("4g0Ct");
var $j3a3y = parcelRequire("j3a3y");

var $8IHa9 = parcelRequire("8IHa9");
/**
 * Returns the global event processors.
 * @deprecated Global event processors will be removed in v8.
 */ function $503ba8c00efa1d46$export$3c4238858b85e8ac() {
    return (0, $3bpJ1.getGlobalSingleton)("globalEventProcessors", ()=>[]);
}
/**
 * Add a EventProcessor to be kept globally.
 * @deprecated Use `addEventProcessor` instead. Global event processors will be removed in v8.
 */ function $503ba8c00efa1d46$export$8e4e25f54d456511(callback) {
    // eslint-disable-next-line deprecation/deprecation
    $503ba8c00efa1d46$export$3c4238858b85e8ac().push(callback);
}
/**
 * Process an array of event processors, returning the processed event (or `null` if the event was dropped).
 */ function $503ba8c00efa1d46$export$bf2a096c3e883e79(processors, event, hint, index = 0) {
    return new (0, $j3a3y.SyncPromise)((resolve, reject)=>{
        const processor = processors[index];
        if (event === null || typeof processor !== "function") resolve(event);
        else {
            const result = processor({
                ...event
            }, hint);
            (0, $8IHa9.DEBUG_BUILD) && processor.id && result === null && (0, $4g0Ct.logger).log(`Event processor "${processor.id}" dropped event`);
            if ((0, $2zW56.isThenable)(result)) result.then((final)=>$503ba8c00efa1d46$export$bf2a096c3e883e79(processors, final, hint, index + 1).then(resolve)).then(null, reject);
            else $503ba8c00efa1d46$export$bf2a096c3e883e79(processors, result, hint, index + 1).then(resolve).then(null, reject);
        }
    });
}

});
parcelRegister("j3a3y", function(module, exports) {

$parcel$export(module.exports, "resolvedSyncPromise", () => $dde6191ffa17294f$export$1fda8aa4d135f8aa);
$parcel$export(module.exports, "SyncPromise", () => $dde6191ffa17294f$export$6f292d4960313241);
$parcel$export(module.exports, "rejectedSyncPromise", () => $dde6191ffa17294f$export$78e43115b553f358);

var $2zW56 = parcelRequire("2zW56");
/* eslint-disable @typescript-eslint/explicit-function-return-type */ /** SyncPromise internal states */ var $dde6191ffa17294f$var$States;
(function(States) {
    /** Pending */ const PENDING = 0;
    States[States["PENDING"] = PENDING] = "PENDING";
    /** Resolved / OK */ const RESOLVED = 1;
    States[States["RESOLVED"] = RESOLVED] = "RESOLVED";
    /** Rejected / Error */ const REJECTED = 2;
    States[States["REJECTED"] = REJECTED] = "REJECTED";
})($dde6191ffa17294f$var$States || ($dde6191ffa17294f$var$States = {}));
// Overloads so we can call resolvedSyncPromise without arguments and generic argument
/**
 * Creates a resolved sync promise.
 *
 * @param value the value to resolve the promise with
 * @returns the resolved sync promise
 */ function $dde6191ffa17294f$export$1fda8aa4d135f8aa(value) {
    return new $dde6191ffa17294f$export$6f292d4960313241((resolve)=>{
        resolve(value);
    });
}
/**
 * Creates a rejected sync promise.
 *
 * @param value the value to reject the promise with
 * @returns the rejected sync promise
 */ function $dde6191ffa17294f$export$78e43115b553f358(reason) {
    return new $dde6191ffa17294f$export$6f292d4960313241((_, reject)=>{
        reject(reason);
    });
}
/**
 * Thenable class that behaves like a Promise and follows it's interface
 * but is not async internally
 */ class $dde6191ffa17294f$export$6f292d4960313241 {
    constructor(executor){
        $dde6191ffa17294f$export$6f292d4960313241.prototype.__init.call(this);
        $dde6191ffa17294f$export$6f292d4960313241.prototype.__init2.call(this);
        $dde6191ffa17294f$export$6f292d4960313241.prototype.__init3.call(this);
        $dde6191ffa17294f$export$6f292d4960313241.prototype.__init4.call(this);
        this._state = $dde6191ffa17294f$var$States.PENDING;
        this._handlers = [];
        try {
            executor(this._resolve, this._reject);
        } catch (e) {
            this._reject(e);
        }
    }
    /** JSDoc */ then(onfulfilled, onrejected) {
        return new $dde6191ffa17294f$export$6f292d4960313241((resolve, reject)=>{
            this._handlers.push([
                false,
                (result)=>{
                    if (!onfulfilled) // TODO: ¯\_(ツ)_/¯
                    // TODO: FIXME
                    resolve(result);
                    else try {
                        resolve(onfulfilled(result));
                    } catch (e) {
                        reject(e);
                    }
                },
                (reason)=>{
                    if (!onrejected) reject(reason);
                    else try {
                        resolve(onrejected(reason));
                    } catch (e) {
                        reject(e);
                    }
                }
            ]);
            this._executeHandlers();
        });
    }
    /** JSDoc */ catch(onrejected) {
        return this.then((val)=>val, onrejected);
    }
    /** JSDoc */ finally(onfinally) {
        return new $dde6191ffa17294f$export$6f292d4960313241((resolve, reject)=>{
            let val;
            let isRejected;
            return this.then((value)=>{
                isRejected = false;
                val = value;
                if (onfinally) onfinally();
            }, (reason)=>{
                isRejected = true;
                val = reason;
                if (onfinally) onfinally();
            }).then(()=>{
                if (isRejected) {
                    reject(val);
                    return;
                }
                resolve(val);
            });
        });
    }
    /** JSDoc */ __init() {
        this._resolve = (value)=>{
            this._setResult($dde6191ffa17294f$var$States.RESOLVED, value);
        };
    }
    /** JSDoc */ __init2() {
        this._reject = (reason)=>{
            this._setResult($dde6191ffa17294f$var$States.REJECTED, reason);
        };
    }
    /** JSDoc */ __init3() {
        this._setResult = (state, value)=>{
            if (this._state !== $dde6191ffa17294f$var$States.PENDING) return;
            if ((0, $2zW56.isThenable)(value)) {
                value.then(this._resolve, this._reject);
                return;
            }
            this._state = state;
            this._value = value;
            this._executeHandlers();
        };
    }
    /** JSDoc */ __init4() {
        this._executeHandlers = ()=>{
            if (this._state === $dde6191ffa17294f$var$States.PENDING) return;
            const cachedHandlers = this._handlers.slice();
            this._handlers = [];
            cachedHandlers.forEach((handler)=>{
                if (handler[0]) return;
                if (this._state === $dde6191ffa17294f$var$States.RESOLVED) // eslint-disable-next-line @typescript-eslint/no-floating-promises
                handler[1](this._value);
                if (this._state === $dde6191ffa17294f$var$States.REJECTED) handler[2](this._value);
                handler[0] = true;
            });
        };
    }
}

});


parcelRegister("oyvka", function(module, exports) {

$parcel$export(module.exports, "makeSession", () => $049d01d3a3164ac2$export$14a186326edbb264);
$parcel$export(module.exports, "updateSession", () => $049d01d3a3164ac2$export$531818e825e774db);
$parcel$export(module.exports, "closeSession", () => $049d01d3a3164ac2$export$56521d9ba90f62ee);

var $jL8lq = parcelRequire("jL8lq");
var $cvSY8 = parcelRequire("cvSY8");
var $b1E2c = parcelRequire("b1E2c");
/**
 * Creates a new `Session` object by setting certain default parameters. If optional @param context
 * is passed, the passed properties are applied to the session object.
 *
 * @param context (optional) additional properties to be applied to the returned session object
 *
 * @returns a new `Session` object
 */ function $049d01d3a3164ac2$export$14a186326edbb264(context) {
    // Both timestamp and started are in seconds since the UNIX epoch.
    const startingTime = (0, $cvSY8.timestampInSeconds)();
    const session = {
        sid: (0, $b1E2c.uuid4)(),
        init: true,
        timestamp: startingTime,
        started: startingTime,
        duration: 0,
        status: "ok",
        errors: 0,
        ignoreDuration: false,
        toJSON: ()=>$049d01d3a3164ac2$var$sessionToJSON(session)
    };
    if (context) $049d01d3a3164ac2$export$531818e825e774db(session, context);
    return session;
}
/**
 * Updates a session object with the properties passed in the context.
 *
 * Note that this function mutates the passed object and returns void.
 * (Had to do this instead of returning a new and updated session because closing and sending a session
 * makes an update to the session after it was passed to the sending logic.
 * @see BaseClient.captureSession )
 *
 * @param session the `Session` to update
 * @param context the `SessionContext` holding the properties that should be updated in @param session
 */ // eslint-disable-next-line complexity
function $049d01d3a3164ac2$export$531818e825e774db(session, context = {}) {
    if (context.user) {
        if (!session.ipAddress && context.user.ip_address) session.ipAddress = context.user.ip_address;
        if (!session.did && !context.did) session.did = context.user.id || context.user.email || context.user.username;
    }
    session.timestamp = context.timestamp || (0, $cvSY8.timestampInSeconds)();
    if (context.abnormal_mechanism) session.abnormal_mechanism = context.abnormal_mechanism;
    if (context.ignoreDuration) session.ignoreDuration = context.ignoreDuration;
    if (context.sid) // Good enough uuid validation. — Kamil
    session.sid = context.sid.length === 32 ? context.sid : (0, $b1E2c.uuid4)();
    if (context.init !== undefined) session.init = context.init;
    if (!session.did && context.did) session.did = `${context.did}`;
    if (typeof context.started === "number") session.started = context.started;
    if (session.ignoreDuration) session.duration = undefined;
    else if (typeof context.duration === "number") session.duration = context.duration;
    else {
        const duration = session.timestamp - session.started;
        session.duration = duration >= 0 ? duration : 0;
    }
    if (context.release) session.release = context.release;
    if (context.environment) session.environment = context.environment;
    if (!session.ipAddress && context.ipAddress) session.ipAddress = context.ipAddress;
    if (!session.userAgent && context.userAgent) session.userAgent = context.userAgent;
    if (typeof context.errors === "number") session.errors = context.errors;
    if (context.status) session.status = context.status;
}
/**
 * Closes a session by setting its status and updating the session object with it.
 * Internally calls `updateSession` to update the passed session object.
 *
 * Note that this function mutates the passed session (@see updateSession for explanation).
 *
 * @param session the `Session` object to be closed
 * @param status the `SessionStatus` with which the session was closed. If you don't pass a status,
 *               this function will keep the previously set status, unless it was `'ok'` in which case
 *               it is changed to `'exited'`.
 */ function $049d01d3a3164ac2$export$56521d9ba90f62ee(session, status) {
    let context = {};
    if (status) context = {
        status: status
    };
    else if (session.status === "ok") context = {
        status: "exited"
    };
    $049d01d3a3164ac2$export$531818e825e774db(session, context);
}
/**
 * Serializes a passed session object to a JSON object with a slightly different structure.
 * This is necessary because the Sentry backend requires a slightly different schema of a session
 * than the one the JS SDKs use internally.
 *
 * @param session the session to be converted
 *
 * @returns a JSON object of the passed session
 */ function $049d01d3a3164ac2$var$sessionToJSON(session) {
    return (0, $jL8lq.dropUndefinedKeys)({
        sid: `${session.sid}`,
        init: session.init,
        // Make sure that sec is converted to ms for date constructor
        started: new Date(session.started * 1000).toISOString(),
        timestamp: new Date(session.timestamp * 1000).toISOString(),
        status: session.status,
        errors: session.errors,
        did: typeof session.did === "number" || typeof session.did === "string" ? `${session.did}` : undefined,
        duration: session.duration,
        abnormal_mechanism: session.abnormal_mechanism,
        attrs: {
            release: session.release,
            environment: session.environment,
            ip_address: session.ipAddress,
            user_agent: session.userAgent
        }
    });
}

});


parcelRegister("9OAWn", function(module, exports) {

$parcel$export(module.exports, "SDK_VERSION", () => $725570364ca356d5$export$31499a9cd224b78c);
const $725570364ca356d5$export$31499a9cd224b78c = "7.86.0";

});


parcelRegister("54O61", function(module, exports) {

$parcel$export(module.exports, "registerErrorInstrumentation", () => $3b242f8574a305e5$export$637857c1d87b640c);

var $isDtX = parcelRequire("isDtX");
var $e5Ga6 = parcelRequire("e5Ga6");
var $4g0Ct = parcelRequire("4g0Ct");

var $8IHa9 = parcelRequire("8IHa9");

var $5UTPE = parcelRequire("5UTPE");
let $3b242f8574a305e5$var$errorsInstrumented = false;
/**
 * Configures global error listeners
 */ function $3b242f8574a305e5$export$637857c1d87b640c() {
    if ($3b242f8574a305e5$var$errorsInstrumented) return;
    $3b242f8574a305e5$var$errorsInstrumented = true;
    (0, $isDtX.addGlobalErrorInstrumentationHandler)($3b242f8574a305e5$var$errorCallback);
    (0, $e5Ga6.addGlobalUnhandledRejectionInstrumentationHandler)($3b242f8574a305e5$var$errorCallback);
}
/**
 * If an error or unhandled promise occurs, we mark the active transaction as failed
 */ function $3b242f8574a305e5$var$errorCallback() {
    const activeTransaction = (0, $5UTPE.getActiveTransaction)();
    if (activeTransaction) {
        const status = "internal_error";
        (0, $8IHa9.DEBUG_BUILD) && (0, $4g0Ct.logger).log(`[Tracing] Transaction: ${status} -> Global error occured`);
        activeTransaction.setStatus(status);
    }
}
// The function name will be lost when bundling but we need to be able to identify this listener later to maintain the
// node.js default exit behaviour
$3b242f8574a305e5$var$errorCallback.tag = "sentry_tracingErrorCallback";

});
parcelRegister("isDtX", function(module, exports) {

$parcel$export(module.exports, "addGlobalErrorInstrumentationHandler", () => $d70977d9b36915fd$export$55b5c3ba2194f0c6);

var $3bpJ1 = parcelRequire("3bpJ1");

var $dbwHv = parcelRequire("dbwHv");
let $d70977d9b36915fd$var$_oldOnErrorHandler = null;
/**
 * Add an instrumentation handler for when an error is captured by the global error handler.
 *
 * Use at your own risk, this might break without changelog notice, only used internally.
 * @hidden
 */ function $d70977d9b36915fd$export$55b5c3ba2194f0c6(handler) {
    const type = "error";
    (0, $dbwHv.addHandler)(type, handler);
    (0, $dbwHv.maybeInstrument)(type, $d70977d9b36915fd$var$instrumentError);
}
function $d70977d9b36915fd$var$instrumentError() {
    $d70977d9b36915fd$var$_oldOnErrorHandler = (0, $3bpJ1.GLOBAL_OBJ).onerror;
    (0, $3bpJ1.GLOBAL_OBJ).onerror = function(msg, url, line, column, error) {
        const handlerData = {
            column: column,
            error: error,
            line: line,
            msg: msg,
            url: url
        };
        (0, $dbwHv.triggerHandlers)("error", handlerData);
        if ($d70977d9b36915fd$var$_oldOnErrorHandler && !$d70977d9b36915fd$var$_oldOnErrorHandler.__SENTRY_LOADER__) // eslint-disable-next-line prefer-rest-params
        return $d70977d9b36915fd$var$_oldOnErrorHandler.apply(this, arguments);
        return false;
    };
    (0, $3bpJ1.GLOBAL_OBJ).onerror.__SENTRY_INSTRUMENTED__ = true;
}

});
parcelRegister("dbwHv", function(module, exports) {

$parcel$export(module.exports, "addHandler", () => $9995ab194a6bc98e$export$a4e09611e30da72e);
$parcel$export(module.exports, "maybeInstrument", () => $9995ab194a6bc98e$export$e18d6c5462c01368);
$parcel$export(module.exports, "triggerHandlers", () => $9995ab194a6bc98e$export$b18c893e424d3127);

var $eKZKa = parcelRequire("eKZKa");

var $4g0Ct = parcelRequire("4g0Ct");

var $16dZf = parcelRequire("16dZf");
// We keep the handlers globally
const $9995ab194a6bc98e$var$handlers = {};
const $9995ab194a6bc98e$var$instrumented = {};
/** Add a handler function. */ function $9995ab194a6bc98e$export$a4e09611e30da72e(type, handler) {
    $9995ab194a6bc98e$var$handlers[type] = $9995ab194a6bc98e$var$handlers[type] || [];
    $9995ab194a6bc98e$var$handlers[type].push(handler);
}
/**
 * Reset all instrumentation handlers.
 * This can be used by tests to ensure we have a clean slate of instrumentation handlers.
 */ function $9995ab194a6bc98e$export$b17eab759a1cb5fe() {
    Object.keys($9995ab194a6bc98e$var$handlers).forEach((key)=>{
        $9995ab194a6bc98e$var$handlers[key] = undefined;
    });
}
/** Maybe run an instrumentation function, unless it was already called. */ function $9995ab194a6bc98e$export$e18d6c5462c01368(type, instrumentFn) {
    if (!$9995ab194a6bc98e$var$instrumented[type]) {
        instrumentFn();
        $9995ab194a6bc98e$var$instrumented[type] = true;
    }
}
/** Trigger handlers for a given instrumentation type. */ function $9995ab194a6bc98e$export$b18c893e424d3127(type, data) {
    const typeHandlers = type && $9995ab194a6bc98e$var$handlers[type];
    if (!typeHandlers) return;
    for (const handler of typeHandlers)try {
        handler(data);
    } catch (e) {
        (0, $eKZKa.DEBUG_BUILD) && (0, $4g0Ct.logger).error(`Error while triggering instrumentation handler.\nType: ${type}\nName: ${(0, $16dZf.getFunctionName)(handler)}\nError:`, e);
    }
}

});
parcelRegister("16dZf", function(module, exports) {

$parcel$export(module.exports, "createStackParser", () => $0cd1337813906a62$export$a5739666fb2d03d4);
$parcel$export(module.exports, "stackParserFromStackParserOptions", () => $0cd1337813906a62$export$1d5cf88b347146d4);
$parcel$export(module.exports, "getFunctionName", () => $0cd1337813906a62$export$aad197c7121a6651);

var $cDXrx = parcelRequire("cDXrx");
const $0cd1337813906a62$var$STACKTRACE_FRAME_LIMIT = 50;
// Used to sanitize webpack (error: *) wrapped stack errors
const $0cd1337813906a62$var$WEBPACK_ERROR_REGEXP = /\(error: (.*)\)/;
const $0cd1337813906a62$var$STRIP_FRAME_REGEXP = /captureMessage|captureException/;
/**
 * Creates a stack parser with the supplied line parsers
 *
 * StackFrames are returned in the correct order for Sentry Exception
 * frames and with Sentry SDK internal frames removed from the top and bottom
 *
 */ function $0cd1337813906a62$export$a5739666fb2d03d4(...parsers) {
    const sortedParsers = parsers.sort((a, b)=>a[0] - b[0]).map((p)=>p[1]);
    return (stack, skipFirst = 0)=>{
        const frames = [];
        const lines = stack.split("\n");
        for(let i = skipFirst; i < lines.length; i++){
            const line = lines[i];
            // Ignore lines over 1kb as they are unlikely to be stack frames.
            // Many of the regular expressions use backtracking which results in run time that increases exponentially with
            // input size. Huge strings can result in hangs/Denial of Service:
            // https://github.com/getsentry/sentry-javascript/issues/2286
            if (line.length > 1024) continue;
            // https://github.com/getsentry/sentry-javascript/issues/5459
            // Remove webpack (error: *) wrappers
            const cleanedLine = $0cd1337813906a62$var$WEBPACK_ERROR_REGEXP.test(line) ? line.replace($0cd1337813906a62$var$WEBPACK_ERROR_REGEXP, "$1") : line;
            // https://github.com/getsentry/sentry-javascript/issues/7813
            // Skip Error: lines
            if (cleanedLine.match(/\S*Error: /)) continue;
            for (const parser of sortedParsers){
                const frame = parser(cleanedLine);
                if (frame) {
                    frames.push(frame);
                    break;
                }
            }
            if (frames.length >= $0cd1337813906a62$var$STACKTRACE_FRAME_LIMIT) break;
        }
        return $0cd1337813906a62$export$c55c24c0eeba0205(frames);
    };
}
/**
 * Gets a stack parser implementation from Options.stackParser
 * @see Options
 *
 * If options contains an array of line parsers, it is converted into a parser
 */ function $0cd1337813906a62$export$1d5cf88b347146d4(stackParser) {
    if (Array.isArray(stackParser)) return $0cd1337813906a62$export$a5739666fb2d03d4(...stackParser);
    return stackParser;
}
/**
 * Removes Sentry frames from the top and bottom of the stack if present and enforces a limit of max number of frames.
 * Assumes stack input is ordered from top to bottom and returns the reverse representation so call site of the
 * function that caused the crash is the last frame in the array.
 * @hidden
 */ function $0cd1337813906a62$export$c55c24c0eeba0205(stack) {
    if (!stack.length) return [];
    const localStack = Array.from(stack);
    // If stack starts with one of our API calls, remove it (starts, meaning it's the top of the stack - aka last call)
    if (/sentryWrapped/.test(localStack[localStack.length - 1].function || "")) localStack.pop();
    // Reversing in the middle of the procedure allows us to just pop the values off the stack
    localStack.reverse();
    // If stack ends with one of our internal API calls, remove it (ends, meaning it's the bottom of the stack - aka top-most call)
    if ($0cd1337813906a62$var$STRIP_FRAME_REGEXP.test(localStack[localStack.length - 1].function || "")) {
        localStack.pop();
        // When using synthetic events, we will have a 2 levels deep stack, as `new Error('Sentry syntheticException')`
        // is produced within the hub itself, making it:
        //
        //   Sentry.captureException()
        //   getCurrentHub().captureException()
        //
        // instead of just the top `Sentry` call itself.
        // This forces us to possibly strip an additional frame in the exact same was as above.
        if ($0cd1337813906a62$var$STRIP_FRAME_REGEXP.test(localStack[localStack.length - 1].function || "")) localStack.pop();
    }
    return localStack.slice(0, $0cd1337813906a62$var$STACKTRACE_FRAME_LIMIT).map((frame)=>({
            ...frame,
            filename: frame.filename || localStack[localStack.length - 1].filename,
            function: frame.function || "?"
        }));
}
const $0cd1337813906a62$var$defaultFunctionName = "<anonymous>";
/**
 * Safely extract function name from itself
 */ function $0cd1337813906a62$export$aad197c7121a6651(fn) {
    try {
        if (!fn || typeof fn !== "function") return $0cd1337813906a62$var$defaultFunctionName;
        return fn.name || $0cd1337813906a62$var$defaultFunctionName;
    } catch (e) {
        // Just accessing custom props in some Selenium environments
        // can cause a "Permission denied" exception (see raven-js#495).
        return $0cd1337813906a62$var$defaultFunctionName;
    }
}
/**
 * Node.js stack line parser
 *
 * This is in @sentry/utils so it can be used from the Electron SDK in the browser for when `nodeIntegration == true`.
 * This allows it to be used without referencing or importing any node specific code which causes bundlers to complain
 */ function $0cd1337813906a62$export$673345a0da635a78(getModule) {
    return [
        90,
        (0, $cDXrx.node)(getModule)
    ];
}

});
parcelRegister("cDXrx", function(module, exports) {

$parcel$export(module.exports, "node", () => $93473cbc517fed7c$export$35059013cd4a06db);
/**
 * Does this filename look like it's part of the app code?
 */ function $93473cbc517fed7c$export$1de92f38f4de99a8(filename, isNative = false) {
    const isInternal = isNative || filename && // It's not internal if it's an absolute linux path
    !filename.startsWith("/") && // It's not internal if it's an absolute windows path
    !filename.includes(":\\") && // It's not internal if the path is starting with a dot
    !filename.startsWith(".") && // It's not internal if the frame has a protocol. In node, this is usually the case if the file got pre-processed with a bundler like webpack
    !filename.match(/^[a-zA-Z]([a-zA-Z0-9.\-+])*:\/\//); // Schema from: https://stackoverflow.com/a/3641782
    // in_app is all that's not an internal Node function or a module within node_modules
    // note that isNative appears to return true even for node core libraries
    // see https://github.com/getsentry/raven-node/issues/176
    return !isInternal && filename !== undefined && !filename.includes("node_modules/");
}
/** Node Stack line parser */ // eslint-disable-next-line complexity
function $93473cbc517fed7c$export$35059013cd4a06db(getModule) {
    const FILENAME_MATCH = /^\s*[-]{4,}$/;
    const FULL_MATCH = /at (?:async )?(?:(.+?)\s+\()?(?:(.+):(\d+):(\d+)?|([^)]+))\)?/;
    // eslint-disable-next-line complexity
    return (line)=>{
        const lineMatch = line.match(FULL_MATCH);
        if (lineMatch) {
            let object;
            let method;
            let functionName;
            let typeName;
            let methodName;
            if (lineMatch[1]) {
                functionName = lineMatch[1];
                let methodStart = functionName.lastIndexOf(".");
                if (functionName[methodStart - 1] === ".") methodStart--;
                if (methodStart > 0) {
                    object = functionName.slice(0, methodStart);
                    method = functionName.slice(methodStart + 1);
                    const objectEnd = object.indexOf(".Module");
                    if (objectEnd > 0) {
                        functionName = functionName.slice(objectEnd + 1);
                        object = object.slice(0, objectEnd);
                    }
                }
                typeName = undefined;
            }
            if (method) {
                typeName = object;
                methodName = method;
            }
            if (method === "<anonymous>") {
                methodName = undefined;
                functionName = undefined;
            }
            if (functionName === undefined) {
                methodName = methodName || "<anonymous>";
                functionName = typeName ? `${typeName}.${methodName}` : methodName;
            }
            let filename = lineMatch[2] && lineMatch[2].startsWith("file://") ? lineMatch[2].slice(7) : lineMatch[2];
            const isNative = lineMatch[5] === "native";
            if (!filename && lineMatch[5] && !isNative) filename = lineMatch[5];
            return {
                filename: filename,
                module: getModule ? getModule(filename) : undefined,
                function: functionName,
                lineno: parseInt(lineMatch[3], 10) || undefined,
                colno: parseInt(lineMatch[4], 10) || undefined,
                in_app: $93473cbc517fed7c$export$1de92f38f4de99a8(filename, isNative)
            };
        }
        if (line.match(FILENAME_MATCH)) return {
            filename: line
        };
        return undefined;
    };
}

});




parcelRegister("e5Ga6", function(module, exports) {

$parcel$export(module.exports, "addGlobalUnhandledRejectionInstrumentationHandler", () => $a4223cccebdcb864$export$8bf4fc6858821a4e);

var $3bpJ1 = parcelRequire("3bpJ1");

var $dbwHv = parcelRequire("dbwHv");
let $a4223cccebdcb864$var$_oldOnUnhandledRejectionHandler = null;
/**
 * Add an instrumentation handler for when an unhandled promise rejection is captured.
 *
 * Use at your own risk, this might break without changelog notice, only used internally.
 * @hidden
 */ function $a4223cccebdcb864$export$8bf4fc6858821a4e(handler) {
    const type = "unhandledrejection";
    (0, $dbwHv.addHandler)(type, handler);
    (0, $dbwHv.maybeInstrument)(type, $a4223cccebdcb864$var$instrumentUnhandledRejection);
}
function $a4223cccebdcb864$var$instrumentUnhandledRejection() {
    $a4223cccebdcb864$var$_oldOnUnhandledRejectionHandler = (0, $3bpJ1.GLOBAL_OBJ).onunhandledrejection;
    (0, $3bpJ1.GLOBAL_OBJ).onunhandledrejection = function(e) {
        const handlerData = e;
        (0, $dbwHv.triggerHandlers)("unhandledrejection", handlerData);
        if ($a4223cccebdcb864$var$_oldOnUnhandledRejectionHandler && !$a4223cccebdcb864$var$_oldOnUnhandledRejectionHandler.__SENTRY_LOADER__) // eslint-disable-next-line prefer-rest-params
        return $a4223cccebdcb864$var$_oldOnUnhandledRejectionHandler.apply(this, arguments);
        return true;
    };
    (0, $3bpJ1.GLOBAL_OBJ).onunhandledrejection.__SENTRY_INSTRUMENTED__ = true;
}

});

parcelRegister("5UTPE", function(module, exports) {

$parcel$export(module.exports, "getActiveTransaction", () => $44ed7dd0e837ba6e$export$a7feb32fdd923295);
$parcel$export(module.exports, "extractTraceparentData", () => $44ed7dd0e837ba6e$export$8e9a29865c0a1226);

var $65HJt = parcelRequire("65HJt");

var $cmFjP = parcelRequire("cmFjP");
/** Grabs active transaction off scope, if any */ function $44ed7dd0e837ba6e$export$a7feb32fdd923295(maybeHub) {
    const hub = maybeHub || (0, $cmFjP.getCurrentHub)();
    const scope = hub.getScope();
    return scope.getTransaction();
}
/**
 * The `extractTraceparentData` function and `TRACEPARENT_REGEXP` constant used
 * to be declared in this file. It was later moved into `@sentry/utils` as part of a
 * move to remove `@sentry/tracing` dependencies from `@sentry/node` (`extractTraceparentData`
 * is the only tracing function used by `@sentry/node`).
 *
 * These exports are kept here for backwards compatability's sake.
 *
 * See https://github.com/getsentry/sentry-javascript/issues/4642 for more details.
 *
 * @deprecated Import this function from `@sentry/utils` instead
 */ const $44ed7dd0e837ba6e$export$8e9a29865c0a1226 = (0, $65HJt.extractTraceparentData);

});
parcelRegister("65HJt", function(module, exports) {

$parcel$export(module.exports, "TRACEPARENT_REGEXP", () => $46f5220cb64aa700$export$394a210812ba3012);
$parcel$export(module.exports, "extractTraceparentData", () => $46f5220cb64aa700$export$8e9a29865c0a1226);
$parcel$export(module.exports, "tracingContextFromHeaders", () => $46f5220cb64aa700$export$ca5c066532785b6e);
$parcel$export(module.exports, "generateSentryTraceHeader", () => $46f5220cb64aa700$export$f35d907436da45cf);

var $dzA7g = parcelRequire("dzA7g");

var $b1E2c = parcelRequire("b1E2c");
const $46f5220cb64aa700$export$394a210812ba3012 = new RegExp("^[ \\t]*([0-9a-f]{32})?-?([0-9a-f]{16})?-?([01])?[ \\t]*$");
/**
 * Extract transaction context data from a `sentry-trace` header.
 *
 * @param traceparent Traceparent string
 *
 * @returns Object containing data from the header, or undefined if traceparent string is malformed
 */ function $46f5220cb64aa700$export$8e9a29865c0a1226(traceparent) {
    if (!traceparent) return undefined;
    const matches = traceparent.match($46f5220cb64aa700$export$394a210812ba3012);
    if (!matches) return undefined;
    let parentSampled;
    if (matches[3] === "1") parentSampled = true;
    else if (matches[3] === "0") parentSampled = false;
    return {
        traceId: matches[1],
        parentSampled: parentSampled,
        parentSpanId: matches[2]
    };
}
/**
 * Create tracing context from incoming headers.
 */ function $46f5220cb64aa700$export$ca5c066532785b6e(sentryTrace, baggage) {
    const traceparentData = $46f5220cb64aa700$export$8e9a29865c0a1226(sentryTrace);
    const dynamicSamplingContext = (0, $dzA7g.baggageHeaderToDynamicSamplingContext)(baggage);
    const { traceId: traceId, parentSpanId: parentSpanId, parentSampled: parentSampled } = traceparentData || {};
    const propagationContext = {
        traceId: traceId || (0, $b1E2c.uuid4)(),
        spanId: (0, $b1E2c.uuid4)().substring(16),
        sampled: parentSampled
    };
    if (parentSpanId) propagationContext.parentSpanId = parentSpanId;
    if (dynamicSamplingContext) propagationContext.dsc = dynamicSamplingContext;
    return {
        traceparentData: traceparentData,
        dynamicSamplingContext: dynamicSamplingContext,
        propagationContext: propagationContext
    };
}
/**
 * Create sentry-trace header from span context values.
 */ function $46f5220cb64aa700$export$f35d907436da45cf(traceId = (0, $b1E2c.uuid4)(), spanId = (0, $b1E2c.uuid4)().substring(16), sampled) {
    let sampledString = "";
    if (sampled !== undefined) sampledString = sampled ? "-1" : "-0";
    return `${traceId}-${spanId}${sampledString}`;
}

});
parcelRegister("dzA7g", function(module, exports) {

$parcel$export(module.exports, "BAGGAGE_HEADER_NAME", () => $9e1a8f302f19c673$export$9ca9946bd449ac06);
$parcel$export(module.exports, "baggageHeaderToDynamicSamplingContext", () => $9e1a8f302f19c673$export$5b96ee2c8421f107);
$parcel$export(module.exports, "dynamicSamplingContextToSentryBaggageHeader", () => $9e1a8f302f19c673$export$56766feef403f365);

var $eKZKa = parcelRequire("eKZKa");

var $2zW56 = parcelRequire("2zW56");

var $4g0Ct = parcelRequire("4g0Ct");
const $9e1a8f302f19c673$export$9ca9946bd449ac06 = "baggage";
const $9e1a8f302f19c673$export$6e69537d67fa20f = "sentry-";
const $9e1a8f302f19c673$export$eb0401070c617ea5 = /^sentry-/;
/**
 * Max length of a serialized baggage string
 *
 * https://www.w3.org/TR/baggage/#limits
 */ const $9e1a8f302f19c673$export$bdd844ddb2def819 = 8192;
/**
 * Takes a baggage header and turns it into Dynamic Sampling Context, by extracting all the "sentry-" prefixed values
 * from it.
 *
 * @param baggageHeader A very bread definition of a baggage header as it might appear in various frameworks.
 * @returns The Dynamic Sampling Context that was found on `baggageHeader`, if there was any, `undefined` otherwise.
 */ function $9e1a8f302f19c673$export$5b96ee2c8421f107(// Very liberal definition of what any incoming header might look like
baggageHeader) {
    if (!(0, $2zW56.isString)(baggageHeader) && !Array.isArray(baggageHeader)) return undefined;
    // Intermediary object to store baggage key value pairs of incoming baggage headers on.
    // It is later used to read Sentry-DSC-values from.
    let baggageObject = {};
    if (Array.isArray(baggageHeader)) // Combine all baggage headers into one object containing the baggage values so we can later read the Sentry-DSC-values from it
    baggageObject = baggageHeader.reduce((acc, curr)=>{
        const currBaggageObject = $9e1a8f302f19c673$var$baggageHeaderToObject(curr);
        return {
            ...acc,
            ...currBaggageObject
        };
    }, {});
    else {
        // Return undefined if baggage header is an empty string (technically an empty baggage header is not spec conform but
        // this is how we choose to handle it)
        if (!baggageHeader) return undefined;
        baggageObject = $9e1a8f302f19c673$var$baggageHeaderToObject(baggageHeader);
    }
    // Read all "sentry-" prefixed values out of the baggage object and put it onto a dynamic sampling context object.
    const dynamicSamplingContext = Object.entries(baggageObject).reduce((acc, [key, value])=>{
        if (key.match($9e1a8f302f19c673$export$eb0401070c617ea5)) {
            const nonPrefixedKey = key.slice($9e1a8f302f19c673$export$6e69537d67fa20f.length);
            acc[nonPrefixedKey] = value;
        }
        return acc;
    }, {});
    // Only return a dynamic sampling context object if there are keys in it.
    // A keyless object means there were no sentry values on the header, which means that there is no DSC.
    if (Object.keys(dynamicSamplingContext).length > 0) return dynamicSamplingContext;
    else return undefined;
}
/**
 * Turns a Dynamic Sampling Object into a baggage header by prefixing all the keys on the object with "sentry-".
 *
 * @param dynamicSamplingContext The Dynamic Sampling Context to turn into a header. For convenience and compatibility
 * with the `getDynamicSamplingContext` method on the Transaction class ,this argument can also be `undefined`. If it is
 * `undefined` the function will return `undefined`.
 * @returns a baggage header, created from `dynamicSamplingContext`, or `undefined` either if `dynamicSamplingContext`
 * was `undefined`, or if `dynamicSamplingContext` didn't contain any values.
 */ function $9e1a8f302f19c673$export$56766feef403f365(// this also takes undefined for convenience and bundle size in other places
dynamicSamplingContext) {
    if (!dynamicSamplingContext) return undefined;
    // Prefix all DSC keys with "sentry-" and put them into a new object
    const sentryPrefixedDSC = Object.entries(dynamicSamplingContext).reduce((acc, [dscKey, dscValue])=>{
        if (dscValue) acc[`${$9e1a8f302f19c673$export$6e69537d67fa20f}${dscKey}`] = dscValue;
        return acc;
    }, {});
    return $9e1a8f302f19c673$var$objectToBaggageHeader(sentryPrefixedDSC);
}
/**
 * Will parse a baggage header, which is a simple key-value map, into a flat object.
 *
 * @param baggageHeader The baggage header to parse.
 * @returns a flat object containing all the key-value pairs from `baggageHeader`.
 */ function $9e1a8f302f19c673$var$baggageHeaderToObject(baggageHeader) {
    return baggageHeader.split(",").map((baggageEntry)=>baggageEntry.split("=").map((keyOrValue)=>decodeURIComponent(keyOrValue.trim()))).reduce((acc, [key, value])=>{
        acc[key] = value;
        return acc;
    }, {});
}
/**
 * Turns a flat object (key-value pairs) into a baggage header, which is also just key-value pairs.
 *
 * @param object The object to turn into a baggage header.
 * @returns a baggage header string, or `undefined` if the object didn't have any values, since an empty baggage header
 * is not spec compliant.
 */ function $9e1a8f302f19c673$var$objectToBaggageHeader(object) {
    if (Object.keys(object).length === 0) // An empty baggage header is not spec compliant: We return undefined.
    return undefined;
    return Object.entries(object).reduce((baggageHeader, [objectKey, objectValue], currentIndex)=>{
        const baggageEntry = `${encodeURIComponent(objectKey)}=${encodeURIComponent(objectValue)}`;
        const newBaggageHeader = currentIndex === 0 ? baggageEntry : `${baggageHeader},${baggageEntry}`;
        if (newBaggageHeader.length > $9e1a8f302f19c673$export$bdd844ddb2def819) {
            (0, $eKZKa.DEBUG_BUILD) && (0, $4g0Ct.logger).warn(`Not adding key: ${objectKey} with val: ${objectValue} to baggage header due to exceeding baggage size limits.`);
            return baggageHeader;
        } else return newBaggageHeader;
    }, "");
}

});




parcelRegister("2EZoq", function(module, exports) {

$parcel$export(module.exports, "TRACING_DEFAULTS", () => $1efef08b5fe9fa0b$export$809a2b7987fd5306);
$parcel$export(module.exports, "IdleTransaction", () => $1efef08b5fe9fa0b$export$b279e6bd7040371f);

var $4g0Ct = parcelRequire("4g0Ct");
var $cvSY8 = parcelRequire("cvSY8");

var $8IHa9 = parcelRequire("8IHa9");

var $cKEJC = parcelRequire("cKEJC");

var $6Tqu0 = parcelRequire("6Tqu0");
const $1efef08b5fe9fa0b$export$809a2b7987fd5306 = {
    idleTimeout: 1000,
    finalTimeout: 30000,
    heartbeatInterval: 5000
};
const $1efef08b5fe9fa0b$var$FINISH_REASON_TAG = "finishReason";
const $1efef08b5fe9fa0b$var$IDLE_TRANSACTION_FINISH_REASONS = [
    "heartbeatFailed",
    "idleTimeout",
    "documentHidden",
    "finalTimeout",
    "externalFinish",
    "cancelled"
];
/**
 * @inheritDoc
 */ class $1efef08b5fe9fa0b$export$370d6113c18ba86c extends (0, $cKEJC.SpanRecorder) {
    constructor(_pushActivity, _popActivity, transactionSpanId, maxlen){
        super(maxlen);
        this._pushActivity = _pushActivity;
        this._popActivity = _popActivity;
        this.transactionSpanId = transactionSpanId;
    }
    /**
   * @inheritDoc
   */ add(span) {
        // We should make sure we do not push and pop activities for
        // the transaction that this span recorder belongs to.
        if (span.spanId !== this.transactionSpanId) {
            // We patch span.finish() to pop an activity after setting an endTimestamp.
            span.finish = (endTimestamp)=>{
                span.endTimestamp = typeof endTimestamp === "number" ? endTimestamp : (0, $cvSY8.timestampInSeconds)();
                this._popActivity(span.spanId);
            };
            // We should only push new activities if the span does not have an end timestamp.
            if (span.endTimestamp === undefined) this._pushActivity(span.spanId);
        }
        super.add(span);
    }
}
/**
 * An IdleTransaction is a transaction that automatically finishes. It does this by tracking child spans as activities.
 * You can have multiple IdleTransactions active, but if the `onScope` option is specified, the idle transaction will
 * put itself on the scope on creation.
 */ class $1efef08b5fe9fa0b$export$b279e6bd7040371f extends (0, $6Tqu0.Transaction) {
    // Activities store a list of active spans
    // Track state of activities in previous heartbeat
    // Amount of times heartbeat has counted. Will cause transaction to finish after 3 beats.
    // We should not use heartbeat if we finished a transaction
    // Idle timeout was canceled and we should finish the transaction with the last span end.
    /**
   * Timer that tracks Transaction idleTimeout
   */ constructor(transactionContext, _idleHub, /**
     * The time to wait in ms until the idle transaction will be finished. This timer is started each time
     * there are no active spans on this transaction.
     */ _idleTimeout = $1efef08b5fe9fa0b$export$809a2b7987fd5306.idleTimeout, /**
     * The final value in ms that a transaction cannot exceed
     */ _finalTimeout = $1efef08b5fe9fa0b$export$809a2b7987fd5306.finalTimeout, _heartbeatInterval = $1efef08b5fe9fa0b$export$809a2b7987fd5306.heartbeatInterval, // Whether or not the transaction should put itself on the scope when it starts and pop itself off when it ends
    _onScope = false){
        super(transactionContext, _idleHub);
        this._idleHub = _idleHub;
        this._idleTimeout = _idleTimeout;
        this._finalTimeout = _finalTimeout;
        this._heartbeatInterval = _heartbeatInterval;
        this._onScope = _onScope;
        this.activities = {};
        this._heartbeatCounter = 0;
        this._finished = false;
        this._idleTimeoutCanceledPermanently = false;
        this._beforeFinishCallbacks = [];
        this._finishReason = $1efef08b5fe9fa0b$var$IDLE_TRANSACTION_FINISH_REASONS[4];
        if (_onScope) {
            // We set the transaction here on the scope so error events pick up the trace
            // context and attach it to the error.
            (0, $8IHa9.DEBUG_BUILD) && (0, $4g0Ct.logger).log(`Setting idle transaction on scope. Span ID: ${this.spanId}`);
            _idleHub.configureScope((scope)=>scope.setSpan(this));
        }
        this._restartIdleTimeout();
        setTimeout(()=>{
            if (!this._finished) {
                this.setStatus("deadline_exceeded");
                this._finishReason = $1efef08b5fe9fa0b$var$IDLE_TRANSACTION_FINISH_REASONS[3];
                this.finish();
            }
        }, this._finalTimeout);
    }
    /** {@inheritDoc} */ finish(endTimestamp = (0, $cvSY8.timestampInSeconds)()) {
        this._finished = true;
        this.activities = {};
        if (this.op === "ui.action.click") this.setTag($1efef08b5fe9fa0b$var$FINISH_REASON_TAG, this._finishReason);
        if (this.spanRecorder) {
            (0, $8IHa9.DEBUG_BUILD) && (0, $4g0Ct.logger).log("[Tracing] finishing IdleTransaction", new Date(endTimestamp * 1000).toISOString(), this.op);
            for (const callback of this._beforeFinishCallbacks)callback(this, endTimestamp);
            this.spanRecorder.spans = this.spanRecorder.spans.filter((span)=>{
                // If we are dealing with the transaction itself, we just return it
                if (span.spanId === this.spanId) return true;
                // We cancel all pending spans with status "cancelled" to indicate the idle transaction was finished early
                if (!span.endTimestamp) {
                    span.endTimestamp = endTimestamp;
                    span.setStatus("cancelled");
                    (0, $8IHa9.DEBUG_BUILD) && (0, $4g0Ct.logger).log("[Tracing] cancelling span since transaction ended early", JSON.stringify(span, undefined, 2));
                }
                const spanStartedBeforeTransactionFinish = span.startTimestamp < endTimestamp;
                // Add a delta with idle timeout so that we prevent false positives
                const timeoutWithMarginOfError = (this._finalTimeout + this._idleTimeout) / 1000;
                const spanEndedBeforeFinalTimeout = span.endTimestamp - this.startTimestamp < timeoutWithMarginOfError;
                if (0, $8IHa9.DEBUG_BUILD) {
                    const stringifiedSpan = JSON.stringify(span, undefined, 2);
                    if (!spanStartedBeforeTransactionFinish) (0, $4g0Ct.logger).log("[Tracing] discarding Span since it happened after Transaction was finished", stringifiedSpan);
                    else if (!spanEndedBeforeFinalTimeout) (0, $4g0Ct.logger).log("[Tracing] discarding Span since it finished after Transaction final timeout", stringifiedSpan);
                }
                return spanStartedBeforeTransactionFinish && spanEndedBeforeFinalTimeout;
            });
            (0, $8IHa9.DEBUG_BUILD) && (0, $4g0Ct.logger).log("[Tracing] flushing IdleTransaction");
        } else (0, $8IHa9.DEBUG_BUILD) && (0, $4g0Ct.logger).log("[Tracing] No active IdleTransaction");
        // if `this._onScope` is `true`, the transaction put itself on the scope when it started
        if (this._onScope) {
            const scope = this._idleHub.getScope();
            if (scope.getTransaction() === this) scope.setSpan(undefined);
        }
        return super.finish(endTimestamp);
    }
    /**
   * Register a callback function that gets excecuted before the transaction finishes.
   * Useful for cleanup or if you want to add any additional spans based on current context.
   *
   * This is exposed because users have no other way of running something before an idle transaction
   * finishes.
   */ registerBeforeFinishCallback(callback) {
        this._beforeFinishCallbacks.push(callback);
    }
    /**
   * @inheritDoc
   */ initSpanRecorder(maxlen) {
        if (!this.spanRecorder) {
            const pushActivity = (id)=>{
                if (this._finished) return;
                this._pushActivity(id);
            };
            const popActivity = (id)=>{
                if (this._finished) return;
                this._popActivity(id);
            };
            this.spanRecorder = new $1efef08b5fe9fa0b$export$370d6113c18ba86c(pushActivity, popActivity, this.spanId, maxlen);
            // Start heartbeat so that transactions do not run forever.
            (0, $8IHa9.DEBUG_BUILD) && (0, $4g0Ct.logger).log("Starting heartbeat");
            this._pingHeartbeat();
        }
        this.spanRecorder.add(this);
    }
    /**
   * Cancels the existing idle timeout, if there is one.
   * @param restartOnChildSpanChange Default is `true`.
   *                                 If set to false the transaction will end
   *                                 with the last child span.
   */ cancelIdleTimeout(endTimestamp, { restartOnChildSpanChange: restartOnChildSpanChange } = {
        restartOnChildSpanChange: true
    }) {
        this._idleTimeoutCanceledPermanently = restartOnChildSpanChange === false;
        if (this._idleTimeoutID) {
            clearTimeout(this._idleTimeoutID);
            this._idleTimeoutID = undefined;
            if (Object.keys(this.activities).length === 0 && this._idleTimeoutCanceledPermanently) {
                this._finishReason = $1efef08b5fe9fa0b$var$IDLE_TRANSACTION_FINISH_REASONS[5];
                this.finish(endTimestamp);
            }
        }
    }
    /**
   * Temporary method used to externally set the transaction's `finishReason`
   *
   * ** WARNING**
   * This is for the purpose of experimentation only and will be removed in the near future, do not use!
   *
   * @internal
   *
   */ setFinishReason(reason) {
        this._finishReason = reason;
    }
    /**
   * Restarts idle timeout, if there is no running idle timeout it will start one.
   */ _restartIdleTimeout(endTimestamp) {
        this.cancelIdleTimeout();
        this._idleTimeoutID = setTimeout(()=>{
            if (!this._finished && Object.keys(this.activities).length === 0) {
                this._finishReason = $1efef08b5fe9fa0b$var$IDLE_TRANSACTION_FINISH_REASONS[1];
                this.finish(endTimestamp);
            }
        }, this._idleTimeout);
    }
    /**
   * Start tracking a specific activity.
   * @param spanId The span id that represents the activity
   */ _pushActivity(spanId) {
        this.cancelIdleTimeout(undefined, {
            restartOnChildSpanChange: !this._idleTimeoutCanceledPermanently
        });
        (0, $8IHa9.DEBUG_BUILD) && (0, $4g0Ct.logger).log(`[Tracing] pushActivity: ${spanId}`);
        this.activities[spanId] = true;
        (0, $8IHa9.DEBUG_BUILD) && (0, $4g0Ct.logger).log("[Tracing] new activities count", Object.keys(this.activities).length);
    }
    /**
   * Remove an activity from usage
   * @param spanId The span id that represents the activity
   */ _popActivity(spanId) {
        if (this.activities[spanId]) {
            (0, $8IHa9.DEBUG_BUILD) && (0, $4g0Ct.logger).log(`[Tracing] popActivity ${spanId}`);
            // eslint-disable-next-line @typescript-eslint/no-dynamic-delete
            delete this.activities[spanId];
            (0, $8IHa9.DEBUG_BUILD) && (0, $4g0Ct.logger).log("[Tracing] new activities count", Object.keys(this.activities).length);
        }
        if (Object.keys(this.activities).length === 0) {
            const endTimestamp = (0, $cvSY8.timestampInSeconds)();
            if (this._idleTimeoutCanceledPermanently) {
                this._finishReason = $1efef08b5fe9fa0b$var$IDLE_TRANSACTION_FINISH_REASONS[5];
                this.finish(endTimestamp);
            } else // We need to add the timeout here to have the real endtimestamp of the transaction
            // Remember timestampInSeconds is in seconds, timeout is in ms
            this._restartIdleTimeout(endTimestamp + this._idleTimeout / 1000);
        }
    }
    /**
   * Checks when entries of this.activities are not changing for 3 beats.
   * If this occurs we finish the transaction.
   */ _beat() {
        // We should not be running heartbeat if the idle transaction is finished.
        if (this._finished) return;
        const heartbeatString = Object.keys(this.activities).join("");
        if (heartbeatString === this._prevHeartbeatString) this._heartbeatCounter++;
        else this._heartbeatCounter = 1;
        this._prevHeartbeatString = heartbeatString;
        if (this._heartbeatCounter >= 3) {
            (0, $8IHa9.DEBUG_BUILD) && (0, $4g0Ct.logger).log("[Tracing] Transaction finished because of no change for 3 heart beats");
            this.setStatus("deadline_exceeded");
            this._finishReason = $1efef08b5fe9fa0b$var$IDLE_TRANSACTION_FINISH_REASONS[0];
            this.finish();
        } else this._pingHeartbeat();
    }
    /**
   * Pings the heartbeat
   */ _pingHeartbeat() {
        (0, $8IHa9.DEBUG_BUILD) && (0, $4g0Ct.logger).log(`pinging Heartbeat -> current counter: ${this._heartbeatCounter}`);
        setTimeout(()=>{
            this._beat();
        }, this._heartbeatInterval);
    }
}

});
parcelRegister("cKEJC", function(module, exports) {

$parcel$export(module.exports, "SpanRecorder", () => $948960fec1caf8ab$export$10c95c129cd0d4fe);
$parcel$export(module.exports, "Span", () => $948960fec1caf8ab$export$5f1714a13ed34c01);
$parcel$export(module.exports, "spanStatusfromHttpCode", () => $948960fec1caf8ab$export$ac65c70d78fcdb55);

var $jL8lq = parcelRequire("jL8lq");
var $65HJt = parcelRequire("65HJt");
var $4g0Ct = parcelRequire("4g0Ct");
var $cvSY8 = parcelRequire("cvSY8");
var $b1E2c = parcelRequire("b1E2c");

var $8IHa9 = parcelRequire("8IHa9");
/**
 * Keeps track of finished spans for a given transaction
 * @internal
 * @hideconstructor
 * @hidden
 */ class $948960fec1caf8ab$export$10c95c129cd0d4fe {
    constructor(maxlen = 1000){
        this._maxlen = maxlen;
        this.spans = [];
    }
    /**
   * This is just so that we don't run out of memory while recording a lot
   * of spans. At some point we just stop and flush out the start of the
   * trace tree (i.e.the first n spans with the smallest
   * start_timestamp).
   */ add(span) {
        if (this.spans.length > this._maxlen) span.spanRecorder = undefined;
        else this.spans.push(span);
    }
}
/**
 * Span contains all data about a span
 */ class $948960fec1caf8ab$export$5f1714a13ed34c01 {
    /**
   * @inheritDoc
   */ /**
   * @inheritDoc
   */ /**
   * @inheritDoc
   */ /**
   * Internal keeper of the status
   */ /**
   * @inheritDoc
   */ /**
   * Timestamp in seconds when the span was created.
   */ /**
   * Timestamp in seconds when the span ended.
   */ /**
   * @inheritDoc
   */ /**
   * @inheritDoc
   */ /**
   * @inheritDoc
   */ /**
   * @inheritDoc
   */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
    /**
   * List of spans that were finalized
   */ /**
   * @inheritDoc
   */ /**
   * The instrumenter that created this span.
   */ /**
   * The origin of the span, giving context about what created the span.
   */ /**
   * You should never call the constructor manually, always use `Sentry.startTransaction()`
   * or call `startChild()` on an existing span.
   * @internal
   * @hideconstructor
   * @hidden
   */ constructor(spanContext = {}){
        this.traceId = spanContext.traceId || (0, $b1E2c.uuid4)();
        this.spanId = spanContext.spanId || (0, $b1E2c.uuid4)().substring(16);
        this.startTimestamp = spanContext.startTimestamp || (0, $cvSY8.timestampInSeconds)();
        this.tags = spanContext.tags || {};
        this.data = spanContext.data || {};
        this.instrumenter = spanContext.instrumenter || "sentry";
        this.origin = spanContext.origin || "manual";
        if (spanContext.parentSpanId) this.parentSpanId = spanContext.parentSpanId;
        // We want to include booleans as well here
        if ("sampled" in spanContext) this.sampled = spanContext.sampled;
        if (spanContext.op) this.op = spanContext.op;
        if (spanContext.description) this.description = spanContext.description;
        if (spanContext.name) this.description = spanContext.name;
        if (spanContext.status) this.status = spanContext.status;
        if (spanContext.endTimestamp) this.endTimestamp = spanContext.endTimestamp;
    }
    /** An alias for `description` of the Span. */ get name() {
        return this.description || "";
    }
    /** Update the name of the span. */ set name(name) {
        this.setName(name);
    }
    /**
   * @inheritDoc
   */ startChild(spanContext) {
        const childSpan = new $948960fec1caf8ab$export$5f1714a13ed34c01({
            ...spanContext,
            parentSpanId: this.spanId,
            sampled: this.sampled,
            traceId: this.traceId
        });
        childSpan.spanRecorder = this.spanRecorder;
        if (childSpan.spanRecorder) childSpan.spanRecorder.add(childSpan);
        childSpan.transaction = this.transaction;
        if ((0, $8IHa9.DEBUG_BUILD) && childSpan.transaction) {
            const opStr = spanContext && spanContext.op || "< unknown op >";
            const nameStr = childSpan.transaction.name || "< unknown name >";
            const idStr = childSpan.transaction.spanId;
            const logMessage = `[Tracing] Starting '${opStr}' span on transaction '${nameStr}' (${idStr}).`;
            childSpan.transaction.metadata.spanMetadata[childSpan.spanId] = {
                logMessage: logMessage
            };
            (0, $4g0Ct.logger).log(logMessage);
        }
        return childSpan;
    }
    /**
   * @inheritDoc
   */ setTag(key, value) {
        this.tags = {
            ...this.tags,
            [key]: value
        };
        return this;
    }
    /**
   * @inheritDoc
   */ // eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/explicit-module-boundary-types
    setData(key, value) {
        this.data = {
            ...this.data,
            [key]: value
        };
        return this;
    }
    /**
   * @inheritDoc
   */ setStatus(value) {
        this.status = value;
        return this;
    }
    /**
   * @inheritDoc
   */ setHttpStatus(httpStatus) {
        this.setTag("http.status_code", String(httpStatus));
        this.setData("http.response.status_code", httpStatus);
        const spanStatus = $948960fec1caf8ab$export$ac65c70d78fcdb55(httpStatus);
        if (spanStatus !== "unknown_error") this.setStatus(spanStatus);
        return this;
    }
    /**
   * @inheritDoc
   */ setName(name) {
        this.description = name;
    }
    /**
   * @inheritDoc
   */ isSuccess() {
        return this.status === "ok";
    }
    /**
   * @inheritDoc
   */ finish(endTimestamp) {
        if ((0, $8IHa9.DEBUG_BUILD) && // Don't call this for transactions
        this.transaction && this.transaction.spanId !== this.spanId) {
            const { logMessage: logMessage } = this.transaction.metadata.spanMetadata[this.spanId];
            if (logMessage) (0, $4g0Ct.logger).log(logMessage.replace("Starting", "Finishing"));
        }
        this.endTimestamp = typeof endTimestamp === "number" ? endTimestamp : (0, $cvSY8.timestampInSeconds)();
    }
    /**
   * @inheritDoc
   */ toTraceparent() {
        return (0, $65HJt.generateSentryTraceHeader)(this.traceId, this.spanId, this.sampled);
    }
    /**
   * @inheritDoc
   */ toContext() {
        return (0, $jL8lq.dropUndefinedKeys)({
            data: this.data,
            description: this.description,
            endTimestamp: this.endTimestamp,
            op: this.op,
            parentSpanId: this.parentSpanId,
            sampled: this.sampled,
            spanId: this.spanId,
            startTimestamp: this.startTimestamp,
            status: this.status,
            tags: this.tags,
            traceId: this.traceId
        });
    }
    /**
   * @inheritDoc
   */ updateWithContext(spanContext) {
        this.data = spanContext.data || {};
        this.description = spanContext.description;
        this.endTimestamp = spanContext.endTimestamp;
        this.op = spanContext.op;
        this.parentSpanId = spanContext.parentSpanId;
        this.sampled = spanContext.sampled;
        this.spanId = spanContext.spanId || this.spanId;
        this.startTimestamp = spanContext.startTimestamp || this.startTimestamp;
        this.status = spanContext.status;
        this.tags = spanContext.tags || {};
        this.traceId = spanContext.traceId || this.traceId;
        return this;
    }
    /**
   * @inheritDoc
   */ getTraceContext() {
        return (0, $jL8lq.dropUndefinedKeys)({
            data: Object.keys(this.data).length > 0 ? this.data : undefined,
            description: this.description,
            op: this.op,
            parent_span_id: this.parentSpanId,
            span_id: this.spanId,
            status: this.status,
            tags: Object.keys(this.tags).length > 0 ? this.tags : undefined,
            trace_id: this.traceId,
            origin: this.origin
        });
    }
    /**
   * @inheritDoc
   */ toJSON() {
        return (0, $jL8lq.dropUndefinedKeys)({
            data: Object.keys(this.data).length > 0 ? this.data : undefined,
            description: this.description,
            op: this.op,
            parent_span_id: this.parentSpanId,
            span_id: this.spanId,
            start_timestamp: this.startTimestamp,
            status: this.status,
            tags: Object.keys(this.tags).length > 0 ? this.tags : undefined,
            timestamp: this.endTimestamp,
            trace_id: this.traceId,
            origin: this.origin
        });
    }
}
/**
 * Converts a HTTP status code into a {@link SpanStatusType}.
 *
 * @param httpStatus The HTTP response status code.
 * @returns The span status or unknown_error.
 */ function $948960fec1caf8ab$export$ac65c70d78fcdb55(httpStatus) {
    if (httpStatus < 400 && httpStatus >= 100) return "ok";
    if (httpStatus >= 400 && httpStatus < 500) switch(httpStatus){
        case 401:
            return "unauthenticated";
        case 403:
            return "permission_denied";
        case 404:
            return "not_found";
        case 409:
            return "already_exists";
        case 413:
            return "failed_precondition";
        case 429:
            return "resource_exhausted";
        default:
            return "invalid_argument";
    }
    if (httpStatus >= 500 && httpStatus < 600) switch(httpStatus){
        case 501:
            return "unimplemented";
        case 503:
            return "unavailable";
        case 504:
            return "deadline_exceeded";
        default:
            return "internal_error";
    }
    return "unknown_error";
}

});

parcelRegister("6Tqu0", function(module, exports) {

$parcel$export(module.exports, "Transaction", () => $504c6c1458d8d0e9$export$febc5573c75cefb0);

var $jL8lq = parcelRequire("jL8lq");
var $4g0Ct = parcelRequire("4g0Ct");

var $8IHa9 = parcelRequire("8IHa9");

var $cmFjP = parcelRequire("cmFjP");

var $bPHT6 = parcelRequire("bPHT6");

var $cKEJC = parcelRequire("cKEJC");
/** JSDoc */ class $504c6c1458d8d0e9$export$febc5573c75cefb0 extends (0, $cKEJC.Span) {
    /**
   * The reference to the current hub.
   */ /**
   * This constructor should never be called manually. Those instrumenting tracing should use
   * `Sentry.startTransaction()`, and internal methods should use `hub.startTransaction()`.
   * @internal
   * @hideconstructor
   * @hidden
   */ constructor(transactionContext, hub){
        super(transactionContext);
        // We need to delete description since it's set by the Span class constructor
        // but not needed for transactions.
        delete this.description;
        this._measurements = {};
        this._contexts = {};
        this._hub = hub || (0, $cmFjP.getCurrentHub)();
        this._name = transactionContext.name || "";
        this.metadata = {
            source: "custom",
            ...transactionContext.metadata,
            spanMetadata: {}
        };
        this._trimEnd = transactionContext.trimEnd;
        // this is because transactions are also spans, and spans have a transaction pointer
        this.transaction = this;
        // If Dynamic Sampling Context is provided during the creation of the transaction, we freeze it as it usually means
        // there is incoming Dynamic Sampling Context. (Either through an incoming request, a baggage meta-tag, or other means)
        const incomingDynamicSamplingContext = this.metadata.dynamicSamplingContext;
        if (incomingDynamicSamplingContext) // We shallow copy this in case anything writes to the original reference of the passed in `dynamicSamplingContext`
        this._frozenDynamicSamplingContext = {
            ...incomingDynamicSamplingContext
        };
    }
    /** Getter for `name` property */ get name() {
        return this._name;
    }
    /** Setter for `name` property, which also sets `source` as custom */ set name(newName) {
        this.setName(newName);
    }
    /**
   * JSDoc
   */ setName(name, source = "custom") {
        this._name = name;
        this.metadata.source = source;
    }
    /**
   * Attaches SpanRecorder to the span itself
   * @param maxlen maximum number of spans that can be recorded
   */ initSpanRecorder(maxlen = 1000) {
        if (!this.spanRecorder) this.spanRecorder = new (0, $cKEJC.SpanRecorder)(maxlen);
        this.spanRecorder.add(this);
    }
    /**
   * @inheritDoc
   */ setContext(key, context) {
        if (context === null) // eslint-disable-next-line @typescript-eslint/no-dynamic-delete
        delete this._contexts[key];
        else this._contexts[key] = context;
    }
    /**
   * @inheritDoc
   */ setMeasurement(name, value, unit = "") {
        this._measurements[name] = {
            value: value,
            unit: unit
        };
    }
    /**
   * @inheritDoc
   */ setMetadata(newMetadata) {
        this.metadata = {
            ...this.metadata,
            ...newMetadata
        };
    }
    /**
   * @inheritDoc
   */ finish(endTimestamp) {
        const transaction = this._finishTransaction(endTimestamp);
        if (!transaction) return undefined;
        return this._hub.captureEvent(transaction);
    }
    /**
   * @inheritDoc
   */ toContext() {
        const spanContext = super.toContext();
        return (0, $jL8lq.dropUndefinedKeys)({
            ...spanContext,
            name: this.name,
            trimEnd: this._trimEnd
        });
    }
    /**
   * @inheritDoc
   */ updateWithContext(transactionContext) {
        super.updateWithContext(transactionContext);
        this.name = transactionContext.name || "";
        this._trimEnd = transactionContext.trimEnd;
        return this;
    }
    /**
   * @inheritdoc
   *
   * @experimental
   */ getDynamicSamplingContext() {
        if (this._frozenDynamicSamplingContext) return this._frozenDynamicSamplingContext;
        const hub = this._hub || (0, $cmFjP.getCurrentHub)();
        const client = hub.getClient();
        if (!client) return {};
        const scope = hub.getScope();
        const dsc = (0, $bPHT6.getDynamicSamplingContextFromClient)(this.traceId, client, scope);
        const maybeSampleRate = this.metadata.sampleRate;
        if (maybeSampleRate !== undefined) dsc.sample_rate = `${maybeSampleRate}`;
        // We don't want to have a transaction name in the DSC if the source is "url" because URLs might contain PII
        const source = this.metadata.source;
        if (source && source !== "url") dsc.transaction = this.name;
        if (this.sampled !== undefined) dsc.sampled = String(this.sampled);
        // Uncomment if we want to make DSC immutable
        // this._frozenDynamicSamplingContext = dsc;
        return dsc;
    }
    /**
   * Override the current hub with a new one.
   * Used if you want another hub to finish the transaction.
   *
   * @internal
   */ setHub(hub) {
        this._hub = hub;
    }
    /**
   * Finish the transaction & prepare the event to send to Sentry.
   */ _finishTransaction(endTimestamp) {
        // This transaction is already finished, so we should not flush it again.
        if (this.endTimestamp !== undefined) return undefined;
        if (!this.name) {
            (0, $8IHa9.DEBUG_BUILD) && (0, $4g0Ct.logger).warn("Transaction has no name, falling back to `<unlabeled transaction>`.");
            this.name = "<unlabeled transaction>";
        }
        // just sets the end timestamp
        super.finish(endTimestamp);
        const client = this._hub.getClient();
        if (client && client.emit) client.emit("finishTransaction", this);
        if (this.sampled !== true) {
            // At this point if `sampled !== true` we want to discard the transaction.
            (0, $8IHa9.DEBUG_BUILD) && (0, $4g0Ct.logger).log("[Tracing] Discarding transaction because its trace was not chosen to be sampled.");
            if (client) client.recordDroppedEvent("sample_rate", "transaction");
            return undefined;
        }
        const finishedSpans = this.spanRecorder ? this.spanRecorder.spans.filter((s)=>s !== this && s.endTimestamp) : [];
        if (this._trimEnd && finishedSpans.length > 0) this.endTimestamp = finishedSpans.reduce((prev, current)=>{
            if (prev.endTimestamp && current.endTimestamp) return prev.endTimestamp > current.endTimestamp ? prev : current;
            return prev;
        }).endTimestamp;
        const metadata = this.metadata;
        const transaction = {
            contexts: {
                ...this._contexts,
                // We don't want to override trace context
                trace: this.getTraceContext()
            },
            spans: finishedSpans,
            start_timestamp: this.startTimestamp,
            tags: this.tags,
            timestamp: this.endTimestamp,
            transaction: this.name,
            type: "transaction",
            sdkProcessingMetadata: {
                ...metadata,
                dynamicSamplingContext: this.getDynamicSamplingContext()
            },
            ...metadata.source && {
                transaction_info: {
                    source: metadata.source
                }
            }
        };
        const hasMeasurements = Object.keys(this._measurements).length > 0;
        if (hasMeasurements) {
            (0, $8IHa9.DEBUG_BUILD) && (0, $4g0Ct.logger).log("[Measurements] Adding measurements to transaction", JSON.stringify(this._measurements, undefined, 2));
            transaction.measurements = this._measurements;
        }
        (0, $8IHa9.DEBUG_BUILD) && (0, $4g0Ct.logger).log(`[Tracing] Finishing ${this.op} transaction: ${this.name}.`);
        return transaction;
    }
}

});
parcelRegister("bPHT6", function(module, exports) {

$parcel$export(module.exports, "getDynamicSamplingContextFromClient", () => $89d6805454b84092$export$366bad00d6815eed);

var $jL8lq = parcelRequire("jL8lq");

var $kfXMR = parcelRequire("kfXMR");
/**
 * Creates a dynamic sampling context from a client.
 *
 * Dispatchs the `createDsc` lifecycle hook as a side effect.
 */ function $89d6805454b84092$export$366bad00d6815eed(trace_id, client, scope) {
    const options = client.getOptions();
    const { publicKey: public_key } = client.getDsn() || {};
    const { segment: user_segment } = scope && scope.getUser() || {};
    const dsc = (0, $jL8lq.dropUndefinedKeys)({
        environment: options.environment || (0, $kfXMR.DEFAULT_ENVIRONMENT),
        release: options.release,
        user_segment: user_segment,
        public_key: public_key,
        trace_id: trace_id
    });
    client.emit && client.emit("createDsc", dsc);
    return dsc;
}

});



parcelRegister("kJ1jU", function(module, exports) {

$parcel$export(module.exports, "sampleTransaction", () => $f16908c3df50a491$export$b3258c3993bc9b71);

var $2zW56 = parcelRequire("2zW56");
var $4g0Ct = parcelRequire("4g0Ct");

var $8IHa9 = parcelRequire("8IHa9");

var $duCnO = parcelRequire("duCnO");
/**
 * Makes a sampling decision for the given transaction and stores it on the transaction.
 *
 * Called every time a transaction is created. Only transactions which emerge with a `sampled` value of `true` will be
 * sent to Sentry.
 *
 * This method muttes the given `transaction` and will set the `sampled` value on it.
 * It returns the same transaction, for convenience.
 */ function $f16908c3df50a491$export$b3258c3993bc9b71(transaction, options, samplingContext) {
    // nothing to do if tracing is not enabled
    if (!(0, $duCnO.hasTracingEnabled)(options)) {
        transaction.sampled = false;
        return transaction;
    }
    // if the user has forced a sampling decision by passing a `sampled` value in their transaction context, go with that
    if (transaction.sampled !== undefined) {
        transaction.setMetadata({
            sampleRate: Number(transaction.sampled)
        });
        return transaction;
    }
    // we would have bailed already if neither `tracesSampler` nor `tracesSampleRate` nor `enableTracing` were defined, so one of these should
    // work; prefer the hook if so
    let sampleRate;
    if (typeof options.tracesSampler === "function") {
        sampleRate = options.tracesSampler(samplingContext);
        transaction.setMetadata({
            sampleRate: Number(sampleRate)
        });
    } else if (samplingContext.parentSampled !== undefined) sampleRate = samplingContext.parentSampled;
    else if (typeof options.tracesSampleRate !== "undefined") {
        sampleRate = options.tracesSampleRate;
        transaction.setMetadata({
            sampleRate: Number(sampleRate)
        });
    } else {
        // When `enableTracing === true`, we use a sample rate of 100%
        sampleRate = 1;
        transaction.setMetadata({
            sampleRate: sampleRate
        });
    }
    // Since this is coming from the user (or from a function provided by the user), who knows what we might get. (The
    // only valid values are booleans or numbers between 0 and 1.)
    if (!$f16908c3df50a491$var$isValidSampleRate(sampleRate)) {
        (0, $8IHa9.DEBUG_BUILD) && (0, $4g0Ct.logger).warn("[Tracing] Discarding transaction because of invalid sample rate.");
        transaction.sampled = false;
        return transaction;
    }
    // if the function returned 0 (or false), or if `tracesSampleRate` is 0, it's a sign the transaction should be dropped
    if (!sampleRate) {
        (0, $8IHa9.DEBUG_BUILD) && (0, $4g0Ct.logger).log(`[Tracing] Discarding transaction because ${typeof options.tracesSampler === "function" ? "tracesSampler returned 0 or false" : "a negative sampling decision was inherited or tracesSampleRate is set to 0"}`);
        transaction.sampled = false;
        return transaction;
    }
    // Now we roll the dice. Math.random is inclusive of 0, but not of 1, so strict < is safe here. In case sampleRate is
    // a boolean, the < comparison will cause it to be automatically cast to 1 if it's true and 0 if it's false.
    transaction.sampled = Math.random() < sampleRate;
    // if we're not going to keep it, we're done
    if (!transaction.sampled) {
        (0, $8IHa9.DEBUG_BUILD) && (0, $4g0Ct.logger).log(`[Tracing] Discarding transaction because it's not included in the random sample (sampling rate = ${Number(sampleRate)})`);
        return transaction;
    }
    (0, $8IHa9.DEBUG_BUILD) && (0, $4g0Ct.logger).log(`[Tracing] starting ${transaction.op} transaction - ${transaction.name}`);
    return transaction;
}
/**
 * Checks the given sample rate to make sure it is valid type and value (a boolean, or a number between 0 and 1).
 */ function $f16908c3df50a491$var$isValidSampleRate(rate) {
    // we need to check NaN explicitly because it's of type 'number' and therefore wouldn't get caught by this typecheck
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    if ((0, $2zW56.isNaN)(rate) || !(typeof rate === "number" || typeof rate === "boolean")) {
        (0, $8IHa9.DEBUG_BUILD) && (0, $4g0Ct.logger).warn(`[Tracing] Given sample rate is invalid. Sample rate must be a boolean or a number between 0 and 1. Got ${JSON.stringify(rate)} of type ${JSON.stringify(typeof rate)}.`);
        return false;
    }
    // in case sampleRate is a boolean, it will get automatically cast to 1 if it's true and 0 if it's false
    if (rate < 0 || rate > 1) {
        (0, $8IHa9.DEBUG_BUILD) && (0, $4g0Ct.logger).warn(`[Tracing] Given sample rate is invalid. Sample rate must be between 0 and 1. Got ${rate}.`);
        return false;
    }
    return true;
}

});
parcelRegister("duCnO", function(module, exports) {

$parcel$export(module.exports, "hasTracingEnabled", () => $9d2bd9c413e91a74$export$5008da00b1b6dee6);

var $b8438 = parcelRequire("b8438");
// Treeshakable guard to remove all code related to tracing
/**
 * Determines if tracing is currently enabled.
 *
 * Tracing is enabled when at least one of `tracesSampleRate` and `tracesSampler` is defined in the SDK config.
 */ function $9d2bd9c413e91a74$export$5008da00b1b6dee6(maybeOptions) {
    if (typeof __SENTRY_TRACING__ === "boolean" && !__SENTRY_TRACING__) return false;
    const client = (0, $b8438.getClient)();
    const options = maybeOptions || client && client.getOptions();
    return !!options && (options.enableTracing || "tracesSampleRate" in options || "tracesSampler" in options);
}

});
parcelRegister("b8438", function(module, exports) {

$parcel$export(module.exports, "captureException", () => $81a395368bb6f380$export$f5282963edea4a68);
$parcel$export(module.exports, "captureMessage", () => $81a395368bb6f380$export$45654777c133ae80);
$parcel$export(module.exports, "addBreadcrumb", () => $81a395368bb6f380$export$efda9a273d7a036d);
$parcel$export(module.exports, "withScope", () => $81a395368bb6f380$export$ec58d9285c204497);
$parcel$export(module.exports, "getClient", () => $81a395368bb6f380$export$6bb76d6eba7e258c);

var $2zW56 = parcelRequire("2zW56");
var $4g0Ct = parcelRequire("4g0Ct");
var $cvSY8 = parcelRequire("cvSY8");
var $b1E2c = parcelRequire("b1E2c");

var $8IHa9 = parcelRequire("8IHa9");

var $cmFjP = parcelRequire("cmFjP");

var $az0Em = parcelRequire("az0Em");
// Note: All functions in this file are typed with a return value of `ReturnType<Hub[HUB_FUNCTION]>`,
// where HUB_FUNCTION is some method on the Hub class.
//
// This is done to make sure the top level SDK methods stay in sync with the hub methods.
// Although every method here has an explicit return type, some of them (that map to void returns) do not
// contain `return` keywords. This is done to save on bundle size, as `return` is not minifiable.
/**
 * Captures an exception event and sends it to Sentry.
 * This accepts an event hint as optional second parameter.
 * Alternatively, you can also pass a CaptureContext directly as second parameter.
 */ function $81a395368bb6f380$export$f5282963edea4a68(// eslint-disable-next-line @typescript-eslint/no-explicit-any
exception, hint) {
    return (0, $cmFjP.getCurrentHub)().captureException(exception, (0, $az0Em.parseEventHintOrCaptureContext)(hint));
}
/**
 * Captures a message event and sends it to Sentry.
 *
 * @param message The message to send to Sentry.
 * @param Severity Define the level of the message.
 * @returns The generated eventId.
 */ function $81a395368bb6f380$export$45654777c133ae80(message, // eslint-disable-next-line deprecation/deprecation
captureContext) {
    // This is necessary to provide explicit scopes upgrade, without changing the original
    // arity of the `captureMessage(message, level)` method.
    const level = typeof captureContext === "string" ? captureContext : undefined;
    const context = typeof captureContext !== "string" ? {
        captureContext: captureContext
    } : undefined;
    return (0, $cmFjP.getCurrentHub)().captureMessage(message, level, context);
}
/**
 * Captures a manually created event and sends it to Sentry.
 *
 * @param event The event to send to Sentry.
 * @returns The generated eventId.
 */ function $81a395368bb6f380$export$1462b974fdcf6ba2(event, hint) {
    return (0, $cmFjP.getCurrentHub)().captureEvent(event, hint);
}
/**
 * Callback to set context information onto the scope.
 * @param callback Callback function that receives Scope.
 */ function $81a395368bb6f380$export$99d44f04437e9cb8(callback) {
    (0, $cmFjP.getCurrentHub)().configureScope(callback);
}
/**
 * Records a new breadcrumb which will be attached to future events.
 *
 * Breadcrumbs will be added to subsequent events to provide more context on
 * user's actions prior to an error or crash.
 *
 * @param breadcrumb The breadcrumb to record.
 */ function $81a395368bb6f380$export$efda9a273d7a036d(breadcrumb) {
    (0, $cmFjP.getCurrentHub)().addBreadcrumb(breadcrumb);
}
/**
 * Sets context data with the given name.
 * @param name of the context
 * @param context Any kind of data. This data will be normalized.
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function $81a395368bb6f380$export$2f04de43fe27971a(name, context) {
    (0, $cmFjP.getCurrentHub)().setContext(name, context);
}
/**
 * Set an object that will be merged sent as extra data with the event.
 * @param extras Extras object to merge into current context.
 */ function $81a395368bb6f380$export$bb4922da0dd51b92(extras) {
    (0, $cmFjP.getCurrentHub)().setExtras(extras);
}
/**
 * Set key:value that will be sent as extra data with the event.
 * @param key String of extra
 * @param extra Any kind of data. This data will be normalized.
 */ function $81a395368bb6f380$export$8e8e7789d42ed61d(key, extra) {
    (0, $cmFjP.getCurrentHub)().setExtra(key, extra);
}
/**
 * Set an object that will be merged sent as tags data with the event.
 * @param tags Tags context object to merge into current context.
 */ function $81a395368bb6f380$export$74a8fb34822092e6(tags) {
    (0, $cmFjP.getCurrentHub)().setTags(tags);
}
/**
 * Set key:value that will be sent as tags data with the event.
 *
 * Can also be used to unset a tag, by passing `undefined`.
 *
 * @param key String key of tag
 * @param value Value of tag
 */ function $81a395368bb6f380$export$a37d07ee78eb4569(key, value) {
    (0, $cmFjP.getCurrentHub)().setTag(key, value);
}
/**
 * Updates user context information for future events.
 *
 * @param user User context object to be set in the current context. Pass `null` to unset the user.
 */ function $81a395368bb6f380$export$8b6bb3dd62a01be2(user) {
    (0, $cmFjP.getCurrentHub)().setUser(user);
}
/**
 * Creates a new scope with and executes the given operation within.
 * The scope is automatically removed once the operation
 * finishes or throws.
 *
 * This is essentially a convenience function for:
 *
 *     pushScope();
 *     callback();
 *     popScope();
 *
 * @param callback that will be enclosed into push/popScope.
 */ function $81a395368bb6f380$export$ec58d9285c204497(callback) {
    (0, $cmFjP.getCurrentHub)().withScope(callback);
}
/**
 * Starts a new `Transaction` and returns it. This is the entry point to manual tracing instrumentation.
 *
 * A tree structure can be built by adding child spans to the transaction, and child spans to other spans. To start a
 * new child span within the transaction or any span, call the respective `.startChild()` method.
 *
 * Every child span must be finished before the transaction is finished, otherwise the unfinished spans are discarded.
 *
 * The transaction must be finished with a call to its `.finish()` method, at which point the transaction with all its
 * finished child spans will be sent to Sentry.
 *
 * NOTE: This function should only be used for *manual* instrumentation. Auto-instrumentation should call
 * `startTransaction` directly on the hub.
 *
 * @param context Properties of the new `Transaction`.
 * @param customSamplingContext Information given to the transaction sampling function (along with context-dependent
 * default values). See {@link Options.tracesSampler}.
 *
 * @returns The transaction which was just started
 */ function $81a395368bb6f380$export$e262da7ae6480481(context, customSamplingContext) {
    return (0, $cmFjP.getCurrentHub)().startTransaction({
        ...context
    }, customSamplingContext);
}
/**
 * Create a cron monitor check in and send it to Sentry.
 *
 * @param checkIn An object that describes a check in.
 * @param upsertMonitorConfig An optional object that describes a monitor config. Use this if you want
 * to create a monitor automatically when sending a check in.
 */ function $81a395368bb6f380$export$413528111fbc67c(checkIn, upsertMonitorConfig) {
    const hub = (0, $cmFjP.getCurrentHub)();
    const scope = hub.getScope();
    const client = hub.getClient();
    if (!client) (0, $8IHa9.DEBUG_BUILD) && (0, $4g0Ct.logger).warn("Cannot capture check-in. No client defined.");
    else if (!client.captureCheckIn) (0, $8IHa9.DEBUG_BUILD) && (0, $4g0Ct.logger).warn("Cannot capture check-in. Client does not support sending check-ins.");
    else return client.captureCheckIn(checkIn, upsertMonitorConfig, scope);
    return (0, $b1E2c.uuid4)();
}
/**
 * Wraps a callback with a cron monitor check in. The check in will be sent to Sentry when the callback finishes.
 *
 * @param monitorSlug The distinct slug of the monitor.
 * @param upsertMonitorConfig An optional object that describes a monitor config. Use this if you want
 * to create a monitor automatically when sending a check in.
 */ function $81a395368bb6f380$export$553526fc5f03c0b1(monitorSlug, callback, upsertMonitorConfig) {
    const checkInId = $81a395368bb6f380$export$413528111fbc67c({
        monitorSlug: monitorSlug,
        status: "in_progress"
    }, upsertMonitorConfig);
    const now = (0, $cvSY8.timestampInSeconds)();
    function finishCheckIn(status) {
        $81a395368bb6f380$export$413528111fbc67c({
            monitorSlug: monitorSlug,
            status: status,
            checkInId: checkInId,
            duration: (0, $cvSY8.timestampInSeconds)() - now
        });
    }
    let maybePromiseResult;
    try {
        maybePromiseResult = callback();
    } catch (e) {
        finishCheckIn("error");
        throw e;
    }
    if ((0, $2zW56.isThenable)(maybePromiseResult)) Promise.resolve(maybePromiseResult).then(()=>{
        finishCheckIn("ok");
    }, ()=>{
        finishCheckIn("error");
    });
    else finishCheckIn("ok");
    return maybePromiseResult;
}
/**
 * Call `flush()` on the current client, if there is one. See {@link Client.flush}.
 *
 * @param timeout Maximum time in ms the client should wait to flush its event queue. Omitting this parameter will cause
 * the client to wait until all events are sent before resolving the promise.
 * @returns A promise which resolves to `true` if the queue successfully drains before the timeout, or `false` if it
 * doesn't (or if there's no client defined).
 */ async function $81a395368bb6f380$export$4909b86c8034bf73(timeout) {
    const client = $81a395368bb6f380$export$6bb76d6eba7e258c();
    if (client) return client.flush(timeout);
    (0, $8IHa9.DEBUG_BUILD) && (0, $4g0Ct.logger).warn("Cannot flush events. No client defined.");
    return Promise.resolve(false);
}
/**
 * Call `close()` on the current client, if there is one. See {@link Client.close}.
 *
 * @param timeout Maximum time in ms the client should wait to flush its event queue before shutting down. Omitting this
 * parameter will cause the client to wait until all events are sent before disabling itself.
 * @returns A promise which resolves to `true` if the queue successfully drains before the timeout, or `false` if it
 * doesn't (or if there's no client defined).
 */ async function $81a395368bb6f380$export$8360e631d277ea4d(timeout) {
    const client = $81a395368bb6f380$export$6bb76d6eba7e258c();
    if (client) return client.close(timeout);
    (0, $8IHa9.DEBUG_BUILD) && (0, $4g0Ct.logger).warn("Cannot flush events and disable SDK. No client defined.");
    return Promise.resolve(false);
}
/**
 * This is the getter for lastEventId.
 *
 * @returns The last event id of a captured event.
 */ function $81a395368bb6f380$export$5d4e9fd7fac8e617() {
    return (0, $cmFjP.getCurrentHub)().lastEventId();
}
/**
 * Get the currently active client.
 */ function $81a395368bb6f380$export$6bb76d6eba7e258c() {
    return (0, $cmFjP.getCurrentHub)().getClient();
}

});
parcelRegister("az0Em", function(module, exports) {

$parcel$export(module.exports, "prepareEvent", () => $7b0dad5cf366cc16$export$2d67fb380bd11267);
$parcel$export(module.exports, "parseEventHintOrCaptureContext", () => $7b0dad5cf366cc16$export$76b5f966996d1653);

var $b1E2c = parcelRequire("b1E2c");
var $cvSY8 = parcelRequire("cvSY8");
var $3bpJ1 = parcelRequire("3bpJ1");
var $drMc1 = parcelRequire("drMc1");
var $j3a3y = parcelRequire("j3a3y");
var $91U3U = parcelRequire("91U3U");

var $kfXMR = parcelRequire("kfXMR");

var $6T4Sa = parcelRequire("6T4Sa");

var $coQoV = parcelRequire("coQoV");
/**
 * This type makes sure that we get either a CaptureContext, OR an EventHint.
 * It does not allow mixing them, which could lead to unexpected outcomes, e.g. this is disallowed:
 * { user: { id: '123' }, mechanism: { handled: false } }
 */ /**
 * Adds common information to events.
 *
 * The information includes release and environment from `options`,
 * breadcrumbs and context (extra, tags and user) from the scope.
 *
 * Information that is already present in the event is never overwritten. For
 * nested objects, such as the context, keys are merged.
 *
 * Note: This also triggers callbacks for `addGlobalEventProcessor`, but not `beforeSend`.
 *
 * @param event The original event.
 * @param hint May contain additional information about the original exception.
 * @param scope A scope containing event metadata.
 * @returns A new event with more information.
 * @hidden
 */ function $7b0dad5cf366cc16$export$2d67fb380bd11267(options, event, hint, scope, client) {
    const { normalizeDepth: normalizeDepth = 3, normalizeMaxBreadth: normalizeMaxBreadth = 1000 } = options;
    const prepared = {
        ...event,
        event_id: event.event_id || hint.event_id || (0, $b1E2c.uuid4)(),
        timestamp: event.timestamp || (0, $cvSY8.dateTimestampInSeconds)()
    };
    const integrations = hint.integrations || options.integrations.map((i)=>i.name);
    $7b0dad5cf366cc16$var$applyClientOptions(prepared, options);
    $7b0dad5cf366cc16$var$applyIntegrationsMetadata(prepared, integrations);
    // Only put debug IDs onto frames for error events.
    if (event.type === undefined) $7b0dad5cf366cc16$export$63042efc86f043e7(prepared, options.stackParser);
    // If we have scope given to us, use it as the base for further modifications.
    // This allows us to prevent unnecessary copying of data if `captureContext` is not provided.
    let finalScope = scope;
    if (hint.captureContext) finalScope = (0, $coQoV.Scope).clone(finalScope).update(hint.captureContext);
    if (hint.mechanism) (0, $b1E2c.addExceptionMechanism)(prepared, hint.mechanism);
    // We prepare the result here with a resolved Event.
    let result = (0, $j3a3y.resolvedSyncPromise)(prepared);
    const clientEventProcessors = client && client.getEventProcessors ? client.getEventProcessors() : [];
    // This should be the last thing called, since we want that
    // {@link Hub.addEventProcessor} gets the finished prepared event.
    //
    // We need to check for the existence of `finalScope.getAttachments`
    // because `getAttachments` can be undefined if users are using an older version
    // of `@sentry/core` that does not have the `getAttachments` method.
    // See: https://github.com/getsentry/sentry-javascript/issues/5229
    if (finalScope) {
        // Collect attachments from the hint and scope
        if (finalScope.getAttachments) {
            const attachments = [
                ...hint.attachments || [],
                ...finalScope.getAttachments()
            ];
            if (attachments.length) hint.attachments = attachments;
        }
        // In case we have a hub we reassign it.
        result = finalScope.applyToEvent(prepared, hint, clientEventProcessors);
    } else // Apply client & global event processors even if there is no scope
    // TODO (v8): Update the order to be Global > Client
    result = (0, $6T4Sa.notifyEventProcessors)([
        ...clientEventProcessors,
        // eslint-disable-next-line deprecation/deprecation
        ...(0, $6T4Sa.getGlobalEventProcessors)()
    ], prepared, hint);
    return result.then((evt)=>{
        if (evt) // We apply the debug_meta field only after all event processors have ran, so that if any event processors modified
        // file names (e.g.the RewriteFrames integration) the filename -> debug ID relationship isn't destroyed.
        // This should not cause any PII issues, since we're only moving data that is already on the event and not adding
        // any new data
        $7b0dad5cf366cc16$export$1be657ba8ef44ff0(evt);
        if (typeof normalizeDepth === "number" && normalizeDepth > 0) return $7b0dad5cf366cc16$var$normalizeEvent(evt, normalizeDepth, normalizeMaxBreadth);
        return evt;
    });
}
/**
 *  Enhances event using the client configuration.
 *  It takes care of all "static" values like environment, release and `dist`,
 *  as well as truncating overly long values.
 * @param event event instance to be enhanced
 */ function $7b0dad5cf366cc16$var$applyClientOptions(event, options) {
    const { environment: environment, release: release, dist: dist, maxValueLength: maxValueLength = 250 } = options;
    if (!("environment" in event)) event.environment = "environment" in options ? environment : (0, $kfXMR.DEFAULT_ENVIRONMENT);
    if (event.release === undefined && release !== undefined) event.release = release;
    if (event.dist === undefined && dist !== undefined) event.dist = dist;
    if (event.message) event.message = (0, $91U3U.truncate)(event.message, maxValueLength);
    const exception = event.exception && event.exception.values && event.exception.values[0];
    if (exception && exception.value) exception.value = (0, $91U3U.truncate)(exception.value, maxValueLength);
    const request = event.request;
    if (request && request.url) request.url = (0, $91U3U.truncate)(request.url, maxValueLength);
}
const $7b0dad5cf366cc16$var$debugIdStackParserCache = new WeakMap();
/**
 * Puts debug IDs into the stack frames of an error event.
 */ function $7b0dad5cf366cc16$export$63042efc86f043e7(event, stackParser) {
    const debugIdMap = (0, $3bpJ1.GLOBAL_OBJ)._sentryDebugIds;
    if (!debugIdMap) return;
    let debugIdStackFramesCache;
    const cachedDebugIdStackFrameCache = $7b0dad5cf366cc16$var$debugIdStackParserCache.get(stackParser);
    if (cachedDebugIdStackFrameCache) debugIdStackFramesCache = cachedDebugIdStackFrameCache;
    else {
        debugIdStackFramesCache = new Map();
        $7b0dad5cf366cc16$var$debugIdStackParserCache.set(stackParser, debugIdStackFramesCache);
    }
    // Build a map of filename -> debug_id
    const filenameDebugIdMap = Object.keys(debugIdMap).reduce((acc, debugIdStackTrace)=>{
        let parsedStack;
        const cachedParsedStack = debugIdStackFramesCache.get(debugIdStackTrace);
        if (cachedParsedStack) parsedStack = cachedParsedStack;
        else {
            parsedStack = stackParser(debugIdStackTrace);
            debugIdStackFramesCache.set(debugIdStackTrace, parsedStack);
        }
        for(let i = parsedStack.length - 1; i >= 0; i--){
            const stackFrame = parsedStack[i];
            if (stackFrame.filename) {
                acc[stackFrame.filename] = debugIdMap[debugIdStackTrace];
                break;
            }
        }
        return acc;
    }, {});
    try {
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        event.exception.values.forEach((exception)=>{
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            exception.stacktrace.frames.forEach((frame)=>{
                if (frame.filename) frame.debug_id = filenameDebugIdMap[frame.filename];
            });
        });
    } catch (e) {
    // To save bundle size we're just try catching here instead of checking for the existence of all the different objects.
    }
}
/**
 * Moves debug IDs from the stack frames of an error event into the debug_meta field.
 */ function $7b0dad5cf366cc16$export$1be657ba8ef44ff0(event) {
    // Extract debug IDs and filenames from the stack frames on the event.
    const filenameDebugIdMap = {};
    try {
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        event.exception.values.forEach((exception)=>{
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            exception.stacktrace.frames.forEach((frame)=>{
                if (frame.debug_id) {
                    if (frame.abs_path) filenameDebugIdMap[frame.abs_path] = frame.debug_id;
                    else if (frame.filename) filenameDebugIdMap[frame.filename] = frame.debug_id;
                    delete frame.debug_id;
                }
            });
        });
    } catch (e) {
    // To save bundle size we're just try catching here instead of checking for the existence of all the different objects.
    }
    if (Object.keys(filenameDebugIdMap).length === 0) return;
    // Fill debug_meta information
    event.debug_meta = event.debug_meta || {};
    event.debug_meta.images = event.debug_meta.images || [];
    const images = event.debug_meta.images;
    Object.keys(filenameDebugIdMap).forEach((filename)=>{
        images.push({
            type: "sourcemap",
            code_file: filename,
            debug_id: filenameDebugIdMap[filename]
        });
    });
}
/**
 * This function adds all used integrations to the SDK info in the event.
 * @param event The event that will be filled with all integrations.
 */ function $7b0dad5cf366cc16$var$applyIntegrationsMetadata(event, integrationNames) {
    if (integrationNames.length > 0) {
        event.sdk = event.sdk || {};
        event.sdk.integrations = [
            ...event.sdk.integrations || [],
            ...integrationNames
        ];
    }
}
/**
 * Applies `normalize` function on necessary `Event` attributes to make them safe for serialization.
 * Normalized keys:
 * - `breadcrumbs.data`
 * - `user`
 * - `contexts`
 * - `extra`
 * @param event Event
 * @returns Normalized event
 */ function $7b0dad5cf366cc16$var$normalizeEvent(event, depth, maxBreadth) {
    if (!event) return null;
    const normalized = {
        ...event,
        ...event.breadcrumbs && {
            breadcrumbs: event.breadcrumbs.map((b)=>({
                    ...b,
                    ...b.data && {
                        data: (0, $drMc1.normalize)(b.data, depth, maxBreadth)
                    }
                }))
        },
        ...event.user && {
            user: (0, $drMc1.normalize)(event.user, depth, maxBreadth)
        },
        ...event.contexts && {
            contexts: (0, $drMc1.normalize)(event.contexts, depth, maxBreadth)
        },
        ...event.extra && {
            extra: (0, $drMc1.normalize)(event.extra, depth, maxBreadth)
        }
    };
    // event.contexts.trace stores information about a Transaction. Similarly,
    // event.spans[] stores information about child Spans. Given that a
    // Transaction is conceptually a Span, normalization should apply to both
    // Transactions and Spans consistently.
    // For now the decision is to skip normalization of Transactions and Spans,
    // so this block overwrites the normalized event to add back the original
    // Transaction information prior to normalization.
    if (event.contexts && event.contexts.trace && normalized.contexts) {
        normalized.contexts.trace = event.contexts.trace;
        // event.contexts.trace.data may contain circular/dangerous data so we need to normalize it
        if (event.contexts.trace.data) normalized.contexts.trace.data = (0, $drMc1.normalize)(event.contexts.trace.data, depth, maxBreadth);
    }
    // event.spans[].data may contain circular/dangerous data so we need to normalize it
    if (event.spans) normalized.spans = event.spans.map((span)=>{
        // We cannot use the spread operator here because `toJSON` on `span` is non-enumerable
        if (span.data) span.data = (0, $drMc1.normalize)(span.data, depth, maxBreadth);
        return span;
    });
    return normalized;
}
/**
 * Parse either an `EventHint` directly, or convert a `CaptureContext` to an `EventHint`.
 * This is used to allow to update method signatures that used to accept a `CaptureContext` but should now accept an `EventHint`.
 */ function $7b0dad5cf366cc16$export$76b5f966996d1653(hint) {
    if (!hint) return undefined;
    // If you pass a Scope or `() => Scope` as CaptureContext, we just return this as captureContext
    if ($7b0dad5cf366cc16$var$hintIsScopeOrFunction(hint)) return {
        captureContext: hint
    };
    if ($7b0dad5cf366cc16$var$hintIsScopeContext(hint)) return {
        captureContext: hint
    };
    return hint;
}
function $7b0dad5cf366cc16$var$hintIsScopeOrFunction(hint) {
    return hint instanceof (0, $coQoV.Scope) || typeof hint === "function";
}
const $7b0dad5cf366cc16$var$captureContextKeys = [
    "user",
    "level",
    "extra",
    "contexts",
    "tags",
    "fingerprint",
    "requestSession",
    "propagationContext"
];
function $7b0dad5cf366cc16$var$hintIsScopeContext(hint) {
    return Object.keys(hint).some((key)=>$7b0dad5cf366cc16$var$captureContextKeys.includes(key));
}

});
parcelRegister("drMc1", function(module, exports) {

$parcel$export(module.exports, "normalize", () => $9ca32e18a091d955$export$a3295358bff77e);
$parcel$export(module.exports, "normalizeToSize", () => $9ca32e18a091d955$export$23fbbb20bed71033);

var $2zW56 = parcelRequire("2zW56");

var $3BHn6 = parcelRequire("3BHn6");

var $jL8lq = parcelRequire("jL8lq");

var $16dZf = parcelRequire("16dZf");
/**
 * Recursively normalizes the given object.
 *
 * - Creates a copy to prevent original input mutation
 * - Skips non-enumerable properties
 * - When stringifying, calls `toJSON` if implemented
 * - Removes circular references
 * - Translates non-serializable values (`undefined`/`NaN`/functions) to serializable format
 * - Translates known global objects/classes to a string representations
 * - Takes care of `Error` object serialization
 * - Optionally limits depth of final output
 * - Optionally limits number of properties/elements included in any single object/array
 *
 * @param input The object to be normalized.
 * @param depth The max depth to which to normalize the object. (Anything deeper stringified whole.)
 * @param maxProperties The max number of elements or properties to be included in any single array or
 * object in the normallized output.
 * @returns A normalized version of the object, or `"**non-serializable**"` if any errors are thrown during normalization.
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function $9ca32e18a091d955$export$a3295358bff77e(input, depth = 100, maxProperties = Infinity) {
    try {
        // since we're at the outermost level, we don't provide a key
        return $9ca32e18a091d955$export$588732934346abbf("", input, depth, maxProperties);
    } catch (err) {
        return {
            ERROR: `**non-serializable** (${err})`
        };
    }
}
/** JSDoc */ function $9ca32e18a091d955$export$23fbbb20bed71033(// eslint-disable-next-line @typescript-eslint/no-explicit-any
object, // Default Node.js REPL depth
depth = 3, // 100kB, as 200kB is max payload size, so half sounds reasonable
maxSize = 102400) {
    const normalized = $9ca32e18a091d955$export$a3295358bff77e(object, depth);
    if ($9ca32e18a091d955$var$jsonSize(normalized) > maxSize) return $9ca32e18a091d955$export$23fbbb20bed71033(object, depth - 1, maxSize);
    return normalized;
}
/**
 * Visits a node to perform normalization on it
 *
 * @param key The key corresponding to the given node
 * @param value The node to be visited
 * @param depth Optional number indicating the maximum recursion depth
 * @param maxProperties Optional maximum number of properties/elements included in any single object/array
 * @param memo Optional Memo class handling decycling
 */ function $9ca32e18a091d955$export$588732934346abbf(key, value, depth = Infinity, maxProperties = Infinity, memo = (0, $3BHn6.memoBuilder)()) {
    const [memoize, unmemoize] = memo;
    // Get the simple cases out of the way first
    if (value == null || // this matches null and undefined -> eqeq not eqeqeq
    [
        "number",
        "boolean",
        "string"
    ].includes(typeof value) && !(0, $2zW56.isNaN)(value)) return value;
    const stringified = $9ca32e18a091d955$var$stringifyValue(key, value);
    // Anything we could potentially dig into more (objects or arrays) will have come back as `"[object XXXX]"`.
    // Everything else will have already been serialized, so if we don't see that pattern, we're done.
    if (!stringified.startsWith("[object ")) return stringified;
    // From here on, we can assert that `value` is either an object or an array.
    // Do not normalize objects that we know have already been normalized. As a general rule, the
    // "__sentry_skip_normalization__" property should only be used sparingly and only should only be set on objects that
    // have already been normalized.
    if (value["__sentry_skip_normalization__"]) return value;
    // We can set `__sentry_override_normalization_depth__` on an object to ensure that from there
    // We keep a certain amount of depth.
    // This should be used sparingly, e.g. we use it for the redux integration to ensure we get a certain amount of state.
    const remainingDepth = typeof value["__sentry_override_normalization_depth__"] === "number" ? value["__sentry_override_normalization_depth__"] : depth;
    // We're also done if we've reached the max depth
    if (remainingDepth === 0) // At this point we know `serialized` is a string of the form `"[object XXXX]"`. Clean it up so it's just `"[XXXX]"`.
    return stringified.replace("object ", "");
    // If we've already visited this branch, bail out, as it's circular reference. If not, note that we're seeing it now.
    if (memoize(value)) return "[Circular ~]";
    // If the value has a `toJSON` method, we call it to extract more information
    const valueWithToJSON = value;
    if (valueWithToJSON && typeof valueWithToJSON.toJSON === "function") try {
        const jsonValue = valueWithToJSON.toJSON();
        // We need to normalize the return value of `.toJSON()` in case it has circular references
        return $9ca32e18a091d955$export$588732934346abbf("", jsonValue, remainingDepth - 1, maxProperties, memo);
    } catch (err) {
    // pass (The built-in `toJSON` failed, but we can still try to do it ourselves)
    }
    // At this point we know we either have an object or an array, we haven't seen it before, and we're going to recurse
    // because we haven't yet reached the max depth. Create an accumulator to hold the results of visiting each
    // property/entry, and keep track of the number of items we add to it.
    const normalized = Array.isArray(value) ? [] : {};
    let numAdded = 0;
    // Before we begin, convert`Error` and`Event` instances into plain objects, since some of each of their relevant
    // properties are non-enumerable and otherwise would get missed.
    const visitable = (0, $jL8lq.convertToPlainObject)(value);
    for(const visitKey in visitable){
        // Avoid iterating over fields in the prototype if they've somehow been exposed to enumeration.
        if (!Object.prototype.hasOwnProperty.call(visitable, visitKey)) continue;
        if (numAdded >= maxProperties) {
            normalized[visitKey] = "[MaxProperties ~]";
            break;
        }
        // Recursively visit all the child nodes
        const visitValue = visitable[visitKey];
        normalized[visitKey] = $9ca32e18a091d955$export$588732934346abbf(visitKey, visitValue, remainingDepth - 1, maxProperties, memo);
        numAdded++;
    }
    // Once we've visited all the branches, remove the parent from memo storage
    unmemoize(value);
    // Return accumulated values
    return normalized;
}
/* eslint-disable complexity */ /**
 * Stringify the given value. Handles various known special values and types.
 *
 * Not meant to be used on simple primitives which already have a string representation, as it will, for example, turn
 * the number 1231 into "[Object Number]", nor on `null`, as it will throw.
 *
 * @param value The value to stringify
 * @returns A stringified representation of the given value
 */ function $9ca32e18a091d955$var$stringifyValue(key, // this type is a tiny bit of a cheat, since this function does handle NaN (which is technically a number), but for
// our internal use, it'll do
value) {
    try {
        if (key === "domain" && value && typeof value === "object" && value._events) return "[Domain]";
        if (key === "domainEmitter") return "[DomainEmitter]";
        // It's safe to use `global`, `window`, and `document` here in this manner, as we are asserting using `typeof` first
        // which won't throw if they are not present.
        if (typeof $parcel$global !== "undefined" && value === $parcel$global) return "[Global]";
        // eslint-disable-next-line no-restricted-globals
        if (typeof window !== "undefined" && value === window) return "[Window]";
        // eslint-disable-next-line no-restricted-globals
        if (typeof document !== "undefined" && value === document) return "[Document]";
        if ((0, $2zW56.isVueViewModel)(value)) return "[VueViewModel]";
        // React's SyntheticEvent thingy
        if ((0, $2zW56.isSyntheticEvent)(value)) return "[SyntheticEvent]";
        if (typeof value === "number" && value !== value) return "[NaN]";
        if (typeof value === "function") return `[Function: ${(0, $16dZf.getFunctionName)(value)}]`;
        if (typeof value === "symbol") return `[${String(value)}]`;
        // stringified BigInts are indistinguishable from regular numbers, so we need to label them to avoid confusion
        if (typeof value === "bigint") return `[BigInt: ${String(value)}]`;
        // Now that we've knocked out all the special cases and the primitives, all we have left are objects. Simply casting
        // them to strings means that instances of classes which haven't defined their `toStringTag` will just come out as
        // `"[object Object]"`. If we instead look at the constructor's name (which is the same as the name of the class),
        // we can make sure that only plain objects come out that way.
        const objName = $9ca32e18a091d955$var$getConstructorName(value);
        // Handle HTML Elements
        if (/^HTML(\w*)Element$/.test(objName)) return `[HTMLElement: ${objName}]`;
        return `[object ${objName}]`;
    } catch (err) {
        return `**non-serializable** (${err})`;
    }
}
/* eslint-enable complexity */ function $9ca32e18a091d955$var$getConstructorName(value) {
    const prototype = Object.getPrototypeOf(value);
    return prototype ? prototype.constructor.name : "null prototype";
}
/** Calculates bytes size of input string */ function $9ca32e18a091d955$var$utf8Length(value) {
    // eslint-disable-next-line no-bitwise
    return ~-encodeURI(value).split(/%..|./).length;
}
/** Calculates bytes size of input object */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function $9ca32e18a091d955$var$jsonSize(value) {
    return $9ca32e18a091d955$var$utf8Length(JSON.stringify(value));
}

});
parcelRegister("3BHn6", function(module, exports) {

$parcel$export(module.exports, "memoBuilder", () => $2a06788518a26cc6$export$8115b0b78e956ab3);
/* eslint-disable @typescript-eslint/no-unsafe-member-access */ /* eslint-disable @typescript-eslint/no-explicit-any */ /**
 * Helper to decycle json objects
 */ function $2a06788518a26cc6$export$8115b0b78e956ab3() {
    const hasWeakSet = typeof WeakSet === "function";
    const inner = hasWeakSet ? new WeakSet() : [];
    function memoize(obj) {
        if (hasWeakSet) {
            if (inner.has(obj)) return true;
            inner.add(obj);
            return false;
        }
        // eslint-disable-next-line @typescript-eslint/prefer-for-of
        for(let i = 0; i < inner.length; i++){
            const value = inner[i];
            if (value === obj) return true;
        }
        inner.push(obj);
        return false;
    }
    function unmemoize(obj) {
        if (hasWeakSet) inner.delete(obj);
        else {
            for(let i = 0; i < inner.length; i++)if (inner[i] === obj) {
                inner.splice(i, 1);
                break;
            }
        }
    }
    return [
        memoize,
        unmemoize
    ];
}

});








parcelRegister("6KR8i", function(module, exports) {

$parcel$export(module.exports, "useSyncExternalStore", () => $4eb0410bd318fafe$export$306c0aa65ff9ec16, (v) => $4eb0410bd318fafe$export$306c0aa65ff9ec16 = v);
/**
 * @license React
 * use-sync-external-store-shim.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $4eb0410bd318fafe$export$306c0aa65ff9ec16;
"use strict";

(function() {
    "use strict";
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ !== "undefined" && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart === "function") __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart(new Error());
    var React = (parcelRequire("acw62"));
    var ReactSharedInternals = React.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function error(format) {
        for(var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++)args[_key2 - 1] = arguments[_key2];
        printWarning("error", format, args);
    }
    function printWarning(level, format, args) {
        var ReactDebugCurrentFrame = ReactSharedInternals.ReactDebugCurrentFrame;
        var stack = ReactDebugCurrentFrame.getStackAddendum();
        if (stack !== "") {
            format += "%s";
            args = args.concat([
                stack
            ]);
        } // eslint-disable-next-line react-internal/safe-string-coercion
        var argsWithFormat = args.map(function(item) {
            return String(item);
        }); // Careful: RN currently depends on this prefix
        argsWithFormat.unshift("Warning: " + format); // We intentionally don't use spread (or .apply) directly because it
        // breaks IE9: https://github.com/facebook/react/issues/13610
        // eslint-disable-next-line react-internal/no-production-logging
        Function.prototype.apply.call(console[level], console, argsWithFormat);
    }
    /**
 * inlined Object.is polyfill to avoid requiring consumers ship their own
 * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
 */ function is(x, y) {
        return x === y && (x !== 0 || 1 / x === 1 / y) || x !== x && y !== y // eslint-disable-line no-self-compare
        ;
    }
    var objectIs = typeof Object.is === "function" ? Object.is : is;
    // dispatch for CommonJS interop named imports.
    var useState = React.useState, useEffect = React.useEffect, useLayoutEffect = React.useLayoutEffect, useDebugValue = React.useDebugValue;
    var didWarnOld18Alpha = false;
    var didWarnUncachedGetSnapshot = false; // Disclaimer: This shim breaks many of the rules of React, and only works
    // because of a very particular set of implementation details and assumptions
    // -- change any one of them and it will break. The most important assumption
    // is that updates are always synchronous, because concurrent rendering is
    // only available in versions of React that also have a built-in
    // useSyncExternalStore API. And we only use this shim when the built-in API
    // does not exist.
    //
    // Do not assume that the clever hacks used by this hook also work in general.
    // The point of this shim is to replace the need for hacks by other libraries.
    function useSyncExternalStore(subscribe, getSnapshot, // React do not expose a way to check if we're hydrating. So users of the shim
    // will need to track that themselves and return the correct value
    // from `getSnapshot`.
    getServerSnapshot) {
        if (!didWarnOld18Alpha) {
            if (React.startTransition !== undefined) {
                didWarnOld18Alpha = true;
                error("You are using an outdated, pre-release alpha of React 18 that does not support useSyncExternalStore. The use-sync-external-store shim will not work correctly. Upgrade to a newer pre-release.");
            }
        }
        // breaks the rules of React, and only works here because of specific
        // implementation details, most importantly that updates are
        // always synchronous.
        var value = getSnapshot();
        if (!didWarnUncachedGetSnapshot) {
            var cachedValue = getSnapshot();
            if (!objectIs(value, cachedValue)) {
                error("The result of getSnapshot should be cached to avoid an infinite loop");
                didWarnUncachedGetSnapshot = true;
            }
        }
        // re-render whenever the subscribed state changes by updating an some
        // arbitrary useState hook. Then, during render, we call getSnapshot to read
        // the current value.
        //
        // Because we don't actually use the state returned by the useState hook, we
        // can save a bit of memory by storing other stuff in that slot.
        //
        // To implement the early bailout, we need to track some things on a mutable
        // object. Usually, we would put that in a useRef hook, but we can stash it in
        // our useState hook instead.
        //
        // To force a re-render, we call forceUpdate({inst}). That works because the
        // new object always fails an equality check.
        var _useState = useState({
            inst: {
                value: value,
                getSnapshot: getSnapshot
            }
        }), inst = _useState[0].inst, forceUpdate = _useState[1]; // Track the latest getSnapshot function with a ref. This needs to be updated
        // in the layout phase so we can access it during the tearing check that
        // happens on subscribe.
        useLayoutEffect(function() {
            inst.value = value;
            inst.getSnapshot = getSnapshot; // Whenever getSnapshot or subscribe changes, we need to check in the
            // commit phase if there was an interleaved mutation. In concurrent mode
            // this can happen all the time, but even in synchronous mode, an earlier
            // effect may have mutated the store.
            if (checkIfSnapshotChanged(inst)) // Force a re-render.
            forceUpdate({
                inst: inst
            });
        }, [
            subscribe,
            value,
            getSnapshot
        ]);
        useEffect(function() {
            // Check for changes right before subscribing. Subsequent changes will be
            // detected in the subscription handler.
            if (checkIfSnapshotChanged(inst)) // Force a re-render.
            forceUpdate({
                inst: inst
            });
            var handleStoreChange = function() {
                // TODO: Because there is no cross-renderer API for batching updates, it's
                // up to the consumer of this library to wrap their subscription event
                // with unstable_batchedUpdates. Should we try to detect when this isn't
                // the case and print a warning in development?
                // The store changed. Check if the snapshot changed since the last time we
                // read from the store.
                if (checkIfSnapshotChanged(inst)) // Force a re-render.
                forceUpdate({
                    inst: inst
                });
            }; // Subscribe to the store and return a clean-up function.
            return subscribe(handleStoreChange);
        }, [
            subscribe
        ]);
        useDebugValue(value);
        return value;
    }
    function checkIfSnapshotChanged(inst) {
        var latestGetSnapshot = inst.getSnapshot;
        var prevValue = inst.value;
        try {
            var nextValue = latestGetSnapshot();
            return !objectIs(prevValue, nextValue);
        } catch (error) {
            return true;
        }
    }
    function useSyncExternalStore$1(subscribe, getSnapshot, getServerSnapshot) {
        // Note: The shim does not use getServerSnapshot, because pre-18 versions of
        // React do not expose a way to check if we're hydrating. So users of the shim
        // will need to track that themselves and return the correct value
        // from `getSnapshot`.
        return getSnapshot();
    }
    var canUseDOM = !!(typeof window !== "undefined" && typeof window.document !== "undefined" && typeof window.document.createElement !== "undefined");
    var isServerEnvironment = !canUseDOM;
    var shim = isServerEnvironment ? useSyncExternalStore$1 : useSyncExternalStore;
    var useSyncExternalStore$2 = React.useSyncExternalStore !== undefined ? React.useSyncExternalStore : shim;
    $4eb0410bd318fafe$export$306c0aa65ff9ec16 = useSyncExternalStore$2;
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ !== "undefined" && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop === "function") __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop(new Error());
})();

});

parcelRegister("f504n", function(module, exports) {

var $23YZo = parcelRequire("23YZo");

var $fiQnm = parcelRequire("fiQnm");
/** Detect free variable `exports`. */ var freeExports = exports && !exports.nodeType && exports;
/** Detect free variable `module`. */ var freeModule = freeExports && true && module && !module.nodeType && module;
/** Detect the popular CommonJS extension `module.exports`. */ var moduleExports = freeModule && freeModule.exports === freeExports;
/** Built-in value references. */ var Buffer = moduleExports ? $23YZo.Buffer : undefined;
/* Built-in method references for those with the same name as other `lodash` methods. */ var nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined;
/**
 * Checks if `value` is a buffer.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
 * @example
 *
 * _.isBuffer(new Buffer(2));
 * // => true
 *
 * _.isBuffer(new Uint8Array(2));
 * // => false
 */ var isBuffer = nativeIsBuffer || $fiQnm;
module.exports = isBuffer;

});
parcelRegister("23YZo", function(module, exports) {

var $ljJ8G = parcelRequire("ljJ8G");
/** Detect free variable `self`. */ var $180b2bc3c0deaf6c$var$freeSelf = typeof self == "object" && self && self.Object === Object && self;
/** Used as a reference to the global object. */ var $180b2bc3c0deaf6c$var$root = $ljJ8G || $180b2bc3c0deaf6c$var$freeSelf || Function("return this")();
module.exports = $180b2bc3c0deaf6c$var$root;

});
parcelRegister("ljJ8G", function(module, exports) {
/** Detect free variable `global` from Node.js. */ var $f84e62f9db5b9ccd$var$freeGlobal = typeof $parcel$global == "object" && $parcel$global && $parcel$global.Object === Object && $parcel$global;
module.exports = $f84e62f9db5b9ccd$var$freeGlobal;

});


parcelRegister("fiQnm", function(module, exports) {
/**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */ function $b2412a30bba480f5$var$stubFalse() {
    return false;
}
module.exports = $b2412a30bba480f5$var$stubFalse;

});


parcelRegister("jIny1", function(module, exports) {

var $ljJ8G = parcelRequire("ljJ8G");
/** Detect free variable `exports`. */ var freeExports = exports && !exports.nodeType && exports;
/** Detect free variable `module`. */ var freeModule = freeExports && true && module && !module.nodeType && module;
/** Detect the popular CommonJS extension `module.exports`. */ var moduleExports = freeModule && freeModule.exports === freeExports;
/** Detect free variable `process` from Node.js. */ var freeProcess = moduleExports && $ljJ8G.process;
/** Used to access faster Node.js helpers. */ var nodeUtil = function() {
    try {
        // Use `util.types` for Node.js 10+.
        var types = freeModule && freeModule.require && freeModule.require("util").types;
        if (types) return types;
        // Legacy `process.binding('util')` for Node.js < 10.
        return freeProcess && freeProcess.binding && freeProcess.binding("util");
    } catch (e) {}
}();
module.exports = nodeUtil;

});

parcelRegister("7YFi7", function(module, exports) {

$parcel$export(module.exports, "useFormik", () => useFormik);
$parcel$export(module.exports, "Formik", () => Formik);
$parcel$export(module.exports, "Field", () => Field);
$parcel$export(module.exports, "Form", () => Form);

var $cCVp3 = parcelRequire("cCVp3");

var $3rtvu = parcelRequire("3rtvu");

var $acw62 = parcelRequire("acw62");

var $ai2Pb = parcelRequire("ai2Pb");

var $9RYKL = parcelRequire("9RYKL");

var $hNIl0 = parcelRequire("hNIl0");

var $58lCa = parcelRequire("58lCa");

var $9ORqK = parcelRequire("9ORqK");

var $chB0Q = parcelRequire("chB0Q");
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _inheritsLoose(subClass, superClass) {
    subClass.prototype = Object.create(superClass.prototype);
    subClass.prototype.constructor = subClass;
    subClass.__proto__ = superClass;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function _assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
var FormikContext = /*#__PURE__*/ (0, $acw62.createContext)(undefined);
FormikContext.displayName = "FormikContext";
var FormikProvider = FormikContext.Provider;
var FormikConsumer = FormikContext.Consumer;
function useFormikContext() {
    var formik = (0, $acw62.useContext)(FormikContext);
    !!!formik && (0, $9RYKL.default)(false, "Formik context is undefined, please verify you are calling useFormikContext() as child of a <Formik> component.");
    return formik;
}
/** @private is the value an empty array? */ var isEmptyArray = function isEmptyArray(value) {
    return Array.isArray(value) && value.length === 0;
};
/** @private is the given object a Function? */ var isFunction = function isFunction(obj) {
    return typeof obj === "function";
};
/** @private is the given object an Object? */ var isObject = function isObject(obj) {
    return obj !== null && typeof obj === "object";
};
/** @private is the given object an integer? */ var isInteger = function isInteger(obj) {
    return String(Math.floor(Number(obj))) === obj;
};
/** @private is the given object a string? */ var isString = function isString(obj) {
    return Object.prototype.toString.call(obj) === "[object String]";
};
/** @private is the given object a NaN? */ // eslint-disable-next-line no-self-compare
var isNaN$1 = function isNaN1(obj) {
    return obj !== obj;
};
/** @private Does a React component have exactly 0 children? */ var isEmptyChildren = function isEmptyChildren(children) {
    return (0, $acw62.Children).count(children) === 0;
};
/** @private is the given object/value a promise? */ var isPromise = function isPromise(value) {
    return isObject(value) && isFunction(value.then);
};
/** @private is the given object/value a type of synthetic event? */ var isInputEvent = function isInputEvent(value) {
    return value && isObject(value) && isObject(value.target);
};
/**
 * Same as document.activeElement but wraps in a try-catch block. In IE it is
 * not safe to call document.activeElement if there is nothing focused.
 *
 * The activeElement will be null only if the document or document body is not
 * yet defined.
 *
 * @param {?Document} doc Defaults to current document.
 * @return {Element | null}
 * @see https://github.com/facebook/fbjs/blob/master/packages/fbjs/src/core/dom/getActiveElement.js
 */ function getActiveElement(doc) {
    doc = doc || (typeof document !== "undefined" ? document : undefined);
    if (typeof doc === "undefined") return null;
    try {
        return doc.activeElement || doc.body;
    } catch (e) {
        return doc.body;
    }
}
/**
 * Deeply get a value from an object via its path.
 */ function getIn(obj, key, def, p) {
    if (p === void 0) p = 0;
    var path = (0, $58lCa.default)(key);
    while(obj && p < path.length)obj = obj[path[p++]];
     // check if path is not in the end
    if (p !== path.length && !obj) return def;
    return obj === undefined ? def : obj;
}
/**
 * Deeply set a value from in object via it's path. If the value at `path`
 * has changed, return a shallow copy of obj with `value` set at `path`.
 * If `value` has not changed, return the original `obj`.
 *
 * Existing objects / arrays along `path` are also shallow copied. Sibling
 * objects along path retain the same internal js reference. Since new
 * objects / arrays are only created along `path`, we can test if anything
 * changed in a nested structure by comparing the object's reference in
 * the old and new object, similar to how russian doll cache invalidation
 * works.
 *
 * In earlier versions of this function, which used cloneDeep, there were
 * issues whereby settings a nested value would mutate the parent
 * instead of creating a new object. `clone` avoids that bug making a
 * shallow copy of the objects along the update path
 * so no object is mutated in place.
 *
 * Before changing this function, please read through the following
 * discussions.
 *
 * @see https://github.com/developit/linkstate
 * @see https://github.com/jaredpalmer/formik/pull/123
 */ function setIn(obj, path, value) {
    var res = (0, $hNIl0.default)(obj); // this keeps inheritance when obj is a class
    var resVal = res;
    var i = 0;
    var pathArray = (0, $58lCa.default)(path);
    for(; i < pathArray.length - 1; i++){
        var currentPath = pathArray[i];
        var currentObj = getIn(obj, pathArray.slice(0, i + 1));
        if (currentObj && (isObject(currentObj) || Array.isArray(currentObj))) resVal = resVal[currentPath] = (0, $hNIl0.default)(currentObj);
        else {
            var nextPath = pathArray[i + 1];
            resVal = resVal[currentPath] = isInteger(nextPath) && Number(nextPath) >= 0 ? [] : {};
        }
    } // Return original object if new value is the same as current
    if ((i === 0 ? obj : resVal)[pathArray[i]] === value) return obj;
    if (value === undefined) delete resVal[pathArray[i]];
    else resVal[pathArray[i]] = value;
     // If the path array has a single element, the loop did not run.
    // Deleting on `resVal` had no effect in this scenario, so we delete on the result instead.
    if (i === 0 && value === undefined) delete res[pathArray[i]];
    return res;
}
/**
 * Recursively a set the same value for all keys and arrays nested object, cloning
 * @param object
 * @param value
 * @param visited
 * @param response
 */ function setNestedObjectValues(object, value, visited, response) {
    if (visited === void 0) visited = new WeakMap();
    if (response === void 0) response = {};
    for(var _i = 0, _Object$keys = Object.keys(object); _i < _Object$keys.length; _i++){
        var k = _Object$keys[_i];
        var val = object[k];
        if (isObject(val)) {
            if (!visited.get(val)) {
                visited.set(val, true); // In order to keep array values consistent for both dot path  and
                // bracket syntax, we need to check if this is an array so that
                // this will output  { friends: [true] } and not { friends: { "0": true } }
                response[k] = Array.isArray(val) ? [] : {};
                setNestedObjectValues(val, value, visited, response[k]);
            }
        } else response[k] = value;
    }
    return response;
}
function formikReducer(state, msg) {
    switch(msg.type){
        case "SET_VALUES":
            return _extends({}, state, {
                values: msg.payload
            });
        case "SET_TOUCHED":
            return _extends({}, state, {
                touched: msg.payload
            });
        case "SET_ERRORS":
            if ((0, (/*@__PURE__*/$parcel$interopDefault($ai2Pb)))(state.errors, msg.payload)) return state;
            return _extends({}, state, {
                errors: msg.payload
            });
        case "SET_STATUS":
            return _extends({}, state, {
                status: msg.payload
            });
        case "SET_ISSUBMITTING":
            return _extends({}, state, {
                isSubmitting: msg.payload
            });
        case "SET_ISVALIDATING":
            return _extends({}, state, {
                isValidating: msg.payload
            });
        case "SET_FIELD_VALUE":
            return _extends({}, state, {
                values: setIn(state.values, msg.payload.field, msg.payload.value)
            });
        case "SET_FIELD_TOUCHED":
            return _extends({}, state, {
                touched: setIn(state.touched, msg.payload.field, msg.payload.value)
            });
        case "SET_FIELD_ERROR":
            return _extends({}, state, {
                errors: setIn(state.errors, msg.payload.field, msg.payload.value)
            });
        case "RESET_FORM":
            return _extends({}, state, msg.payload);
        case "SET_FORMIK_STATE":
            return msg.payload(state);
        case "SUBMIT_ATTEMPT":
            return _extends({}, state, {
                touched: setNestedObjectValues(state.values, true),
                isSubmitting: true,
                submitCount: state.submitCount + 1
            });
        case "SUBMIT_FAILURE":
            return _extends({}, state, {
                isSubmitting: false
            });
        case "SUBMIT_SUCCESS":
            return _extends({}, state, {
                isSubmitting: false
            });
        default:
            return state;
    }
} // Initial empty states // objects
var emptyErrors = {};
var emptyTouched = {};
function useFormik(_ref) {
    var _ref$validateOnChange = _ref.validateOnChange, validateOnChange = _ref$validateOnChange === void 0 ? true : _ref$validateOnChange, _ref$validateOnBlur = _ref.validateOnBlur, validateOnBlur = _ref$validateOnBlur === void 0 ? true : _ref$validateOnBlur, _ref$validateOnMount = _ref.validateOnMount, validateOnMount = _ref$validateOnMount === void 0 ? false : _ref$validateOnMount, isInitialValid = _ref.isInitialValid, _ref$enableReinitiali = _ref.enableReinitialize, enableReinitialize = _ref$enableReinitiali === void 0 ? false : _ref$enableReinitiali, onSubmit = _ref.onSubmit, rest = _objectWithoutPropertiesLoose(_ref, [
        "validateOnChange",
        "validateOnBlur",
        "validateOnMount",
        "isInitialValid",
        "enableReinitialize",
        "onSubmit"
    ]);
    var props = _extends({
        validateOnChange: validateOnChange,
        validateOnBlur: validateOnBlur,
        validateOnMount: validateOnMount,
        onSubmit: onSubmit
    }, rest);
    var initialValues = (0, $acw62.useRef)(props.initialValues);
    var initialErrors = (0, $acw62.useRef)(props.initialErrors || emptyErrors);
    var initialTouched = (0, $acw62.useRef)(props.initialTouched || emptyTouched);
    var initialStatus = (0, $acw62.useRef)(props.initialStatus);
    var isMounted = (0, $acw62.useRef)(false);
    var fieldRegistry = (0, $acw62.useRef)({});
    // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $acw62.useEffect)(function() {
        !(typeof isInitialValid === "undefined") && (0, $9RYKL.default)(false, "isInitialValid has been deprecated and will be removed in future versions of Formik. Please use initialErrors or validateOnMount instead."); // eslint-disable-next-line
    }, []);
    (0, $acw62.useEffect)(function() {
        isMounted.current = true;
        return function() {
            isMounted.current = false;
        };
    }, []);
    var _React$useState = (0, $acw62.useState)(0), setIteration = _React$useState[1];
    var stateRef = (0, $acw62.useRef)({
        values: props.initialValues,
        errors: props.initialErrors || emptyErrors,
        touched: props.initialTouched || emptyTouched,
        status: props.initialStatus,
        isSubmitting: false,
        isValidating: false,
        submitCount: 0
    });
    var state = stateRef.current;
    var dispatch = (0, $acw62.useCallback)(function(action) {
        var prev = stateRef.current;
        stateRef.current = formikReducer(prev, action); // force rerender
        if (prev !== stateRef.current) setIteration(function(x) {
            return x + 1;
        });
    }, []);
    var runValidateHandler = (0, $acw62.useCallback)(function(values, field) {
        return new Promise(function(resolve, reject) {
            var maybePromisedErrors = props.validate(values, field);
            if (maybePromisedErrors == null) // use loose null check here on purpose
            resolve(emptyErrors);
            else if (isPromise(maybePromisedErrors)) maybePromisedErrors.then(function(errors) {
                resolve(errors || emptyErrors);
            }, function(actualException) {
                console.warn("Warning: An unhandled error was caught during validation in <Formik validate />", actualException);
                reject(actualException);
            });
            else resolve(maybePromisedErrors);
        });
    }, [
        props.validate
    ]);
    /**
   * Run validation against a Yup schema and optionally run a function if successful
   */ var runValidationSchema = (0, $acw62.useCallback)(function(values, field) {
        var validationSchema = props.validationSchema;
        var schema = isFunction(validationSchema) ? validationSchema(field) : validationSchema;
        var promise = field && schema.validateAt ? schema.validateAt(field, values) : validateYupSchema(values, schema);
        return new Promise(function(resolve, reject) {
            promise.then(function() {
                resolve(emptyErrors);
            }, function(err) {
                // Yup will throw a validation error if validation fails. We catch those and
                // resolve them into Formik errors. We can sniff if something is a Yup error
                // by checking error.name.
                // @see https://github.com/jquense/yup#validationerrorerrors-string--arraystring-value-any-path-string
                if (err.name === "ValidationError") resolve(yupToFormErrors(err));
                else {
                    console.warn("Warning: An unhandled error was caught during validation in <Formik validationSchema />", err);
                    reject(err);
                }
            });
        });
    }, [
        props.validationSchema
    ]);
    var runSingleFieldLevelValidation = (0, $acw62.useCallback)(function(field, value) {
        return new Promise(function(resolve) {
            return resolve(fieldRegistry.current[field].validate(value));
        });
    }, []);
    var runFieldLevelValidations = (0, $acw62.useCallback)(function(values) {
        var fieldKeysWithValidation = Object.keys(fieldRegistry.current).filter(function(f) {
            return isFunction(fieldRegistry.current[f].validate);
        }); // Construct an array with all of the field validation functions
        var fieldValidations = fieldKeysWithValidation.length > 0 ? fieldKeysWithValidation.map(function(f) {
            return runSingleFieldLevelValidation(f, getIn(values, f));
        }) : [
            Promise.resolve("DO_NOT_DELETE_YOU_WILL_BE_FIRED")
        ]; // use special case ;)
        return Promise.all(fieldValidations).then(function(fieldErrorsList) {
            return fieldErrorsList.reduce(function(prev, curr, index) {
                if (curr === "DO_NOT_DELETE_YOU_WILL_BE_FIRED") return prev;
                if (curr) prev = setIn(prev, fieldKeysWithValidation[index], curr);
                return prev;
            }, {});
        });
    }, [
        runSingleFieldLevelValidation
    ]); // Run all validations and return the result
    var runAllValidations = (0, $acw62.useCallback)(function(values) {
        return Promise.all([
            runFieldLevelValidations(values),
            props.validationSchema ? runValidationSchema(values) : {},
            props.validate ? runValidateHandler(values) : {}
        ]).then(function(_ref2) {
            var fieldErrors = _ref2[0], schemaErrors = _ref2[1], validateErrors = _ref2[2];
            var combinedErrors = (0, $cCVp3.default).all([
                fieldErrors,
                schemaErrors,
                validateErrors
            ], {
                arrayMerge: arrayMerge
            });
            return combinedErrors;
        });
    }, [
        props.validate,
        props.validationSchema,
        runFieldLevelValidations,
        runValidateHandler,
        runValidationSchema
    ]); // Run all validations methods and update state accordingly
    var validateFormWithHighPriority = useEventCallback(function(values) {
        if (values === void 0) values = state.values;
        dispatch({
            type: "SET_ISVALIDATING",
            payload: true
        });
        return runAllValidations(values).then(function(combinedErrors) {
            if (!!isMounted.current) {
                dispatch({
                    type: "SET_ISVALIDATING",
                    payload: false
                });
                dispatch({
                    type: "SET_ERRORS",
                    payload: combinedErrors
                });
            }
            return combinedErrors;
        });
    });
    (0, $acw62.useEffect)(function() {
        if (validateOnMount && isMounted.current === true && (0, (/*@__PURE__*/$parcel$interopDefault($ai2Pb)))(initialValues.current, props.initialValues)) validateFormWithHighPriority(initialValues.current);
    }, [
        validateOnMount,
        validateFormWithHighPriority
    ]);
    var resetForm = (0, $acw62.useCallback)(function(nextState) {
        var values = nextState && nextState.values ? nextState.values : initialValues.current;
        var errors = nextState && nextState.errors ? nextState.errors : initialErrors.current ? initialErrors.current : props.initialErrors || {};
        var touched = nextState && nextState.touched ? nextState.touched : initialTouched.current ? initialTouched.current : props.initialTouched || {};
        var status = nextState && nextState.status ? nextState.status : initialStatus.current ? initialStatus.current : props.initialStatus;
        initialValues.current = values;
        initialErrors.current = errors;
        initialTouched.current = touched;
        initialStatus.current = status;
        var dispatchFn = function dispatchFn() {
            dispatch({
                type: "RESET_FORM",
                payload: {
                    isSubmitting: !!nextState && !!nextState.isSubmitting,
                    errors: errors,
                    touched: touched,
                    status: status,
                    values: values,
                    isValidating: !!nextState && !!nextState.isValidating,
                    submitCount: !!nextState && !!nextState.submitCount && typeof nextState.submitCount === "number" ? nextState.submitCount : 0
                }
            });
        };
        if (props.onReset) {
            var maybePromisedOnReset = props.onReset(state.values, imperativeMethods);
            if (isPromise(maybePromisedOnReset)) maybePromisedOnReset.then(dispatchFn);
            else dispatchFn();
        } else dispatchFn();
    }, [
        props.initialErrors,
        props.initialStatus,
        props.initialTouched,
        props.onReset
    ]);
    (0, $acw62.useEffect)(function() {
        if (isMounted.current === true && !(0, (/*@__PURE__*/$parcel$interopDefault($ai2Pb)))(initialValues.current, props.initialValues)) {
            if (enableReinitialize) {
                initialValues.current = props.initialValues;
                resetForm();
                if (validateOnMount) validateFormWithHighPriority(initialValues.current);
            }
        }
    }, [
        enableReinitialize,
        props.initialValues,
        resetForm,
        validateOnMount,
        validateFormWithHighPriority
    ]);
    (0, $acw62.useEffect)(function() {
        if (enableReinitialize && isMounted.current === true && !(0, (/*@__PURE__*/$parcel$interopDefault($ai2Pb)))(initialErrors.current, props.initialErrors)) {
            initialErrors.current = props.initialErrors || emptyErrors;
            dispatch({
                type: "SET_ERRORS",
                payload: props.initialErrors || emptyErrors
            });
        }
    }, [
        enableReinitialize,
        props.initialErrors
    ]);
    (0, $acw62.useEffect)(function() {
        if (enableReinitialize && isMounted.current === true && !(0, (/*@__PURE__*/$parcel$interopDefault($ai2Pb)))(initialTouched.current, props.initialTouched)) {
            initialTouched.current = props.initialTouched || emptyTouched;
            dispatch({
                type: "SET_TOUCHED",
                payload: props.initialTouched || emptyTouched
            });
        }
    }, [
        enableReinitialize,
        props.initialTouched
    ]);
    (0, $acw62.useEffect)(function() {
        if (enableReinitialize && isMounted.current === true && !(0, (/*@__PURE__*/$parcel$interopDefault($ai2Pb)))(initialStatus.current, props.initialStatus)) {
            initialStatus.current = props.initialStatus;
            dispatch({
                type: "SET_STATUS",
                payload: props.initialStatus
            });
        }
    }, [
        enableReinitialize,
        props.initialStatus,
        props.initialTouched
    ]);
    var validateField = useEventCallback(function(name) {
        // This will efficiently validate a single field by avoiding state
        // changes if the validation function is synchronous. It's different from
        // what is called when using validateForm.
        if (fieldRegistry.current[name] && isFunction(fieldRegistry.current[name].validate)) {
            var value = getIn(state.values, name);
            var maybePromise = fieldRegistry.current[name].validate(value);
            if (isPromise(maybePromise)) {
                // Only flip isValidating if the function is async.
                dispatch({
                    type: "SET_ISVALIDATING",
                    payload: true
                });
                return maybePromise.then(function(x) {
                    return x;
                }).then(function(error) {
                    dispatch({
                        type: "SET_FIELD_ERROR",
                        payload: {
                            field: name,
                            value: error
                        }
                    });
                    dispatch({
                        type: "SET_ISVALIDATING",
                        payload: false
                    });
                });
            } else {
                dispatch({
                    type: "SET_FIELD_ERROR",
                    payload: {
                        field: name,
                        value: maybePromise
                    }
                });
                return Promise.resolve(maybePromise);
            }
        } else if (props.validationSchema) {
            dispatch({
                type: "SET_ISVALIDATING",
                payload: true
            });
            return runValidationSchema(state.values, name).then(function(x) {
                return x;
            }).then(function(error) {
                dispatch({
                    type: "SET_FIELD_ERROR",
                    payload: {
                        field: name,
                        value: getIn(error, name)
                    }
                });
                dispatch({
                    type: "SET_ISVALIDATING",
                    payload: false
                });
            });
        }
        return Promise.resolve();
    });
    var registerField = (0, $acw62.useCallback)(function(name, _ref3) {
        var validate = _ref3.validate;
        fieldRegistry.current[name] = {
            validate: validate
        };
    }, []);
    var unregisterField = (0, $acw62.useCallback)(function(name) {
        delete fieldRegistry.current[name];
    }, []);
    var setTouched = useEventCallback(function(touched, shouldValidate) {
        dispatch({
            type: "SET_TOUCHED",
            payload: touched
        });
        var willValidate = shouldValidate === undefined ? validateOnBlur : shouldValidate;
        return willValidate ? validateFormWithHighPriority(state.values) : Promise.resolve();
    });
    var setErrors = (0, $acw62.useCallback)(function(errors) {
        dispatch({
            type: "SET_ERRORS",
            payload: errors
        });
    }, []);
    var setValues = useEventCallback(function(values, shouldValidate) {
        var resolvedValues = isFunction(values) ? values(state.values) : values;
        dispatch({
            type: "SET_VALUES",
            payload: resolvedValues
        });
        var willValidate = shouldValidate === undefined ? validateOnChange : shouldValidate;
        return willValidate ? validateFormWithHighPriority(resolvedValues) : Promise.resolve();
    });
    var setFieldError = (0, $acw62.useCallback)(function(field, value) {
        dispatch({
            type: "SET_FIELD_ERROR",
            payload: {
                field: field,
                value: value
            }
        });
    }, []);
    var setFieldValue = useEventCallback(function(field, value, shouldValidate) {
        dispatch({
            type: "SET_FIELD_VALUE",
            payload: {
                field: field,
                value: value
            }
        });
        var willValidate = shouldValidate === undefined ? validateOnChange : shouldValidate;
        return willValidate ? validateFormWithHighPriority(setIn(state.values, field, value)) : Promise.resolve();
    });
    var executeChange = (0, $acw62.useCallback)(function(eventOrTextValue, maybePath) {
        // By default, assume that the first argument is a string. This allows us to use
        // handleChange with React Native and React Native Web's onChangeText prop which
        // provides just the value of the input.
        var field = maybePath;
        var val = eventOrTextValue;
        var parsed; // If the first argument is not a string though, it has to be a synthetic React Event (or a fake one),
        // so we handle like we would a normal HTML change event.
        if (!isString(eventOrTextValue)) {
            // If we can, persist the event
            // @see https://reactjs.org/docs/events.html#event-pooling
            if (eventOrTextValue.persist) eventOrTextValue.persist();
            var target = eventOrTextValue.target ? eventOrTextValue.target : eventOrTextValue.currentTarget;
            var type = target.type, name = target.name, id = target.id, value = target.value, checked = target.checked, outerHTML = target.outerHTML, options = target.options, multiple = target.multiple;
            field = maybePath ? maybePath : name ? name : id;
            if (!field && true) warnAboutMissingIdentifier({
                htmlContent: outerHTML,
                documentationAnchorLink: "handlechange-e-reactchangeeventany--void",
                handlerName: "handleChange"
            });
            val = /number|range/.test(type) ? (parsed = parseFloat(value), isNaN(parsed) ? "" : parsed) : /checkbox/.test(type) // checkboxes
             ? getValueForCheckbox(getIn(state.values, field), checked, value) : options && multiple // <select multiple>
             ? getSelectedValues(options) : value;
        }
        if (field) // Set form fields by name
        setFieldValue(field, val);
    }, [
        setFieldValue,
        state.values
    ]);
    var handleChange = useEventCallback(function(eventOrPath) {
        if (isString(eventOrPath)) return function(event) {
            return executeChange(event, eventOrPath);
        };
        else executeChange(eventOrPath);
    });
    var setFieldTouched = useEventCallback(function(field, touched, shouldValidate) {
        if (touched === void 0) touched = true;
        dispatch({
            type: "SET_FIELD_TOUCHED",
            payload: {
                field: field,
                value: touched
            }
        });
        var willValidate = shouldValidate === undefined ? validateOnBlur : shouldValidate;
        return willValidate ? validateFormWithHighPriority(state.values) : Promise.resolve();
    });
    var executeBlur = (0, $acw62.useCallback)(function(e, path) {
        if (e.persist) e.persist();
        var _e$target = e.target, name = _e$target.name, id = _e$target.id, outerHTML = _e$target.outerHTML;
        var field = path ? path : name ? name : id;
        if (!field && true) warnAboutMissingIdentifier({
            htmlContent: outerHTML,
            documentationAnchorLink: "handleblur-e-any--void",
            handlerName: "handleBlur"
        });
        setFieldTouched(field, true);
    }, [
        setFieldTouched
    ]);
    var handleBlur = useEventCallback(function(eventOrString) {
        if (isString(eventOrString)) return function(event) {
            return executeBlur(event, eventOrString);
        };
        else executeBlur(eventOrString);
    });
    var setFormikState = (0, $acw62.useCallback)(function(stateOrCb) {
        if (isFunction(stateOrCb)) dispatch({
            type: "SET_FORMIK_STATE",
            payload: stateOrCb
        });
        else dispatch({
            type: "SET_FORMIK_STATE",
            payload: function payload() {
                return stateOrCb;
            }
        });
    }, []);
    var setStatus = (0, $acw62.useCallback)(function(status) {
        dispatch({
            type: "SET_STATUS",
            payload: status
        });
    }, []);
    var setSubmitting = (0, $acw62.useCallback)(function(isSubmitting) {
        dispatch({
            type: "SET_ISSUBMITTING",
            payload: isSubmitting
        });
    }, []);
    var submitForm = useEventCallback(function() {
        dispatch({
            type: "SUBMIT_ATTEMPT"
        });
        return validateFormWithHighPriority().then(function(combinedErrors) {
            // In case an error was thrown and passed to the resolved Promise,
            // `combinedErrors` can be an instance of an Error. We need to check
            // that and abort the submit.
            // If we don't do that, calling `Object.keys(new Error())` yields an
            // empty array, which causes the validation to pass and the form
            // to be submitted.
            var isInstanceOfError = combinedErrors instanceof Error;
            var isActuallyValid = !isInstanceOfError && Object.keys(combinedErrors).length === 0;
            if (isActuallyValid) {
                // Proceed with submit...
                //
                // To respect sync submit fns, we can't simply wrap executeSubmit in a promise and
                // _always_ dispatch SUBMIT_SUCCESS because isSubmitting would then always be false.
                // This would be fine in simple cases, but make it impossible to disable submit
                // buttons where people use callbacks or promises as side effects (which is basically
                // all of v1 Formik code). Instead, recall that we are inside of a promise chain already,
                //  so we can try/catch executeSubmit(), if it returns undefined, then just bail.
                // If there are errors, throw em. Otherwise, wrap executeSubmit in a promise and handle
                // cleanup of isSubmitting on behalf of the consumer.
                var promiseOrUndefined;
                try {
                    promiseOrUndefined = executeSubmit(); // Bail if it's sync, consumer is responsible for cleaning up
                    // via setSubmitting(false)
                    if (promiseOrUndefined === undefined) return;
                } catch (error) {
                    throw error;
                }
                return Promise.resolve(promiseOrUndefined).then(function(result) {
                    if (!!isMounted.current) dispatch({
                        type: "SUBMIT_SUCCESS"
                    });
                    return result;
                })["catch"](function(_errors) {
                    if (!!isMounted.current) {
                        dispatch({
                            type: "SUBMIT_FAILURE"
                        }); // This is a legit error rejected by the onSubmit fn
                        // so we don't want to break the promise chain
                        throw _errors;
                    }
                });
            } else if (!!isMounted.current) {
                // ^^^ Make sure Formik is still mounted before updating state
                dispatch({
                    type: "SUBMIT_FAILURE"
                }); // throw combinedErrors;
                if (isInstanceOfError) throw combinedErrors;
            }
            return;
        });
    });
    var handleSubmit = useEventCallback(function(e) {
        if (e && e.preventDefault && isFunction(e.preventDefault)) e.preventDefault();
        if (e && e.stopPropagation && isFunction(e.stopPropagation)) e.stopPropagation();
         // Warn if form submission is triggered by a <button> without a
        // specified `type` attribute during development. This mitigates
        // a common gotcha in forms with both reset and submit buttons,
        // where the dev forgets to add type="button" to the reset button.
        if (typeof document !== "undefined") {
            // Safely get the active element (works with IE)
            var activeElement = getActiveElement();
            if (activeElement !== null && activeElement instanceof HTMLButtonElement) !(activeElement.attributes && activeElement.attributes.getNamedItem("type")) && (0, $9RYKL.default)(false, 'You submitted a Formik form using a button with an unspecified `type` attribute.  Most browsers default button elements to `type="submit"`. If this is not a submit button, please add `type="button"`.');
        }
        submitForm()["catch"](function(reason) {
            console.warn("Warning: An unhandled error was caught from submitForm()", reason);
        });
    });
    var imperativeMethods = {
        resetForm: resetForm,
        validateForm: validateFormWithHighPriority,
        validateField: validateField,
        setErrors: setErrors,
        setFieldError: setFieldError,
        setFieldTouched: setFieldTouched,
        setFieldValue: setFieldValue,
        setStatus: setStatus,
        setSubmitting: setSubmitting,
        setTouched: setTouched,
        setValues: setValues,
        setFormikState: setFormikState,
        submitForm: submitForm
    };
    var executeSubmit = useEventCallback(function() {
        return onSubmit(state.values, imperativeMethods);
    });
    var handleReset = useEventCallback(function(e) {
        if (e && e.preventDefault && isFunction(e.preventDefault)) e.preventDefault();
        if (e && e.stopPropagation && isFunction(e.stopPropagation)) e.stopPropagation();
        resetForm();
    });
    var getFieldMeta = (0, $acw62.useCallback)(function(name) {
        return {
            value: getIn(state.values, name),
            error: getIn(state.errors, name),
            touched: !!getIn(state.touched, name),
            initialValue: getIn(initialValues.current, name),
            initialTouched: !!getIn(initialTouched.current, name),
            initialError: getIn(initialErrors.current, name)
        };
    }, [
        state.errors,
        state.touched,
        state.values
    ]);
    var getFieldHelpers = (0, $acw62.useCallback)(function(name) {
        return {
            setValue: function setValue(value, shouldValidate) {
                return setFieldValue(name, value, shouldValidate);
            },
            setTouched: function setTouched(value, shouldValidate) {
                return setFieldTouched(name, value, shouldValidate);
            },
            setError: function setError(value) {
                return setFieldError(name, value);
            }
        };
    }, [
        setFieldValue,
        setFieldTouched,
        setFieldError
    ]);
    var getFieldProps = (0, $acw62.useCallback)(function(nameOrOptions) {
        var isAnObject = isObject(nameOrOptions);
        var name = isAnObject ? nameOrOptions.name : nameOrOptions;
        var valueState = getIn(state.values, name);
        var field = {
            name: name,
            value: valueState,
            onChange: handleChange,
            onBlur: handleBlur
        };
        if (isAnObject) {
            var type = nameOrOptions.type, valueProp = nameOrOptions.value, is = nameOrOptions.as, multiple = nameOrOptions.multiple;
            if (type === "checkbox") {
                if (valueProp === undefined) field.checked = !!valueState;
                else {
                    field.checked = !!(Array.isArray(valueState) && ~valueState.indexOf(valueProp));
                    field.value = valueProp;
                }
            } else if (type === "radio") {
                field.checked = valueState === valueProp;
                field.value = valueProp;
            } else if (is === "select" && multiple) {
                field.value = field.value || [];
                field.multiple = true;
            }
        }
        return field;
    }, [
        handleBlur,
        handleChange,
        state.values
    ]);
    var dirty = (0, $acw62.useMemo)(function() {
        return !(0, (/*@__PURE__*/$parcel$interopDefault($ai2Pb)))(initialValues.current, state.values);
    }, [
        initialValues.current,
        state.values
    ]);
    var isValid = (0, $acw62.useMemo)(function() {
        return typeof isInitialValid !== "undefined" ? dirty ? state.errors && Object.keys(state.errors).length === 0 : isInitialValid !== false && isFunction(isInitialValid) ? isInitialValid(props) : isInitialValid : state.errors && Object.keys(state.errors).length === 0;
    }, [
        isInitialValid,
        dirty,
        state.errors,
        props
    ]);
    var ctx = _extends({}, state, {
        initialValues: initialValues.current,
        initialErrors: initialErrors.current,
        initialTouched: initialTouched.current,
        initialStatus: initialStatus.current,
        handleBlur: handleBlur,
        handleChange: handleChange,
        handleReset: handleReset,
        handleSubmit: handleSubmit,
        resetForm: resetForm,
        setErrors: setErrors,
        setFormikState: setFormikState,
        setFieldTouched: setFieldTouched,
        setFieldValue: setFieldValue,
        setFieldError: setFieldError,
        setStatus: setStatus,
        setSubmitting: setSubmitting,
        setTouched: setTouched,
        setValues: setValues,
        submitForm: submitForm,
        validateForm: validateFormWithHighPriority,
        validateField: validateField,
        isValid: isValid,
        dirty: dirty,
        unregisterField: unregisterField,
        registerField: registerField,
        getFieldProps: getFieldProps,
        getFieldMeta: getFieldMeta,
        getFieldHelpers: getFieldHelpers,
        validateOnBlur: validateOnBlur,
        validateOnChange: validateOnChange,
        validateOnMount: validateOnMount
    });
    return ctx;
}
function Formik(props) {
    var formikbag = useFormik(props);
    var component = props.component, children = props.children, render = props.render, innerRef = props.innerRef; // This allows folks to pass a ref to <Formik />
    (0, $acw62.useImperativeHandle)(innerRef, function() {
        return formikbag;
    });
    // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $acw62.useEffect)(function() {
        !!props.render && (0, $9RYKL.default)(false, "<Formik render> has been deprecated and will be removed in future versions of Formik. Please use a child callback function instead. To get rid of this warning, replace <Formik render={(props) => ...} /> with <Formik>{(props) => ...}</Formik>"); // eslint-disable-next-line
    }, []);
    return (0, $acw62.createElement)(FormikProvider, {
        value: formikbag
    }, component ? (0, $acw62.createElement)(component, formikbag) : render ? render(formikbag) : children // children come last, always called
     ? isFunction(children) ? children(formikbag) : !isEmptyChildren(children) ? (0, $acw62.Children).only(children) : null : null);
}
function warnAboutMissingIdentifier(_ref4) {
    var htmlContent = _ref4.htmlContent, documentationAnchorLink = _ref4.documentationAnchorLink, handlerName = _ref4.handlerName;
    console.warn("Warning: Formik called `" + handlerName + "`, but you forgot to pass an `id` or `name` attribute to your input:\n    " + htmlContent + "\n    Formik cannot determine which value to update. For more info see https://formik.org/docs/api/formik#" + documentationAnchorLink + "\n  ");
}
/**
 * Transform Yup ValidationError to a more usable object
 */ function yupToFormErrors(yupError) {
    var errors = {};
    if (yupError.inner) {
        if (yupError.inner.length === 0) return setIn(errors, yupError.path, yupError.message);
        for(var _iterator = yupError.inner, _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _iterator[Symbol.iterator]();;){
            var _ref5;
            if (_isArray) {
                if (_i >= _iterator.length) break;
                _ref5 = _iterator[_i++];
            } else {
                _i = _iterator.next();
                if (_i.done) break;
                _ref5 = _i.value;
            }
            var err = _ref5;
            if (!getIn(errors, err.path)) errors = setIn(errors, err.path, err.message);
        }
    }
    return errors;
}
/**
 * Validate a yup schema.
 */ function validateYupSchema(values, schema, sync, context) {
    if (sync === void 0) sync = false;
    var normalizedValues = prepareDataForValidation(values);
    return schema[sync ? "validateSync" : "validate"](normalizedValues, {
        abortEarly: false,
        context: context || normalizedValues
    });
}
/**
 * Recursively prepare values.
 */ function prepareDataForValidation(values) {
    var data = Array.isArray(values) ? [] : {};
    for(var k in values)if (Object.prototype.hasOwnProperty.call(values, k)) {
        var key = String(k);
        if (Array.isArray(values[key]) === true) data[key] = values[key].map(function(value) {
            if (Array.isArray(value) === true || (0, $3rtvu.default)(value)) return prepareDataForValidation(value);
            else return value !== "" ? value : undefined;
        });
        else if ((0, $3rtvu.default)(values[key])) data[key] = prepareDataForValidation(values[key]);
        else data[key] = values[key] !== "" ? values[key] : undefined;
    }
    return data;
}
/**
 * deepmerge array merging algorithm
 * https://github.com/KyleAMathews/deepmerge#combine-array
 */ function arrayMerge(target, source, options) {
    var destination = target.slice();
    source.forEach(function merge(e, i) {
        if (typeof destination[i] === "undefined") {
            var cloneRequested = options.clone !== false;
            var shouldClone = cloneRequested && options.isMergeableObject(e);
            destination[i] = shouldClone ? (0, $cCVp3.default)(Array.isArray(e) ? [] : {}, e, options) : e;
        } else if (options.isMergeableObject(e)) destination[i] = (0, $cCVp3.default)(target[i], e, options);
        else if (target.indexOf(e) === -1) destination.push(e);
    });
    return destination;
}
/** Return multi select values based on an array of options */ function getSelectedValues(options) {
    return Array.from(options).filter(function(el) {
        return el.selected;
    }).map(function(el) {
        return el.value;
    });
}
/** Return the next value for a checkbox */ function getValueForCheckbox(currentValue, checked, valueProp) {
    // If the current value was a boolean, return a boolean
    if (typeof currentValue === "boolean") return Boolean(checked);
     // If the currentValue was not a boolean we want to return an array
    var currentArrayOfValues = [];
    var isValueInArray = false;
    var index = -1;
    if (!Array.isArray(currentValue)) {
        // eslint-disable-next-line eqeqeq
        if (!valueProp || valueProp == "true" || valueProp == "false") return Boolean(checked);
    } else {
        // If the current value is already an array, use it
        currentArrayOfValues = currentValue;
        index = currentValue.indexOf(valueProp);
        isValueInArray = index >= 0;
    } // If the checkbox was checked and the value is not already present in the aray we want to add the new value to the array of values
    if (checked && valueProp && !isValueInArray) return currentArrayOfValues.concat(valueProp);
     // If the checkbox was unchecked and the value is not in the array, simply return the already existing array of values
    if (!isValueInArray) return currentArrayOfValues;
     // If the checkbox was unchecked and the value is in the array, remove the value and return the array
    return currentArrayOfValues.slice(0, index).concat(currentArrayOfValues.slice(index + 1));
} // React currently throws a warning when using useLayoutEffect on the server.
// To get around it, we can conditionally useEffect on the server (no-op) and
// useLayoutEffect in the browser.
// @see https://gist.github.com/gaearon/e7d97cdf38a2907924ea12e4ebdf3c85
var useIsomorphicLayoutEffect = typeof window !== "undefined" && typeof window.document !== "undefined" && typeof window.document.createElement !== "undefined" ? (0, $acw62.useLayoutEffect) : (0, $acw62.useEffect);
function useEventCallback(fn) {
    var ref = (0, $acw62.useRef)(fn); // we copy a ref to the callback scoped to the current state/props on each render
    useIsomorphicLayoutEffect(function() {
        ref.current = fn;
    });
    return (0, $acw62.useCallback)(function() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        return ref.current.apply(void 0, args);
    }, []);
}
function useField(propsOrFieldName) {
    var formik = useFormikContext();
    var getFieldProps = formik.getFieldProps, getFieldMeta = formik.getFieldMeta, getFieldHelpers = formik.getFieldHelpers, registerField = formik.registerField, unregisterField = formik.unregisterField;
    var isAnObject = isObject(propsOrFieldName); // Normalize propsOrFieldName to FieldHookConfig<Val>
    var props = isAnObject ? propsOrFieldName : {
        name: propsOrFieldName
    };
    var fieldName = props.name, validateFn = props.validate;
    (0, $acw62.useEffect)(function() {
        if (fieldName) registerField(fieldName, {
            validate: validateFn
        });
        return function() {
            if (fieldName) unregisterField(fieldName);
        };
    }, [
        registerField,
        unregisterField,
        fieldName,
        validateFn
    ]);
    !formik && (0, $9RYKL.default)(false, "useField() / <Field /> must be used underneath a <Formik> component or withFormik() higher order component");
    !fieldName && (0, $9RYKL.default)(false, "Invalid field name. Either pass `useField` a string or an object containing a `name` key.");
    var fieldHelpers = (0, $acw62.useMemo)(function() {
        return getFieldHelpers(fieldName);
    }, [
        getFieldHelpers,
        fieldName
    ]);
    return [
        getFieldProps(props),
        getFieldMeta(fieldName),
        fieldHelpers
    ];
}
function Field(_ref) {
    var validate = _ref.validate, name = _ref.name, render = _ref.render, children = _ref.children, is = _ref.as, component = _ref.component, className = _ref.className, props = _objectWithoutPropertiesLoose(_ref, [
        "validate",
        "name",
        "render",
        "children",
        "as",
        "component",
        "className"
    ]);
    var _useFormikContext = useFormikContext(), formik = _objectWithoutPropertiesLoose(_useFormikContext, [
        "validate",
        "validationSchema"
    ]);
    // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $acw62.useEffect)(function() {
        !!render && (0, $9RYKL.default)(false, '<Field render> has been deprecated and will be removed in future versions of Formik. Please use a child callback function instead. To get rid of this warning, replace <Field name="' + name + '" render={({field, form}) => ...} /> with <Field name="' + name + '">{({field, form, meta}) => ...}</Field>');
        !!(is && children && isFunction(children)) && (0, $9RYKL.default)(false, "You should not use <Field as> and <Field children> as a function in the same <Field> component; <Field as> will be ignored.");
        !!(component && children && isFunction(children)) && (0, $9RYKL.default)(false, "You should not use <Field component> and <Field children> as a function in the same <Field> component; <Field component> will be ignored.");
        !!(render && children && !isEmptyChildren(children)) && (0, $9RYKL.default)(false, "You should not use <Field render> and <Field children> in the same <Field> component; <Field children> will be ignored"); // eslint-disable-next-line
    }, []);
    var registerField = formik.registerField, unregisterField = formik.unregisterField;
    (0, $acw62.useEffect)(function() {
        registerField(name, {
            validate: validate
        });
        return function() {
            unregisterField(name);
        };
    }, [
        registerField,
        unregisterField,
        name,
        validate
    ]);
    var field = formik.getFieldProps(_extends({
        name: name
    }, props));
    var meta = formik.getFieldMeta(name);
    var legacyBag = {
        field: field,
        form: formik
    };
    if (render) return render(_extends({}, legacyBag, {
        meta: meta
    }));
    if (isFunction(children)) return children(_extends({}, legacyBag, {
        meta: meta
    }));
    if (component) {
        // This behavior is backwards compat with earlier Formik 0.9 to 1.x
        if (typeof component === "string") {
            var innerRef = props.innerRef, rest = _objectWithoutPropertiesLoose(props, [
                "innerRef"
            ]);
            return (0, $acw62.createElement)(component, _extends({
                ref: innerRef
            }, field, rest, {
                className: className
            }), children);
        } // We don't pass `meta` for backwards compat
        return (0, $acw62.createElement)(component, _extends({
            field: field,
            form: formik
        }, props, {
            className: className
        }), children);
    } // default to input here so we can check for both `as` and `children` above
    var asElement = is || "input";
    if (typeof asElement === "string") {
        var _innerRef = props.innerRef, _rest = _objectWithoutPropertiesLoose(props, [
            "innerRef"
        ]);
        return (0, $acw62.createElement)(asElement, _extends({
            ref: _innerRef
        }, field, _rest, {
            className: className
        }), children);
    }
    return (0, $acw62.createElement)(asElement, _extends({}, field, props, {
        className: className
    }), children);
}
var Form = /*#__PURE__*/ (0, $acw62.forwardRef)(function(props, ref) {
    // iOS needs an "action" attribute for nice input: https://stackoverflow.com/a/39485162/406725
    // We default the action to "#" in case the preventDefault fails (just updates the URL hash)
    var action = props.action, rest = _objectWithoutPropertiesLoose(props, [
        "action"
    ]);
    var _action = action != null ? action : "#";
    var _useFormikContext = useFormikContext(), handleReset = _useFormikContext.handleReset, handleSubmit = _useFormikContext.handleSubmit;
    return (0, $acw62.createElement)("form", _extends({
        onSubmit: handleSubmit,
        ref: ref,
        onReset: handleReset,
        action: _action
    }, rest));
});
Form.displayName = "Form";
/**
 * A public higher-order component to access the imperative API
 */ function withFormik(_ref) {
    var _ref$mapPropsToValues = _ref.mapPropsToValues, mapPropsToValues = _ref$mapPropsToValues === void 0 ? function(vanillaProps) {
        var val = {};
        for(var k in vanillaProps)if (vanillaProps.hasOwnProperty(k) && typeof vanillaProps[k] !== "function") // @todo TypeScript fix
        val[k] = vanillaProps[k];
        return val;
    } : _ref$mapPropsToValues, config = _objectWithoutPropertiesLoose(_ref, [
        "mapPropsToValues"
    ]);
    return function createFormik(Component$1) {
        var componentDisplayName = Component$1.displayName || Component$1.name || Component$1.constructor && Component$1.constructor.name || "Component";
        /**
     * We need to use closures here for to provide the wrapped component's props to
     * the respective withFormik config methods.
     */ var C = /*#__PURE__*/ function(_React$Component) {
            _inheritsLoose(C, _React$Component);
            function C() {
                var _this;
                for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
                _this = _React$Component.call.apply(_React$Component, [
                    this
                ].concat(args)) || this;
                _this.validate = function(values) {
                    return config.validate(values, _this.props);
                };
                _this.validationSchema = function() {
                    return isFunction(config.validationSchema) ? config.validationSchema(_this.props) : config.validationSchema;
                };
                _this.handleSubmit = function(values, actions) {
                    return config.handleSubmit(values, _extends({}, actions, {
                        props: _this.props
                    }));
                };
                _this.renderFormComponent = function(formikProps) {
                    return (0, $acw62.createElement)(Component$1, _extends({}, _this.props, formikProps));
                };
                return _this;
            }
            var _proto = C.prototype;
            _proto.render = function render() {
                var _this$props = this.props, props = _objectWithoutPropertiesLoose(_this$props, [
                    "children"
                ]);
                return (0, $acw62.createElement)(Formik, _extends({}, props, config, {
                    validate: config.validate && this.validate,
                    validationSchema: config.validationSchema && this.validationSchema,
                    initialValues: mapPropsToValues(this.props),
                    initialStatus: config.mapPropsToStatus && config.mapPropsToStatus(this.props),
                    initialErrors: config.mapPropsToErrors && config.mapPropsToErrors(this.props),
                    initialTouched: config.mapPropsToTouched && config.mapPropsToTouched(this.props),
                    onSubmit: this.handleSubmit,
                    children: this.renderFormComponent
                }));
            };
            return C;
        }((0, $acw62.Component));
        C.displayName = "WithFormik(" + componentDisplayName + ")";
        return (0, (/*@__PURE__*/$parcel$interopDefault($9ORqK)))(C, Component$1 // cast type to ComponentClass (even if SFC)
        );
    };
}
/**
 * Connect any component to Formik context, and inject as a prop called `formik`;
 * @param Comp React Component
 */ function connect(Comp) {
    var C = function C(props) {
        return (0, $acw62.createElement)(FormikConsumer, null, function(formik) {
            !!!formik && (0, $9RYKL.default)(false, "Formik context is undefined, please verify you are rendering <Form>, <Field>, <FastField>, <FieldArray>, or your custom context-using component as a child of a <Formik> component. Component name: " + Comp.name);
            return (0, $acw62.createElement)(Comp, _extends({}, props, {
                formik: formik
            }));
        });
    };
    var componentDisplayName = Comp.displayName || Comp.name || Comp.constructor && Comp.constructor.name || "Component"; // Assign Comp to C.WrappedComponent so we can access the inner component in tests
    // For example, <Field.WrappedComponent /> gets us <FieldInner/>
    C.WrappedComponent = Comp;
    C.displayName = "FormikConnect(" + componentDisplayName + ")";
    return (0, (/*@__PURE__*/$parcel$interopDefault($9ORqK)))(C, Comp // cast type to ComponentClass (even if SFC)
    );
}
/**
 * Some array helpers!
 */ var move = function move(array, from, to) {
    var copy = copyArrayLike(array);
    var value = copy[from];
    copy.splice(from, 1);
    copy.splice(to, 0, value);
    return copy;
};
var swap = function swap(arrayLike, indexA, indexB) {
    var copy = copyArrayLike(arrayLike);
    var a = copy[indexA];
    copy[indexA] = copy[indexB];
    copy[indexB] = a;
    return copy;
};
var insert = function insert(arrayLike, index, value) {
    var copy = copyArrayLike(arrayLike);
    copy.splice(index, 0, value);
    return copy;
};
var replace = function replace(arrayLike, index, value) {
    var copy = copyArrayLike(arrayLike);
    copy[index] = value;
    return copy;
};
var copyArrayLike = function copyArrayLike(arrayLike) {
    if (!arrayLike) return [];
    else if (Array.isArray(arrayLike)) return [].concat(arrayLike);
    else {
        var maxIndex = Object.keys(arrayLike).map(function(key) {
            return parseInt(key);
        }).reduce(function(max, el) {
            return el > max ? el : max;
        }, 0);
        return Array.from(_extends({}, arrayLike, {
            length: maxIndex + 1
        }));
    }
};
var createAlterationHandler = function createAlterationHandler(alteration, defaultFunction) {
    var fn = typeof alteration === "function" ? alteration : defaultFunction;
    return function(data) {
        if (Array.isArray(data) || isObject(data)) {
            var clone = copyArrayLike(data);
            return fn(clone);
        } // This can be assumed to be a primitive, which
        // is a case for top level validation errors
        return data;
    };
};
var FieldArrayInner = /*#__PURE__*/ function(_React$Component) {
    _inheritsLoose(FieldArrayInner, _React$Component);
    function FieldArrayInner(props) {
        var _this;
        _this = _React$Component.call(this, props) || this; // We need TypeScript generics on these, so we'll bind them in the constructor
        // @todo Fix TS 3.2.1
        _this.updateArrayField = function(fn, alterTouched, alterErrors) {
            var _this$props = _this.props, name = _this$props.name, setFormikState = _this$props.formik.setFormikState;
            setFormikState(function(prevState) {
                var updateErrors = createAlterationHandler(alterErrors, fn);
                var updateTouched = createAlterationHandler(alterTouched, fn); // values fn should be executed before updateErrors and updateTouched,
                // otherwise it causes an error with unshift.
                var values = setIn(prevState.values, name, fn(getIn(prevState.values, name)));
                var fieldError = alterErrors ? updateErrors(getIn(prevState.errors, name)) : undefined;
                var fieldTouched = alterTouched ? updateTouched(getIn(prevState.touched, name)) : undefined;
                if (isEmptyArray(fieldError)) fieldError = undefined;
                if (isEmptyArray(fieldTouched)) fieldTouched = undefined;
                return _extends({}, prevState, {
                    values: values,
                    errors: alterErrors ? setIn(prevState.errors, name, fieldError) : prevState.errors,
                    touched: alterTouched ? setIn(prevState.touched, name, fieldTouched) : prevState.touched
                });
            });
        };
        _this.push = function(value) {
            return _this.updateArrayField(function(arrayLike) {
                return [].concat(copyArrayLike(arrayLike), [
                    (0, $chB0Q.default)(value)
                ]);
            }, false, false);
        };
        _this.handlePush = function(value) {
            return function() {
                return _this.push(value);
            };
        };
        _this.swap = function(indexA, indexB) {
            return _this.updateArrayField(function(array) {
                return swap(array, indexA, indexB);
            }, true, true);
        };
        _this.handleSwap = function(indexA, indexB) {
            return function() {
                return _this.swap(indexA, indexB);
            };
        };
        _this.move = function(from, to) {
            return _this.updateArrayField(function(array) {
                return move(array, from, to);
            }, true, true);
        };
        _this.handleMove = function(from, to) {
            return function() {
                return _this.move(from, to);
            };
        };
        _this.insert = function(index, value) {
            return _this.updateArrayField(function(array) {
                return insert(array, index, value);
            }, function(array) {
                return insert(array, index, null);
            }, function(array) {
                return insert(array, index, null);
            });
        };
        _this.handleInsert = function(index, value) {
            return function() {
                return _this.insert(index, value);
            };
        };
        _this.replace = function(index, value) {
            return _this.updateArrayField(function(array) {
                return replace(array, index, value);
            }, false, false);
        };
        _this.handleReplace = function(index, value) {
            return function() {
                return _this.replace(index, value);
            };
        };
        _this.unshift = function(value) {
            var length = -1;
            _this.updateArrayField(function(array) {
                var arr = array ? [
                    value
                ].concat(array) : [
                    value
                ];
                length = arr.length;
                return arr;
            }, function(array) {
                return array ? [
                    null
                ].concat(array) : [
                    null
                ];
            }, function(array) {
                return array ? [
                    null
                ].concat(array) : [
                    null
                ];
            });
            return length;
        };
        _this.handleUnshift = function(value) {
            return function() {
                return _this.unshift(value);
            };
        };
        _this.handleRemove = function(index) {
            return function() {
                return _this.remove(index);
            };
        };
        _this.handlePop = function() {
            return function() {
                return _this.pop();
            };
        };
        _this.remove = _this.remove.bind(_assertThisInitialized(_this));
        _this.pop = _this.pop.bind(_assertThisInitialized(_this));
        return _this;
    }
    var _proto = FieldArrayInner.prototype;
    _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
        if (this.props.validateOnChange && this.props.formik.validateOnChange && !(0, (/*@__PURE__*/$parcel$interopDefault($ai2Pb)))(getIn(prevProps.formik.values, prevProps.name), getIn(this.props.formik.values, this.props.name))) this.props.formik.validateForm(this.props.formik.values);
    };
    _proto.remove = function remove(index) {
        // We need to make sure we also remove relevant pieces of `touched` and `errors`
        var result;
        this.updateArrayField(function(array) {
            var copy = array ? copyArrayLike(array) : [];
            if (!result) result = copy[index];
            if (isFunction(copy.splice)) copy.splice(index, 1);
             // if the array only includes undefined values we have to return an empty array
            return isFunction(copy.every) ? copy.every(function(v) {
                return v === undefined;
            }) ? [] : copy : copy;
        }, true, true);
        return result;
    };
    _proto.pop = function pop() {
        // Remove relevant pieces of `touched` and `errors` too!
        var result;
        this.updateArrayField(function(array) {
            var tmp = array.slice();
            if (!result) result = tmp && tmp.pop && tmp.pop();
            return tmp;
        }, true, true);
        return result;
    };
    _proto.render = function render() {
        var arrayHelpers = {
            push: this.push,
            pop: this.pop,
            swap: this.swap,
            move: this.move,
            insert: this.insert,
            replace: this.replace,
            unshift: this.unshift,
            remove: this.remove,
            handlePush: this.handlePush,
            handlePop: this.handlePop,
            handleSwap: this.handleSwap,
            handleMove: this.handleMove,
            handleInsert: this.handleInsert,
            handleReplace: this.handleReplace,
            handleUnshift: this.handleUnshift,
            handleRemove: this.handleRemove
        };
        var _this$props2 = this.props, component = _this$props2.component, render = _this$props2.render, children = _this$props2.children, name = _this$props2.name, _this$props2$formik = _this$props2.formik, restOfFormik = _objectWithoutPropertiesLoose(_this$props2$formik, [
            "validate",
            "validationSchema"
        ]);
        var props = _extends({}, arrayHelpers, {
            form: restOfFormik,
            name: name
        });
        return component ? (0, $acw62.createElement)(component, props) : render ? render(props) : children // children come last, always called
         ? typeof children === "function" ? children(props) : !isEmptyChildren(children) ? (0, $acw62.Children).only(children) : null : null;
    };
    return FieldArrayInner;
}((0, $acw62.Component));
FieldArrayInner.defaultProps = {
    validateOnChange: true
};
var FieldArray = /*#__PURE__*/ connect(FieldArrayInner);
var ErrorMessageImpl = /*#__PURE__*/ function(_React$Component) {
    _inheritsLoose(ErrorMessageImpl, _React$Component);
    function ErrorMessageImpl() {
        return _React$Component.apply(this, arguments) || this;
    }
    var _proto = ErrorMessageImpl.prototype;
    _proto.shouldComponentUpdate = function shouldComponentUpdate(props) {
        if (getIn(this.props.formik.errors, this.props.name) !== getIn(props.formik.errors, this.props.name) || getIn(this.props.formik.touched, this.props.name) !== getIn(props.formik.touched, this.props.name) || Object.keys(this.props).length !== Object.keys(props).length) return true;
        else return false;
    };
    _proto.render = function render() {
        var _this$props = this.props, component = _this$props.component, formik = _this$props.formik, render = _this$props.render, children = _this$props.children, name = _this$props.name, rest = _objectWithoutPropertiesLoose(_this$props, [
            "component",
            "formik",
            "render",
            "children",
            "name"
        ]);
        var touch = getIn(formik.touched, name);
        var error = getIn(formik.errors, name);
        return !!touch && !!error ? render ? isFunction(render) ? render(error) : null : children ? isFunction(children) ? children(error) : null : component ? (0, $acw62.createElement)(component, rest, error) : error : null;
    };
    return ErrorMessageImpl;
}((0, $acw62.Component));
var ErrorMessage = /*#__PURE__*/ connect(ErrorMessageImpl);
/**
 * Custom Field component for quickly hooking into Formik
 * context and wiring up forms.
 */ var FastFieldInner = /*#__PURE__*/ function(_React$Component) {
    _inheritsLoose(FastFieldInner, _React$Component);
    function FastFieldInner(props) {
        var _this;
        _this = _React$Component.call(this, props) || this;
        var render = props.render, children = props.children, component = props.component, is = props.as, name = props.name;
        !!render && (0, $9RYKL.default)(false, "<FastField render> has been deprecated. Please use a child callback function instead: <FastField name={" + name + "}>{props => ...}</FastField> instead.");
        !!(component && render) && (0, $9RYKL.default)(false, "You should not use <FastField component> and <FastField render> in the same <FastField> component; <FastField component> will be ignored");
        !!(is && children && isFunction(children)) && (0, $9RYKL.default)(false, "You should not use <FastField as> and <FastField children> as a function in the same <FastField> component; <FastField as> will be ignored.");
        !!(component && children && isFunction(children)) && (0, $9RYKL.default)(false, "You should not use <FastField component> and <FastField children> as a function in the same <FastField> component; <FastField component> will be ignored.");
        !!(render && children && !isEmptyChildren(children)) && (0, $9RYKL.default)(false, "You should not use <FastField render> and <FastField children> in the same <FastField> component; <FastField children> will be ignored");
        return _this;
    }
    var _proto = FastFieldInner.prototype;
    _proto.shouldComponentUpdate = function shouldComponentUpdate(props) {
        if (this.props.shouldUpdate) return this.props.shouldUpdate(props, this.props);
        else if (props.name !== this.props.name || getIn(props.formik.values, this.props.name) !== getIn(this.props.formik.values, this.props.name) || getIn(props.formik.errors, this.props.name) !== getIn(this.props.formik.errors, this.props.name) || getIn(props.formik.touched, this.props.name) !== getIn(this.props.formik.touched, this.props.name) || Object.keys(this.props).length !== Object.keys(props).length || props.formik.isSubmitting !== this.props.formik.isSubmitting) return true;
        else return false;
    };
    _proto.componentDidMount = function componentDidMount() {
        // Register the Field with the parent Formik. Parent will cycle through
        // registered Field's validate fns right prior to submit
        this.props.formik.registerField(this.props.name, {
            validate: this.props.validate
        });
    };
    _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
        if (this.props.name !== prevProps.name) {
            this.props.formik.unregisterField(prevProps.name);
            this.props.formik.registerField(this.props.name, {
                validate: this.props.validate
            });
        }
        if (this.props.validate !== prevProps.validate) this.props.formik.registerField(this.props.name, {
            validate: this.props.validate
        });
    };
    _proto.componentWillUnmount = function componentWillUnmount() {
        this.props.formik.unregisterField(this.props.name);
    };
    _proto.render = function render() {
        var _this$props = this.props, name = _this$props.name, render = _this$props.render, is = _this$props.as, children = _this$props.children, component = _this$props.component, formik = _this$props.formik, props = _objectWithoutPropertiesLoose(_this$props, [
            "validate",
            "name",
            "render",
            "as",
            "children",
            "component",
            "shouldUpdate",
            "formik"
        ]);
        var restOfFormik = _objectWithoutPropertiesLoose(formik, [
            "validate",
            "validationSchema"
        ]);
        var field = formik.getFieldProps(_extends({
            name: name
        }, props));
        var meta = {
            value: getIn(formik.values, name),
            error: getIn(formik.errors, name),
            touched: !!getIn(formik.touched, name),
            initialValue: getIn(formik.initialValues, name),
            initialTouched: !!getIn(formik.initialTouched, name),
            initialError: getIn(formik.initialErrors, name)
        };
        var bag = {
            field: field,
            meta: meta,
            form: restOfFormik
        };
        if (render) return render(bag);
        if (isFunction(children)) return children(bag);
        if (component) {
            // This behavior is backwards compat with earlier Formik 0.9 to 1.x
            if (typeof component === "string") {
                var innerRef = props.innerRef, rest = _objectWithoutPropertiesLoose(props, [
                    "innerRef"
                ]);
                return (0, $acw62.createElement)(component, _extends({
                    ref: innerRef
                }, field, rest), children);
            } // We don't pass `meta` for backwards compat
            return (0, $acw62.createElement)(component, _extends({
                field: field,
                form: formik
            }, props), children);
        } // default to input here so we can check for both `as` and `children` above
        var asElement = is || "input";
        if (typeof asElement === "string") {
            var _innerRef = props.innerRef, _rest = _objectWithoutPropertiesLoose(props, [
                "innerRef"
            ]);
            return (0, $acw62.createElement)(asElement, _extends({
                ref: _innerRef
            }, field, _rest), children);
        }
        return (0, $acw62.createElement)(asElement, _extends({}, field, props), children);
    };
    return FastFieldInner;
}((0, $acw62.Component));
var FastField = /*#__PURE__*/ connect(FastFieldInner);

});
parcelRegister("cCVp3", function(module, exports) {

$parcel$export(module.exports, "default", () => $93158fb633685272$export$2e2bcd8739ae039);
var $93158fb633685272$var$isMergeableObject = function isMergeableObject(value) {
    return $93158fb633685272$var$isNonNullObject(value) && !$93158fb633685272$var$isSpecial(value);
};
function $93158fb633685272$var$isNonNullObject(value) {
    return !!value && typeof value === "object";
}
function $93158fb633685272$var$isSpecial(value) {
    var stringValue = Object.prototype.toString.call(value);
    return stringValue === "[object RegExp]" || stringValue === "[object Date]" || $93158fb633685272$var$isReactElement(value);
}
// see https://github.com/facebook/react/blob/b5ac963fb791d1298e7f396236383bc955f916c1/src/isomorphic/classic/element/ReactElement.js#L21-L25
var $93158fb633685272$var$canUseSymbol = typeof Symbol === "function" && Symbol.for;
var $93158fb633685272$var$REACT_ELEMENT_TYPE = $93158fb633685272$var$canUseSymbol ? Symbol.for("react.element") : 0xeac7;
function $93158fb633685272$var$isReactElement(value) {
    return value.$$typeof === $93158fb633685272$var$REACT_ELEMENT_TYPE;
}
function $93158fb633685272$var$emptyTarget(val) {
    return Array.isArray(val) ? [] : {};
}
function $93158fb633685272$var$cloneUnlessOtherwiseSpecified(value, options) {
    return options.clone !== false && options.isMergeableObject(value) ? $93158fb633685272$var$deepmerge($93158fb633685272$var$emptyTarget(value), value, options) : value;
}
function $93158fb633685272$var$defaultArrayMerge(target, source, options) {
    return target.concat(source).map(function(element) {
        return $93158fb633685272$var$cloneUnlessOtherwiseSpecified(element, options);
    });
}
function $93158fb633685272$var$mergeObject(target, source, options) {
    var destination = {};
    if (options.isMergeableObject(target)) Object.keys(target).forEach(function(key) {
        destination[key] = $93158fb633685272$var$cloneUnlessOtherwiseSpecified(target[key], options);
    });
    Object.keys(source).forEach(function(key) {
        if (!options.isMergeableObject(source[key]) || !target[key]) destination[key] = $93158fb633685272$var$cloneUnlessOtherwiseSpecified(source[key], options);
        else destination[key] = $93158fb633685272$var$deepmerge(target[key], source[key], options);
    });
    return destination;
}
function $93158fb633685272$var$deepmerge(target, source, options) {
    options = options || {};
    options.arrayMerge = options.arrayMerge || $93158fb633685272$var$defaultArrayMerge;
    options.isMergeableObject = options.isMergeableObject || $93158fb633685272$var$isMergeableObject;
    var sourceIsArray = Array.isArray(source);
    var targetIsArray = Array.isArray(target);
    var sourceAndTargetTypesMatch = sourceIsArray === targetIsArray;
    if (!sourceAndTargetTypesMatch) return $93158fb633685272$var$cloneUnlessOtherwiseSpecified(source, options);
    else if (sourceIsArray) return options.arrayMerge(target, source, options);
    else return $93158fb633685272$var$mergeObject(target, source, options);
}
$93158fb633685272$var$deepmerge.all = function deepmergeAll(array, options) {
    if (!Array.isArray(array)) throw new Error("first argument should be an array");
    return array.reduce(function(prev, next) {
        return $93158fb633685272$var$deepmerge(prev, next, options);
    }, {});
};
var $93158fb633685272$var$deepmerge_1 = $93158fb633685272$var$deepmerge;
var $93158fb633685272$export$2e2bcd8739ae039 = $93158fb633685272$var$deepmerge_1;

});

parcelRegister("3rtvu", function(module, exports) {

$parcel$export(module.exports, "default", () => $281ac82f5f5844b1$export$2e2bcd8739ae039);

var $hArsG = parcelRequire("hArsG");

var $bzIQZ = parcelRequire("bzIQZ");

var $f2iog = parcelRequire("f2iog");
/** `Object#toString` result references. */ var $281ac82f5f5844b1$var$objectTag = "[object Object]";
/** Used for built-in method references. */ var $281ac82f5f5844b1$var$funcProto = Function.prototype, $281ac82f5f5844b1$var$objectProto = Object.prototype;
/** Used to resolve the decompiled source of functions. */ var $281ac82f5f5844b1$var$funcToString = $281ac82f5f5844b1$var$funcProto.toString;
/** Used to check objects for own properties. */ var $281ac82f5f5844b1$var$hasOwnProperty = $281ac82f5f5844b1$var$objectProto.hasOwnProperty;
/** Used to infer the `Object` constructor. */ var $281ac82f5f5844b1$var$objectCtorString = $281ac82f5f5844b1$var$funcToString.call(Object);
/**
 * Checks if `value` is a plain object, that is, an object created by the
 * `Object` constructor or one with a `[[Prototype]]` of `null`.
 *
 * @static
 * @memberOf _
 * @since 0.8.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 * }
 *
 * _.isPlainObject(new Foo);
 * // => false
 *
 * _.isPlainObject([1, 2, 3]);
 * // => false
 *
 * _.isPlainObject({ 'x': 0, 'y': 0 });
 * // => true
 *
 * _.isPlainObject(Object.create(null));
 * // => true
 */ function $281ac82f5f5844b1$var$isPlainObject(value) {
    if (!(0, $f2iog.default)(value) || (0, $hArsG.default)(value) != $281ac82f5f5844b1$var$objectTag) return false;
    var proto = (0, $bzIQZ.default)(value);
    if (proto === null) return true;
    var Ctor = $281ac82f5f5844b1$var$hasOwnProperty.call(proto, "constructor") && proto.constructor;
    return typeof Ctor == "function" && Ctor instanceof Ctor && $281ac82f5f5844b1$var$funcToString.call(Ctor) == $281ac82f5f5844b1$var$objectCtorString;
}
var $281ac82f5f5844b1$export$2e2bcd8739ae039 = $281ac82f5f5844b1$var$isPlainObject;

});
parcelRegister("hArsG", function(module, exports) {

$parcel$export(module.exports, "default", () => $ccdb19c7f0a62300$export$2e2bcd8739ae039);

var $kRxPv = parcelRequire("kRxPv");

var $7IZ3R = parcelRequire("7IZ3R");

var $cIkDx = parcelRequire("cIkDx");
/** `Object#toString` result references. */ var $ccdb19c7f0a62300$var$nullTag = "[object Null]", $ccdb19c7f0a62300$var$undefinedTag = "[object Undefined]";
/** Built-in value references. */ var $ccdb19c7f0a62300$var$symToStringTag = (0, $kRxPv.default) ? (0, $kRxPv.default).toStringTag : undefined;
/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */ function $ccdb19c7f0a62300$var$baseGetTag(value) {
    if (value == null) return value === undefined ? $ccdb19c7f0a62300$var$undefinedTag : $ccdb19c7f0a62300$var$nullTag;
    return $ccdb19c7f0a62300$var$symToStringTag && $ccdb19c7f0a62300$var$symToStringTag in Object(value) ? (0, $7IZ3R.default)(value) : (0, $cIkDx.default)(value);
}
var $ccdb19c7f0a62300$export$2e2bcd8739ae039 = $ccdb19c7f0a62300$var$baseGetTag;

});
parcelRegister("kRxPv", function(module, exports) {

$parcel$export(module.exports, "default", () => $f302ffc9a48734c4$export$2e2bcd8739ae039);

var $2mpFt = parcelRequire("2mpFt");
/** Built-in value references. */ var $f302ffc9a48734c4$var$Symbol = (0, $2mpFt.default).Symbol;
var $f302ffc9a48734c4$export$2e2bcd8739ae039 = $f302ffc9a48734c4$var$Symbol;

});
parcelRegister("2mpFt", function(module, exports) {

$parcel$export(module.exports, "default", () => $1b818bf49f333098$export$2e2bcd8739ae039);

var $4kWvg = parcelRequire("4kWvg");
/** Detect free variable `self`. */ var $1b818bf49f333098$var$freeSelf = typeof self == "object" && self && self.Object === Object && self;
/** Used as a reference to the global object. */ var $1b818bf49f333098$var$root = (0, $4kWvg.default) || $1b818bf49f333098$var$freeSelf || Function("return this")();
var $1b818bf49f333098$export$2e2bcd8739ae039 = $1b818bf49f333098$var$root;

});
parcelRegister("4kWvg", function(module, exports) {

$parcel$export(module.exports, "default", () => $32866938ab70cc57$export$2e2bcd8739ae039);
/** Detect free variable `global` from Node.js. */ var $32866938ab70cc57$var$freeGlobal = typeof $parcel$global == "object" && $parcel$global && $parcel$global.Object === Object && $parcel$global;
var $32866938ab70cc57$export$2e2bcd8739ae039 = $32866938ab70cc57$var$freeGlobal;

});



parcelRegister("7IZ3R", function(module, exports) {

$parcel$export(module.exports, "default", () => $59fc01f5e412f819$export$2e2bcd8739ae039);

var $kRxPv = parcelRequire("kRxPv");
/** Used for built-in method references. */ var $59fc01f5e412f819$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $59fc01f5e412f819$var$hasOwnProperty = $59fc01f5e412f819$var$objectProto.hasOwnProperty;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var $59fc01f5e412f819$var$nativeObjectToString = $59fc01f5e412f819$var$objectProto.toString;
/** Built-in value references. */ var $59fc01f5e412f819$var$symToStringTag = (0, $kRxPv.default) ? (0, $kRxPv.default).toStringTag : undefined;
/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */ function $59fc01f5e412f819$var$getRawTag(value) {
    var isOwn = $59fc01f5e412f819$var$hasOwnProperty.call(value, $59fc01f5e412f819$var$symToStringTag), tag = value[$59fc01f5e412f819$var$symToStringTag];
    try {
        value[$59fc01f5e412f819$var$symToStringTag] = undefined;
        var unmasked = true;
    } catch (e) {}
    var result = $59fc01f5e412f819$var$nativeObjectToString.call(value);
    if (unmasked) {
        if (isOwn) value[$59fc01f5e412f819$var$symToStringTag] = tag;
        else delete value[$59fc01f5e412f819$var$symToStringTag];
    }
    return result;
}
var $59fc01f5e412f819$export$2e2bcd8739ae039 = $59fc01f5e412f819$var$getRawTag;

});

parcelRegister("cIkDx", function(module, exports) {

$parcel$export(module.exports, "default", () => $94199a1861e07064$export$2e2bcd8739ae039);
/** Used for built-in method references. */ var $94199a1861e07064$var$objectProto = Object.prototype;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var $94199a1861e07064$var$nativeObjectToString = $94199a1861e07064$var$objectProto.toString;
/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */ function $94199a1861e07064$var$objectToString(value) {
    return $94199a1861e07064$var$nativeObjectToString.call(value);
}
var $94199a1861e07064$export$2e2bcd8739ae039 = $94199a1861e07064$var$objectToString;

});


parcelRegister("bzIQZ", function(module, exports) {

$parcel$export(module.exports, "default", () => $86d5c19d81d423c4$export$2e2bcd8739ae039);

var $7N1cZ = parcelRequire("7N1cZ");
/** Built-in value references. */ var $86d5c19d81d423c4$var$getPrototype = (0, $7N1cZ.default)(Object.getPrototypeOf, Object);
var $86d5c19d81d423c4$export$2e2bcd8739ae039 = $86d5c19d81d423c4$var$getPrototype;

});
parcelRegister("7N1cZ", function(module, exports) {

$parcel$export(module.exports, "default", () => $5abe0bf7e062106b$export$2e2bcd8739ae039);
/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */ function $5abe0bf7e062106b$var$overArg(func, transform) {
    return function(arg) {
        return func(transform(arg));
    };
}
var $5abe0bf7e062106b$export$2e2bcd8739ae039 = $5abe0bf7e062106b$var$overArg;

});


parcelRegister("f2iog", function(module, exports) {

$parcel$export(module.exports, "default", () => $af254ed7460d123e$export$2e2bcd8739ae039);
/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */ function $af254ed7460d123e$var$isObjectLike(value) {
    return value != null && typeof value == "object";
}
var $af254ed7460d123e$export$2e2bcd8739ae039 = $af254ed7460d123e$var$isObjectLike;

});


parcelRegister("ai2Pb", function(module, exports) {
"use strict";
var $77ddc6be16b1d7de$var$isArray = Array.isArray;
var $77ddc6be16b1d7de$var$keyList = Object.keys;
var $77ddc6be16b1d7de$var$hasProp = Object.prototype.hasOwnProperty;
var $77ddc6be16b1d7de$var$hasElementType = typeof Element !== "undefined";
function $77ddc6be16b1d7de$var$equal(a, b) {
    // fast-deep-equal index.js 2.0.1
    if (a === b) return true;
    if (a && b && typeof a == "object" && typeof b == "object") {
        var arrA = $77ddc6be16b1d7de$var$isArray(a), arrB = $77ddc6be16b1d7de$var$isArray(b), i, length, key;
        if (arrA && arrB) {
            length = a.length;
            if (length != b.length) return false;
            for(i = length; i-- !== 0;)if (!$77ddc6be16b1d7de$var$equal(a[i], b[i])) return false;
            return true;
        }
        if (arrA != arrB) return false;
        var dateA = a instanceof Date, dateB = b instanceof Date;
        if (dateA != dateB) return false;
        if (dateA && dateB) return a.getTime() == b.getTime();
        var regexpA = a instanceof RegExp, regexpB = b instanceof RegExp;
        if (regexpA != regexpB) return false;
        if (regexpA && regexpB) return a.toString() == b.toString();
        var keys = $77ddc6be16b1d7de$var$keyList(a);
        length = keys.length;
        if (length !== $77ddc6be16b1d7de$var$keyList(b).length) return false;
        for(i = length; i-- !== 0;)if (!$77ddc6be16b1d7de$var$hasProp.call(b, keys[i])) return false;
        // end fast-deep-equal
        // start react-fast-compare
        // custom handling for DOM elements
        if ($77ddc6be16b1d7de$var$hasElementType && a instanceof Element && b instanceof Element) return a === b;
        // custom handling for React
        for(i = length; i-- !== 0;){
            key = keys[i];
            if (key === "_owner" && a.$$typeof) continue;
            else {
                // all other properties should be traversed as usual
                if (!$77ddc6be16b1d7de$var$equal(a[key], b[key])) return false;
            }
        }
        // end react-fast-compare
        // fast-deep-equal index.js 2.0.1
        return true;
    }
    return a !== a && b !== b;
}
// end fast-deep-equal
module.exports = function exportedEqual(a, b) {
    try {
        return $77ddc6be16b1d7de$var$equal(a, b);
    } catch (error) {
        if (error.message && error.message.match(/stack|recursion/i) || error.number === -2146828260) {
            // warn on circular references, don't crash
            // browsers give this different errors name and messages:
            // chrome/safari: "RangeError", "Maximum call stack size exceeded"
            // firefox: "InternalError", too much recursion"
            // edge: "Error", "Out of stack space"
            console.warn("Warning: react-fast-compare does not handle circular references.", error.name, error.message);
            return false;
        }
        // some other error. we should definitely know about these
        throw error;
    }
};

});

parcelRegister("9RYKL", function(module, exports) {

$parcel$export(module.exports, "default", () => $72f8309e8b4c5d38$export$2e2bcd8739ae039);
var $72f8309e8b4c5d38$var$isProduction = false;
function $72f8309e8b4c5d38$var$warning(condition, message) {
    if (!$72f8309e8b4c5d38$var$isProduction) {
        if (condition) return;
        var text = "Warning: " + message;
        if (typeof console !== "undefined") console.warn(text);
        try {
            throw Error(text);
        } catch (x) {}
    }
}
var $72f8309e8b4c5d38$export$2e2bcd8739ae039 = $72f8309e8b4c5d38$var$warning;

});

parcelRegister("hNIl0", function(module, exports) {

$parcel$export(module.exports, "default", () => $cf5967d89366f433$export$2e2bcd8739ae039);

var $gbpSA = parcelRequire("gbpSA");
/** Used to compose bitmasks for cloning. */ var $cf5967d89366f433$var$CLONE_SYMBOLS_FLAG = 4;
/**
 * Creates a shallow clone of `value`.
 *
 * **Note:** This method is loosely based on the
 * [structured clone algorithm](https://mdn.io/Structured_clone_algorithm)
 * and supports cloning arrays, array buffers, booleans, date objects, maps,
 * numbers, `Object` objects, regexes, sets, strings, symbols, and typed
 * arrays. The own enumerable properties of `arguments` objects are cloned
 * as plain objects. An empty object is returned for uncloneable values such
 * as error objects, functions, DOM nodes, and WeakMaps.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to clone.
 * @returns {*} Returns the cloned value.
 * @see _.cloneDeep
 * @example
 *
 * var objects = [{ 'a': 1 }, { 'b': 2 }];
 *
 * var shallow = _.clone(objects);
 * console.log(shallow[0] === objects[0]);
 * // => true
 */ function $cf5967d89366f433$var$clone(value) {
    return (0, $gbpSA.default)(value, $cf5967d89366f433$var$CLONE_SYMBOLS_FLAG);
}
var $cf5967d89366f433$export$2e2bcd8739ae039 = $cf5967d89366f433$var$clone;

});
parcelRegister("gbpSA", function(module, exports) {

$parcel$export(module.exports, "default", () => $bc81bf84e8d65dab$export$2e2bcd8739ae039);

var $9WjpT = parcelRequire("9WjpT");

var $iDECW = parcelRequire("iDECW");

var $a6l6i = parcelRequire("a6l6i");

var $7FIi5 = parcelRequire("7FIi5");

var $3vFgL = parcelRequire("3vFgL");

var $gqoYg = parcelRequire("gqoYg");

var $jXStN = parcelRequire("jXStN");

var $8gRDv = parcelRequire("8gRDv");

var $7AKhX = parcelRequire("7AKhX");

var $oK0lo = parcelRequire("oK0lo");

var $7bulh = parcelRequire("7bulh");

var $4wkSQ = parcelRequire("4wkSQ");

var $9HyGp = parcelRequire("9HyGp");

var $iBTyS = parcelRequire("iBTyS");

var $7lgl7 = parcelRequire("7lgl7");

var $hf0C9 = parcelRequire("hf0C9");

var $f3ZL4 = parcelRequire("f3ZL4");

var $5HFwJ = parcelRequire("5HFwJ");

var $iYDsF = parcelRequire("iYDsF");

var $4X3Cn = parcelRequire("4X3Cn");

var $8krEv = parcelRequire("8krEv");

var $ceNjR = parcelRequire("ceNjR");
/** Used to compose bitmasks for cloning. */ var $bc81bf84e8d65dab$var$CLONE_DEEP_FLAG = 1, $bc81bf84e8d65dab$var$CLONE_FLAT_FLAG = 2, $bc81bf84e8d65dab$var$CLONE_SYMBOLS_FLAG = 4;
/** `Object#toString` result references. */ var $bc81bf84e8d65dab$var$argsTag = "[object Arguments]", $bc81bf84e8d65dab$var$arrayTag = "[object Array]", $bc81bf84e8d65dab$var$boolTag = "[object Boolean]", $bc81bf84e8d65dab$var$dateTag = "[object Date]", $bc81bf84e8d65dab$var$errorTag = "[object Error]", $bc81bf84e8d65dab$var$funcTag = "[object Function]", $bc81bf84e8d65dab$var$genTag = "[object GeneratorFunction]", $bc81bf84e8d65dab$var$mapTag = "[object Map]", $bc81bf84e8d65dab$var$numberTag = "[object Number]", $bc81bf84e8d65dab$var$objectTag = "[object Object]", $bc81bf84e8d65dab$var$regexpTag = "[object RegExp]", $bc81bf84e8d65dab$var$setTag = "[object Set]", $bc81bf84e8d65dab$var$stringTag = "[object String]", $bc81bf84e8d65dab$var$symbolTag = "[object Symbol]", $bc81bf84e8d65dab$var$weakMapTag = "[object WeakMap]";
var $bc81bf84e8d65dab$var$arrayBufferTag = "[object ArrayBuffer]", $bc81bf84e8d65dab$var$dataViewTag = "[object DataView]", $bc81bf84e8d65dab$var$float32Tag = "[object Float32Array]", $bc81bf84e8d65dab$var$float64Tag = "[object Float64Array]", $bc81bf84e8d65dab$var$int8Tag = "[object Int8Array]", $bc81bf84e8d65dab$var$int16Tag = "[object Int16Array]", $bc81bf84e8d65dab$var$int32Tag = "[object Int32Array]", $bc81bf84e8d65dab$var$uint8Tag = "[object Uint8Array]", $bc81bf84e8d65dab$var$uint8ClampedTag = "[object Uint8ClampedArray]", $bc81bf84e8d65dab$var$uint16Tag = "[object Uint16Array]", $bc81bf84e8d65dab$var$uint32Tag = "[object Uint32Array]";
/** Used to identify `toStringTag` values supported by `_.clone`. */ var $bc81bf84e8d65dab$var$cloneableTags = {};
$bc81bf84e8d65dab$var$cloneableTags[$bc81bf84e8d65dab$var$argsTag] = $bc81bf84e8d65dab$var$cloneableTags[$bc81bf84e8d65dab$var$arrayTag] = $bc81bf84e8d65dab$var$cloneableTags[$bc81bf84e8d65dab$var$arrayBufferTag] = $bc81bf84e8d65dab$var$cloneableTags[$bc81bf84e8d65dab$var$dataViewTag] = $bc81bf84e8d65dab$var$cloneableTags[$bc81bf84e8d65dab$var$boolTag] = $bc81bf84e8d65dab$var$cloneableTags[$bc81bf84e8d65dab$var$dateTag] = $bc81bf84e8d65dab$var$cloneableTags[$bc81bf84e8d65dab$var$float32Tag] = $bc81bf84e8d65dab$var$cloneableTags[$bc81bf84e8d65dab$var$float64Tag] = $bc81bf84e8d65dab$var$cloneableTags[$bc81bf84e8d65dab$var$int8Tag] = $bc81bf84e8d65dab$var$cloneableTags[$bc81bf84e8d65dab$var$int16Tag] = $bc81bf84e8d65dab$var$cloneableTags[$bc81bf84e8d65dab$var$int32Tag] = $bc81bf84e8d65dab$var$cloneableTags[$bc81bf84e8d65dab$var$mapTag] = $bc81bf84e8d65dab$var$cloneableTags[$bc81bf84e8d65dab$var$numberTag] = $bc81bf84e8d65dab$var$cloneableTags[$bc81bf84e8d65dab$var$objectTag] = $bc81bf84e8d65dab$var$cloneableTags[$bc81bf84e8d65dab$var$regexpTag] = $bc81bf84e8d65dab$var$cloneableTags[$bc81bf84e8d65dab$var$setTag] = $bc81bf84e8d65dab$var$cloneableTags[$bc81bf84e8d65dab$var$stringTag] = $bc81bf84e8d65dab$var$cloneableTags[$bc81bf84e8d65dab$var$symbolTag] = $bc81bf84e8d65dab$var$cloneableTags[$bc81bf84e8d65dab$var$uint8Tag] = $bc81bf84e8d65dab$var$cloneableTags[$bc81bf84e8d65dab$var$uint8ClampedTag] = $bc81bf84e8d65dab$var$cloneableTags[$bc81bf84e8d65dab$var$uint16Tag] = $bc81bf84e8d65dab$var$cloneableTags[$bc81bf84e8d65dab$var$uint32Tag] = true;
$bc81bf84e8d65dab$var$cloneableTags[$bc81bf84e8d65dab$var$errorTag] = $bc81bf84e8d65dab$var$cloneableTags[$bc81bf84e8d65dab$var$funcTag] = $bc81bf84e8d65dab$var$cloneableTags[$bc81bf84e8d65dab$var$weakMapTag] = false;
/**
 * The base implementation of `_.clone` and `_.cloneDeep` which tracks
 * traversed objects.
 *
 * @private
 * @param {*} value The value to clone.
 * @param {boolean} bitmask The bitmask flags.
 *  1 - Deep clone
 *  2 - Flatten inherited properties
 *  4 - Clone symbols
 * @param {Function} [customizer] The function to customize cloning.
 * @param {string} [key] The key of `value`.
 * @param {Object} [object] The parent object of `value`.
 * @param {Object} [stack] Tracks traversed objects and their clone counterparts.
 * @returns {*} Returns the cloned value.
 */ function $bc81bf84e8d65dab$var$baseClone(value, bitmask, customizer, key, object, stack) {
    var result, isDeep = bitmask & $bc81bf84e8d65dab$var$CLONE_DEEP_FLAG, isFlat = bitmask & $bc81bf84e8d65dab$var$CLONE_FLAT_FLAG, isFull = bitmask & $bc81bf84e8d65dab$var$CLONE_SYMBOLS_FLAG;
    if (customizer) result = object ? customizer(value, key, object, stack) : customizer(value);
    if (result !== undefined) return result;
    if (!(0, $iYDsF.default)(value)) return value;
    var isArr = (0, $hf0C9.default)(value);
    if (isArr) {
        result = (0, $9HyGp.default)(value);
        if (!isDeep) return (0, $jXStN.default)(value, result);
    } else {
        var tag = (0, $4wkSQ.default)(value), isFunc = tag == $bc81bf84e8d65dab$var$funcTag || tag == $bc81bf84e8d65dab$var$genTag;
        if ((0, $f3ZL4.default)(value)) return (0, $gqoYg.default)(value, isDeep);
        if (tag == $bc81bf84e8d65dab$var$objectTag || tag == $bc81bf84e8d65dab$var$argsTag || isFunc && !object) {
            result = isFlat || isFunc ? {} : (0, $7lgl7.default)(value);
            if (!isDeep) return isFlat ? (0, $7AKhX.default)(value, (0, $3vFgL.default)(result, value)) : (0, $8gRDv.default)(value, (0, $7FIi5.default)(result, value));
        } else {
            if (!$bc81bf84e8d65dab$var$cloneableTags[tag]) return object ? value : {};
            result = (0, $iBTyS.default)(value, tag, isDeep);
        }
    }
    // Check for circular references and return its corresponding clone.
    stack || (stack = new (0, $9WjpT.default));
    var stacked = stack.get(value);
    if (stacked) return stacked;
    stack.set(value, result);
    if ((0, $4X3Cn.default)(value)) value.forEach(function(subValue) {
        result.add($bc81bf84e8d65dab$var$baseClone(subValue, bitmask, customizer, subValue, value, stack));
    });
    else if ((0, $5HFwJ.default)(value)) value.forEach(function(subValue, key) {
        result.set(key, $bc81bf84e8d65dab$var$baseClone(subValue, bitmask, customizer, key, value, stack));
    });
    var keysFunc = isFull ? isFlat ? (0, $7bulh.default) : (0, $oK0lo.default) : isFlat ? (0, $ceNjR.default) : (0, $8krEv.default);
    var props = isArr ? undefined : keysFunc(value);
    (0, $iDECW.default)(props || value, function(subValue, key) {
        if (props) {
            key = subValue;
            subValue = value[key];
        }
        // Recursively populate clone (susceptible to call stack limits).
        (0, $a6l6i.default)(result, key, $bc81bf84e8d65dab$var$baseClone(subValue, bitmask, customizer, key, value, stack));
    });
    return result;
}
var $bc81bf84e8d65dab$export$2e2bcd8739ae039 = $bc81bf84e8d65dab$var$baseClone;

});
parcelRegister("9WjpT", function(module, exports) {

$parcel$export(module.exports, "default", () => $73c8979051c99f66$export$2e2bcd8739ae039);

var $kVnfZ = parcelRequire("kVnfZ");

var $czhOX = parcelRequire("czhOX");

var $5QEPI = parcelRequire("5QEPI");

var $lwDUG = parcelRequire("lwDUG");

var $b5lTf = parcelRequire("b5lTf");

var $i8OSr = parcelRequire("i8OSr");
/**
 * Creates a stack cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function $73c8979051c99f66$var$Stack(entries) {
    var data = this.__data__ = new (0, $kVnfZ.default)(entries);
    this.size = data.size;
}
// Add methods to `Stack`.
$73c8979051c99f66$var$Stack.prototype.clear = (0, $czhOX.default);
$73c8979051c99f66$var$Stack.prototype["delete"] = (0, $5QEPI.default);
$73c8979051c99f66$var$Stack.prototype.get = (0, $lwDUG.default);
$73c8979051c99f66$var$Stack.prototype.has = (0, $b5lTf.default);
$73c8979051c99f66$var$Stack.prototype.set = (0, $i8OSr.default);
var $73c8979051c99f66$export$2e2bcd8739ae039 = $73c8979051c99f66$var$Stack;

});
parcelRegister("kVnfZ", function(module, exports) {

$parcel$export(module.exports, "default", () => $f3bb2bde4f3d2e10$export$2e2bcd8739ae039);

var $htx5f = parcelRequire("htx5f");

var $dEGYX = parcelRequire("dEGYX");

var $eiOY8 = parcelRequire("eiOY8");

var $5yv8I = parcelRequire("5yv8I");

var $67Adw = parcelRequire("67Adw");
/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function $f3bb2bde4f3d2e10$var$ListCache(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
// Add methods to `ListCache`.
$f3bb2bde4f3d2e10$var$ListCache.prototype.clear = (0, $htx5f.default);
$f3bb2bde4f3d2e10$var$ListCache.prototype["delete"] = (0, $dEGYX.default);
$f3bb2bde4f3d2e10$var$ListCache.prototype.get = (0, $eiOY8.default);
$f3bb2bde4f3d2e10$var$ListCache.prototype.has = (0, $5yv8I.default);
$f3bb2bde4f3d2e10$var$ListCache.prototype.set = (0, $67Adw.default);
var $f3bb2bde4f3d2e10$export$2e2bcd8739ae039 = $f3bb2bde4f3d2e10$var$ListCache;

});
parcelRegister("htx5f", function(module, exports) {

$parcel$export(module.exports, "default", () => $cb8ececfecd0309c$export$2e2bcd8739ae039);
/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */ function $cb8ececfecd0309c$var$listCacheClear() {
    this.__data__ = [];
    this.size = 0;
}
var $cb8ececfecd0309c$export$2e2bcd8739ae039 = $cb8ececfecd0309c$var$listCacheClear;

});

parcelRegister("dEGYX", function(module, exports) {

$parcel$export(module.exports, "default", () => $9f105a2cb198cf75$export$2e2bcd8739ae039);

var $eWSnX = parcelRequire("eWSnX");
/** Used for built-in method references. */ var $9f105a2cb198cf75$var$arrayProto = Array.prototype;
/** Built-in value references. */ var $9f105a2cb198cf75$var$splice = $9f105a2cb198cf75$var$arrayProto.splice;
/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function $9f105a2cb198cf75$var$listCacheDelete(key) {
    var data = this.__data__, index = (0, $eWSnX.default)(data, key);
    if (index < 0) return false;
    var lastIndex = data.length - 1;
    if (index == lastIndex) data.pop();
    else $9f105a2cb198cf75$var$splice.call(data, index, 1);
    --this.size;
    return true;
}
var $9f105a2cb198cf75$export$2e2bcd8739ae039 = $9f105a2cb198cf75$var$listCacheDelete;

});
parcelRegister("eWSnX", function(module, exports) {

$parcel$export(module.exports, "default", () => $ae20ab4a6778d088$export$2e2bcd8739ae039);

var $lvgV1 = parcelRequire("lvgV1");
/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */ function $ae20ab4a6778d088$var$assocIndexOf(array, key) {
    var length = array.length;
    while(length--){
        if ((0, $lvgV1.default)(array[length][0], key)) return length;
    }
    return -1;
}
var $ae20ab4a6778d088$export$2e2bcd8739ae039 = $ae20ab4a6778d088$var$assocIndexOf;

});
parcelRegister("lvgV1", function(module, exports) {

$parcel$export(module.exports, "default", () => $fa799df2e830873c$export$2e2bcd8739ae039);
/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */ function $fa799df2e830873c$var$eq(value, other) {
    return value === other || value !== value && other !== other;
}
var $fa799df2e830873c$export$2e2bcd8739ae039 = $fa799df2e830873c$var$eq;

});



parcelRegister("eiOY8", function(module, exports) {

$parcel$export(module.exports, "default", () => $a69a48810b4d495b$export$2e2bcd8739ae039);

var $eWSnX = parcelRequire("eWSnX");
/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function $a69a48810b4d495b$var$listCacheGet(key) {
    var data = this.__data__, index = (0, $eWSnX.default)(data, key);
    return index < 0 ? undefined : data[index][1];
}
var $a69a48810b4d495b$export$2e2bcd8739ae039 = $a69a48810b4d495b$var$listCacheGet;

});

parcelRegister("5yv8I", function(module, exports) {

$parcel$export(module.exports, "default", () => $40b84863e34edf18$export$2e2bcd8739ae039);

var $eWSnX = parcelRequire("eWSnX");
/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $40b84863e34edf18$var$listCacheHas(key) {
    return (0, $eWSnX.default)(this.__data__, key) > -1;
}
var $40b84863e34edf18$export$2e2bcd8739ae039 = $40b84863e34edf18$var$listCacheHas;

});

parcelRegister("67Adw", function(module, exports) {

$parcel$export(module.exports, "default", () => $474f7d7f66ed40d6$export$2e2bcd8739ae039);

var $eWSnX = parcelRequire("eWSnX");
/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */ function $474f7d7f66ed40d6$var$listCacheSet(key, value) {
    var data = this.__data__, index = (0, $eWSnX.default)(data, key);
    if (index < 0) {
        ++this.size;
        data.push([
            key,
            value
        ]);
    } else data[index][1] = value;
    return this;
}
var $474f7d7f66ed40d6$export$2e2bcd8739ae039 = $474f7d7f66ed40d6$var$listCacheSet;

});


parcelRegister("czhOX", function(module, exports) {

$parcel$export(module.exports, "default", () => $926693c1c5aa1b3b$export$2e2bcd8739ae039);

var $kVnfZ = parcelRequire("kVnfZ");
/**
 * Removes all key-value entries from the stack.
 *
 * @private
 * @name clear
 * @memberOf Stack
 */ function $926693c1c5aa1b3b$var$stackClear() {
    this.__data__ = new (0, $kVnfZ.default);
    this.size = 0;
}
var $926693c1c5aa1b3b$export$2e2bcd8739ae039 = $926693c1c5aa1b3b$var$stackClear;

});

parcelRegister("5QEPI", function(module, exports) {

$parcel$export(module.exports, "default", () => $44217bb0c3913906$export$2e2bcd8739ae039);
/**
 * Removes `key` and its value from the stack.
 *
 * @private
 * @name delete
 * @memberOf Stack
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function $44217bb0c3913906$var$stackDelete(key) {
    var data = this.__data__, result = data["delete"](key);
    this.size = data.size;
    return result;
}
var $44217bb0c3913906$export$2e2bcd8739ae039 = $44217bb0c3913906$var$stackDelete;

});

parcelRegister("lwDUG", function(module, exports) {

$parcel$export(module.exports, "default", () => $fabb8c13d7ec2da0$export$2e2bcd8739ae039);
/**
 * Gets the stack value for `key`.
 *
 * @private
 * @name get
 * @memberOf Stack
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function $fabb8c13d7ec2da0$var$stackGet(key) {
    return this.__data__.get(key);
}
var $fabb8c13d7ec2da0$export$2e2bcd8739ae039 = $fabb8c13d7ec2da0$var$stackGet;

});

parcelRegister("b5lTf", function(module, exports) {

$parcel$export(module.exports, "default", () => $8121243fb2037ab0$export$2e2bcd8739ae039);
/**
 * Checks if a stack value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Stack
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $8121243fb2037ab0$var$stackHas(key) {
    return this.__data__.has(key);
}
var $8121243fb2037ab0$export$2e2bcd8739ae039 = $8121243fb2037ab0$var$stackHas;

});

parcelRegister("i8OSr", function(module, exports) {

$parcel$export(module.exports, "default", () => $d350707940985b27$export$2e2bcd8739ae039);

var $kVnfZ = parcelRequire("kVnfZ");

var $fs3H6 = parcelRequire("fs3H6");

var $7n3PR = parcelRequire("7n3PR");
/** Used as the size to enable large array optimizations. */ var $d350707940985b27$var$LARGE_ARRAY_SIZE = 200;
/**
 * Sets the stack `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Stack
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the stack cache instance.
 */ function $d350707940985b27$var$stackSet(key, value) {
    var data = this.__data__;
    if (data instanceof (0, $kVnfZ.default)) {
        var pairs = data.__data__;
        if (!(0, $fs3H6.default) || pairs.length < $d350707940985b27$var$LARGE_ARRAY_SIZE - 1) {
            pairs.push([
                key,
                value
            ]);
            this.size = ++data.size;
            return this;
        }
        data = this.__data__ = new (0, $7n3PR.default)(pairs);
    }
    data.set(key, value);
    this.size = data.size;
    return this;
}
var $d350707940985b27$export$2e2bcd8739ae039 = $d350707940985b27$var$stackSet;

});
parcelRegister("fs3H6", function(module, exports) {

$parcel$export(module.exports, "default", () => $b3fc56271887eaf3$export$2e2bcd8739ae039);

var $jLT9P = parcelRequire("jLT9P");

var $2mpFt = parcelRequire("2mpFt");
/* Built-in method references that are verified to be native. */ var $b3fc56271887eaf3$var$Map = (0, $jLT9P.default)((0, $2mpFt.default), "Map");
var $b3fc56271887eaf3$export$2e2bcd8739ae039 = $b3fc56271887eaf3$var$Map;

});
parcelRegister("jLT9P", function(module, exports) {

$parcel$export(module.exports, "default", () => $e64d313d457435ee$export$2e2bcd8739ae039);

var $hJ8AQ = parcelRequire("hJ8AQ");

var $b0QTV = parcelRequire("b0QTV");
/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */ function $e64d313d457435ee$var$getNative(object, key) {
    var value = (0, $b0QTV.default)(object, key);
    return (0, $hJ8AQ.default)(value) ? value : undefined;
}
var $e64d313d457435ee$export$2e2bcd8739ae039 = $e64d313d457435ee$var$getNative;

});
parcelRegister("hJ8AQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $ce7d4e19db8c5f74$export$2e2bcd8739ae039);

var $4VY3C = parcelRequire("4VY3C");

var $fMWvx = parcelRequire("fMWvx");

var $iYDsF = parcelRequire("iYDsF");

var $5bfPQ = parcelRequire("5bfPQ");
/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */ var $ce7d4e19db8c5f74$var$reRegExpChar = /[\\^$.*+?()[\]{}|]/g;
/** Used to detect host constructors (Safari). */ var $ce7d4e19db8c5f74$var$reIsHostCtor = /^\[object .+?Constructor\]$/;
/** Used for built-in method references. */ var $ce7d4e19db8c5f74$var$funcProto = Function.prototype, $ce7d4e19db8c5f74$var$objectProto = Object.prototype;
/** Used to resolve the decompiled source of functions. */ var $ce7d4e19db8c5f74$var$funcToString = $ce7d4e19db8c5f74$var$funcProto.toString;
/** Used to check objects for own properties. */ var $ce7d4e19db8c5f74$var$hasOwnProperty = $ce7d4e19db8c5f74$var$objectProto.hasOwnProperty;
/** Used to detect if a method is native. */ var $ce7d4e19db8c5f74$var$reIsNative = RegExp("^" + $ce7d4e19db8c5f74$var$funcToString.call($ce7d4e19db8c5f74$var$hasOwnProperty).replace($ce7d4e19db8c5f74$var$reRegExpChar, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$");
/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */ function $ce7d4e19db8c5f74$var$baseIsNative(value) {
    if (!(0, $iYDsF.default)(value) || (0, $fMWvx.default)(value)) return false;
    var pattern = (0, $4VY3C.default)(value) ? $ce7d4e19db8c5f74$var$reIsNative : $ce7d4e19db8c5f74$var$reIsHostCtor;
    return pattern.test((0, $5bfPQ.default)(value));
}
var $ce7d4e19db8c5f74$export$2e2bcd8739ae039 = $ce7d4e19db8c5f74$var$baseIsNative;

});
parcelRegister("4VY3C", function(module, exports) {

$parcel$export(module.exports, "default", () => $397b12740d7995ef$export$2e2bcd8739ae039);

var $hArsG = parcelRequire("hArsG");

var $iYDsF = parcelRequire("iYDsF");
/** `Object#toString` result references. */ var $397b12740d7995ef$var$asyncTag = "[object AsyncFunction]", $397b12740d7995ef$var$funcTag = "[object Function]", $397b12740d7995ef$var$genTag = "[object GeneratorFunction]", $397b12740d7995ef$var$proxyTag = "[object Proxy]";
/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */ function $397b12740d7995ef$var$isFunction(value) {
    if (!(0, $iYDsF.default)(value)) return false;
    // The use of `Object#toString` avoids issues with the `typeof` operator
    // in Safari 9 which returns 'object' for typed arrays and other constructors.
    var tag = (0, $hArsG.default)(value);
    return tag == $397b12740d7995ef$var$funcTag || tag == $397b12740d7995ef$var$genTag || tag == $397b12740d7995ef$var$asyncTag || tag == $397b12740d7995ef$var$proxyTag;
}
var $397b12740d7995ef$export$2e2bcd8739ae039 = $397b12740d7995ef$var$isFunction;

});
parcelRegister("iYDsF", function(module, exports) {

$parcel$export(module.exports, "default", () => $dd0c70c8150db920$export$2e2bcd8739ae039);
/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */ function $dd0c70c8150db920$var$isObject(value) {
    var type = typeof value;
    return value != null && (type == "object" || type == "function");
}
var $dd0c70c8150db920$export$2e2bcd8739ae039 = $dd0c70c8150db920$var$isObject;

});


parcelRegister("fMWvx", function(module, exports) {

$parcel$export(module.exports, "default", () => $b7e8b9239f02cfcb$export$2e2bcd8739ae039);

var $gsGrt = parcelRequire("gsGrt");
/** Used to detect methods masquerading as native. */ var $b7e8b9239f02cfcb$var$maskSrcKey = function() {
    var uid = /[^.]+$/.exec((0, $gsGrt.default) && (0, $gsGrt.default).keys && (0, $gsGrt.default).keys.IE_PROTO || "");
    return uid ? "Symbol(src)_1." + uid : "";
}();
/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */ function $b7e8b9239f02cfcb$var$isMasked(func) {
    return !!$b7e8b9239f02cfcb$var$maskSrcKey && $b7e8b9239f02cfcb$var$maskSrcKey in func;
}
var $b7e8b9239f02cfcb$export$2e2bcd8739ae039 = $b7e8b9239f02cfcb$var$isMasked;

});
parcelRegister("gsGrt", function(module, exports) {

$parcel$export(module.exports, "default", () => $bfc02efb2c4f5b86$export$2e2bcd8739ae039);

var $2mpFt = parcelRequire("2mpFt");
/** Used to detect overreaching core-js shims. */ var $bfc02efb2c4f5b86$var$coreJsData = (0, $2mpFt.default)["__core-js_shared__"];
var $bfc02efb2c4f5b86$export$2e2bcd8739ae039 = $bfc02efb2c4f5b86$var$coreJsData;

});


parcelRegister("5bfPQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $3c5a435f91273845$export$2e2bcd8739ae039);
/** Used for built-in method references. */ var $3c5a435f91273845$var$funcProto = Function.prototype;
/** Used to resolve the decompiled source of functions. */ var $3c5a435f91273845$var$funcToString = $3c5a435f91273845$var$funcProto.toString;
/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to convert.
 * @returns {string} Returns the source code.
 */ function $3c5a435f91273845$var$toSource(func) {
    if (func != null) {
        try {
            return $3c5a435f91273845$var$funcToString.call(func);
        } catch (e) {}
        try {
            return func + "";
        } catch (e) {}
    }
    return "";
}
var $3c5a435f91273845$export$2e2bcd8739ae039 = $3c5a435f91273845$var$toSource;

});


parcelRegister("b0QTV", function(module, exports) {

$parcel$export(module.exports, "default", () => $8048bad1174acf1d$export$2e2bcd8739ae039);
/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */ function $8048bad1174acf1d$var$getValue(object, key) {
    return object == null ? undefined : object[key];
}
var $8048bad1174acf1d$export$2e2bcd8739ae039 = $8048bad1174acf1d$var$getValue;

});



parcelRegister("7n3PR", function(module, exports) {

$parcel$export(module.exports, "default", () => $55dda8022ba8f51a$export$2e2bcd8739ae039);

var $bAMUC = parcelRequire("bAMUC");

var $56mPM = parcelRequire("56mPM");

var $428kg = parcelRequire("428kg");

var $jYsb1 = parcelRequire("jYsb1");

var $5XP4x = parcelRequire("5XP4x");
/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function $55dda8022ba8f51a$var$MapCache(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
// Add methods to `MapCache`.
$55dda8022ba8f51a$var$MapCache.prototype.clear = (0, $bAMUC.default);
$55dda8022ba8f51a$var$MapCache.prototype["delete"] = (0, $56mPM.default);
$55dda8022ba8f51a$var$MapCache.prototype.get = (0, $428kg.default);
$55dda8022ba8f51a$var$MapCache.prototype.has = (0, $jYsb1.default);
$55dda8022ba8f51a$var$MapCache.prototype.set = (0, $5XP4x.default);
var $55dda8022ba8f51a$export$2e2bcd8739ae039 = $55dda8022ba8f51a$var$MapCache;

});
parcelRegister("bAMUC", function(module, exports) {

$parcel$export(module.exports, "default", () => $8708ff73733b2f97$export$2e2bcd8739ae039);

var $lSo3Y = parcelRequire("lSo3Y");

var $kVnfZ = parcelRequire("kVnfZ");

var $fs3H6 = parcelRequire("fs3H6");
/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */ function $8708ff73733b2f97$var$mapCacheClear() {
    this.size = 0;
    this.__data__ = {
        "hash": new (0, $lSo3Y.default),
        "map": new ((0, $fs3H6.default) || (0, $kVnfZ.default)),
        "string": new (0, $lSo3Y.default)
    };
}
var $8708ff73733b2f97$export$2e2bcd8739ae039 = $8708ff73733b2f97$var$mapCacheClear;

});
parcelRegister("lSo3Y", function(module, exports) {

$parcel$export(module.exports, "default", () => $fed14e894961a2f6$export$2e2bcd8739ae039);

var $kTYGm = parcelRequire("kTYGm");

var $3NrNW = parcelRequire("3NrNW");

var $lyGZN = parcelRequire("lyGZN");

var $lMA2G = parcelRequire("lMA2G");

var $aKknX = parcelRequire("aKknX");
/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function $fed14e894961a2f6$var$Hash(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
// Add methods to `Hash`.
$fed14e894961a2f6$var$Hash.prototype.clear = (0, $kTYGm.default);
$fed14e894961a2f6$var$Hash.prototype["delete"] = (0, $3NrNW.default);
$fed14e894961a2f6$var$Hash.prototype.get = (0, $lyGZN.default);
$fed14e894961a2f6$var$Hash.prototype.has = (0, $lMA2G.default);
$fed14e894961a2f6$var$Hash.prototype.set = (0, $aKknX.default);
var $fed14e894961a2f6$export$2e2bcd8739ae039 = $fed14e894961a2f6$var$Hash;

});
parcelRegister("kTYGm", function(module, exports) {

$parcel$export(module.exports, "default", () => $f37803ed33a1d3d1$export$2e2bcd8739ae039);

var $cbYyv = parcelRequire("cbYyv");
/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */ function $f37803ed33a1d3d1$var$hashClear() {
    this.__data__ = (0, $cbYyv.default) ? (0, $cbYyv.default)(null) : {};
    this.size = 0;
}
var $f37803ed33a1d3d1$export$2e2bcd8739ae039 = $f37803ed33a1d3d1$var$hashClear;

});
parcelRegister("cbYyv", function(module, exports) {

$parcel$export(module.exports, "default", () => $8e057c2da47d85b2$export$2e2bcd8739ae039);

var $jLT9P = parcelRequire("jLT9P");
/* Built-in method references that are verified to be native. */ var $8e057c2da47d85b2$var$nativeCreate = (0, $jLT9P.default)(Object, "create");
var $8e057c2da47d85b2$export$2e2bcd8739ae039 = $8e057c2da47d85b2$var$nativeCreate;

});


parcelRegister("3NrNW", function(module, exports) {

$parcel$export(module.exports, "default", () => $2c3b841be68d9967$export$2e2bcd8739ae039);
/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function $2c3b841be68d9967$var$hashDelete(key) {
    var result = this.has(key) && delete this.__data__[key];
    this.size -= result ? 1 : 0;
    return result;
}
var $2c3b841be68d9967$export$2e2bcd8739ae039 = $2c3b841be68d9967$var$hashDelete;

});

parcelRegister("lyGZN", function(module, exports) {

$parcel$export(module.exports, "default", () => $fb1e2001932a20de$export$2e2bcd8739ae039);

var $cbYyv = parcelRequire("cbYyv");
/** Used to stand-in for `undefined` hash values. */ var $fb1e2001932a20de$var$HASH_UNDEFINED = "__lodash_hash_undefined__";
/** Used for built-in method references. */ var $fb1e2001932a20de$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $fb1e2001932a20de$var$hasOwnProperty = $fb1e2001932a20de$var$objectProto.hasOwnProperty;
/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function $fb1e2001932a20de$var$hashGet(key) {
    var data = this.__data__;
    if (0, $cbYyv.default) {
        var result = data[key];
        return result === $fb1e2001932a20de$var$HASH_UNDEFINED ? undefined : result;
    }
    return $fb1e2001932a20de$var$hasOwnProperty.call(data, key) ? data[key] : undefined;
}
var $fb1e2001932a20de$export$2e2bcd8739ae039 = $fb1e2001932a20de$var$hashGet;

});

parcelRegister("lMA2G", function(module, exports) {

$parcel$export(module.exports, "default", () => $fdba09ea24ad742a$export$2e2bcd8739ae039);

var $cbYyv = parcelRequire("cbYyv");
/** Used for built-in method references. */ var $fdba09ea24ad742a$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $fdba09ea24ad742a$var$hasOwnProperty = $fdba09ea24ad742a$var$objectProto.hasOwnProperty;
/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $fdba09ea24ad742a$var$hashHas(key) {
    var data = this.__data__;
    return (0, $cbYyv.default) ? data[key] !== undefined : $fdba09ea24ad742a$var$hasOwnProperty.call(data, key);
}
var $fdba09ea24ad742a$export$2e2bcd8739ae039 = $fdba09ea24ad742a$var$hashHas;

});

parcelRegister("aKknX", function(module, exports) {

$parcel$export(module.exports, "default", () => $7d2e036616ad2fb6$export$2e2bcd8739ae039);

var $cbYyv = parcelRequire("cbYyv");
/** Used to stand-in for `undefined` hash values. */ var $7d2e036616ad2fb6$var$HASH_UNDEFINED = "__lodash_hash_undefined__";
/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */ function $7d2e036616ad2fb6$var$hashSet(key, value) {
    var data = this.__data__;
    this.size += this.has(key) ? 0 : 1;
    data[key] = (0, $cbYyv.default) && value === undefined ? $7d2e036616ad2fb6$var$HASH_UNDEFINED : value;
    return this;
}
var $7d2e036616ad2fb6$export$2e2bcd8739ae039 = $7d2e036616ad2fb6$var$hashSet;

});



parcelRegister("56mPM", function(module, exports) {

$parcel$export(module.exports, "default", () => $3b6f39a956fe6a39$export$2e2bcd8739ae039);

var $9vBNU = parcelRequire("9vBNU");
/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function $3b6f39a956fe6a39$var$mapCacheDelete(key) {
    var result = (0, $9vBNU.default)(this, key)["delete"](key);
    this.size -= result ? 1 : 0;
    return result;
}
var $3b6f39a956fe6a39$export$2e2bcd8739ae039 = $3b6f39a956fe6a39$var$mapCacheDelete;

});
parcelRegister("9vBNU", function(module, exports) {

$parcel$export(module.exports, "default", () => $6ec4556484e81801$export$2e2bcd8739ae039);

var $4WJzL = parcelRequire("4WJzL");
/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */ function $6ec4556484e81801$var$getMapData(map, key) {
    var data = map.__data__;
    return (0, $4WJzL.default)(key) ? data[typeof key == "string" ? "string" : "hash"] : data.map;
}
var $6ec4556484e81801$export$2e2bcd8739ae039 = $6ec4556484e81801$var$getMapData;

});
parcelRegister("4WJzL", function(module, exports) {

$parcel$export(module.exports, "default", () => $399fee9a556f4b4d$export$2e2bcd8739ae039);
/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */ function $399fee9a556f4b4d$var$isKeyable(value) {
    var type = typeof value;
    return type == "string" || type == "number" || type == "symbol" || type == "boolean" ? value !== "__proto__" : value === null;
}
var $399fee9a556f4b4d$export$2e2bcd8739ae039 = $399fee9a556f4b4d$var$isKeyable;

});



parcelRegister("428kg", function(module, exports) {

$parcel$export(module.exports, "default", () => $2efdcea83805e55c$export$2e2bcd8739ae039);

var $9vBNU = parcelRequire("9vBNU");
/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function $2efdcea83805e55c$var$mapCacheGet(key) {
    return (0, $9vBNU.default)(this, key).get(key);
}
var $2efdcea83805e55c$export$2e2bcd8739ae039 = $2efdcea83805e55c$var$mapCacheGet;

});

parcelRegister("jYsb1", function(module, exports) {

$parcel$export(module.exports, "default", () => $e8a97a3ac9920cdd$export$2e2bcd8739ae039);

var $9vBNU = parcelRequire("9vBNU");
/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $e8a97a3ac9920cdd$var$mapCacheHas(key) {
    return (0, $9vBNU.default)(this, key).has(key);
}
var $e8a97a3ac9920cdd$export$2e2bcd8739ae039 = $e8a97a3ac9920cdd$var$mapCacheHas;

});

parcelRegister("5XP4x", function(module, exports) {

$parcel$export(module.exports, "default", () => $457a144fcd79754e$export$2e2bcd8739ae039);

var $9vBNU = parcelRequire("9vBNU");
/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */ function $457a144fcd79754e$var$mapCacheSet(key, value) {
    var data = (0, $9vBNU.default)(this, key), size = data.size;
    data.set(key, value);
    this.size += data.size == size ? 0 : 1;
    return this;
}
var $457a144fcd79754e$export$2e2bcd8739ae039 = $457a144fcd79754e$var$mapCacheSet;

});




parcelRegister("iDECW", function(module, exports) {

$parcel$export(module.exports, "default", () => $d91b623631254979$export$2e2bcd8739ae039);
/**
 * A specialized version of `_.forEach` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns `array`.
 */ function $d91b623631254979$var$arrayEach(array, iteratee) {
    var index = -1, length = array == null ? 0 : array.length;
    while(++index < length){
        if (iteratee(array[index], index, array) === false) break;
    }
    return array;
}
var $d91b623631254979$export$2e2bcd8739ae039 = $d91b623631254979$var$arrayEach;

});

parcelRegister("a6l6i", function(module, exports) {

$parcel$export(module.exports, "default", () => $75aad50ec93ed496$export$2e2bcd8739ae039);

var $dLTlW = parcelRequire("dLTlW");

var $lvgV1 = parcelRequire("lvgV1");
/** Used for built-in method references. */ var $75aad50ec93ed496$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $75aad50ec93ed496$var$hasOwnProperty = $75aad50ec93ed496$var$objectProto.hasOwnProperty;
/**
 * Assigns `value` to `key` of `object` if the existing value is not equivalent
 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */ function $75aad50ec93ed496$var$assignValue(object, key, value) {
    var objValue = object[key];
    if (!($75aad50ec93ed496$var$hasOwnProperty.call(object, key) && (0, $lvgV1.default)(objValue, value)) || value === undefined && !(key in object)) (0, $dLTlW.default)(object, key, value);
}
var $75aad50ec93ed496$export$2e2bcd8739ae039 = $75aad50ec93ed496$var$assignValue;

});
parcelRegister("dLTlW", function(module, exports) {

$parcel$export(module.exports, "default", () => $a06a9a17329ff8a6$export$2e2bcd8739ae039);

var $1RMjB = parcelRequire("1RMjB");
/**
 * The base implementation of `assignValue` and `assignMergeValue` without
 * value checks.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */ function $a06a9a17329ff8a6$var$baseAssignValue(object, key, value) {
    if (key == "__proto__" && (0, $1RMjB.default)) (0, $1RMjB.default)(object, key, {
        "configurable": true,
        "enumerable": true,
        "value": value,
        "writable": true
    });
    else object[key] = value;
}
var $a06a9a17329ff8a6$export$2e2bcd8739ae039 = $a06a9a17329ff8a6$var$baseAssignValue;

});
parcelRegister("1RMjB", function(module, exports) {

$parcel$export(module.exports, "default", () => $15c038100f8779dc$export$2e2bcd8739ae039);

var $jLT9P = parcelRequire("jLT9P");
var $15c038100f8779dc$var$defineProperty = function() {
    try {
        var func = (0, $jLT9P.default)(Object, "defineProperty");
        func({}, "", {});
        return func;
    } catch (e) {}
}();
var $15c038100f8779dc$export$2e2bcd8739ae039 = $15c038100f8779dc$var$defineProperty;

});



parcelRegister("7FIi5", function(module, exports) {

$parcel$export(module.exports, "default", () => $595eb7f7a07807be$export$2e2bcd8739ae039);

var $3Wzdm = parcelRequire("3Wzdm");

var $8krEv = parcelRequire("8krEv");
/**
 * The base implementation of `_.assign` without support for multiple sources
 * or `customizer` functions.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @returns {Object} Returns `object`.
 */ function $595eb7f7a07807be$var$baseAssign(object, source) {
    return object && (0, $3Wzdm.default)(source, (0, $8krEv.default)(source), object);
}
var $595eb7f7a07807be$export$2e2bcd8739ae039 = $595eb7f7a07807be$var$baseAssign;

});
parcelRegister("3Wzdm", function(module, exports) {

$parcel$export(module.exports, "default", () => $2df21abc8bda85fc$export$2e2bcd8739ae039);

var $a6l6i = parcelRequire("a6l6i");

var $dLTlW = parcelRequire("dLTlW");
/**
 * Copies properties of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy properties from.
 * @param {Array} props The property identifiers to copy.
 * @param {Object} [object={}] The object to copy properties to.
 * @param {Function} [customizer] The function to customize copied values.
 * @returns {Object} Returns `object`.
 */ function $2df21abc8bda85fc$var$copyObject(source, props, object, customizer) {
    var isNew = !object;
    object || (object = {});
    var index = -1, length = props.length;
    while(++index < length){
        var key = props[index];
        var newValue = customizer ? customizer(object[key], source[key], key, object, source) : undefined;
        if (newValue === undefined) newValue = source[key];
        if (isNew) (0, $dLTlW.default)(object, key, newValue);
        else (0, $a6l6i.default)(object, key, newValue);
    }
    return object;
}
var $2df21abc8bda85fc$export$2e2bcd8739ae039 = $2df21abc8bda85fc$var$copyObject;

});

parcelRegister("8krEv", function(module, exports) {

$parcel$export(module.exports, "default", () => $6105a42c6332ca51$export$2e2bcd8739ae039);

var $OC2DR = parcelRequire("OC2DR");

var $lTyg4 = parcelRequire("lTyg4");

var $lAOUf = parcelRequire("lAOUf");
/**
 * Creates an array of the own enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects. See the
 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * for more details.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keys(new Foo);
 * // => ['a', 'b'] (iteration order is not guaranteed)
 *
 * _.keys('hi');
 * // => ['0', '1']
 */ function $6105a42c6332ca51$var$keys(object) {
    return (0, $lAOUf.default)(object) ? (0, $OC2DR.default)(object) : (0, $lTyg4.default)(object);
}
var $6105a42c6332ca51$export$2e2bcd8739ae039 = $6105a42c6332ca51$var$keys;

});
parcelRegister("OC2DR", function(module, exports) {

$parcel$export(module.exports, "default", () => $09822de5e5cf749f$export$2e2bcd8739ae039);

var $3f4I6 = parcelRequire("3f4I6");

var $5VdmZ = parcelRequire("5VdmZ");

var $hf0C9 = parcelRequire("hf0C9");

var $f3ZL4 = parcelRequire("f3ZL4");

var $cBYZY = parcelRequire("cBYZY");

var $cmTeE = parcelRequire("cmTeE");
/** Used for built-in method references. */ var $09822de5e5cf749f$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $09822de5e5cf749f$var$hasOwnProperty = $09822de5e5cf749f$var$objectProto.hasOwnProperty;
/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */ function $09822de5e5cf749f$var$arrayLikeKeys(value, inherited) {
    var isArr = (0, $hf0C9.default)(value), isArg = !isArr && (0, $5VdmZ.default)(value), isBuff = !isArr && !isArg && (0, $f3ZL4.default)(value), isType = !isArr && !isArg && !isBuff && (0, $cmTeE.default)(value), skipIndexes = isArr || isArg || isBuff || isType, result = skipIndexes ? (0, $3f4I6.default)(value.length, String) : [], length = result.length;
    for(var key in value)if ((inherited || $09822de5e5cf749f$var$hasOwnProperty.call(value, key)) && !(skipIndexes && // Safari 9 has enumerable `arguments.length` in strict mode.
    (key == "length" || // Node.js 0.10 has enumerable non-index properties on buffers.
    isBuff && (key == "offset" || key == "parent") || // PhantomJS 2 has enumerable non-index properties on typed arrays.
    isType && (key == "buffer" || key == "byteLength" || key == "byteOffset") || // Skip index properties.
    (0, $cBYZY.default)(key, length)))) result.push(key);
    return result;
}
var $09822de5e5cf749f$export$2e2bcd8739ae039 = $09822de5e5cf749f$var$arrayLikeKeys;

});
parcelRegister("3f4I6", function(module, exports) {

$parcel$export(module.exports, "default", () => $25c66d2c4e8fadd1$export$2e2bcd8739ae039);
/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */ function $25c66d2c4e8fadd1$var$baseTimes(n, iteratee) {
    var index = -1, result = Array(n);
    while(++index < n)result[index] = iteratee(index);
    return result;
}
var $25c66d2c4e8fadd1$export$2e2bcd8739ae039 = $25c66d2c4e8fadd1$var$baseTimes;

});

parcelRegister("5VdmZ", function(module, exports) {

$parcel$export(module.exports, "default", () => $44fca59879666c41$export$2e2bcd8739ae039);

var $j2nBL = parcelRequire("j2nBL");

var $f2iog = parcelRequire("f2iog");
/** Used for built-in method references. */ var $44fca59879666c41$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $44fca59879666c41$var$hasOwnProperty = $44fca59879666c41$var$objectProto.hasOwnProperty;
/** Built-in value references. */ var $44fca59879666c41$var$propertyIsEnumerable = $44fca59879666c41$var$objectProto.propertyIsEnumerable;
/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */ var $44fca59879666c41$var$isArguments = (0, $j2nBL.default)(function() {
    return arguments;
}()) ? (0, $j2nBL.default) : function(value) {
    return (0, $f2iog.default)(value) && $44fca59879666c41$var$hasOwnProperty.call(value, "callee") && !$44fca59879666c41$var$propertyIsEnumerable.call(value, "callee");
};
var $44fca59879666c41$export$2e2bcd8739ae039 = $44fca59879666c41$var$isArguments;

});
parcelRegister("j2nBL", function(module, exports) {

$parcel$export(module.exports, "default", () => $ddc0844e7eecdb52$export$2e2bcd8739ae039);

var $hArsG = parcelRequire("hArsG");

var $f2iog = parcelRequire("f2iog");
/** `Object#toString` result references. */ var $ddc0844e7eecdb52$var$argsTag = "[object Arguments]";
/**
 * The base implementation of `_.isArguments`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 */ function $ddc0844e7eecdb52$var$baseIsArguments(value) {
    return (0, $f2iog.default)(value) && (0, $hArsG.default)(value) == $ddc0844e7eecdb52$var$argsTag;
}
var $ddc0844e7eecdb52$export$2e2bcd8739ae039 = $ddc0844e7eecdb52$var$baseIsArguments;

});


parcelRegister("hf0C9", function(module, exports) {

$parcel$export(module.exports, "default", () => $c8d4506109b88831$export$2e2bcd8739ae039);
/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */ var $c8d4506109b88831$var$isArray = Array.isArray;
var $c8d4506109b88831$export$2e2bcd8739ae039 = $c8d4506109b88831$var$isArray;

});

parcelRegister("f3ZL4", function(module, exports) {

$parcel$export(module.exports, "default", () => $af770abdaf769dee$export$2e2bcd8739ae039);

var $2mpFt = parcelRequire("2mpFt");

var $kcGKx = parcelRequire("kcGKx");
/** Detect free variable `exports`. */ var freeExports = exports && !exports.nodeType && exports;
/** Detect free variable `module`. */ var freeModule = freeExports && true && module && !module.nodeType && module;
/** Detect the popular CommonJS extension `module.exports`. */ var moduleExports = freeModule && freeModule.exports === freeExports;
/** Built-in value references. */ var Buffer = moduleExports ? (0, $2mpFt.default).Buffer : undefined;
/* Built-in method references for those with the same name as other `lodash` methods. */ var nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined;
/**
 * Checks if `value` is a buffer.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
 * @example
 *
 * _.isBuffer(new Buffer(2));
 * // => true
 *
 * _.isBuffer(new Uint8Array(2));
 * // => false
 */ var isBuffer = nativeIsBuffer || (0, $kcGKx.default);
var $af770abdaf769dee$export$2e2bcd8739ae039 = isBuffer;

});
parcelRegister("kcGKx", function(module, exports) {

$parcel$export(module.exports, "default", () => $eb5616d4c933d058$export$2e2bcd8739ae039);
/**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */ function $eb5616d4c933d058$var$stubFalse() {
    return false;
}
var $eb5616d4c933d058$export$2e2bcd8739ae039 = $eb5616d4c933d058$var$stubFalse;

});


parcelRegister("cBYZY", function(module, exports) {

$parcel$export(module.exports, "default", () => $92e841cef318fb91$export$2e2bcd8739ae039);
/** Used as references for various `Number` constants. */ var $92e841cef318fb91$var$MAX_SAFE_INTEGER = 9007199254740991;
/** Used to detect unsigned integer values. */ var $92e841cef318fb91$var$reIsUint = /^(?:0|[1-9]\d*)$/;
/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */ function $92e841cef318fb91$var$isIndex(value, length) {
    var type = typeof value;
    length = length == null ? $92e841cef318fb91$var$MAX_SAFE_INTEGER : length;
    return !!length && (type == "number" || type != "symbol" && $92e841cef318fb91$var$reIsUint.test(value)) && value > -1 && value % 1 == 0 && value < length;
}
var $92e841cef318fb91$export$2e2bcd8739ae039 = $92e841cef318fb91$var$isIndex;

});

parcelRegister("cmTeE", function(module, exports) {

$parcel$export(module.exports, "default", () => $901262b1d4441a58$export$2e2bcd8739ae039);

var $eaXgH = parcelRequire("eaXgH");

var $hb0cD = parcelRequire("hb0cD");

var $lFXqE = parcelRequire("lFXqE");
/* Node.js helper references. */ var $901262b1d4441a58$var$nodeIsTypedArray = (0, $lFXqE.default) && (0, $lFXqE.default).isTypedArray;
/**
 * Checks if `value` is classified as a typed array.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 * @example
 *
 * _.isTypedArray(new Uint8Array);
 * // => true
 *
 * _.isTypedArray([]);
 * // => false
 */ var $901262b1d4441a58$var$isTypedArray = $901262b1d4441a58$var$nodeIsTypedArray ? (0, $hb0cD.default)($901262b1d4441a58$var$nodeIsTypedArray) : (0, $eaXgH.default);
var $901262b1d4441a58$export$2e2bcd8739ae039 = $901262b1d4441a58$var$isTypedArray;

});
parcelRegister("eaXgH", function(module, exports) {

$parcel$export(module.exports, "default", () => $a51ff94e4fd33486$export$2e2bcd8739ae039);

var $hArsG = parcelRequire("hArsG");

var $idNmI = parcelRequire("idNmI");

var $f2iog = parcelRequire("f2iog");
/** `Object#toString` result references. */ var $a51ff94e4fd33486$var$argsTag = "[object Arguments]", $a51ff94e4fd33486$var$arrayTag = "[object Array]", $a51ff94e4fd33486$var$boolTag = "[object Boolean]", $a51ff94e4fd33486$var$dateTag = "[object Date]", $a51ff94e4fd33486$var$errorTag = "[object Error]", $a51ff94e4fd33486$var$funcTag = "[object Function]", $a51ff94e4fd33486$var$mapTag = "[object Map]", $a51ff94e4fd33486$var$numberTag = "[object Number]", $a51ff94e4fd33486$var$objectTag = "[object Object]", $a51ff94e4fd33486$var$regexpTag = "[object RegExp]", $a51ff94e4fd33486$var$setTag = "[object Set]", $a51ff94e4fd33486$var$stringTag = "[object String]", $a51ff94e4fd33486$var$weakMapTag = "[object WeakMap]";
var $a51ff94e4fd33486$var$arrayBufferTag = "[object ArrayBuffer]", $a51ff94e4fd33486$var$dataViewTag = "[object DataView]", $a51ff94e4fd33486$var$float32Tag = "[object Float32Array]", $a51ff94e4fd33486$var$float64Tag = "[object Float64Array]", $a51ff94e4fd33486$var$int8Tag = "[object Int8Array]", $a51ff94e4fd33486$var$int16Tag = "[object Int16Array]", $a51ff94e4fd33486$var$int32Tag = "[object Int32Array]", $a51ff94e4fd33486$var$uint8Tag = "[object Uint8Array]", $a51ff94e4fd33486$var$uint8ClampedTag = "[object Uint8ClampedArray]", $a51ff94e4fd33486$var$uint16Tag = "[object Uint16Array]", $a51ff94e4fd33486$var$uint32Tag = "[object Uint32Array]";
/** Used to identify `toStringTag` values of typed arrays. */ var $a51ff94e4fd33486$var$typedArrayTags = {};
$a51ff94e4fd33486$var$typedArrayTags[$a51ff94e4fd33486$var$float32Tag] = $a51ff94e4fd33486$var$typedArrayTags[$a51ff94e4fd33486$var$float64Tag] = $a51ff94e4fd33486$var$typedArrayTags[$a51ff94e4fd33486$var$int8Tag] = $a51ff94e4fd33486$var$typedArrayTags[$a51ff94e4fd33486$var$int16Tag] = $a51ff94e4fd33486$var$typedArrayTags[$a51ff94e4fd33486$var$int32Tag] = $a51ff94e4fd33486$var$typedArrayTags[$a51ff94e4fd33486$var$uint8Tag] = $a51ff94e4fd33486$var$typedArrayTags[$a51ff94e4fd33486$var$uint8ClampedTag] = $a51ff94e4fd33486$var$typedArrayTags[$a51ff94e4fd33486$var$uint16Tag] = $a51ff94e4fd33486$var$typedArrayTags[$a51ff94e4fd33486$var$uint32Tag] = true;
$a51ff94e4fd33486$var$typedArrayTags[$a51ff94e4fd33486$var$argsTag] = $a51ff94e4fd33486$var$typedArrayTags[$a51ff94e4fd33486$var$arrayTag] = $a51ff94e4fd33486$var$typedArrayTags[$a51ff94e4fd33486$var$arrayBufferTag] = $a51ff94e4fd33486$var$typedArrayTags[$a51ff94e4fd33486$var$boolTag] = $a51ff94e4fd33486$var$typedArrayTags[$a51ff94e4fd33486$var$dataViewTag] = $a51ff94e4fd33486$var$typedArrayTags[$a51ff94e4fd33486$var$dateTag] = $a51ff94e4fd33486$var$typedArrayTags[$a51ff94e4fd33486$var$errorTag] = $a51ff94e4fd33486$var$typedArrayTags[$a51ff94e4fd33486$var$funcTag] = $a51ff94e4fd33486$var$typedArrayTags[$a51ff94e4fd33486$var$mapTag] = $a51ff94e4fd33486$var$typedArrayTags[$a51ff94e4fd33486$var$numberTag] = $a51ff94e4fd33486$var$typedArrayTags[$a51ff94e4fd33486$var$objectTag] = $a51ff94e4fd33486$var$typedArrayTags[$a51ff94e4fd33486$var$regexpTag] = $a51ff94e4fd33486$var$typedArrayTags[$a51ff94e4fd33486$var$setTag] = $a51ff94e4fd33486$var$typedArrayTags[$a51ff94e4fd33486$var$stringTag] = $a51ff94e4fd33486$var$typedArrayTags[$a51ff94e4fd33486$var$weakMapTag] = false;
/**
 * The base implementation of `_.isTypedArray` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 */ function $a51ff94e4fd33486$var$baseIsTypedArray(value) {
    return (0, $f2iog.default)(value) && (0, $idNmI.default)(value.length) && !!$a51ff94e4fd33486$var$typedArrayTags[(0, $hArsG.default)(value)];
}
var $a51ff94e4fd33486$export$2e2bcd8739ae039 = $a51ff94e4fd33486$var$baseIsTypedArray;

});
parcelRegister("idNmI", function(module, exports) {

$parcel$export(module.exports, "default", () => $d43fbbcf5bc665de$export$2e2bcd8739ae039);
/** Used as references for various `Number` constants. */ var $d43fbbcf5bc665de$var$MAX_SAFE_INTEGER = 9007199254740991;
/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */ function $d43fbbcf5bc665de$var$isLength(value) {
    return typeof value == "number" && value > -1 && value % 1 == 0 && value <= $d43fbbcf5bc665de$var$MAX_SAFE_INTEGER;
}
var $d43fbbcf5bc665de$export$2e2bcd8739ae039 = $d43fbbcf5bc665de$var$isLength;

});


parcelRegister("hb0cD", function(module, exports) {

$parcel$export(module.exports, "default", () => $c8139f05a61e038a$export$2e2bcd8739ae039);
/**
 * The base implementation of `_.unary` without support for storing metadata.
 *
 * @private
 * @param {Function} func The function to cap arguments for.
 * @returns {Function} Returns the new capped function.
 */ function $c8139f05a61e038a$var$baseUnary(func) {
    return function(value) {
        return func(value);
    };
}
var $c8139f05a61e038a$export$2e2bcd8739ae039 = $c8139f05a61e038a$var$baseUnary;

});

parcelRegister("lFXqE", function(module, exports) {

$parcel$export(module.exports, "default", () => $fc7b86a02b9b077f$export$2e2bcd8739ae039);

var $4kWvg = parcelRequire("4kWvg");
/** Detect free variable `exports`. */ var freeExports = exports && !exports.nodeType && exports;
/** Detect free variable `module`. */ var freeModule = freeExports && true && module && !module.nodeType && module;
/** Detect the popular CommonJS extension `module.exports`. */ var moduleExports = freeModule && freeModule.exports === freeExports;
/** Detect free variable `process` from Node.js. */ var freeProcess = moduleExports && (0, $4kWvg.default).process;
/** Used to access faster Node.js helpers. */ var nodeUtil = function() {
    try {
        // Use `util.types` for Node.js 10+.
        var types = freeModule && freeModule.require && freeModule.require("util").types;
        if (types) return types;
        // Legacy `process.binding('util')` for Node.js < 10.
        return freeProcess && freeProcess.binding && freeProcess.binding("util");
    } catch (e) {}
}();
var $fc7b86a02b9b077f$export$2e2bcd8739ae039 = nodeUtil;

});



parcelRegister("lTyg4", function(module, exports) {

$parcel$export(module.exports, "default", () => $ff094f04b4f9f6ca$export$2e2bcd8739ae039);

var $74QAJ = parcelRequire("74QAJ");

var $4lnKf = parcelRequire("4lnKf");
/** Used for built-in method references. */ var $ff094f04b4f9f6ca$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $ff094f04b4f9f6ca$var$hasOwnProperty = $ff094f04b4f9f6ca$var$objectProto.hasOwnProperty;
/**
 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */ function $ff094f04b4f9f6ca$var$baseKeys(object) {
    if (!(0, $74QAJ.default)(object)) return (0, $4lnKf.default)(object);
    var result = [];
    for(var key in Object(object))if ($ff094f04b4f9f6ca$var$hasOwnProperty.call(object, key) && key != "constructor") result.push(key);
    return result;
}
var $ff094f04b4f9f6ca$export$2e2bcd8739ae039 = $ff094f04b4f9f6ca$var$baseKeys;

});
parcelRegister("74QAJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $5271b3ac6403835d$export$2e2bcd8739ae039);
/** Used for built-in method references. */ var $5271b3ac6403835d$var$objectProto = Object.prototype;
/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */ function $5271b3ac6403835d$var$isPrototype(value) {
    var Ctor = value && value.constructor, proto = typeof Ctor == "function" && Ctor.prototype || $5271b3ac6403835d$var$objectProto;
    return value === proto;
}
var $5271b3ac6403835d$export$2e2bcd8739ae039 = $5271b3ac6403835d$var$isPrototype;

});

parcelRegister("4lnKf", function(module, exports) {

$parcel$export(module.exports, "default", () => $329b8ad85e05c8eb$export$2e2bcd8739ae039);

var $7N1cZ = parcelRequire("7N1cZ");
/* Built-in method references for those with the same name as other `lodash` methods. */ var $329b8ad85e05c8eb$var$nativeKeys = (0, $7N1cZ.default)(Object.keys, Object);
var $329b8ad85e05c8eb$export$2e2bcd8739ae039 = $329b8ad85e05c8eb$var$nativeKeys;

});


parcelRegister("lAOUf", function(module, exports) {

$parcel$export(module.exports, "default", () => $fb8472aba17743fc$export$2e2bcd8739ae039);

var $4VY3C = parcelRequire("4VY3C");

var $idNmI = parcelRequire("idNmI");
/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */ function $fb8472aba17743fc$var$isArrayLike(value) {
    return value != null && (0, $idNmI.default)(value.length) && !(0, $4VY3C.default)(value);
}
var $fb8472aba17743fc$export$2e2bcd8739ae039 = $fb8472aba17743fc$var$isArrayLike;

});



parcelRegister("3vFgL", function(module, exports) {

$parcel$export(module.exports, "default", () => $28e447985d6ff998$export$2e2bcd8739ae039);

var $3Wzdm = parcelRequire("3Wzdm");

var $ceNjR = parcelRequire("ceNjR");
/**
 * The base implementation of `_.assignIn` without support for multiple sources
 * or `customizer` functions.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @returns {Object} Returns `object`.
 */ function $28e447985d6ff998$var$baseAssignIn(object, source) {
    return object && (0, $3Wzdm.default)(source, (0, $ceNjR.default)(source), object);
}
var $28e447985d6ff998$export$2e2bcd8739ae039 = $28e447985d6ff998$var$baseAssignIn;

});
parcelRegister("ceNjR", function(module, exports) {

$parcel$export(module.exports, "default", () => $8e8d0ca4619e1205$export$2e2bcd8739ae039);

var $OC2DR = parcelRequire("OC2DR");

var $28fGX = parcelRequire("28fGX");

var $lAOUf = parcelRequire("lAOUf");
/**
 * Creates an array of the own and inherited enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keysIn(new Foo);
 * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
 */ function $8e8d0ca4619e1205$var$keysIn(object) {
    return (0, $lAOUf.default)(object) ? (0, $OC2DR.default)(object, true) : (0, $28fGX.default)(object);
}
var $8e8d0ca4619e1205$export$2e2bcd8739ae039 = $8e8d0ca4619e1205$var$keysIn;

});
parcelRegister("28fGX", function(module, exports) {

$parcel$export(module.exports, "default", () => $18d88030c379da98$export$2e2bcd8739ae039);

var $iYDsF = parcelRequire("iYDsF");

var $74QAJ = parcelRequire("74QAJ");

var $ab5U2 = parcelRequire("ab5U2");
/** Used for built-in method references. */ var $18d88030c379da98$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $18d88030c379da98$var$hasOwnProperty = $18d88030c379da98$var$objectProto.hasOwnProperty;
/**
 * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */ function $18d88030c379da98$var$baseKeysIn(object) {
    if (!(0, $iYDsF.default)(object)) return (0, $ab5U2.default)(object);
    var isProto = (0, $74QAJ.default)(object), result = [];
    for(var key in object)if (!(key == "constructor" && (isProto || !$18d88030c379da98$var$hasOwnProperty.call(object, key)))) result.push(key);
    return result;
}
var $18d88030c379da98$export$2e2bcd8739ae039 = $18d88030c379da98$var$baseKeysIn;

});
parcelRegister("ab5U2", function(module, exports) {

$parcel$export(module.exports, "default", () => $768f82a6c66c1e5e$export$2e2bcd8739ae039);
/**
 * This function is like
 * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * except that it includes inherited enumerable properties.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */ function $768f82a6c66c1e5e$var$nativeKeysIn(object) {
    var result = [];
    if (object != null) for(var key in Object(object))result.push(key);
    return result;
}
var $768f82a6c66c1e5e$export$2e2bcd8739ae039 = $768f82a6c66c1e5e$var$nativeKeysIn;

});




parcelRegister("gqoYg", function(module, exports) {

$parcel$export(module.exports, "default", () => $bf5271c040a1f410$export$2e2bcd8739ae039);

var $2mpFt = parcelRequire("2mpFt");
/** Detect free variable `exports`. */ var freeExports = exports && !exports.nodeType && exports;
/** Detect free variable `module`. */ var freeModule = freeExports && true && module && !module.nodeType && module;
/** Detect the popular CommonJS extension `module.exports`. */ var moduleExports = freeModule && freeModule.exports === freeExports;
/** Built-in value references. */ var Buffer = moduleExports ? (0, $2mpFt.default).Buffer : undefined, allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined;
/**
 * Creates a clone of  `buffer`.
 *
 * @private
 * @param {Buffer} buffer The buffer to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Buffer} Returns the cloned buffer.
 */ function cloneBuffer(buffer, isDeep) {
    if (isDeep) return buffer.slice();
    var length = buffer.length, result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);
    buffer.copy(result);
    return result;
}
var $bf5271c040a1f410$export$2e2bcd8739ae039 = cloneBuffer;

});

parcelRegister("jXStN", function(module, exports) {

$parcel$export(module.exports, "default", () => $e88dc98a9c0b5c36$export$2e2bcd8739ae039);
/**
 * Copies the values of `source` to `array`.
 *
 * @private
 * @param {Array} source The array to copy values from.
 * @param {Array} [array=[]] The array to copy values to.
 * @returns {Array} Returns `array`.
 */ function $e88dc98a9c0b5c36$var$copyArray(source, array) {
    var index = -1, length = source.length;
    array || (array = Array(length));
    while(++index < length)array[index] = source[index];
    return array;
}
var $e88dc98a9c0b5c36$export$2e2bcd8739ae039 = $e88dc98a9c0b5c36$var$copyArray;

});

parcelRegister("8gRDv", function(module, exports) {

$parcel$export(module.exports, "default", () => $60596c5c5ae95246$export$2e2bcd8739ae039);

var $3Wzdm = parcelRequire("3Wzdm");

var $dKFRe = parcelRequire("dKFRe");
/**
 * Copies own symbols of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy symbols from.
 * @param {Object} [object={}] The object to copy symbols to.
 * @returns {Object} Returns `object`.
 */ function $60596c5c5ae95246$var$copySymbols(source, object) {
    return (0, $3Wzdm.default)(source, (0, $dKFRe.default)(source), object);
}
var $60596c5c5ae95246$export$2e2bcd8739ae039 = $60596c5c5ae95246$var$copySymbols;

});
parcelRegister("dKFRe", function(module, exports) {

$parcel$export(module.exports, "default", () => $02956b8552c88dad$export$2e2bcd8739ae039);

var $bpczR = parcelRequire("bpczR");

var $37AVt = parcelRequire("37AVt");
/** Used for built-in method references. */ var $02956b8552c88dad$var$objectProto = Object.prototype;
/** Built-in value references. */ var $02956b8552c88dad$var$propertyIsEnumerable = $02956b8552c88dad$var$objectProto.propertyIsEnumerable;
/* Built-in method references for those with the same name as other `lodash` methods. */ var $02956b8552c88dad$var$nativeGetSymbols = Object.getOwnPropertySymbols;
/**
 * Creates an array of the own enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */ var $02956b8552c88dad$var$getSymbols = !$02956b8552c88dad$var$nativeGetSymbols ? (0, $37AVt.default) : function(object) {
    if (object == null) return [];
    object = Object(object);
    return (0, $bpczR.default)($02956b8552c88dad$var$nativeGetSymbols(object), function(symbol) {
        return $02956b8552c88dad$var$propertyIsEnumerable.call(object, symbol);
    });
};
var $02956b8552c88dad$export$2e2bcd8739ae039 = $02956b8552c88dad$var$getSymbols;

});
parcelRegister("bpczR", function(module, exports) {

$parcel$export(module.exports, "default", () => $84dbc91852227c49$export$2e2bcd8739ae039);
/**
 * A specialized version of `_.filter` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {Array} Returns the new filtered array.
 */ function $84dbc91852227c49$var$arrayFilter(array, predicate) {
    var index = -1, length = array == null ? 0 : array.length, resIndex = 0, result = [];
    while(++index < length){
        var value = array[index];
        if (predicate(value, index, array)) result[resIndex++] = value;
    }
    return result;
}
var $84dbc91852227c49$export$2e2bcd8739ae039 = $84dbc91852227c49$var$arrayFilter;

});

parcelRegister("37AVt", function(module, exports) {

$parcel$export(module.exports, "default", () => $245eab4238d1191b$export$2e2bcd8739ae039);
/**
 * This method returns a new empty array.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {Array} Returns the new empty array.
 * @example
 *
 * var arrays = _.times(2, _.stubArray);
 *
 * console.log(arrays);
 * // => [[], []]
 *
 * console.log(arrays[0] === arrays[1]);
 * // => false
 */ function $245eab4238d1191b$var$stubArray() {
    return [];
}
var $245eab4238d1191b$export$2e2bcd8739ae039 = $245eab4238d1191b$var$stubArray;

});



parcelRegister("7AKhX", function(module, exports) {

$parcel$export(module.exports, "default", () => $586fcd2cd99597f5$export$2e2bcd8739ae039);

var $3Wzdm = parcelRequire("3Wzdm");

var $hDzVK = parcelRequire("hDzVK");
/**
 * Copies own and inherited symbols of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy symbols from.
 * @param {Object} [object={}] The object to copy symbols to.
 * @returns {Object} Returns `object`.
 */ function $586fcd2cd99597f5$var$copySymbolsIn(source, object) {
    return (0, $3Wzdm.default)(source, (0, $hDzVK.default)(source), object);
}
var $586fcd2cd99597f5$export$2e2bcd8739ae039 = $586fcd2cd99597f5$var$copySymbolsIn;

});
parcelRegister("hDzVK", function(module, exports) {

$parcel$export(module.exports, "default", () => $cd71f33290dd3540$export$2e2bcd8739ae039);

var $6JPqi = parcelRequire("6JPqi");

var $bzIQZ = parcelRequire("bzIQZ");

var $dKFRe = parcelRequire("dKFRe");

var $37AVt = parcelRequire("37AVt");
/* Built-in method references for those with the same name as other `lodash` methods. */ var $cd71f33290dd3540$var$nativeGetSymbols = Object.getOwnPropertySymbols;
/**
 * Creates an array of the own and inherited enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */ var $cd71f33290dd3540$var$getSymbolsIn = !$cd71f33290dd3540$var$nativeGetSymbols ? (0, $37AVt.default) : function(object) {
    var result = [];
    while(object){
        (0, $6JPqi.default)(result, (0, $dKFRe.default)(object));
        object = (0, $bzIQZ.default)(object);
    }
    return result;
};
var $cd71f33290dd3540$export$2e2bcd8739ae039 = $cd71f33290dd3540$var$getSymbolsIn;

});
parcelRegister("6JPqi", function(module, exports) {

$parcel$export(module.exports, "default", () => $4e7ed5991d883ad6$export$2e2bcd8739ae039);
/**
 * Appends the elements of `values` to `array`.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {Array} values The values to append.
 * @returns {Array} Returns `array`.
 */ function $4e7ed5991d883ad6$var$arrayPush(array, values) {
    var index = -1, length = values.length, offset = array.length;
    while(++index < length)array[offset + index] = values[index];
    return array;
}
var $4e7ed5991d883ad6$export$2e2bcd8739ae039 = $4e7ed5991d883ad6$var$arrayPush;

});



parcelRegister("oK0lo", function(module, exports) {

$parcel$export(module.exports, "default", () => $04a5ed8d1a69f13e$export$2e2bcd8739ae039);

var $hNlD0 = parcelRequire("hNlD0");

var $dKFRe = parcelRequire("dKFRe");

var $8krEv = parcelRequire("8krEv");
/**
 * Creates an array of own enumerable property names and symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */ function $04a5ed8d1a69f13e$var$getAllKeys(object) {
    return (0, $hNlD0.default)(object, (0, $8krEv.default), (0, $dKFRe.default));
}
var $04a5ed8d1a69f13e$export$2e2bcd8739ae039 = $04a5ed8d1a69f13e$var$getAllKeys;

});
parcelRegister("hNlD0", function(module, exports) {

$parcel$export(module.exports, "default", () => $cf47ca2fc3f4de6e$export$2e2bcd8739ae039);

var $6JPqi = parcelRequire("6JPqi");

var $hf0C9 = parcelRequire("hf0C9");
/**
 * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
 * `keysFunc` and `symbolsFunc` to get the enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @param {Function} symbolsFunc The function to get the symbols of `object`.
 * @returns {Array} Returns the array of property names and symbols.
 */ function $cf47ca2fc3f4de6e$var$baseGetAllKeys(object, keysFunc, symbolsFunc) {
    var result = keysFunc(object);
    return (0, $hf0C9.default)(object) ? result : (0, $6JPqi.default)(result, symbolsFunc(object));
}
var $cf47ca2fc3f4de6e$export$2e2bcd8739ae039 = $cf47ca2fc3f4de6e$var$baseGetAllKeys;

});


parcelRegister("7bulh", function(module, exports) {

$parcel$export(module.exports, "default", () => $53b118d05aedad9a$export$2e2bcd8739ae039);

var $hNlD0 = parcelRequire("hNlD0");

var $hDzVK = parcelRequire("hDzVK");

var $ceNjR = parcelRequire("ceNjR");
/**
 * Creates an array of own and inherited enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */ function $53b118d05aedad9a$var$getAllKeysIn(object) {
    return (0, $hNlD0.default)(object, (0, $ceNjR.default), (0, $hDzVK.default));
}
var $53b118d05aedad9a$export$2e2bcd8739ae039 = $53b118d05aedad9a$var$getAllKeysIn;

});

parcelRegister("4wkSQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $34aa59a61c7ccccb$export$2e2bcd8739ae039);

var $dR5x6 = parcelRequire("dR5x6");

var $fs3H6 = parcelRequire("fs3H6");

var $ab1Hq = parcelRequire("ab1Hq");

var $iypSL = parcelRequire("iypSL");

var $1xFLT = parcelRequire("1xFLT");

var $hArsG = parcelRequire("hArsG");

var $5bfPQ = parcelRequire("5bfPQ");
/** `Object#toString` result references. */ var $34aa59a61c7ccccb$var$mapTag = "[object Map]", $34aa59a61c7ccccb$var$objectTag = "[object Object]", $34aa59a61c7ccccb$var$promiseTag = "[object Promise]", $34aa59a61c7ccccb$var$setTag = "[object Set]", $34aa59a61c7ccccb$var$weakMapTag = "[object WeakMap]";
var $34aa59a61c7ccccb$var$dataViewTag = "[object DataView]";
/** Used to detect maps, sets, and weakmaps. */ var $34aa59a61c7ccccb$var$dataViewCtorString = (0, $5bfPQ.default)((0, $dR5x6.default)), $34aa59a61c7ccccb$var$mapCtorString = (0, $5bfPQ.default)((0, $fs3H6.default)), $34aa59a61c7ccccb$var$promiseCtorString = (0, $5bfPQ.default)((0, $ab1Hq.default)), $34aa59a61c7ccccb$var$setCtorString = (0, $5bfPQ.default)((0, $iypSL.default)), $34aa59a61c7ccccb$var$weakMapCtorString = (0, $5bfPQ.default)((0, $1xFLT.default));
/**
 * Gets the `toStringTag` of `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */ var $34aa59a61c7ccccb$var$getTag = (0, $hArsG.default);
// Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
if ((0, $dR5x6.default) && $34aa59a61c7ccccb$var$getTag(new (0, $dR5x6.default)(new ArrayBuffer(1))) != $34aa59a61c7ccccb$var$dataViewTag || (0, $fs3H6.default) && $34aa59a61c7ccccb$var$getTag(new (0, $fs3H6.default)) != $34aa59a61c7ccccb$var$mapTag || (0, $ab1Hq.default) && $34aa59a61c7ccccb$var$getTag((0, $ab1Hq.default).resolve()) != $34aa59a61c7ccccb$var$promiseTag || (0, $iypSL.default) && $34aa59a61c7ccccb$var$getTag(new (0, $iypSL.default)) != $34aa59a61c7ccccb$var$setTag || (0, $1xFLT.default) && $34aa59a61c7ccccb$var$getTag(new (0, $1xFLT.default)) != $34aa59a61c7ccccb$var$weakMapTag) $34aa59a61c7ccccb$var$getTag = function(value) {
    var result = (0, $hArsG.default)(value), Ctor = result == $34aa59a61c7ccccb$var$objectTag ? value.constructor : undefined, ctorString = Ctor ? (0, $5bfPQ.default)(Ctor) : "";
    if (ctorString) switch(ctorString){
        case $34aa59a61c7ccccb$var$dataViewCtorString:
            return $34aa59a61c7ccccb$var$dataViewTag;
        case $34aa59a61c7ccccb$var$mapCtorString:
            return $34aa59a61c7ccccb$var$mapTag;
        case $34aa59a61c7ccccb$var$promiseCtorString:
            return $34aa59a61c7ccccb$var$promiseTag;
        case $34aa59a61c7ccccb$var$setCtorString:
            return $34aa59a61c7ccccb$var$setTag;
        case $34aa59a61c7ccccb$var$weakMapCtorString:
            return $34aa59a61c7ccccb$var$weakMapTag;
    }
    return result;
};
var $34aa59a61c7ccccb$export$2e2bcd8739ae039 = $34aa59a61c7ccccb$var$getTag;

});
parcelRegister("dR5x6", function(module, exports) {

$parcel$export(module.exports, "default", () => $a1648453896f67d2$export$2e2bcd8739ae039);

var $jLT9P = parcelRequire("jLT9P");

var $2mpFt = parcelRequire("2mpFt");
/* Built-in method references that are verified to be native. */ var $a1648453896f67d2$var$DataView = (0, $jLT9P.default)((0, $2mpFt.default), "DataView");
var $a1648453896f67d2$export$2e2bcd8739ae039 = $a1648453896f67d2$var$DataView;

});

parcelRegister("ab1Hq", function(module, exports) {

$parcel$export(module.exports, "default", () => $768c3ff3ee4df356$export$2e2bcd8739ae039);

var $jLT9P = parcelRequire("jLT9P");

var $2mpFt = parcelRequire("2mpFt");
/* Built-in method references that are verified to be native. */ var $768c3ff3ee4df356$var$Promise = (0, $jLT9P.default)((0, $2mpFt.default), "Promise");
var $768c3ff3ee4df356$export$2e2bcd8739ae039 = $768c3ff3ee4df356$var$Promise;

});

parcelRegister("iypSL", function(module, exports) {

$parcel$export(module.exports, "default", () => $d81f7aa452e6e637$export$2e2bcd8739ae039);

var $jLT9P = parcelRequire("jLT9P");

var $2mpFt = parcelRequire("2mpFt");
/* Built-in method references that are verified to be native. */ var $d81f7aa452e6e637$var$Set = (0, $jLT9P.default)((0, $2mpFt.default), "Set");
var $d81f7aa452e6e637$export$2e2bcd8739ae039 = $d81f7aa452e6e637$var$Set;

});

parcelRegister("1xFLT", function(module, exports) {

$parcel$export(module.exports, "default", () => $11f94673ff7d99d8$export$2e2bcd8739ae039);

var $jLT9P = parcelRequire("jLT9P");

var $2mpFt = parcelRequire("2mpFt");
/* Built-in method references that are verified to be native. */ var $11f94673ff7d99d8$var$WeakMap = (0, $jLT9P.default)((0, $2mpFt.default), "WeakMap");
var $11f94673ff7d99d8$export$2e2bcd8739ae039 = $11f94673ff7d99d8$var$WeakMap;

});


parcelRegister("9HyGp", function(module, exports) {

$parcel$export(module.exports, "default", () => $7103088c29fc4f0b$export$2e2bcd8739ae039);
/** Used for built-in method references. */ var $7103088c29fc4f0b$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $7103088c29fc4f0b$var$hasOwnProperty = $7103088c29fc4f0b$var$objectProto.hasOwnProperty;
/**
 * Initializes an array clone.
 *
 * @private
 * @param {Array} array The array to clone.
 * @returns {Array} Returns the initialized clone.
 */ function $7103088c29fc4f0b$var$initCloneArray(array) {
    var length = array.length, result = new array.constructor(length);
    // Add properties assigned by `RegExp#exec`.
    if (length && typeof array[0] == "string" && $7103088c29fc4f0b$var$hasOwnProperty.call(array, "index")) {
        result.index = array.index;
        result.input = array.input;
    }
    return result;
}
var $7103088c29fc4f0b$export$2e2bcd8739ae039 = $7103088c29fc4f0b$var$initCloneArray;

});

parcelRegister("iBTyS", function(module, exports) {

$parcel$export(module.exports, "default", () => $d8c6c80dd3650253$export$2e2bcd8739ae039);

var $9tz5c = parcelRequire("9tz5c");

var $9sDYA = parcelRequire("9sDYA");

var $g8BP3 = parcelRequire("g8BP3");

var $lcI69 = parcelRequire("lcI69");

var $40E9j = parcelRequire("40E9j");
/** `Object#toString` result references. */ var $d8c6c80dd3650253$var$boolTag = "[object Boolean]", $d8c6c80dd3650253$var$dateTag = "[object Date]", $d8c6c80dd3650253$var$mapTag = "[object Map]", $d8c6c80dd3650253$var$numberTag = "[object Number]", $d8c6c80dd3650253$var$regexpTag = "[object RegExp]", $d8c6c80dd3650253$var$setTag = "[object Set]", $d8c6c80dd3650253$var$stringTag = "[object String]", $d8c6c80dd3650253$var$symbolTag = "[object Symbol]";
var $d8c6c80dd3650253$var$arrayBufferTag = "[object ArrayBuffer]", $d8c6c80dd3650253$var$dataViewTag = "[object DataView]", $d8c6c80dd3650253$var$float32Tag = "[object Float32Array]", $d8c6c80dd3650253$var$float64Tag = "[object Float64Array]", $d8c6c80dd3650253$var$int8Tag = "[object Int8Array]", $d8c6c80dd3650253$var$int16Tag = "[object Int16Array]", $d8c6c80dd3650253$var$int32Tag = "[object Int32Array]", $d8c6c80dd3650253$var$uint8Tag = "[object Uint8Array]", $d8c6c80dd3650253$var$uint8ClampedTag = "[object Uint8ClampedArray]", $d8c6c80dd3650253$var$uint16Tag = "[object Uint16Array]", $d8c6c80dd3650253$var$uint32Tag = "[object Uint32Array]";
/**
 * Initializes an object clone based on its `toStringTag`.
 *
 * **Note:** This function only supports cloning values with tags of
 * `Boolean`, `Date`, `Error`, `Map`, `Number`, `RegExp`, `Set`, or `String`.
 *
 * @private
 * @param {Object} object The object to clone.
 * @param {string} tag The `toStringTag` of the object to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the initialized clone.
 */ function $d8c6c80dd3650253$var$initCloneByTag(object, tag, isDeep) {
    var Ctor = object.constructor;
    switch(tag){
        case $d8c6c80dd3650253$var$arrayBufferTag:
            return (0, $9tz5c.default)(object);
        case $d8c6c80dd3650253$var$boolTag:
        case $d8c6c80dd3650253$var$dateTag:
            return new Ctor(+object);
        case $d8c6c80dd3650253$var$dataViewTag:
            return (0, $9sDYA.default)(object, isDeep);
        case $d8c6c80dd3650253$var$float32Tag:
        case $d8c6c80dd3650253$var$float64Tag:
        case $d8c6c80dd3650253$var$int8Tag:
        case $d8c6c80dd3650253$var$int16Tag:
        case $d8c6c80dd3650253$var$int32Tag:
        case $d8c6c80dd3650253$var$uint8Tag:
        case $d8c6c80dd3650253$var$uint8ClampedTag:
        case $d8c6c80dd3650253$var$uint16Tag:
        case $d8c6c80dd3650253$var$uint32Tag:
            return (0, $40E9j.default)(object, isDeep);
        case $d8c6c80dd3650253$var$mapTag:
            return new Ctor;
        case $d8c6c80dd3650253$var$numberTag:
        case $d8c6c80dd3650253$var$stringTag:
            return new Ctor(object);
        case $d8c6c80dd3650253$var$regexpTag:
            return (0, $g8BP3.default)(object);
        case $d8c6c80dd3650253$var$setTag:
            return new Ctor;
        case $d8c6c80dd3650253$var$symbolTag:
            return (0, $lcI69.default)(object);
    }
}
var $d8c6c80dd3650253$export$2e2bcd8739ae039 = $d8c6c80dd3650253$var$initCloneByTag;

});
parcelRegister("9tz5c", function(module, exports) {

$parcel$export(module.exports, "default", () => $6e620930bc6a5ada$export$2e2bcd8739ae039);

var $dJVnF = parcelRequire("dJVnF");
/**
 * Creates a clone of `arrayBuffer`.
 *
 * @private
 * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
 * @returns {ArrayBuffer} Returns the cloned array buffer.
 */ function $6e620930bc6a5ada$var$cloneArrayBuffer(arrayBuffer) {
    var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
    new (0, $dJVnF.default)(result).set(new (0, $dJVnF.default)(arrayBuffer));
    return result;
}
var $6e620930bc6a5ada$export$2e2bcd8739ae039 = $6e620930bc6a5ada$var$cloneArrayBuffer;

});
parcelRegister("dJVnF", function(module, exports) {

$parcel$export(module.exports, "default", () => $a00bfcf041d47533$export$2e2bcd8739ae039);

var $2mpFt = parcelRequire("2mpFt");
/** Built-in value references. */ var $a00bfcf041d47533$var$Uint8Array = (0, $2mpFt.default).Uint8Array;
var $a00bfcf041d47533$export$2e2bcd8739ae039 = $a00bfcf041d47533$var$Uint8Array;

});


parcelRegister("9sDYA", function(module, exports) {

$parcel$export(module.exports, "default", () => $6e35bd0ad6403ada$export$2e2bcd8739ae039);

var $9tz5c = parcelRequire("9tz5c");
/**
 * Creates a clone of `dataView`.
 *
 * @private
 * @param {Object} dataView The data view to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned data view.
 */ function $6e35bd0ad6403ada$var$cloneDataView(dataView, isDeep) {
    var buffer = isDeep ? (0, $9tz5c.default)(dataView.buffer) : dataView.buffer;
    return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
}
var $6e35bd0ad6403ada$export$2e2bcd8739ae039 = $6e35bd0ad6403ada$var$cloneDataView;

});

parcelRegister("g8BP3", function(module, exports) {

$parcel$export(module.exports, "default", () => $bbfabb74c4bdb037$export$2e2bcd8739ae039);
/** Used to match `RegExp` flags from their coerced string values. */ var $bbfabb74c4bdb037$var$reFlags = /\w*$/;
/**
 * Creates a clone of `regexp`.
 *
 * @private
 * @param {Object} regexp The regexp to clone.
 * @returns {Object} Returns the cloned regexp.
 */ function $bbfabb74c4bdb037$var$cloneRegExp(regexp) {
    var result = new regexp.constructor(regexp.source, $bbfabb74c4bdb037$var$reFlags.exec(regexp));
    result.lastIndex = regexp.lastIndex;
    return result;
}
var $bbfabb74c4bdb037$export$2e2bcd8739ae039 = $bbfabb74c4bdb037$var$cloneRegExp;

});

parcelRegister("lcI69", function(module, exports) {

$parcel$export(module.exports, "default", () => $f6fcecf8c6eee3b2$export$2e2bcd8739ae039);

var $kRxPv = parcelRequire("kRxPv");
/** Used to convert symbols to primitives and strings. */ var $f6fcecf8c6eee3b2$var$symbolProto = (0, $kRxPv.default) ? (0, $kRxPv.default).prototype : undefined, $f6fcecf8c6eee3b2$var$symbolValueOf = $f6fcecf8c6eee3b2$var$symbolProto ? $f6fcecf8c6eee3b2$var$symbolProto.valueOf : undefined;
/**
 * Creates a clone of the `symbol` object.
 *
 * @private
 * @param {Object} symbol The symbol object to clone.
 * @returns {Object} Returns the cloned symbol object.
 */ function $f6fcecf8c6eee3b2$var$cloneSymbol(symbol) {
    return $f6fcecf8c6eee3b2$var$symbolValueOf ? Object($f6fcecf8c6eee3b2$var$symbolValueOf.call(symbol)) : {};
}
var $f6fcecf8c6eee3b2$export$2e2bcd8739ae039 = $f6fcecf8c6eee3b2$var$cloneSymbol;

});

parcelRegister("40E9j", function(module, exports) {

$parcel$export(module.exports, "default", () => $2eb64e5339c21018$export$2e2bcd8739ae039);

var $9tz5c = parcelRequire("9tz5c");
/**
 * Creates a clone of `typedArray`.
 *
 * @private
 * @param {Object} typedArray The typed array to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned typed array.
 */ function $2eb64e5339c21018$var$cloneTypedArray(typedArray, isDeep) {
    var buffer = isDeep ? (0, $9tz5c.default)(typedArray.buffer) : typedArray.buffer;
    return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
}
var $2eb64e5339c21018$export$2e2bcd8739ae039 = $2eb64e5339c21018$var$cloneTypedArray;

});


parcelRegister("7lgl7", function(module, exports) {

$parcel$export(module.exports, "default", () => $55872b451e11a8ad$export$2e2bcd8739ae039);

var $kgBRQ = parcelRequire("kgBRQ");

var $bzIQZ = parcelRequire("bzIQZ");

var $74QAJ = parcelRequire("74QAJ");
/**
 * Initializes an object clone.
 *
 * @private
 * @param {Object} object The object to clone.
 * @returns {Object} Returns the initialized clone.
 */ function $55872b451e11a8ad$var$initCloneObject(object) {
    return typeof object.constructor == "function" && !(0, $74QAJ.default)(object) ? (0, $kgBRQ.default)((0, $bzIQZ.default)(object)) : {};
}
var $55872b451e11a8ad$export$2e2bcd8739ae039 = $55872b451e11a8ad$var$initCloneObject;

});
parcelRegister("kgBRQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $ec12acf7896f0d70$export$2e2bcd8739ae039);

var $iYDsF = parcelRequire("iYDsF");
/** Built-in value references. */ var $ec12acf7896f0d70$var$objectCreate = Object.create;
/**
 * The base implementation of `_.create` without support for assigning
 * properties to the created object.
 *
 * @private
 * @param {Object} proto The object to inherit from.
 * @returns {Object} Returns the new object.
 */ var $ec12acf7896f0d70$var$baseCreate = function() {
    function object() {}
    return function(proto) {
        if (!(0, $iYDsF.default)(proto)) return {};
        if ($ec12acf7896f0d70$var$objectCreate) return $ec12acf7896f0d70$var$objectCreate(proto);
        object.prototype = proto;
        var result = new object;
        object.prototype = undefined;
        return result;
    };
}();
var $ec12acf7896f0d70$export$2e2bcd8739ae039 = $ec12acf7896f0d70$var$baseCreate;

});


parcelRegister("5HFwJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $42712e4fe0b60e59$export$2e2bcd8739ae039);

var $dp7sl = parcelRequire("dp7sl");

var $hb0cD = parcelRequire("hb0cD");

var $lFXqE = parcelRequire("lFXqE");
/* Node.js helper references. */ var $42712e4fe0b60e59$var$nodeIsMap = (0, $lFXqE.default) && (0, $lFXqE.default).isMap;
/**
 * Checks if `value` is classified as a `Map` object.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a map, else `false`.
 * @example
 *
 * _.isMap(new Map);
 * // => true
 *
 * _.isMap(new WeakMap);
 * // => false
 */ var $42712e4fe0b60e59$var$isMap = $42712e4fe0b60e59$var$nodeIsMap ? (0, $hb0cD.default)($42712e4fe0b60e59$var$nodeIsMap) : (0, $dp7sl.default);
var $42712e4fe0b60e59$export$2e2bcd8739ae039 = $42712e4fe0b60e59$var$isMap;

});
parcelRegister("dp7sl", function(module, exports) {

$parcel$export(module.exports, "default", () => $9c2364d1ace94eb9$export$2e2bcd8739ae039);

var $4wkSQ = parcelRequire("4wkSQ");

var $f2iog = parcelRequire("f2iog");
/** `Object#toString` result references. */ var $9c2364d1ace94eb9$var$mapTag = "[object Map]";
/**
 * The base implementation of `_.isMap` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a map, else `false`.
 */ function $9c2364d1ace94eb9$var$baseIsMap(value) {
    return (0, $f2iog.default)(value) && (0, $4wkSQ.default)(value) == $9c2364d1ace94eb9$var$mapTag;
}
var $9c2364d1ace94eb9$export$2e2bcd8739ae039 = $9c2364d1ace94eb9$var$baseIsMap;

});


parcelRegister("4X3Cn", function(module, exports) {

$parcel$export(module.exports, "default", () => $39af7a8fe30b5013$export$2e2bcd8739ae039);

var $4Mn6B = parcelRequire("4Mn6B");

var $hb0cD = parcelRequire("hb0cD");

var $lFXqE = parcelRequire("lFXqE");
/* Node.js helper references. */ var $39af7a8fe30b5013$var$nodeIsSet = (0, $lFXqE.default) && (0, $lFXqE.default).isSet;
/**
 * Checks if `value` is classified as a `Set` object.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a set, else `false`.
 * @example
 *
 * _.isSet(new Set);
 * // => true
 *
 * _.isSet(new WeakSet);
 * // => false
 */ var $39af7a8fe30b5013$var$isSet = $39af7a8fe30b5013$var$nodeIsSet ? (0, $hb0cD.default)($39af7a8fe30b5013$var$nodeIsSet) : (0, $4Mn6B.default);
var $39af7a8fe30b5013$export$2e2bcd8739ae039 = $39af7a8fe30b5013$var$isSet;

});
parcelRegister("4Mn6B", function(module, exports) {

$parcel$export(module.exports, "default", () => $37ad91635d9ff11e$export$2e2bcd8739ae039);

var $4wkSQ = parcelRequire("4wkSQ");

var $f2iog = parcelRequire("f2iog");
/** `Object#toString` result references. */ var $37ad91635d9ff11e$var$setTag = "[object Set]";
/**
 * The base implementation of `_.isSet` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a set, else `false`.
 */ function $37ad91635d9ff11e$var$baseIsSet(value) {
    return (0, $f2iog.default)(value) && (0, $4wkSQ.default)(value) == $37ad91635d9ff11e$var$setTag;
}
var $37ad91635d9ff11e$export$2e2bcd8739ae039 = $37ad91635d9ff11e$var$baseIsSet;

});




parcelRegister("58lCa", function(module, exports) {

$parcel$export(module.exports, "default", () => $3bce775629368657$export$2e2bcd8739ae039);

var $afgje = parcelRequire("afgje");

var $jXStN = parcelRequire("jXStN");

var $hf0C9 = parcelRequire("hf0C9");

var $1WN0o = parcelRequire("1WN0o");

var $6D9Aa = parcelRequire("6D9Aa");

var $ft2bY = parcelRequire("ft2bY");

var $1fnxW = parcelRequire("1fnxW");
/**
 * Converts `value` to a property path array.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Util
 * @param {*} value The value to convert.
 * @returns {Array} Returns the new property path array.
 * @example
 *
 * _.toPath('a.b.c');
 * // => ['a', 'b', 'c']
 *
 * _.toPath('a[0].b.c');
 * // => ['a', '0', 'b', 'c']
 */ function $3bce775629368657$var$toPath(value) {
    if ((0, $hf0C9.default)(value)) return (0, $afgje.default)(value, (0, $ft2bY.default));
    return (0, $1WN0o.default)(value) ? [
        value
    ] : (0, $jXStN.default)((0, $6D9Aa.default)((0, $1fnxW.default)(value)));
}
var $3bce775629368657$export$2e2bcd8739ae039 = $3bce775629368657$var$toPath;

});
parcelRegister("afgje", function(module, exports) {

$parcel$export(module.exports, "default", () => $7757f4c9b8d2d7a9$export$2e2bcd8739ae039);
/**
 * A specialized version of `_.map` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */ function $7757f4c9b8d2d7a9$var$arrayMap(array, iteratee) {
    var index = -1, length = array == null ? 0 : array.length, result = Array(length);
    while(++index < length)result[index] = iteratee(array[index], index, array);
    return result;
}
var $7757f4c9b8d2d7a9$export$2e2bcd8739ae039 = $7757f4c9b8d2d7a9$var$arrayMap;

});

parcelRegister("1WN0o", function(module, exports) {

$parcel$export(module.exports, "default", () => $16b138b0231026b6$export$2e2bcd8739ae039);

var $hArsG = parcelRequire("hArsG");

var $f2iog = parcelRequire("f2iog");
/** `Object#toString` result references. */ var $16b138b0231026b6$var$symbolTag = "[object Symbol]";
/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */ function $16b138b0231026b6$var$isSymbol(value) {
    return typeof value == "symbol" || (0, $f2iog.default)(value) && (0, $hArsG.default)(value) == $16b138b0231026b6$var$symbolTag;
}
var $16b138b0231026b6$export$2e2bcd8739ae039 = $16b138b0231026b6$var$isSymbol;

});

parcelRegister("6D9Aa", function(module, exports) {

$parcel$export(module.exports, "default", () => $4d3dd1738f3a2bd9$export$2e2bcd8739ae039);

var $bOE4H = parcelRequire("bOE4H");
/** Used to match property names within property paths. */ var $4d3dd1738f3a2bd9$var$rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;
/** Used to match backslashes in property paths. */ var $4d3dd1738f3a2bd9$var$reEscapeChar = /\\(\\)?/g;
/**
 * Converts `string` to a property path array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the property path array.
 */ var $4d3dd1738f3a2bd9$var$stringToPath = (0, $bOE4H.default)(function(string) {
    var result = [];
    if (string.charCodeAt(0) === 46 /* . */ ) result.push("");
    string.replace($4d3dd1738f3a2bd9$var$rePropName, function(match, number, quote, subString) {
        result.push(quote ? subString.replace($4d3dd1738f3a2bd9$var$reEscapeChar, "$1") : number || match);
    });
    return result;
});
var $4d3dd1738f3a2bd9$export$2e2bcd8739ae039 = $4d3dd1738f3a2bd9$var$stringToPath;

});
parcelRegister("bOE4H", function(module, exports) {

$parcel$export(module.exports, "default", () => $89a3733fc9405b69$export$2e2bcd8739ae039);

var $e21Zk = parcelRequire("e21Zk");
/** Used as the maximum memoize cache size. */ var $89a3733fc9405b69$var$MAX_MEMOIZE_SIZE = 500;
/**
 * A specialized version of `_.memoize` which clears the memoized function's
 * cache when it exceeds `MAX_MEMOIZE_SIZE`.
 *
 * @private
 * @param {Function} func The function to have its output memoized.
 * @returns {Function} Returns the new memoized function.
 */ function $89a3733fc9405b69$var$memoizeCapped(func) {
    var result = (0, $e21Zk.default)(func, function(key) {
        if (cache.size === $89a3733fc9405b69$var$MAX_MEMOIZE_SIZE) cache.clear();
        return key;
    });
    var cache = result.cache;
    return result;
}
var $89a3733fc9405b69$export$2e2bcd8739ae039 = $89a3733fc9405b69$var$memoizeCapped;

});
parcelRegister("e21Zk", function(module, exports) {

$parcel$export(module.exports, "default", () => $a372cb680e5e1128$export$2e2bcd8739ae039);

var $7n3PR = parcelRequire("7n3PR");
/** Error message constants. */ var $a372cb680e5e1128$var$FUNC_ERROR_TEXT = "Expected a function";
/**
 * Creates a function that memoizes the result of `func`. If `resolver` is
 * provided, it determines the cache key for storing the result based on the
 * arguments provided to the memoized function. By default, the first argument
 * provided to the memoized function is used as the map cache key. The `func`
 * is invoked with the `this` binding of the memoized function.
 *
 * **Note:** The cache is exposed as the `cache` property on the memoized
 * function. Its creation may be customized by replacing the `_.memoize.Cache`
 * constructor with one whose instances implement the
 * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
 * method interface of `clear`, `delete`, `get`, `has`, and `set`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to have its output memoized.
 * @param {Function} [resolver] The function to resolve the cache key.
 * @returns {Function} Returns the new memoized function.
 * @example
 *
 * var object = { 'a': 1, 'b': 2 };
 * var other = { 'c': 3, 'd': 4 };
 *
 * var values = _.memoize(_.values);
 * values(object);
 * // => [1, 2]
 *
 * values(other);
 * // => [3, 4]
 *
 * object.a = 2;
 * values(object);
 * // => [1, 2]
 *
 * // Modify the result cache.
 * values.cache.set(object, ['a', 'b']);
 * values(object);
 * // => ['a', 'b']
 *
 * // Replace `_.memoize.Cache`.
 * _.memoize.Cache = WeakMap;
 */ function $a372cb680e5e1128$var$memoize(func, resolver) {
    if (typeof func != "function" || resolver != null && typeof resolver != "function") throw new TypeError($a372cb680e5e1128$var$FUNC_ERROR_TEXT);
    var memoized = function() {
        var args = arguments, key = resolver ? resolver.apply(this, args) : args[0], cache = memoized.cache;
        if (cache.has(key)) return cache.get(key);
        var result = func.apply(this, args);
        memoized.cache = cache.set(key, result) || cache;
        return result;
    };
    memoized.cache = new ($a372cb680e5e1128$var$memoize.Cache || (0, $7n3PR.default));
    return memoized;
}
// Expose `MapCache`.
$a372cb680e5e1128$var$memoize.Cache = (0, $7n3PR.default);
var $a372cb680e5e1128$export$2e2bcd8739ae039 = $a372cb680e5e1128$var$memoize;

});



parcelRegister("ft2bY", function(module, exports) {

$parcel$export(module.exports, "default", () => $b42b43c5a84e61a9$export$2e2bcd8739ae039);

var $1WN0o = parcelRequire("1WN0o");
/** Used as references for various `Number` constants. */ var $b42b43c5a84e61a9$var$INFINITY = 1 / 0;
/**
 * Converts `value` to a string key if it's not a string or symbol.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {string|symbol} Returns the key.
 */ function $b42b43c5a84e61a9$var$toKey(value) {
    if (typeof value == "string" || (0, $1WN0o.default)(value)) return value;
    var result = value + "";
    return result == "0" && 1 / value == -$b42b43c5a84e61a9$var$INFINITY ? "-0" : result;
}
var $b42b43c5a84e61a9$export$2e2bcd8739ae039 = $b42b43c5a84e61a9$var$toKey;

});

parcelRegister("1fnxW", function(module, exports) {

$parcel$export(module.exports, "default", () => $0e8974ff738aca49$export$2e2bcd8739ae039);

var $5sJxm = parcelRequire("5sJxm");
/**
 * Converts `value` to a string. An empty string is returned for `null`
 * and `undefined` values. The sign of `-0` is preserved.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 * @example
 *
 * _.toString(null);
 * // => ''
 *
 * _.toString(-0);
 * // => '-0'
 *
 * _.toString([1, 2, 3]);
 * // => '1,2,3'
 */ function $0e8974ff738aca49$var$toString(value) {
    return value == null ? "" : (0, $5sJxm.default)(value);
}
var $0e8974ff738aca49$export$2e2bcd8739ae039 = $0e8974ff738aca49$var$toString;

});
parcelRegister("5sJxm", function(module, exports) {

$parcel$export(module.exports, "default", () => $3fa2e3fba0ff938d$export$2e2bcd8739ae039);

var $kRxPv = parcelRequire("kRxPv");

var $afgje = parcelRequire("afgje");

var $hf0C9 = parcelRequire("hf0C9");

var $1WN0o = parcelRequire("1WN0o");
/** Used as references for various `Number` constants. */ var $3fa2e3fba0ff938d$var$INFINITY = 1 / 0;
/** Used to convert symbols to primitives and strings. */ var $3fa2e3fba0ff938d$var$symbolProto = (0, $kRxPv.default) ? (0, $kRxPv.default).prototype : undefined, $3fa2e3fba0ff938d$var$symbolToString = $3fa2e3fba0ff938d$var$symbolProto ? $3fa2e3fba0ff938d$var$symbolProto.toString : undefined;
/**
 * The base implementation of `_.toString` which doesn't convert nullish
 * values to empty strings.
 *
 * @private
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 */ function $3fa2e3fba0ff938d$var$baseToString(value) {
    // Exit early for strings to avoid a performance hit in some environments.
    if (typeof value == "string") return value;
    if ((0, $hf0C9.default)(value)) // Recursively convert values (susceptible to call stack limits).
    return (0, $afgje.default)(value, $3fa2e3fba0ff938d$var$baseToString) + "";
    if ((0, $1WN0o.default)(value)) return $3fa2e3fba0ff938d$var$symbolToString ? $3fa2e3fba0ff938d$var$symbolToString.call(value) : "";
    var result = value + "";
    return result == "0" && 1 / value == -$3fa2e3fba0ff938d$var$INFINITY ? "-0" : result;
}
var $3fa2e3fba0ff938d$export$2e2bcd8739ae039 = $3fa2e3fba0ff938d$var$baseToString;

});



parcelRegister("9ORqK", function(module, exports) {
"use strict";

var $4jPKB = parcelRequire("4jPKB");
/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */ var $72623ab6bcb0a33b$var$REACT_STATICS = {
    childContextTypes: true,
    contextType: true,
    contextTypes: true,
    defaultProps: true,
    displayName: true,
    getDefaultProps: true,
    getDerivedStateFromError: true,
    getDerivedStateFromProps: true,
    mixins: true,
    propTypes: true,
    type: true
};
var $72623ab6bcb0a33b$var$KNOWN_STATICS = {
    name: true,
    length: true,
    prototype: true,
    caller: true,
    callee: true,
    arguments: true,
    arity: true
};
var $72623ab6bcb0a33b$var$FORWARD_REF_STATICS = {
    "$$typeof": true,
    render: true,
    defaultProps: true,
    displayName: true,
    propTypes: true
};
var $72623ab6bcb0a33b$var$MEMO_STATICS = {
    "$$typeof": true,
    compare: true,
    defaultProps: true,
    displayName: true,
    propTypes: true,
    type: true
};
var $72623ab6bcb0a33b$var$TYPE_STATICS = {};
$72623ab6bcb0a33b$var$TYPE_STATICS[$4jPKB.ForwardRef] = $72623ab6bcb0a33b$var$FORWARD_REF_STATICS;
$72623ab6bcb0a33b$var$TYPE_STATICS[$4jPKB.Memo] = $72623ab6bcb0a33b$var$MEMO_STATICS;
function $72623ab6bcb0a33b$var$getStatics(component) {
    // React v16.11 and below
    if ($4jPKB.isMemo(component)) return $72623ab6bcb0a33b$var$MEMO_STATICS;
     // React v16.12 and above
    return $72623ab6bcb0a33b$var$TYPE_STATICS[component["$$typeof"]] || $72623ab6bcb0a33b$var$REACT_STATICS;
}
var $72623ab6bcb0a33b$var$defineProperty = Object.defineProperty;
var $72623ab6bcb0a33b$var$getOwnPropertyNames = Object.getOwnPropertyNames;
var $72623ab6bcb0a33b$var$getOwnPropertySymbols = Object.getOwnPropertySymbols;
var $72623ab6bcb0a33b$var$getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var $72623ab6bcb0a33b$var$getPrototypeOf = Object.getPrototypeOf;
var $72623ab6bcb0a33b$var$objectPrototype = Object.prototype;
function $72623ab6bcb0a33b$var$hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
    if (typeof sourceComponent !== "string") {
        // don't hoist over string (html) components
        if ($72623ab6bcb0a33b$var$objectPrototype) {
            var inheritedComponent = $72623ab6bcb0a33b$var$getPrototypeOf(sourceComponent);
            if (inheritedComponent && inheritedComponent !== $72623ab6bcb0a33b$var$objectPrototype) $72623ab6bcb0a33b$var$hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
        }
        var keys = $72623ab6bcb0a33b$var$getOwnPropertyNames(sourceComponent);
        if ($72623ab6bcb0a33b$var$getOwnPropertySymbols) keys = keys.concat($72623ab6bcb0a33b$var$getOwnPropertySymbols(sourceComponent));
        var targetStatics = $72623ab6bcb0a33b$var$getStatics(targetComponent);
        var sourceStatics = $72623ab6bcb0a33b$var$getStatics(sourceComponent);
        for(var i = 0; i < keys.length; ++i){
            var key = keys[i];
            if (!$72623ab6bcb0a33b$var$KNOWN_STATICS[key] && !(blacklist && blacklist[key]) && !(sourceStatics && sourceStatics[key]) && !(targetStatics && targetStatics[key])) {
                var descriptor = $72623ab6bcb0a33b$var$getOwnPropertyDescriptor(sourceComponent, key);
                try {
                    // Avoid failures from read-only properties
                    $72623ab6bcb0a33b$var$defineProperty(targetComponent, key, descriptor);
                } catch (e) {}
            }
        }
    }
    return targetComponent;
}
module.exports = $72623ab6bcb0a33b$var$hoistNonReactStatics;

});

parcelRegister("chB0Q", function(module, exports) {

$parcel$export(module.exports, "default", () => $8f13c87c1500733f$export$2e2bcd8739ae039);

var $gbpSA = parcelRequire("gbpSA");
/** Used to compose bitmasks for cloning. */ var $8f13c87c1500733f$var$CLONE_DEEP_FLAG = 1, $8f13c87c1500733f$var$CLONE_SYMBOLS_FLAG = 4;
/**
 * This method is like `_.clone` except that it recursively clones `value`.
 *
 * @static
 * @memberOf _
 * @since 1.0.0
 * @category Lang
 * @param {*} value The value to recursively clone.
 * @returns {*} Returns the deep cloned value.
 * @see _.clone
 * @example
 *
 * var objects = [{ 'a': 1 }, { 'b': 2 }];
 *
 * var deep = _.cloneDeep(objects);
 * console.log(deep[0] === objects[0]);
 * // => false
 */ function $8f13c87c1500733f$var$cloneDeep(value) {
    return (0, $gbpSA.default)(value, $8f13c87c1500733f$var$CLONE_DEEP_FLAG | $8f13c87c1500733f$var$CLONE_SYMBOLS_FLAG);
}
var $8f13c87c1500733f$export$2e2bcd8739ae039 = $8f13c87c1500733f$var$cloneDeep;

});


parcelRegister("cKmnI", function(module, exports) {
module.exports = new URL("all-jobs.1ca69b21.svg", import.meta.url).toString();

});

parcelRegister("8vIg3", function(module, exports) {
module.exports = new URL("applicants-review.0ffcece4.svg", import.meta.url).toString();

});

parcelRegister("gBUUB", function(module, exports) {
module.exports = new URL("attendance-review.1ca69b21.svg", import.meta.url).toString();

});

parcelRegister("jZLRF", function(module, exports) {
module.exports = new URL("home.4dcd022b.svg", import.meta.url).toString();

});

parcelRegister("6Q2tT", function(module, exports) {
module.exports = new URL("manage-locations.9a847da6.svg", import.meta.url).toString();

});

parcelRegister("dy8LX", function(module, exports) {
module.exports = new URL("register-corporate.f20ae9ba.svg", import.meta.url).toString();

});

parcelRegister("hjM4b", function(module, exports) {
module.exports = new URL("users.8a53f447.svg", import.meta.url).toString();

});

parcelRegister("gUHwc", function(module, exports) {
module.exports = new URL("orders.49dd9f62.svg", import.meta.url).toString();

});

parcelRegister("9zBTl", function(module, exports) {
module.exports = new URL("active.6f32920a.svg", import.meta.url).toString();

});

parcelRegister("jCzbX", function(module, exports) {
module.exports = new URL("all.46fa9702.svg", import.meta.url).toString();

});

parcelRegister("6LaZs", function(module, exports) {
module.exports = new URL("close-sidebar.64f427af.svg", import.meta.url).toString();

});

parcelRegister("kMouu", function(module, exports) {
module.exports = new URL("drafts.baca9d50.svg", import.meta.url).toString();

});

parcelRegister("dtbix", function(module, exports) {
module.exports = new URL("my-staff.e18373de.svg", import.meta.url).toString();

});

parcelRegister("8qQHC", function(module, exports) {
module.exports = new URL("past.bdfbac82.svg", import.meta.url).toString();

});

parcelRegister("d1nVj", function(module, exports) {
module.exports = new URL("star.382c1b5d.svg", import.meta.url).toString();

});

parcelRegister("68Yas", function(module, exports) {
module.exports = new URL("invoice.3ea91b37.svg", import.meta.url).toString();

});

parcelRegister("hCzH7", function(module, exports) {
module.exports = new URL("payment.948df894.svg", import.meta.url).toString();

});

parcelRegister("kLorN", function(module, exports) {

$parcel$export(module.exports, "CLIENT_STATUS_ACTIVE", () => $3f81618b9387ab6c$export$c45d4c5f73d93fee);
$parcel$export(module.exports, "CLIENT_STATUSES_ALLOWED_TO_CHANGE_CORPORATE_DETAILS", () => $3f81618b9387ab6c$export$a6d812737334857);
$parcel$export(module.exports, "TERMS_AND_CONDITIONS_TYPE_PRIVACY_POLICY_CLIENT", () => $3f81618b9387ab6c$export$f4197ccbaacf1a95);
$parcel$export(module.exports, "TERMS_AND_CONDITIONS_TYPE_AFFILIATE_CLIENT", () => $3f81618b9387ab6c$export$6a36d92a85b6466d);
$parcel$export(module.exports, "API_VERSION_URL", () => $3f81618b9387ab6c$export$bb689a66e0c39da4);
$parcel$export(module.exports, "INITIAL_VERSION", () => $3f81618b9387ab6c$export$15c72ef9b0f96a47);
$parcel$export(module.exports, "VERSION_CACHE_NAME", () => $3f81618b9387ab6c$export$e82c96b27cc2ea24);
$parcel$export(module.exports, "VERSION_CACHE_KEY", () => $3f81618b9387ab6c$export$6825ebfedde34998);
const $3f81618b9387ab6c$export$22ec04a7bda8f8c1 = "sales@ogram.ae";
const $3f81618b9387ab6c$export$2913f846bd431370 = "800-OGRAM";
const $3f81618b9387ab6c$export$c19ece7ea27dcd9e = "AED";
const $3f81618b9387ab6c$export$881f502aa4fbe4 = "http://help.ogram.co/en/articles/4287235-terms-conditions";
var $3f81618b9387ab6c$export$9e9f3b3fe5782094;
(function(ACCOUNT_TYPE) {
    ACCOUNT_TYPE["attendanceManager"] = "A";
})($3f81618b9387ab6c$export$9e9f3b3fe5782094 || ($3f81618b9387ab6c$export$9e9f3b3fe5782094 = {}));
const $3f81618b9387ab6c$export$ecf6508459835aaf = "https://help.ogram.co/en/articles/4287328-privacy-policy";
const $3f81618b9387ab6c$export$9b009f11d57f4035 = "https://www.ogram.co/gr/en/privacy-policy-companies/";
const $3f81618b9387ab6c$export$d3da14318cb47db5 = 2;
const $3f81618b9387ab6c$export$c45d4c5f73d93fee = 5;
const $3f81618b9387ab6c$export$ad7a3c082d16bde0 = 6;
const $3f81618b9387ab6c$export$a6d812737334857 = [
    $3f81618b9387ab6c$export$d3da14318cb47db5,
    $3f81618b9387ab6c$export$ad7a3c082d16bde0
];
const $3f81618b9387ab6c$export$f4197ccbaacf1a95 = 9;
const $3f81618b9387ab6c$export$6a36d92a85b6466d = 10;
const $3f81618b9387ab6c$export$bb689a66e0c39da4 = "common/version/check";
const $3f81618b9387ab6c$export$15c72ef9b0f96a47 = "1.0.0";
const $3f81618b9387ab6c$export$e82c96b27cc2ea24 = "version_cache";
const $3f81618b9387ab6c$export$6825ebfedde34998 = "app_version";
const $3f81618b9387ab6c$export$8e78c240d4a406b0 = {
    bottom: "80px",
    right: "3%",
    background: "rgba(127, 114, 217, .7)"
};

});

parcelRegister("ghXKL", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function get() {
        return $bdbc95a11a631544$var$_ReactGoogleAutocomplete.default;
    }
});
Object.defineProperty(module.exports, "usePlacesWidget", {
    enumerable: true,
    get: function get() {
        return $bdbc95a11a631544$var$_usePlacesWidget.default;
    }
});

var $bdbc95a11a631544$var$_ReactGoogleAutocomplete = $bdbc95a11a631544$var$_interopRequireDefault((parcelRequire("6axgL")));

var $bdbc95a11a631544$var$_usePlacesWidget = $bdbc95a11a631544$var$_interopRequireDefault((parcelRequire("cUv9E")));
function $bdbc95a11a631544$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}

});
parcelRegister("6axgL", function(module, exports) {
"use strict";
function $47dd7bd848418faa$var$_typeof(obj) {
    "@babel/helpers - typeof";
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") $47dd7bd848418faa$var$_typeof = function _typeof(obj) {
        return typeof obj;
    };
    else $47dd7bd848418faa$var$_typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return $47dd7bd848418faa$var$_typeof(obj);
}
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $47dd7bd848418faa$var$_react = $47dd7bd848418faa$var$_interopRequireWildcard((parcelRequire("acw62")));

var $47dd7bd848418faa$var$_propTypes = $47dd7bd848418faa$var$_interopRequireDefault((parcelRequire("c9Z8w")));

var $47dd7bd848418faa$var$_usePlacesWidget2 = $47dd7bd848418faa$var$_interopRequireDefault((parcelRequire("cUv9E")));
function $47dd7bd848418faa$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $47dd7bd848418faa$var$_getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return ($47dd7bd848418faa$var$_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function $47dd7bd848418faa$var$_interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || $47dd7bd848418faa$var$_typeof(obj) !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = $47dd7bd848418faa$var$_getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
function $47dd7bd848418faa$var$_extends() {
    $47dd7bd848418faa$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $47dd7bd848418faa$var$_extends.apply(this, arguments);
}
function $47dd7bd848418faa$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $47dd7bd848418faa$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $47dd7bd848418faa$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $47dd7bd848418faa$var$ReactGoogleAutocomplete(props) {
    var onPlaceSelected = props.onPlaceSelected, apiKey = props.apiKey, libraries = props.libraries, inputAutocompleteValue = props.inputAutocompleteValue, options = props.options, googleMapsScriptBaseUrl = props.googleMapsScriptBaseUrl, refProp = props.refProp, language = props.language, rest = $47dd7bd848418faa$var$_objectWithoutProperties(props, [
        "onPlaceSelected",
        "apiKey",
        "libraries",
        "inputAutocompleteValue",
        "options",
        "googleMapsScriptBaseUrl",
        "refProp",
        "language"
    ]);
    var _usePlacesWidget = (0, $47dd7bd848418faa$var$_usePlacesWidget2.default)({
        ref: refProp,
        googleMapsScriptBaseUrl: googleMapsScriptBaseUrl,
        onPlaceSelected: onPlaceSelected,
        apiKey: apiKey,
        libraries: libraries,
        inputAutocompleteValue: inputAutocompleteValue,
        options: options,
        language: language
    }), ref = _usePlacesWidget.ref;
    return /*#__PURE__*/ $47dd7bd848418faa$var$_react.default.createElement("input", $47dd7bd848418faa$var$_extends({
        ref: ref
    }, rest));
}
$47dd7bd848418faa$var$ReactGoogleAutocomplete.propTypes = {
    apiKey: $47dd7bd848418faa$var$_propTypes.default.string,
    libraries: $47dd7bd848418faa$var$_propTypes.default.arrayOf($47dd7bd848418faa$var$_propTypes.default.string),
    ref: $47dd7bd848418faa$var$_propTypes.default.oneOfType([
        $47dd7bd848418faa$var$_propTypes.default.func,
        $47dd7bd848418faa$var$_propTypes.default.shape({
            current: $47dd7bd848418faa$var$_propTypes.default.any
        })
    ]),
    googleMapsScriptBaseUrl: $47dd7bd848418faa$var$_propTypes.default.string,
    onPlaceSelected: $47dd7bd848418faa$var$_propTypes.default.func,
    inputAutocompleteValue: $47dd7bd848418faa$var$_propTypes.default.string,
    options: $47dd7bd848418faa$var$_propTypes.default.shape({
        componentRestrictions: $47dd7bd848418faa$var$_propTypes.default.object,
        bounds: $47dd7bd848418faa$var$_propTypes.default.object,
        location: $47dd7bd848418faa$var$_propTypes.default.object,
        offset: $47dd7bd848418faa$var$_propTypes.default.number,
        origin: $47dd7bd848418faa$var$_propTypes.default.object,
        radius: $47dd7bd848418faa$var$_propTypes.default.number,
        sessionToken: $47dd7bd848418faa$var$_propTypes.default.object,
        types: $47dd7bd848418faa$var$_propTypes.default.arrayOf($47dd7bd848418faa$var$_propTypes.default.string)
    }),
    language: $47dd7bd848418faa$var$_propTypes.default.string
};
var $47dd7bd848418faa$var$_default = /*#__PURE__*/ (0, $47dd7bd848418faa$var$_react.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ $47dd7bd848418faa$var$_react.default.createElement($47dd7bd848418faa$var$ReactGoogleAutocomplete, $47dd7bd848418faa$var$_extends({}, props, {
        refProp: ref
    }));
});
module.exports.default = $47dd7bd848418faa$var$_default;

});
parcelRegister("cUv9E", function(module, exports) {
"use strict";
function $9662e1abb63012eb$var$_typeof(obj) {
    "@babel/helpers - typeof";
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") $9662e1abb63012eb$var$_typeof = function _typeof(obj) {
        return typeof obj;
    };
    else $9662e1abb63012eb$var$_typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return $9662e1abb63012eb$var$_typeof(obj);
}
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $9662e1abb63012eb$var$usePlacesWidget;

var $9662e1abb63012eb$var$_react = $9662e1abb63012eb$var$_interopRequireWildcard((parcelRequire("acw62")));

var $5oweV = parcelRequire("5oweV");

var $kMBKI = parcelRequire("kMBKI");
function $9662e1abb63012eb$var$_getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return ($9662e1abb63012eb$var$_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function $9662e1abb63012eb$var$_interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || $9662e1abb63012eb$var$_typeof(obj) !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = $9662e1abb63012eb$var$_getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
function $9662e1abb63012eb$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $9662e1abb63012eb$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) $9662e1abb63012eb$var$ownKeys(Object(source), true).forEach(function(key) {
            $9662e1abb63012eb$var$_defineProperty(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else $9662e1abb63012eb$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $9662e1abb63012eb$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $9662e1abb63012eb$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $9662e1abb63012eb$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $9662e1abb63012eb$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $9662e1abb63012eb$var$usePlacesWidget(props) {
    var ref = props.ref, onPlaceSelected = props.onPlaceSelected, apiKey = props.apiKey, _props$libraries = props.libraries, libraries = _props$libraries === void 0 ? "places" : _props$libraries, _props$inputAutocompl = props.inputAutocompleteValue, inputAutocompleteValue = _props$inputAutocompl === void 0 ? "new-password" : _props$inputAutocompl, _props$options = props.options;
    _props$options = _props$options === void 0 ? {} : _props$options;
    var _props$options$types = _props$options.types, types = _props$options$types === void 0 ? [
        "(cities)"
    ] : _props$options$types, componentRestrictions = _props$options.componentRestrictions, _props$options$fields = _props$options.fields, fields = _props$options$fields === void 0 ? [
        "address_components",
        "geometry.location",
        "place_id",
        "formatted_address"
    ] : _props$options$fields, bounds = _props$options.bounds, options = $9662e1abb63012eb$var$_objectWithoutProperties(_props$options, [
        "types",
        "componentRestrictions",
        "fields",
        "bounds"
    ]), _props$googleMapsScri = props.googleMapsScriptBaseUrl, googleMapsScriptBaseUrl = _props$googleMapsScri === void 0 ? $kMBKI.GOOGLE_MAP_SCRIPT_BASE_URL : _props$googleMapsScri, language = props.language;
    var inputRef = (0, $9662e1abb63012eb$var$_react.useRef)(null);
    var event = (0, $9662e1abb63012eb$var$_react.useRef)(null);
    var autocompleteRef = (0, $9662e1abb63012eb$var$_react.useRef)(null);
    var observerHack = (0, $9662e1abb63012eb$var$_react.useRef)(null);
    var languageQueryParam = language ? "&language=".concat(language) : "";
    var googleMapsScriptUrl = "".concat(googleMapsScriptBaseUrl, "?libraries=").concat(libraries, "&key=").concat(apiKey).concat(languageQueryParam);
    var handleLoadScript = (0, $9662e1abb63012eb$var$_react.useCallback)(function() {
        return (0, $5oweV.loadGoogleMapScript)(googleMapsScriptBaseUrl, googleMapsScriptUrl);
    }, [
        googleMapsScriptBaseUrl,
        googleMapsScriptUrl
    ]);
    (0, $9662e1abb63012eb$var$_react.useEffect)(function() {
        var config = $9662e1abb63012eb$var$_objectSpread($9662e1abb63012eb$var$_objectSpread({}, options), {}, {
            fields: fields,
            types: types,
            bounds: bounds
        });
        if (componentRestrictions) config.componentRestrictions = componentRestrictions;
        if (autocompleteRef.current || !inputRef.current || !$5oweV.isBrowser) return;
        if (ref && !ref.current) ref.current = inputRef.current;
        var handleAutoComplete = function handleAutoComplete() {
            var _google$maps;
            if (typeof google === "undefined") return console.error("Google has not been found. Make sure your provide apiKey prop.");
            if (!((_google$maps = google.maps) !== null && _google$maps !== void 0 && _google$maps.places)) return console.error("Google maps places API must be loaded.");
            if (!inputRef.current instanceof HTMLInputElement) return console.error("Input ref must be HTMLInputElement.");
            autocompleteRef.current = new google.maps.places.Autocomplete(inputRef.current, config);
            if (autocompleteRef.current) event.current = autocompleteRef.current.addListener("place_changed", function() {
                if (onPlaceSelected && autocompleteRef && autocompleteRef.current) onPlaceSelected(autocompleteRef.current.getPlace(), inputRef.current, autocompleteRef.current);
            });
        };
        if (apiKey) handleLoadScript().then(function() {
            return handleAutoComplete();
        });
        else handleAutoComplete();
        return function() {
            return event.current ? event.current.remove() : undefined;
        };
    }, []); // Autofill workaround adapted from https://stackoverflow.com/questions/29931712/chrome-autofill-covers-autocomplete-for-google-maps-api-v3/49161445#49161445
    (0, $9662e1abb63012eb$var$_react.useEffect)(function() {
        var _React$version;
        // TODO find out why react 18(strict mode) hangs the page loading
        if (!($9662e1abb63012eb$var$_react.default !== null && $9662e1abb63012eb$var$_react.default !== void 0 && (_React$version = $9662e1abb63012eb$var$_react.default.version) !== null && _React$version !== void 0 && _React$version.startsWith("18")) && $5oweV.isBrowser && window.MutationObserver && inputRef.current && inputRef.current instanceof HTMLInputElement) {
            observerHack.current = new MutationObserver(function() {
                observerHack.current.disconnect();
                if (inputRef.current) inputRef.current.autocomplete = inputAutocompleteValue;
            });
            observerHack.current.observe(inputRef.current, {
                attributes: true,
                attributeFilter: [
                    "autocomplete"
                ]
            });
        }
    }, [
        inputAutocompleteValue
    ]);
    (0, $9662e1abb63012eb$var$_react.useEffect)(function() {
        if (autocompleteRef.current) autocompleteRef.current.setFields(fields);
    }, [
        fields
    ]);
    (0, $9662e1abb63012eb$var$_react.useEffect)(function() {
        if (autocompleteRef.current) autocompleteRef.current.setBounds(bounds);
    }, [
        bounds
    ]);
    (0, $9662e1abb63012eb$var$_react.useEffect)(function() {
        if (autocompleteRef.current) autocompleteRef.current.setComponentRestrictions(componentRestrictions);
    }, [
        componentRestrictions
    ]);
    (0, $9662e1abb63012eb$var$_react.useEffect)(function() {
        if (autocompleteRef.current) autocompleteRef.current.setOptions(options);
    }, [
        options
    ]);
    return {
        ref: inputRef,
        autocompleteRef: autocompleteRef
    };
}

});
parcelRegister("5oweV", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.loadGoogleMapScript = module.exports.isBrowser = void 0;
var $3ed833ccc77419f7$var$isBrowser = typeof window !== "undefined" && window.document;
module.exports.isBrowser = $3ed833ccc77419f7$var$isBrowser;
var $3ed833ccc77419f7$var$loadGoogleMapScript = function loadGoogleMapScript(googleMapsScriptBaseUrl, googleMapsScriptUrl) {
    if (!$3ed833ccc77419f7$var$isBrowser) return Promise.resolve();
    if (typeof google !== "undefined") {
        if (google.maps && google.maps.api) return Promise.resolve();
    }
    var scriptElements = document.querySelectorAll('script[src*="'.concat(googleMapsScriptBaseUrl, '"]'));
    if (scriptElements && scriptElements.length) return new Promise(function(resolve) {
        // in case we already have a script on the page and it's loaded we resolve
        if (typeof google !== "undefined") return resolve(); // otherwise we wait until it's loaded and resolve
        scriptElements[0].addEventListener("load", function() {
            return resolve();
        });
    });
    var scriptUrl = new URL(googleMapsScriptUrl);
    scriptUrl.searchParams.set("callback", "__REACT_GOOGLE_AUTOCOMPLETE_CALLBACK__");
    var el = document.createElement("script");
    el.src = scriptUrl.toString();
    return new Promise(function(resolve) {
        window.__REACT_GOOGLE_AUTOCOMPLETE_CALLBACK__ = resolve;
        document.body.appendChild(el);
    });
};
module.exports.loadGoogleMapScript = $3ed833ccc77419f7$var$loadGoogleMapScript;

});

parcelRegister("kMBKI", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.GOOGLE_MAP_SCRIPT_BASE_URL = void 0;
var $f215932f1180401d$var$GOOGLE_MAP_SCRIPT_BASE_URL = "https://maps.googleapis.com/maps/api/js";
module.exports.GOOGLE_MAP_SCRIPT_BASE_URL = $f215932f1180401d$var$GOOGLE_MAP_SCRIPT_BASE_URL;

});




parcelRegister("kTOWR", function(module, exports) {

$parcel$export(module.exports, "ContextConsumer", () => $f3707700bffa1d93$export$a7c73072b1a182ae, (v) => $f3707700bffa1d93$export$a7c73072b1a182ae = v);
$parcel$export(module.exports, "ContextProvider", () => $f3707700bffa1d93$export$9f27bc3417b4524d, (v) => $f3707700bffa1d93$export$9f27bc3417b4524d = v);
$parcel$export(module.exports, "Element", () => $f3707700bffa1d93$export$db77ccec0bb4ccac, (v) => $f3707700bffa1d93$export$db77ccec0bb4ccac = v);
$parcel$export(module.exports, "ForwardRef", () => $f3707700bffa1d93$export$8392c0c9d3dcbd35, (v) => $f3707700bffa1d93$export$8392c0c9d3dcbd35 = v);
$parcel$export(module.exports, "Fragment", () => $f3707700bffa1d93$export$ffb0004e005737fa, (v) => $f3707700bffa1d93$export$ffb0004e005737fa = v);
$parcel$export(module.exports, "Lazy", () => $f3707700bffa1d93$export$b624eff549462981, (v) => $f3707700bffa1d93$export$b624eff549462981 = v);
$parcel$export(module.exports, "Memo", () => $f3707700bffa1d93$export$7897aa7841a5380c, (v) => $f3707700bffa1d93$export$7897aa7841a5380c = v);
$parcel$export(module.exports, "Portal", () => $f3707700bffa1d93$export$602eac185826482c, (v) => $f3707700bffa1d93$export$602eac185826482c = v);
$parcel$export(module.exports, "Profiler", () => $f3707700bffa1d93$export$e2c29f18771995cb, (v) => $f3707700bffa1d93$export$e2c29f18771995cb = v);
$parcel$export(module.exports, "StrictMode", () => $f3707700bffa1d93$export$5f8d39834fd61797, (v) => $f3707700bffa1d93$export$5f8d39834fd61797 = v);
$parcel$export(module.exports, "Suspense", () => $f3707700bffa1d93$export$74bf444e3cd11ea5, (v) => $f3707700bffa1d93$export$74bf444e3cd11ea5 = v);
$parcel$export(module.exports, "SuspenseList", () => $f3707700bffa1d93$export$998bcd577473dd93, (v) => $f3707700bffa1d93$export$998bcd577473dd93 = v);
$parcel$export(module.exports, "isAsyncMode", () => $f3707700bffa1d93$export$92387174baf9b227, (v) => $f3707700bffa1d93$export$92387174baf9b227 = v);
$parcel$export(module.exports, "isConcurrentMode", () => $f3707700bffa1d93$export$ec112efeb987d9c6, (v) => $f3707700bffa1d93$export$ec112efeb987d9c6 = v);
$parcel$export(module.exports, "isContextConsumer", () => $f3707700bffa1d93$export$b706b080d889d2c9, (v) => $f3707700bffa1d93$export$b706b080d889d2c9 = v);
$parcel$export(module.exports, "isContextProvider", () => $f3707700bffa1d93$export$5be5a87408f70ddc, (v) => $f3707700bffa1d93$export$5be5a87408f70ddc = v);
$parcel$export(module.exports, "isElement", () => $f3707700bffa1d93$export$45a5e7f76e0caa8d, (v) => $f3707700bffa1d93$export$45a5e7f76e0caa8d = v);
$parcel$export(module.exports, "isForwardRef", () => $f3707700bffa1d93$export$455c2e768291efa6, (v) => $f3707700bffa1d93$export$455c2e768291efa6 = v);
$parcel$export(module.exports, "isFragment", () => $f3707700bffa1d93$export$9522e17588c12572, (v) => $f3707700bffa1d93$export$9522e17588c12572 = v);
$parcel$export(module.exports, "isLazy", () => $f3707700bffa1d93$export$2110ac352bb060b9, (v) => $f3707700bffa1d93$export$2110ac352bb060b9 = v);
$parcel$export(module.exports, "isMemo", () => $f3707700bffa1d93$export$56885ab8b9c456ab, (v) => $f3707700bffa1d93$export$56885ab8b9c456ab = v);
$parcel$export(module.exports, "isPortal", () => $f3707700bffa1d93$export$d927fcb6adf8f9de, (v) => $f3707700bffa1d93$export$d927fcb6adf8f9de = v);
$parcel$export(module.exports, "isProfiler", () => $f3707700bffa1d93$export$b82d16f27459e05a, (v) => $f3707700bffa1d93$export$b82d16f27459e05a = v);
$parcel$export(module.exports, "isStrictMode", () => $f3707700bffa1d93$export$522c17b4f5e123e8, (v) => $f3707700bffa1d93$export$522c17b4f5e123e8 = v);
$parcel$export(module.exports, "isSuspense", () => $f3707700bffa1d93$export$1aabd8a0274ecfd6, (v) => $f3707700bffa1d93$export$1aabd8a0274ecfd6 = v);
$parcel$export(module.exports, "isSuspenseList", () => $f3707700bffa1d93$export$3d6c20d97e46b957, (v) => $f3707700bffa1d93$export$3d6c20d97e46b957 = v);
$parcel$export(module.exports, "isValidElementType", () => $f3707700bffa1d93$export$9b621391a187a31a, (v) => $f3707700bffa1d93$export$9b621391a187a31a = v);
$parcel$export(module.exports, "typeOf", () => $f3707700bffa1d93$export$f5bbd400c2f4426f, (v) => $f3707700bffa1d93$export$f5bbd400c2f4426f = v);
/**
 * @license React
 * react-is.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $f3707700bffa1d93$export$a7c73072b1a182ae;
var $f3707700bffa1d93$export$9f27bc3417b4524d;
var $f3707700bffa1d93$export$db77ccec0bb4ccac;
var $f3707700bffa1d93$export$8392c0c9d3dcbd35;
var $f3707700bffa1d93$export$ffb0004e005737fa;
var $f3707700bffa1d93$export$b624eff549462981;
var $f3707700bffa1d93$export$7897aa7841a5380c;
var $f3707700bffa1d93$export$602eac185826482c;
var $f3707700bffa1d93$export$e2c29f18771995cb;
var $f3707700bffa1d93$export$5f8d39834fd61797;
var $f3707700bffa1d93$export$74bf444e3cd11ea5;
var $f3707700bffa1d93$export$998bcd577473dd93;
var $f3707700bffa1d93$export$92387174baf9b227;
var $f3707700bffa1d93$export$ec112efeb987d9c6;
var $f3707700bffa1d93$export$b706b080d889d2c9;
var $f3707700bffa1d93$export$5be5a87408f70ddc;
var $f3707700bffa1d93$export$45a5e7f76e0caa8d;
var $f3707700bffa1d93$export$455c2e768291efa6;
var $f3707700bffa1d93$export$9522e17588c12572;
var $f3707700bffa1d93$export$2110ac352bb060b9;
var $f3707700bffa1d93$export$56885ab8b9c456ab;
var $f3707700bffa1d93$export$d927fcb6adf8f9de;
var $f3707700bffa1d93$export$b82d16f27459e05a;
var $f3707700bffa1d93$export$522c17b4f5e123e8;
var $f3707700bffa1d93$export$1aabd8a0274ecfd6;
var $f3707700bffa1d93$export$3d6c20d97e46b957;
var $f3707700bffa1d93$export$9b621391a187a31a;
var $f3707700bffa1d93$export$f5bbd400c2f4426f;
"use strict";
(function() {
    "use strict";
    // ATTENTION
    // When adding new symbols to this file,
    // Please consider also adding to 'react-devtools-shared/src/backend/ReactSymbols'
    // The Symbol used to tag the ReactElement-like types.
    var REACT_ELEMENT_TYPE = Symbol.for("react.element");
    var REACT_PORTAL_TYPE = Symbol.for("react.portal");
    var REACT_FRAGMENT_TYPE = Symbol.for("react.fragment");
    var REACT_STRICT_MODE_TYPE = Symbol.for("react.strict_mode");
    var REACT_PROFILER_TYPE = Symbol.for("react.profiler");
    var REACT_PROVIDER_TYPE = Symbol.for("react.provider");
    var REACT_CONTEXT_TYPE = Symbol.for("react.context");
    var REACT_SERVER_CONTEXT_TYPE = Symbol.for("react.server_context");
    var REACT_FORWARD_REF_TYPE = Symbol.for("react.forward_ref");
    var REACT_SUSPENSE_TYPE = Symbol.for("react.suspense");
    var REACT_SUSPENSE_LIST_TYPE = Symbol.for("react.suspense_list");
    var REACT_MEMO_TYPE = Symbol.for("react.memo");
    var REACT_LAZY_TYPE = Symbol.for("react.lazy");
    var REACT_OFFSCREEN_TYPE = Symbol.for("react.offscreen");
    // -----------------------------------------------------------------------------
    var enableScopeAPI = false; // Experimental Create Event Handle API.
    var enableCacheElement = false;
    var enableTransitionTracing = false; // No known bugs, but needs performance testing
    var enableLegacyHidden = false; // Enables unstable_avoidThisFallback feature in Fiber
    // stuff. Intended to enable React core members to more easily debug scheduling
    // issues in DEV builds.
    var enableDebugTracing = false; // Track which Fiber(s) schedule render work.
    var REACT_MODULE_REFERENCE;
    REACT_MODULE_REFERENCE = Symbol.for("react.module.reference");
    function isValidElementType(type) {
        if (typeof type === "string" || typeof type === "function") return true;
         // Note: typeof might be other than 'symbol' or 'number' (e.g. if it's a polyfill).
        if (type === REACT_FRAGMENT_TYPE || type === REACT_PROFILER_TYPE || enableDebugTracing || type === REACT_STRICT_MODE_TYPE || type === REACT_SUSPENSE_TYPE || type === REACT_SUSPENSE_LIST_TYPE || enableLegacyHidden || type === REACT_OFFSCREEN_TYPE || enableScopeAPI || enableCacheElement || enableTransitionTracing) return true;
        if (typeof type === "object" && type !== null) {
            if (type.$$typeof === REACT_LAZY_TYPE || type.$$typeof === REACT_MEMO_TYPE || type.$$typeof === REACT_PROVIDER_TYPE || type.$$typeof === REACT_CONTEXT_TYPE || type.$$typeof === REACT_FORWARD_REF_TYPE || // This needs to include all possible module reference object
            // types supported by any Flight configuration anywhere since
            // we don't know which Flight build this will end up being used
            // with.
            type.$$typeof === REACT_MODULE_REFERENCE || type.getModuleId !== undefined) return true;
        }
        return false;
    }
    function typeOf(object) {
        if (typeof object === "object" && object !== null) {
            var $$typeof = object.$$typeof;
            switch($$typeof){
                case REACT_ELEMENT_TYPE:
                    var type = object.type;
                    switch(type){
                        case REACT_FRAGMENT_TYPE:
                        case REACT_PROFILER_TYPE:
                        case REACT_STRICT_MODE_TYPE:
                        case REACT_SUSPENSE_TYPE:
                        case REACT_SUSPENSE_LIST_TYPE:
                            return type;
                        default:
                            var $$typeofType = type && type.$$typeof;
                            switch($$typeofType){
                                case REACT_SERVER_CONTEXT_TYPE:
                                case REACT_CONTEXT_TYPE:
                                case REACT_FORWARD_REF_TYPE:
                                case REACT_LAZY_TYPE:
                                case REACT_MEMO_TYPE:
                                case REACT_PROVIDER_TYPE:
                                    return $$typeofType;
                                default:
                                    return $$typeof;
                            }
                    }
                case REACT_PORTAL_TYPE:
                    return $$typeof;
            }
        }
        return undefined;
    }
    var ContextConsumer = REACT_CONTEXT_TYPE;
    var ContextProvider = REACT_PROVIDER_TYPE;
    var Element = REACT_ELEMENT_TYPE;
    var ForwardRef = REACT_FORWARD_REF_TYPE;
    var Fragment = REACT_FRAGMENT_TYPE;
    var Lazy = REACT_LAZY_TYPE;
    var Memo = REACT_MEMO_TYPE;
    var Portal = REACT_PORTAL_TYPE;
    var Profiler = REACT_PROFILER_TYPE;
    var StrictMode = REACT_STRICT_MODE_TYPE;
    var Suspense = REACT_SUSPENSE_TYPE;
    var SuspenseList = REACT_SUSPENSE_LIST_TYPE;
    var hasWarnedAboutDeprecatedIsAsyncMode = false;
    var hasWarnedAboutDeprecatedIsConcurrentMode = false; // AsyncMode should be deprecated
    function isAsyncMode(object) {
        if (!hasWarnedAboutDeprecatedIsAsyncMode) {
            hasWarnedAboutDeprecatedIsAsyncMode = true; // Using console['warn'] to evade Babel and ESLint
            console["warn"]("The ReactIs.isAsyncMode() alias has been deprecated, and will be removed in React 18+.");
        }
        return false;
    }
    function isConcurrentMode(object) {
        if (!hasWarnedAboutDeprecatedIsConcurrentMode) {
            hasWarnedAboutDeprecatedIsConcurrentMode = true; // Using console['warn'] to evade Babel and ESLint
            console["warn"]("The ReactIs.isConcurrentMode() alias has been deprecated, and will be removed in React 18+.");
        }
        return false;
    }
    function isContextConsumer(object) {
        return typeOf(object) === REACT_CONTEXT_TYPE;
    }
    function isContextProvider(object) {
        return typeOf(object) === REACT_PROVIDER_TYPE;
    }
    function isElement(object) {
        return typeof object === "object" && object !== null && object.$$typeof === REACT_ELEMENT_TYPE;
    }
    function isForwardRef(object) {
        return typeOf(object) === REACT_FORWARD_REF_TYPE;
    }
    function isFragment(object) {
        return typeOf(object) === REACT_FRAGMENT_TYPE;
    }
    function isLazy(object) {
        return typeOf(object) === REACT_LAZY_TYPE;
    }
    function isMemo(object) {
        return typeOf(object) === REACT_MEMO_TYPE;
    }
    function isPortal(object) {
        return typeOf(object) === REACT_PORTAL_TYPE;
    }
    function isProfiler(object) {
        return typeOf(object) === REACT_PROFILER_TYPE;
    }
    function isStrictMode(object) {
        return typeOf(object) === REACT_STRICT_MODE_TYPE;
    }
    function isSuspense(object) {
        return typeOf(object) === REACT_SUSPENSE_TYPE;
    }
    function isSuspenseList(object) {
        return typeOf(object) === REACT_SUSPENSE_LIST_TYPE;
    }
    $f3707700bffa1d93$export$a7c73072b1a182ae = ContextConsumer;
    $f3707700bffa1d93$export$9f27bc3417b4524d = ContextProvider;
    $f3707700bffa1d93$export$db77ccec0bb4ccac = Element;
    $f3707700bffa1d93$export$8392c0c9d3dcbd35 = ForwardRef;
    $f3707700bffa1d93$export$ffb0004e005737fa = Fragment;
    $f3707700bffa1d93$export$b624eff549462981 = Lazy;
    $f3707700bffa1d93$export$7897aa7841a5380c = Memo;
    $f3707700bffa1d93$export$602eac185826482c = Portal;
    $f3707700bffa1d93$export$e2c29f18771995cb = Profiler;
    $f3707700bffa1d93$export$5f8d39834fd61797 = StrictMode;
    $f3707700bffa1d93$export$74bf444e3cd11ea5 = Suspense;
    $f3707700bffa1d93$export$998bcd577473dd93 = SuspenseList;
    $f3707700bffa1d93$export$92387174baf9b227 = isAsyncMode;
    $f3707700bffa1d93$export$ec112efeb987d9c6 = isConcurrentMode;
    $f3707700bffa1d93$export$b706b080d889d2c9 = isContextConsumer;
    $f3707700bffa1d93$export$5be5a87408f70ddc = isContextProvider;
    $f3707700bffa1d93$export$45a5e7f76e0caa8d = isElement;
    $f3707700bffa1d93$export$455c2e768291efa6 = isForwardRef;
    $f3707700bffa1d93$export$9522e17588c12572 = isFragment;
    $f3707700bffa1d93$export$2110ac352bb060b9 = isLazy;
    $f3707700bffa1d93$export$56885ab8b9c456ab = isMemo;
    $f3707700bffa1d93$export$d927fcb6adf8f9de = isPortal;
    $f3707700bffa1d93$export$b82d16f27459e05a = isProfiler;
    $f3707700bffa1d93$export$522c17b4f5e123e8 = isStrictMode;
    $f3707700bffa1d93$export$1aabd8a0274ecfd6 = isSuspense;
    $f3707700bffa1d93$export$3d6c20d97e46b957 = isSuspenseList;
    $f3707700bffa1d93$export$9b621391a187a31a = isValidElementType;
    $f3707700bffa1d93$export$f5bbd400c2f4426f = typeOf;
})();

});

parcelRegister("9My83", function(module, exports) {




(function(global, factory) {
    if (typeof define === "function" && define.amd) define([
        "exports",
        "react",
        "react-dom",
        "./lib/ScriptCache",
        "./lib/GoogleApi"
    ], factory);
    else {
        var mod;
        factory(module.exports, (parcelRequire("acw62")), (parcelRequire("1u0KT")), (parcelRequire("1YevD")), (parcelRequire("bGOQR")));
    }
})(module.exports, function(exports1, _react, _reactDom, _ScriptCache, _GoogleApi) {
    "use strict";
    Object.defineProperty(exports1, "__esModule", {
        value: true
    });
    exports1.wrapper = undefined;
    var _react2 = _interopRequireDefault(_react);
    var _reactDom2 = _interopRequireDefault(_reactDom);
    var _GoogleApi2 = _interopRequireDefault(_GoogleApi);
    function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
            default: obj
        };
    }
    function _classCallCheck(instance, Constructor) {
        if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
    }
    var _createClass = function() {
        function defineProperties(target, props) {
            for(var i = 0; i < props.length; i++){
                var descriptor = props[i];
                descriptor.enumerable = descriptor.enumerable || false;
                descriptor.configurable = true;
                if ("value" in descriptor) descriptor.writable = true;
                Object.defineProperty(target, descriptor.key, descriptor);
            }
        }
        return function(Constructor, protoProps, staticProps) {
            if (protoProps) defineProperties(Constructor.prototype, protoProps);
            if (staticProps) defineProperties(Constructor, staticProps);
            return Constructor;
        };
    }();
    function _possibleConstructorReturn(self, call) {
        if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return call && (typeof call === "object" || typeof call === "function") ? call : self;
    }
    function _inherits(subClass, superClass) {
        if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
        subClass.prototype = Object.create(superClass && superClass.prototype, {
            constructor: {
                value: subClass,
                enumerable: false,
                writable: true,
                configurable: true
            }
        });
        if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
    }
    var defaultMapConfig = {};
    var serialize = function serialize(obj) {
        return JSON.stringify(obj);
    };
    var isSame = function isSame(obj1, obj2) {
        return obj1 === obj2 || serialize(obj1) === serialize(obj2);
    };
    var defaultCreateCache = function defaultCreateCache(options) {
        options = options || {};
        var apiKey = options.apiKey;
        var libraries = options.libraries || [
            "places"
        ];
        var version = options.version || "3";
        var language = options.language || "en";
        var url = options.url;
        var client = options.client;
        var region = options.region;
        return (0, _ScriptCache.ScriptCache)({
            google: (0, _GoogleApi2.default)({
                apiKey: apiKey,
                language: language,
                libraries: libraries,
                version: version,
                url: url,
                client: client,
                region: region
            })
        });
    };
    var DefaultLoadingContainer = function DefaultLoadingContainer(props) {
        return _react2.default.createElement("div", null, "Loading...");
    };
    var wrapper = exports1.wrapper = function wrapper(input, className, style) {
        return function(WrappedComponent) {
            var Wrapper = function(_React$Component) {
                _inherits(Wrapper, _React$Component);
                function Wrapper(props, context) {
                    _classCallCheck(this, Wrapper);
                    // Build options from input
                    var _this = _possibleConstructorReturn(this, (Wrapper.__proto__ || Object.getPrototypeOf(Wrapper)).call(this, props, context));
                    var options = typeof input === "function" ? input(props) : input;
                    // Initialize required Google scripts and other configured options
                    _this.initialize(options);
                    _this.state = {
                        loaded: false,
                        map: null,
                        google: null,
                        options: options
                    };
                    _this.mapRef = _react2.default.createRef();
                    return _this;
                }
                _createClass(Wrapper, [
                    {
                        key: "componentDidUpdate",
                        value: function componentDidUpdate(props) {
                            // Do not update input if it's not dynamic
                            if (typeof input !== "function") return;
                            // Get options to compare
                            var prevOptions = this.state.options;
                            var options = typeof input === "function" ? input(props) : input;
                            // Ignore when options are not changed
                            if (isSame(options, prevOptions)) return;
                            // Initialize with new options
                            this.initialize(options);
                            // Save new options in component state,
                            // and remove information about previous API handlers
                            this.state = {
                                options: options,
                                loaded: false,
                                google: null
                            };
                        }
                    },
                    {
                        key: "componentWillUnmount",
                        value: function componentWillUnmount() {
                            if (this.unregisterLoadHandler) this.unregisterLoadHandler();
                        }
                    },
                    {
                        key: "initialize",
                        value: function initialize(options) {
                            // Avoid race condition: remove previous 'load' listener
                            if (this.unregisterLoadHandler) {
                                this.unregisterLoadHandler();
                                this.unregisterLoadHandler = null;
                            }
                            // Load cache factory
                            var createCache = options.createCache || defaultCreateCache;
                            // Build script
                            this.scriptCache = createCache(options);
                            this.unregisterLoadHandler = this.scriptCache.google.onLoad(this.onLoad.bind(this));
                            // Store information about loading container
                            this.LoadingContainer = options.LoadingContainer || DefaultLoadingContainer;
                        }
                    },
                    {
                        key: "onLoad",
                        value: function onLoad(err, tag) {
                            this._gapi = window.google;
                            this.setState({
                                loaded: true,
                                google: this._gapi
                            });
                        }
                    },
                    {
                        key: "render",
                        value: function render() {
                            var LoadingContainer = this.LoadingContainer;
                            if (!this.state.loaded) return _react2.default.createElement(LoadingContainer, null);
                            var props = Object.assign({}, this.props, {
                                loaded: this.state.loaded,
                                google: window.google
                            });
                            return _react2.default.createElement("div", {
                                className: className,
                                style: style
                            }, _react2.default.createElement(WrappedComponent, props), _react2.default.createElement("div", {
                                ref: this.mapRef
                            }));
                        }
                    }
                ]);
                return Wrapper;
            }(_react2.default.Component);
            return Wrapper;
        };
    };
    exports1.default = wrapper;
});

});
parcelRegister("1YevD", function(module, exports) {

(function(global, factory) {
    if (typeof define === "function" && define.amd) define([
        "exports",
        "./windowOrGlobal"
    ], factory);
    else {
        var mod;
        factory(module.exports, (parcelRequire("7ZRcx")));
    }
})(module.exports, function(exports1, window) {
    "use strict";
    Object.defineProperty(exports1, "__esModule", {
        value: true
    });
    var counter = 0;
    var scriptMap = typeof window !== "undefined" && window._scriptMap || new Map();
    var ScriptCache = exports1.ScriptCache = function(global) {
        global._scriptMap = global._scriptMap || scriptMap;
        return function ScriptCache(scripts) {
            var Cache = {};
            Cache._onLoad = function(key) {
                return function(cb) {
                    var registered = true;
                    function unregister() {
                        registered = false;
                    }
                    var stored = scriptMap.get(key);
                    if (stored) stored.promise.then(function() {
                        if (registered) stored.error ? cb(stored.error) : cb(null, stored);
                        return stored;
                    }).catch(function(error) {
                        return cb(error);
                    });
                    return unregister;
                };
            };
            Cache._scriptTag = function(key, src) {
                if (!scriptMap.has(key)) {
                    // Server side rendering environments don't always have access to the `document` global.
                    // In these cases, we're not going to be able to return a script tag, so just return null.
                    if (typeof document === "undefined") return null;
                    var tag = document.createElement("script");
                    var promise = new Promise(function(resolve, reject) {
                        var body = document.getElementsByTagName("body")[0];
                        tag.type = "text/javascript";
                        tag.async = false; // Load in order
                        var cbName = "loaderCB" + counter++ + Date.now();
                        var cb = void 0;
                        var handleResult = function handleResult(state) {
                            return function(evt) {
                                var stored = scriptMap.get(key);
                                if (state === "loaded") {
                                    stored.resolved = true;
                                    resolve(src);
                                // stored.handlers.forEach(h => h.call(null, stored))
                                // stored.handlers = []
                                } else if (state === "error") {
                                    stored.errored = true;
                                    // stored.handlers.forEach(h => h.call(null, stored))
                                    // stored.handlers = [];
                                    reject(evt);
                                }
                                stored.loaded = true;
                                cleanup();
                            };
                        };
                        var cleanup = function cleanup() {
                            if (global[cbName] && typeof global[cbName] === "function") {
                                global[cbName] = null;
                                delete global[cbName];
                            }
                        };
                        tag.onload = handleResult("loaded");
                        tag.onerror = handleResult("error");
                        tag.onreadystatechange = function() {
                            handleResult(tag.readyState);
                        };
                        // Pick off callback, if there is one
                        if (src.match(/callback=CALLBACK_NAME/)) {
                            src = src.replace(/(callback=)[^\&]+/, "$1" + cbName);
                            cb = window[cbName] = tag.onload;
                        } else tag.addEventListener("load", tag.onload);
                        tag.addEventListener("error", tag.onerror);
                        tag.src = src;
                        body.appendChild(tag);
                        return tag;
                    });
                    var initialState = {
                        loaded: false,
                        error: false,
                        promise: promise,
                        tag: tag
                    };
                    scriptMap.set(key, initialState);
                }
                return scriptMap.get(key).tag;
            };
            // let scriptTags = document.querySelectorAll('script')
            //
            // NodeList.prototype.filter = Array.prototype.filter;
            // NodeList.prototype.map = Array.prototype.map;
            // const initialScripts = scriptTags
            //   .filter(s => !!s.src)
            //   .map(s => s.src.split('?')[0])
            //   .reduce((memo, script) => {
            //     memo[script] = script;
            //     return memo;
            //   }, {});
            Object.keys(scripts).forEach(function(key) {
                var script = scripts[key];
                var tag = window._scriptMap.has(key) ? window._scriptMap.get(key).tag : Cache._scriptTag(key, script);
                Cache[key] = {
                    tag: tag,
                    onLoad: Cache._onLoad(key)
                };
            });
            return Cache;
        };
    }(window);
    exports1.default = ScriptCache;
});

});
parcelRegister("7ZRcx", function(module, exports) {
(function(global1, factory) {
    if (typeof define === "function" && define.amd) define([
        "module"
    ], factory);
    else {
        var mod;
        factory(module);
    }
})(this, function(module1) {
    "use strict";
    var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    module1.exports = (typeof self === "undefined" ? "undefined" : _typeof(self)) === "object" && self.self === self && self || (typeof $parcel$global === "undefined" ? "undefined" : _typeof($parcel$global)) === "object" && $parcel$global.global === $parcel$global && $parcel$global || undefined;
});

});


parcelRegister("bGOQR", function(module, exports) {
(function(global, factory) {
    if (typeof define === "function" && define.amd) define([
        "exports"
    ], factory);
    else {
        var mod;
        factory(module.exports);
    }
})(module.exports, function(exports1) {
    "use strict";
    Object.defineProperty(exports1, "__esModule", {
        value: true
    });
    var GoogleApi = exports1.GoogleApi = function GoogleApi(opts) {
        opts = opts || {};
        if (!opts.hasOwnProperty("apiKey")) throw new Error("You must pass an apiKey to use GoogleApi");
        var apiKey = opts.apiKey;
        var libraries = opts.libraries || [
            "places"
        ];
        var client = opts.client;
        var URL = opts.url || "https://maps.googleapis.com/maps/api/js";
        var googleVersion = opts.version || "3.31";
        var script = null;
        var google = typeof window !== "undefined" && window.google || null;
        var loading = false;
        var channel = null;
        var language = opts.language;
        var region = opts.region || null;
        var onLoadEvents = [];
        var url = function url() {
            var url = URL;
            var params = {
                key: apiKey,
                callback: "CALLBACK_NAME",
                libraries: libraries.join(","),
                client: client,
                v: googleVersion,
                channel: channel,
                language: language,
                region: region,
                onerror: "ERROR_FUNCTION"
            };
            var paramStr = Object.keys(params).filter(function(k) {
                return !!params[k];
            }).map(function(k) {
                return k + "=" + params[k];
            }).join("&");
            return url + "?" + paramStr;
        };
        return url();
    };
    exports1.default = GoogleApi;
});

});


parcelRegister("iKDvV", function(module, exports) {



(function(global, factory) {
    if (typeof define === "function" && define.amd) define([
        "exports",
        "react",
        "prop-types",
        "../lib/String"
    ], factory);
    else {
        var mod;
        factory(module.exports, (parcelRequire("acw62")), (parcelRequire("c9Z8w")), (parcelRequire("7twkG")));
    }
})(module.exports, function(exports1, _react, _propTypes, _String) {
    "use strict";
    Object.defineProperty(exports1, "__esModule", {
        value: true
    });
    exports1.Marker = undefined;
    var _react2 = _interopRequireDefault(_react);
    var _propTypes2 = _interopRequireDefault(_propTypes);
    function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
            default: obj
        };
    }
    var _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    function _objectWithoutProperties(obj, keys) {
        var target = {};
        for(var i in obj){
            if (keys.indexOf(i) >= 0) continue;
            if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
            target[i] = obj[i];
        }
        return target;
    }
    function _classCallCheck(instance, Constructor) {
        if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
    }
    var _createClass = function() {
        function defineProperties(target, props) {
            for(var i = 0; i < props.length; i++){
                var descriptor = props[i];
                descriptor.enumerable = descriptor.enumerable || false;
                descriptor.configurable = true;
                if ("value" in descriptor) descriptor.writable = true;
                Object.defineProperty(target, descriptor.key, descriptor);
            }
        }
        return function(Constructor, protoProps, staticProps) {
            if (protoProps) defineProperties(Constructor.prototype, protoProps);
            if (staticProps) defineProperties(Constructor, staticProps);
            return Constructor;
        };
    }();
    function _possibleConstructorReturn(self, call) {
        if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return call && (typeof call === "object" || typeof call === "function") ? call : self;
    }
    function _inherits(subClass, superClass) {
        if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
        subClass.prototype = Object.create(superClass && superClass.prototype, {
            constructor: {
                value: subClass,
                enumerable: false,
                writable: true,
                configurable: true
            }
        });
        if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
    }
    var evtNames = [
        "click",
        "dblclick",
        "dragend",
        "mousedown",
        "mouseout",
        "mouseover",
        "mouseup",
        "recenter"
    ];
    var wrappedPromise = function wrappedPromise() {
        var wrappedPromise = {}, promise = new Promise(function(resolve, reject) {
            wrappedPromise.resolve = resolve;
            wrappedPromise.reject = reject;
        });
        wrappedPromise.then = promise.then.bind(promise);
        wrappedPromise.catch = promise.catch.bind(promise);
        wrappedPromise.promise = promise;
        return wrappedPromise;
    };
    var Marker = exports1.Marker = function(_React$Component) {
        _inherits(Marker, _React$Component);
        function Marker() {
            _classCallCheck(this, Marker);
            return _possibleConstructorReturn(this, (Marker.__proto__ || Object.getPrototypeOf(Marker)).apply(this, arguments));
        }
        _createClass(Marker, [
            {
                key: "componentDidMount",
                value: function componentDidMount() {
                    this.markerPromise = wrappedPromise();
                    this.renderMarker();
                }
            },
            {
                key: "componentDidUpdate",
                value: function componentDidUpdate(prevProps) {
                    if (this.props.map !== prevProps.map || this.props.position !== prevProps.position || this.props.icon !== prevProps.icon) {
                        if (this.marker) this.marker.setMap(null);
                        this.renderMarker();
                    }
                }
            },
            {
                key: "componentWillUnmount",
                value: function componentWillUnmount() {
                    if (this.marker) this.marker.setMap(null);
                }
            },
            {
                key: "renderMarker",
                value: function renderMarker() {
                    var _this2 = this;
                    var _props = this.props, map = _props.map, google = _props.google, position = _props.position, mapCenter = _props.mapCenter, icon = _props.icon, label = _props.label, draggable = _props.draggable, title = _props.title, props = _objectWithoutProperties(_props, [
                        "map",
                        "google",
                        "position",
                        "mapCenter",
                        "icon",
                        "label",
                        "draggable",
                        "title"
                    ]);
                    if (!google) return null;
                    var pos = position || mapCenter;
                    if (!(pos instanceof google.maps.LatLng)) pos = new google.maps.LatLng(pos.lat, pos.lng);
                    var pref = _extends({
                        map: map,
                        position: pos,
                        icon: icon,
                        label: label,
                        title: title,
                        draggable: draggable
                    }, props);
                    this.marker = new google.maps.Marker(pref);
                    evtNames.forEach(function(e) {
                        _this2.marker.addListener(e, _this2.handleEvent(e));
                    });
                    this.markerPromise.resolve(this.marker);
                }
            },
            {
                key: "getMarker",
                value: function getMarker() {
                    return this.markerPromise;
                }
            },
            {
                key: "handleEvent",
                value: function handleEvent(evt) {
                    var _this3 = this;
                    return function(e) {
                        var evtName = "on" + (0, _String.camelize)(evt);
                        if (_this3.props[evtName]) _this3.props[evtName](_this3.props, _this3.marker, e);
                    };
                }
            },
            {
                key: "render",
                value: function render() {
                    return null;
                }
            }
        ]);
        return Marker;
    }(_react2.default.Component);
    Marker.propTypes = {
        position: _propTypes2.default.object,
        map: _propTypes2.default.object
    };
    evtNames.forEach(function(e) {
        return Marker.propTypes[e] = _propTypes2.default.func;
    });
    Marker.defaultProps = {
        name: "Marker"
    };
    exports1.default = Marker;
});

});
parcelRegister("7twkG", function(module, exports) {
(function(global, factory) {
    if (typeof define === "function" && define.amd) define([
        "exports"
    ], factory);
    else {
        var mod;
        factory(module.exports);
    }
})(module.exports, function(exports1) {
    "use strict";
    Object.defineProperty(exports1, "__esModule", {
        value: true
    });
    var camelize = exports1.camelize = function camelize(str) {
        return str.split("_").map(function(word) {
            return word.charAt(0).toUpperCase() + word.slice(1);
        }).join("");
    };
});

});


parcelRegister("l5unh", function(module, exports) {




(function(global, factory) {
    if (typeof define === "function" && define.amd) define([
        "exports",
        "react",
        "prop-types",
        "react-dom",
        "react-dom/server"
    ], factory);
    else {
        var mod;
        factory(module.exports, (parcelRequire("acw62")), (parcelRequire("c9Z8w")), (parcelRequire("1u0KT")), (parcelRequire("kZ6Rz")));
    }
})(module.exports, function(exports1, _react, _propTypes, _reactDom, _server) {
    "use strict";
    Object.defineProperty(exports1, "__esModule", {
        value: true
    });
    exports1.InfoWindow = undefined;
    var _react2 = _interopRequireDefault(_react);
    var _propTypes2 = _interopRequireDefault(_propTypes);
    var _reactDom2 = _interopRequireDefault(_reactDom);
    var _server2 = _interopRequireDefault(_server);
    function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
            default: obj
        };
    }
    var _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    function _objectWithoutProperties(obj, keys) {
        var target = {};
        for(var i in obj){
            if (keys.indexOf(i) >= 0) continue;
            if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
            target[i] = obj[i];
        }
        return target;
    }
    function _classCallCheck(instance, Constructor) {
        if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
    }
    var _createClass = function() {
        function defineProperties(target, props) {
            for(var i = 0; i < props.length; i++){
                var descriptor = props[i];
                descriptor.enumerable = descriptor.enumerable || false;
                descriptor.configurable = true;
                if ("value" in descriptor) descriptor.writable = true;
                Object.defineProperty(target, descriptor.key, descriptor);
            }
        }
        return function(Constructor, protoProps, staticProps) {
            if (protoProps) defineProperties(Constructor.prototype, protoProps);
            if (staticProps) defineProperties(Constructor, staticProps);
            return Constructor;
        };
    }();
    function _possibleConstructorReturn(self, call) {
        if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return call && (typeof call === "object" || typeof call === "function") ? call : self;
    }
    function _inherits(subClass, superClass) {
        if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
        subClass.prototype = Object.create(superClass && superClass.prototype, {
            constructor: {
                value: subClass,
                enumerable: false,
                writable: true,
                configurable: true
            }
        });
        if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
    }
    var InfoWindow = exports1.InfoWindow = function(_React$Component) {
        _inherits(InfoWindow, _React$Component);
        function InfoWindow() {
            _classCallCheck(this, InfoWindow);
            return _possibleConstructorReturn(this, (InfoWindow.__proto__ || Object.getPrototypeOf(InfoWindow)).apply(this, arguments));
        }
        _createClass(InfoWindow, [
            {
                key: "componentDidMount",
                value: function componentDidMount() {
                    this.renderInfoWindow();
                }
            },
            {
                key: "componentDidUpdate",
                value: function componentDidUpdate(prevProps) {
                    var _props = this.props, google1 = _props.google, map = _props.map;
                    if (!google1 || !map) return;
                    if (map !== prevProps.map) this.renderInfoWindow();
                    if (this.props.position !== prevProps.position) this.updatePosition();
                    if (this.props.children !== prevProps.children) this.updateContent();
                    if (this.props.visible !== prevProps.visible || this.props.marker !== prevProps.marker || this.props.position !== prevProps.position) this.props.visible ? this.openWindow() : this.closeWindow();
                }
            },
            {
                key: "renderInfoWindow",
                value: function renderInfoWindow() {
                    var _props2 = this.props, map = _props2.map, google1 = _props2.google, mapCenter = _props2.mapCenter, props = _objectWithoutProperties(_props2, [
                        "map",
                        "google",
                        "mapCenter"
                    ]);
                    if (!google1 || !google1.maps) return;
                    var iw = this.infowindow = new google1.maps.InfoWindow(_extends({
                        content: ""
                    }, props));
                    google1.maps.event.addListener(iw, "closeclick", this.onClose.bind(this));
                    google1.maps.event.addListener(iw, "domready", this.onOpen.bind(this));
                }
            },
            {
                key: "onOpen",
                value: function onOpen() {
                    if (this.props.onOpen) this.props.onOpen();
                }
            },
            {
                key: "onClose",
                value: function onClose() {
                    if (this.props.onClose) this.props.onClose();
                }
            },
            {
                key: "openWindow",
                value: function openWindow() {
                    this.infowindow.open(this.props.map, this.props.marker);
                }
            },
            {
                key: "updatePosition",
                value: function updatePosition() {
                    var pos = this.props.position;
                    if (!(pos instanceof google.maps.LatLng)) pos = pos && new google.maps.LatLng(pos.lat, pos.lng);
                    this.infowindow.setPosition(pos);
                }
            },
            {
                key: "updateContent",
                value: function updateContent() {
                    var content = this.renderChildren();
                    this.infowindow.setContent(content);
                }
            },
            {
                key: "closeWindow",
                value: function closeWindow() {
                    this.infowindow.close();
                }
            },
            {
                key: "renderChildren",
                value: function renderChildren() {
                    var children = this.props.children;
                    return _server2.default.renderToString(children);
                }
            },
            {
                key: "render",
                value: function render() {
                    return null;
                }
            }
        ]);
        return InfoWindow;
    }(_react2.default.Component);
    InfoWindow.propTypes = {
        children: _propTypes2.default.element.isRequired,
        map: _propTypes2.default.object,
        marker: _propTypes2.default.object,
        position: _propTypes2.default.object,
        visible: _propTypes2.default.bool,
        // callbacks
        onClose: _propTypes2.default.func,
        onOpen: _propTypes2.default.func
    };
    InfoWindow.defaultProps = {
        visible: false
    };
    exports1.default = InfoWindow;
});

});
parcelRegister("kZ6Rz", function(module, exports) {

$parcel$export(module.exports, "version", () => $f46ed4009cb9c1cd$export$83d89fbfd8236492, (v) => $f46ed4009cb9c1cd$export$83d89fbfd8236492 = v);
$parcel$export(module.exports, "renderToString", () => $f46ed4009cb9c1cd$export$80e7718417253a51, (v) => $f46ed4009cb9c1cd$export$80e7718417253a51 = v);
$parcel$export(module.exports, "renderToStaticMarkup", () => $f46ed4009cb9c1cd$export$eb3a06aef9e6ee51, (v) => $f46ed4009cb9c1cd$export$eb3a06aef9e6ee51 = v);
$parcel$export(module.exports, "renderToNodeStream", () => $f46ed4009cb9c1cd$export$307591e98609eddd, (v) => $f46ed4009cb9c1cd$export$307591e98609eddd = v);
$parcel$export(module.exports, "renderToStaticNodeStream", () => $f46ed4009cb9c1cd$export$b23711c915539651, (v) => $f46ed4009cb9c1cd$export$b23711c915539651 = v);
$parcel$export(module.exports, "renderToReadableStream", () => $f46ed4009cb9c1cd$export$7020a3240b287705, (v) => $f46ed4009cb9c1cd$export$7020a3240b287705 = v);
var $f46ed4009cb9c1cd$export$83d89fbfd8236492;
var $f46ed4009cb9c1cd$export$80e7718417253a51;
var $f46ed4009cb9c1cd$export$eb3a06aef9e6ee51;
var $f46ed4009cb9c1cd$export$307591e98609eddd;
var $f46ed4009cb9c1cd$export$b23711c915539651;
var $f46ed4009cb9c1cd$export$7020a3240b287705;
"use strict";
var $f46ed4009cb9c1cd$var$l, $f46ed4009cb9c1cd$var$s;

$f46ed4009cb9c1cd$var$l = (parcelRequire("Rr1ew"));

$f46ed4009cb9c1cd$var$s = (parcelRequire("2jGA3"));
$f46ed4009cb9c1cd$export$83d89fbfd8236492 = $f46ed4009cb9c1cd$var$l.version;
$f46ed4009cb9c1cd$export$80e7718417253a51 = $f46ed4009cb9c1cd$var$l.renderToString;
$f46ed4009cb9c1cd$export$eb3a06aef9e6ee51 = $f46ed4009cb9c1cd$var$l.renderToStaticMarkup;
$f46ed4009cb9c1cd$export$307591e98609eddd = $f46ed4009cb9c1cd$var$l.renderToNodeStream;
$f46ed4009cb9c1cd$export$b23711c915539651 = $f46ed4009cb9c1cd$var$l.renderToStaticNodeStream;
$f46ed4009cb9c1cd$export$7020a3240b287705 = $f46ed4009cb9c1cd$var$s.renderToReadableStream;

});
parcelRegister("Rr1ew", function(module, exports) {

$parcel$export(module.exports, "renderToNodeStream", () => $0a09e8bdaadac978$export$307591e98609eddd, (v) => $0a09e8bdaadac978$export$307591e98609eddd = v);
$parcel$export(module.exports, "renderToStaticMarkup", () => $0a09e8bdaadac978$export$eb3a06aef9e6ee51, (v) => $0a09e8bdaadac978$export$eb3a06aef9e6ee51 = v);
$parcel$export(module.exports, "renderToStaticNodeStream", () => $0a09e8bdaadac978$export$b23711c915539651, (v) => $0a09e8bdaadac978$export$b23711c915539651 = v);
$parcel$export(module.exports, "renderToString", () => $0a09e8bdaadac978$export$80e7718417253a51, (v) => $0a09e8bdaadac978$export$80e7718417253a51 = v);
$parcel$export(module.exports, "version", () => $0a09e8bdaadac978$export$83d89fbfd8236492, (v) => $0a09e8bdaadac978$export$83d89fbfd8236492 = v);
/**
 * @license React
 * react-dom-server-legacy.browser.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $0a09e8bdaadac978$export$307591e98609eddd;
var $0a09e8bdaadac978$export$eb3a06aef9e6ee51;
var $0a09e8bdaadac978$export$b23711c915539651;
var $0a09e8bdaadac978$export$80e7718417253a51;
var $0a09e8bdaadac978$export$83d89fbfd8236492;
"use strict";

(function() {
    "use strict";
    var React = (parcelRequire("acw62"));
    var ReactVersion = "18.2.0";
    var ReactSharedInternals = React.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    // by calls to these methods by a Babel plugin.
    //
    // In PROD (or in packages without access to React internals),
    // they are left as they are instead.
    function warn(format) {
        for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)args[_key - 1] = arguments[_key];
        printWarning("warn", format, args);
    }
    function error(format) {
        for(var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++)args[_key2 - 1] = arguments[_key2];
        printWarning("error", format, args);
    }
    function printWarning(level, format, args) {
        var ReactDebugCurrentFrame = ReactSharedInternals.ReactDebugCurrentFrame;
        var stack = ReactDebugCurrentFrame.getStackAddendum();
        if (stack !== "") {
            format += "%s";
            args = args.concat([
                stack
            ]);
        } // eslint-disable-next-line react-internal/safe-string-coercion
        var argsWithFormat = args.map(function(item) {
            return String(item);
        }); // Careful: RN currently depends on this prefix
        argsWithFormat.unshift("Warning: " + format); // We intentionally don't use spread (or .apply) directly because it
        // breaks IE9: https://github.com/facebook/react/issues/13610
        // eslint-disable-next-line react-internal/no-production-logging
        Function.prototype.apply.call(console[level], console, argsWithFormat);
    }
    function scheduleWork(callback) {
        callback();
    }
    function beginWriting(destination) {}
    function writeChunk(destination, chunk) {
        writeChunkAndReturn(destination, chunk);
    }
    function writeChunkAndReturn(destination, chunk) {
        return destination.push(chunk);
    }
    function completeWriting(destination) {}
    function close(destination) {
        destination.push(null);
    }
    function stringToChunk(content) {
        return content;
    }
    function stringToPrecomputedChunk(content) {
        return content;
    }
    function closeWithError(destination, error) {
        // $FlowFixMe: This is an Error object or the destination accepts other types.
        destination.destroy(error);
    }
    /*
 * The `'' + value` pattern (used in in perf-sensitive code) throws for Symbol
 * and Temporal.* types. See https://github.com/facebook/react/pull/22064.
 *
 * The functions in this module will throw an easier-to-understand,
 * easier-to-debug exception with a clear errors message message explaining the
 * problem. (Instead of a confusing exception thrown inside the implementation
 * of the `value` object).
 */ // $FlowFixMe only called in DEV, so void return is not possible.
    function typeName(value) {
        // toStringTag is needed for namespaced types like Temporal.Instant
        var hasToStringTag = typeof Symbol === "function" && Symbol.toStringTag;
        var type = hasToStringTag && value[Symbol.toStringTag] || value.constructor.name || "Object";
        return type;
    } // $FlowFixMe only called in DEV, so void return is not possible.
    function willCoercionThrow(value) {
        try {
            testStringCoercion(value);
            return false;
        } catch (e) {
            return true;
        }
    }
    function testStringCoercion(value) {
        // If you ended up here by following an exception call stack, here's what's
        // happened: you supplied an object or symbol value to React (as a prop, key,
        // DOM attribute, CSS property, string ref, etc.) and when React tried to
        // coerce it to a string using `'' + value`, an exception was thrown.
        //
        // The most common types that will cause this exception are `Symbol` instances
        // and Temporal objects like `Temporal.Instant`. But any object that has a
        // `valueOf` or `[Symbol.toPrimitive]` method that throws will also cause this
        // exception. (Library authors do this to prevent users from using built-in
        // numeric operators like `+` or comparison operators like `>=` because custom
        // methods are needed to perform accurate arithmetic or comparison.)
        //
        // To fix the problem, coerce this object or symbol value to a string before
        // passing it to React. The most reliable way is usually `String(value)`.
        //
        // To find which value is throwing, check the browser or debugger console.
        // Before this exception was thrown, there should be `console.error` output
        // that shows the type (Symbol, Temporal.PlainDate, etc.) that caused the
        // problem and how that type was used: key, atrribute, input value prop, etc.
        // In most cases, this console output also shows the component and its
        // ancestor components where the exception happened.
        //
        // eslint-disable-next-line react-internal/safe-string-coercion
        return "" + value;
    }
    function checkAttributeStringCoercion(value, attributeName) {
        if (willCoercionThrow(value)) {
            error("The provided `%s` attribute is an unsupported type %s. This value must be coerced to a string before before using it here.", attributeName, typeName(value));
            return testStringCoercion(value); // throw (to help callers find troubleshooting comments)
        }
    }
    function checkCSSPropertyStringCoercion(value, propName) {
        if (willCoercionThrow(value)) {
            error("The provided `%s` CSS property is an unsupported type %s. This value must be coerced to a string before before using it here.", propName, typeName(value));
            return testStringCoercion(value); // throw (to help callers find troubleshooting comments)
        }
    }
    function checkHtmlStringCoercion(value) {
        if (willCoercionThrow(value)) {
            error("The provided HTML markup uses a value of unsupported type %s. This value must be coerced to a string before before using it here.", typeName(value));
            return testStringCoercion(value); // throw (to help callers find troubleshooting comments)
        }
    }
    var hasOwnProperty = Object.prototype.hasOwnProperty;
    // A reserved attribute.
    // It is handled by React separately and shouldn't be written to the DOM.
    var RESERVED = 0; // A simple string attribute.
    // Attributes that aren't in the filter are presumed to have this type.
    var STRING = 1; // A string attribute that accepts booleans in React. In HTML, these are called
    // "enumerated" attributes with "true" and "false" as possible values.
    // When true, it should be set to a "true" string.
    // When false, it should be set to a "false" string.
    var BOOLEANISH_STRING = 2; // A real boolean attribute.
    // When true, it should be present (set either to an empty string or its name).
    // When false, it should be omitted.
    var BOOLEAN = 3; // An attribute that can be used as a flag as well as with a value.
    // When true, it should be present (set either to an empty string or its name).
    // When false, it should be omitted.
    // For any other value, should be present with that value.
    var OVERLOADED_BOOLEAN = 4; // An attribute that must be numeric or parse as a numeric.
    // When falsy, it should be removed.
    var NUMERIC = 5; // An attribute that must be positive numeric or parse as a positive numeric.
    // When falsy, it should be removed.
    var POSITIVE_NUMERIC = 6;
    /* eslint-disable max-len */ var ATTRIBUTE_NAME_START_CHAR = ":A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD";
    /* eslint-enable max-len */ var ATTRIBUTE_NAME_CHAR = ATTRIBUTE_NAME_START_CHAR + "\\-.0-9\\u00B7\\u0300-\\u036F\\u203F-\\u2040";
    var VALID_ATTRIBUTE_NAME_REGEX = new RegExp("^[" + ATTRIBUTE_NAME_START_CHAR + "][" + ATTRIBUTE_NAME_CHAR + "]*$");
    var illegalAttributeNameCache = {};
    var validatedAttributeNameCache = {};
    function isAttributeNameSafe(attributeName) {
        if (hasOwnProperty.call(validatedAttributeNameCache, attributeName)) return true;
        if (hasOwnProperty.call(illegalAttributeNameCache, attributeName)) return false;
        if (VALID_ATTRIBUTE_NAME_REGEX.test(attributeName)) {
            validatedAttributeNameCache[attributeName] = true;
            return true;
        }
        illegalAttributeNameCache[attributeName] = true;
        error("Invalid attribute name: `%s`", attributeName);
        return false;
    }
    function shouldRemoveAttributeWithWarning(name, value, propertyInfo, isCustomComponentTag) {
        if (propertyInfo !== null && propertyInfo.type === RESERVED) return false;
        switch(typeof value){
            case "function":
            case "symbol":
                // eslint-disable-line
                return true;
            case "boolean":
                if (isCustomComponentTag) return false;
                if (propertyInfo !== null) return !propertyInfo.acceptsBooleans;
                else {
                    var prefix = name.toLowerCase().slice(0, 5);
                    return prefix !== "data-" && prefix !== "aria-";
                }
            default:
                return false;
        }
    }
    function getPropertyInfo(name) {
        return properties.hasOwnProperty(name) ? properties[name] : null;
    }
    function PropertyInfoRecord(name, type, mustUseProperty, attributeName, attributeNamespace, sanitizeURL, removeEmptyString) {
        this.acceptsBooleans = type === BOOLEANISH_STRING || type === BOOLEAN || type === OVERLOADED_BOOLEAN;
        this.attributeName = attributeName;
        this.attributeNamespace = attributeNamespace;
        this.mustUseProperty = mustUseProperty;
        this.propertyName = name;
        this.type = type;
        this.sanitizeURL = sanitizeURL;
        this.removeEmptyString = removeEmptyString;
    } // When adding attributes to this list, be sure to also add them to
    // the `possibleStandardNames` module to ensure casing and incorrect
    // name warnings.
    var properties = {}; // These props are reserved by React. They shouldn't be written to the DOM.
    var reservedProps = [
        "children",
        "dangerouslySetInnerHTML",
        // elements (not just inputs). Now that ReactDOMInput assigns to the
        // defaultValue property -- do we need this?
        "defaultValue",
        "defaultChecked",
        "innerHTML",
        "suppressContentEditableWarning",
        "suppressHydrationWarning",
        "style"
    ];
    reservedProps.forEach(function(name) {
        properties[name] = new PropertyInfoRecord(name, RESERVED, false, name, null, false, false);
    }); // A few React string attributes have a different name.
    // This is a mapping from React prop names to the attribute names.
    [
        [
            "acceptCharset",
            "accept-charset"
        ],
        [
            "className",
            "class"
        ],
        [
            "htmlFor",
            "for"
        ],
        [
            "httpEquiv",
            "http-equiv"
        ]
    ].forEach(function(_ref) {
        var name = _ref[0], attributeName = _ref[1];
        properties[name] = new PropertyInfoRecord(name, STRING, false, attributeName, null, false, false);
    }); // These are "enumerated" HTML attributes that accept "true" and "false".
    // In React, we let users pass `true` and `false` even though technically
    // these aren't boolean attributes (they are coerced to strings).
    [
        "contentEditable",
        "draggable",
        "spellCheck",
        "value"
    ].forEach(function(name) {
        properties[name] = new PropertyInfoRecord(name, BOOLEANISH_STRING, false, name.toLowerCase(), null, false, false);
    }); // These are "enumerated" SVG attributes that accept "true" and "false".
    // In React, we let users pass `true` and `false` even though technically
    // these aren't boolean attributes (they are coerced to strings).
    // Since these are SVG attributes, their attribute names are case-sensitive.
    [
        "autoReverse",
        "externalResourcesRequired",
        "focusable",
        "preserveAlpha"
    ].forEach(function(name) {
        properties[name] = new PropertyInfoRecord(name, BOOLEANISH_STRING, false, name, null, false, false);
    }); // These are HTML boolean attributes.
    [
        "allowFullScreen",
        "async",
        // on the client side because the browsers are inconsistent. Instead we call focus().
        "autoFocus",
        "autoPlay",
        "controls",
        "default",
        "defer",
        "disabled",
        "disablePictureInPicture",
        "disableRemotePlayback",
        "formNoValidate",
        "hidden",
        "loop",
        "noModule",
        "noValidate",
        "open",
        "playsInline",
        "readOnly",
        "required",
        "reversed",
        "scoped",
        "seamless",
        "itemScope"
    ].forEach(function(name) {
        properties[name] = new PropertyInfoRecord(name, BOOLEAN, false, name.toLowerCase(), null, false, false);
    }); // These are the few React props that we set as DOM properties
    // rather than attributes. These are all booleans.
    [
        "checked",
        // disabled with `removeAttribute`. We have special logic for handling this.
        "multiple",
        "muted",
        "selected" // NOTE: if you add a camelCased prop to this list,
    ].forEach(function(name) {
        properties[name] = new PropertyInfoRecord(name, BOOLEAN, true, name, null, false, false);
    }); // These are HTML attributes that are "overloaded booleans": they behave like
    // booleans, but can also accept a string value.
    [
        "capture",
        "download" // NOTE: if you add a camelCased prop to this list,
    ].forEach(function(name) {
        properties[name] = new PropertyInfoRecord(name, OVERLOADED_BOOLEAN, false, name, null, false, false);
    }); // These are HTML attributes that must be positive numbers.
    [
        "cols",
        "rows",
        "size",
        "span" // NOTE: if you add a camelCased prop to this list,
    ].forEach(function(name) {
        properties[name] = new PropertyInfoRecord(name, POSITIVE_NUMERIC, false, name, null, false, false);
    }); // These are HTML attributes that must be numbers.
    [
        "rowSpan",
        "start"
    ].forEach(function(name) {
        properties[name] = new PropertyInfoRecord(name, NUMERIC, false, name.toLowerCase(), null, false, false);
    });
    var CAMELIZE = /[\-\:]([a-z])/g;
    var capitalize = function(token) {
        return token[1].toUpperCase();
    }; // This is a list of all SVG attributes that need special casing, namespacing,
    // or boolean value assignment. Regular attributes that just accept strings
    // and have the same names are omitted, just like in the HTML attribute filter.
    // Some of these attributes can be hard to find. This list was created by
    // scraping the MDN documentation.
    [
        "accent-height",
        "alignment-baseline",
        "arabic-form",
        "baseline-shift",
        "cap-height",
        "clip-path",
        "clip-rule",
        "color-interpolation",
        "color-interpolation-filters",
        "color-profile",
        "color-rendering",
        "dominant-baseline",
        "enable-background",
        "fill-opacity",
        "fill-rule",
        "flood-color",
        "flood-opacity",
        "font-family",
        "font-size",
        "font-size-adjust",
        "font-stretch",
        "font-style",
        "font-variant",
        "font-weight",
        "glyph-name",
        "glyph-orientation-horizontal",
        "glyph-orientation-vertical",
        "horiz-adv-x",
        "horiz-origin-x",
        "image-rendering",
        "letter-spacing",
        "lighting-color",
        "marker-end",
        "marker-mid",
        "marker-start",
        "overline-position",
        "overline-thickness",
        "paint-order",
        "panose-1",
        "pointer-events",
        "rendering-intent",
        "shape-rendering",
        "stop-color",
        "stop-opacity",
        "strikethrough-position",
        "strikethrough-thickness",
        "stroke-dasharray",
        "stroke-dashoffset",
        "stroke-linecap",
        "stroke-linejoin",
        "stroke-miterlimit",
        "stroke-opacity",
        "stroke-width",
        "text-anchor",
        "text-decoration",
        "text-rendering",
        "underline-position",
        "underline-thickness",
        "unicode-bidi",
        "unicode-range",
        "units-per-em",
        "v-alphabetic",
        "v-hanging",
        "v-ideographic",
        "v-mathematical",
        "vector-effect",
        "vert-adv-y",
        "vert-origin-x",
        "vert-origin-y",
        "word-spacing",
        "writing-mode",
        "xmlns:xlink",
        "x-height" // NOTE: if you add a camelCased prop to this list,
    ].forEach(function(attributeName) {
        var name = attributeName.replace(CAMELIZE, capitalize);
        properties[name] = new PropertyInfoRecord(name, STRING, false, attributeName, null, false, false);
    }); // String SVG attributes with the xlink namespace.
    [
        "xlink:actuate",
        "xlink:arcrole",
        "xlink:role",
        "xlink:show",
        "xlink:title",
        "xlink:type" // NOTE: if you add a camelCased prop to this list,
    ].forEach(function(attributeName) {
        var name = attributeName.replace(CAMELIZE, capitalize);
        properties[name] = new PropertyInfoRecord(name, STRING, false, attributeName, "http://www.w3.org/1999/xlink", false, false);
    }); // String SVG attributes with the xml namespace.
    [
        "xml:base",
        "xml:lang",
        "xml:space" // NOTE: if you add a camelCased prop to this list,
    ].forEach(function(attributeName) {
        var name = attributeName.replace(CAMELIZE, capitalize);
        properties[name] = new PropertyInfoRecord(name, STRING, false, attributeName, "http://www.w3.org/XML/1998/namespace", false, false);
    }); // These attribute exists both in HTML and SVG.
    // The attribute name is case-sensitive in SVG so we can't just use
    // the React name like we do for attributes that exist only in HTML.
    [
        "tabIndex",
        "crossOrigin"
    ].forEach(function(attributeName) {
        properties[attributeName] = new PropertyInfoRecord(attributeName, STRING, false, attributeName.toLowerCase(), null, false, false);
    }); // These attributes accept URLs. These must not allow javascript: URLS.
    // These will also need to accept Trusted Types object in the future.
    var xlinkHref = "xlinkHref";
    properties[xlinkHref] = new PropertyInfoRecord("xlinkHref", STRING, false, "xlink:href", "http://www.w3.org/1999/xlink", true, false);
    [
        "src",
        "href",
        "action",
        "formAction"
    ].forEach(function(attributeName) {
        properties[attributeName] = new PropertyInfoRecord(attributeName, STRING, false, attributeName.toLowerCase(), null, true, true);
    });
    /**
 * CSS properties which accept numbers but are not in units of "px".
 */ var isUnitlessNumber = {
        animationIterationCount: true,
        aspectRatio: true,
        borderImageOutset: true,
        borderImageSlice: true,
        borderImageWidth: true,
        boxFlex: true,
        boxFlexGroup: true,
        boxOrdinalGroup: true,
        columnCount: true,
        columns: true,
        flex: true,
        flexGrow: true,
        flexPositive: true,
        flexShrink: true,
        flexNegative: true,
        flexOrder: true,
        gridArea: true,
        gridRow: true,
        gridRowEnd: true,
        gridRowSpan: true,
        gridRowStart: true,
        gridColumn: true,
        gridColumnEnd: true,
        gridColumnSpan: true,
        gridColumnStart: true,
        fontWeight: true,
        lineClamp: true,
        lineHeight: true,
        opacity: true,
        order: true,
        orphans: true,
        tabSize: true,
        widows: true,
        zIndex: true,
        zoom: true,
        // SVG-related properties
        fillOpacity: true,
        floodOpacity: true,
        stopOpacity: true,
        strokeDasharray: true,
        strokeDashoffset: true,
        strokeMiterlimit: true,
        strokeOpacity: true,
        strokeWidth: true
    };
    /**
 * @param {string} prefix vendor-specific prefix, eg: Webkit
 * @param {string} key style name, eg: transitionDuration
 * @return {string} style name prefixed with `prefix`, properly camelCased, eg:
 * WebkitTransitionDuration
 */ function prefixKey(prefix, key) {
        return prefix + key.charAt(0).toUpperCase() + key.substring(1);
    }
    /**
 * Support style names that may come passed in prefixed by adding permutations
 * of vendor prefixes.
 */ var prefixes = [
        "Webkit",
        "ms",
        "Moz",
        "O"
    ]; // Using Object.keys here, or else the vanilla for-in loop makes IE8 go into an
    // infinite loop, because it iterates over the newly added props too.
    Object.keys(isUnitlessNumber).forEach(function(prop) {
        prefixes.forEach(function(prefix) {
            isUnitlessNumber[prefixKey(prefix, prop)] = isUnitlessNumber[prop];
        });
    });
    var hasReadOnlyValue = {
        button: true,
        checkbox: true,
        image: true,
        hidden: true,
        radio: true,
        reset: true,
        submit: true
    };
    function checkControlledValueProps(tagName, props) {
        if (!(hasReadOnlyValue[props.type] || props.onChange || props.onInput || props.readOnly || props.disabled || props.value == null)) error("You provided a `value` prop to a form field without an `onChange` handler. This will render a read-only field. If the field should be mutable use `defaultValue`. Otherwise, set either `onChange` or `readOnly`.");
        if (!(props.onChange || props.readOnly || props.disabled || props.checked == null)) error("You provided a `checked` prop to a form field without an `onChange` handler. This will render a read-only field. If the field should be mutable use `defaultChecked`. Otherwise, set either `onChange` or `readOnly`.");
    }
    function isCustomComponent(tagName, props) {
        if (tagName.indexOf("-") === -1) return typeof props.is === "string";
        switch(tagName){
            // These are reserved SVG and MathML elements.
            // We don't mind this list too much because we expect it to never grow.
            // The alternative is to track the namespace in a few places which is convoluted.
            // https://w3c.github.io/webcomponents/spec/custom/#custom-elements-core-concepts
            case "annotation-xml":
            case "color-profile":
            case "font-face":
            case "font-face-src":
            case "font-face-uri":
            case "font-face-format":
            case "font-face-name":
            case "missing-glyph":
                return false;
            default:
                return true;
        }
    }
    var ariaProperties = {
        "aria-current": 0,
        // state
        "aria-description": 0,
        "aria-details": 0,
        "aria-disabled": 0,
        // state
        "aria-hidden": 0,
        // state
        "aria-invalid": 0,
        // state
        "aria-keyshortcuts": 0,
        "aria-label": 0,
        "aria-roledescription": 0,
        // Widget Attributes
        "aria-autocomplete": 0,
        "aria-checked": 0,
        "aria-expanded": 0,
        "aria-haspopup": 0,
        "aria-level": 0,
        "aria-modal": 0,
        "aria-multiline": 0,
        "aria-multiselectable": 0,
        "aria-orientation": 0,
        "aria-placeholder": 0,
        "aria-pressed": 0,
        "aria-readonly": 0,
        "aria-required": 0,
        "aria-selected": 0,
        "aria-sort": 0,
        "aria-valuemax": 0,
        "aria-valuemin": 0,
        "aria-valuenow": 0,
        "aria-valuetext": 0,
        // Live Region Attributes
        "aria-atomic": 0,
        "aria-busy": 0,
        "aria-live": 0,
        "aria-relevant": 0,
        // Drag-and-Drop Attributes
        "aria-dropeffect": 0,
        "aria-grabbed": 0,
        // Relationship Attributes
        "aria-activedescendant": 0,
        "aria-colcount": 0,
        "aria-colindex": 0,
        "aria-colspan": 0,
        "aria-controls": 0,
        "aria-describedby": 0,
        "aria-errormessage": 0,
        "aria-flowto": 0,
        "aria-labelledby": 0,
        "aria-owns": 0,
        "aria-posinset": 0,
        "aria-rowcount": 0,
        "aria-rowindex": 0,
        "aria-rowspan": 0,
        "aria-setsize": 0
    };
    var warnedProperties = {};
    var rARIA = new RegExp("^(aria)-[" + ATTRIBUTE_NAME_CHAR + "]*$");
    var rARIACamel = new RegExp("^(aria)[A-Z][" + ATTRIBUTE_NAME_CHAR + "]*$");
    function validateProperty(tagName, name) {
        if (hasOwnProperty.call(warnedProperties, name) && warnedProperties[name]) return true;
        if (rARIACamel.test(name)) {
            var ariaName = "aria-" + name.slice(4).toLowerCase();
            var correctName = ariaProperties.hasOwnProperty(ariaName) ? ariaName : null; // If this is an aria-* attribute, but is not listed in the known DOM
            // DOM properties, then it is an invalid aria-* attribute.
            if (correctName == null) {
                error("Invalid ARIA attribute `%s`. ARIA attributes follow the pattern aria-* and must be lowercase.", name);
                warnedProperties[name] = true;
                return true;
            } // aria-* attributes should be lowercase; suggest the lowercase version.
            if (name !== correctName) {
                error("Invalid ARIA attribute `%s`. Did you mean `%s`?", name, correctName);
                warnedProperties[name] = true;
                return true;
            }
        }
        if (rARIA.test(name)) {
            var lowerCasedName = name.toLowerCase();
            var standardName = ariaProperties.hasOwnProperty(lowerCasedName) ? lowerCasedName : null; // If this is an aria-* attribute, but is not listed in the known DOM
            // DOM properties, then it is an invalid aria-* attribute.
            if (standardName == null) {
                warnedProperties[name] = true;
                return false;
            } // aria-* attributes should be lowercase; suggest the lowercase version.
            if (name !== standardName) {
                error("Unknown ARIA attribute `%s`. Did you mean `%s`?", name, standardName);
                warnedProperties[name] = true;
                return true;
            }
        }
        return true;
    }
    function warnInvalidARIAProps(type, props) {
        var invalidProps = [];
        for(var key in props){
            var isValid = validateProperty(type, key);
            if (!isValid) invalidProps.push(key);
        }
        var unknownPropString = invalidProps.map(function(prop) {
            return "`" + prop + "`";
        }).join(", ");
        if (invalidProps.length === 1) error("Invalid aria prop %s on <%s> tag. For details, see https://reactjs.org/link/invalid-aria-props", unknownPropString, type);
        else if (invalidProps.length > 1) error("Invalid aria props %s on <%s> tag. For details, see https://reactjs.org/link/invalid-aria-props", unknownPropString, type);
    }
    function validateProperties(type, props) {
        if (isCustomComponent(type, props)) return;
        warnInvalidARIAProps(type, props);
    }
    var didWarnValueNull = false;
    function validateProperties$1(type, props) {
        if (type !== "input" && type !== "textarea" && type !== "select") return;
        if (props != null && props.value === null && !didWarnValueNull) {
            didWarnValueNull = true;
            if (type === "select" && props.multiple) error("`value` prop on `%s` should not be null. Consider using an empty array when `multiple` is set to `true` to clear the component or `undefined` for uncontrolled components.", type);
            else error("`value` prop on `%s` should not be null. Consider using an empty string to clear the component or `undefined` for uncontrolled components.", type);
        }
    }
    // When adding attributes to the HTML or SVG allowed attribute list, be sure to
    // also add them to this module to ensure casing and incorrect name
    // warnings.
    var possibleStandardNames = {
        // HTML
        accept: "accept",
        acceptcharset: "acceptCharset",
        "accept-charset": "acceptCharset",
        accesskey: "accessKey",
        action: "action",
        allowfullscreen: "allowFullScreen",
        alt: "alt",
        as: "as",
        async: "async",
        autocapitalize: "autoCapitalize",
        autocomplete: "autoComplete",
        autocorrect: "autoCorrect",
        autofocus: "autoFocus",
        autoplay: "autoPlay",
        autosave: "autoSave",
        capture: "capture",
        cellpadding: "cellPadding",
        cellspacing: "cellSpacing",
        challenge: "challenge",
        charset: "charSet",
        checked: "checked",
        children: "children",
        cite: "cite",
        class: "className",
        classid: "classID",
        classname: "className",
        cols: "cols",
        colspan: "colSpan",
        content: "content",
        contenteditable: "contentEditable",
        contextmenu: "contextMenu",
        controls: "controls",
        controlslist: "controlsList",
        coords: "coords",
        crossorigin: "crossOrigin",
        dangerouslysetinnerhtml: "dangerouslySetInnerHTML",
        data: "data",
        datetime: "dateTime",
        default: "default",
        defaultchecked: "defaultChecked",
        defaultvalue: "defaultValue",
        defer: "defer",
        dir: "dir",
        disabled: "disabled",
        disablepictureinpicture: "disablePictureInPicture",
        disableremoteplayback: "disableRemotePlayback",
        download: "download",
        draggable: "draggable",
        enctype: "encType",
        enterkeyhint: "enterKeyHint",
        for: "htmlFor",
        form: "form",
        formmethod: "formMethod",
        formaction: "formAction",
        formenctype: "formEncType",
        formnovalidate: "formNoValidate",
        formtarget: "formTarget",
        frameborder: "frameBorder",
        headers: "headers",
        height: "height",
        hidden: "hidden",
        high: "high",
        href: "href",
        hreflang: "hrefLang",
        htmlfor: "htmlFor",
        httpequiv: "httpEquiv",
        "http-equiv": "httpEquiv",
        icon: "icon",
        id: "id",
        imagesizes: "imageSizes",
        imagesrcset: "imageSrcSet",
        innerhtml: "innerHTML",
        inputmode: "inputMode",
        integrity: "integrity",
        is: "is",
        itemid: "itemID",
        itemprop: "itemProp",
        itemref: "itemRef",
        itemscope: "itemScope",
        itemtype: "itemType",
        keyparams: "keyParams",
        keytype: "keyType",
        kind: "kind",
        label: "label",
        lang: "lang",
        list: "list",
        loop: "loop",
        low: "low",
        manifest: "manifest",
        marginwidth: "marginWidth",
        marginheight: "marginHeight",
        max: "max",
        maxlength: "maxLength",
        media: "media",
        mediagroup: "mediaGroup",
        method: "method",
        min: "min",
        minlength: "minLength",
        multiple: "multiple",
        muted: "muted",
        name: "name",
        nomodule: "noModule",
        nonce: "nonce",
        novalidate: "noValidate",
        open: "open",
        optimum: "optimum",
        pattern: "pattern",
        placeholder: "placeholder",
        playsinline: "playsInline",
        poster: "poster",
        preload: "preload",
        profile: "profile",
        radiogroup: "radioGroup",
        readonly: "readOnly",
        referrerpolicy: "referrerPolicy",
        rel: "rel",
        required: "required",
        reversed: "reversed",
        role: "role",
        rows: "rows",
        rowspan: "rowSpan",
        sandbox: "sandbox",
        scope: "scope",
        scoped: "scoped",
        scrolling: "scrolling",
        seamless: "seamless",
        selected: "selected",
        shape: "shape",
        size: "size",
        sizes: "sizes",
        span: "span",
        spellcheck: "spellCheck",
        src: "src",
        srcdoc: "srcDoc",
        srclang: "srcLang",
        srcset: "srcSet",
        start: "start",
        step: "step",
        style: "style",
        summary: "summary",
        tabindex: "tabIndex",
        target: "target",
        title: "title",
        type: "type",
        usemap: "useMap",
        value: "value",
        width: "width",
        wmode: "wmode",
        wrap: "wrap",
        // SVG
        about: "about",
        accentheight: "accentHeight",
        "accent-height": "accentHeight",
        accumulate: "accumulate",
        additive: "additive",
        alignmentbaseline: "alignmentBaseline",
        "alignment-baseline": "alignmentBaseline",
        allowreorder: "allowReorder",
        alphabetic: "alphabetic",
        amplitude: "amplitude",
        arabicform: "arabicForm",
        "arabic-form": "arabicForm",
        ascent: "ascent",
        attributename: "attributeName",
        attributetype: "attributeType",
        autoreverse: "autoReverse",
        azimuth: "azimuth",
        basefrequency: "baseFrequency",
        baselineshift: "baselineShift",
        "baseline-shift": "baselineShift",
        baseprofile: "baseProfile",
        bbox: "bbox",
        begin: "begin",
        bias: "bias",
        by: "by",
        calcmode: "calcMode",
        capheight: "capHeight",
        "cap-height": "capHeight",
        clip: "clip",
        clippath: "clipPath",
        "clip-path": "clipPath",
        clippathunits: "clipPathUnits",
        cliprule: "clipRule",
        "clip-rule": "clipRule",
        color: "color",
        colorinterpolation: "colorInterpolation",
        "color-interpolation": "colorInterpolation",
        colorinterpolationfilters: "colorInterpolationFilters",
        "color-interpolation-filters": "colorInterpolationFilters",
        colorprofile: "colorProfile",
        "color-profile": "colorProfile",
        colorrendering: "colorRendering",
        "color-rendering": "colorRendering",
        contentscripttype: "contentScriptType",
        contentstyletype: "contentStyleType",
        cursor: "cursor",
        cx: "cx",
        cy: "cy",
        d: "d",
        datatype: "datatype",
        decelerate: "decelerate",
        descent: "descent",
        diffuseconstant: "diffuseConstant",
        direction: "direction",
        display: "display",
        divisor: "divisor",
        dominantbaseline: "dominantBaseline",
        "dominant-baseline": "dominantBaseline",
        dur: "dur",
        dx: "dx",
        dy: "dy",
        edgemode: "edgeMode",
        elevation: "elevation",
        enablebackground: "enableBackground",
        "enable-background": "enableBackground",
        end: "end",
        exponent: "exponent",
        externalresourcesrequired: "externalResourcesRequired",
        fill: "fill",
        fillopacity: "fillOpacity",
        "fill-opacity": "fillOpacity",
        fillrule: "fillRule",
        "fill-rule": "fillRule",
        filter: "filter",
        filterres: "filterRes",
        filterunits: "filterUnits",
        floodopacity: "floodOpacity",
        "flood-opacity": "floodOpacity",
        floodcolor: "floodColor",
        "flood-color": "floodColor",
        focusable: "focusable",
        fontfamily: "fontFamily",
        "font-family": "fontFamily",
        fontsize: "fontSize",
        "font-size": "fontSize",
        fontsizeadjust: "fontSizeAdjust",
        "font-size-adjust": "fontSizeAdjust",
        fontstretch: "fontStretch",
        "font-stretch": "fontStretch",
        fontstyle: "fontStyle",
        "font-style": "fontStyle",
        fontvariant: "fontVariant",
        "font-variant": "fontVariant",
        fontweight: "fontWeight",
        "font-weight": "fontWeight",
        format: "format",
        from: "from",
        fx: "fx",
        fy: "fy",
        g1: "g1",
        g2: "g2",
        glyphname: "glyphName",
        "glyph-name": "glyphName",
        glyphorientationhorizontal: "glyphOrientationHorizontal",
        "glyph-orientation-horizontal": "glyphOrientationHorizontal",
        glyphorientationvertical: "glyphOrientationVertical",
        "glyph-orientation-vertical": "glyphOrientationVertical",
        glyphref: "glyphRef",
        gradienttransform: "gradientTransform",
        gradientunits: "gradientUnits",
        hanging: "hanging",
        horizadvx: "horizAdvX",
        "horiz-adv-x": "horizAdvX",
        horizoriginx: "horizOriginX",
        "horiz-origin-x": "horizOriginX",
        ideographic: "ideographic",
        imagerendering: "imageRendering",
        "image-rendering": "imageRendering",
        in2: "in2",
        in: "in",
        inlist: "inlist",
        intercept: "intercept",
        k1: "k1",
        k2: "k2",
        k3: "k3",
        k4: "k4",
        k: "k",
        kernelmatrix: "kernelMatrix",
        kernelunitlength: "kernelUnitLength",
        kerning: "kerning",
        keypoints: "keyPoints",
        keysplines: "keySplines",
        keytimes: "keyTimes",
        lengthadjust: "lengthAdjust",
        letterspacing: "letterSpacing",
        "letter-spacing": "letterSpacing",
        lightingcolor: "lightingColor",
        "lighting-color": "lightingColor",
        limitingconeangle: "limitingConeAngle",
        local: "local",
        markerend: "markerEnd",
        "marker-end": "markerEnd",
        markerheight: "markerHeight",
        markermid: "markerMid",
        "marker-mid": "markerMid",
        markerstart: "markerStart",
        "marker-start": "markerStart",
        markerunits: "markerUnits",
        markerwidth: "markerWidth",
        mask: "mask",
        maskcontentunits: "maskContentUnits",
        maskunits: "maskUnits",
        mathematical: "mathematical",
        mode: "mode",
        numoctaves: "numOctaves",
        offset: "offset",
        opacity: "opacity",
        operator: "operator",
        order: "order",
        orient: "orient",
        orientation: "orientation",
        origin: "origin",
        overflow: "overflow",
        overlineposition: "overlinePosition",
        "overline-position": "overlinePosition",
        overlinethickness: "overlineThickness",
        "overline-thickness": "overlineThickness",
        paintorder: "paintOrder",
        "paint-order": "paintOrder",
        panose1: "panose1",
        "panose-1": "panose1",
        pathlength: "pathLength",
        patterncontentunits: "patternContentUnits",
        patterntransform: "patternTransform",
        patternunits: "patternUnits",
        pointerevents: "pointerEvents",
        "pointer-events": "pointerEvents",
        points: "points",
        pointsatx: "pointsAtX",
        pointsaty: "pointsAtY",
        pointsatz: "pointsAtZ",
        prefix: "prefix",
        preservealpha: "preserveAlpha",
        preserveaspectratio: "preserveAspectRatio",
        primitiveunits: "primitiveUnits",
        property: "property",
        r: "r",
        radius: "radius",
        refx: "refX",
        refy: "refY",
        renderingintent: "renderingIntent",
        "rendering-intent": "renderingIntent",
        repeatcount: "repeatCount",
        repeatdur: "repeatDur",
        requiredextensions: "requiredExtensions",
        requiredfeatures: "requiredFeatures",
        resource: "resource",
        restart: "restart",
        result: "result",
        results: "results",
        rotate: "rotate",
        rx: "rx",
        ry: "ry",
        scale: "scale",
        security: "security",
        seed: "seed",
        shaperendering: "shapeRendering",
        "shape-rendering": "shapeRendering",
        slope: "slope",
        spacing: "spacing",
        specularconstant: "specularConstant",
        specularexponent: "specularExponent",
        speed: "speed",
        spreadmethod: "spreadMethod",
        startoffset: "startOffset",
        stddeviation: "stdDeviation",
        stemh: "stemh",
        stemv: "stemv",
        stitchtiles: "stitchTiles",
        stopcolor: "stopColor",
        "stop-color": "stopColor",
        stopopacity: "stopOpacity",
        "stop-opacity": "stopOpacity",
        strikethroughposition: "strikethroughPosition",
        "strikethrough-position": "strikethroughPosition",
        strikethroughthickness: "strikethroughThickness",
        "strikethrough-thickness": "strikethroughThickness",
        string: "string",
        stroke: "stroke",
        strokedasharray: "strokeDasharray",
        "stroke-dasharray": "strokeDasharray",
        strokedashoffset: "strokeDashoffset",
        "stroke-dashoffset": "strokeDashoffset",
        strokelinecap: "strokeLinecap",
        "stroke-linecap": "strokeLinecap",
        strokelinejoin: "strokeLinejoin",
        "stroke-linejoin": "strokeLinejoin",
        strokemiterlimit: "strokeMiterlimit",
        "stroke-miterlimit": "strokeMiterlimit",
        strokewidth: "strokeWidth",
        "stroke-width": "strokeWidth",
        strokeopacity: "strokeOpacity",
        "stroke-opacity": "strokeOpacity",
        suppresscontenteditablewarning: "suppressContentEditableWarning",
        suppresshydrationwarning: "suppressHydrationWarning",
        surfacescale: "surfaceScale",
        systemlanguage: "systemLanguage",
        tablevalues: "tableValues",
        targetx: "targetX",
        targety: "targetY",
        textanchor: "textAnchor",
        "text-anchor": "textAnchor",
        textdecoration: "textDecoration",
        "text-decoration": "textDecoration",
        textlength: "textLength",
        textrendering: "textRendering",
        "text-rendering": "textRendering",
        to: "to",
        transform: "transform",
        typeof: "typeof",
        u1: "u1",
        u2: "u2",
        underlineposition: "underlinePosition",
        "underline-position": "underlinePosition",
        underlinethickness: "underlineThickness",
        "underline-thickness": "underlineThickness",
        unicode: "unicode",
        unicodebidi: "unicodeBidi",
        "unicode-bidi": "unicodeBidi",
        unicoderange: "unicodeRange",
        "unicode-range": "unicodeRange",
        unitsperem: "unitsPerEm",
        "units-per-em": "unitsPerEm",
        unselectable: "unselectable",
        valphabetic: "vAlphabetic",
        "v-alphabetic": "vAlphabetic",
        values: "values",
        vectoreffect: "vectorEffect",
        "vector-effect": "vectorEffect",
        version: "version",
        vertadvy: "vertAdvY",
        "vert-adv-y": "vertAdvY",
        vertoriginx: "vertOriginX",
        "vert-origin-x": "vertOriginX",
        vertoriginy: "vertOriginY",
        "vert-origin-y": "vertOriginY",
        vhanging: "vHanging",
        "v-hanging": "vHanging",
        videographic: "vIdeographic",
        "v-ideographic": "vIdeographic",
        viewbox: "viewBox",
        viewtarget: "viewTarget",
        visibility: "visibility",
        vmathematical: "vMathematical",
        "v-mathematical": "vMathematical",
        vocab: "vocab",
        widths: "widths",
        wordspacing: "wordSpacing",
        "word-spacing": "wordSpacing",
        writingmode: "writingMode",
        "writing-mode": "writingMode",
        x1: "x1",
        x2: "x2",
        x: "x",
        xchannelselector: "xChannelSelector",
        xheight: "xHeight",
        "x-height": "xHeight",
        xlinkactuate: "xlinkActuate",
        "xlink:actuate": "xlinkActuate",
        xlinkarcrole: "xlinkArcrole",
        "xlink:arcrole": "xlinkArcrole",
        xlinkhref: "xlinkHref",
        "xlink:href": "xlinkHref",
        xlinkrole: "xlinkRole",
        "xlink:role": "xlinkRole",
        xlinkshow: "xlinkShow",
        "xlink:show": "xlinkShow",
        xlinktitle: "xlinkTitle",
        "xlink:title": "xlinkTitle",
        xlinktype: "xlinkType",
        "xlink:type": "xlinkType",
        xmlbase: "xmlBase",
        "xml:base": "xmlBase",
        xmllang: "xmlLang",
        "xml:lang": "xmlLang",
        xmlns: "xmlns",
        "xml:space": "xmlSpace",
        xmlnsxlink: "xmlnsXlink",
        "xmlns:xlink": "xmlnsXlink",
        xmlspace: "xmlSpace",
        y1: "y1",
        y2: "y2",
        y: "y",
        ychannelselector: "yChannelSelector",
        z: "z",
        zoomandpan: "zoomAndPan"
    };
    var validateProperty$1 = function() {};
    var warnedProperties$1 = {};
    var EVENT_NAME_REGEX = /^on./;
    var INVALID_EVENT_NAME_REGEX = /^on[^A-Z]/;
    var rARIA$1 = new RegExp("^(aria)-[" + ATTRIBUTE_NAME_CHAR + "]*$");
    var rARIACamel$1 = new RegExp("^(aria)[A-Z][" + ATTRIBUTE_NAME_CHAR + "]*$");
    validateProperty$1 = function(tagName, name, value, eventRegistry) {
        if (hasOwnProperty.call(warnedProperties$1, name) && warnedProperties$1[name]) return true;
        var lowerCasedName = name.toLowerCase();
        if (lowerCasedName === "onfocusin" || lowerCasedName === "onfocusout") {
            error("React uses onFocus and onBlur instead of onFocusIn and onFocusOut. All React events are normalized to bubble, so onFocusIn and onFocusOut are not needed/supported by React.");
            warnedProperties$1[name] = true;
            return true;
        } // We can't rely on the event system being injected on the server.
        if (eventRegistry != null) {
            var registrationNameDependencies = eventRegistry.registrationNameDependencies, possibleRegistrationNames = eventRegistry.possibleRegistrationNames;
            if (registrationNameDependencies.hasOwnProperty(name)) return true;
            var registrationName = possibleRegistrationNames.hasOwnProperty(lowerCasedName) ? possibleRegistrationNames[lowerCasedName] : null;
            if (registrationName != null) {
                error("Invalid event handler property `%s`. Did you mean `%s`?", name, registrationName);
                warnedProperties$1[name] = true;
                return true;
            }
            if (EVENT_NAME_REGEX.test(name)) {
                error("Unknown event handler property `%s`. It will be ignored.", name);
                warnedProperties$1[name] = true;
                return true;
            }
        } else if (EVENT_NAME_REGEX.test(name)) {
            // If no event plugins have been injected, we are in a server environment.
            // So we can't tell if the event name is correct for sure, but we can filter
            // out known bad ones like `onclick`. We can't suggest a specific replacement though.
            if (INVALID_EVENT_NAME_REGEX.test(name)) error("Invalid event handler property `%s`. React events use the camelCase naming convention, for example `onClick`.", name);
            warnedProperties$1[name] = true;
            return true;
        } // Let the ARIA attribute hook validate ARIA attributes
        if (rARIA$1.test(name) || rARIACamel$1.test(name)) return true;
        if (lowerCasedName === "innerhtml") {
            error("Directly setting property `innerHTML` is not permitted. For more information, lookup documentation on `dangerouslySetInnerHTML`.");
            warnedProperties$1[name] = true;
            return true;
        }
        if (lowerCasedName === "aria") {
            error("The `aria` attribute is reserved for future use in React. Pass individual `aria-` attributes instead.");
            warnedProperties$1[name] = true;
            return true;
        }
        if (lowerCasedName === "is" && value !== null && value !== undefined && typeof value !== "string") {
            error("Received a `%s` for a string attribute `is`. If this is expected, cast the value to a string.", typeof value);
            warnedProperties$1[name] = true;
            return true;
        }
        if (typeof value === "number" && isNaN(value)) {
            error("Received NaN for the `%s` attribute. If this is expected, cast the value to a string.", name);
            warnedProperties$1[name] = true;
            return true;
        }
        var propertyInfo = getPropertyInfo(name);
        var isReserved = propertyInfo !== null && propertyInfo.type === RESERVED; // Known attributes should match the casing specified in the property config.
        if (possibleStandardNames.hasOwnProperty(lowerCasedName)) {
            var standardName = possibleStandardNames[lowerCasedName];
            if (standardName !== name) {
                error("Invalid DOM property `%s`. Did you mean `%s`?", name, standardName);
                warnedProperties$1[name] = true;
                return true;
            }
        } else if (!isReserved && name !== lowerCasedName) {
            // Unknown attributes should have lowercase casing since that's how they
            // will be cased anyway with server rendering.
            error("React does not recognize the `%s` prop on a DOM element. If you intentionally want it to appear in the DOM as a custom attribute, spell it as lowercase `%s` instead. If you accidentally passed it from a parent component, remove it from the DOM element.", name, lowerCasedName);
            warnedProperties$1[name] = true;
            return true;
        }
        if (typeof value === "boolean" && shouldRemoveAttributeWithWarning(name, value, propertyInfo, false)) {
            if (value) error('Received `%s` for a non-boolean attribute `%s`.\n\nIf you want to write it to the DOM, pass a string instead: %s="%s" or %s={value.toString()}.', value, name, name, value, name);
            else error('Received `%s` for a non-boolean attribute `%s`.\n\nIf you want to write it to the DOM, pass a string instead: %s="%s" or %s={value.toString()}.\n\nIf you used to conditionally omit it with %s={condition && value}, pass %s={condition ? value : undefined} instead.', value, name, name, value, name, name, name);
            warnedProperties$1[name] = true;
            return true;
        } // Now that we've validated casing, do not validate
        // data types for reserved props
        if (isReserved) return true;
         // Warn when a known attribute is a bad type
        if (shouldRemoveAttributeWithWarning(name, value, propertyInfo, false)) {
            warnedProperties$1[name] = true;
            return false;
        } // Warn when passing the strings 'false' or 'true' into a boolean prop
        if ((value === "false" || value === "true") && propertyInfo !== null && propertyInfo.type === BOOLEAN) {
            error("Received the string `%s` for the boolean attribute `%s`. %s Did you mean %s={%s}?", value, name, value === "false" ? "The browser will interpret it as a truthy value." : 'Although this works, it will not work as expected if you pass the string "false".', name, value);
            warnedProperties$1[name] = true;
            return true;
        }
        return true;
    };
    var warnUnknownProperties = function(type, props, eventRegistry) {
        var unknownProps = [];
        for(var key in props){
            var isValid = validateProperty$1(type, key, props[key], eventRegistry);
            if (!isValid) unknownProps.push(key);
        }
        var unknownPropString = unknownProps.map(function(prop) {
            return "`" + prop + "`";
        }).join(", ");
        if (unknownProps.length === 1) error("Invalid value for prop %s on <%s> tag. Either remove it from the element, or pass a string or number value to keep it in the DOM. For details, see https://reactjs.org/link/attribute-behavior ", unknownPropString, type);
        else if (unknownProps.length > 1) error("Invalid values for props %s on <%s> tag. Either remove them from the element, or pass a string or number value to keep them in the DOM. For details, see https://reactjs.org/link/attribute-behavior ", unknownPropString, type);
    };
    function validateProperties$2(type, props, eventRegistry) {
        if (isCustomComponent(type, props)) return;
        warnUnknownProperties(type, props, eventRegistry);
    }
    var warnValidStyle = function() {};
    // 'msTransform' is correct, but the other prefixes should be capitalized
    var badVendoredStyleNamePattern = /^(?:webkit|moz|o)[A-Z]/;
    var msPattern = /^-ms-/;
    var hyphenPattern = /-(.)/g; // style values shouldn't contain a semicolon
    var badStyleValueWithSemicolonPattern = /;\s*$/;
    var warnedStyleNames = {};
    var warnedStyleValues = {};
    var warnedForNaNValue = false;
    var warnedForInfinityValue = false;
    var camelize = function(string) {
        return string.replace(hyphenPattern, function(_, character) {
            return character.toUpperCase();
        });
    };
    var warnHyphenatedStyleName = function(name) {
        if (warnedStyleNames.hasOwnProperty(name) && warnedStyleNames[name]) return;
        warnedStyleNames[name] = true;
        error("Unsupported style property %s. Did you mean %s?", name, // (http://www.andismith.com/blog/2012/02/modernizr-prefixed/), an `-ms` prefix
        // is converted to lowercase `ms`.
        camelize(name.replace(msPattern, "ms-")));
    };
    var warnBadVendoredStyleName = function(name) {
        if (warnedStyleNames.hasOwnProperty(name) && warnedStyleNames[name]) return;
        warnedStyleNames[name] = true;
        error("Unsupported vendor-prefixed style property %s. Did you mean %s?", name, name.charAt(0).toUpperCase() + name.slice(1));
    };
    var warnStyleValueWithSemicolon = function(name, value) {
        if (warnedStyleValues.hasOwnProperty(value) && warnedStyleValues[value]) return;
        warnedStyleValues[value] = true;
        error('Style property values shouldn\'t contain a semicolon. Try "%s: %s" instead.', name, value.replace(badStyleValueWithSemicolonPattern, ""));
    };
    var warnStyleValueIsNaN = function(name, value) {
        if (warnedForNaNValue) return;
        warnedForNaNValue = true;
        error("`NaN` is an invalid value for the `%s` css style property.", name);
    };
    var warnStyleValueIsInfinity = function(name, value) {
        if (warnedForInfinityValue) return;
        warnedForInfinityValue = true;
        error("`Infinity` is an invalid value for the `%s` css style property.", name);
    };
    warnValidStyle = function(name, value) {
        if (name.indexOf("-") > -1) warnHyphenatedStyleName(name);
        else if (badVendoredStyleNamePattern.test(name)) warnBadVendoredStyleName(name);
        else if (badStyleValueWithSemicolonPattern.test(value)) warnStyleValueWithSemicolon(name, value);
        if (typeof value === "number") {
            if (isNaN(value)) warnStyleValueIsNaN(name, value);
            else if (!isFinite(value)) warnStyleValueIsInfinity(name, value);
        }
    };
    var warnValidStyle$1 = warnValidStyle;
    // code copied and modified from escape-html
    var matchHtmlRegExp = /["'&<>]/;
    /**
 * Escapes special characters and HTML entities in a given html string.
 *
 * @param  {string} string HTML string to escape for later insertion
 * @return {string}
 * @public
 */ function escapeHtml(string) {
        checkHtmlStringCoercion(string);
        var str = "" + string;
        var match = matchHtmlRegExp.exec(str);
        if (!match) return str;
        var escape;
        var html = "";
        var index;
        var lastIndex = 0;
        for(index = match.index; index < str.length; index++){
            switch(str.charCodeAt(index)){
                case 34:
                    // "
                    escape = "&quot;";
                    break;
                case 38:
                    // &
                    escape = "&amp;";
                    break;
                case 39:
                    // '
                    escape = "&#x27;"; // modified from escape-html; used to be '&#39'
                    break;
                case 60:
                    // <
                    escape = "&lt;";
                    break;
                case 62:
                    // >
                    escape = "&gt;";
                    break;
                default:
                    continue;
            }
            if (lastIndex !== index) html += str.substring(lastIndex, index);
            lastIndex = index + 1;
            html += escape;
        }
        return lastIndex !== index ? html + str.substring(lastIndex, index) : html;
    } // end code copied and modified from escape-html
    /**
 * Escapes text to prevent scripting attacks.
 *
 * @param {*} text Text value to escape.
 * @return {string} An escaped string.
 */ function escapeTextForBrowser(text) {
        if (typeof text === "boolean" || typeof text === "number") // this shortcircuit helps perf for types that we know will never have
        // special characters, especially given that this function is used often
        // for numeric dom ids.
        return "" + text;
        return escapeHtml(text);
    }
    var uppercasePattern = /([A-Z])/g;
    var msPattern$1 = /^ms-/;
    /**
 * Hyphenates a camelcased CSS property name, for example:
 *
 *   > hyphenateStyleName('backgroundColor')
 *   < "background-color"
 *   > hyphenateStyleName('MozTransition')
 *   < "-moz-transition"
 *   > hyphenateStyleName('msTransition')
 *   < "-ms-transition"
 *
 * As Modernizr suggests (http://modernizr.com/docs/#prefixed), an `ms` prefix
 * is converted to `-ms-`.
 */ function hyphenateStyleName(name) {
        return name.replace(uppercasePattern, "-$1").toLowerCase().replace(msPattern$1, "-ms-");
    }
    // and any newline or tab are filtered out as if they're not part of the URL.
    // https://url.spec.whatwg.org/#url-parsing
    // Tab or newline are defined as \r\n\t:
    // https://infra.spec.whatwg.org/#ascii-tab-or-newline
    // A C0 control is a code point in the range \u0000 NULL to \u001F
    // INFORMATION SEPARATOR ONE, inclusive:
    // https://infra.spec.whatwg.org/#c0-control-or-space
    /* eslint-disable max-len */ var isJavaScriptProtocol = /^[\u0000-\u001F ]*j[\r\n\t]*a[\r\n\t]*v[\r\n\t]*a[\r\n\t]*s[\r\n\t]*c[\r\n\t]*r[\r\n\t]*i[\r\n\t]*p[\r\n\t]*t[\r\n\t]*\:/i;
    var didWarn = false;
    function sanitizeURL(url) {
        if (!didWarn && isJavaScriptProtocol.test(url)) {
            didWarn = true;
            error("A future version of React will block javascript: URLs as a security precaution. Use event handlers instead if you can. If you need to generate unsafe HTML try using dangerouslySetInnerHTML instead. React was passed %s.", JSON.stringify(url));
        }
    }
    var isArrayImpl = Array.isArray; // eslint-disable-next-line no-redeclare
    function isArray(a) {
        return isArrayImpl(a);
    }
    var startInlineScript = stringToPrecomputedChunk("<script>");
    var endInlineScript = stringToPrecomputedChunk("</script>");
    var startScriptSrc = stringToPrecomputedChunk('<script src="');
    var startModuleSrc = stringToPrecomputedChunk('<script type="module" src="');
    var endAsyncScript = stringToPrecomputedChunk('" async=""></script>');
    /**
 * This escaping function is designed to work with bootstrapScriptContent only.
 * because we know we are escaping the entire script. We can avoid for instance
 * escaping html comment string sequences that are valid javascript as well because
 * if there are no sebsequent <script sequences the html parser will never enter
 * script data double escaped state (see: https://www.w3.org/TR/html53/syntax.html#script-data-double-escaped-state)
 *
 * While untrusted script content should be made safe before using this api it will
 * ensure that the script cannot be early terminated or never terminated state
 */ function escapeBootstrapScriptContent(scriptText) {
        checkHtmlStringCoercion(scriptText);
        return ("" + scriptText).replace(scriptRegex, scriptReplacer);
    }
    var scriptRegex = /(<\/|<)(s)(cript)/gi;
    var scriptReplacer = function(match, prefix, s, suffix) {
        return "" + prefix + (s === "s" ? "\\u0073" : "\\u0053") + suffix;
    }; // Allows us to keep track of what we've already written so we can refer back to it.
    function createResponseState(identifierPrefix, nonce, bootstrapScriptContent, bootstrapScripts, bootstrapModules) {
        var idPrefix = identifierPrefix === undefined ? "" : identifierPrefix;
        var inlineScriptWithNonce = nonce === undefined ? startInlineScript : stringToPrecomputedChunk('<script nonce="' + escapeTextForBrowser(nonce) + '">');
        var bootstrapChunks = [];
        if (bootstrapScriptContent !== undefined) bootstrapChunks.push(inlineScriptWithNonce, stringToChunk(escapeBootstrapScriptContent(bootstrapScriptContent)), endInlineScript);
        if (bootstrapScripts !== undefined) for(var i = 0; i < bootstrapScripts.length; i++)bootstrapChunks.push(startScriptSrc, stringToChunk(escapeTextForBrowser(bootstrapScripts[i])), endAsyncScript);
        if (bootstrapModules !== undefined) for(var _i = 0; _i < bootstrapModules.length; _i++)bootstrapChunks.push(startModuleSrc, stringToChunk(escapeTextForBrowser(bootstrapModules[_i])), endAsyncScript);
        return {
            bootstrapChunks: bootstrapChunks,
            startInlineScript: inlineScriptWithNonce,
            placeholderPrefix: stringToPrecomputedChunk(idPrefix + "P:"),
            segmentPrefix: stringToPrecomputedChunk(idPrefix + "S:"),
            boundaryPrefix: idPrefix + "B:",
            idPrefix: idPrefix,
            nextSuspenseID: 0,
            sentCompleteSegmentFunction: false,
            sentCompleteBoundaryFunction: false,
            sentClientRenderFunction: false
        };
    } // Constants for the insertion mode we're currently writing in. We don't encode all HTML5 insertion
    // modes. We only include the variants as they matter for the sake of our purposes.
    // We don't actually provide the namespace therefore we use constants instead of the string.
    var ROOT_HTML_MODE = 0; // Used for the root most element tag.
    var HTML_MODE = 1;
    var SVG_MODE = 2;
    var MATHML_MODE = 3;
    var HTML_TABLE_MODE = 4;
    var HTML_TABLE_BODY_MODE = 5;
    var HTML_TABLE_ROW_MODE = 6;
    var HTML_COLGROUP_MODE = 7; // We have a greater than HTML_TABLE_MODE check elsewhere. If you add more cases here, make sure it
    // still makes sense
    function createFormatContext(insertionMode, selectedValue) {
        return {
            insertionMode: insertionMode,
            selectedValue: selectedValue
        };
    }
    function getChildFormatContext(parentContext, type, props) {
        switch(type){
            case "select":
                return createFormatContext(HTML_MODE, props.value != null ? props.value : props.defaultValue);
            case "svg":
                return createFormatContext(SVG_MODE, null);
            case "math":
                return createFormatContext(MATHML_MODE, null);
            case "foreignObject":
                return createFormatContext(HTML_MODE, null);
            // Table parents are special in that their children can only be created at all if they're
            // wrapped in a table parent. So we need to encode that we're entering this mode.
            case "table":
                return createFormatContext(HTML_TABLE_MODE, null);
            case "thead":
            case "tbody":
            case "tfoot":
                return createFormatContext(HTML_TABLE_BODY_MODE, null);
            case "colgroup":
                return createFormatContext(HTML_COLGROUP_MODE, null);
            case "tr":
                return createFormatContext(HTML_TABLE_ROW_MODE, null);
        }
        if (parentContext.insertionMode >= HTML_TABLE_MODE) // Whatever tag this was, it wasn't a table parent or other special parent, so we must have
        // entered plain HTML again.
        return createFormatContext(HTML_MODE, null);
        if (parentContext.insertionMode === ROOT_HTML_MODE) // We've emitted the root and is now in plain HTML mode.
        return createFormatContext(HTML_MODE, null);
        return parentContext;
    }
    var UNINITIALIZED_SUSPENSE_BOUNDARY_ID = null;
    function assignSuspenseBoundaryID(responseState) {
        var generatedID = responseState.nextSuspenseID++;
        return stringToPrecomputedChunk(responseState.boundaryPrefix + generatedID.toString(16));
    }
    function makeId(responseState, treeId, localId) {
        var idPrefix = responseState.idPrefix;
        var id = ":" + idPrefix + "R" + treeId; // Unless this is the first id at this level, append a number at the end
        // that represents the position of this useId hook among all the useId
        // hooks for this fiber.
        if (localId > 0) id += "H" + localId.toString(32);
        return id + ":";
    }
    function encodeHTMLTextNode(text) {
        return escapeTextForBrowser(text);
    }
    var textSeparator = stringToPrecomputedChunk("<!-- -->");
    function pushTextInstance(target, text, responseState, textEmbedded) {
        if (text === "") // Empty text doesn't have a DOM node representation and the hydration is aware of this.
        return textEmbedded;
        if (textEmbedded) target.push(textSeparator);
        target.push(stringToChunk(encodeHTMLTextNode(text)));
        return true;
    } // Called when Fizz is done with a Segment. Currently the only purpose is to conditionally
    // emit a text separator when we don't know for sure it is safe to omit
    function pushSegmentFinale(target, responseState, lastPushedText, textEmbedded) {
        if (lastPushedText && textEmbedded) target.push(textSeparator);
    }
    var styleNameCache = new Map();
    function processStyleName(styleName) {
        var chunk = styleNameCache.get(styleName);
        if (chunk !== undefined) return chunk;
        var result = stringToPrecomputedChunk(escapeTextForBrowser(hyphenateStyleName(styleName)));
        styleNameCache.set(styleName, result);
        return result;
    }
    var styleAttributeStart = stringToPrecomputedChunk(' style="');
    var styleAssign = stringToPrecomputedChunk(":");
    var styleSeparator = stringToPrecomputedChunk(";");
    function pushStyle(target, responseState, style) {
        if (typeof style !== "object") throw new Error("The `style` prop expects a mapping from style properties to values, not a string. For example, style={{marginRight: spacing + 'em'}} when using JSX.");
        var isFirst = true;
        for(var styleName in style){
            if (!hasOwnProperty.call(style, styleName)) continue;
             // If you provide unsafe user data here they can inject arbitrary CSS
            // which may be problematic (I couldn't repro this):
            // https://www.owasp.org/index.php/XSS_Filter_Evasion_Cheat_Sheet
            // http://www.thespanner.co.uk/2007/11/26/ultimate-xss-css-injection/
            // This is not an XSS hole but instead a potential CSS injection issue
            // which has lead to a greater discussion about how we're going to
            // trust URLs moving forward. See #2115901
            var styleValue = style[styleName];
            if (styleValue == null || typeof styleValue === "boolean" || styleValue === "") continue;
            var nameChunk = void 0;
            var valueChunk = void 0;
            var isCustomProperty = styleName.indexOf("--") === 0;
            if (isCustomProperty) {
                nameChunk = stringToChunk(escapeTextForBrowser(styleName));
                checkCSSPropertyStringCoercion(styleValue, styleName);
                valueChunk = stringToChunk(escapeTextForBrowser(("" + styleValue).trim()));
            } else {
                warnValidStyle$1(styleName, styleValue);
                nameChunk = processStyleName(styleName);
                if (typeof styleValue === "number") {
                    if (styleValue !== 0 && !hasOwnProperty.call(isUnitlessNumber, styleName)) valueChunk = stringToChunk(styleValue + "px"); // Presumes implicit 'px' suffix for unitless numbers
                    else valueChunk = stringToChunk("" + styleValue);
                } else {
                    checkCSSPropertyStringCoercion(styleValue, styleName);
                    valueChunk = stringToChunk(escapeTextForBrowser(("" + styleValue).trim()));
                }
            }
            if (isFirst) {
                isFirst = false; // If it's first, we don't need any separators prefixed.
                target.push(styleAttributeStart, nameChunk, styleAssign, valueChunk);
            } else target.push(styleSeparator, nameChunk, styleAssign, valueChunk);
        }
        if (!isFirst) target.push(attributeEnd);
    }
    var attributeSeparator = stringToPrecomputedChunk(" ");
    var attributeAssign = stringToPrecomputedChunk('="');
    var attributeEnd = stringToPrecomputedChunk('"');
    var attributeEmptyString = stringToPrecomputedChunk('=""');
    function pushAttribute(target, responseState, name, value) {
        switch(name){
            case "style":
                pushStyle(target, responseState, value);
                return;
            case "defaultValue":
            case "defaultChecked":
            case "innerHTML":
            case "suppressContentEditableWarning":
            case "suppressHydrationWarning":
                // Ignored. These are built-in to React on the client.
                return;
        }
        if (// We have already filtered out null/undefined and reserved words.
        name.length > 2 && (name[0] === "o" || name[0] === "O") && (name[1] === "n" || name[1] === "N")) return;
        var propertyInfo = getPropertyInfo(name);
        if (propertyInfo !== null) {
            // shouldRemoveAttribute
            switch(typeof value){
                case "function":
                case "symbol":
                    // eslint-disable-line
                    return;
                case "boolean":
                    if (!propertyInfo.acceptsBooleans) return;
            }
            var attributeName = propertyInfo.attributeName;
            var attributeNameChunk = stringToChunk(attributeName); // TODO: If it's known we can cache the chunk.
            switch(propertyInfo.type){
                case BOOLEAN:
                    if (value) target.push(attributeSeparator, attributeNameChunk, attributeEmptyString);
                    return;
                case OVERLOADED_BOOLEAN:
                    if (value === true) target.push(attributeSeparator, attributeNameChunk, attributeEmptyString);
                    else if (value === false) ;
                    else target.push(attributeSeparator, attributeNameChunk, attributeAssign, stringToChunk(escapeTextForBrowser(value)), attributeEnd);
                    return;
                case NUMERIC:
                    if (!isNaN(value)) target.push(attributeSeparator, attributeNameChunk, attributeAssign, stringToChunk(escapeTextForBrowser(value)), attributeEnd);
                    break;
                case POSITIVE_NUMERIC:
                    if (!isNaN(value) && value >= 1) target.push(attributeSeparator, attributeNameChunk, attributeAssign, stringToChunk(escapeTextForBrowser(value)), attributeEnd);
                    break;
                default:
                    if (propertyInfo.sanitizeURL) {
                        checkAttributeStringCoercion(value, attributeName);
                        value = "" + value;
                        sanitizeURL(value);
                    }
                    target.push(attributeSeparator, attributeNameChunk, attributeAssign, stringToChunk(escapeTextForBrowser(value)), attributeEnd);
            }
        } else if (isAttributeNameSafe(name)) {
            // shouldRemoveAttribute
            switch(typeof value){
                case "function":
                case "symbol":
                    // eslint-disable-line
                    return;
                case "boolean":
                    var prefix = name.toLowerCase().slice(0, 5);
                    if (prefix !== "data-" && prefix !== "aria-") return;
            }
            target.push(attributeSeparator, stringToChunk(name), attributeAssign, stringToChunk(escapeTextForBrowser(value)), attributeEnd);
        }
    }
    var endOfStartTag = stringToPrecomputedChunk(">");
    var endOfStartTagSelfClosing = stringToPrecomputedChunk("/>");
    function pushInnerHTML(target, innerHTML, children) {
        if (innerHTML != null) {
            if (children != null) throw new Error("Can only set one of `children` or `props.dangerouslySetInnerHTML`.");
            if (typeof innerHTML !== "object" || !("__html" in innerHTML)) throw new Error("`props.dangerouslySetInnerHTML` must be in the form `{__html: ...}`. Please visit https://reactjs.org/link/dangerously-set-inner-html for more information.");
            var html = innerHTML.__html;
            if (html !== null && html !== undefined) {
                checkHtmlStringCoercion(html);
                target.push(stringToChunk("" + html));
            }
        }
    } // TODO: Move these to ResponseState so that we warn for every request.
    // It would help debugging in stateful servers (e.g. service worker).
    var didWarnDefaultInputValue = false;
    var didWarnDefaultChecked = false;
    var didWarnDefaultSelectValue = false;
    var didWarnDefaultTextareaValue = false;
    var didWarnInvalidOptionChildren = false;
    var didWarnInvalidOptionInnerHTML = false;
    var didWarnSelectedSetOnOption = false;
    function checkSelectProp(props, propName) {
        var value = props[propName];
        if (value != null) {
            var array = isArray(value);
            if (props.multiple && !array) error("The `%s` prop supplied to <select> must be an array if `multiple` is true.", propName);
            else if (!props.multiple && array) error("The `%s` prop supplied to <select> must be a scalar value if `multiple` is false.", propName);
        }
    }
    function pushStartSelect(target, props, responseState) {
        checkControlledValueProps("select", props);
        checkSelectProp(props, "value");
        checkSelectProp(props, "defaultValue");
        if (props.value !== undefined && props.defaultValue !== undefined && !didWarnDefaultSelectValue) {
            error("Select elements must be either controlled or uncontrolled (specify either the value prop, or the defaultValue prop, but not both). Decide between using a controlled or uncontrolled select element and remove one of these props. More info: https://reactjs.org/link/controlled-components");
            didWarnDefaultSelectValue = true;
        }
        target.push(startChunkForTag("select"));
        var children = null;
        var innerHTML = null;
        for(var propKey in props)if (hasOwnProperty.call(props, propKey)) {
            var propValue = props[propKey];
            if (propValue == null) continue;
            switch(propKey){
                case "children":
                    children = propValue;
                    break;
                case "dangerouslySetInnerHTML":
                    // TODO: This doesn't really make sense for select since it can't use the controlled
                    // value in the innerHTML.
                    innerHTML = propValue;
                    break;
                case "defaultValue":
                case "value":
                    break;
                default:
                    pushAttribute(target, responseState, propKey, propValue);
                    break;
            }
        }
        target.push(endOfStartTag);
        pushInnerHTML(target, innerHTML, children);
        return children;
    }
    function flattenOptionChildren(children) {
        var content = ""; // Flatten children and warn if they aren't strings or numbers;
        // invalid types are ignored.
        React.Children.forEach(children, function(child) {
            if (child == null) return;
            content += child;
            if (!didWarnInvalidOptionChildren && typeof child !== "string" && typeof child !== "number") {
                didWarnInvalidOptionChildren = true;
                error("Cannot infer the option value of complex children. Pass a `value` prop or use a plain string as children to <option>.");
            }
        });
        return content;
    }
    var selectedMarkerAttribute = stringToPrecomputedChunk(' selected=""');
    function pushStartOption(target, props, responseState, formatContext) {
        var selectedValue = formatContext.selectedValue;
        target.push(startChunkForTag("option"));
        var children = null;
        var value = null;
        var selected = null;
        var innerHTML = null;
        for(var propKey in props)if (hasOwnProperty.call(props, propKey)) {
            var propValue = props[propKey];
            if (propValue == null) continue;
            switch(propKey){
                case "children":
                    children = propValue;
                    break;
                case "selected":
                    // ignore
                    selected = propValue;
                    // TODO: Remove support for `selected` in <option>.
                    if (!didWarnSelectedSetOnOption) {
                        error("Use the `defaultValue` or `value` props on <select> instead of setting `selected` on <option>.");
                        didWarnSelectedSetOnOption = true;
                    }
                    break;
                case "dangerouslySetInnerHTML":
                    innerHTML = propValue;
                    break;
                // eslint-disable-next-line-no-fallthrough
                case "value":
                    value = propValue;
                // We intentionally fallthrough to also set the attribute on the node.
                // eslint-disable-next-line-no-fallthrough
                default:
                    pushAttribute(target, responseState, propKey, propValue);
                    break;
            }
        }
        if (selectedValue != null) {
            var stringValue;
            if (value !== null) {
                checkAttributeStringCoercion(value, "value");
                stringValue = "" + value;
            } else {
                if (innerHTML !== null) {
                    if (!didWarnInvalidOptionInnerHTML) {
                        didWarnInvalidOptionInnerHTML = true;
                        error("Pass a `value` prop if you set dangerouslyInnerHTML so React knows which value should be selected.");
                    }
                }
                stringValue = flattenOptionChildren(children);
            }
            if (isArray(selectedValue)) // multiple
            for(var i = 0; i < selectedValue.length; i++){
                checkAttributeStringCoercion(selectedValue[i], "value");
                var v = "" + selectedValue[i];
                if (v === stringValue) {
                    target.push(selectedMarkerAttribute);
                    break;
                }
            }
            else {
                checkAttributeStringCoercion(selectedValue, "select.value");
                if ("" + selectedValue === stringValue) target.push(selectedMarkerAttribute);
            }
        } else if (selected) target.push(selectedMarkerAttribute);
        target.push(endOfStartTag);
        pushInnerHTML(target, innerHTML, children);
        return children;
    }
    function pushInput(target, props, responseState) {
        checkControlledValueProps("input", props);
        if (props.checked !== undefined && props.defaultChecked !== undefined && !didWarnDefaultChecked) {
            error("%s contains an input of type %s with both checked and defaultChecked props. Input elements must be either controlled or uncontrolled (specify either the checked prop, or the defaultChecked prop, but not both). Decide between using a controlled or uncontrolled input element and remove one of these props. More info: https://reactjs.org/link/controlled-components", "A component", props.type);
            didWarnDefaultChecked = true;
        }
        if (props.value !== undefined && props.defaultValue !== undefined && !didWarnDefaultInputValue) {
            error("%s contains an input of type %s with both value and defaultValue props. Input elements must be either controlled or uncontrolled (specify either the value prop, or the defaultValue prop, but not both). Decide between using a controlled or uncontrolled input element and remove one of these props. More info: https://reactjs.org/link/controlled-components", "A component", props.type);
            didWarnDefaultInputValue = true;
        }
        target.push(startChunkForTag("input"));
        var value = null;
        var defaultValue = null;
        var checked = null;
        var defaultChecked = null;
        for(var propKey in props)if (hasOwnProperty.call(props, propKey)) {
            var propValue = props[propKey];
            if (propValue == null) continue;
            switch(propKey){
                case "children":
                case "dangerouslySetInnerHTML":
                    throw new Error("input is a self-closing tag and must neither have `children` nor use `dangerouslySetInnerHTML`.");
                // eslint-disable-next-line-no-fallthrough
                case "defaultChecked":
                    defaultChecked = propValue;
                    break;
                case "defaultValue":
                    defaultValue = propValue;
                    break;
                case "checked":
                    checked = propValue;
                    break;
                case "value":
                    value = propValue;
                    break;
                default:
                    pushAttribute(target, responseState, propKey, propValue);
                    break;
            }
        }
        if (checked !== null) pushAttribute(target, responseState, "checked", checked);
        else if (defaultChecked !== null) pushAttribute(target, responseState, "checked", defaultChecked);
        if (value !== null) pushAttribute(target, responseState, "value", value);
        else if (defaultValue !== null) pushAttribute(target, responseState, "value", defaultValue);
        target.push(endOfStartTagSelfClosing);
        return null;
    }
    function pushStartTextArea(target, props, responseState) {
        checkControlledValueProps("textarea", props);
        if (props.value !== undefined && props.defaultValue !== undefined && !didWarnDefaultTextareaValue) {
            error("Textarea elements must be either controlled or uncontrolled (specify either the value prop, or the defaultValue prop, but not both). Decide between using a controlled or uncontrolled textarea and remove one of these props. More info: https://reactjs.org/link/controlled-components");
            didWarnDefaultTextareaValue = true;
        }
        target.push(startChunkForTag("textarea"));
        var value = null;
        var defaultValue = null;
        var children = null;
        for(var propKey in props)if (hasOwnProperty.call(props, propKey)) {
            var propValue = props[propKey];
            if (propValue == null) continue;
            switch(propKey){
                case "children":
                    children = propValue;
                    break;
                case "value":
                    value = propValue;
                    break;
                case "defaultValue":
                    defaultValue = propValue;
                    break;
                case "dangerouslySetInnerHTML":
                    throw new Error("`dangerouslySetInnerHTML` does not make sense on <textarea>.");
                // eslint-disable-next-line-no-fallthrough
                default:
                    pushAttribute(target, responseState, propKey, propValue);
                    break;
            }
        }
        if (value === null && defaultValue !== null) value = defaultValue;
        target.push(endOfStartTag); // TODO (yungsters): Remove support for children content in <textarea>.
        if (children != null) {
            error("Use the `defaultValue` or `value` props instead of setting children on <textarea>.");
            if (value != null) throw new Error("If you supply `defaultValue` on a <textarea>, do not pass children.");
            if (isArray(children)) {
                if (children.length > 1) throw new Error("<textarea> can only have at most one child.");
                 // TODO: remove the coercion and the DEV check below because it will
                checkHtmlStringCoercion(children[0]);
                value = "" + children[0];
            }
            checkHtmlStringCoercion(children);
            value = "" + children;
        }
        if (typeof value === "string" && value[0] === "\n") // text/html ignores the first character in these tags if it's a newline
        // Prefer to break application/xml over text/html (for now) by adding
        // a newline specifically to get eaten by the parser. (Alternately for
        // textareas, replacing "^\n" with "\r\n" doesn't get eaten, and the first
        // \r is normalized out by HTMLTextAreaElement#value.)
        // See: <http://www.w3.org/TR/html-polyglot/#newlines-in-textarea-and-pre>
        // See: <http://www.w3.org/TR/html5/syntax.html#element-restrictions>
        // See: <http://www.w3.org/TR/html5/syntax.html#newlines>
        // See: Parsing of "textarea" "listing" and "pre" elements
        //  from <http://www.w3.org/TR/html5/syntax.html#parsing-main-inbody>
        target.push(leadingNewline);
         // ToString and push directly instead of recurse over children.
        // We don't really support complex children in the value anyway.
        // This also currently avoids a trailing comment node which breaks textarea.
        if (value !== null) {
            checkAttributeStringCoercion(value, "value");
            target.push(stringToChunk(encodeHTMLTextNode("" + value)));
        }
        return null;
    }
    function pushSelfClosing(target, props, tag, responseState) {
        target.push(startChunkForTag(tag));
        for(var propKey in props)if (hasOwnProperty.call(props, propKey)) {
            var propValue = props[propKey];
            if (propValue == null) continue;
            switch(propKey){
                case "children":
                case "dangerouslySetInnerHTML":
                    throw new Error(tag + " is a self-closing tag and must neither have `children` nor " + "use `dangerouslySetInnerHTML`.");
                // eslint-disable-next-line-no-fallthrough
                default:
                    pushAttribute(target, responseState, propKey, propValue);
                    break;
            }
        }
        target.push(endOfStartTagSelfClosing);
        return null;
    }
    function pushStartMenuItem(target, props, responseState) {
        target.push(startChunkForTag("menuitem"));
        for(var propKey in props)if (hasOwnProperty.call(props, propKey)) {
            var propValue = props[propKey];
            if (propValue == null) continue;
            switch(propKey){
                case "children":
                case "dangerouslySetInnerHTML":
                    throw new Error("menuitems cannot have `children` nor `dangerouslySetInnerHTML`.");
                // eslint-disable-next-line-no-fallthrough
                default:
                    pushAttribute(target, responseState, propKey, propValue);
                    break;
            }
        }
        target.push(endOfStartTag);
        return null;
    }
    function pushStartTitle(target, props, responseState) {
        target.push(startChunkForTag("title"));
        var children = null;
        for(var propKey in props)if (hasOwnProperty.call(props, propKey)) {
            var propValue = props[propKey];
            if (propValue == null) continue;
            switch(propKey){
                case "children":
                    children = propValue;
                    break;
                case "dangerouslySetInnerHTML":
                    throw new Error("`dangerouslySetInnerHTML` does not make sense on <title>.");
                // eslint-disable-next-line-no-fallthrough
                default:
                    pushAttribute(target, responseState, propKey, propValue);
                    break;
            }
        }
        target.push(endOfStartTag);
        var child = Array.isArray(children) && children.length < 2 ? children[0] || null : children;
        if (Array.isArray(children) && children.length > 1) error("A title element received an array with more than 1 element as children. In browsers title Elements can only have Text Nodes as children. If the children being rendered output more than a single text node in aggregate the browser will display markup and comments as text in the title and hydration will likely fail and fall back to client rendering");
        else if (child != null && child.$$typeof != null) error("A title element received a React element for children. In the browser title Elements can only have Text Nodes as children. If the children being rendered output more than a single text node in aggregate the browser will display markup and comments as text in the title and hydration will likely fail and fall back to client rendering");
        else if (child != null && typeof child !== "string" && typeof child !== "number") error("A title element received a value that was not a string or number for children. In the browser title Elements can only have Text Nodes as children. If the children being rendered output more than a single text node in aggregate the browser will display markup and comments as text in the title and hydration will likely fail and fall back to client rendering");
        return children;
    }
    function pushStartGenericElement(target, props, tag, responseState) {
        target.push(startChunkForTag(tag));
        var children = null;
        var innerHTML = null;
        for(var propKey in props)if (hasOwnProperty.call(props, propKey)) {
            var propValue = props[propKey];
            if (propValue == null) continue;
            switch(propKey){
                case "children":
                    children = propValue;
                    break;
                case "dangerouslySetInnerHTML":
                    innerHTML = propValue;
                    break;
                default:
                    pushAttribute(target, responseState, propKey, propValue);
                    break;
            }
        }
        target.push(endOfStartTag);
        pushInnerHTML(target, innerHTML, children);
        if (typeof children === "string") {
            // Special case children as a string to avoid the unnecessary comment.
            // TODO: Remove this special case after the general optimization is in place.
            target.push(stringToChunk(encodeHTMLTextNode(children)));
            return null;
        }
        return children;
    }
    function pushStartCustomElement(target, props, tag, responseState) {
        target.push(startChunkForTag(tag));
        var children = null;
        var innerHTML = null;
        for(var propKey in props)if (hasOwnProperty.call(props, propKey)) {
            var propValue = props[propKey];
            if (propValue == null) continue;
            switch(propKey){
                case "children":
                    children = propValue;
                    break;
                case "dangerouslySetInnerHTML":
                    innerHTML = propValue;
                    break;
                case "style":
                    pushStyle(target, responseState, propValue);
                    break;
                case "suppressContentEditableWarning":
                case "suppressHydrationWarning":
                    break;
                default:
                    if (isAttributeNameSafe(propKey) && typeof propValue !== "function" && typeof propValue !== "symbol") target.push(attributeSeparator, stringToChunk(propKey), attributeAssign, stringToChunk(escapeTextForBrowser(propValue)), attributeEnd);
                    break;
            }
        }
        target.push(endOfStartTag);
        pushInnerHTML(target, innerHTML, children);
        return children;
    }
    var leadingNewline = stringToPrecomputedChunk("\n");
    function pushStartPreformattedElement(target, props, tag, responseState) {
        target.push(startChunkForTag(tag));
        var children = null;
        var innerHTML = null;
        for(var propKey in props)if (hasOwnProperty.call(props, propKey)) {
            var propValue = props[propKey];
            if (propValue == null) continue;
            switch(propKey){
                case "children":
                    children = propValue;
                    break;
                case "dangerouslySetInnerHTML":
                    innerHTML = propValue;
                    break;
                default:
                    pushAttribute(target, responseState, propKey, propValue);
                    break;
            }
        }
        target.push(endOfStartTag); // text/html ignores the first character in these tags if it's a newline
        // Prefer to break application/xml over text/html (for now) by adding
        // a newline specifically to get eaten by the parser. (Alternately for
        // textareas, replacing "^\n" with "\r\n" doesn't get eaten, and the first
        // \r is normalized out by HTMLTextAreaElement#value.)
        // See: <http://www.w3.org/TR/html-polyglot/#newlines-in-textarea-and-pre>
        // See: <http://www.w3.org/TR/html5/syntax.html#element-restrictions>
        // See: <http://www.w3.org/TR/html5/syntax.html#newlines>
        // See: Parsing of "textarea" "listing" and "pre" elements
        //  from <http://www.w3.org/TR/html5/syntax.html#parsing-main-inbody>
        // TODO: This doesn't deal with the case where the child is an array
        // or component that returns a string.
        if (innerHTML != null) {
            if (children != null) throw new Error("Can only set one of `children` or `props.dangerouslySetInnerHTML`.");
            if (typeof innerHTML !== "object" || !("__html" in innerHTML)) throw new Error("`props.dangerouslySetInnerHTML` must be in the form `{__html: ...}`. Please visit https://reactjs.org/link/dangerously-set-inner-html for more information.");
            var html = innerHTML.__html;
            if (html !== null && html !== undefined) {
                if (typeof html === "string" && html.length > 0 && html[0] === "\n") target.push(leadingNewline, stringToChunk(html));
                else {
                    checkHtmlStringCoercion(html);
                    target.push(stringToChunk("" + html));
                }
            }
        }
        if (typeof children === "string" && children[0] === "\n") target.push(leadingNewline);
        return children;
    } // We accept any tag to be rendered but since this gets injected into arbitrary
    // HTML, we want to make sure that it's a safe tag.
    // http://www.w3.org/TR/REC-xml/#NT-Name
    var VALID_TAG_REGEX = /^[a-zA-Z][a-zA-Z:_\.\-\d]*$/; // Simplified subset
    var validatedTagCache = new Map();
    function startChunkForTag(tag) {
        var tagStartChunk = validatedTagCache.get(tag);
        if (tagStartChunk === undefined) {
            if (!VALID_TAG_REGEX.test(tag)) throw new Error("Invalid tag: " + tag);
            tagStartChunk = stringToPrecomputedChunk("<" + tag);
            validatedTagCache.set(tag, tagStartChunk);
        }
        return tagStartChunk;
    }
    var DOCTYPE = stringToPrecomputedChunk("<!DOCTYPE html>");
    function pushStartInstance(target, type, props, responseState, formatContext) {
        validateProperties(type, props);
        validateProperties$1(type, props);
        validateProperties$2(type, props, null);
        if (!props.suppressContentEditableWarning && props.contentEditable && props.children != null) error("A component is `contentEditable` and contains `children` managed by React. It is now your responsibility to guarantee that none of those nodes are unexpectedly modified or duplicated. This is probably not intentional.");
        if (formatContext.insertionMode !== SVG_MODE && formatContext.insertionMode !== MATHML_MODE) {
            if (type.indexOf("-") === -1 && typeof props.is !== "string" && type.toLowerCase() !== type) error("<%s /> is using incorrect casing. Use PascalCase for React components, or lowercase for HTML elements.", type);
        }
        switch(type){
            // Special tags
            case "select":
                return pushStartSelect(target, props, responseState);
            case "option":
                return pushStartOption(target, props, responseState, formatContext);
            case "textarea":
                return pushStartTextArea(target, props, responseState);
            case "input":
                return pushInput(target, props, responseState);
            case "menuitem":
                return pushStartMenuItem(target, props, responseState);
            case "title":
                return pushStartTitle(target, props, responseState);
            // Newline eating tags
            case "listing":
            case "pre":
                return pushStartPreformattedElement(target, props, type, responseState);
            // Omitted close tags
            case "area":
            case "base":
            case "br":
            case "col":
            case "embed":
            case "hr":
            case "img":
            case "keygen":
            case "link":
            case "meta":
            case "param":
            case "source":
            case "track":
            case "wbr":
                return pushSelfClosing(target, props, type, responseState);
            // These are reserved SVG and MathML elements, that are never custom elements.
            // https://w3c.github.io/webcomponents/spec/custom/#custom-elements-core-concepts
            case "annotation-xml":
            case "color-profile":
            case "font-face":
            case "font-face-src":
            case "font-face-uri":
            case "font-face-format":
            case "font-face-name":
            case "missing-glyph":
                return pushStartGenericElement(target, props, type, responseState);
            case "html":
                if (formatContext.insertionMode === ROOT_HTML_MODE) // If we're rendering the html tag and we're at the root (i.e. not in foreignObject)
                // then we also emit the DOCTYPE as part of the root content as a convenience for
                // rendering the whole document.
                target.push(DOCTYPE);
                return pushStartGenericElement(target, props, type, responseState);
            default:
                if (type.indexOf("-") === -1 && typeof props.is !== "string") // Generic element
                return pushStartGenericElement(target, props, type, responseState);
                else // Custom element
                return pushStartCustomElement(target, props, type, responseState);
        }
    }
    var endTag1 = stringToPrecomputedChunk("</");
    var endTag2 = stringToPrecomputedChunk(">");
    function pushEndInstance(target, type, props) {
        switch(type){
            // Omitted close tags
            // TODO: Instead of repeating this switch we could try to pass a flag from above.
            // That would require returning a tuple. Which might be ok if it gets inlined.
            case "area":
            case "base":
            case "br":
            case "col":
            case "embed":
            case "hr":
            case "img":
            case "input":
            case "keygen":
            case "link":
            case "meta":
            case "param":
            case "source":
            case "track":
            case "wbr":
                break;
            default:
                target.push(endTag1, stringToChunk(type), endTag2);
        }
    }
    function writeCompletedRoot(destination, responseState) {
        var bootstrapChunks = responseState.bootstrapChunks;
        var i = 0;
        for(; i < bootstrapChunks.length - 1; i++)writeChunk(destination, bootstrapChunks[i]);
        if (i < bootstrapChunks.length) return writeChunkAndReturn(destination, bootstrapChunks[i]);
        return true;
    } // Structural Nodes
    // A placeholder is a node inside a hidden partial tree that can be filled in later, but before
    // display. It's never visible to users. We use the template tag because it can be used in every
    // type of parent. <script> tags also work in every other tag except <colgroup>.
    var placeholder1 = stringToPrecomputedChunk('<template id="');
    var placeholder2 = stringToPrecomputedChunk('"></template>');
    function writePlaceholder(destination, responseState, id) {
        writeChunk(destination, placeholder1);
        writeChunk(destination, responseState.placeholderPrefix);
        var formattedID = stringToChunk(id.toString(16));
        writeChunk(destination, formattedID);
        return writeChunkAndReturn(destination, placeholder2);
    } // Suspense boundaries are encoded as comments.
    var startCompletedSuspenseBoundary = stringToPrecomputedChunk("<!--$-->");
    var startPendingSuspenseBoundary1 = stringToPrecomputedChunk('<!--$?--><template id="');
    var startPendingSuspenseBoundary2 = stringToPrecomputedChunk('"></template>');
    var startClientRenderedSuspenseBoundary = stringToPrecomputedChunk("<!--$!-->");
    var endSuspenseBoundary = stringToPrecomputedChunk("<!--/$-->");
    var clientRenderedSuspenseBoundaryError1 = stringToPrecomputedChunk("<template");
    var clientRenderedSuspenseBoundaryErrorAttrInterstitial = stringToPrecomputedChunk('"');
    var clientRenderedSuspenseBoundaryError1A = stringToPrecomputedChunk(' data-dgst="');
    var clientRenderedSuspenseBoundaryError1B = stringToPrecomputedChunk(' data-msg="');
    var clientRenderedSuspenseBoundaryError1C = stringToPrecomputedChunk(' data-stck="');
    var clientRenderedSuspenseBoundaryError2 = stringToPrecomputedChunk("></template>");
    function writeStartCompletedSuspenseBoundary(destination, responseState) {
        return writeChunkAndReturn(destination, startCompletedSuspenseBoundary);
    }
    function writeStartPendingSuspenseBoundary(destination, responseState, id) {
        writeChunk(destination, startPendingSuspenseBoundary1);
        if (id === null) throw new Error("An ID must have been assigned before we can complete the boundary.");
        writeChunk(destination, id);
        return writeChunkAndReturn(destination, startPendingSuspenseBoundary2);
    }
    function writeStartClientRenderedSuspenseBoundary(destination, responseState, errorDigest, errorMesssage, errorComponentStack) {
        var result;
        result = writeChunkAndReturn(destination, startClientRenderedSuspenseBoundary);
        writeChunk(destination, clientRenderedSuspenseBoundaryError1);
        if (errorDigest) {
            writeChunk(destination, clientRenderedSuspenseBoundaryError1A);
            writeChunk(destination, stringToChunk(escapeTextForBrowser(errorDigest)));
            writeChunk(destination, clientRenderedSuspenseBoundaryErrorAttrInterstitial);
        }
        if (errorMesssage) {
            writeChunk(destination, clientRenderedSuspenseBoundaryError1B);
            writeChunk(destination, stringToChunk(escapeTextForBrowser(errorMesssage)));
            writeChunk(destination, clientRenderedSuspenseBoundaryErrorAttrInterstitial);
        }
        if (errorComponentStack) {
            writeChunk(destination, clientRenderedSuspenseBoundaryError1C);
            writeChunk(destination, stringToChunk(escapeTextForBrowser(errorComponentStack)));
            writeChunk(destination, clientRenderedSuspenseBoundaryErrorAttrInterstitial);
        }
        result = writeChunkAndReturn(destination, clientRenderedSuspenseBoundaryError2);
        return result;
    }
    function writeEndCompletedSuspenseBoundary(destination, responseState) {
        return writeChunkAndReturn(destination, endSuspenseBoundary);
    }
    function writeEndPendingSuspenseBoundary(destination, responseState) {
        return writeChunkAndReturn(destination, endSuspenseBoundary);
    }
    function writeEndClientRenderedSuspenseBoundary(destination, responseState) {
        return writeChunkAndReturn(destination, endSuspenseBoundary);
    }
    var startSegmentHTML = stringToPrecomputedChunk('<div hidden id="');
    var startSegmentHTML2 = stringToPrecomputedChunk('">');
    var endSegmentHTML = stringToPrecomputedChunk("</div>");
    var startSegmentSVG = stringToPrecomputedChunk('<svg aria-hidden="true" style="display:none" id="');
    var startSegmentSVG2 = stringToPrecomputedChunk('">');
    var endSegmentSVG = stringToPrecomputedChunk("</svg>");
    var startSegmentMathML = stringToPrecomputedChunk('<math aria-hidden="true" style="display:none" id="');
    var startSegmentMathML2 = stringToPrecomputedChunk('">');
    var endSegmentMathML = stringToPrecomputedChunk("</math>");
    var startSegmentTable = stringToPrecomputedChunk('<table hidden id="');
    var startSegmentTable2 = stringToPrecomputedChunk('">');
    var endSegmentTable = stringToPrecomputedChunk("</table>");
    var startSegmentTableBody = stringToPrecomputedChunk('<table hidden><tbody id="');
    var startSegmentTableBody2 = stringToPrecomputedChunk('">');
    var endSegmentTableBody = stringToPrecomputedChunk("</tbody></table>");
    var startSegmentTableRow = stringToPrecomputedChunk('<table hidden><tr id="');
    var startSegmentTableRow2 = stringToPrecomputedChunk('">');
    var endSegmentTableRow = stringToPrecomputedChunk("</tr></table>");
    var startSegmentColGroup = stringToPrecomputedChunk('<table hidden><colgroup id="');
    var startSegmentColGroup2 = stringToPrecomputedChunk('">');
    var endSegmentColGroup = stringToPrecomputedChunk("</colgroup></table>");
    function writeStartSegment(destination, responseState, formatContext, id) {
        switch(formatContext.insertionMode){
            case ROOT_HTML_MODE:
            case HTML_MODE:
                writeChunk(destination, startSegmentHTML);
                writeChunk(destination, responseState.segmentPrefix);
                writeChunk(destination, stringToChunk(id.toString(16)));
                return writeChunkAndReturn(destination, startSegmentHTML2);
            case SVG_MODE:
                writeChunk(destination, startSegmentSVG);
                writeChunk(destination, responseState.segmentPrefix);
                writeChunk(destination, stringToChunk(id.toString(16)));
                return writeChunkAndReturn(destination, startSegmentSVG2);
            case MATHML_MODE:
                writeChunk(destination, startSegmentMathML);
                writeChunk(destination, responseState.segmentPrefix);
                writeChunk(destination, stringToChunk(id.toString(16)));
                return writeChunkAndReturn(destination, startSegmentMathML2);
            case HTML_TABLE_MODE:
                writeChunk(destination, startSegmentTable);
                writeChunk(destination, responseState.segmentPrefix);
                writeChunk(destination, stringToChunk(id.toString(16)));
                return writeChunkAndReturn(destination, startSegmentTable2);
            // TODO: For the rest of these, there will be extra wrapper nodes that never
            // get deleted from the document. We need to delete the table too as part
            // of the injected scripts. They are invisible though so it's not too terrible
            // and it's kind of an edge case to suspend in a table. Totally supported though.
            case HTML_TABLE_BODY_MODE:
                writeChunk(destination, startSegmentTableBody);
                writeChunk(destination, responseState.segmentPrefix);
                writeChunk(destination, stringToChunk(id.toString(16)));
                return writeChunkAndReturn(destination, startSegmentTableBody2);
            case HTML_TABLE_ROW_MODE:
                writeChunk(destination, startSegmentTableRow);
                writeChunk(destination, responseState.segmentPrefix);
                writeChunk(destination, stringToChunk(id.toString(16)));
                return writeChunkAndReturn(destination, startSegmentTableRow2);
            case HTML_COLGROUP_MODE:
                writeChunk(destination, startSegmentColGroup);
                writeChunk(destination, responseState.segmentPrefix);
                writeChunk(destination, stringToChunk(id.toString(16)));
                return writeChunkAndReturn(destination, startSegmentColGroup2);
            default:
                throw new Error("Unknown insertion mode. This is a bug in React.");
        }
    }
    function writeEndSegment(destination, formatContext) {
        switch(formatContext.insertionMode){
            case ROOT_HTML_MODE:
            case HTML_MODE:
                return writeChunkAndReturn(destination, endSegmentHTML);
            case SVG_MODE:
                return writeChunkAndReturn(destination, endSegmentSVG);
            case MATHML_MODE:
                return writeChunkAndReturn(destination, endSegmentMathML);
            case HTML_TABLE_MODE:
                return writeChunkAndReturn(destination, endSegmentTable);
            case HTML_TABLE_BODY_MODE:
                return writeChunkAndReturn(destination, endSegmentTableBody);
            case HTML_TABLE_ROW_MODE:
                return writeChunkAndReturn(destination, endSegmentTableRow);
            case HTML_COLGROUP_MODE:
                return writeChunkAndReturn(destination, endSegmentColGroup);
            default:
                throw new Error("Unknown insertion mode. This is a bug in React.");
        }
    } // Instruction Set
    // The following code is the source scripts that we then minify and inline below,
    // with renamed function names that we hope don't collide:
    // const COMMENT_NODE = 8;
    // const SUSPENSE_START_DATA = '$';
    // const SUSPENSE_END_DATA = '/$';
    // const SUSPENSE_PENDING_START_DATA = '$?';
    // const SUSPENSE_FALLBACK_START_DATA = '$!';
    //
    // function clientRenderBoundary(suspenseBoundaryID, errorDigest, errorMsg, errorComponentStack) {
    //   // Find the fallback's first element.
    //   const suspenseIdNode = document.getElementById(suspenseBoundaryID);
    //   if (!suspenseIdNode) {
    //     // The user must have already navigated away from this tree.
    //     // E.g. because the parent was hydrated.
    //     return;
    //   }
    //   // Find the boundary around the fallback. This is always the previous node.
    //   const suspenseNode = suspenseIdNode.previousSibling;
    //   // Tag it to be client rendered.
    //   suspenseNode.data = SUSPENSE_FALLBACK_START_DATA;
    //   // assign error metadata to first sibling
    //   let dataset = suspenseIdNode.dataset;
    //   if (errorDigest) dataset.dgst = errorDigest;
    //   if (errorMsg) dataset.msg = errorMsg;
    //   if (errorComponentStack) dataset.stck = errorComponentStack;
    //   // Tell React to retry it if the parent already hydrated.
    //   if (suspenseNode._reactRetry) {
    //     suspenseNode._reactRetry();
    //   }
    // }
    //
    // function completeBoundary(suspenseBoundaryID, contentID) {
    //   // Find the fallback's first element.
    //   const suspenseIdNode = document.getElementById(suspenseBoundaryID);
    //   const contentNode = document.getElementById(contentID);
    //   // We'll detach the content node so that regardless of what happens next we don't leave in the tree.
    //   // This might also help by not causing recalcing each time we move a child from here to the target.
    //   contentNode.parentNode.removeChild(contentNode);
    //   if (!suspenseIdNode) {
    //     // The user must have already navigated away from this tree.
    //     // E.g. because the parent was hydrated. That's fine there's nothing to do
    //     // but we have to make sure that we already deleted the container node.
    //     return;
    //   }
    //   // Find the boundary around the fallback. This is always the previous node.
    //   const suspenseNode = suspenseIdNode.previousSibling;
    //
    //   // Clear all the existing children. This is complicated because
    //   // there can be embedded Suspense boundaries in the fallback.
    //   // This is similar to clearSuspenseBoundary in ReactDOMHostConfig.
    //   // TODO: We could avoid this if we never emitted suspense boundaries in fallback trees.
    //   // They never hydrate anyway. However, currently we support incrementally loading the fallback.
    //   const parentInstance = suspenseNode.parentNode;
    //   let node = suspenseNode.nextSibling;
    //   let depth = 0;
    //   do {
    //     if (node && node.nodeType === COMMENT_NODE) {
    //       const data = node.data;
    //       if (data === SUSPENSE_END_DATA) {
    //         if (depth === 0) {
    //           break;
    //         } else {
    //           depth--;
    //         }
    //       } else if (
    //         data === SUSPENSE_START_DATA ||
    //         data === SUSPENSE_PENDING_START_DATA ||
    //         data === SUSPENSE_FALLBACK_START_DATA
    //       ) {
    //         depth++;
    //       }
    //     }
    //
    //     const nextNode = node.nextSibling;
    //     parentInstance.removeChild(node);
    //     node = nextNode;
    //   } while (node);
    //
    //   const endOfBoundary = node;
    //
    //   // Insert all the children from the contentNode between the start and end of suspense boundary.
    //   while (contentNode.firstChild) {
    //     parentInstance.insertBefore(contentNode.firstChild, endOfBoundary);
    //   }
    //   suspenseNode.data = SUSPENSE_START_DATA;
    //   if (suspenseNode._reactRetry) {
    //     suspenseNode._reactRetry();
    //   }
    // }
    //
    // function completeSegment(containerID, placeholderID) {
    //   const segmentContainer = document.getElementById(containerID);
    //   const placeholderNode = document.getElementById(placeholderID);
    //   // We always expect both nodes to exist here because, while we might
    //   // have navigated away from the main tree, we still expect the detached
    //   // tree to exist.
    //   segmentContainer.parentNode.removeChild(segmentContainer);
    //   while (segmentContainer.firstChild) {
    //     placeholderNode.parentNode.insertBefore(
    //       segmentContainer.firstChild,
    //       placeholderNode,
    //     );
    //   }
    //   placeholderNode.parentNode.removeChild(placeholderNode);
    // }
    var completeSegmentFunction = "function $RS(a,b){a=document.getElementById(a);b=document.getElementById(b);for(a.parentNode.removeChild(a);a.firstChild;)b.parentNode.insertBefore(a.firstChild,b);b.parentNode.removeChild(b)}";
    var completeBoundaryFunction = 'function $RC(a,b){a=document.getElementById(a);b=document.getElementById(b);b.parentNode.removeChild(b);if(a){a=a.previousSibling;var f=a.parentNode,c=a.nextSibling,e=0;do{if(c&&8===c.nodeType){var d=c.data;if("/$"===d)if(0===e)break;else e--;else"$"!==d&&"$?"!==d&&"$!"!==d||e++}d=c.nextSibling;f.removeChild(c);c=d}while(c);for(;b.firstChild;)f.insertBefore(b.firstChild,c);a.data="$";a._reactRetry&&a._reactRetry()}}';
    var clientRenderFunction = 'function $RX(b,c,d,e){var a=document.getElementById(b);a&&(b=a.previousSibling,b.data="$!",a=a.dataset,c&&(a.dgst=c),d&&(a.msg=d),e&&(a.stck=e),b._reactRetry&&b._reactRetry())}';
    var completeSegmentScript1Full = stringToPrecomputedChunk(completeSegmentFunction + ';$RS("');
    var completeSegmentScript1Partial = stringToPrecomputedChunk('$RS("');
    var completeSegmentScript2 = stringToPrecomputedChunk('","');
    var completeSegmentScript3 = stringToPrecomputedChunk('")</script>');
    function writeCompletedSegmentInstruction(destination, responseState, contentSegmentID) {
        writeChunk(destination, responseState.startInlineScript);
        if (!responseState.sentCompleteSegmentFunction) {
            // The first time we write this, we'll need to include the full implementation.
            responseState.sentCompleteSegmentFunction = true;
            writeChunk(destination, completeSegmentScript1Full);
        } else // Future calls can just reuse the same function.
        writeChunk(destination, completeSegmentScript1Partial);
        writeChunk(destination, responseState.segmentPrefix);
        var formattedID = stringToChunk(contentSegmentID.toString(16));
        writeChunk(destination, formattedID);
        writeChunk(destination, completeSegmentScript2);
        writeChunk(destination, responseState.placeholderPrefix);
        writeChunk(destination, formattedID);
        return writeChunkAndReturn(destination, completeSegmentScript3);
    }
    var completeBoundaryScript1Full = stringToPrecomputedChunk(completeBoundaryFunction + ';$RC("');
    var completeBoundaryScript1Partial = stringToPrecomputedChunk('$RC("');
    var completeBoundaryScript2 = stringToPrecomputedChunk('","');
    var completeBoundaryScript3 = stringToPrecomputedChunk('")</script>');
    function writeCompletedBoundaryInstruction(destination, responseState, boundaryID, contentSegmentID) {
        writeChunk(destination, responseState.startInlineScript);
        if (!responseState.sentCompleteBoundaryFunction) {
            // The first time we write this, we'll need to include the full implementation.
            responseState.sentCompleteBoundaryFunction = true;
            writeChunk(destination, completeBoundaryScript1Full);
        } else // Future calls can just reuse the same function.
        writeChunk(destination, completeBoundaryScript1Partial);
        if (boundaryID === null) throw new Error("An ID must have been assigned before we can complete the boundary.");
        var formattedContentID = stringToChunk(contentSegmentID.toString(16));
        writeChunk(destination, boundaryID);
        writeChunk(destination, completeBoundaryScript2);
        writeChunk(destination, responseState.segmentPrefix);
        writeChunk(destination, formattedContentID);
        return writeChunkAndReturn(destination, completeBoundaryScript3);
    }
    var clientRenderScript1Full = stringToPrecomputedChunk(clientRenderFunction + ';$RX("');
    var clientRenderScript1Partial = stringToPrecomputedChunk('$RX("');
    var clientRenderScript1A = stringToPrecomputedChunk('"');
    var clientRenderScript2 = stringToPrecomputedChunk(")</script>");
    var clientRenderErrorScriptArgInterstitial = stringToPrecomputedChunk(",");
    function writeClientRenderBoundaryInstruction(destination, responseState, boundaryID, errorDigest, errorMessage, errorComponentStack) {
        writeChunk(destination, responseState.startInlineScript);
        if (!responseState.sentClientRenderFunction) {
            // The first time we write this, we'll need to include the full implementation.
            responseState.sentClientRenderFunction = true;
            writeChunk(destination, clientRenderScript1Full);
        } else // Future calls can just reuse the same function.
        writeChunk(destination, clientRenderScript1Partial);
        if (boundaryID === null) throw new Error("An ID must have been assigned before we can complete the boundary.");
        writeChunk(destination, boundaryID);
        writeChunk(destination, clientRenderScript1A);
        if (errorDigest || errorMessage || errorComponentStack) {
            writeChunk(destination, clientRenderErrorScriptArgInterstitial);
            writeChunk(destination, stringToChunk(escapeJSStringsForInstructionScripts(errorDigest || "")));
        }
        if (errorMessage || errorComponentStack) {
            writeChunk(destination, clientRenderErrorScriptArgInterstitial);
            writeChunk(destination, stringToChunk(escapeJSStringsForInstructionScripts(errorMessage || "")));
        }
        if (errorComponentStack) {
            writeChunk(destination, clientRenderErrorScriptArgInterstitial);
            writeChunk(destination, stringToChunk(escapeJSStringsForInstructionScripts(errorComponentStack)));
        }
        return writeChunkAndReturn(destination, clientRenderScript2);
    }
    var regexForJSStringsInScripts = /[<\u2028\u2029]/g;
    function escapeJSStringsForInstructionScripts(input) {
        var escaped = JSON.stringify(input);
        return escaped.replace(regexForJSStringsInScripts, function(match) {
            switch(match){
                // santizing breaking out of strings and script tags
                case "<":
                    return "\\u003c";
                case "\u2028":
                    return "\\u2028";
                case "\u2029":
                    return "\\u2029";
                default:
                    // eslint-disable-next-line react-internal/prod-error-codes
                    throw new Error("escapeJSStringsForInstructionScripts encountered a match it does not know how to replace. this means the match regex and the replacement characters are no longer in sync. This is a bug in React");
            }
        });
    }
    function createResponseState$1(generateStaticMarkup, identifierPrefix) {
        var responseState = createResponseState(identifierPrefix, undefined);
        return {
            // Keep this in sync with ReactDOMServerFormatConfig
            bootstrapChunks: responseState.bootstrapChunks,
            startInlineScript: responseState.startInlineScript,
            placeholderPrefix: responseState.placeholderPrefix,
            segmentPrefix: responseState.segmentPrefix,
            boundaryPrefix: responseState.boundaryPrefix,
            idPrefix: responseState.idPrefix,
            nextSuspenseID: responseState.nextSuspenseID,
            sentCompleteSegmentFunction: responseState.sentCompleteSegmentFunction,
            sentCompleteBoundaryFunction: responseState.sentCompleteBoundaryFunction,
            sentClientRenderFunction: responseState.sentClientRenderFunction,
            // This is an extra field for the legacy renderer
            generateStaticMarkup: generateStaticMarkup
        };
    }
    function createRootFormatContext() {
        return {
            insertionMode: HTML_MODE,
            // We skip the root mode because we don't want to emit the DOCTYPE in legacy mode.
            selectedValue: null
        };
    }
    function pushTextInstance$1(target, text, responseState, textEmbedded) {
        if (responseState.generateStaticMarkup) {
            target.push(stringToChunk(escapeTextForBrowser(text)));
            return false;
        } else return pushTextInstance(target, text, responseState, textEmbedded);
    }
    function pushSegmentFinale$1(target, responseState, lastPushedText, textEmbedded) {
        if (responseState.generateStaticMarkup) return;
        else return pushSegmentFinale(target, responseState, lastPushedText, textEmbedded);
    }
    function writeStartCompletedSuspenseBoundary$1(destination, responseState) {
        if (responseState.generateStaticMarkup) // A completed boundary is done and doesn't need a representation in the HTML
        // if we're not going to be hydrating it.
        return true;
        return writeStartCompletedSuspenseBoundary(destination);
    }
    function writeStartClientRenderedSuspenseBoundary$1(destination, responseState, errorDigest, errorMessage, errorComponentStack) {
        if (responseState.generateStaticMarkup) // A client rendered boundary is done and doesn't need a representation in the HTML
        // since we'll never hydrate it. This is arguably an error in static generation.
        return true;
        return writeStartClientRenderedSuspenseBoundary(destination, responseState, errorDigest, errorMessage, errorComponentStack);
    }
    function writeEndCompletedSuspenseBoundary$1(destination, responseState) {
        if (responseState.generateStaticMarkup) return true;
        return writeEndCompletedSuspenseBoundary(destination);
    }
    function writeEndClientRenderedSuspenseBoundary$1(destination, responseState) {
        if (responseState.generateStaticMarkup) return true;
        return writeEndClientRenderedSuspenseBoundary(destination);
    }
    var assign = Object.assign;
    // ATTENTION
    // When adding new symbols to this file,
    // Please consider also adding to 'react-devtools-shared/src/backend/ReactSymbols'
    // The Symbol used to tag the ReactElement-like types.
    var REACT_ELEMENT_TYPE = Symbol.for("react.element");
    var REACT_PORTAL_TYPE = Symbol.for("react.portal");
    var REACT_FRAGMENT_TYPE = Symbol.for("react.fragment");
    var REACT_STRICT_MODE_TYPE = Symbol.for("react.strict_mode");
    var REACT_PROFILER_TYPE = Symbol.for("react.profiler");
    var REACT_PROVIDER_TYPE = Symbol.for("react.provider");
    var REACT_CONTEXT_TYPE = Symbol.for("react.context");
    var REACT_FORWARD_REF_TYPE = Symbol.for("react.forward_ref");
    var REACT_SUSPENSE_TYPE = Symbol.for("react.suspense");
    var REACT_SUSPENSE_LIST_TYPE = Symbol.for("react.suspense_list");
    var REACT_MEMO_TYPE = Symbol.for("react.memo");
    var REACT_LAZY_TYPE = Symbol.for("react.lazy");
    var REACT_SCOPE_TYPE = Symbol.for("react.scope");
    var REACT_DEBUG_TRACING_MODE_TYPE = Symbol.for("react.debug_trace_mode");
    var REACT_LEGACY_HIDDEN_TYPE = Symbol.for("react.legacy_hidden");
    var REACT_SERVER_CONTEXT_DEFAULT_VALUE_NOT_LOADED = Symbol.for("react.default_value");
    var MAYBE_ITERATOR_SYMBOL = Symbol.iterator;
    var FAUX_ITERATOR_SYMBOL = "@@iterator";
    function getIteratorFn(maybeIterable) {
        if (maybeIterable === null || typeof maybeIterable !== "object") return null;
        var maybeIterator = MAYBE_ITERATOR_SYMBOL && maybeIterable[MAYBE_ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL];
        if (typeof maybeIterator === "function") return maybeIterator;
        return null;
    }
    function getWrappedName(outerType, innerType, wrapperName) {
        var displayName = outerType.displayName;
        if (displayName) return displayName;
        var functionName = innerType.displayName || innerType.name || "";
        return functionName !== "" ? wrapperName + "(" + functionName + ")" : wrapperName;
    } // Keep in sync with react-reconciler/getComponentNameFromFiber
    function getContextName(type) {
        return type.displayName || "Context";
    } // Note that the reconciler package should generally prefer to use getComponentNameFromFiber() instead.
    function getComponentNameFromType(type) {
        if (type == null) // Host root, text node or just invalid type.
        return null;
        if (typeof type.tag === "number") error("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue.");
        if (typeof type === "function") return type.displayName || type.name || null;
        if (typeof type === "string") return type;
        switch(type){
            case REACT_FRAGMENT_TYPE:
                return "Fragment";
            case REACT_PORTAL_TYPE:
                return "Portal";
            case REACT_PROFILER_TYPE:
                return "Profiler";
            case REACT_STRICT_MODE_TYPE:
                return "StrictMode";
            case REACT_SUSPENSE_TYPE:
                return "Suspense";
            case REACT_SUSPENSE_LIST_TYPE:
                return "SuspenseList";
        }
        if (typeof type === "object") switch(type.$$typeof){
            case REACT_CONTEXT_TYPE:
                var context = type;
                return getContextName(context) + ".Consumer";
            case REACT_PROVIDER_TYPE:
                var provider = type;
                return getContextName(provider._context) + ".Provider";
            case REACT_FORWARD_REF_TYPE:
                return getWrappedName(type, type.render, "ForwardRef");
            case REACT_MEMO_TYPE:
                var outerName = type.displayName || null;
                if (outerName !== null) return outerName;
                return getComponentNameFromType(type.type) || "Memo";
            case REACT_LAZY_TYPE:
                var lazyComponent = type;
                var payload = lazyComponent._payload;
                var init = lazyComponent._init;
                try {
                    return getComponentNameFromType(init(payload));
                } catch (x) {
                    return null;
                }
        }
        return null;
    }
    // Helpers to patch console.logs to avoid logging during side-effect free
    // replaying on render function. This currently only patches the object
    // lazily which won't cover if the log function was extracted eagerly.
    // We could also eagerly patch the method.
    var disabledDepth = 0;
    var prevLog;
    var prevInfo;
    var prevWarn;
    var prevError;
    var prevGroup;
    var prevGroupCollapsed;
    var prevGroupEnd;
    function disabledLog() {}
    disabledLog.__reactDisabledLog = true;
    function disableLogs() {
        if (disabledDepth === 0) {
            /* eslint-disable react-internal/no-production-logging */ prevLog = console.log;
            prevInfo = console.info;
            prevWarn = console.warn;
            prevError = console.error;
            prevGroup = console.group;
            prevGroupCollapsed = console.groupCollapsed;
            prevGroupEnd = console.groupEnd; // https://github.com/facebook/react/issues/19099
            var props = {
                configurable: true,
                enumerable: true,
                value: disabledLog,
                writable: true
            }; // $FlowFixMe Flow thinks console is immutable.
            Object.defineProperties(console, {
                info: props,
                log: props,
                warn: props,
                error: props,
                group: props,
                groupCollapsed: props,
                groupEnd: props
            });
        /* eslint-enable react-internal/no-production-logging */ }
        disabledDepth++;
    }
    function reenableLogs() {
        disabledDepth--;
        if (disabledDepth === 0) {
            /* eslint-disable react-internal/no-production-logging */ var props = {
                configurable: true,
                enumerable: true,
                writable: true
            }; // $FlowFixMe Flow thinks console is immutable.
            Object.defineProperties(console, {
                log: assign({}, props, {
                    value: prevLog
                }),
                info: assign({}, props, {
                    value: prevInfo
                }),
                warn: assign({}, props, {
                    value: prevWarn
                }),
                error: assign({}, props, {
                    value: prevError
                }),
                group: assign({}, props, {
                    value: prevGroup
                }),
                groupCollapsed: assign({}, props, {
                    value: prevGroupCollapsed
                }),
                groupEnd: assign({}, props, {
                    value: prevGroupEnd
                })
            });
        /* eslint-enable react-internal/no-production-logging */ }
        if (disabledDepth < 0) error("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
    }
    var ReactCurrentDispatcher = ReactSharedInternals.ReactCurrentDispatcher;
    var prefix;
    function describeBuiltInComponentFrame(name, source, ownerFn) {
        if (prefix === undefined) // Extract the VM specific prefix used by each line.
        try {
            throw Error();
        } catch (x) {
            var match = x.stack.trim().match(/\n( *(at )?)/);
            prefix = match && match[1] || "";
        }
         // We use the prefix to ensure our stacks line up with native stack frames.
        return "\n" + prefix + name;
    }
    var reentry = false;
    var componentFrameCache;
    var PossiblyWeakMap = typeof WeakMap === "function" ? WeakMap : Map;
    componentFrameCache = new PossiblyWeakMap();
    function describeNativeComponentFrame(fn, construct) {
        // If something asked for a stack inside a fake render, it should get ignored.
        if (!fn || reentry) return "";
        var frame = componentFrameCache.get(fn);
        if (frame !== undefined) return frame;
        var control;
        reentry = true;
        var previousPrepareStackTrace = Error.prepareStackTrace; // $FlowFixMe It does accept undefined.
        Error.prepareStackTrace = undefined;
        var previousDispatcher;
        previousDispatcher = ReactCurrentDispatcher.current; // Set the dispatcher in DEV because this might be call in the render function
        // for warnings.
        ReactCurrentDispatcher.current = null;
        disableLogs();
        try {
            // This should throw.
            if (construct) {
                // Something should be setting the props in the constructor.
                var Fake = function() {
                    throw Error();
                }; // $FlowFixMe
                Object.defineProperty(Fake.prototype, "props", {
                    set: function() {
                        // We use a throwing setter instead of frozen or non-writable props
                        // because that won't throw in a non-strict mode function.
                        throw Error();
                    }
                });
                if (typeof Reflect === "object" && Reflect.construct) {
                    // We construct a different control for this case to include any extra
                    // frames added by the construct call.
                    try {
                        Reflect.construct(Fake, []);
                    } catch (x) {
                        control = x;
                    }
                    Reflect.construct(fn, [], Fake);
                } else {
                    try {
                        Fake.call();
                    } catch (x) {
                        control = x;
                    }
                    fn.call(Fake.prototype);
                }
            } else {
                try {
                    throw Error();
                } catch (x) {
                    control = x;
                }
                fn();
            }
        } catch (sample) {
            // This is inlined manually because closure doesn't do it for us.
            if (sample && control && typeof sample.stack === "string") {
                // This extracts the first frame from the sample that isn't also in the control.
                // Skipping one frame that we assume is the frame that calls the two.
                var sampleLines = sample.stack.split("\n");
                var controlLines = control.stack.split("\n");
                var s = sampleLines.length - 1;
                var c = controlLines.length - 1;
                while(s >= 1 && c >= 0 && sampleLines[s] !== controlLines[c])// We expect at least one stack frame to be shared.
                // Typically this will be the root most one. However, stack frames may be
                // cut off due to maximum stack limits. In this case, one maybe cut off
                // earlier than the other. We assume that the sample is longer or the same
                // and there for cut off earlier. So we should find the root most frame in
                // the sample somewhere in the control.
                c--;
                for(; s >= 1 && c >= 0; s--, c--)// Next we find the first one that isn't the same which should be the
                // frame that called our sample function and the control.
                if (sampleLines[s] !== controlLines[c]) {
                    // In V8, the first line is describing the message but other VMs don't.
                    // If we're about to return the first line, and the control is also on the same
                    // line, that's a pretty good indicator that our sample threw at same line as
                    // the control. I.e. before we entered the sample frame. So we ignore this result.
                    // This can happen if you passed a class to function component, or non-function.
                    if (s !== 1 || c !== 1) do {
                        s--;
                        c--; // We may still have similar intermediate frames from the construct call.
                        // The next one that isn't the same should be our match though.
                        if (c < 0 || sampleLines[s] !== controlLines[c]) {
                            // V8 adds a "new" prefix for native classes. Let's remove it to make it prettier.
                            var _frame = "\n" + sampleLines[s].replace(" at new ", " at "); // If our component frame is labeled "<anonymous>"
                            // but we have a user-provided "displayName"
                            // splice it in to make the stack more readable.
                            if (fn.displayName && _frame.includes("<anonymous>")) _frame = _frame.replace("<anonymous>", fn.displayName);
                            if (typeof fn === "function") componentFrameCache.set(fn, _frame);
                            return _frame;
                        }
                    }while (s >= 1 && c >= 0);
                    break;
                }
            }
        } finally{
            reentry = false;
            ReactCurrentDispatcher.current = previousDispatcher;
            reenableLogs();
            Error.prepareStackTrace = previousPrepareStackTrace;
        } // Fallback to just using the name if we couldn't make it throw.
        var name = fn ? fn.displayName || fn.name : "";
        var syntheticFrame = name ? describeBuiltInComponentFrame(name) : "";
        if (typeof fn === "function") componentFrameCache.set(fn, syntheticFrame);
        return syntheticFrame;
    }
    function describeClassComponentFrame(ctor, source, ownerFn) {
        return describeNativeComponentFrame(ctor, true);
    }
    function describeFunctionComponentFrame(fn, source, ownerFn) {
        return describeNativeComponentFrame(fn, false);
    }
    function shouldConstruct(Component) {
        var prototype = Component.prototype;
        return !!(prototype && prototype.isReactComponent);
    }
    function describeUnknownElementTypeFrameInDEV(type, source, ownerFn) {
        if (type == null) return "";
        if (typeof type === "function") return describeNativeComponentFrame(type, shouldConstruct(type));
        if (typeof type === "string") return describeBuiltInComponentFrame(type);
        switch(type){
            case REACT_SUSPENSE_TYPE:
                return describeBuiltInComponentFrame("Suspense");
            case REACT_SUSPENSE_LIST_TYPE:
                return describeBuiltInComponentFrame("SuspenseList");
        }
        if (typeof type === "object") switch(type.$$typeof){
            case REACT_FORWARD_REF_TYPE:
                return describeFunctionComponentFrame(type.render);
            case REACT_MEMO_TYPE:
                // Memo may contain any component type so we recursively resolve it.
                return describeUnknownElementTypeFrameInDEV(type.type, source, ownerFn);
            case REACT_LAZY_TYPE:
                var lazyComponent = type;
                var payload = lazyComponent._payload;
                var init = lazyComponent._init;
                try {
                    // Lazy may contain any component type so we recursively resolve it.
                    return describeUnknownElementTypeFrameInDEV(init(payload), source, ownerFn);
                } catch (x) {}
        }
        return "";
    }
    var loggedTypeFailures = {};
    var ReactDebugCurrentFrame = ReactSharedInternals.ReactDebugCurrentFrame;
    function setCurrentlyValidatingElement(element) {
        if (element) {
            var owner = element._owner;
            var stack = describeUnknownElementTypeFrameInDEV(element.type, element._source, owner ? owner.type : null);
            ReactDebugCurrentFrame.setExtraStackFrame(stack);
        } else ReactDebugCurrentFrame.setExtraStackFrame(null);
    }
    function checkPropTypes(typeSpecs, values, location, componentName, element) {
        // $FlowFixMe This is okay but Flow doesn't know it.
        var has = Function.call.bind(hasOwnProperty);
        for(var typeSpecName in typeSpecs)if (has(typeSpecs, typeSpecName)) {
            var error$1 = void 0; // Prop type validation may throw. In case they do, we don't want to
            // fail the render phase where it didn't fail before. So we log it.
            // After these have been cleaned up, we'll let them throw.
            try {
                // This is intentionally an invariant that gets caught. It's the same
                // behavior as without this statement except with a better message.
                if (typeof typeSpecs[typeSpecName] !== "function") {
                    // eslint-disable-next-line react-internal/prod-error-codes
                    var err = Error((componentName || "React class") + ": " + location + " type `" + typeSpecName + "` is invalid; " + "it must be a function, usually from the `prop-types` package, but received `" + typeof typeSpecs[typeSpecName] + "`." + "This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                    err.name = "Invariant Violation";
                    throw err;
                }
                error$1 = typeSpecs[typeSpecName](values, typeSpecName, componentName, location, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (ex) {
                error$1 = ex;
            }
            if (error$1 && !(error$1 instanceof Error)) {
                setCurrentlyValidatingElement(element);
                error("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", componentName || "React class", location, typeSpecName, typeof error$1);
                setCurrentlyValidatingElement(null);
            }
            if (error$1 instanceof Error && !(error$1.message in loggedTypeFailures)) {
                // Only monitor this failure once because there tends to be a lot of the
                // same error.
                loggedTypeFailures[error$1.message] = true;
                setCurrentlyValidatingElement(element);
                error("Failed %s type: %s", location, error$1.message);
                setCurrentlyValidatingElement(null);
            }
        }
    }
    var warnedAboutMissingGetChildContext;
    warnedAboutMissingGetChildContext = {};
    var emptyContextObject = {};
    Object.freeze(emptyContextObject);
    function getMaskedContext(type, unmaskedContext) {
        var contextTypes = type.contextTypes;
        if (!contextTypes) return emptyContextObject;
        var context = {};
        for(var key in contextTypes)context[key] = unmaskedContext[key];
        var name = getComponentNameFromType(type) || "Unknown";
        checkPropTypes(contextTypes, context, "context", name);
        return context;
    }
    function processChildContext(instance, type, parentContext, childContextTypes) {
        // TODO (bvaughn) Replace this behavior with an invariant() in the future.
        // It has only been added in Fiber to match the (unintentional) behavior in Stack.
        if (typeof instance.getChildContext !== "function") {
            var componentName = getComponentNameFromType(type) || "Unknown";
            if (!warnedAboutMissingGetChildContext[componentName]) {
                warnedAboutMissingGetChildContext[componentName] = true;
                error("%s.childContextTypes is specified but there is no getChildContext() method on the instance. You can either define getChildContext() on %s or remove childContextTypes from it.", componentName, componentName);
            }
            return parentContext;
        }
        var childContext = instance.getChildContext();
        for(var contextKey in childContext){
            if (!(contextKey in childContextTypes)) throw new Error((getComponentNameFromType(type) || "Unknown") + '.getChildContext(): key "' + contextKey + '" is not defined in childContextTypes.');
        }
        var name = getComponentNameFromType(type) || "Unknown";
        checkPropTypes(childContextTypes, childContext, "child context", name);
        return assign({}, parentContext, childContext);
    }
    var rendererSigil;
    // Use this to detect multiple renderers using the same context
    rendererSigil = {};
    // Forming a reverse tree.
    var rootContextSnapshot = null; // We assume that this runtime owns the "current" field on all ReactContext instances.
    // This global (actually thread local) state represents what state all those "current",
    // fields are currently in.
    var currentActiveSnapshot = null;
    function popNode(prev) {
        prev.context._currentValue2 = prev.parentValue;
    }
    function pushNode(next) {
        next.context._currentValue2 = next.value;
    }
    function popToNearestCommonAncestor(prev, next) {
        if (prev === next) ;
        else {
            popNode(prev);
            var parentPrev = prev.parent;
            var parentNext = next.parent;
            if (parentPrev === null) {
                if (parentNext !== null) throw new Error("The stacks must reach the root at the same time. This is a bug in React.");
            } else {
                if (parentNext === null) throw new Error("The stacks must reach the root at the same time. This is a bug in React.");
                popToNearestCommonAncestor(parentPrev, parentNext);
            } // On the way back, we push the new ones that weren't common.
            pushNode(next);
        }
    }
    function popAllPrevious(prev) {
        popNode(prev);
        var parentPrev = prev.parent;
        if (parentPrev !== null) popAllPrevious(parentPrev);
    }
    function pushAllNext(next) {
        var parentNext = next.parent;
        if (parentNext !== null) pushAllNext(parentNext);
        pushNode(next);
    }
    function popPreviousToCommonLevel(prev, next) {
        popNode(prev);
        var parentPrev = prev.parent;
        if (parentPrev === null) throw new Error("The depth must equal at least at zero before reaching the root. This is a bug in React.");
        if (parentPrev.depth === next.depth) // We found the same level. Now we just need to find a shared ancestor.
        popToNearestCommonAncestor(parentPrev, next);
        else // We must still be deeper.
        popPreviousToCommonLevel(parentPrev, next);
    }
    function popNextToCommonLevel(prev, next) {
        var parentNext = next.parent;
        if (parentNext === null) throw new Error("The depth must equal at least at zero before reaching the root. This is a bug in React.");
        if (prev.depth === parentNext.depth) // We found the same level. Now we just need to find a shared ancestor.
        popToNearestCommonAncestor(prev, parentNext);
        else // We must still be deeper.
        popNextToCommonLevel(prev, parentNext);
        pushNode(next);
    } // Perform context switching to the new snapshot.
    // To make it cheap to read many contexts, while not suspending, we make the switch eagerly by
    // updating all the context's current values. That way reads, always just read the current value.
    // At the cost of updating contexts even if they're never read by this subtree.
    function switchContext(newSnapshot) {
        // The basic algorithm we need to do is to pop back any contexts that are no longer on the stack.
        // We also need to update any new contexts that are now on the stack with the deepest value.
        // The easiest way to update new contexts is to just reapply them in reverse order from the
        // perspective of the backpointers. To avoid allocating a lot when switching, we use the stack
        // for that. Therefore this algorithm is recursive.
        // 1) First we pop which ever snapshot tree was deepest. Popping old contexts as we go.
        // 2) Then we find the nearest common ancestor from there. Popping old contexts as we go.
        // 3) Then we reapply new contexts on the way back up the stack.
        var prev = currentActiveSnapshot;
        var next = newSnapshot;
        if (prev !== next) {
            if (prev === null) // $FlowFixMe: This has to be non-null since it's not equal to prev.
            pushAllNext(next);
            else if (next === null) popAllPrevious(prev);
            else if (prev.depth === next.depth) popToNearestCommonAncestor(prev, next);
            else if (prev.depth > next.depth) popPreviousToCommonLevel(prev, next);
            else popNextToCommonLevel(prev, next);
            currentActiveSnapshot = next;
        }
    }
    function pushProvider(context, nextValue) {
        var prevValue;
        prevValue = context._currentValue2;
        context._currentValue2 = nextValue;
        if (context._currentRenderer2 !== undefined && context._currentRenderer2 !== null && context._currentRenderer2 !== rendererSigil) error("Detected multiple renderers concurrently rendering the same context provider. This is currently unsupported.");
        context._currentRenderer2 = rendererSigil;
        var prevNode = currentActiveSnapshot;
        var newNode = {
            parent: prevNode,
            depth: prevNode === null ? 0 : prevNode.depth + 1,
            context: context,
            parentValue: prevValue,
            value: nextValue
        };
        currentActiveSnapshot = newNode;
        return newNode;
    }
    function popProvider(context) {
        var prevSnapshot = currentActiveSnapshot;
        if (prevSnapshot === null) throw new Error("Tried to pop a Context at the root of the app. This is a bug in React.");
        if (prevSnapshot.context !== context) error("The parent context is not the expected context. This is probably a bug in React.");
        var _value = prevSnapshot.parentValue;
        if (_value === REACT_SERVER_CONTEXT_DEFAULT_VALUE_NOT_LOADED) prevSnapshot.context._currentValue2 = prevSnapshot.context._defaultValue;
        else prevSnapshot.context._currentValue2 = _value;
        if (context._currentRenderer2 !== undefined && context._currentRenderer2 !== null && context._currentRenderer2 !== rendererSigil) error("Detected multiple renderers concurrently rendering the same context provider. This is currently unsupported.");
        context._currentRenderer2 = rendererSigil;
        return currentActiveSnapshot = prevSnapshot.parent;
    }
    function getActiveContext() {
        return currentActiveSnapshot;
    }
    function readContext(context) {
        var value = context._currentValue2;
        return value;
    }
    /**
 * `ReactInstanceMap` maintains a mapping from a public facing stateful
 * instance (key) and the internal representation (value). This allows public
 * methods to accept the user facing instance as an argument and map them back
 * to internal methods.
 *
 * Note that this module is currently shared and assumed to be stateless.
 * If this becomes an actual Map, that will break.
 */ function get(key) {
        return key._reactInternals;
    }
    function set(key, value) {
        key._reactInternals = value;
    }
    var didWarnAboutNoopUpdateForComponent = {};
    var didWarnAboutDeprecatedWillMount = {};
    var didWarnAboutUninitializedState;
    var didWarnAboutGetSnapshotBeforeUpdateWithoutDidUpdate;
    var didWarnAboutLegacyLifecyclesAndDerivedState;
    var didWarnAboutUndefinedDerivedState;
    var warnOnUndefinedDerivedState;
    var warnOnInvalidCallback;
    var didWarnAboutDirectlyAssigningPropsToState;
    var didWarnAboutContextTypeAndContextTypes;
    var didWarnAboutInvalidateContextType;
    didWarnAboutUninitializedState = new Set();
    didWarnAboutGetSnapshotBeforeUpdateWithoutDidUpdate = new Set();
    didWarnAboutLegacyLifecyclesAndDerivedState = new Set();
    didWarnAboutDirectlyAssigningPropsToState = new Set();
    didWarnAboutUndefinedDerivedState = new Set();
    didWarnAboutContextTypeAndContextTypes = new Set();
    didWarnAboutInvalidateContextType = new Set();
    var didWarnOnInvalidCallback = new Set();
    warnOnInvalidCallback = function(callback, callerName) {
        if (callback === null || typeof callback === "function") return;
        var key = callerName + "_" + callback;
        if (!didWarnOnInvalidCallback.has(key)) {
            didWarnOnInvalidCallback.add(key);
            error("%s(...): Expected the last optional `callback` argument to be a function. Instead received: %s.", callerName, callback);
        }
    };
    warnOnUndefinedDerivedState = function(type, partialState) {
        if (partialState === undefined) {
            var componentName = getComponentNameFromType(type) || "Component";
            if (!didWarnAboutUndefinedDerivedState.has(componentName)) {
                didWarnAboutUndefinedDerivedState.add(componentName);
                error("%s.getDerivedStateFromProps(): A valid state object (or null) must be returned. You have returned undefined.", componentName);
            }
        }
    };
    function warnNoop(publicInstance, callerName) {
        var _constructor = publicInstance.constructor;
        var componentName = _constructor && getComponentNameFromType(_constructor) || "ReactClass";
        var warningKey = componentName + "." + callerName;
        if (didWarnAboutNoopUpdateForComponent[warningKey]) return;
        error("%s(...): Can only update a mounting component. This usually means you called %s() outside componentWillMount() on the server. This is a no-op.\n\nPlease check the code for the %s component.", callerName, callerName, componentName);
        didWarnAboutNoopUpdateForComponent[warningKey] = true;
    }
    var classComponentUpdater = {
        isMounted: function(inst) {
            return false;
        },
        enqueueSetState: function(inst, payload, callback) {
            var internals = get(inst);
            if (internals.queue === null) warnNoop(inst, "setState");
            else {
                internals.queue.push(payload);
                if (callback !== undefined && callback !== null) warnOnInvalidCallback(callback, "setState");
            }
        },
        enqueueReplaceState: function(inst, payload, callback) {
            var internals = get(inst);
            internals.replace = true;
            internals.queue = [
                payload
            ];
            if (callback !== undefined && callback !== null) warnOnInvalidCallback(callback, "setState");
        },
        enqueueForceUpdate: function(inst, callback) {
            var internals = get(inst);
            if (internals.queue === null) warnNoop(inst, "forceUpdate");
            else if (callback !== undefined && callback !== null) warnOnInvalidCallback(callback, "setState");
        }
    };
    function applyDerivedStateFromProps(instance, ctor, getDerivedStateFromProps, prevState, nextProps) {
        var partialState = getDerivedStateFromProps(nextProps, prevState);
        warnOnUndefinedDerivedState(ctor, partialState);
        var newState = partialState === null || partialState === undefined ? prevState : assign({}, prevState, partialState);
        return newState;
    }
    function constructClassInstance(ctor, props, maskedLegacyContext) {
        var context = emptyContextObject;
        var contextType = ctor.contextType;
        if ("contextType" in ctor) {
            var isValid = contextType === null || contextType !== undefined && contextType.$$typeof === REACT_CONTEXT_TYPE && contextType._context === undefined; // Not a <Context.Consumer>
            if (!isValid && !didWarnAboutInvalidateContextType.has(ctor)) {
                didWarnAboutInvalidateContextType.add(ctor);
                var addendum = "";
                if (contextType === undefined) addendum = " However, it is set to undefined. This can be caused by a typo or by mixing up named and default imports. This can also happen due to a circular dependency, so try moving the createContext() call to a separate file.";
                else if (typeof contextType !== "object") addendum = " However, it is set to a " + typeof contextType + ".";
                else if (contextType.$$typeof === REACT_PROVIDER_TYPE) addendum = " Did you accidentally pass the Context.Provider instead?";
                else if (contextType._context !== undefined) // <Context.Consumer>
                addendum = " Did you accidentally pass the Context.Consumer instead?";
                else addendum = " However, it is set to an object with keys {" + Object.keys(contextType).join(", ") + "}.";
                error("%s defines an invalid contextType. contextType should point to the Context object returned by React.createContext().%s", getComponentNameFromType(ctor) || "Component", addendum);
            }
        }
        if (typeof contextType === "object" && contextType !== null) context = readContext(contextType);
        else context = maskedLegacyContext;
        var instance = new ctor(props, context);
        if (typeof ctor.getDerivedStateFromProps === "function" && (instance.state === null || instance.state === undefined)) {
            var componentName = getComponentNameFromType(ctor) || "Component";
            if (!didWarnAboutUninitializedState.has(componentName)) {
                didWarnAboutUninitializedState.add(componentName);
                error("`%s` uses `getDerivedStateFromProps` but its initial state is %s. This is not recommended. Instead, define the initial state by assigning an object to `this.state` in the constructor of `%s`. This ensures that `getDerivedStateFromProps` arguments have a consistent shape.", componentName, instance.state === null ? "null" : "undefined", componentName);
            }
        } // If new component APIs are defined, "unsafe" lifecycles won't be called.
        // Warn about these lifecycles if they are present.
        // Don't warn about react-lifecycles-compat polyfilled methods though.
        if (typeof ctor.getDerivedStateFromProps === "function" || typeof instance.getSnapshotBeforeUpdate === "function") {
            var foundWillMountName = null;
            var foundWillReceivePropsName = null;
            var foundWillUpdateName = null;
            if (typeof instance.componentWillMount === "function" && instance.componentWillMount.__suppressDeprecationWarning !== true) foundWillMountName = "componentWillMount";
            else if (typeof instance.UNSAFE_componentWillMount === "function") foundWillMountName = "UNSAFE_componentWillMount";
            if (typeof instance.componentWillReceiveProps === "function" && instance.componentWillReceiveProps.__suppressDeprecationWarning !== true) foundWillReceivePropsName = "componentWillReceiveProps";
            else if (typeof instance.UNSAFE_componentWillReceiveProps === "function") foundWillReceivePropsName = "UNSAFE_componentWillReceiveProps";
            if (typeof instance.componentWillUpdate === "function" && instance.componentWillUpdate.__suppressDeprecationWarning !== true) foundWillUpdateName = "componentWillUpdate";
            else if (typeof instance.UNSAFE_componentWillUpdate === "function") foundWillUpdateName = "UNSAFE_componentWillUpdate";
            if (foundWillMountName !== null || foundWillReceivePropsName !== null || foundWillUpdateName !== null) {
                var _componentName = getComponentNameFromType(ctor) || "Component";
                var newApiName = typeof ctor.getDerivedStateFromProps === "function" ? "getDerivedStateFromProps()" : "getSnapshotBeforeUpdate()";
                if (!didWarnAboutLegacyLifecyclesAndDerivedState.has(_componentName)) {
                    didWarnAboutLegacyLifecyclesAndDerivedState.add(_componentName);
                    error("Unsafe legacy lifecycles will not be called for components using new component APIs.\n\n%s uses %s but also contains the following legacy lifecycles:%s%s%s\n\nThe above lifecycles should be removed. Learn more about this warning here:\nhttps://reactjs.org/link/unsafe-component-lifecycles", _componentName, newApiName, foundWillMountName !== null ? "\n  " + foundWillMountName : "", foundWillReceivePropsName !== null ? "\n  " + foundWillReceivePropsName : "", foundWillUpdateName !== null ? "\n  " + foundWillUpdateName : "");
                }
            }
        }
        return instance;
    }
    function checkClassInstance(instance, ctor, newProps) {
        var name = getComponentNameFromType(ctor) || "Component";
        var renderPresent = instance.render;
        if (!renderPresent) {
            if (ctor.prototype && typeof ctor.prototype.render === "function") error("%s(...): No `render` method found on the returned component instance: did you accidentally return an object from the constructor?", name);
            else error("%s(...): No `render` method found on the returned component instance: you may have forgotten to define `render`.", name);
        }
        if (instance.getInitialState && !instance.getInitialState.isReactClassApproved && !instance.state) error("getInitialState was defined on %s, a plain JavaScript class. This is only supported for classes created using React.createClass. Did you mean to define a state property instead?", name);
        if (instance.getDefaultProps && !instance.getDefaultProps.isReactClassApproved) error("getDefaultProps was defined on %s, a plain JavaScript class. This is only supported for classes created using React.createClass. Use a static property to define defaultProps instead.", name);
        if (instance.propTypes) error("propTypes was defined as an instance property on %s. Use a static property to define propTypes instead.", name);
        if (instance.contextType) error("contextType was defined as an instance property on %s. Use a static property to define contextType instead.", name);
        if (instance.contextTypes) error("contextTypes was defined as an instance property on %s. Use a static property to define contextTypes instead.", name);
        if (ctor.contextType && ctor.contextTypes && !didWarnAboutContextTypeAndContextTypes.has(ctor)) {
            didWarnAboutContextTypeAndContextTypes.add(ctor);
            error("%s declares both contextTypes and contextType static properties. The legacy contextTypes property will be ignored.", name);
        }
        if (typeof instance.componentShouldUpdate === "function") error("%s has a method called componentShouldUpdate(). Did you mean shouldComponentUpdate()? The name is phrased as a question because the function is expected to return a value.", name);
        if (ctor.prototype && ctor.prototype.isPureReactComponent && typeof instance.shouldComponentUpdate !== "undefined") error("%s has a method called shouldComponentUpdate(). shouldComponentUpdate should not be used when extending React.PureComponent. Please extend React.Component if shouldComponentUpdate is used.", getComponentNameFromType(ctor) || "A pure component");
        if (typeof instance.componentDidUnmount === "function") error("%s has a method called componentDidUnmount(). But there is no such lifecycle method. Did you mean componentWillUnmount()?", name);
        if (typeof instance.componentDidReceiveProps === "function") error("%s has a method called componentDidReceiveProps(). But there is no such lifecycle method. If you meant to update the state in response to changing props, use componentWillReceiveProps(). If you meant to fetch data or run side-effects or mutations after React has updated the UI, use componentDidUpdate().", name);
        if (typeof instance.componentWillRecieveProps === "function") error("%s has a method called componentWillRecieveProps(). Did you mean componentWillReceiveProps()?", name);
        if (typeof instance.UNSAFE_componentWillRecieveProps === "function") error("%s has a method called UNSAFE_componentWillRecieveProps(). Did you mean UNSAFE_componentWillReceiveProps()?", name);
        var hasMutatedProps = instance.props !== newProps;
        if (instance.props !== undefined && hasMutatedProps) error("%s(...): When calling super() in `%s`, make sure to pass up the same props that your component's constructor was passed.", name, name);
        if (instance.defaultProps) error("Setting defaultProps as an instance property on %s is not supported and will be ignored. Instead, define defaultProps as a static property on %s.", name, name);
        if (typeof instance.getSnapshotBeforeUpdate === "function" && typeof instance.componentDidUpdate !== "function" && !didWarnAboutGetSnapshotBeforeUpdateWithoutDidUpdate.has(ctor)) {
            didWarnAboutGetSnapshotBeforeUpdateWithoutDidUpdate.add(ctor);
            error("%s: getSnapshotBeforeUpdate() should be used with componentDidUpdate(). This component defines getSnapshotBeforeUpdate() only.", getComponentNameFromType(ctor));
        }
        if (typeof instance.getDerivedStateFromProps === "function") error("%s: getDerivedStateFromProps() is defined as an instance method and will be ignored. Instead, declare it as a static method.", name);
        if (typeof instance.getDerivedStateFromError === "function") error("%s: getDerivedStateFromError() is defined as an instance method and will be ignored. Instead, declare it as a static method.", name);
        if (typeof ctor.getSnapshotBeforeUpdate === "function") error("%s: getSnapshotBeforeUpdate() is defined as a static method and will be ignored. Instead, declare it as an instance method.", name);
        var _state = instance.state;
        if (_state && (typeof _state !== "object" || isArray(_state))) error("%s.state: must be set to an object or null", name);
        if (typeof instance.getChildContext === "function" && typeof ctor.childContextTypes !== "object") error("%s.getChildContext(): childContextTypes must be defined in order to use getChildContext().", name);
    }
    function callComponentWillMount(type, instance) {
        var oldState = instance.state;
        if (typeof instance.componentWillMount === "function") {
            if (instance.componentWillMount.__suppressDeprecationWarning !== true) {
                var componentName = getComponentNameFromType(type) || "Unknown";
                if (!didWarnAboutDeprecatedWillMount[componentName]) {
                    warn("componentWillMount has been renamed, and is not recommended for use. See https://reactjs.org/link/unsafe-component-lifecycles for details.\n\n* Move code from componentWillMount to componentDidMount (preferred in most cases) or the constructor.\n\nPlease update the following components: %s", componentName);
                    didWarnAboutDeprecatedWillMount[componentName] = true;
                }
            }
            instance.componentWillMount();
        }
        if (typeof instance.UNSAFE_componentWillMount === "function") instance.UNSAFE_componentWillMount();
        if (oldState !== instance.state) {
            error("%s.componentWillMount(): Assigning directly to this.state is deprecated (except inside a component's constructor). Use setState instead.", getComponentNameFromType(type) || "Component");
            classComponentUpdater.enqueueReplaceState(instance, instance.state, null);
        }
    }
    function processUpdateQueue(internalInstance, inst, props, maskedLegacyContext) {
        if (internalInstance.queue !== null && internalInstance.queue.length > 0) {
            var oldQueue = internalInstance.queue;
            var oldReplace = internalInstance.replace;
            internalInstance.queue = null;
            internalInstance.replace = false;
            if (oldReplace && oldQueue.length === 1) inst.state = oldQueue[0];
            else {
                var nextState = oldReplace ? oldQueue[0] : inst.state;
                var dontMutate = true;
                for(var i = oldReplace ? 1 : 0; i < oldQueue.length; i++){
                    var partial = oldQueue[i];
                    var partialState = typeof partial === "function" ? partial.call(inst, nextState, props, maskedLegacyContext) : partial;
                    if (partialState != null) {
                        if (dontMutate) {
                            dontMutate = false;
                            nextState = assign({}, nextState, partialState);
                        } else assign(nextState, partialState);
                    }
                }
                inst.state = nextState;
            }
        } else internalInstance.queue = null;
    } // Invokes the mount life-cycles on a previously never rendered instance.
    function mountClassInstance(instance, ctor, newProps, maskedLegacyContext) {
        checkClassInstance(instance, ctor, newProps);
        var initialState = instance.state !== undefined ? instance.state : null;
        instance.updater = classComponentUpdater;
        instance.props = newProps;
        instance.state = initialState; // We don't bother initializing the refs object on the server, since we're not going to resolve them anyway.
        // The internal instance will be used to manage updates that happen during this mount.
        var internalInstance = {
            queue: [],
            replace: false
        };
        set(instance, internalInstance);
        var contextType = ctor.contextType;
        if (typeof contextType === "object" && contextType !== null) instance.context = readContext(contextType);
        else instance.context = maskedLegacyContext;
        if (instance.state === newProps) {
            var componentName = getComponentNameFromType(ctor) || "Component";
            if (!didWarnAboutDirectlyAssigningPropsToState.has(componentName)) {
                didWarnAboutDirectlyAssigningPropsToState.add(componentName);
                error("%s: It is not recommended to assign props directly to state because updates to props won't be reflected in state. In most cases, it is better to use props directly.", componentName);
            }
        }
        var getDerivedStateFromProps = ctor.getDerivedStateFromProps;
        if (typeof getDerivedStateFromProps === "function") instance.state = applyDerivedStateFromProps(instance, ctor, getDerivedStateFromProps, initialState, newProps);
         // In order to support react-lifecycles-compat polyfilled components,
        // Unsafe lifecycles should not be invoked for components using the new APIs.
        if (typeof ctor.getDerivedStateFromProps !== "function" && typeof instance.getSnapshotBeforeUpdate !== "function" && (typeof instance.UNSAFE_componentWillMount === "function" || typeof instance.componentWillMount === "function")) {
            callComponentWillMount(ctor, instance); // If we had additional state updates during this life-cycle, let's
            // process them now.
            processUpdateQueue(internalInstance, instance, newProps, maskedLegacyContext);
        }
    }
    // Ids are base 32 strings whose binary representation corresponds to the
    // position of a node in a tree.
    // Every time the tree forks into multiple children, we add additional bits to
    // the left of the sequence that represent the position of the child within the
    // current level of children.
    //
    //      00101       00010001011010101
    //      ╰─┬─╯       ╰───────┬───────╯
    //   Fork 5 of 20       Parent id
    //
    // The leading 0s are important. In the above example, you only need 3 bits to
    // represent slot 5. However, you need 5 bits to represent all the forks at
    // the current level, so we must account for the empty bits at the end.
    //
    // For this same reason, slots are 1-indexed instead of 0-indexed. Otherwise,
    // the zeroth id at a level would be indistinguishable from its parent.
    //
    // If a node has only one child, and does not materialize an id (i.e. does not
    // contain a useId hook), then we don't need to allocate any space in the
    // sequence. It's treated as a transparent indirection. For example, these two
    // trees produce the same ids:
    //
    // <>                          <>
    //   <Indirection>               <A />
    //     <A />                     <B />
    //   </Indirection>            </>
    //   <B />
    // </>
    //
    // However, we cannot skip any node that materializes an id. Otherwise, a parent
    // id that does not fork would be indistinguishable from its child id. For
    // example, this tree does not fork, but the parent and child must have
    // different ids.
    //
    // <Parent>
    //   <Child />
    // </Parent>
    //
    // To handle this scenario, every time we materialize an id, we allocate a
    // new level with a single slot. You can think of this as a fork with only one
    // prong, or an array of children with length 1.
    //
    // It's possible for the size of the sequence to exceed 32 bits, the max
    // size for bitwise operations. When this happens, we make more room by
    // converting the right part of the id to a string and storing it in an overflow
    // variable. We use a base 32 string representation, because 32 is the largest
    // power of 2 that is supported by toString(). We want the base to be large so
    // that the resulting ids are compact, and we want the base to be a power of 2
    // because every log2(base) bits corresponds to a single character, i.e. every
    // log2(32) = 5 bits. That means we can lop bits off the end 5 at a time without
    // affecting the final result.
    var emptyTreeContext = {
        id: 1,
        overflow: ""
    };
    function getTreeId(context) {
        var overflow = context.overflow;
        var idWithLeadingBit = context.id;
        var id = idWithLeadingBit & ~getLeadingBit(idWithLeadingBit);
        return id.toString(32) + overflow;
    }
    function pushTreeContext(baseContext, totalChildren, index) {
        var baseIdWithLeadingBit = baseContext.id;
        var baseOverflow = baseContext.overflow; // The leftmost 1 marks the end of the sequence, non-inclusive. It's not part
        // of the id; we use it to account for leading 0s.
        var baseLength = getBitLength(baseIdWithLeadingBit) - 1;
        var baseId = baseIdWithLeadingBit & ~(1 << baseLength);
        var slot = index + 1;
        var length = getBitLength(totalChildren) + baseLength; // 30 is the max length we can store without overflowing, taking into
        // consideration the leading 1 we use to mark the end of the sequence.
        if (length > 30) {
            // We overflowed the bitwise-safe range. Fall back to slower algorithm.
            // This branch assumes the length of the base id is greater than 5; it won't
            // work for smaller ids, because you need 5 bits per character.
            //
            // We encode the id in multiple steps: first the base id, then the
            // remaining digits.
            //
            // Each 5 bit sequence corresponds to a single base 32 character. So for
            // example, if the current id is 23 bits long, we can convert 20 of those
            // bits into a string of 4 characters, with 3 bits left over.
            //
            // First calculate how many bits in the base id represent a complete
            // sequence of characters.
            var numberOfOverflowBits = baseLength - baseLength % 5; // Then create a bitmask that selects only those bits.
            var newOverflowBits = (1 << numberOfOverflowBits) - 1; // Select the bits, and convert them to a base 32 string.
            var newOverflow = (baseId & newOverflowBits).toString(32); // Now we can remove those bits from the base id.
            var restOfBaseId = baseId >> numberOfOverflowBits;
            var restOfBaseLength = baseLength - numberOfOverflowBits; // Finally, encode the rest of the bits using the normal algorithm. Because
            // we made more room, this time it won't overflow.
            var restOfLength = getBitLength(totalChildren) + restOfBaseLength;
            var restOfNewBits = slot << restOfBaseLength;
            var id = restOfNewBits | restOfBaseId;
            var overflow = newOverflow + baseOverflow;
            return {
                id: 1 << restOfLength | id,
                overflow: overflow
            };
        } else {
            // Normal path
            var newBits = slot << baseLength;
            var _id = newBits | baseId;
            var _overflow = baseOverflow;
            return {
                id: 1 << length | _id,
                overflow: _overflow
            };
        }
    }
    function getBitLength(number) {
        return 32 - clz32(number);
    }
    function getLeadingBit(id) {
        return 1 << getBitLength(id) - 1;
    } // TODO: Math.clz32 is supported in Node 12+. Maybe we can drop the fallback.
    var clz32 = Math.clz32 ? Math.clz32 : clz32Fallback; // Count leading zeros.
    // Based on:
    // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Math/clz32
    var log = Math.log;
    var LN2 = Math.LN2;
    function clz32Fallback(x) {
        var asUint = x >>> 0;
        if (asUint === 0) return 32;
        return 31 - (log(asUint) / LN2 | 0) | 0;
    }
    /**
 * inlined Object.is polyfill to avoid requiring consumers ship their own
 * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
 */ function is(x, y) {
        return x === y && (x !== 0 || 1 / x === 1 / y) || x !== x && y !== y // eslint-disable-line no-self-compare
        ;
    }
    var objectIs = typeof Object.is === "function" ? Object.is : is;
    var currentlyRenderingComponent = null;
    var currentlyRenderingTask = null;
    var firstWorkInProgressHook = null;
    var workInProgressHook = null; // Whether the work-in-progress hook is a re-rendered hook
    var isReRender = false; // Whether an update was scheduled during the currently executing render pass.
    var didScheduleRenderPhaseUpdate = false; // Counts the number of useId hooks in this component
    var localIdCounter = 0; // Lazily created map of render-phase updates
    var renderPhaseUpdates = null; // Counter to prevent infinite loops.
    var numberOfReRenders = 0;
    var RE_RENDER_LIMIT = 25;
    var isInHookUserCodeInDev = false; // In DEV, this is the name of the currently executing primitive hook
    var currentHookNameInDev;
    function resolveCurrentlyRenderingComponent() {
        if (currentlyRenderingComponent === null) throw new Error("Invalid hook call. Hooks can only be called inside of the body of a function component. This could happen for one of the following reasons:\n1. You might have mismatching versions of React and the renderer (such as React DOM)\n2. You might be breaking the Rules of Hooks\n3. You might have more than one copy of React in the same app\nSee https://reactjs.org/link/invalid-hook-call for tips about how to debug and fix this problem.");
        if (isInHookUserCodeInDev) error("Do not call Hooks inside useEffect(...), useMemo(...), or other built-in Hooks. You can only call Hooks at the top level of your React function. For more information, see https://reactjs.org/link/rules-of-hooks");
        return currentlyRenderingComponent;
    }
    function areHookInputsEqual(nextDeps, prevDeps) {
        if (prevDeps === null) {
            error("%s received a final argument during this render, but not during the previous render. Even though the final argument is optional, its type cannot change between renders.", currentHookNameInDev);
            return false;
        }
        // Don't bother comparing lengths in prod because these arrays should be
        // passed inline.
        if (nextDeps.length !== prevDeps.length) error("The final argument passed to %s changed size between renders. The order and size of this array must remain constant.\n\nPrevious: %s\nIncoming: %s", currentHookNameInDev, "[" + nextDeps.join(", ") + "]", "[" + prevDeps.join(", ") + "]");
        for(var i = 0; i < prevDeps.length && i < nextDeps.length; i++){
            if (objectIs(nextDeps[i], prevDeps[i])) continue;
            return false;
        }
        return true;
    }
    function createHook() {
        if (numberOfReRenders > 0) throw new Error("Rendered more hooks than during the previous render");
        return {
            memoizedState: null,
            queue: null,
            next: null
        };
    }
    function createWorkInProgressHook() {
        if (workInProgressHook === null) {
            // This is the first hook in the list
            if (firstWorkInProgressHook === null) {
                isReRender = false;
                firstWorkInProgressHook = workInProgressHook = createHook();
            } else {
                // There's already a work-in-progress. Reuse it.
                isReRender = true;
                workInProgressHook = firstWorkInProgressHook;
            }
        } else if (workInProgressHook.next === null) {
            isReRender = false; // Append to the end of the list
            workInProgressHook = workInProgressHook.next = createHook();
        } else {
            // There's already a work-in-progress. Reuse it.
            isReRender = true;
            workInProgressHook = workInProgressHook.next;
        }
        return workInProgressHook;
    }
    function prepareToUseHooks(task, componentIdentity) {
        currentlyRenderingComponent = componentIdentity;
        currentlyRenderingTask = task;
        isInHookUserCodeInDev = false;
        // didScheduleRenderPhaseUpdate = false;
        // localIdCounter = 0;
        // firstWorkInProgressHook = null;
        // numberOfReRenders = 0;
        // renderPhaseUpdates = null;
        // workInProgressHook = null;
        localIdCounter = 0;
    }
    function finishHooks(Component, props, children, refOrContext) {
        // This must be called after every function component to prevent hooks from
        // being used in classes.
        while(didScheduleRenderPhaseUpdate){
            // Updates were scheduled during the render phase. They are stored in
            // the `renderPhaseUpdates` map. Call the component again, reusing the
            // work-in-progress hooks and applying the additional updates on top. Keep
            // restarting until no more updates are scheduled.
            didScheduleRenderPhaseUpdate = false;
            localIdCounter = 0;
            numberOfReRenders += 1; // Start over from the beginning of the list
            workInProgressHook = null;
            children = Component(props, refOrContext);
        }
        resetHooksState();
        return children;
    }
    function checkDidRenderIdHook() {
        // This should be called immediately after every finishHooks call.
        // Conceptually, it's part of the return value of finishHooks; it's only a
        // separate function to avoid using an array tuple.
        var didRenderIdHook = localIdCounter !== 0;
        return didRenderIdHook;
    } // Reset the internal hooks state if an error occurs while rendering a component
    function resetHooksState() {
        isInHookUserCodeInDev = false;
        currentlyRenderingComponent = null;
        currentlyRenderingTask = null;
        didScheduleRenderPhaseUpdate = false;
        firstWorkInProgressHook = null;
        numberOfReRenders = 0;
        renderPhaseUpdates = null;
        workInProgressHook = null;
    }
    function readContext$1(context) {
        if (isInHookUserCodeInDev) error("Context can only be read while React is rendering. In classes, you can read it in the render method or getDerivedStateFromProps. In function components, you can read it directly in the function body, but not inside Hooks like useReducer() or useMemo().");
        return readContext(context);
    }
    function useContext(context) {
        currentHookNameInDev = "useContext";
        resolveCurrentlyRenderingComponent();
        return readContext(context);
    }
    function basicStateReducer(state, action) {
        // $FlowFixMe: Flow doesn't like mixed types
        return typeof action === "function" ? action(state) : action;
    }
    function useState(initialState) {
        currentHookNameInDev = "useState";
        return useReducer(basicStateReducer, initialState);
    }
    function useReducer(reducer, initialArg, init) {
        if (reducer !== basicStateReducer) currentHookNameInDev = "useReducer";
        currentlyRenderingComponent = resolveCurrentlyRenderingComponent();
        workInProgressHook = createWorkInProgressHook();
        if (isReRender) {
            // This is a re-render. Apply the new render phase updates to the previous
            // current hook.
            var queue = workInProgressHook.queue;
            var dispatch = queue.dispatch;
            if (renderPhaseUpdates !== null) {
                // Render phase updates are stored in a map of queue -> linked list
                var firstRenderPhaseUpdate = renderPhaseUpdates.get(queue);
                if (firstRenderPhaseUpdate !== undefined) {
                    renderPhaseUpdates.delete(queue);
                    var newState = workInProgressHook.memoizedState;
                    var update = firstRenderPhaseUpdate;
                    do {
                        // Process this render phase update. We don't have to check the
                        // priority because it will always be the same as the current
                        // render's.
                        var action = update.action;
                        isInHookUserCodeInDev = true;
                        newState = reducer(newState, action);
                        isInHookUserCodeInDev = false;
                        update = update.next;
                    }while (update !== null);
                    workInProgressHook.memoizedState = newState;
                    return [
                        newState,
                        dispatch
                    ];
                }
            }
            return [
                workInProgressHook.memoizedState,
                dispatch
            ];
        } else {
            isInHookUserCodeInDev = true;
            var initialState;
            if (reducer === basicStateReducer) // Special case for `useState`.
            initialState = typeof initialArg === "function" ? initialArg() : initialArg;
            else initialState = init !== undefined ? init(initialArg) : initialArg;
            isInHookUserCodeInDev = false;
            workInProgressHook.memoizedState = initialState;
            var _queue = workInProgressHook.queue = {
                last: null,
                dispatch: null
            };
            var _dispatch = _queue.dispatch = dispatchAction.bind(null, currentlyRenderingComponent, _queue);
            return [
                workInProgressHook.memoizedState,
                _dispatch
            ];
        }
    }
    function useMemo(nextCreate, deps) {
        currentlyRenderingComponent = resolveCurrentlyRenderingComponent();
        workInProgressHook = createWorkInProgressHook();
        var nextDeps = deps === undefined ? null : deps;
        if (workInProgressHook !== null) {
            var prevState = workInProgressHook.memoizedState;
            if (prevState !== null) {
                if (nextDeps !== null) {
                    var prevDeps = prevState[1];
                    if (areHookInputsEqual(nextDeps, prevDeps)) return prevState[0];
                }
            }
        }
        isInHookUserCodeInDev = true;
        var nextValue = nextCreate();
        isInHookUserCodeInDev = false;
        workInProgressHook.memoizedState = [
            nextValue,
            nextDeps
        ];
        return nextValue;
    }
    function useRef(initialValue) {
        currentlyRenderingComponent = resolveCurrentlyRenderingComponent();
        workInProgressHook = createWorkInProgressHook();
        var previousRef = workInProgressHook.memoizedState;
        if (previousRef === null) {
            var ref = {
                current: initialValue
            };
            Object.seal(ref);
            workInProgressHook.memoizedState = ref;
            return ref;
        } else return previousRef;
    }
    function useLayoutEffect(create, inputs) {
        currentHookNameInDev = "useLayoutEffect";
        error("useLayoutEffect does nothing on the server, because its effect cannot be encoded into the server renderer's output format. This will lead to a mismatch between the initial, non-hydrated UI and the intended UI. To avoid this, useLayoutEffect should only be used in components that render exclusively on the client. See https://reactjs.org/link/uselayouteffect-ssr for common fixes.");
    }
    function dispatchAction(componentIdentity, queue, action) {
        if (numberOfReRenders >= RE_RENDER_LIMIT) throw new Error("Too many re-renders. React limits the number of renders to prevent an infinite loop.");
        if (componentIdentity === currentlyRenderingComponent) {
            // This is a render phase update. Stash it in a lazily-created map of
            // queue -> linked list of updates. After this render pass, we'll restart
            // and apply the stashed updates on top of the work-in-progress hook.
            didScheduleRenderPhaseUpdate = true;
            var update = {
                action: action,
                next: null
            };
            if (renderPhaseUpdates === null) renderPhaseUpdates = new Map();
            var firstRenderPhaseUpdate = renderPhaseUpdates.get(queue);
            if (firstRenderPhaseUpdate === undefined) renderPhaseUpdates.set(queue, update);
            else {
                // Append the update to the end of the list.
                var lastRenderPhaseUpdate = firstRenderPhaseUpdate;
                while(lastRenderPhaseUpdate.next !== null)lastRenderPhaseUpdate = lastRenderPhaseUpdate.next;
                lastRenderPhaseUpdate.next = update;
            }
        }
    }
    function useCallback(callback, deps) {
        return useMemo(function() {
            return callback;
        }, deps);
    } // TODO Decide on how to implement this hook for server rendering.
    // If a mutation occurs during render, consider triggering a Suspense boundary
    // and falling back to client rendering.
    function useMutableSource(source, getSnapshot, subscribe) {
        resolveCurrentlyRenderingComponent();
        return getSnapshot(source._source);
    }
    function useSyncExternalStore(subscribe, getSnapshot, getServerSnapshot) {
        if (getServerSnapshot === undefined) throw new Error("Missing getServerSnapshot, which is required for server-rendered content. Will revert to client rendering.");
        return getServerSnapshot();
    }
    function useDeferredValue(value) {
        resolveCurrentlyRenderingComponent();
        return value;
    }
    function unsupportedStartTransition() {
        throw new Error("startTransition cannot be called during server rendering.");
    }
    function useTransition() {
        resolveCurrentlyRenderingComponent();
        return [
            false,
            unsupportedStartTransition
        ];
    }
    function useId() {
        var task = currentlyRenderingTask;
        var treeId = getTreeId(task.treeContext);
        var responseState = currentResponseState;
        if (responseState === null) throw new Error("Invalid hook call. Hooks can only be called inside of the body of a function component.");
        var localId = localIdCounter++;
        return makeId(responseState, treeId, localId);
    }
    function noop() {}
    var Dispatcher = {
        readContext: readContext$1,
        useContext: useContext,
        useMemo: useMemo,
        useReducer: useReducer,
        useRef: useRef,
        useState: useState,
        useInsertionEffect: noop,
        useLayoutEffect: useLayoutEffect,
        useCallback: useCallback,
        // useImperativeHandle is not run in the server environment
        useImperativeHandle: noop,
        // Effects are not run in the server environment.
        useEffect: noop,
        // Debugging effect
        useDebugValue: noop,
        useDeferredValue: useDeferredValue,
        useTransition: useTransition,
        useId: useId,
        // Subscriptions are not setup in a server environment.
        useMutableSource: useMutableSource,
        useSyncExternalStore: useSyncExternalStore
    };
    var currentResponseState = null;
    function setCurrentResponseState(responseState) {
        currentResponseState = responseState;
    }
    function getStackByComponentStackNode(componentStack) {
        try {
            var info = "";
            var node = componentStack;
            do {
                switch(node.tag){
                    case 0:
                        info += describeBuiltInComponentFrame(node.type, null, null);
                        break;
                    case 1:
                        info += describeFunctionComponentFrame(node.type, null, null);
                        break;
                    case 2:
                        info += describeClassComponentFrame(node.type, null, null);
                        break;
                }
                node = node.parent;
            }while (node);
            return info;
        } catch (x) {
            return "\nError generating stack: " + x.message + "\n" + x.stack;
        }
    }
    var ReactCurrentDispatcher$1 = ReactSharedInternals.ReactCurrentDispatcher;
    var ReactDebugCurrentFrame$1 = ReactSharedInternals.ReactDebugCurrentFrame;
    var PENDING = 0;
    var COMPLETED = 1;
    var FLUSHED = 2;
    var ABORTED = 3;
    var ERRORED = 4;
    var OPEN = 0;
    var CLOSING = 1;
    var CLOSED = 2;
    // This is a default heuristic for how to split up the HTML content into progressive
    // loading. Our goal is to be able to display additional new content about every 500ms.
    // Faster than that is unnecessary and should be throttled on the client. It also
    // adds unnecessary overhead to do more splits. We don't know if it's a higher or lower
    // end device but higher end suffer less from the overhead than lower end does from
    // not getting small enough pieces. We error on the side of low end.
    // We base this on low end 3G speeds which is about 500kbits per second. We assume
    // that there can be a reasonable drop off from max bandwidth which leaves you with
    // as little as 80%. We can receive half of that each 500ms - at best. In practice,
    // a little bandwidth is lost to processing and contention - e.g. CSS and images that
    // are downloaded along with the main content. So we estimate about half of that to be
    // the lower end throughput. In other words, we expect that you can at least show
    // about 12.5kb of content per 500ms. Not counting starting latency for the first
    // paint.
    // 500 * 1024 / 8 * .8 * 0.5 / 2
    var DEFAULT_PROGRESSIVE_CHUNK_SIZE = 12800;
    function defaultErrorHandler(error) {
        console["error"](error); // Don't transform to our wrapper
        return null;
    }
    function noop$1() {}
    function createRequest(children, responseState, rootFormatContext, progressiveChunkSize, onError, onAllReady, onShellReady, onShellError, onFatalError) {
        var pingedTasks = [];
        var abortSet = new Set();
        var request = {
            destination: null,
            responseState: responseState,
            progressiveChunkSize: progressiveChunkSize === undefined ? DEFAULT_PROGRESSIVE_CHUNK_SIZE : progressiveChunkSize,
            status: OPEN,
            fatalError: null,
            nextSegmentId: 0,
            allPendingTasks: 0,
            pendingRootTasks: 0,
            completedRootSegment: null,
            abortableTasks: abortSet,
            pingedTasks: pingedTasks,
            clientRenderedBoundaries: [],
            completedBoundaries: [],
            partialBoundaries: [],
            onError: onError === undefined ? defaultErrorHandler : onError,
            onAllReady: onAllReady === undefined ? noop$1 : onAllReady,
            onShellReady: onShellReady === undefined ? noop$1 : onShellReady,
            onShellError: onShellError === undefined ? noop$1 : onShellError,
            onFatalError: onFatalError === undefined ? noop$1 : onFatalError
        }; // This segment represents the root fallback.
        var rootSegment = createPendingSegment(request, 0, null, rootFormatContext, false, false); // There is no parent so conceptually, we're unblocked to flush this segment.
        rootSegment.parentFlushed = true;
        var rootTask = createTask(request, children, null, rootSegment, abortSet, emptyContextObject, rootContextSnapshot, emptyTreeContext);
        pingedTasks.push(rootTask);
        return request;
    }
    function pingTask(request, task) {
        var pingedTasks = request.pingedTasks;
        pingedTasks.push(task);
        if (pingedTasks.length === 1) scheduleWork(function() {
            return performWork(request);
        });
    }
    function createSuspenseBoundary(request, fallbackAbortableTasks) {
        return {
            id: UNINITIALIZED_SUSPENSE_BOUNDARY_ID,
            rootSegmentID: -1,
            parentFlushed: false,
            pendingTasks: 0,
            forceClientRender: false,
            completedSegments: [],
            byteSize: 0,
            fallbackAbortableTasks: fallbackAbortableTasks,
            errorDigest: null
        };
    }
    function createTask(request, node, blockedBoundary, blockedSegment, abortSet, legacyContext, context, treeContext) {
        request.allPendingTasks++;
        if (blockedBoundary === null) request.pendingRootTasks++;
        else blockedBoundary.pendingTasks++;
        var task = {
            node: node,
            ping: function() {
                return pingTask(request, task);
            },
            blockedBoundary: blockedBoundary,
            blockedSegment: blockedSegment,
            abortSet: abortSet,
            legacyContext: legacyContext,
            context: context,
            treeContext: treeContext
        };
        task.componentStack = null;
        abortSet.add(task);
        return task;
    }
    function createPendingSegment(request, index, boundary, formatContext, lastPushedText, textEmbedded) {
        return {
            status: PENDING,
            id: -1,
            // lazily assigned later
            index: index,
            parentFlushed: false,
            chunks: [],
            children: [],
            formatContext: formatContext,
            boundary: boundary,
            lastPushedText: lastPushedText,
            textEmbedded: textEmbedded
        };
    } // DEV-only global reference to the currently executing task
    var currentTaskInDEV = null;
    function getCurrentStackInDEV() {
        if (currentTaskInDEV === null || currentTaskInDEV.componentStack === null) return "";
        return getStackByComponentStackNode(currentTaskInDEV.componentStack);
    }
    function pushBuiltInComponentStackInDEV(task, type) {
        task.componentStack = {
            tag: 0,
            parent: task.componentStack,
            type: type
        };
    }
    function pushFunctionComponentStackInDEV(task, type) {
        task.componentStack = {
            tag: 1,
            parent: task.componentStack,
            type: type
        };
    }
    function pushClassComponentStackInDEV(task, type) {
        task.componentStack = {
            tag: 2,
            parent: task.componentStack,
            type: type
        };
    }
    function popComponentStackInDEV(task) {
        if (task.componentStack === null) error("Unexpectedly popped too many stack frames. This is a bug in React.");
        else task.componentStack = task.componentStack.parent;
    } // stash the component stack of an unwinding error until it is processed
    var lastBoundaryErrorComponentStackDev = null;
    function captureBoundaryErrorDetailsDev(boundary, error) {
        var errorMessage;
        if (typeof error === "string") errorMessage = error;
        else if (error && typeof error.message === "string") errorMessage = error.message;
        else // eslint-disable-next-line react-internal/safe-string-coercion
        errorMessage = String(error);
        var errorComponentStack = lastBoundaryErrorComponentStackDev || getCurrentStackInDEV();
        lastBoundaryErrorComponentStackDev = null;
        boundary.errorMessage = errorMessage;
        boundary.errorComponentStack = errorComponentStack;
    }
    function logRecoverableError(request, error) {
        // If this callback errors, we intentionally let that error bubble up to become a fatal error
        // so that someone fixes the error reporting instead of hiding it.
        var errorDigest = request.onError(error);
        if (errorDigest != null && typeof errorDigest !== "string") // eslint-disable-next-line react-internal/prod-error-codes
        throw new Error('onError returned something with a type other than "string". onError should return a string and may return null or undefined but must not return anything else. It received something of type "' + typeof errorDigest + '" instead');
        return errorDigest;
    }
    function fatalError(request, error) {
        // This is called outside error handling code such as if the root errors outside
        // a suspense boundary or if the root suspense boundary's fallback errors.
        // It's also called if React itself or its host configs errors.
        var onShellError = request.onShellError;
        onShellError(error);
        var onFatalError = request.onFatalError;
        onFatalError(error);
        if (request.destination !== null) {
            request.status = CLOSED;
            closeWithError(request.destination, error);
        } else {
            request.status = CLOSING;
            request.fatalError = error;
        }
    }
    function renderSuspenseBoundary(request, task, props) {
        pushBuiltInComponentStackInDEV(task, "Suspense");
        var parentBoundary = task.blockedBoundary;
        var parentSegment = task.blockedSegment; // Each time we enter a suspense boundary, we split out into a new segment for
        // the fallback so that we can later replace that segment with the content.
        // This also lets us split out the main content even if it doesn't suspend,
        // in case it ends up generating a large subtree of content.
        var fallback = props.fallback;
        var content = props.children;
        var fallbackAbortSet = new Set();
        var newBoundary = createSuspenseBoundary(request, fallbackAbortSet);
        var insertionIndex = parentSegment.chunks.length; // The children of the boundary segment is actually the fallback.
        var boundarySegment = createPendingSegment(request, insertionIndex, newBoundary, parentSegment.formatContext, false, false);
        parentSegment.children.push(boundarySegment); // The parentSegment has a child Segment at this index so we reset the lastPushedText marker on the parent
        parentSegment.lastPushedText = false; // This segment is the actual child content. We can start rendering that immediately.
        var contentRootSegment = createPendingSegment(request, 0, null, parentSegment.formatContext, false, false); // We mark the root segment as having its parent flushed. It's not really flushed but there is
        // no parent segment so there's nothing to wait on.
        contentRootSegment.parentFlushed = true; // Currently this is running synchronously. We could instead schedule this to pingedTasks.
        // I suspect that there might be some efficiency benefits from not creating the suspended task
        // and instead just using the stack if possible.
        // TODO: Call this directly instead of messing with saving and restoring contexts.
        // We can reuse the current context and task to render the content immediately without
        // context switching. We just need to temporarily switch which boundary and which segment
        // we're writing to. If something suspends, it'll spawn new suspended task with that context.
        task.blockedBoundary = newBoundary;
        task.blockedSegment = contentRootSegment;
        try {
            // We use the safe form because we don't handle suspending here. Only error handling.
            renderNode(request, task, content);
            pushSegmentFinale$1(contentRootSegment.chunks, request.responseState, contentRootSegment.lastPushedText, contentRootSegment.textEmbedded);
            contentRootSegment.status = COMPLETED;
            queueCompletedSegment(newBoundary, contentRootSegment);
            if (newBoundary.pendingTasks === 0) {
                // This must have been the last segment we were waiting on. This boundary is now complete.
                // Therefore we won't need the fallback. We early return so that we don't have to create
                // the fallback.
                popComponentStackInDEV(task);
                return;
            }
        } catch (error) {
            contentRootSegment.status = ERRORED;
            newBoundary.forceClientRender = true;
            newBoundary.errorDigest = logRecoverableError(request, error);
            captureBoundaryErrorDetailsDev(newBoundary, error);
        // We don't need to schedule any task because we know the parent has written yet.
        // We do need to fallthrough to create the fallback though.
        } finally{
            task.blockedBoundary = parentBoundary;
            task.blockedSegment = parentSegment;
        } // We create suspended task for the fallback because we don't want to actually work
        // on it yet in case we finish the main content, so we queue for later.
        var suspendedFallbackTask = createTask(request, fallback, parentBoundary, boundarySegment, fallbackAbortSet, task.legacyContext, task.context, task.treeContext);
        suspendedFallbackTask.componentStack = task.componentStack;
        // on preparing fallbacks if we don't have any more main content to task on.
        request.pingedTasks.push(suspendedFallbackTask);
        popComponentStackInDEV(task);
    }
    function renderHostElement(request, task, type, props) {
        pushBuiltInComponentStackInDEV(task, type);
        var segment = task.blockedSegment;
        var children = pushStartInstance(segment.chunks, type, props, request.responseState, segment.formatContext);
        segment.lastPushedText = false;
        var prevContext = segment.formatContext;
        segment.formatContext = getChildFormatContext(prevContext, type, props); // We use the non-destructive form because if something suspends, we still
        // need to pop back up and finish this subtree of HTML.
        renderNode(request, task, children); // We expect that errors will fatal the whole task and that we don't need
        // the correct context. Therefore this is not in a finally.
        segment.formatContext = prevContext;
        pushEndInstance(segment.chunks, type);
        segment.lastPushedText = false;
        popComponentStackInDEV(task);
    }
    function shouldConstruct$1(Component) {
        return Component.prototype && Component.prototype.isReactComponent;
    }
    function renderWithHooks(request, task, Component, props, secondArg) {
        var componentIdentity = {};
        prepareToUseHooks(task, componentIdentity);
        var result = Component(props, secondArg);
        return finishHooks(Component, props, result, secondArg);
    }
    function finishClassComponent(request, task, instance, Component, props) {
        var nextChildren = instance.render();
        if (instance.props !== props) {
            if (!didWarnAboutReassigningProps) error("It looks like %s is reassigning its own `this.props` while rendering. This is not supported and can lead to confusing bugs.", getComponentNameFromType(Component) || "a component");
            didWarnAboutReassigningProps = true;
        }
        var childContextTypes = Component.childContextTypes;
        if (childContextTypes !== null && childContextTypes !== undefined) {
            var previousContext = task.legacyContext;
            var mergedContext = processChildContext(instance, Component, previousContext, childContextTypes);
            task.legacyContext = mergedContext;
            renderNodeDestructive(request, task, nextChildren);
            task.legacyContext = previousContext;
            return;
        }
        renderNodeDestructive(request, task, nextChildren);
    }
    function renderClassComponent(request, task, Component, props) {
        pushClassComponentStackInDEV(task, Component);
        var maskedContext = getMaskedContext(Component, task.legacyContext);
        var instance = constructClassInstance(Component, props, maskedContext);
        mountClassInstance(instance, Component, props, maskedContext);
        finishClassComponent(request, task, instance, Component, props);
        popComponentStackInDEV(task);
    }
    var didWarnAboutBadClass = {};
    var didWarnAboutModulePatternComponent = {};
    var didWarnAboutContextTypeOnFunctionComponent = {};
    var didWarnAboutGetDerivedStateOnFunctionComponent = {};
    var didWarnAboutReassigningProps = false;
    var didWarnAboutGenerators = false;
    var didWarnAboutMaps = false;
    var hasWarnedAboutUsingContextAsConsumer = false; // This would typically be a function component but we still support module pattern
    // components for some reason.
    function renderIndeterminateComponent(request, task, Component, props) {
        var legacyContext;
        legacyContext = getMaskedContext(Component, task.legacyContext);
        pushFunctionComponentStackInDEV(task, Component);
        if (Component.prototype && typeof Component.prototype.render === "function") {
            var componentName = getComponentNameFromType(Component) || "Unknown";
            if (!didWarnAboutBadClass[componentName]) {
                error("The <%s /> component appears to have a render method, but doesn't extend React.Component. This is likely to cause errors. Change %s to extend React.Component instead.", componentName, componentName);
                didWarnAboutBadClass[componentName] = true;
            }
        }
        var value = renderWithHooks(request, task, Component, props, legacyContext);
        var hasId = checkDidRenderIdHook();
        // Support for module components is deprecated and is removed behind a flag.
        // Whether or not it would crash later, we want to show a good message in DEV first.
        if (typeof value === "object" && value !== null && typeof value.render === "function" && value.$$typeof === undefined) {
            var _componentName = getComponentNameFromType(Component) || "Unknown";
            if (!didWarnAboutModulePatternComponent[_componentName]) {
                error("The <%s /> component appears to be a function component that returns a class instance. Change %s to a class that extends React.Component instead. If you can't use a class try assigning the prototype on the function as a workaround. `%s.prototype = React.Component.prototype`. Don't use an arrow function since it cannot be called with `new` by React.", _componentName, _componentName, _componentName);
                didWarnAboutModulePatternComponent[_componentName] = true;
            }
        }
        if (// Eventually we'll delete this branch altogether.
        typeof value === "object" && value !== null && typeof value.render === "function" && value.$$typeof === undefined) {
            var _componentName2 = getComponentNameFromType(Component) || "Unknown";
            if (!didWarnAboutModulePatternComponent[_componentName2]) {
                error("The <%s /> component appears to be a function component that returns a class instance. Change %s to a class that extends React.Component instead. If you can't use a class try assigning the prototype on the function as a workaround. `%s.prototype = React.Component.prototype`. Don't use an arrow function since it cannot be called with `new` by React.", _componentName2, _componentName2, _componentName2);
                didWarnAboutModulePatternComponent[_componentName2] = true;
            }
            mountClassInstance(value, Component, props, legacyContext);
            finishClassComponent(request, task, value, Component, props);
        } else {
            validateFunctionComponentInDev(Component);
            // the previous task every again, so we can use the destructive recursive form.
            if (hasId) {
                // This component materialized an id. We treat this as its own level, with
                // a single "child" slot.
                var prevTreeContext = task.treeContext;
                var totalChildren = 1;
                var index = 0;
                task.treeContext = pushTreeContext(prevTreeContext, totalChildren, index);
                try {
                    renderNodeDestructive(request, task, value);
                } finally{
                    task.treeContext = prevTreeContext;
                }
            } else renderNodeDestructive(request, task, value);
        }
        popComponentStackInDEV(task);
    }
    function validateFunctionComponentInDev(Component) {
        if (Component) {
            if (Component.childContextTypes) error("%s(...): childContextTypes cannot be defined on a function component.", Component.displayName || Component.name || "Component");
        }
        if (typeof Component.getDerivedStateFromProps === "function") {
            var _componentName3 = getComponentNameFromType(Component) || "Unknown";
            if (!didWarnAboutGetDerivedStateOnFunctionComponent[_componentName3]) {
                error("%s: Function components do not support getDerivedStateFromProps.", _componentName3);
                didWarnAboutGetDerivedStateOnFunctionComponent[_componentName3] = true;
            }
        }
        if (typeof Component.contextType === "object" && Component.contextType !== null) {
            var _componentName4 = getComponentNameFromType(Component) || "Unknown";
            if (!didWarnAboutContextTypeOnFunctionComponent[_componentName4]) {
                error("%s: Function components do not support contextType.", _componentName4);
                didWarnAboutContextTypeOnFunctionComponent[_componentName4] = true;
            }
        }
    }
    function resolveDefaultProps(Component, baseProps) {
        if (Component && Component.defaultProps) {
            // Resolve default props. Taken from ReactElement
            var props = assign({}, baseProps);
            var defaultProps = Component.defaultProps;
            for(var propName in defaultProps)if (props[propName] === undefined) props[propName] = defaultProps[propName];
            return props;
        }
        return baseProps;
    }
    function renderForwardRef(request, task, type, props, ref) {
        pushFunctionComponentStackInDEV(task, type.render);
        var children = renderWithHooks(request, task, type.render, props, ref);
        var hasId = checkDidRenderIdHook();
        if (hasId) {
            // This component materialized an id. We treat this as its own level, with
            // a single "child" slot.
            var prevTreeContext = task.treeContext;
            var totalChildren = 1;
            var index = 0;
            task.treeContext = pushTreeContext(prevTreeContext, totalChildren, index);
            try {
                renderNodeDestructive(request, task, children);
            } finally{
                task.treeContext = prevTreeContext;
            }
        } else renderNodeDestructive(request, task, children);
        popComponentStackInDEV(task);
    }
    function renderMemo(request, task, type, props, ref) {
        var innerType = type.type;
        var resolvedProps = resolveDefaultProps(innerType, props);
        renderElement(request, task, innerType, resolvedProps, ref);
    }
    function renderContextConsumer(request, task, context, props) {
        if (context._context === undefined) {
            // This may be because it's a Context (rather than a Consumer).
            // Or it may be because it's older React where they're the same thing.
            // We only want to warn if we're sure it's a new React.
            if (context !== context.Consumer) {
                if (!hasWarnedAboutUsingContextAsConsumer) {
                    hasWarnedAboutUsingContextAsConsumer = true;
                    error("Rendering <Context> directly is not supported and will be removed in a future major release. Did you mean to render <Context.Consumer> instead?");
                }
            }
        } else context = context._context;
        var render = props.children;
        if (typeof render !== "function") error("A context consumer was rendered with multiple children, or a child that isn't a function. A context consumer expects a single child that is a function. If you did pass a function, make sure there is no trailing or leading whitespace around it.");
        var newValue = readContext(context);
        var newChildren = render(newValue);
        renderNodeDestructive(request, task, newChildren);
    }
    function renderContextProvider(request, task, type, props) {
        var context = type._context;
        var value = props.value;
        var children = props.children;
        var prevSnapshot;
        prevSnapshot = task.context;
        task.context = pushProvider(context, value);
        renderNodeDestructive(request, task, children);
        task.context = popProvider(context);
        if (prevSnapshot !== task.context) error("Popping the context provider did not return back to the original snapshot. This is a bug in React.");
    }
    function renderLazyComponent(request, task, lazyComponent, props, ref) {
        pushBuiltInComponentStackInDEV(task, "Lazy");
        var payload = lazyComponent._payload;
        var init = lazyComponent._init;
        var Component = init(payload);
        var resolvedProps = resolveDefaultProps(Component, props);
        renderElement(request, task, Component, resolvedProps, ref);
        popComponentStackInDEV(task);
    }
    function renderElement(request, task, type, props, ref) {
        if (typeof type === "function") {
            if (shouldConstruct$1(type)) {
                renderClassComponent(request, task, type, props);
                return;
            } else {
                renderIndeterminateComponent(request, task, type, props);
                return;
            }
        }
        if (typeof type === "string") {
            renderHostElement(request, task, type, props);
            return;
        }
        switch(type){
            // TODO: LegacyHidden acts the same as a fragment. This only works
            // because we currently assume that every instance of LegacyHidden is
            // accompanied by a host component wrapper. In the hidden mode, the host
            // component is given a `hidden` attribute, which ensures that the
            // initial HTML is not visible. To support the use of LegacyHidden as a
            // true fragment, without an extra DOM node, we would have to hide the
            // initial HTML in some other way.
            // TODO: Add REACT_OFFSCREEN_TYPE here too with the same capability.
            case REACT_LEGACY_HIDDEN_TYPE:
            case REACT_DEBUG_TRACING_MODE_TYPE:
            case REACT_STRICT_MODE_TYPE:
            case REACT_PROFILER_TYPE:
            case REACT_FRAGMENT_TYPE:
                renderNodeDestructive(request, task, props.children);
                return;
            case REACT_SUSPENSE_LIST_TYPE:
                pushBuiltInComponentStackInDEV(task, "SuspenseList"); // TODO: SuspenseList should control the boundaries.
                renderNodeDestructive(request, task, props.children);
                popComponentStackInDEV(task);
                return;
            case REACT_SCOPE_TYPE:
                throw new Error("ReactDOMServer does not yet support scope components.");
            // eslint-disable-next-line-no-fallthrough
            case REACT_SUSPENSE_TYPE:
                renderSuspenseBoundary(request, task, props);
                return;
        }
        if (typeof type === "object" && type !== null) switch(type.$$typeof){
            case REACT_FORWARD_REF_TYPE:
                renderForwardRef(request, task, type, props, ref);
                return;
            case REACT_MEMO_TYPE:
                renderMemo(request, task, type, props, ref);
                return;
            case REACT_PROVIDER_TYPE:
                renderContextProvider(request, task, type, props);
                return;
            case REACT_CONTEXT_TYPE:
                renderContextConsumer(request, task, type, props);
                return;
            case REACT_LAZY_TYPE:
                renderLazyComponent(request, task, type, props);
                return;
        }
        var info = "";
        if (type === undefined || typeof type === "object" && type !== null && Object.keys(type).length === 0) info += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.";
        throw new Error("Element type is invalid: expected a string (for built-in components) or a class/function (for composite components) " + ("but got: " + (type == null ? type : typeof type) + "." + info));
    }
    function validateIterable(iterable, iteratorFn) {
        // We don't support rendering Generators because it's a mutation.
        // See https://github.com/facebook/react/issues/12995
        if (typeof Symbol === "function" && // $FlowFixMe Flow doesn't know about toStringTag
        iterable[Symbol.toStringTag] === "Generator") {
            if (!didWarnAboutGenerators) error("Using Generators as children is unsupported and will likely yield unexpected results because enumerating a generator mutates it. You may convert it to an array with `Array.from()` or the `[...spread]` operator before rendering. Keep in mind you might need to polyfill these features for older browsers.");
            didWarnAboutGenerators = true;
        } // Warn about using Maps as children
        if (iterable.entries === iteratorFn) {
            if (!didWarnAboutMaps) error("Using Maps as children is not supported. Use an array of keyed ReactElements instead.");
            didWarnAboutMaps = true;
        }
    }
    function renderNodeDestructive(request, task, node) {
        // In Dev we wrap renderNodeDestructiveImpl in a try / catch so we can capture
        // a component stack at the right place in the tree. We don't do this in renderNode
        // becuase it is not called at every layer of the tree and we may lose frames
        try {
            return renderNodeDestructiveImpl(request, task, node);
        } catch (x) {
            if (typeof x === "object" && x !== null && typeof x.then === "function") ;
            else // This is an error, stash the component stack if it is null.
            lastBoundaryErrorComponentStackDev = lastBoundaryErrorComponentStackDev !== null ? lastBoundaryErrorComponentStackDev : getCurrentStackInDEV();
             // rethrow so normal suspense logic can handle thrown value accordingly
            throw x;
        }
    } // This function by it self renders a node and consumes the task by mutating it
    // to update the current execution state.
    function renderNodeDestructiveImpl(request, task, node) {
        // Stash the node we're working on. We'll pick up from this task in case
        // something suspends.
        task.node = node; // Handle object types
        if (typeof node === "object" && node !== null) {
            switch(node.$$typeof){
                case REACT_ELEMENT_TYPE:
                    var element = node;
                    var type = element.type;
                    var props = element.props;
                    var ref = element.ref;
                    renderElement(request, task, type, props, ref);
                    return;
                case REACT_PORTAL_TYPE:
                    throw new Error("Portals are not currently supported by the server renderer. Render them conditionally so that they only appear on the client render.");
                // eslint-disable-next-line-no-fallthrough
                case REACT_LAZY_TYPE:
                    var lazyNode = node;
                    var payload = lazyNode._payload;
                    var init = lazyNode._init;
                    var resolvedNode;
                    try {
                        resolvedNode = init(payload);
                    } catch (x) {
                        if (typeof x === "object" && x !== null && typeof x.then === "function") // this Lazy initializer is suspending. push a temporary frame onto the stack so it can be
                        // popped off in spawnNewSuspendedTask. This aligns stack behavior between Lazy in element position
                        // vs Component position. We do not want the frame for Errors so we exclusively do this in
                        // the wakeable branch
                        pushBuiltInComponentStackInDEV(task, "Lazy");
                        throw x;
                    }
                    renderNodeDestructive(request, task, resolvedNode);
                    return;
            }
            if (isArray(node)) {
                renderChildrenArray(request, task, node);
                return;
            }
            var iteratorFn = getIteratorFn(node);
            if (iteratorFn) {
                validateIterable(node, iteratorFn);
                var iterator = iteratorFn.call(node);
                if (iterator) {
                    // We need to know how many total children are in this set, so that we
                    // can allocate enough id slots to acommodate them. So we must exhaust
                    // the iterator before we start recursively rendering the children.
                    // TODO: This is not great but I think it's inherent to the id
                    // generation algorithm.
                    var step = iterator.next(); // If there are not entries, we need to push an empty so we start by checking that.
                    if (!step.done) {
                        var children = [];
                        do {
                            children.push(step.value);
                            step = iterator.next();
                        }while (!step.done);
                        renderChildrenArray(request, task, children);
                        return;
                    }
                    return;
                }
            }
            var childString = Object.prototype.toString.call(node);
            throw new Error("Objects are not valid as a React child (found: " + (childString === "[object Object]" ? "object with keys {" + Object.keys(node).join(", ") + "}" : childString) + "). " + "If you meant to render a collection of children, use an array " + "instead.");
        }
        if (typeof node === "string") {
            var segment = task.blockedSegment;
            segment.lastPushedText = pushTextInstance$1(task.blockedSegment.chunks, node, request.responseState, segment.lastPushedText);
            return;
        }
        if (typeof node === "number") {
            var _segment = task.blockedSegment;
            _segment.lastPushedText = pushTextInstance$1(task.blockedSegment.chunks, "" + node, request.responseState, _segment.lastPushedText);
            return;
        }
        if (typeof node === "function") error("Functions are not valid as a React child. This may happen if you return a Component instead of <Component /> from render. Or maybe you meant to call this function rather than return it.");
    }
    function renderChildrenArray(request, task, children) {
        var totalChildren = children.length;
        for(var i = 0; i < totalChildren; i++){
            var prevTreeContext = task.treeContext;
            task.treeContext = pushTreeContext(prevTreeContext, totalChildren, i);
            try {
                // We need to use the non-destructive form so that we can safely pop back
                // up and render the sibling if something suspends.
                renderNode(request, task, children[i]);
            } finally{
                task.treeContext = prevTreeContext;
            }
        }
    }
    function spawnNewSuspendedTask(request, task, x) {
        // Something suspended, we'll need to create a new segment and resolve it later.
        var segment = task.blockedSegment;
        var insertionIndex = segment.chunks.length;
        var newSegment = createPendingSegment(request, insertionIndex, null, segment.formatContext, segment.lastPushedText, true);
        segment.children.push(newSegment); // Reset lastPushedText for current Segment since the new Segment "consumed" it
        segment.lastPushedText = false;
        var newTask = createTask(request, task.node, task.blockedBoundary, newSegment, task.abortSet, task.legacyContext, task.context, task.treeContext);
        if (task.componentStack !== null) // We pop one task off the stack because the node that suspended will be tried again,
        // which will add it back onto the stack.
        newTask.componentStack = task.componentStack.parent;
        var ping = newTask.ping;
        x.then(ping, ping);
    } // This is a non-destructive form of rendering a node. If it suspends it spawns
    // a new task and restores the context of this task to what it was before.
    function renderNode(request, task, node) {
        // TODO: Store segment.children.length here and reset it in case something
        // suspended partially through writing something.
        // Snapshot the current context in case something throws to interrupt the
        // process.
        var previousFormatContext = task.blockedSegment.formatContext;
        var previousLegacyContext = task.legacyContext;
        var previousContext = task.context;
        var previousComponentStack = null;
        previousComponentStack = task.componentStack;
        try {
            return renderNodeDestructive(request, task, node);
        } catch (x) {
            resetHooksState();
            if (typeof x === "object" && x !== null && typeof x.then === "function") {
                spawnNewSuspendedTask(request, task, x); // Restore the context. We assume that this will be restored by the inner
                // functions in case nothing throws so we don't use "finally" here.
                task.blockedSegment.formatContext = previousFormatContext;
                task.legacyContext = previousLegacyContext;
                task.context = previousContext; // Restore all active ReactContexts to what they were before.
                switchContext(previousContext);
                task.componentStack = previousComponentStack;
                return;
            } else {
                // Restore the context. We assume that this will be restored by the inner
                // functions in case nothing throws so we don't use "finally" here.
                task.blockedSegment.formatContext = previousFormatContext;
                task.legacyContext = previousLegacyContext;
                task.context = previousContext; // Restore all active ReactContexts to what they were before.
                switchContext(previousContext);
                task.componentStack = previousComponentStack;
                // Let's terminate the rest of the tree and don't render any siblings.
                throw x;
            }
        }
    }
    function erroredTask(request, boundary, segment, error) {
        // Report the error to a global handler.
        var errorDigest = logRecoverableError(request, error);
        if (boundary === null) fatalError(request, error);
        else {
            boundary.pendingTasks--;
            if (!boundary.forceClientRender) {
                boundary.forceClientRender = true;
                boundary.errorDigest = errorDigest;
                captureBoundaryErrorDetailsDev(boundary, error);
                // so we can flush it, if the parent already flushed.
                if (boundary.parentFlushed) // We don't have a preference where in the queue this goes since it's likely
                // to error on the client anyway. However, intentionally client-rendered
                // boundaries should be flushed earlier so that they can start on the client.
                // We reuse the same queue for errors.
                request.clientRenderedBoundaries.push(boundary);
            }
        }
        request.allPendingTasks--;
        if (request.allPendingTasks === 0) {
            var onAllReady = request.onAllReady;
            onAllReady();
        }
    }
    function abortTaskSoft(task) {
        // This aborts task without aborting the parent boundary that it blocks.
        // It's used for when we didn't need this task to complete the tree.
        // If task was needed, then it should use abortTask instead.
        var request = this;
        var boundary = task.blockedBoundary;
        var segment = task.blockedSegment;
        segment.status = ABORTED;
        finishedTask(request, boundary, segment);
    }
    function abortTask(task, request, reason) {
        // This aborts the task and aborts the parent that it blocks, putting it into
        // client rendered mode.
        var boundary = task.blockedBoundary;
        var segment = task.blockedSegment;
        segment.status = ABORTED;
        if (boundary === null) {
            request.allPendingTasks--; // We didn't complete the root so we have nothing to show. We can close
            // the request;
            if (request.status !== CLOSED) {
                request.status = CLOSED;
                if (request.destination !== null) close(request.destination);
            }
        } else {
            boundary.pendingTasks--;
            if (!boundary.forceClientRender) {
                boundary.forceClientRender = true;
                var _error = reason === undefined ? new Error("The render was aborted by the server without a reason.") : reason;
                boundary.errorDigest = request.onError(_error);
                var errorPrefix = "The server did not finish this Suspense boundary: ";
                if (_error && typeof _error.message === "string") _error = errorPrefix + _error.message;
                else // eslint-disable-next-line react-internal/safe-string-coercion
                _error = errorPrefix + String(_error);
                var previousTaskInDev = currentTaskInDEV;
                currentTaskInDEV = task;
                try {
                    captureBoundaryErrorDetailsDev(boundary, _error);
                } finally{
                    currentTaskInDEV = previousTaskInDev;
                }
                if (boundary.parentFlushed) request.clientRenderedBoundaries.push(boundary);
            } // If this boundary was still pending then we haven't already cancelled its fallbacks.
            // We'll need to abort the fallbacks, which will also error that parent boundary.
            boundary.fallbackAbortableTasks.forEach(function(fallbackTask) {
                return abortTask(fallbackTask, request, reason);
            });
            boundary.fallbackAbortableTasks.clear();
            request.allPendingTasks--;
            if (request.allPendingTasks === 0) {
                var onAllReady = request.onAllReady;
                onAllReady();
            }
        }
    }
    function queueCompletedSegment(boundary, segment) {
        if (segment.chunks.length === 0 && segment.children.length === 1 && segment.children[0].boundary === null) {
            // This is an empty segment. There's nothing to write, so we can instead transfer the ID
            // to the child. That way any existing references point to the child.
            var childSegment = segment.children[0];
            childSegment.id = segment.id;
            childSegment.parentFlushed = true;
            if (childSegment.status === COMPLETED) queueCompletedSegment(boundary, childSegment);
        } else {
            var completedSegments = boundary.completedSegments;
            completedSegments.push(segment);
        }
    }
    function finishedTask(request, boundary, segment) {
        if (boundary === null) {
            if (segment.parentFlushed) {
                if (request.completedRootSegment !== null) throw new Error("There can only be one root segment. This is a bug in React.");
                request.completedRootSegment = segment;
            }
            request.pendingRootTasks--;
            if (request.pendingRootTasks === 0) {
                // We have completed the shell so the shell can't error anymore.
                request.onShellError = noop$1;
                var onShellReady = request.onShellReady;
                onShellReady();
            }
        } else {
            boundary.pendingTasks--;
            if (boundary.forceClientRender) ;
            else if (boundary.pendingTasks === 0) {
                // This must have been the last segment we were waiting on. This boundary is now complete.
                if (segment.parentFlushed) // Our parent segment already flushed, so we need to schedule this segment to be emitted.
                // If it is a segment that was aborted, we'll write other content instead so we don't need
                // to emit it.
                {
                    if (segment.status === COMPLETED) queueCompletedSegment(boundary, segment);
                }
                if (boundary.parentFlushed) // The segment might be part of a segment that didn't flush yet, but if the boundary's
                // parent flushed, we need to schedule the boundary to be emitted.
                request.completedBoundaries.push(boundary);
                 // We can now cancel any pending task on the fallback since we won't need to show it anymore.
                // This needs to happen after we read the parentFlushed flags because aborting can finish
                // work which can trigger user code, which can start flushing, which can change those flags.
                boundary.fallbackAbortableTasks.forEach(abortTaskSoft, request);
                boundary.fallbackAbortableTasks.clear();
            } else {
                if (segment.parentFlushed) // Our parent already flushed, so we need to schedule this segment to be emitted.
                // If it is a segment that was aborted, we'll write other content instead so we don't need
                // to emit it.
                {
                    if (segment.status === COMPLETED) {
                        queueCompletedSegment(boundary, segment);
                        var completedSegments = boundary.completedSegments;
                        if (completedSegments.length === 1) // This is the first time since we last flushed that we completed anything.
                        // We can schedule this boundary to emit its partially completed segments early
                        // in case the parent has already been flushed.
                        {
                            if (boundary.parentFlushed) request.partialBoundaries.push(boundary);
                        }
                    }
                }
            }
        }
        request.allPendingTasks--;
        if (request.allPendingTasks === 0) {
            // This needs to be called at the very end so that we can synchronously write the result
            // in the callback if needed.
            var onAllReady = request.onAllReady;
            onAllReady();
        }
    }
    function retryTask(request, task) {
        var segment = task.blockedSegment;
        if (segment.status !== PENDING) // We completed this by other means before we had a chance to retry it.
        return;
         // We restore the context to what it was when we suspended.
        // We don't restore it after we leave because it's likely that we'll end up
        // needing a very similar context soon again.
        switchContext(task.context);
        var prevTaskInDEV = null;
        prevTaskInDEV = currentTaskInDEV;
        currentTaskInDEV = task;
        try {
            // We call the destructive form that mutates this task. That way if something
            // suspends again, we can reuse the same task instead of spawning a new one.
            renderNodeDestructive(request, task, task.node);
            pushSegmentFinale$1(segment.chunks, request.responseState, segment.lastPushedText, segment.textEmbedded);
            task.abortSet.delete(task);
            segment.status = COMPLETED;
            finishedTask(request, task.blockedBoundary, segment);
        } catch (x) {
            resetHooksState();
            if (typeof x === "object" && x !== null && typeof x.then === "function") {
                // Something suspended again, let's pick it back up later.
                var ping = task.ping;
                x.then(ping, ping);
            } else {
                task.abortSet.delete(task);
                segment.status = ERRORED;
                erroredTask(request, task.blockedBoundary, segment, x);
            }
        } finally{
            currentTaskInDEV = prevTaskInDEV;
        }
    }
    function performWork(request) {
        if (request.status === CLOSED) return;
        var prevContext = getActiveContext();
        var prevDispatcher = ReactCurrentDispatcher$1.current;
        ReactCurrentDispatcher$1.current = Dispatcher;
        var prevGetCurrentStackImpl;
        prevGetCurrentStackImpl = ReactDebugCurrentFrame$1.getCurrentStack;
        ReactDebugCurrentFrame$1.getCurrentStack = getCurrentStackInDEV;
        var prevResponseState = currentResponseState;
        setCurrentResponseState(request.responseState);
        try {
            var pingedTasks = request.pingedTasks;
            var i;
            for(i = 0; i < pingedTasks.length; i++){
                var task = pingedTasks[i];
                retryTask(request, task);
            }
            pingedTasks.splice(0, i);
            if (request.destination !== null) flushCompletedQueues(request, request.destination);
        } catch (error) {
            logRecoverableError(request, error);
            fatalError(request, error);
        } finally{
            setCurrentResponseState(prevResponseState);
            ReactCurrentDispatcher$1.current = prevDispatcher;
            ReactDebugCurrentFrame$1.getCurrentStack = prevGetCurrentStackImpl;
            if (prevDispatcher === Dispatcher) // This means that we were in a reentrant work loop. This could happen
            // in a renderer that supports synchronous work like renderToString,
            // when it's called from within another renderer.
            // Normally we don't bother switching the contexts to their root/default
            // values when leaving because we'll likely need the same or similar
            // context again. However, when we're inside a synchronous loop like this
            // we'll to restore the context to what it was before returning.
            switchContext(prevContext);
        }
    }
    function flushSubtree(request, destination, segment) {
        segment.parentFlushed = true;
        switch(segment.status){
            case PENDING:
                // We're emitting a placeholder for this segment to be filled in later.
                // Therefore we'll need to assign it an ID - to refer to it by.
                var segmentID = segment.id = request.nextSegmentId++; // When this segment finally completes it won't be embedded in text since it will flush separately
                segment.lastPushedText = false;
                segment.textEmbedded = false;
                return writePlaceholder(destination, request.responseState, segmentID);
            case COMPLETED:
                segment.status = FLUSHED;
                var r = true;
                var chunks = segment.chunks;
                var chunkIdx = 0;
                var children = segment.children;
                for(var childIdx = 0; childIdx < children.length; childIdx++){
                    var nextChild = children[childIdx]; // Write all the chunks up until the next child.
                    for(; chunkIdx < nextChild.index; chunkIdx++)writeChunk(destination, chunks[chunkIdx]);
                    r = flushSegment(request, destination, nextChild);
                } // Finally just write all the remaining chunks
                for(; chunkIdx < chunks.length - 1; chunkIdx++)writeChunk(destination, chunks[chunkIdx]);
                if (chunkIdx < chunks.length) r = writeChunkAndReturn(destination, chunks[chunkIdx]);
                return r;
            default:
                throw new Error("Aborted, errored or already flushed boundaries should not be flushed again. This is a bug in React.");
        }
    }
    function flushSegment(request, destination, segment) {
        var boundary = segment.boundary;
        if (boundary === null) // Not a suspense boundary.
        return flushSubtree(request, destination, segment);
        boundary.parentFlushed = true; // This segment is a Suspense boundary. We need to decide whether to
        // emit the content or the fallback now.
        if (boundary.forceClientRender) {
            // Emit a client rendered suspense boundary wrapper.
            // We never queue the inner boundary so we'll never emit its content or partial segments.
            writeStartClientRenderedSuspenseBoundary$1(destination, request.responseState, boundary.errorDigest, boundary.errorMessage, boundary.errorComponentStack); // Flush the fallback.
            flushSubtree(request, destination, segment);
            return writeEndClientRenderedSuspenseBoundary$1(destination, request.responseState);
        } else if (boundary.pendingTasks > 0) {
            // This boundary is still loading. Emit a pending suspense boundary wrapper.
            // Assign an ID to refer to the future content by.
            boundary.rootSegmentID = request.nextSegmentId++;
            if (boundary.completedSegments.length > 0) // If this is at least partially complete, we can queue it to be partially emitted early.
            request.partialBoundaries.push(boundary);
             /// This is the first time we should have referenced this ID.
            var id = boundary.id = assignSuspenseBoundaryID(request.responseState);
            writeStartPendingSuspenseBoundary(destination, request.responseState, id); // Flush the fallback.
            flushSubtree(request, destination, segment);
            return writeEndPendingSuspenseBoundary(destination, request.responseState);
        } else if (boundary.byteSize > request.progressiveChunkSize) {
            // This boundary is large and will be emitted separately so that we can progressively show
            // other content. We add it to the queue during the flush because we have to ensure that
            // the parent flushes first so that there's something to inject it into.
            // We also have to make sure that it's emitted into the queue in a deterministic slot.
            // I.e. we can't insert it here when it completes.
            // Assign an ID to refer to the future content by.
            boundary.rootSegmentID = request.nextSegmentId++;
            request.completedBoundaries.push(boundary); // Emit a pending rendered suspense boundary wrapper.
            writeStartPendingSuspenseBoundary(destination, request.responseState, boundary.id); // Flush the fallback.
            flushSubtree(request, destination, segment);
            return writeEndPendingSuspenseBoundary(destination, request.responseState);
        } else {
            // We can inline this boundary's content as a complete boundary.
            writeStartCompletedSuspenseBoundary$1(destination, request.responseState);
            var completedSegments = boundary.completedSegments;
            if (completedSegments.length !== 1) throw new Error("A previously unvisited boundary must have exactly one root segment. This is a bug in React.");
            var contentSegment = completedSegments[0];
            flushSegment(request, destination, contentSegment);
            return writeEndCompletedSuspenseBoundary$1(destination, request.responseState);
        }
    }
    function flushClientRenderedBoundary(request, destination, boundary) {
        return writeClientRenderBoundaryInstruction(destination, request.responseState, boundary.id, boundary.errorDigest, boundary.errorMessage, boundary.errorComponentStack);
    }
    function flushSegmentContainer(request, destination, segment) {
        writeStartSegment(destination, request.responseState, segment.formatContext, segment.id);
        flushSegment(request, destination, segment);
        return writeEndSegment(destination, segment.formatContext);
    }
    function flushCompletedBoundary(request, destination, boundary) {
        var completedSegments = boundary.completedSegments;
        var i = 0;
        for(; i < completedSegments.length; i++){
            var segment = completedSegments[i];
            flushPartiallyCompletedSegment(request, destination, boundary, segment);
        }
        completedSegments.length = 0;
        return writeCompletedBoundaryInstruction(destination, request.responseState, boundary.id, boundary.rootSegmentID);
    }
    function flushPartialBoundary(request, destination, boundary) {
        var completedSegments = boundary.completedSegments;
        var i = 0;
        for(; i < completedSegments.length; i++){
            var segment = completedSegments[i];
            if (!flushPartiallyCompletedSegment(request, destination, boundary, segment)) {
                i++;
                completedSegments.splice(0, i); // Only write as much as the buffer wants. Something higher priority
                // might want to write later.
                return false;
            }
        }
        completedSegments.splice(0, i);
        return true;
    }
    function flushPartiallyCompletedSegment(request, destination, boundary, segment) {
        if (segment.status === FLUSHED) // We've already flushed this inline.
        return true;
        var segmentID = segment.id;
        if (segmentID === -1) {
            // This segment wasn't previously referred to. This happens at the root of
            // a boundary. We make kind of a leap here and assume this is the root.
            var rootSegmentID = segment.id = boundary.rootSegmentID;
            if (rootSegmentID === -1) throw new Error("A root segment ID must have been assigned by now. This is a bug in React.");
            return flushSegmentContainer(request, destination, segment);
        } else {
            flushSegmentContainer(request, destination, segment);
            return writeCompletedSegmentInstruction(destination, request.responseState, segmentID);
        }
    }
    function flushCompletedQueues(request, destination) {
        try {
            // The structure of this is to go through each queue one by one and write
            // until the sink tells us to stop. When we should stop, we still finish writing
            // that item fully and then yield. At that point we remove the already completed
            // items up until the point we completed them.
            // TODO: Emit preloading.
            // TODO: It's kind of unfortunate to keep checking this array after we've already
            // emitted the root.
            var completedRootSegment = request.completedRootSegment;
            if (completedRootSegment !== null && request.pendingRootTasks === 0) {
                flushSegment(request, destination, completedRootSegment);
                request.completedRootSegment = null;
                writeCompletedRoot(destination, request.responseState);
            } // We emit client rendering instructions for already emitted boundaries first.
            // This is so that we can signal to the client to start client rendering them as
            // soon as possible.
            var clientRenderedBoundaries = request.clientRenderedBoundaries;
            var i;
            for(i = 0; i < clientRenderedBoundaries.length; i++){
                var boundary = clientRenderedBoundaries[i];
                if (!flushClientRenderedBoundary(request, destination, boundary)) {
                    request.destination = null;
                    i++;
                    clientRenderedBoundaries.splice(0, i);
                    return;
                }
            }
            clientRenderedBoundaries.splice(0, i); // Next we emit any complete boundaries. It's better to favor boundaries
            // that are completely done since we can actually show them, than it is to emit
            // any individual segments from a partially complete boundary.
            var completedBoundaries = request.completedBoundaries;
            for(i = 0; i < completedBoundaries.length; i++){
                var _boundary = completedBoundaries[i];
                if (!flushCompletedBoundary(request, destination, _boundary)) {
                    request.destination = null;
                    i++;
                    completedBoundaries.splice(0, i);
                    return;
                }
            }
            completedBoundaries.splice(0, i); // Allow anything written so far to flush to the underlying sink before
            // we continue with lower priorities.
            completeWriting(destination);
            beginWriting(destination); // TODO: Here we'll emit data used by hydration.
            // Next we emit any segments of any boundaries that are partially complete
            // but not deeply complete.
            var partialBoundaries = request.partialBoundaries;
            for(i = 0; i < partialBoundaries.length; i++){
                var _boundary2 = partialBoundaries[i];
                if (!flushPartialBoundary(request, destination, _boundary2)) {
                    request.destination = null;
                    i++;
                    partialBoundaries.splice(0, i);
                    return;
                }
            }
            partialBoundaries.splice(0, i); // Next we check the completed boundaries again. This may have had
            // boundaries added to it in case they were too larged to be inlined.
            // New ones might be added in this loop.
            var largeBoundaries = request.completedBoundaries;
            for(i = 0; i < largeBoundaries.length; i++){
                var _boundary3 = largeBoundaries[i];
                if (!flushCompletedBoundary(request, destination, _boundary3)) {
                    request.destination = null;
                    i++;
                    largeBoundaries.splice(0, i);
                    return;
                }
            }
            largeBoundaries.splice(0, i);
        } finally{
            if (request.allPendingTasks === 0 && request.pingedTasks.length === 0 && request.clientRenderedBoundaries.length === 0 && request.completedBoundaries.length === 0 // We don't need to check any partially completed segments because
            ) {
                if (request.abortableTasks.size !== 0) error("There was still abortable task at the root when we closed. This is a bug in React.");
                close(destination);
            }
        }
    }
    function startWork(request) {
        scheduleWork(function() {
            return performWork(request);
        });
    }
    function startFlowing(request, destination) {
        if (request.status === CLOSING) {
            request.status = CLOSED;
            closeWithError(destination, request.fatalError);
            return;
        }
        if (request.status === CLOSED) return;
        if (request.destination !== null) // We're already flowing.
        return;
        request.destination = destination;
        try {
            flushCompletedQueues(request, destination);
        } catch (error) {
            logRecoverableError(request, error);
            fatalError(request, error);
        }
    } // This is called to early terminate a request. It puts all pending boundaries in client rendered state.
    function abort(request, reason) {
        try {
            var abortableTasks = request.abortableTasks;
            abortableTasks.forEach(function(task) {
                return abortTask(task, request, reason);
            });
            abortableTasks.clear();
            if (request.destination !== null) flushCompletedQueues(request, request.destination);
        } catch (error) {
            logRecoverableError(request, error);
            fatalError(request, error);
        }
    }
    function onError() {}
    function renderToStringImpl(children, options, generateStaticMarkup, abortReason) {
        var didFatal = false;
        var fatalError = null;
        var result = "";
        var destination = {
            push: function(chunk) {
                if (chunk !== null) result += chunk;
                return true;
            },
            destroy: function(error) {
                didFatal = true;
                fatalError = error;
            }
        };
        var readyToStream = false;
        function onShellReady() {
            readyToStream = true;
        }
        var request = createRequest(children, createResponseState$1(generateStaticMarkup, options ? options.identifierPrefix : undefined), createRootFormatContext(), Infinity, onError, undefined, onShellReady, undefined, undefined);
        startWork(request); // If anything suspended and is still pending, we'll abort it before writing.
        // That way we write only client-rendered boundaries from the start.
        abort(request, abortReason);
        startFlowing(request, destination);
        if (didFatal) throw fatalError;
        if (!readyToStream) // Note: This error message is the one we use on the client. It doesn't
        // really make sense here. But this is the legacy server renderer, anyway.
        // We're going to delete it soon.
        throw new Error("A component suspended while responding to synchronous input. This will cause the UI to be replaced with a loading indicator. To fix, updates that suspend should be wrapped with startTransition.");
        return result;
    }
    function renderToString(children, options) {
        return renderToStringImpl(children, options, false, 'The server used "renderToString" which does not support Suspense. If you intended for this Suspense boundary to render the fallback content on the server consider throwing an Error somewhere within the Suspense boundary. If you intended to have the server wait for the suspended component please switch to "renderToReadableStream" which supports Suspense on the server');
    }
    function renderToStaticMarkup(children, options) {
        return renderToStringImpl(children, options, true, 'The server used "renderToStaticMarkup" which does not support Suspense. If you intended to have the server wait for the suspended component please switch to "renderToReadableStream" which supports Suspense on the server');
    }
    function renderToNodeStream() {
        throw new Error("ReactDOMServer.renderToNodeStream(): The streaming API is not available in the browser. Use ReactDOMServer.renderToString() instead.");
    }
    function renderToStaticNodeStream() {
        throw new Error("ReactDOMServer.renderToStaticNodeStream(): The streaming API is not available in the browser. Use ReactDOMServer.renderToStaticMarkup() instead.");
    }
    $0a09e8bdaadac978$export$307591e98609eddd = renderToNodeStream;
    $0a09e8bdaadac978$export$eb3a06aef9e6ee51 = renderToStaticMarkup;
    $0a09e8bdaadac978$export$b23711c915539651 = renderToStaticNodeStream;
    $0a09e8bdaadac978$export$80e7718417253a51 = renderToString;
    $0a09e8bdaadac978$export$83d89fbfd8236492 = ReactVersion;
})();

});

parcelRegister("2jGA3", function(module, exports) {

$parcel$export(module.exports, "renderToReadableStream", () => $1afe62ba3a7403ae$export$7020a3240b287705, (v) => $1afe62ba3a7403ae$export$7020a3240b287705 = v);
$parcel$export(module.exports, "version", () => $1afe62ba3a7403ae$export$83d89fbfd8236492, (v) => $1afe62ba3a7403ae$export$83d89fbfd8236492 = v);
/**
 * @license React
 * react-dom-server.browser.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $1afe62ba3a7403ae$export$7020a3240b287705;
var $1afe62ba3a7403ae$export$83d89fbfd8236492;
"use strict";

(function() {
    "use strict";
    var React = (parcelRequire("acw62"));
    var ReactVersion = "18.2.0";
    var ReactSharedInternals = React.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    // by calls to these methods by a Babel plugin.
    //
    // In PROD (or in packages without access to React internals),
    // they are left as they are instead.
    function warn(format) {
        for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)args[_key - 1] = arguments[_key];
        printWarning("warn", format, args);
    }
    function error(format) {
        for(var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++)args[_key2 - 1] = arguments[_key2];
        printWarning("error", format, args);
    }
    function printWarning(level, format, args) {
        var ReactDebugCurrentFrame = ReactSharedInternals.ReactDebugCurrentFrame;
        var stack = ReactDebugCurrentFrame.getStackAddendum();
        if (stack !== "") {
            format += "%s";
            args = args.concat([
                stack
            ]);
        } // eslint-disable-next-line react-internal/safe-string-coercion
        var argsWithFormat = args.map(function(item) {
            return String(item);
        }); // Careful: RN currently depends on this prefix
        argsWithFormat.unshift("Warning: " + format); // We intentionally don't use spread (or .apply) directly because it
        // breaks IE9: https://github.com/facebook/react/issues/13610
        // eslint-disable-next-line react-internal/no-production-logging
        Function.prototype.apply.call(console[level], console, argsWithFormat);
    }
    function scheduleWork(callback) {
        callback();
    }
    var VIEW_SIZE = 512;
    var currentView = null;
    var writtenBytes = 0;
    function beginWriting(destination) {
        currentView = new Uint8Array(VIEW_SIZE);
        writtenBytes = 0;
    }
    function writeChunk(destination, chunk) {
        if (chunk.length === 0) return;
        if (chunk.length > VIEW_SIZE) {
            // this chunk may overflow a single view which implies it was not
            // one that is cached by the streaming renderer. We will enqueu
            // it directly and expect it is not re-used
            if (writtenBytes > 0) {
                destination.enqueue(new Uint8Array(currentView.buffer, 0, writtenBytes));
                currentView = new Uint8Array(VIEW_SIZE);
                writtenBytes = 0;
            }
            destination.enqueue(chunk);
            return;
        }
        var bytesToWrite = chunk;
        var allowableBytes = currentView.length - writtenBytes;
        if (allowableBytes < bytesToWrite.length) {
            // this chunk would overflow the current view. We enqueue a full view
            // and start a new view with the remaining chunk
            if (allowableBytes === 0) // the current view is already full, send it
            destination.enqueue(currentView);
            else {
                // fill up the current view and apply the remaining chunk bytes
                // to a new view.
                currentView.set(bytesToWrite.subarray(0, allowableBytes), writtenBytes); // writtenBytes += allowableBytes; // this can be skipped because we are going to immediately reset the view
                destination.enqueue(currentView);
                bytesToWrite = bytesToWrite.subarray(allowableBytes);
            }
            currentView = new Uint8Array(VIEW_SIZE);
            writtenBytes = 0;
        }
        currentView.set(bytesToWrite, writtenBytes);
        writtenBytes += bytesToWrite.length;
    }
    function writeChunkAndReturn(destination, chunk) {
        writeChunk(destination, chunk); // in web streams there is no backpressure so we can alwas write more
        return true;
    }
    function completeWriting(destination) {
        if (currentView && writtenBytes > 0) {
            destination.enqueue(new Uint8Array(currentView.buffer, 0, writtenBytes));
            currentView = null;
            writtenBytes = 0;
        }
    }
    function close(destination) {
        destination.close();
    }
    var textEncoder = new TextEncoder();
    function stringToChunk(content) {
        return textEncoder.encode(content);
    }
    function stringToPrecomputedChunk(content) {
        return textEncoder.encode(content);
    }
    function closeWithError(destination, error) {
        if (typeof destination.error === "function") // $FlowFixMe: This is an Error object or the destination accepts other types.
        destination.error(error);
        else // Earlier implementations doesn't support this method. In that environment you're
        // supposed to throw from a promise returned but we don't return a promise in our
        // approach. We could fork this implementation but this is environment is an edge
        // case to begin with. It's even less common to run this in an older environment.
        // Even then, this is not where errors are supposed to happen and they get reported
        // to a global callback in addition to this anyway. So it's fine just to close this.
        destination.close();
    }
    /*
 * The `'' + value` pattern (used in in perf-sensitive code) throws for Symbol
 * and Temporal.* types. See https://github.com/facebook/react/pull/22064.
 *
 * The functions in this module will throw an easier-to-understand,
 * easier-to-debug exception with a clear errors message message explaining the
 * problem. (Instead of a confusing exception thrown inside the implementation
 * of the `value` object).
 */ // $FlowFixMe only called in DEV, so void return is not possible.
    function typeName(value) {
        // toStringTag is needed for namespaced types like Temporal.Instant
        var hasToStringTag = typeof Symbol === "function" && Symbol.toStringTag;
        var type = hasToStringTag && value[Symbol.toStringTag] || value.constructor.name || "Object";
        return type;
    } // $FlowFixMe only called in DEV, so void return is not possible.
    function willCoercionThrow(value) {
        try {
            testStringCoercion(value);
            return false;
        } catch (e) {
            return true;
        }
    }
    function testStringCoercion(value) {
        // If you ended up here by following an exception call stack, here's what's
        // happened: you supplied an object or symbol value to React (as a prop, key,
        // DOM attribute, CSS property, string ref, etc.) and when React tried to
        // coerce it to a string using `'' + value`, an exception was thrown.
        //
        // The most common types that will cause this exception are `Symbol` instances
        // and Temporal objects like `Temporal.Instant`. But any object that has a
        // `valueOf` or `[Symbol.toPrimitive]` method that throws will also cause this
        // exception. (Library authors do this to prevent users from using built-in
        // numeric operators like `+` or comparison operators like `>=` because custom
        // methods are needed to perform accurate arithmetic or comparison.)
        //
        // To fix the problem, coerce this object or symbol value to a string before
        // passing it to React. The most reliable way is usually `String(value)`.
        //
        // To find which value is throwing, check the browser or debugger console.
        // Before this exception was thrown, there should be `console.error` output
        // that shows the type (Symbol, Temporal.PlainDate, etc.) that caused the
        // problem and how that type was used: key, atrribute, input value prop, etc.
        // In most cases, this console output also shows the component and its
        // ancestor components where the exception happened.
        //
        // eslint-disable-next-line react-internal/safe-string-coercion
        return "" + value;
    }
    function checkAttributeStringCoercion(value, attributeName) {
        if (willCoercionThrow(value)) {
            error("The provided `%s` attribute is an unsupported type %s. This value must be coerced to a string before before using it here.", attributeName, typeName(value));
            return testStringCoercion(value); // throw (to help callers find troubleshooting comments)
        }
    }
    function checkCSSPropertyStringCoercion(value, propName) {
        if (willCoercionThrow(value)) {
            error("The provided `%s` CSS property is an unsupported type %s. This value must be coerced to a string before before using it here.", propName, typeName(value));
            return testStringCoercion(value); // throw (to help callers find troubleshooting comments)
        }
    }
    function checkHtmlStringCoercion(value) {
        if (willCoercionThrow(value)) {
            error("The provided HTML markup uses a value of unsupported type %s. This value must be coerced to a string before before using it here.", typeName(value));
            return testStringCoercion(value); // throw (to help callers find troubleshooting comments)
        }
    }
    var hasOwnProperty = Object.prototype.hasOwnProperty;
    // A reserved attribute.
    // It is handled by React separately and shouldn't be written to the DOM.
    var RESERVED = 0; // A simple string attribute.
    // Attributes that aren't in the filter are presumed to have this type.
    var STRING = 1; // A string attribute that accepts booleans in React. In HTML, these are called
    // "enumerated" attributes with "true" and "false" as possible values.
    // When true, it should be set to a "true" string.
    // When false, it should be set to a "false" string.
    var BOOLEANISH_STRING = 2; // A real boolean attribute.
    // When true, it should be present (set either to an empty string or its name).
    // When false, it should be omitted.
    var BOOLEAN = 3; // An attribute that can be used as a flag as well as with a value.
    // When true, it should be present (set either to an empty string or its name).
    // When false, it should be omitted.
    // For any other value, should be present with that value.
    var OVERLOADED_BOOLEAN = 4; // An attribute that must be numeric or parse as a numeric.
    // When falsy, it should be removed.
    var NUMERIC = 5; // An attribute that must be positive numeric or parse as a positive numeric.
    // When falsy, it should be removed.
    var POSITIVE_NUMERIC = 6;
    /* eslint-disable max-len */ var ATTRIBUTE_NAME_START_CHAR = ":A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD";
    /* eslint-enable max-len */ var ATTRIBUTE_NAME_CHAR = ATTRIBUTE_NAME_START_CHAR + "\\-.0-9\\u00B7\\u0300-\\u036F\\u203F-\\u2040";
    var VALID_ATTRIBUTE_NAME_REGEX = new RegExp("^[" + ATTRIBUTE_NAME_START_CHAR + "][" + ATTRIBUTE_NAME_CHAR + "]*$");
    var illegalAttributeNameCache = {};
    var validatedAttributeNameCache = {};
    function isAttributeNameSafe(attributeName) {
        if (hasOwnProperty.call(validatedAttributeNameCache, attributeName)) return true;
        if (hasOwnProperty.call(illegalAttributeNameCache, attributeName)) return false;
        if (VALID_ATTRIBUTE_NAME_REGEX.test(attributeName)) {
            validatedAttributeNameCache[attributeName] = true;
            return true;
        }
        illegalAttributeNameCache[attributeName] = true;
        error("Invalid attribute name: `%s`", attributeName);
        return false;
    }
    function shouldRemoveAttributeWithWarning(name, value, propertyInfo, isCustomComponentTag) {
        if (propertyInfo !== null && propertyInfo.type === RESERVED) return false;
        switch(typeof value){
            case "function":
            case "symbol":
                // eslint-disable-line
                return true;
            case "boolean":
                if (isCustomComponentTag) return false;
                if (propertyInfo !== null) return !propertyInfo.acceptsBooleans;
                else {
                    var prefix = name.toLowerCase().slice(0, 5);
                    return prefix !== "data-" && prefix !== "aria-";
                }
            default:
                return false;
        }
    }
    function getPropertyInfo(name) {
        return properties.hasOwnProperty(name) ? properties[name] : null;
    }
    function PropertyInfoRecord(name, type, mustUseProperty, attributeName, attributeNamespace, sanitizeURL, removeEmptyString) {
        this.acceptsBooleans = type === BOOLEANISH_STRING || type === BOOLEAN || type === OVERLOADED_BOOLEAN;
        this.attributeName = attributeName;
        this.attributeNamespace = attributeNamespace;
        this.mustUseProperty = mustUseProperty;
        this.propertyName = name;
        this.type = type;
        this.sanitizeURL = sanitizeURL;
        this.removeEmptyString = removeEmptyString;
    } // When adding attributes to this list, be sure to also add them to
    // the `possibleStandardNames` module to ensure casing and incorrect
    // name warnings.
    var properties = {}; // These props are reserved by React. They shouldn't be written to the DOM.
    var reservedProps = [
        "children",
        "dangerouslySetInnerHTML",
        // elements (not just inputs). Now that ReactDOMInput assigns to the
        // defaultValue property -- do we need this?
        "defaultValue",
        "defaultChecked",
        "innerHTML",
        "suppressContentEditableWarning",
        "suppressHydrationWarning",
        "style"
    ];
    reservedProps.forEach(function(name) {
        properties[name] = new PropertyInfoRecord(name, RESERVED, false, name, null, false, false);
    }); // A few React string attributes have a different name.
    // This is a mapping from React prop names to the attribute names.
    [
        [
            "acceptCharset",
            "accept-charset"
        ],
        [
            "className",
            "class"
        ],
        [
            "htmlFor",
            "for"
        ],
        [
            "httpEquiv",
            "http-equiv"
        ]
    ].forEach(function(_ref) {
        var name = _ref[0], attributeName = _ref[1];
        properties[name] = new PropertyInfoRecord(name, STRING, false, attributeName, null, false, false);
    }); // These are "enumerated" HTML attributes that accept "true" and "false".
    // In React, we let users pass `true` and `false` even though technically
    // these aren't boolean attributes (they are coerced to strings).
    [
        "contentEditable",
        "draggable",
        "spellCheck",
        "value"
    ].forEach(function(name) {
        properties[name] = new PropertyInfoRecord(name, BOOLEANISH_STRING, false, name.toLowerCase(), null, false, false);
    }); // These are "enumerated" SVG attributes that accept "true" and "false".
    // In React, we let users pass `true` and `false` even though technically
    // these aren't boolean attributes (they are coerced to strings).
    // Since these are SVG attributes, their attribute names are case-sensitive.
    [
        "autoReverse",
        "externalResourcesRequired",
        "focusable",
        "preserveAlpha"
    ].forEach(function(name) {
        properties[name] = new PropertyInfoRecord(name, BOOLEANISH_STRING, false, name, null, false, false);
    }); // These are HTML boolean attributes.
    [
        "allowFullScreen",
        "async",
        // on the client side because the browsers are inconsistent. Instead we call focus().
        "autoFocus",
        "autoPlay",
        "controls",
        "default",
        "defer",
        "disabled",
        "disablePictureInPicture",
        "disableRemotePlayback",
        "formNoValidate",
        "hidden",
        "loop",
        "noModule",
        "noValidate",
        "open",
        "playsInline",
        "readOnly",
        "required",
        "reversed",
        "scoped",
        "seamless",
        "itemScope"
    ].forEach(function(name) {
        properties[name] = new PropertyInfoRecord(name, BOOLEAN, false, name.toLowerCase(), null, false, false);
    }); // These are the few React props that we set as DOM properties
    // rather than attributes. These are all booleans.
    [
        "checked",
        // disabled with `removeAttribute`. We have special logic for handling this.
        "multiple",
        "muted",
        "selected" // NOTE: if you add a camelCased prop to this list,
    ].forEach(function(name) {
        properties[name] = new PropertyInfoRecord(name, BOOLEAN, true, name, null, false, false);
    }); // These are HTML attributes that are "overloaded booleans": they behave like
    // booleans, but can also accept a string value.
    [
        "capture",
        "download" // NOTE: if you add a camelCased prop to this list,
    ].forEach(function(name) {
        properties[name] = new PropertyInfoRecord(name, OVERLOADED_BOOLEAN, false, name, null, false, false);
    }); // These are HTML attributes that must be positive numbers.
    [
        "cols",
        "rows",
        "size",
        "span" // NOTE: if you add a camelCased prop to this list,
    ].forEach(function(name) {
        properties[name] = new PropertyInfoRecord(name, POSITIVE_NUMERIC, false, name, null, false, false);
    }); // These are HTML attributes that must be numbers.
    [
        "rowSpan",
        "start"
    ].forEach(function(name) {
        properties[name] = new PropertyInfoRecord(name, NUMERIC, false, name.toLowerCase(), null, false, false);
    });
    var CAMELIZE = /[\-\:]([a-z])/g;
    var capitalize = function(token) {
        return token[1].toUpperCase();
    }; // This is a list of all SVG attributes that need special casing, namespacing,
    // or boolean value assignment. Regular attributes that just accept strings
    // and have the same names are omitted, just like in the HTML attribute filter.
    // Some of these attributes can be hard to find. This list was created by
    // scraping the MDN documentation.
    [
        "accent-height",
        "alignment-baseline",
        "arabic-form",
        "baseline-shift",
        "cap-height",
        "clip-path",
        "clip-rule",
        "color-interpolation",
        "color-interpolation-filters",
        "color-profile",
        "color-rendering",
        "dominant-baseline",
        "enable-background",
        "fill-opacity",
        "fill-rule",
        "flood-color",
        "flood-opacity",
        "font-family",
        "font-size",
        "font-size-adjust",
        "font-stretch",
        "font-style",
        "font-variant",
        "font-weight",
        "glyph-name",
        "glyph-orientation-horizontal",
        "glyph-orientation-vertical",
        "horiz-adv-x",
        "horiz-origin-x",
        "image-rendering",
        "letter-spacing",
        "lighting-color",
        "marker-end",
        "marker-mid",
        "marker-start",
        "overline-position",
        "overline-thickness",
        "paint-order",
        "panose-1",
        "pointer-events",
        "rendering-intent",
        "shape-rendering",
        "stop-color",
        "stop-opacity",
        "strikethrough-position",
        "strikethrough-thickness",
        "stroke-dasharray",
        "stroke-dashoffset",
        "stroke-linecap",
        "stroke-linejoin",
        "stroke-miterlimit",
        "stroke-opacity",
        "stroke-width",
        "text-anchor",
        "text-decoration",
        "text-rendering",
        "underline-position",
        "underline-thickness",
        "unicode-bidi",
        "unicode-range",
        "units-per-em",
        "v-alphabetic",
        "v-hanging",
        "v-ideographic",
        "v-mathematical",
        "vector-effect",
        "vert-adv-y",
        "vert-origin-x",
        "vert-origin-y",
        "word-spacing",
        "writing-mode",
        "xmlns:xlink",
        "x-height" // NOTE: if you add a camelCased prop to this list,
    ].forEach(function(attributeName) {
        var name = attributeName.replace(CAMELIZE, capitalize);
        properties[name] = new PropertyInfoRecord(name, STRING, false, attributeName, null, false, false);
    }); // String SVG attributes with the xlink namespace.
    [
        "xlink:actuate",
        "xlink:arcrole",
        "xlink:role",
        "xlink:show",
        "xlink:title",
        "xlink:type" // NOTE: if you add a camelCased prop to this list,
    ].forEach(function(attributeName) {
        var name = attributeName.replace(CAMELIZE, capitalize);
        properties[name] = new PropertyInfoRecord(name, STRING, false, attributeName, "http://www.w3.org/1999/xlink", false, false);
    }); // String SVG attributes with the xml namespace.
    [
        "xml:base",
        "xml:lang",
        "xml:space" // NOTE: if you add a camelCased prop to this list,
    ].forEach(function(attributeName) {
        var name = attributeName.replace(CAMELIZE, capitalize);
        properties[name] = new PropertyInfoRecord(name, STRING, false, attributeName, "http://www.w3.org/XML/1998/namespace", false, false);
    }); // These attribute exists both in HTML and SVG.
    // The attribute name is case-sensitive in SVG so we can't just use
    // the React name like we do for attributes that exist only in HTML.
    [
        "tabIndex",
        "crossOrigin"
    ].forEach(function(attributeName) {
        properties[attributeName] = new PropertyInfoRecord(attributeName, STRING, false, attributeName.toLowerCase(), null, false, false);
    }); // These attributes accept URLs. These must not allow javascript: URLS.
    // These will also need to accept Trusted Types object in the future.
    var xlinkHref = "xlinkHref";
    properties[xlinkHref] = new PropertyInfoRecord("xlinkHref", STRING, false, "xlink:href", "http://www.w3.org/1999/xlink", true, false);
    [
        "src",
        "href",
        "action",
        "formAction"
    ].forEach(function(attributeName) {
        properties[attributeName] = new PropertyInfoRecord(attributeName, STRING, false, attributeName.toLowerCase(), null, true, true);
    });
    /**
 * CSS properties which accept numbers but are not in units of "px".
 */ var isUnitlessNumber = {
        animationIterationCount: true,
        aspectRatio: true,
        borderImageOutset: true,
        borderImageSlice: true,
        borderImageWidth: true,
        boxFlex: true,
        boxFlexGroup: true,
        boxOrdinalGroup: true,
        columnCount: true,
        columns: true,
        flex: true,
        flexGrow: true,
        flexPositive: true,
        flexShrink: true,
        flexNegative: true,
        flexOrder: true,
        gridArea: true,
        gridRow: true,
        gridRowEnd: true,
        gridRowSpan: true,
        gridRowStart: true,
        gridColumn: true,
        gridColumnEnd: true,
        gridColumnSpan: true,
        gridColumnStart: true,
        fontWeight: true,
        lineClamp: true,
        lineHeight: true,
        opacity: true,
        order: true,
        orphans: true,
        tabSize: true,
        widows: true,
        zIndex: true,
        zoom: true,
        // SVG-related properties
        fillOpacity: true,
        floodOpacity: true,
        stopOpacity: true,
        strokeDasharray: true,
        strokeDashoffset: true,
        strokeMiterlimit: true,
        strokeOpacity: true,
        strokeWidth: true
    };
    /**
 * @param {string} prefix vendor-specific prefix, eg: Webkit
 * @param {string} key style name, eg: transitionDuration
 * @return {string} style name prefixed with `prefix`, properly camelCased, eg:
 * WebkitTransitionDuration
 */ function prefixKey(prefix, key) {
        return prefix + key.charAt(0).toUpperCase() + key.substring(1);
    }
    /**
 * Support style names that may come passed in prefixed by adding permutations
 * of vendor prefixes.
 */ var prefixes = [
        "Webkit",
        "ms",
        "Moz",
        "O"
    ]; // Using Object.keys here, or else the vanilla for-in loop makes IE8 go into an
    // infinite loop, because it iterates over the newly added props too.
    Object.keys(isUnitlessNumber).forEach(function(prop) {
        prefixes.forEach(function(prefix) {
            isUnitlessNumber[prefixKey(prefix, prop)] = isUnitlessNumber[prop];
        });
    });
    var hasReadOnlyValue = {
        button: true,
        checkbox: true,
        image: true,
        hidden: true,
        radio: true,
        reset: true,
        submit: true
    };
    function checkControlledValueProps(tagName, props) {
        if (!(hasReadOnlyValue[props.type] || props.onChange || props.onInput || props.readOnly || props.disabled || props.value == null)) error("You provided a `value` prop to a form field without an `onChange` handler. This will render a read-only field. If the field should be mutable use `defaultValue`. Otherwise, set either `onChange` or `readOnly`.");
        if (!(props.onChange || props.readOnly || props.disabled || props.checked == null)) error("You provided a `checked` prop to a form field without an `onChange` handler. This will render a read-only field. If the field should be mutable use `defaultChecked`. Otherwise, set either `onChange` or `readOnly`.");
    }
    function isCustomComponent(tagName, props) {
        if (tagName.indexOf("-") === -1) return typeof props.is === "string";
        switch(tagName){
            // These are reserved SVG and MathML elements.
            // We don't mind this list too much because we expect it to never grow.
            // The alternative is to track the namespace in a few places which is convoluted.
            // https://w3c.github.io/webcomponents/spec/custom/#custom-elements-core-concepts
            case "annotation-xml":
            case "color-profile":
            case "font-face":
            case "font-face-src":
            case "font-face-uri":
            case "font-face-format":
            case "font-face-name":
            case "missing-glyph":
                return false;
            default:
                return true;
        }
    }
    var ariaProperties = {
        "aria-current": 0,
        // state
        "aria-description": 0,
        "aria-details": 0,
        "aria-disabled": 0,
        // state
        "aria-hidden": 0,
        // state
        "aria-invalid": 0,
        // state
        "aria-keyshortcuts": 0,
        "aria-label": 0,
        "aria-roledescription": 0,
        // Widget Attributes
        "aria-autocomplete": 0,
        "aria-checked": 0,
        "aria-expanded": 0,
        "aria-haspopup": 0,
        "aria-level": 0,
        "aria-modal": 0,
        "aria-multiline": 0,
        "aria-multiselectable": 0,
        "aria-orientation": 0,
        "aria-placeholder": 0,
        "aria-pressed": 0,
        "aria-readonly": 0,
        "aria-required": 0,
        "aria-selected": 0,
        "aria-sort": 0,
        "aria-valuemax": 0,
        "aria-valuemin": 0,
        "aria-valuenow": 0,
        "aria-valuetext": 0,
        // Live Region Attributes
        "aria-atomic": 0,
        "aria-busy": 0,
        "aria-live": 0,
        "aria-relevant": 0,
        // Drag-and-Drop Attributes
        "aria-dropeffect": 0,
        "aria-grabbed": 0,
        // Relationship Attributes
        "aria-activedescendant": 0,
        "aria-colcount": 0,
        "aria-colindex": 0,
        "aria-colspan": 0,
        "aria-controls": 0,
        "aria-describedby": 0,
        "aria-errormessage": 0,
        "aria-flowto": 0,
        "aria-labelledby": 0,
        "aria-owns": 0,
        "aria-posinset": 0,
        "aria-rowcount": 0,
        "aria-rowindex": 0,
        "aria-rowspan": 0,
        "aria-setsize": 0
    };
    var warnedProperties = {};
    var rARIA = new RegExp("^(aria)-[" + ATTRIBUTE_NAME_CHAR + "]*$");
    var rARIACamel = new RegExp("^(aria)[A-Z][" + ATTRIBUTE_NAME_CHAR + "]*$");
    function validateProperty(tagName, name) {
        if (hasOwnProperty.call(warnedProperties, name) && warnedProperties[name]) return true;
        if (rARIACamel.test(name)) {
            var ariaName = "aria-" + name.slice(4).toLowerCase();
            var correctName = ariaProperties.hasOwnProperty(ariaName) ? ariaName : null; // If this is an aria-* attribute, but is not listed in the known DOM
            // DOM properties, then it is an invalid aria-* attribute.
            if (correctName == null) {
                error("Invalid ARIA attribute `%s`. ARIA attributes follow the pattern aria-* and must be lowercase.", name);
                warnedProperties[name] = true;
                return true;
            } // aria-* attributes should be lowercase; suggest the lowercase version.
            if (name !== correctName) {
                error("Invalid ARIA attribute `%s`. Did you mean `%s`?", name, correctName);
                warnedProperties[name] = true;
                return true;
            }
        }
        if (rARIA.test(name)) {
            var lowerCasedName = name.toLowerCase();
            var standardName = ariaProperties.hasOwnProperty(lowerCasedName) ? lowerCasedName : null; // If this is an aria-* attribute, but is not listed in the known DOM
            // DOM properties, then it is an invalid aria-* attribute.
            if (standardName == null) {
                warnedProperties[name] = true;
                return false;
            } // aria-* attributes should be lowercase; suggest the lowercase version.
            if (name !== standardName) {
                error("Unknown ARIA attribute `%s`. Did you mean `%s`?", name, standardName);
                warnedProperties[name] = true;
                return true;
            }
        }
        return true;
    }
    function warnInvalidARIAProps(type, props) {
        var invalidProps = [];
        for(var key in props){
            var isValid = validateProperty(type, key);
            if (!isValid) invalidProps.push(key);
        }
        var unknownPropString = invalidProps.map(function(prop) {
            return "`" + prop + "`";
        }).join(", ");
        if (invalidProps.length === 1) error("Invalid aria prop %s on <%s> tag. For details, see https://reactjs.org/link/invalid-aria-props", unknownPropString, type);
        else if (invalidProps.length > 1) error("Invalid aria props %s on <%s> tag. For details, see https://reactjs.org/link/invalid-aria-props", unknownPropString, type);
    }
    function validateProperties(type, props) {
        if (isCustomComponent(type, props)) return;
        warnInvalidARIAProps(type, props);
    }
    var didWarnValueNull = false;
    function validateProperties$1(type, props) {
        if (type !== "input" && type !== "textarea" && type !== "select") return;
        if (props != null && props.value === null && !didWarnValueNull) {
            didWarnValueNull = true;
            if (type === "select" && props.multiple) error("`value` prop on `%s` should not be null. Consider using an empty array when `multiple` is set to `true` to clear the component or `undefined` for uncontrolled components.", type);
            else error("`value` prop on `%s` should not be null. Consider using an empty string to clear the component or `undefined` for uncontrolled components.", type);
        }
    }
    // When adding attributes to the HTML or SVG allowed attribute list, be sure to
    // also add them to this module to ensure casing and incorrect name
    // warnings.
    var possibleStandardNames = {
        // HTML
        accept: "accept",
        acceptcharset: "acceptCharset",
        "accept-charset": "acceptCharset",
        accesskey: "accessKey",
        action: "action",
        allowfullscreen: "allowFullScreen",
        alt: "alt",
        as: "as",
        async: "async",
        autocapitalize: "autoCapitalize",
        autocomplete: "autoComplete",
        autocorrect: "autoCorrect",
        autofocus: "autoFocus",
        autoplay: "autoPlay",
        autosave: "autoSave",
        capture: "capture",
        cellpadding: "cellPadding",
        cellspacing: "cellSpacing",
        challenge: "challenge",
        charset: "charSet",
        checked: "checked",
        children: "children",
        cite: "cite",
        class: "className",
        classid: "classID",
        classname: "className",
        cols: "cols",
        colspan: "colSpan",
        content: "content",
        contenteditable: "contentEditable",
        contextmenu: "contextMenu",
        controls: "controls",
        controlslist: "controlsList",
        coords: "coords",
        crossorigin: "crossOrigin",
        dangerouslysetinnerhtml: "dangerouslySetInnerHTML",
        data: "data",
        datetime: "dateTime",
        default: "default",
        defaultchecked: "defaultChecked",
        defaultvalue: "defaultValue",
        defer: "defer",
        dir: "dir",
        disabled: "disabled",
        disablepictureinpicture: "disablePictureInPicture",
        disableremoteplayback: "disableRemotePlayback",
        download: "download",
        draggable: "draggable",
        enctype: "encType",
        enterkeyhint: "enterKeyHint",
        for: "htmlFor",
        form: "form",
        formmethod: "formMethod",
        formaction: "formAction",
        formenctype: "formEncType",
        formnovalidate: "formNoValidate",
        formtarget: "formTarget",
        frameborder: "frameBorder",
        headers: "headers",
        height: "height",
        hidden: "hidden",
        high: "high",
        href: "href",
        hreflang: "hrefLang",
        htmlfor: "htmlFor",
        httpequiv: "httpEquiv",
        "http-equiv": "httpEquiv",
        icon: "icon",
        id: "id",
        imagesizes: "imageSizes",
        imagesrcset: "imageSrcSet",
        innerhtml: "innerHTML",
        inputmode: "inputMode",
        integrity: "integrity",
        is: "is",
        itemid: "itemID",
        itemprop: "itemProp",
        itemref: "itemRef",
        itemscope: "itemScope",
        itemtype: "itemType",
        keyparams: "keyParams",
        keytype: "keyType",
        kind: "kind",
        label: "label",
        lang: "lang",
        list: "list",
        loop: "loop",
        low: "low",
        manifest: "manifest",
        marginwidth: "marginWidth",
        marginheight: "marginHeight",
        max: "max",
        maxlength: "maxLength",
        media: "media",
        mediagroup: "mediaGroup",
        method: "method",
        min: "min",
        minlength: "minLength",
        multiple: "multiple",
        muted: "muted",
        name: "name",
        nomodule: "noModule",
        nonce: "nonce",
        novalidate: "noValidate",
        open: "open",
        optimum: "optimum",
        pattern: "pattern",
        placeholder: "placeholder",
        playsinline: "playsInline",
        poster: "poster",
        preload: "preload",
        profile: "profile",
        radiogroup: "radioGroup",
        readonly: "readOnly",
        referrerpolicy: "referrerPolicy",
        rel: "rel",
        required: "required",
        reversed: "reversed",
        role: "role",
        rows: "rows",
        rowspan: "rowSpan",
        sandbox: "sandbox",
        scope: "scope",
        scoped: "scoped",
        scrolling: "scrolling",
        seamless: "seamless",
        selected: "selected",
        shape: "shape",
        size: "size",
        sizes: "sizes",
        span: "span",
        spellcheck: "spellCheck",
        src: "src",
        srcdoc: "srcDoc",
        srclang: "srcLang",
        srcset: "srcSet",
        start: "start",
        step: "step",
        style: "style",
        summary: "summary",
        tabindex: "tabIndex",
        target: "target",
        title: "title",
        type: "type",
        usemap: "useMap",
        value: "value",
        width: "width",
        wmode: "wmode",
        wrap: "wrap",
        // SVG
        about: "about",
        accentheight: "accentHeight",
        "accent-height": "accentHeight",
        accumulate: "accumulate",
        additive: "additive",
        alignmentbaseline: "alignmentBaseline",
        "alignment-baseline": "alignmentBaseline",
        allowreorder: "allowReorder",
        alphabetic: "alphabetic",
        amplitude: "amplitude",
        arabicform: "arabicForm",
        "arabic-form": "arabicForm",
        ascent: "ascent",
        attributename: "attributeName",
        attributetype: "attributeType",
        autoreverse: "autoReverse",
        azimuth: "azimuth",
        basefrequency: "baseFrequency",
        baselineshift: "baselineShift",
        "baseline-shift": "baselineShift",
        baseprofile: "baseProfile",
        bbox: "bbox",
        begin: "begin",
        bias: "bias",
        by: "by",
        calcmode: "calcMode",
        capheight: "capHeight",
        "cap-height": "capHeight",
        clip: "clip",
        clippath: "clipPath",
        "clip-path": "clipPath",
        clippathunits: "clipPathUnits",
        cliprule: "clipRule",
        "clip-rule": "clipRule",
        color: "color",
        colorinterpolation: "colorInterpolation",
        "color-interpolation": "colorInterpolation",
        colorinterpolationfilters: "colorInterpolationFilters",
        "color-interpolation-filters": "colorInterpolationFilters",
        colorprofile: "colorProfile",
        "color-profile": "colorProfile",
        colorrendering: "colorRendering",
        "color-rendering": "colorRendering",
        contentscripttype: "contentScriptType",
        contentstyletype: "contentStyleType",
        cursor: "cursor",
        cx: "cx",
        cy: "cy",
        d: "d",
        datatype: "datatype",
        decelerate: "decelerate",
        descent: "descent",
        diffuseconstant: "diffuseConstant",
        direction: "direction",
        display: "display",
        divisor: "divisor",
        dominantbaseline: "dominantBaseline",
        "dominant-baseline": "dominantBaseline",
        dur: "dur",
        dx: "dx",
        dy: "dy",
        edgemode: "edgeMode",
        elevation: "elevation",
        enablebackground: "enableBackground",
        "enable-background": "enableBackground",
        end: "end",
        exponent: "exponent",
        externalresourcesrequired: "externalResourcesRequired",
        fill: "fill",
        fillopacity: "fillOpacity",
        "fill-opacity": "fillOpacity",
        fillrule: "fillRule",
        "fill-rule": "fillRule",
        filter: "filter",
        filterres: "filterRes",
        filterunits: "filterUnits",
        floodopacity: "floodOpacity",
        "flood-opacity": "floodOpacity",
        floodcolor: "floodColor",
        "flood-color": "floodColor",
        focusable: "focusable",
        fontfamily: "fontFamily",
        "font-family": "fontFamily",
        fontsize: "fontSize",
        "font-size": "fontSize",
        fontsizeadjust: "fontSizeAdjust",
        "font-size-adjust": "fontSizeAdjust",
        fontstretch: "fontStretch",
        "font-stretch": "fontStretch",
        fontstyle: "fontStyle",
        "font-style": "fontStyle",
        fontvariant: "fontVariant",
        "font-variant": "fontVariant",
        fontweight: "fontWeight",
        "font-weight": "fontWeight",
        format: "format",
        from: "from",
        fx: "fx",
        fy: "fy",
        g1: "g1",
        g2: "g2",
        glyphname: "glyphName",
        "glyph-name": "glyphName",
        glyphorientationhorizontal: "glyphOrientationHorizontal",
        "glyph-orientation-horizontal": "glyphOrientationHorizontal",
        glyphorientationvertical: "glyphOrientationVertical",
        "glyph-orientation-vertical": "glyphOrientationVertical",
        glyphref: "glyphRef",
        gradienttransform: "gradientTransform",
        gradientunits: "gradientUnits",
        hanging: "hanging",
        horizadvx: "horizAdvX",
        "horiz-adv-x": "horizAdvX",
        horizoriginx: "horizOriginX",
        "horiz-origin-x": "horizOriginX",
        ideographic: "ideographic",
        imagerendering: "imageRendering",
        "image-rendering": "imageRendering",
        in2: "in2",
        in: "in",
        inlist: "inlist",
        intercept: "intercept",
        k1: "k1",
        k2: "k2",
        k3: "k3",
        k4: "k4",
        k: "k",
        kernelmatrix: "kernelMatrix",
        kernelunitlength: "kernelUnitLength",
        kerning: "kerning",
        keypoints: "keyPoints",
        keysplines: "keySplines",
        keytimes: "keyTimes",
        lengthadjust: "lengthAdjust",
        letterspacing: "letterSpacing",
        "letter-spacing": "letterSpacing",
        lightingcolor: "lightingColor",
        "lighting-color": "lightingColor",
        limitingconeangle: "limitingConeAngle",
        local: "local",
        markerend: "markerEnd",
        "marker-end": "markerEnd",
        markerheight: "markerHeight",
        markermid: "markerMid",
        "marker-mid": "markerMid",
        markerstart: "markerStart",
        "marker-start": "markerStart",
        markerunits: "markerUnits",
        markerwidth: "markerWidth",
        mask: "mask",
        maskcontentunits: "maskContentUnits",
        maskunits: "maskUnits",
        mathematical: "mathematical",
        mode: "mode",
        numoctaves: "numOctaves",
        offset: "offset",
        opacity: "opacity",
        operator: "operator",
        order: "order",
        orient: "orient",
        orientation: "orientation",
        origin: "origin",
        overflow: "overflow",
        overlineposition: "overlinePosition",
        "overline-position": "overlinePosition",
        overlinethickness: "overlineThickness",
        "overline-thickness": "overlineThickness",
        paintorder: "paintOrder",
        "paint-order": "paintOrder",
        panose1: "panose1",
        "panose-1": "panose1",
        pathlength: "pathLength",
        patterncontentunits: "patternContentUnits",
        patterntransform: "patternTransform",
        patternunits: "patternUnits",
        pointerevents: "pointerEvents",
        "pointer-events": "pointerEvents",
        points: "points",
        pointsatx: "pointsAtX",
        pointsaty: "pointsAtY",
        pointsatz: "pointsAtZ",
        prefix: "prefix",
        preservealpha: "preserveAlpha",
        preserveaspectratio: "preserveAspectRatio",
        primitiveunits: "primitiveUnits",
        property: "property",
        r: "r",
        radius: "radius",
        refx: "refX",
        refy: "refY",
        renderingintent: "renderingIntent",
        "rendering-intent": "renderingIntent",
        repeatcount: "repeatCount",
        repeatdur: "repeatDur",
        requiredextensions: "requiredExtensions",
        requiredfeatures: "requiredFeatures",
        resource: "resource",
        restart: "restart",
        result: "result",
        results: "results",
        rotate: "rotate",
        rx: "rx",
        ry: "ry",
        scale: "scale",
        security: "security",
        seed: "seed",
        shaperendering: "shapeRendering",
        "shape-rendering": "shapeRendering",
        slope: "slope",
        spacing: "spacing",
        specularconstant: "specularConstant",
        specularexponent: "specularExponent",
        speed: "speed",
        spreadmethod: "spreadMethod",
        startoffset: "startOffset",
        stddeviation: "stdDeviation",
        stemh: "stemh",
        stemv: "stemv",
        stitchtiles: "stitchTiles",
        stopcolor: "stopColor",
        "stop-color": "stopColor",
        stopopacity: "stopOpacity",
        "stop-opacity": "stopOpacity",
        strikethroughposition: "strikethroughPosition",
        "strikethrough-position": "strikethroughPosition",
        strikethroughthickness: "strikethroughThickness",
        "strikethrough-thickness": "strikethroughThickness",
        string: "string",
        stroke: "stroke",
        strokedasharray: "strokeDasharray",
        "stroke-dasharray": "strokeDasharray",
        strokedashoffset: "strokeDashoffset",
        "stroke-dashoffset": "strokeDashoffset",
        strokelinecap: "strokeLinecap",
        "stroke-linecap": "strokeLinecap",
        strokelinejoin: "strokeLinejoin",
        "stroke-linejoin": "strokeLinejoin",
        strokemiterlimit: "strokeMiterlimit",
        "stroke-miterlimit": "strokeMiterlimit",
        strokewidth: "strokeWidth",
        "stroke-width": "strokeWidth",
        strokeopacity: "strokeOpacity",
        "stroke-opacity": "strokeOpacity",
        suppresscontenteditablewarning: "suppressContentEditableWarning",
        suppresshydrationwarning: "suppressHydrationWarning",
        surfacescale: "surfaceScale",
        systemlanguage: "systemLanguage",
        tablevalues: "tableValues",
        targetx: "targetX",
        targety: "targetY",
        textanchor: "textAnchor",
        "text-anchor": "textAnchor",
        textdecoration: "textDecoration",
        "text-decoration": "textDecoration",
        textlength: "textLength",
        textrendering: "textRendering",
        "text-rendering": "textRendering",
        to: "to",
        transform: "transform",
        typeof: "typeof",
        u1: "u1",
        u2: "u2",
        underlineposition: "underlinePosition",
        "underline-position": "underlinePosition",
        underlinethickness: "underlineThickness",
        "underline-thickness": "underlineThickness",
        unicode: "unicode",
        unicodebidi: "unicodeBidi",
        "unicode-bidi": "unicodeBidi",
        unicoderange: "unicodeRange",
        "unicode-range": "unicodeRange",
        unitsperem: "unitsPerEm",
        "units-per-em": "unitsPerEm",
        unselectable: "unselectable",
        valphabetic: "vAlphabetic",
        "v-alphabetic": "vAlphabetic",
        values: "values",
        vectoreffect: "vectorEffect",
        "vector-effect": "vectorEffect",
        version: "version",
        vertadvy: "vertAdvY",
        "vert-adv-y": "vertAdvY",
        vertoriginx: "vertOriginX",
        "vert-origin-x": "vertOriginX",
        vertoriginy: "vertOriginY",
        "vert-origin-y": "vertOriginY",
        vhanging: "vHanging",
        "v-hanging": "vHanging",
        videographic: "vIdeographic",
        "v-ideographic": "vIdeographic",
        viewbox: "viewBox",
        viewtarget: "viewTarget",
        visibility: "visibility",
        vmathematical: "vMathematical",
        "v-mathematical": "vMathematical",
        vocab: "vocab",
        widths: "widths",
        wordspacing: "wordSpacing",
        "word-spacing": "wordSpacing",
        writingmode: "writingMode",
        "writing-mode": "writingMode",
        x1: "x1",
        x2: "x2",
        x: "x",
        xchannelselector: "xChannelSelector",
        xheight: "xHeight",
        "x-height": "xHeight",
        xlinkactuate: "xlinkActuate",
        "xlink:actuate": "xlinkActuate",
        xlinkarcrole: "xlinkArcrole",
        "xlink:arcrole": "xlinkArcrole",
        xlinkhref: "xlinkHref",
        "xlink:href": "xlinkHref",
        xlinkrole: "xlinkRole",
        "xlink:role": "xlinkRole",
        xlinkshow: "xlinkShow",
        "xlink:show": "xlinkShow",
        xlinktitle: "xlinkTitle",
        "xlink:title": "xlinkTitle",
        xlinktype: "xlinkType",
        "xlink:type": "xlinkType",
        xmlbase: "xmlBase",
        "xml:base": "xmlBase",
        xmllang: "xmlLang",
        "xml:lang": "xmlLang",
        xmlns: "xmlns",
        "xml:space": "xmlSpace",
        xmlnsxlink: "xmlnsXlink",
        "xmlns:xlink": "xmlnsXlink",
        xmlspace: "xmlSpace",
        y1: "y1",
        y2: "y2",
        y: "y",
        ychannelselector: "yChannelSelector",
        z: "z",
        zoomandpan: "zoomAndPan"
    };
    var validateProperty$1 = function() {};
    var warnedProperties$1 = {};
    var EVENT_NAME_REGEX = /^on./;
    var INVALID_EVENT_NAME_REGEX = /^on[^A-Z]/;
    var rARIA$1 = new RegExp("^(aria)-[" + ATTRIBUTE_NAME_CHAR + "]*$");
    var rARIACamel$1 = new RegExp("^(aria)[A-Z][" + ATTRIBUTE_NAME_CHAR + "]*$");
    validateProperty$1 = function(tagName, name, value, eventRegistry) {
        if (hasOwnProperty.call(warnedProperties$1, name) && warnedProperties$1[name]) return true;
        var lowerCasedName = name.toLowerCase();
        if (lowerCasedName === "onfocusin" || lowerCasedName === "onfocusout") {
            error("React uses onFocus and onBlur instead of onFocusIn and onFocusOut. All React events are normalized to bubble, so onFocusIn and onFocusOut are not needed/supported by React.");
            warnedProperties$1[name] = true;
            return true;
        } // We can't rely on the event system being injected on the server.
        if (eventRegistry != null) {
            var registrationNameDependencies = eventRegistry.registrationNameDependencies, possibleRegistrationNames = eventRegistry.possibleRegistrationNames;
            if (registrationNameDependencies.hasOwnProperty(name)) return true;
            var registrationName = possibleRegistrationNames.hasOwnProperty(lowerCasedName) ? possibleRegistrationNames[lowerCasedName] : null;
            if (registrationName != null) {
                error("Invalid event handler property `%s`. Did you mean `%s`?", name, registrationName);
                warnedProperties$1[name] = true;
                return true;
            }
            if (EVENT_NAME_REGEX.test(name)) {
                error("Unknown event handler property `%s`. It will be ignored.", name);
                warnedProperties$1[name] = true;
                return true;
            }
        } else if (EVENT_NAME_REGEX.test(name)) {
            // If no event plugins have been injected, we are in a server environment.
            // So we can't tell if the event name is correct for sure, but we can filter
            // out known bad ones like `onclick`. We can't suggest a specific replacement though.
            if (INVALID_EVENT_NAME_REGEX.test(name)) error("Invalid event handler property `%s`. React events use the camelCase naming convention, for example `onClick`.", name);
            warnedProperties$1[name] = true;
            return true;
        } // Let the ARIA attribute hook validate ARIA attributes
        if (rARIA$1.test(name) || rARIACamel$1.test(name)) return true;
        if (lowerCasedName === "innerhtml") {
            error("Directly setting property `innerHTML` is not permitted. For more information, lookup documentation on `dangerouslySetInnerHTML`.");
            warnedProperties$1[name] = true;
            return true;
        }
        if (lowerCasedName === "aria") {
            error("The `aria` attribute is reserved for future use in React. Pass individual `aria-` attributes instead.");
            warnedProperties$1[name] = true;
            return true;
        }
        if (lowerCasedName === "is" && value !== null && value !== undefined && typeof value !== "string") {
            error("Received a `%s` for a string attribute `is`. If this is expected, cast the value to a string.", typeof value);
            warnedProperties$1[name] = true;
            return true;
        }
        if (typeof value === "number" && isNaN(value)) {
            error("Received NaN for the `%s` attribute. If this is expected, cast the value to a string.", name);
            warnedProperties$1[name] = true;
            return true;
        }
        var propertyInfo = getPropertyInfo(name);
        var isReserved = propertyInfo !== null && propertyInfo.type === RESERVED; // Known attributes should match the casing specified in the property config.
        if (possibleStandardNames.hasOwnProperty(lowerCasedName)) {
            var standardName = possibleStandardNames[lowerCasedName];
            if (standardName !== name) {
                error("Invalid DOM property `%s`. Did you mean `%s`?", name, standardName);
                warnedProperties$1[name] = true;
                return true;
            }
        } else if (!isReserved && name !== lowerCasedName) {
            // Unknown attributes should have lowercase casing since that's how they
            // will be cased anyway with server rendering.
            error("React does not recognize the `%s` prop on a DOM element. If you intentionally want it to appear in the DOM as a custom attribute, spell it as lowercase `%s` instead. If you accidentally passed it from a parent component, remove it from the DOM element.", name, lowerCasedName);
            warnedProperties$1[name] = true;
            return true;
        }
        if (typeof value === "boolean" && shouldRemoveAttributeWithWarning(name, value, propertyInfo, false)) {
            if (value) error('Received `%s` for a non-boolean attribute `%s`.\n\nIf you want to write it to the DOM, pass a string instead: %s="%s" or %s={value.toString()}.', value, name, name, value, name);
            else error('Received `%s` for a non-boolean attribute `%s`.\n\nIf you want to write it to the DOM, pass a string instead: %s="%s" or %s={value.toString()}.\n\nIf you used to conditionally omit it with %s={condition && value}, pass %s={condition ? value : undefined} instead.', value, name, name, value, name, name, name);
            warnedProperties$1[name] = true;
            return true;
        } // Now that we've validated casing, do not validate
        // data types for reserved props
        if (isReserved) return true;
         // Warn when a known attribute is a bad type
        if (shouldRemoveAttributeWithWarning(name, value, propertyInfo, false)) {
            warnedProperties$1[name] = true;
            return false;
        } // Warn when passing the strings 'false' or 'true' into a boolean prop
        if ((value === "false" || value === "true") && propertyInfo !== null && propertyInfo.type === BOOLEAN) {
            error("Received the string `%s` for the boolean attribute `%s`. %s Did you mean %s={%s}?", value, name, value === "false" ? "The browser will interpret it as a truthy value." : 'Although this works, it will not work as expected if you pass the string "false".', name, value);
            warnedProperties$1[name] = true;
            return true;
        }
        return true;
    };
    var warnUnknownProperties = function(type, props, eventRegistry) {
        var unknownProps = [];
        for(var key in props){
            var isValid = validateProperty$1(type, key, props[key], eventRegistry);
            if (!isValid) unknownProps.push(key);
        }
        var unknownPropString = unknownProps.map(function(prop) {
            return "`" + prop + "`";
        }).join(", ");
        if (unknownProps.length === 1) error("Invalid value for prop %s on <%s> tag. Either remove it from the element, or pass a string or number value to keep it in the DOM. For details, see https://reactjs.org/link/attribute-behavior ", unknownPropString, type);
        else if (unknownProps.length > 1) error("Invalid values for props %s on <%s> tag. Either remove them from the element, or pass a string or number value to keep them in the DOM. For details, see https://reactjs.org/link/attribute-behavior ", unknownPropString, type);
    };
    function validateProperties$2(type, props, eventRegistry) {
        if (isCustomComponent(type, props)) return;
        warnUnknownProperties(type, props, eventRegistry);
    }
    var warnValidStyle = function() {};
    // 'msTransform' is correct, but the other prefixes should be capitalized
    var badVendoredStyleNamePattern = /^(?:webkit|moz|o)[A-Z]/;
    var msPattern = /^-ms-/;
    var hyphenPattern = /-(.)/g; // style values shouldn't contain a semicolon
    var badStyleValueWithSemicolonPattern = /;\s*$/;
    var warnedStyleNames = {};
    var warnedStyleValues = {};
    var warnedForNaNValue = false;
    var warnedForInfinityValue = false;
    var camelize = function(string) {
        return string.replace(hyphenPattern, function(_, character) {
            return character.toUpperCase();
        });
    };
    var warnHyphenatedStyleName = function(name) {
        if (warnedStyleNames.hasOwnProperty(name) && warnedStyleNames[name]) return;
        warnedStyleNames[name] = true;
        error("Unsupported style property %s. Did you mean %s?", name, // (http://www.andismith.com/blog/2012/02/modernizr-prefixed/), an `-ms` prefix
        // is converted to lowercase `ms`.
        camelize(name.replace(msPattern, "ms-")));
    };
    var warnBadVendoredStyleName = function(name) {
        if (warnedStyleNames.hasOwnProperty(name) && warnedStyleNames[name]) return;
        warnedStyleNames[name] = true;
        error("Unsupported vendor-prefixed style property %s. Did you mean %s?", name, name.charAt(0).toUpperCase() + name.slice(1));
    };
    var warnStyleValueWithSemicolon = function(name, value) {
        if (warnedStyleValues.hasOwnProperty(value) && warnedStyleValues[value]) return;
        warnedStyleValues[value] = true;
        error('Style property values shouldn\'t contain a semicolon. Try "%s: %s" instead.', name, value.replace(badStyleValueWithSemicolonPattern, ""));
    };
    var warnStyleValueIsNaN = function(name, value) {
        if (warnedForNaNValue) return;
        warnedForNaNValue = true;
        error("`NaN` is an invalid value for the `%s` css style property.", name);
    };
    var warnStyleValueIsInfinity = function(name, value) {
        if (warnedForInfinityValue) return;
        warnedForInfinityValue = true;
        error("`Infinity` is an invalid value for the `%s` css style property.", name);
    };
    warnValidStyle = function(name, value) {
        if (name.indexOf("-") > -1) warnHyphenatedStyleName(name);
        else if (badVendoredStyleNamePattern.test(name)) warnBadVendoredStyleName(name);
        else if (badStyleValueWithSemicolonPattern.test(value)) warnStyleValueWithSemicolon(name, value);
        if (typeof value === "number") {
            if (isNaN(value)) warnStyleValueIsNaN(name, value);
            else if (!isFinite(value)) warnStyleValueIsInfinity(name, value);
        }
    };
    var warnValidStyle$1 = warnValidStyle;
    // code copied and modified from escape-html
    var matchHtmlRegExp = /["'&<>]/;
    /**
 * Escapes special characters and HTML entities in a given html string.
 *
 * @param  {string} string HTML string to escape for later insertion
 * @return {string}
 * @public
 */ function escapeHtml(string) {
        checkHtmlStringCoercion(string);
        var str = "" + string;
        var match = matchHtmlRegExp.exec(str);
        if (!match) return str;
        var escape;
        var html = "";
        var index;
        var lastIndex = 0;
        for(index = match.index; index < str.length; index++){
            switch(str.charCodeAt(index)){
                case 34:
                    // "
                    escape = "&quot;";
                    break;
                case 38:
                    // &
                    escape = "&amp;";
                    break;
                case 39:
                    // '
                    escape = "&#x27;"; // modified from escape-html; used to be '&#39'
                    break;
                case 60:
                    // <
                    escape = "&lt;";
                    break;
                case 62:
                    // >
                    escape = "&gt;";
                    break;
                default:
                    continue;
            }
            if (lastIndex !== index) html += str.substring(lastIndex, index);
            lastIndex = index + 1;
            html += escape;
        }
        return lastIndex !== index ? html + str.substring(lastIndex, index) : html;
    } // end code copied and modified from escape-html
    /**
 * Escapes text to prevent scripting attacks.
 *
 * @param {*} text Text value to escape.
 * @return {string} An escaped string.
 */ function escapeTextForBrowser(text) {
        if (typeof text === "boolean" || typeof text === "number") // this shortcircuit helps perf for types that we know will never have
        // special characters, especially given that this function is used often
        // for numeric dom ids.
        return "" + text;
        return escapeHtml(text);
    }
    var uppercasePattern = /([A-Z])/g;
    var msPattern$1 = /^ms-/;
    /**
 * Hyphenates a camelcased CSS property name, for example:
 *
 *   > hyphenateStyleName('backgroundColor')
 *   < "background-color"
 *   > hyphenateStyleName('MozTransition')
 *   < "-moz-transition"
 *   > hyphenateStyleName('msTransition')
 *   < "-ms-transition"
 *
 * As Modernizr suggests (http://modernizr.com/docs/#prefixed), an `ms` prefix
 * is converted to `-ms-`.
 */ function hyphenateStyleName(name) {
        return name.replace(uppercasePattern, "-$1").toLowerCase().replace(msPattern$1, "-ms-");
    }
    // and any newline or tab are filtered out as if they're not part of the URL.
    // https://url.spec.whatwg.org/#url-parsing
    // Tab or newline are defined as \r\n\t:
    // https://infra.spec.whatwg.org/#ascii-tab-or-newline
    // A C0 control is a code point in the range \u0000 NULL to \u001F
    // INFORMATION SEPARATOR ONE, inclusive:
    // https://infra.spec.whatwg.org/#c0-control-or-space
    /* eslint-disable max-len */ var isJavaScriptProtocol = /^[\u0000-\u001F ]*j[\r\n\t]*a[\r\n\t]*v[\r\n\t]*a[\r\n\t]*s[\r\n\t]*c[\r\n\t]*r[\r\n\t]*i[\r\n\t]*p[\r\n\t]*t[\r\n\t]*\:/i;
    var didWarn = false;
    function sanitizeURL(url) {
        if (!didWarn && isJavaScriptProtocol.test(url)) {
            didWarn = true;
            error("A future version of React will block javascript: URLs as a security precaution. Use event handlers instead if you can. If you need to generate unsafe HTML try using dangerouslySetInnerHTML instead. React was passed %s.", JSON.stringify(url));
        }
    }
    var isArrayImpl = Array.isArray; // eslint-disable-next-line no-redeclare
    function isArray(a) {
        return isArrayImpl(a);
    }
    var startInlineScript = stringToPrecomputedChunk("<script>");
    var endInlineScript = stringToPrecomputedChunk("</script>");
    var startScriptSrc = stringToPrecomputedChunk('<script src="');
    var startModuleSrc = stringToPrecomputedChunk('<script type="module" src="');
    var endAsyncScript = stringToPrecomputedChunk('" async=""></script>');
    /**
 * This escaping function is designed to work with bootstrapScriptContent only.
 * because we know we are escaping the entire script. We can avoid for instance
 * escaping html comment string sequences that are valid javascript as well because
 * if there are no sebsequent <script sequences the html parser will never enter
 * script data double escaped state (see: https://www.w3.org/TR/html53/syntax.html#script-data-double-escaped-state)
 *
 * While untrusted script content should be made safe before using this api it will
 * ensure that the script cannot be early terminated or never terminated state
 */ function escapeBootstrapScriptContent(scriptText) {
        checkHtmlStringCoercion(scriptText);
        return ("" + scriptText).replace(scriptRegex, scriptReplacer);
    }
    var scriptRegex = /(<\/|<)(s)(cript)/gi;
    var scriptReplacer = function(match, prefix, s, suffix) {
        return "" + prefix + (s === "s" ? "\\u0073" : "\\u0053") + suffix;
    }; // Allows us to keep track of what we've already written so we can refer back to it.
    function createResponseState(identifierPrefix, nonce, bootstrapScriptContent, bootstrapScripts, bootstrapModules) {
        var idPrefix = identifierPrefix === undefined ? "" : identifierPrefix;
        var inlineScriptWithNonce = nonce === undefined ? startInlineScript : stringToPrecomputedChunk('<script nonce="' + escapeTextForBrowser(nonce) + '">');
        var bootstrapChunks = [];
        if (bootstrapScriptContent !== undefined) bootstrapChunks.push(inlineScriptWithNonce, stringToChunk(escapeBootstrapScriptContent(bootstrapScriptContent)), endInlineScript);
        if (bootstrapScripts !== undefined) for(var i = 0; i < bootstrapScripts.length; i++)bootstrapChunks.push(startScriptSrc, stringToChunk(escapeTextForBrowser(bootstrapScripts[i])), endAsyncScript);
        if (bootstrapModules !== undefined) for(var _i = 0; _i < bootstrapModules.length; _i++)bootstrapChunks.push(startModuleSrc, stringToChunk(escapeTextForBrowser(bootstrapModules[_i])), endAsyncScript);
        return {
            bootstrapChunks: bootstrapChunks,
            startInlineScript: inlineScriptWithNonce,
            placeholderPrefix: stringToPrecomputedChunk(idPrefix + "P:"),
            segmentPrefix: stringToPrecomputedChunk(idPrefix + "S:"),
            boundaryPrefix: idPrefix + "B:",
            idPrefix: idPrefix,
            nextSuspenseID: 0,
            sentCompleteSegmentFunction: false,
            sentCompleteBoundaryFunction: false,
            sentClientRenderFunction: false
        };
    } // Constants for the insertion mode we're currently writing in. We don't encode all HTML5 insertion
    // modes. We only include the variants as they matter for the sake of our purposes.
    // We don't actually provide the namespace therefore we use constants instead of the string.
    var ROOT_HTML_MODE = 0; // Used for the root most element tag.
    var HTML_MODE = 1;
    var SVG_MODE = 2;
    var MATHML_MODE = 3;
    var HTML_TABLE_MODE = 4;
    var HTML_TABLE_BODY_MODE = 5;
    var HTML_TABLE_ROW_MODE = 6;
    var HTML_COLGROUP_MODE = 7; // We have a greater than HTML_TABLE_MODE check elsewhere. If you add more cases here, make sure it
    // still makes sense
    function createFormatContext(insertionMode, selectedValue) {
        return {
            insertionMode: insertionMode,
            selectedValue: selectedValue
        };
    }
    function createRootFormatContext(namespaceURI) {
        var insertionMode = namespaceURI === "http://www.w3.org/2000/svg" ? SVG_MODE : namespaceURI === "http://www.w3.org/1998/Math/MathML" ? MATHML_MODE : ROOT_HTML_MODE;
        return createFormatContext(insertionMode, null);
    }
    function getChildFormatContext(parentContext, type, props) {
        switch(type){
            case "select":
                return createFormatContext(HTML_MODE, props.value != null ? props.value : props.defaultValue);
            case "svg":
                return createFormatContext(SVG_MODE, null);
            case "math":
                return createFormatContext(MATHML_MODE, null);
            case "foreignObject":
                return createFormatContext(HTML_MODE, null);
            // Table parents are special in that their children can only be created at all if they're
            // wrapped in a table parent. So we need to encode that we're entering this mode.
            case "table":
                return createFormatContext(HTML_TABLE_MODE, null);
            case "thead":
            case "tbody":
            case "tfoot":
                return createFormatContext(HTML_TABLE_BODY_MODE, null);
            case "colgroup":
                return createFormatContext(HTML_COLGROUP_MODE, null);
            case "tr":
                return createFormatContext(HTML_TABLE_ROW_MODE, null);
        }
        if (parentContext.insertionMode >= HTML_TABLE_MODE) // Whatever tag this was, it wasn't a table parent or other special parent, so we must have
        // entered plain HTML again.
        return createFormatContext(HTML_MODE, null);
        if (parentContext.insertionMode === ROOT_HTML_MODE) // We've emitted the root and is now in plain HTML mode.
        return createFormatContext(HTML_MODE, null);
        return parentContext;
    }
    var UNINITIALIZED_SUSPENSE_BOUNDARY_ID = null;
    function assignSuspenseBoundaryID(responseState) {
        var generatedID = responseState.nextSuspenseID++;
        return stringToPrecomputedChunk(responseState.boundaryPrefix + generatedID.toString(16));
    }
    function makeId(responseState, treeId, localId) {
        var idPrefix = responseState.idPrefix;
        var id = ":" + idPrefix + "R" + treeId; // Unless this is the first id at this level, append a number at the end
        // that represents the position of this useId hook among all the useId
        // hooks for this fiber.
        if (localId > 0) id += "H" + localId.toString(32);
        return id + ":";
    }
    function encodeHTMLTextNode(text) {
        return escapeTextForBrowser(text);
    }
    var textSeparator = stringToPrecomputedChunk("<!-- -->");
    function pushTextInstance(target, text, responseState, textEmbedded) {
        if (text === "") // Empty text doesn't have a DOM node representation and the hydration is aware of this.
        return textEmbedded;
        if (textEmbedded) target.push(textSeparator);
        target.push(stringToChunk(encodeHTMLTextNode(text)));
        return true;
    } // Called when Fizz is done with a Segment. Currently the only purpose is to conditionally
    // emit a text separator when we don't know for sure it is safe to omit
    function pushSegmentFinale(target, responseState, lastPushedText, textEmbedded) {
        if (lastPushedText && textEmbedded) target.push(textSeparator);
    }
    var styleNameCache = new Map();
    function processStyleName(styleName) {
        var chunk = styleNameCache.get(styleName);
        if (chunk !== undefined) return chunk;
        var result = stringToPrecomputedChunk(escapeTextForBrowser(hyphenateStyleName(styleName)));
        styleNameCache.set(styleName, result);
        return result;
    }
    var styleAttributeStart = stringToPrecomputedChunk(' style="');
    var styleAssign = stringToPrecomputedChunk(":");
    var styleSeparator = stringToPrecomputedChunk(";");
    function pushStyle(target, responseState, style) {
        if (typeof style !== "object") throw new Error("The `style` prop expects a mapping from style properties to values, not a string. For example, style={{marginRight: spacing + 'em'}} when using JSX.");
        var isFirst = true;
        for(var styleName in style){
            if (!hasOwnProperty.call(style, styleName)) continue;
             // If you provide unsafe user data here they can inject arbitrary CSS
            // which may be problematic (I couldn't repro this):
            // https://www.owasp.org/index.php/XSS_Filter_Evasion_Cheat_Sheet
            // http://www.thespanner.co.uk/2007/11/26/ultimate-xss-css-injection/
            // This is not an XSS hole but instead a potential CSS injection issue
            // which has lead to a greater discussion about how we're going to
            // trust URLs moving forward. See #2115901
            var styleValue = style[styleName];
            if (styleValue == null || typeof styleValue === "boolean" || styleValue === "") continue;
            var nameChunk = void 0;
            var valueChunk = void 0;
            var isCustomProperty = styleName.indexOf("--") === 0;
            if (isCustomProperty) {
                nameChunk = stringToChunk(escapeTextForBrowser(styleName));
                checkCSSPropertyStringCoercion(styleValue, styleName);
                valueChunk = stringToChunk(escapeTextForBrowser(("" + styleValue).trim()));
            } else {
                warnValidStyle$1(styleName, styleValue);
                nameChunk = processStyleName(styleName);
                if (typeof styleValue === "number") {
                    if (styleValue !== 0 && !hasOwnProperty.call(isUnitlessNumber, styleName)) valueChunk = stringToChunk(styleValue + "px"); // Presumes implicit 'px' suffix for unitless numbers
                    else valueChunk = stringToChunk("" + styleValue);
                } else {
                    checkCSSPropertyStringCoercion(styleValue, styleName);
                    valueChunk = stringToChunk(escapeTextForBrowser(("" + styleValue).trim()));
                }
            }
            if (isFirst) {
                isFirst = false; // If it's first, we don't need any separators prefixed.
                target.push(styleAttributeStart, nameChunk, styleAssign, valueChunk);
            } else target.push(styleSeparator, nameChunk, styleAssign, valueChunk);
        }
        if (!isFirst) target.push(attributeEnd);
    }
    var attributeSeparator = stringToPrecomputedChunk(" ");
    var attributeAssign = stringToPrecomputedChunk('="');
    var attributeEnd = stringToPrecomputedChunk('"');
    var attributeEmptyString = stringToPrecomputedChunk('=""');
    function pushAttribute(target, responseState, name, value) {
        switch(name){
            case "style":
                pushStyle(target, responseState, value);
                return;
            case "defaultValue":
            case "defaultChecked":
            case "innerHTML":
            case "suppressContentEditableWarning":
            case "suppressHydrationWarning":
                // Ignored. These are built-in to React on the client.
                return;
        }
        if (// We have already filtered out null/undefined and reserved words.
        name.length > 2 && (name[0] === "o" || name[0] === "O") && (name[1] === "n" || name[1] === "N")) return;
        var propertyInfo = getPropertyInfo(name);
        if (propertyInfo !== null) {
            // shouldRemoveAttribute
            switch(typeof value){
                case "function":
                case "symbol":
                    // eslint-disable-line
                    return;
                case "boolean":
                    if (!propertyInfo.acceptsBooleans) return;
            }
            var attributeName = propertyInfo.attributeName;
            var attributeNameChunk = stringToChunk(attributeName); // TODO: If it's known we can cache the chunk.
            switch(propertyInfo.type){
                case BOOLEAN:
                    if (value) target.push(attributeSeparator, attributeNameChunk, attributeEmptyString);
                    return;
                case OVERLOADED_BOOLEAN:
                    if (value === true) target.push(attributeSeparator, attributeNameChunk, attributeEmptyString);
                    else if (value === false) ;
                    else target.push(attributeSeparator, attributeNameChunk, attributeAssign, stringToChunk(escapeTextForBrowser(value)), attributeEnd);
                    return;
                case NUMERIC:
                    if (!isNaN(value)) target.push(attributeSeparator, attributeNameChunk, attributeAssign, stringToChunk(escapeTextForBrowser(value)), attributeEnd);
                    break;
                case POSITIVE_NUMERIC:
                    if (!isNaN(value) && value >= 1) target.push(attributeSeparator, attributeNameChunk, attributeAssign, stringToChunk(escapeTextForBrowser(value)), attributeEnd);
                    break;
                default:
                    if (propertyInfo.sanitizeURL) {
                        checkAttributeStringCoercion(value, attributeName);
                        value = "" + value;
                        sanitizeURL(value);
                    }
                    target.push(attributeSeparator, attributeNameChunk, attributeAssign, stringToChunk(escapeTextForBrowser(value)), attributeEnd);
            }
        } else if (isAttributeNameSafe(name)) {
            // shouldRemoveAttribute
            switch(typeof value){
                case "function":
                case "symbol":
                    // eslint-disable-line
                    return;
                case "boolean":
                    var prefix = name.toLowerCase().slice(0, 5);
                    if (prefix !== "data-" && prefix !== "aria-") return;
            }
            target.push(attributeSeparator, stringToChunk(name), attributeAssign, stringToChunk(escapeTextForBrowser(value)), attributeEnd);
        }
    }
    var endOfStartTag = stringToPrecomputedChunk(">");
    var endOfStartTagSelfClosing = stringToPrecomputedChunk("/>");
    function pushInnerHTML(target, innerHTML, children) {
        if (innerHTML != null) {
            if (children != null) throw new Error("Can only set one of `children` or `props.dangerouslySetInnerHTML`.");
            if (typeof innerHTML !== "object" || !("__html" in innerHTML)) throw new Error("`props.dangerouslySetInnerHTML` must be in the form `{__html: ...}`. Please visit https://reactjs.org/link/dangerously-set-inner-html for more information.");
            var html = innerHTML.__html;
            if (html !== null && html !== undefined) {
                checkHtmlStringCoercion(html);
                target.push(stringToChunk("" + html));
            }
        }
    } // TODO: Move these to ResponseState so that we warn for every request.
    // It would help debugging in stateful servers (e.g. service worker).
    var didWarnDefaultInputValue = false;
    var didWarnDefaultChecked = false;
    var didWarnDefaultSelectValue = false;
    var didWarnDefaultTextareaValue = false;
    var didWarnInvalidOptionChildren = false;
    var didWarnInvalidOptionInnerHTML = false;
    var didWarnSelectedSetOnOption = false;
    function checkSelectProp(props, propName) {
        var value = props[propName];
        if (value != null) {
            var array = isArray(value);
            if (props.multiple && !array) error("The `%s` prop supplied to <select> must be an array if `multiple` is true.", propName);
            else if (!props.multiple && array) error("The `%s` prop supplied to <select> must be a scalar value if `multiple` is false.", propName);
        }
    }
    function pushStartSelect(target, props, responseState) {
        checkControlledValueProps("select", props);
        checkSelectProp(props, "value");
        checkSelectProp(props, "defaultValue");
        if (props.value !== undefined && props.defaultValue !== undefined && !didWarnDefaultSelectValue) {
            error("Select elements must be either controlled or uncontrolled (specify either the value prop, or the defaultValue prop, but not both). Decide between using a controlled or uncontrolled select element and remove one of these props. More info: https://reactjs.org/link/controlled-components");
            didWarnDefaultSelectValue = true;
        }
        target.push(startChunkForTag("select"));
        var children = null;
        var innerHTML = null;
        for(var propKey in props)if (hasOwnProperty.call(props, propKey)) {
            var propValue = props[propKey];
            if (propValue == null) continue;
            switch(propKey){
                case "children":
                    children = propValue;
                    break;
                case "dangerouslySetInnerHTML":
                    // TODO: This doesn't really make sense for select since it can't use the controlled
                    // value in the innerHTML.
                    innerHTML = propValue;
                    break;
                case "defaultValue":
                case "value":
                    break;
                default:
                    pushAttribute(target, responseState, propKey, propValue);
                    break;
            }
        }
        target.push(endOfStartTag);
        pushInnerHTML(target, innerHTML, children);
        return children;
    }
    function flattenOptionChildren(children) {
        var content = ""; // Flatten children and warn if they aren't strings or numbers;
        // invalid types are ignored.
        React.Children.forEach(children, function(child) {
            if (child == null) return;
            content += child;
            if (!didWarnInvalidOptionChildren && typeof child !== "string" && typeof child !== "number") {
                didWarnInvalidOptionChildren = true;
                error("Cannot infer the option value of complex children. Pass a `value` prop or use a plain string as children to <option>.");
            }
        });
        return content;
    }
    var selectedMarkerAttribute = stringToPrecomputedChunk(' selected=""');
    function pushStartOption(target, props, responseState, formatContext) {
        var selectedValue = formatContext.selectedValue;
        target.push(startChunkForTag("option"));
        var children = null;
        var value = null;
        var selected = null;
        var innerHTML = null;
        for(var propKey in props)if (hasOwnProperty.call(props, propKey)) {
            var propValue = props[propKey];
            if (propValue == null) continue;
            switch(propKey){
                case "children":
                    children = propValue;
                    break;
                case "selected":
                    // ignore
                    selected = propValue;
                    // TODO: Remove support for `selected` in <option>.
                    if (!didWarnSelectedSetOnOption) {
                        error("Use the `defaultValue` or `value` props on <select> instead of setting `selected` on <option>.");
                        didWarnSelectedSetOnOption = true;
                    }
                    break;
                case "dangerouslySetInnerHTML":
                    innerHTML = propValue;
                    break;
                // eslint-disable-next-line-no-fallthrough
                case "value":
                    value = propValue;
                // We intentionally fallthrough to also set the attribute on the node.
                // eslint-disable-next-line-no-fallthrough
                default:
                    pushAttribute(target, responseState, propKey, propValue);
                    break;
            }
        }
        if (selectedValue != null) {
            var stringValue;
            if (value !== null) {
                checkAttributeStringCoercion(value, "value");
                stringValue = "" + value;
            } else {
                if (innerHTML !== null) {
                    if (!didWarnInvalidOptionInnerHTML) {
                        didWarnInvalidOptionInnerHTML = true;
                        error("Pass a `value` prop if you set dangerouslyInnerHTML so React knows which value should be selected.");
                    }
                }
                stringValue = flattenOptionChildren(children);
            }
            if (isArray(selectedValue)) // multiple
            for(var i = 0; i < selectedValue.length; i++){
                checkAttributeStringCoercion(selectedValue[i], "value");
                var v = "" + selectedValue[i];
                if (v === stringValue) {
                    target.push(selectedMarkerAttribute);
                    break;
                }
            }
            else {
                checkAttributeStringCoercion(selectedValue, "select.value");
                if ("" + selectedValue === stringValue) target.push(selectedMarkerAttribute);
            }
        } else if (selected) target.push(selectedMarkerAttribute);
        target.push(endOfStartTag);
        pushInnerHTML(target, innerHTML, children);
        return children;
    }
    function pushInput(target, props, responseState) {
        checkControlledValueProps("input", props);
        if (props.checked !== undefined && props.defaultChecked !== undefined && !didWarnDefaultChecked) {
            error("%s contains an input of type %s with both checked and defaultChecked props. Input elements must be either controlled or uncontrolled (specify either the checked prop, or the defaultChecked prop, but not both). Decide between using a controlled or uncontrolled input element and remove one of these props. More info: https://reactjs.org/link/controlled-components", "A component", props.type);
            didWarnDefaultChecked = true;
        }
        if (props.value !== undefined && props.defaultValue !== undefined && !didWarnDefaultInputValue) {
            error("%s contains an input of type %s with both value and defaultValue props. Input elements must be either controlled or uncontrolled (specify either the value prop, or the defaultValue prop, but not both). Decide between using a controlled or uncontrolled input element and remove one of these props. More info: https://reactjs.org/link/controlled-components", "A component", props.type);
            didWarnDefaultInputValue = true;
        }
        target.push(startChunkForTag("input"));
        var value = null;
        var defaultValue = null;
        var checked = null;
        var defaultChecked = null;
        for(var propKey in props)if (hasOwnProperty.call(props, propKey)) {
            var propValue = props[propKey];
            if (propValue == null) continue;
            switch(propKey){
                case "children":
                case "dangerouslySetInnerHTML":
                    throw new Error("input is a self-closing tag and must neither have `children` nor use `dangerouslySetInnerHTML`.");
                // eslint-disable-next-line-no-fallthrough
                case "defaultChecked":
                    defaultChecked = propValue;
                    break;
                case "defaultValue":
                    defaultValue = propValue;
                    break;
                case "checked":
                    checked = propValue;
                    break;
                case "value":
                    value = propValue;
                    break;
                default:
                    pushAttribute(target, responseState, propKey, propValue);
                    break;
            }
        }
        if (checked !== null) pushAttribute(target, responseState, "checked", checked);
        else if (defaultChecked !== null) pushAttribute(target, responseState, "checked", defaultChecked);
        if (value !== null) pushAttribute(target, responseState, "value", value);
        else if (defaultValue !== null) pushAttribute(target, responseState, "value", defaultValue);
        target.push(endOfStartTagSelfClosing);
        return null;
    }
    function pushStartTextArea(target, props, responseState) {
        checkControlledValueProps("textarea", props);
        if (props.value !== undefined && props.defaultValue !== undefined && !didWarnDefaultTextareaValue) {
            error("Textarea elements must be either controlled or uncontrolled (specify either the value prop, or the defaultValue prop, but not both). Decide between using a controlled or uncontrolled textarea and remove one of these props. More info: https://reactjs.org/link/controlled-components");
            didWarnDefaultTextareaValue = true;
        }
        target.push(startChunkForTag("textarea"));
        var value = null;
        var defaultValue = null;
        var children = null;
        for(var propKey in props)if (hasOwnProperty.call(props, propKey)) {
            var propValue = props[propKey];
            if (propValue == null) continue;
            switch(propKey){
                case "children":
                    children = propValue;
                    break;
                case "value":
                    value = propValue;
                    break;
                case "defaultValue":
                    defaultValue = propValue;
                    break;
                case "dangerouslySetInnerHTML":
                    throw new Error("`dangerouslySetInnerHTML` does not make sense on <textarea>.");
                // eslint-disable-next-line-no-fallthrough
                default:
                    pushAttribute(target, responseState, propKey, propValue);
                    break;
            }
        }
        if (value === null && defaultValue !== null) value = defaultValue;
        target.push(endOfStartTag); // TODO (yungsters): Remove support for children content in <textarea>.
        if (children != null) {
            error("Use the `defaultValue` or `value` props instead of setting children on <textarea>.");
            if (value != null) throw new Error("If you supply `defaultValue` on a <textarea>, do not pass children.");
            if (isArray(children)) {
                if (children.length > 1) throw new Error("<textarea> can only have at most one child.");
                 // TODO: remove the coercion and the DEV check below because it will
                checkHtmlStringCoercion(children[0]);
                value = "" + children[0];
            }
            checkHtmlStringCoercion(children);
            value = "" + children;
        }
        if (typeof value === "string" && value[0] === "\n") // text/html ignores the first character in these tags if it's a newline
        // Prefer to break application/xml over text/html (for now) by adding
        // a newline specifically to get eaten by the parser. (Alternately for
        // textareas, replacing "^\n" with "\r\n" doesn't get eaten, and the first
        // \r is normalized out by HTMLTextAreaElement#value.)
        // See: <http://www.w3.org/TR/html-polyglot/#newlines-in-textarea-and-pre>
        // See: <http://www.w3.org/TR/html5/syntax.html#element-restrictions>
        // See: <http://www.w3.org/TR/html5/syntax.html#newlines>
        // See: Parsing of "textarea" "listing" and "pre" elements
        //  from <http://www.w3.org/TR/html5/syntax.html#parsing-main-inbody>
        target.push(leadingNewline);
         // ToString and push directly instead of recurse over children.
        // We don't really support complex children in the value anyway.
        // This also currently avoids a trailing comment node which breaks textarea.
        if (value !== null) {
            checkAttributeStringCoercion(value, "value");
            target.push(stringToChunk(encodeHTMLTextNode("" + value)));
        }
        return null;
    }
    function pushSelfClosing(target, props, tag, responseState) {
        target.push(startChunkForTag(tag));
        for(var propKey in props)if (hasOwnProperty.call(props, propKey)) {
            var propValue = props[propKey];
            if (propValue == null) continue;
            switch(propKey){
                case "children":
                case "dangerouslySetInnerHTML":
                    throw new Error(tag + " is a self-closing tag and must neither have `children` nor " + "use `dangerouslySetInnerHTML`.");
                // eslint-disable-next-line-no-fallthrough
                default:
                    pushAttribute(target, responseState, propKey, propValue);
                    break;
            }
        }
        target.push(endOfStartTagSelfClosing);
        return null;
    }
    function pushStartMenuItem(target, props, responseState) {
        target.push(startChunkForTag("menuitem"));
        for(var propKey in props)if (hasOwnProperty.call(props, propKey)) {
            var propValue = props[propKey];
            if (propValue == null) continue;
            switch(propKey){
                case "children":
                case "dangerouslySetInnerHTML":
                    throw new Error("menuitems cannot have `children` nor `dangerouslySetInnerHTML`.");
                // eslint-disable-next-line-no-fallthrough
                default:
                    pushAttribute(target, responseState, propKey, propValue);
                    break;
            }
        }
        target.push(endOfStartTag);
        return null;
    }
    function pushStartTitle(target, props, responseState) {
        target.push(startChunkForTag("title"));
        var children = null;
        for(var propKey in props)if (hasOwnProperty.call(props, propKey)) {
            var propValue = props[propKey];
            if (propValue == null) continue;
            switch(propKey){
                case "children":
                    children = propValue;
                    break;
                case "dangerouslySetInnerHTML":
                    throw new Error("`dangerouslySetInnerHTML` does not make sense on <title>.");
                // eslint-disable-next-line-no-fallthrough
                default:
                    pushAttribute(target, responseState, propKey, propValue);
                    break;
            }
        }
        target.push(endOfStartTag);
        var child = Array.isArray(children) && children.length < 2 ? children[0] || null : children;
        if (Array.isArray(children) && children.length > 1) error("A title element received an array with more than 1 element as children. In browsers title Elements can only have Text Nodes as children. If the children being rendered output more than a single text node in aggregate the browser will display markup and comments as text in the title and hydration will likely fail and fall back to client rendering");
        else if (child != null && child.$$typeof != null) error("A title element received a React element for children. In the browser title Elements can only have Text Nodes as children. If the children being rendered output more than a single text node in aggregate the browser will display markup and comments as text in the title and hydration will likely fail and fall back to client rendering");
        else if (child != null && typeof child !== "string" && typeof child !== "number") error("A title element received a value that was not a string or number for children. In the browser title Elements can only have Text Nodes as children. If the children being rendered output more than a single text node in aggregate the browser will display markup and comments as text in the title and hydration will likely fail and fall back to client rendering");
        return children;
    }
    function pushStartGenericElement(target, props, tag, responseState) {
        target.push(startChunkForTag(tag));
        var children = null;
        var innerHTML = null;
        for(var propKey in props)if (hasOwnProperty.call(props, propKey)) {
            var propValue = props[propKey];
            if (propValue == null) continue;
            switch(propKey){
                case "children":
                    children = propValue;
                    break;
                case "dangerouslySetInnerHTML":
                    innerHTML = propValue;
                    break;
                default:
                    pushAttribute(target, responseState, propKey, propValue);
                    break;
            }
        }
        target.push(endOfStartTag);
        pushInnerHTML(target, innerHTML, children);
        if (typeof children === "string") {
            // Special case children as a string to avoid the unnecessary comment.
            // TODO: Remove this special case after the general optimization is in place.
            target.push(stringToChunk(encodeHTMLTextNode(children)));
            return null;
        }
        return children;
    }
    function pushStartCustomElement(target, props, tag, responseState) {
        target.push(startChunkForTag(tag));
        var children = null;
        var innerHTML = null;
        for(var propKey in props)if (hasOwnProperty.call(props, propKey)) {
            var propValue = props[propKey];
            if (propValue == null) continue;
            switch(propKey){
                case "children":
                    children = propValue;
                    break;
                case "dangerouslySetInnerHTML":
                    innerHTML = propValue;
                    break;
                case "style":
                    pushStyle(target, responseState, propValue);
                    break;
                case "suppressContentEditableWarning":
                case "suppressHydrationWarning":
                    break;
                default:
                    if (isAttributeNameSafe(propKey) && typeof propValue !== "function" && typeof propValue !== "symbol") target.push(attributeSeparator, stringToChunk(propKey), attributeAssign, stringToChunk(escapeTextForBrowser(propValue)), attributeEnd);
                    break;
            }
        }
        target.push(endOfStartTag);
        pushInnerHTML(target, innerHTML, children);
        return children;
    }
    var leadingNewline = stringToPrecomputedChunk("\n");
    function pushStartPreformattedElement(target, props, tag, responseState) {
        target.push(startChunkForTag(tag));
        var children = null;
        var innerHTML = null;
        for(var propKey in props)if (hasOwnProperty.call(props, propKey)) {
            var propValue = props[propKey];
            if (propValue == null) continue;
            switch(propKey){
                case "children":
                    children = propValue;
                    break;
                case "dangerouslySetInnerHTML":
                    innerHTML = propValue;
                    break;
                default:
                    pushAttribute(target, responseState, propKey, propValue);
                    break;
            }
        }
        target.push(endOfStartTag); // text/html ignores the first character in these tags if it's a newline
        // Prefer to break application/xml over text/html (for now) by adding
        // a newline specifically to get eaten by the parser. (Alternately for
        // textareas, replacing "^\n" with "\r\n" doesn't get eaten, and the first
        // \r is normalized out by HTMLTextAreaElement#value.)
        // See: <http://www.w3.org/TR/html-polyglot/#newlines-in-textarea-and-pre>
        // See: <http://www.w3.org/TR/html5/syntax.html#element-restrictions>
        // See: <http://www.w3.org/TR/html5/syntax.html#newlines>
        // See: Parsing of "textarea" "listing" and "pre" elements
        //  from <http://www.w3.org/TR/html5/syntax.html#parsing-main-inbody>
        // TODO: This doesn't deal with the case where the child is an array
        // or component that returns a string.
        if (innerHTML != null) {
            if (children != null) throw new Error("Can only set one of `children` or `props.dangerouslySetInnerHTML`.");
            if (typeof innerHTML !== "object" || !("__html" in innerHTML)) throw new Error("`props.dangerouslySetInnerHTML` must be in the form `{__html: ...}`. Please visit https://reactjs.org/link/dangerously-set-inner-html for more information.");
            var html = innerHTML.__html;
            if (html !== null && html !== undefined) {
                if (typeof html === "string" && html.length > 0 && html[0] === "\n") target.push(leadingNewline, stringToChunk(html));
                else {
                    checkHtmlStringCoercion(html);
                    target.push(stringToChunk("" + html));
                }
            }
        }
        if (typeof children === "string" && children[0] === "\n") target.push(leadingNewline);
        return children;
    } // We accept any tag to be rendered but since this gets injected into arbitrary
    // HTML, we want to make sure that it's a safe tag.
    // http://www.w3.org/TR/REC-xml/#NT-Name
    var VALID_TAG_REGEX = /^[a-zA-Z][a-zA-Z:_\.\-\d]*$/; // Simplified subset
    var validatedTagCache = new Map();
    function startChunkForTag(tag) {
        var tagStartChunk = validatedTagCache.get(tag);
        if (tagStartChunk === undefined) {
            if (!VALID_TAG_REGEX.test(tag)) throw new Error("Invalid tag: " + tag);
            tagStartChunk = stringToPrecomputedChunk("<" + tag);
            validatedTagCache.set(tag, tagStartChunk);
        }
        return tagStartChunk;
    }
    var DOCTYPE = stringToPrecomputedChunk("<!DOCTYPE html>");
    function pushStartInstance(target, type, props, responseState, formatContext) {
        validateProperties(type, props);
        validateProperties$1(type, props);
        validateProperties$2(type, props, null);
        if (!props.suppressContentEditableWarning && props.contentEditable && props.children != null) error("A component is `contentEditable` and contains `children` managed by React. It is now your responsibility to guarantee that none of those nodes are unexpectedly modified or duplicated. This is probably not intentional.");
        if (formatContext.insertionMode !== SVG_MODE && formatContext.insertionMode !== MATHML_MODE) {
            if (type.indexOf("-") === -1 && typeof props.is !== "string" && type.toLowerCase() !== type) error("<%s /> is using incorrect casing. Use PascalCase for React components, or lowercase for HTML elements.", type);
        }
        switch(type){
            // Special tags
            case "select":
                return pushStartSelect(target, props, responseState);
            case "option":
                return pushStartOption(target, props, responseState, formatContext);
            case "textarea":
                return pushStartTextArea(target, props, responseState);
            case "input":
                return pushInput(target, props, responseState);
            case "menuitem":
                return pushStartMenuItem(target, props, responseState);
            case "title":
                return pushStartTitle(target, props, responseState);
            // Newline eating tags
            case "listing":
            case "pre":
                return pushStartPreformattedElement(target, props, type, responseState);
            // Omitted close tags
            case "area":
            case "base":
            case "br":
            case "col":
            case "embed":
            case "hr":
            case "img":
            case "keygen":
            case "link":
            case "meta":
            case "param":
            case "source":
            case "track":
            case "wbr":
                return pushSelfClosing(target, props, type, responseState);
            // These are reserved SVG and MathML elements, that are never custom elements.
            // https://w3c.github.io/webcomponents/spec/custom/#custom-elements-core-concepts
            case "annotation-xml":
            case "color-profile":
            case "font-face":
            case "font-face-src":
            case "font-face-uri":
            case "font-face-format":
            case "font-face-name":
            case "missing-glyph":
                return pushStartGenericElement(target, props, type, responseState);
            case "html":
                if (formatContext.insertionMode === ROOT_HTML_MODE) // If we're rendering the html tag and we're at the root (i.e. not in foreignObject)
                // then we also emit the DOCTYPE as part of the root content as a convenience for
                // rendering the whole document.
                target.push(DOCTYPE);
                return pushStartGenericElement(target, props, type, responseState);
            default:
                if (type.indexOf("-") === -1 && typeof props.is !== "string") // Generic element
                return pushStartGenericElement(target, props, type, responseState);
                else // Custom element
                return pushStartCustomElement(target, props, type, responseState);
        }
    }
    var endTag1 = stringToPrecomputedChunk("</");
    var endTag2 = stringToPrecomputedChunk(">");
    function pushEndInstance(target, type, props) {
        switch(type){
            // Omitted close tags
            // TODO: Instead of repeating this switch we could try to pass a flag from above.
            // That would require returning a tuple. Which might be ok if it gets inlined.
            case "area":
            case "base":
            case "br":
            case "col":
            case "embed":
            case "hr":
            case "img":
            case "input":
            case "keygen":
            case "link":
            case "meta":
            case "param":
            case "source":
            case "track":
            case "wbr":
                break;
            default:
                target.push(endTag1, stringToChunk(type), endTag2);
        }
    }
    function writeCompletedRoot(destination, responseState) {
        var bootstrapChunks = responseState.bootstrapChunks;
        var i = 0;
        for(; i < bootstrapChunks.length - 1; i++)writeChunk(destination, bootstrapChunks[i]);
        if (i < bootstrapChunks.length) return writeChunkAndReturn(destination, bootstrapChunks[i]);
        return true;
    } // Structural Nodes
    // A placeholder is a node inside a hidden partial tree that can be filled in later, but before
    // display. It's never visible to users. We use the template tag because it can be used in every
    // type of parent. <script> tags also work in every other tag except <colgroup>.
    var placeholder1 = stringToPrecomputedChunk('<template id="');
    var placeholder2 = stringToPrecomputedChunk('"></template>');
    function writePlaceholder(destination, responseState, id) {
        writeChunk(destination, placeholder1);
        writeChunk(destination, responseState.placeholderPrefix);
        var formattedID = stringToChunk(id.toString(16));
        writeChunk(destination, formattedID);
        return writeChunkAndReturn(destination, placeholder2);
    } // Suspense boundaries are encoded as comments.
    var startCompletedSuspenseBoundary = stringToPrecomputedChunk("<!--$-->");
    var startPendingSuspenseBoundary1 = stringToPrecomputedChunk('<!--$?--><template id="');
    var startPendingSuspenseBoundary2 = stringToPrecomputedChunk('"></template>');
    var startClientRenderedSuspenseBoundary = stringToPrecomputedChunk("<!--$!-->");
    var endSuspenseBoundary = stringToPrecomputedChunk("<!--/$-->");
    var clientRenderedSuspenseBoundaryError1 = stringToPrecomputedChunk("<template");
    var clientRenderedSuspenseBoundaryErrorAttrInterstitial = stringToPrecomputedChunk('"');
    var clientRenderedSuspenseBoundaryError1A = stringToPrecomputedChunk(' data-dgst="');
    var clientRenderedSuspenseBoundaryError1B = stringToPrecomputedChunk(' data-msg="');
    var clientRenderedSuspenseBoundaryError1C = stringToPrecomputedChunk(' data-stck="');
    var clientRenderedSuspenseBoundaryError2 = stringToPrecomputedChunk("></template>");
    function writeStartCompletedSuspenseBoundary(destination, responseState) {
        return writeChunkAndReturn(destination, startCompletedSuspenseBoundary);
    }
    function writeStartPendingSuspenseBoundary(destination, responseState, id) {
        writeChunk(destination, startPendingSuspenseBoundary1);
        if (id === null) throw new Error("An ID must have been assigned before we can complete the boundary.");
        writeChunk(destination, id);
        return writeChunkAndReturn(destination, startPendingSuspenseBoundary2);
    }
    function writeStartClientRenderedSuspenseBoundary(destination, responseState, errorDigest, errorMesssage, errorComponentStack) {
        var result;
        result = writeChunkAndReturn(destination, startClientRenderedSuspenseBoundary);
        writeChunk(destination, clientRenderedSuspenseBoundaryError1);
        if (errorDigest) {
            writeChunk(destination, clientRenderedSuspenseBoundaryError1A);
            writeChunk(destination, stringToChunk(escapeTextForBrowser(errorDigest)));
            writeChunk(destination, clientRenderedSuspenseBoundaryErrorAttrInterstitial);
        }
        if (errorMesssage) {
            writeChunk(destination, clientRenderedSuspenseBoundaryError1B);
            writeChunk(destination, stringToChunk(escapeTextForBrowser(errorMesssage)));
            writeChunk(destination, clientRenderedSuspenseBoundaryErrorAttrInterstitial);
        }
        if (errorComponentStack) {
            writeChunk(destination, clientRenderedSuspenseBoundaryError1C);
            writeChunk(destination, stringToChunk(escapeTextForBrowser(errorComponentStack)));
            writeChunk(destination, clientRenderedSuspenseBoundaryErrorAttrInterstitial);
        }
        result = writeChunkAndReturn(destination, clientRenderedSuspenseBoundaryError2);
        return result;
    }
    function writeEndCompletedSuspenseBoundary(destination, responseState) {
        return writeChunkAndReturn(destination, endSuspenseBoundary);
    }
    function writeEndPendingSuspenseBoundary(destination, responseState) {
        return writeChunkAndReturn(destination, endSuspenseBoundary);
    }
    function writeEndClientRenderedSuspenseBoundary(destination, responseState) {
        return writeChunkAndReturn(destination, endSuspenseBoundary);
    }
    var startSegmentHTML = stringToPrecomputedChunk('<div hidden id="');
    var startSegmentHTML2 = stringToPrecomputedChunk('">');
    var endSegmentHTML = stringToPrecomputedChunk("</div>");
    var startSegmentSVG = stringToPrecomputedChunk('<svg aria-hidden="true" style="display:none" id="');
    var startSegmentSVG2 = stringToPrecomputedChunk('">');
    var endSegmentSVG = stringToPrecomputedChunk("</svg>");
    var startSegmentMathML = stringToPrecomputedChunk('<math aria-hidden="true" style="display:none" id="');
    var startSegmentMathML2 = stringToPrecomputedChunk('">');
    var endSegmentMathML = stringToPrecomputedChunk("</math>");
    var startSegmentTable = stringToPrecomputedChunk('<table hidden id="');
    var startSegmentTable2 = stringToPrecomputedChunk('">');
    var endSegmentTable = stringToPrecomputedChunk("</table>");
    var startSegmentTableBody = stringToPrecomputedChunk('<table hidden><tbody id="');
    var startSegmentTableBody2 = stringToPrecomputedChunk('">');
    var endSegmentTableBody = stringToPrecomputedChunk("</tbody></table>");
    var startSegmentTableRow = stringToPrecomputedChunk('<table hidden><tr id="');
    var startSegmentTableRow2 = stringToPrecomputedChunk('">');
    var endSegmentTableRow = stringToPrecomputedChunk("</tr></table>");
    var startSegmentColGroup = stringToPrecomputedChunk('<table hidden><colgroup id="');
    var startSegmentColGroup2 = stringToPrecomputedChunk('">');
    var endSegmentColGroup = stringToPrecomputedChunk("</colgroup></table>");
    function writeStartSegment(destination, responseState, formatContext, id) {
        switch(formatContext.insertionMode){
            case ROOT_HTML_MODE:
            case HTML_MODE:
                writeChunk(destination, startSegmentHTML);
                writeChunk(destination, responseState.segmentPrefix);
                writeChunk(destination, stringToChunk(id.toString(16)));
                return writeChunkAndReturn(destination, startSegmentHTML2);
            case SVG_MODE:
                writeChunk(destination, startSegmentSVG);
                writeChunk(destination, responseState.segmentPrefix);
                writeChunk(destination, stringToChunk(id.toString(16)));
                return writeChunkAndReturn(destination, startSegmentSVG2);
            case MATHML_MODE:
                writeChunk(destination, startSegmentMathML);
                writeChunk(destination, responseState.segmentPrefix);
                writeChunk(destination, stringToChunk(id.toString(16)));
                return writeChunkAndReturn(destination, startSegmentMathML2);
            case HTML_TABLE_MODE:
                writeChunk(destination, startSegmentTable);
                writeChunk(destination, responseState.segmentPrefix);
                writeChunk(destination, stringToChunk(id.toString(16)));
                return writeChunkAndReturn(destination, startSegmentTable2);
            // TODO: For the rest of these, there will be extra wrapper nodes that never
            // get deleted from the document. We need to delete the table too as part
            // of the injected scripts. They are invisible though so it's not too terrible
            // and it's kind of an edge case to suspend in a table. Totally supported though.
            case HTML_TABLE_BODY_MODE:
                writeChunk(destination, startSegmentTableBody);
                writeChunk(destination, responseState.segmentPrefix);
                writeChunk(destination, stringToChunk(id.toString(16)));
                return writeChunkAndReturn(destination, startSegmentTableBody2);
            case HTML_TABLE_ROW_MODE:
                writeChunk(destination, startSegmentTableRow);
                writeChunk(destination, responseState.segmentPrefix);
                writeChunk(destination, stringToChunk(id.toString(16)));
                return writeChunkAndReturn(destination, startSegmentTableRow2);
            case HTML_COLGROUP_MODE:
                writeChunk(destination, startSegmentColGroup);
                writeChunk(destination, responseState.segmentPrefix);
                writeChunk(destination, stringToChunk(id.toString(16)));
                return writeChunkAndReturn(destination, startSegmentColGroup2);
            default:
                throw new Error("Unknown insertion mode. This is a bug in React.");
        }
    }
    function writeEndSegment(destination, formatContext) {
        switch(formatContext.insertionMode){
            case ROOT_HTML_MODE:
            case HTML_MODE:
                return writeChunkAndReturn(destination, endSegmentHTML);
            case SVG_MODE:
                return writeChunkAndReturn(destination, endSegmentSVG);
            case MATHML_MODE:
                return writeChunkAndReturn(destination, endSegmentMathML);
            case HTML_TABLE_MODE:
                return writeChunkAndReturn(destination, endSegmentTable);
            case HTML_TABLE_BODY_MODE:
                return writeChunkAndReturn(destination, endSegmentTableBody);
            case HTML_TABLE_ROW_MODE:
                return writeChunkAndReturn(destination, endSegmentTableRow);
            case HTML_COLGROUP_MODE:
                return writeChunkAndReturn(destination, endSegmentColGroup);
            default:
                throw new Error("Unknown insertion mode. This is a bug in React.");
        }
    } // Instruction Set
    // The following code is the source scripts that we then minify and inline below,
    // with renamed function names that we hope don't collide:
    // const COMMENT_NODE = 8;
    // const SUSPENSE_START_DATA = '$';
    // const SUSPENSE_END_DATA = '/$';
    // const SUSPENSE_PENDING_START_DATA = '$?';
    // const SUSPENSE_FALLBACK_START_DATA = '$!';
    //
    // function clientRenderBoundary(suspenseBoundaryID, errorDigest, errorMsg, errorComponentStack) {
    //   // Find the fallback's first element.
    //   const suspenseIdNode = document.getElementById(suspenseBoundaryID);
    //   if (!suspenseIdNode) {
    //     // The user must have already navigated away from this tree.
    //     // E.g. because the parent was hydrated.
    //     return;
    //   }
    //   // Find the boundary around the fallback. This is always the previous node.
    //   const suspenseNode = suspenseIdNode.previousSibling;
    //   // Tag it to be client rendered.
    //   suspenseNode.data = SUSPENSE_FALLBACK_START_DATA;
    //   // assign error metadata to first sibling
    //   let dataset = suspenseIdNode.dataset;
    //   if (errorDigest) dataset.dgst = errorDigest;
    //   if (errorMsg) dataset.msg = errorMsg;
    //   if (errorComponentStack) dataset.stck = errorComponentStack;
    //   // Tell React to retry it if the parent already hydrated.
    //   if (suspenseNode._reactRetry) {
    //     suspenseNode._reactRetry();
    //   }
    // }
    //
    // function completeBoundary(suspenseBoundaryID, contentID) {
    //   // Find the fallback's first element.
    //   const suspenseIdNode = document.getElementById(suspenseBoundaryID);
    //   const contentNode = document.getElementById(contentID);
    //   // We'll detach the content node so that regardless of what happens next we don't leave in the tree.
    //   // This might also help by not causing recalcing each time we move a child from here to the target.
    //   contentNode.parentNode.removeChild(contentNode);
    //   if (!suspenseIdNode) {
    //     // The user must have already navigated away from this tree.
    //     // E.g. because the parent was hydrated. That's fine there's nothing to do
    //     // but we have to make sure that we already deleted the container node.
    //     return;
    //   }
    //   // Find the boundary around the fallback. This is always the previous node.
    //   const suspenseNode = suspenseIdNode.previousSibling;
    //
    //   // Clear all the existing children. This is complicated because
    //   // there can be embedded Suspense boundaries in the fallback.
    //   // This is similar to clearSuspenseBoundary in ReactDOMHostConfig.
    //   // TODO: We could avoid this if we never emitted suspense boundaries in fallback trees.
    //   // They never hydrate anyway. However, currently we support incrementally loading the fallback.
    //   const parentInstance = suspenseNode.parentNode;
    //   let node = suspenseNode.nextSibling;
    //   let depth = 0;
    //   do {
    //     if (node && node.nodeType === COMMENT_NODE) {
    //       const data = node.data;
    //       if (data === SUSPENSE_END_DATA) {
    //         if (depth === 0) {
    //           break;
    //         } else {
    //           depth--;
    //         }
    //       } else if (
    //         data === SUSPENSE_START_DATA ||
    //         data === SUSPENSE_PENDING_START_DATA ||
    //         data === SUSPENSE_FALLBACK_START_DATA
    //       ) {
    //         depth++;
    //       }
    //     }
    //
    //     const nextNode = node.nextSibling;
    //     parentInstance.removeChild(node);
    //     node = nextNode;
    //   } while (node);
    //
    //   const endOfBoundary = node;
    //
    //   // Insert all the children from the contentNode between the start and end of suspense boundary.
    //   while (contentNode.firstChild) {
    //     parentInstance.insertBefore(contentNode.firstChild, endOfBoundary);
    //   }
    //   suspenseNode.data = SUSPENSE_START_DATA;
    //   if (suspenseNode._reactRetry) {
    //     suspenseNode._reactRetry();
    //   }
    // }
    //
    // function completeSegment(containerID, placeholderID) {
    //   const segmentContainer = document.getElementById(containerID);
    //   const placeholderNode = document.getElementById(placeholderID);
    //   // We always expect both nodes to exist here because, while we might
    //   // have navigated away from the main tree, we still expect the detached
    //   // tree to exist.
    //   segmentContainer.parentNode.removeChild(segmentContainer);
    //   while (segmentContainer.firstChild) {
    //     placeholderNode.parentNode.insertBefore(
    //       segmentContainer.firstChild,
    //       placeholderNode,
    //     );
    //   }
    //   placeholderNode.parentNode.removeChild(placeholderNode);
    // }
    var completeSegmentFunction = "function $RS(a,b){a=document.getElementById(a);b=document.getElementById(b);for(a.parentNode.removeChild(a);a.firstChild;)b.parentNode.insertBefore(a.firstChild,b);b.parentNode.removeChild(b)}";
    var completeBoundaryFunction = 'function $RC(a,b){a=document.getElementById(a);b=document.getElementById(b);b.parentNode.removeChild(b);if(a){a=a.previousSibling;var f=a.parentNode,c=a.nextSibling,e=0;do{if(c&&8===c.nodeType){var d=c.data;if("/$"===d)if(0===e)break;else e--;else"$"!==d&&"$?"!==d&&"$!"!==d||e++}d=c.nextSibling;f.removeChild(c);c=d}while(c);for(;b.firstChild;)f.insertBefore(b.firstChild,c);a.data="$";a._reactRetry&&a._reactRetry()}}';
    var clientRenderFunction = 'function $RX(b,c,d,e){var a=document.getElementById(b);a&&(b=a.previousSibling,b.data="$!",a=a.dataset,c&&(a.dgst=c),d&&(a.msg=d),e&&(a.stck=e),b._reactRetry&&b._reactRetry())}';
    var completeSegmentScript1Full = stringToPrecomputedChunk(completeSegmentFunction + ';$RS("');
    var completeSegmentScript1Partial = stringToPrecomputedChunk('$RS("');
    var completeSegmentScript2 = stringToPrecomputedChunk('","');
    var completeSegmentScript3 = stringToPrecomputedChunk('")</script>');
    function writeCompletedSegmentInstruction(destination, responseState, contentSegmentID) {
        writeChunk(destination, responseState.startInlineScript);
        if (!responseState.sentCompleteSegmentFunction) {
            // The first time we write this, we'll need to include the full implementation.
            responseState.sentCompleteSegmentFunction = true;
            writeChunk(destination, completeSegmentScript1Full);
        } else // Future calls can just reuse the same function.
        writeChunk(destination, completeSegmentScript1Partial);
        writeChunk(destination, responseState.segmentPrefix);
        var formattedID = stringToChunk(contentSegmentID.toString(16));
        writeChunk(destination, formattedID);
        writeChunk(destination, completeSegmentScript2);
        writeChunk(destination, responseState.placeholderPrefix);
        writeChunk(destination, formattedID);
        return writeChunkAndReturn(destination, completeSegmentScript3);
    }
    var completeBoundaryScript1Full = stringToPrecomputedChunk(completeBoundaryFunction + ';$RC("');
    var completeBoundaryScript1Partial = stringToPrecomputedChunk('$RC("');
    var completeBoundaryScript2 = stringToPrecomputedChunk('","');
    var completeBoundaryScript3 = stringToPrecomputedChunk('")</script>');
    function writeCompletedBoundaryInstruction(destination, responseState, boundaryID, contentSegmentID) {
        writeChunk(destination, responseState.startInlineScript);
        if (!responseState.sentCompleteBoundaryFunction) {
            // The first time we write this, we'll need to include the full implementation.
            responseState.sentCompleteBoundaryFunction = true;
            writeChunk(destination, completeBoundaryScript1Full);
        } else // Future calls can just reuse the same function.
        writeChunk(destination, completeBoundaryScript1Partial);
        if (boundaryID === null) throw new Error("An ID must have been assigned before we can complete the boundary.");
        var formattedContentID = stringToChunk(contentSegmentID.toString(16));
        writeChunk(destination, boundaryID);
        writeChunk(destination, completeBoundaryScript2);
        writeChunk(destination, responseState.segmentPrefix);
        writeChunk(destination, formattedContentID);
        return writeChunkAndReturn(destination, completeBoundaryScript3);
    }
    var clientRenderScript1Full = stringToPrecomputedChunk(clientRenderFunction + ';$RX("');
    var clientRenderScript1Partial = stringToPrecomputedChunk('$RX("');
    var clientRenderScript1A = stringToPrecomputedChunk('"');
    var clientRenderScript2 = stringToPrecomputedChunk(")</script>");
    var clientRenderErrorScriptArgInterstitial = stringToPrecomputedChunk(",");
    function writeClientRenderBoundaryInstruction(destination, responseState, boundaryID, errorDigest, errorMessage, errorComponentStack) {
        writeChunk(destination, responseState.startInlineScript);
        if (!responseState.sentClientRenderFunction) {
            // The first time we write this, we'll need to include the full implementation.
            responseState.sentClientRenderFunction = true;
            writeChunk(destination, clientRenderScript1Full);
        } else // Future calls can just reuse the same function.
        writeChunk(destination, clientRenderScript1Partial);
        if (boundaryID === null) throw new Error("An ID must have been assigned before we can complete the boundary.");
        writeChunk(destination, boundaryID);
        writeChunk(destination, clientRenderScript1A);
        if (errorDigest || errorMessage || errorComponentStack) {
            writeChunk(destination, clientRenderErrorScriptArgInterstitial);
            writeChunk(destination, stringToChunk(escapeJSStringsForInstructionScripts(errorDigest || "")));
        }
        if (errorMessage || errorComponentStack) {
            writeChunk(destination, clientRenderErrorScriptArgInterstitial);
            writeChunk(destination, stringToChunk(escapeJSStringsForInstructionScripts(errorMessage || "")));
        }
        if (errorComponentStack) {
            writeChunk(destination, clientRenderErrorScriptArgInterstitial);
            writeChunk(destination, stringToChunk(escapeJSStringsForInstructionScripts(errorComponentStack)));
        }
        return writeChunkAndReturn(destination, clientRenderScript2);
    }
    var regexForJSStringsInScripts = /[<\u2028\u2029]/g;
    function escapeJSStringsForInstructionScripts(input) {
        var escaped = JSON.stringify(input);
        return escaped.replace(regexForJSStringsInScripts, function(match) {
            switch(match){
                // santizing breaking out of strings and script tags
                case "<":
                    return "\\u003c";
                case "\u2028":
                    return "\\u2028";
                case "\u2029":
                    return "\\u2029";
                default:
                    // eslint-disable-next-line react-internal/prod-error-codes
                    throw new Error("escapeJSStringsForInstructionScripts encountered a match it does not know how to replace. this means the match regex and the replacement characters are no longer in sync. This is a bug in React");
            }
        });
    }
    var assign = Object.assign;
    // ATTENTION
    // When adding new symbols to this file,
    // Please consider also adding to 'react-devtools-shared/src/backend/ReactSymbols'
    // The Symbol used to tag the ReactElement-like types.
    var REACT_ELEMENT_TYPE = Symbol.for("react.element");
    var REACT_PORTAL_TYPE = Symbol.for("react.portal");
    var REACT_FRAGMENT_TYPE = Symbol.for("react.fragment");
    var REACT_STRICT_MODE_TYPE = Symbol.for("react.strict_mode");
    var REACT_PROFILER_TYPE = Symbol.for("react.profiler");
    var REACT_PROVIDER_TYPE = Symbol.for("react.provider");
    var REACT_CONTEXT_TYPE = Symbol.for("react.context");
    var REACT_FORWARD_REF_TYPE = Symbol.for("react.forward_ref");
    var REACT_SUSPENSE_TYPE = Symbol.for("react.suspense");
    var REACT_SUSPENSE_LIST_TYPE = Symbol.for("react.suspense_list");
    var REACT_MEMO_TYPE = Symbol.for("react.memo");
    var REACT_LAZY_TYPE = Symbol.for("react.lazy");
    var REACT_SCOPE_TYPE = Symbol.for("react.scope");
    var REACT_DEBUG_TRACING_MODE_TYPE = Symbol.for("react.debug_trace_mode");
    var REACT_LEGACY_HIDDEN_TYPE = Symbol.for("react.legacy_hidden");
    var REACT_SERVER_CONTEXT_DEFAULT_VALUE_NOT_LOADED = Symbol.for("react.default_value");
    var MAYBE_ITERATOR_SYMBOL = Symbol.iterator;
    var FAUX_ITERATOR_SYMBOL = "@@iterator";
    function getIteratorFn(maybeIterable) {
        if (maybeIterable === null || typeof maybeIterable !== "object") return null;
        var maybeIterator = MAYBE_ITERATOR_SYMBOL && maybeIterable[MAYBE_ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL];
        if (typeof maybeIterator === "function") return maybeIterator;
        return null;
    }
    function getWrappedName(outerType, innerType, wrapperName) {
        var displayName = outerType.displayName;
        if (displayName) return displayName;
        var functionName = innerType.displayName || innerType.name || "";
        return functionName !== "" ? wrapperName + "(" + functionName + ")" : wrapperName;
    } // Keep in sync with react-reconciler/getComponentNameFromFiber
    function getContextName(type) {
        return type.displayName || "Context";
    } // Note that the reconciler package should generally prefer to use getComponentNameFromFiber() instead.
    function getComponentNameFromType(type) {
        if (type == null) // Host root, text node or just invalid type.
        return null;
        if (typeof type.tag === "number") error("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue.");
        if (typeof type === "function") return type.displayName || type.name || null;
        if (typeof type === "string") return type;
        switch(type){
            case REACT_FRAGMENT_TYPE:
                return "Fragment";
            case REACT_PORTAL_TYPE:
                return "Portal";
            case REACT_PROFILER_TYPE:
                return "Profiler";
            case REACT_STRICT_MODE_TYPE:
                return "StrictMode";
            case REACT_SUSPENSE_TYPE:
                return "Suspense";
            case REACT_SUSPENSE_LIST_TYPE:
                return "SuspenseList";
        }
        if (typeof type === "object") switch(type.$$typeof){
            case REACT_CONTEXT_TYPE:
                var context = type;
                return getContextName(context) + ".Consumer";
            case REACT_PROVIDER_TYPE:
                var provider = type;
                return getContextName(provider._context) + ".Provider";
            case REACT_FORWARD_REF_TYPE:
                return getWrappedName(type, type.render, "ForwardRef");
            case REACT_MEMO_TYPE:
                var outerName = type.displayName || null;
                if (outerName !== null) return outerName;
                return getComponentNameFromType(type.type) || "Memo";
            case REACT_LAZY_TYPE:
                var lazyComponent = type;
                var payload = lazyComponent._payload;
                var init = lazyComponent._init;
                try {
                    return getComponentNameFromType(init(payload));
                } catch (x) {
                    return null;
                }
        }
        return null;
    }
    // Helpers to patch console.logs to avoid logging during side-effect free
    // replaying on render function. This currently only patches the object
    // lazily which won't cover if the log function was extracted eagerly.
    // We could also eagerly patch the method.
    var disabledDepth = 0;
    var prevLog;
    var prevInfo;
    var prevWarn;
    var prevError;
    var prevGroup;
    var prevGroupCollapsed;
    var prevGroupEnd;
    function disabledLog() {}
    disabledLog.__reactDisabledLog = true;
    function disableLogs() {
        if (disabledDepth === 0) {
            /* eslint-disable react-internal/no-production-logging */ prevLog = console.log;
            prevInfo = console.info;
            prevWarn = console.warn;
            prevError = console.error;
            prevGroup = console.group;
            prevGroupCollapsed = console.groupCollapsed;
            prevGroupEnd = console.groupEnd; // https://github.com/facebook/react/issues/19099
            var props = {
                configurable: true,
                enumerable: true,
                value: disabledLog,
                writable: true
            }; // $FlowFixMe Flow thinks console is immutable.
            Object.defineProperties(console, {
                info: props,
                log: props,
                warn: props,
                error: props,
                group: props,
                groupCollapsed: props,
                groupEnd: props
            });
        /* eslint-enable react-internal/no-production-logging */ }
        disabledDepth++;
    }
    function reenableLogs() {
        disabledDepth--;
        if (disabledDepth === 0) {
            /* eslint-disable react-internal/no-production-logging */ var props = {
                configurable: true,
                enumerable: true,
                writable: true
            }; // $FlowFixMe Flow thinks console is immutable.
            Object.defineProperties(console, {
                log: assign({}, props, {
                    value: prevLog
                }),
                info: assign({}, props, {
                    value: prevInfo
                }),
                warn: assign({}, props, {
                    value: prevWarn
                }),
                error: assign({}, props, {
                    value: prevError
                }),
                group: assign({}, props, {
                    value: prevGroup
                }),
                groupCollapsed: assign({}, props, {
                    value: prevGroupCollapsed
                }),
                groupEnd: assign({}, props, {
                    value: prevGroupEnd
                })
            });
        /* eslint-enable react-internal/no-production-logging */ }
        if (disabledDepth < 0) error("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
    }
    var ReactCurrentDispatcher = ReactSharedInternals.ReactCurrentDispatcher;
    var prefix;
    function describeBuiltInComponentFrame(name, source, ownerFn) {
        if (prefix === undefined) // Extract the VM specific prefix used by each line.
        try {
            throw Error();
        } catch (x) {
            var match = x.stack.trim().match(/\n( *(at )?)/);
            prefix = match && match[1] || "";
        }
         // We use the prefix to ensure our stacks line up with native stack frames.
        return "\n" + prefix + name;
    }
    var reentry = false;
    var componentFrameCache;
    var PossiblyWeakMap = typeof WeakMap === "function" ? WeakMap : Map;
    componentFrameCache = new PossiblyWeakMap();
    function describeNativeComponentFrame(fn, construct) {
        // If something asked for a stack inside a fake render, it should get ignored.
        if (!fn || reentry) return "";
        var frame = componentFrameCache.get(fn);
        if (frame !== undefined) return frame;
        var control;
        reentry = true;
        var previousPrepareStackTrace = Error.prepareStackTrace; // $FlowFixMe It does accept undefined.
        Error.prepareStackTrace = undefined;
        var previousDispatcher;
        previousDispatcher = ReactCurrentDispatcher.current; // Set the dispatcher in DEV because this might be call in the render function
        // for warnings.
        ReactCurrentDispatcher.current = null;
        disableLogs();
        try {
            // This should throw.
            if (construct) {
                // Something should be setting the props in the constructor.
                var Fake = function() {
                    throw Error();
                }; // $FlowFixMe
                Object.defineProperty(Fake.prototype, "props", {
                    set: function() {
                        // We use a throwing setter instead of frozen or non-writable props
                        // because that won't throw in a non-strict mode function.
                        throw Error();
                    }
                });
                if (typeof Reflect === "object" && Reflect.construct) {
                    // We construct a different control for this case to include any extra
                    // frames added by the construct call.
                    try {
                        Reflect.construct(Fake, []);
                    } catch (x) {
                        control = x;
                    }
                    Reflect.construct(fn, [], Fake);
                } else {
                    try {
                        Fake.call();
                    } catch (x) {
                        control = x;
                    }
                    fn.call(Fake.prototype);
                }
            } else {
                try {
                    throw Error();
                } catch (x) {
                    control = x;
                }
                fn();
            }
        } catch (sample) {
            // This is inlined manually because closure doesn't do it for us.
            if (sample && control && typeof sample.stack === "string") {
                // This extracts the first frame from the sample that isn't also in the control.
                // Skipping one frame that we assume is the frame that calls the two.
                var sampleLines = sample.stack.split("\n");
                var controlLines = control.stack.split("\n");
                var s = sampleLines.length - 1;
                var c = controlLines.length - 1;
                while(s >= 1 && c >= 0 && sampleLines[s] !== controlLines[c])// We expect at least one stack frame to be shared.
                // Typically this will be the root most one. However, stack frames may be
                // cut off due to maximum stack limits. In this case, one maybe cut off
                // earlier than the other. We assume that the sample is longer or the same
                // and there for cut off earlier. So we should find the root most frame in
                // the sample somewhere in the control.
                c--;
                for(; s >= 1 && c >= 0; s--, c--)// Next we find the first one that isn't the same which should be the
                // frame that called our sample function and the control.
                if (sampleLines[s] !== controlLines[c]) {
                    // In V8, the first line is describing the message but other VMs don't.
                    // If we're about to return the first line, and the control is also on the same
                    // line, that's a pretty good indicator that our sample threw at same line as
                    // the control. I.e. before we entered the sample frame. So we ignore this result.
                    // This can happen if you passed a class to function component, or non-function.
                    if (s !== 1 || c !== 1) do {
                        s--;
                        c--; // We may still have similar intermediate frames from the construct call.
                        // The next one that isn't the same should be our match though.
                        if (c < 0 || sampleLines[s] !== controlLines[c]) {
                            // V8 adds a "new" prefix for native classes. Let's remove it to make it prettier.
                            var _frame = "\n" + sampleLines[s].replace(" at new ", " at "); // If our component frame is labeled "<anonymous>"
                            // but we have a user-provided "displayName"
                            // splice it in to make the stack more readable.
                            if (fn.displayName && _frame.includes("<anonymous>")) _frame = _frame.replace("<anonymous>", fn.displayName);
                            if (typeof fn === "function") componentFrameCache.set(fn, _frame);
                            return _frame;
                        }
                    }while (s >= 1 && c >= 0);
                    break;
                }
            }
        } finally{
            reentry = false;
            ReactCurrentDispatcher.current = previousDispatcher;
            reenableLogs();
            Error.prepareStackTrace = previousPrepareStackTrace;
        } // Fallback to just using the name if we couldn't make it throw.
        var name = fn ? fn.displayName || fn.name : "";
        var syntheticFrame = name ? describeBuiltInComponentFrame(name) : "";
        if (typeof fn === "function") componentFrameCache.set(fn, syntheticFrame);
        return syntheticFrame;
    }
    function describeClassComponentFrame(ctor, source, ownerFn) {
        return describeNativeComponentFrame(ctor, true);
    }
    function describeFunctionComponentFrame(fn, source, ownerFn) {
        return describeNativeComponentFrame(fn, false);
    }
    function shouldConstruct(Component) {
        var prototype = Component.prototype;
        return !!(prototype && prototype.isReactComponent);
    }
    function describeUnknownElementTypeFrameInDEV(type, source, ownerFn) {
        if (type == null) return "";
        if (typeof type === "function") return describeNativeComponentFrame(type, shouldConstruct(type));
        if (typeof type === "string") return describeBuiltInComponentFrame(type);
        switch(type){
            case REACT_SUSPENSE_TYPE:
                return describeBuiltInComponentFrame("Suspense");
            case REACT_SUSPENSE_LIST_TYPE:
                return describeBuiltInComponentFrame("SuspenseList");
        }
        if (typeof type === "object") switch(type.$$typeof){
            case REACT_FORWARD_REF_TYPE:
                return describeFunctionComponentFrame(type.render);
            case REACT_MEMO_TYPE:
                // Memo may contain any component type so we recursively resolve it.
                return describeUnknownElementTypeFrameInDEV(type.type, source, ownerFn);
            case REACT_LAZY_TYPE:
                var lazyComponent = type;
                var payload = lazyComponent._payload;
                var init = lazyComponent._init;
                try {
                    // Lazy may contain any component type so we recursively resolve it.
                    return describeUnknownElementTypeFrameInDEV(init(payload), source, ownerFn);
                } catch (x) {}
        }
        return "";
    }
    var loggedTypeFailures = {};
    var ReactDebugCurrentFrame = ReactSharedInternals.ReactDebugCurrentFrame;
    function setCurrentlyValidatingElement(element) {
        if (element) {
            var owner = element._owner;
            var stack = describeUnknownElementTypeFrameInDEV(element.type, element._source, owner ? owner.type : null);
            ReactDebugCurrentFrame.setExtraStackFrame(stack);
        } else ReactDebugCurrentFrame.setExtraStackFrame(null);
    }
    function checkPropTypes(typeSpecs, values, location, componentName, element) {
        // $FlowFixMe This is okay but Flow doesn't know it.
        var has = Function.call.bind(hasOwnProperty);
        for(var typeSpecName in typeSpecs)if (has(typeSpecs, typeSpecName)) {
            var error$1 = void 0; // Prop type validation may throw. In case they do, we don't want to
            // fail the render phase where it didn't fail before. So we log it.
            // After these have been cleaned up, we'll let them throw.
            try {
                // This is intentionally an invariant that gets caught. It's the same
                // behavior as without this statement except with a better message.
                if (typeof typeSpecs[typeSpecName] !== "function") {
                    // eslint-disable-next-line react-internal/prod-error-codes
                    var err = Error((componentName || "React class") + ": " + location + " type `" + typeSpecName + "` is invalid; " + "it must be a function, usually from the `prop-types` package, but received `" + typeof typeSpecs[typeSpecName] + "`." + "This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                    err.name = "Invariant Violation";
                    throw err;
                }
                error$1 = typeSpecs[typeSpecName](values, typeSpecName, componentName, location, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (ex) {
                error$1 = ex;
            }
            if (error$1 && !(error$1 instanceof Error)) {
                setCurrentlyValidatingElement(element);
                error("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", componentName || "React class", location, typeSpecName, typeof error$1);
                setCurrentlyValidatingElement(null);
            }
            if (error$1 instanceof Error && !(error$1.message in loggedTypeFailures)) {
                // Only monitor this failure once because there tends to be a lot of the
                // same error.
                loggedTypeFailures[error$1.message] = true;
                setCurrentlyValidatingElement(element);
                error("Failed %s type: %s", location, error$1.message);
                setCurrentlyValidatingElement(null);
            }
        }
    }
    var warnedAboutMissingGetChildContext;
    warnedAboutMissingGetChildContext = {};
    var emptyContextObject = {};
    Object.freeze(emptyContextObject);
    function getMaskedContext(type, unmaskedContext) {
        var contextTypes = type.contextTypes;
        if (!contextTypes) return emptyContextObject;
        var context = {};
        for(var key in contextTypes)context[key] = unmaskedContext[key];
        var name = getComponentNameFromType(type) || "Unknown";
        checkPropTypes(contextTypes, context, "context", name);
        return context;
    }
    function processChildContext(instance, type, parentContext, childContextTypes) {
        // TODO (bvaughn) Replace this behavior with an invariant() in the future.
        // It has only been added in Fiber to match the (unintentional) behavior in Stack.
        if (typeof instance.getChildContext !== "function") {
            var componentName = getComponentNameFromType(type) || "Unknown";
            if (!warnedAboutMissingGetChildContext[componentName]) {
                warnedAboutMissingGetChildContext[componentName] = true;
                error("%s.childContextTypes is specified but there is no getChildContext() method on the instance. You can either define getChildContext() on %s or remove childContextTypes from it.", componentName, componentName);
            }
            return parentContext;
        }
        var childContext = instance.getChildContext();
        for(var contextKey in childContext){
            if (!(contextKey in childContextTypes)) throw new Error((getComponentNameFromType(type) || "Unknown") + '.getChildContext(): key "' + contextKey + '" is not defined in childContextTypes.');
        }
        var name = getComponentNameFromType(type) || "Unknown";
        checkPropTypes(childContextTypes, childContext, "child context", name);
        return assign({}, parentContext, childContext);
    }
    var rendererSigil;
    // Use this to detect multiple renderers using the same context
    rendererSigil = {};
    // Forming a reverse tree.
    var rootContextSnapshot = null; // We assume that this runtime owns the "current" field on all ReactContext instances.
    // This global (actually thread local) state represents what state all those "current",
    // fields are currently in.
    var currentActiveSnapshot = null;
    function popNode(prev) {
        prev.context._currentValue = prev.parentValue;
    }
    function pushNode(next) {
        next.context._currentValue = next.value;
    }
    function popToNearestCommonAncestor(prev, next) {
        if (prev === next) ;
        else {
            popNode(prev);
            var parentPrev = prev.parent;
            var parentNext = next.parent;
            if (parentPrev === null) {
                if (parentNext !== null) throw new Error("The stacks must reach the root at the same time. This is a bug in React.");
            } else {
                if (parentNext === null) throw new Error("The stacks must reach the root at the same time. This is a bug in React.");
                popToNearestCommonAncestor(parentPrev, parentNext);
            } // On the way back, we push the new ones that weren't common.
            pushNode(next);
        }
    }
    function popAllPrevious(prev) {
        popNode(prev);
        var parentPrev = prev.parent;
        if (parentPrev !== null) popAllPrevious(parentPrev);
    }
    function pushAllNext(next) {
        var parentNext = next.parent;
        if (parentNext !== null) pushAllNext(parentNext);
        pushNode(next);
    }
    function popPreviousToCommonLevel(prev, next) {
        popNode(prev);
        var parentPrev = prev.parent;
        if (parentPrev === null) throw new Error("The depth must equal at least at zero before reaching the root. This is a bug in React.");
        if (parentPrev.depth === next.depth) // We found the same level. Now we just need to find a shared ancestor.
        popToNearestCommonAncestor(parentPrev, next);
        else // We must still be deeper.
        popPreviousToCommonLevel(parentPrev, next);
    }
    function popNextToCommonLevel(prev, next) {
        var parentNext = next.parent;
        if (parentNext === null) throw new Error("The depth must equal at least at zero before reaching the root. This is a bug in React.");
        if (prev.depth === parentNext.depth) // We found the same level. Now we just need to find a shared ancestor.
        popToNearestCommonAncestor(prev, parentNext);
        else // We must still be deeper.
        popNextToCommonLevel(prev, parentNext);
        pushNode(next);
    } // Perform context switching to the new snapshot.
    // To make it cheap to read many contexts, while not suspending, we make the switch eagerly by
    // updating all the context's current values. That way reads, always just read the current value.
    // At the cost of updating contexts even if they're never read by this subtree.
    function switchContext(newSnapshot) {
        // The basic algorithm we need to do is to pop back any contexts that are no longer on the stack.
        // We also need to update any new contexts that are now on the stack with the deepest value.
        // The easiest way to update new contexts is to just reapply them in reverse order from the
        // perspective of the backpointers. To avoid allocating a lot when switching, we use the stack
        // for that. Therefore this algorithm is recursive.
        // 1) First we pop which ever snapshot tree was deepest. Popping old contexts as we go.
        // 2) Then we find the nearest common ancestor from there. Popping old contexts as we go.
        // 3) Then we reapply new contexts on the way back up the stack.
        var prev = currentActiveSnapshot;
        var next = newSnapshot;
        if (prev !== next) {
            if (prev === null) // $FlowFixMe: This has to be non-null since it's not equal to prev.
            pushAllNext(next);
            else if (next === null) popAllPrevious(prev);
            else if (prev.depth === next.depth) popToNearestCommonAncestor(prev, next);
            else if (prev.depth > next.depth) popPreviousToCommonLevel(prev, next);
            else popNextToCommonLevel(prev, next);
            currentActiveSnapshot = next;
        }
    }
    function pushProvider(context, nextValue) {
        var prevValue;
        prevValue = context._currentValue;
        context._currentValue = nextValue;
        if (context._currentRenderer !== undefined && context._currentRenderer !== null && context._currentRenderer !== rendererSigil) error("Detected multiple renderers concurrently rendering the same context provider. This is currently unsupported.");
        context._currentRenderer = rendererSigil;
        var prevNode = currentActiveSnapshot;
        var newNode = {
            parent: prevNode,
            depth: prevNode === null ? 0 : prevNode.depth + 1,
            context: context,
            parentValue: prevValue,
            value: nextValue
        };
        currentActiveSnapshot = newNode;
        return newNode;
    }
    function popProvider(context) {
        var prevSnapshot = currentActiveSnapshot;
        if (prevSnapshot === null) throw new Error("Tried to pop a Context at the root of the app. This is a bug in React.");
        if (prevSnapshot.context !== context) error("The parent context is not the expected context. This is probably a bug in React.");
        var value = prevSnapshot.parentValue;
        if (value === REACT_SERVER_CONTEXT_DEFAULT_VALUE_NOT_LOADED) prevSnapshot.context._currentValue = prevSnapshot.context._defaultValue;
        else prevSnapshot.context._currentValue = value;
        if (context._currentRenderer !== undefined && context._currentRenderer !== null && context._currentRenderer !== rendererSigil) error("Detected multiple renderers concurrently rendering the same context provider. This is currently unsupported.");
        context._currentRenderer = rendererSigil;
        return currentActiveSnapshot = prevSnapshot.parent;
    }
    function getActiveContext() {
        return currentActiveSnapshot;
    }
    function readContext(context) {
        var value = context._currentValue;
        return value;
    }
    /**
 * `ReactInstanceMap` maintains a mapping from a public facing stateful
 * instance (key) and the internal representation (value). This allows public
 * methods to accept the user facing instance as an argument and map them back
 * to internal methods.
 *
 * Note that this module is currently shared and assumed to be stateless.
 * If this becomes an actual Map, that will break.
 */ function get(key) {
        return key._reactInternals;
    }
    function set(key, value) {
        key._reactInternals = value;
    }
    var didWarnAboutNoopUpdateForComponent = {};
    var didWarnAboutDeprecatedWillMount = {};
    var didWarnAboutUninitializedState;
    var didWarnAboutGetSnapshotBeforeUpdateWithoutDidUpdate;
    var didWarnAboutLegacyLifecyclesAndDerivedState;
    var didWarnAboutUndefinedDerivedState;
    var warnOnUndefinedDerivedState;
    var warnOnInvalidCallback;
    var didWarnAboutDirectlyAssigningPropsToState;
    var didWarnAboutContextTypeAndContextTypes;
    var didWarnAboutInvalidateContextType;
    didWarnAboutUninitializedState = new Set();
    didWarnAboutGetSnapshotBeforeUpdateWithoutDidUpdate = new Set();
    didWarnAboutLegacyLifecyclesAndDerivedState = new Set();
    didWarnAboutDirectlyAssigningPropsToState = new Set();
    didWarnAboutUndefinedDerivedState = new Set();
    didWarnAboutContextTypeAndContextTypes = new Set();
    didWarnAboutInvalidateContextType = new Set();
    var didWarnOnInvalidCallback = new Set();
    warnOnInvalidCallback = function(callback, callerName) {
        if (callback === null || typeof callback === "function") return;
        var key = callerName + "_" + callback;
        if (!didWarnOnInvalidCallback.has(key)) {
            didWarnOnInvalidCallback.add(key);
            error("%s(...): Expected the last optional `callback` argument to be a function. Instead received: %s.", callerName, callback);
        }
    };
    warnOnUndefinedDerivedState = function(type, partialState) {
        if (partialState === undefined) {
            var componentName = getComponentNameFromType(type) || "Component";
            if (!didWarnAboutUndefinedDerivedState.has(componentName)) {
                didWarnAboutUndefinedDerivedState.add(componentName);
                error("%s.getDerivedStateFromProps(): A valid state object (or null) must be returned. You have returned undefined.", componentName);
            }
        }
    };
    function warnNoop(publicInstance, callerName) {
        var _constructor = publicInstance.constructor;
        var componentName = _constructor && getComponentNameFromType(_constructor) || "ReactClass";
        var warningKey = componentName + "." + callerName;
        if (didWarnAboutNoopUpdateForComponent[warningKey]) return;
        error("%s(...): Can only update a mounting component. This usually means you called %s() outside componentWillMount() on the server. This is a no-op.\n\nPlease check the code for the %s component.", callerName, callerName, componentName);
        didWarnAboutNoopUpdateForComponent[warningKey] = true;
    }
    var classComponentUpdater = {
        isMounted: function(inst) {
            return false;
        },
        enqueueSetState: function(inst, payload, callback) {
            var internals = get(inst);
            if (internals.queue === null) warnNoop(inst, "setState");
            else {
                internals.queue.push(payload);
                if (callback !== undefined && callback !== null) warnOnInvalidCallback(callback, "setState");
            }
        },
        enqueueReplaceState: function(inst, payload, callback) {
            var internals = get(inst);
            internals.replace = true;
            internals.queue = [
                payload
            ];
            if (callback !== undefined && callback !== null) warnOnInvalidCallback(callback, "setState");
        },
        enqueueForceUpdate: function(inst, callback) {
            var internals = get(inst);
            if (internals.queue === null) warnNoop(inst, "forceUpdate");
            else if (callback !== undefined && callback !== null) warnOnInvalidCallback(callback, "setState");
        }
    };
    function applyDerivedStateFromProps(instance, ctor, getDerivedStateFromProps, prevState, nextProps) {
        var partialState = getDerivedStateFromProps(nextProps, prevState);
        warnOnUndefinedDerivedState(ctor, partialState);
        var newState = partialState === null || partialState === undefined ? prevState : assign({}, prevState, partialState);
        return newState;
    }
    function constructClassInstance(ctor, props, maskedLegacyContext) {
        var context = emptyContextObject;
        var contextType = ctor.contextType;
        if ("contextType" in ctor) {
            var isValid = contextType === null || contextType !== undefined && contextType.$$typeof === REACT_CONTEXT_TYPE && contextType._context === undefined; // Not a <Context.Consumer>
            if (!isValid && !didWarnAboutInvalidateContextType.has(ctor)) {
                didWarnAboutInvalidateContextType.add(ctor);
                var addendum = "";
                if (contextType === undefined) addendum = " However, it is set to undefined. This can be caused by a typo or by mixing up named and default imports. This can also happen due to a circular dependency, so try moving the createContext() call to a separate file.";
                else if (typeof contextType !== "object") addendum = " However, it is set to a " + typeof contextType + ".";
                else if (contextType.$$typeof === REACT_PROVIDER_TYPE) addendum = " Did you accidentally pass the Context.Provider instead?";
                else if (contextType._context !== undefined) // <Context.Consumer>
                addendum = " Did you accidentally pass the Context.Consumer instead?";
                else addendum = " However, it is set to an object with keys {" + Object.keys(contextType).join(", ") + "}.";
                error("%s defines an invalid contextType. contextType should point to the Context object returned by React.createContext().%s", getComponentNameFromType(ctor) || "Component", addendum);
            }
        }
        if (typeof contextType === "object" && contextType !== null) context = readContext(contextType);
        else context = maskedLegacyContext;
        var instance = new ctor(props, context);
        if (typeof ctor.getDerivedStateFromProps === "function" && (instance.state === null || instance.state === undefined)) {
            var componentName = getComponentNameFromType(ctor) || "Component";
            if (!didWarnAboutUninitializedState.has(componentName)) {
                didWarnAboutUninitializedState.add(componentName);
                error("`%s` uses `getDerivedStateFromProps` but its initial state is %s. This is not recommended. Instead, define the initial state by assigning an object to `this.state` in the constructor of `%s`. This ensures that `getDerivedStateFromProps` arguments have a consistent shape.", componentName, instance.state === null ? "null" : "undefined", componentName);
            }
        } // If new component APIs are defined, "unsafe" lifecycles won't be called.
        // Warn about these lifecycles if they are present.
        // Don't warn about react-lifecycles-compat polyfilled methods though.
        if (typeof ctor.getDerivedStateFromProps === "function" || typeof instance.getSnapshotBeforeUpdate === "function") {
            var foundWillMountName = null;
            var foundWillReceivePropsName = null;
            var foundWillUpdateName = null;
            if (typeof instance.componentWillMount === "function" && instance.componentWillMount.__suppressDeprecationWarning !== true) foundWillMountName = "componentWillMount";
            else if (typeof instance.UNSAFE_componentWillMount === "function") foundWillMountName = "UNSAFE_componentWillMount";
            if (typeof instance.componentWillReceiveProps === "function" && instance.componentWillReceiveProps.__suppressDeprecationWarning !== true) foundWillReceivePropsName = "componentWillReceiveProps";
            else if (typeof instance.UNSAFE_componentWillReceiveProps === "function") foundWillReceivePropsName = "UNSAFE_componentWillReceiveProps";
            if (typeof instance.componentWillUpdate === "function" && instance.componentWillUpdate.__suppressDeprecationWarning !== true) foundWillUpdateName = "componentWillUpdate";
            else if (typeof instance.UNSAFE_componentWillUpdate === "function") foundWillUpdateName = "UNSAFE_componentWillUpdate";
            if (foundWillMountName !== null || foundWillReceivePropsName !== null || foundWillUpdateName !== null) {
                var _componentName = getComponentNameFromType(ctor) || "Component";
                var newApiName = typeof ctor.getDerivedStateFromProps === "function" ? "getDerivedStateFromProps()" : "getSnapshotBeforeUpdate()";
                if (!didWarnAboutLegacyLifecyclesAndDerivedState.has(_componentName)) {
                    didWarnAboutLegacyLifecyclesAndDerivedState.add(_componentName);
                    error("Unsafe legacy lifecycles will not be called for components using new component APIs.\n\n%s uses %s but also contains the following legacy lifecycles:%s%s%s\n\nThe above lifecycles should be removed. Learn more about this warning here:\nhttps://reactjs.org/link/unsafe-component-lifecycles", _componentName, newApiName, foundWillMountName !== null ? "\n  " + foundWillMountName : "", foundWillReceivePropsName !== null ? "\n  " + foundWillReceivePropsName : "", foundWillUpdateName !== null ? "\n  " + foundWillUpdateName : "");
                }
            }
        }
        return instance;
    }
    function checkClassInstance(instance, ctor, newProps) {
        var name = getComponentNameFromType(ctor) || "Component";
        var renderPresent = instance.render;
        if (!renderPresent) {
            if (ctor.prototype && typeof ctor.prototype.render === "function") error("%s(...): No `render` method found on the returned component instance: did you accidentally return an object from the constructor?", name);
            else error("%s(...): No `render` method found on the returned component instance: you may have forgotten to define `render`.", name);
        }
        if (instance.getInitialState && !instance.getInitialState.isReactClassApproved && !instance.state) error("getInitialState was defined on %s, a plain JavaScript class. This is only supported for classes created using React.createClass. Did you mean to define a state property instead?", name);
        if (instance.getDefaultProps && !instance.getDefaultProps.isReactClassApproved) error("getDefaultProps was defined on %s, a plain JavaScript class. This is only supported for classes created using React.createClass. Use a static property to define defaultProps instead.", name);
        if (instance.propTypes) error("propTypes was defined as an instance property on %s. Use a static property to define propTypes instead.", name);
        if (instance.contextType) error("contextType was defined as an instance property on %s. Use a static property to define contextType instead.", name);
        if (instance.contextTypes) error("contextTypes was defined as an instance property on %s. Use a static property to define contextTypes instead.", name);
        if (ctor.contextType && ctor.contextTypes && !didWarnAboutContextTypeAndContextTypes.has(ctor)) {
            didWarnAboutContextTypeAndContextTypes.add(ctor);
            error("%s declares both contextTypes and contextType static properties. The legacy contextTypes property will be ignored.", name);
        }
        if (typeof instance.componentShouldUpdate === "function") error("%s has a method called componentShouldUpdate(). Did you mean shouldComponentUpdate()? The name is phrased as a question because the function is expected to return a value.", name);
        if (ctor.prototype && ctor.prototype.isPureReactComponent && typeof instance.shouldComponentUpdate !== "undefined") error("%s has a method called shouldComponentUpdate(). shouldComponentUpdate should not be used when extending React.PureComponent. Please extend React.Component if shouldComponentUpdate is used.", getComponentNameFromType(ctor) || "A pure component");
        if (typeof instance.componentDidUnmount === "function") error("%s has a method called componentDidUnmount(). But there is no such lifecycle method. Did you mean componentWillUnmount()?", name);
        if (typeof instance.componentDidReceiveProps === "function") error("%s has a method called componentDidReceiveProps(). But there is no such lifecycle method. If you meant to update the state in response to changing props, use componentWillReceiveProps(). If you meant to fetch data or run side-effects or mutations after React has updated the UI, use componentDidUpdate().", name);
        if (typeof instance.componentWillRecieveProps === "function") error("%s has a method called componentWillRecieveProps(). Did you mean componentWillReceiveProps()?", name);
        if (typeof instance.UNSAFE_componentWillRecieveProps === "function") error("%s has a method called UNSAFE_componentWillRecieveProps(). Did you mean UNSAFE_componentWillReceiveProps()?", name);
        var hasMutatedProps = instance.props !== newProps;
        if (instance.props !== undefined && hasMutatedProps) error("%s(...): When calling super() in `%s`, make sure to pass up the same props that your component's constructor was passed.", name, name);
        if (instance.defaultProps) error("Setting defaultProps as an instance property on %s is not supported and will be ignored. Instead, define defaultProps as a static property on %s.", name, name);
        if (typeof instance.getSnapshotBeforeUpdate === "function" && typeof instance.componentDidUpdate !== "function" && !didWarnAboutGetSnapshotBeforeUpdateWithoutDidUpdate.has(ctor)) {
            didWarnAboutGetSnapshotBeforeUpdateWithoutDidUpdate.add(ctor);
            error("%s: getSnapshotBeforeUpdate() should be used with componentDidUpdate(). This component defines getSnapshotBeforeUpdate() only.", getComponentNameFromType(ctor));
        }
        if (typeof instance.getDerivedStateFromProps === "function") error("%s: getDerivedStateFromProps() is defined as an instance method and will be ignored. Instead, declare it as a static method.", name);
        if (typeof instance.getDerivedStateFromError === "function") error("%s: getDerivedStateFromError() is defined as an instance method and will be ignored. Instead, declare it as a static method.", name);
        if (typeof ctor.getSnapshotBeforeUpdate === "function") error("%s: getSnapshotBeforeUpdate() is defined as a static method and will be ignored. Instead, declare it as an instance method.", name);
        var _state = instance.state;
        if (_state && (typeof _state !== "object" || isArray(_state))) error("%s.state: must be set to an object or null", name);
        if (typeof instance.getChildContext === "function" && typeof ctor.childContextTypes !== "object") error("%s.getChildContext(): childContextTypes must be defined in order to use getChildContext().", name);
    }
    function callComponentWillMount(type, instance) {
        var oldState = instance.state;
        if (typeof instance.componentWillMount === "function") {
            if (instance.componentWillMount.__suppressDeprecationWarning !== true) {
                var componentName = getComponentNameFromType(type) || "Unknown";
                if (!didWarnAboutDeprecatedWillMount[componentName]) {
                    warn("componentWillMount has been renamed, and is not recommended for use. See https://reactjs.org/link/unsafe-component-lifecycles for details.\n\n* Move code from componentWillMount to componentDidMount (preferred in most cases) or the constructor.\n\nPlease update the following components: %s", componentName);
                    didWarnAboutDeprecatedWillMount[componentName] = true;
                }
            }
            instance.componentWillMount();
        }
        if (typeof instance.UNSAFE_componentWillMount === "function") instance.UNSAFE_componentWillMount();
        if (oldState !== instance.state) {
            error("%s.componentWillMount(): Assigning directly to this.state is deprecated (except inside a component's constructor). Use setState instead.", getComponentNameFromType(type) || "Component");
            classComponentUpdater.enqueueReplaceState(instance, instance.state, null);
        }
    }
    function processUpdateQueue(internalInstance, inst, props, maskedLegacyContext) {
        if (internalInstance.queue !== null && internalInstance.queue.length > 0) {
            var oldQueue = internalInstance.queue;
            var oldReplace = internalInstance.replace;
            internalInstance.queue = null;
            internalInstance.replace = false;
            if (oldReplace && oldQueue.length === 1) inst.state = oldQueue[0];
            else {
                var nextState = oldReplace ? oldQueue[0] : inst.state;
                var dontMutate = true;
                for(var i = oldReplace ? 1 : 0; i < oldQueue.length; i++){
                    var partial = oldQueue[i];
                    var partialState = typeof partial === "function" ? partial.call(inst, nextState, props, maskedLegacyContext) : partial;
                    if (partialState != null) {
                        if (dontMutate) {
                            dontMutate = false;
                            nextState = assign({}, nextState, partialState);
                        } else assign(nextState, partialState);
                    }
                }
                inst.state = nextState;
            }
        } else internalInstance.queue = null;
    } // Invokes the mount life-cycles on a previously never rendered instance.
    function mountClassInstance(instance, ctor, newProps, maskedLegacyContext) {
        checkClassInstance(instance, ctor, newProps);
        var initialState = instance.state !== undefined ? instance.state : null;
        instance.updater = classComponentUpdater;
        instance.props = newProps;
        instance.state = initialState; // We don't bother initializing the refs object on the server, since we're not going to resolve them anyway.
        // The internal instance will be used to manage updates that happen during this mount.
        var internalInstance = {
            queue: [],
            replace: false
        };
        set(instance, internalInstance);
        var contextType = ctor.contextType;
        if (typeof contextType === "object" && contextType !== null) instance.context = readContext(contextType);
        else instance.context = maskedLegacyContext;
        if (instance.state === newProps) {
            var componentName = getComponentNameFromType(ctor) || "Component";
            if (!didWarnAboutDirectlyAssigningPropsToState.has(componentName)) {
                didWarnAboutDirectlyAssigningPropsToState.add(componentName);
                error("%s: It is not recommended to assign props directly to state because updates to props won't be reflected in state. In most cases, it is better to use props directly.", componentName);
            }
        }
        var getDerivedStateFromProps = ctor.getDerivedStateFromProps;
        if (typeof getDerivedStateFromProps === "function") instance.state = applyDerivedStateFromProps(instance, ctor, getDerivedStateFromProps, initialState, newProps);
         // In order to support react-lifecycles-compat polyfilled components,
        // Unsafe lifecycles should not be invoked for components using the new APIs.
        if (typeof ctor.getDerivedStateFromProps !== "function" && typeof instance.getSnapshotBeforeUpdate !== "function" && (typeof instance.UNSAFE_componentWillMount === "function" || typeof instance.componentWillMount === "function")) {
            callComponentWillMount(ctor, instance); // If we had additional state updates during this life-cycle, let's
            // process them now.
            processUpdateQueue(internalInstance, instance, newProps, maskedLegacyContext);
        }
    }
    // Ids are base 32 strings whose binary representation corresponds to the
    // position of a node in a tree.
    // Every time the tree forks into multiple children, we add additional bits to
    // the left of the sequence that represent the position of the child within the
    // current level of children.
    //
    //      00101       00010001011010101
    //      ╰─┬─╯       ╰───────┬───────╯
    //   Fork 5 of 20       Parent id
    //
    // The leading 0s are important. In the above example, you only need 3 bits to
    // represent slot 5. However, you need 5 bits to represent all the forks at
    // the current level, so we must account for the empty bits at the end.
    //
    // For this same reason, slots are 1-indexed instead of 0-indexed. Otherwise,
    // the zeroth id at a level would be indistinguishable from its parent.
    //
    // If a node has only one child, and does not materialize an id (i.e. does not
    // contain a useId hook), then we don't need to allocate any space in the
    // sequence. It's treated as a transparent indirection. For example, these two
    // trees produce the same ids:
    //
    // <>                          <>
    //   <Indirection>               <A />
    //     <A />                     <B />
    //   </Indirection>            </>
    //   <B />
    // </>
    //
    // However, we cannot skip any node that materializes an id. Otherwise, a parent
    // id that does not fork would be indistinguishable from its child id. For
    // example, this tree does not fork, but the parent and child must have
    // different ids.
    //
    // <Parent>
    //   <Child />
    // </Parent>
    //
    // To handle this scenario, every time we materialize an id, we allocate a
    // new level with a single slot. You can think of this as a fork with only one
    // prong, or an array of children with length 1.
    //
    // It's possible for the size of the sequence to exceed 32 bits, the max
    // size for bitwise operations. When this happens, we make more room by
    // converting the right part of the id to a string and storing it in an overflow
    // variable. We use a base 32 string representation, because 32 is the largest
    // power of 2 that is supported by toString(). We want the base to be large so
    // that the resulting ids are compact, and we want the base to be a power of 2
    // because every log2(base) bits corresponds to a single character, i.e. every
    // log2(32) = 5 bits. That means we can lop bits off the end 5 at a time without
    // affecting the final result.
    var emptyTreeContext = {
        id: 1,
        overflow: ""
    };
    function getTreeId(context) {
        var overflow = context.overflow;
        var idWithLeadingBit = context.id;
        var id = idWithLeadingBit & ~getLeadingBit(idWithLeadingBit);
        return id.toString(32) + overflow;
    }
    function pushTreeContext(baseContext, totalChildren, index) {
        var baseIdWithLeadingBit = baseContext.id;
        var baseOverflow = baseContext.overflow; // The leftmost 1 marks the end of the sequence, non-inclusive. It's not part
        // of the id; we use it to account for leading 0s.
        var baseLength = getBitLength(baseIdWithLeadingBit) - 1;
        var baseId = baseIdWithLeadingBit & ~(1 << baseLength);
        var slot = index + 1;
        var length = getBitLength(totalChildren) + baseLength; // 30 is the max length we can store without overflowing, taking into
        // consideration the leading 1 we use to mark the end of the sequence.
        if (length > 30) {
            // We overflowed the bitwise-safe range. Fall back to slower algorithm.
            // This branch assumes the length of the base id is greater than 5; it won't
            // work for smaller ids, because you need 5 bits per character.
            //
            // We encode the id in multiple steps: first the base id, then the
            // remaining digits.
            //
            // Each 5 bit sequence corresponds to a single base 32 character. So for
            // example, if the current id is 23 bits long, we can convert 20 of those
            // bits into a string of 4 characters, with 3 bits left over.
            //
            // First calculate how many bits in the base id represent a complete
            // sequence of characters.
            var numberOfOverflowBits = baseLength - baseLength % 5; // Then create a bitmask that selects only those bits.
            var newOverflowBits = (1 << numberOfOverflowBits) - 1; // Select the bits, and convert them to a base 32 string.
            var newOverflow = (baseId & newOverflowBits).toString(32); // Now we can remove those bits from the base id.
            var restOfBaseId = baseId >> numberOfOverflowBits;
            var restOfBaseLength = baseLength - numberOfOverflowBits; // Finally, encode the rest of the bits using the normal algorithm. Because
            // we made more room, this time it won't overflow.
            var restOfLength = getBitLength(totalChildren) + restOfBaseLength;
            var restOfNewBits = slot << restOfBaseLength;
            var id = restOfNewBits | restOfBaseId;
            var overflow = newOverflow + baseOverflow;
            return {
                id: 1 << restOfLength | id,
                overflow: overflow
            };
        } else {
            // Normal path
            var newBits = slot << baseLength;
            var _id = newBits | baseId;
            var _overflow = baseOverflow;
            return {
                id: 1 << length | _id,
                overflow: _overflow
            };
        }
    }
    function getBitLength(number) {
        return 32 - clz32(number);
    }
    function getLeadingBit(id) {
        return 1 << getBitLength(id) - 1;
    } // TODO: Math.clz32 is supported in Node 12+. Maybe we can drop the fallback.
    var clz32 = Math.clz32 ? Math.clz32 : clz32Fallback; // Count leading zeros.
    // Based on:
    // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Math/clz32
    var log = Math.log;
    var LN2 = Math.LN2;
    function clz32Fallback(x) {
        var asUint = x >>> 0;
        if (asUint === 0) return 32;
        return 31 - (log(asUint) / LN2 | 0) | 0;
    }
    /**
 * inlined Object.is polyfill to avoid requiring consumers ship their own
 * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
 */ function is(x, y) {
        return x === y && (x !== 0 || 1 / x === 1 / y) || x !== x && y !== y // eslint-disable-line no-self-compare
        ;
    }
    var objectIs = typeof Object.is === "function" ? Object.is : is;
    var currentlyRenderingComponent = null;
    var currentlyRenderingTask = null;
    var firstWorkInProgressHook = null;
    var workInProgressHook = null; // Whether the work-in-progress hook is a re-rendered hook
    var isReRender = false; // Whether an update was scheduled during the currently executing render pass.
    var didScheduleRenderPhaseUpdate = false; // Counts the number of useId hooks in this component
    var localIdCounter = 0; // Lazily created map of render-phase updates
    var renderPhaseUpdates = null; // Counter to prevent infinite loops.
    var numberOfReRenders = 0;
    var RE_RENDER_LIMIT = 25;
    var isInHookUserCodeInDev = false; // In DEV, this is the name of the currently executing primitive hook
    var currentHookNameInDev;
    function resolveCurrentlyRenderingComponent() {
        if (currentlyRenderingComponent === null) throw new Error("Invalid hook call. Hooks can only be called inside of the body of a function component. This could happen for one of the following reasons:\n1. You might have mismatching versions of React and the renderer (such as React DOM)\n2. You might be breaking the Rules of Hooks\n3. You might have more than one copy of React in the same app\nSee https://reactjs.org/link/invalid-hook-call for tips about how to debug and fix this problem.");
        if (isInHookUserCodeInDev) error("Do not call Hooks inside useEffect(...), useMemo(...), or other built-in Hooks. You can only call Hooks at the top level of your React function. For more information, see https://reactjs.org/link/rules-of-hooks");
        return currentlyRenderingComponent;
    }
    function areHookInputsEqual(nextDeps, prevDeps) {
        if (prevDeps === null) {
            error("%s received a final argument during this render, but not during the previous render. Even though the final argument is optional, its type cannot change between renders.", currentHookNameInDev);
            return false;
        }
        // Don't bother comparing lengths in prod because these arrays should be
        // passed inline.
        if (nextDeps.length !== prevDeps.length) error("The final argument passed to %s changed size between renders. The order and size of this array must remain constant.\n\nPrevious: %s\nIncoming: %s", currentHookNameInDev, "[" + nextDeps.join(", ") + "]", "[" + prevDeps.join(", ") + "]");
        for(var i = 0; i < prevDeps.length && i < nextDeps.length; i++){
            if (objectIs(nextDeps[i], prevDeps[i])) continue;
            return false;
        }
        return true;
    }
    function createHook() {
        if (numberOfReRenders > 0) throw new Error("Rendered more hooks than during the previous render");
        return {
            memoizedState: null,
            queue: null,
            next: null
        };
    }
    function createWorkInProgressHook() {
        if (workInProgressHook === null) {
            // This is the first hook in the list
            if (firstWorkInProgressHook === null) {
                isReRender = false;
                firstWorkInProgressHook = workInProgressHook = createHook();
            } else {
                // There's already a work-in-progress. Reuse it.
                isReRender = true;
                workInProgressHook = firstWorkInProgressHook;
            }
        } else if (workInProgressHook.next === null) {
            isReRender = false; // Append to the end of the list
            workInProgressHook = workInProgressHook.next = createHook();
        } else {
            // There's already a work-in-progress. Reuse it.
            isReRender = true;
            workInProgressHook = workInProgressHook.next;
        }
        return workInProgressHook;
    }
    function prepareToUseHooks(task, componentIdentity) {
        currentlyRenderingComponent = componentIdentity;
        currentlyRenderingTask = task;
        isInHookUserCodeInDev = false;
        // didScheduleRenderPhaseUpdate = false;
        // localIdCounter = 0;
        // firstWorkInProgressHook = null;
        // numberOfReRenders = 0;
        // renderPhaseUpdates = null;
        // workInProgressHook = null;
        localIdCounter = 0;
    }
    function finishHooks(Component, props, children, refOrContext) {
        // This must be called after every function component to prevent hooks from
        // being used in classes.
        while(didScheduleRenderPhaseUpdate){
            // Updates were scheduled during the render phase. They are stored in
            // the `renderPhaseUpdates` map. Call the component again, reusing the
            // work-in-progress hooks and applying the additional updates on top. Keep
            // restarting until no more updates are scheduled.
            didScheduleRenderPhaseUpdate = false;
            localIdCounter = 0;
            numberOfReRenders += 1; // Start over from the beginning of the list
            workInProgressHook = null;
            children = Component(props, refOrContext);
        }
        resetHooksState();
        return children;
    }
    function checkDidRenderIdHook() {
        // This should be called immediately after every finishHooks call.
        // Conceptually, it's part of the return value of finishHooks; it's only a
        // separate function to avoid using an array tuple.
        var didRenderIdHook = localIdCounter !== 0;
        return didRenderIdHook;
    } // Reset the internal hooks state if an error occurs while rendering a component
    function resetHooksState() {
        isInHookUserCodeInDev = false;
        currentlyRenderingComponent = null;
        currentlyRenderingTask = null;
        didScheduleRenderPhaseUpdate = false;
        firstWorkInProgressHook = null;
        numberOfReRenders = 0;
        renderPhaseUpdates = null;
        workInProgressHook = null;
    }
    function readContext$1(context) {
        if (isInHookUserCodeInDev) error("Context can only be read while React is rendering. In classes, you can read it in the render method or getDerivedStateFromProps. In function components, you can read it directly in the function body, but not inside Hooks like useReducer() or useMemo().");
        return readContext(context);
    }
    function useContext(context) {
        currentHookNameInDev = "useContext";
        resolveCurrentlyRenderingComponent();
        return readContext(context);
    }
    function basicStateReducer(state, action) {
        // $FlowFixMe: Flow doesn't like mixed types
        return typeof action === "function" ? action(state) : action;
    }
    function useState(initialState) {
        currentHookNameInDev = "useState";
        return useReducer(basicStateReducer, initialState);
    }
    function useReducer(reducer, initialArg, init) {
        if (reducer !== basicStateReducer) currentHookNameInDev = "useReducer";
        currentlyRenderingComponent = resolveCurrentlyRenderingComponent();
        workInProgressHook = createWorkInProgressHook();
        if (isReRender) {
            // This is a re-render. Apply the new render phase updates to the previous
            // current hook.
            var queue = workInProgressHook.queue;
            var dispatch = queue.dispatch;
            if (renderPhaseUpdates !== null) {
                // Render phase updates are stored in a map of queue -> linked list
                var firstRenderPhaseUpdate = renderPhaseUpdates.get(queue);
                if (firstRenderPhaseUpdate !== undefined) {
                    renderPhaseUpdates.delete(queue);
                    var newState = workInProgressHook.memoizedState;
                    var update = firstRenderPhaseUpdate;
                    do {
                        // Process this render phase update. We don't have to check the
                        // priority because it will always be the same as the current
                        // render's.
                        var action = update.action;
                        isInHookUserCodeInDev = true;
                        newState = reducer(newState, action);
                        isInHookUserCodeInDev = false;
                        update = update.next;
                    }while (update !== null);
                    workInProgressHook.memoizedState = newState;
                    return [
                        newState,
                        dispatch
                    ];
                }
            }
            return [
                workInProgressHook.memoizedState,
                dispatch
            ];
        } else {
            isInHookUserCodeInDev = true;
            var initialState;
            if (reducer === basicStateReducer) // Special case for `useState`.
            initialState = typeof initialArg === "function" ? initialArg() : initialArg;
            else initialState = init !== undefined ? init(initialArg) : initialArg;
            isInHookUserCodeInDev = false;
            workInProgressHook.memoizedState = initialState;
            var _queue = workInProgressHook.queue = {
                last: null,
                dispatch: null
            };
            var _dispatch = _queue.dispatch = dispatchAction.bind(null, currentlyRenderingComponent, _queue);
            return [
                workInProgressHook.memoizedState,
                _dispatch
            ];
        }
    }
    function useMemo(nextCreate, deps) {
        currentlyRenderingComponent = resolveCurrentlyRenderingComponent();
        workInProgressHook = createWorkInProgressHook();
        var nextDeps = deps === undefined ? null : deps;
        if (workInProgressHook !== null) {
            var prevState = workInProgressHook.memoizedState;
            if (prevState !== null) {
                if (nextDeps !== null) {
                    var prevDeps = prevState[1];
                    if (areHookInputsEqual(nextDeps, prevDeps)) return prevState[0];
                }
            }
        }
        isInHookUserCodeInDev = true;
        var nextValue = nextCreate();
        isInHookUserCodeInDev = false;
        workInProgressHook.memoizedState = [
            nextValue,
            nextDeps
        ];
        return nextValue;
    }
    function useRef(initialValue) {
        currentlyRenderingComponent = resolveCurrentlyRenderingComponent();
        workInProgressHook = createWorkInProgressHook();
        var previousRef = workInProgressHook.memoizedState;
        if (previousRef === null) {
            var ref = {
                current: initialValue
            };
            Object.seal(ref);
            workInProgressHook.memoizedState = ref;
            return ref;
        } else return previousRef;
    }
    function useLayoutEffect(create, inputs) {
        currentHookNameInDev = "useLayoutEffect";
        error("useLayoutEffect does nothing on the server, because its effect cannot be encoded into the server renderer's output format. This will lead to a mismatch between the initial, non-hydrated UI and the intended UI. To avoid this, useLayoutEffect should only be used in components that render exclusively on the client. See https://reactjs.org/link/uselayouteffect-ssr for common fixes.");
    }
    function dispatchAction(componentIdentity, queue, action) {
        if (numberOfReRenders >= RE_RENDER_LIMIT) throw new Error("Too many re-renders. React limits the number of renders to prevent an infinite loop.");
        if (componentIdentity === currentlyRenderingComponent) {
            // This is a render phase update. Stash it in a lazily-created map of
            // queue -> linked list of updates. After this render pass, we'll restart
            // and apply the stashed updates on top of the work-in-progress hook.
            didScheduleRenderPhaseUpdate = true;
            var update = {
                action: action,
                next: null
            };
            if (renderPhaseUpdates === null) renderPhaseUpdates = new Map();
            var firstRenderPhaseUpdate = renderPhaseUpdates.get(queue);
            if (firstRenderPhaseUpdate === undefined) renderPhaseUpdates.set(queue, update);
            else {
                // Append the update to the end of the list.
                var lastRenderPhaseUpdate = firstRenderPhaseUpdate;
                while(lastRenderPhaseUpdate.next !== null)lastRenderPhaseUpdate = lastRenderPhaseUpdate.next;
                lastRenderPhaseUpdate.next = update;
            }
        }
    }
    function useCallback(callback, deps) {
        return useMemo(function() {
            return callback;
        }, deps);
    } // TODO Decide on how to implement this hook for server rendering.
    // If a mutation occurs during render, consider triggering a Suspense boundary
    // and falling back to client rendering.
    function useMutableSource(source, getSnapshot, subscribe) {
        resolveCurrentlyRenderingComponent();
        return getSnapshot(source._source);
    }
    function useSyncExternalStore(subscribe, getSnapshot, getServerSnapshot) {
        if (getServerSnapshot === undefined) throw new Error("Missing getServerSnapshot, which is required for server-rendered content. Will revert to client rendering.");
        return getServerSnapshot();
    }
    function useDeferredValue(value) {
        resolveCurrentlyRenderingComponent();
        return value;
    }
    function unsupportedStartTransition() {
        throw new Error("startTransition cannot be called during server rendering.");
    }
    function useTransition() {
        resolveCurrentlyRenderingComponent();
        return [
            false,
            unsupportedStartTransition
        ];
    }
    function useId() {
        var task = currentlyRenderingTask;
        var treeId = getTreeId(task.treeContext);
        var responseState = currentResponseState;
        if (responseState === null) throw new Error("Invalid hook call. Hooks can only be called inside of the body of a function component.");
        var localId = localIdCounter++;
        return makeId(responseState, treeId, localId);
    }
    function noop() {}
    var Dispatcher = {
        readContext: readContext$1,
        useContext: useContext,
        useMemo: useMemo,
        useReducer: useReducer,
        useRef: useRef,
        useState: useState,
        useInsertionEffect: noop,
        useLayoutEffect: useLayoutEffect,
        useCallback: useCallback,
        // useImperativeHandle is not run in the server environment
        useImperativeHandle: noop,
        // Effects are not run in the server environment.
        useEffect: noop,
        // Debugging effect
        useDebugValue: noop,
        useDeferredValue: useDeferredValue,
        useTransition: useTransition,
        useId: useId,
        // Subscriptions are not setup in a server environment.
        useMutableSource: useMutableSource,
        useSyncExternalStore: useSyncExternalStore
    };
    var currentResponseState = null;
    function setCurrentResponseState(responseState) {
        currentResponseState = responseState;
    }
    function getStackByComponentStackNode(componentStack) {
        try {
            var info = "";
            var node = componentStack;
            do {
                switch(node.tag){
                    case 0:
                        info += describeBuiltInComponentFrame(node.type, null, null);
                        break;
                    case 1:
                        info += describeFunctionComponentFrame(node.type, null, null);
                        break;
                    case 2:
                        info += describeClassComponentFrame(node.type, null, null);
                        break;
                }
                node = node.parent;
            }while (node);
            return info;
        } catch (x) {
            return "\nError generating stack: " + x.message + "\n" + x.stack;
        }
    }
    var ReactCurrentDispatcher$1 = ReactSharedInternals.ReactCurrentDispatcher;
    var ReactDebugCurrentFrame$1 = ReactSharedInternals.ReactDebugCurrentFrame;
    var PENDING = 0;
    var COMPLETED = 1;
    var FLUSHED = 2;
    var ABORTED = 3;
    var ERRORED = 4;
    var OPEN = 0;
    var CLOSING = 1;
    var CLOSED = 2;
    // This is a default heuristic for how to split up the HTML content into progressive
    // loading. Our goal is to be able to display additional new content about every 500ms.
    // Faster than that is unnecessary and should be throttled on the client. It also
    // adds unnecessary overhead to do more splits. We don't know if it's a higher or lower
    // end device but higher end suffer less from the overhead than lower end does from
    // not getting small enough pieces. We error on the side of low end.
    // We base this on low end 3G speeds which is about 500kbits per second. We assume
    // that there can be a reasonable drop off from max bandwidth which leaves you with
    // as little as 80%. We can receive half of that each 500ms - at best. In practice,
    // a little bandwidth is lost to processing and contention - e.g. CSS and images that
    // are downloaded along with the main content. So we estimate about half of that to be
    // the lower end throughput. In other words, we expect that you can at least show
    // about 12.5kb of content per 500ms. Not counting starting latency for the first
    // paint.
    // 500 * 1024 / 8 * .8 * 0.5 / 2
    var DEFAULT_PROGRESSIVE_CHUNK_SIZE = 12800;
    function defaultErrorHandler(error) {
        console["error"](error); // Don't transform to our wrapper
        return null;
    }
    function noop$1() {}
    function createRequest(children, responseState, rootFormatContext, progressiveChunkSize, onError, onAllReady, onShellReady, onShellError, onFatalError) {
        var pingedTasks = [];
        var abortSet = new Set();
        var request = {
            destination: null,
            responseState: responseState,
            progressiveChunkSize: progressiveChunkSize === undefined ? DEFAULT_PROGRESSIVE_CHUNK_SIZE : progressiveChunkSize,
            status: OPEN,
            fatalError: null,
            nextSegmentId: 0,
            allPendingTasks: 0,
            pendingRootTasks: 0,
            completedRootSegment: null,
            abortableTasks: abortSet,
            pingedTasks: pingedTasks,
            clientRenderedBoundaries: [],
            completedBoundaries: [],
            partialBoundaries: [],
            onError: onError === undefined ? defaultErrorHandler : onError,
            onAllReady: onAllReady === undefined ? noop$1 : onAllReady,
            onShellReady: onShellReady === undefined ? noop$1 : onShellReady,
            onShellError: onShellError === undefined ? noop$1 : onShellError,
            onFatalError: onFatalError === undefined ? noop$1 : onFatalError
        }; // This segment represents the root fallback.
        var rootSegment = createPendingSegment(request, 0, null, rootFormatContext, false, false); // There is no parent so conceptually, we're unblocked to flush this segment.
        rootSegment.parentFlushed = true;
        var rootTask = createTask(request, children, null, rootSegment, abortSet, emptyContextObject, rootContextSnapshot, emptyTreeContext);
        pingedTasks.push(rootTask);
        return request;
    }
    function pingTask(request, task) {
        var pingedTasks = request.pingedTasks;
        pingedTasks.push(task);
        if (pingedTasks.length === 1) scheduleWork(function() {
            return performWork(request);
        });
    }
    function createSuspenseBoundary(request, fallbackAbortableTasks) {
        return {
            id: UNINITIALIZED_SUSPENSE_BOUNDARY_ID,
            rootSegmentID: -1,
            parentFlushed: false,
            pendingTasks: 0,
            forceClientRender: false,
            completedSegments: [],
            byteSize: 0,
            fallbackAbortableTasks: fallbackAbortableTasks,
            errorDigest: null
        };
    }
    function createTask(request, node, blockedBoundary, blockedSegment, abortSet, legacyContext, context, treeContext) {
        request.allPendingTasks++;
        if (blockedBoundary === null) request.pendingRootTasks++;
        else blockedBoundary.pendingTasks++;
        var task = {
            node: node,
            ping: function() {
                return pingTask(request, task);
            },
            blockedBoundary: blockedBoundary,
            blockedSegment: blockedSegment,
            abortSet: abortSet,
            legacyContext: legacyContext,
            context: context,
            treeContext: treeContext
        };
        task.componentStack = null;
        abortSet.add(task);
        return task;
    }
    function createPendingSegment(request, index, boundary, formatContext, lastPushedText, textEmbedded) {
        return {
            status: PENDING,
            id: -1,
            // lazily assigned later
            index: index,
            parentFlushed: false,
            chunks: [],
            children: [],
            formatContext: formatContext,
            boundary: boundary,
            lastPushedText: lastPushedText,
            textEmbedded: textEmbedded
        };
    } // DEV-only global reference to the currently executing task
    var currentTaskInDEV = null;
    function getCurrentStackInDEV() {
        if (currentTaskInDEV === null || currentTaskInDEV.componentStack === null) return "";
        return getStackByComponentStackNode(currentTaskInDEV.componentStack);
    }
    function pushBuiltInComponentStackInDEV(task, type) {
        task.componentStack = {
            tag: 0,
            parent: task.componentStack,
            type: type
        };
    }
    function pushFunctionComponentStackInDEV(task, type) {
        task.componentStack = {
            tag: 1,
            parent: task.componentStack,
            type: type
        };
    }
    function pushClassComponentStackInDEV(task, type) {
        task.componentStack = {
            tag: 2,
            parent: task.componentStack,
            type: type
        };
    }
    function popComponentStackInDEV(task) {
        if (task.componentStack === null) error("Unexpectedly popped too many stack frames. This is a bug in React.");
        else task.componentStack = task.componentStack.parent;
    } // stash the component stack of an unwinding error until it is processed
    var lastBoundaryErrorComponentStackDev = null;
    function captureBoundaryErrorDetailsDev(boundary, error) {
        var errorMessage;
        if (typeof error === "string") errorMessage = error;
        else if (error && typeof error.message === "string") errorMessage = error.message;
        else // eslint-disable-next-line react-internal/safe-string-coercion
        errorMessage = String(error);
        var errorComponentStack = lastBoundaryErrorComponentStackDev || getCurrentStackInDEV();
        lastBoundaryErrorComponentStackDev = null;
        boundary.errorMessage = errorMessage;
        boundary.errorComponentStack = errorComponentStack;
    }
    function logRecoverableError(request, error) {
        // If this callback errors, we intentionally let that error bubble up to become a fatal error
        // so that someone fixes the error reporting instead of hiding it.
        var errorDigest = request.onError(error);
        if (errorDigest != null && typeof errorDigest !== "string") // eslint-disable-next-line react-internal/prod-error-codes
        throw new Error('onError returned something with a type other than "string". onError should return a string and may return null or undefined but must not return anything else. It received something of type "' + typeof errorDigest + '" instead');
        return errorDigest;
    }
    function fatalError(request, error) {
        // This is called outside error handling code such as if the root errors outside
        // a suspense boundary or if the root suspense boundary's fallback errors.
        // It's also called if React itself or its host configs errors.
        var onShellError = request.onShellError;
        onShellError(error);
        var onFatalError = request.onFatalError;
        onFatalError(error);
        if (request.destination !== null) {
            request.status = CLOSED;
            closeWithError(request.destination, error);
        } else {
            request.status = CLOSING;
            request.fatalError = error;
        }
    }
    function renderSuspenseBoundary(request, task, props) {
        pushBuiltInComponentStackInDEV(task, "Suspense");
        var parentBoundary = task.blockedBoundary;
        var parentSegment = task.blockedSegment; // Each time we enter a suspense boundary, we split out into a new segment for
        // the fallback so that we can later replace that segment with the content.
        // This also lets us split out the main content even if it doesn't suspend,
        // in case it ends up generating a large subtree of content.
        var fallback = props.fallback;
        var content = props.children;
        var fallbackAbortSet = new Set();
        var newBoundary = createSuspenseBoundary(request, fallbackAbortSet);
        var insertionIndex = parentSegment.chunks.length; // The children of the boundary segment is actually the fallback.
        var boundarySegment = createPendingSegment(request, insertionIndex, newBoundary, parentSegment.formatContext, false, false);
        parentSegment.children.push(boundarySegment); // The parentSegment has a child Segment at this index so we reset the lastPushedText marker on the parent
        parentSegment.lastPushedText = false; // This segment is the actual child content. We can start rendering that immediately.
        var contentRootSegment = createPendingSegment(request, 0, null, parentSegment.formatContext, false, false); // We mark the root segment as having its parent flushed. It's not really flushed but there is
        // no parent segment so there's nothing to wait on.
        contentRootSegment.parentFlushed = true; // Currently this is running synchronously. We could instead schedule this to pingedTasks.
        // I suspect that there might be some efficiency benefits from not creating the suspended task
        // and instead just using the stack if possible.
        // TODO: Call this directly instead of messing with saving and restoring contexts.
        // We can reuse the current context and task to render the content immediately without
        // context switching. We just need to temporarily switch which boundary and which segment
        // we're writing to. If something suspends, it'll spawn new suspended task with that context.
        task.blockedBoundary = newBoundary;
        task.blockedSegment = contentRootSegment;
        try {
            // We use the safe form because we don't handle suspending here. Only error handling.
            renderNode(request, task, content);
            pushSegmentFinale(contentRootSegment.chunks, request.responseState, contentRootSegment.lastPushedText, contentRootSegment.textEmbedded);
            contentRootSegment.status = COMPLETED;
            queueCompletedSegment(newBoundary, contentRootSegment);
            if (newBoundary.pendingTasks === 0) {
                // This must have been the last segment we were waiting on. This boundary is now complete.
                // Therefore we won't need the fallback. We early return so that we don't have to create
                // the fallback.
                popComponentStackInDEV(task);
                return;
            }
        } catch (error) {
            contentRootSegment.status = ERRORED;
            newBoundary.forceClientRender = true;
            newBoundary.errorDigest = logRecoverableError(request, error);
            captureBoundaryErrorDetailsDev(newBoundary, error);
        // We don't need to schedule any task because we know the parent has written yet.
        // We do need to fallthrough to create the fallback though.
        } finally{
            task.blockedBoundary = parentBoundary;
            task.blockedSegment = parentSegment;
        } // We create suspended task for the fallback because we don't want to actually work
        // on it yet in case we finish the main content, so we queue for later.
        var suspendedFallbackTask = createTask(request, fallback, parentBoundary, boundarySegment, fallbackAbortSet, task.legacyContext, task.context, task.treeContext);
        suspendedFallbackTask.componentStack = task.componentStack;
        // on preparing fallbacks if we don't have any more main content to task on.
        request.pingedTasks.push(suspendedFallbackTask);
        popComponentStackInDEV(task);
    }
    function renderHostElement(request, task, type, props) {
        pushBuiltInComponentStackInDEV(task, type);
        var segment = task.blockedSegment;
        var children = pushStartInstance(segment.chunks, type, props, request.responseState, segment.formatContext);
        segment.lastPushedText = false;
        var prevContext = segment.formatContext;
        segment.formatContext = getChildFormatContext(prevContext, type, props); // We use the non-destructive form because if something suspends, we still
        // need to pop back up and finish this subtree of HTML.
        renderNode(request, task, children); // We expect that errors will fatal the whole task and that we don't need
        // the correct context. Therefore this is not in a finally.
        segment.formatContext = prevContext;
        pushEndInstance(segment.chunks, type);
        segment.lastPushedText = false;
        popComponentStackInDEV(task);
    }
    function shouldConstruct$1(Component) {
        return Component.prototype && Component.prototype.isReactComponent;
    }
    function renderWithHooks(request, task, Component, props, secondArg) {
        var componentIdentity = {};
        prepareToUseHooks(task, componentIdentity);
        var result = Component(props, secondArg);
        return finishHooks(Component, props, result, secondArg);
    }
    function finishClassComponent(request, task, instance, Component, props) {
        var nextChildren = instance.render();
        if (instance.props !== props) {
            if (!didWarnAboutReassigningProps) error("It looks like %s is reassigning its own `this.props` while rendering. This is not supported and can lead to confusing bugs.", getComponentNameFromType(Component) || "a component");
            didWarnAboutReassigningProps = true;
        }
        var childContextTypes = Component.childContextTypes;
        if (childContextTypes !== null && childContextTypes !== undefined) {
            var previousContext = task.legacyContext;
            var mergedContext = processChildContext(instance, Component, previousContext, childContextTypes);
            task.legacyContext = mergedContext;
            renderNodeDestructive(request, task, nextChildren);
            task.legacyContext = previousContext;
            return;
        }
        renderNodeDestructive(request, task, nextChildren);
    }
    function renderClassComponent(request, task, Component, props) {
        pushClassComponentStackInDEV(task, Component);
        var maskedContext = getMaskedContext(Component, task.legacyContext);
        var instance = constructClassInstance(Component, props, maskedContext);
        mountClassInstance(instance, Component, props, maskedContext);
        finishClassComponent(request, task, instance, Component, props);
        popComponentStackInDEV(task);
    }
    var didWarnAboutBadClass = {};
    var didWarnAboutModulePatternComponent = {};
    var didWarnAboutContextTypeOnFunctionComponent = {};
    var didWarnAboutGetDerivedStateOnFunctionComponent = {};
    var didWarnAboutReassigningProps = false;
    var didWarnAboutGenerators = false;
    var didWarnAboutMaps = false;
    var hasWarnedAboutUsingContextAsConsumer = false; // This would typically be a function component but we still support module pattern
    // components for some reason.
    function renderIndeterminateComponent(request, task, Component, props) {
        var legacyContext;
        legacyContext = getMaskedContext(Component, task.legacyContext);
        pushFunctionComponentStackInDEV(task, Component);
        if (Component.prototype && typeof Component.prototype.render === "function") {
            var componentName = getComponentNameFromType(Component) || "Unknown";
            if (!didWarnAboutBadClass[componentName]) {
                error("The <%s /> component appears to have a render method, but doesn't extend React.Component. This is likely to cause errors. Change %s to extend React.Component instead.", componentName, componentName);
                didWarnAboutBadClass[componentName] = true;
            }
        }
        var value = renderWithHooks(request, task, Component, props, legacyContext);
        var hasId = checkDidRenderIdHook();
        // Support for module components is deprecated and is removed behind a flag.
        // Whether or not it would crash later, we want to show a good message in DEV first.
        if (typeof value === "object" && value !== null && typeof value.render === "function" && value.$$typeof === undefined) {
            var _componentName = getComponentNameFromType(Component) || "Unknown";
            if (!didWarnAboutModulePatternComponent[_componentName]) {
                error("The <%s /> component appears to be a function component that returns a class instance. Change %s to a class that extends React.Component instead. If you can't use a class try assigning the prototype on the function as a workaround. `%s.prototype = React.Component.prototype`. Don't use an arrow function since it cannot be called with `new` by React.", _componentName, _componentName, _componentName);
                didWarnAboutModulePatternComponent[_componentName] = true;
            }
        }
        if (// Eventually we'll delete this branch altogether.
        typeof value === "object" && value !== null && typeof value.render === "function" && value.$$typeof === undefined) {
            var _componentName2 = getComponentNameFromType(Component) || "Unknown";
            if (!didWarnAboutModulePatternComponent[_componentName2]) {
                error("The <%s /> component appears to be a function component that returns a class instance. Change %s to a class that extends React.Component instead. If you can't use a class try assigning the prototype on the function as a workaround. `%s.prototype = React.Component.prototype`. Don't use an arrow function since it cannot be called with `new` by React.", _componentName2, _componentName2, _componentName2);
                didWarnAboutModulePatternComponent[_componentName2] = true;
            }
            mountClassInstance(value, Component, props, legacyContext);
            finishClassComponent(request, task, value, Component, props);
        } else {
            validateFunctionComponentInDev(Component);
            // the previous task every again, so we can use the destructive recursive form.
            if (hasId) {
                // This component materialized an id. We treat this as its own level, with
                // a single "child" slot.
                var prevTreeContext = task.treeContext;
                var totalChildren = 1;
                var index = 0;
                task.treeContext = pushTreeContext(prevTreeContext, totalChildren, index);
                try {
                    renderNodeDestructive(request, task, value);
                } finally{
                    task.treeContext = prevTreeContext;
                }
            } else renderNodeDestructive(request, task, value);
        }
        popComponentStackInDEV(task);
    }
    function validateFunctionComponentInDev(Component) {
        if (Component) {
            if (Component.childContextTypes) error("%s(...): childContextTypes cannot be defined on a function component.", Component.displayName || Component.name || "Component");
        }
        if (typeof Component.getDerivedStateFromProps === "function") {
            var _componentName3 = getComponentNameFromType(Component) || "Unknown";
            if (!didWarnAboutGetDerivedStateOnFunctionComponent[_componentName3]) {
                error("%s: Function components do not support getDerivedStateFromProps.", _componentName3);
                didWarnAboutGetDerivedStateOnFunctionComponent[_componentName3] = true;
            }
        }
        if (typeof Component.contextType === "object" && Component.contextType !== null) {
            var _componentName4 = getComponentNameFromType(Component) || "Unknown";
            if (!didWarnAboutContextTypeOnFunctionComponent[_componentName4]) {
                error("%s: Function components do not support contextType.", _componentName4);
                didWarnAboutContextTypeOnFunctionComponent[_componentName4] = true;
            }
        }
    }
    function resolveDefaultProps(Component, baseProps) {
        if (Component && Component.defaultProps) {
            // Resolve default props. Taken from ReactElement
            var props = assign({}, baseProps);
            var defaultProps = Component.defaultProps;
            for(var propName in defaultProps)if (props[propName] === undefined) props[propName] = defaultProps[propName];
            return props;
        }
        return baseProps;
    }
    function renderForwardRef(request, task, type, props, ref) {
        pushFunctionComponentStackInDEV(task, type.render);
        var children = renderWithHooks(request, task, type.render, props, ref);
        var hasId = checkDidRenderIdHook();
        if (hasId) {
            // This component materialized an id. We treat this as its own level, with
            // a single "child" slot.
            var prevTreeContext = task.treeContext;
            var totalChildren = 1;
            var index = 0;
            task.treeContext = pushTreeContext(prevTreeContext, totalChildren, index);
            try {
                renderNodeDestructive(request, task, children);
            } finally{
                task.treeContext = prevTreeContext;
            }
        } else renderNodeDestructive(request, task, children);
        popComponentStackInDEV(task);
    }
    function renderMemo(request, task, type, props, ref) {
        var innerType = type.type;
        var resolvedProps = resolveDefaultProps(innerType, props);
        renderElement(request, task, innerType, resolvedProps, ref);
    }
    function renderContextConsumer(request, task, context, props) {
        if (context._context === undefined) {
            // This may be because it's a Context (rather than a Consumer).
            // Or it may be because it's older React where they're the same thing.
            // We only want to warn if we're sure it's a new React.
            if (context !== context.Consumer) {
                if (!hasWarnedAboutUsingContextAsConsumer) {
                    hasWarnedAboutUsingContextAsConsumer = true;
                    error("Rendering <Context> directly is not supported and will be removed in a future major release. Did you mean to render <Context.Consumer> instead?");
                }
            }
        } else context = context._context;
        var render = props.children;
        if (typeof render !== "function") error("A context consumer was rendered with multiple children, or a child that isn't a function. A context consumer expects a single child that is a function. If you did pass a function, make sure there is no trailing or leading whitespace around it.");
        var newValue = readContext(context);
        var newChildren = render(newValue);
        renderNodeDestructive(request, task, newChildren);
    }
    function renderContextProvider(request, task, type, props) {
        var context = type._context;
        var value = props.value;
        var children = props.children;
        var prevSnapshot;
        prevSnapshot = task.context;
        task.context = pushProvider(context, value);
        renderNodeDestructive(request, task, children);
        task.context = popProvider(context);
        if (prevSnapshot !== task.context) error("Popping the context provider did not return back to the original snapshot. This is a bug in React.");
    }
    function renderLazyComponent(request, task, lazyComponent, props, ref) {
        pushBuiltInComponentStackInDEV(task, "Lazy");
        var payload = lazyComponent._payload;
        var init = lazyComponent._init;
        var Component = init(payload);
        var resolvedProps = resolveDefaultProps(Component, props);
        renderElement(request, task, Component, resolvedProps, ref);
        popComponentStackInDEV(task);
    }
    function renderElement(request, task, type, props, ref) {
        if (typeof type === "function") {
            if (shouldConstruct$1(type)) {
                renderClassComponent(request, task, type, props);
                return;
            } else {
                renderIndeterminateComponent(request, task, type, props);
                return;
            }
        }
        if (typeof type === "string") {
            renderHostElement(request, task, type, props);
            return;
        }
        switch(type){
            // TODO: LegacyHidden acts the same as a fragment. This only works
            // because we currently assume that every instance of LegacyHidden is
            // accompanied by a host component wrapper. In the hidden mode, the host
            // component is given a `hidden` attribute, which ensures that the
            // initial HTML is not visible. To support the use of LegacyHidden as a
            // true fragment, without an extra DOM node, we would have to hide the
            // initial HTML in some other way.
            // TODO: Add REACT_OFFSCREEN_TYPE here too with the same capability.
            case REACT_LEGACY_HIDDEN_TYPE:
            case REACT_DEBUG_TRACING_MODE_TYPE:
            case REACT_STRICT_MODE_TYPE:
            case REACT_PROFILER_TYPE:
            case REACT_FRAGMENT_TYPE:
                renderNodeDestructive(request, task, props.children);
                return;
            case REACT_SUSPENSE_LIST_TYPE:
                pushBuiltInComponentStackInDEV(task, "SuspenseList"); // TODO: SuspenseList should control the boundaries.
                renderNodeDestructive(request, task, props.children);
                popComponentStackInDEV(task);
                return;
            case REACT_SCOPE_TYPE:
                throw new Error("ReactDOMServer does not yet support scope components.");
            // eslint-disable-next-line-no-fallthrough
            case REACT_SUSPENSE_TYPE:
                renderSuspenseBoundary(request, task, props);
                return;
        }
        if (typeof type === "object" && type !== null) switch(type.$$typeof){
            case REACT_FORWARD_REF_TYPE:
                renderForwardRef(request, task, type, props, ref);
                return;
            case REACT_MEMO_TYPE:
                renderMemo(request, task, type, props, ref);
                return;
            case REACT_PROVIDER_TYPE:
                renderContextProvider(request, task, type, props);
                return;
            case REACT_CONTEXT_TYPE:
                renderContextConsumer(request, task, type, props);
                return;
            case REACT_LAZY_TYPE:
                renderLazyComponent(request, task, type, props);
                return;
        }
        var info = "";
        if (type === undefined || typeof type === "object" && type !== null && Object.keys(type).length === 0) info += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.";
        throw new Error("Element type is invalid: expected a string (for built-in components) or a class/function (for composite components) " + ("but got: " + (type == null ? type : typeof type) + "." + info));
    }
    function validateIterable(iterable, iteratorFn) {
        // We don't support rendering Generators because it's a mutation.
        // See https://github.com/facebook/react/issues/12995
        if (typeof Symbol === "function" && // $FlowFixMe Flow doesn't know about toStringTag
        iterable[Symbol.toStringTag] === "Generator") {
            if (!didWarnAboutGenerators) error("Using Generators as children is unsupported and will likely yield unexpected results because enumerating a generator mutates it. You may convert it to an array with `Array.from()` or the `[...spread]` operator before rendering. Keep in mind you might need to polyfill these features for older browsers.");
            didWarnAboutGenerators = true;
        } // Warn about using Maps as children
        if (iterable.entries === iteratorFn) {
            if (!didWarnAboutMaps) error("Using Maps as children is not supported. Use an array of keyed ReactElements instead.");
            didWarnAboutMaps = true;
        }
    }
    function renderNodeDestructive(request, task, node) {
        // In Dev we wrap renderNodeDestructiveImpl in a try / catch so we can capture
        // a component stack at the right place in the tree. We don't do this in renderNode
        // becuase it is not called at every layer of the tree and we may lose frames
        try {
            return renderNodeDestructiveImpl(request, task, node);
        } catch (x) {
            if (typeof x === "object" && x !== null && typeof x.then === "function") ;
            else // This is an error, stash the component stack if it is null.
            lastBoundaryErrorComponentStackDev = lastBoundaryErrorComponentStackDev !== null ? lastBoundaryErrorComponentStackDev : getCurrentStackInDEV();
             // rethrow so normal suspense logic can handle thrown value accordingly
            throw x;
        }
    } // This function by it self renders a node and consumes the task by mutating it
    // to update the current execution state.
    function renderNodeDestructiveImpl(request, task, node) {
        // Stash the node we're working on. We'll pick up from this task in case
        // something suspends.
        task.node = node; // Handle object types
        if (typeof node === "object" && node !== null) {
            switch(node.$$typeof){
                case REACT_ELEMENT_TYPE:
                    var element = node;
                    var type = element.type;
                    var props = element.props;
                    var ref = element.ref;
                    renderElement(request, task, type, props, ref);
                    return;
                case REACT_PORTAL_TYPE:
                    throw new Error("Portals are not currently supported by the server renderer. Render them conditionally so that they only appear on the client render.");
                // eslint-disable-next-line-no-fallthrough
                case REACT_LAZY_TYPE:
                    var lazyNode = node;
                    var payload = lazyNode._payload;
                    var init = lazyNode._init;
                    var resolvedNode;
                    try {
                        resolvedNode = init(payload);
                    } catch (x) {
                        if (typeof x === "object" && x !== null && typeof x.then === "function") // this Lazy initializer is suspending. push a temporary frame onto the stack so it can be
                        // popped off in spawnNewSuspendedTask. This aligns stack behavior between Lazy in element position
                        // vs Component position. We do not want the frame for Errors so we exclusively do this in
                        // the wakeable branch
                        pushBuiltInComponentStackInDEV(task, "Lazy");
                        throw x;
                    }
                    renderNodeDestructive(request, task, resolvedNode);
                    return;
            }
            if (isArray(node)) {
                renderChildrenArray(request, task, node);
                return;
            }
            var iteratorFn = getIteratorFn(node);
            if (iteratorFn) {
                validateIterable(node, iteratorFn);
                var iterator = iteratorFn.call(node);
                if (iterator) {
                    // We need to know how many total children are in this set, so that we
                    // can allocate enough id slots to acommodate them. So we must exhaust
                    // the iterator before we start recursively rendering the children.
                    // TODO: This is not great but I think it's inherent to the id
                    // generation algorithm.
                    var step = iterator.next(); // If there are not entries, we need to push an empty so we start by checking that.
                    if (!step.done) {
                        var children = [];
                        do {
                            children.push(step.value);
                            step = iterator.next();
                        }while (!step.done);
                        renderChildrenArray(request, task, children);
                        return;
                    }
                    return;
                }
            }
            var childString = Object.prototype.toString.call(node);
            throw new Error("Objects are not valid as a React child (found: " + (childString === "[object Object]" ? "object with keys {" + Object.keys(node).join(", ") + "}" : childString) + "). " + "If you meant to render a collection of children, use an array " + "instead.");
        }
        if (typeof node === "string") {
            var segment = task.blockedSegment;
            segment.lastPushedText = pushTextInstance(task.blockedSegment.chunks, node, request.responseState, segment.lastPushedText);
            return;
        }
        if (typeof node === "number") {
            var _segment = task.blockedSegment;
            _segment.lastPushedText = pushTextInstance(task.blockedSegment.chunks, "" + node, request.responseState, _segment.lastPushedText);
            return;
        }
        if (typeof node === "function") error("Functions are not valid as a React child. This may happen if you return a Component instead of <Component /> from render. Or maybe you meant to call this function rather than return it.");
    }
    function renderChildrenArray(request, task, children) {
        var totalChildren = children.length;
        for(var i = 0; i < totalChildren; i++){
            var prevTreeContext = task.treeContext;
            task.treeContext = pushTreeContext(prevTreeContext, totalChildren, i);
            try {
                // We need to use the non-destructive form so that we can safely pop back
                // up and render the sibling if something suspends.
                renderNode(request, task, children[i]);
            } finally{
                task.treeContext = prevTreeContext;
            }
        }
    }
    function spawnNewSuspendedTask(request, task, x) {
        // Something suspended, we'll need to create a new segment and resolve it later.
        var segment = task.blockedSegment;
        var insertionIndex = segment.chunks.length;
        var newSegment = createPendingSegment(request, insertionIndex, null, segment.formatContext, segment.lastPushedText, true);
        segment.children.push(newSegment); // Reset lastPushedText for current Segment since the new Segment "consumed" it
        segment.lastPushedText = false;
        var newTask = createTask(request, task.node, task.blockedBoundary, newSegment, task.abortSet, task.legacyContext, task.context, task.treeContext);
        if (task.componentStack !== null) // We pop one task off the stack because the node that suspended will be tried again,
        // which will add it back onto the stack.
        newTask.componentStack = task.componentStack.parent;
        var ping = newTask.ping;
        x.then(ping, ping);
    } // This is a non-destructive form of rendering a node. If it suspends it spawns
    // a new task and restores the context of this task to what it was before.
    function renderNode(request, task, node) {
        // TODO: Store segment.children.length here and reset it in case something
        // suspended partially through writing something.
        // Snapshot the current context in case something throws to interrupt the
        // process.
        var previousFormatContext = task.blockedSegment.formatContext;
        var previousLegacyContext = task.legacyContext;
        var previousContext = task.context;
        var previousComponentStack = null;
        previousComponentStack = task.componentStack;
        try {
            return renderNodeDestructive(request, task, node);
        } catch (x) {
            resetHooksState();
            if (typeof x === "object" && x !== null && typeof x.then === "function") {
                spawnNewSuspendedTask(request, task, x); // Restore the context. We assume that this will be restored by the inner
                // functions in case nothing throws so we don't use "finally" here.
                task.blockedSegment.formatContext = previousFormatContext;
                task.legacyContext = previousLegacyContext;
                task.context = previousContext; // Restore all active ReactContexts to what they were before.
                switchContext(previousContext);
                task.componentStack = previousComponentStack;
                return;
            } else {
                // Restore the context. We assume that this will be restored by the inner
                // functions in case nothing throws so we don't use "finally" here.
                task.blockedSegment.formatContext = previousFormatContext;
                task.legacyContext = previousLegacyContext;
                task.context = previousContext; // Restore all active ReactContexts to what they were before.
                switchContext(previousContext);
                task.componentStack = previousComponentStack;
                // Let's terminate the rest of the tree and don't render any siblings.
                throw x;
            }
        }
    }
    function erroredTask(request, boundary, segment, error) {
        // Report the error to a global handler.
        var errorDigest = logRecoverableError(request, error);
        if (boundary === null) fatalError(request, error);
        else {
            boundary.pendingTasks--;
            if (!boundary.forceClientRender) {
                boundary.forceClientRender = true;
                boundary.errorDigest = errorDigest;
                captureBoundaryErrorDetailsDev(boundary, error);
                // so we can flush it, if the parent already flushed.
                if (boundary.parentFlushed) // We don't have a preference where in the queue this goes since it's likely
                // to error on the client anyway. However, intentionally client-rendered
                // boundaries should be flushed earlier so that they can start on the client.
                // We reuse the same queue for errors.
                request.clientRenderedBoundaries.push(boundary);
            }
        }
        request.allPendingTasks--;
        if (request.allPendingTasks === 0) {
            var onAllReady = request.onAllReady;
            onAllReady();
        }
    }
    function abortTaskSoft(task) {
        // This aborts task without aborting the parent boundary that it blocks.
        // It's used for when we didn't need this task to complete the tree.
        // If task was needed, then it should use abortTask instead.
        var request = this;
        var boundary = task.blockedBoundary;
        var segment = task.blockedSegment;
        segment.status = ABORTED;
        finishedTask(request, boundary, segment);
    }
    function abortTask(task, request, reason) {
        // This aborts the task and aborts the parent that it blocks, putting it into
        // client rendered mode.
        var boundary = task.blockedBoundary;
        var segment = task.blockedSegment;
        segment.status = ABORTED;
        if (boundary === null) {
            request.allPendingTasks--; // We didn't complete the root so we have nothing to show. We can close
            // the request;
            if (request.status !== CLOSED) {
                request.status = CLOSED;
                if (request.destination !== null) close(request.destination);
            }
        } else {
            boundary.pendingTasks--;
            if (!boundary.forceClientRender) {
                boundary.forceClientRender = true;
                var _error = reason === undefined ? new Error("The render was aborted by the server without a reason.") : reason;
                boundary.errorDigest = request.onError(_error);
                var errorPrefix = "The server did not finish this Suspense boundary: ";
                if (_error && typeof _error.message === "string") _error = errorPrefix + _error.message;
                else // eslint-disable-next-line react-internal/safe-string-coercion
                _error = errorPrefix + String(_error);
                var previousTaskInDev = currentTaskInDEV;
                currentTaskInDEV = task;
                try {
                    captureBoundaryErrorDetailsDev(boundary, _error);
                } finally{
                    currentTaskInDEV = previousTaskInDev;
                }
                if (boundary.parentFlushed) request.clientRenderedBoundaries.push(boundary);
            } // If this boundary was still pending then we haven't already cancelled its fallbacks.
            // We'll need to abort the fallbacks, which will also error that parent boundary.
            boundary.fallbackAbortableTasks.forEach(function(fallbackTask) {
                return abortTask(fallbackTask, request, reason);
            });
            boundary.fallbackAbortableTasks.clear();
            request.allPendingTasks--;
            if (request.allPendingTasks === 0) {
                var onAllReady = request.onAllReady;
                onAllReady();
            }
        }
    }
    function queueCompletedSegment(boundary, segment) {
        if (segment.chunks.length === 0 && segment.children.length === 1 && segment.children[0].boundary === null) {
            // This is an empty segment. There's nothing to write, so we can instead transfer the ID
            // to the child. That way any existing references point to the child.
            var childSegment = segment.children[0];
            childSegment.id = segment.id;
            childSegment.parentFlushed = true;
            if (childSegment.status === COMPLETED) queueCompletedSegment(boundary, childSegment);
        } else {
            var completedSegments = boundary.completedSegments;
            completedSegments.push(segment);
        }
    }
    function finishedTask(request, boundary, segment) {
        if (boundary === null) {
            if (segment.parentFlushed) {
                if (request.completedRootSegment !== null) throw new Error("There can only be one root segment. This is a bug in React.");
                request.completedRootSegment = segment;
            }
            request.pendingRootTasks--;
            if (request.pendingRootTasks === 0) {
                // We have completed the shell so the shell can't error anymore.
                request.onShellError = noop$1;
                var onShellReady = request.onShellReady;
                onShellReady();
            }
        } else {
            boundary.pendingTasks--;
            if (boundary.forceClientRender) ;
            else if (boundary.pendingTasks === 0) {
                // This must have been the last segment we were waiting on. This boundary is now complete.
                if (segment.parentFlushed) // Our parent segment already flushed, so we need to schedule this segment to be emitted.
                // If it is a segment that was aborted, we'll write other content instead so we don't need
                // to emit it.
                {
                    if (segment.status === COMPLETED) queueCompletedSegment(boundary, segment);
                }
                if (boundary.parentFlushed) // The segment might be part of a segment that didn't flush yet, but if the boundary's
                // parent flushed, we need to schedule the boundary to be emitted.
                request.completedBoundaries.push(boundary);
                 // We can now cancel any pending task on the fallback since we won't need to show it anymore.
                // This needs to happen after we read the parentFlushed flags because aborting can finish
                // work which can trigger user code, which can start flushing, which can change those flags.
                boundary.fallbackAbortableTasks.forEach(abortTaskSoft, request);
                boundary.fallbackAbortableTasks.clear();
            } else {
                if (segment.parentFlushed) // Our parent already flushed, so we need to schedule this segment to be emitted.
                // If it is a segment that was aborted, we'll write other content instead so we don't need
                // to emit it.
                {
                    if (segment.status === COMPLETED) {
                        queueCompletedSegment(boundary, segment);
                        var completedSegments = boundary.completedSegments;
                        if (completedSegments.length === 1) // This is the first time since we last flushed that we completed anything.
                        // We can schedule this boundary to emit its partially completed segments early
                        // in case the parent has already been flushed.
                        {
                            if (boundary.parentFlushed) request.partialBoundaries.push(boundary);
                        }
                    }
                }
            }
        }
        request.allPendingTasks--;
        if (request.allPendingTasks === 0) {
            // This needs to be called at the very end so that we can synchronously write the result
            // in the callback if needed.
            var onAllReady = request.onAllReady;
            onAllReady();
        }
    }
    function retryTask(request, task) {
        var segment = task.blockedSegment;
        if (segment.status !== PENDING) // We completed this by other means before we had a chance to retry it.
        return;
         // We restore the context to what it was when we suspended.
        // We don't restore it after we leave because it's likely that we'll end up
        // needing a very similar context soon again.
        switchContext(task.context);
        var prevTaskInDEV = null;
        prevTaskInDEV = currentTaskInDEV;
        currentTaskInDEV = task;
        try {
            // We call the destructive form that mutates this task. That way if something
            // suspends again, we can reuse the same task instead of spawning a new one.
            renderNodeDestructive(request, task, task.node);
            pushSegmentFinale(segment.chunks, request.responseState, segment.lastPushedText, segment.textEmbedded);
            task.abortSet.delete(task);
            segment.status = COMPLETED;
            finishedTask(request, task.blockedBoundary, segment);
        } catch (x) {
            resetHooksState();
            if (typeof x === "object" && x !== null && typeof x.then === "function") {
                // Something suspended again, let's pick it back up later.
                var ping = task.ping;
                x.then(ping, ping);
            } else {
                task.abortSet.delete(task);
                segment.status = ERRORED;
                erroredTask(request, task.blockedBoundary, segment, x);
            }
        } finally{
            currentTaskInDEV = prevTaskInDEV;
        }
    }
    function performWork(request) {
        if (request.status === CLOSED) return;
        var prevContext = getActiveContext();
        var prevDispatcher = ReactCurrentDispatcher$1.current;
        ReactCurrentDispatcher$1.current = Dispatcher;
        var prevGetCurrentStackImpl;
        prevGetCurrentStackImpl = ReactDebugCurrentFrame$1.getCurrentStack;
        ReactDebugCurrentFrame$1.getCurrentStack = getCurrentStackInDEV;
        var prevResponseState = currentResponseState;
        setCurrentResponseState(request.responseState);
        try {
            var pingedTasks = request.pingedTasks;
            var i;
            for(i = 0; i < pingedTasks.length; i++){
                var task = pingedTasks[i];
                retryTask(request, task);
            }
            pingedTasks.splice(0, i);
            if (request.destination !== null) flushCompletedQueues(request, request.destination);
        } catch (error) {
            logRecoverableError(request, error);
            fatalError(request, error);
        } finally{
            setCurrentResponseState(prevResponseState);
            ReactCurrentDispatcher$1.current = prevDispatcher;
            ReactDebugCurrentFrame$1.getCurrentStack = prevGetCurrentStackImpl;
            if (prevDispatcher === Dispatcher) // This means that we were in a reentrant work loop. This could happen
            // in a renderer that supports synchronous work like renderToString,
            // when it's called from within another renderer.
            // Normally we don't bother switching the contexts to their root/default
            // values when leaving because we'll likely need the same or similar
            // context again. However, when we're inside a synchronous loop like this
            // we'll to restore the context to what it was before returning.
            switchContext(prevContext);
        }
    }
    function flushSubtree(request, destination, segment) {
        segment.parentFlushed = true;
        switch(segment.status){
            case PENDING:
                // We're emitting a placeholder for this segment to be filled in later.
                // Therefore we'll need to assign it an ID - to refer to it by.
                var segmentID = segment.id = request.nextSegmentId++; // When this segment finally completes it won't be embedded in text since it will flush separately
                segment.lastPushedText = false;
                segment.textEmbedded = false;
                return writePlaceholder(destination, request.responseState, segmentID);
            case COMPLETED:
                segment.status = FLUSHED;
                var r = true;
                var chunks = segment.chunks;
                var chunkIdx = 0;
                var children = segment.children;
                for(var childIdx = 0; childIdx < children.length; childIdx++){
                    var nextChild = children[childIdx]; // Write all the chunks up until the next child.
                    for(; chunkIdx < nextChild.index; chunkIdx++)writeChunk(destination, chunks[chunkIdx]);
                    r = flushSegment(request, destination, nextChild);
                } // Finally just write all the remaining chunks
                for(; chunkIdx < chunks.length - 1; chunkIdx++)writeChunk(destination, chunks[chunkIdx]);
                if (chunkIdx < chunks.length) r = writeChunkAndReturn(destination, chunks[chunkIdx]);
                return r;
            default:
                throw new Error("Aborted, errored or already flushed boundaries should not be flushed again. This is a bug in React.");
        }
    }
    function flushSegment(request, destination, segment) {
        var boundary = segment.boundary;
        if (boundary === null) // Not a suspense boundary.
        return flushSubtree(request, destination, segment);
        boundary.parentFlushed = true; // This segment is a Suspense boundary. We need to decide whether to
        // emit the content or the fallback now.
        if (boundary.forceClientRender) {
            // Emit a client rendered suspense boundary wrapper.
            // We never queue the inner boundary so we'll never emit its content or partial segments.
            writeStartClientRenderedSuspenseBoundary(destination, request.responseState, boundary.errorDigest, boundary.errorMessage, boundary.errorComponentStack); // Flush the fallback.
            flushSubtree(request, destination, segment);
            return writeEndClientRenderedSuspenseBoundary(destination, request.responseState);
        } else if (boundary.pendingTasks > 0) {
            // This boundary is still loading. Emit a pending suspense boundary wrapper.
            // Assign an ID to refer to the future content by.
            boundary.rootSegmentID = request.nextSegmentId++;
            if (boundary.completedSegments.length > 0) // If this is at least partially complete, we can queue it to be partially emitted early.
            request.partialBoundaries.push(boundary);
             /// This is the first time we should have referenced this ID.
            var id = boundary.id = assignSuspenseBoundaryID(request.responseState);
            writeStartPendingSuspenseBoundary(destination, request.responseState, id); // Flush the fallback.
            flushSubtree(request, destination, segment);
            return writeEndPendingSuspenseBoundary(destination, request.responseState);
        } else if (boundary.byteSize > request.progressiveChunkSize) {
            // This boundary is large and will be emitted separately so that we can progressively show
            // other content. We add it to the queue during the flush because we have to ensure that
            // the parent flushes first so that there's something to inject it into.
            // We also have to make sure that it's emitted into the queue in a deterministic slot.
            // I.e. we can't insert it here when it completes.
            // Assign an ID to refer to the future content by.
            boundary.rootSegmentID = request.nextSegmentId++;
            request.completedBoundaries.push(boundary); // Emit a pending rendered suspense boundary wrapper.
            writeStartPendingSuspenseBoundary(destination, request.responseState, boundary.id); // Flush the fallback.
            flushSubtree(request, destination, segment);
            return writeEndPendingSuspenseBoundary(destination, request.responseState);
        } else {
            // We can inline this boundary's content as a complete boundary.
            writeStartCompletedSuspenseBoundary(destination, request.responseState);
            var completedSegments = boundary.completedSegments;
            if (completedSegments.length !== 1) throw new Error("A previously unvisited boundary must have exactly one root segment. This is a bug in React.");
            var contentSegment = completedSegments[0];
            flushSegment(request, destination, contentSegment);
            return writeEndCompletedSuspenseBoundary(destination, request.responseState);
        }
    }
    function flushClientRenderedBoundary(request, destination, boundary) {
        return writeClientRenderBoundaryInstruction(destination, request.responseState, boundary.id, boundary.errorDigest, boundary.errorMessage, boundary.errorComponentStack);
    }
    function flushSegmentContainer(request, destination, segment) {
        writeStartSegment(destination, request.responseState, segment.formatContext, segment.id);
        flushSegment(request, destination, segment);
        return writeEndSegment(destination, segment.formatContext);
    }
    function flushCompletedBoundary(request, destination, boundary) {
        var completedSegments = boundary.completedSegments;
        var i = 0;
        for(; i < completedSegments.length; i++){
            var segment = completedSegments[i];
            flushPartiallyCompletedSegment(request, destination, boundary, segment);
        }
        completedSegments.length = 0;
        return writeCompletedBoundaryInstruction(destination, request.responseState, boundary.id, boundary.rootSegmentID);
    }
    function flushPartialBoundary(request, destination, boundary) {
        var completedSegments = boundary.completedSegments;
        var i = 0;
        for(; i < completedSegments.length; i++){
            var segment = completedSegments[i];
            if (!flushPartiallyCompletedSegment(request, destination, boundary, segment)) {
                i++;
                completedSegments.splice(0, i); // Only write as much as the buffer wants. Something higher priority
                // might want to write later.
                return false;
            }
        }
        completedSegments.splice(0, i);
        return true;
    }
    function flushPartiallyCompletedSegment(request, destination, boundary, segment) {
        if (segment.status === FLUSHED) // We've already flushed this inline.
        return true;
        var segmentID = segment.id;
        if (segmentID === -1) {
            // This segment wasn't previously referred to. This happens at the root of
            // a boundary. We make kind of a leap here and assume this is the root.
            var rootSegmentID = segment.id = boundary.rootSegmentID;
            if (rootSegmentID === -1) throw new Error("A root segment ID must have been assigned by now. This is a bug in React.");
            return flushSegmentContainer(request, destination, segment);
        } else {
            flushSegmentContainer(request, destination, segment);
            return writeCompletedSegmentInstruction(destination, request.responseState, segmentID);
        }
    }
    function flushCompletedQueues(request, destination) {
        beginWriting();
        try {
            // The structure of this is to go through each queue one by one and write
            // until the sink tells us to stop. When we should stop, we still finish writing
            // that item fully and then yield. At that point we remove the already completed
            // items up until the point we completed them.
            // TODO: Emit preloading.
            // TODO: It's kind of unfortunate to keep checking this array after we've already
            // emitted the root.
            var completedRootSegment = request.completedRootSegment;
            if (completedRootSegment !== null && request.pendingRootTasks === 0) {
                flushSegment(request, destination, completedRootSegment);
                request.completedRootSegment = null;
                writeCompletedRoot(destination, request.responseState);
            } // We emit client rendering instructions for already emitted boundaries first.
            // This is so that we can signal to the client to start client rendering them as
            // soon as possible.
            var clientRenderedBoundaries = request.clientRenderedBoundaries;
            var i;
            for(i = 0; i < clientRenderedBoundaries.length; i++){
                var boundary = clientRenderedBoundaries[i];
                if (!flushClientRenderedBoundary(request, destination, boundary)) {
                    request.destination = null;
                    i++;
                    clientRenderedBoundaries.splice(0, i);
                    return;
                }
            }
            clientRenderedBoundaries.splice(0, i); // Next we emit any complete boundaries. It's better to favor boundaries
            // that are completely done since we can actually show them, than it is to emit
            // any individual segments from a partially complete boundary.
            var completedBoundaries = request.completedBoundaries;
            for(i = 0; i < completedBoundaries.length; i++){
                var _boundary = completedBoundaries[i];
                if (!flushCompletedBoundary(request, destination, _boundary)) {
                    request.destination = null;
                    i++;
                    completedBoundaries.splice(0, i);
                    return;
                }
            }
            completedBoundaries.splice(0, i); // Allow anything written so far to flush to the underlying sink before
            // we continue with lower priorities.
            completeWriting(destination);
            beginWriting(destination); // TODO: Here we'll emit data used by hydration.
            // Next we emit any segments of any boundaries that are partially complete
            // but not deeply complete.
            var partialBoundaries = request.partialBoundaries;
            for(i = 0; i < partialBoundaries.length; i++){
                var _boundary2 = partialBoundaries[i];
                if (!flushPartialBoundary(request, destination, _boundary2)) {
                    request.destination = null;
                    i++;
                    partialBoundaries.splice(0, i);
                    return;
                }
            }
            partialBoundaries.splice(0, i); // Next we check the completed boundaries again. This may have had
            // boundaries added to it in case they were too larged to be inlined.
            // New ones might be added in this loop.
            var largeBoundaries = request.completedBoundaries;
            for(i = 0; i < largeBoundaries.length; i++){
                var _boundary3 = largeBoundaries[i];
                if (!flushCompletedBoundary(request, destination, _boundary3)) {
                    request.destination = null;
                    i++;
                    largeBoundaries.splice(0, i);
                    return;
                }
            }
            largeBoundaries.splice(0, i);
        } finally{
            completeWriting(destination);
            if (request.allPendingTasks === 0 && request.pingedTasks.length === 0 && request.clientRenderedBoundaries.length === 0 && request.completedBoundaries.length === 0 // We don't need to check any partially completed segments because
            ) {
                if (request.abortableTasks.size !== 0) error("There was still abortable task at the root when we closed. This is a bug in React.");
                close(destination);
            }
        }
    }
    function startWork(request) {
        scheduleWork(function() {
            return performWork(request);
        });
    }
    function startFlowing(request, destination) {
        if (request.status === CLOSING) {
            request.status = CLOSED;
            closeWithError(destination, request.fatalError);
            return;
        }
        if (request.status === CLOSED) return;
        if (request.destination !== null) // We're already flowing.
        return;
        request.destination = destination;
        try {
            flushCompletedQueues(request, destination);
        } catch (error) {
            logRecoverableError(request, error);
            fatalError(request, error);
        }
    } // This is called to early terminate a request. It puts all pending boundaries in client rendered state.
    function abort(request, reason) {
        try {
            var abortableTasks = request.abortableTasks;
            abortableTasks.forEach(function(task) {
                return abortTask(task, request, reason);
            });
            abortableTasks.clear();
            if (request.destination !== null) flushCompletedQueues(request, request.destination);
        } catch (error) {
            logRecoverableError(request, error);
            fatalError(request, error);
        }
    }
    function renderToReadableStream(children, options) {
        return new Promise(function(resolve, reject) {
            var onFatalError;
            var onAllReady;
            var allReady = new Promise(function(res, rej) {
                onAllReady = res;
                onFatalError = rej;
            });
            function onShellReady() {
                var stream = new ReadableStream({
                    type: "bytes",
                    pull: function(controller) {
                        startFlowing(request, controller);
                    },
                    cancel: function(reason) {
                        abort(request);
                    }
                }, {
                    highWaterMark: 0
                }); // TODO: Move to sub-classing ReadableStream.
                stream.allReady = allReady;
                resolve(stream);
            }
            function onShellError(error) {
                // If the shell errors the caller of `renderToReadableStream` won't have access to `allReady`.
                // However, `allReady` will be rejected by `onFatalError` as well.
                // So we need to catch the duplicate, uncatchable fatal error in `allReady` to prevent a `UnhandledPromiseRejection`.
                allReady.catch(function() {});
                reject(error);
            }
            var request = createRequest(children, createResponseState(options ? options.identifierPrefix : undefined, options ? options.nonce : undefined, options ? options.bootstrapScriptContent : undefined, options ? options.bootstrapScripts : undefined, options ? options.bootstrapModules : undefined), createRootFormatContext(options ? options.namespaceURI : undefined), options ? options.progressiveChunkSize : undefined, options ? options.onError : undefined, onAllReady, onShellReady, onShellError, onFatalError);
            if (options && options.signal) {
                var signal = options.signal;
                var listener = function() {
                    abort(request, signal.reason);
                    signal.removeEventListener("abort", listener);
                };
                signal.addEventListener("abort", listener);
            }
            startWork(request);
        });
    }
    $1afe62ba3a7403ae$export$7020a3240b287705 = renderToReadableStream;
    $1afe62ba3a7403ae$export$83d89fbfd8236492 = ReactVersion;
})();

});



parcelRegister("4l0Ad", function(module, exports) {



(function(global, factory) {
    if (typeof define === "function" && define.amd) define([
        "exports",
        "react",
        "prop-types",
        "../lib/String"
    ], factory);
    else {
        var mod;
        factory(module.exports, (parcelRequire("acw62")), (parcelRequire("c9Z8w")), (parcelRequire("7twkG")));
    }
})(module.exports, function(exports1, _react, _propTypes, _String) {
    "use strict";
    Object.defineProperty(exports1, "__esModule", {
        value: true
    });
    exports1.HeatMap = undefined;
    var _react2 = _interopRequireDefault(_react);
    var _propTypes2 = _interopRequireDefault(_propTypes);
    function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
            default: obj
        };
    }
    var _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    function _objectWithoutProperties(obj, keys) {
        var target = {};
        for(var i in obj){
            if (keys.indexOf(i) >= 0) continue;
            if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
            target[i] = obj[i];
        }
        return target;
    }
    function _classCallCheck(instance, Constructor) {
        if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
    }
    var _createClass = function() {
        function defineProperties(target, props) {
            for(var i = 0; i < props.length; i++){
                var descriptor = props[i];
                descriptor.enumerable = descriptor.enumerable || false;
                descriptor.configurable = true;
                if ("value" in descriptor) descriptor.writable = true;
                Object.defineProperty(target, descriptor.key, descriptor);
            }
        }
        return function(Constructor, protoProps, staticProps) {
            if (protoProps) defineProperties(Constructor.prototype, protoProps);
            if (staticProps) defineProperties(Constructor, staticProps);
            return Constructor;
        };
    }();
    function _possibleConstructorReturn(self, call) {
        if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return call && (typeof call === "object" || typeof call === "function") ? call : self;
    }
    function _inherits(subClass, superClass) {
        if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
        subClass.prototype = Object.create(superClass && superClass.prototype, {
            constructor: {
                value: subClass,
                enumerable: false,
                writable: true,
                configurable: true
            }
        });
        if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
    }
    var evtNames = [
        "click",
        "mouseover",
        "recenter"
    ];
    var wrappedPromise = function wrappedPromise() {
        var wrappedPromise = {}, promise = new Promise(function(resolve, reject) {
            wrappedPromise.resolve = resolve;
            wrappedPromise.reject = reject;
        });
        wrappedPromise.then = promise.then.bind(promise);
        wrappedPromise.catch = promise.catch.bind(promise);
        wrappedPromise.promise = promise;
        return wrappedPromise;
    };
    var HeatMap = exports1.HeatMap = function(_React$Component) {
        _inherits(HeatMap, _React$Component);
        function HeatMap() {
            _classCallCheck(this, HeatMap);
            return _possibleConstructorReturn(this, (HeatMap.__proto__ || Object.getPrototypeOf(HeatMap)).apply(this, arguments));
        }
        _createClass(HeatMap, [
            {
                key: "componentDidMount",
                value: function componentDidMount() {
                    this.heatMapPromise = wrappedPromise();
                    this.renderHeatMap();
                }
            },
            {
                key: "componentDidUpdate",
                value: function componentDidUpdate(prevProps) {
                    if (this.props.map !== prevProps.map || this.props.position !== prevProps.position) {
                        if (this.heatMap) {
                            this.heatMap.setMap(null);
                            this.renderHeatMap();
                        }
                    }
                }
            },
            {
                key: "componentWillUnmount",
                value: function componentWillUnmount() {
                    if (this.heatMap) this.heatMap.setMap(null);
                }
            },
            {
                key: "renderHeatMap",
                value: function renderHeatMap() {
                    var _this2 = this;
                    var _props = this.props, map = _props.map, google = _props.google, positions = _props.positions, mapCenter = _props.mapCenter, icon = _props.icon, gradient = _props.gradient, _props$radius = _props.radius, radius = _props$radius === undefined ? 20 : _props$radius, _props$opacity = _props.opacity, opacity = _props$opacity === undefined ? 0.2 : _props$opacity, props = _objectWithoutProperties(_props, [
                        "map",
                        "google",
                        "positions",
                        "mapCenter",
                        "icon",
                        "gradient",
                        "radius",
                        "opacity"
                    ]);
                    if (!google) return null;
                    var data = positions.map(function(pos) {
                        return {
                            location: new google.maps.LatLng(pos.lat, pos.lng),
                            weight: pos.weight
                        };
                    });
                    var pref = _extends({
                        map: map,
                        gradient: gradient,
                        radius: radius,
                        opacity: opacity,
                        data: data
                    }, props);
                    this.heatMap = new google.maps.visualization.HeatmapLayer(pref);
                    this.heatMap.set("radius", radius === undefined ? 20 : radius);
                    this.heatMap.set("opacity", opacity === undefined ? 0.2 : opacity);
                    evtNames.forEach(function(e) {
                        _this2.heatMap.addListener(e, _this2.handleEvent(e));
                    });
                    this.heatMapPromise.resolve(this.heatMap);
                }
            },
            {
                key: "getHeatMap",
                value: function getHeatMap() {
                    return this.heatMapPromise;
                }
            },
            {
                key: "handleEvent",
                value: function handleEvent(evt) {
                    var _this3 = this;
                    return function(e) {
                        var evtName = "on" + (0, _String.camelize)(evt);
                        if (_this3.props[evtName]) _this3.props[evtName](_this3.props, _this3.heatMap, e);
                    };
                }
            },
            {
                key: "render",
                value: function render() {
                    return null;
                }
            }
        ]);
        return HeatMap;
    }(_react2.default.Component);
    HeatMap.propTypes = {
        position: _propTypes2.default.object,
        map: _propTypes2.default.object,
        icon: _propTypes2.default.string
    };
    evtNames.forEach(function(e) {
        return HeatMap.propTypes[e] = _propTypes2.default.func;
    });
    HeatMap.defaultProps = {
        name: "HeatMap"
    };
    exports1.default = HeatMap;
});

});

parcelRegister("76QNe", function(module, exports) {




(function(global, factory) {
    if (typeof define === "function" && define.amd) define([
        "exports",
        "react",
        "prop-types",
        "../lib/arePathsEqual",
        "../lib/String"
    ], factory);
    else {
        var mod;
        factory(module.exports, (parcelRequire("acw62")), (parcelRequire("c9Z8w")), (parcelRequire("1p0TA")), (parcelRequire("7twkG")));
    }
})(module.exports, function(exports1, _react, _propTypes, _arePathsEqual, _String) {
    "use strict";
    Object.defineProperty(exports1, "__esModule", {
        value: true
    });
    exports1.Polygon = undefined;
    var _react2 = _interopRequireDefault(_react);
    var _propTypes2 = _interopRequireDefault(_propTypes);
    function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
            default: obj
        };
    }
    var _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    function _objectWithoutProperties(obj, keys) {
        var target = {};
        for(var i in obj){
            if (keys.indexOf(i) >= 0) continue;
            if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
            target[i] = obj[i];
        }
        return target;
    }
    function _classCallCheck(instance, Constructor) {
        if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
    }
    var _createClass = function() {
        function defineProperties(target, props) {
            for(var i = 0; i < props.length; i++){
                var descriptor = props[i];
                descriptor.enumerable = descriptor.enumerable || false;
                descriptor.configurable = true;
                if ("value" in descriptor) descriptor.writable = true;
                Object.defineProperty(target, descriptor.key, descriptor);
            }
        }
        return function(Constructor, protoProps, staticProps) {
            if (protoProps) defineProperties(Constructor.prototype, protoProps);
            if (staticProps) defineProperties(Constructor, staticProps);
            return Constructor;
        };
    }();
    function _possibleConstructorReturn(self, call) {
        if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return call && (typeof call === "object" || typeof call === "function") ? call : self;
    }
    function _inherits(subClass, superClass) {
        if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
        subClass.prototype = Object.create(superClass && superClass.prototype, {
            constructor: {
                value: subClass,
                enumerable: false,
                writable: true,
                configurable: true
            }
        });
        if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
    }
    var evtNames = [
        "click",
        "mouseout",
        "mouseover"
    ];
    var wrappedPromise = function wrappedPromise() {
        var wrappedPromise = {}, promise = new Promise(function(resolve, reject) {
            wrappedPromise.resolve = resolve;
            wrappedPromise.reject = reject;
        });
        wrappedPromise.then = promise.then.bind(promise);
        wrappedPromise.catch = promise.catch.bind(promise);
        wrappedPromise.promise = promise;
        return wrappedPromise;
    };
    var Polygon = exports1.Polygon = function(_React$Component) {
        _inherits(Polygon, _React$Component);
        function Polygon() {
            _classCallCheck(this, Polygon);
            return _possibleConstructorReturn(this, (Polygon.__proto__ || Object.getPrototypeOf(Polygon)).apply(this, arguments));
        }
        _createClass(Polygon, [
            {
                key: "componentDidMount",
                value: function componentDidMount() {
                    this.polygonPromise = wrappedPromise();
                    this.renderPolygon();
                }
            },
            {
                key: "componentDidUpdate",
                value: function componentDidUpdate(prevProps) {
                    if (this.props.map !== prevProps.map || !(0, _arePathsEqual.arePathsEqual)(this.props.paths, prevProps.paths)) {
                        if (this.polygon) this.polygon.setMap(null);
                        this.renderPolygon();
                    }
                }
            },
            {
                key: "componentWillUnmount",
                value: function componentWillUnmount() {
                    if (this.polygon) this.polygon.setMap(null);
                }
            },
            {
                key: "renderPolygon",
                value: function renderPolygon() {
                    var _this2 = this;
                    var _props = this.props, map = _props.map, google = _props.google, paths = _props.paths, strokeColor = _props.strokeColor, strokeOpacity = _props.strokeOpacity, strokeWeight = _props.strokeWeight, fillColor = _props.fillColor, fillOpacity = _props.fillOpacity, props = _objectWithoutProperties(_props, [
                        "map",
                        "google",
                        "paths",
                        "strokeColor",
                        "strokeOpacity",
                        "strokeWeight",
                        "fillColor",
                        "fillOpacity"
                    ]);
                    if (!google) return null;
                    var params = _extends({
                        map: map,
                        paths: paths,
                        strokeColor: strokeColor,
                        strokeOpacity: strokeOpacity,
                        strokeWeight: strokeWeight,
                        fillColor: fillColor,
                        fillOpacity: fillOpacity
                    }, props);
                    this.polygon = new google.maps.Polygon(params);
                    evtNames.forEach(function(e) {
                        _this2.polygon.addListener(e, _this2.handleEvent(e));
                    });
                    this.polygonPromise.resolve(this.polygon);
                }
            },
            {
                key: "getPolygon",
                value: function getPolygon() {
                    return this.polygonPromise;
                }
            },
            {
                key: "handleEvent",
                value: function handleEvent(evt) {
                    var _this3 = this;
                    return function(e) {
                        var evtName = "on" + (0, _String.camelize)(evt);
                        if (_this3.props[evtName]) _this3.props[evtName](_this3.props, _this3.polygon, e);
                    };
                }
            },
            {
                key: "render",
                value: function render() {
                    return null;
                }
            }
        ]);
        return Polygon;
    }(_react2.default.Component);
    Polygon.propTypes = {
        paths: _propTypes2.default.array,
        strokeColor: _propTypes2.default.string,
        strokeOpacity: _propTypes2.default.number,
        strokeWeight: _propTypes2.default.number,
        fillColor: _propTypes2.default.string,
        fillOpacity: _propTypes2.default.number
    };
    evtNames.forEach(function(e) {
        return Polygon.propTypes[e] = _propTypes2.default.func;
    });
    Polygon.defaultProps = {
        name: "Polygon"
    };
    exports1.default = Polygon;
});

});
parcelRegister("1p0TA", function(module, exports) {
(function(global, factory) {
    if (typeof define === "function" && define.amd) define([
        "exports"
    ], factory);
    else {
        var mod;
        factory(module.exports);
    }
})(module.exports, function(exports1) {
    "use strict";
    Object.defineProperty(exports1, "__esModule", {
        value: true
    });
    var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    /**
   * Compares two path arrays of LatLng objects.
   */ var arePathsEqual = exports1.arePathsEqual = function arePathsEqual(pathA, pathB) {
        if (pathA === pathB) return true;
        if (!Array.isArray(pathA) || !Array.isArray(pathB)) return false;
        if (pathA.length !== pathB.length) return false;
        for(var i = 0; i < pathA.length; ++i){
            if (pathA[i] === pathB[i]) continue;
            if (!isValidLatLng(pathA[i]) || !isValidLatLng(pathB[i])) return false;
            if (pathB[i].lat !== pathA[i].lat || pathB[i].lng !== pathA[i].lng) return false;
        }
        return true;
    };
    /**
   * Helper that checks whether an array consists of objects
   * with lat and lng properties
   * @param {object} elem the element to check
   * @returns {boolean} whether or not it's valid
   */ var isValidLatLng = function isValidLatLng(elem) {
        return elem !== null && (typeof elem === "undefined" ? "undefined" : _typeof(elem)) === "object" && elem.hasOwnProperty("lat") && elem.hasOwnProperty("lng");
    };
});

});


parcelRegister("7CAz9", function(module, exports) {




(function(global, factory) {
    if (typeof define === "function" && define.amd) define([
        "exports",
        "react",
        "prop-types",
        "../lib/arePathsEqual",
        "../lib/String"
    ], factory);
    else {
        var mod;
        factory(module.exports, (parcelRequire("acw62")), (parcelRequire("c9Z8w")), (parcelRequire("1p0TA")), (parcelRequire("7twkG")));
    }
})(module.exports, function(exports1, _react, _propTypes, _arePathsEqual, _String) {
    "use strict";
    Object.defineProperty(exports1, "__esModule", {
        value: true
    });
    exports1.Polyline = undefined;
    var _react2 = _interopRequireDefault(_react);
    var _propTypes2 = _interopRequireDefault(_propTypes);
    function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
            default: obj
        };
    }
    var _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    function _objectWithoutProperties(obj, keys) {
        var target = {};
        for(var i in obj){
            if (keys.indexOf(i) >= 0) continue;
            if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
            target[i] = obj[i];
        }
        return target;
    }
    function _classCallCheck(instance, Constructor) {
        if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
    }
    var _createClass = function() {
        function defineProperties(target, props) {
            for(var i = 0; i < props.length; i++){
                var descriptor = props[i];
                descriptor.enumerable = descriptor.enumerable || false;
                descriptor.configurable = true;
                if ("value" in descriptor) descriptor.writable = true;
                Object.defineProperty(target, descriptor.key, descriptor);
            }
        }
        return function(Constructor, protoProps, staticProps) {
            if (protoProps) defineProperties(Constructor.prototype, protoProps);
            if (staticProps) defineProperties(Constructor, staticProps);
            return Constructor;
        };
    }();
    function _possibleConstructorReturn(self, call) {
        if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return call && (typeof call === "object" || typeof call === "function") ? call : self;
    }
    function _inherits(subClass, superClass) {
        if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
        subClass.prototype = Object.create(superClass && superClass.prototype, {
            constructor: {
                value: subClass,
                enumerable: false,
                writable: true,
                configurable: true
            }
        });
        if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
    }
    var evtNames = [
        "click",
        "mouseout",
        "mouseover"
    ];
    var wrappedPromise = function wrappedPromise() {
        var wrappedPromise = {}, promise = new Promise(function(resolve, reject) {
            wrappedPromise.resolve = resolve;
            wrappedPromise.reject = reject;
        });
        wrappedPromise.then = promise.then.bind(promise);
        wrappedPromise.catch = promise.catch.bind(promise);
        wrappedPromise.promise = promise;
        return wrappedPromise;
    };
    var Polyline = exports1.Polyline = function(_React$Component) {
        _inherits(Polyline, _React$Component);
        function Polyline() {
            _classCallCheck(this, Polyline);
            return _possibleConstructorReturn(this, (Polyline.__proto__ || Object.getPrototypeOf(Polyline)).apply(this, arguments));
        }
        _createClass(Polyline, [
            {
                key: "componentDidMount",
                value: function componentDidMount() {
                    this.polylinePromise = wrappedPromise();
                    this.renderPolyline();
                }
            },
            {
                key: "componentDidUpdate",
                value: function componentDidUpdate(prevProps) {
                    if (this.props.map !== prevProps.map || !(0, _arePathsEqual.arePathsEqual)(this.props.path, prevProps.path)) {
                        if (this.polyline) this.polyline.setMap(null);
                        this.renderPolyline();
                    }
                }
            },
            {
                key: "componentWillUnmount",
                value: function componentWillUnmount() {
                    if (this.polyline) this.polyline.setMap(null);
                }
            },
            {
                key: "renderPolyline",
                value: function renderPolyline() {
                    var _this2 = this;
                    var _props = this.props, map = _props.map, google = _props.google, path = _props.path, strokeColor = _props.strokeColor, strokeOpacity = _props.strokeOpacity, strokeWeight = _props.strokeWeight, props = _objectWithoutProperties(_props, [
                        "map",
                        "google",
                        "path",
                        "strokeColor",
                        "strokeOpacity",
                        "strokeWeight"
                    ]);
                    if (!google) return null;
                    var params = _extends({
                        map: map,
                        path: path,
                        strokeColor: strokeColor,
                        strokeOpacity: strokeOpacity,
                        strokeWeight: strokeWeight
                    }, props);
                    this.polyline = new google.maps.Polyline(params);
                    evtNames.forEach(function(e) {
                        _this2.polyline.addListener(e, _this2.handleEvent(e));
                    });
                    this.polylinePromise.resolve(this.polyline);
                }
            },
            {
                key: "getPolyline",
                value: function getPolyline() {
                    return this.polylinePromise;
                }
            },
            {
                key: "handleEvent",
                value: function handleEvent(evt) {
                    var _this3 = this;
                    return function(e) {
                        var evtName = "on" + (0, _String.camelize)(evt);
                        if (_this3.props[evtName]) _this3.props[evtName](_this3.props, _this3.polyline, e);
                    };
                }
            },
            {
                key: "render",
                value: function render() {
                    return null;
                }
            }
        ]);
        return Polyline;
    }(_react2.default.Component);
    Polyline.propTypes = {
        path: _propTypes2.default.array,
        strokeColor: _propTypes2.default.string,
        strokeOpacity: _propTypes2.default.number,
        strokeWeight: _propTypes2.default.number
    };
    evtNames.forEach(function(e) {
        return Polyline.propTypes[e] = _propTypes2.default.func;
    });
    Polyline.defaultProps = {
        name: "Polyline"
    };
    exports1.default = Polyline;
});

});

parcelRegister("3cI8p", function(module, exports) {




(function(global, factory) {
    if (typeof define === "function" && define.amd) define([
        "exports",
        "react",
        "prop-types",
        "../lib/arePathsEqual",
        "../lib/String"
    ], factory);
    else {
        var mod;
        factory(module.exports, (parcelRequire("acw62")), (parcelRequire("c9Z8w")), (parcelRequire("1p0TA")), (parcelRequire("7twkG")));
    }
})(module.exports, function(exports1, _react, _propTypes, _arePathsEqual, _String) {
    "use strict";
    Object.defineProperty(exports1, "__esModule", {
        value: true
    });
    exports1.Circle = undefined;
    var _react2 = _interopRequireDefault(_react);
    var _propTypes2 = _interopRequireDefault(_propTypes);
    function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
            default: obj
        };
    }
    var _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    function _objectWithoutProperties(obj, keys) {
        var target = {};
        for(var i in obj){
            if (keys.indexOf(i) >= 0) continue;
            if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
            target[i] = obj[i];
        }
        return target;
    }
    function _classCallCheck(instance, Constructor) {
        if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
    }
    var _createClass = function() {
        function defineProperties(target, props) {
            for(var i = 0; i < props.length; i++){
                var descriptor = props[i];
                descriptor.enumerable = descriptor.enumerable || false;
                descriptor.configurable = true;
                if ("value" in descriptor) descriptor.writable = true;
                Object.defineProperty(target, descriptor.key, descriptor);
            }
        }
        return function(Constructor, protoProps, staticProps) {
            if (protoProps) defineProperties(Constructor.prototype, protoProps);
            if (staticProps) defineProperties(Constructor, staticProps);
            return Constructor;
        };
    }();
    function _possibleConstructorReturn(self, call) {
        if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return call && (typeof call === "object" || typeof call === "function") ? call : self;
    }
    function _inherits(subClass, superClass) {
        if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
        subClass.prototype = Object.create(superClass && superClass.prototype, {
            constructor: {
                value: subClass,
                enumerable: false,
                writable: true,
                configurable: true
            }
        });
        if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
    }
    var evtNames = [
        "click",
        "mouseout",
        "mouseover"
    ];
    var wrappedPromise = function wrappedPromise() {
        var wrappedPromise = {}, promise = new Promise(function(resolve, reject) {
            wrappedPromise.resolve = resolve;
            wrappedPromise.reject = reject;
        });
        wrappedPromise.then = promise.then.bind(promise);
        wrappedPromise.catch = promise.catch.bind(promise);
        wrappedPromise.promise = promise;
        return wrappedPromise;
    };
    var Circle = exports1.Circle = function(_React$Component) {
        _inherits(Circle, _React$Component);
        function Circle() {
            var _ref;
            var _temp, _this, _ret;
            _classCallCheck(this, Circle);
            for(var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
            return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Circle.__proto__ || Object.getPrototypeOf(Circle)).call.apply(_ref, [
                this
            ].concat(args))), _this), _this.centerChanged = function(newCenter) {
                var _this$props$center = _this.props.center, lat = _this$props$center.lat, lng = _this$props$center.lng;
                return lat !== newCenter.lat || lng !== newCenter.lng;
            }, _this.propsChanged = function(newProps) {
                if (_this.centerChanged(newProps.center)) return true;
                return Object.keys(Circle.propTypes).some(function(key) {
                    return _this.props[key] !== newProps[key];
                });
            }, _this.destroyCircle = function() {
                if (_this.circle) _this.circle.setMap(null);
            }, _temp), _possibleConstructorReturn(_this, _ret);
        }
        _createClass(Circle, [
            {
                key: "componentDidMount",
                value: function componentDidMount() {
                    this.circlePromise = wrappedPromise();
                    this.renderCircle();
                }
            },
            {
                key: "componentDidUpdate",
                value: function componentDidUpdate(prevProps) {
                    var _props = this.props, path = _props.path, map = _props.map;
                    if (this.propsChanged(prevProps) || map !== prevProps.map || !(0, _arePathsEqual.arePathsEqual)(path, prevProps.path)) {
                        this.destroyCircle();
                        this.renderCircle();
                    }
                }
            },
            {
                key: "componentWillUnmount",
                value: function componentWillUnmount() {
                    this.destroyCircle();
                }
            },
            {
                key: "renderCircle",
                value: function renderCircle() {
                    var _this2 = this;
                    var _props2 = this.props, map = _props2.map, google = _props2.google, center = _props2.center, radius = _props2.radius, strokeColor = _props2.strokeColor, strokeOpacity = _props2.strokeOpacity, strokeWeight = _props2.strokeWeight, fillColor = _props2.fillColor, fillOpacity = _props2.fillOpacity, draggable = _props2.draggable, visible = _props2.visible, props = _objectWithoutProperties(_props2, [
                        "map",
                        "google",
                        "center",
                        "radius",
                        "strokeColor",
                        "strokeOpacity",
                        "strokeWeight",
                        "fillColor",
                        "fillOpacity",
                        "draggable",
                        "visible"
                    ]);
                    if (!google) return null;
                    var params = _extends({}, props, {
                        map: map,
                        center: center,
                        radius: radius,
                        draggable: draggable,
                        visible: visible,
                        options: {
                            strokeColor: strokeColor,
                            strokeOpacity: strokeOpacity,
                            strokeWeight: strokeWeight,
                            fillColor: fillColor,
                            fillOpacity: fillOpacity
                        }
                    });
                    this.circle = new google.maps.Circle(params);
                    evtNames.forEach(function(e) {
                        _this2.circle.addListener(e, _this2.handleEvent(e));
                    });
                    this.circlePromise.resolve(this.circle);
                }
            },
            {
                key: "getCircle",
                value: function getCircle() {
                    return this.circlePromise;
                }
            },
            {
                key: "handleEvent",
                value: function handleEvent(evt) {
                    var _this3 = this;
                    return function(e) {
                        var evtName = "on" + (0, _String.camelize)(evt);
                        if (_this3.props[evtName]) _this3.props[evtName](_this3.props, _this3.circle, e);
                    };
                }
            },
            {
                key: "render",
                value: function render() {
                    return null;
                }
            }
        ]);
        return Circle;
    }(_react2.default.Component);
    Circle.propTypes = {
        center: _propTypes2.default.object,
        radius: _propTypes2.default.number,
        strokeColor: _propTypes2.default.string,
        strokeOpacity: _propTypes2.default.number,
        strokeWeight: _propTypes2.default.number,
        fillColor: _propTypes2.default.string,
        fillOpacity: _propTypes2.default.number,
        draggable: _propTypes2.default.bool,
        visible: _propTypes2.default.bool
    };
    evtNames.forEach(function(e) {
        return Circle.propTypes[e] = _propTypes2.default.func;
    });
    Circle.defaultProps = {
        name: "Circle"
    };
    exports1.default = Circle;
});

});

parcelRegister("3pQuS", function(module, exports) {




(function(global, factory) {
    if (typeof define === "function" && define.amd) define([
        "exports",
        "react",
        "prop-types",
        "../lib/areBoundsEqual",
        "../lib/String"
    ], factory);
    else {
        var mod;
        factory(module.exports, (parcelRequire("acw62")), (parcelRequire("c9Z8w")), (parcelRequire("bIRJp")), (parcelRequire("7twkG")));
    }
})(module.exports, function(exports1, _react, _propTypes, _areBoundsEqual, _String) {
    "use strict";
    Object.defineProperty(exports1, "__esModule", {
        value: true
    });
    exports1.Rectangle = undefined;
    var _react2 = _interopRequireDefault(_react);
    var _propTypes2 = _interopRequireDefault(_propTypes);
    function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
            default: obj
        };
    }
    var _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    function _objectWithoutProperties(obj, keys) {
        var target = {};
        for(var i in obj){
            if (keys.indexOf(i) >= 0) continue;
            if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
            target[i] = obj[i];
        }
        return target;
    }
    function _classCallCheck(instance, Constructor) {
        if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
    }
    var _createClass = function() {
        function defineProperties(target, props) {
            for(var i = 0; i < props.length; i++){
                var descriptor = props[i];
                descriptor.enumerable = descriptor.enumerable || false;
                descriptor.configurable = true;
                if ("value" in descriptor) descriptor.writable = true;
                Object.defineProperty(target, descriptor.key, descriptor);
            }
        }
        return function(Constructor, protoProps, staticProps) {
            if (protoProps) defineProperties(Constructor.prototype, protoProps);
            if (staticProps) defineProperties(Constructor, staticProps);
            return Constructor;
        };
    }();
    function _possibleConstructorReturn(self, call) {
        if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return call && (typeof call === "object" || typeof call === "function") ? call : self;
    }
    function _inherits(subClass, superClass) {
        if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
        subClass.prototype = Object.create(superClass && superClass.prototype, {
            constructor: {
                value: subClass,
                enumerable: false,
                writable: true,
                configurable: true
            }
        });
        if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
    }
    var evtNames = [
        "click",
        "mouseout",
        "mouseover"
    ];
    var wrappedPromise = function wrappedPromise() {
        var wrappedPromise = {}, promise = new Promise(function(resolve, reject) {
            wrappedPromise.resolve = resolve;
            wrappedPromise.reject = reject;
        });
        wrappedPromise.then = promise.then.bind(promise);
        wrappedPromise.catch = promise.catch.bind(promise);
        wrappedPromise.promise = promise;
        return wrappedPromise;
    };
    var Rectangle = exports1.Rectangle = function(_React$Component) {
        _inherits(Rectangle, _React$Component);
        function Rectangle() {
            _classCallCheck(this, Rectangle);
            return _possibleConstructorReturn(this, (Rectangle.__proto__ || Object.getPrototypeOf(Rectangle)).apply(this, arguments));
        }
        _createClass(Rectangle, [
            {
                key: "componentDidMount",
                value: function componentDidMount() {
                    this.rectanglePromise = wrappedPromise();
                    this.renderRectangle();
                }
            },
            {
                key: "componentDidUpdate",
                value: function componentDidUpdate(prevProps) {
                    if (this.props.map !== prevProps.map || !(0, _areBoundsEqual.areBoundsEqual)(this.props.bounds, prevProps.bounds)) {
                        if (this.rectangle) this.rectangle.setMap(null);
                        this.renderRectangle();
                    }
                }
            },
            {
                key: "componentWillUnmount",
                value: function componentWillUnmount() {
                    if (this.rectangle) this.rectangle.setMap(null);
                }
            },
            {
                key: "renderRectangle",
                value: function renderRectangle() {
                    var _this2 = this;
                    var _props = this.props, map = _props.map, google = _props.google, bounds = _props.bounds, strokeColor = _props.strokeColor, strokeOpacity = _props.strokeOpacity, strokeWeight = _props.strokeWeight, fillColor = _props.fillColor, fillOpacity = _props.fillOpacity, props = _objectWithoutProperties(_props, [
                        "map",
                        "google",
                        "bounds",
                        "strokeColor",
                        "strokeOpacity",
                        "strokeWeight",
                        "fillColor",
                        "fillOpacity"
                    ]);
                    if (!google) return null;
                    var params = _extends({
                        map: map,
                        bounds: bounds,
                        strokeColor: strokeColor,
                        strokeOpacity: strokeOpacity,
                        strokeWeight: strokeWeight,
                        fillColor: fillColor,
                        fillOpacity: fillOpacity
                    }, props);
                    this.rectangle = new google.maps.Rectangle(params);
                    evtNames.forEach(function(e) {
                        _this2.rectangle.addListener(e, _this2.handleEvent(e));
                    });
                    this.rectanglePromise.resolve(this.rectangle);
                }
            },
            {
                key: "getRectangle",
                value: function getRectangle() {
                    return this.rectanglePromise;
                }
            },
            {
                key: "handleEvent",
                value: function handleEvent(evt) {
                    var _this3 = this;
                    return function(e) {
                        var evtName = "on" + (0, _String.camelize)(evt);
                        if (_this3.props[evtName]) _this3.props[evtName](_this3.props, _this3.rectangle, e);
                    };
                }
            },
            {
                key: "render",
                value: function render() {
                    console.log("hii, ", this.props.bounds);
                    return null;
                }
            }
        ]);
        return Rectangle;
    }(_react2.default.Component);
    Rectangle.propTypes = {
        bounds: _propTypes2.default.object,
        strokeColor: _propTypes2.default.string,
        strokeOpacity: _propTypes2.default.number,
        strokeWeight: _propTypes2.default.number,
        fillColor: _propTypes2.default.string,
        fillOpacity: _propTypes2.default.number
    };
    evtNames.forEach(function(e) {
        return Rectangle.propTypes[e] = _propTypes2.default.func;
    });
    Rectangle.defaultProps = {
        name: "Rectangle"
    };
    exports1.default = Rectangle;
});

});
parcelRegister("bIRJp", function(module, exports) {
(function(global, factory) {
    if (typeof define === "function" && define.amd) define([
        "exports"
    ], factory);
    else {
        var mod;
        factory(module.exports);
    }
})(module.exports, function(exports1) {
    "use strict";
    Object.defineProperty(exports1, "__esModule", {
        value: true
    });
    var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    /**
   * Compares two bound objects.
   */ var areBoundsEqual = exports1.areBoundsEqual = function areBoundsEqual(boundA, boundB) {
        if (boundA === boundB) return true;
        if (!(boundA instanceof Object) || !(boundB instanceof Object)) return false;
        if (Object.keys(boundA).length !== Object.keys(boundB).length) return false;
        if (!areValidBounds(boundA) || !areValidBounds(boundB)) return false;
        var _iteratorNormalCompletion = true;
        var _didIteratorError = false;
        var _iteratorError = undefined;
        try {
            for(var _iterator = Object.keys(boundA)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var key = _step.value;
                if (boundA[key] !== boundB[key]) return false;
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return) _iterator.return();
            } finally{
                if (_didIteratorError) throw _iteratorError;
            }
        }
        return true;
    };
    /**
   * Helper that checks whether an array consists of objects
   * with lat and lng properties
   * @param {object} elem the element to check
   * @returns {boolean} whether or not it's valid
   */ var areValidBounds = function areValidBounds(elem) {
        return elem !== null && (typeof elem === "undefined" ? "undefined" : _typeof(elem)) === "object" && elem.hasOwnProperty("north") && elem.hasOwnProperty("south") && elem.hasOwnProperty("east") && elem.hasOwnProperty("west");
    };
});

});


parcelRegister("9oAip", function(module, exports) {
(function(global, factory) {
    if (typeof define === "function" && define.amd) define([
        "exports"
    ], factory);
    else {
        var mod;
        factory(module.exports);
    }
})(module.exports, function(exports1) {
    "use strict";
    Object.defineProperty(exports1, "__esModule", {
        value: true
    });
    // https://facebook.github.io/react/blog/2015/12/16/ismounted-antipattern.html
    var makeCancelable = exports1.makeCancelable = function makeCancelable(promise) {
        var hasCanceled_ = false;
        var wrappedPromise = new Promise(function(resolve, reject) {
            promise.then(function(val) {
                return hasCanceled_ ? reject({
                    isCanceled: true
                }) : resolve(val);
            });
            promise.catch(function(error) {
                return hasCanceled_ ? reject({
                    isCanceled: true
                }) : reject(error);
            });
        });
        return {
            promise: wrappedPromise,
            cancel: function cancel() {
                hasCanceled_ = true;
            }
        };
    };
});

});

parcelRegister("bvEEJ", function(module, exports) {
"use strict";
var $8612205f1301d87b$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $8612205f1301d87b$var$__assign = module.exports && module.exports.__assign || function() {
    $8612205f1301d87b$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $8612205f1301d87b$var$__assign.apply(this, arguments);
};
var $8612205f1301d87b$var$__rest = module.exports && module.exports.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $8612205f1301d87b$var$__importStar = module.exports && module.exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    }
    result["default"] = mod;
    return result;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $8612205f1301d87b$var$React = $8612205f1301d87b$var$__importStar((parcelRequire("acw62")));
var $8612205f1301d87b$var$DEFAULT_COLON = ":";
var $8612205f1301d87b$var$DEFAULT_VALUE_SHORT = "00" + $8612205f1301d87b$var$DEFAULT_COLON + "00";
var $8612205f1301d87b$var$DEFAULT_VALUE_FULL = "00" + $8612205f1301d87b$var$DEFAULT_COLON + "00" + $8612205f1301d87b$var$DEFAULT_COLON + "00";
function $8612205f1301d87b$var$isNumber(value) {
    var number = Number(value);
    return !isNaN(number) && String(value) === String(number);
}
module.exports.isNumber = $8612205f1301d87b$var$isNumber;
function $8612205f1301d87b$var$formatTimeItem(value) {
    return ((value || "") + "00").substr(0, 2);
}
module.exports.formatTimeItem = $8612205f1301d87b$var$formatTimeItem;
function $8612205f1301d87b$var$validateTimeAndCursor(showSeconds, value, defaultValue, colon, cursorPosition) {
    if (showSeconds === void 0) showSeconds = false;
    if (value === void 0) value = "";
    if (defaultValue === void 0) defaultValue = "";
    if (colon === void 0) colon = $8612205f1301d87b$var$DEFAULT_COLON;
    if (cursorPosition === void 0) cursorPosition = 0;
    var _a = defaultValue.split(colon), oldH = _a[0], oldM = _a[1], oldS = _a[2];
    var newCursorPosition = Number(cursorPosition);
    var _b = String(value).split(colon), newH = _b[0], newM = _b[1], newS = _b[2];
    newH = $8612205f1301d87b$var$formatTimeItem(newH);
    if (Number(newH[0]) > 2) {
        newH = oldH;
        newCursorPosition -= 1;
    } else if (Number(newH[0]) === 2) {
        if (Number(oldH[0]) === 2 && Number(newH[1]) > 3) {
            newH = "2" + oldH[1];
            newCursorPosition -= 2;
        } else if (Number(newH[1]) > 3) newH = "23";
    }
    newM = $8612205f1301d87b$var$formatTimeItem(newM);
    if (Number(newM[0]) > 5) {
        newM = oldM;
        newCursorPosition -= 1;
    }
    if (showSeconds) {
        newS = $8612205f1301d87b$var$formatTimeItem(newS);
        if (Number(newS[0]) > 5) {
            newS = oldS;
            newCursorPosition -= 1;
        }
    }
    var validatedValue = showSeconds ? "" + newH + colon + newM + colon + newS : "" + newH + colon + newM;
    return [
        validatedValue,
        newCursorPosition
    ];
}
module.exports.validateTimeAndCursor = $8612205f1301d87b$var$validateTimeAndCursor;
var $8612205f1301d87b$var$TimeField = /** @class */ function(_super) {
    $8612205f1301d87b$var$__extends(TimeField, _super);
    function TimeField(props) {
        var _this = _super.call(this, props) || this;
        var _showSeconds = Boolean(props.showSeconds);
        var _defaultValue = _showSeconds ? $8612205f1301d87b$var$DEFAULT_VALUE_FULL : $8612205f1301d87b$var$DEFAULT_VALUE_SHORT;
        var _colon = props.colon && props.colon.length === 1 ? props.colon : $8612205f1301d87b$var$DEFAULT_COLON;
        var validatedTime = $8612205f1301d87b$var$validateTimeAndCursor(_showSeconds, _this.props.value, _defaultValue, _colon)[0];
        _this.state = {
            value: validatedTime,
            _colon: _colon,
            _showSeconds: _showSeconds,
            _defaultValue: _defaultValue,
            _maxLength: _defaultValue.length
        };
        _this.onInputChange = _this.onInputChange.bind(_this);
        return _this;
    }
    TimeField.prototype.componentDidUpdate = function(prevProps) {
        if (this.props.value !== prevProps.value) {
            var validatedTime = $8612205f1301d87b$var$validateTimeAndCursor(this.state._showSeconds, this.props.value, this.state._defaultValue, this.state._colon)[0];
            this.setState({
                value: validatedTime
            });
        }
    };
    TimeField.prototype.onInputChange = function(event, callback) {
        var oldValue = this.state.value;
        var inputEl = event.target;
        var inputValue = inputEl.value;
        var position = inputEl.selectionEnd || 0;
        var isTyped = inputValue.length > oldValue.length;
        var cursorCharacter = inputValue[position - 1];
        var addedCharacter = isTyped ? cursorCharacter : null;
        var removedCharacter = isTyped ? null : oldValue[position];
        var replacedSingleCharacter = inputValue.length === oldValue.length ? oldValue[position - 1] : null;
        var colon = this.state._colon;
        var newValue = oldValue;
        var newPosition = position;
        if (addedCharacter !== null) {
            if (position > this.state._maxLength) newPosition = this.state._maxLength;
            else if ((position === 3 || position === 6) && addedCharacter === colon) newValue = "" + inputValue.substr(0, position - 1) + colon + inputValue.substr(position + 1);
            else if ((position === 3 || position === 6) && $8612205f1301d87b$var$isNumber(addedCharacter)) {
                newValue = "" + inputValue.substr(0, position - 1) + colon + addedCharacter + inputValue.substr(position + 2);
                newPosition = position + 1;
            } else if ($8612205f1301d87b$var$isNumber(addedCharacter)) {
                // user typed a number
                newValue = inputValue.substr(0, position - 1) + addedCharacter + inputValue.substr(position + 1);
                if (position === 2 || position === 5) newPosition = position + 1;
            } else // if user typed NOT a number, then keep old value & position
            newPosition = position - 1;
        } else if (replacedSingleCharacter !== null) {
            // user replaced only a single character
            if ($8612205f1301d87b$var$isNumber(cursorCharacter)) {
                if (position - 1 === 2 || position - 1 === 5) newValue = "" + inputValue.substr(0, position - 1) + colon + inputValue.substr(position);
                else newValue = inputValue;
            } else {
                // user replaced a number on some non-number character
                newValue = oldValue;
                newPosition = position - 1;
            }
        } else if (typeof cursorCharacter !== "undefined" && cursorCharacter !== colon && !$8612205f1301d87b$var$isNumber(cursorCharacter)) {
            // set of characters replaced by non-number
            newValue = oldValue;
            newPosition = position - 1;
        } else if (removedCharacter !== null) {
            if ((position === 2 || position === 5) && removedCharacter === colon) {
                newValue = inputValue.substr(0, position - 1) + "0" + colon + inputValue.substr(position);
                newPosition = position - 1;
            } else // user removed a number
            newValue = inputValue.substr(0, position) + "0" + inputValue.substr(position);
        }
        var _a = $8612205f1301d87b$var$validateTimeAndCursor(this.state._showSeconds, newValue, oldValue, colon, newPosition), validatedTime = _a[0], validatedCursorPosition = _a[1];
        this.setState({
            value: validatedTime
        }, function() {
            inputEl.selectionStart = validatedCursorPosition;
            inputEl.selectionEnd = validatedCursorPosition;
            callback(event, validatedTime);
        });
        event.persist();
    };
    TimeField.prototype.render = function() {
        var _this = this;
        var value = this.state.value;
        var _a = this.props, onChange = _a.onChange, style = _a.style, showSeconds = _a.showSeconds, input = _a.input, inputRef = _a.inputRef, colon = _a.colon, props = $8612205f1301d87b$var$__rest(_a, [
            "onChange",
            "style",
            "showSeconds",
            "input",
            "inputRef",
            "colon"
        ]); //eslint-disable-line no-unused-vars
        var onChangeHandler = function(event) {
            return _this.onInputChange(event, function(e, v) {
                return onChange && onChange(e, v);
            });
        };
        if (input) return $8612205f1301d87b$var$React.cloneElement(input, $8612205f1301d87b$var$__assign($8612205f1301d87b$var$__assign({}, props), {
            value: value,
            style: style,
            onChange: onChangeHandler
        }));
        return $8612205f1301d87b$var$React.createElement("input", $8612205f1301d87b$var$__assign({
            type: "text"
        }, props, {
            ref: inputRef,
            value: value,
            onChange: onChangeHandler,
            style: $8612205f1301d87b$var$__assign({
                width: showSeconds ? 54 : 35
            }, style)
        }));
    };
    TimeField.defaultProps = {
        showSeconds: false,
        input: null,
        style: {},
        colon: $8612205f1301d87b$var$DEFAULT_COLON
    };
    return TimeField;
}($8612205f1301d87b$var$React.Component);
module.exports.default = $8612205f1301d87b$var$TimeField;

});

parcelRegister("3FXWU", function(module, exports) {

$parcel$export(module.exports, "getVersionCacheKey", () => $2e98f63657d75fba$export$3af51cc27673a6ec);
$parcel$export(module.exports, "getCurrentAppVersion", () => $2e98f63657d75fba$export$b74c7dad0c035ee4);

var $kLorN = parcelRequire("kLorN");

var $bsQZT = parcelRequire("bsQZT");
function $2e98f63657d75fba$export$3af51cc27673a6ec() {
    return (0, $bsQZT.config).API_URL + (0, $kLorN.VERSION_CACHE_KEY);
}
async function $2e98f63657d75fba$export$b74c7dad0c035ee4() {
    const cache = await caches.open((0, $kLorN.VERSION_CACHE_NAME));
    const version = await cache.match($2e98f63657d75fba$export$3af51cc27673a6ec());
    return await version?.text() ?? (0, $kLorN.INITIAL_VERSION);
}

});

var $7b02d682eb115277$exports = {};
"use strict";

$7b02d682eb115277$exports = (parcelRequire("7B2bR"));


var $7e96a608cb33bf79$export$882461b6382ed46c;
var $7e96a608cb33bf79$export$757ceba2d55c277e;
"use strict";

var $1u0KT = parcelRequire("1u0KT");
var $7e96a608cb33bf79$var$i = $1u0KT.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
$7e96a608cb33bf79$export$882461b6382ed46c = function(c, o) {
    $7e96a608cb33bf79$var$i.usingClientEntryPoint = true;
    try {
        return $1u0KT.createRoot(c, o);
    } finally{
        $7e96a608cb33bf79$var$i.usingClientEntryPoint = false;
    }
};
$7e96a608cb33bf79$export$757ceba2d55c277e = function(c, h, o) {
    $7e96a608cb33bf79$var$i.usingClientEntryPoint = true;
    try {
        return $1u0KT.hydrateRoot(c, h, o);
    } finally{
        $7e96a608cb33bf79$var$i.usingClientEntryPoint = false;
    }
};



var $aa99fc635abb2d38$exports = {};
//! moment.js locale configuration
//! locale : Greek [el]
//! author : Aggelos Karalias : https://github.com/mehiel

(function(global, factory) {
    factory((parcelRequire("45fvw")));
})($aa99fc635abb2d38$exports, function(moment) {
    "use strict";
    //! moment.js locale configuration
    function isFunction(input) {
        return typeof Function !== "undefined" && input instanceof Function || Object.prototype.toString.call(input) === "[object Function]";
    }
    var el = moment.defineLocale("el", {
        monthsNominativeEl: "\u0399\u03B1\u03BD\u03BF\u03C5\u03AC\u03C1\u03B9\u03BF\u03C2_\u03A6\u03B5\u03B2\u03C1\u03BF\u03C5\u03AC\u03C1\u03B9\u03BF\u03C2_\u039C\u03AC\u03C1\u03C4\u03B9\u03BF\u03C2_\u0391\u03C0\u03C1\u03AF\u03BB\u03B9\u03BF\u03C2_\u039C\u03AC\u03B9\u03BF\u03C2_\u0399\u03BF\u03CD\u03BD\u03B9\u03BF\u03C2_\u0399\u03BF\u03CD\u03BB\u03B9\u03BF\u03C2_\u0391\u03CD\u03B3\u03BF\u03C5\u03C3\u03C4\u03BF\u03C2_\u03A3\u03B5\u03C0\u03C4\u03AD\u03BC\u03B2\u03C1\u03B9\u03BF\u03C2_\u039F\u03BA\u03C4\u03CE\u03B2\u03C1\u03B9\u03BF\u03C2_\u039D\u03BF\u03AD\u03BC\u03B2\u03C1\u03B9\u03BF\u03C2_\u0394\u03B5\u03BA\u03AD\u03BC\u03B2\u03C1\u03B9\u03BF\u03C2".split("_"),
        monthsGenitiveEl: "\u0399\u03B1\u03BD\u03BF\u03C5\u03B1\u03C1\u03AF\u03BF\u03C5_\u03A6\u03B5\u03B2\u03C1\u03BF\u03C5\u03B1\u03C1\u03AF\u03BF\u03C5_\u039C\u03B1\u03C1\u03C4\u03AF\u03BF\u03C5_\u0391\u03C0\u03C1\u03B9\u03BB\u03AF\u03BF\u03C5_\u039C\u03B1\u0390\u03BF\u03C5_\u0399\u03BF\u03C5\u03BD\u03AF\u03BF\u03C5_\u0399\u03BF\u03C5\u03BB\u03AF\u03BF\u03C5_\u0391\u03C5\u03B3\u03BF\u03CD\u03C3\u03C4\u03BF\u03C5_\u03A3\u03B5\u03C0\u03C4\u03B5\u03BC\u03B2\u03C1\u03AF\u03BF\u03C5_\u039F\u03BA\u03C4\u03C9\u03B2\u03C1\u03AF\u03BF\u03C5_\u039D\u03BF\u03B5\u03BC\u03B2\u03C1\u03AF\u03BF\u03C5_\u0394\u03B5\u03BA\u03B5\u03BC\u03B2\u03C1\u03AF\u03BF\u03C5".split("_"),
        months: function(momentToFormat, format) {
            if (!momentToFormat) return this._monthsNominativeEl;
            else if (typeof format === "string" && /D/.test(format.substring(0, format.indexOf("MMMM")))) // if there is a day number before 'MMMM'
            return this._monthsGenitiveEl[momentToFormat.month()];
            else return this._monthsNominativeEl[momentToFormat.month()];
        },
        monthsShort: "\u0399\u03B1\u03BD_\u03A6\u03B5\u03B2_\u039C\u03B1\u03C1_\u0391\u03C0\u03C1_\u039C\u03B1\u03CA_\u0399\u03BF\u03C5\u03BD_\u0399\u03BF\u03C5\u03BB_\u0391\u03C5\u03B3_\u03A3\u03B5\u03C0_\u039F\u03BA\u03C4_\u039D\u03BF\u03B5_\u0394\u03B5\u03BA".split("_"),
        weekdays: "\u039A\u03C5\u03C1\u03B9\u03B1\u03BA\u03AE_\u0394\u03B5\u03C5\u03C4\u03AD\u03C1\u03B1_\u03A4\u03C1\u03AF\u03C4\u03B7_\u03A4\u03B5\u03C4\u03AC\u03C1\u03C4\u03B7_\u03A0\u03AD\u03BC\u03C0\u03C4\u03B7_\u03A0\u03B1\u03C1\u03B1\u03C3\u03BA\u03B5\u03C5\u03AE_\u03A3\u03AC\u03B2\u03B2\u03B1\u03C4\u03BF".split("_"),
        weekdaysShort: "\u039A\u03C5\u03C1_\u0394\u03B5\u03C5_\u03A4\u03C1\u03B9_\u03A4\u03B5\u03C4_\u03A0\u03B5\u03BC_\u03A0\u03B1\u03C1_\u03A3\u03B1\u03B2".split("_"),
        weekdaysMin: "\u039A\u03C5_\u0394\u03B5_\u03A4\u03C1_\u03A4\u03B5_\u03A0\u03B5_\u03A0\u03B1_\u03A3\u03B1".split("_"),
        meridiem: function(hours, minutes, isLower) {
            if (hours > 11) return isLower ? "\u03BC\u03BC" : "\u039C\u039C";
            else return isLower ? "\u03C0\u03BC" : "\u03A0\u039C";
        },
        isPM: function(input) {
            return (input + "").toLowerCase()[0] === "\u03BC";
        },
        meridiemParse: /[ΠΜ]\.?Μ?\.?/i,
        longDateFormat: {
            LT: "h:mm A",
            LTS: "h:mm:ss A",
            L: "DD/MM/YYYY",
            LL: "D MMMM YYYY",
            LLL: "D MMMM YYYY h:mm A",
            LLLL: "dddd, D MMMM YYYY h:mm A"
        },
        calendarEl: {
            sameDay: "[\u03A3\u03AE\u03BC\u03B5\u03C1\u03B1 {}] LT",
            nextDay: "[\u0391\u03CD\u03C1\u03B9\u03BF {}] LT",
            nextWeek: "dddd [{}] LT",
            lastDay: "[\u03A7\u03B8\u03B5\u03C2 {}] LT",
            lastWeek: function() {
                switch(this.day()){
                    case 6:
                        return "[\u03C4\u03BF \u03C0\u03C1\u03BF\u03B7\u03B3\u03BF\u03CD\u03BC\u03B5\u03BD\u03BF] dddd [{}] LT";
                    default:
                        return "[\u03C4\u03B7\u03BD \u03C0\u03C1\u03BF\u03B7\u03B3\u03BF\u03CD\u03BC\u03B5\u03BD\u03B7] dddd [{}] LT";
                }
            },
            sameElse: "L"
        },
        calendar: function(key, mom) {
            var output = this._calendarEl[key], hours = mom && mom.hours();
            if (isFunction(output)) output = output.apply(mom);
            return output.replace("{}", hours % 12 === 1 ? "\u03C3\u03C4\u03B7" : "\u03C3\u03C4\u03B9\u03C2");
        },
        relativeTime: {
            future: "\u03C3\u03B5 %s",
            past: "%s \u03C0\u03C1\u03B9\u03BD",
            s: "\u03BB\u03AF\u03B3\u03B1 \u03B4\u03B5\u03C5\u03C4\u03B5\u03C1\u03CC\u03BB\u03B5\u03C0\u03C4\u03B1",
            ss: "%d \u03B4\u03B5\u03C5\u03C4\u03B5\u03C1\u03CC\u03BB\u03B5\u03C0\u03C4\u03B1",
            m: "\u03AD\u03BD\u03B1 \u03BB\u03B5\u03C0\u03C4\u03CC",
            mm: "%d \u03BB\u03B5\u03C0\u03C4\u03AC",
            h: "\u03BC\u03AF\u03B1 \u03CE\u03C1\u03B1",
            hh: "%d \u03CE\u03C1\u03B5\u03C2",
            d: "\u03BC\u03AF\u03B1 \u03BC\u03AD\u03C1\u03B1",
            dd: "%d \u03BC\u03AD\u03C1\u03B5\u03C2",
            M: "\u03AD\u03BD\u03B1\u03C2 \u03BC\u03AE\u03BD\u03B1\u03C2",
            MM: "%d \u03BC\u03AE\u03BD\u03B5\u03C2",
            y: "\u03AD\u03BD\u03B1\u03C2 \u03C7\u03C1\u03CC\u03BD\u03BF\u03C2",
            yy: "%d \u03C7\u03C1\u03CC\u03BD\u03B9\u03B1"
        },
        dayOfMonthOrdinalParse: /\d{1,2}η/,
        ordinal: "%d\u03B7",
        week: {
            dow: 1,
            doy: 4
        }
    });
    return el;
});


var $dc754d6167ad2bd7$exports = {};
//! moment.js locale configuration
//! locale : Arabic [ar]
//! author : Abdel Said: https://github.com/abdelsaid
//! author : Ahmed Elkhatib
//! author : forabi https://github.com/forabi

(function(global, factory) {
    factory((parcelRequire("45fvw")));
})($dc754d6167ad2bd7$exports, function(moment) {
    "use strict";
    //! moment.js locale configuration
    var symbolMap = {
        1: "\u0661",
        2: "\u0662",
        3: "\u0663",
        4: "\u0664",
        5: "\u0665",
        6: "\u0666",
        7: "\u0667",
        8: "\u0668",
        9: "\u0669",
        0: "\u0660"
    }, numberMap = {
        "\u0661": "1",
        "\u0662": "2",
        "\u0663": "3",
        "\u0664": "4",
        "\u0665": "5",
        "\u0666": "6",
        "\u0667": "7",
        "\u0668": "8",
        "\u0669": "9",
        "\u0660": "0"
    }, pluralForm = function(n) {
        return n === 0 ? 0 : n === 1 ? 1 : n === 2 ? 2 : n % 100 >= 3 && n % 100 <= 10 ? 3 : n % 100 >= 11 ? 4 : 5;
    }, plurals = {
        s: [
            "\u0623\u0642\u0644 \u0645\u0646 \u062B\u0627\u0646\u064A\u0629",
            "\u062B\u0627\u0646\u064A\u0629 \u0648\u0627\u062D\u062F\u0629",
            [
                "\u062B\u0627\u0646\u064A\u062A\u0627\u0646",
                "\u062B\u0627\u0646\u064A\u062A\u064A\u0646"
            ],
            "%d \u062B\u0648\u0627\u0646",
            "%d \u062B\u0627\u0646\u064A\u0629",
            "%d \u062B\u0627\u0646\u064A\u0629"
        ],
        m: [
            "\u0623\u0642\u0644 \u0645\u0646 \u062F\u0642\u064A\u0642\u0629",
            "\u062F\u0642\u064A\u0642\u0629 \u0648\u0627\u062D\u062F\u0629",
            [
                "\u062F\u0642\u064A\u0642\u062A\u0627\u0646",
                "\u062F\u0642\u064A\u0642\u062A\u064A\u0646"
            ],
            "%d \u062F\u0642\u0627\u0626\u0642",
            "%d \u062F\u0642\u064A\u0642\u0629",
            "%d \u062F\u0642\u064A\u0642\u0629"
        ],
        h: [
            "\u0623\u0642\u0644 \u0645\u0646 \u0633\u0627\u0639\u0629",
            "\u0633\u0627\u0639\u0629 \u0648\u0627\u062D\u062F\u0629",
            [
                "\u0633\u0627\u0639\u062A\u0627\u0646",
                "\u0633\u0627\u0639\u062A\u064A\u0646"
            ],
            "%d \u0633\u0627\u0639\u0627\u062A",
            "%d \u0633\u0627\u0639\u0629",
            "%d \u0633\u0627\u0639\u0629"
        ],
        d: [
            "\u0623\u0642\u0644 \u0645\u0646 \u064A\u0648\u0645",
            "\u064A\u0648\u0645 \u0648\u0627\u062D\u062F",
            [
                "\u064A\u0648\u0645\u0627\u0646",
                "\u064A\u0648\u0645\u064A\u0646"
            ],
            "%d \u0623\u064A\u0627\u0645",
            "%d \u064A\u0648\u0645\u064B\u0627",
            "%d \u064A\u0648\u0645"
        ],
        M: [
            "\u0623\u0642\u0644 \u0645\u0646 \u0634\u0647\u0631",
            "\u0634\u0647\u0631 \u0648\u0627\u062D\u062F",
            [
                "\u0634\u0647\u0631\u0627\u0646",
                "\u0634\u0647\u0631\u064A\u0646"
            ],
            "%d \u0623\u0634\u0647\u0631",
            "%d \u0634\u0647\u0631\u0627",
            "%d \u0634\u0647\u0631"
        ],
        y: [
            "\u0623\u0642\u0644 \u0645\u0646 \u0639\u0627\u0645",
            "\u0639\u0627\u0645 \u0648\u0627\u062D\u062F",
            [
                "\u0639\u0627\u0645\u0627\u0646",
                "\u0639\u0627\u0645\u064A\u0646"
            ],
            "%d \u0623\u0639\u0648\u0627\u0645",
            "%d \u0639\u0627\u0645\u064B\u0627",
            "%d \u0639\u0627\u0645"
        ]
    }, pluralize = function(u) {
        return function(number, withoutSuffix, string, isFuture) {
            var f = pluralForm(number), str = plurals[u][pluralForm(number)];
            if (f === 2) str = str[withoutSuffix ? 0 : 1];
            return str.replace(/%d/i, number);
        };
    }, months = [
        "\u064A\u0646\u0627\u064A\u0631",
        "\u0641\u0628\u0631\u0627\u064A\u0631",
        "\u0645\u0627\u0631\u0633",
        "\u0623\u0628\u0631\u064A\u0644",
        "\u0645\u0627\u064A\u0648",
        "\u064A\u0648\u0646\u064A\u0648",
        "\u064A\u0648\u0644\u064A\u0648",
        "\u0623\u063A\u0633\u0637\u0633",
        "\u0633\u0628\u062A\u0645\u0628\u0631",
        "\u0623\u0643\u062A\u0648\u0628\u0631",
        "\u0646\u0648\u0641\u0645\u0628\u0631",
        "\u062F\u064A\u0633\u0645\u0628\u0631"
    ];
    var ar = moment.defineLocale("ar", {
        months: months,
        monthsShort: months,
        weekdays: "\u0627\u0644\u0623\u062D\u062F_\u0627\u0644\u0625\u062B\u0646\u064A\u0646_\u0627\u0644\u062B\u0644\u0627\u062B\u0627\u0621_\u0627\u0644\u0623\u0631\u0628\u0639\u0627\u0621_\u0627\u0644\u062E\u0645\u064A\u0633_\u0627\u0644\u062C\u0645\u0639\u0629_\u0627\u0644\u0633\u0628\u062A".split("_"),
        weekdaysShort: "\u0623\u062D\u062F_\u0625\u062B\u0646\u064A\u0646_\u062B\u0644\u0627\u062B\u0627\u0621_\u0623\u0631\u0628\u0639\u0627\u0621_\u062E\u0645\u064A\u0633_\u062C\u0645\u0639\u0629_\u0633\u0628\u062A".split("_"),
        weekdaysMin: "\u062D_\u0646_\u062B_\u0631_\u062E_\u062C_\u0633".split("_"),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: "HH:mm",
            LTS: "HH:mm:ss",
            L: "D/\u200FM/\u200FYYYY",
            LL: "D MMMM YYYY",
            LLL: "D MMMM YYYY HH:mm",
            LLLL: "dddd D MMMM YYYY HH:mm"
        },
        meridiemParse: /ص|م/,
        isPM: function(input) {
            return "\u0645" === input;
        },
        meridiem: function(hour, minute, isLower) {
            if (hour < 12) return "\u0635";
            else return "\u0645";
        },
        calendar: {
            sameDay: "[\u0627\u0644\u064A\u0648\u0645 \u0639\u0646\u062F \u0627\u0644\u0633\u0627\u0639\u0629] LT",
            nextDay: "[\u063A\u062F\u064B\u0627 \u0639\u0646\u062F \u0627\u0644\u0633\u0627\u0639\u0629] LT",
            nextWeek: "dddd [\u0639\u0646\u062F \u0627\u0644\u0633\u0627\u0639\u0629] LT",
            lastDay: "[\u0623\u0645\u0633 \u0639\u0646\u062F \u0627\u0644\u0633\u0627\u0639\u0629] LT",
            lastWeek: "dddd [\u0639\u0646\u062F \u0627\u0644\u0633\u0627\u0639\u0629] LT",
            sameElse: "L"
        },
        relativeTime: {
            future: "\u0628\u0639\u062F %s",
            past: "\u0645\u0646\u0630 %s",
            s: pluralize("s"),
            ss: pluralize("s"),
            m: pluralize("m"),
            mm: pluralize("m"),
            h: pluralize("h"),
            hh: pluralize("h"),
            d: pluralize("d"),
            dd: pluralize("d"),
            M: pluralize("M"),
            MM: pluralize("M"),
            y: pluralize("y"),
            yy: pluralize("y")
        },
        preparse: function(string) {
            return string.replace(/[١٢٣٤٥٦٧٨٩٠]/g, function(match) {
                return numberMap[match];
            }).replace(/،/g, ",");
        },
        postformat: function(string) {
            return string.replace(/\d/g, function(match) {
                return symbolMap[match];
            }).replace(/,/g, "\u060C");
        },
        week: {
            dow: 6,
            doy: 12
        }
    });
    return ar;
});



var $c9Z8w = parcelRequire("c9Z8w");
var $2a96cca22bca25a2$exports = {};
"use strict";
function $2a96cca22bca25a2$var$_interopDefault(ex) {
    return ex && typeof ex === "object" && "default" in ex ? ex["default"] : ex;
}

var $acw62 = parcelRequire("acw62");
var $2a96cca22bca25a2$var$React__default = $2a96cca22bca25a2$var$_interopDefault($acw62);
function $2a96cca22bca25a2$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $2a96cca22bca25a2$var$_inheritsLoose(subClass, superClass) {
    subClass.prototype = Object.create(superClass.prototype);
    subClass.prototype.constructor = subClass;
    subClass.__proto__ = superClass;
}
var $2a96cca22bca25a2$var$canUseDOM = !!(typeof window !== "undefined" && window.document && window.document.createElement);
function $2a96cca22bca25a2$var$withSideEffect(reducePropsToState, handleStateChangeOnClient, mapStateOnServer) {
    if (typeof reducePropsToState !== "function") throw new Error("Expected reducePropsToState to be a function.");
    if (typeof handleStateChangeOnClient !== "function") throw new Error("Expected handleStateChangeOnClient to be a function.");
    if (typeof mapStateOnServer !== "undefined" && typeof mapStateOnServer !== "function") throw new Error("Expected mapStateOnServer to either be undefined or a function.");
    function getDisplayName(WrappedComponent) {
        return WrappedComponent.displayName || WrappedComponent.name || "Component";
    }
    return function wrap(WrappedComponent) {
        if (typeof WrappedComponent !== "function") throw new Error("Expected WrappedComponent to be a React component.");
        var mountedInstances = [];
        var state;
        function emitChange() {
            state = reducePropsToState(mountedInstances.map(function(instance) {
                return instance.props;
            }));
            if (SideEffect.canUseDOM) handleStateChangeOnClient(state);
            else if (mapStateOnServer) state = mapStateOnServer(state);
        }
        var SideEffect = /*#__PURE__*/ function(_PureComponent) {
            $2a96cca22bca25a2$var$_inheritsLoose(SideEffect, _PureComponent);
            function SideEffect() {
                return _PureComponent.apply(this, arguments) || this;
            }
            // Try to use displayName of wrapped component
            // Expose canUseDOM so tests can monkeypatch it
            SideEffect.peek = function peek() {
                return state;
            };
            SideEffect.rewind = function rewind() {
                if (SideEffect.canUseDOM) throw new Error("You may only call rewind() on the server. Call peek() to read the current state.");
                var recordedState = state;
                state = undefined;
                mountedInstances = [];
                return recordedState;
            };
            var _proto = SideEffect.prototype;
            _proto.UNSAFE_componentWillMount = function UNSAFE_componentWillMount() {
                mountedInstances.push(this);
                emitChange();
            };
            _proto.componentDidUpdate = function componentDidUpdate() {
                emitChange();
            };
            _proto.componentWillUnmount = function componentWillUnmount() {
                var index = mountedInstances.indexOf(this);
                mountedInstances.splice(index, 1);
                emitChange();
            };
            _proto.render = function render() {
                return $2a96cca22bca25a2$var$React__default.createElement(WrappedComponent, this.props);
            };
            return SideEffect;
        }($acw62.PureComponent);
        $2a96cca22bca25a2$var$_defineProperty(SideEffect, "displayName", "SideEffect(" + getDisplayName(WrappedComponent) + ")");
        $2a96cca22bca25a2$var$_defineProperty(SideEffect, "canUseDOM", $2a96cca22bca25a2$var$canUseDOM);
        return SideEffect;
    };
}
$2a96cca22bca25a2$exports = $2a96cca22bca25a2$var$withSideEffect;


var $78aff76c5c9c7533$exports = {};
/* global Map:readonly, Set:readonly, ArrayBuffer:readonly */ var $78aff76c5c9c7533$var$hasElementType = typeof Element !== "undefined";
var $78aff76c5c9c7533$var$hasMap = typeof Map === "function";
var $78aff76c5c9c7533$var$hasSet = typeof Set === "function";
var $78aff76c5c9c7533$var$hasArrayBuffer = typeof ArrayBuffer === "function" && !!ArrayBuffer.isView;
// Note: We **don't** need `envHasBigInt64Array` in fde es6/index.js
function $78aff76c5c9c7533$var$equal(a, b) {
    // START: fast-deep-equal es6/index.js 3.1.3
    if (a === b) return true;
    if (a && b && typeof a == "object" && typeof b == "object") {
        if (a.constructor !== b.constructor) return false;
        var length, i, keys;
        if (Array.isArray(a)) {
            length = a.length;
            if (length != b.length) return false;
            for(i = length; i-- !== 0;)if (!$78aff76c5c9c7533$var$equal(a[i], b[i])) return false;
            return true;
        }
        // START: Modifications:
        // 1. Extra `has<Type> &&` helpers in initial condition allow es6 code
        //    to co-exist with es5.
        // 2. Replace `for of` with es5 compliant iteration using `for`.
        //    Basically, take:
        //
        //    ```js
        //    for (i of a.entries())
        //      if (!b.has(i[0])) return false;
        //    ```
        //
        //    ... and convert to:
        //
        //    ```js
        //    it = a.entries();
        //    while (!(i = it.next()).done)
        //      if (!b.has(i.value[0])) return false;
        //    ```
        //
        //    **Note**: `i` access switches to `i.value`.
        var it;
        if ($78aff76c5c9c7533$var$hasMap && a instanceof Map && b instanceof Map) {
            if (a.size !== b.size) return false;
            it = a.entries();
            while(!(i = it.next()).done)if (!b.has(i.value[0])) return false;
            it = a.entries();
            while(!(i = it.next()).done)if (!$78aff76c5c9c7533$var$equal(i.value[1], b.get(i.value[0]))) return false;
            return true;
        }
        if ($78aff76c5c9c7533$var$hasSet && a instanceof Set && b instanceof Set) {
            if (a.size !== b.size) return false;
            it = a.entries();
            while(!(i = it.next()).done)if (!b.has(i.value[0])) return false;
            return true;
        }
        // END: Modifications
        if ($78aff76c5c9c7533$var$hasArrayBuffer && ArrayBuffer.isView(a) && ArrayBuffer.isView(b)) {
            length = a.length;
            if (length != b.length) return false;
            for(i = length; i-- !== 0;)if (a[i] !== b[i]) return false;
            return true;
        }
        if (a.constructor === RegExp) return a.source === b.source && a.flags === b.flags;
        // START: Modifications:
        // Apply guards for `Object.create(null)` handling. See:
        // - https://github.com/FormidableLabs/react-fast-compare/issues/64
        // - https://github.com/epoberezkin/fast-deep-equal/issues/49
        if (a.valueOf !== Object.prototype.valueOf && typeof a.valueOf === "function" && typeof b.valueOf === "function") return a.valueOf() === b.valueOf();
        if (a.toString !== Object.prototype.toString && typeof a.toString === "function" && typeof b.toString === "function") return a.toString() === b.toString();
        // END: Modifications
        keys = Object.keys(a);
        length = keys.length;
        if (length !== Object.keys(b).length) return false;
        for(i = length; i-- !== 0;)if (!Object.prototype.hasOwnProperty.call(b, keys[i])) return false;
        // END: fast-deep-equal
        // START: react-fast-compare
        // custom handling for DOM elements
        if ($78aff76c5c9c7533$var$hasElementType && a instanceof Element) return false;
        // custom handling for React/Preact
        for(i = length; i-- !== 0;){
            if ((keys[i] === "_owner" || keys[i] === "__v" || keys[i] === "__o") && a.$$typeof) continue;
            // all other properties should be traversed as usual
            if (!$78aff76c5c9c7533$var$equal(a[keys[i]], b[keys[i]])) return false;
        }
        // END: react-fast-compare
        // START: fast-deep-equal
        return true;
    }
    return a !== a && b !== b;
}
// end fast-deep-equal
$78aff76c5c9c7533$exports = function isEqual(a, b) {
    try {
        return $78aff76c5c9c7533$var$equal(a, b);
    } catch (error) {
        if ((error.message || "").match(/stack|recursion/i)) {
            // warn on circular references, don't crash
            // browsers give this different errors name and messages:
            // chrome/safari: "RangeError", "Maximum call stack size exceeded"
            // firefox: "InternalError", too much recursion"
            // edge: "Error", "Out of stack space"
            console.warn("react-fast-compare cannot handle circular refs");
            return false;
        }
        // some other error. we should definitely know about these
        throw error;
    }
};



var $acw62 = parcelRequire("acw62");

var $8coUR = parcelRequire("8coUR");
var $837d879502e60b4b$var$ATTRIBUTE_NAMES = {
    BODY: "bodyAttributes",
    HTML: "htmlAttributes",
    TITLE: "titleAttributes"
};
var $837d879502e60b4b$var$TAG_NAMES = {
    BASE: "base",
    BODY: "body",
    HEAD: "head",
    HTML: "html",
    LINK: "link",
    META: "meta",
    NOSCRIPT: "noscript",
    SCRIPT: "script",
    STYLE: "style",
    TITLE: "title"
};
var $837d879502e60b4b$var$VALID_TAG_NAMES = Object.keys($837d879502e60b4b$var$TAG_NAMES).map(function(name) {
    return $837d879502e60b4b$var$TAG_NAMES[name];
});
var $837d879502e60b4b$var$TAG_PROPERTIES = {
    CHARSET: "charset",
    CSS_TEXT: "cssText",
    HREF: "href",
    HTTPEQUIV: "http-equiv",
    INNER_HTML: "innerHTML",
    ITEM_PROP: "itemprop",
    NAME: "name",
    PROPERTY: "property",
    REL: "rel",
    SRC: "src",
    TARGET: "target"
};
var $837d879502e60b4b$var$REACT_TAG_MAP = {
    accesskey: "accessKey",
    charset: "charSet",
    class: "className",
    contenteditable: "contentEditable",
    contextmenu: "contextMenu",
    "http-equiv": "httpEquiv",
    itemprop: "itemProp",
    tabindex: "tabIndex"
};
var $837d879502e60b4b$var$HELMET_PROPS = {
    DEFAULT_TITLE: "defaultTitle",
    DEFER: "defer",
    ENCODE_SPECIAL_CHARACTERS: "encodeSpecialCharacters",
    ON_CHANGE_CLIENT_STATE: "onChangeClientState",
    TITLE_TEMPLATE: "titleTemplate"
};
var $837d879502e60b4b$var$HTML_TAG_MAP = Object.keys($837d879502e60b4b$var$REACT_TAG_MAP).reduce(function(obj, key) {
    obj[$837d879502e60b4b$var$REACT_TAG_MAP[key]] = key;
    return obj;
}, {});
var $837d879502e60b4b$var$SELF_CLOSING_TAGS = [
    $837d879502e60b4b$var$TAG_NAMES.NOSCRIPT,
    $837d879502e60b4b$var$TAG_NAMES.SCRIPT,
    $837d879502e60b4b$var$TAG_NAMES.STYLE
];
var $837d879502e60b4b$var$HELMET_ATTRIBUTE = "data-react-helmet";
var $837d879502e60b4b$var$_typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function(obj) {
    return typeof obj;
} : function(obj) {
    return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
};
var $837d879502e60b4b$var$classCallCheck = function(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
};
var $837d879502e60b4b$var$createClass = function() {
    function defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    return function(Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
    };
}();
var $837d879502e60b4b$var$_extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};
var $837d879502e60b4b$var$inherits = function(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
};
var $837d879502e60b4b$var$objectWithoutProperties = function(obj, keys) {
    var target = {};
    for(var i in obj){
        if (keys.indexOf(i) >= 0) continue;
        if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
        target[i] = obj[i];
    }
    return target;
};
var $837d879502e60b4b$var$possibleConstructorReturn = function(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
};
var $837d879502e60b4b$var$encodeSpecialCharacters = function encodeSpecialCharacters(str) {
    var encode = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
    if (encode === false) return String(str);
    return String(str).replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;").replace(/'/g, "&#x27;");
};
var $837d879502e60b4b$var$getTitleFromPropsList = function getTitleFromPropsList(propsList) {
    var innermostTitle = $837d879502e60b4b$var$getInnermostProperty(propsList, $837d879502e60b4b$var$TAG_NAMES.TITLE);
    var innermostTemplate = $837d879502e60b4b$var$getInnermostProperty(propsList, $837d879502e60b4b$var$HELMET_PROPS.TITLE_TEMPLATE);
    if (innermostTemplate && innermostTitle) // use function arg to avoid need to escape $ characters
    return innermostTemplate.replace(/%s/g, function() {
        return Array.isArray(innermostTitle) ? innermostTitle.join("") : innermostTitle;
    });
    var innermostDefaultTitle = $837d879502e60b4b$var$getInnermostProperty(propsList, $837d879502e60b4b$var$HELMET_PROPS.DEFAULT_TITLE);
    return innermostTitle || innermostDefaultTitle || undefined;
};
var $837d879502e60b4b$var$getOnChangeClientState = function getOnChangeClientState(propsList) {
    return $837d879502e60b4b$var$getInnermostProperty(propsList, $837d879502e60b4b$var$HELMET_PROPS.ON_CHANGE_CLIENT_STATE) || function() {};
};
var $837d879502e60b4b$var$getAttributesFromPropsList = function getAttributesFromPropsList(tagType, propsList) {
    return propsList.filter(function(props) {
        return typeof props[tagType] !== "undefined";
    }).map(function(props) {
        return props[tagType];
    }).reduce(function(tagAttrs, current) {
        return $837d879502e60b4b$var$_extends({}, tagAttrs, current);
    }, {});
};
var $837d879502e60b4b$var$getBaseTagFromPropsList = function getBaseTagFromPropsList(primaryAttributes, propsList) {
    return propsList.filter(function(props) {
        return typeof props[$837d879502e60b4b$var$TAG_NAMES.BASE] !== "undefined";
    }).map(function(props) {
        return props[$837d879502e60b4b$var$TAG_NAMES.BASE];
    }).reverse().reduce(function(innermostBaseTag, tag) {
        if (!innermostBaseTag.length) {
            var keys = Object.keys(tag);
            for(var i = 0; i < keys.length; i++){
                var attributeKey = keys[i];
                var lowerCaseAttributeKey = attributeKey.toLowerCase();
                if (primaryAttributes.indexOf(lowerCaseAttributeKey) !== -1 && tag[lowerCaseAttributeKey]) return innermostBaseTag.concat(tag);
            }
        }
        return innermostBaseTag;
    }, []);
};
var $837d879502e60b4b$var$getTagsFromPropsList = function getTagsFromPropsList(tagName, primaryAttributes, propsList) {
    // Calculate list of tags, giving priority innermost component (end of the propslist)
    var approvedSeenTags = {};
    return propsList.filter(function(props) {
        if (Array.isArray(props[tagName])) return true;
        if (typeof props[tagName] !== "undefined") $837d879502e60b4b$var$warn("Helmet: " + tagName + ' should be of type "Array". Instead found type "' + $837d879502e60b4b$var$_typeof(props[tagName]) + '"');
        return false;
    }).map(function(props) {
        return props[tagName];
    }).reverse().reduce(function(approvedTags, instanceTags) {
        var instanceSeenTags = {};
        instanceTags.filter(function(tag) {
            var primaryAttributeKey = void 0;
            var keys = Object.keys(tag);
            for(var i = 0; i < keys.length; i++){
                var attributeKey = keys[i];
                var lowerCaseAttributeKey = attributeKey.toLowerCase();
                // Special rule with link tags, since rel and href are both primary tags, rel takes priority
                if (primaryAttributes.indexOf(lowerCaseAttributeKey) !== -1 && !(primaryAttributeKey === $837d879502e60b4b$var$TAG_PROPERTIES.REL && tag[primaryAttributeKey].toLowerCase() === "canonical") && !(lowerCaseAttributeKey === $837d879502e60b4b$var$TAG_PROPERTIES.REL && tag[lowerCaseAttributeKey].toLowerCase() === "stylesheet")) primaryAttributeKey = lowerCaseAttributeKey;
                // Special case for innerHTML which doesn't work lowercased
                if (primaryAttributes.indexOf(attributeKey) !== -1 && (attributeKey === $837d879502e60b4b$var$TAG_PROPERTIES.INNER_HTML || attributeKey === $837d879502e60b4b$var$TAG_PROPERTIES.CSS_TEXT || attributeKey === $837d879502e60b4b$var$TAG_PROPERTIES.ITEM_PROP)) primaryAttributeKey = attributeKey;
            }
            if (!primaryAttributeKey || !tag[primaryAttributeKey]) return false;
            var value = tag[primaryAttributeKey].toLowerCase();
            if (!approvedSeenTags[primaryAttributeKey]) approvedSeenTags[primaryAttributeKey] = {};
            if (!instanceSeenTags[primaryAttributeKey]) instanceSeenTags[primaryAttributeKey] = {};
            if (!approvedSeenTags[primaryAttributeKey][value]) {
                instanceSeenTags[primaryAttributeKey][value] = true;
                return true;
            }
            return false;
        }).reverse().forEach(function(tag) {
            return approvedTags.push(tag);
        });
        // Update seen tags with tags from this instance
        var keys = Object.keys(instanceSeenTags);
        for(var i = 0; i < keys.length; i++){
            var attributeKey = keys[i];
            var tagUnion = (0, (/*@__PURE__*/$parcel$interopDefault($8coUR)))({}, approvedSeenTags[attributeKey], instanceSeenTags[attributeKey]);
            approvedSeenTags[attributeKey] = tagUnion;
        }
        return approvedTags;
    }, []).reverse();
};
var $837d879502e60b4b$var$getInnermostProperty = function getInnermostProperty(propsList, property) {
    for(var i = propsList.length - 1; i >= 0; i--){
        var props = propsList[i];
        if (props.hasOwnProperty(property)) return props[property];
    }
    return null;
};
var $837d879502e60b4b$var$reducePropsToState = function reducePropsToState(propsList) {
    return {
        baseTag: $837d879502e60b4b$var$getBaseTagFromPropsList([
            $837d879502e60b4b$var$TAG_PROPERTIES.HREF,
            $837d879502e60b4b$var$TAG_PROPERTIES.TARGET
        ], propsList),
        bodyAttributes: $837d879502e60b4b$var$getAttributesFromPropsList($837d879502e60b4b$var$ATTRIBUTE_NAMES.BODY, propsList),
        defer: $837d879502e60b4b$var$getInnermostProperty(propsList, $837d879502e60b4b$var$HELMET_PROPS.DEFER),
        encode: $837d879502e60b4b$var$getInnermostProperty(propsList, $837d879502e60b4b$var$HELMET_PROPS.ENCODE_SPECIAL_CHARACTERS),
        htmlAttributes: $837d879502e60b4b$var$getAttributesFromPropsList($837d879502e60b4b$var$ATTRIBUTE_NAMES.HTML, propsList),
        linkTags: $837d879502e60b4b$var$getTagsFromPropsList($837d879502e60b4b$var$TAG_NAMES.LINK, [
            $837d879502e60b4b$var$TAG_PROPERTIES.REL,
            $837d879502e60b4b$var$TAG_PROPERTIES.HREF
        ], propsList),
        metaTags: $837d879502e60b4b$var$getTagsFromPropsList($837d879502e60b4b$var$TAG_NAMES.META, [
            $837d879502e60b4b$var$TAG_PROPERTIES.NAME,
            $837d879502e60b4b$var$TAG_PROPERTIES.CHARSET,
            $837d879502e60b4b$var$TAG_PROPERTIES.HTTPEQUIV,
            $837d879502e60b4b$var$TAG_PROPERTIES.PROPERTY,
            $837d879502e60b4b$var$TAG_PROPERTIES.ITEM_PROP
        ], propsList),
        noscriptTags: $837d879502e60b4b$var$getTagsFromPropsList($837d879502e60b4b$var$TAG_NAMES.NOSCRIPT, [
            $837d879502e60b4b$var$TAG_PROPERTIES.INNER_HTML
        ], propsList),
        onChangeClientState: $837d879502e60b4b$var$getOnChangeClientState(propsList),
        scriptTags: $837d879502e60b4b$var$getTagsFromPropsList($837d879502e60b4b$var$TAG_NAMES.SCRIPT, [
            $837d879502e60b4b$var$TAG_PROPERTIES.SRC,
            $837d879502e60b4b$var$TAG_PROPERTIES.INNER_HTML
        ], propsList),
        styleTags: $837d879502e60b4b$var$getTagsFromPropsList($837d879502e60b4b$var$TAG_NAMES.STYLE, [
            $837d879502e60b4b$var$TAG_PROPERTIES.CSS_TEXT
        ], propsList),
        title: $837d879502e60b4b$var$getTitleFromPropsList(propsList),
        titleAttributes: $837d879502e60b4b$var$getAttributesFromPropsList($837d879502e60b4b$var$ATTRIBUTE_NAMES.TITLE, propsList)
    };
};
var $837d879502e60b4b$var$rafPolyfill = function() {
    var clock = Date.now();
    return function(callback) {
        var currentTime = Date.now();
        if (currentTime - clock > 16) {
            clock = currentTime;
            callback(currentTime);
        } else setTimeout(function() {
            $837d879502e60b4b$var$rafPolyfill(callback);
        }, 0);
    };
}();
var $837d879502e60b4b$var$cafPolyfill = function cafPolyfill(id) {
    return clearTimeout(id);
};
var $837d879502e60b4b$var$requestAnimationFrame = typeof window !== "undefined" ? window.requestAnimationFrame && window.requestAnimationFrame.bind(window) || window.webkitRequestAnimationFrame || window.mozRequestAnimationFrame || $837d879502e60b4b$var$rafPolyfill : $parcel$global.requestAnimationFrame || $837d879502e60b4b$var$rafPolyfill;
var $837d879502e60b4b$var$cancelAnimationFrame = typeof window !== "undefined" ? window.cancelAnimationFrame || window.webkitCancelAnimationFrame || window.mozCancelAnimationFrame || $837d879502e60b4b$var$cafPolyfill : $parcel$global.cancelAnimationFrame || $837d879502e60b4b$var$cafPolyfill;
var $837d879502e60b4b$var$warn = function warn(msg) {
    return console && typeof console.warn === "function" && console.warn(msg);
};
var $837d879502e60b4b$var$_helmetCallback = null;
var $837d879502e60b4b$var$handleClientStateChange = function handleClientStateChange(newState) {
    if ($837d879502e60b4b$var$_helmetCallback) $837d879502e60b4b$var$cancelAnimationFrame($837d879502e60b4b$var$_helmetCallback);
    if (newState.defer) $837d879502e60b4b$var$_helmetCallback = $837d879502e60b4b$var$requestAnimationFrame(function() {
        $837d879502e60b4b$var$commitTagChanges(newState, function() {
            $837d879502e60b4b$var$_helmetCallback = null;
        });
    });
    else {
        $837d879502e60b4b$var$commitTagChanges(newState);
        $837d879502e60b4b$var$_helmetCallback = null;
    }
};
var $837d879502e60b4b$var$commitTagChanges = function commitTagChanges(newState, cb) {
    var baseTag = newState.baseTag, bodyAttributes = newState.bodyAttributes, htmlAttributes = newState.htmlAttributes, linkTags = newState.linkTags, metaTags = newState.metaTags, noscriptTags = newState.noscriptTags, onChangeClientState = newState.onChangeClientState, scriptTags = newState.scriptTags, styleTags = newState.styleTags, title = newState.title, titleAttributes = newState.titleAttributes;
    $837d879502e60b4b$var$updateAttributes($837d879502e60b4b$var$TAG_NAMES.BODY, bodyAttributes);
    $837d879502e60b4b$var$updateAttributes($837d879502e60b4b$var$TAG_NAMES.HTML, htmlAttributes);
    $837d879502e60b4b$var$updateTitle(title, titleAttributes);
    var tagUpdates = {
        baseTag: $837d879502e60b4b$var$updateTags($837d879502e60b4b$var$TAG_NAMES.BASE, baseTag),
        linkTags: $837d879502e60b4b$var$updateTags($837d879502e60b4b$var$TAG_NAMES.LINK, linkTags),
        metaTags: $837d879502e60b4b$var$updateTags($837d879502e60b4b$var$TAG_NAMES.META, metaTags),
        noscriptTags: $837d879502e60b4b$var$updateTags($837d879502e60b4b$var$TAG_NAMES.NOSCRIPT, noscriptTags),
        scriptTags: $837d879502e60b4b$var$updateTags($837d879502e60b4b$var$TAG_NAMES.SCRIPT, scriptTags),
        styleTags: $837d879502e60b4b$var$updateTags($837d879502e60b4b$var$TAG_NAMES.STYLE, styleTags)
    };
    var addedTags = {};
    var removedTags = {};
    Object.keys(tagUpdates).forEach(function(tagType) {
        var _tagUpdates$tagType = tagUpdates[tagType], newTags = _tagUpdates$tagType.newTags, oldTags = _tagUpdates$tagType.oldTags;
        if (newTags.length) addedTags[tagType] = newTags;
        if (oldTags.length) removedTags[tagType] = tagUpdates[tagType].oldTags;
    });
    cb && cb();
    onChangeClientState(newState, addedTags, removedTags);
};
var $837d879502e60b4b$var$flattenArray = function flattenArray(possibleArray) {
    return Array.isArray(possibleArray) ? possibleArray.join("") : possibleArray;
};
var $837d879502e60b4b$var$updateTitle = function updateTitle(title, attributes) {
    if (typeof title !== "undefined" && document.title !== title) document.title = $837d879502e60b4b$var$flattenArray(title);
    $837d879502e60b4b$var$updateAttributes($837d879502e60b4b$var$TAG_NAMES.TITLE, attributes);
};
var $837d879502e60b4b$var$updateAttributes = function updateAttributes(tagName, attributes) {
    var elementTag = document.getElementsByTagName(tagName)[0];
    if (!elementTag) return;
    var helmetAttributeString = elementTag.getAttribute($837d879502e60b4b$var$HELMET_ATTRIBUTE);
    var helmetAttributes = helmetAttributeString ? helmetAttributeString.split(",") : [];
    var attributesToRemove = [].concat(helmetAttributes);
    var attributeKeys = Object.keys(attributes);
    for(var i = 0; i < attributeKeys.length; i++){
        var attribute = attributeKeys[i];
        var value = attributes[attribute] || "";
        if (elementTag.getAttribute(attribute) !== value) elementTag.setAttribute(attribute, value);
        if (helmetAttributes.indexOf(attribute) === -1) helmetAttributes.push(attribute);
        var indexToSave = attributesToRemove.indexOf(attribute);
        if (indexToSave !== -1) attributesToRemove.splice(indexToSave, 1);
    }
    for(var _i = attributesToRemove.length - 1; _i >= 0; _i--)elementTag.removeAttribute(attributesToRemove[_i]);
    if (helmetAttributes.length === attributesToRemove.length) elementTag.removeAttribute($837d879502e60b4b$var$HELMET_ATTRIBUTE);
    else if (elementTag.getAttribute($837d879502e60b4b$var$HELMET_ATTRIBUTE) !== attributeKeys.join(",")) elementTag.setAttribute($837d879502e60b4b$var$HELMET_ATTRIBUTE, attributeKeys.join(","));
};
var $837d879502e60b4b$var$updateTags = function updateTags(type, tags) {
    var headElement = document.head || document.querySelector($837d879502e60b4b$var$TAG_NAMES.HEAD);
    var tagNodes = headElement.querySelectorAll(type + "[" + $837d879502e60b4b$var$HELMET_ATTRIBUTE + "]");
    var oldTags = Array.prototype.slice.call(tagNodes);
    var newTags = [];
    var indexToDelete = void 0;
    if (tags && tags.length) tags.forEach(function(tag) {
        var newElement = document.createElement(type);
        for(var attribute in tag)if (tag.hasOwnProperty(attribute)) {
            if (attribute === $837d879502e60b4b$var$TAG_PROPERTIES.INNER_HTML) newElement.innerHTML = tag.innerHTML;
            else if (attribute === $837d879502e60b4b$var$TAG_PROPERTIES.CSS_TEXT) {
                if (newElement.styleSheet) newElement.styleSheet.cssText = tag.cssText;
                else newElement.appendChild(document.createTextNode(tag.cssText));
            } else {
                var value = typeof tag[attribute] === "undefined" ? "" : tag[attribute];
                newElement.setAttribute(attribute, value);
            }
        }
        newElement.setAttribute($837d879502e60b4b$var$HELMET_ATTRIBUTE, "true");
        // Remove a duplicate tag from domTagstoRemove, so it isn't cleared.
        if (oldTags.some(function(existingTag, index) {
            indexToDelete = index;
            return newElement.isEqualNode(existingTag);
        })) oldTags.splice(indexToDelete, 1);
        else newTags.push(newElement);
    });
    oldTags.forEach(function(tag) {
        return tag.parentNode.removeChild(tag);
    });
    newTags.forEach(function(tag) {
        return headElement.appendChild(tag);
    });
    return {
        oldTags: oldTags,
        newTags: newTags
    };
};
var $837d879502e60b4b$var$generateElementAttributesAsString = function generateElementAttributesAsString(attributes) {
    return Object.keys(attributes).reduce(function(str, key) {
        var attr = typeof attributes[key] !== "undefined" ? key + '="' + attributes[key] + '"' : "" + key;
        return str ? str + " " + attr : attr;
    }, "");
};
var $837d879502e60b4b$var$generateTitleAsString = function generateTitleAsString(type, title, attributes, encode) {
    var attributeString = $837d879502e60b4b$var$generateElementAttributesAsString(attributes);
    var flattenedTitle = $837d879502e60b4b$var$flattenArray(title);
    return attributeString ? "<" + type + " " + $837d879502e60b4b$var$HELMET_ATTRIBUTE + '="true" ' + attributeString + ">" + $837d879502e60b4b$var$encodeSpecialCharacters(flattenedTitle, encode) + "</" + type + ">" : "<" + type + " " + $837d879502e60b4b$var$HELMET_ATTRIBUTE + '="true">' + $837d879502e60b4b$var$encodeSpecialCharacters(flattenedTitle, encode) + "</" + type + ">";
};
var $837d879502e60b4b$var$generateTagsAsString = function generateTagsAsString(type, tags, encode) {
    return tags.reduce(function(str, tag) {
        var attributeHtml = Object.keys(tag).filter(function(attribute) {
            return !(attribute === $837d879502e60b4b$var$TAG_PROPERTIES.INNER_HTML || attribute === $837d879502e60b4b$var$TAG_PROPERTIES.CSS_TEXT);
        }).reduce(function(string, attribute) {
            var attr = typeof tag[attribute] === "undefined" ? attribute : attribute + '="' + $837d879502e60b4b$var$encodeSpecialCharacters(tag[attribute], encode) + '"';
            return string ? string + " " + attr : attr;
        }, "");
        var tagContent = tag.innerHTML || tag.cssText || "";
        var isSelfClosing = $837d879502e60b4b$var$SELF_CLOSING_TAGS.indexOf(type) === -1;
        return str + "<" + type + " " + $837d879502e60b4b$var$HELMET_ATTRIBUTE + '="true" ' + attributeHtml + (isSelfClosing ? "/>" : ">" + tagContent + "</" + type + ">");
    }, "");
};
var $837d879502e60b4b$var$convertElementAttributestoReactProps = function convertElementAttributestoReactProps(attributes) {
    var initProps = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    return Object.keys(attributes).reduce(function(obj, key) {
        obj[$837d879502e60b4b$var$REACT_TAG_MAP[key] || key] = attributes[key];
        return obj;
    }, initProps);
};
var $837d879502e60b4b$var$convertReactPropstoHtmlAttributes = function convertReactPropstoHtmlAttributes(props) {
    var initAttributes = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    return Object.keys(props).reduce(function(obj, key) {
        obj[$837d879502e60b4b$var$HTML_TAG_MAP[key] || key] = props[key];
        return obj;
    }, initAttributes);
};
var $837d879502e60b4b$var$generateTitleAsReactComponent = function generateTitleAsReactComponent(type, title, attributes) {
    var _initProps;
    // assigning into an array to define toString function on it
    var initProps = (_initProps = {
        key: title
    }, _initProps[$837d879502e60b4b$var$HELMET_ATTRIBUTE] = true, _initProps);
    var props = $837d879502e60b4b$var$convertElementAttributestoReactProps(attributes, initProps);
    return [
        (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($837d879502e60b4b$var$TAG_NAMES.TITLE, props, title)
    ];
};
var $837d879502e60b4b$var$generateTagsAsReactComponent = function generateTagsAsReactComponent(type, tags) {
    return tags.map(function(tag, i) {
        var _mappedTag;
        var mappedTag = (_mappedTag = {
            key: i
        }, _mappedTag[$837d879502e60b4b$var$HELMET_ATTRIBUTE] = true, _mappedTag);
        Object.keys(tag).forEach(function(attribute) {
            var mappedAttribute = $837d879502e60b4b$var$REACT_TAG_MAP[attribute] || attribute;
            if (mappedAttribute === $837d879502e60b4b$var$TAG_PROPERTIES.INNER_HTML || mappedAttribute === $837d879502e60b4b$var$TAG_PROPERTIES.CSS_TEXT) {
                var content = tag.innerHTML || tag.cssText;
                mappedTag.dangerouslySetInnerHTML = {
                    __html: content
                };
            } else mappedTag[mappedAttribute] = tag[attribute];
        });
        return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(type, mappedTag);
    });
};
var $837d879502e60b4b$var$getMethodsForTag = function getMethodsForTag(type, tags, encode) {
    switch(type){
        case $837d879502e60b4b$var$TAG_NAMES.TITLE:
            return {
                toComponent: function toComponent() {
                    return $837d879502e60b4b$var$generateTitleAsReactComponent(type, tags.title, tags.titleAttributes, encode);
                },
                toString: function toString() {
                    return $837d879502e60b4b$var$generateTitleAsString(type, tags.title, tags.titleAttributes, encode);
                }
            };
        case $837d879502e60b4b$var$ATTRIBUTE_NAMES.BODY:
        case $837d879502e60b4b$var$ATTRIBUTE_NAMES.HTML:
            return {
                toComponent: function toComponent() {
                    return $837d879502e60b4b$var$convertElementAttributestoReactProps(tags);
                },
                toString: function toString() {
                    return $837d879502e60b4b$var$generateElementAttributesAsString(tags);
                }
            };
        default:
            return {
                toComponent: function toComponent() {
                    return $837d879502e60b4b$var$generateTagsAsReactComponent(type, tags);
                },
                toString: function toString() {
                    return $837d879502e60b4b$var$generateTagsAsString(type, tags, encode);
                }
            };
    }
};
var $837d879502e60b4b$var$mapStateOnServer = function mapStateOnServer(_ref) {
    var baseTag = _ref.baseTag, bodyAttributes = _ref.bodyAttributes, encode = _ref.encode, htmlAttributes = _ref.htmlAttributes, linkTags = _ref.linkTags, metaTags = _ref.metaTags, noscriptTags = _ref.noscriptTags, scriptTags = _ref.scriptTags, styleTags = _ref.styleTags, _ref$title = _ref.title, title = _ref$title === undefined ? "" : _ref$title, titleAttributes = _ref.titleAttributes;
    return {
        base: $837d879502e60b4b$var$getMethodsForTag($837d879502e60b4b$var$TAG_NAMES.BASE, baseTag, encode),
        bodyAttributes: $837d879502e60b4b$var$getMethodsForTag($837d879502e60b4b$var$ATTRIBUTE_NAMES.BODY, bodyAttributes, encode),
        htmlAttributes: $837d879502e60b4b$var$getMethodsForTag($837d879502e60b4b$var$ATTRIBUTE_NAMES.HTML, htmlAttributes, encode),
        link: $837d879502e60b4b$var$getMethodsForTag($837d879502e60b4b$var$TAG_NAMES.LINK, linkTags, encode),
        meta: $837d879502e60b4b$var$getMethodsForTag($837d879502e60b4b$var$TAG_NAMES.META, metaTags, encode),
        noscript: $837d879502e60b4b$var$getMethodsForTag($837d879502e60b4b$var$TAG_NAMES.NOSCRIPT, noscriptTags, encode),
        script: $837d879502e60b4b$var$getMethodsForTag($837d879502e60b4b$var$TAG_NAMES.SCRIPT, scriptTags, encode),
        style: $837d879502e60b4b$var$getMethodsForTag($837d879502e60b4b$var$TAG_NAMES.STYLE, styleTags, encode),
        title: $837d879502e60b4b$var$getMethodsForTag($837d879502e60b4b$var$TAG_NAMES.TITLE, {
            title: title,
            titleAttributes: titleAttributes
        }, encode)
    };
};
var $837d879502e60b4b$var$Helmet = function Helmet(Component) {
    var _class, _temp;
    return _temp = _class = function(_React$Component) {
        $837d879502e60b4b$var$inherits(HelmetWrapper, _React$Component);
        function HelmetWrapper() {
            $837d879502e60b4b$var$classCallCheck(this, HelmetWrapper);
            return $837d879502e60b4b$var$possibleConstructorReturn(this, _React$Component.apply(this, arguments));
        }
        HelmetWrapper.prototype.shouldComponentUpdate = function shouldComponentUpdate(nextProps) {
            return !(0, (/*@__PURE__*/$parcel$interopDefault($78aff76c5c9c7533$exports)))(this.props, nextProps);
        };
        HelmetWrapper.prototype.mapNestedChildrenToProps = function mapNestedChildrenToProps(child, nestedChildren) {
            if (!nestedChildren) return null;
            switch(child.type){
                case $837d879502e60b4b$var$TAG_NAMES.SCRIPT:
                case $837d879502e60b4b$var$TAG_NAMES.NOSCRIPT:
                    return {
                        innerHTML: nestedChildren
                    };
                case $837d879502e60b4b$var$TAG_NAMES.STYLE:
                    return {
                        cssText: nestedChildren
                    };
            }
            throw new Error("<" + child.type + " /> elements are self-closing and can not contain children. Refer to our API for more information.");
        };
        HelmetWrapper.prototype.flattenArrayTypeChildren = function flattenArrayTypeChildren(_ref) {
            var _babelHelpers$extends;
            var child = _ref.child, arrayTypeChildren = _ref.arrayTypeChildren, newChildProps = _ref.newChildProps, nestedChildren = _ref.nestedChildren;
            return $837d879502e60b4b$var$_extends({}, arrayTypeChildren, (_babelHelpers$extends = {}, _babelHelpers$extends[child.type] = [].concat(arrayTypeChildren[child.type] || [], [
                $837d879502e60b4b$var$_extends({}, newChildProps, this.mapNestedChildrenToProps(child, nestedChildren))
            ]), _babelHelpers$extends));
        };
        HelmetWrapper.prototype.mapObjectTypeChildren = function mapObjectTypeChildren(_ref2) {
            var _babelHelpers$extends2, _babelHelpers$extends3;
            var child = _ref2.child, newProps = _ref2.newProps, newChildProps = _ref2.newChildProps, nestedChildren = _ref2.nestedChildren;
            switch(child.type){
                case $837d879502e60b4b$var$TAG_NAMES.TITLE:
                    return $837d879502e60b4b$var$_extends({}, newProps, (_babelHelpers$extends2 = {}, _babelHelpers$extends2[child.type] = nestedChildren, _babelHelpers$extends2.titleAttributes = $837d879502e60b4b$var$_extends({}, newChildProps), _babelHelpers$extends2));
                case $837d879502e60b4b$var$TAG_NAMES.BODY:
                    return $837d879502e60b4b$var$_extends({}, newProps, {
                        bodyAttributes: $837d879502e60b4b$var$_extends({}, newChildProps)
                    });
                case $837d879502e60b4b$var$TAG_NAMES.HTML:
                    return $837d879502e60b4b$var$_extends({}, newProps, {
                        htmlAttributes: $837d879502e60b4b$var$_extends({}, newChildProps)
                    });
            }
            return $837d879502e60b4b$var$_extends({}, newProps, (_babelHelpers$extends3 = {}, _babelHelpers$extends3[child.type] = $837d879502e60b4b$var$_extends({}, newChildProps), _babelHelpers$extends3));
        };
        HelmetWrapper.prototype.mapArrayTypeChildrenToProps = function mapArrayTypeChildrenToProps(arrayTypeChildren, newProps) {
            var newFlattenedProps = $837d879502e60b4b$var$_extends({}, newProps);
            Object.keys(arrayTypeChildren).forEach(function(arrayChildName) {
                var _babelHelpers$extends4;
                newFlattenedProps = $837d879502e60b4b$var$_extends({}, newFlattenedProps, (_babelHelpers$extends4 = {}, _babelHelpers$extends4[arrayChildName] = arrayTypeChildren[arrayChildName], _babelHelpers$extends4));
            });
            return newFlattenedProps;
        };
        HelmetWrapper.prototype.warnOnInvalidChildren = function warnOnInvalidChildren(child, nestedChildren) {
            if (!$837d879502e60b4b$var$VALID_TAG_NAMES.some(function(name) {
                return child.type === name;
            })) {
                if (typeof child.type === "function") return $837d879502e60b4b$var$warn("You may be attempting to nest <Helmet> components within each other, which is not allowed. Refer to our API for more information.");
                return $837d879502e60b4b$var$warn("Only elements types " + $837d879502e60b4b$var$VALID_TAG_NAMES.join(", ") + " are allowed. Helmet does not support rendering <" + child.type + "> elements. Refer to our API for more information.");
            }
            if (nestedChildren && typeof nestedChildren !== "string" && (!Array.isArray(nestedChildren) || nestedChildren.some(function(nestedChild) {
                return typeof nestedChild !== "string";
            }))) throw new Error("Helmet expects a string as a child of <" + child.type + ">. Did you forget to wrap your children in braces? ( <" + child.type + ">{``}</" + child.type + "> ) Refer to our API for more information.");
            return true;
        };
        HelmetWrapper.prototype.mapChildrenToProps = function mapChildrenToProps(children, newProps) {
            var _this2 = this;
            var arrayTypeChildren = {};
            (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Children.forEach(children, function(child) {
                if (!child || !child.props) return;
                var _child$props = child.props, nestedChildren = _child$props.children, childProps = $837d879502e60b4b$var$objectWithoutProperties(_child$props, [
                    "children"
                ]);
                var newChildProps = $837d879502e60b4b$var$convertReactPropstoHtmlAttributes(childProps);
                _this2.warnOnInvalidChildren(child, nestedChildren);
                switch(child.type){
                    case $837d879502e60b4b$var$TAG_NAMES.LINK:
                    case $837d879502e60b4b$var$TAG_NAMES.META:
                    case $837d879502e60b4b$var$TAG_NAMES.NOSCRIPT:
                    case $837d879502e60b4b$var$TAG_NAMES.SCRIPT:
                    case $837d879502e60b4b$var$TAG_NAMES.STYLE:
                        arrayTypeChildren = _this2.flattenArrayTypeChildren({
                            child: child,
                            arrayTypeChildren: arrayTypeChildren,
                            newChildProps: newChildProps,
                            nestedChildren: nestedChildren
                        });
                        break;
                    default:
                        newProps = _this2.mapObjectTypeChildren({
                            child: child,
                            newProps: newProps,
                            newChildProps: newChildProps,
                            nestedChildren: nestedChildren
                        });
                        break;
                }
            });
            newProps = this.mapArrayTypeChildrenToProps(arrayTypeChildren, newProps);
            return newProps;
        };
        HelmetWrapper.prototype.render = function render() {
            var _props = this.props, children = _props.children, props = $837d879502e60b4b$var$objectWithoutProperties(_props, [
                "children"
            ]);
            var newProps = $837d879502e60b4b$var$_extends({}, props);
            if (children) newProps = this.mapChildrenToProps(children, newProps);
            return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(Component, newProps);
        };
        $837d879502e60b4b$var$createClass(HelmetWrapper, null, [
            {
                key: "canUseDOM",
                // Component.peek comes from react-side-effect:
                // For testing, you may use a static peek() method available on the returned component.
                // It lets you get the current state without resetting the mounted instance stack.
                // Don’t use it for anything other than testing.
                /**
             * @param {Object} base: {"target": "_blank", "href": "http://mysite.com/"}
             * @param {Object} bodyAttributes: {"className": "root"}
             * @param {String} defaultTitle: "Default Title"
             * @param {Boolean} defer: true
             * @param {Boolean} encodeSpecialCharacters: true
             * @param {Object} htmlAttributes: {"lang": "en", "amp": undefined}
             * @param {Array} link: [{"rel": "canonical", "href": "http://mysite.com/example"}]
             * @param {Array} meta: [{"name": "description", "content": "Test description"}]
             * @param {Array} noscript: [{"innerHTML": "<img src='http://mysite.com/js/test.js'"}]
             * @param {Function} onChangeClientState: "(newState) => console.log(newState)"
             * @param {Array} script: [{"type": "text/javascript", "src": "http://mysite.com/js/test.js"}]
             * @param {Array} style: [{"type": "text/css", "cssText": "div { display: block; color: blue; }"}]
             * @param {String} title: "Title"
             * @param {Object} titleAttributes: {"itemprop": "name"}
             * @param {String} titleTemplate: "MySite.com - %s"
             */ set: function set$$1(canUseDOM) {
                    Component.canUseDOM = canUseDOM;
                }
            }
        ]);
        return HelmetWrapper;
    }((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Component), _class.propTypes = {
        base: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object,
        bodyAttributes: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object,
        children: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOfType([
            (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).node),
            (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).node
        ]),
        defaultTitle: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
        defer: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
        encodeSpecialCharacters: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
        htmlAttributes: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object,
        link: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object),
        meta: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object),
        noscript: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object),
        onChangeClientState: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
        script: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object),
        style: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object),
        title: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
        titleAttributes: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object,
        titleTemplate: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string
    }, _class.defaultProps = {
        defer: true,
        encodeSpecialCharacters: true
    }, _class.peek = Component.peek, _class.rewind = function() {
        var mappedState = Component.rewind();
        if (!mappedState) // provide fallback if mappedState is undefined
        mappedState = $837d879502e60b4b$var$mapStateOnServer({
            baseTag: [],
            bodyAttributes: {},
            encodeSpecialCharacters: true,
            htmlAttributes: {},
            linkTags: [],
            metaTags: [],
            noscriptTags: [],
            scriptTags: [],
            styleTags: [],
            title: "",
            titleAttributes: {}
        });
        return mappedState;
    }, _temp;
};
var $837d879502e60b4b$var$NullComponent = function NullComponent() {
    return null;
};
var $837d879502e60b4b$var$HelmetSideEffects = (0, (/*@__PURE__*/$parcel$interopDefault($2a96cca22bca25a2$exports)))($837d879502e60b4b$var$reducePropsToState, $837d879502e60b4b$var$handleClientStateChange, $837d879502e60b4b$var$mapStateOnServer)($837d879502e60b4b$var$NullComponent);
var $837d879502e60b4b$export$dcef8f9bb9a41431 = $837d879502e60b4b$var$Helmet($837d879502e60b4b$var$HelmetSideEffects);
$837d879502e60b4b$export$dcef8f9bb9a41431.renderStatic = $837d879502e60b4b$export$dcef8f9bb9a41431.rewind;
var $837d879502e60b4b$export$2e2bcd8739ae039 = $837d879502e60b4b$export$dcef8f9bb9a41431;



var $acw62 = parcelRequire("acw62");

var $45fvw = parcelRequire("45fvw");
var $81292b5b491156fc$exports = {};
"use strict";
Object.defineProperty($81292b5b491156fc$exports, "__esModule", {
    value: true
});
var $21daa036d62cc547$exports = {};
"use strict";
Object.defineProperty($21daa036d62cc547$exports, "__esModule", {
    value: true
});
$21daa036d62cc547$exports.bodyOpenClassName = $21daa036d62cc547$exports.portalClassName = undefined;
var $21daa036d62cc547$var$_extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};
var $21daa036d62cc547$var$_createClass = function() {
    function defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    return function(Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
    };
}();

var $acw62 = parcelRequire("acw62");
var $21daa036d62cc547$var$_react2 = $21daa036d62cc547$var$_interopRequireDefault($acw62);

var $1u0KT = parcelRequire("1u0KT");
var $21daa036d62cc547$var$_reactDom2 = $21daa036d62cc547$var$_interopRequireDefault($1u0KT);

var $c9Z8w = parcelRequire("c9Z8w");
var $21daa036d62cc547$var$_propTypes2 = $21daa036d62cc547$var$_interopRequireDefault($c9Z8w);
var $853c8e196b6200d7$exports = {};
"use strict";
Object.defineProperty($853c8e196b6200d7$exports, "__esModule", {
    value: true
});
var $853c8e196b6200d7$var$_extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};
var $853c8e196b6200d7$var$_typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function(obj) {
    return typeof obj;
} : function(obj) {
    return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
};
var $853c8e196b6200d7$var$_createClass = function() {
    function defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    return function(Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
    };
}();

var $acw62 = parcelRequire("acw62");

var $c9Z8w = parcelRequire("c9Z8w");
var $853c8e196b6200d7$var$_propTypes2 = $853c8e196b6200d7$var$_interopRequireDefault($c9Z8w);
var $4a4c3b2f05aea188$exports = {};
"use strict";
Object.defineProperty($4a4c3b2f05aea188$exports, "__esModule", {
    value: true
});
$4a4c3b2f05aea188$exports.resetState = $4a4c3b2f05aea188$var$resetState;
$4a4c3b2f05aea188$exports.log = $4a4c3b2f05aea188$var$log;
$4a4c3b2f05aea188$exports.handleBlur = $4a4c3b2f05aea188$var$handleBlur;
$4a4c3b2f05aea188$exports.handleFocus = $4a4c3b2f05aea188$var$handleFocus;
$4a4c3b2f05aea188$exports.markForFocusLater = $4a4c3b2f05aea188$var$markForFocusLater;
$4a4c3b2f05aea188$exports.returnFocus = $4a4c3b2f05aea188$var$returnFocus;
$4a4c3b2f05aea188$exports.popWithoutFocus = $4a4c3b2f05aea188$var$popWithoutFocus;
$4a4c3b2f05aea188$exports.setupScopedFocus = $4a4c3b2f05aea188$var$setupScopedFocus;
$4a4c3b2f05aea188$exports.teardownScopedFocus = $4a4c3b2f05aea188$var$teardownScopedFocus;
var $dbb24e2c8fdaedca$exports = {};
"use strict";
Object.defineProperty($dbb24e2c8fdaedca$exports, "__esModule", {
    value: true
});
$dbb24e2c8fdaedca$exports.default = $dbb24e2c8fdaedca$var$findTabbableDescendants;
/*!
 * Adapted from jQuery UI core
 *
 * http://jqueryui.com
 *
 * Copyright 2014 jQuery Foundation and other contributors
 * Released under the MIT license.
 * http://jquery.org/license
 *
 * http://api.jqueryui.com/category/ui-core/
 */ var $dbb24e2c8fdaedca$var$DISPLAY_NONE = "none";
var $dbb24e2c8fdaedca$var$DISPLAY_CONTENTS = "contents";
var $dbb24e2c8fdaedca$var$tabbableNode = /input|select|textarea|button|object|iframe/;
function $dbb24e2c8fdaedca$var$isNotOverflowing(element, style) {
    return style.getPropertyValue("overflow") !== "visible" || // if 'overflow: visible' set, check if there is actually any overflow
    element.scrollWidth <= 0 && element.scrollHeight <= 0;
}
function $dbb24e2c8fdaedca$var$hidesContents(element) {
    var zeroSize = element.offsetWidth <= 0 && element.offsetHeight <= 0;
    // If the node is empty, this is good enough
    if (zeroSize && !element.innerHTML) return true;
    try {
        // Otherwise we need to check some styles
        var style = window.getComputedStyle(element);
        var displayValue = style.getPropertyValue("display");
        return zeroSize ? displayValue !== $dbb24e2c8fdaedca$var$DISPLAY_CONTENTS && $dbb24e2c8fdaedca$var$isNotOverflowing(element, style) : displayValue === $dbb24e2c8fdaedca$var$DISPLAY_NONE;
    } catch (exception) {
        // eslint-disable-next-line no-console
        console.warn("Failed to inspect element style");
        return false;
    }
}
function $dbb24e2c8fdaedca$var$visible(element) {
    var parentElement = element;
    var rootNode = element.getRootNode && element.getRootNode();
    while(parentElement){
        if (parentElement === document.body) break;
        // if we are not hidden yet, skip to checking outside the Web Component
        if (rootNode && parentElement === rootNode) parentElement = rootNode.host.parentNode;
        if ($dbb24e2c8fdaedca$var$hidesContents(parentElement)) return false;
        parentElement = parentElement.parentNode;
    }
    return true;
}
function $dbb24e2c8fdaedca$var$focusable(element, isTabIndexNotNaN) {
    var nodeName = element.nodeName.toLowerCase();
    var res = $dbb24e2c8fdaedca$var$tabbableNode.test(nodeName) && !element.disabled || (nodeName === "a" ? element.href || isTabIndexNotNaN : isTabIndexNotNaN);
    return res && $dbb24e2c8fdaedca$var$visible(element);
}
function $dbb24e2c8fdaedca$var$tabbable(element) {
    var tabIndex = element.getAttribute("tabindex");
    if (tabIndex === null) tabIndex = undefined;
    var isTabIndexNaN = isNaN(tabIndex);
    return (isTabIndexNaN || tabIndex >= 0) && $dbb24e2c8fdaedca$var$focusable(element, !isTabIndexNaN);
}
function $dbb24e2c8fdaedca$var$findTabbableDescendants(element) {
    var descendants = [].slice.call(element.querySelectorAll("*"), 0).reduce(function(finished, el) {
        return finished.concat(!el.shadowRoot ? [
            el
        ] : $dbb24e2c8fdaedca$var$findTabbableDescendants(el.shadowRoot));
    }, []);
    return descendants.filter($dbb24e2c8fdaedca$var$tabbable);
}
$dbb24e2c8fdaedca$exports = $dbb24e2c8fdaedca$exports["default"];


var $4a4c3b2f05aea188$var$_tabbable2 = $4a4c3b2f05aea188$var$_interopRequireDefault($dbb24e2c8fdaedca$exports);
function $4a4c3b2f05aea188$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $4a4c3b2f05aea188$var$focusLaterElements = [];
var $4a4c3b2f05aea188$var$modalElement = null;
var $4a4c3b2f05aea188$var$needToFocus = false;
/* eslint-disable no-console */ /* istanbul ignore next */ function $4a4c3b2f05aea188$var$resetState() {
    $4a4c3b2f05aea188$var$focusLaterElements = [];
}
/* istanbul ignore next */ function $4a4c3b2f05aea188$var$log() {
    console.log("focusManager ----------");
    $4a4c3b2f05aea188$var$focusLaterElements.forEach(function(f) {
        var check = f || {};
        console.log(check.nodeName, check.className, check.id);
    });
    console.log("end focusManager ----------");
}
/* eslint-enable no-console */ function $4a4c3b2f05aea188$var$handleBlur() {
    $4a4c3b2f05aea188$var$needToFocus = true;
}
function $4a4c3b2f05aea188$var$handleFocus() {
    if ($4a4c3b2f05aea188$var$needToFocus) {
        $4a4c3b2f05aea188$var$needToFocus = false;
        if (!$4a4c3b2f05aea188$var$modalElement) return;
        // need to see how jQuery shims document.on('focusin') so we don't need the
        // setTimeout, firefox doesn't support focusin, if it did, we could focus
        // the element outside of a setTimeout. Side-effect of this implementation
        // is that the document.body gets focus, and then we focus our element right
        // after, seems fine.
        setTimeout(function() {
            if ($4a4c3b2f05aea188$var$modalElement.contains(document.activeElement)) return;
            var el = (0, $4a4c3b2f05aea188$var$_tabbable2.default)($4a4c3b2f05aea188$var$modalElement)[0] || $4a4c3b2f05aea188$var$modalElement;
            el.focus();
        }, 0);
    }
}
function $4a4c3b2f05aea188$var$markForFocusLater() {
    $4a4c3b2f05aea188$var$focusLaterElements.push(document.activeElement);
}
/* eslint-disable no-console */ function $4a4c3b2f05aea188$var$returnFocus() {
    var preventScroll = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
    var toFocus = null;
    try {
        if ($4a4c3b2f05aea188$var$focusLaterElements.length !== 0) {
            toFocus = $4a4c3b2f05aea188$var$focusLaterElements.pop();
            toFocus.focus({
                preventScroll: preventScroll
            });
        }
        return;
    } catch (e) {
        console.warn([
            "You tried to return focus to",
            toFocus,
            "but it is not in the DOM anymore"
        ].join(" "));
    }
}
/* eslint-enable no-console */ function $4a4c3b2f05aea188$var$popWithoutFocus() {
    $4a4c3b2f05aea188$var$focusLaterElements.length > 0 && $4a4c3b2f05aea188$var$focusLaterElements.pop();
}
function $4a4c3b2f05aea188$var$setupScopedFocus(element) {
    $4a4c3b2f05aea188$var$modalElement = element;
    if (window.addEventListener) {
        window.addEventListener("blur", $4a4c3b2f05aea188$var$handleBlur, false);
        document.addEventListener("focus", $4a4c3b2f05aea188$var$handleFocus, true);
    } else {
        window.attachEvent("onBlur", $4a4c3b2f05aea188$var$handleBlur);
        document.attachEvent("onFocus", $4a4c3b2f05aea188$var$handleFocus);
    }
}
function $4a4c3b2f05aea188$var$teardownScopedFocus() {
    $4a4c3b2f05aea188$var$modalElement = null;
    if (window.addEventListener) {
        window.removeEventListener("blur", $4a4c3b2f05aea188$var$handleBlur);
        document.removeEventListener("focus", $4a4c3b2f05aea188$var$handleFocus);
    } else {
        window.detachEvent("onBlur", $4a4c3b2f05aea188$var$handleBlur);
        document.detachEvent("onFocus", $4a4c3b2f05aea188$var$handleFocus);
    }
}


var $853c8e196b6200d7$var$focusManager = $853c8e196b6200d7$var$_interopRequireWildcard($4a4c3b2f05aea188$exports);
var $8ab6c60fe3353573$exports = {};
"use strict";
Object.defineProperty($8ab6c60fe3353573$exports, "__esModule", {
    value: true
});
$8ab6c60fe3353573$exports.default = $8ab6c60fe3353573$var$scopeTab;

var $8ab6c60fe3353573$var$_tabbable2 = $8ab6c60fe3353573$var$_interopRequireDefault($dbb24e2c8fdaedca$exports);
function $8ab6c60fe3353573$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $8ab6c60fe3353573$var$getActiveElement() {
    var el = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : document;
    return el.activeElement.shadowRoot ? $8ab6c60fe3353573$var$getActiveElement(el.activeElement.shadowRoot) : el.activeElement;
}
function $8ab6c60fe3353573$var$scopeTab(node, event) {
    var tabbable = (0, $8ab6c60fe3353573$var$_tabbable2.default)(node);
    if (!tabbable.length) {
        // Do nothing, since there are no elements that can receive focus.
        event.preventDefault();
        return;
    }
    var target = void 0;
    var shiftKey = event.shiftKey;
    var head = tabbable[0];
    var tail = tabbable[tabbable.length - 1];
    var activeElement = $8ab6c60fe3353573$var$getActiveElement();
    // proceed with default browser behavior on tab.
    // Focus on last element on shift + tab.
    if (node === activeElement) {
        if (!shiftKey) return;
        target = tail;
    }
    if (tail === activeElement && !shiftKey) target = head;
    if (head === activeElement && shiftKey) target = tail;
    if (target) {
        event.preventDefault();
        target.focus();
        return;
    }
    // Safari radio issue.
    //
    // Safari does not move the focus to the radio button,
    // so we need to force it to really walk through all elements.
    //
    // This is very error prone, since we are trying to guess
    // if it is a safari browser from the first occurence between
    // chrome or safari.
    //
    // The chrome user agent contains the first ocurrence
    // as the 'chrome/version' and later the 'safari/version'.
    var checkSafari = /(\bChrome\b|\bSafari\b)\//.exec(navigator.userAgent);
    var isSafariDesktop = checkSafari != null && checkSafari[1] != "Chrome" && /\biPod\b|\biPad\b/g.exec(navigator.userAgent) == null;
    // If we are not in safari desktop, let the browser control
    // the focus
    if (!isSafariDesktop) return;
    var x = tabbable.indexOf(activeElement);
    if (x > -1) x += shiftKey ? -1 : 1;
    target = tabbable[x];
    // If the tabbable element does not exist,
    // focus head/tail based on shiftKey
    if (typeof target === "undefined") {
        event.preventDefault();
        target = shiftKey ? tail : head;
        target.focus();
        return;
    }
    event.preventDefault();
    target.focus();
}
$8ab6c60fe3353573$exports = $8ab6c60fe3353573$exports["default"];


var $853c8e196b6200d7$var$_scopeTab2 = $853c8e196b6200d7$var$_interopRequireDefault($8ab6c60fe3353573$exports);
var $c3139925b7b56b46$exports = {};
"use strict";
Object.defineProperty($c3139925b7b56b46$exports, "__esModule", {
    value: true
});
$c3139925b7b56b46$exports.resetState = $c3139925b7b56b46$var$resetState;
$c3139925b7b56b46$exports.log = $c3139925b7b56b46$var$log;
$c3139925b7b56b46$exports.assertNodeList = $c3139925b7b56b46$var$assertNodeList;
$c3139925b7b56b46$exports.setElement = $c3139925b7b56b46$var$setElement;
$c3139925b7b56b46$exports.validateElement = $c3139925b7b56b46$var$validateElement;
$c3139925b7b56b46$exports.hide = $c3139925b7b56b46$var$hide;
$c3139925b7b56b46$exports.show = $c3139925b7b56b46$var$show;
$c3139925b7b56b46$exports.documentNotReadyOrSSRTesting = $c3139925b7b56b46$var$documentNotReadyOrSSRTesting;
var $ebfc6adce9fdacf8$exports = {};
/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ "use strict";
/**
 * Similar to invariant but only logs a warning if the condition is not met.
 * This can be used to log issues in development environments in critical
 * paths. Removing the logging code for production environments will keep the
 * same logic and follow the same code paths.
 */ var $ebfc6adce9fdacf8$var$__DEV__ = true;
var $ebfc6adce9fdacf8$var$warning = function() {};
if ($ebfc6adce9fdacf8$var$__DEV__) {
    var $ebfc6adce9fdacf8$var$printWarning = function printWarning(format, args) {
        var len = arguments.length;
        args = new Array(len > 1 ? len - 1 : 0);
        for(var key = 1; key < len; key++)args[key - 1] = arguments[key];
        var argIndex = 0;
        var message = "Warning: " + format.replace(/%s/g, function() {
            return args[argIndex++];
        });
        if (typeof console !== "undefined") console.error(message);
        try {
            // --- Welcome to debugging React ---
            // This error was thrown as a convenience so that you can use this stack
            // to find the callsite that caused this warning to fire.
            throw new Error(message);
        } catch (x) {}
    };
    $ebfc6adce9fdacf8$var$warning = function(condition, format, args) {
        var len = arguments.length;
        args = new Array(len > 2 ? len - 2 : 0);
        for(var key = 2; key < len; key++)args[key - 2] = arguments[key];
        if (format === undefined) throw new Error("`warning(condition, format, ...args)` requires a warning message argument");
        if (!condition) $ebfc6adce9fdacf8$var$printWarning.apply(null, [
            format
        ].concat(args));
    };
}
$ebfc6adce9fdacf8$exports = $ebfc6adce9fdacf8$var$warning;


var $c3139925b7b56b46$var$_warning2 = $c3139925b7b56b46$var$_interopRequireDefault($ebfc6adce9fdacf8$exports);
var $c2956c5113267bbb$exports = {};
"use strict";
Object.defineProperty($c2956c5113267bbb$exports, "__esModule", {
    value: true
});
$c2956c5113267bbb$exports.canUseDOM = $c2956c5113267bbb$exports.SafeNodeList = $c2956c5113267bbb$exports.SafeHTMLCollection = undefined;
var $9b1af1a6f2632174$exports = {};
/*!
  Copyright (c) 2015 Jed Watson.
  Based on code that is Copyright 2013-2015, Facebook, Inc.
  All rights reserved.
*/ /* global define */ (function() {
    "use strict";
    var canUseDOM = !!(typeof window !== "undefined" && window.document && window.document.createElement);
    var ExecutionEnvironment = {
        canUseDOM: canUseDOM,
        canUseWorkers: typeof Worker !== "undefined",
        canUseEventListeners: canUseDOM && !!(window.addEventListener || window.attachEvent),
        canUseViewport: canUseDOM && !!window.screen
    };
    if (typeof define === "function" && typeof define.amd === "object" && define.amd) define(function() {
        return ExecutionEnvironment;
    });
    else if (0, $9b1af1a6f2632174$exports) $9b1af1a6f2632174$exports = ExecutionEnvironment;
    else window.ExecutionEnvironment = ExecutionEnvironment;
})();


var $c2956c5113267bbb$var$_exenv2 = $c2956c5113267bbb$var$_interopRequireDefault($9b1af1a6f2632174$exports);
function $c2956c5113267bbb$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $c2956c5113267bbb$var$EE = $c2956c5113267bbb$var$_exenv2.default;
var $c2956c5113267bbb$var$SafeHTMLElement = $c2956c5113267bbb$var$EE.canUseDOM ? window.HTMLElement : {};
var $c2956c5113267bbb$var$SafeHTMLCollection = $c2956c5113267bbb$exports.SafeHTMLCollection = $c2956c5113267bbb$var$EE.canUseDOM ? window.HTMLCollection : {};
var $c2956c5113267bbb$var$SafeNodeList = $c2956c5113267bbb$exports.SafeNodeList = $c2956c5113267bbb$var$EE.canUseDOM ? window.NodeList : {};
var $c2956c5113267bbb$var$canUseDOM = $c2956c5113267bbb$exports.canUseDOM = $c2956c5113267bbb$var$EE.canUseDOM;
$c2956c5113267bbb$exports.default = $c2956c5113267bbb$var$SafeHTMLElement;


function $c3139925b7b56b46$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $c3139925b7b56b46$var$globalElement = null;
/* eslint-disable no-console */ /* istanbul ignore next */ function $c3139925b7b56b46$var$resetState() {
    if ($c3139925b7b56b46$var$globalElement) {
        if ($c3139925b7b56b46$var$globalElement.removeAttribute) $c3139925b7b56b46$var$globalElement.removeAttribute("aria-hidden");
        else if ($c3139925b7b56b46$var$globalElement.length != null) $c3139925b7b56b46$var$globalElement.forEach(function(element) {
            return element.removeAttribute("aria-hidden");
        });
        else document.querySelectorAll($c3139925b7b56b46$var$globalElement).forEach(function(element) {
            return element.removeAttribute("aria-hidden");
        });
    }
    $c3139925b7b56b46$var$globalElement = null;
}
/* istanbul ignore next */ function $c3139925b7b56b46$var$log() {
    var check = $c3139925b7b56b46$var$globalElement || {};
    console.log("ariaAppHider ----------");
    console.log(check.nodeName, check.className, check.id);
    console.log("end ariaAppHider ----------");
}
/* eslint-enable no-console */ function $c3139925b7b56b46$var$assertNodeList(nodeList, selector) {
    if (!nodeList || !nodeList.length) throw new Error("react-modal: No elements were found for selector " + selector + ".");
}
function $c3139925b7b56b46$var$setElement(element) {
    var useElement = element;
    if (typeof useElement === "string" && $c2956c5113267bbb$exports.canUseDOM) {
        var el = document.querySelectorAll(useElement);
        $c3139925b7b56b46$var$assertNodeList(el, useElement);
        useElement = el;
    }
    $c3139925b7b56b46$var$globalElement = useElement || $c3139925b7b56b46$var$globalElement;
    return $c3139925b7b56b46$var$globalElement;
}
function $c3139925b7b56b46$var$validateElement(appElement) {
    var el = appElement || $c3139925b7b56b46$var$globalElement;
    if (el) return Array.isArray(el) || el instanceof HTMLCollection || el instanceof NodeList ? el : [
        el
    ];
    else {
        (0, $c3139925b7b56b46$var$_warning2.default)(false, [
            "react-modal: App element is not defined.",
            "Please use `Modal.setAppElement(el)` or set `appElement={el}`.",
            "This is needed so screen readers don't see main content",
            "when modal is opened. It is not recommended, but you can opt-out",
            "by setting `ariaHideApp={false}`."
        ].join(" "));
        return [];
    }
}
function $c3139925b7b56b46$var$hide(appElement) {
    var _iteratorNormalCompletion = true;
    var _didIteratorError = false;
    var _iteratorError = undefined;
    try {
        for(var _iterator = $c3139925b7b56b46$var$validateElement(appElement)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var el = _step.value;
            el.setAttribute("aria-hidden", "true");
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return) _iterator.return();
        } finally{
            if (_didIteratorError) throw _iteratorError;
        }
    }
}
function $c3139925b7b56b46$var$show(appElement) {
    var _iteratorNormalCompletion2 = true;
    var _didIteratorError2 = false;
    var _iteratorError2 = undefined;
    try {
        for(var _iterator2 = $c3139925b7b56b46$var$validateElement(appElement)[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true){
            var el = _step2.value;
            el.removeAttribute("aria-hidden");
        }
    } catch (err) {
        _didIteratorError2 = true;
        _iteratorError2 = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion2 && _iterator2.return) _iterator2.return();
        } finally{
            if (_didIteratorError2) throw _iteratorError2;
        }
    }
}
function $c3139925b7b56b46$var$documentNotReadyOrSSRTesting() {
    $c3139925b7b56b46$var$globalElement = null;
}


var $853c8e196b6200d7$var$ariaAppHider = $853c8e196b6200d7$var$_interopRequireWildcard($c3139925b7b56b46$exports);
var $f45bbb0d96c30d54$exports = {};
"use strict";
Object.defineProperty($f45bbb0d96c30d54$exports, "__esModule", {
    value: true
});
$f45bbb0d96c30d54$exports.resetState = $f45bbb0d96c30d54$var$resetState;
$f45bbb0d96c30d54$exports.log = $f45bbb0d96c30d54$var$log;
var $f45bbb0d96c30d54$var$htmlClassList = {};
var $f45bbb0d96c30d54$var$docBodyClassList = {};
/* eslint-disable no-console */ /* istanbul ignore next */ function $f45bbb0d96c30d54$var$removeClass(at, cls) {
    at.classList.remove(cls);
}
/* istanbul ignore next */ function $f45bbb0d96c30d54$var$resetState() {
    var htmlElement = document.getElementsByTagName("html")[0];
    for(var cls in $f45bbb0d96c30d54$var$htmlClassList)$f45bbb0d96c30d54$var$removeClass(htmlElement, $f45bbb0d96c30d54$var$htmlClassList[cls]);
    var body = document.body;
    for(var _cls in $f45bbb0d96c30d54$var$docBodyClassList)$f45bbb0d96c30d54$var$removeClass(body, $f45bbb0d96c30d54$var$docBodyClassList[_cls]);
    $f45bbb0d96c30d54$var$htmlClassList = {};
    $f45bbb0d96c30d54$var$docBodyClassList = {};
}
/* istanbul ignore next */ function $f45bbb0d96c30d54$var$log() {
    var classes = document.getElementsByTagName("html")[0].className;
    var buffer = "Show tracked classes:\n\n";
    buffer += "<html /> (" + classes + "):\n  ";
    for(var x in $f45bbb0d96c30d54$var$htmlClassList)buffer += "  " + x + " " + $f45bbb0d96c30d54$var$htmlClassList[x] + "\n  ";
    classes = document.body.className;
    buffer += "\n\ndoc.body (" + classes + "):\n  ";
    for(var _x in $f45bbb0d96c30d54$var$docBodyClassList)buffer += "  " + _x + " " + $f45bbb0d96c30d54$var$docBodyClassList[_x] + "\n  ";
    buffer += "\n";
    console.log(buffer);
}
/* eslint-enable no-console */ /**
 * Track the number of reference of a class.
 * @param {object} poll The poll to receive the reference.
 * @param {string} className The class name.
 * @return {string}
 */ var $f45bbb0d96c30d54$var$incrementReference = function incrementReference(poll, className) {
    if (!poll[className]) poll[className] = 0;
    poll[className] += 1;
    return className;
};
/**
 * Drop the reference of a class.
 * @param {object} poll The poll to receive the reference.
 * @param {string} className The class name.
 * @return {string}
 */ var $f45bbb0d96c30d54$var$decrementReference = function decrementReference(poll, className) {
    if (poll[className]) poll[className] -= 1;
    return className;
};
/**
 * Track a class and add to the given class list.
 * @param {Object} classListRef A class list of an element.
 * @param {Object} poll         The poll to be used.
 * @param {Array}  classes      The list of classes to be tracked.
 */ var $f45bbb0d96c30d54$var$trackClass = function trackClass(classListRef, poll, classes) {
    classes.forEach(function(className) {
        $f45bbb0d96c30d54$var$incrementReference(poll, className);
        classListRef.add(className);
    });
};
/**
 * Untrack a class and remove from the given class list if the reference
 * reaches 0.
 * @param {Object} classListRef A class list of an element.
 * @param {Object} poll         The poll to be used.
 * @param {Array}  classes      The list of classes to be untracked.
 */ var $f45bbb0d96c30d54$var$untrackClass = function untrackClass(classListRef, poll, classes) {
    classes.forEach(function(className) {
        $f45bbb0d96c30d54$var$decrementReference(poll, className);
        poll[className] === 0 && classListRef.remove(className);
    });
};
/**
 * Public inferface to add classes to the document.body.
 * @param {string} bodyClass The class string to be added.
 *                           It may contain more then one class
 *                           with ' ' as separator.
 */ var $f45bbb0d96c30d54$var$add = $f45bbb0d96c30d54$exports.add = function add(element, classString) {
    return $f45bbb0d96c30d54$var$trackClass(element.classList, element.nodeName.toLowerCase() == "html" ? $f45bbb0d96c30d54$var$htmlClassList : $f45bbb0d96c30d54$var$docBodyClassList, classString.split(" "));
};
/**
 * Public inferface to remove classes from the document.body.
 * @param {string} bodyClass The class string to be added.
 *                           It may contain more then one class
 *                           with ' ' as separator.
 */ var $f45bbb0d96c30d54$var$remove = $f45bbb0d96c30d54$exports.remove = function remove(element, classString) {
    return $f45bbb0d96c30d54$var$untrackClass(element.classList, element.nodeName.toLowerCase() == "html" ? $f45bbb0d96c30d54$var$htmlClassList : $f45bbb0d96c30d54$var$docBodyClassList, classString.split(" "));
};


var $853c8e196b6200d7$var$classList = $853c8e196b6200d7$var$_interopRequireWildcard($f45bbb0d96c30d54$exports);

var $853c8e196b6200d7$var$_safeHTMLElement2 = $853c8e196b6200d7$var$_interopRequireDefault($c2956c5113267bbb$exports);
var $eb505cd0fca5b004$exports = {};
"use strict";
Object.defineProperty($eb505cd0fca5b004$exports, "__esModule", {
    value: true
});
$eb505cd0fca5b004$exports.log = $eb505cd0fca5b004$var$log;
$eb505cd0fca5b004$exports.resetState = $eb505cd0fca5b004$var$resetState;
function $eb505cd0fca5b004$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
// Tracks portals that are open and emits events to subscribers
var $eb505cd0fca5b004$var$PortalOpenInstances = function PortalOpenInstances() {
    var _this = this;
    $eb505cd0fca5b004$var$_classCallCheck(this, PortalOpenInstances);
    this.register = function(openInstance) {
        if (_this.openInstances.indexOf(openInstance) !== -1) {
            // eslint-disable-next-line no-console
            console.warn("React-Modal: Cannot register modal instance that's already open");
            return;
        }
        _this.openInstances.push(openInstance);
        _this.emit("register");
    };
    this.deregister = function(openInstance) {
        var index = _this.openInstances.indexOf(openInstance);
        if (index === -1) {
            // eslint-disable-next-line no-console
            console.warn("React-Modal: Unable to deregister " + openInstance + " as " + "it was never registered");
            return;
        }
        _this.openInstances.splice(index, 1);
        _this.emit("deregister");
    };
    this.subscribe = function(callback) {
        _this.subscribers.push(callback);
    };
    this.emit = function(eventType) {
        _this.subscribers.forEach(function(subscriber) {
            return subscriber(eventType, // shallow copy to avoid accidental mutation
            _this.openInstances.slice());
        });
    };
    this.openInstances = [];
    this.subscribers = [];
};
var $eb505cd0fca5b004$var$portalOpenInstances = new $eb505cd0fca5b004$var$PortalOpenInstances();
/* eslint-disable no-console */ /* istanbul ignore next */ function $eb505cd0fca5b004$var$log() {
    console.log("portalOpenInstances ----------");
    console.log($eb505cd0fca5b004$var$portalOpenInstances.openInstances.length);
    $eb505cd0fca5b004$var$portalOpenInstances.openInstances.forEach(function(p) {
        return console.log(p);
    });
    console.log("end portalOpenInstances ----------");
}
/* istanbul ignore next */ function $eb505cd0fca5b004$var$resetState() {
    $eb505cd0fca5b004$var$portalOpenInstances = new $eb505cd0fca5b004$var$PortalOpenInstances();
}
/* eslint-enable no-console */ $eb505cd0fca5b004$exports.default = $eb505cd0fca5b004$var$portalOpenInstances;


var $853c8e196b6200d7$var$_portalOpenInstances2 = $853c8e196b6200d7$var$_interopRequireDefault($eb505cd0fca5b004$exports);
var $b2f35082d0ec1256$exports = {};
"use strict";
Object.defineProperty($b2f35082d0ec1256$exports, "__esModule", {
    value: true
});
$b2f35082d0ec1256$exports.resetState = $b2f35082d0ec1256$var$resetState;
$b2f35082d0ec1256$exports.log = $b2f35082d0ec1256$var$log;

var $b2f35082d0ec1256$var$_portalOpenInstances2 = $b2f35082d0ec1256$var$_interopRequireDefault($eb505cd0fca5b004$exports);
function $b2f35082d0ec1256$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
// Body focus trap see Issue #742
var $b2f35082d0ec1256$var$before = void 0, $b2f35082d0ec1256$var$after = void 0, $b2f35082d0ec1256$var$instances = [];
/* eslint-disable no-console */ /* istanbul ignore next */ function $b2f35082d0ec1256$var$resetState() {
    var _arr = [
        $b2f35082d0ec1256$var$before,
        $b2f35082d0ec1256$var$after
    ];
    for(var _i = 0; _i < _arr.length; _i++){
        var item = _arr[_i];
        if (!item) continue;
        item.parentNode && item.parentNode.removeChild(item);
    }
    $b2f35082d0ec1256$var$before = $b2f35082d0ec1256$var$after = null;
    $b2f35082d0ec1256$var$instances = [];
}
/* istanbul ignore next */ function $b2f35082d0ec1256$var$log() {
    console.log("bodyTrap ----------");
    console.log($b2f35082d0ec1256$var$instances.length);
    var _arr2 = [
        $b2f35082d0ec1256$var$before,
        $b2f35082d0ec1256$var$after
    ];
    for(var _i2 = 0; _i2 < _arr2.length; _i2++){
        var item = _arr2[_i2];
        var check = item || {};
        console.log(check.nodeName, check.className, check.id);
    }
    console.log("edn bodyTrap ----------");
}
/* eslint-enable no-console */ function $b2f35082d0ec1256$var$focusContent() {
    if ($b2f35082d0ec1256$var$instances.length === 0) {
        // eslint-disable-next-line no-console
        console.warn("React-Modal: Open instances > 0 expected");
        return;
    }
    $b2f35082d0ec1256$var$instances[$b2f35082d0ec1256$var$instances.length - 1].focusContent();
}
function $b2f35082d0ec1256$var$bodyTrap(eventType, openInstances) {
    if (!$b2f35082d0ec1256$var$before && !$b2f35082d0ec1256$var$after) {
        $b2f35082d0ec1256$var$before = document.createElement("div");
        $b2f35082d0ec1256$var$before.setAttribute("data-react-modal-body-trap", "");
        $b2f35082d0ec1256$var$before.style.position = "absolute";
        $b2f35082d0ec1256$var$before.style.opacity = "0";
        $b2f35082d0ec1256$var$before.setAttribute("tabindex", "0");
        $b2f35082d0ec1256$var$before.addEventListener("focus", $b2f35082d0ec1256$var$focusContent);
        $b2f35082d0ec1256$var$after = $b2f35082d0ec1256$var$before.cloneNode();
        $b2f35082d0ec1256$var$after.addEventListener("focus", $b2f35082d0ec1256$var$focusContent);
    }
    $b2f35082d0ec1256$var$instances = openInstances;
    if ($b2f35082d0ec1256$var$instances.length > 0) {
        // Add focus trap
        if (document.body.firstChild !== $b2f35082d0ec1256$var$before) document.body.insertBefore($b2f35082d0ec1256$var$before, document.body.firstChild);
        if (document.body.lastChild !== $b2f35082d0ec1256$var$after) document.body.appendChild($b2f35082d0ec1256$var$after);
    } else {
        // Remove focus trap
        if ($b2f35082d0ec1256$var$before.parentElement) $b2f35082d0ec1256$var$before.parentElement.removeChild($b2f35082d0ec1256$var$before);
        if ($b2f35082d0ec1256$var$after.parentElement) $b2f35082d0ec1256$var$after.parentElement.removeChild($b2f35082d0ec1256$var$after);
    }
}
$b2f35082d0ec1256$var$_portalOpenInstances2.default.subscribe($b2f35082d0ec1256$var$bodyTrap);


function $853c8e196b6200d7$var$_interopRequireWildcard(obj) {
    if (obj && obj.__esModule) return obj;
    else {
        var newObj = {};
        if (obj != null) {
            for(var key in obj)if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
        }
        newObj.default = obj;
        return newObj;
    }
}
function $853c8e196b6200d7$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $853c8e196b6200d7$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $853c8e196b6200d7$var$_possibleConstructorReturn(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function $853c8e196b6200d7$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
// so that our CSS is statically analyzable
var $853c8e196b6200d7$var$CLASS_NAMES = {
    overlay: "ReactModal__Overlay",
    content: "ReactModal__Content"
};
/**
 * We need to support the deprecated `KeyboardEvent.keyCode` in addition to
 * `KeyboardEvent.code` for apps that still support IE11. Can be removed when
 * `react-modal` only supports React >18 (which dropped IE support).
 */ var $853c8e196b6200d7$var$isTabKey = function isTabKey(event) {
    return event.code === "Tab" || event.keyCode === 9;
};
var $853c8e196b6200d7$var$isEscKey = function isEscKey(event) {
    return event.code === "Escape" || event.keyCode === 27;
};
var $853c8e196b6200d7$var$ariaHiddenInstances = 0;
var $853c8e196b6200d7$var$ModalPortal = function(_Component) {
    $853c8e196b6200d7$var$_inherits(ModalPortal, _Component);
    function ModalPortal(props) {
        $853c8e196b6200d7$var$_classCallCheck(this, ModalPortal);
        var _this = $853c8e196b6200d7$var$_possibleConstructorReturn(this, (ModalPortal.__proto__ || Object.getPrototypeOf(ModalPortal)).call(this, props));
        _this.setOverlayRef = function(overlay) {
            _this.overlay = overlay;
            _this.props.overlayRef && _this.props.overlayRef(overlay);
        };
        _this.setContentRef = function(content) {
            _this.content = content;
            _this.props.contentRef && _this.props.contentRef(content);
        };
        _this.afterClose = function() {
            var _this$props = _this.props, appElement = _this$props.appElement, ariaHideApp = _this$props.ariaHideApp, htmlOpenClassName = _this$props.htmlOpenClassName, bodyOpenClassName = _this$props.bodyOpenClassName, parentSelector = _this$props.parentSelector;
            var parentDocument = parentSelector && parentSelector().ownerDocument || document;
            // Remove classes.
            bodyOpenClassName && $853c8e196b6200d7$var$classList.remove(parentDocument.body, bodyOpenClassName);
            htmlOpenClassName && $853c8e196b6200d7$var$classList.remove(parentDocument.getElementsByTagName("html")[0], htmlOpenClassName);
            // Reset aria-hidden attribute if all modals have been removed
            if (ariaHideApp && $853c8e196b6200d7$var$ariaHiddenInstances > 0) {
                $853c8e196b6200d7$var$ariaHiddenInstances -= 1;
                if ($853c8e196b6200d7$var$ariaHiddenInstances === 0) $853c8e196b6200d7$var$ariaAppHider.show(appElement);
            }
            if (_this.props.shouldFocusAfterRender) {
                if (_this.props.shouldReturnFocusAfterClose) {
                    $853c8e196b6200d7$var$focusManager.returnFocus(_this.props.preventScroll);
                    $853c8e196b6200d7$var$focusManager.teardownScopedFocus();
                } else $853c8e196b6200d7$var$focusManager.popWithoutFocus();
            }
            if (_this.props.onAfterClose) _this.props.onAfterClose();
            $853c8e196b6200d7$var$_portalOpenInstances2.default.deregister(_this);
        };
        _this.open = function() {
            _this.beforeOpen();
            if (_this.state.afterOpen && _this.state.beforeClose) {
                clearTimeout(_this.closeTimer);
                _this.setState({
                    beforeClose: false
                });
            } else {
                if (_this.props.shouldFocusAfterRender) {
                    $853c8e196b6200d7$var$focusManager.setupScopedFocus(_this.node);
                    $853c8e196b6200d7$var$focusManager.markForFocusLater();
                }
                _this.setState({
                    isOpen: true
                }, function() {
                    _this.openAnimationFrame = requestAnimationFrame(function() {
                        _this.setState({
                            afterOpen: true
                        });
                        if (_this.props.isOpen && _this.props.onAfterOpen) _this.props.onAfterOpen({
                            overlayEl: _this.overlay,
                            contentEl: _this.content
                        });
                    });
                });
            }
        };
        _this.close = function() {
            if (_this.props.closeTimeoutMS > 0) _this.closeWithTimeout();
            else _this.closeWithoutTimeout();
        };
        _this.focusContent = function() {
            return _this.content && !_this.contentHasFocus() && _this.content.focus({
                preventScroll: true
            });
        };
        _this.closeWithTimeout = function() {
            var closesAt = Date.now() + _this.props.closeTimeoutMS;
            _this.setState({
                beforeClose: true,
                closesAt: closesAt
            }, function() {
                _this.closeTimer = setTimeout(_this.closeWithoutTimeout, _this.state.closesAt - Date.now());
            });
        };
        _this.closeWithoutTimeout = function() {
            _this.setState({
                beforeClose: false,
                isOpen: false,
                afterOpen: false,
                closesAt: null
            }, _this.afterClose);
        };
        _this.handleKeyDown = function(event) {
            if ($853c8e196b6200d7$var$isTabKey(event)) (0, $853c8e196b6200d7$var$_scopeTab2.default)(_this.content, event);
            if (_this.props.shouldCloseOnEsc && $853c8e196b6200d7$var$isEscKey(event)) {
                event.stopPropagation();
                _this.requestClose(event);
            }
        };
        _this.handleOverlayOnClick = function(event) {
            if (_this.shouldClose === null) _this.shouldClose = true;
            if (_this.shouldClose && _this.props.shouldCloseOnOverlayClick) {
                if (_this.ownerHandlesClose()) _this.requestClose(event);
                else _this.focusContent();
            }
            _this.shouldClose = null;
        };
        _this.handleContentOnMouseUp = function() {
            _this.shouldClose = false;
        };
        _this.handleOverlayOnMouseDown = function(event) {
            if (!_this.props.shouldCloseOnOverlayClick && event.target == _this.overlay) event.preventDefault();
        };
        _this.handleContentOnClick = function() {
            _this.shouldClose = false;
        };
        _this.handleContentOnMouseDown = function() {
            _this.shouldClose = false;
        };
        _this.requestClose = function(event) {
            return _this.ownerHandlesClose() && _this.props.onRequestClose(event);
        };
        _this.ownerHandlesClose = function() {
            return _this.props.onRequestClose;
        };
        _this.shouldBeClosed = function() {
            return !_this.state.isOpen && !_this.state.beforeClose;
        };
        _this.contentHasFocus = function() {
            return document.activeElement === _this.content || _this.content.contains(document.activeElement);
        };
        _this.buildClassName = function(which, additional) {
            var classNames = (typeof additional === "undefined" ? "undefined" : $853c8e196b6200d7$var$_typeof(additional)) === "object" ? additional : {
                base: $853c8e196b6200d7$var$CLASS_NAMES[which],
                afterOpen: $853c8e196b6200d7$var$CLASS_NAMES[which] + "--after-open",
                beforeClose: $853c8e196b6200d7$var$CLASS_NAMES[which] + "--before-close"
            };
            var className = classNames.base;
            if (_this.state.afterOpen) className = className + " " + classNames.afterOpen;
            if (_this.state.beforeClose) className = className + " " + classNames.beforeClose;
            return typeof additional === "string" && additional ? className + " " + additional : className;
        };
        _this.attributesFromObject = function(prefix, items) {
            return Object.keys(items).reduce(function(acc, name) {
                acc[prefix + "-" + name] = items[name];
                return acc;
            }, {});
        };
        _this.state = {
            afterOpen: false,
            beforeClose: false
        };
        _this.shouldClose = null;
        _this.moveFromContentToOverlay = null;
        return _this;
    }
    $853c8e196b6200d7$var$_createClass(ModalPortal, [
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                if (this.props.isOpen) this.open();
            }
        },
        {
            key: "componentDidUpdate",
            value: function componentDidUpdate(prevProps, prevState) {
                if (prevProps.bodyOpenClassName !== this.props.bodyOpenClassName) // eslint-disable-next-line no-console
                console.warn('React-Modal: "bodyOpenClassName" prop has been modified. This may cause unexpected behavior when multiple modals are open.');
                if (prevProps.htmlOpenClassName !== this.props.htmlOpenClassName) // eslint-disable-next-line no-console
                console.warn('React-Modal: "htmlOpenClassName" prop has been modified. This may cause unexpected behavior when multiple modals are open.');
                if (this.props.isOpen && !prevProps.isOpen) this.open();
                else if (!this.props.isOpen && prevProps.isOpen) this.close();
                // Focus only needs to be set once when the modal is being opened
                if (this.props.shouldFocusAfterRender && this.state.isOpen && !prevState.isOpen) this.focusContent();
            }
        },
        {
            key: "componentWillUnmount",
            value: function componentWillUnmount() {
                if (this.state.isOpen) this.afterClose();
                clearTimeout(this.closeTimer);
                cancelAnimationFrame(this.openAnimationFrame);
            }
        },
        {
            key: "beforeOpen",
            value: function beforeOpen() {
                var _props = this.props, appElement = _props.appElement, ariaHideApp = _props.ariaHideApp, htmlOpenClassName = _props.htmlOpenClassName, bodyOpenClassName = _props.bodyOpenClassName, parentSelector = _props.parentSelector;
                var parentDocument = parentSelector && parentSelector().ownerDocument || document;
                // Add classes.
                bodyOpenClassName && $853c8e196b6200d7$var$classList.add(parentDocument.body, bodyOpenClassName);
                htmlOpenClassName && $853c8e196b6200d7$var$classList.add(parentDocument.getElementsByTagName("html")[0], htmlOpenClassName);
                if (ariaHideApp) {
                    $853c8e196b6200d7$var$ariaHiddenInstances += 1;
                    $853c8e196b6200d7$var$ariaAppHider.hide(appElement);
                }
                $853c8e196b6200d7$var$_portalOpenInstances2.default.register(this);
            }
        },
        {
            key: "render",
            value: function render() {
                var _props2 = this.props, id = _props2.id, className = _props2.className, overlayClassName = _props2.overlayClassName, defaultStyles = _props2.defaultStyles, children = _props2.children;
                var contentStyles = className ? {} : defaultStyles.content;
                var overlayStyles = overlayClassName ? {} : defaultStyles.overlay;
                if (this.shouldBeClosed()) return null;
                var overlayProps = {
                    ref: this.setOverlayRef,
                    className: this.buildClassName("overlay", overlayClassName),
                    style: $853c8e196b6200d7$var$_extends({}, overlayStyles, this.props.style.overlay),
                    onClick: this.handleOverlayOnClick,
                    onMouseDown: this.handleOverlayOnMouseDown
                };
                var contentProps = $853c8e196b6200d7$var$_extends({
                    id: id,
                    ref: this.setContentRef,
                    style: $853c8e196b6200d7$var$_extends({}, contentStyles, this.props.style.content),
                    className: this.buildClassName("content", className),
                    tabIndex: "-1",
                    onKeyDown: this.handleKeyDown,
                    onMouseDown: this.handleContentOnMouseDown,
                    onMouseUp: this.handleContentOnMouseUp,
                    onClick: this.handleContentOnClick,
                    role: this.props.role,
                    "aria-label": this.props.contentLabel
                }, this.attributesFromObject("aria", $853c8e196b6200d7$var$_extends({
                    modal: true
                }, this.props.aria)), this.attributesFromObject("data", this.props.data || {}), {
                    "data-testid": this.props.testId
                });
                var contentElement = this.props.contentElement(contentProps, children);
                return this.props.overlayElement(overlayProps, contentElement);
            }
        }
    ]);
    return ModalPortal;
}($acw62.Component);
$853c8e196b6200d7$var$ModalPortal.defaultProps = {
    style: {
        overlay: {},
        content: {}
    },
    defaultStyles: {}
};
$853c8e196b6200d7$var$ModalPortal.propTypes = {
    isOpen: $853c8e196b6200d7$var$_propTypes2.default.bool.isRequired,
    defaultStyles: $853c8e196b6200d7$var$_propTypes2.default.shape({
        content: $853c8e196b6200d7$var$_propTypes2.default.object,
        overlay: $853c8e196b6200d7$var$_propTypes2.default.object
    }),
    style: $853c8e196b6200d7$var$_propTypes2.default.shape({
        content: $853c8e196b6200d7$var$_propTypes2.default.object,
        overlay: $853c8e196b6200d7$var$_propTypes2.default.object
    }),
    className: $853c8e196b6200d7$var$_propTypes2.default.oneOfType([
        $853c8e196b6200d7$var$_propTypes2.default.string,
        $853c8e196b6200d7$var$_propTypes2.default.object
    ]),
    overlayClassName: $853c8e196b6200d7$var$_propTypes2.default.oneOfType([
        $853c8e196b6200d7$var$_propTypes2.default.string,
        $853c8e196b6200d7$var$_propTypes2.default.object
    ]),
    parentSelector: $853c8e196b6200d7$var$_propTypes2.default.func,
    bodyOpenClassName: $853c8e196b6200d7$var$_propTypes2.default.string,
    htmlOpenClassName: $853c8e196b6200d7$var$_propTypes2.default.string,
    ariaHideApp: $853c8e196b6200d7$var$_propTypes2.default.bool,
    appElement: $853c8e196b6200d7$var$_propTypes2.default.oneOfType([
        $853c8e196b6200d7$var$_propTypes2.default.instanceOf($853c8e196b6200d7$var$_safeHTMLElement2.default),
        $853c8e196b6200d7$var$_propTypes2.default.instanceOf($c2956c5113267bbb$exports.SafeHTMLCollection),
        $853c8e196b6200d7$var$_propTypes2.default.instanceOf($c2956c5113267bbb$exports.SafeNodeList),
        $853c8e196b6200d7$var$_propTypes2.default.arrayOf($853c8e196b6200d7$var$_propTypes2.default.instanceOf($853c8e196b6200d7$var$_safeHTMLElement2.default))
    ]),
    onAfterOpen: $853c8e196b6200d7$var$_propTypes2.default.func,
    onAfterClose: $853c8e196b6200d7$var$_propTypes2.default.func,
    onRequestClose: $853c8e196b6200d7$var$_propTypes2.default.func,
    closeTimeoutMS: $853c8e196b6200d7$var$_propTypes2.default.number,
    shouldFocusAfterRender: $853c8e196b6200d7$var$_propTypes2.default.bool,
    shouldCloseOnOverlayClick: $853c8e196b6200d7$var$_propTypes2.default.bool,
    shouldReturnFocusAfterClose: $853c8e196b6200d7$var$_propTypes2.default.bool,
    preventScroll: $853c8e196b6200d7$var$_propTypes2.default.bool,
    role: $853c8e196b6200d7$var$_propTypes2.default.string,
    contentLabel: $853c8e196b6200d7$var$_propTypes2.default.string,
    aria: $853c8e196b6200d7$var$_propTypes2.default.object,
    data: $853c8e196b6200d7$var$_propTypes2.default.object,
    children: $853c8e196b6200d7$var$_propTypes2.default.node,
    shouldCloseOnEsc: $853c8e196b6200d7$var$_propTypes2.default.bool,
    overlayRef: $853c8e196b6200d7$var$_propTypes2.default.func,
    contentRef: $853c8e196b6200d7$var$_propTypes2.default.func,
    id: $853c8e196b6200d7$var$_propTypes2.default.string,
    overlayElement: $853c8e196b6200d7$var$_propTypes2.default.func,
    contentElement: $853c8e196b6200d7$var$_propTypes2.default.func,
    testId: $853c8e196b6200d7$var$_propTypes2.default.string
};
$853c8e196b6200d7$exports.default = $853c8e196b6200d7$var$ModalPortal;
$853c8e196b6200d7$exports = $853c8e196b6200d7$exports["default"];


var $21daa036d62cc547$var$_ModalPortal2 = $21daa036d62cc547$var$_interopRequireDefault($853c8e196b6200d7$exports);

var $21daa036d62cc547$var$ariaAppHider = $21daa036d62cc547$var$_interopRequireWildcard($c3139925b7b56b46$exports);

var $21daa036d62cc547$var$_safeHTMLElement2 = $21daa036d62cc547$var$_interopRequireDefault($c2956c5113267bbb$exports);
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ function $c8a186e1757974bb$var$componentWillMount() {
    // Call this.constructor.gDSFP to support sub-classes.
    var state = this.constructor.getDerivedStateFromProps(this.props, this.state);
    if (state !== null && state !== undefined) this.setState(state);
}
function $c8a186e1757974bb$var$componentWillReceiveProps(nextProps) {
    // Call this.constructor.gDSFP to support sub-classes.
    // Use the setState() updater to ensure state isn't stale in certain edge cases.
    function updater(prevState) {
        var state = this.constructor.getDerivedStateFromProps(nextProps, prevState);
        return state !== null && state !== undefined ? state : null;
    }
    // Binding "this" is important for shallow renderer support.
    this.setState(updater.bind(this));
}
function $c8a186e1757974bb$var$componentWillUpdate(nextProps, nextState) {
    try {
        var prevProps = this.props;
        var prevState = this.state;
        this.props = nextProps;
        this.state = nextState;
        this.__reactInternalSnapshotFlag = true;
        this.__reactInternalSnapshot = this.getSnapshotBeforeUpdate(prevProps, prevState);
    } finally{
        this.props = prevProps;
        this.state = prevState;
    }
}
// React may warn about cWM/cWRP/cWU methods being deprecated.
// Add a flag to suppress these warnings for this special case.
$c8a186e1757974bb$var$componentWillMount.__suppressDeprecationWarning = true;
$c8a186e1757974bb$var$componentWillReceiveProps.__suppressDeprecationWarning = true;
$c8a186e1757974bb$var$componentWillUpdate.__suppressDeprecationWarning = true;
function $c8a186e1757974bb$export$cea1c58a6db52bca(Component) {
    var prototype = Component.prototype;
    if (!prototype || !prototype.isReactComponent) throw new Error("Can only polyfill class components");
    if (typeof Component.getDerivedStateFromProps !== "function" && typeof prototype.getSnapshotBeforeUpdate !== "function") return Component;
    // If new component APIs are defined, "unsafe" lifecycles won't be called.
    // Error if any of these lifecycles are present,
    // Because they would work differently between older and newer (16.3+) versions of React.
    var foundWillMountName = null;
    var foundWillReceivePropsName = null;
    var foundWillUpdateName = null;
    if (typeof prototype.componentWillMount === "function") foundWillMountName = "componentWillMount";
    else if (typeof prototype.UNSAFE_componentWillMount === "function") foundWillMountName = "UNSAFE_componentWillMount";
    if (typeof prototype.componentWillReceiveProps === "function") foundWillReceivePropsName = "componentWillReceiveProps";
    else if (typeof prototype.UNSAFE_componentWillReceiveProps === "function") foundWillReceivePropsName = "UNSAFE_componentWillReceiveProps";
    if (typeof prototype.componentWillUpdate === "function") foundWillUpdateName = "componentWillUpdate";
    else if (typeof prototype.UNSAFE_componentWillUpdate === "function") foundWillUpdateName = "UNSAFE_componentWillUpdate";
    if (foundWillMountName !== null || foundWillReceivePropsName !== null || foundWillUpdateName !== null) {
        var componentName = Component.displayName || Component.name;
        var newApiName = typeof Component.getDerivedStateFromProps === "function" ? "getDerivedStateFromProps()" : "getSnapshotBeforeUpdate()";
        throw Error("Unsafe legacy lifecycles will not be called for components using new component APIs.\n\n" + componentName + " uses " + newApiName + " but also contains the following legacy lifecycles:" + (foundWillMountName !== null ? "\n  " + foundWillMountName : "") + (foundWillReceivePropsName !== null ? "\n  " + foundWillReceivePropsName : "") + (foundWillUpdateName !== null ? "\n  " + foundWillUpdateName : "") + "\n\nThe above lifecycles should be removed. Learn more about this warning here:\n" + "https://fb.me/react-async-component-lifecycle-hooks");
    }
    // React <= 16.2 does not support static getDerivedStateFromProps.
    // As a workaround, use cWM and cWRP to invoke the new static lifecycle.
    // Newer versions of React will ignore these lifecycles if gDSFP exists.
    if (typeof Component.getDerivedStateFromProps === "function") {
        prototype.componentWillMount = $c8a186e1757974bb$var$componentWillMount;
        prototype.componentWillReceiveProps = $c8a186e1757974bb$var$componentWillReceiveProps;
    }
    // React <= 16.2 does not support getSnapshotBeforeUpdate.
    // As a workaround, use cWU to invoke the new lifecycle.
    // Newer versions of React will ignore that lifecycle if gSBU exists.
    if (typeof prototype.getSnapshotBeforeUpdate === "function") {
        if (typeof prototype.componentDidUpdate !== "function") throw new Error("Cannot polyfill getSnapshotBeforeUpdate() for components that do not define componentDidUpdate() on the prototype");
        prototype.componentWillUpdate = $c8a186e1757974bb$var$componentWillUpdate;
        var componentDidUpdate = prototype.componentDidUpdate;
        prototype.componentDidUpdate = function componentDidUpdatePolyfill(prevProps, prevState, maybeSnapshot) {
            // 16.3+ will not execute our will-update method;
            // It will pass a snapshot value to did-update though.
            // Older versions will require our polyfilled will-update value.
            // We need to handle both cases, but can't just check for the presence of "maybeSnapshot",
            // Because for <= 15.x versions this might be a "prevContext" object.
            // We also can't just check "__reactInternalSnapshot",
            // Because get-snapshot might return a falsy value.
            // So check for the explicit __reactInternalSnapshotFlag flag to determine behavior.
            var snapshot = this.__reactInternalSnapshotFlag ? this.__reactInternalSnapshot : maybeSnapshot;
            componentDidUpdate.call(this, prevProps, prevState, snapshot);
        };
    }
    return Component;
}


function $21daa036d62cc547$var$_interopRequireWildcard(obj) {
    if (obj && obj.__esModule) return obj;
    else {
        var newObj = {};
        if (obj != null) {
            for(var key in obj)if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
        }
        newObj.default = obj;
        return newObj;
    }
}
function $21daa036d62cc547$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $21daa036d62cc547$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $21daa036d62cc547$var$_possibleConstructorReturn(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function $21daa036d62cc547$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
var $21daa036d62cc547$var$portalClassName = $21daa036d62cc547$exports.portalClassName = "ReactModalPortal";
var $21daa036d62cc547$var$bodyOpenClassName = $21daa036d62cc547$exports.bodyOpenClassName = "ReactModal__Body--open";
var $21daa036d62cc547$var$isReact16 = $c2956c5113267bbb$exports.canUseDOM && $21daa036d62cc547$var$_reactDom2.default.createPortal !== undefined;
var $21daa036d62cc547$var$createHTMLElement = function createHTMLElement(name) {
    return document.createElement(name);
};
var $21daa036d62cc547$var$getCreatePortal = function getCreatePortal() {
    return $21daa036d62cc547$var$isReact16 ? $21daa036d62cc547$var$_reactDom2.default.createPortal : $21daa036d62cc547$var$_reactDom2.default.unstable_renderSubtreeIntoContainer;
};
function $21daa036d62cc547$var$getParentElement(parentSelector) {
    return parentSelector();
}
var $21daa036d62cc547$var$Modal = function(_Component) {
    $21daa036d62cc547$var$_inherits(Modal, _Component);
    function Modal() {
        var _ref;
        var _temp, _this, _ret;
        $21daa036d62cc547$var$_classCallCheck(this, Modal);
        for(var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        return _ret = (_temp = (_this = $21daa036d62cc547$var$_possibleConstructorReturn(this, (_ref = Modal.__proto__ || Object.getPrototypeOf(Modal)).call.apply(_ref, [
            this
        ].concat(args))), _this), _this.removePortal = function() {
            !$21daa036d62cc547$var$isReact16 && $21daa036d62cc547$var$_reactDom2.default.unmountComponentAtNode(_this.node);
            var parent = $21daa036d62cc547$var$getParentElement(_this.props.parentSelector);
            if (parent && parent.contains(_this.node)) parent.removeChild(_this.node);
            else // eslint-disable-next-line no-console
            console.warn('React-Modal: "parentSelector" prop did not returned any DOM element. Make sure that the parent element is unmounted to avoid any memory leaks.');
        }, _this.portalRef = function(ref) {
            _this.portal = ref;
        }, _this.renderPortal = function(props) {
            var createPortal = $21daa036d62cc547$var$getCreatePortal();
            var portal = createPortal(_this, $21daa036d62cc547$var$_react2.default.createElement($21daa036d62cc547$var$_ModalPortal2.default, $21daa036d62cc547$var$_extends({
                defaultStyles: Modal.defaultStyles
            }, props)), _this.node);
            _this.portalRef(portal);
        }, _temp), $21daa036d62cc547$var$_possibleConstructorReturn(_this, _ret);
    }
    $21daa036d62cc547$var$_createClass(Modal, [
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                if (!$c2956c5113267bbb$exports.canUseDOM) return;
                if (!$21daa036d62cc547$var$isReact16) this.node = $21daa036d62cc547$var$createHTMLElement("div");
                this.node.className = this.props.portalClassName;
                var parent = $21daa036d62cc547$var$getParentElement(this.props.parentSelector);
                parent.appendChild(this.node);
                !$21daa036d62cc547$var$isReact16 && this.renderPortal(this.props);
            }
        },
        {
            key: "getSnapshotBeforeUpdate",
            value: function getSnapshotBeforeUpdate(prevProps) {
                var prevParent = $21daa036d62cc547$var$getParentElement(prevProps.parentSelector);
                var nextParent = $21daa036d62cc547$var$getParentElement(this.props.parentSelector);
                return {
                    prevParent: prevParent,
                    nextParent: nextParent
                };
            }
        },
        {
            key: "componentDidUpdate",
            value: function componentDidUpdate(prevProps, _, snapshot) {
                if (!$c2956c5113267bbb$exports.canUseDOM) return;
                var _props = this.props, isOpen = _props.isOpen, portalClassName = _props.portalClassName;
                if (prevProps.portalClassName !== portalClassName) this.node.className = portalClassName;
                var prevParent = snapshot.prevParent, nextParent = snapshot.nextParent;
                if (nextParent !== prevParent) {
                    prevParent.removeChild(this.node);
                    nextParent.appendChild(this.node);
                }
                // Stop unnecessary renders if modal is remaining closed
                if (!prevProps.isOpen && !isOpen) return;
                !$21daa036d62cc547$var$isReact16 && this.renderPortal(this.props);
            }
        },
        {
            key: "componentWillUnmount",
            value: function componentWillUnmount() {
                if (!$c2956c5113267bbb$exports.canUseDOM || !this.node || !this.portal) return;
                var state = this.portal.state;
                var now = Date.now();
                var closesAt = state.isOpen && this.props.closeTimeoutMS && (state.closesAt || now + this.props.closeTimeoutMS);
                if (closesAt) {
                    if (!state.beforeClose) this.portal.closeWithTimeout();
                    setTimeout(this.removePortal, closesAt - now);
                } else this.removePortal();
            }
        },
        {
            key: "render",
            value: function render() {
                if (!$c2956c5113267bbb$exports.canUseDOM || !$21daa036d62cc547$var$isReact16) return null;
                if (!this.node && $21daa036d62cc547$var$isReact16) this.node = $21daa036d62cc547$var$createHTMLElement("div");
                var createPortal = $21daa036d62cc547$var$getCreatePortal();
                return createPortal($21daa036d62cc547$var$_react2.default.createElement($21daa036d62cc547$var$_ModalPortal2.default, $21daa036d62cc547$var$_extends({
                    ref: this.portalRef,
                    defaultStyles: Modal.defaultStyles
                }, this.props)), this.node);
            }
        }
    ], [
        {
            key: "setAppElement",
            value: function setAppElement(element) {
                $21daa036d62cc547$var$ariaAppHider.setElement(element);
            }
        }
    ]);
    return Modal;
}($acw62.Component);
$21daa036d62cc547$var$Modal.propTypes = {
    isOpen: $21daa036d62cc547$var$_propTypes2.default.bool.isRequired,
    style: $21daa036d62cc547$var$_propTypes2.default.shape({
        content: $21daa036d62cc547$var$_propTypes2.default.object,
        overlay: $21daa036d62cc547$var$_propTypes2.default.object
    }),
    portalClassName: $21daa036d62cc547$var$_propTypes2.default.string,
    bodyOpenClassName: $21daa036d62cc547$var$_propTypes2.default.string,
    htmlOpenClassName: $21daa036d62cc547$var$_propTypes2.default.string,
    className: $21daa036d62cc547$var$_propTypes2.default.oneOfType([
        $21daa036d62cc547$var$_propTypes2.default.string,
        $21daa036d62cc547$var$_propTypes2.default.shape({
            base: $21daa036d62cc547$var$_propTypes2.default.string.isRequired,
            afterOpen: $21daa036d62cc547$var$_propTypes2.default.string.isRequired,
            beforeClose: $21daa036d62cc547$var$_propTypes2.default.string.isRequired
        })
    ]),
    overlayClassName: $21daa036d62cc547$var$_propTypes2.default.oneOfType([
        $21daa036d62cc547$var$_propTypes2.default.string,
        $21daa036d62cc547$var$_propTypes2.default.shape({
            base: $21daa036d62cc547$var$_propTypes2.default.string.isRequired,
            afterOpen: $21daa036d62cc547$var$_propTypes2.default.string.isRequired,
            beforeClose: $21daa036d62cc547$var$_propTypes2.default.string.isRequired
        })
    ]),
    appElement: $21daa036d62cc547$var$_propTypes2.default.oneOfType([
        $21daa036d62cc547$var$_propTypes2.default.instanceOf($21daa036d62cc547$var$_safeHTMLElement2.default),
        $21daa036d62cc547$var$_propTypes2.default.instanceOf($c2956c5113267bbb$exports.SafeHTMLCollection),
        $21daa036d62cc547$var$_propTypes2.default.instanceOf($c2956c5113267bbb$exports.SafeNodeList),
        $21daa036d62cc547$var$_propTypes2.default.arrayOf($21daa036d62cc547$var$_propTypes2.default.instanceOf($21daa036d62cc547$var$_safeHTMLElement2.default))
    ]),
    onAfterOpen: $21daa036d62cc547$var$_propTypes2.default.func,
    onRequestClose: $21daa036d62cc547$var$_propTypes2.default.func,
    closeTimeoutMS: $21daa036d62cc547$var$_propTypes2.default.number,
    ariaHideApp: $21daa036d62cc547$var$_propTypes2.default.bool,
    shouldFocusAfterRender: $21daa036d62cc547$var$_propTypes2.default.bool,
    shouldCloseOnOverlayClick: $21daa036d62cc547$var$_propTypes2.default.bool,
    shouldReturnFocusAfterClose: $21daa036d62cc547$var$_propTypes2.default.bool,
    preventScroll: $21daa036d62cc547$var$_propTypes2.default.bool,
    parentSelector: $21daa036d62cc547$var$_propTypes2.default.func,
    aria: $21daa036d62cc547$var$_propTypes2.default.object,
    data: $21daa036d62cc547$var$_propTypes2.default.object,
    role: $21daa036d62cc547$var$_propTypes2.default.string,
    contentLabel: $21daa036d62cc547$var$_propTypes2.default.string,
    shouldCloseOnEsc: $21daa036d62cc547$var$_propTypes2.default.bool,
    overlayRef: $21daa036d62cc547$var$_propTypes2.default.func,
    contentRef: $21daa036d62cc547$var$_propTypes2.default.func,
    id: $21daa036d62cc547$var$_propTypes2.default.string,
    overlayElement: $21daa036d62cc547$var$_propTypes2.default.func,
    contentElement: $21daa036d62cc547$var$_propTypes2.default.func
};
$21daa036d62cc547$var$Modal.defaultProps = {
    isOpen: false,
    portalClassName: $21daa036d62cc547$var$portalClassName,
    bodyOpenClassName: $21daa036d62cc547$var$bodyOpenClassName,
    role: "dialog",
    ariaHideApp: true,
    closeTimeoutMS: 0,
    shouldFocusAfterRender: true,
    shouldCloseOnEsc: true,
    shouldCloseOnOverlayClick: true,
    shouldReturnFocusAfterClose: true,
    preventScroll: false,
    parentSelector: function parentSelector() {
        return document.body;
    },
    overlayElement: function overlayElement(props, contentEl) {
        return $21daa036d62cc547$var$_react2.default.createElement("div", props, contentEl);
    },
    contentElement: function contentElement(props, children) {
        return $21daa036d62cc547$var$_react2.default.createElement("div", props, children);
    }
};
$21daa036d62cc547$var$Modal.defaultStyles = {
    overlay: {
        position: "fixed",
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: "rgba(255, 255, 255, 0.75)"
    },
    content: {
        position: "absolute",
        top: "40px",
        left: "40px",
        right: "40px",
        bottom: "40px",
        border: "1px solid #ccc",
        background: "#fff",
        overflow: "auto",
        WebkitOverflowScrolling: "touch",
        borderRadius: "4px",
        outline: "none",
        padding: "20px"
    }
};
(0, $c8a186e1757974bb$export$cea1c58a6db52bca)($21daa036d62cc547$var$Modal);
$21daa036d62cc547$var$Modal.setCreateHTMLElement = function(fn) {
    return $21daa036d62cc547$var$createHTMLElement = fn;
};
$21daa036d62cc547$exports.default = $21daa036d62cc547$var$Modal;


var $81292b5b491156fc$var$_Modal2 = $81292b5b491156fc$var$_interopRequireDefault($21daa036d62cc547$exports);
function $81292b5b491156fc$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
$81292b5b491156fc$exports.default = $81292b5b491156fc$var$_Modal2.default;
$81292b5b491156fc$exports = $81292b5b491156fc$exports["default"];


const $673ff3dfc4a496de$var$consoleLogger = {
    type: "logger",
    log (args) {
        this.output("log", args);
    },
    warn (args) {
        this.output("warn", args);
    },
    error (args) {
        this.output("error", args);
    },
    output (type, args) {
        if (console && console[type]) console[type].apply(console, args);
    }
};
class $673ff3dfc4a496de$var$Logger {
    constructor(concreteLogger){
        let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        this.init(concreteLogger, options);
    }
    init(concreteLogger) {
        let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        this.prefix = options.prefix || "i18next:";
        this.logger = concreteLogger || $673ff3dfc4a496de$var$consoleLogger;
        this.options = options;
        this.debug = options.debug;
    }
    log() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        return this.forward(args, "log", "", true);
    }
    warn() {
        for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
        return this.forward(args, "warn", "", true);
    }
    error() {
        for(var _len3 = arguments.length, args = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++)args[_key3] = arguments[_key3];
        return this.forward(args, "error", "");
    }
    deprecate() {
        for(var _len4 = arguments.length, args = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++)args[_key4] = arguments[_key4];
        return this.forward(args, "warn", "WARNING DEPRECATED: ", true);
    }
    forward(args, lvl, prefix, debugOnly) {
        if (debugOnly && !this.debug) return null;
        if (typeof args[0] === "string") args[0] = `${prefix}${this.prefix} ${args[0]}`;
        return this.logger[lvl](args);
    }
    create(moduleName) {
        return new $673ff3dfc4a496de$var$Logger(this.logger, {
            prefix: `${this.prefix}:${moduleName}:`,
            ...this.options
        });
    }
    clone(options) {
        options = options || this.options;
        options.prefix = options.prefix || this.prefix;
        return new $673ff3dfc4a496de$var$Logger(this.logger, options);
    }
}
var $673ff3dfc4a496de$var$baseLogger = new $673ff3dfc4a496de$var$Logger();
class $673ff3dfc4a496de$var$EventEmitter {
    constructor(){
        this.observers = {};
    }
    on(events, listener) {
        events.split(" ").forEach((event)=>{
            this.observers[event] = this.observers[event] || [];
            this.observers[event].push(listener);
        });
        return this;
    }
    off(event, listener) {
        if (!this.observers[event]) return;
        if (!listener) {
            delete this.observers[event];
            return;
        }
        this.observers[event] = this.observers[event].filter((l)=>l !== listener);
    }
    emit(event) {
        for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)args[_key - 1] = arguments[_key];
        if (this.observers[event]) {
            const cloned = [].concat(this.observers[event]);
            cloned.forEach((observer)=>{
                observer(...args);
            });
        }
        if (this.observers["*"]) {
            const cloned = [].concat(this.observers["*"]);
            cloned.forEach((observer)=>{
                observer.apply(observer, [
                    event,
                    ...args
                ]);
            });
        }
    }
}
function $673ff3dfc4a496de$var$defer() {
    let res;
    let rej;
    const promise = new Promise((resolve, reject)=>{
        res = resolve;
        rej = reject;
    });
    promise.resolve = res;
    promise.reject = rej;
    return promise;
}
function $673ff3dfc4a496de$var$makeString(object) {
    if (object == null) return "";
    return "" + object;
}
function $673ff3dfc4a496de$var$copy(a, s, t) {
    a.forEach((m)=>{
        if (s[m]) t[m] = s[m];
    });
}
function $673ff3dfc4a496de$var$getLastOfPath(object, path, Empty) {
    function cleanKey(key) {
        return key && key.indexOf("###") > -1 ? key.replace(/###/g, ".") : key;
    }
    function canNotTraverseDeeper() {
        return !object || typeof object === "string";
    }
    const stack = typeof path !== "string" ? [].concat(path) : path.split(".");
    while(stack.length > 1){
        if (canNotTraverseDeeper()) return {};
        const key = cleanKey(stack.shift());
        if (!object[key] && Empty) object[key] = new Empty();
        if (Object.prototype.hasOwnProperty.call(object, key)) object = object[key];
        else object = {};
    }
    if (canNotTraverseDeeper()) return {};
    return {
        obj: object,
        k: cleanKey(stack.shift())
    };
}
function $673ff3dfc4a496de$var$setPath(object, path, newValue) {
    const { obj: obj, k: k } = $673ff3dfc4a496de$var$getLastOfPath(object, path, Object);
    obj[k] = newValue;
}
function $673ff3dfc4a496de$var$pushPath(object, path, newValue, concat) {
    const { obj: obj, k: k } = $673ff3dfc4a496de$var$getLastOfPath(object, path, Object);
    obj[k] = obj[k] || [];
    if (concat) obj[k] = obj[k].concat(newValue);
    if (!concat) obj[k].push(newValue);
}
function $673ff3dfc4a496de$var$getPath(object, path) {
    const { obj: obj, k: k } = $673ff3dfc4a496de$var$getLastOfPath(object, path);
    if (!obj) return undefined;
    return obj[k];
}
function $673ff3dfc4a496de$var$getPathWithDefaults(data, defaultData, key) {
    const value = $673ff3dfc4a496de$var$getPath(data, key);
    if (value !== undefined) return value;
    return $673ff3dfc4a496de$var$getPath(defaultData, key);
}
function $673ff3dfc4a496de$var$deepExtend(target, source, overwrite) {
    for(const prop in source)if (prop !== "__proto__" && prop !== "constructor") {
        if (prop in target) {
            if (typeof target[prop] === "string" || target[prop] instanceof String || typeof source[prop] === "string" || source[prop] instanceof String) {
                if (overwrite) target[prop] = source[prop];
            } else $673ff3dfc4a496de$var$deepExtend(target[prop], source[prop], overwrite);
        } else target[prop] = source[prop];
    }
    return target;
}
function $673ff3dfc4a496de$var$regexEscape(str) {
    return str.replace(/[\-\[\]\/\{\}\(\)\*\+\?\.\\\^\$\|]/g, "\\$&");
}
var $673ff3dfc4a496de$var$_entityMap = {
    "&": "&amp;",
    "<": "&lt;",
    ">": "&gt;",
    '"': "&quot;",
    "'": "&#39;",
    "/": "&#x2F;"
};
function $673ff3dfc4a496de$var$escape(data) {
    if (typeof data === "string") return data.replace(/[&<>"'\/]/g, (s)=>$673ff3dfc4a496de$var$_entityMap[s]);
    return data;
}
const $673ff3dfc4a496de$var$chars = [
    " ",
    ",",
    "?",
    "!",
    ";"
];
function $673ff3dfc4a496de$var$looksLikeObjectPath(key, nsSeparator, keySeparator) {
    nsSeparator = nsSeparator || "";
    keySeparator = keySeparator || "";
    const possibleChars = $673ff3dfc4a496de$var$chars.filter((c)=>nsSeparator.indexOf(c) < 0 && keySeparator.indexOf(c) < 0);
    if (possibleChars.length === 0) return true;
    const r = new RegExp(`(${possibleChars.map((c)=>c === "?" ? "\\?" : c).join("|")})`);
    let matched = !r.test(key);
    if (!matched) {
        const ki = key.indexOf(keySeparator);
        if (ki > 0 && !r.test(key.substring(0, ki))) matched = true;
    }
    return matched;
}
function $673ff3dfc4a496de$var$deepFind(obj, path) {
    let keySeparator = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : ".";
    if (!obj) return undefined;
    if (obj[path]) return obj[path];
    const paths = path.split(keySeparator);
    let current = obj;
    for(let i = 0; i < paths.length; ++i){
        if (!current) return undefined;
        if (typeof current[paths[i]] === "string" && i + 1 < paths.length) return undefined;
        if (current[paths[i]] === undefined) {
            let j = 2;
            let p = paths.slice(i, i + j).join(keySeparator);
            let mix = current[p];
            while(mix === undefined && paths.length > i + j){
                j++;
                p = paths.slice(i, i + j).join(keySeparator);
                mix = current[p];
            }
            if (mix === undefined) return undefined;
            if (mix === null) return null;
            if (path.endsWith(p)) {
                if (typeof mix === "string") return mix;
                if (p && typeof mix[p] === "string") return mix[p];
            }
            const joinedPath = paths.slice(i + j).join(keySeparator);
            if (joinedPath) return $673ff3dfc4a496de$var$deepFind(mix, joinedPath, keySeparator);
            return undefined;
        }
        current = current[paths[i]];
    }
    return current;
}
function $673ff3dfc4a496de$var$getCleanedCode(code) {
    if (code && code.indexOf("_") > 0) return code.replace("_", "-");
    return code;
}
class $673ff3dfc4a496de$var$ResourceStore extends $673ff3dfc4a496de$var$EventEmitter {
    constructor(data){
        let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
            ns: [
                "translation"
            ],
            defaultNS: "translation"
        };
        super();
        this.data = data || {};
        this.options = options;
        if (this.options.keySeparator === undefined) this.options.keySeparator = ".";
        if (this.options.ignoreJSONStructure === undefined) this.options.ignoreJSONStructure = true;
    }
    addNamespaces(ns) {
        if (this.options.ns.indexOf(ns) < 0) this.options.ns.push(ns);
    }
    removeNamespaces(ns) {
        const index = this.options.ns.indexOf(ns);
        if (index > -1) this.options.ns.splice(index, 1);
    }
    getResource(lng, ns, key) {
        let options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
        const keySeparator = options.keySeparator !== undefined ? options.keySeparator : this.options.keySeparator;
        const ignoreJSONStructure = options.ignoreJSONStructure !== undefined ? options.ignoreJSONStructure : this.options.ignoreJSONStructure;
        let path = [
            lng,
            ns
        ];
        if (key && typeof key !== "string") path = path.concat(key);
        if (key && typeof key === "string") path = path.concat(keySeparator ? key.split(keySeparator) : key);
        if (lng.indexOf(".") > -1) path = lng.split(".");
        const result = $673ff3dfc4a496de$var$getPath(this.data, path);
        if (result || !ignoreJSONStructure || typeof key !== "string") return result;
        return $673ff3dfc4a496de$var$deepFind(this.data && this.data[lng] && this.data[lng][ns], key, keySeparator);
    }
    addResource(lng, ns, key, value) {
        let options = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : {
            silent: false
        };
        const keySeparator = options.keySeparator !== undefined ? options.keySeparator : this.options.keySeparator;
        let path = [
            lng,
            ns
        ];
        if (key) path = path.concat(keySeparator ? key.split(keySeparator) : key);
        if (lng.indexOf(".") > -1) {
            path = lng.split(".");
            value = ns;
            ns = path[1];
        }
        this.addNamespaces(ns);
        $673ff3dfc4a496de$var$setPath(this.data, path, value);
        if (!options.silent) this.emit("added", lng, ns, key, value);
    }
    addResources(lng, ns, resources) {
        let options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {
            silent: false
        };
        for(const m in resources)if (typeof resources[m] === "string" || Object.prototype.toString.apply(resources[m]) === "[object Array]") this.addResource(lng, ns, m, resources[m], {
            silent: true
        });
        if (!options.silent) this.emit("added", lng, ns, resources);
    }
    addResourceBundle(lng, ns, resources, deep, overwrite) {
        let options = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : {
            silent: false
        };
        let path = [
            lng,
            ns
        ];
        if (lng.indexOf(".") > -1) {
            path = lng.split(".");
            deep = resources;
            resources = ns;
            ns = path[1];
        }
        this.addNamespaces(ns);
        let pack = $673ff3dfc4a496de$var$getPath(this.data, path) || {};
        if (deep) $673ff3dfc4a496de$var$deepExtend(pack, resources, overwrite);
        else pack = {
            ...pack,
            ...resources
        };
        $673ff3dfc4a496de$var$setPath(this.data, path, pack);
        if (!options.silent) this.emit("added", lng, ns, resources);
    }
    removeResourceBundle(lng, ns) {
        if (this.hasResourceBundle(lng, ns)) delete this.data[lng][ns];
        this.removeNamespaces(ns);
        this.emit("removed", lng, ns);
    }
    hasResourceBundle(lng, ns) {
        return this.getResource(lng, ns) !== undefined;
    }
    getResourceBundle(lng, ns) {
        if (!ns) ns = this.options.defaultNS;
        if (this.options.compatibilityAPI === "v1") return {
            ...this.getResource(lng, ns)
        };
        return this.getResource(lng, ns);
    }
    getDataByLanguage(lng) {
        return this.data[lng];
    }
    hasLanguageSomeTranslations(lng) {
        const data = this.getDataByLanguage(lng);
        const n = data && Object.keys(data) || [];
        return !!n.find((v)=>data[v] && Object.keys(data[v]).length > 0);
    }
    toJSON() {
        return this.data;
    }
}
var $673ff3dfc4a496de$var$postProcessor = {
    processors: {},
    addPostProcessor (module) {
        this.processors[module.name] = module;
    },
    handle (processors, value, key, options, translator) {
        processors.forEach((processor)=>{
            if (this.processors[processor]) value = this.processors[processor].process(value, key, options, translator);
        });
        return value;
    }
};
const $673ff3dfc4a496de$var$checkedLoadedFor = {};
class $673ff3dfc4a496de$var$Translator extends $673ff3dfc4a496de$var$EventEmitter {
    constructor(services){
        let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        super();
        $673ff3dfc4a496de$var$copy([
            "resourceStore",
            "languageUtils",
            "pluralResolver",
            "interpolator",
            "backendConnector",
            "i18nFormat",
            "utils"
        ], services, this);
        this.options = options;
        if (this.options.keySeparator === undefined) this.options.keySeparator = ".";
        this.logger = $673ff3dfc4a496de$var$baseLogger.create("translator");
    }
    changeLanguage(lng) {
        if (lng) this.language = lng;
    }
    exists(key) {
        let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
            interpolation: {}
        };
        if (key === undefined || key === null) return false;
        const resolved = this.resolve(key, options);
        return resolved && resolved.res !== undefined;
    }
    extractFromKey(key, options) {
        let nsSeparator = options.nsSeparator !== undefined ? options.nsSeparator : this.options.nsSeparator;
        if (nsSeparator === undefined) nsSeparator = ":";
        const keySeparator = options.keySeparator !== undefined ? options.keySeparator : this.options.keySeparator;
        let namespaces = options.ns || this.options.defaultNS || [];
        const wouldCheckForNsInKey = nsSeparator && key.indexOf(nsSeparator) > -1;
        const seemsNaturalLanguage = !this.options.userDefinedKeySeparator && !options.keySeparator && !this.options.userDefinedNsSeparator && !options.nsSeparator && !$673ff3dfc4a496de$var$looksLikeObjectPath(key, nsSeparator, keySeparator);
        if (wouldCheckForNsInKey && !seemsNaturalLanguage) {
            const m = key.match(this.interpolator.nestingRegexp);
            if (m && m.length > 0) return {
                key: key,
                namespaces: namespaces
            };
            const parts = key.split(nsSeparator);
            if (nsSeparator !== keySeparator || nsSeparator === keySeparator && this.options.ns.indexOf(parts[0]) > -1) namespaces = parts.shift();
            key = parts.join(keySeparator);
        }
        if (typeof namespaces === "string") namespaces = [
            namespaces
        ];
        return {
            key: key,
            namespaces: namespaces
        };
    }
    translate(keys, options, lastKey) {
        if (typeof options !== "object" && this.options.overloadTranslationOptionHandler) options = this.options.overloadTranslationOptionHandler(arguments);
        if (typeof options === "object") options = {
            ...options
        };
        if (!options) options = {};
        if (keys === undefined || keys === null) return "";
        if (!Array.isArray(keys)) keys = [
            String(keys)
        ];
        const returnDetails = options.returnDetails !== undefined ? options.returnDetails : this.options.returnDetails;
        const keySeparator = options.keySeparator !== undefined ? options.keySeparator : this.options.keySeparator;
        const { key: key, namespaces: namespaces } = this.extractFromKey(keys[keys.length - 1], options);
        const namespace = namespaces[namespaces.length - 1];
        const lng = options.lng || this.language;
        const appendNamespaceToCIMode = options.appendNamespaceToCIMode || this.options.appendNamespaceToCIMode;
        if (lng && lng.toLowerCase() === "cimode") {
            if (appendNamespaceToCIMode) {
                const nsSeparator = options.nsSeparator || this.options.nsSeparator;
                if (returnDetails) return {
                    res: `${namespace}${nsSeparator}${key}`,
                    usedKey: key,
                    exactUsedKey: key,
                    usedLng: lng,
                    usedNS: namespace,
                    usedParams: this.getUsedParamsDetails(options)
                };
                return `${namespace}${nsSeparator}${key}`;
            }
            if (returnDetails) return {
                res: key,
                usedKey: key,
                exactUsedKey: key,
                usedLng: lng,
                usedNS: namespace,
                usedParams: this.getUsedParamsDetails(options)
            };
            return key;
        }
        const resolved = this.resolve(keys, options);
        let res = resolved && resolved.res;
        const resUsedKey = resolved && resolved.usedKey || key;
        const resExactUsedKey = resolved && resolved.exactUsedKey || key;
        const resType = Object.prototype.toString.apply(res);
        const noObject = [
            "[object Number]",
            "[object Function]",
            "[object RegExp]"
        ];
        const joinArrays = options.joinArrays !== undefined ? options.joinArrays : this.options.joinArrays;
        const handleAsObjectInI18nFormat = !this.i18nFormat || this.i18nFormat.handleAsObject;
        const handleAsObject = typeof res !== "string" && typeof res !== "boolean" && typeof res !== "number";
        if (handleAsObjectInI18nFormat && res && handleAsObject && noObject.indexOf(resType) < 0 && !(typeof joinArrays === "string" && resType === "[object Array]")) {
            if (!options.returnObjects && !this.options.returnObjects) {
                if (!this.options.returnedObjectHandler) this.logger.warn("accessing an object - but returnObjects options is not enabled!");
                const r = this.options.returnedObjectHandler ? this.options.returnedObjectHandler(resUsedKey, res, {
                    ...options,
                    ns: namespaces
                }) : `key '${key} (${this.language})' returned an object instead of string.`;
                if (returnDetails) {
                    resolved.res = r;
                    resolved.usedParams = this.getUsedParamsDetails(options);
                    return resolved;
                }
                return r;
            }
            if (keySeparator) {
                const resTypeIsArray = resType === "[object Array]";
                const copy = resTypeIsArray ? [] : {};
                const newKeyToUse = resTypeIsArray ? resExactUsedKey : resUsedKey;
                for(const m in res)if (Object.prototype.hasOwnProperty.call(res, m)) {
                    const deepKey = `${newKeyToUse}${keySeparator}${m}`;
                    copy[m] = this.translate(deepKey, {
                        ...options,
                        joinArrays: false,
                        ns: namespaces
                    });
                    if (copy[m] === deepKey) copy[m] = res[m];
                }
                res = copy;
            }
        } else if (handleAsObjectInI18nFormat && typeof joinArrays === "string" && resType === "[object Array]") {
            res = res.join(joinArrays);
            if (res) res = this.extendTranslation(res, keys, options, lastKey);
        } else {
            let usedDefault = false;
            let usedKey = false;
            const needsPluralHandling = options.count !== undefined && typeof options.count !== "string";
            const hasDefaultValue = $673ff3dfc4a496de$var$Translator.hasDefaultValue(options);
            const defaultValueSuffix = needsPluralHandling ? this.pluralResolver.getSuffix(lng, options.count, options) : "";
            const defaultValueSuffixOrdinalFallback = options.ordinal && needsPluralHandling ? this.pluralResolver.getSuffix(lng, options.count, {
                ordinal: false
            }) : "";
            const defaultValue = options[`defaultValue${defaultValueSuffix}`] || options[`defaultValue${defaultValueSuffixOrdinalFallback}`] || options.defaultValue;
            if (!this.isValidLookup(res) && hasDefaultValue) {
                usedDefault = true;
                res = defaultValue;
            }
            if (!this.isValidLookup(res)) {
                usedKey = true;
                res = key;
            }
            const missingKeyNoValueFallbackToKey = options.missingKeyNoValueFallbackToKey || this.options.missingKeyNoValueFallbackToKey;
            const resForMissing = missingKeyNoValueFallbackToKey && usedKey ? undefined : res;
            const updateMissing = hasDefaultValue && defaultValue !== res && this.options.updateMissing;
            if (usedKey || usedDefault || updateMissing) {
                this.logger.log(updateMissing ? "updateKey" : "missingKey", lng, namespace, key, updateMissing ? defaultValue : res);
                if (keySeparator) {
                    const fk = this.resolve(key, {
                        ...options,
                        keySeparator: false
                    });
                    if (fk && fk.res) this.logger.warn("Seems the loaded translations were in flat JSON format instead of nested. Either set keySeparator: false on init or make sure your translations are published in nested format.");
                }
                let lngs = [];
                const fallbackLngs = this.languageUtils.getFallbackCodes(this.options.fallbackLng, options.lng || this.language);
                if (this.options.saveMissingTo === "fallback" && fallbackLngs && fallbackLngs[0]) for(let i = 0; i < fallbackLngs.length; i++)lngs.push(fallbackLngs[i]);
                else if (this.options.saveMissingTo === "all") lngs = this.languageUtils.toResolveHierarchy(options.lng || this.language);
                else lngs.push(options.lng || this.language);
                const send = (l, k, specificDefaultValue)=>{
                    const defaultForMissing = hasDefaultValue && specificDefaultValue !== res ? specificDefaultValue : resForMissing;
                    if (this.options.missingKeyHandler) this.options.missingKeyHandler(l, namespace, k, defaultForMissing, updateMissing, options);
                    else if (this.backendConnector && this.backendConnector.saveMissing) this.backendConnector.saveMissing(l, namespace, k, defaultForMissing, updateMissing, options);
                    this.emit("missingKey", l, namespace, k, res);
                };
                if (this.options.saveMissing) {
                    if (this.options.saveMissingPlurals && needsPluralHandling) lngs.forEach((language)=>{
                        this.pluralResolver.getSuffixes(language, options).forEach((suffix)=>{
                            send([
                                language
                            ], key + suffix, options[`defaultValue${suffix}`] || defaultValue);
                        });
                    });
                    else send(lngs, key, defaultValue);
                }
            }
            res = this.extendTranslation(res, keys, options, resolved, lastKey);
            if (usedKey && res === key && this.options.appendNamespaceToMissingKey) res = `${namespace}:${key}`;
            if ((usedKey || usedDefault) && this.options.parseMissingKeyHandler) {
                if (this.options.compatibilityAPI !== "v1") res = this.options.parseMissingKeyHandler(this.options.appendNamespaceToMissingKey ? `${namespace}:${key}` : key, usedDefault ? res : undefined);
                else res = this.options.parseMissingKeyHandler(res);
            }
        }
        if (returnDetails) {
            resolved.res = res;
            resolved.usedParams = this.getUsedParamsDetails(options);
            return resolved;
        }
        return res;
    }
    extendTranslation(res, key, options, resolved, lastKey) {
        var _this = this;
        if (this.i18nFormat && this.i18nFormat.parse) res = this.i18nFormat.parse(res, {
            ...this.options.interpolation.defaultVariables,
            ...options
        }, options.lng || this.language || resolved.usedLng, resolved.usedNS, resolved.usedKey, {
            resolved: resolved
        });
        else if (!options.skipInterpolation) {
            if (options.interpolation) this.interpolator.init({
                ...options,
                interpolation: {
                    ...this.options.interpolation,
                    ...options.interpolation
                }
            });
            const skipOnVariables = typeof res === "string" && (options && options.interpolation && options.interpolation.skipOnVariables !== undefined ? options.interpolation.skipOnVariables : this.options.interpolation.skipOnVariables);
            let nestBef;
            if (skipOnVariables) {
                const nb = res.match(this.interpolator.nestingRegexp);
                nestBef = nb && nb.length;
            }
            let data = options.replace && typeof options.replace !== "string" ? options.replace : options;
            if (this.options.interpolation.defaultVariables) data = {
                ...this.options.interpolation.defaultVariables,
                ...data
            };
            res = this.interpolator.interpolate(res, data, options.lng || this.language, options);
            if (skipOnVariables) {
                const na = res.match(this.interpolator.nestingRegexp);
                const nestAft = na && na.length;
                if (nestBef < nestAft) options.nest = false;
            }
            if (!options.lng && this.options.compatibilityAPI !== "v1" && resolved && resolved.res) options.lng = resolved.usedLng;
            if (options.nest !== false) res = this.interpolator.nest(res, function() {
                for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
                if (lastKey && lastKey[0] === args[0] && !options.context) {
                    _this.logger.warn(`It seems you are nesting recursively key: ${args[0]} in key: ${key[0]}`);
                    return null;
                }
                return _this.translate(...args, key);
            }, options);
            if (options.interpolation) this.interpolator.reset();
        }
        const postProcess = options.postProcess || this.options.postProcess;
        const postProcessorNames = typeof postProcess === "string" ? [
            postProcess
        ] : postProcess;
        if (res !== undefined && res !== null && postProcessorNames && postProcessorNames.length && options.applyPostProcessor !== false) res = $673ff3dfc4a496de$var$postProcessor.handle(postProcessorNames, res, key, this.options && this.options.postProcessPassResolved ? {
            i18nResolved: {
                ...resolved,
                usedParams: this.getUsedParamsDetails(options)
            },
            ...options
        } : options, this);
        return res;
    }
    resolve(keys) {
        let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        let found;
        let usedKey;
        let exactUsedKey;
        let usedLng;
        let usedNS;
        if (typeof keys === "string") keys = [
            keys
        ];
        keys.forEach((k)=>{
            if (this.isValidLookup(found)) return;
            const extracted = this.extractFromKey(k, options);
            const key = extracted.key;
            usedKey = key;
            let namespaces = extracted.namespaces;
            if (this.options.fallbackNS) namespaces = namespaces.concat(this.options.fallbackNS);
            const needsPluralHandling = options.count !== undefined && typeof options.count !== "string";
            const needsZeroSuffixLookup = needsPluralHandling && !options.ordinal && options.count === 0 && this.pluralResolver.shouldUseIntlApi();
            const needsContextHandling = options.context !== undefined && (typeof options.context === "string" || typeof options.context === "number") && options.context !== "";
            const codes = options.lngs ? options.lngs : this.languageUtils.toResolveHierarchy(options.lng || this.language, options.fallbackLng);
            namespaces.forEach((ns)=>{
                if (this.isValidLookup(found)) return;
                usedNS = ns;
                if (!$673ff3dfc4a496de$var$checkedLoadedFor[`${codes[0]}-${ns}`] && this.utils && this.utils.hasLoadedNamespace && !this.utils.hasLoadedNamespace(usedNS)) {
                    $673ff3dfc4a496de$var$checkedLoadedFor[`${codes[0]}-${ns}`] = true;
                    this.logger.warn(`key "${usedKey}" for languages "${codes.join(", ")}" won't get resolved as namespace "${usedNS}" was not yet loaded`, "This means something IS WRONG in your setup. You access the t function before i18next.init / i18next.loadNamespace / i18next.changeLanguage was done. Wait for the callback or Promise to resolve before accessing it!!!");
                }
                codes.forEach((code)=>{
                    if (this.isValidLookup(found)) return;
                    usedLng = code;
                    const finalKeys = [
                        key
                    ];
                    if (this.i18nFormat && this.i18nFormat.addLookupKeys) this.i18nFormat.addLookupKeys(finalKeys, key, code, ns, options);
                    else {
                        let pluralSuffix;
                        if (needsPluralHandling) pluralSuffix = this.pluralResolver.getSuffix(code, options.count, options);
                        const zeroSuffix = `${this.options.pluralSeparator}zero`;
                        const ordinalPrefix = `${this.options.pluralSeparator}ordinal${this.options.pluralSeparator}`;
                        if (needsPluralHandling) {
                            finalKeys.push(key + pluralSuffix);
                            if (options.ordinal && pluralSuffix.indexOf(ordinalPrefix) === 0) finalKeys.push(key + pluralSuffix.replace(ordinalPrefix, this.options.pluralSeparator));
                            if (needsZeroSuffixLookup) finalKeys.push(key + zeroSuffix);
                        }
                        if (needsContextHandling) {
                            const contextKey = `${key}${this.options.contextSeparator}${options.context}`;
                            finalKeys.push(contextKey);
                            if (needsPluralHandling) {
                                finalKeys.push(contextKey + pluralSuffix);
                                if (options.ordinal && pluralSuffix.indexOf(ordinalPrefix) === 0) finalKeys.push(contextKey + pluralSuffix.replace(ordinalPrefix, this.options.pluralSeparator));
                                if (needsZeroSuffixLookup) finalKeys.push(contextKey + zeroSuffix);
                            }
                        }
                    }
                    let possibleKey;
                    while(possibleKey = finalKeys.pop())if (!this.isValidLookup(found)) {
                        exactUsedKey = possibleKey;
                        found = this.getResource(code, ns, possibleKey, options);
                    }
                });
            });
        });
        return {
            res: found,
            usedKey: usedKey,
            exactUsedKey: exactUsedKey,
            usedLng: usedLng,
            usedNS: usedNS
        };
    }
    isValidLookup(res) {
        return res !== undefined && !(!this.options.returnNull && res === null) && !(!this.options.returnEmptyString && res === "");
    }
    getResource(code, ns, key) {
        let options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
        if (this.i18nFormat && this.i18nFormat.getResource) return this.i18nFormat.getResource(code, ns, key, options);
        return this.resourceStore.getResource(code, ns, key, options);
    }
    getUsedParamsDetails() {
        let options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        const optionsKeys = [
            "defaultValue",
            "ordinal",
            "context",
            "replace",
            "lng",
            "lngs",
            "fallbackLng",
            "ns",
            "keySeparator",
            "nsSeparator",
            "returnObjects",
            "returnDetails",
            "joinArrays",
            "postProcess",
            "interpolation"
        ];
        const useOptionsReplaceForData = options.replace && typeof options.replace !== "string";
        let data = useOptionsReplaceForData ? options.replace : options;
        if (useOptionsReplaceForData && typeof options.count !== "undefined") data.count = options.count;
        if (this.options.interpolation.defaultVariables) data = {
            ...this.options.interpolation.defaultVariables,
            ...data
        };
        if (!useOptionsReplaceForData) {
            data = {
                ...data
            };
            for (const key of optionsKeys)delete data[key];
        }
        return data;
    }
    static hasDefaultValue(options) {
        const prefix = "defaultValue";
        for(const option in options){
            if (Object.prototype.hasOwnProperty.call(options, option) && prefix === option.substring(0, prefix.length) && undefined !== options[option]) return true;
        }
        return false;
    }
}
function $673ff3dfc4a496de$var$capitalize(string) {
    return string.charAt(0).toUpperCase() + string.slice(1);
}
class $673ff3dfc4a496de$var$LanguageUtil {
    constructor(options){
        this.options = options;
        this.supportedLngs = this.options.supportedLngs || false;
        this.logger = $673ff3dfc4a496de$var$baseLogger.create("languageUtils");
    }
    getScriptPartFromCode(code) {
        code = $673ff3dfc4a496de$var$getCleanedCode(code);
        if (!code || code.indexOf("-") < 0) return null;
        const p = code.split("-");
        if (p.length === 2) return null;
        p.pop();
        if (p[p.length - 1].toLowerCase() === "x") return null;
        return this.formatLanguageCode(p.join("-"));
    }
    getLanguagePartFromCode(code) {
        code = $673ff3dfc4a496de$var$getCleanedCode(code);
        if (!code || code.indexOf("-") < 0) return code;
        const p = code.split("-");
        return this.formatLanguageCode(p[0]);
    }
    formatLanguageCode(code) {
        if (typeof code === "string" && code.indexOf("-") > -1) {
            const specialCases = [
                "hans",
                "hant",
                "latn",
                "cyrl",
                "cans",
                "mong",
                "arab"
            ];
            let p = code.split("-");
            if (this.options.lowerCaseLng) p = p.map((part)=>part.toLowerCase());
            else if (p.length === 2) {
                p[0] = p[0].toLowerCase();
                p[1] = p[1].toUpperCase();
                if (specialCases.indexOf(p[1].toLowerCase()) > -1) p[1] = $673ff3dfc4a496de$var$capitalize(p[1].toLowerCase());
            } else if (p.length === 3) {
                p[0] = p[0].toLowerCase();
                if (p[1].length === 2) p[1] = p[1].toUpperCase();
                if (p[0] !== "sgn" && p[2].length === 2) p[2] = p[2].toUpperCase();
                if (specialCases.indexOf(p[1].toLowerCase()) > -1) p[1] = $673ff3dfc4a496de$var$capitalize(p[1].toLowerCase());
                if (specialCases.indexOf(p[2].toLowerCase()) > -1) p[2] = $673ff3dfc4a496de$var$capitalize(p[2].toLowerCase());
            }
            return p.join("-");
        }
        return this.options.cleanCode || this.options.lowerCaseLng ? code.toLowerCase() : code;
    }
    isSupportedCode(code) {
        if (this.options.load === "languageOnly" || this.options.nonExplicitSupportedLngs) code = this.getLanguagePartFromCode(code);
        return !this.supportedLngs || !this.supportedLngs.length || this.supportedLngs.indexOf(code) > -1;
    }
    getBestMatchFromCodes(codes) {
        if (!codes) return null;
        let found;
        codes.forEach((code)=>{
            if (found) return;
            const cleanedLng = this.formatLanguageCode(code);
            if (!this.options.supportedLngs || this.isSupportedCode(cleanedLng)) found = cleanedLng;
        });
        if (!found && this.options.supportedLngs) codes.forEach((code)=>{
            if (found) return;
            const lngOnly = this.getLanguagePartFromCode(code);
            if (this.isSupportedCode(lngOnly)) return found = lngOnly;
            found = this.options.supportedLngs.find((supportedLng)=>{
                if (supportedLng === lngOnly) return supportedLng;
                if (supportedLng.indexOf("-") < 0 && lngOnly.indexOf("-") < 0) return;
                if (supportedLng.indexOf(lngOnly) === 0) return supportedLng;
            });
        });
        if (!found) found = this.getFallbackCodes(this.options.fallbackLng)[0];
        return found;
    }
    getFallbackCodes(fallbacks, code) {
        if (!fallbacks) return [];
        if (typeof fallbacks === "function") fallbacks = fallbacks(code);
        if (typeof fallbacks === "string") fallbacks = [
            fallbacks
        ];
        if (Object.prototype.toString.apply(fallbacks) === "[object Array]") return fallbacks;
        if (!code) return fallbacks.default || [];
        let found = fallbacks[code];
        if (!found) found = fallbacks[this.getScriptPartFromCode(code)];
        if (!found) found = fallbacks[this.formatLanguageCode(code)];
        if (!found) found = fallbacks[this.getLanguagePartFromCode(code)];
        if (!found) found = fallbacks.default;
        return found || [];
    }
    toResolveHierarchy(code, fallbackCode) {
        const fallbackCodes = this.getFallbackCodes(fallbackCode || this.options.fallbackLng || [], code);
        const codes = [];
        const addCode = (c)=>{
            if (!c) return;
            if (this.isSupportedCode(c)) codes.push(c);
            else this.logger.warn(`rejecting language code not found in supportedLngs: ${c}`);
        };
        if (typeof code === "string" && (code.indexOf("-") > -1 || code.indexOf("_") > -1)) {
            if (this.options.load !== "languageOnly") addCode(this.formatLanguageCode(code));
            if (this.options.load !== "languageOnly" && this.options.load !== "currentOnly") addCode(this.getScriptPartFromCode(code));
            if (this.options.load !== "currentOnly") addCode(this.getLanguagePartFromCode(code));
        } else if (typeof code === "string") addCode(this.formatLanguageCode(code));
        fallbackCodes.forEach((fc)=>{
            if (codes.indexOf(fc) < 0) addCode(this.formatLanguageCode(fc));
        });
        return codes;
    }
}
let $673ff3dfc4a496de$var$sets = [
    {
        lngs: [
            "ach",
            "ak",
            "am",
            "arn",
            "br",
            "fil",
            "gun",
            "ln",
            "mfe",
            "mg",
            "mi",
            "oc",
            "pt",
            "pt-BR",
            "tg",
            "tl",
            "ti",
            "tr",
            "uz",
            "wa"
        ],
        nr: [
            1,
            2
        ],
        fc: 1
    },
    {
        lngs: [
            "af",
            "an",
            "ast",
            "az",
            "bg",
            "bn",
            "ca",
            "da",
            "de",
            "dev",
            "el",
            "en",
            "eo",
            "es",
            "et",
            "eu",
            "fi",
            "fo",
            "fur",
            "fy",
            "gl",
            "gu",
            "ha",
            "hi",
            "hu",
            "hy",
            "ia",
            "it",
            "kk",
            "kn",
            "ku",
            "lb",
            "mai",
            "ml",
            "mn",
            "mr",
            "nah",
            "nap",
            "nb",
            "ne",
            "nl",
            "nn",
            "no",
            "nso",
            "pa",
            "pap",
            "pms",
            "ps",
            "pt-PT",
            "rm",
            "sco",
            "se",
            "si",
            "so",
            "son",
            "sq",
            "sv",
            "sw",
            "ta",
            "te",
            "tk",
            "ur",
            "yo"
        ],
        nr: [
            1,
            2
        ],
        fc: 2
    },
    {
        lngs: [
            "ay",
            "bo",
            "cgg",
            "fa",
            "ht",
            "id",
            "ja",
            "jbo",
            "ka",
            "km",
            "ko",
            "ky",
            "lo",
            "ms",
            "sah",
            "su",
            "th",
            "tt",
            "ug",
            "vi",
            "wo",
            "zh"
        ],
        nr: [
            1
        ],
        fc: 3
    },
    {
        lngs: [
            "be",
            "bs",
            "cnr",
            "dz",
            "hr",
            "ru",
            "sr",
            "uk"
        ],
        nr: [
            1,
            2,
            5
        ],
        fc: 4
    },
    {
        lngs: [
            "ar"
        ],
        nr: [
            0,
            1,
            2,
            3,
            11,
            100
        ],
        fc: 5
    },
    {
        lngs: [
            "cs",
            "sk"
        ],
        nr: [
            1,
            2,
            5
        ],
        fc: 6
    },
    {
        lngs: [
            "csb",
            "pl"
        ],
        nr: [
            1,
            2,
            5
        ],
        fc: 7
    },
    {
        lngs: [
            "cy"
        ],
        nr: [
            1,
            2,
            3,
            8
        ],
        fc: 8
    },
    {
        lngs: [
            "fr"
        ],
        nr: [
            1,
            2
        ],
        fc: 9
    },
    {
        lngs: [
            "ga"
        ],
        nr: [
            1,
            2,
            3,
            7,
            11
        ],
        fc: 10
    },
    {
        lngs: [
            "gd"
        ],
        nr: [
            1,
            2,
            3,
            20
        ],
        fc: 11
    },
    {
        lngs: [
            "is"
        ],
        nr: [
            1,
            2
        ],
        fc: 12
    },
    {
        lngs: [
            "jv"
        ],
        nr: [
            0,
            1
        ],
        fc: 13
    },
    {
        lngs: [
            "kw"
        ],
        nr: [
            1,
            2,
            3,
            4
        ],
        fc: 14
    },
    {
        lngs: [
            "lt"
        ],
        nr: [
            1,
            2,
            10
        ],
        fc: 15
    },
    {
        lngs: [
            "lv"
        ],
        nr: [
            1,
            2,
            0
        ],
        fc: 16
    },
    {
        lngs: [
            "mk"
        ],
        nr: [
            1,
            2
        ],
        fc: 17
    },
    {
        lngs: [
            "mnk"
        ],
        nr: [
            0,
            1,
            2
        ],
        fc: 18
    },
    {
        lngs: [
            "mt"
        ],
        nr: [
            1,
            2,
            11,
            20
        ],
        fc: 19
    },
    {
        lngs: [
            "or"
        ],
        nr: [
            2,
            1
        ],
        fc: 2
    },
    {
        lngs: [
            "ro"
        ],
        nr: [
            1,
            2,
            20
        ],
        fc: 20
    },
    {
        lngs: [
            "sl"
        ],
        nr: [
            5,
            1,
            2,
            3
        ],
        fc: 21
    },
    {
        lngs: [
            "he",
            "iw"
        ],
        nr: [
            1,
            2,
            20,
            21
        ],
        fc: 22
    }
];
let $673ff3dfc4a496de$var$_rulesPluralsTypes = {
    1: function(n) {
        return Number(n > 1);
    },
    2: function(n) {
        return Number(n != 1);
    },
    3: function(n) {
        return 0;
    },
    4: function(n) {
        return Number(n % 10 == 1 && n % 100 != 11 ? 0 : n % 10 >= 2 && n % 10 <= 4 && (n % 100 < 10 || n % 100 >= 20) ? 1 : 2);
    },
    5: function(n) {
        return Number(n == 0 ? 0 : n == 1 ? 1 : n == 2 ? 2 : n % 100 >= 3 && n % 100 <= 10 ? 3 : n % 100 >= 11 ? 4 : 5);
    },
    6: function(n) {
        return Number(n == 1 ? 0 : n >= 2 && n <= 4 ? 1 : 2);
    },
    7: function(n) {
        return Number(n == 1 ? 0 : n % 10 >= 2 && n % 10 <= 4 && (n % 100 < 10 || n % 100 >= 20) ? 1 : 2);
    },
    8: function(n) {
        return Number(n == 1 ? 0 : n == 2 ? 1 : n != 8 && n != 11 ? 2 : 3);
    },
    9: function(n) {
        return Number(n >= 2);
    },
    10: function(n) {
        return Number(n == 1 ? 0 : n == 2 ? 1 : n < 7 ? 2 : n < 11 ? 3 : 4);
    },
    11: function(n) {
        return Number(n == 1 || n == 11 ? 0 : n == 2 || n == 12 ? 1 : n > 2 && n < 20 ? 2 : 3);
    },
    12: function(n) {
        return Number(n % 10 != 1 || n % 100 == 11);
    },
    13: function(n) {
        return Number(n !== 0);
    },
    14: function(n) {
        return Number(n == 1 ? 0 : n == 2 ? 1 : n == 3 ? 2 : 3);
    },
    15: function(n) {
        return Number(n % 10 == 1 && n % 100 != 11 ? 0 : n % 10 >= 2 && (n % 100 < 10 || n % 100 >= 20) ? 1 : 2);
    },
    16: function(n) {
        return Number(n % 10 == 1 && n % 100 != 11 ? 0 : n !== 0 ? 1 : 2);
    },
    17: function(n) {
        return Number(n == 1 || n % 10 == 1 && n % 100 != 11 ? 0 : 1);
    },
    18: function(n) {
        return Number(n == 0 ? 0 : n == 1 ? 1 : 2);
    },
    19: function(n) {
        return Number(n == 1 ? 0 : n == 0 || n % 100 > 1 && n % 100 < 11 ? 1 : n % 100 > 10 && n % 100 < 20 ? 2 : 3);
    },
    20: function(n) {
        return Number(n == 1 ? 0 : n == 0 || n % 100 > 0 && n % 100 < 20 ? 1 : 2);
    },
    21: function(n) {
        return Number(n % 100 == 1 ? 1 : n % 100 == 2 ? 2 : n % 100 == 3 || n % 100 == 4 ? 3 : 0);
    },
    22: function(n) {
        return Number(n == 1 ? 0 : n == 2 ? 1 : (n < 0 || n > 10) && n % 10 == 0 ? 2 : 3);
    }
};
const $673ff3dfc4a496de$var$nonIntlVersions = [
    "v1",
    "v2",
    "v3"
];
const $673ff3dfc4a496de$var$intlVersions = [
    "v4"
];
const $673ff3dfc4a496de$var$suffixesOrder = {
    zero: 0,
    one: 1,
    two: 2,
    few: 3,
    many: 4,
    other: 5
};
function $673ff3dfc4a496de$var$createRules() {
    const rules = {};
    $673ff3dfc4a496de$var$sets.forEach((set)=>{
        set.lngs.forEach((l)=>{
            rules[l] = {
                numbers: set.nr,
                plurals: $673ff3dfc4a496de$var$_rulesPluralsTypes[set.fc]
            };
        });
    });
    return rules;
}
class $673ff3dfc4a496de$var$PluralResolver {
    constructor(languageUtils){
        let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        this.languageUtils = languageUtils;
        this.options = options;
        this.logger = $673ff3dfc4a496de$var$baseLogger.create("pluralResolver");
        if ((!this.options.compatibilityJSON || $673ff3dfc4a496de$var$intlVersions.includes(this.options.compatibilityJSON)) && (typeof Intl === "undefined" || !Intl.PluralRules)) {
            this.options.compatibilityJSON = "v3";
            this.logger.error("Your environment seems not to be Intl API compatible, use an Intl.PluralRules polyfill. Will fallback to the compatibilityJSON v3 format handling.");
        }
        this.rules = $673ff3dfc4a496de$var$createRules();
    }
    addRule(lng, obj) {
        this.rules[lng] = obj;
    }
    getRule(code) {
        let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        if (this.shouldUseIntlApi()) try {
            return new Intl.PluralRules($673ff3dfc4a496de$var$getCleanedCode(code), {
                type: options.ordinal ? "ordinal" : "cardinal"
            });
        } catch (err) {
            return;
        }
        return this.rules[code] || this.rules[this.languageUtils.getLanguagePartFromCode(code)];
    }
    needsPlural(code) {
        let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        const rule = this.getRule(code, options);
        if (this.shouldUseIntlApi()) return rule && rule.resolvedOptions().pluralCategories.length > 1;
        return rule && rule.numbers.length > 1;
    }
    getPluralFormsOfKey(code, key) {
        let options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
        return this.getSuffixes(code, options).map((suffix)=>`${key}${suffix}`);
    }
    getSuffixes(code) {
        let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        const rule = this.getRule(code, options);
        if (!rule) return [];
        if (this.shouldUseIntlApi()) return rule.resolvedOptions().pluralCategories.sort((pluralCategory1, pluralCategory2)=>$673ff3dfc4a496de$var$suffixesOrder[pluralCategory1] - $673ff3dfc4a496de$var$suffixesOrder[pluralCategory2]).map((pluralCategory)=>`${this.options.prepend}${options.ordinal ? `ordinal${this.options.prepend}` : ""}${pluralCategory}`);
        return rule.numbers.map((number)=>this.getSuffix(code, number, options));
    }
    getSuffix(code, count) {
        let options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
        const rule = this.getRule(code, options);
        if (rule) {
            if (this.shouldUseIntlApi()) return `${this.options.prepend}${options.ordinal ? `ordinal${this.options.prepend}` : ""}${rule.select(count)}`;
            return this.getSuffixRetroCompatible(rule, count);
        }
        this.logger.warn(`no plural rule found for: ${code}`);
        return "";
    }
    getSuffixRetroCompatible(rule, count) {
        const idx = rule.noAbs ? rule.plurals(count) : rule.plurals(Math.abs(count));
        let suffix = rule.numbers[idx];
        if (this.options.simplifyPluralSuffix && rule.numbers.length === 2 && rule.numbers[0] === 1) {
            if (suffix === 2) suffix = "plural";
            else if (suffix === 1) suffix = "";
        }
        const returnSuffix = ()=>this.options.prepend && suffix.toString() ? this.options.prepend + suffix.toString() : suffix.toString();
        if (this.options.compatibilityJSON === "v1") {
            if (suffix === 1) return "";
            if (typeof suffix === "number") return `_plural_${suffix.toString()}`;
            return returnSuffix();
        } else if (this.options.compatibilityJSON === "v2") return returnSuffix();
        else if (this.options.simplifyPluralSuffix && rule.numbers.length === 2 && rule.numbers[0] === 1) return returnSuffix();
        return this.options.prepend && idx.toString() ? this.options.prepend + idx.toString() : idx.toString();
    }
    shouldUseIntlApi() {
        return !$673ff3dfc4a496de$var$nonIntlVersions.includes(this.options.compatibilityJSON);
    }
}
function $673ff3dfc4a496de$var$deepFindWithDefaults(data, defaultData, key) {
    let keySeparator = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : ".";
    let ignoreJSONStructure = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : true;
    let path = $673ff3dfc4a496de$var$getPathWithDefaults(data, defaultData, key);
    if (!path && ignoreJSONStructure && typeof key === "string") {
        path = $673ff3dfc4a496de$var$deepFind(data, key, keySeparator);
        if (path === undefined) path = $673ff3dfc4a496de$var$deepFind(defaultData, key, keySeparator);
    }
    return path;
}
class $673ff3dfc4a496de$var$Interpolator {
    constructor(){
        let options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        this.logger = $673ff3dfc4a496de$var$baseLogger.create("interpolator");
        this.options = options;
        this.format = options.interpolation && options.interpolation.format || ((value)=>value);
        this.init(options);
    }
    init() {
        let options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        if (!options.interpolation) options.interpolation = {
            escapeValue: true
        };
        const iOpts = options.interpolation;
        this.escape = iOpts.escape !== undefined ? iOpts.escape : $673ff3dfc4a496de$var$escape;
        this.escapeValue = iOpts.escapeValue !== undefined ? iOpts.escapeValue : true;
        this.useRawValueToEscape = iOpts.useRawValueToEscape !== undefined ? iOpts.useRawValueToEscape : false;
        this.prefix = iOpts.prefix ? $673ff3dfc4a496de$var$regexEscape(iOpts.prefix) : iOpts.prefixEscaped || "{{";
        this.suffix = iOpts.suffix ? $673ff3dfc4a496de$var$regexEscape(iOpts.suffix) : iOpts.suffixEscaped || "}}";
        this.formatSeparator = iOpts.formatSeparator ? iOpts.formatSeparator : iOpts.formatSeparator || ",";
        this.unescapePrefix = iOpts.unescapeSuffix ? "" : iOpts.unescapePrefix || "-";
        this.unescapeSuffix = this.unescapePrefix ? "" : iOpts.unescapeSuffix || "";
        this.nestingPrefix = iOpts.nestingPrefix ? $673ff3dfc4a496de$var$regexEscape(iOpts.nestingPrefix) : iOpts.nestingPrefixEscaped || $673ff3dfc4a496de$var$regexEscape("$t(");
        this.nestingSuffix = iOpts.nestingSuffix ? $673ff3dfc4a496de$var$regexEscape(iOpts.nestingSuffix) : iOpts.nestingSuffixEscaped || $673ff3dfc4a496de$var$regexEscape(")");
        this.nestingOptionsSeparator = iOpts.nestingOptionsSeparator ? iOpts.nestingOptionsSeparator : iOpts.nestingOptionsSeparator || ",";
        this.maxReplaces = iOpts.maxReplaces ? iOpts.maxReplaces : 1000;
        this.alwaysFormat = iOpts.alwaysFormat !== undefined ? iOpts.alwaysFormat : false;
        this.resetRegExp();
    }
    reset() {
        if (this.options) this.init(this.options);
    }
    resetRegExp() {
        const regexpStr = `${this.prefix}(.+?)${this.suffix}`;
        this.regexp = new RegExp(regexpStr, "g");
        const regexpUnescapeStr = `${this.prefix}${this.unescapePrefix}(.+?)${this.unescapeSuffix}${this.suffix}`;
        this.regexpUnescape = new RegExp(regexpUnescapeStr, "g");
        const nestingRegexpStr = `${this.nestingPrefix}(.+?)${this.nestingSuffix}`;
        this.nestingRegexp = new RegExp(nestingRegexpStr, "g");
    }
    interpolate(str, data, lng, options) {
        let match;
        let value;
        let replaces;
        const defaultData = this.options && this.options.interpolation && this.options.interpolation.defaultVariables || {};
        function regexSafe(val) {
            return val.replace(/\$/g, "$$$$");
        }
        const handleFormat = (key)=>{
            if (key.indexOf(this.formatSeparator) < 0) {
                const path = $673ff3dfc4a496de$var$deepFindWithDefaults(data, defaultData, key, this.options.keySeparator, this.options.ignoreJSONStructure);
                return this.alwaysFormat ? this.format(path, undefined, lng, {
                    ...options,
                    ...data,
                    interpolationkey: key
                }) : path;
            }
            const p = key.split(this.formatSeparator);
            const k = p.shift().trim();
            const f = p.join(this.formatSeparator).trim();
            return this.format($673ff3dfc4a496de$var$deepFindWithDefaults(data, defaultData, k, this.options.keySeparator, this.options.ignoreJSONStructure), f, lng, {
                ...options,
                ...data,
                interpolationkey: k
            });
        };
        this.resetRegExp();
        const missingInterpolationHandler = options && options.missingInterpolationHandler || this.options.missingInterpolationHandler;
        const skipOnVariables = options && options.interpolation && options.interpolation.skipOnVariables !== undefined ? options.interpolation.skipOnVariables : this.options.interpolation.skipOnVariables;
        const todos = [
            {
                regex: this.regexpUnescape,
                safeValue: (val)=>regexSafe(val)
            },
            {
                regex: this.regexp,
                safeValue: (val)=>this.escapeValue ? regexSafe(this.escape(val)) : regexSafe(val)
            }
        ];
        todos.forEach((todo)=>{
            replaces = 0;
            while(match = todo.regex.exec(str)){
                const matchedVar = match[1].trim();
                value = handleFormat(matchedVar);
                if (value === undefined) {
                    if (typeof missingInterpolationHandler === "function") {
                        const temp = missingInterpolationHandler(str, match, options);
                        value = typeof temp === "string" ? temp : "";
                    } else if (options && Object.prototype.hasOwnProperty.call(options, matchedVar)) value = "";
                    else if (skipOnVariables) {
                        value = match[0];
                        continue;
                    } else {
                        this.logger.warn(`missed to pass in variable ${matchedVar} for interpolating ${str}`);
                        value = "";
                    }
                } else if (typeof value !== "string" && !this.useRawValueToEscape) value = $673ff3dfc4a496de$var$makeString(value);
                const safeValue = todo.safeValue(value);
                str = str.replace(match[0], safeValue);
                if (skipOnVariables) {
                    todo.regex.lastIndex += value.length;
                    todo.regex.lastIndex -= match[0].length;
                } else todo.regex.lastIndex = 0;
                replaces++;
                if (replaces >= this.maxReplaces) break;
            }
        });
        return str;
    }
    nest(str, fc) {
        let options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
        let match;
        let value;
        let clonedOptions;
        function handleHasOptions(key, inheritedOptions) {
            const sep = this.nestingOptionsSeparator;
            if (key.indexOf(sep) < 0) return key;
            const c = key.split(new RegExp(`${sep}[ ]*{`));
            let optionsString = `{${c[1]}`;
            key = c[0];
            optionsString = this.interpolate(optionsString, clonedOptions);
            const matchedSingleQuotes = optionsString.match(/'/g);
            const matchedDoubleQuotes = optionsString.match(/"/g);
            if (matchedSingleQuotes && matchedSingleQuotes.length % 2 === 0 && !matchedDoubleQuotes || matchedDoubleQuotes.length % 2 !== 0) optionsString = optionsString.replace(/'/g, '"');
            try {
                clonedOptions = JSON.parse(optionsString);
                if (inheritedOptions) clonedOptions = {
                    ...inheritedOptions,
                    ...clonedOptions
                };
            } catch (e) {
                this.logger.warn(`failed parsing options string in nesting for key ${key}`, e);
                return `${key}${sep}${optionsString}`;
            }
            delete clonedOptions.defaultValue;
            return key;
        }
        while(match = this.nestingRegexp.exec(str)){
            let formatters = [];
            clonedOptions = {
                ...options
            };
            clonedOptions = clonedOptions.replace && typeof clonedOptions.replace !== "string" ? clonedOptions.replace : clonedOptions;
            clonedOptions.applyPostProcessor = false;
            delete clonedOptions.defaultValue;
            let doReduce = false;
            if (match[0].indexOf(this.formatSeparator) !== -1 && !/{.*}/.test(match[1])) {
                const r = match[1].split(this.formatSeparator).map((elem)=>elem.trim());
                match[1] = r.shift();
                formatters = r;
                doReduce = true;
            }
            value = fc(handleHasOptions.call(this, match[1].trim(), clonedOptions), clonedOptions);
            if (value && match[0] === str && typeof value !== "string") return value;
            if (typeof value !== "string") value = $673ff3dfc4a496de$var$makeString(value);
            if (!value) {
                this.logger.warn(`missed to resolve ${match[1]} for nesting ${str}`);
                value = "";
            }
            if (doReduce) value = formatters.reduce((v, f)=>this.format(v, f, options.lng, {
                    ...options,
                    interpolationkey: match[1].trim()
                }), value.trim());
            str = str.replace(match[0], value);
            this.regexp.lastIndex = 0;
        }
        return str;
    }
}
function $673ff3dfc4a496de$var$parseFormatStr(formatStr) {
    let formatName = formatStr.toLowerCase().trim();
    const formatOptions = {};
    if (formatStr.indexOf("(") > -1) {
        const p = formatStr.split("(");
        formatName = p[0].toLowerCase().trim();
        const optStr = p[1].substring(0, p[1].length - 1);
        if (formatName === "currency" && optStr.indexOf(":") < 0) {
            if (!formatOptions.currency) formatOptions.currency = optStr.trim();
        } else if (formatName === "relativetime" && optStr.indexOf(":") < 0) {
            if (!formatOptions.range) formatOptions.range = optStr.trim();
        } else {
            const opts = optStr.split(";");
            opts.forEach((opt)=>{
                if (!opt) return;
                const [key, ...rest] = opt.split(":");
                const val = rest.join(":").trim().replace(/^'+|'+$/g, "");
                if (!formatOptions[key.trim()]) formatOptions[key.trim()] = val;
                if (val === "false") formatOptions[key.trim()] = false;
                if (val === "true") formatOptions[key.trim()] = true;
                if (!isNaN(val)) formatOptions[key.trim()] = parseInt(val, 10);
            });
        }
    }
    return {
        formatName: formatName,
        formatOptions: formatOptions
    };
}
function $673ff3dfc4a496de$var$createCachedFormatter(fn) {
    const cache = {};
    return function invokeFormatter(val, lng, options) {
        const key = lng + JSON.stringify(options);
        let formatter = cache[key];
        if (!formatter) {
            formatter = fn($673ff3dfc4a496de$var$getCleanedCode(lng), options);
            cache[key] = formatter;
        }
        return formatter(val);
    };
}
class $673ff3dfc4a496de$var$Formatter {
    constructor(){
        let options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        this.logger = $673ff3dfc4a496de$var$baseLogger.create("formatter");
        this.options = options;
        this.formats = {
            number: $673ff3dfc4a496de$var$createCachedFormatter((lng, opt)=>{
                const formatter = new Intl.NumberFormat(lng, {
                    ...opt
                });
                return (val)=>formatter.format(val);
            }),
            currency: $673ff3dfc4a496de$var$createCachedFormatter((lng, opt)=>{
                const formatter = new Intl.NumberFormat(lng, {
                    ...opt,
                    style: "currency"
                });
                return (val)=>formatter.format(val);
            }),
            datetime: $673ff3dfc4a496de$var$createCachedFormatter((lng, opt)=>{
                const formatter = new Intl.DateTimeFormat(lng, {
                    ...opt
                });
                return (val)=>formatter.format(val);
            }),
            relativetime: $673ff3dfc4a496de$var$createCachedFormatter((lng, opt)=>{
                const formatter = new Intl.RelativeTimeFormat(lng, {
                    ...opt
                });
                return (val)=>formatter.format(val, opt.range || "day");
            }),
            list: $673ff3dfc4a496de$var$createCachedFormatter((lng, opt)=>{
                const formatter = new Intl.ListFormat(lng, {
                    ...opt
                });
                return (val)=>formatter.format(val);
            })
        };
        this.init(options);
    }
    init(services) {
        let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
            interpolation: {}
        };
        const iOpts = options.interpolation;
        this.formatSeparator = iOpts.formatSeparator ? iOpts.formatSeparator : iOpts.formatSeparator || ",";
    }
    add(name, fc) {
        this.formats[name.toLowerCase().trim()] = fc;
    }
    addCached(name, fc) {
        this.formats[name.toLowerCase().trim()] = $673ff3dfc4a496de$var$createCachedFormatter(fc);
    }
    format(value, format, lng) {
        let options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
        const formats = format.split(this.formatSeparator);
        const result = formats.reduce((mem, f)=>{
            const { formatName: formatName, formatOptions: formatOptions } = $673ff3dfc4a496de$var$parseFormatStr(f);
            if (this.formats[formatName]) {
                let formatted = mem;
                try {
                    const valOptions = options && options.formatParams && options.formatParams[options.interpolationkey] || {};
                    const l = valOptions.locale || valOptions.lng || options.locale || options.lng || lng;
                    formatted = this.formats[formatName](mem, l, {
                        ...formatOptions,
                        ...options,
                        ...valOptions
                    });
                } catch (error) {
                    this.logger.warn(error);
                }
                return formatted;
            } else this.logger.warn(`there was no format function for ${formatName}`);
            return mem;
        }, value);
        return result;
    }
}
function $673ff3dfc4a496de$var$removePending(q, name) {
    if (q.pending[name] !== undefined) {
        delete q.pending[name];
        q.pendingCount--;
    }
}
class $673ff3dfc4a496de$var$Connector extends $673ff3dfc4a496de$var$EventEmitter {
    constructor(backend, store, services){
        let options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
        super();
        this.backend = backend;
        this.store = store;
        this.services = services;
        this.languageUtils = services.languageUtils;
        this.options = options;
        this.logger = $673ff3dfc4a496de$var$baseLogger.create("backendConnector");
        this.waitingReads = [];
        this.maxParallelReads = options.maxParallelReads || 10;
        this.readingCalls = 0;
        this.maxRetries = options.maxRetries >= 0 ? options.maxRetries : 5;
        this.retryTimeout = options.retryTimeout >= 1 ? options.retryTimeout : 350;
        this.state = {};
        this.queue = [];
        if (this.backend && this.backend.init) this.backend.init(services, options.backend, options);
    }
    queueLoad(languages, namespaces, options, callback) {
        const toLoad = {};
        const pending = {};
        const toLoadLanguages = {};
        const toLoadNamespaces = {};
        languages.forEach((lng)=>{
            let hasAllNamespaces = true;
            namespaces.forEach((ns)=>{
                const name = `${lng}|${ns}`;
                if (!options.reload && this.store.hasResourceBundle(lng, ns)) this.state[name] = 2;
                else if (this.state[name] < 0) ;
                else if (this.state[name] === 1) {
                    if (pending[name] === undefined) pending[name] = true;
                } else {
                    this.state[name] = 1;
                    hasAllNamespaces = false;
                    if (pending[name] === undefined) pending[name] = true;
                    if (toLoad[name] === undefined) toLoad[name] = true;
                    if (toLoadNamespaces[ns] === undefined) toLoadNamespaces[ns] = true;
                }
            });
            if (!hasAllNamespaces) toLoadLanguages[lng] = true;
        });
        if (Object.keys(toLoad).length || Object.keys(pending).length) this.queue.push({
            pending: pending,
            pendingCount: Object.keys(pending).length,
            loaded: {},
            errors: [],
            callback: callback
        });
        return {
            toLoad: Object.keys(toLoad),
            pending: Object.keys(pending),
            toLoadLanguages: Object.keys(toLoadLanguages),
            toLoadNamespaces: Object.keys(toLoadNamespaces)
        };
    }
    loaded(name, err, data) {
        const s = name.split("|");
        const lng = s[0];
        const ns = s[1];
        if (err) this.emit("failedLoading", lng, ns, err);
        if (data) this.store.addResourceBundle(lng, ns, data);
        this.state[name] = err ? -1 : 2;
        const loaded = {};
        this.queue.forEach((q)=>{
            $673ff3dfc4a496de$var$pushPath(q.loaded, [
                lng
            ], ns);
            $673ff3dfc4a496de$var$removePending(q, name);
            if (err) q.errors.push(err);
            if (q.pendingCount === 0 && !q.done) {
                Object.keys(q.loaded).forEach((l)=>{
                    if (!loaded[l]) loaded[l] = {};
                    const loadedKeys = q.loaded[l];
                    if (loadedKeys.length) loadedKeys.forEach((n)=>{
                        if (loaded[l][n] === undefined) loaded[l][n] = true;
                    });
                });
                q.done = true;
                if (q.errors.length) q.callback(q.errors);
                else q.callback();
            }
        });
        this.emit("loaded", loaded);
        this.queue = this.queue.filter((q)=>!q.done);
    }
    read(lng, ns, fcName) {
        let tried = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 0;
        let wait = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : this.retryTimeout;
        let callback = arguments.length > 5 ? arguments[5] : undefined;
        if (!lng.length) return callback(null, {});
        if (this.readingCalls >= this.maxParallelReads) {
            this.waitingReads.push({
                lng: lng,
                ns: ns,
                fcName: fcName,
                tried: tried,
                wait: wait,
                callback: callback
            });
            return;
        }
        this.readingCalls++;
        const resolver = (err, data)=>{
            this.readingCalls--;
            if (this.waitingReads.length > 0) {
                const next = this.waitingReads.shift();
                this.read(next.lng, next.ns, next.fcName, next.tried, next.wait, next.callback);
            }
            if (err && data && tried < this.maxRetries) {
                setTimeout(()=>{
                    this.read.call(this, lng, ns, fcName, tried + 1, wait * 2, callback);
                }, wait);
                return;
            }
            callback(err, data);
        };
        const fc = this.backend[fcName].bind(this.backend);
        if (fc.length === 2) {
            try {
                const r = fc(lng, ns);
                if (r && typeof r.then === "function") r.then((data)=>resolver(null, data)).catch(resolver);
                else resolver(null, r);
            } catch (err) {
                resolver(err);
            }
            return;
        }
        return fc(lng, ns, resolver);
    }
    prepareLoading(languages, namespaces) {
        let options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
        let callback = arguments.length > 3 ? arguments[3] : undefined;
        if (!this.backend) {
            this.logger.warn("No backend was added via i18next.use. Will not load resources.");
            return callback && callback();
        }
        if (typeof languages === "string") languages = this.languageUtils.toResolveHierarchy(languages);
        if (typeof namespaces === "string") namespaces = [
            namespaces
        ];
        const toLoad = this.queueLoad(languages, namespaces, options, callback);
        if (!toLoad.toLoad.length) {
            if (!toLoad.pending.length) callback();
            return null;
        }
        toLoad.toLoad.forEach((name)=>{
            this.loadOne(name);
        });
    }
    load(languages, namespaces, callback) {
        this.prepareLoading(languages, namespaces, {}, callback);
    }
    reload(languages, namespaces, callback) {
        this.prepareLoading(languages, namespaces, {
            reload: true
        }, callback);
    }
    loadOne(name) {
        let prefix = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "";
        const s = name.split("|");
        const lng = s[0];
        const ns = s[1];
        this.read(lng, ns, "read", undefined, undefined, (err, data)=>{
            if (err) this.logger.warn(`${prefix}loading namespace ${ns} for language ${lng} failed`, err);
            if (!err && data) this.logger.log(`${prefix}loaded namespace ${ns} for language ${lng}`, data);
            this.loaded(name, err, data);
        });
    }
    saveMissing(languages, namespace, key, fallbackValue, isUpdate) {
        let options = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : {};
        let clb = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : ()=>{};
        if (this.services.utils && this.services.utils.hasLoadedNamespace && !this.services.utils.hasLoadedNamespace(namespace)) {
            this.logger.warn(`did not save key "${key}" as the namespace "${namespace}" was not yet loaded`, "This means something IS WRONG in your setup. You access the t function before i18next.init / i18next.loadNamespace / i18next.changeLanguage was done. Wait for the callback or Promise to resolve before accessing it!!!");
            return;
        }
        if (key === undefined || key === null || key === "") return;
        if (this.backend && this.backend.create) {
            const opts = {
                ...options,
                isUpdate: isUpdate
            };
            const fc = this.backend.create.bind(this.backend);
            if (fc.length < 6) try {
                let r;
                if (fc.length === 5) r = fc(languages, namespace, key, fallbackValue, opts);
                else r = fc(languages, namespace, key, fallbackValue);
                if (r && typeof r.then === "function") r.then((data)=>clb(null, data)).catch(clb);
                else clb(null, r);
            } catch (err) {
                clb(err);
            }
            else fc(languages, namespace, key, fallbackValue, clb, opts);
        }
        if (!languages || !languages[0]) return;
        this.store.addResource(languages[0], namespace, key, fallbackValue);
    }
}
function $673ff3dfc4a496de$var$get() {
    return {
        debug: false,
        initImmediate: true,
        ns: [
            "translation"
        ],
        defaultNS: [
            "translation"
        ],
        fallbackLng: [
            "dev"
        ],
        fallbackNS: false,
        supportedLngs: false,
        nonExplicitSupportedLngs: false,
        load: "all",
        preload: false,
        simplifyPluralSuffix: true,
        keySeparator: ".",
        nsSeparator: ":",
        pluralSeparator: "_",
        contextSeparator: "_",
        partialBundledLanguages: false,
        saveMissing: false,
        updateMissing: false,
        saveMissingTo: "fallback",
        saveMissingPlurals: true,
        missingKeyHandler: false,
        missingInterpolationHandler: false,
        postProcess: false,
        postProcessPassResolved: false,
        returnNull: false,
        returnEmptyString: true,
        returnObjects: false,
        joinArrays: false,
        returnedObjectHandler: false,
        parseMissingKeyHandler: false,
        appendNamespaceToMissingKey: false,
        appendNamespaceToCIMode: false,
        overloadTranslationOptionHandler: function handle(args) {
            let ret = {};
            if (typeof args[1] === "object") ret = args[1];
            if (typeof args[1] === "string") ret.defaultValue = args[1];
            if (typeof args[2] === "string") ret.tDescription = args[2];
            if (typeof args[2] === "object" || typeof args[3] === "object") {
                const options = args[3] || args[2];
                Object.keys(options).forEach((key)=>{
                    ret[key] = options[key];
                });
            }
            return ret;
        },
        interpolation: {
            escapeValue: true,
            format: (value, format, lng, options)=>value,
            prefix: "{{",
            suffix: "}}",
            formatSeparator: ",",
            unescapePrefix: "-",
            nestingPrefix: "$t(",
            nestingSuffix: ")",
            nestingOptionsSeparator: ",",
            maxReplaces: 1000,
            skipOnVariables: true
        }
    };
}
function $673ff3dfc4a496de$var$transformOptions(options) {
    if (typeof options.ns === "string") options.ns = [
        options.ns
    ];
    if (typeof options.fallbackLng === "string") options.fallbackLng = [
        options.fallbackLng
    ];
    if (typeof options.fallbackNS === "string") options.fallbackNS = [
        options.fallbackNS
    ];
    if (options.supportedLngs && options.supportedLngs.indexOf("cimode") < 0) options.supportedLngs = options.supportedLngs.concat([
        "cimode"
    ]);
    return options;
}
function $673ff3dfc4a496de$var$noop() {}
function $673ff3dfc4a496de$var$bindMemberFunctions(inst) {
    const mems = Object.getOwnPropertyNames(Object.getPrototypeOf(inst));
    mems.forEach((mem)=>{
        if (typeof inst[mem] === "function") inst[mem] = inst[mem].bind(inst);
    });
}
class $673ff3dfc4a496de$var$I18n extends $673ff3dfc4a496de$var$EventEmitter {
    constructor(){
        let options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        let callback = arguments.length > 1 ? arguments[1] : undefined;
        super();
        this.options = $673ff3dfc4a496de$var$transformOptions(options);
        this.services = {};
        this.logger = $673ff3dfc4a496de$var$baseLogger;
        this.modules = {
            external: []
        };
        $673ff3dfc4a496de$var$bindMemberFunctions(this);
        if (callback && !this.isInitialized && !options.isClone) {
            if (!this.options.initImmediate) {
                this.init(options, callback);
                return this;
            }
            setTimeout(()=>{
                this.init(options, callback);
            }, 0);
        }
    }
    init() {
        var _this = this;
        let options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        let callback = arguments.length > 1 ? arguments[1] : undefined;
        if (typeof options === "function") {
            callback = options;
            options = {};
        }
        if (!options.defaultNS && options.defaultNS !== false && options.ns) {
            if (typeof options.ns === "string") options.defaultNS = options.ns;
            else if (options.ns.indexOf("translation") < 0) options.defaultNS = options.ns[0];
        }
        const defOpts = $673ff3dfc4a496de$var$get();
        this.options = {
            ...defOpts,
            ...this.options,
            ...$673ff3dfc4a496de$var$transformOptions(options)
        };
        if (this.options.compatibilityAPI !== "v1") this.options.interpolation = {
            ...defOpts.interpolation,
            ...this.options.interpolation
        };
        if (options.keySeparator !== undefined) this.options.userDefinedKeySeparator = options.keySeparator;
        if (options.nsSeparator !== undefined) this.options.userDefinedNsSeparator = options.nsSeparator;
        function createClassOnDemand(ClassOrObject) {
            if (!ClassOrObject) return null;
            if (typeof ClassOrObject === "function") return new ClassOrObject();
            return ClassOrObject;
        }
        if (!this.options.isClone) {
            if (this.modules.logger) $673ff3dfc4a496de$var$baseLogger.init(createClassOnDemand(this.modules.logger), this.options);
            else $673ff3dfc4a496de$var$baseLogger.init(null, this.options);
            let formatter;
            if (this.modules.formatter) formatter = this.modules.formatter;
            else if (typeof Intl !== "undefined") formatter = $673ff3dfc4a496de$var$Formatter;
            const lu = new $673ff3dfc4a496de$var$LanguageUtil(this.options);
            this.store = new $673ff3dfc4a496de$var$ResourceStore(this.options.resources, this.options);
            const s = this.services;
            s.logger = $673ff3dfc4a496de$var$baseLogger;
            s.resourceStore = this.store;
            s.languageUtils = lu;
            s.pluralResolver = new $673ff3dfc4a496de$var$PluralResolver(lu, {
                prepend: this.options.pluralSeparator,
                compatibilityJSON: this.options.compatibilityJSON,
                simplifyPluralSuffix: this.options.simplifyPluralSuffix
            });
            if (formatter && (!this.options.interpolation.format || this.options.interpolation.format === defOpts.interpolation.format)) {
                s.formatter = createClassOnDemand(formatter);
                s.formatter.init(s, this.options);
                this.options.interpolation.format = s.formatter.format.bind(s.formatter);
            }
            s.interpolator = new $673ff3dfc4a496de$var$Interpolator(this.options);
            s.utils = {
                hasLoadedNamespace: this.hasLoadedNamespace.bind(this)
            };
            s.backendConnector = new $673ff3dfc4a496de$var$Connector(createClassOnDemand(this.modules.backend), s.resourceStore, s, this.options);
            s.backendConnector.on("*", function(event) {
                for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)args[_key - 1] = arguments[_key];
                _this.emit(event, ...args);
            });
            if (this.modules.languageDetector) {
                s.languageDetector = createClassOnDemand(this.modules.languageDetector);
                if (s.languageDetector.init) s.languageDetector.init(s, this.options.detection, this.options);
            }
            if (this.modules.i18nFormat) {
                s.i18nFormat = createClassOnDemand(this.modules.i18nFormat);
                if (s.i18nFormat.init) s.i18nFormat.init(this);
            }
            this.translator = new $673ff3dfc4a496de$var$Translator(this.services, this.options);
            this.translator.on("*", function(event) {
                for(var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++)args[_key2 - 1] = arguments[_key2];
                _this.emit(event, ...args);
            });
            this.modules.external.forEach((m)=>{
                if (m.init) m.init(this);
            });
        }
        this.format = this.options.interpolation.format;
        if (!callback) callback = $673ff3dfc4a496de$var$noop;
        if (this.options.fallbackLng && !this.services.languageDetector && !this.options.lng) {
            const codes = this.services.languageUtils.getFallbackCodes(this.options.fallbackLng);
            if (codes.length > 0 && codes[0] !== "dev") this.options.lng = codes[0];
        }
        if (!this.services.languageDetector && !this.options.lng) this.logger.warn("init: no languageDetector is used and no lng is defined");
        const storeApi = [
            "getResource",
            "hasResourceBundle",
            "getResourceBundle",
            "getDataByLanguage"
        ];
        storeApi.forEach((fcName)=>{
            this[fcName] = function() {
                return _this.store[fcName](...arguments);
            };
        });
        const storeApiChained = [
            "addResource",
            "addResources",
            "addResourceBundle",
            "removeResourceBundle"
        ];
        storeApiChained.forEach((fcName)=>{
            this[fcName] = function() {
                _this.store[fcName](...arguments);
                return _this;
            };
        });
        const deferred = $673ff3dfc4a496de$var$defer();
        const load = ()=>{
            const finish = (err, t)=>{
                if (this.isInitialized && !this.initializedStoreOnce) this.logger.warn("init: i18next is already initialized. You should call init just once!");
                this.isInitialized = true;
                if (!this.options.isClone) this.logger.log("initialized", this.options);
                this.emit("initialized", this.options);
                deferred.resolve(t);
                callback(err, t);
            };
            if (this.languages && this.options.compatibilityAPI !== "v1" && !this.isInitialized) return finish(null, this.t.bind(this));
            this.changeLanguage(this.options.lng, finish);
        };
        if (this.options.resources || !this.options.initImmediate) load();
        else setTimeout(load, 0);
        return deferred;
    }
    loadResources(language) {
        let callback = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : $673ff3dfc4a496de$var$noop;
        let usedCallback = callback;
        const usedLng = typeof language === "string" ? language : this.language;
        if (typeof language === "function") usedCallback = language;
        if (!this.options.resources || this.options.partialBundledLanguages) {
            if (usedLng && usedLng.toLowerCase() === "cimode" && (!this.options.preload || this.options.preload.length === 0)) return usedCallback();
            const toLoad = [];
            const append = (lng)=>{
                if (!lng) return;
                if (lng === "cimode") return;
                const lngs = this.services.languageUtils.toResolveHierarchy(lng);
                lngs.forEach((l)=>{
                    if (l === "cimode") return;
                    if (toLoad.indexOf(l) < 0) toLoad.push(l);
                });
            };
            if (!usedLng) {
                const fallbacks = this.services.languageUtils.getFallbackCodes(this.options.fallbackLng);
                fallbacks.forEach((l)=>append(l));
            } else append(usedLng);
            if (this.options.preload) this.options.preload.forEach((l)=>append(l));
            this.services.backendConnector.load(toLoad, this.options.ns, (e)=>{
                if (!e && !this.resolvedLanguage && this.language) this.setResolvedLanguage(this.language);
                usedCallback(e);
            });
        } else usedCallback(null);
    }
    reloadResources(lngs, ns, callback) {
        const deferred = $673ff3dfc4a496de$var$defer();
        if (!lngs) lngs = this.languages;
        if (!ns) ns = this.options.ns;
        if (!callback) callback = $673ff3dfc4a496de$var$noop;
        this.services.backendConnector.reload(lngs, ns, (err)=>{
            deferred.resolve();
            callback(err);
        });
        return deferred;
    }
    use(module) {
        if (!module) throw new Error("You are passing an undefined module! Please check the object you are passing to i18next.use()");
        if (!module.type) throw new Error("You are passing a wrong module! Please check the object you are passing to i18next.use()");
        if (module.type === "backend") this.modules.backend = module;
        if (module.type === "logger" || module.log && module.warn && module.error) this.modules.logger = module;
        if (module.type === "languageDetector") this.modules.languageDetector = module;
        if (module.type === "i18nFormat") this.modules.i18nFormat = module;
        if (module.type === "postProcessor") $673ff3dfc4a496de$var$postProcessor.addPostProcessor(module);
        if (module.type === "formatter") this.modules.formatter = module;
        if (module.type === "3rdParty") this.modules.external.push(module);
        return this;
    }
    setResolvedLanguage(l) {
        if (!l || !this.languages) return;
        if ([
            "cimode",
            "dev"
        ].indexOf(l) > -1) return;
        for(let li = 0; li < this.languages.length; li++){
            const lngInLngs = this.languages[li];
            if ([
                "cimode",
                "dev"
            ].indexOf(lngInLngs) > -1) continue;
            if (this.store.hasLanguageSomeTranslations(lngInLngs)) {
                this.resolvedLanguage = lngInLngs;
                break;
            }
        }
    }
    changeLanguage(lng, callback) {
        var _this2 = this;
        this.isLanguageChangingTo = lng;
        const deferred = $673ff3dfc4a496de$var$defer();
        this.emit("languageChanging", lng);
        const setLngProps = (l)=>{
            this.language = l;
            this.languages = this.services.languageUtils.toResolveHierarchy(l);
            this.resolvedLanguage = undefined;
            this.setResolvedLanguage(l);
        };
        const done = (err, l)=>{
            if (l) {
                setLngProps(l);
                this.translator.changeLanguage(l);
                this.isLanguageChangingTo = undefined;
                this.emit("languageChanged", l);
                this.logger.log("languageChanged", l);
            } else this.isLanguageChangingTo = undefined;
            deferred.resolve(function() {
                return _this2.t(...arguments);
            });
            if (callback) callback(err, function() {
                return _this2.t(...arguments);
            });
        };
        const setLng = (lngs)=>{
            if (!lng && !lngs && this.services.languageDetector) lngs = [];
            const l = typeof lngs === "string" ? lngs : this.services.languageUtils.getBestMatchFromCodes(lngs);
            if (l) {
                if (!this.language) setLngProps(l);
                if (!this.translator.language) this.translator.changeLanguage(l);
                if (this.services.languageDetector && this.services.languageDetector.cacheUserLanguage) this.services.languageDetector.cacheUserLanguage(l);
            }
            this.loadResources(l, (err)=>{
                done(err, l);
            });
        };
        if (!lng && this.services.languageDetector && !this.services.languageDetector.async) setLng(this.services.languageDetector.detect());
        else if (!lng && this.services.languageDetector && this.services.languageDetector.async) {
            if (this.services.languageDetector.detect.length === 0) this.services.languageDetector.detect().then(setLng);
            else this.services.languageDetector.detect(setLng);
        } else setLng(lng);
        return deferred;
    }
    getFixedT(lng, ns, keyPrefix) {
        var _this3 = this;
        const fixedT = function(key, opts) {
            let options;
            if (typeof opts !== "object") {
                for(var _len3 = arguments.length, rest = new Array(_len3 > 2 ? _len3 - 2 : 0), _key3 = 2; _key3 < _len3; _key3++)rest[_key3 - 2] = arguments[_key3];
                options = _this3.options.overloadTranslationOptionHandler([
                    key,
                    opts
                ].concat(rest));
            } else options = {
                ...opts
            };
            options.lng = options.lng || fixedT.lng;
            options.lngs = options.lngs || fixedT.lngs;
            options.ns = options.ns || fixedT.ns;
            options.keyPrefix = options.keyPrefix || keyPrefix || fixedT.keyPrefix;
            const keySeparator = _this3.options.keySeparator || ".";
            let resultKey;
            if (options.keyPrefix && Array.isArray(key)) resultKey = key.map((k)=>`${options.keyPrefix}${keySeparator}${k}`);
            else resultKey = options.keyPrefix ? `${options.keyPrefix}${keySeparator}${key}` : key;
            return _this3.t(resultKey, options);
        };
        if (typeof lng === "string") fixedT.lng = lng;
        else fixedT.lngs = lng;
        fixedT.ns = ns;
        fixedT.keyPrefix = keyPrefix;
        return fixedT;
    }
    t() {
        return this.translator && this.translator.translate(...arguments);
    }
    exists() {
        return this.translator && this.translator.exists(...arguments);
    }
    setDefaultNamespace(ns) {
        this.options.defaultNS = ns;
    }
    hasLoadedNamespace(ns) {
        let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        if (!this.isInitialized) {
            this.logger.warn("hasLoadedNamespace: i18next was not initialized", this.languages);
            return false;
        }
        if (!this.languages || !this.languages.length) {
            this.logger.warn("hasLoadedNamespace: i18n.languages were undefined or empty", this.languages);
            return false;
        }
        const lng = options.lng || this.resolvedLanguage || this.languages[0];
        const fallbackLng = this.options ? this.options.fallbackLng : false;
        const lastLng = this.languages[this.languages.length - 1];
        if (lng.toLowerCase() === "cimode") return true;
        const loadNotPending = (l, n)=>{
            const loadState = this.services.backendConnector.state[`${l}|${n}`];
            return loadState === -1 || loadState === 2;
        };
        if (options.precheck) {
            const preResult = options.precheck(this, loadNotPending);
            if (preResult !== undefined) return preResult;
        }
        if (this.hasResourceBundle(lng, ns)) return true;
        if (!this.services.backendConnector.backend || this.options.resources && !this.options.partialBundledLanguages) return true;
        if (loadNotPending(lng, ns) && (!fallbackLng || loadNotPending(lastLng, ns))) return true;
        return false;
    }
    loadNamespaces(ns, callback) {
        const deferred = $673ff3dfc4a496de$var$defer();
        if (!this.options.ns) {
            if (callback) callback();
            return Promise.resolve();
        }
        if (typeof ns === "string") ns = [
            ns
        ];
        ns.forEach((n)=>{
            if (this.options.ns.indexOf(n) < 0) this.options.ns.push(n);
        });
        this.loadResources((err)=>{
            deferred.resolve();
            if (callback) callback(err);
        });
        return deferred;
    }
    loadLanguages(lngs, callback) {
        const deferred = $673ff3dfc4a496de$var$defer();
        if (typeof lngs === "string") lngs = [
            lngs
        ];
        const preloaded = this.options.preload || [];
        const newLngs = lngs.filter((lng)=>preloaded.indexOf(lng) < 0);
        if (!newLngs.length) {
            if (callback) callback();
            return Promise.resolve();
        }
        this.options.preload = preloaded.concat(newLngs);
        this.loadResources((err)=>{
            deferred.resolve();
            if (callback) callback(err);
        });
        return deferred;
    }
    dir(lng) {
        if (!lng) lng = this.resolvedLanguage || (this.languages && this.languages.length > 0 ? this.languages[0] : this.language);
        if (!lng) return "rtl";
        const rtlLngs = [
            "ar",
            "shu",
            "sqr",
            "ssh",
            "xaa",
            "yhd",
            "yud",
            "aao",
            "abh",
            "abv",
            "acm",
            "acq",
            "acw",
            "acx",
            "acy",
            "adf",
            "ads",
            "aeb",
            "aec",
            "afb",
            "ajp",
            "apc",
            "apd",
            "arb",
            "arq",
            "ars",
            "ary",
            "arz",
            "auz",
            "avl",
            "ayh",
            "ayl",
            "ayn",
            "ayp",
            "bbz",
            "pga",
            "he",
            "iw",
            "ps",
            "pbt",
            "pbu",
            "pst",
            "prp",
            "prd",
            "ug",
            "ur",
            "ydd",
            "yds",
            "yih",
            "ji",
            "yi",
            "hbo",
            "men",
            "xmn",
            "fa",
            "jpr",
            "peo",
            "pes",
            "prs",
            "dv",
            "sam",
            "ckb"
        ];
        const languageUtils = this.services && this.services.languageUtils || new $673ff3dfc4a496de$var$LanguageUtil($673ff3dfc4a496de$var$get());
        return rtlLngs.indexOf(languageUtils.getLanguagePartFromCode(lng)) > -1 || lng.toLowerCase().indexOf("-arab") > 1 ? "rtl" : "ltr";
    }
    static createInstance() {
        let options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        let callback = arguments.length > 1 ? arguments[1] : undefined;
        return new $673ff3dfc4a496de$var$I18n(options, callback);
    }
    cloneInstance() {
        let options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        let callback = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : $673ff3dfc4a496de$var$noop;
        const forkResourceStore = options.forkResourceStore;
        if (forkResourceStore) delete options.forkResourceStore;
        const mergedOptions = {
            ...this.options,
            ...options,
            isClone: true
        };
        const clone = new $673ff3dfc4a496de$var$I18n(mergedOptions);
        if (options.debug !== undefined || options.prefix !== undefined) clone.logger = clone.logger.clone(options);
        const membersToCopy = [
            "store",
            "services",
            "language"
        ];
        membersToCopy.forEach((m)=>{
            clone[m] = this[m];
        });
        clone.services = {
            ...this.services
        };
        clone.services.utils = {
            hasLoadedNamespace: clone.hasLoadedNamespace.bind(clone)
        };
        if (forkResourceStore) {
            clone.store = new $673ff3dfc4a496de$var$ResourceStore(this.store.data, mergedOptions);
            clone.services.resourceStore = clone.store;
        }
        clone.translator = new $673ff3dfc4a496de$var$Translator(clone.services, mergedOptions);
        clone.translator.on("*", function(event) {
            for(var _len4 = arguments.length, args = new Array(_len4 > 1 ? _len4 - 1 : 0), _key4 = 1; _key4 < _len4; _key4++)args[_key4 - 1] = arguments[_key4];
            clone.emit(event, ...args);
        });
        clone.init(mergedOptions, callback);
        clone.translator.options = mergedOptions;
        clone.translator.backendConnector.services.utils = {
            hasLoadedNamespace: clone.hasLoadedNamespace.bind(clone)
        };
        return clone;
    }
    toJSON() {
        return {
            options: this.options,
            store: this.store,
            language: this.language,
            languages: this.languages,
            resolvedLanguage: this.resolvedLanguage
        };
    }
}
const $673ff3dfc4a496de$export$2e2bcd8739ae039 = $673ff3dfc4a496de$var$I18n.createInstance();
$673ff3dfc4a496de$export$2e2bcd8739ae039.createInstance = $673ff3dfc4a496de$var$I18n.createInstance;
const $673ff3dfc4a496de$export$99152e8d49ca4e7d = $673ff3dfc4a496de$export$2e2bcd8739ae039.createInstance;
const $673ff3dfc4a496de$export$147ec2801e896265 = $673ff3dfc4a496de$export$2e2bcd8739ae039.dir;
const $673ff3dfc4a496de$export$2cd8252107eb640b = $673ff3dfc4a496de$export$2e2bcd8739ae039.init;
const $673ff3dfc4a496de$export$d3d08d944062d7e = $673ff3dfc4a496de$export$2e2bcd8739ae039.loadResources;
const $673ff3dfc4a496de$export$a5d9bf5d83fcab09 = $673ff3dfc4a496de$export$2e2bcd8739ae039.reloadResources;
const $673ff3dfc4a496de$export$1f96ae73734a86cc = $673ff3dfc4a496de$export$2e2bcd8739ae039.use;
const $673ff3dfc4a496de$export$61465194746e7fd2 = $673ff3dfc4a496de$export$2e2bcd8739ae039.changeLanguage;
const $673ff3dfc4a496de$export$f90d180fc7da3b3b = $673ff3dfc4a496de$export$2e2bcd8739ae039.getFixedT;
const $673ff3dfc4a496de$export$625550452a3fa3ec = $673ff3dfc4a496de$export$2e2bcd8739ae039.t;
const $673ff3dfc4a496de$export$f7e9f41ea797a17 = $673ff3dfc4a496de$export$2e2bcd8739ae039.exists;
const $673ff3dfc4a496de$export$2b4b218e406d2d00 = $673ff3dfc4a496de$export$2e2bcd8739ae039.setDefaultNamespace;
const $673ff3dfc4a496de$export$93d9ee97c1ad3f31 = $673ff3dfc4a496de$export$2e2bcd8739ae039.hasLoadedNamespace;
const $673ff3dfc4a496de$export$83be934b53fff43b = $673ff3dfc4a496de$export$2e2bcd8739ae039.loadNamespaces;
const $673ff3dfc4a496de$export$8cd7e7a54fa865bc = $673ff3dfc4a496de$export$2e2bcd8739ae039.loadLanguages;


var $9ad33fbf770c55a1$export$9696fcf1798e1cb5;
(function(ApiErrorTypes) {
    ApiErrorTypes["AuthError"] = "AuthError";
    ApiErrorTypes["NotFound"] = "NotFound";
    ApiErrorTypes["ClientError"] = "ClientError";
    ApiErrorTypes["ServerError"] = "ServerError";
    ApiErrorTypes["ConnectionError"] = "ConnectionError";
    ApiErrorTypes["TooManyRequestsError"] = "TooManyRequestsError";
    ApiErrorTypes["PermissionError"] = "PermissionError";
})($9ad33fbf770c55a1$export$9696fcf1798e1cb5 || ($9ad33fbf770c55a1$export$9696fcf1798e1cb5 = {}));
class $9ad33fbf770c55a1$export$f2e832acab1bdd79 extends Error {
    constructor(type, data){
        super(`ApiError: ${type}`);
        this.type = type;
        this.data = data;
    }
}


let $26572c2694c8d6b7$var$tokenIsRefreshing = false;
async function $26572c2694c8d6b7$var$checkRefresh() {
    return new Promise((resolve)=>{
        let retries = 0;
        const fn = ()=>setTimeout(()=>{
                if (!$26572c2694c8d6b7$var$tokenIsRefreshing) resolve(retries);
                else if (retries >= 5) {
                    $26572c2694c8d6b7$var$tokenIsRefreshing = false;
                    resolve(retries);
                } else {
                    retries++;
                    fn();
                }
            }, 800);
        fn();
    });
}
async function $26572c2694c8d6b7$export$8dca5393d4ca3ac8(response) {
    if (response.data.code === "token_expired") {
        if (response.config.url === this.config.refreshURL && response.status !== 200) throw new (0, $9ad33fbf770c55a1$export$f2e832acab1bdd79)((0, $9ad33fbf770c55a1$export$9696fcf1798e1cb5).AuthError, {
            code: "common",
            message: "refresh token error"
        });
        let headers;
        let authKey = await this.getAuthKey();
        if (authKey) headers = {
            authorization: await this.getAuthKey()
        };
        if ($26572c2694c8d6b7$var$tokenIsRefreshing) {
            await $26572c2694c8d6b7$var$checkRefresh();
            authKey = await this.getAuthKey();
            headers = authKey ? {
                authorization: authKey
            } : undefined;
            return this.api.request({
                ...response.config,
                headers: headers
            });
        }
        $26572c2694c8d6b7$var$tokenIsRefreshing = true;
        const refreshResponse = await this.api.post(this.config.refreshURL, null, {
            headers: headers
        });
        if (refreshResponse.status === 200) {
            const authorizationKey = refreshResponse.headers.authorization;
            await this.setAuthKey(authorizationKey); // set token anyway so if we depend on cookies will remove current token from storage
            if (authorizationKey) headers = {
                authorization: authorizationKey
            };
            else headers = undefined;
            $26572c2694c8d6b7$var$tokenIsRefreshing = false;
            return this.api.request({
                ...response.config,
                headers: headers
            });
        }
        $26572c2694c8d6b7$var$tokenIsRefreshing = false;
    }
    return response;
}
async function $26572c2694c8d6b7$export$590164b364696c41(request) {
    if ($26572c2694c8d6b7$var$tokenIsRefreshing && request.url !== this.config.refreshURL) await $26572c2694c8d6b7$var$checkRefresh();
    return request;
}


let $dacbeb7af41d49ec$var$runAssertFns = true;
function $dacbeb7af41d49ec$export$940a7873bb071df8(options) {
    $dacbeb7af41d49ec$var$runAssertFns = options.runAssertFns;
}
function $dacbeb7af41d49ec$export$a7a9523472993e97(value, msg = `Assertion failed`) {
    if (value !== true) throw new Error(msg);
}
function $dacbeb7af41d49ec$export$804de46662e4ac95(value) {}
function $dacbeb7af41d49ec$export$471f926058ed234c(value, msg = `Assertion failed`) {
    if ($dacbeb7af41d49ec$var$runAssertFns) {
        if (value() !== true) throw new Error(msg);
    }
}
function $dacbeb7af41d49ec$export$d0c8ecbd4ed8940c(value, msg = `Expected array but got ${value}`) {
    if (!Array.isArray(value)) throw new Error(msg);
}
function $dacbeb7af41d49ec$export$b5478a1684008f71(value, msg = `Expected object but got ${value}`) {
    if (typeof value !== "object" || value === null) throw new Error(msg);
}
function $dacbeb7af41d49ec$export$eb1f29ffd28794ef(value, msg = `Expected string but got ${value}`) {
    if (typeof value !== "string") throw new Error(msg);
}
function $dacbeb7af41d49ec$export$43cf4c0b46aaaf19(value, msg = `Expected number but got ${value}`) {
    if (typeof value !== "number") throw new Error(msg);
}
function $dacbeb7af41d49ec$export$3524ac7216468ee2(value, msg = `Expected boolean but got ${value}`) {
    if (typeof value !== "boolean") throw new Error(msg);
}
function $dacbeb7af41d49ec$export$9219f6caf3e9368b(value, msg = `Expected non undefined value`) {
    if (value === undefined) throw new Error(msg);
}
function $dacbeb7af41d49ec$export$ed54e7c357841b2d(value, msg = `Expected non null value`) {
    if (value === null) throw new Error(msg);
}
function $dacbeb7af41d49ec$export$7c574cd5d840bb43(value, msg = `Expected non nullable value`) {
    if (value === undefined || value === null) throw new Error(msg);
}
function $dacbeb7af41d49ec$export$16841e8ae6ecdfed(value, msg = `Expected non undefined value`) {
    if (value === undefined) throw new Error(msg);
    return value;
}
function $dacbeb7af41d49ec$export$c9fe13db74ed5944(value, msg = `Expected non null value`) {
    if (value === null) throw new Error(msg);
    return value;
}
function $dacbeb7af41d49ec$export$26128561c93f5847(value, msg = `Expected non nullable value`) {
    if (value === null || value === undefined) throw new Error(msg);
    return value;
}
function $dacbeb7af41d49ec$export$b3e22bcfd64c1022(msg = `Never call`) {
    throw new Error(msg);
}
function $dacbeb7af41d49ec$export$f8c76b23bd3a3edb(value, msg = `Never possible value: ${JSON.stringify(value)}`) {
    throw new Error(msg);
}
function $dacbeb7af41d49ec$export$ff48c1682738baf1(value) {}
function $dacbeb7af41d49ec$export$f2db7d5238e1d23f(value) {
    return value;
}
function $dacbeb7af41d49ec$export$6554612db691658e(value) {
    return value;
}
function $dacbeb7af41d49ec$export$f8b8b9ce72e9ccbf(val) {
    return val;
}


var $b302555736d21bd7$exports = {};

$b302555736d21bd7$exports = (parcelRequire("7we3r"));



function $0f5438aadff0af94$export$a04c6c6965dd4709(arr, fn) {
    const newArr = [];
    for (const el of arr){
        const r = fn(el);
        if (r !== undefined) newArr.push(r);
    }
    return newArr;
}
function $0f5438aadff0af94$export$259b4dd69e654a7a(obj) {
    return Object.keys(obj);
}
function $0f5438aadff0af94$export$d02631cccf789723(from, to, step = 1) {
    const arr = [];
    for(let i = from; i <= to; i += step)arr.push(i);
    if (from <= to && arr[arr.length - 1] !== to) arr.push(to);
    return arr;
}
function $0f5438aadff0af94$export$5ed2d08173f8a798(date) {
    date.setHours(0);
    date.setMinutes(0);
    date.setSeconds(0);
    date.setMilliseconds(0);
    return date;
}
function $0f5438aadff0af94$export$87779c0c97a6c3df(obj, partial) {
    const newObj = {
        ...obj
    };
    for(const key in partial){
        const k = key;
        const val = partial[key];
        newObj[k] = $0f5438aadff0af94$export$a6cdc56e425d0d0a(val) && !(val instanceof Date) ? $0f5438aadff0af94$export$87779c0c97a6c3df((0, $dacbeb7af41d49ec$export$f2db7d5238e1d23f)(obj[k]), val) : val;
    }
    return newObj;
}
function $0f5438aadff0af94$export$58aefef1ff9edd34(obj, fn) {
    const newObj = {};
    for(const key in obj)newObj[key] = fn(key, obj[key]);
    return newObj;
}
function $0f5438aadff0af94$export$357523c63a2253b9(obj, keys) {
    const newObj = {};
    for(const key in obj)if (keys.indexOf(key) > -1) newObj[key] = obj[key];
    return newObj;
}
function $0f5438aadff0af94$export$30a06c8d3562193f(obj, keys) {
    const newObj = {};
    for(const key in obj)if (keys.indexOf(key) === -1) newObj[key] = obj[key];
    return newObj;
}
function $0f5438aadff0af94$export$a6cdc56e425d0d0a(obj) {
    return typeof obj === "object" && obj !== null;
}
const $0f5438aadff0af94$export$b70dcce1c70696bf = (str)=>str.replace(/([-_][a-z])/g, (group)=>group.toUpperCase().replace("-", "").replace("_", ""));
const $0f5438aadff0af94$export$1391212d75b2ee65 = (ms)=>new Promise((resolve)=>setTimeout(resolve, ms));



class $447a9f947dafe1f5$export$bf71da7aebe9ddc1 {
    async setAuthKey(authorizationKey) {
        this.authorizationKey = authorizationKey;
        return await Promise.resolve(true);
    }
    async getAuthKey() {
        return await Promise.resolve(this.authorizationKey);
    }
    async makeRequest(config) {
        let result;
        try {
            result = await this.request(config);
        } catch (err) {
            throw new (0, $9ad33fbf770c55a1$export$f2e832acab1bdd79)((0, $9ad33fbf770c55a1$export$9696fcf1798e1cb5).ConnectionError, err);
        }
        const { data: data, status: status, headers: headers } = result;
        if (status >= 200 && status < 300) {
            if (headers["authorization"] !== undefined) this.setAuthKey(headers["authorization"]);
            return data;
        }
        const error = data;
        if (status === 401) throw new (0, $9ad33fbf770c55a1$export$f2e832acab1bdd79)((0, $9ad33fbf770c55a1$export$9696fcf1798e1cb5).AuthError, error);
        if (status === 403) throw new (0, $9ad33fbf770c55a1$export$f2e832acab1bdd79)((0, $9ad33fbf770c55a1$export$9696fcf1798e1cb5).PermissionError, error);
        if (status === 404) throw new (0, $9ad33fbf770c55a1$export$f2e832acab1bdd79)((0, $9ad33fbf770c55a1$export$9696fcf1798e1cb5).NotFound, error);
        if (status === 429) throw new (0, $9ad33fbf770c55a1$export$f2e832acab1bdd79)((0, $9ad33fbf770c55a1$export$9696fcf1798e1cb5).TooManyRequestsError, error);
        if (status >= 400 && status < 500) throw new (0, $9ad33fbf770c55a1$export$f2e832acab1bdd79)((0, $9ad33fbf770c55a1$export$9696fcf1798e1cb5).ClientError, error);
        if (status >= 500) throw new (0, $9ad33fbf770c55a1$export$f2e832acab1bdd79)((0, $9ad33fbf770c55a1$export$9696fcf1798e1cb5).ServerError, error);
        throw new (0, $9ad33fbf770c55a1$export$f2e832acab1bdd79)((0, $9ad33fbf770c55a1$export$9696fcf1798e1cb5).ConnectionError, error);
    }
}



class $42168642299f176a$export$159faee26ec5badf extends (0, $447a9f947dafe1f5$export$bf71da7aebe9ddc1) {
    constructor(config){
        var _a, _b;
        super();
        const customHeaders = config.lang ? {
            "x-lang-code": config.lang
        } : undefined;
        const axiosConfig = {
            baseURL: config.url,
            timeout: config.timeout,
            validateStatus: (status)=>status >= 200 && status < 600,
            headers: {
                "content-type": "application/json",
                ...customHeaders
            }
        };
        if (config.withCredentials) axiosConfig.withCredentials = true;
        this.api = (0, (/*@__PURE__*/$parcel$interopDefault($b302555736d21bd7$exports))).create(axiosConfig);
        this.config = config;
        // Add interceptors
        this.addDefaultInterceptors();
        (_a = config.requestInterceptors) === null || _a === void 0 || _a.forEach((interceptor)=>{
            this.api.interceptors.request.use(interceptor.bind(this));
        });
        (_b = config.responseInterceptors) === null || _b === void 0 || _b.forEach((interceptor)=>{
            this.api.interceptors.response.use(interceptor.bind(this));
        });
    }
    addDefaultInterceptors() {
        this.api.interceptors.request.use((0, $26572c2694c8d6b7$export$590164b364696c41).bind(this));
        this.api.interceptors.response.use((0, $26572c2694c8d6b7$export$8dca5393d4ca3ac8).bind(this));
    }
    async normalizeResponse(method, url, response) {
        var _a;
        const res = await response;
        const d = res.data;
        const status = d.status === "fail" && res.status < 400 ? 400 : res.status;
        const data = d instanceof Blob ? d : d.status === "fail" ? d : (_a = d.data) !== null && _a !== void 0 ? _a : null;
        const normResponse = {
            status: status,
            data: data,
            headers: res.headers
        };
        return normResponse;
    }
    normalizeErrors(errors) {
        // eslint-disable-next-line @typescript-eslint/no-unsafe-call
        if ((0, $0f5438aadff0af94$export$a6cdc56e425d0d0a)(errors)) {
            if (Array.isArray(errors)) return {
                code: "common",
                // eslint-disable-next-line
                message: errors[0].message
            };
            else return errors;
        }
        throw (0, $dacbeb7af41d49ec$export$b3e22bcfd64c1022)("Unexpected error type");
    }
    /**
     * Send an API call
     */ async request(axiosConfig) {
        var _a, _b;
        const authToken = await this.getAuthKey();
        const { authorization: authorization, ...headers } = (_a = axiosConfig.headers) !== null && _a !== void 0 ? _a : {};
        if (authToken) headers.authorization = authToken;
        return await this.normalizeResponse((_b = axiosConfig.method) !== null && _b !== void 0 ? _b : "get", (0, $dacbeb7af41d49ec$export$16841e8ae6ecdfed)(axiosConfig.url), this.api.request({
            ...axiosConfig,
            headers: headers
        }));
    }
}







var $4f362 = parcelRequire("4f362");

var $acw62 = parcelRequire("acw62");

var $0f5d242bb09a95af$var$__decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
class $0f5d242bb09a95af$export$f120933b6bd85d2d {
    constructor(){
        this.status = "pending";
        this.isLoading = false;
        this.promise = undefined;
        this.error = undefined;
        (0, $4f362.makeObservable)(this);
    }
}
$0f5d242bb09a95af$var$__decorate([
    (0, $4f362.observable)
], $0f5d242bb09a95af$export$f120933b6bd85d2d.prototype, "isLoading", void 0);
$0f5d242bb09a95af$var$__decorate([
    (0, $4f362.observable)
], $0f5d242bb09a95af$export$f120933b6bd85d2d.prototype, "error", void 0);
function $0f5d242bb09a95af$export$53dbb6361647310d(context) {
    function useStore() {
        return $acw62.useContext(context);
    }
    function useQuery(cb, config) {
        if (config) {
            if ((config === null || config === void 0 ? void 0 : config.hasFallback) === undefined) config.hasFallback = true;
        } else // eslint-disable-next-line no-param-reassign
        config = {
            hasFallback: true
        };
        const [result, fn] = create(cb, config);
        if (result.status === "pending") fn();
        return result;
    }
    function useDelayedQuery(cb, config) {
        const [query, fn] = create(cb, config);
        const enableQuery = ()=>{
            fn();
        };
        return {
            query: query,
            enableQuery: enableQuery
        };
    }
    function useSuspenseQuery(cb, config) {
        const [result, fn] = create(cb, config);
        if (result.status === "pending") throw fn();
        return result;
    }
    function useMutation(cb, config) {
        return create(cb, config);
    }
    function create(cb, config) {
        var _a;
        // eslint-disable-next-line react-hooks/rules-of-hooks
        const result = $acw62.useRef(new $0f5d242bb09a95af$export$f120933b6bd85d2d()).current;
        const fn = (0, $4f362.action)((params)=>{
            setDefaultState();
            result.reload = ()=>fn(params);
            const promise = cb(params);
            result.promise = promise;
            return promise.then((0, $4f362.action)((data)=>{
                var _a;
                result.status = "data";
                (_a = config === null || config === void 0 ? void 0 : config.onSuccess) === null || _a === void 0 || _a.call(config, data);
                result.isLoading = false;
            })).catch((0, $4f362.action)((err)=>{
                var _a, _b;
                result.status = "error";
                result.error = err;
                if ((_a = config === null || config === void 0 ? void 0 : config.filterError) === null || _a === void 0 ? void 0 : _a.find((error)=>error === err.type)) (_b = config === null || config === void 0 ? void 0 : config.onError) === null || _b === void 0 || _b.call(config, err);
                result.isLoading = false;
            }));
            function setDefaultState() {
                result.status = "loading";
                result.isLoading = true;
                result.error = undefined;
            }
        });
        if (result.error !== undefined) {
            if (result.error instanceof (0, $9ad33fbf770c55a1$export$f2e832acab1bdd79) && (config === null || config === void 0 ? void 0 : config.hasFallback)) result.error.hasFallback = true;
            if (!(result.error instanceof (0, $9ad33fbf770c55a1$export$f2e832acab1bdd79)) || !((_a = config === null || config === void 0 ? void 0 : config.filterError) === null || _a === void 0 ? void 0 : _a.includes(result.error.type))) throw result.error;
        }
        return [
            result,
            fn
        ];
    }
    return {
        MSTProvider: context.Provider,
        useQuery: useQuery,
        useDelayedQuery: useDelayedQuery,
        useStore: useStore,
        useMutation: useMutation,
        useSuspenseQuery: useSuspenseQuery,
        RequestResult: $0f5d242bb09a95af$export$f120933b6bd85d2d
    };
}





var $i56po = parcelRequire("i56po");
const $ba1494607b43dcd2$export$39f36b94c3034e99 = (self)=>{
    return {
        actions: {
            request: (method, url, data, options = {})=>{
                var _a;
                let sendData = data;
                if (((_a = options === null || options === void 0 ? void 0 : options.headers) === null || _a === void 0 ? void 0 : _a["Content-Type"]) === "multipart/form-data") {
                    const formData = new FormData();
                    for(const key in data)formData.append(key, (0, $i56po.cast)(data[key]));
                    sendData = formData;
                }
                return (0, $i56po.getEnv)(self).api.makeRequest({
                    method: method,
                    url: url,
                    data: sendData,
                    ...options
                });
            },
            rawRequest: (method, url, data)=>{
                return (0, $i56po.getEnv)(self).rawApi.request({
                    method: method,
                    url: url,
                    data: data
                });
            }
        }
    };
};





/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * @fileoverview Firebase constants.  Some of these (@defines) can be overridden at compile-time.
 */ 
var $hPtJY = parcelRequire("hPtJY");
const $c38e0f42709c826a$export$588c7fdda06fbb0a = {
    /**
     * @define {boolean} Whether this is the client Node.js SDK.
     */ NODE_CLIENT: false,
    /**
     * @define {boolean} Whether this is the Admin Node.js SDK.
     */ NODE_ADMIN: false,
    /**
     * Firebase SDK Version
     */ SDK_VERSION: "${JSCORE_VERSION}"
};
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Throws an error if the provided assertion is falsy
 */ const $c38e0f42709c826a$export$a7a9523472993e97 = function(assertion, message) {
    if (!assertion) throw $c38e0f42709c826a$export$a39cad550e7ab28a(message);
};
/**
 * Returns an Error object suitable for throwing.
 */ const $c38e0f42709c826a$export$a39cad550e7ab28a = function(message) {
    return new Error("Firebase Database (" + $c38e0f42709c826a$export$588c7fdda06fbb0a.SDK_VERSION + ") INTERNAL ASSERT FAILED: " + message);
};
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $c38e0f42709c826a$var$stringToByteArray$1 = function(str) {
    // TODO(user): Use native implementations if/when available
    const out = [];
    let p = 0;
    for(let i = 0; i < str.length; i++){
        let c = str.charCodeAt(i);
        if (c < 128) out[p++] = c;
        else if (c < 2048) {
            out[p++] = c >> 6 | 192;
            out[p++] = c & 63 | 128;
        } else if ((c & 0xfc00) === 0xd800 && i + 1 < str.length && (str.charCodeAt(i + 1) & 0xfc00) === 0xdc00) {
            // Surrogate Pair
            c = 0x10000 + ((c & 0x03ff) << 10) + (str.charCodeAt(++i) & 0x03ff);
            out[p++] = c >> 18 | 240;
            out[p++] = c >> 12 & 63 | 128;
            out[p++] = c >> 6 & 63 | 128;
            out[p++] = c & 63 | 128;
        } else {
            out[p++] = c >> 12 | 224;
            out[p++] = c >> 6 & 63 | 128;
            out[p++] = c & 63 | 128;
        }
    }
    return out;
};
/**
 * Turns an array of numbers into the string given by the concatenation of the
 * characters to which the numbers correspond.
 * @param bytes Array of numbers representing characters.
 * @return Stringification of the array.
 */ const $c38e0f42709c826a$var$byteArrayToString = function(bytes) {
    // TODO(user): Use native implementations if/when available
    const out = [];
    let pos = 0, c = 0;
    while(pos < bytes.length){
        const c1 = bytes[pos++];
        if (c1 < 128) out[c++] = String.fromCharCode(c1);
        else if (c1 > 191 && c1 < 224) {
            const c2 = bytes[pos++];
            out[c++] = String.fromCharCode((c1 & 31) << 6 | c2 & 63);
        } else if (c1 > 239 && c1 < 365) {
            // Surrogate Pair
            const c2 = bytes[pos++];
            const c3 = bytes[pos++];
            const c4 = bytes[pos++];
            const u = ((c1 & 7) << 18 | (c2 & 63) << 12 | (c3 & 63) << 6 | c4 & 63) - 0x10000;
            out[c++] = String.fromCharCode(0xd800 + (u >> 10));
            out[c++] = String.fromCharCode(0xdc00 + (u & 1023));
        } else {
            const c2 = bytes[pos++];
            const c3 = bytes[pos++];
            out[c++] = String.fromCharCode((c1 & 15) << 12 | (c2 & 63) << 6 | c3 & 63);
        }
    }
    return out.join("");
};
// We define it as an object literal instead of a class because a class compiled down to es5 can't
// be treeshaked. https://github.com/rollup/rollup/issues/1691
// Static lookup maps, lazily populated by init_()
const $c38e0f42709c826a$export$b3b2de96497acc47 = {
    /**
     * Maps bytes to characters.
     */ byteToCharMap_: null,
    /**
     * Maps characters to bytes.
     */ charToByteMap_: null,
    /**
     * Maps bytes to websafe characters.
     * @private
     */ byteToCharMapWebSafe_: null,
    /**
     * Maps websafe characters to bytes.
     * @private
     */ charToByteMapWebSafe_: null,
    /**
     * Our default alphabet, shared between
     * ENCODED_VALS and ENCODED_VALS_WEBSAFE
     */ ENCODED_VALS_BASE: "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789",
    /**
     * Our default alphabet. Value 64 (=) is special; it means "nothing."
     */ get ENCODED_VALS () {
        return this.ENCODED_VALS_BASE + "+/=";
    },
    /**
     * Our websafe alphabet.
     */ get ENCODED_VALS_WEBSAFE () {
        return this.ENCODED_VALS_BASE + "-_.";
    },
    /**
     * Whether this browser supports the atob and btoa functions. This extension
     * started at Mozilla but is now implemented by many browsers. We use the
     * ASSUME_* variables to avoid pulling in the full useragent detection library
     * but still allowing the standard per-browser compilations.
     *
     */ HAS_NATIVE_SUPPORT: typeof atob === "function",
    /**
     * Base64-encode an array of bytes.
     *
     * @param input An array of bytes (numbers with
     *     value in [0, 255]) to encode.
     * @param webSafe Boolean indicating we should use the
     *     alternative alphabet.
     * @return The base64 encoded string.
     */ encodeByteArray (input, webSafe) {
        if (!Array.isArray(input)) throw Error("encodeByteArray takes an array as a parameter");
        this.init_();
        const byteToCharMap = webSafe ? this.byteToCharMapWebSafe_ : this.byteToCharMap_;
        const output = [];
        for(let i = 0; i < input.length; i += 3){
            const byte1 = input[i];
            const haveByte2 = i + 1 < input.length;
            const byte2 = haveByte2 ? input[i + 1] : 0;
            const haveByte3 = i + 2 < input.length;
            const byte3 = haveByte3 ? input[i + 2] : 0;
            const outByte1 = byte1 >> 2;
            const outByte2 = (byte1 & 0x03) << 4 | byte2 >> 4;
            let outByte3 = (byte2 & 0x0f) << 2 | byte3 >> 6;
            let outByte4 = byte3 & 0x3f;
            if (!haveByte3) {
                outByte4 = 64;
                if (!haveByte2) outByte3 = 64;
            }
            output.push(byteToCharMap[outByte1], byteToCharMap[outByte2], byteToCharMap[outByte3], byteToCharMap[outByte4]);
        }
        return output.join("");
    },
    /**
     * Base64-encode a string.
     *
     * @param input A string to encode.
     * @param webSafe If true, we should use the
     *     alternative alphabet.
     * @return The base64 encoded string.
     */ encodeString (input, webSafe) {
        // Shortcut for Mozilla browsers that implement
        // a native base64 encoder in the form of "btoa/atob"
        if (this.HAS_NATIVE_SUPPORT && !webSafe) return btoa(input);
        return this.encodeByteArray($c38e0f42709c826a$var$stringToByteArray$1(input), webSafe);
    },
    /**
     * Base64-decode a string.
     *
     * @param input to decode.
     * @param webSafe True if we should use the
     *     alternative alphabet.
     * @return string representing the decoded value.
     */ decodeString (input, webSafe) {
        // Shortcut for Mozilla browsers that implement
        // a native base64 encoder in the form of "btoa/atob"
        if (this.HAS_NATIVE_SUPPORT && !webSafe) return atob(input);
        return $c38e0f42709c826a$var$byteArrayToString(this.decodeStringToByteArray(input, webSafe));
    },
    /**
     * Base64-decode a string.
     *
     * In base-64 decoding, groups of four characters are converted into three
     * bytes.  If the encoder did not apply padding, the input length may not
     * be a multiple of 4.
     *
     * In this case, the last group will have fewer than 4 characters, and
     * padding will be inferred.  If the group has one or two characters, it decodes
     * to one byte.  If the group has three characters, it decodes to two bytes.
     *
     * @param input Input to decode.
     * @param webSafe True if we should use the web-safe alphabet.
     * @return bytes representing the decoded value.
     */ decodeStringToByteArray (input, webSafe) {
        this.init_();
        const charToByteMap = webSafe ? this.charToByteMapWebSafe_ : this.charToByteMap_;
        const output = [];
        for(let i = 0; i < input.length;){
            const byte1 = charToByteMap[input.charAt(i++)];
            const haveByte2 = i < input.length;
            const byte2 = haveByte2 ? charToByteMap[input.charAt(i)] : 0;
            ++i;
            const haveByte3 = i < input.length;
            const byte3 = haveByte3 ? charToByteMap[input.charAt(i)] : 64;
            ++i;
            const haveByte4 = i < input.length;
            const byte4 = haveByte4 ? charToByteMap[input.charAt(i)] : 64;
            ++i;
            if (byte1 == null || byte2 == null || byte3 == null || byte4 == null) throw new $c38e0f42709c826a$export$55ca9d4bee46aeb3();
            const outByte1 = byte1 << 2 | byte2 >> 4;
            output.push(outByte1);
            if (byte3 !== 64) {
                const outByte2 = byte2 << 4 & 0xf0 | byte3 >> 2;
                output.push(outByte2);
                if (byte4 !== 64) {
                    const outByte3 = byte3 << 6 & 0xc0 | byte4;
                    output.push(outByte3);
                }
            }
        }
        return output;
    },
    /**
     * Lazy static initialization function. Called before
     * accessing any of the static map variables.
     * @private
     */ init_ () {
        if (!this.byteToCharMap_) {
            this.byteToCharMap_ = {};
            this.charToByteMap_ = {};
            this.byteToCharMapWebSafe_ = {};
            this.charToByteMapWebSafe_ = {};
            // We want quick mappings back and forth, so we precompute two maps.
            for(let i = 0; i < this.ENCODED_VALS.length; i++){
                this.byteToCharMap_[i] = this.ENCODED_VALS.charAt(i);
                this.charToByteMap_[this.byteToCharMap_[i]] = i;
                this.byteToCharMapWebSafe_[i] = this.ENCODED_VALS_WEBSAFE.charAt(i);
                this.charToByteMapWebSafe_[this.byteToCharMapWebSafe_[i]] = i;
                // Be forgiving when decoding and correctly decode both encodings.
                if (i >= this.ENCODED_VALS_BASE.length) {
                    this.charToByteMap_[this.ENCODED_VALS_WEBSAFE.charAt(i)] = i;
                    this.charToByteMapWebSafe_[this.ENCODED_VALS.charAt(i)] = i;
                }
            }
        }
    }
};
/**
 * An error encountered while decoding base64 string.
 */ class $c38e0f42709c826a$export$55ca9d4bee46aeb3 extends Error {
    constructor(){
        super(...arguments);
        this.name = "DecodeBase64StringError";
    }
}
/**
 * URL-safe base64 encoding
 */ const $c38e0f42709c826a$export$e510a73ee562749 = function(str) {
    const utf8Bytes = $c38e0f42709c826a$var$stringToByteArray$1(str);
    return $c38e0f42709c826a$export$b3b2de96497acc47.encodeByteArray(utf8Bytes, true);
};
/**
 * URL-safe base64 encoding (without "." padding in the end).
 * e.g. Used in JSON Web Token (JWT) parts.
 */ const $c38e0f42709c826a$export$4b5284a3025a455 = function(str) {
    // Use base64url encoding and remove padding in the end (dot characters).
    return $c38e0f42709c826a$export$e510a73ee562749(str).replace(/\./g, "");
};
/**
 * URL-safe base64 decoding
 *
 * NOTE: DO NOT use the global atob() function - it does NOT support the
 * base64Url variant encoding.
 *
 * @param str To be decoded
 * @return Decoded result, if possible
 */ const $c38e0f42709c826a$export$c62426fdd000a97e = function(str) {
    try {
        return $c38e0f42709c826a$export$b3b2de96497acc47.decodeString(str, true);
    } catch (e) {
        console.error("base64Decode failed: ", e);
    }
    return null;
};
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Do a deep-copy of basic JavaScript Objects or Arrays.
 */ function $c38e0f42709c826a$export$6c40052bed430212(value) {
    return $c38e0f42709c826a$export$54e9fb29908872fa(undefined, value);
}
/**
 * Copy properties from source to target (recursively allows extension
 * of Objects and Arrays).  Scalar values in the target are over-written.
 * If target is undefined, an object of the appropriate type will be created
 * (and returned).
 *
 * We recursively copy all child properties of plain Objects in the source- so
 * that namespace- like dictionaries are merged.
 *
 * Note that the target can be a function, in which case the properties in
 * the source Object are copied onto it as static properties of the Function.
 *
 * Note: we don't merge __proto__ to prevent prototype pollution
 */ function $c38e0f42709c826a$export$54e9fb29908872fa(target, source) {
    if (!(source instanceof Object)) return source;
    switch(source.constructor){
        case Date:
            // Treat Dates like scalars; if the target date object had any child
            // properties - they will be lost!
            const dateValue = source;
            return new Date(dateValue.getTime());
        case Object:
            if (target === undefined) target = {};
            break;
        case Array:
            // Always copy the array source and overwrite the target.
            target = [];
            break;
        default:
            // Not a plain Object - treat it as a scalar.
            return source;
    }
    for(const prop in source){
        // use isValidKey to guard against prototype pollution. See https://snyk.io/vuln/SNYK-JS-LODASH-450202
        if (!source.hasOwnProperty(prop) || !$c38e0f42709c826a$var$isValidKey(prop)) continue;
        target[prop] = $c38e0f42709c826a$export$54e9fb29908872fa(target[prop], source[prop]);
    }
    return target;
}
function $c38e0f42709c826a$var$isValidKey(key) {
    return key !== "__proto__";
}
/**
 * @license
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Polyfill for `globalThis` object.
 * @returns the `globalThis` object for the given environment.
 * @public
 */ function $c38e0f42709c826a$export$a4e55266d2135a7f() {
    if (typeof self !== "undefined") return self;
    if (typeof window !== "undefined") return window;
    if (typeof $parcel$global !== "undefined") return $parcel$global;
    throw new Error("Unable to locate global object.");
}
/**
 * @license
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $c38e0f42709c826a$var$getDefaultsFromGlobal = ()=>$c38e0f42709c826a$export$a4e55266d2135a7f().__FIREBASE_DEFAULTS__;
/**
 * Attempt to read defaults from a JSON string provided to
 * process(.)env(.)__FIREBASE_DEFAULTS__ or a JSON file whose path is in
 * process(.)env(.)__FIREBASE_DEFAULTS_PATH__
 * The dots are in parens because certain compilers (Vite?) cannot
 * handle seeing that variable in comments.
 * See https://github.com/firebase/firebase-js-sdk/issues/6838
 */ const $c38e0f42709c826a$var$getDefaultsFromEnvVariable = ()=>{
    if (typeof $hPtJY === "undefined" || typeof $hPtJY.env === "undefined") return;
    const defaultsJsonString = undefined;
    if (defaultsJsonString) return JSON.parse(defaultsJsonString);
};
const $c38e0f42709c826a$var$getDefaultsFromCookie = ()=>{
    if (typeof document === "undefined") return;
    let match;
    try {
        match = document.cookie.match(/__FIREBASE_DEFAULTS__=([^;]+)/);
    } catch (e) {
        // Some environments such as Angular Universal SSR have a
        // `document` object but error on accessing `document.cookie`.
        return;
    }
    const decoded = match && $c38e0f42709c826a$export$c62426fdd000a97e(match[1]);
    return decoded && JSON.parse(decoded);
};
/**
 * Get the __FIREBASE_DEFAULTS__ object. It checks in order:
 * (1) if such an object exists as a property of `globalThis`
 * (2) if such an object was provided on a shell environment variable
 * (3) if such an object exists in a cookie
 * @public
 */ const $c38e0f42709c826a$export$212bb2fc580a90a8 = ()=>{
    try {
        return $c38e0f42709c826a$var$getDefaultsFromGlobal() || $c38e0f42709c826a$var$getDefaultsFromEnvVariable() || $c38e0f42709c826a$var$getDefaultsFromCookie();
    } catch (e) {
        /**
         * Catch-all for being unable to get __FIREBASE_DEFAULTS__ due
         * to any environment case we have not accounted for. Log to
         * info instead of swallowing so we can find these unknown cases
         * and add paths for them if needed.
         */ console.info(`Unable to get __FIREBASE_DEFAULTS__ due to: ${e}`);
        return;
    }
};
/**
 * Returns emulator host stored in the __FIREBASE_DEFAULTS__ object
 * for the given product.
 * @returns a URL host formatted like `127.0.0.1:9999` or `[::1]:4000` if available
 * @public
 */ const $c38e0f42709c826a$export$9c11895284c8adad = (productName)=>{
    var _a, _b;
    return (_b = (_a = $c38e0f42709c826a$export$212bb2fc580a90a8()) === null || _a === void 0 ? void 0 : _a.emulatorHosts) === null || _b === void 0 ? void 0 : _b[productName];
};
/**
 * Returns emulator hostname and port stored in the __FIREBASE_DEFAULTS__ object
 * for the given product.
 * @returns a pair of hostname and port like `["::1", 4000]` if available
 * @public
 */ const $c38e0f42709c826a$export$a3febcf1f14a3a0c = (productName)=>{
    const host = $c38e0f42709c826a$export$9c11895284c8adad(productName);
    if (!host) return undefined;
    const separatorIndex = host.lastIndexOf(":"); // Finding the last since IPv6 addr also has colons.
    if (separatorIndex <= 0 || separatorIndex + 1 === host.length) throw new Error(`Invalid host ${host} with no separate hostname and port!`);
    // eslint-disable-next-line no-restricted-globals
    const port = parseInt(host.substring(separatorIndex + 1), 10);
    if (host[0] === "[") // Bracket-quoted `[ipv6addr]:port` => return "ipv6addr" (without brackets).
    return [
        host.substring(1, separatorIndex - 1),
        port
    ];
    else return [
        host.substring(0, separatorIndex),
        port
    ];
};
/**
 * Returns Firebase app config stored in the __FIREBASE_DEFAULTS__ object.
 * @public
 */ const $c38e0f42709c826a$export$3dfb6827a9f89756 = ()=>{
    var _a;
    return (_a = $c38e0f42709c826a$export$212bb2fc580a90a8()) === null || _a === void 0 ? void 0 : _a.config;
};
/**
 * Returns an experimental setting on the __FIREBASE_DEFAULTS__ object (properties
 * prefixed by "_")
 * @public
 */ const $c38e0f42709c826a$export$5539a1a3afe87d6 = (name)=>{
    var _a;
    return (_a = $c38e0f42709c826a$export$212bb2fc580a90a8()) === null || _a === void 0 ? void 0 : _a[`_${name}`];
};
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $c38e0f42709c826a$export$85f6557964517f1a {
    constructor(){
        this.reject = ()=>{};
        this.resolve = ()=>{};
        this.promise = new Promise((resolve, reject)=>{
            this.resolve = resolve;
            this.reject = reject;
        });
    }
    /**
     * Our API internals are not promiseified and cannot because our callback APIs have subtle expectations around
     * invoking promises inline, which Promises are forbidden to do. This method accepts an optional node-style callback
     * and returns a node-style callback which will resolve or reject the Deferred's promise.
     */ wrapCallback(callback) {
        return (error, value)=>{
            if (error) this.reject(error);
            else this.resolve(value);
            if (typeof callback === "function") {
                // Attaching noop handler just in case developer wasn't expecting
                // promises
                this.promise.catch(()=>{});
                // Some of our callbacks don't expect a value and our own tests
                // assert that the parameter length is 1
                if (callback.length === 1) callback(error);
                else callback(error, value);
            }
        };
    }
}
/**
 * @license
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $c38e0f42709c826a$export$367bf224123348f1(token, projectId) {
    if (token.uid) throw new Error('The "uid" field is no longer supported by mockUserToken. Please use "sub" instead for Firebase Auth User ID.');
    // Unsecured JWTs use "none" as the algorithm.
    const header = {
        alg: "none",
        type: "JWT"
    };
    const project = projectId || "demo-project";
    const iat = token.iat || 0;
    const sub = token.sub || token.user_id;
    if (!sub) throw new Error("mockUserToken must contain 'sub' or 'user_id' field!");
    const payload = Object.assign({
        // Set all required fields to decent defaults
        iss: `https://securetoken.google.com/${project}`,
        aud: project,
        iat: iat,
        exp: iat + 3600,
        auth_time: iat,
        sub: sub,
        user_id: sub,
        firebase: {
            sign_in_provider: "custom",
            identities: {}
        }
    }, token);
    // Unsecured JWTs use the empty string as a signature.
    const signature = "";
    return [
        $c38e0f42709c826a$export$4b5284a3025a455(JSON.stringify(header)),
        $c38e0f42709c826a$export$4b5284a3025a455(JSON.stringify(payload)),
        signature
    ].join(".");
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Returns navigator.userAgent string or '' if it's not defined.
 * @return user agent string
 */ function $c38e0f42709c826a$export$c36915b22ce77c19() {
    if (typeof navigator !== "undefined" && typeof navigator["userAgent"] === "string") return navigator["userAgent"];
    else return "";
}
/**
 * Detect Cordova / PhoneGap / Ionic frameworks on a mobile device.
 *
 * Deliberately does not rely on checking `file://` URLs (as this fails PhoneGap
 * in the Ripple emulator) nor Cordova `onDeviceReady`, which would normally
 * wait for a callback.
 */ function $c38e0f42709c826a$export$872f8323f01d7ae0() {
    return typeof window !== "undefined" && // @ts-ignore Setting up an broadly applicable index signature for Window
    // just to deal with this case would probably be a bad idea.
    !!(window["cordova"] || window["phonegap"] || window["PhoneGap"]) && /ios|iphone|ipod|ipad|android|blackberry|iemobile/i.test($c38e0f42709c826a$export$c36915b22ce77c19());
}
/**
 * Detect Node.js.
 *
 * @return true if Node.js environment is detected or specified.
 */ // Node detection logic from: https://github.com/iliakan/detect-node/
function $c38e0f42709c826a$export$8ee0fc9ee280b4ee() {
    var _a;
    const forceEnvironment = (_a = $c38e0f42709c826a$export$212bb2fc580a90a8()) === null || _a === void 0 ? void 0 : _a.forceEnvironment;
    if (forceEnvironment === "node") return true;
    else if (forceEnvironment === "browser") return false;
    try {
        return Object.prototype.toString.call($parcel$global.process) === "[object process]";
    } catch (e) {
        return false;
    }
}
/**
 * Detect Browser Environment
 */ function $c38e0f42709c826a$export$4e09c449d6c407f7() {
    return typeof self === "object" && self.self === self;
}
function $c38e0f42709c826a$export$caa8774a9107a58e() {
    const runtime = typeof chrome === "object" ? chrome.runtime : typeof browser === "object" ? browser.runtime : undefined;
    return typeof runtime === "object" && runtime.id !== undefined;
}
/**
 * Detect React Native.
 *
 * @return true if ReactNative environment is detected.
 */ function $c38e0f42709c826a$export$f7a1e23e542d38e3() {
    return typeof navigator === "object" && navigator["product"] === "ReactNative";
}
/** Detects Electron apps. */ function $c38e0f42709c826a$export$f2f6a8999f8ebd30() {
    return $c38e0f42709c826a$export$c36915b22ce77c19().indexOf("Electron/") >= 0;
}
/** Detects Internet Explorer. */ function $c38e0f42709c826a$export$7e7b1a9668aaed8() {
    const ua = $c38e0f42709c826a$export$c36915b22ce77c19();
    return ua.indexOf("MSIE ") >= 0 || ua.indexOf("Trident/") >= 0;
}
/** Detects Universal Windows Platform apps. */ function $c38e0f42709c826a$export$202944b2d2824246() {
    return $c38e0f42709c826a$export$c36915b22ce77c19().indexOf("MSAppHost/") >= 0;
}
/**
 * Detect whether the current SDK build is the Node version.
 *
 * @return true if it's the Node SDK build.
 */ function $c38e0f42709c826a$export$5d1d834fbbf8bab7() {
    return $c38e0f42709c826a$export$588c7fdda06fbb0a.NODE_CLIENT === true || $c38e0f42709c826a$export$588c7fdda06fbb0a.NODE_ADMIN === true;
}
/** Returns true if we are running in Safari. */ function $c38e0f42709c826a$export$95df08bae54cb4df() {
    return !$c38e0f42709c826a$export$8ee0fc9ee280b4ee() && navigator.userAgent.includes("Safari") && !navigator.userAgent.includes("Chrome");
}
/**
 * This method checks if indexedDB is supported by current browser/service worker context
 * @return true if indexedDB is supported by current browser/service worker context
 */ function $c38e0f42709c826a$export$3865db50535c2055() {
    try {
        return typeof indexedDB === "object";
    } catch (e) {
        return false;
    }
}
/**
 * This method validates browser/sw context for indexedDB by opening a dummy indexedDB database and reject
 * if errors occur during the database open operation.
 *
 * @throws exception if current browser/sw context can't run idb.open (ex: Safari iframe, Firefox
 * private browsing)
 */ function $c38e0f42709c826a$export$a8a3018f3d187a4d() {
    return new Promise((resolve, reject)=>{
        try {
            let preExist = true;
            const DB_CHECK_NAME = "validate-browser-context-for-indexeddb-analytics-module";
            const request = self.indexedDB.open(DB_CHECK_NAME);
            request.onsuccess = ()=>{
                request.result.close();
                // delete database only when it doesn't pre-exist
                if (!preExist) self.indexedDB.deleteDatabase(DB_CHECK_NAME);
                resolve(true);
            };
            request.onupgradeneeded = ()=>{
                preExist = false;
            };
            request.onerror = ()=>{
                var _a;
                reject(((_a = request.error) === null || _a === void 0 ? void 0 : _a.message) || "");
            };
        } catch (error) {
            reject(error);
        }
    });
}
/**
 *
 * This method checks whether cookie is enabled within current browser
 * @return true if cookie is enabled within current browser
 */ function $c38e0f42709c826a$export$f172b7eb6cf60599() {
    if (typeof navigator === "undefined" || !navigator.cookieEnabled) return false;
    return true;
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * @fileoverview Standardized Firebase Error.
 *
 * Usage:
 *
 *   // Typescript string literals for type-safe codes
 *   type Err =
 *     'unknown' |
 *     'object-not-found'
 *     ;
 *
 *   // Closure enum for type-safe error codes
 *   // at-enum {string}
 *   var Err = {
 *     UNKNOWN: 'unknown',
 *     OBJECT_NOT_FOUND: 'object-not-found',
 *   }
 *
 *   let errors: Map<Err, string> = {
 *     'generic-error': "Unknown error",
 *     'file-not-found': "Could not find file: {$file}",
 *   };
 *
 *   // Type-safe function - must pass a valid error code as param.
 *   let error = new ErrorFactory<Err>('service', 'Service', errors);
 *
 *   ...
 *   throw error.create(Err.GENERIC);
 *   ...
 *   throw error.create(Err.FILE_NOT_FOUND, {'file': fileName});
 *   ...
 *   // Service: Could not file file: foo.txt (service/file-not-found).
 *
 *   catch (e) {
 *     assert(e.message === "Could not find file: foo.txt.");
 *     if ((e as FirebaseError)?.code === 'service/file-not-found') {
 *       console.log("Could not read file: " + e['file']);
 *     }
 *   }
 */ const $c38e0f42709c826a$var$ERROR_NAME = "FirebaseError";
// Based on code from:
// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Error#Custom_Error_Types
class $c38e0f42709c826a$export$dd24e9cd51226c56 extends Error {
    constructor(/** The error code for this error. */ code, message, /** Custom data for this error. */ customData){
        super(message);
        this.code = code;
        this.customData = customData;
        /** The custom name for all FirebaseErrors. */ this.name = $c38e0f42709c826a$var$ERROR_NAME;
        // Fix For ES5
        // https://github.com/Microsoft/TypeScript-wiki/blob/master/Breaking-Changes.md#extending-built-ins-like-error-array-and-map-may-no-longer-work
        Object.setPrototypeOf(this, $c38e0f42709c826a$export$dd24e9cd51226c56.prototype);
        // Maintains proper stack trace for where our error was thrown.
        // Only available on V8.
        if (Error.captureStackTrace) Error.captureStackTrace(this, $c38e0f42709c826a$export$3fa6e1b18a3b2d40.prototype.create);
    }
}
class $c38e0f42709c826a$export$3fa6e1b18a3b2d40 {
    constructor(service, serviceName, errors){
        this.service = service;
        this.serviceName = serviceName;
        this.errors = errors;
    }
    create(code, ...data) {
        const customData = data[0] || {};
        const fullCode = `${this.service}/${code}`;
        const template = this.errors[code];
        const message = template ? $c38e0f42709c826a$var$replaceTemplate(template, customData) : "Error";
        // Service Name: Error message (service/code).
        const fullMessage = `${this.serviceName}: ${message} (${fullCode}).`;
        const error = new $c38e0f42709c826a$export$dd24e9cd51226c56(fullCode, fullMessage, customData);
        return error;
    }
}
function $c38e0f42709c826a$var$replaceTemplate(template, data) {
    return template.replace($c38e0f42709c826a$var$PATTERN, (_, key)=>{
        const value = data[key];
        return value != null ? String(value) : `<${key}?>`;
    });
}
const $c38e0f42709c826a$var$PATTERN = /\{\$([^}]+)}/g;
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Evaluates a JSON string into a javascript object.
 *
 * @param {string} str A string containing JSON.
 * @return {*} The javascript object representing the specified JSON.
 */ function $c38e0f42709c826a$export$c5a53ce6a17cf18d(str) {
    return JSON.parse(str);
}
/**
 * Returns JSON representing a javascript object.
 * @param {*} data Javascript object to be stringified.
 * @return {string} The JSON contents of the object.
 */ function $c38e0f42709c826a$export$fac44ee5b035f737(data) {
    return JSON.stringify(data);
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Decodes a Firebase auth. token into constituent parts.
 *
 * Notes:
 * - May return with invalid / incomplete claims if there's no native base64 decoding support.
 * - Doesn't check if the token is actually valid.
 */ const $c38e0f42709c826a$export$2f872c0f2117be69 = function(token) {
    let header = {}, claims = {}, data = {}, signature = "";
    try {
        const parts = token.split(".");
        header = $c38e0f42709c826a$export$c5a53ce6a17cf18d($c38e0f42709c826a$export$c62426fdd000a97e(parts[0]) || "");
        claims = $c38e0f42709c826a$export$c5a53ce6a17cf18d($c38e0f42709c826a$export$c62426fdd000a97e(parts[1]) || "");
        signature = parts[2];
        data = claims["d"] || {};
        delete claims["d"];
    } catch (e) {}
    return {
        header: header,
        claims: claims,
        data: data,
        signature: signature
    };
};
/**
 * Decodes a Firebase auth. token and checks the validity of its time-based claims. Will return true if the
 * token is within the time window authorized by the 'nbf' (not-before) and 'iat' (issued-at) claims.
 *
 * Notes:
 * - May return a false negative if there's no native base64 decoding support.
 * - Doesn't check if the token is actually valid.
 */ const $c38e0f42709c826a$export$5f870fcca7ae6a88 = function(token) {
    const claims = $c38e0f42709c826a$export$2f872c0f2117be69(token).claims;
    const now = Math.floor(new Date().getTime() / 1000);
    let validSince = 0, validUntil = 0;
    if (typeof claims === "object") {
        if (claims.hasOwnProperty("nbf")) validSince = claims["nbf"];
        else if (claims.hasOwnProperty("iat")) validSince = claims["iat"];
        if (claims.hasOwnProperty("exp")) validUntil = claims["exp"];
        else // token will expire after 24h by default
        validUntil = validSince + 86400;
    }
    return !!now && !!validSince && !!validUntil && now >= validSince && now <= validUntil;
};
/**
 * Decodes a Firebase auth. token and returns its issued at time if valid, null otherwise.
 *
 * Notes:
 * - May return null if there's no native base64 decoding support.
 * - Doesn't check if the token is actually valid.
 */ const $c38e0f42709c826a$export$701c661ec91095f2 = function(token) {
    const claims = $c38e0f42709c826a$export$2f872c0f2117be69(token).claims;
    if (typeof claims === "object" && claims.hasOwnProperty("iat")) return claims["iat"];
    return null;
};
/**
 * Decodes a Firebase auth. token and checks the validity of its format. Expects a valid issued-at time.
 *
 * Notes:
 * - May return a false negative if there's no native base64 decoding support.
 * - Doesn't check if the token is actually valid.
 */ const $c38e0f42709c826a$export$9565ca3d387f8aa0 = function(token) {
    const decoded = $c38e0f42709c826a$export$2f872c0f2117be69(token), claims = decoded.claims;
    return !!claims && typeof claims === "object" && claims.hasOwnProperty("iat");
};
/**
 * Attempts to peer into an auth token and determine if it's an admin auth token by looking at the claims portion.
 *
 * Notes:
 * - May return a false negative if there's no native base64 decoding support.
 * - Doesn't check if the token is actually valid.
 */ const $c38e0f42709c826a$export$fc970ed23da99565 = function(token) {
    const claims = $c38e0f42709c826a$export$2f872c0f2117be69(token).claims;
    return typeof claims === "object" && claims["admin"] === true;
};
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $c38e0f42709c826a$export$2344b14b097df817(obj, key) {
    return Object.prototype.hasOwnProperty.call(obj, key);
}
function $c38e0f42709c826a$export$e51ae4db7b428f67(obj, key) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) return obj[key];
    else return undefined;
}
function $c38e0f42709c826a$export$dd1bc94b04021eeb(obj) {
    for(const key in obj){
        if (Object.prototype.hasOwnProperty.call(obj, key)) return false;
    }
    return true;
}
function $c38e0f42709c826a$export$871de8747c9eaa88(obj, fn, contextObj) {
    const res = {};
    for(const key in obj)if (Object.prototype.hasOwnProperty.call(obj, key)) res[key] = fn.call(contextObj, obj[key], key, obj);
    return res;
}
/**
 * Deep equal two objects. Support Arrays and Objects.
 */ function $c38e0f42709c826a$export$9cb4719e2e525b7a(a, b) {
    if (a === b) return true;
    const aKeys = Object.keys(a);
    const bKeys = Object.keys(b);
    for (const k of aKeys){
        if (!bKeys.includes(k)) return false;
        const aProp = a[k];
        const bProp = b[k];
        if ($c38e0f42709c826a$var$isObject(aProp) && $c38e0f42709c826a$var$isObject(bProp)) {
            if (!$c38e0f42709c826a$export$9cb4719e2e525b7a(aProp, bProp)) return false;
        } else if (aProp !== bProp) return false;
    }
    for (const k of bKeys){
        if (!aKeys.includes(k)) return false;
    }
    return true;
}
function $c38e0f42709c826a$var$isObject(thing) {
    return thing !== null && typeof thing === "object";
}
/**
 * @license
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Rejects if the given promise doesn't resolve in timeInMS milliseconds.
 * @internal
 */ function $c38e0f42709c826a$export$a9cd205a244d9f54(promise, timeInMS = 2000) {
    const deferredPromise = new $c38e0f42709c826a$export$85f6557964517f1a();
    setTimeout(()=>deferredPromise.reject("timeout!"), timeInMS);
    promise.then(deferredPromise.resolve, deferredPromise.reject);
    return deferredPromise.promise;
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Returns a querystring-formatted string (e.g. &arg=val&arg2=val2) from a
 * params object (e.g. {arg: 'val', arg2: 'val2'})
 * Note: You must prepend it with ? when adding it to a URL.
 */ function $c38e0f42709c826a$export$ac4103b836844853(querystringParams) {
    const params = [];
    for (const [key, value] of Object.entries(querystringParams))if (Array.isArray(value)) value.forEach((arrayVal)=>{
        params.push(encodeURIComponent(key) + "=" + encodeURIComponent(arrayVal));
    });
    else params.push(encodeURIComponent(key) + "=" + encodeURIComponent(value));
    return params.length ? "&" + params.join("&") : "";
}
/**
 * Decodes a querystring (e.g. ?arg=val&arg2=val2) into a params object
 * (e.g. {arg: 'val', arg2: 'val2'})
 */ function $c38e0f42709c826a$export$c1271ca4c8a70741(querystring) {
    const obj = {};
    const tokens = querystring.replace(/^\?/, "").split("&");
    tokens.forEach((token)=>{
        if (token) {
            const [key, value] = token.split("=");
            obj[decodeURIComponent(key)] = decodeURIComponent(value);
        }
    });
    return obj;
}
/**
 * Extract the query string part of a URL, including the leading question mark (if present).
 */ function $c38e0f42709c826a$export$1a8408415472d8ed(url) {
    const queryStart = url.indexOf("?");
    if (!queryStart) return "";
    const fragmentStart = url.indexOf("#", queryStart);
    return url.substring(queryStart, fragmentStart > 0 ? fragmentStart : undefined);
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * @fileoverview SHA-1 cryptographic hash.
 * Variable names follow the notation in FIPS PUB 180-3:
 * http://csrc.nist.gov/publications/fips/fips180-3/fips180-3_final.pdf.
 *
 * Usage:
 *   var sha1 = new sha1();
 *   sha1.update(bytes);
 *   var hash = sha1.digest();
 *
 * Performance:
 *   Chrome 23:   ~400 Mbit/s
 *   Firefox 16:  ~250 Mbit/s
 *
 */ /**
 * SHA-1 cryptographic hash constructor.
 *
 * The properties declared here are discussed in the above algorithm document.
 * @constructor
 * @final
 * @struct
 */ class $c38e0f42709c826a$export$c85d589bf4e25fef {
    constructor(){
        /**
         * Holds the previous values of accumulated variables a-e in the compress_
         * function.
         * @private
         */ this.chain_ = [];
        /**
         * A buffer holding the partially computed hash result.
         * @private
         */ this.buf_ = [];
        /**
         * An array of 80 bytes, each a part of the message to be hashed.  Referred to
         * as the message schedule in the docs.
         * @private
         */ this.W_ = [];
        /**
         * Contains data needed to pad messages less than 64 bytes.
         * @private
         */ this.pad_ = [];
        /**
         * @private {number}
         */ this.inbuf_ = 0;
        /**
         * @private {number}
         */ this.total_ = 0;
        this.blockSize = 64;
        this.pad_[0] = 128;
        for(let i = 1; i < this.blockSize; ++i)this.pad_[i] = 0;
        this.reset();
    }
    reset() {
        this.chain_[0] = 0x67452301;
        this.chain_[1] = 0xefcdab89;
        this.chain_[2] = 0x98badcfe;
        this.chain_[3] = 0x10325476;
        this.chain_[4] = 0xc3d2e1f0;
        this.inbuf_ = 0;
        this.total_ = 0;
    }
    /**
     * Internal compress helper function.
     * @param buf Block to compress.
     * @param offset Offset of the block in the buffer.
     * @private
     */ compress_(buf, offset) {
        if (!offset) offset = 0;
        const W = this.W_;
        // get 16 big endian words
        if (typeof buf === "string") for(let i = 0; i < 16; i++){
            // TODO(user): [bug 8140122] Recent versions of Safari for Mac OS and iOS
            // have a bug that turns the post-increment ++ operator into pre-increment
            // during JIT compilation.  We have code that depends heavily on SHA-1 for
            // correctness and which is affected by this bug, so I've removed all uses
            // of post-increment ++ in which the result value is used.  We can revert
            // this change once the Safari bug
            // (https://bugs.webkit.org/show_bug.cgi?id=109036) has been fixed and
            // most clients have been updated.
            W[i] = buf.charCodeAt(offset) << 24 | buf.charCodeAt(offset + 1) << 16 | buf.charCodeAt(offset + 2) << 8 | buf.charCodeAt(offset + 3);
            offset += 4;
        }
        else for(let i = 0; i < 16; i++){
            W[i] = buf[offset] << 24 | buf[offset + 1] << 16 | buf[offset + 2] << 8 | buf[offset + 3];
            offset += 4;
        }
        // expand to 80 words
        for(let i = 16; i < 80; i++){
            const t = W[i - 3] ^ W[i - 8] ^ W[i - 14] ^ W[i - 16];
            W[i] = (t << 1 | t >>> 31) & 0xffffffff;
        }
        let a = this.chain_[0];
        let b = this.chain_[1];
        let c = this.chain_[2];
        let d = this.chain_[3];
        let e = this.chain_[4];
        let f, k;
        // TODO(user): Try to unroll this loop to speed up the computation.
        for(let i = 0; i < 80; i++){
            if (i < 40) {
                if (i < 20) {
                    f = d ^ b & (c ^ d);
                    k = 0x5a827999;
                } else {
                    f = b ^ c ^ d;
                    k = 0x6ed9eba1;
                }
            } else if (i < 60) {
                f = b & c | d & (b | c);
                k = 0x8f1bbcdc;
            } else {
                f = b ^ c ^ d;
                k = 0xca62c1d6;
            }
            const t = (a << 5 | a >>> 27) + f + e + k + W[i] & 0xffffffff;
            e = d;
            d = c;
            c = (b << 30 | b >>> 2) & 0xffffffff;
            b = a;
            a = t;
        }
        this.chain_[0] = this.chain_[0] + a & 0xffffffff;
        this.chain_[1] = this.chain_[1] + b & 0xffffffff;
        this.chain_[2] = this.chain_[2] + c & 0xffffffff;
        this.chain_[3] = this.chain_[3] + d & 0xffffffff;
        this.chain_[4] = this.chain_[4] + e & 0xffffffff;
    }
    update(bytes, length) {
        // TODO(johnlenz): tighten the function signature and remove this check
        if (bytes == null) return;
        if (length === undefined) length = bytes.length;
        const lengthMinusBlock = length - this.blockSize;
        let n = 0;
        // Using local instead of member variables gives ~5% speedup on Firefox 16.
        const buf = this.buf_;
        let inbuf = this.inbuf_;
        // The outer while loop should execute at most twice.
        while(n < length){
            // When we have no data in the block to top up, we can directly process the
            // input buffer (assuming it contains sufficient data). This gives ~25%
            // speedup on Chrome 23 and ~15% speedup on Firefox 16, but requires that
            // the data is provided in large chunks (or in multiples of 64 bytes).
            if (inbuf === 0) while(n <= lengthMinusBlock){
                this.compress_(bytes, n);
                n += this.blockSize;
            }
            if (typeof bytes === "string") while(n < length){
                buf[inbuf] = bytes.charCodeAt(n);
                ++inbuf;
                ++n;
                if (inbuf === this.blockSize) {
                    this.compress_(buf);
                    inbuf = 0;
                    break;
                }
            }
            else while(n < length){
                buf[inbuf] = bytes[n];
                ++inbuf;
                ++n;
                if (inbuf === this.blockSize) {
                    this.compress_(buf);
                    inbuf = 0;
                    break;
                }
            }
        }
        this.inbuf_ = inbuf;
        this.total_ += length;
    }
    /** @override */ digest() {
        const digest = [];
        let totalBits = this.total_ * 8;
        // Add pad 0x80 0x00*.
        if (this.inbuf_ < 56) this.update(this.pad_, 56 - this.inbuf_);
        else this.update(this.pad_, this.blockSize - (this.inbuf_ - 56));
        // Add # bits.
        for(let i = this.blockSize - 1; i >= 56; i--){
            this.buf_[i] = totalBits & 255;
            totalBits /= 256; // Don't use bit-shifting here!
        }
        this.compress_(this.buf_);
        let n = 0;
        for(let i = 0; i < 5; i++)for(let j = 24; j >= 0; j -= 8){
            digest[n] = this.chain_[i] >> j & 255;
            ++n;
        }
        return digest;
    }
}
/**
 * Helper to make a Subscribe function (just like Promise helps make a
 * Thenable).
 *
 * @param executor Function which can make calls to a single Observer
 *     as a proxy.
 * @param onNoObservers Callback when count of Observers goes to zero.
 */ function $c38e0f42709c826a$export$364097d812234b3f(executor, onNoObservers) {
    const proxy = new $c38e0f42709c826a$var$ObserverProxy(executor, onNoObservers);
    return proxy.subscribe.bind(proxy);
}
/**
 * Implement fan-out for any number of Observers attached via a subscribe
 * function.
 */ class $c38e0f42709c826a$var$ObserverProxy {
    /**
     * @param executor Function which can make calls to a single Observer
     *     as a proxy.
     * @param onNoObservers Callback when count of Observers goes to zero.
     */ constructor(executor, onNoObservers){
        this.observers = [];
        this.unsubscribes = [];
        this.observerCount = 0;
        // Micro-task scheduling by calling task.then().
        this.task = Promise.resolve();
        this.finalized = false;
        this.onNoObservers = onNoObservers;
        // Call the executor asynchronously so subscribers that are called
        // synchronously after the creation of the subscribe function
        // can still receive the very first value generated in the executor.
        this.task.then(()=>{
            executor(this);
        }).catch((e)=>{
            this.error(e);
        });
    }
    next(value) {
        this.forEachObserver((observer)=>{
            observer.next(value);
        });
    }
    error(error) {
        this.forEachObserver((observer)=>{
            observer.error(error);
        });
        this.close(error);
    }
    complete() {
        this.forEachObserver((observer)=>{
            observer.complete();
        });
        this.close();
    }
    /**
     * Subscribe function that can be used to add an Observer to the fan-out list.
     *
     * - We require that no event is sent to a subscriber sychronously to their
     *   call to subscribe().
     */ subscribe(nextOrObserver, error, complete) {
        let observer;
        if (nextOrObserver === undefined && error === undefined && complete === undefined) throw new Error("Missing Observer.");
        // Assemble an Observer object when passed as callback functions.
        if ($c38e0f42709c826a$var$implementsAnyMethods(nextOrObserver, [
            "next",
            "error",
            "complete"
        ])) observer = nextOrObserver;
        else observer = {
            next: nextOrObserver,
            error: error,
            complete: complete
        };
        if (observer.next === undefined) observer.next = $c38e0f42709c826a$var$noop;
        if (observer.error === undefined) observer.error = $c38e0f42709c826a$var$noop;
        if (observer.complete === undefined) observer.complete = $c38e0f42709c826a$var$noop;
        const unsub = this.unsubscribeOne.bind(this, this.observers.length);
        // Attempt to subscribe to a terminated Observable - we
        // just respond to the Observer with the final error or complete
        // event.
        if (this.finalized) // eslint-disable-next-line @typescript-eslint/no-floating-promises
        this.task.then(()=>{
            try {
                if (this.finalError) observer.error(this.finalError);
                else observer.complete();
            } catch (e) {
            // nothing
            }
            return;
        });
        this.observers.push(observer);
        return unsub;
    }
    // Unsubscribe is synchronous - we guarantee that no events are sent to
    // any unsubscribed Observer.
    unsubscribeOne(i) {
        if (this.observers === undefined || this.observers[i] === undefined) return;
        delete this.observers[i];
        this.observerCount -= 1;
        if (this.observerCount === 0 && this.onNoObservers !== undefined) this.onNoObservers(this);
    }
    forEachObserver(fn) {
        if (this.finalized) // Already closed by previous event....just eat the additional values.
        return;
        // Since sendOne calls asynchronously - there is no chance that
        // this.observers will become undefined.
        for(let i = 0; i < this.observers.length; i++)this.sendOne(i, fn);
    }
    // Call the Observer via one of it's callback function. We are careful to
    // confirm that the observe has not been unsubscribed since this asynchronous
    // function had been queued.
    sendOne(i, fn) {
        // Execute the callback asynchronously
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        this.task.then(()=>{
            if (this.observers !== undefined && this.observers[i] !== undefined) try {
                fn(this.observers[i]);
            } catch (e) {
                // Ignore exceptions raised in Observers or missing methods of an
                // Observer.
                // Log error to console. b/31404806
                if (typeof console !== "undefined" && console.error) console.error(e);
            }
        });
    }
    close(err) {
        if (this.finalized) return;
        this.finalized = true;
        if (err !== undefined) this.finalError = err;
        // Proxy is no longer needed - garbage collect references
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        this.task.then(()=>{
            this.observers = undefined;
            this.onNoObservers = undefined;
        });
    }
}
/** Turn synchronous function into one called asynchronously. */ // eslint-disable-next-line @typescript-eslint/ban-types
function $c38e0f42709c826a$export$12af436354f1a4f7(fn, onError) {
    return (...args)=>{
        Promise.resolve(true).then(()=>{
            fn(...args);
        }).catch((error)=>{
            if (onError) onError(error);
        });
    };
}
/**
 * Return true if the object passed in implements any of the named methods.
 */ function $c38e0f42709c826a$var$implementsAnyMethods(obj, methods) {
    if (typeof obj !== "object" || obj === null) return false;
    for (const method of methods){
        if (method in obj && typeof obj[method] === "function") return true;
    }
    return false;
}
function $c38e0f42709c826a$var$noop() {
// do nothing
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Check to make sure the appropriate number of arguments are provided for a public function.
 * Throws an error if it fails.
 *
 * @param fnName The function name
 * @param minCount The minimum number of arguments to allow for the function call
 * @param maxCount The maximum number of argument to allow for the function call
 * @param argCount The actual number of arguments provided.
 */ const $c38e0f42709c826a$export$20164226a0ed35c3 = function(fnName, minCount, maxCount, argCount) {
    let argError;
    if (argCount < minCount) argError = "at least " + minCount;
    else if (argCount > maxCount) argError = maxCount === 0 ? "none" : "no more than " + maxCount;
    if (argError) {
        const error = fnName + " failed: Was called with " + argCount + (argCount === 1 ? " argument." : " arguments.") + " Expects " + argError + ".";
        throw new Error(error);
    }
};
/**
 * Generates a string to prefix an error message about failed argument validation
 *
 * @param fnName The function name
 * @param argName The name of the argument
 * @return The prefix to add to the error thrown for validation.
 */ function $c38e0f42709c826a$export$adea4917e02d93dc(fnName, argName) {
    return `${fnName} failed: ${argName} argument `;
}
/**
 * @param fnName
 * @param argumentNumber
 * @param namespace
 * @param optional
 */ function $c38e0f42709c826a$export$8eef22622e725943(fnName, namespace, optional) {
    if (optional && !namespace) return;
    if (typeof namespace !== "string") //TODO: I should do more validation here. We only allow certain chars in namespaces.
    throw new Error($c38e0f42709c826a$export$adea4917e02d93dc(fnName, "namespace") + "must be a valid firebase namespace.");
}
function $c38e0f42709c826a$export$5bcd2a2eb6640dfa(fnName, argumentName, // eslint-disable-next-line @typescript-eslint/ban-types
callback, optional) {
    if (optional && !callback) return;
    if (typeof callback !== "function") throw new Error($c38e0f42709c826a$export$adea4917e02d93dc(fnName, argumentName) + "must be a valid function.");
}
function $c38e0f42709c826a$export$df77539402cfb523(fnName, argumentName, context, optional) {
    if (optional && !context) return;
    if (typeof context !== "object" || context === null) throw new Error($c38e0f42709c826a$export$adea4917e02d93dc(fnName, argumentName) + "must be a valid context object.");
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // Code originally came from goog.crypt.stringToUtf8ByteArray, but for some reason they
// automatically replaced '\r\n' with '\n', and they didn't handle surrogate pairs,
// so it's been modified.
// Note that not all Unicode characters appear as single characters in JavaScript strings.
// fromCharCode returns the UTF-16 encoding of a character - so some Unicode characters
// use 2 characters in Javascript.  All 4-byte UTF-8 characters begin with a first
// character in the range 0xD800 - 0xDBFF (the first character of a so-called surrogate
// pair).
// See http://www.ecma-international.org/ecma-262/5.1/#sec-15.1.3
/**
 * @param {string} str
 * @return {Array}
 */ const $c38e0f42709c826a$export$655666783217a925 = function(str) {
    const out = [];
    let p = 0;
    for(let i = 0; i < str.length; i++){
        let c = str.charCodeAt(i);
        // Is this the lead surrogate in a surrogate pair?
        if (c >= 0xd800 && c <= 0xdbff) {
            const high = c - 0xd800; // the high 10 bits.
            i++;
            $c38e0f42709c826a$export$a7a9523472993e97(i < str.length, "Surrogate pair missing trail surrogate.");
            const low = str.charCodeAt(i) - 0xdc00; // the low 10 bits.
            c = 0x10000 + (high << 10) + low;
        }
        if (c < 128) out[p++] = c;
        else if (c < 2048) {
            out[p++] = c >> 6 | 192;
            out[p++] = c & 63 | 128;
        } else if (c < 65536) {
            out[p++] = c >> 12 | 224;
            out[p++] = c >> 6 & 63 | 128;
            out[p++] = c & 63 | 128;
        } else {
            out[p++] = c >> 18 | 240;
            out[p++] = c >> 12 & 63 | 128;
            out[p++] = c >> 6 & 63 | 128;
            out[p++] = c & 63 | 128;
        }
    }
    return out;
};
/**
 * Calculate length without actually converting; useful for doing cheaper validation.
 * @param {string} str
 * @return {number}
 */ const $c38e0f42709c826a$export$9536dc0a75b20bf9 = function(str) {
    let p = 0;
    for(let i = 0; i < str.length; i++){
        const c = str.charCodeAt(i);
        if (c < 128) p++;
        else if (c < 2048) p += 2;
        else if (c >= 0xd800 && c <= 0xdbff) {
            // Lead surrogate of a surrogate pair.  The pair together will take 4 bytes to represent.
            p += 4;
            i++; // skip trail surrogate.
        } else p += 3;
    }
    return p;
};
/**
 * @license
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Copied from https://stackoverflow.com/a/2117523
 * Generates a new uuid.
 * @public
 */ const $c38e0f42709c826a$export$abe4376e1bf796d6 = function() {
    return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, (c)=>{
        const r = Math.random() * 16 | 0, v = c === "x" ? r : r & 0x3 | 0x8;
        return v.toString(16);
    });
};
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * The amount of milliseconds to exponentially increase.
 */ const $c38e0f42709c826a$var$DEFAULT_INTERVAL_MILLIS = 1000;
/**
 * The factor to backoff by.
 * Should be a number greater than 1.
 */ const $c38e0f42709c826a$var$DEFAULT_BACKOFF_FACTOR = 2;
/**
 * The maximum milliseconds to increase to.
 *
 * <p>Visible for testing
 */ const $c38e0f42709c826a$export$bdf1213ffbdb096e = 14400000; // Four hours, like iOS and Android.
/**
 * The percentage of backoff time to randomize by.
 * See
 * http://go/safe-client-behavior#step-1-determine-the-appropriate-retry-interval-to-handle-spike-traffic
 * for context.
 *
 * <p>Visible for testing
 */ const $c38e0f42709c826a$export$3518ed2cfe61fa30 = 0.5;
/**
 * Based on the backoff method from
 * https://github.com/google/closure-library/blob/master/closure/goog/math/exponentialbackoff.js.
 * Extracted here so we don't need to pass metadata and a stateful ExponentialBackoff object around.
 */ function $c38e0f42709c826a$export$4d810c0ca64ed8e9(backoffCount, intervalMillis = $c38e0f42709c826a$var$DEFAULT_INTERVAL_MILLIS, backoffFactor = $c38e0f42709c826a$var$DEFAULT_BACKOFF_FACTOR) {
    // Calculates an exponentially increasing value.
    // Deviation: calculates value from count and a constant interval, so we only need to save value
    // and count to restore state.
    const currBaseValue = intervalMillis * Math.pow(backoffFactor, backoffCount);
    // A random "fuzz" to avoid waves of retries.
    // Deviation: randomFactor is required.
    const randomWait = Math.round(// A fraction of the backoff value to add/subtract.
    // Deviation: changes multiplication order to improve readability.
    $c38e0f42709c826a$export$3518ed2cfe61fa30 * currBaseValue * // A random float (rounded to int by Math.round above) in the range [-1, 1]. Determines
    // if we add or subtract.
    (Math.random() - 0.5) * 2);
    // Limits backoff to max to avoid effectively permanent backoff.
    return Math.min($c38e0f42709c826a$export$bdf1213ffbdb096e, currBaseValue + randomWait);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Provide English ordinal letters after a number
 */ function $c38e0f42709c826a$export$7bb39f879164e4ac(i) {
    if (!Number.isFinite(i)) return `${i}`;
    return i + $c38e0f42709c826a$var$indicator(i);
}
function $c38e0f42709c826a$var$indicator(i) {
    i = Math.abs(i);
    const cent = i % 100;
    if (cent >= 10 && cent <= 20) return "th";
    const dec = i % 10;
    if (dec === 1) return "st";
    if (dec === 2) return "nd";
    if (dec === 3) return "rd";
    return "th";
}
/**
 * @license
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $c38e0f42709c826a$export$4befe9b5fa509a1b(service) {
    if (service && service._delegate) return service._delegate;
    else return service;
}


/**
 * Component for service name T, e.g. `auth`, `auth-internal`
 */ class $a83e7ccd68ca8d4e$export$16fa2f45be04daa8 {
    /**
     *
     * @param name The public service name, e.g. app, auth, firestore, database
     * @param instanceFactory Service factory responsible for creating the public interface
     * @param type whether the service provided by the component is public or private
     */ constructor(name, instanceFactory, type){
        this.name = name;
        this.instanceFactory = instanceFactory;
        this.type = type;
        this.multipleInstances = false;
        /**
         * Properties to be added to the service namespace
         */ this.serviceProps = {};
        this.instantiationMode = "LAZY" /* InstantiationMode.LAZY */ ;
        this.onInstanceCreated = null;
    }
    setInstantiationMode(mode) {
        this.instantiationMode = mode;
        return this;
    }
    setMultipleInstances(multipleInstances) {
        this.multipleInstances = multipleInstances;
        return this;
    }
    setServiceProps(props) {
        this.serviceProps = props;
        return this;
    }
    setInstanceCreatedCallback(callback) {
        this.onInstanceCreated = callback;
        return this;
    }
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $a83e7ccd68ca8d4e$var$DEFAULT_ENTRY_NAME = "[DEFAULT]";
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Provider for instance for service name T, e.g. 'auth', 'auth-internal'
 * NameServiceMapping[T] is an alias for the type of the instance
 */ class $a83e7ccd68ca8d4e$export$2881499e37b75b9a {
    constructor(name, container){
        this.name = name;
        this.container = container;
        this.component = null;
        this.instances = new Map();
        this.instancesDeferred = new Map();
        this.instancesOptions = new Map();
        this.onInitCallbacks = new Map();
    }
    /**
     * @param identifier A provider can provide mulitple instances of a service
     * if this.component.multipleInstances is true.
     */ get(identifier) {
        // if multipleInstances is not supported, use the default name
        const normalizedIdentifier = this.normalizeInstanceIdentifier(identifier);
        if (!this.instancesDeferred.has(normalizedIdentifier)) {
            const deferred = new (0, $c38e0f42709c826a$export$85f6557964517f1a)();
            this.instancesDeferred.set(normalizedIdentifier, deferred);
            if (this.isInitialized(normalizedIdentifier) || this.shouldAutoInitialize()) // initialize the service if it can be auto-initialized
            try {
                const instance = this.getOrInitializeService({
                    instanceIdentifier: normalizedIdentifier
                });
                if (instance) deferred.resolve(instance);
            } catch (e) {
            // when the instance factory throws an exception during get(), it should not cause
            // a fatal error. We just return the unresolved promise in this case.
            }
        }
        return this.instancesDeferred.get(normalizedIdentifier).promise;
    }
    getImmediate(options) {
        var _a;
        // if multipleInstances is not supported, use the default name
        const normalizedIdentifier = this.normalizeInstanceIdentifier(options === null || options === void 0 ? void 0 : options.identifier);
        const optional = (_a = options === null || options === void 0 ? void 0 : options.optional) !== null && _a !== void 0 ? _a : false;
        if (this.isInitialized(normalizedIdentifier) || this.shouldAutoInitialize()) try {
            return this.getOrInitializeService({
                instanceIdentifier: normalizedIdentifier
            });
        } catch (e) {
            if (optional) return null;
            else throw e;
        }
        else {
            // In case a component is not initialized and should/can not be auto-initialized at the moment, return null if the optional flag is set, or throw
            if (optional) return null;
            else throw Error(`Service ${this.name} is not available`);
        }
    }
    getComponent() {
        return this.component;
    }
    setComponent(component) {
        if (component.name !== this.name) throw Error(`Mismatching Component ${component.name} for Provider ${this.name}.`);
        if (this.component) throw Error(`Component for ${this.name} has already been provided`);
        this.component = component;
        // return early without attempting to initialize the component if the component requires explicit initialization (calling `Provider.initialize()`)
        if (!this.shouldAutoInitialize()) return;
        // if the service is eager, initialize the default instance
        if ($a83e7ccd68ca8d4e$var$isComponentEager(component)) try {
            this.getOrInitializeService({
                instanceIdentifier: $a83e7ccd68ca8d4e$var$DEFAULT_ENTRY_NAME
            });
        } catch (e) {
        // when the instance factory for an eager Component throws an exception during the eager
        // initialization, it should not cause a fatal error.
        // TODO: Investigate if we need to make it configurable, because some component may want to cause
        // a fatal error in this case?
        }
        // Create service instances for the pending promises and resolve them
        // NOTE: if this.multipleInstances is false, only the default instance will be created
        // and all promises with resolve with it regardless of the identifier.
        for (const [instanceIdentifier, instanceDeferred] of this.instancesDeferred.entries()){
            const normalizedIdentifier = this.normalizeInstanceIdentifier(instanceIdentifier);
            try {
                // `getOrInitializeService()` should always return a valid instance since a component is guaranteed. use ! to make typescript happy.
                const instance = this.getOrInitializeService({
                    instanceIdentifier: normalizedIdentifier
                });
                instanceDeferred.resolve(instance);
            } catch (e) {
            // when the instance factory throws an exception, it should not cause
            // a fatal error. We just leave the promise unresolved.
            }
        }
    }
    clearInstance(identifier = $a83e7ccd68ca8d4e$var$DEFAULT_ENTRY_NAME) {
        this.instancesDeferred.delete(identifier);
        this.instancesOptions.delete(identifier);
        this.instances.delete(identifier);
    }
    // app.delete() will call this method on every provider to delete the services
    // TODO: should we mark the provider as deleted?
    async delete() {
        const services = Array.from(this.instances.values());
        await Promise.all([
            ...services.filter((service)=>"INTERNAL" in service) // legacy services
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            .map((service)=>service.INTERNAL.delete()),
            ...services.filter((service)=>"_delete" in service) // modularized services
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            .map((service)=>service._delete())
        ]);
    }
    isComponentSet() {
        return this.component != null;
    }
    isInitialized(identifier = $a83e7ccd68ca8d4e$var$DEFAULT_ENTRY_NAME) {
        return this.instances.has(identifier);
    }
    getOptions(identifier = $a83e7ccd68ca8d4e$var$DEFAULT_ENTRY_NAME) {
        return this.instancesOptions.get(identifier) || {};
    }
    initialize(opts = {}) {
        const { options: options = {} } = opts;
        const normalizedIdentifier = this.normalizeInstanceIdentifier(opts.instanceIdentifier);
        if (this.isInitialized(normalizedIdentifier)) throw Error(`${this.name}(${normalizedIdentifier}) has already been initialized`);
        if (!this.isComponentSet()) throw Error(`Component ${this.name} has not been registered yet`);
        const instance = this.getOrInitializeService({
            instanceIdentifier: normalizedIdentifier,
            options: options
        });
        // resolve any pending promise waiting for the service instance
        for (const [instanceIdentifier, instanceDeferred] of this.instancesDeferred.entries()){
            const normalizedDeferredIdentifier = this.normalizeInstanceIdentifier(instanceIdentifier);
            if (normalizedIdentifier === normalizedDeferredIdentifier) instanceDeferred.resolve(instance);
        }
        return instance;
    }
    /**
     *
     * @param callback - a function that will be invoked  after the provider has been initialized by calling provider.initialize().
     * The function is invoked SYNCHRONOUSLY, so it should not execute any longrunning tasks in order to not block the program.
     *
     * @param identifier An optional instance identifier
     * @returns a function to unregister the callback
     */ onInit(callback, identifier) {
        var _a;
        const normalizedIdentifier = this.normalizeInstanceIdentifier(identifier);
        const existingCallbacks = (_a = this.onInitCallbacks.get(normalizedIdentifier)) !== null && _a !== void 0 ? _a : new Set();
        existingCallbacks.add(callback);
        this.onInitCallbacks.set(normalizedIdentifier, existingCallbacks);
        const existingInstance = this.instances.get(normalizedIdentifier);
        if (existingInstance) callback(existingInstance, normalizedIdentifier);
        return ()=>{
            existingCallbacks.delete(callback);
        };
    }
    /**
     * Invoke onInit callbacks synchronously
     * @param instance the service instance`
     */ invokeOnInitCallbacks(instance, identifier) {
        const callbacks = this.onInitCallbacks.get(identifier);
        if (!callbacks) return;
        for (const callback of callbacks)try {
            callback(instance, identifier);
        } catch (_a) {
        // ignore errors in the onInit callback
        }
    }
    getOrInitializeService({ instanceIdentifier: instanceIdentifier, options: options = {} }) {
        let instance = this.instances.get(instanceIdentifier);
        if (!instance && this.component) {
            instance = this.component.instanceFactory(this.container, {
                instanceIdentifier: $a83e7ccd68ca8d4e$var$normalizeIdentifierForFactory(instanceIdentifier),
                options: options
            });
            this.instances.set(instanceIdentifier, instance);
            this.instancesOptions.set(instanceIdentifier, options);
            /**
             * Invoke onInit listeners.
             * Note this.component.onInstanceCreated is different, which is used by the component creator,
             * while onInit listeners are registered by consumers of the provider.
             */ this.invokeOnInitCallbacks(instance, instanceIdentifier);
            /**
             * Order is important
             * onInstanceCreated() should be called after this.instances.set(instanceIdentifier, instance); which
             * makes `isInitialized()` return true.
             */ if (this.component.onInstanceCreated) try {
                this.component.onInstanceCreated(this.container, instanceIdentifier, instance);
            } catch (_a) {
            // ignore errors in the onInstanceCreatedCallback
            }
        }
        return instance || null;
    }
    normalizeInstanceIdentifier(identifier = $a83e7ccd68ca8d4e$var$DEFAULT_ENTRY_NAME) {
        if (this.component) return this.component.multipleInstances ? identifier : $a83e7ccd68ca8d4e$var$DEFAULT_ENTRY_NAME;
        else return identifier; // assume multiple instances are supported before the component is provided.
    }
    shouldAutoInitialize() {
        return !!this.component && this.component.instantiationMode !== "EXPLICIT" /* InstantiationMode.EXPLICIT */ ;
    }
}
// undefined should be passed to the service factory for the default instance
function $a83e7ccd68ca8d4e$var$normalizeIdentifierForFactory(identifier) {
    return identifier === $a83e7ccd68ca8d4e$var$DEFAULT_ENTRY_NAME ? undefined : identifier;
}
function $a83e7ccd68ca8d4e$var$isComponentEager(component) {
    return component.instantiationMode === "EAGER" /* InstantiationMode.EAGER */ ;
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * ComponentContainer that provides Providers for service name T, e.g. `auth`, `auth-internal`
 */ class $a83e7ccd68ca8d4e$export$436a80eea5d5c0c5 {
    constructor(name){
        this.name = name;
        this.providers = new Map();
    }
    /**
     *
     * @param component Component being added
     * @param overwrite When a component with the same name has already been registered,
     * if overwrite is true: overwrite the existing component with the new component and create a new
     * provider with the new component. It can be useful in tests where you want to use different mocks
     * for different tests.
     * if overwrite is false: throw an exception
     */ addComponent(component) {
        const provider = this.getProvider(component.name);
        if (provider.isComponentSet()) throw new Error(`Component ${component.name} has already been registered with ${this.name}`);
        provider.setComponent(component);
    }
    addOrOverwriteComponent(component) {
        const provider = this.getProvider(component.name);
        if (provider.isComponentSet()) // delete the existing provider from the container, so we can register the new component
        this.providers.delete(component.name);
        this.addComponent(component);
    }
    /**
     * getProvider provides a type safe interface where it can only be called with a field name
     * present in NameServiceMapping interface.
     *
     * Firebase SDKs providing services should extend NameServiceMapping interface to register
     * themselves.
     */ getProvider(name) {
        if (this.providers.has(name)) return this.providers.get(name);
        // create a Provider for a service that hasn't registered with Firebase
        const provider = new $a83e7ccd68ca8d4e$export$2881499e37b75b9a(name, this);
        this.providers.set(name, provider);
        return provider;
    }
    getProviders() {
        return Array.from(this.providers.values());
    }
}


/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * A container for all of the Logger instances
 */ const $45b460d9de9b230f$var$instances = [];
/**
 * The JS SDK supports 5 log levels and also allows a user the ability to
 * silence the logs altogether.
 *
 * The order is a follows:
 * DEBUG < VERBOSE < INFO < WARN < ERROR
 *
 * All of the log types above the current log level will be captured (i.e. if
 * you set the log level to `INFO`, errors will still be logged, but `DEBUG` and
 * `VERBOSE` logs will not)
 */ var $45b460d9de9b230f$export$243e62d78d3b544d;
(function(LogLevel) {
    LogLevel[LogLevel["DEBUG"] = 0] = "DEBUG";
    LogLevel[LogLevel["VERBOSE"] = 1] = "VERBOSE";
    LogLevel[LogLevel["INFO"] = 2] = "INFO";
    LogLevel[LogLevel["WARN"] = 3] = "WARN";
    LogLevel[LogLevel["ERROR"] = 4] = "ERROR";
    LogLevel[LogLevel["SILENT"] = 5] = "SILENT";
})($45b460d9de9b230f$export$243e62d78d3b544d || ($45b460d9de9b230f$export$243e62d78d3b544d = {}));
const $45b460d9de9b230f$var$levelStringToEnum = {
    "debug": $45b460d9de9b230f$export$243e62d78d3b544d.DEBUG,
    "verbose": $45b460d9de9b230f$export$243e62d78d3b544d.VERBOSE,
    "info": $45b460d9de9b230f$export$243e62d78d3b544d.INFO,
    "warn": $45b460d9de9b230f$export$243e62d78d3b544d.WARN,
    "error": $45b460d9de9b230f$export$243e62d78d3b544d.ERROR,
    "silent": $45b460d9de9b230f$export$243e62d78d3b544d.SILENT
};
/**
 * The default log level
 */ const $45b460d9de9b230f$var$defaultLogLevel = $45b460d9de9b230f$export$243e62d78d3b544d.INFO;
/**
 * By default, `console.debug` is not displayed in the developer console (in
 * chrome). To avoid forcing users to have to opt-in to these logs twice
 * (i.e. once for firebase, and once in the console), we are sending `DEBUG`
 * logs to the `console.log` function.
 */ const $45b460d9de9b230f$var$ConsoleMethod = {
    [$45b460d9de9b230f$export$243e62d78d3b544d.DEBUG]: "log",
    [$45b460d9de9b230f$export$243e62d78d3b544d.VERBOSE]: "log",
    [$45b460d9de9b230f$export$243e62d78d3b544d.INFO]: "info",
    [$45b460d9de9b230f$export$243e62d78d3b544d.WARN]: "warn",
    [$45b460d9de9b230f$export$243e62d78d3b544d.ERROR]: "error"
};
/**
 * The default log handler will forward DEBUG, VERBOSE, INFO, WARN, and ERROR
 * messages on to their corresponding console counterparts (if the log method
 * is supported by the current log level)
 */ const $45b460d9de9b230f$var$defaultLogHandler = (instance, logType, ...args)=>{
    if (logType < instance.logLevel) return;
    const now = new Date().toISOString();
    const method = $45b460d9de9b230f$var$ConsoleMethod[logType];
    if (method) console[method](`[${now}]  ${instance.name}:`, ...args);
    else throw new Error(`Attempted to log a message with an invalid logType (value: ${logType})`);
};
class $45b460d9de9b230f$export$efa9a398d6368992 {
    /**
     * Gives you an instance of a Logger to capture messages according to
     * Firebase's logging scheme.
     *
     * @param name The name that the logs will be associated with
     */ constructor(name){
        this.name = name;
        /**
         * The log level of the given Logger instance.
         */ this._logLevel = $45b460d9de9b230f$var$defaultLogLevel;
        /**
         * The main (internal) log handler for the Logger instance.
         * Can be set to a new function in internal package code but not by user.
         */ this._logHandler = $45b460d9de9b230f$var$defaultLogHandler;
        /**
         * The optional, additional, user-defined log handler for the Logger instance.
         */ this._userLogHandler = null;
        /**
         * Capture the current instance for later use
         */ $45b460d9de9b230f$var$instances.push(this);
    }
    get logLevel() {
        return this._logLevel;
    }
    set logLevel(val) {
        if (!(val in $45b460d9de9b230f$export$243e62d78d3b544d)) throw new TypeError(`Invalid value "${val}" assigned to \`logLevel\``);
        this._logLevel = val;
    }
    // Workaround for setter/getter having to be the same type.
    setLogLevel(val) {
        this._logLevel = typeof val === "string" ? $45b460d9de9b230f$var$levelStringToEnum[val] : val;
    }
    get logHandler() {
        return this._logHandler;
    }
    set logHandler(val) {
        if (typeof val !== "function") throw new TypeError("Value assigned to `logHandler` must be a function");
        this._logHandler = val;
    }
    get userLogHandler() {
        return this._userLogHandler;
    }
    set userLogHandler(val) {
        this._userLogHandler = val;
    }
    /**
     * The functions below are all based on the `console` interface
     */ debug(...args) {
        this._userLogHandler && this._userLogHandler(this, $45b460d9de9b230f$export$243e62d78d3b544d.DEBUG, ...args);
        this._logHandler(this, $45b460d9de9b230f$export$243e62d78d3b544d.DEBUG, ...args);
    }
    log(...args) {
        this._userLogHandler && this._userLogHandler(this, $45b460d9de9b230f$export$243e62d78d3b544d.VERBOSE, ...args);
        this._logHandler(this, $45b460d9de9b230f$export$243e62d78d3b544d.VERBOSE, ...args);
    }
    info(...args) {
        this._userLogHandler && this._userLogHandler(this, $45b460d9de9b230f$export$243e62d78d3b544d.INFO, ...args);
        this._logHandler(this, $45b460d9de9b230f$export$243e62d78d3b544d.INFO, ...args);
    }
    warn(...args) {
        this._userLogHandler && this._userLogHandler(this, $45b460d9de9b230f$export$243e62d78d3b544d.WARN, ...args);
        this._logHandler(this, $45b460d9de9b230f$export$243e62d78d3b544d.WARN, ...args);
    }
    error(...args) {
        this._userLogHandler && this._userLogHandler(this, $45b460d9de9b230f$export$243e62d78d3b544d.ERROR, ...args);
        this._logHandler(this, $45b460d9de9b230f$export$243e62d78d3b544d.ERROR, ...args);
    }
}
function $45b460d9de9b230f$export$c622e99c0ce7b1c9(level) {
    $45b460d9de9b230f$var$instances.forEach((inst)=>{
        inst.setLogLevel(level);
    });
}
function $45b460d9de9b230f$export$29577d29c84db5f6(logCallback, options) {
    for (const instance of $45b460d9de9b230f$var$instances){
        let customLogLevel = null;
        if (options && options.level) customLogLevel = $45b460d9de9b230f$var$levelStringToEnum[options.level];
        if (logCallback === null) instance.userLogHandler = null;
        else instance.userLogHandler = (instance, level, ...args)=>{
            const message = args.map((arg)=>{
                if (arg == null) return null;
                else if (typeof arg === "string") return arg;
                else if (typeof arg === "number" || typeof arg === "boolean") return arg.toString();
                else if (arg instanceof Error) return arg.message;
                else try {
                    return JSON.stringify(arg);
                } catch (ignored) {
                    return null;
                }
            }).filter((arg)=>arg).join(" ");
            if (level >= (customLogLevel !== null && customLogLevel !== void 0 ? customLogLevel : instance.logLevel)) logCallback({
                level: $45b460d9de9b230f$export$243e62d78d3b544d[level].toLowerCase(),
                message: message,
                args: args,
                type: instance.name
            });
        };
    }
}



const $e67bf383372d72f4$export$23f2a1d2818174ef = (object, constructors)=>constructors.some((c)=>object instanceof c);
let $e67bf383372d72f4$var$idbProxyableTypes;
let $e67bf383372d72f4$var$cursorAdvanceMethods;
// This is a function to prevent it throwing up in node environments.
function $e67bf383372d72f4$var$getIdbProxyableTypes() {
    return $e67bf383372d72f4$var$idbProxyableTypes || ($e67bf383372d72f4$var$idbProxyableTypes = [
        IDBDatabase,
        IDBObjectStore,
        IDBIndex,
        IDBCursor,
        IDBTransaction
    ]);
}
// This is a function to prevent it throwing up in node environments.
function $e67bf383372d72f4$var$getCursorAdvanceMethods() {
    return $e67bf383372d72f4$var$cursorAdvanceMethods || ($e67bf383372d72f4$var$cursorAdvanceMethods = [
        IDBCursor.prototype.advance,
        IDBCursor.prototype.continue,
        IDBCursor.prototype.continuePrimaryKey
    ]);
}
const $e67bf383372d72f4$var$cursorRequestMap = new WeakMap();
const $e67bf383372d72f4$var$transactionDoneMap = new WeakMap();
const $e67bf383372d72f4$var$transactionStoreNamesMap = new WeakMap();
const $e67bf383372d72f4$var$transformCache = new WeakMap();
const $e67bf383372d72f4$export$407448d2b89b1813 = new WeakMap();
function $e67bf383372d72f4$var$promisifyRequest(request) {
    const promise = new Promise((resolve, reject)=>{
        const unlisten = ()=>{
            request.removeEventListener("success", success);
            request.removeEventListener("error", error);
        };
        const success = ()=>{
            resolve($e67bf383372d72f4$export$efccba1c4a2ef57b(request.result));
            unlisten();
        };
        const error = ()=>{
            reject(request.error);
            unlisten();
        };
        request.addEventListener("success", success);
        request.addEventListener("error", error);
    });
    promise.then((value)=>{
        // Since cursoring reuses the IDBRequest (*sigh*), we cache it for later retrieval
        // (see wrapFunction).
        if (value instanceof IDBCursor) $e67bf383372d72f4$var$cursorRequestMap.set(value, request);
    // Catching to avoid "Uncaught Promise exceptions"
    }).catch(()=>{});
    // This mapping exists in reverseTransformCache but doesn't doesn't exist in transformCache. This
    // is because we create many promises from a single IDBRequest.
    $e67bf383372d72f4$export$407448d2b89b1813.set(promise, request);
    return promise;
}
function $e67bf383372d72f4$var$cacheDonePromiseForTransaction(tx) {
    // Early bail if we've already created a done promise for this transaction.
    if ($e67bf383372d72f4$var$transactionDoneMap.has(tx)) return;
    const done = new Promise((resolve, reject)=>{
        const unlisten = ()=>{
            tx.removeEventListener("complete", complete);
            tx.removeEventListener("error", error);
            tx.removeEventListener("abort", error);
        };
        const complete = ()=>{
            resolve();
            unlisten();
        };
        const error = ()=>{
            reject(tx.error || new DOMException("AbortError", "AbortError"));
            unlisten();
        };
        tx.addEventListener("complete", complete);
        tx.addEventListener("error", error);
        tx.addEventListener("abort", error);
    });
    // Cache it for later retrieval.
    $e67bf383372d72f4$var$transactionDoneMap.set(tx, done);
}
let $e67bf383372d72f4$var$idbProxyTraps = {
    get (target, prop, receiver) {
        if (target instanceof IDBTransaction) {
            // Special handling for transaction.done.
            if (prop === "done") return $e67bf383372d72f4$var$transactionDoneMap.get(target);
            // Polyfill for objectStoreNames because of Edge.
            if (prop === "objectStoreNames") return target.objectStoreNames || $e67bf383372d72f4$var$transactionStoreNamesMap.get(target);
            // Make tx.store return the only store in the transaction, or undefined if there are many.
            if (prop === "store") return receiver.objectStoreNames[1] ? undefined : receiver.objectStore(receiver.objectStoreNames[0]);
        }
        // Else transform whatever we get back.
        return $e67bf383372d72f4$export$efccba1c4a2ef57b(target[prop]);
    },
    set (target, prop, value) {
        target[prop] = value;
        return true;
    },
    has (target, prop) {
        if (target instanceof IDBTransaction && (prop === "done" || prop === "store")) return true;
        return prop in target;
    }
};
function $e67bf383372d72f4$export$43caf9889c228507(callback) {
    $e67bf383372d72f4$var$idbProxyTraps = callback($e67bf383372d72f4$var$idbProxyTraps);
}
function $e67bf383372d72f4$var$wrapFunction(func) {
    // Due to expected object equality (which is enforced by the caching in `wrap`), we
    // only create one new func per func.
    // Edge doesn't support objectStoreNames (booo), so we polyfill it here.
    if (func === IDBDatabase.prototype.transaction && !("objectStoreNames" in IDBTransaction.prototype)) return function(storeNames, ...args) {
        const tx = func.call($e67bf383372d72f4$export$3b14a55fb2447963(this), storeNames, ...args);
        $e67bf383372d72f4$var$transactionStoreNamesMap.set(tx, storeNames.sort ? storeNames.sort() : [
            storeNames
        ]);
        return $e67bf383372d72f4$export$efccba1c4a2ef57b(tx);
    };
    // Cursor methods are special, as the behaviour is a little more different to standard IDB. In
    // IDB, you advance the cursor and wait for a new 'success' on the IDBRequest that gave you the
    // cursor. It's kinda like a promise that can resolve with many values. That doesn't make sense
    // with real promises, so each advance methods returns a new promise for the cursor object, or
    // undefined if the end of the cursor has been reached.
    if ($e67bf383372d72f4$var$getCursorAdvanceMethods().includes(func)) return function(...args) {
        // Calling the original function with the proxy as 'this' causes ILLEGAL INVOCATION, so we use
        // the original object.
        func.apply($e67bf383372d72f4$export$3b14a55fb2447963(this), args);
        return $e67bf383372d72f4$export$efccba1c4a2ef57b($e67bf383372d72f4$var$cursorRequestMap.get(this));
    };
    return function(...args) {
        // Calling the original function with the proxy as 'this' causes ILLEGAL INVOCATION, so we use
        // the original object.
        return $e67bf383372d72f4$export$efccba1c4a2ef57b(func.apply($e67bf383372d72f4$export$3b14a55fb2447963(this), args));
    };
}
function $e67bf383372d72f4$var$transformCachableValue(value) {
    if (typeof value === "function") return $e67bf383372d72f4$var$wrapFunction(value);
    // This doesn't return, it just creates a 'done' promise for the transaction,
    // which is later returned for transaction.done (see idbObjectHandler).
    if (value instanceof IDBTransaction) $e67bf383372d72f4$var$cacheDonePromiseForTransaction(value);
    if ($e67bf383372d72f4$export$23f2a1d2818174ef(value, $e67bf383372d72f4$var$getIdbProxyableTypes())) return new Proxy(value, $e67bf383372d72f4$var$idbProxyTraps);
    // Return the same value back if we're not going to transform it.
    return value;
}
function $e67bf383372d72f4$export$efccba1c4a2ef57b(value) {
    // We sometimes generate multiple promises from a single IDBRequest (eg when cursoring), because
    // IDB is weird and a single IDBRequest can yield many responses, so these can't be cached.
    if (value instanceof IDBRequest) return $e67bf383372d72f4$var$promisifyRequest(value);
    // If we've already transformed this value before, reuse the transformed value.
    // This is faster, but it also provides object equality.
    if ($e67bf383372d72f4$var$transformCache.has(value)) return $e67bf383372d72f4$var$transformCache.get(value);
    const newValue = $e67bf383372d72f4$var$transformCachableValue(value);
    // Not all types are transformed.
    // These may be primitive types, so they can't be WeakMap keys.
    if (newValue !== value) {
        $e67bf383372d72f4$var$transformCache.set(value, newValue);
        $e67bf383372d72f4$export$407448d2b89b1813.set(newValue, value);
    }
    return newValue;
}
const $e67bf383372d72f4$export$3b14a55fb2447963 = (value)=>$e67bf383372d72f4$export$407448d2b89b1813.get(value);


/**
 * Open a database.
 *
 * @param name Name of the database.
 * @param version Schema version.
 * @param callbacks Additional callbacks.
 */ function $da032767b57a4aa4$export$ca0ed41b1a2af7e(name, version, { blocked: blocked, upgrade: upgrade, blocking: blocking, terminated: terminated } = {}) {
    const request = indexedDB.open(name, version);
    const openPromise = (0, $e67bf383372d72f4$export$efccba1c4a2ef57b)(request);
    if (upgrade) request.addEventListener("upgradeneeded", (event)=>{
        upgrade((0, $e67bf383372d72f4$export$efccba1c4a2ef57b)(request.result), event.oldVersion, event.newVersion, (0, $e67bf383372d72f4$export$efccba1c4a2ef57b)(request.transaction), event);
    });
    if (blocked) request.addEventListener("blocked", (event)=>blocked(// Casting due to https://github.com/microsoft/TypeScript-DOM-lib-generator/pull/1405
        event.oldVersion, event.newVersion, event));
    openPromise.then((db)=>{
        if (terminated) db.addEventListener("close", ()=>terminated());
        if (blocking) db.addEventListener("versionchange", (event)=>blocking(event.oldVersion, event.newVersion, event));
    }).catch(()=>{});
    return openPromise;
}
/**
 * Delete a database.
 *
 * @param name Name of the database.
 */ function $da032767b57a4aa4$export$9d6df0ac66a98bb2(name, { blocked: blocked } = {}) {
    const request = indexedDB.deleteDatabase(name);
    if (blocked) request.addEventListener("blocked", (event)=>blocked(// Casting due to https://github.com/microsoft/TypeScript-DOM-lib-generator/pull/1405
        event.oldVersion, event));
    return (0, $e67bf383372d72f4$export$efccba1c4a2ef57b)(request).then(()=>undefined);
}
const $da032767b57a4aa4$var$readMethods = [
    "get",
    "getKey",
    "getAll",
    "getAllKeys",
    "count"
];
const $da032767b57a4aa4$var$writeMethods = [
    "put",
    "add",
    "delete",
    "clear"
];
const $da032767b57a4aa4$var$cachedMethods = new Map();
function $da032767b57a4aa4$var$getMethod(target, prop) {
    if (!(target instanceof IDBDatabase && !(prop in target) && typeof prop === "string")) return;
    if ($da032767b57a4aa4$var$cachedMethods.get(prop)) return $da032767b57a4aa4$var$cachedMethods.get(prop);
    const targetFuncName = prop.replace(/FromIndex$/, "");
    const useIndex = prop !== targetFuncName;
    const isWrite = $da032767b57a4aa4$var$writeMethods.includes(targetFuncName);
    if (// Bail if the target doesn't exist on the target. Eg, getAll isn't in Edge.
    !(targetFuncName in (useIndex ? IDBIndex : IDBObjectStore).prototype) || !(isWrite || $da032767b57a4aa4$var$readMethods.includes(targetFuncName))) return;
    const method = async function(storeName, ...args) {
        // isWrite ? 'readwrite' : undefined gzipps better, but fails in Edge :(
        const tx = this.transaction(storeName, isWrite ? "readwrite" : "readonly");
        let target = tx.store;
        if (useIndex) target = target.index(args.shift());
        // Must reject if op rejects.
        // If it's a write operation, must reject if tx.done rejects.
        // Must reject with op rejection first.
        // Must resolve with op value.
        // Must handle both promises (no unhandled rejections)
        return (await Promise.all([
            target[targetFuncName](...args),
            isWrite && tx.done
        ]))[0];
    };
    $da032767b57a4aa4$var$cachedMethods.set(prop, method);
    return method;
}
(0, $e67bf383372d72f4$export$43caf9889c228507)((oldTraps)=>({
        ...oldTraps,
        get: (target, prop, receiver)=>$da032767b57a4aa4$var$getMethod(target, prop) || oldTraps.get(target, prop, receiver),
        has: (target, prop)=>!!$da032767b57a4aa4$var$getMethod(target, prop) || oldTraps.has(target, prop)
    }));


/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $57d436074e210fb5$var$PlatformLoggerServiceImpl {
    constructor(container){
        this.container = container;
    }
    // In initial implementation, this will be called by installations on
    // auth token refresh, and installations will send this string.
    getPlatformInfoString() {
        const providers = this.container.getProviders();
        // Loop through providers and get library/version pairs from any that are
        // version components.
        return providers.map((provider)=>{
            if ($57d436074e210fb5$var$isVersionServiceProvider(provider)) {
                const service = provider.getImmediate();
                return `${service.library}/${service.version}`;
            } else return null;
        }).filter((logString)=>logString).join(" ");
    }
}
/**
 *
 * @param provider check if this provider provides a VersionService
 *
 * NOTE: Using Provider<'app-version'> is a hack to indicate that the provider
 * provides VersionService. The provider is not necessarily a 'app-version'
 * provider.
 */ function $57d436074e210fb5$var$isVersionServiceProvider(provider) {
    const component = provider.getComponent();
    return (component === null || component === void 0 ? void 0 : component.type) === "VERSION" /* ComponentType.VERSION */ ;
}
const $57d436074e210fb5$var$name$o = "@firebase/app";
const $57d436074e210fb5$var$version$1 = "0.9.13";
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $57d436074e210fb5$var$logger = new (0, $45b460d9de9b230f$export$efa9a398d6368992)("@firebase/app");
const $57d436074e210fb5$var$name$n = "@firebase/app-compat";
const $57d436074e210fb5$var$name$m = "@firebase/analytics-compat";
const $57d436074e210fb5$var$name$l = "@firebase/analytics";
const $57d436074e210fb5$var$name$k = "@firebase/app-check-compat";
const $57d436074e210fb5$var$name$j = "@firebase/app-check";
const $57d436074e210fb5$var$name$i = "@firebase/auth";
const $57d436074e210fb5$var$name$h = "@firebase/auth-compat";
const $57d436074e210fb5$var$name$g = "@firebase/database";
const $57d436074e210fb5$var$name$f = "@firebase/database-compat";
const $57d436074e210fb5$var$name$e = "@firebase/functions";
const $57d436074e210fb5$var$name$d = "@firebase/functions-compat";
const $57d436074e210fb5$var$name$c = "@firebase/installations";
const $57d436074e210fb5$var$name$b = "@firebase/installations-compat";
const $57d436074e210fb5$var$name$a = "@firebase/messaging";
const $57d436074e210fb5$var$name$9 = "@firebase/messaging-compat";
const $57d436074e210fb5$var$name$8 = "@firebase/performance";
const $57d436074e210fb5$var$name$7 = "@firebase/performance-compat";
const $57d436074e210fb5$var$name$6 = "@firebase/remote-config";
const $57d436074e210fb5$var$name$5 = "@firebase/remote-config-compat";
const $57d436074e210fb5$var$name$4 = "@firebase/storage";
const $57d436074e210fb5$var$name$3 = "@firebase/storage-compat";
const $57d436074e210fb5$var$name$2 = "@firebase/firestore";
const $57d436074e210fb5$var$name$1 = "@firebase/firestore-compat";
const $57d436074e210fb5$var$name = "firebase";
const $57d436074e210fb5$var$version = "9.23.0";
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * The default app name
 *
 * @internal
 */ const $57d436074e210fb5$export$9f30fa0c10967f7f = "[DEFAULT]";
const $57d436074e210fb5$var$PLATFORM_LOG_STRING = {
    [$57d436074e210fb5$var$name$o]: "fire-core",
    [$57d436074e210fb5$var$name$n]: "fire-core-compat",
    [$57d436074e210fb5$var$name$l]: "fire-analytics",
    [$57d436074e210fb5$var$name$m]: "fire-analytics-compat",
    [$57d436074e210fb5$var$name$j]: "fire-app-check",
    [$57d436074e210fb5$var$name$k]: "fire-app-check-compat",
    [$57d436074e210fb5$var$name$i]: "fire-auth",
    [$57d436074e210fb5$var$name$h]: "fire-auth-compat",
    [$57d436074e210fb5$var$name$g]: "fire-rtdb",
    [$57d436074e210fb5$var$name$f]: "fire-rtdb-compat",
    [$57d436074e210fb5$var$name$e]: "fire-fn",
    [$57d436074e210fb5$var$name$d]: "fire-fn-compat",
    [$57d436074e210fb5$var$name$c]: "fire-iid",
    [$57d436074e210fb5$var$name$b]: "fire-iid-compat",
    [$57d436074e210fb5$var$name$a]: "fire-fcm",
    [$57d436074e210fb5$var$name$9]: "fire-fcm-compat",
    [$57d436074e210fb5$var$name$8]: "fire-perf",
    [$57d436074e210fb5$var$name$7]: "fire-perf-compat",
    [$57d436074e210fb5$var$name$6]: "fire-rc",
    [$57d436074e210fb5$var$name$5]: "fire-rc-compat",
    [$57d436074e210fb5$var$name$4]: "fire-gcs",
    [$57d436074e210fb5$var$name$3]: "fire-gcs-compat",
    [$57d436074e210fb5$var$name$2]: "fire-fst",
    [$57d436074e210fb5$var$name$1]: "fire-fst-compat",
    "fire-js": "fire-js",
    [$57d436074e210fb5$var$name]: "fire-js-all"
};
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * @internal
 */ const $57d436074e210fb5$export$b4e3c36c855b14b5 = new Map();
/**
 * Registered components.
 *
 * @internal
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
const $57d436074e210fb5$export$9566bce3835c0f28 = new Map();
/**
 * @param component - the component being added to this app's container
 *
 * @internal
 */ function $57d436074e210fb5$export$fa5244b94c62d36a(app, component) {
    try {
        app.container.addComponent(component);
    } catch (e) {
        $57d436074e210fb5$var$logger.debug(`Component ${component.name} failed to register with FirebaseApp ${app.name}`, e);
    }
}
/**
 *
 * @internal
 */ function $57d436074e210fb5$export$4393112b42e2b41d(app, component) {
    app.container.addOrOverwriteComponent(component);
}
/**
 *
 * @param component - the component to register
 * @returns whether or not the component is registered successfully
 *
 * @internal
 */ function $57d436074e210fb5$export$c930050e7bb63965(component) {
    const componentName = component.name;
    if ($57d436074e210fb5$export$9566bce3835c0f28.has(componentName)) {
        $57d436074e210fb5$var$logger.debug(`There were multiple attempts to register component ${componentName}.`);
        return false;
    }
    $57d436074e210fb5$export$9566bce3835c0f28.set(componentName, component);
    // add the component to existing app instances
    for (const app of $57d436074e210fb5$export$b4e3c36c855b14b5.values())$57d436074e210fb5$export$fa5244b94c62d36a(app, component);
    return true;
}
/**
 *
 * @param app - FirebaseApp instance
 * @param name - service name
 *
 * @returns the provider for the service with the matching name
 *
 * @internal
 */ function $57d436074e210fb5$export$fa0d6da0f5838f50(app, name) {
    const heartbeatController = app.container.getProvider("heartbeat").getImmediate({
        optional: true
    });
    if (heartbeatController) heartbeatController.triggerHeartbeat();
    return app.container.getProvider(name);
}
/**
 *
 * @param app - FirebaseApp instance
 * @param name - service name
 * @param instanceIdentifier - service instance identifier in case the service supports multiple instances
 *
 * @internal
 */ function $57d436074e210fb5$export$48d18de2ff1c45a5(app, name, instanceIdentifier = $57d436074e210fb5$export$9f30fa0c10967f7f) {
    $57d436074e210fb5$export$fa0d6da0f5838f50(app, name).clearInstance(instanceIdentifier);
}
/**
 * Test only
 *
 * @internal
 */ function $57d436074e210fb5$export$3685d89b9c3cdfaf() {
    $57d436074e210fb5$export$9566bce3835c0f28.clear();
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $57d436074e210fb5$var$ERRORS = {
    ["no-app" /* AppError.NO_APP */ ]: "No Firebase App '{$appName}' has been created - call initializeApp() first",
    ["bad-app-name" /* AppError.BAD_APP_NAME */ ]: "Illegal App name: '{$appName}",
    ["duplicate-app" /* AppError.DUPLICATE_APP */ ]: "Firebase App named '{$appName}' already exists with different options or config",
    ["app-deleted" /* AppError.APP_DELETED */ ]: "Firebase App named '{$appName}' already deleted",
    ["no-options" /* AppError.NO_OPTIONS */ ]: "Need to provide options, when not being deployed to hosting via source.",
    ["invalid-app-argument" /* AppError.INVALID_APP_ARGUMENT */ ]: "firebase.{$appName}() takes either no argument or a Firebase App instance.",
    ["invalid-log-argument" /* AppError.INVALID_LOG_ARGUMENT */ ]: "First argument to `onLog` must be null or a function.",
    ["idb-open" /* AppError.IDB_OPEN */ ]: "Error thrown when opening IndexedDB. Original error: {$originalErrorMessage}.",
    ["idb-get" /* AppError.IDB_GET */ ]: "Error thrown when reading from IndexedDB. Original error: {$originalErrorMessage}.",
    ["idb-set" /* AppError.IDB_WRITE */ ]: "Error thrown when writing to IndexedDB. Original error: {$originalErrorMessage}.",
    ["idb-delete" /* AppError.IDB_DELETE */ ]: "Error thrown when deleting from IndexedDB. Original error: {$originalErrorMessage}."
};
const $57d436074e210fb5$var$ERROR_FACTORY = new (0, $c38e0f42709c826a$export$3fa6e1b18a3b2d40)("app", "Firebase", $57d436074e210fb5$var$ERRORS);
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $57d436074e210fb5$var$FirebaseAppImpl {
    constructor(options, config, container){
        this._isDeleted = false;
        this._options = Object.assign({}, options);
        this._config = Object.assign({}, config);
        this._name = config.name;
        this._automaticDataCollectionEnabled = config.automaticDataCollectionEnabled;
        this._container = container;
        this.container.addComponent(new (0, $a83e7ccd68ca8d4e$export$16fa2f45be04daa8)("app", ()=>this, "PUBLIC" /* ComponentType.PUBLIC */ ));
    }
    get automaticDataCollectionEnabled() {
        this.checkDestroyed();
        return this._automaticDataCollectionEnabled;
    }
    set automaticDataCollectionEnabled(val) {
        this.checkDestroyed();
        this._automaticDataCollectionEnabled = val;
    }
    get name() {
        this.checkDestroyed();
        return this._name;
    }
    get options() {
        this.checkDestroyed();
        return this._options;
    }
    get config() {
        this.checkDestroyed();
        return this._config;
    }
    get container() {
        return this._container;
    }
    get isDeleted() {
        return this._isDeleted;
    }
    set isDeleted(val) {
        this._isDeleted = val;
    }
    /**
     * This function will throw an Error if the App has already been deleted -
     * use before performing API actions on the App.
     */ checkDestroyed() {
        if (this.isDeleted) throw $57d436074e210fb5$var$ERROR_FACTORY.create("app-deleted" /* AppError.APP_DELETED */ , {
            appName: this._name
        });
    }
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * The current SDK version.
 *
 * @public
 */ const $57d436074e210fb5$export$31499a9cd224b78c = $57d436074e210fb5$var$version;
function $57d436074e210fb5$export$c55cfd413944906d(_options, rawConfig = {}) {
    let options = _options;
    if (typeof rawConfig !== "object") {
        const name = rawConfig;
        rawConfig = {
            name: name
        };
    }
    const config = Object.assign({
        name: $57d436074e210fb5$export$9f30fa0c10967f7f,
        automaticDataCollectionEnabled: false
    }, rawConfig);
    const name = config.name;
    if (typeof name !== "string" || !name) throw $57d436074e210fb5$var$ERROR_FACTORY.create("bad-app-name" /* AppError.BAD_APP_NAME */ , {
        appName: String(name)
    });
    options || (options = (0, $c38e0f42709c826a$export$3dfb6827a9f89756)());
    if (!options) throw $57d436074e210fb5$var$ERROR_FACTORY.create("no-options" /* AppError.NO_OPTIONS */ );
    const existingApp = $57d436074e210fb5$export$b4e3c36c855b14b5.get(name);
    if (existingApp) {
        // return the existing app if options and config deep equal the ones in the existing app.
        if ((0, $c38e0f42709c826a$export$9cb4719e2e525b7a)(options, existingApp.options) && (0, $c38e0f42709c826a$export$9cb4719e2e525b7a)(config, existingApp.config)) return existingApp;
        else throw $57d436074e210fb5$var$ERROR_FACTORY.create("duplicate-app" /* AppError.DUPLICATE_APP */ , {
            appName: name
        });
    }
    const container = new (0, $a83e7ccd68ca8d4e$export$436a80eea5d5c0c5)(name);
    for (const component of $57d436074e210fb5$export$9566bce3835c0f28.values())container.addComponent(component);
    const newApp = new $57d436074e210fb5$var$FirebaseAppImpl(options, config, container);
    $57d436074e210fb5$export$b4e3c36c855b14b5.set(name, newApp);
    return newApp;
}
/**
 * Retrieves a {@link @firebase/app#FirebaseApp} instance.
 *
 * When called with no arguments, the default app is returned. When an app name
 * is provided, the app corresponding to that name is returned.
 *
 * An exception is thrown if the app being retrieved has not yet been
 * initialized.
 *
 * @example
 * ```javascript
 * // Return the default app
 * const app = getApp();
 * ```
 *
 * @example
 * ```javascript
 * // Return a named app
 * const otherApp = getApp("otherApp");
 * ```
 *
 * @param name - Optional name of the app to return. If no name is
 *   provided, the default is `"[DEFAULT]"`.
 *
 * @returns The app corresponding to the provided app name.
 *   If no app name is provided, the default app is returned.
 *
 * @public
 */ function $57d436074e210fb5$export$f9962582c9e66d99(name = $57d436074e210fb5$export$9f30fa0c10967f7f) {
    const app = $57d436074e210fb5$export$b4e3c36c855b14b5.get(name);
    if (!app && name === $57d436074e210fb5$export$9f30fa0c10967f7f && (0, $c38e0f42709c826a$export$3dfb6827a9f89756)()) return $57d436074e210fb5$export$c55cfd413944906d();
    if (!app) throw $57d436074e210fb5$var$ERROR_FACTORY.create("no-app" /* AppError.NO_APP */ , {
        appName: name
    });
    return app;
}
/**
 * A (read-only) array of all initialized apps.
 * @public
 */ function $57d436074e210fb5$export$68ddedf7d44b3bdf() {
    return Array.from($57d436074e210fb5$export$b4e3c36c855b14b5.values());
}
/**
 * Renders this app unusable and frees the resources of all associated
 * services.
 *
 * @example
 * ```javascript
 * deleteApp(app)
 *   .then(function() {
 *     console.log("App deleted successfully");
 *   })
 *   .catch(function(error) {
 *     console.log("Error deleting app:", error);
 *   });
 * ```
 *
 * @public
 */ async function $57d436074e210fb5$export$6eec44aa53d5ea34(app) {
    const name = app.name;
    if ($57d436074e210fb5$export$b4e3c36c855b14b5.has(name)) {
        $57d436074e210fb5$export$b4e3c36c855b14b5.delete(name);
        await Promise.all(app.container.getProviders().map((provider)=>provider.delete()));
        app.isDeleted = true;
    }
}
/**
 * Registers a library's name and version for platform logging purposes.
 * @param library - Name of 1p or 3p library (e.g. firestore, angularfire)
 * @param version - Current version of that library.
 * @param variant - Bundle variant, e.g., node, rn, etc.
 *
 * @public
 */ function $57d436074e210fb5$export$d29d5299a7137abc(libraryKeyOrName, version, variant) {
    var _a;
    // TODO: We can use this check to whitelist strings when/if we set up
    // a good whitelist system.
    let library = (_a = $57d436074e210fb5$var$PLATFORM_LOG_STRING[libraryKeyOrName]) !== null && _a !== void 0 ? _a : libraryKeyOrName;
    if (variant) library += `-${variant}`;
    const libraryMismatch = library.match(/\s|\//);
    const versionMismatch = version.match(/\s|\//);
    if (libraryMismatch || versionMismatch) {
        const warning = [
            `Unable to register library "${library}" with version "${version}":`
        ];
        if (libraryMismatch) warning.push(`library name "${library}" contains illegal characters (whitespace or "/")`);
        if (libraryMismatch && versionMismatch) warning.push("and");
        if (versionMismatch) warning.push(`version name "${version}" contains illegal characters (whitespace or "/")`);
        $57d436074e210fb5$var$logger.warn(warning.join(" "));
        return;
    }
    $57d436074e210fb5$export$c930050e7bb63965(new (0, $a83e7ccd68ca8d4e$export$16fa2f45be04daa8)(`${library}-version`, ()=>({
            library: library,
            version: version
        }), "VERSION" /* ComponentType.VERSION */ ));
}
/**
 * Sets log handler for all Firebase SDKs.
 * @param logCallback - An optional custom log handler that executes user code whenever
 * the Firebase SDK makes a logging call.
 *
 * @public
 */ function $57d436074e210fb5$export$a82ad227dc8163dc(logCallback, options) {
    if (logCallback !== null && typeof logCallback !== "function") throw $57d436074e210fb5$var$ERROR_FACTORY.create("invalid-log-argument" /* AppError.INVALID_LOG_ARGUMENT */ );
    (0, $45b460d9de9b230f$export$29577d29c84db5f6)(logCallback, options);
}
/**
 * Sets log level for all Firebase SDKs.
 *
 * All of the log types above the current log level are captured (i.e. if
 * you set the log level to `info`, errors are logged, but `debug` and
 * `verbose` logs are not).
 *
 * @public
 */ function $57d436074e210fb5$export$c622e99c0ce7b1c9(logLevel) {
    (0, $45b460d9de9b230f$export$c622e99c0ce7b1c9)(logLevel);
}
/**
 * @license
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $57d436074e210fb5$var$DB_NAME = "firebase-heartbeat-database";
const $57d436074e210fb5$var$DB_VERSION = 1;
const $57d436074e210fb5$var$STORE_NAME = "firebase-heartbeat-store";
let $57d436074e210fb5$var$dbPromise = null;
function $57d436074e210fb5$var$getDbPromise() {
    if (!$57d436074e210fb5$var$dbPromise) $57d436074e210fb5$var$dbPromise = (0, $da032767b57a4aa4$export$ca0ed41b1a2af7e)($57d436074e210fb5$var$DB_NAME, $57d436074e210fb5$var$DB_VERSION, {
        upgrade: (db, oldVersion)=>{
            // We don't use 'break' in this switch statement, the fall-through
            // behavior is what we want, because if there are multiple versions between
            // the old version and the current version, we want ALL the migrations
            // that correspond to those versions to run, not only the last one.
            // eslint-disable-next-line default-case
            switch(oldVersion){
                case 0:
                    db.createObjectStore($57d436074e210fb5$var$STORE_NAME);
            }
        }
    }).catch((e)=>{
        throw $57d436074e210fb5$var$ERROR_FACTORY.create("idb-open" /* AppError.IDB_OPEN */ , {
            originalErrorMessage: e.message
        });
    });
    return $57d436074e210fb5$var$dbPromise;
}
async function $57d436074e210fb5$var$readHeartbeatsFromIndexedDB(app) {
    try {
        const db = await $57d436074e210fb5$var$getDbPromise();
        const result = await db.transaction($57d436074e210fb5$var$STORE_NAME).objectStore($57d436074e210fb5$var$STORE_NAME).get($57d436074e210fb5$var$computeKey(app));
        return result;
    } catch (e) {
        if (e instanceof (0, $c38e0f42709c826a$export$dd24e9cd51226c56)) $57d436074e210fb5$var$logger.warn(e.message);
        else {
            const idbGetError = $57d436074e210fb5$var$ERROR_FACTORY.create("idb-get" /* AppError.IDB_GET */ , {
                originalErrorMessage: e === null || e === void 0 ? void 0 : e.message
            });
            $57d436074e210fb5$var$logger.warn(idbGetError.message);
        }
    }
}
async function $57d436074e210fb5$var$writeHeartbeatsToIndexedDB(app, heartbeatObject) {
    try {
        const db = await $57d436074e210fb5$var$getDbPromise();
        const tx = db.transaction($57d436074e210fb5$var$STORE_NAME, "readwrite");
        const objectStore = tx.objectStore($57d436074e210fb5$var$STORE_NAME);
        await objectStore.put(heartbeatObject, $57d436074e210fb5$var$computeKey(app));
        await tx.done;
    } catch (e) {
        if (e instanceof (0, $c38e0f42709c826a$export$dd24e9cd51226c56)) $57d436074e210fb5$var$logger.warn(e.message);
        else {
            const idbGetError = $57d436074e210fb5$var$ERROR_FACTORY.create("idb-set" /* AppError.IDB_WRITE */ , {
                originalErrorMessage: e === null || e === void 0 ? void 0 : e.message
            });
            $57d436074e210fb5$var$logger.warn(idbGetError.message);
        }
    }
}
function $57d436074e210fb5$var$computeKey(app) {
    return `${app.name}!${app.options.appId}`;
}
/**
 * @license
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $57d436074e210fb5$var$MAX_HEADER_BYTES = 1024;
// 30 days
const $57d436074e210fb5$var$STORED_HEARTBEAT_RETENTION_MAX_MILLIS = 2592000000;
class $57d436074e210fb5$var$HeartbeatServiceImpl {
    constructor(container){
        this.container = container;
        /**
         * In-memory cache for heartbeats, used by getHeartbeatsHeader() to generate
         * the header string.
         * Stores one record per date. This will be consolidated into the standard
         * format of one record per user agent string before being sent as a header.
         * Populated from indexedDB when the controller is instantiated and should
         * be kept in sync with indexedDB.
         * Leave public for easier testing.
         */ this._heartbeatsCache = null;
        const app = this.container.getProvider("app").getImmediate();
        this._storage = new $57d436074e210fb5$var$HeartbeatStorageImpl(app);
        this._heartbeatsCachePromise = this._storage.read().then((result)=>{
            this._heartbeatsCache = result;
            return result;
        });
    }
    /**
     * Called to report a heartbeat. The function will generate
     * a HeartbeatsByUserAgent object, update heartbeatsCache, and persist it
     * to IndexedDB.
     * Note that we only store one heartbeat per day. So if a heartbeat for today is
     * already logged, subsequent calls to this function in the same day will be ignored.
     */ async triggerHeartbeat() {
        const platformLogger = this.container.getProvider("platform-logger").getImmediate();
        // This is the "Firebase user agent" string from the platform logger
        // service, not the browser user agent.
        const agent = platformLogger.getPlatformInfoString();
        const date = $57d436074e210fb5$var$getUTCDateString();
        if (this._heartbeatsCache === null) this._heartbeatsCache = await this._heartbeatsCachePromise;
        // Do not store a heartbeat if one is already stored for this day
        // or if a header has already been sent today.
        if (this._heartbeatsCache.lastSentHeartbeatDate === date || this._heartbeatsCache.heartbeats.some((singleDateHeartbeat)=>singleDateHeartbeat.date === date)) return;
        else // There is no entry for this date. Create one.
        this._heartbeatsCache.heartbeats.push({
            date: date,
            agent: agent
        });
        // Remove entries older than 30 days.
        this._heartbeatsCache.heartbeats = this._heartbeatsCache.heartbeats.filter((singleDateHeartbeat)=>{
            const hbTimestamp = new Date(singleDateHeartbeat.date).valueOf();
            const now = Date.now();
            return now - hbTimestamp <= $57d436074e210fb5$var$STORED_HEARTBEAT_RETENTION_MAX_MILLIS;
        });
        return this._storage.overwrite(this._heartbeatsCache);
    }
    /**
     * Returns a base64 encoded string which can be attached to the heartbeat-specific header directly.
     * It also clears all heartbeats from memory as well as in IndexedDB.
     *
     * NOTE: Consuming product SDKs should not send the header if this method
     * returns an empty string.
     */ async getHeartbeatsHeader() {
        if (this._heartbeatsCache === null) await this._heartbeatsCachePromise;
        // If it's still null or the array is empty, there is no data to send.
        if (this._heartbeatsCache === null || this._heartbeatsCache.heartbeats.length === 0) return "";
        const date = $57d436074e210fb5$var$getUTCDateString();
        // Extract as many heartbeats from the cache as will fit under the size limit.
        const { heartbeatsToSend: heartbeatsToSend, unsentEntries: unsentEntries } = $57d436074e210fb5$var$extractHeartbeatsForHeader(this._heartbeatsCache.heartbeats);
        const headerString = (0, $c38e0f42709c826a$export$4b5284a3025a455)(JSON.stringify({
            version: 2,
            heartbeats: heartbeatsToSend
        }));
        // Store last sent date to prevent another being logged/sent for the same day.
        this._heartbeatsCache.lastSentHeartbeatDate = date;
        if (unsentEntries.length > 0) {
            // Store any unsent entries if they exist.
            this._heartbeatsCache.heartbeats = unsentEntries;
            // This seems more likely than emptying the array (below) to lead to some odd state
            // since the cache isn't empty and this will be called again on the next request,
            // and is probably safest if we await it.
            await this._storage.overwrite(this._heartbeatsCache);
        } else {
            this._heartbeatsCache.heartbeats = [];
            // Do not wait for this, to reduce latency.
            this._storage.overwrite(this._heartbeatsCache);
        }
        return headerString;
    }
}
function $57d436074e210fb5$var$getUTCDateString() {
    const today = new Date();
    // Returns date format 'YYYY-MM-DD'
    return today.toISOString().substring(0, 10);
}
function $57d436074e210fb5$var$extractHeartbeatsForHeader(heartbeatsCache, maxSize = $57d436074e210fb5$var$MAX_HEADER_BYTES) {
    // Heartbeats grouped by user agent in the standard format to be sent in
    // the header.
    const heartbeatsToSend = [];
    // Single date format heartbeats that are not sent.
    let unsentEntries = heartbeatsCache.slice();
    for (const singleDateHeartbeat of heartbeatsCache){
        // Look for an existing entry with the same user agent.
        const heartbeatEntry = heartbeatsToSend.find((hb)=>hb.agent === singleDateHeartbeat.agent);
        if (!heartbeatEntry) {
            // If no entry for this user agent exists, create one.
            heartbeatsToSend.push({
                agent: singleDateHeartbeat.agent,
                dates: [
                    singleDateHeartbeat.date
                ]
            });
            if ($57d436074e210fb5$var$countBytes(heartbeatsToSend) > maxSize) {
                // If the header would exceed max size, remove the added heartbeat
                // entry and stop adding to the header.
                heartbeatsToSend.pop();
                break;
            }
        } else {
            heartbeatEntry.dates.push(singleDateHeartbeat.date);
            // If the header would exceed max size, remove the added date
            // and stop adding to the header.
            if ($57d436074e210fb5$var$countBytes(heartbeatsToSend) > maxSize) {
                heartbeatEntry.dates.pop();
                break;
            }
        }
        // Pop unsent entry from queue. (Skipped if adding the entry exceeded
        // quota and the loop breaks early.)
        unsentEntries = unsentEntries.slice(1);
    }
    return {
        heartbeatsToSend: heartbeatsToSend,
        unsentEntries: unsentEntries
    };
}
class $57d436074e210fb5$var$HeartbeatStorageImpl {
    constructor(app){
        this.app = app;
        this._canUseIndexedDBPromise = this.runIndexedDBEnvironmentCheck();
    }
    async runIndexedDBEnvironmentCheck() {
        if (!(0, $c38e0f42709c826a$export$3865db50535c2055)()) return false;
        else return (0, $c38e0f42709c826a$export$a8a3018f3d187a4d)().then(()=>true).catch(()=>false);
    }
    /**
     * Read all heartbeats.
     */ async read() {
        const canUseIndexedDB = await this._canUseIndexedDBPromise;
        if (!canUseIndexedDB) return {
            heartbeats: []
        };
        else {
            const idbHeartbeatObject = await $57d436074e210fb5$var$readHeartbeatsFromIndexedDB(this.app);
            return idbHeartbeatObject || {
                heartbeats: []
            };
        }
    }
    // overwrite the storage with the provided heartbeats
    async overwrite(heartbeatsObject) {
        var _a;
        const canUseIndexedDB = await this._canUseIndexedDBPromise;
        if (!canUseIndexedDB) return;
        else {
            const existingHeartbeatsObject = await this.read();
            return $57d436074e210fb5$var$writeHeartbeatsToIndexedDB(this.app, {
                lastSentHeartbeatDate: (_a = heartbeatsObject.lastSentHeartbeatDate) !== null && _a !== void 0 ? _a : existingHeartbeatsObject.lastSentHeartbeatDate,
                heartbeats: heartbeatsObject.heartbeats
            });
        }
    }
    // add heartbeats
    async add(heartbeatsObject) {
        var _a;
        const canUseIndexedDB = await this._canUseIndexedDBPromise;
        if (!canUseIndexedDB) return;
        else {
            const existingHeartbeatsObject = await this.read();
            return $57d436074e210fb5$var$writeHeartbeatsToIndexedDB(this.app, {
                lastSentHeartbeatDate: (_a = heartbeatsObject.lastSentHeartbeatDate) !== null && _a !== void 0 ? _a : existingHeartbeatsObject.lastSentHeartbeatDate,
                heartbeats: [
                    ...existingHeartbeatsObject.heartbeats,
                    ...heartbeatsObject.heartbeats
                ]
            });
        }
    }
}
/**
 * Calculate bytes of a HeartbeatsByUserAgent array after being wrapped
 * in a platform logging header JSON object, stringified, and converted
 * to base 64.
 */ function $57d436074e210fb5$var$countBytes(heartbeatsCache) {
    // base64 has a restricted set of characters, all of which should be 1 byte.
    return (0, $c38e0f42709c826a$export$4b5284a3025a455)(// heartbeatsCache wrapper properties
    JSON.stringify({
        version: 2,
        heartbeats: heartbeatsCache
    })).length;
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $57d436074e210fb5$var$registerCoreComponents(variant) {
    $57d436074e210fb5$export$c930050e7bb63965(new (0, $a83e7ccd68ca8d4e$export$16fa2f45be04daa8)("platform-logger", (container)=>new $57d436074e210fb5$var$PlatformLoggerServiceImpl(container), "PRIVATE" /* ComponentType.PRIVATE */ ));
    $57d436074e210fb5$export$c930050e7bb63965(new (0, $a83e7ccd68ca8d4e$export$16fa2f45be04daa8)("heartbeat", (container)=>new $57d436074e210fb5$var$HeartbeatServiceImpl(container), "PRIVATE" /* ComponentType.PRIVATE */ ));
    // Register `app` package.
    $57d436074e210fb5$export$d29d5299a7137abc($57d436074e210fb5$var$name$o, $57d436074e210fb5$var$version$1, variant);
    // BUILD_TARGET will be replaced by values like esm5, esm2017, cjs5, etc during the compilation
    $57d436074e210fb5$export$d29d5299a7137abc($57d436074e210fb5$var$name$o, $57d436074e210fb5$var$version$1, "esm2017");
    // Register platform SDK identifier (no version).
    $57d436074e210fb5$export$d29d5299a7137abc("fire-js", "");
}
/**
 * Firebase App
 *
 * @remarks This package coordinates the communication between the different Firebase components
 * @packageDocumentation
 */ $57d436074e210fb5$var$registerCoreComponents("");








const $622a081c3b3bf47b$export$23f2a1d2818174ef = (object, constructors)=>constructors.some((c)=>object instanceof c);
let $622a081c3b3bf47b$var$idbProxyableTypes;
let $622a081c3b3bf47b$var$cursorAdvanceMethods;
// This is a function to prevent it throwing up in node environments.
function $622a081c3b3bf47b$var$getIdbProxyableTypes() {
    return $622a081c3b3bf47b$var$idbProxyableTypes || ($622a081c3b3bf47b$var$idbProxyableTypes = [
        IDBDatabase,
        IDBObjectStore,
        IDBIndex,
        IDBCursor,
        IDBTransaction
    ]);
}
// This is a function to prevent it throwing up in node environments.
function $622a081c3b3bf47b$var$getCursorAdvanceMethods() {
    return $622a081c3b3bf47b$var$cursorAdvanceMethods || ($622a081c3b3bf47b$var$cursorAdvanceMethods = [
        IDBCursor.prototype.advance,
        IDBCursor.prototype.continue,
        IDBCursor.prototype.continuePrimaryKey
    ]);
}
const $622a081c3b3bf47b$var$cursorRequestMap = new WeakMap();
const $622a081c3b3bf47b$var$transactionDoneMap = new WeakMap();
const $622a081c3b3bf47b$var$transactionStoreNamesMap = new WeakMap();
const $622a081c3b3bf47b$var$transformCache = new WeakMap();
const $622a081c3b3bf47b$export$407448d2b89b1813 = new WeakMap();
function $622a081c3b3bf47b$var$promisifyRequest(request) {
    const promise = new Promise((resolve, reject)=>{
        const unlisten = ()=>{
            request.removeEventListener("success", success);
            request.removeEventListener("error", error);
        };
        const success = ()=>{
            resolve($622a081c3b3bf47b$export$efccba1c4a2ef57b(request.result));
            unlisten();
        };
        const error = ()=>{
            reject(request.error);
            unlisten();
        };
        request.addEventListener("success", success);
        request.addEventListener("error", error);
    });
    promise.then((value)=>{
        // Since cursoring reuses the IDBRequest (*sigh*), we cache it for later retrieval
        // (see wrapFunction).
        if (value instanceof IDBCursor) $622a081c3b3bf47b$var$cursorRequestMap.set(value, request);
    // Catching to avoid "Uncaught Promise exceptions"
    }).catch(()=>{});
    // This mapping exists in reverseTransformCache but doesn't doesn't exist in transformCache. This
    // is because we create many promises from a single IDBRequest.
    $622a081c3b3bf47b$export$407448d2b89b1813.set(promise, request);
    return promise;
}
function $622a081c3b3bf47b$var$cacheDonePromiseForTransaction(tx) {
    // Early bail if we've already created a done promise for this transaction.
    if ($622a081c3b3bf47b$var$transactionDoneMap.has(tx)) return;
    const done = new Promise((resolve, reject)=>{
        const unlisten = ()=>{
            tx.removeEventListener("complete", complete);
            tx.removeEventListener("error", error);
            tx.removeEventListener("abort", error);
        };
        const complete = ()=>{
            resolve();
            unlisten();
        };
        const error = ()=>{
            reject(tx.error || new DOMException("AbortError", "AbortError"));
            unlisten();
        };
        tx.addEventListener("complete", complete);
        tx.addEventListener("error", error);
        tx.addEventListener("abort", error);
    });
    // Cache it for later retrieval.
    $622a081c3b3bf47b$var$transactionDoneMap.set(tx, done);
}
let $622a081c3b3bf47b$var$idbProxyTraps = {
    get (target, prop, receiver) {
        if (target instanceof IDBTransaction) {
            // Special handling for transaction.done.
            if (prop === "done") return $622a081c3b3bf47b$var$transactionDoneMap.get(target);
            // Polyfill for objectStoreNames because of Edge.
            if (prop === "objectStoreNames") return target.objectStoreNames || $622a081c3b3bf47b$var$transactionStoreNamesMap.get(target);
            // Make tx.store return the only store in the transaction, or undefined if there are many.
            if (prop === "store") return receiver.objectStoreNames[1] ? undefined : receiver.objectStore(receiver.objectStoreNames[0]);
        }
        // Else transform whatever we get back.
        return $622a081c3b3bf47b$export$efccba1c4a2ef57b(target[prop]);
    },
    set (target, prop, value) {
        target[prop] = value;
        return true;
    },
    has (target, prop) {
        if (target instanceof IDBTransaction && (prop === "done" || prop === "store")) return true;
        return prop in target;
    }
};
function $622a081c3b3bf47b$export$43caf9889c228507(callback) {
    $622a081c3b3bf47b$var$idbProxyTraps = callback($622a081c3b3bf47b$var$idbProxyTraps);
}
function $622a081c3b3bf47b$var$wrapFunction(func) {
    // Due to expected object equality (which is enforced by the caching in `wrap`), we
    // only create one new func per func.
    // Edge doesn't support objectStoreNames (booo), so we polyfill it here.
    if (func === IDBDatabase.prototype.transaction && !("objectStoreNames" in IDBTransaction.prototype)) return function(storeNames, ...args) {
        const tx = func.call($622a081c3b3bf47b$export$3b14a55fb2447963(this), storeNames, ...args);
        $622a081c3b3bf47b$var$transactionStoreNamesMap.set(tx, storeNames.sort ? storeNames.sort() : [
            storeNames
        ]);
        return $622a081c3b3bf47b$export$efccba1c4a2ef57b(tx);
    };
    // Cursor methods are special, as the behaviour is a little more different to standard IDB. In
    // IDB, you advance the cursor and wait for a new 'success' on the IDBRequest that gave you the
    // cursor. It's kinda like a promise that can resolve with many values. That doesn't make sense
    // with real promises, so each advance methods returns a new promise for the cursor object, or
    // undefined if the end of the cursor has been reached.
    if ($622a081c3b3bf47b$var$getCursorAdvanceMethods().includes(func)) return function(...args) {
        // Calling the original function with the proxy as 'this' causes ILLEGAL INVOCATION, so we use
        // the original object.
        func.apply($622a081c3b3bf47b$export$3b14a55fb2447963(this), args);
        return $622a081c3b3bf47b$export$efccba1c4a2ef57b($622a081c3b3bf47b$var$cursorRequestMap.get(this));
    };
    return function(...args) {
        // Calling the original function with the proxy as 'this' causes ILLEGAL INVOCATION, so we use
        // the original object.
        return $622a081c3b3bf47b$export$efccba1c4a2ef57b(func.apply($622a081c3b3bf47b$export$3b14a55fb2447963(this), args));
    };
}
function $622a081c3b3bf47b$var$transformCachableValue(value) {
    if (typeof value === "function") return $622a081c3b3bf47b$var$wrapFunction(value);
    // This doesn't return, it just creates a 'done' promise for the transaction,
    // which is later returned for transaction.done (see idbObjectHandler).
    if (value instanceof IDBTransaction) $622a081c3b3bf47b$var$cacheDonePromiseForTransaction(value);
    if ($622a081c3b3bf47b$export$23f2a1d2818174ef(value, $622a081c3b3bf47b$var$getIdbProxyableTypes())) return new Proxy(value, $622a081c3b3bf47b$var$idbProxyTraps);
    // Return the same value back if we're not going to transform it.
    return value;
}
function $622a081c3b3bf47b$export$efccba1c4a2ef57b(value) {
    // We sometimes generate multiple promises from a single IDBRequest (eg when cursoring), because
    // IDB is weird and a single IDBRequest can yield many responses, so these can't be cached.
    if (value instanceof IDBRequest) return $622a081c3b3bf47b$var$promisifyRequest(value);
    // If we've already transformed this value before, reuse the transformed value.
    // This is faster, but it also provides object equality.
    if ($622a081c3b3bf47b$var$transformCache.has(value)) return $622a081c3b3bf47b$var$transformCache.get(value);
    const newValue = $622a081c3b3bf47b$var$transformCachableValue(value);
    // Not all types are transformed.
    // These may be primitive types, so they can't be WeakMap keys.
    if (newValue !== value) {
        $622a081c3b3bf47b$var$transformCache.set(value, newValue);
        $622a081c3b3bf47b$export$407448d2b89b1813.set(newValue, value);
    }
    return newValue;
}
const $622a081c3b3bf47b$export$3b14a55fb2447963 = (value)=>$622a081c3b3bf47b$export$407448d2b89b1813.get(value);


/**
 * Open a database.
 *
 * @param name Name of the database.
 * @param version Schema version.
 * @param callbacks Additional callbacks.
 */ function $7f9eff7de122d39a$export$ca0ed41b1a2af7e(name, version, { blocked: blocked, upgrade: upgrade, blocking: blocking, terminated: terminated } = {}) {
    const request = indexedDB.open(name, version);
    const openPromise = (0, $622a081c3b3bf47b$export$efccba1c4a2ef57b)(request);
    if (upgrade) request.addEventListener("upgradeneeded", (event)=>{
        upgrade((0, $622a081c3b3bf47b$export$efccba1c4a2ef57b)(request.result), event.oldVersion, event.newVersion, (0, $622a081c3b3bf47b$export$efccba1c4a2ef57b)(request.transaction));
    });
    if (blocked) request.addEventListener("blocked", ()=>blocked());
    openPromise.then((db)=>{
        if (terminated) db.addEventListener("close", ()=>terminated());
        if (blocking) db.addEventListener("versionchange", ()=>blocking());
    }).catch(()=>{});
    return openPromise;
}
/**
 * Delete a database.
 *
 * @param name Name of the database.
 */ function $7f9eff7de122d39a$export$9d6df0ac66a98bb2(name, { blocked: blocked } = {}) {
    const request = indexedDB.deleteDatabase(name);
    if (blocked) request.addEventListener("blocked", ()=>blocked());
    return (0, $622a081c3b3bf47b$export$efccba1c4a2ef57b)(request).then(()=>undefined);
}
const $7f9eff7de122d39a$var$readMethods = [
    "get",
    "getKey",
    "getAll",
    "getAllKeys",
    "count"
];
const $7f9eff7de122d39a$var$writeMethods = [
    "put",
    "add",
    "delete",
    "clear"
];
const $7f9eff7de122d39a$var$cachedMethods = new Map();
function $7f9eff7de122d39a$var$getMethod(target, prop) {
    if (!(target instanceof IDBDatabase && !(prop in target) && typeof prop === "string")) return;
    if ($7f9eff7de122d39a$var$cachedMethods.get(prop)) return $7f9eff7de122d39a$var$cachedMethods.get(prop);
    const targetFuncName = prop.replace(/FromIndex$/, "");
    const useIndex = prop !== targetFuncName;
    const isWrite = $7f9eff7de122d39a$var$writeMethods.includes(targetFuncName);
    if (// Bail if the target doesn't exist on the target. Eg, getAll isn't in Edge.
    !(targetFuncName in (useIndex ? IDBIndex : IDBObjectStore).prototype) || !(isWrite || $7f9eff7de122d39a$var$readMethods.includes(targetFuncName))) return;
    const method = async function(storeName, ...args) {
        // isWrite ? 'readwrite' : undefined gzipps better, but fails in Edge :(
        const tx = this.transaction(storeName, isWrite ? "readwrite" : "readonly");
        let target = tx.store;
        if (useIndex) target = target.index(args.shift());
        // Must reject if op rejects.
        // If it's a write operation, must reject if tx.done rejects.
        // Must reject with op rejection first.
        // Must resolve with op value.
        // Must handle both promises (no unhandled rejections)
        return (await Promise.all([
            target[targetFuncName](...args),
            isWrite && tx.done
        ]))[0];
    };
    $7f9eff7de122d39a$var$cachedMethods.set(prop, method);
    return method;
}
(0, $622a081c3b3bf47b$export$43caf9889c228507)((oldTraps)=>({
        ...oldTraps,
        get: (target, prop, receiver)=>$7f9eff7de122d39a$var$getMethod(target, prop) || oldTraps.get(target, prop, receiver),
        has: (target, prop)=>!!$7f9eff7de122d39a$var$getMethod(target, prop) || oldTraps.has(target, prop)
    }));


const $1ee9b91e988771f9$var$name = "@firebase/installations";
const $1ee9b91e988771f9$var$version = "0.6.4";
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $1ee9b91e988771f9$var$PENDING_TIMEOUT_MS = 10000;
const $1ee9b91e988771f9$var$PACKAGE_VERSION = `w:${$1ee9b91e988771f9$var$version}`;
const $1ee9b91e988771f9$var$INTERNAL_AUTH_VERSION = "FIS_v2";
const $1ee9b91e988771f9$var$INSTALLATIONS_API_URL = "https://firebaseinstallations.googleapis.com/v1";
const $1ee9b91e988771f9$var$TOKEN_EXPIRATION_BUFFER = 3600000; // One hour
const $1ee9b91e988771f9$var$SERVICE = "installations";
const $1ee9b91e988771f9$var$SERVICE_NAME = "Installations";
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $1ee9b91e988771f9$var$ERROR_DESCRIPTION_MAP = {
    ["missing-app-config-values" /* ErrorCode.MISSING_APP_CONFIG_VALUES */ ]: 'Missing App configuration value: "{$valueName}"',
    ["not-registered" /* ErrorCode.NOT_REGISTERED */ ]: "Firebase Installation is not registered.",
    ["installation-not-found" /* ErrorCode.INSTALLATION_NOT_FOUND */ ]: "Firebase Installation not found.",
    ["request-failed" /* ErrorCode.REQUEST_FAILED */ ]: '{$requestName} request failed with error "{$serverCode} {$serverStatus}: {$serverMessage}"',
    ["app-offline" /* ErrorCode.APP_OFFLINE */ ]: "Could not process request. Application offline.",
    ["delete-pending-registration" /* ErrorCode.DELETE_PENDING_REGISTRATION */ ]: "Can't delete installation while there is a pending registration request."
};
const $1ee9b91e988771f9$var$ERROR_FACTORY = new (0, $c38e0f42709c826a$export$3fa6e1b18a3b2d40)($1ee9b91e988771f9$var$SERVICE, $1ee9b91e988771f9$var$SERVICE_NAME, $1ee9b91e988771f9$var$ERROR_DESCRIPTION_MAP);
/** Returns true if error is a FirebaseError that is based on an error from the server. */ function $1ee9b91e988771f9$var$isServerError(error) {
    return error instanceof (0, $c38e0f42709c826a$export$dd24e9cd51226c56) && error.code.includes("request-failed" /* ErrorCode.REQUEST_FAILED */ );
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $1ee9b91e988771f9$var$getInstallationsEndpoint({ projectId: projectId }) {
    return `${$1ee9b91e988771f9$var$INSTALLATIONS_API_URL}/projects/${projectId}/installations`;
}
function $1ee9b91e988771f9$var$extractAuthTokenInfoFromResponse(response) {
    return {
        token: response.token,
        requestStatus: 2 /* RequestStatus.COMPLETED */ ,
        expiresIn: $1ee9b91e988771f9$var$getExpiresInFromResponseExpiresIn(response.expiresIn),
        creationTime: Date.now()
    };
}
async function $1ee9b91e988771f9$var$getErrorFromResponse(requestName, response) {
    const responseJson = await response.json();
    const errorData = responseJson.error;
    return $1ee9b91e988771f9$var$ERROR_FACTORY.create("request-failed" /* ErrorCode.REQUEST_FAILED */ , {
        requestName: requestName,
        serverCode: errorData.code,
        serverMessage: errorData.message,
        serverStatus: errorData.status
    });
}
function $1ee9b91e988771f9$var$getHeaders({ apiKey: apiKey }) {
    return new Headers({
        "Content-Type": "application/json",
        Accept: "application/json",
        "x-goog-api-key": apiKey
    });
}
function $1ee9b91e988771f9$var$getHeadersWithAuth(appConfig, { refreshToken: refreshToken }) {
    const headers = $1ee9b91e988771f9$var$getHeaders(appConfig);
    headers.append("Authorization", $1ee9b91e988771f9$var$getAuthorizationHeader(refreshToken));
    return headers;
}
/**
 * Calls the passed in fetch wrapper and returns the response.
 * If the returned response has a status of 5xx, re-runs the function once and
 * returns the response.
 */ async function $1ee9b91e988771f9$var$retryIfServerError(fn) {
    const result = await fn();
    if (result.status >= 500 && result.status < 600) // Internal Server Error. Retry request.
    return fn();
    return result;
}
function $1ee9b91e988771f9$var$getExpiresInFromResponseExpiresIn(responseExpiresIn) {
    // This works because the server will never respond with fractions of a second.
    return Number(responseExpiresIn.replace("s", "000"));
}
function $1ee9b91e988771f9$var$getAuthorizationHeader(refreshToken) {
    return `${$1ee9b91e988771f9$var$INTERNAL_AUTH_VERSION} ${refreshToken}`;
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ async function $1ee9b91e988771f9$var$createInstallationRequest({ appConfig: appConfig, heartbeatServiceProvider: heartbeatServiceProvider }, { fid: fid }) {
    const endpoint = $1ee9b91e988771f9$var$getInstallationsEndpoint(appConfig);
    const headers = $1ee9b91e988771f9$var$getHeaders(appConfig);
    // If heartbeat service exists, add the heartbeat string to the header.
    const heartbeatService = heartbeatServiceProvider.getImmediate({
        optional: true
    });
    if (heartbeatService) {
        const heartbeatsHeader = await heartbeatService.getHeartbeatsHeader();
        if (heartbeatsHeader) headers.append("x-firebase-client", heartbeatsHeader);
    }
    const body = {
        fid: fid,
        authVersion: $1ee9b91e988771f9$var$INTERNAL_AUTH_VERSION,
        appId: appConfig.appId,
        sdkVersion: $1ee9b91e988771f9$var$PACKAGE_VERSION
    };
    const request = {
        method: "POST",
        headers: headers,
        body: JSON.stringify(body)
    };
    const response = await $1ee9b91e988771f9$var$retryIfServerError(()=>fetch(endpoint, request));
    if (response.ok) {
        const responseValue = await response.json();
        const registeredInstallationEntry = {
            fid: responseValue.fid || fid,
            registrationStatus: 2 /* RequestStatus.COMPLETED */ ,
            refreshToken: responseValue.refreshToken,
            authToken: $1ee9b91e988771f9$var$extractAuthTokenInfoFromResponse(responseValue.authToken)
        };
        return registeredInstallationEntry;
    } else throw await $1ee9b91e988771f9$var$getErrorFromResponse("Create Installation", response);
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /** Returns a promise that resolves after given time passes. */ function $1ee9b91e988771f9$var$sleep(ms) {
    return new Promise((resolve)=>{
        setTimeout(resolve, ms);
    });
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $1ee9b91e988771f9$var$bufferToBase64UrlSafe(array) {
    const b64 = btoa(String.fromCharCode(...array));
    return b64.replace(/\+/g, "-").replace(/\//g, "_");
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $1ee9b91e988771f9$var$VALID_FID_PATTERN = /^[cdef][\w-]{21}$/;
const $1ee9b91e988771f9$var$INVALID_FID = "";
/**
 * Generates a new FID using random values from Web Crypto API.
 * Returns an empty string if FID generation fails for any reason.
 */ function $1ee9b91e988771f9$var$generateFid() {
    try {
        // A valid FID has exactly 22 base64 characters, which is 132 bits, or 16.5
        // bytes. our implementation generates a 17 byte array instead.
        const fidByteArray = new Uint8Array(17);
        const crypto = self.crypto || self.msCrypto;
        crypto.getRandomValues(fidByteArray);
        // Replace the first 4 random bits with the constant FID header of 0b0111.
        fidByteArray[0] = 112 + fidByteArray[0] % 16;
        const fid = $1ee9b91e988771f9$var$encode(fidByteArray);
        return $1ee9b91e988771f9$var$VALID_FID_PATTERN.test(fid) ? fid : $1ee9b91e988771f9$var$INVALID_FID;
    } catch (_a) {
        // FID generation errored
        return $1ee9b91e988771f9$var$INVALID_FID;
    }
}
/** Converts a FID Uint8Array to a base64 string representation. */ function $1ee9b91e988771f9$var$encode(fidByteArray) {
    const b64String = $1ee9b91e988771f9$var$bufferToBase64UrlSafe(fidByteArray);
    // Remove the 23rd character that was added because of the extra 4 bits at the
    // end of our 17 byte array, and the '=' padding.
    return b64String.substr(0, 22);
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /** Returns a string key that can be used to identify the app. */ function $1ee9b91e988771f9$var$getKey(appConfig) {
    return `${appConfig.appName}!${appConfig.appId}`;
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $1ee9b91e988771f9$var$fidChangeCallbacks = new Map();
/**
 * Calls the onIdChange callbacks with the new FID value, and broadcasts the
 * change to other tabs.
 */ function $1ee9b91e988771f9$var$fidChanged(appConfig, fid) {
    const key = $1ee9b91e988771f9$var$getKey(appConfig);
    $1ee9b91e988771f9$var$callFidChangeCallbacks(key, fid);
    $1ee9b91e988771f9$var$broadcastFidChange(key, fid);
}
function $1ee9b91e988771f9$var$addCallback(appConfig, callback) {
    // Open the broadcast channel if it's not already open,
    // to be able to listen to change events from other tabs.
    $1ee9b91e988771f9$var$getBroadcastChannel();
    const key = $1ee9b91e988771f9$var$getKey(appConfig);
    let callbackSet = $1ee9b91e988771f9$var$fidChangeCallbacks.get(key);
    if (!callbackSet) {
        callbackSet = new Set();
        $1ee9b91e988771f9$var$fidChangeCallbacks.set(key, callbackSet);
    }
    callbackSet.add(callback);
}
function $1ee9b91e988771f9$var$removeCallback(appConfig, callback) {
    const key = $1ee9b91e988771f9$var$getKey(appConfig);
    const callbackSet = $1ee9b91e988771f9$var$fidChangeCallbacks.get(key);
    if (!callbackSet) return;
    callbackSet.delete(callback);
    if (callbackSet.size === 0) $1ee9b91e988771f9$var$fidChangeCallbacks.delete(key);
    // Close broadcast channel if there are no more callbacks.
    $1ee9b91e988771f9$var$closeBroadcastChannel();
}
function $1ee9b91e988771f9$var$callFidChangeCallbacks(key, fid) {
    const callbacks = $1ee9b91e988771f9$var$fidChangeCallbacks.get(key);
    if (!callbacks) return;
    for (const callback of callbacks)callback(fid);
}
function $1ee9b91e988771f9$var$broadcastFidChange(key, fid) {
    const channel = $1ee9b91e988771f9$var$getBroadcastChannel();
    if (channel) channel.postMessage({
        key: key,
        fid: fid
    });
    $1ee9b91e988771f9$var$closeBroadcastChannel();
}
let $1ee9b91e988771f9$var$broadcastChannel = null;
/** Opens and returns a BroadcastChannel if it is supported by the browser. */ function $1ee9b91e988771f9$var$getBroadcastChannel() {
    if (!$1ee9b91e988771f9$var$broadcastChannel && "BroadcastChannel" in self) {
        $1ee9b91e988771f9$var$broadcastChannel = new BroadcastChannel("[Firebase] FID Change");
        $1ee9b91e988771f9$var$broadcastChannel.onmessage = (e)=>{
            $1ee9b91e988771f9$var$callFidChangeCallbacks(e.data.key, e.data.fid);
        };
    }
    return $1ee9b91e988771f9$var$broadcastChannel;
}
function $1ee9b91e988771f9$var$closeBroadcastChannel() {
    if ($1ee9b91e988771f9$var$fidChangeCallbacks.size === 0 && $1ee9b91e988771f9$var$broadcastChannel) {
        $1ee9b91e988771f9$var$broadcastChannel.close();
        $1ee9b91e988771f9$var$broadcastChannel = null;
    }
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $1ee9b91e988771f9$var$DATABASE_NAME = "firebase-installations-database";
const $1ee9b91e988771f9$var$DATABASE_VERSION = 1;
const $1ee9b91e988771f9$var$OBJECT_STORE_NAME = "firebase-installations-store";
let $1ee9b91e988771f9$var$dbPromise = null;
function $1ee9b91e988771f9$var$getDbPromise() {
    if (!$1ee9b91e988771f9$var$dbPromise) $1ee9b91e988771f9$var$dbPromise = (0, $7f9eff7de122d39a$export$ca0ed41b1a2af7e)($1ee9b91e988771f9$var$DATABASE_NAME, $1ee9b91e988771f9$var$DATABASE_VERSION, {
        upgrade: (db, oldVersion)=>{
            // We don't use 'break' in this switch statement, the fall-through
            // behavior is what we want, because if there are multiple versions between
            // the old version and the current version, we want ALL the migrations
            // that correspond to those versions to run, not only the last one.
            // eslint-disable-next-line default-case
            switch(oldVersion){
                case 0:
                    db.createObjectStore($1ee9b91e988771f9$var$OBJECT_STORE_NAME);
            }
        }
    });
    return $1ee9b91e988771f9$var$dbPromise;
}
/** Assigns or overwrites the record for the given key with the given value. */ async function $1ee9b91e988771f9$var$set(appConfig, value) {
    const key = $1ee9b91e988771f9$var$getKey(appConfig);
    const db = await $1ee9b91e988771f9$var$getDbPromise();
    const tx = db.transaction($1ee9b91e988771f9$var$OBJECT_STORE_NAME, "readwrite");
    const objectStore = tx.objectStore($1ee9b91e988771f9$var$OBJECT_STORE_NAME);
    const oldValue = await objectStore.get(key);
    await objectStore.put(value, key);
    await tx.done;
    if (!oldValue || oldValue.fid !== value.fid) $1ee9b91e988771f9$var$fidChanged(appConfig, value.fid);
    return value;
}
/** Removes record(s) from the objectStore that match the given key. */ async function $1ee9b91e988771f9$var$remove(appConfig) {
    const key = $1ee9b91e988771f9$var$getKey(appConfig);
    const db = await $1ee9b91e988771f9$var$getDbPromise();
    const tx = db.transaction($1ee9b91e988771f9$var$OBJECT_STORE_NAME, "readwrite");
    await tx.objectStore($1ee9b91e988771f9$var$OBJECT_STORE_NAME).delete(key);
    await tx.done;
}
/**
 * Atomically updates a record with the result of updateFn, which gets
 * called with the current value. If newValue is undefined, the record is
 * deleted instead.
 * @return Updated value
 */ async function $1ee9b91e988771f9$var$update(appConfig, updateFn) {
    const key = $1ee9b91e988771f9$var$getKey(appConfig);
    const db = await $1ee9b91e988771f9$var$getDbPromise();
    const tx = db.transaction($1ee9b91e988771f9$var$OBJECT_STORE_NAME, "readwrite");
    const store = tx.objectStore($1ee9b91e988771f9$var$OBJECT_STORE_NAME);
    const oldValue = await store.get(key);
    const newValue = updateFn(oldValue);
    if (newValue === undefined) await store.delete(key);
    else await store.put(newValue, key);
    await tx.done;
    if (newValue && (!oldValue || oldValue.fid !== newValue.fid)) $1ee9b91e988771f9$var$fidChanged(appConfig, newValue.fid);
    return newValue;
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Updates and returns the InstallationEntry from the database.
 * Also triggers a registration request if it is necessary and possible.
 */ async function $1ee9b91e988771f9$var$getInstallationEntry(installations) {
    let registrationPromise;
    const installationEntry = await $1ee9b91e988771f9$var$update(installations.appConfig, (oldEntry)=>{
        const installationEntry = $1ee9b91e988771f9$var$updateOrCreateInstallationEntry(oldEntry);
        const entryWithPromise = $1ee9b91e988771f9$var$triggerRegistrationIfNecessary(installations, installationEntry);
        registrationPromise = entryWithPromise.registrationPromise;
        return entryWithPromise.installationEntry;
    });
    if (installationEntry.fid === $1ee9b91e988771f9$var$INVALID_FID) // FID generation failed. Waiting for the FID from the server.
    return {
        installationEntry: await registrationPromise
    };
    return {
        installationEntry: installationEntry,
        registrationPromise: registrationPromise
    };
}
/**
 * Creates a new Installation Entry if one does not exist.
 * Also clears timed out pending requests.
 */ function $1ee9b91e988771f9$var$updateOrCreateInstallationEntry(oldEntry) {
    const entry = oldEntry || {
        fid: $1ee9b91e988771f9$var$generateFid(),
        registrationStatus: 0 /* RequestStatus.NOT_STARTED */ 
    };
    return $1ee9b91e988771f9$var$clearTimedOutRequest(entry);
}
/**
 * If the Firebase Installation is not registered yet, this will trigger the
 * registration and return an InProgressInstallationEntry.
 *
 * If registrationPromise does not exist, the installationEntry is guaranteed
 * to be registered.
 */ function $1ee9b91e988771f9$var$triggerRegistrationIfNecessary(installations, installationEntry) {
    if (installationEntry.registrationStatus === 0 /* RequestStatus.NOT_STARTED */ ) {
        if (!navigator.onLine) {
            // Registration required but app is offline.
            const registrationPromiseWithError = Promise.reject($1ee9b91e988771f9$var$ERROR_FACTORY.create("app-offline" /* ErrorCode.APP_OFFLINE */ ));
            return {
                installationEntry: installationEntry,
                registrationPromise: registrationPromiseWithError
            };
        }
        // Try registering. Change status to IN_PROGRESS.
        const inProgressEntry = {
            fid: installationEntry.fid,
            registrationStatus: 1 /* RequestStatus.IN_PROGRESS */ ,
            registrationTime: Date.now()
        };
        const registrationPromise = $1ee9b91e988771f9$var$registerInstallation(installations, inProgressEntry);
        return {
            installationEntry: inProgressEntry,
            registrationPromise: registrationPromise
        };
    } else if (installationEntry.registrationStatus === 1 /* RequestStatus.IN_PROGRESS */ ) return {
        installationEntry: installationEntry,
        registrationPromise: $1ee9b91e988771f9$var$waitUntilFidRegistration(installations)
    };
    else return {
        installationEntry: installationEntry
    };
}
/** This will be executed only once for each new Firebase Installation. */ async function $1ee9b91e988771f9$var$registerInstallation(installations, installationEntry) {
    try {
        const registeredInstallationEntry = await $1ee9b91e988771f9$var$createInstallationRequest(installations, installationEntry);
        return $1ee9b91e988771f9$var$set(installations.appConfig, registeredInstallationEntry);
    } catch (e) {
        if ($1ee9b91e988771f9$var$isServerError(e) && e.customData.serverCode === 409) // Server returned a "FID can not be used" error.
        // Generate a new ID next time.
        await $1ee9b91e988771f9$var$remove(installations.appConfig);
        else // Registration failed. Set FID as not registered.
        await $1ee9b91e988771f9$var$set(installations.appConfig, {
            fid: installationEntry.fid,
            registrationStatus: 0 /* RequestStatus.NOT_STARTED */ 
        });
        throw e;
    }
}
/** Call if FID registration is pending in another request. */ async function $1ee9b91e988771f9$var$waitUntilFidRegistration(installations) {
    // Unfortunately, there is no way of reliably observing when a value in
    // IndexedDB changes (yet, see https://github.com/WICG/indexed-db-observers),
    // so we need to poll.
    let entry = await $1ee9b91e988771f9$var$updateInstallationRequest(installations.appConfig);
    while(entry.registrationStatus === 1 /* RequestStatus.IN_PROGRESS */ ){
        // createInstallation request still in progress.
        await $1ee9b91e988771f9$var$sleep(100);
        entry = await $1ee9b91e988771f9$var$updateInstallationRequest(installations.appConfig);
    }
    if (entry.registrationStatus === 0 /* RequestStatus.NOT_STARTED */ ) {
        // The request timed out or failed in a different call. Try again.
        const { installationEntry: installationEntry, registrationPromise: registrationPromise } = await $1ee9b91e988771f9$var$getInstallationEntry(installations);
        if (registrationPromise) return registrationPromise;
        else // if there is no registrationPromise, entry is registered.
        return installationEntry;
    }
    return entry;
}
/**
 * Called only if there is a CreateInstallation request in progress.
 *
 * Updates the InstallationEntry in the DB based on the status of the
 * CreateInstallation request.
 *
 * Returns the updated InstallationEntry.
 */ function $1ee9b91e988771f9$var$updateInstallationRequest(appConfig) {
    return $1ee9b91e988771f9$var$update(appConfig, (oldEntry)=>{
        if (!oldEntry) throw $1ee9b91e988771f9$var$ERROR_FACTORY.create("installation-not-found" /* ErrorCode.INSTALLATION_NOT_FOUND */ );
        return $1ee9b91e988771f9$var$clearTimedOutRequest(oldEntry);
    });
}
function $1ee9b91e988771f9$var$clearTimedOutRequest(entry) {
    if ($1ee9b91e988771f9$var$hasInstallationRequestTimedOut(entry)) return {
        fid: entry.fid,
        registrationStatus: 0 /* RequestStatus.NOT_STARTED */ 
    };
    return entry;
}
function $1ee9b91e988771f9$var$hasInstallationRequestTimedOut(installationEntry) {
    return installationEntry.registrationStatus === 1 /* RequestStatus.IN_PROGRESS */  && installationEntry.registrationTime + $1ee9b91e988771f9$var$PENDING_TIMEOUT_MS < Date.now();
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ async function $1ee9b91e988771f9$var$generateAuthTokenRequest({ appConfig: appConfig, heartbeatServiceProvider: heartbeatServiceProvider }, installationEntry) {
    const endpoint = $1ee9b91e988771f9$var$getGenerateAuthTokenEndpoint(appConfig, installationEntry);
    const headers = $1ee9b91e988771f9$var$getHeadersWithAuth(appConfig, installationEntry);
    // If heartbeat service exists, add the heartbeat string to the header.
    const heartbeatService = heartbeatServiceProvider.getImmediate({
        optional: true
    });
    if (heartbeatService) {
        const heartbeatsHeader = await heartbeatService.getHeartbeatsHeader();
        if (heartbeatsHeader) headers.append("x-firebase-client", heartbeatsHeader);
    }
    const body = {
        installation: {
            sdkVersion: $1ee9b91e988771f9$var$PACKAGE_VERSION,
            appId: appConfig.appId
        }
    };
    const request = {
        method: "POST",
        headers: headers,
        body: JSON.stringify(body)
    };
    const response = await $1ee9b91e988771f9$var$retryIfServerError(()=>fetch(endpoint, request));
    if (response.ok) {
        const responseValue = await response.json();
        const completedAuthToken = $1ee9b91e988771f9$var$extractAuthTokenInfoFromResponse(responseValue);
        return completedAuthToken;
    } else throw await $1ee9b91e988771f9$var$getErrorFromResponse("Generate Auth Token", response);
}
function $1ee9b91e988771f9$var$getGenerateAuthTokenEndpoint(appConfig, { fid: fid }) {
    return `${$1ee9b91e988771f9$var$getInstallationsEndpoint(appConfig)}/${fid}/authTokens:generate`;
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Returns a valid authentication token for the installation. Generates a new
 * token if one doesn't exist, is expired or about to expire.
 *
 * Should only be called if the Firebase Installation is registered.
 */ async function $1ee9b91e988771f9$var$refreshAuthToken(installations, forceRefresh = false) {
    let tokenPromise;
    const entry = await $1ee9b91e988771f9$var$update(installations.appConfig, (oldEntry)=>{
        if (!$1ee9b91e988771f9$var$isEntryRegistered(oldEntry)) throw $1ee9b91e988771f9$var$ERROR_FACTORY.create("not-registered" /* ErrorCode.NOT_REGISTERED */ );
        const oldAuthToken = oldEntry.authToken;
        if (!forceRefresh && $1ee9b91e988771f9$var$isAuthTokenValid(oldAuthToken)) // There is a valid token in the DB.
        return oldEntry;
        else if (oldAuthToken.requestStatus === 1 /* RequestStatus.IN_PROGRESS */ ) {
            // There already is a token request in progress.
            tokenPromise = $1ee9b91e988771f9$var$waitUntilAuthTokenRequest(installations, forceRefresh);
            return oldEntry;
        } else {
            // No token or token expired.
            if (!navigator.onLine) throw $1ee9b91e988771f9$var$ERROR_FACTORY.create("app-offline" /* ErrorCode.APP_OFFLINE */ );
            const inProgressEntry = $1ee9b91e988771f9$var$makeAuthTokenRequestInProgressEntry(oldEntry);
            tokenPromise = $1ee9b91e988771f9$var$fetchAuthTokenFromServer(installations, inProgressEntry);
            return inProgressEntry;
        }
    });
    const authToken = tokenPromise ? await tokenPromise : entry.authToken;
    return authToken;
}
/**
 * Call only if FID is registered and Auth Token request is in progress.
 *
 * Waits until the current pending request finishes. If the request times out,
 * tries once in this thread as well.
 */ async function $1ee9b91e988771f9$var$waitUntilAuthTokenRequest(installations, forceRefresh) {
    // Unfortunately, there is no way of reliably observing when a value in
    // IndexedDB changes (yet, see https://github.com/WICG/indexed-db-observers),
    // so we need to poll.
    let entry = await $1ee9b91e988771f9$var$updateAuthTokenRequest(installations.appConfig);
    while(entry.authToken.requestStatus === 1 /* RequestStatus.IN_PROGRESS */ ){
        // generateAuthToken still in progress.
        await $1ee9b91e988771f9$var$sleep(100);
        entry = await $1ee9b91e988771f9$var$updateAuthTokenRequest(installations.appConfig);
    }
    const authToken = entry.authToken;
    if (authToken.requestStatus === 0 /* RequestStatus.NOT_STARTED */ ) // The request timed out or failed in a different call. Try again.
    return $1ee9b91e988771f9$var$refreshAuthToken(installations, forceRefresh);
    else return authToken;
}
/**
 * Called only if there is a GenerateAuthToken request in progress.
 *
 * Updates the InstallationEntry in the DB based on the status of the
 * GenerateAuthToken request.
 *
 * Returns the updated InstallationEntry.
 */ function $1ee9b91e988771f9$var$updateAuthTokenRequest(appConfig) {
    return $1ee9b91e988771f9$var$update(appConfig, (oldEntry)=>{
        if (!$1ee9b91e988771f9$var$isEntryRegistered(oldEntry)) throw $1ee9b91e988771f9$var$ERROR_FACTORY.create("not-registered" /* ErrorCode.NOT_REGISTERED */ );
        const oldAuthToken = oldEntry.authToken;
        if ($1ee9b91e988771f9$var$hasAuthTokenRequestTimedOut(oldAuthToken)) return Object.assign(Object.assign({}, oldEntry), {
            authToken: {
                requestStatus: 0 /* RequestStatus.NOT_STARTED */ 
            }
        });
        return oldEntry;
    });
}
async function $1ee9b91e988771f9$var$fetchAuthTokenFromServer(installations, installationEntry) {
    try {
        const authToken = await $1ee9b91e988771f9$var$generateAuthTokenRequest(installations, installationEntry);
        const updatedInstallationEntry = Object.assign(Object.assign({}, installationEntry), {
            authToken: authToken
        });
        await $1ee9b91e988771f9$var$set(installations.appConfig, updatedInstallationEntry);
        return authToken;
    } catch (e) {
        if ($1ee9b91e988771f9$var$isServerError(e) && (e.customData.serverCode === 401 || e.customData.serverCode === 404)) // Server returned a "FID not found" or a "Invalid authentication" error.
        // Generate a new ID next time.
        await $1ee9b91e988771f9$var$remove(installations.appConfig);
        else {
            const updatedInstallationEntry = Object.assign(Object.assign({}, installationEntry), {
                authToken: {
                    requestStatus: 0 /* RequestStatus.NOT_STARTED */ 
                }
            });
            await $1ee9b91e988771f9$var$set(installations.appConfig, updatedInstallationEntry);
        }
        throw e;
    }
}
function $1ee9b91e988771f9$var$isEntryRegistered(installationEntry) {
    return installationEntry !== undefined && installationEntry.registrationStatus === 2 /* RequestStatus.COMPLETED */ ;
}
function $1ee9b91e988771f9$var$isAuthTokenValid(authToken) {
    return authToken.requestStatus === 2 /* RequestStatus.COMPLETED */  && !$1ee9b91e988771f9$var$isAuthTokenExpired(authToken);
}
function $1ee9b91e988771f9$var$isAuthTokenExpired(authToken) {
    const now = Date.now();
    return now < authToken.creationTime || authToken.creationTime + authToken.expiresIn < now + $1ee9b91e988771f9$var$TOKEN_EXPIRATION_BUFFER;
}
/** Returns an updated InstallationEntry with an InProgressAuthToken. */ function $1ee9b91e988771f9$var$makeAuthTokenRequestInProgressEntry(oldEntry) {
    const inProgressAuthToken = {
        requestStatus: 1 /* RequestStatus.IN_PROGRESS */ ,
        requestTime: Date.now()
    };
    return Object.assign(Object.assign({}, oldEntry), {
        authToken: inProgressAuthToken
    });
}
function $1ee9b91e988771f9$var$hasAuthTokenRequestTimedOut(authToken) {
    return authToken.requestStatus === 1 /* RequestStatus.IN_PROGRESS */  && authToken.requestTime + $1ee9b91e988771f9$var$PENDING_TIMEOUT_MS < Date.now();
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Creates a Firebase Installation if there isn't one for the app and
 * returns the Installation ID.
 * @param installations - The `Installations` instance.
 *
 * @public
 */ async function $1ee9b91e988771f9$export$218c8c3169c024d2(installations) {
    const installationsImpl = installations;
    const { installationEntry: installationEntry, registrationPromise: registrationPromise } = await $1ee9b91e988771f9$var$getInstallationEntry(installationsImpl);
    if (registrationPromise) registrationPromise.catch(console.error);
    else // If the installation is already registered, update the authentication
    // token if needed.
    $1ee9b91e988771f9$var$refreshAuthToken(installationsImpl).catch(console.error);
    return installationEntry.fid;
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Returns a Firebase Installations auth token, identifying the current
 * Firebase Installation.
 * @param installations - The `Installations` instance.
 * @param forceRefresh - Force refresh regardless of token expiration.
 *
 * @public
 */ async function $1ee9b91e988771f9$export$257b2d10b709d8ef(installations, forceRefresh = false) {
    const installationsImpl = installations;
    await $1ee9b91e988771f9$var$completeInstallationRegistration(installationsImpl);
    // At this point we either have a Registered Installation in the DB, or we've
    // already thrown an error.
    const authToken = await $1ee9b91e988771f9$var$refreshAuthToken(installationsImpl, forceRefresh);
    return authToken.token;
}
async function $1ee9b91e988771f9$var$completeInstallationRegistration(installations) {
    const { registrationPromise: registrationPromise } = await $1ee9b91e988771f9$var$getInstallationEntry(installations);
    if (registrationPromise) // A createInstallation request is in progress. Wait until it finishes.
    await registrationPromise;
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ async function $1ee9b91e988771f9$var$deleteInstallationRequest(appConfig, installationEntry) {
    const endpoint = $1ee9b91e988771f9$var$getDeleteEndpoint(appConfig, installationEntry);
    const headers = $1ee9b91e988771f9$var$getHeadersWithAuth(appConfig, installationEntry);
    const request = {
        method: "DELETE",
        headers: headers
    };
    const response = await $1ee9b91e988771f9$var$retryIfServerError(()=>fetch(endpoint, request));
    if (!response.ok) throw await $1ee9b91e988771f9$var$getErrorFromResponse("Delete Installation", response);
}
function $1ee9b91e988771f9$var$getDeleteEndpoint(appConfig, { fid: fid }) {
    return `${$1ee9b91e988771f9$var$getInstallationsEndpoint(appConfig)}/${fid}`;
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Deletes the Firebase Installation and all associated data.
 * @param installations - The `Installations` instance.
 *
 * @public
 */ async function $1ee9b91e988771f9$export$5f6b87a08674814c(installations) {
    const { appConfig: appConfig } = installations;
    const entry = await $1ee9b91e988771f9$var$update(appConfig, (oldEntry)=>{
        if (oldEntry && oldEntry.registrationStatus === 0 /* RequestStatus.NOT_STARTED */ ) // Delete the unregistered entry without sending a deleteInstallation request.
        return undefined;
        return oldEntry;
    });
    if (entry) {
        if (entry.registrationStatus === 1 /* RequestStatus.IN_PROGRESS */ ) // Can't delete while trying to register.
        throw $1ee9b91e988771f9$var$ERROR_FACTORY.create("delete-pending-registration" /* ErrorCode.DELETE_PENDING_REGISTRATION */ );
        else if (entry.registrationStatus === 2 /* RequestStatus.COMPLETED */ ) {
            if (!navigator.onLine) throw $1ee9b91e988771f9$var$ERROR_FACTORY.create("app-offline" /* ErrorCode.APP_OFFLINE */ );
            else {
                await $1ee9b91e988771f9$var$deleteInstallationRequest(appConfig, entry);
                await $1ee9b91e988771f9$var$remove(appConfig);
            }
        }
    }
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Sets a new callback that will get called when Installation ID changes.
 * Returns an unsubscribe function that will remove the callback when called.
 * @param installations - The `Installations` instance.
 * @param callback - The callback function that is invoked when FID changes.
 * @returns A function that can be called to unsubscribe.
 *
 * @public
 */ function $1ee9b91e988771f9$export$ceb4c11381bc36e8(installations, callback) {
    const { appConfig: appConfig } = installations;
    $1ee9b91e988771f9$var$addCallback(appConfig, callback);
    return ()=>{
        $1ee9b91e988771f9$var$removeCallback(appConfig, callback);
    };
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Returns an instance of {@link Installations} associated with the given
 * {@link @firebase/app#FirebaseApp} instance.
 * @param app - The {@link @firebase/app#FirebaseApp} instance.
 *
 * @public
 */ function $1ee9b91e988771f9$export$9bfc115e43431ff5(app = (0, $57d436074e210fb5$export$f9962582c9e66d99)()) {
    const installationsImpl = (0, $57d436074e210fb5$export$fa0d6da0f5838f50)(app, "installations").getImmediate();
    return installationsImpl;
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $1ee9b91e988771f9$var$extractAppConfig(app) {
    if (!app || !app.options) throw $1ee9b91e988771f9$var$getMissingValueError("App Configuration");
    if (!app.name) throw $1ee9b91e988771f9$var$getMissingValueError("App Name");
    // Required app config keys
    const configKeys = [
        "projectId",
        "apiKey",
        "appId"
    ];
    for (const keyName of configKeys){
        if (!app.options[keyName]) throw $1ee9b91e988771f9$var$getMissingValueError(keyName);
    }
    return {
        appName: app.name,
        projectId: app.options.projectId,
        apiKey: app.options.apiKey,
        appId: app.options.appId
    };
}
function $1ee9b91e988771f9$var$getMissingValueError(valueName) {
    return $1ee9b91e988771f9$var$ERROR_FACTORY.create("missing-app-config-values" /* ErrorCode.MISSING_APP_CONFIG_VALUES */ , {
        valueName: valueName
    });
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $1ee9b91e988771f9$var$INSTALLATIONS_NAME = "installations";
const $1ee9b91e988771f9$var$INSTALLATIONS_NAME_INTERNAL = "installations-internal";
const $1ee9b91e988771f9$var$publicFactory = (container)=>{
    const app = container.getProvider("app").getImmediate();
    // Throws if app isn't configured properly.
    const appConfig = $1ee9b91e988771f9$var$extractAppConfig(app);
    const heartbeatServiceProvider = (0, $57d436074e210fb5$export$fa0d6da0f5838f50)(app, "heartbeat");
    const installationsImpl = {
        app: app,
        appConfig: appConfig,
        heartbeatServiceProvider: heartbeatServiceProvider,
        _delete: ()=>Promise.resolve()
    };
    return installationsImpl;
};
const $1ee9b91e988771f9$var$internalFactory = (container)=>{
    const app = container.getProvider("app").getImmediate();
    // Internal FIS instance relies on public FIS instance.
    const installations = (0, $57d436074e210fb5$export$fa0d6da0f5838f50)(app, $1ee9b91e988771f9$var$INSTALLATIONS_NAME).getImmediate();
    const installationsInternal = {
        getId: ()=>$1ee9b91e988771f9$export$218c8c3169c024d2(installations),
        getToken: (forceRefresh)=>$1ee9b91e988771f9$export$257b2d10b709d8ef(installations, forceRefresh)
    };
    return installationsInternal;
};
function $1ee9b91e988771f9$var$registerInstallations() {
    (0, $57d436074e210fb5$export$c930050e7bb63965)(new (0, $a83e7ccd68ca8d4e$export$16fa2f45be04daa8)($1ee9b91e988771f9$var$INSTALLATIONS_NAME, $1ee9b91e988771f9$var$publicFactory, "PUBLIC" /* ComponentType.PUBLIC */ ));
    (0, $57d436074e210fb5$export$c930050e7bb63965)(new (0, $a83e7ccd68ca8d4e$export$16fa2f45be04daa8)($1ee9b91e988771f9$var$INSTALLATIONS_NAME_INTERNAL, $1ee9b91e988771f9$var$internalFactory, "PRIVATE" /* ComponentType.PRIVATE */ ));
}
/**
 * Firebase Installations
 *
 * @packageDocumentation
 */ $1ee9b91e988771f9$var$registerInstallations();
(0, $57d436074e210fb5$export$d29d5299a7137abc)($1ee9b91e988771f9$var$name, $1ee9b91e988771f9$var$version);
// BUILD_TARGET will be replaced by values like esm5, esm2017, cjs5, etc during the compilation
(0, $57d436074e210fb5$export$d29d5299a7137abc)($1ee9b91e988771f9$var$name, $1ee9b91e988771f9$var$version, "esm2017");


/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Type constant for Firebase Analytics.
 */ const $0d15f034d14801d0$var$ANALYTICS_TYPE = "analytics";
// Key to attach FID to in gtag params.
const $0d15f034d14801d0$var$GA_FID_KEY = "firebase_id";
const $0d15f034d14801d0$var$ORIGIN_KEY = "origin";
const $0d15f034d14801d0$var$FETCH_TIMEOUT_MILLIS = 60000;
const $0d15f034d14801d0$var$DYNAMIC_CONFIG_URL = "https://firebase.googleapis.com/v1alpha/projects/-/apps/{app-id}/webConfig";
const $0d15f034d14801d0$var$GTAG_URL = "https://www.googletagmanager.com/gtag/js";
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $0d15f034d14801d0$var$logger = new (0, $45b460d9de9b230f$export$efa9a398d6368992)("@firebase/analytics");
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $0d15f034d14801d0$var$ERRORS = {
    ["already-exists" /* AnalyticsError.ALREADY_EXISTS */ ]: "A Firebase Analytics instance with the appId {$id}  already exists. Only one Firebase Analytics instance can be created for each appId.",
    ["already-initialized" /* AnalyticsError.ALREADY_INITIALIZED */ ]: "initializeAnalytics() cannot be called again with different options than those it was initially called with. It can be called again with the same options to return the existing instance, or getAnalytics() can be used to get a reference to the already-intialized instance.",
    ["already-initialized-settings" /* AnalyticsError.ALREADY_INITIALIZED_SETTINGS */ ]: "Firebase Analytics has already been initialized.settings() must be called before initializing any Analytics instanceor it will have no effect.",
    ["interop-component-reg-failed" /* AnalyticsError.INTEROP_COMPONENT_REG_FAILED */ ]: "Firebase Analytics Interop Component failed to instantiate: {$reason}",
    ["invalid-analytics-context" /* AnalyticsError.INVALID_ANALYTICS_CONTEXT */ ]: "Firebase Analytics is not supported in this environment. Wrap initialization of analytics in analytics.isSupported() to prevent initialization in unsupported environments. Details: {$errorInfo}",
    ["indexeddb-unavailable" /* AnalyticsError.INDEXEDDB_UNAVAILABLE */ ]: "IndexedDB unavailable or restricted in this environment. Wrap initialization of analytics in analytics.isSupported() to prevent initialization in unsupported environments. Details: {$errorInfo}",
    ["fetch-throttle" /* AnalyticsError.FETCH_THROTTLE */ ]: "The config fetch request timed out while in an exponential backoff state. Unix timestamp in milliseconds when fetch request throttling ends: {$throttleEndTimeMillis}.",
    ["config-fetch-failed" /* AnalyticsError.CONFIG_FETCH_FAILED */ ]: "Dynamic config fetch failed: [{$httpStatus}] {$responseMessage}",
    ["no-api-key" /* AnalyticsError.NO_API_KEY */ ]: 'The "apiKey" field is empty in the local Firebase config. Firebase Analytics requires this field tocontain a valid API key.',
    ["no-app-id" /* AnalyticsError.NO_APP_ID */ ]: 'The "appId" field is empty in the local Firebase config. Firebase Analytics requires this field tocontain a valid app ID.',
    ["no-client-id" /* AnalyticsError.NO_CLIENT_ID */ ]: 'The "client_id" field is empty.',
    ["invalid-gtag-resource" /* AnalyticsError.INVALID_GTAG_RESOURCE */ ]: "Trusted Types detected an invalid gtag resource: {$gtagURL}."
};
const $0d15f034d14801d0$var$ERROR_FACTORY = new (0, $c38e0f42709c826a$export$3fa6e1b18a3b2d40)("analytics", "Analytics", $0d15f034d14801d0$var$ERRORS);
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Verifies and creates a TrustedScriptURL.
 */ function $0d15f034d14801d0$var$createGtagTrustedTypesScriptURL(url) {
    if (!url.startsWith($0d15f034d14801d0$var$GTAG_URL)) {
        const err = $0d15f034d14801d0$var$ERROR_FACTORY.create("invalid-gtag-resource" /* AnalyticsError.INVALID_GTAG_RESOURCE */ , {
            gtagURL: url
        });
        $0d15f034d14801d0$var$logger.warn(err.message);
        return "";
    }
    return url;
}
/**
 * Makeshift polyfill for Promise.allSettled(). Resolves when all promises
 * have either resolved or rejected.
 *
 * @param promises Array of promises to wait for.
 */ function $0d15f034d14801d0$var$promiseAllSettled(promises) {
    return Promise.all(promises.map((promise)=>promise.catch((e)=>e)));
}
/**
 * Creates a TrustedTypePolicy object that implements the rules passed as policyOptions.
 *
 * @param policyName A string containing the name of the policy
 * @param policyOptions Object containing implementations of instance methods for TrustedTypesPolicy, see {@link https://developer.mozilla.org/en-US/docs/Web/API/TrustedTypePolicy#instance_methods
 * | the TrustedTypePolicy reference documentation}.
 */ function $0d15f034d14801d0$var$createTrustedTypesPolicy(policyName, policyOptions) {
    // Create a TrustedTypes policy that we can use for updating src
    // properties
    let trustedTypesPolicy;
    if (window.trustedTypes) trustedTypesPolicy = window.trustedTypes.createPolicy(policyName, policyOptions);
    return trustedTypesPolicy;
}
/**
 * Inserts gtag script tag into the page to asynchronously download gtag.
 * @param dataLayerName Name of datalayer (most often the default, "_dataLayer").
 */ function $0d15f034d14801d0$var$insertScriptTag(dataLayerName, measurementId) {
    const trustedTypesPolicy = $0d15f034d14801d0$var$createTrustedTypesPolicy("firebase-js-sdk-policy", {
        createScriptURL: $0d15f034d14801d0$var$createGtagTrustedTypesScriptURL
    });
    const script = document.createElement("script");
    // We are not providing an analyticsId in the URL because it would trigger a `page_view`
    // without fid. We will initialize ga-id using gtag (config) command together with fid.
    const gtagScriptURL = `${$0d15f034d14801d0$var$GTAG_URL}?l=${dataLayerName}&id=${measurementId}`;
    script.src = trustedTypesPolicy ? trustedTypesPolicy === null || trustedTypesPolicy === void 0 ? void 0 : trustedTypesPolicy.createScriptURL(gtagScriptURL) : gtagScriptURL;
    script.async = true;
    document.head.appendChild(script);
}
/**
 * Get reference to, or create, global datalayer.
 * @param dataLayerName Name of datalayer (most often the default, "_dataLayer").
 */ function $0d15f034d14801d0$var$getOrCreateDataLayer(dataLayerName) {
    // Check for existing dataLayer and create if needed.
    let dataLayer = [];
    if (Array.isArray(window[dataLayerName])) dataLayer = window[dataLayerName];
    else window[dataLayerName] = dataLayer;
    return dataLayer;
}
/**
 * Wrapped gtag logic when gtag is called with 'config' command.
 *
 * @param gtagCore Basic gtag function that just appends to dataLayer.
 * @param initializationPromisesMap Map of appIds to their initialization promises.
 * @param dynamicConfigPromisesList Array of dynamic config fetch promises.
 * @param measurementIdToAppId Map of GA measurementIDs to corresponding Firebase appId.
 * @param measurementId GA Measurement ID to set config for.
 * @param gtagParams Gtag config params to set.
 */ async function $0d15f034d14801d0$var$gtagOnConfig(gtagCore, initializationPromisesMap, dynamicConfigPromisesList, measurementIdToAppId, measurementId, gtagParams) {
    // If config is already fetched, we know the appId and can use it to look up what FID promise we
    /// are waiting for, and wait only on that one.
    const correspondingAppId = measurementIdToAppId[measurementId];
    try {
        if (correspondingAppId) await initializationPromisesMap[correspondingAppId];
        else {
            // If config is not fetched yet, wait for all configs (we don't know which one we need) and
            // find the appId (if any) corresponding to this measurementId. If there is one, wait on
            // that appId's initialization promise. If there is none, promise resolves and gtag
            // call goes through.
            const dynamicConfigResults = await $0d15f034d14801d0$var$promiseAllSettled(dynamicConfigPromisesList);
            const foundConfig = dynamicConfigResults.find((config)=>config.measurementId === measurementId);
            if (foundConfig) await initializationPromisesMap[foundConfig.appId];
        }
    } catch (e) {
        $0d15f034d14801d0$var$logger.error(e);
    }
    gtagCore("config" /* GtagCommand.CONFIG */ , measurementId, gtagParams);
}
/**
 * Wrapped gtag logic when gtag is called with 'event' command.
 *
 * @param gtagCore Basic gtag function that just appends to dataLayer.
 * @param initializationPromisesMap Map of appIds to their initialization promises.
 * @param dynamicConfigPromisesList Array of dynamic config fetch promises.
 * @param measurementId GA Measurement ID to log event to.
 * @param gtagParams Params to log with this event.
 */ async function $0d15f034d14801d0$var$gtagOnEvent(gtagCore, initializationPromisesMap, dynamicConfigPromisesList, measurementId, gtagParams) {
    try {
        let initializationPromisesToWaitFor = [];
        // If there's a 'send_to' param, check if any ID specified matches
        // an initializeIds() promise we are waiting for.
        if (gtagParams && gtagParams["send_to"]) {
            let gaSendToList = gtagParams["send_to"];
            // Make it an array if is isn't, so it can be dealt with the same way.
            if (!Array.isArray(gaSendToList)) gaSendToList = [
                gaSendToList
            ];
            // Checking 'send_to' fields requires having all measurement ID results back from
            // the dynamic config fetch.
            const dynamicConfigResults = await $0d15f034d14801d0$var$promiseAllSettled(dynamicConfigPromisesList);
            for (const sendToId of gaSendToList){
                // Any fetched dynamic measurement ID that matches this 'send_to' ID
                const foundConfig = dynamicConfigResults.find((config)=>config.measurementId === sendToId);
                const initializationPromise = foundConfig && initializationPromisesMap[foundConfig.appId];
                if (initializationPromise) initializationPromisesToWaitFor.push(initializationPromise);
                else {
                    // Found an item in 'send_to' that is not associated
                    // directly with an FID, possibly a group.  Empty this array,
                    // exit the loop early, and let it get populated below.
                    initializationPromisesToWaitFor = [];
                    break;
                }
            }
        }
        // This will be unpopulated if there was no 'send_to' field , or
        // if not all entries in the 'send_to' field could be mapped to
        // a FID. In these cases, wait on all pending initialization promises.
        if (initializationPromisesToWaitFor.length === 0) initializationPromisesToWaitFor = Object.values(initializationPromisesMap);
        // Run core gtag function with args after all relevant initialization
        // promises have been resolved.
        await Promise.all(initializationPromisesToWaitFor);
        // Workaround for http://b/141370449 - third argument cannot be undefined.
        gtagCore("event" /* GtagCommand.EVENT */ , measurementId, gtagParams || {});
    } catch (e) {
        $0d15f034d14801d0$var$logger.error(e);
    }
}
/**
 * Wraps a standard gtag function with extra code to wait for completion of
 * relevant initialization promises before sending requests.
 *
 * @param gtagCore Basic gtag function that just appends to dataLayer.
 * @param initializationPromisesMap Map of appIds to their initialization promises.
 * @param dynamicConfigPromisesList Array of dynamic config fetch promises.
 * @param measurementIdToAppId Map of GA measurementIDs to corresponding Firebase appId.
 */ function $0d15f034d14801d0$var$wrapGtag(gtagCore, /**
 * Allows wrapped gtag calls to wait on whichever intialization promises are required,
 * depending on the contents of the gtag params' `send_to` field, if any.
 */ initializationPromisesMap, /**
 * Wrapped gtag calls sometimes require all dynamic config fetches to have returned
 * before determining what initialization promises (which include FIDs) to wait for.
 */ dynamicConfigPromisesList, /**
 * Wrapped gtag config calls can narrow down which initialization promise (with FID)
 * to wait for if the measurementId is already fetched, by getting the corresponding appId,
 * which is the key for the initialization promises map.
 */ measurementIdToAppId) {
    /**
     * Wrapper around gtag that ensures FID is sent with gtag calls.
     * @param command Gtag command type.
     * @param idOrNameOrParams Measurement ID if command is EVENT/CONFIG, params if command is SET.
     * @param gtagParams Params if event is EVENT/CONFIG.
     */ async function gtagWrapper(command, ...args) {
        try {
            // If event, check that relevant initialization promises have completed.
            if (command === "event" /* GtagCommand.EVENT */ ) {
                const [measurementId, gtagParams] = args;
                // If EVENT, second arg must be measurementId.
                await $0d15f034d14801d0$var$gtagOnEvent(gtagCore, initializationPromisesMap, dynamicConfigPromisesList, measurementId, gtagParams);
            } else if (command === "config" /* GtagCommand.CONFIG */ ) {
                const [measurementId, gtagParams] = args;
                // If CONFIG, second arg must be measurementId.
                await $0d15f034d14801d0$var$gtagOnConfig(gtagCore, initializationPromisesMap, dynamicConfigPromisesList, measurementIdToAppId, measurementId, gtagParams);
            } else if (command === "consent" /* GtagCommand.CONSENT */ ) {
                const [gtagParams] = args;
                gtagCore("consent" /* GtagCommand.CONSENT */ , "update", gtagParams);
            } else if (command === "get" /* GtagCommand.GET */ ) {
                const [measurementId, fieldName, callback] = args;
                gtagCore("get" /* GtagCommand.GET */ , measurementId, fieldName, callback);
            } else if (command === "set" /* GtagCommand.SET */ ) {
                const [customParams] = args;
                // If SET, second arg must be params.
                gtagCore("set" /* GtagCommand.SET */ , customParams);
            } else gtagCore(command, ...args);
        } catch (e) {
            $0d15f034d14801d0$var$logger.error(e);
        }
    }
    return gtagWrapper;
}
/**
 * Creates global gtag function or wraps existing one if found.
 * This wrapped function attaches Firebase instance ID (FID) to gtag 'config' and
 * 'event' calls that belong to the GAID associated with this Firebase instance.
 *
 * @param initializationPromisesMap Map of appIds to their initialization promises.
 * @param dynamicConfigPromisesList Array of dynamic config fetch promises.
 * @param measurementIdToAppId Map of GA measurementIDs to corresponding Firebase appId.
 * @param dataLayerName Name of global GA datalayer array.
 * @param gtagFunctionName Name of global gtag function ("gtag" if not user-specified).
 */ function $0d15f034d14801d0$var$wrapOrCreateGtag(initializationPromisesMap, dynamicConfigPromisesList, measurementIdToAppId, dataLayerName, gtagFunctionName) {
    // Create a basic core gtag function
    let gtagCore = function(..._args) {
        // Must push IArguments object, not an array.
        window[dataLayerName].push(arguments);
    };
    // Replace it with existing one if found
    if (window[gtagFunctionName] && typeof window[gtagFunctionName] === "function") // @ts-ignore
    gtagCore = window[gtagFunctionName];
    window[gtagFunctionName] = $0d15f034d14801d0$var$wrapGtag(gtagCore, initializationPromisesMap, dynamicConfigPromisesList, measurementIdToAppId);
    return {
        gtagCore: gtagCore,
        wrappedGtag: window[gtagFunctionName]
    };
}
/**
 * Returns the script tag in the DOM matching both the gtag url pattern
 * and the provided data layer name.
 */ function $0d15f034d14801d0$var$findGtagScriptOnPage(dataLayerName) {
    const scriptTags = window.document.getElementsByTagName("script");
    for (const tag of Object.values(scriptTags)){
        if (tag.src && tag.src.includes($0d15f034d14801d0$var$GTAG_URL) && tag.src.includes(dataLayerName)) return tag;
    }
    return null;
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Backoff factor for 503 errors, which we want to be conservative about
 * to avoid overloading servers. Each retry interval will be
 * BASE_INTERVAL_MILLIS * LONG_RETRY_FACTOR ^ retryCount, so the second one
 * will be ~30 seconds (with fuzzing).
 */ const $0d15f034d14801d0$var$LONG_RETRY_FACTOR = 30;
/**
 * Base wait interval to multiplied by backoffFactor^backoffCount.
 */ const $0d15f034d14801d0$var$BASE_INTERVAL_MILLIS = 1000;
/**
 * Stubbable retry data storage class.
 */ class $0d15f034d14801d0$var$RetryData {
    constructor(throttleMetadata = {}, intervalMillis = $0d15f034d14801d0$var$BASE_INTERVAL_MILLIS){
        this.throttleMetadata = throttleMetadata;
        this.intervalMillis = intervalMillis;
    }
    getThrottleMetadata(appId) {
        return this.throttleMetadata[appId];
    }
    setThrottleMetadata(appId, metadata) {
        this.throttleMetadata[appId] = metadata;
    }
    deleteThrottleMetadata(appId) {
        delete this.throttleMetadata[appId];
    }
}
const $0d15f034d14801d0$var$defaultRetryData = new $0d15f034d14801d0$var$RetryData();
/**
 * Set GET request headers.
 * @param apiKey App API key.
 */ function $0d15f034d14801d0$var$getHeaders(apiKey) {
    return new Headers({
        Accept: "application/json",
        "x-goog-api-key": apiKey
    });
}
/**
 * Fetches dynamic config from backend.
 * @param app Firebase app to fetch config for.
 */ async function $0d15f034d14801d0$var$fetchDynamicConfig(appFields) {
    var _a;
    const { appId: appId, apiKey: apiKey } = appFields;
    const request = {
        method: "GET",
        headers: $0d15f034d14801d0$var$getHeaders(apiKey)
    };
    const appUrl = $0d15f034d14801d0$var$DYNAMIC_CONFIG_URL.replace("{app-id}", appId);
    const response = await fetch(appUrl, request);
    if (response.status !== 200 && response.status !== 304) {
        let errorMessage = "";
        try {
            // Try to get any error message text from server response.
            const jsonResponse = await response.json();
            if ((_a = jsonResponse.error) === null || _a === void 0 ? void 0 : _a.message) errorMessage = jsonResponse.error.message;
        } catch (_ignored) {}
        throw $0d15f034d14801d0$var$ERROR_FACTORY.create("config-fetch-failed" /* AnalyticsError.CONFIG_FETCH_FAILED */ , {
            httpStatus: response.status,
            responseMessage: errorMessage
        });
    }
    return response.json();
}
/**
 * Fetches dynamic config from backend, retrying if failed.
 * @param app Firebase app to fetch config for.
 */ async function $0d15f034d14801d0$var$fetchDynamicConfigWithRetry(app, // retryData and timeoutMillis are parameterized to allow passing a different value for testing.
retryData = $0d15f034d14801d0$var$defaultRetryData, timeoutMillis) {
    const { appId: appId, apiKey: apiKey, measurementId: measurementId } = app.options;
    if (!appId) throw $0d15f034d14801d0$var$ERROR_FACTORY.create("no-app-id" /* AnalyticsError.NO_APP_ID */ );
    if (!apiKey) {
        if (measurementId) return {
            measurementId: measurementId,
            appId: appId
        };
        throw $0d15f034d14801d0$var$ERROR_FACTORY.create("no-api-key" /* AnalyticsError.NO_API_KEY */ );
    }
    const throttleMetadata = retryData.getThrottleMetadata(appId) || {
        backoffCount: 0,
        throttleEndTimeMillis: Date.now()
    };
    const signal = new $0d15f034d14801d0$var$AnalyticsAbortSignal();
    setTimeout(async ()=>{
        // Note a very low delay, eg < 10ms, can elapse before listeners are initialized.
        signal.abort();
    }, timeoutMillis !== undefined ? timeoutMillis : $0d15f034d14801d0$var$FETCH_TIMEOUT_MILLIS);
    return $0d15f034d14801d0$var$attemptFetchDynamicConfigWithRetry({
        appId: appId,
        apiKey: apiKey,
        measurementId: measurementId
    }, throttleMetadata, signal, retryData);
}
/**
 * Runs one retry attempt.
 * @param appFields Necessary app config fields.
 * @param throttleMetadata Ongoing metadata to determine throttling times.
 * @param signal Abort signal.
 */ async function $0d15f034d14801d0$var$attemptFetchDynamicConfigWithRetry(appFields, { throttleEndTimeMillis: throttleEndTimeMillis, backoffCount: backoffCount }, signal, retryData = $0d15f034d14801d0$var$defaultRetryData // for testing
) {
    var _a;
    const { appId: appId, measurementId: measurementId } = appFields;
    // Starts with a (potentially zero) timeout to support resumption from stored state.
    // Ensures the throttle end time is honored if the last attempt timed out.
    // Note the SDK will never make a request if the fetch timeout expires at this point.
    try {
        await $0d15f034d14801d0$var$setAbortableTimeout(signal, throttleEndTimeMillis);
    } catch (e) {
        if (measurementId) {
            $0d15f034d14801d0$var$logger.warn(`Timed out fetching this Firebase app's measurement ID from the server.` + ` Falling back to the measurement ID ${measurementId}` + ` provided in the "measurementId" field in the local Firebase config. [${e === null || e === void 0 ? void 0 : e.message}]`);
            return {
                appId: appId,
                measurementId: measurementId
            };
        }
        throw e;
    }
    try {
        const response = await $0d15f034d14801d0$var$fetchDynamicConfig(appFields);
        // Note the SDK only clears throttle state if response is success or non-retriable.
        retryData.deleteThrottleMetadata(appId);
        return response;
    } catch (e) {
        const error = e;
        if (!$0d15f034d14801d0$var$isRetriableError(error)) {
            retryData.deleteThrottleMetadata(appId);
            if (measurementId) {
                $0d15f034d14801d0$var$logger.warn(`Failed to fetch this Firebase app's measurement ID from the server.` + ` Falling back to the measurement ID ${measurementId}` + ` provided in the "measurementId" field in the local Firebase config. [${error === null || error === void 0 ? void 0 : error.message}]`);
                return {
                    appId: appId,
                    measurementId: measurementId
                };
            } else throw e;
        }
        const backoffMillis = Number((_a = error === null || error === void 0 ? void 0 : error.customData) === null || _a === void 0 ? void 0 : _a.httpStatus) === 503 ? (0, $c38e0f42709c826a$export$4d810c0ca64ed8e9)(backoffCount, retryData.intervalMillis, $0d15f034d14801d0$var$LONG_RETRY_FACTOR) : (0, $c38e0f42709c826a$export$4d810c0ca64ed8e9)(backoffCount, retryData.intervalMillis);
        // Increments backoff state.
        const throttleMetadata = {
            throttleEndTimeMillis: Date.now() + backoffMillis,
            backoffCount: backoffCount + 1
        };
        // Persists state.
        retryData.setThrottleMetadata(appId, throttleMetadata);
        $0d15f034d14801d0$var$logger.debug(`Calling attemptFetch again in ${backoffMillis} millis`);
        return $0d15f034d14801d0$var$attemptFetchDynamicConfigWithRetry(appFields, throttleMetadata, signal, retryData);
    }
}
/**
 * Supports waiting on a backoff by:
 *
 * <ul>
 *   <li>Promisifying setTimeout, so we can set a timeout in our Promise chain</li>
 *   <li>Listening on a signal bus for abort events, just like the Fetch API</li>
 *   <li>Failing in the same way the Fetch API fails, so timing out a live request and a throttled
 *       request appear the same.</li>
 * </ul>
 *
 * <p>Visible for testing.
 */ function $0d15f034d14801d0$var$setAbortableTimeout(signal, throttleEndTimeMillis) {
    return new Promise((resolve, reject)=>{
        // Derives backoff from given end time, normalizing negative numbers to zero.
        const backoffMillis = Math.max(throttleEndTimeMillis - Date.now(), 0);
        const timeout = setTimeout(resolve, backoffMillis);
        // Adds listener, rather than sets onabort, because signal is a shared object.
        signal.addEventListener(()=>{
            clearTimeout(timeout);
            // If the request completes before this timeout, the rejection has no effect.
            reject($0d15f034d14801d0$var$ERROR_FACTORY.create("fetch-throttle" /* AnalyticsError.FETCH_THROTTLE */ , {
                throttleEndTimeMillis: throttleEndTimeMillis
            }));
        });
    });
}
/**
 * Returns true if the {@link Error} indicates a fetch request may succeed later.
 */ function $0d15f034d14801d0$var$isRetriableError(e) {
    if (!(e instanceof (0, $c38e0f42709c826a$export$dd24e9cd51226c56)) || !e.customData) return false;
    // Uses string index defined by ErrorData, which FirebaseError implements.
    const httpStatus = Number(e.customData["httpStatus"]);
    return httpStatus === 429 || httpStatus === 500 || httpStatus === 503 || httpStatus === 504;
}
/**
 * Shims a minimal AbortSignal (copied from Remote Config).
 *
 * <p>AbortController's AbortSignal conveniently decouples fetch timeout logic from other aspects
 * of networking, such as retries. Firebase doesn't use AbortController enough to justify a
 * polyfill recommendation, like we do with the Fetch API, but this minimal shim can easily be
 * swapped out if/when we do.
 */ class $0d15f034d14801d0$var$AnalyticsAbortSignal {
    constructor(){
        this.listeners = [];
    }
    addEventListener(listener) {
        this.listeners.push(listener);
    }
    abort() {
        this.listeners.forEach((listener)=>listener());
    }
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Event parameters to set on 'gtag' during initialization.
 */ let $0d15f034d14801d0$var$defaultEventParametersForInit;
/**
 * Logs an analytics event through the Firebase SDK.
 *
 * @param gtagFunction Wrapped gtag function that waits for fid to be set before sending an event
 * @param eventName Google Analytics event name, choose from standard list or use a custom string.
 * @param eventParams Analytics event parameters.
 */ async function $0d15f034d14801d0$var$logEvent$1(gtagFunction, initializationPromise, eventName, eventParams, options) {
    if (options && options.global) {
        gtagFunction("event" /* GtagCommand.EVENT */ , eventName, eventParams);
        return;
    } else {
        const measurementId = await initializationPromise;
        const params = Object.assign(Object.assign({}, eventParams), {
            "send_to": measurementId
        });
        gtagFunction("event" /* GtagCommand.EVENT */ , eventName, params);
    }
}
/**
 * Set screen_name parameter for this Google Analytics ID.
 *
 * @deprecated Use {@link logEvent} with `eventName` as 'screen_view' and add relevant `eventParams`.
 * See {@link https://firebase.google.com/docs/analytics/screenviews | Track Screenviews}.
 *
 * @param gtagFunction Wrapped gtag function that waits for fid to be set before sending an event
 * @param screenName Screen name string to set.
 */ async function $0d15f034d14801d0$var$setCurrentScreen$1(gtagFunction, initializationPromise, screenName, options) {
    if (options && options.global) {
        gtagFunction("set" /* GtagCommand.SET */ , {
            "screen_name": screenName
        });
        return Promise.resolve();
    } else {
        const measurementId = await initializationPromise;
        gtagFunction("config" /* GtagCommand.CONFIG */ , measurementId, {
            update: true,
            "screen_name": screenName
        });
    }
}
/**
 * Set user_id parameter for this Google Analytics ID.
 *
 * @param gtagFunction Wrapped gtag function that waits for fid to be set before sending an event
 * @param id User ID string to set
 */ async function $0d15f034d14801d0$var$setUserId$1(gtagFunction, initializationPromise, id, options) {
    if (options && options.global) {
        gtagFunction("set" /* GtagCommand.SET */ , {
            "user_id": id
        });
        return Promise.resolve();
    } else {
        const measurementId = await initializationPromise;
        gtagFunction("config" /* GtagCommand.CONFIG */ , measurementId, {
            update: true,
            "user_id": id
        });
    }
}
/**
 * Set all other user properties other than user_id and screen_name.
 *
 * @param gtagFunction Wrapped gtag function that waits for fid to be set before sending an event
 * @param properties Map of user properties to set
 */ async function $0d15f034d14801d0$var$setUserProperties$1(gtagFunction, initializationPromise, properties, options) {
    if (options && options.global) {
        const flatProperties = {};
        for (const key of Object.keys(properties))// use dot notation for merge behavior in gtag.js
        flatProperties[`user_properties.${key}`] = properties[key];
        gtagFunction("set" /* GtagCommand.SET */ , flatProperties);
        return Promise.resolve();
    } else {
        const measurementId = await initializationPromise;
        gtagFunction("config" /* GtagCommand.CONFIG */ , measurementId, {
            update: true,
            "user_properties": properties
        });
    }
}
/**
 * Retrieves a unique Google Analytics identifier for the web client.
 * See {@link https://developers.google.com/analytics/devguides/collection/ga4/reference/config#client_id | client_id}.
 *
 * @param gtagFunction Wrapped gtag function that waits for fid to be set before sending an event
 */ async function $0d15f034d14801d0$var$internalGetGoogleAnalyticsClientId(gtagFunction, initializationPromise) {
    const measurementId = await initializationPromise;
    return new Promise((resolve, reject)=>{
        gtagFunction("get" /* GtagCommand.GET */ , measurementId, "client_id", (clientId)=>{
            if (!clientId) reject($0d15f034d14801d0$var$ERROR_FACTORY.create("no-client-id" /* AnalyticsError.NO_CLIENT_ID */ ));
            resolve(clientId);
        });
    });
}
/**
 * Set whether collection is enabled for this ID.
 *
 * @param enabled If true, collection is enabled for this ID.
 */ async function $0d15f034d14801d0$var$setAnalyticsCollectionEnabled$1(initializationPromise, enabled) {
    const measurementId = await initializationPromise;
    window[`ga-disable-${measurementId}`] = !enabled;
}
/**
 * Consent parameters to default to during 'gtag' initialization.
 */ let $0d15f034d14801d0$var$defaultConsentSettingsForInit;
/**
 * Sets the variable {@link defaultConsentSettingsForInit} for use in the initialization of
 * analytics.
 *
 * @param consentSettings Maps the applicable end user consent state for gtag.js.
 */ function $0d15f034d14801d0$var$_setConsentDefaultForInit(consentSettings) {
    $0d15f034d14801d0$var$defaultConsentSettingsForInit = consentSettings;
}
/**
 * Sets the variable `defaultEventParametersForInit` for use in the initialization of
 * analytics.
 *
 * @param customParams Any custom params the user may pass to gtag.js.
 */ function $0d15f034d14801d0$var$_setDefaultEventParametersForInit(customParams) {
    $0d15f034d14801d0$var$defaultEventParametersForInit = customParams;
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ async function $0d15f034d14801d0$var$validateIndexedDB() {
    if (!(0, $c38e0f42709c826a$export$3865db50535c2055)()) {
        $0d15f034d14801d0$var$logger.warn($0d15f034d14801d0$var$ERROR_FACTORY.create("indexeddb-unavailable" /* AnalyticsError.INDEXEDDB_UNAVAILABLE */ , {
            errorInfo: "IndexedDB is not available in this environment."
        }).message);
        return false;
    } else try {
        await (0, $c38e0f42709c826a$export$a8a3018f3d187a4d)();
    } catch (e) {
        $0d15f034d14801d0$var$logger.warn($0d15f034d14801d0$var$ERROR_FACTORY.create("indexeddb-unavailable" /* AnalyticsError.INDEXEDDB_UNAVAILABLE */ , {
            errorInfo: e === null || e === void 0 ? void 0 : e.toString()
        }).message);
        return false;
    }
    return true;
}
/**
 * Initialize the analytics instance in gtag.js by calling config command with fid.
 *
 * NOTE: We combine analytics initialization and setting fid together because we want fid to be
 * part of the `page_view` event that's sent during the initialization
 * @param app Firebase app
 * @param gtagCore The gtag function that's not wrapped.
 * @param dynamicConfigPromisesList Array of all dynamic config promises.
 * @param measurementIdToAppId Maps measurementID to appID.
 * @param installations _FirebaseInstallationsInternal instance.
 *
 * @returns Measurement ID.
 */ async function $0d15f034d14801d0$var$_initializeAnalytics(app, dynamicConfigPromisesList, measurementIdToAppId, installations, gtagCore, dataLayerName, options) {
    var _a;
    const dynamicConfigPromise = $0d15f034d14801d0$var$fetchDynamicConfigWithRetry(app);
    // Once fetched, map measurementIds to appId, for ease of lookup in wrapped gtag function.
    dynamicConfigPromise.then((config)=>{
        measurementIdToAppId[config.measurementId] = config.appId;
        if (app.options.measurementId && config.measurementId !== app.options.measurementId) $0d15f034d14801d0$var$logger.warn(`The measurement ID in the local Firebase config (${app.options.measurementId})` + ` does not match the measurement ID fetched from the server (${config.measurementId}).` + ` To ensure analytics events are always sent to the correct Analytics property,` + ` update the` + ` measurement ID field in the local config or remove it from the local config.`);
    }).catch((e)=>$0d15f034d14801d0$var$logger.error(e));
    // Add to list to track state of all dynamic config promises.
    dynamicConfigPromisesList.push(dynamicConfigPromise);
    const fidPromise = $0d15f034d14801d0$var$validateIndexedDB().then((envIsValid)=>{
        if (envIsValid) return installations.getId();
        else return undefined;
    });
    const [dynamicConfig, fid] = await Promise.all([
        dynamicConfigPromise,
        fidPromise
    ]);
    // Detect if user has already put the gtag <script> tag on this page with the passed in
    // data layer name.
    if (!$0d15f034d14801d0$var$findGtagScriptOnPage(dataLayerName)) $0d15f034d14801d0$var$insertScriptTag(dataLayerName, dynamicConfig.measurementId);
    // Detects if there are consent settings that need to be configured.
    if ($0d15f034d14801d0$var$defaultConsentSettingsForInit) {
        gtagCore("consent" /* GtagCommand.CONSENT */ , "default", $0d15f034d14801d0$var$defaultConsentSettingsForInit);
        $0d15f034d14801d0$var$_setConsentDefaultForInit(undefined);
    }
    // This command initializes gtag.js and only needs to be called once for the entire web app,
    // but since it is idempotent, we can call it multiple times.
    // We keep it together with other initialization logic for better code structure.
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    gtagCore("js", new Date());
    // User config added first. We don't want users to accidentally overwrite
    // base Firebase config properties.
    const configProperties = (_a = options === null || options === void 0 ? void 0 : options.config) !== null && _a !== void 0 ? _a : {};
    // guard against developers accidentally setting properties with prefix `firebase_`
    configProperties[$0d15f034d14801d0$var$ORIGIN_KEY] = "firebase";
    configProperties.update = true;
    if (fid != null) configProperties[$0d15f034d14801d0$var$GA_FID_KEY] = fid;
    // It should be the first config command called on this GA-ID
    // Initialize this GA-ID and set FID on it using the gtag config API.
    // Note: This will trigger a page_view event unless 'send_page_view' is set to false in
    // `configProperties`.
    gtagCore("config" /* GtagCommand.CONFIG */ , dynamicConfig.measurementId, configProperties);
    // Detects if there is data that will be set on every event logged from the SDK.
    if ($0d15f034d14801d0$var$defaultEventParametersForInit) {
        gtagCore("set" /* GtagCommand.SET */ , $0d15f034d14801d0$var$defaultEventParametersForInit);
        $0d15f034d14801d0$var$_setDefaultEventParametersForInit(undefined);
    }
    return dynamicConfig.measurementId;
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Analytics Service class.
 */ class $0d15f034d14801d0$var$AnalyticsService {
    constructor(app){
        this.app = app;
    }
    _delete() {
        delete $0d15f034d14801d0$var$initializationPromisesMap[this.app.options.appId];
        return Promise.resolve();
    }
}
/**
 * Maps appId to full initialization promise. Wrapped gtag calls must wait on
 * all or some of these, depending on the call's `send_to` param and the status
 * of the dynamic config fetches (see below).
 */ let $0d15f034d14801d0$var$initializationPromisesMap = {};
/**
 * List of dynamic config fetch promises. In certain cases, wrapped gtag calls
 * wait on all these to be complete in order to determine if it can selectively
 * wait for only certain initialization (FID) promises or if it must wait for all.
 */ let $0d15f034d14801d0$var$dynamicConfigPromisesList = [];
/**
 * Maps fetched measurementIds to appId. Populated when the app's dynamic config
 * fetch completes. If already populated, gtag config calls can use this to
 * selectively wait for only this app's initialization promise (FID) instead of all
 * initialization promises.
 */ const $0d15f034d14801d0$var$measurementIdToAppId = {};
/**
 * Name for window global data layer array used by GA: defaults to 'dataLayer'.
 */ let $0d15f034d14801d0$var$dataLayerName = "dataLayer";
/**
 * Name for window global gtag function used by GA: defaults to 'gtag'.
 */ let $0d15f034d14801d0$var$gtagName = "gtag";
/**
 * Reproduction of standard gtag function or reference to existing
 * gtag function on window object.
 */ let $0d15f034d14801d0$var$gtagCoreFunction;
/**
 * Wrapper around gtag function that ensures FID is sent with all
 * relevant event and config calls.
 */ let $0d15f034d14801d0$var$wrappedGtagFunction;
/**
 * Flag to ensure page initialization steps (creation or wrapping of
 * dataLayer and gtag script) are only run once per page load.
 */ let $0d15f034d14801d0$var$globalInitDone = false;
/**
 * Configures Firebase Analytics to use custom `gtag` or `dataLayer` names.
 * Intended to be used if `gtag.js` script has been installed on
 * this page independently of Firebase Analytics, and is using non-default
 * names for either the `gtag` function or for `dataLayer`.
 * Must be called before calling `getAnalytics()` or it won't
 * have any effect.
 *
 * @public
 *
 * @param options - Custom gtag and dataLayer names.
 */ function $0d15f034d14801d0$export$a5a6e0b888b2c992(options) {
    if ($0d15f034d14801d0$var$globalInitDone) throw $0d15f034d14801d0$var$ERROR_FACTORY.create("already-initialized" /* AnalyticsError.ALREADY_INITIALIZED */ );
    if (options.dataLayerName) $0d15f034d14801d0$var$dataLayerName = options.dataLayerName;
    if (options.gtagName) $0d15f034d14801d0$var$gtagName = options.gtagName;
}
/**
 * Returns true if no environment mismatch is found.
 * If environment mismatches are found, throws an INVALID_ANALYTICS_CONTEXT
 * error that also lists details for each mismatch found.
 */ function $0d15f034d14801d0$var$warnOnBrowserContextMismatch() {
    const mismatchedEnvMessages = [];
    if ((0, $c38e0f42709c826a$export$caa8774a9107a58e)()) mismatchedEnvMessages.push("This is a browser extension environment.");
    if (!(0, $c38e0f42709c826a$export$f172b7eb6cf60599)()) mismatchedEnvMessages.push("Cookies are not available.");
    if (mismatchedEnvMessages.length > 0) {
        const details = mismatchedEnvMessages.map((message, index)=>`(${index + 1}) ${message}`).join(" ");
        const err = $0d15f034d14801d0$var$ERROR_FACTORY.create("invalid-analytics-context" /* AnalyticsError.INVALID_ANALYTICS_CONTEXT */ , {
            errorInfo: details
        });
        $0d15f034d14801d0$var$logger.warn(err.message);
    }
}
/**
 * Analytics instance factory.
 * @internal
 */ function $0d15f034d14801d0$var$factory(app, installations, options) {
    $0d15f034d14801d0$var$warnOnBrowserContextMismatch();
    const appId = app.options.appId;
    if (!appId) throw $0d15f034d14801d0$var$ERROR_FACTORY.create("no-app-id" /* AnalyticsError.NO_APP_ID */ );
    if (!app.options.apiKey) {
        if (app.options.measurementId) $0d15f034d14801d0$var$logger.warn(`The "apiKey" field is empty in the local Firebase config. This is needed to fetch the latest` + ` measurement ID for this Firebase app. Falling back to the measurement ID ${app.options.measurementId}` + ` provided in the "measurementId" field in the local Firebase config.`);
        else throw $0d15f034d14801d0$var$ERROR_FACTORY.create("no-api-key" /* AnalyticsError.NO_API_KEY */ );
    }
    if ($0d15f034d14801d0$var$initializationPromisesMap[appId] != null) throw $0d15f034d14801d0$var$ERROR_FACTORY.create("already-exists" /* AnalyticsError.ALREADY_EXISTS */ , {
        id: appId
    });
    if (!$0d15f034d14801d0$var$globalInitDone) {
        // Steps here should only be done once per page: creation or wrapping
        // of dataLayer and global gtag function.
        $0d15f034d14801d0$var$getOrCreateDataLayer($0d15f034d14801d0$var$dataLayerName);
        const { wrappedGtag: wrappedGtag, gtagCore: gtagCore } = $0d15f034d14801d0$var$wrapOrCreateGtag($0d15f034d14801d0$var$initializationPromisesMap, $0d15f034d14801d0$var$dynamicConfigPromisesList, $0d15f034d14801d0$var$measurementIdToAppId, $0d15f034d14801d0$var$dataLayerName, $0d15f034d14801d0$var$gtagName);
        $0d15f034d14801d0$var$wrappedGtagFunction = wrappedGtag;
        $0d15f034d14801d0$var$gtagCoreFunction = gtagCore;
        $0d15f034d14801d0$var$globalInitDone = true;
    }
    // Async but non-blocking.
    // This map reflects the completion state of all promises for each appId.
    $0d15f034d14801d0$var$initializationPromisesMap[appId] = $0d15f034d14801d0$var$_initializeAnalytics(app, $0d15f034d14801d0$var$dynamicConfigPromisesList, $0d15f034d14801d0$var$measurementIdToAppId, installations, $0d15f034d14801d0$var$gtagCoreFunction, $0d15f034d14801d0$var$dataLayerName, options);
    const analyticsInstance = new $0d15f034d14801d0$var$AnalyticsService(app);
    return analyticsInstance;
}
/* eslint-disable @typescript-eslint/no-explicit-any */ /**
 * Returns an {@link Analytics} instance for the given app.
 *
 * @public
 *
 * @param app - The {@link @firebase/app#FirebaseApp} to use.
 */ function $0d15f034d14801d0$export$b0297573c90085aa(app = (0, $57d436074e210fb5$export$f9962582c9e66d99)()) {
    app = (0, $c38e0f42709c826a$export$4befe9b5fa509a1b)(app);
    // Dependencies
    const analyticsProvider = (0, $57d436074e210fb5$export$fa0d6da0f5838f50)(app, $0d15f034d14801d0$var$ANALYTICS_TYPE);
    if (analyticsProvider.isInitialized()) return analyticsProvider.getImmediate();
    return $0d15f034d14801d0$export$e1ffb6ba450b0317(app);
}
/**
 * Returns an {@link Analytics} instance for the given app.
 *
 * @public
 *
 * @param app - The {@link @firebase/app#FirebaseApp} to use.
 */ function $0d15f034d14801d0$export$e1ffb6ba450b0317(app, options = {}) {
    // Dependencies
    const analyticsProvider = (0, $57d436074e210fb5$export$fa0d6da0f5838f50)(app, $0d15f034d14801d0$var$ANALYTICS_TYPE);
    if (analyticsProvider.isInitialized()) {
        const existingInstance = analyticsProvider.getImmediate();
        if ((0, $c38e0f42709c826a$export$9cb4719e2e525b7a)(options, analyticsProvider.getOptions())) return existingInstance;
        else throw $0d15f034d14801d0$var$ERROR_FACTORY.create("already-initialized" /* AnalyticsError.ALREADY_INITIALIZED */ );
    }
    const analyticsInstance = analyticsProvider.initialize({
        options: options
    });
    return analyticsInstance;
}
/**
 * This is a public static method provided to users that wraps four different checks:
 *
 * 1. Check if it's not a browser extension environment.
 * 2. Check if cookies are enabled in current browser.
 * 3. Check if IndexedDB is supported by the browser environment.
 * 4. Check if the current browser context is valid for using `IndexedDB.open()`.
 *
 * @public
 *
 */ async function $0d15f034d14801d0$export$48c17662a6902497() {
    if ((0, $c38e0f42709c826a$export$caa8774a9107a58e)()) return false;
    if (!(0, $c38e0f42709c826a$export$f172b7eb6cf60599)()) return false;
    if (!(0, $c38e0f42709c826a$export$3865db50535c2055)()) return false;
    try {
        const isDBOpenable = await (0, $c38e0f42709c826a$export$a8a3018f3d187a4d)();
        return isDBOpenable;
    } catch (error) {
        return false;
    }
}
/**
 * Use gtag `config` command to set `screen_name`.
 *
 * @public
 *
 * @deprecated Use {@link logEvent} with `eventName` as 'screen_view' and add relevant `eventParams`.
 * See {@link https://firebase.google.com/docs/analytics/screenviews | Track Screenviews}.
 *
 * @param analyticsInstance - The {@link Analytics} instance.
 * @param screenName - Screen name to set.
 */ function $0d15f034d14801d0$export$a364c5ef84862575(analyticsInstance, screenName, options) {
    analyticsInstance = (0, $c38e0f42709c826a$export$4befe9b5fa509a1b)(analyticsInstance);
    $0d15f034d14801d0$var$setCurrentScreen$1($0d15f034d14801d0$var$wrappedGtagFunction, $0d15f034d14801d0$var$initializationPromisesMap[analyticsInstance.app.options.appId], screenName, options).catch((e)=>$0d15f034d14801d0$var$logger.error(e));
}
/**
 * Retrieves a unique Google Analytics identifier for the web client.
 * See {@link https://developers.google.com/analytics/devguides/collection/ga4/reference/config#client_id | client_id}.
 *
 * @public
 *
 * @param app - The {@link @firebase/app#FirebaseApp} to use.
 */ async function $0d15f034d14801d0$export$108b704ce5c937fe(analyticsInstance) {
    analyticsInstance = (0, $c38e0f42709c826a$export$4befe9b5fa509a1b)(analyticsInstance);
    return $0d15f034d14801d0$var$internalGetGoogleAnalyticsClientId($0d15f034d14801d0$var$wrappedGtagFunction, $0d15f034d14801d0$var$initializationPromisesMap[analyticsInstance.app.options.appId]);
}
/**
 * Use gtag `config` command to set `user_id`.
 *
 * @public
 *
 * @param analyticsInstance - The {@link Analytics} instance.
 * @param id - User ID to set.
 */ function $0d15f034d14801d0$export$7f5abdb7f5093137(analyticsInstance, id, options) {
    analyticsInstance = (0, $c38e0f42709c826a$export$4befe9b5fa509a1b)(analyticsInstance);
    $0d15f034d14801d0$var$setUserId$1($0d15f034d14801d0$var$wrappedGtagFunction, $0d15f034d14801d0$var$initializationPromisesMap[analyticsInstance.app.options.appId], id, options).catch((e)=>$0d15f034d14801d0$var$logger.error(e));
}
/**
 * Use gtag `config` command to set all params specified.
 *
 * @public
 */ function $0d15f034d14801d0$export$d0e176862bf869b8(analyticsInstance, properties, options) {
    analyticsInstance = (0, $c38e0f42709c826a$export$4befe9b5fa509a1b)(analyticsInstance);
    $0d15f034d14801d0$var$setUserProperties$1($0d15f034d14801d0$var$wrappedGtagFunction, $0d15f034d14801d0$var$initializationPromisesMap[analyticsInstance.app.options.appId], properties, options).catch((e)=>$0d15f034d14801d0$var$logger.error(e));
}
/**
 * Sets whether Google Analytics collection is enabled for this app on this device.
 * Sets global `window['ga-disable-analyticsId'] = true;`
 *
 * @public
 *
 * @param analyticsInstance - The {@link Analytics} instance.
 * @param enabled - If true, enables collection, if false, disables it.
 */ function $0d15f034d14801d0$export$7d544a250c4ed423(analyticsInstance, enabled) {
    analyticsInstance = (0, $c38e0f42709c826a$export$4befe9b5fa509a1b)(analyticsInstance);
    $0d15f034d14801d0$var$setAnalyticsCollectionEnabled$1($0d15f034d14801d0$var$initializationPromisesMap[analyticsInstance.app.options.appId], enabled).catch((e)=>$0d15f034d14801d0$var$logger.error(e));
}
/**
 * Adds data that will be set on every event logged from the SDK, including automatic ones.
 * With gtag's "set" command, the values passed persist on the current page and are passed with
 * all subsequent events.
 * @public
 * @param customParams - Any custom params the user may pass to gtag.js.
 */ function $0d15f034d14801d0$export$9bde4a1551d6c3ba(customParams) {
    // Check if reference to existing gtag function on window object exists
    if ($0d15f034d14801d0$var$wrappedGtagFunction) $0d15f034d14801d0$var$wrappedGtagFunction("set" /* GtagCommand.SET */ , customParams);
    else $0d15f034d14801d0$var$_setDefaultEventParametersForInit(customParams);
}
/**
 * Sends a Google Analytics event with given `eventParams`. This method
 * automatically associates this logged event with this Firebase web
 * app instance on this device.
 * List of official event parameters can be found in the gtag.js
 * reference documentation:
 * {@link https://developers.google.com/gtagjs/reference/ga4-events
 * | the GA4 reference documentation}.
 *
 * @public
 */ function $0d15f034d14801d0$export$5e9eec8001665ac5(analyticsInstance, eventName, eventParams, options) {
    analyticsInstance = (0, $c38e0f42709c826a$export$4befe9b5fa509a1b)(analyticsInstance);
    $0d15f034d14801d0$var$logEvent$1($0d15f034d14801d0$var$wrappedGtagFunction, $0d15f034d14801d0$var$initializationPromisesMap[analyticsInstance.app.options.appId], eventName, eventParams, options).catch((e)=>$0d15f034d14801d0$var$logger.error(e));
}
/**
 * Sets the applicable end user consent state for this web app across all gtag references once
 * Firebase Analytics is initialized.
 *
 * Use the {@link ConsentSettings} to specify individual consent type values. By default consent
 * types are set to "granted".
 * @public
 * @param consentSettings - Maps the applicable end user consent state for gtag.js.
 */ function $0d15f034d14801d0$export$ff06c4c0781050d7(consentSettings) {
    // Check if reference to existing gtag function on window object exists
    if ($0d15f034d14801d0$var$wrappedGtagFunction) $0d15f034d14801d0$var$wrappedGtagFunction("consent" /* GtagCommand.CONSENT */ , "update", consentSettings);
    else $0d15f034d14801d0$var$_setConsentDefaultForInit(consentSettings);
}
const $0d15f034d14801d0$var$name = "@firebase/analytics";
const $0d15f034d14801d0$var$version = "0.10.0";
/**
 * Firebase Analytics
 *
 * @packageDocumentation
 */ function $0d15f034d14801d0$var$registerAnalytics() {
    (0, $57d436074e210fb5$export$c930050e7bb63965)(new (0, $a83e7ccd68ca8d4e$export$16fa2f45be04daa8)($0d15f034d14801d0$var$ANALYTICS_TYPE, (container, { options: analyticsOptions })=>{
        // getImmediate for FirebaseApp will always succeed
        const app = container.getProvider("app").getImmediate();
        const installations = container.getProvider("installations-internal").getImmediate();
        return $0d15f034d14801d0$var$factory(app, installations, analyticsOptions);
    }, "PUBLIC" /* ComponentType.PUBLIC */ ));
    (0, $57d436074e210fb5$export$c930050e7bb63965)(new (0, $a83e7ccd68ca8d4e$export$16fa2f45be04daa8)("analytics-internal", internalFactory, "PRIVATE" /* ComponentType.PRIVATE */ ));
    (0, $57d436074e210fb5$export$d29d5299a7137abc)($0d15f034d14801d0$var$name, $0d15f034d14801d0$var$version);
    // BUILD_TARGET will be replaced by values like esm5, esm2017, cjs5, etc during the compilation
    (0, $57d436074e210fb5$export$d29d5299a7137abc)($0d15f034d14801d0$var$name, $0d15f034d14801d0$var$version, "esm2017");
    function internalFactory(container) {
        try {
            const analytics = container.getProvider($0d15f034d14801d0$var$ANALYTICS_TYPE).getImmediate();
            return {
                logEvent: (eventName, eventParams, options)=>$0d15f034d14801d0$export$5e9eec8001665ac5(analytics, eventName, eventParams, options)
            };
        } catch (e) {
            throw $0d15f034d14801d0$var$ERROR_FACTORY.create("interop-component-reg-failed" /* AnalyticsError.INTEROP_COMPONENT_REG_FAILED */ , {
                reason: e
            });
        }
    }
}
$0d15f034d14801d0$var$registerAnalytics();





var $b20e7fc8482ee2a9$var$name = "firebase";
var $b20e7fc8482ee2a9$var$version = "9.23.0";
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ (0, $57d436074e210fb5$export$d29d5299a7137abc)($b20e7fc8482ee2a9$var$name, $b20e7fc8482ee2a9$var$version, "app");


// @ts-nocheck
/* eslint-disable */ 
/**
 * Tokenize input string.
 */ function $9a68e512a3ff5e52$var$lexer(str) {
    var tokens = [];
    var i = 0;
    while(i < str.length){
        var char = str[i];
        if (char === "*" || char === "+" || char === "?") {
            tokens.push({
                type: "MODIFIER",
                index: i,
                value: str[i++]
            });
            continue;
        }
        if (char === "\\") {
            tokens.push({
                type: "ESCAPED_CHAR",
                index: i++,
                value: str[i++]
            });
            continue;
        }
        if (char === "{") {
            tokens.push({
                type: "OPEN",
                index: i,
                value: str[i++]
            });
            continue;
        }
        if (char === "}") {
            tokens.push({
                type: "CLOSE",
                index: i,
                value: str[i++]
            });
            continue;
        }
        if (char === ":") {
            var name = "";
            var j = i + 1;
            while(j < str.length){
                var code = str.charCodeAt(j);
                if (// `0-9`
                code >= 48 && code <= 57 || // `A-Z`
                code >= 65 && code <= 90 || // `a-z`
                code >= 97 && code <= 122 || // `_`
                code === 95) {
                    name += str[j++];
                    continue;
                }
                break;
            }
            if (!name) throw new TypeError("Missing parameter name at ".concat(i));
            tokens.push({
                type: "NAME",
                index: i,
                value: name
            });
            i = j;
            continue;
        }
        if (char === "(") {
            var count = 1;
            var pattern = "";
            var j = i + 1;
            if (str[j] === "?") throw new TypeError('Pattern cannot start with "?" at '.concat(j));
            while(j < str.length){
                if (str[j] === "\\") {
                    pattern += str[j++] + str[j++];
                    continue;
                }
                if (str[j] === ")") {
                    count--;
                    if (count === 0) {
                        j++;
                        break;
                    }
                } else if (str[j] === "(") {
                    count++;
                    if (str[j + 1] !== "?") throw new TypeError("Capturing groups are not allowed at ".concat(j));
                }
                pattern += str[j++];
            }
            if (count) throw new TypeError("Unbalanced pattern at ".concat(i));
            if (!pattern) throw new TypeError("Missing pattern at ".concat(i));
            tokens.push({
                type: "PATTERN",
                index: i,
                value: pattern
            });
            i = j;
            continue;
        }
        tokens.push({
            type: "CHAR",
            index: i,
            value: str[i++]
        });
    }
    tokens.push({
        type: "END",
        index: i,
        value: ""
    });
    return tokens;
}
function $9a68e512a3ff5e52$export$98e6a39c04603d36(str, options) {
    if (options === void 0) options = {};
    var tokens = $9a68e512a3ff5e52$var$lexer(str);
    var _a = options.prefixes, prefixes = _a === void 0 ? "./" : _a;
    var defaultPattern = "[^".concat($9a68e512a3ff5e52$var$escapeString(options.delimiter || "/#?"), "]+?");
    var result = [];
    var key = 0;
    var i = 0;
    var path = "";
    var tryConsume = function(type) {
        if (i < tokens.length && tokens[i].type === type) return tokens[i++].value;
    };
    var mustConsume = function(type) {
        var value = tryConsume(type);
        if (value !== undefined) return value;
        var _a = tokens[i], nextType = _a.type, index = _a.index;
        throw new TypeError("Unexpected ".concat(nextType, " at ").concat(index, ", expected ").concat(type));
    };
    var consumeText = function() {
        var result = "";
        var value;
        while(value = tryConsume("CHAR") || tryConsume("ESCAPED_CHAR"))result += value;
        return result;
    };
    while(i < tokens.length){
        var char = tryConsume("CHAR");
        var name = tryConsume("NAME");
        var pattern = tryConsume("PATTERN");
        if (name || pattern) {
            var prefix = char || "";
            if (prefixes.indexOf(prefix) === -1) {
                path += prefix;
                prefix = "";
            }
            if (path) {
                result.push(path);
                path = "";
            }
            result.push({
                name: name || key++,
                prefix: prefix,
                suffix: "",
                pattern: pattern || defaultPattern,
                modifier: tryConsume("MODIFIER") || ""
            });
            continue;
        }
        var value = char || tryConsume("ESCAPED_CHAR");
        if (value) {
            path += value;
            continue;
        }
        if (path) {
            result.push(path);
            path = "";
        }
        var open = tryConsume("OPEN");
        if (open) {
            var prefix = consumeText();
            var name_1 = tryConsume("NAME") || "";
            var pattern_1 = tryConsume("PATTERN") || "";
            var suffix = consumeText();
            mustConsume("CLOSE");
            result.push({
                name: name_1 || (pattern_1 ? key++ : ""),
                pattern: name_1 && !pattern_1 ? defaultPattern : pattern_1,
                prefix: prefix,
                suffix: suffix,
                modifier: tryConsume("MODIFIER") || ""
            });
            continue;
        }
        mustConsume("END");
    }
    return result;
}
function $9a68e512a3ff5e52$export$ef7acd7185315e22(str, options) {
    return $9a68e512a3ff5e52$export$5b9bad9e403cf3d9($9a68e512a3ff5e52$export$98e6a39c04603d36(str, options), options);
}
function $9a68e512a3ff5e52$export$5b9bad9e403cf3d9(tokens, options) {
    if (options === void 0) options = {};
    var reFlags = $9a68e512a3ff5e52$var$flags(options);
    var _a = options.encode, encode = _a === void 0 ? function(x) {
        return x;
    } : _a, _b = options.validate, validate = _b === void 0 ? true : _b;
    // Compile all the tokens into regexps.
    var matches = tokens.map(function(token) {
        if (typeof token === "object") return new RegExp("^(?:".concat(token.pattern, ")$"), reFlags);
    });
    return function(data) {
        var path = "";
        for(var i = 0; i < tokens.length; i++){
            var token = tokens[i];
            if (typeof token === "string") {
                path += token;
                continue;
            }
            var value = data ? data[token.name] : undefined;
            var optional = token.modifier === "?" || token.modifier === "*";
            var repeat = token.modifier === "*" || token.modifier === "+";
            if (Array.isArray(value)) {
                if (!repeat) throw new TypeError('Expected "'.concat(token.name, '" to not repeat, but got an array'));
                if (value.length === 0) {
                    if (optional) continue;
                    throw new TypeError('Expected "'.concat(token.name, '" to not be empty'));
                }
                for(var j = 0; j < value.length; j++){
                    var segment = encode(value[j], token);
                    if (validate && !matches[i].test(segment)) throw new TypeError('Expected all "'.concat(token.name, '" to match "').concat(token.pattern, '", but got "').concat(segment, '"'));
                    path += token.prefix + segment + token.suffix;
                }
                continue;
            }
            if (typeof value === "string" || typeof value === "number") {
                var segment = encode(String(value), token);
                if (validate && !matches[i].test(segment)) throw new TypeError('Expected "'.concat(token.name, '" to match "').concat(token.pattern, '", but got "').concat(segment, '"'));
                path += token.prefix + segment + token.suffix;
                continue;
            }
            if (optional) continue;
            var typeOfMessage = repeat ? "an array" : "a string";
            throw new TypeError('Expected "'.concat(token.name, '" to be ').concat(typeOfMessage));
        }
        return path;
    };
}
function $9a68e512a3ff5e52$export$4659b591c19bdf3d(str, options) {
    var keys = [];
    var re = $9a68e512a3ff5e52$export$71304158c7e35877(str, keys, options);
    return $9a68e512a3ff5e52$export$968e97c88708237a(re, keys, options);
}
function $9a68e512a3ff5e52$export$968e97c88708237a(re, keys, options) {
    if (options === void 0) options = {};
    var _a = options.decode, decode = _a === void 0 ? function(x) {
        return x;
    } : _a;
    return function(pathname) {
        var m = re.exec(pathname);
        if (!m) return false;
        var path = m[0], index = m.index;
        var params = Object.create(null);
        var _loop_1 = function(i) {
            if (m[i] === undefined) return "continue";
            var key = keys[i - 1];
            if (key.modifier === "*" || key.modifier === "+") params[key.name] = m[i].split(key.prefix + key.suffix).map(function(value) {
                return decode(value, key);
            });
            else params[key.name] = decode(m[i], key);
        };
        for(var i = 1; i < m.length; i++)_loop_1(i);
        return {
            path: path,
            index: index,
            params: params
        };
    };
}
/**
 * Escape a regular expression string.
 */ function $9a68e512a3ff5e52$var$escapeString(str) {
    return str.replace(/([.+*?=^!:${}()[\]|/\\])/g, "\\$1");
}
/**
 * Get the flags for a regexp from the options.
 */ function $9a68e512a3ff5e52$var$flags(options) {
    return options && options.sensitive ? "" : "i";
}
/**
 * Pull out keys from a regexp.
 */ function $9a68e512a3ff5e52$var$regexpToRegexp(path, keys) {
    if (!keys) return path;
    var groupsRegex = /\((?:\?<(.*?)>)?(?!\?)/g;
    var index = 0;
    var execResult = groupsRegex.exec(path.source);
    while(execResult){
        keys.push({
            // Use parenthesized substring match if available, index otherwise
            name: execResult[1] || index++,
            prefix: "",
            suffix: "",
            modifier: "",
            pattern: ""
        });
        execResult = groupsRegex.exec(path.source);
    }
    return path;
}
/**
 * Transform an array into a regexp.
 */ function $9a68e512a3ff5e52$var$arrayToRegexp(paths, keys, options) {
    var parts = paths.map(function(path) {
        return $9a68e512a3ff5e52$export$71304158c7e35877(path, keys, options).source;
    });
    return new RegExp("(?:".concat(parts.join("|"), ")"), $9a68e512a3ff5e52$var$flags(options));
}
/**
 * Create a path regexp from string input.
 */ function $9a68e512a3ff5e52$var$stringToRegexp(path, keys, options) {
    return $9a68e512a3ff5e52$export$9a9303716def6456($9a68e512a3ff5e52$export$98e6a39c04603d36(path, options), keys, options);
}
function $9a68e512a3ff5e52$export$9a9303716def6456(tokens, keys, options) {
    if (options === void 0) options = {};
    var _a = options.strict, strict = _a === void 0 ? false : _a, _b = options.start, start = _b === void 0 ? true : _b, _c = options.end, end = _c === void 0 ? true : _c, _d = options.encode, encode = _d === void 0 ? function(x) {
        return x;
    } : _d, _e = options.delimiter, delimiter = _e === void 0 ? "/#?" : _e, _f = options.endsWith, endsWith = _f === void 0 ? "" : _f;
    var endsWithRe = "[".concat($9a68e512a3ff5e52$var$escapeString(endsWith), "]|$");
    var delimiterRe = "[".concat($9a68e512a3ff5e52$var$escapeString(delimiter), "]");
    var route = start ? "^" : "";
    // Iterate over the tokens and create our regexp string.
    for(var _i = 0, tokens_1 = tokens; _i < tokens_1.length; _i++){
        var token = tokens_1[_i];
        if (typeof token === "string") route += $9a68e512a3ff5e52$var$escapeString(encode(token));
        else {
            var prefix = $9a68e512a3ff5e52$var$escapeString(encode(token.prefix));
            var suffix = $9a68e512a3ff5e52$var$escapeString(encode(token.suffix));
            if (token.pattern) {
                if (keys) keys.push(token);
                if (prefix || suffix) {
                    if (token.modifier === "+" || token.modifier === "*") {
                        var mod = token.modifier === "*" ? "?" : "";
                        route += "(?:".concat(prefix, "((?:").concat(token.pattern, ")(?:").concat(suffix).concat(prefix, "(?:").concat(token.pattern, "))*)").concat(suffix, ")").concat(mod);
                    } else route += "(?:".concat(prefix, "(").concat(token.pattern, ")").concat(suffix, ")").concat(token.modifier);
                } else if (token.modifier === "+" || token.modifier === "*") route += "((?:".concat(token.pattern, ")").concat(token.modifier, ")");
                else route += "(".concat(token.pattern, ")").concat(token.modifier);
            } else route += "(?:".concat(prefix).concat(suffix, ")").concat(token.modifier);
        }
    }
    if (end) {
        if (!strict) route += "".concat(delimiterRe, "?");
        route += !options.endsWith ? "$" : "(?=".concat(endsWithRe, ")");
    } else {
        var endToken = tokens[tokens.length - 1];
        var isEndDelimited = typeof endToken === "string" ? delimiterRe.indexOf(endToken[endToken.length - 1]) > -1 : endToken === undefined;
        if (!strict) route += "(?:".concat(delimiterRe, "(?=").concat(endsWithRe, "))?");
        if (!isEndDelimited) route += "(?=".concat(delimiterRe, "|").concat(endsWithRe, ")");
    }
    return new RegExp(route, $9a68e512a3ff5e52$var$flags(options));
}
function $9a68e512a3ff5e52$export$71304158c7e35877(path, keys, options) {
    if (path instanceof RegExp) return $9a68e512a3ff5e52$var$regexpToRegexp(path, keys);
    if (Array.isArray(path)) return $9a68e512a3ff5e52$var$arrayToRegexp(path, keys, options);
    return $9a68e512a3ff5e52$var$stringToRegexp(path, keys, options);
}



var $acw62 = parcelRequire("acw62");
/**
 * Loads something from storage and runs it thru JSON.parse.
 *
 * @param key The key to fetch.
 */ function $34dcbefa7de5eb80$export$11e63f7b0f3d9900(key) {
    try {
        const almostThere = localStorage.getItem(key);
        return JSON.parse(almostThere ?? "");
    } catch  {
        return null;
    }
}
function $34dcbefa7de5eb80$export$a1544dad697b423d(key, value) {
    try {
        localStorage.setItem(key, JSON.stringify(value));
        return true;
    } catch  {
        return false;
    }
}
function $34dcbefa7de5eb80$export$cd7f480d6b8286c3(key) {
    try {
        localStorage.removeItem(key);
    } catch (err) {
        console.error(err);
    }
}
function $34dcbefa7de5eb80$export$42ffd38884aecdac() {
    try {
        localStorage.clear();
    } catch (err) {
        console.error(err);
    }
}



var $bsQZT = parcelRequire("bsQZT");
const $73ccb33f5de6f5aa$export$bcd432401d75348c = "uae";
const $73ccb33f5de6f5aa$export$8cee2ea722248f16 = "gr";
const $73ccb33f5de6f5aa$export$811bdaadc05cb990 = "sa";
const $73ccb33f5de6f5aa$export$449b009f68cc9554 = "en";
const $73ccb33f5de6f5aa$export$3297dfed24c77062 = [
    $73ccb33f5de6f5aa$export$bcd432401d75348c,
    $73ccb33f5de6f5aa$export$8cee2ea722248f16,
    $73ccb33f5de6f5aa$export$811bdaadc05cb990
];
const $73ccb33f5de6f5aa$export$6edc700f7fbcc994 = "ae";
const $73ccb33f5de6f5aa$export$58a015662fd42aad = "gr";
const $73ccb33f5de6f5aa$export$7216bf63c07650e2 = "sa";
const $73ccb33f5de6f5aa$export$5ee3c680189caa8f = {
    [$73ccb33f5de6f5aa$export$bcd432401d75348c]: $73ccb33f5de6f5aa$export$6edc700f7fbcc994,
    [$73ccb33f5de6f5aa$export$8cee2ea722248f16]: $73ccb33f5de6f5aa$export$58a015662fd42aad,
    [$73ccb33f5de6f5aa$export$811bdaadc05cb990]: $73ccb33f5de6f5aa$export$7216bf63c07650e2
};
class $73ccb33f5de6f5aa$var$MarketService {
    getCurrentMarketCode() {
        const availableMarkets = $73ccb33f5de6f5aa$export$3297dfed24c77062.join("|");
        const regExp = new RegExp(`/(${availableMarkets})(/{0,1}.*)`);
        const marketMatch = window.location.pathname.match(regExp);
        if (Boolean(marketMatch)) {
            (0, $34dcbefa7de5eb80$export$a1544dad697b423d)("marketId", marketMatch?.[1]);
            return marketMatch?.[1];
        }
        const marketId = (0, $34dcbefa7de5eb80$export$11e63f7b0f3d9900)("marketId");
        if (!marketId) (0, $34dcbefa7de5eb80$export$a1544dad697b423d)("marketId", $73ccb33f5de6f5aa$export$bcd432401d75348c);
        window.location.href = `/${marketId}${window.location.pathname}${window.location.search}`;
        return null;
    }
    getCurrentLanguage() {
        if (this.language === null) this.language = (0, $34dcbefa7de5eb80$export$11e63f7b0f3d9900)("userLanguage");
        return this.language;
    }
    constructor(){
        this.language = null;
    }
}
const $73ccb33f5de6f5aa$export$daa49e131b652e5b = new $73ccb33f5de6f5aa$var$MarketService();
const $73ccb33f5de6f5aa$export$b1e18f6e4a77eef2 = {
    [$73ccb33f5de6f5aa$export$bcd432401d75348c]: {
        iso2Code: $73ccb33f5de6f5aa$export$6edc700f7fbcc994,
        centerCoordinatesOnMap: {
            lat: 24,
            lng: 53.8478
        },
        currency: "AED",
        launched: true,
        stripePublishedKey: (0, $bsQZT.config).STRIPE_PUBLISHABLE_KEY_UAE,
        registration: {
            allowOnlyCorporate: false,
            requireConsentAcceptance: false,
            requiredCorporateFields: [
                "company_name",
                "address",
                "po_box",
                "is_lpo_required",
                "trade_name"
            ]
        },
        order: {
            nonExperiencedTitle: "job_draft_details.experience_student",
            includePublicTransportationField: true,
            includeGenderField: true,
            includeNationalityField: true
        },
        finance: {
            showInvoices: true
        },
        applicantReview: {
            includeNationality: true,
            includeHeight: true
        },
        firstDayOfWeek: "Mon"
    },
    [$73ccb33f5de6f5aa$export$8cee2ea722248f16]: {
        iso2Code: $73ccb33f5de6f5aa$export$58a015662fd42aad,
        centerCoordinatesOnMap: {
            lat: 39.0988,
            lng: 21.838
        },
        currency: "EUR",
        launched: true,
        stripePublishedKey: (0, $bsQZT.config).STRIPE_PUBLISHABLE_KEY_GR,
        registration: {
            allowOnlyCorporate: true,
            requireConsentAcceptance: true,
            requiredCorporateFields: [
                "company_name",
                "industry",
                "address",
                "po_box",
                "license_number",
                "free_zone",
                "region",
                "vat"
            ]
        },
        order: {
            nonExperiencedTitle: "job_draft_details.experience_beginner",
            includePublicTransportationField: false,
            includeGenderField: false,
            includeNationalityField: false
        },
        finance: {
            showInvoices: false
        },
        applicantReview: {
            includeNationality: false,
            includeHeight: false
        },
        firstDayOfWeek: "Mon"
    },
    [$73ccb33f5de6f5aa$export$811bdaadc05cb990]: {
        iso2Code: $73ccb33f5de6f5aa$export$7216bf63c07650e2,
        centerCoordinatesOnMap: {
            lat: 25.16919,
            lng: 46.77095
        },
        currency: "SAR",
        launched: true,
        stripePublishedKey: (0, $bsQZT.config).STRIPE_PUBLISHABLE_KEY_UAE,
        registration: {
            allowOnlyCorporate: true,
            requireConsentAcceptance: false,
            requiredCorporateFields: [
                "company_name",
                "address",
                "po_box",
                "is_lpo_required",
                "trade_name"
            ]
        },
        order: {
            nonExperiencedTitle: "job_draft_details.experience_student",
            includePublicTransportationField: true,
            includeGenderField: true,
            includeNationalityField: true
        },
        finance: {
            showInvoices: true
        },
        applicantReview: {
            includeNationality: true,
            includeHeight: true
        },
        firstDayOfWeek: "Sun"
    }
};
const $73ccb33f5de6f5aa$export$8707029d024490c9 = ()=>{
    return $73ccb33f5de6f5aa$export$b1e18f6e4a77eef2[$73ccb33f5de6f5aa$export$daa49e131b652e5b.getCurrentMarketCode() ?? $73ccb33f5de6f5aa$export$bcd432401d75348c];
};
const $73ccb33f5de6f5aa$export$1d82b0dbb491a5f4 = ()=>{
    const market = $73ccb33f5de6f5aa$export$daa49e131b652e5b.getCurrentMarketCode();
    return $73ccb33f5de6f5aa$export$b1e18f6e4a77eef2[market ?? $73ccb33f5de6f5aa$export$bcd432401d75348c].launched;
};




var $c74a0566d4b0fd6d$export$5e27155e276f6d1c;
(function(TrackedEvent) {
    TrackedEvent["LeanPaymentMethodChosen"] = "Lean Payment Method Chosen";
    TrackedEvent["LeanPaymentPaid"] = "Lean Payment Paid";
    TrackedEvent["LeanPaymentAuthorizationInitiated"] = "Lean Payment Authorization Initiated";
    TrackedEvent["ViewedPaymentCompleted"] = "Viewed Payment Completed";
    TrackedEvent["ViewedNotSubmittedOrderSummary"] = "Viewed Not Submitted Order Summary";
    TrackedEvent["ViewedSubmittedOrderSummary"] = "Viewed Submitted Order Summary";
    TrackedEvent["ViewedConfirmOrderSummary"] = "Viewed Confirm Order Summary";
    TrackedEvent["ViewedInstallProgressiveAppBanner"] = "Viewed Install Progressive App Banner";
    TrackedEvent["AppInstalledAsProgressive"] = "App Installed As Progressive";
    TrackedEvent["ChiefCongratulationsPopupShown"] = "Chief Congratulations Popup Shown";
    TrackedEvent["RatingSet"] = "RatingSet";
    TrackedEvent["FavoriteAdded"] = "FavoriteAdded";
    TrackedEvent["FavoriteRemoved"] = "FavoriteRemoved";
    TrackedEvent["PastWorkersPageOpened"] = "PastWorkersPageOpened";
    TrackedEvent["PastWorkersListFiltersApplied"] = "PastWorkersListFiltersApplied";
    TrackedEvent["PastWorkersListPaginationUsed"] = "PastWorkersListPaginationUsed";
    TrackedEvent["PastWorkersListSortUsed"] = "PastWorkersListSortUsed";
    TrackedEvent["PastWorkersProfileOpened"] = "PastWorkersProfileOpened";
    TrackedEvent["PreferredWorkerAddedToOrder"] = "PreferredWorkerAddedToOrder";
    TrackedEvent["PreferredWorkerRemovedFromOrder"] = "PreferredWorkerRemovedFromOrder";
    TrackedEvent["PreferredWorkerSearchStarted"] = "PreferredWorkerSearchStarted";
    TrackedEvent["PreferredWorkerScrolled"] = "PreferredWorkerScrolled";
    TrackedEvent["PreferredWorkerTriedToAddMoreThanPossible"] = "PreferredWorkerTriedToAddMoreThanPossible";
    TrackedEvent["ExtendedOrderFromOrdersList"] = "ExtendedOrderFromOrdersList";
    TrackedEvent["ExtendedOrderFromOrderDetails"] = "ExtendedOrderFromOrderDetails";
    TrackedEvent["ExtendedOrderFromAllJobs"] = "ExtendedOrderFromAllJobs";
    TrackedEvent["RatingPopupAfterAttendanceReviewShown"] = "RatingPopupAfterAttendanceReviewShown";
    TrackedEvent["RatingSetAfterAttendanceReview"] = "RatingSetAfterAttendanceReview";
    TrackedEvent["RatingSetAfterAttendanceReviewAtLeastOnce"] = "RatingSetAfterAttendanceReviewAtLeastOnce";
    TrackedEvent["RatingSetAfterAttendanceReviewForAllOGs"] = "RatingSetAfterAttendanceReviewForAllOGs";
    TrackedEvent["RatingSetFromRatingsList"] = "RatingSetFromRatingsList";
    TrackedEvent["RatingSetFromPastWorkers"] = "RatingSetFromPastWorkers";
    TrackedEvent["HiringJobWasPrefilled"] = "HiringJobWasPrefilled";
    TrackedEvent["HiringPrefilledJobWasCleared"] = "HiringPrefilledJobWasCleared";
    TrackedEvent["TimesheetWeekBackClicked"] = "TimesheetWeekBackClicked";
    TrackedEvent["TimesheetWeekForwardClicked"] = "TimesheetWeekForwardClicked";
    TrackedEvent["TimesheetLocationFilterUsed"] = "TimesheetLocationFilterUsed";
    TrackedEvent["TimesheetDesignationFilterUsed"] = "TimesheetDesignationFilterUsed";
    TrackedEvent["TimesheetStartTimeBulkChanged"] = "TimesheetStartTimeBulkChanged";
    TrackedEvent["TimesheetEndTimeBulkChanged"] = "TimesheetEndTimeBulkChanged";
    TrackedEvent["TimesheetSPStartTimeChanged"] = "TimesheetSPStartTimeChanged";
    TrackedEvent["TimesheetSPEndTimeChanged"] = "TimesheetSPEndTimeChanged";
    TrackedEvent["TimesheetSlotOptionsViewed"] = "TimesheetSlotOptionsViewed";
    TrackedEvent["TimesheetCancelClicked"] = "TimesheetCancelClicked";
    TrackedEvent["TimesheetSaveClicked"] = "TimesheetSaveClicked";
    TrackedEvent["TimesheetSlotOptionCheckInClicked"] = "TimesheetSlotOptionCheckInClicked";
    TrackedEvent["TimesheetSlotOptionCheckOutClicked"] = "TimesheetSlotOptionCheckOutClicked";
    TrackedEvent["TimesheetSlotOptionExtendShiftClicked"] = "TimesheetSlotOptionExtendShiftClicked";
    TrackedEvent["TimesheetSlotOptionCancelClicked"] = "TimesheetSlotOptionCancelClicked";
    TrackedEvent["TimesheetSlotOptionPhoneClicked"] = "TimesheetSlotOptionPhoneClicked";
    TrackedEvent["TimesheetSlotOptionWhatsappClicked"] = "TimesheetSlotOptionWhatsappClicked";
    TrackedEvent["TimesheetSlotEmptySlotClicked"] = "TimesheetSlotEmptySlotClicked";
    TrackedEvent["TimesheetSlotOptionSPSelectClicked"] = "TimesheetSlotOptionSPSelectClicked";
    TrackedEvent["TimesheetCancellationAllShiftsSelected"] = "TimesheetCancellationAllShiftsSelected";
    TrackedEvent["TimesheetCancellationConfirmed"] = "TimesheetCancellationConfirmed";
    TrackedEvent["TimesheetCancellationCancelled"] = "TimesheetCancellationCancelled";
    TrackedEvent["TimesheetStatusLabelClicked"] = "TimesheetStatusLabelClicked";
    TrackedEvent["TimesheetMonthTitleClicked"] = "TimesheetMonthTitleClicked";
    TrackedEvent["TimesheetCurrentWeekClicked"] = "TimesheetCurrentWeekClicked";
    TrackedEvent["TimesheetCalendarSwitcherOpened"] = "TimesheetCalendarSwitcherOpened";
    TrackedEvent["TimesheetWeekSwitchedViaCalendar"] = "TimesheetWeekSwitchedViaCalendar";
    TrackedEvent["TimesheetDateTitleClicked"] = "TimesheetDateTitleClicked";
    TrackedEvent["TimesheetRowExpanded"] = "TimesheetRowExpanded";
    TrackedEvent["TimesheetOrder3DotsClicked"] = "TimesheetOrder3DotsClicked";
    TrackedEvent["TimesheetSPProfileClicked"] = "TimesheetSPProfileClicked";
    TrackedEvent["HomeCarouselHireNowClicked"] = "HomeCarouselHireNowClicked";
    TrackedEvent["HomeCarouselRegisterCorporateClicked"] = "HomeCarouselRegisterCorporateClicked";
    TrackedEvent["HomeCarouselInviteStaffStartClicked"] = "HomeCarouselInviteStaffStartClicked";
    TrackedEvent["HomeCarouselInviteStaffDismissClicked"] = "HomeCarouselInviteStaffDismissClicked";
    TrackedEvent["HomeStatsPendingPaymentsClicked"] = "HomeStatsPendingPaymentsClicked";
    TrackedEvent["HomeStatsShiftsAttendanceClicked"] = "HomeStatsShiftsAttendanceClicked";
    TrackedEvent["HomeStatsOrdersToConfirmClicked"] = "HomeStatsOrdersToConfirmClicked";
    TrackedEvent["HomeStatsRatingsClicked"] = "HomeStatsRatingsClicked";
    TrackedEvent["HomeStatsApplicantsClicked"] = "HomeStatsApplicantsClicked";
    TrackedEvent["StickyPanelPendingPaymentsShown"] = "StickyPanelPendingPaymentsShown";
    TrackedEvent["StickyPanelPendingPaymentsClicked"] = "StickyPanelPendingPaymentsClicked";
    TrackedEvent["StickyPanelPendingOrdersShown"] = "StickyPanelPendingOrdersShown";
    TrackedEvent["StickyPanelPendingOrdersClicked"] = "StickyPanelPendingOrdersClicked";
    TrackedEvent["StickyPanelPendingAttendanceShown"] = "StickyPanelPendingAttendanceShown";
    TrackedEvent["StickyPanelPendingAttendanceClicked"] = "StickyPanelPendingAttendanceClicked";
    TrackedEvent["StickyPanelPendingRatingsShown"] = "StickyPanelPendingRatingsShown";
    TrackedEvent["StickyPanelPendingRatingsClicked"] = "StickyPanelPendingRatingsClicked";
    TrackedEvent["StickyPanelRaisedDisputesShown"] = "StickyPanelRaisedDisputesShown";
    TrackedEvent["StickyPanelRaisedDisputesClicked"] = "StickyPanelRaisedDisputesClicked";
    TrackedEvent["OrderFormSawNationalityOption"] = "OrderFormSeenNationalityOption";
    TrackedEvent["OrderFormToggledOnNationalityOption"] = "OrderFormToggledOnNationalityOption";
    TrackedEvent["OrderFormNationalityAllowedAll"] = "OrderFormNationalityAllowedAll";
})($c74a0566d4b0fd6d$export$5e27155e276f6d1c || ($c74a0566d4b0fd6d$export$5e27155e276f6d1c = {}));
var $c74a0566d4b0fd6d$export$4690203fd259f070;
(function(Conversion) {
    Conversion["SignInClicked"] = "AW-764793267/JjZKCNGOwcwYELOj1-wC";
    Conversion["SignUpClicked"] = "AW-764793267/Axi5CN2hgM4YELOj1-wC";
})($c74a0566d4b0fd6d$export$4690203fd259f070 || ($c74a0566d4b0fd6d$export$4690203fd259f070 = {}));
class $c74a0566d4b0fd6d$var$TrackingService {
    constructor(){
        this.email = null;
        this.identifyUser = (userId)=>{
            (0, $0d15f034d14801d0$export$7f5abdb7f5093137)((0, $0d15f034d14801d0$export$b0297573c90085aa)(), String(userId));
        };
        this.assignUserProperties = (clientId, roles, email)=>{
            (0, $0d15f034d14801d0$export$d0e176862bf869b8)((0, $0d15f034d14801d0$export$b0297573c90085aa)(), {
                clientId: String(clientId),
                roles: roles.join(","),
                mainRole: String(roles[0]),
                market: String((0, $73ccb33f5de6f5aa$export$daa49e131b652e5b).getCurrentMarketCode())
            });
            this.email = email;
        };
        this.resetUser = ()=>{
            (0, $0d15f034d14801d0$export$7f5abdb7f5093137)((0, $0d15f034d14801d0$export$b0297573c90085aa)(), "");
        };
        this.track = (event, properties)=>{
            if (this.email?.endsWith("@ogram.co")) return;
            (0, $0d15f034d14801d0$export$5e9eec8001665ac5)((0, $0d15f034d14801d0$export$b0297573c90085aa)(), event, properties);
        };
        this.conversion = (event)=>{
            if ("gtag" in window) window.gtag("event", "conversion", {
                "send_to": event,
                "event_callback": ()=>{}
            });
        };
        this.metaConversion = (type, event, payload)=>{
            if ("fbq" in window) window.fbq(type, event, payload);
        };
    }
}
const $c74a0566d4b0fd6d$export$e9db7d6e73593439 = new $c74a0566d4b0fd6d$var$TrackingService();


function $7df35e9df335b1c8$export$544c268deaca2597(path) {
    const prefix = (0, $73ccb33f5de6f5aa$export$daa49e131b652e5b).getCurrentMarketCode();
    if (!!prefix) path = `/${prefix}${path}`;
    const keys = [];
    const tokens = (0, $9a68e512a3ff5e52$export$98e6a39c04603d36)(path);
    const re = (0, $9a68e512a3ff5e52$export$9a9303716def6456)(tokens, keys);
    const _match = (0, $9a68e512a3ff5e52$export$968e97c88708237a)(re, keys, {
        decode: decodeURIComponent
    });
    const _toUrl = (0, $9a68e512a3ff5e52$export$5b9bad9e403cf3d9)(tokens, {
        encode: encodeURIComponent
    });
    const requiredFields = new Set(tokens.map((token)=>typeof token !== "string" ? String(token.name) : undefined).filter((t)=>t !== undefined));
    const matchUrl = (url)=>{
        const m = _match(url.path);
        if (m === false) return null;
        const params = m.params;
        url.query.split("&").forEach((p)=>{
            const r = p.split("=");
            const key = decodeURIComponent(r[0]);
            const val = decodeURIComponent(r[1]);
            if (!(key in params)) params[key] = val;
        });
        return params;
    };
    const testUrl = (urlPath)=>{
        return _match(urlPath) !== false;
    };
    const toUrl = (params)=>{
        let query = "";
        const keyParams = Object.keys(params);
        keyParams.forEach((key, index)=>{
            if (!requiredFields.has(key)) {
                query += `${encodeURIComponent(key)}=${encodeURIComponent(params[key])}`;
                if (index !== keyParams.length - 1) query += "&";
            }
        });
        return _toUrl(params) + (query === "" ? "" : `?${query}`);
    };
    return {
        path: path,
        matchUrl: matchUrl,
        testUrl: testUrl,
        toUrl: toUrl
    };
}
const $7df35e9df335b1c8$export$e21aa10ba666c75b = /*#__PURE__*/ (0, $acw62.createContext)(null);
const $7df35e9df335b1c8$var$createUrl = ()=>({
        path: window.location.pathname,
        query: window.location.search.substr(1),
        state: window.history.state
    });
const $7df35e9df335b1c8$export$55185c17a0fcbe46 = /*#__PURE__*/ (0, $acw62.memo)(function Router(props) {
    const { children: children, initialUrl: initialUrl, onBeforeNextUrl: onBeforeNextUrl, onAfterNextUrl: onAfterNextUrl, onBackForward: onBackForward, scrollRestoration: scrollRestoration = true } = props;
    const defaultUrl = ()=>{
        if (initialUrl === undefined) return $7df35e9df335b1c8$var$createUrl();
        const p = initialUrl.split("?");
        return {
            path: p[0],
            query: p[1] || "",
            state: undefined
        };
    };
    const [url, setUrl] = (0, $acw62.useState)(defaultUrl);
    const [fromBackForward, setBackForwardState] = (0, $acw62.useState)(false);
    const change = (type)=>(url)=>{
            if (typeof window === "object") {
                const state = onBeforeNextUrl && onBeforeNextUrl(url);
                window.history[type](state, "", url);
                onAfterNextUrl && onAfterNextUrl(url);
                setUrl($7df35e9df335b1c8$var$createUrl());
                setBackForwardState(false);
            }
        };
    const router = {
        push: change("pushState"),
        replace: change("replaceState"),
        url: url
    };
    (0, $acw62.useEffect)(()=>{
        if (scrollRestoration) window.history.scrollRestoration = "auto";
        const fn = ()=>{
            onBackForward && onBackForward(window.location.href);
            setUrl($7df35e9df335b1c8$var$createUrl());
            setBackForwardState(true);
        };
        window.addEventListener("popstate", fn);
        return ()=>window.removeEventListener("popstate", fn);
    }, []);
    (0, $acw62.useLayoutEffect)(()=>{
        if (!fromBackForward && scrollRestoration) window.scrollTo(0, 0);
    }, [
        fromBackForward,
        scrollRestoration
    ]);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($7df35e9df335b1c8$export$e21aa10ba666c75b.Provider, {
        value: router,
        children: children
    });
});
function $7df35e9df335b1c8$export$e7b0ac011bb776c6(props) {
    const { children: children, route: route } = props;
    const router = (0, $acw62.useContext)($7df35e9df335b1c8$export$e21aa10ba666c75b);
    if (typeof children === "function") {
        const res = route.matchUrl(router.url);
        if (res !== null) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7b02d682eb115277$exports.Fragment), {
            children: children(res)
        });
        return null;
    }
    if (route.testUrl(router.url.path)) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7b02d682eb115277$exports.Fragment), {
        children: children
    });
    return null;
}
function $7df35e9df335b1c8$export$a6c7ac8248d6e38a(props) {
    const { children: children, params: params, route: route } = props;
    const router = (0, $acw62.useContext)($7df35e9df335b1c8$export$e21aa10ba666c75b);
    const url = route.toUrl(params);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("a", {
        href: url,
        className: props.className,
        onClick: (e)=>{
            props.handleClick?.(e);
            if (!e.ctrlKey && !e.metaKey) {
                e.preventDefault();
                (0, $c74a0566d4b0fd6d$export$e9db7d6e73593439).track("page_view", {
                    page_location: url
                });
                return router.push(url);
            }
        },
        children: children
    });
}
function $7df35e9df335b1c8$export$602eaf6d5314ce55() {
    const router = (0, $acw62.useContext)($7df35e9df335b1c8$export$e21aa10ba666c75b);
    return (route, params)=>{
        const url = route.toUrl(params);
        (0, $c74a0566d4b0fd6d$export$e9db7d6e73593439).track("page_view", {
            page_location: url
        });
        router.push(url);
    };
}
function $7df35e9df335b1c8$export$e8c52816aa4ad75a() {
    const router = (0, $acw62.useContext)($7df35e9df335b1c8$export$e21aa10ba666c75b);
    const currentMarketCode = (0, $73ccb33f5de6f5aa$export$daa49e131b652e5b).getCurrentMarketCode();
    if (!currentMarketCode) return router.url.path === "/";
    return router.url.path === `/${currentMarketCode}` || router.url.path === `/${currentMarketCode}/`;
}



var $b8438 = parcelRequire("b8438");
var $cmFjP = parcelRequire("cmFjP");
var $b8438 = parcelRequire("b8438");
var $cmFjP = parcelRequire("cmFjP");
var $b1E2c = parcelRequire("b1E2c");
var $4g0Ct = parcelRequire("4g0Ct");

var $8IHa9 = parcelRequire("8IHa9");

var $6T4Sa = parcelRequire("6T4Sa");

var $b8438 = parcelRequire("b8438");

var $cmFjP = parcelRequire("cmFjP");
const $51cfcbefde61ff20$export$b14a8888f80a0b3e = [];
/** Map of integrations assigned to a client */ /**
 * Remove duplicates from the given array, preferring the last instance of any duplicate. Not guaranteed to
 * preseve the order of integrations in the array.
 *
 * @private
 */ function $51cfcbefde61ff20$var$filterDuplicates(integrations) {
    const integrationsByName = {};
    integrations.forEach((currentInstance)=>{
        const { name: name } = currentInstance;
        const existingInstance = integrationsByName[name];
        // We want integrations later in the array to overwrite earlier ones of the same type, except that we never want a
        // default instance to overwrite an existing user instance
        if (existingInstance && !existingInstance.isDefaultInstance && currentInstance.isDefaultInstance) return;
        integrationsByName[name] = currentInstance;
    });
    return Object.keys(integrationsByName).map((k)=>integrationsByName[k]);
}
/** Gets integrations to install */ function $51cfcbefde61ff20$export$68bc4c01ab8ae766(options) {
    const defaultIntegrations = options.defaultIntegrations || [];
    const userIntegrations = options.integrations;
    // We flag default instances, so that later we can tell them apart from any user-created instances of the same class
    defaultIntegrations.forEach((integration)=>{
        integration.isDefaultInstance = true;
    });
    let integrations;
    if (Array.isArray(userIntegrations)) integrations = [
        ...defaultIntegrations,
        ...userIntegrations
    ];
    else if (typeof userIntegrations === "function") integrations = (0, $b1E2c.arrayify)(userIntegrations(defaultIntegrations));
    else integrations = defaultIntegrations;
    const finalIntegrations = $51cfcbefde61ff20$var$filterDuplicates(integrations);
    // The `Debug` integration prints copies of the `event` and `hint` which will be passed to `beforeSend` or
    // `beforeSendTransaction`. It therefore has to run after all other integrations, so that the changes of all event
    // processors will be reflected in the printed values. For lack of a more elegant way to guarantee that, we therefore
    // locate it and, assuming it exists, pop it out of its current spot and shove it onto the end of the array.
    const debugIndex = $51cfcbefde61ff20$var$findIndex(finalIntegrations, (integration)=>integration.name === "Debug");
    if (debugIndex !== -1) {
        const [debugInstance] = finalIntegrations.splice(debugIndex, 1);
        finalIntegrations.push(debugInstance);
    }
    return finalIntegrations;
}
/**
 * Given a list of integration instances this installs them all. When `withDefaults` is set to `true` then all default
 * integrations are added unless they were already provided before.
 * @param integrations array of integration instances
 * @param withDefault should enable default integrations
 */ function $51cfcbefde61ff20$export$51abed9797baa598(client, integrations) {
    const integrationIndex = {};
    integrations.forEach((integration)=>{
        // guard against empty provided integrations
        if (integration) $51cfcbefde61ff20$export$e7390a03b70a6f2f(client, integration, integrationIndex);
    });
    return integrationIndex;
}
/** Setup a single integration.  */ function $51cfcbefde61ff20$export$e7390a03b70a6f2f(client, integration, integrationIndex) {
    integrationIndex[integration.name] = integration;
    // `setupOnce` is only called the first time
    if ($51cfcbefde61ff20$export$b14a8888f80a0b3e.indexOf(integration.name) === -1) {
        // eslint-disable-next-line deprecation/deprecation
        integration.setupOnce((0, $6T4Sa.addGlobalEventProcessor), (0, $cmFjP.getCurrentHub));
        $51cfcbefde61ff20$export$b14a8888f80a0b3e.push(integration.name);
    }
    // `setup` is run for each client
    if (integration.setup && typeof integration.setup === "function") integration.setup(client);
    if (client.on && typeof integration.preprocessEvent === "function") {
        const callback = integration.preprocessEvent.bind(integration);
        client.on("preprocessEvent", (event, hint)=>callback(event, hint, client));
    }
    if (client.addEventProcessor && typeof integration.processEvent === "function") {
        const callback = integration.processEvent.bind(integration);
        const processor = Object.assign((event, hint)=>callback(event, hint, client), {
            id: integration.name
        });
        client.addEventProcessor(processor);
    }
    (0, $8IHa9.DEBUG_BUILD) && (0, $4g0Ct.logger).log(`Integration installed: ${integration.name}`);
}
/** Add an integration to the current hub's client. */ function $51cfcbefde61ff20$export$2d8f5188773bcddd(integration) {
    const client = (0, $b8438.getClient)();
    if (!client || !client.addIntegration) {
        (0, $8IHa9.DEBUG_BUILD) && (0, $4g0Ct.logger).warn(`Cannot add integration "${integration.name}" because no SDK Client is available.`);
        return;
    }
    client.addIntegration(integration);
}
// Polyfill for Array.findIndex(), which is not supported in ES5
function $51cfcbefde61ff20$var$findIndex(arr, callback) {
    for(let i = 0; i < arr.length; i++){
        if (callback(arr[i]) === true) return i;
    }
    return -1;
}


var $eKZKa = parcelRequire("eKZKa");

var $4g0Ct = parcelRequire("4g0Ct");
/** Regular expression used to parse a Dsn. */ const $f7133678d936cd5e$var$DSN_REGEX = /^(?:(\w+):)\/\/(?:(\w+)(?::(\w+)?)?@)([\w.-]+)(?::(\d+))?\/(.+)/;
function $f7133678d936cd5e$var$isValidProtocol(protocol) {
    return protocol === "http" || protocol === "https";
}
/**
 * Renders the string representation of this Dsn.
 *
 * By default, this will render the public representation without the password
 * component. To get the deprecated private representation, set `withPassword`
 * to true.
 *
 * @param withPassword When set to true, the password will be included.
 */ function $f7133678d936cd5e$export$44d472fbb931a776(dsn, withPassword = false) {
    const { host: host, path: path, pass: pass, port: port, projectId: projectId, protocol: protocol, publicKey: publicKey } = dsn;
    return `${protocol}://${publicKey}${withPassword && pass ? `:${pass}` : ""}` + `@${host}${port ? `:${port}` : ""}/${path ? `${path}/` : path}${projectId}`;
}
/**
 * Parses a Dsn from a given string.
 *
 * @param str A Dsn as string
 * @returns Dsn as DsnComponents or undefined if @param str is not a valid DSN string
 */ function $f7133678d936cd5e$export$b892860177f70a30(str) {
    const match = $f7133678d936cd5e$var$DSN_REGEX.exec(str);
    if (!match) {
        // This should be logged to the console
        (0, $4g0Ct.consoleSandbox)(()=>{
            // eslint-disable-next-line no-console
            console.error(`Invalid Sentry Dsn: ${str}`);
        });
        return undefined;
    }
    const [protocol, publicKey, pass = "", host, port = "", lastPath] = match.slice(1);
    let path = "";
    let projectId = lastPath;
    const split = projectId.split("/");
    if (split.length > 1) {
        path = split.slice(0, -1).join("/");
        projectId = split.pop();
    }
    if (projectId) {
        const projectMatch = projectId.match(/^\d+/);
        if (projectMatch) projectId = projectMatch[0];
    }
    return $f7133678d936cd5e$var$dsnFromComponents({
        host: host,
        pass: pass,
        path: path,
        projectId: projectId,
        port: port,
        protocol: protocol,
        publicKey: publicKey
    });
}
function $f7133678d936cd5e$var$dsnFromComponents(components) {
    return {
        protocol: components.protocol,
        publicKey: components.publicKey || "",
        pass: components.pass || "",
        host: components.host,
        port: components.port || "",
        path: components.path || "",
        projectId: components.projectId
    };
}
function $f7133678d936cd5e$var$validateDsn(dsn) {
    if (!(0, $eKZKa.DEBUG_BUILD)) return true;
    const { port: port, projectId: projectId, protocol: protocol } = dsn;
    const requiredComponents = [
        "protocol",
        "publicKey",
        "host",
        "projectId"
    ];
    const hasMissingRequiredComponent = requiredComponents.find((component)=>{
        if (!dsn[component]) {
            (0, $4g0Ct.logger).error(`Invalid Sentry Dsn: ${component} missing`);
            return true;
        }
        return false;
    });
    if (hasMissingRequiredComponent) return false;
    if (!projectId.match(/^\d+$/)) {
        (0, $4g0Ct.logger).error(`Invalid Sentry Dsn: Invalid projectId ${projectId}`);
        return false;
    }
    if (!$f7133678d936cd5e$var$isValidProtocol(protocol)) {
        (0, $4g0Ct.logger).error(`Invalid Sentry Dsn: Invalid protocol ${protocol}`);
        return false;
    }
    if (port && isNaN(parseInt(port, 10))) {
        (0, $4g0Ct.logger).error(`Invalid Sentry Dsn: Invalid port ${port}`);
        return false;
    }
    return true;
}
/**
 * Creates a valid Sentry Dsn object, identifying a Sentry instance and project.
 * @returns a valid DsnComponents object or `undefined` if @param from is an invalid DSN source
 */ function $f7133678d936cd5e$export$128827c3562ec0cb(from) {
    const components = typeof from === "string" ? $f7133678d936cd5e$export$b892860177f70a30(from) : $f7133678d936cd5e$var$dsnFromComponents(from);
    if (!components || !$f7133678d936cd5e$var$validateDsn(components)) return undefined;
    return components;
}


var $jL8lq = parcelRequire("jL8lq");
const $d91612272370ed71$var$SENTRY_API_VERSION = "7";
/** Returns the prefix to construct Sentry ingestion API endpoints. */ function $d91612272370ed71$var$getBaseApiEndpoint(dsn) {
    const protocol = dsn.protocol ? `${dsn.protocol}:` : "";
    const port = dsn.port ? `:${dsn.port}` : "";
    return `${protocol}//${dsn.host}${port}${dsn.path ? `/${dsn.path}` : ""}/api/`;
}
/** Returns the ingest API endpoint for target. */ function $d91612272370ed71$var$_getIngestEndpoint(dsn) {
    return `${$d91612272370ed71$var$getBaseApiEndpoint(dsn)}${dsn.projectId}/envelope/`;
}
/** Returns a URL-encoded string with auth config suitable for a query string. */ function $d91612272370ed71$var$_encodedAuth(dsn, sdkInfo) {
    return (0, $jL8lq.urlEncode)({
        // We send only the minimum set of required information. See
        // https://github.com/getsentry/sentry-javascript/issues/2572.
        sentry_key: dsn.publicKey,
        sentry_version: $d91612272370ed71$var$SENTRY_API_VERSION,
        ...sdkInfo && {
            sentry_client: `${sdkInfo.name}/${sdkInfo.version}`
        }
    });
}
/**
 * Returns the envelope endpoint URL with auth in the query string.
 *
 * Sending auth as part of the query string and not as custom HTTP headers avoids CORS preflight requests.
 */ function $d91612272370ed71$export$9964600bfe84e6a3(dsn, // TODO (v8): Remove `tunnelOrOptions` in favor of `options`, and use the substitute code below
// options: ClientOptions = {} as ClientOptions,
tunnelOrOptions = {}) {
    // TODO (v8): Use this code instead
    // const { tunnel, _metadata = {} } = options;
    // return tunnel ? tunnel : `${_getIngestEndpoint(dsn)}?${_encodedAuth(dsn, _metadata.sdk)}`;
    const tunnel = typeof tunnelOrOptions === "string" ? tunnelOrOptions : tunnelOrOptions.tunnel;
    const sdkInfo = typeof tunnelOrOptions === "string" || !tunnelOrOptions._metadata ? undefined : tunnelOrOptions._metadata.sdk;
    return tunnel ? tunnel : `${$d91612272370ed71$var$_getIngestEndpoint(dsn)}?${$d91612272370ed71$var$_encodedAuth(dsn, sdkInfo)}`;
}
/** Returns the url to the report dialog endpoint. */ function $d91612272370ed71$export$671c7ed8e40a7a57(dsnLike, dialogOptions) {
    const dsn = (0, $f7133678d936cd5e$export$128827c3562ec0cb)(dsnLike);
    if (!dsn) return "";
    const endpoint = `${$d91612272370ed71$var$getBaseApiEndpoint(dsn)}embed/error-page/`;
    let encodedOptions = `dsn=${(0, $f7133678d936cd5e$export$44d472fbb931a776)(dsn)}`;
    for(const key in dialogOptions){
        if (key === "dsn") continue;
        if (key === "onClose") continue;
        if (key === "user") {
            const user = dialogOptions.user;
            if (!user) continue;
            if (user.name) encodedOptions += `&name=${encodeURIComponent(user.name)}`;
            if (user.email) encodedOptions += `&email=${encodeURIComponent(user.email)}`;
        } else encodedOptions += `&${encodeURIComponent(key)}=${encodeURIComponent(dialogOptions[key])}`;
    }
    return `${endpoint}?${encodedOptions}`;
}


var $4g0Ct = parcelRequire("4g0Ct");

var $8IHa9 = parcelRequire("8IHa9");

var $cmFjP = parcelRequire("cmFjP");
/** A class object that can instantiate Client objects. */ /**
 * Internal function to create a new SDK client instance. The client is
 * installed and then bound to the current scope.
 *
 * @param clientClass The client class to instantiate.
 * @param options Options to pass to the client.
 */ function $93002778f3923c52$export$5333c3f1c58d9bc1(clientClass, options) {
    if (options.debug === true) {
        if (0, $8IHa9.DEBUG_BUILD) (0, $4g0Ct.logger).enable();
        else // use `console.warn` rather than `logger.warn` since by non-debug bundles have all `logger.x` statements stripped
        (0, $4g0Ct.consoleSandbox)(()=>{
            // eslint-disable-next-line no-console
            console.warn("[Sentry] Cannot initialize SDK with `debug` option using a non-debug bundle.");
        });
    }
    const hub = (0, $cmFjP.getCurrentHub)();
    const scope = hub.getScope();
    scope.update(options.initialScope);
    const client = new clientClass(options);
    hub.bindClient(client);
}

var $d410fde205ba0588$exports = {};

$parcel$export($d410fde205ba0588$exports, "FunctionToString", () => $ceb328f2f449885f$export$da4704525c20ae79);
$parcel$export($d410fde205ba0588$exports, "InboundFilters", () => $499a1b6c2e7bd9e9$export$2ffbb5359dcc6be4);
$parcel$export($d410fde205ba0588$exports, "LinkedErrors", () => $a97c883563fbc553$export$8d1e60aaf616fb4f);

var $jL8lq = parcelRequire("jL8lq");
let $ceb328f2f449885f$var$originalFunctionToString;
/** Patch toString calls to return proper name for wrapped functions */ class $ceb328f2f449885f$export$da4704525c20ae79 {
    /**
   * @inheritDoc
   */ static __initStatic() {
        this.id = "FunctionToString";
    }
    /**
   * @inheritDoc
   */ constructor(){
        this.name = $ceb328f2f449885f$export$da4704525c20ae79.id;
    }
    /**
   * @inheritDoc
   */ setupOnce() {
        // eslint-disable-next-line @typescript-eslint/unbound-method
        $ceb328f2f449885f$var$originalFunctionToString = Function.prototype.toString;
        // intrinsics (like Function.prototype) might be immutable in some environments
        // e.g. Node with --frozen-intrinsics, XS (an embedded JavaScript engine) or SES (a JavaScript proposal)
        try {
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            Function.prototype.toString = function(...args) {
                const context = (0, $jL8lq.getOriginalFunction)(this) || this;
                return $ceb328f2f449885f$var$originalFunctionToString.apply(context, args);
            };
        } catch (e) {
        // ignore errors here, just don't patch this
        }
    }
}
$ceb328f2f449885f$export$da4704525c20ae79.__initStatic();



var $b1E2c = parcelRequire("b1E2c");
var $4g0Ct = parcelRequire("4g0Ct");
var $91U3U = parcelRequire("91U3U");

var $8IHa9 = parcelRequire("8IHa9");
// "Script error." is hard coded into browsers for errors that it can't read.
// this is the result of a script being pulled in from an external domain and CORS.
const $499a1b6c2e7bd9e9$var$DEFAULT_IGNORE_ERRORS = [
    /^Script error\.?$/,
    /^Javascript error: Script error\.? on line 0$/
];
const $499a1b6c2e7bd9e9$var$DEFAULT_IGNORE_TRANSACTIONS = [
    /^.*\/healthcheck$/,
    /^.*\/healthy$/,
    /^.*\/live$/,
    /^.*\/ready$/,
    /^.*\/heartbeat$/,
    /^.*\/health$/,
    /^.*\/healthz$/
];
/** Options for the InboundFilters integration */ /** Inbound filters configurable by the user */ class $499a1b6c2e7bd9e9$export$2ffbb5359dcc6be4 {
    /**
   * @inheritDoc
   */ static __initStatic() {
        this.id = "InboundFilters";
    }
    /**
   * @inheritDoc
   */ constructor(options = {}){
        this.name = $499a1b6c2e7bd9e9$export$2ffbb5359dcc6be4.id;
        this._options = options;
    }
    /**
   * @inheritDoc
   */ setupOnce(_addGlobalEventProcessor, _getCurrentHub) {
    // noop
    }
    /** @inheritDoc */ processEvent(event, _eventHint, client) {
        const clientOptions = client.getOptions();
        const options = $499a1b6c2e7bd9e9$export$6620a151868b99aa(this._options, clientOptions);
        return $499a1b6c2e7bd9e9$export$3c6361fddf6cd929(event, options) ? null : event;
    }
}
$499a1b6c2e7bd9e9$export$2ffbb5359dcc6be4.__initStatic();
/** JSDoc */ function $499a1b6c2e7bd9e9$export$6620a151868b99aa(internalOptions = {}, clientOptions = {}) {
    return {
        allowUrls: [
            ...internalOptions.allowUrls || [],
            ...clientOptions.allowUrls || []
        ],
        denyUrls: [
            ...internalOptions.denyUrls || [],
            ...clientOptions.denyUrls || []
        ],
        ignoreErrors: [
            ...internalOptions.ignoreErrors || [],
            ...clientOptions.ignoreErrors || [],
            ...internalOptions.disableErrorDefaults ? [] : $499a1b6c2e7bd9e9$var$DEFAULT_IGNORE_ERRORS
        ],
        ignoreTransactions: [
            ...internalOptions.ignoreTransactions || [],
            ...clientOptions.ignoreTransactions || [],
            ...internalOptions.disableTransactionDefaults ? [] : $499a1b6c2e7bd9e9$var$DEFAULT_IGNORE_TRANSACTIONS
        ],
        ignoreInternal: internalOptions.ignoreInternal !== undefined ? internalOptions.ignoreInternal : true
    };
}
/** JSDoc */ function $499a1b6c2e7bd9e9$export$3c6361fddf6cd929(event, options) {
    if (options.ignoreInternal && $499a1b6c2e7bd9e9$var$_isSentryError(event)) {
        (0, $8IHa9.DEBUG_BUILD) && (0, $4g0Ct.logger).warn(`Event dropped due to being internal Sentry Error.\nEvent: ${(0, $b1E2c.getEventDescription)(event)}`);
        return true;
    }
    if ($499a1b6c2e7bd9e9$var$_isIgnoredError(event, options.ignoreErrors)) {
        (0, $8IHa9.DEBUG_BUILD) && (0, $4g0Ct.logger).warn(`Event dropped due to being matched by \`ignoreErrors\` option.\nEvent: ${(0, $b1E2c.getEventDescription)(event)}`);
        return true;
    }
    if ($499a1b6c2e7bd9e9$var$_isIgnoredTransaction(event, options.ignoreTransactions)) {
        (0, $8IHa9.DEBUG_BUILD) && (0, $4g0Ct.logger).warn(`Event dropped due to being matched by \`ignoreTransactions\` option.\nEvent: ${(0, $b1E2c.getEventDescription)(event)}`);
        return true;
    }
    if ($499a1b6c2e7bd9e9$var$_isDeniedUrl(event, options.denyUrls)) {
        (0, $8IHa9.DEBUG_BUILD) && (0, $4g0Ct.logger).warn(`Event dropped due to being matched by \`denyUrls\` option.\nEvent: ${(0, $b1E2c.getEventDescription)(event)}.\nUrl: ${$499a1b6c2e7bd9e9$var$_getEventFilterUrl(event)}`);
        return true;
    }
    if (!$499a1b6c2e7bd9e9$var$_isAllowedUrl(event, options.allowUrls)) {
        (0, $8IHa9.DEBUG_BUILD) && (0, $4g0Ct.logger).warn(`Event dropped due to not being matched by \`allowUrls\` option.\nEvent: ${(0, $b1E2c.getEventDescription)(event)}.\nUrl: ${$499a1b6c2e7bd9e9$var$_getEventFilterUrl(event)}`);
        return true;
    }
    return false;
}
function $499a1b6c2e7bd9e9$var$_isIgnoredError(event, ignoreErrors) {
    // If event.type, this is not an error
    if (event.type || !ignoreErrors || !ignoreErrors.length) return false;
    return $499a1b6c2e7bd9e9$var$_getPossibleEventMessages(event).some((message)=>(0, $91U3U.stringMatchesSomePattern)(message, ignoreErrors));
}
function $499a1b6c2e7bd9e9$var$_isIgnoredTransaction(event, ignoreTransactions) {
    if (event.type !== "transaction" || !ignoreTransactions || !ignoreTransactions.length) return false;
    const name = event.transaction;
    return name ? (0, $91U3U.stringMatchesSomePattern)(name, ignoreTransactions) : false;
}
function $499a1b6c2e7bd9e9$var$_isDeniedUrl(event, denyUrls) {
    // TODO: Use Glob instead?
    if (!denyUrls || !denyUrls.length) return false;
    const url = $499a1b6c2e7bd9e9$var$_getEventFilterUrl(event);
    return !url ? false : (0, $91U3U.stringMatchesSomePattern)(url, denyUrls);
}
function $499a1b6c2e7bd9e9$var$_isAllowedUrl(event, allowUrls) {
    // TODO: Use Glob instead?
    if (!allowUrls || !allowUrls.length) return true;
    const url = $499a1b6c2e7bd9e9$var$_getEventFilterUrl(event);
    return !url ? true : (0, $91U3U.stringMatchesSomePattern)(url, allowUrls);
}
function $499a1b6c2e7bd9e9$var$_getPossibleEventMessages(event) {
    const possibleMessages = [];
    if (event.message) possibleMessages.push(event.message);
    let lastException;
    try {
        // @ts-expect-error Try catching to save bundle size
        // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
        lastException = event.exception.values[event.exception.values.length - 1];
    } catch (e) {
    // try catching to save bundle size checking existence of variables
    }
    if (lastException) {
        if (lastException.value) {
            possibleMessages.push(lastException.value);
            if (lastException.type) possibleMessages.push(`${lastException.type}: ${lastException.value}`);
        }
    }
    if ((0, $8IHa9.DEBUG_BUILD) && possibleMessages.length === 0) (0, $4g0Ct.logger).error(`Could not extract message for event ${(0, $b1E2c.getEventDescription)(event)}`);
    return possibleMessages;
}
function $499a1b6c2e7bd9e9$var$_isSentryError(event) {
    try {
        // @ts-expect-error can't be a sentry error if undefined
        // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
        return event.exception.values[0].type === "SentryError";
    } catch (e) {
    // ignore
    }
    return false;
}
function $499a1b6c2e7bd9e9$var$_getLastValidUrl(frames = []) {
    for(let i = frames.length - 1; i >= 0; i--){
        const frame = frames[i];
        if (frame && frame.filename !== "<anonymous>" && frame.filename !== "[native code]") return frame.filename || null;
    }
    return null;
}
function $499a1b6c2e7bd9e9$var$_getEventFilterUrl(event) {
    try {
        let frames;
        try {
            // @ts-expect-error we only care about frames if the whole thing here is defined
            frames = event.exception.values[0].stacktrace.frames;
        } catch (e) {
        // ignore
        }
        return frames ? $499a1b6c2e7bd9e9$var$_getLastValidUrl(frames) : null;
    } catch (oO) {
        (0, $8IHa9.DEBUG_BUILD) && (0, $4g0Ct.logger).error(`Cannot extract url for event ${(0, $b1E2c.getEventDescription)(event)}`);
        return null;
    }
}



var $2zW56 = parcelRequire("2zW56");

var $91U3U = parcelRequire("91U3U");
/**
 * Creates exceptions inside `event.exception.values` for errors that are nested on properties based on the `key` parameter.
 */ function $021240852b914991$export$b91c38ed7d8ae9b2(exceptionFromErrorImplementation, parser, maxValueLimit = 250, key, limit, event, hint) {
    if (!event.exception || !event.exception.values || !hint || !(0, $2zW56.isInstanceOf)(hint.originalException, Error)) return;
    // Generally speaking the last item in `event.exception.values` is the exception originating from the original Error
    const originalException = event.exception.values.length > 0 ? event.exception.values[event.exception.values.length - 1] : undefined;
    // We only create exception grouping if there is an exception in the event.
    if (originalException) event.exception.values = $021240852b914991$var$truncateAggregateExceptions($021240852b914991$var$aggregateExceptionsFromError(exceptionFromErrorImplementation, parser, limit, hint.originalException, key, event.exception.values, originalException, 0), maxValueLimit);
}
function $021240852b914991$var$aggregateExceptionsFromError(exceptionFromErrorImplementation, parser, limit, error, key, prevExceptions, exception, exceptionId) {
    if (prevExceptions.length >= limit + 1) return prevExceptions;
    let newExceptions = [
        ...prevExceptions
    ];
    if ((0, $2zW56.isInstanceOf)(error[key], Error)) {
        $021240852b914991$var$applyExceptionGroupFieldsForParentException(exception, exceptionId);
        const newException = exceptionFromErrorImplementation(parser, error[key]);
        const newExceptionId = newExceptions.length;
        $021240852b914991$var$applyExceptionGroupFieldsForChildException(newException, key, newExceptionId, exceptionId);
        newExceptions = $021240852b914991$var$aggregateExceptionsFromError(exceptionFromErrorImplementation, parser, limit, error[key], key, [
            newException,
            ...newExceptions
        ], newException, newExceptionId);
    }
    // This will create exception grouping for AggregateErrors
    // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/AggregateError
    if (Array.isArray(error.errors)) error.errors.forEach((childError, i)=>{
        if ((0, $2zW56.isInstanceOf)(childError, Error)) {
            $021240852b914991$var$applyExceptionGroupFieldsForParentException(exception, exceptionId);
            const newException = exceptionFromErrorImplementation(parser, childError);
            const newExceptionId = newExceptions.length;
            $021240852b914991$var$applyExceptionGroupFieldsForChildException(newException, `errors[${i}]`, newExceptionId, exceptionId);
            newExceptions = $021240852b914991$var$aggregateExceptionsFromError(exceptionFromErrorImplementation, parser, limit, childError, key, [
                newException,
                ...newExceptions
            ], newException, newExceptionId);
        }
    });
    return newExceptions;
}
function $021240852b914991$var$applyExceptionGroupFieldsForParentException(exception, exceptionId) {
    // Don't know if this default makes sense. The protocol requires us to set these values so we pick *some* default.
    exception.mechanism = exception.mechanism || {
        type: "generic",
        handled: true
    };
    exception.mechanism = {
        ...exception.mechanism,
        is_exception_group: true,
        exception_id: exceptionId
    };
}
function $021240852b914991$var$applyExceptionGroupFieldsForChildException(exception, source, exceptionId, parentId) {
    // Don't know if this default makes sense. The protocol requires us to set these values so we pick *some* default.
    exception.mechanism = exception.mechanism || {
        type: "generic",
        handled: true
    };
    exception.mechanism = {
        ...exception.mechanism,
        type: "chained",
        source: source,
        exception_id: exceptionId,
        parent_id: parentId
    };
}
/**
 * Truncate the message (exception.value) of all exceptions in the event.
 * Because this event processor is ran after `applyClientOptions`,
 * we need to truncate the message of the added exceptions here.
 */ function $021240852b914991$var$truncateAggregateExceptions(exceptions, maxValueLength) {
    return exceptions.map((exception)=>{
        if (exception.value) exception.value = (0, $91U3U.truncate)(exception.value, maxValueLength);
        return exception;
    });
}


var $2zW56 = parcelRequire("2zW56");

var $b1E2c = parcelRequire("b1E2c");

var $drMc1 = parcelRequire("drMc1");

var $jL8lq = parcelRequire("jL8lq");
/**
 * Extracts stack frames from the error.stack string
 */ function $bf09fb77f1b0ae9a$export$d478b2c12fbcfdda(stackParser, error) {
    return stackParser(error.stack || "", 1);
}
/**
 * Extracts stack frames from the error and builds a Sentry Exception
 */ function $bf09fb77f1b0ae9a$export$a6c2d27607295951(stackParser, error) {
    const exception = {
        type: error.name || error.constructor.name,
        value: error.message
    };
    const frames = $bf09fb77f1b0ae9a$export$d478b2c12fbcfdda(stackParser, error);
    if (frames.length) exception.stacktrace = {
        frames: frames
    };
    return exception;
}
function $bf09fb77f1b0ae9a$var$getMessageForObject(exception) {
    if ("name" in exception && typeof exception.name === "string") {
        let message = `'${exception.name}' captured as exception`;
        if ("message" in exception && typeof exception.message === "string") message += ` with message '${exception.message}'`;
        return message;
    } else if ("message" in exception && typeof exception.message === "string") return exception.message;
    else // This will allow us to group events based on top-level keys
    // which is much better than creating new group when any key/value change
    return `Object captured as exception with keys: ${(0, $jL8lq.extractExceptionKeysForMessage)(exception)}`;
}
/**
 * Builds and Event from a Exception
 * @hidden
 */ function $bf09fb77f1b0ae9a$export$9dd56ed1ef0c3420(getCurrentHub, stackParser, exception, hint) {
    let ex = exception;
    const providedMechanism = hint && hint.data && hint.data.mechanism;
    const mechanism = providedMechanism || {
        handled: true,
        type: "generic"
    };
    if (!(0, $2zW56.isError)(exception)) {
        if ((0, $2zW56.isPlainObject)(exception)) {
            const hub = getCurrentHub();
            const client = hub.getClient();
            const normalizeDepth = client && client.getOptions().normalizeDepth;
            hub.configureScope((scope)=>{
                scope.setExtra("__serialized__", (0, $drMc1.normalizeToSize)(exception, normalizeDepth));
            });
            const message = $bf09fb77f1b0ae9a$var$getMessageForObject(exception);
            ex = hint && hint.syntheticException || new Error(message);
            ex.message = message;
        } else {
            // This handles when someone does: `throw "something awesome";`
            // We use synthesized Error here so we can extract a (rough) stack trace.
            ex = hint && hint.syntheticException || new Error(exception);
            ex.message = exception;
        }
        mechanism.synthetic = true;
    }
    const event = {
        exception: {
            values: [
                $bf09fb77f1b0ae9a$export$a6c2d27607295951(stackParser, ex)
            ]
        }
    };
    (0, $b1E2c.addExceptionTypeValue)(event, undefined, undefined);
    (0, $b1E2c.addExceptionMechanism)(event, mechanism);
    return {
        ...event,
        event_id: hint && hint.event_id
    };
}
/**
 * Builds and Event from a Message
 * @hidden
 */ function $bf09fb77f1b0ae9a$export$5425b53185d13d6c(stackParser, message, // eslint-disable-next-line deprecation/deprecation
level = "info", hint, attachStacktrace) {
    const event = {
        event_id: hint && hint.event_id,
        level: level,
        message: message
    };
    if (attachStacktrace && hint && hint.syntheticException) {
        const frames = $bf09fb77f1b0ae9a$export$d478b2c12fbcfdda(stackParser, hint.syntheticException);
        if (frames.length) event.exception = {
            values: [
                {
                    value: message,
                    stacktrace: {
                        frames: frames
                    }
                }
            ]
        };
    }
    return event;
}


const $a97c883563fbc553$var$DEFAULT_KEY = "cause";
const $a97c883563fbc553$var$DEFAULT_LIMIT = 5;
/** Adds SDK info to an event. */ class $a97c883563fbc553$export$8d1e60aaf616fb4f {
    /**
   * @inheritDoc
   */ static __initStatic() {
        this.id = "LinkedErrors";
    }
    /**
   * @inheritDoc
   */ /**
   * @inheritDoc
   */ /**
   * @inheritDoc
   */ /**
   * @inheritDoc
   */ constructor(options = {}){
        this._key = options.key || $a97c883563fbc553$var$DEFAULT_KEY;
        this._limit = options.limit || $a97c883563fbc553$var$DEFAULT_LIMIT;
        this.name = $a97c883563fbc553$export$8d1e60aaf616fb4f.id;
    }
    /** @inheritdoc */ setupOnce() {
    // noop
    }
    /**
   * @inheritDoc
   */ preprocessEvent(event, hint, client) {
        const options = client.getOptions();
        (0, $021240852b914991$export$b91c38ed7d8ae9b2)((0, $bf09fb77f1b0ae9a$export$a6c2d27607295951), options.stackParser, options.maxValueLength, this._key, this._limit, event, hint);
    }
}
$a97c883563fbc553$export$8d1e60aaf616fb4f.__initStatic();





var $jL8lq = parcelRequire("jL8lq");



var $3bpJ1 = parcelRequire("3bpJ1");

var $3bpJ1 = parcelRequire("3bpJ1");
// Based on https://github.com/angular/angular.js/pull/13945/files
// eslint-disable-next-line deprecation/deprecation
const $a7f24c22762d2906$var$WINDOW = (0, $3bpJ1.getGlobalObject)();
/**
 * Tells whether current environment supports History API
 * {@link supportsHistory}.
 *
 * @returns Answer to the given question.
 */ function $a7f24c22762d2906$export$67fc34576016d6ec() {
    // NOTE: in Chrome App environment, touching history.pushState, *even inside
    //       a try/catch block*, will cause Chrome to output an error to console.error
    // borrowed from: https://github.com/angular/angular.js/pull/13945/files
    /* eslint-disable @typescript-eslint/no-unsafe-member-access */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const chrome = $a7f24c22762d2906$var$WINDOW.chrome;
    const isChromePackagedApp = chrome && chrome.app && chrome.app.runtime;
    /* eslint-enable @typescript-eslint/no-unsafe-member-access */ const hasHistoryApi = "history" in $a7f24c22762d2906$var$WINDOW && !!$a7f24c22762d2906$var$WINDOW.history.pushState && !!$a7f24c22762d2906$var$WINDOW.history.replaceState;
    return !isChromePackagedApp && hasHistoryApi;
}



var $dbwHv = parcelRequire("dbwHv");
const $2579aac1b9dfd189$var$WINDOW = (0, $3bpJ1.GLOBAL_OBJ);
let $2579aac1b9dfd189$var$lastHref;
/**
 * Add an instrumentation handler for when a fetch request happens.
 * The handler function is called once when the request starts and once when it ends,
 * which can be identified by checking if it has an `endTimestamp`.
 *
 * Use at your own risk, this might break without changelog notice, only used internally.
 * @hidden
 */ function $2579aac1b9dfd189$export$3f18c56c58114e75(handler) {
    const type = "history";
    (0, $dbwHv.addHandler)(type, handler);
    (0, $dbwHv.maybeInstrument)(type, $2579aac1b9dfd189$var$instrumentHistory);
}
function $2579aac1b9dfd189$var$instrumentHistory() {
    if (!(0, $a7f24c22762d2906$export$67fc34576016d6ec)()) return;
    const oldOnPopState = $2579aac1b9dfd189$var$WINDOW.onpopstate;
    $2579aac1b9dfd189$var$WINDOW.onpopstate = function(...args) {
        const to = $2579aac1b9dfd189$var$WINDOW.location.href;
        // keep track of the current URL state, as we always receive only the updated state
        const from = $2579aac1b9dfd189$var$lastHref;
        $2579aac1b9dfd189$var$lastHref = to;
        const handlerData = {
            from: from,
            to: to
        };
        (0, $dbwHv.triggerHandlers)("history", handlerData);
        if (oldOnPopState) // Apparently this can throw in Firefox when incorrectly implemented plugin is installed.
        // https://github.com/getsentry/sentry-javascript/issues/3344
        // https://github.com/bugsnag/bugsnag-js/issues/469
        try {
            return oldOnPopState.apply(this, args);
        } catch (_oO) {
        // no-empty
        }
    };
    function historyReplacementFunction(originalHistoryFunction) {
        return function(...args) {
            const url = args.length > 2 ? args[2] : undefined;
            if (url) {
                // coerce to string (this is what pushState does)
                const from = $2579aac1b9dfd189$var$lastHref;
                const to = String(url);
                // keep track of the current URL state, as we always receive only the updated state
                $2579aac1b9dfd189$var$lastHref = to;
                const handlerData = {
                    from: from,
                    to: to
                };
                (0, $dbwHv.triggerHandlers)("history", handlerData);
            }
            return originalHistoryFunction.apply(this, args);
        };
    }
    (0, $jL8lq.fill)($2579aac1b9dfd189$var$WINDOW.history, "pushState", historyReplacementFunction);
    (0, $jL8lq.fill)($2579aac1b9dfd189$var$WINDOW.history, "replaceState", historyReplacementFunction);
}


var $4g0Ct = parcelRequire("4g0Ct");
var $16dZf = parcelRequire("16dZf");
var $eKZKa = parcelRequire("eKZKa");

var $4g0Ct = parcelRequire("4g0Ct");

var $3bpJ1 = parcelRequire("3bpJ1");
// eslint-disable-next-line deprecation/deprecation
const $a87a94b8e4ff7f26$var$WINDOW = (0, $3bpJ1.getGlobalObject)();
/**
 * Tells whether current environment supports ErrorEvent objects
 * {@link supportsErrorEvent}.
 *
 * @returns Answer to the given question.
 */ function $a87a94b8e4ff7f26$export$caa710b4d7f9cadf() {
    try {
        new ErrorEvent("");
        return true;
    } catch (e) {
        return false;
    }
}
/**
 * Tells whether current environment supports DOMError objects
 * {@link supportsDOMError}.
 *
 * @returns Answer to the given question.
 */ function $a87a94b8e4ff7f26$export$1c08bd1a7eb3c472() {
    try {
        // Chrome: VM89:1 Uncaught TypeError: Failed to construct 'DOMError':
        // 1 argument required, but only 0 present.
        // @ts-expect-error It really needs 1 argument, not 0.
        new DOMError("");
        return true;
    } catch (e) {
        return false;
    }
}
/**
 * Tells whether current environment supports DOMException objects
 * {@link supportsDOMException}.
 *
 * @returns Answer to the given question.
 */ function $a87a94b8e4ff7f26$export$ab12a5d056f1d3a() {
    try {
        new DOMException("");
        return true;
    } catch (e) {
        return false;
    }
}
/**
 * Tells whether current environment supports Fetch API
 * {@link supportsFetch}.
 *
 * @returns Answer to the given question.
 */ function $a87a94b8e4ff7f26$export$edf3cb81fd7d2a3e() {
    if (!("fetch" in $a87a94b8e4ff7f26$var$WINDOW)) return false;
    try {
        new Headers();
        new Request("http://www.example.com");
        new Response();
        return true;
    } catch (e) {
        return false;
    }
}
/**
 * isNativeFetch checks if the given function is a native implementation of fetch()
 */ // eslint-disable-next-line @typescript-eslint/ban-types
function $a87a94b8e4ff7f26$export$18cf36ed71d733e7(func) {
    return func && /^function fetch\(\)\s+\{\s+\[native code\]\s+\}$/.test(func.toString());
}
/**
 * Tells whether current environment supports Fetch API natively
 * {@link supportsNativeFetch}.
 *
 * @returns true if `window.fetch` is natively implemented, false otherwise
 */ function $a87a94b8e4ff7f26$export$c82d238e23c40b21() {
    if (typeof EdgeRuntime === "string") return true;
    if (!$a87a94b8e4ff7f26$export$edf3cb81fd7d2a3e()) return false;
    // Fast path to avoid DOM I/O
    // eslint-disable-next-line @typescript-eslint/unbound-method
    if ($a87a94b8e4ff7f26$export$18cf36ed71d733e7($a87a94b8e4ff7f26$var$WINDOW.fetch)) return true;
    // window.fetch is implemented, but is polyfilled or already wrapped (e.g: by a chrome extension)
    // so create a "pure" iframe to see if that has native fetch
    let result = false;
    const doc = $a87a94b8e4ff7f26$var$WINDOW.document;
    // eslint-disable-next-line deprecation/deprecation
    if (doc && typeof doc.createElement === "function") try {
        const sandbox = doc.createElement("iframe");
        sandbox.hidden = true;
        doc.head.appendChild(sandbox);
        if (sandbox.contentWindow && sandbox.contentWindow.fetch) // eslint-disable-next-line @typescript-eslint/unbound-method
        result = $a87a94b8e4ff7f26$export$18cf36ed71d733e7(sandbox.contentWindow.fetch);
        doc.head.removeChild(sandbox);
    } catch (err) {
        (0, $eKZKa.DEBUG_BUILD) && (0, $4g0Ct.logger).warn("Could not create sandbox iframe for pure fetch check, bailing to window.fetch: ", err);
    }
    return result;
}
/**
 * Tells whether current environment supports ReportingObserver API
 * {@link supportsReportingObserver}.
 *
 * @returns Answer to the given question.
 */ function $a87a94b8e4ff7f26$export$531055a6c684a70a() {
    return "ReportingObserver" in $a87a94b8e4ff7f26$var$WINDOW;
}
/**
 * Tells whether current environment supports Referrer Policy API
 * {@link supportsReferrerPolicy}.
 *
 * @returns Answer to the given question.
 */ function $a87a94b8e4ff7f26$export$2d308b428295192f() {
    // Despite all stars in the sky saying that Edge supports old draft syntax, aka 'never', 'always', 'origin' and 'default'
    // (see https://caniuse.com/#feat=referrer-policy),
    // it doesn't. And it throws an exception instead of ignoring this parameter...
    // REF: https://github.com/getsentry/raven-js/issues/1233
    if (!$a87a94b8e4ff7f26$export$edf3cb81fd7d2a3e()) return false;
    try {
        new Request("_", {
            referrerPolicy: "origin"
        });
        return true;
    } catch (e) {
        return false;
    }
}




var $drMc1 = parcelRequire("drMc1");

var $jL8lq = parcelRequire("jL8lq");
/**
 * Creates an envelope.
 * Make sure to always explicitly provide the generic to this function
 * so that the envelope types resolve correctly.
 */ function $2cae643f899492f0$export$f93f7f385160c44e(headers, items = []) {
    return [
        headers,
        items
    ];
}
/**
 * Add an item to an envelope.
 * Make sure to always explicitly provide the generic to this function
 * so that the envelope types resolve correctly.
 */ function $2cae643f899492f0$export$d650323442802f6f(envelope, newItem) {
    const [headers, items] = envelope;
    return [
        headers,
        [
            ...items,
            newItem
        ]
    ];
}
/**
 * Convenience function to loop through the items and item types of an envelope.
 * (This function was mostly created because working with envelope types is painful at the moment)
 *
 * If the callback returns true, the rest of the items will be skipped.
 */ function $2cae643f899492f0$export$c56c55acf0136fd3(envelope, callback) {
    const envelopeItems = envelope[1];
    for (const envelopeItem of envelopeItems){
        const envelopeItemType = envelopeItem[0].type;
        const result = callback(envelopeItem, envelopeItemType);
        if (result) return true;
    }
    return false;
}
/**
 * Returns true if the envelope contains any of the given envelope item types
 */ function $2cae643f899492f0$export$604a45d95a155e2b(envelope, types) {
    return $2cae643f899492f0$export$c56c55acf0136fd3(envelope, (_, type)=>types.includes(type));
}
/**
 * Encode a string to UTF8.
 */ function $2cae643f899492f0$var$encodeUTF8(input, textEncoder) {
    const utf8 = textEncoder || new TextEncoder();
    return utf8.encode(input);
}
/**
 * Serializes an envelope.
 */ function $2cae643f899492f0$export$32f9b428425aac85(envelope, textEncoder) {
    const [envHeaders, items] = envelope;
    // Initially we construct our envelope as a string and only convert to binary chunks if we encounter binary data
    let parts = JSON.stringify(envHeaders);
    function append(next) {
        if (typeof parts === "string") parts = typeof next === "string" ? parts + next : [
            $2cae643f899492f0$var$encodeUTF8(parts, textEncoder),
            next
        ];
        else parts.push(typeof next === "string" ? $2cae643f899492f0$var$encodeUTF8(next, textEncoder) : next);
    }
    for (const item of items){
        const [itemHeaders, payload] = item;
        append(`\n${JSON.stringify(itemHeaders)}\n`);
        if (typeof payload === "string" || payload instanceof Uint8Array) append(payload);
        else {
            let stringifiedPayload;
            try {
                stringifiedPayload = JSON.stringify(payload);
            } catch (e) {
                // In case, despite all our efforts to keep `payload` circular-dependency-free, `JSON.strinify()` still
                // fails, we try again after normalizing it again with infinite normalization depth. This of course has a
                // performance impact but in this case a performance hit is better than throwing.
                stringifiedPayload = JSON.stringify((0, $drMc1.normalize)(payload));
            }
            append(stringifiedPayload);
        }
    }
    return typeof parts === "string" ? parts : $2cae643f899492f0$var$concatBuffers(parts);
}
function $2cae643f899492f0$var$concatBuffers(buffers) {
    const totalLength = buffers.reduce((acc, buf)=>acc + buf.length, 0);
    const merged = new Uint8Array(totalLength);
    let offset = 0;
    for (const buffer of buffers){
        merged.set(buffer, offset);
        offset += buffer.length;
    }
    return merged;
}
/**
 * Parses an envelope
 */ function $2cae643f899492f0$export$3338d0c7b6e17a2b(env, textEncoder, textDecoder) {
    let buffer = typeof env === "string" ? textEncoder.encode(env) : env;
    function readBinary(length) {
        const bin = buffer.subarray(0, length);
        // Replace the buffer with the remaining data excluding trailing newline
        buffer = buffer.subarray(length + 1);
        return bin;
    }
    function readJson() {
        let i = buffer.indexOf(0xa);
        // If we couldn't find a newline, we must have found the end of the buffer
        if (i < 0) i = buffer.length;
        return JSON.parse(textDecoder.decode(readBinary(i)));
    }
    const envelopeHeader = readJson();
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const items = [];
    while(buffer.length){
        const itemHeader = readJson();
        const binaryLength = typeof itemHeader.length === "number" ? itemHeader.length : undefined;
        items.push([
            itemHeader,
            binaryLength ? readBinary(binaryLength) : readJson()
        ]);
    }
    return [
        envelopeHeader,
        items
    ];
}
/**
 * Creates attachment envelope items
 */ function $2cae643f899492f0$export$d8fc80952cc31fa4(attachment, textEncoder) {
    const buffer = typeof attachment.data === "string" ? $2cae643f899492f0$var$encodeUTF8(attachment.data, textEncoder) : attachment.data;
    return [
        (0, $jL8lq.dropUndefinedKeys)({
            type: "attachment",
            length: buffer.length,
            filename: attachment.filename,
            content_type: attachment.contentType,
            attachment_type: attachment.attachmentType
        }),
        buffer
    ];
}
const $2cae643f899492f0$var$ITEM_TYPE_TO_DATA_CATEGORY_MAP = {
    session: "session",
    sessions: "session",
    attachment: "attachment",
    transaction: "transaction",
    event: "error",
    client_report: "internal",
    user_report: "default",
    profile: "profile",
    replay_event: "replay",
    replay_recording: "replay",
    check_in: "monitor",
    feedback: "feedback",
    // TODO: This is a temporary workaround until we have a proper data category for metrics
    statsd: "unknown"
};
/**
 * Maps the type of an envelope item to a data category.
 */ function $2cae643f899492f0$export$b11169581eeaf237(type) {
    return $2cae643f899492f0$var$ITEM_TYPE_TO_DATA_CATEGORY_MAP[type];
}
/** Extracts the minimal SDK info from from the metadata or an events */ function $2cae643f899492f0$export$d369f3b2758f6743(metadataOrEvent) {
    if (!metadataOrEvent || !metadataOrEvent.sdk) return;
    const { name: name, version: version } = metadataOrEvent.sdk;
    return {
        name: name,
        version: version
    };
}
/**
 * Creates event envelope headers, based on event, sdk info and tunnel
 * Note: This function was extracted from the core package to make it available in Replay
 */ function $2cae643f899492f0$export$92b6093782fe661b(event, sdkInfo, tunnel, dsn) {
    const dynamicSamplingContext = event.sdkProcessingMetadata && event.sdkProcessingMetadata.dynamicSamplingContext;
    return {
        event_id: event.event_id,
        sent_at: new Date().toISOString(),
        ...sdkInfo && {
            sdk: sdkInfo
        },
        ...!!tunnel && dsn && {
            dsn: (0, $f7133678d936cd5e$export$44d472fbb931a776)(dsn)
        },
        ...dynamicSamplingContext && {
            trace: (0, $jL8lq.dropUndefinedKeys)({
                ...dynamicSamplingContext
            })
        }
    };
}


var $b1E2c = parcelRequire("b1E2c");
var $2zW56 = parcelRequire("2zW56");
var $4g0Ct = parcelRequire("4g0Ct");
var $j3a3y = parcelRequire("j3a3y");/** An error emitted by Sentry SDKs and related utilities. */ class $890c53ca2f6b4a7a$export$5949942ba2a7c0e2 extends Error {
    /** Display name of this error instance. */ constructor(message, logLevel = "warn"){
        super(message);
        this.message = message;
        this.name = new.target.prototype.constructor.name;
        // This sets the prototype to be `Error`, not `SentryError`. It's unclear why we do this, but commenting this line
        // out causes various (seemingly totally unrelated) playwright tests consistently time out. FYI, this makes
        // instances of `SentryError` fail `obj instanceof SentryError` checks.
        Object.setPrototypeOf(this, new.target.prototype);
        this.logLevel = logLevel;
    }
}




var $8IHa9 = parcelRequire("8IHa9");

/**
 * Apply SdkInfo (name, version, packages, integrations) to the corresponding event key.
 * Merge with existing data if any.
 **/ function $9b6c4c62dbf66cae$var$enhanceEventWithSdkInfo(event, sdkInfo) {
    if (!sdkInfo) return event;
    event.sdk = event.sdk || {};
    event.sdk.name = event.sdk.name || sdkInfo.name;
    event.sdk.version = event.sdk.version || sdkInfo.version;
    event.sdk.integrations = [
        ...event.sdk.integrations || [],
        ...sdkInfo.integrations || []
    ];
    event.sdk.packages = [
        ...event.sdk.packages || [],
        ...sdkInfo.packages || []
    ];
    return event;
}
/** Creates an envelope from a Session */ function $9b6c4c62dbf66cae$export$124b03c077baa2f3(session, dsn, metadata, tunnel) {
    const sdkInfo = (0, $2cae643f899492f0$export$d369f3b2758f6743)(metadata);
    const envelopeHeaders = {
        sent_at: new Date().toISOString(),
        ...sdkInfo && {
            sdk: sdkInfo
        },
        ...!!tunnel && dsn && {
            dsn: (0, $f7133678d936cd5e$export$44d472fbb931a776)(dsn)
        }
    };
    const envelopeItem = "aggregates" in session ? [
        {
            type: "sessions"
        },
        session
    ] : [
        {
            type: "session"
        },
        session.toJSON()
    ];
    return (0, $2cae643f899492f0$export$f93f7f385160c44e)(envelopeHeaders, [
        envelopeItem
    ]);
}
/**
 * Create an Envelope from an event.
 */ function $9b6c4c62dbf66cae$export$c31057337a18010f(event, dsn, metadata, tunnel) {
    const sdkInfo = (0, $2cae643f899492f0$export$d369f3b2758f6743)(metadata);
    /*
    Note: Due to TS, event.type may be `replay_event`, theoretically.
    In practice, we never call `createEventEnvelope` with `replay_event` type,
    and we'd have to adjut a looot of types to make this work properly.
    We want to avoid casting this around, as that could lead to bugs (e.g. when we add another type)
    So the safe choice is to really guard against the replay_event type here.
  */ const eventType = event.type && event.type !== "replay_event" ? event.type : "event";
    $9b6c4c62dbf66cae$var$enhanceEventWithSdkInfo(event, metadata && metadata.sdk);
    const envelopeHeaders = (0, $2cae643f899492f0$export$92b6093782fe661b)(event, sdkInfo, tunnel, dsn);
    // Prevent this data (which, if it exists, was used in earlier steps in the processing pipeline) from being sent to
    // sentry. (Note: Our use of this property comes and goes with whatever we might be debugging, whatever hacks we may
    // have temporarily added, etc. Even if we don't happen to be using it at some point in the future, let's not get rid
    // of this `delete`, lest we miss putting it back in the next time the property is in use.)
    delete event.sdkProcessingMetadata;
    const eventItem = [
        {
            type: eventType
        },
        event
    ];
    return (0, $2cae643f899492f0$export$f93f7f385160c44e)(envelopeHeaders, [
        eventItem
    ]);
}



var $cmFjP = parcelRequire("cmFjP");


var $oyvka = parcelRequire("oyvka");

var $bPHT6 = parcelRequire("bPHT6");

var $az0Em = parcelRequire("az0Em");
const $5d4a5f71b683f78e$var$ALREADY_SEEN_ERROR = "Not capturing exception because it's already been captured.";
/**
 * Base implementation for all JavaScript SDK clients.
 *
 * Call the constructor with the corresponding options
 * specific to the client subclass. To access these options later, use
 * {@link Client.getOptions}.
 *
 * If a Dsn is specified in the options, it will be parsed and stored. Use
 * {@link Client.getDsn} to retrieve the Dsn at any moment. In case the Dsn is
 * invalid, the constructor will throw a {@link SentryException}. Note that
 * without a valid Dsn, the SDK will not send any events to Sentry.
 *
 * Before sending an event, it is passed through
 * {@link BaseClient._prepareEvent} to add SDK information and scope data
 * (breadcrumbs and context). To add more custom information, override this
 * method and extend the resulting prepared event.
 *
 * To issue automatically created events (e.g. via instrumentation), use
 * {@link Client.captureEvent}. It will prepare the event and pass it through
 * the callback lifecycle. To issue auto-breadcrumbs, use
 * {@link Client.addBreadcrumb}.
 *
 * @example
 * class NodeClient extends BaseClient<NodeOptions> {
 *   public constructor(options: NodeOptions) {
 *     super(options);
 *   }
 *
 *   // ...
 * }
 */ class $5d4a5f71b683f78e$export$4f22f74eddb7716a {
    /** Options passed to the SDK. */ /** The client Dsn, if specified in options. Without this Dsn, the SDK will be disabled. */ /** Array of set up integrations. */ /** Indicates whether this client's integrations have been set up. */ /** Number of calls being processed */ /** Holds flushable  */ // eslint-disable-next-line @typescript-eslint/ban-types
    /**
   * Initializes this client instance.
   *
   * @param options Options for the client.
   */ constructor(options){
        this._options = options;
        this._integrations = {};
        this._integrationsInitialized = false;
        this._numProcessing = 0;
        this._outcomes = {};
        this._hooks = {};
        this._eventProcessors = [];
        if (options.dsn) this._dsn = (0, $f7133678d936cd5e$export$128827c3562ec0cb)(options.dsn);
        else (0, $8IHa9.DEBUG_BUILD) && (0, $4g0Ct.logger).warn("No DSN provided, client will not send events.");
        if (this._dsn) {
            const url = (0, $d91612272370ed71$export$9964600bfe84e6a3)(this._dsn, options);
            this._transport = options.transport({
                recordDroppedEvent: this.recordDroppedEvent.bind(this),
                ...options.transportOptions,
                url: url
            });
        }
    }
    /**
   * @inheritDoc
   */ // eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/explicit-module-boundary-types
    captureException(exception, hint, scope) {
        // ensure we haven't captured this very object before
        if ((0, $b1E2c.checkOrSetAlreadyCaught)(exception)) {
            (0, $8IHa9.DEBUG_BUILD) && (0, $4g0Ct.logger).log($5d4a5f71b683f78e$var$ALREADY_SEEN_ERROR);
            return;
        }
        let eventId = hint && hint.event_id;
        this._process(this.eventFromException(exception, hint).then((event)=>this._captureEvent(event, hint, scope)).then((result)=>{
            eventId = result;
        }));
        return eventId;
    }
    /**
   * @inheritDoc
   */ captureMessage(message, // eslint-disable-next-line deprecation/deprecation
    level, hint, scope) {
        let eventId = hint && hint.event_id;
        const promisedEvent = (0, $2zW56.isPrimitive)(message) ? this.eventFromMessage(String(message), level, hint) : this.eventFromException(message, hint);
        this._process(promisedEvent.then((event)=>this._captureEvent(event, hint, scope)).then((result)=>{
            eventId = result;
        }));
        return eventId;
    }
    /**
   * @inheritDoc
   */ captureEvent(event, hint, scope) {
        // ensure we haven't captured this very object before
        if (hint && hint.originalException && (0, $b1E2c.checkOrSetAlreadyCaught)(hint.originalException)) {
            (0, $8IHa9.DEBUG_BUILD) && (0, $4g0Ct.logger).log($5d4a5f71b683f78e$var$ALREADY_SEEN_ERROR);
            return;
        }
        let eventId = hint && hint.event_id;
        this._process(this._captureEvent(event, hint, scope).then((result)=>{
            eventId = result;
        }));
        return eventId;
    }
    /**
   * @inheritDoc
   */ captureSession(session) {
        if (!(typeof session.release === "string")) (0, $8IHa9.DEBUG_BUILD) && (0, $4g0Ct.logger).warn("Discarded session because of missing or non-string release");
        else {
            this.sendSession(session);
            // After sending, we set init false to indicate it's not the first occurrence
            (0, $oyvka.updateSession)(session, {
                init: false
            });
        }
    }
    /**
   * @inheritDoc
   */ getDsn() {
        return this._dsn;
    }
    /**
   * @inheritDoc
   */ getOptions() {
        return this._options;
    }
    /**
   * @see SdkMetadata in @sentry/types
   *
   * @return The metadata of the SDK
   */ getSdkMetadata() {
        return this._options._metadata;
    }
    /**
   * @inheritDoc
   */ getTransport() {
        return this._transport;
    }
    /**
   * @inheritDoc
   */ flush(timeout) {
        const transport = this._transport;
        if (transport) return this._isClientDoneProcessing(timeout).then((clientFinished)=>{
            return transport.flush(timeout).then((transportFlushed)=>clientFinished && transportFlushed);
        });
        else return (0, $j3a3y.resolvedSyncPromise)(true);
    }
    /**
   * @inheritDoc
   */ close(timeout) {
        return this.flush(timeout).then((result)=>{
            this.getOptions().enabled = false;
            return result;
        });
    }
    /** Get all installed event processors. */ getEventProcessors() {
        return this._eventProcessors;
    }
    /** @inheritDoc */ addEventProcessor(eventProcessor) {
        this._eventProcessors.push(eventProcessor);
    }
    /**
   * Sets up the integrations
   */ setupIntegrations(forceInitialize) {
        if (forceInitialize && !this._integrationsInitialized || this._isEnabled() && !this._integrationsInitialized) {
            this._integrations = (0, $51cfcbefde61ff20$export$51abed9797baa598)(this, this._options.integrations);
            this._integrationsInitialized = true;
        }
    }
    /**
   * Gets an installed integration by its `id`.
   *
   * @returns The installed integration or `undefined` if no integration with that `id` was installed.
   */ getIntegrationById(integrationId) {
        return this._integrations[integrationId];
    }
    /**
   * @inheritDoc
   */ getIntegration(integration) {
        try {
            return this._integrations[integration.id] || null;
        } catch (_oO) {
            (0, $8IHa9.DEBUG_BUILD) && (0, $4g0Ct.logger).warn(`Cannot retrieve integration ${integration.id} from the current Client`);
            return null;
        }
    }
    /**
   * @inheritDoc
   */ addIntegration(integration) {
        (0, $51cfcbefde61ff20$export$e7390a03b70a6f2f)(this, integration, this._integrations);
    }
    /**
   * @inheritDoc
   */ sendEvent(event, hint = {}) {
        this.emit("beforeSendEvent", event, hint);
        let env = (0, $9b6c4c62dbf66cae$export$c31057337a18010f)(event, this._dsn, this._options._metadata, this._options.tunnel);
        for (const attachment of hint.attachments || [])env = (0, $2cae643f899492f0$export$d650323442802f6f)(env, (0, $2cae643f899492f0$export$d8fc80952cc31fa4)(attachment, this._options.transportOptions && this._options.transportOptions.textEncoder));
        const promise = this._sendEnvelope(env);
        if (promise) promise.then((sendResponse)=>this.emit("afterSendEvent", event, sendResponse), null);
    }
    /**
   * @inheritDoc
   */ sendSession(session) {
        const env = (0, $9b6c4c62dbf66cae$export$124b03c077baa2f3)(session, this._dsn, this._options._metadata, this._options.tunnel);
        this._sendEnvelope(env);
    }
    /**
   * @inheritDoc
   */ recordDroppedEvent(reason, category, _event) {
        // Note: we use `event` in replay, where we overwrite this hook.
        if (this._options.sendClientReports) {
            // We want to track each category (error, transaction, session, replay_event) separately
            // but still keep the distinction between different type of outcomes.
            // We could use nested maps, but it's much easier to read and type this way.
            // A correct type for map-based implementation if we want to go that route
            // would be `Partial<Record<SentryRequestType, Partial<Record<Outcome, number>>>>`
            // With typescript 4.1 we could even use template literal types
            const key = `${reason}:${category}`;
            (0, $8IHa9.DEBUG_BUILD) && (0, $4g0Ct.logger).log(`Adding outcome: "${key}"`);
            // The following works because undefined + 1 === NaN and NaN is falsy
            this._outcomes[key] = this._outcomes[key] + 1 || 1;
        }
    }
    // Keep on() & emit() signatures in sync with types' client.ts interface
    /* eslint-disable @typescript-eslint/unified-signatures */ /** @inheritdoc */ /** @inheritdoc */ on(hook, callback) {
        if (!this._hooks[hook]) this._hooks[hook] = [];
        // @ts-expect-error We assue the types are correct
        this._hooks[hook].push(callback);
    }
    /** @inheritdoc */ /** @inheritdoc */ emit(hook, ...rest) {
        if (this._hooks[hook]) this._hooks[hook].forEach((callback)=>callback(...rest));
    }
    /* eslint-enable @typescript-eslint/unified-signatures */ /** Updates existing session based on the provided event */ _updateSessionFromEvent(session, event) {
        let crashed = false;
        let errored = false;
        const exceptions = event.exception && event.exception.values;
        if (exceptions) {
            errored = true;
            for (const ex of exceptions){
                const mechanism = ex.mechanism;
                if (mechanism && mechanism.handled === false) {
                    crashed = true;
                    break;
                }
            }
        }
        // A session is updated and that session update is sent in only one of the two following scenarios:
        // 1. Session with non terminal status and 0 errors + an error occurred -> Will set error count to 1 and send update
        // 2. Session with non terminal status and 1 error + a crash occurred -> Will set status crashed and send update
        const sessionNonTerminal = session.status === "ok";
        const shouldUpdateAndSend = sessionNonTerminal && session.errors === 0 || sessionNonTerminal && crashed;
        if (shouldUpdateAndSend) {
            (0, $oyvka.updateSession)(session, {
                ...crashed && {
                    status: "crashed"
                },
                errors: session.errors || Number(errored || crashed)
            });
            this.captureSession(session);
        }
    }
    /**
   * Determine if the client is finished processing. Returns a promise because it will wait `timeout` ms before saying
   * "no" (resolving to `false`) in order to give the client a chance to potentially finish first.
   *
   * @param timeout The time, in ms, after which to resolve to `false` if the client is still busy. Passing `0` (or not
   * passing anything) will make the promise wait as long as it takes for processing to finish before resolving to
   * `true`.
   * @returns A promise which will resolve to `true` if processing is already done or finishes before the timeout, and
   * `false` otherwise
   */ _isClientDoneProcessing(timeout) {
        return new (0, $j3a3y.SyncPromise)((resolve)=>{
            let ticked = 0;
            const tick = 1;
            const interval = setInterval(()=>{
                if (this._numProcessing == 0) {
                    clearInterval(interval);
                    resolve(true);
                } else {
                    ticked += tick;
                    if (timeout && ticked >= timeout) {
                        clearInterval(interval);
                        resolve(false);
                    }
                }
            }, tick);
        });
    }
    /** Determines whether this SDK is enabled and a transport is present. */ _isEnabled() {
        return this.getOptions().enabled !== false && this._transport !== undefined;
    }
    /**
   * Adds common information to events.
   *
   * The information includes release and environment from `options`,
   * breadcrumbs and context (extra, tags and user) from the scope.
   *
   * Information that is already present in the event is never overwritten. For
   * nested objects, such as the context, keys are merged.
   *
   * @param event The original event.
   * @param hint May contain additional information about the original exception.
   * @param scope A scope containing event metadata.
   * @returns A new event with more information.
   */ _prepareEvent(event, hint, scope) {
        const options = this.getOptions();
        const integrations = Object.keys(this._integrations);
        if (!hint.integrations && integrations.length > 0) hint.integrations = integrations;
        this.emit("preprocessEvent", event, hint);
        return (0, $az0Em.prepareEvent)(options, event, hint, scope, this).then((evt)=>{
            if (evt === null) return evt;
            // If a trace context is not set on the event, we use the propagationContext set on the event to
            // generate a trace context. If the propagationContext does not have a dynamic sampling context, we
            // also generate one for it.
            const { propagationContext: propagationContext } = evt.sdkProcessingMetadata || {};
            const trace = evt.contexts && evt.contexts.trace;
            if (!trace && propagationContext) {
                const { traceId: trace_id, spanId: spanId, parentSpanId: parentSpanId, dsc: dsc } = propagationContext;
                evt.contexts = {
                    trace: {
                        trace_id: trace_id,
                        span_id: spanId,
                        parent_span_id: parentSpanId
                    },
                    ...evt.contexts
                };
                const dynamicSamplingContext = dsc ? dsc : (0, $bPHT6.getDynamicSamplingContextFromClient)(trace_id, this, scope);
                evt.sdkProcessingMetadata = {
                    dynamicSamplingContext: dynamicSamplingContext,
                    ...evt.sdkProcessingMetadata
                };
            }
            return evt;
        });
    }
    /**
   * Processes the event and logs an error in case of rejection
   * @param event
   * @param hint
   * @param scope
   */ _captureEvent(event, hint = {}, scope) {
        return this._processEvent(event, hint, scope).then((finalEvent)=>{
            return finalEvent.event_id;
        }, (reason)=>{
            if (0, $8IHa9.DEBUG_BUILD) {
                // If something's gone wrong, log the error as a warning. If it's just us having used a `SentryError` for
                // control flow, log just the message (no stack) as a log-level log.
                const sentryError = reason;
                if (sentryError.logLevel === "log") (0, $4g0Ct.logger).log(sentryError.message);
                else (0, $4g0Ct.logger).warn(sentryError);
            }
            return undefined;
        });
    }
    /**
   * Processes an event (either error or message) and sends it to Sentry.
   *
   * This also adds breadcrumbs and context information to the event. However,
   * platform specific meta data (such as the User's IP address) must be added
   * by the SDK implementor.
   *
   *
   * @param event The event to send to Sentry.
   * @param hint May contain additional information about the original exception.
   * @param scope A scope containing event metadata.
   * @returns A SyncPromise that resolves with the event or rejects in case event was/will not be send.
   */ _processEvent(event, hint, scope) {
        const options = this.getOptions();
        const { sampleRate: sampleRate } = options;
        const isTransaction = $5d4a5f71b683f78e$var$isTransactionEvent(event);
        const isError = $5d4a5f71b683f78e$var$isErrorEvent(event);
        const eventType = event.type || "error";
        const beforeSendLabel = `before send for type \`${eventType}\``;
        // 1.0 === 100% events are sent
        // 0.0 === 0% events are sent
        // Sampling for transaction happens somewhere else
        if (isError && typeof sampleRate === "number" && Math.random() > sampleRate) {
            this.recordDroppedEvent("sample_rate", "error", event);
            return (0, $j3a3y.rejectedSyncPromise)(new (0, $890c53ca2f6b4a7a$export$5949942ba2a7c0e2)(`Discarding event because it's not included in the random sample (sampling rate = ${sampleRate})`, "log"));
        }
        const dataCategory = eventType === "replay_event" ? "replay" : eventType;
        return this._prepareEvent(event, hint, scope).then((prepared)=>{
            if (prepared === null) {
                this.recordDroppedEvent("event_processor", dataCategory, event);
                throw new (0, $890c53ca2f6b4a7a$export$5949942ba2a7c0e2)("An event processor returned `null`, will not send event.", "log");
            }
            const isInternalException = hint.data && hint.data.__sentry__ === true;
            if (isInternalException) return prepared;
            const result = $5d4a5f71b683f78e$var$processBeforeSend(options, prepared, hint);
            return $5d4a5f71b683f78e$var$_validateBeforeSendResult(result, beforeSendLabel);
        }).then((processedEvent)=>{
            if (processedEvent === null) {
                this.recordDroppedEvent("before_send", dataCategory, event);
                throw new (0, $890c53ca2f6b4a7a$export$5949942ba2a7c0e2)(`${beforeSendLabel} returned \`null\`, will not send event.`, "log");
            }
            const session = scope && scope.getSession();
            if (!isTransaction && session) this._updateSessionFromEvent(session, processedEvent);
            // None of the Sentry built event processor will update transaction name,
            // so if the transaction name has been changed by an event processor, we know
            // it has to come from custom event processor added by a user
            const transactionInfo = processedEvent.transaction_info;
            if (isTransaction && transactionInfo && processedEvent.transaction !== event.transaction) {
                const source = "custom";
                processedEvent.transaction_info = {
                    ...transactionInfo,
                    source: source
                };
            }
            this.sendEvent(processedEvent, hint);
            return processedEvent;
        }).then(null, (reason)=>{
            if (reason instanceof (0, $890c53ca2f6b4a7a$export$5949942ba2a7c0e2)) throw reason;
            this.captureException(reason, {
                data: {
                    __sentry__: true
                },
                originalException: reason
            });
            throw new (0, $890c53ca2f6b4a7a$export$5949942ba2a7c0e2)(`Event processing pipeline threw an error, original event will not be sent. Details have been sent as a new event.\nReason: ${reason}`);
        });
    }
    /**
   * Occupies the client with processing and event
   */ _process(promise) {
        this._numProcessing++;
        promise.then((value)=>{
            this._numProcessing--;
            return value;
        }, (reason)=>{
            this._numProcessing--;
            return reason;
        });
    }
    /**
   * @inheritdoc
   */ _sendEnvelope(envelope) {
        this.emit("beforeEnvelope", envelope);
        if (this._isEnabled() && this._transport) return this._transport.send(envelope).then(null, (reason)=>{
            (0, $8IHa9.DEBUG_BUILD) && (0, $4g0Ct.logger).error("Error while sending event:", reason);
        });
        else (0, $8IHa9.DEBUG_BUILD) && (0, $4g0Ct.logger).error("Transport disabled");
    }
    /**
   * Clears outcomes on this client and returns them.
   */ _clearOutcomes() {
        const outcomes = this._outcomes;
        this._outcomes = {};
        return Object.keys(outcomes).map((key)=>{
            const [reason, category] = key.split(":");
            return {
                reason: reason,
                category: category,
                quantity: outcomes[key]
            };
        });
    }
}
/**
 * Verifies that return value of configured `beforeSend` or `beforeSendTransaction` is of expected type, and returns the value if so.
 */ function $5d4a5f71b683f78e$var$_validateBeforeSendResult(beforeSendResult, beforeSendLabel) {
    const invalidValueError = `${beforeSendLabel} must return \`null\` or a valid event.`;
    if ((0, $2zW56.isThenable)(beforeSendResult)) return beforeSendResult.then((event)=>{
        if (!(0, $2zW56.isPlainObject)(event) && event !== null) throw new (0, $890c53ca2f6b4a7a$export$5949942ba2a7c0e2)(invalidValueError);
        return event;
    }, (e)=>{
        throw new (0, $890c53ca2f6b4a7a$export$5949942ba2a7c0e2)(`${beforeSendLabel} rejected with ${e}`);
    });
    else if (!(0, $2zW56.isPlainObject)(beforeSendResult) && beforeSendResult !== null) throw new (0, $890c53ca2f6b4a7a$export$5949942ba2a7c0e2)(invalidValueError);
    return beforeSendResult;
}
/**
 * Process the matching `beforeSendXXX` callback.
 */ function $5d4a5f71b683f78e$var$processBeforeSend(options, event, hint) {
    const { beforeSend: beforeSend, beforeSendTransaction: beforeSendTransaction } = options;
    if ($5d4a5f71b683f78e$var$isErrorEvent(event) && beforeSend) return beforeSend(event, hint);
    if ($5d4a5f71b683f78e$var$isTransactionEvent(event) && beforeSendTransaction) return beforeSendTransaction(event, hint);
    return event;
}
function $5d4a5f71b683f78e$var$isErrorEvent(event) {
    return event.type === undefined;
}
function $5d4a5f71b683f78e$var$isTransactionEvent(event) {
    return event.type === "transaction";
}
/**
 * Add an event processor to the current client.
 * This event processor will run for all events processed by this client.
 */ function $5d4a5f71b683f78e$export$9aac0b9f77928fbf(callback) {
    const client = (0, $cmFjP.getCurrentHub)().getClient();
    if (!client || !client.addEventProcessor) return;
    client.addEventProcessor(callback);
}


var $9OAWn = parcelRequire("9OAWn");


var $cvSY8 = parcelRequire("cvSY8");
/**
 * Creates client report envelope
 * @param discarded_events An array of discard events
 * @param dsn A DSN that can be set on the header. Optional.
 */ function $d90c5d9ac5d72442$export$f3b9ed77c03eeb00(discarded_events, dsn, timestamp) {
    const clientReportItem = [
        {
            type: "client_report"
        },
        {
            timestamp: timestamp || (0, $cvSY8.dateTimestampInSeconds)(),
            discarded_events: discarded_events
        }
    ];
    return (0, $2cae643f899492f0$export$f93f7f385160c44e)(dsn ? {
        dsn: dsn
    } : {}, [
        clientReportItem
    ]);
}


var $Wgg6o = parcelRequire("Wgg6o");
var $4g0Ct = parcelRequire("4g0Ct");
/**
 * This serves as a build time flag that will be true by default, but false in non-debug builds or if users replace `__SENTRY_DEBUG__` in their generated code.
 *
 * ATTENTION: This constant must never cross package boundaries (i.e. be exported) to guarantee that it can be used for tree shaking.
 */ const $817d897c5dc6d664$export$16a28057038b10ef = typeof __SENTRY_DEBUG__ === "undefined" || __SENTRY_DEBUG__;



var $cmFjP = parcelRequire("cmFjP");

var $b1E2c = parcelRequire("b1E2c");
var $jL8lq = parcelRequire("jL8lq");
var $2zW56 = parcelRequire("2zW56");
var $drMc1 = parcelRequire("drMc1");
var $j3a3y = parcelRequire("j3a3y");
/**
 * This function creates an exception from a JavaScript Error
 */ function $230372ac01587541$export$a6c2d27607295951(stackParser, ex) {
    // Get the frames first since Opera can lose the stack if we touch anything else first
    const frames = $230372ac01587541$export$d478b2c12fbcfdda(stackParser, ex);
    const exception = {
        type: ex && ex.name,
        value: $230372ac01587541$var$extractMessage(ex)
    };
    if (frames.length) exception.stacktrace = {
        frames: frames
    };
    if (exception.type === undefined && exception.value === "") exception.value = "Unrecoverable error caught";
    return exception;
}
/**
 * @hidden
 */ function $230372ac01587541$export$a6a5dd73e489caf(stackParser, exception, syntheticException, isUnhandledRejection) {
    const hub = (0, $cmFjP.getCurrentHub)();
    const client = hub.getClient();
    const normalizeDepth = client && client.getOptions().normalizeDepth;
    const event = {
        exception: {
            values: [
                {
                    type: (0, $2zW56.isEvent)(exception) ? exception.constructor.name : isUnhandledRejection ? "UnhandledRejection" : "Error",
                    value: $230372ac01587541$var$getNonErrorObjectExceptionValue(exception, {
                        isUnhandledRejection: isUnhandledRejection
                    })
                }
            ]
        },
        extra: {
            __serialized__: (0, $drMc1.normalizeToSize)(exception, normalizeDepth)
        }
    };
    if (syntheticException) {
        const frames = $230372ac01587541$export$d478b2c12fbcfdda(stackParser, syntheticException);
        if (frames.length) // event.exception.values[0] has been set above
        event.exception.values[0].stacktrace = {
            frames: frames
        };
    }
    return event;
}
/**
 * @hidden
 */ function $230372ac01587541$export$73fbea5a0a5234af(stackParser, ex) {
    return {
        exception: {
            values: [
                $230372ac01587541$export$a6c2d27607295951(stackParser, ex)
            ]
        }
    };
}
/** Parses stack frames from an error */ function $230372ac01587541$export$d478b2c12fbcfdda(stackParser, ex) {
    // Access and store the stacktrace property before doing ANYTHING
    // else to it because Opera is not very good at providing it
    // reliably in other circumstances.
    const stacktrace = ex.stacktrace || ex.stack || "";
    const popSize = $230372ac01587541$var$getPopSize(ex);
    try {
        return stackParser(stacktrace, popSize);
    } catch (e) {
    // no-empty
    }
    return [];
}
// Based on our own mapping pattern - https://github.com/getsentry/sentry/blob/9f08305e09866c8bd6d0c24f5b0aabdd7dd6c59c/src/sentry/lang/javascript/errormapping.py#L83-L108
const $230372ac01587541$var$reactMinifiedRegexp = /Minified React error #\d+;/i;
function $230372ac01587541$var$getPopSize(ex) {
    if (ex) {
        if (typeof ex.framesToPop === "number") return ex.framesToPop;
        if ($230372ac01587541$var$reactMinifiedRegexp.test(ex.message)) return 1;
    }
    return 0;
}
/**
 * There are cases where stacktrace.message is an Event object
 * https://github.com/getsentry/sentry-javascript/issues/1949
 * In this specific case we try to extract stacktrace.message.error.message
 */ function $230372ac01587541$var$extractMessage(ex) {
    const message = ex && ex.message;
    if (!message) return "No error message";
    if (message.error && typeof message.error.message === "string") return message.error.message;
    return message;
}
/**
 * Creates an {@link Event} from all inputs to `captureException` and non-primitive inputs to `captureMessage`.
 * @hidden
 */ function $230372ac01587541$export$ea3ec7e569b823fc(stackParser, exception, hint, attachStacktrace) {
    const syntheticException = hint && hint.syntheticException || undefined;
    const event = $230372ac01587541$export$9dd56ed1ef0c3420(stackParser, exception, syntheticException, attachStacktrace);
    (0, $b1E2c.addExceptionMechanism)(event); // defaults to { type: 'generic', handled: true }
    event.level = "error";
    if (hint && hint.event_id) event.event_id = hint.event_id;
    return (0, $j3a3y.resolvedSyncPromise)(event);
}
/**
 * Builds and Event from a Message
 * @hidden
 */ function $230372ac01587541$export$5425b53185d13d6c(stackParser, message, // eslint-disable-next-line deprecation/deprecation
level = "info", hint, attachStacktrace) {
    const syntheticException = hint && hint.syntheticException || undefined;
    const event = $230372ac01587541$export$47d86ae4b3c9994(stackParser, message, syntheticException, attachStacktrace);
    event.level = level;
    if (hint && hint.event_id) event.event_id = hint.event_id;
    return (0, $j3a3y.resolvedSyncPromise)(event);
}
/**
 * @hidden
 */ function $230372ac01587541$export$9dd56ed1ef0c3420(stackParser, exception, syntheticException, attachStacktrace, isUnhandledRejection) {
    let event;
    if ((0, $2zW56.isErrorEvent)(exception) && exception.error) {
        // If it is an ErrorEvent with `error` property, extract it to get actual Error
        const errorEvent = exception;
        return $230372ac01587541$export$73fbea5a0a5234af(stackParser, errorEvent.error);
    }
    // If it is a `DOMError` (which is a legacy API, but still supported in some browsers) then we just extract the name
    // and message, as it doesn't provide anything else. According to the spec, all `DOMExceptions` should also be
    // `Error`s, but that's not the case in IE11, so in that case we treat it the same as we do a `DOMError`.
    //
    // https://developer.mozilla.org/en-US/docs/Web/API/DOMError
    // https://developer.mozilla.org/en-US/docs/Web/API/DOMException
    // https://webidl.spec.whatwg.org/#es-DOMException-specialness
    if ((0, $2zW56.isDOMError)(exception) || (0, $2zW56.isDOMException)(exception)) {
        const domException = exception;
        if ("stack" in exception) event = $230372ac01587541$export$73fbea5a0a5234af(stackParser, exception);
        else {
            const name = domException.name || ((0, $2zW56.isDOMError)(domException) ? "DOMError" : "DOMException");
            const message = domException.message ? `${name}: ${domException.message}` : name;
            event = $230372ac01587541$export$47d86ae4b3c9994(stackParser, message, syntheticException, attachStacktrace);
            (0, $b1E2c.addExceptionTypeValue)(event, message);
        }
        if ("code" in domException) // eslint-disable-next-line deprecation/deprecation
        event.tags = {
            ...event.tags,
            "DOMException.code": `${domException.code}`
        };
        return event;
    }
    if ((0, $2zW56.isError)(exception)) // we have a real Error object, do nothing
    return $230372ac01587541$export$73fbea5a0a5234af(stackParser, exception);
    if ((0, $2zW56.isPlainObject)(exception) || (0, $2zW56.isEvent)(exception)) {
        // If it's a plain object or an instance of `Event` (the built-in JS kind, not this SDK's `Event` type), serialize
        // it manually. This will allow us to group events based on top-level keys which is much better than creating a new
        // group on any key/value change.
        const objectException = exception;
        event = $230372ac01587541$export$a6a5dd73e489caf(stackParser, objectException, syntheticException, isUnhandledRejection);
        (0, $b1E2c.addExceptionMechanism)(event, {
            synthetic: true
        });
        return event;
    }
    // If none of previous checks were valid, then it means that it's not:
    // - an instance of DOMError
    // - an instance of DOMException
    // - an instance of Event
    // - an instance of Error
    // - a valid ErrorEvent (one with an error property)
    // - a plain Object
    //
    // So bail out and capture it as a simple message:
    event = $230372ac01587541$export$47d86ae4b3c9994(stackParser, exception, syntheticException, attachStacktrace);
    (0, $b1E2c.addExceptionTypeValue)(event, `${exception}`, undefined);
    (0, $b1E2c.addExceptionMechanism)(event, {
        synthetic: true
    });
    return event;
}
/**
 * @hidden
 */ function $230372ac01587541$export$47d86ae4b3c9994(stackParser, input, syntheticException, attachStacktrace) {
    const event = {
        message: input
    };
    if (attachStacktrace && syntheticException) {
        const frames = $230372ac01587541$export$d478b2c12fbcfdda(stackParser, syntheticException);
        if (frames.length) event.exception = {
            values: [
                {
                    value: input,
                    stacktrace: {
                        frames: frames
                    }
                }
            ]
        };
    }
    return event;
}
function $230372ac01587541$var$getNonErrorObjectExceptionValue(exception, { isUnhandledRejection: isUnhandledRejection }) {
    const keys = (0, $jL8lq.extractExceptionKeysForMessage)(exception);
    const captureType = isUnhandledRejection ? "promise rejection" : "exception";
    // Some ErrorEvent instances do not have an `error` property, which is why they are not handled before
    // We still want to try to get a decent message for these cases
    if ((0, $2zW56.isErrorEvent)(exception)) return `Event \`ErrorEvent\` captured as ${captureType} with message \`${exception.message}\``;
    if ((0, $2zW56.isEvent)(exception)) {
        const className = $230372ac01587541$var$getObjectClassName(exception);
        return `Event \`${className}\` (type=${exception.type}) captured as ${captureType}`;
    }
    return `Object captured as ${captureType} with keys: ${keys}`;
}
function $230372ac01587541$var$getObjectClassName(obj) {
    try {
        const prototype = Object.getPrototypeOf(obj);
        return prototype ? prototype.constructor.name : undefined;
    } catch (e) {
    // ignore errors here
    }
}



var $b8438 = parcelRequire("b8438");

var $b1E2c = parcelRequire("b1E2c");
var $jL8lq = parcelRequire("jL8lq");
var $3bpJ1 = parcelRequire("3bpJ1");
const $4e817323ced6d78c$export$56d8a8a25bd48b81 = (0, $3bpJ1.GLOBAL_OBJ);
let $4e817323ced6d78c$var$ignoreOnError = 0;
/**
 * @hidden
 */ function $4e817323ced6d78c$export$b79738ab10c590b2() {
    return $4e817323ced6d78c$var$ignoreOnError > 0;
}
/**
 * @hidden
 */ function $4e817323ced6d78c$export$1265a142ff5ba165() {
    // onerror should trigger before setTimeout
    $4e817323ced6d78c$var$ignoreOnError++;
    setTimeout(()=>{
        $4e817323ced6d78c$var$ignoreOnError--;
    });
}
/**
 * Instruments the given function and sends an event to Sentry every time the
 * function throws an exception.
 *
 * @param fn A function to wrap. It is generally safe to pass an unbound function, because the returned wrapper always
 * has a correct `this` context.
 * @returns The wrapped function.
 * @hidden
 */ function $4e817323ced6d78c$export$4997ffc0176396a6(fn, options = {}, before) {
    // for future readers what this does is wrap a function and then create
    // a bi-directional wrapping between them.
    //
    // example: wrapped = wrap(original);
    //  original.__sentry_wrapped__ -> wrapped
    //  wrapped.__sentry_original__ -> original
    if (typeof fn !== "function") return fn;
    try {
        // if we're dealing with a function that was previously wrapped, return
        // the original wrapper.
        const wrapper = fn.__sentry_wrapped__;
        if (wrapper) return wrapper;
        // We don't wanna wrap it twice
        if ((0, $jL8lq.getOriginalFunction)(fn)) return fn;
    } catch (e) {
        // Just accessing custom props in some Selenium environments
        // can cause a "Permission denied" exception (see raven-js#495).
        // Bail on wrapping and return the function as-is (defers to window.onerror).
        return fn;
    }
    /* eslint-disable prefer-rest-params */ // It is important that `sentryWrapped` is not an arrow function to preserve the context of `this`
    const sentryWrapped = function() {
        const args = Array.prototype.slice.call(arguments);
        try {
            if (before && typeof before === "function") before.apply(this, arguments);
            // eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/no-unsafe-member-access
            const wrappedArguments = args.map((arg)=>$4e817323ced6d78c$export$4997ffc0176396a6(arg, options));
            // Attempt to invoke user-land function
            // NOTE: If you are a Sentry user, and you are seeing this stack frame, it
            //       means the sentry.javascript SDK caught an error invoking your application code. This
            //       is expected behavior and NOT indicative of a bug with sentry.javascript.
            return fn.apply(this, wrappedArguments);
        } catch (ex) {
            $4e817323ced6d78c$export$1265a142ff5ba165();
            (0, $b8438.withScope)((scope)=>{
                scope.addEventProcessor((event)=>{
                    if (options.mechanism) {
                        (0, $b1E2c.addExceptionTypeValue)(event, undefined, undefined);
                        (0, $b1E2c.addExceptionMechanism)(event, options.mechanism);
                    }
                    event.extra = {
                        ...event.extra,
                        arguments: args
                    };
                    return event;
                });
                (0, $b8438.captureException)(ex);
            });
            throw ex;
        }
    };
    /* eslint-enable prefer-rest-params */ // Accessing some objects may throw
    // ref: https://github.com/getsentry/sentry-javascript/issues/1168
    try {
        for(const property in fn)if (Object.prototype.hasOwnProperty.call(fn, property)) sentryWrapped[property] = fn[property];
    } catch (_oO) {} // eslint-disable-line no-empty
    // Signal that this function has been wrapped/filled already
    // for both debugging and to prevent it to being wrapped/filled twice
    (0, $jL8lq.markFunctionWrapped)(sentryWrapped, fn);
    (0, $jL8lq.addNonEnumerableProperty)(fn, "__sentry_wrapped__", sentryWrapped);
    // Restore original function name (not all browsers allow that)
    try {
        const descriptor = Object.getOwnPropertyDescriptor(sentryWrapped, "name");
        if (descriptor.configurable) Object.defineProperty(sentryWrapped, "name", {
            get () {
                return fn.name;
            }
        });
    // eslint-disable-next-line no-empty
    } catch (_oO) {}
    return sentryWrapped;
}



/**
 * Creates an envelope from a user feedback.
 */ function $b03dbb36f8019264$export$24a4dfcb686ee5bf(feedback, { metadata: metadata, tunnel: tunnel, dsn: dsn }) {
    const headers = {
        event_id: feedback.event_id,
        sent_at: new Date().toISOString(),
        ...metadata && metadata.sdk && {
            sdk: {
                name: metadata.sdk.name,
                version: metadata.sdk.version
            }
        },
        ...!!tunnel && !!dsn && {
            dsn: (0, $f7133678d936cd5e$export$44d472fbb931a776)(dsn)
        }
    };
    const item = $b03dbb36f8019264$var$createUserFeedbackEnvelopeItem(feedback);
    return (0, $2cae643f899492f0$export$f93f7f385160c44e)(headers, [
        item
    ]);
}
function $b03dbb36f8019264$var$createUserFeedbackEnvelopeItem(feedback) {
    const feedbackHeaders = {
        type: "user_report"
    };
    return [
        feedbackHeaders,
        feedback
    ];
}


/**
 * Configuration options for the Sentry Browser SDK.
 * @see @sentry/types Options for more information.
 */ /**
 * The Sentry Browser SDK Client.
 *
 * @see BrowserOptions for documentation on configuration options.
 * @see SentryClient for usage documentation.
 */ class $c55795097f9daeb0$export$1df9218a526d318d extends (0, $5d4a5f71b683f78e$export$4f22f74eddb7716a) {
    /**
   * Creates a new Browser SDK instance.
   *
   * @param options Configuration options for this SDK.
   */ constructor(options){
        const sdkSource = (0, $4e817323ced6d78c$export$56d8a8a25bd48b81).SENTRY_SDK_SOURCE || (0, $Wgg6o.getSDKSource)();
        options._metadata = options._metadata || {};
        options._metadata.sdk = options._metadata.sdk || {
            name: "sentry.javascript.browser",
            packages: [
                {
                    name: `${sdkSource}:@sentry/browser`,
                    version: (0, $9OAWn.SDK_VERSION)
                }
            ],
            version: (0, $9OAWn.SDK_VERSION)
        };
        super(options);
        if (options.sendClientReports && (0, $4e817323ced6d78c$export$56d8a8a25bd48b81).document) (0, $4e817323ced6d78c$export$56d8a8a25bd48b81).document.addEventListener("visibilitychange", ()=>{
            if ((0, $4e817323ced6d78c$export$56d8a8a25bd48b81).document.visibilityState === "hidden") this._flushOutcomes();
        });
    }
    /**
   * @inheritDoc
   */ eventFromException(exception, hint) {
        return (0, $230372ac01587541$export$ea3ec7e569b823fc)(this._options.stackParser, exception, hint, this._options.attachStacktrace);
    }
    /**
   * @inheritDoc
   */ eventFromMessage(message, // eslint-disable-next-line deprecation/deprecation
    level = "info", hint) {
        return (0, $230372ac01587541$export$5425b53185d13d6c)(this._options.stackParser, message, level, hint, this._options.attachStacktrace);
    }
    /**
   * Sends user feedback to Sentry.
   */ captureUserFeedback(feedback) {
        if (!this._isEnabled()) {
            (0, $817d897c5dc6d664$export$16a28057038b10ef) && (0, $4g0Ct.logger).warn("SDK not enabled, will not capture user feedback.");
            return;
        }
        const envelope = (0, $b03dbb36f8019264$export$24a4dfcb686ee5bf)(feedback, {
            metadata: this.getSdkMetadata(),
            dsn: this.getDsn(),
            tunnel: this.getOptions().tunnel
        });
        this._sendEnvelope(envelope);
    }
    /**
   * @inheritDoc
   */ _prepareEvent(event, hint, scope) {
        event.platform = event.platform || "javascript";
        return super._prepareEvent(event, hint, scope);
    }
    /**
   * Sends client reports as an envelope.
   */ _flushOutcomes() {
        const outcomes = this._clearOutcomes();
        if (outcomes.length === 0) {
            (0, $817d897c5dc6d664$export$16a28057038b10ef) && (0, $4g0Ct.logger).log("No outcomes to send");
            return;
        }
        // This is really the only place where we want to check for a DSN and only send outcomes then
        if (!this._dsn) {
            (0, $817d897c5dc6d664$export$16a28057038b10ef) && (0, $4g0Ct.logger).log("No dsn provided, will not send outcomes");
            return;
        }
        (0, $817d897c5dc6d664$export$16a28057038b10ef) && (0, $4g0Ct.logger).log("Sending outcomes:", outcomes);
        const envelope = (0, $d90c5d9ac5d72442$export$f3b9ed77c03eeb00)(outcomes, this._options.tunnel && (0, $f7133678d936cd5e$export$44d472fbb931a776)(this._dsn));
        this._sendEnvelope(envelope);
    }
}





var $cmFjP = parcelRequire("cmFjP");

var $isDtX = parcelRequire("isDtX");
var $e5Ga6 = parcelRequire("e5Ga6");
var $ibKgU = parcelRequire("ibKgU");
var $2zW56 = parcelRequire("2zW56");
var $4g0Ct = parcelRequire("4g0Ct");



/* eslint-disable @typescript-eslint/no-unsafe-member-access */ /** Global handlers */ class $9d72a78ef45a7c39$export$204155decbc90e5a {
    /**
   * @inheritDoc
   */ static __initStatic() {
        this.id = "GlobalHandlers";
    }
    /**
   * @inheritDoc
   */ /** JSDoc */ /**
   * Stores references functions to installing handlers. Will set to undefined
   * after they have been run so that they are not used twice.
   */ /** JSDoc */ constructor(options){
        this.name = $9d72a78ef45a7c39$export$204155decbc90e5a.id;
        this._options = {
            onerror: true,
            onunhandledrejection: true,
            ...options
        };
        this._installFunc = {
            onerror: $9d72a78ef45a7c39$var$_installGlobalOnErrorHandler,
            onunhandledrejection: $9d72a78ef45a7c39$var$_installGlobalOnUnhandledRejectionHandler
        };
    }
    /**
   * @inheritDoc
   */ setupOnce() {
        Error.stackTraceLimit = 50;
        const options = this._options;
        // We can disable guard-for-in as we construct the options object above + do checks against
        // `this._installFunc` for the property.
        // eslint-disable-next-line guard-for-in
        for(const key in options){
            const installFunc = this._installFunc[key];
            if (installFunc && options[key]) {
                $9d72a78ef45a7c39$var$globalHandlerLog(key);
                installFunc();
                this._installFunc[key] = undefined;
            }
        }
    }
}
$9d72a78ef45a7c39$export$204155decbc90e5a.__initStatic();
function $9d72a78ef45a7c39$var$_installGlobalOnErrorHandler() {
    (0, $isDtX.addGlobalErrorInstrumentationHandler)((data)=>{
        const [hub, stackParser, attachStacktrace] = $9d72a78ef45a7c39$var$getHubAndOptions();
        if (!hub.getIntegration($9d72a78ef45a7c39$export$204155decbc90e5a)) return;
        const { msg: msg, url: url, line: line, column: column, error: error } = data;
        if ((0, $4e817323ced6d78c$export$b79738ab10c590b2)()) return;
        const event = error === undefined && (0, $2zW56.isString)(msg) ? $9d72a78ef45a7c39$var$_eventFromIncompleteOnError(msg, url, line, column) : $9d72a78ef45a7c39$var$_enhanceEventWithInitialFrame((0, $230372ac01587541$export$9dd56ed1ef0c3420)(stackParser, error || msg, undefined, attachStacktrace, false), url, line, column);
        event.level = "error";
        hub.captureEvent(event, {
            originalException: error,
            mechanism: {
                handled: false,
                type: "onerror"
            }
        });
    });
}
function $9d72a78ef45a7c39$var$_installGlobalOnUnhandledRejectionHandler() {
    (0, $e5Ga6.addGlobalUnhandledRejectionInstrumentationHandler)((e)=>{
        const [hub, stackParser, attachStacktrace] = $9d72a78ef45a7c39$var$getHubAndOptions();
        if (!hub.getIntegration($9d72a78ef45a7c39$export$204155decbc90e5a)) return;
        if ((0, $4e817323ced6d78c$export$b79738ab10c590b2)()) return true;
        const error = $9d72a78ef45a7c39$var$_getUnhandledRejectionError(e);
        const event = (0, $2zW56.isPrimitive)(error) ? $9d72a78ef45a7c39$var$_eventFromRejectionWithPrimitive(error) : (0, $230372ac01587541$export$9dd56ed1ef0c3420)(stackParser, error, undefined, attachStacktrace, true);
        event.level = "error";
        hub.captureEvent(event, {
            originalException: error,
            mechanism: {
                handled: false,
                type: "onunhandledrejection"
            }
        });
        return;
    });
}
function $9d72a78ef45a7c39$var$_getUnhandledRejectionError(error) {
    if ((0, $2zW56.isPrimitive)(error)) return error;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const e = error;
    // dig the object of the rejection out of known event types
    try {
        // PromiseRejectionEvents store the object of the rejection under 'reason'
        // see https://developer.mozilla.org/en-US/docs/Web/API/PromiseRejectionEvent
        if ("reason" in e) return e.reason;
        else if ("detail" in e && "reason" in e.detail) return e.detail.reason;
    } catch (e2) {} // eslint-disable-line no-empty
    return error;
}
/**
 * Create an event from a promise rejection where the `reason` is a primitive.
 *
 * @param reason: The `reason` property of the promise rejection
 * @returns An Event object with an appropriate `exception` value
 */ function $9d72a78ef45a7c39$var$_eventFromRejectionWithPrimitive(reason) {
    return {
        exception: {
            values: [
                {
                    type: "UnhandledRejection",
                    // String() is needed because the Primitive type includes symbols (which can't be automatically stringified)
                    value: `Non-Error promise rejection captured with value: ${String(reason)}`
                }
            ]
        }
    };
}
/**
 * This function creates a stack from an old, error-less onerror handler.
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function $9d72a78ef45a7c39$var$_eventFromIncompleteOnError(msg, url, line, column) {
    const ERROR_TYPES_RE = /^(?:[Uu]ncaught (?:exception: )?)?(?:((?:Eval|Internal|Range|Reference|Syntax|Type|URI|)Error): )?(.*)$/i;
    // If 'message' is ErrorEvent, get real message from inside
    let message = (0, $2zW56.isErrorEvent)(msg) ? msg.message : msg;
    let name = "Error";
    const groups = message.match(ERROR_TYPES_RE);
    if (groups) {
        name = groups[1];
        message = groups[2];
    }
    const event = {
        exception: {
            values: [
                {
                    type: name,
                    value: message
                }
            ]
        }
    };
    return $9d72a78ef45a7c39$var$_enhanceEventWithInitialFrame(event, url, line, column);
}
/** JSDoc */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function $9d72a78ef45a7c39$var$_enhanceEventWithInitialFrame(event, url, line, column) {
    // event.exception
    const e = event.exception = event.exception || {};
    // event.exception.values
    const ev = e.values = e.values || [];
    // event.exception.values[0]
    const ev0 = ev[0] = ev[0] || {};
    // event.exception.values[0].stacktrace
    const ev0s = ev0.stacktrace = ev0.stacktrace || {};
    // event.exception.values[0].stacktrace.frames
    const ev0sf = ev0s.frames = ev0s.frames || [];
    const colno = isNaN(parseInt(column, 10)) ? undefined : column;
    const lineno = isNaN(parseInt(line, 10)) ? undefined : line;
    const filename = (0, $2zW56.isString)(url) && url.length > 0 ? url : (0, $ibKgU.getLocationHref)();
    // event.exception.values[0].stacktrace.frames
    if (ev0sf.length === 0) ev0sf.push({
        colno: colno,
        filename: filename,
        function: "?",
        in_app: true,
        lineno: lineno
    });
    return event;
}
function $9d72a78ef45a7c39$var$globalHandlerLog(type) {
    (0, $817d897c5dc6d664$export$16a28057038b10ef) && (0, $4g0Ct.logger).log(`Global Handler attached: ${type}`);
}
function $9d72a78ef45a7c39$var$getHubAndOptions() {
    const hub = (0, $cmFjP.getCurrentHub)();
    const client = hub.getClient();
    const options = client && client.getOptions() || {
        stackParser: ()=>[],
        attachStacktrace: false
    };
    return [
        hub,
        options.stackParser,
        options.attachStacktrace
    ];
}



var $jL8lq = parcelRequire("jL8lq");
var $16dZf = parcelRequire("16dZf");

const $f8ac3caec1ed9186$var$DEFAULT_EVENT_TARGET = [
    "EventTarget",
    "Window",
    "Node",
    "ApplicationCache",
    "AudioTrackList",
    "BroadcastChannel",
    "ChannelMergerNode",
    "CryptoOperation",
    "EventSource",
    "FileReader",
    "HTMLUnknownElement",
    "IDBDatabase",
    "IDBRequest",
    "IDBTransaction",
    "KeyOperation",
    "MediaController",
    "MessagePort",
    "ModalWindow",
    "Notification",
    "SVGElementInstance",
    "Screen",
    "SharedWorker",
    "TextTrack",
    "TextTrackCue",
    "TextTrackList",
    "WebSocket",
    "WebSocketWorker",
    "Worker",
    "XMLHttpRequest",
    "XMLHttpRequestEventTarget",
    "XMLHttpRequestUpload"
];
/** Wrap timer functions and event targets to catch errors and provide better meta data */ class $f8ac3caec1ed9186$export$f1a018517668e6d3 {
    /**
   * @inheritDoc
   */ static __initStatic() {
        this.id = "TryCatch";
    }
    /**
   * @inheritDoc
   */ /** JSDoc */ /**
   * @inheritDoc
   */ constructor(options){
        this.name = $f8ac3caec1ed9186$export$f1a018517668e6d3.id;
        this._options = {
            XMLHttpRequest: true,
            eventTarget: true,
            requestAnimationFrame: true,
            setInterval: true,
            setTimeout: true,
            ...options
        };
    }
    /**
   * Wrap timer functions and event targets to catch errors
   * and provide better metadata.
   */ setupOnce() {
        if (this._options.setTimeout) (0, $jL8lq.fill)((0, $4e817323ced6d78c$export$56d8a8a25bd48b81), "setTimeout", $f8ac3caec1ed9186$var$_wrapTimeFunction);
        if (this._options.setInterval) (0, $jL8lq.fill)((0, $4e817323ced6d78c$export$56d8a8a25bd48b81), "setInterval", $f8ac3caec1ed9186$var$_wrapTimeFunction);
        if (this._options.requestAnimationFrame) (0, $jL8lq.fill)((0, $4e817323ced6d78c$export$56d8a8a25bd48b81), "requestAnimationFrame", $f8ac3caec1ed9186$var$_wrapRAF);
        if (this._options.XMLHttpRequest && "XMLHttpRequest" in (0, $4e817323ced6d78c$export$56d8a8a25bd48b81)) (0, $jL8lq.fill)(XMLHttpRequest.prototype, "send", $f8ac3caec1ed9186$var$_wrapXHR);
        const eventTargetOption = this._options.eventTarget;
        if (eventTargetOption) {
            const eventTarget = Array.isArray(eventTargetOption) ? eventTargetOption : $f8ac3caec1ed9186$var$DEFAULT_EVENT_TARGET;
            eventTarget.forEach($f8ac3caec1ed9186$var$_wrapEventTarget);
        }
    }
}
$f8ac3caec1ed9186$export$f1a018517668e6d3.__initStatic();
/** JSDoc */ function $f8ac3caec1ed9186$var$_wrapTimeFunction(original) {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return function(...args) {
        const originalCallback = args[0];
        args[0] = (0, $4e817323ced6d78c$export$4997ffc0176396a6)(originalCallback, {
            mechanism: {
                data: {
                    function: (0, $16dZf.getFunctionName)(original)
                },
                handled: false,
                type: "instrument"
            }
        });
        return original.apply(this, args);
    };
}
/** JSDoc */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function $f8ac3caec1ed9186$var$_wrapRAF(original) {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return function(callback) {
        // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
        return original.apply(this, [
            (0, $4e817323ced6d78c$export$4997ffc0176396a6)(callback, {
                mechanism: {
                    data: {
                        function: "requestAnimationFrame",
                        handler: (0, $16dZf.getFunctionName)(original)
                    },
                    handled: false,
                    type: "instrument"
                }
            })
        ]);
    };
}
/** JSDoc */ function $f8ac3caec1ed9186$var$_wrapXHR(originalSend) {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return function(...args) {
        // eslint-disable-next-line @typescript-eslint/no-this-alias
        const xhr = this;
        const xmlHttpRequestProps = [
            "onload",
            "onerror",
            "onprogress",
            "onreadystatechange"
        ];
        xmlHttpRequestProps.forEach((prop)=>{
            if (prop in xhr && typeof xhr[prop] === "function") // eslint-disable-next-line @typescript-eslint/no-explicit-any
            (0, $jL8lq.fill)(xhr, prop, function(original) {
                const wrapOptions = {
                    mechanism: {
                        data: {
                            function: prop,
                            handler: (0, $16dZf.getFunctionName)(original)
                        },
                        handled: false,
                        type: "instrument"
                    }
                };
                // If Instrument integration has been called before TryCatch, get the name of original function
                const originalFunction = (0, $jL8lq.getOriginalFunction)(original);
                if (originalFunction) wrapOptions.mechanism.data.handler = (0, $16dZf.getFunctionName)(originalFunction);
                // Otherwise wrap directly
                return (0, $4e817323ced6d78c$export$4997ffc0176396a6)(original, wrapOptions);
            });
        });
        return originalSend.apply(this, args);
    };
}
/** JSDoc */ function $f8ac3caec1ed9186$var$_wrapEventTarget(target) {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const globalObject = (0, $4e817323ced6d78c$export$56d8a8a25bd48b81);
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    const proto = globalObject[target] && globalObject[target].prototype;
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access, no-prototype-builtins
    if (!proto || !proto.hasOwnProperty || !proto.hasOwnProperty("addEventListener")) return;
    (0, $jL8lq.fill)(proto, "addEventListener", function(original) {
        return function(// eslint-disable-next-line @typescript-eslint/no-explicit-any
        eventName, fn, options) {
            try {
                if (typeof fn.handleEvent === "function") // ESlint disable explanation:
                //  First, it is generally safe to call `wrap` with an unbound function. Furthermore, using `.bind()` would
                //  introduce a bug here, because bind returns a new function that doesn't have our
                //  flags(like __sentry_original__) attached. `wrap` checks for those flags to avoid unnecessary wrapping.
                //  Without those flags, every call to addEventListener wraps the function again, causing a memory leak.
                // eslint-disable-next-line @typescript-eslint/unbound-method
                fn.handleEvent = (0, $4e817323ced6d78c$export$4997ffc0176396a6)(fn.handleEvent, {
                    mechanism: {
                        data: {
                            function: "handleEvent",
                            handler: (0, $16dZf.getFunctionName)(fn),
                            target: target
                        },
                        handled: false,
                        type: "instrument"
                    }
                });
            } catch (err) {
            // can sometimes get 'Permission denied to access property "handle Event'
            }
            return original.apply(this, [
                eventName,
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                (0, $4e817323ced6d78c$export$4997ffc0176396a6)(fn, {
                    mechanism: {
                        data: {
                            function: "addEventListener",
                            handler: (0, $16dZf.getFunctionName)(fn),
                            target: target
                        },
                        handled: false,
                        type: "instrument"
                    }
                }),
                options
            ]);
        };
    });
    (0, $jL8lq.fill)(proto, "removeEventListener", function(originalRemoveEventListener) {
        return function(// eslint-disable-next-line @typescript-eslint/no-explicit-any
        eventName, fn, options) {
            /**
         * There are 2 possible scenarios here:
         *
         * 1. Someone passes a callback, which was attached prior to Sentry initialization, or by using unmodified
         * method, eg. `document.addEventListener.call(el, name, handler). In this case, we treat this function
         * as a pass-through, and call original `removeEventListener` with it.
         *
         * 2. Someone passes a callback, which was attached after Sentry was initialized, which means that it was using
         * our wrapped version of `addEventListener`, which internally calls `wrap` helper.
         * This helper "wraps" whole callback inside a try/catch statement, and attached appropriate metadata to it,
         * in order for us to make a distinction between wrapped/non-wrapped functions possible.
         * If a function was wrapped, it has additional property of `__sentry_wrapped__`, holding the handler.
         *
         * When someone adds a handler prior to initialization, and then do it again, but after,
         * then we have to detach both of them. Otherwise, if we'd detach only wrapped one, it'd be impossible
         * to get rid of the initial handler and it'd stick there forever.
         */ const wrappedEventHandler = fn;
            try {
                const originalEventHandler = wrappedEventHandler && wrappedEventHandler.__sentry_wrapped__;
                if (originalEventHandler) originalRemoveEventListener.call(this, eventName, originalEventHandler, options);
            } catch (e) {
            // ignore, accessing __sentry_wrapped__ will throw in some Selenium environments
            }
            return originalRemoveEventListener.call(this, eventName, wrappedEventHandler, options);
        };
    });
}



var $b8438 = parcelRequire("b8438");
var $cmFjP = parcelRequire("cmFjP");

var $b1E2c = parcelRequire("b1E2c");

var $jL8lq = parcelRequire("jL8lq");

var $3bpJ1 = parcelRequire("3bpJ1");

var $dbwHv = parcelRequire("dbwHv");
const $6dad95eb90f2d36c$var$WINDOW = (0, $3bpJ1.GLOBAL_OBJ);
const $6dad95eb90f2d36c$var$DEBOUNCE_DURATION = 1000;
let $6dad95eb90f2d36c$var$debounceTimerID;
let $6dad95eb90f2d36c$var$lastCapturedEventType;
let $6dad95eb90f2d36c$var$lastCapturedEventTargetId;
/**
 * Add an instrumentation handler for when a click or a keypress happens.
 *
 * Use at your own risk, this might break without changelog notice, only used internally.
 * @hidden
 */ function $6dad95eb90f2d36c$export$5aeffd3db2cf9df7(handler) {
    const type = "dom";
    (0, $dbwHv.addHandler)(type, handler);
    (0, $dbwHv.maybeInstrument)(type, $6dad95eb90f2d36c$export$3014bbf0af0e1d4a);
}
/** Exported for tests only. */ function $6dad95eb90f2d36c$export$3014bbf0af0e1d4a() {
    if (!$6dad95eb90f2d36c$var$WINDOW.document) return;
    // Make it so that any click or keypress that is unhandled / bubbled up all the way to the document triggers our dom
    // handlers. (Normally we have only one, which captures a breadcrumb for each click or keypress.) Do this before
    // we instrument `addEventListener` so that we don't end up attaching this handler twice.
    const triggerDOMHandler = (0, $dbwHv.triggerHandlers).bind(null, "dom");
    const globalDOMEventHandler = $6dad95eb90f2d36c$var$makeDOMEventHandler(triggerDOMHandler, true);
    $6dad95eb90f2d36c$var$WINDOW.document.addEventListener("click", globalDOMEventHandler, false);
    $6dad95eb90f2d36c$var$WINDOW.document.addEventListener("keypress", globalDOMEventHandler, false);
    // After hooking into click and keypress events bubbled up to `document`, we also hook into user-handled
    // clicks & keypresses, by adding an event listener of our own to any element to which they add a listener. That
    // way, whenever one of their handlers is triggered, ours will be, too. (This is needed because their handler
    // could potentially prevent the event from bubbling up to our global listeners. This way, our handler are still
    // guaranteed to fire at least once.)
    [
        "EventTarget",
        "Node"
    ].forEach((target)=>{
        // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
        const proto = $6dad95eb90f2d36c$var$WINDOW[target] && $6dad95eb90f2d36c$var$WINDOW[target].prototype;
        // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access, no-prototype-builtins
        if (!proto || !proto.hasOwnProperty || !proto.hasOwnProperty("addEventListener")) return;
        (0, $jL8lq.fill)(proto, "addEventListener", function(originalAddEventListener) {
            return function(type, listener, options) {
                if (type === "click" || type == "keypress") try {
                    const el = this;
                    const handlers = el.__sentry_instrumentation_handlers__ = el.__sentry_instrumentation_handlers__ || {};
                    const handlerForType = handlers[type] = handlers[type] || {
                        refCount: 0
                    };
                    if (!handlerForType.handler) {
                        const handler = $6dad95eb90f2d36c$var$makeDOMEventHandler(triggerDOMHandler);
                        handlerForType.handler = handler;
                        originalAddEventListener.call(this, type, handler, options);
                    }
                    handlerForType.refCount++;
                } catch (e) {
                // Accessing dom properties is always fragile.
                // Also allows us to skip `addEventListenrs` calls with no proper `this` context.
                }
                return originalAddEventListener.call(this, type, listener, options);
            };
        });
        (0, $jL8lq.fill)(proto, "removeEventListener", function(originalRemoveEventListener) {
            return function(type, listener, options) {
                if (type === "click" || type == "keypress") try {
                    const el = this;
                    const handlers = el.__sentry_instrumentation_handlers__ || {};
                    const handlerForType = handlers[type];
                    if (handlerForType) {
                        handlerForType.refCount--;
                        // If there are no longer any custom handlers of the current type on this element, we can remove ours, too.
                        if (handlerForType.refCount <= 0) {
                            originalRemoveEventListener.call(this, type, handlerForType.handler, options);
                            handlerForType.handler = undefined;
                            delete handlers[type]; // eslint-disable-line @typescript-eslint/no-dynamic-delete
                        }
                        // If there are no longer any custom handlers of any type on this element, cleanup everything.
                        if (Object.keys(handlers).length === 0) delete el.__sentry_instrumentation_handlers__;
                    }
                } catch (e) {
                // Accessing dom properties is always fragile.
                // Also allows us to skip `addEventListenrs` calls with no proper `this` context.
                }
                return originalRemoveEventListener.call(this, type, listener, options);
            };
        });
    });
}
/**
 * Check whether the event is similar to the last captured one. For example, two click events on the same button.
 */ function $6dad95eb90f2d36c$var$isSimilarToLastCapturedEvent(event) {
    // If both events have different type, then user definitely performed two separate actions. e.g. click + keypress.
    if (event.type !== $6dad95eb90f2d36c$var$lastCapturedEventType) return false;
    try {
        // If both events have the same type, it's still possible that actions were performed on different targets.
        // e.g. 2 clicks on different buttons.
        if (!event.target || event.target._sentryId !== $6dad95eb90f2d36c$var$lastCapturedEventTargetId) return false;
    } catch (e) {
    // just accessing `target` property can throw an exception in some rare circumstances
    // see: https://github.com/getsentry/sentry-javascript/issues/838
    }
    // If both events have the same type _and_ same `target` (an element which triggered an event, _not necessarily_
    // to which an event listener was attached), we treat them as the same action, as we want to capture
    // only one breadcrumb. e.g. multiple clicks on the same button, or typing inside a user input box.
    return true;
}
/**
 * Decide whether an event should be captured.
 * @param event event to be captured
 */ function $6dad95eb90f2d36c$var$shouldSkipDOMEvent(eventType, target) {
    // We are only interested in filtering `keypress` events for now.
    if (eventType !== "keypress") return false;
    if (!target || !target.tagName) return true;
    // Only consider keypress events on actual input elements. This will disregard keypresses targeting body
    // e.g.tabbing through elements, hotkeys, etc.
    if (target.tagName === "INPUT" || target.tagName === "TEXTAREA" || target.isContentEditable) return false;
    return true;
}
/**
 * Wraps addEventListener to capture UI breadcrumbs
 */ function $6dad95eb90f2d36c$var$makeDOMEventHandler(handler, globalListener = false) {
    return (event)=>{
        // It's possible this handler might trigger multiple times for the same
        // event (e.g. event propagation through node ancestors).
        // Ignore if we've already captured that event.
        if (!event || event["_sentryCaptured"]) return;
        const target = $6dad95eb90f2d36c$var$getEventTarget(event);
        // We always want to skip _some_ events.
        if ($6dad95eb90f2d36c$var$shouldSkipDOMEvent(event.type, target)) return;
        // Mark event as "seen"
        (0, $jL8lq.addNonEnumerableProperty)(event, "_sentryCaptured", true);
        if (target && !target._sentryId) // Add UUID to event target so we can identify if
        (0, $jL8lq.addNonEnumerableProperty)(target, "_sentryId", (0, $b1E2c.uuid4)());
        const name = event.type === "keypress" ? "input" : event.type;
        // If there is no last captured event, it means that we can safely capture the new event and store it for future comparisons.
        // If there is a last captured event, see if the new event is different enough to treat it as a unique one.
        // If that's the case, emit the previous event and store locally the newly-captured DOM event.
        if (!$6dad95eb90f2d36c$var$isSimilarToLastCapturedEvent(event)) {
            const handlerData = {
                event: event,
                name: name,
                global: globalListener
            };
            handler(handlerData);
            $6dad95eb90f2d36c$var$lastCapturedEventType = event.type;
            $6dad95eb90f2d36c$var$lastCapturedEventTargetId = target ? target._sentryId : undefined;
        }
        // Start a new debounce timer that will prevent us from capturing multiple events that should be grouped together.
        clearTimeout($6dad95eb90f2d36c$var$debounceTimerID);
        $6dad95eb90f2d36c$var$debounceTimerID = $6dad95eb90f2d36c$var$WINDOW.setTimeout(()=>{
            $6dad95eb90f2d36c$var$lastCapturedEventTargetId = undefined;
            $6dad95eb90f2d36c$var$lastCapturedEventType = undefined;
        }, $6dad95eb90f2d36c$var$DEBOUNCE_DURATION);
    };
}
function $6dad95eb90f2d36c$var$getEventTarget(event) {
    try {
        return event.target;
    } catch (e) {
        // just accessing `target` property can throw an exception in some rare circumstances
        // see: https://github.com/getsentry/sentry-javascript/issues/838
        return null;
    }
}


var $4g0Ct = parcelRequire("4g0Ct");

var $jL8lq = parcelRequire("jL8lq");

var $3bpJ1 = parcelRequire("3bpJ1");

var $dbwHv = parcelRequire("dbwHv");
/**
 * Add an instrumentation handler for when a console.xxx method is called.
 *
 * Use at your own risk, this might break without changelog notice, only used internally.
 * @hidden
 */ function $d81ce3377b27def9$export$1d6e0d073f9e6723(handler) {
    const type = "console";
    (0, $dbwHv.addHandler)(type, handler);
    (0, $dbwHv.maybeInstrument)(type, $d81ce3377b27def9$var$instrumentConsole);
}
function $d81ce3377b27def9$var$instrumentConsole() {
    if (!("console" in (0, $3bpJ1.GLOBAL_OBJ))) return;
    (0, $4g0Ct.CONSOLE_LEVELS).forEach(function(level) {
        if (!(level in (0, $3bpJ1.GLOBAL_OBJ).console)) return;
        (0, $jL8lq.fill)((0, $3bpJ1.GLOBAL_OBJ).console, level, function(originalConsoleMethod) {
            (0, $4g0Ct.originalConsoleMethods)[level] = originalConsoleMethod;
            return function(...args) {
                const handlerData = {
                    args: args,
                    level: level
                };
                (0, $dbwHv.triggerHandlers)("console", handlerData);
                const log = (0, $4g0Ct.originalConsoleMethods)[level];
                log && log.apply((0, $3bpJ1.GLOBAL_OBJ).console, args);
            };
        });
    });
}


var $jL8lq = parcelRequire("jL8lq");


var $3bpJ1 = parcelRequire("3bpJ1");

var $dbwHv = parcelRequire("dbwHv");
/**
 * Add an instrumentation handler for when a fetch request happens.
 * The handler function is called once when the request starts and once when it ends,
 * which can be identified by checking if it has an `endTimestamp`.
 *
 * Use at your own risk, this might break without changelog notice, only used internally.
 * @hidden
 */ function $deebfb2c2f3e82fb$export$f75d3c772c923df0(handler) {
    const type = "fetch";
    (0, $dbwHv.addHandler)(type, handler);
    (0, $dbwHv.maybeInstrument)(type, $deebfb2c2f3e82fb$var$instrumentFetch);
}
function $deebfb2c2f3e82fb$var$instrumentFetch() {
    if (!(0, $a87a94b8e4ff7f26$export$c82d238e23c40b21)()) return;
    (0, $jL8lq.fill)((0, $3bpJ1.GLOBAL_OBJ), "fetch", function(originalFetch) {
        return function(...args) {
            const { method: method, url: url } = $deebfb2c2f3e82fb$export$f7a71163cc309d9a(args);
            const handlerData = {
                args: args,
                fetchData: {
                    method: method,
                    url: url
                },
                startTimestamp: Date.now()
            };
            (0, $dbwHv.triggerHandlers)("fetch", {
                ...handlerData
            });
            // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
            return originalFetch.apply((0, $3bpJ1.GLOBAL_OBJ), args).then((response)=>{
                const finishedHandlerData = {
                    ...handlerData,
                    endTimestamp: Date.now(),
                    response: response
                };
                (0, $dbwHv.triggerHandlers)("fetch", finishedHandlerData);
                return response;
            }, (error)=>{
                const erroredHandlerData = {
                    ...handlerData,
                    endTimestamp: Date.now(),
                    error: error
                };
                (0, $dbwHv.triggerHandlers)("fetch", erroredHandlerData);
                // NOTE: If you are a Sentry user, and you are seeing this stack frame,
                //       it means the sentry.javascript SDK caught an error invoking your application code.
                //       This is expected behavior and NOT indicative of a bug with sentry.javascript.
                throw error;
            });
        };
    });
}
function $deebfb2c2f3e82fb$var$hasProp(obj, prop) {
    return !!obj && typeof obj === "object" && !!obj[prop];
}
function $deebfb2c2f3e82fb$var$getUrlFromResource(resource) {
    if (typeof resource === "string") return resource;
    if (!resource) return "";
    if ($deebfb2c2f3e82fb$var$hasProp(resource, "url")) return resource.url;
    if (resource.toString) return resource.toString();
    return "";
}
/**
 * Parses the fetch arguments to find the used Http method and the url of the request.
 * Exported for tests only.
 */ function $deebfb2c2f3e82fb$export$f7a71163cc309d9a(fetchArgs) {
    if (fetchArgs.length === 0) return {
        method: "GET",
        url: ""
    };
    if (fetchArgs.length === 2) {
        const [url, options] = fetchArgs;
        return {
            url: $deebfb2c2f3e82fb$var$getUrlFromResource(url),
            method: $deebfb2c2f3e82fb$var$hasProp(options, "method") ? String(options.method).toUpperCase() : "GET"
        };
    }
    const arg = fetchArgs[0];
    return {
        url: $deebfb2c2f3e82fb$var$getUrlFromResource(arg),
        method: $deebfb2c2f3e82fb$var$hasProp(arg, "method") ? String(arg.method).toUpperCase() : "GET"
    };
}


var $2zW56 = parcelRequire("2zW56");

var $jL8lq = parcelRequire("jL8lq");

var $3bpJ1 = parcelRequire("3bpJ1");

var $dbwHv = parcelRequire("dbwHv");
const $ae6dc6125d1c3217$var$WINDOW = (0, $3bpJ1.GLOBAL_OBJ);
const $ae6dc6125d1c3217$export$55b6bb1e45c6cf59 = "__sentry_xhr_v3__";
/**
 * Add an instrumentation handler for when an XHR request happens.
 * The handler function is called once when the request starts and once when it ends,
 * which can be identified by checking if it has an `endTimestamp`.
 *
 * Use at your own risk, this might break without changelog notice, only used internally.
 * @hidden
 */ function $ae6dc6125d1c3217$export$26ace48dd54c9aea(handler) {
    const type = "xhr";
    (0, $dbwHv.addHandler)(type, handler);
    (0, $dbwHv.maybeInstrument)(type, $ae6dc6125d1c3217$export$c67d533bf77cbf54);
}
/** Exported only for tests. */ function $ae6dc6125d1c3217$export$c67d533bf77cbf54() {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    if (!$ae6dc6125d1c3217$var$WINDOW.XMLHttpRequest) return;
    const xhrproto = XMLHttpRequest.prototype;
    (0, $jL8lq.fill)(xhrproto, "open", function(originalOpen) {
        return function(...args) {
            const startTimestamp = Date.now();
            // open() should always be called with two or more arguments
            // But to be on the safe side, we actually validate this and bail out if we don't have a method & url
            const method = (0, $2zW56.isString)(args[0]) ? args[0].toUpperCase() : undefined;
            const url = $ae6dc6125d1c3217$var$parseUrl(args[1]);
            if (!method || !url) return originalOpen.apply(this, args);
            this[$ae6dc6125d1c3217$export$55b6bb1e45c6cf59] = {
                method: method,
                url: url,
                request_headers: {}
            };
            // if Sentry key appears in URL, don't capture it as a request
            if (method === "POST" && url.match(/sentry_key/)) this.__sentry_own_request__ = true;
            const onreadystatechangeHandler = ()=>{
                // For whatever reason, this is not the same instance here as from the outer method
                const xhrInfo = this[$ae6dc6125d1c3217$export$55b6bb1e45c6cf59];
                if (!xhrInfo) return;
                if (this.readyState === 4) {
                    try {
                        // touching statusCode in some platforms throws
                        // an exception
                        xhrInfo.status_code = this.status;
                    } catch (e) {
                    /* do nothing */ }
                    const handlerData = {
                        args: [
                            method,
                            url
                        ],
                        endTimestamp: Date.now(),
                        startTimestamp: startTimestamp,
                        xhr: this
                    };
                    (0, $dbwHv.triggerHandlers)("xhr", handlerData);
                }
            };
            if ("onreadystatechange" in this && typeof this.onreadystatechange === "function") (0, $jL8lq.fill)(this, "onreadystatechange", function(original) {
                return function(...readyStateArgs) {
                    onreadystatechangeHandler();
                    return original.apply(this, readyStateArgs);
                };
            });
            else this.addEventListener("readystatechange", onreadystatechangeHandler);
            // Intercepting `setRequestHeader` to access the request headers of XHR instance.
            // This will only work for user/library defined headers, not for the default/browser-assigned headers.
            // Request cookies are also unavailable for XHR, as `Cookie` header can't be defined by `setRequestHeader`.
            (0, $jL8lq.fill)(this, "setRequestHeader", function(original) {
                return function(...setRequestHeaderArgs) {
                    const [header, value] = setRequestHeaderArgs;
                    const xhrInfo = this[$ae6dc6125d1c3217$export$55b6bb1e45c6cf59];
                    if (xhrInfo && (0, $2zW56.isString)(header) && (0, $2zW56.isString)(value)) xhrInfo.request_headers[header.toLowerCase()] = value;
                    return original.apply(this, setRequestHeaderArgs);
                };
            });
            return originalOpen.apply(this, args);
        };
    });
    (0, $jL8lq.fill)(xhrproto, "send", function(originalSend) {
        return function(...args) {
            const sentryXhrData = this[$ae6dc6125d1c3217$export$55b6bb1e45c6cf59];
            if (!sentryXhrData) return originalSend.apply(this, args);
            if (args[0] !== undefined) sentryXhrData.body = args[0];
            const handlerData = {
                args: [
                    sentryXhrData.method,
                    sentryXhrData.url
                ],
                startTimestamp: Date.now(),
                xhr: this
            };
            (0, $dbwHv.triggerHandlers)("xhr", handlerData);
            return originalSend.apply(this, args);
        };
    });
}
function $ae6dc6125d1c3217$var$parseUrl(url) {
    if ((0, $2zW56.isString)(url)) return url;
    try {
        // url can be a string or URL
        // but since URL is not available in IE11, we do not check for it,
        // but simply assume it is an URL and return `toString()` from it (which returns the full URL)
        // If that fails, we just return undefined
        return url.toString();
    } catch (e2) {} // eslint-disable-line no-empty
    return undefined;
}


var $b1E2c = parcelRequire("b1E2c");
var $ibKgU = parcelRequire("ibKgU");
var $4g0Ct = parcelRequire("4g0Ct");/**
 * Parses string form of URL into an object
 * // borrowed from https://tools.ietf.org/html/rfc3986#appendix-B
 * // intentionally using regex and not <a/> href parsing trick because React Native and other
 * // environments where DOM might not be available
 * @returns parsed URL object
 */ function $25257edadcf16f49$export$7a5253c0f62e0150(url) {
    if (!url) return {};
    const match = url.match(/^(([^:/?#]+):)?(\/\/([^/?#]*))?([^?#]*)(\?([^#]*))?(#(.*))?$/);
    if (!match) return {};
    // coerce to undefined values to empty string so we don't get 'undefined'
    const query = match[6] || "";
    const fragment = match[8] || "";
    return {
        host: match[4],
        path: match[5],
        protocol: match[2],
        search: query,
        hash: fragment,
        relative: match[5] + query + fragment
    };
}
/**
 * Strip the query string and fragment off of a given URL or path (if present)
 *
 * @param urlPath Full URL or path, including possible query string and/or fragment
 * @returns URL or path without query string or fragment
 */ function $25257edadcf16f49$export$ce084c78234bd35(urlPath) {
    // eslint-disable-next-line no-useless-escape
    return urlPath.split(/[\?#]/, 1)[0];
}
/**
 * Returns number of URL segments of a passed string URL.
 */ function $25257edadcf16f49$export$69dd85280a8d374c(url) {
    // split at '/' or at '\/' to split regex urls correctly
    return url.split(/\\?\//).filter((s)=>s.length > 0 && s !== ",").length;
}
/**
 * Takes a URL object and returns a sanitized string which is safe to use as span description
 * see: https://develop.sentry.dev/sdk/data-handling/#structuring-data
 */ function $25257edadcf16f49$export$e0ba26c9e23e1fe0(url) {
    const { protocol: protocol, host: host, path: path } = url;
    const filteredHost = host && host// Always filter out authority
    .replace(/^.*@/, "[filtered]:[filtered]@")// Don't show standard :80 (http) and :443 (https) ports to reduce the noise
    // TODO: Use new URL global if it exists
    .replace(/(:80)$/, "").replace(/(:443)$/, "") || "";
    return `${protocol ? `${protocol}://` : ""}${filteredHost}${path}`;
}


var $91U3U = parcelRequire("91U3U");// Note: Ideally the `SeverityLevel` type would be derived from `validSeverityLevels`, but that would mean either
//
// a) moving `validSeverityLevels` to `@sentry/types`,
// b) moving the`SeverityLevel` type here, or
// c) importing `validSeverityLevels` from here into `@sentry/types`.
//
// Option A would make `@sentry/types` a runtime dependency of `@sentry/utils` (not good), and options B and C would
// create a circular dependency between `@sentry/types` and `@sentry/utils` (also not good). So a TODO accompanying the
// type, reminding anyone who changes it to change this list also, will have to do.
const $7f06244a5e0d22e8$export$411d0ffdba845b6c = [
    "fatal",
    "error",
    "warning",
    "log",
    "info",
    "debug"
];
/**
 * Converts a string-based level into a member of the deprecated {@link Severity} enum.
 *
 * @deprecated `severityFromString` is deprecated. Please use `severityLevelFromString` instead.
 *
 * @param level String representation of Severity
 * @returns Severity
 */ function $7f06244a5e0d22e8$export$e01cef29b4327697(level) {
    return $7f06244a5e0d22e8$export$d771ef054122c30a(level);
}
/**
 * Converts a string-based level into a `SeverityLevel`, normalizing it along the way.
 *
 * @param level String representation of desired `SeverityLevel`.
 * @returns The `SeverityLevel` corresponding to the given string, or 'log' if the string isn't a valid level.
 */ function $7f06244a5e0d22e8$export$d771ef054122c30a(level) {
    return level === "warn" ? "warning" : $7f06244a5e0d22e8$export$411d0ffdba845b6c.includes(level) ? level : "log";
}











/* eslint-disable max-lines */ /** JSDoc */ /** maxStringLength gets capped to prevent 100 breadcrumbs exceeding 1MB event payload size */ const $b50dad0732e7f682$var$MAX_ALLOWED_STRING_LENGTH = 1024;
/**
 * Default Breadcrumbs instrumentations
 * TODO: Deprecated - with v6, this will be renamed to `Instrument`
 */ class $b50dad0732e7f682$export$2dc68d50d56fbbd {
    /**
   * @inheritDoc
   */ static __initStatic() {
        this.id = "Breadcrumbs";
    }
    /**
   * @inheritDoc
   */ /**
   * Options of the breadcrumbs integration.
   */ // This field is public, because we use it in the browser client to check if the `sentry` option is enabled.
    /**
   * @inheritDoc
   */ constructor(options){
        this.name = $b50dad0732e7f682$export$2dc68d50d56fbbd.id;
        this.options = {
            console: true,
            dom: true,
            fetch: true,
            history: true,
            sentry: true,
            xhr: true,
            ...options
        };
    }
    /**
   * Instrument browser built-ins w/ breadcrumb capturing
   *  - Console API
   *  - DOM API (click/typing)
   *  - XMLHttpRequest API
   *  - Fetch API
   *  - History API
   */ setupOnce() {
        if (this.options.console) (0, $d81ce3377b27def9$export$1d6e0d073f9e6723)($b50dad0732e7f682$var$_consoleBreadcrumb);
        if (this.options.dom) (0, $6dad95eb90f2d36c$export$5aeffd3db2cf9df7)($b50dad0732e7f682$var$_domBreadcrumb(this.options.dom));
        if (this.options.xhr) (0, $ae6dc6125d1c3217$export$26ace48dd54c9aea)($b50dad0732e7f682$var$_xhrBreadcrumb);
        if (this.options.fetch) (0, $deebfb2c2f3e82fb$export$f75d3c772c923df0)($b50dad0732e7f682$var$_fetchBreadcrumb);
        if (this.options.history) (0, $2579aac1b9dfd189$export$3f18c56c58114e75)($b50dad0732e7f682$var$_historyBreadcrumb);
        if (this.options.sentry) {
            const client = (0, $b8438.getClient)();
            client && client.on && client.on("beforeSendEvent", $b50dad0732e7f682$var$addSentryBreadcrumb);
        }
    }
}
$b50dad0732e7f682$export$2dc68d50d56fbbd.__initStatic();
/**
 * Adds a breadcrumb for Sentry events or transactions if this option is enabled.
 */ function $b50dad0732e7f682$var$addSentryBreadcrumb(event) {
    (0, $cmFjP.getCurrentHub)().addBreadcrumb({
        category: `sentry.${event.type === "transaction" ? "transaction" : "event"}`,
        event_id: event.event_id,
        level: event.level,
        message: (0, $b1E2c.getEventDescription)(event)
    }, {
        event: event
    });
}
/**
 * A HOC that creaes a function that creates breadcrumbs from DOM API calls.
 * This is a HOC so that we get access to dom options in the closure.
 */ function $b50dad0732e7f682$var$_domBreadcrumb(dom) {
    function _innerDomBreadcrumb(handlerData) {
        let target;
        let keyAttrs = typeof dom === "object" ? dom.serializeAttribute : undefined;
        let maxStringLength = typeof dom === "object" && typeof dom.maxStringLength === "number" ? dom.maxStringLength : undefined;
        if (maxStringLength && maxStringLength > $b50dad0732e7f682$var$MAX_ALLOWED_STRING_LENGTH) {
            (0, $817d897c5dc6d664$export$16a28057038b10ef) && (0, $4g0Ct.logger).warn(`\`dom.maxStringLength\` cannot exceed ${$b50dad0732e7f682$var$MAX_ALLOWED_STRING_LENGTH}, but a value of ${maxStringLength} was configured. Sentry will use ${$b50dad0732e7f682$var$MAX_ALLOWED_STRING_LENGTH} instead.`);
            maxStringLength = $b50dad0732e7f682$var$MAX_ALLOWED_STRING_LENGTH;
        }
        if (typeof keyAttrs === "string") keyAttrs = [
            keyAttrs
        ];
        // Accessing event.target can throw (see getsentry/raven-js#838, #768)
        try {
            const event = handlerData.event;
            target = $b50dad0732e7f682$var$_isEvent(event) ? (0, $ibKgU.htmlTreeAsString)(event.target, {
                keyAttrs: keyAttrs,
                maxStringLength: maxStringLength
            }) : (0, $ibKgU.htmlTreeAsString)(event, {
                keyAttrs: keyAttrs,
                maxStringLength: maxStringLength
            });
        } catch (e) {
            target = "<unknown>";
        }
        if (target.length === 0) return;
        (0, $cmFjP.getCurrentHub)().addBreadcrumb({
            category: `ui.${handlerData.name}`,
            message: target
        }, {
            event: handlerData.event,
            name: handlerData.name,
            global: handlerData.global
        });
    }
    return _innerDomBreadcrumb;
}
/**
 * Creates breadcrumbs from console API calls
 */ function $b50dad0732e7f682$var$_consoleBreadcrumb(handlerData) {
    const breadcrumb = {
        category: "console",
        data: {
            arguments: handlerData.args,
            logger: "console"
        },
        level: (0, $7f06244a5e0d22e8$export$d771ef054122c30a)(handlerData.level),
        message: (0, $91U3U.safeJoin)(handlerData.args, " ")
    };
    if (handlerData.level === "assert") {
        if (handlerData.args[0] === false) {
            breadcrumb.message = `Assertion failed: ${(0, $91U3U.safeJoin)(handlerData.args.slice(1), " ") || "console.assert"}`;
            breadcrumb.data.arguments = handlerData.args.slice(1);
        } else // Don't capture a breadcrumb for passed assertions
        return;
    }
    (0, $cmFjP.getCurrentHub)().addBreadcrumb(breadcrumb, {
        input: handlerData.args,
        level: handlerData.level
    });
}
/**
 * Creates breadcrumbs from XHR API calls
 */ function $b50dad0732e7f682$var$_xhrBreadcrumb(handlerData) {
    const { startTimestamp: startTimestamp, endTimestamp: endTimestamp } = handlerData;
    const sentryXhrData = handlerData.xhr[0, $ae6dc6125d1c3217$export$55b6bb1e45c6cf59];
    // We only capture complete, non-sentry requests
    if (!startTimestamp || !endTimestamp || !sentryXhrData) return;
    const { method: method, url: url, status_code: status_code, body: body } = sentryXhrData;
    const data = {
        method: method,
        url: url,
        status_code: status_code
    };
    const hint = {
        xhr: handlerData.xhr,
        input: body,
        startTimestamp: startTimestamp,
        endTimestamp: endTimestamp
    };
    (0, $cmFjP.getCurrentHub)().addBreadcrumb({
        category: "xhr",
        data: data,
        type: "http"
    }, hint);
}
/**
 * Creates breadcrumbs from fetch API calls
 */ function $b50dad0732e7f682$var$_fetchBreadcrumb(handlerData) {
    const { startTimestamp: startTimestamp, endTimestamp: endTimestamp } = handlerData;
    // We only capture complete fetch requests
    if (!endTimestamp) return;
    if (handlerData.fetchData.url.match(/sentry_key/) && handlerData.fetchData.method === "POST") // We will not create breadcrumbs for fetch requests that contain `sentry_key` (internal sentry requests)
    return;
    if (handlerData.error) {
        const data = handlerData.fetchData;
        const hint = {
            data: handlerData.error,
            input: handlerData.args,
            startTimestamp: startTimestamp,
            endTimestamp: endTimestamp
        };
        (0, $cmFjP.getCurrentHub)().addBreadcrumb({
            category: "fetch",
            data: data,
            level: "error",
            type: "http"
        }, hint);
    } else {
        const response = handlerData.response;
        const data = {
            ...handlerData.fetchData,
            status_code: response && response.status
        };
        const hint = {
            input: handlerData.args,
            response: response,
            startTimestamp: startTimestamp,
            endTimestamp: endTimestamp
        };
        (0, $cmFjP.getCurrentHub)().addBreadcrumb({
            category: "fetch",
            data: data,
            type: "http"
        }, hint);
    }
}
/**
 * Creates breadcrumbs from history API calls
 */ function $b50dad0732e7f682$var$_historyBreadcrumb(handlerData) {
    let from = handlerData.from;
    let to = handlerData.to;
    const parsedLoc = (0, $25257edadcf16f49$export$7a5253c0f62e0150)((0, $4e817323ced6d78c$export$56d8a8a25bd48b81).location.href);
    let parsedFrom = from ? (0, $25257edadcf16f49$export$7a5253c0f62e0150)(from) : undefined;
    const parsedTo = (0, $25257edadcf16f49$export$7a5253c0f62e0150)(to);
    // Initial pushState doesn't provide `from` information
    if (!parsedFrom || !parsedFrom.path) parsedFrom = parsedLoc;
    // Use only the path component of the URL if the URL matches the current
    // document (almost all the time when using pushState)
    if (parsedLoc.protocol === parsedTo.protocol && parsedLoc.host === parsedTo.host) to = parsedTo.relative;
    if (parsedLoc.protocol === parsedFrom.protocol && parsedLoc.host === parsedFrom.host) from = parsedFrom.relative;
    (0, $cmFjP.getCurrentHub)().addBreadcrumb({
        category: "navigation",
        data: {
            from: from,
            to: to
        }
    });
}
function $b50dad0732e7f682$var$_isEvent(event) {
    return !!event && !!event.target;
}




const $732232d08e00e18c$var$DEFAULT_KEY = "cause";
const $732232d08e00e18c$var$DEFAULT_LIMIT = 5;
/** Adds SDK info to an event. */ class $732232d08e00e18c$export$8d1e60aaf616fb4f {
    /**
   * @inheritDoc
   */ static __initStatic() {
        this.id = "LinkedErrors";
    }
    /**
   * @inheritDoc
   */ /**
   * @inheritDoc
   */ /**
   * @inheritDoc
   */ /**
   * @inheritDoc
   */ constructor(options = {}){
        this.name = $732232d08e00e18c$export$8d1e60aaf616fb4f.id;
        this._key = options.key || $732232d08e00e18c$var$DEFAULT_KEY;
        this._limit = options.limit || $732232d08e00e18c$var$DEFAULT_LIMIT;
    }
    /** @inheritdoc */ setupOnce() {
    // noop
    }
    /**
   * @inheritDoc
   */ preprocessEvent(event, hint, client) {
        const options = client.getOptions();
        (0, $021240852b914991$export$b91c38ed7d8ae9b2)((0, $230372ac01587541$export$a6c2d27607295951), options.stackParser, options.maxValueLength, this._key, this._limit, event, hint);
    }
}
$732232d08e00e18c$export$8d1e60aaf616fb4f.__initStatic();



/** HttpContext integration collects information about HTTP request headers */ class $a609b75c449d57c1$export$5d2ee9a544b09a94 {
    /**
   * @inheritDoc
   */ static __initStatic() {
        this.id = "HttpContext";
    }
    /**
   * @inheritDoc
   */ constructor(){
        this.name = $a609b75c449d57c1$export$5d2ee9a544b09a94.id;
    }
    /**
   * @inheritDoc
   */ setupOnce() {
    // noop
    }
    /** @inheritDoc */ preprocessEvent(event) {
        // if none of the information we want exists, don't bother
        if (!(0, $4e817323ced6d78c$export$56d8a8a25bd48b81).navigator && !(0, $4e817323ced6d78c$export$56d8a8a25bd48b81).location && !(0, $4e817323ced6d78c$export$56d8a8a25bd48b81).document) return;
        // grab as much info as exists and add it to the event
        const url = event.request && event.request.url || (0, $4e817323ced6d78c$export$56d8a8a25bd48b81).location && (0, $4e817323ced6d78c$export$56d8a8a25bd48b81).location.href;
        const { referrer: referrer } = (0, $4e817323ced6d78c$export$56d8a8a25bd48b81).document || {};
        const { userAgent: userAgent } = (0, $4e817323ced6d78c$export$56d8a8a25bd48b81).navigator || {};
        const headers = {
            ...event.request && event.request.headers,
            ...referrer && {
                Referer: referrer
            },
            ...userAgent && {
                "User-Agent": userAgent
            }
        };
        const request = {
            ...event.request,
            ...url && {
                url: url
            },
            headers: headers
        };
        event.request = request;
    }
}
$a609b75c449d57c1$export$5d2ee9a544b09a94.__initStatic();



var $4g0Ct = parcelRequire("4g0Ct");

/** Deduplication filter */ class $893f0ce260470ef7$export$688d98c249d31ad3 {
    /**
   * @inheritDoc
   */ static __initStatic() {
        this.id = "Dedupe";
    }
    /**
   * @inheritDoc
   */ /**
   * @inheritDoc
   */ constructor(){
        this.name = $893f0ce260470ef7$export$688d98c249d31ad3.id;
    }
    /** @inheritDoc */ setupOnce(_addGlobalEventProcessor, _getCurrentHub) {
    // noop
    }
    /**
   * @inheritDoc
   */ processEvent(currentEvent) {
        // We want to ignore any non-error type events, e.g. transactions or replays
        // These should never be deduped, and also not be compared against as _previousEvent.
        if (currentEvent.type) return currentEvent;
        // Juuust in case something goes wrong
        try {
            if ($893f0ce260470ef7$var$_shouldDropEvent(currentEvent, this._previousEvent)) {
                (0, $817d897c5dc6d664$export$16a28057038b10ef) && (0, $4g0Ct.logger).warn("Event dropped due to being a duplicate of previously captured event.");
                return null;
            }
        } catch (_oO) {} // eslint-disable-line no-empty
        return this._previousEvent = currentEvent;
    }
}
$893f0ce260470ef7$export$688d98c249d31ad3.__initStatic();
/** JSDoc */ function $893f0ce260470ef7$var$_shouldDropEvent(currentEvent, previousEvent) {
    if (!previousEvent) return false;
    if ($893f0ce260470ef7$var$_isSameMessageEvent(currentEvent, previousEvent)) return true;
    if ($893f0ce260470ef7$var$_isSameExceptionEvent(currentEvent, previousEvent)) return true;
    return false;
}
/** JSDoc */ function $893f0ce260470ef7$var$_isSameMessageEvent(currentEvent, previousEvent) {
    const currentMessage = currentEvent.message;
    const previousMessage = previousEvent.message;
    // If neither event has a message property, they were both exceptions, so bail out
    if (!currentMessage && !previousMessage) return false;
    // If only one event has a stacktrace, but not the other one, they are not the same
    if (currentMessage && !previousMessage || !currentMessage && previousMessage) return false;
    if (currentMessage !== previousMessage) return false;
    if (!$893f0ce260470ef7$var$_isSameFingerprint(currentEvent, previousEvent)) return false;
    if (!$893f0ce260470ef7$var$_isSameStacktrace(currentEvent, previousEvent)) return false;
    return true;
}
/** JSDoc */ function $893f0ce260470ef7$var$_isSameExceptionEvent(currentEvent, previousEvent) {
    const previousException = $893f0ce260470ef7$var$_getExceptionFromEvent(previousEvent);
    const currentException = $893f0ce260470ef7$var$_getExceptionFromEvent(currentEvent);
    if (!previousException || !currentException) return false;
    if (previousException.type !== currentException.type || previousException.value !== currentException.value) return false;
    if (!$893f0ce260470ef7$var$_isSameFingerprint(currentEvent, previousEvent)) return false;
    if (!$893f0ce260470ef7$var$_isSameStacktrace(currentEvent, previousEvent)) return false;
    return true;
}
/** JSDoc */ function $893f0ce260470ef7$var$_isSameStacktrace(currentEvent, previousEvent) {
    let currentFrames = $893f0ce260470ef7$var$_getFramesFromEvent(currentEvent);
    let previousFrames = $893f0ce260470ef7$var$_getFramesFromEvent(previousEvent);
    // If neither event has a stacktrace, they are assumed to be the same
    if (!currentFrames && !previousFrames) return true;
    // If only one event has a stacktrace, but not the other one, they are not the same
    if (currentFrames && !previousFrames || !currentFrames && previousFrames) return false;
    currentFrames;
    previousFrames;
    // If number of frames differ, they are not the same
    if (previousFrames.length !== currentFrames.length) return false;
    // Otherwise, compare the two
    for(let i = 0; i < previousFrames.length; i++){
        const frameA = previousFrames[i];
        const frameB = currentFrames[i];
        if (frameA.filename !== frameB.filename || frameA.lineno !== frameB.lineno || frameA.colno !== frameB.colno || frameA.function !== frameB.function) return false;
    }
    return true;
}
/** JSDoc */ function $893f0ce260470ef7$var$_isSameFingerprint(currentEvent, previousEvent) {
    let currentFingerprint = currentEvent.fingerprint;
    let previousFingerprint = previousEvent.fingerprint;
    // If neither event has a fingerprint, they are assumed to be the same
    if (!currentFingerprint && !previousFingerprint) return true;
    // If only one event has a fingerprint, but not the other one, they are not the same
    if (currentFingerprint && !previousFingerprint || !currentFingerprint && previousFingerprint) return false;
    currentFingerprint;
    previousFingerprint;
    // Otherwise, compare the two
    try {
        return !!(currentFingerprint.join("") === previousFingerprint.join(""));
    } catch (_oO) {
        return false;
    }
}
/** JSDoc */ function $893f0ce260470ef7$var$_getExceptionFromEvent(event) {
    return event.exception && event.exception.values && event.exception.values[0];
}
/** JSDoc */ function $893f0ce260470ef7$var$_getFramesFromEvent(event) {
    const exception = event.exception;
    if (exception) try {
        // @ts-expect-error Object could be undefined
        return exception.values[0].stacktrace.frames;
    } catch (_oO) {
        return undefined;
    }
    return undefined;
}



var $16dZf = parcelRequire("16dZf");
// global reference to slice
const $6fa852429033a8df$var$UNKNOWN_FUNCTION = "?";
const $6fa852429033a8df$var$OPERA10_PRIORITY = 10;
const $6fa852429033a8df$var$OPERA11_PRIORITY = 20;
const $6fa852429033a8df$var$CHROME_PRIORITY = 30;
const $6fa852429033a8df$var$WINJS_PRIORITY = 40;
const $6fa852429033a8df$var$GECKO_PRIORITY = 50;
function $6fa852429033a8df$var$createFrame(filename, func, lineno, colno) {
    const frame = {
        filename: filename,
        function: func,
        in_app: true
    };
    if (lineno !== undefined) frame.lineno = lineno;
    if (colno !== undefined) frame.colno = colno;
    return frame;
}
// Chromium based browsers: Chrome, Brave, new Opera, new Edge
const $6fa852429033a8df$var$chromeRegex = /^\s*at (?:(.+?\)(?: \[.+\])?|.*?) ?\((?:address at )?)?(?:async )?((?:<anonymous>|[-a-z]+:|.*bundle|\/)?.*?)(?::(\d+))?(?::(\d+))?\)?\s*$/i;
const $6fa852429033a8df$var$chromeEvalRegex = /\((\S*)(?::(\d+))(?::(\d+))\)/;
const $6fa852429033a8df$var$chrome = (line)=>{
    const parts = $6fa852429033a8df$var$chromeRegex.exec(line);
    if (parts) {
        const isEval = parts[2] && parts[2].indexOf("eval") === 0; // start of line
        if (isEval) {
            const subMatch = $6fa852429033a8df$var$chromeEvalRegex.exec(parts[2]);
            if (subMatch) {
                // throw out eval line/column and use top-most line/column number
                parts[2] = subMatch[1]; // url
                parts[3] = subMatch[2]; // line
                parts[4] = subMatch[3]; // column
            }
        }
        // Kamil: One more hack won't hurt us right? Understanding and adding more rules on top of these regexps right now
        // would be way too time consuming. (TODO: Rewrite whole RegExp to be more readable)
        const [func, filename] = $6fa852429033a8df$var$extractSafariExtensionDetails(parts[1] || $6fa852429033a8df$var$UNKNOWN_FUNCTION, parts[2]);
        return $6fa852429033a8df$var$createFrame(filename, func, parts[3] ? +parts[3] : undefined, parts[4] ? +parts[4] : undefined);
    }
    return;
};
const $6fa852429033a8df$export$263a749fff749872 = [
    $6fa852429033a8df$var$CHROME_PRIORITY,
    $6fa852429033a8df$var$chrome
];
// gecko regex: `(?:bundle|\d+\.js)`: `bundle` is for react native, `\d+\.js` also but specifically for ram bundles because it
// generates filenames without a prefix like `file://` the filenames in the stacktrace are just 42.js
// We need this specific case for now because we want no other regex to match.
const $6fa852429033a8df$var$geckoREgex = /^\s*(.*?)(?:\((.*?)\))?(?:^|@)?((?:[-a-z]+)?:\/.*?|\[native code\]|[^@]*(?:bundle|\d+\.js)|\/[\w\-. /=]+)(?::(\d+))?(?::(\d+))?\s*$/i;
const $6fa852429033a8df$var$geckoEvalRegex = /(\S+) line (\d+)(?: > eval line \d+)* > eval/i;
const $6fa852429033a8df$var$gecko = (line)=>{
    const parts = $6fa852429033a8df$var$geckoREgex.exec(line);
    if (parts) {
        const isEval = parts[3] && parts[3].indexOf(" > eval") > -1;
        if (isEval) {
            const subMatch = $6fa852429033a8df$var$geckoEvalRegex.exec(parts[3]);
            if (subMatch) {
                // throw out eval line/column and use top-most line number
                parts[1] = parts[1] || "eval";
                parts[3] = subMatch[1];
                parts[4] = subMatch[2];
                parts[5] = ""; // no column when eval
            }
        }
        let filename = parts[3];
        let func = parts[1] || $6fa852429033a8df$var$UNKNOWN_FUNCTION;
        [func, filename] = $6fa852429033a8df$var$extractSafariExtensionDetails(func, filename);
        return $6fa852429033a8df$var$createFrame(filename, func, parts[4] ? +parts[4] : undefined, parts[5] ? +parts[5] : undefined);
    }
    return;
};
const $6fa852429033a8df$export$cdba47a5dd2804d = [
    $6fa852429033a8df$var$GECKO_PRIORITY,
    $6fa852429033a8df$var$gecko
];
const $6fa852429033a8df$var$winjsRegex = /^\s*at (?:((?:\[object object\])?.+) )?\(?((?:[-a-z]+):.*?):(\d+)(?::(\d+))?\)?\s*$/i;
const $6fa852429033a8df$var$winjs = (line)=>{
    const parts = $6fa852429033a8df$var$winjsRegex.exec(line);
    return parts ? $6fa852429033a8df$var$createFrame(parts[2], parts[1] || $6fa852429033a8df$var$UNKNOWN_FUNCTION, +parts[3], parts[4] ? +parts[4] : undefined) : undefined;
};
const $6fa852429033a8df$export$179460296da408e8 = [
    $6fa852429033a8df$var$WINJS_PRIORITY,
    $6fa852429033a8df$var$winjs
];
const $6fa852429033a8df$var$opera10Regex = / line (\d+).*script (?:in )?(\S+)(?:: in function (\S+))?$/i;
const $6fa852429033a8df$var$opera10 = (line)=>{
    const parts = $6fa852429033a8df$var$opera10Regex.exec(line);
    return parts ? $6fa852429033a8df$var$createFrame(parts[2], parts[3] || $6fa852429033a8df$var$UNKNOWN_FUNCTION, +parts[1]) : undefined;
};
const $6fa852429033a8df$export$f892b52c880ffc7a = [
    $6fa852429033a8df$var$OPERA10_PRIORITY,
    $6fa852429033a8df$var$opera10
];
const $6fa852429033a8df$var$opera11Regex = / line (\d+), column (\d+)\s*(?:in (?:<anonymous function: ([^>]+)>|([^)]+))\(.*\))? in (.*):\s*$/i;
const $6fa852429033a8df$var$opera11 = (line)=>{
    const parts = $6fa852429033a8df$var$opera11Regex.exec(line);
    return parts ? $6fa852429033a8df$var$createFrame(parts[5], parts[3] || parts[4] || $6fa852429033a8df$var$UNKNOWN_FUNCTION, +parts[1], +parts[2]) : undefined;
};
const $6fa852429033a8df$export$af11af13f09fb0dc = [
    $6fa852429033a8df$var$OPERA11_PRIORITY,
    $6fa852429033a8df$var$opera11
];
const $6fa852429033a8df$export$7197c0fe6554c079 = [
    $6fa852429033a8df$export$263a749fff749872,
    $6fa852429033a8df$export$cdba47a5dd2804d,
    $6fa852429033a8df$export$179460296da408e8
];
const $6fa852429033a8df$export$2b2b997d81bf3907 = (0, $16dZf.createStackParser)(...$6fa852429033a8df$export$7197c0fe6554c079);
/**
 * Safari web extensions, starting version unknown, can produce "frames-only" stacktraces.
 * What it means, is that instead of format like:
 *
 * Error: wat
 *   at function@url:row:col
 *   at function@url:row:col
 *   at function@url:row:col
 *
 * it produces something like:
 *
 *   function@url:row:col
 *   function@url:row:col
 *   function@url:row:col
 *
 * Because of that, it won't be captured by `chrome` RegExp and will fall into `Gecko` branch.
 * This function is extracted so that we can use it in both places without duplicating the logic.
 * Unfortunately "just" changing RegExp is too complicated now and making it pass all tests
 * and fix this case seems like an impossible, or at least way too time-consuming task.
 */ const $6fa852429033a8df$var$extractSafariExtensionDetails = (func, filename)=>{
    const isSafariExtension = func.indexOf("safari-extension") !== -1;
    const isSafariWebExtension = func.indexOf("safari-web-extension") !== -1;
    return isSafariExtension || isSafariWebExtension ? [
        func.indexOf("@") !== -1 ? func.split("@")[0] : $6fa852429033a8df$var$UNKNOWN_FUNCTION,
        isSafariExtension ? `safari-extension:${filename}` : `safari-web-extension:${filename}`
    ] : [
        func,
        filename
    ];
};


// Intentionally keeping the key broad, as we don't know for sure what rate limit headers get returned from backend
const $e02662e4aa308398$export$b09ce39faaeb1e7c = 60000; // 60 seconds
/**
 * Extracts Retry-After value from the request header or returns default value
 * @param header string representation of 'Retry-After' header
 * @param now current unix timestamp
 *
 */ function $e02662e4aa308398$export$615352e17ed7741(header, now = Date.now()) {
    const headerDelay = parseInt(`${header}`, 10);
    if (!isNaN(headerDelay)) return headerDelay * 1000;
    const headerDate = Date.parse(`${header}`);
    if (!isNaN(headerDate)) return headerDate - now;
    return $e02662e4aa308398$export$b09ce39faaeb1e7c;
}
/**
 * Gets the time that the given category is disabled until for rate limiting.
 * In case no category-specific limit is set but a general rate limit across all categories is active,
 * that time is returned.
 *
 * @return the time in ms that the category is disabled until or 0 if there's no active rate limit.
 */ function $e02662e4aa308398$export$b89fc7b2e4c799e7(limits, category) {
    return limits[category] || limits.all || 0;
}
/**
 * Checks if a category is rate limited
 */ function $e02662e4aa308398$export$6c91fec22056810a(limits, category, now = Date.now()) {
    return $e02662e4aa308398$export$b89fc7b2e4c799e7(limits, category) > now;
}
/**
 * Update ratelimits from incoming headers.
 *
 * @return the updated RateLimits object.
 */ function $e02662e4aa308398$export$699aff705e0d49d4(limits, { statusCode: statusCode, headers: headers }, now = Date.now()) {
    const updatedRateLimits = {
        ...limits
    };
    // "The name is case-insensitive."
    // https://developer.mozilla.org/en-US/docs/Web/API/Headers/get
    const rateLimitHeader = headers && headers["x-sentry-rate-limits"];
    const retryAfterHeader = headers && headers["retry-after"];
    if (rateLimitHeader) /**
     * rate limit headers are of the form
     *     <header>,<header>,..
     * where each <header> is of the form
     *     <retry_after>: <categories>: <scope>: <reason_code>
     * where
     *     <retry_after> is a delay in seconds
     *     <categories> is the event type(s) (error, transaction, etc) being rate limited and is of the form
     *         <category>;<category>;...
     *     <scope> is what's being limited (org, project, or key) - ignored by SDK
     *     <reason_code> is an arbitrary string like "org_quota" - ignored by SDK
     */ for (const limit of rateLimitHeader.trim().split(",")){
        const [retryAfter, categories] = limit.split(":", 2);
        const headerDelay = parseInt(retryAfter, 10);
        const delay = (!isNaN(headerDelay) ? headerDelay : 60) * 1000; // 60sec default
        if (!categories) updatedRateLimits.all = now + delay;
        else for (const category of categories.split(";"))updatedRateLimits[category] = now + delay;
    }
    else if (retryAfterHeader) updatedRateLimits.all = now + $e02662e4aa308398$export$615352e17ed7741(retryAfterHeader, now);
    else if (statusCode === 429) updatedRateLimits.all = now + 60000;
    return updatedRateLimits;
}


var $4g0Ct = parcelRequire("4g0Ct");

var $j3a3y = parcelRequire("j3a3y");
/**
 * Creates an new PromiseBuffer object with the specified limit
 * @param limit max number of promises that can be stored in the buffer
 */ function $e21a1e6dd57da767$export$85a4f67f852183e6(limit) {
    const buffer = [];
    function isReady() {
        return limit === undefined || buffer.length < limit;
    }
    /**
   * Remove a promise from the queue.
   *
   * @param task Can be any PromiseLike<T>
   * @returns Removed promise.
   */ function remove(task) {
        return buffer.splice(buffer.indexOf(task), 1)[0];
    }
    /**
   * Add a promise (representing an in-flight action) to the queue, and set it to remove itself on fulfillment.
   *
   * @param taskProducer A function producing any PromiseLike<T>; In previous versions this used to be `task:
   *        PromiseLike<T>`, but under that model, Promises were instantly created on the call-site and their executor
   *        functions therefore ran immediately. Thus, even if the buffer was full, the action still happened. By
   *        requiring the promise to be wrapped in a function, we can defer promise creation until after the buffer
   *        limit check.
   * @returns The original promise.
   */ function add(taskProducer) {
        if (!isReady()) return (0, $j3a3y.rejectedSyncPromise)(new (0, $890c53ca2f6b4a7a$export$5949942ba2a7c0e2)("Not adding Promise because buffer limit was reached."));
        // start the task and add its promise to the queue
        const task = taskProducer();
        if (buffer.indexOf(task) === -1) buffer.push(task);
        task.then(()=>remove(task))// Use `then(null, rejectionHandler)` rather than `catch(rejectionHandler)` so that we can use `PromiseLike`
        // rather than `Promise`. `PromiseLike` doesn't have a `.catch` method, making its polyfill smaller. (ES5 didn't
        // have promises, so TS has to polyfill when down-compiling.)
        .then(null, ()=>remove(task).then(null, ()=>{
            // We have to add another catch here because `remove()` starts a new promise chain.
            }));
        return task;
    }
    /**
   * Wait for all promises in the queue to resolve or for timeout to expire, whichever comes first.
   *
   * @param timeout The time, in ms, after which to resolve to `false` if the queue is still non-empty. Passing `0` (or
   * not passing anything) will make the promise wait as long as it takes for the queue to drain before resolving to
   * `true`.
   * @returns A promise which will resolve to `true` if the queue is already empty or drains before the timeout, and
   * `false` otherwise
   */ function drain(timeout) {
        return new (0, $j3a3y.SyncPromise)((resolve, reject)=>{
            let counter = buffer.length;
            if (!counter) return resolve(true);
            // wait for `timeout` ms and then resolve to `false` (if not cancelled first)
            const capturedSetTimeout = setTimeout(()=>{
                if (timeout && timeout > 0) resolve(false);
            }, timeout);
            // if all promises resolve in time, cancel the timer and resolve to `true`
            buffer.forEach((item)=>{
                (0, $j3a3y.resolvedSyncPromise)(item).then(()=>{
                    if (!--counter) {
                        clearTimeout(capturedSetTimeout);
                        resolve(true);
                    }
                }, reject);
            });
        });
    }
    return {
        $: buffer,
        add: add,
        drain: drain
    };
}


var $j3a3y = parcelRequire("j3a3y");

var $8IHa9 = parcelRequire("8IHa9");
const $551fd97e865f07d3$export$e515cf6dfd2f98b8 = 30;
/**
 * Creates an instance of a Sentry `Transport`
 *
 * @param options
 * @param makeRequest
 */ function $551fd97e865f07d3$export$d09f50d9ab7f7b69(options, makeRequest, buffer = (0, $e21a1e6dd57da767$export$85a4f67f852183e6)(options.bufferSize || $551fd97e865f07d3$export$e515cf6dfd2f98b8)) {
    let rateLimits = {};
    const flush = (timeout)=>buffer.drain(timeout);
    function send(envelope) {
        const filteredEnvelopeItems = [];
        // Drop rate limited items from envelope
        (0, $2cae643f899492f0$export$c56c55acf0136fd3)(envelope, (item, type)=>{
            const envelopeItemDataCategory = (0, $2cae643f899492f0$export$b11169581eeaf237)(type);
            if ((0, $e02662e4aa308398$export$6c91fec22056810a)(rateLimits, envelopeItemDataCategory)) {
                const event = $551fd97e865f07d3$var$getEventForEnvelopeItem(item, type);
                options.recordDroppedEvent("ratelimit_backoff", envelopeItemDataCategory, event);
            } else filteredEnvelopeItems.push(item);
        });
        // Skip sending if envelope is empty after filtering out rate limited events
        if (filteredEnvelopeItems.length === 0) return (0, $j3a3y.resolvedSyncPromise)();
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const filteredEnvelope = (0, $2cae643f899492f0$export$f93f7f385160c44e)(envelope[0], filteredEnvelopeItems);
        // Creates client report for each item in an envelope
        const recordEnvelopeLoss = (reason)=>{
            (0, $2cae643f899492f0$export$c56c55acf0136fd3)(filteredEnvelope, (item, type)=>{
                const event = $551fd97e865f07d3$var$getEventForEnvelopeItem(item, type);
                options.recordDroppedEvent(reason, (0, $2cae643f899492f0$export$b11169581eeaf237)(type), event);
            });
        };
        const requestTask = ()=>makeRequest({
                body: (0, $2cae643f899492f0$export$32f9b428425aac85)(filteredEnvelope, options.textEncoder)
            }).then((response)=>{
                // We don't want to throw on NOK responses, but we want to at least log them
                if (response.statusCode !== undefined && (response.statusCode < 200 || response.statusCode >= 300)) (0, $8IHa9.DEBUG_BUILD) && (0, $4g0Ct.logger).warn(`Sentry responded with status code ${response.statusCode} to sent event.`);
                rateLimits = (0, $e02662e4aa308398$export$699aff705e0d49d4)(rateLimits, response);
                return response;
            }, (error)=>{
                recordEnvelopeLoss("network_error");
                throw error;
            });
        return buffer.add(requestTask).then((result)=>result, (error)=>{
            if (error instanceof (0, $890c53ca2f6b4a7a$export$5949942ba2a7c0e2)) {
                (0, $8IHa9.DEBUG_BUILD) && (0, $4g0Ct.logger).error("Skipped sending event because buffer is full.");
                recordEnvelopeLoss("queue_overflow");
                return (0, $j3a3y.resolvedSyncPromise)();
            } else throw error;
        });
    }
    // We use this to identifify if the transport is the base transport
    // TODO (v8): Remove this again as we'll no longer need it
    send.__sentry__baseTransport__ = true;
    return {
        send: send,
        flush: flush
    };
}
function $551fd97e865f07d3$var$getEventForEnvelopeItem(item, type) {
    if (type !== "event" && type !== "transaction") return undefined;
    return Array.isArray(item) ? item[1] : undefined;
}



var $j3a3y = parcelRequire("j3a3y");

var $4g0Ct = parcelRequire("4g0Ct");


let $7d25350de9c66b8e$var$cachedFetchImpl = undefined;
/**
 * A special usecase for incorrectly wrapped Fetch APIs in conjunction with ad-blockers.
 * Whenever someone wraps the Fetch API and returns the wrong promise chain,
 * this chain becomes orphaned and there is no possible way to capture it's rejections
 * other than allowing it bubble up to this very handler. eg.
 *
 * const f = window.fetch;
 * window.fetch = function () {
 *   const p = f.apply(this, arguments);
 *
 *   p.then(function() {
 *     console.log('hi.');
 *   });
 *
 *   return p;
 * }
 *
 * `p.then(function () { ... })` is producing a completely separate promise chain,
 * however, what's returned is `p` - the result of original `fetch` call.
 *
 * This mean, that whenever we use the Fetch API to send our own requests, _and_
 * some ad-blocker blocks it, this orphaned chain will _always_ reject,
 * effectively causing another event to be captured.
 * This makes a whole process become an infinite loop, which we need to somehow
 * deal with, and break it in one way or another.
 *
 * To deal with this issue, we are making sure that we _always_ use the real
 * browser Fetch API, instead of relying on what `window.fetch` exposes.
 * The only downside to this would be missing our own requests as breadcrumbs,
 * but because we are already not doing this, it should be just fine.
 *
 * Possible failed fetch error messages per-browser:
 *
 * Chrome:  Failed to fetch
 * Edge:    Failed to Fetch
 * Firefox: NetworkError when attempting to fetch resource
 * Safari:  resource blocked by content blocker
 */ function $7d25350de9c66b8e$export$8be2119ce08e3379() {
    if ($7d25350de9c66b8e$var$cachedFetchImpl) return $7d25350de9c66b8e$var$cachedFetchImpl;
    /* eslint-disable @typescript-eslint/unbound-method */ // Fast path to avoid DOM I/O
    if ((0, $a87a94b8e4ff7f26$export$18cf36ed71d733e7)((0, $4e817323ced6d78c$export$56d8a8a25bd48b81).fetch)) return $7d25350de9c66b8e$var$cachedFetchImpl = (0, $4e817323ced6d78c$export$56d8a8a25bd48b81).fetch.bind((0, $4e817323ced6d78c$export$56d8a8a25bd48b81));
    const document = (0, $4e817323ced6d78c$export$56d8a8a25bd48b81).document;
    let fetchImpl = (0, $4e817323ced6d78c$export$56d8a8a25bd48b81).fetch;
    // eslint-disable-next-line deprecation/deprecation
    if (document && typeof document.createElement === "function") try {
        const sandbox = document.createElement("iframe");
        sandbox.hidden = true;
        document.head.appendChild(sandbox);
        const contentWindow = sandbox.contentWindow;
        if (contentWindow && contentWindow.fetch) fetchImpl = contentWindow.fetch;
        document.head.removeChild(sandbox);
    } catch (e) {
        (0, $817d897c5dc6d664$export$16a28057038b10ef) && (0, $4g0Ct.logger).warn("Could not create sandbox iframe for pure fetch check, bailing to window.fetch: ", e);
    }
    return $7d25350de9c66b8e$var$cachedFetchImpl = fetchImpl.bind((0, $4e817323ced6d78c$export$56d8a8a25bd48b81));
/* eslint-enable @typescript-eslint/unbound-method */ }
/** Clears cached fetch impl */ function $7d25350de9c66b8e$export$d499686d2dd738c6() {
    $7d25350de9c66b8e$var$cachedFetchImpl = undefined;
}


/**
 * Creates a Transport that uses the Fetch API to send events to Sentry.
 */ function $9237c8bb75383bbf$export$b2311068c46d7cc8(options, nativeFetch = (0, $7d25350de9c66b8e$export$8be2119ce08e3379)()) {
    let pendingBodySize = 0;
    let pendingCount = 0;
    function makeRequest(request) {
        const requestSize = request.body.length;
        pendingBodySize += requestSize;
        pendingCount++;
        const requestOptions = {
            body: request.body,
            method: "POST",
            referrerPolicy: "origin",
            headers: options.headers,
            // Outgoing requests are usually cancelled when navigating to a different page, causing a "TypeError: Failed to
            // fetch" error and sending a "network_error" client-outcome - in Chrome, the request status shows "(cancelled)".
            // The `keepalive` flag keeps outgoing requests alive, even when switching pages. We want this since we're
            // frequently sending events right before the user is switching pages (eg. whenfinishing navigation transactions).
            // Gotchas:
            // - `keepalive` isn't supported by Firefox
            // - As per spec (https://fetch.spec.whatwg.org/#http-network-or-cache-fetch):
            //   If the sum of contentLength and inflightKeepaliveBytes is greater than 64 kibibytes, then return a network error.
            //   We will therefore only activate the flag when we're below that limit.
            // There is also a limit of requests that can be open at the same time, so we also limit this to 15
            // See https://github.com/getsentry/sentry-javascript/pull/7553 for details
            keepalive: pendingBodySize <= 60000 && pendingCount < 15,
            ...options.fetchOptions
        };
        try {
            return nativeFetch(options.url, requestOptions).then((response)=>{
                pendingBodySize -= requestSize;
                pendingCount--;
                return {
                    statusCode: response.status,
                    headers: {
                        "x-sentry-rate-limits": response.headers.get("X-Sentry-Rate-Limits"),
                        "retry-after": response.headers.get("Retry-After")
                    }
                };
            });
        } catch (e) {
            (0, $7d25350de9c66b8e$export$d499686d2dd738c6)();
            pendingBodySize -= requestSize;
            pendingCount--;
            return (0, $j3a3y.rejectedSyncPromise)(e);
        }
    }
    return (0, $551fd97e865f07d3$export$d09f50d9ab7f7b69)(options, makeRequest);
}




var $j3a3y = parcelRequire("j3a3y");
/**
 * The DONE ready state for XmlHttpRequest
 *
 * Defining it here as a constant b/c XMLHttpRequest.DONE is not always defined
 * (e.g. during testing, it is `undefined`)
 *
 * @see {@link https://developer.mozilla.org/en-US/docs/Web/API/XMLHttpRequest/readyState}
 */ const $8be23756f879b8e4$var$XHR_READYSTATE_DONE = 4;
/**
 * Creates a Transport that uses the XMLHttpRequest API to send events to Sentry.
 */ function $8be23756f879b8e4$export$5e1441cee30d5a39(options) {
    function makeRequest(request) {
        return new (0, $j3a3y.SyncPromise)((resolve, reject)=>{
            const xhr = new XMLHttpRequest();
            xhr.onerror = reject;
            xhr.onreadystatechange = ()=>{
                if (xhr.readyState === $8be23756f879b8e4$var$XHR_READYSTATE_DONE) resolve({
                    statusCode: xhr.status,
                    headers: {
                        "x-sentry-rate-limits": xhr.getResponseHeader("X-Sentry-Rate-Limits"),
                        "retry-after": xhr.getResponseHeader("Retry-After")
                    }
                });
            };
            xhr.open("POST", options.url);
            for(const header in options.headers)if (Object.prototype.hasOwnProperty.call(options.headers, header)) xhr.setRequestHeader(header, options.headers[header]);
            xhr.send(request.body);
        });
    }
    return (0, $551fd97e865f07d3$export$d09f50d9ab7f7b69)(options, makeRequest);
}


const $4c87801c815e53f1$export$5ef831fccfce35e5 = [
    new (0, $d410fde205ba0588$exports).InboundFilters(),
    new (0, $d410fde205ba0588$exports).FunctionToString(),
    new (0, $f8ac3caec1ed9186$export$f1a018517668e6d3)(),
    new (0, $b50dad0732e7f682$export$2dc68d50d56fbbd)(),
    new (0, $9d72a78ef45a7c39$export$204155decbc90e5a)(),
    new (0, $732232d08e00e18c$export$8d1e60aaf616fb4f)(),
    new (0, $893f0ce260470ef7$export$688d98c249d31ad3)(),
    new (0, $a609b75c449d57c1$export$5d2ee9a544b09a94)()
];
/**
 * A magic string that build tooling can leverage in order to inject a release value into the SDK.
 */ /**
 * The Sentry Browser SDK Client.
 *
 * To use this SDK, call the {@link init} function as early as possible when
 * loading the web page. To set context information or send manual events, use
 * the provided methods.
 *
 * @example
 *
 * ```
 *
 * import { init } from '@sentry/browser';
 *
 * init({
 *   dsn: '__DSN__',
 *   // ...
 * });
 * ```
 *
 * @example
 * ```
 *
 * import { configureScope } from '@sentry/browser';
 * configureScope((scope: Scope) => {
 *   scope.setExtra({ battery: 0.7 });
 *   scope.setTag({ user_mode: 'admin' });
 *   scope.setUser({ id: '4711' });
 * });
 * ```
 *
 * @example
 * ```
 *
 * import { addBreadcrumb } from '@sentry/browser';
 * addBreadcrumb({
 *   message: 'My Breadcrumb',
 *   // ...
 * });
 * ```
 *
 * @example
 *
 * ```
 *
 * import * as Sentry from '@sentry/browser';
 * Sentry.captureMessage('Hello, world!');
 * Sentry.captureException(new Error('Good bye'));
 * Sentry.captureEvent({
 *   message: 'Manual',
 *   stacktrace: [
 *     // ...
 *   ],
 * });
 * ```
 *
 * @see {@link BrowserOptions} for documentation on configuration options.
 */ function $4c87801c815e53f1$export$2cd8252107eb640b(options = {}) {
    if (options.defaultIntegrations === undefined) options.defaultIntegrations = $4c87801c815e53f1$export$5ef831fccfce35e5;
    if (options.release === undefined) {
        // This allows build tooling to find-and-replace __SENTRY_RELEASE__ to inject a release value
        if (typeof __SENTRY_RELEASE__ === "string") options.release = __SENTRY_RELEASE__;
        // This supports the variable that sentry-webpack-plugin injects
        if ((0, $4e817323ced6d78c$export$56d8a8a25bd48b81).SENTRY_RELEASE && (0, $4e817323ced6d78c$export$56d8a8a25bd48b81).SENTRY_RELEASE.id) options.release = (0, $4e817323ced6d78c$export$56d8a8a25bd48b81).SENTRY_RELEASE.id;
    }
    if (options.autoSessionTracking === undefined) options.autoSessionTracking = true;
    if (options.sendClientReports === undefined) options.sendClientReports = true;
    const clientOptions = {
        ...options,
        stackParser: (0, $16dZf.stackParserFromStackParserOptions)(options.stackParser || (0, $6fa852429033a8df$export$2b2b997d81bf3907)),
        integrations: (0, $51cfcbefde61ff20$export$68bc4c01ab8ae766)(options),
        transport: options.transport || ((0, $a87a94b8e4ff7f26$export$edf3cb81fd7d2a3e)() ? (0, $9237c8bb75383bbf$export$b2311068c46d7cc8) : (0, $8be23756f879b8e4$export$5e1441cee30d5a39))
    };
    (0, $93002778f3923c52$export$5333c3f1c58d9bc1)((0, $c55795097f9daeb0$export$1df9218a526d318d), clientOptions);
    if (options.autoSessionTracking) $4c87801c815e53f1$var$startSessionTracking();
}
/**
 * Present the user with a report dialog.
 *
 * @param options Everything is optional, we try to fetch all info need from the global scope.
 */ function $4c87801c815e53f1$export$3a8fd680da42627b(options = {}, hub = (0, $cmFjP.getCurrentHub)()) {
    // doesn't work without a document (React Native)
    if (!(0, $4e817323ced6d78c$export$56d8a8a25bd48b81).document) {
        (0, $817d897c5dc6d664$export$16a28057038b10ef) && (0, $4g0Ct.logger).error("Global document not defined in showReportDialog call");
        return;
    }
    const { client: client, scope: scope } = hub.getStackTop();
    const dsn = options.dsn || client && client.getDsn();
    if (!dsn) {
        (0, $817d897c5dc6d664$export$16a28057038b10ef) && (0, $4g0Ct.logger).error("DSN not configured for showReportDialog call");
        return;
    }
    if (scope) options.user = {
        ...scope.getUser(),
        ...options.user
    };
    if (!options.eventId) options.eventId = hub.lastEventId();
    const script = (0, $4e817323ced6d78c$export$56d8a8a25bd48b81).document.createElement("script");
    script.async = true;
    script.crossOrigin = "anonymous";
    script.src = (0, $d91612272370ed71$export$671c7ed8e40a7a57)(dsn, options);
    if (options.onLoad) script.onload = options.onLoad;
    const { onClose: onClose } = options;
    if (onClose) {
        const reportDialogClosedMessageHandler = (event)=>{
            if (event.data === "__sentry_reportdialog_closed__") try {
                onClose();
            } finally{
                (0, $4e817323ced6d78c$export$56d8a8a25bd48b81).removeEventListener("message", reportDialogClosedMessageHandler);
            }
        };
        (0, $4e817323ced6d78c$export$56d8a8a25bd48b81).addEventListener("message", reportDialogClosedMessageHandler);
    }
    const injectionPoint = (0, $4e817323ced6d78c$export$56d8a8a25bd48b81).document.head || (0, $4e817323ced6d78c$export$56d8a8a25bd48b81).document.body;
    if (injectionPoint) injectionPoint.appendChild(script);
    else (0, $817d897c5dc6d664$export$16a28057038b10ef) && (0, $4g0Ct.logger).error("Not injecting report dialog. No injection point found in HTML");
}
/**
 * This function is here to be API compatible with the loader.
 * @hidden
 */ function $4c87801c815e53f1$export$a3f323d81eede727() {
// Noop
}
/**
 * This function is here to be API compatible with the loader.
 * @hidden
 */ function $4c87801c815e53f1$export$4e4d8b287d028b6b(callback) {
    callback();
}
/**
 * Wrap code within a try/catch block so the SDK is able to capture errors.
 *
 * @deprecated This function will be removed in v8.
 * It is not part of Sentry's official API and it's easily replaceable by using a try/catch block
 * and calling Sentry.captureException.
 *
 * @param fn A function to wrap.
 *
 * @returns The result of wrapped function call.
 */ // TODO(v8): Remove this function
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function $4c87801c815e53f1$export$4997ffc0176396a6(fn) {
    return (0, $4e817323ced6d78c$export$4997ffc0176396a6)(fn)();
}
function $4c87801c815e53f1$var$startSessionOnHub(hub) {
    hub.startSession({
        ignoreDuration: true
    });
    hub.captureSession();
}
/**
 * Enable automatic Session Tracking for the initial page load.
 */ function $4c87801c815e53f1$var$startSessionTracking() {
    if (typeof (0, $4e817323ced6d78c$export$56d8a8a25bd48b81).document === "undefined") {
        (0, $817d897c5dc6d664$export$16a28057038b10ef) && (0, $4g0Ct.logger).warn("Session tracking in non-browser environment with @sentry/browser is not supported.");
        return;
    }
    const hub = (0, $cmFjP.getCurrentHub)();
    // The only way for this to be false is for there to be a version mismatch between @sentry/browser (>= 6.0.0) and
    // @sentry/hub (< 5.27.0). In the simple case, there won't ever be such a mismatch, because the two packages are
    // pinned at the same version in package.json, but there are edge cases where it's possible. See
    // https://github.com/getsentry/sentry-javascript/issues/3207 and
    // https://github.com/getsentry/sentry-javascript/issues/3234 and
    // https://github.com/getsentry/sentry-javascript/issues/3278.
    if (!hub.captureSession) return;
    // The session duration for browser sessions does not track a meaningful
    // concept that can be used as a metric.
    // Automatically captured sessions are akin to page views, and thus we
    // discard their duration.
    $4c87801c815e53f1$var$startSessionOnHub(hub);
    // We want to create a session for every navigation as well
    (0, $2579aac1b9dfd189$export$3f18c56c58114e75)(({ from: from, to: to })=>{
        // Don't create an additional session for the initial route or if the location did not change
        if (from !== undefined && from !== to) $4c87801c815e53f1$var$startSessionOnHub((0, $cmFjP.getCurrentHub)());
    });
}
/**
 * Captures user feedback and sends it to Sentry.
 */ function $4c87801c815e53f1$export$88cefaf72d1e58a3(feedback) {
    const client = (0, $b8438.getClient)();
    if (client) client.captureUserFeedback(feedback);
}


var $9OAWn = parcelRequire("9OAWn");
/**
 * Inits the React SDK
 */ function $795a7664e1a3c052$export$2cd8252107eb640b(options) {
    const opts = {
        _metadata: {},
        ...options
    };
    opts._metadata.sdk = opts._metadata.sdk || {
        name: "sentry.javascript.react",
        packages: [
            {
                name: "npm:@sentry/react",
                version: (0, $9OAWn.SDK_VERSION)
            }
        ],
        version: (0, $9OAWn.SDK_VERSION)
    };
    (0, $4c87801c815e53f1$export$2cd8252107eb640b)(opts);
}



var $3NuqQ = parcelRequire("3NuqQ");/**
 * Polyfill for the optional chain operator, `?.`, given previous conversion of the expression into an array of values,
 * descriptors, and functions.
 *
 * Adapted from Sucrase (https://github.com/alangpierce/sucrase)
 * See https://github.com/alangpierce/sucrase/blob/265887868966917f3b924ce38dfad01fbab1329f/src/transformers/OptionalChainingNullishTransformer.ts#L15
 *
 * @param ops Array result of expression conversion
 * @returns The value of the expression
 */ function $ba7e9f49429c2354$export$3cc482e6b02f32f7(ops) {
    let lastAccessLHS = undefined;
    let value = ops[0];
    let i = 1;
    while(i < ops.length){
        const op = ops[i];
        const fn = ops[i + 1];
        i += 2;
        // by checking for loose equality to `null`, we catch both `null` and `undefined`
        if ((op === "optionalAccess" || op === "optionalCall") && value == null) // really we're meaning to return `undefined` as an actual value here, but it saves bytes not to write it
        return;
        if (op === "access" || op === "optionalAccess") {
            lastAccessLHS = value;
            value = fn(value);
        } else if (op === "call" || op === "optionalCall") {
            value = fn((...args)=>value.call(lastAccessLHS, ...args));
            lastAccessLHS = undefined;
        }
    }
    return value;
}


var $b1E2c = parcelRequire("b1E2c");
var $jL8lq = parcelRequire("jL8lq");
var $2zW56 = parcelRequire("2zW56");
var $289ZW = parcelRequire("289ZW");
var $4g0Ct = parcelRequire("4g0Ct");
/**
 * This serves as a build time flag that will be true by default, but false in non-debug builds or if users replace `__SENTRY_DEBUG__` in their generated code.
 *
 * ATTENTION: This constant must never cross package boundaries (i.e. be exported) to guarantee that it can be used for tree shaking.
 */ const $a5e85a0c259bdb77$export$16a28057038b10ef = typeof __SENTRY_DEBUG__ === "undefined" || __SENTRY_DEBUG__;



/**
 * Check if Sentry auto-instrumentation should be disabled.
 *
 * @param getCurrentHub A method to fetch the current hub
 * @returns boolean
 */ function $a9d137194c535c9f$export$34db76d03eb96b7e(getCurrentHub) {
    const clientOptions = (0, $ba7e9f49429c2354$export$3cc482e6b02f32f7)([
        getCurrentHub,
        "call",
        (_)=>_(),
        "access",
        (_2)=>_2.getClient,
        "call",
        (_3)=>_3(),
        "optionalAccess",
        (_4)=>_4.getOptions,
        "call",
        (_5)=>_5()
    ]);
    const instrumenter = (0, $ba7e9f49429c2354$export$3cc482e6b02f32f7)([
        clientOptions,
        "optionalAccess",
        (_6)=>_6.instrumenter
    ]) || "sentry";
    return instrumenter !== "sentry";
}


/** Tracing integration for Apollo */ class $72d6e24f36ba74e2$export$3db3e396472fda8d {
    /**
   * @inheritDoc
   */ static __initStatic() {
        this.id = "Apollo";
    }
    /**
   * @inheritDoc
   */ /**
   * @inheritDoc
   */ constructor(options = {
        useNestjs: false
    }){
        this.name = $72d6e24f36ba74e2$export$3db3e396472fda8d.id;
        this._useNest = !!options.useNestjs;
    }
    /** @inheritdoc */ loadDependency() {
        if (this._useNest) this._module = this._module || (0, $289ZW.loadModule)("@nestjs/graphql");
        else this._module = this._module || (0, $289ZW.loadModule)("apollo-server-core");
        return this._module;
    }
    /**
   * @inheritDoc
   */ setupOnce(_, getCurrentHub) {
        if ((0, $a9d137194c535c9f$export$34db76d03eb96b7e)(getCurrentHub)) {
            (0, $a5e85a0c259bdb77$export$16a28057038b10ef) && (0, $4g0Ct.logger).log("Apollo Integration is skipped because of instrumenter configuration.");
            return;
        }
        if (this._useNest) {
            const pkg = this.loadDependency();
            if (!pkg) {
                (0, $a5e85a0c259bdb77$export$16a28057038b10ef) && (0, $4g0Ct.logger).error("Apollo-NestJS Integration was unable to require @nestjs/graphql package.");
                return;
            }
            /**
       * Iterate over resolvers of NestJS ResolversExplorerService before schemas are constructed.
       */ (0, $jL8lq.fill)(pkg.GraphQLFactory.prototype, "mergeWithSchema", function(orig) {
                return function(...args) {
                    (0, $jL8lq.fill)(this.resolversExplorerService, "explore", function(orig) {
                        return function() {
                            const resolvers = (0, $b1E2c.arrayify)(orig.call(this));
                            const instrumentedResolvers = $72d6e24f36ba74e2$var$instrumentResolvers(resolvers, getCurrentHub);
                            return instrumentedResolvers;
                        };
                    });
                    return orig.call(this, ...args);
                };
            });
        } else {
            const pkg = this.loadDependency();
            if (!pkg) {
                (0, $a5e85a0c259bdb77$export$16a28057038b10ef) && (0, $4g0Ct.logger).error("Apollo Integration was unable to require apollo-server-core package.");
                return;
            }
            /**
       * Iterate over resolvers of the ApolloServer instance before schemas are constructed.
       */ (0, $jL8lq.fill)(pkg.ApolloServerBase.prototype, "constructSchema", function(orig) {
                return function() {
                    if (!this.config.resolvers) {
                        if (0, $a5e85a0c259bdb77$export$16a28057038b10ef) {
                            if (this.config.schema) {
                                (0, $4g0Ct.logger).warn("Apollo integration is not able to trace `ApolloServer` instances constructed via `schema` property.If you are using NestJS with Apollo, please use `Sentry.Integrations.Apollo({ useNestjs: true })` instead.");
                                (0, $4g0Ct.logger).warn();
                            } else if (this.config.modules) (0, $4g0Ct.logger).warn("Apollo integration is not able to trace `ApolloServer` instances constructed via `modules` property.");
                            (0, $4g0Ct.logger).error("Skipping tracing as no resolvers found on the `ApolloServer` instance.");
                        }
                        return orig.call(this);
                    }
                    const resolvers = (0, $b1E2c.arrayify)(this.config.resolvers);
                    this.config.resolvers = $72d6e24f36ba74e2$var$instrumentResolvers(resolvers, getCurrentHub);
                    return orig.call(this);
                };
            });
        }
    }
}
$72d6e24f36ba74e2$export$3db3e396472fda8d.__initStatic();
function $72d6e24f36ba74e2$var$instrumentResolvers(resolvers, getCurrentHub) {
    return resolvers.map((model)=>{
        Object.keys(model).forEach((resolverGroupName)=>{
            Object.keys(model[resolverGroupName]).forEach((resolverName)=>{
                if (typeof model[resolverGroupName][resolverName] !== "function") return;
                $72d6e24f36ba74e2$var$wrapResolver(model, resolverGroupName, resolverName, getCurrentHub);
            });
        });
        return model;
    });
}
/**
 * Wrap a single resolver which can be a parent of other resolvers and/or db operations.
 */ function $72d6e24f36ba74e2$var$wrapResolver(model, resolverGroupName, resolverName, getCurrentHub) {
    (0, $jL8lq.fill)(model[resolverGroupName], resolverName, function(orig) {
        return function(...args) {
            const scope = getCurrentHub().getScope();
            const parentSpan = scope.getSpan();
            const span = (0, $ba7e9f49429c2354$export$3cc482e6b02f32f7)([
                parentSpan,
                "optionalAccess",
                (_2)=>_2.startChild,
                "call",
                (_3)=>_3({
                        description: `${resolverGroupName}.${resolverName}`,
                        op: "graphql.resolve",
                        origin: "auto.graphql.apollo"
                    })
            ]);
            const rv = orig.call(this, ...args);
            if ((0, $2zW56.isThenable)(rv)) return rv.then((res)=>{
                (0, $ba7e9f49429c2354$export$3cc482e6b02f32f7)([
                    span,
                    "optionalAccess",
                    (_4)=>_4.finish,
                    "call",
                    (_5)=>_5()
                ]);
                return res;
            });
            (0, $ba7e9f49429c2354$export$3cc482e6b02f32f7)([
                span,
                "optionalAccess",
                (_6)=>_6.finish,
                "call",
                (_7)=>_7()
            ]);
            return rv;
        };
    });
}


var $gu0hs = parcelRequire("gu0hs");
var $5UTPE = parcelRequire("5UTPE");
var $2EZoq = parcelRequire("2EZoq");

var $ibKgU = parcelRequire("ibKgU");
var $4g0Ct = parcelRequire("4g0Ct");
var $65HJt = parcelRequire("65HJt");


var $5UTPE = parcelRequire("5UTPE");

var $4g0Ct = parcelRequire("4g0Ct");


var $3bpJ1 = parcelRequire("3bpJ1");
const $fe9433352f19d4b6$export$56d8a8a25bd48b81 = (0, $3bpJ1.GLOBAL_OBJ);


/**
 * Add a listener that cancels and finishes a transaction when the global
 * document is hidden.
 */ function $a50bc2aef3fcf638$export$6f18f55521af71a1() {
    if ((0, $fe9433352f19d4b6$export$56d8a8a25bd48b81) && (0, $fe9433352f19d4b6$export$56d8a8a25bd48b81).document) (0, $fe9433352f19d4b6$export$56d8a8a25bd48b81).document.addEventListener("visibilitychange", ()=>{
        const activeTransaction = (0, $5UTPE.getActiveTransaction)();
        if ((0, $fe9433352f19d4b6$export$56d8a8a25bd48b81).document.hidden && activeTransaction) {
            const statusType = "cancelled";
            (0, $a5e85a0c259bdb77$export$16a28057038b10ef) && (0, $4g0Ct.logger).log(`[Tracing] Transaction: ${statusType} -> since tab moved to the background, op: ${activeTransaction.op}`);
            // We should not set status if it is already set, this prevent important statuses like
            // error or data loss from being overwritten on transaction.
            if (!activeTransaction.status) activeTransaction.setStatus(statusType);
            activeTransaction.setTag("visibilitychange", "document.hidden");
            activeTransaction.finish();
        }
    });
    else (0, $a5e85a0c259bdb77$export$16a28057038b10ef) && (0, $4g0Ct.logger).warn("[Tracing] Could not set up background tab detection due to lack of global document");
}



var $5UTPE = parcelRequire("5UTPE");

var $cvSY8 = parcelRequire("cvSY8");
var $ibKgU = parcelRequire("ibKgU");
var $4g0Ct = parcelRequire("4g0Ct");


var $16dZf = parcelRequire("16dZf");
var $4g0Ct = parcelRequire("4g0Ct");

const $13c2ca2b7f8f393a$export$17679dccdd551979 = (callback, metric, reportAllChanges)=>{
    let prevValue;
    let delta;
    return (forceReport)=>{
        if (metric.value >= 0) {
            if (forceReport || reportAllChanges) {
                delta = metric.value - (prevValue || 0);
                // Report the metric if there's a non-zero delta or if no previous
                // value exists (which can happen in the case of the document becoming
                // hidden when the metric value is 0).
                // See: https://github.com/GoogleChrome/web-vitals/issues/14
                if (delta || prevValue === undefined) {
                    prevValue = metric.value;
                    metric.delta = delta;
                    callback(metric);
                }
            }
        }
    };
};



/*
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Performantly generate a unique, 30-char string by combining a version
 * number, the current timestamp with a 13-digit number integer.
 * @return {string}
 */ const $5863aef6ed758511$export$407ea409d1f3b539 = ()=>{
    return `v3-${Date.now()}-${Math.floor(Math.random() * (9e12 - 1)) + 1e12}`;
};



/*
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $0ae3ea9e7f2c4254$var$getNavigationEntryFromPerformanceTiming = ()=>{
    // eslint-disable-next-line deprecation/deprecation
    const timing = (0, $fe9433352f19d4b6$export$56d8a8a25bd48b81).performance.timing;
    // eslint-disable-next-line deprecation/deprecation
    const type = (0, $fe9433352f19d4b6$export$56d8a8a25bd48b81).performance.navigation.type;
    const navigationEntry = {
        entryType: "navigation",
        startTime: 0,
        type: type == 2 ? "back_forward" : type === 1 ? "reload" : "navigate"
    };
    for(const key in timing)if (key !== "navigationStart" && key !== "toJSON") // eslint-disable-next-line deprecation/deprecation
    navigationEntry[key] = Math.max(timing[key] - timing.navigationStart, 0);
    return navigationEntry;
};
const $0ae3ea9e7f2c4254$export$6431553786c94949 = ()=>{
    if ((0, $fe9433352f19d4b6$export$56d8a8a25bd48b81).__WEB_VITALS_POLYFILL__) return (0, $fe9433352f19d4b6$export$56d8a8a25bd48b81).performance && (performance.getEntriesByType && performance.getEntriesByType("navigation")[0] || $0ae3ea9e7f2c4254$var$getNavigationEntryFromPerformanceTiming());
    else return (0, $fe9433352f19d4b6$export$56d8a8a25bd48b81).performance && performance.getEntriesByType && performance.getEntriesByType("navigation")[0];
};


/*
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $57e88e157c530457$export$d3e828b3c7b5b845 = ()=>{
    const navEntry = (0, $0ae3ea9e7f2c4254$export$6431553786c94949)();
    return navEntry && navEntry.activationStart || 0;
};



/*
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $e8d4206fcb32f41c$export$3c29b44508a0612b = (name, value)=>{
    const navEntry = (0, $0ae3ea9e7f2c4254$export$6431553786c94949)();
    let navigationType = "navigate";
    if (navEntry) {
        if ((0, $fe9433352f19d4b6$export$56d8a8a25bd48b81).document.prerendering || (0, $57e88e157c530457$export$d3e828b3c7b5b845)() > 0) navigationType = "prerender";
        else navigationType = navEntry.type.replace(/_/g, "-");
    }
    return {
        name: name,
        value: typeof value === "undefined" ? -1 : value,
        rating: "good",
        delta: 0,
        entries: [],
        id: (0, $5863aef6ed758511$export$407ea409d1f3b539)(),
        navigationType: navigationType
    };
};


/**
 * Takes a performance entry type and a callback function, and creates a
 * `PerformanceObserver` instance that will observe the specified entry type
 * with buffering enabled and call the callback _for each entry_.
 *
 * This function also feature-detects entry support and wraps the logic in a
 * try/catch to avoid errors in unsupporting browsers.
 */ const $c62bade033a6ea98$export$d1203567a167490e = (type, callback, opts)=>{
    try {
        if (PerformanceObserver.supportedEntryTypes.includes(type)) {
            const po = new PerformanceObserver((list)=>{
                callback(list.getEntries());
            });
            po.observe(Object.assign({
                type: type,
                buffered: true
            }, opts || {}));
            return po;
        }
    } catch (e) {
    // Do nothing.
    }
    return;
};



/*
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $d30f0c2db0bdbc5b$export$91ec2be6fdd8f1b4 = (cb, once)=>{
    const onHiddenOrPageHide = (event)=>{
        if (event.type === "pagehide" || (0, $fe9433352f19d4b6$export$56d8a8a25bd48b81).document.visibilityState === "hidden") {
            cb(event);
            if (once) {
                removeEventListener("visibilitychange", onHiddenOrPageHide, true);
                removeEventListener("pagehide", onHiddenOrPageHide, true);
            }
        }
    };
    addEventListener("visibilitychange", onHiddenOrPageHide, true);
    // Some browsers have buggy implementations of visibilitychange,
    // so we use pagehide in addition, just to be safe.
    addEventListener("pagehide", onHiddenOrPageHide, true);
};


/*
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Calculates the [CLS](https://web.dev/cls/) value for the current page and
 * calls the `callback` function once the value is ready to be reported, along
 * with all `layout-shift` performance entries that were used in the metric
 * value calculation. The reported value is a `double` (corresponding to a
 * [layout shift score](https://web.dev/cls/#layout-shift-score)).
 *
 * If the `reportAllChanges` configuration option is set to `true`, the
 * `callback` function will be called as soon as the value is initially
 * determined as well as any time the value changes throughout the page
 * lifespan.
 *
 * _**Important:** CLS should be continually monitored for changes throughout
 * the entire lifespan of a page—including if the user returns to the page after
 * it's been hidden/backgrounded. However, since browsers often [will not fire
 * additional callbacks once the user has backgrounded a
 * page](https://developer.chrome.com/blog/page-lifecycle-api/#advice-hidden),
 * `callback` is always called when the page's visibility state changes to
 * hidden. As a result, the `callback` function might be called multiple times
 * during the same page load._
 */ const $06ed980438256cb2$export$a7873055838e5ad8 = (onReport)=>{
    const metric = (0, $e8d4206fcb32f41c$export$3c29b44508a0612b)("CLS", 0);
    let report;
    let sessionValue = 0;
    let sessionEntries = [];
    // const handleEntries = (entries: Metric['entries']) => {
    const handleEntries = (entries)=>{
        entries.forEach((entry)=>{
            // Only count layout shifts without recent user input.
            if (!entry.hadRecentInput) {
                const firstSessionEntry = sessionEntries[0];
                const lastSessionEntry = sessionEntries[sessionEntries.length - 1];
                // If the entry occurred less than 1 second after the previous entry and
                // less than 5 seconds after the first entry in the session, include the
                // entry in the current session. Otherwise, start a new session.
                if (sessionValue && sessionEntries.length !== 0 && entry.startTime - lastSessionEntry.startTime < 1000 && entry.startTime - firstSessionEntry.startTime < 5000) {
                    sessionValue += entry.value;
                    sessionEntries.push(entry);
                } else {
                    sessionValue = entry.value;
                    sessionEntries = [
                        entry
                    ];
                }
                // If the current session value is larger than the current CLS value,
                // update CLS and the entries contributing to it.
                if (sessionValue > metric.value) {
                    metric.value = sessionValue;
                    metric.entries = sessionEntries;
                    if (report) report();
                }
            }
        });
    };
    const po = (0, $c62bade033a6ea98$export$d1203567a167490e)("layout-shift", handleEntries);
    if (po) {
        report = (0, $13c2ca2b7f8f393a$export$17679dccdd551979)(onReport, metric);
        const stopListening = ()=>{
            handleEntries(po.takeRecords());
            report(true);
        };
        (0, $d30f0c2db0bdbc5b$export$91ec2be6fdd8f1b4)(stopListening);
        return stopListening;
    }
    return;
};





/*
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ let $b6c848c639162360$var$firstHiddenTime = -1;
const $b6c848c639162360$var$initHiddenTime = ()=>{
    // If the document is hidden and not prerendering, assume it was always
    // hidden and the page was loaded in the background.
    return (0, $fe9433352f19d4b6$export$56d8a8a25bd48b81).document.visibilityState === "hidden" && !(0, $fe9433352f19d4b6$export$56d8a8a25bd48b81).document.prerendering ? 0 : Infinity;
};
const $b6c848c639162360$var$trackChanges = ()=>{
    // Update the time if/when the document becomes hidden.
    (0, $d30f0c2db0bdbc5b$export$91ec2be6fdd8f1b4)(({ timeStamp: timeStamp })=>{
        $b6c848c639162360$var$firstHiddenTime = timeStamp;
    }, true);
};
const $b6c848c639162360$export$443f86b2c77012c4 = ()=>{
    if ($b6c848c639162360$var$firstHiddenTime < 0) {
        // If the document is hidden when this code runs, assume it was hidden
        // since navigation start. This isn't a perfect heuristic, but it's the
        // best we can do until an API is available to support querying past
        // visibilityState.
        $b6c848c639162360$var$firstHiddenTime = $b6c848c639162360$var$initHiddenTime();
        $b6c848c639162360$var$trackChanges();
    }
    return {
        get firstHiddenTime () {
            return $b6c848c639162360$var$firstHiddenTime;
        }
    };
};





/*
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Calculates the [FID](https://web.dev/fid/) value for the current page and
 * calls the `callback` function once the value is ready, along with the
 * relevant `first-input` performance entry used to determine the value. The
 * reported value is a `DOMHighResTimeStamp`.
 *
 * _**Important:** since FID is only reported after the user interacts with the
 * page, it's possible that it will not be reported for some page loads._
 */ const $fde0c7d375f4fcfc$export$39705a25c49af873 = (onReport)=>{
    const visibilityWatcher = (0, $b6c848c639162360$export$443f86b2c77012c4)();
    const metric = (0, $e8d4206fcb32f41c$export$3c29b44508a0612b)("FID");
    // eslint-disable-next-line prefer-const
    let report;
    const handleEntry = (entry)=>{
        // Only report if the page wasn't hidden prior to the first input.
        if (entry.startTime < visibilityWatcher.firstHiddenTime) {
            metric.value = entry.processingStart - entry.startTime;
            metric.entries.push(entry);
            report(true);
        }
    };
    const handleEntries = (entries)=>{
        entries.forEach(handleEntry);
    };
    const po = (0, $c62bade033a6ea98$export$d1203567a167490e)("first-input", handleEntries);
    report = (0, $13c2ca2b7f8f393a$export$17679dccdd551979)(onReport, metric);
    if (po) (0, $d30f0c2db0bdbc5b$export$91ec2be6fdd8f1b4)(()=>{
        handleEntries(po.takeRecords());
        po.disconnect();
    }, true);
};








/*
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $ca1c2d1679c3e1ef$var$reportedMetricIDs = {};
/**
 * Calculates the [LCP](https://web.dev/lcp/) value for the current page and
 * calls the `callback` function once the value is ready (along with the
 * relevant `largest-contentful-paint` performance entry used to determine the
 * value). The reported value is a `DOMHighResTimeStamp`.
 */ const $ca1c2d1679c3e1ef$export$947b1626ab8d5632 = (onReport)=>{
    const visibilityWatcher = (0, $b6c848c639162360$export$443f86b2c77012c4)();
    const metric = (0, $e8d4206fcb32f41c$export$3c29b44508a0612b)("LCP");
    let report;
    const handleEntries = (entries)=>{
        const lastEntry = entries[entries.length - 1];
        if (lastEntry) {
            // The startTime attribute returns the value of the renderTime if it is
            // not 0, and the value of the loadTime otherwise. The activationStart
            // reference is used because LCP should be relative to page activation
            // rather than navigation start if the page was prerendered.
            const value = Math.max(lastEntry.startTime - (0, $57e88e157c530457$export$d3e828b3c7b5b845)(), 0);
            // Only report if the page wasn't hidden prior to LCP.
            if (value < visibilityWatcher.firstHiddenTime) {
                metric.value = value;
                metric.entries = [
                    lastEntry
                ];
                report();
            }
        }
    };
    const po = (0, $c62bade033a6ea98$export$d1203567a167490e)("largest-contentful-paint", handleEntries);
    if (po) {
        report = (0, $13c2ca2b7f8f393a$export$17679dccdd551979)(onReport, metric);
        const stopListening = ()=>{
            if (!$ca1c2d1679c3e1ef$var$reportedMetricIDs[metric.id]) {
                handleEntries(po.takeRecords());
                po.disconnect();
                $ca1c2d1679c3e1ef$var$reportedMetricIDs[metric.id] = true;
                report(true);
            }
        };
        // Stop listening after input. Note: while scrolling is an input that
        // stop LCP observation, it's unreliable since it can be programmatically
        // generated. See: https://github.com/GoogleChrome/web-vitals/issues/75
        [
            "keydown",
            "click"
        ].forEach((type)=>{
            addEventListener(type, stopListening, {
                once: true,
                capture: true
            });
        });
        (0, $d30f0c2db0bdbc5b$export$91ec2be6fdd8f1b4)(stopListening, true);
        return stopListening;
    }
    return;
};



const $8b02f76565f096cc$var$handlers = {};
const $8b02f76565f096cc$var$instrumented = {};
let $8b02f76565f096cc$var$_previousCls;
let $8b02f76565f096cc$var$_previousFid;
let $8b02f76565f096cc$var$_previousLcp;
/**
 * Add a callback that will be triggered when a CLS metric is available.
 * Returns a cleanup callback which can be called to remove the instrumentation handler.
 */ function $8b02f76565f096cc$export$861b82818b37ba5b(callback) {
    return $8b02f76565f096cc$var$addMetricObserver("cls", callback, $8b02f76565f096cc$var$instrumentCls, $8b02f76565f096cc$var$_previousCls);
}
/**
 * Add a callback that will be triggered when a LCP metric is available.
 * Returns a cleanup callback which can be called to remove the instrumentation handler.
 */ function $8b02f76565f096cc$export$3fd4b53331200102(callback) {
    return $8b02f76565f096cc$var$addMetricObserver("lcp", callback, $8b02f76565f096cc$var$instrumentLcp, $8b02f76565f096cc$var$_previousLcp);
}
/**
 * Add a callback that will be triggered when a FID metric is available.
 * Returns a cleanup callback which can be called to remove the instrumentation handler.
 */ function $8b02f76565f096cc$export$2707d7471c0b918f(callback) {
    return $8b02f76565f096cc$var$addMetricObserver("fid", callback, $8b02f76565f096cc$var$instrumentFid, $8b02f76565f096cc$var$_previousFid);
}
/**
 * Add a callback that will be triggered when a performance observer is triggered,
 * and receives the entries of the observer.
 * Returns a cleanup callback which can be called to remove the instrumentation handler.
 */ function $8b02f76565f096cc$export$69816c1a049f8db6(type, callback) {
    $8b02f76565f096cc$var$addHandler(type, callback);
    if (!$8b02f76565f096cc$var$instrumented[type]) {
        $8b02f76565f096cc$var$instrumentPerformanceObserver(type);
        $8b02f76565f096cc$var$instrumented[type] = true;
    }
    return $8b02f76565f096cc$var$getCleanupCallback(type, callback);
}
/** Trigger all handlers of a given type. */ function $8b02f76565f096cc$var$triggerHandlers(type, data) {
    const typeHandlers = $8b02f76565f096cc$var$handlers[type];
    if (!typeHandlers || !typeHandlers.length) return;
    for (const handler of typeHandlers)try {
        handler(data);
    } catch (e) {
        (0, $a5e85a0c259bdb77$export$16a28057038b10ef) && (0, $4g0Ct.logger).error(`Error while triggering instrumentation handler.\nType: ${type}\nName: ${(0, $16dZf.getFunctionName)(handler)}\nError:`, e);
    }
}
function $8b02f76565f096cc$var$instrumentCls() {
    (0, $06ed980438256cb2$export$a7873055838e5ad8)((metric)=>{
        $8b02f76565f096cc$var$triggerHandlers("cls", {
            metric: metric
        });
        $8b02f76565f096cc$var$_previousCls = metric;
    });
}
function $8b02f76565f096cc$var$instrumentFid() {
    (0, $fde0c7d375f4fcfc$export$39705a25c49af873)((metric)=>{
        $8b02f76565f096cc$var$triggerHandlers("fid", {
            metric: metric
        });
        $8b02f76565f096cc$var$_previousFid = metric;
    });
}
function $8b02f76565f096cc$var$instrumentLcp() {
    (0, $ca1c2d1679c3e1ef$export$947b1626ab8d5632)((metric)=>{
        $8b02f76565f096cc$var$triggerHandlers("lcp", {
            metric: metric
        });
        $8b02f76565f096cc$var$_previousLcp = metric;
    });
}
function $8b02f76565f096cc$var$addMetricObserver(type, callback, instrumentFn, previousValue) {
    $8b02f76565f096cc$var$addHandler(type, callback);
    if (!$8b02f76565f096cc$var$instrumented[type]) {
        instrumentFn();
        $8b02f76565f096cc$var$instrumented[type] = true;
    }
    if (previousValue) callback({
        metric: previousValue
    });
    return $8b02f76565f096cc$var$getCleanupCallback(type, callback);
}
function $8b02f76565f096cc$var$instrumentPerformanceObserver(type) {
    const options = {};
    // Special per-type options we want to use
    if (type === "event") options.durationThreshold = 0;
    (0, $c62bade033a6ea98$export$d1203567a167490e)(type, (entries)=>{
        $8b02f76565f096cc$var$triggerHandlers(type, {
            entries: entries
        });
    }, options);
}
function $8b02f76565f096cc$var$addHandler(type, handler) {
    $8b02f76565f096cc$var$handlers[type] = $8b02f76565f096cc$var$handlers[type] || [];
    $8b02f76565f096cc$var$handlers[type].push(handler);
}
// Get a callback which can be called to remove the instrumentation handler
function $8b02f76565f096cc$var$getCleanupCallback(type, callback) {
    return ()=>{
        const typeHandlers = $8b02f76565f096cc$var$handlers[type];
        if (!typeHandlers) return;
        const index = typeHandlers.indexOf(callback);
        if (index !== -1) typeHandlers.splice(index, 1);
    };
}




/**
 * Checks if a given value is a valid measurement value.
 */ function $5efc8c95ea982b90$export$27169ccae1b439e3(value) {
    return typeof value === "number" && isFinite(value);
}
/**
 * Helper function to start child on transactions. This function will make sure that the transaction will
 * use the start timestamp of the created child span if it is earlier than the transactions actual
 * start timestamp.
 */ function $5efc8c95ea982b90$export$8bd469e1f37aa721(transaction, { startTimestamp: startTimestamp, ...ctx }) {
    if (startTimestamp && transaction.startTimestamp > startTimestamp) transaction.startTimestamp = startTimestamp;
    return transaction.startChild({
        startTimestamp: startTimestamp,
        ...ctx
    });
}


const $df8507bffbb2043c$var$MAX_INT_AS_BYTES = 2147483647;
/**
 * Converts from milliseconds to seconds
 * @param time time in ms
 */ function $df8507bffbb2043c$var$msToSec(time) {
    return time / 1000;
}
function $df8507bffbb2043c$var$getBrowserPerformanceAPI() {
    // @ts-expect-error we want to make sure all of these are available, even if TS is sure they are
    return (0, $fe9433352f19d4b6$export$56d8a8a25bd48b81) && (0, $fe9433352f19d4b6$export$56d8a8a25bd48b81).addEventListener && (0, $fe9433352f19d4b6$export$56d8a8a25bd48b81).performance;
}
let $df8507bffbb2043c$var$_performanceCursor = 0;
let $df8507bffbb2043c$var$_measurements = {};
let $df8507bffbb2043c$var$_lcpEntry;
let $df8507bffbb2043c$var$_clsEntry;
/**
 * Start tracking web vitals
 *
 * @returns A function that forces web vitals collection
 */ function $df8507bffbb2043c$export$7c69f0412d101b88() {
    const performance = $df8507bffbb2043c$var$getBrowserPerformanceAPI();
    if (performance && (0, $cvSY8.browserPerformanceTimeOrigin)) {
        // @ts-expect-error we want to make sure all of these are available, even if TS is sure they are
        if (performance.mark) (0, $fe9433352f19d4b6$export$56d8a8a25bd48b81).performance.mark("sentry-tracing-init");
        const fidCallback = $df8507bffbb2043c$var$_trackFID();
        const clsCallback = $df8507bffbb2043c$var$_trackCLS();
        const lcpCallback = $df8507bffbb2043c$var$_trackLCP();
        return ()=>{
            fidCallback();
            clsCallback();
            lcpCallback();
        };
    }
    return ()=>undefined;
}
/**
 * Start tracking long tasks.
 */ function $df8507bffbb2043c$export$f396d19077034ad2() {
    (0, $8b02f76565f096cc$export$69816c1a049f8db6)("longtask", ({ entries: entries })=>{
        for (const entry of entries){
            const transaction = (0, $5UTPE.getActiveTransaction)();
            if (!transaction) return;
            const startTime = $df8507bffbb2043c$var$msToSec((0, $cvSY8.browserPerformanceTimeOrigin) + entry.startTime);
            const duration = $df8507bffbb2043c$var$msToSec(entry.duration);
            transaction.startChild({
                description: "Main UI thread blocked",
                op: "ui.long-task",
                origin: "auto.ui.browser.metrics",
                startTimestamp: startTime,
                endTimestamp: startTime + duration
            });
        }
    });
}
/**
 * Start tracking interaction events.
 */ function $df8507bffbb2043c$export$e27543e0976315e4() {
    (0, $8b02f76565f096cc$export$69816c1a049f8db6)("event", ({ entries: entries })=>{
        for (const entry of entries){
            const transaction = (0, $5UTPE.getActiveTransaction)();
            if (!transaction) return;
            if (entry.name === "click") {
                const startTime = $df8507bffbb2043c$var$msToSec((0, $cvSY8.browserPerformanceTimeOrigin) + entry.startTime);
                const duration = $df8507bffbb2043c$var$msToSec(entry.duration);
                transaction.startChild({
                    description: (0, $ibKgU.htmlTreeAsString)(entry.target),
                    op: `ui.interaction.${entry.name}`,
                    origin: "auto.ui.browser.metrics",
                    startTimestamp: startTime,
                    endTimestamp: startTime + duration
                });
            }
        }
    });
}
/** Starts tracking the Cumulative Layout Shift on the current page. */ function $df8507bffbb2043c$var$_trackCLS() {
    return (0, $8b02f76565f096cc$export$861b82818b37ba5b)(({ metric: metric })=>{
        const entry = metric.entries.pop();
        if (!entry) return;
        (0, $a5e85a0c259bdb77$export$16a28057038b10ef) && (0, $4g0Ct.logger).log("[Measurements] Adding CLS");
        $df8507bffbb2043c$var$_measurements["cls"] = {
            value: metric.value,
            unit: ""
        };
        $df8507bffbb2043c$var$_clsEntry = entry;
    });
}
/** Starts tracking the Largest Contentful Paint on the current page. */ function $df8507bffbb2043c$var$_trackLCP() {
    return (0, $8b02f76565f096cc$export$3fd4b53331200102)(({ metric: metric })=>{
        const entry = metric.entries.pop();
        if (!entry) return;
        (0, $a5e85a0c259bdb77$export$16a28057038b10ef) && (0, $4g0Ct.logger).log("[Measurements] Adding LCP");
        $df8507bffbb2043c$var$_measurements["lcp"] = {
            value: metric.value,
            unit: "millisecond"
        };
        $df8507bffbb2043c$var$_lcpEntry = entry;
    });
}
/** Starts tracking the First Input Delay on the current page. */ function $df8507bffbb2043c$var$_trackFID() {
    return (0, $8b02f76565f096cc$export$2707d7471c0b918f)(({ metric: metric })=>{
        const entry = metric.entries.pop();
        if (!entry) return;
        const timeOrigin = $df8507bffbb2043c$var$msToSec((0, $cvSY8.browserPerformanceTimeOrigin));
        const startTime = $df8507bffbb2043c$var$msToSec(entry.startTime);
        (0, $a5e85a0c259bdb77$export$16a28057038b10ef) && (0, $4g0Ct.logger).log("[Measurements] Adding FID");
        $df8507bffbb2043c$var$_measurements["fid"] = {
            value: metric.value,
            unit: "millisecond"
        };
        $df8507bffbb2043c$var$_measurements["mark.fid"] = {
            value: timeOrigin + startTime,
            unit: "second"
        };
    });
}
/** Add performance related spans to a transaction */ function $df8507bffbb2043c$export$5f8fa6b3467a7443(transaction) {
    const performance = $df8507bffbb2043c$var$getBrowserPerformanceAPI();
    if (!performance || !(0, $fe9433352f19d4b6$export$56d8a8a25bd48b81).performance.getEntries || !(0, $cvSY8.browserPerformanceTimeOrigin)) // Gatekeeper if performance API not available
    return;
    (0, $a5e85a0c259bdb77$export$16a28057038b10ef) && (0, $4g0Ct.logger).log("[Tracing] Adding & adjusting spans using Performance API");
    const timeOrigin = $df8507bffbb2043c$var$msToSec((0, $cvSY8.browserPerformanceTimeOrigin));
    const performanceEntries = performance.getEntries();
    let responseStartTimestamp;
    let requestStartTimestamp;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    performanceEntries.slice($df8507bffbb2043c$var$_performanceCursor).forEach((entry)=>{
        const startTime = $df8507bffbb2043c$var$msToSec(entry.startTime);
        const duration = $df8507bffbb2043c$var$msToSec(entry.duration);
        if (transaction.op === "navigation" && timeOrigin + startTime < transaction.startTimestamp) return;
        switch(entry.entryType){
            case "navigation":
                $df8507bffbb2043c$var$_addNavigationSpans(transaction, entry, timeOrigin);
                responseStartTimestamp = timeOrigin + $df8507bffbb2043c$var$msToSec(entry.responseStart);
                requestStartTimestamp = timeOrigin + $df8507bffbb2043c$var$msToSec(entry.requestStart);
                break;
            case "mark":
            case "paint":
            case "measure":
                {
                    $df8507bffbb2043c$export$bc93b84e4d45912d(transaction, entry, startTime, duration, timeOrigin);
                    // capture web vitals
                    const firstHidden = (0, $b6c848c639162360$export$443f86b2c77012c4)();
                    // Only report if the page wasn't hidden prior to the web vital.
                    const shouldRecord = entry.startTime < firstHidden.firstHiddenTime;
                    if (entry.name === "first-paint" && shouldRecord) {
                        (0, $a5e85a0c259bdb77$export$16a28057038b10ef) && (0, $4g0Ct.logger).log("[Measurements] Adding FP");
                        $df8507bffbb2043c$var$_measurements["fp"] = {
                            value: entry.startTime,
                            unit: "millisecond"
                        };
                    }
                    if (entry.name === "first-contentful-paint" && shouldRecord) {
                        (0, $a5e85a0c259bdb77$export$16a28057038b10ef) && (0, $4g0Ct.logger).log("[Measurements] Adding FCP");
                        $df8507bffbb2043c$var$_measurements["fcp"] = {
                            value: entry.startTime,
                            unit: "millisecond"
                        };
                    }
                    break;
                }
            case "resource":
                {
                    const resourceName = entry.name.replace((0, $fe9433352f19d4b6$export$56d8a8a25bd48b81).location.origin, "");
                    $df8507bffbb2043c$export$c82fe1a70634f317(transaction, entry, resourceName, startTime, duration, timeOrigin);
                    break;
                }
        }
    });
    $df8507bffbb2043c$var$_performanceCursor = Math.max(performanceEntries.length - 1, 0);
    $df8507bffbb2043c$var$_trackNavigator(transaction);
    // Measurements are only available for pageload transactions
    if (transaction.op === "pageload") {
        // Generate TTFB (Time to First Byte), which measured as the time between the beginning of the transaction and the
        // start of the response in milliseconds
        if (typeof responseStartTimestamp === "number") {
            (0, $a5e85a0c259bdb77$export$16a28057038b10ef) && (0, $4g0Ct.logger).log("[Measurements] Adding TTFB");
            $df8507bffbb2043c$var$_measurements["ttfb"] = {
                value: (responseStartTimestamp - transaction.startTimestamp) * 1000,
                unit: "millisecond"
            };
            if (typeof requestStartTimestamp === "number" && requestStartTimestamp <= responseStartTimestamp) // Capture the time spent making the request and receiving the first byte of the response.
            // This is the time between the start of the request and the start of the response in milliseconds.
            $df8507bffbb2043c$var$_measurements["ttfb.requestTime"] = {
                value: (responseStartTimestamp - requestStartTimestamp) * 1000,
                unit: "millisecond"
            };
        }
        [
            "fcp",
            "fp",
            "lcp"
        ].forEach((name)=>{
            if (!$df8507bffbb2043c$var$_measurements[name] || timeOrigin >= transaction.startTimestamp) return;
            // The web vitals, fcp, fp, lcp, and ttfb, all measure relative to timeOrigin.
            // Unfortunately, timeOrigin is not captured within the transaction span data, so these web vitals will need
            // to be adjusted to be relative to transaction.startTimestamp.
            const oldValue = $df8507bffbb2043c$var$_measurements[name].value;
            const measurementTimestamp = timeOrigin + $df8507bffbb2043c$var$msToSec(oldValue);
            // normalizedValue should be in milliseconds
            const normalizedValue = Math.abs((measurementTimestamp - transaction.startTimestamp) * 1000);
            const delta = normalizedValue - oldValue;
            (0, $a5e85a0c259bdb77$export$16a28057038b10ef) && (0, $4g0Ct.logger).log(`[Measurements] Normalized ${name} from ${oldValue} to ${normalizedValue} (${delta})`);
            $df8507bffbb2043c$var$_measurements[name].value = normalizedValue;
        });
        const fidMark = $df8507bffbb2043c$var$_measurements["mark.fid"];
        if (fidMark && $df8507bffbb2043c$var$_measurements["fid"]) {
            // create span for FID
            (0, $5efc8c95ea982b90$export$8bd469e1f37aa721)(transaction, {
                description: "first input delay",
                endTimestamp: fidMark.value + $df8507bffbb2043c$var$msToSec($df8507bffbb2043c$var$_measurements["fid"].value),
                op: "ui.action",
                origin: "auto.ui.browser.metrics",
                startTimestamp: fidMark.value
            });
            // Delete mark.fid as we don't want it to be part of final payload
            delete $df8507bffbb2043c$var$_measurements["mark.fid"];
        }
        // If FCP is not recorded we should not record the cls value
        // according to the new definition of CLS.
        if (!("fcp" in $df8507bffbb2043c$var$_measurements)) delete $df8507bffbb2043c$var$_measurements.cls;
        Object.keys($df8507bffbb2043c$var$_measurements).forEach((measurementName)=>{
            transaction.setMeasurement(measurementName, $df8507bffbb2043c$var$_measurements[measurementName].value, $df8507bffbb2043c$var$_measurements[measurementName].unit);
        });
        $df8507bffbb2043c$var$_tagMetricInfo(transaction);
    }
    $df8507bffbb2043c$var$_lcpEntry = undefined;
    $df8507bffbb2043c$var$_clsEntry = undefined;
    $df8507bffbb2043c$var$_measurements = {};
}
/** Create measure related spans */ function $df8507bffbb2043c$export$bc93b84e4d45912d(transaction, // eslint-disable-next-line @typescript-eslint/no-explicit-any
entry, startTime, duration, timeOrigin) {
    const measureStartTimestamp = timeOrigin + startTime;
    const measureEndTimestamp = measureStartTimestamp + duration;
    (0, $5efc8c95ea982b90$export$8bd469e1f37aa721)(transaction, {
        description: entry.name,
        endTimestamp: measureEndTimestamp,
        op: entry.entryType,
        origin: "auto.resource.browser.metrics",
        startTimestamp: measureStartTimestamp
    });
    return measureStartTimestamp;
}
/** Instrument navigation entries */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function $df8507bffbb2043c$var$_addNavigationSpans(transaction, entry, timeOrigin) {
    [
        "unloadEvent",
        "redirect",
        "domContentLoadedEvent",
        "loadEvent",
        "connect"
    ].forEach((event)=>{
        $df8507bffbb2043c$var$_addPerformanceNavigationTiming(transaction, entry, event, timeOrigin);
    });
    $df8507bffbb2043c$var$_addPerformanceNavigationTiming(transaction, entry, "secureConnection", timeOrigin, "TLS/SSL", "connectEnd");
    $df8507bffbb2043c$var$_addPerformanceNavigationTiming(transaction, entry, "fetch", timeOrigin, "cache", "domainLookupStart");
    $df8507bffbb2043c$var$_addPerformanceNavigationTiming(transaction, entry, "domainLookup", timeOrigin, "DNS");
    $df8507bffbb2043c$var$_addRequest(transaction, entry, timeOrigin);
}
/** Create performance navigation related spans */ function $df8507bffbb2043c$var$_addPerformanceNavigationTiming(transaction, // eslint-disable-next-line @typescript-eslint/no-explicit-any
entry, event, timeOrigin, description, eventEnd) {
    const end = eventEnd ? entry[eventEnd] : entry[`${event}End`];
    const start = entry[`${event}Start`];
    if (!start || !end) return;
    (0, $5efc8c95ea982b90$export$8bd469e1f37aa721)(transaction, {
        op: "browser",
        origin: "auto.browser.browser.metrics",
        description: description || event,
        startTimestamp: timeOrigin + $df8507bffbb2043c$var$msToSec(start),
        endTimestamp: timeOrigin + $df8507bffbb2043c$var$msToSec(end)
    });
}
/** Create request and response related spans */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function $df8507bffbb2043c$var$_addRequest(transaction, entry, timeOrigin) {
    (0, $5efc8c95ea982b90$export$8bd469e1f37aa721)(transaction, {
        op: "browser",
        origin: "auto.browser.browser.metrics",
        description: "request",
        startTimestamp: timeOrigin + $df8507bffbb2043c$var$msToSec(entry.requestStart),
        endTimestamp: timeOrigin + $df8507bffbb2043c$var$msToSec(entry.responseEnd)
    });
    (0, $5efc8c95ea982b90$export$8bd469e1f37aa721)(transaction, {
        op: "browser",
        origin: "auto.browser.browser.metrics",
        description: "response",
        startTimestamp: timeOrigin + $df8507bffbb2043c$var$msToSec(entry.responseStart),
        endTimestamp: timeOrigin + $df8507bffbb2043c$var$msToSec(entry.responseEnd)
    });
}
/** Create resource-related spans */ function $df8507bffbb2043c$export$c82fe1a70634f317(transaction, entry, resourceName, startTime, duration, timeOrigin) {
    // we already instrument based on fetch and xhr, so we don't need to
    // duplicate spans here.
    if (entry.initiatorType === "xmlhttprequest" || entry.initiatorType === "fetch") return;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const data = {};
    $df8507bffbb2043c$var$setResourceEntrySizeData(data, entry, "transferSize", "http.response_transfer_size");
    $df8507bffbb2043c$var$setResourceEntrySizeData(data, entry, "encodedBodySize", "http.response_content_length");
    $df8507bffbb2043c$var$setResourceEntrySizeData(data, entry, "decodedBodySize", "http.decoded_response_content_length");
    if ("renderBlockingStatus" in entry) data["resource.render_blocking_status"] = entry.renderBlockingStatus;
    const startTimestamp = timeOrigin + startTime;
    const endTimestamp = startTimestamp + duration;
    (0, $5efc8c95ea982b90$export$8bd469e1f37aa721)(transaction, {
        description: resourceName,
        endTimestamp: endTimestamp,
        op: entry.initiatorType ? `resource.${entry.initiatorType}` : "resource.other",
        origin: "auto.resource.browser.metrics",
        startTimestamp: startTimestamp,
        data: data
    });
}
/**
 * Capture the information of the user agent.
 */ function $df8507bffbb2043c$var$_trackNavigator(transaction) {
    const navigator = (0, $fe9433352f19d4b6$export$56d8a8a25bd48b81).navigator;
    if (!navigator) return;
    // track network connectivity
    const connection = navigator.connection;
    if (connection) {
        if (connection.effectiveType) transaction.setTag("effectiveConnectionType", connection.effectiveType);
        if (connection.type) transaction.setTag("connectionType", connection.type);
        if ((0, $5efc8c95ea982b90$export$27169ccae1b439e3)(connection.rtt)) $df8507bffbb2043c$var$_measurements["connection.rtt"] = {
            value: connection.rtt,
            unit: "millisecond"
        };
    }
    if ((0, $5efc8c95ea982b90$export$27169ccae1b439e3)(navigator.deviceMemory)) transaction.setTag("deviceMemory", `${navigator.deviceMemory} GB`);
    if ((0, $5efc8c95ea982b90$export$27169ccae1b439e3)(navigator.hardwareConcurrency)) transaction.setTag("hardwareConcurrency", String(navigator.hardwareConcurrency));
}
/** Add LCP / CLS data to transaction to allow debugging */ function $df8507bffbb2043c$var$_tagMetricInfo(transaction) {
    if ($df8507bffbb2043c$var$_lcpEntry) {
        (0, $a5e85a0c259bdb77$export$16a28057038b10ef) && (0, $4g0Ct.logger).log("[Measurements] Adding LCP Data");
        // Capture Properties of the LCP element that contributes to the LCP.
        if ($df8507bffbb2043c$var$_lcpEntry.element) transaction.setTag("lcp.element", (0, $ibKgU.htmlTreeAsString)($df8507bffbb2043c$var$_lcpEntry.element));
        if ($df8507bffbb2043c$var$_lcpEntry.id) transaction.setTag("lcp.id", $df8507bffbb2043c$var$_lcpEntry.id);
        if ($df8507bffbb2043c$var$_lcpEntry.url) // Trim URL to the first 200 characters.
        transaction.setTag("lcp.url", $df8507bffbb2043c$var$_lcpEntry.url.trim().slice(0, 200));
        transaction.setTag("lcp.size", $df8507bffbb2043c$var$_lcpEntry.size);
    }
    // See: https://developer.mozilla.org/en-US/docs/Web/API/LayoutShift
    if ($df8507bffbb2043c$var$_clsEntry && $df8507bffbb2043c$var$_clsEntry.sources) {
        (0, $a5e85a0c259bdb77$export$16a28057038b10ef) && (0, $4g0Ct.logger).log("[Measurements] Adding CLS Data");
        $df8507bffbb2043c$var$_clsEntry.sources.forEach((source, index)=>transaction.setTag(`cls.source.${index + 1}`, (0, $ibKgU.htmlTreeAsString)(source.node)));
    }
}
function $df8507bffbb2043c$var$setResourceEntrySizeData(data, entry, key, dataKey) {
    const entryVal = entry[key];
    if (entryVal != null && entryVal < $df8507bffbb2043c$var$MAX_INT_AS_BYTES) data[dataKey] = entryVal;
}



var $cmFjP = parcelRequire("cmFjP");
var $bPHT6 = parcelRequire("bPHT6");
var $duCnO = parcelRequire("duCnO");

var $dzA7g = parcelRequire("dzA7g");
var $cvSY8 = parcelRequire("cvSY8");
var $65HJt = parcelRequire("65HJt");
var $91U3U = parcelRequire("91U3U");

var $cmFjP = parcelRequire("cmFjP");
var $bPHT6 = parcelRequire("bPHT6");
var $duCnO = parcelRequire("duCnO");

var $dzA7g = parcelRequire("dzA7g");
var $65HJt = parcelRequire("65HJt");
var $2zW56 = parcelRequire("2zW56");
/**
 * Create and track fetch request spans for usage in combination with `addInstrumentationHandler`.
 *
 * @returns Span if a span was created, otherwise void.
 */ function $bb4def6c8b51e56d$export$6d73c62358c655be(handlerData, shouldCreateSpan, shouldAttachHeaders, spans, spanOrigin = "auto.http.browser") {
    if (!(0, $duCnO.hasTracingEnabled)() || !handlerData.fetchData) return undefined;
    const shouldCreateSpanResult = shouldCreateSpan(handlerData.fetchData.url);
    if (handlerData.endTimestamp && shouldCreateSpanResult) {
        const spanId = handlerData.fetchData.__span;
        if (!spanId) return;
        const span = spans[spanId];
        if (span) {
            if (handlerData.response) {
                span.setHttpStatus(handlerData.response.status);
                const contentLength = handlerData.response && handlerData.response.headers && handlerData.response.headers.get("content-length");
                if (contentLength) {
                    const contentLengthNum = parseInt(contentLength);
                    if (contentLengthNum > 0) span.setData("http.response_content_length", contentLengthNum);
                }
            } else if (handlerData.error) span.setStatus("internal_error");
            span.finish();
            // eslint-disable-next-line @typescript-eslint/no-dynamic-delete
            delete spans[spanId];
        }
        return undefined;
    }
    const hub = (0, $cmFjP.getCurrentHub)();
    const scope = hub.getScope();
    const client = hub.getClient();
    const parentSpan = scope.getSpan();
    const { method: method, url: url } = handlerData.fetchData;
    const span = shouldCreateSpanResult && parentSpan ? parentSpan.startChild({
        data: {
            url: url,
            type: "fetch",
            "http.method": method
        },
        description: `${method} ${url}`,
        op: "http.client",
        origin: spanOrigin
    }) : undefined;
    if (span) {
        handlerData.fetchData.__span = span.spanId;
        spans[span.spanId] = span;
    }
    if (shouldAttachHeaders(handlerData.fetchData.url) && client) {
        const request = handlerData.args[0];
        // In case the user hasn't set the second argument of a fetch call we default it to `{}`.
        handlerData.args[1] = handlerData.args[1] || {};
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const options = handlerData.args[1];
        // eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/no-unsafe-member-access
        options.headers = $bb4def6c8b51e56d$export$6717acf674206871(request, client, scope, options, span);
    }
    return span;
}
/**
 * Adds sentry-trace and baggage headers to the various forms of fetch headers
 */ function $bb4def6c8b51e56d$export$6717acf674206871(request, client, scope, options, requestSpan) {
    const span = requestSpan || scope.getSpan();
    const transaction = span && span.transaction;
    const { traceId: traceId, sampled: sampled, dsc: dsc } = scope.getPropagationContext();
    const sentryTraceHeader = span ? span.toTraceparent() : (0, $65HJt.generateSentryTraceHeader)(traceId, undefined, sampled);
    const dynamicSamplingContext = transaction ? transaction.getDynamicSamplingContext() : dsc ? dsc : (0, $bPHT6.getDynamicSamplingContextFromClient)(traceId, client, scope);
    const sentryBaggageHeader = (0, $dzA7g.dynamicSamplingContextToSentryBaggageHeader)(dynamicSamplingContext);
    const headers = typeof Request !== "undefined" && (0, $2zW56.isInstanceOf)(request, Request) ? request.headers : options.headers;
    if (!headers) return {
        "sentry-trace": sentryTraceHeader,
        baggage: sentryBaggageHeader
    };
    else if (typeof Headers !== "undefined" && (0, $2zW56.isInstanceOf)(headers, Headers)) {
        const newHeaders = new Headers(headers);
        newHeaders.append("sentry-trace", sentryTraceHeader);
        if (sentryBaggageHeader) // If the same header is appended multiple times the browser will merge the values into a single request header.
        // Its therefore safe to simply push a "baggage" entry, even though there might already be another baggage header.
        newHeaders.append((0, $dzA7g.BAGGAGE_HEADER_NAME), sentryBaggageHeader);
        return newHeaders;
    } else if (Array.isArray(headers)) {
        const newHeaders = [
            ...headers,
            [
                "sentry-trace",
                sentryTraceHeader
            ]
        ];
        if (sentryBaggageHeader) // If there are multiple entries with the same key, the browser will merge the values into a single request header.
        // Its therefore safe to simply push a "baggage" entry, even though there might already be another baggage header.
        newHeaders.push([
            (0, $dzA7g.BAGGAGE_HEADER_NAME),
            sentryBaggageHeader
        ]);
        return newHeaders;
    } else {
        const existingBaggageHeader = "baggage" in headers ? headers.baggage : undefined;
        const newBaggageHeaders = [];
        if (Array.isArray(existingBaggageHeader)) newBaggageHeaders.push(...existingBaggageHeader);
        else if (existingBaggageHeader) newBaggageHeaders.push(existingBaggageHeader);
        if (sentryBaggageHeader) newBaggageHeaders.push(sentryBaggageHeader);
        return {
            ...headers,
            "sentry-trace": sentryTraceHeader,
            baggage: newBaggageHeaders.length > 0 ? newBaggageHeaders.join(",") : undefined
        };
    }
}



/* eslint-disable max-lines */ const $e425abf0f1e5a10f$export$15bd0305d05ad07b = [
    "localhost",
    /^\/(?!\/)/
];
/** Options for Request Instrumentation */ const $e425abf0f1e5a10f$export$cc17fb3c0bc95cd7 = {
    traceFetch: true,
    traceXHR: true,
    enableHTTPTimings: true,
    // TODO (v8): Remove this property
    tracingOrigins: $e425abf0f1e5a10f$export$15bd0305d05ad07b,
    tracePropagationTargets: $e425abf0f1e5a10f$export$15bd0305d05ad07b
};
/** Registers span creators for xhr and fetch requests  */ function $e425abf0f1e5a10f$export$864489cb3478db3e(_options) {
    const { traceFetch: traceFetch, traceXHR: traceXHR, tracePropagationTargets: // eslint-disable-next-line deprecation/deprecation
    tracePropagationTargets, tracingOrigins: // eslint-disable-next-line deprecation/deprecation
    tracingOrigins, shouldCreateSpanForRequest: shouldCreateSpanForRequest, enableHTTPTimings: enableHTTPTimings } = {
        traceFetch: $e425abf0f1e5a10f$export$cc17fb3c0bc95cd7.traceFetch,
        traceXHR: $e425abf0f1e5a10f$export$cc17fb3c0bc95cd7.traceXHR,
        ..._options
    };
    const shouldCreateSpan = typeof shouldCreateSpanForRequest === "function" ? shouldCreateSpanForRequest : (_)=>true;
    // TODO(v8) Remove tracingOrigins here
    // The only reason we're passing it in here is because this instrumentOutgoingRequests function is publicly exported
    // and we don't want to break the API. We can remove it in v8.
    const shouldAttachHeadersWithTargets = (url)=>$e425abf0f1e5a10f$export$c260386ab3f0b3dd(url, tracePropagationTargets || tracingOrigins);
    const spans = {};
    if (traceFetch) (0, $deebfb2c2f3e82fb$export$f75d3c772c923df0)((handlerData)=>{
        const createdSpan = (0, $bb4def6c8b51e56d$export$6d73c62358c655be)(handlerData, shouldCreateSpan, shouldAttachHeadersWithTargets, spans);
        if (enableHTTPTimings && createdSpan) $e425abf0f1e5a10f$var$addHTTPTimings(createdSpan);
    });
    if (traceXHR) (0, $ae6dc6125d1c3217$export$26ace48dd54c9aea)((handlerData)=>{
        const createdSpan = $e425abf0f1e5a10f$export$49680d91e75e2ef7(handlerData, shouldCreateSpan, shouldAttachHeadersWithTargets, spans);
        if (enableHTTPTimings && createdSpan) $e425abf0f1e5a10f$var$addHTTPTimings(createdSpan);
    });
}
function $e425abf0f1e5a10f$var$isPerformanceResourceTiming(entry) {
    return entry.entryType === "resource" && "initiatorType" in entry && typeof entry.nextHopProtocol === "string" && (entry.initiatorType === "fetch" || entry.initiatorType === "xmlhttprequest");
}
/**
 * Creates a temporary observer to listen to the next fetch/xhr resourcing timings,
 * so that when timings hit their per-browser limit they don't need to be removed.
 *
 * @param span A span that has yet to be finished, must contain `url` on data.
 */ function $e425abf0f1e5a10f$var$addHTTPTimings(span) {
    const url = span.data.url;
    if (!url) return;
    const cleanup = (0, $8b02f76565f096cc$export$69816c1a049f8db6)("resource", ({ entries: entries })=>{
        entries.forEach((entry)=>{
            if ($e425abf0f1e5a10f$var$isPerformanceResourceTiming(entry) && entry.name.endsWith(url)) {
                const spanData = $e425abf0f1e5a10f$var$resourceTimingEntryToSpanData(entry);
                spanData.forEach((data)=>span.setData(...data));
                // In the next tick, clean this handler up
                // We have to wait here because otherwise this cleans itself up before it is fully done
                setTimeout(cleanup);
            }
        });
    });
}
/**
 * Converts ALPN protocol ids to name and version.
 *
 * (https://www.iana.org/assignments/tls-extensiontype-values/tls-extensiontype-values.xhtml#alpn-protocol-ids)
 * @param nextHopProtocol PerformanceResourceTiming.nextHopProtocol
 */ function $e425abf0f1e5a10f$export$57c6f824442f9fe1(nextHopProtocol) {
    let name = "unknown";
    let version = "unknown";
    let _name = "";
    for (const char of nextHopProtocol){
        // http/1.1 etc.
        if (char === "/") {
            [name, version] = nextHopProtocol.split("/");
            break;
        }
        // h2, h3 etc.
        if (!isNaN(Number(char))) {
            name = _name === "h" ? "http" : _name;
            version = nextHopProtocol.split(_name)[1];
            break;
        }
        _name += char;
    }
    if (_name === nextHopProtocol) // webrtc, ftp, etc.
    name = _name;
    return {
        name: name,
        version: version
    };
}
function $e425abf0f1e5a10f$var$getAbsoluteTime(time = 0) {
    return (((0, $cvSY8.browserPerformanceTimeOrigin) || performance.timeOrigin) + time) / 1000;
}
function $e425abf0f1e5a10f$var$resourceTimingEntryToSpanData(resourceTiming) {
    const { name: name, version: version } = $e425abf0f1e5a10f$export$57c6f824442f9fe1(resourceTiming.nextHopProtocol);
    const timingSpanData = [];
    timingSpanData.push([
        "network.protocol.version",
        version
    ], [
        "network.protocol.name",
        name
    ]);
    if (!(0, $cvSY8.browserPerformanceTimeOrigin)) return timingSpanData;
    return [
        ...timingSpanData,
        [
            "http.request.redirect_start",
            $e425abf0f1e5a10f$var$getAbsoluteTime(resourceTiming.redirectStart)
        ],
        [
            "http.request.fetch_start",
            $e425abf0f1e5a10f$var$getAbsoluteTime(resourceTiming.fetchStart)
        ],
        [
            "http.request.domain_lookup_start",
            $e425abf0f1e5a10f$var$getAbsoluteTime(resourceTiming.domainLookupStart)
        ],
        [
            "http.request.domain_lookup_end",
            $e425abf0f1e5a10f$var$getAbsoluteTime(resourceTiming.domainLookupEnd)
        ],
        [
            "http.request.connect_start",
            $e425abf0f1e5a10f$var$getAbsoluteTime(resourceTiming.connectStart)
        ],
        [
            "http.request.secure_connection_start",
            $e425abf0f1e5a10f$var$getAbsoluteTime(resourceTiming.secureConnectionStart)
        ],
        [
            "http.request.connection_end",
            $e425abf0f1e5a10f$var$getAbsoluteTime(resourceTiming.connectEnd)
        ],
        [
            "http.request.request_start",
            $e425abf0f1e5a10f$var$getAbsoluteTime(resourceTiming.requestStart)
        ],
        [
            "http.request.response_start",
            $e425abf0f1e5a10f$var$getAbsoluteTime(resourceTiming.responseStart)
        ],
        [
            "http.request.response_end",
            $e425abf0f1e5a10f$var$getAbsoluteTime(resourceTiming.responseEnd)
        ]
    ];
}
/**
 * A function that determines whether to attach tracing headers to a request.
 * This was extracted from `instrumentOutgoingRequests` to make it easier to test shouldAttachHeaders.
 * We only export this fuction for testing purposes.
 */ function $e425abf0f1e5a10f$export$c260386ab3f0b3dd(url, tracePropagationTargets) {
    return (0, $91U3U.stringMatchesSomePattern)(url, tracePropagationTargets || $e425abf0f1e5a10f$export$15bd0305d05ad07b);
}
/**
 * Create and track xhr request spans
 *
 * @returns Span if a span was created, otherwise void.
 */ // eslint-disable-next-line complexity
function $e425abf0f1e5a10f$export$49680d91e75e2ef7(handlerData, shouldCreateSpan, shouldAttachHeaders, spans) {
    const xhr = handlerData.xhr;
    const sentryXhrData = xhr && xhr[0, $ae6dc6125d1c3217$export$55b6bb1e45c6cf59];
    if (!(0, $duCnO.hasTracingEnabled)() || !xhr || xhr.__sentry_own_request__ || !sentryXhrData) return undefined;
    const shouldCreateSpanResult = shouldCreateSpan(sentryXhrData.url);
    // check first if the request has finished and is tracked by an existing span which should now end
    if (handlerData.endTimestamp && shouldCreateSpanResult) {
        const spanId = xhr.__sentry_xhr_span_id__;
        if (!spanId) return;
        const span = spans[spanId];
        if (span && sentryXhrData.status_code !== undefined) {
            span.setHttpStatus(sentryXhrData.status_code);
            span.finish();
            // eslint-disable-next-line @typescript-eslint/no-dynamic-delete
            delete spans[spanId];
        }
        return undefined;
    }
    const hub = (0, $cmFjP.getCurrentHub)();
    const scope = hub.getScope();
    const parentSpan = scope.getSpan();
    const span = shouldCreateSpanResult && parentSpan ? parentSpan.startChild({
        data: {
            type: "xhr",
            "http.method": sentryXhrData.method,
            url: sentryXhrData.url
        },
        description: `${sentryXhrData.method} ${sentryXhrData.url}`,
        op: "http.client",
        origin: "auto.http.browser"
    }) : undefined;
    if (span) {
        xhr.__sentry_xhr_span_id__ = span.spanId;
        spans[xhr.__sentry_xhr_span_id__] = span;
    }
    if (xhr.setRequestHeader && shouldAttachHeaders(sentryXhrData.url)) {
        if (span) {
            const transaction = span && span.transaction;
            const dynamicSamplingContext = transaction && transaction.getDynamicSamplingContext();
            const sentryBaggageHeader = (0, $dzA7g.dynamicSamplingContextToSentryBaggageHeader)(dynamicSamplingContext);
            $e425abf0f1e5a10f$var$setHeaderOnXhr(xhr, span.toTraceparent(), sentryBaggageHeader);
        } else {
            const client = hub.getClient();
            const { traceId: traceId, sampled: sampled, dsc: dsc } = scope.getPropagationContext();
            const sentryTraceHeader = (0, $65HJt.generateSentryTraceHeader)(traceId, undefined, sampled);
            const dynamicSamplingContext = dsc || (client ? (0, $bPHT6.getDynamicSamplingContextFromClient)(traceId, client, scope) : undefined);
            const sentryBaggageHeader = (0, $dzA7g.dynamicSamplingContextToSentryBaggageHeader)(dynamicSamplingContext);
            $e425abf0f1e5a10f$var$setHeaderOnXhr(xhr, sentryTraceHeader, sentryBaggageHeader);
        }
    }
    return span;
}
function $e425abf0f1e5a10f$var$setHeaderOnXhr(xhr, sentryTraceHeader, sentryBaggageHeader) {
    try {
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        xhr.setRequestHeader("sentry-trace", sentryTraceHeader);
        if (sentryBaggageHeader) // From MDN: "If this method is called several times with the same header, the values are merged into one single request header."
        // We can therefore simply set a baggage header without checking what was there before
        // https://developer.mozilla.org/en-US/docs/Web/API/XMLHttpRequest/setRequestHeader
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        xhr.setRequestHeader((0, $dzA7g.BAGGAGE_HEADER_NAME), sentryBaggageHeader);
    } catch (_) {
    // Error: InvalidStateError: Failed to execute 'setRequestHeader' on 'XMLHttpRequest': The object's state must be OPENED.
    }
}



var $cvSY8 = parcelRequire("cvSY8");
var $4g0Ct = parcelRequire("4g0Ct");


/**
 * Default function implementing pageload and navigation transactions
 */ function $fe365ce63ae91e59$export$86649cc09fe75143(customStartTransaction, startTransactionOnPageLoad = true, startTransactionOnLocationChange = true) {
    if (!(0, $fe9433352f19d4b6$export$56d8a8a25bd48b81) || !(0, $fe9433352f19d4b6$export$56d8a8a25bd48b81).location) {
        (0, $a5e85a0c259bdb77$export$16a28057038b10ef) && (0, $4g0Ct.logger).warn("Could not initialize routing instrumentation due to invalid location");
        return;
    }
    let startingUrl = (0, $fe9433352f19d4b6$export$56d8a8a25bd48b81).location.href;
    let activeTransaction;
    if (startTransactionOnPageLoad) activeTransaction = customStartTransaction({
        name: (0, $fe9433352f19d4b6$export$56d8a8a25bd48b81).location.pathname,
        // pageload should always start at timeOrigin (and needs to be in s, not ms)
        startTimestamp: (0, $cvSY8.browserPerformanceTimeOrigin) ? (0, $cvSY8.browserPerformanceTimeOrigin) / 1000 : undefined,
        op: "pageload",
        origin: "auto.pageload.browser",
        metadata: {
            source: "url"
        }
    });
    if (startTransactionOnLocationChange) (0, $2579aac1b9dfd189$export$3f18c56c58114e75)(({ to: to, from: from })=>{
        /**
       * This early return is there to account for some cases where a navigation transaction starts right after
       * long-running pageload. We make sure that if `from` is undefined and a valid `startingURL` exists, we don't
       * create an uneccessary navigation transaction.
       *
       * This was hard to duplicate, but this behavior stopped as soon as this fix was applied. This issue might also
       * only be caused in certain development environments where the usage of a hot module reloader is causing
       * errors.
       */ if (from === undefined && startingUrl && startingUrl.indexOf(to) !== -1) {
            startingUrl = undefined;
            return;
        }
        if (from !== to) {
            startingUrl = undefined;
            if (activeTransaction) {
                (0, $a5e85a0c259bdb77$export$16a28057038b10ef) && (0, $4g0Ct.logger).log(`[Tracing] Finishing current transaction with op: ${activeTransaction.op}`);
                // If there's an open transaction on the scope, we need to finish it before creating an new one.
                activeTransaction.finish();
            }
            activeTransaction = customStartTransaction({
                name: (0, $fe9433352f19d4b6$export$56d8a8a25bd48b81).location.pathname,
                op: "navigation",
                origin: "auto.navigation.browser",
                metadata: {
                    source: "url"
                }
            });
        }
    });
}



const $1a684ef8a4a48899$export$bbd2089f30bd3708 = "BrowserTracing";
/** Options for Browser Tracing integration */ const $1a684ef8a4a48899$var$DEFAULT_BROWSER_TRACING_OPTIONS = {
    ...(0, $2EZoq.TRACING_DEFAULTS),
    markBackgroundTransactions: true,
    routingInstrumentation: (0, $fe365ce63ae91e59$export$86649cc09fe75143),
    startTransactionOnLocationChange: true,
    startTransactionOnPageLoad: true,
    enableLongTask: true,
    _experiments: {},
    ...(0, $e425abf0f1e5a10f$export$cc17fb3c0bc95cd7)
};
/**
 * The Browser Tracing integration automatically instruments browser pageload/navigation
 * actions as transactions, and captures requests, metrics and errors as spans.
 *
 * The integration can be configured with a variety of options, and can be extended to use
 * any routing library. This integration uses {@see IdleTransaction} to create transactions.
 */ class $1a684ef8a4a48899$export$46d3bbd0375f5fa4 {
    // This class currently doesn't have a static `id` field like the other integration classes, because it prevented
    // @sentry/tracing from being treeshaken. Tree shakers do not like static fields, because they behave like side effects.
    // TODO: Come up with a better plan, than using static fields on integration classes, and use that plan on all
    // integrations.
    /** Browser Tracing integration options */ /**
   * @inheritDoc
   */ constructor(_options){
        this.name = $1a684ef8a4a48899$export$bbd2089f30bd3708;
        this._hasSetTracePropagationTargets = false;
        (0, $gu0hs.addTracingExtensions)();
        if (0, $a5e85a0c259bdb77$export$16a28057038b10ef) this._hasSetTracePropagationTargets = !!(_options && // eslint-disable-next-line deprecation/deprecation
        (_options.tracePropagationTargets || _options.tracingOrigins));
        this.options = {
            ...$1a684ef8a4a48899$var$DEFAULT_BROWSER_TRACING_OPTIONS,
            ..._options
        };
        // Special case: enableLongTask can be set in _experiments
        // TODO (v8): Remove this in v8
        if (this.options._experiments.enableLongTask !== undefined) this.options.enableLongTask = this.options._experiments.enableLongTask;
        // TODO (v8): remove this block after tracingOrigins is removed
        // Set tracePropagationTargets to tracingOrigins if specified by the user
        // In case both are specified, tracePropagationTargets takes precedence
        // eslint-disable-next-line deprecation/deprecation
        if (_options && !_options.tracePropagationTargets && _options.tracingOrigins) // eslint-disable-next-line deprecation/deprecation
        this.options.tracePropagationTargets = _options.tracingOrigins;
        this._collectWebVitals = (0, $df8507bffbb2043c$export$7c69f0412d101b88)();
        if (this.options.enableLongTask) (0, $df8507bffbb2043c$export$f396d19077034ad2)();
        if (this.options._experiments.enableInteractions) (0, $df8507bffbb2043c$export$e27543e0976315e4)();
    }
    /**
   * @inheritDoc
   */ setupOnce(_, getCurrentHub) {
        this._getCurrentHub = getCurrentHub;
        const hub = getCurrentHub();
        const client = hub.getClient();
        const clientOptions = client && client.getOptions();
        const { routingInstrumentation: instrumentRouting, startTransactionOnLocationChange: startTransactionOnLocationChange, startTransactionOnPageLoad: startTransactionOnPageLoad, markBackgroundTransactions: markBackgroundTransactions, traceFetch: traceFetch, traceXHR: traceXHR, shouldCreateSpanForRequest: shouldCreateSpanForRequest, enableHTTPTimings: enableHTTPTimings, _experiments: _experiments } = this.options;
        const clientOptionsTracePropagationTargets = clientOptions && clientOptions.tracePropagationTargets;
        // There are three ways to configure tracePropagationTargets:
        // 1. via top level client option `tracePropagationTargets`
        // 2. via BrowserTracing option `tracePropagationTargets`
        // 3. via BrowserTracing option `tracingOrigins` (deprecated)
        //
        // To avoid confusion, favour top level client option `tracePropagationTargets`, and fallback to
        // BrowserTracing option `tracePropagationTargets` and then `tracingOrigins` (deprecated).
        // This is done as it minimizes bundle size (we don't have to have undefined checks).
        //
        // If both 1 and either one of 2 or 3 are set (from above), we log out a warning.
        // eslint-disable-next-line deprecation/deprecation
        const tracePropagationTargets = clientOptionsTracePropagationTargets || this.options.tracePropagationTargets;
        if ((0, $a5e85a0c259bdb77$export$16a28057038b10ef) && this._hasSetTracePropagationTargets && clientOptionsTracePropagationTargets) (0, $4g0Ct.logger).warn("[Tracing] The `tracePropagationTargets` option was set in the BrowserTracing integration and top level `Sentry.init`. The top level `Sentry.init` value is being used.");
        instrumentRouting((context)=>{
            const transaction = this._createRouteTransaction(context);
            this.options._experiments.onStartRouteTransaction && this.options._experiments.onStartRouteTransaction(transaction, context, getCurrentHub);
            return transaction;
        }, startTransactionOnPageLoad, startTransactionOnLocationChange);
        if (markBackgroundTransactions) (0, $a50bc2aef3fcf638$export$6f18f55521af71a1)();
        if (_experiments.enableInteractions) this._registerInteractionListener();
        (0, $e425abf0f1e5a10f$export$864489cb3478db3e)({
            traceFetch: traceFetch,
            traceXHR: traceXHR,
            tracePropagationTargets: tracePropagationTargets,
            shouldCreateSpanForRequest: shouldCreateSpanForRequest,
            enableHTTPTimings: enableHTTPTimings
        });
    }
    /** Create routing idle transaction. */ _createRouteTransaction(context) {
        if (!this._getCurrentHub) {
            (0, $a5e85a0c259bdb77$export$16a28057038b10ef) && (0, $4g0Ct.logger).warn(`[Tracing] Did not create ${context.op} transaction because _getCurrentHub is invalid.`);
            return undefined;
        }
        const hub = this._getCurrentHub();
        const { beforeNavigate: beforeNavigate, idleTimeout: idleTimeout, finalTimeout: finalTimeout, heartbeatInterval: heartbeatInterval } = this.options;
        const isPageloadTransaction = context.op === "pageload";
        const sentryTrace = isPageloadTransaction ? $1a684ef8a4a48899$export$f147b32b03c9cf11("sentry-trace") : "";
        const baggage = isPageloadTransaction ? $1a684ef8a4a48899$export$f147b32b03c9cf11("baggage") : "";
        const { traceparentData: traceparentData, dynamicSamplingContext: dynamicSamplingContext, propagationContext: propagationContext } = (0, $65HJt.tracingContextFromHeaders)(sentryTrace, baggage);
        const expandedContext = {
            ...context,
            ...traceparentData,
            metadata: {
                ...context.metadata,
                dynamicSamplingContext: traceparentData && !dynamicSamplingContext ? {} : dynamicSamplingContext
            },
            trimEnd: true
        };
        const modifiedContext = typeof beforeNavigate === "function" ? beforeNavigate(expandedContext) : expandedContext;
        // For backwards compatibility reasons, beforeNavigate can return undefined to "drop" the transaction (prevent it
        // from being sent to Sentry).
        const finalContext = modifiedContext === undefined ? {
            ...expandedContext,
            sampled: false
        } : modifiedContext;
        // If `beforeNavigate` set a custom name, record that fact
        finalContext.metadata = finalContext.name !== expandedContext.name ? {
            ...finalContext.metadata,
            source: "custom"
        } : finalContext.metadata;
        this._latestRouteName = finalContext.name;
        this._latestRouteSource = finalContext.metadata && finalContext.metadata.source;
        if (finalContext.sampled === false) (0, $a5e85a0c259bdb77$export$16a28057038b10ef) && (0, $4g0Ct.logger).log(`[Tracing] Will not send ${finalContext.op} transaction because of beforeNavigate.`);
        (0, $a5e85a0c259bdb77$export$16a28057038b10ef) && (0, $4g0Ct.logger).log(`[Tracing] Starting ${finalContext.op} transaction on scope`);
        const { location: location } = (0, $fe9433352f19d4b6$export$56d8a8a25bd48b81);
        const idleTransaction = (0, $gu0hs.startIdleTransaction)(hub, finalContext, idleTimeout, finalTimeout, true, {
            location: location
        }, heartbeatInterval);
        const scope = hub.getScope();
        // If it's a pageload and there is a meta tag set
        // use the traceparentData as the propagation context
        if (isPageloadTransaction && traceparentData) scope.setPropagationContext(propagationContext);
        else // Navigation transactions should set a new propagation context based on the
        // created idle transaction.
        scope.setPropagationContext({
            traceId: idleTransaction.traceId,
            spanId: idleTransaction.spanId,
            parentSpanId: idleTransaction.parentSpanId,
            sampled: idleTransaction.sampled
        });
        idleTransaction.registerBeforeFinishCallback((transaction)=>{
            this._collectWebVitals();
            (0, $df8507bffbb2043c$export$5f8fa6b3467a7443)(transaction);
        });
        return idleTransaction;
    }
    /** Start listener for interaction transactions */ _registerInteractionListener() {
        let inflightInteractionTransaction;
        const registerInteractionTransaction = ()=>{
            const { idleTimeout: idleTimeout, finalTimeout: finalTimeout, heartbeatInterval: heartbeatInterval } = this.options;
            const op = "ui.action.click";
            const currentTransaction = (0, $5UTPE.getActiveTransaction)();
            if (currentTransaction && currentTransaction.op && [
                "navigation",
                "pageload"
            ].includes(currentTransaction.op)) {
                (0, $a5e85a0c259bdb77$export$16a28057038b10ef) && (0, $4g0Ct.logger).warn(`[Tracing] Did not create ${op} transaction because a pageload or navigation transaction is in progress.`);
                return undefined;
            }
            if (inflightInteractionTransaction) {
                inflightInteractionTransaction.setFinishReason("interactionInterrupted");
                inflightInteractionTransaction.finish();
                inflightInteractionTransaction = undefined;
            }
            if (!this._getCurrentHub) {
                (0, $a5e85a0c259bdb77$export$16a28057038b10ef) && (0, $4g0Ct.logger).warn(`[Tracing] Did not create ${op} transaction because _getCurrentHub is invalid.`);
                return undefined;
            }
            if (!this._latestRouteName) {
                (0, $a5e85a0c259bdb77$export$16a28057038b10ef) && (0, $4g0Ct.logger).warn(`[Tracing] Did not create ${op} transaction because _latestRouteName is missing.`);
                return undefined;
            }
            const hub = this._getCurrentHub();
            const { location: location } = (0, $fe9433352f19d4b6$export$56d8a8a25bd48b81);
            const context = {
                name: this._latestRouteName,
                op: op,
                trimEnd: true,
                metadata: {
                    source: this._latestRouteSource || "url"
                }
            };
            inflightInteractionTransaction = (0, $gu0hs.startIdleTransaction)(hub, context, idleTimeout, finalTimeout, true, {
                location: location
            }, heartbeatInterval);
        };
        [
            "click"
        ].forEach((type)=>{
            addEventListener(type, registerInteractionTransaction, {
                once: false,
                capture: true
            });
        });
    }
}
/** Returns the value of a meta tag */ function $1a684ef8a4a48899$export$f147b32b03c9cf11(metaName) {
    // Can't specify generic to `getDomElement` because tracing can be used
    // in a variety of environments, have to disable `no-unsafe-member-access`
    // as a result.
    const metaTag = (0, $ibKgU.getDomElement)(`meta[name=${metaName}]`);
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    return metaTag ? metaTag.getAttribute("content") : undefined;
}

/**
 * This code was originally copied from the 'cookie` module at v0.5.0 and was simplified for our use case.
 * https://github.com/jshttp/cookie/blob/a0c84147aab6266bdb3996cf4062e93907c0b0fc/index.js
 * It had the following license:
 *
 * (The MIT License)
 *
 * Copyright (c) 2012-2014 Roman Shtylman <shtylman@gmail.com>
 * Copyright (c) 2015 Douglas Christopher Wilson <doug@somethingdoug.com>
 *
 * Permission is hereby granted, free of charge, to any person obtaining
 * a copy of this software and associated documentation files (the
 * 'Software'), to deal in the Software without restriction, including
 * without limitation the rights to use, copy, modify, merge, publish,
 * distribute, sublicense, and/or sell copies of the Software, and to
 * permit persons to whom the Software is furnished to do so, subject to
 * the following conditions:
 *
 * The above copyright notice and this permission notice shall be
 * included in all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED 'AS IS', WITHOUT WARRANTY OF ANY KIND,
 * EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
 * MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT.
 * IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY
 * CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT,
 * TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE
 * SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
 */ /**
 * Parses a cookie string
 */ function $99dc60c0d6480f52$export$d0eaf3e94be578f6(str) {
    const obj = {};
    let index = 0;
    while(index < str.length){
        const eqIdx = str.indexOf("=", index);
        // no more cookie pairs
        if (eqIdx === -1) break;
        let endIdx = str.indexOf(";", index);
        if (endIdx === -1) endIdx = str.length;
        else if (endIdx < eqIdx) {
            // backtrack on prior semicolon
            index = str.lastIndexOf(";", eqIdx - 1) + 1;
            continue;
        }
        const key = str.slice(index, eqIdx).trim();
        // only assign once
        if (undefined === obj[key]) {
            let val = str.slice(eqIdx + 1, endIdx).trim();
            // quoted values
            if (val.charCodeAt(0) === 0x22) val = val.slice(1, -1);
            try {
                obj[key] = val.indexOf("%") !== -1 ? decodeURIComponent(val) : val;
            } catch (e) {
                obj[key] = val;
            }
        }
        index = endIdx + 1;
    }
    return obj;
}



var $eKZKa = parcelRequire("eKZKa");

var $2zW56 = parcelRequire("2zW56");

var $4g0Ct = parcelRequire("4g0Ct");

var $drMc1 = parcelRequire("drMc1");

const $bfbb651c762ddc49$var$DEFAULT_INCLUDES = {
    ip: false,
    request: true,
    transaction: true,
    user: true
};
const $bfbb651c762ddc49$var$DEFAULT_REQUEST_INCLUDES = [
    "cookies",
    "data",
    "headers",
    "method",
    "query_string",
    "url"
];
const $bfbb651c762ddc49$export$33c1c602a3538e5e = [
    "id",
    "username",
    "email"
];
/**
 * Sets parameterized route as transaction name e.g.: `GET /users/:id`
 * Also adds more context data on the transaction from the request
 */ function $bfbb651c762ddc49$export$1973410ef8793cd6(transaction, req, deps) {
    if (!transaction) return;
    if (!transaction.metadata.source || transaction.metadata.source === "url") // Attempt to grab a parameterized route off of the request
    transaction.setName(...$bfbb651c762ddc49$export$8c5ebee2e5bb9575(req, {
        path: true,
        method: true
    }));
    transaction.setData("url", req.originalUrl || req.url);
    if (req.baseUrl) transaction.setData("baseUrl", req.baseUrl);
    transaction.setData("query", $bfbb651c762ddc49$var$extractQueryParams(req, deps));
}
/**
 * Extracts a complete and parameterized path from the request object and uses it to construct transaction name.
 * If the parameterized transaction name cannot be extracted, we fall back to the raw URL.
 *
 * Additionally, this function determines and returns the transaction name source
 *
 * eg. GET /mountpoint/user/:id
 *
 * @param req A request object
 * @param options What to include in the transaction name (method, path, or a custom route name to be
 *                used instead of the request's route)
 *
 * @returns A tuple of the fully constructed transaction name [0] and its source [1] (can be either 'route' or 'url')
 */ function $bfbb651c762ddc49$export$8c5ebee2e5bb9575(req, options = {}) {
    const method = req.method && req.method.toUpperCase();
    let path = "";
    let source = "url";
    // Check to see if there's a parameterized route we can use (as there is in Express)
    if (options.customRoute || req.route) {
        path = options.customRoute || `${req.baseUrl || ""}${req.route && req.route.path}`;
        source = "route";
    } else if (req.originalUrl || req.url) path = (0, $25257edadcf16f49$export$ce084c78234bd35)(req.originalUrl || req.url || "");
    let name = "";
    if (options.method && method) name += method;
    if (options.method && options.path) name += " ";
    if (options.path && path) name += path;
    return [
        name,
        source
    ];
}
/** JSDoc */ function $bfbb651c762ddc49$var$extractTransaction(req, type) {
    switch(type){
        case "path":
            return $bfbb651c762ddc49$export$8c5ebee2e5bb9575(req, {
                path: true
            })[0];
        case "handler":
            return req.route && req.route.stack && req.route.stack[0] && req.route.stack[0].name || "<anonymous>";
        case "methodPath":
        default:
            {
                // if exist _reconstructedRoute return that path instead of route.path
                const customRoute = req._reconstructedRoute ? req._reconstructedRoute : undefined;
                return $bfbb651c762ddc49$export$8c5ebee2e5bb9575(req, {
                    path: true,
                    method: true,
                    customRoute: customRoute
                })[0];
            }
    }
}
/** JSDoc */ function $bfbb651c762ddc49$var$extractUserData(user, keys) {
    const extractedUser = {};
    const attributes = Array.isArray(keys) ? keys : $bfbb651c762ddc49$export$33c1c602a3538e5e;
    attributes.forEach((key)=>{
        if (user && key in user) extractedUser[key] = user[key];
    });
    return extractedUser;
}
/**
 * Normalize data from the request object, accounting for framework differences.
 *
 * @param req The request object from which to extract data
 * @param options.include An optional array of keys to include in the normalized data. Defaults to
 * DEFAULT_REQUEST_INCLUDES if not provided.
 * @param options.deps Injected, platform-specific dependencies
 * @returns An object containing normalized request data
 */ function $bfbb651c762ddc49$export$b5c5d78255f11c84(req, options) {
    const { include: include = $bfbb651c762ddc49$var$DEFAULT_REQUEST_INCLUDES, deps: deps } = options || {};
    const requestData = {};
    // headers:
    //   node, express, koa, nextjs: req.headers
    const headers = req.headers || {};
    // method:
    //   node, express, koa, nextjs: req.method
    const method = req.method;
    // host:
    //   express: req.hostname in > 4 and req.host in < 4
    //   koa: req.host
    //   node, nextjs: req.headers.host
    const host = req.hostname || req.host || headers.host || "<no host>";
    // protocol:
    //   node, nextjs: <n/a>
    //   express, koa: req.protocol
    const protocol = req.protocol === "https" || req.socket && req.socket.encrypted ? "https" : "http";
    // url (including path and query string):
    //   node, express: req.originalUrl
    //   koa, nextjs: req.url
    const originalUrl = req.originalUrl || req.url || "";
    // absolute url
    const absoluteUrl = originalUrl.startsWith(protocol) ? originalUrl : `${protocol}://${host}${originalUrl}`;
    include.forEach((key)=>{
        switch(key){
            case "headers":
                requestData.headers = headers;
                // Remove the Cookie header in case cookie data should not be included in the event
                if (!include.includes("cookies")) delete requestData.headers.cookie;
                break;
            case "method":
                requestData.method = method;
                break;
            case "url":
                requestData.url = absoluteUrl;
                break;
            case "cookies":
                // cookies:
                //   node, express, koa: req.headers.cookie
                //   vercel, sails.js, express (w/ cookie middleware), nextjs: req.cookies
                requestData.cookies = // TODO (v8 / #5257): We're only sending the empty object for backwards compatibility, so the last bit can
                // come off in v8
                req.cookies || headers.cookie && (0, $99dc60c0d6480f52$export$d0eaf3e94be578f6)(headers.cookie) || {};
                break;
            case "query_string":
                // query string:
                //   node: req.url (raw)
                //   express, koa, nextjs: req.query
                // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
                requestData.query_string = $bfbb651c762ddc49$var$extractQueryParams(req, deps);
                break;
            case "data":
                if (method === "GET" || method === "HEAD") break;
                // body data:
                //   express, koa, nextjs: req.body
                //
                //   when using node by itself, you have to read the incoming stream(see
                //   https://nodejs.dev/learn/get-http-request-body-data-using-nodejs); if a user is doing that, we can't know
                //   where they're going to store the final result, so they'll have to capture this data themselves
                if (req.body !== undefined) requestData.data = (0, $2zW56.isString)(req.body) ? req.body : JSON.stringify((0, $drMc1.normalize)(req.body));
                break;
            default:
                if (({}).hasOwnProperty.call(req, key)) requestData[key] = req[key];
        }
    });
    return requestData;
}
/**
 * Add data from the given request to the given event
 *
 * @param event The event to which the request data will be added
 * @param req Request object
 * @param options.include Flags to control what data is included
 * @param options.deps Injected platform-specific dependencies
 * @returns The mutated `Event` object
 */ function $bfbb651c762ddc49$export$e560aeb323d2791d(event, req, options) {
    const include = {
        ...$bfbb651c762ddc49$var$DEFAULT_INCLUDES,
        ...options && options.include
    };
    if (include.request) {
        const extractedRequestData = Array.isArray(include.request) ? $bfbb651c762ddc49$export$b5c5d78255f11c84(req, {
            include: include.request,
            deps: options && options.deps
        }) : $bfbb651c762ddc49$export$b5c5d78255f11c84(req, {
            deps: options && options.deps
        });
        event.request = {
            ...event.request,
            ...extractedRequestData
        };
    }
    if (include.user) {
        const extractedUser = req.user && (0, $2zW56.isPlainObject)(req.user) ? $bfbb651c762ddc49$var$extractUserData(req.user, include.user) : {};
        if (Object.keys(extractedUser).length) event.user = {
            ...event.user,
            ...extractedUser
        };
    }
    // client ip:
    //   node, nextjs: req.socket.remoteAddress
    //   express, koa: req.ip
    if (include.ip) {
        const ip = req.ip || req.socket && req.socket.remoteAddress;
        if (ip) event.user = {
            ...event.user,
            ip_address: ip
        };
    }
    if (include.transaction && !event.transaction) // TODO do we even need this anymore?
    // TODO make this work for nextjs
    event.transaction = $bfbb651c762ddc49$var$extractTransaction(req, include.transaction);
    return event;
}
function $bfbb651c762ddc49$var$extractQueryParams(req, deps) {
    // url (including path and query string):
    //   node, express: req.originalUrl
    //   koa, nextjs: req.url
    let originalUrl = req.originalUrl || req.url || "";
    if (!originalUrl) return;
    // The `URL` constructor can't handle internal URLs of the form `/some/path/here`, so stick a dummy protocol and
    // hostname on the beginning. Since the point here is just to grab the query string, it doesn't matter what we use.
    if (originalUrl.startsWith("/")) originalUrl = `http://dogs.are.great${originalUrl}`;
    try {
        return req.query || new URL(originalUrl).search.slice(1) || // In Node 8, `URL` isn't in the global scope, so we have to use the built-in module from Node
        deps && deps.url && deps.url.parse(originalUrl).query || undefined;
    } catch (e2) {
        return undefined;
    }
}
/**
 * Transforms a `Headers` object that implements the `Web Fetch API` (https://developer.mozilla.org/en-US/docs/Web/API/Headers) into a simple key-value dict.
 * The header keys will be lower case: e.g. A "Content-Type" header will be stored as "content-type".
 */ function $bfbb651c762ddc49$export$fee0927b05379c23(winterCGHeaders) {
    const headers = {};
    try {
        winterCGHeaders.forEach((value, key)=>{
            if (typeof value === "string") // We check that value is a string even though it might be redundant to make sure prototype pollution is not possible.
            headers[key] = value;
        });
    } catch (e) {
        (0, $eKZKa.DEBUG_BUILD) && (0, $4g0Ct.logger).warn("Sentry failed extracting headers from a request object. If you see this, please file an issue.");
    }
    return headers;
}
/**
 * Converts a `Request` object that implements the `Web Fetch API` (https://developer.mozilla.org/en-US/docs/Web/API/Headers) into the format that the `RequestData` integration understands.
 */ function $bfbb651c762ddc49$export$49a11ed11911fd29(req) {
    const headers = $bfbb651c762ddc49$export$fee0927b05379c23(req.headers);
    return {
        method: req.method,
        url: req.url,
        headers: headers
    };
}


var $3bpJ1 = parcelRequire("3bpJ1");
var $2zW56 = parcelRequire("2zW56");
var $4g0Ct = parcelRequire("4g0Ct");


/**
 * Express integration
 *
 * Provides an request and error handler for Express framework as well as tracing capabilities
 */ class $04470ea8dc00f88f$export$6dafdd8fec05099d {
    /**
   * @inheritDoc
   */ static __initStatic() {
        this.id = "Express";
    }
    /**
   * @inheritDoc
   */ /**
   * Express App instance
   */ /**
   * @inheritDoc
   */ constructor(options = {}){
        this.name = $04470ea8dc00f88f$export$6dafdd8fec05099d.id;
        this._router = options.router || options.app;
        this._methods = (Array.isArray(options.methods) ? options.methods : []).concat("use");
    }
    /**
   * @inheritDoc
   */ setupOnce(_, getCurrentHub) {
        if (!this._router) {
            (0, $a5e85a0c259bdb77$export$16a28057038b10ef) && (0, $4g0Ct.logger).error("ExpressIntegration is missing an Express instance");
            return;
        }
        if ((0, $a9d137194c535c9f$export$34db76d03eb96b7e)(getCurrentHub)) {
            (0, $a5e85a0c259bdb77$export$16a28057038b10ef) && (0, $4g0Ct.logger).log("Express Integration is skipped because of instrumenter configuration.");
            return;
        }
        $04470ea8dc00f88f$var$instrumentMiddlewares(this._router, this._methods);
        $04470ea8dc00f88f$var$instrumentRouter(this._router);
    }
}
$04470ea8dc00f88f$export$6dafdd8fec05099d.__initStatic();
/**
 * Wraps original middleware function in a tracing call, which stores the info about the call as a span,
 * and finishes it once the middleware is done invoking.
 *
 * Express middlewares have 3 various forms, thus we have to take care of all of them:
 * // sync
 * app.use(function (req, res) { ... })
 * // async
 * app.use(function (req, res, next) { ... })
 * // error handler
 * app.use(function (err, req, res, next) { ... })
 *
 * They all internally delegate to the `router[method]` of the given application instance.
 */ // eslint-disable-next-line @typescript-eslint/ban-types, @typescript-eslint/no-explicit-any
function $04470ea8dc00f88f$var$wrap(fn, method) {
    const arity = fn.length;
    switch(arity){
        case 2:
            return function(req, res) {
                const transaction = res.__sentry_transaction;
                if (transaction) {
                    const span = transaction.startChild({
                        description: fn.name,
                        op: `middleware.express.${method}`,
                        origin: "auto.middleware.express"
                    });
                    res.once("finish", ()=>{
                        span.finish();
                    });
                }
                return fn.call(this, req, res);
            };
        case 3:
            return function(req, res, next) {
                const transaction = res.__sentry_transaction;
                const span = (0, $ba7e9f49429c2354$export$3cc482e6b02f32f7)([
                    transaction,
                    "optionalAccess",
                    (_2)=>_2.startChild,
                    "call",
                    (_3)=>_3({
                            description: fn.name,
                            op: `middleware.express.${method}`,
                            origin: "auto.middleware.express"
                        })
                ]);
                fn.call(this, req, res, function(...args) {
                    (0, $ba7e9f49429c2354$export$3cc482e6b02f32f7)([
                        span,
                        "optionalAccess",
                        (_4)=>_4.finish,
                        "call",
                        (_5)=>_5()
                    ]);
                    next.call(this, ...args);
                });
            };
        case 4:
            return function(err, req, res, next) {
                const transaction = res.__sentry_transaction;
                const span = (0, $ba7e9f49429c2354$export$3cc482e6b02f32f7)([
                    transaction,
                    "optionalAccess",
                    (_6)=>_6.startChild,
                    "call",
                    (_7)=>_7({
                            description: fn.name,
                            op: `middleware.express.${method}`,
                            origin: "auto.middleware.express"
                        })
                ]);
                fn.call(this, err, req, res, function(...args) {
                    (0, $ba7e9f49429c2354$export$3cc482e6b02f32f7)([
                        span,
                        "optionalAccess",
                        (_8)=>_8.finish,
                        "call",
                        (_9)=>_9()
                    ]);
                    next.call(this, ...args);
                });
            };
        default:
            throw new Error(`Express middleware takes 2-4 arguments. Got: ${arity}`);
    }
}
/**
 * Takes all the function arguments passed to the original `app` or `router` method, eg. `app.use` or `router.use`
 * and wraps every function, as well as array of functions with a call to our `wrap` method.
 * We have to take care of the arrays as well as iterate over all of the arguments,
 * as `app.use` can accept middlewares in few various forms.
 *
 * app.use([<path>], <fn>)
 * app.use([<path>], <fn>, ...<fn>)
 * app.use([<path>], ...<fn>[])
 */ function $04470ea8dc00f88f$var$wrapMiddlewareArgs(args, method) {
    return args.map((arg)=>{
        if (typeof arg === "function") return $04470ea8dc00f88f$var$wrap(arg, method);
        if (Array.isArray(arg)) return arg.map((a)=>{
            if (typeof a === "function") return $04470ea8dc00f88f$var$wrap(a, method);
            return a;
        });
        return arg;
    });
}
/**
 * Patches original router to utilize our tracing functionality
 */ function $04470ea8dc00f88f$var$patchMiddleware(router, method) {
    const originalCallback = router[method];
    router[method] = function(...args) {
        return originalCallback.call(this, ...$04470ea8dc00f88f$var$wrapMiddlewareArgs(args, method));
    };
    return router;
}
/**
 * Patches original router methods
 */ function $04470ea8dc00f88f$var$instrumentMiddlewares(router, methods = []) {
    methods.forEach((method)=>$04470ea8dc00f88f$var$patchMiddleware(router, method));
}
/**
 * Patches the prototype of Express.Router to accumulate the resolved route
 * if a layer instance's `match` function was called and it returned a successful match.
 *
 * @see https://github.com/expressjs/express/blob/master/lib/router/index.js
 *
 * @param appOrRouter the router instance which can either be an app (i.e. top-level) or a (nested) router.
 */ function $04470ea8dc00f88f$var$instrumentRouter(appOrRouter) {
    // This is how we can distinguish between app and routers
    const isApp = "settings" in appOrRouter;
    // In case the app's top-level router hasn't been initialized yet, we have to do it now
    if (isApp && appOrRouter._router === undefined && appOrRouter.lazyrouter) appOrRouter.lazyrouter();
    const router = isApp ? appOrRouter._router : appOrRouter;
    if (!router) {
        /*
    If we end up here, this means likely that this integration is used with Express 3 or Express 5.
    For now, we don't support these versions (3 is very old and 5 is still in beta). To support Express 5,
    we'd need to make more changes to the routing instrumentation because the router is no longer part of
    the Express core package but maintained in its own package. The new router has different function
    signatures and works slightly differently, demanding more changes than just taking the router from
    `app.router` instead of `app._router`.
    @see https://github.com/pillarjs/router

    TODO: Proper Express 5 support
    */ (0, $a5e85a0c259bdb77$export$16a28057038b10ef) && (0, $4g0Ct.logger).debug("Cannot instrument router for URL Parameterization (did not find a valid router).");
        (0, $a5e85a0c259bdb77$export$16a28057038b10ef) && (0, $4g0Ct.logger).debug("Routing instrumentation is currently only supported in Express 4.");
        return;
    }
    const routerProto = Object.getPrototypeOf(router);
    const originalProcessParams = routerProto.process_params;
    routerProto.process_params = function process_params(layer, called, req, res, done) {
        // Base case: We're in the first part of the URL (thus we start with the root '/')
        if (!req._reconstructedRoute) req._reconstructedRoute = "";
        // If the layer's partial route has params, is a regex or an array, the route is stored in layer.route.
        const { layerRoutePath: layerRoutePath, isRegex: isRegex, isArray: isArray, numExtraSegments: numExtraSegments } = $04470ea8dc00f88f$var$getLayerRoutePathInfo(layer);
        if (layerRoutePath || isRegex || isArray) req._hasParameters = true;
        // Otherwise, the hardcoded path (i.e. a partial route without params) is stored in layer.path
        let partialRoute;
        if (layerRoutePath) partialRoute = layerRoutePath;
        else /**
       * prevent duplicate segment in _reconstructedRoute param if router match multiple routes before final path
       * example:
       * original url: /api/v1/1234
       * prevent: /api/api/v1/:userId
       * router structure
       * /api -> middleware
       * /api/v1 -> middleware
       * /1234 -> endpoint with param :userId
       * final _reconstructedRoute is /api/v1/:userId
       */ partialRoute = $04470ea8dc00f88f$export$ea5dbbfd8423c1fa(req.originalUrl, req._reconstructedRoute, layer.path) || "";
        // Normalize the partial route so that it doesn't contain leading or trailing slashes
        // and exclude empty or '*' wildcard routes.
        // The exclusion of '*' routes is our best effort to not "pollute" the transaction name
        // with interim handlers (e.g. ones that check authentication or do other middleware stuff).
        // We want to end up with the parameterized URL of the incoming request without any extraneous path segments.
        const finalPartialRoute = partialRoute.split("/").filter((segment)=>segment.length > 0 && (isRegex || isArray || !segment.includes("*"))).join("/");
        // If we found a valid partial URL, we append it to the reconstructed route
        if (finalPartialRoute && finalPartialRoute.length > 0) // If the partial route is from a regex route, we append a '/' to close the regex
        req._reconstructedRoute += `/${finalPartialRoute}${isRegex ? "/" : ""}`;
        // Now we check if we are in the "last" part of the route. We determine this by comparing the
        // number of URL segments from the original URL to that of our reconstructed parameterized URL.
        // If we've reached our final destination, we update the transaction name.
        const urlLength = (0, $25257edadcf16f49$export$69dd85280a8d374c)((0, $25257edadcf16f49$export$ce084c78234bd35)(req.originalUrl || "")) + numExtraSegments;
        const routeLength = (0, $25257edadcf16f49$export$69dd85280a8d374c)(req._reconstructedRoute);
        if (urlLength === routeLength) {
            if (!req._hasParameters) {
                if (req._reconstructedRoute !== req.originalUrl) req._reconstructedRoute = req.originalUrl ? (0, $25257edadcf16f49$export$ce084c78234bd35)(req.originalUrl) : req.originalUrl;
            }
            const transaction = res.__sentry_transaction;
            if (transaction && transaction.metadata.source !== "custom") {
                // If the request URL is '/' or empty, the reconstructed route will be empty.
                // Therefore, we fall back to setting the final route to '/' in this case.
                const finalRoute = req._reconstructedRoute || "/";
                transaction.setName(...(0, $bfbb651c762ddc49$export$8c5ebee2e5bb9575)(req, {
                    path: true,
                    method: true,
                    customRoute: finalRoute
                }));
            }
        }
        return originalProcessParams.call(this, layer, called, req, res, done);
    };
}
/**
 * Recreate layer.route.path from layer.regexp and layer.keys.
 * Works until express.js used package path-to-regexp@0.1.7
 * or until layer.keys contain offset attribute
 *
 * @param layer the layer to extract the stringified route from
 *
 * @returns string in layer.route.path structure 'router/:pathParam' or undefined
 */ const $04470ea8dc00f88f$export$bde9c19304d7dbd3 = (path, regexp, keys)=>{
    if (!path || !regexp || !keys || Object.keys(keys).length === 0 || !(0, $ba7e9f49429c2354$export$3cc482e6b02f32f7)([
        keys,
        "access",
        (_10)=>_10[0],
        "optionalAccess",
        (_11)=>_11.offset
    ])) return undefined;
    const orderedKeys = keys.sort((a, b)=>a.offset - b.offset);
    // add d flag for getting indices from regexp result
    const pathRegex = new RegExp(regexp, `${regexp.flags}d`);
    /**
   * use custom type cause of TS error with missing indices in RegExpExecArray
   */ const execResult = pathRegex.exec(path);
    if (!execResult || !execResult.indices) return undefined;
    /**
   * remove first match from regex cause contain whole layer.path
   */ const [, ...paramIndices] = execResult.indices;
    if (paramIndices.length !== orderedKeys.length) return undefined;
    let resultPath = path;
    let indexShift = 0;
    /**
   * iterate param matches from regexp.exec
   */ paramIndices.forEach((item, index)=>{
        /** check if offsets is define because in some cases regex d flag returns undefined */ if (item) {
            const [startOffset, endOffset] = item;
            /**
       * isolate part before param
       */ const substr1 = resultPath.substring(0, startOffset - indexShift);
            /**
       * define paramName as replacement in format :pathParam
       */ const replacement = `:${orderedKeys[index].name}`;
            /**
       * isolate part after param
       */ const substr2 = resultPath.substring(endOffset - indexShift);
            /**
       * recreate original path but with param replacement
       */ resultPath = substr1 + replacement + substr2;
            /**
       * calculate new index shift after resultPath was modified
       */ indexShift = indexShift + (endOffset - startOffset - replacement.length);
        }
    });
    return resultPath;
};
/**
 * Extracts and stringifies the layer's route which can either be a string with parameters (`users/:id`),
 * a RegEx (`/test/`) or an array of strings and regexes (`['/path1', /\/path[2-5]/, /path/:id]`). Additionally
 * returns extra information about the route, such as if the route is defined as regex or as an array.
 *
 * @param layer the layer to extract the stringified route from
 *
 * @returns an object containing the stringified route, a flag determining if the route was a regex
 *          and the number of extra segments to the matched path that are additionally in the route,
 *          if the route was an array (defaults to 0).
 */ function $04470ea8dc00f88f$var$getLayerRoutePathInfo(layer) {
    let lrp = (0, $ba7e9f49429c2354$export$3cc482e6b02f32f7)([
        layer,
        "access",
        (_12)=>_12.route,
        "optionalAccess",
        (_13)=>_13.path
    ]);
    const isRegex = (0, $2zW56.isRegExp)(lrp);
    const isArray = Array.isArray(lrp);
    if (!lrp) {
        // parse node.js major version
        // Next.js will complain if we directly use `proces.versions` here because of edge runtime.
        const [major] = (0, $3bpJ1.GLOBAL_OBJ).process.versions.node.split(".").map(Number);
        // allow call extractOriginalRoute only if node version support Regex d flag, node 16+
        if (major >= 16) /**
       * If lrp does not exist try to recreate original layer path from route regexp
       */ lrp = $04470ea8dc00f88f$export$bde9c19304d7dbd3(layer.path, layer.regexp, layer.keys);
    }
    if (!lrp) return {
        isRegex: isRegex,
        isArray: isArray,
        numExtraSegments: 0
    };
    const numExtraSegments = isArray ? Math.max($04470ea8dc00f88f$var$getNumberOfArrayUrlSegments(lrp) - (0, $25257edadcf16f49$export$69dd85280a8d374c)(layer.path || ""), 0) : 0;
    const layerRoutePath = $04470ea8dc00f88f$var$getLayerRoutePathString(isArray, lrp);
    return {
        layerRoutePath: layerRoutePath,
        isRegex: isRegex,
        isArray: isArray,
        numExtraSegments: numExtraSegments
    };
}
/**
 * Returns the number of URL segments in an array of routes
 *
 * Example: ['/api/test', /\/api\/post[0-9]/, '/users/:id/details`] -> 7
 */ function $04470ea8dc00f88f$var$getNumberOfArrayUrlSegments(routesArray) {
    return routesArray.reduce((accNumSegments, currentRoute)=>{
        // array members can be a RegEx -> convert them toString
        return accNumSegments + (0, $25257edadcf16f49$export$69dd85280a8d374c)(currentRoute.toString());
    }, 0);
}
/**
 * Extracts and returns the stringified version of the layers route path
 * Handles route arrays (by joining the paths together) as well as RegExp and normal
 * string values (in the latter case the toString conversion is technically unnecessary but
 * it doesn't hurt us either).
 */ function $04470ea8dc00f88f$var$getLayerRoutePathString(isArray, lrp) {
    if (isArray) return lrp.map((r)=>r.toString()).join(",");
    return lrp && lrp.toString();
}
/**
 * remove duplicate segment contain in layerPath against reconstructedRoute,
 * and return only unique segment that can be added into reconstructedRoute
 */ function $04470ea8dc00f88f$export$ea5dbbfd8423c1fa(originalUrl, reconstructedRoute, layerPath) {
    // filter query params
    const normalizeURL = (0, $25257edadcf16f49$export$ce084c78234bd35)(originalUrl || "");
    const originalUrlSplit = (0, $ba7e9f49429c2354$export$3cc482e6b02f32f7)([
        normalizeURL,
        "optionalAccess",
        (_14)=>_14.split,
        "call",
        (_15)=>_15("/"),
        "access",
        (_16)=>_16.filter,
        "call",
        (_17)=>_17((v)=>!!v)
    ]);
    let tempCounter = 0;
    const currentOffset = (0, $ba7e9f49429c2354$export$3cc482e6b02f32f7)([
        reconstructedRoute,
        "optionalAccess",
        (_18)=>_18.split,
        "call",
        (_19)=>_19("/"),
        "access",
        (_20)=>_20.filter,
        "call",
        (_21)=>_21((v)=>!!v),
        "access",
        (_22)=>_22.length
    ]) || 0;
    const result = (0, $ba7e9f49429c2354$export$3cc482e6b02f32f7)([
        layerPath,
        "optionalAccess",
        (_23)=>_23.split,
        "call",
        (_24)=>_24("/"),
        "access",
        (_25)=>_25.filter,
        "call",
        (_26)=>_26((segment)=>{
                if ((0, $ba7e9f49429c2354$export$3cc482e6b02f32f7)([
                    originalUrlSplit,
                    "optionalAccess",
                    (_27)=>_27[currentOffset + tempCounter]
                ]) === segment) {
                    tempCounter += 1;
                    return true;
                }
                return false;
            }),
        "access",
        (_28)=>_28.join,
        "call",
        (_29)=>_29("/")
    ]);
    return result;
}


var $5UTPE = parcelRequire("5UTPE");
var $jL8lq = parcelRequire("jL8lq");
var $2zW56 = parcelRequire("2zW56");
var $289ZW = parcelRequire("289ZW");
var $4g0Ct = parcelRequire("4g0Ct");


/** Tracing integration for graphql package */ class $cc85be36602e051f$export$b735d011553f1049 {
    /**
   * @inheritDoc
   */ static __initStatic() {
        this.id = "GraphQL";
    }
    /**
   * @inheritDoc
   */ constructor(){
        this.name = $cc85be36602e051f$export$b735d011553f1049.id;
    }
    /** @inheritdoc */ loadDependency() {
        return this._module = this._module || (0, $289ZW.loadModule)("graphql/execution/execute.js");
    }
    /**
   * @inheritDoc
   */ setupOnce(_, getCurrentHub) {
        if ((0, $a9d137194c535c9f$export$34db76d03eb96b7e)(getCurrentHub)) {
            (0, $a5e85a0c259bdb77$export$16a28057038b10ef) && (0, $4g0Ct.logger).log("GraphQL Integration is skipped because of instrumenter configuration.");
            return;
        }
        const pkg = this.loadDependency();
        if (!pkg) {
            (0, $a5e85a0c259bdb77$export$16a28057038b10ef) && (0, $4g0Ct.logger).error("GraphQL Integration was unable to require graphql/execution package.");
            return;
        }
        (0, $jL8lq.fill)(pkg, "execute", function(orig) {
            return function(...args) {
                const scope = getCurrentHub().getScope();
                const parentSpan = scope.getSpan();
                const span = (0, $ba7e9f49429c2354$export$3cc482e6b02f32f7)([
                    parentSpan,
                    "optionalAccess",
                    (_2)=>_2.startChild,
                    "call",
                    (_3)=>_3({
                            description: "execute",
                            op: "graphql.execute",
                            origin: "auto.graphql.graphql"
                        })
                ]);
                (0, $ba7e9f49429c2354$export$3cc482e6b02f32f7)([
                    scope,
                    "optionalAccess",
                    (_4)=>_4.setSpan,
                    "call",
                    (_5)=>_5(span)
                ]);
                const rv = orig.call(this, ...args);
                if ((0, $2zW56.isThenable)(rv)) return rv.then((res)=>{
                    (0, $ba7e9f49429c2354$export$3cc482e6b02f32f7)([
                        span,
                        "optionalAccess",
                        (_6)=>_6.finish,
                        "call",
                        (_7)=>_7()
                    ]);
                    (0, $ba7e9f49429c2354$export$3cc482e6b02f32f7)([
                        scope,
                        "optionalAccess",
                        (_8)=>_8.setSpan,
                        "call",
                        (_9)=>_9(parentSpan)
                    ]);
                    return res;
                });
                (0, $ba7e9f49429c2354$export$3cc482e6b02f32f7)([
                    span,
                    "optionalAccess",
                    (_10)=>_10.finish,
                    "call",
                    (_11)=>_11()
                ]);
                (0, $ba7e9f49429c2354$export$3cc482e6b02f32f7)([
                    scope,
                    "optionalAccess",
                    (_12)=>_12.setSpan,
                    "call",
                    (_13)=>_13(parentSpan)
                ]);
                return rv;
            };
        });
    }
}
$cc85be36602e051f$export$b735d011553f1049.__initStatic();


var $duCnO = parcelRequire("duCnO");
var $2EZoq = parcelRequire("2EZoq");
var $jL8lq = parcelRequire("jL8lq");
var $2zW56 = parcelRequire("2zW56");
var $289ZW = parcelRequire("289ZW");
var $4g0Ct = parcelRequire("4g0Ct");


// This allows us to use the same array for both defaults options and the type itself.
// (note `as const` at the end to make it a union of string literal types (i.e. "a" | "b" | ... )
// and not just a string[])
const $b507c398886020fd$var$OPERATIONS = [
    "aggregate",
    "bulkWrite",
    "countDocuments",
    "createIndex",
    "createIndexes",
    "deleteMany",
    "deleteOne",
    "distinct",
    "drop",
    "dropIndex",
    "dropIndexes",
    "estimatedDocumentCount",
    "find",
    "findOne",
    "findOneAndDelete",
    "findOneAndReplace",
    "findOneAndUpdate",
    "indexes",
    "indexExists",
    "indexInformation",
    "initializeOrderedBulkOp",
    "insertMany",
    "insertOne",
    "isCapped",
    "mapReduce",
    "options",
    "parallelCollectionScan",
    "rename",
    "replaceOne",
    "stats",
    "updateMany",
    "updateOne"
];
// All of the operations above take `options` and `callback` as their final parameters, but some of them
// take additional parameters as well. For those operations, this is a map of
// { <operation name>:  [<names of additional parameters>] }, as a way to know what to call the operation's
// positional arguments when we add them to the span's `data` object later
const $b507c398886020fd$var$OPERATION_SIGNATURES = {
    // aggregate intentionally not included because `pipeline` arguments are too complex to serialize well
    // see https://github.com/getsentry/sentry-javascript/pull/3102
    bulkWrite: [
        "operations"
    ],
    countDocuments: [
        "query"
    ],
    createIndex: [
        "fieldOrSpec"
    ],
    createIndexes: [
        "indexSpecs"
    ],
    deleteMany: [
        "filter"
    ],
    deleteOne: [
        "filter"
    ],
    distinct: [
        "key",
        "query"
    ],
    dropIndex: [
        "indexName"
    ],
    find: [
        "query"
    ],
    findOne: [
        "query"
    ],
    findOneAndDelete: [
        "filter"
    ],
    findOneAndReplace: [
        "filter",
        "replacement"
    ],
    findOneAndUpdate: [
        "filter",
        "update"
    ],
    indexExists: [
        "indexes"
    ],
    insertMany: [
        "docs"
    ],
    insertOne: [
        "doc"
    ],
    mapReduce: [
        "map",
        "reduce"
    ],
    rename: [
        "newName"
    ],
    replaceOne: [
        "filter",
        "doc"
    ],
    updateMany: [
        "filter",
        "update"
    ],
    updateOne: [
        "filter",
        "update"
    ]
};
function $b507c398886020fd$var$isCursor(maybeCursor) {
    return maybeCursor && typeof maybeCursor === "object" && maybeCursor.once && typeof maybeCursor.once === "function";
}
/** Tracing integration for mongo package */ class $b507c398886020fd$export$968aa4360b02a334 {
    /**
   * @inheritDoc
   */ static __initStatic() {
        this.id = "Mongo";
    }
    /**
   * @inheritDoc
   */ /**
   * @inheritDoc
   */ constructor(options = {}){
        this.name = $b507c398886020fd$export$968aa4360b02a334.id;
        this._operations = Array.isArray(options.operations) ? options.operations : $b507c398886020fd$var$OPERATIONS;
        this._describeOperations = "describeOperations" in options ? options.describeOperations : true;
        this._useMongoose = !!options.useMongoose;
    }
    /** @inheritdoc */ loadDependency() {
        const moduleName = this._useMongoose ? "mongoose" : "mongodb";
        return this._module = this._module || (0, $289ZW.loadModule)(moduleName);
    }
    /**
   * @inheritDoc
   */ setupOnce(_, getCurrentHub) {
        if ((0, $a9d137194c535c9f$export$34db76d03eb96b7e)(getCurrentHub)) {
            (0, $a5e85a0c259bdb77$export$16a28057038b10ef) && (0, $4g0Ct.logger).log("Mongo Integration is skipped because of instrumenter configuration.");
            return;
        }
        const pkg = this.loadDependency();
        if (!pkg) {
            const moduleName = this._useMongoose ? "mongoose" : "mongodb";
            (0, $a5e85a0c259bdb77$export$16a28057038b10ef) && (0, $4g0Ct.logger).error(`Mongo Integration was unable to require \`${moduleName}\` package.`);
            return;
        }
        this._instrumentOperations(pkg.Collection, this._operations, getCurrentHub);
    }
    /**
   * Patches original collection methods
   */ _instrumentOperations(collection, operations, getCurrentHub) {
        operations.forEach((operation)=>this._patchOperation(collection, operation, getCurrentHub));
    }
    /**
   * Patches original collection to utilize our tracing functionality
   */ _patchOperation(collection, operation, getCurrentHub) {
        if (!(operation in collection.prototype)) return;
        const getSpanContext = this._getSpanContextFromOperationArguments.bind(this);
        (0, $jL8lq.fill)(collection.prototype, operation, function(orig) {
            return function(...args) {
                const lastArg = args[args.length - 1];
                const scope = getCurrentHub().getScope();
                const parentSpan = scope.getSpan();
                // Check if the operation was passed a callback. (mapReduce requires a different check, as
                // its (non-callback) arguments can also be functions.)
                if (typeof lastArg !== "function" || operation === "mapReduce" && args.length === 2) {
                    const span = (0, $ba7e9f49429c2354$export$3cc482e6b02f32f7)([
                        parentSpan,
                        "optionalAccess",
                        (_2)=>_2.startChild,
                        "call",
                        (_3)=>_3(getSpanContext(this, operation, args))
                    ]);
                    const maybePromiseOrCursor = orig.call(this, ...args);
                    if ((0, $2zW56.isThenable)(maybePromiseOrCursor)) return maybePromiseOrCursor.then((res)=>{
                        (0, $ba7e9f49429c2354$export$3cc482e6b02f32f7)([
                            span,
                            "optionalAccess",
                            (_4)=>_4.finish,
                            "call",
                            (_5)=>_5()
                        ]);
                        return res;
                    });
                    else if ($b507c398886020fd$var$isCursor(maybePromiseOrCursor)) {
                        const cursor = maybePromiseOrCursor;
                        try {
                            cursor.once("close", ()=>{
                                (0, $ba7e9f49429c2354$export$3cc482e6b02f32f7)([
                                    span,
                                    "optionalAccess",
                                    (_6)=>_6.finish,
                                    "call",
                                    (_7)=>_7()
                                ]);
                            });
                        } catch (e) {
                            // If the cursor is already closed, `once` will throw an error. In that case, we can
                            // finish the span immediately.
                            (0, $ba7e9f49429c2354$export$3cc482e6b02f32f7)([
                                span,
                                "optionalAccess",
                                (_8)=>_8.finish,
                                "call",
                                (_9)=>_9()
                            ]);
                        }
                        return cursor;
                    } else {
                        (0, $ba7e9f49429c2354$export$3cc482e6b02f32f7)([
                            span,
                            "optionalAccess",
                            (_10)=>_10.finish,
                            "call",
                            (_11)=>_11()
                        ]);
                        return maybePromiseOrCursor;
                    }
                }
                const span = (0, $ba7e9f49429c2354$export$3cc482e6b02f32f7)([
                    parentSpan,
                    "optionalAccess",
                    (_12)=>_12.startChild,
                    "call",
                    (_13)=>_13(getSpanContext(this, operation, args.slice(0, -1)))
                ]);
                return orig.call(this, ...args.slice(0, -1), function(err, result) {
                    (0, $ba7e9f49429c2354$export$3cc482e6b02f32f7)([
                        span,
                        "optionalAccess",
                        (_14)=>_14.finish,
                        "call",
                        (_15)=>_15()
                    ]);
                    lastArg(err, result);
                });
            };
        });
    }
    /**
   * Form a SpanContext based on the user input to a given operation.
   */ _getSpanContextFromOperationArguments(collection, operation, args) {
        const data = {
            "db.system": "mongodb",
            "db.name": collection.dbName,
            "db.operation": operation,
            "db.mongodb.collection": collection.collectionName
        };
        const spanContext = {
            op: "db",
            // TODO v8: Use `${collection.collectionName}.${operation}`
            origin: "auto.db.mongo",
            description: operation,
            data: data
        };
        // If the operation takes no arguments besides `options` and `callback`, or if argument
        // collection is disabled for this operation, just return early.
        const signature = $b507c398886020fd$var$OPERATION_SIGNATURES[operation];
        const shouldDescribe = Array.isArray(this._describeOperations) ? this._describeOperations.includes(operation) : this._describeOperations;
        if (!signature || !shouldDescribe) return spanContext;
        try {
            // Special case for `mapReduce`, as the only one accepting functions as arguments.
            if (operation === "mapReduce") {
                const [map, reduce] = args;
                data[signature[0]] = typeof map === "string" ? map : map.name || "<anonymous>";
                data[signature[1]] = typeof reduce === "string" ? reduce : reduce.name || "<anonymous>";
            } else for(let i = 0; i < signature.length; i++)data[`db.mongodb.${signature[i]}`] = JSON.stringify(args[i]);
        } catch (_oO) {
        // no-empty
        }
        return spanContext;
    }
}
$b507c398886020fd$export$968aa4360b02a334.__initStatic();


var $jL8lq = parcelRequire("jL8lq");
var $289ZW = parcelRequire("289ZW");
var $4g0Ct = parcelRequire("4g0Ct");


/** Tracing integration for node-mysql package */ class $f7ee3fbca33c38de$export$a2cc26ff91a3f8ad {
    /**
   * @inheritDoc
   */ static __initStatic() {
        this.id = "Mysql";
    }
    /**
   * @inheritDoc
   */ constructor(){
        this.name = $f7ee3fbca33c38de$export$a2cc26ff91a3f8ad.id;
    }
    /** @inheritdoc */ loadDependency() {
        return this._module = this._module || (0, $289ZW.loadModule)("mysql/lib/Connection.js");
    }
    /**
   * @inheritDoc
   */ setupOnce(_, getCurrentHub) {
        if ((0, $a9d137194c535c9f$export$34db76d03eb96b7e)(getCurrentHub)) {
            (0, $a5e85a0c259bdb77$export$16a28057038b10ef) && (0, $4g0Ct.logger).log("Mysql Integration is skipped because of instrumenter configuration.");
            return;
        }
        const pkg = this.loadDependency();
        if (!pkg) {
            (0, $a5e85a0c259bdb77$export$16a28057038b10ef) && (0, $4g0Ct.logger).error("Mysql Integration was unable to require `mysql` package.");
            return;
        }
        let mySqlConfig = undefined;
        try {
            pkg.prototype.connect = new Proxy(pkg.prototype.connect, {
                apply (wrappingTarget, thisArg, args) {
                    if (!mySqlConfig) mySqlConfig = thisArg.config;
                    return wrappingTarget.apply(thisArg, args);
                }
            });
        } catch (e) {
            (0, $a5e85a0c259bdb77$export$16a28057038b10ef) && (0, $4g0Ct.logger).error("Mysql Integration was unable to instrument `mysql` config.");
        }
        function spanDataFromConfig() {
            if (!mySqlConfig) return {};
            return {
                "server.address": mySqlConfig.host,
                "server.port": mySqlConfig.port,
                "db.user": mySqlConfig.user
            };
        }
        function finishSpan(span) {
            if (!span || span.endTimestamp) return;
            const data = spanDataFromConfig();
            Object.keys(data).forEach((key)=>{
                span.setData(key, data[key]);
            });
            span.finish();
        }
        // The original function will have one of these signatures:
        //    function (callback) => void
        //    function (options, callback) => void
        //    function (options, values, callback) => void
        (0, $jL8lq.fill)(pkg, "createQuery", function(orig) {
            return function(options, values, callback) {
                const scope = getCurrentHub().getScope();
                const parentSpan = scope.getSpan();
                const span = (0, $ba7e9f49429c2354$export$3cc482e6b02f32f7)([
                    parentSpan,
                    "optionalAccess",
                    (_2)=>_2.startChild,
                    "call",
                    (_3)=>_3({
                            description: typeof options === "string" ? options : options.sql,
                            op: "db",
                            origin: "auto.db.mysql",
                            data: {
                                "db.system": "mysql"
                            }
                        })
                ]);
                if (typeof callback === "function") return orig.call(this, options, values, function(err, result, fields) {
                    finishSpan(span);
                    callback(err, result, fields);
                });
                if (typeof values === "function") return orig.call(this, options, function(err, result, fields) {
                    finishSpan(span);
                    values(err, result, fields);
                });
                // streaming, no callback!
                const query = orig.call(this, options, values);
                query.on("end", ()=>{
                    finishSpan(span);
                });
                return query;
            };
        });
    }
}
$f7ee3fbca33c38de$export$a2cc26ff91a3f8ad.__initStatic();


var $jL8lq = parcelRequire("jL8lq");
var $2zW56 = parcelRequire("2zW56");
var $289ZW = parcelRequire("289ZW");
var $4g0Ct = parcelRequire("4g0Ct");


/** Tracing integration for node-postgres package */ class $3497dd2fc8e02eea$export$806ddb599177abc4 {
    /**
   * @inheritDoc
   */ static __initStatic() {
        this.id = "Postgres";
    }
    /**
   * @inheritDoc
   */ constructor(options = {}){
        this.name = $3497dd2fc8e02eea$export$806ddb599177abc4.id;
        this._usePgNative = !!options.usePgNative;
        this._module = options.module;
    }
    /** @inheritdoc */ loadDependency() {
        return this._module = this._module || (0, $289ZW.loadModule)("pg");
    }
    /**
   * @inheritDoc
   */ setupOnce(_, getCurrentHub) {
        if ((0, $a9d137194c535c9f$export$34db76d03eb96b7e)(getCurrentHub)) {
            (0, $a5e85a0c259bdb77$export$16a28057038b10ef) && (0, $4g0Ct.logger).log("Postgres Integration is skipped because of instrumenter configuration.");
            return;
        }
        const pkg = this.loadDependency();
        if (!pkg) {
            (0, $a5e85a0c259bdb77$export$16a28057038b10ef) && (0, $4g0Ct.logger).error("Postgres Integration was unable to require `pg` package.");
            return;
        }
        const Client = this._usePgNative ? (0, $ba7e9f49429c2354$export$3cc482e6b02f32f7)([
            pkg,
            "access",
            (_2)=>_2.native,
            "optionalAccess",
            (_3)=>_3.Client
        ]) : pkg.Client;
        if (!Client) {
            (0, $a5e85a0c259bdb77$export$16a28057038b10ef) && (0, $4g0Ct.logger).error("Postgres Integration was unable to access 'pg-native' bindings.");
            return;
        }
        /**
     * function (query, callback) => void
     * function (query, params, callback) => void
     * function (query) => Promise
     * function (query, params) => Promise
     * function (pg.Cursor) => pg.Cursor
     */ (0, $jL8lq.fill)(Client.prototype, "query", function(orig) {
            return function(config, values, callback) {
                const scope = getCurrentHub().getScope();
                const parentSpan = scope.getSpan();
                const data = {
                    "db.system": "postgresql"
                };
                try {
                    if (this.database) data["db.name"] = this.database;
                    if (this.host) data["server.address"] = this.host;
                    if (this.port) data["server.port"] = this.port;
                    if (this.user) data["db.user"] = this.user;
                } catch (e) {
                // ignore
                }
                const span = (0, $ba7e9f49429c2354$export$3cc482e6b02f32f7)([
                    parentSpan,
                    "optionalAccess",
                    (_4)=>_4.startChild,
                    "call",
                    (_5)=>_5({
                            description: typeof config === "string" ? config : config.text,
                            op: "db",
                            origin: "auto.db.postgres",
                            data: data
                        })
                ]);
                if (typeof callback === "function") return orig.call(this, config, values, function(err, result) {
                    (0, $ba7e9f49429c2354$export$3cc482e6b02f32f7)([
                        span,
                        "optionalAccess",
                        (_6)=>_6.finish,
                        "call",
                        (_7)=>_7()
                    ]);
                    callback(err, result);
                });
                if (typeof values === "function") return orig.call(this, config, function(err, result) {
                    (0, $ba7e9f49429c2354$export$3cc482e6b02f32f7)([
                        span,
                        "optionalAccess",
                        (_8)=>_8.finish,
                        "call",
                        (_9)=>_9()
                    ]);
                    values(err, result);
                });
                const rv = typeof values !== "undefined" ? orig.call(this, config, values) : orig.call(this, config);
                if ((0, $2zW56.isThenable)(rv)) return rv.then((res)=>{
                    (0, $ba7e9f49429c2354$export$3cc482e6b02f32f7)([
                        span,
                        "optionalAccess",
                        (_10)=>_10.finish,
                        "call",
                        (_11)=>_11()
                    ]);
                    return res;
                });
                (0, $ba7e9f49429c2354$export$3cc482e6b02f32f7)([
                    span,
                    "optionalAccess",
                    (_12)=>_12.finish,
                    "call",
                    (_13)=>_13()
                ]);
                return rv;
            };
        });
    }
}
$3497dd2fc8e02eea$export$806ddb599177abc4.__initStatic();


var $cmFjP = parcelRequire("cmFjP");
var $jL8lq = parcelRequire("jL8lq");
var $2zW56 = parcelRequire("2zW56");
var $4g0Ct = parcelRequire("4g0Ct");
var $65HJt = parcelRequire("65HJt");

var $8IHa9 = parcelRequire("8IHa9");

var $cmFjP = parcelRequire("cmFjP");

var $duCnO = parcelRequire("duCnO");
/**
 * Wraps a function with a transaction/span and finishes the span after the function is done.
 *
 * Note that if you have not enabled tracing extensions via `addTracingExtensions`
 * or you didn't set `tracesSampleRate`, this function will not generate spans
 * and the `span` returned from the callback will be undefined.
 *
 * This function is meant to be used internally and may break at any time. Use at your own risk.
 *
 * @internal
 * @private
 */ function $b73c4ddb8b981968$export$357889f174732d38(context, callback, // eslint-disable-next-line @typescript-eslint/no-empty-function
onError = ()=>{}) {
    const ctx = $b73c4ddb8b981968$var$normalizeContext(context);
    const hub = (0, $cmFjP.getCurrentHub)();
    const scope = hub.getScope();
    const parentSpan = scope.getSpan();
    const activeSpan = $b73c4ddb8b981968$var$createChildSpanOrTransaction(hub, parentSpan, ctx);
    scope.setSpan(activeSpan);
    function finishAndSetSpan() {
        activeSpan && activeSpan.finish();
        hub.getScope().setSpan(parentSpan);
    }
    let maybePromiseResult;
    try {
        maybePromiseResult = callback(activeSpan);
    } catch (e) {
        activeSpan && activeSpan.setStatus("internal_error");
        onError(e);
        finishAndSetSpan();
        throw e;
    }
    if ((0, $2zW56.isThenable)(maybePromiseResult)) Promise.resolve(maybePromiseResult).then(()=>{
        finishAndSetSpan();
    }, (e)=>{
        activeSpan && activeSpan.setStatus("internal_error");
        onError(e);
        finishAndSetSpan();
    });
    else finishAndSetSpan();
    return maybePromiseResult;
}
/**
 * Wraps a function with a transaction/span and finishes the span after the function is done.
 * The created span is the active span and will be used as parent by other spans created inside the function
 * and can be accessed via `Sentry.getSpan()`, as long as the function is executed while the scope is active.
 *
 * If you want to create a span that is not set as active, use {@link startInactiveSpan}.
 *
 * Note that if you have not enabled tracing extensions via `addTracingExtensions`
 * or you didn't set `tracesSampleRate`, this function will not generate spans
 * and the `span` returned from the callback will be undefined.
 */ function $b73c4ddb8b981968$export$a1bd95187356f372(context, callback) {
    const ctx = $b73c4ddb8b981968$var$normalizeContext(context);
    const hub = (0, $cmFjP.getCurrentHub)();
    const scope = hub.getScope();
    const parentSpan = scope.getSpan();
    const activeSpan = $b73c4ddb8b981968$var$createChildSpanOrTransaction(hub, parentSpan, ctx);
    scope.setSpan(activeSpan);
    function finishAndSetSpan() {
        activeSpan && activeSpan.finish();
        hub.getScope().setSpan(parentSpan);
    }
    let maybePromiseResult;
    try {
        maybePromiseResult = callback(activeSpan);
    } catch (e) {
        activeSpan && activeSpan.setStatus("internal_error");
        finishAndSetSpan();
        throw e;
    }
    if ((0, $2zW56.isThenable)(maybePromiseResult)) Promise.resolve(maybePromiseResult).then(()=>{
        finishAndSetSpan();
    }, ()=>{
        activeSpan && activeSpan.setStatus("internal_error");
        finishAndSetSpan();
    });
    else finishAndSetSpan();
    return maybePromiseResult;
}
/**
 * @deprecated Use {@link startSpan} instead.
 */ const $b73c4ddb8b981968$export$cb9e396e6b90b703 = $b73c4ddb8b981968$export$a1bd95187356f372;
/**
 * Similar to `Sentry.startSpan`. Wraps a function with a transaction/span, but does not finish the span
 * after the function is done automatically.
 *
 * The created span is the active span and will be used as parent by other spans created inside the function
 * and can be accessed via `Sentry.getActiveSpan()`, as long as the function is executed while the scope is active.
 *
 * Note that if you have not enabled tracing extensions via `addTracingExtensions`
 * or you didn't set `tracesSampleRate`, this function will not generate spans
 * and the `span` returned from the callback will be undefined.
 */ function $b73c4ddb8b981968$export$c10292ad04b92aea(context, callback) {
    const ctx = $b73c4ddb8b981968$var$normalizeContext(context);
    const hub = (0, $cmFjP.getCurrentHub)();
    const scope = hub.getScope();
    const parentSpan = scope.getSpan();
    const activeSpan = $b73c4ddb8b981968$var$createChildSpanOrTransaction(hub, parentSpan, ctx);
    scope.setSpan(activeSpan);
    function finishAndSetSpan() {
        activeSpan && activeSpan.finish();
        hub.getScope().setSpan(parentSpan);
    }
    let maybePromiseResult;
    try {
        maybePromiseResult = callback(activeSpan, finishAndSetSpan);
    } catch (e) {
        activeSpan && activeSpan.setStatus("internal_error");
        throw e;
    }
    if ((0, $2zW56.isThenable)(maybePromiseResult)) Promise.resolve(maybePromiseResult).then(undefined, ()=>{
        activeSpan && activeSpan.setStatus("internal_error");
    });
    return maybePromiseResult;
}
/**
 * Creates a span. This span is not set as active, so will not get automatic instrumentation spans
 * as children or be able to be accessed via `Sentry.getSpan()`.
 *
 * If you want to create a span that is set as active, use {@link startSpan}.
 *
 * Note that if you have not enabled tracing extensions via `addTracingExtensions`
 * or you didn't set `tracesSampleRate` or `tracesSampler`, this function will not generate spans
 * and the `span` returned from the callback will be undefined.
 */ function $b73c4ddb8b981968$export$63dbba021a6b4047(context) {
    if (!(0, $duCnO.hasTracingEnabled)()) return undefined;
    const ctx = {
        ...context
    };
    // If a name is set and a description is not, set the description to the name.
    if (ctx.name !== undefined && ctx.description === undefined) ctx.description = ctx.name;
    const hub = (0, $cmFjP.getCurrentHub)();
    const parentSpan = $b73c4ddb8b981968$export$1be426a8e585c83e();
    return parentSpan ? parentSpan.startChild(ctx) : hub.startTransaction(ctx);
}
/**
 * Returns the currently active span.
 */ function $b73c4ddb8b981968$export$1be426a8e585c83e() {
    return (0, $cmFjP.getCurrentHub)().getScope().getSpan();
}
/**
 * Continue a trace from `sentry-trace` and `baggage` values.
 * These values can be obtained from incoming request headers,
 * or in the browser from `<meta name="sentry-trace">` and `<meta name="baggage">` HTML tags.
 *
 * The callback receives a transactionContext that may be used for `startTransaction` or `startSpan`.
 */ function $b73c4ddb8b981968$export$d2ee9b39b25437b3({ sentryTrace: sentryTrace, baggage: baggage }, callback) {
    const hub = (0, $cmFjP.getCurrentHub)();
    const currentScope = hub.getScope();
    const { traceparentData: traceparentData, dynamicSamplingContext: dynamicSamplingContext, propagationContext: propagationContext } = (0, $65HJt.tracingContextFromHeaders)(sentryTrace, baggage);
    currentScope.setPropagationContext(propagationContext);
    if ((0, $8IHa9.DEBUG_BUILD) && traceparentData) (0, $4g0Ct.logger).log(`[Tracing] Continuing trace ${traceparentData.traceId}.`);
    const transactionContext = {
        ...traceparentData,
        metadata: (0, $jL8lq.dropUndefinedKeys)({
            dynamicSamplingContext: traceparentData && !dynamicSamplingContext ? {} : dynamicSamplingContext
        })
    };
    if (!callback) return transactionContext;
    return callback(transactionContext);
}
function $b73c4ddb8b981968$var$createChildSpanOrTransaction(hub, parentSpan, ctx) {
    if (!(0, $duCnO.hasTracingEnabled)()) return undefined;
    return parentSpan ? parentSpan.startChild(ctx) : hub.startTransaction(ctx);
}
function $b73c4ddb8b981968$var$normalizeContext(context) {
    const ctx = {
        ...context
    };
    // If a name is set and a description is not, set the description to the name.
    if (ctx.name !== undefined && ctx.description === undefined) ctx.description = ctx.name;
    return ctx;
}



var $jL8lq = parcelRequire("jL8lq");
var $4g0Ct = parcelRequire("4g0Ct");


function $55d28c9b57eb05c8$var$isValidPrismaClient(possibleClient) {
    return !!possibleClient && !!possibleClient["$use"];
}
/** Tracing integration for @prisma/client package */ class $55d28c9b57eb05c8$export$e300e6f4779d55c2 {
    /**
   * @inheritDoc
   */ static __initStatic() {
        this.id = "Prisma";
    }
    /**
   * @inheritDoc
   */ /**
   * @inheritDoc
   */ constructor(options = {}){
        this.name = $55d28c9b57eb05c8$export$e300e6f4779d55c2.id;
        // We instrument the PrismaClient inside the constructor and not inside `setupOnce` because in some cases of server-side
        // bundling (Next.js) multiple Prisma clients can be instantiated, even though users don't intend to. When instrumenting
        // in setupOnce we can only ever instrument one client.
        // https://github.com/getsentry/sentry-javascript/issues/7216#issuecomment-1602375012
        // In the future we might explore providing a dedicated PrismaClient middleware instead of this hack.
        if ($55d28c9b57eb05c8$var$isValidPrismaClient(options.client) && !options.client._sentryInstrumented) {
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            (0, $jL8lq.addNonEnumerableProperty)(options.client, "_sentryInstrumented", true);
            const clientData = {};
            try {
                const engineConfig = options.client._engineConfig;
                if (engineConfig) {
                    const { activeProvider: activeProvider, clientVersion: clientVersion } = engineConfig;
                    if (activeProvider) clientData["db.system"] = activeProvider;
                    if (clientVersion) clientData["db.prisma.version"] = clientVersion;
                }
            } catch (e) {
            // ignore
            }
            options.client.$use((params, next)=>{
                if ((0, $a9d137194c535c9f$export$34db76d03eb96b7e)((0, $cmFjP.getCurrentHub))) return next(params);
                const action = params.action;
                const model = params.model;
                return (0, $b73c4ddb8b981968$export$357889f174732d38)({
                    name: model ? `${model} ${action}` : action,
                    op: "db.prisma",
                    origin: "auto.db.prisma",
                    data: {
                        ...clientData,
                        "db.operation": action
                    }
                }, ()=>next(params));
            });
        } else (0, $a5e85a0c259bdb77$export$16a28057038b10ef) && (0, $4g0Ct.logger).warn("Unsupported Prisma client provided to PrismaIntegration. Provided client:", options.client);
    }
    /**
   * @inheritDoc
   */ setupOnce() {
    // Noop - here for backwards compatibility
    }
}
$55d28c9b57eb05c8$export$e300e6f4779d55c2.__initStatic();


var $cKEJC = parcelRequire("cKEJC");/** The status of an Span.
 *
 * @deprecated Use string literals - if you require type casting, cast to SpanStatusType type
 */ var $6d9884e3956d809f$export$beb8e6a823e89c5d;
(function(SpanStatus) {
    /** The operation completed successfully. */ const Ok = "ok";
    SpanStatus["Ok"] = Ok;
    /** Deadline expired before operation could complete. */ const DeadlineExceeded = "deadline_exceeded";
    SpanStatus["DeadlineExceeded"] = DeadlineExceeded;
    /** 401 Unauthorized (actually does mean unauthenticated according to RFC 7235) */ const Unauthenticated = "unauthenticated";
    SpanStatus["Unauthenticated"] = Unauthenticated;
    /** 403 Forbidden */ const PermissionDenied = "permission_denied";
    SpanStatus["PermissionDenied"] = PermissionDenied;
    /** 404 Not Found. Some requested entity (file or directory) was not found. */ const NotFound = "not_found";
    SpanStatus["NotFound"] = NotFound;
    /** 429 Too Many Requests */ const ResourceExhausted = "resource_exhausted";
    SpanStatus["ResourceExhausted"] = ResourceExhausted;
    /** Client specified an invalid argument. 4xx. */ const InvalidArgument = "invalid_argument";
    SpanStatus["InvalidArgument"] = InvalidArgument;
    /** 501 Not Implemented */ const Unimplemented = "unimplemented";
    SpanStatus["Unimplemented"] = Unimplemented;
    /** 503 Service Unavailable */ const Unavailable = "unavailable";
    SpanStatus["Unavailable"] = Unavailable;
    /** Other/generic 5xx. */ const InternalError = "internal_error";
    SpanStatus["InternalError"] = InternalError;
    /** Unknown. Any non-standard HTTP status code. */ const UnknownError = "unknown_error";
    SpanStatus["UnknownError"] = UnknownError;
    /** The operation was cancelled (typically by the user). */ const Cancelled = "cancelled";
    SpanStatus["Cancelled"] = Cancelled;
    /** Already exists (409) */ const AlreadyExists = "already_exists";
    SpanStatus["AlreadyExists"] = AlreadyExists;
    /** Operation was rejected because the system is not in a state required for the operation's */ const FailedPrecondition = "failed_precondition";
    SpanStatus["FailedPrecondition"] = FailedPrecondition;
    /** The operation was aborted, typically due to a concurrency issue. */ const Aborted = "aborted";
    SpanStatus["Aborted"] = Aborted;
    /** Operation was attempted past the valid range. */ const OutOfRange = "out_of_range";
    SpanStatus["OutOfRange"] = OutOfRange;
    /** Unrecoverable data loss or corruption */ const DataLoss = "data_loss";
    SpanStatus["DataLoss"] = DataLoss;
})($6d9884e3956d809f$export$beb8e6a823e89c5d || ($6d9884e3956d809f$export$beb8e6a823e89c5d = {}));


var $gu0hs = parcelRequire("gu0hs");
var $65HJt = parcelRequire("65HJt");
var $6Tqu0 = parcelRequire("6Tqu0");
// BrowserTracing is already exported as part of `Integrations` below (and for the moment will remain so for
// backwards compatibility), but that interferes with treeshaking, so we also export it separately
// here.
/**
 * @deprecated `@sentry/tracing` has been deprecated and will be moved to to `@sentry/node`, `@sentry/browser`, or your framework SDK in the next major version.
 * `BrowserTracing` can be imported from `@sentry/browser` or your framework SDK
 *
 * import { BrowserTracing } from '@sentry/browser';
 * new BrowserTracing()
 */ const $2c54dac91da760a9$export$46d3bbd0375f5fa4 = (0, $1a684ef8a4a48899$export$46d3bbd0375f5fa4);
// BrowserTracing is already exported as part of `Integrations` below (and for the moment will remain so for
// backwards compatibility), but that interferes with treeshaking, so we also export it separately
// here.
/**
 * @deprecated `@sentry/tracing` has been deprecated and will be moved to to `@sentry/node`, `@sentry/browser`, or your framework SDK in the next major version.
 * `BrowserTracing` can be imported from `@sentry/browser` or your framework SDK
 *
 * import { BrowserTracing } from '@sentry/browser';
 * new BrowserTracing()
 */ /**
 * @deprecated `@sentry/tracing` has been deprecated and will be moved to to `@sentry/node`, `@sentry/browser`, or your framework SDK in the next major version.
 */ const $2c54dac91da760a9$export$5a20b45239a3c0a6 = (0, $3NuqQ.addExtensionMethods);
/**
 * @deprecated `@sentry/tracing` has been deprecated and will be moved to to `@sentry/node`, `@sentry/browser`, or your framework SDK in the next major version.
 *
 * `getActiveTransaction` can be imported from `@sentry/node`, `@sentry/browser`, or your framework SDK
 */ const $2c54dac91da760a9$export$a7feb32fdd923295 = (0, $5UTPE.getActiveTransaction);
/**
 * @deprecated `@sentry/tracing` has been deprecated and will be moved to to `@sentry/node`, `@sentry/browser`, or your framework SDK in the next major version.
 *
 * `extractTraceparentData` can be imported from `@sentry/node`, `@sentry/browser`, or your framework SDK
 */ // eslint-disable-next-line deprecation/deprecation
const $2c54dac91da760a9$export$8e9a29865c0a1226 = (0, $5UTPE.extractTraceparentData);
/**
 * @deprecated `@sentry/tracing` has been deprecated and will be moved to to `@sentry/node`, `@sentry/browser`, or your framework SDK in the next major version.
 *
 * `spanStatusfromHttpCode` can be imported from `@sentry/node`, `@sentry/browser`, or your framework SDK
 */ const $2c54dac91da760a9$export$ac65c70d78fcdb55 = (0, $cKEJC.spanStatusfromHttpCode);
/**
 * @deprecated `@sentry/tracing` has been deprecated and will be moved to to `@sentry/node`, `@sentry/browser`, or your framework SDK in the next major version.
 *
 * `SpanStatusType` can be imported from `@sentry/node`, `@sentry/browser`, or your framework SDK
 */ /**
 * @deprecated `@sentry/tracing` has been deprecated and will be moved to to `@sentry/node`, `@sentry/browser`, or your framework SDK in the next major version.
 *
 * `Transaction` can be imported from `@sentry/node`, `@sentry/browser`, or your framework SDK
 */ const $2c54dac91da760a9$export$febc5573c75cefb0 = (0, $6Tqu0.Transaction);
/**
 * @deprecated `@sentry/tracing` has been deprecated and will be moved to to `@sentry/node`, `@sentry/browser`, or your framework SDK in the next major version.
 *
 * `Transaction` can be imported from `@sentry/node`, `@sentry/browser`, or your framework SDK
 */ /**
 * @deprecated `@sentry/tracing` has been deprecated and will be moved to to `@sentry/node`, `@sentry/browser`, or your framework SDK in the next major version.
 *
 * `Span` can be imported from `@sentry/node`, `@sentry/browser`, or your framework SDK
 */ const $2c54dac91da760a9$export$5f1714a13ed34c01 = (0, $cKEJC.Span);
/**
 * @deprecated `@sentry/tracing` has been deprecated and will be moved to to `@sentry/node`, `@sentry/browser`, or your framework SDK in the next major version.
 *
 * `Span` can be imported from `@sentry/node`, `@sentry/browser`, or your framework SDK
 */ /**
 * @deprecated `@sentry/tracing` has been deprecated and will be moved to to `@sentry/node`, `@sentry/browser`, or your framework SDK in the next major version.
 */ const $2c54dac91da760a9$export$bbd2089f30bd3708 = (0, $1a684ef8a4a48899$export$bbd2089f30bd3708);
/**
 * @deprecated `@sentry/tracing` has been deprecated and will be moved to to `@sentry/node`, `@sentry/browser`, or your framework SDK in the next major version.
 *
 * `defaultRequestInstrumentationOptions` can be imported from `@sentry/browser`, or your framework SDK
 */ const $2c54dac91da760a9$export$cc17fb3c0bc95cd7 = (0, $e425abf0f1e5a10f$export$cc17fb3c0bc95cd7);
/**
 * @deprecated `@sentry/tracing` has been deprecated and will be moved to to `@sentry/node`, `@sentry/browser`, or your framework SDK in the next major version.
 *
 * `hasTracingEnabled` can be imported from `@sentry/utils`
 */ const $2c54dac91da760a9$export$5008da00b1b6dee6 = (0, $duCnO.hasTracingEnabled);
/**
 * @deprecated `@sentry/tracing` has been deprecated and will be moved to to `@sentry/node`, `@sentry/browser`, or your framework SDK in the next major version.
 *
 * `stripUrlQueryAndFragment` can be imported from `@sentry/utils`
 */ const $2c54dac91da760a9$export$ce084c78234bd35 = (0, $25257edadcf16f49$export$ce084c78234bd35);
/**
 * @deprecated `@sentry/tracing` has been deprecated and will be moved to to `@sentry/node`, `@sentry/browser`, or your framework SDK in the next major version.
 *
 * `TRACEPARENT_REGEXP` can be imported from `@sentry/utils`
 */ const $2c54dac91da760a9$export$394a210812ba3012 = (0, $65HJt.TRACEPARENT_REGEXP);
/**
 * @deprecated `@sentry/tracing` has been deprecated and will be moved to to `@sentry/node`, `@sentry/browser`, or your framework SDK in the next major version.
 */ const $2c54dac91da760a9$export$b279e6bd7040371f = (0, $2EZoq.IdleTransaction);
/**
 * @deprecated `@sentry/tracing` has been deprecated and will be moved to to `@sentry/node`, `@sentry/browser`, or your framework SDK in the next major version.
 */ /**
 * @deprecated `@sentry/tracing` has been deprecated and will be moved to to `@sentry/node`, `@sentry/browser`, or your framework SDK in the next major version.
 */ const $2c54dac91da760a9$export$864489cb3478db3e = (0, $e425abf0f1e5a10f$export$864489cb3478db3e);
/**
 * @deprecated `@sentry/tracing` has been deprecated and will be moved to to `@sentry/node`, `@sentry/browser`, or your framework SDK in the next major version.
 */ const $2c54dac91da760a9$export$479dbd817e392a4f = (0, $gu0hs.startIdleTransaction);
/**
 * @deprecated `@sentry/tracing` has been deprecated and will be moved to to `@sentry/node`, `@sentry/browser`, or your framework SDK in the next major version.
 */ // eslint-disable-next-line deprecation/deprecation
const $2c54dac91da760a9$export$beb8e6a823e89c5d = (0, $6d9884e3956d809f$export$beb8e6a823e89c5d);
/**
 * @deprecated `@sentry/tracing` has been deprecated and will be moved to to `@sentry/node`, `@sentry/browser`, or your framework SDK in the next major version.
 */ // eslint-disable-next-line deprecation/deprecation
const $2c54dac91da760a9$export$99d02219d259eb94 = {
    /**
   * @deprecated `@sentry/tracing` has been deprecated and will be moved to to `@sentry/node`, `@sentry/browser`, or your framework SDK in the next major version.
   * `BrowserTracing` can be imported from `@sentry/browser` or your framework SDK
   *
   * import { BrowserTracing } from '@sentry/browser';
   * new BrowserTracing()
   */ // eslint-disable-next-line deprecation/deprecation
    BrowserTracing: $2c54dac91da760a9$export$46d3bbd0375f5fa4,
    /**
   * @deprecated `@sentry/tracing` has been deprecated and will be moved to to `@sentry/node`, `@sentry/browser`, or your framework SDK in the next major version.
   * `Apollo` can be imported from `@sentry/node`
   *
   * import { Integrations } from '@sentry/node';
   * new Integrations.Apollo({ ... })
   */ // eslint-disable-next-line deprecation/deprecation
    Apollo: (0, $72d6e24f36ba74e2$export$3db3e396472fda8d),
    /**
   * @deprecated `@sentry/tracing` has been deprecated and will be moved to to `@sentry/node`, `@sentry/browser`, or your framework SDK in the next major version.
   * `Express` can be imported from `@sentry/node`
   *
   * import { Integrations } from '@sentry/node';
   * new Integrations.Express({ ... })
   */ // eslint-disable-next-line deprecation/deprecation
    Express: (0, $04470ea8dc00f88f$export$6dafdd8fec05099d),
    /**
   * @deprecated `@sentry/tracing` has been deprecated and will be moved to to `@sentry/node`, `@sentry/browser`, or your framework SDK in the next major version.
   * `GraphQL` can be imported from `@sentry/node`
   *
   * import { Integrations } from '@sentry/node';
   * new Integrations.GraphQL({ ... })
   */ // eslint-disable-next-line deprecation/deprecation
    GraphQL: (0, $cc85be36602e051f$export$b735d011553f1049),
    /**
   * @deprecated `@sentry/tracing` has been deprecated and will be moved to to `@sentry/node`, `@sentry/browser`, or your framework SDK in the next major version.
   * `Mongo` can be imported from `@sentry/node`
   *
   * import { Integrations } from '@sentry/node';
   * new Integrations.Mongo({ ... })
   */ // eslint-disable-next-line deprecation/deprecation
    Mongo: (0, $b507c398886020fd$export$968aa4360b02a334),
    /**
   * @deprecated `@sentry/tracing` has been deprecated and will be moved to to `@sentry/node`, `@sentry/browser`, or your framework SDK in the next major version.
   * `Mysql` can be imported from `@sentry/node`
   *
   * import { Integrations } from '@sentry/node';
   * new Integrations.Mysql({ ... })
   */ // eslint-disable-next-line deprecation/deprecation
    Mysql: (0, $f7ee3fbca33c38de$export$a2cc26ff91a3f8ad),
    /**
   * @deprecated `@sentry/tracing` has been deprecated and will be moved to to `@sentry/node`, `@sentry/browser`, or your framework SDK in the next major version.
   * `Postgres` can be imported from `@sentry/node`
   *
   * import { Integrations } from '@sentry/node';
   * new Integrations.Postgres({ ... })
   */ // eslint-disable-next-line deprecation/deprecation
    Postgres: (0, $3497dd2fc8e02eea$export$806ddb599177abc4),
    /**
   * @deprecated `@sentry/tracing` has been deprecated and will be moved to to `@sentry/node`, `@sentry/browser`, or your framework SDK in the next major version.
   * `Prisma` can be imported from `@sentry/node`
   *
   * import { Integrations } from '@sentry/node';
   * new Integrations.Prisma({ ... })
   */ // eslint-disable-next-line deprecation/deprecation
    Prisma: (0, $55d28c9b57eb05c8$export$e300e6f4779d55c2)
};
// Treeshakable guard to remove all code related to tracing
// Guard for tree
if (typeof __SENTRY_TRACING__ === "undefined" || __SENTRY_TRACING__) // We are patching the global object with our hub extension methods
(0, $3NuqQ.addExtensionMethods)();



var $b1E2c = parcelRequire("b1E2c");
var $4g0Ct = parcelRequire("4g0Ct");
var $3bpJ1 = parcelRequire("3bpJ1");
var $91U3U = parcelRequire("91U3U");
/** Send Console API calls as Sentry Events */ class $929d6316a55f553e$export$25a43cb5b5c58c08 {
    /**
   * @inheritDoc
   */ static __initStatic() {
        this.id = "CaptureConsole";
    }
    /**
   * @inheritDoc
   */ /**
   * @inheritDoc
   */ /**
   * @inheritDoc
   */ constructor(options = {}){
        this.name = $929d6316a55f553e$export$25a43cb5b5c58c08.id;
        this._levels = options.levels || (0, $4g0Ct.CONSOLE_LEVELS);
    }
    /**
   * @inheritDoc
   */ setupOnce(_, getCurrentHub) {
        if (!("console" in (0, $3bpJ1.GLOBAL_OBJ))) return;
        const levels = this._levels;
        (0, $d81ce3377b27def9$export$1d6e0d073f9e6723)(({ args: args, level: level })=>{
            if (!levels.includes(level)) return;
            const hub = getCurrentHub();
            if (!hub.getIntegration($929d6316a55f553e$export$25a43cb5b5c58c08)) return;
            $929d6316a55f553e$var$consoleHandler(hub, args, level);
        });
    }
}
$929d6316a55f553e$export$25a43cb5b5c58c08.__initStatic();
function $929d6316a55f553e$var$consoleHandler(hub, args, level) {
    hub.withScope((scope)=>{
        scope.setLevel((0, $7f06244a5e0d22e8$export$d771ef054122c30a)(level));
        scope.setExtra("arguments", args);
        scope.addEventProcessor((event)=>{
            event.logger = "console";
            (0, $b1E2c.addExceptionMechanism)(event, {
                handled: false,
                type: "console"
            });
            return event;
        });
        let message = (0, $91U3U.safeJoin)(args, " ");
        const error = args.find((arg)=>arg instanceof Error);
        if (level === "assert") {
            if (args[0] === false) {
                message = `Assertion failed: ${(0, $91U3U.safeJoin)(args.slice(1), " ") || "console.assert"}`;
                scope.setExtra("arguments", args.slice(1));
                hub.captureMessage(message);
            }
        } else if (level === "error" && error) hub.captureException(error);
        else hub.captureMessage(message);
    });
}




var $bsQZT = parcelRequire("bsQZT");
if ((0, $bsQZT.isProductionEnvironment)()) $795a7664e1a3c052$export$2cd8252107eb640b({
    dsn: "https://51665d1b23424de488ae50aaa2b4dde6@o418998.ingest.sentry.io/4504117096349696",
    integrations: [
        new (0, $2c54dac91da760a9$export$46d3bbd0375f5fa4)({
            tracingOrigins: [
                "*"
            ]
        }),
        new (0, $929d6316a55f553e$export$25a43cb5b5c58c08)({
            levels: [
                "error"
            ]
        })
    ],
    tracesSampleRate: 1.0,
    normalizeDepth: 8,
    ignoreErrors: [
        "Error: ApiError: AuthError",
        "Error: ApiError: ConnectionError",
        "Error: ApiError: ClientError",
        "Error: ApiError: NotFound"
    ]
});
function $0c0f53a5cea85ce7$export$efda9a273d7a036d(breadcrumb) {
    const initializedClient = $cmFjP.getCurrentHub().getClient();
    if (!initializedClient) return;
    $b8438.addBreadcrumb(breadcrumb);
}
function $0c0f53a5cea85ce7$export$3e205fbb5df021e0(message, extra) {
    const initializedClient = $cmFjP.getCurrentHub().getClient();
    if (!initializedClient) {
        // Sentry only runs in production, so keep the error visible on the other environments.
        console.error(message, extra);
        return;
    }
    $b8438.captureMessage(message, {
        level: "error",
        extra: extra
    });
}
function $0c0f53a5cea85ce7$export$9e0ff99299d29cce(error, errorInfo) {
    if (error instanceof (0, $9ad33fbf770c55a1$export$f2e832acab1bdd79)) {
        const loggedErrors = [
            (0, $9ad33fbf770c55a1$export$9696fcf1798e1cb5).ServerError,
            (0, $9ad33fbf770c55a1$export$9696fcf1798e1cb5).TooManyRequestsError,
            (0, $9ad33fbf770c55a1$export$9696fcf1798e1cb5).PermissionError
        ];
        if (loggedErrors.includes(error.type)) console.error(error);
        return;
    }
    console.error(error, errorInfo);
}



var $acw62 = parcelRequire("acw62");

const $4671947198ddd366$export$a078c61943f9dbbe = (0, $acw62.createContext)(null);
const { MSTProvider: $4671947198ddd366$export$6087095ff4170ca6, RequestResult: $4671947198ddd366$export$f120933b6bd85d2d, useMutation: $4671947198ddd366$export$609860bf8b0084c, useQuery: $4671947198ddd366$export$dd0a697e1782aedd, useDelayedQuery: $4671947198ddd366$export$517ca4f7fee4e226, useSuspenseQuery: $4671947198ddd366$export$5bf2755c0a009e74, useStore: $4671947198ddd366$export$6ccbb43953eebf8 } = (0, $0f5d242bb09a95af$export$53dbb6361647310d)($4671947198ddd366$export$a078c61943f9dbbe);


function $97ceb908306849fc$var$downloadFile(file, name) {
    const url = window.URL.createObjectURL(new Blob([
        file
    ]));
    const link = document.createElement("a");
    link.href = url;
    link.download = name;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
}
const $97ceb908306849fc$export$a6a7b3d614e2e0ac = {
    downloadFile: $97ceb908306849fc$var$downloadFile
};


let $8aadbb076e78b446$var$fileService;
const $8aadbb076e78b446$export$5c0c0a0f4bf15c0f = (service)=>{
    $8aadbb076e78b446$var$fileService = service;
};
const $8aadbb076e78b446$export$fdb90e0242959057 = ()=>{
    if (!$8aadbb076e78b446$var$fileService) throw new Error("File service has not been initialized!");
    return {
        download: (file, name)=>{
            $8aadbb076e78b446$var$fileService?.download(file, name);
        }
    };
};




var $acw62 = parcelRequire("acw62");

var $4f362 = parcelRequire("4f362");

var $acw62 = parcelRequire("acw62");

var $4f362 = parcelRequire("4f362");

var $acw62 = parcelRequire("acw62");
if (!(0, $acw62.useState)) throw new Error("mobx-react-lite requires React with Hooks support");
if (!(0, $4f362.makeObservable)) throw new Error("mobx-react-lite@3 requires mobx at least version 6 to be available");



var $1u0KT = parcelRequire("1u0KT");


var $1u0KT = parcelRequire("1u0KT");

var $4f362 = parcelRequire("4f362");
function $99f5b14b61d7fc1b$export$fb2daceae6f5097a(callback) {
    callback();
}
function $99f5b14b61d7fc1b$export$294943bbc3c74f4f(reactionScheduler) {
    if (!reactionScheduler) {
        reactionScheduler = $99f5b14b61d7fc1b$export$fb2daceae6f5097a;
        console.warn("[MobX] Failed to get unstable_batched updates from react-dom / react-native");
    }
    (0, $4f362.configure)({
        reactionScheduler: reactionScheduler
    });
}
var $99f5b14b61d7fc1b$export$13ce1459b9a04b51 = function() {
    console.warn("[MobX] Deprecated");
    return true;
};


var $b5ce610bb01e19a7$var$deprecatedMessages = [];
function $b5ce610bb01e19a7$export$be38475be17599d(msg) {
    if (!$b5ce610bb01e19a7$var$deprecatedMessages.includes(msg)) {
        $b5ce610bb01e19a7$var$deprecatedMessages.push(msg);
        console.warn(msg);
    }
}



var $4f362 = parcelRequire("4f362");

var $acw62 = parcelRequire("acw62");

var $4f362 = parcelRequire("4f362");
function $7da2408ee6acaa23$export$ef795f1f307682c7(v) {
    return (0, $4f362.getDependencyTree)(v);
}


var $40dffc1f1e2603e1$var$globalIsUsingStaticRendering = false;
function $40dffc1f1e2603e1$export$5d52eaa7c0f24c9e(enable) {
    $40dffc1f1e2603e1$var$globalIsUsingStaticRendering = enable;
}
function $40dffc1f1e2603e1$export$55979271896d643e() {
    return $40dffc1f1e2603e1$var$globalIsUsingStaticRendering;
}


var $5d8a086ace365ebf$export$e901ba0ffe10ba41 = 10000;
var $5d8a086ace365ebf$export$1ae22ce5a82f26b6 = 10000;
var $5d8a086ace365ebf$export$b7a00d372cedeedd = /** @class */ function() {
    function TimerBasedFinalizationRegistry(finalize) {
        var _this = this;
        Object.defineProperty(this, "finalize", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: finalize
        });
        Object.defineProperty(this, "registrations", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: new Map()
        });
        Object.defineProperty(this, "sweepTimeout", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        // Bound so it can be used directly as setTimeout callback.
        Object.defineProperty(this, "sweep", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: function(maxAge) {
                if (maxAge === void 0) maxAge = $5d8a086ace365ebf$export$e901ba0ffe10ba41;
                // cancel timeout so we can force sweep anytime
                clearTimeout(_this.sweepTimeout);
                _this.sweepTimeout = undefined;
                var now = Date.now();
                _this.registrations.forEach(function(registration, token) {
                    if (now - registration.registeredAt >= maxAge) {
                        _this.finalize(registration.value);
                        _this.registrations.delete(token);
                    }
                });
                if (_this.registrations.size > 0) _this.scheduleSweep();
            }
        });
        // Bound so it can be exported directly as clearTimers test utility.
        Object.defineProperty(this, "finalizeAllImmediately", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: function() {
                _this.sweep(0);
            }
        });
    }
    // Token is actually required with this impl
    Object.defineProperty(TimerBasedFinalizationRegistry.prototype, "register", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function(target, value, token) {
            this.registrations.set(token, {
                value: value,
                registeredAt: Date.now()
            });
            this.scheduleSweep();
        }
    });
    Object.defineProperty(TimerBasedFinalizationRegistry.prototype, "unregister", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function(token) {
            this.registrations.delete(token);
        }
    });
    Object.defineProperty(TimerBasedFinalizationRegistry.prototype, "scheduleSweep", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function() {
            if (this.sweepTimeout === undefined) this.sweepTimeout = setTimeout(this.sweep, $5d8a086ace365ebf$export$1ae22ce5a82f26b6);
        }
    });
    return TimerBasedFinalizationRegistry;
}();
var $5d8a086ace365ebf$export$da5d55a244964b51 = typeof FinalizationRegistry !== "undefined" ? FinalizationRegistry : $5d8a086ace365ebf$export$b7a00d372cedeedd;


var $51a1c53254be4238$export$10e8a12fbfd8583c = new (0, $5d8a086ace365ebf$export$da5d55a244964b51)(function(adm) {
    var _a;
    (_a = adm.reaction) === null || _a === void 0 || _a.dispose();
    adm.reaction = null;
});


var $c8e45c4daa4b95cb$exports = {};
"use strict";

$c8e45c4daa4b95cb$exports = (parcelRequire("6KR8i"));


// Required by SSR when hydrating #3669
var $4374dd72d08982f1$var$getServerSnapshot = function() {};
function $4374dd72d08982f1$var$createReaction(adm) {
    adm.reaction = new (0, $4f362.Reaction)("observer".concat(adm.name), function() {
        var _a;
        adm.stateVersion = Symbol();
        // onStoreChange won't be available until the component "mounts".
        // If state changes in between initial render and mount,
        // `useSyncExternalStore` should handle that by checking the state version and issuing update.
        (_a = adm.onStoreChange) === null || _a === void 0 || _a.call(adm);
    });
}
function $4374dd72d08982f1$export$b9c7ecd090a87b14(render, baseComponentName) {
    if (baseComponentName === void 0) baseComponentName = "observed";
    if ((0, $40dffc1f1e2603e1$export$55979271896d643e)()) return render();
    var admRef = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(null);
    if (!admRef.current) {
        // First render
        var adm_1 = {
            reaction: null,
            onStoreChange: null,
            stateVersion: Symbol(),
            name: baseComponentName,
            subscribe: function(onStoreChange) {
                // Do NOT access admRef here!
                (0, $51a1c53254be4238$export$10e8a12fbfd8583c).unregister(adm_1);
                adm_1.onStoreChange = onStoreChange;
                if (!adm_1.reaction) {
                    // We've lost our reaction and therefore all subscriptions, occurs when:
                    // 1. Timer based finalization registry disposed reaction before component mounted.
                    // 2. React "re-mounts" same component without calling render in between (typically <StrictMode>).
                    // We have to recreate reaction and schedule re-render to recreate subscriptions,
                    // even if state did not change.
                    $4374dd72d08982f1$var$createReaction(adm_1);
                    // `onStoreChange` won't force update if subsequent `getSnapshot` returns same value.
                    // So we make sure that is not the case
                    adm_1.stateVersion = Symbol();
                }
                return function() {
                    var _a;
                    // Do NOT access admRef here!
                    adm_1.onStoreChange = null;
                    (_a = adm_1.reaction) === null || _a === void 0 || _a.dispose();
                    adm_1.reaction = null;
                };
            },
            getSnapshot: function() {
                // Do NOT access admRef here!
                return adm_1.stateVersion;
            }
        };
        admRef.current = adm_1;
    }
    var adm = admRef.current;
    if (!adm.reaction) {
        // First render or reaction was disposed by registry before subscribe
        $4374dd72d08982f1$var$createReaction(adm);
        // StrictMode/ConcurrentMode/Suspense may mean that our component is
        // rendered and abandoned multiple times, so we need to track leaked
        // Reactions.
        (0, $51a1c53254be4238$export$10e8a12fbfd8583c).register(admRef, adm, adm);
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useDebugValue(adm.reaction, (0, $7da2408ee6acaa23$export$ef795f1f307682c7));
    (0, $c8e45c4daa4b95cb$exports.useSyncExternalStore)(// Both of these must be stable, otherwise it would keep resubscribing every render.
    adm.subscribe, adm.getSnapshot, $4374dd72d08982f1$var$getServerSnapshot);
    // render the original component, but have the
    // reaction track the observables, so that rendering
    // can be invalidated (see above) once a dependency changes
    var renderResult;
    var exception;
    adm.reaction.track(function() {
        try {
            renderResult = render();
        } catch (e) {
            exception = e;
        }
    });
    if (exception) throw exception; // re-throw any exceptions caught during rendering
    return renderResult;
}





var $acw62 = parcelRequire("acw62");


var $252edd5f5fc562a7$var$warnObserverOptionsDeprecated = true;
var $252edd5f5fc562a7$var$hasSymbol = typeof Symbol === "function" && Symbol.for;
// Using react-is had some issues (and operates on elements, not on types), see #608 / #609
var $252edd5f5fc562a7$var$ReactForwardRefSymbol = $252edd5f5fc562a7$var$hasSymbol ? Symbol.for("react.forward_ref") : typeof (0, $acw62.forwardRef) === "function" && (0, $acw62.forwardRef)(function(props) {
    return null;
})["$$typeof"];
var $252edd5f5fc562a7$var$ReactMemoSymbol = $252edd5f5fc562a7$var$hasSymbol ? Symbol.for("react.memo") : typeof (0, $acw62.memo) === "function" && (0, $acw62.memo)(function(props) {
    return null;
})["$$typeof"];
function $252edd5f5fc562a7$export$b6ae1bc530f4c149(baseComponent, // TODO remove in next major
options) {
    var _a;
    if ($252edd5f5fc562a7$var$warnObserverOptionsDeprecated && options) {
        $252edd5f5fc562a7$var$warnObserverOptionsDeprecated = false;
        console.warn("[mobx-react-lite] `observer(fn, { forwardRef: true })` is deprecated, use `observer(React.forwardRef(fn))`");
    }
    if ($252edd5f5fc562a7$var$ReactMemoSymbol && baseComponent["$$typeof"] === $252edd5f5fc562a7$var$ReactMemoSymbol) throw new Error("[mobx-react-lite] You are trying to use `observer` on a function component wrapped in either another `observer` or `React.memo`. The observer already applies 'React.memo' for you.");
    // The working of observer is explained step by step in this talk: https://www.youtube.com/watch?v=cPF4iBedoF0&feature=youtu.be&t=1307
    if ((0, $40dffc1f1e2603e1$export$55979271896d643e)()) return baseComponent;
    var useForwardRef = (_a = options === null || options === void 0 ? void 0 : options.forwardRef) !== null && _a !== void 0 ? _a : false;
    var render = baseComponent;
    var baseComponentName = baseComponent.displayName || baseComponent.name;
    // If already wrapped with forwardRef, unwrap,
    // so we can patch render and apply memo
    if ($252edd5f5fc562a7$var$ReactForwardRefSymbol && baseComponent["$$typeof"] === $252edd5f5fc562a7$var$ReactForwardRefSymbol) {
        useForwardRef = true;
        render = baseComponent["render"];
        if (typeof render !== "function") throw new Error("[mobx-react-lite] `render` property of ForwardRef was not a function");
    }
    var observerComponent = function(props, ref) {
        return (0, $4374dd72d08982f1$export$b9c7ecd090a87b14)(function() {
            return render(props, ref);
        }, baseComponentName);
    };
    observerComponent.displayName = baseComponent.displayName;
    Object.defineProperty(observerComponent, "name", {
        value: baseComponent.name,
        writable: true,
        configurable: true
    });
    // Support legacy context: `contextTypes` must be applied before `memo`
    if (baseComponent.contextTypes) observerComponent.contextTypes = baseComponent.contextTypes;
    if (useForwardRef) // `forwardRef` must be applied prior `memo`
    // `forwardRef(observer(cmp))` throws:
    // "forwardRef requires a render function but received a `memo` component. Instead of forwardRef(memo(...)), use memo(forwardRef(...))"
    observerComponent = (0, $acw62.forwardRef)(observerComponent);
    // memo; we are not interested in deep updates
    // in props; we assume that if deep objects are changed,
    // this is in observables, which would have been tracked anyway
    observerComponent = (0, $acw62.memo)(observerComponent);
    $252edd5f5fc562a7$var$copyStaticProperties(baseComponent, observerComponent);
    Object.defineProperty(observerComponent, "contextTypes", {
        set: function() {
            var _a, _b;
            throw new Error("[mobx-react-lite] `".concat(this.displayName || ((_a = this.type) === null || _a === void 0 ? void 0 : _a.displayName) || ((_b = this.type) === null || _b === void 0 ? void 0 : _b.name) || "Component", ".contextTypes` must be set before applying `observer`."));
        }
    });
    return observerComponent;
}
// based on https://github.com/mridgway/hoist-non-react-statics/blob/master/src/index.js
var $252edd5f5fc562a7$var$hoistBlackList = {
    $$typeof: true,
    render: true,
    compare: true,
    type: true,
    // Don't redefine `displayName`,
    // it's defined as getter-setter pair on `memo` (see #3192).
    displayName: true
};
function $252edd5f5fc562a7$var$copyStaticProperties(base, target) {
    Object.keys(base).forEach(function(key) {
        if (!$252edd5f5fc562a7$var$hoistBlackList[key]) Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(base, key));
    });
}



function $d681ac3da181f0df$export$c1cbdee04e18ea8b(_a) {
    var children = _a.children, render = _a.render;
    var component = children || render;
    if (typeof component !== "function") return null;
    return (0, $4374dd72d08982f1$export$b9c7ecd090a87b14)(component);
}
$d681ac3da181f0df$export$c1cbdee04e18ea8b.propTypes = {
    children: $d681ac3da181f0df$var$ObserverPropsCheck,
    render: $d681ac3da181f0df$var$ObserverPropsCheck
};
$d681ac3da181f0df$export$c1cbdee04e18ea8b.displayName = "Observer";
function $d681ac3da181f0df$var$ObserverPropsCheck(props, key, componentName, location, propFullName) {
    var extraKey = key === "children" ? "render" : "children";
    var hasProp = typeof props[key] === "function";
    var hasExtraProp = typeof props[extraKey] === "function";
    if (hasProp && hasExtraProp) return new Error("MobX Observer: Do not use children and render in the same time in`" + componentName);
    if (hasProp || hasExtraProp) return null;
    return new Error("Invalid prop `" + propFullName + "` of type `" + typeof props[key] + "` supplied to" + " `" + componentName + "`, expected `function`.");
}



var $4f362 = parcelRequire("4f362");

var $acw62 = parcelRequire("acw62");
function $47eccd77986d48be$export$aa207039f277c5f(initializer, annotations) {
    return (0, $acw62.useState)(function() {
        return (0, $4f362.observable)(initializer(), annotations, {
            autoBind: true
        });
    })[0];
}



var $4f362 = parcelRequire("4f362");

var $acw62 = parcelRequire("acw62");



var $4f362 = parcelRequire("4f362");

var $acw62 = parcelRequire("acw62");
var $54d94be3a43cbdf6$var$__read = undefined && undefined.__read || function(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
};
function $54d94be3a43cbdf6$export$e0ded3646391939c(current) {
    (0, $b5ce610bb01e19a7$export$be38475be17599d)("[mobx-react-lite] 'useAsObservableSource' is deprecated, please store the values directly in an observable, for example by using 'useLocalObservable', and sync future updates using 'useEffect' when needed. See the README for examples.");
    var _a = $54d94be3a43cbdf6$var$__read((0, $acw62.useState)(function() {
        return (0, $4f362.observable)(current, {}, {
            deep: false
        });
    }), 1), res = _a[0];
    (0, $4f362.runInAction)(function() {
        Object.assign(res, current);
    });
    return res;
}


function $e13a4158639bc20c$export$f5b97ae82d1eeaf3(initializer, current) {
    (0, $b5ce610bb01e19a7$export$be38475be17599d)("[mobx-react-lite] 'useLocalStore' is deprecated, use 'useLocalObservable' instead.");
    var source = current && (0, $54d94be3a43cbdf6$export$e0ded3646391939c)(current);
    return (0, $acw62.useState)(function() {
        return (0, $4f362.observable)(initializer(source), undefined, {
            autoBind: true
        });
    })[0];
}



var $da731a93076ee9dc$var$_a;
(0, $99f5b14b61d7fc1b$export$294943bbc3c74f4f)((0, $1u0KT.unstable_batchedUpdates));
var $da731a93076ee9dc$export$469d51fb8d268227 = ($da731a93076ee9dc$var$_a = (0, $51a1c53254be4238$export$10e8a12fbfd8583c)["finalizeAllImmediately"]) !== null && $da731a93076ee9dc$var$_a !== void 0 ? $da731a93076ee9dc$var$_a : function() {};
function $da731a93076ee9dc$export$b9c7ecd090a87b14(fn, baseComponentName) {
    if (baseComponentName === void 0) baseComponentName = "observed";
    (0, $b5ce610bb01e19a7$export$be38475be17599d)("[mobx-react-lite] 'useObserver(fn)' is deprecated. Use `<Observer>{fn}</Observer>` instead, or wrap the entire component in `observer`.");
    return (0, $4374dd72d08982f1$export$b9c7ecd090a87b14)(fn, baseComponentName);
}
function $da731a93076ee9dc$export$7613124ee4202834(enable) {
    console.warn("[mobx-react-lite] 'useStaticRendering' is deprecated, use 'enableStaticRendering' instead");
    (0, $40dffc1f1e2603e1$export$5d52eaa7c0f24c9e)(enable);
}


function $aca50e9407ba89c9$var$shallowEqual(objA, objB) {
    //From: https://github.com/facebook/fbjs/blob/c69904a511b900266935168223063dd8772dfc40/packages/fbjs/src/core/shallowEqual.js
    if ($aca50e9407ba89c9$var$is(objA, objB)) return true;
    if (typeof objA !== "object" || objA === null || typeof objB !== "object" || objB === null) return false;
    var keysA = Object.keys(objA);
    var keysB = Object.keys(objB);
    if (keysA.length !== keysB.length) return false;
    for(var i = 0; i < keysA.length; i++){
        if (!Object.hasOwnProperty.call(objB, keysA[i]) || !$aca50e9407ba89c9$var$is(objA[keysA[i]], objB[keysA[i]])) return false;
    }
    return true;
}
function $aca50e9407ba89c9$var$is(x, y) {
    // From: https://github.com/facebook/fbjs/blob/c69904a511b900266935168223063dd8772dfc40/packages/fbjs/src/core/shallowEqual.js
    if (x === y) return x !== 0 || 1 / x === 1 / y;
    else return x !== x && y !== y;
}
// based on https://github.com/mridgway/hoist-non-react-statics/blob/master/src/index.js
var $aca50e9407ba89c9$var$hoistBlackList = {
    $$typeof: 1,
    render: 1,
    compare: 1,
    type: 1,
    childContextTypes: 1,
    contextType: 1,
    contextTypes: 1,
    defaultProps: 1,
    getDefaultProps: 1,
    getDerivedStateFromError: 1,
    getDerivedStateFromProps: 1,
    mixins: 1,
    displayName: 1,
    propTypes: 1
};
function $aca50e9407ba89c9$var$copyStaticProperties(base, target) {
    var protoProps = Object.getOwnPropertyNames(Object.getPrototypeOf(base));
    Object.getOwnPropertyNames(base).forEach(function(key) {
        if (!$aca50e9407ba89c9$var$hoistBlackList[key] && protoProps.indexOf(key) === -1) Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(base, key));
    });
}
/**
 * Utilities for patching componentWillUnmount, to make sure @disposeOnUnmount works correctly icm with user defined hooks
 * and the handler provided by mobx-react
 */ var $aca50e9407ba89c9$var$mobxMixins = /*#__PURE__*/ Symbol("patchMixins");
var $aca50e9407ba89c9$var$mobxPatchedDefinition = /*#__PURE__*/ Symbol("patchedDefinition");
function $aca50e9407ba89c9$var$getMixins(target, methodName) {
    var mixins = target[$aca50e9407ba89c9$var$mobxMixins] = target[$aca50e9407ba89c9$var$mobxMixins] || {};
    var methodMixins = mixins[methodName] = mixins[methodName] || {};
    methodMixins.locks = methodMixins.locks || 0;
    methodMixins.methods = methodMixins.methods || [];
    return methodMixins;
}
function $aca50e9407ba89c9$var$wrapper(realMethod, mixins) {
    var _this = this;
    for(var _len = arguments.length, args = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++)args[_key - 2] = arguments[_key];
    // locks are used to ensure that mixins are invoked only once per invocation, even on recursive calls
    mixins.locks++;
    try {
        var retVal;
        if (realMethod !== undefined && realMethod !== null) retVal = realMethod.apply(this, args);
        return retVal;
    } finally{
        mixins.locks--;
        if (mixins.locks === 0) mixins.methods.forEach(function(mx) {
            mx.apply(_this, args);
        });
    }
}
function $aca50e9407ba89c9$var$wrapFunction(realMethod, mixins) {
    var fn = function fn() {
        for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
        $aca50e9407ba89c9$var$wrapper.call.apply($aca50e9407ba89c9$var$wrapper, [
            this,
            realMethod,
            mixins
        ].concat(args));
    };
    return fn;
}
function $aca50e9407ba89c9$var$patch(target, methodName, mixinMethod) {
    var mixins = $aca50e9407ba89c9$var$getMixins(target, methodName);
    if (mixins.methods.indexOf(mixinMethod) < 0) mixins.methods.push(mixinMethod);
    var oldDefinition = Object.getOwnPropertyDescriptor(target, methodName);
    if (oldDefinition && oldDefinition[$aca50e9407ba89c9$var$mobxPatchedDefinition]) // already patched definition, do not repatch
    return;
    var originalMethod = target[methodName];
    var newDefinition = $aca50e9407ba89c9$var$createDefinition(target, methodName, oldDefinition ? oldDefinition.enumerable : undefined, mixins, originalMethod);
    Object.defineProperty(target, methodName, newDefinition);
}
function $aca50e9407ba89c9$var$createDefinition(target, methodName, enumerable, mixins, originalMethod) {
    var _ref;
    var wrappedFunc = $aca50e9407ba89c9$var$wrapFunction(originalMethod, mixins);
    return _ref = {}, _ref[$aca50e9407ba89c9$var$mobxPatchedDefinition] = true, _ref.get = function get() {
        return wrappedFunc;
    }, _ref.set = function set(value) {
        if (this === target) wrappedFunc = $aca50e9407ba89c9$var$wrapFunction(value, mixins);
        else {
            // when it is an instance of the prototype/a child prototype patch that particular case again separately
            // since we need to store separate values depending on wether it is the actual instance, the prototype, etc
            // e.g. the method for super might not be the same as the method for the prototype which might be not the same
            // as the method for the instance
            var newDefinition = $aca50e9407ba89c9$var$createDefinition(this, methodName, enumerable, mixins, value);
            Object.defineProperty(this, methodName, newDefinition);
        }
    }, _ref.configurable = true, _ref.enumerable = enumerable, _ref;
}
var $aca50e9407ba89c9$var$administrationSymbol = /*#__PURE__*/ Symbol("ObserverAdministration");
var $aca50e9407ba89c9$var$isMobXReactObserverSymbol = /*#__PURE__*/ Symbol("isMobXReactObserver");
var $aca50e9407ba89c9$var$observablePropDescriptors;
$aca50e9407ba89c9$var$observablePropDescriptors = {
    props: /*#__PURE__*/ $aca50e9407ba89c9$var$createObservablePropDescriptor("props"),
    state: /*#__PURE__*/ $aca50e9407ba89c9$var$createObservablePropDescriptor("state"),
    context: /*#__PURE__*/ $aca50e9407ba89c9$var$createObservablePropDescriptor("context")
};
function $aca50e9407ba89c9$var$getAdministration(component) {
    var _component$administra;
    // We create administration lazily, because we can't patch constructor
    // and the exact moment of initialization partially depends on React internals.
    // At the time of writing this, the first thing invoked is one of the observable getter/setter (state/props/context).
    return (_component$administra = component[$aca50e9407ba89c9$var$administrationSymbol]) != null ? _component$administra : component[$aca50e9407ba89c9$var$administrationSymbol] = {
        reaction: null,
        mounted: false,
        reactionInvalidatedBeforeMount: false,
        forceUpdate: null,
        name: $aca50e9407ba89c9$var$getDisplayName(component.constructor),
        state: undefined,
        props: undefined,
        context: undefined
    };
}
function $aca50e9407ba89c9$var$makeClassComponentObserver(componentClass) {
    var prototype = componentClass.prototype;
    if (componentClass[$aca50e9407ba89c9$var$isMobXReactObserverSymbol]) {
        var displayName = $aca50e9407ba89c9$var$getDisplayName(componentClass);
        throw new Error("The provided component class (" + displayName + ") has already been declared as an observer component.");
    } else componentClass[$aca50e9407ba89c9$var$isMobXReactObserverSymbol] = true;
    if (prototype.componentWillReact) throw new Error("The componentWillReact life-cycle event is no longer supported");
    if (componentClass["__proto__"] !== (0, $acw62.PureComponent)) {
        if (!prototype.shouldComponentUpdate) prototype.shouldComponentUpdate = $aca50e9407ba89c9$var$observerSCU;
        else if (prototype.shouldComponentUpdate !== $aca50e9407ba89c9$var$observerSCU) // n.b. unequal check, instead of existence check, as @observer might be on superclass as well
        throw new Error("It is not allowed to use shouldComponentUpdate in observer based components.");
    }
    Object.defineProperties(prototype, $aca50e9407ba89c9$var$observablePropDescriptors);
    var originalRender = prototype.render;
    if (typeof originalRender !== "function") {
        var _displayName = $aca50e9407ba89c9$var$getDisplayName(componentClass);
        throw new Error("[mobx-react] class component (" + _displayName + ") is missing `render` method." + "\n`observer` requires `render` being a function defined on prototype." + "\n`render = () => {}` or `render = function() {}` is not supported.");
    }
    prototype.render = function() {
        Object.defineProperty(this, "render", {
            // There is no safe way to replace render, therefore it's forbidden.
            configurable: false,
            writable: false,
            value: (0, $40dffc1f1e2603e1$export$55979271896d643e)() ? originalRender : $aca50e9407ba89c9$var$createReactiveRender.call(this, originalRender)
        });
        return this.render();
    };
    var originalComponentDidMount = prototype.componentDidMount;
    prototype.componentDidMount = function() {
        var _this = this;
        if (this.componentDidMount !== Object.getPrototypeOf(this).componentDidMount) {
            var _displayName2 = $aca50e9407ba89c9$var$getDisplayName(componentClass);
            throw new Error("[mobx-react] `observer(" + _displayName2 + ").componentDidMount` must be defined on prototype." + "\n`componentDidMount = () => {}` or `componentDidMount = function() {}` is not supported.");
        }
        // `componentDidMount` may not be called at all. React can abandon the instance after `render`.
        // That's why we use finalization registry to dispose reaction created during render.
        // Happens with `<Suspend>` see #3492
        //
        // `componentDidMount` can be called immediately after `componentWillUnmount` without calling `render` in between.
        // Happens with `<StrictMode>`see #3395.
        //
        // If `componentDidMount` is called, it's guaranteed to run synchronously with render (similary to `useLayoutEffect`).
        // Therefore we don't have to worry about external (observable) state being updated before mount (no state version checking).
        //
        // Things may change: "In the future, React will provide a feature that lets components preserve state between unmounts"
        var admin = $aca50e9407ba89c9$var$getAdministration(this);
        admin.mounted = true;
        // Component instance committed, prevent reaction disposal.
        (0, $51a1c53254be4238$export$10e8a12fbfd8583c).unregister(this);
        // We don't set forceUpdate before mount because it requires a reference to `this`,
        // therefore `this` could NOT be garbage collected before mount,
        // preventing reaction disposal by FinalizationRegistry and leading to memory leak.
        // As an alternative we could have `admin.instanceRef = new WeakRef(this)`, but lets avoid it if possible.
        admin.forceUpdate = function() {
            return _this.forceUpdate();
        };
        if (!admin.reaction || admin.reactionInvalidatedBeforeMount) // Missing reaction:
        // 1. Instance was unmounted (reaction disposed) and immediately remounted without running render #3395.
        // 2. Reaction was disposed by finalization registry before mount. Shouldn't ever happen for class components:
        // `componentDidMount` runs synchronously after render, but our registry are deferred (can't run in between).
        // In any case we lost subscriptions to observables, so we have to create new reaction and re-render to resubscribe.
        // The reaction will be created lazily by following render.
        // Reaction invalidated before mount:
        // 1. A descendant's `componenDidMount` invalidated it's parent #3730
        admin.forceUpdate();
        return originalComponentDidMount == null ? void 0 : originalComponentDidMount.apply(this, arguments);
    };
    // TODO@major Overly complicated "patch" is only needed to support the deprecated @disposeOnUnmount
    $aca50e9407ba89c9$var$patch(prototype, "componentWillUnmount", function() {
        var _admin$reaction;
        if ((0, $40dffc1f1e2603e1$export$55979271896d643e)()) return;
        var admin = $aca50e9407ba89c9$var$getAdministration(this);
        (_admin$reaction = admin.reaction) == null || _admin$reaction.dispose();
        admin.reaction = null;
        admin.forceUpdate = null;
        admin.mounted = false;
        admin.reactionInvalidatedBeforeMount = false;
    });
    return componentClass;
}
// Generates a friendly name for debugging
function $aca50e9407ba89c9$var$getDisplayName(componentClass) {
    return componentClass.displayName || componentClass.name || "<component>";
}
function $aca50e9407ba89c9$var$createReactiveRender(originalRender) {
    var boundOriginalRender = originalRender.bind(this);
    var admin = $aca50e9407ba89c9$var$getAdministration(this);
    function reactiveRender() {
        if (!admin.reaction) {
            // Create reaction lazily to support re-mounting #3395
            admin.reaction = $aca50e9407ba89c9$var$createReaction(admin);
            if (!admin.mounted) // React can abandon this instance and never call `componentDidMount`/`componentWillUnmount`,
            // we have to make sure reaction will be disposed.
            (0, $51a1c53254be4238$export$10e8a12fbfd8583c).register(this, admin, this);
        }
        var error = undefined;
        var renderResult = undefined;
        admin.reaction.track(function() {
            try {
                // TODO@major
                // Optimization: replace with _allowStateChangesStart/End (not available in mobx@6.0.0)
                renderResult = (0, $4f362._allowStateChanges)(false, boundOriginalRender);
            } catch (e) {
                error = e;
            }
        });
        if (error) throw error;
        return renderResult;
    }
    return reactiveRender;
}
function $aca50e9407ba89c9$var$createReaction(admin) {
    return new (0, $4f362.Reaction)(admin.name + ".render()", function() {
        if (!admin.mounted) {
            // This is neccessary to avoid react warning about calling forceUpdate on component that isn't mounted yet.
            // This happens when component is abandoned after render - our reaction is already created and reacts to changes.
            // `componenDidMount` runs synchronously after `render`, so unlike functional component, there is no delay during which the reaction could be invalidated.
            // However `componentDidMount` runs AFTER it's descendants' `componentDidMount`, which CAN invalidate the reaction, see #3730. Therefore remember and forceUpdate on mount.
            admin.reactionInvalidatedBeforeMount = true;
            return;
        }
        try {
            admin.forceUpdate == null || admin.forceUpdate();
        } catch (error) {
            var _admin$reaction2;
            (_admin$reaction2 = admin.reaction) == null || _admin$reaction2.dispose();
            admin.reaction = null;
        }
    });
}
function $aca50e9407ba89c9$var$observerSCU(nextProps, nextState) {
    if ((0, $40dffc1f1e2603e1$export$55979271896d643e)()) console.warn("[mobx-react] It seems that a re-rendering of a React component is triggered while in static (server-side) mode. Please make sure components are rendered only once server-side.");
    // update on any state changes (as is the default)
    if (this.state !== nextState) return true;
    // update if props are shallowly not equal, inspired by PureRenderMixin
    // we could return just 'false' here, and avoid the `skipRender` checks etc
    // however, it is nicer if lifecycle events are triggered like usually,
    // so we return true here if props are shallowly modified.
    return !$aca50e9407ba89c9$var$shallowEqual(this.props, nextProps);
}
function $aca50e9407ba89c9$var$createObservablePropDescriptor(key) {
    return {
        configurable: true,
        enumerable: true,
        get: function get() {
            var admin = $aca50e9407ba89c9$var$getAdministration(this);
            var derivation = (0, $4f362._getGlobalState)().trackingDerivation;
            if (derivation && derivation !== admin.reaction) throw new Error('[mobx-react] Cannot read "' + admin.name + "." + key + "\" in a reactive context, as it isn't observable.\n                    Please use component lifecycle method to copy the value into a local observable first.\n                    See https://github.com/mobxjs/mobx/blob/main/packages/mobx-react/README.md#note-on-using-props-and-state-in-derivations");
            return admin[key];
        },
        set: function set(value) {
            $aca50e9407ba89c9$var$getAdministration(this)[key] = value;
        }
    };
}
function $aca50e9407ba89c9$export$b6ae1bc530f4c149(component, context) {
    if (context && context.kind !== "class") throw new Error("The @observer decorator can be used on classes only");
    if (component["isMobxInjector"] === true) console.warn("Mobx observer: You are trying to use `observer` on a component that already has `inject`. Please apply `observer` before applying `inject`");
    if (Object.prototype.isPrototypeOf.call((0, $acw62.Component), component) || Object.prototype.isPrototypeOf.call((0, $acw62.PureComponent), component)) // Class component
    return $aca50e9407ba89c9$var$makeClassComponentObserver(component);
    else // Function component
    return (0, $252edd5f5fc562a7$export$b6ae1bc530f4c149)(component);
}
function $aca50e9407ba89c9$var$_extends() {
    $aca50e9407ba89c9$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $aca50e9407ba89c9$var$_extends.apply(this, arguments);
}
function $aca50e9407ba89c9$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var $aca50e9407ba89c9$var$_excluded = [
    "children"
];
var $aca50e9407ba89c9$export$f07786cea590ef31 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createContext({});
function $aca50e9407ba89c9$export$2881499e37b75b9a(props) {
    var children = props.children, stores = $aca50e9407ba89c9$var$_objectWithoutPropertiesLoose(props, $aca50e9407ba89c9$var$_excluded);
    var parentValue = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useContext($aca50e9407ba89c9$export$f07786cea590ef31);
    var mutableProviderRef = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef($aca50e9407ba89c9$var$_extends({}, parentValue, stores));
    var value = mutableProviderRef.current;
    var newValue = $aca50e9407ba89c9$var$_extends({}, value, stores); // spread in previous state for the context based stores
    if (!$aca50e9407ba89c9$var$shallowEqual(value, newValue)) throw new Error("MobX Provider: The set of provided stores has changed. See: https://github.com/mobxjs/mobx-react#the-set-of-provided-stores-has-changed-error.");
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($aca50e9407ba89c9$export$f07786cea590ef31.Provider, {
        value: value
    }, children);
}
$aca50e9407ba89c9$export$2881499e37b75b9a.displayName = "MobXProvider";
/**
 * Store Injection
 */ function $aca50e9407ba89c9$var$createStoreInjector(grabStoresFn, component, injectNames, makeReactive) {
    // Support forward refs
    var Injector = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).forwardRef(function(props, ref) {
        var newProps = $aca50e9407ba89c9$var$_extends({}, props);
        var context = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useContext($aca50e9407ba89c9$export$f07786cea590ef31);
        Object.assign(newProps, grabStoresFn(context || {}, newProps) || {});
        if (ref) newProps.ref = ref;
        return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(component, newProps);
    });
    if (makeReactive) Injector = $aca50e9407ba89c9$export$b6ae1bc530f4c149(Injector);
    Injector["isMobxInjector"] = true; // assigned late to suppress observer warning
    // Static fields from component should be visible on the generated Injector
    $aca50e9407ba89c9$var$copyStaticProperties(component, Injector);
    Injector["wrappedComponent"] = component;
    Injector.displayName = $aca50e9407ba89c9$var$getInjectName(component, injectNames);
    return Injector;
}
function $aca50e9407ba89c9$var$getInjectName(component, injectNames) {
    var displayName;
    var componentName = component.displayName || component.name || component.constructor && component.constructor.name || "Component";
    if (injectNames) displayName = "inject-with-" + injectNames + "(" + componentName + ")";
    else displayName = "inject(" + componentName + ")";
    return displayName;
}
function $aca50e9407ba89c9$var$grabStoresByName(storeNames) {
    return function(baseStores, nextProps) {
        storeNames.forEach(function(storeName) {
            if (storeName in nextProps // prefer props over stores
            ) return;
            if (!(storeName in baseStores)) throw new Error("MobX injector: Store '" + storeName + "' is not available! Make sure it is provided by some Provider");
            nextProps[storeName] = baseStores[storeName];
        });
        return nextProps;
    };
}
/**
 * higher order component that injects stores to a child.
 * takes either a varargs list of strings, which are stores read from the context,
 * or a function that manually maps the available stores from the context to props:
 * storesToProps(mobxStores, props, context) => newProps
 */ function $aca50e9407ba89c9$export$a976684a0efeb93f() {
    for(var _len = arguments.length, storeNames = new Array(_len), _key = 0; _key < _len; _key++)storeNames[_key] = arguments[_key];
    if (typeof arguments[0] === "function") {
        var grabStoresFn = arguments[0];
        return function(componentClass) {
            return $aca50e9407ba89c9$var$createStoreInjector(grabStoresFn, componentClass, grabStoresFn.name, true);
        };
    } else return function(componentClass) {
        return $aca50e9407ba89c9$var$createStoreInjector($aca50e9407ba89c9$var$grabStoresByName(storeNames), componentClass, storeNames.join("-"), false);
    };
}
var $aca50e9407ba89c9$var$reactMajorVersion = /*#__PURE__*/ Number.parseInt(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).version.split(".")[0]);
var $aca50e9407ba89c9$var$warnedAboutDisposeOnUnmountDeprecated = false;
var $aca50e9407ba89c9$var$protoStoreKey = /*#__PURE__*/ Symbol("disposeOnUnmountProto");
var $aca50e9407ba89c9$var$instStoreKey = /*#__PURE__*/ Symbol("disposeOnUnmountInst");
function $aca50e9407ba89c9$var$runDisposersOnWillUnmount() {
    var _this = this;
    [].concat(this[$aca50e9407ba89c9$var$protoStoreKey] || [], this[$aca50e9407ba89c9$var$instStoreKey] || []).forEach(function(propKeyOrFunction) {
        var prop = typeof propKeyOrFunction === "string" ? _this[propKeyOrFunction] : propKeyOrFunction;
        if (prop !== undefined && prop !== null) {
            if (Array.isArray(prop)) prop.map(function(f) {
                return f();
            });
            else prop();
        }
    });
}
/**
 * @deprecated `disposeOnUnmount` is not compatible with React 18 and higher.
 */ function $aca50e9407ba89c9$export$4e749cb731da87a9(target, propertyKeyOrFunction) {
    if (Array.isArray(propertyKeyOrFunction)) return propertyKeyOrFunction.map(function(fn) {
        return $aca50e9407ba89c9$export$4e749cb731da87a9(target, fn);
    });
    if (!$aca50e9407ba89c9$var$warnedAboutDisposeOnUnmountDeprecated) {
        if ($aca50e9407ba89c9$var$reactMajorVersion >= 18) console.error("[mobx-react] disposeOnUnmount is not compatible with React 18 and higher. Don't use it.");
        else console.warn("[mobx-react] disposeOnUnmount is deprecated. It won't work correctly with React 18 and higher.");
        $aca50e9407ba89c9$var$warnedAboutDisposeOnUnmountDeprecated = true;
    }
    var c = Object.getPrototypeOf(target).constructor;
    var c2 = Object.getPrototypeOf(target.constructor);
    // Special case for react-hot-loader
    var c3 = Object.getPrototypeOf(Object.getPrototypeOf(target));
    if (!(c === (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Component || c === (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).PureComponent || c2 === (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Component || c2 === (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).PureComponent || c3 === (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Component || c3 === (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).PureComponent)) throw new Error("[mobx-react] disposeOnUnmount only supports direct subclasses of React.Component or React.PureComponent.");
    if (typeof propertyKeyOrFunction !== "string" && typeof propertyKeyOrFunction !== "function" && !Array.isArray(propertyKeyOrFunction)) throw new Error("[mobx-react] disposeOnUnmount only works if the parameter is either a property key or a function.");
    // decorator's target is the prototype, so it doesn't have any instance properties like props
    var isDecorator = typeof propertyKeyOrFunction === "string";
    // add property key / function we want run (disposed) to the store
    var componentWasAlreadyModified = !!target[$aca50e9407ba89c9$var$protoStoreKey] || !!target[$aca50e9407ba89c9$var$instStoreKey];
    var store = isDecorator ? // decorators are added to the prototype store
    target[$aca50e9407ba89c9$var$protoStoreKey] || (target[$aca50e9407ba89c9$var$protoStoreKey] = []) : // functions are added to the instance store
    target[$aca50e9407ba89c9$var$instStoreKey] || (target[$aca50e9407ba89c9$var$instStoreKey] = []);
    store.push(propertyKeyOrFunction);
    // tweak the component class componentWillUnmount if not done already
    if (!componentWasAlreadyModified) $aca50e9407ba89c9$var$patch(target, "componentWillUnmount", $aca50e9407ba89c9$var$runDisposersOnWillUnmount);
    // return the disposer as is if invoked as a non decorator
    if (typeof propertyKeyOrFunction !== "string") return propertyKeyOrFunction;
}
// Copied from React.PropTypes
function $aca50e9407ba89c9$var$createChainableTypeChecker(validator) {
    function checkType(isRequired, props, propName, componentName, location, propFullName) {
        for(var _len = arguments.length, rest = new Array(_len > 6 ? _len - 6 : 0), _key = 6; _key < _len; _key++)rest[_key - 6] = arguments[_key];
        return (0, $4f362.untracked)(function() {
            componentName = componentName || "<<anonymous>>";
            propFullName = propFullName || propName;
            if (props[propName] == null) {
                if (isRequired) {
                    var actual = props[propName] === null ? "null" : "undefined";
                    return new Error("The " + location + " `" + propFullName + "` is marked as required " + "in `" + componentName + "`, but its value is `" + actual + "`.");
                }
                return null;
            } else // @ts-ignore rest arg is necessary for some React internals - fails tests otherwise
            return validator.apply(void 0, [
                props,
                propName,
                componentName,
                location,
                propFullName
            ].concat(rest));
        });
    }
    var chainedCheckType = checkType.bind(null, false);
    // Add isRequired to satisfy Requirable
    chainedCheckType.isRequired = checkType.bind(null, true);
    return chainedCheckType;
}
// Copied from React.PropTypes
function $aca50e9407ba89c9$var$isSymbol(propType, propValue) {
    // Native Symbol.
    if (propType === "symbol") return true;
    // 19.4.3.5 Symbol.prototype[@@toStringTag] === 'Symbol'
    if (propValue["@@toStringTag"] === "Symbol") return true;
    // Fallback for non-spec compliant Symbols which are polyfilled.
    if (typeof Symbol === "function" && propValue instanceof Symbol) return true;
    return false;
}
// Copied from React.PropTypes
function $aca50e9407ba89c9$var$getPropType(propValue) {
    var propType = typeof propValue;
    if (Array.isArray(propValue)) return "array";
    if (propValue instanceof RegExp) // Old webkits (at least until Android 4.0) return 'function' rather than
    // 'object' for typeof a RegExp. We'll normalize this here so that /bla/
    // passes PropTypes.object.
    return "object";
    if ($aca50e9407ba89c9$var$isSymbol(propType, propValue)) return "symbol";
    return propType;
}
// This handles more types than `getPropType`. Only used for error messages.
// Copied from React.PropTypes
function $aca50e9407ba89c9$var$getPreciseType(propValue) {
    var propType = $aca50e9407ba89c9$var$getPropType(propValue);
    if (propType === "object") {
        if (propValue instanceof Date) return "date";
        else if (propValue instanceof RegExp) return "regexp";
    }
    return propType;
}
function $aca50e9407ba89c9$var$createObservableTypeCheckerCreator(allowNativeType, mobxType) {
    return $aca50e9407ba89c9$var$createChainableTypeChecker(function(props, propName, componentName, location, propFullName) {
        return (0, $4f362.untracked)(function() {
            if (allowNativeType) {
                if ($aca50e9407ba89c9$var$getPropType(props[propName]) === mobxType.toLowerCase()) return null;
            }
            var mobxChecker;
            switch(mobxType){
                case "Array":
                    mobxChecker = (0, $4f362.isObservableArray);
                    break;
                case "Object":
                    mobxChecker = (0, $4f362.isObservableObject);
                    break;
                case "Map":
                    mobxChecker = (0, $4f362.isObservableMap);
                    break;
                default:
                    throw new Error("Unexpected mobxType: " + mobxType);
            }
            var propValue = props[propName];
            if (!mobxChecker(propValue)) {
                var preciseType = $aca50e9407ba89c9$var$getPreciseType(propValue);
                var nativeTypeExpectationMessage = allowNativeType ? " or javascript `" + mobxType.toLowerCase() + "`" : "";
                return new Error("Invalid prop `" + propFullName + "` of type `" + preciseType + "` supplied to" + " `" + componentName + "`, expected `mobx.Observable" + mobxType + "`" + nativeTypeExpectationMessage + ".");
            }
            return null;
        });
    });
}
function $aca50e9407ba89c9$var$createObservableArrayOfTypeChecker(allowNativeType, typeChecker) {
    return $aca50e9407ba89c9$var$createChainableTypeChecker(function(props, propName, componentName, location, propFullName) {
        for(var _len2 = arguments.length, rest = new Array(_len2 > 5 ? _len2 - 5 : 0), _key2 = 5; _key2 < _len2; _key2++)rest[_key2 - 5] = arguments[_key2];
        return (0, $4f362.untracked)(function() {
            if (typeof typeChecker !== "function") return new Error("Property `" + propFullName + "` of component `" + componentName + "` has " + "invalid PropType notation.");
            else {
                var error = $aca50e9407ba89c9$var$createObservableTypeCheckerCreator(allowNativeType, "Array")(props, propName, componentName, location, propFullName);
                if (error instanceof Error) return error;
                var propValue = props[propName];
                for(var i = 0; i < propValue.length; i++){
                    error = typeChecker.apply(void 0, [
                        propValue,
                        i,
                        componentName,
                        location,
                        propFullName + "[" + i + "]"
                    ].concat(rest));
                    if (error instanceof Error) return error;
                }
                return null;
            }
        });
    });
}
var $aca50e9407ba89c9$var$observableArray = /*#__PURE__*/ $aca50e9407ba89c9$var$createObservableTypeCheckerCreator(false, "Array");
var $aca50e9407ba89c9$var$observableArrayOf = /*#__PURE__*/ $aca50e9407ba89c9$var$createObservableArrayOfTypeChecker.bind(null, false);
var $aca50e9407ba89c9$var$observableMap = /*#__PURE__*/ $aca50e9407ba89c9$var$createObservableTypeCheckerCreator(false, "Map");
var $aca50e9407ba89c9$var$observableObject = /*#__PURE__*/ $aca50e9407ba89c9$var$createObservableTypeCheckerCreator(false, "Object");
var $aca50e9407ba89c9$var$arrayOrObservableArray = /*#__PURE__*/ $aca50e9407ba89c9$var$createObservableTypeCheckerCreator(true, "Array");
var $aca50e9407ba89c9$var$arrayOrObservableArrayOf = /*#__PURE__*/ $aca50e9407ba89c9$var$createObservableArrayOfTypeChecker.bind(null, true);
var $aca50e9407ba89c9$var$objectOrObservableObject = /*#__PURE__*/ $aca50e9407ba89c9$var$createObservableTypeCheckerCreator(true, "Object");
var $aca50e9407ba89c9$export$e0c95a451cd220b7 = {
    observableArray: $aca50e9407ba89c9$var$observableArray,
    observableArrayOf: $aca50e9407ba89c9$var$observableArrayOf,
    observableMap: $aca50e9407ba89c9$var$observableMap,
    observableObject: $aca50e9407ba89c9$var$observableObject,
    arrayOrObservableArray: $aca50e9407ba89c9$var$arrayOrObservableArray,
    arrayOrObservableArrayOf: $aca50e9407ba89c9$var$arrayOrObservableArrayOf,
    objectOrObservableObject: $aca50e9407ba89c9$var$objectOrObservableObject
};
if (!(0, $acw62.Component)) throw new Error("mobx-react requires React to be available");
if (!(0, $4f362.observable)) throw new Error("mobx-react requires mobx to be available");



var $acw62 = parcelRequire("acw62");
var $27ab08c24269de64$exports = {};
function $27ab08c24269de64$var$_extends() {
    $27ab08c24269de64$exports = $27ab08c24269de64$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    }, $27ab08c24269de64$exports.__esModule = true, $27ab08c24269de64$exports["default"] = $27ab08c24269de64$exports;
    return $27ab08c24269de64$var$_extends.apply(this, arguments);
}
$27ab08c24269de64$exports = $27ab08c24269de64$var$_extends, $27ab08c24269de64$exports.__esModule = true, $27ab08c24269de64$exports["default"] = $27ab08c24269de64$exports;



var $acw62 = parcelRequire("acw62");
var $dca61ba26e2661d8$exports = {};
/**
 * This file automatically generated from `pre-publish.js`.
 * Do not manually edit.
 */ $dca61ba26e2661d8$exports = {
    "area": true,
    "base": true,
    "br": true,
    "col": true,
    "embed": true,
    "hr": true,
    "img": true,
    "input": true,
    "link": true,
    "meta": true,
    "param": true,
    "source": true,
    "track": true,
    "wbr": true
};


var $69084eaa2e6a0d50$var$t = /\s([^'"/\s><]+?)[\s/>]|([^\s=]+)=\s?(".*?"|'.*?')/g;
function $69084eaa2e6a0d50$var$n(n) {
    var r = {
        type: "tag",
        name: "",
        voidElement: !1,
        attrs: {},
        children: []
    }, i = n.match(/<\/?([^\s]+?)[/\s>]/);
    if (i && (r.name = i[1], ((0, (/*@__PURE__*/$parcel$interopDefault($dca61ba26e2661d8$exports)))[i[1]] || "/" === n.charAt(n.length - 2)) && (r.voidElement = !0), r.name.startsWith("!--"))) {
        var s = n.indexOf("-->");
        return {
            type: "comment",
            comment: -1 !== s ? n.slice(4, s) : ""
        };
    }
    for(var a = new RegExp($69084eaa2e6a0d50$var$t), c = null; null !== (c = a.exec(n));)if (c[0].trim()) {
        if (c[1]) {
            var o = c[1].trim(), l = [
                o,
                ""
            ];
            o.indexOf("=") > -1 && (l = o.split("=")), r.attrs[l[0]] = l[1], a.lastIndex--;
        } else c[2] && (r.attrs[c[2]] = c[3].trim().substring(1, c[3].length - 1));
    }
    return r;
}
var $69084eaa2e6a0d50$var$r = /<[a-zA-Z0-9\-\!\/](?:"[^"]*"|'[^']*'|[^'">])*>/g, $69084eaa2e6a0d50$var$i = /^\s*$/, $69084eaa2e6a0d50$var$s = Object.create(null);
function $69084eaa2e6a0d50$var$a(e, t) {
    switch(t.type){
        case "text":
            return e + t.content;
        case "tag":
            return e += "<" + t.name + (t.attrs ? function(e) {
                var t = [];
                for(var n in e)t.push(n + '="' + e[n] + '"');
                return t.length ? " " + t.join(" ") : "";
            }(t.attrs) : "") + (t.voidElement ? "/>" : ">"), t.voidElement ? e : e + t.children.reduce($69084eaa2e6a0d50$var$a, "") + "</" + t.name + ">";
        case "comment":
            return e + "<!--" + t.comment + "-->";
    }
}
var $69084eaa2e6a0d50$var$c = {
    parse: function(e, t) {
        t || (t = {}), t.components || (t.components = $69084eaa2e6a0d50$var$s);
        var a, c = [], o = [], l = -1, m = !1;
        if (0 !== e.indexOf("<")) {
            var u = e.indexOf("<");
            c.push({
                type: "text",
                content: -1 === u ? e : e.substring(0, u)
            });
        }
        return e.replace($69084eaa2e6a0d50$var$r, function(r, s) {
            if (m) {
                if (r !== "</" + a.name + ">") return;
                m = !1;
            }
            var u, f = "/" !== r.charAt(1), h = r.startsWith("<!--"), p = s + r.length, d = e.charAt(p);
            if (h) {
                var v = $69084eaa2e6a0d50$var$n(r);
                return l < 0 ? (c.push(v), c) : ((u = o[l]).children.push(v), c);
            }
            if (f && (l++, "tag" === (a = $69084eaa2e6a0d50$var$n(r)).type && t.components[a.name] && (a.type = "component", m = !0), a.voidElement || m || !d || "<" === d || a.children.push({
                type: "text",
                content: e.slice(p, e.indexOf("<", p))
            }), 0 === l && c.push(a), (u = o[l - 1]) && u.children.push(a), o[l] = a), (!f || a.voidElement) && (l > -1 && (a.voidElement || a.name === r.slice(2, -1)) && (l--, a = -1 === l ? c : o[l]), !m && "<" !== d && d)) {
                u = -1 === l ? c : o[l].children;
                var x = e.indexOf("<", p), g = e.slice(p, -1 === x ? void 0 : x);
                $69084eaa2e6a0d50$var$i.test(g) && (g = " "), (x > -1 && l + u.length >= 0 || " " !== g) && u.push({
                    type: "text",
                    content: g
                });
            }
        }), c;
    },
    stringify: function(e) {
        return e.reduce(function(e, t) {
            return e + $69084eaa2e6a0d50$var$a("", t);
        }, "");
    }
};
var $69084eaa2e6a0d50$export$2e2bcd8739ae039 = $69084eaa2e6a0d50$var$c;


function $cfb6e0167e0b350d$export$c106dd0671a0fc2d() {
    if (console && console.warn) {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        if (typeof args[0] === "string") args[0] = `react-i18next:: ${args[0]}`;
        console.warn(...args);
    }
}
const $cfb6e0167e0b350d$var$alreadyWarned = {};
function $cfb6e0167e0b350d$export$5b28268982f175ba() {
    for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
    if (typeof args[0] === "string" && $cfb6e0167e0b350d$var$alreadyWarned[args[0]]) return;
    if (typeof args[0] === "string") $cfb6e0167e0b350d$var$alreadyWarned[args[0]] = new Date();
    $cfb6e0167e0b350d$export$c106dd0671a0fc2d(...args);
}
const $cfb6e0167e0b350d$var$loadedClb = (i18n, cb)=>()=>{
        if (i18n.isInitialized) cb();
        else {
            const initialized = ()=>{
                setTimeout(()=>{
                    i18n.off("initialized", initialized);
                }, 0);
                cb();
            };
            i18n.on("initialized", initialized);
        }
    };
function $cfb6e0167e0b350d$export$83be934b53fff43b(i18n, ns, cb) {
    i18n.loadNamespaces(ns, $cfb6e0167e0b350d$var$loadedClb(i18n, cb));
}
function $cfb6e0167e0b350d$export$8cd7e7a54fa865bc(i18n, lng, ns, cb) {
    if (typeof ns === "string") ns = [
        ns
    ];
    ns.forEach((n)=>{
        if (i18n.options.ns.indexOf(n) < 0) i18n.options.ns.push(n);
    });
    i18n.loadLanguages(lng, $cfb6e0167e0b350d$var$loadedClb(i18n, cb));
}
function $cfb6e0167e0b350d$var$oldI18nextHasLoadedNamespace(ns, i18n) {
    let options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    const lng = i18n.languages[0];
    const fallbackLng = i18n.options ? i18n.options.fallbackLng : false;
    const lastLng = i18n.languages[i18n.languages.length - 1];
    if (lng.toLowerCase() === "cimode") return true;
    const loadNotPending = (l, n)=>{
        const loadState = i18n.services.backendConnector.state[`${l}|${n}`];
        return loadState === -1 || loadState === 2;
    };
    if (options.bindI18n && options.bindI18n.indexOf("languageChanging") > -1 && i18n.services.backendConnector.backend && i18n.isLanguageChangingTo && !loadNotPending(i18n.isLanguageChangingTo, ns)) return false;
    if (i18n.hasResourceBundle(lng, ns)) return true;
    if (!i18n.services.backendConnector.backend || i18n.options.resources && !i18n.options.partialBundledLanguages) return true;
    if (loadNotPending(lng, ns) && (!fallbackLng || loadNotPending(lastLng, ns))) return true;
    return false;
}
function $cfb6e0167e0b350d$export$93d9ee97c1ad3f31(ns, i18n) {
    let options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    if (!i18n.languages || !i18n.languages.length) {
        $cfb6e0167e0b350d$export$5b28268982f175ba("i18n.languages were undefined or empty", i18n.languages);
        return true;
    }
    const isNewerI18next = i18n.options.ignoreJSONStructure !== undefined;
    if (!isNewerI18next) return $cfb6e0167e0b350d$var$oldI18nextHasLoadedNamespace(ns, i18n, options);
    return i18n.hasLoadedNamespace(ns, {
        lng: options.lng,
        precheck: (i18nInstance, loadNotPending)=>{
            if (options.bindI18n && options.bindI18n.indexOf("languageChanging") > -1 && i18nInstance.services.backendConnector.backend && i18nInstance.isLanguageChangingTo && !loadNotPending(i18nInstance.isLanguageChangingTo, ns)) return false;
        }
    });
}
function $cfb6e0167e0b350d$export$be63e0664592e141(Component) {
    return Component.displayName || Component.name || (typeof Component === "string" && Component.length > 0 ? Component : "Unknown");
}


const $d7f2d92b0368699f$var$matchHtmlEntity = /&(?:amp|#38|lt|#60|gt|#62|apos|#39|quot|#34|nbsp|#160|copy|#169|reg|#174|hellip|#8230|#x2F|#47);/g;
const $d7f2d92b0368699f$var$htmlEntities = {
    "&amp;": "&",
    "&#38;": "&",
    "&lt;": "<",
    "&#60;": "<",
    "&gt;": ">",
    "&#62;": ">",
    "&apos;": "'",
    "&#39;": "'",
    "&quot;": '"',
    "&#34;": '"',
    "&nbsp;": " ",
    "&#160;": " ",
    "&copy;": "\xa9",
    "&#169;": "\xa9",
    "&reg;": "\xae",
    "&#174;": "\xae",
    "&hellip;": "\u2026",
    "&#8230;": "\u2026",
    "&#x2F;": "/",
    "&#47;": "/"
};
const $d7f2d92b0368699f$var$unescapeHtmlEntity = (m)=>$d7f2d92b0368699f$var$htmlEntities[m];
const $d7f2d92b0368699f$export$e8bacd2802a88316 = (text)=>text.replace($d7f2d92b0368699f$var$matchHtmlEntity, $d7f2d92b0368699f$var$unescapeHtmlEntity);


let $4f75eea5b29ffc65$var$defaultOptions = {
    bindI18n: "languageChanged",
    bindI18nStore: "",
    transEmptyNodeValue: "",
    transSupportBasicHtmlNodes: true,
    transWrapTextNodes: "",
    transKeepBasicHtmlNodesFor: [
        "br",
        "strong",
        "i",
        "p"
    ],
    useSuspense: true,
    unescape: $d7f2d92b0368699f$export$e8bacd2802a88316
};
function $4f75eea5b29ffc65$export$2e2366488d12e20d() {
    let options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    $4f75eea5b29ffc65$var$defaultOptions = {
        ...$4f75eea5b29ffc65$var$defaultOptions,
        ...options
    };
}
function $4f75eea5b29ffc65$export$212bb2fc580a90a8() {
    return $4f75eea5b29ffc65$var$defaultOptions;
}


let $1d04edb3ddd0d89e$var$i18nInstance;
function $1d04edb3ddd0d89e$export$a039134f2fc7e0(instance) {
    $1d04edb3ddd0d89e$var$i18nInstance = instance;
}
function $1d04edb3ddd0d89e$export$64af334f494c2f47() {
    return $1d04edb3ddd0d89e$var$i18nInstance;
}


function $acffcb171536f8e9$var$hasChildren(node, checkLength) {
    if (!node) return false;
    const base = node.props ? node.props.children : node.children;
    if (checkLength) return base.length > 0;
    return !!base;
}
function $acffcb171536f8e9$var$getChildren(node) {
    if (!node) return [];
    const children = node.props ? node.props.children : node.children;
    return node.props && node.props.i18nIsDynamicList ? $acffcb171536f8e9$var$getAsArray(children) : children;
}
function $acffcb171536f8e9$var$hasValidReactChildren(children) {
    if (Object.prototype.toString.call(children) !== "[object Array]") return false;
    return children.every((child)=>(0, $acw62.isValidElement)(child));
}
function $acffcb171536f8e9$var$getAsArray(data) {
    return Array.isArray(data) ? data : [
        data
    ];
}
function $acffcb171536f8e9$var$mergeProps(source, target) {
    const newTarget = {
        ...target
    };
    newTarget.props = Object.assign(source.props, target.props);
    return newTarget;
}
function $acffcb171536f8e9$export$4f7a36dd898f1267(children, i18nOptions) {
    if (!children) return "";
    let stringNode = "";
    const childrenArray = $acffcb171536f8e9$var$getAsArray(children);
    const keepArray = i18nOptions.transSupportBasicHtmlNodes && i18nOptions.transKeepBasicHtmlNodesFor ? i18nOptions.transKeepBasicHtmlNodesFor : [];
    childrenArray.forEach((child, childIndex)=>{
        if (typeof child === "string") stringNode += `${child}`;
        else if ((0, $acw62.isValidElement)(child)) {
            const childPropsCount = Object.keys(child.props).length;
            const shouldKeepChild = keepArray.indexOf(child.type) > -1;
            const childChildren = child.props.children;
            if (!childChildren && shouldKeepChild && childPropsCount === 0) stringNode += `<${child.type}/>`;
            else if (!childChildren && (!shouldKeepChild || childPropsCount !== 0)) stringNode += `<${childIndex}></${childIndex}>`;
            else if (child.props.i18nIsDynamicList) stringNode += `<${childIndex}></${childIndex}>`;
            else if (shouldKeepChild && childPropsCount === 1 && typeof childChildren === "string") stringNode += `<${child.type}>${childChildren}</${child.type}>`;
            else {
                const content = $acffcb171536f8e9$export$4f7a36dd898f1267(childChildren, i18nOptions);
                stringNode += `<${childIndex}>${content}</${childIndex}>`;
            }
        } else if (child === null) (0, $cfb6e0167e0b350d$export$c106dd0671a0fc2d)(`Trans: the passed in value is invalid - seems you passed in a null child.`);
        else if (typeof child === "object") {
            const { format: format, ...clone } = child;
            const keys = Object.keys(clone);
            if (keys.length === 1) {
                const value = format ? `${keys[0]}, ${format}` : keys[0];
                stringNode += `{{${value}}}`;
            } else (0, $cfb6e0167e0b350d$export$c106dd0671a0fc2d)(`react-i18next: the passed in object contained more than one variable - the object should look like {{ value, format }} where format is optional.`, child);
        } else (0, $cfb6e0167e0b350d$export$c106dd0671a0fc2d)(`Trans: the passed in value is invalid - seems you passed in a variable like {number} - please pass in variables for interpolation as full objects like {{number}}.`, child);
    });
    return stringNode;
}
function $acffcb171536f8e9$var$renderNodes(children, targetString, i18n, i18nOptions, combinedTOpts, shouldUnescape) {
    if (targetString === "") return [];
    const keepArray = i18nOptions.transKeepBasicHtmlNodesFor || [];
    const emptyChildrenButNeedsHandling = targetString && new RegExp(keepArray.map((keep)=>`<${keep}`).join("|")).test(targetString);
    if (!children && !emptyChildrenButNeedsHandling && !shouldUnescape) return [
        targetString
    ];
    const data = {};
    function getData(childs) {
        const childrenArray = $acffcb171536f8e9$var$getAsArray(childs);
        childrenArray.forEach((child)=>{
            if (typeof child === "string") return;
            if ($acffcb171536f8e9$var$hasChildren(child)) getData($acffcb171536f8e9$var$getChildren(child));
            else if (typeof child === "object" && !(0, $acw62.isValidElement)(child)) Object.assign(data, child);
        });
    }
    getData(children);
    const ast = (0, $69084eaa2e6a0d50$export$2e2bcd8739ae039).parse(`<0>${targetString}</0>`);
    const opts = {
        ...data,
        ...combinedTOpts
    };
    function renderInner(child, node, rootReactNode) {
        const childs = $acffcb171536f8e9$var$getChildren(child);
        const mappedChildren = mapAST(childs, node.children, rootReactNode);
        return $acffcb171536f8e9$var$hasValidReactChildren(childs) && mappedChildren.length === 0 || child.props && child.props.i18nIsDynamicList ? childs : mappedChildren;
    }
    function pushTranslatedJSX(child, inner, mem, i, isVoid) {
        if (child.dummy) {
            child.children = inner;
            mem.push((0, $acw62.cloneElement)(child, {
                key: i
            }, isVoid ? undefined : inner));
        } else mem.push(...(0, $acw62.Children).map([
            child
        ], (c)=>{
            const props = {
                ...c.props
            };
            delete props.i18nIsDynamicList;
            return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(c.type, (0, (/*@__PURE__*/$parcel$interopDefault($27ab08c24269de64$exports)))({}, props, {
                key: i,
                ref: c.ref
            }, isVoid ? {} : {
                children: inner
            }));
        }));
    }
    function mapAST(reactNode, astNode, rootReactNode) {
        const reactNodes = $acffcb171536f8e9$var$getAsArray(reactNode);
        const astNodes = $acffcb171536f8e9$var$getAsArray(astNode);
        return astNodes.reduce((mem, node, i)=>{
            const translationContent = node.children && node.children[0] && node.children[0].content && i18n.services.interpolator.interpolate(node.children[0].content, opts, i18n.language);
            if (node.type === "tag") {
                let tmp = reactNodes[parseInt(node.name, 10)];
                if (rootReactNode.length === 1 && !tmp) tmp = rootReactNode[0][node.name];
                if (!tmp) tmp = {};
                const child = Object.keys(node.attrs).length !== 0 ? $acffcb171536f8e9$var$mergeProps({
                    props: node.attrs
                }, tmp) : tmp;
                const isElement = (0, $acw62.isValidElement)(child);
                const isValidTranslationWithChildren = isElement && $acffcb171536f8e9$var$hasChildren(node, true) && !node.voidElement;
                const isEmptyTransWithHTML = emptyChildrenButNeedsHandling && typeof child === "object" && child.dummy && !isElement;
                const isKnownComponent = typeof children === "object" && children !== null && Object.hasOwnProperty.call(children, node.name);
                if (typeof child === "string") {
                    const value = i18n.services.interpolator.interpolate(child, opts, i18n.language);
                    mem.push(value);
                } else if ($acffcb171536f8e9$var$hasChildren(child) || isValidTranslationWithChildren) {
                    const inner = renderInner(child, node, rootReactNode);
                    pushTranslatedJSX(child, inner, mem, i);
                } else if (isEmptyTransWithHTML) {
                    const inner = mapAST(reactNodes, node.children, rootReactNode);
                    pushTranslatedJSX(child, inner, mem, i);
                } else if (Number.isNaN(parseFloat(node.name))) {
                    if (isKnownComponent) {
                        const inner = renderInner(child, node, rootReactNode);
                        pushTranslatedJSX(child, inner, mem, i, node.voidElement);
                    } else if (i18nOptions.transSupportBasicHtmlNodes && keepArray.indexOf(node.name) > -1) {
                        if (node.voidElement) mem.push((0, $acw62.createElement)(node.name, {
                            key: `${node.name}-${i}`
                        }));
                        else {
                            const inner = mapAST(reactNodes, node.children, rootReactNode);
                            mem.push((0, $acw62.createElement)(node.name, {
                                key: `${node.name}-${i}`
                            }, inner));
                        }
                    } else if (node.voidElement) mem.push(`<${node.name} />`);
                    else {
                        const inner = mapAST(reactNodes, node.children, rootReactNode);
                        mem.push(`<${node.name}>${inner}</${node.name}>`);
                    }
                } else if (typeof child === "object" && !isElement) {
                    const content = node.children[0] ? translationContent : null;
                    if (content) mem.push(content);
                } else pushTranslatedJSX(child, translationContent, mem, i, node.children.length !== 1 || !translationContent);
            } else if (node.type === "text") {
                const wrapTextNodes = i18nOptions.transWrapTextNodes;
                const content = shouldUnescape ? i18nOptions.unescape(i18n.services.interpolator.interpolate(node.content, opts, i18n.language)) : i18n.services.interpolator.interpolate(node.content, opts, i18n.language);
                if (wrapTextNodes) mem.push((0, $acw62.createElement)(wrapTextNodes, {
                    key: `${node.name}-${i}`
                }, content));
                else mem.push(content);
            }
            return mem;
        }, []);
    }
    const result = mapAST([
        {
            dummy: true,
            children: children || []
        }
    ], ast, $acffcb171536f8e9$var$getAsArray(children || []));
    return $acffcb171536f8e9$var$getChildren(result[0]);
}
function $acffcb171536f8e9$export$8d6a9236f2e3f2ce(_ref) {
    let { children: children, count: count, parent: parent, i18nKey: i18nKey, context: context, tOptions: tOptions = {}, values: values, defaults: defaults, components: components, ns: ns, i18n: i18nFromProps, t: tFromProps, shouldUnescape: shouldUnescape, ...additionalProps } = _ref;
    const i18n = i18nFromProps || (0, $1d04edb3ddd0d89e$export$64af334f494c2f47)();
    if (!i18n) {
        (0, $cfb6e0167e0b350d$export$5b28268982f175ba)("You will need to pass in an i18next instance by using i18nextReactModule");
        return children;
    }
    const t = tFromProps || i18n.t.bind(i18n) || ((k)=>k);
    if (context) tOptions.context = context;
    const reactI18nextOptions = {
        ...(0, $4f75eea5b29ffc65$export$212bb2fc580a90a8)(),
        ...i18n.options && i18n.options.react
    };
    let namespaces = ns || t.ns || i18n.options && i18n.options.defaultNS;
    namespaces = typeof namespaces === "string" ? [
        namespaces
    ] : namespaces || [
        "translation"
    ];
    const nodeAsString = $acffcb171536f8e9$export$4f7a36dd898f1267(children, reactI18nextOptions);
    const defaultValue = defaults || nodeAsString || reactI18nextOptions.transEmptyNodeValue || i18nKey;
    const { hashTransKey: hashTransKey } = reactI18nextOptions;
    const key = i18nKey || (hashTransKey ? hashTransKey(nodeAsString || defaultValue) : nodeAsString || defaultValue);
    if (i18n.options && i18n.options.interpolation && i18n.options.interpolation.defaultVariables) values = values && Object.keys(values).length > 0 ? {
        ...values,
        ...i18n.options.interpolation.defaultVariables
    } : {
        ...i18n.options.interpolation.defaultVariables
    };
    const interpolationOverride = values ? tOptions.interpolation : {
        interpolation: {
            ...tOptions.interpolation,
            prefix: "#$?",
            suffix: "?$#"
        }
    };
    const combinedTOpts = {
        ...tOptions,
        count: count,
        ...values,
        ...interpolationOverride,
        defaultValue: defaultValue,
        ns: namespaces
    };
    const translation = key ? t(key, combinedTOpts) : defaultValue;
    if (components) Object.keys(components).forEach((c)=>{
        const comp = components[c];
        if (typeof comp.type === "function" || !comp.props || !comp.props.children || translation.indexOf(`${c}/>`) < 0 && translation.indexOf(`${c} />`) < 0) return;
        function Componentized() {
            return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, comp);
        }
        components[c] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(Componentized, null);
    });
    const content = $acffcb171536f8e9$var$renderNodes(components || children, translation, i18n, reactI18nextOptions, combinedTOpts, shouldUnescape);
    const useAsParent = parent !== undefined ? parent : reactI18nextOptions.defaultTransParent;
    return useAsParent ? (0, $acw62.createElement)(useAsParent, additionalProps, content) : content;
}



var $acw62 = parcelRequire("acw62");




const $26bfda595e5aa141$export$ae7e14d40d89f296 = {
    type: "3rdParty",
    init (instance) {
        (0, $4f75eea5b29ffc65$export$2e2366488d12e20d)(instance.options.react);
        (0, $1d04edb3ddd0d89e$export$a039134f2fc7e0)(instance);
    }
};


const $0636c84fe4549f1f$export$5603ab5ced17ce64 = (0, $acw62.createContext)();
class $0636c84fe4549f1f$export$ea171b67e3820290 {
    constructor(){
        this.usedNamespaces = {};
    }
    addUsedNamespaces(namespaces) {
        namespaces.forEach((ns)=>{
            if (!this.usedNamespaces[ns]) this.usedNamespaces[ns] = true;
        });
    }
    getUsedNamespaces() {
        return Object.keys(this.usedNamespaces);
    }
}
function $0636c84fe4549f1f$export$30ff0342ccf735a(ForComponent) {
    return (ctx)=>new Promise((resolve)=>{
            const i18nInitialProps = $0636c84fe4549f1f$export$704200e5d0b9e8f();
            if (ForComponent.getInitialProps) ForComponent.getInitialProps(ctx).then((componentsInitialProps)=>{
                resolve({
                    ...componentsInitialProps,
                    ...i18nInitialProps
                });
            });
            else resolve(i18nInitialProps);
        });
}
function $0636c84fe4549f1f$export$704200e5d0b9e8f() {
    const i18n = (0, $1d04edb3ddd0d89e$export$64af334f494c2f47)();
    const namespaces = i18n.reportNamespaces ? i18n.reportNamespaces.getUsedNamespaces() : [];
    const ret = {};
    const initialI18nStore = {};
    i18n.languages.forEach((l)=>{
        initialI18nStore[l] = {};
        namespaces.forEach((ns)=>{
            initialI18nStore[l][ns] = i18n.getResourceBundle(l, ns) || {};
        });
    });
    ret.initialI18nStore = initialI18nStore;
    ret.initialLanguage = i18n.language;
    return ret;
}


function $e04d9533328ca578$export$8d6a9236f2e3f2ce(_ref) {
    let { children: children, count: count, parent: parent, i18nKey: i18nKey, context: context, tOptions: tOptions = {}, values: values, defaults: defaults, components: components, ns: ns, i18n: i18nFromProps, t: tFromProps, shouldUnescape: shouldUnescape, ...additionalProps } = _ref;
    const { i18n: i18nFromContext, defaultNS: defaultNSFromContext } = (0, $acw62.useContext)((0, $0636c84fe4549f1f$export$5603ab5ced17ce64)) || {};
    const i18n = i18nFromProps || i18nFromContext || (0, $1d04edb3ddd0d89e$export$64af334f494c2f47)();
    const t = tFromProps || i18n && i18n.t.bind(i18n);
    return (0, $acffcb171536f8e9$export$8d6a9236f2e3f2ce)({
        children: children,
        count: count,
        parent: parent,
        i18nKey: i18nKey,
        context: context,
        tOptions: tOptions,
        values: values,
        defaults: defaults,
        components: components,
        ns: ns || t && t.ns || defaultNSFromContext || i18n && i18n.options && i18n.options.defaultNS,
        i18n: i18n,
        t: tFromProps,
        shouldUnescape: shouldUnescape,
        ...additionalProps
    });
}




var $acw62 = parcelRequire("acw62");


const $3765cebd031b52c0$var$usePrevious = (value, ignore)=>{
    const ref = (0, $acw62.useRef)();
    (0, $acw62.useEffect)(()=>{
        ref.current = ignore ? ref.current : value;
    }, [
        value,
        ignore
    ]);
    return ref.current;
};
function $3765cebd031b52c0$export$9fc83ad70ead8663(ns) {
    let props = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    const { i18n: i18nFromProps } = props;
    const { i18n: i18nFromContext, defaultNS: defaultNSFromContext } = (0, $acw62.useContext)((0, $0636c84fe4549f1f$export$5603ab5ced17ce64)) || {};
    const i18n = i18nFromProps || i18nFromContext || (0, $1d04edb3ddd0d89e$export$64af334f494c2f47)();
    if (i18n && !i18n.reportNamespaces) i18n.reportNamespaces = new (0, $0636c84fe4549f1f$export$ea171b67e3820290)();
    if (!i18n) {
        (0, $cfb6e0167e0b350d$export$5b28268982f175ba)("You will need to pass in an i18next instance by using initReactI18next");
        const notReadyT = (k, optsOrDefaultValue)=>{
            if (typeof optsOrDefaultValue === "string") return optsOrDefaultValue;
            if (optsOrDefaultValue && typeof optsOrDefaultValue === "object" && typeof optsOrDefaultValue.defaultValue === "string") return optsOrDefaultValue.defaultValue;
            return Array.isArray(k) ? k[k.length - 1] : k;
        };
        const retNotReady = [
            notReadyT,
            {},
            false
        ];
        retNotReady.t = notReadyT;
        retNotReady.i18n = {};
        retNotReady.ready = false;
        return retNotReady;
    }
    if (i18n.options.react && i18n.options.react.wait !== undefined) (0, $cfb6e0167e0b350d$export$5b28268982f175ba)("It seems you are still using the old wait option, you may migrate to the new useSuspense behaviour.");
    const i18nOptions = {
        ...(0, $4f75eea5b29ffc65$export$212bb2fc580a90a8)(),
        ...i18n.options.react,
        ...props
    };
    const { useSuspense: useSuspense, keyPrefix: keyPrefix } = i18nOptions;
    let namespaces = ns || defaultNSFromContext || i18n.options && i18n.options.defaultNS;
    namespaces = typeof namespaces === "string" ? [
        namespaces
    ] : namespaces || [
        "translation"
    ];
    if (i18n.reportNamespaces.addUsedNamespaces) i18n.reportNamespaces.addUsedNamespaces(namespaces);
    const ready = (i18n.isInitialized || i18n.initializedStoreOnce) && namespaces.every((n)=>(0, $cfb6e0167e0b350d$export$93d9ee97c1ad3f31)(n, i18n, i18nOptions));
    function getT() {
        return i18n.getFixedT(props.lng || null, i18nOptions.nsMode === "fallback" ? namespaces : namespaces[0], keyPrefix);
    }
    const [t, setT] = (0, $acw62.useState)(getT);
    let joinedNS = namespaces.join();
    if (props.lng) joinedNS = `${props.lng}${joinedNS}`;
    const previousJoinedNS = $3765cebd031b52c0$var$usePrevious(joinedNS);
    const isMounted = (0, $acw62.useRef)(true);
    (0, $acw62.useEffect)(()=>{
        const { bindI18n: bindI18n, bindI18nStore: bindI18nStore } = i18nOptions;
        isMounted.current = true;
        if (!ready && !useSuspense) {
            if (props.lng) (0, $cfb6e0167e0b350d$export$8cd7e7a54fa865bc)(i18n, props.lng, namespaces, ()=>{
                if (isMounted.current) setT(getT);
            });
            else (0, $cfb6e0167e0b350d$export$83be934b53fff43b)(i18n, namespaces, ()=>{
                if (isMounted.current) setT(getT);
            });
        }
        if (ready && previousJoinedNS && previousJoinedNS !== joinedNS && isMounted.current) setT(getT);
        function boundReset() {
            if (isMounted.current) setT(getT);
        }
        if (bindI18n && i18n) i18n.on(bindI18n, boundReset);
        if (bindI18nStore && i18n) i18n.store.on(bindI18nStore, boundReset);
        return ()=>{
            isMounted.current = false;
            if (bindI18n && i18n) bindI18n.split(" ").forEach((e)=>i18n.off(e, boundReset));
            if (bindI18nStore && i18n) bindI18nStore.split(" ").forEach((e)=>i18n.store.off(e, boundReset));
        };
    }, [
        i18n,
        joinedNS
    ]);
    const isInitial = (0, $acw62.useRef)(true);
    (0, $acw62.useEffect)(()=>{
        if (isMounted.current && !isInitial.current) setT(getT);
        isInitial.current = false;
    }, [
        i18n,
        keyPrefix
    ]);
    const ret = [
        t,
        i18n,
        ready
    ];
    ret.t = t;
    ret.i18n = i18n;
    ret.ready = ready;
    if (ready) return ret;
    if (!ready && !useSuspense) return ret;
    throw new Promise((resolve)=>{
        if (props.lng) (0, $cfb6e0167e0b350d$export$8cd7e7a54fa865bc)(i18n, props.lng, namespaces, ()=>resolve());
        else (0, $cfb6e0167e0b350d$export$83be934b53fff43b)(i18n, namespaces, ()=>resolve());
    });
}



var $acw62 = parcelRequire("acw62");


function $d9bd4545752f9667$export$2dcb0053efd21124(ns) {
    let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    return function Extend(WrappedComponent) {
        function I18nextWithTranslation(_ref) {
            let { forwardedRef: forwardedRef, ...rest } = _ref;
            const [t, i18n, ready] = (0, $3765cebd031b52c0$export$9fc83ad70ead8663)(ns, {
                ...rest,
                keyPrefix: options.keyPrefix
            });
            const passDownProps = {
                ...rest,
                t: t,
                i18n: i18n,
                tReady: ready
            };
            if (options.withRef && forwardedRef) passDownProps.ref = forwardedRef;
            else if (!options.withRef && forwardedRef) passDownProps.forwardedRef = forwardedRef;
            return (0, $acw62.createElement)(WrappedComponent, passDownProps);
        }
        I18nextWithTranslation.displayName = `withI18nextTranslation(${(0, $cfb6e0167e0b350d$export$be63e0664592e141)(WrappedComponent)})`;
        I18nextWithTranslation.WrappedComponent = WrappedComponent;
        const forwardRef = (props, ref)=>(0, $acw62.createElement)(I18nextWithTranslation, Object.assign({}, props, {
                forwardedRef: ref
            }));
        return options.withRef ? (0, $acw62.forwardRef)(forwardRef) : I18nextWithTranslation;
    };
}



function $868685a400877801$export$b63289fbda65eed1(props) {
    const { ns: ns, children: children, ...options } = props;
    const [t, i18n, ready] = (0, $3765cebd031b52c0$export$9fc83ad70ead8663)(ns, options);
    return children(t, {
        i18n: i18n,
        lng: i18n.language
    }, ready);
}



var $acw62 = parcelRequire("acw62");

function $c313608318d394ab$export$1325e8699caa160f(_ref) {
    let { i18n: i18n, defaultNS: defaultNS, children: children } = _ref;
    const value = (0, $acw62.useMemo)(()=>({
            i18n: i18n,
            defaultNS: defaultNS
        }), [
        i18n,
        defaultNS
    ]);
    return (0, $acw62.createElement)((0, $0636c84fe4549f1f$export$5603ab5ced17ce64).Provider, {
        value: value
    }, children);
}



var $acw62 = parcelRequire("acw62");

var $acw62 = parcelRequire("acw62");

function $d97c91d803f78bcc$export$3526fb65ade8d8b7(initialI18nStore, initialLanguage) {
    let props = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    const { i18n: i18nFromProps } = props;
    const { i18n: i18nFromContext } = (0, $acw62.useContext)((0, $0636c84fe4549f1f$export$5603ab5ced17ce64)) || {};
    const i18n = i18nFromProps || i18nFromContext || (0, $1d04edb3ddd0d89e$export$64af334f494c2f47)();
    if (i18n.options && i18n.options.isClone) return;
    if (initialI18nStore && !i18n.initializedStoreOnce) {
        i18n.services.resourceStore.data = initialI18nStore;
        i18n.options.ns = Object.values(initialI18nStore).reduce((mem, lngResources)=>{
            Object.keys(lngResources).forEach((ns)=>{
                if (mem.indexOf(ns) < 0) mem.push(ns);
            });
            return mem;
        }, i18n.options.ns);
        i18n.initializedStoreOnce = true;
        i18n.isInitialized = true;
    }
    if (initialLanguage && !i18n.initializedLanguageOnce) {
        i18n.changeLanguage(initialLanguage);
        i18n.initializedLanguageOnce = true;
    }
}




function $afd5c8e3ef499392$export$80dfa519af1c8605() {
    return function Extend(WrappedComponent) {
        function I18nextWithSSR(_ref) {
            let { initialI18nStore: initialI18nStore, initialLanguage: initialLanguage, ...rest } = _ref;
            (0, $d97c91d803f78bcc$export$3526fb65ade8d8b7)(initialI18nStore, initialLanguage);
            return (0, $acw62.createElement)(WrappedComponent, {
                ...rest
            });
        }
        I18nextWithSSR.getInitialProps = (0, $0636c84fe4549f1f$export$30ff0342ccf735a)(WrappedComponent);
        I18nextWithSSR.displayName = `withI18nextSSR(${(0, $cfb6e0167e0b350d$export$be63e0664592e141)(WrappedComponent)})`;
        I18nextWithSSR.WrappedComponent = WrappedComponent;
        return I18nextWithSSR;
    };
}







const $2843511fe0fbbf82$export$324d90190a8b822a = ()=>"";
const $2843511fe0fbbf82$export$2da9be4cfdb689b1 = ()=>"";
const $2843511fe0fbbf82$export$98e628dec113755e = ()=>"";
const $2843511fe0fbbf82$export$2e6c959c16ff56b8 = ()=>"";
const $2843511fe0fbbf82$export$4e35d5c922a95490 = ()=>"";
const $2843511fe0fbbf82$export$720a3b9db04b7a0f = ()=>"";



var $acw62 = parcelRequire("acw62");
function $15e6d94060e5d8b6$var$r(e) {
    var t, f, n = "";
    if ("string" == typeof e || "number" == typeof e) n += e;
    else if ("object" == typeof e) {
        if (Array.isArray(e)) for(t = 0; t < e.length; t++)e[t] && (f = $15e6d94060e5d8b6$var$r(e[t])) && (n && (n += " "), n += f);
        else for(t in e)e[t] && (n && (n += " "), n += t);
    }
    return n;
}
function $15e6d94060e5d8b6$export$4f5d2d50c9deca37() {
    for(var e, t, f = 0, n = ""; f < arguments.length;)(e = arguments[f++]) && (t = $15e6d94060e5d8b6$var$r(e)) && (n && (n += " "), n += t);
    return n;
}
var $15e6d94060e5d8b6$export$2e2bcd8739ae039 = $15e6d94060e5d8b6$export$4f5d2d50c9deca37;



var $1u0KT = parcelRequire("1u0KT");
function $60f27fc97e29822a$var$_extends() {
    $60f27fc97e29822a$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $60f27fc97e29822a$var$_extends.apply(this, arguments);
}
function $60f27fc97e29822a$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $60f27fc97e29822a$var$isNum(v) {
    return typeof v === "number" && !isNaN(v);
}
function $60f27fc97e29822a$var$isBool(v) {
    return typeof v === "boolean";
}
function $60f27fc97e29822a$var$isStr(v) {
    return typeof v === "string";
}
function $60f27fc97e29822a$var$isFn(v) {
    return typeof v === "function";
}
function $60f27fc97e29822a$var$parseClassName(v) {
    return $60f27fc97e29822a$var$isStr(v) || $60f27fc97e29822a$var$isFn(v) ? v : null;
}
function $60f27fc97e29822a$var$isToastIdValid(toastId) {
    return toastId === 0 || toastId;
}
function $60f27fc97e29822a$var$getAutoCloseDelay(toastAutoClose, containerAutoClose) {
    return toastAutoClose === false || $60f27fc97e29822a$var$isNum(toastAutoClose) && toastAutoClose > 0 ? toastAutoClose : containerAutoClose;
}
var $60f27fc97e29822a$var$canUseDom = !!(typeof window !== "undefined" && window.document && window.document.createElement);
function $60f27fc97e29822a$var$canBeRendered(content) {
    return (0, $acw62.isValidElement)(content) || $60f27fc97e29822a$var$isStr(content) || $60f27fc97e29822a$var$isFn(content) || $60f27fc97e29822a$var$isNum(content);
}
var $60f27fc97e29822a$var$POSITION = {
    TOP_LEFT: "top-left",
    TOP_RIGHT: "top-right",
    TOP_CENTER: "top-center",
    BOTTOM_LEFT: "bottom-left",
    BOTTOM_RIGHT: "bottom-right",
    BOTTOM_CENTER: "bottom-center"
};
var $60f27fc97e29822a$var$TYPE = {
    INFO: "info",
    SUCCESS: "success",
    WARNING: "warning",
    ERROR: "error",
    DEFAULT: "default"
};
/**
 * Used to collapse toast after exit animation
 */ function $60f27fc97e29822a$export$184cca501f1aed7f(node, done, duration) {
    if (duration === void 0) duration = 300;
    var scrollHeight = node.scrollHeight, style = node.style;
    requestAnimationFrame(function() {
        style.minHeight = "initial";
        style.height = scrollHeight + "px";
        style.transition = "all " + duration + "ms";
        requestAnimationFrame(function() {
            style.height = "0";
            style.padding = "0";
            style.margin = "0";
            setTimeout(done, duration);
        });
    });
}
/**
 * Css animation that just work.
 * You could use animate.css for instance
 *
 *
 * ```
 * cssTransition({
 *   enter: "animate__animated animate__bounceIn",
 *   exit: "animate__animated animate__bounceOut"
 * })
 * ```
 *
 */ function $60f27fc97e29822a$export$3ff7dc44d332d222(_ref) {
    var enter = _ref.enter, exit = _ref.exit, _ref$appendPosition = _ref.appendPosition, appendPosition = _ref$appendPosition === void 0 ? false : _ref$appendPosition, _ref$collapse = _ref.collapse, collapse = _ref$collapse === void 0 ? true : _ref$collapse, _ref$collapseDuration = _ref.collapseDuration, collapseDuration = _ref$collapseDuration === void 0 ? 300 : _ref$collapseDuration;
    return function ToastTransition(_ref2) {
        var children = _ref2.children, position = _ref2.position, preventExitTransition = _ref2.preventExitTransition, done = _ref2.done, nodeRef = _ref2.nodeRef, isIn = _ref2.isIn;
        var enterClassName = appendPosition ? enter + "--" + position : enter;
        var exitClassName = appendPosition ? exit + "--" + position : exit;
        var baseClassName = (0, $acw62.useRef)();
        var animationStep = (0, $acw62.useRef)(0);
        (0, $acw62.useLayoutEffect)(function() {
            onEnter();
        }, []);
        (0, $acw62.useEffect)(function() {
            if (!isIn) preventExitTransition ? onExited() : onExit();
        }, [
            isIn
        ]);
        function onEnter() {
            var node = nodeRef.current;
            baseClassName.current = node.className;
            node.className += " " + enterClassName;
            node.addEventListener("animationend", onEntered);
            node.addEventListener("animationcancel", onEntered);
        }
        function onEntered(e) {
            if (e.target !== nodeRef.current) return;
            var node = nodeRef.current;
            node.dispatchEvent(new Event("d"));
            node.removeEventListener("animationend", onEntered);
            node.removeEventListener("animationcancel", onEntered);
            if (animationStep.current === 0) node.className = baseClassName.current;
        }
        function onExit() {
            animationStep.current = 1 /* Exit */ ;
            var node = nodeRef.current;
            node.className += " " + exitClassName;
            node.addEventListener("animationend", onExited);
        }
        function onExited() {
            var node = nodeRef.current;
            node.removeEventListener("animationend", onExited);
            collapse ? $60f27fc97e29822a$export$184cca501f1aed7f(node, done, collapseDuration) : done();
        }
        return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, children);
    };
}
var $60f27fc97e29822a$var$eventManager = {
    list: /*#__PURE__*/ new Map(),
    emitQueue: /*#__PURE__*/ new Map(),
    on: function on(event, callback) {
        this.list.has(event) || this.list.set(event, []);
        this.list.get(event).push(callback);
        return this;
    },
    off: function off(event, callback) {
        if (callback) {
            var cb = this.list.get(event).filter(function(cb) {
                return cb !== callback;
            });
            this.list.set(event, cb);
            return this;
        }
        this.list["delete"](event);
        return this;
    },
    cancelEmit: function cancelEmit(event) {
        var timers = this.emitQueue.get(event);
        if (timers) {
            timers.forEach(clearTimeout);
            this.emitQueue["delete"](event);
        }
        return this;
    },
    /**
   * Enqueue the event at the end of the call stack
   * Doing so let the user call toast as follow:
   * toast('1')
   * toast('2')
   * toast('3')
   * Without setTimemout the code above will not work
   */ emit: function emit(event) {
        var _this = this;
        for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)args[_key - 1] = arguments[_key];
        this.list.has(event) && this.list.get(event).forEach(function(callback) {
            var timer = setTimeout(function() {
                // @ts-ignore
                callback.apply(void 0, args);
            }, 0);
            _this.emitQueue.has(event) || _this.emitQueue.set(event, []);
            _this.emitQueue.get(event).push(timer);
        });
    }
};
var $60f27fc97e29822a$var$_excluded = [
    "delay",
    "staleId"
];
function $60f27fc97e29822a$export$b262e13ca2dd2381(props) {
    var _useReducer = (0, $acw62.useReducer)(function(x) {
        return x + 1;
    }, 0), forceUpdate = _useReducer[1];
    var _useState = (0, $acw62.useState)([]), toastIds = _useState[0], setToastIds = _useState[1];
    var containerRef = (0, $acw62.useRef)(null);
    var toastToRender = (0, $acw62.useRef)(new Map()).current;
    var isToastActive = function isToastActive(id) {
        return toastIds.indexOf(id) !== -1;
    };
    var instance = (0, $acw62.useRef)({
        toastKey: 1,
        displayedToast: 0,
        count: 0,
        queue: [],
        props: props,
        containerId: null,
        isToastActive: isToastActive,
        getToast: function getToast(id) {
            return toastToRender.get(id);
        }
    }).current;
    (0, $acw62.useEffect)(function() {
        instance.containerId = props.containerId;
        $60f27fc97e29822a$var$eventManager.cancelEmit(3).on(0, buildToast).on(1, function(toastId) {
            return containerRef.current && removeToast(toastId);
        }).on(5, clearWaitingQueue).emit(2, instance);
        return function() {
            return $60f27fc97e29822a$var$eventManager.emit(3, instance);
        };
    }, []);
    (0, $acw62.useEffect)(function() {
        instance.isToastActive = isToastActive;
        instance.displayedToast = toastIds.length;
        $60f27fc97e29822a$var$eventManager.emit(4, toastIds.length, props.containerId);
    }, [
        toastIds
    ]);
    (0, $acw62.useEffect)(function() {
        instance.props = props;
    });
    function clearWaitingQueue(_ref) {
        var containerId = _ref.containerId;
        var limit = instance.props.limit;
        if (limit && (!containerId || instance.containerId === containerId)) {
            instance.count -= instance.queue.length;
            instance.queue = [];
        }
    }
    function removeToast(toastId) {
        setToastIds(function(state) {
            return $60f27fc97e29822a$var$isToastIdValid(toastId) ? state.filter(function(id) {
                return id !== toastId;
            }) : [];
        });
    }
    function dequeueToast() {
        var _instance$queue$shift = instance.queue.shift(), toastContent = _instance$queue$shift.toastContent, toastProps = _instance$queue$shift.toastProps, staleId = _instance$queue$shift.staleId;
        appendToast(toastContent, toastProps, staleId);
    }
    /**
   * check if a container is attached to the dom
   * check for multi-container, build only if associated
   * check for duplicate toastId if no update
   */ function isNotValid(options) {
        return !containerRef.current || instance.props.enableMultiContainer && options.containerId !== instance.props.containerId || toastToRender.has(options.toastId) && options.updateId == null;
    } // this function and all the function called inside needs to rely on refs
    function buildToast(content, _ref2) {
        var delay = _ref2.delay, staleId = _ref2.staleId, options = $60f27fc97e29822a$var$_objectWithoutPropertiesLoose(_ref2, $60f27fc97e29822a$var$_excluded);
        if (!$60f27fc97e29822a$var$canBeRendered(content) || isNotValid(options)) return;
        var toastId = options.toastId, updateId = options.updateId, data = options.data;
        var props = instance.props;
        var closeToast = function closeToast() {
            return removeToast(toastId);
        };
        var isNotAnUpdate = updateId == null;
        if (isNotAnUpdate) instance.count++;
        var toastProps = {
            toastId: toastId,
            updateId: updateId,
            isLoading: options.isLoading,
            theme: options.theme || props.theme,
            icon: options.icon != null ? options.icon : props.icon,
            isIn: false,
            key: options.key || instance.toastKey++,
            type: options.type,
            closeToast: closeToast,
            closeButton: options.closeButton,
            rtl: props.rtl,
            position: options.position || props.position,
            transition: options.transition || props.transition,
            className: $60f27fc97e29822a$var$parseClassName(options.className || props.toastClassName),
            bodyClassName: $60f27fc97e29822a$var$parseClassName(options.bodyClassName || props.bodyClassName),
            style: options.style || props.toastStyle,
            bodyStyle: options.bodyStyle || props.bodyStyle,
            onClick: options.onClick || props.onClick,
            pauseOnHover: $60f27fc97e29822a$var$isBool(options.pauseOnHover) ? options.pauseOnHover : props.pauseOnHover,
            pauseOnFocusLoss: $60f27fc97e29822a$var$isBool(options.pauseOnFocusLoss) ? options.pauseOnFocusLoss : props.pauseOnFocusLoss,
            draggable: $60f27fc97e29822a$var$isBool(options.draggable) ? options.draggable : props.draggable,
            draggablePercent: options.draggablePercent || props.draggablePercent,
            draggableDirection: options.draggableDirection || props.draggableDirection,
            closeOnClick: $60f27fc97e29822a$var$isBool(options.closeOnClick) ? options.closeOnClick : props.closeOnClick,
            progressClassName: $60f27fc97e29822a$var$parseClassName(options.progressClassName || props.progressClassName),
            progressStyle: options.progressStyle || props.progressStyle,
            autoClose: options.isLoading ? false : $60f27fc97e29822a$var$getAutoCloseDelay(options.autoClose, props.autoClose),
            hideProgressBar: $60f27fc97e29822a$var$isBool(options.hideProgressBar) ? options.hideProgressBar : props.hideProgressBar,
            progress: options.progress,
            role: options.role || props.role,
            deleteToast: function deleteToast() {
                toastToRender["delete"](toastId);
                var queueLen = instance.queue.length;
                instance.count = $60f27fc97e29822a$var$isToastIdValid(toastId) ? instance.count - 1 : instance.count - instance.displayedToast;
                if (instance.count < 0) instance.count = 0;
                if (queueLen > 0) {
                    var freeSlot = $60f27fc97e29822a$var$isToastIdValid(toastId) ? 1 : instance.props.limit;
                    if (queueLen === 1 || freeSlot === 1) {
                        instance.displayedToast++;
                        dequeueToast();
                    } else {
                        var toDequeue = freeSlot > queueLen ? queueLen : freeSlot;
                        instance.displayedToast = toDequeue;
                        for(var i = 0; i < toDequeue; i++)dequeueToast();
                    }
                } else forceUpdate();
            }
        };
        if ($60f27fc97e29822a$var$isFn(options.onOpen)) toastProps.onOpen = options.onOpen;
        if ($60f27fc97e29822a$var$isFn(options.onClose)) toastProps.onClose = options.onClose;
        toastProps.closeButton = props.closeButton;
        if (options.closeButton === false || $60f27fc97e29822a$var$canBeRendered(options.closeButton)) toastProps.closeButton = options.closeButton;
        else if (options.closeButton === true) toastProps.closeButton = $60f27fc97e29822a$var$canBeRendered(props.closeButton) ? props.closeButton : true;
        var toastContent = content;
        if ((0, $acw62.isValidElement)(content) && !$60f27fc97e29822a$var$isStr(content.type)) toastContent = (0, $acw62.cloneElement)(content, {
            closeToast: closeToast,
            toastProps: toastProps,
            data: data
        });
        else if ($60f27fc97e29822a$var$isFn(content)) toastContent = content({
            closeToast: closeToast,
            toastProps: toastProps,
            data: data
        });
         // not handling limit + delay by design. Waiting for user feedback first
        if (props.limit && props.limit > 0 && instance.count > props.limit && isNotAnUpdate) instance.queue.push({
            toastContent: toastContent,
            toastProps: toastProps,
            staleId: staleId
        });
        else if ($60f27fc97e29822a$var$isNum(delay) && delay > 0) setTimeout(function() {
            appendToast(toastContent, toastProps, staleId);
        }, delay);
        else appendToast(toastContent, toastProps, staleId);
    }
    function appendToast(content, toastProps, staleId) {
        var toastId = toastProps.toastId;
        if (staleId) toastToRender["delete"](staleId);
        toastToRender.set(toastId, {
            content: content,
            props: toastProps
        });
        setToastIds(function(state) {
            return [].concat(state, [
                toastId
            ]).filter(function(id) {
                return id !== staleId;
            });
        });
    }
    function getToastToRender(cb) {
        var toRender = new Map();
        var collection = Array.from(toastToRender.values());
        if (props.newestOnTop) collection.reverse();
        collection.forEach(function(toast) {
            var position = toast.props.position;
            toRender.has(position) || toRender.set(position, []);
            toRender.get(position).push(toast);
        });
        return Array.from(toRender, function(p) {
            return cb(p[0], p[1]);
        });
    }
    return {
        getToastToRender: getToastToRender,
        containerRef: containerRef,
        isToastActive: isToastActive
    };
}
function $60f27fc97e29822a$var$getX(e) {
    return e.targetTouches && e.targetTouches.length >= 1 ? e.targetTouches[0].clientX : e.clientX;
}
function $60f27fc97e29822a$var$getY(e) {
    return e.targetTouches && e.targetTouches.length >= 1 ? e.targetTouches[0].clientY : e.clientY;
}
function $60f27fc97e29822a$export$a407b657d3044108(props) {
    var _useState = (0, $acw62.useState)(false), isRunning = _useState[0], setIsRunning = _useState[1];
    var _useState2 = (0, $acw62.useState)(false), preventExitTransition = _useState2[0], setPreventExitTransition = _useState2[1];
    var toastRef = (0, $acw62.useRef)(null);
    var drag = (0, $acw62.useRef)({
        start: 0,
        x: 0,
        y: 0,
        delta: 0,
        removalDistance: 0,
        canCloseOnClick: true,
        canDrag: false,
        boundingRect: null,
        didMove: false
    }).current;
    var syncProps = (0, $acw62.useRef)(props);
    var autoClose = props.autoClose, pauseOnHover = props.pauseOnHover, closeToast = props.closeToast, onClick = props.onClick, closeOnClick = props.closeOnClick;
    (0, $acw62.useEffect)(function() {
        syncProps.current = props;
    });
    (0, $acw62.useEffect)(function() {
        if (toastRef.current) toastRef.current.addEventListener("d", playToast, {
            once: true
        });
        if ($60f27fc97e29822a$var$isFn(props.onOpen)) props.onOpen((0, $acw62.isValidElement)(props.children) && props.children.props);
        return function() {
            var props = syncProps.current;
            if ($60f27fc97e29822a$var$isFn(props.onClose)) props.onClose((0, $acw62.isValidElement)(props.children) && props.children.props);
        };
    }, []);
    (0, $acw62.useEffect)(function() {
        props.pauseOnFocusLoss && bindFocusEvents();
        return function() {
            props.pauseOnFocusLoss && unbindFocusEvents();
        };
    }, [
        props.pauseOnFocusLoss
    ]);
    function onDragStart(e) {
        if (props.draggable) {
            bindDragEvents();
            var toast = toastRef.current;
            drag.canCloseOnClick = true;
            drag.canDrag = true;
            drag.boundingRect = toast.getBoundingClientRect();
            toast.style.transition = "";
            drag.x = $60f27fc97e29822a$var$getX(e.nativeEvent);
            drag.y = $60f27fc97e29822a$var$getY(e.nativeEvent);
            if (props.draggableDirection === "x") {
                drag.start = drag.x;
                drag.removalDistance = toast.offsetWidth * (props.draggablePercent / 100);
            } else {
                drag.start = drag.y;
                drag.removalDistance = toast.offsetHeight * (props.draggablePercent === 80 ? props.draggablePercent * 1.5 : props.draggablePercent / 100);
            }
        }
    }
    function onDragTransitionEnd() {
        if (drag.boundingRect) {
            var _drag$boundingRect = drag.boundingRect, top = _drag$boundingRect.top, bottom = _drag$boundingRect.bottom, left = _drag$boundingRect.left, right = _drag$boundingRect.right;
            if (props.pauseOnHover && drag.x >= left && drag.x <= right && drag.y >= top && drag.y <= bottom) pauseToast();
            else playToast();
        }
    }
    function playToast() {
        setIsRunning(true);
    }
    function pauseToast() {
        setIsRunning(false);
    }
    function bindFocusEvents() {
        if (!document.hasFocus()) pauseToast();
        window.addEventListener("focus", playToast);
        window.addEventListener("blur", pauseToast);
    }
    function unbindFocusEvents() {
        window.removeEventListener("focus", playToast);
        window.removeEventListener("blur", pauseToast);
    }
    function bindDragEvents() {
        drag.didMove = false;
        document.addEventListener("mousemove", onDragMove);
        document.addEventListener("mouseup", onDragEnd);
        document.addEventListener("touchmove", onDragMove);
        document.addEventListener("touchend", onDragEnd);
    }
    function unbindDragEvents() {
        document.removeEventListener("mousemove", onDragMove);
        document.removeEventListener("mouseup", onDragEnd);
        document.removeEventListener("touchmove", onDragMove);
        document.removeEventListener("touchend", onDragEnd);
    }
    function onDragMove(e) {
        var toast = toastRef.current;
        if (drag.canDrag && toast) {
            drag.didMove = true;
            if (isRunning) pauseToast();
            drag.x = $60f27fc97e29822a$var$getX(e);
            drag.y = $60f27fc97e29822a$var$getY(e);
            if (props.draggableDirection === "x") drag.delta = drag.x - drag.start;
            else drag.delta = drag.y - drag.start;
             // prevent false positif during a toast click
            if (drag.start !== drag.x) drag.canCloseOnClick = false;
            toast.style.transform = "translate" + props.draggableDirection + "(" + drag.delta + "px)";
            toast.style.opacity = "" + (1 - Math.abs(drag.delta / drag.removalDistance));
        }
    }
    function onDragEnd() {
        unbindDragEvents();
        var toast = toastRef.current;
        if (drag.canDrag && drag.didMove && toast) {
            drag.canDrag = false;
            if (Math.abs(drag.delta) > drag.removalDistance) {
                setPreventExitTransition(true);
                props.closeToast();
                return;
            }
            toast.style.transition = "transform 0.2s, opacity 0.2s";
            toast.style.transform = "translate" + props.draggableDirection + "(0)";
            toast.style.opacity = "1";
        }
    }
    var eventHandlers = {
        onMouseDown: onDragStart,
        onTouchStart: onDragStart,
        onMouseUp: onDragTransitionEnd,
        onTouchEnd: onDragTransitionEnd
    };
    if (autoClose && pauseOnHover) {
        eventHandlers.onMouseEnter = pauseToast;
        eventHandlers.onMouseLeave = playToast;
    } // prevent toast from closing when user drags the toast
    if (closeOnClick) eventHandlers.onClick = function(e) {
        onClick && onClick(e);
        drag.canCloseOnClick && closeToast();
    };
    return {
        playToast: playToast,
        pauseToast: pauseToast,
        isRunning: isRunning,
        preventExitTransition: preventExitTransition,
        toastRef: toastRef,
        eventHandlers: eventHandlers
    };
}
function $60f27fc97e29822a$var$CloseButton(_ref) {
    var closeToast = _ref.closeToast, theme = _ref.theme, _ref$ariaLabel = _ref.ariaLabel, ariaLabel = _ref$ariaLabel === void 0 ? "close" : _ref$ariaLabel;
    return (0, $acw62.createElement)("button", {
        className: "Toastify__close-button Toastify__close-button--" + theme,
        type: "button",
        onClick: function onClick(e) {
            e.stopPropagation();
            closeToast(e);
        },
        "aria-label": ariaLabel
    }, (0, $acw62.createElement)("svg", {
        "aria-hidden": "true",
        viewBox: "0 0 14 16"
    }, (0, $acw62.createElement)("path", {
        fillRule: "evenodd",
        d: "M7.71 8.23l3.75 3.75-1.48 1.48-3.75-3.75-3.75 3.75L1 11.98l3.75-3.75L1 4.48 2.48 3l3.75 3.75L9.98 3l1.48 1.48-3.75 3.75z"
    })));
}
function $60f27fc97e29822a$var$ProgressBar(_ref) {
    var _cx, _animationEvent;
    var delay = _ref.delay, isRunning = _ref.isRunning, closeToast = _ref.closeToast, type = _ref.type, hide = _ref.hide, className = _ref.className, userStyle = _ref.style, controlledProgress = _ref.controlledProgress, progress = _ref.progress, rtl = _ref.rtl, isIn = _ref.isIn, theme = _ref.theme;
    var style = $60f27fc97e29822a$var$_extends({}, userStyle, {
        animationDuration: delay + "ms",
        animationPlayState: isRunning ? "running" : "paused",
        opacity: hide ? 0 : 1
    });
    if (controlledProgress) style.transform = "scaleX(" + progress + ")";
    var defaultClassName = (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)("Toastify__progress-bar", controlledProgress ? "Toastify__progress-bar--controlled" : "Toastify__progress-bar--animated", "Toastify__progress-bar-theme--" + theme, "Toastify__progress-bar--" + type, (_cx = {}, _cx["Toastify__progress-bar--rtl"] = rtl, _cx));
    var classNames = $60f27fc97e29822a$var$isFn(className) ? className({
        rtl: rtl,
        type: type,
        defaultClassName: defaultClassName
    }) : (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)(defaultClassName, className); // 🧐 controlledProgress is derived from progress
    // so if controlledProgress is set
    // it means that this is also the case for progress
    var animationEvent = (_animationEvent = {}, _animationEvent[controlledProgress && progress >= 1 ? "onTransitionEnd" : "onAnimationEnd"] = controlledProgress && progress < 1 ? null : function() {
        isIn && closeToast();
    }, _animationEvent); // TODO: add aria-valuenow, aria-valuemax, aria-valuemin
    return (0, $acw62.createElement)("div", Object.assign({
        role: "progressbar",
        "aria-hidden": hide ? "true" : "false",
        "aria-label": "notification timer",
        className: classNames,
        style: style
    }, animationEvent));
}
$60f27fc97e29822a$var$ProgressBar.defaultProps = {
    type: $60f27fc97e29822a$var$TYPE.DEFAULT,
    hide: false
};
var $60f27fc97e29822a$var$_excluded$1 = [
    "theme",
    "type"
];
var $60f27fc97e29822a$var$Svg = function Svg(_ref) {
    var theme = _ref.theme, type = _ref.type, rest = $60f27fc97e29822a$var$_objectWithoutPropertiesLoose(_ref, $60f27fc97e29822a$var$_excluded$1);
    return (0, $acw62.createElement)("svg", Object.assign({
        viewBox: "0 0 24 24",
        width: "100%",
        height: "100%",
        fill: theme === "colored" ? "currentColor" : "var(--toastify-icon-color-" + type + ")"
    }, rest));
};
function $60f27fc97e29822a$var$Warning(props) {
    return (0, $acw62.createElement)($60f27fc97e29822a$var$Svg, Object.assign({}, props), (0, $acw62.createElement)("path", {
        d: "M23.32 17.191L15.438 2.184C14.728.833 13.416 0 11.996 0c-1.42 0-2.733.833-3.443 2.184L.533 17.448a4.744 4.744 0 000 4.368C1.243 23.167 2.555 24 3.975 24h16.05C22.22 24 24 22.044 24 19.632c0-.904-.251-1.746-.68-2.44zm-9.622 1.46c0 1.033-.724 1.823-1.698 1.823s-1.698-.79-1.698-1.822v-.043c0-1.028.724-1.822 1.698-1.822s1.698.79 1.698 1.822v.043zm.039-12.285l-.84 8.06c-.057.581-.408.943-.897.943-.49 0-.84-.367-.896-.942l-.84-8.065c-.057-.624.25-1.095.779-1.095h1.91c.528.005.84.476.784 1.1z"
    }));
}
function $60f27fc97e29822a$var$Info(props) {
    return (0, $acw62.createElement)($60f27fc97e29822a$var$Svg, Object.assign({}, props), (0, $acw62.createElement)("path", {
        d: "M12 0a12 12 0 1012 12A12.013 12.013 0 0012 0zm.25 5a1.5 1.5 0 11-1.5 1.5 1.5 1.5 0 011.5-1.5zm2.25 13.5h-4a1 1 0 010-2h.75a.25.25 0 00.25-.25v-4.5a.25.25 0 00-.25-.25h-.75a1 1 0 010-2h1a2 2 0 012 2v4.75a.25.25 0 00.25.25h.75a1 1 0 110 2z"
    }));
}
function $60f27fc97e29822a$var$Success(props) {
    return (0, $acw62.createElement)($60f27fc97e29822a$var$Svg, Object.assign({}, props), (0, $acw62.createElement)("path", {
        d: "M12 0a12 12 0 1012 12A12.014 12.014 0 0012 0zm6.927 8.2l-6.845 9.289a1.011 1.011 0 01-1.43.188l-4.888-3.908a1 1 0 111.25-1.562l4.076 3.261 6.227-8.451a1 1 0 111.61 1.183z"
    }));
}
function $60f27fc97e29822a$var$Error(props) {
    return (0, $acw62.createElement)($60f27fc97e29822a$var$Svg, Object.assign({}, props), (0, $acw62.createElement)("path", {
        d: "M11.983 0a12.206 12.206 0 00-8.51 3.653A11.8 11.8 0 000 12.207 11.779 11.779 0 0011.8 24h.214A12.111 12.111 0 0024 11.791 11.766 11.766 0 0011.983 0zM10.5 16.542a1.476 1.476 0 011.449-1.53h.027a1.527 1.527 0 011.523 1.47 1.475 1.475 0 01-1.449 1.53h-.027a1.529 1.529 0 01-1.523-1.47zM11 12.5v-6a1 1 0 012 0v6a1 1 0 11-2 0z"
    }));
}
function $60f27fc97e29822a$var$Spinner() {
    return (0, $acw62.createElement)("div", {
        className: "Toastify__spinner"
    });
}
var $60f27fc97e29822a$export$4f13f83fd8bb1dac = {
    info: $60f27fc97e29822a$var$Info,
    warning: $60f27fc97e29822a$var$Warning,
    success: $60f27fc97e29822a$var$Success,
    error: $60f27fc97e29822a$var$Error,
    spinner: $60f27fc97e29822a$var$Spinner
};
var $60f27fc97e29822a$var$Toast = function Toast(props) {
    var _cx, _cx2;
    var _useToast = $60f27fc97e29822a$export$a407b657d3044108(props), isRunning = _useToast.isRunning, preventExitTransition = _useToast.preventExitTransition, toastRef = _useToast.toastRef, eventHandlers = _useToast.eventHandlers;
    var closeButton = props.closeButton, children = props.children, autoClose = props.autoClose, onClick = props.onClick, type = props.type, hideProgressBar = props.hideProgressBar, closeToast = props.closeToast, Transition = props.transition, position = props.position, className = props.className, style = props.style, bodyClassName = props.bodyClassName, bodyStyle = props.bodyStyle, progressClassName = props.progressClassName, progressStyle = props.progressStyle, updateId = props.updateId, role = props.role, progress = props.progress, rtl = props.rtl, toastId = props.toastId, deleteToast = props.deleteToast, isIn = props.isIn, isLoading = props.isLoading, icon = props.icon, theme = props.theme;
    var defaultClassName = (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)("Toastify__toast", "Toastify__toast-theme--" + theme, "Toastify__toast--" + type, (_cx = {}, _cx["Toastify__toast--rtl"] = rtl, _cx));
    var cssClasses = $60f27fc97e29822a$var$isFn(className) ? className({
        rtl: rtl,
        position: position,
        type: type,
        defaultClassName: defaultClassName
    }) : (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)(defaultClassName, className);
    var isProgressControlled = !!progress;
    var maybeIcon = $60f27fc97e29822a$export$4f13f83fd8bb1dac[type];
    var iconProps = {
        theme: theme,
        type: type
    };
    var Icon = maybeIcon && maybeIcon(iconProps);
    if (icon === false) Icon = void 0;
    else if ($60f27fc97e29822a$var$isFn(icon)) Icon = icon(iconProps);
    else if ((0, $acw62.isValidElement)(icon)) Icon = (0, $acw62.cloneElement)(icon, iconProps);
    else if ($60f27fc97e29822a$var$isStr(icon)) Icon = icon;
    else if (isLoading) Icon = $60f27fc97e29822a$export$4f13f83fd8bb1dac.spinner();
    function renderCloseButton(closeButton) {
        if (!closeButton) return;
        var props = {
            closeToast: closeToast,
            type: type,
            theme: theme
        };
        if ($60f27fc97e29822a$var$isFn(closeButton)) return closeButton(props);
        if ((0, $acw62.isValidElement)(closeButton)) return (0, $acw62.cloneElement)(closeButton, props);
    }
    return (0, $acw62.createElement)(Transition, {
        isIn: isIn,
        done: deleteToast,
        position: position,
        preventExitTransition: preventExitTransition,
        nodeRef: toastRef
    }, (0, $acw62.createElement)("div", Object.assign({
        id: toastId,
        onClick: onClick,
        className: cssClasses
    }, eventHandlers, {
        style: style,
        ref: toastRef
    }), (0, $acw62.createElement)("div", Object.assign({}, isIn && {
        role: role
    }, {
        className: $60f27fc97e29822a$var$isFn(bodyClassName) ? bodyClassName({
            type: type
        }) : (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)("Toastify__toast-body", bodyClassName),
        style: bodyStyle
    }), Icon && (0, $acw62.createElement)("div", {
        className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)("Toastify__toast-icon", (_cx2 = {}, _cx2["Toastify--animate-icon Toastify__zoom-enter"] = !isLoading, _cx2))
    }, Icon), (0, $acw62.createElement)("div", null, children)), renderCloseButton(closeButton), (autoClose || isProgressControlled) && (0, $acw62.createElement)($60f27fc97e29822a$var$ProgressBar, Object.assign({}, updateId && !isProgressControlled ? {
        key: "pb-" + updateId
    } : {}, {
        rtl: rtl,
        theme: theme,
        delay: autoClose,
        isRunning: isRunning,
        isIn: isIn,
        closeToast: closeToast,
        hide: hideProgressBar,
        type: type,
        style: progressStyle,
        className: progressClassName,
        controlledProgress: isProgressControlled,
        progress: progress
    }))));
};
var $60f27fc97e29822a$export$d20e79fdc3899e95 = /*#__PURE__*/ $60f27fc97e29822a$export$3ff7dc44d332d222({
    enter: "Toastify--animate Toastify__bounce-enter",
    exit: "Toastify--animate Toastify__bounce-exit",
    appendPosition: true
});
var $60f27fc97e29822a$export$d8dc01b5c85a37b9 = /*#__PURE__*/ $60f27fc97e29822a$export$3ff7dc44d332d222({
    enter: "Toastify--animate Toastify__slide-enter",
    exit: "Toastify--animate Toastify__slide-exit",
    appendPosition: true
});
var $60f27fc97e29822a$export$65cfd44a2050f99 = /*#__PURE__*/ $60f27fc97e29822a$export$3ff7dc44d332d222({
    enter: "Toastify--animate Toastify__zoom-enter",
    exit: "Toastify--animate Toastify__zoom-exit"
});
var $60f27fc97e29822a$export$4d2fae537bd90431 = /*#__PURE__*/ $60f27fc97e29822a$export$3ff7dc44d332d222({
    enter: "Toastify--animate Toastify__flip-enter",
    exit: "Toastify--animate Toastify__flip-exit"
});
var $60f27fc97e29822a$export$f2815235e76a62b9 = function ToastContainer(props) {
    var _useToastContainer = $60f27fc97e29822a$export$b262e13ca2dd2381(props), getToastToRender = _useToastContainer.getToastToRender, containerRef = _useToastContainer.containerRef, isToastActive = _useToastContainer.isToastActive;
    var className = props.className, style = props.style, rtl = props.rtl, containerId = props.containerId;
    function getClassName(position) {
        var _cx;
        var defaultClassName = (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)("Toastify__toast-container", "Toastify__toast-container--" + position, (_cx = {}, _cx["Toastify__toast-container--rtl"] = rtl, _cx));
        return $60f27fc97e29822a$var$isFn(className) ? className({
            position: position,
            rtl: rtl,
            defaultClassName: defaultClassName
        }) : (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)(defaultClassName, $60f27fc97e29822a$var$parseClassName(className));
    }
    return (0, $acw62.createElement)("div", {
        ref: containerRef,
        className: "Toastify",
        id: containerId
    }, getToastToRender(function(position, toastList) {
        var containerStyle = !toastList.length ? $60f27fc97e29822a$var$_extends({}, style, {
            pointerEvents: "none"
        }) : $60f27fc97e29822a$var$_extends({}, style);
        return (0, $acw62.createElement)("div", {
            className: getClassName(position),
            style: containerStyle,
            key: "container-" + position
        }, toastList.map(function(_ref) {
            var content = _ref.content, toastProps = _ref.props;
            return (0, $acw62.createElement)($60f27fc97e29822a$var$Toast, Object.assign({}, toastProps, {
                isIn: isToastActive(toastProps.toastId),
                key: "toast-" + toastProps.key,
                closeButton: toastProps.closeButton === true ? $60f27fc97e29822a$var$CloseButton : toastProps.closeButton
            }), content);
        }));
    }));
};
$60f27fc97e29822a$export$f2815235e76a62b9.defaultProps = {
    position: $60f27fc97e29822a$var$POSITION.TOP_RIGHT,
    transition: $60f27fc97e29822a$export$d20e79fdc3899e95,
    rtl: false,
    autoClose: 5000,
    hideProgressBar: false,
    closeButton: $60f27fc97e29822a$var$CloseButton,
    pauseOnHover: true,
    pauseOnFocusLoss: true,
    closeOnClick: true,
    newestOnTop: false,
    draggable: true,
    draggablePercent: 80,
    draggableDirection: "x",
    role: "alert",
    theme: "light"
};
var $60f27fc97e29822a$var$containers = /*#__PURE__*/ new Map();
var $60f27fc97e29822a$var$latestInstance;
var $60f27fc97e29822a$var$containerDomNode;
var $60f27fc97e29822a$var$containerConfig;
var $60f27fc97e29822a$var$queue = [];
var $60f27fc97e29822a$var$lazy = false;
/**
 * Get the toast by id, given it's in the DOM, otherwise returns null
 */ function $60f27fc97e29822a$var$getToast(toastId, _ref) {
    var containerId = _ref.containerId;
    var container = $60f27fc97e29822a$var$containers.get(containerId || $60f27fc97e29822a$var$latestInstance);
    if (!container) return null;
    return container.getToast(toastId);
}
/**
 * Generate a random toastId
 */ function $60f27fc97e29822a$var$generateToastId() {
    return Math.random().toString(36).substring(2, 9);
}
/**
 * Generate a toastId or use the one provided
 */ function $60f27fc97e29822a$var$getToastId(options) {
    if (options && ($60f27fc97e29822a$var$isStr(options.toastId) || $60f27fc97e29822a$var$isNum(options.toastId))) return options.toastId;
    return $60f27fc97e29822a$var$generateToastId();
}
/**
 * If the container is not mounted, the toast is enqueued and
 * the container lazy mounted
 */ function $60f27fc97e29822a$var$dispatchToast(content, options) {
    if ($60f27fc97e29822a$var$containers.size > 0) $60f27fc97e29822a$var$eventManager.emit(0, content, options);
    else {
        $60f27fc97e29822a$var$queue.push({
            content: content,
            options: options
        });
        if ($60f27fc97e29822a$var$lazy && $60f27fc97e29822a$var$canUseDom) {
            $60f27fc97e29822a$var$lazy = false;
            $60f27fc97e29822a$var$containerDomNode = document.createElement("div");
            document.body.appendChild($60f27fc97e29822a$var$containerDomNode);
            (0, $1u0KT.render)((0, $acw62.createElement)($60f27fc97e29822a$export$f2815235e76a62b9, Object.assign({}, $60f27fc97e29822a$var$containerConfig)), $60f27fc97e29822a$var$containerDomNode);
        }
    }
    return options.toastId;
}
/**
 * Merge provided options with the defaults settings and generate the toastId
 */ function $60f27fc97e29822a$var$mergeOptions(type, options) {
    return $60f27fc97e29822a$var$_extends({}, options, {
        type: options && options.type || type,
        toastId: $60f27fc97e29822a$var$getToastId(options)
    });
}
function $60f27fc97e29822a$var$createToastByType(type) {
    return function(content, options) {
        return $60f27fc97e29822a$var$dispatchToast(content, $60f27fc97e29822a$var$mergeOptions(type, options));
    };
}
function $60f27fc97e29822a$export$b410431fab84fa58(content, options) {
    return $60f27fc97e29822a$var$dispatchToast(content, $60f27fc97e29822a$var$mergeOptions($60f27fc97e29822a$var$TYPE.DEFAULT, options));
}
$60f27fc97e29822a$export$b410431fab84fa58.loading = function(content, options) {
    return $60f27fc97e29822a$var$dispatchToast(content, $60f27fc97e29822a$var$mergeOptions($60f27fc97e29822a$var$TYPE.DEFAULT, $60f27fc97e29822a$var$_extends({
        isLoading: true,
        autoClose: false,
        closeOnClick: false,
        closeButton: false,
        draggable: false
    }, options)));
};
function $60f27fc97e29822a$var$handlePromise(promise, _ref2, options) {
    var pending = _ref2.pending, error = _ref2.error, success = _ref2.success;
    var id;
    if (pending) id = $60f27fc97e29822a$var$isStr(pending) ? $60f27fc97e29822a$export$b410431fab84fa58.loading(pending, options) : $60f27fc97e29822a$export$b410431fab84fa58.loading(pending.render, $60f27fc97e29822a$var$_extends({}, options, pending));
    var resetParams = {
        isLoading: null,
        autoClose: null,
        closeOnClick: null,
        closeButton: null,
        draggable: null
    };
    var resolver = function resolver(type, input, result) {
        // Remove the toast if the input has not been provided. This prevents the toast from hanging
        // in the pending state if a success/error toast has not been provided.
        if (input == null) {
            $60f27fc97e29822a$export$b410431fab84fa58.dismiss(id);
            return;
        }
        var baseParams = $60f27fc97e29822a$var$_extends({
            type: type
        }, resetParams, options, {
            data: result
        });
        var params = $60f27fc97e29822a$var$isStr(input) ? {
            render: input
        } : input; // if the id is set we know that it's an update
        if (id) $60f27fc97e29822a$export$b410431fab84fa58.update(id, $60f27fc97e29822a$var$_extends({}, baseParams, params));
        else // using toast.promise without loading
        $60f27fc97e29822a$export$b410431fab84fa58(params.render, $60f27fc97e29822a$var$_extends({}, baseParams, params));
        return result;
    };
    var p = $60f27fc97e29822a$var$isFn(promise) ? promise() : promise; //call the resolvers only when needed
    p.then(function(result) {
        return resolver("success", success, result);
    })["catch"](function(err) {
        return resolver("error", error, err);
    });
    return p;
}
$60f27fc97e29822a$export$b410431fab84fa58.promise = $60f27fc97e29822a$var$handlePromise;
$60f27fc97e29822a$export$b410431fab84fa58.success = /*#__PURE__*/ $60f27fc97e29822a$var$createToastByType($60f27fc97e29822a$var$TYPE.SUCCESS);
$60f27fc97e29822a$export$b410431fab84fa58.info = /*#__PURE__*/ $60f27fc97e29822a$var$createToastByType($60f27fc97e29822a$var$TYPE.INFO);
$60f27fc97e29822a$export$b410431fab84fa58.error = /*#__PURE__*/ $60f27fc97e29822a$var$createToastByType($60f27fc97e29822a$var$TYPE.ERROR);
$60f27fc97e29822a$export$b410431fab84fa58.warning = /*#__PURE__*/ $60f27fc97e29822a$var$createToastByType($60f27fc97e29822a$var$TYPE.WARNING);
$60f27fc97e29822a$export$b410431fab84fa58.warn = $60f27fc97e29822a$export$b410431fab84fa58.warning;
$60f27fc97e29822a$export$b410431fab84fa58.dark = function(content, options) {
    return $60f27fc97e29822a$var$dispatchToast(content, $60f27fc97e29822a$var$mergeOptions($60f27fc97e29822a$var$TYPE.DEFAULT, $60f27fc97e29822a$var$_extends({
        theme: "dark"
    }, options)));
};
/**
 * Remove toast programmaticaly
 */ $60f27fc97e29822a$export$b410431fab84fa58.dismiss = function(id) {
    return $60f27fc97e29822a$var$eventManager.emit(1, id);
};
/**
 * Clear waiting queue when limit is used
 */ $60f27fc97e29822a$export$b410431fab84fa58.clearWaitingQueue = function(params) {
    if (params === void 0) params = {};
    return $60f27fc97e29822a$var$eventManager.emit(5, params);
};
/**
 * return true if one container is displaying the toast
 */ $60f27fc97e29822a$export$b410431fab84fa58.isActive = function(id) {
    var isToastActive = false;
    $60f27fc97e29822a$var$containers.forEach(function(container) {
        if (container.isToastActive && container.isToastActive(id)) isToastActive = true;
    });
    return isToastActive;
};
$60f27fc97e29822a$export$b410431fab84fa58.update = function(toastId, options) {
    if (options === void 0) options = {};
    // if you call toast and toast.update directly nothing will be displayed
    // this is why I defered the update
    setTimeout(function() {
        var toast = $60f27fc97e29822a$var$getToast(toastId, options);
        if (toast) {
            var oldOptions = toast.props, oldContent = toast.content;
            var nextOptions = $60f27fc97e29822a$var$_extends({}, oldOptions, options, {
                toastId: options.toastId || toastId,
                updateId: $60f27fc97e29822a$var$generateToastId()
            });
            if (nextOptions.toastId !== toastId) nextOptions.staleId = toastId;
            var content = nextOptions.render || oldContent;
            delete nextOptions.render;
            $60f27fc97e29822a$var$dispatchToast(content, nextOptions);
        }
    }, 0);
};
/**
 * Used for controlled progress bar.
 */ $60f27fc97e29822a$export$b410431fab84fa58.done = function(id) {
    $60f27fc97e29822a$export$b410431fab84fa58.update(id, {
        progress: 1
    });
};
/**
 * @deprecated
 * API will change in the next major release
 *
 * Track changes. The callback get the number of toast displayed
 */ $60f27fc97e29822a$export$b410431fab84fa58.onChange = function(callback) {
    if ($60f27fc97e29822a$var$isFn(callback)) $60f27fc97e29822a$var$eventManager.on(4, callback);
    return function() {
        $60f27fc97e29822a$var$isFn(callback) && $60f27fc97e29822a$var$eventManager.off(4, callback);
    };
};
/**
 * @deprecated
 * will be removed in the next major release
 *
 * Configure the ToastContainer when lazy mounted
 * Prefer ToastContainer over this one
 */ $60f27fc97e29822a$export$b410431fab84fa58.configure = function(config) {
    if (config === void 0) config = {};
    $60f27fc97e29822a$var$lazy = true;
    $60f27fc97e29822a$var$containerConfig = config;
};
$60f27fc97e29822a$export$b410431fab84fa58.POSITION = $60f27fc97e29822a$var$POSITION;
$60f27fc97e29822a$export$b410431fab84fa58.TYPE = $60f27fc97e29822a$var$TYPE;
/**
 * Wait until the ToastContainer is mounted to dispatch the toast
 * and attach isActive method
 */ $60f27fc97e29822a$var$eventManager.on(2, function(containerInstance) {
    $60f27fc97e29822a$var$latestInstance = containerInstance.containerId || containerInstance;
    $60f27fc97e29822a$var$containers.set($60f27fc97e29822a$var$latestInstance, containerInstance);
    $60f27fc97e29822a$var$queue.forEach(function(item) {
        $60f27fc97e29822a$var$eventManager.emit(0, item.content, item.options);
    });
    $60f27fc97e29822a$var$queue = [];
}).on(3, function(containerInstance) {
    $60f27fc97e29822a$var$containers["delete"](containerInstance.containerId || containerInstance);
    if ($60f27fc97e29822a$var$containers.size === 0) $60f27fc97e29822a$var$eventManager.off(0).off(1).off(5);
    if ($60f27fc97e29822a$var$canUseDom && $60f27fc97e29822a$var$containerDomNode) document.body.removeChild($60f27fc97e29822a$var$containerDomNode);
});


// Unique ID creation requires a high quality random # generator. In the browser we therefore
// require the crypto API and do not support built-in fallback to lower quality random number
// generators (like Math.random()).
var $568f4ee4022ba00e$var$getRandomValues;
var $568f4ee4022ba00e$var$rnds8 = new Uint8Array(16);
function $568f4ee4022ba00e$export$2e2bcd8739ae039() {
    // lazy load so that environments that need to polyfill have a chance to do so
    if (!$568f4ee4022ba00e$var$getRandomValues) {
        // getRandomValues needs to be invoked in a context where "this" is a Crypto implementation. Also,
        // find the complete implementation of crypto (msCrypto) on IE11.
        $568f4ee4022ba00e$var$getRandomValues = typeof crypto !== "undefined" && crypto.getRandomValues && crypto.getRandomValues.bind(crypto) || typeof msCrypto !== "undefined" && typeof msCrypto.getRandomValues === "function" && msCrypto.getRandomValues.bind(msCrypto);
        if (!$568f4ee4022ba00e$var$getRandomValues) throw new Error("crypto.getRandomValues() not supported. See https://github.com/uuidjs/uuid#getrandomvalues-not-supported");
    }
    return $568f4ee4022ba00e$var$getRandomValues($568f4ee4022ba00e$var$rnds8);
}


var $32c496bfb6c27b56$export$2e2bcd8739ae039 = /^(?:[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}|00000000-0000-0000-0000-000000000000)$/i;


function $46d323206dcbf256$var$validate(uuid) {
    return typeof uuid === "string" && (0, $32c496bfb6c27b56$export$2e2bcd8739ae039).test(uuid);
}
var $46d323206dcbf256$export$2e2bcd8739ae039 = $46d323206dcbf256$var$validate;


/**
 * Convert array of 16 byte values to UUID string format of the form:
 * XXXXXXXX-XXXX-XXXX-XXXX-XXXXXXXXXXXX
 */ var $1d0137947e8554ce$var$byteToHex = [];
for(var $1d0137947e8554ce$var$i = 0; $1d0137947e8554ce$var$i < 256; ++$1d0137947e8554ce$var$i)$1d0137947e8554ce$var$byteToHex.push(($1d0137947e8554ce$var$i + 0x100).toString(16).substr(1));
function $1d0137947e8554ce$var$stringify(arr) {
    var offset = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
    // Note: Be careful editing this code!  It's been tuned for performance
    // and works in ways you may not expect. See https://github.com/uuidjs/uuid/pull/434
    var uuid = ($1d0137947e8554ce$var$byteToHex[arr[offset + 0]] + $1d0137947e8554ce$var$byteToHex[arr[offset + 1]] + $1d0137947e8554ce$var$byteToHex[arr[offset + 2]] + $1d0137947e8554ce$var$byteToHex[arr[offset + 3]] + "-" + $1d0137947e8554ce$var$byteToHex[arr[offset + 4]] + $1d0137947e8554ce$var$byteToHex[arr[offset + 5]] + "-" + $1d0137947e8554ce$var$byteToHex[arr[offset + 6]] + $1d0137947e8554ce$var$byteToHex[arr[offset + 7]] + "-" + $1d0137947e8554ce$var$byteToHex[arr[offset + 8]] + $1d0137947e8554ce$var$byteToHex[arr[offset + 9]] + "-" + $1d0137947e8554ce$var$byteToHex[arr[offset + 10]] + $1d0137947e8554ce$var$byteToHex[arr[offset + 11]] + $1d0137947e8554ce$var$byteToHex[arr[offset + 12]] + $1d0137947e8554ce$var$byteToHex[arr[offset + 13]] + $1d0137947e8554ce$var$byteToHex[arr[offset + 14]] + $1d0137947e8554ce$var$byteToHex[arr[offset + 15]]).toLowerCase(); // Consistency check for valid UUID.  If this throws, it's likely due to one
    // of the following:
    // - One or more input array values don't map to a hex octet (leading to
    // "undefined" in the uuid)
    // - Invalid input values for the RFC `version` or `variant` fields
    if (!(0, $46d323206dcbf256$export$2e2bcd8739ae039)(uuid)) throw TypeError("Stringified UUID is invalid");
    return uuid;
}
var $1d0137947e8554ce$export$2e2bcd8739ae039 = $1d0137947e8554ce$var$stringify;


function $3fa3ae484854b431$var$v4(options, buf, offset) {
    options = options || {};
    var rnds = options.random || (options.rng || (0, $568f4ee4022ba00e$export$2e2bcd8739ae039))(); // Per 4.4, set bits for version and `clock_seq_hi_and_reserved`
    rnds[6] = rnds[6] & 0x0f | 0x40;
    rnds[8] = rnds[8] & 0x3f | 0x80; // Copy bytes to buffer, if provided
    if (buf) {
        offset = offset || 0;
        for(var i = 0; i < 16; ++i)buf[offset + i] = rnds[i];
        return buf;
    }
    return (0, $1d0137947e8554ce$export$2e2bcd8739ae039)(rnds);
}
var $3fa3ae484854b431$export$2e2bcd8739ae039 = $3fa3ae484854b431$var$v4;





const $0534349ae8731d0b$export$66b32f6f30eb4b4 = {
    index: (0, $7df35e9df335b1c8$export$544c268deaca2597)("/"),
    signUp: (0, $7df35e9df335b1c8$export$544c268deaca2597)("/sign-up"),
    signUpWithOrder: (0, $7df35e9df335b1c8$export$544c268deaca2597)("/start"),
    signUpWithOrderForm: (0, $7df35e9df335b1c8$export$544c268deaca2597)("/start/form"),
    forgotPassword: (0, $7df35e9df335b1c8$export$544c268deaca2597)("/forgot-password"),
    resetPassword: (0, $7df35e9df335b1c8$export$544c268deaca2597)("/reset-password"),
    changePassword: (0, $7df35e9df335b1c8$export$544c268deaca2597)("/change-password"),
    login: (0, $7df35e9df335b1c8$export$544c268deaca2597)("/login"),
    verifyEmail: (0, $7df35e9df335b1c8$export$544c268deaca2597)("/verifyemail"),
    allJobs: (0, $7df35e9df335b1c8$export$544c268deaca2597)("/all-jobs/:date"),
    pastWorkers: (0, $7df35e9df335b1c8$export$544c268deaca2597)("/staff/past"),
    applicantsReview: (0, $7df35e9df335b1c8$export$544c268deaca2597)("/jobs/applicants"),
    users: (0, $7df35e9df335b1c8$export$544c268deaca2597)("/users"),
    unconfirmedUsers: (0, $7df35e9df335b1c8$export$544c268deaca2597)("/users/unconfirmed"),
    createUser: (0, $7df35e9df335b1c8$export$544c268deaca2597)("/users/create"),
    inviteUser: (0, $7df35e9df335b1c8$export$544c268deaca2597)("/users/invite"),
    attendanceManagers: (0, $7df35e9df335b1c8$export$544c268deaca2597)("/profile/attendance-managers"),
    addAttendanceManagers: (0, $7df35e9df335b1c8$export$544c268deaca2597)("/attendance-managers/add"),
    editAttendanceManagers: (0, $7df35e9df335b1c8$export$544c268deaca2597)("/profile/attendance-managers/edit/:id"),
    editProfile: (0, $7df35e9df335b1c8$export$544c268deaca2597)("/profile/edit"),
    editCompany: (0, $7df35e9df335b1c8$export$544c268deaca2597)("/profile/edit-company"),
    setPasswordToHire: (0, $7df35e9df335b1c8$export$544c268deaca2597)("/onboarding/hire-now"),
    setCompanyDetailsToHire: (0, $7df35e9df335b1c8$export$544c268deaca2597)("/onboarding/hire-now/company-details"),
    setPasswordToManageSchedule: (0, $7df35e9df335b1c8$export$544c268deaca2597)("/onboarding/manage-schedule"),
    setCompanyDetailsToManageSchedule: (0, $7df35e9df335b1c8$export$544c268deaca2597)("/onboarding/manage-schedule/company-details"),
    locations: (0, $7df35e9df335b1c8$export$544c268deaca2597)("/locations"),
    editLocations: (0, $7df35e9df335b1c8$export$544c268deaca2597)("/locations/edit/:id"),
    addLocations: (0, $7df35e9df335b1c8$export$544c268deaca2597)("/locations/add"),
    paymentMethods: (0, $7df35e9df335b1c8$export$544c268deaca2597)("/profile/payment-methods"),
    editPaymentMethod: (0, $7df35e9df335b1c8$export$544c268deaca2597)("/profile/payment-methods/edit/:id"),
    addPaymentMethod: (0, $7df35e9df335b1c8$export$544c268deaca2597)("/profile/payment-methods/add"),
    invoices: (0, $7df35e9df335b1c8$export$544c268deaca2597)("/profile/invoices"),
    invoice: (0, $7df35e9df335b1c8$export$544c268deaca2597)("/profile/invoices/:id"),
    invoiceOgrammer: (0, $7df35e9df335b1c8$export$544c268deaca2597)("/profile/invoices/:invoiceItemId/:ogrammerId"),
    preferences: (0, $7df35e9df335b1c8$export$544c268deaca2597)("/profile/preferences"),
    orderDraft: (0, $7df35e9df335b1c8$export$544c268deaca2597)("/orders/create"),
    extendedOrderDraft: (0, $7df35e9df335b1c8$export$544c268deaca2597)("/orders/extend"),
    setJobCategory: (0, $7df35e9df335b1c8$export$544c268deaca2597)("/orders/create/jobs/create/category"),
    setJobLocation: (0, $7df35e9df335b1c8$export$544c268deaca2597)("/orders/create/jobs/create/location"),
    setJobPrice: (0, $7df35e9df335b1c8$export$544c268deaca2597)("/orders/create/jobs/create/price"),
    jobDraftDetails: (0, $7df35e9df335b1c8$export$544c268deaca2597)("/orders/create/jobs/create/details"),
    jobDraftDetailsPopupField: (0, $7df35e9df335b1c8$export$544c268deaca2597)("/orders/create/jobs/create/details/:popupField"),
    orderDraftSummary: (0, $7df35e9df335b1c8$export$544c268deaca2597)("/order/:orderId/summary"),
    completeCompanyDetailsForPaymentTerms: (0, $7df35e9df335b1c8$export$544c268deaca2597)("/complete-company-details"),
    orderRequestSuccess: (0, $7df35e9df335b1c8$export$544c268deaca2597)("/order/:orderId/summary/requested"),
    orderConfirmation: (0, $7df35e9df335b1c8$export$544c268deaca2597)("/order/:orderId/confirm"),
    orderCreateSuccess: (0, $7df35e9df335b1c8$export$544c268deaca2597)("/order/create/:orderId/success"),
    orderDuplicate: (0, $7df35e9df335b1c8$export$544c268deaca2597)("/order/:orderId/duplicate"),
    orderDuplicateChooseJobs: (0, $7df35e9df335b1c8$export$544c268deaca2597)("/order/:orderId/duplicate/choose-jobs"),
    attendanceShiftsList: (0, $7df35e9df335b1c8$export$544c268deaca2597)("/attendance-shifts"),
    attendanceQR: (0, $7df35e9df335b1c8$export$544c268deaca2597)("/qr-attendance"),
    completeRegistration: (0, $7df35e9df335b1c8$export$544c268deaca2597)("/complete-registration"),
    signSLA: (0, $7df35e9df335b1c8$export$544c268deaca2597)("/sign-sla"),
    onboardingFinish: (0, $7df35e9df335b1c8$export$544c268deaca2597)("/onboarding-finish"),
    jobOGCherryPicker: (0, $7df35e9df335b1c8$export$544c268deaca2597)("/jobs/:jobId/applicants"),
    applicantDetails: (0, $7df35e9df335b1c8$export$544c268deaca2597)("/jobs/:jobId/applicants/:applicantId"),
    jobRatingRequests: (0, $7df35e9df335b1c8$export$544c268deaca2597)("/job-rating-requests"),
    jobRatingDetails: (0, $7df35e9df335b1c8$export$544c268deaca2597)("/job-rating-requests/:id"),
    knowledgeCenter: (0, $7df35e9df335b1c8$export$544c268deaca2597)("/knowledge-center"),
    orders: (0, $7df35e9df335b1c8$export$544c268deaca2597)("/orders-list/:ordersState"),
    confirmClientInvitation: (0, $7df35e9df335b1c8$export$544c268deaca2597)("/confirm-client-invitation/:clientId"),
    paymentList: (0, $7df35e9df335b1c8$export$544c268deaca2597)("/payments-list/:paymentStatus"),
    payWithCard: (0, $7df35e9df335b1c8$export$544c268deaca2597)("/payments/:paymentId/card/pay"),
    cardPaymentStatus: (0, $7df35e9df335b1c8$export$544c268deaca2597)("/payments/:paymentId/status"),
    paymentMethodsList: (0, $7df35e9df335b1c8$export$544c268deaca2597)("/payments/:paymentId/payment-methods"),
    payWithSavedCard: (0, $7df35e9df335b1c8$export$544c268deaca2597)("/payments/:paymentId/saved-card/pay"),
    paymentDetails: (0, $7df35e9df335b1c8$export$544c268deaca2597)("/payments/:paymentId"),
    accountStatement: (0, $7df35e9df335b1c8$export$544c268deaca2597)("/account-statement"),
    wireTransferDetails: (0, $7df35e9df335b1c8$export$544c268deaca2597)("/payments/:paymentId/wire/details"),
    wireTransferUploadSlip: (0, $7df35e9df335b1c8$export$544c268deaca2597)("/payments/:paymentId/wire/slip"),
    savedPaymentMethods: (0, $7df35e9df335b1c8$export$544c268deaca2597)("/saved-payment-methods"),
    saveCard: (0, $7df35e9df335b1c8$export$544c268deaca2597)("/save-card"),
    affiliateDashboard: (0, $7df35e9df335b1c8$export$544c268deaca2597)("/affiliate/home"),
    affiliateReferralsList: (0, $7df35e9df335b1c8$export$544c268deaca2597)("/affiliate/referrals"),
    affiliateEarnings: (0, $7df35e9df335b1c8$export$544c268deaca2597)("/affiliate/earnings"),
    disputes: (0, $7df35e9df335b1c8$export$544c268deaca2597)("/disputes")
};



var $i56po = parcelRequire("i56po");
var $97fa7686fb8e51ed$export$b8ca5fa4899cbfc7;
(function(AccountType) {
    AccountType["CORPORATE"] = "B";
    AccountType["NOT_CORPORATE"] = "C";
})($97fa7686fb8e51ed$export$b8ca5fa4899cbfc7 || ($97fa7686fb8e51ed$export$b8ca5fa4899cbfc7 = {}));
var $97fa7686fb8e51ed$export$eb3485a690c2f0b8;
(function(UserRole) {
    UserRole[UserRole["Owner"] = 1] = "Owner";
    UserRole[UserRole["Admin"] = 2] = "Admin";
    UserRole[UserRole["Manager"] = 3] = "Manager";
    UserRole[UserRole["Finance"] = 4] = "Finance";
})($97fa7686fb8e51ed$export$eb3485a690c2f0b8 || ($97fa7686fb8e51ed$export$eb3485a690c2f0b8 = {}));
var $97fa7686fb8e51ed$export$3288d34c523a1192;
(function(Tag) {
    Tag["PaymentsEnabled"] = "_payments_enabled";
    Tag["LeanPaymentsEnabled"] = "_lean_payments_enabled";
})($97fa7686fb8e51ed$export$3288d34c523a1192 || ($97fa7686fb8e51ed$export$3288d34c523a1192 = {}));
const $97fa7686fb8e51ed$var$AccountProfileModel = (0, $i56po.types).model("AccountProfile", {
    id: (0, $i56po.types).identifierNumber,
    company_name: (0, $i56po.types).maybeNull((0, $i56po.types).string)
});
const $97fa7686fb8e51ed$export$a304486d272e5789 = (0, $i56po.types).model("Account", {
    id: (0, $i56po.types).identifierNumber,
    user_id: (0, $i56po.types).maybeNull((0, $i56po.types).number),
    name: (0, $i56po.types).string,
    account_type: (0, $i56po.types).string,
    is_basic_info_complete: (0, $i56po.types).boolean,
    is_corporate_details_complete: (0, $i56po.types).boolean,
    roles: (0, $i56po.types).array((0, $i56po.types).number),
    profiles: (0, $i56po.types).array($97fa7686fb8e51ed$var$AccountProfileModel),
    tags: (0, $i56po.types).array((0, $i56po.types).string),
    email: (0, $i56po.types).string
});
const $97fa7686fb8e51ed$export$2094fea184162489 = (self)=>({
        setAccount (account) {
            self.account = $97fa7686fb8e51ed$export$a304486d272e5789.create(account);
        }
    });




var $acw62 = parcelRequire("acw62");




const $db33374530818377$export$dc075a807a8c61e8 = (Component)=>{
    const ComponentWithHomeRouting = (0, $aca50e9407ba89c9$export$b6ae1bc530f4c149)((props)=>{
        const { logged: logged } = (0, $4671947198ddd366$export$6ccbb43953eebf8)().data;
        const redirect = (0, $7df35e9df335b1c8$export$602eaf6d5314ce55)();
        (0, $acw62.useEffect)(()=>{
            if (logged) redirect((0, $0534349ae8731d0b$export$66b32f6f30eb4b4).index, {});
        }, []);
        if (logged) return null;
        return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)(Component, {
            ...props
        });
    });
    return ComponentWithHomeRouting;
};



// ES6 Map
var $c20a5baa3b2b3be7$var$map;
try {
    $c20a5baa3b2b3be7$var$map = Map;
} catch (_) {}
var $c20a5baa3b2b3be7$var$set;
// ES6 Set
try {
    $c20a5baa3b2b3be7$var$set = Set;
} catch (_) {}
function $c20a5baa3b2b3be7$var$baseClone(src, circulars, clones) {
    // Null/undefined/functions/etc
    if (!src || typeof src !== "object" || typeof src === "function") return src;
    // DOM Node
    if (src.nodeType && "cloneNode" in src) return src.cloneNode(true);
    // Date
    if (src instanceof Date) return new Date(src.getTime());
    // RegExp
    if (src instanceof RegExp) return new RegExp(src);
    // Arrays
    if (Array.isArray(src)) return src.map($c20a5baa3b2b3be7$export$2e2bcd8739ae039);
    // ES6 Maps
    if ($c20a5baa3b2b3be7$var$map && src instanceof $c20a5baa3b2b3be7$var$map) return new Map(Array.from(src.entries()));
    // ES6 Sets
    if ($c20a5baa3b2b3be7$var$set && src instanceof $c20a5baa3b2b3be7$var$set) return new Set(Array.from(src.values()));
    // Object
    if (src instanceof Object) {
        circulars.push(src);
        var obj = Object.create(src);
        clones.push(obj);
        for(var key in src){
            var idx = circulars.findIndex(function(i) {
                return i === src[key];
            });
            obj[key] = idx > -1 ? clones[idx] : $c20a5baa3b2b3be7$var$baseClone(src[key], circulars, clones);
        }
        return obj;
    }
    // ???
    return src;
}
function $c20a5baa3b2b3be7$export$2e2bcd8739ae039(src) {
    return $c20a5baa3b2b3be7$var$baseClone(src, [], []);
}


const $3bcbbcae986c2431$var$toString = Object.prototype.toString;
const $3bcbbcae986c2431$var$errorToString = Error.prototype.toString;
const $3bcbbcae986c2431$var$regExpToString = RegExp.prototype.toString;
const $3bcbbcae986c2431$var$symbolToString = typeof Symbol !== "undefined" ? Symbol.prototype.toString : ()=>"";
const $3bcbbcae986c2431$var$SYMBOL_REGEXP = /^Symbol\((.*)\)(.*)$/;
function $3bcbbcae986c2431$var$printNumber(val) {
    if (val != +val) return "NaN";
    const isNegativeZero = val === 0 && 1 / val < 0;
    return isNegativeZero ? "-0" : "" + val;
}
function $3bcbbcae986c2431$var$printSimpleValue(val, quoteStrings = false) {
    if (val == null || val === true || val === false) return "" + val;
    const typeOf = typeof val;
    if (typeOf === "number") return $3bcbbcae986c2431$var$printNumber(val);
    if (typeOf === "string") return quoteStrings ? `"${val}"` : val;
    if (typeOf === "function") return "[Function " + (val.name || "anonymous") + "]";
    if (typeOf === "symbol") return $3bcbbcae986c2431$var$symbolToString.call(val).replace($3bcbbcae986c2431$var$SYMBOL_REGEXP, "Symbol($1)");
    const tag = $3bcbbcae986c2431$var$toString.call(val).slice(8, -1);
    if (tag === "Date") return isNaN(val.getTime()) ? "" + val : val.toISOString(val);
    if (tag === "Error" || val instanceof Error) return "[" + $3bcbbcae986c2431$var$errorToString.call(val) + "]";
    if (tag === "RegExp") return $3bcbbcae986c2431$var$regExpToString.call(val);
    return null;
}
function $3bcbbcae986c2431$export$2e2bcd8739ae039(value, quoteStrings) {
    let result = $3bcbbcae986c2431$var$printSimpleValue(value, quoteStrings);
    if (result !== null) return result;
    return JSON.stringify(value, function(key, value) {
        let result = $3bcbbcae986c2431$var$printSimpleValue(this[key], quoteStrings);
        if (result !== null) return result;
        return value;
    }, 2);
}


let $3ea8894c2d1a8ff8$export$9b30b6294c1449a8 = {
    default: "${path} is invalid",
    required: "${path} is a required field",
    oneOf: "${path} must be one of the following values: ${values}",
    notOneOf: "${path} must not be one of the following values: ${values}",
    notType: ({ path: path, type: type, value: value, originalValue: originalValue })=>{
        let isCast = originalValue != null && originalValue !== value;
        let msg = `${path} must be a \`${type}\` type, ` + `but the final value was: \`${(0, $3bcbbcae986c2431$export$2e2bcd8739ae039)(value, true)}\`` + (isCast ? ` (cast from the value \`${(0, $3bcbbcae986c2431$export$2e2bcd8739ae039)(originalValue, true)}\`).` : ".");
        if (value === null) msg += `\n If "null" is intended as an empty value be sure to mark the schema as \`.nullable()\``;
        return msg;
    },
    defined: "${path} must be defined"
};
let $3ea8894c2d1a8ff8$export$22b082955e083ec3 = {
    length: "${path} must be exactly ${length} characters",
    min: "${path} must be at least ${min} characters",
    max: "${path} must be at most ${max} characters",
    matches: '${path} must match the following: "${regex}"',
    email: "${path} must be a valid email",
    url: "${path} must be a valid URL",
    uuid: "${path} must be a valid UUID",
    trim: "${path} must be a trimmed string",
    lowercase: "${path} must be a lowercase string",
    uppercase: "${path} must be a upper case string"
};
let $3ea8894c2d1a8ff8$export$98e628dec113755e = {
    min: "${path} must be greater than or equal to ${min}",
    max: "${path} must be less than or equal to ${max}",
    lessThan: "${path} must be less than ${less}",
    moreThan: "${path} must be greater than ${more}",
    positive: "${path} must be a positive number",
    negative: "${path} must be a negative number",
    integer: "${path} must be an integer"
};
let $3ea8894c2d1a8ff8$export$324d90190a8b822a = {
    min: "${path} field must be later than ${min}",
    max: "${path} field must be at earlier than ${max}"
};
let $3ea8894c2d1a8ff8$export$4a21f16c33752377 = {
    isValue: "${path} field must be ${value}"
};
let $3ea8894c2d1a8ff8$export$be5493f9613cbbe = {
    noUnknown: "${path} field has unspecified keys: ${unknown}"
};
let $3ea8894c2d1a8ff8$export$2f23118c22fb2630 = {
    min: "${path} field must have at least ${min} items",
    max: "${path} field must have less than or equal to ${max} items",
    length: "${path} must have ${length} items"
};
var $3ea8894c2d1a8ff8$export$2e2bcd8739ae039 = Object.assign(Object.create(null), {
    mixed: $3ea8894c2d1a8ff8$export$9b30b6294c1449a8,
    string: $3ea8894c2d1a8ff8$export$22b082955e083ec3,
    number: $3ea8894c2d1a8ff8$export$98e628dec113755e,
    date: $3ea8894c2d1a8ff8$export$324d90190a8b822a,
    object: $3ea8894c2d1a8ff8$export$be5493f9613cbbe,
    array: $3ea8894c2d1a8ff8$export$2f23118c22fb2630,
    boolean: $3ea8894c2d1a8ff8$export$4a21f16c33752377
});


var $e21135b6db383fe3$exports = {};
var $3c47f0745c8ad323$exports = {};
/** Used for built-in method references. */ var $3c47f0745c8ad323$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $3c47f0745c8ad323$var$hasOwnProperty = $3c47f0745c8ad323$var$objectProto.hasOwnProperty;
/**
 * The base implementation of `_.has` without support for deep paths.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {Array|string} key The key to check.
 * @returns {boolean} Returns `true` if `key` exists, else `false`.
 */ function $3c47f0745c8ad323$var$baseHas(object, key) {
    return object != null && $3c47f0745c8ad323$var$hasOwnProperty.call(object, key);
}
$3c47f0745c8ad323$exports = $3c47f0745c8ad323$var$baseHas;


var $85aaea8f77d790ae$exports = {};
var $38afcbfab85a0553$exports = {};
var $0488fde9aa355453$exports = {};
/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */ var $0488fde9aa355453$var$isArray = Array.isArray;
$0488fde9aa355453$exports = $0488fde9aa355453$var$isArray;


var $03e9beb856e9b4cd$exports = {};

var $6b5a5095e0934938$exports = {};
var $a7f8a2555793d7d3$exports = {};
var $3ba72ebe7e4419b5$exports = {};

var $23YZo = parcelRequire("23YZo");
/** Built-in value references. */ var $3ba72ebe7e4419b5$var$Symbol = $23YZo.Symbol;
$3ba72ebe7e4419b5$exports = $3ba72ebe7e4419b5$var$Symbol;


var $dabe9ecbecc6d0b5$exports = {};

/** Used for built-in method references. */ var $dabe9ecbecc6d0b5$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $dabe9ecbecc6d0b5$var$hasOwnProperty = $dabe9ecbecc6d0b5$var$objectProto.hasOwnProperty;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var $dabe9ecbecc6d0b5$var$nativeObjectToString = $dabe9ecbecc6d0b5$var$objectProto.toString;
/** Built-in value references. */ var $dabe9ecbecc6d0b5$var$symToStringTag = $3ba72ebe7e4419b5$exports ? $3ba72ebe7e4419b5$exports.toStringTag : undefined;
/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */ function $dabe9ecbecc6d0b5$var$getRawTag(value) {
    var isOwn = $dabe9ecbecc6d0b5$var$hasOwnProperty.call(value, $dabe9ecbecc6d0b5$var$symToStringTag), tag = value[$dabe9ecbecc6d0b5$var$symToStringTag];
    try {
        value[$dabe9ecbecc6d0b5$var$symToStringTag] = undefined;
        var unmasked = true;
    } catch (e) {}
    var result = $dabe9ecbecc6d0b5$var$nativeObjectToString.call(value);
    if (unmasked) {
        if (isOwn) value[$dabe9ecbecc6d0b5$var$symToStringTag] = tag;
        else delete value[$dabe9ecbecc6d0b5$var$symToStringTag];
    }
    return result;
}
$dabe9ecbecc6d0b5$exports = $dabe9ecbecc6d0b5$var$getRawTag;


var $3fce91ec3914aaed$exports = {};
/** Used for built-in method references. */ var $3fce91ec3914aaed$var$objectProto = Object.prototype;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var $3fce91ec3914aaed$var$nativeObjectToString = $3fce91ec3914aaed$var$objectProto.toString;
/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */ function $3fce91ec3914aaed$var$objectToString(value) {
    return $3fce91ec3914aaed$var$nativeObjectToString.call(value);
}
$3fce91ec3914aaed$exports = $3fce91ec3914aaed$var$objectToString;


/** `Object#toString` result references. */ var $a7f8a2555793d7d3$var$nullTag = "[object Null]", $a7f8a2555793d7d3$var$undefinedTag = "[object Undefined]";
/** Built-in value references. */ var $a7f8a2555793d7d3$var$symToStringTag = $3ba72ebe7e4419b5$exports ? $3ba72ebe7e4419b5$exports.toStringTag : undefined;
/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */ function $a7f8a2555793d7d3$var$baseGetTag(value) {
    if (value == null) return value === undefined ? $a7f8a2555793d7d3$var$undefinedTag : $a7f8a2555793d7d3$var$nullTag;
    return $a7f8a2555793d7d3$var$symToStringTag && $a7f8a2555793d7d3$var$symToStringTag in Object(value) ? $dabe9ecbecc6d0b5$exports(value) : $3fce91ec3914aaed$exports(value);
}
$a7f8a2555793d7d3$exports = $a7f8a2555793d7d3$var$baseGetTag;


var $61269cf1f3e020be$exports = {};
/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */ function $61269cf1f3e020be$var$isObjectLike(value) {
    return value != null && typeof value == "object";
}
$61269cf1f3e020be$exports = $61269cf1f3e020be$var$isObjectLike;


/** `Object#toString` result references. */ var $6b5a5095e0934938$var$symbolTag = "[object Symbol]";
/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */ function $6b5a5095e0934938$var$isSymbol(value) {
    return typeof value == "symbol" || $61269cf1f3e020be$exports(value) && $a7f8a2555793d7d3$exports(value) == $6b5a5095e0934938$var$symbolTag;
}
$6b5a5095e0934938$exports = $6b5a5095e0934938$var$isSymbol;


/** Used to match property names within property paths. */ var $03e9beb856e9b4cd$var$reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, $03e9beb856e9b4cd$var$reIsPlainProp = /^\w*$/;
/**
 * Checks if `value` is a property name and not a property path.
 *
 * @private
 * @param {*} value The value to check.
 * @param {Object} [object] The object to query keys on.
 * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
 */ function $03e9beb856e9b4cd$var$isKey(value, object) {
    if ($0488fde9aa355453$exports(value)) return false;
    var type = typeof value;
    if (type == "number" || type == "symbol" || type == "boolean" || value == null || $6b5a5095e0934938$exports(value)) return true;
    return $03e9beb856e9b4cd$var$reIsPlainProp.test(value) || !$03e9beb856e9b4cd$var$reIsDeepProp.test(value) || object != null && value in Object(object);
}
$03e9beb856e9b4cd$exports = $03e9beb856e9b4cd$var$isKey;


var $f9135a667399ede4$exports = {};
var $6aae515404bf5dd2$exports = {};
var $17f5c88c594eac51$exports = {};
var $4902f64a16640324$exports = {};
var $df2cd4bc93f21548$exports = {};
var $8d50e526a9e9b7fa$exports = {};
var $80f20c637ba11563$exports = {};
var $e95343b7bf5d617b$exports = {};
var $5037fd2e597c2a03$exports = {};
var $8360225fb63098b3$exports = {};
var $004783abbde551e4$exports = {};

var $f9ff2e983beb6b86$exports = {};
/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */ function $f9ff2e983beb6b86$var$isObject(value) {
    var type = typeof value;
    return value != null && (type == "object" || type == "function");
}
$f9ff2e983beb6b86$exports = $f9ff2e983beb6b86$var$isObject;


/** `Object#toString` result references. */ var $004783abbde551e4$var$asyncTag = "[object AsyncFunction]", $004783abbde551e4$var$funcTag = "[object Function]", $004783abbde551e4$var$genTag = "[object GeneratorFunction]", $004783abbde551e4$var$proxyTag = "[object Proxy]";
/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */ function $004783abbde551e4$var$isFunction(value) {
    if (!$f9ff2e983beb6b86$exports(value)) return false;
    // The use of `Object#toString` avoids issues with the `typeof` operator
    // in Safari 9 which returns 'object' for typed arrays and other constructors.
    var tag = $a7f8a2555793d7d3$exports(value);
    return tag == $004783abbde551e4$var$funcTag || tag == $004783abbde551e4$var$genTag || tag == $004783abbde551e4$var$asyncTag || tag == $004783abbde551e4$var$proxyTag;
}
$004783abbde551e4$exports = $004783abbde551e4$var$isFunction;


var $5e8d211f630cd46d$exports = {};
var $baf78e1246b3b18f$exports = {};

var $23YZo = parcelRequire("23YZo");
/** Used to detect overreaching core-js shims. */ var $baf78e1246b3b18f$var$coreJsData = $23YZo["__core-js_shared__"];
$baf78e1246b3b18f$exports = $baf78e1246b3b18f$var$coreJsData;


/** Used to detect methods masquerading as native. */ var $5e8d211f630cd46d$var$maskSrcKey = function() {
    var uid = /[^.]+$/.exec($baf78e1246b3b18f$exports && $baf78e1246b3b18f$exports.keys && $baf78e1246b3b18f$exports.keys.IE_PROTO || "");
    return uid ? "Symbol(src)_1." + uid : "";
}();
/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */ function $5e8d211f630cd46d$var$isMasked(func) {
    return !!$5e8d211f630cd46d$var$maskSrcKey && $5e8d211f630cd46d$var$maskSrcKey in func;
}
$5e8d211f630cd46d$exports = $5e8d211f630cd46d$var$isMasked;



var $9c6b3ec69362487e$exports = {};
/** Used for built-in method references. */ var $9c6b3ec69362487e$var$funcProto = Function.prototype;
/** Used to resolve the decompiled source of functions. */ var $9c6b3ec69362487e$var$funcToString = $9c6b3ec69362487e$var$funcProto.toString;
/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to convert.
 * @returns {string} Returns the source code.
 */ function $9c6b3ec69362487e$var$toSource(func) {
    if (func != null) {
        try {
            return $9c6b3ec69362487e$var$funcToString.call(func);
        } catch (e) {}
        try {
            return func + "";
        } catch (e) {}
    }
    return "";
}
$9c6b3ec69362487e$exports = $9c6b3ec69362487e$var$toSource;


/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */ var $8360225fb63098b3$var$reRegExpChar = /[\\^$.*+?()[\]{}|]/g;
/** Used to detect host constructors (Safari). */ var $8360225fb63098b3$var$reIsHostCtor = /^\[object .+?Constructor\]$/;
/** Used for built-in method references. */ var $8360225fb63098b3$var$funcProto = Function.prototype, $8360225fb63098b3$var$objectProto = Object.prototype;
/** Used to resolve the decompiled source of functions. */ var $8360225fb63098b3$var$funcToString = $8360225fb63098b3$var$funcProto.toString;
/** Used to check objects for own properties. */ var $8360225fb63098b3$var$hasOwnProperty = $8360225fb63098b3$var$objectProto.hasOwnProperty;
/** Used to detect if a method is native. */ var $8360225fb63098b3$var$reIsNative = RegExp("^" + $8360225fb63098b3$var$funcToString.call($8360225fb63098b3$var$hasOwnProperty).replace($8360225fb63098b3$var$reRegExpChar, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$");
/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */ function $8360225fb63098b3$var$baseIsNative(value) {
    if (!$f9ff2e983beb6b86$exports(value) || $5e8d211f630cd46d$exports(value)) return false;
    var pattern = $004783abbde551e4$exports(value) ? $8360225fb63098b3$var$reIsNative : $8360225fb63098b3$var$reIsHostCtor;
    return pattern.test($9c6b3ec69362487e$exports(value));
}
$8360225fb63098b3$exports = $8360225fb63098b3$var$baseIsNative;


var $d50b255f8680c47a$exports = {};
/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */ function $d50b255f8680c47a$var$getValue(object, key) {
    return object == null ? undefined : object[key];
}
$d50b255f8680c47a$exports = $d50b255f8680c47a$var$getValue;


/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */ function $5037fd2e597c2a03$var$getNative(object, key) {
    var value = $d50b255f8680c47a$exports(object, key);
    return $8360225fb63098b3$exports(value) ? value : undefined;
}
$5037fd2e597c2a03$exports = $5037fd2e597c2a03$var$getNative;


/* Built-in method references that are verified to be native. */ var $e95343b7bf5d617b$var$nativeCreate = $5037fd2e597c2a03$exports(Object, "create");
$e95343b7bf5d617b$exports = $e95343b7bf5d617b$var$nativeCreate;


/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */ function $80f20c637ba11563$var$hashClear() {
    this.__data__ = $e95343b7bf5d617b$exports ? $e95343b7bf5d617b$exports(null) : {};
    this.size = 0;
}
$80f20c637ba11563$exports = $80f20c637ba11563$var$hashClear;


var $60a2188452e03a76$exports = {};
/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function $60a2188452e03a76$var$hashDelete(key) {
    var result = this.has(key) && delete this.__data__[key];
    this.size -= result ? 1 : 0;
    return result;
}
$60a2188452e03a76$exports = $60a2188452e03a76$var$hashDelete;


var $0ade0ffa62051a98$exports = {};

/** Used to stand-in for `undefined` hash values. */ var $0ade0ffa62051a98$var$HASH_UNDEFINED = "__lodash_hash_undefined__";
/** Used for built-in method references. */ var $0ade0ffa62051a98$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $0ade0ffa62051a98$var$hasOwnProperty = $0ade0ffa62051a98$var$objectProto.hasOwnProperty;
/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function $0ade0ffa62051a98$var$hashGet(key) {
    var data = this.__data__;
    if ($e95343b7bf5d617b$exports) {
        var result = data[key];
        return result === $0ade0ffa62051a98$var$HASH_UNDEFINED ? undefined : result;
    }
    return $0ade0ffa62051a98$var$hasOwnProperty.call(data, key) ? data[key] : undefined;
}
$0ade0ffa62051a98$exports = $0ade0ffa62051a98$var$hashGet;


var $0d7f9677a17b6bef$exports = {};

/** Used for built-in method references. */ var $0d7f9677a17b6bef$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $0d7f9677a17b6bef$var$hasOwnProperty = $0d7f9677a17b6bef$var$objectProto.hasOwnProperty;
/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $0d7f9677a17b6bef$var$hashHas(key) {
    var data = this.__data__;
    return $e95343b7bf5d617b$exports ? data[key] !== undefined : $0d7f9677a17b6bef$var$hasOwnProperty.call(data, key);
}
$0d7f9677a17b6bef$exports = $0d7f9677a17b6bef$var$hashHas;


var $d33db65186b62952$exports = {};

/** Used to stand-in for `undefined` hash values. */ var $d33db65186b62952$var$HASH_UNDEFINED = "__lodash_hash_undefined__";
/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */ function $d33db65186b62952$var$hashSet(key, value) {
    var data = this.__data__;
    this.size += this.has(key) ? 0 : 1;
    data[key] = $e95343b7bf5d617b$exports && value === undefined ? $d33db65186b62952$var$HASH_UNDEFINED : value;
    return this;
}
$d33db65186b62952$exports = $d33db65186b62952$var$hashSet;


/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function $8d50e526a9e9b7fa$var$Hash(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
// Add methods to `Hash`.
$8d50e526a9e9b7fa$var$Hash.prototype.clear = $80f20c637ba11563$exports;
$8d50e526a9e9b7fa$var$Hash.prototype["delete"] = $60a2188452e03a76$exports;
$8d50e526a9e9b7fa$var$Hash.prototype.get = $0ade0ffa62051a98$exports;
$8d50e526a9e9b7fa$var$Hash.prototype.has = $0d7f9677a17b6bef$exports;
$8d50e526a9e9b7fa$var$Hash.prototype.set = $d33db65186b62952$exports;
$8d50e526a9e9b7fa$exports = $8d50e526a9e9b7fa$var$Hash;


var $dd14efc87ba1cd5b$exports = {};
var $83df40714bf7006e$exports = {};
/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */ function $83df40714bf7006e$var$listCacheClear() {
    this.__data__ = [];
    this.size = 0;
}
$83df40714bf7006e$exports = $83df40714bf7006e$var$listCacheClear;


var $d22fe27824ff9351$exports = {};
var $87257b05f5d9ad81$exports = {};
var $50557587dab070a0$exports = {};
/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */ function $50557587dab070a0$var$eq(value, other) {
    return value === other || value !== value && other !== other;
}
$50557587dab070a0$exports = $50557587dab070a0$var$eq;


/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */ function $87257b05f5d9ad81$var$assocIndexOf(array, key) {
    var length = array.length;
    while(length--){
        if ($50557587dab070a0$exports(array[length][0], key)) return length;
    }
    return -1;
}
$87257b05f5d9ad81$exports = $87257b05f5d9ad81$var$assocIndexOf;


/** Used for built-in method references. */ var $d22fe27824ff9351$var$arrayProto = Array.prototype;
/** Built-in value references. */ var $d22fe27824ff9351$var$splice = $d22fe27824ff9351$var$arrayProto.splice;
/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function $d22fe27824ff9351$var$listCacheDelete(key) {
    var data = this.__data__, index = $87257b05f5d9ad81$exports(data, key);
    if (index < 0) return false;
    var lastIndex = data.length - 1;
    if (index == lastIndex) data.pop();
    else $d22fe27824ff9351$var$splice.call(data, index, 1);
    --this.size;
    return true;
}
$d22fe27824ff9351$exports = $d22fe27824ff9351$var$listCacheDelete;


var $b2e6263d81cdc1b3$exports = {};

/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function $b2e6263d81cdc1b3$var$listCacheGet(key) {
    var data = this.__data__, index = $87257b05f5d9ad81$exports(data, key);
    return index < 0 ? undefined : data[index][1];
}
$b2e6263d81cdc1b3$exports = $b2e6263d81cdc1b3$var$listCacheGet;


var $29e2bc7b7348833e$exports = {};

/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $29e2bc7b7348833e$var$listCacheHas(key) {
    return $87257b05f5d9ad81$exports(this.__data__, key) > -1;
}
$29e2bc7b7348833e$exports = $29e2bc7b7348833e$var$listCacheHas;


var $ff9311500b60ab72$exports = {};

/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */ function $ff9311500b60ab72$var$listCacheSet(key, value) {
    var data = this.__data__, index = $87257b05f5d9ad81$exports(data, key);
    if (index < 0) {
        ++this.size;
        data.push([
            key,
            value
        ]);
    } else data[index][1] = value;
    return this;
}
$ff9311500b60ab72$exports = $ff9311500b60ab72$var$listCacheSet;


/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function $dd14efc87ba1cd5b$var$ListCache(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
// Add methods to `ListCache`.
$dd14efc87ba1cd5b$var$ListCache.prototype.clear = $83df40714bf7006e$exports;
$dd14efc87ba1cd5b$var$ListCache.prototype["delete"] = $d22fe27824ff9351$exports;
$dd14efc87ba1cd5b$var$ListCache.prototype.get = $b2e6263d81cdc1b3$exports;
$dd14efc87ba1cd5b$var$ListCache.prototype.has = $29e2bc7b7348833e$exports;
$dd14efc87ba1cd5b$var$ListCache.prototype.set = $ff9311500b60ab72$exports;
$dd14efc87ba1cd5b$exports = $dd14efc87ba1cd5b$var$ListCache;


var $19b02faa57603249$exports = {};


var $23YZo = parcelRequire("23YZo");
/* Built-in method references that are verified to be native. */ var $19b02faa57603249$var$Map = $5037fd2e597c2a03$exports($23YZo, "Map");
$19b02faa57603249$exports = $19b02faa57603249$var$Map;


/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */ function $df2cd4bc93f21548$var$mapCacheClear() {
    this.size = 0;
    this.__data__ = {
        "hash": new $8d50e526a9e9b7fa$exports,
        "map": new ($19b02faa57603249$exports || $dd14efc87ba1cd5b$exports),
        "string": new $8d50e526a9e9b7fa$exports
    };
}
$df2cd4bc93f21548$exports = $df2cd4bc93f21548$var$mapCacheClear;


var $44464964ade29765$exports = {};
var $c0b23e5f03c2595b$exports = {};
var $09c4668903e66c1d$exports = {};
/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */ function $09c4668903e66c1d$var$isKeyable(value) {
    var type = typeof value;
    return type == "string" || type == "number" || type == "symbol" || type == "boolean" ? value !== "__proto__" : value === null;
}
$09c4668903e66c1d$exports = $09c4668903e66c1d$var$isKeyable;


/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */ function $c0b23e5f03c2595b$var$getMapData(map, key) {
    var data = map.__data__;
    return $09c4668903e66c1d$exports(key) ? data[typeof key == "string" ? "string" : "hash"] : data.map;
}
$c0b23e5f03c2595b$exports = $c0b23e5f03c2595b$var$getMapData;


/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function $44464964ade29765$var$mapCacheDelete(key) {
    var result = $c0b23e5f03c2595b$exports(this, key)["delete"](key);
    this.size -= result ? 1 : 0;
    return result;
}
$44464964ade29765$exports = $44464964ade29765$var$mapCacheDelete;


var $ba80406da5503086$exports = {};

/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function $ba80406da5503086$var$mapCacheGet(key) {
    return $c0b23e5f03c2595b$exports(this, key).get(key);
}
$ba80406da5503086$exports = $ba80406da5503086$var$mapCacheGet;


var $d3abe18ea687dfb7$exports = {};

/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $d3abe18ea687dfb7$var$mapCacheHas(key) {
    return $c0b23e5f03c2595b$exports(this, key).has(key);
}
$d3abe18ea687dfb7$exports = $d3abe18ea687dfb7$var$mapCacheHas;


var $347643e3dcfcc207$exports = {};

/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */ function $347643e3dcfcc207$var$mapCacheSet(key, value) {
    var data = $c0b23e5f03c2595b$exports(this, key), size = data.size;
    data.set(key, value);
    this.size += data.size == size ? 0 : 1;
    return this;
}
$347643e3dcfcc207$exports = $347643e3dcfcc207$var$mapCacheSet;


/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function $4902f64a16640324$var$MapCache(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
// Add methods to `MapCache`.
$4902f64a16640324$var$MapCache.prototype.clear = $df2cd4bc93f21548$exports;
$4902f64a16640324$var$MapCache.prototype["delete"] = $44464964ade29765$exports;
$4902f64a16640324$var$MapCache.prototype.get = $ba80406da5503086$exports;
$4902f64a16640324$var$MapCache.prototype.has = $d3abe18ea687dfb7$exports;
$4902f64a16640324$var$MapCache.prototype.set = $347643e3dcfcc207$exports;
$4902f64a16640324$exports = $4902f64a16640324$var$MapCache;


/** Error message constants. */ var $17f5c88c594eac51$var$FUNC_ERROR_TEXT = "Expected a function";
/**
 * Creates a function that memoizes the result of `func`. If `resolver` is
 * provided, it determines the cache key for storing the result based on the
 * arguments provided to the memoized function. By default, the first argument
 * provided to the memoized function is used as the map cache key. The `func`
 * is invoked with the `this` binding of the memoized function.
 *
 * **Note:** The cache is exposed as the `cache` property on the memoized
 * function. Its creation may be customized by replacing the `_.memoize.Cache`
 * constructor with one whose instances implement the
 * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
 * method interface of `clear`, `delete`, `get`, `has`, and `set`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to have its output memoized.
 * @param {Function} [resolver] The function to resolve the cache key.
 * @returns {Function} Returns the new memoized function.
 * @example
 *
 * var object = { 'a': 1, 'b': 2 };
 * var other = { 'c': 3, 'd': 4 };
 *
 * var values = _.memoize(_.values);
 * values(object);
 * // => [1, 2]
 *
 * values(other);
 * // => [3, 4]
 *
 * object.a = 2;
 * values(object);
 * // => [1, 2]
 *
 * // Modify the result cache.
 * values.cache.set(object, ['a', 'b']);
 * values(object);
 * // => ['a', 'b']
 *
 * // Replace `_.memoize.Cache`.
 * _.memoize.Cache = WeakMap;
 */ function $17f5c88c594eac51$var$memoize(func, resolver) {
    if (typeof func != "function" || resolver != null && typeof resolver != "function") throw new TypeError($17f5c88c594eac51$var$FUNC_ERROR_TEXT);
    var memoized = function() {
        var args = arguments, key = resolver ? resolver.apply(this, args) : args[0], cache = memoized.cache;
        if (cache.has(key)) return cache.get(key);
        var result = func.apply(this, args);
        memoized.cache = cache.set(key, result) || cache;
        return result;
    };
    memoized.cache = new ($17f5c88c594eac51$var$memoize.Cache || $4902f64a16640324$exports);
    return memoized;
}
// Expose `MapCache`.
$17f5c88c594eac51$var$memoize.Cache = $4902f64a16640324$exports;
$17f5c88c594eac51$exports = $17f5c88c594eac51$var$memoize;


/** Used as the maximum memoize cache size. */ var $6aae515404bf5dd2$var$MAX_MEMOIZE_SIZE = 500;
/**
 * A specialized version of `_.memoize` which clears the memoized function's
 * cache when it exceeds `MAX_MEMOIZE_SIZE`.
 *
 * @private
 * @param {Function} func The function to have its output memoized.
 * @returns {Function} Returns the new memoized function.
 */ function $6aae515404bf5dd2$var$memoizeCapped(func) {
    var result = $17f5c88c594eac51$exports(func, function(key) {
        if (cache.size === $6aae515404bf5dd2$var$MAX_MEMOIZE_SIZE) cache.clear();
        return key;
    });
    var cache = result.cache;
    return result;
}
$6aae515404bf5dd2$exports = $6aae515404bf5dd2$var$memoizeCapped;


/** Used to match property names within property paths. */ var $f9135a667399ede4$var$rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;
/** Used to match backslashes in property paths. */ var $f9135a667399ede4$var$reEscapeChar = /\\(\\)?/g;
/**
 * Converts `string` to a property path array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the property path array.
 */ var $f9135a667399ede4$var$stringToPath = $6aae515404bf5dd2$exports(function(string) {
    var result = [];
    if (string.charCodeAt(0) === 46 /* . */ ) result.push("");
    string.replace($f9135a667399ede4$var$rePropName, function(match, number, quote, subString) {
        result.push(quote ? subString.replace($f9135a667399ede4$var$reEscapeChar, "$1") : number || match);
    });
    return result;
});
$f9135a667399ede4$exports = $f9135a667399ede4$var$stringToPath;


var $f5d9385a9cc7e413$exports = {};
var $f16f644742c27c21$exports = {};

var $d26d80da1ba3948c$exports = {};
/**
 * A specialized version of `_.map` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */ function $d26d80da1ba3948c$var$arrayMap(array, iteratee) {
    var index = -1, length = array == null ? 0 : array.length, result = Array(length);
    while(++index < length)result[index] = iteratee(array[index], index, array);
    return result;
}
$d26d80da1ba3948c$exports = $d26d80da1ba3948c$var$arrayMap;




/** Used as references for various `Number` constants. */ var $f16f644742c27c21$var$INFINITY = 1 / 0;
/** Used to convert symbols to primitives and strings. */ var $f16f644742c27c21$var$symbolProto = $3ba72ebe7e4419b5$exports ? $3ba72ebe7e4419b5$exports.prototype : undefined, $f16f644742c27c21$var$symbolToString = $f16f644742c27c21$var$symbolProto ? $f16f644742c27c21$var$symbolProto.toString : undefined;
/**
 * The base implementation of `_.toString` which doesn't convert nullish
 * values to empty strings.
 *
 * @private
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 */ function $f16f644742c27c21$var$baseToString(value) {
    // Exit early for strings to avoid a performance hit in some environments.
    if (typeof value == "string") return value;
    if ($0488fde9aa355453$exports(value)) // Recursively convert values (susceptible to call stack limits).
    return $d26d80da1ba3948c$exports(value, $f16f644742c27c21$var$baseToString) + "";
    if ($6b5a5095e0934938$exports(value)) return $f16f644742c27c21$var$symbolToString ? $f16f644742c27c21$var$symbolToString.call(value) : "";
    var result = value + "";
    return result == "0" && 1 / value == -$f16f644742c27c21$var$INFINITY ? "-0" : result;
}
$f16f644742c27c21$exports = $f16f644742c27c21$var$baseToString;


/**
 * Converts `value` to a string. An empty string is returned for `null`
 * and `undefined` values. The sign of `-0` is preserved.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 * @example
 *
 * _.toString(null);
 * // => ''
 *
 * _.toString(-0);
 * // => '-0'
 *
 * _.toString([1, 2, 3]);
 * // => '1,2,3'
 */ function $f5d9385a9cc7e413$var$toString(value) {
    return value == null ? "" : $f16f644742c27c21$exports(value);
}
$f5d9385a9cc7e413$exports = $f5d9385a9cc7e413$var$toString;


/**
 * Casts `value` to a path array if it's not one.
 *
 * @private
 * @param {*} value The value to inspect.
 * @param {Object} [object] The object to query keys on.
 * @returns {Array} Returns the cast property path array.
 */ function $38afcbfab85a0553$var$castPath(value, object) {
    if ($0488fde9aa355453$exports(value)) return value;
    return $03e9beb856e9b4cd$exports(value, object) ? [
        value
    ] : $f9135a667399ede4$exports($f5d9385a9cc7e413$exports(value));
}
$38afcbfab85a0553$exports = $38afcbfab85a0553$var$castPath;


var $7d0c6fd0eb26be0e$exports = {};
var $fb8f823cdc90f511$exports = {};


/** `Object#toString` result references. */ var $fb8f823cdc90f511$var$argsTag = "[object Arguments]";
/**
 * The base implementation of `_.isArguments`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 */ function $fb8f823cdc90f511$var$baseIsArguments(value) {
    return $61269cf1f3e020be$exports(value) && $a7f8a2555793d7d3$exports(value) == $fb8f823cdc90f511$var$argsTag;
}
$fb8f823cdc90f511$exports = $fb8f823cdc90f511$var$baseIsArguments;



/** Used for built-in method references. */ var $7d0c6fd0eb26be0e$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $7d0c6fd0eb26be0e$var$hasOwnProperty = $7d0c6fd0eb26be0e$var$objectProto.hasOwnProperty;
/** Built-in value references. */ var $7d0c6fd0eb26be0e$var$propertyIsEnumerable = $7d0c6fd0eb26be0e$var$objectProto.propertyIsEnumerable;
/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */ var $7d0c6fd0eb26be0e$var$isArguments = $fb8f823cdc90f511$exports(function() {
    return arguments;
}()) ? $fb8f823cdc90f511$exports : function(value) {
    return $61269cf1f3e020be$exports(value) && $7d0c6fd0eb26be0e$var$hasOwnProperty.call(value, "callee") && !$7d0c6fd0eb26be0e$var$propertyIsEnumerable.call(value, "callee");
};
$7d0c6fd0eb26be0e$exports = $7d0c6fd0eb26be0e$var$isArguments;



var $d83738e053b5eb08$exports = {};
/** Used as references for various `Number` constants. */ var $d83738e053b5eb08$var$MAX_SAFE_INTEGER = 9007199254740991;
/** Used to detect unsigned integer values. */ var $d83738e053b5eb08$var$reIsUint = /^(?:0|[1-9]\d*)$/;
/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */ function $d83738e053b5eb08$var$isIndex(value, length) {
    var type = typeof value;
    length = length == null ? $d83738e053b5eb08$var$MAX_SAFE_INTEGER : length;
    return !!length && (type == "number" || type != "symbol" && $d83738e053b5eb08$var$reIsUint.test(value)) && value > -1 && value % 1 == 0 && value < length;
}
$d83738e053b5eb08$exports = $d83738e053b5eb08$var$isIndex;


var $15d215b19bcf1187$exports = {};
/** Used as references for various `Number` constants. */ var $15d215b19bcf1187$var$MAX_SAFE_INTEGER = 9007199254740991;
/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */ function $15d215b19bcf1187$var$isLength(value) {
    return typeof value == "number" && value > -1 && value % 1 == 0 && value <= $15d215b19bcf1187$var$MAX_SAFE_INTEGER;
}
$15d215b19bcf1187$exports = $15d215b19bcf1187$var$isLength;


var $4d60aa8c33155976$exports = {};

/** Used as references for various `Number` constants. */ var $4d60aa8c33155976$var$INFINITY = 1 / 0;
/**
 * Converts `value` to a string key if it's not a string or symbol.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {string|symbol} Returns the key.
 */ function $4d60aa8c33155976$var$toKey(value) {
    if (typeof value == "string" || $6b5a5095e0934938$exports(value)) return value;
    var result = value + "";
    return result == "0" && 1 / value == -$4d60aa8c33155976$var$INFINITY ? "-0" : result;
}
$4d60aa8c33155976$exports = $4d60aa8c33155976$var$toKey;


/**
 * Checks if `path` exists on `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @param {Function} hasFunc The function to check properties.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 */ function $85aaea8f77d790ae$var$hasPath(object, path, hasFunc) {
    path = $38afcbfab85a0553$exports(path, object);
    var index = -1, length = path.length, result = false;
    while(++index < length){
        var key = $4d60aa8c33155976$exports(path[index]);
        if (!(result = object != null && hasFunc(object, key))) break;
        object = object[key];
    }
    if (result || ++index != length) return result;
    length = object == null ? 0 : object.length;
    return !!length && $15d215b19bcf1187$exports(length) && $d83738e053b5eb08$exports(key, length) && ($0488fde9aa355453$exports(object) || $7d0c6fd0eb26be0e$exports(object));
}
$85aaea8f77d790ae$exports = $85aaea8f77d790ae$var$hasPath;


/**
 * Checks if `path` is a direct property of `object`.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 * @example
 *
 * var object = { 'a': { 'b': 2 } };
 * var other = _.create({ 'a': _.create({ 'b': 2 }) });
 *
 * _.has(object, 'a');
 * // => true
 *
 * _.has(object, 'a.b');
 * // => true
 *
 * _.has(object, ['a', 'b']);
 * // => true
 *
 * _.has(other, 'a');
 * // => false
 */ function $e21135b6db383fe3$var$has(object, path) {
    return object != null && $85aaea8f77d790ae$exports(object, path, $3c47f0745c8ad323$exports);
}
$e21135b6db383fe3$exports = $e21135b6db383fe3$var$has;


const $1d4517ced724be00$var$isSchema = (obj)=>obj && obj.__isYupSchema__;
var $1d4517ced724be00$export$2e2bcd8739ae039 = $1d4517ced724be00$var$isSchema;


class $7e653e8008789a27$var$Condition {
    constructor(refs, options){
        this.fn = void 0;
        this.refs = refs;
        this.refs = refs;
        if (typeof options === "function") {
            this.fn = options;
            return;
        }
        if (!(0, (/*@__PURE__*/$parcel$interopDefault($e21135b6db383fe3$exports)))(options, "is")) throw new TypeError("`is:` is required for `when()` conditions");
        if (!options.then && !options.otherwise) throw new TypeError("either `then:` or `otherwise:` is required for `when()` conditions");
        let { is: is, then: then, otherwise: otherwise } = options;
        let check = typeof is === "function" ? is : (...values)=>values.every((value)=>value === is);
        this.fn = function(...args) {
            let options = args.pop();
            let schema = args.pop();
            let branch = check(...args) ? then : otherwise;
            if (!branch) return undefined;
            if (typeof branch === "function") return branch(schema);
            return schema.concat(branch.resolve(options));
        };
    }
    resolve(base, options) {
        let values = this.refs.map((ref)=>ref.getValue(options == null ? void 0 : options.value, options == null ? void 0 : options.parent, options == null ? void 0 : options.context));
        let schema = this.fn.apply(base, values.concat(base, options));
        if (schema === undefined || schema === base) return base;
        if (!(0, $1d4517ced724be00$export$2e2bcd8739ae039)(schema)) throw new TypeError("conditions must return a schema object");
        return schema.resolve(options);
    }
}
var $7e653e8008789a27$export$2e2bcd8739ae039 = $7e653e8008789a27$var$Condition;



function $245da59127fdc582$export$2e2bcd8739ae039(value) {
    return value == null ? [] : [].concat(value);
}


function $d2e70d35996a7daf$var$_extends() {
    $d2e70d35996a7daf$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $d2e70d35996a7daf$var$_extends.apply(this, arguments);
}
let $d2e70d35996a7daf$var$strReg = /\$\{\s*(\w+)\s*\}/g;
class $d2e70d35996a7daf$export$2e2bcd8739ae039 extends Error {
    static formatError(message, params) {
        const path = params.label || params.path || "this";
        if (path !== params.path) params = $d2e70d35996a7daf$var$_extends({}, params, {
            path: path
        });
        if (typeof message === "string") return message.replace($d2e70d35996a7daf$var$strReg, (_, key)=>(0, $3bcbbcae986c2431$export$2e2bcd8739ae039)(params[key]));
        if (typeof message === "function") return message(params);
        return message;
    }
    static isError(err) {
        return err && err.name === "ValidationError";
    }
    constructor(errorOrErrors, value, field, type){
        super();
        this.value = void 0;
        this.path = void 0;
        this.type = void 0;
        this.errors = void 0;
        this.params = void 0;
        this.inner = void 0;
        this.name = "ValidationError";
        this.value = value;
        this.path = field;
        this.type = type;
        this.errors = [];
        this.inner = [];
        (0, $245da59127fdc582$export$2e2bcd8739ae039)(errorOrErrors).forEach((err)=>{
            if ($d2e70d35996a7daf$export$2e2bcd8739ae039.isError(err)) {
                this.errors.push(...err.errors);
                this.inner = this.inner.concat(err.inner.length ? err.inner : err);
            } else this.errors.push(err);
        });
        this.message = this.errors.length > 1 ? `${this.errors.length} errors occurred` : this.errors[0];
        if (Error.captureStackTrace) Error.captureStackTrace(this, $d2e70d35996a7daf$export$2e2bcd8739ae039);
    }
}


const $d2d0e6ad55c8832e$var$once = (cb)=>{
    let fired = false;
    return (...args)=>{
        if (fired) return;
        fired = true;
        cb(...args);
    };
};
function $d2d0e6ad55c8832e$export$2e2bcd8739ae039(options, cb) {
    let { endEarly: endEarly, tests: tests, args: args, value: value, errors: errors, sort: sort, path: path } = options;
    let callback = $d2d0e6ad55c8832e$var$once(cb);
    let count = tests.length;
    const nestedErrors = [];
    errors = errors ? errors : [];
    if (!count) return errors.length ? callback(new (0, $d2e70d35996a7daf$export$2e2bcd8739ae039)(errors, value, path)) : callback(null, value);
    for(let i = 0; i < tests.length; i++){
        const test = tests[i];
        test(args, function finishTestRun(err) {
            if (err) {
                // always return early for non validation errors
                if (!(0, $d2e70d35996a7daf$export$2e2bcd8739ae039).isError(err)) return callback(err, value);
                if (endEarly) {
                    err.value = value;
                    return callback(err, value);
                }
                nestedErrors.push(err);
            }
            if (--count <= 0) {
                if (nestedErrors.length) {
                    if (sort) nestedErrors.sort(sort); //show parent errors after the nested ones: name.first, name
                    if (errors.length) nestedErrors.push(...errors);
                    errors = nestedErrors;
                }
                if (errors.length) {
                    callback(new (0, $d2e70d35996a7daf$export$2e2bcd8739ae039)(errors, value, path), value);
                    return;
                }
                callback(null, value);
            }
        });
    }
}


var $17211428bc2045c4$exports = {};
var $96b401257ea00d24$exports = {};
var $31e24313ace94404$exports = {};

var $31e24313ace94404$var$defineProperty = function() {
    try {
        var func = $5037fd2e597c2a03$exports(Object, "defineProperty");
        func({}, "", {});
        return func;
    } catch (e) {}
}();
$31e24313ace94404$exports = $31e24313ace94404$var$defineProperty;


/**
 * The base implementation of `assignValue` and `assignMergeValue` without
 * value checks.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */ function $96b401257ea00d24$var$baseAssignValue(object, key, value) {
    if (key == "__proto__" && $31e24313ace94404$exports) $31e24313ace94404$exports(object, key, {
        "configurable": true,
        "enumerable": true,
        "value": value,
        "writable": true
    });
    else object[key] = value;
}
$96b401257ea00d24$exports = $96b401257ea00d24$var$baseAssignValue;


var $34edfba366a0cfa1$exports = {};
var $9f0778b809a8c692$exports = {};
var $e7bbde6376f4568a$exports = {};
/**
 * Creates a base function for methods like `_.forIn` and `_.forOwn`.
 *
 * @private
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */ function $e7bbde6376f4568a$var$createBaseFor(fromRight) {
    return function(object, iteratee, keysFunc) {
        var index = -1, iterable = Object(object), props = keysFunc(object), length = props.length;
        while(length--){
            var key = props[fromRight ? length : ++index];
            if (iteratee(iterable[key], key, iterable) === false) break;
        }
        return object;
    };
}
$e7bbde6376f4568a$exports = $e7bbde6376f4568a$var$createBaseFor;


/**
 * The base implementation of `baseForOwn` which iterates over `object`
 * properties returned by `keysFunc` and invokes `iteratee` for each property.
 * Iteratee functions may exit iteration early by explicitly returning `false`.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @returns {Object} Returns `object`.
 */ var $9f0778b809a8c692$var$baseFor = $e7bbde6376f4568a$exports();
$9f0778b809a8c692$exports = $9f0778b809a8c692$var$baseFor;


var $08f0eaf3fbcb2fde$exports = {};
var $64568844439edb7f$exports = {};
var $b14d62a510ae7f2d$exports = {};
/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */ function $b14d62a510ae7f2d$var$baseTimes(n, iteratee) {
    var index = -1, result = Array(n);
    while(++index < n)result[index] = iteratee(index);
    return result;
}
$b14d62a510ae7f2d$exports = $b14d62a510ae7f2d$var$baseTimes;





var $f504n = parcelRequire("f504n");

var $156c3727697ab085$exports = {};
var $9d076681a0e29d68$exports = {};



/** `Object#toString` result references. */ var $9d076681a0e29d68$var$argsTag = "[object Arguments]", $9d076681a0e29d68$var$arrayTag = "[object Array]", $9d076681a0e29d68$var$boolTag = "[object Boolean]", $9d076681a0e29d68$var$dateTag = "[object Date]", $9d076681a0e29d68$var$errorTag = "[object Error]", $9d076681a0e29d68$var$funcTag = "[object Function]", $9d076681a0e29d68$var$mapTag = "[object Map]", $9d076681a0e29d68$var$numberTag = "[object Number]", $9d076681a0e29d68$var$objectTag = "[object Object]", $9d076681a0e29d68$var$regexpTag = "[object RegExp]", $9d076681a0e29d68$var$setTag = "[object Set]", $9d076681a0e29d68$var$stringTag = "[object String]", $9d076681a0e29d68$var$weakMapTag = "[object WeakMap]";
var $9d076681a0e29d68$var$arrayBufferTag = "[object ArrayBuffer]", $9d076681a0e29d68$var$dataViewTag = "[object DataView]", $9d076681a0e29d68$var$float32Tag = "[object Float32Array]", $9d076681a0e29d68$var$float64Tag = "[object Float64Array]", $9d076681a0e29d68$var$int8Tag = "[object Int8Array]", $9d076681a0e29d68$var$int16Tag = "[object Int16Array]", $9d076681a0e29d68$var$int32Tag = "[object Int32Array]", $9d076681a0e29d68$var$uint8Tag = "[object Uint8Array]", $9d076681a0e29d68$var$uint8ClampedTag = "[object Uint8ClampedArray]", $9d076681a0e29d68$var$uint16Tag = "[object Uint16Array]", $9d076681a0e29d68$var$uint32Tag = "[object Uint32Array]";
/** Used to identify `toStringTag` values of typed arrays. */ var $9d076681a0e29d68$var$typedArrayTags = {};
$9d076681a0e29d68$var$typedArrayTags[$9d076681a0e29d68$var$float32Tag] = $9d076681a0e29d68$var$typedArrayTags[$9d076681a0e29d68$var$float64Tag] = $9d076681a0e29d68$var$typedArrayTags[$9d076681a0e29d68$var$int8Tag] = $9d076681a0e29d68$var$typedArrayTags[$9d076681a0e29d68$var$int16Tag] = $9d076681a0e29d68$var$typedArrayTags[$9d076681a0e29d68$var$int32Tag] = $9d076681a0e29d68$var$typedArrayTags[$9d076681a0e29d68$var$uint8Tag] = $9d076681a0e29d68$var$typedArrayTags[$9d076681a0e29d68$var$uint8ClampedTag] = $9d076681a0e29d68$var$typedArrayTags[$9d076681a0e29d68$var$uint16Tag] = $9d076681a0e29d68$var$typedArrayTags[$9d076681a0e29d68$var$uint32Tag] = true;
$9d076681a0e29d68$var$typedArrayTags[$9d076681a0e29d68$var$argsTag] = $9d076681a0e29d68$var$typedArrayTags[$9d076681a0e29d68$var$arrayTag] = $9d076681a0e29d68$var$typedArrayTags[$9d076681a0e29d68$var$arrayBufferTag] = $9d076681a0e29d68$var$typedArrayTags[$9d076681a0e29d68$var$boolTag] = $9d076681a0e29d68$var$typedArrayTags[$9d076681a0e29d68$var$dataViewTag] = $9d076681a0e29d68$var$typedArrayTags[$9d076681a0e29d68$var$dateTag] = $9d076681a0e29d68$var$typedArrayTags[$9d076681a0e29d68$var$errorTag] = $9d076681a0e29d68$var$typedArrayTags[$9d076681a0e29d68$var$funcTag] = $9d076681a0e29d68$var$typedArrayTags[$9d076681a0e29d68$var$mapTag] = $9d076681a0e29d68$var$typedArrayTags[$9d076681a0e29d68$var$numberTag] = $9d076681a0e29d68$var$typedArrayTags[$9d076681a0e29d68$var$objectTag] = $9d076681a0e29d68$var$typedArrayTags[$9d076681a0e29d68$var$regexpTag] = $9d076681a0e29d68$var$typedArrayTags[$9d076681a0e29d68$var$setTag] = $9d076681a0e29d68$var$typedArrayTags[$9d076681a0e29d68$var$stringTag] = $9d076681a0e29d68$var$typedArrayTags[$9d076681a0e29d68$var$weakMapTag] = false;
/**
 * The base implementation of `_.isTypedArray` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 */ function $9d076681a0e29d68$var$baseIsTypedArray(value) {
    return $61269cf1f3e020be$exports(value) && $15d215b19bcf1187$exports(value.length) && !!$9d076681a0e29d68$var$typedArrayTags[$a7f8a2555793d7d3$exports(value)];
}
$9d076681a0e29d68$exports = $9d076681a0e29d68$var$baseIsTypedArray;


var $692cb5474f422969$exports = {};
/**
 * The base implementation of `_.unary` without support for storing metadata.
 *
 * @private
 * @param {Function} func The function to cap arguments for.
 * @returns {Function} Returns the new capped function.
 */ function $692cb5474f422969$var$baseUnary(func) {
    return function(value) {
        return func(value);
    };
}
$692cb5474f422969$exports = $692cb5474f422969$var$baseUnary;



var $jIny1 = parcelRequire("jIny1");
/* Node.js helper references. */ var $156c3727697ab085$var$nodeIsTypedArray = $jIny1 && $jIny1.isTypedArray;
/**
 * Checks if `value` is classified as a typed array.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 * @example
 *
 * _.isTypedArray(new Uint8Array);
 * // => true
 *
 * _.isTypedArray([]);
 * // => false
 */ var $156c3727697ab085$var$isTypedArray = $156c3727697ab085$var$nodeIsTypedArray ? $692cb5474f422969$exports($156c3727697ab085$var$nodeIsTypedArray) : $9d076681a0e29d68$exports;
$156c3727697ab085$exports = $156c3727697ab085$var$isTypedArray;


/** Used for built-in method references. */ var $64568844439edb7f$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $64568844439edb7f$var$hasOwnProperty = $64568844439edb7f$var$objectProto.hasOwnProperty;
/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */ function $64568844439edb7f$var$arrayLikeKeys(value, inherited) {
    var isArr = $0488fde9aa355453$exports(value), isArg = !isArr && $7d0c6fd0eb26be0e$exports(value), isBuff = !isArr && !isArg && $f504n(value), isType = !isArr && !isArg && !isBuff && $156c3727697ab085$exports(value), skipIndexes = isArr || isArg || isBuff || isType, result = skipIndexes ? $b14d62a510ae7f2d$exports(value.length, String) : [], length = result.length;
    for(var key in value)if ((inherited || $64568844439edb7f$var$hasOwnProperty.call(value, key)) && !(skipIndexes && // Safari 9 has enumerable `arguments.length` in strict mode.
    (key == "length" || // Node.js 0.10 has enumerable non-index properties on buffers.
    isBuff && (key == "offset" || key == "parent") || // PhantomJS 2 has enumerable non-index properties on typed arrays.
    isType && (key == "buffer" || key == "byteLength" || key == "byteOffset") || // Skip index properties.
    $d83738e053b5eb08$exports(key, length)))) result.push(key);
    return result;
}
$64568844439edb7f$exports = $64568844439edb7f$var$arrayLikeKeys;


var $e811d2e210fb58cc$exports = {};
var $292432068be14a79$exports = {};
/** Used for built-in method references. */ var $292432068be14a79$var$objectProto = Object.prototype;
/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */ function $292432068be14a79$var$isPrototype(value) {
    var Ctor = value && value.constructor, proto = typeof Ctor == "function" && Ctor.prototype || $292432068be14a79$var$objectProto;
    return value === proto;
}
$292432068be14a79$exports = $292432068be14a79$var$isPrototype;


var $0b26005314403d97$exports = {};
var $ff813e49bf3cca3d$exports = {};
/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */ function $ff813e49bf3cca3d$var$overArg(func, transform) {
    return function(arg) {
        return func(transform(arg));
    };
}
$ff813e49bf3cca3d$exports = $ff813e49bf3cca3d$var$overArg;


/* Built-in method references for those with the same name as other `lodash` methods. */ var $0b26005314403d97$var$nativeKeys = $ff813e49bf3cca3d$exports(Object.keys, Object);
$0b26005314403d97$exports = $0b26005314403d97$var$nativeKeys;


/** Used for built-in method references. */ var $e811d2e210fb58cc$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $e811d2e210fb58cc$var$hasOwnProperty = $e811d2e210fb58cc$var$objectProto.hasOwnProperty;
/**
 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */ function $e811d2e210fb58cc$var$baseKeys(object) {
    if (!$292432068be14a79$exports(object)) return $0b26005314403d97$exports(object);
    var result = [];
    for(var key in Object(object))if ($e811d2e210fb58cc$var$hasOwnProperty.call(object, key) && key != "constructor") result.push(key);
    return result;
}
$e811d2e210fb58cc$exports = $e811d2e210fb58cc$var$baseKeys;


var $ac2c42592aa05543$exports = {};


/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */ function $ac2c42592aa05543$var$isArrayLike(value) {
    return value != null && $15d215b19bcf1187$exports(value.length) && !$004783abbde551e4$exports(value);
}
$ac2c42592aa05543$exports = $ac2c42592aa05543$var$isArrayLike;


/**
 * Creates an array of the own enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects. See the
 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * for more details.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keys(new Foo);
 * // => ['a', 'b'] (iteration order is not guaranteed)
 *
 * _.keys('hi');
 * // => ['0', '1']
 */ function $08f0eaf3fbcb2fde$var$keys(object) {
    return $ac2c42592aa05543$exports(object) ? $64568844439edb7f$exports(object) : $e811d2e210fb58cc$exports(object);
}
$08f0eaf3fbcb2fde$exports = $08f0eaf3fbcb2fde$var$keys;


/**
 * The base implementation of `_.forOwn` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Object} Returns `object`.
 */ function $34edfba366a0cfa1$var$baseForOwn(object, iteratee) {
    return object && $9f0778b809a8c692$exports(object, iteratee, $08f0eaf3fbcb2fde$exports);
}
$34edfba366a0cfa1$exports = $34edfba366a0cfa1$var$baseForOwn;


var $5aba4f6d9f8304a3$exports = {};
var $e780807e2b795134$exports = {};
var $ec073f38db6e7d54$exports = {};
var $bbb2d98cae25b61a$exports = {};

var $e8ee1d354807980a$exports = {};

/**
 * Removes all key-value entries from the stack.
 *
 * @private
 * @name clear
 * @memberOf Stack
 */ function $e8ee1d354807980a$var$stackClear() {
    this.__data__ = new $dd14efc87ba1cd5b$exports;
    this.size = 0;
}
$e8ee1d354807980a$exports = $e8ee1d354807980a$var$stackClear;


var $b2ddb9d63293f3a5$exports = {};
/**
 * Removes `key` and its value from the stack.
 *
 * @private
 * @name delete
 * @memberOf Stack
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function $b2ddb9d63293f3a5$var$stackDelete(key) {
    var data = this.__data__, result = data["delete"](key);
    this.size = data.size;
    return result;
}
$b2ddb9d63293f3a5$exports = $b2ddb9d63293f3a5$var$stackDelete;


var $80d0940a423a17dc$exports = {};
/**
 * Gets the stack value for `key`.
 *
 * @private
 * @name get
 * @memberOf Stack
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function $80d0940a423a17dc$var$stackGet(key) {
    return this.__data__.get(key);
}
$80d0940a423a17dc$exports = $80d0940a423a17dc$var$stackGet;


var $010f38d5d914cfa2$exports = {};
/**
 * Checks if a stack value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Stack
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $010f38d5d914cfa2$var$stackHas(key) {
    return this.__data__.has(key);
}
$010f38d5d914cfa2$exports = $010f38d5d914cfa2$var$stackHas;


var $9280d00f89f25fa9$exports = {};



/** Used as the size to enable large array optimizations. */ var $9280d00f89f25fa9$var$LARGE_ARRAY_SIZE = 200;
/**
 * Sets the stack `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Stack
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the stack cache instance.
 */ function $9280d00f89f25fa9$var$stackSet(key, value) {
    var data = this.__data__;
    if (data instanceof $dd14efc87ba1cd5b$exports) {
        var pairs = data.__data__;
        if (!$19b02faa57603249$exports || pairs.length < $9280d00f89f25fa9$var$LARGE_ARRAY_SIZE - 1) {
            pairs.push([
                key,
                value
            ]);
            this.size = ++data.size;
            return this;
        }
        data = this.__data__ = new $4902f64a16640324$exports(pairs);
    }
    data.set(key, value);
    this.size = data.size;
    return this;
}
$9280d00f89f25fa9$exports = $9280d00f89f25fa9$var$stackSet;


/**
 * Creates a stack cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function $bbb2d98cae25b61a$var$Stack(entries) {
    var data = this.__data__ = new $dd14efc87ba1cd5b$exports(entries);
    this.size = data.size;
}
// Add methods to `Stack`.
$bbb2d98cae25b61a$var$Stack.prototype.clear = $e8ee1d354807980a$exports;
$bbb2d98cae25b61a$var$Stack.prototype["delete"] = $b2ddb9d63293f3a5$exports;
$bbb2d98cae25b61a$var$Stack.prototype.get = $80d0940a423a17dc$exports;
$bbb2d98cae25b61a$var$Stack.prototype.has = $010f38d5d914cfa2$exports;
$bbb2d98cae25b61a$var$Stack.prototype.set = $9280d00f89f25fa9$exports;
$bbb2d98cae25b61a$exports = $bbb2d98cae25b61a$var$Stack;


var $769812b29c18141e$exports = {};
var $567f2dd161ebd4f6$exports = {};

var $1081bd3a2e361911$exports = {};
var $a29ccdc0f60e279e$exports = {};

var $dda8f7b6b589544e$exports = {};
/** Used to stand-in for `undefined` hash values. */ var $dda8f7b6b589544e$var$HASH_UNDEFINED = "__lodash_hash_undefined__";
/**
 * Adds `value` to the array cache.
 *
 * @private
 * @name add
 * @memberOf SetCache
 * @alias push
 * @param {*} value The value to cache.
 * @returns {Object} Returns the cache instance.
 */ function $dda8f7b6b589544e$var$setCacheAdd(value) {
    this.__data__.set(value, $dda8f7b6b589544e$var$HASH_UNDEFINED);
    return this;
}
$dda8f7b6b589544e$exports = $dda8f7b6b589544e$var$setCacheAdd;


var $66732c92c350622c$exports = {};
/**
 * Checks if `value` is in the array cache.
 *
 * @private
 * @name has
 * @memberOf SetCache
 * @param {*} value The value to search for.
 * @returns {number} Returns `true` if `value` is found, else `false`.
 */ function $66732c92c350622c$var$setCacheHas(value) {
    return this.__data__.has(value);
}
$66732c92c350622c$exports = $66732c92c350622c$var$setCacheHas;


/**
 *
 * Creates an array cache object to store unique values.
 *
 * @private
 * @constructor
 * @param {Array} [values] The values to cache.
 */ function $a29ccdc0f60e279e$var$SetCache(values) {
    var index = -1, length = values == null ? 0 : values.length;
    this.__data__ = new $4902f64a16640324$exports;
    while(++index < length)this.add(values[index]);
}
// Add methods to `SetCache`.
$a29ccdc0f60e279e$var$SetCache.prototype.add = $a29ccdc0f60e279e$var$SetCache.prototype.push = $dda8f7b6b589544e$exports;
$a29ccdc0f60e279e$var$SetCache.prototype.has = $66732c92c350622c$exports;
$a29ccdc0f60e279e$exports = $a29ccdc0f60e279e$var$SetCache;


var $aae24ad60cc3cfcb$exports = {};
/**
 * A specialized version of `_.some` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {boolean} Returns `true` if any element passes the predicate check,
 *  else `false`.
 */ function $aae24ad60cc3cfcb$var$arraySome(array, predicate) {
    var index = -1, length = array == null ? 0 : array.length;
    while(++index < length){
        if (predicate(array[index], index, array)) return true;
    }
    return false;
}
$aae24ad60cc3cfcb$exports = $aae24ad60cc3cfcb$var$arraySome;


var $1b44096ad4b9e2d5$exports = {};
/**
 * Checks if a `cache` value for `key` exists.
 *
 * @private
 * @param {Object} cache The cache to query.
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $1b44096ad4b9e2d5$var$cacheHas(cache, key) {
    return cache.has(key);
}
$1b44096ad4b9e2d5$exports = $1b44096ad4b9e2d5$var$cacheHas;


/** Used to compose bitmasks for value comparisons. */ var $1081bd3a2e361911$var$COMPARE_PARTIAL_FLAG = 1, $1081bd3a2e361911$var$COMPARE_UNORDERED_FLAG = 2;
/**
 * A specialized version of `baseIsEqualDeep` for arrays with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Array} array The array to compare.
 * @param {Array} other The other array to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `array` and `other` objects.
 * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
 */ function $1081bd3a2e361911$var$equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
    var isPartial = bitmask & $1081bd3a2e361911$var$COMPARE_PARTIAL_FLAG, arrLength = array.length, othLength = other.length;
    if (arrLength != othLength && !(isPartial && othLength > arrLength)) return false;
    // Check that cyclic values are equal.
    var arrStacked = stack.get(array);
    var othStacked = stack.get(other);
    if (arrStacked && othStacked) return arrStacked == other && othStacked == array;
    var index = -1, result = true, seen = bitmask & $1081bd3a2e361911$var$COMPARE_UNORDERED_FLAG ? new $a29ccdc0f60e279e$exports : undefined;
    stack.set(array, other);
    stack.set(other, array);
    // Ignore non-index properties.
    while(++index < arrLength){
        var arrValue = array[index], othValue = other[index];
        if (customizer) var compared = isPartial ? customizer(othValue, arrValue, index, other, array, stack) : customizer(arrValue, othValue, index, array, other, stack);
        if (compared !== undefined) {
            if (compared) continue;
            result = false;
            break;
        }
        // Recursively compare arrays (susceptible to call stack limits).
        if (seen) {
            if (!$aae24ad60cc3cfcb$exports(other, function(othValue, othIndex) {
                if (!$1b44096ad4b9e2d5$exports(seen, othIndex) && (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) return seen.push(othIndex);
            })) {
                result = false;
                break;
            }
        } else if (!(arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
            result = false;
            break;
        }
    }
    stack["delete"](array);
    stack["delete"](other);
    return result;
}
$1081bd3a2e361911$exports = $1081bd3a2e361911$var$equalArrays;


var $baf52b9e146f3da7$exports = {};

var $facf83d1449a27b8$exports = {};

var $23YZo = parcelRequire("23YZo");
/** Built-in value references. */ var $facf83d1449a27b8$var$Uint8Array = $23YZo.Uint8Array;
$facf83d1449a27b8$exports = $facf83d1449a27b8$var$Uint8Array;




var $91d4444cbb077e0c$exports = {};
/**
 * Converts `map` to its key-value pairs.
 *
 * @private
 * @param {Object} map The map to convert.
 * @returns {Array} Returns the key-value pairs.
 */ function $91d4444cbb077e0c$var$mapToArray(map) {
    var index = -1, result = Array(map.size);
    map.forEach(function(value, key) {
        result[++index] = [
            key,
            value
        ];
    });
    return result;
}
$91d4444cbb077e0c$exports = $91d4444cbb077e0c$var$mapToArray;


var $11f509f8f53d8c36$exports = {};
/**
 * Converts `set` to an array of its values.
 *
 * @private
 * @param {Object} set The set to convert.
 * @returns {Array} Returns the values.
 */ function $11f509f8f53d8c36$var$setToArray(set) {
    var index = -1, result = Array(set.size);
    set.forEach(function(value) {
        result[++index] = value;
    });
    return result;
}
$11f509f8f53d8c36$exports = $11f509f8f53d8c36$var$setToArray;


/** Used to compose bitmasks for value comparisons. */ var $baf52b9e146f3da7$var$COMPARE_PARTIAL_FLAG = 1, $baf52b9e146f3da7$var$COMPARE_UNORDERED_FLAG = 2;
/** `Object#toString` result references. */ var $baf52b9e146f3da7$var$boolTag = "[object Boolean]", $baf52b9e146f3da7$var$dateTag = "[object Date]", $baf52b9e146f3da7$var$errorTag = "[object Error]", $baf52b9e146f3da7$var$mapTag = "[object Map]", $baf52b9e146f3da7$var$numberTag = "[object Number]", $baf52b9e146f3da7$var$regexpTag = "[object RegExp]", $baf52b9e146f3da7$var$setTag = "[object Set]", $baf52b9e146f3da7$var$stringTag = "[object String]", $baf52b9e146f3da7$var$symbolTag = "[object Symbol]";
var $baf52b9e146f3da7$var$arrayBufferTag = "[object ArrayBuffer]", $baf52b9e146f3da7$var$dataViewTag = "[object DataView]";
/** Used to convert symbols to primitives and strings. */ var $baf52b9e146f3da7$var$symbolProto = $3ba72ebe7e4419b5$exports ? $3ba72ebe7e4419b5$exports.prototype : undefined, $baf52b9e146f3da7$var$symbolValueOf = $baf52b9e146f3da7$var$symbolProto ? $baf52b9e146f3da7$var$symbolProto.valueOf : undefined;
/**
 * A specialized version of `baseIsEqualDeep` for comparing objects of
 * the same `toStringTag`.
 *
 * **Note:** This function only supports comparing values with tags of
 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {string} tag The `toStringTag` of the objects to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */ function $baf52b9e146f3da7$var$equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
    switch(tag){
        case $baf52b9e146f3da7$var$dataViewTag:
            if (object.byteLength != other.byteLength || object.byteOffset != other.byteOffset) return false;
            object = object.buffer;
            other = other.buffer;
        case $baf52b9e146f3da7$var$arrayBufferTag:
            if (object.byteLength != other.byteLength || !equalFunc(new $facf83d1449a27b8$exports(object), new $facf83d1449a27b8$exports(other))) return false;
            return true;
        case $baf52b9e146f3da7$var$boolTag:
        case $baf52b9e146f3da7$var$dateTag:
        case $baf52b9e146f3da7$var$numberTag:
            // Coerce booleans to `1` or `0` and dates to milliseconds.
            // Invalid dates are coerced to `NaN`.
            return $50557587dab070a0$exports(+object, +other);
        case $baf52b9e146f3da7$var$errorTag:
            return object.name == other.name && object.message == other.message;
        case $baf52b9e146f3da7$var$regexpTag:
        case $baf52b9e146f3da7$var$stringTag:
            // Coerce regexes to strings and treat strings, primitives and objects,
            // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
            // for more details.
            return object == other + "";
        case $baf52b9e146f3da7$var$mapTag:
            var convert = $91d4444cbb077e0c$exports;
        case $baf52b9e146f3da7$var$setTag:
            var isPartial = bitmask & $baf52b9e146f3da7$var$COMPARE_PARTIAL_FLAG;
            convert || (convert = $11f509f8f53d8c36$exports);
            if (object.size != other.size && !isPartial) return false;
            // Assume cyclic values are equal.
            var stacked = stack.get(object);
            if (stacked) return stacked == other;
            bitmask |= $baf52b9e146f3da7$var$COMPARE_UNORDERED_FLAG;
            // Recursively compare objects (susceptible to call stack limits).
            stack.set(object, other);
            var result = $1081bd3a2e361911$exports(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
            stack["delete"](object);
            return result;
        case $baf52b9e146f3da7$var$symbolTag:
            if ($baf52b9e146f3da7$var$symbolValueOf) return $baf52b9e146f3da7$var$symbolValueOf.call(object) == $baf52b9e146f3da7$var$symbolValueOf.call(other);
    }
    return false;
}
$baf52b9e146f3da7$exports = $baf52b9e146f3da7$var$equalByTag;


var $ac8a81cbae0357e8$exports = {};
var $7958eecccfe4cef6$exports = {};
var $9144d49da7a47a72$exports = {};
var $cc77dbb7c08db6a8$exports = {};
/**
 * Appends the elements of `values` to `array`.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {Array} values The values to append.
 * @returns {Array} Returns `array`.
 */ function $cc77dbb7c08db6a8$var$arrayPush(array, values) {
    var index = -1, length = values.length, offset = array.length;
    while(++index < length)array[offset + index] = values[index];
    return array;
}
$cc77dbb7c08db6a8$exports = $cc77dbb7c08db6a8$var$arrayPush;



/**
 * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
 * `keysFunc` and `symbolsFunc` to get the enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @param {Function} symbolsFunc The function to get the symbols of `object`.
 * @returns {Array} Returns the array of property names and symbols.
 */ function $9144d49da7a47a72$var$baseGetAllKeys(object, keysFunc, symbolsFunc) {
    var result = keysFunc(object);
    return $0488fde9aa355453$exports(object) ? result : $cc77dbb7c08db6a8$exports(result, symbolsFunc(object));
}
$9144d49da7a47a72$exports = $9144d49da7a47a72$var$baseGetAllKeys;


var $51326a29f571e7cd$exports = {};
var $6549fed720324048$exports = {};
/**
 * A specialized version of `_.filter` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {Array} Returns the new filtered array.
 */ function $6549fed720324048$var$arrayFilter(array, predicate) {
    var index = -1, length = array == null ? 0 : array.length, resIndex = 0, result = [];
    while(++index < length){
        var value = array[index];
        if (predicate(value, index, array)) result[resIndex++] = value;
    }
    return result;
}
$6549fed720324048$exports = $6549fed720324048$var$arrayFilter;


var $8fc9f7df9b0c06bb$exports = {};
/**
 * This method returns a new empty array.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {Array} Returns the new empty array.
 * @example
 *
 * var arrays = _.times(2, _.stubArray);
 *
 * console.log(arrays);
 * // => [[], []]
 *
 * console.log(arrays[0] === arrays[1]);
 * // => false
 */ function $8fc9f7df9b0c06bb$var$stubArray() {
    return [];
}
$8fc9f7df9b0c06bb$exports = $8fc9f7df9b0c06bb$var$stubArray;


/** Used for built-in method references. */ var $51326a29f571e7cd$var$objectProto = Object.prototype;
/** Built-in value references. */ var $51326a29f571e7cd$var$propertyIsEnumerable = $51326a29f571e7cd$var$objectProto.propertyIsEnumerable;
/* Built-in method references for those with the same name as other `lodash` methods. */ var $51326a29f571e7cd$var$nativeGetSymbols = Object.getOwnPropertySymbols;
/**
 * Creates an array of the own enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */ var $51326a29f571e7cd$var$getSymbols = !$51326a29f571e7cd$var$nativeGetSymbols ? $8fc9f7df9b0c06bb$exports : function(object) {
    if (object == null) return [];
    object = Object(object);
    return $6549fed720324048$exports($51326a29f571e7cd$var$nativeGetSymbols(object), function(symbol) {
        return $51326a29f571e7cd$var$propertyIsEnumerable.call(object, symbol);
    });
};
$51326a29f571e7cd$exports = $51326a29f571e7cd$var$getSymbols;



/**
 * Creates an array of own enumerable property names and symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */ function $7958eecccfe4cef6$var$getAllKeys(object) {
    return $9144d49da7a47a72$exports(object, $08f0eaf3fbcb2fde$exports, $51326a29f571e7cd$exports);
}
$7958eecccfe4cef6$exports = $7958eecccfe4cef6$var$getAllKeys;


/** Used to compose bitmasks for value comparisons. */ var $ac8a81cbae0357e8$var$COMPARE_PARTIAL_FLAG = 1;
/** Used for built-in method references. */ var $ac8a81cbae0357e8$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $ac8a81cbae0357e8$var$hasOwnProperty = $ac8a81cbae0357e8$var$objectProto.hasOwnProperty;
/**
 * A specialized version of `baseIsEqualDeep` for objects with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */ function $ac8a81cbae0357e8$var$equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
    var isPartial = bitmask & $ac8a81cbae0357e8$var$COMPARE_PARTIAL_FLAG, objProps = $7958eecccfe4cef6$exports(object), objLength = objProps.length, othProps = $7958eecccfe4cef6$exports(other), othLength = othProps.length;
    if (objLength != othLength && !isPartial) return false;
    var index = objLength;
    while(index--){
        var key = objProps[index];
        if (!(isPartial ? key in other : $ac8a81cbae0357e8$var$hasOwnProperty.call(other, key))) return false;
    }
    // Check that cyclic values are equal.
    var objStacked = stack.get(object);
    var othStacked = stack.get(other);
    if (objStacked && othStacked) return objStacked == other && othStacked == object;
    var result = true;
    stack.set(object, other);
    stack.set(other, object);
    var skipCtor = isPartial;
    while(++index < objLength){
        key = objProps[index];
        var objValue = object[key], othValue = other[key];
        if (customizer) var compared = isPartial ? customizer(othValue, objValue, key, other, object, stack) : customizer(objValue, othValue, key, object, other, stack);
        // Recursively compare objects (susceptible to call stack limits).
        if (!(compared === undefined ? objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack) : compared)) {
            result = false;
            break;
        }
        skipCtor || (skipCtor = key == "constructor");
    }
    if (result && !skipCtor) {
        var objCtor = object.constructor, othCtor = other.constructor;
        // Non `Object` object instances with different constructors are not equal.
        if (objCtor != othCtor && "constructor" in object && "constructor" in other && !(typeof objCtor == "function" && objCtor instanceof objCtor && typeof othCtor == "function" && othCtor instanceof othCtor)) result = false;
    }
    stack["delete"](object);
    stack["delete"](other);
    return result;
}
$ac8a81cbae0357e8$exports = $ac8a81cbae0357e8$var$equalObjects;


var $474f685f496bfe31$exports = {};
var $41ce0ff3b38ee753$exports = {};


var $23YZo = parcelRequire("23YZo");
/* Built-in method references that are verified to be native. */ var $41ce0ff3b38ee753$var$DataView = $5037fd2e597c2a03$exports($23YZo, "DataView");
$41ce0ff3b38ee753$exports = $41ce0ff3b38ee753$var$DataView;



var $b0226bdea11cb834$exports = {};


var $23YZo = parcelRequire("23YZo");
/* Built-in method references that are verified to be native. */ var $b0226bdea11cb834$var$Promise = $5037fd2e597c2a03$exports($23YZo, "Promise");
$b0226bdea11cb834$exports = $b0226bdea11cb834$var$Promise;


var $05f44e958da968eb$exports = {};


var $23YZo = parcelRequire("23YZo");
/* Built-in method references that are verified to be native. */ var $05f44e958da968eb$var$Set = $5037fd2e597c2a03$exports($23YZo, "Set");
$05f44e958da968eb$exports = $05f44e958da968eb$var$Set;


var $aedce50092a1e6a6$exports = {};


var $23YZo = parcelRequire("23YZo");
/* Built-in method references that are verified to be native. */ var $aedce50092a1e6a6$var$WeakMap = $5037fd2e597c2a03$exports($23YZo, "WeakMap");
$aedce50092a1e6a6$exports = $aedce50092a1e6a6$var$WeakMap;




/** `Object#toString` result references. */ var $474f685f496bfe31$var$mapTag = "[object Map]", $474f685f496bfe31$var$objectTag = "[object Object]", $474f685f496bfe31$var$promiseTag = "[object Promise]", $474f685f496bfe31$var$setTag = "[object Set]", $474f685f496bfe31$var$weakMapTag = "[object WeakMap]";
var $474f685f496bfe31$var$dataViewTag = "[object DataView]";
/** Used to detect maps, sets, and weakmaps. */ var $474f685f496bfe31$var$dataViewCtorString = $9c6b3ec69362487e$exports($41ce0ff3b38ee753$exports), $474f685f496bfe31$var$mapCtorString = $9c6b3ec69362487e$exports($19b02faa57603249$exports), $474f685f496bfe31$var$promiseCtorString = $9c6b3ec69362487e$exports($b0226bdea11cb834$exports), $474f685f496bfe31$var$setCtorString = $9c6b3ec69362487e$exports($05f44e958da968eb$exports), $474f685f496bfe31$var$weakMapCtorString = $9c6b3ec69362487e$exports($aedce50092a1e6a6$exports);
/**
 * Gets the `toStringTag` of `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */ var $474f685f496bfe31$var$getTag = $a7f8a2555793d7d3$exports;
// Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
if ($41ce0ff3b38ee753$exports && $474f685f496bfe31$var$getTag(new $41ce0ff3b38ee753$exports(new ArrayBuffer(1))) != $474f685f496bfe31$var$dataViewTag || $19b02faa57603249$exports && $474f685f496bfe31$var$getTag(new $19b02faa57603249$exports) != $474f685f496bfe31$var$mapTag || $b0226bdea11cb834$exports && $474f685f496bfe31$var$getTag($b0226bdea11cb834$exports.resolve()) != $474f685f496bfe31$var$promiseTag || $05f44e958da968eb$exports && $474f685f496bfe31$var$getTag(new $05f44e958da968eb$exports) != $474f685f496bfe31$var$setTag || $aedce50092a1e6a6$exports && $474f685f496bfe31$var$getTag(new $aedce50092a1e6a6$exports) != $474f685f496bfe31$var$weakMapTag) $474f685f496bfe31$var$getTag = function(value) {
    var result = $a7f8a2555793d7d3$exports(value), Ctor = result == $474f685f496bfe31$var$objectTag ? value.constructor : undefined, ctorString = Ctor ? $9c6b3ec69362487e$exports(Ctor) : "";
    if (ctorString) switch(ctorString){
        case $474f685f496bfe31$var$dataViewCtorString:
            return $474f685f496bfe31$var$dataViewTag;
        case $474f685f496bfe31$var$mapCtorString:
            return $474f685f496bfe31$var$mapTag;
        case $474f685f496bfe31$var$promiseCtorString:
            return $474f685f496bfe31$var$promiseTag;
        case $474f685f496bfe31$var$setCtorString:
            return $474f685f496bfe31$var$setTag;
        case $474f685f496bfe31$var$weakMapCtorString:
            return $474f685f496bfe31$var$weakMapTag;
    }
    return result;
};
$474f685f496bfe31$exports = $474f685f496bfe31$var$getTag;




var $f504n = parcelRequire("f504n");

/** Used to compose bitmasks for value comparisons. */ var $567f2dd161ebd4f6$var$COMPARE_PARTIAL_FLAG = 1;
/** `Object#toString` result references. */ var $567f2dd161ebd4f6$var$argsTag = "[object Arguments]", $567f2dd161ebd4f6$var$arrayTag = "[object Array]", $567f2dd161ebd4f6$var$objectTag = "[object Object]";
/** Used for built-in method references. */ var $567f2dd161ebd4f6$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $567f2dd161ebd4f6$var$hasOwnProperty = $567f2dd161ebd4f6$var$objectProto.hasOwnProperty;
/**
 * A specialized version of `baseIsEqual` for arrays and objects which performs
 * deep comparisons and tracks traversed objects enabling objects with circular
 * references to be compared.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} [stack] Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */ function $567f2dd161ebd4f6$var$baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
    var objIsArr = $0488fde9aa355453$exports(object), othIsArr = $0488fde9aa355453$exports(other), objTag = objIsArr ? $567f2dd161ebd4f6$var$arrayTag : $474f685f496bfe31$exports(object), othTag = othIsArr ? $567f2dd161ebd4f6$var$arrayTag : $474f685f496bfe31$exports(other);
    objTag = objTag == $567f2dd161ebd4f6$var$argsTag ? $567f2dd161ebd4f6$var$objectTag : objTag;
    othTag = othTag == $567f2dd161ebd4f6$var$argsTag ? $567f2dd161ebd4f6$var$objectTag : othTag;
    var objIsObj = objTag == $567f2dd161ebd4f6$var$objectTag, othIsObj = othTag == $567f2dd161ebd4f6$var$objectTag, isSameTag = objTag == othTag;
    if (isSameTag && $f504n(object)) {
        if (!$f504n(other)) return false;
        objIsArr = true;
        objIsObj = false;
    }
    if (isSameTag && !objIsObj) {
        stack || (stack = new $bbb2d98cae25b61a$exports);
        return objIsArr || $156c3727697ab085$exports(object) ? $1081bd3a2e361911$exports(object, other, bitmask, customizer, equalFunc, stack) : $baf52b9e146f3da7$exports(object, other, objTag, bitmask, customizer, equalFunc, stack);
    }
    if (!(bitmask & $567f2dd161ebd4f6$var$COMPARE_PARTIAL_FLAG)) {
        var objIsWrapped = objIsObj && $567f2dd161ebd4f6$var$hasOwnProperty.call(object, "__wrapped__"), othIsWrapped = othIsObj && $567f2dd161ebd4f6$var$hasOwnProperty.call(other, "__wrapped__");
        if (objIsWrapped || othIsWrapped) {
            var objUnwrapped = objIsWrapped ? object.value() : object, othUnwrapped = othIsWrapped ? other.value() : other;
            stack || (stack = new $bbb2d98cae25b61a$exports);
            return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
        }
    }
    if (!isSameTag) return false;
    stack || (stack = new $bbb2d98cae25b61a$exports);
    return $ac8a81cbae0357e8$exports(object, other, bitmask, customizer, equalFunc, stack);
}
$567f2dd161ebd4f6$exports = $567f2dd161ebd4f6$var$baseIsEqualDeep;



/**
 * The base implementation of `_.isEqual` which supports partial comparisons
 * and tracks traversed objects.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @param {boolean} bitmask The bitmask flags.
 *  1 - Unordered comparison
 *  2 - Partial comparison
 * @param {Function} [customizer] The function to customize comparisons.
 * @param {Object} [stack] Tracks traversed `value` and `other` objects.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 */ function $769812b29c18141e$var$baseIsEqual(value, other, bitmask, customizer, stack) {
    if (value === other) return true;
    if (value == null || other == null || !$61269cf1f3e020be$exports(value) && !$61269cf1f3e020be$exports(other)) return value !== value && other !== other;
    return $567f2dd161ebd4f6$exports(value, other, bitmask, customizer, $769812b29c18141e$var$baseIsEqual, stack);
}
$769812b29c18141e$exports = $769812b29c18141e$var$baseIsEqual;


/** Used to compose bitmasks for value comparisons. */ var $ec073f38db6e7d54$var$COMPARE_PARTIAL_FLAG = 1, $ec073f38db6e7d54$var$COMPARE_UNORDERED_FLAG = 2;
/**
 * The base implementation of `_.isMatch` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The object to inspect.
 * @param {Object} source The object of property values to match.
 * @param {Array} matchData The property names, values, and compare flags to match.
 * @param {Function} [customizer] The function to customize comparisons.
 * @returns {boolean} Returns `true` if `object` is a match, else `false`.
 */ function $ec073f38db6e7d54$var$baseIsMatch(object, source, matchData, customizer) {
    var index = matchData.length, length = index, noCustomizer = !customizer;
    if (object == null) return !length;
    object = Object(object);
    while(index--){
        var data = matchData[index];
        if (noCustomizer && data[2] ? data[1] !== object[data[0]] : !(data[0] in object)) return false;
    }
    while(++index < length){
        data = matchData[index];
        var key = data[0], objValue = object[key], srcValue = data[1];
        if (noCustomizer && data[2]) {
            if (objValue === undefined && !(key in object)) return false;
        } else {
            var stack = new $bbb2d98cae25b61a$exports;
            if (customizer) var result = customizer(objValue, srcValue, key, object, source, stack);
            if (!(result === undefined ? $769812b29c18141e$exports(srcValue, objValue, $ec073f38db6e7d54$var$COMPARE_PARTIAL_FLAG | $ec073f38db6e7d54$var$COMPARE_UNORDERED_FLAG, customizer, stack) : result)) return false;
        }
    }
    return true;
}
$ec073f38db6e7d54$exports = $ec073f38db6e7d54$var$baseIsMatch;


var $6b4f84f6be7f825c$exports = {};
var $0ff8edf4f90a7955$exports = {};

/**
 * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` if suitable for strict
 *  equality comparisons, else `false`.
 */ function $0ff8edf4f90a7955$var$isStrictComparable(value) {
    return value === value && !$f9ff2e983beb6b86$exports(value);
}
$0ff8edf4f90a7955$exports = $0ff8edf4f90a7955$var$isStrictComparable;



/**
 * Gets the property names, values, and compare flags of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the match data of `object`.
 */ function $6b4f84f6be7f825c$var$getMatchData(object) {
    var result = $08f0eaf3fbcb2fde$exports(object), length = result.length;
    while(length--){
        var key = result[length], value = object[key];
        result[length] = [
            key,
            value,
            $0ff8edf4f90a7955$exports(value)
        ];
    }
    return result;
}
$6b4f84f6be7f825c$exports = $6b4f84f6be7f825c$var$getMatchData;


var $1f9d5e891556ddb9$exports = {};
/**
 * A specialized version of `matchesProperty` for source values suitable
 * for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new spec function.
 */ function $1f9d5e891556ddb9$var$matchesStrictComparable(key, srcValue) {
    return function(object) {
        if (object == null) return false;
        return object[key] === srcValue && (srcValue !== undefined || key in Object(object));
    };
}
$1f9d5e891556ddb9$exports = $1f9d5e891556ddb9$var$matchesStrictComparable;


/**
 * The base implementation of `_.matches` which doesn't clone `source`.
 *
 * @private
 * @param {Object} source The object of property values to match.
 * @returns {Function} Returns the new spec function.
 */ function $e780807e2b795134$var$baseMatches(source) {
    var matchData = $6b4f84f6be7f825c$exports(source);
    if (matchData.length == 1 && matchData[0][2]) return $1f9d5e891556ddb9$exports(matchData[0][0], matchData[0][1]);
    return function(object) {
        return object === source || $ec073f38db6e7d54$exports(object, source, matchData);
    };
}
$e780807e2b795134$exports = $e780807e2b795134$var$baseMatches;


var $d5fe8a98fe4800eb$exports = {};

var $d299ac421c05c135$exports = {};
var $fd2d90f592c63519$exports = {};


/**
 * The base implementation of `_.get` without support for default values.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @returns {*} Returns the resolved value.
 */ function $fd2d90f592c63519$var$baseGet(object, path) {
    path = $38afcbfab85a0553$exports(path, object);
    var index = 0, length = path.length;
    while(object != null && index < length)object = object[$4d60aa8c33155976$exports(path[index++])];
    return index && index == length ? object : undefined;
}
$fd2d90f592c63519$exports = $fd2d90f592c63519$var$baseGet;


/**
 * Gets the value at `path` of `object`. If the resolved value is
 * `undefined`, the `defaultValue` is returned in its place.
 *
 * @static
 * @memberOf _
 * @since 3.7.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @param {*} [defaultValue] The value returned for `undefined` resolved values.
 * @returns {*} Returns the resolved value.
 * @example
 *
 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
 *
 * _.get(object, 'a[0].b.c');
 * // => 3
 *
 * _.get(object, ['a', '0', 'b', 'c']);
 * // => 3
 *
 * _.get(object, 'a.b.c', 'default');
 * // => 'default'
 */ function $d299ac421c05c135$var$get(object, path, defaultValue) {
    var result = object == null ? undefined : $fd2d90f592c63519$exports(object, path);
    return result === undefined ? defaultValue : result;
}
$d299ac421c05c135$exports = $d299ac421c05c135$var$get;


var $221e04e57e35dd04$exports = {};
var $d53c6080f339a51f$exports = {};
/**
 * The base implementation of `_.hasIn` without support for deep paths.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {Array|string} key The key to check.
 * @returns {boolean} Returns `true` if `key` exists, else `false`.
 */ function $d53c6080f339a51f$var$baseHasIn(object, key) {
    return object != null && key in Object(object);
}
$d53c6080f339a51f$exports = $d53c6080f339a51f$var$baseHasIn;



/**
 * Checks if `path` is a direct or inherited property of `object`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 * @example
 *
 * var object = _.create({ 'a': _.create({ 'b': 2 }) });
 *
 * _.hasIn(object, 'a');
 * // => true
 *
 * _.hasIn(object, 'a.b');
 * // => true
 *
 * _.hasIn(object, ['a', 'b']);
 * // => true
 *
 * _.hasIn(object, 'b');
 * // => false
 */ function $221e04e57e35dd04$var$hasIn(object, path) {
    return object != null && $85aaea8f77d790ae$exports(object, path, $d53c6080f339a51f$exports);
}
$221e04e57e35dd04$exports = $221e04e57e35dd04$var$hasIn;






/** Used to compose bitmasks for value comparisons. */ var $d5fe8a98fe4800eb$var$COMPARE_PARTIAL_FLAG = 1, $d5fe8a98fe4800eb$var$COMPARE_UNORDERED_FLAG = 2;
/**
 * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
 *
 * @private
 * @param {string} path The path of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new spec function.
 */ function $d5fe8a98fe4800eb$var$baseMatchesProperty(path, srcValue) {
    if ($03e9beb856e9b4cd$exports(path) && $0ff8edf4f90a7955$exports(srcValue)) return $1f9d5e891556ddb9$exports($4d60aa8c33155976$exports(path), srcValue);
    return function(object) {
        var objValue = $d299ac421c05c135$exports(object, path);
        return objValue === undefined && objValue === srcValue ? $221e04e57e35dd04$exports(object, path) : $769812b29c18141e$exports(srcValue, objValue, $d5fe8a98fe4800eb$var$COMPARE_PARTIAL_FLAG | $d5fe8a98fe4800eb$var$COMPARE_UNORDERED_FLAG);
    };
}
$d5fe8a98fe4800eb$exports = $d5fe8a98fe4800eb$var$baseMatchesProperty;


var $37dff9aa04444f9c$exports = {};
/**
 * This method returns the first argument it receives.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {*} value Any value.
 * @returns {*} Returns `value`.
 * @example
 *
 * var object = { 'a': 1 };
 *
 * console.log(_.identity(object) === object);
 * // => true
 */ function $37dff9aa04444f9c$var$identity(value) {
    return value;
}
$37dff9aa04444f9c$exports = $37dff9aa04444f9c$var$identity;



var $87123e72266aa58c$exports = {};
var $d45a621b4548f6bb$exports = {};
/**
 * The base implementation of `_.property` without support for deep paths.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @returns {Function} Returns the new accessor function.
 */ function $d45a621b4548f6bb$var$baseProperty(key) {
    return function(object) {
        return object == null ? undefined : object[key];
    };
}
$d45a621b4548f6bb$exports = $d45a621b4548f6bb$var$baseProperty;


var $e029d02f9dd10368$exports = {};

/**
 * A specialized version of `baseProperty` which supports deep paths.
 *
 * @private
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new accessor function.
 */ function $e029d02f9dd10368$var$basePropertyDeep(path) {
    return function(object) {
        return $fd2d90f592c63519$exports(object, path);
    };
}
$e029d02f9dd10368$exports = $e029d02f9dd10368$var$basePropertyDeep;




/**
 * Creates a function that returns the value at `path` of a given object.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new accessor function.
 * @example
 *
 * var objects = [
 *   { 'a': { 'b': 2 } },
 *   { 'a': { 'b': 1 } }
 * ];
 *
 * _.map(objects, _.property('a.b'));
 * // => [2, 1]
 *
 * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
 * // => [1, 2]
 */ function $87123e72266aa58c$var$property(path) {
    return $03e9beb856e9b4cd$exports(path) ? $d45a621b4548f6bb$exports($4d60aa8c33155976$exports(path)) : $e029d02f9dd10368$exports(path);
}
$87123e72266aa58c$exports = $87123e72266aa58c$var$property;


/**
 * The base implementation of `_.iteratee`.
 *
 * @private
 * @param {*} [value=_.identity] The value to convert to an iteratee.
 * @returns {Function} Returns the iteratee.
 */ function $5aba4f6d9f8304a3$var$baseIteratee(value) {
    // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
    // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
    if (typeof value == "function") return value;
    if (value == null) return $37dff9aa04444f9c$exports;
    if (typeof value == "object") return $0488fde9aa355453$exports(value) ? $d5fe8a98fe4800eb$exports(value[0], value[1]) : $e780807e2b795134$exports(value);
    return $87123e72266aa58c$exports(value);
}
$5aba4f6d9f8304a3$exports = $5aba4f6d9f8304a3$var$baseIteratee;


/**
 * Creates an object with the same keys as `object` and values generated
 * by running each own enumerable string keyed property of `object` thru
 * `iteratee`. The iteratee is invoked with three arguments:
 * (value, key, object).
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Object
 * @param {Object} object The object to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @returns {Object} Returns the new mapped object.
 * @see _.mapKeys
 * @example
 *
 * var users = {
 *   'fred':    { 'user': 'fred',    'age': 40 },
 *   'pebbles': { 'user': 'pebbles', 'age': 1 }
 * };
 *
 * _.mapValues(users, function(o) { return o.age; });
 * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
 *
 * // The `_.property` iteratee shorthand.
 * _.mapValues(users, 'age');
 * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
 */ function $17211428bc2045c4$var$mapValues(object, iteratee) {
    var result = {};
    iteratee = $5aba4f6d9f8304a3$exports(iteratee, 3);
    $34edfba366a0cfa1$exports(object, function(value, key, object) {
        $96b401257ea00d24$exports(result, key, iteratee(value, key, object));
    });
    return result;
}
$17211428bc2045c4$exports = $17211428bc2045c4$var$mapValues;



var $0a34a21cae127bf5$exports = {};
/**
 * Based on Kendo UI Core expression code <https://github.com/telerik/kendo-ui-core#license-information>
 */ "use strict";
function $0a34a21cae127bf5$var$Cache(maxSize) {
    this._maxSize = maxSize;
    this.clear();
}
$0a34a21cae127bf5$var$Cache.prototype.clear = function() {
    this._size = 0;
    this._values = Object.create(null);
};
$0a34a21cae127bf5$var$Cache.prototype.get = function(key) {
    return this._values[key];
};
$0a34a21cae127bf5$var$Cache.prototype.set = function(key, value) {
    this._size >= this._maxSize && this.clear();
    if (!(key in this._values)) this._size++;
    return this._values[key] = value;
};
var $0a34a21cae127bf5$var$SPLIT_REGEX = /[^.^\]^[]+|(?=\[\]|\.\.)/g, $0a34a21cae127bf5$var$DIGIT_REGEX = /^\d+$/, $0a34a21cae127bf5$var$LEAD_DIGIT_REGEX = /^\d/, $0a34a21cae127bf5$var$SPEC_CHAR_REGEX = /[~`!#$%\^&*+=\-\[\]\\';,/{}|\\":<>\?]/g, $0a34a21cae127bf5$var$CLEAN_QUOTES_REGEX = /^\s*(['"]?)(.*?)(\1)\s*$/, $0a34a21cae127bf5$var$MAX_CACHE_SIZE = 512;
var $0a34a21cae127bf5$var$pathCache = new $0a34a21cae127bf5$var$Cache($0a34a21cae127bf5$var$MAX_CACHE_SIZE), $0a34a21cae127bf5$var$setCache = new $0a34a21cae127bf5$var$Cache($0a34a21cae127bf5$var$MAX_CACHE_SIZE), $0a34a21cae127bf5$var$getCache = new $0a34a21cae127bf5$var$Cache($0a34a21cae127bf5$var$MAX_CACHE_SIZE);
var $0a34a21cae127bf5$var$config;
$0a34a21cae127bf5$exports = {
    Cache: $0a34a21cae127bf5$var$Cache,
    split: $0a34a21cae127bf5$var$split,
    normalizePath: $0a34a21cae127bf5$var$normalizePath,
    setter: function(path) {
        var parts = $0a34a21cae127bf5$var$normalizePath(path);
        return $0a34a21cae127bf5$var$setCache.get(path) || $0a34a21cae127bf5$var$setCache.set(path, function setter(obj, value) {
            var index = 0;
            var len = parts.length;
            var data = obj;
            while(index < len - 1){
                var part = parts[index];
                if (part === "__proto__" || part === "constructor" || part === "prototype") return obj;
                data = data[parts[index++]];
            }
            data[parts[index]] = value;
        });
    },
    getter: function(path, safe) {
        var parts = $0a34a21cae127bf5$var$normalizePath(path);
        return $0a34a21cae127bf5$var$getCache.get(path) || $0a34a21cae127bf5$var$getCache.set(path, function getter(data) {
            var index = 0, len = parts.length;
            while(index < len){
                if (data != null || !safe) data = data[parts[index++]];
                else return;
            }
            return data;
        });
    },
    join: function(segments) {
        return segments.reduce(function(path, part) {
            return path + ($0a34a21cae127bf5$var$isQuoted(part) || $0a34a21cae127bf5$var$DIGIT_REGEX.test(part) ? "[" + part + "]" : (path ? "." : "") + part);
        }, "");
    },
    forEach: function(path, cb, thisArg) {
        $0a34a21cae127bf5$var$forEach(Array.isArray(path) ? path : $0a34a21cae127bf5$var$split(path), cb, thisArg);
    }
};
function $0a34a21cae127bf5$var$normalizePath(path) {
    return $0a34a21cae127bf5$var$pathCache.get(path) || $0a34a21cae127bf5$var$pathCache.set(path, $0a34a21cae127bf5$var$split(path).map(function(part) {
        return part.replace($0a34a21cae127bf5$var$CLEAN_QUOTES_REGEX, "$2");
    }));
}
function $0a34a21cae127bf5$var$split(path) {
    return path.match($0a34a21cae127bf5$var$SPLIT_REGEX) || [
        ""
    ];
}
function $0a34a21cae127bf5$var$forEach(parts, iter, thisArg) {
    var len = parts.length, part, idx, isArray, isBracket;
    for(idx = 0; idx < len; idx++){
        part = parts[idx];
        if (part) {
            if ($0a34a21cae127bf5$var$shouldBeQuoted(part)) part = '"' + part + '"';
            isBracket = $0a34a21cae127bf5$var$isQuoted(part);
            isArray = !isBracket && /^\d+$/.test(part);
            iter.call(thisArg, part, isBracket, isArray, idx, parts);
        }
    }
}
function $0a34a21cae127bf5$var$isQuoted(str) {
    return typeof str === "string" && str && [
        "'",
        '"'
    ].indexOf(str.charAt(0)) !== -1;
}
function $0a34a21cae127bf5$var$hasLeadingNumber(part) {
    return part.match($0a34a21cae127bf5$var$LEAD_DIGIT_REGEX) && !part.match($0a34a21cae127bf5$var$DIGIT_REGEX);
}
function $0a34a21cae127bf5$var$hasSpecialChars(part) {
    return $0a34a21cae127bf5$var$SPEC_CHAR_REGEX.test(part);
}
function $0a34a21cae127bf5$var$shouldBeQuoted(part) {
    return !$0a34a21cae127bf5$var$isQuoted(part) && ($0a34a21cae127bf5$var$hasLeadingNumber(part) || $0a34a21cae127bf5$var$hasSpecialChars(part));
}


const $f5cdfa956e941194$var$prefixes = {
    context: "$",
    value: "."
};
function $f5cdfa956e941194$export$185802fd694ee1f5(key, options) {
    return new $f5cdfa956e941194$export$2e2bcd8739ae039(key, options);
}
class $f5cdfa956e941194$export$2e2bcd8739ae039 {
    constructor(key, options = {}){
        this.key = void 0;
        this.isContext = void 0;
        this.isValue = void 0;
        this.isSibling = void 0;
        this.path = void 0;
        this.getter = void 0;
        this.map = void 0;
        if (typeof key !== "string") throw new TypeError("ref must be a string, got: " + key);
        this.key = key.trim();
        if (key === "") throw new TypeError("ref must be a non-empty string");
        this.isContext = this.key[0] === $f5cdfa956e941194$var$prefixes.context;
        this.isValue = this.key[0] === $f5cdfa956e941194$var$prefixes.value;
        this.isSibling = !this.isContext && !this.isValue;
        let prefix = this.isContext ? $f5cdfa956e941194$var$prefixes.context : this.isValue ? $f5cdfa956e941194$var$prefixes.value : "";
        this.path = this.key.slice(prefix.length);
        this.getter = this.path && (0, $0a34a21cae127bf5$exports.getter)(this.path, true);
        this.map = options.map;
    }
    getValue(value, parent, context) {
        let result = this.isContext ? context : this.isValue ? value : parent;
        if (this.getter) result = this.getter(result || {});
        if (this.map) result = this.map(result);
        return result;
    }
    /**
   *
   * @param {*} value
   * @param {Object} options
   * @param {Object=} options.context
   * @param {Object=} options.parent
   */ cast(value, options) {
        return this.getValue(value, options == null ? void 0 : options.parent, options == null ? void 0 : options.context);
    }
    resolve() {
        return this;
    }
    describe() {
        return {
            type: "ref",
            key: this.key
        };
    }
    toString() {
        return `Ref(${this.key})`;
    }
    static isRef(value) {
        return value && value.__isYupRef;
    }
} // @ts-ignore
$f5cdfa956e941194$export$2e2bcd8739ae039.prototype.__isYupRef = true;


function $7c576e9ad8044c54$var$_extends() {
    $7c576e9ad8044c54$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $7c576e9ad8044c54$var$_extends.apply(this, arguments);
}
function $7c576e9ad8044c54$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $7c576e9ad8044c54$export$2e2bcd8739ae039(config) {
    function validate(_ref, cb) {
        let { value: value, path: path = "", label: label, options: options, originalValue: originalValue, sync: sync } = _ref, rest = $7c576e9ad8044c54$var$_objectWithoutPropertiesLoose(_ref, [
            "value",
            "path",
            "label",
            "options",
            "originalValue",
            "sync"
        ]);
        const { name: name, test: test, params: params, message: message } = config;
        let { parent: parent, context: context } = options;
        function resolve(item) {
            return (0, $f5cdfa956e941194$export$2e2bcd8739ae039).isRef(item) ? item.getValue(value, parent, context) : item;
        }
        function createError(overrides = {}) {
            const nextParams = (0, (/*@__PURE__*/$parcel$interopDefault($17211428bc2045c4$exports)))($7c576e9ad8044c54$var$_extends({
                value: value,
                originalValue: originalValue,
                label: label,
                path: overrides.path || path
            }, params, overrides.params), resolve);
            const error = new (0, $d2e70d35996a7daf$export$2e2bcd8739ae039)((0, $d2e70d35996a7daf$export$2e2bcd8739ae039).formatError(overrides.message || message, nextParams), value, nextParams.path, overrides.type || name);
            error.params = nextParams;
            return error;
        }
        let ctx = $7c576e9ad8044c54$var$_extends({
            path: path,
            parent: parent,
            type: name,
            createError: createError,
            resolve: resolve,
            options: options,
            originalValue: originalValue
        }, rest);
        if (!sync) {
            try {
                Promise.resolve(test.call(ctx, value, ctx)).then((validOrError)=>{
                    if ((0, $d2e70d35996a7daf$export$2e2bcd8739ae039).isError(validOrError)) cb(validOrError);
                    else if (!validOrError) cb(createError());
                    else cb(null, validOrError);
                }).catch(cb);
            } catch (err) {
                cb(err);
            }
            return;
        }
        let result;
        try {
            var _ref2;
            result = test.call(ctx, value, ctx);
            if (typeof ((_ref2 = result) == null ? void 0 : _ref2.then) === "function") throw new Error(`Validation test of type: "${ctx.type}" returned a Promise during a synchronous validate. ` + `This test will finish after the validate call has returned`);
        } catch (err) {
            cb(err);
            return;
        }
        if ((0, $d2e70d35996a7daf$export$2e2bcd8739ae039).isError(result)) cb(result);
        else if (!result) cb(createError());
        else cb(null, result);
    }
    validate.OPTIONS = config;
    return validate;
}





let $5b552ca0a6c1ed5f$var$trim = (part)=>part.substr(0, part.length - 1).substr(1);
function $5b552ca0a6c1ed5f$export$c52e5867d5879e24(schema, path, value, context = value) {
    let parent, lastPart, lastPartDebug; // root path: ''
    if (!path) return {
        parent: parent,
        parentPath: path,
        schema: schema
    };
    (0, $0a34a21cae127bf5$exports.forEach)(path, (_part, isBracket, isArray)=>{
        let part = isBracket ? $5b552ca0a6c1ed5f$var$trim(_part) : _part;
        schema = schema.resolve({
            context: context,
            parent: parent,
            value: value
        });
        if (schema.innerType) {
            let idx = isArray ? parseInt(part, 10) : 0;
            if (value && idx >= value.length) throw new Error(`Yup.reach cannot resolve an array item at index: ${_part}, in the path: ${path}. ` + `because there is no value at that index. `);
            parent = value;
            value = value && value[idx];
            schema = schema.innerType;
        } // sometimes the array index part of a path doesn't exist: "nested.arr.child"
        // in these cases the current part is the next schema and should be processed
        // in this iteration. For cases where the index signature is included this
        // check will fail and we'll handle the `child` part on the next iteration like normal
        if (!isArray) {
            if (!schema.fields || !schema.fields[part]) throw new Error(`The schema does not contain the path: ${path}. ` + `(failed at: ${lastPartDebug} which is a type: "${schema._type}")`);
            parent = value;
            value = value && value[part];
            schema = schema.fields[part];
        }
        lastPart = part;
        lastPartDebug = isBracket ? "[" + _part + "]" : "." + _part;
    });
    return {
        schema: schema,
        parent: parent,
        parentPath: lastPart
    };
}
const $5b552ca0a6c1ed5f$var$reach = (obj, path, value, context)=>$5b552ca0a6c1ed5f$export$c52e5867d5879e24(obj, path, value, context).schema;
var $5b552ca0a6c1ed5f$export$2e2bcd8739ae039 = $5b552ca0a6c1ed5f$var$reach;




class $3f307508f67966f1$export$2e2bcd8739ae039 {
    constructor(){
        this.list = void 0;
        this.refs = void 0;
        this.list = new Set();
        this.refs = new Map();
    }
    get size() {
        return this.list.size + this.refs.size;
    }
    describe() {
        const description = [];
        for (const item of this.list)description.push(item);
        for (const [, ref] of this.refs)description.push(ref.describe());
        return description;
    }
    toArray() {
        return Array.from(this.list).concat(Array.from(this.refs.values()));
    }
    resolveAll(resolve) {
        return this.toArray().reduce((acc, e)=>acc.concat((0, $f5cdfa956e941194$export$2e2bcd8739ae039).isRef(e) ? resolve(e) : e), []);
    }
    add(value) {
        (0, $f5cdfa956e941194$export$2e2bcd8739ae039).isRef(value) ? this.refs.set(value.key, value) : this.list.add(value);
    }
    delete(value) {
        (0, $f5cdfa956e941194$export$2e2bcd8739ae039).isRef(value) ? this.refs.delete(value.key) : this.list.delete(value);
    }
    clone() {
        const next = new $3f307508f67966f1$export$2e2bcd8739ae039();
        next.list = new Set(this.list);
        next.refs = new Map(this.refs);
        return next;
    }
    merge(newItems, removeItems) {
        const next = this.clone();
        newItems.list.forEach((value)=>next.add(value));
        newItems.refs.forEach((value)=>next.add(value));
        removeItems.list.forEach((value)=>next.delete(value));
        removeItems.refs.forEach((value)=>next.delete(value));
        return next;
    }
}



function $bcee4fc8dbde13e1$var$_extends() {
    $bcee4fc8dbde13e1$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $bcee4fc8dbde13e1$var$_extends.apply(this, arguments);
}
class $bcee4fc8dbde13e1$export$2e2bcd8739ae039 {
    constructor(options){
        this.deps = [];
        this.tests = void 0;
        this.transforms = void 0;
        this.conditions = [];
        this._mutate = void 0;
        this._typeError = void 0;
        this._whitelist = new (0, $3f307508f67966f1$export$2e2bcd8739ae039)();
        this._blacklist = new (0, $3f307508f67966f1$export$2e2bcd8739ae039)();
        this.exclusiveTests = Object.create(null);
        this.spec = void 0;
        this.tests = [];
        this.transforms = [];
        this.withMutation(()=>{
            this.typeError((0, $3ea8894c2d1a8ff8$export$9b30b6294c1449a8).notType);
        });
        this.type = (options == null ? void 0 : options.type) || "mixed";
        this.spec = $bcee4fc8dbde13e1$var$_extends({
            strip: false,
            strict: false,
            abortEarly: true,
            recursive: true,
            nullable: false,
            presence: "optional"
        }, options == null ? void 0 : options.spec);
    }
    get _type() {
        return this.type;
    }
    _typeCheck(_value) {
        return true;
    }
    clone(spec) {
        if (this._mutate) {
            if (spec) Object.assign(this.spec, spec);
            return this;
        } // if the nested value is a schema we can skip cloning, since
        // they are already immutable
        const next = Object.create(Object.getPrototypeOf(this)); // @ts-expect-error this is readonly
        next.type = this.type;
        next._typeError = this._typeError;
        next._whitelistError = this._whitelistError;
        next._blacklistError = this._blacklistError;
        next._whitelist = this._whitelist.clone();
        next._blacklist = this._blacklist.clone();
        next.exclusiveTests = $bcee4fc8dbde13e1$var$_extends({}, this.exclusiveTests); // @ts-expect-error this is readonly
        next.deps = [
            ...this.deps
        ];
        next.conditions = [
            ...this.conditions
        ];
        next.tests = [
            ...this.tests
        ];
        next.transforms = [
            ...this.transforms
        ];
        next.spec = (0, $c20a5baa3b2b3be7$export$2e2bcd8739ae039)($bcee4fc8dbde13e1$var$_extends({}, this.spec, spec));
        return next;
    }
    label(label) {
        let next = this.clone();
        next.spec.label = label;
        return next;
    }
    meta(...args) {
        if (args.length === 0) return this.spec.meta;
        let next = this.clone();
        next.spec.meta = Object.assign(next.spec.meta || {}, args[0]);
        return next;
    }
    //   TCast,
    //   TContext,
    //   TOutput
    // > {
    //   return this as any;
    // }
    withMutation(fn) {
        let before = this._mutate;
        this._mutate = true;
        let result = fn(this);
        this._mutate = before;
        return result;
    }
    concat(schema) {
        if (!schema || schema === this) return this;
        if (schema.type !== this.type && this.type !== "mixed") throw new TypeError(`You cannot \`concat()\` schema's of different types: ${this.type} and ${schema.type}`);
        let base = this;
        let combined = schema.clone();
        const mergedSpec = $bcee4fc8dbde13e1$var$_extends({}, base.spec, combined.spec); // if (combined.spec.nullable === UNSET)
        //   mergedSpec.nullable = base.spec.nullable;
        // if (combined.spec.presence === UNSET)
        //   mergedSpec.presence = base.spec.presence;
        combined.spec = mergedSpec;
        combined._typeError || (combined._typeError = base._typeError);
        combined._whitelistError || (combined._whitelistError = base._whitelistError);
        combined._blacklistError || (combined._blacklistError = base._blacklistError); // manually merge the blacklist/whitelist (the other `schema` takes
        // precedence in case of conflicts)
        combined._whitelist = base._whitelist.merge(schema._whitelist, schema._blacklist);
        combined._blacklist = base._blacklist.merge(schema._blacklist, schema._whitelist); // start with the current tests
        combined.tests = base.tests;
        combined.exclusiveTests = base.exclusiveTests; // manually add the new tests to ensure
        // the deduping logic is consistent
        combined.withMutation((next)=>{
            schema.tests.forEach((fn)=>{
                next.test(fn.OPTIONS);
            });
        });
        combined.transforms = [
            ...base.transforms,
            ...combined.transforms
        ];
        return combined;
    }
    isType(v) {
        if (this.spec.nullable && v === null) return true;
        return this._typeCheck(v);
    }
    resolve(options) {
        let schema = this;
        if (schema.conditions.length) {
            let conditions = schema.conditions;
            schema = schema.clone();
            schema.conditions = [];
            schema = conditions.reduce((schema, condition)=>condition.resolve(schema, options), schema);
            schema = schema.resolve(options);
        }
        return schema;
    }
    /**
   *
   * @param {*} value
   * @param {Object} options
   * @param {*=} options.parent
   * @param {*=} options.context
   */ cast(value, options = {}) {
        let resolvedSchema = this.resolve($bcee4fc8dbde13e1$var$_extends({
            value: value
        }, options));
        let result = resolvedSchema._cast(value, options);
        if (value !== undefined && options.assert !== false && resolvedSchema.isType(result) !== true) {
            let formattedValue = (0, $3bcbbcae986c2431$export$2e2bcd8739ae039)(value);
            let formattedResult = (0, $3bcbbcae986c2431$export$2e2bcd8739ae039)(result);
            throw new TypeError(`The value of ${options.path || "field"} could not be cast to a value ` + `that satisfies the schema type: "${resolvedSchema._type}". \n\n` + `attempted value: ${formattedValue} \n` + (formattedResult !== formattedValue ? `result of cast: ${formattedResult}` : ""));
        }
        return result;
    }
    _cast(rawValue, _options) {
        let value = rawValue === undefined ? rawValue : this.transforms.reduce((value, fn)=>fn.call(this, value, rawValue, this), rawValue);
        if (value === undefined) value = this.getDefault();
        return value;
    }
    _validate(_value, options = {}, cb) {
        let { sync: sync, path: path, from: from = [], originalValue: originalValue = _value, strict: strict = this.spec.strict, abortEarly: abortEarly = this.spec.abortEarly } = options;
        let value = _value;
        if (!strict) // this._validating = true;
        value = this._cast(value, $bcee4fc8dbde13e1$var$_extends({
            assert: false
        }, options)); // this._validating = false;
         // value is cast, we can check if it meets type requirements
        let args = {
            value: value,
            path: path,
            options: options,
            originalValue: originalValue,
            schema: this,
            label: this.spec.label,
            sync: sync,
            from: from
        };
        let initialTests = [];
        if (this._typeError) initialTests.push(this._typeError);
        let finalTests = [];
        if (this._whitelistError) finalTests.push(this._whitelistError);
        if (this._blacklistError) finalTests.push(this._blacklistError);
        (0, $d2d0e6ad55c8832e$export$2e2bcd8739ae039)({
            args: args,
            value: value,
            path: path,
            sync: sync,
            tests: initialTests,
            endEarly: abortEarly
        }, (err)=>{
            if (err) return void cb(err, value);
            (0, $d2d0e6ad55c8832e$export$2e2bcd8739ae039)({
                tests: this.tests.concat(finalTests),
                args: args,
                path: path,
                sync: sync,
                value: value,
                endEarly: abortEarly
            }, cb);
        });
    }
    validate(value, options, maybeCb) {
        let schema = this.resolve($bcee4fc8dbde13e1$var$_extends({}, options, {
            value: value
        })); // callback case is for nested validations
        return typeof maybeCb === "function" ? schema._validate(value, options, maybeCb) : new Promise((resolve, reject)=>schema._validate(value, options, (err, value)=>{
                if (err) reject(err);
                else resolve(value);
            }));
    }
    validateSync(value, options) {
        let schema = this.resolve($bcee4fc8dbde13e1$var$_extends({}, options, {
            value: value
        }));
        let result;
        schema._validate(value, $bcee4fc8dbde13e1$var$_extends({}, options, {
            sync: true
        }), (err, value)=>{
            if (err) throw err;
            result = value;
        });
        return result;
    }
    isValid(value, options) {
        return this.validate(value, options).then(()=>true, (err)=>{
            if ((0, $d2e70d35996a7daf$export$2e2bcd8739ae039).isError(err)) return false;
            throw err;
        });
    }
    isValidSync(value, options) {
        try {
            this.validateSync(value, options);
            return true;
        } catch (err) {
            if ((0, $d2e70d35996a7daf$export$2e2bcd8739ae039).isError(err)) return false;
            throw err;
        }
    }
    _getDefault() {
        let defaultValue = this.spec.default;
        if (defaultValue == null) return defaultValue;
        return typeof defaultValue === "function" ? defaultValue.call(this) : (0, $c20a5baa3b2b3be7$export$2e2bcd8739ae039)(defaultValue);
    }
    getDefault(options) {
        let schema = this.resolve(options || {});
        return schema._getDefault();
    }
    default(def) {
        if (arguments.length === 0) return this._getDefault();
        let next = this.clone({
            default: def
        });
        return next;
    }
    strict(isStrict = true) {
        let next = this.clone();
        next.spec.strict = isStrict;
        return next;
    }
    _isPresent(value) {
        return value != null;
    }
    defined(message = (0, $3ea8894c2d1a8ff8$export$9b30b6294c1449a8).defined) {
        return this.test({
            message: message,
            name: "defined",
            exclusive: true,
            test (value) {
                return value !== undefined;
            }
        });
    }
    required(message = (0, $3ea8894c2d1a8ff8$export$9b30b6294c1449a8).required) {
        return this.clone({
            presence: "required"
        }).withMutation((s)=>s.test({
                message: message,
                name: "required",
                exclusive: true,
                test (value) {
                    return this.schema._isPresent(value);
                }
            }));
    }
    notRequired() {
        let next = this.clone({
            presence: "optional"
        });
        next.tests = next.tests.filter((test)=>test.OPTIONS.name !== "required");
        return next;
    }
    nullable(isNullable = true) {
        let next = this.clone({
            nullable: isNullable !== false
        });
        return next;
    }
    transform(fn) {
        let next = this.clone();
        next.transforms.push(fn);
        return next;
    }
    /**
   * Adds a test function to the schema's queue of tests.
   * tests can be exclusive or non-exclusive.
   *
   * - exclusive tests, will replace any existing tests of the same name.
   * - non-exclusive: can be stacked
   *
   * If a non-exclusive test is added to a schema with an exclusive test of the same name
   * the exclusive test is removed and further tests of the same name will be stacked.
   *
   * If an exclusive test is added to a schema with non-exclusive tests of the same name
   * the previous tests are removed and further tests of the same name will replace each other.
   */ test(...args) {
        let opts;
        if (args.length === 1) {
            if (typeof args[0] === "function") opts = {
                test: args[0]
            };
            else opts = args[0];
        } else if (args.length === 2) opts = {
            name: args[0],
            test: args[1]
        };
        else opts = {
            name: args[0],
            message: args[1],
            test: args[2]
        };
        if (opts.message === undefined) opts.message = (0, $3ea8894c2d1a8ff8$export$9b30b6294c1449a8).default;
        if (typeof opts.test !== "function") throw new TypeError("`test` is a required parameters");
        let next = this.clone();
        let validate = (0, $7c576e9ad8044c54$export$2e2bcd8739ae039)(opts);
        let isExclusive = opts.exclusive || opts.name && next.exclusiveTests[opts.name] === true;
        if (opts.exclusive) {
            if (!opts.name) throw new TypeError("Exclusive tests must provide a unique `name` identifying the test");
        }
        if (opts.name) next.exclusiveTests[opts.name] = !!opts.exclusive;
        next.tests = next.tests.filter((fn)=>{
            if (fn.OPTIONS.name === opts.name) {
                if (isExclusive) return false;
                if (fn.OPTIONS.test === validate.OPTIONS.test) return false;
            }
            return true;
        });
        next.tests.push(validate);
        return next;
    }
    when(keys, options) {
        if (!Array.isArray(keys) && typeof keys !== "string") {
            options = keys;
            keys = ".";
        }
        let next = this.clone();
        let deps = (0, $245da59127fdc582$export$2e2bcd8739ae039)(keys).map((key)=>new (0, $f5cdfa956e941194$export$2e2bcd8739ae039)(key));
        deps.forEach((dep)=>{
            // @ts-ignore
            if (dep.isSibling) next.deps.push(dep.key);
        });
        next.conditions.push(new (0, $7e653e8008789a27$export$2e2bcd8739ae039)(deps, options));
        return next;
    }
    typeError(message) {
        let next = this.clone();
        next._typeError = (0, $7c576e9ad8044c54$export$2e2bcd8739ae039)({
            message: message,
            name: "typeError",
            test (value) {
                if (value !== undefined && !this.schema.isType(value)) return this.createError({
                    params: {
                        type: this.schema._type
                    }
                });
                return true;
            }
        });
        return next;
    }
    oneOf(enums, message = (0, $3ea8894c2d1a8ff8$export$9b30b6294c1449a8).oneOf) {
        let next = this.clone();
        enums.forEach((val)=>{
            next._whitelist.add(val);
            next._blacklist.delete(val);
        });
        next._whitelistError = (0, $7c576e9ad8044c54$export$2e2bcd8739ae039)({
            message: message,
            name: "oneOf",
            test (value) {
                if (value === undefined) return true;
                let valids = this.schema._whitelist;
                let resolved = valids.resolveAll(this.resolve);
                return resolved.includes(value) ? true : this.createError({
                    params: {
                        values: valids.toArray().join(", "),
                        resolved: resolved
                    }
                });
            }
        });
        return next;
    }
    notOneOf(enums, message = (0, $3ea8894c2d1a8ff8$export$9b30b6294c1449a8).notOneOf) {
        let next = this.clone();
        enums.forEach((val)=>{
            next._blacklist.add(val);
            next._whitelist.delete(val);
        });
        next._blacklistError = (0, $7c576e9ad8044c54$export$2e2bcd8739ae039)({
            message: message,
            name: "notOneOf",
            test (value) {
                let invalids = this.schema._blacklist;
                let resolved = invalids.resolveAll(this.resolve);
                if (resolved.includes(value)) return this.createError({
                    params: {
                        values: invalids.toArray().join(", "),
                        resolved: resolved
                    }
                });
                return true;
            }
        });
        return next;
    }
    strip(strip = true) {
        let next = this.clone();
        next.spec.strip = strip;
        return next;
    }
    describe() {
        const next = this.clone();
        const { label: label, meta: meta } = next.spec;
        const description = {
            meta: meta,
            label: label,
            type: next.type,
            oneOf: next._whitelist.describe(),
            notOneOf: next._blacklist.describe(),
            tests: next.tests.map((fn)=>({
                    name: fn.OPTIONS.name,
                    params: fn.OPTIONS.params
                })).filter((n, idx, list)=>list.findIndex((c)=>c.name === n.name) === idx)
        };
        return description;
    }
} // eslint-disable-next-line @typescript-eslint/no-unused-vars
// @ts-expect-error
$bcee4fc8dbde13e1$export$2e2bcd8739ae039.prototype.__isYupSchema__ = true;
for (const method of [
    "validate",
    "validateSync"
])$bcee4fc8dbde13e1$export$2e2bcd8739ae039.prototype[`${method}At`] = function(path, value, options = {}) {
    const { parent: parent, parentPath: parentPath, schema: schema } = (0, $5b552ca0a6c1ed5f$export$c52e5867d5879e24)(this, path, value, options.context);
    return schema[method](parent && parent[parentPath], $bcee4fc8dbde13e1$var$_extends({}, options, {
        parent: parent,
        path: path
    }));
};
for (const alias of [
    "equals",
    "is"
])$bcee4fc8dbde13e1$export$2e2bcd8739ae039.prototype[alias] = $bcee4fc8dbde13e1$export$2e2bcd8739ae039.prototype.oneOf;
for (const alias of [
    "not",
    "nope"
])$bcee4fc8dbde13e1$export$2e2bcd8739ae039.prototype[alias] = $bcee4fc8dbde13e1$export$2e2bcd8739ae039.prototype.notOneOf;
$bcee4fc8dbde13e1$export$2e2bcd8739ae039.prototype.optional = $bcee4fc8dbde13e1$export$2e2bcd8739ae039.prototype.notRequired;


const $9baedbe56e25b51a$var$Mixed = (0, $bcee4fc8dbde13e1$export$2e2bcd8739ae039);
var $9baedbe56e25b51a$export$2e2bcd8739ae039 = $9baedbe56e25b51a$var$Mixed;
function $9baedbe56e25b51a$export$185802fd694ee1f5() {
    return new $9baedbe56e25b51a$var$Mixed();
} // XXX: this is using the Base schema so that `addMethod(mixed)` works as a base class
$9baedbe56e25b51a$export$185802fd694ee1f5.prototype = $9baedbe56e25b51a$var$Mixed.prototype;




const $55daa1cd95624d91$var$isAbsent = (value)=>value == null;
var $55daa1cd95624d91$export$2e2bcd8739ae039 = $55daa1cd95624d91$var$isAbsent;


function $0237b22d97657ad7$export$185802fd694ee1f5() {
    return new $0237b22d97657ad7$export$2e2bcd8739ae039();
}
class $0237b22d97657ad7$export$2e2bcd8739ae039 extends (0, $bcee4fc8dbde13e1$export$2e2bcd8739ae039) {
    constructor(){
        super({
            type: "boolean"
        });
        this.withMutation(()=>{
            this.transform(function(value) {
                if (!this.isType(value)) {
                    if (/^(true|1)$/i.test(String(value))) return true;
                    if (/^(false|0)$/i.test(String(value))) return false;
                }
                return value;
            });
        });
    }
    _typeCheck(v) {
        if (v instanceof Boolean) v = v.valueOf();
        return typeof v === "boolean";
    }
    isTrue(message = (0, $3ea8894c2d1a8ff8$export$4a21f16c33752377).isValue) {
        return this.test({
            message: message,
            name: "is-value",
            exclusive: true,
            params: {
                value: "true"
            },
            test (value) {
                return (0, $55daa1cd95624d91$export$2e2bcd8739ae039)(value) || value === true;
            }
        });
    }
    isFalse(message = (0, $3ea8894c2d1a8ff8$export$4a21f16c33752377).isValue) {
        return this.test({
            message: message,
            name: "is-value",
            exclusive: true,
            params: {
                value: "false"
            },
            test (value) {
                return (0, $55daa1cd95624d91$export$2e2bcd8739ae039)(value) || value === false;
            }
        });
    }
}
$0237b22d97657ad7$export$185802fd694ee1f5.prototype = $0237b22d97657ad7$export$2e2bcd8739ae039.prototype;





let $bcc252d93ab3046c$var$rEmail = /^((([a-z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+(\.([a-z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+)*)|((\x22)((((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(([\x01-\x08\x0b\x0c\x0e-\x1f\x7f]|\x21|[\x23-\x5b]|[\x5d-\x7e]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(\\([\x01-\x09\x0b\x0c\x0d-\x7f]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]))))*(((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(\x22)))@((([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.)+(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))$/i; // eslint-disable-next-line
let $bcc252d93ab3046c$var$rUrl = /^((https?|ftp):)?\/\/(((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:)*@)?(((\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5])\.(\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5])\.(\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5])\.(\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5]))|((([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.)+(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.?)(:\d*)?)(\/((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)+(\/(([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)*)*)?)?(\?((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)|[\uE000-\uF8FF]|\/|\?)*)?(\#((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)|\/|\?)*)?$/i; // eslint-disable-next-line
let $bcc252d93ab3046c$var$rUUID = /^(?:[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}|00000000-0000-0000-0000-000000000000)$/i;
let $bcc252d93ab3046c$var$isTrimmed = (value)=>(0, $55daa1cd95624d91$export$2e2bcd8739ae039)(value) || value === value.trim();
let $bcc252d93ab3046c$var$objStringTag = ({}).toString();
function $bcc252d93ab3046c$export$185802fd694ee1f5() {
    return new $bcc252d93ab3046c$export$2e2bcd8739ae039();
}
class $bcc252d93ab3046c$export$2e2bcd8739ae039 extends (0, $bcee4fc8dbde13e1$export$2e2bcd8739ae039) {
    constructor(){
        super({
            type: "string"
        });
        this.withMutation(()=>{
            this.transform(function(value) {
                if (this.isType(value)) return value;
                if (Array.isArray(value)) return value;
                const strValue = value != null && value.toString ? value.toString() : value;
                if (strValue === $bcc252d93ab3046c$var$objStringTag) return value;
                return strValue;
            });
        });
    }
    _typeCheck(value) {
        if (value instanceof String) value = value.valueOf();
        return typeof value === "string";
    }
    _isPresent(value) {
        return super._isPresent(value) && !!value.length;
    }
    length(length, message = (0, $3ea8894c2d1a8ff8$export$22b082955e083ec3).length) {
        return this.test({
            message: message,
            name: "length",
            exclusive: true,
            params: {
                length: length
            },
            test (value) {
                return (0, $55daa1cd95624d91$export$2e2bcd8739ae039)(value) || value.length === this.resolve(length);
            }
        });
    }
    min(min, message = (0, $3ea8894c2d1a8ff8$export$22b082955e083ec3).min) {
        return this.test({
            message: message,
            name: "min",
            exclusive: true,
            params: {
                min: min
            },
            test (value) {
                return (0, $55daa1cd95624d91$export$2e2bcd8739ae039)(value) || value.length >= this.resolve(min);
            }
        });
    }
    max(max, message = (0, $3ea8894c2d1a8ff8$export$22b082955e083ec3).max) {
        return this.test({
            name: "max",
            exclusive: true,
            message: message,
            params: {
                max: max
            },
            test (value) {
                return (0, $55daa1cd95624d91$export$2e2bcd8739ae039)(value) || value.length <= this.resolve(max);
            }
        });
    }
    matches(regex, options) {
        let excludeEmptyString = false;
        let message;
        let name;
        if (options) {
            if (typeof options === "object") ({ excludeEmptyString: excludeEmptyString = false, message: message, name: name } = options);
            else message = options;
        }
        return this.test({
            name: name || "matches",
            message: message || (0, $3ea8894c2d1a8ff8$export$22b082955e083ec3).matches,
            params: {
                regex: regex
            },
            test: (value)=>(0, $55daa1cd95624d91$export$2e2bcd8739ae039)(value) || value === "" && excludeEmptyString || value.search(regex) !== -1
        });
    }
    email(message = (0, $3ea8894c2d1a8ff8$export$22b082955e083ec3).email) {
        return this.matches($bcc252d93ab3046c$var$rEmail, {
            name: "email",
            message: message,
            excludeEmptyString: true
        });
    }
    url(message = (0, $3ea8894c2d1a8ff8$export$22b082955e083ec3).url) {
        return this.matches($bcc252d93ab3046c$var$rUrl, {
            name: "url",
            message: message,
            excludeEmptyString: true
        });
    }
    uuid(message = (0, $3ea8894c2d1a8ff8$export$22b082955e083ec3).uuid) {
        return this.matches($bcc252d93ab3046c$var$rUUID, {
            name: "uuid",
            message: message,
            excludeEmptyString: false
        });
    }
    ensure() {
        return this.default("").transform((val)=>val === null ? "" : val);
    }
    trim(message = (0, $3ea8894c2d1a8ff8$export$22b082955e083ec3).trim) {
        return this.transform((val)=>val != null ? val.trim() : val).test({
            message: message,
            name: "trim",
            test: $bcc252d93ab3046c$var$isTrimmed
        });
    }
    lowercase(message = (0, $3ea8894c2d1a8ff8$export$22b082955e083ec3).lowercase) {
        return this.transform((value)=>!(0, $55daa1cd95624d91$export$2e2bcd8739ae039)(value) ? value.toLowerCase() : value).test({
            message: message,
            name: "string_case",
            exclusive: true,
            test: (value)=>(0, $55daa1cd95624d91$export$2e2bcd8739ae039)(value) || value === value.toLowerCase()
        });
    }
    uppercase(message = (0, $3ea8894c2d1a8ff8$export$22b082955e083ec3).uppercase) {
        return this.transform((value)=>!(0, $55daa1cd95624d91$export$2e2bcd8739ae039)(value) ? value.toUpperCase() : value).test({
            message: message,
            name: "string_case",
            exclusive: true,
            test: (value)=>(0, $55daa1cd95624d91$export$2e2bcd8739ae039)(value) || value === value.toUpperCase()
        });
    }
}
$bcc252d93ab3046c$export$185802fd694ee1f5.prototype = $bcc252d93ab3046c$export$2e2bcd8739ae039.prototype; //
 // String Interfaces
 //





let $425f4614c2bd74f2$var$isNaN = (value)=>value != +value;
function $425f4614c2bd74f2$export$185802fd694ee1f5() {
    return new $425f4614c2bd74f2$export$2e2bcd8739ae039();
}
class $425f4614c2bd74f2$export$2e2bcd8739ae039 extends (0, $bcee4fc8dbde13e1$export$2e2bcd8739ae039) {
    constructor(){
        super({
            type: "number"
        });
        this.withMutation(()=>{
            this.transform(function(value) {
                let parsed = value;
                if (typeof parsed === "string") {
                    parsed = parsed.replace(/\s/g, "");
                    if (parsed === "") return NaN; // don't use parseFloat to avoid positives on alpha-numeric strings
                    parsed = +parsed;
                }
                if (this.isType(parsed)) return parsed;
                return parseFloat(parsed);
            });
        });
    }
    _typeCheck(value) {
        if (value instanceof Number) value = value.valueOf();
        return typeof value === "number" && !$425f4614c2bd74f2$var$isNaN(value);
    }
    min(min, message = (0, $3ea8894c2d1a8ff8$export$98e628dec113755e).min) {
        return this.test({
            message: message,
            name: "min",
            exclusive: true,
            params: {
                min: min
            },
            test (value) {
                return (0, $55daa1cd95624d91$export$2e2bcd8739ae039)(value) || value >= this.resolve(min);
            }
        });
    }
    max(max, message = (0, $3ea8894c2d1a8ff8$export$98e628dec113755e).max) {
        return this.test({
            message: message,
            name: "max",
            exclusive: true,
            params: {
                max: max
            },
            test (value) {
                return (0, $55daa1cd95624d91$export$2e2bcd8739ae039)(value) || value <= this.resolve(max);
            }
        });
    }
    lessThan(less, message = (0, $3ea8894c2d1a8ff8$export$98e628dec113755e).lessThan) {
        return this.test({
            message: message,
            name: "max",
            exclusive: true,
            params: {
                less: less
            },
            test (value) {
                return (0, $55daa1cd95624d91$export$2e2bcd8739ae039)(value) || value < this.resolve(less);
            }
        });
    }
    moreThan(more, message = (0, $3ea8894c2d1a8ff8$export$98e628dec113755e).moreThan) {
        return this.test({
            message: message,
            name: "min",
            exclusive: true,
            params: {
                more: more
            },
            test (value) {
                return (0, $55daa1cd95624d91$export$2e2bcd8739ae039)(value) || value > this.resolve(more);
            }
        });
    }
    positive(msg = (0, $3ea8894c2d1a8ff8$export$98e628dec113755e).positive) {
        return this.moreThan(0, msg);
    }
    negative(msg = (0, $3ea8894c2d1a8ff8$export$98e628dec113755e).negative) {
        return this.lessThan(0, msg);
    }
    integer(message = (0, $3ea8894c2d1a8ff8$export$98e628dec113755e).integer) {
        return this.test({
            name: "integer",
            message: message,
            test: (val)=>(0, $55daa1cd95624d91$export$2e2bcd8739ae039)(val) || Number.isInteger(val)
        });
    }
    truncate() {
        return this.transform((value)=>!(0, $55daa1cd95624d91$export$2e2bcd8739ae039)(value) ? value | 0 : value);
    }
    round(method) {
        var _method;
        let avail = [
            "ceil",
            "floor",
            "round",
            "trunc"
        ];
        method = ((_method = method) == null ? void 0 : _method.toLowerCase()) || "round"; // this exists for symemtry with the new Math.trunc
        if (method === "trunc") return this.truncate();
        if (avail.indexOf(method.toLowerCase()) === -1) throw new TypeError("Only valid options for round() are: " + avail.join(", "));
        return this.transform((value)=>!(0, $55daa1cd95624d91$export$2e2bcd8739ae039)(value) ? Math[method](value) : value);
    }
}
$425f4614c2bd74f2$export$185802fd694ee1f5.prototype = $425f4614c2bd74f2$export$2e2bcd8739ae039.prototype; //
 // Number Interfaces
 //


// @ts-ignore
/* eslint-disable */ /**
 *
 * Date.parse with progressive enhancement for ISO 8601 <https://github.com/csnover/js-iso8601>
 * NON-CONFORMANT EDITION.
 * © 2011 Colin Snover <http://zetafleet.com>
 * Released under MIT license.
 */ //              1 YYYY                 2 MM        3 DD              4 HH     5 mm        6 ss            7 msec         8 Z 9 ±    10 tzHH    11 tzmm
var $7b96554ad88dbbc3$var$isoReg = /^(\d{4}|[+\-]\d{6})(?:-?(\d{2})(?:-?(\d{2}))?)?(?:[ T]?(\d{2}):?(\d{2})(?::?(\d{2})(?:[,\.](\d{1,}))?)?(?:(Z)|([+\-])(\d{2})(?::?(\d{2}))?)?)?$/;
function $7b96554ad88dbbc3$export$2e2bcd8739ae039(date) {
    var numericKeys = [
        1,
        4,
        5,
        6,
        7,
        10,
        11
    ], minutesOffset = 0, timestamp, struct;
    if (struct = $7b96554ad88dbbc3$var$isoReg.exec(date)) {
        // avoid NaN timestamps caused by “undefined” values being passed to Date.UTC
        for(var i = 0, k; k = numericKeys[i]; ++i)struct[k] = +struct[k] || 0; // allow undefined days and months
        struct[2] = (+struct[2] || 1) - 1;
        struct[3] = +struct[3] || 1; // allow arbitrary sub-second precision beyond milliseconds
        struct[7] = struct[7] ? String(struct[7]).substr(0, 3) : 0; // timestamps without timezone identifiers should be considered local time
        if ((struct[8] === undefined || struct[8] === "") && (struct[9] === undefined || struct[9] === "")) timestamp = +new Date(struct[1], struct[2], struct[3], struct[4], struct[5], struct[6], struct[7]);
        else {
            if (struct[8] !== "Z" && struct[9] !== undefined) {
                minutesOffset = struct[10] * 60 + struct[11];
                if (struct[9] === "+") minutesOffset = 0 - minutesOffset;
            }
            timestamp = Date.UTC(struct[1], struct[2], struct[3], struct[4], struct[5] + minutesOffset, struct[6], struct[7]);
        }
    } else timestamp = Date.parse ? Date.parse(date) : NaN;
    return timestamp;
}






let $647598aeb0c659d9$var$invalidDate = new Date("");
let $647598aeb0c659d9$var$isDate = (obj)=>Object.prototype.toString.call(obj) === "[object Date]";
function $647598aeb0c659d9$export$185802fd694ee1f5() {
    return new $647598aeb0c659d9$export$2e2bcd8739ae039();
}
class $647598aeb0c659d9$export$2e2bcd8739ae039 extends (0, $bcee4fc8dbde13e1$export$2e2bcd8739ae039) {
    constructor(){
        super({
            type: "date"
        });
        this.withMutation(()=>{
            this.transform(function(value) {
                if (this.isType(value)) return value;
                value = (0, $7b96554ad88dbbc3$export$2e2bcd8739ae039)(value); // 0 is a valid timestamp equivalent to 1970-01-01T00:00:00Z(unix epoch) or before.
                return !isNaN(value) ? new Date(value) : $647598aeb0c659d9$var$invalidDate;
            });
        });
    }
    _typeCheck(v) {
        return $647598aeb0c659d9$var$isDate(v) && !isNaN(v.getTime());
    }
    prepareParam(ref, name) {
        let param;
        if (!(0, $f5cdfa956e941194$export$2e2bcd8739ae039).isRef(ref)) {
            let cast = this.cast(ref);
            if (!this._typeCheck(cast)) throw new TypeError(`\`${name}\` must be a Date or a value that can be \`cast()\` to a Date`);
            param = cast;
        } else param = ref;
        return param;
    }
    min(min, message = (0, $3ea8894c2d1a8ff8$export$324d90190a8b822a).min) {
        let limit = this.prepareParam(min, "min");
        return this.test({
            message: message,
            name: "min",
            exclusive: true,
            params: {
                min: min
            },
            test (value) {
                return (0, $55daa1cd95624d91$export$2e2bcd8739ae039)(value) || value >= this.resolve(limit);
            }
        });
    }
    max(max, message = (0, $3ea8894c2d1a8ff8$export$324d90190a8b822a).max) {
        let limit = this.prepareParam(max, "max");
        return this.test({
            message: message,
            name: "max",
            exclusive: true,
            params: {
                max: max
            },
            test (value) {
                return (0, $55daa1cd95624d91$export$2e2bcd8739ae039)(value) || value <= this.resolve(limit);
            }
        });
    }
}
$647598aeb0c659d9$export$2e2bcd8739ae039.INVALID_DATE = $647598aeb0c659d9$var$invalidDate;
$647598aeb0c659d9$export$185802fd694ee1f5.prototype = $647598aeb0c659d9$export$2e2bcd8739ae039.prototype;
$647598aeb0c659d9$export$185802fd694ee1f5.INVALID_DATE = $647598aeb0c659d9$var$invalidDate;



var $4f0248df72a92950$exports = {};
var $0b2d21aee1d97729$exports = {};
var $1389b3710f5da9e8$exports = {};
/**
 * A specialized version of `_.reduce` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {*} [accumulator] The initial value.
 * @param {boolean} [initAccum] Specify using the first element of `array` as
 *  the initial value.
 * @returns {*} Returns the accumulated value.
 */ function $1389b3710f5da9e8$var$arrayReduce(array, iteratee, accumulator, initAccum) {
    var index = -1, length = array == null ? 0 : array.length;
    if (initAccum && length) accumulator = array[++index];
    while(++index < length)accumulator = iteratee(accumulator, array[index], index, array);
    return accumulator;
}
$1389b3710f5da9e8$exports = $1389b3710f5da9e8$var$arrayReduce;


var $ed80fa8833e2b532$exports = {};
var $3384256242a1b577$exports = {};
var $dcb2a7eb44d37cba$exports = {};
/**
 * The base implementation of `_.propertyOf` without support for deep paths.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Function} Returns the new accessor function.
 */ function $dcb2a7eb44d37cba$var$basePropertyOf(object) {
    return function(key) {
        return object == null ? undefined : object[key];
    };
}
$dcb2a7eb44d37cba$exports = $dcb2a7eb44d37cba$var$basePropertyOf;


/** Used to map Latin Unicode letters to basic Latin letters. */ var $3384256242a1b577$var$deburredLetters = {
    // Latin-1 Supplement block.
    "\xc0": "A",
    "\xc1": "A",
    "\xc2": "A",
    "\xc3": "A",
    "\xc4": "A",
    "\xc5": "A",
    "\xe0": "a",
    "\xe1": "a",
    "\xe2": "a",
    "\xe3": "a",
    "\xe4": "a",
    "\xe5": "a",
    "\xc7": "C",
    "\xe7": "c",
    "\xd0": "D",
    "\xf0": "d",
    "\xc8": "E",
    "\xc9": "E",
    "\xca": "E",
    "\xcb": "E",
    "\xe8": "e",
    "\xe9": "e",
    "\xea": "e",
    "\xeb": "e",
    "\xcc": "I",
    "\xcd": "I",
    "\xce": "I",
    "\xcf": "I",
    "\xec": "i",
    "\xed": "i",
    "\xee": "i",
    "\xef": "i",
    "\xd1": "N",
    "\xf1": "n",
    "\xd2": "O",
    "\xd3": "O",
    "\xd4": "O",
    "\xd5": "O",
    "\xd6": "O",
    "\xd8": "O",
    "\xf2": "o",
    "\xf3": "o",
    "\xf4": "o",
    "\xf5": "o",
    "\xf6": "o",
    "\xf8": "o",
    "\xd9": "U",
    "\xda": "U",
    "\xdb": "U",
    "\xdc": "U",
    "\xf9": "u",
    "\xfa": "u",
    "\xfb": "u",
    "\xfc": "u",
    "\xdd": "Y",
    "\xfd": "y",
    "\xff": "y",
    "\xc6": "Ae",
    "\xe6": "ae",
    "\xde": "Th",
    "\xfe": "th",
    "\xdf": "ss",
    // Latin Extended-A block.
    "\u0100": "A",
    "\u0102": "A",
    "\u0104": "A",
    "\u0101": "a",
    "\u0103": "a",
    "\u0105": "a",
    "\u0106": "C",
    "\u0108": "C",
    "\u010A": "C",
    "\u010C": "C",
    "\u0107": "c",
    "\u0109": "c",
    "\u010B": "c",
    "\u010D": "c",
    "\u010E": "D",
    "\u0110": "D",
    "\u010F": "d",
    "\u0111": "d",
    "\u0112": "E",
    "\u0114": "E",
    "\u0116": "E",
    "\u0118": "E",
    "\u011A": "E",
    "\u0113": "e",
    "\u0115": "e",
    "\u0117": "e",
    "\u0119": "e",
    "\u011B": "e",
    "\u011C": "G",
    "\u011E": "G",
    "\u0120": "G",
    "\u0122": "G",
    "\u011D": "g",
    "\u011F": "g",
    "\u0121": "g",
    "\u0123": "g",
    "\u0124": "H",
    "\u0126": "H",
    "\u0125": "h",
    "\u0127": "h",
    "\u0128": "I",
    "\u012A": "I",
    "\u012C": "I",
    "\u012E": "I",
    "\u0130": "I",
    "\u0129": "i",
    "\u012B": "i",
    "\u012D": "i",
    "\u012F": "i",
    "\u0131": "i",
    "\u0134": "J",
    "\u0135": "j",
    "\u0136": "K",
    "\u0137": "k",
    "\u0138": "k",
    "\u0139": "L",
    "\u013B": "L",
    "\u013D": "L",
    "\u013F": "L",
    "\u0141": "L",
    "\u013A": "l",
    "\u013C": "l",
    "\u013E": "l",
    "\u0140": "l",
    "\u0142": "l",
    "\u0143": "N",
    "\u0145": "N",
    "\u0147": "N",
    "\u014A": "N",
    "\u0144": "n",
    "\u0146": "n",
    "\u0148": "n",
    "\u014B": "n",
    "\u014C": "O",
    "\u014E": "O",
    "\u0150": "O",
    "\u014D": "o",
    "\u014F": "o",
    "\u0151": "o",
    "\u0154": "R",
    "\u0156": "R",
    "\u0158": "R",
    "\u0155": "r",
    "\u0157": "r",
    "\u0159": "r",
    "\u015A": "S",
    "\u015C": "S",
    "\u015E": "S",
    "\u0160": "S",
    "\u015B": "s",
    "\u015D": "s",
    "\u015F": "s",
    "\u0161": "s",
    "\u0162": "T",
    "\u0164": "T",
    "\u0166": "T",
    "\u0163": "t",
    "\u0165": "t",
    "\u0167": "t",
    "\u0168": "U",
    "\u016A": "U",
    "\u016C": "U",
    "\u016E": "U",
    "\u0170": "U",
    "\u0172": "U",
    "\u0169": "u",
    "\u016B": "u",
    "\u016D": "u",
    "\u016F": "u",
    "\u0171": "u",
    "\u0173": "u",
    "\u0174": "W",
    "\u0175": "w",
    "\u0176": "Y",
    "\u0177": "y",
    "\u0178": "Y",
    "\u0179": "Z",
    "\u017B": "Z",
    "\u017D": "Z",
    "\u017A": "z",
    "\u017C": "z",
    "\u017E": "z",
    "\u0132": "IJ",
    "\u0133": "ij",
    "\u0152": "Oe",
    "\u0153": "oe",
    "\u0149": "'n",
    "\u017F": "s"
};
/**
 * Used by `_.deburr` to convert Latin-1 Supplement and Latin Extended-A
 * letters to basic Latin letters.
 *
 * @private
 * @param {string} letter The matched letter to deburr.
 * @returns {string} Returns the deburred letter.
 */ var $3384256242a1b577$var$deburrLetter = $dcb2a7eb44d37cba$exports($3384256242a1b577$var$deburredLetters);
$3384256242a1b577$exports = $3384256242a1b577$var$deburrLetter;



/** Used to match Latin Unicode letters (excluding mathematical operators). */ var $ed80fa8833e2b532$var$reLatin = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g;
/** Used to compose unicode character classes. */ var $ed80fa8833e2b532$var$rsComboMarksRange = "\\u0300-\\u036f", $ed80fa8833e2b532$var$reComboHalfMarksRange = "\\ufe20-\\ufe2f", $ed80fa8833e2b532$var$rsComboSymbolsRange = "\\u20d0-\\u20ff", $ed80fa8833e2b532$var$rsComboRange = $ed80fa8833e2b532$var$rsComboMarksRange + $ed80fa8833e2b532$var$reComboHalfMarksRange + $ed80fa8833e2b532$var$rsComboSymbolsRange;
/** Used to compose unicode capture groups. */ var $ed80fa8833e2b532$var$rsCombo = "[" + $ed80fa8833e2b532$var$rsComboRange + "]";
/**
 * Used to match [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks) and
 * [combining diacritical marks for symbols](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks_for_Symbols).
 */ var $ed80fa8833e2b532$var$reComboMark = RegExp($ed80fa8833e2b532$var$rsCombo, "g");
/**
 * Deburrs `string` by converting
 * [Latin-1 Supplement](https://en.wikipedia.org/wiki/Latin-1_Supplement_(Unicode_block)#Character_table)
 * and [Latin Extended-A](https://en.wikipedia.org/wiki/Latin_Extended-A)
 * letters to basic Latin letters and removing
 * [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks).
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category String
 * @param {string} [string=''] The string to deburr.
 * @returns {string} Returns the deburred string.
 * @example
 *
 * _.deburr('déjà vu');
 * // => 'deja vu'
 */ function $ed80fa8833e2b532$var$deburr(string) {
    string = $f5d9385a9cc7e413$exports(string);
    return string && string.replace($ed80fa8833e2b532$var$reLatin, $3384256242a1b577$exports).replace($ed80fa8833e2b532$var$reComboMark, "");
}
$ed80fa8833e2b532$exports = $ed80fa8833e2b532$var$deburr;


var $12f2ccb7e11b3895$exports = {};
var $7e165cbd28a9af51$exports = {};
/** Used to match words composed of alphanumeric characters. */ var $7e165cbd28a9af51$var$reAsciiWord = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g;
/**
 * Splits an ASCII `string` into an array of its words.
 *
 * @private
 * @param {string} The string to inspect.
 * @returns {Array} Returns the words of `string`.
 */ function $7e165cbd28a9af51$var$asciiWords(string) {
    return string.match($7e165cbd28a9af51$var$reAsciiWord) || [];
}
$7e165cbd28a9af51$exports = $7e165cbd28a9af51$var$asciiWords;


var $8688e0b23f5a081b$exports = {};
/** Used to detect strings that need a more robust regexp to match words. */ var $8688e0b23f5a081b$var$reHasUnicodeWord = /[a-z][A-Z]|[A-Z]{2}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/;
/**
 * Checks if `string` contains a word composed of Unicode symbols.
 *
 * @private
 * @param {string} string The string to inspect.
 * @returns {boolean} Returns `true` if a word is found, else `false`.
 */ function $8688e0b23f5a081b$var$hasUnicodeWord(string) {
    return $8688e0b23f5a081b$var$reHasUnicodeWord.test(string);
}
$8688e0b23f5a081b$exports = $8688e0b23f5a081b$var$hasUnicodeWord;



var $325a565efdffbc96$exports = {};
/** Used to compose unicode character classes. */ var $325a565efdffbc96$var$rsAstralRange = "\ud800-\udfff", $325a565efdffbc96$var$rsComboMarksRange = "\\u0300-\\u036f", $325a565efdffbc96$var$reComboHalfMarksRange = "\\ufe20-\\ufe2f", $325a565efdffbc96$var$rsComboSymbolsRange = "\\u20d0-\\u20ff", $325a565efdffbc96$var$rsComboRange = $325a565efdffbc96$var$rsComboMarksRange + $325a565efdffbc96$var$reComboHalfMarksRange + $325a565efdffbc96$var$rsComboSymbolsRange, $325a565efdffbc96$var$rsDingbatRange = "\\u2700-\\u27bf", $325a565efdffbc96$var$rsLowerRange = "a-z\\xdf-\\xf6\\xf8-\\xff", $325a565efdffbc96$var$rsMathOpRange = "\\xac\\xb1\\xd7\\xf7", $325a565efdffbc96$var$rsNonCharRange = "\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf", $325a565efdffbc96$var$rsPunctuationRange = "\\u2000-\\u206f", $325a565efdffbc96$var$rsSpaceRange = " \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000", $325a565efdffbc96$var$rsUpperRange = "A-Z\\xc0-\\xd6\\xd8-\\xde", $325a565efdffbc96$var$rsVarRange = "\\ufe0e\\ufe0f", $325a565efdffbc96$var$rsBreakRange = $325a565efdffbc96$var$rsMathOpRange + $325a565efdffbc96$var$rsNonCharRange + $325a565efdffbc96$var$rsPunctuationRange + $325a565efdffbc96$var$rsSpaceRange;
/** Used to compose unicode capture groups. */ var $325a565efdffbc96$var$rsApos = "['\u2019]", $325a565efdffbc96$var$rsBreak = "[" + $325a565efdffbc96$var$rsBreakRange + "]", $325a565efdffbc96$var$rsCombo = "[" + $325a565efdffbc96$var$rsComboRange + "]", $325a565efdffbc96$var$rsDigits = "\\d+", $325a565efdffbc96$var$rsDingbat = "[" + $325a565efdffbc96$var$rsDingbatRange + "]", $325a565efdffbc96$var$rsLower = "[" + $325a565efdffbc96$var$rsLowerRange + "]", $325a565efdffbc96$var$rsMisc = "[^" + $325a565efdffbc96$var$rsAstralRange + $325a565efdffbc96$var$rsBreakRange + $325a565efdffbc96$var$rsDigits + $325a565efdffbc96$var$rsDingbatRange + $325a565efdffbc96$var$rsLowerRange + $325a565efdffbc96$var$rsUpperRange + "]", $325a565efdffbc96$var$rsFitz = "\ud83c[\udffb-\udfff]", $325a565efdffbc96$var$rsModifier = "(?:" + $325a565efdffbc96$var$rsCombo + "|" + $325a565efdffbc96$var$rsFitz + ")", $325a565efdffbc96$var$rsNonAstral = "[^" + $325a565efdffbc96$var$rsAstralRange + "]", $325a565efdffbc96$var$rsRegional = "(?:\ud83c[\udde6-\uddff]){2}", $325a565efdffbc96$var$rsSurrPair = "[\ud800-\udbff][\udc00-\udfff]", $325a565efdffbc96$var$rsUpper = "[" + $325a565efdffbc96$var$rsUpperRange + "]", $325a565efdffbc96$var$rsZWJ = "\\u200d";
/** Used to compose unicode regexes. */ var $325a565efdffbc96$var$rsMiscLower = "(?:" + $325a565efdffbc96$var$rsLower + "|" + $325a565efdffbc96$var$rsMisc + ")", $325a565efdffbc96$var$rsMiscUpper = "(?:" + $325a565efdffbc96$var$rsUpper + "|" + $325a565efdffbc96$var$rsMisc + ")", $325a565efdffbc96$var$rsOptContrLower = "(?:" + $325a565efdffbc96$var$rsApos + "(?:d|ll|m|re|s|t|ve))?", $325a565efdffbc96$var$rsOptContrUpper = "(?:" + $325a565efdffbc96$var$rsApos + "(?:D|LL|M|RE|S|T|VE))?", $325a565efdffbc96$var$reOptMod = $325a565efdffbc96$var$rsModifier + "?", $325a565efdffbc96$var$rsOptVar = "[" + $325a565efdffbc96$var$rsVarRange + "]?", $325a565efdffbc96$var$rsOptJoin = "(?:" + $325a565efdffbc96$var$rsZWJ + "(?:" + [
    $325a565efdffbc96$var$rsNonAstral,
    $325a565efdffbc96$var$rsRegional,
    $325a565efdffbc96$var$rsSurrPair
].join("|") + ")" + $325a565efdffbc96$var$rsOptVar + $325a565efdffbc96$var$reOptMod + ")*", $325a565efdffbc96$var$rsOrdLower = "\\d*(?:1st|2nd|3rd|(?![123])\\dth)(?=\\b|[A-Z_])", $325a565efdffbc96$var$rsOrdUpper = "\\d*(?:1ST|2ND|3RD|(?![123])\\dTH)(?=\\b|[a-z_])", $325a565efdffbc96$var$rsSeq = $325a565efdffbc96$var$rsOptVar + $325a565efdffbc96$var$reOptMod + $325a565efdffbc96$var$rsOptJoin, $325a565efdffbc96$var$rsEmoji = "(?:" + [
    $325a565efdffbc96$var$rsDingbat,
    $325a565efdffbc96$var$rsRegional,
    $325a565efdffbc96$var$rsSurrPair
].join("|") + ")" + $325a565efdffbc96$var$rsSeq;
/** Used to match complex or compound words. */ var $325a565efdffbc96$var$reUnicodeWord = RegExp([
    $325a565efdffbc96$var$rsUpper + "?" + $325a565efdffbc96$var$rsLower + "+" + $325a565efdffbc96$var$rsOptContrLower + "(?=" + [
        $325a565efdffbc96$var$rsBreak,
        $325a565efdffbc96$var$rsUpper,
        "$"
    ].join("|") + ")",
    $325a565efdffbc96$var$rsMiscUpper + "+" + $325a565efdffbc96$var$rsOptContrUpper + "(?=" + [
        $325a565efdffbc96$var$rsBreak,
        $325a565efdffbc96$var$rsUpper + $325a565efdffbc96$var$rsMiscLower,
        "$"
    ].join("|") + ")",
    $325a565efdffbc96$var$rsUpper + "?" + $325a565efdffbc96$var$rsMiscLower + "+" + $325a565efdffbc96$var$rsOptContrLower,
    $325a565efdffbc96$var$rsUpper + "+" + $325a565efdffbc96$var$rsOptContrUpper,
    $325a565efdffbc96$var$rsOrdUpper,
    $325a565efdffbc96$var$rsOrdLower,
    $325a565efdffbc96$var$rsDigits,
    $325a565efdffbc96$var$rsEmoji
].join("|"), "g");
/**
 * Splits a Unicode `string` into an array of its words.
 *
 * @private
 * @param {string} The string to inspect.
 * @returns {Array} Returns the words of `string`.
 */ function $325a565efdffbc96$var$unicodeWords(string) {
    return string.match($325a565efdffbc96$var$reUnicodeWord) || [];
}
$325a565efdffbc96$exports = $325a565efdffbc96$var$unicodeWords;


/**
 * Splits `string` into an array of its words.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category String
 * @param {string} [string=''] The string to inspect.
 * @param {RegExp|string} [pattern] The pattern to match words.
 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
 * @returns {Array} Returns the words of `string`.
 * @example
 *
 * _.words('fred, barney, & pebbles');
 * // => ['fred', 'barney', 'pebbles']
 *
 * _.words('fred, barney, & pebbles', /[^, ]+/g);
 * // => ['fred', 'barney', '&', 'pebbles']
 */ function $12f2ccb7e11b3895$var$words(string, pattern, guard) {
    string = $f5d9385a9cc7e413$exports(string);
    pattern = guard ? undefined : pattern;
    if (pattern === undefined) return $8688e0b23f5a081b$exports(string) ? $325a565efdffbc96$exports(string) : $7e165cbd28a9af51$exports(string);
    return string.match(pattern) || [];
}
$12f2ccb7e11b3895$exports = $12f2ccb7e11b3895$var$words;


/** Used to compose unicode capture groups. */ var $0b2d21aee1d97729$var$rsApos = "['\u2019]";
/** Used to match apostrophes. */ var $0b2d21aee1d97729$var$reApos = RegExp($0b2d21aee1d97729$var$rsApos, "g");
/**
 * Creates a function like `_.camelCase`.
 *
 * @private
 * @param {Function} callback The function to combine each word.
 * @returns {Function} Returns the new compounder function.
 */ function $0b2d21aee1d97729$var$createCompounder(callback) {
    return function(string) {
        return $1389b3710f5da9e8$exports($12f2ccb7e11b3895$exports($ed80fa8833e2b532$exports(string).replace($0b2d21aee1d97729$var$reApos, "")), callback, "");
    };
}
$0b2d21aee1d97729$exports = $0b2d21aee1d97729$var$createCompounder;


/**
 * Converts `string` to
 * [snake case](https://en.wikipedia.org/wiki/Snake_case).
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category String
 * @param {string} [string=''] The string to convert.
 * @returns {string} Returns the snake cased string.
 * @example
 *
 * _.snakeCase('Foo Bar');
 * // => 'foo_bar'
 *
 * _.snakeCase('fooBar');
 * // => 'foo_bar'
 *
 * _.snakeCase('--FOO-BAR--');
 * // => 'foo_bar'
 */ var $4f0248df72a92950$var$snakeCase = $0b2d21aee1d97729$exports(function(result, word, index) {
    return result + (index ? "_" : "") + word.toLowerCase();
});
$4f0248df72a92950$exports = $4f0248df72a92950$var$snakeCase;


var $d57e6f3349076887$exports = {};
var $49f1f8db3e260fbf$exports = {};

var $da6130e1e4702e32$exports = {};
var $0d9811a54a2f955a$exports = {};
var $cfe77c1a7b7c7d6e$exports = {};
var $109fb88fe59de104$exports = {};
/**
 * The base implementation of `_.slice` without an iteratee call guard.
 *
 * @private
 * @param {Array} array The array to slice.
 * @param {number} [start=0] The start position.
 * @param {number} [end=array.length] The end position.
 * @returns {Array} Returns the slice of `array`.
 */ function $109fb88fe59de104$var$baseSlice(array, start, end) {
    var index = -1, length = array.length;
    if (start < 0) start = -start > length ? 0 : length + start;
    end = end > length ? length : end;
    if (end < 0) end += length;
    length = start > end ? 0 : end - start >>> 0;
    start >>>= 0;
    var result = Array(length);
    while(++index < length)result[index] = array[index + start];
    return result;
}
$109fb88fe59de104$exports = $109fb88fe59de104$var$baseSlice;


/**
 * Casts `array` to a slice if it's needed.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {number} start The start position.
 * @param {number} [end=array.length] The end position.
 * @returns {Array} Returns the cast slice.
 */ function $cfe77c1a7b7c7d6e$var$castSlice(array, start, end) {
    var length = array.length;
    end = end === undefined ? length : end;
    return !start && end >= length ? array : $109fb88fe59de104$exports(array, start, end);
}
$cfe77c1a7b7c7d6e$exports = $cfe77c1a7b7c7d6e$var$castSlice;


var $00fdf7eab00be2e7$exports = {};
/** Used to compose unicode character classes. */ var $00fdf7eab00be2e7$var$rsAstralRange = "\ud800-\udfff", $00fdf7eab00be2e7$var$rsComboMarksRange = "\\u0300-\\u036f", $00fdf7eab00be2e7$var$reComboHalfMarksRange = "\\ufe20-\\ufe2f", $00fdf7eab00be2e7$var$rsComboSymbolsRange = "\\u20d0-\\u20ff", $00fdf7eab00be2e7$var$rsComboRange = $00fdf7eab00be2e7$var$rsComboMarksRange + $00fdf7eab00be2e7$var$reComboHalfMarksRange + $00fdf7eab00be2e7$var$rsComboSymbolsRange, $00fdf7eab00be2e7$var$rsVarRange = "\\ufe0e\\ufe0f";
/** Used to compose unicode capture groups. */ var $00fdf7eab00be2e7$var$rsZWJ = "\\u200d";
/** Used to detect strings with [zero-width joiners or code points from the astral planes](http://eev.ee/blog/2015/09/12/dark-corners-of-unicode/). */ var $00fdf7eab00be2e7$var$reHasUnicode = RegExp("[" + $00fdf7eab00be2e7$var$rsZWJ + $00fdf7eab00be2e7$var$rsAstralRange + $00fdf7eab00be2e7$var$rsComboRange + $00fdf7eab00be2e7$var$rsVarRange + "]");
/**
 * Checks if `string` contains Unicode symbols.
 *
 * @private
 * @param {string} string The string to inspect.
 * @returns {boolean} Returns `true` if a symbol is found, else `false`.
 */ function $00fdf7eab00be2e7$var$hasUnicode(string) {
    return $00fdf7eab00be2e7$var$reHasUnicode.test(string);
}
$00fdf7eab00be2e7$exports = $00fdf7eab00be2e7$var$hasUnicode;


var $9a986c87d425808c$exports = {};
var $43b96a6d93895c83$exports = {};
/**
 * Converts an ASCII `string` to an array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the converted array.
 */ function $43b96a6d93895c83$var$asciiToArray(string) {
    return string.split("");
}
$43b96a6d93895c83$exports = $43b96a6d93895c83$var$asciiToArray;



var $c3bf9ebcb1b53b1d$exports = {};
/** Used to compose unicode character classes. */ var $c3bf9ebcb1b53b1d$var$rsAstralRange = "\ud800-\udfff", $c3bf9ebcb1b53b1d$var$rsComboMarksRange = "\\u0300-\\u036f", $c3bf9ebcb1b53b1d$var$reComboHalfMarksRange = "\\ufe20-\\ufe2f", $c3bf9ebcb1b53b1d$var$rsComboSymbolsRange = "\\u20d0-\\u20ff", $c3bf9ebcb1b53b1d$var$rsComboRange = $c3bf9ebcb1b53b1d$var$rsComboMarksRange + $c3bf9ebcb1b53b1d$var$reComboHalfMarksRange + $c3bf9ebcb1b53b1d$var$rsComboSymbolsRange, $c3bf9ebcb1b53b1d$var$rsVarRange = "\\ufe0e\\ufe0f";
/** Used to compose unicode capture groups. */ var $c3bf9ebcb1b53b1d$var$rsAstral = "[" + $c3bf9ebcb1b53b1d$var$rsAstralRange + "]", $c3bf9ebcb1b53b1d$var$rsCombo = "[" + $c3bf9ebcb1b53b1d$var$rsComboRange + "]", $c3bf9ebcb1b53b1d$var$rsFitz = "\ud83c[\udffb-\udfff]", $c3bf9ebcb1b53b1d$var$rsModifier = "(?:" + $c3bf9ebcb1b53b1d$var$rsCombo + "|" + $c3bf9ebcb1b53b1d$var$rsFitz + ")", $c3bf9ebcb1b53b1d$var$rsNonAstral = "[^" + $c3bf9ebcb1b53b1d$var$rsAstralRange + "]", $c3bf9ebcb1b53b1d$var$rsRegional = "(?:\ud83c[\udde6-\uddff]){2}", $c3bf9ebcb1b53b1d$var$rsSurrPair = "[\ud800-\udbff][\udc00-\udfff]", $c3bf9ebcb1b53b1d$var$rsZWJ = "\\u200d";
/** Used to compose unicode regexes. */ var $c3bf9ebcb1b53b1d$var$reOptMod = $c3bf9ebcb1b53b1d$var$rsModifier + "?", $c3bf9ebcb1b53b1d$var$rsOptVar = "[" + $c3bf9ebcb1b53b1d$var$rsVarRange + "]?", $c3bf9ebcb1b53b1d$var$rsOptJoin = "(?:" + $c3bf9ebcb1b53b1d$var$rsZWJ + "(?:" + [
    $c3bf9ebcb1b53b1d$var$rsNonAstral,
    $c3bf9ebcb1b53b1d$var$rsRegional,
    $c3bf9ebcb1b53b1d$var$rsSurrPair
].join("|") + ")" + $c3bf9ebcb1b53b1d$var$rsOptVar + $c3bf9ebcb1b53b1d$var$reOptMod + ")*", $c3bf9ebcb1b53b1d$var$rsSeq = $c3bf9ebcb1b53b1d$var$rsOptVar + $c3bf9ebcb1b53b1d$var$reOptMod + $c3bf9ebcb1b53b1d$var$rsOptJoin, $c3bf9ebcb1b53b1d$var$rsSymbol = "(?:" + [
    $c3bf9ebcb1b53b1d$var$rsNonAstral + $c3bf9ebcb1b53b1d$var$rsCombo + "?",
    $c3bf9ebcb1b53b1d$var$rsCombo,
    $c3bf9ebcb1b53b1d$var$rsRegional,
    $c3bf9ebcb1b53b1d$var$rsSurrPair,
    $c3bf9ebcb1b53b1d$var$rsAstral
].join("|") + ")";
/** Used to match [string symbols](https://mathiasbynens.be/notes/javascript-unicode). */ var $c3bf9ebcb1b53b1d$var$reUnicode = RegExp($c3bf9ebcb1b53b1d$var$rsFitz + "(?=" + $c3bf9ebcb1b53b1d$var$rsFitz + ")|" + $c3bf9ebcb1b53b1d$var$rsSymbol + $c3bf9ebcb1b53b1d$var$rsSeq, "g");
/**
 * Converts a Unicode `string` to an array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the converted array.
 */ function $c3bf9ebcb1b53b1d$var$unicodeToArray(string) {
    return string.match($c3bf9ebcb1b53b1d$var$reUnicode) || [];
}
$c3bf9ebcb1b53b1d$exports = $c3bf9ebcb1b53b1d$var$unicodeToArray;


/**
 * Converts `string` to an array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the converted array.
 */ function $9a986c87d425808c$var$stringToArray(string) {
    return $00fdf7eab00be2e7$exports(string) ? $c3bf9ebcb1b53b1d$exports(string) : $43b96a6d93895c83$exports(string);
}
$9a986c87d425808c$exports = $9a986c87d425808c$var$stringToArray;



/**
 * Creates a function like `_.lowerFirst`.
 *
 * @private
 * @param {string} methodName The name of the `String` case method to use.
 * @returns {Function} Returns the new case function.
 */ function $0d9811a54a2f955a$var$createCaseFirst(methodName) {
    return function(string) {
        string = $f5d9385a9cc7e413$exports(string);
        var strSymbols = $00fdf7eab00be2e7$exports(string) ? $9a986c87d425808c$exports(string) : undefined;
        var chr = strSymbols ? strSymbols[0] : string.charAt(0);
        var trailing = strSymbols ? $cfe77c1a7b7c7d6e$exports(strSymbols, 1).join("") : string.slice(1);
        return chr[methodName]() + trailing;
    };
}
$0d9811a54a2f955a$exports = $0d9811a54a2f955a$var$createCaseFirst;


/**
 * Converts the first character of `string` to upper case.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category String
 * @param {string} [string=''] The string to convert.
 * @returns {string} Returns the converted string.
 * @example
 *
 * _.upperFirst('fred');
 * // => 'Fred'
 *
 * _.upperFirst('FRED');
 * // => 'FRED'
 */ var $da6130e1e4702e32$var$upperFirst = $0d9811a54a2f955a$exports("toUpperCase");
$da6130e1e4702e32$exports = $da6130e1e4702e32$var$upperFirst;


/**
 * Converts the first character of `string` to upper case and the remaining
 * to lower case.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category String
 * @param {string} [string=''] The string to capitalize.
 * @returns {string} Returns the capitalized string.
 * @example
 *
 * _.capitalize('FRED');
 * // => 'Fred'
 */ function $49f1f8db3e260fbf$var$capitalize(string) {
    return $da6130e1e4702e32$exports($f5d9385a9cc7e413$exports(string).toLowerCase());
}
$49f1f8db3e260fbf$exports = $49f1f8db3e260fbf$var$capitalize;



/**
 * Converts `string` to [camel case](https://en.wikipedia.org/wiki/CamelCase).
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category String
 * @param {string} [string=''] The string to convert.
 * @returns {string} Returns the camel cased string.
 * @example
 *
 * _.camelCase('Foo Bar');
 * // => 'fooBar'
 *
 * _.camelCase('--foo-bar--');
 * // => 'fooBar'
 *
 * _.camelCase('__FOO_BAR__');
 * // => 'fooBar'
 */ var $d57e6f3349076887$var$camelCase = $0b2d21aee1d97729$exports(function(result, word, index) {
    word = word.toLowerCase();
    return result + (index ? $49f1f8db3e260fbf$exports(word) : word);
});
$d57e6f3349076887$exports = $d57e6f3349076887$var$camelCase;


var $3415b394b567e74a$exports = {};



/**
 * The opposite of `_.mapValues`; this method creates an object with the
 * same values as `object` and keys generated by running each own enumerable
 * string keyed property of `object` thru `iteratee`. The iteratee is invoked
 * with three arguments: (value, key, object).
 *
 * @static
 * @memberOf _
 * @since 3.8.0
 * @category Object
 * @param {Object} object The object to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @returns {Object} Returns the new mapped object.
 * @see _.mapValues
 * @example
 *
 * _.mapKeys({ 'a': 1, 'b': 2 }, function(value, key) {
 *   return key + value;
 * });
 * // => { 'a1': 1, 'b2': 2 }
 */ function $3415b394b567e74a$var$mapKeys(object, iteratee) {
    var result = {};
    iteratee = $5aba4f6d9f8304a3$exports(iteratee, 3);
    $34edfba366a0cfa1$exports(object, function(value, key, object) {
        $96b401257ea00d24$exports(result, iteratee(value, key, object), value);
    });
    return result;
}
$3415b394b567e74a$exports = $3415b394b567e74a$var$mapKeys;






var $a2cee144eac47a21$exports = {};
/**
 * Topological sorting function
 *
 * @param {Array} edges
 * @returns {Array}
 */ $a2cee144eac47a21$exports = function(edges) {
    return $a2cee144eac47a21$var$toposort($a2cee144eac47a21$var$uniqueNodes(edges), edges);
};
$a2cee144eac47a21$exports.array = $a2cee144eac47a21$var$toposort;
function $a2cee144eac47a21$var$toposort(nodes, edges) {
    var cursor = nodes.length, sorted = new Array(cursor), visited = {}, i = cursor, outgoingEdges = $a2cee144eac47a21$var$makeOutgoingEdges(edges), nodesHash = $a2cee144eac47a21$var$makeNodesHash(nodes);
    // check for unknown nodes
    edges.forEach(function(edge) {
        if (!nodesHash.has(edge[0]) || !nodesHash.has(edge[1])) throw new Error("Unknown node. There is an unknown node in the supplied edges.");
    });
    while(i--)if (!visited[i]) visit(nodes[i], i, new Set());
    return sorted;
    function visit(node, i, predecessors) {
        if (predecessors.has(node)) {
            var nodeRep;
            try {
                nodeRep = ", node was:" + JSON.stringify(node);
            } catch (e) {
                nodeRep = "";
            }
            throw new Error("Cyclic dependency" + nodeRep);
        }
        if (!nodesHash.has(node)) throw new Error("Found unknown node. Make sure to provided all involved nodes. Unknown node: " + JSON.stringify(node));
        if (visited[i]) return;
        visited[i] = true;
        var outgoing = outgoingEdges.get(node) || new Set();
        outgoing = Array.from(outgoing);
        if (i = outgoing.length) {
            predecessors.add(node);
            do {
                var child = outgoing[--i];
                visit(child, nodesHash.get(child), predecessors);
            }while (i);
            predecessors.delete(node);
        }
        sorted[--cursor] = node;
    }
}
function $a2cee144eac47a21$var$uniqueNodes(arr) {
    var res = new Set();
    for(var i = 0, len = arr.length; i < len; i++){
        var edge = arr[i];
        res.add(edge[0]);
        res.add(edge[1]);
    }
    return Array.from(res);
}
function $a2cee144eac47a21$var$makeOutgoingEdges(arr) {
    var edges = new Map();
    for(var i = 0, len = arr.length; i < len; i++){
        var edge = arr[i];
        if (!edges.has(edge[0])) edges.set(edge[0], new Set());
        if (!edges.has(edge[1])) edges.set(edge[1], new Set());
        edges.get(edge[0]).add(edge[1]);
    }
    return edges;
}
function $a2cee144eac47a21$var$makeNodesHash(arr) {
    var res = new Map();
    for(var i = 0, len = arr.length; i < len; i++)res.set(arr[i], i);
    return res;
}





function $ade87c847c1ee6bb$export$2e2bcd8739ae039(fields, excludedEdges = []) {
    let edges = [];
    let nodes = new Set();
    let excludes = new Set(excludedEdges.map(([a, b])=>`${a}-${b}`));
    function addNode(depPath, key) {
        let node = (0, $0a34a21cae127bf5$exports.split)(depPath)[0];
        nodes.add(node);
        if (!excludes.has(`${key}-${node}`)) edges.push([
            key,
            node
        ]);
    }
    for(const key in fields)if ((0, (/*@__PURE__*/$parcel$interopDefault($e21135b6db383fe3$exports)))(fields, key)) {
        let value = fields[key];
        nodes.add(key);
        if ((0, $f5cdfa956e941194$export$2e2bcd8739ae039).isRef(value) && value.isSibling) addNode(value.path, key);
        else if ((0, $1d4517ced724be00$export$2e2bcd8739ae039)(value) && "deps" in value) value.deps.forEach((path)=>addNode(path, key));
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($a2cee144eac47a21$exports))).array(Array.from(nodes), edges).reverse();
}


function $b59a7ce2e5e0a1e4$var$findIndex(arr, err) {
    let idx = Infinity;
    arr.some((key, ii)=>{
        var _err$path;
        if (((_err$path = err.path) == null ? void 0 : _err$path.indexOf(key)) !== -1) {
            idx = ii;
            return true;
        }
    });
    return idx;
}
function $b59a7ce2e5e0a1e4$export$2e2bcd8739ae039(keys) {
    return (a, b)=>{
        return $b59a7ce2e5e0a1e4$var$findIndex(keys, a) - $b59a7ce2e5e0a1e4$var$findIndex(keys, b);
    };
}





function $cd7706ce94a8dfd1$var$_extends() {
    $cd7706ce94a8dfd1$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $cd7706ce94a8dfd1$var$_extends.apply(this, arguments);
}
let $cd7706ce94a8dfd1$var$isObject = (obj)=>Object.prototype.toString.call(obj) === "[object Object]";
function $cd7706ce94a8dfd1$var$unknown(ctx, value) {
    let known = Object.keys(ctx.fields);
    return Object.keys(value).filter((key)=>known.indexOf(key) === -1);
}
const $cd7706ce94a8dfd1$var$defaultSort = (0, $b59a7ce2e5e0a1e4$export$2e2bcd8739ae039)([]);
class $cd7706ce94a8dfd1$export$2e2bcd8739ae039 extends (0, $bcee4fc8dbde13e1$export$2e2bcd8739ae039) {
    constructor(spec){
        super({
            type: "object"
        });
        this.fields = Object.create(null);
        this._sortErrors = $cd7706ce94a8dfd1$var$defaultSort;
        this._nodes = [];
        this._excludedEdges = [];
        this.withMutation(()=>{
            this.transform(function coerce(value) {
                if (typeof value === "string") try {
                    value = JSON.parse(value);
                } catch (err) {
                    value = null;
                }
                if (this.isType(value)) return value;
                return null;
            });
            if (spec) this.shape(spec);
        });
    }
    _typeCheck(value) {
        return $cd7706ce94a8dfd1$var$isObject(value) || typeof value === "function";
    }
    _cast(_value, options = {}) {
        var _options$stripUnknown;
        let value = super._cast(_value, options); //should ignore nulls here
        if (value === undefined) return this.getDefault();
        if (!this._typeCheck(value)) return value;
        let fields = this.fields;
        let strip = (_options$stripUnknown = options.stripUnknown) != null ? _options$stripUnknown : this.spec.noUnknown;
        let props = this._nodes.concat(Object.keys(value).filter((v)=>this._nodes.indexOf(v) === -1));
        let intermediateValue = {}; // is filled during the transform below
        let innerOptions = $cd7706ce94a8dfd1$var$_extends({}, options, {
            parent: intermediateValue,
            __validating: options.__validating || false
        });
        let isChanged = false;
        for (const prop of props){
            let field = fields[prop];
            let exists = (0, (/*@__PURE__*/$parcel$interopDefault($e21135b6db383fe3$exports)))(value, prop);
            if (field) {
                let fieldValue;
                let inputValue = value[prop]; // safe to mutate since this is fired in sequence
                innerOptions.path = (options.path ? `${options.path}.` : "") + prop; // innerOptions.value = value[prop];
                field = field.resolve({
                    value: inputValue,
                    context: options.context,
                    parent: intermediateValue
                });
                let fieldSpec = "spec" in field ? field.spec : undefined;
                let strict = fieldSpec == null ? void 0 : fieldSpec.strict;
                if (fieldSpec == null ? void 0 : fieldSpec.strip) {
                    isChanged = isChanged || prop in value;
                    continue;
                }
                fieldValue = !options.__validating || !strict ? field.cast(value[prop], innerOptions) : value[prop];
                if (fieldValue !== undefined) intermediateValue[prop] = fieldValue;
            } else if (exists && !strip) intermediateValue[prop] = value[prop];
            if (intermediateValue[prop] !== value[prop]) isChanged = true;
        }
        return isChanged ? intermediateValue : value;
    }
    _validate(_value, opts = {}, callback) {
        let errors = [];
        let { sync: sync, from: from = [], originalValue: originalValue = _value, abortEarly: abortEarly = this.spec.abortEarly, recursive: recursive = this.spec.recursive } = opts;
        from = [
            {
                schema: this,
                value: originalValue
            },
            ...from
        ]; // this flag is needed for handling `strict` correctly in the context of
        // validation vs just casting. e.g strict() on a field is only used when validating
        opts.__validating = true;
        opts.originalValue = originalValue;
        opts.from = from;
        super._validate(_value, opts, (err, value)=>{
            if (err) {
                if (!(0, $d2e70d35996a7daf$export$2e2bcd8739ae039).isError(err) || abortEarly) return void callback(err, value);
                errors.push(err);
            }
            if (!recursive || !$cd7706ce94a8dfd1$var$isObject(value)) {
                callback(errors[0] || null, value);
                return;
            }
            originalValue = originalValue || value;
            let tests = this._nodes.map((key)=>(_, cb)=>{
                    let path = key.indexOf(".") === -1 ? (opts.path ? `${opts.path}.` : "") + key : `${opts.path || ""}["${key}"]`;
                    let field = this.fields[key];
                    if (field && "validate" in field) {
                        field.validate(value[key], $cd7706ce94a8dfd1$var$_extends({}, opts, {
                            path: // @ts-ignore
                            path,
                            from: from,
                            // inner fields are always strict:
                            // 1. this isn't strict so the casting will also have cast inner values
                            // 2. this is strict in which case the nested values weren't cast either
                            strict: true,
                            parent: value,
                            originalValue: originalValue[key]
                        }), cb);
                        return;
                    }
                    cb(null);
                });
            (0, $d2d0e6ad55c8832e$export$2e2bcd8739ae039)({
                sync: sync,
                tests: tests,
                value: value,
                errors: errors,
                endEarly: abortEarly,
                sort: this._sortErrors,
                path: opts.path
            }, callback);
        });
    }
    clone(spec) {
        const next = super.clone(spec);
        next.fields = $cd7706ce94a8dfd1$var$_extends({}, this.fields);
        next._nodes = this._nodes;
        next._excludedEdges = this._excludedEdges;
        next._sortErrors = this._sortErrors;
        return next;
    }
    concat(schema) {
        let next = super.concat(schema);
        let nextFields = next.fields;
        for (let [field, schemaOrRef] of Object.entries(this.fields)){
            const target = nextFields[field];
            if (target === undefined) nextFields[field] = schemaOrRef;
            else if (target instanceof (0, $bcee4fc8dbde13e1$export$2e2bcd8739ae039) && schemaOrRef instanceof (0, $bcee4fc8dbde13e1$export$2e2bcd8739ae039)) nextFields[field] = schemaOrRef.concat(target);
        }
        return next.withMutation(()=>next.shape(nextFields, this._excludedEdges));
    }
    getDefaultFromShape() {
        let dft = {};
        this._nodes.forEach((key)=>{
            const field = this.fields[key];
            dft[key] = "default" in field ? field.getDefault() : undefined;
        });
        return dft;
    }
    _getDefault() {
        if ("default" in this.spec) return super._getDefault();
         // if there is no default set invent one
        if (!this._nodes.length) return undefined;
        return this.getDefaultFromShape();
    }
    shape(additions, excludes = []) {
        let next = this.clone();
        let fields = Object.assign(next.fields, additions);
        next.fields = fields;
        next._sortErrors = (0, $b59a7ce2e5e0a1e4$export$2e2bcd8739ae039)(Object.keys(fields));
        if (excludes.length) {
            // this is a convenience for when users only supply a single pair
            if (!Array.isArray(excludes[0])) excludes = [
                excludes
            ];
            next._excludedEdges = [
                ...next._excludedEdges,
                ...excludes
            ];
        }
        next._nodes = (0, $ade87c847c1ee6bb$export$2e2bcd8739ae039)(fields, next._excludedEdges);
        return next;
    }
    pick(keys) {
        const picked = {};
        for (const key of keys)if (this.fields[key]) picked[key] = this.fields[key];
        return this.clone().withMutation((next)=>{
            next.fields = {};
            return next.shape(picked);
        });
    }
    omit(keys) {
        const next = this.clone();
        const fields = next.fields;
        next.fields = {};
        for (const key of keys)delete fields[key];
        return next.withMutation(()=>next.shape(fields));
    }
    from(from, to, alias) {
        let fromGetter = (0, $0a34a21cae127bf5$exports.getter)(from, true);
        return this.transform((obj)=>{
            if (obj == null) return obj;
            let newObj = obj;
            if ((0, (/*@__PURE__*/$parcel$interopDefault($e21135b6db383fe3$exports)))(obj, from)) {
                newObj = $cd7706ce94a8dfd1$var$_extends({}, obj);
                if (!alias) delete newObj[from];
                newObj[to] = fromGetter(obj);
            }
            return newObj;
        });
    }
    noUnknown(noAllow = true, message = (0, $3ea8894c2d1a8ff8$export$be5493f9613cbbe).noUnknown) {
        if (typeof noAllow === "string") {
            message = noAllow;
            noAllow = true;
        }
        let next = this.test({
            name: "noUnknown",
            exclusive: true,
            message: message,
            test (value) {
                if (value == null) return true;
                const unknownKeys = $cd7706ce94a8dfd1$var$unknown(this.schema, value);
                return !noAllow || unknownKeys.length === 0 || this.createError({
                    params: {
                        unknown: unknownKeys.join(", ")
                    }
                });
            }
        });
        next.spec.noUnknown = noAllow;
        return next;
    }
    unknown(allow = true, message = (0, $3ea8894c2d1a8ff8$export$be5493f9613cbbe).noUnknown) {
        return this.noUnknown(!allow, message);
    }
    transformKeys(fn) {
        return this.transform((obj)=>obj && (0, (/*@__PURE__*/$parcel$interopDefault($3415b394b567e74a$exports)))(obj, (_, key)=>fn(key)));
    }
    camelCase() {
        return this.transformKeys((0, (/*@__PURE__*/$parcel$interopDefault($d57e6f3349076887$exports))));
    }
    snakeCase() {
        return this.transformKeys((0, (/*@__PURE__*/$parcel$interopDefault($4f0248df72a92950$exports))));
    }
    constantCase() {
        return this.transformKeys((key)=>(0, (/*@__PURE__*/$parcel$interopDefault($4f0248df72a92950$exports)))(key).toUpperCase());
    }
    describe() {
        let base = super.describe();
        base.fields = (0, (/*@__PURE__*/$parcel$interopDefault($17211428bc2045c4$exports)))(this.fields, (value)=>value.describe());
        return base;
    }
}
function $cd7706ce94a8dfd1$export$185802fd694ee1f5(spec) {
    return new $cd7706ce94a8dfd1$export$2e2bcd8739ae039(spec);
}
$cd7706ce94a8dfd1$export$185802fd694ee1f5.prototype = $cd7706ce94a8dfd1$export$2e2bcd8739ae039.prototype;









function $e218604b96487b25$var$_extends() {
    $e218604b96487b25$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $e218604b96487b25$var$_extends.apply(this, arguments);
}
function $e218604b96487b25$export$185802fd694ee1f5(type) {
    return new $e218604b96487b25$export$2e2bcd8739ae039(type);
}
class $e218604b96487b25$export$2e2bcd8739ae039 extends (0, $bcee4fc8dbde13e1$export$2e2bcd8739ae039) {
    constructor(type){
        super({
            type: "array"
        }); // `undefined` specifically means uninitialized, as opposed to
        // "no subtype"
        this.innerType = void 0;
        this.innerType = type;
        this.withMutation(()=>{
            this.transform(function(values) {
                if (typeof values === "string") try {
                    values = JSON.parse(values);
                } catch (err) {
                    values = null;
                }
                return this.isType(values) ? values : null;
            });
        });
    }
    _typeCheck(v) {
        return Array.isArray(v);
    }
    get _subType() {
        return this.innerType;
    }
    _cast(_value, _opts) {
        const value = super._cast(_value, _opts); //should ignore nulls here
        if (!this._typeCheck(value) || !this.innerType) return value;
        let isChanged = false;
        const castArray = value.map((v, idx)=>{
            const castElement = this.innerType.cast(v, $e218604b96487b25$var$_extends({}, _opts, {
                path: `${_opts.path || ""}[${idx}]`
            }));
            if (castElement !== v) isChanged = true;
            return castElement;
        });
        return isChanged ? castArray : value;
    }
    _validate(_value, options = {}, callback) {
        var _options$abortEarly, _options$recursive;
        let errors = [];
        let sync = options.sync;
        let path = options.path;
        let innerType = this.innerType;
        let endEarly = (_options$abortEarly = options.abortEarly) != null ? _options$abortEarly : this.spec.abortEarly;
        let recursive = (_options$recursive = options.recursive) != null ? _options$recursive : this.spec.recursive;
        let originalValue = options.originalValue != null ? options.originalValue : _value;
        super._validate(_value, options, (err, value)=>{
            if (err) {
                if (!(0, $d2e70d35996a7daf$export$2e2bcd8739ae039).isError(err) || endEarly) return void callback(err, value);
                errors.push(err);
            }
            if (!recursive || !innerType || !this._typeCheck(value)) {
                callback(errors[0] || null, value);
                return;
            }
            originalValue = originalValue || value; // #950 Ensure that sparse array empty slots are validated
            let tests = new Array(value.length);
            for(let idx = 0; idx < value.length; idx++){
                let item = value[idx];
                let path = `${options.path || ""}[${idx}]`; // object._validate note for isStrict explanation
                let innerOptions = $e218604b96487b25$var$_extends({}, options, {
                    path: path,
                    strict: true,
                    parent: value,
                    index: idx,
                    originalValue: originalValue[idx]
                });
                tests[idx] = (_, cb)=>innerType.validate(item, innerOptions, cb);
            }
            (0, $d2d0e6ad55c8832e$export$2e2bcd8739ae039)({
                sync: sync,
                path: path,
                value: value,
                errors: errors,
                endEarly: endEarly,
                tests: tests
            }, callback);
        });
    }
    clone(spec) {
        const next = super.clone(spec);
        next.innerType = this.innerType;
        return next;
    }
    concat(schema) {
        let next = super.concat(schema);
        next.innerType = this.innerType;
        if (schema.innerType) next.innerType = next.innerType ? next.innerType.concat(schema.innerType) : schema.innerType;
        return next;
    }
    of(schema) {
        // FIXME: this should return a new instance of array without the default to be
        let next = this.clone();
        if (!(0, $1d4517ced724be00$export$2e2bcd8739ae039)(schema)) throw new TypeError("`array.of()` sub-schema must be a valid yup schema not: " + (0, $3bcbbcae986c2431$export$2e2bcd8739ae039)(schema)); // FIXME(ts):
        next.innerType = schema;
        return next;
    }
    length(length, message = (0, $3ea8894c2d1a8ff8$export$2f23118c22fb2630).length) {
        return this.test({
            message: message,
            name: "length",
            exclusive: true,
            params: {
                length: length
            },
            test (value) {
                return (0, $55daa1cd95624d91$export$2e2bcd8739ae039)(value) || value.length === this.resolve(length);
            }
        });
    }
    min(min, message) {
        message = message || (0, $3ea8894c2d1a8ff8$export$2f23118c22fb2630).min;
        return this.test({
            message: message,
            name: "min",
            exclusive: true,
            params: {
                min: min
            },
            // FIXME(ts): Array<typeof T>
            test (value) {
                return (0, $55daa1cd95624d91$export$2e2bcd8739ae039)(value) || value.length >= this.resolve(min);
            }
        });
    }
    max(max, message) {
        message = message || (0, $3ea8894c2d1a8ff8$export$2f23118c22fb2630).max;
        return this.test({
            message: message,
            name: "max",
            exclusive: true,
            params: {
                max: max
            },
            test (value) {
                return (0, $55daa1cd95624d91$export$2e2bcd8739ae039)(value) || value.length <= this.resolve(max);
            }
        });
    }
    ensure() {
        return this.default(()=>[]).transform((val, original)=>{
            // We don't want to return `null` for nullable schema
            if (this._typeCheck(val)) return val;
            return original == null ? [] : [].concat(original);
        });
    }
    compact(rejector) {
        let reject = !rejector ? (v)=>!!v : (v, i, a)=>!rejector(v, i, a);
        return this.transform((values)=>values != null ? values.filter(reject) : values);
    }
    describe() {
        let base = super.describe();
        if (this.innerType) base.innerType = this.innerType.describe();
        return base;
    }
    nullable(isNullable = true) {
        return super.nullable(isNullable);
    }
    defined() {
        return super.defined();
    }
    required(msg) {
        return super.required(msg);
    }
}
$e218604b96487b25$export$185802fd694ee1f5.prototype = $e218604b96487b25$export$2e2bcd8739ae039.prototype; //
 // Interfaces
 //




function $5a78aa552a6b7bb3$export$185802fd694ee1f5(builder) {
    return new $5a78aa552a6b7bb3$var$Lazy(builder);
}
class $5a78aa552a6b7bb3$var$Lazy {
    constructor(builder){
        this.type = "lazy";
        this.__isYupSchema__ = true;
        this.__inputType = void 0;
        this.__outputType = void 0;
        this._resolve = (value, options = {})=>{
            let schema = this.builder(value, options);
            if (!(0, $1d4517ced724be00$export$2e2bcd8739ae039)(schema)) throw new TypeError("lazy() functions must return a valid schema");
            return schema.resolve(options);
        };
        this.builder = builder;
    }
    resolve(options) {
        return this._resolve(options.value, options);
    }
    cast(value, options) {
        return this._resolve(value, options).cast(value, options);
    }
    validate(value, options, maybeCb) {
        // @ts-expect-error missing public callback on type
        return this._resolve(value, options).validate(value, options, maybeCb);
    }
    validateSync(value, options) {
        return this._resolve(value, options).validateSync(value, options);
    }
    validateAt(path, value, options) {
        return this._resolve(value, options).validateAt(path, value, options);
    }
    validateSyncAt(path, value, options) {
        return this._resolve(value, options).validateSyncAt(path, value, options);
    }
    describe() {
        return null;
    }
    isValid(value, options) {
        return this._resolve(value, options).isValid(value, options);
    }
    isValidSync(value, options) {
        return this._resolve(value, options).isValidSync(value, options);
    }
}
var $5a78aa552a6b7bb3$export$2e2bcd8739ae039 = $5a78aa552a6b7bb3$var$Lazy;






function $eabff3e78de076bd$export$2e2bcd8739ae039(custom) {
    Object.keys(custom).forEach((type)=>{
        // @ts-ignore
        Object.keys(custom[type]).forEach((method)=>{
            // @ts-ignore
            (0, $3ea8894c2d1a8ff8$export$2e2bcd8739ae039)[type][method] = custom[type][method];
        });
    });
}



function $920660c8aca77688$export$20be359f745f973c(schemaType, name, fn) {
    if (!schemaType || !(0, $1d4517ced724be00$export$2e2bcd8739ae039)(schemaType.prototype)) throw new TypeError("You must provide a yup schema constructor function");
    if (typeof name !== "string") throw new TypeError("A Method name must be provided");
    if (typeof fn !== "function") throw new TypeError("Method function must be provided");
    schemaType.prototype[name] = fn;
}





var $7YFi7 = parcelRequire("7YFi7");





const $1067a74e1c3483e2$export$f551688fc98f2e09 = ({ children: children, errors: errors, className: className = "" })=>{
    const getError = ()=>{
        if (!errors) return null;
        let errorMessage = "";
        if (typeof errors === "string") errorMessage = errors;
        if (Array.isArray(errors)) errorMessage = errors[0];
        return errorMessage;
    };
    const error = getError();
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: `FieldError ${className}`,
        children: [
            children,
            Boolean(error) && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                className: "FieldError__label",
                children: error
            })
        ]
    });
};




var $7YFi7 = parcelRequire("7YFi7");

function $79dd68e96d831dee$var$getDirectionByInputType(type) {
    switch(type){
        case "email":
        case "number":
        case "tel":
        case "url":
            return "ltr";
        default:
            return "undefined" // will by set by css instead
            ;
    }
}
function $79dd68e96d831dee$export$c86715117507e8e5({ label: label, getValue: getValue, formikKey: formikKey, formikProps: formikProps, type: type, disabled: disabled, className: className }) {
    const handleKeyUp = (event)=>{
        if (getValue) getValue(event.target.value);
    };
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: `TextInput ${disabled ? "disabled" : ""}`,
        dir: $79dd68e96d831dee$var$getDirectionByInputType(type),
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7YFi7.Field), {
                placeholder: "",
                disabled: disabled,
                name: formikKey,
                autoComplete: "off",
                className: `TextInput__input ${className ?? ""}`,
                onKeyUp: handleKeyUp,
                type: type ?? "text",
                required: true
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                className: `input-label ${Boolean(formikProps.getFieldProps(formikKey).value) && "active"}`,
                children: label
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                className: "error-msg",
                children: formikProps.touched[formikKey] && formikProps.errors[formikKey]
            })
        ]
    });
}
var $79dd68e96d831dee$export$2e2bcd8739ae039 = $79dd68e96d831dee$export$c86715117507e8e5;



const $660b2ca422e0e2ae$var$MIN_FLEX = 0;
const $660b2ca422e0e2ae$var$MAX_FLEX = 1;
const $660b2ca422e0e2ae$var$MIN_HEIGHT = 0;
const $660b2ca422e0e2ae$var$MIN_WIDTH = 0;
const $660b2ca422e0e2ae$var$Vertical = ({ height: height, className: className })=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        style: {
            minHeight: height
        },
        className: className
    });
const $660b2ca422e0e2ae$var$Horizontal = ({ width: width, className: className })=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        style: {
            minWidth: width
        },
        className: className
    });
const $660b2ca422e0e2ae$var$Spacer = ({ flex: flex = $660b2ca422e0e2ae$var$MAX_FLEX, minHeight: minHeight, minWidth: minWidth })=>{
    if (typeof flex === "number" && (flex < $660b2ca422e0e2ae$var$MIN_FLEX || flex > $660b2ca422e0e2ae$var$MAX_FLEX)) throw new Error(`Invalid flex value, expected range 0..1, got ${flex} instead`);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        style: {
            flex: flex,
            minHeight: minHeight ?? $660b2ca422e0e2ae$var$MIN_HEIGHT,
            minWidth: minWidth ?? $660b2ca422e0e2ae$var$MIN_WIDTH
        }
    });
};
const $660b2ca422e0e2ae$export$1ff3c3f08ae963c0 = {
    Vertical: $660b2ca422e0e2ae$var$Vertical,
    Horizontal: $660b2ca422e0e2ae$var$Horizontal,
    Spacer: $660b2ca422e0e2ae$var$Spacer
};



var $3279ad32455be7ff$exports = {};
$3279ad32455be7ff$exports = new URL("app-logo.fef20770.svg", import.meta.url).toString();




const $db88d867bf4ae88f$export$b597ee422a3143dc = (0, $aca50e9407ba89c9$export$b6ae1bc530f4c149)(()=>{
    const store = (0, $4671947198ddd366$export$6ccbb43953eebf8)();
    const redirect = (0, $7df35e9df335b1c8$export$602eaf6d5314ce55)();
    const { t: t } = (0, $3765cebd031b52c0$export$9fc83ad70ead8663)();
    const [restorePasswordResult, restorePassword] = (0, $4671947198ddd366$export$609860bf8b0084c)(store.data.forgotPassword, {
        onSuccess: ()=>{
            (0, $60f27fc97e29822a$export$b410431fab84fa58).success(t("forgot_password.email_sent"));
            redirect((0, $0534349ae8731d0b$export$66b32f6f30eb4b4).login, {});
        },
        onError: (err)=>{
            if (err.data.message) alert(err.data.message);
        },
        filterError: [
            (0, $9ad33fbf770c55a1$export$9696fcf1798e1cb5).ClientError
        ]
    });
    const errors = restorePasswordResult.error?.data.errors;
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "ForgotPassword",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                src: (0, (/*@__PURE__*/$parcel$interopDefault($3279ad32455be7ff$exports))),
                className: "ForgotPassword__logo"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $660b2ca422e0e2ae$export$1ff3c3f08ae963c0).Vertical, {
                height: 45
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h1", {
                className: "ForgotPassword__title",
                children: t("forgot_password.title")
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $660b2ca422e0e2ae$export$1ff3c3f08ae963c0).Vertical, {
                height: 5
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h2", {
                className: "ForgotPassword__subtitle",
                children: t("forgot_password.description")
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $660b2ca422e0e2ae$export$1ff3c3f08ae963c0).Vertical, {
                height: 53
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7YFi7.Formik), {
                initialValues: {
                    email: ""
                },
                validationSchema: $cd7706ce94a8dfd1$export$185802fd694ee1f5().shape({
                    email: $bcc252d93ab3046c$export$185802fd694ee1f5().email(t("validation_messages.email_invalid")).required(t("forgot_password.please_enter_email"))
                }),
                onSubmit: restorePassword,
                children: (formikProps)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7YFi7.Form), {
                        noValidate: true,
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $1067a74e1c3483e2$export$f551688fc98f2e09), {
                                errors: errors?.email,
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $79dd68e96d831dee$export$2e2bcd8739ae039), {
                                    type: "email",
                                    label: t("forgot_password.email"),
                                    formikProps: formikProps,
                                    formikKey: "email"
                                })
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $660b2ca422e0e2ae$export$1ff3c3f08ae963c0).Vertical, {
                                height: 25
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                type: "submit",
                                className: "ForgotPassword__button",
                                children: t("forgot_password.submit")
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $660b2ca422e0e2ae$export$1ff3c3f08ae963c0).Vertical, {
                                height: 25
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                className: "ForgotPassword__backContainer",
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7df35e9df335b1c8$export$a6c7ac8248d6e38a), {
                                    route: (0, $0534349ae8731d0b$export$66b32f6f30eb4b4).login,
                                    params: {},
                                    className: "ForgotPassword__backContainer__backLink",
                                    children: t("forgot_password.back_to_sign_in")
                                })
                            })
                        ]
                    })
            })
        ]
    });
});







var $7YFi7 = parcelRequire("7YFi7");



const $32ef62acd40089c4$export$1da4558c59cbf0b1 = ()=>{
    let deviceId = localStorage.getItem("device_id");
    if (deviceId) return deviceId;
    deviceId = (0, $3fa3ae484854b431$export$2e2bcd8739ae039)();
    localStorage.setItem("device_id", deviceId);
    return deviceId;
};



var $acw62 = parcelRequire("acw62");


const $b0034e17e4ec3171$export$23f2a1d2818174ef = (object, constructors)=>constructors.some((c)=>object instanceof c);
let $b0034e17e4ec3171$var$idbProxyableTypes;
let $b0034e17e4ec3171$var$cursorAdvanceMethods;
// This is a function to prevent it throwing up in node environments.
function $b0034e17e4ec3171$var$getIdbProxyableTypes() {
    return $b0034e17e4ec3171$var$idbProxyableTypes || ($b0034e17e4ec3171$var$idbProxyableTypes = [
        IDBDatabase,
        IDBObjectStore,
        IDBIndex,
        IDBCursor,
        IDBTransaction
    ]);
}
// This is a function to prevent it throwing up in node environments.
function $b0034e17e4ec3171$var$getCursorAdvanceMethods() {
    return $b0034e17e4ec3171$var$cursorAdvanceMethods || ($b0034e17e4ec3171$var$cursorAdvanceMethods = [
        IDBCursor.prototype.advance,
        IDBCursor.prototype.continue,
        IDBCursor.prototype.continuePrimaryKey
    ]);
}
const $b0034e17e4ec3171$var$cursorRequestMap = new WeakMap();
const $b0034e17e4ec3171$var$transactionDoneMap = new WeakMap();
const $b0034e17e4ec3171$var$transactionStoreNamesMap = new WeakMap();
const $b0034e17e4ec3171$var$transformCache = new WeakMap();
const $b0034e17e4ec3171$export$407448d2b89b1813 = new WeakMap();
function $b0034e17e4ec3171$var$promisifyRequest(request) {
    const promise = new Promise((resolve, reject)=>{
        const unlisten = ()=>{
            request.removeEventListener("success", success);
            request.removeEventListener("error", error);
        };
        const success = ()=>{
            resolve($b0034e17e4ec3171$export$efccba1c4a2ef57b(request.result));
            unlisten();
        };
        const error = ()=>{
            reject(request.error);
            unlisten();
        };
        request.addEventListener("success", success);
        request.addEventListener("error", error);
    });
    promise.then((value)=>{
        // Since cursoring reuses the IDBRequest (*sigh*), we cache it for later retrieval
        // (see wrapFunction).
        if (value instanceof IDBCursor) $b0034e17e4ec3171$var$cursorRequestMap.set(value, request);
    // Catching to avoid "Uncaught Promise exceptions"
    }).catch(()=>{});
    // This mapping exists in reverseTransformCache but doesn't doesn't exist in transformCache. This
    // is because we create many promises from a single IDBRequest.
    $b0034e17e4ec3171$export$407448d2b89b1813.set(promise, request);
    return promise;
}
function $b0034e17e4ec3171$var$cacheDonePromiseForTransaction(tx) {
    // Early bail if we've already created a done promise for this transaction.
    if ($b0034e17e4ec3171$var$transactionDoneMap.has(tx)) return;
    const done = new Promise((resolve, reject)=>{
        const unlisten = ()=>{
            tx.removeEventListener("complete", complete);
            tx.removeEventListener("error", error);
            tx.removeEventListener("abort", error);
        };
        const complete = ()=>{
            resolve();
            unlisten();
        };
        const error = ()=>{
            reject(tx.error || new DOMException("AbortError", "AbortError"));
            unlisten();
        };
        tx.addEventListener("complete", complete);
        tx.addEventListener("error", error);
        tx.addEventListener("abort", error);
    });
    // Cache it for later retrieval.
    $b0034e17e4ec3171$var$transactionDoneMap.set(tx, done);
}
let $b0034e17e4ec3171$var$idbProxyTraps = {
    get (target, prop, receiver) {
        if (target instanceof IDBTransaction) {
            // Special handling for transaction.done.
            if (prop === "done") return $b0034e17e4ec3171$var$transactionDoneMap.get(target);
            // Polyfill for objectStoreNames because of Edge.
            if (prop === "objectStoreNames") return target.objectStoreNames || $b0034e17e4ec3171$var$transactionStoreNamesMap.get(target);
            // Make tx.store return the only store in the transaction, or undefined if there are many.
            if (prop === "store") return receiver.objectStoreNames[1] ? undefined : receiver.objectStore(receiver.objectStoreNames[0]);
        }
        // Else transform whatever we get back.
        return $b0034e17e4ec3171$export$efccba1c4a2ef57b(target[prop]);
    },
    set (target, prop, value) {
        target[prop] = value;
        return true;
    },
    has (target, prop) {
        if (target instanceof IDBTransaction && (prop === "done" || prop === "store")) return true;
        return prop in target;
    }
};
function $b0034e17e4ec3171$export$43caf9889c228507(callback) {
    $b0034e17e4ec3171$var$idbProxyTraps = callback($b0034e17e4ec3171$var$idbProxyTraps);
}
function $b0034e17e4ec3171$var$wrapFunction(func) {
    // Due to expected object equality (which is enforced by the caching in `wrap`), we
    // only create one new func per func.
    // Edge doesn't support objectStoreNames (booo), so we polyfill it here.
    if (func === IDBDatabase.prototype.transaction && !("objectStoreNames" in IDBTransaction.prototype)) return function(storeNames, ...args) {
        const tx = func.call($b0034e17e4ec3171$export$3b14a55fb2447963(this), storeNames, ...args);
        $b0034e17e4ec3171$var$transactionStoreNamesMap.set(tx, storeNames.sort ? storeNames.sort() : [
            storeNames
        ]);
        return $b0034e17e4ec3171$export$efccba1c4a2ef57b(tx);
    };
    // Cursor methods are special, as the behaviour is a little more different to standard IDB. In
    // IDB, you advance the cursor and wait for a new 'success' on the IDBRequest that gave you the
    // cursor. It's kinda like a promise that can resolve with many values. That doesn't make sense
    // with real promises, so each advance methods returns a new promise for the cursor object, or
    // undefined if the end of the cursor has been reached.
    if ($b0034e17e4ec3171$var$getCursorAdvanceMethods().includes(func)) return function(...args) {
        // Calling the original function with the proxy as 'this' causes ILLEGAL INVOCATION, so we use
        // the original object.
        func.apply($b0034e17e4ec3171$export$3b14a55fb2447963(this), args);
        return $b0034e17e4ec3171$export$efccba1c4a2ef57b($b0034e17e4ec3171$var$cursorRequestMap.get(this));
    };
    return function(...args) {
        // Calling the original function with the proxy as 'this' causes ILLEGAL INVOCATION, so we use
        // the original object.
        return $b0034e17e4ec3171$export$efccba1c4a2ef57b(func.apply($b0034e17e4ec3171$export$3b14a55fb2447963(this), args));
    };
}
function $b0034e17e4ec3171$var$transformCachableValue(value) {
    if (typeof value === "function") return $b0034e17e4ec3171$var$wrapFunction(value);
    // This doesn't return, it just creates a 'done' promise for the transaction,
    // which is later returned for transaction.done (see idbObjectHandler).
    if (value instanceof IDBTransaction) $b0034e17e4ec3171$var$cacheDonePromiseForTransaction(value);
    if ($b0034e17e4ec3171$export$23f2a1d2818174ef(value, $b0034e17e4ec3171$var$getIdbProxyableTypes())) return new Proxy(value, $b0034e17e4ec3171$var$idbProxyTraps);
    // Return the same value back if we're not going to transform it.
    return value;
}
function $b0034e17e4ec3171$export$efccba1c4a2ef57b(value) {
    // We sometimes generate multiple promises from a single IDBRequest (eg when cursoring), because
    // IDB is weird and a single IDBRequest can yield many responses, so these can't be cached.
    if (value instanceof IDBRequest) return $b0034e17e4ec3171$var$promisifyRequest(value);
    // If we've already transformed this value before, reuse the transformed value.
    // This is faster, but it also provides object equality.
    if ($b0034e17e4ec3171$var$transformCache.has(value)) return $b0034e17e4ec3171$var$transformCache.get(value);
    const newValue = $b0034e17e4ec3171$var$transformCachableValue(value);
    // Not all types are transformed.
    // These may be primitive types, so they can't be WeakMap keys.
    if (newValue !== value) {
        $b0034e17e4ec3171$var$transformCache.set(value, newValue);
        $b0034e17e4ec3171$export$407448d2b89b1813.set(newValue, value);
    }
    return newValue;
}
const $b0034e17e4ec3171$export$3b14a55fb2447963 = (value)=>$b0034e17e4ec3171$export$407448d2b89b1813.get(value);


/**
 * Open a database.
 *
 * @param name Name of the database.
 * @param version Schema version.
 * @param callbacks Additional callbacks.
 */ function $96aa1f92c7775faf$export$ca0ed41b1a2af7e(name, version, { blocked: blocked, upgrade: upgrade, blocking: blocking, terminated: terminated } = {}) {
    const request = indexedDB.open(name, version);
    const openPromise = (0, $b0034e17e4ec3171$export$efccba1c4a2ef57b)(request);
    if (upgrade) request.addEventListener("upgradeneeded", (event)=>{
        upgrade((0, $b0034e17e4ec3171$export$efccba1c4a2ef57b)(request.result), event.oldVersion, event.newVersion, (0, $b0034e17e4ec3171$export$efccba1c4a2ef57b)(request.transaction));
    });
    if (blocked) request.addEventListener("blocked", ()=>blocked());
    openPromise.then((db)=>{
        if (terminated) db.addEventListener("close", ()=>terminated());
        if (blocking) db.addEventListener("versionchange", ()=>blocking());
    }).catch(()=>{});
    return openPromise;
}
/**
 * Delete a database.
 *
 * @param name Name of the database.
 */ function $96aa1f92c7775faf$export$9d6df0ac66a98bb2(name, { blocked: blocked } = {}) {
    const request = indexedDB.deleteDatabase(name);
    if (blocked) request.addEventListener("blocked", ()=>blocked());
    return (0, $b0034e17e4ec3171$export$efccba1c4a2ef57b)(request).then(()=>undefined);
}
const $96aa1f92c7775faf$var$readMethods = [
    "get",
    "getKey",
    "getAll",
    "getAllKeys",
    "count"
];
const $96aa1f92c7775faf$var$writeMethods = [
    "put",
    "add",
    "delete",
    "clear"
];
const $96aa1f92c7775faf$var$cachedMethods = new Map();
function $96aa1f92c7775faf$var$getMethod(target, prop) {
    if (!(target instanceof IDBDatabase && !(prop in target) && typeof prop === "string")) return;
    if ($96aa1f92c7775faf$var$cachedMethods.get(prop)) return $96aa1f92c7775faf$var$cachedMethods.get(prop);
    const targetFuncName = prop.replace(/FromIndex$/, "");
    const useIndex = prop !== targetFuncName;
    const isWrite = $96aa1f92c7775faf$var$writeMethods.includes(targetFuncName);
    if (// Bail if the target doesn't exist on the target. Eg, getAll isn't in Edge.
    !(targetFuncName in (useIndex ? IDBIndex : IDBObjectStore).prototype) || !(isWrite || $96aa1f92c7775faf$var$readMethods.includes(targetFuncName))) return;
    const method = async function(storeName, ...args) {
        // isWrite ? 'readwrite' : undefined gzipps better, but fails in Edge :(
        const tx = this.transaction(storeName, isWrite ? "readwrite" : "readonly");
        let target = tx.store;
        if (useIndex) target = target.index(args.shift());
        // Must reject if op rejects.
        // If it's a write operation, must reject if tx.done rejects.
        // Must reject with op rejection first.
        // Must resolve with op value.
        // Must handle both promises (no unhandled rejections)
        return (await Promise.all([
            target[targetFuncName](...args),
            isWrite && tx.done
        ]))[0];
    };
    $96aa1f92c7775faf$var$cachedMethods.set(prop, method);
    return method;
}
(0, $b0034e17e4ec3171$export$43caf9889c228507)((oldTraps)=>({
        ...oldTraps,
        get: (target, prop, receiver)=>$96aa1f92c7775faf$var$getMethod(target, prop) || oldTraps.get(target, prop, receiver),
        has: (target, prop)=>!!$96aa1f92c7775faf$var$getMethod(target, prop) || oldTraps.has(target, prop)
    }));




/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $97b6afad2c5c80cd$var$DEFAULT_SW_PATH = "/firebase-messaging-sw.js";
const $97b6afad2c5c80cd$var$DEFAULT_SW_SCOPE = "/firebase-cloud-messaging-push-scope";
const $97b6afad2c5c80cd$var$DEFAULT_VAPID_KEY = "BDOU99-h67HcA6JeFXHbSNMu7e2yNNu3RzoMj8TM4W88jITfq7ZmPvIM1Iv-4_l2LxQcYwhqby2xGpWwzjfAnG4";
const $97b6afad2c5c80cd$var$ENDPOINT = "https://fcmregistrations.googleapis.com/v1";
const $97b6afad2c5c80cd$var$CONSOLE_CAMPAIGN_ID = "google.c.a.c_id";
const $97b6afad2c5c80cd$var$CONSOLE_CAMPAIGN_NAME = "google.c.a.c_l";
const $97b6afad2c5c80cd$var$CONSOLE_CAMPAIGN_TIME = "google.c.a.ts";
/** Set to '1' if Analytics is enabled for the campaign */ const $97b6afad2c5c80cd$var$CONSOLE_CAMPAIGN_ANALYTICS_ENABLED = "google.c.a.e";
var $97b6afad2c5c80cd$var$MessageType$1;
(function(MessageType) {
    MessageType[MessageType["DATA_MESSAGE"] = 1] = "DATA_MESSAGE";
    MessageType[MessageType["DISPLAY_NOTIFICATION"] = 3] = "DISPLAY_NOTIFICATION";
})($97b6afad2c5c80cd$var$MessageType$1 || ($97b6afad2c5c80cd$var$MessageType$1 = {}));
/**
 * @license
 * Copyright 2018 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License"); you may not use this file except
 * in compliance with the License. You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under the License
 * is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express
 * or implied. See the License for the specific language governing permissions and limitations under
 * the License.
 */ var $97b6afad2c5c80cd$var$MessageType;
(function(MessageType) {
    MessageType["PUSH_RECEIVED"] = "push-received";
    MessageType["NOTIFICATION_CLICKED"] = "notification-clicked";
})($97b6afad2c5c80cd$var$MessageType || ($97b6afad2c5c80cd$var$MessageType = {}));
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $97b6afad2c5c80cd$var$arrayToBase64(array) {
    const uint8Array = new Uint8Array(array);
    const base64String = btoa(String.fromCharCode(...uint8Array));
    return base64String.replace(/=/g, "").replace(/\+/g, "-").replace(/\//g, "_");
}
function $97b6afad2c5c80cd$var$base64ToArray(base64String) {
    const padding = "=".repeat((4 - base64String.length % 4) % 4);
    const base64 = (base64String + padding).replace(/\-/g, "+").replace(/_/g, "/");
    const rawData = atob(base64);
    const outputArray = new Uint8Array(rawData.length);
    for(let i = 0; i < rawData.length; ++i)outputArray[i] = rawData.charCodeAt(i);
    return outputArray;
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $97b6afad2c5c80cd$var$OLD_DB_NAME = "fcm_token_details_db";
/**
 * The last DB version of 'fcm_token_details_db' was 4. This is one higher, so that the upgrade
 * callback is called for all versions of the old DB.
 */ const $97b6afad2c5c80cd$var$OLD_DB_VERSION = 5;
const $97b6afad2c5c80cd$var$OLD_OBJECT_STORE_NAME = "fcm_token_object_Store";
async function $97b6afad2c5c80cd$var$migrateOldDatabase(senderId) {
    if ("databases" in indexedDB) {
        // indexedDb.databases() is an IndexedDB v3 API and does not exist in all browsers. TODO: Remove
        // typecast when it lands in TS types.
        const databases = await indexedDB.databases();
        const dbNames = databases.map((db)=>db.name);
        if (!dbNames.includes($97b6afad2c5c80cd$var$OLD_DB_NAME)) // old DB didn't exist, no need to open.
        return null;
    }
    let tokenDetails = null;
    const db = await (0, $96aa1f92c7775faf$export$ca0ed41b1a2af7e)($97b6afad2c5c80cd$var$OLD_DB_NAME, $97b6afad2c5c80cd$var$OLD_DB_VERSION, {
        upgrade: async (db, oldVersion, newVersion, upgradeTransaction)=>{
            var _a;
            if (oldVersion < 2) // Database too old, skip migration.
            return;
            if (!db.objectStoreNames.contains($97b6afad2c5c80cd$var$OLD_OBJECT_STORE_NAME)) // Database did not exist. Nothing to do.
            return;
            const objectStore = upgradeTransaction.objectStore($97b6afad2c5c80cd$var$OLD_OBJECT_STORE_NAME);
            const value = await objectStore.index("fcmSenderId").get(senderId);
            await objectStore.clear();
            if (!value) // No entry in the database, nothing to migrate.
            return;
            if (oldVersion === 2) {
                const oldDetails = value;
                if (!oldDetails.auth || !oldDetails.p256dh || !oldDetails.endpoint) return;
                tokenDetails = {
                    token: oldDetails.fcmToken,
                    createTime: (_a = oldDetails.createTime) !== null && _a !== void 0 ? _a : Date.now(),
                    subscriptionOptions: {
                        auth: oldDetails.auth,
                        p256dh: oldDetails.p256dh,
                        endpoint: oldDetails.endpoint,
                        swScope: oldDetails.swScope,
                        vapidKey: typeof oldDetails.vapidKey === "string" ? oldDetails.vapidKey : $97b6afad2c5c80cd$var$arrayToBase64(oldDetails.vapidKey)
                    }
                };
            } else if (oldVersion === 3) {
                const oldDetails = value;
                tokenDetails = {
                    token: oldDetails.fcmToken,
                    createTime: oldDetails.createTime,
                    subscriptionOptions: {
                        auth: $97b6afad2c5c80cd$var$arrayToBase64(oldDetails.auth),
                        p256dh: $97b6afad2c5c80cd$var$arrayToBase64(oldDetails.p256dh),
                        endpoint: oldDetails.endpoint,
                        swScope: oldDetails.swScope,
                        vapidKey: $97b6afad2c5c80cd$var$arrayToBase64(oldDetails.vapidKey)
                    }
                };
            } else if (oldVersion === 4) {
                const oldDetails = value;
                tokenDetails = {
                    token: oldDetails.fcmToken,
                    createTime: oldDetails.createTime,
                    subscriptionOptions: {
                        auth: $97b6afad2c5c80cd$var$arrayToBase64(oldDetails.auth),
                        p256dh: $97b6afad2c5c80cd$var$arrayToBase64(oldDetails.p256dh),
                        endpoint: oldDetails.endpoint,
                        swScope: oldDetails.swScope,
                        vapidKey: $97b6afad2c5c80cd$var$arrayToBase64(oldDetails.vapidKey)
                    }
                };
            }
        }
    });
    db.close();
    // Delete all old databases.
    await (0, $96aa1f92c7775faf$export$9d6df0ac66a98bb2)($97b6afad2c5c80cd$var$OLD_DB_NAME);
    await (0, $96aa1f92c7775faf$export$9d6df0ac66a98bb2)("fcm_vapid_details_db");
    await (0, $96aa1f92c7775faf$export$9d6df0ac66a98bb2)("undefined");
    return $97b6afad2c5c80cd$var$checkTokenDetails(tokenDetails) ? tokenDetails : null;
}
function $97b6afad2c5c80cd$var$checkTokenDetails(tokenDetails) {
    if (!tokenDetails || !tokenDetails.subscriptionOptions) return false;
    const { subscriptionOptions: subscriptionOptions } = tokenDetails;
    return typeof tokenDetails.createTime === "number" && tokenDetails.createTime > 0 && typeof tokenDetails.token === "string" && tokenDetails.token.length > 0 && typeof subscriptionOptions.auth === "string" && subscriptionOptions.auth.length > 0 && typeof subscriptionOptions.p256dh === "string" && subscriptionOptions.p256dh.length > 0 && typeof subscriptionOptions.endpoint === "string" && subscriptionOptions.endpoint.length > 0 && typeof subscriptionOptions.swScope === "string" && subscriptionOptions.swScope.length > 0 && typeof subscriptionOptions.vapidKey === "string" && subscriptionOptions.vapidKey.length > 0;
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // Exported for tests.
const $97b6afad2c5c80cd$var$DATABASE_NAME = "firebase-messaging-database";
const $97b6afad2c5c80cd$var$DATABASE_VERSION = 1;
const $97b6afad2c5c80cd$var$OBJECT_STORE_NAME = "firebase-messaging-store";
let $97b6afad2c5c80cd$var$dbPromise = null;
function $97b6afad2c5c80cd$var$getDbPromise() {
    if (!$97b6afad2c5c80cd$var$dbPromise) $97b6afad2c5c80cd$var$dbPromise = (0, $96aa1f92c7775faf$export$ca0ed41b1a2af7e)($97b6afad2c5c80cd$var$DATABASE_NAME, $97b6afad2c5c80cd$var$DATABASE_VERSION, {
        upgrade: (upgradeDb, oldVersion)=>{
            // We don't use 'break' in this switch statement, the fall-through behavior is what we want,
            // because if there are multiple versions between the old version and the current version, we
            // want ALL the migrations that correspond to those versions to run, not only the last one.
            // eslint-disable-next-line default-case
            switch(oldVersion){
                case 0:
                    upgradeDb.createObjectStore($97b6afad2c5c80cd$var$OBJECT_STORE_NAME);
            }
        }
    });
    return $97b6afad2c5c80cd$var$dbPromise;
}
/** Gets record(s) from the objectStore that match the given key. */ async function $97b6afad2c5c80cd$var$dbGet(firebaseDependencies) {
    const key = $97b6afad2c5c80cd$var$getKey(firebaseDependencies);
    const db = await $97b6afad2c5c80cd$var$getDbPromise();
    const tokenDetails = await db.transaction($97b6afad2c5c80cd$var$OBJECT_STORE_NAME).objectStore($97b6afad2c5c80cd$var$OBJECT_STORE_NAME).get(key);
    if (tokenDetails) return tokenDetails;
    else {
        // Check if there is a tokenDetails object in the old DB.
        const oldTokenDetails = await $97b6afad2c5c80cd$var$migrateOldDatabase(firebaseDependencies.appConfig.senderId);
        if (oldTokenDetails) {
            await $97b6afad2c5c80cd$var$dbSet(firebaseDependencies, oldTokenDetails);
            return oldTokenDetails;
        }
    }
}
/** Assigns or overwrites the record for the given key with the given value. */ async function $97b6afad2c5c80cd$var$dbSet(firebaseDependencies, tokenDetails) {
    const key = $97b6afad2c5c80cd$var$getKey(firebaseDependencies);
    const db = await $97b6afad2c5c80cd$var$getDbPromise();
    const tx = db.transaction($97b6afad2c5c80cd$var$OBJECT_STORE_NAME, "readwrite");
    await tx.objectStore($97b6afad2c5c80cd$var$OBJECT_STORE_NAME).put(tokenDetails, key);
    await tx.done;
    return tokenDetails;
}
/** Removes record(s) from the objectStore that match the given key. */ async function $97b6afad2c5c80cd$var$dbRemove(firebaseDependencies) {
    const key = $97b6afad2c5c80cd$var$getKey(firebaseDependencies);
    const db = await $97b6afad2c5c80cd$var$getDbPromise();
    const tx = db.transaction($97b6afad2c5c80cd$var$OBJECT_STORE_NAME, "readwrite");
    await tx.objectStore($97b6afad2c5c80cd$var$OBJECT_STORE_NAME).delete(key);
    await tx.done;
}
function $97b6afad2c5c80cd$var$getKey({ appConfig: appConfig }) {
    return appConfig.appId;
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $97b6afad2c5c80cd$var$ERROR_MAP = {
    ["missing-app-config-values" /* ErrorCode.MISSING_APP_CONFIG_VALUES */ ]: 'Missing App configuration value: "{$valueName}"',
    ["only-available-in-window" /* ErrorCode.AVAILABLE_IN_WINDOW */ ]: "This method is available in a Window context.",
    ["only-available-in-sw" /* ErrorCode.AVAILABLE_IN_SW */ ]: "This method is available in a service worker context.",
    ["permission-default" /* ErrorCode.PERMISSION_DEFAULT */ ]: "The notification permission was not granted and dismissed instead.",
    ["permission-blocked" /* ErrorCode.PERMISSION_BLOCKED */ ]: "The notification permission was not granted and blocked instead.",
    ["unsupported-browser" /* ErrorCode.UNSUPPORTED_BROWSER */ ]: "This browser doesn't support the API's required to use the Firebase SDK.",
    ["indexed-db-unsupported" /* ErrorCode.INDEXED_DB_UNSUPPORTED */ ]: "This browser doesn't support indexedDb.open() (ex. Safari iFrame, Firefox Private Browsing, etc)",
    ["failed-service-worker-registration" /* ErrorCode.FAILED_DEFAULT_REGISTRATION */ ]: "We are unable to register the default service worker. {$browserErrorMessage}",
    ["token-subscribe-failed" /* ErrorCode.TOKEN_SUBSCRIBE_FAILED */ ]: "A problem occurred while subscribing the user to FCM: {$errorInfo}",
    ["token-subscribe-no-token" /* ErrorCode.TOKEN_SUBSCRIBE_NO_TOKEN */ ]: "FCM returned no token when subscribing the user to push.",
    ["token-unsubscribe-failed" /* ErrorCode.TOKEN_UNSUBSCRIBE_FAILED */ ]: "A problem occurred while unsubscribing the user from FCM: {$errorInfo}",
    ["token-update-failed" /* ErrorCode.TOKEN_UPDATE_FAILED */ ]: "A problem occurred while updating the user from FCM: {$errorInfo}",
    ["token-update-no-token" /* ErrorCode.TOKEN_UPDATE_NO_TOKEN */ ]: "FCM returned no token when updating the user to push.",
    ["use-sw-after-get-token" /* ErrorCode.USE_SW_AFTER_GET_TOKEN */ ]: "The useServiceWorker() method may only be called once and must be called before calling getToken() to ensure your service worker is used.",
    ["invalid-sw-registration" /* ErrorCode.INVALID_SW_REGISTRATION */ ]: "The input to useServiceWorker() must be a ServiceWorkerRegistration.",
    ["invalid-bg-handler" /* ErrorCode.INVALID_BG_HANDLER */ ]: "The input to setBackgroundMessageHandler() must be a function.",
    ["invalid-vapid-key" /* ErrorCode.INVALID_VAPID_KEY */ ]: "The public VAPID key must be a string.",
    ["use-vapid-key-after-get-token" /* ErrorCode.USE_VAPID_KEY_AFTER_GET_TOKEN */ ]: "The usePublicVapidKey() method may only be called once and must be called before calling getToken() to ensure your VAPID key is used."
};
const $97b6afad2c5c80cd$var$ERROR_FACTORY = new (0, $c38e0f42709c826a$export$3fa6e1b18a3b2d40)("messaging", "Messaging", $97b6afad2c5c80cd$var$ERROR_MAP);
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ async function $97b6afad2c5c80cd$var$requestGetToken(firebaseDependencies, subscriptionOptions) {
    const headers = await $97b6afad2c5c80cd$var$getHeaders(firebaseDependencies);
    const body = $97b6afad2c5c80cd$var$getBody(subscriptionOptions);
    const subscribeOptions = {
        method: "POST",
        headers: headers,
        body: JSON.stringify(body)
    };
    let responseData;
    try {
        const response = await fetch($97b6afad2c5c80cd$var$getEndpoint(firebaseDependencies.appConfig), subscribeOptions);
        responseData = await response.json();
    } catch (err) {
        throw $97b6afad2c5c80cd$var$ERROR_FACTORY.create("token-subscribe-failed" /* ErrorCode.TOKEN_SUBSCRIBE_FAILED */ , {
            errorInfo: err === null || err === void 0 ? void 0 : err.toString()
        });
    }
    if (responseData.error) {
        const message = responseData.error.message;
        throw $97b6afad2c5c80cd$var$ERROR_FACTORY.create("token-subscribe-failed" /* ErrorCode.TOKEN_SUBSCRIBE_FAILED */ , {
            errorInfo: message
        });
    }
    if (!responseData.token) throw $97b6afad2c5c80cd$var$ERROR_FACTORY.create("token-subscribe-no-token" /* ErrorCode.TOKEN_SUBSCRIBE_NO_TOKEN */ );
    return responseData.token;
}
async function $97b6afad2c5c80cd$var$requestUpdateToken(firebaseDependencies, tokenDetails) {
    const headers = await $97b6afad2c5c80cd$var$getHeaders(firebaseDependencies);
    const body = $97b6afad2c5c80cd$var$getBody(tokenDetails.subscriptionOptions);
    const updateOptions = {
        method: "PATCH",
        headers: headers,
        body: JSON.stringify(body)
    };
    let responseData;
    try {
        const response = await fetch(`${$97b6afad2c5c80cd$var$getEndpoint(firebaseDependencies.appConfig)}/${tokenDetails.token}`, updateOptions);
        responseData = await response.json();
    } catch (err) {
        throw $97b6afad2c5c80cd$var$ERROR_FACTORY.create("token-update-failed" /* ErrorCode.TOKEN_UPDATE_FAILED */ , {
            errorInfo: err === null || err === void 0 ? void 0 : err.toString()
        });
    }
    if (responseData.error) {
        const message = responseData.error.message;
        throw $97b6afad2c5c80cd$var$ERROR_FACTORY.create("token-update-failed" /* ErrorCode.TOKEN_UPDATE_FAILED */ , {
            errorInfo: message
        });
    }
    if (!responseData.token) throw $97b6afad2c5c80cd$var$ERROR_FACTORY.create("token-update-no-token" /* ErrorCode.TOKEN_UPDATE_NO_TOKEN */ );
    return responseData.token;
}
async function $97b6afad2c5c80cd$var$requestDeleteToken(firebaseDependencies, token) {
    const headers = await $97b6afad2c5c80cd$var$getHeaders(firebaseDependencies);
    const unsubscribeOptions = {
        method: "DELETE",
        headers: headers
    };
    try {
        const response = await fetch(`${$97b6afad2c5c80cd$var$getEndpoint(firebaseDependencies.appConfig)}/${token}`, unsubscribeOptions);
        const responseData = await response.json();
        if (responseData.error) {
            const message = responseData.error.message;
            throw $97b6afad2c5c80cd$var$ERROR_FACTORY.create("token-unsubscribe-failed" /* ErrorCode.TOKEN_UNSUBSCRIBE_FAILED */ , {
                errorInfo: message
            });
        }
    } catch (err) {
        throw $97b6afad2c5c80cd$var$ERROR_FACTORY.create("token-unsubscribe-failed" /* ErrorCode.TOKEN_UNSUBSCRIBE_FAILED */ , {
            errorInfo: err === null || err === void 0 ? void 0 : err.toString()
        });
    }
}
function $97b6afad2c5c80cd$var$getEndpoint({ projectId: projectId }) {
    return `${$97b6afad2c5c80cd$var$ENDPOINT}/projects/${projectId}/registrations`;
}
async function $97b6afad2c5c80cd$var$getHeaders({ appConfig: appConfig, installations: installations }) {
    const authToken = await installations.getToken();
    return new Headers({
        "Content-Type": "application/json",
        Accept: "application/json",
        "x-goog-api-key": appConfig.apiKey,
        "x-goog-firebase-installations-auth": `FIS ${authToken}`
    });
}
function $97b6afad2c5c80cd$var$getBody({ p256dh: p256dh, auth: auth, endpoint: endpoint, vapidKey: vapidKey }) {
    const body = {
        web: {
            endpoint: endpoint,
            auth: auth,
            p256dh: p256dh
        }
    };
    if (vapidKey !== $97b6afad2c5c80cd$var$DEFAULT_VAPID_KEY) body.web.applicationPubKey = vapidKey;
    return body;
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // UpdateRegistration will be called once every week.
const $97b6afad2c5c80cd$var$TOKEN_EXPIRATION_MS = 604800000; // 7 days
async function $97b6afad2c5c80cd$var$getTokenInternal(messaging) {
    const pushSubscription = await $97b6afad2c5c80cd$var$getPushSubscription(messaging.swRegistration, messaging.vapidKey);
    const subscriptionOptions = {
        vapidKey: messaging.vapidKey,
        swScope: messaging.swRegistration.scope,
        endpoint: pushSubscription.endpoint,
        auth: $97b6afad2c5c80cd$var$arrayToBase64(pushSubscription.getKey("auth")),
        p256dh: $97b6afad2c5c80cd$var$arrayToBase64(pushSubscription.getKey("p256dh"))
    };
    const tokenDetails = await $97b6afad2c5c80cd$var$dbGet(messaging.firebaseDependencies);
    if (!tokenDetails) // No token, get a new one.
    return $97b6afad2c5c80cd$var$getNewToken(messaging.firebaseDependencies, subscriptionOptions);
    else if (!$97b6afad2c5c80cd$var$isTokenValid(tokenDetails.subscriptionOptions, subscriptionOptions)) {
        // Invalid token, get a new one.
        try {
            await $97b6afad2c5c80cd$var$requestDeleteToken(messaging.firebaseDependencies, tokenDetails.token);
        } catch (e) {
            // Suppress errors because of #2364
            console.warn(e);
        }
        return $97b6afad2c5c80cd$var$getNewToken(messaging.firebaseDependencies, subscriptionOptions);
    } else if (Date.now() >= tokenDetails.createTime + $97b6afad2c5c80cd$var$TOKEN_EXPIRATION_MS) // Weekly token refresh
    return $97b6afad2c5c80cd$var$updateToken(messaging, {
        token: tokenDetails.token,
        createTime: Date.now(),
        subscriptionOptions: subscriptionOptions
    });
    else // Valid token, nothing to do.
    return tokenDetails.token;
}
/**
 * This method deletes the token from the database, unsubscribes the token from FCM, and unregisters
 * the push subscription if it exists.
 */ async function $97b6afad2c5c80cd$var$deleteTokenInternal(messaging) {
    const tokenDetails = await $97b6afad2c5c80cd$var$dbGet(messaging.firebaseDependencies);
    if (tokenDetails) {
        await $97b6afad2c5c80cd$var$requestDeleteToken(messaging.firebaseDependencies, tokenDetails.token);
        await $97b6afad2c5c80cd$var$dbRemove(messaging.firebaseDependencies);
    }
    // Unsubscribe from the push subscription.
    const pushSubscription = await messaging.swRegistration.pushManager.getSubscription();
    if (pushSubscription) return pushSubscription.unsubscribe();
    // If there's no SW, consider it a success.
    return true;
}
async function $97b6afad2c5c80cd$var$updateToken(messaging, tokenDetails) {
    try {
        const updatedToken = await $97b6afad2c5c80cd$var$requestUpdateToken(messaging.firebaseDependencies, tokenDetails);
        const updatedTokenDetails = Object.assign(Object.assign({}, tokenDetails), {
            token: updatedToken,
            createTime: Date.now()
        });
        await $97b6afad2c5c80cd$var$dbSet(messaging.firebaseDependencies, updatedTokenDetails);
        return updatedToken;
    } catch (e) {
        await $97b6afad2c5c80cd$var$deleteTokenInternal(messaging);
        throw e;
    }
}
async function $97b6afad2c5c80cd$var$getNewToken(firebaseDependencies, subscriptionOptions) {
    const token = await $97b6afad2c5c80cd$var$requestGetToken(firebaseDependencies, subscriptionOptions);
    const tokenDetails = {
        token: token,
        createTime: Date.now(),
        subscriptionOptions: subscriptionOptions
    };
    await $97b6afad2c5c80cd$var$dbSet(firebaseDependencies, tokenDetails);
    return tokenDetails.token;
}
/**
 * Gets a PushSubscription for the current user.
 */ async function $97b6afad2c5c80cd$var$getPushSubscription(swRegistration, vapidKey) {
    const subscription = await swRegistration.pushManager.getSubscription();
    if (subscription) return subscription;
    return swRegistration.pushManager.subscribe({
        userVisibleOnly: true,
        // Chrome <= 75 doesn't support base64-encoded VAPID key. For backward compatibility, VAPID key
        // submitted to pushManager#subscribe must be of type Uint8Array.
        applicationServerKey: $97b6afad2c5c80cd$var$base64ToArray(vapidKey)
    });
}
/**
 * Checks if the saved tokenDetails object matches the configuration provided.
 */ function $97b6afad2c5c80cd$var$isTokenValid(dbOptions, currentOptions) {
    const isVapidKeyEqual = currentOptions.vapidKey === dbOptions.vapidKey;
    const isEndpointEqual = currentOptions.endpoint === dbOptions.endpoint;
    const isAuthEqual = currentOptions.auth === dbOptions.auth;
    const isP256dhEqual = currentOptions.p256dh === dbOptions.p256dh;
    return isVapidKeyEqual && isEndpointEqual && isAuthEqual && isP256dhEqual;
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $97b6afad2c5c80cd$var$externalizePayload(internalPayload) {
    const payload = {
        from: internalPayload.from,
        // eslint-disable-next-line camelcase
        collapseKey: internalPayload.collapse_key,
        // eslint-disable-next-line camelcase
        messageId: internalPayload.fcmMessageId
    };
    $97b6afad2c5c80cd$var$propagateNotificationPayload(payload, internalPayload);
    $97b6afad2c5c80cd$var$propagateDataPayload(payload, internalPayload);
    $97b6afad2c5c80cd$var$propagateFcmOptions(payload, internalPayload);
    return payload;
}
function $97b6afad2c5c80cd$var$propagateNotificationPayload(payload, messagePayloadInternal) {
    if (!messagePayloadInternal.notification) return;
    payload.notification = {};
    const title = messagePayloadInternal.notification.title;
    if (!!title) payload.notification.title = title;
    const body = messagePayloadInternal.notification.body;
    if (!!body) payload.notification.body = body;
    const image = messagePayloadInternal.notification.image;
    if (!!image) payload.notification.image = image;
    const icon = messagePayloadInternal.notification.icon;
    if (!!icon) payload.notification.icon = icon;
}
function $97b6afad2c5c80cd$var$propagateDataPayload(payload, messagePayloadInternal) {
    if (!messagePayloadInternal.data) return;
    payload.data = messagePayloadInternal.data;
}
function $97b6afad2c5c80cd$var$propagateFcmOptions(payload, messagePayloadInternal) {
    var _a, _b, _c, _d, _e;
    // fcmOptions.link value is written into notification.click_action. see more in b/232072111
    if (!messagePayloadInternal.fcmOptions && !((_a = messagePayloadInternal.notification) === null || _a === void 0 ? void 0 : _a.click_action)) return;
    payload.fcmOptions = {};
    const link = (_c = (_b = messagePayloadInternal.fcmOptions) === null || _b === void 0 ? void 0 : _b.link) !== null && _c !== void 0 ? _c : (_d = messagePayloadInternal.notification) === null || _d === void 0 ? void 0 : _d.click_action;
    if (!!link) payload.fcmOptions.link = link;
    // eslint-disable-next-line camelcase
    const analyticsLabel = (_e = messagePayloadInternal.fcmOptions) === null || _e === void 0 ? void 0 : _e.analytics_label;
    if (!!analyticsLabel) payload.fcmOptions.analyticsLabel = analyticsLabel;
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $97b6afad2c5c80cd$var$isConsoleMessage(data) {
    // This message has a campaign ID, meaning it was sent using the Firebase Console.
    return typeof data === "object" && !!data && $97b6afad2c5c80cd$var$CONSOLE_CAMPAIGN_ID in data;
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ $97b6afad2c5c80cd$var$_mergeStrings("hts/frbslgigp.ogepscmv/ieo/eaylg", "tp:/ieaeogn-agolai.o/1frlglgc/o");
$97b6afad2c5c80cd$var$_mergeStrings("AzSCbw63g1R0nCw85jG8", "Iaya3yLKwmgvh7cF0q4");
function $97b6afad2c5c80cd$var$_mergeStrings(s1, s2) {
    const resultArray = [];
    for(let i = 0; i < s1.length; i++){
        resultArray.push(s1.charAt(i));
        if (i < s2.length) resultArray.push(s2.charAt(i));
    }
    return resultArray.join("");
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $97b6afad2c5c80cd$var$extractAppConfig(app) {
    if (!app || !app.options) throw $97b6afad2c5c80cd$var$getMissingValueError("App Configuration Object");
    if (!app.name) throw $97b6afad2c5c80cd$var$getMissingValueError("App Name");
    // Required app config keys
    const configKeys = [
        "projectId",
        "apiKey",
        "appId",
        "messagingSenderId"
    ];
    const { options: options } = app;
    for (const keyName of configKeys){
        if (!options[keyName]) throw $97b6afad2c5c80cd$var$getMissingValueError(keyName);
    }
    return {
        appName: app.name,
        projectId: options.projectId,
        apiKey: options.apiKey,
        appId: options.appId,
        senderId: options.messagingSenderId
    };
}
function $97b6afad2c5c80cd$var$getMissingValueError(valueName) {
    return $97b6afad2c5c80cd$var$ERROR_FACTORY.create("missing-app-config-values" /* ErrorCode.MISSING_APP_CONFIG_VALUES */ , {
        valueName: valueName
    });
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $97b6afad2c5c80cd$var$MessagingService {
    constructor(app, installations, analyticsProvider){
        // logging is only done with end user consent. Default to false.
        this.deliveryMetricsExportedToBigQueryEnabled = false;
        this.onBackgroundMessageHandler = null;
        this.onMessageHandler = null;
        this.logEvents = [];
        this.isLogServiceStarted = false;
        const appConfig = $97b6afad2c5c80cd$var$extractAppConfig(app);
        this.firebaseDependencies = {
            app: app,
            appConfig: appConfig,
            installations: installations,
            analyticsProvider: analyticsProvider
        };
    }
    _delete() {
        return Promise.resolve();
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ async function $97b6afad2c5c80cd$var$registerDefaultSw(messaging) {
    try {
        messaging.swRegistration = await navigator.serviceWorker.register($97b6afad2c5c80cd$var$DEFAULT_SW_PATH, {
            scope: $97b6afad2c5c80cd$var$DEFAULT_SW_SCOPE
        });
        // The timing when browser updates sw when sw has an update is unreliable from experiment. It
        // leads to version conflict when the SDK upgrades to a newer version in the main page, but sw
        // is stuck with the old version. For example,
        // https://github.com/firebase/firebase-js-sdk/issues/2590 The following line reliably updates
        // sw if there was an update.
        messaging.swRegistration.update().catch(()=>{
        /* it is non blocking and we don't care if it failed */ });
    } catch (e) {
        throw $97b6afad2c5c80cd$var$ERROR_FACTORY.create("failed-service-worker-registration" /* ErrorCode.FAILED_DEFAULT_REGISTRATION */ , {
            browserErrorMessage: e === null || e === void 0 ? void 0 : e.message
        });
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ async function $97b6afad2c5c80cd$var$updateSwReg(messaging, swRegistration) {
    if (!swRegistration && !messaging.swRegistration) await $97b6afad2c5c80cd$var$registerDefaultSw(messaging);
    if (!swRegistration && !!messaging.swRegistration) return;
    if (!(swRegistration instanceof ServiceWorkerRegistration)) throw $97b6afad2c5c80cd$var$ERROR_FACTORY.create("invalid-sw-registration" /* ErrorCode.INVALID_SW_REGISTRATION */ );
    messaging.swRegistration = swRegistration;
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ async function $97b6afad2c5c80cd$var$updateVapidKey(messaging, vapidKey) {
    if (!!vapidKey) messaging.vapidKey = vapidKey;
    else if (!messaging.vapidKey) messaging.vapidKey = $97b6afad2c5c80cd$var$DEFAULT_VAPID_KEY;
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ async function $97b6afad2c5c80cd$var$getToken$1(messaging, options) {
    if (!navigator) throw $97b6afad2c5c80cd$var$ERROR_FACTORY.create("only-available-in-window" /* ErrorCode.AVAILABLE_IN_WINDOW */ );
    if (Notification.permission === "default") await Notification.requestPermission();
    if (Notification.permission !== "granted") throw $97b6afad2c5c80cd$var$ERROR_FACTORY.create("permission-blocked" /* ErrorCode.PERMISSION_BLOCKED */ );
    await $97b6afad2c5c80cd$var$updateVapidKey(messaging, options === null || options === void 0 ? void 0 : options.vapidKey);
    await $97b6afad2c5c80cd$var$updateSwReg(messaging, options === null || options === void 0 ? void 0 : options.serviceWorkerRegistration);
    return $97b6afad2c5c80cd$var$getTokenInternal(messaging);
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ async function $97b6afad2c5c80cd$var$logToScion(messaging, messageType, data) {
    const eventType = $97b6afad2c5c80cd$var$getEventType(messageType);
    const analytics = await messaging.firebaseDependencies.analyticsProvider.get();
    analytics.logEvent(eventType, {
        /* eslint-disable camelcase */ message_id: data[$97b6afad2c5c80cd$var$CONSOLE_CAMPAIGN_ID],
        message_name: data[$97b6afad2c5c80cd$var$CONSOLE_CAMPAIGN_NAME],
        message_time: data[$97b6afad2c5c80cd$var$CONSOLE_CAMPAIGN_TIME],
        message_device_time: Math.floor(Date.now() / 1000)
    });
}
function $97b6afad2c5c80cd$var$getEventType(messageType) {
    switch(messageType){
        case $97b6afad2c5c80cd$var$MessageType.NOTIFICATION_CLICKED:
            return "notification_open";
        case $97b6afad2c5c80cd$var$MessageType.PUSH_RECEIVED:
            return "notification_foreground";
        default:
            throw new Error();
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ async function $97b6afad2c5c80cd$var$messageEventListener(messaging, event) {
    const internalPayload = event.data;
    if (!internalPayload.isFirebaseMessaging) return;
    if (messaging.onMessageHandler && internalPayload.messageType === $97b6afad2c5c80cd$var$MessageType.PUSH_RECEIVED) {
        if (typeof messaging.onMessageHandler === "function") messaging.onMessageHandler($97b6afad2c5c80cd$var$externalizePayload(internalPayload));
        else messaging.onMessageHandler.next($97b6afad2c5c80cd$var$externalizePayload(internalPayload));
    }
    // Log to Scion if applicable
    const dataPayload = internalPayload.data;
    if ($97b6afad2c5c80cd$var$isConsoleMessage(dataPayload) && dataPayload[$97b6afad2c5c80cd$var$CONSOLE_CAMPAIGN_ANALYTICS_ENABLED] === "1") await $97b6afad2c5c80cd$var$logToScion(messaging, internalPayload.messageType, dataPayload);
}
const $97b6afad2c5c80cd$var$name = "@firebase/messaging";
const $97b6afad2c5c80cd$var$version = "0.12.4";
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $97b6afad2c5c80cd$var$WindowMessagingFactory = (container)=>{
    const messaging = new $97b6afad2c5c80cd$var$MessagingService(container.getProvider("app").getImmediate(), container.getProvider("installations-internal").getImmediate(), container.getProvider("analytics-internal"));
    navigator.serviceWorker.addEventListener("message", (e)=>$97b6afad2c5c80cd$var$messageEventListener(messaging, e));
    return messaging;
};
const $97b6afad2c5c80cd$var$WindowMessagingInternalFactory = (container)=>{
    const messaging = container.getProvider("messaging").getImmediate();
    const messagingInternal = {
        getToken: (options)=>$97b6afad2c5c80cd$var$getToken$1(messaging, options)
    };
    return messagingInternal;
};
function $97b6afad2c5c80cd$var$registerMessagingInWindow() {
    (0, $57d436074e210fb5$export$c930050e7bb63965)(new (0, $a83e7ccd68ca8d4e$export$16fa2f45be04daa8)("messaging", $97b6afad2c5c80cd$var$WindowMessagingFactory, "PUBLIC" /* ComponentType.PUBLIC */ ));
    (0, $57d436074e210fb5$export$c930050e7bb63965)(new (0, $a83e7ccd68ca8d4e$export$16fa2f45be04daa8)("messaging-internal", $97b6afad2c5c80cd$var$WindowMessagingInternalFactory, "PRIVATE" /* ComponentType.PRIVATE */ ));
    (0, $57d436074e210fb5$export$d29d5299a7137abc)($97b6afad2c5c80cd$var$name, $97b6afad2c5c80cd$var$version);
    // BUILD_TARGET will be replaced by values like esm5, esm2017, cjs5, etc during the compilation
    (0, $57d436074e210fb5$export$d29d5299a7137abc)($97b6afad2c5c80cd$var$name, $97b6afad2c5c80cd$var$version, "esm2017");
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Checks if all required APIs exist in the browser.
 * @returns a Promise that resolves to a boolean.
 *
 * @public
 */ async function $97b6afad2c5c80cd$export$48c17662a6902497() {
    try {
        // This throws if open() is unsupported, so adding it to the conditional
        // statement below can cause an uncaught error.
        await (0, $c38e0f42709c826a$export$a8a3018f3d187a4d)();
    } catch (e) {
        return false;
    }
    // firebase-js-sdk/issues/2393 reveals that idb#open in Safari iframe and Firefox private browsing
    // might be prohibited to run. In these contexts, an error would be thrown during the messaging
    // instantiating phase, informing the developers to import/call isSupported for special handling.
    return typeof window !== "undefined" && (0, $c38e0f42709c826a$export$3865db50535c2055)() && (0, $c38e0f42709c826a$export$f172b7eb6cf60599)() && "serviceWorker" in navigator && "PushManager" in window && "Notification" in window && "fetch" in window && ServiceWorkerRegistration.prototype.hasOwnProperty("showNotification") && PushSubscription.prototype.hasOwnProperty("getKey");
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ async function $97b6afad2c5c80cd$var$deleteToken$1(messaging) {
    if (!navigator) throw $97b6afad2c5c80cd$var$ERROR_FACTORY.create("only-available-in-window" /* ErrorCode.AVAILABLE_IN_WINDOW */ );
    if (!messaging.swRegistration) await $97b6afad2c5c80cd$var$registerDefaultSw(messaging);
    return $97b6afad2c5c80cd$var$deleteTokenInternal(messaging);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $97b6afad2c5c80cd$var$onMessage$1(messaging, nextOrObserver) {
    if (!navigator) throw $97b6afad2c5c80cd$var$ERROR_FACTORY.create("only-available-in-window" /* ErrorCode.AVAILABLE_IN_WINDOW */ );
    messaging.onMessageHandler = nextOrObserver;
    return ()=>{
        messaging.onMessageHandler = null;
    };
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Retrieves a Firebase Cloud Messaging instance.
 *
 * @returns The Firebase Cloud Messaging instance associated with the provided firebase app.
 *
 * @public
 */ function $97b6afad2c5c80cd$export$f74c3c76482a8451(app = (0, $57d436074e210fb5$export$f9962582c9e66d99)()) {
    // Conscious decision to make this async check non-blocking during the messaging instance
    // initialization phase for performance consideration. An error would be thrown latter for
    // developer's information. Developers can then choose to import and call `isSupported` for
    // special handling.
    $97b6afad2c5c80cd$export$48c17662a6902497().then((isSupported)=>{
        // If `isWindowSupported()` resolved, but returned false.
        if (!isSupported) throw $97b6afad2c5c80cd$var$ERROR_FACTORY.create("unsupported-browser" /* ErrorCode.UNSUPPORTED_BROWSER */ );
    }, (_)=>{
        // If `isWindowSupported()` rejected.
        throw $97b6afad2c5c80cd$var$ERROR_FACTORY.create("indexed-db-unsupported" /* ErrorCode.INDEXED_DB_UNSUPPORTED */ );
    });
    return (0, $57d436074e210fb5$export$fa0d6da0f5838f50)((0, $c38e0f42709c826a$export$4befe9b5fa509a1b)(app), "messaging").getImmediate();
}
/**
 * Subscribes the {@link Messaging} instance to push notifications. Returns an Firebase Cloud
 * Messaging registration token that can be used to send push messages to that {@link Messaging}
 * instance.
 *
 * If a notification permission isn't already granted, this method asks the user for permission. The
 * returned promise rejects if the user does not allow the app to show notifications.
 *
 * @param messaging - The {@link Messaging} instance.
 * @param options - Provides an optional vapid key and an optinoal service worker registration
 *
 * @returns The promise resolves with an FCM registration token.
 *
 * @public
 */ async function $97b6afad2c5c80cd$export$257b2d10b709d8ef(messaging, options) {
    messaging = (0, $c38e0f42709c826a$export$4befe9b5fa509a1b)(messaging);
    return $97b6afad2c5c80cd$var$getToken$1(messaging, options);
}
/**
 * Deletes the registration token associated with this {@link Messaging} instance and unsubscribes
 * the {@link Messaging} instance from the push subscription.
 *
 * @param messaging - The {@link Messaging} instance.
 *
 * @returns The promise resolves when the token has been successfully deleted.
 *
 * @public
 */ function $97b6afad2c5c80cd$export$95d23a5f596fdc8e(messaging) {
    messaging = (0, $c38e0f42709c826a$export$4befe9b5fa509a1b)(messaging);
    return $97b6afad2c5c80cd$var$deleteToken$1(messaging);
}
/**
 * When a push message is received and the user is currently on a page for your origin, the
 * message is passed to the page and an `onMessage()` event is dispatched with the payload of
 * the push message.
 *
 *
 * @param messaging - The {@link Messaging} instance.
 * @param nextOrObserver - This function, or observer object with `next` defined,
 *     is called when a message is received and the user is currently viewing your page.
 * @returns To stop listening for messages execute this returned function.
 *
 * @public
 */ function $97b6afad2c5c80cd$export$7275a8dcb77dc20d(messaging, nextOrObserver) {
    messaging = (0, $c38e0f42709c826a$export$4befe9b5fa509a1b)(messaging);
    return $97b6afad2c5c80cd$var$onMessage$1(messaging, nextOrObserver);
}
/**
 * Firebase Cloud Messaging
 *
 * @packageDocumentation
 */ $97b6afad2c5c80cd$var$registerMessagingInWindow();





var $bsQZT = parcelRequire("bsQZT");
const $d958c836b794ffc2$export$f2cb4a1378695967 = async ()=>{
    if (await (0, $97b6afad2c5c80cd$export$48c17662a6902497)()) try {
        const token = await (0, $97b6afad2c5c80cd$export$257b2d10b709d8ef)((0, $97b6afad2c5c80cd$export$f74c3c76482a8451)(), {
            vapidKey: (0, $bsQZT.config).FIREBASE_WEB_CONFIG.vapidKey
        });
        return token;
    } catch  {
        return "0";
    }
    else return "0";
};


const $7af34371d75563b6$export$5a8e049606f4bc34 = ()=>{
    const [firebaseToken, setFirebaseToken] = (0, $acw62.useState)("0");
    (0, $acw62.useEffect)(()=>{
        (0, $d958c836b794ffc2$export$f2cb4a1378695967)().then(setFirebaseToken).catch(()=>setFirebaseToken("0"));
    }, []);
    return firebaseToken;
};




function $4d35ca0862055760$export$2e2bcd8739ae039(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}


function $b8f57191916382d3$export$2e2bcd8739ae039(o) {
    "@babel/helpers - typeof";
    return $b8f57191916382d3$export$2e2bcd8739ae039 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $b8f57191916382d3$export$2e2bcd8739ae039(o);
}



function $96eac03571e01dbf$export$2e2bcd8739ae039(input, hint) {
    if ((0, $b8f57191916382d3$export$2e2bcd8739ae039)(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ((0, $b8f57191916382d3$export$2e2bcd8739ae039)(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}


function $3a21fd50cbcd11cf$export$2e2bcd8739ae039(arg) {
    var key = (0, $96eac03571e01dbf$export$2e2bcd8739ae039)(arg, "string");
    return (0, $b8f57191916382d3$export$2e2bcd8739ae039)(key) === "symbol" ? key : String(key);
}


function $94019358ecbcf36b$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, (0, $3a21fd50cbcd11cf$export$2e2bcd8739ae039)(descriptor.key), descriptor);
    }
}
function $94019358ecbcf36b$export$2e2bcd8739ae039(Constructor, protoProps, staticProps) {
    if (protoProps) $94019358ecbcf36b$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $94019358ecbcf36b$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}


var $60196a4650e96cb1$var$arr = [];
var $60196a4650e96cb1$var$each = $60196a4650e96cb1$var$arr.forEach;
var $60196a4650e96cb1$var$slice = $60196a4650e96cb1$var$arr.slice;
function $60196a4650e96cb1$var$defaults(obj) {
    $60196a4650e96cb1$var$each.call($60196a4650e96cb1$var$slice.call(arguments, 1), function(source) {
        if (source) {
            for(var prop in source)if (obj[prop] === undefined) obj[prop] = source[prop];
        }
    });
    return obj;
}
// eslint-disable-next-line no-control-regex
var $60196a4650e96cb1$var$fieldContentRegExp = /^[\u0009\u0020-\u007e\u0080-\u00ff]+$/;
var $60196a4650e96cb1$var$serializeCookie = function serializeCookie(name, val, options) {
    var opt = options || {};
    opt.path = opt.path || "/";
    var value = encodeURIComponent(val);
    var str = "".concat(name, "=").concat(value);
    if (opt.maxAge > 0) {
        var maxAge = opt.maxAge - 0;
        if (Number.isNaN(maxAge)) throw new Error("maxAge should be a Number");
        str += "; Max-Age=".concat(Math.floor(maxAge));
    }
    if (opt.domain) {
        if (!$60196a4650e96cb1$var$fieldContentRegExp.test(opt.domain)) throw new TypeError("option domain is invalid");
        str += "; Domain=".concat(opt.domain);
    }
    if (opt.path) {
        if (!$60196a4650e96cb1$var$fieldContentRegExp.test(opt.path)) throw new TypeError("option path is invalid");
        str += "; Path=".concat(opt.path);
    }
    if (opt.expires) {
        if (typeof opt.expires.toUTCString !== "function") throw new TypeError("option expires is invalid");
        str += "; Expires=".concat(opt.expires.toUTCString());
    }
    if (opt.httpOnly) str += "; HttpOnly";
    if (opt.secure) str += "; Secure";
    if (opt.sameSite) {
        var sameSite = typeof opt.sameSite === "string" ? opt.sameSite.toLowerCase() : opt.sameSite;
        switch(sameSite){
            case true:
                str += "; SameSite=Strict";
                break;
            case "lax":
                str += "; SameSite=Lax";
                break;
            case "strict":
                str += "; SameSite=Strict";
                break;
            case "none":
                str += "; SameSite=None";
                break;
            default:
                throw new TypeError("option sameSite is invalid");
        }
    }
    return str;
};
var $60196a4650e96cb1$var$cookie = {
    create: function create(name, value, minutes, domain) {
        var cookieOptions = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : {
            path: "/",
            sameSite: "strict"
        };
        if (minutes) {
            cookieOptions.expires = new Date();
            cookieOptions.expires.setTime(cookieOptions.expires.getTime() + minutes * 60000);
        }
        if (domain) cookieOptions.domain = domain;
        document.cookie = $60196a4650e96cb1$var$serializeCookie(name, encodeURIComponent(value), cookieOptions);
    },
    read: function read(name) {
        var nameEQ = "".concat(name, "=");
        var ca = document.cookie.split(";");
        for(var i = 0; i < ca.length; i++){
            var c = ca[i];
            while(c.charAt(0) === " ")c = c.substring(1, c.length);
            if (c.indexOf(nameEQ) === 0) return c.substring(nameEQ.length, c.length);
        }
        return null;
    },
    remove: function remove(name) {
        this.create(name, "", -1);
    }
};
var $60196a4650e96cb1$var$cookie$1 = {
    name: "cookie",
    lookup: function lookup(options) {
        var found;
        if (options.lookupCookie && typeof document !== "undefined") {
            var c = $60196a4650e96cb1$var$cookie.read(options.lookupCookie);
            if (c) found = c;
        }
        return found;
    },
    cacheUserLanguage: function cacheUserLanguage(lng, options) {
        if (options.lookupCookie && typeof document !== "undefined") $60196a4650e96cb1$var$cookie.create(options.lookupCookie, lng, options.cookieMinutes, options.cookieDomain, options.cookieOptions);
    }
};
var $60196a4650e96cb1$var$querystring = {
    name: "querystring",
    lookup: function lookup(options) {
        var found;
        if (typeof window !== "undefined") {
            var search = window.location.search;
            if (!window.location.search && window.location.hash && window.location.hash.indexOf("?") > -1) search = window.location.hash.substring(window.location.hash.indexOf("?"));
            var query = search.substring(1);
            var params = query.split("&");
            for(var i = 0; i < params.length; i++){
                var pos = params[i].indexOf("=");
                if (pos > 0) {
                    var key = params[i].substring(0, pos);
                    if (key === options.lookupQuerystring) found = params[i].substring(pos + 1);
                }
            }
        }
        return found;
    }
};
var $60196a4650e96cb1$var$hasLocalStorageSupport = null;
var $60196a4650e96cb1$var$localStorageAvailable = function localStorageAvailable() {
    if ($60196a4650e96cb1$var$hasLocalStorageSupport !== null) return $60196a4650e96cb1$var$hasLocalStorageSupport;
    try {
        $60196a4650e96cb1$var$hasLocalStorageSupport = window !== "undefined" && window.localStorage !== null;
        var testKey = "i18next.translate.boo";
        window.localStorage.setItem(testKey, "foo");
        window.localStorage.removeItem(testKey);
    } catch (e) {
        $60196a4650e96cb1$var$hasLocalStorageSupport = false;
    }
    return $60196a4650e96cb1$var$hasLocalStorageSupport;
};
var $60196a4650e96cb1$var$localStorage = {
    name: "localStorage",
    lookup: function lookup(options) {
        var found;
        if (options.lookupLocalStorage && $60196a4650e96cb1$var$localStorageAvailable()) {
            var lng = window.localStorage.getItem(options.lookupLocalStorage);
            if (lng) found = lng;
        }
        return found;
    },
    cacheUserLanguage: function cacheUserLanguage(lng, options) {
        if (options.lookupLocalStorage && $60196a4650e96cb1$var$localStorageAvailable()) window.localStorage.setItem(options.lookupLocalStorage, lng);
    }
};
var $60196a4650e96cb1$var$hasSessionStorageSupport = null;
var $60196a4650e96cb1$var$sessionStorageAvailable = function sessionStorageAvailable() {
    if ($60196a4650e96cb1$var$hasSessionStorageSupport !== null) return $60196a4650e96cb1$var$hasSessionStorageSupport;
    try {
        $60196a4650e96cb1$var$hasSessionStorageSupport = window !== "undefined" && window.sessionStorage !== null;
        var testKey = "i18next.translate.boo";
        window.sessionStorage.setItem(testKey, "foo");
        window.sessionStorage.removeItem(testKey);
    } catch (e) {
        $60196a4650e96cb1$var$hasSessionStorageSupport = false;
    }
    return $60196a4650e96cb1$var$hasSessionStorageSupport;
};
var $60196a4650e96cb1$var$sessionStorage = {
    name: "sessionStorage",
    lookup: function lookup(options) {
        var found;
        if (options.lookupSessionStorage && $60196a4650e96cb1$var$sessionStorageAvailable()) {
            var lng = window.sessionStorage.getItem(options.lookupSessionStorage);
            if (lng) found = lng;
        }
        return found;
    },
    cacheUserLanguage: function cacheUserLanguage(lng, options) {
        if (options.lookupSessionStorage && $60196a4650e96cb1$var$sessionStorageAvailable()) window.sessionStorage.setItem(options.lookupSessionStorage, lng);
    }
};
var $60196a4650e96cb1$var$navigator$1 = {
    name: "navigator",
    lookup: function lookup(options) {
        var found = [];
        if (typeof navigator !== "undefined") {
            if (navigator.languages) // chrome only; not an array, so can't use .push.apply instead of iterating
            for(var i = 0; i < navigator.languages.length; i++)found.push(navigator.languages[i]);
            if (navigator.userLanguage) found.push(navigator.userLanguage);
            if (navigator.language) found.push(navigator.language);
        }
        return found.length > 0 ? found : undefined;
    }
};
var $60196a4650e96cb1$var$htmlTag = {
    name: "htmlTag",
    lookup: function lookup(options) {
        var found;
        var htmlTag = options.htmlTag || (typeof document !== "undefined" ? document.documentElement : null);
        if (htmlTag && typeof htmlTag.getAttribute === "function") found = htmlTag.getAttribute("lang");
        return found;
    }
};
var $60196a4650e96cb1$var$path = {
    name: "path",
    lookup: function lookup(options) {
        var found;
        if (typeof window !== "undefined") {
            var language = window.location.pathname.match(/\/([a-zA-Z-]*)/g);
            if (language instanceof Array) {
                if (typeof options.lookupFromPathIndex === "number") {
                    if (typeof language[options.lookupFromPathIndex] !== "string") return undefined;
                    found = language[options.lookupFromPathIndex].replace("/", "");
                } else found = language[0].replace("/", "");
            }
        }
        return found;
    }
};
var $60196a4650e96cb1$var$subdomain = {
    name: "subdomain",
    lookup: function lookup(options) {
        // If given get the subdomain index else 1
        var lookupFromSubdomainIndex = typeof options.lookupFromSubdomainIndex === "number" ? options.lookupFromSubdomainIndex + 1 : 1;
        // get all matches if window.location. is existing
        // first item of match is the match itself and the second is the first group macht which sould be the first subdomain match
        // is the hostname no public domain get the or option of localhost
        var language = typeof window !== "undefined" && window.location && window.location.hostname && window.location.hostname.match(/^(\w{2,5})\.(([a-z0-9-]{1,63}\.[a-z]{2,6})|localhost)/i);
        // if there is no match (null) return undefined
        if (!language) return undefined;
        // return the given group match
        return language[lookupFromSubdomainIndex];
    }
};
function $60196a4650e96cb1$var$getDefaults() {
    return {
        order: [
            "querystring",
            "cookie",
            "localStorage",
            "sessionStorage",
            "navigator",
            "htmlTag"
        ],
        lookupQuerystring: "lng",
        lookupCookie: "i18next",
        lookupLocalStorage: "i18nextLng",
        lookupSessionStorage: "i18nextLng",
        // cache user language
        caches: [
            "localStorage"
        ],
        excludeCacheFor: [
            "cimode"
        ],
        // cookieMinutes: 10,
        // cookieDomain: 'myDomain'
        convertDetectedLanguage: function convertDetectedLanguage(l) {
            return l;
        }
    };
}
var $60196a4650e96cb1$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    function Browser(services) {
        var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        (0, $4d35ca0862055760$export$2e2bcd8739ae039)(this, Browser);
        this.type = "languageDetector";
        this.detectors = {};
        this.init(services, options);
    }
    (0, $94019358ecbcf36b$export$2e2bcd8739ae039)(Browser, [
        {
            key: "init",
            value: function init(services) {
                var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                var i18nOptions = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
                this.services = services || {
                    languageUtils: {}
                }; // this way the language detector can be used without i18next
                this.options = $60196a4650e96cb1$var$defaults(options, this.options || {}, $60196a4650e96cb1$var$getDefaults());
                if (typeof this.options.convertDetectedLanguage === "string" && this.options.convertDetectedLanguage.indexOf("15897") > -1) this.options.convertDetectedLanguage = function(l) {
                    return l.replace("-", "_");
                };
                // backwards compatibility
                if (this.options.lookupFromUrlIndex) this.options.lookupFromPathIndex = this.options.lookupFromUrlIndex;
                this.i18nOptions = i18nOptions;
                this.addDetector($60196a4650e96cb1$var$cookie$1);
                this.addDetector($60196a4650e96cb1$var$querystring);
                this.addDetector($60196a4650e96cb1$var$localStorage);
                this.addDetector($60196a4650e96cb1$var$sessionStorage);
                this.addDetector($60196a4650e96cb1$var$navigator$1);
                this.addDetector($60196a4650e96cb1$var$htmlTag);
                this.addDetector($60196a4650e96cb1$var$path);
                this.addDetector($60196a4650e96cb1$var$subdomain);
            }
        },
        {
            key: "addDetector",
            value: function addDetector(detector) {
                this.detectors[detector.name] = detector;
            }
        },
        {
            key: "detect",
            value: function detect(detectionOrder) {
                var _this = this;
                if (!detectionOrder) detectionOrder = this.options.order;
                var detected = [];
                detectionOrder.forEach(function(detectorName) {
                    if (_this.detectors[detectorName]) {
                        var lookup = _this.detectors[detectorName].lookup(_this.options);
                        if (lookup && typeof lookup === "string") lookup = [
                            lookup
                        ];
                        if (lookup) detected = detected.concat(lookup);
                    }
                });
                detected = detected.map(function(d) {
                    return _this.options.convertDetectedLanguage(d);
                });
                if (this.services.languageUtils.getBestMatchFromCodes) return detected; // new i18next v19.5.0
                return detected.length > 0 ? detected[0] : null; // a little backward compatibility
            }
        },
        {
            key: "cacheUserLanguage",
            value: function cacheUserLanguage(lng, caches) {
                var _this2 = this;
                if (!caches) caches = this.options.caches;
                if (!caches) return;
                if (this.options.excludeCacheFor && this.options.excludeCacheFor.indexOf(lng) > -1) return;
                caches.forEach(function(cacheName) {
                    if (_this2.detectors[cacheName]) _this2.detectors[cacheName].cacheUserLanguage(lng, _this2.options);
                });
            }
        }
    ]);
    return Browser;
}();
$60196a4650e96cb1$export$2e2bcd8739ae039.type = "languageDetector";



var $0c3ba772772ffc54$exports = {};
$0c3ba772772ffc54$exports = JSON.parse('{"common":{"ogram":"Ogram","start_now":"Start Now","dismiss":"Dismiss","continue":"Continue","text_copied":"Text copied to clipboard","tc":"Terms and Conditions","shifts":"shifts","show_more":"Show More","ogs":"OGs","i_accept_terms":"I accept the <1>Terms of Service</1>","i_accept":"I accept the","terms_of_service":"Terms of Service","yes":"Yes","no":"No","id_n":"ID#{{id}}","loading":"Loading...","app_version":"App Version: {{version}}","select":"Select","job_n":"Job #{{id}}","filters":"Filters","filter":"Filter","location":"Location","designation":"Designation","change":"Change","cancel":"Cancel","order_id":"Order ID","is_overdue":"Is Overdue","date_from":"Date From","date_to":"Date To","now":"Now","no_data_found":"No Data Found","not_available":"Not Available","clear":"Clear","done":"Done","optional":"Optional","industry":"Industry","employees_amount_tier":"How many employees does your company have?","n_selected":"{{count}} Selected","ended_at":"Ended at {{date}}"},"password":{"minimumChars":"+6 characters","oneLowercase":"1 lowercase letter","oneNumber":"1 Number","oneUppercase":"1 uppercase letter"},"login":{"good_to_see_you_back":"Good to see you back","sign_in_to_account":"Please sign in to your account","enter_email":"please enter your email","enter_password":"please enter your password","email":"Email","password":"Password","remember_me":"Remember Me","forgot_password_question":"Forgot password?","sign_in":"Sign In","signin_in":"Signing in...","sign_up_link_text":"Sign Up","test_string":"Testing the system"},"create_password":{"title":"Create a password","description":"Please create a password to be able to login using your email next time","please_enter_password":"Please enter your password","please_confirm_password":"Please confirm your password","confirm_password":"Confirm Password","password":"Password","password_matched":"Password Matched","password_not_matched":"Password Not Matched","resend_modal_button":"Resend Email","sending":"Sending...","email_invalid":"Your email is invalid","email_required":"Please provide your email","email":"Email","email_is_sent":"New link has been sent to your email address.","submit":"Submit"},"forgot_password":{"title":"Forgot password?","description":"Enter the email address associated with your account","please_enter_email":"please enter your email","email_must_be_valid":"Email must be valid","email":"Email","submit":"Submit","back_to_sign_in":"Back to Sign in","forgot_password":"Forgot Password","password_sent_to_email":"New password is sent to email.","resend":"Resend","reset_password":"Reset Password","email_sent":"A password reset link has been sent to your email account"},"validation_messages":{"email_invalid":"Your email is invalid"},"reset_password":{"title":"Reset Password","description":"Enter new password","please_enter_password":"Please enter new password","please_confirm_password":"Please confirm password","password":"Password","confirm_password":"Confirm Password","password_mathched":"Password Matched","password_not_matched":"Password Not Matched","submit":"Submit"},"change_password":{"title":"Change Password","description":"Enter old and new password","please_enter_old_password":"Please enter old password","please_enter_password":"Please enter new password","please_confirm_password":"Please confirm new password","old_password":"Old Password","new_password":"New Password","confirm_new_password":"Confirm New Password","password_matched":"Password Matched","password_not_matched":"Password Not Matched","submit":"Submit","password_changed_successfully":"Your password has been changed successfully"},"sign_up":{"title":"Client Registration","subtitle":"Please register to be able to create and control your orders","sign_up":"Sign Up","first_name":"First Name","last_name":"Last Name","phone":"Phone","email":"Email","password":"Password","city":"City","company_name_optional":"Company Name (Required for Companies)","company_name":"Company Name","agree_to_emails":"I agree to receive marketing notifications from Ogram","are_you_corporate_question":"Are you a corporate?","back_to_sign_in":"Back to Sign in","first_name_required":"Please enter your first name","last_name_required":"Please enter your last name","industry_required":"Please select your industry","employees_amount_tier_required":"Please select amount of employees","phone_required":"Please enter your phone","email_required":"Please enter your email","company_name_required":"Company name is required for corporate users","city_required":"Please enter your city","submitting":"Submitting...","choose_work_category_title":"What Staff do you need?","choose_work_category_subtitle":"Tell us about the first job","create_new_order_title":"Start Hiring","contact_details_title":"What is your contact details?","contact_details_subtitle":"Add your contact details so we can be able to reach you","how_to_reach_title":"How can we reach you?","next":"Next","phone_invalid":"Please type valid phone","already_registered":"Already have an account?","sign_in":"Sign in","consent":"By clicking the \\"Sign Up\\" button, you grant permission for our company to use your personal information for account creation and order processing.","thank_you":"Thank you!"},"verify_email":{"title":"Verify your email address","description":"Verification code has been sent to your email","we_sent_code_to_email":"We sent code to {{email}}. Please check your inbox and enter the verification code below the finish setting up your account.","please_enter_code":"please enter the code","verification_code":"Verification code","verify":"Verify","did_not_receive_email_question":"Didn\'t receive the email? Resend code in 3:00 minutes","not_your_email_question":"Not your email?","change_email":"Change email"},"applicant_details":{"n_shifts_completed":"{{count}} shifts completed","years_of_experience":"{{count}} Yrs","information":"Information","work_experience":"Work Experience","education":"Education","get_next_applicant":"get next applicant","in":"in","chief_og":"Chief OG","skills":"Skills","added_as_favourite":"{{spName}} is now on our preferred list. We\'ll prioritize {{spName}} in our algorithms.","chief":"<1>Chief OG\'s </1><2>are experienced team leaders, hand picked to better coordinate Ogram teams on the ground.</2>","interview":"Interview","view_answer":"View Answer","job_history_with_you":"Job History with You","work_category_experience":"{{ workCategoryName }} Experience","other_experience":"Other Experience"},"sp_rating":{"novice":"Novice","advanced_beginner":"Advanced Beginner","competent":"Competent","proficient":"Proficient","expert":"Expert"},"applicants_review":{"title":"Applicants Review","no_applicants_to_reivew":"No Applicants To Review","percent_filled":"{{percent}}% Filled"},"job_cherry_picking":{"title":"Job Details","accepted":"Accepted","rejected":"Rejected","reject":"Reject","accept":"Accept","exp":"Exp","age":"Age","language":"Language","nationality":"Nationality","years_of_experience":"{{count}} Yrs","experience":"Experience","height":"Height","gender":"Gender","height_cm":"{{count}} cm","years_old":"{{count}} years","total_applicants":"Applicants ({{count}})","sort_by":"Sort by:","rating":"Rating","see_more":"see more","confirmation":"Confirmation","you_are_about_to_accept":"You are about to accept <1>{{name}}</1> for the job","you_are_about_to_reject":"You are about to reject <1>{{name}}</1> They will be removed from the list","confirm":"Confirm","cancel":"Cancel","jobID":"Job ID","designation":"Designation","location":"Location","required_quantity":"Required Quantity","fulfillment":"Fulfilment","fulfillmentRatio":"{{percent}}%","start_date":"Start Date","end_date":"End Date","seniority_level":"Seniority Level","congratulation_exclamation":"Congratulations!","you_have_assigned_staff":"You have assigned all required staff","done":"Done","skill_match":"Skill Match","chief_title":"We Have Something For You","chief_subtitle":"Add a Chief OG to your team - it\'s free!","chief_og":"Chief OG","what_is_chief":"What is a Chief OG?","chief_definition":"A Chief OG is a team leader, carefully selected by us to help manage larger Ogram teams. For example, by resolving disputes and coordinating team members - at no extra cost to you.\\nAnd all this is <1>completely free for you.</1>","chief_button_label":"Sounds good","time":"Time","applicant_assigned":"Applicant is assigned!","shortlisted":"Shortlisted"},"interview":{"applicants_finished":"No more answers to review","applicant_id":"ID#{{id}}","next_question":"Next Question","accept":"Accept","assigned":"Assigned","next_applicant":"Next applicant","question_short":"Q{{index}}:","rating_question_short":"Rating Q{{index}}:","recommended_to_hire":"Recommended to Hire","overall_rating":"Overall Rating","video_player_not_supported":"Your browser does not support video player, please try to update it or use another browser.","submitting_rating":"Submitting rating...","rating_applied":"Rating applied!"},"complete_registration":{"title":"Register a Corporate","legal_information":"Legal Information","field_required":"This Field is Required","yes":"yes","no":"no","company_name":"Company Name","trade_name_as_license":"Trade Name as per Trade License","trade_license_number":"Trade License Number","legal_address":"Legal Address","po_box":"PO Box","free_zone":"Free Zone","lpo_required":"LPO Required","region":"Region","vat_certificate":"VAT certificate","upload_vat":"Upload VAT certificate","i_agree_with_terms":"I agree to the <1>Privacy Policy</1>","i_agree_with_company_pp":"I agree to the <1>Privacy Policy for Companies</1>","i_agree_with_company_terms":"I agree to the <1>Terms and Conditions</1>","continue":"Continue","gr":{"company_name":"Company\'s name","address":"Address with Street - Number - City","tax_jurisdiction":"DOY (Tax Jurisdiction)","registry_number":"Company Registry Number","zip_code":"ZIP code","industry":"Industry","industry_retail":"Retails","industry_hotels":"Hotels","industry_brc":"Bar/Restaurant/Cafe"},"document_selected":"Document Selected","document_submitted":"Document Submitted"},"change_schedule_options":{"all_dates_from_date":"All Days From {{date}}","date_only":"{{date}} Only","every_day_from_date":"Every {{day}} from {{date}}","custom":"Custom"},"onboarding_complete":{"title":"Thank You!","description":"We\'ve received your company details.","done":"Done"},"sign_sla":{"title":"Sign SLA","i_agree":"I Agree"},"home":{"hello_name":"Hello, <1>{{name}}</1>","hello":"Hello","shifts_attendance_review":"Shifts attendance review","orders_to_confirm":"Orders to confirm","rating_requests":"Rating requests","applicant_review":"Applicant review","pending_payments":"Pending Payments","error_failed_to_load_statistics":"Failed to load statistics","error_failed_to_load_home_page":"Failed to load home page","coming_soon":{"hello":"Hello","we_are_coming_soon":"We Are Coming Soon","prepare_for_launch":"Hello! We are preparing for our big launch.","on_demand_staff":"On-Demand Staff","find_workers":"Find and manage high-quality workers on one simple, centralized platform.","short_term_contracts":"Short-Term Contracts","post_jobs":"Post temporary or long-term jobs and fill your next shift within 48 hours of signing up.","incredible_savings":"Incredible Savings","save_money":"Pay only for delivered work hours"}},"interview_popup":{"title":"Video Interview","description":"Incorporate video interviewing into your recruitment efforts to save your team hours and quicker moving.","create_order_button":"Create Order"},"sidebar":{"company":"Company","error_failed_to_load_sidebar":"Failed to load sidebar. Please try again","create_order":"Create Order","register_corporate":"Register a Corporate","account":"ACCOUNT","manage_locations":"Manage Locations","users":"Users","knowledge_center":"Knowledge Centre","home":"Home","all_jobs":"All Jobs","attendance_review":"Attendance Review","orders":"Orders","applicants_review":"Applicants Review","rating_requests":"Rating requests","invoices":"Invoices","payments":"Payments","payment_methods":"Payment Methods","billing":"BILLING","orders_uppercase":"ORDERS","disputes":"Disputes"},"all_jobs":{"title":"Calendar","day":"Day","3_days":"3 Day","week":"Week","month":"Month","percent_filled":"{{count}}% Filled","start":"Start","end":"End","manage_shift":"Manage shift","unsaved_changes":"You have unsaved changes. Are you sure you want to leave this page?","shift_canceled":"Shift has been cancelled","og_checked_in":"The ogrammer has been checked in","og_checked_out":"The ogrammer has been checked out","assigned_to":"Assigned to","no_zero":"","no_one":"","no_two":"","no_few":"","no_many":"","no_other":"","empty_slot":"{{count}} empty slots","select_OG":"Select OG","cancel":"Cancel","save_changes_count":"Save Changes ({{count}})","update_success":"Successfully updated","accepted":"Accepted","canceled":"Canceled","completed":"Completed","irrelevant":"Irrelevant","pending":"Pending","started":"Started","extension_announcement":"You can now extend orders directly from this page. Click the three dots next to the order and select \\"Extend Order.\\"","current_week":"Go to current week","filter_location":"Filter Location","filter_designation":"Filter Designation","sps_required":"{{amount}} OGs required","bulk_apply":"Bulk Apply","apply_to_sp_only":"Apply to {{spName}} only","select_ogs_to_apply":"Select OGs to apply changes","copy_changes_to_more_ogs_on":"Copy changes to more OGs on"},"job_shifts":{"title":"Job Shifts","change_schedule":"Change schedule","cancel_shift":"Cancel Shift","confirmation_question":"You are about to cancel the job for all Ogrammers, are you sure of that?","i_have_capacity":"I have capacity","select_reason":"Select A Reason","other":"Other","comment_here":"Comment here (Optional)","cancel_job":"Cancel Job","cancel":"Cancel","set_start_time":"please set start time","set_end_time":"please set end time","start_time":"Start Time","end_time":"End Time","apply_schedule":"Apply Schedule","apply_on_days":"Apply on selected days from {{date}}","confirm":"Confirm","pending":"Pending","started":"Started","check_in":"Check in","check_out":"Check out","extend_shift":"Extend Shift","call":"Call","whatsapp":"WhatsApp","remove_from_favourites":"Remove from favourites","add_to_favourites":"Add to favourites","extra_time":"Extra Time","percent_filled":"{{percent}}% Filled","for_the_job":"for the job","cancel_all_following_shifts":"Cancel all following shifts","block_ogrammer":"Block Ogrammer"},"location_list":{"title":"Locations","add_location":"Add Location","location_required":"Location name is required","address_required":"Address is required","address_details_required":"Additional address details is required","region_required":"Region is required","location_name":"Location name","region":"Region","location_address":"Location address","address_details":"Additional address details","upload_location_image":"Upload the location image (Optional)","save":"Save","delete":"Delete","check_in_restrictions_title":"Check-In Restrictions","large_area":"Mall or a Large community","no_restrictions":"Disable geolocation restriction","additional_details":"Additional Details","restrictions_info_modal_text":"Please turn on \u201C<strong>Mall or a Large community</strong>\u201D option if the staff is required to work at the Large area. We\'ll adjust the radius of check-in and check-out zone.<br/><br/>\u201C<strong>Disable geolocation restriction</strong>\u201D option will remove geo-restrictions in case of remote work or if the job will take place across several locations.","you_have_n_locations":"You have {{locationsCount}} locations"},"add_location":{"title":"Add Location"},"edit_location":{"title":"Edit Location"},"orders_list":{"title":"Orders","empty_list_title":"Start Hiring Today!","empty_list_description":"Looking for part-time staff?\\nLet us know your work requirements.","create_order":"Create Order","tab_title_pending":"Pending","tab_title_active":"Active","tab_title_completed":"Completed"},"order":{"order_number":"Order #{{id}}","order_summary":"Order Summary","jobs":"Jobs","cost":"Cost","i_accept_terms":"I accept the <1>Terms of Service</1>","confirm":"Confirm","order_confirmed":"Order Confirmed","thank_you_for_confirming_order":"Thank you for confirming the order.","done":"Done","payment_terms":"Payment terms","complete_company_details":"Complete company details to change payment terms","change_terms":"Change Terms","location":"Location","end_date":"End date","start_date":"Start date","subtotal":"Subtotal","transportations":"Transportations","vat_percent":"VAT ({{count}}%)","estimated_total":"Estimated total","dates":"Dates","days_count":"({{count}} day)","hours":"Hours","hours_amount":"{{hours}} hour","hours_per_day":"({{hoursPerDay}} h/day)","rate":"Rate","hour_rate":"{{currency}} {{hourRate}}/h","transportation_cost":"{{currency}} {{cost}}/day","category_schedule":"{{category}} Schedule","order_summary_days_count":"({{count}} days)","hello_name":"Hello, <1>{{name}}</1>","confirm_order":"We have received new order request from you. In order to proceed, please review and confirm the details below.","pending_rates_review":"Your order request is under review. We will notify you once the rates are assigned.","send_for_review":"Send For Review","under_review":"Under Review","final_amount_will_be_based":"*Final Total amount will be based on the actual attendance","amend_order":"Amend Order","i_accept":"I accept the","terms_of_service":"Terms of Service","select_amend_reason":"Select Amendment Reason","select_reason":"Select reason","submitting":"Submitting...","continue":"Continue","cancel":"Cancel","quotation_download_title":"Download quotation","quotation_download_action_text":"Download","quotation_download_in_progress_text":"Downloading...","lpo_upload_title":"Upload  your signed LPO","lpo_upload_action_text":"Upload","lpo_upload_in_progress_text":"Uploading...","lpo_upload_success_message":"LPO was successfully uploaded","menu_download_quote":"Download a quote","menu_upload_lpo":"Upload LPO","lpo_download_title":"Download LPO","lpo_download_in_progress_text":"Downloading...","menu_duplicate_order":"Duplicate order","draft_order_title":"Draft Order","job_to_duplicate":"Job to duplicate","need_to_review_corporate_details":"We have received new order request from you. In order to proceed, please review and complete company details","corporate_details_are_being_reviewed":"We are reviewing your company details which you sent us","complete_company_details_link":"Complete company details","duplicate_order":"Duplicate order","days":"Days","to_end":"to End","suggest_extension":"Thank you for choosing our services. Extend your order for additional services or products.","extend_your_order":"Extend your order"},"job_draft_category":{"title":"Create New Order","tell_about_job":"Tell us about the job","tell_about_first_job":"Tell us about the first job","find_staff":"Find vetted staff for your every need"},"job_draft_price":{"title":"Set the Hourly Rates","subtitle":"Attract best workers with competitive rates","low_rate_og_message":"\u26A0\uFE0F Significantly below market standard","low_rate_fill_message":"\uD83D\uDC22 High risk of low fill rate","middle_rate_og_message":"\uD83D\uDC65 Workers from certain countries may have limited availability due to market conditions","middle_rate_fill_message":"\u23F3 Moderate fill rate","good_rate_og_message":"\uD83C\uDF1F Competitive hourly rate","good_rate_fill_message":"\uD83D\uDE80 Good fill rate","money_amount":"{{currency}} {{amount}}","rate_is_less_than_min":"Rate is less than minimal allowed of {{min}}","input_label":"Hour Rate, {{currency}}","decrease_rate":"decrease rate","increase_rate":"increase rate","short_explanation":"The recommended rate is dynamically calculated based on demand, timing, and job specifics, and already includes our commission","estimated_total":"Estimated total*","includes_vat":"*Includes {{vat}}% VAT"},"job_draft_details":{"title":"{{category}} Job","fill_job_details":"Please fill the job details","staff":"Staff","quantity":"Quantity","location":"Location","start_date":"Start date","end_date":"End date","days":"Days","start_time":"Start time","end_time":"End time","requirements":"Specialization [Optional]","job_description":"Job Description","experience":"Experience","dresscode":"Dresscode","additional_preferences":"Additional preferences [Optional]","languages":"Languages","gender":"Gender","additional_documents":"Additional Documents","video_interview":"Video Interview","manual_selection":"Manual Staff Selection","accreditation":"Accreditation Required","submitting":"Submitting...","save":"Submit","finish":"Finish","next":"Next","create_duplicate":"Save","step_n_of_m_steps":"{{objectNameLabel}} {{index}} of {{count}}","work_category_required":"Please choose work category","quantity_required":"Please set how many staff you need","location_required":"Please set the location","schedule_type_required":"Please select your schedule type","same_time_prompt_required":"Please tell us if all days have the same start/end time","start_date_required":"Please set the start date","end_date_required":"Please set the end date or make the job open ended","end_date_cannot_be_before_start_date":"End date cannot be before start date","start_time_required":"Please set the start time","end_time_required":"Please set the end time","select_one_date_at_least":"Please select at least one day","fill_all_selected_dates":"Please fill in all inputs for selected dates","job_cant_start_early":"Job cannot start earlier than in 24 hours","must_include_day_of_start_date":"Day of start date must be included","must_include_day_of_end_date":"Day of end date must be included","description_required":"Please set the description","description_too_long":"Description is too long, please make it shorter","experience_required":"Please choose seniority level","dresscode_required":"Please choose dresscode","languages_required":"Select languages or remove the filter","documents_required":"Select documents or remove the filter","interview_required":"Select questions or remove the filter","manual_selection_required":"Select manual selection option or remove the filter","accreditation_required":"Select accreditation option or remove the filter","staff_amount_title":"How many staff do you need?","staff_amount_subtitle":"Select the quantity you need or just type it","location_title":"Where do you need the staff?","location_subtitle":"Select the location or venue where you need staff.","location_add_new":"Add New Location","location_add":"Add Location","dates_title":"When are the staff needed?","dates_subtitle":"Select the date/dates when you need them.","dates_open_ended":"Open-ended (no end date)","schedule_title":"Will they work the same days every week?","schedule_subtitle":"For example, Monday to Friday every week.","schedule_i_have_same_weekly":"I have the same shedule every week","schedule_schedule_weekly":"Schedule on a Weekly basis","schedule_i_need_schedule_daily":"I need to shedule on a daily basis","schedule_schedule_daily":"Schedule on a Daily basis","time_title":"What is the hourly schedule for the job?","time_subtitle":"Select which days you want staff to work","time_select_dates_schedule":"Please, select dates and schedule type first","time_days_selected":"{{count}} days selected","time_dates_selected":"{{count}} dates selected","requirements_title":"Do the workers need a specific specialization?","requirements_subtitle":"Select the specialization that best matches your requirements.","requirements_add_new":"Add New Requirement","requirements_create":"Create Work Requirement","requirement_requirement":"Requirement","requirement_add_requirement":"Add Requirement","description_title":"What will they do?","description_subtitle":"Add a job description for the staff (Describe the duties and responsibilities expected of the staff)","description_placeholder":"Describe job details","experience_title":"How experienced do you need the staff to be?","experience_subtitle":"Select the level of experience you want the staff to have","experience_student":"Student","experience_beginner":"Beginner","experience_junior":"Junior","experience_middle":"Mid-Senior","experience_senior":"Senior","experience_hint":"*The higher the seniority of the staff, the higher the hourly rates.","experience_years":"years","uniform_title":"Do you have a dresscode preference?","uniform_subtitle":"Tell us if you need formal or casual attire","uniform_dresscode":"Dresscode","preferences_title":"Do you have any additional preferences?","preferences_subtitle":"Decide on your additional preferences.","preferences_languages":"Language","preferences_gender":"Gender","preferences_documents":"Additional Documents","preferences_interview":"Video Interview","nationalities":"Nationality","nationalities_title":"What are your preferred nationalities?","nationalities_subtitle":"Select specific nationalities that align with your hiring needs","nationalities_option_any":"Hire the best talent, regardless of nationality","preferences_manual_staff_selection":"Manual Staff Selection","preferences_accreditation_required":"Accreditation Required","preferences_accommodation_offered":"Accommodation offered","accommodation_required":"Accommodation Required","accommodation_yes":"Yes","accommodation_no":"No","boarding_required":"Boarding Required","transport_accessibility_required":"Transport Accessibility required","preferences_boarding_offered":"Boarding offered","accommodation_title":"Do you offer boarding for this role?","do_you_offer_accommodation":"Do you offer accommodation for this role?","no_boarding":"No boarding offered","half_boarding":"Half-board","full_boarding":"Full-board","languages_title":"What\'s your preference for language?","languages_subtitle":"Pick specific languages the staff should speak","gender_title":"What\'s your preference for gender?","gender_subtitle":"Please select gender preference, if any","gender_male":"Male","gender_female":"Female","gender_no_preference":"No","documents_title":"What are your additional documentary requirements?","documents_subtitle":"Select required additonal document types","manual_selectinon_title":"Would you like us to auto-select the best Ogrammers for the job?","manual_selectinon_subtitle":"If you choose \\"No\\", you will have to manually select Ogrammers and will not benefit from our Smart Staff Selection algorithm","manual_selectinon_yes":"Yes","manual_selectinon_no":"No","accreditation_title":"Do the staff require accreditation to enter the venue or event?","accreditation_subtitle":"Please note that accreditation will affect our fulfilment time","accreditation_yes":"Yes","accreditation_no":"No","poc_title":"Who will be handling the attendance?","poc_subtitle":"Select a person will be the main point of contact for the job","point_of_contact":"Point of contact","add_poc":"Add new POC","select_location_first":"Please, select job\'s location first","poc_required":"Please select contact","start_date_must_be_at_least_today":"Start date must start at least today","end_date_must_be_at_least_today":"End date must start at least today","greece_launch_info":"Please note that orders can only be placed starting from June 1st. We process your orders within 72 hours. Any orders submitted before this date will not be processed. Thank you for your understanding","select_document":"Select Document","junior":"Junior","midSenior":"Mid-Senior","senior":"Senior","student":"Student","beginner":"Beginner","interview_title":"What are the key topics you would like to cover with the applicants?","interview_subtitle":"OG will submit video recordings of their question answers","interview_new_question":"Add New Question?","interview_question_form_title":"Add New Question","interview_question_form_placeholder":"Type description here","interview_question_form_submit":"Submit","interview_question_created":"Question has been created!","start_and_end_date_must_be_selected":"Start date {{startDate}} and End date {{endDate}} must be selected","what_are_the_shifts_timings":"Tell us about the time schedule for this job:","what_are_job_timings":"What are the job timings?","select_same_time":"Select which time you want staff to work every day","start_and_ends_are_same":"Shifts will Start and End at the same time every day","time_vary":"Shift times vary day to day","less_than_24h_warning":"The job starts in less than 24 hours and we may not have enough time to fulfill it.","job_was_prefilled":"The form was pre-filled based on the last job data","invited_quantity_more_than_required_quantity":"You have selected more OGs than required in the job. In this case, the first who accepts will be assigned to the job"},"order_requested":{"title":"Thank you!","subtitle":"Our team has received your order and we will get back to you soon!","done":"Done","complete_registration":"Complete Registration","later":"Later"},"order_draft":{"title":"Create New Order","jobs":"Jobs","confirm_delete_job":"Are you sure you want to delete {{name}} job?","add_another_job":"+ Add Another Job","add_another_job_with_plus":"Add Another Job","add_first_job":"Add First Job","continue":"Continue","quantity":"Quantity","days":"Days","days_amount":"{{count}} day","location":"Location","what_to_copy":"Which preferences of the {{category}} job would you like to copy?","select_preferences":"Please select preferrences which need to be copied","schedule":"Schedule","requirements":"Requirements","job_description":"Job Description","seniority_level":"Seniority Level","dresscode":"Dresscode","language":"Language","gender":"Gender","documents":"Additional Documents","manual_selection":"Manual Staff Selection","accreditation_requried":"Accreditation Required","accommodation_offered":"Accommodation offered","interview_required":"Video Interview","boarding_offered":"Boarding offered","duplicate_job":"Duplicate Job","blank_job":"Blank Job","workers":"workers","jobs_count":"{{count}} Job(s)","public_transport_accessibility":"Public Transport Accessibility","public_transport_accessibility_accessible":"Yes, it\'s near a bus / metro stop","public_transport_accessibility_not_accessible":"No, it\'s not easily accessible by public transport","is_location_accessible_by_transport":"Is this location accessible by public transport?","tell_if_location_is_reachable":"Tell us if your location can be reached by bus or metro.","pricing":{"best_price_1":"Best price guarantee","best_price_2":"Our pricing model is dynamically structured, taking into account current market demand.","best_price_3":"This approach allows us to continually offer you the best value and services you\'ve come to expect from us. Reach out to us at any time for more information.","best_price_4":"Request a call from the sales team","estimated_total":"Estimated total*","type":"Type","hours":"Hours","hourly_rate":"Hourly rate"},"callback_request_sent":"Your request has been successfully sent","end_date":"End Date","start_date":"Start Date","updated":"Updated","n_hours":"{{hours}} hours","edit_job":"Edit Job"},"order_extension":{"how_to_extend":"How do you want to extend the dates for the jobs?","you_can_extend_order":"You have ability to extend dates for the jobs","same_extension_date":"New end date is same for all jobs","different_extension_dates":"Extend the jobs for different periods","for_how_long_extend":"For how long do you want to extend your jobs?","do_not_extend":"Don\'t Extend","select_date":"Select Date","select_start_date":"Select Start Date","select_end_date":"Select End Date","extend_order":"Extend order","schedule_description":"The extend days you need your staff to work","edit":"Edit","done":"Done","full_schedule":"Full Schedule","current_end_date":"Current End Date:","select_sps":"Select Ogrammers","select_sps_to_extend":"Select Ogrammers you want to extend"},"order_confirmed":{"title":"Order Confirmed","description":"Thank you for confirming the order.","done":"Done"},"attendance_manager_form":{"first_name":"First name","last_name":"Last name","phone":"Phone","email":"Email","job_role":"Job Role","save":"Save","edit_attendance_manager":"Edit Attendance Manager","add_attendance_manager":"Add Attendance Manager"},"attendance_manager_list":{"title":"Attendance Managers","add_manager":"Add Manager","edit":"Edit"},"company_form":{"title":"Company Details","saved":"Saved","company_name":"Company Name","company_name_as_in_license":"Company Name as mentioned in the Trade License","address":"Address","po_box":"POBox","vat_certificate":"Vat Certificate","trade_license":"Trade License","finance_first_name":"Finance First Name","finance_last_name":"Finance Last Name","finance_phone":"Finance Phone","finance_email":"Finance Email","extension":"Extension","save":"Save"},"invoice":{"invoice_#":"Invoice #{{index}}","export_pdf":"Export (PDF)","exporting":"Exporting...","report_issue":"Report an issue","details":"Details","invoice_number":"Invoice number","date":"Date","due_date":"Due Date","status":"Status","pending":"Pending","paid":"Paid","costs":"Costs","subtotal":"Subtotal","transportation":"Transportation","vat_percent":"VAT ({{count}}%)","total":"Total","breakdown":"Breakdown","pay_now":"Pay Now","total_shifts":"Total Shifts","total_hours":"Total Hours","total_ogs":"Total OG\'s","shifts":"Shifts","hours":"Hours","amount":"Amount","report_issue_modal_title":"Report an issue","report_issue_message_required":"Message is required","report_issue_message_placeholder":"Please describe your issue","report_issue_submit":"Submit","report_issue_cancel":"Cancel","issue_was_reported":"Your issue was reported","issue_is_submitting":"Loading..."},"invoice_card":{"invoice_#":"No #{{index}}","due_days_ago":"Due {{count}} days ago","due_today":"Due today","due_tomorrow":"Due tomorrow","due_days_ahead":"Due {{count}} days ahead"},"invoice_ogrammer":{"og_details":"OG details","job":"Job","location":"Location","shifts":"Shifts","hours":"Hours","amount_due":"Amount Due","shift_details":"Shifts details","day":"Day","approved_by":"Approved By"},"profile_form":{"title":"Edit Profile","first_name_required":"first name is required","last_name_required":"last name is required","phone_required":"phone is required","email_required":"email is required","upload_photo":"Upload Photo","private":"Private","corporate":"Corporate","register_corporate":"Register a Corporate","first_name":"First name","last_name":"Last Name","phone":"Phone","email":"Email","save":"Save","cancel":"Cancel","sign_out":"Sign out","agree_to_emails":"I agree to receive marketing notifications from Ogram"},"rating_request_list":{"title":"Rating Requests","empty_list":"No recent Ogrammers to rate"},"rating_request_panel":{"title":"Rating Requests","action":"Rate Now"},"job_rating":{"title":"Job Rating","how_was_experience_question":"How was your overall experience?","please_rate_team":"Please rate the entire team","tell_us_about_ogs":"Tell us more about Ogrammers","tell_us_which_stood_out":"Tell us which ones stood out, and which ones  can work on improvements","confirm":"Confirm","comment":"Comment","provide_overall_rating":"Please provide an overall rating","provide_og_rating":"Please provide rating for the ogrammer","provide_ogrammers_rating":"Please provide rating for ogrammers","thank_you_for_submitting":"Thank you for submitting the rating!","rate_workers":"Rate Your Recent Workers","importance_of_rating":"Your feedback helps us <strong>match you with top workers</strong> and supports Ogrammers in <strong>growing their careers</strong>. Take a moment to rate now!","rating_submitted":"Rating submitted. Thank you!"},"shifts_attendance_list":{"title":"Attendance Review","empty_list":"No pending attendance reports","review_now":"Review Now","all_designations":"All Designations"},"shifts_attendance_details":{"attended_question":"Attended?","attended":"Attended","not_attended":"Not Attended","did_not":"Didn\'t","confirm_amount":"Confirm ({{count}})"},"shift_attendance_common":{"are_you_sure_og_worked_n_hours":"Are you sure that {{name}} worked for {{hours}} hours? It\'s {{difference}} hours less than what was booked.","no_show":"No Show","limited_time_to_confirm":"Limited time to confirm","time_to_review_description":"Confirm Attendance as soon as possible to avoid incorrect billing","i_understand":"I Understand","n_minutes":"{{count}} minutes","n_hours":"{{hours}} hours","select_reason":"Select A Reason","update":"Update","cancel":"Cancel","hours_left":"{{count}} h Left","urgent":"Urgent","check_in":"Check-In","check_out":"Check-Out","update_hours":"Update {{count}} hours","add_hours":"Add {{count}} hours","attendance_confirmed":"Attendance Confirmed","thanks_for_confirming":"Thank you for confirming the attendance of Ogrammers.","done":"Done","day_off":"Day Off","total_hours":"Total Hours","shift_duration_too_long":"Shift duration shouldn\'t exceed 12 hours"},"user_management":{"users":"Users","add_new_user":"Add New User","invite_user":"Invite User","confirm_deletion_question":"Are you sure you want to delete this contact?","enter_first_name":"please enter first name","enter_last_name":"please enter last name","enter_phone":"please enter phone","enter_email":"please enter email","choose_role":"please choose a role","choose_location":"please choose a location","first_name":"First Name","last_name":"Last Name","phone":"Phone","email":"Email","invite_user_exclamation":"Invite User Now!","job_role":"Job role","location":"Location","save":"Save","delete":"Delete","cancel":"Cancel","you_have_n_users":"You have {{count}} users","add_user":"Add New User","or":"Or","invite_existing_user":"Invite an existing user","invitation_confirmed":"Invitation confirmed!","invitation_alert_text":"Invitation has been sent successfully. The user will be added to your company after accepting the invitation.","users_tab_active_users":"Users","users_tab_invitations":"Invitations","role_admin":"Admin","role_owner":"Owner","role_manager":"Manager","role_finance":"Finance"},"onboarding":{"knowledge_center":"Knowledge Centre","create_password":"Create Password","register_corporate":"Register a Corporate","click_here_to_close":"Click here to close"},"lead_widget":{"looking_for_staff":"Looking for \\npart-time staff?","hire_now":"Hire Now"},"uncompleted_actions_carousel":{"looking_for_staff":"Looking for part-time\\nstaff?","hire_now":"Hire Now","edit_company":"Provide company details to\\nunlock flexible payments","start_edit_company":"Start Now","add_poc":"Assign roles to your team\\nmembers","start_add_poc":"Start Now","dismiss_add_poc":"Dismiss","error_failed_to_load":"Failed to load carousel","connect":"Connect","connect_your_bank_account":"Connect your account with your bank","become_affiliate":"Invite your staff to join Ogram"},"not_authorized_error":{"title":"Access Denied","description":"You don\'t have permission to access the requested page...","sign_in":"Sign In","toast_title":"Your session has expired. Please log in again to continue."},"page_not_found":{"title":"Page Not Found!","description":"The page you are looking for doesn\'t seem to exist...","go_back":"Go Back"},"permission_error":{"title":"You don\'t have permission to view this page","back":"Back"},"too_many_attempts":{"title":"Too Many Attempts!","description":"Please try again a little bit later.","ok":"Ok"},"notifications":{"title":"Notifications","load_more":"Load more","no_more_notifications":"No more notifications","no_notifications_yet":"No notifications yet","error_failed_to_load_notifications":"Failed to load notifications. Please try again"},"home_onboarding":{"title":"Home","intro_title":"Welcome to Ogram!","intro_description":"The smart platform that businesses and individuals use to efficiently fulfill their part-time hiring needs.","intro_footer":"Whenever you use a feature for the first time, a similar message will pop up to guide you.","hire_title":"Hire part-time staff","hire":"The \u201CHire Now\u201D feature allows you to book part-time staff. This is how you tell us what, where, and when you need the staff.","attendance_title":"Attendance review counter","attendance":"This is where you review and sign off the digital attendance reports. The number in the box indicates the pending reports to review.","orders_title":"Orders confirmation counter","orders":"Whenever a staff-order requires manual pricing, we need your final confirmation before we can deploy the staff. Here\'s where you can access all pending orders.","ratings_title":"Rating requests counter","ratings":"Your feedback is very important to us and is leveraged by cutting-edge technology that continuously elevates the service. Here\'s where you can rate the service.","applicants_review_title":"Jobs applicant counter","applicants_review":"The platform selects and deploys staff automatically. You can also select the staff based on their experience. Here is where you review and select candidates.","outro":"Ready to get started?\\nYou can alway access the \u201CKnowledge Centre\u201D from the home screen menu or by clicking on \u201C?\u201D whenever you need guidance."},"all_jobs_onboarding":{"title":"All Jobs","jobs_list_title":"Jobs list","jobs_list":"\u201CAll Jobs\u201D is a list of your booked jobs split by days. By clicking on a job, you are able to see the list of assigned Ogrammers.","job_details_title":"Job details","job_details":"On a job page, you are able to clock in staff, extend or cancel shifts. Adding an Ogrammer to favourites ensures their preferred selection next time.","change_schedule_title":"Change schedule","change_schedule":"You are able to adjust your shifts schedule. Keeping the schedule up-to-date is very important, so Ogrammers can use their apps to clock in.","bulk_schedule_change_title":"Bulk schedule change","bulk_schedule_change":"The schedule may be changed for a selected day or for multiple days at a time. Please keep in mind that shift duration can\'t be reduced.","cancel_shift_title":"Cancel a shift","cancel_shift":"You can cancel an individual Ogrammer\'s shift; as well as block them from applying for all future shifts."},"attendance_review_onboarding":{"title":"Attendance Review","jobs_pending_review_title":"Jobs pending application","jobs_pending_review":"The \\"Attendance Review\\" section allows you to adjust and confirm Ogrammers\' attendances on a daily basis. You will be billed accordingly to the time logged.","attendance_details_title":"Attendance details","attendance_details":"A job page shows a list of assigned Ogrammers\' respective times logged. You can correct the time by clicking on it.","attendance_status_title":"Attendance status change","attendance_status":"You can also correct an Ogrammer\'s attendance status if they were mistakenly marked as having not attended.","attendance_time_title":"Attendance time change","attendance_time":"You will be prompted to enter the correct attendance timing, which will be set to the scheduled hours by default.","not_attended_reason_title":"Not attended reason change","not_attended_reason":"If an Ogrammer has not attended, you are also able to change the reason; either it was a Day Off or Sick Leave.","confirmation_time_title":"Confirmation of time","confirmation_time":"It\'s extremely important to confirm attendances regularly as they will be auto-confirmed within 72 hours. Failing to do so will see you billed accordingly."},"order_confirmation_onboarding":{"title":"Orders","pending_confirmation_title":"Orders pending confirmation","pending_confirmation":"The \\"Orders\\" section contains a list of your pre-booked orders that are pending your review and confirmation.","order_confirmation_title":"Order confirmation","order_confirmation":"On a pending confirmation Order page, please review the order details and final rates carefully. Staff will be deployed once the order has been confirmed.","order_amend_title":"Amend Order","order_amend":"If your requirements change or you have budget concerns, please feel free to amend the order."},"order_creation_onboarding":{"title":"Order Creation","select_designation_title":"Select designation","select_designation":"The order creation process starts with selecting a designation for the first job. Additional designations can be selected once the first job is created.","job_details_title":"Job details","job_details":"After selecting a designation, you can fill in the job details by starting with the quantity needed.","job_duration_title":"Job duration","job_duration":"If the job is recurring and has no specific end date, you can swipe the toggle which will remove the end date and keep the job open ended.","scheduling_options_title":"Scheduling options","scheduling_options":"If your job schedule repeats every week, choose the \'Weekly\' option and enter the timings for each day of the week. Otherwise, you can schedule on a daily basis","job_requirements_title":"Job requirements","job_requirements":"You can select requirements from a predefined list or add specific skills/duties required for the job.","shifts_breakdown_title":"Shifts breakdown","shifts_breakdown":"Once you specified the first job details a draft order has been created. You can add more jobs/designations to the order by pressing on \u201CAdd Another Job\u201D.","duplicate_job_title":"Duplicate job","duplicate_job":"If you want to create another job with the same or similar requirements, you can click on the job copy button. You will be able to specify which details to copy.","send_for_review_title":"Sending for review","send_for_review":"By pressing the \'Send for Review\' button, you will send the order to our sales team for review. We will price your order then notify you to get final confirmation."},"applicants_review_onboarding":{"title":"Applicants Review","pending_applicant_review_title":"Jobs pending applicants review","pending_applicant_review":"The \\"Applicants Review\\" section contains a list of jobs with applicants pending review. Once a job has been fulfilled it will disappear from the list.","applicant_list_title":"Job applicants list","applicant_list":"A Job page shows a list of Ogrammers who have applied. You can accept or reject them straight away or review their profile details further.","applicant_details_title":"Applicant details","applicant_details":"An Ogrammer\'s details page displays their Rating, Top Skills, Seniority Level, BIO, Work Experience and Education."},"locations_onboarding":{"title":"Locations","location_list_title":"Locations list","location_list":"The \\"Locations\\" section contains a list of your outlet\'s locations.","location_details_title":"Location details","location_details":"Please make sure that your location on the map is accurate. Ogrammers will not be able to check in outside of the selected point."},"users_onboarding":{"title":"Users","user_list_title":"Users list","user_list":"The \\"Users\\" section allows you to control who has access to your company. You can create new users or invite existing ones.","user_details_title":"User details","user_details":"You are able to assign one of the following roles: Admin, Attendance Manager, Finance. Roles can be limited by location."},"rating_requests_onboarding":{"title":"Rating Requests","pending_feedback_title":"Jobs pending feedback","pending_feedback":"The \\"Rating Requests\\" section contains a list of jobs requiring your feedback. After a job has been completed, we would like you to rate your experience.","rating_details_title":"Job rating details","rating_details":"You can rate your overall job experience, as well as rate individual Ogrammers. You are free to give compliments, highlight issues and leave comments."},"invoices_onboarding":{"title":"Invoices","invoice_list_title":"Invoices list","invoice_list":"\u201CInvoices\u201D contains a list of your current and past invoices. If any invoice is in a \u201CPending\u201D state it means that we are expecting a payment from you.","invoice_breakdown_title":"Invoice breakdown","invoice_breakdown":"An order page contains a summary plus a jobs breakdown. By expanding jobs, you will be able to find a shift\'s summary split by Ogrammers.","shifts_breakdown_title":"Invoice shifts breakdown","shifts_breakdown":"By clicking on an Ogrammer, you are able to see how many hours on each day this Ogrammer worked.","export_invoice_title":"Export invoice","export_invoice":"From the Invoice Menu, you can download a PDF breakdown of an invoice; as well as report any issues with an invoice."},"duplicate_order":{"choose_jobs_main_title":"First, select your desired jobs","choose_jobs_secondary_title":"choose and select the jobs that you need to extend","choose_jobs_confirm":"Confirm","duplicate_job_subtitle":"Please review the job details","duplicate_order":"Duplicate order"},"payment":{"payment":"Payment","card_payment":"Checkout","was_successful":"Thank you, your payment has been successful.","email_was_sent_to":"A confirmation email has sent to ","can_go_to_payments_list_page":"You can go to payments page and check its status there","transaction_id":"Transaction ID","date":"Date","payment_method":"Payment method","amount":"Amount","status":"Status","go_to_payments_list_page":"Go to Payments","status_unpaid":"Unpaid","status_processing":"Processing","status_paid":"Paid","status_cancelled":"Cancelled","status_refunded":"Refunded","payment_method_card_title":"Card","payment_method_card_wide_title":"Card payment","payment_method_card_description":"New Credit/Debit Card","payment_method_lean_description":"Instant Bank Transfer","processing_running":"Processing...","save_card_for_future":"Save this card for future transactions","all_transactions_are_secured":"All transactions are secure and encrypted","details":"Details","payment_number":"Payment number","due_date":"Due date","invoices":"Invoices","total_payment":"Total payment ","pay_now":"Pay Now","authorize":"Authorize Now","pending":"Pending","processing":"Processing","completed":"Completed","invoice":"Invoice","payment_details_title":"Payment #{{paymentId}}","payments":"Payments","payment_methods":"Payment methods","select_payment_method":"Select the payment method you want to use","continue":"Continue","pay":"Pay","payment_completed":"Payment completed","payment_processing":"Payment is processing","updating_status":"Updating status...","empty_pending_list":"No pending payments","empty_processing_list":"No processing payments","empty_completed_list":"No completed payments","back_to_order":"Back to order","overdue_balance":"Overdue balance","payment_method_wire_transfer_title":"Bank Transfer","payment_method_wire_transfer_description":"Bank Transfer","text_copied":"Text copied to clipboard","checkout":"Checkout","wire_transfer_details":"Wire transfer details","wire_transfer_amount":"Amount","wire_transfer_bank_account_name":"Account name","wire_transfer_bank_account_bank_name":"Bank name","wire_transfer_bank_account_number":"Account number","wire_transfer_bank_account_iban":"IBAN","wire_transfer_bank_account_bank_address":"Bank address","wire_transfer_upload_alert_text":"Please upload the copy of your bank proof of payment in receipt","next":"Next","wire_transfer_has_been_canceled":"Wire transfer has been canceled","wire_transfer_slip_was_uploaded":"The slip was uploaded","please_upload_slip":"Please upload Bank Slip","bank_slip_info_in_alert":"The bank slip must clearly show the payment amount and Bank stamp","payment_slip":"Payment slip","upload_payment_slip":"Upload Payment slip","document_selected":"Document Selected","you_can_upload_slip_now_or_later":"You can upload a slip now or later using button above. We\u2019ll remind you to upload a slip until you upload it.","you_can_select_another_payment_method":"If you wish to select another payment method, please cancel the Wire Transfer using this link.","wire_transfer_cancel_button":"Cancel Wire transfer and select another payment method","wire_transfer_remind_later_button":"Remind me later","wire_transfer_i_have_sent_money":"I\'ve sent money","wire_transfer_slip_uploading":"Loading...","wire_transfer_slip_under_review":"Slip is under review","wire_transfer_out_team_is_checking_slip":"Our team will check the slip soon.","download_slip":"Download Slip","card_payment_cancel_button":"Cancel Card payment and select another payment method","card_payment_has_been_canceled":"Card payment has been canceled","error_failed_to_load_panel":"Failed to load payment panel","add_account":"Add Account","learn_more_about":"Learn More About","lean_payment":"Lean Payment","lean_modal_title_1":"Why use Instant Bank Transfer?","lean_modal_title_2":"Move money instantly with the security of your bank","lean_modal_title_3":"This payment method allows you to initiate an instant bank transfer from your business banking account. You only need to connect your account once and then can use it for any future payments.","lean_modal_action_1":"Connect your bank account","lean_modal_action_2":"Pay instantly","lean_modal_title_4":"Your payments will always be secured by multi-factor authentication, the same way as if you\'d use your bank account.","payment_awaiting_authorization":"Payment is awaiting authorization","will_be_paid_after_authorize":"Your payout will be paid after you authorize it.","loading":"Loading...","connect_lean_account":"Connect Lean Account","successfully_connected_bank":"Successfully connected bank account","payment_has_been_queued":"Payment has been queued","successfully_paid":"Payment has been successfully paid","cannot_pay":"Payment Failed","lean":{"setup_status_active":"active","setup_status_pending":"pending","setup_status_not_connected":"not connected","account_is_being_connected":"Your account is being connected now. Please choose another payment method or try again later"}},"account_statement":{"recent_activities":"Recent Activities","account_statement":"Account Statement","currency":"AED","from":"From","to":"to","starts_from":"Starts from","downloading":"Downloading...","download":"Download","invoice":"Invoice","credit_note":"Credit Note","empty_list":"No data for chosen period"},"calendar":{"month_january":"January","month_february":"February","month_march":"March","month_april":"April","month_may":"May","month_june":"June","month_july":"July","month_august":"August","month_september":"September","month_october":"October","month_november":"November","month_december":"December","month":"Month","year":"Year","cancel":"Cancel","set":"Set","clear":"Clear","all_locations":"All Locations"},"payment_item":{"status_draft":"Draft","status_paid":"Paid","status_unpaid":"Pending","status_processed":"Processed","status_voided":"Voided"},"saved_payment_methods":{"method_has_been_added":"Payment method has been added successfully","save_card":"Save Card","saving_progress":"Saving...","remove_payment_method":"Remove payment method","method_has_been_deleted":"Payment method was deleted successfully","payment_methods":"Payment Methods","no_payment_methods_added":"No payment methods added yet","add_new_card":"Add a new card"},"error_boundary":{"default":{"server_error":"Internal Server Error","permission_error":"Permission Denied","client_error":"Client Error","not_found_error":"Not Found","not_authorized_error":"Not Authorized","connection_error":"Connection error. Check your internet connection","too_many_requests_error":"Too Many Requests. Try again later","default_error":"Something Went Wrong. Please try again","try_again":"Try Again"},"payment":{"cannot_fetch_overdue_server_error":"Couldn\'t fetch overdue payments data"}},"pending_orders_panel":{"pending_confirmation":"Pending confirmation","n_orders":"{{count}} order(s)","confirm_now":"Confirm now"},"raised_disputes_panel":{"title":"Raised disputes","n_disputes":"{{count}} dispute(s)","review_now":"Review now"},"step_indicator":{"step_of":"Step {{currentStepNumber}} of {{stepsCount}}"},"page_stepper":{"next":"Next","previous":"Previous","finish":"Finish","of":"of"},"order_status":{"draft":"Draft","pending_confirmation":"Pending Confirmation","under_review":"Under Review","started":"Started","upcoming":"Upcoming"},"toggle":{"yes_short":"Y","no_short":"N"},"time":{"mon":"Mon","tue":"Tue","wed":"Wed","thu":"Thu","fri":"Fri","sat":"Sat","sun":"Sun"},"time_picker":{"hour":"hour","minute":"minute","cancel":"cancel","set":"set"},"become_affiliate":{"modal_title":"Become an Affiliate","modal_subtitle":"Invite your staff to join Ogram and earn extra money!","accept_tc":"Terms and Conditions"},"common_affiliate":{"join_ogram":"Join Ogram with my special link","my_referrals":"My Referrals","send_invitation":"Send Invitation","share_link":"Invite your team to Ogram App and start earning!","copy_and_send_link":"Or copy and send the link below","tc_1":"These terms aren\u2019t directly involved with referral programs, but they\u2019re closely related enough for us to include here (several define other distinct categories of referral marketing)","tc_2":"Defining these terms helps alleviate some of the confusion about what is and isn\u2019t a referral program.","section_title":"AFFILIATE","dashboard":"Dashboard","referrals":"Referrals","earnings":"Earnings","designation":"Designation","payout":"Payout","due_date":"Due Date","join_date":"Join Date","this_month":"This Month","invite_more_staff":"Invite more staff","margin_split":"Margin Split","invite_your_staff":"Invite Your Staff","invite_staff_more_details":"Invite your co-workers to join Ogram to earn extra money!","invite_now":"Invite Now","earning_history":"Earnings History","total_earnings":"Total Earnings","status_profile_created":"Profile Created","status_activated":"Activated","status_booked_shifts":"Booked Shifts","status_shifts_done":"Shifts Done","status_unknown":"Unknown","referrals_list":"Referrals List"},"affiliate_instructions":{"how_it_works":"How it works","instruction_1_title":"Send an Invitation","instruction_1_subtitle":"Just share your link","instruction_2_title":"They join","instruction_2_subtitle":"And start completing paid shifts","instruction_3_title":"You Start Earning!","instruction_3_subtitle":"Get paid a commission for their work","instruction_4_title":"Track Your Staff","instruction_4_subtitle":"Using our affiliate dashboard"},"qr_scan":{"invalid_qr_code_provided":"Invalid QR Code Provided. Please, provide the one given by an Ogrammer","camera_permission_required":"Camera Permission required","access_denied":"Access to camera denied.","enable_permission":"To scan the QR code, please enable camera permission or use your mobile camera instead.","instruction_title":"What is the process?","step_1":"Step One","to_scan":"Scan","step_1_text":"Scan the code provided by the OG.","step_2":"Step Two","check_in_or_out":"Check in or out","step_2_text":"Check them in or out, and see job details.","sp_id_form_title":"If the QR code doesn\'t work, please enter the OG ID","sp_id_label":"Enter the OG ID","scan_qr":"Scan QR","sp_cant_be_checked_in_or_out":"This OG can\'t be checked-in/out","qr":"QR","scan_next_qr":"Scan Another QR","success_modal_text":"The {{processTitle}} process has been successfully completed.","carousel_title":"Check staff in and out by using the QR code","sp_id_form_title_1":"*QR Code not working?","sp_id_form_title_2":"Enter the OG ID below","camera_missing_title":"Your webcam is not compatible with the current browser.","camera_missing_description":" Please try your mobile camera instead \uD83D\uDCF8\uD83D\uDCF1","set_default_time":"Set Default"},"staff":{"past_workers":"Past Workers","hours_worked":"Hours Worked","n_hours":"{{hoursAmount}} Hours","n_shifts":"{{shiftsAmount}} Shifts","last_job":"Last Job","locations_worked":"Locations Worked","plus_n_locations":"+ {{locationsAmount}} Locations","enter_notes_on_worker":"Enter your notes on worker","favorite_only":"Favorite Only","apply":"Apply","reset":"Reset","how_was_the_worker":"How was the OG?","rating_submitted":"Rating Submitted!","search_worker_by_id_or_name":"Search Worker by ID or name","worker_name":"Worker Name","designations":"Designations","your_rating":"Your Rating","notes":"Notes","no_workers_found":"No workers found","note_validation_length":"Notes must be no longer than 499 characters","n_more":"{{ amount }} more","last_designation":"Last Designation","shifts_worked":"Shifts Worked","last_location":"Last Location"},"invited_sps":{"quantity_must_not_be_greater":"You can send maximum 3 invitations per 1 open job position. If you want to invite more OGs, please increase required job quantity","form_title":"Would you like to invite your past Ogrammers?","form_subtitle":"This step is optional. If you invite fewer Ogrammers than needed, Ogram will fill the remaining positions","select_required_data":"Please select quantity, location, designation and schedule first","invited_sps":"Preferred Ogrammers [Optional]","worked_at_current_location":"Worked at current location"},"pagination":{"page":"Page","of":"of"},"rating_popup":{"title":"Please Rate Your Experience with Ogrammers","subtitle_1":"We prioritize the best-rated workers for your future jobs. ","subtitle_2":"Your ratings help us prioritize top performers, ensuring you get the best service every time","ogs_to_rate":"OGs to Rate","will_be_prioritized":"This OG will be prioritized for you","will_not_be_assigned":"This OG won\u2019t be assigned again."},"disputes":{"overtime":"Overtime","no_show":"No-show","og_attendance":"OG attendance","check_in":"Check In","check_out":"Check Out","total_hours":"Total Hours","n_hours":"{{ count }} hours","your_attendance":"Your attendance","og_claims_n_hours_more":"OG claims they worked {{ count }} hours more","og_claims_show_up":"You cancelled the shift, but OG claims they did work","og_comment":"OG comment","view_attached_file":"View attached file","are_you_sure_to_agree":"Are you sure you want to agree with the OG?","dispute_resolved":"Dispute resolved successfully","i_agree":"I agree with the OG","are_you_sure_to_decline":"Are you sure you want to decline the OG dispute?","dispute_declined":"Dispute declined successfully","i_dont_agree":"I don\'t agree"}}');


var $92ad81250484a30b$exports = {};
$92ad81250484a30b$exports = JSON.parse('{"common":{"ogram":"Ogram","start_now":"\u039E\u03B5\u03BA\u03B9\u03BD\u03AE\u03C3\u03C4\u03B5 \u03A4\u03CE\u03C1\u03B1","dismiss":"\u039A\u03BB\u03B5\u03AF\u03C3\u03B9\u03BC\u03BF","continue":"\u03A3\u03C5\u03BD\u03AD\u03C7\u03B5\u03B9\u03B1","text_copied":"\u03A4\u03BF \u03BA\u03B5\u03AF\u03BC\u03B5\u03BD\u03BF \u03B1\u03BD\u03C4\u03B9\u03B3\u03C1\u03AC\u03C6\u03B7\u03BA\u03B5 \u03C3\u03C4\u03BF \u03C0\u03C1\u03CC\u03C7\u03B5\u03B9\u03C1\u03BF","tc":"\u038C\u03C1\u03BF\u03B9 \u03BA\u03B1\u03B9 \u03A0\u03C1\u03BF\u03CB\u03C0\u03BF\u03B8\u03AD\u03C3\u03B5\u03B9\u03C2","shifts":"\u03B2\u03AC\u03C1\u03B4\u03B9\u03B5\u03C2","show_more":"\u0394\u03B5\u03AF\u03BE\u03B5 \u03A0\u03B5\u03C1\u03B9\u03C3\u03C3\u03CC\u03C4\u03B5\u03C1\u03B1","ogs":"OGs","i_accept_terms":"\u0391\u03C0\u03BF\u03B4\u03AD\u03C7\u03BF\u03BC\u03B1\u03B9 \u03C4\u03BF\u03C5\u03C2 <1>\u038C\u03C1\u03BF\u03C5\u03C2 \u03A7\u03C1\u03AE\u03C3\u03B7\u03C2</1>","i_accept":"\u0391\u03C0\u03BF\u03B4\u03AD\u03C7\u03BF\u03BC\u03B1\u03B9 \u03C4\u03BF\u03C5\u03C2","terms_of_service":"\u038C\u03C1\u03BF\u03C5\u03C2 \u03A7\u03C1\u03AE\u03C3\u03B7\u03C2","yes":"\u039D\u03B1\u03B9","no":"\u038C\u03C7\u03B9","id_n":"ID#{{id}}","loading":"\u03A6\u03BF\u03C1\u03C4\u03CE\u03BD\u03B5\u03B9...","app_version":"App Version: {{version}}","select":"\u0395\u03C0\u03B9\u03BB\u03BF\u03B3\u03AE","job_n":"\u0394\u03BF\u03C5\u03BB\u03B5\u03B9\u03AC #{{id}}","filters":"Filters","filter":"Filter","location":"\u03A4\u03BF\u03C0\u03BF\u03B8\u03B5\u03C3\u03AF\u03B1","designation":"\u0395\u03B9\u03B4\u03B9\u03BA\u03CC\u03C4\u03B7\u03C4\u03B1","change":"\u0391\u03BB\u03BB\u03B1\u03B3\u03AE","cancel":"\u0391\u03BA\u03CD\u03C1\u03C9\u03C3\u03B7","order_id":"\u0391\u03C1\u03B9\u03B8\u03BC\u03CC\u03C2 \u03A0\u03B1\u03C1\u03B1\u03B3\u03B3\u03B5\u03BB\u03AF\u03B1\u03C2","is_overdue":"\u0388\u03C7\u03BF\u03C5\u03BD \u03BA\u03B1\u03B8\u03C5\u03C3\u03C4\u03B5\u03C1\u03AE\u03C3\u03B5\u03B9","date_from":"\u0397\u03BC\u03B5\u03C1\u03BF\u03BC\u03B7\u03BD\u03AF\u03B1 \u0388\u03BD\u03B1\u03C1\u03BE\u03B7\u03C2","date_to":"\u0397\u03BC\u03B5\u03C1\u03BF\u03BC\u03B7\u03BD\u03AF\u03B1 \u039B\u03AE\u03BE\u03B7\u03C2","now":"\u03A4\u03CE\u03C1\u03B1","no_data_found":"\u0394\u03B5\u03BD \u03B2\u03C1\u03AD\u03B8\u03B7\u03BA\u03B1\u03BD \u03C3\u03C4\u03BF\u03B9\u03C7\u03B5\u03AF\u03B1","not_available":"\u0394\u03B5\u03BD \u03B5\u03AF\u03BD\u03B1\u03B9 \u03B4\u03B9\u03B1\u03B8\u03AD\u03C3\u03B9\u03BC\u03BF","done":"\u03A4\u03AD\u03BB\u03BF\u03C2","clear":"\u0394\u03B9\u03B1\u03B3\u03C1\u03B1\u03C6\u03AE \u038C\u03BB\u03C9\u03BD","optional":"Optional","industry":"Industry","employees_amount_tier":"How many employees does your company have?","n_selected":"{{count}} Selected","ended_at":"Ended at {{date}}"},"password":{"minimumChars":"+6 \u03C7\u03B1\u03C1\u03B1\u03BA\u03C4\u03AE\u03C1\u03B5\u03C2","oneLowercase":"1 \u03C0\u03B5\u03B6\u03CC \u03B3\u03C1\u03AC\u03BC\u03BC\u03B1","oneNumber":"1 \u03B1\u03C1\u03B9\u03B8\u03BC\u03CC\u03C2","oneUppercase":"1 \u03BA\u03B5\u03C6\u03B1\u03BB\u03B1\u03AF\u03BF \u03B3\u03C1\u03AC\u03BC\u03BC\u03B1"},"login":{"good_to_see_you_back":"\u03A7\u03B1\u03B9\u03C1\u03CC\u03BC\u03B1\u03C3\u03C4\u03B5 \u03C0\u03BF\u03BB\u03CD \u03C0\u03BF\u03C5 \u03C3\u03B1\u03C2 \u03B2\u03BB\u03AD\u03C0\u03BF\u03C5\u03BC\u03B5","sign_in_to_account":"\u03A3\u03C5\u03BD\u03B4\u03B5\u03B8\u03B5\u03AF\u03C4\u03B5 \u03C3\u03C4\u03BF\u03BD \u03BB\u03BF\u03B3\u03B1\u03C1\u03B9\u03B1\u03C3\u03BC\u03CC \u03C3\u03B1\u03C2","enter_email":"\u03A0\u03C1\u03BF\u03C3\u03B8\u03AD\u03C3\u03C4\u03B5 \u03C4\u03BF email \u03C3\u03B1\u03C2","enter_password":"\u03A3\u03C5\u03BC\u03C0\u03BB\u03B7\u03C1\u03CE\u03C3\u03C4\u03B5 \u03C4\u03BF\u03BD \u03BA\u03C9\u03B4\u03B9\u03BA\u03CC \u03C3\u03B1\u03C2","email":"Email","password":"\u039A\u03C9\u03B4\u03B9\u03BA\u03CC\u03C2","remember_me":"\u039D\u03B1 \u03BC\u03B5 \u03B8\u03C5\u03BC\u03AC\u03C3\u03B1\u03B9","forgot_password_question":"\u039E\u03B5\u03C7\u03AC\u03C3\u03B1\u03C4\u03B5 \u03C4\u03BF\u03BD \u03BA\u03C9\u03B4\u03B9\u03BA\u03CC \u03C3\u03B1\u03C2;","sign_in":"\u03A3\u03CD\u03BD\u03B4\u03B5\u03C3\u03B7","signin_in":"\u03A3\u03B1\u03C2 \u03C3\u03C5\u03BD\u03B4\u03AD\u03BF\u03C5\u03BC\u03B5...","sign_up_link_text":"\u0395\u03B3\u03B3\u03C1\u03B1\u03C6\u03AE","test_string":"\u0394\u03BF\u03BA\u03B9\u03BC\u03AE \u03C4\u03BF\u03C5 \u03C3\u03C5\u03C3\u03C4\u03AE\u03BC\u03B1\u03C4\u03BF\u03C2"},"create_password":{"title":"\u0394\u03B7\u03BC\u03B9\u03BF\u03C5\u03C1\u03B3\u03AE\u03C3\u03C4\u03B5 \u03AD\u03BD\u03B1\u03BD \u03BA\u03C9\u03B4\u03B9\u03BA\u03CC","description":"\u0394\u03B7\u03BC\u03B9\u03BF\u03C5\u03C1\u03B3\u03AE\u03C3\u03C4\u03B5 \u03AD\u03BD\u03B1\u03BD \u03BA\u03C9\u03B4\u03B9\u03BA\u03CC \u03C0\u03C1\u03CC\u03C3\u03B2\u03B1\u03C3\u03B7\u03C2 \u03B3\u03B9\u03B1 \u03BD\u03B1 \u03BC\u03C0\u03BF\u03C1\u03B5\u03AF\u03C4\u03B5 \u03BD\u03B1 \u03C3\u03C5\u03BD\u03B4\u03AD\u03B5\u03C3\u03C4\u03B5 \u03BC\u03B5 \u03C4\u03BF email \u03C3\u03B1\u03C2","please_enter_password":"\u03A3\u03C5\u03BC\u03C0\u03BB\u03B7\u03C1\u03CE\u03C3\u03C4\u03B5 \u03C4\u03BF\u03BD \u03BA\u03C9\u03B4\u03B9\u03BA\u03CC \u03C3\u03B1\u03C2","please_confirm_password":"\u0395\u03C0\u03B9\u03B2\u03B5\u03B2\u03B1\u03B9\u03CE\u03C3\u03C4\u03B5 \u03C4\u03BF\u03BD \u03BA\u03C9\u03B4\u03B9\u03BA\u03CC \u03C3\u03B1\u03C2","confirm_password":"\u0395\u03C0\u03B9\u03B2\u03B5\u03B2\u03B1\u03AF\u03C9\u03C3\u03B7 \u03BA\u03C9\u03B4\u03B9\u03BA\u03BF\u03CD","password":"\u039A\u03C9\u03B4\u03B9\u03BA\u03CC\u03C2","password_matched":"\u039F\u03B9 \u039A\u03C9\u03B4\u03B9\u03BA\u03BF\u03AF \u03A4\u03B1\u03B9\u03C1\u03B9\u03AC\u03B6\u03BF\u03C5\u03BD","password_not_matched":"\u039F\u03B9 \u039A\u03C9\u03B4\u03B9\u03BA\u03BF\u03AF \u0394\u03B5\u03BD \u03A4\u03B1\u03B9\u03C1\u03B9\u03AC\u03B6\u03BF\u03C5\u03BD","resend_modal_button":"\u0395\u03C0\u03B1\u03BD\u03B1\u03C0\u03BF\u03C3\u03C4\u03BF\u03BB\u03AE email","sending":"\u0391\u03C0\u03BF\u03C3\u03C4\u03BF\u03BB\u03AE...","email_invalid":"\u03A4\u03BF email \u03B4\u03B5\u03BD \u03B5\u03AF\u03BD\u03B1\u03B9 \u03AD\u03B3\u03BA\u03C5\u03C1\u03BF","email_required":"\u03A3\u03C5\u03BC\u03C0\u03BB\u03B7\u03C1\u03CE\u03C3\u03C4\u03B5 \u03C4\u03BF email \u03C3\u03B1\u03C2","email":"Email","email_is_sent":"\u0388\u03BD\u03B1\u03C2 \u03BD\u03AD\u03BF\u03C2 \u03C3\u03CD\u03BD\u03B4\u03B5\u03C3\u03BC\u03BF\u03C2 \u03AD\u03C7\u03B5\u03B9 \u03C3\u03C4\u03B1\u03BB\u03B5\u03AF \u03C3\u03C4\u03BF email \u03C3\u03B1\u03C2.","submit":"\u03A5\u03C0\u03BF\u03B2\u03BF\u03BB\u03AE"},"forgot_password":{"title":"\u039E\u03B5\u03C7\u03AC\u03C3\u03B1\u03C3\u03C4\u03B5 \u03C4\u03BF\u03BD \u03BA\u03C9\u03B4\u03B9\u03BA\u03CC \u03C3\u03B1\u03C2;","description":"\u03A0\u03C1\u03BF\u03C3\u03B8\u03AD\u03C3\u03C4\u03B5 \u03C4\u03BF email \u03C0\u03BF\u03C5 \u03C3\u03C5\u03BD\u03B4\u03AD\u03B5\u03C4\u03B1\u03B9 \u03BC\u03B5 \u03C4\u03BF\u03BD \u03BB\u03BF\u03B3\u03B1\u03C1\u03B9\u03B1\u03C3\u03BC\u03CC \u03C3\u03B1\u03C2","please_enter_email":"\u03A3\u03C5\u03BC\u03C0\u03BB\u03B7\u03C1\u03CE\u03C3\u03C4\u03B5 \u03C4\u03BF email \u03C3\u03B1\u03C2","email_must_be_valid":"\u03A4\u03BF email \u03B4\u03B5\u03BD \u03B5\u03AF\u03BD\u03B1\u03B9 \u03AD\u03B3\u03BA\u03C5\u03C1\u03BF","email":"Email","submit":"\u03A5\u03C0\u03BF\u03B2\u03BF\u03BB\u03AE","back_to_sign_in":"\u0395\u03C0\u03B9\u03C3\u03C4\u03C1\u03BF\u03C6\u03AE \u03C3\u03C4\u03B7 \u03A3\u03CD\u03BD\u03B4\u03B5\u03C3\u03B7","forgot_password":"\u039E\u03AD\u03C7\u03B1\u03C3\u03B1 \u03C4\u03BF\u03BD \u03BA\u03C9\u03B4\u03B9\u03BA\u03CC","password_sent_to_email":"\u0388\u03BD\u03B1\u03C2 \u03BD\u03AD\u03BF\u03C2 \u03BA\u03C9\u03B4\u03B9\u03BA\u03CC\u03C2 \u03AD\u03C7\u03B5\u03B9 \u03C3\u03C4\u03B1\u03BB\u03B5\u03AF \u03C3\u03C4\u03BF email \u03C3\u03B1\u03C2.","resend":"\u0395\u03C0\u03B1\u03BD\u03B1\u03C0\u03BF\u03C3\u03C4\u03BF\u03BB\u03AE","reset_password":"\u0395\u03C0\u03B1\u03BD\u03B1\u03C6\u03BF\u03C1\u03AC \u03BA\u03C9\u03B4\u03B9\u03BA\u03BF\u03CD","email_sent":"\u0388\u03BD\u03B1\u03C2 \u03C3\u03CD\u03BD\u03B4\u03B5\u03C3\u03BC\u03BF\u03C2 \u03B5\u03C0\u03B1\u03BD\u03B1\u03C6\u03BF\u03C1\u03AC\u03C2 \u03BA\u03C9\u03B4\u03B9\u03BA\u03BF\u03CD \u03C0\u03C1\u03CC\u03C3\u03B2\u03B1\u03C3\u03B7\u03C2 \u03AD\u03C7\u03B5\u03B9 \u03C3\u03C4\u03B1\u03BB\u03B5\u03AF \u03C3\u03C4o email \u03C3\u03B1\u03C2"},"validation_messages":{"email_invalid":"\u03A4\u03BF email \u03B4\u03B5\u03BD \u03B5\u03AF\u03BD\u03B1\u03B9 \u03AD\u03B3\u03BA\u03C5\u03C1\u03BF"},"reset_password":{"title":"\u0395\u03C0\u03B1\u03BD\u03B1\u03C6\u03BF\u03C1\u03AC \u03BA\u03C9\u03B4\u03B9\u03BA\u03BF\u03CD","description":"\u03A0\u03C1\u03BF\u03C3\u03B8\u03AD\u03C3\u03C4\u03B5 \u03BD\u03AD\u03BF \u03BA\u03C9\u03B4\u03B9\u03BA\u03CC","please_enter_password":"\u03A0\u03C1\u03BF\u03C3\u03B8\u03AD\u03C3\u03C4\u03B5 \u03BD\u03AD\u03BF \u03BA\u03C9\u03B4\u03B9\u03BA\u03CC","please_confirm_password":"\u0395\u03C0\u03B9\u03B2\u03B5\u03B2\u03B1\u03B9\u03CE\u03C3\u03C4\u03B5 \u03C4\u03BF\u03BD \u03BA\u03C9\u03B4\u03B9\u03BA\u03CC \u03C3\u03B1\u03C2","password":"\u039A\u03C9\u03B4\u03B9\u03BA\u03CC\u03C2","confirm_password":"\u0395\u03C0\u03B9\u03B2\u03B5\u03B2\u03B1\u03AF\u03C9\u03C3\u03B7 \u03BA\u03C9\u03B4\u03B9\u03BA\u03BF\u03CD","password_mathched":"\u039F\u03B9 \u03BA\u03C9\u03B4\u03B9\u03BA\u03BF\u03AF \u03C4\u03B1\u03B9\u03C1\u03B9\u03AC\u03B6\u03BF\u03C5\u03BD","password_not_matched":"\u039F\u03B9 \u03BA\u03C9\u03B4\u03B9\u03BA\u03BF\u03AF \u03B4\u03B5\u03BD \u03C4\u03B1\u03B9\u03C1\u03B9\u03AC\u03B6\u03BF\u03C5\u03BD","submit":"\u03A5\u03C0\u03BF\u03B2\u03BF\u03BB\u03AE"},"change_password":{"title":"\u0391\u03BB\u03BB\u03AC\u03BE\u03C4\u03B5 \u03BA\u03C9\u03B4\u03B9\u03BA\u03CC \u03C0\u03C1\u03CC\u03C3\u03B2\u03B1\u03C3\u03B7\u03C2","description":"\u0395\u03B9\u03C3\u03AC\u03B3\u03B5\u03C4\u03B5 \u03C4\u03BF\u03BD \u03C0\u03B1\u03BB\u03B9\u03CC \u03BA\u03B1\u03B9 \u03C4\u03BF\u03BD \u03BD\u03AD\u03BF \u03BA\u03C9\u03B4\u03B9\u03BA\u03CC \u03C0\u03C1\u03CC\u03C3\u03B2\u03B1\u03C3\u03B7\u03C2","please_enter_old_password":"\u0395\u03B9\u03C3\u03AC\u03B3\u03B5\u03C4\u03B5 \u03C4\u03BF\u03BD \u03C0\u03B1\u03BB\u03B9\u03CC \u03BA\u03C9\u03B4\u03B9\u03BA\u03CC \u03C0\u03C1\u03CC\u03C3\u03B2\u03B1\u03C3\u03B7\u03C2","please_enter_password":"\u0395\u03B9\u03C3\u03AC\u03B3\u03B5\u03C4\u03B5 \u03C4\u03BF\u03BD \u03BD\u03AD\u03BF \u03BA\u03C9\u03B4\u03B9\u03BA\u03CC \u03C0\u03C1\u03CC\u03C3\u03B2\u03B1\u03C3\u03B7\u03C2","please_confirm_password":"\u0395\u03C0\u03B9\u03B2\u03B5\u03B2\u03B1\u03B9\u03CE\u03C3\u03C4\u03B5 \u03C4\u03BF\u03BD \u03BD\u03AD\u03BF \u03BA\u03C9\u03B4\u03B9\u03BA\u03CC \u03C0\u03C1\u03CC\u03C3\u03B2\u03B1\u03C3\u03B7\u03C2","old_password":"\u03A0\u03B1\u03BB\u03B9\u03CC\u03C2 \u039A\u03C9\u03B4\u03B9\u03BA\u03CC\u03C2 \u03A0\u03C1\u03CC\u03C3\u03B2\u03B1\u03C3\u03B7\u03C2","new_password":"\u039D\u03AD\u03BF\u03C2 \u039A\u03C9\u03B4\u03B9\u03BA\u03CC\u03C2 \u03A0\u03C1\u03CC\u03C3\u03B2\u03B1\u03C3\u03B7\u03C2","confirm_new_password":"\u0395\u03C0\u03B9\u03B2\u03B5\u03B2\u03B1\u03B9\u03CE\u03C3\u03C4\u03B5 \u03C4\u03BF\u03BD \u03BD\u03AD\u03BF \u03BA\u03C9\u03B4\u03B9\u03BA\u03CC","password_matched":"\u039F\u03B9 \u03BA\u03C9\u03B4\u03B9\u03BA\u03BF\u03AF \u03C4\u03B1\u03B9\u03C1\u03B9\u03AC\u03B6\u03BF\u03C5\u03BD","password_not_matched":"\u039F\u03B9 \u03BA\u03C9\u03B4\u03B9\u03BA\u03BF\u03AF \u03B4\u03B5\u03BD \u03C4\u03B1\u03B9\u03C1\u03B9\u03AC\u03B6\u03BF\u03C5\u03BD","submit":"\u03A5\u03C0\u03BF\u03B2\u03BF\u03BB\u03AE","password_changed_successfully":"\u039F \u03BA\u03C9\u03B4\u03B9\u03BA\u03CC\u03C2 \u03C0\u03C1\u03CC\u03C3\u03B2\u03B1\u03C3\u03B7\u03C2 \u03AC\u03BB\u03BB\u03B1\u03BE\u03B5 \u03BC\u03B5 \u03B5\u03C0\u03B9\u03C4\u03C5\u03C7\u03AF\u03B1"},"sign_up":{"title":"\u0395\u03B3\u03B3\u03C1\u03B1\u03C6\u03AE \u03A0\u03B5\u03BB\u03AC\u03C4\u03B7","subtitle":"\u0395\u03B3\u03B3\u03C1\u03B1\u03C6\u03B5\u03AF\u03C4\u03B5 \u03B3\u03B9\u03B1 \u03BD\u03B1 \u03BC\u03C0\u03BF\u03C1\u03B5\u03AF\u03C4\u03B5 \u03BD\u03B1 \u03B4\u03B7\u03BC\u03B9\u03BF\u03C5\u03C1\u03B3\u03B5\u03AF\u03C4\u03B5 \u03BA\u03B1\u03B9 \u03BD\u03B1 \u03B5\u03BB\u03AD\u03B3\u03C7\u03B5\u03C4\u03B5 \u03C4\u03B9\u03C2 \u03C0\u03B1\u03C1\u03B1\u03B3\u03B3\u03B5\u03BB\u03AF\u03B5\u03C2 \u03C3\u03B1\u03C2","sign_up":"\u0395\u03B3\u03B3\u03C1\u03B1\u03C6\u03AE","first_name":"\u038C\u03BD\u03BF\u03BC\u03B1","last_name":"\u0395\u03C0\u03AF\u03B8\u03B5\u03C4\u03BF","phone":"\u03A4\u03B7\u03BB\u03AD\u03C6\u03C9\u03BD\u03BF","email":"Email","password":"\u039A\u03C9\u03B4\u03B9\u03BA\u03CC\u03C2 \u03C0\u03C1\u03CC\u03C3\u03B2\u03B1\u03C3\u03B7\u03C2","city":"\u03A0\u03CC\u03BB\u03B7","company_name_optional":"\u038C\u03BD\u03BF\u03BC\u03B1 \u03B5\u03C4\u03B1\u03B9\u03C1\u03B5\u03AF\u03B1\u03C2 (\u0391\u03C0\u03B1\u03B9\u03C4\u03B5\u03AF\u03C4\u03B1\u03B9 \u03B3\u03B9\u03B1 \u03B5\u03C4\u03B1\u03B9\u03C1\u03B5\u03AF\u03B5\u03C2)","company_name":"\u038C\u03BD\u03BF\u03BC\u03B1 \u03B5\u03C4\u03B1\u03B9\u03C1\u03B5\u03AF\u03B1\u03C2","agree_to_emails":"\u03A3\u03C5\u03BC\u03C6\u03CE\u03BD\u03C9 \u03BD\u03B1 \u03BB\u03B1\u03BC\u03B2\u03AC\u03BD\u03C9 \u03B5\u03B9\u03B4\u03BF\u03C0\u03BF\u03B9\u03AE\u03C3\u03B5\u03B9\u03C2 \u03B3\u03B9\u03B1 \u03BB\u03CC\u03B3\u03BF\u03C5\u03C2 marketing \u03B1\u03C0\u03CC \u03C4\u03B7\u03BD Ogram","are_you_corporate_question":"\u0395\u03AF\u03C3\u03C4\u03B5 \u03B5\u03C4\u03B1\u03B9\u03C1\u03B5\u03AF\u03B1;","back_to_sign_in":"\u03A0\u03AF\u03C3\u03C9 \u03C3\u03C4\u03B7 \u03A3\u03CD\u03BD\u03B4\u03B5\u03C3\u03B7","first_name_required":"\u03A0\u03C1\u03BF\u03C3\u03B8\u03AD\u03C3\u03C4\u03B5 \u03C4\u03BF \u03CC\u03BD\u03BF\u03BC\u03AC \u03C3\u03B1\u03C2","last_name_required":"\u03A0\u03C1\u03BF\u03C3\u03B8\u03AD\u03C3\u03C4\u03B5 \u03C4\u03BF \u03B5\u03C0\u03AF\u03B8\u03B5\u03C4\u03CC \u03C3\u03B1\u03C2","industry_required":"Please select your industry","employees_amount_tier_required":"Please select amount of employees","phone_required":"\u03A0\u03C1\u03BF\u03C3\u03B8\u03AD\u03C3\u03C4\u03B5 \u03C4\u03BF \u03C4\u03B7\u03BB\u03AD\u03C6\u03C9\u03BD\u03CC \u03C3\u03B1\u03C2","email_required":"\u03A0\u03C1\u03BF\u03C3\u03B8\u03AD\u03C3\u03C4\u03B5 \u03C4\u03BF email \u03C3\u03B1\u03C2","company_name_required":"\u03A4\u03BF \u03CC\u03BD\u03BF\u03BC\u03B1 \u03C4\u03B7\u03C2 \u03B5\u03C4\u03B1\u03B9\u03C1\u03B5\u03AF\u03B1\u03C2 \u03B5\u03AF\u03BD\u03B1\u03B9 \u03B1\u03C0\u03B1\u03C1\u03B1\u03AF\u03C4\u03B7\u03C4\u03BF \u03B3\u03B9\u03B1 \u03B5\u03C4\u03B1\u03B9\u03C1\u03B9\u03BA\u03BF\u03CD\u03C2 \u03C7\u03C1\u03AE\u03C3\u03C4\u03B5\u03C2","city_required":"\u03A0\u03C1\u03BF\u03C3\u03B8\u03AD\u03C3\u03C4\u03B5 \u03C4\u03B7\u03BD \u03C0\u03CC\u03BB\u03B7 \u03C3\u03B1\u03C2","submitting":"\u03A6\u03CC\u03C1\u03C4\u03C9\u03C3\u03B7...","choose_work_category_title":"\u03A4\u03B9 \u03C0\u03C1\u03BF\u03C3\u03C9\u03C0\u03B9\u03BA\u03CC \u03C7\u03C1\u03B5\u03B9\u03AC\u03B6\u03B5\u03C3\u03C4\u03B5;","choose_work_category_subtitle":"\u03A0\u03B5\u03C1\u03B9\u03B3\u03C1\u03AC\u03C8\u03C4\u03B5 \u03C4\u03B7\u03BD \u03B8\u03AD\u03C3\u03B7 \u03B5\u03C1\u03B3\u03B1\u03C3\u03AF\u03B1\u03C2","create_new_order_title":"\u039E\u03B5\u03BA\u03B9\u03BD\u03AE\u03C3\u03C4\u03B5 \u03BD\u03B1 \u03A0\u03C1\u03BF\u03C3\u03BB\u03B1\u03BC\u03B2\u03AC\u03BD\u03B5\u03C4\u03B5","contact_details_title":"\u03A0\u03BF\u03B9\u03B1 \u03B5\u03AF\u03BD\u03B1\u03B9 \u03C4\u03B1 \u03C3\u03C4\u03BF\u03B9\u03C7\u03B5\u03AF\u03B1 \u03B5\u03C0\u03B9\u03BA\u03BF\u03B9\u03BD\u03C9\u03BD\u03AF\u03B1\u03C2 \u03C3\u03B1\u03C2;","contact_details_subtitle":"\u03A0\u03C1\u03BF\u03C3\u03B8\u03AD\u03C3\u03C4\u03B5 \u03C4\u03B1 \u03C3\u03C4\u03BF\u03B9\u03C7\u03B5\u03AF\u03B1 \u03B5\u03C0\u03B9\u03BA\u03BF\u03B9\u03BD\u03C9\u03BD\u03AF\u03B1\u03C2 \u03C3\u03B1\u03C2 \u03B3\u03B9\u03B1 \u03BD\u03B1 \u03B5\u03C0\u03B9\u03BA\u03BF\u03B9\u03BD\u03C9\u03BD\u03AE\u03C3\u03BF\u03C5\u03BC\u03B5 \u03BC\u03B1\u03B6\u03AF \u03C3\u03B1\u03C2","how_to_reach_title":"\u03A0\u03C9\u03C2 \u03BC\u03C0\u03BF\u03C1\u03BF\u03CD\u03BC\u03B5 \u03BD\u03B1 \u03B5\u03C0\u03B9\u03BA\u03BF\u03B9\u03BD\u03C9\u03BD\u03AE\u03C3\u03BF\u03C5\u03BC\u03B5;","next":"\u0395\u03C0\u03CC\u03BC\u03B5\u03BD\u03BF","phone_invalid":"\u03A0\u03BB\u03B7\u03BA\u03C4\u03C1\u03BF\u03BB\u03BF\u03B3\u03AE\u03C3\u03C4\u03B5 \u03AD\u03BD\u03B1 \u03AD\u03B3\u03BA\u03C5\u03C1\u03BF \u03C4\u03B7\u03BB\u03AD\u03C6\u03C9\u03BD\u03BF","already_registered":"\u0388\u03C7\u03B5\u03C4\u03B5 \u03AE\u03B4\u03B7 \u03BB\u03BF\u03B3\u03B1\u03C1\u03B9\u03B1\u03C3\u03BC\u03CC;","sign_in":"\u03A3\u03C5\u03BD\u03B4\u03B5\u03B8\u03B5\u03AF\u03C4\u03B5","consent":"\u039A\u03AC\u03BD\u03BF\u03BD\u03C4\u03B1\u03C2 \u03BA\u03BB\u03B9\u03BA \u03C3\u03C4\u03BF \u03BA\u03BF\u03C5\u03BC\u03C0\u03AF \\"\u0395\u03B3\u03B3\u03C1\u03B1\u03C6\u03AE\\", \u03C7\u03BF\u03C1\u03B7\u03B3\u03B5\u03AF\u03C4\u03B5 \u03AC\u03B4\u03B5\u03B9\u03B1 \u03C3\u03C4\u03B7\u03BD \u03B5\u03C4\u03B1\u03B9\u03C1\u03B5\u03AF\u03B1 \u03BC\u03B1\u03C2 \u03BD\u03B1 \u03C7\u03C1\u03B7\u03C3\u03B9\u03BC\u03BF\u03C0\u03BF\u03B9\u03AE\u03C3\u03B5\u03B9 \u03C4\u03B1 \u03C0\u03C1\u03BF\u03C3\u03C9\u03C0\u03B9\u03BA\u03AC \u03C3\u03B1\u03C2 \u03C3\u03C4\u03BF\u03B9\u03C7\u03B5\u03AF\u03B1 \u03B3\u03B9\u03B1 \u03C4\u03B7 \u03B4\u03B7\u03BC\u03B9\u03BF\u03C5\u03C1\u03B3\u03AF\u03B1 \u03BB\u03BF\u03B3\u03B1\u03C1\u03B9\u03B1\u03C3\u03BC\u03BF\u03CD \u03BA\u03B1\u03B9 \u03C4\u03B7\u03BD \u03B5\u03C0\u03B5\u03BE\u03B5\u03C1\u03B3\u03B1\u03C3\u03AF\u03B1 \u03C4\u03B7\u03C2 \u03C0\u03B1\u03C1\u03B1\u03B3\u03B3\u03B5\u03BB\u03AF\u03B1\u03C2 \u03C3\u03B1\u03C2.","thank_you":"\u03A3\u03B1\u03C2 \u03B5\u03C5\u03C7\u03B1\u03C1\u03B9\u03C3\u03C4\u03BF\u03CD\u03BC\u03B5!"},"verify_email":{"title":"\u0395\u03C0\u03B9\u03B2\u03B5\u03B2\u03B1\u03B9\u03CE\u03C3\u03C4\u03B5 \u03C4\u03BF email \u03C3\u03B1\u03C2","description":"\u039F \u03BA\u03C9\u03B4\u03B9\u03BA\u03CC\u03C2 \u03B5\u03C0\u03B9\u03B2\u03B5\u03B2\u03B1\u03AF\u03C9\u03C3\u03B7\u03C2 \u03AD\u03C7\u03B5\u03B9 \u03C3\u03C4\u03B1\u03BB\u03B5\u03AF \u03C3\u03C4\u03BF email \u03C3\u03B1\u03C2","we_sent_code_to_email":"\u03A3\u03C4\u03B5\u03AF\u03BB\u03B1\u03BC\u03B5 \u03C4\u03BF\u03BD \u03BA\u03C9\u03B4\u03B9\u03BA\u03CC \u03B5\u03C0\u03B1\u03BB\u03AE\u03B8\u03B5\u03C5\u03C3\u03B7\u03C2 \u03C3\u03C4\u03BF {{email}}. \u0395\u03BB\u03AD\u03B3\u03BE\u03C4\u03B5 \u03C4\u03B1 \u03B5\u03B9\u03C3\u03B5\u03C1\u03C7\u03CC\u03BC\u03B5\u03BD\u03AC \u03C3\u03B1\u03C2 \u03BA\u03B1\u03B9 \u03C0\u03C1\u03BF\u03C3\u03B8\u03AD\u03C3\u03C4\u03B5 \u03C4\u03BF\u03BD \u03BA\u03C9\u03B4\u03B9\u03BA\u03CC \u03B5\u03C0\u03B1\u03BB\u03AE\u03B8\u03B5\u03C5\u03C3\u03B7\u03C2 \u03C0\u03B1\u03C1\u03B1\u03BA\u03AC\u03C4\u03C9 \u03B3\u03B9\u03B1 \u03BD\u03B1 \u03BF\u03BB\u03BF\u03BA\u03BB\u03B7\u03C1\u03CE\u03C3\u03B5\u03C4\u03B5 \u03C4\u03B7\u03BD \u03B4\u03B7\u03BC\u03B9\u03BF\u03C5\u03C1\u03B3\u03AF\u03B1 \u03C4\u03BF\u03C5 \u03BB\u03BF\u03B3\u03B1\u03C1\u03B9\u03B1\u03C3\u03BC\u03BF\u03CD \u03C3\u03B1\u03C2.","please_enter_code":"\u03A0\u03C1\u03BF\u03C3\u03B8\u03AD\u03C3\u03C4\u03B5 \u03C4\u03BF\u03BD \u03BA\u03C9\u03B4\u03B9\u03BA\u03CC \u03B5\u03C0\u03B1\u03BB\u03AE\u03B8\u03B5\u03C5\u03C3\u03B7\u03C2","verification_code":"\u039A\u03C9\u03B4\u03B9\u03BA\u03CC\u03C2 \u0395\u03C0\u03B1\u03BB\u03AE\u03B8\u03B5\u03C5\u03C3\u03B7\u03C2","verify":"\u0395\u03C0\u03B1\u03BB\u03AE\u03B8\u03B5\u03C5\u03C3\u03B7","did_not_receive_email_question":"\u0394\u03B5\u03BD \u03BB\u03AC\u03B2\u03B1\u03C4\u03B5 \u03C4\u03BF email; \u0395\u03C0\u03B1\u03BD\u03AC\u03BB\u03B7\u03C8\u03B7 \u03B1\u03C0\u03BF\u03C3\u03C4\u03BF\u03BB\u03AE\u03C2 \u03BA\u03C9\u03B4\u03B9\u03BA\u03BF\u03CD \u03C3\u03B5 3 \u03BB\u03B5\u03C0\u03C4\u03AC","not_your_email_question":"\u0394\u03B5\u03BD \u03B5\u03AF\u03BD\u03B1\u03B9 \u03C4\u03BF email \u03C3\u03B1\u03C2;","change_email":"\u0391\u03BB\u03BB\u03AC\u03BE\u03C4\u03B5 \u03C4\u03BF email \u03C3\u03B1\u03C2"},"applicant_details":{"n_shifts_completed":"{{count}} \u03BF\u03BB\u03BF\u03BA\u03BB\u03B7\u03C1\u03C9\u03BC\u03AD\u03BD\u03B5\u03C2 \u03B2\u03AC\u03C1\u03B4\u03B9\u03B5\u03C2","years_of_experience":"{{count}} \u03A7\u03C1\u03CC\u03BD\u03B9\u03B1","information":"\u03A0\u03BB\u03B7\u03C1\u03BF\u03C6\u03BF\u03C1\u03AF\u03B5\u03C2","work_experience":"\u0395\u03C0\u03B1\u03B3\u03B3\u03B5\u03BB\u03BC\u03B1\u03C4\u03B9\u03BA\u03AE \u0395\u03BC\u03C0\u03B5\u03B9\u03C1\u03AF\u03B1","education":"\u0395\u03BA\u03C0\u03B1\u03AF\u03B4\u03B5\u03C5\u03C3\u03B7","get_next_applicant":"\u0395\u03C0\u03CC\u03BC\u03B5\u03BD\u03BF\u03C2 \u03C5\u03C0\u03BF\u03C8\u03AE\u03C6\u03B9\u03BF\u03C2","in":"\u03BC\u03AD\u03C3\u03B1","chief_og":"\u0391\u03C1\u03C7\u03B7\u03B3\u03CC\u03C2 OG","added_as_favourite":"\u039F/\u0397 {{spName}} \u03B2\u03C1\u03AF\u03C3\u03BA\u03B5\u03C4\u03B1\u03B9 \u03C0\u03BB\u03AD\u03BF\u03BD \u03C3\u03C4\u03B7 \u03BB\u03AF\u03C3\u03C4\u03B1 \u03C4\u03C9\u03BD \u03C0\u03C1\u03BF\u03C4\u03B9\u03BC\u03AE\u03C3\u03B5\u03CE\u03BD \u03BC\u03B1\u03C2. \u0398\u03B1 \u03B4\u03AF\u03BD\u03BF\u03C5\u03BC\u03B5 \u03C0\u03C1\u03BF\u03C4\u03B5\u03C1\u03B1\u03B9\u03CC\u03C4\u03B7\u03C4\u03B1 \u03C3\u03C4\u03BF\u03BD/\u03C3\u03C4\u03B7\u03BD {{spName}} \u03C3\u03C4\u03BF\u03BD \u03B1\u03BB\u03B3\u03CC\u03C1\u03B9\u03B8\u03BC\u03CC \u03BC\u03B1\u03C2.","skills":"\u0394\u03B5\u03BE\u03B9\u03CC\u03C4\u03B7\u03C4\u03B5\u03C2","chief":"\u039F\u03B9 <1>\u0391\u03C1\u03C7\u03B7\u03B3\u03BF\u03AF OG\'s </1><2>\u03B5\u03AF\u03BD\u03B1\u03B9 \u03AD\u03BC\u03C0\u03B5\u03B9\u03C1\u03BF\u03B9 \u03C3\u03C4\u03B7\u03BD \u03B7\u03B3\u03B5\u03C3\u03AF\u03B1 \u03BF\u03BC\u03AC\u03B4\u03C9\u03BD \u03BA\u03B1\u03B9 \u03C4\u03BF\u03C5\u03C2 \u03AD\u03C7\u03BF\u03C5\u03BC\u03B5 \u03B5\u03C0\u03B9\u03BB\u03AD\u03BE\u03B5\u03B9 \u03BC\u03B5 \u03C0\u03C1\u03BF\u03C3\u03BF\u03C7\u03AE \u03B3\u03B9\u03B1 \u03BD\u03B1 \u03C3\u03C5\u03BD\u03C4\u03BF\u03BD\u03AF\u03B6\u03BF\u03C5\u03BD \u03BA\u03B1\u03BB\u03CD\u03C4\u03B5\u03C1\u03B1 \u03C4\u03B9\u03C2 \u03BF\u03BC\u03AC\u03B4\u03B5\u03C2 \u03C4\u03B7\u03C2 Ogram \u03C3\u03C4\u03BF\u03BD \u03C7\u03CE\u03C1\u03BF \u03B5\u03C1\u03B3\u03B1\u03C3\u03AF\u03B1\u03C2.</2>","interview":"\u03A3\u03C5\u03BD\u03AD\u03BD\u03C4\u03B5\u03C5\u03BE\u03B7","view_answer":"\u0394\u03B5\u03AF\u03C4\u03B5 \u03C4\u03B7\u03BD \u0391\u03C0\u03AC\u03BD\u03C4\u03B7\u03C3\u03B7","job_history_with_you":"\u0399\u03C3\u03C4\u03BF\u03C1\u03B9\u03BA\u03CC \u03A3\u03C5\u03BD\u03B5\u03C1\u03B3\u03B1\u03C3\u03AF\u03B1\u03C2 \u03BC\u03B5 \u0395\u03C3\u03AC\u03C2","work_category_experience":"{{ workCategoryName }} \u0395\u03BC\u03C0\u03B5\u03B9\u03C1\u03AF\u03B1","other_experience":"\u0386\u03BB\u03BB\u03B7 \u0395\u03BC\u03C0\u03B5\u03B9\u03C1\u03AF\u03B1"},"applicants_review":{"title":"\u0388\u03BB\u03B5\u03B3\u03C7\u03BF\u03C2 \u03A5\u03C0\u03BF\u03C8\u03B7\u03C6\u03AF\u03C9\u03BD","no_applicants_to_reivew":"\u0394\u03B5\u03BD \u03C5\u03C0\u03AC\u03C1\u03C7\u03BF\u03C5\u03BD \u03C5\u03C0\u03BF\u03C8\u03AE\u03C6\u03B9\u03BF\u03B9 \u03B3\u03B9\u03B1 \u03AD\u03BB\u03B5\u03B3\u03C7\u03BF","percent_filled":"{{percent}}% \u0393\u03B5\u03BC\u03AC\u03C4\u03BF"},"job_cherry_picking":{"title":"\u039B\u03B5\u03C0\u03C4\u03BF\u03BC\u03AD\u03C1\u03B5\u03B9\u03B5\u03C2 \u0395\u03C1\u03B3\u03B1\u03C3\u03AF\u03B1\u03C2","accepted":"\u0394\u03B5\u03BA\u03C4\u03AE","rejected":"\u0391\u03C0\u03BF\u03C1\u03C1\u03AF\u03C6\u03B8\u03B7\u03BA\u03B5","reject":"\u0391\u03C0\u03CC\u03C1\u03C1\u03B9\u03C8\u03B7","accept":"\u0391\u03C0\u03BF\u03B4\u03BF\u03C7\u03AE","exp":"\u0395\u03BC\u03C0\u03B5\u03B9\u03C1\u03AF\u03B1","age":"\u0397\u03BB\u03B9\u03BA\u03AF\u03B1","language":"\u0393\u03BB\u03CE\u03C3\u03C3\u03B1","nationality":"\u0395\u03B8\u03BD\u03B9\u03BA\u03CC\u03C4\u03B7\u03C4\u03B1","years_of_experience":"{{count}} \u03A7\u03C1\u03CC\u03BD\u03B9\u03B1","experience":"\u0395\u03BC\u03C0\u03B5\u03B9\u03C1\u03AF\u03B1","height":"\u038E\u03C8\u03BF\u03C2","gender":"Gender","height_cm":"{{count}} \u03B5\u03BA","years_old":"{{count}} \u03C7\u03C1\u03BF\u03BD\u03CE\u03BD","total_applicants":"\u03A5\u03C0\u03BF\u03C8\u03AE\u03C6\u03B9\u03BF\u03B9 ({{count}})","sort_by":"\u03A4\u03B1\u03BE\u03B9\u03BD\u03CC\u03BC\u03B7\u03C3\u03B7 \u03BA\u03B1\u03C4\u03AC:","rating":"\u0392\u03B1\u03B8\u03BC\u03BF\u03BB\u03BF\u03B3\u03AF\u03B1","see_more":"\u0394\u03B5\u03AF\u03C4\u03B5 \u03A0\u03B5\u03C1\u03B9\u03C3\u03C3\u03CC\u03C4\u03B5\u03C1\u03B1","confirmation":"\u0395\u03C0\u03B9\u03B2\u03B5\u03B2\u03B1\u03AF\u03C9\u03C3\u03B7","you_are_about_to_accept":"\u03A0\u03C1\u03CC\u03BA\u03B5\u03B9\u03C4\u03B1\u03B9 \u03BD\u03B1 \u03B1\u03C0\u03BF\u03B4\u03B5\u03C7\u03C4\u03B5\u03AF\u03C4\u03B5 \u03C4\u03BF\u03BD/\u03C4\u03B7\u03BD <1>{{name}}</1> \u03B3\u03B9\u03B1 \u03C4\u03B7\u03BD \u03B8\u03AD\u03C3\u03B7","you_are_about_to_reject":"\u03A0\u03C1\u03CC\u03BA\u03B5\u03B9\u03C4\u03B1\u03B9 \u03BD\u03B1 \u03B1\u03C0\u03BF\u03C1\u03C1\u03AF\u03C8\u03B5\u03C4\u03B5 \u03C4\u03BF\u03BD/\u03C4\u03B7\u03BD <1>{{name}}</1>. \u0398\u03B1 \u03B1\u03C6\u03B1\u03B9\u03C1\u03B5\u03B8\u03B5\u03AF \u03B1\u03C0\u03CC \u03C4\u03B7\u03BD \u03BB\u03AF\u03C3\u03C4\u03B1","confirm":"\u0395\u03C0\u03B9\u03B2\u03B5\u03B2\u03B1\u03AF\u03C9\u03C3\u03B7","cancel":"\u0391\u03BA\u03CD\u03C1\u03C9\u03C3\u03B7","jobID":"\u039A\u03C9\u03B4\u03B9\u03BA\u03CC\u03C2 \u0398\u03AD\u03C3\u03B7\u03C2","designation":"\u0395\u03B9\u03B4\u03B9\u03BA\u03CC\u03C4\u03B7\u03C4\u03B1","location":"\u03A4\u03BF\u03C0\u03BF\u03B8\u03B5\u03C3\u03AF\u03B1","required_quantity":"\u0391\u03C0\u03B1\u03B9\u03C4\u03BF\u03CD\u03BC\u03B5\u03BD\u03BF\u03C2 \u0391\u03C1\u03B9\u03B8\u03BC\u03CC\u03C2","fulfillment":"\u0395\u03BA\u03C0\u03BB\u03AE\u03C1\u03C9\u03C3\u03B7","fulfillmentRatio":"{{percent}}%","start_date":"\u0397\u03BC/\u03BD\u03AF\u03B1 \u0388\u03BD\u03B1\u03C1\u03BE\u03B7\u03C2","end_date":"\u0397\u03BC/\u03BD\u03AF\u03B1 \u039B\u03AE\u03BE\u03B7\u03C2","seniority_level":"\u0395\u03C0\u03AF\u03C0\u03B5\u03B4\u03BF \u0395\u03BC\u03C0\u03B5\u03B9\u03C1\u03AF\u03B1\u03C2","congratulation_exclamation":"\u03A3\u03C5\u03B3\u03C7\u03B1\u03C1\u03B7\u03C4\u03AE\u03C1\u03B9\u03B1!","you_have_assigned_staff":"\u0388\u03C7\u03B5\u03C4\u03B5 \u03B1\u03BD\u03B1\u03B8\u03AD\u03C3\u03B5\u03B9 \u03CC\u03BB\u03BF \u03C4\u03BF \u03B1\u03C0\u03B1\u03B9\u03C4\u03BF\u03CD\u03BC\u03B5\u03BD\u03BF \u03C0\u03C1\u03BF\u03C3\u03C9\u03C0\u03B9\u03BA\u03CC","done":"\u03A4\u03AD\u03BB\u03BF\u03C2","skill_match":"\u03A4\u03B1\u03AF\u03C1\u03B9\u03B1\u03C3\u03BC\u03B1 \u0394\u03B5\u03BE\u03B9\u03BF\u03C4\u03AE\u03C4\u03C9\u03BD","chief_title":"\u0388\u03C7\u03BF\u03C5\u03BC\u03B5 \u039A\u03AC\u03C4\u03B9 \u0393\u03B9\u03B1 \u0395\u03C3\u03AC\u03C2","chief_subtitle":"\u03A0\u03C1\u03BF\u03C3\u03B8\u03AD\u03C3\u03C4\u03B5 \u03AD\u03BD\u03B1\u03BD \u0391\u03C1\u03C7\u03B7\u03B3\u03CC OG \u03C3\u03C4\u03B7\u03BD \u03BF\u03BC\u03AC\u03B4\u03B1 \u03C3\u03B1\u03C2 - \u03B5\u03AF\u03BD\u03B1\u03B9 \u03B4\u03C9\u03C1\u03B5\u03AC\u03BD!","chief_og":"\u0391\u03C1\u03C7\u03B7\u03B3\u03CC\u03C2 OG","what_is_chief":"\u03A4\u03B9 \u03B5\u03AF\u03BD\u03B1\u03B9 \u03AD\u03BD\u03B1\u03C2 \u0391\u03C1\u03C7\u03B7\u03B3\u03CC\u03C2 OG;","chief_definition":"\u039F \u0391\u03C1\u03C7\u03B7\u03B3\u03CC\u03C2 OG \u03B5\u03AF\u03BD\u03B1\u03B9 \u03AD\u03BD\u03B1\u03C2 \u03B7\u03B3\u03AD\u03C4\u03B7\u03C2 \u03BF\u03BC\u03AC\u03B4\u03B1\u03C2, \u03B5\u03C0\u03B9\u03BB\u03B5\u03B3\u03BC\u03AD\u03BD\u03BF\u03C2 \u03C0\u03C1\u03BF\u03C3\u03B5\u03BA\u03C4\u03B9\u03BA\u03AC \u03B1\u03C0\u03CC \u03B5\u03BC\u03AC\u03C2 \u03B3\u03B9\u03B1 \u03BD\u03B1 \u03B2\u03BF\u03B7\u03B8\u03AC \u03C3\u03C4\u03B7 \u03B4\u03B9\u03B1\u03C7\u03B5\u03AF\u03C1\u03B9\u03C3\u03B7 \u03C4\u03C9\u03BD \u03BC\u03B5\u03B3\u03B1\u03BB\u03CD\u03C4\u03B5\u03C1\u03C9\u03BD \u03BF\u03BC\u03AC\u03B4\u03C9\u03BD \u03C4\u03B7\u03C2 Ogram. \u0393\u03B9\u03B1 \u03C0\u03B1\u03C1\u03AC\u03B4\u03B5\u03B9\u03B3\u03BC\u03B1, \u03B5\u03C0\u03B9\u03BB\u03CD\u03BF\u03BD\u03C4\u03B1\u03C2 \u03B4\u03B9\u03B1\u03C6\u03C9\u03BD\u03AF\u03B5\u03C2 \u03BA\u03B1\u03B9 \u03C3\u03C5\u03BD\u03C4\u03BF\u03BD\u03AF\u03B6\u03BF\u03BD\u03C4\u03B1\u03C2 \u03C4\u03B1 \u03BC\u03AD\u03BB\u03B7 \u03C4\u03B7\u03C2 \u03BF\u03BC\u03AC\u03B4\u03B1\u03C2 - \u03C7\u03C9\u03C1\u03AF\u03C2 \u03B5\u03C0\u03B9\u03C0\u03BB\u03AD\u03BF\u03BD \u03BA\u03CC\u03C3\u03C4\u03BF\u03C2 \u03B3\u03B9\u03B1 \u03B5\u03C3\u03AC\u03C2. \\n\u039A\u03B1\u03B9 \u03CC\u03BB\u03BF \u03B1\u03C5\u03C4\u03CC \u03B5\u03AF\u03BD\u03B1\u03B9 <1>\u03B5\u03BD\u03C4\u03B5\u03BB\u03CE\u03C2 \u03B4\u03C9\u03C1\u03B5\u03AC\u03BD \u03B3\u03B9\u03B1 \u03B5\u03C3\u03AC\u03C2.</1>","chief_button_label":"\u0391\u03BA\u03BF\u03CD\u03B3\u03B5\u03C4\u03B1\u03B9 \u03BA\u03B1\u03BB\u03CC","time":"\u03A7\u03C1\u03CC\u03BD\u03BF\u03C2","applicant_assigned":"\u039F \u03C5\u03C0\u03BF\u03C8\u03AE\u03C6\u03B9\u03BF\u03C2 \u03AD\u03C7\u03B5\u03B9 \u03B1\u03BD\u03B1\u03C4\u03B5\u03B8\u03B5\u03AF!","shortlisted":"\u039B\u03AF\u03C3\u03C4\u03B1 \u0395\u03C0\u03B9\u03BA\u03C1\u03B1\u03C4\u03AD\u03C3\u03C4\u03B5\u03C1\u03C9\u03BD"},"interview":{"applicants_finished":"\u0394\u03B5\u03BD \u03C5\u03C0\u03AC\u03C1\u03C7\u03BF\u03C5\u03BD \u03AC\u03BB\u03BB\u03B5\u03C2 \u03B1\u03C0\u03B1\u03BD\u03C4\u03AE\u03C3\u03B5\u03B9\u03C2 \u03C0\u03C1\u03BF\u03C2 \u03B1\u03BE\u03B9\u03BF\u03BB\u03CC\u03B3\u03B7\u03C3\u03B7","applicant_id":"ID#{{id}}","next_question":"\u0395\u03C0\u03CC\u03BC\u03B5\u03BD\u03B7 \u0395\u03C1\u03CE\u03C4\u03B7\u03C3\u03B7","accept":"\u0391\u03C0\u03BF\u03B4\u03BF\u03C7\u03AE","assigned":"\u0391\u03BD\u03B1\u03C4\u03AD\u03B8\u03B7\u03BA\u03B5","next_applicant":"\u0395\u03C0\u03CC\u03BC\u03B5\u03BD\u03BF\u03C2 \u03C5\u03C0\u03BF\u03C8\u03AE\u03C6\u03B9\u03BF\u03C2","question_short":"\u0395{{index}}:","rating_question_short":"\u0391\u03BE\u03B9\u03BF\u03BB\u03CC\u03B3\u03B7\u03C3\u03B7 \u0395{{index}}:","recommended_to_hire":"\u03A0\u03C1\u03BF\u03C4\u03B5\u03B9\u03BD\u03CC\u03BC\u03B5\u03BD\u03BF\u03B9 \u03B3\u03B9\u03B1 \u03A0\u03C1\u03CC\u03C3\u03BB\u03B7\u03C8\u03B7","overall_rating":"\u03A3\u03C5\u03BD\u03BF\u03BB\u03B9\u03BA\u03AD\u03C2 \u0391\u03BE\u03B9\u03BF\u03BB\u03BF\u03B3\u03AE\u03C3\u03B5\u03B9\u03C2","video_player_not_supported":"\u039F browser \u03C3\u03B1\u03C2 \u03B4\u03B5\u03BD \u03C5\u03C0\u03BF\u03C3\u03C4\u03B7\u03C1\u03AF\u03B6\u03B5\u03B9 \u03C4\u03B7\u03BD \u03B1\u03BD\u03B1\u03C0\u03B1\u03C1\u03B1\u03B3\u03C9\u03B3\u03AE \u03B2\u03AF\u03BD\u03C4\u03B5\u03BF. \u03A0\u03B1\u03C1\u03B1\u03BA\u03B1\u03BB\u03CE \u03B4\u03BF\u03BA\u03B9\u03BC\u03AC\u03C3\u03C4\u03B5 \u03BD\u03B1 \u03C4\u03BF\u03BD \u03B5\u03BD\u03B7\u03BC\u03B5\u03C1\u03CE\u03C3\u03B5\u03C4\u03B5 \u03AE \u03C7\u03C1\u03B7\u03C3\u03B9\u03BC\u03BF\u03C0\u03BF\u03B9\u03AE\u03C3\u03C4\u03B5 \u03AC\u03BB\u03BB\u03BF\u03BD browser.","submitting_rating":"\u03A5\u03C0\u03BF\u03B2\u03BF\u03BB\u03AE \u03B1\u03BE\u03B9\u03BF\u03BB\u03CC\u03B3\u03B7\u03C3\u03B7\u03C2...","rating_applied":"\u0397 \u03B1\u03BE\u03B9\u03BF\u03BB\u03CC\u03B3\u03B7\u03C3\u03B7 \u03B5\u03C6\u03B1\u03C1\u03BC\u03CC\u03C3\u03C4\u03B7\u03BA\u03B5!"},"complete_registration":{"title":"\u0395\u03B3\u03B3\u03C1\u03B1\u03C6\u03AE \u0395\u03C4\u03B1\u03B9\u03C1\u03B5\u03AF\u03B1\u03C2","legal_information":"\u039D\u03BF\u03BC\u03B9\u03BA\u03AD\u03C2 \u03A0\u03BB\u03B7\u03C1\u03BF\u03C6\u03BF\u03C1\u03AF\u03B5\u03C2","field_required":"\u0391\u03C5\u03C4\u03CC \u03C4\u03BF \u03C0\u03B5\u03B4\u03AF\u03BF \u03B5\u03AF\u03BD\u03B1\u03B9 \u03C5\u03C0\u03BF\u03C7\u03C1\u03B5\u03C9\u03C4\u03B9\u03BA\u03CC","yes":"\u039D\u03B1\u03B9","no":"\u038C\u03C7\u03B9","company_name":"\u038C\u03BD\u03BF\u03BC\u03B1 \u0395\u03C4\u03B1\u03B9\u03C1\u03B5\u03AF\u03B1\u03C2","trade_name_as_license":"\u0395\u03BC\u03C0\u03BF\u03C1\u03B9\u03BA\u03AE \u039F\u03BD\u03BF\u03BC\u03B1\u03C3\u03AF\u03B1 \u03C3\u03CD\u03BC\u03C6\u03C9\u03BD\u03B1 \u03BC\u03B5 \u03C4\u03B7\u03BD \u0386\u03B4\u03B5\u03B9\u03B1","trade_license_number":"\u0391\u03C1\u03B9\u03B8\u03BC\u03CC\u03C2 \u0395\u03BC\u03C0\u03BF\u03C1\u03B9\u03BA\u03AE\u03C2 \u0386\u03B4\u03B5\u03B9\u03B1\u03C2","legal_address":"\u0394\u03B9\u03B5\u03CD\u03B8\u03C5\u03BD\u03C3\u03B7 \u0395\u03C0\u03B9\u03C7\u03B5\u03AF\u03C1\u03B7\u03C3\u03B7\u03C2","po_box":"\u03A4\u03B1\u03C7\u03C5\u03B4\u03C1\u03BF\u03BC\u03B9\u03BA\u03CC\u03C2 \u039A\u03CE\u03B4\u03B9\u03BA\u03B1\u03C2","free_zone":"\u0395\u03BB\u03B5\u03CD\u03B8\u03B5\u03C1\u03B7 \u0396\u03CE\u03BD\u03B7","lpo_required":"\u0391\u03C0\u03B1\u03B9\u03C4\u03B5\u03AF\u03C4\u03B1\u03B9 \u03A3\u03CD\u03BC\u03B2\u03B1\u03C3\u03B7 \u03A0\u03B1\u03C1\u03BF\u03C7\u03AE\u03C2 \u03A5\u03C0\u03B7\u03C1\u03B5\u03C3\u03B9\u03CE\u03BD","region":"\u03A0\u03B5\u03C1\u03B9\u03BF\u03C7\u03AE","vat_certificate":"\u03A0\u03B9\u03C3\u03C4\u03BF\u03C0\u03BF\u03B9\u03B7\u03C4\u03B9\u03BA\u03CC \u03A6.\u03A0.\u0391.","upload_vat":"\u03A0\u03C1\u03BF\u03C3\u03B8\u03AD\u03C3\u03C4\u03B5 \u03C4\u03BF \u03A0\u03B9\u03C3\u03C4\u03BF\u03C0\u03BF\u03B9\u03B7\u03C4\u03B9\u03BA\u03CC \u03C4\u03BF\u03C5 \u03A6\u03A0\u0391","i_agree_with_terms":"\u03A3\u03C5\u03BC\u03C6\u03C9\u03BD\u03CE \u03BC\u03B5 \u03C4\u03B7\u03BD <1>\u03A0\u03BF\u03BB\u03B9\u03C4\u03B9\u03BA\u03AE \u0391\u03C0\u03BF\u03C1\u03C1\u03AE\u03C4\u03BF\u03C5</1>","i_agree_with_company_pp":"\u03A3\u03C5\u03BC\u03C6\u03C9\u03BD\u03CE \u03BC\u03B5 \u03C4\u03B7\u03BD <1>\u03A0\u03BF\u03BB\u03B9\u03C4\u03B9\u03BA\u03AE \u0391\u03C0\u03BF\u03C1\u03C1\u03AE\u03C4\u03BF\u03C5 \u0393\u03B9\u03B1 \u0395\u03C4\u03B1\u03B9\u03C1\u03AF\u03B5\u03C2</1>","i_agree_with_company_terms":"\u03A3\u03C5\u03BC\u03C6\u03C9\u03BD\u03CE \u03BC\u03B5 \u03C4\u03BF\u03C5\u03C2 <1>\u038C\u03C1\u03BF\u03C5\u03C2 \u03BA\u03B1\u03B9 \u03C4\u03B9\u03C2 \u03A0\u03C1\u03BF\u03CB\u03C0\u03BF\u03B8\u03AD\u03C3\u03B5\u03B9\u03C2</1>","continue":"\u03A3\u03C5\u03BD\u03AD\u03C7\u03B5\u03B9\u03B1","gr":{"company_name":"\u0395\u03C0\u03C9\u03BD\u03C5\u03BC\u03AF\u03B1 \u0395\u03C0\u03B9\u03C7\u03B5\u03AF\u03C1\u03B7\u03C3\u03B7\u03C2","address":"\u0394\u03B9\u03B5\u03CD\u03B8\u03C5\u03BD\u03C3\u03B7: \u039F\u03B4\u03CC\u03C2-\u0391\u03C1\u03B9\u03B8\u03BC\u03CC\u03C2-\u03A0\u03CC\u03BB\u03B7","tax_jurisdiction":"\u0394.\u039F.\u03A5.","registry_number":"\u0391\u03A1. \u0393\u0395\u039C\u0397","zip_code":"\u03A4\u03B1\u03C7\u03C5\u03B4\u03C1\u03BF\u03BC\u03B9\u03BA\u03CC\u03C2 \u039A\u03CE\u03B4\u03B9\u03BA\u03B1\u03C2","industry":"\u03A4\u03BF\u03BC\u03AD\u03B1\u03C2 \u0394\u03C1\u03B1\u03C3\u03C4\u03B7\u03C1\u03B9\u03CC\u03C4\u03B7\u03C4\u03B1\u03C2","industry_retail":"\u039B\u03B9\u03B1\u03BD\u03B5\u03BC\u03C0\u03CC\u03C1\u03B9\u03BF","industry_hotels":"\u039E\u03B5\u03BD\u03BF\u03B4\u03BF\u03C7\u03B5\u03B9\u03B1\u03BA\u03AC","industry_brc":"Bar/\u0395\u03C3\u03C4\u03B1\u03C4\u03CC\u03C1\u03B9\u03BF/\u039A\u03B1\u03C6\u03AD"},"document_selected":"T\u03B1 \u0388\u03B3\u03B3\u03C1\u03B1\u03C6\u03B1 \u0395\u03C0\u03B9\u03BB\u03AD\u03C7\u03B8\u03B7\u03BA\u03B1\u03BD","document_submitted":"\u03A4\u03B1 \u0388\u03B3\u03B3\u03C1\u03B1\u03C6\u03B1 \u03A5\u03C0\u03BF\u03B2\u03BB\u03AE\u03B8\u03B7\u03BA\u03B1\u03BD"},"change_schedule_options":{"all_dates_from_date":"\u038C\u03BB\u03B5\u03C2 \u03BF\u03B9 \u03B7\u03BC\u03AD\u03C1\u03B5\u03C2 \u03B1\u03C0\u03CC {{date}}","date_only":"\u039C\u03CC\u03BD\u03BF {{date}}","every_day_from_date":"\u039A\u03AC\u03B8\u03B5 {{day}} \u03B1\u03C0\u03CC {{date}}","custom":"\u03A0\u03C1\u03BF\u03C3\u03B1\u03C1\u03BC\u03BF\u03B3\u03AE"},"onboarding_complete":{"title":"\u03A3\u03B1\u03C2 \u03B5\u03C5\u03C7\u03B1\u03C1\u03B9\u03C3\u03C4\u03BF\u03CD\u03BC\u03B5!","description":"\u0388\u03C7\u03BF\u03C5\u03BC\u03B5 \u03BB\u03AC\u03B2\u03B5\u03B9 \u03C4\u03B9\u03C2 \u03C0\u03BB\u03B7\u03C1\u03BF\u03C6\u03BF\u03C1\u03AF\u03B5\u03C2 \u03C4\u03B7\u03C2 \u03B5\u03C4\u03B1\u03B9\u03C1\u03B5\u03AF\u03B1\u03C2 \u03C3\u03B1\u03C2.","done":"\u03A4\u03AD\u03BB\u03BF\u03C2"},"sign_sla":{"title":"\u03A5\u03C0\u03BF\u03B3\u03C1\u03AC\u03C8\u03C4\u03B5 \u03C4\u03B7 \u03A3\u03C5\u03BC\u03C6\u03C9\u03BD\u03AF\u03B1 \u03A0\u03B1\u03C1\u03BF\u03C7\u03AE\u03C2 \u03A5\u03C0\u03B7\u03C1\u03B5\u03C3\u03B9\u03CE\u03BD","i_agree":"\u03A3\u03C5\u03BC\u03C6\u03C9\u03BD\u03CE"},"home":{"hello_name":"\u0393\u03B5\u03B9\u03B1 \u03C3\u03B1\u03C2, <1>{{name}}</1>","hello":"\u0393\u03B5\u03B9\u03B1 \u03C3\u03B1\u03C2","shifts_attendance_review":"\u0388\u03BB\u03B5\u03B3\u03C7\u03BF\u03C2 \u03C0\u03B1\u03C1\u03BF\u03C5\u03C3\u03AF\u03B1\u03C2 \u03B2\u03B1\u03C1\u03B4\u03B9\u03CE\u03BD","orders_to_confirm":"\u03A0\u03B1\u03C1\u03B1\u03B3\u03B3\u03B5\u03BB\u03AF\u03B5\u03C2 \u03B3\u03B9\u03B1 \u0395\u03C0\u03B9\u03B2\u03B5\u03B2\u03B1\u03AF\u03C9\u03C3\u03B7","rating_requests":"\u0391\u03B9\u03C4\u03AE\u03BC\u03B1\u03C4\u03B1 \u03B1\u03BE\u03B9\u03BF\u03BB\u03CC\u03B3\u03B7\u03C3\u03B7\u03C2","applicant_review":"\u0388\u03BB\u03B5\u03B3\u03C7\u03BF\u03C2 \u03C5\u03C0\u03BF\u03C8\u03B7\u03C6\u03AF\u03C9\u03BD","pending_payments":"\u0395\u03BA\u03BA\u03C1\u03B5\u03BC\u03B5\u03AF\u03C2 \u03A0\u03BB\u03B7\u03C1\u03C9\u03BC\u03AD\u03C2","error_failed_to_load_statistics":"\u0391\u03C0\u03BF\u03C4\u03C5\u03C7\u03AF\u03B1 \u03C6\u03CC\u03C1\u03C4\u03C9\u03C3\u03B7\u03C2 \u03C3\u03C4\u03B1\u03C4\u03B9\u03C3\u03C4\u03B9\u03BA\u03CE\u03BD","error_failed_to_load_home_page":"\u0391\u03C0\u03BF\u03C4\u03C5\u03C7\u03AF\u03B1 \u03C6\u03CC\u03C1\u03C4\u03C9\u03C3\u03B7\u03C2 \u03B1\u03C1\u03C7\u03B9\u03BA\u03AE\u03C2 \u03C3\u03B5\u03BB\u03AF\u03B4\u03B1\u03C2","coming_soon":{"hello":"\u0393\u03B5\u03B9\u03B1 \u03C3\u03B1\u03C2","we_are_coming_soon":"\u03A3\u03CD\u03BD\u03C4\u03BF\u03BC\u03B1 \u039A\u03BF\u03BD\u03C4\u03AC \u03A3\u03B1\u03C2","prepare_for_launch":"\u03A4\u03CE\u03C1\u03B1 \u03BA\u03B1\u03B9 \u03C3\u03C4\u03B7\u03BD \u0395\u03BB\u03BB\u03AC\u03B4\u03B1! \u0397 \u03C0\u03C1\u03BF\u03B5\u03C4\u03BF\u03B9\u03BC\u03B1\u03C3\u03AF\u03B1 \u03AD\u03C7\u03B5\u03B9 \u03AE\u03B4\u03B7 \u03BE\u03B5\u03BA\u03B9\u03BD\u03AE\u03C3\u03B5\u03B9.","on_demand_staff":"\u03A0\u03C1\u03BF\u03C3\u03C9\u03C0\u03B9\u03BA\u03CC \u039A\u03B1\u03C4\' \u0391\u03C0\u03B1\u03AF\u03C4\u03B7\u03C3\u03B7","find_workers":"\u0392\u03C1\u03B5\u03AF\u03C4\u03B5 \u03BA\u03B1\u03B9 \u03C0\u03C1\u03BF\u03C3\u03BB\u03AC\u03B2\u03B5\u03C4\u03B5 \u03C4\u03BF \u03BA\u03B1\u03C4\u03AC\u03BB\u03BB\u03B7\u03BB\u03BF \u03C0\u03C1\u03BF\u03C3\u03C9\u03C0\u03B9\u03BA\u03CC \u03C3\u03C4o \u03C0\u03B9\u03BF \u03B1\u03C0\u03BB\u03CC \u03BA\u03B1\u03B9 \u03B5\u03BE\u03B5\u03B9\u03B4\u03B9\u03BA\u03B5\u03C5\u03BC\u03AD\u03BD\u03BF app.","short_term_contracts":"\u0392\u03C1\u03B1\u03C7\u03C5\u03C0\u03C1\u03CC\u03B8\u03B5\u03C3\u03BC\u03B1 \u03A3\u03C5\u03BC\u03B2\u03CC\u03BB\u03B1\u03B9\u03B1","post_jobs":"\u0394\u03B7\u03BC\u03BF\u03C3\u03B9\u03B5\u03CD\u03C3\u03C4\u03B5 \u03C0\u03C1\u03BF\u03C3\u03C9\u03C1\u03B9\u03BD\u03AD\u03C2 \u03AE \u03BC\u03B1\u03BA\u03C1\u03BF\u03C7\u03C1\u03CC\u03BD\u03B9\u03B5\u03C2 \u03B8\u03AD\u03C3\u03B5\u03B9\u03C2 \u03B5\u03C1\u03B3\u03B1\u03C3\u03AF\u03B1\u03C2 \u03BA\u03B1\u03B9 \u03BA\u03B1\u03BB\u03CD\u03C8\u03C4\u03B5 \u03C4\u03B7\u03BD \u03B5\u03C0\u03CC\u03BC\u03B5\u03BD\u03B7 \u03B2\u03AC\u03C1\u03B4\u03B9\u03AC \u03C3\u03B1\u03C2 \u03B5\u03BD\u03C4\u03CC\u03C2 48 \u03C9\u03C1\u03CE\u03BD \u03B1\u03C0\u03CC \u03C4\u03B7\u03BD \u03B5\u03B3\u03B3\u03C1\u03B1\u03C6\u03AE \u03C3\u03B1\u03C2.","incredible_savings":"\u0395\u03BE\u03BF\u03B9\u03BA\u03BF\u03BD\u03BF\u03BC\u03AE\u03C3\u03C4\u03B5 \u03A7\u03C1\u03AE\u03BC\u03B1\u03C4\u03B1","save_money":"\u03A0\u03BB\u03B7\u03C1\u03CE\u03BD\u03B5\u03C4\u03B5 \u03BC\u03CC\u03BD\u03BF \u03C4\u03B9\u03C2 \u03CE\u03C1\u03B5\u03C2 \u03B5\u03C1\u03B3\u03B1\u03C3\u03AF\u03B1\u03C2"}},"interview_popup":{"title":"\u03A3\u03C5\u03BD\u03AD\u03BD\u03C4\u03B5\u03C5\u03BE\u03B7 \u03BC\u03AD\u03C3\u03C9 \u0392\u03AF\u03BD\u03C4\u03B5\u03BF","description":"\u0395\u03BD\u03C3\u03C9\u03BC\u03B1\u03C4\u03CE\u03C3\u03C4\u03B5 \u03C4\u03B9\u03C2 \u03C3\u03C5\u03BD\u03B5\u03BD\u03C4\u03B5\u03CD\u03BE\u03B5\u03B9\u03C2 \u03BC\u03AD\u03C3\u03C9 \u03B2\u03AF\u03BD\u03C4\u03B5\u03BF \u03C3\u03C4\u03B9\u03C2 \u03C0\u03C1\u03BF\u03C3\u03C0\u03AC\u03B8\u03B5\u03B9\u03B5\u03C2 \u03C0\u03C1\u03CC\u03C3\u03BB\u03B7\u03C8\u03B7\u03C2 \u03C3\u03B1\u03C2 \u03B3\u03B9\u03B1 \u03BD\u03B1 \u03B5\u03BE\u03BF\u03B9\u03BA\u03BF\u03BD\u03BF\u03BC\u03AE\u03C3\u03B5\u03C4\u03B5 \u03CE\u03C1\u03B5\u03C2 \u03B3\u03B9\u03B1 \u03C4\u03B7\u03BD \u03BF\u03BC\u03AC\u03B4\u03B1 \u03C3\u03B1\u03C2 \u03BA\u03B1\u03B9 \u03BD\u03B1 \u03B5\u03C0\u03B9\u03C4\u03B1\u03C7\u03CD\u03BD\u03B5\u03C4\u03B5 \u03C4\u03B9\u03C2 \u03B4\u03B9\u03B1\u03B4\u03B9\u03BA\u03B1\u03C3\u03AF\u03B5\u03C2.","create_order_button":"\u0394\u03B7\u03BC\u03B9\u03BF\u03C5\u03C1\u03B3\u03AE\u03C3\u03C4\u03B5 \u03BC\u03B9\u03B1 \u03A0\u03B1\u03C1\u03B1\u03B3\u03B3\u03B5\u03BB\u03AF\u03B1"},"sidebar":{"company":"\u0395\u03C4\u03B1\u03B9\u03C1\u03B5\u03AF\u03B1","error_failed_to_load_sidebar":"\u0391\u03C0\u03BF\u03C4\u03C5\u03C7\u03AF\u03B1 \u03C6\u03CC\u03C1\u03C4\u03C9\u03C3\u03B7\u03C2 \u03C0\u03BB\u03B1\u03CA\u03BD\u03AE\u03C2 \u03BC\u03C0\u03AC\u03C1\u03B1\u03C2. \u03A0\u03C1\u03BF\u03C3\u03C0\u03B1\u03B8\u03AE\u03C3\u03C4\u03B5 \u03BE\u03B1\u03BD\u03AC","create_order":"\u0394\u03B7\u03BC\u03B9\u03BF\u03C5\u03C1\u03B3\u03AF\u03B1 \u03A0\u03B1\u03C1\u03B1\u03B3\u03B3\u03B5\u03BB\u03AF\u03B1\u03C2","register_corporate":"\u0395\u03B3\u03B3\u03C1\u03B1\u03C6\u03AE \u0395\u03C0\u03B9\u03C7\u03B5\u03AF\u03C1\u03B7\u03C3\u03B7\u03C2","account":"\u039B\u03BF\u03B3\u03B1\u03C1\u03B9\u03B1\u03C3\u03BC\u03CC\u03C2","manage_locations":"\u0394\u03B9\u03B1\u03C7\u03B5\u03AF\u03C1\u03B7\u03C3\u03B7 \u03A4\u03BF\u03C0\u03BF\u03B8\u03B5\u03C3\u03B9\u03CE\u03BD","users":"\u03A7\u03C1\u03AE\u03C3\u03C4\u03B5\u03C2","knowledge_center":"\u039A\u03AD\u03BD\u03C4\u03C1\u03BF \u0393\u03BD\u03CE\u03C3\u03B7\u03C2","home":"\u0391\u03C1\u03C7\u03B9\u03BA\u03AE","all_jobs":"\u038C\u03BB\u03B5\u03C2 \u03BF\u03B9 \u0398\u03AD\u03C3\u03B5\u03B9\u03C2 \u0395\u03C1\u03B3\u03B1\u03C3\u03AF\u03B1\u03C2","attendance_review":"\u0391\u03BD\u03B1\u03C3\u03BA\u03CC\u03C0\u03B7\u03C3\u03B7 \u03A0\u03B1\u03C1\u03BF\u03C5\u03C3\u03B9\u03CE\u03BD","orders":"\u03A0\u03B1\u03C1\u03B1\u03B3\u03B3\u03B5\u03BB\u03AF\u03B5\u03C2","applicants_review":"\u0388\u03BB\u03B5\u03B3\u03C7\u03BF\u03C2 \u03A5\u03C0\u03BF\u03C8\u03B7\u03C6\u03AF\u03C9\u03BD","rating_requests":"\u0391\u03B9\u03C4\u03AE\u03BC\u03B1\u03C4\u03B1 \u03B1\u03BE\u03B9\u03BF\u03BB\u03CC\u03B3\u03B7\u03C3\u03B7\u03C2","invoices":"\u03A4\u03B9\u03BC\u03BF\u03BB\u03CC\u03B3\u03B9\u03B1","payments":"\u03A0\u03BB\u03B7\u03C1\u03C9\u03BC\u03AD\u03C2","payment_methods":"\u03A4\u03C1\u03CC\u03C0\u03BF\u03B9 \u03C0\u03BB\u03B7\u03C1\u03C9\u03BC\u03AE\u03C2","billing":"\u03A4\u03B9\u03BC\u03BF\u03BB\u03CC\u03B3\u03B7\u03C3\u03B7","orders_uppercase":"\u03A0\u03B1\u03C1\u03B1\u03B3\u03B3\u03B5\u03BB\u03AF\u03B5\u03C2","disputes":"Disputes"},"all_jobs":{"title":"\u0397\u03BC\u03B5\u03C1\u03BF\u03BB\u03CC\u03B3\u03B9\u03BF","day":"\u0397\u03BC\u03AD\u03C1\u03B1","3_days":"3 \u039C\u03AD\u03C1\u03B5\u03C2","week":"\u0395\u03B2\u03B4\u03BF\u03BC\u03AC\u03B4\u03B1","month":"\u039C\u03AE\u03BD\u03B1\u03C2","percent_filled":"{{count}}% \u0393\u03B5\u03BC\u03AC\u03C4\u03BF","start":"\u0388\u03BD\u03B1\u03C1\u03BE\u03B7","end":"\u039B\u03AE\u03BE\u03B7","manage_shift":"\u0394\u03B9\u03B1\u03C7\u03B5\u03AF\u03C1\u03B9\u03C3\u03B7 \u03B2\u03AC\u03C1\u03B4\u03B9\u03B1\u03C2","unsaved_changes":"\u0388\u03C7\u03B5\u03C4\u03B5 \u03BC\u03B7 \u03B1\u03C0\u03BF\u03B8\u03B7\u03BA\u03B5\u03C5\u03BC\u03AD\u03BD\u03B5\u03C2 \u03B1\u03BB\u03BB\u03B1\u03B3\u03AD\u03C2. \u0395\u03AF\u03C3\u03C4\u03B5 \u03C3\u03AF\u03B3\u03BF\u03C5\u03C1\u03BF\u03B9 \u03CC\u03C4\u03B9 \u03B8\u03AD\u03BB\u03B5\u03C4\u03B5 \u03BD\u03B1 \u03B1\u03C6\u03AE\u03C3\u03B5\u03C4\u03B5 \u03B1\u03C5\u03C4\u03AE \u03C4\u03B7 \u03C3\u03B5\u03BB\u03AF\u03B4\u03B1;","shift_canceled":"\u0397 \u03B2\u03AC\u03C1\u03B4\u03B9\u03B1 \u03AD\u03C7\u03B5\u03B9 \u03B1\u03BA\u03C5\u03C1\u03C9\u03B8\u03B5\u03AF","og_checked_in":"\u039F Ogrammer \u03AD\u03C7\u03B5\u03B9 \u03BE\u03B5\u03BA\u03B9\u03BD\u03AE\u03C3\u03B5\u03B9 \u03C4\u03B7\u03BD \u03B2\u03AC\u03C1\u03B4\u03B9\u03B1","og_checked_out":"\u039F Ogrammer \u03AD\u03C7\u03B5\u03B9 \u03BF\u03BB\u03BF\u03BA\u03BB\u03B7\u03C1\u03CE\u03C3\u03B5\u03B9 \u03C4\u03B7\u03BD \u03B2\u03AC\u03C1\u03B4\u03B9\u03B1","assigned_to":"\u0391\u03BD\u03B1\u03C4\u03AD\u03B8\u03B7\u03BA\u03B5 \u03C3\u03C4\u03BF\u03BD/\u03C3\u03C4\u03B7\u03BD","no_zero":"","no_one":"","no_two":"","no_few":"","no_many":"","no_other":"","empty_slot":"{{count}} \u039A\u03B5\u03BD\u03AE \u03B8\u03AD\u03C3\u03B7","select_OG":"\u0395\u03C0\u03B9\u03BB\u03AD\u03BE\u03C4\u03B5 OG","cancel":"\u0391\u03BA\u03CD\u03C1\u03C9\u03C3\u03B7","save_changes_count":"\u0391\u03C0\u03BF\u03B8\u03AE\u03BA\u03B5\u03C5\u03C3\u03B7 \u0391\u03BB\u03BB\u03B1\u03B3\u03CE\u03BD ({{count}})","update_success":"\u0395\u03C0\u03B9\u03C4\u03C5\u03C7\u03AE\u03C2 \u03B5\u03BD\u03B7\u03BC\u03AD\u03C1\u03C9\u03C3\u03B7","accepted":"\u0388\u03B3\u03B9\u03BD\u03B1\u03BD \u0391\u03C0\u03BF\u03B4\u03B5\u03BA\u03C4\u03AD\u03C2","canceled":"\u0391\u03BA\u03C5\u03C1\u03CE\u03B8\u03B7\u03BA\u03B1\u03BD","completed":"\u039F\u03BB\u03BF\u03BA\u03BB\u03B7\u03C1\u03CE\u03B8\u03B7\u03BA\u03B1\u03BD","irrelevant":"\u039C\u03B7 \u03C3\u03C7\u03B5\u03C4\u03B9\u03BA\u03CC","pending":"\u03A3\u03B5 \u03B5\u03BA\u03BA\u03C1\u03B5\u03BC\u03CC\u03C4\u03B7\u03C4\u03B1","started":"\u0388\u03C7\u03BF\u03C5\u03BD \u039E\u03B5\u03BA\u03B9\u03BD\u03AE\u03C3\u03B5\u03B9","extension_announcement":"\u039C\u03C0\u03BF\u03C1\u03B5\u03AF\u03C4\u03B5 \u03C0\u03BB\u03AD\u03BF\u03BD \u03BD\u03B1 \u03B5\u03C0\u03B5\u03BA\u03C4\u03B5\u03AF\u03BD\u03B5\u03C4\u03B5 \u03C4\u03B9\u03C2 \u03C0\u03B1\u03C1\u03B1\u03B3\u03B3\u03B5\u03BB\u03AF\u03B5\u03C2 \u03C3\u03B1\u03C2 \u03B1\u03C0\u03B5\u03C5\u03B8\u03B5\u03AF\u03B1\u03C2 \u03B1\u03C0\u03CC \u03B1\u03C5\u03C4\u03AE \u03C4\u03B7 \u03C3\u03B5\u03BB\u03AF\u03B4\u03B1. \u039A\u03AC\u03BD\u03C4\u03B5 \u03BA\u03BB\u03B9\u03BA \u03C3\u03C4\u03B9\u03C2 \u03C4\u03C1\u03B5\u03B9\u03C2 \u03C4\u03B5\u03BB\u03B5\u03AF\u03B5\u03C2 \u03B4\u03AF\u03C0\u03BB\u03B1 \u03C3\u03C4\u03B7\u03BD \u03C0\u03B1\u03C1\u03B1\u03B3\u03B3\u03B5\u03BB\u03AF\u03B1 \u03BA\u03B1\u03B9 \u03B5\u03C0\u03B9\u03BB\u03AD\u03BE\u03C4\u03B5 \\"\u0395\u03C0\u03AD\u03BA\u03C4\u03B1\u03C3\u03B7 \u03A0\u03B1\u03C1\u03B1\u03B3\u03B3\u03B5\u03BB\u03AF\u03B1\u03C2\\"","current_week":"\u03A4\u03C1\u03AD\u03C7\u03BF\u03C5\u03C3\u03B1 \u0395\u03B2\u03B4\u03BF\u03BC\u03AC\u03B4\u03B1","filter_location":"Filter Location","filter_designation":"Filter Designation","sps_required":"{{amount}} OGs required","bulk_apply":"Bulk Apply","apply_to_sp_only":"Apply to {{spName}} only","select_ogs_to_apply":"Select OGs to apply changes","copy_changes_to_more_ogs_on":"Copy changes to more OGs on"},"job_shifts":{"title":"\u0392\u03AC\u03C1\u03B4\u03B9\u03B5\u03C2","change_schedule":"\u0391\u03BB\u03BB\u03B1\u03B3\u03AE \u03C0\u03C1\u03BF\u03B3\u03C1\u03AC\u03BC\u03BC\u03B1\u03C4\u03BF\u03C2","cancel_shift":"\u0391\u03BA\u03CD\u03C1\u03C9\u03C3\u03B7 \u03B2\u03AC\u03C1\u03B4\u03B9\u03B1\u03C2","confirmation_question":"\u03A0\u03C1\u03CC\u03BA\u03B5\u03B9\u03C4\u03B1\u03B9 \u03BD\u03B1 \u03B1\u03BA\u03C5\u03C1\u03CE\u03C3\u03B5\u03C4\u03B5 \u03C4\u03B7\u03BD \u03B5\u03C1\u03B3\u03B1\u03C3\u03AF\u03B1 \u03B3\u03B9\u03B1 \u03CC\u03BB\u03BF\u03C5\u03C2 \u03C4\u03BF\u03C5\u03C2 Ogrammers, \u03B5\u03AF\u03C3\u03C4\u03B5 \u03C3\u03AF\u03B3\u03BF\u03C5\u03C1\u03BF\u03B9 \u03B3\u03B9\u03B1 \u03B1\u03C5\u03C4\u03CC;","i_have_capacity":"\u0388\u03C7\u03C9 \u03B4\u03C5\u03BD\u03B1\u03C4\u03CC\u03C4\u03B7\u03C4\u03B1","select_reason":"\u0395\u03C0\u03B9\u03BB\u03AD\u03BE\u03C4\u03B5 \u0391\u03B9\u03C4\u03B9\u03BF\u03BB\u03BF\u03B3\u03AF\u03B1","other":"\u0386\u03BB\u03BB\u03BF","comment_here":"\u03A3\u03C7\u03BF\u03BB\u03B9\u03AC\u03C3\u03C4\u03B5 \u03B5\u03B4\u03CE (\u03A0\u03C1\u03BF\u03B1\u03B9\u03C1\u03B5\u03C4\u03B9\u03BA\u03CC)","cancel_job":"\u0391\u03BA\u03C5\u03C1\u03CE\u03C3\u03C4\u03B5 \u03C4\u03B7\u03BD \u03B5\u03C1\u03B3\u03B1\u03C3\u03AF\u03B1","cancel":"\u0391\u03BA\u03CD\u03C1\u03C9\u03C3\u03B7","set_start_time":"\u03A1\u03C5\u03B8\u03BC\u03AF\u03C3\u03C4\u03B5 \u03C4\u03B7\u03BD \u03CE\u03C1\u03B1 \u03AD\u03BD\u03B1\u03C1\u03BE\u03B7\u03C2","set_end_time":"\u03A1\u03C5\u03B8\u03BC\u03AF\u03C3\u03C4\u03B5 \u03C4\u03B7\u03BD \u03CE\u03C1\u03B1 \u03BB\u03AE\u03BE\u03B7\u03C2","start_time":"\u038F\u03C1\u03B1 \u0388\u03BD\u03B1\u03C1\u03BE\u03B7\u03C2","end_time":"\u038F\u03C1\u03B1 \u039B\u03AE\u03BE\u03B7\u03C2","apply_schedule":"\u0395\u03C6\u03B1\u03C1\u03BC\u03BF\u03B3\u03AE \u03A0\u03C1\u03BF\u03B3\u03C1\u03AC\u03BC\u03BC\u03B1\u03C4\u03BF\u03C2","apply_on_days":"\u0395\u03C6\u03B1\u03C1\u03BC\u03BF\u03B3\u03AE \u03C3\u03B5 \u03C3\u03C5\u03B3\u03BA\u03B5\u03BA\u03C1\u03B9\u03BC\u03AD\u03BD\u03B5\u03C2 \u03B7\u03BC\u03AD\u03C1\u03B5\u03C2 \u03B1\u03C0\u03CC {{date}}","confirm":"\u0395\u03C0\u03B9\u03B2\u03B5\u03B2\u03B1\u03AF\u03C9\u03C3\u03B7","pending":"\u03A3\u03B5 \u03B5\u03BA\u03BA\u03C1\u03B5\u03BC\u03CC\u03C4\u03B7\u03C4\u03B1","started":"\u0388\u03C7\u03BF\u03C5\u03BD \u03BE\u03B5\u03BA\u03B9\u03BD\u03AE\u03C3\u03B5\u03B9","check_in":"\u0388\u03BD\u03B1\u03C1\u03BE\u03B7 \u03B2\u03AC\u03C1\u03B4\u03B9\u03B1\u03C2","check_out":"\u039B\u03AE\u03BE\u03B7 \u03B2\u03AC\u03C1\u03B4\u03B9\u03B1\u03C2","extend_shift":"\u0395\u03C0\u03AD\u03BA\u03C4\u03B1\u03C3\u03B7 \u0392\u03AC\u03C1\u03B4\u03B9\u03B1\u03C2","call":"\u039A\u03BB\u03AE\u03C3\u03B7","whatsapp":"WhatsApp","remove_from_favourites":"\u0391\u03C6\u03B1\u03AF\u03C1\u03B5\u03C3\u03B7 \u03B1\u03C0\u03CC \u03C4\u03B1 \u03B1\u03B3\u03B1\u03C0\u03B7\u03BC\u03AD\u03BD\u03B1","add_to_favourites":"\u03A0\u03C1\u03BF\u03C3\u03B8\u03AE\u03BA\u03B7 \u03C3\u03C4\u03B1 \u03B1\u03B3\u03B1\u03C0\u03B7\u03BC\u03AD\u03BD\u03B1","extra_time":"\u0395\u03C0\u03B9\u03C0\u03BB\u03AD\u03BF\u03BD \u03A7\u03C1\u03CC\u03BD\u03BF\u03C2","percent_filled":"{{percent}}% \u0393\u03B5\u03BC\u03AC\u03C4\u03BF","for_the_job":"\u03B3\u03B9\u03B1 \u03C4\u03B7\u03BD \u03B8\u03AD\u03C3\u03B7","cancel_all_following_shifts":"\u0391\u03BA\u03CD\u03C1\u03C9\u03C3\u03B7 \u03CC\u03BB\u03C9\u03BD \u03C4\u03C9\u03BD \u03B5\u03C0\u03CC\u03BC\u03B5\u03BD\u03C9\u03BD \u03B2\u03B1\u03C1\u03B4\u03B9\u03CE\u03BD","block_ogrammer":"\u0391\u03C0\u03BF\u03BA\u03BB\u03B5\u03B9\u03C3\u03BC\u03CC\u03C2 Ogrammer"},"location_list":{"title":"\u03A4\u03BF\u03C0\u03BF\u03B8\u03B5\u03C3\u03AF\u03B5\u03C2","add_location":"\u03A0\u03C1\u03BF\u03C3\u03B8\u03AE\u03BA\u03B7 \u03A4\u03BF\u03C0\u03BF\u03B8\u03B5\u03C3\u03AF\u03B1\u03C2","location_required":"\u03A4\u03BF \u03CC\u03BD\u03BF\u03BC\u03B1 \u03C4\u03B7\u03C2 \u03C4\u03BF\u03C0\u03BF\u03B8\u03B5\u03C3\u03AF\u03B1\u03C2 \u03B5\u03AF\u03BD\u03B1\u03B9 \u03C5\u03C0\u03BF\u03C7\u03C1\u03B5\u03C9\u03C4\u03B9\u03BA\u03CC","address_required":"\u0397 \u03B4\u03B9\u03B5\u03CD\u03B8\u03C5\u03BD\u03C3\u03B7 \u03B5\u03AF\u03BD\u03B1\u03B9 \u03C5\u03C0\u03BF\u03C7\u03C1\u03B5\u03C9\u03C4\u03B9\u03BA\u03AE","address_details_required":"\u0391\u03C0\u03B1\u03B9\u03C4\u03BF\u03CD\u03BD\u03C4\u03B1\u03B9 \u03C0\u03C1\u03CC\u03C3\u03B8\u03B5\u03C4\u03B5\u03C2 \u03C0\u03BB\u03B7\u03C1\u03BF\u03C6\u03BF\u03C1\u03AF\u03B5\u03C2 \u03B4\u03B9\u03B5\u03CD\u03B8\u03C5\u03BD\u03C3\u03B7\u03C2","region_required":"\u0397 \u03C0\u03B5\u03C1\u03B9\u03BF\u03C7\u03AE \u03B5\u03AF\u03BD\u03B1\u03B9 \u03C5\u03C0\u03BF\u03C7\u03C1\u03B5\u03C9\u03C4\u03B9\u03BA\u03AE","location_name":"\u038C\u03BD\u03BF\u03BC\u03B1 \u03C4\u03BF\u03C0\u03BF\u03B8\u03B5\u03C3\u03AF\u03B1\u03C2","region":"\u03A0\u03B5\u03C1\u03B9\u03BF\u03C7\u03AE","location_address":"\u0394\u03B9\u03B5\u03CD\u03B8\u03C5\u03BD\u03C3\u03B7 \u03A4\u03BF\u03C0\u03BF\u03B8\u03B5\u03C3\u03AF\u03B1\u03C2","address_details":"\u0395\u03C0\u03B9\u03C0\u03BB\u03AD\u03BF\u03BD \u03C0\u03BB\u03B7\u03C1\u03BF\u03C6\u03BF\u03C1\u03AF\u03B5\u03C2 \u03B4\u03B9\u03B5\u03CD\u03B8\u03C5\u03BD\u03C3\u03B7\u03C2","upload_location_image":"\u0391\u03BD\u03B5\u03B2\u03AC\u03C3\u03C4\u03B5 \u03C6\u03C9\u03C4\u03BF\u03B3\u03C1\u03B1\u03C6\u03AF\u03B1 \u03C4\u03B7\u03C2 \u03C4\u03BF\u03C0\u03BF\u03B8\u03B5\u03C3\u03AF\u03B1\u03C2 (\u03A0\u03C1\u03BF\u03B1\u03B9\u03C1\u03B5\u03C4\u03B9\u03BA\u03CC)","save":"\u0391\u03C0\u03BF\u03B8\u03AE\u03BA\u03B5\u03C5\u03C3\u03B7","delete":"\u0394\u03B9\u03B1\u03B3\u03C1\u03B1\u03C6\u03AE","check_in_restrictions_title":"\u03A0\u03B5\u03C1\u03B9\u03BF\u03C1\u03B9\u03C3\u03BC\u03BF\u03AF Check-in","large_area":"\u03A0\u03BF\u03BB\u03C5\u03BA\u03B1\u03C4\u03AC\u03C3\u03C4\u03B7\u03BC\u03B1 \u03AE \u03A3\u03C5\u03BD\u03BF\u03B9\u03BA\u03B9\u03B1\u03BA\u03AE \u03A4\u03BF\u03C0\u03BF\u03B8\u03B5\u03C3\u03AF\u03B1","no_restrictions":"\u0391\u03C0\u03B5\u03BD\u03B5\u03C1\u03B3\u03BF\u03C0\u03BF\u03AF\u03B7\u03C3\u03B7 \u03C0\u03B5\u03C1\u03B9\u03BF\u03C1\u03B9\u03C3\u03BC\u03BF\u03CD \u03B3\u03B5\u03C9\u03B5\u03BD\u03C4\u03BF\u03C0\u03B9\u03C3\u03BC\u03BF\u03CD","additional_details":"\u0395\u03C0\u03B9\u03C0\u03C1\u03CC\u03C3\u03B8\u03B5\u03C4\u03B5\u03C2 \u03A0\u03BB\u03B7\u03C1\u03BF\u03C6\u03BF\u03C1\u03AF\u03B5\u03C2","restrictions_info_modal_text":"\u0395\u03BD\u03B5\u03C1\u03B3\u03BF\u03C0\u03BF\u03B9\u03AE\u03C3\u03C4\u03B5 \u03C4\u03B7\u03BD \u03B5\u03C0\u03B9\u03BB\u03BF\u03B3\u03AE \u201C<strong> \u03A0\u03BF\u03BB\u03C5\u03BA\u03B1\u03C4\u03AC\u03C3\u03C4\u03B7\u03BC\u03B1 \u03AE \u03A3\u03C5\u03BD\u03BF\u03B9\u03BA\u03B9\u03B1\u03BA\u03AE \u03A4\u03BF\u03C0\u03BF\u03B8\u03B5\u03C3\u03AF\u03B1</strong>\u201C, \u03B5\u03AC\u03BD \u03C4\u03BF \u03C0\u03C1\u03BF\u03C3\u03C9\u03C0\u03B9\u03BA\u03CC \u03C0\u03C1\u03AD\u03C0\u03B5\u03B9 \u03BD\u03B1 \u03B5\u03C1\u03B3\u03B1\u03C3\u03C4\u03B5\u03AF \u03C3\u03B5 \u03C0\u03BF\u03BB\u03CD \u03BC\u03B5\u03B3\u03AC\u03BB\u03B5\u03C2 \u03B5\u03B3\u03BA\u03B1\u03C4\u03B1\u03C3\u03C4\u03AC\u03C3\u03B5\u03B9\u03C2. \u0398\u03B1 \u03C0\u03C1\u03BF\u03C3\u03B1\u03C1\u03BC\u03CC\u03C3\u03BF\u03C5\u03BC\u03B5 \u03B1\u03BD\u03AC\u03BB\u03BF\u03B3\u03B1 \u03C4\u03B7\u03BD \u03B1\u03BA\u03C4\u03AF\u03BD\u03B1 \u03C4\u03B7\u03C2 \u03B6\u03CE\u03BD\u03B7\u03C2 check-in \u03BA\u03B1\u03B9 check-out.<br/><br/>\u0397 \u03B5\u03C0\u03B9\u03BB\u03BF\u03B3\u03AE \u201C<strong>\u0391\u03C0\u03B5\u03BD\u03B5\u03C1\u03B3\u03BF\u03C0\u03BF\u03AF\u03B7\u03C3\u03B7 \u03C0\u03B5\u03C1\u03B9\u03BF\u03C1\u03B9\u03C3\u03BC\u03BF\u03CD \u03B3\u03B5\u03C9\u03B3\u03C1\u03B1\u03C6\u03B9\u03BA\u03AE\u03C2 \u03C4\u03BF\u03C0\u03BF\u03B8\u03B5\u03C3\u03AF\u03B1\u03C2</strong>\u201C \u03B8\u03B1 \u03BA\u03B1\u03C4\u03B1\u03C1\u03B3\u03AE\u03C3\u03B5\u03B9 \u03C4\u03BF\u03C5\u03C2 \u03B3\u03B5\u03C9\u03B3\u03C1\u03B1\u03C6\u03B9\u03BA\u03BF\u03CD\u03C2 \u03C0\u03B5\u03C1\u03B9\u03BF\u03C1\u03B9\u03C3\u03BC\u03BF\u03CD\u03C2 \u03C3\u03B5 \u03C0\u03B5\u03C1\u03AF\u03C0\u03C4\u03C9\u03C3\u03B7 \u03B1\u03C0\u03BF\u03BC\u03B1\u03BA\u03C1\u03C5\u03C3\u03BC\u03AD\u03BD\u03B7\u03C2 \u03B5\u03C1\u03B3\u03B1\u03C3\u03AF\u03B1\u03C2 \u03AE \u03B5\u03AC\u03BD \u03B7 \u03B5\u03C1\u03B3\u03B1\u03C3\u03AF\u03B1 \u03B8\u03B1 \u03C0\u03C1\u03B1\u03B3\u03BC\u03B1\u03C4\u03BF\u03C0\u03BF\u03B9\u03B7\u03B8\u03B5\u03AF \u03C3\u03B5 \u03C0\u03BF\u03BB\u03BB\u03AD\u03C2 \u03C4\u03BF\u03C0\u03BF\u03B8\u03B5\u03C3\u03AF\u03B5\u03C2.","you_have_n_locations":"\u0388\u03C7\u03B5\u03C4\u03B5 {{locationsCount}} \u03C4\u03BF\u03C0\u03BF\u03B8\u03B5\u03C3\u03AF\u03B5\u03C2"},"add_location":{"title":"\u03A0\u03C1\u03BF\u03C3\u03B8\u03AE\u03BA\u03B7 \u03A4\u03BF\u03C0\u03BF\u03B8\u03B5\u03C3\u03AF\u03B1\u03C2"},"edit_location":{"title":"\u0395\u03C0\u03B5\u03BE\u03B5\u03C1\u03B3\u03B1\u03C3\u03AF\u03B1 \u03A4\u03BF\u03C0\u03BF\u03B8\u03B5\u03C3\u03AF\u03B1\u03C2"},"orders_list":{"title":"\u03A0\u03B1\u03C1\u03B1\u03B3\u03B3\u03B5\u03BB\u03AF\u03B5\u03C2","empty_list_title":"\u039E\u03B5\u03BA\u03B9\u03BD\u03AE\u03C3\u03C4\u03B5 \u03BD\u03B1 \u03A0\u03C1\u03BF\u03C3\u03BB\u03B1\u03BC\u03B2\u03AC\u03BD\u03B5\u03C4\u03B5 \u03A3\u03AE\u03BC\u03B5\u03C1\u03B1!","empty_list_description":"\u0391\u03BD\u03B1\u03B6\u03B7\u03C4\u03AC\u03C4\u03B5 \u03C0\u03C1\u03BF\u03C3\u03C9\u03C0\u03B9\u03BA\u03CC \u03C0\u03C1\u03BF\u03C3\u03C9\u03C1\u03B9\u03BD\u03AE\u03C2 \u03B1\u03C0\u03B1\u03C3\u03C7\u03CC\u03BB\u03B7\u03C3\u03B7\u03C2; \\n\u0395\u03BD\u03B7\u03BC\u03B5\u03C1\u03CE\u03C3\u03C4\u03B5 \u03BC\u03B1\u03C2 \u03B3\u03B9\u03B1 \u03C4\u03B7\u03BD \u03B8\u03AD\u03C3\u03B7.","create_order":"\u0394\u03B7\u03BC\u03B9\u03BF\u03C5\u03C1\u03B3\u03AF\u03B1 \u03A0\u03B1\u03C1\u03B1\u03B3\u03B3\u03B5\u03BB\u03AF\u03B1\u03C2","tab_title_pending":"\u03A3\u03B5 \u03B5\u03BA\u03BA\u03C1\u03B5\u03BC\u03CC\u03C4\u03B7\u03C4\u03B1","tab_title_active":"\u0395\u03BD\u03B5\u03C1\u03B3\u03AE","tab_title_completed":"\u039F\u03BB\u03BF\u03BA\u03BB\u03B7\u03C1\u03C9\u03BC\u03AD\u03BD\u03B7"},"order":{"order_number":"\u03A0\u03B1\u03C1\u03B1\u03B3\u03B3\u03B5\u03BB\u03AF\u03B1 #{{id}}","order_summary":"\u03A3\u03CD\u03BD\u03BF\u03C8\u03B7 \u03A0\u03B1\u03C1\u03B1\u03B3\u03B3\u03B5\u03BB\u03AF\u03B1\u03C2","jobs":"\u0398\u03AD\u03C3\u03B5\u03B9\u03C2 \u0395\u03C1\u03B3\u03B1\u03C3\u03AF\u03B1\u03C2","cost":"\u039A\u03CC\u03C3\u03C4\u03BF\u03C2","i_accept_terms":"\u0391\u03C0\u03BF\u03B4\u03AD\u03C7\u03BF\u03BC\u03B1\u03B9 \u03C4\u03BF\u03C5\u03C2 <1>\u038C\u03C1\u03BF\u03C5\u03C2 \u03A7\u03C1\u03AE\u03C3\u03B7\u03C2</1>","confirm":"\u0395\u03C0\u03B9\u03B2\u03B5\u03B2\u03B1\u03AF\u03C9\u03C3\u03B7","order_confirmed":"\u0395\u03C0\u03B9\u03B2\u03B5\u03B2\u03B1\u03AF\u03C9\u03C3\u03B7 \u03A0\u03B1\u03C1\u03B1\u03B3\u03B3\u03B5\u03BB\u03AF\u03B1\u03C2","thank_you_for_confirming_order":"\u0395\u03C5\u03C7\u03B1\u03C1\u03B9\u03C3\u03C4\u03BF\u03CD\u03BC\u03B5 \u03B3\u03B9\u03B1 \u03C4\u03B7\u03BD \u03B5\u03C0\u03B9\u03B2\u03B5\u03B2\u03B1\u03AF\u03C9\u03C3\u03B7 \u03C4\u03B7\u03C2 \u03C0\u03B1\u03C1\u03B1\u03B3\u03B3\u03B5\u03BB\u03AF\u03B1\u03C2 \u03C3\u03B1\u03C2.","done":"\u039F\u03BB\u03BF\u03BA\u03BB\u03AE\u03C1\u03C9\u03C3\u03B7","payment_terms":"\u038C\u03C1\u03BF\u03B9 \u03A0\u03BB\u03B7\u03C1\u03C9\u03BC\u03AE\u03C2","complete_company_details":"\u03A3\u03C5\u03BC\u03C0\u03BB\u03B7\u03C1\u03CE\u03C3\u03C4\u03B5 \u03C4\u03B1 \u03C3\u03C4\u03BF\u03B9\u03C7\u03B5\u03AF\u03B1 \u03C4\u03B7\u03C2 \u03B5\u03C4\u03B1\u03B9\u03C1\u03B5\u03AF\u03B1\u03C2 \u03B3\u03B9\u03B1 \u03BD\u03B1 \u03B1\u03BB\u03BB\u03AC\u03BE\u03B5\u03C4\u03B5 \u03C4\u03BF\u03C5\u03C2 \u03CC\u03C1\u03BF\u03C5\u03C2 \u03C0\u03BB\u03B7\u03C1\u03C9\u03BC\u03AE\u03C2","change_terms":"\u0391\u03BB\u03BB\u03B1\u03B3\u03AE \u038C\u03C1\u03C9\u03BD","duplicate_order":"\u0391\u03BD\u03C4\u03B9\u03B3\u03C1\u03B1\u03C6\u03AE \u03A0\u03B1\u03C1\u03B1\u03B3\u03B3\u03B5\u03BB\u03AF\u03B1\u03C2","days":"\u0397\u03BC\u03AD\u03C1\u03B5\u03C2","to_end":"\u03BC\u03AD\u03C7\u03C1\u03B9 \u03C4\u03BF \u03A4\u03AD\u03BB\u03BF\u03C2","location":"\u03A4\u03BF\u03C0\u03BF\u03B8\u03B5\u03C3\u03AF\u03B1","end_date":"\u0397\u03BC/\u03BD\u03AF\u03B1 \u039B\u03AE\u03BE\u03B7\u03C2","start_date":"\u0397\u03BC/\u03BD\u03AF\u03B1 \u0388\u03BD\u03B1\u03C1\u03BE\u03B7\u03C2","subtotal":"\u039C\u03B5\u03C1\u03B9\u03BA\u03CC \u03A3\u03CD\u03BD\u03BF\u03BB\u03BF","transportations":"\u039C\u03B5\u03C4\u03B1\u03C6\u03BF\u03C1\u03B9\u03BA\u03AC","vat_percent":"\u03A6.\u03A0.\u0391. ({{count}}%)","estimated_total":"\u0395\u03BA\u03C4\u03B9\u03BC\u03CE\u03BC\u03B5\u03BD\u03BF \u03A3\u03CD\u03BD\u03BF\u03BB\u03BF","dates":"\u0397\u03BC\u03B5\u03C1\u03BF\u03BC\u03B7\u03BD\u03AF\u03B5\u03C2","days_count":"(\u0391\u03C1\u03B9\u03B8\u03BC\u03CC\u03C2 \u0397\u03BC\u03B5\u03C1\u03CE\u03BD: {{count}})","hours":"\u038F\u03C1\u03B5\u03C2","hours_amount":"\u0391\u03C1\u03B9\u03B8\u03BC\u03CC\u03C2 \u03A9\u03C1\u03CE\u03BD: {{hours}}","hours_per_day":"({{hoursPerDay}} \u03CE\u03C1\u03B5\u03C2/\u03B7\u03BC\u03AD\u03C1\u03B1)","rate":"\u03A9\u03C1\u03BF\u03BC\u03AF\u03C3\u03B8\u03B9\u03BF","hour_rate":"{{currency}} {{hourRate}}/\u03CE\u03C1\u03B1","transportation_cost":"{{currency}} {{cost}}/\u03B7\u03BC\u03AD\u03C1\u03B1","category_schedule":"\u03A0\u03C1\u03CC\u03B3\u03C1\u03B1\u03BC\u03BC\u03B1 {{category}}","order_summary_days_count":"(\u0391\u03C1\u03B9\u03B8\u03BC\u03CC\u03C2 \u0397\u03BC\u03B5\u03C1\u03CE\u03BD: {{count}})","hello_name":"\u0393\u03B5\u03B9\u03B1 \u03C3\u03BF\u03C5, <1>{{name}}</1>","confirm_order":"\u0388\u03C7\u03BF\u03C5\u03BC\u03B5 \u03BB\u03AC\u03B2\u03B5\u03B9 \u03B1\u03AF\u03C4\u03B7\u03BC\u03B1 \u03BD\u03AD\u03B1\u03C2 \u03C0\u03B1\u03C1\u03B1\u03B3\u03B3\u03B5\u03BB\u03AF\u03B1\u03C2 \u03B1\u03C0\u03CC \u03B5\u03C3\u03AC\u03C2. \u0393\u03B9\u03B1 \u03BD\u03B1 \u03C0\u03C1\u03BF\u03C7\u03C9\u03C1\u03AE\u03C3\u03BF\u03C5\u03BC\u03B5, \u03C0\u03B1\u03C1\u03B1\u03BA\u03B1\u03BB\u03BF\u03CD\u03BC\u03B5 \u03B5\u03BB\u03AD\u03B3\u03BE\u03C4\u03B5 \u03BA\u03B1\u03B9 \u03B5\u03C0\u03B9\u03B2\u03B5\u03B2\u03B1\u03B9\u03CE\u03C3\u03C4\u03B5 \u03C4\u03B1 \u03C0\u03B1\u03C1\u03B1\u03BA\u03AC\u03C4\u03C9 \u03C3\u03C4\u03BF\u03B9\u03C7\u03B5\u03AF\u03B1.","pending_rates_review":"\u03A4\u03BF \u03B1\u03AF\u03C4\u03B7\u03BC\u03B1 \u03C0\u03B1\u03C1\u03B1\u03B3\u03B3\u03B5\u03BB\u03AF\u03B1\u03C2 \u03C3\u03B1\u03C2 \u03B5\u03AF\u03BD\u03B1\u03B9 \u03C5\u03C0\u03CC \u03B5\u03BE\u03AD\u03C4\u03B1\u03C3\u03B7. \u0398\u03B1 \u03C3\u03B1\u03C2 \u03B5\u03B9\u03B4\u03BF\u03C0\u03BF\u03B9\u03AE\u03C3\u03BF\u03C5\u03BC\u03B5 \u03BC\u03CC\u03BB\u03B9\u03C2 \u03BF\u03C1\u03B9\u03C3\u03C4\u03B9\u03BA\u03BF\u03C0\u03BF\u03B9\u03B7\u03B8\u03BF\u03CD\u03BD \u03BF\u03B9 \u03C7\u03C1\u03B5\u03CE\u03C3\u03B5\u03B9\u03C2.","send_for_review":"\u0391\u03C0\u03BF\u03C3\u03C4\u03BF\u03BB\u03AE \u03B3\u03B9\u03B1 \u0388\u03BB\u03B5\u03B3\u03C7\u03BF","under_review":"\u03A5\u03C0\u03CC \u0395\u03BE\u03AD\u03C4\u03B1\u03C3\u03B7","final_amount_will_be_based":"*\u03A4\u03BF \u03C4\u03B5\u03BB\u03B9\u03BA\u03CC \u03C3\u03C5\u03BD\u03BF\u03BB\u03B9\u03BA\u03CC \u03C0\u03BF\u03C3\u03CC \u03B8\u03B1 \u03C0\u03C1\u03BF\u03BA\u03CD\u03C8\u03B5\u03B9 \u03B1\u03C0\u03CC \u03C4\u03B7\u03BD \u03C0\u03C1\u03B1\u03B3\u03BC\u03B1\u03C4\u03B9\u03BA\u03AE \u03C3\u03C5\u03BC\u03BC\u03B5\u03C4\u03BF\u03C7\u03AE","amend_order":"\u03A4\u03C1\u03BF\u03C0\u03BF\u03C0\u03BF\u03AF\u03B7\u03C3\u03B7 \u03A0\u03B1\u03C1\u03B1\u03B3\u03B3\u03B5\u03BB\u03AF\u03B1\u03C2","i_accept":"\u0391\u03C0\u03BF\u03B4\u03BF\u03C7\u03AE \u03C4\u03C9\u03BD","terms_of_service":"\u038C\u03C1\u03C9\u03BD \u03A7\u03C1\u03AE\u03C3\u03B7\u03C2","select_amend_reason":"\u0395\u03C0\u03B9\u03BB\u03AD\u03BE\u03C4\u03B5 \u03C4\u03B7\u03BD \u0391\u03B9\u03C4\u03AF\u03B1 \u03A4\u03C1\u03BF\u03C0\u03BF\u03C0\u03BF\u03AF\u03B7\u03C3\u03B7\u03C2","select_reason":"\u0395\u03C0\u03B9\u03BB\u03AD\u03BE\u03C4\u03B5 \u03C4\u03B7\u03BD \u0391\u03B9\u03C4\u03AF\u03B1","submitting":"\u03A5\u03C0\u03BF\u03B2\u03BF\u03BB\u03AE...","continue":"\u03A3\u03C5\u03BD\u03AD\u03C7\u03B5\u03B9\u03B1","cancel":"\u0391\u03BA\u03CD\u03C1\u03C9\u03C3\u03B7","quotation_download_title":"\u039B\u03AE\u03C8\u03B7 \u03A0\u03C1\u03BF\u03C3\u03C6\u03BF\u03C1\u03AC\u03C2","quotation_download_action_text":"\u039B\u03AE\u03C8\u03B7","quotation_download_in_progress_text":"\u0393\u03AF\u03BD\u03B5\u03C4\u03B1\u03B9 \u039B\u03AE\u03C8\u03B7...","lpo_upload_title":"\u0391\u03BD\u03B5\u03B2\u03AC\u03C3\u03C4\u03B5    \u03C4\u03B7\u03BD \u03A5\u03C0\u03BF\u03B3\u03B5\u03B3\u03C1\u03B1\u03BC\u03BC\u03AD\u03BD\u03B7 \u03A3\u03CD\u03BC\u03B2\u03B1\u03C3\u03B7 \u03A0\u03B1\u03C1\u03BF\u03C7\u03AE\u03C2 \u03A5\u03C0\u03B7\u03C1\u03B5\u03C3\u03B9\u03CE\u03BD","lpo_upload_action_text":"\u0391\u03BD\u03B5\u03B2\u03AC\u03C3\u03C4\u03B5","lpo_upload_in_progress_text":"\u0391\u03BD\u03B5\u03B2\u03B1\u03AF\u03BD\u03B5\u03B9...","lpo_upload_success_message":"\u0397 \u03A3\u03CD\u03BC\u03B2\u03B1\u03C3\u03B7 \u03A0\u03B1\u03C1\u03BF\u03C7\u03AE\u03C2 \u03A5\u03C0\u03B7\u03C1\u03B5\u03C3\u03B9\u03CE\u03BD \u03AD\u03C7\u03B5\u03B9 \u03B1\u03BD\u03AD\u03B2\u03B5\u03B9 \u03B5\u03C0\u03B9\u03C4\u03C5\u03C7\u03CE\u03C2","menu_download_quote":"\u039A\u03B1\u03C4\u03B5\u03B2\u03AC\u03C3\u03C4\u03B5 \u03C4\u03B7\u03BD \u03A0\u03C1\u03BF\u03C3\u03C6\u03BF\u03C1\u03AC","menu_upload_lpo":"\u0391\u03BD\u03B5\u03B2\u03AC\u03C3\u03C4\u03B5 \u03C4\u03B7\u03BD \u03A3\u03CD\u03BC\u03B2\u03B1\u03C3\u03B7 \u03A0\u03B1\u03C1\u03BF\u03C7\u03AE\u03C2 \u03A5\u03C0\u03B7\u03C1\u03B5\u03C3\u03B9\u03CE\u03BD","lpo_download_title":"\u039A\u03B1\u03C4\u03B5\u03B2\u03AC\u03C3\u03C4\u03B5 \u03C4\u03B7\u03BD \u03A3\u03CD\u03BC\u03B2\u03B1\u03C3\u03B7 \u03A0\u03B1\u03C1\u03BF\u03C7\u03AE\u03C2 \u03A5\u03C0\u03B7\u03C1\u03B5\u03C3\u03B9\u03CE\u03BD","lpo_download_in_progress_text":"\u0393\u03AF\u03BD\u03B5\u03C4\u03B1\u03B9 \u039B\u03AE\u03C8\u03B7...","menu_duplicate_order":"\u0391\u03BD\u03C4\u03B9\u03B3\u03C1\u03AC\u03C8\u03C4\u03B5 \u03C4\u03B7\u03BD \u03C0\u03B1\u03C1\u03B1\u03B3\u03B3\u03B5\u03BB\u03AF\u03B1","draft_order_title":"\u03A0\u03C1\u03BF\u03C3\u03C7\u03AD\u03B4\u03B9\u03BF \u03A0\u03B1\u03C1\u03B1\u03B3\u03B3\u03B5\u03BB\u03AF\u03B1\u03C2","job_to_duplicate":"\u0395\u03C1\u03B3\u03B1\u03C3\u03AF\u03B1 \u03C0\u03C1\u03BF\u03C2 \u0391\u03BD\u03C4\u03B9\u03B3\u03C1\u03B1\u03C6\u03AE","need_to_review_corporate_details":"\u0388\u03C7\u03BF\u03C5\u03BC\u03B5 \u03BB\u03AC\u03B2\u03B5\u03B9 \u03BD\u03AD\u03BF \u03B1\u03AF\u03C4\u03B7\u03BC\u03B1 \u03C0\u03B1\u03C1\u03B1\u03B3\u03B3\u03B5\u03BB\u03AF\u03B1\u03C2 \u03B1\u03C0\u03CC \u03B5\u03C3\u03AC\u03C2. \u0393\u03B9\u03B1 \u03BD\u03B1 \u03C0\u03C1\u03BF\u03C7\u03C9\u03C1\u03AE\u03C3\u03BF\u03C5\u03BC\u03B5, \u03C0\u03B1\u03C1\u03B1\u03BA\u03B1\u03BB\u03BF\u03CD\u03BC\u03B5 \u03B5\u03BB\u03AD\u03B3\u03BE\u03C4\u03B5 \u03BA\u03B1\u03B9 \u03C3\u03C5\u03BC\u03C0\u03BB\u03B7\u03C1\u03CE\u03C3\u03C4\u03B5 \u03C4\u03B1 \u03C3\u03C4\u03BF\u03B9\u03C7\u03B5\u03AF\u03B1 \u03C4\u03B7\u03C2 \u03B5\u03C4\u03B1\u03B9\u03C1\u03B5\u03AF\u03B1\u03C2","corporate_details_are_being_reviewed":"\u0395\u03BE\u03B5\u03C4\u03AC\u03B6\u03BF\u03C5\u03BC\u03B5 \u03C4\u03B1 \u03C3\u03C4\u03BF\u03B9\u03C7\u03B5\u03AF\u03B1 \u03C4\u03B7\u03C2 \u03B5\u03C4\u03B1\u03B9\u03C1\u03B5\u03AF\u03B1\u03C2 \u03C0\u03BF\u03C5 \u03BC\u03B1\u03C2 \u03C3\u03C4\u03B5\u03AF\u03BB\u03B1\u03C4\u03B5","complete_company_details_link":"\u03A3\u03C5\u03BC\u03C0\u03BB\u03B7\u03C1\u03CE\u03C3\u03C4\u03B5 \u03C4\u03B1 \u03C3\u03C4\u03BF\u03B9\u03C7\u03B5\u03AF\u03B1 \u03C4\u03B7\u03C2 \u03B5\u03C4\u03B1\u03B9\u03C1\u03B5\u03AF\u03B1\u03C2","suggest_extension":"\u03A3\u03B1\u03C2 \u03B5\u03C5\u03C7\u03B1\u03C1\u03B9\u03C3\u03C4\u03BF\u03CD\u03BC\u03B5 \u03C0\u03BF\u03C5 \u03B5\u03C0\u03B9\u03BB\u03AD\u03BE\u03B1\u03C4\u03B5 \u03C4\u03B9\u03C2 \u03C5\u03C0\u03B7\u03C1\u03B5\u03C3\u03AF\u03B5\u03C2 \u03BC\u03B1\u03C2. \u0395\u03C0\u03B5\u03BA\u03C4\u03B5\u03AF\u03BD\u03B5\u03C4\u03B5 \u03C4\u03B7\u03BD \u03C0\u03B1\u03C1\u03B1\u03B3\u03B3\u03B5\u03BB\u03AF\u03B1 \u03C3\u03B1\u03C2 \u03B3\u03B9\u03B1 \u03B5\u03C0\u03B9\u03C0\u03BB\u03AD\u03BF\u03BD \u03C5\u03C0\u03B7\u03C1\u03B5\u03C3\u03AF\u03B5\u03C2 \u03AE \u03C0\u03C1\u03BF\u03CA\u03CC\u03BD\u03C4\u03B1.","extend_your_order":"\u0395\u03C0\u03AD\u03BA\u03C4\u03B1\u03C3\u03B7 \u03A0\u03B1\u03C1\u03B1\u03B3\u03B3\u03B5\u03BB\u03AF\u03B1\u03C2"},"job_draft_category":{"title":"\u0394\u03B7\u03BC\u03B9\u03BF\u03C5\u03C1\u03B3\u03AF\u03B1 \u039D\u03AD\u03B1\u03C2 \u03A0\u03B1\u03C1\u03B1\u03B3\u03B3\u03B5\u03BB\u03AF\u03B1\u03C2","tell_about_job":"\u03A0\u03B5\u03AF\u03C4\u03B5 \u03BC\u03B1\u03C2 \u03B3\u03B9\u03B1 \u03C4\u03B7\u03BD \u03B8\u03AD\u03C3\u03B7 \u03B5\u03C1\u03B3\u03B1\u03C3\u03AF\u03B1\u03C2","tell_about_first_job":"\u03A0\u03B5\u03AF\u03C4\u03B5 \u03BC\u03B1\u03C2 \u03B3\u03B9\u03B1 \u03C4\u03B7\u03BD \u03C0\u03C1\u03CE\u03C4\u03B7 \u03B8\u03AD\u03C3\u03B7 \u03B5\u03C1\u03B3\u03B1\u03C3\u03AF\u03B1\u03C2","find_staff":"\u0392\u03C1\u03B5\u03AF\u03C4\u03B5 \u03B5\u03BE\u03B5\u03B9\u03B4\u03B9\u03BA\u03B5\u03C5\u03BC\u03AD\u03BD\u03BF \u03C0\u03C1\u03BF\u03C3\u03C9\u03C0\u03B9\u03BA\u03CC \u03B3\u03B9\u03B1 \u03BA\u03AC\u03B8\u03B5 \u03C3\u03B1\u03C2 \u03B1\u03BD\u03AC\u03B3\u03BA\u03B7"},"job_draft_price":{"title":"Set the Hourly Rates","subtitle":"Attract best workers with competitive rates","low_rate_og_message":"\u26A0\uFE0F Significantly below market standard","low_rate_fill_message":"\uD83D\uDC22 High risk of low fill rate","middle_rate_og_message":"\uD83D\uDC65 Below market standard","middle_rate_fill_message":"\u23F3 Moderate low fill rate","good_rate_og_message":"\uD83C\uDF1F Competitive hourly rate","good_rate_fill_message":"\uD83D\uDE80 Good fill rate","money_amount":"{{currency}} {{amount}}","rate_is_less_than_min":"Rate is less than minimal allowed of {{min}}","input_label":"Hour Rate, {{currency}}","decrease_rate":"decrease rate","increase_rate":"increase rate","short_explanation":"The recommended rate is dynamically calculated based on demand, timing, and job specifics, and already includes our commission","estimated_total":"Estimated total*","includes_vat":"*Includes {{vat}}% VAT"},"job_draft_details":{"title":"\u0398\u03AD\u03C3\u03B7 \u0395\u03C1\u03B3\u03B1\u03C3\u03AF\u03B1\u03C2: {{category}}","fill_job_details":"\u03A3\u03C5\u03BC\u03C0\u03BB\u03B7\u03C1\u03CE\u03C3\u03C4\u03B5 \u03C4\u03B1 \u03C3\u03C4\u03BF\u03B9\u03C7\u03B5\u03AF\u03B1 \u03C4\u03B7\u03C2 \u03B8\u03AD\u03C3\u03B7\u03C2","staff":"\u03A0\u03C1\u03BF\u03C3\u03C9\u03C0\u03B9\u03BA\u03CC","quantity":"\u03A0\u03BF\u03C3\u03CC\u03C4\u03B7\u03C4\u03B1","location":"\u03A4\u03BF\u03C0\u03BF\u03B8\u03B5\u03C3\u03AF\u03B1","start_date":"\u0397\u03BC/\u03BD\u03AF\u03B1 \u0388\u03BD\u03B1\u03C1\u03BE\u03B7\u03C2","end_date":"\u0397\u03BC/\u03BD\u03AF\u03B1\u03C2 \u039B\u03AE\u03BE\u03B7\u03C2","days":"\u0397\u03BC\u03AD\u03C1\u03B5\u03C2","start_time":"\u038F\u03C1\u03B1 \u0388\u03BD\u03B1\u03C1\u03BE\u03B7\u03C2","end_time":"\u038F\u03C1\u03B1 \u039B\u03AE\u03BE\u03B7\u03C2","requirements":"\u0395\u03BE\u03B5\u03B9\u03B4\u03AF\u03BA\u03B5\u03C5\u03C3\u03B7","job_description":"\u03A0\u03B5\u03C1\u03B9\u03B3\u03C1\u03B1\u03C6\u03AE \u0398\u03AD\u03C3\u03B7\u03C2 \u0395\u03C1\u03B3\u03B1\u03C3\u03AF\u03B1\u03C2","experience":"\u0395\u03BC\u03C0\u03B5\u03B9\u03C1\u03AF\u03B1","dresscode":"\u0395\u03BD\u03B4\u03C5\u03BC\u03B1\u03C4\u03BF\u03BB\u03BF\u03B3\u03B9\u03BA\u03CC\u03C2 \u039A\u03CE\u03B4\u03B9\u03BA\u03B1\u03C2","additional_preferences":"\u0395\u03C0\u03B9\u03C0\u03BB\u03AD\u03BF\u03BD \u03A0\u03C1\u03BF\u03C4\u03B9\u03BC\u03AE\u03C3\u03B5\u03B9\u03C2","languages":"\u0393\u03BB\u03CE\u03C3\u03C3\u03B5\u03C2","gender":"\u03A6\u03CD\u03BB\u03BF","additional_documents":"\u03A0\u03C1\u03CC\u03C3\u03B8\u03B5\u03C4\u03B1 \u0388\u03B3\u03B3\u03C1\u03B1\u03C6\u03B1","video_interview":"\u03A3\u03C5\u03BD\u03AD\u03BD\u03C4\u03B5\u03C5\u03BE\u03B7 \u03BC\u03AD\u03C3\u03C9 \u0392\u03AF\u03BD\u03C4\u03B5\u03BF","manual_selection":"\u03A7\u03B5\u03B9\u03C1\u03BF\u03BA\u03AF\u03BD\u03B7\u03C4\u03B7 \u0395\u03C0\u03B9\u03BB\u03BF\u03B3\u03AE \u03A0\u03C1\u03BF\u03C3\u03C9\u03C0\u03B9\u03BA\u03BF\u03CD","accreditation":"\u0391\u03C0\u03B1\u03B9\u03C4\u03B5\u03AF\u03C4\u03B1\u03B9 \u0394\u03B9\u03B1\u03C0\u03AF\u03C3\u03C4\u03B5\u03C5\u03C3\u03B7","submitting":"\u03A5\u03C0\u03BF\u03B2\u03BF\u03BB\u03AE...","save":"\u03A5\u03C0\u03BF\u03B2\u03BF\u03BB\u03AE","finish":"\u03A4\u03AD\u03BB\u03BF\u03C2","next":"\u0395\u03C0\u03CC\u03BC\u03B5\u03BD\u03BF","create_duplicate":"\u0391\u03C0\u03BF\u03B8\u03AE\u03BA\u03B5\u03C5\u03C3\u03B7","work_category_required":"\u03A0\u03B1\u03C1\u03B1\u03BA\u03B1\u03BB\u03CE \u03B5\u03C0\u03B9\u03BB\u03AD\u03BE\u03C4\u03B5 \u03BA\u03B1\u03C4\u03B7\u03B3\u03BF\u03C1\u03AF\u03B1 \u03B5\u03C1\u03B3\u03B1\u03C3\u03AF\u03B1\u03C2","step_n_of_m_steps":"{{objectNameLabel}} \u0392\u03AE\u03BC\u03B1 {{index}} \u03B1\u03C0\u03CC {{count}}","quantity_required":"\u039F\u03C1\u03AF\u03C3\u03C4\u03B5 \u03C0\u03CC\u03C3\u03BF \u03C0\u03C1\u03BF\u03C3\u03C9\u03C0\u03B9\u03BA\u03CC \u03C7\u03C1\u03B5\u03B9\u03AC\u03B6\u03B5\u03C3\u03C4\u03B5","location_required":"\u039F\u03C1\u03AF\u03C3\u03C4\u03B5 \u03C4\u03B7\u03BD \u03C4\u03BF\u03C0\u03BF\u03B8\u03B5\u03C3\u03AF\u03B1","schedule_type_required":"\u03A0\u03B1\u03C1\u03B1\u03BA\u03B1\u03BB\u03CE \u03B5\u03C0\u03B9\u03BB\u03AD\u03BE\u03C4\u03B5 \u03C4\u03CD\u03C0\u03BF \u03C0\u03C1\u03BF\u03B3\u03C1\u03AC\u03BC\u03BC\u03B1\u03C4\u03BF\u03C2","same_time_prompt_required":"\u03A0\u03B1\u03C1\u03B1\u03BA\u03B1\u03BB\u03BF\u03CD\u03BC\u03B5 \u03B5\u03BD\u03B7\u03BC\u03B5\u03C1\u03CE\u03C3\u03C4\u03B5 \u03BC\u03B1\u03C2 \u03B1\u03BD \u03CC\u03BB\u03B5\u03C2 \u03BF\u03B9 \u03B7\u03BC\u03AD\u03C1\u03B5\u03C2 \u03AD\u03C7\u03BF\u03C5\u03BD \u03C4\u03B7\u03BD \u03AF\u03B4\u03B9\u03B1 \u03CE\u03C1\u03B1 \u03AD\u03BD\u03B1\u03C1\u03BE\u03B7\u03C2/\u03BB\u03AE\u03BE\u03B7\u03C2","start_date_required":"\u039F\u03C1\u03AF\u03C3\u03C4\u03B5 \u03B7\u03BC\u03B5\u03C1\u03BF\u03BC\u03B7\u03BD\u03AF\u03B1 \u03AD\u03BD\u03B1\u03C1\u03BE\u03B7\u03C2","end_date_required":"\u039F\u03C1\u03AF\u03C3\u03C4\u03B5 \u03C4\u03B7\u03BD \u03B7\u03BC\u03B5\u03C1\u03BF\u03BC\u03B7\u03BD\u03AF\u03B1 \u03BB\u03AE\u03BE\u03B7\u03C2 \u03AE \u03BA\u03AC\u03BD\u03C4\u03B5 \u03C4\u03B7\u03BD \u03B5\u03C1\u03B3\u03B1\u03C3\u03AF\u03B1 \u03B1\u03BD\u03BF\u03B9\u03C7\u03C4\u03AE","end_date_cannot_be_before_start_date":"\u0397 \u03B7\u03BC\u03B5\u03C1\u03BF\u03BC\u03B7\u03BD\u03AF\u03B1 \u03BB\u03AE\u03BE\u03B7\u03C2 \u03B4\u03B5\u03BD \u03BC\u03C0\u03BF\u03C1\u03B5\u03AF \u03BD\u03B1 \u03C0\u03C1\u03BF\u03B7\u03B3\u03B5\u03AF\u03C4\u03B1\u03B9 \u03C4\u03B7\u03C2 \u03B7\u03BC\u03B5\u03C1\u03BF\u03BC\u03B7\u03BD\u03AF\u03B1\u03C2 \u03AD\u03BD\u03B1\u03C1\u03BE\u03B7\u03C2","start_time_required":"\u039F\u03C1\u03AF\u03C3\u03C4\u03B5 \u03C4\u03B7\u03BD \u03CE\u03C1\u03B1 \u03AD\u03BD\u03B1\u03C1\u03BE\u03B7\u03C2","end_time_required":"\u039F\u03C1\u03AF\u03C3\u03C4\u03B5 \u03C4\u03B7\u03BD \u03CE\u03C1\u03B1 \u03BB\u03AE\u03BE\u03B7\u03C2","select_one_date_at_least":"\u03A0\u03B1\u03C1\u03B1\u03BA\u03B1\u03BB\u03BF\u03CD\u03BC\u03B5 \u03B5\u03C0\u03B9\u03BB\u03AD\u03BE\u03C4\u03B5 \u03C4\u03BF\u03C5\u03BB\u03AC\u03C7\u03B9\u03C3\u03C4\u03BF\u03BD \u03BC\u03AF\u03B1 \u03B7\u03BC\u03AD\u03C1\u03B1","fill_all_selected_dates":"\u03A0\u03B1\u03C1\u03B1\u03BA\u03B1\u03BB\u03CE \u03C3\u03C5\u03BC\u03C0\u03BB\u03B7\u03C1\u03CE\u03C3\u03C4\u03B5 \u03CC\u03BB\u03B1 \u03C4\u03B1 \u03C0\u03B5\u03B4\u03AF\u03B1 \u03B3\u03B9\u03B1 \u03C4\u03B9\u03C2 \u03B5\u03C0\u03B9\u03BB\u03B5\u03B3\u03BC\u03AD\u03BD\u03B5\u03C2 \u03B7\u03BC\u03B5\u03C1\u03BF\u03BC\u03B7\u03BD\u03AF\u03B5\u03C2","job_cant_start_early":"\u0397 \u03B5\u03C1\u03B3\u03B1\u03C3\u03AF\u03B1 \u03B4\u03B5\u03BD \u03BC\u03C0\u03BF\u03C1\u03B5\u03AF \u03BD\u03B1 \u03BE\u03B5\u03BA\u03B9\u03BD\u03AC \u03C0\u03B9\u03BF \u03C3\u03CD\u03BD\u03C4\u03BF\u03BC\u03B1 \u03B1\u03C0\u03CC 24 \u03CE\u03C1\u03B5\u03C2","must_include_day_of_start_date":"\u0397 \u03B7\u03BC\u03AD\u03C1\u03B1 \u03AD\u03BD\u03B1\u03C1\u03BE\u03B7\u03C2 \u03C0\u03C1\u03AD\u03C0\u03B5\u03B9 \u03BD\u03B1 \u03C3\u03C5\u03BC\u03C0\u03B5\u03C1\u03B9\u03BB\u03B1\u03BC\u03B2\u03AC\u03BD\u03B5\u03C4\u03B1\u03B9","must_include_day_of_end_date":"\u0397 \u03B7\u03BC\u03AD\u03C1\u03B1 \u03BB\u03AE\u03BE\u03B7\u03C2 \u03C0\u03C1\u03AD\u03C0\u03B5\u03B9 \u03BD\u03B1 \u03C3\u03C5\u03BC\u03C0\u03B5\u03C1\u03B9\u03BB\u03B1\u03BC\u03B2\u03AC\u03BD\u03B5\u03C4\u03B1\u03B9","description_required":"\u039F\u03C1\u03AF\u03C3\u03C4\u03B5 \u03BC\u03B9\u03B1 \u03C0\u03B5\u03C1\u03B9\u03B3\u03C1\u03B1\u03C6\u03AE","description_too_long":"\u0397 \u03C0\u03B5\u03C1\u03B9\u03B3\u03C1\u03B1\u03C6\u03AE \u03B5\u03AF\u03BD\u03B1\u03B9 \u03C0\u03BF\u03BB\u03CD \u03BC\u03B5\u03B3\u03AC\u03BB\u03B7, \u03C0\u03B1\u03C1\u03B1\u03BA\u03B1\u03BB\u03BF\u03CD\u03BC\u03B5 \u03BA\u03AC\u03BD\u03C4\u03B5 \u03C4\u03B7\u03BD \u03C0\u03B9\u03BF \u03C3\u03CD\u03BD\u03C4\u03BF\u03BC\u03B7","experience_required":"\u0395\u03C0\u03B9\u03BB\u03AD\u03BE\u03C4\u03B5 \u03C4\u03BF \u03B5\u03C0\u03AF\u03C0\u03B5\u03B4\u03BF \u03B5\u03BC\u03C0\u03B5\u03B9\u03C1\u03AF\u03B1\u03C2","dresscode_required":"\u0395\u03C0\u03B9\u03BB\u03AD\u03BE\u03C4\u03B5 \u03B5\u03BD\u03B4\u03C5\u03BC\u03B1\u03C4\u03BF\u03BB\u03BF\u03B3\u03B9\u03BA\u03CC \u03BA\u03CE\u03B4\u03B9\u03BA\u03B1","languages_required":"\u0395\u03C0\u03B9\u03BB\u03AD\u03BE\u03C4\u03B5 \u03B3\u03BB\u03CE\u03C3\u03C3\u03B5\u03C2 \u03AE \u03B1\u03C6\u03B1\u03B9\u03C1\u03AD\u03C3\u03C4\u03B5 \u03C4\u03BF \u03C6\u03AF\u03BB\u03C4\u03C1\u03BF","documents_required":"\u0395\u03C0\u03B9\u03BB\u03AD\u03BE\u03C4\u03B5 \u03B1\u03C1\u03C7\u03B5\u03AF\u03B1 \u03AE \u03B1\u03C6\u03B1\u03B9\u03C1\u03AD\u03C3\u03C4\u03B5 \u03C4\u03BF \u03C6\u03AF\u03BB\u03C4\u03C1\u03BF","interview_required":"\u0395\u03C0\u03B9\u03BB\u03AD\u03BE\u03C4\u03B5 \u03B5\u03C1\u03C9\u03C4\u03AE\u03C3\u03B5\u03B9\u03C2 \u03AE \u03B1\u03C6\u03B1\u03B9\u03C1\u03AD\u03C3\u03C4\u03B5 \u03C4\u03BF \u03C6\u03AF\u03BB\u03C4\u03C1\u03BF","manual_selection_required":"\u0395\u03C0\u03B9\u03BB\u03AD\u03BE\u03C4\u03B5 \u03B4\u03C5\u03BD\u03B1\u03C4\u03CC\u03C4\u03B7\u03C4\u03B1 \u03C7\u03B5\u03B9\u03C1\u03BF\u03BA\u03AF\u03BD\u03B7\u03C4\u03B7\u03C2 \u03B5\u03C0\u03B9\u03BB\u03BF\u03B3\u03AE\u03C2 \u03AE \u03B1\u03C6\u03B1\u03B9\u03C1\u03AD\u03C3\u03C4\u03B5 \u03C4\u03BF \u03C6\u03AF\u03BB\u03C4\u03C1\u03BF","accreditation_required":"\u0395\u03C0\u03B9\u03BB\u03AD\u03BE\u03C4\u03B5 \u03B4\u03B9\u03B1\u03C0\u03AF\u03C3\u03C4\u03B5\u03C5\u03C3\u03B7 \u03AE \u03B1\u03C6\u03B1\u03B9\u03C1\u03AD\u03C3\u03C4\u03B5 \u03C4\u03BF \u03C6\u03AF\u03BB\u03C4\u03C1\u03BF","staff_amount_title":"\u03A0\u03CC\u03C3\u03B1 \u03AC\u03C4\u03BF\u03BC\u03B1 \u03C0\u03C1\u03BF\u03C3\u03C9\u03C0\u03B9\u03BA\u03CC \u03C7\u03C1\u03B5\u03B9\u03AC\u03B6\u03B5\u03C3\u03C4\u03B5;","staff_amount_subtitle":"\u0395\u03C0\u03B9\u03BB\u03AD\u03BE\u03C4\u03B5 \u03B1\u03C0\u03CC \u03C4\u03BF + \u03C4\u03BF\u03BD \u03B1\u03C1\u03B9\u03B8\u03BC\u03CC \u03B5\u03C1\u03B3\u03B1\u03B6\u03BF\u03BC\u03AD\u03BD\u03C9\u03BD \u03AE \u03C0\u03BB\u03B7\u03BA\u03C4\u03C1\u03BF\u03BB\u03BF\u03B3\u03AE\u03C3\u03C4\u03B5 \u03C4\u03BF\u03BD","location_title":"\u03A3\u03B5 \u03C0\u03BF\u03B9\u03B1 \u03C0\u03B5\u03C1\u03B9\u03BF\u03C7\u03AE \u03C7\u03C1\u03B5\u03B9\u03AC\u03B6\u03B5\u03C3\u03C4\u03B5 \u03C4\u03BF \u03C0\u03C1\u03BF\u03C3\u03C9\u03C0\u03B9\u03BA\u03CC;","location_subtitle":"\u0395\u03C0\u03B9\u03BB\u03AD\u03BE\u03C4\u03B5 \u03C4\u03B7\u03BD \u03C4\u03BF\u03C0\u03BF\u03B8\u03B5\u03C3\u03AF\u03B1 \u03C4\u03B7\u03C2 \u03B5\u03C0\u03B9\u03C7\u03B5\u03AF\u03C1\u03B7\u03C3\u03AE\u03C2 \u03C3\u03B1\u03C2 \u03AE \u03C4\u03BF\u03BD \u03C7\u03CE\u03C1\u03BF \u03C0\u03BF\u03C5 \u03C7\u03C1\u03B5\u03B9\u03AC\u03B6\u03B5\u03C3\u03C4\u03B5 \u03C0\u03C1\u03BF\u03C3\u03C9\u03C0\u03B9\u03BA\u03CC.","location_add_new":"\u03A0\u03C1\u03BF\u03C3\u03B8\u03AD\u03C3\u03C4\u03B5 \u039D\u03AD\u03B1 \u03A4\u03BF\u03C0\u03BF\u03B8\u03B5\u03C3\u03AF\u03B1","location_add":"\u03A0\u03C1\u03BF\u03C3\u03B8\u03AD\u03C3\u03C4\u03B5 \u03A4\u03BF\u03C0\u03BF\u03B8\u03B5\u03C3\u03AF\u03B1","dates_title":"\u03A0\u03CC\u03C4\u03B5 \u03C7\u03C1\u03B5\u03B9\u03AC\u03B6\u03B5\u03C3\u03C4\u03B5 \u03C4\u03BF \u03C0\u03C1\u03BF\u03C3\u03C9\u03C0\u03B9\u03BA\u03CC;","dates_subtitle":"\u0395\u03C0\u03B9\u03BB\u03AD\u03BE\u03C4\u03B5 \u03C4\u03B7\u03BD \u03B7\u03BC\u03B5\u03C1\u03BF\u03BC\u03B7\u03BD\u03AF\u03B1/\u03B7\u03BC\u03B5\u03C1\u03BF\u03BC\u03B7\u03BD\u03AF\u03B5\u03C2 \u03C0\u03BF\u03C5 \u03C4\u03BF\u03C5\u03C2 \u03C7\u03C1\u03B5\u03B9\u03AC\u03B6\u03B5\u03C3\u03C4\u03B5.","dates_open_ended":"\u0391\u03BD\u03BF\u03B9\u03C7\u03C4\u03AE (\u03C7\u03C9\u03C1\u03AF\u03C2 \u03B7\u03BC/\u03BD\u03AF\u03B1 \u03BB\u03AE\u03BE\u03B7\u03C2)","schedule_title":"\u0398\u03B1 \u03B4\u03BF\u03C5\u03BB\u03B5\u03CD\u03BF\u03C5\u03BD \u03C4\u03B9\u03C2 \u03AF\u03B4\u03B9\u03B5\u03C2 \u03BC\u03AD\u03C1\u03B5\u03C2 \u03BA\u03AC\u03B8\u03B5 \u03B5\u03B2\u03B4\u03BF\u03BC\u03AC\u03B4\u03B1;","schedule_subtitle":"\u0393\u03B9\u03B1 \u03C0\u03B1\u03C1\u03AC\u03B4\u03B5\u03B9\u03B3\u03BC\u03B1, \u0394\u03B5\u03C5\u03C4\u03AD\u03C1\u03B1 \u03BC\u03B5 \u03A0\u03B1\u03C1\u03B1\u03C3\u03BA\u03B5\u03C5\u03AE \u03BA\u03AC\u03B8\u03B5 \u03B5\u03B2\u03B4\u03BF\u03BC\u03AC\u03B4\u03B1.","schedule_i_have_same_weekly":"\u0388\u03C7\u03C9 \u03C4\u03BF \u03AF\u03B4\u03B9\u03BF \u03C0\u03C1\u03CC\u03B3\u03C1\u03B1\u03BC\u03BC\u03B1 \u03BA\u03AC\u03B8\u03B5 \u03B5\u03B2\u03B4\u03BF\u03BC\u03AC\u03B4\u03B1","schedule_schedule_weekly":"\u03A0\u03C1\u03BF\u03B3\u03C1\u03B1\u03BC\u03BC\u03B1\u03C4\u03B9\u03C3\u03BC\u03CC\u03C2 \u03C3\u03B5 \u03B5\u03B2\u03B4\u03BF\u03BC\u03B1\u03B4\u03B9\u03B1\u03AF\u03B1 \u03B2\u03AC\u03C3\u03B7","schedule_i_need_schedule_daily":"\u03A7\u03C1\u03B5\u03B9\u03AC\u03B6\u03B5\u03C4\u03B1\u03B9 \u03BD\u03B1 \u03C0\u03C1\u03BF\u03B3\u03C1\u03B1\u03BC\u03BC\u03B1\u03C4\u03AF\u03C3\u03C9 \u03C3\u03B5 \u03BA\u03B1\u03B8\u03B7\u03BC\u03B5\u03C1\u03B9\u03BD\u03AE \u03B2\u03AC\u03C3\u03B7","schedule_schedule_daily":"\u03A0\u03C1\u03BF\u03B3\u03C1\u03B1\u03BC\u03BC\u03B1\u03C4\u03B9\u03C3\u03BC\u03CC\u03C2 \u03C3\u03B5 \u03B7\u03BC\u03B5\u03C1\u03AE\u03C3\u03B9\u03B1 \u03B2\u03AC\u03C3\u03B7","time_title":"\u03A0\u03BF\u03B9\u03BF \u03B5\u03AF\u03BD\u03B1\u03B9 \u03C4\u03BF \u03C9\u03C1\u03B9\u03B1\u03AF\u03BF \u03C0\u03C1\u03CC\u03B3\u03C1\u03B1\u03BC\u03BC\u03B1 \u03C4\u03B7\u03C2 \u03B8\u03AD\u03C3\u03B7\u03C2;","time_subtitle":"\u0395\u03C0\u03B9\u03BB\u03AD\u03BE\u03C4\u03B5 \u03C0\u03BF\u03B9\u03B5\u03C2 \u03B7\u03BC\u03AD\u03C1\u03B5\u03C2 \u03B8\u03AD\u03BB\u03B5\u03C4\u03B5 \u03BD\u03B1 \u03B5\u03C1\u03B3\u03AC\u03B6\u03B5\u03C4\u03B1\u03B9 \u03C4\u03BF \u03C0\u03C1\u03BF\u03C3\u03C9\u03C0\u03B9\u03BA\u03CC","time_select_dates_schedule":"\u0395\u03C0\u03B9\u03BB\u03AD\u03BE\u03C4\u03B5 \u03C0\u03C1\u03CE\u03C4\u03B1 \u03B7\u03BC\u03B5\u03C1\u03BF\u03BC\u03B7\u03BD\u03AF\u03B5\u03C2 \u03BA\u03B1\u03B9 \u03C4\u03CD\u03C0\u03BF \u03C0\u03C1\u03BF\u03B3\u03C1\u03AC\u03BC\u03BC\u03B1\u03C4\u03BF\u03C2","time_days_selected":"{{count}} \u03B7\u03BC\u03AD\u03C1\u03B5\u03C2 \u03B5\u03C0\u03B9\u03BB\u03AD\u03C7\u03B8\u03B7\u03BA\u03B1\u03BD","time_dates_selected":"{{count}} \u03B7\u03BC\u03B5\u03C1\u03BF\u03BC\u03B7\u03BD\u03AF\u03B5\u03C2 \u03B5\u03C0\u03B9\u03BB\u03AD\u03C7\u03B8\u03B7\u03BA\u03B1\u03BD","requirements_title":"\u03A7\u03C1\u03B5\u03B9\u03AC\u03B6\u03B5\u03C4\u03B1\u03B9 \u03BD\u03B1 \u03B4\u03B9\u03B1\u03B8\u03AD\u03C4\u03BF\u03C5\u03BD \u03BA\u03AC\u03C0\u03BF\u03B9\u03B1 \u03B5\u03BE\u03B5\u03B9\u03B4\u03AF\u03BA\u03B5\u03C5\u03C3\u03B7 \u03BF\u03B9 \u03B5\u03C1\u03B3\u03B1\u03B6\u03CC\u03BC\u03B5\u03BD\u03BF\u03B9;","requirements_subtitle":"\u0395\u03C0\u03B9\u03BB\u03AD\u03BE\u03C4\u03B5 \u03C4\u03B7\u03BD \u03B5\u03BE\u03B5\u03B9\u03B4\u03AF\u03BA\u03B5\u03C5\u03C3\u03B7 \u03C0\u03BF\u03C5 \u03C4\u03B1\u03B9\u03C1\u03AF\u03B1\u03B6\u03B5\u03B9 \u03BA\u03B1\u03BB\u03CD\u03C4\u03B5\u03C1\u03B1 \u03BC\u03B5 \u03C4\u03B9\u03C2 \u03B1\u03C0\u03B1\u03B9\u03C4\u03AE\u03C3\u03B5\u03B9\u03C2 \u03C4\u03B7\u03C2 \u03B8\u03AD\u03C3\u03B7\u03C2.","requirements_add_new":"\u03A0\u03C1\u03BF\u03C3\u03B8\u03AE\u03BA\u03B7 \u039D\u03AD\u03B1\u03C2 \u0394\u03B5\u03BE\u03B9\u03CC\u03C4\u03B7\u03C4\u03B1\u03C2","requirements_create":"\u0394\u03B7\u03BC\u03B9\u03BF\u03C5\u03C1\u03B3\u03AE\u03C3\u03C4\u03B5 \u0395\u03C0\u03B1\u03B3\u03B3\u03B5\u03BB\u03BC\u03B1\u03C4\u03B9\u03BA\u03AE \u0394\u03B5\u03BE\u03B9\u03CC\u03C4\u03B7\u03C4\u03B1","requirement_requirement":"\u0394\u03B5\u03BE\u03B9\u03CC\u03C4\u03B7\u03C4\u03B1","requirement_add_requirement":"\u03A0\u03C1\u03BF\u03C3\u03B8\u03AD\u03C3\u03C4\u03B5 \u0394\u03B5\u03BE\u03B9\u03CC\u03C4\u03B7\u03C4\u03B1","description_title":"\u039C\u03B5 \u03C4\u03B9 \u03B8\u03B1 \u03B1\u03C0\u03B1\u03C3\u03C7\u03BF\u03BB\u03B7\u03B8\u03BF\u03CD\u03BD;","description_subtitle":"\u03A0\u03C1\u03BF\u03C3\u03B8\u03AD\u03C3\u03C4\u03B5 \u03BC\u03B9\u03B1 \u03C0\u03B5\u03C1\u03B9\u03B3\u03C1\u03B1\u03C6\u03AE \u03C4\u03B7\u03C2 \u03B8\u03AD\u03C3\u03B7\u03C2 (\u03A0\u03B5\u03C1\u03B9\u03B3\u03C1\u03AC\u03C8\u03C4\u03B5 \u03C4\u03B1 \u03BA\u03B1\u03B8\u03AE\u03BA\u03BF\u03BD\u03C4\u03B1 \u03BA\u03B1\u03B9 \u03C4\u03B9\u03C2 \u03B5\u03C5\u03B8\u03CD\u03BD\u03B5\u03C2 \u03C0\u03BF\u03C5 \u03B8\u03B1 \u03B1\u03BD\u03B1\u03BB\u03AC\u03B2\u03BF\u03C5\u03BD)","description_placeholder":"\u03A0\u03B5\u03C1\u03B9\u03B3\u03C1\u03AC\u03C8\u03C4\u03B5 \u03C4\u03B9\u03C2 \u03BB\u03B5\u03C0\u03C4\u03BF\u03BC\u03AD\u03C1\u03B5\u03B9\u03B5\u03C2 \u03C4\u03B7\u03C2 \u03B8\u03AD\u03C3\u03B7\u03C2","experience_title":"\u03A0\u03CC\u03C3\u03BF \u03AD\u03BC\u03C0\u03B5\u03B9\u03C1\u03BF \u03C7\u03C1\u03B5\u03B9\u03AC\u03B6\u03B5\u03C4\u03B1\u03B9 \u03BD\u03B1 \u03B5\u03AF\u03BD\u03B1\u03B9 \u03C4\u03BF \u03C0\u03C1\u03BF\u03C3\u03C9\u03C0\u03B9\u03BA\u03CC;","experience_subtitle":"\u0395\u03C0\u03B9\u03BB\u03AD\u03BE\u03C4\u03B5 \u03C4\u03BF \u03B5\u03C0\u03AF\u03C0\u03B5\u03B4\u03BF \u03B5\u03BC\u03C0\u03B5\u03B9\u03C1\u03AF\u03B1\u03C2 \u03C0\u03BF\u03C5 \u03B8\u03AD\u03BB\u03B5\u03C4\u03B5 \u03BD\u03B1 \u03AD\u03C7\u03B5\u03B9 \u03C4\u03BF \u03C0\u03C1\u03BF\u03C3\u03C9\u03C0\u03B9\u03BA\u03CC","experience_student":"\u03A6\u03BF\u03B9\u03C4\u03B7\u03C4\u03AE\u03C2/\u03C4\u03C1\u03B9\u03B1","experience_beginner":"\u0391\u03C1\u03C7\u03AC\u03C1\u03B9\u03BF\u03C2","experience_junior":"Junior - \u039C\u03B5 \u03BC\u03B9\u03BA\u03C1\u03AE \u03B5\u03BC\u03C0\u03B5\u03B9\u03C1\u03AF\u03B1","experience_middle":"Mid-Senior - \u0391\u03C1\u03BA\u03B5\u03C4\u03AE \u03B5\u03BC\u03C0\u03B5\u03B9\u03C1\u03AF\u03B1","experience_senior":"Senior - \u03A0\u03BF\u03BB\u03CD \u03B5\u03BC\u03C0\u03B5\u03B9\u03C1\u03AF\u03B1","experience_hint":"*\u039F\u03C3\u03BF \u03BC\u03B5\u03B3\u03B1\u03BB\u03CD\u03C4\u03B5\u03C1\u03B7 \u03B5\u03AF\u03BD\u03B1\u03B9 \u03B7 \u03B5\u03BC\u03C0\u03B5\u03B9\u03C1\u03AF\u03B1, \u03C4\u03CC\u03C3\u03BF \u03B1\u03C5\u03BE\u03AC\u03BD\u03B5\u03C4\u03B1\u03B9 \u03C4\u03BF \u03C9\u03C1\u03BF\u03BC\u03AF\u03C3\u03B8\u03B9\u03BF.","experience_years":"\u03C7\u03C1\u03CC\u03BD\u03B9\u03B1","uniform_title":"\u0388\u03C7\u03B5\u03C4\u03B5 \u03C0\u03C1\u03BF\u03C4\u03AF\u03BC\u03B7\u03C3\u03B7 \u03B3\u03B9\u03B1 \u03C4\u03BF\u03BD \u03B5\u03BD\u03B4\u03C5\u03BC\u03B1\u03C4\u03BF\u03BB\u03BF\u03B3\u03B9\u03BA\u03CC \u03BA\u03CE\u03B4\u03B9\u03BA\u03B1;","uniform_subtitle":"\u0395\u03BD\u03B7\u03BC\u03B5\u03C1\u03CE\u03C3\u03C4\u03B5 \u03BC\u03B1\u03C2 \u03AD\u03B1\u03BD \u03B7 \u03B8\u03AD\u03C3\u03B7 \u03B1\u03C0\u03B1\u03B9\u03C4\u03B5\u03AF \u03B5\u03C0\u03AF\u03C3\u03B7\u03BC\u03BF \u03AE \u03BA\u03B1\u03B8\u03B7\u03BC\u03B5\u03C1\u03B9\u03BD\u03CC \u03BD\u03C4\u03CD\u03C3\u03B9\u03BC\u03BF","uniform_dresscode":"\u0395\u03BD\u03B4\u03C5\u03BC\u03B1\u03C4\u03BF\u03BB\u03BF\u03B3\u03B9\u03BA\u03CC\u03C2 \u039A\u03CE\u03B4\u03B9\u03BA\u03B1\u03C2","preferences_title":"\u0388\u03C7\u03B5\u03C4\u03B5 \u03AC\u03BB\u03BB\u03B5\u03C2 \u03B5\u03C0\u03B9\u03C0\u03BB\u03AD\u03BF\u03BD \u03C0\u03C1\u03BF\u03C4\u03B9\u03BC\u03AE\u03C3\u03B5\u03B9\u03C2;","preferences_subtitle":"\u03A3\u03CD\u03C1\u03B5\u03C4\u03B5 \u03C3\u03C4\u03B7\u03BD \u03AD\u03BD\u03B4\u03B5\u03B9\u03BE\u03B7 \u039D \u03B3\u03B9\u03B1 \u03CC\u03C0\u03BF\u03B9\u03B1 \u03B1\u03C0\u03CC \u03C4\u03B1 \u03C0\u03B1\u03C1\u03B1\u03BA\u03AC\u03C4\u03C9 \u03B5\u03C0\u03B9\u03B8\u03C5\u03BC\u03B5\u03AF\u03C4\u03B5 \u03BD\u03B1 \u03C3\u03C5\u03BC\u03C0\u03B5\u03C1\u03B9\u03BB\u03B7\u03C6\u03B8\u03BF\u03CD\u03BD.","preferences_languages":"\u0393\u03BB\u03CE\u03C3\u03C3\u03B1","preferences_gender":"\u03A6\u03CD\u03BB\u03BF","preferences_documents":"\u0395\u03C0\u03B9\u03C0\u03BB\u03AD\u03BF\u03BD \u0388\u03B3\u03B3\u03C1\u03B1\u03C6\u03B1","preferences_interview":"\u03A3\u03C5\u03BD\u03AD\u03BD\u03C4\u03B5\u03C5\u03BE\u03B7 \u03BC\u03AD\u03C3\u03C9 \u0392\u03AF\u03BD\u03C4\u03B5\u03BF","nationalities":"Nationality","nationalities_title":"What are your preferred nationalities?","nationalities_subtitle":"Select specific nationalities that align with your hiring needs","nationalities_option_any":"Hire the best talent, regardless of nationality","preferences_manual_staff_selection":"\u03A7\u03B5\u03B9\u03C1\u03BF\u03BA\u03AF\u03BD\u03B7\u03C4\u03B7 \u0395\u03C0\u03B9\u03BB\u03BF\u03B3\u03AE \u03A0\u03C1\u03BF\u03C3\u03C9\u03C0\u03B9\u03BA\u03BF\u03CD","preferences_accreditation_required":"\u0391\u03C0\u03B1\u03B9\u03C4\u03B5\u03AF\u03C4\u03B1\u03B9 \u0394\u03B9\u03B1\u03C0\u03AF\u03C3\u03C4\u03B5\u03C5\u03C3\u03B7","preferences_accommodation_offered":"\u03A0\u03B1\u03C1\u03BF\u03C7\u03AE \u03B4\u03C9\u03C1\u03B5\u03AC\u03BD \u03B4\u03B9\u03B1\u03BC\u03BF\u03BD\u03AE\u03C2","accommodation_required":"\u0391\u03C0\u03B1\u03B9\u03C4\u03B5\u03AF\u03C4\u03B1\u03B9 \u0394\u03B9\u03B1\u03BC\u03BF\u03BD\u03AE","accommodation_yes":"\u039D\u03B1\u03B9","accommodation_no":"\u038C\u03C7\u03B9","boarding_required":"\u0391\u03C0\u03B1\u03B9\u03C4\u03B5\u03AF\u03C4\u03B1\u03B9 \u03A3\u03AF\u03C4\u03B9\u03C3\u03B7","transport_accessibility_required":"\u0391\u03C0\u03B1\u03B9\u03C4\u03B5\u03AF\u03C4\u03B1\u03B9 \u03A0\u03C1\u03CC\u03C3\u03B2\u03B1\u03C3\u03B7 \u03C3\u03B5 \u039C\u03AD\u03C3\u03B1 \u039C\u03B5\u03C4\u03B1\u03C6\u03BF\u03C1\u03AC\u03C2","preferences_boarding_offered":"\u03A0\u03B1\u03C1\u03BF\u03C7\u03AE \u03C3\u03AF\u03C4\u03B9\u03C3\u03B7\u03C2","accommodation_title":"\u03A0\u03B1\u03C1\u03AD\u03C7\u03B5\u03C4\u03B5 \u03C3\u03AF\u03C4\u03B9\u03C3\u03B7 \u03B3\u03B9\u03B1 \u03B1\u03C5\u03C4\u03AE \u03C4\u03B7 \u03B8\u03AD\u03C3\u03B7 \u03B5\u03C1\u03B3\u03B1\u03C3\u03AF\u03B1\u03C2;","do_you_offer_accommodation":"\u03A0\u03B1\u03C1\u03AD\u03C7\u03B5\u03C4\u03B5 \u03B4\u03C9\u03C1\u03B5\u03AC\u03BD \u03B4\u03B9\u03B1\u03BC\u03BF\u03BD\u03AE \u03B3\u03B9\u03B1 \u03B1\u03C5\u03C4\u03AE \u03C4\u03B7 \u03B8\u03AD\u03C3\u03B7 \u03B5\u03C1\u03B3\u03B1\u03C3\u03AF\u03B1\u03C2;","no_boarding":"\u0394\u03B5\u03BD \u03C0\u03B1\u03C1\u03AD\u03C7\u03B5\u03C4\u03B1\u03B9 \u03C3\u03AF\u03C4\u03B9\u03C3\u03B7","half_boarding":"\u039C\u03B5\u03C1\u03B9\u03BA\u03AE \u03C3\u03AF\u03C4\u03B9\u03C3\u03B7","full_boarding":"\u03A0\u03BB\u03AE\u03C1\u03B7\u03C2 \u03C3\u03AF\u03C4\u03B9\u03C3\u03B7","languages_title":"\u03A0\u03BF\u03B9\u03B1 \u03B5\u03AF\u03BD\u03B1\u03B9 \u03B7 \u03C0\u03C1\u03BF\u03C4\u03B9\u03BC\u03CE\u03BC\u03B5\u03BD\u03B7 \u03B3\u03BB\u03CE\u03C3\u03C3\u03B1 \u03B5\u03C0\u03B9\u03BA\u03BF\u03B9\u03BD\u03C9\u03BD\u03AF\u03B1\u03C2 \u03BC\u03B1\u03B6\u03AF \u03C3\u03B1\u03C2;","languages_subtitle":"\u0395\u03C0\u03B9\u03BB\u03AD\u03BE\u03C4\u03B5 \u03C4\u03B9\u03C2 \u03B3\u03BB\u03CE\u03C3\u03C3\u03B5\u03C2 \u03C0\u03BF\u03C5 \u03C7\u03C1\u03B5\u03B9\u03AC\u03B6\u03B5\u03C4\u03B1\u03B9 \u03BD\u03B1 \u03B3\u03BD\u03C9\u03C1\u03AF\u03B6\u03B5\u03B9 \u03C4\u03BF \u03C0\u03C1\u03BF\u03C3\u03C9\u03C0\u03B9\u03BA\u03CC","gender_title":"\u03A0\u03BF\u03B9\u03B1 \u03B5\u03AF\u03BD\u03B1\u03B9 \u03B7 \u03C0\u03C1\u03BF\u03C4\u03AF\u03BC\u03B7\u03C3\u03AE \u03C3\u03B1\u03C2 \u03B3\u03B9\u03B1 \u03C4\u03BF \u03C6\u03CD\u03BB\u03BF;","gender_subtitle":"\u0395\u03C0\u03B9\u03BB\u03AD\u03BE\u03C4\u03B5 \u03C0\u03C1\u03BF\u03C4\u03AF\u03BC\u03B7\u03C3\u03B7 \u03C6\u03CD\u03BB\u03BF\u03C5, \u03B5\u03AC\u03BD \u03C5\u03C0\u03AC\u03C1\u03C7\u03B5\u03B9","gender_male":"\u0386\u03BD\u03C4\u03C1\u03B1\u03C2","gender_female":"\u0393\u03C5\u03BD\u03B1\u03AF\u03BA\u03B1","gender_no_preference":"\u038C\u03C7\u03B9","documents_title":"\u03A0\u03BF\u03B9\u03B1 \u03B5\u03AF\u03BD\u03B1\u03B9 \u03C4\u03B1 \u03B1\u03C0\u03B1\u03B9\u03C4\u03BF\u03CD\u03BC\u03B5\u03BD\u03B1 \u03C0\u03C1\u03CC\u03C3\u03B8\u03B5\u03C4\u03B1 \u03AD\u03B3\u03B3\u03C1\u03B1\u03C6\u03B1;","documents_subtitle":"\u0395\u03C0\u03B9\u03BB\u03AD\u03BE\u03C4\u03B5 \u03C4\u03B1 \u03B1\u03C0\u03B1\u03B9\u03C4\u03BF\u03CD\u03BC\u03B5\u03BD\u03B1 \u03AD\u03B3\u03B3\u03C1\u03B1\u03C6\u03B1","manual_selectinon_title":"\u0398\u03B1 \u03B8\u03AD\u03BB\u03B1\u03C4\u03B5 \u03BD\u03B1 \u03B5\u03C0\u03B9\u03BB\u03AD\u03BE\u03BF\u03C5\u03BC\u03B5 \u03B1\u03C5\u03C4\u03CC\u03BC\u03B1\u03C4\u03B1 \u03B3\u03B9\u03B1 \u03B5\u03C3\u03AC\u03C2 \u03C4\u03BF\u03C5\u03C2 \u03B9\u03B4\u03B1\u03BD\u03B9\u03BA\u03BF\u03CD\u03C2 Ogrammers \u03B3\u03B9\u03B1 \u03C4\u03B7\u03BD \u03B8\u03AD\u03C3\u03B7;","manual_selectinon_subtitle":"\u0395\u03AC\u03BD \u03B5\u03C0\u03B9\u03BB\u03AD\u03BE\u03B5\u03C4\u03B5 \xab\u03CC\u03C7\u03B9\xbb \u03B8\u03B1 \u03C7\u03C1\u03B5\u03B9\u03B1\u03C3\u03C4\u03B5\u03AF \u03BD\u03B1 \u03B4\u03B9\u03B1\u03BB\u03AD\u03BE\u03B5\u03C4\u03B5 Ogrammers \u03C7\u03B5\u03B9\u03C1\u03BF\u03BA\u03AF\u03BD\u03B7\u03C4\u03B1 \u03BA\u03B1\u03B9 \u03B4\u03B5\u03BD \u03B8\u03B1 \u03B5\u03C0\u03C9\u03C6\u03B5\u03BB\u03B7\u03B8\u03B5\u03AF\u03C4\u03B5 \u03B1\u03C0\u03CC \u03C4\u03BF\u03BD \u03B1\u03BB\u03B3\u03CC\u03C1\u03B9\u03B8\u03BC\u03BF Smart Staff Selection","manual_selectinon_yes":"\u039D\u03B1\u03B9","manual_selectinon_no":"\u038C\u03C7\u03B9","accreditation_title":"\u0398\u03B1 \u03C7\u03C1\u03B5\u03B9\u03B1\u03C3\u03C4\u03B5\u03AF \u03BA\u03AC\u03C0\u03BF\u03B9\u03B1 \u03B4\u03B9\u03B1\u03C0\u03AF\u03C3\u03C4\u03B5\u03C5\u03C3\u03B7 \u03C4\u03BF \u03C0\u03C1\u03BF\u03C3\u03C9\u03C0\u03B9\u03BA\u03CC \u03B3\u03B9\u03B1 \u03C4\u03B7\u03BD \u03B5\u03AF\u03C3\u03BF\u03B4\u03BF \u03C3\u03C4\u03BF\u03BD \u03C7\u03CE\u03C1\u03BF/\u03B5\u03BA\u03B4\u03AE\u03BB\u03C9\u03C3\u03B7;","accreditation_subtitle":"\u039B\u03AC\u03B2\u03B5\u03C4\u03B5 \u03C5\u03C0\u03CC\u03C8\u03B7 \u03CC\u03C4\u03B9 \u03B7 \u03B4\u03B9\u03B1\u03C0\u03AF\u03C3\u03C4\u03B5\u03C5\u03C3\u03B7 \u03B8\u03B1 \u03B5\u03C0\u03B7\u03C1\u03B5\u03AC\u03C3\u03B5\u03B9 \u03C4\u03BF\u03BD \u03C7\u03C1\u03CC\u03BD\u03BF \u03B5\u03BA\u03C0\u03BB\u03AE\u03C1\u03C9\u03C3\u03B7\u03C2 \u03C4\u03B7\u03C2 \u03C0\u03B1\u03C1\u03B1\u03B3\u03B3\u03B5\u03BB\u03AF\u03B1\u03C2 \u03C3\u03B1\u03C2","accreditation_yes":"\u039D\u03B1\u03B9","accreditation_no":"\u038C\u03C7\u03B9","poc_title":"\u03A0\u03BF\u03B9\u03BF\u03C2 \u03B8\u03B1 \u03B4\u03B9\u03B1\u03C7\u03B5\u03B9\u03C1\u03B9\u03C3\u03C4\u03B5\u03AF \u03C4\u03B7\u03BD \u03C0\u03C1\u03BF\u03C3\u03AD\u03BB\u03B5\u03C5\u03C3\u03B7;","poc_subtitle":"\u0395\u03C0\u03B9\u03BB\u03AD\u03BE\u03C4\u03B5 \u03C4\u03BF \u03AC\u03C4\u03BF\u03BC\u03BF \u03B1\u03C0\u03CC \u03C4\u03B7\u03BD \u03B5\u03C0\u03B9\u03C7\u03B5\u03AF\u03C1\u03B7\u03C3\u03AE \u03C3\u03B1\u03C2 \u03C0\u03BF\u03C5 \u03B8\u03B1 \u03B5\u03AF\u03BD\u03B1\u03B9 \u03C4\u03BF \u03BA\u03CD\u03C1\u03B9\u03BF \u03C0\u03C1\u03CC\u03C3\u03C9\u03C0\u03BF \u03B5\u03C0\u03B9\u03BA\u03BF\u03B9\u03BD\u03C9\u03BD\u03AF\u03B1\u03C2 \u03B3\u03B9\u03B1 \u03C4\u03B7 \u03B8\u03AD\u03C3\u03B7","point_of_contact":"\u03A0\u03C1\u03CC\u03C3\u03C9\u03C0\u03BF \u0395\u03C0\u03B9\u03BA\u03BF\u03B9\u03BD\u03C9\u03BD\u03AF\u03B1\u03C2","add_poc":"\u03A0\u03C1\u03BF\u03C3\u03B8\u03AD\u03C3\u03C4\u03B5 \u03BD\u03AD\u03BF \u03C0\u03C1\u03CC\u03C3\u03C9\u03C0\u03BF \u03B5\u03C0\u03B9\u03BA\u03BF\u03B9\u03BD\u03C9\u03BD\u03AF\u03B1\u03C2","select_location_first":"\u03A0\u03B1\u03C1\u03B1\u03BA\u03B1\u03BB\u03BF\u03CD\u03BC\u03B5, \u03C3\u03C5\u03BC\u03C0\u03BB\u03B7\u03C1\u03CE\u03C3\u03C4\u03B5 \u03C0\u03C1\u03CE\u03C4\u03B1 \u03C4\u03B7\u03BD \u03C4\u03BF\u03C0\u03BF\u03B8\u03B5\u03C3\u03AF\u03B1 \u03C4\u03B7\u03C2 \u03B8\u03AD\u03C3\u03B7\u03C2","poc_required":"\u0395\u03C0\u03B9\u03BB\u03AD\u03BE\u03C4\u03B5 \u03B5\u03C0\u03B9\u03BA\u03BF\u03B9\u03BD\u03C9\u03BD\u03AF\u03B1","start_date_must_be_at_least_today":"\u0397 \u03B7\u03BC\u03B5\u03C1\u03BF\u03BC\u03B7\u03BD\u03AF\u03B1 \u03AD\u03BD\u03B1\u03C1\u03BE\u03B7\u03C2 \u03C0\u03C1\u03AD\u03C0\u03B5\u03B9 \u03BD\u03B1 \u03BF\u03C1\u03B9\u03C3\u03C4\u03B5\u03AF \u03C4\u03BF \u03BD\u03C9\u03C1\u03AF\u03C4\u03B5\u03C1\u03BF \u03C3\u03AE\u03BC\u03B5\u03C1\u03B1","end_date_must_be_at_least_today":"\u0397 \u03B7\u03BC\u03B5\u03C1\u03BF\u03BC\u03B7\u03BD\u03AF\u03B1 \u03BB\u03AE\u03BE\u03B7\u03C2 \u03C0\u03C1\u03AD\u03C0\u03B5\u03B9 \u03BD\u03B1 \u03BF\u03C1\u03B9\u03C3\u03C4\u03B5\u03AF \u03C4\u03BF \u03BD\u03C9\u03C1\u03AF\u03C4\u03B5\u03C1\u03BF \u03C3\u03AE\u03BC\u03B5\u03C1\u03B1","greece_launch_info":"\u0398\u03B1 \u03B8\u03AD\u03BB\u03B1\u03BC\u03B5 \u03BD\u03B1 \u03C3\u03B1\u03C2 \u03B5\u03BD\u03B7\u03BC\u03B5\u03C1\u03CE\u03C3\u03BF\u03C5\u03BC\u03B5 \u03CC\u03C4\u03B9 \u03B7 \u03B4\u03B7\u03BC\u03B9\u03BF\u03C5\u03C1\u03B3\u03AF\u03B1 \u03B8\u03AD\u03C3\u03B7\u03C2 \u03B5\u03C1\u03B3\u03B1\u03C3\u03AF\u03B1\u03C2 \u03BC\u03C0\u03BF\u03C1\u03B5\u03AF \u03BD\u03B1 \u03B3\u03AF\u03BD\u03B5\u03B9 \u03BC\u03B5\u03C4\u03AC \u03C4\u03B9\u03C2 1 \u0399\u03BF\u03C5\u03BD\u03AF\u03BF\u03C5. \u0395\u03C0\u03B5\u03BE\u03B5\u03C1\u03B3\u03B1\u03B6\u03CC\u03BC\u03B1\u03C3\u03C4\u03B5 \u03C4\u03B1 \u03B1\u03B9\u03C4\u03AE\u03BC\u03B1\u03C4\u03AC \u03C3\u03B1\u03C2 \u03B5\u03BD\u03C4\u03CC\u03C2 72 \u03C9\u03C1\u03CE\u03BD. \u03A4\u03C5\u03C7\u03CC\u03BD \u03B1\u03B9\u03C4\u03AE\u03BC\u03B1\u03C4\u03B1 \u03C0\u03BF\u03C5 \u03C5\u03C0\u03BF\u03B2\u03BB\u03AE\u03B8\u03B7\u03BA\u03B1\u03BD \u03C0\u03C1\u03B9\u03BD \u03B1\u03C0\u03CC \u03B1\u03C5\u03C4\u03AE \u03C4\u03B7\u03BD \u03B7\u03BC\u03B5\u03C1\u03BF\u03BC\u03B7\u03BD\u03AF\u03B1 \u03B4\u03B5\u03BD \u03B8\u03B1 \u03C5\u03C0\u03BF\u03B2\u03BB\u03B7\u03B8\u03BF\u03CD\u03BD \u03C3\u03B5 \u03B5\u03C0\u03B5\u03BE\u03B5\u03C1\u03B3\u03B1\u03C3\u03AF\u03B1. \u0395\u03C5\u03C7\u03B1\u03C1\u03B9\u03C3\u03C4\u03BF\u03CD\u03BC\u03B5 \u03B3\u03B9\u03B1 \u03C4\u03B7\u03BD \u03BA\u03B1\u03C4\u03B1\u03BD\u03CC\u03B7\u03C3\u03AE \u03C3\u03B1\u03C2","select_document":"\u0395\u03C0\u03B9\u03BB\u03AD\u03BE\u03C4\u03B5 \u03B1\u03C1\u03C7\u03B5\u03AF\u03B1","junior":"\u0391\u03C1\u03C7\u03AC\u03C1\u03B9\u03BF\u03C2","midSenior":"\u039C\u03B5 \u03BB\u03AF\u03B3\u03B7 \u03B5\u03BC\u03C0\u03B5\u03B9\u03C1\u03AF\u03B1","senior":"\u0388\u03BC\u03C0\u03B5\u03B9\u03C1\u03BF\u03C2","student":"\u03A6\u03BF\u03B9\u03C4\u03B7\u03C4\u03AE\u03C2","beginner":"\u0391\u03C1\u03C7\u03AC\u03C1\u03B9\u03BF\u03C2","interview_title":"\u03A0\u03BF\u03B9\u03B5\u03C2 \u03B5\u03AF\u03BD\u03B1\u03B9 \u03BF\u03B9 \u03B2\u03B1\u03C3\u03B9\u03BA\u03AD\u03C2 \u03B8\u03B5\u03BC\u03B1\u03C4\u03B9\u03BA\u03AD\u03C2 \u03C0\u03BF\u03C5 \u03B8\u03B1 \u03B8\u03AD\u03BB\u03B1\u03C4\u03B5 \u03BD\u03B1 \u03BA\u03B1\u03BB\u03CD\u03C8\u03B5\u03C4\u03B5 \u03BC\u03B5 \u03C4\u03BF\u03C5\u03C2 \u03C5\u03C0\u03BF\u03C8\u03AE\u03C6\u03B9\u03BF\u03C5\u03C2;","interview_subtitle":"\u039F\u03B9 OG \u03B8\u03B1 \u03C5\u03C0\u03BF\u03B2\u03AC\u03BB\u03BF\u03C5\u03BD \u03B2\u03B9\u03BD\u03C4\u03B5\u03BF\u03C3\u03BA\u03BF\u03C0\u03B7\u03BC\u03AD\u03BD\u03B5\u03C2 \u03C4\u03B9\u03C2 \u03B5\u03C1\u03C9\u03C4\u03AE\u03C3\u03B5\u03B9\u03C2 \u03C4\u03BF\u03C5\u03C2 \u03BA\u03B1\u03B9 \u03C4\u03B9\u03C2 \u03B1\u03C0\u03B1\u03BD\u03C4\u03AE\u03C3\u03B5\u03B9\u03C2","interview_new_question":"\u03A0\u03C1\u03BF\u03C3\u03B8\u03AE\u03BA\u03B7 \u039D\u03AD\u03B1\u03C2 \u0395\u03C1\u03CE\u03C4\u03B7\u03C3\u03B7\u03C2;","interview_question_form_title":"\u03A0\u03C1\u03BF\u03C3\u03B8\u03AE\u03BA\u03B7 \u039D\u03AD\u03B1\u03C2 \u0395\u03C1\u03CE\u03C4\u03B7\u03C3\u03B7\u03C2","interview_question_form_placeholder":"\u03A0\u03BB\u03B7\u03BA\u03C4\u03C1\u03BF\u03BB\u03BF\u03B3\u03AE\u03C3\u03C4\u03B5 \u03C4\u03B7\u03BD \u03C0\u03B5\u03C1\u03B9\u03B3\u03C1\u03B1\u03C6\u03AE \u03B5\u03B4\u03CE","interview_question_form_submit":"\u03A5\u03C0\u03BF\u03B2\u03BF\u03BB\u03AE","interview_question_created":"\u0397 \u03B5\u03C1\u03CE\u03C4\u03B7\u03C3\u03B7 \u03AD\u03C7\u03B5\u03B9 \u03C0\u03C1\u03BF\u03C3\u03C4\u03B5\u03B8\u03B5\u03AF!","start_and_end_date_must_be_selected":"\u0397 \u0397\u03BC\u03B5\u03C1\u03BF\u03BC\u03B7\u03BD\u03AF\u03B1 \u0388\u03BD\u03B1\u03C1\u03BE\u03B7\u03C2: {{startDate}} \u03BA\u03B1\u03B9 \u03B7 \u0397\u03BC\u03B5\u03C1\u03BF\u03BC\u03B7\u03BD\u03AF\u03B1 \u039B\u03AE\u03BE\u03B7\u03C2: {{endDate}} \u03C0\u03C1\u03AD\u03C0\u03B5\u03B9 \u03BD\u03B1 \u03B5\u03AF\u03BD\u03B1\u03B9 \u03B5\u03C0\u03B9\u03BB\u03B5\u03B3\u03BC\u03AD\u03BD\u03B5\u03C2","what_are_the_shifts_timings":"\u03A0\u03B5\u03AF\u03C4\u03B5 \u03BC\u03B1\u03C2 \u03B3\u03B9\u03B1 \u03C4\u03BF \u03C9\u03C1\u03AC\u03C1\u03B9\u03BF \u03B5\u03C1\u03B3\u03B1\u03C3\u03AF\u03B1\u03C2 \u03C3\u03B5 \u03B1\u03C5\u03C4\u03AE\u03BD \u03C4\u03B7 \u03B8\u03AD\u03C3\u03B7:","what_are_job_timings":"\u03A0\u03BF\u03B9\u03B5\u03C2 \u03B5\u03AF\u03BD\u03B1\u03B9 \u03BF\u03B9 \u03CE\u03C1\u03B5\u03C2 \u03B5\u03C1\u03B3\u03B1\u03C3\u03AF\u03B1\u03C2;","select_same_time":"\u0395\u03C0\u03B9\u03BB\u03AD\u03BE\u03C4\u03B5 \u03C0\u03BF\u03B9\u03B5\u03C2 \u03CE\u03C1\u03B5\u03C2 \u03B8\u03AD\u03BB\u03B5\u03C4\u03B5 \u03BD\u03B1 \u03B5\u03C1\u03B3\u03AC\u03B6\u03B5\u03C4\u03B1\u03B9 \u03C4\u03BF \u03C0\u03C1\u03BF\u03C3\u03C9\u03C0\u03B9\u03BA\u03CC \u03BA\u03B1\u03B8\u03B7\u03BC\u03B5\u03C1\u03B9\u03BD\u03AC","start_and_ends_are_same":"\u039F\u03B9 \u03B2\u03AC\u03C1\u03B4\u03B9\u03B5\u03C2 \u03B8\u03B1 \u03BE\u03B5\u03BA\u03B9\u03BD\u03BF\u03CD\u03BD \u03BA\u03B1\u03B9 \u03B8\u03B1 \u03C4\u03B5\u03BB\u03B5\u03B9\u03CE\u03BD\u03BF\u03C5\u03BD \u03C4\u03B7\u03BD \u03AF\u03B4\u03B9\u03B1 \u03CE\u03C1\u03B1 \u03BA\u03AC\u03B8\u03B5 \u03BC\u03AD\u03C1\u03B1","time_vary":"\u039F\u03B9 \u03CE\u03C1\u03B5\u03C2 \u03B2\u03AC\u03C1\u03B4\u03B9\u03B1\u03C2 \u03B4\u03B9\u03B1\u03C6\u03AD\u03C1\u03BF\u03C5\u03BD \u03B1\u03C0\u03CC \u03BC\u03AD\u03C1\u03B1 \u03C3\u03B5 \u03BC\u03AD\u03C1\u03B1","less_than_24h_warning":"\u0397 \u03B4\u03BF\u03C5\u03BB\u03B5\u03B9\u03AC \u03BE\u03B5\u03BA\u03B9\u03BD\u03AC \u03C3\u03B5 \u03BB\u03B9\u03B3\u03CC\u03C4\u03B5\u03C1\u03BF \u03B1\u03C0\u03CC 24 \u03CE\u03C1\u03B5\u03C2 \u03BA\u03B1\u03B9 \u03BC\u03C0\u03BF\u03C1\u03B5\u03AF \u03BD\u03B1 \u03BC\u03B7\u03BD \u03AD\u03C7\u03BF\u03C5\u03BC\u03B5 \u03B1\u03C1\u03BA\u03B5\u03C4\u03CC \u03C7\u03C1\u03CC\u03BD\u03BF \u03B3\u03B9\u03B1 \u03BD\u03B1 \u03BA\u03B1\u03BB\u03CD\u03C8\u03BF\u03C5\u03BC\u03B5 \u03C4\u03B7\u03BD \u03B8\u03AD\u03C3\u03B7.","job_was_prefilled":"\u0397 \u03C6\u03CC\u03C1\u03BC\u03B1 \u03C0\u03C1\u03BF-\u03C3\u03C5\u03BC\u03C0\u03BB\u03B7\u03C1\u03CE\u03B8\u03B7\u03BA\u03B5 \u03B2\u03AC\u03C3\u03B5\u03B9 \u03C4\u03C9\u03BD \u03B4\u03B5\u03B4\u03BF\u03BC\u03AD\u03BD\u03C9\u03BD \u03C4\u03B7\u03C2 \u03C4\u03B5\u03BB\u03B5\u03C5\u03C4\u03B1\u03AF\u03B1\u03C2 \u03B8\u03AD\u03C3\u03B7\u03C2 \u03B5\u03C1\u03B3\u03B1\u03C3\u03AF\u03B1\u03C2","invited_quantity_more_than_required_quantity":"\u0388\u03C7\u03B5\u03C4\u03B5 \u03B5\u03C0\u03B9\u03BB\u03AD\u03BE\u03B5\u03B9 \u03C0\u03B5\u03C1\u03B9\u03C3\u03C3\u03CC\u03C4\u03B5\u03C1\u03BF\u03C5\u03C2 OGs \u03B1\u03C0\u03CC \u03CC\u03C3\u03BF\u03C5\u03C2 \u03B1\u03C0\u03B1\u03B9\u03C4\u03BF\u03CD\u03BD\u03C4\u03B1\u03B9 \u03B3\u03B9\u03B1 \u03C4\u03B7 \u03B8\u03AD\u03C3\u03B7. \u03A3\u03B5 \u03B1\u03C5\u03C4\u03AE \u03C4\u03B7\u03BD \u03C0\u03B5\u03C1\u03AF\u03C0\u03C4\u03C9\u03C3\u03B7, \u03BF \u03C0\u03C1\u03CE\u03C4\u03BF\u03C2 \u03C0\u03BF\u03C5 \u03B8\u03B1 \u03B1\u03C0\u03BF\u03B4\u03B5\u03C7\u03C4\u03B5\u03AF \u03C4\u03B7\u03BD \u03C0\u03C1\u03CC\u03C3\u03BA\u03BB\u03B7\u03C3\u03B7, \u03B8\u03B1 \u03B1\u03BD\u03B1\u03BB\u03AC\u03B2\u03B5\u03B9 \u03C4\u03B7\u03BD \u03B4\u03BF\u03C5\u03BB\u03B5\u03B9\u03AC"},"order_requested":{"title":"\u03A3\u03B1\u03C2 \u03B5\u03C5\u03C7\u03B1\u03C1\u03B9\u03C3\u03C4\u03BF\u03CD\u03BC\u03B5!","subtitle":"\u0397 \u03BF\u03BC\u03AC\u03B4\u03B1 \u03BC\u03B1\u03C2 \u03AD\u03C7\u03B5\u03B9 \u03BB\u03AC\u03B2\u03B5\u03B9 \u03C4\u03B7\u03BD \u03C0\u03B1\u03C1\u03B1\u03B3\u03B3\u03B5\u03BB\u03AF\u03B1 \u03C3\u03B1\u03C2 \u03BA\u03B1\u03B9 \u03B8\u03B1 \u03B5\u03C0\u03B9\u03BA\u03BF\u03B9\u03BD\u03C9\u03BD\u03AE\u03C3\u03BF\u03C5\u03BC\u03B5 \u03BC\u03B1\u03B6\u03AF \u03C3\u03B1\u03C2 \u03C3\u03CD\u03BD\u03C4\u03BF\u03BC\u03B1!","done":"\u03A4\u03AD\u03BB\u03BF\u03C2","complete_registration":"\u039F\u03BB\u03BF\u03BA\u03BB\u03AE\u03C1\u03C9\u03C3\u03B7 \u03B5\u03B3\u03B3\u03C1\u03B1\u03C6\u03AE\u03C2","later":"\u0391\u03C1\u03B3\u03CC\u03C4\u03B5\u03C1\u03B1"},"order_draft":{"title":"\u0394\u03B7\u03BC\u03B9\u03BF\u03C5\u03C1\u03B3\u03AF\u03B1 \u039D\u03AD\u03B1\u03C2 \u03A0\u03B1\u03C1\u03B1\u03B3\u03B3\u03B5\u03BB\u03AF\u03B1\u03C2","jobs":"\u0398\u03AD\u03C3\u03B5\u03B9\u03C2 \u0395\u03C1\u03B3\u03B1\u03C3\u03AF\u03B1\u03C2","confirm_delete_job":"\u0395\u03AF\u03C3\u03C4\u03B5 \u03C3\u03AF\u03B3\u03BF\u03C5\u03C1\u03BF\u03B9 \u03CC\u03C4\u03B9 \u03B8\u03AD\u03BB\u03B5\u03C4\u03B5 \u03BD\u03B1 \u03B4\u03B9\u03B1\u03B3\u03C1\u03AC\u03C8\u03B5\u03C4\u03B5 \u03C4\u03B7\u03BD \u03B8\u03AD\u03C3\u03B7 {{name}} ;","add_another_job":"+ \u03A0\u03C1\u03BF\u03C3\u03B8\u03AD\u03C3\u03C4\u03B5 \u03BA\u03B9 \u03AC\u03BB\u03BB\u03B7 \u0398\u03AD\u03C3\u03B7 \u0395\u03C1\u03B3\u03B1\u03C3\u03AF\u03B1\u03C2","add_another_job_with_plus":"\u03A0\u03C1\u03BF\u03C3\u03B8\u03AD\u03C3\u03C4\u03B5 \u03BA\u03B9 \u03AC\u03BB\u03BB\u03B7 \u0398\u03AD\u03C3\u03B7 \u0395\u03C1\u03B3\u03B1\u03C3\u03AF\u03B1\u03C2","add_first_job":"\u03A0\u03C1\u03BF\u03C3\u03B8\u03AD\u03C3\u03C4\u03B5 \u03C4\u03B7\u03BD \u03C0\u03C1\u03CE\u03C4\u03B7 \u0398\u03AD\u03C3\u03B7 \u0395\u03C1\u03B3\u03B1\u03C3\u03AF\u03B1\u03C2","continue":"\u03A3\u03C5\u03BD\u03AD\u03C7\u03B5\u03B9\u03B1","quantity":"\u03A0\u03BF\u03C3\u03CC\u03C4\u03B7\u03C4\u03B1","days":"\u0397\u03BC\u03AD\u03C1\u03B5\u03C2","days_amount":"{{count}} \u03B7\u03BC\u03AD\u03C1\u03B5\u03C2","location":"\u03A4\u03BF\u03C0\u03BF\u03B8\u03B5\u03C3\u03AF\u03B1","what_to_copy":"\u03A0\u03BF\u03B9\u03B5\u03C2 \u03C0\u03C1\u03BF\u03C4\u03B9\u03BC\u03AE\u03C3\u03B5\u03B9\u03C2 \u03B1\u03C0\u03CC \u03C4\u03B7\u03BD \u03B8\u03AD\u03C3\u03B7 {{category}} \u03B5\u03C0\u03B9\u03B8\u03C5\u03BC\u03B5\u03AF\u03C4\u03B5 \u03BD\u03B1 \u03B1\u03BD\u03C4\u03B9\u03B3\u03C1\u03AC\u03C8\u03B5\u03C4\u03B5;","select_preferences":"\u0395\u03C0\u03B9\u03BB\u03AD\u03BE\u03C4\u03B5 \u03C0\u03C1\u03BF\u03C4\u03B9\u03BC\u03AE\u03C3\u03B5\u03B9\u03C2 \u03C0\u03BF\u03C5 \u03B8\u03AD\u03BB\u03B5\u03C4\u03B5 \u03BD\u03B1 \u03B1\u03BD\u03C4\u03B9\u03B3\u03C1\u03B1\u03C6\u03BF\u03CD\u03BD","schedule":"\u03A0\u03C1\u03CC\u03B3\u03C1\u03B1\u03BC\u03BC\u03B1","requirements":"\u0391\u03C0\u03B1\u03B9\u03C4\u03AE\u03C3\u03B5\u03B9\u03C2","job_description":"\u03A0\u03B5\u03C1\u03B9\u03B3\u03C1\u03B1\u03C6\u03AE \u0395\u03C1\u03B3\u03B1\u03C3\u03AF\u03B1\u03C2","seniority_level":"\u0395\u03C0\u03AF\u03C0\u03B5\u03B4\u03BF \u0395\u03BC\u03C0\u03B5\u03B9\u03C1\u03AF\u03B1\u03C2","dresscode":"\u0395\u03BD\u03B4\u03C5\u03BC\u03B1\u03C4\u03BF\u03BB\u03BF\u03B3\u03B9\u03BA\u03CC\u03C2 \u039A\u03CE\u03B4\u03B9\u03BA\u03B1\u03C2","language":"\u0393\u03BB\u03CE\u03C3\u03C3\u03B1","gender":"\u03A6\u03CD\u03BB\u03BF","documents":"\u0395\u03C0\u03B9\u03C0\u03BB\u03AD\u03BF\u03BD \u0388\u03B3\u03B3\u03C1\u03B1\u03C6\u03B1","manual_selection":"\u03A7\u03B5\u03B9\u03C1\u03BF\u03BA\u03AF\u03BD\u03B7\u03C4\u03B7 \u0395\u03C0\u03B9\u03BB\u03BF\u03B3\u03AE \u03A0\u03C1\u03BF\u03C3\u03C9\u03C0\u03B9\u03BA\u03BF\u03CD","accreditation_requried":"\u0391\u03C0\u03B1\u03B9\u03C4\u03B5\u03AF\u03C4\u03B1\u03B9 \u0394\u03B9\u03B1\u03C0\u03AF\u03C3\u03C4\u03B5\u03C5\u03C3\u03B7 \u0395\u03B9\u03C3\u03CC\u03B4\u03BF\u03C5","accommodation_offered":"\u03A0\u03B1\u03C1\u03BF\u03C7\u03AE \u03B4\u03C9\u03C1\u03B5\u03AC\u03BD \u03B4\u03B9\u03B1\u03BC\u03BF\u03BD\u03AE\u03C2","interview_required":"\u03A3\u03C5\u03BD\u03AD\u03BD\u03C4\u03B5\u03C5\u03BE\u03B7 \u03BC\u03B5 \u0392\u03AF\u03BD\u03C4\u03B5\u03BF","boarding_offered":"\u03A0\u03B1\u03C1\u03BF\u03C7\u03AE \u03C3\u03AF\u03C4\u03B9\u03C3\u03B7\u03C2","duplicate_job":"\u0391\u03BD\u03C4\u03B9\u03B3\u03C1\u03B1\u03C6\u03AE \u03C4\u03B7\u03C2 \u0394\u03BF\u03C5\u03BB\u03B5\u03B9\u03AC\u03C2","blank_job":"\u039A\u03B5\u03BD\u03AE \u0394\u03BF\u03C5\u03BB\u03B5\u03B9\u03AC","workers":"\u03A0\u03C1\u03BF\u03C3\u03C9\u03C0\u03B9\u03BA\u03CC","jobs_count":"\u0391\u03C1\u03B9\u03B8\u03BC\u03CC\u03C2 \u0398\u03AD\u03C3\u03B5\u03C9\u03BD \u0395\u03C1\u03B3\u03B1\u03C3\u03AF\u03B1\u03C2: {{count}}","public_transport_accessibility":"\u03A0\u03C1\u03BF\u03C3\u03B2\u03B1\u03C3\u03B9\u03BC\u03CC\u03C4\u03B7\u03C4\u03B1 \u03C3\u03B5 \u039C\u03AD\u03C3\u03B1 \u039C\u03B1\u03B6\u03B9\u03BA\u03AE\u03C2 \u039C\u03B5\u03C4\u03B1\u03C6\u03BF\u03C1\u03AC\u03C2","public_transport_accessibility_accessible":"\u039D\u03B1\u03B9, \u03B5\u03AF\u03BD\u03B1\u03B9 \u03BA\u03BF\u03BD\u03C4\u03AC \u03C3\u03B5 \u03C3\u03C4\u03AC\u03C3\u03B7 \u03BB\u03B5\u03C9\u03C6\u03BF\u03C1\u03B5\u03AF\u03BF\u03C5 / \u03BC\u03B5\u03C4\u03C1\u03CC","public_transport_accessibility_not_accessible":"\u038C\u03C7\u03B9, \u03B4\u03B5\u03BD \u03B5\u03AF\u03BD\u03B1\u03B9 \u03B5\u03CD\u03BA\u03BF\u03BB\u03B1 \u03C0\u03C1\u03BF\u03C3\u03B2\u03AC\u03C3\u03B9\u03BC\u03B7 \u03BC\u03B5 \u03C4\u03B1 \u03BC\u03AD\u03C3\u03B1 \u03BC\u03B1\u03B6\u03B9\u03BA\u03AE\u03C2 \u03BC\u03B5\u03C4\u03B1\u03C6\u03BF\u03C1\u03AC\u03C2","is_location_accessible_by_transport":"\u0391\u03C5\u03C4\u03AE \u03B7 \u03C4\u03BF\u03C0\u03BF\u03B8\u03B5\u03C3\u03AF\u03B1 \u03B5\u03AF\u03BD\u03B1\u03B9 \u03C0\u03C1\u03BF\u03C3\u03B2\u03AC\u03C3\u03B9\u03BC\u03B7 \u03BC\u03B5 \u03BC\u03AD\u03C3\u03B1 \u03BC\u03B1\u03B6\u03B9\u03BA\u03AE\u03C2 \u03BC\u03B5\u03C4\u03B1\u03C6\u03BF\u03C1\u03AC\u03C2;","tell_if_location_is_reachable":"\u03A0\u03B5\u03AF\u03C4\u03B5 \u03BC\u03B1\u03C2 \u03B5\u03AC\u03BD \u03B7 \u03C4\u03BF\u03C0\u03BF\u03B8\u03B5\u03C3\u03AF\u03B1 \u03C3\u03B1\u03C2 \u03B5\u03AF\u03BD\u03B1\u03B9 \u03C0\u03C1\u03BF\u03C3\u03B2\u03AC\u03C3\u03B9\u03BC\u03B7 \u03BC\u03B5 \u03BB\u03B5\u03C9\u03C6\u03BF\u03C1\u03B5\u03AF\u03BF \u03AE \u03BC\u03B5\u03C4\u03C1\u03CC.","pricing":{"best_price_4":"\u0396\u03B7\u03C4\u03AE\u03C3\u03C4\u03B5 \u03BC\u03B9\u03B1 \u03BA\u03BB\u03AE\u03C3\u03B7 \u03B1\u03C0\u03CC \u03C4\u03B7\u03BD \u03BF\u03BC\u03AC\u03B4\u03B1 \u03C0\u03C9\u03BB\u03AE\u03C3\u03B5\u03C9\u03BD","estimated_total":"\u0395\u03BA\u03C4\u03B9\u03BC\u03CE\u03BC\u03B5\u03BD\u03BF \u03C3\u03CD\u03BD\u03BF\u03BB\u03BF*","hours":"\u038F\u03C1\u03B5\u03C2","type":"\u0395\u03AF\u03B4\u03BF\u03C2","hourly_rate":"\u03A9\u03C1\u03BF\u03BC\u03AF\u03C3\u03B8\u03B9\u03BF","best_price_1":"\u0395\u03B3\u03B3\u03CD\u03B7\u03C3\u03B7 \u03BA\u03B1\u03BB\u03CD\u03C4\u03B5\u03C1\u03B7\u03C2 \u03C4\u03B9\u03BC\u03AE\u03C2","best_price_2":"\u03A4\u03BF \u03BC\u03BF\u03BD\u03C4\u03AD\u03BB\u03BF \u03C4\u03B9\u03BC\u03BF\u03BB\u03CC\u03B3\u03B7\u03C3\u03B7\u03C2 \u03BC\u03B1\u03C2 \u03B5\u03AF\u03BD\u03B1\u03B9 \u03B4\u03C5\u03BD\u03B1\u03BC\u03B9\u03BA\u03AC \u03B4\u03BF\u03BC\u03B7\u03BC\u03AD\u03BD\u03BF, \u03BB\u03B1\u03BC\u03B2\u03AC\u03BD\u03BF\u03BD\u03C4\u03B1\u03C2 \u03C5\u03C0\u03CC\u03C8\u03B7 \u03C4\u03B7\u03BD \u03C4\u03C1\u03AD\u03C7\u03BF\u03C5\u03C3\u03B1 \u03B6\u03AE\u03C4\u03B7\u03C3\u03B7 \u03C4\u03B7\u03C2 \u03B1\u03B3\u03BF\u03C1\u03AC\u03C2.","best_price_3":"\u0391\u03C5\u03C4\u03AE \u03B7 \u03C0\u03C1\u03BF\u03C3\u03AD\u03B3\u03B3\u03B9\u03C3\u03B7 \u03BC\u03B1\u03C2 \u03B5\u03C0\u03B9\u03C4\u03C1\u03AD\u03C0\u03B5\u03B9 \u03BD\u03B1 \u03C3\u03B1\u03C2 \u03C0\u03C1\u03BF\u03C3\u03C6\u03AD\u03C1\u03BF\u03C5\u03BC\u03B5 \u03C3\u03C5\u03BD\u03B5\u03C7\u03CE\u03C2 \u03C4\u03B7\u03BD \u03BA\u03B1\u03BB\u03CD\u03C4\u03B5\u03C1\u03B7 \u03B1\u03BE\u03AF\u03B1 \u03BA\u03B1\u03B9 \u03C4\u03B9\u03C2 \u03BA\u03B1\u03BB\u03CD\u03C4\u03B5\u03C1\u03B5\u03C2 \u03C5\u03C0\u03B7\u03C1\u03B5\u03C3\u03AF\u03B5\u03C2. \u0395\u03C0\u03B9\u03BA\u03BF\u03B9\u03BD\u03C9\u03BD\u03AE\u03C3\u03C4\u03B5 \u03BC\u03B1\u03B6\u03AF \u03BC\u03B1\u03C2 \u03B1\u03BD\u03AC \u03C0\u03AC\u03C3\u03B1 \u03C3\u03C4\u03B9\u03B3\u03BC\u03AE \u03B3\u03B9\u03B1 \u03C0\u03B5\u03C1\u03B9\u03C3\u03C3\u03CC\u03C4\u03B5\u03C1\u03B5\u03C2 \u03C0\u03BB\u03B7\u03C1\u03BF\u03C6\u03BF\u03C1\u03AF\u03B5\u03C2."},"callback_request_sent":"\u03A4\u03BF \u03B1\u03AF\u03C4\u03B7\u03BC\u03AC \u03C3\u03B1\u03C2 \u03C3\u03C4\u03AC\u03BB\u03B8\u03B7\u03BA\u03B5 \u03BC\u03B5 \u03B5\u03C0\u03B9\u03C4\u03C5\u03C7\u03AF\u03B1","end_date":"\u0397\u03BC\u03B5\u03C1\u03BF\u03BC\u03B7\u03BD\u03AF\u03B1 \u039B\u03AE\u03BE\u03B7\u03C2","start_date":"\u0397\u03BC\u03B5\u03C1\u03BF\u03BC\u03B7\u03BD\u03AF\u03B1 \u0388\u03BD\u03B1\u03C1\u03BE\u03B7\u03C2","updated":"\u0395\u03BD\u03B7\u03BC\u03B5\u03C1\u03CE\u03B8\u03B7\u03BA\u03B5","n_hours":"{{hours}} \u03CE\u03C1\u03B5\u03C2","edit_job":"\u0395\u03C0\u03B5\u03BE\u03B5\u03C1\u03B3\u03B1\u03C3\u03AF\u03B1 \u0398\u03AD\u03C3\u03B7\u03C2 \u0395\u03C1\u03B3\u03B1\u03C3\u03AF\u03B1\u03C2"},"order_extension":{"how_to_extend":"\u03A0\u03CE\u03C2 \u03B8\u03AD\u03BB\u03B5\u03C4\u03B5 \u03BD\u03B1 \u03B5\u03C0\u03B5\u03BA\u03C4\u03B5\u03AF\u03BD\u03B5\u03C4\u03B5 \u03C4\u03B9\u03C2 \u03B7\u03BC\u03B5\u03C1\u03BF\u03BC\u03B7\u03BD\u03AF\u03B5\u03C2 \u03B3\u03B9\u03B1 \u03C4\u03B9\u03C2 \u03B8\u03AD\u03C3\u03B5\u03B9\u03C2 \u03B5\u03C1\u03B3\u03B1\u03C3\u03AF\u03B1\u03C2;","you_can_extend_order":"\u0388\u03C7\u03B5\u03C4\u03B5 \u03C4\u03B7 \u03B4\u03C5\u03BD\u03B1\u03C4\u03CC\u03C4\u03B7\u03C4\u03B1 \u03BD\u03B1 \u03B5\u03C0\u03B5\u03BA\u03C4\u03B5\u03AF\u03BD\u03B5\u03C4\u03B5 \u03C4\u03B9\u03C2 \u03B7\u03BC\u03B5\u03C1\u03BF\u03BC\u03B7\u03BD\u03AF\u03B5\u03C2 \u03B3\u03B9\u03B1 \u03C4\u03B9\u03C2 \u03B8\u03AD\u03C3\u03B5\u03B9\u03C2 \u03B5\u03C1\u03B3\u03B1\u03C3\u03AF\u03B1\u03C2","same_extension_date":"\u0397 \u03BD\u03AD\u03B1 \u03B7\u03BC\u03B5\u03C1\u03BF\u03BC\u03B7\u03BD\u03AF\u03B1 \u03BB\u03AE\u03BE\u03B7\u03C2 \u03B5\u03AF\u03BD\u03B1\u03B9 \u03B7 \u03AF\u03B4\u03B9\u03B1 \u03B3\u03B9\u03B1 \u03CC\u03BB\u03B5\u03C2 \u03C4\u03B9\u03C2 \u03B8\u03AD\u03C3\u03B5\u03B9\u03C2 \u03B5\u03C1\u03B3\u03B1\u03C3\u03AF\u03B1\u03C2","different_extension_dates":"\u0395\u03C0\u03B5\u03BA\u03C4\u03B5\u03AF\u03BD\u03B5\u03C4\u03B5 \u03C4\u03B9\u03C2 \u03B8\u03AD\u03C3\u03B5\u03B9\u03C2 \u03B5\u03C1\u03B3\u03B1\u03C3\u03AF\u03B1\u03C2 \u03B3\u03B9\u03B1 \u03B4\u03B9\u03B1\u03C6\u03BF\u03C1\u03B5\u03C4\u03B9\u03BA\u03AD\u03C2 \u03C0\u03B5\u03C1\u03B9\u03CC\u03B4\u03BF\u03C5\u03C2","for_how_long_extend":"\u0393\u03B9\u03B1 \u03C0\u03CC\u03C3\u03BF \u03BA\u03B1\u03B9\u03C1\u03CC \u03B8\u03AD\u03BB\u03B5\u03C4\u03B5 \u03BD\u03B1 \u03B5\u03C0\u03B5\u03BA\u03C4\u03B5\u03AF\u03BD\u03B5\u03C4\u03B5 \u03C4\u03B9\u03C2 \u03B8\u03AD\u03C3\u03B5\u03B9\u03C2 \u03B5\u03C1\u03B3\u03B1\u03C3\u03AF\u03B1\u03C2 \u03C3\u03B1\u03C2;","do_not_extend":"\u03A7\u03C9\u03C1\u03AF\u03C2 \u0395\u03C0\u03AD\u03BA\u03C4\u03B1\u03C3\u03B7","select_date":"\u0395\u03C0\u03B9\u03BB\u03BF\u03B3\u03AE \u0397\u03BC\u03B5\u03C1\u03BF\u03BC\u03B7\u03BD\u03AF\u03B1\u03C2","select_start_date":"\u0395\u03C0\u03B9\u03BB\u03AD\u03BE\u03C4\u03B5 \u0397\u03BC\u03B5\u03C1\u03BF\u03BC\u03B7\u03BD\u03AF\u03B1 \u0388\u03BD\u03B1\u03C1\u03BE\u03B7\u03C2","select_end_date":"\u0395\u03C0\u03B9\u03BB\u03AD\u03BE\u03C4\u03B5 \u0397\u03BC\u03B5\u03C1\u03BF\u03BC\u03B7\u03BD\u03AF\u03B1 \u039B\u03AE\u03BE\u03B7\u03C2","extend_order":"\u0395\u03C0\u03AD\u03BA\u03C4\u03B1\u03C3\u03B7 \u03A0\u03B1\u03C1\u03B1\u03B3\u03B3\u03B5\u03BB\u03AF\u03B1\u03C2","schedule_description":"\u039F\u03B9 \u03B5\u03C0\u03B9\u03C0\u03BB\u03AD\u03BF\u03BD \u03B7\u03BC\u03AD\u03C1\u03B5\u03C2 \u03C0\u03BF\u03C5 \u03C7\u03C1\u03B5\u03B9\u03AC\u03B6\u03B5\u03C3\u03C4\u03B5 \u03BD\u03B1 \u03B5\u03C1\u03B3\u03B1\u03C3\u03C4\u03B5\u03AF \u03C4\u03BF \u03C0\u03C1\u03BF\u03C3\u03C9\u03C0\u03B9\u03BA\u03CC \u03C3\u03B1\u03C2","edit":"\u0395\u03C0\u03B5\u03BE\u03B5\u03C1\u03B3\u03B1\u03C3\u03AF\u03B1","done":"\u039F\u03BB\u03BF\u03BA\u03BB\u03AE\u03C1\u03C9\u03C3\u03B7","full_schedule":"\u03A0\u039B\u03AE\u03C1\u03B5\u03C2 \u03A0\u03C1\u03CC\u03B3\u03C1\u03B1\u03BC\u03BC\u03B1","current_end_date":"Current End Date:","select_sps":"Select Ogrammers","select_sps_to_extend":"Select Ogrammers you want to extend"},"order_confirmed":{"title":"\u0397 \u03A0\u03B1\u03C1\u03B1\u03B3\u03B3\u03B5\u03BB\u03AF\u03B1 \u0395\u03C0\u03B9\u03B2\u03B5\u03B2\u03B1\u03B9\u03CE\u03B8\u03B7\u03BA\u03B5","description":"\u0395\u03C5\u03C7\u03B1\u03C1\u03B9\u03C3\u03C4\u03BF\u03CD\u03BC\u03B5 \u03B3\u03B9\u03B1 \u03C4\u03B7\u03BD \u03B5\u03C0\u03B9\u03B2\u03B5\u03B2\u03B1\u03AF\u03C9\u03C3\u03B7 \u03C4\u03B7\u03C2 \u03C0\u03B1\u03C1\u03B1\u03B3\u03B3\u03B5\u03BB\u03AF\u03B1\u03C2 \u03C3\u03B1\u03C2.","done":"\u03A4\u03AD\u03BB\u03BF\u03C2"},"attendance_manager_form":{"first_name":"\u038C\u03BD\u03BF\u03BC\u03B1","last_name":"\u0395\u03C0\u03AF\u03B8\u03B5\u03C4\u03BF","phone":"\u03A4\u03B7\u03BB\u03AD\u03C6\u03C9\u03BD\u03BF","email":"Email","job_role":"\u03A1\u03CC\u03BB\u03BF\u03C2 \u0395\u03C1\u03B3\u03B1\u03C3\u03AF\u03B1\u03C2","save":"\u0391\u03C0\u03BF\u03B8\u03AE\u03BA\u03B5\u03C5\u03C3\u03B7","edit_attendance_manager":"\u0395\u03C0\u03B5\u03BE\u03B5\u03C1\u03B3\u03B1\u03C3\u03AF\u03B1 \u03A5\u03C0\u03B5\u03CD\u03B8\u03C5\u03BD\u03BF\u03C5 \u03A0\u03C1\u03BF\u03C3\u03AD\u03BB\u03B5\u03C5\u03C3\u03B7\u03C2","add_attendance_manager":"\u03A0\u03C1\u03BF\u03C3\u03B8\u03AE\u03BA\u03B7 \u03A5\u03C0\u03B5\u03CD\u03B8\u03C5\u03BD\u03BF\u03C5 \u03A0\u03C1\u03BF\u03C3\u03AD\u03BB\u03B5\u03C5\u03C3\u03B7\u03C2"},"attendance_manager_list":{"title":"\u03A5\u03C0\u03B5\u03CD\u03B8\u03C5\u03BD\u03BF\u03B9 \u03A0\u03C1\u03BF\u03C3\u03AD\u03BB\u03B5\u03C5\u03C3\u03B7\u03C2","add_manager":"\u03A0\u03C1\u03BF\u03C3\u03B8\u03AD\u03C3\u03C4\u03B5 \u03A5\u03C0\u03B5\u03CD\u03B8\u03C5\u03BD\u03BF","edit":"\u0395\u03C0\u03B5\u03BE\u03B5\u03C1\u03B3\u03B1\u03C3\u03AF\u03B1"},"company_form":{"title":"\u03A0\u03BB\u03B7\u03C1\u03BF\u03C6\u03BF\u03C1\u03AF\u03B5\u03C2 \u0395\u03C4\u03B1\u03B9\u03C1\u03B5\u03AF\u03B1\u03C2","saved":"\u0391\u03C0\u03BF\u03B8\u03B7\u03BA\u03B5\u03CD\u03C4\u03B7\u03BA\u03B5","company_name":"\u038C\u03BD\u03BF\u03BC\u03B1 \u0395\u03C4\u03B1\u03B9\u03C1\u03B5\u03AF\u03B1\u03C2","company_name_as_in_license":"\u038C\u03BD\u03BF\u03BC\u03B1 \u03B5\u03C4\u03B1\u03B9\u03C1\u03B5\u03AF\u03B1\u03C2 \u03CC\u03C0\u03C9\u03C2 \u03B1\u03BD\u03B1\u03B3\u03C1\u03AC\u03C6\u03B5\u03C4\u03B1\u03B9 \u03C3\u03C4\u03B7\u03BD \u0395\u03BC\u03C0\u03BF\u03C1\u03B9\u03BA\u03AE \u0386\u03B4\u03B5\u03B9\u03B1","address":"\u0394\u03B9\u03B5\u03CD\u03B8\u03C5\u03BD\u03C3\u03B7","po_box":"\u03A4\u03B1\u03C7\u03C5\u03B4\u03C1\u03BF\u03BC\u03B9\u03BA\u03CC\u03C2 \u039A\u03CE\u03B4\u03B9\u03BA\u03B1\u03C2","vat_certificate":"\u03A0\u03B9\u03C3\u03C4\u03BF\u03C0\u03BF\u03B9\u03B7\u03C4\u03B9\u03BA\u03CC \u03A6.\u03A0.\u0391.","trade_license":"\u0395\u03BC\u03C0\u03BF\u03C1\u03B9\u03BA\u03AE \u0386\u03B4\u03B5\u03B9\u03B1","finance_first_name":"\u038C\u03BD\u03BF\u03BC\u03B1 \u03A5\u03C0\u03B5\u03CD\u03B8\u03C5\u03BD\u03BF\u03C5 \u039F\u03B9\u03BA\u03BF\u03BD\u03BF\u03BC\u03B9\u03BA\u03CE\u03BD","finance_last_name":"\u0395\u03C0\u03AF\u03B8\u03B5\u03C4\u03BF \u03A5\u03C0\u03B5\u03CD\u03B8\u03C5\u03BD\u03BF\u03C5 \u039F\u03B9\u03BA\u03BF\u03BD\u03BF\u03BC\u03B9\u03BA\u03CE\u03BD","finance_phone":"\u03A4\u03B7\u03BB\u03AD\u03C6\u03C9\u03BD\u03BF \u03A5\u03C0\u03B5\u03CD\u03B8\u03C5\u03BD\u03BF\u03C5 \u039F\u03B9\u03BA\u03BF\u03BD\u03BF\u03BC\u03B9\u03BA\u03CE\u03BD","finance_email":"Email \u03A5\u03C0\u03B5\u03CD\u03B8\u03C5\u03BD\u03BF\u03C5 \u039F\u03B9\u03BA\u03BF\u03BD\u03BF\u03BC\u03B9\u03BA\u03CE\u03BD","extension":"\u0395\u03C3\u03C9\u03C4\u03B5\u03C1\u03B9\u03BA\u03CC\u03C2 \u0391\u03C1\u03B9\u03B8\u03BC\u03CC\u03C2","save":"\u0391\u03C0\u03BF\u03B8\u03AE\u03BA\u03B5\u03C5\u03C3\u03B7"},"invoice":{"invoice_#":"\u03A4\u03B9\u03BC\u03BF\u03BB\u03CC\u03B3\u03B9\u03BF #{{index}}","export_pdf":"\u0395\u03BE\u03B1\u03B3\u03C9\u03B3\u03AE (PDF)","exporting":"\u0393\u03AF\u03BD\u03B5\u03C4\u03B1\u03B9 \u0395\u03BE\u03B1\u03B3\u03C9\u03B3\u03AE...","report_issue":"\u0391\u03BD\u03B1\u03C6\u03BF\u03C1\u03AC \u03C0\u03C1\u03BF\u03B2\u03BB\u03AE\u03BC\u03B1\u03C4\u03BF\u03C2","details":"\u039B\u03B5\u03C0\u03C4\u03BF\u03BC\u03AD\u03C1\u03B5\u03B9\u03B5\u03C2","invoice_number":"\u0391\u03C1\u03B9\u03B8\u03BC\u03CC\u03C2 \u03C4\u03B9\u03BC\u03BF\u03BB\u03BF\u03B3\u03AF\u03BF\u03C5","date":"\u0397\u03BC\u03B5\u03C1\u03BF\u03BC\u03B7\u03BD\u03AF\u03B1","due_date":"\u0397\u03BC\u03B5\u03C1\u03BF\u03BC\u03B7\u03BD\u03AF\u03B1 \u03A0\u03BB\u03B7\u03C1\u03C9\u03BC\u03AE\u03C2","status":"\u039A\u03B1\u03C4\u03AC\u03C3\u03C4\u03B1\u03C3\u03B7","pending":"\u0395\u03BA\u03BA\u03C1\u03B5\u03BC\u03B5\u03AF","paid":"\u03A0\u03BB\u03B7\u03C1\u03C9\u03BC\u03AD\u03BD\u03BF","costs":"\u039A\u03CC\u03C3\u03C4\u03BF\u03C2","subtotal":"\u039C\u03B5\u03C1\u03B9\u03BA\u03CC \u03A3\u03CD\u03BD\u03BF\u03BB\u03BF","transportation":"\u039C\u03B5\u03C4\u03B1\u03C6\u03BF\u03C1\u03B9\u03BA\u03AC","vat_percent":"\u03A6.\u03A0.\u0391. ({{count}}%)","total":"\u03A3\u03CD\u03BD\u03BF\u03BB\u03BF","breakdown":"\u0391\u03BD\u03AC\u03BB\u03C5\u03C3\u03B7","pay_now":"\u03A0\u03BB\u03B7\u03C1\u03C9\u03BC\u03AE \u03A4\u03CE\u03C1\u03B1","total_shifts":"\u03A3\u03C5\u03BD\u03BF\u03BB\u03B9\u03BA\u03AD\u03C2 \u0392\u03AC\u03C1\u03B4\u03B9\u03B5\u03C2","total_hours":"\u03A3\u03C5\u03BD\u03BF\u03BB\u03B9\u03BA\u03AD\u03C2 \u038F\u03C1\u03B5\u03C2","total_ogs":"\u03A3\u03CD\u03BD\u03BF\u03BB\u03BF \u0395\u03C1\u03B3\u03B1\u03B6\u03CC\u03BC\u03B5\u03BD\u03C9\u03BD OG\'s","shifts":"\u0392\u03AC\u03C1\u03B4\u03B9\u03B5\u03C2","hours":"\u038F\u03C1\u03B5\u03C2","amount":"\u03A0\u03BF\u03C3\u03CC","report_issue_modal_title":"\u0391\u03BD\u03B1\u03C6\u03BF\u03C1\u03AC \u03C0\u03C1\u03BF\u03B2\u03BB\u03AE\u03BC\u03B1\u03C4\u03BF\u03C2","report_issue_message_required":"\u0391\u03C0\u03B1\u03B9\u03C4\u03B5\u03AF\u03C4\u03B1\u03B9 \u03BC\u03AE\u03BD\u03C5\u03BC\u03B1","report_issue_message_placeholder":"\u03A0\u03B5\u03C1\u03B9\u03B3\u03C1\u03AC\u03C8\u03C4\u03B5 \u03BC\u03B1\u03C2 \u03C4\u03BF \u03C0\u03C1\u03CC\u03B2\u03BB\u03B7\u03BC\u03B1 \u03C0\u03BF\u03C5 \u03B1\u03BD\u03C4\u03B9\u03BC\u03B5\u03C4\u03C9\u03C0\u03AF\u03C3\u03B1\u03C4\u03B5","report_issue_submit":"\u03A5\u03C0\u03BF\u03B2\u03BF\u03BB\u03AE","report_issue_cancel":"\u0391\u03BA\u03CD\u03C1\u03C9\u03C3\u03B7","issue_was_reported":"\u03A4\u03BF \u03C0\u03C1\u03CC\u03B2\u03BB\u03B7\u03BC\u03B1 \u03B1\u03BD\u03B1\u03C6\u03AD\u03C1\u03B8\u03B7\u03BA\u03B5","issue_is_submitting":"\u03A6\u03CC\u03C1\u03C4\u03C9\u03C3\u03B7..."},"invoice_card":{"invoice_#":"\u0391\u03C1. #{{index}}","due_days_ago":"\u03A0\u03BB\u03B7\u03C1\u03C9\u03BC\u03AE \u03C0\u03C1\u03B9\u03BD \u03B1\u03C0\u03CC {{count}} \u03B7\u03BC\u03AD\u03C1\u03B5\u03C2","due_today":"\u03A0\u03BB\u03B7\u03C1\u03C9\u03BC\u03AE \u03C3\u03AE\u03BC\u03B5\u03C1\u03B1","due_tomorrow":"\u03A0\u03BB\u03B7\u03C1\u03C9\u03BC\u03AE \u03B1\u03CD\u03C1\u03B9\u03BF","due_days_ahead":"\u03A0\u03BB\u03B7\u03C1\u03C9\u03BC\u03AE \u03C3\u03B5 {{count}} \u03B7\u03BC\u03AD\u03C1\u03B5\u03C2"},"invoice_ogrammer":{"og_details":"\u03A0\u03BB\u03B7\u03C1\u03BF\u03C6\u03BF\u03C1\u03AF\u03B5\u03C2 Ogrammer","job":"\u0398\u03AD\u03C3\u03B7 \u0395\u03C1\u03B3\u03B1\u03C3\u03AF\u03B1\u03C2","location":"\u03A4\u03BF\u03C0\u03BF\u03B8\u03B5\u03C3\u03AF\u03B1","shifts":"\u0392\u03AC\u03C1\u03B4\u03B9\u03B5\u03C2","hours":"\u038F\u03C1\u03B5\u03C2","amount_due":"\u039F\u03C6\u03B5\u03B9\u03BB\u03CC\u03BC\u03B5\u03BD\u03BF \u03C0\u03BF\u03C3\u03CC","shift_details":"\u039B\u03B5\u03C0\u03C4\u03BF\u03BC\u03AD\u03C1\u03B5\u03B9\u03B5\u03C2 \u03B2\u03B1\u03C1\u03B4\u03B9\u03CE\u03BD","day":"\u0397\u03BC\u03AD\u03C1\u03B1","approved_by":"\u0395\u03B3\u03BA\u03C1\u03AF\u03B8\u03B7\u03BA\u03B5 \u03B1\u03C0\u03CC"},"profile_form":{"title":"\u0395\u03C0\u03B5\u03BE\u03B5\u03C1\u03B3\u03B1\u03C3\u03AF\u03B1 \u03C0\u03C1\u03BF\u03C6\u03AF\u03BB","first_name_required":"\u03A4\u03BF \u03CC\u03BD\u03BF\u03BC\u03B1 \u03B5\u03AF\u03BD\u03B1\u03B9 \u03C5\u03C0\u03BF\u03C7\u03C1\u03B5\u03C9\u03C4\u03B9\u03BA\u03CC","last_name_required":"\u03A4\u03BF \u03B5\u03C0\u03AF\u03B8\u03B5\u03C4\u03BF \u03B5\u03AF\u03BD\u03B1\u03B9 \u03C5\u03C0\u03BF\u03C7\u03C1\u03B5\u03C9\u03C4\u03B9\u03BA\u03CC","phone_required":"\u03A4\u03BF \u03C4\u03B7\u03BB\u03AD\u03C6\u03C9\u03BD\u03BF \u03B5\u03AF\u03BD\u03B1\u03B9 \u03C5\u03C0\u03BF\u03C7\u03C1\u03B5\u03C9\u03C4\u03B9\u03BA\u03CC","email_required":"\u03A4\u03BF email \u03B5\u03AF\u03BD\u03B1\u03B9 \u03C5\u03C0\u03BF\u03C7\u03C1\u03B5\u03C9\u03C4\u03B9\u03BA\u03CC","upload_photo":"\u0391\u03BD\u03B5\u03B2\u03AC\u03C3\u03C4\u03B5 \u03A6\u03C9\u03C4\u03BF\u03B3\u03C1\u03B1\u03C6\u03AF\u03B1","private":"\u0399\u03B4\u03B9\u03CE\u03C4\u03B7\u03C2","corporate":"\u0395\u03C4\u03B1\u03B9\u03C1\u03B5\u03AF\u03B1","register_corporate":"\u0395\u03B3\u03B3\u03C1\u03B1\u03C6\u03AE \u0395\u03C0\u03B9\u03C7\u03B5\u03AF\u03C1\u03B7\u03C3\u03B7\u03C2","first_name":"\u038C\u03BD\u03BF\u03BC\u03B1","last_name":"\u0395\u03C0\u03AF\u03B8\u03B5\u03C4\u03BF","phone":"\u03A4\u03B7\u03BB\u03AD\u03C6\u03C9\u03BD\u03BF","email":"Email","save":"\u0391\u03C0\u03BF\u03B8\u03AE\u03BA\u03B5\u03C5\u03C3\u03B7","cancel":"\u0391\u03BA\u03CD\u03C1\u03C9\u03C3\u03B7","sign_out":"\u0391\u03C0\u03BF\u03C3\u03CD\u03BD\u03B4\u03B5\u03C3\u03B7","agree_to_emails":"\u03A3\u03C5\u03BC\u03C6\u03CE\u03BD\u03C9 \u03BD\u03B1 \u03BB\u03B1\u03BC\u03B2\u03AC\u03BD\u03C9 \u03B5\u03B9\u03B4\u03BF\u03C0\u03BF\u03B9\u03AE\u03C3\u03B5\u03B9\u03C2 \u03B3\u03B9\u03B1 \u03BB\u03CC\u03B3\u03BF\u03C5\u03C2 marketing \u03B1\u03C0\u03CC \u03C4\u03B7\u03BD Ogram"},"rating_request_list":{"title":"\u0391\u03B9\u03C4\u03AE\u03BC\u03B1\u03C4\u03B1 \u0391\u03BE\u03B9\u03BF\u03BB\u03CC\u03B3\u03B7\u03C3\u03B7\u03C2","empty_list":"\u0394\u03B5\u03BD \u03C5\u03C0\u03AC\u03C1\u03C7\u03BF\u03C5\u03BD \u03B5\u03BA\u03BA\u03C1\u03B5\u03BC\u03AE \u03B1\u03B9\u03C4\u03AE\u03BC\u03B1\u03C4\u03B1"},"rating_request_panel":{"title":"\u0391\u03B9\u03C4\u03AE\u03BC\u03B1\u03C4\u03B1 \u0391\u03BE\u03B9\u03BF\u03BB\u03CC\u03B3\u03B7\u03C3\u03B7\u03C2","action":"\u0392\u03B1\u03B8\u03BC\u03BF\u03BB\u03BF\u03B3\u03AE\u03C3\u03C4\u03B5 \u03A4\u03CE\u03C1\u03B1"},"job_rating":{"title":"\u0391\u03BE\u03B9\u03BF\u03BB\u03CC\u03B3\u03B7\u03C3\u03B7 \u0398\u03AD\u03C3\u03B7\u03C2","how_was_experience_question":"\u03A0\u03CE\u03C2 \u03B8\u03B1 \u03B1\u03BE\u03B9\u03BF\u03BB\u03BF\u03B3\u03BF\u03CD\u03C3\u03B1\u03C4\u03B5 \u03C4\u03B7\u03BD \u03C3\u03C5\u03BD\u03BF\u03BB\u03B9\u03BA\u03AE \u03C3\u03B1\u03C2 \u03B5\u03BC\u03C0\u03B5\u03B9\u03C1\u03AF\u03B1;","please_rate_team":"\u03A0\u03B1\u03C1\u03B1\u03BA\u03B1\u03BB\u03BF\u03CD\u03BC\u03B5 \u03B2\u03B1\u03B8\u03BC\u03BF\u03BB\u03BF\u03B3\u03AE\u03C3\u03C4\u03B5 \u03C4\u03BF \u03C3\u03CD\u03BD\u03BF\u03BB\u03BF \u03C4\u03B7\u03C2 \u03BF\u03BC\u03AC\u03B4\u03B1\u03C2","tell_us_about_ogs":"\u03A0\u03B5\u03AF\u03C4\u03B5 \u03BC\u03B1\u03C2 \u03C0\u03B5\u03C1\u03B9\u03C3\u03C3\u03CC\u03C4\u03B5\u03C1\u03B1 \u03B3\u03B9\u03B1 \u03C4\u03BF\u03C5\u03C2 Ogrammers","tell_us_which_stood_out":"\u03A0\u03B5\u03AF\u03C4\u03B5 \u03BC\u03B1\u03C2 \u03C0\u03BF\u03B9\u03BF\u03B9 \u03BE\u03B5\u03C7\u03CE\u03C1\u03B9\u03C3\u03B1\u03BD \u03BA\u03B1\u03B9 \u03C0\u03BF\u03B9\u03BF\u03B9 \u03AD\u03C7\u03BF\u03C5\u03BD \u03C0\u03B5\u03C1\u03B9\u03B8\u03CE\u03C1\u03B9\u03B1 \u03B2\u03B5\u03BB\u03C4\u03AF\u03C9\u03C3\u03B7\u03C2","confirm":"\u0395\u03C0\u03B9\u03B2\u03B5\u03B2\u03B1\u03AF\u03C9\u03C3\u03B7","comment":"\u03A3\u03C7\u03CC\u03BB\u03B9\u03BF","provide_overall_rating":"\u0394\u03CE\u03C3\u03C4\u03B5 \u03BC\u03B9\u03B1 \u03C3\u03C5\u03BD\u03BF\u03BB\u03B9\u03BA\u03AE \u03B2\u03B1\u03B8\u03BC\u03BF\u03BB\u03BF\u03B3\u03AF\u03B1","provide_og_rating":"\u0392\u03B1\u03B8\u03BC\u03BF\u03BB\u03BF\u03B3\u03AE\u03C3\u03C4\u03B5 \u03C4\u03BF\u03BD \u039Fgrammer","provide_ogrammers_rating":"\u0392\u03B1\u03B8\u03BC\u03BF\u03BB\u03BF\u03B3\u03AE\u03C3\u03C4\u03B5 \u03C4\u03BF\u03C5\u03C2 \u039Fgrammers","thank_you_for_submitting":"\u03A3\u03B1\u03C2 \u03B5\u03C5\u03C7\u03B1\u03C1\u03B9\u03C3\u03C4\u03BF\u03CD\u03BC\u03B5 \u03B3\u03B9\u03B1 \u03C4\u03B7\u03BD \u03C5\u03C0\u03BF\u03B2\u03BF\u03BB\u03AE \u03C4\u03B7\u03C2 \u03B1\u03BE\u03B9\u03BF\u03BB\u03CC\u03B3\u03B7\u03C3\u03B7\u03C2!","rate_workers":"Rate Your Recent Workers","importance_of_rating":"Your feedback helps us <strong>match you with top workers</strong> and supports Ogrammers in <strong>growing their careers</strong>. Take a moment to rate now!","rating_submitted":"Rating submitted. Thank you!"},"shifts_attendance_list":{"title":"\u0391\u03BD\u03B1\u03C3\u03BA\u03CC\u03C0\u03B7\u03C3\u03B7 \u03A0\u03B1\u03C1\u03BF\u03C5\u03C3\u03B9\u03CE\u03BD","empty_list":"\u0394\u03B5\u03BD \u03C5\u03C0\u03AC\u03C1\u03C7\u03BF\u03C5\u03BD \u03B5\u03BA\u03BA\u03C1\u03B5\u03BC\u03B5\u03AF\u03C2 \u03B1\u03BD\u03B1\u03C6\u03BF\u03C1\u03AD\u03C2 \u03C0\u03B1\u03C1\u03BF\u03C5\u03C3\u03AF\u03B1\u03C2","review_now":"A\u03BD\u03B1\u03C3\u03BA\u03CC\u03C0\u03B7\u03C3\u03B7 \u03A4\u03CE\u03C1\u03B1","all_designations":"\u038C\u03BB\u03B5\u03C2 \u03BF\u03B9 \u0395\u03B9\u03B4\u03B9\u03BA\u03CC\u03C4\u03B7\u03C4\u03B5\u03C2"},"shifts_attendance_details":{"attended_question":"\u03A0\u03B1\u03C1\u03B5\u03B2\u03C1\u03AD\u03B8\u03B7\u03BA\u03B5?","attended":"\u03A0\u03B1\u03C1\u03B5\u03B2\u03C1\u03AD\u03B8\u03B7\u03BA\u03B5","not_attended":"\u0394\u03B5\u03BD \u03C0\u03B1\u03C1\u03B5\u03B2\u03C1\u03AD\u03B8\u03B7\u03BA\u03B5","did_not":"\u0394\u03B5\u03BD \u03C0\u03B1\u03C1\u03B5\u03B2\u03C1\u03AD\u03B8\u03B7\u03BA\u03B5","confirm_amount":"({{count}}) \u03B5\u03C0\u03B9\u03B2\u03B5\u03B2\u03B1\u03B9\u03C9\u03BC\u03AD\u03BD\u03BF\u03B9"},"shift_attendance_common":{"are_you_sure_og_worked_n_hours":"\u0395\u03AF\u03C3\u03C4\u03B5 \u03C3\u03AF\u03B3\u03BF\u03C5\u03C1\u03BF\u03B9 \u03CC\u03C4\u03B9 \u03BF/\u03B7 {{name}} \u03B5\u03C1\u03B3\u03AC\u03C3\u03C4\u03B7\u03BA\u03B5 \u03B3\u03B9\u03B1 {{hours}} \u03CE\u03C1\u03B5\u03C2; \u0395\u03AF\u03BD\u03B1\u03B9 {{difference}} \u03CE\u03C1\u03B5\u03C2 \u03BB\u03B9\u03B3\u03CC\u03C4\u03B5\u03C1\u03B5\u03C2 \u03B1\u03C0\u03CC \u03B1\u03C5\u03C4\u03AD\u03C2 \u03C0\u03BF\u03C5 \u03B5\u03AF\u03C7\u03B1\u03C4\u03B5 \u03BA\u03BB\u03B5\u03AF\u03C3\u03B5\u03B9.","no_show":"\u0394\u03B5\u03BD \u0395\u03BC\u03C6\u03B1\u03BD\u03AF\u03C3\u03C4\u03B7\u03BA\u03B5","limited_time_to_confirm":"\u03A0\u03B5\u03C1\u03B9\u03BF\u03C1\u03B9\u03C3\u03BC\u03AD\u03BD\u03BF\u03C2 \u03C7\u03C1\u03CC\u03BD\u03BF\u03C2 \u03B3\u03B9\u03B1 \u03B5\u03C0\u03B9\u03B2\u03B5\u03B2\u03B1\u03AF\u03C9\u03C3\u03B7","time_to_review_description":"\u0395\u03C0\u03B9\u03B2\u03B5\u03B2\u03B1\u03B9\u03CE\u03C3\u03C4\u03B5 \u03C4\u03B7\u03BD \u03C0\u03B1\u03C1\u03BF\u03C5\u03C3\u03AF\u03B1 \u03C4\u03BF \u03C3\u03C5\u03BD\u03C4\u03BF\u03BC\u03CC\u03C4\u03B5\u03C1\u03BF \u03B4\u03C5\u03BD\u03B1\u03C4\u03CC \u03B3\u03B9\u03B1 \u03BD\u03B1 \u03B1\u03C0\u03BF\u03C6\u03CD\u03B3\u03B5\u03C4\u03B5 \u03BB\u03B1\u03BD\u03B8\u03B1\u03C3\u03BC\u03AD\u03BD\u03B7 \u03C7\u03C1\u03AD\u03C9\u03C3\u03B7","i_understand":"\u039A\u03B1\u03C4\u03B1\u03BB\u03B1\u03B2\u03B1\u03AF\u03BD\u03C9","n_minutes":"{{count}} \u03BB\u03B5\u03C0\u03C4\u03AC","n_hours":"{{hours}} \u03CE\u03C1\u03B5\u03C2","select_reason":"\u0395\u03C0\u03B9\u03BB\u03AD\u03BE\u03C4\u03B5 \u0391\u03B9\u03C4\u03B9\u03BF\u03BB\u03BF\u03B3\u03AF\u03B1","update":"\u0391\u03BD\u03B1\u03BD\u03AD\u03C9\u03C3\u03B7","cancel":"\u0391\u03BA\u03CD\u03C1\u03C9\u03C3\u03B7","hours_left":"{{count}} \u03CE\u03C1\u03B5\u03C2 \u03B1\u03C0\u03BF\u03BC\u03AD\u03BD\u03BF\u03C5\u03BD","urgent":"\u0395\u03C0\u03B5\u03AF\u03B3\u03BF\u03BD","check_in":"\u0386\u03C6\u03B9\u03BE\u03B7","check_out":"\u0391\u03BD\u03B1\u03C7\u03CE\u03C1\u03B7\u03C3\u03B7","update_hours":"\u0391\u03BD\u03B1\u03BD\u03AD\u03C9\u03C3\u03B7 {{count}} \u03C9\u03C1\u03CE\u03BD","add_hours":"\u03A0\u03C1\u03BF\u03C3\u03B8\u03AE\u03BA\u03B7 {{count}} \u03C9\u03C1\u03CE\u03BD","attendance_confirmed":"\u0397 \u03C0\u03B1\u03C1\u03BF\u03C5\u03C3\u03AF\u03B1 \u03B5\u03C0\u03B9\u03B2\u03B5\u03B2\u03B1\u03B9\u03CE\u03B8\u03B7\u03BA\u03B5","thanks_for_confirming":"\u0395\u03C5\u03C7\u03B1\u03C1\u03B9\u03C3\u03C4\u03BF\u03CD\u03BC\u03B5 \u03B3\u03B9\u03B1 \u03C4\u03B7\u03BD \u03B5\u03C0\u03B9\u03B2\u03B5\u03B2\u03B1\u03AF\u03C9\u03C3\u03B7 \u03C4\u03B7\u03C2 \u03C0\u03B1\u03C1\u03BF\u03C5\u03C3\u03AF\u03B1\u03C2 \u03C4\u03C9\u03BD Ogrammers.","done":"\u039F\u03BB\u03BF\u03BA\u03BB\u03B7\u03C1\u03CE\u03B8\u03B7\u03BA\u03B5","day_off":"\u03A1\u03B5\u03C0\u03CC","total_hours":"\u03A3\u03C5\u03BD\u03BF\u03BB\u03B9\u03BA\u03AD\u03C2 \u038F\u03C1\u03B5\u03C2","shift_duration_too_long":"\u0397 \u03B4\u03B9\u03AC\u03C1\u03BA\u03B5\u03B9\u03B1 \u03C4\u03B7\u03C2 \u03B2\u03AC\u03C1\u03B4\u03B9\u03B1\u03C2 \u03B4\u03B5\u03BD \u03C0\u03C1\u03AD\u03C0\u03B5\u03B9 \u03BD\u03B1 \u03C5\u03C0\u03B5\u03C1\u03B2\u03B1\u03AF\u03BD\u03B5\u03B9 \u03C4\u03B9\u03C2 12 \u03CE\u03C1\u03B5\u03C2"},"user_management":{"users":"\u03A7\u03C1\u03AE\u03C3\u03C4\u03B5\u03C2","add_new_user":"\u03A0\u03C1\u03BF\u03C3\u03B8\u03AD\u03C3\u03C4\u03B5 \u039D\u03AD\u03BF \u03A7\u03C1\u03AE\u03C3\u03C4\u03B7","invite_user":"\u03A0\u03C1\u03BF\u03C3\u03BA\u03B1\u03BB\u03AD\u03C3\u03C4\u03B5 \u03A7\u03C1\u03AE\u03C3\u03C4\u03B7","confirm_deletion_question":"\u0395\u03AF\u03C3\u03C4\u03B5 \u03C3\u03AF\u03B3\u03BF\u03C5\u03C1\u03BF\u03B9 \u03CC\u03C4\u03B9 \u03B8\u03AD\u03BB\u03B5\u03C4\u03B5 \u03BD\u03B1 \u03B4\u03B9\u03B1\u03B3\u03C1\u03AC\u03C8\u03B5\u03C4\u03B5 \u03B1\u03C5\u03C4\u03AE \u03C4\u03B7\u03BD \u03B5\u03C0\u03B1\u03C6\u03AE;","enter_first_name":"\u03A0\u03C1\u03BF\u03C3\u03B8\u03AD\u03C3\u03C4\u03B5 \u038C\u03BD\u03BF\u03BC\u03B1","enter_last_name":"\u03A0\u03C1\u03BF\u03C3\u03B8\u03AD\u03C3\u03C4\u03B5 \u0395\u03C0\u03AF\u03B8\u03B5\u03C4\u03BF","enter_phone":"\u03A0\u03C1\u03BF\u03C3\u03B8\u03AD\u03C3\u03C4\u03B5 \u03A4\u03B7\u03BB\u03AD\u03C6\u03C9\u03BD\u03BF","enter_email":"\u03A0\u03C1\u03BF\u03C3\u03B8\u03AD\u03C3\u03C4\u03B5 email","choose_role":"\u0395\u03C0\u03B9\u03BB\u03AD\u03BE\u03C4\u03B5 \u03C1\u03CC\u03BB\u03BF","choose_location":"\u0395\u03C0\u03B9\u03BB\u03AD\u03BE\u03C4\u03B5 \u03C4\u03BF\u03C0\u03BF\u03B8\u03B5\u03C3\u03AF\u03B1","first_name":"\u038C\u03BD\u03BF\u03BC\u03B1","last_name":"\u0395\u03C0\u03AF\u03B8\u03B5\u03C4\u03BF","phone":"\u03A4\u03B7\u03BB\u03AD\u03C6\u03C9\u03BD\u03BF","email":"Email","invite_user_exclamation":"\u03A0\u03C1\u03BF\u03C3\u03BA\u03B1\u03BB\u03AD\u03C3\u03C4\u03B5 \u03C4\u03BF\u03BD \u03A7\u03C1\u03AE\u03C3\u03C4\u03B7 \u03C4\u03CE\u03C1\u03B1!","job_role":"\u03A1\u03CC\u03BB\u03BF\u03C2 \u0398\u03AD\u03C3\u03B7\u03C2","location":"\u03A4\u03BF\u03C0\u03BF\u03B8\u03B5\u03C3\u03AF\u03B1","save":"\u0391\u03C0\u03BF\u03B8\u03AE\u03BA\u03B5\u03C5\u03C3\u03B7","delete":"\u0394\u03B9\u03B1\u03B3\u03C1\u03B1\u03C6\u03AE","cancel":"\u0391\u03BA\u03CD\u03C1\u03C9\u03C3\u03B7","you_have_n_users":"\u0388\u03C7\u03B5\u03C4\u03B5 {{count}} \u03C7\u03C1\u03AE\u03C3\u03C4\u03B5\u03C2","add_user":"\u03A0\u03C1\u03BF\u03C3\u03B8\u03AD\u03C3\u03C4\u03B5 \u039D\u03AD\u03BF \u03A7\u03C1\u03AE\u03C3\u03C4\u03B7","or":"\u03AE","invite_existing_user":"\u03A0\u03C1\u03BF\u03C3\u03BA\u03B1\u03BB\u03AD\u03C3\u03C4\u03B5 \u03C5\u03C0\u03AC\u03C1\u03C7\u03BF\u03BD\u03C4\u03B1 \u03C7\u03C1\u03AE\u03C3\u03C4\u03B7","invitation_confirmed":"\u0397 \u03C0\u03C1\u03CC\u03C3\u03BA\u03BB\u03B7\u03C3\u03B7 \u03B5\u03C0\u03B9\u03B2\u03B5\u03B2\u03B1\u03B9\u03CE\u03B8\u03B7\u03BA\u03B5!","invitation_alert_text":"\u0397 \u03C0\u03C1\u03CC\u03C3\u03BA\u03BB\u03B7\u03C3\u03B7 \u03C3\u03C4\u03AC\u03BB\u03B8\u03B7\u03BA\u03B5 \u03BC\u03B5 \u03B5\u03C0\u03B9\u03C4\u03C5\u03C7\u03AF\u03B1. \u039F \u03C7\u03C1\u03AE\u03C3\u03C4\u03B7\u03C2 \u03B8\u03B1 \u03B5\u03C1\u03B3\u03B1\u03C3\u03C4\u03B5\u03AF \u03C3\u03C4\u03B7\u03BD \u03B5\u03C4\u03B1\u03B9\u03C1\u03B5\u03AF\u03B1 \u03C3\u03B1\u03C2 \u03B1\u03C6\u03BF\u03CD \u03B1\u03C0\u03BF\u03B4\u03B5\u03C7\u03C4\u03B5\u03AF \u03C4\u03B7\u03BD \u03C0\u03C1\u03CC\u03C3\u03BA\u03BB\u03B7\u03C3\u03B7.","users_tab_active_users":"\u03A7\u03C1\u03AE\u03C3\u03C4\u03B5\u03C2","users_tab_invitations":"\u03A0\u03C1\u03BF\u03C3\u03BA\u03BB\u03AE\u03C3\u03B5\u03B9\u03C2","role_admin":"\u0394\u03B9\u03B1\u03C7\u03B5\u03B9\u03C1\u03B9\u03C3\u03C4\u03AE\u03C2","role_owner":"\u0399\u03B4\u03B9\u03BF\u03BA\u03C4\u03AE\u03C4\u03B7\u03C2","role_manager":"\u0394\u03B9\u03B5\u03C5\u03B8\u03C5\u03BD\u03C4\u03AE\u03C2","role_finance":"\u039F\u03B9\u03BA\u03BF\u03BD\u03BF\u03BC\u03B9\u03BA\u03CC\u03C2"},"onboarding":{"knowledge_center":"\u039A\u03AD\u03BD\u03C4\u03C1\u03BF \u0393\u03BD\u03CE\u03C3\u03B7\u03C2","create_password":"\u0394\u03B7\u03BC\u03B9\u03BF\u03C5\u03C1\u03B3\u03AF\u03B1 \u039A\u03C9\u03B4\u03B9\u03BA\u03BF\u03CD","register_corporate":"\u0395\u03B3\u03B3\u03C1\u03B1\u03C6\u03AE \u0395\u03C4\u03B1\u03B9\u03C1\u03B5\u03AF\u03B1\u03C2","click_here_to_close":"\u039A\u03BB\u03B5\u03AF\u03C3\u03B9\u03BC\u03BF"},"lead_widget":{"looking_for_staff":"\u03A8\u03AC\u03C7\u03BD\u03B5\u03C4\u03B5\\n\u03C0\u03C1\u03BF\u03C3\u03C9\u03C0\u03B9\u03BA\u03CC \u03C0\u03C1\u03BF\u03C3\u03C9\u03C1\u03B9\u03BD\u03AE\u03C2 \u03B1\u03C0\u03B1\u03C3\u03C7\u03CC\u03BB\u03B7\u03C3\u03B7\u03C2;","hire_now":"\u03A0\u03C1\u03BF\u03C3\u03BB\u03AC\u03B2\u03B5\u03C4\u03B5 \u03A4\u03CE\u03C1\u03B1"},"uncompleted_actions_carousel":{"looking_for_staff":"\u03A8\u03AC\u03C7\u03BD\u03B5\u03C4\u03B5 \u03C0\u03C1\u03BF\u03C3\u03C9\u03C0\u03B9\u03BA\u03CC \\n\u03C0\u03C1\u03BF\u03C3\u03C9\u03C1\u03B9\u03BD\u03AE\u03C2 \u03B1\u03C0\u03B1\u03C3\u03C7\u03CC\u03BB\u03B7\u03C3\u03B7\u03C2;","hire_now":"\u03A0\u03C1\u03BF\u03C3\u03BB\u03AC\u03B2\u03B5\u03C4\u03B5 \u03A4\u03CE\u03C1\u03B1","edit_company":"\u03A0\u03C1\u03BF\u03C3\u03B8\u03AD\u03C3\u03C4\u03B5 \u03C4\u03B1 \u03C3\u03C4\u03BF\u03B9\u03C7\u03B5\u03AF\u03B1 \u03C4\u03B7\u03C2 \u03B5\u03C4\u03B1\u03B9\u03C1\u03B5\u03AF\u03B1\u03C2 \u03BA\u03B1\u03B9 \\n\u03B1\u03C0\u03BF\u03BA\u03C4\u03AE\u03C3\u03C4\u03B5 \u03C0\u03C1\u03CC\u03C3\u03B2\u03B1\u03C3\u03B7 \u03C3\u03C4\u03B9\u03C2 \u03B5\u03C5\u03AD\u03BB\u03B9\u03BA\u03C4\u03B5\u03C2 \u03C0\u03BB\u03B7\u03C1\u03C9\u03BC\u03AD\u03C2","start_edit_company":"\u039E\u03B5\u03BA\u03B9\u03BD\u03AE\u03C3\u03C4\u03B5 \u03A4\u03CE\u03C1\u03B1","add_poc":"\u039F\u03C1\u03AF\u03C3\u03C4\u03B5 \u03C1\u03CC\u03BB\u03BF\u03C5\u03C2 \\n\u03B3\u03B9\u03B1 \u03C4\u03B1 \u03BC\u03AD\u03BB\u03B7 \u03C4\u03B7\u03C2 \u03BF\u03BC\u03AC\u03B4\u03B1\u03C2","start_add_poc":"\u039E\u03B5\u03BA\u03B9\u03BD\u03AE\u03C3\u03C4\u03B5 \u03A4\u03CE\u03C1\u03B1","dismiss_add_poc":"\u039A\u03BB\u03B5\u03AF\u03C3\u03B9\u03BC\u03BF","error_failed_to_load":"\u0391\u03C0\u03BF\u03C4\u03C5\u03C7\u03AF\u03B1 \u03C6\u03CC\u03C1\u03C4\u03C9\u03C3\u03B7\u03C2 carousel","connect":"\u03A3\u03CD\u03BD\u03B4\u03B5\u03C3\u03B7","connect_your_bank_account":"\u03A3\u03C5\u03BD\u03B4\u03AD\u03C3\u03C4\u03B5 \u03C4\u03BF\u03BD \u03BB\u03BF\u03B3\u03B1\u03C1\u03B9\u03B1\u03C3\u03BC\u03CC \u03BC\u03B5 \u03C4\u03B7\u03BD \u03A4\u03C1\u03AC\u03C0\u03B5\u03B6\u03AC \u03C3\u03B1\u03C2","become_affiliate":"\u03A0\u03C1\u03BF\u03C3\u03BA\u03B1\u03BB\u03AD\u03C3\u03C4\u03B5 \u03C4\u03BF \u03C0\u03C1\u03BF\u03C3\u03C9\u03C0\u03B9\u03BA\u03CC \u03C3\u03B1\u03C2 \u03BD\u03B1 \u03C3\u03C5\u03BC\u03BC\u03B5\u03C4\u03AC\u03C3\u03C7\u03B5\u03B9 \u03C3\u03C4\u03B7\u03BD Ogram"},"not_authorized_error":{"title":"\u0394\u03B5\u03BD \u03B5\u03C0\u03B9\u03C4\u03C1\u03AD\u03C0\u03B5\u03C4\u03B1\u03B9 \u03B7 \u03C0\u03C1\u03CC\u03C3\u03B2\u03B1\u03C3\u03B7","description":"\u0394\u03B5\u03BD \u03AD\u03C7\u03B5\u03C4\u03B5 \u03AC\u03B4\u03B5\u03B9\u03B1 \u03C0\u03C1\u03CC\u03C3\u03B2\u03B1\u03C3\u03B7\u03C2 \u03C3\u03C4\u03B7 \u03C3\u03C5\u03B3\u03BA\u03B5\u03BA\u03C1\u03B9\u03BC\u03AD\u03BD\u03B7 \u03C3\u03B5\u03BB\u03AF\u03B4\u03B1...","sign_in":"\u03A3\u03CD\u03BD\u03B4\u03B5\u03C3\u03B7","toast_title":"Your session has expired. Please log in again to continue."},"page_not_found":{"title":"\u0397 \u03C3\u03B5\u03BB\u03AF\u03B4\u03B1 \u03B4\u03B5\u03BD \u03B2\u03C1\u03AD\u03B8\u03B7\u03BA\u03B5!","description":"\u0397 \u03C3\u03B5\u03BB\u03AF\u03B4\u03B1 \u03C0\u03BF\u03C5 \u03C8\u03AC\u03C7\u03BD\u03B5\u03C4\u03B5 \u03B4\u03B5\u03BD \u03C5\u03C0\u03AC\u03C1\u03C7\u03B5\u03B9...","go_back":"\u03A0\u03AF\u03C3\u03C9"},"permission_error":{"title":"\u0394\u03B5\u03BD \u03AD\u03C7\u03B5\u03C4\u03B5 \u03AC\u03B4\u03B5\u03B9\u03B1 \u03BD\u03B1 \u03B4\u03B5\u03AF\u03C4\u03B5 \u03B1\u03C5\u03C4\u03AE \u03C4\u03B7 \u03C3\u03B5\u03BB\u03AF\u03B4\u03B1","back":"\u03A0\u03AF\u03C3\u03C9"},"too_many_attempts":{"title":"\u03A0\u03AC\u03C1\u03B1 \u03C0\u03BF\u03BB\u03BB\u03AD\u03C2 \u03C0\u03C1\u03BF\u03C3\u03C0\u03AC\u03B8\u03B5\u03B9\u03B5\u03C2!","description":"\u03A0\u03B1\u03C1\u03B1\u03BA\u03B1\u03BB\u03BF\u03CD\u03BC\u03B5 \u03B4\u03BF\u03BA\u03B9\u03BC\u03AC\u03C3\u03C4\u03B5 \u03C0\u03AC\u03BB\u03B9 \u03C3\u03B5 \u03BB\u03AF\u03B3\u03BF.","ok":"O\u03BA"},"notifications":{"title":"\u0395\u03B9\u03B4\u03BF\u03C0\u03BF\u03B9\u03AE\u03C3\u03B5\u03B9\u03C2","load_more":"\u03A6\u03CC\u03C1\u03C4\u03C9\u03C3\u03B7 \u03C0\u03B5\u03C1\u03B9\u03C3\u03C3\u03CC\u03C4\u03B5\u03C1\u03C9\u03BD","no_more_notifications":"\u0394\u03B5\u03BD \u03C5\u03C0\u03AC\u03C1\u03C7\u03BF\u03C5\u03BD \u03AC\u03BB\u03BB\u03B5\u03C2 \u03B5\u03B9\u03B4\u03BF\u03C0\u03BF\u03B9\u03AE\u03C3\u03B5\u03B9\u03C2","no_notifications_yet":"\u0394\u03B5\u03BD \u03C5\u03C0\u03AC\u03C1\u03C7\u03BF\u03C5\u03BD \u03B5\u03B9\u03B4\u03BF\u03C0\u03BF\u03B9\u03AE\u03C3\u03B5\u03B9\u03C2 \u03B1\u03BA\u03CC\u03BC\u03B1","error_failed_to_load_notifications":"\u0391\u03C0\u03BF\u03C4\u03C5\u03C7\u03AF\u03B1 \u03C6\u03CC\u03C1\u03C4\u03C9\u03C3\u03B7\u03C2 \u03B5\u03B9\u03B4\u03BF\u03C0\u03BF\u03B9\u03AE\u03C3\u03B5\u03C9\u03BD. \u03A0\u03C1\u03BF\u03C3\u03C0\u03B1\u03B8\u03AE\u03C3\u03C4\u03B5 \u03B1\u03C1\u03B3\u03CC\u03C4\u03B5\u03C1\u03B1"},"home_onboarding":{"title":"\u0391\u03C1\u03C7\u03B9\u03BA\u03AE","intro_title":"\u039A\u03B1\u03BB\u03C9\u03C3\u03AE\u03C1\u03B8\u03B1\u03C4\u03B5 \u03C3\u03C4\u03B7\u03BD Ogram!","intro_description":"\u0397 \u03AD\u03BE\u03C5\u03C0\u03BD\u03B7 \u03C0\u03BB\u03B1\u03C4\u03C6\u03CC\u03C1\u03BC\u03B1 \u03C0\u03BF\u03C5 \u03C7\u03C1\u03B7\u03C3\u03B9\u03BC\u03BF\u03C0\u03BF\u03B9\u03BF\u03CD\u03BD \u03B5\u03C0\u03B9\u03C7\u03B5\u03B9\u03C1\u03AE\u03C3\u03B5\u03B9\u03C2 \u03BA\u03B1\u03B9 \u03B9\u03B4\u03B9\u03CE\u03C4\u03B5\u03C2 \u03B3\u03B9\u03B1 \u03BD\u03B1 \u03BA\u03B1\u03BB\u03CD\u03C8\u03BF\u03C5\u03BD \u03AC\u03BC\u03B5\u03C3\u03B1 \u03BA\u03B1\u03B9 \u03B5\u03CD\u03BA\u03BF\u03BB\u03B1 \u03C4\u03B9\u03C2 \u03B1\u03BD\u03AC\u03B3\u03BA\u03B5\u03C2 \u03C4\u03BF\u03C5\u03C2 \u03B3\u03B9\u03B1 \u03C0\u03C1\u03BF\u03C3\u03C9\u03C0\u03B9\u03BA\u03CC \u03C0\u03C1\u03BF\u03C3\u03C9\u03C1\u03B9\u03BD\u03AE\u03C2 \u03B1\u03C0\u03B1\u03C3\u03C7\u03CC\u03BB\u03B7\u03C3\u03B7\u03C2.","intro_footer":"\u039A\u03AC\u03B8\u03B5 \u03C6\u03BF\u03C1\u03AC \u03C0\u03BF\u03C5 \u03C7\u03C1\u03B7\u03C3\u03B9\u03BC\u03BF\u03C0\u03BF\u03B9\u03B5\u03AF\u03C4\u03B5 \u03BC\u03B9\u03B1 \u03BB\u03B5\u03B9\u03C4\u03BF\u03C5\u03C1\u03B3\u03AF\u03B1 \u03B3\u03B9\u03B1 \u03C0\u03C1\u03CE\u03C4\u03B7 \u03C6\u03BF\u03C1\u03AC, \u03B8\u03B1 \u03B5\u03BC\u03C6\u03B1\u03BD\u03AF\u03B6\u03B5\u03C4\u03B1\u03B9 \u03AD\u03BD\u03B1 \u03BC\u03AE\u03BD\u03C5\u03BC\u03B1 \u03CC\u03C0\u03BF\u03C5 \u03B8\u03B1 \u03C3\u03B1\u03C2 \u03BA\u03B1\u03B8\u03BF\u03B4\u03B7\u03B3\u03B5\u03AF.","hire_title":"\u03A0\u03C1\u03BF\u03C3\u03BB\u03AC\u03B2\u03B5\u03C4\u03B5 \u03A0\u03C1\u03BF\u03C3\u03C9\u03C0\u03B9\u03BA\u03CC \u03A0\u03C1\u03BF\u03C3\u03C9\u03C1\u03B9\u03BD\u03AE\u03C2 \u0391\u03C0\u03B1\u03C3\u03C7\u03CC\u03BB\u03B7\u03C3\u03B7\u03C2","hire":"\u0397 \u03BB\u03B5\u03B9\u03C4\u03BF\u03C5\u03C1\u03B3\u03AF\u03B1 \u201C\u03A0\u03C1\u03BF\u03C3\u03BB\u03AC\u03B2\u03B5\u03C4\u03B5 \u03A4\u03CE\u03C1\u03B1\u201D \u03C3\u03B1\u03C2 \u03B5\u03C0\u03B9\u03C4\u03C1\u03AD\u03C0\u03B5\u03B9 \u03BD\u03B1 \u03B2\u03C1\u03B5\u03AF\u03C4\u03B5 \u03C0\u03C1\u03BF\u03C3\u03C9\u03C0\u03B9\u03BA\u03CC \u03C0\u03C1\u03BF\u03C3\u03C9\u03C1\u03B9\u03BD\u03AE\u03C2 \u03B1\u03C0\u03B1\u03C3\u03C7\u03CC\u03BB\u03B7\u03C3\u03B7\u03C2. \u039C\u03B5 \u03B1\u03C5\u03C4\u03CC\u03BD \u03C4\u03BF\u03BD \u03C4\u03C1\u03CC\u03C0\u03BF \u03BC\u03B1\u03C2 \u03B5\u03BD\u03B7\u03BC\u03B5\u03C1\u03CE\u03BD\u03B5\u03C4\u03B5 \u03B3\u03B9\u03B1 \u03C4\u03BF \u03C4\u03B9 \u03C0\u03C1\u03BF\u03C3\u03C9\u03C0\u03B9\u03BA\u03CC \u03C7\u03C1\u03B5\u03B9\u03AC\u03B6\u03B5\u03C3\u03C4\u03B5, \u03C0\u03BF\u03CD \u03BA\u03B1\u03B9 \u03C0\u03CC\u03C4\u03B5 \u03C4\u03BF \u03C7\u03C1\u03B5\u03B9\u03AC\u03B6\u03B5\u03C3\u03C4\u03B5.","attendance_title":"\u039C\u03B5\u03C4\u03C1\u03B7\u03C4\u03AE\u03C2 \u0391\u03BD\u03B1\u03C3\u03BA\u03CC\u03C0\u03B7\u03C3\u03B7\u03C2 \u03A0\u03B1\u03C1\u03BF\u03C5\u03C3\u03B9\u03CE\u03BD","attendance":"\u0395\u03B4\u03CE \u03B5\u03BB\u03AD\u03B3\u03C7\u03B5\u03C4\u03B5 \u03BA\u03B1\u03B9 \u03C5\u03C0\u03BF\u03B3\u03C1\u03AC\u03C6\u03B5\u03C4\u03B5 \u03C4\u03B9\u03C2 \u03C8\u03B7\u03C6\u03B9\u03B1\u03BA\u03AD\u03C2 \u03B1\u03BD\u03B1\u03C6\u03BF\u03C1\u03AD\u03C2 \u03C0\u03B1\u03C1\u03BF\u03C5\u03C3\u03AF\u03B1\u03C2. \u039F \u03B1\u03C1\u03B9\u03B8\u03BC\u03CC\u03C2 \u03C3\u03C4\u03BF \u03C0\u03BB\u03B1\u03AF\u03C3\u03B9\u03BF \u03C5\u03C0\u03BF\u03B4\u03B5\u03B9\u03BA\u03BD\u03CD\u03B5\u03B9 \u03C4\u03B9\u03C2 \u03B5\u03BA\u03BA\u03C1\u03B5\u03BC\u03B5\u03AF\u03C2 \u03B1\u03BD\u03B1\u03C6\u03BF\u03C1\u03AD\u03C2 \u03B3\u03B9\u03B1 \u03AD\u03BB\u03B5\u03B3\u03C7\u03BF.","orders_title":"\u039C\u03B5\u03C4\u03C1\u03B7\u03C4\u03AE\u03C2 \u0395\u03C0\u03B9\u03B2\u03B5\u03B2\u03B1\u03AF\u03C9\u03C3\u03B7\u03C2 \u03A0\u03B1\u03C1\u03B1\u03B3\u03B3\u03B5\u03BB\u03B9\u03CE\u03BD","orders":"\u038C\u03C0\u03BF\u03C4\u03B5 \u03BC\u03B9\u03B1 \u03C0\u03B1\u03C1\u03B1\u03B3\u03B3\u03B5\u03BB\u03AF\u03B1 \u03C0\u03C1\u03BF\u03C3\u03C9\u03C0\u03B9\u03BA\u03BF\u03CD \u03B1\u03C0\u03B1\u03B9\u03C4\u03B5\u03AF \u03C7\u03B5\u03B9\u03C1\u03BF\u03BA\u03AF\u03BD\u03B7\u03C4\u03B7 \u03C4\u03B9\u03BC\u03BF\u03BB\u03CC\u03B3\u03B7\u03C3\u03B7, \u03C7\u03C1\u03B5\u03B9\u03B1\u03B6\u03CC\u03BC\u03B1\u03C3\u03C4\u03B5 \u03C4\u03B7\u03BD \u03C4\u03B5\u03BB\u03B9\u03BA\u03AE \u03C3\u03B1\u03C2 \u03B5\u03C0\u03B9\u03B2\u03B5\u03B2\u03B1\u03AF\u03C9\u03C3\u03B7 \u03C0\u03C1\u03B9\u03BD \u03BC\u03C0\u03BF\u03C1\u03AD\u03C3\u03BF\u03C5\u03BC\u03B5 \u03BD\u03B1 \u03B1\u03BD\u03B1\u03B8\u03AD\u03C3\u03BF\u03C5\u03BC\u03B5 \u03C4\u03BF \u03C0\u03C1\u03BF\u03C3\u03C9\u03C0\u03B9\u03BA\u03CC. \u0395\u03B4\u03CE \u03BC\u03C0\u03BF\u03C1\u03B5\u03AF\u03C4\u03B5 \u03BD\u03B1 \u03B1\u03C0\u03BF\u03BA\u03C4\u03AE\u03C3\u03B5\u03C4\u03B5 \u03C0\u03C1\u03CC\u03C3\u03B2\u03B1\u03C3\u03B7 \u03C3\u03B5 \u03CC\u03BB\u03B5\u03C2 \u03C4\u03B9\u03C2 \u03B5\u03BA\u03BA\u03C1\u03B5\u03BC\u03B5\u03AF\u03C2 \u03C0\u03B1\u03C1\u03B1\u03B3\u03B3\u03B5\u03BB\u03AF\u03B5\u03C2.","ratings_title":"\u039C\u03B5\u03C4\u03C1\u03B7\u03C4\u03AE\u03C2 \u0391\u03B9\u03C4\u03B7\u03BC\u03AC\u03C4\u03C9\u03BD \u0391\u03BE\u03B9\u03BF\u03BB\u03CC\u03B3\u03B7\u03C3\u03B7\u03C2","ratings":"\u0397 \u03B3\u03BD\u03CE\u03BC\u03B7 \u03C3\u03B1\u03C2 \u03B5\u03AF\u03BD\u03B1\u03B9 \u03C0\u03BF\u03BB\u03CD \u03C3\u03B7\u03BC\u03B1\u03BD\u03C4\u03B9\u03BA\u03AE \u03B3\u03B9\u03B1 \u03B5\u03BC\u03AC\u03C2 \u03BA\u03B1\u03B9 \u03C4\u03B7\u03BD \u03C7\u03C1\u03B7\u03C3\u03B9\u03BC\u03BF\u03C0\u03BF\u03B9\u03BF\u03CD\u03BC\u03B5 \u03C3\u03C4\u03B7\u03BD \u03C0\u03C1\u03BF\u03B7\u03B3\u03BC\u03AD\u03BD\u03B7 \u03C4\u03B5\u03C7\u03BD\u03BF\u03BB\u03BF\u03B3\u03AF\u03B1 \u03BC\u03B1\u03C2 \u03B3\u03B9\u03B1 \u03BD\u03B1 \u03B2\u03B5\u03BB\u03C4\u03B9\u03CE\u03BD\u03BF\u03C5\u03BC\u03B5 \u03C3\u03C5\u03BD\u03B5\u03C7\u03CE\u03C2 \u03C4\u03B9\u03C2 \u03C5\u03C0\u03B7\u03C1\u03B5\u03C3\u03AF\u03B5\u03C2 \u03BC\u03B1\u03C2. \u0395\u03B4\u03CE \u03BC\u03C0\u03BF\u03C1\u03B5\u03AF\u03C4\u03B5 \u03BD\u03B1 \u03B1\u03BE\u03B9\u03BF\u03BB\u03BF\u03B3\u03AE\u03C3\u03B5\u03C4\u03B5 \u03C4\u03B7\u03BD \u03C5\u03C0\u03B7\u03C1\u03B5\u03C3\u03AF\u03B1.","applicants_review_title":"\u039C\u03B5\u03C4\u03C1\u03B7\u03C4\u03AE\u03C2 \u03A5\u03C0\u03BF\u03C8\u03B7\u03C6\u03AF\u03C9\u03BD \u0395\u03C1\u03B3\u03B1\u03B6\u03CC\u03BC\u03B5\u03BD\u03C9\u03BD","applicants_review":"\u0397 \u03C0\u03BB\u03B1\u03C4\u03C6\u03CC\u03C1\u03BC\u03B1 \u03B5\u03C0\u03B9\u03BB\u03AD\u03B3\u03B5\u03B9 \u03BA\u03B1\u03B9 \u03B1\u03BD\u03B1\u03B8\u03AD\u03C4\u03B5\u03B9 \u03B1\u03C5\u03C4\u03CC\u03BC\u03B1\u03C4\u03B1 \u03C4\u03BF \u03C0\u03C1\u03BF\u03C3\u03C9\u03C0\u03B9\u03BA\u03CC. \u039C\u03C0\u03BF\u03C1\u03B5\u03AF\u03C4\u03B5 \u03B5\u03C0\u03AF\u03C3\u03B7\u03C2 \u03BD\u03B1 \u03B5\u03C0\u03B9\u03BB\u03AD\u03BE\u03B5\u03C4\u03B5 \u03C4\u03BF \u03C0\u03C1\u03BF\u03C3\u03C9\u03C0\u03B9\u03BA\u03CC \u03BC\u03B5 \u03B2\u03AC\u03C3\u03B7 \u03C4\u03B7\u03BD \u03B5\u03BC\u03C0\u03B5\u03B9\u03C1\u03AF\u03B1 \u03C4\u03BF\u03C5. \u0395\u03B4\u03CE \u03BC\u03C0\u03BF\u03C1\u03B5\u03AF\u03C4\u03B5 \u03BD\u03B1 \u03B1\u03BD\u03B1\u03B8\u03B5\u03C9\u03C1\u03AE\u03C3\u03B5\u03C4\u03B5 \u03BA\u03B1\u03B9 \u03BD\u03B1 \u03B5\u03C0\u03B9\u03BB\u03AD\u03BE\u03B5\u03C4\u03B5 \u03C5\u03C0\u03BF\u03C8\u03B7\u03C6\u03AF\u03BF\u03C5\u03C2.","outro":"\u0395\u03AF\u03C3\u03C4\u03B5 \u03AD\u03C4\u03BF\u03B9\u03BC\u03BF\u03B9 \u03BD\u03B1 \u03BE\u03B5\u03BA\u03B9\u03BD\u03AE\u03C3\u03B5\u03C4\u03B5; \\n\u039C\u03C0\u03BF\u03C1\u03B5\u03AF\u03C4\u03B5 \u03C0\u03AC\u03BD\u03C4\u03B1 \u03BD\u03B1 \u03AD\u03C7\u03B5\u03C4\u03B5 \u03C0\u03C1\u03CC\u03C3\u03B2\u03B1\u03C3\u03B7 \u03C3\u03C4\u03BF \'\u039A\u03AD\u03BD\u03C4\u03C1\u03BF \u0393\u03BD\u03CE\u03C3\u03B7\u03C2\' \u03B1\u03C0\u03CC \u03C4\u03BF \u03BC\u03B5\u03BD\u03BF\u03CD \u03C4\u03B7\u03C2 \u03B1\u03C1\u03C7\u03B9\u03BA\u03AE\u03C2 \u03BF\u03B8\u03CC\u03BD\u03B7\u03C2 \u03AE \u03BA\u03AC\u03BD\u03BF\u03BD\u03C4\u03B1\u03C2 \u03BA\u03BB\u03B9\u03BA \u03C3\u03C4\u03BF \'?\', \u03CC\u03C0\u03BF\u03C4\u03B5 \u03C7\u03C1\u03B5\u03B9\u03AC\u03B6\u03B5\u03C3\u03C4\u03B5 \u03BA\u03B1\u03B8\u03BF\u03B4\u03AE\u03B3\u03B7\u03C3\u03B7."},"all_jobs_onboarding":{"title":"\u038C\u03BB\u03B5\u03C2 \u03BF\u03B9 \u0398\u03AD\u03C3\u03B5\u03B9\u03C2 \u0395\u03C1\u03B3\u03B1\u03C3\u03AF\u03B1\u03C2","jobs_list_title":"\u039B\u03AF\u03C3\u03C4\u03B1 \u0398\u03AD\u03C3\u03B5\u03C9\u03BD \u0395\u03C1\u03B3\u03B1\u03C3\u03AF\u03B1\u03C2","jobs_list":"\u03A3\u03C4\u03B7\u03BD \u03B5\u03BD\u03CC\u03C4\u03B7\u03C4\u03B1 \u201C\u038C\u03BB\u03B5\u03C2 \u03BF\u03B9 \u0394\u03BF\u03C5\u03BB\u03B5\u03B9\u03AD\u03C2\u201D \u03B8\u03B1 \u03B2\u03C1\u03B5\u03AF\u03C4\u03B5 \u03BC\u03B9\u03B1 \u03BB\u03AF\u03C3\u03C4\u03B1 \u03C4\u03C9\u03BD \u03B8\u03AD\u03C3\u03B5\u03C9\u03BD \u03B5\u03C1\u03B3\u03B1\u03C3\u03AF\u03B1\u03C2 \u03C3\u03B1\u03C2, \u03C7\u03C9\u03C1\u03B9\u03C3\u03BC\u03AD\u03BD\u03B7 \u03B1\u03BD\u03AC \u03B7\u03BC\u03AD\u03C1\u03B1. \u039A\u03AC\u03BD\u03BF\u03BD\u03C4\u03B1\u03C2 \u03BA\u03BB\u03B9\u03BA \u03C3\u03B5 \u03BC\u03B9\u03B1 \u03B8\u03AD\u03C3\u03B7 \u03B5\u03C1\u03B3\u03B1\u03C3\u03AF\u03B1\u03C2, \u03BC\u03C0\u03BF\u03C1\u03B5\u03AF\u03C4\u03B5 \u03BD\u03B1 \u03B4\u03B5\u03AF\u03C4\u03B5 \u03C4\u03B7 \u03BB\u03AF\u03C3\u03C4\u03B1 \u03C4\u03C9\u03BD Ogrammers \u03C0\u03BF\u03C5 \u03B8\u03B1 \u03B5\u03C1\u03B3\u03B1\u03C3\u03C4\u03BF\u03CD\u03BD \u03C3\u03B5 \u03B1\u03C5\u03C4\u03AE\u03BD.","job_details_title":"\u03A0\u03BB\u03B7\u03C1\u03BF\u03C6\u03BF\u03C1\u03AF\u03B5\u03C2 \u0398\u03AD\u03C3\u03B7\u03C2 \u03B5\u03C1\u03B3\u03B1\u03C3\u03AF\u03B1\u03C2","job_details":"\u03A3\u03C4\u03B7 \u03C3\u03B5\u03BB\u03AF\u03B4\u03B1 \u03BC\u03B9\u03B1\u03C2 \u03B8\u03AD\u03C3\u03B7\u03C2 \u03B5\u03C1\u03B3\u03B1\u03C3\u03AF\u03B1\u03C2, \u03BC\u03C0\u03BF\u03C1\u03B5\u03AF\u03C4\u03B5 \u03BD\u03B1 \u03BA\u03B1\u03C4\u03B1\u03B3\u03C1\u03AC\u03C8\u03B5\u03C4\u03B5 \u03C4\u03B7\u03BD \u03AC\u03C6\u03B9\u03BE\u03B7 \u03C4\u03BF\u03C5 \u03C0\u03C1\u03BF\u03C3\u03C9\u03C0\u03B9\u03BA\u03BF\u03CD, \u03BD\u03B1 \u03B5\u03C0\u03B5\u03BA\u03C4\u03B5\u03AF\u03BD\u03B5\u03C4\u03B5 \u03AE \u03BD\u03B1 \u03B1\u03BA\u03C5\u03C1\u03CE\u03C3\u03B5\u03C4\u03B5 \u03B2\u03AC\u03C1\u03B4\u03B9\u03B5\u03C2. \u0397 \u03C0\u03C1\u03BF\u03C3\u03B8\u03AE\u03BA\u03B7 \u03B5\u03BD\u03CC\u03C2 Ogrammer \u03C3\u03C4\u03B1 \u03B1\u03B3\u03B1\u03C0\u03B7\u03BC\u03AD\u03BD\u03B1 \u03B4\u03AF\u03BD\u03B5\u03B9 \u03BC\u03B5\u03B3\u03B1\u03BB\u03CD\u03C4\u03B5\u03C1\u03B5\u03C2 \u03C0\u03B9\u03B8\u03B1\u03BD\u03CC\u03C4\u03B7\u03C4\u03B5\u03C2 \u03C3\u03C4\u03B7\u03BD \u03B5\u03C0\u03B9\u03BB\u03BF\u03B3\u03AE \u03C4\u03BF\u03C5\u03C2 \u03C4\u03B7\u03BD \u03B5\u03C0\u03CC\u03BC\u03B5\u03BD\u03B7 \u03C6\u03BF\u03C1\u03AC.","change_schedule_title":"\u0391\u03BB\u03BB\u03B1\u03B3\u03AE \u03A0\u03C1\u03BF\u03B3\u03C1\u03AC\u03BC\u03BC\u03B1\u03C4\u03BF\u03C2","change_schedule":"\u039C\u03C0\u03BF\u03C1\u03B5\u03AF\u03C4\u03B5 \u03BD\u03B1 \u03C0\u03C1\u03BF\u03C3\u03B1\u03C1\u03BC\u03CC\u03C3\u03B5\u03C4\u03B5 \u03C4\u03BF \u03C0\u03C1\u03CC\u03B3\u03C1\u03B1\u03BC\u03BC\u03B1 \u03C4\u03C9\u03BD \u03B2\u03B1\u03C1\u03B4\u03B9\u03CE\u03BD \u03C3\u03B1\u03C2. \u0397 \u03B5\u03BD\u03B7\u03BC\u03AD\u03C1\u03C9\u03C3\u03B7 \u03C4\u03BF\u03C5 \u03C0\u03C1\u03BF\u03B3\u03C1\u03AC\u03BC\u03BC\u03B1\u03C4\u03BF\u03C2 \u03B5\u03AF\u03BD\u03B1\u03B9 \u03C0\u03BF\u03BB\u03CD \u03C3\u03B7\u03BC\u03B1\u03BD\u03C4\u03B9\u03BA\u03AE, \u03CE\u03C3\u03C4\u03B5 \u03BF\u03B9 Ogrammers \u03BD\u03B1 \u03BC\u03C0\u03BF\u03C1\u03BF\u03CD\u03BD \u03BD\u03B1 \u03C7\u03C1\u03B7\u03C3\u03B9\u03BC\u03BF\u03C0\u03BF\u03B9\u03BF\u03CD\u03BD \u03C4\u03B9\u03C2 \u03B5\u03C6\u03B1\u03C1\u03BC\u03BF\u03B3\u03AD\u03C2 \u03C4\u03BF\u03C5\u03C2 \u03B3\u03B9\u03B1 \u03BD\u03B1 \u03BA\u03B1\u03C4\u03B1\u03B3\u03C1\u03AC\u03C6\u03BF\u03C5\u03BD \u03C4\u03B7\u03BD \u03AC\u03C6\u03B9\u03BE\u03AE \u03C4\u03BF\u03C5\u03C2.","bulk_schedule_change_title":"\u039C\u03B1\u03B6\u03B9\u03BA\u03AE \u0391\u03BB\u03BB\u03B1\u03B3\u03AE \u03A0\u03C1\u03BF\u03B3\u03C1\u03AC\u03BC\u03BC\u03B1\u03C4\u03BF\u03C2","bulk_schedule_change":"\u039C\u03C0\u03BF\u03C1\u03B5\u03AF\u03C4\u03B5 \u03BD\u03B1 \u03B1\u03BB\u03BB\u03AC\u03BE\u03B5\u03C4\u03B5 \u03C4\u03BF \u03C0\u03C1\u03CC\u03B3\u03C1\u03B1\u03BC\u03BC\u03B1 \u03B3\u03B9\u03B1 \u03BC\u03B9\u03B1 \u03AE \u03C0\u03B5\u03C1\u03B9\u03C3\u03C3\u03CC\u03C4\u03B5\u03C1\u03B5\u03C2 \u03BC\u03AD\u03C1\u03B5\u03C2 \u03BA\u03AC\u03B8\u03B5 \u03C6\u03BF\u03C1\u03AC. \u0397 \u03B4\u03B9\u03AC\u03C1\u03BA\u03B5\u03B9\u03B1 \u03C4\u03B7\u03C2 \u03B2\u03AC\u03C1\u03B4\u03B9\u03B1\u03C2 \u03B4\u03B5\u03BD \u03BC\u03C0\u03BF\u03C1\u03B5\u03AF \u03BD\u03B1 \u03BC\u03B5\u03B9\u03C9\u03B8\u03B5\u03AF.","cancel_shift_title":"\u0391\u03BA\u03CD\u03C1\u03C9\u03C3\u03B7 \u0392\u03AC\u03C1\u03B4\u03B9\u03B1\u03C2","cancel_shift":"\u039C\u03C0\u03BF\u03C1\u03B5\u03AF\u03C4\u03B5 \u03BD\u03B1 \u03B1\u03BA\u03C5\u03C1\u03CE\u03C3\u03B5\u03C4\u03B5 \u03C4\u03B7 \u03B2\u03AC\u03C1\u03B4\u03B9\u03B1 \u03B5\u03BD\u03CC\u03C2 \u03BC\u03B5\u03BC\u03BF\u03BD\u03C9\u03BC\u03AD\u03BD\u03BF\u03C5 Ogrammer, \u03BA\u03B1\u03B8\u03CE\u03C2 \u03BA\u03B1\u03B9 \u03BD\u03B1 \u03C4\u03BF\u03C5\u03C2 \u03B1\u03C0\u03BF\u03BA\u03BB\u03B5\u03AF\u03C3\u03B5\u03C4\u03B5 \u03B1\u03C0\u03CC \u03C4\u03B7\u03BD \u03C5\u03C0\u03BF\u03B2\u03BF\u03BB\u03AE \u03B1\u03B9\u03C4\u03AE\u03C3\u03B5\u03C9\u03BD \u03B3\u03B9\u03B1 \u03CC\u03BB\u03B5\u03C2 \u03C4\u03B9\u03C2 \u03BC\u03B5\u03BB\u03BB\u03BF\u03BD\u03C4\u03B9\u03BA\u03AD\u03C2 \u03B2\u03AC\u03C1\u03B4\u03B9\u03B5\u03C2."},"attendance_review_onboarding":{"title":"\u0388\u03BB\u03B5\u03B3\u03C7\u03BF\u03C2 \u03A0\u03C1\u03BF\u03C3\u03AD\u03BB\u03B5\u03C5\u03C3\u03B7\u03C2","jobs_pending_review_title":"\u0398\u03AD\u03C3\u03B5\u03B9\u03C2 \u03B5\u03C1\u03B3\u03B1\u03C3\u03AF\u03B1\u03C2 \u03C0\u03BF\u03C5 \u03B1\u03BD\u03B1\u03BC\u03AD\u03BD\u03BF\u03C5\u03BD \u03B1\u03AF\u03C4\u03B7\u03C3\u03B7","jobs_pending_review":"\u0397 \u03B5\u03BD\u03CC\u03C4\u03B7\u03C4\u03B1 \\"\u0391\u03BD\u03B1\u03C3\u03BA\u03CC\u03C0\u03B7\u03C3\u03B7 \u03A0\u03B1\u03C1\u03BF\u03C5\u03C3\u03B9\u03CE\u03BD\\" \u03C3\u03B1\u03C2 \u03B5\u03C0\u03B9\u03C4\u03C1\u03AD\u03C0\u03B5\u03B9 \u03BD\u03B1 \u03C0\u03C1\u03BF\u03C3\u03B1\u03C1\u03BC\u03CC\u03B6\u03B5\u03C4\u03B5 \u03BA\u03B1\u03B9 \u03BD\u03B1 \u03B5\u03C0\u03B9\u03B2\u03B5\u03B2\u03B1\u03B9\u03CE\u03BD\u03B5\u03C4\u03B5 \u03C4\u03B9\u03C2 \u03C0\u03B1\u03C1\u03BF\u03C5\u03C3\u03AF\u03B5\u03C2 \u03C4\u03C9\u03BD Ogrammers \u03C3\u03B5 \u03BA\u03B1\u03B8\u03B7\u03BC\u03B5\u03C1\u03B9\u03BD\u03AE \u03B2\u03AC\u03C3\u03B7. \u0398\u03B1 \u03C7\u03C1\u03B5\u03CE\u03BD\u03B5\u03C3\u03C4\u03B5 \u03B1\u03BD\u03AC\u03BB\u03BF\u03B3\u03B1 \u03BC\u03B5 \u03C4\u03BF\u03BD \u03BA\u03B1\u03C4\u03B1\u03B3\u03B5\u03B3\u03C1\u03B1\u03BC\u03BC\u03AD\u03BD\u03BF \u03C7\u03C1\u03CC\u03BD\u03BF.","attendance_details_title":"\u039B\u03B5\u03C0\u03C4\u03BF\u03BC\u03AD\u03C1\u03B5\u03B9\u03B5\u03C2 \u03A0\u03C1\u03BF\u03C3\u03AD\u03BB\u03B5\u03C5\u03C3\u03B7\u03C2","attendance_details":"\u0397 \u03C3\u03B5\u03BB\u03AF\u03B4\u03B1 \u03BC\u03B9\u03B1\u03C2 \u03B8\u03AD\u03C3\u03B7\u03C2 \u03B5\u03C1\u03B3\u03B1\u03C3\u03AF\u03B1\u03C2 \u03B4\u03B5\u03AF\u03C7\u03BD\u03B5\u03B9 \u03BC\u03B9\u03B1 \u03BB\u03AF\u03C3\u03C4\u03B1 \u03BC\u03B5 \u03C4\u03B9\u03C2 \u03BA\u03B1\u03C4\u03B1\u03B3\u03B5\u03B3\u03C1\u03B1\u03BC\u03BC\u03AD\u03BD\u03B5\u03C2 \u03CE\u03C1\u03B5\u03C2 \u03C4\u03C9\u03BD \u03B5\u03C1\u03B3\u03B1\u03B6\u03CC\u03BC\u03B5\u03BD\u03C9\u03BD Ogrammers. \u039C\u03C0\u03BF\u03C1\u03B5\u03AF\u03C4\u03B5 \u03BD\u03B1 \u03B4\u03B9\u03BF\u03C1\u03B8\u03CE\u03C3\u03B5\u03C4\u03B5 \u03C4\u03BF\u03BD \u03C7\u03C1\u03CC\u03BD\u03BF \u03BA\u03AC\u03BD\u03BF\u03BD\u03C4\u03B1\u03C2 \u03BA\u03BB\u03B9\u03BA \u03C0\u03AC\u03BD\u03C9 \u03C4\u03BF\u03C5.","attendance_status_title":"\u0391\u03BB\u03BB\u03B1\u03B3\u03AE \u039A\u03B1\u03C4\u03AC\u03C3\u03C4\u03B1\u03C3\u03B7\u03C2 \u03A0\u03C1\u03BF\u03C3\u03AD\u03BB\u03B5\u03C5\u03C3\u03B7\u03C2","attendance_status":"\u039C\u03C0\u03BF\u03C1\u03B5\u03AF\u03C4\u03B5 \u03B5\u03C0\u03AF\u03C3\u03B7\u03C2 \u03BD\u03B1 \u03B4\u03B9\u03BF\u03C1\u03B8\u03CE\u03C3\u03B5\u03C4\u03B5 \u03C4\u03B7\u03BD \u03BA\u03B1\u03C4\u03AC\u03C3\u03C4\u03B1\u03C3\u03B7 \u03C0\u03B1\u03C1\u03BF\u03C5\u03C3\u03AF\u03B1\u03C2 \u03B5\u03BD\u03CC\u03C2 Ogrammer \u03B5\u03AC\u03BD \u03C3\u03B7\u03BC\u03B5\u03B9\u03CE\u03C3\u03B1\u03C4\u03B5 \u03BB\u03B1\u03BD\u03B8\u03B1\u03C3\u03BC\u03AD\u03BD\u03B1 \u03CC\u03C4\u03B9 \u03B4\u03B5\u03BD \u03C0\u03B1\u03C1\u03B5\u03C5\u03C1\u03AD\u03B8\u03B7\u03BA\u03B5.","attendance_time_title":"\u0391\u03BB\u03BB\u03B1\u03B3\u03AE \u038F\u03C1\u03B1\u03C2 \u03A0\u03C1\u03BF\u03C3\u03AD\u03BB\u03B5\u03C5\u03C3\u03B7\u03C2","attendance_time":"\u0398\u03B1 \u03C3\u03B1\u03C2 \u03B6\u03B7\u03C4\u03B7\u03B8\u03B5\u03AF \u03BD\u03B1 \u03B5\u03B9\u03C3\u03B1\u03B3\u03AC\u03B3\u03B5\u03C4\u03B5 \u03C4\u03BF\u03BD \u03C3\u03C9\u03C3\u03C4\u03CC \u03C7\u03C1\u03CC\u03BD\u03BF \u03C0\u03B1\u03C1\u03BF\u03C5\u03C3\u03AF\u03B1\u03C2, \u03BF \u03BF\u03C0\u03BF\u03AF\u03BF\u03C2 \u03B8\u03B1 \u03C1\u03C5\u03B8\u03BC\u03B9\u03C3\u03C4\u03B5\u03AF \u03C3\u03C4\u03B9\u03C2 \u03C0\u03C1\u03BF\u03B3\u03C1\u03B1\u03BC\u03BC\u03B1\u03C4\u03B9\u03C3\u03BC\u03AD\u03BD\u03B5\u03C2 \u03CE\u03C1\u03B5\u03C2 \u03B1\u03C0\u03CC \u03C0\u03C1\u03BF\u03B5\u03C0\u03B9\u03BB\u03BF\u03B3\u03AE.","not_attended_reason_title":"\u0391\u03BB\u03BB\u03B1\u03B3\u03AE \u039B\u03CC\u03B3\u03BF\u03C5 \u0391\u03C0\u03BF\u03C5\u03C3\u03AF\u03B1\u03C2","not_attended_reason":"\u0391\u03BD \u03AD\u03BD\u03B1\u03C2 Ogrammer \u03B4\u03B5\u03BD \u03AD\u03C7\u03B5\u03B9 \u03C0\u03B1\u03C1\u03B5\u03C5\u03C1\u03B5\u03B8\u03B5\u03AF, \u03BC\u03C0\u03BF\u03C1\u03B5\u03AF\u03C4\u03B5 \u03BD\u03B1 \u03B1\u03BB\u03BB\u03AC\u03BE\u03B5\u03C4\u03B5 \u03C4\u03B7\u03BD \u03B1\u03B9\u03C4\u03AF\u03B1\xb7 \u03B5\u03AF\u03C4\u03B5 \u03AE\u03C4\u03B1\u03BD \u03C1\u03B5\u03C0\u03CC \u03B5\u03AF\u03C4\u03B5 \u03AC\u03B4\u03B5\u03B9\u03B1 \u03B1\u03C3\u03B8\u03B5\u03BD\u03B5\u03AF\u03B1\u03C2.","confirmation_time_title":"\u0395\u03C0\u03B9\u03B2\u03B5\u03B2\u03B1\u03AF\u03C9\u03C3\u03B7 \u03CE\u03C1\u03B1\u03C2","confirmation_time":"\u0395\u03AF\u03BD\u03B1\u03B9 \u03C0\u03BF\u03BB\u03CD \u03C3\u03B7\u03BC\u03B1\u03BD\u03C4\u03B9\u03BA\u03CC \u03BD\u03B1 \u03B5\u03C0\u03B9\u03B2\u03B5\u03B2\u03B1\u03B9\u03CE\u03BD\u03BF\u03BD\u03C4\u03B1\u03B9 \u03C4\u03B1\u03BA\u03C4\u03B9\u03BA\u03AC \u03BF\u03B9 \u03C0\u03B1\u03C1\u03BF\u03C5\u03C3\u03AF\u03B5\u03C2 \u03C4\u03C9\u03BD Ogrammers, \u03BA\u03B1\u03B8\u03CE\u03C2 \u03B8\u03B1 \u03BF\u03C1\u03B9\u03C3\u03C4\u03B9\u03BA\u03BF\u03C0\u03BF\u03B9\u03BF\u03CD\u03BD\u03C4\u03B1\u03B9 \u03B1\u03C0\u03CC \u03C4\u03BF \u03C3\u03CD\u03C3\u03C4\u03B7\u03BC\u03B1 \u03B1\u03C5\u03C4\u03CC\u03BC\u03B1\u03C4\u03B1 \u03B5\u03BD\u03C4\u03CC\u03C2 72 \u03C9\u03C1\u03CE\u03BD. \u03A3\u03B5 \u03C0\u03B5\u03C1\u03AF\u03C0\u03C4\u03C9\u03C3\u03B7 \u03C0\u03BF\u03C5 \u03B4\u03B5\u03BD \u03B5\u03C0\u03B9\u03B2\u03B5\u03B2\u03B1\u03B9\u03C9\u03B8\u03BF\u03CD\u03BD, \u03B7 \u03C7\u03C1\u03AD\u03C9\u03C3\u03B7 \u03B8\u03B1 \u03B5\u03AF\u03BD\u03B1\u03B9 \u03B1\u03BD\u03AC\u03BB\u03BF\u03B3\u03B7."},"order_confirmation_onboarding":{"title":"\u03A0\u03B1\u03C1\u03B1\u03B3\u03B3\u03B5\u03BB\u03AF\u03B5\u03C2","pending_confirmation_title":"\u03A0\u03B1\u03C1\u03B1\u03B3\u03B3\u03B5\u03BB\u03AF\u03B5\u03C2 \u03C0\u03BF\u03C5 \u03B1\u03BD\u03B1\u03BC\u03AD\u03BD\u03BF\u03C5\u03BD \u03B5\u03C0\u03B9\u03B2\u03B5\u03B2\u03B1\u03AF\u03C9\u03C3\u03B7","pending_confirmation":"\u0397 \u03B5\u03BD\u03CC\u03C4\u03B7\u03C4\u03B1 \\"\u03A0\u03B1\u03C1\u03B1\u03B3\u03B3\u03B5\u03BB\u03AF\u03B5\u03C2\\" \u03C0\u03B5\u03C1\u03B9\u03BB\u03B1\u03BC\u03B2\u03AC\u03BD\u03B5\u03B9 \u03BB\u03AF\u03C3\u03C4\u03B1 \u03BC\u03B5 \u03C4\u03B9\u03C2 \u03C0\u03C1\u03BF\u03BA\u03C1\u03B1\u03C4\u03B7\u03BC\u03AD\u03BD\u03B5\u03C2 \u03B8\u03AD\u03C3\u03B5\u03B9\u03C2 \u03B5\u03C1\u03B3\u03B1\u03C3\u03AF\u03B1\u03C2 \u03C3\u03BF\u03C5, \u03B3\u03B9\u03B1 \u03C4\u03B9\u03C2 \u03BF\u03C0\u03BF\u03AF\u03B5\u03C2 \u03B5\u03BA\u03BA\u03C1\u03B5\u03BC\u03B5\u03AF \u03BF \u03AD\u03BB\u03B5\u03B3\u03C7\u03BF\u03C2 \u03BA\u03B1\u03B9 \u03B7 \u03B5\u03C0\u03B9\u03B2\u03B5\u03B2\u03B1\u03AF\u03C9\u03C3\u03AE \u03C4\u03BF\u03C5\u03C2.","order_confirmation_title":"\u0395\u03C0\u03B9\u03B2\u03B5\u03B2\u03B1\u03AF\u03C9\u03C3\u03B7 \u03A0\u03B1\u03C1\u03B1\u03B3\u03B3\u03B5\u03BB\u03B9\u03CE\u03BD","order_confirmation":"\u03A3\u03C4\u03B7 \u03C3\u03B5\u03BB\u03AF\u03B4\u03B1 \u03A0\u03B1\u03C1\u03B1\u03B3\u03B3\u03B5\u03BB\u03AF\u03B5\u03C2 \u03C3\u03B5 \u03B5\u03BA\u03BA\u03C1\u03B5\u03BC\u03CC\u03C4\u03B7\u03C4\u03B1, \u03C0\u03B1\u03C1\u03B1\u03BA\u03B1\u03BB\u03BF\u03CD\u03BC\u03B5 \u03B5\u03BB\u03AD\u03B3\u03BE\u03C4\u03B5 \u03C0\u03C1\u03BF\u03C3\u03B5\u03BA\u03C4\u03B9\u03BA\u03AC \u03C4\u03B9\u03C2 \u03BB\u03B5\u03C0\u03C4\u03BF\u03BC\u03AD\u03C1\u03B5\u03B9\u03B5\u03C2 \u03C4\u03B7\u03C2 \u03C0\u03B1\u03C1\u03B1\u03B3\u03B3\u03B5\u03BB\u03AF\u03B1\u03C2 \u03BA\u03B1\u03B9 \u03C4\u03B9\u03C2 \u03C4\u03B5\u03BB\u03B9\u03BA\u03AD\u03C2 \u03C7\u03C1\u03B5\u03CE\u03C3\u03B5\u03B9\u03C2. \u03A4\u03BF \u03C0\u03C1\u03BF\u03C3\u03C9\u03C0\u03B9\u03BA\u03CC \u03B8\u03B1 \u03B1\u03BD\u03B1\u03C4\u03B5\u03B8\u03B5\u03AF \u03BC\u03CC\u03BB\u03B9\u03C2 \u03B5\u03C0\u03B9\u03B2\u03B5\u03B2\u03B1\u03B9\u03C9\u03B8\u03B5\u03AF \u03B7 \u03C0\u03B1\u03C1\u03B1\u03B3\u03B3\u03B5\u03BB\u03AF\u03B1.","order_amend_title":"\u03A4\u03C1\u03BF\u03C0\u03BF\u03C0\u03BF\u03AF\u03B7\u03C3\u03B7 \u03A0\u03B1\u03C1\u03B1\u03B3\u03B3\u03B5\u03BB\u03AF\u03B1\u03C2","order_amend":"\u0391\u03BD \u03B1\u03BB\u03BB\u03AC\u03BE\u03BF\u03C5\u03BD \u03BF\u03B9 \u03B1\u03C0\u03B1\u03B9\u03C4\u03AE\u03C3\u03B5\u03B9\u03C2 \u03C3\u03B1\u03C2 \u03AE \u03AD\u03C7\u03B5\u03C4\u03B5 \u03B1\u03BD\u03B7\u03C3\u03C5\u03C7\u03AF\u03B5\u03C2 \u03B3\u03B9\u03B1 \u03C4\u03BF\u03BD \u03C0\u03C1\u03BF\u03CB\u03C0\u03BF\u03BB\u03BF\u03B3\u03B9\u03C3\u03BC\u03CC, \u03C0\u03B1\u03C1\u03B1\u03BA\u03B1\u03BB\u03BF\u03CD\u03BC\u03B5 \u03BC\u03B7 \u03B4\u03B9\u03C3\u03C4\u03AC\u03C3\u03B5\u03C4\u03B5 \u03BD\u03B1 \u03C4\u03C1\u03BF\u03C0\u03BF\u03C0\u03BF\u03B9\u03AE\u03C3\u03B5\u03C4\u03B5 \u03C4\u03B7\u03BD \u03C0\u03B1\u03C1\u03B1\u03B3\u03B3\u03B5\u03BB\u03AF\u03B1."},"order_creation_onboarding":{"title":"\u0394\u03B7\u03BC\u03B9\u03BF\u03C5\u03C1\u03B3\u03AF\u03B1 \u03A0\u03B1\u03C1\u03B1\u03B3\u03B3\u03B5\u03BB\u03AF\u03B1\u03C2","select_designation_title":"\u0394\u03B9\u03B1\u03BB\u03AD\u03BE\u03C4\u03B5 \u0395\u03B9\u03B4\u03B9\u03BA\u03CC\u03C4\u03B7\u03C4\u03B1","select_designation":"\u0397 \u03B4\u03B9\u03B1\u03B4\u03B9\u03BA\u03B1\u03C3\u03AF\u03B1 \u03B4\u03B7\u03BC\u03B9\u03BF\u03C5\u03C1\u03B3\u03AF\u03B1\u03C2 \u03C0\u03B1\u03C1\u03B1\u03B3\u03B3\u03B5\u03BB\u03AF\u03B1\u03C2 \u03BE\u03B5\u03BA\u03B9\u03BD\u03AC\u03B5\u03B9 \u03BC\u03B5 \u03C4\u03B7\u03BD \u03B5\u03C0\u03B9\u03BB\u03BF\u03B3\u03AE \u03B5\u03B9\u03B4\u03B9\u03BA\u03CC\u03C4\u03B7\u03C4\u03B1\u03C2 \u03B3\u03B9\u03B1 \u03C4\u03B7\u03BD \u03C0\u03C1\u03CE\u03C4\u03B7 \u03B8\u03AD\u03C3\u03B7 \u03B5\u03C1\u03B3\u03B1\u03C3\u03AF\u03B1\u03C2. \u039C\u03C0\u03BF\u03C1\u03BF\u03CD\u03BD \u03BD\u03B1 \u03C0\u03C1\u03BF\u03C3\u03C4\u03B5\u03B8\u03BF\u03CD\u03BD \u03B5\u03C0\u03B9\u03C0\u03BB\u03AD\u03BF\u03BD \u03B5\u03B9\u03B4\u03B9\u03BA\u03CC\u03C4\u03B7\u03C4\u03B5\u03C2 \u03BC\u03CC\u03BB\u03B9\u03C2 \u03B4\u03B7\u03BC\u03B9\u03BF\u03C5\u03C1\u03B3\u03B7\u03B8\u03B5\u03AF \u03B7 \u03C0\u03C1\u03CE\u03C4\u03B7 \u03B8\u03AD\u03C3\u03B7.","job_details_title":"\u039B\u03B5\u03C0\u03C4\u03BF\u03BC\u03AD\u03C1\u03B5\u03B9\u03B5\u03C2 \u0398\u03AD\u03C3\u03B7\u03C2 \u0395\u03C1\u03B3\u03B1\u03C3\u03AF\u03B1\u03C2","job_details":"\u0395\u03C0\u03B9\u03BB\u03AD\u03BE\u03C4\u03B5 \u03C4\u03B7\u03BD \u03B8\u03AD\u03C3\u03B7 \u03C0\u03BF\u03C5 \u03B8\u03AD\u03BB\u03B5\u03C4\u03B5 \u03BD\u03B1 \u03BA\u03B1\u03BB\u03CD\u03C8\u03B5\u03C4\u03B5 \u03BA\u03B1\u03B9 \u03C3\u03C4\u03B7\u03BD \u03C3\u03C5\u03BD\u03AD\u03C7\u03B5\u03B9\u03B1 \u03B5\u03BD\u03B7\u03BC\u03B5\u03C1\u03CE\u03C3\u03C4\u03B5 \u03C4\u03BF\u03BD \u03B1\u03C1\u03B9\u03B8\u03BC\u03CC \u03C4\u03C9\u03BD \u03C5\u03C0\u03B1\u03BB\u03BB\u03AE\u03BB\u03C9\u03BD \u03C0\u03BF\u03C5 \u03C7\u03C1\u03B5\u03B9\u03AC\u03B6\u03B5\u03C3\u03C4\u03B5 \u03C3\u03C4\u03BF \u03C0\u03B5\u03B4\u03AF\u03BF \u201C\u03C0\u03BF\u03C3\u03CC\u03C4\u03B7\u03C4\u03B1\u201D.","job_duration_title":"\u0394\u03B9\u03AC\u03C1\u03BA\u03B5\u03B9\u03B1 \u0398\u03AD\u03C3\u03B7\u03C2 \u0395\u03C1\u03B3\u03B1\u03C3\u03AF\u03B1\u03C2","job_duration":"\u0391\u03BD \u03B7 \u03B4\u03BF\u03C5\u03BB\u03B5\u03B9\u03AC \u03B5\u03AF\u03BD\u03B1\u03B9 \u03B5\u03C0\u03B1\u03BD\u03B1\u03BB\u03B1\u03BC\u03B2\u03B1\u03BD\u03CC\u03BC\u03B5\u03BD\u03B7 \u03BA\u03B1\u03B9 \u03B4\u03B5\u03BD \u03AD\u03C7\u03B5\u03B9 \u03C3\u03C5\u03B3\u03BA\u03B5\u03BA\u03C1\u03B9\u03BC\u03AD\u03BD\u03B7 \u03B7\u03BC\u03B5\u03C1\u03BF\u03BC\u03B7\u03BD\u03AF\u03B1 \u03BB\u03AE\u03BE\u03B7\u03C2, \u03BC\u03C0\u03BF\u03C1\u03B5\u03AF\u03C4\u03B5 \u03BD\u03B1 \u03C3\u03CD\u03C1\u03B5\u03C4\u03B5 \u03C4\u03BF\u03BD \u03B4\u03B9\u03B1\u03BA\u03CC\u03C0\u03C4\u03B7 \u03B3\u03B9\u03B1 \u03BD\u03B1 \u03B1\u03C6\u03B1\u03B9\u03C1\u03AD\u03C3\u03B5\u03C4\u03B5 \u03C4\u03B7\u03BD \u03B7\u03BC\u03B5\u03C1\u03BF\u03BC\u03B7\u03BD\u03AF\u03B1 \u03BB\u03AE\u03BE\u03B7\u03C2 \u03BA\u03B1\u03B9 \u03BD\u03B1 \u03BA\u03C1\u03B1\u03C4\u03AE\u03C3\u03B5\u03C4\u03B5 \u03C4\u03B7 \u03B4\u03BF\u03C5\u03BB\u03B5\u03B9\u03AC \u03B1\u03BD\u03BF\u03B9\u03C7\u03C4\u03AE.","scheduling_options_title":"\u0395\u03C0\u03B9\u03BB\u03BF\u03B3\u03AD\u03C2 \u03A0\u03C1\u03BF\u03B3\u03C1\u03B1\u03BC\u03BC\u03B1\u03C4\u03B9\u03C3\u03BC\u03BF\u03CD","scheduling_options":"\u0395\u03AC\u03BD \u03C4\u03BF \u03C0\u03C1\u03CC\u03B3\u03C1\u03B1\u03BC\u03BC\u03B1 \u03C4\u03B7\u03C2 \u03B8\u03AD\u03C3\u03B7\u03C2 \u03B5\u03C0\u03B1\u03BD\u03B1\u03BB\u03B1\u03BC\u03B2\u03AC\u03BD\u03B5\u03C4\u03B1\u03B9 \u03BA\u03AC\u03B8\u03B5 \u03B5\u03B2\u03B4\u03BF\u03BC\u03AC\u03B4\u03B1, \u03B5\u03C0\u03B9\u03BB\u03AD\u03BE\u03C4\u03B5 \u03C4\u03B7\u03BD \'\u0395\u03B2\u03B4\u03BF\u03BC\u03B1\u03B4\u03B9\u03B1\u03AF\u03B1\' \u03B5\u03C0\u03B9\u03BB\u03BF\u03B3\u03AE \u03BA\u03B1\u03B9 \u03BF\u03C1\u03AF\u03C3\u03C4\u03B5 \u03C4\u03B9\u03C2 \u03CE\u03C1\u03B5\u03C2 \u03B5\u03C1\u03B3\u03B1\u03C3\u03AF\u03B1\u03C2 \u03B3\u03B9\u03B1 \u03C4\u03B7\u03BD \u03BA\u03AC\u03B8\u03B5 \u03B7\u03BC\u03AD\u03C1\u03B1. \u0394\u03B9\u03B1\u03C6\u03BF\u03C1\u03B5\u03C4\u03B9\u03BA\u03AC, \u03BC\u03C0\u03BF\u03C1\u03B5\u03AF\u03C4\u03B5 \u03BD\u03B1 \u03C6\u03C4\u03B9\u03AC\u03BE\u03B5\u03C4\u03B5 \u03C4\u03BF \u03C0\u03C1\u03CC\u03B3\u03C1\u03B1\u03BC\u03BC\u03B1 \u03C3\u03B5 \u03BA\u03B1\u03B8\u03B7\u03BC\u03B5\u03C1\u03B9\u03BD\u03AE \u03B2\u03AC\u03C3\u03B7","job_requirements_title":"\u0391\u03C0\u03B1\u03B9\u03C4\u03AE\u03C3\u03B5\u03B9\u03C2 \u0398\u03AD\u03C3\u03B7\u03C2","job_requirements":"\u039C\u03C0\u03BF\u03C1\u03B5\u03AF\u03C4\u03B5 \u03BD\u03B1 \u03B5\u03C0\u03B9\u03BB\u03AD\u03BE\u03B5\u03C4\u03B5 \u03B4\u03B5\u03BE\u03B9\u03CC\u03C4\u03B7\u03C4\u03B5\u03C2 \u03B1\u03C0\u03CC \u03C4\u03B7\u03BD \u03C0\u03C1\u03BF\u03BA\u03B1\u03B8\u03BF\u03C1\u03B9\u03C3\u03BC\u03AD\u03BD\u03B7 \u03BB\u03AF\u03C3\u03C4\u03B1 \u03AE \u03BD\u03B1 \u03C0\u03C1\u03BF\u03C3\u03B8\u03AD\u03C3\u03B5\u03C4\u03B5 \u03C3\u03C5\u03B3\u03BA\u03B5\u03BA\u03C1\u03B9\u03BC\u03AD\u03BD\u03B5\u03C2 \u03B4\u03B5\u03BE\u03B9\u03CC\u03C4\u03B7\u03C4\u03B5\u03C2/\u03BA\u03B1\u03B8\u03AE\u03BA\u03BF\u03BD\u03C4\u03B1 \u03C0\u03BF\u03C5 \u03B1\u03C0\u03B1\u03B9\u03C4\u03BF\u03CD\u03BD\u03C4\u03B1\u03B9 \u03B3\u03B9\u03B1 \u03C4\u03B7 \u03B8\u03AD\u03C3\u03B7.","shifts_breakdown_title":"\u0391\u03BD\u03AC\u03BB\u03C5\u03C3\u03B7 \u0392\u03B1\u03C1\u03B4\u03B9\u03CE\u03BD","shifts_breakdown":"\u039C\u03CC\u03BB\u03B9\u03C2 \u03BA\u03B1\u03B8\u03BF\u03C1\u03AF\u03C3\u03B5\u03C4\u03B5 \u03C4\u03B9\u03C2 \u03BB\u03B5\u03C0\u03C4\u03BF\u03BC\u03AD\u03C1\u03B5\u03B9\u03B5\u03C2 \u03C4\u03B7\u03C2 \u03C0\u03C1\u03CE\u03C4\u03B7\u03C2 \u03B4\u03BF\u03C5\u03BB\u03B5\u03B9\u03AC\u03C2, \u03B4\u03B7\u03BC\u03B9\u03BF\u03C5\u03C1\u03B3\u03B5\u03AF\u03C4\u03B1\u03B9 \u03BC\u03B9\u03B1 \u03C0\u03C1\u03CC\u03C7\u03B5\u03B9\u03C1\u03B7 \u03C0\u03B1\u03C1\u03B1\u03B3\u03B3\u03B5\u03BB\u03AF\u03B1. \u039C\u03C0\u03BF\u03C1\u03B5\u03AF\u03C4\u03B5 \u03BD\u03B1 \u03C0\u03C1\u03BF\u03C3\u03B8\u03AD\u03C3\u03B5\u03C4\u03B5 \u03C0\u03B5\u03C1\u03B9\u03C3\u03C3\u03CC\u03C4\u03B5\u03C1\u03B5\u03C2 \u03B4\u03BF\u03C5\u03BB\u03B5\u03B9\u03AD\u03C2/\u03B8\u03AD\u03C3\u03B5\u03B9\u03C2 \u03C3\u03C4\u03B7\u03BD \u03C0\u03B1\u03C1\u03B1\u03B3\u03B3\u03B5\u03BB\u03AF\u03B1 \u03C0\u03B1\u03C4\u03CE\u03BD\u03C4\u03B1\u03C2 \u03C4\u03BF \u03BA\u03BF\u03C5\u03BC\u03C0\u03AF \u201C\u03A0\u03C1\u03BF\u03C3\u03B8\u03AE\u03BA\u03B7 \u0386\u03BB\u03BB\u03B7\u03C2 \u0394\u03BF\u03C5\u03BB\u03B5\u03B9\u03AC\u03C2\u201D.","duplicate_job_title":"\u0391\u03BD\u03C4\u03B9\u03B3\u03C1\u03B1\u03C6\u03AE \u0398\u03AD\u03C3\u03B7\u03C2 \u0395\u03C1\u03B3\u03B1\u03C3\u03AF\u03B1\u03C2","duplicate_job":"\u0395\u03AC\u03BD \u03B5\u03C0\u03B9\u03B8\u03C5\u03BC\u03B5\u03AF\u03C4\u03B5 \u03BD\u03B1 \u03B4\u03B7\u03BC\u03B9\u03BF\u03C5\u03C1\u03B3\u03AE\u03C3\u03B5\u03C4\u03B5 \u03BA\u03B1\u03B9 \u03AC\u03BB\u03BB\u03B5\u03C2 \u03B8\u03AD\u03C3\u03B5\u03B9\u03C2 \u03BC\u03B5 \u03AF\u03B4\u03B9\u03B5\u03C2 \u03AE \u03C0\u03B1\u03C1\u03CC\u03BC\u03BF\u03B9\u03B5\u03C2 \u03B1\u03C0\u03B1\u03B9\u03C4\u03AE\u03C3\u03B5\u03B9\u03C2, \u03BC\u03C0\u03BF\u03C1\u03B5\u03AF\u03C4\u03B5 \u03BD\u03B1 \u03BA\u03AC\u03BD\u03B5\u03C4\u03B5 \u03BA\u03BB\u03B9\u03BA \u03C3\u03C4\u03BF \u03BA\u03BF\u03C5\u03BC\u03C0\u03AF \u03B1\u03BD\u03C4\u03B9\u03B3\u03C1\u03B1\u03C6\u03AE\u03C2 \u03B8\u03AD\u03C3\u03B7\u03C2 \u03B5\u03C1\u03B3\u03B1\u03C3\u03AF\u03B1\u03C2 \u03BA\u03B1\u03B9 \u03BD\u03B1 \u03B5\u03C0\u03B9\u03BB\u03AD\u03BE\u03B5\u03C4\u03B5 \u03C0\u03BF\u03B9\u03B5\u03C2 \u03BB\u03B5\u03C0\u03C4\u03BF\u03BC\u03AD\u03C1\u03B5\u03B9\u03B5\u03C2 \u03B8\u03AD\u03BB\u03B5\u03C4\u03B5 \u03BD\u03B1 \u03B1\u03BD\u03C4\u03B9\u03B3\u03C1\u03AC\u03C8\u03B5\u03C4\u03B5.","send_for_review_title":"\u0391\u03C0\u03BF\u03C3\u03C4\u03BF\u03BB\u03AE \u03B3\u03B9\u03B1 \u0388\u03BB\u03B5\u03B3\u03C7\u03BF","send_for_review":"\u03A0\u03B1\u03C4\u03CE\u03BD\u03C4\u03B1\u03C2 \u03C4\u03BF \u03BA\u03BF\u03C5\u03BC\u03C0\u03AF \'\u0391\u03C0\u03BF\u03C3\u03C4\u03BF\u03BB\u03AE \u03B3\u03B9\u03B1 \u0388\u03BB\u03B5\u03B3\u03C7\u03BF\', \u03B8\u03B1 \u03C3\u03C4\u03B1\u03BB\u03B5\u03AF \u03C4\u03BF \u03B1\u03AF\u03C4\u03B7\u03BC\u03AC \u03C3\u03B1\u03C2 \u03C3\u03C4\u03B7\u03BD \u03BF\u03BC\u03AC\u03B4\u03B1 \u03C0\u03C9\u03BB\u03AE\u03C3\u03B5\u03CE\u03BD \u03BC\u03B1\u03C2 \u03B3\u03B9\u03B1 \u03AD\u03BB\u03B5\u03B3\u03C7\u03BF. \u0398\u03B1 \u03C0\u03C1\u03BF\u03C7\u03C9\u03C1\u03AE\u03C3\u03BF\u03C5\u03BC\u03B5 \u03C3\u03B5 \u03C4\u03B9\u03BC\u03BF\u03BB\u03CC\u03B3\u03B7\u03C3\u03B7 \u03C4\u03B7\u03C2 \u03BA\u03C1\u03AC\u03C4\u03B7\u03C3\u03B7\u03C2 \u03BA\u03B1\u03B9 \u03B8\u03B1 \u03C3\u03B1\u03C2 \u03B5\u03B9\u03B4\u03BF\u03C0\u03BF\u03B9\u03AE\u03C3\u03BF\u03C5\u03BC\u03B5 \u03B3\u03B9\u03B1 \u03C4\u03B7\u03BD \u03C4\u03B5\u03BB\u03B9\u03BA\u03AE \u03B5\u03C0\u03B9\u03B2\u03B5\u03B2\u03B1\u03AF\u03C9\u03C3\u03B7."},"applicants_review_onboarding":{"title":"\u0391\u03BE\u03B9\u03BF\u03BB\u03CC\u03B3\u03B7\u03C3\u03B7 \u0391\u03B9\u03C4\u03BF\u03CD\u03BD\u03C4\u03C9\u03BD","pending_applicant_review_title":"\u0394\u03BF\u03C5\u03BB\u03B5\u03B9\u03AD\u03C2 \u03C3\u03B5 \u03B5\u03BA\u03BA\u03C1\u03B5\u03BC\u03CC\u03C4\u03B7\u03C4\u03B1 \u03B5\u03BB\u03AD\u03B3\u03C7\u03BF\u03C5 \u03C5\u03C0\u03BF\u03C8\u03B7\u03C6\u03AF\u03C9\u03BD","pending_applicant_review":"\u0397 \u03B5\u03BD\u03CC\u03C4\u03B7\u03C4\u03B1 \\"\u0391\u03BE\u03B9\u03BF\u03BB\u03CC\u03B3\u03B7\u03C3\u03B7 \u0391\u03B9\u03C4\u03BF\u03CD\u03BD\u03C4\u03C9\u03BD\\" \u03C0\u03B5\u03C1\u03B9\u03BB\u03B1\u03BC\u03B2\u03AC\u03BD\u03B5\u03B9 \u03BB\u03AF\u03C3\u03C4\u03B1 \u03BC\u03B5 \u03B8\u03AD\u03C3\u03B5\u03B9\u03C2 \u03B5\u03C1\u03B3\u03B1\u03C3\u03AF\u03B1\u03C2 \u03C3\u03C4\u03B9\u03C2 \u03BF\u03C0\u03BF\u03AF\u03B5\u03C2 \u03B5\u03BA\u03BA\u03C1\u03B5\u03BC\u03B5\u03AF \u03B7 \u03B1\u03BE\u03B9\u03BF\u03BB\u03CC\u03B3\u03B7\u03C3\u03B7 \u03C4\u03C9\u03BD \u03C5\u03C0\u03BF\u03C8\u03B7\u03C6\u03AF\u03C9\u03BD. \u039C\u03CC\u03BB\u03B9\u03C2 \u03BA\u03B1\u03BB\u03C5\u03C6\u03B8\u03B5\u03AF \u03BC\u03B9\u03B1 \u03B8\u03AD\u03C3\u03B7, \u03B8\u03B1 \u03B1\u03C6\u03B1\u03B9\u03C1\u03B5\u03B8\u03B5\u03AF \u03B1\u03C0\u03CC \u03C4\u03B7 \u03BB\u03AF\u03C3\u03C4\u03B1.","applicant_list_title":"\u039B\u03AF\u03C3\u03C4\u03B1 \u03A5\u03C0\u03BF\u03C8\u03B7\u03C6\u03AF\u03C9\u03BD","applicant_list":"\u0397 \u03C3\u03B5\u03BB\u03AF\u03B4\u03B1 \u03BC\u03B9\u03B1\u03C2 \u03B8\u03AD\u03C3\u03B7\u03C2 \u03B5\u03C1\u03B3\u03B1\u03C3\u03AF\u03B1\u03C2 \u03B4\u03B5\u03AF\u03C7\u03BD\u03B5\u03B9 \u03BC\u03B9\u03B1 \u03BB\u03AF\u03C3\u03C4\u03B1 \u03BC\u03B5 \u03C4\u03BF\u03C5\u03C2 Ogrammers \u03C0\u03BF\u03C5 \u03AD\u03C7\u03BF\u03C5\u03BD \u03C5\u03C0\u03BF\u03B2\u03AC\u03BB\u03B5\u03B9 \u03B1\u03AF\u03C4\u03B7\u03C3\u03B7. \u039C\u03C0\u03BF\u03C1\u03B5\u03AF\u03C4\u03B5 \u03BD\u03B1 \u03C4\u03BF\u03C5\u03C2 \u03B1\u03C0\u03BF\u03B4\u03B5\u03C7\u03C4\u03B5\u03AF\u03C4\u03B5, \u03BD\u03B1 \u03C4\u03BF\u03C5\u03C2 \u03B1\u03C0\u03BF\u03C1\u03C1\u03AF\u03C8\u03B5\u03C4\u03B5 \u03B1\u03C0\u03B5\u03C5\u03B8\u03B5\u03AF\u03B1\u03C2 \u03AE \u03BD\u03B1 \u03B5\u03BE\u03B5\u03C4\u03AC\u03C3\u03B5\u03C4\u03B5 \u03C0\u03B5\u03C1\u03B1\u03B9\u03C4\u03AD\u03C1\u03C9 \u03C4\u03B1 \u03C3\u03C4\u03BF\u03B9\u03C7\u03B5\u03AF\u03B1 \u03C4\u03BF\u03C5 \u03C0\u03C1\u03BF\u03C6\u03AF\u03BB \u03C4\u03BF\u03C5\u03C2.","applicant_details_title":"\u039B\u03B5\u03C0\u03C4\u03BF\u03BC\u03AD\u03C1\u03B5\u03B9\u03B5\u03C2 \u03A5\u03C0\u03BF\u03C8\u03B7\u03C6\u03AF\u03BF\u03C5","applicant_details":"\u0397 \u03C3\u03B5\u03BB\u03AF\u03B4\u03B1 \u03BB\u03B5\u03C0\u03C4\u03BF\u03BC\u03B5\u03C1\u03B5\u03B9\u03CE\u03BD \u03B5\u03BD\u03CC\u03C2 Ogrammer \u03B5\u03BC\u03C6\u03B1\u03BD\u03AF\u03B6\u03B5\u03B9 \u03C4\u03B7 \u03B2\u03B1\u03B8\u03BC\u03BF\u03BB\u03BF\u03B3\u03AF\u03B1 \u03C4\u03BF\u03C5, \u03C4\u03B9\u03C2 \u03BA\u03BF\u03C1\u03C5\u03C6\u03B1\u03AF\u03B5\u03C2 \u03B4\u03B5\u03BE\u03B9\u03CC\u03C4\u03B7\u03C4\u03AD\u03C2 \u03C4\u03BF\u03C5, \u03C4\u03BF \u03B5\u03C0\u03AF\u03C0\u03B5\u03B4\u03CC \u03B5\u03BC\u03C0\u03B5\u03B9\u03C1\u03AF\u03B1\u03C2 \u03C4\u03BF\u03C5, \u03C4\u03BF \u03B2\u03B9\u03BF\u03B3\u03C1\u03B1\u03C6\u03B9\u03BA\u03CC \u03C3\u03B7\u03BC\u03B5\u03AF\u03C9\u03BC\u03AC \u03C4\u03BF\u03C5, \u03C4\u03B7\u03BD \u03B5\u03C1\u03B3\u03B1\u03C3\u03B9\u03B1\u03BA\u03AE \u03C4\u03BF\u03C5 \u03B5\u03BC\u03C0\u03B5\u03B9\u03C1\u03AF\u03B1 \u03BA\u03B1\u03B9 \u03C4\u03B7\u03BD \u03B5\u03BA\u03C0\u03B1\u03AF\u03B4\u03B5\u03C5\u03C3\u03AE \u03C4\u03BF\u03C5."},"locations_onboarding":{"title":"\u03A4\u03BF\u03C0\u03BF\u03B8\u03B5\u03C3\u03AF\u03B5\u03C2","location_list_title":"\u039B\u03AF\u03C3\u03C4\u03B1 \u03A4\u03BF\u03C0\u03BF\u03B8\u03B5\u03C3\u03B9\u03CE\u03BD","location_list":"\u0397 \u03B5\u03BD\u03CC\u03C4\u03B7\u03C4\u03B1 \\"\u03A4\u03BF\u03C0\u03BF\u03B8\u03B5\u03C3\u03AF\u03B5\u03C2\\" \u03C0\u03B5\u03C1\u03B9\u03BB\u03B1\u03BC\u03B2\u03AC\u03BD\u03B5\u03B9 \u03BC\u03B9\u03B1 \u03BB\u03AF\u03C3\u03C4\u03B1 \u03BC\u03B5 \u03CC\u03BB\u03B5\u03C2 \u03C4\u03B9\u03C2 \u03C4\u03BF\u03C0\u03BF\u03B8\u03B5\u03C3\u03AF\u03B5\u03C2 \u03C4\u03C9\u03BD \u03C5\u03C0\u03BF\u03BA\u03B1\u03C4\u03B1\u03C3\u03C4\u03B7\u03BC\u03AC\u03C4\u03C9\u03BD \u03C3\u03B1\u03C2.","location_details_title":"\u039B\u03B5\u03C0\u03C4\u03BF\u03BC\u03AD\u03C1\u03B5\u03B9\u03B5\u03C2 \u03A4\u03BF\u03C0\u03BF\u03B8\u03B5\u03C3\u03AF\u03B1\u03C2","location_details":"\u03A0\u03B1\u03C1\u03B1\u03BA\u03B1\u03BB\u03BF\u03CD\u03BC\u03B5 \u03B2\u03B5\u03B2\u03B1\u03B9\u03C9\u03B8\u03B5\u03AF\u03C4\u03B5 \u03CC\u03C4\u03B9 \u03B7 \u03C4\u03BF\u03C0\u03BF\u03B8\u03B5\u03C3\u03AF\u03B1 \u03C3\u03B1\u03C2 \u03C3\u03C4\u03BF\u03BD \u03C7\u03AC\u03C1\u03C4\u03B7 \u03B5\u03AF\u03BD\u03B1\u03B9 \u03B1\u03BA\u03C1\u03B9\u03B2\u03AE\u03C2. \u039F\u03B9 Ogrammers \u03B4\u03B5\u03BD \u03B8\u03B1 \u03BC\u03C0\u03BF\u03C1\u03BF\u03CD\u03BD \u03BD\u03B1 \u03B4\u03B7\u03BB\u03CE\u03C3\u03BF\u03C5\u03BD \u03C4\u03B7\u03BD \u03AC\u03C6\u03B9\u03BE\u03AE \u03C4\u03BF\u03C5\u03C2 \u03B5\u03BA\u03C4\u03CC\u03C2 \u03C4\u03BF\u03C5 \u03B5\u03C0\u03B9\u03BB\u03B5\u03B3\u03BC\u03AD\u03BD\u03BF\u03C5 \u03C3\u03B7\u03BC\u03B5\u03AF\u03BF\u03C5 \u03C3\u03C4\u03BF\u03BD \u03C7\u03AC\u03C1\u03C4\u03B7."},"users_onboarding":{"title":"\u03A7\u03C1\u03AE\u03C3\u03C4\u03B5\u03C2","user_list_title":"\u039B\u03AF\u03C3\u03C4\u03B1 \u03A7\u03C1\u03B7\u03C3\u03C4\u03CE\u03BD","user_list":"\u0397 \u03B5\u03BD\u03CC\u03C4\u03B7\u03C4\u03B1 \\"\u03A7\u03C1\u03AE\u03C3\u03C4\u03B5\u03C2\\" \u03C3\u03B1\u03C2 \u03B5\u03C0\u03B9\u03C4\u03C1\u03AD\u03C0\u03B5\u03B9 \u03BD\u03B1 \u03B5\u03BB\u03AD\u03B3\u03C7\u03B5\u03C4\u03B5 \u03C0\u03BF\u03B9\u03BF\u03B9 \u03AD\u03C7\u03BF\u03C5\u03BD \u03C0\u03C1\u03CC\u03C3\u03B2\u03B1\u03C3\u03B7 \u03C3\u03C4\u03B7\u03BD \u03B5\u03C4\u03B1\u03B9\u03C1\u03B5\u03AF\u03B1 \u03C3\u03B1\u03C2. \u039C\u03C0\u03BF\u03C1\u03B5\u03AF\u03C4\u03B5 \u03BD\u03B1 \u03B4\u03B7\u03BC\u03B9\u03BF\u03C5\u03C1\u03B3\u03AE\u03C3\u03B5\u03C4\u03B5 \u03BD\u03AD\u03BF\u03C5\u03C2 \u03C7\u03C1\u03AE\u03C3\u03C4\u03B5\u03C2 \u03AE \u03BD\u03B1 \u03C0\u03C1\u03BF\u03C3\u03BA\u03B1\u03BB\u03AD\u03C3\u03B5\u03C4\u03B5 \u03C5\u03C0\u03AC\u03C1\u03C7\u03BF\u03BD\u03C4\u03B5\u03C2.","user_details_title":"\u039B\u03B5\u03C0\u03C4\u03BF\u03BC\u03AD\u03C1\u03B5\u03B9\u03B5\u03C2 \u03A7\u03C1\u03B7\u03C3\u03C4\u03CE\u03BD","user_details":"\u039C\u03C0\u03BF\u03C1\u03B5\u03AF\u03C4\u03B5 \u03BD\u03B1 \u03B1\u03BD\u03B1\u03B8\u03AD\u03C3\u03B5\u03C4\u03B5 \u03AD\u03BD\u03B1\u03BD \u03B1\u03C0\u03CC \u03C4\u03BF\u03C5\u03C2 \u03B1\u03BA\u03CC\u03BB\u03BF\u03C5\u03B8\u03BF\u03C5\u03C2 \u03C1\u03CC\u03BB\u03BF\u03C5\u03C2: \u0394\u03B9\u03B1\u03C7\u03B5\u03B9\u03C1\u03B9\u03C3\u03C4\u03AE\u03C2, \u03A5\u03C0\u03B5\u03CD\u03B8\u03C5\u03BD\u03BF\u03C2 \u03A0\u03B1\u03C1\u03BF\u03C5\u03C3\u03B9\u03CE\u03BD, \u039F\u03B9\u03BA\u03BF\u03BD\u03BF\u03BC\u03B9\u03BA\u03CC\u03C2. \u039F\u03B9 \u03C1\u03CC\u03BB\u03BF\u03B9 \u03BC\u03C0\u03BF\u03C1\u03BF\u03CD\u03BD \u03BD\u03B1 \u03B1\u03BD\u03B1\u03C4\u03B5\u03B8\u03BF\u03CD\u03BD \u03B4\u03B9\u03B1\u03C6\u03BF\u03C1\u03B5\u03C4\u03B9\u03BA\u03AC \u03C3\u03B5 \u03BA\u03AC\u03B8\u03B5 \u03C4\u03BF\u03C0\u03BF\u03B8\u03B5\u03C3\u03AF\u03B1."},"rating_requests_onboarding":{"title":"\u0391\u03B9\u03C4\u03AE\u03BC\u03B1\u03C4\u03B1 \u0391\u03BE\u03B9\u03BF\u03BB\u03CC\u03B3\u03B7\u03C3\u03B7\u03C2","pending_feedback_title":"\u0398\u03AD\u03C3\u03B5\u03B9\u03C2 \u0395\u03C1\u03B3\u03B1\u03C3\u03AF\u03B1\u03C2 \u03C3\u03B5 \u03B5\u03BA\u03BA\u03C1\u03B5\u03BC\u03CC\u03C4\u03B7\u03C4\u03B1 \u03B1\u03BE\u03B9\u03BF\u03BB\u03CC\u03B3\u03B7\u03C3\u03B7\u03C2","pending_feedback":"\u0397 \u03B5\u03BD\u03CC\u03C4\u03B7\u03C4\u03B1 \\"\u0391\u03B9\u03C4\u03AE\u03BC\u03B1\u03C4\u03B1 \u0391\u03BE\u03B9\u03BF\u03BB\u03CC\u03B3\u03B7\u03C3\u03B7\u03C2\\" \u03C0\u03B5\u03C1\u03B9\u03AD\u03C7\u03B5\u03B9 \u03BC\u03B9\u03B1 \u03BB\u03AF\u03C3\u03C4\u03B1 \u03BC\u03B5 \u03B8\u03AD\u03C3\u03B5\u03B9\u03C2 \u03B5\u03C1\u03B3\u03B1\u03C3\u03AF\u03B1\u03C2 \u03C0\u03BF\u03C5 \u03B1\u03C0\u03B1\u03B9\u03C4\u03BF\u03CD\u03BD \u03C4\u03B7\u03BD \u03B1\u03BD\u03B1\u03C4\u03C1\u03BF\u03C6\u03BF\u03B4\u03CC\u03C4\u03B7\u03C3\u03AE \u03C3\u03B1\u03C2. \u039C\u03B5\u03C4\u03AC \u03C4\u03B7\u03BD \u03BF\u03BB\u03BF\u03BA\u03BB\u03AE\u03C1\u03C9\u03C3\u03B7 \u03BC\u03B9\u03B1\u03C2 \u03B8\u03AD\u03C3\u03B7\u03C2 \u03B5\u03C1\u03B3\u03B1\u03C3\u03AF\u03B1\u03C2, \u03B8\u03B1 \u03B8\u03AD\u03BB\u03B1\u03BC\u03B5 \u03BD\u03B1 \u03B1\u03BE\u03B9\u03BF\u03BB\u03BF\u03B3\u03AE\u03C3\u03B5\u03C4\u03B5 \u03C4\u03B7\u03BD \u03B5\u03BC\u03C0\u03B5\u03B9\u03C1\u03AF\u03B1 \u03C3\u03B1\u03C2.","rating_details_title":"\u039B\u03B5\u03C0\u03C4\u03BF\u03BC\u03AD\u03C1\u03B5\u03B9\u03B5\u03C2 \u0392\u03B1\u03B8\u03BC\u03BF\u03BB\u03BF\u03B3\u03AF\u03B1\u03C2 \u03C4\u03B7\u03C2 \u0398\u03AD\u03C3\u03B7\u03C2","rating_details":"\u039C\u03C0\u03BF\u03C1\u03B5\u03AF\u03C4\u03B5 \u03BD\u03B1 \u03B1\u03BE\u03B9\u03BF\u03BB\u03BF\u03B3\u03AE\u03C3\u03B5\u03C4\u03B5 \u03C4\u03B7 \u03C3\u03C5\u03BD\u03BF\u03BB\u03B9\u03BA\u03AE \u03C3\u03B1\u03C2 \u03B5\u03BC\u03C0\u03B5\u03B9\u03C1\u03AF\u03B1 \u03B1\u03C0\u03CC \u03C4\u03B7 \u03B8\u03AD\u03C3\u03B7 \u03B5\u03C1\u03B3\u03B1\u03C3\u03AF\u03B1\u03C2, \u03BA\u03B1\u03B8\u03CE\u03C2 \u03BA\u03B1\u03B9 \u03BD\u03B1 \u03B1\u03BE\u03B9\u03BF\u03BB\u03BF\u03B3\u03AE\u03C3\u03B5\u03C4\u03B5 \u03BC\u03B5\u03BC\u03BF\u03BD\u03C9\u03BC\u03AD\u03BD\u03BF\u03C5\u03C2 Ogrammers. \u0395\u03AF\u03C3\u03C4\u03B5 \u03B5\u03BB\u03B5\u03CD\u03B8\u03B5\u03C1\u03BF\u03B9 \u03BD\u03B1 \u03B5\u03C0\u03B1\u03B9\u03BD\u03AD\u03C3\u03B5\u03C4\u03B5, \u03BD\u03B1 \u03B5\u03C0\u03B9\u03C3\u03B7\u03BC\u03AC\u03BD\u03B5\u03C4\u03B5 \u03C0\u03C1\u03BF\u03B2\u03BB\u03AE\u03BC\u03B1\u03C4\u03B1 \u03BA\u03B1\u03B9 \u03BD\u03B1 \u03B1\u03C6\u03AE\u03C3\u03B5\u03C4\u03B5 \u03C3\u03C7\u03CC\u03BB\u03B9\u03B1."},"invoices_onboarding":{"title":"\u03A4\u03B9\u03BC\u03BF\u03BB\u03CC\u03B3\u03B9\u03B1","invoice_list_title":"\u039B\u03AF\u03C3\u03C4\u03B1 \u03A4\u03B9\u03BC\u03BF\u03BB\u03BF\u03B3\u03AF\u03C9\u03BD","invoice_list":"\u0397 \u03B5\u03BD\u03CC\u03C4\u03B7\u03C4\u03B1 \u201C\u03A4\u03B9\u03BC\u03BF\u03BB\u03CC\u03B3\u03B9\u03B1\u201D \u03C0\u03B5\u03C1\u03B9\u03AD\u03C7\u03B5\u03B9 \u03BC\u03B9\u03B1 \u03BB\u03AF\u03C3\u03C4\u03B1 \u03BC\u03B5 \u03C4\u03B1 \u03C4\u03C1\u03AD\u03C7\u03BF\u03BD\u03C4\u03B1 \u03BA\u03B1\u03B9 \u03C4\u03B1 \u03C0\u03C1\u03BF\u03B7\u03B3\u03BF\u03CD\u03BC\u03B5\u03BD\u03B1 \u03C4\u03B9\u03BC\u03BF\u03BB\u03CC\u03B3\u03B9\u03AC \u03C3\u03B1\u03C2. \u0395\u03AC\u03BD \u03BA\u03AC\u03C0\u03BF\u03B9\u03BF \u03C4\u03B9\u03BC\u03BF\u03BB\u03CC\u03B3\u03B9\u03BF \u03B5\u03AF\u03BD\u03B1\u03B9 \u03C3\u03B5 \u03BA\u03B1\u03C4\u03AC\u03C3\u03C4\u03B1\u03C3\u03B7 \u201C\u0395\u03BA\u03BA\u03C1\u03B5\u03BC\u03B5\u03AF\u201D, \u03B1\u03C5\u03C4\u03CC \u03C3\u03B7\u03BC\u03B1\u03AF\u03BD\u03B5\u03B9 \u03CC\u03C4\u03B9 \u03B1\u03BD\u03B1\u03BC\u03AD\u03BD\u03BF\u03C5\u03BC\u03B5 \u03C0\u03BB\u03B7\u03C1\u03C9\u03BC\u03AE \u03B1\u03C0\u03CC \u03B5\u03C3\u03AC\u03C2.","invoice_breakdown_title":"\u0391\u03BD\u03AC\u03BB\u03C5\u03C3\u03B7 \u03A4\u03B9\u03BC\u03BF\u03BB\u03BF\u03B3\u03AF\u03BF\u03C5","invoice_breakdown":"\u0397 \u03C3\u03B5\u03BB\u03AF\u03B4\u03B1 \u03BC\u03B9\u03B1\u03C2 \u03C0\u03B1\u03C1\u03B1\u03B3\u03B3\u03B5\u03BB\u03AF\u03B1\u03C2 \u03C0\u03B5\u03C1\u03B9\u03AD\u03C7\u03B5\u03B9 \u03BC\u03B9\u03B1 \u03C3\u03CD\u03BD\u03BF\u03C8\u03B7 \u03BA\u03B1\u03B8\u03CE\u03C2 \u03BA\u03B1\u03B9 \u03BC\u03B9\u03B1 \u03B1\u03BD\u03AC\u03BB\u03C5\u03C3\u03B7 \u03C4\u03C9\u03BD \u03B8\u03AD\u03C3\u03B5\u03C9\u03BD \u03B5\u03C1\u03B3\u03B1\u03C3\u03AF\u03B1\u03C2. \u0395\u03C0\u03B5\u03BA\u03C4\u03B5\u03AF\u03BD\u03BF\u03BD\u03C4\u03B1\u03C2 \u03C4\u03B9\u03C2 \u03B8\u03AD\u03C3\u03B5\u03B9\u03C2 \u03B5\u03C1\u03B3\u03B1\u03C3\u03AF\u03B1\u03C2, \u03B8\u03B1 \u03BC\u03C0\u03BF\u03C1\u03B5\u03AF\u03C4\u03B5 \u03BD\u03B1 \u03B2\u03C1\u03B5\u03AF\u03C4\u03B5 \u03BC\u03B9\u03B1 \u03C3\u03CD\u03BD\u03BF\u03C8\u03B7 \u03C4\u03B7\u03C2 \u03B2\u03AC\u03C1\u03B4\u03B9\u03B1\u03C2, \u03B4\u03B9\u03B1\u03C7\u03C9\u03C1\u03B9\u03C3\u03BC\u03AD\u03BD\u03B7 \u03B1\u03BD\u03AC Ogrammer.","shifts_breakdown_title":"\u0391\u03BD\u03AC\u03BB\u03C5\u03C3\u03B7 \u0392\u03B1\u03C1\u03B4\u03B9\u03CE\u03BD \u03A4\u03B9\u03BC\u03BF\u03BB\u03BF\u03B3\u03AF\u03BF\u03C5","shifts_breakdown":"\u039A\u03AC\u03BD\u03BF\u03BD\u03C4\u03B1\u03C2 \u03BA\u03BB\u03B9\u03BA \u03C3\u03B5 \u03AD\u03BD\u03B1\u03BD Ogrammer, \u03BC\u03C0\u03BF\u03C1\u03B5\u03AF\u03C4\u03B5 \u03BD\u03B1 \u03B4\u03B5\u03AF\u03C4\u03B5 \u03C0\u03CC\u03C3\u03B5\u03C2 \u03CE\u03C1\u03B5\u03C2 \u03B5\u03C1\u03B3\u03AC\u03C3\u03C4\u03B7\u03BA\u03B5 \u03BA\u03AC\u03B8\u03B5 \u03B7\u03BC\u03AD\u03C1\u03B1.","export_invoice_title":"\u0388\u03BA\u03B4\u03BF\u03C3\u03B7 \u03A4\u03B9\u03BC\u03BF\u03BB\u03BF\u03B3\u03AF\u03BF\u03C5","export_invoice":"\u0391\u03C0\u03CC \u03C4\u03BF \u039C\u03B5\u03BD\u03BF\u03CD \u03A4\u03B9\u03BC\u03BF\u03BB\u03BF\u03B3\u03AF\u03C9\u03BD, \u03BC\u03C0\u03BF\u03C1\u03B5\u03AF\u03C4\u03B5 \u03BD\u03B1 \u03BA\u03B1\u03C4\u03B5\u03B2\u03AC\u03C3\u03B5\u03C4\u03B5 \u03BC\u03B9\u03B1 \u03B1\u03BD\u03AC\u03BB\u03C5\u03C3\u03B7 \u03C4\u03B9\u03BC\u03BF\u03BB\u03BF\u03B3\u03AF\u03BF\u03C5 \u03C3\u03B5 \u03BC\u03BF\u03C1\u03C6\u03AE PDF, \u03BA\u03B1\u03B8\u03CE\u03C2 \u03BA\u03B1\u03B9 \u03BD\u03B1 \u03B1\u03BD\u03B1\u03C6\u03AD\u03C1\u03B5\u03C4\u03B5 \u03C4\u03C5\u03C7\u03CC\u03BD \u03C0\u03C1\u03BF\u03B2\u03BB\u03AE\u03BC\u03B1\u03C4\u03B1 \u03BC\u03B5 \u03AD\u03BD\u03B1 \u03C4\u03B9\u03BC\u03BF\u03BB\u03CC\u03B3\u03B9\u03BF."},"duplicate_order":{"choose_jobs_main_title":"\u03A0\u03C1\u03CE\u03C4\u03B1, \u03B5\u03C0\u03B9\u03BB\u03AD\u03BE\u03C4\u03B5 \u03C4\u03B9\u03C2 \u03B5\u03C0\u03B9\u03B8\u03C5\u03BC\u03B7\u03C4\u03AD\u03C2 \u03B8\u03AD\u03C3\u03B5\u03B9\u03C2 \u03B5\u03C1\u03B3\u03B1\u03C3\u03AF\u03B1\u03C2","choose_jobs_secondary_title":"\u0395\u03C0\u03B9\u03BB\u03AD\u03BE\u03C4\u03B5 \u03C4\u03B9\u03C2 \u03B8\u03AD\u03C3\u03B5\u03B9\u03C2 \u03B5\u03C1\u03B3\u03B1\u03C3\u03AF\u03B1\u03C2 \u03C0\u03BF\u03C5 \u03B8\u03AD\u03BB\u03B5\u03C4\u03B5 \u03BD\u03B1 \u03C0\u03B1\u03C1\u03B1\u03C4\u03B5\u03AF\u03BD\u03B5\u03C4\u03B5","choose_jobs_confirm":"\u0395\u03C0\u03B9\u03B2\u03B5\u03B2\u03B1\u03AF\u03C9\u03C3\u03B7","duplicate_job_subtitle":"\u0395\u03BB\u03AD\u03B3\u03BE\u03C4\u03B5 \u03C4\u03B1 \u03C3\u03C4\u03BF\u03B9\u03C7\u03B5\u03AF\u03B1 \u03C4\u03B7\u03C2 \u03B8\u03AD\u03C3\u03B7\u03C2 \u03B5\u03C1\u03B3\u03B1\u03C3\u03AF\u03B1\u03C2","duplicate_order":"\u0391\u03BD\u03C4\u03B9\u03B3\u03C1\u03AC\u03C8\u03C4\u03B5 \u03C4\u03B7\u03BD \u03A0\u03B1\u03C1\u03B1\u03B3\u03B3\u03B5\u03BB\u03AF\u03B1"},"payment":{"payment":"\u03A0\u03BB\u03B7\u03C1\u03C9\u03BC\u03AE","card_payment":"\u0391\u03C0\u03BF\u03C7\u03CE\u03C1\u03B7\u03C3\u03B7","was_successful":"\u0395\u03C5\u03C7\u03B1\u03C1\u03B9\u03C3\u03C4\u03BF\u03CD\u03BC\u03B5, \u03B7 \u03C0\u03BB\u03B7\u03C1\u03C9\u03BC\u03AE \u03C3\u03B1\u03C2 \u03AD\u03B3\u03B9\u03BD\u03B5 \u03BC\u03B5 \u03B5\u03C0\u03B9\u03C4\u03C5\u03C7\u03AF\u03B1.","email_was_sent_to":"\u03A3\u03B1\u03C2 \u03AD\u03C7\u03BF\u03C5\u03BC\u03B5 \u03C3\u03C4\u03B5\u03AF\u03BB\u03B5\u03B9 \u03B5\u03C0\u03B9\u03B2\u03B5\u03B2\u03B1\u03B9\u03C9\u03C4\u03B9\u03BA\u03CC email ","can_go_to_payments_list_page":"\u039C\u03B5\u03C4\u03B1\u03B2\u03B5\u03AF\u03C4\u03B5 \u03C3\u03C4\u03B7 \u03C3\u03B5\u03BB\u03AF\u03B4\u03B1 \u03C0\u03BB\u03B7\u03C1\u03C9\u03BC\u03CE\u03BD \u03B3\u03B9\u03B1 \u03BD\u03B1 \u03B5\u03BB\u03AD\u03B3\u03BE\u03B5\u03C4\u03B5 \u03C4\u03B7\u03BD \u03BA\u03B1\u03C4\u03AC\u03C3\u03C4\u03B1\u03C3\u03B7","transaction_id":"ID \u03A3\u03C5\u03BD\u03B1\u03BB\u03BB\u03B1\u03B3\u03AE\u03C2","date":"\u0397\u03BC\u03B5\u03C1\u03BF\u03BC\u03B7\u03BD\u03AF\u03B1","payment_method":"\u03A4\u03C1\u03CC\u03C0\u03BF\u03C2 \u03A0\u03BB\u03B7\u03C1\u03C9\u03BC\u03AE\u03C2","amount":"\u03A0\u03BF\u03C3\u03CC","status":"\u039A\u03B1\u03C4\u03AC\u03C3\u03C4\u03B1\u03C3\u03B7","go_to_payments_list_page":"\u03A0\u03B7\u03B3\u03B1\u03AF\u03BD\u03B5\u03C4\u03B5 \u03C3\u03C4\u03B9\u03C2 \u03A0\u03BB\u03B7\u03C1\u03C9\u03BC\u03AD\u03C2","status_unpaid":"\u0391\u03C0\u03BB\u03AE\u03C1\u03C9\u03C4\u03B1","status_processing":"\u03A3\u03B5 \u03B5\u03C0\u03B5\u03BE\u03B5\u03C1\u03B3\u03B1\u03C3\u03AF\u03B1","status_paid":"\u03A0\u03BB\u03B7\u03C1\u03CE\u03B8\u03B7\u03BA\u03B5","status_cancelled":"\u0391\u03BA\u03C5\u03C1\u03CE\u03B8\u03B7\u03BA\u03B5","status_refunded":"\u0395\u03C0\u03B9\u03C3\u03C4\u03C1\u03AC\u03C6\u03B7\u03BA\u03B1\u03BD","payment_method_card_title":"\u039A\u03AC\u03C1\u03C4\u03B1","payment_method_card_wide_title":"\u03A0\u03BB\u03B7\u03C1\u03C9\u03BC\u03AE \u03BC\u03B5 \u03BA\u03AC\u03C1\u03C4\u03B1","payment_method_card_description":"\u039A\u03B1\u03B9\u03BD\u03BF\u03CD\u03C1\u03B3\u03B9\u03B1 \u03C0\u03B9\u03C3\u03C4\u03C9\u03C4\u03B9\u03BA\u03AE / \u03C7\u03C1\u03B5\u03C9\u03C3\u03C4\u03B9\u03BA\u03AE \u03BA\u03AC\u03C1\u03C4\u03B1","payment_method_lean_description":"\u039C\u03B5\u03C4\u03B1\u03C6\u03BF\u03C1\u03AC \u03B1\u03C0\u03BF \u03A4\u03C1\u03B1\u03C0\u03B5\u03B6\u03B9\u03BA\u03CC \u039B\u03BF\u03B3\u03B1\u03C1\u03B9\u03B1\u03C3\u03BC\u03CC","processing_running":"\u03A3\u03B5 \u03B5\u03C0\u03B5\u03BE\u03B5\u03C1\u03B3\u03B1\u03C3\u03AF\u03B1...","save_card_for_future":"\u0391\u03C0\u03BF\u03B8\u03B7\u03BA\u03B5\u03CD\u03C3\u03C4\u03B5 \u03C4\u03B7\u03BD \u03BA\u03AC\u03C1\u03C4\u03B1 \u03B3\u03B9\u03B1 \u03BC\u03B5\u03BB\u03BB\u03BF\u03BD\u03C4\u03B9\u03BA\u03AD\u03C2 \u03C3\u03C5\u03BD\u03B1\u03BB\u03BB\u03B1\u03B3\u03AD\u03C2","all_transactions_are_secured":"\u038C\u03BB\u03B5\u03C2 \u03BF\u03B9 \u03C3\u03C5\u03BD\u03B1\u03BB\u03BB\u03B1\u03B3\u03AD\u03C2 \u03B5\u03AF\u03BD\u03B1\u03B9 \u03B1\u03C3\u03C6\u03B1\u03BB\u03B5\u03AF\u03C2 \u03BA\u03B1\u03B9 \u03BA\u03C1\u03C5\u03C0\u03C4\u03BF\u03B3\u03C1\u03B1\u03C6\u03B7\u03BC\u03AD\u03BD\u03B5\u03C2","details":"\u039B\u03B5\u03C0\u03C4\u03BF\u03BC\u03AD\u03C1\u03B5\u03B9\u03B5\u03C2","payment_number":"\u0391\u03C1\u03B9\u03B8\u03BC\u03CC\u03C2 \u03A0\u03BB\u03B7\u03C1\u03C9\u03BC\u03AE\u03C2","due_date":"\u03A4\u03B5\u03BB\u03B9\u03BA\u03AE \u0397\u03BC\u03B5\u03C1\u03BF\u03BC\u03B7\u03BD\u03AF\u03B1 \u03A0\u03BB\u03B7\u03C1\u03C9\u03BC\u03AE\u03C2","invoices":"\u03A4\u03B9\u03BC\u03BF\u03BB\u03CC\u03B3\u03B9\u03B1","total_payment":"\u03A3\u03C5\u03BD\u03BF\u03BB\u03B9\u03BA\u03CC \u03A0\u03BF\u03C3\u03CC \u03A0\u03BB\u03B7\u03C1\u03C9\u03BC\u03AE\u03C2 ","pay_now":"\u03A0\u03BB\u03AE\u03C1\u03C9\u03C3\u03B5 \u03A4\u03CE\u03C1\u03B1","authorize":"\u0394\u03CE\u03C3\u03C4\u03B5 \u0395\u03BE\u03BF\u03C5\u03C3\u03B9\u03BF\u03B4\u03CC\u03C4\u03B7\u03C3\u03B7 \u0393\u03B9\u03B1 \u03A0\u03BB\u03B7\u03C1\u03C9\u03BC\u03AE","pending":"E\u03BA\u03BA\u03C1\u03B5\u03BC\u03B5\u03AF","processing":"\u03A3\u03B5 \u03B5\u03C0\u03B5\u03BE\u03B5\u03C1\u03B3\u03B1\u03C3\u03AF\u03B1","completed":"\u039F\u03BB\u03BF\u03BA\u03BB\u03B7\u03C1\u03CE\u03B8\u03B7\u03BA\u03B5","invoice":"\u03A4\u03B9\u03BC\u03BF\u03BB\u03CC\u03B3\u03B9\u03BF","payment_details_title":"\u03A0\u03BB\u03B7\u03C1\u03C9\u03BC\u03AE #{{paymentId}}","payments":"\u03A0\u03BB\u03B7\u03C1\u03C9\u03BC\u03AD\u03C2","payment_methods":"\u039C\u03AD\u03B8\u03BF\u03B4\u03BF\u03B9 \u03C0\u03BB\u03B7\u03C1\u03C9\u03BC\u03AE\u03C2","select_payment_method":"\u0395\u03C0\u03B9\u03BB\u03AD\u03BE\u03C4\u03B5 \u03BC\u03AD\u03B8\u03BF\u03B4\u03BF \u03C0\u03BB\u03B7\u03C1\u03C9\u03BC\u03AE\u03C2","continue":"\u03A3\u03C5\u03BD\u03B5\u03C7\u03AF\u03C3\u03C4\u03B5","pay":"\u03A0\u03BB\u03B7\u03C1\u03CE\u03C3\u03C4\u03B5","payment_completed":"\u0397 \u03C0\u03BB\u03B7\u03C1\u03C9\u03BC\u03AE \u03BF\u03BB\u03BF\u03BA\u03BB\u03B7\u03C1\u03CE\u03B8\u03B7\u03BA\u03B5","payment_processing":"\u0397 \u03C0\u03BB\u03B7\u03C1\u03C9\u03BC\u03AE \u03B5\u03C0\u03B5\u03BE\u03B5\u03C1\u03B3\u03AC\u03B6\u03B5\u03C4\u03B1\u03B9","updating_status":"\u0395\u03BD\u03B7\u03BC\u03AD\u03C1\u03C9\u03C3\u03B7 \u039A\u03B1\u03C4\u03AC\u03C3\u03C4\u03B1\u03C3\u03B7\u03C2...","empty_pending_list":"\u0394\u03B5\u03BD \u03B5\u03BA\u03BA\u03C1\u03B5\u03BC\u03BF\u03CD\u03BD \u03C0\u03BB\u03B7\u03C1\u03C9\u03BC\u03AD\u03C2","empty_processing_list":"\u0394\u03B5\u03BD \u03C5\u03C0\u03AC\u03C1\u03C7\u03BF\u03C5\u03BD \u03C0\u03BB\u03B7\u03C1\u03C9\u03BC\u03AD\u03C2 \u03C3\u03B5 \u03B5\u03C0\u03B5\u03BE\u03B5\u03C1\u03B3\u03B1\u03C3\u03AF\u03B1","empty_completed_list":"\u0394\u03B5\u03BD \u03C5\u03C0\u03AC\u03C1\u03C7\u03BF\u03C5\u03BD \u03BF\u03BB\u03BF\u03BA\u03BB\u03B7\u03C1\u03C9\u03BC\u03AD\u03BD\u03B5\u03C2 \u03C0\u03BB\u03B7\u03C1\u03C9\u03BC\u03AD\u03C2","back_to_order":"\u03A0\u03AF\u03C3\u03C9 \u03C3\u03C4\u03B9\u03C2 \u03C0\u03B1\u03C1\u03B1\u03B3\u03B3\u03B5\u03BB\u03AF\u03B5\u03C2","overdue_balance":"\u0395\u03BA\u03C0\u03C1\u03CC\u03B8\u03B5\u03C3\u03BC\u03BF \u03C5\u03C0\u03CC\u03BB\u03BF\u03B9\u03C0\u03BF","payment_method_wire_transfer_title":"\u03A4\u03C1\u03B1\u03C0\u03B5\u03B6\u03B9\u03BA\u03AE \u039C\u03B5\u03C4\u03B1\u03C6\u03BF\u03C1\u03AC","payment_method_wire_transfer_description":"\u03A4\u03C1\u03B1\u03C0\u03B5\u03B6\u03B9\u03BA\u03AE \u039C\u03B5\u03C4\u03B1\u03C6\u03BF\u03C1\u03AC","text_copied":"\u03A4\u03BF \u03BA\u03B5\u03AF\u03BC\u03B5\u03BD\u03BF \u03B1\u03BD\u03C4\u03B9\u03B3\u03C1\u03AC\u03C6\u03B7\u03BA\u03B5 \u03C3\u03C4\u03BF \u03C0\u03C1\u03CC\u03C7\u03B5\u03B9\u03C1\u03BF","checkout":"\u039F\u03BB\u03BF\u03BA\u03BB\u03AE\u03C1\u03C9\u03C3\u03B7 \u03A0\u03BB\u03B7\u03C1\u03C9\u03BC\u03AE\u03C2","wire_transfer_details":"\u039B\u03B5\u03C0\u03C4\u03BF\u03BC\u03AD\u03C1\u03B5\u03B9\u03B5\u03C2 \u03C4\u03C1\u03B1\u03C0\u03B5\u03B6\u03B9\u03BA\u03BF\u03CD \u03B5\u03BC\u03B2\u03AC\u03C3\u03BC\u03B1\u03C4\u03BF\u03C2","wire_transfer_amount":"\u03A0\u03BF\u03C3\u03CC","wire_transfer_bank_account_name":"\u038C\u03BD\u03BF\u03BC\u03B1 \u039B\u03BF\u03B3\u03B1\u03C1\u03B9\u03B1\u03C3\u03BC\u03BF\u03CD","wire_transfer_bank_account_bank_name":"\u038C\u03BD\u03BF\u03BC\u03B1 \u03A4\u03C1\u03AC\u03C0\u03B5\u03B6\u03B1\u03C2","wire_transfer_bank_account_number":"\u0391\u03C1\u03B9\u03B8\u03BC\u03CC\u03C2 \u03A4\u03C1\u03B1\u03C0\u03B5\u03B6\u03B9\u03BA\u03BF\u03CD \u039B\u03BF\u03B3\u03B1\u03C1\u03B9\u03B1\u03C3\u03BC\u03BF\u03CD","wire_transfer_bank_account_iban":"IBAN","wire_transfer_bank_account_bank_address":"\u0394\u03B9\u03B5\u03CD\u03B8\u03C5\u03BD\u03C3\u03B7 \u03A4\u03C1\u03AC\u03C0\u03B5\u03B6\u03B1\u03C2","wire_transfer_upload_alert_text":"\u0391\u03BD\u03B5\u03B2\u03AC\u03C3\u03C4\u03B5 \u03C4\u03BF \u03B1\u03C0\u03BF\u03B4\u03B5\u03B9\u03BA\u03C4\u03B9\u03BA\u03CC \u03C4\u03C1\u03B1\u03C0\u03B5\u03B6\u03B9\u03BA\u03AE\u03C2 \u03BA\u03B1\u03C4\u03AC\u03B8\u03B5\u03C3\u03B7\u03C2","next":"\u0395\u03C0\u03CC\u03BC\u03B5\u03BD\u03BF","wire_transfer_has_been_canceled":"\u0397 \u03A4\u03C1\u03B1\u03C0\u03B5\u03B6\u03B9\u03BA\u03AE \u039C\u03B5\u03C4\u03B1\u03C6\u03BF\u03C1\u03AC \u03AD\u03C7\u03B5\u03B9 \u03B1\u03BA\u03C5\u03C1\u03C9\u03B8\u03B5\u03AF","wire_transfer_slip_was_uploaded":"\u03A4\u03BF \u0391\u03C0\u03BF\u03B4\u03B5\u03B9\u03BA\u03C4\u03B9\u03BA\u03CC \u03A0\u03BB\u03B7\u03C1\u03C9\u03BC\u03AE\u03C2 \u03AD\u03C7\u03B5\u03B9 \u03BA\u03B1\u03C4\u03B1\u03C7\u03C9\u03C1\u03B7\u03B8\u03B5\u03AF","please_upload_slip":"\u0391\u03BD\u03B5\u03B2\u03AC\u03C3\u03C4\u03B5 \u03C4\u03BF \u0391\u03C0\u03BF\u03B4\u03B5\u03B9\u03BA\u03C4\u03B9\u03BA\u03CC \u03A0\u03BB\u03B7\u03C1\u03C9\u03BC\u03AE\u03C2 \u03B1\u03C0\u03CC \u03C4\u03B7\u03BD \u03A4\u03C1\u03AC\u03C0\u03B5\u03B6\u03B1","bank_slip_info_in_alert":"\u03A3\u03C4\u03BF \u0391\u03C0\u03BF\u03B4\u03B5\u03B9\u03BA\u03C4\u03B9\u03BA\u03CC \u03A0\u03BB\u03B7\u03C1\u03C9\u03BC\u03AE\u03C2 \u03C0\u03C1\u03AD\u03C0\u03B5\u03B9 \u03BD\u03B1 \u03C6\u03B1\u03AF\u03BD\u03B5\u03C4\u03B1\u03B9 \u03C4\u03BF \u03C0\u03BF\u03C3\u03CC \u03C0\u03BB\u03B7\u03C1\u03C9\u03BC\u03AE\u03C2 \u03BA\u03B1\u03B9 \u03B7 \u03C3\u03C6\u03C1\u03B1\u03B3\u03AF\u03B4\u03B1 \u03C4\u03B7\u03C2 \u03A4\u03C1\u03AC\u03C0\u03B5\u03B6\u03B1\u03C2","payment_slip":"\u0391\u03C0\u03BF\u03B4\u03B5\u03B9\u03BA\u03C4\u03B9\u03BA\u03CC \u03A4\u03C1\u03B1\u03C0\u03B5\u03B6\u03B9\u03BA\u03AE\u03C2 \u039C\u03B5\u03C4\u03B1\u03C6\u03BF\u03C1\u03AC\u03C2","upload_payment_slip":"\u0391\u03BD\u03AD\u03B2\u03B1\u03C3\u03BC\u03B1 \u0391\u03C0\u03BF\u03B4\u03B5\u03B9\u03BA\u03C4\u03B9\u03BA\u03BF\u03CD \u03A0\u03BB\u03B7\u03C1\u03C9\u03BC\u03AE\u03C2","document_selected":"T\u03B1 \u0391\u03C1\u03C7\u03B5\u03AF\u03B1 \u0395\u03C0\u03B9\u03BB\u03AD\u03C7\u03B8\u03B7\u03BA\u03B1\u03BD","you_can_upload_slip_now_or_later":"\u039C\u03C0\u03BF\u03C1\u03B5\u03AF\u03C4\u03B5 \u03BD\u03B1 \u03B1\u03BD\u03B5\u03B2\u03AC\u03C3\u03B5\u03C4\u03B5 \u03C4\u03BF \u0391\u03C0\u03BF\u03B4\u03B5\u03B9\u03BA\u03C4\u03B9\u03BA\u03CC \u03A0\u03BB\u03B7\u03C1\u03C9\u03BC\u03AE\u03C2 \u03C4\u03CE\u03C1\u03B1 \u03C7\u03C1\u03B7\u03C3\u03B9\u03BC\u03BF\u03C0\u03BF\u03B9\u03CE\u03BD\u03C4\u03B1\u03C2 \u03C4\u03BF \u03C0\u03B1\u03C1\u03B1\u03C0\u03AC\u03BD\u03C9 \u03BA\u03BF\u03C5\u03BC\u03C0\u03AF, \u03B4\u03B9\u03B1\u03C6\u03BF\u03C1\u03B5\u03C4\u03B9\u03BA\u03AC \u03B8\u03B1 \u03C3\u03B1\u03C2 \u03C4\u03BF \u03C5\u03C0\u03B5\u03BD\u03B8\u03C5\u03BC\u03AF\u03C3\u03BF\u03C5\u03BC\u03B5 \u03B1\u03C1\u03B3\u03CC\u03C4\u03B5\u03C1\u03B1.","you_can_select_another_payment_method":"\u0391\u03BD \u03B8\u03AD\u03BB\u03B5\u03C4\u03B5 \u03BD\u03B1 \u03B5\u03C0\u03B9\u03BB\u03AD\u03BE\u03B5\u03C4\u03B5 \u03AC\u03BB\u03BB\u03B7 \u03BC\u03AD\u03B8\u03BF\u03B4\u03BF \u03C0\u03BB\u03B7\u03C1\u03C9\u03BC\u03AE\u03C2, \u03B1\u03BA\u03C5\u03C1\u03CE\u03C3\u03C4\u03B5 \u03C4\u03B7\u03BD \u03A4\u03C1\u03B1\u03C0\u03B5\u03B6\u03B9\u03BA\u03AE \u039C\u03B5\u03C4\u03B1\u03C6\u03BF\u03C1\u03AC \u03C7\u03C1\u03B7\u03C3\u03B9\u03BC\u03BF\u03C0\u03BF\u03B9\u03CE\u03BD\u03C4\u03B1\u03C2 \u03B1\u03C5\u03C4\u03CC\u03BD \u03C4\u03BF\u03BD \u03C3\u03CD\u03BD\u03B4\u03B5\u03C3\u03BC\u03BF.","wire_transfer_cancel_button":"\u0391\u03BA\u03C5\u03C1\u03CE\u03C3\u03C4\u03B5 \u03C4\u03B7\u03BD \u03A4\u03C1\u03B1\u03C0\u03B5\u03B6\u03B9\u03BA\u03AE \u039C\u03B5\u03C4\u03B1\u03C6\u03BF\u03C1\u03AC \u03BA\u03B1\u03B9 \u03B5\u03C0\u03B9\u03BB\u03AD\u03BE\u03C4\u03B5 \u03AC\u03BB\u03BB\u03BF\u03BD \u03C4\u03C1\u03CC\u03C0\u03BF \u03C0\u03BB\u03B7\u03C1\u03C9\u03BC\u03AE\u03C2","wire_transfer_remind_later_button":"\u03A5\u03C0\u03B5\u03BD\u03B8\u03CD\u03BC\u03B9\u03C3\u03B7 \u0391\u03C1\u03B3\u03CC\u03C4\u03B5\u03C1\u03B1","wire_transfer_i_have_sent_money":"\u0388\u03C7\u03C9 \u03C3\u03C4\u03B5\u03AF\u03BB\u03B5\u03B9 \u03C7\u03C1\u03AE\u03BC\u03B1\u03C4\u03B1","wire_transfer_slip_uploading":"\u03A6\u03BF\u03C1\u03C4\u03CE\u03BD\u03B5\u03B9...","wire_transfer_slip_under_review":"\u03A4\u03BF \u0391\u03C0\u03BF\u03B4\u03B5\u03B9\u03BA\u03C4\u03B9\u03BA\u03CC \u03A0\u03BB\u03B7\u03C1\u03C9\u03BC\u03AE\u03C2 \u03B5\u03AF\u03BD\u03B1\u03B9 \u03C5\u03C0\u03CC \u03AD\u03BB\u03B5\u03B3\u03C7\u03BF","wire_transfer_out_team_is_checking_slip":"\u0397 \u03BF\u03BC\u03AC\u03B4\u03B1 \u03BC\u03B1\u03C2 \u03B8\u03B1 \u03B5\u03BB\u03AD\u03B3\u03BE\u03B5\u03B9 \u03C4\u03BF \u0391\u03C0\u03BF\u03B4\u03B5\u03B9\u03BA\u03C4\u03B9\u03BA\u03CC \u03A0\u03BB\u03B7\u03C1\u03C9\u03BC\u03AE\u03C2 \u03C3\u03CD\u03BD\u03C4\u03BF\u03BC\u03B1.","download_slip":"\u039A\u03B1\u03C4\u03B5\u03B2\u03AC\u03C3\u03C4\u03B5 \u03C4\u03BF \u0391\u03C0\u03BF\u03B4\u03B5\u03B9\u03BA\u03C4\u03B9\u03BA\u03CC \u03A0\u03BB\u03B7\u03C1\u03C9\u03BC\u03AE\u03C2","card_payment_cancel_button":"\u0391\u03BA\u03C5\u03C1\u03CE\u03C3\u03C4\u03B5 \u03C4\u03B7\u03BD \u03C0\u03BB\u03B7\u03C1\u03C9\u03BC\u03AE \u03BC\u03B5 \u03BA\u03AC\u03C1\u03C4\u03B1 \u03BA\u03B1\u03B9 \u03B5\u03C0\u03B9\u03BB\u03AD\u03BE\u03C4\u03B5 \u03BC\u03B9\u03B1 \u03AC\u03BB\u03BB\u03B7 \u03BC\u03AD\u03B8\u03BF\u03B4\u03BF \u03C0\u03BB\u03B7\u03C1\u03C9\u03BC\u03AE\u03C2","card_payment_has_been_canceled":"\u0397 \u03C0\u03BB\u03B7\u03C1\u03C9\u03BC\u03AE \u03BC\u03B5 \u03BA\u03AC\u03C1\u03C4\u03B1 \u03AD\u03C7\u03B5\u03B9 \u03B1\u03BA\u03C5\u03C1\u03C9\u03B8\u03B5\u03AF","error_failed_to_load_panel":"\u0391\u03C0\u03BF\u03C4\u03C5\u03C7\u03AF\u03B1 \u03C6\u03CC\u03C1\u03C4\u03C9\u03C3\u03B7\u03C2 \u03C4\u03BF\u03C5 \u03C0\u03AF\u03BD\u03B1\u03BA\u03B1 \u03C0\u03BB\u03B7\u03C1\u03C9\u03BC\u03CE\u03BD","add_account":"\u03A0\u03C1\u03BF\u03C3\u03B8\u03AE\u03BA\u03B7 \u039B\u03BF\u03B3\u03B1\u03C1\u03B9\u03B1\u03C3\u03BC\u03BF\u03CD","learn_more_about":"\u039C\u03AC\u03B8\u03B5\u03C4\u03B5 \u03C0\u03B5\u03C1\u03B9\u03C3\u03C3\u03CC\u03C4\u03B5\u03C1\u03B1","lean_payment":"\u0391\u03C0\u03BB\u03BF\u03C0\u03BF\u03B9\u03B7\u03BC\u03AD\u03BD\u03B5\u03C2 \u03A0\u03BB\u03B7\u03C1\u03C9\u03BC\u03AD\u03C2","lean_modal_title_1":"\u0393\u03B9\u03B1\u03C4\u03AF \u03BD\u03B1 \u03C7\u03C1\u03B7\u03C3\u03B9\u03BC\u03BF\u03C0\u03BF\u03B9\u03AE\u03C3\u03B5\u03C4\u03B5 \u0386\u03BC\u03B5\u03C3\u03B7 \u03A4\u03C1\u03B1\u03C0\u03B5\u03B6\u03B9\u03BA\u03AE \u039C\u03B5\u03C4\u03B1\u03C6\u03BF\u03C1\u03AC;","lean_modal_title_2":"\u039C\u03B5\u03C4\u03B1\u03BA\u03B9\u03BD\u03AE\u03C3\u03C4\u03B5 \u03C4\u03B1 \u03C7\u03C1\u03AE\u03BC\u03B1\u03C4\u03B1 \u03BC\u03B5 \u03C4\u03B7\u03BD \u03B1\u03C3\u03C6\u03AC\u03BB\u03B5\u03B9\u03B1 \u03C4\u03B7\u03C2 \u03C4\u03C1\u03AC\u03C0\u03B5\u03B6\u03AC\u03C2 \u03C3\u03B1\u03C2","lean_modal_title_3":"\u0391\u03C5\u03C4\u03AE \u03B7 \u03BC\u03AD\u03B8\u03BF\u03B4\u03BF\u03C2 \u03C0\u03BB\u03B7\u03C1\u03C9\u03BC\u03AE\u03C2 \u03C3\u03AC\u03C2 \u03B5\u03C0\u03B9\u03C4\u03C1\u03AD\u03C0\u03B5\u03B9 \u03BD\u03B1 \u03C0\u03C1\u03B1\u03B3\u03BC\u03B1\u03C4\u03BF\u03C0\u03BF\u03B9\u03AE\u03C3\u03B5\u03C4\u03B5 \u03BC\u03B9\u03B1 \u03AC\u03BC\u03B5\u03C3\u03B7 \u03C4\u03C1\u03B1\u03C0\u03B5\u03B6\u03B9\u03BA\u03AE \u03BC\u03B5\u03C4\u03B1\u03C6\u03BF\u03C1\u03AC \u03B1\u03C0\u03CC \u03C4\u03BF\u03BD \u03C4\u03C1\u03B1\u03C0\u03B5\u03B6\u03B9\u03BA\u03CC \u03BB\u03BF\u03B3\u03B1\u03C1\u03B9\u03B1\u03C3\u03BC\u03CC \u03C4\u03B7\u03C2 \u03B5\u03C0\u03B9\u03C7\u03B5\u03AF\u03C1\u03B7\u03C3\u03AE\u03C2 \u03C3\u03B1\u03C2. \u03A7\u03C1\u03B5\u03B9\u03AC\u03B6\u03B5\u03C4\u03B1\u03B9 \u03BC\u03CC\u03BD\u03BF \u03BD\u03B1 \u03C3\u03C5\u03BD\u03B4\u03AD\u03C3\u03B5\u03C4\u03B5 \u03C4\u03BF\u03BD \u03BB\u03BF\u03B3\u03B1\u03C1\u03B9\u03B1\u03C3\u03BC\u03CC \u03C3\u03B1\u03C2 \u03BC\u03AF\u03B1 \u03C6\u03BF\u03C1\u03AC \u03BA\u03B1\u03B9 \u03C3\u03C4\u03B7 \u03C3\u03C5\u03BD\u03AD\u03C7\u03B5\u03B9\u03B1 \u03B8\u03B1 \u03BC\u03C0\u03BF\u03C1\u03B5\u03AF\u03C4\u03B5 \u03BD\u03B1 \u03C4\u03BF\u03BD \u03C7\u03C1\u03B7\u03C3\u03B9\u03BC\u03BF\u03C0\u03BF\u03B9\u03AE\u03C3\u03B5\u03C4\u03B5 \u03B3\u03B9\u03B1 \u03C4\u03C5\u03C7\u03CC\u03BD \u03BC\u03B5\u03BB\u03BB\u03BF\u03BD\u03C4\u03B9\u03BA\u03AD\u03C2 \u03C0\u03BB\u03B7\u03C1\u03C9\u03BC\u03AD\u03C2.","lean_modal_action_1":"\u03A3\u03C5\u03BD\u03B4\u03AD\u03C3\u03C4\u03B5 \u03C4\u03BF\u03BD \u03C4\u03C1\u03B1\u03C0\u03B5\u03B6\u03B9\u03BA\u03CC \u03C3\u03B1\u03C2 \u03BB\u03BF\u03B3\u03B1\u03C1\u03B9\u03B1\u03C3\u03BC\u03CC","lean_modal_action_2":"\u03A0\u03BB\u03B7\u03C1\u03CE\u03C3\u03C4\u03B5 \u03AC\u03BC\u03B5\u03C3\u03B1","lean_modal_title_4":"\u039F\u03B9 \u03C0\u03BB\u03B7\u03C1\u03C9\u03BC\u03AD\u03C2 \u03C3\u03B1\u03C2 \u03B8\u03B1 \u03B5\u03AF\u03BD\u03B1\u03B9 \u03C0\u03AC\u03BD\u03C4\u03B1 \u03B1\u03C3\u03C6\u03B1\u03BB\u03B5\u03AF\u03C2 \u03C7\u03AC\u03C1\u03B7 \u03C3\u03C4\u03B7\u03BD \u03C0\u03BF\u03BB\u03BB\u03B1\u03C0\u03BB\u03AE \u03C4\u03B1\u03C5\u03C4\u03BF\u03C0\u03BF\u03AF\u03B7\u03C3\u03B7, \u03B1\u03BA\u03C1\u03B9\u03B2\u03CE\u03C2 \u03CC\u03C0\u03C9\u03C2 \u03CC\u03C4\u03B1\u03BD \u03C7\u03C1\u03B7\u03C3\u03B9\u03BC\u03BF\u03C0\u03BF\u03B9\u03B5\u03AF\u03C4\u03B5 \u03C4\u03BF\u03BD \u03C4\u03C1\u03B1\u03C0\u03B5\u03B6\u03B9\u03BA\u03CC \u03C3\u03B1\u03C2 \u03BB\u03BF\u03B3\u03B1\u03C1\u03B9\u03B1\u03C3\u03BC\u03CC.","payment_awaiting_authorization":"\u0397 \u03C0\u03BB\u03B7\u03C1\u03C9\u03BC\u03AE \u03B1\u03BD\u03B1\u03BC\u03AD\u03BD\u03B5\u03B9 \u03AD\u03B3\u03BA\u03C1\u03B9\u03C3\u03B7","will_be_paid_after_authorize":"\u0397 \u03C0\u03BB\u03B7\u03C1\u03C9\u03BC\u03AE \u03C3\u03B1\u03C2 \u03B8\u03B1 \u03BA\u03B1\u03C4\u03B1\u03B2\u03BB\u03B7\u03B8\u03B5\u03AF \u03B1\u03C6\u03BF\u03CD \u03C4\u03B7\u03BD \u03B5\u03BE\u03BF\u03C5\u03C3\u03B9\u03BF\u03B4\u03BF\u03C4\u03AE\u03C3\u03B5\u03C4\u03B5.","loading":"\u03A6\u03BF\u03C1\u03C4\u03CE\u03BD\u03B5\u03B9...","connect_lean_account":"\u03A3\u03C5\u03BD\u03B4\u03AD\u03C3\u03C4\u03B5 \u039B\u03BF\u03B3\u03B1\u03C1\u03B9\u03B1\u03C3\u03BC\u03CC Lean","successfully_connected_bank":"\u039F \u03C4\u03C1\u03B1\u03C0\u03B5\u03B6\u03B9\u03BA\u03CC\u03C2 \u03BB\u03BF\u03B3\u03B1\u03C1\u03B9\u03B1\u03C3\u03BC\u03CC\u03C2 \u03C3\u03C5\u03BD\u03B4\u03AD\u03B8\u03B7\u03BA\u03B5 \u03BC\u03B5 \u03B5\u03C0\u03B9\u03C4\u03C5\u03C7\u03AF\u03B1","payment_has_been_queued":"\u0397 \u03C0\u03BB\u03B7\u03C1\u03C9\u03BC\u03AE \u03C3\u03B1\u03C2 \u03AD\u03C7\u03B5\u03B9 \u03B4\u03C1\u03BF\u03BC\u03BF\u03BB\u03BF\u03B3\u03B7\u03B8\u03B5\u03AF","successfully_paid":"H \u03C0\u03BB\u03B7\u03C1\u03C9\u03BC\u03AE \u03BF\u03BB\u03BF\u03BA\u03BB\u03B7\u03C1\u03CE\u03B8\u03B7\u03BA\u03B5 \u03B5\u03C0\u03B9\u03C4\u03C5\u03C7\u03CE\u03C2","cannot_pay":"\u0391\u03C0\u03BF\u03C4\u03C5\u03C7\u03AF\u03B1 \u03A0\u03BB\u03B7\u03C1\u03C9\u03BC\u03AE\u03C2","lean":{"setup_status_active":"\u0395\u03BD\u03B5\u03C1\u03B3\u03AE","setup_status_pending":"E\u03BA\u03BA\u03C1\u03B5\u03BC\u03AE\u03C2","setup_status_not_connected":"\u03A7\u03C9\u03C1\u03AF\u03C2 \u03C3\u03CD\u03BD\u03B4\u03B5\u03C3\u03B7","account_is_being_connected":"\u039F \u03BB\u03BF\u03B3\u03B1\u03C1\u03B9\u03B1\u03C3\u03BC\u03CC\u03C2 \u03C3\u03B1\u03C2 \u03C3\u03C5\u03BD\u03B4\u03AD\u03B5\u03C4\u03B1\u03B9. \u0395\u03C0\u03B9\u03BB\u03AD\u03BE\u03C4\u03B5 \u03AC\u03BB\u03BB\u03BF \u03C4\u03C1\u03CC\u03C0\u03BF \u03C0\u03BB\u03B7\u03C1\u03C9\u03BC\u03AE\u03C2 \u03AE \u03B4\u03BF\u03BA\u03B9\u03BC\u03AC\u03C3\u03C4\u03B5 \u03BE\u03B1\u03BD\u03AC \u03B1\u03C1\u03B3\u03CC\u03C4\u03B5\u03C1\u03B1"}},"account_statement":{"recent_activities":"\u03A0\u03C1\u03CC\u03C3\u03C6\u03B1\u03C4\u03B5\u03C2 \u0394\u03C1\u03B1\u03C3\u03C4\u03B7\u03C1\u03B9\u03CC\u03C4\u03B7\u03C4\u03B5\u03C2","account_statement":"\u039A\u03B1\u03C4\u03AC\u03C3\u03C4\u03B1\u03C3\u03B7 \u039B\u03BF\u03B3\u03B1\u03C1\u03B9\u03B1\u03C3\u03BC\u03BF\u03CD","currency":"\u0395\u03C5\u03C1\u03CE","from":"\u0391\u03C0\u03CC","to":"\u03A0\u03C1\u03BF\u03C2","starts_from":"\u039E\u03B5\u03BA\u03B9\u03BD\u03AC\u03B5\u03B9 \u03B1\u03C0\u03CC","downloading":"\u039A\u03B1\u03C4\u03B5\u03B2\u03B1\u03AF\u03BD\u03B5\u03B9...","download":"K\u03B1\u03C4\u03B5\u03B2\u03AC\u03C3\u03C4\u03B5","invoice":"\u03A4\u03B9\u03BC\u03BF\u03BB\u03CC\u03B3\u03B9\u03BF","credit_note":"\u03A0\u03B9\u03C3\u03C4\u03C9\u03C4\u03B9\u03BA\u03CC \u03A3\u03B7\u03BC\u03B5\u03AF\u03C9\u03BC\u03B1","empty_list":"\u0394\u03B5\u03BD \u03C5\u03C0\u03AC\u03C1\u03C7\u03BF\u03C5\u03BD \u03B4\u03B5\u03B4\u03BF\u03BC\u03AD\u03BD\u03B1 \u03B3\u03B9\u03B1 \u03C4\u03B7\u03BD \u03B5\u03C0\u03B9\u03BB\u03B5\u03B3\u03BC\u03AD\u03BD\u03B7 \u03C0\u03B5\u03C1\u03AF\u03BF\u03B4\u03BF"},"calendar":{"month_january":"\u0399\u03B1\u03BD\u03BF\u03C5\u03AC\u03C1\u03B9\u03BF\u03C2","month_february":"\u03A6\u03B5\u03B2\u03C1\u03BF\u03C5\u03AC\u03C1\u03B9\u03BF\u03C2","month_march":"\u039C\u03AC\u03C1\u03C4\u03B9\u03BF\u03C2","month_april":"\u0391\u03C0\u03C1\u03AF\u03BB\u03B9\u03BF\u03C2","month_may":"\u039C\u03AC\u03B9\u03BF\u03C2","month_june":"\u0399\u03BF\u03CD\u03BD\u03B9\u03BF\u03C2","month_july":"\u0399\u03BF\u03CD\u03BB\u03B9\u03BF\u03C2","month_august":"\u0391\u03CD\u03B3\u03BF\u03C5\u03C3\u03C4\u03BF\u03C2","month_september":"\u03A3\u03B5\u03C0\u03C4\u03AD\u03BC\u03B2\u03C1\u03B9\u03BF\u03C2","month_october":"\u039F\u03BA\u03C4\u03CE\u03B2\u03C1\u03B9\u03BF\u03C2","month_november":"\u039D\u03BF\u03AD\u03BC\u03B2\u03C1\u03B9\u03BF\u03C2","month_december":"\u0394\u03B5\u03BA\u03AD\u03BC\u03B2\u03C1\u03B9\u03BF\u03C2","month":"\u039C\u03AE\u03BD\u03B1\u03C2","year":"\u0388\u03C4\u03BF\u03C2","cancel":"\u0391\u03BA\u03CD\u03C1\u03C9\u03C3\u03B7","set":"\u039A\u03B1\u03B8\u03BF\u03C1\u03B9\u03C3\u03BC\u03CC\u03C2 \u0397\u03BC\u03B5\u03C1\u03BF\u03BC\u03B7\u03BD\u03B9\u03CE\u03BD","clear":"\u0394\u03B9\u03B1\u03B3\u03C1\u03B1\u03C6\u03AE \u038C\u03BB\u03C9\u03BD","all_locations":"\u038C\u03BB\u03B5\u03C2 \u03BF\u03B9 \u03A4\u03BF\u03C0\u03BF\u03B8\u03B5\u03C3\u03AF\u03B5\u03C2"},"payment_item":{"status_draft":"\u03A0\u03C1\u03CC\u03C7\u03B5\u03B9\u03C1\u03BF","status_paid":"\u03A0\u03BB\u03B7\u03C1\u03CE\u03B8\u03B7\u03BA\u03B5","status_unpaid":"\u0395\u03BA\u03BA\u03C1\u03B5\u03BC\u03B5\u03AF","status_processed":"\u03A3\u03B5 \u0395\u03C0\u03B5\u03BE\u03B5\u03C1\u03B3\u03B1\u03C3\u03AF\u03B1","status_voided":"\u0391\u03BA\u03C5\u03C1\u03C9\u03BC\u03AD\u03BD\u03BF"},"saved_payment_methods":{"method_has_been_added":"\u039F \u03A4\u03C1\u03CC\u03C0\u03BF\u03C2 \u03A0\u03BB\u03B7\u03C1\u03C9\u03BC\u03AE\u03C2 \u03C0\u03C1\u03BF\u03C3\u03C4\u03AD\u03B8\u03B7\u03BA\u03B5 \u03BC\u03B5 \u03B5\u03C0\u03B9\u03C4\u03C5\u03C7\u03AF\u03B1","save_card":"\u0391\u03C0\u03BF\u03B8\u03AE\u03BA\u03B5\u03C5\u03C3\u03B7 \u039A\u03AC\u03C1\u03C4\u03B1\u03C2","saving_progress":"\u0391\u03C0\u03BF\u03B8\u03AE\u03BA\u03B5\u03C5\u03C3\u03B7...","remove_payment_method":"\u0391\u03C6\u03B1\u03AF\u03C1\u03B5\u03C3\u03B7 \u03A4\u03C1\u03CC\u03C0\u03BF\u03C5 \u03A0\u03BB\u03B7\u03C1\u03C9\u03BC\u03AE\u03C2","method_has_been_deleted":"\u039F \u03A4\u03C1\u03CC\u03C0\u03BF\u03C2 \u03A0\u03BB\u03B7\u03C1\u03C9\u03BC\u03AE\u03C2 \u03B1\u03C6\u03B1\u03B9\u03C1\u03AD\u03B8\u03B7\u03BA\u03B5 \u03BC\u03B5 \u03B5\u03C0\u03B9\u03C4\u03C5\u03C7\u03AF\u03B1","payment_methods":"\u03A4\u03C1\u03CC\u03C0\u03BF\u03B9 \u03A0\u03BB\u03B7\u03C1\u03C9\u03BC\u03AE\u03C2","no_payment_methods_added":"\u0394\u03B5\u03BD \u03AD\u03C7\u03B5\u03B9 \u03BF\u03C1\u03B9\u03C3\u03C4\u03B5\u03AF \u03C4\u03C1\u03CC\u03C0\u03BF\u03C2 \u03C0\u03BB\u03B7\u03C1\u03C9\u03BC\u03AE\u03C2","add_new_card":"\u03A0\u03C1\u03BF\u03C3\u03B8\u03AD\u03C3\u03C4\u03B5 \u039D\u03AD\u03B1 \u039A\u03AC\u03C1\u03C4\u03B1"},"error_boundary":{"default":{"server_error":"\u0395\u03C3\u03C9\u03C4\u03B5\u03C1\u03B9\u03BA\u03CC \u03A3\u03C6\u03AC\u03BB\u03BC\u03B1 \u0394\u03B9\u03B1\u03BA\u03BF\u03BC\u03B9\u03C3\u03C4\u03AE","permission_error":"\u0386\u03C1\u03BD\u03B7\u03C3\u03B7 \u03A0\u03C1\u03CC\u03C3\u03B2\u03B1\u03C3\u03B7\u03C2","client_error":"\u03A3\u03C6\u03AC\u03BB\u03BC\u03B1 \u03A0\u03B5\u03BB\u03AC\u03C4\u03B7","not_found_error":"\u0394\u03B5\u03BD \u0392\u03C1\u03AD\u03B8\u03B7\u03BA\u03B5","not_authorized_error":"\u0395\u03BB\u03BB\u03B9\u03C0\u03AE\u03C2 \u0395\u03BE\u03BF\u03C5\u03C3\u03B9\u03BF\u03B4\u03CC\u03C4\u03B7\u03C3\u03B7","connection_error":"\u03A3\u03C6\u03AC\u03BB\u03BC\u03B1 \u03C3\u03CD\u03BD\u03B4\u03B5\u03C3\u03B7\u03C2. \u0395\u03BB\u03AD\u03B3\u03BE\u03C4\u03B5 \u03C4\u03B7 \u03C3\u03CD\u03BD\u03B4\u03B5\u03C3\u03AE \u03C3\u03B1\u03C2 \u03C3\u03C4\u03BF \u0394\u03B9\u03B1\u03B4\u03AF\u03BA\u03C4\u03C5\u03BF","too_many_requests_error":"\u03A0\u03AC\u03C1\u03B1 \u03C0\u03BF\u03BB\u03BB\u03AC \u03B1\u03B9\u03C4\u03AE\u03BC\u03B1\u03C4\u03B1. \u0394\u03BF\u03BA\u03B9\u03BC\u03AC\u03C3\u03C4\u03B5 \u03BE\u03B1\u03BD\u03AC \u03B1\u03C1\u03B3\u03CC\u03C4\u03B5\u03C1\u03B1","default_error":"\u039A\u03AC\u03C4\u03B9 \u03C0\u03AE\u03B3\u03B5 \u03BB\u03AC\u03B8\u03BF\u03C2. \u03A0\u03C1\u03BF\u03C3\u03C0\u03B1\u03B8\u03AE\u03C3\u03C4\u03B5 \u039E\u03B1\u03BD\u03AC","try_again":"\u03A0\u03C1\u03BF\u03C3\u03C0\u03B1\u03B8\u03AE\u03C3\u03C4\u03B5 \u039E\u03B1\u03BD\u03AC"},"payment":{"cannot_fetch_overdue_server_error":"\u0394\u03B5\u03BD \u03AE\u03C4\u03B1\u03BD \u03B4\u03C5\u03BD\u03B1\u03C4\u03AE \u03B7 \u03B1\u03BD\u03AC\u03BA\u03C4\u03B7\u03C3\u03B7 \u03B4\u03B5\u03B4\u03BF\u03BC\u03AD\u03BD\u03C9\u03BD \u03B5\u03BA\u03C0\u03C1\u03CC\u03B8\u03B5\u03C3\u03BC\u03C9\u03BD \u03C0\u03BB\u03B7\u03C1\u03C9\u03BC\u03CE\u03BD"}},"pending_orders_panel":{"pending_confirmation":"\u0395\u03BA\u03BA\u03C1\u03B5\u03BC\u03B5\u03AF \u0395\u03C0\u03B9\u03B2\u03B5\u03B2\u03B1\u03AF\u03C9\u03C3\u03B7","n_orders":"{{count}} \u03C0\u03B1\u03C1\u03B1\u03B3\u03B3\u03B5\u03BB\u03AF\u03B5\u03C2","confirm_now":"\u0395\u03C0\u03B9\u03B2\u03B5\u03B2\u03B1\u03B9\u03CE\u03C3\u03C4\u03B5"},"raised_disputes_panel":{"title":"\u0391\u03BD\u03BF\u03B9\u03C7\u03C4\u03AD\u03C2 \u03B4\u03B9\u03B1\u03C6\u03C9\u03BD\u03AF\u03B5\u03C2","n_disputes":"{{count}} \u03B4\u03B9\u03B1\u03C6\u03C9\u03BD\u03AF\u03B5\u03C2","review_now":"\u0388\u03BB\u03B5\u03B3\u03C7\u03BF\u03C2 \u03C4\u03CE\u03C1\u03B1"},"step_indicator":{"step_of":"\u0392\u03AE\u03BC\u03B1 {{currentStepNumber}} \u03B1\u03C0\u03CC {{stepsCount}}"},"page_stepper":{"next":"\u0395\u03C0\u03CC\u03BC\u03B5\u03BD\u03BF","previous":"\u03A0\u03AF\u03C3\u03C9","finish":"\u03A4\u03AD\u03BB\u03BF\u03C2","of":"\u03B1\u03C0\u03CC"},"order_status":{"draft":"\u03A0\u03C1\u03CC\u03C7\u03B5\u03B9\u03C1\u03BF","pending_confirmation":"\u0395\u03BA\u03BA\u03C1\u03B5\u03BC\u03B5\u03AF \u0395\u03C0\u03B9\u03B2\u03B5\u03B2\u03B1\u03AF\u03C9\u03C3\u03B7","under_review":"\u03A3\u03B5 \u0388\u03BB\u03B5\u03B3\u03C7\u03BF","started":"\u0388\u03C7\u03B5\u03B9 \u039E\u03B5\u03BA\u03B9\u03BD\u03AE\u03C3\u03B5\u03B9","upcoming":"\u0395\u03C0\u03B5\u03C1\u03C7\u03CC\u03BC\u03B5\u03BD\u03B5\u03C2"},"toggle":{"yes_short":"\u039D","no_short":"O"},"time":{"mon":"\u0394\u03B5\u03C5","tue":"\u03A4\u03C1\u03B9","wed":"\u03A4\u03B5\u03C4","thu":"\u03A0\u03B5\u03BC","fri":"\u03A0\u03B1\u03C1","sat":"\u03A3\u03B1\u03B2","sun":"\u039A\u03C5\u03C1"},"sp_rating":{"novice":"\u0391\u03C1\u03C7\u03AC\u03C1\u03B9\u03BF\u03C2","competent":"\u0399\u03BA\u03B1\u03BD\u03CC\u03C2","expert":"\u0395\u03B9\u03B4\u03AE\u03BC\u03BF\u03BD\u03B1\u03C2","advanced_beginner":"\u039C\u03B5 \u039C\u03B9\u03BA\u03C1\u03AE \u0395\u03BC\u03C0\u03B5\u03B9\u03C1\u03AF\u03B1","proficient":"\u0395\u03C0\u03B9\u03B4\u03AD\u03BE\u03B9\u03BF\u03C2"},"time_picker":{"hour":"\u038F\u03C1\u03B1","minute":"\u039B\u03B5\u03C0\u03C4\u03AC","cancel":"\u0391\u03BA\u03CD\u03C1\u03C9\u03C3\u03B7","set":"\u0395\u03C0\u03B9\u03BB\u03BF\u03B3\u03AE"},"become_affiliate":{"modal_title":"\u0393\u03AF\u03BD\u03B5\u03C4\u03B5 \u03A3\u03C5\u03BD\u03B5\u03C1\u03B3\u03AC\u03C4\u03B7\u03C2","modal_subtitle":"\u03A0\u03C1\u03BF\u03C3\u03BA\u03B1\u03BB\u03AD\u03C3\u03C4\u03B5 \u03C4\u03BF \u03C0\u03C1\u03BF\u03C3\u03C9\u03C0\u03B9\u03BA\u03CC \u03C3\u03B1\u03C2 \u03C3\u03C4\u03B7\u03BD Ogram \u03BA\u03B1\u03B9 \u03BA\u03B5\u03C1\u03B4\u03AF\u03C3\u03C4\u03B5 \u03C7\u03C1\u03AE\u03BC\u03B1\u03C4\u03B1!","accept_tc":"\u038C\u03C1\u03BF\u03B9 \u03BA\u03B1\u03B9 \u03A0\u03C1\u03BF\u03CB\u03C0\u03BF\u03B8\u03AD\u03C3\u03B5\u03B9\u03C2"},"common_affiliate":{"join_ogram":"\u0395\u03B3\u03B3\u03C1\u03B1\u03C6\u03B5\u03AF\u03C4\u03B5 \u03C3\u03C4\u03B7\u03BD Ogram \u03BC\u03AD\u03C3\u03C9 \u03C4\u03BF\u03C5 \u03C3\u03C5\u03BD\u03B4\u03AD\u03C3\u03BC\u03BF\u03C5 \u03BC\u03BF\u03C5","my_referrals":"\u039F\u03B9 \u03A3\u03C5\u03C3\u03C4\u03AC\u03C3\u03B5\u03B9\u03C2 \u03BC\u03BF\u03C5","send_invitation":"\u0391\u03C0\u03BF\u03C3\u03C4\u03BF\u03BB\u03AE \u03A0\u03C1\u03CC\u03C3\u03BA\u03BB\u03B7\u03C3\u03B7\u03C2","share_link":"\u03A0\u03C1\u03BF\u03C3\u03BA\u03B1\u03BB\u03AD\u03C3\u03C4\u03B5 \u03C4\u03B7\u03BD \u03BF\u03BC\u03AC\u03B4\u03B1 \u03C3\u03B1\u03C2 \u03C3\u03C4\u03BF App \u03C4\u03B7\u03C2 Ogram \u03BA\u03B1\u03B9 \u03BE\u03B5\u03BA\u03B9\u03BD\u03AE\u03C3\u03C4\u03B5 \u03BD\u03B1 \u03BA\u03B5\u03C1\u03B4\u03AF\u03B6\u03B5\u03C4\u03B5 \u03C7\u03C1\u03AE\u03BC\u03B1\u03C4\u03B1!","copy_and_send_link":"\u0389 \u03B1\u03BD\u03C4\u03B9\u03B3\u03C1\u03AC\u03C8\u03C4\u03B5 \u03C4\u03BF\u03BD \u03C0\u03B1\u03C1\u03B1\u03BA\u03AC\u03C4\u03C9 \u03C3\u03CD\u03BD\u03B4\u03B5\u03C3\u03BC\u03BF \u03BA\u03B1\u03B9 \u03C3\u03C4\u03B5\u03AF\u03BB\u03C4\u03B5 \u03C4\u03BF\u03BD","tc_1":"\u0391\u03C5\u03C4\u03BF\u03AF \u03BF\u03B9 \u03CC\u03C1\u03BF\u03B9 \u03B4\u03B5\u03BD \u03C3\u03C7\u03B5\u03C4\u03AF\u03B6\u03BF\u03BD\u03C4\u03B1\u03B9 \u03AC\u03BC\u03B5\u03C3\u03B1 \u03BC\u03B5 \u03C4\u03BF \u03C0\u03C1\u03CC\u03B3\u03C1\u03B1\u03BC\u03BC\u03B1 \u03C3\u03C5\u03C3\u03C4\u03AC\u03C3\u03B5\u03C9\u03BD, \u03B1\u03BB\u03BB\u03AC \u03B5\u03AF\u03BD\u03B1\u03B9 \u03B1\u03C1\u03BA\u03B5\u03C4\u03AC \u03C3\u03C5\u03BD\u03B1\u03C6\u03B5\u03AF\u03C2 \u03B3\u03B9\u03B1 \u03BD\u03B1 \u03C4\u03BF\u03C5\u03C2 \u03C3\u03C5\u03BC\u03C0\u03B5\u03C1\u03B9\u03BB\u03AC\u03B2\u03BF\u03C5\u03BC\u03B5 \u03B5\u03B4\u03CE (\u03BC\u03B5\u03C1\u03B9\u03BA\u03BF\u03AF \u03BF\u03C1\u03AF\u03B6\u03BF\u03C5\u03BD \u03AC\u03BB\u03BB\u03B5\u03C2 \u03B4\u03B9\u03B1\u03BA\u03C1\u03B9\u03C4\u03AD\u03C2 \u03BA\u03B1\u03C4\u03B7\u03B3\u03BF\u03C1\u03AF\u03B5\u03C2 \u03C0\u03B1\u03C1\u03B1\u03C0\u03BF\u03BC\u03C0\u03AE\u03C2 \u03BC\u03AC\u03C1\u03BA\u03B5\u03C4\u03B9\u03BD\u03B3\u03BA)","tc_2":"\u039F \u03BF\u03C1\u03B9\u03C3\u03BC\u03CC\u03C2 \u03B1\u03C5\u03C4\u03CE\u03BD \u03C4\u03C9\u03BD \u03BF\u03C1\u03BF\u03BB\u03BF\u03B3\u03B9\u03CE\u03BD \u03B2\u03BF\u03B7\u03B8\u03AC \u03C3\u03C4\u03B7\u03BD \u03BA\u03B1\u03BB\u03CD\u03C4\u03B5\u03C1\u03B7 \u03BF\u03C1\u03B9\u03BF\u03B8\u03AD\u03C4\u03B7\u03C3\u03B7 \u03C4\u03BF\u03C5 \u03C4\u03B9 \u03B5\u03AF\u03BD\u03B1\u03B9 \u03BA\u03B1\u03B9 \u03C4\u03B9 \u03B4\u03B5\u03BD \u03B5\u03AF\u03BD\u03B1\u03B9 \u03C0\u03C1\u03CC\u03B3\u03C1\u03B1\u03BC\u03BC\u03B1 \u03C3\u03C5\u03C3\u03C4\u03AC\u03C3\u03B5\u03C9\u03BD.","section_title":"\u03A3\u03A5\u039D\u0395\u03A1\u0393\u0391\u03A4\u0397\u03A3","dashboard":"\u03A0\u03AF\u03BD\u03B1\u03BA\u03B1\u03C2 \u0395\u03BB\u03AD\u03B3\u03C7\u03BF\u03C5","referrals":"\u03A3\u03C5\u03C3\u03C4\u03AC\u03C3\u03B5\u03B9\u03C2","earnings":"\u039A\u03AD\u03C1\u03B4\u03B7","designation":"\u0395\u03B9\u03B4\u03B9\u03BA\u03CC\u03C4\u03B7\u03C4\u03B1","payout":"\u0391\u03C0\u03BF\u03C0\u03BB\u03B7\u03C1\u03C9\u03BC\u03AE","due_date":"\u0397\u03BC\u03B5\u03C1\u03BF\u03BC\u03B7\u03BD\u03AF\u03B1 \u03A0\u03BB\u03B7\u03C1\u03C9\u03BC\u03AE\u03C2","join_date":"\u0397\u03BC\u03B5\u03C1\u03BF\u03BC\u03B7\u03BD\u03AF\u03B1 \u0388\u03BD\u03B1\u03C1\u03BE\u03B7\u03C2","this_month":"\u0391\u03C5\u03C4\u03CC\u03BD \u03C4\u03BF\u03BD \u039C\u03AE\u03BD\u03B1","invite_more_staff":"\u03A0\u03C1\u03BF\u03C3\u03BA\u03B1\u03BB\u03AD\u03C3\u03C4\u03B5 \u03B5\u03C0\u03B9\u03C0\u03BB\u03AD\u03BF\u03BD \u03C0\u03C1\u03BF\u03C3\u03C9\u03C0\u03B9\u03BA\u03CC","margin_split":"\u039A\u03B1\u03C4\u03B1\u03BD\u03BF\u03BC\u03AE \u03A0\u03B5\u03C1\u03B9\u03B8\u03C9\u03C1\u03AF\u03BF\u03C5","invite_your_staff":"\u03A0\u03C1\u03BF\u03C3\u03BA\u03B1\u03BB\u03AD\u03C3\u03C4\u03B5 \u03C4\u03BF \u03C0\u03C1\u03BF\u03C3\u03C9\u03C0\u03B9\u03BA\u03CC \u03C3\u03B1\u03C2","invite_staff_more_details":"\u03A0\u03C1\u03BF\u03C3\u03BA\u03B1\u03BB\u03AD\u03C3\u03C4\u03B5 \u03C4\u03BF\u03C5\u03C2 \u03C3\u03C5\u03BD\u03B1\u03B4\u03AD\u03BB\u03C6\u03BF\u03C5\u03C2 \u03C3\u03B1\u03C2 \u03C3\u03C4\u03B7\u03BD Ogram \u03BA\u03B1\u03B9 \u03BA\u03B5\u03C1\u03B4\u03AF\u03C3\u03C4\u03B5 \u03C7\u03C1\u03AE\u03BC\u03B1\u03C4\u03B1!","invite_now":"\u03A0\u03C1\u03BF\u03C3\u03BA\u03B1\u03BB\u03AD\u03C3\u03C4\u03B5 \u03A4\u03CE\u03C1\u03B1","earning_history":"\u0399\u03C3\u03C4\u03BF\u03C1\u03B9\u03BA\u03CC \u039A\u03B5\u03C1\u03B4\u03CE\u03BD","total_earnings":"\u03A3\u03C5\u03BD\u03BF\u03BB\u03B9\u03BA\u03AC \u039A\u03AD\u03C1\u03B4\u03B7","status_profile_created":"\u03A4\u03BF \u03C0\u03C1\u03BF\u03C6\u03AF\u03BB \u03B4\u03B7\u03BC\u03B9\u03BF\u03C5\u03C1\u03B3\u03AE\u03B8\u03B7\u03BA\u03B5","status_activated":"\u0395\u03BD\u03B5\u03C1\u03B3\u03BF\u03C0\u03BF\u03B9\u03B7\u03BC\u03AD\u03BD\u03BF","status_booked_shifts":"\u039A\u03BB\u03B5\u03B9\u03C3\u03BC\u03AD\u03BD\u03B5\u03C2 \u0392\u03AC\u03C1\u03B4\u03B9\u03B5\u03C2","status_shifts_done":"\u039F\u03BB\u03BF\u03BA\u03BB\u03B7\u03C1\u03C9\u03BC\u03AD\u03BD\u03B5\u03C2 \u0392\u03AC\u03C1\u03B4\u03B9\u03B5\u03C2","status_unknown":"\u0386\u03B3\u03BD\u03C9\u03C3\u03C4\u03BF","referrals_list":"\u039B\u03AF\u03C3\u03C4\u03B1 \u03A3\u03C5\u03C3\u03C4\u03AC\u03C3\u03B5\u03C9\u03BD"},"affiliate_instructions":{"how_it_works":"\u03A0\u03C9\u03C2 \u03B4\u03BF\u03C5\u03BB\u03B5\u03CD\u03B5\u03B9","instruction_1_title":"\u03A3\u03C4\u03B5\u03AF\u03BB\u03C4\u03B5 \u03BC\u03B9\u03B1 \u03A0\u03C1\u03CC\u03C3\u03BA\u03BB\u03B7\u03C3\u03B7","instruction_1_subtitle":"\u0391\u03C0\u03BB\u03AC \u03BC\u03BF\u03B9\u03C1\u03B1\u03C3\u03C4\u03B5\u03AF\u03C4\u03B5 \u03C4\u03BF\u03BD \u03C3\u03CD\u03BD\u03B4\u03B5\u03C3\u03BC\u03CC \u03C3\u03B1\u03C2","instruction_2_title":"\u0395\u03BA\u03B5\u03AF\u03BD\u03BF\u03B9 \u03B3\u03C1\u03AC\u03C6\u03BF\u03BD\u03C4\u03B1\u03B9 \u03C3\u03C4\u03B7\u03BD Ogram","instruction_2_subtitle":"\u039A\u03B1\u03B9 \u03BF\u03BB\u03BF\u03BA\u03BB\u03B7\u03C1\u03CE\u03BD\u03BF\u03C5\u03BD \u03C4\u03B9\u03C2 \u03B2\u03AC\u03C1\u03B4\u03B9\u03AD\u03C2 \u03C4\u03BF\u03C5\u03C2","instruction_3_title":"\u0395\u03C3\u03B5\u03AF\u03C2 \u039E\u03B5\u03BA\u03B9\u03BD\u03AC\u03C4\u03B5 \u039D\u03B1 \u039A\u03B5\u03C1\u03B4\u03AF\u03B6\u03B5\u03C4\u03B5!","instruction_3_subtitle":"\u039B\u03AC\u03B2\u03B5\u03C4\u03B5 \u03C0\u03C1\u03BF\u03BC\u03AE\u03B8\u03B5\u03B9\u03B1 \u03B3\u03B9\u03B1 \u03C4\u03B7 \u03B4\u03BF\u03C5\u03BB\u03B5\u03B9\u03AC \u03C4\u03BF\u03C5\u03C2","instruction_4_title":"\u03A0\u03B1\u03C1\u03B1\u03BA\u03BF\u03BB\u03BF\u03C5\u03B8\u03AE\u03C3\u03C4\u03B5 \u03C4\u03BF \u03A0\u03C1\u03BF\u03C3\u03C9\u03C0\u03B9\u03BA\u03CC \u03C3\u03B1\u03C2","instruction_4_subtitle":"\u03A7\u03C1\u03B7\u03C3\u03B9\u03BC\u03BF\u03C0\u03BF\u03B9\u03CE\u03BD\u03C4\u03B1\u03C2 \u03C4\u03BF\u03BD \u03C0\u03AF\u03BD\u03B1\u03BA\u03B1 \u03B5\u03BB\u03AD\u03B3\u03C7\u03BF\u03C5 \u03C3\u03C5\u03BD\u03B5\u03C1\u03B3\u03B1\u03C4\u03CE\u03BD \u03BC\u03B1\u03C2"},"qr_scan":{"invalid_qr_code_provided":"\u039C\u03B7 \u03AD\u03B3\u03BA\u03C5\u03C1\u03BF QR Code. \u03A0\u03B1\u03C1\u03B1\u03BA\u03B1\u03BB\u03BF\u03CD\u03BC\u03B5, \u03B4\u03CE\u03C3\u03C4\u03B5 \u03B1\u03C5\u03C4\u03CC \u03C0\u03BF\u03C5 \u03C3\u03B1\u03C2 \u03AD\u03B4\u03C9\u03C3\u03B5 \u03AD\u03BD\u03B1\u03C2 Ogrammer","camera_permission_required":"\u0391\u03C0\u03B1\u03B9\u03C4\u03B5\u03AF\u03C4\u03B1\u03B9 \u03A0\u03C1\u03CC\u03C3\u03B2\u03B1\u03C3\u03B7 \u03C3\u03C4\u03B7\u03BD \u039A\u03AC\u03BC\u03B5\u03C1\u03B1","access_denied":"\u0394\u03B5\u03BD \u03B5\u03C0\u03B9\u03C4\u03C1\u03AC\u03C0\u03B7\u03BA\u03B5 \u03C0\u03C1\u03CC\u03C3\u03B2\u03B1\u03C3\u03B7 \u03C3\u03C4\u03B7\u03BD \u03BA\u03AC\u03BC\u03B5\u03C1\u03B1.","enable_permission":"\u0393\u03B9\u03B1 \u03BD\u03B1 \u03C3\u03B1\u03C1\u03CE\u03C3\u03B5\u03C4\u03B5 \u03C4\u03BF QR code, \u03C0\u03B1\u03C1\u03B1\u03BA\u03B1\u03BB\u03BF\u03CD\u03BC\u03B5 \u03B5\u03BD\u03B5\u03C1\u03B3\u03BF\u03C0\u03BF\u03B9\u03AE\u03C3\u03C4\u03B5 \u03C4\u03B7\u03BD \u03AC\u03B4\u03B5\u03B9\u03B1 \u03C0\u03C1\u03CC\u03C3\u03B2\u03B1\u03C3\u03B7\u03C2 \u03C3\u03C4\u03B7\u03BD \u03BA\u03AC\u03BC\u03B5\u03C1\u03B1 \u03AE, \u03B5\u03BD\u03B1\u03BB\u03BB\u03B1\u03BA\u03C4\u03B9\u03BA\u03AC, \u03C7\u03C1\u03B7\u03C3\u03B9\u03BC\u03BF\u03C0\u03BF\u03B9\u03AE\u03C3\u03C4\u03B5 \u03C4\u03B7\u03BD \u03BA\u03AC\u03BC\u03B5\u03C1\u03B1 \u03C4\u03BF\u03C5 \u03BA\u03B9\u03BD\u03B7\u03C4\u03BF\u03CD \u03C3\u03B1\u03C2.","instruction_title":"\u03A0\u03BF\u03B9\u03B1 \u03B5\u03AF\u03BD\u03B1\u03B9 \u03B7 \u03B4\u03B9\u03B1\u03B4\u03B9\u03BA\u03B1\u03C3\u03AF\u03B1;","step_1":"\u0392\u03AE\u03BC\u03B1 \u03A0\u03C1\u03CE\u03C4\u03BF","to_scan":"\u03A3\u03BA\u03B1\u03BD\u03AC\u03C1\u03B5\u03C4\u03B5","step_1_text":"\u03A3\u03BA\u03B1\u03BD\u03AC\u03C1\u03B5\u03C4\u03B5 \u03C4\u03BF\u03BD \u03BA\u03C9\u03B4\u03B9\u03BA\u03CC \u03C0\u03BF\u03C5 \u03B8\u03B1 \u03C3\u03B1\u03C2 \u03B4\u03CE\u03C3\u03B5\u03B9 \u03BF OG.","step_2":"\u0392\u03AE\u03BC\u03B1 \u0394\u03B5\u03CD\u03C4\u03B5\u03C1\u03BF","check_in_or_out":"\u0394\u03B7\u03BB\u03CE\u03C3\u03C4\u03B5 \u0386\u03C6\u03B9\u03BE\u03B7 \u03BA\u03B1\u03B9 \u0391\u03C0\u03BF\u03C7\u03CE\u03C1\u03B7\u03C3\u03B7","step_2_text":"\u039A\u03B1\u03C4\u03B1\u03B3\u03C1\u03AC\u03C8\u03C4\u03B5 \u03C4\u03B7\u03BD \u03AC\u03C6\u03B9\u03BE\u03B7 \u03AE \u03C4\u03B7\u03BD \u03B1\u03C0\u03BF\u03C7\u03CE\u03C1\u03B7\u03C3\u03AE \u03C4\u03BF\u03C5\u03C2 \u03BA\u03B1\u03B9 \u03B4\u03B5\u03AF\u03C4\u03B5 \u03C4\u03B9\u03C2 \u03BB\u03B5\u03C0\u03C4\u03BF\u03BC\u03AD\u03C1\u03B5\u03B9\u03B5\u03C2 \u03C4\u03B7\u03C2 \u03B8\u03AD\u03C3\u03B7\u03C2 \u03B5\u03C1\u03B3\u03B1\u03C3\u03AF\u03B1\u03C2.","sp_id_form_title":"\u0391\u03BD \u03C4\u03BF QR code \u03B4\u03B5\u03BD \u03BB\u03B5\u03B9\u03C4\u03BF\u03C5\u03C1\u03B3\u03B5\u03AF, \u03C0\u03B1\u03C1\u03B1\u03BA\u03B1\u03BB\u03BF\u03CD\u03BC\u03B5 \u03B5\u03B9\u03C3\u03AC\u03B3\u03B5\u03C4\u03B5 \u03C4\u03BF OG ID","sp_id_label":"\u0395\u03B9\u03C3\u03AC\u03B3\u03B5\u03C4\u03B5 OG ID","scan_qr":"\u03A3\u03BA\u03B1\u03BD\u03AC\u03C1\u03B5\u03C4\u03B5 QR","sp_cant_be_checked_in_or_out":"\u0394\u03B5\u03BD \u03BC\u03C0\u03BF\u03C1\u03B5\u03AF \u03BD\u03B1 \u03B4\u03B7\u03BB\u03C9\u03B8\u03B5\u03AF \u03CE\u03C1\u03B1 \u03AC\u03C6\u03B9\u03BE\u03B7\u03C2 \u03BA\u03B1\u03B9 \u03B1\u03C0\u03BF\u03C7\u03CE\u03C1\u03B7\u03C3\u03B7\u03C2 \u03B3\u03B9\u03B1 \u03B1\u03C5\u03C4\u03CC\u03BD \u03C4\u03BF\u03BD OG","qr":"QR","scan_next_qr":"\u03A3\u03BA\u03B1\u03BD\u03AC\u03C1\u03B5\u03C4\u03B5 \u0386\u03BB\u03BB\u03BF QR","success_modal_text":"\u0397 \u03B4\u03B9\u03B1\u03B4\u03B9\u03BA\u03B1\u03C3\u03AF\u03B1 {{processTitle}} \u03BF\u03BB\u03BF\u03BA\u03BB\u03B7\u03C1\u03CE\u03B8\u03B7\u03BA\u03B5 \u03BC\u03B5 \u03B5\u03C0\u03B9\u03C4\u03C5\u03C7\u03AF\u03B1.","carousel_title":"\u0394\u03B7\u03BB\u03CE\u03C3\u03C4\u03B5 \u03C4\u03B7\u03BD \u03AC\u03C6\u03B9\u03BE\u03B7 \u03BA\u03B1\u03B9 \u03C4\u03B7\u03BD \u03B1\u03C0\u03BF\u03C7\u03CE\u03C1\u03B7\u03C3\u03B7 \u03C4\u03BF\u03C5 \u03C0\u03C1\u03BF\u03C3\u03C9\u03C0\u03B9\u03BA\u03BF\u03CD \u03C7\u03C1\u03B7\u03C3\u03B9\u03BC\u03BF\u03C0\u03BF\u03B9\u03CE\u03BD\u03C4\u03B1\u03C2 \u03C4\u03BF QR code","sp_id_form_title_1":"*\u0394\u03B5\u03BD \u03B4\u03BF\u03C5\u03BB\u03B5\u03CD\u03B5\u03B9 \u03C4\u03BF QR code;","sp_id_form_title_2":"\u03A3\u03C5\u03BC\u03C0\u03BB\u03B7\u03C1\u03CE\u03C3\u03C4\u03B5 \u03C4\u03BF OG ID \u03C0\u03B1\u03C1\u03B1\u03BA\u03AC\u03C4\u03C9","camera_missing_title":"\u0397 \u03BA\u03AC\u03BC\u03B5\u03C1\u03AC \u03C3\u03B1\u03C2 \u03B4\u03B5\u03BD \u03B5\u03AF\u03BD\u03B1\u03B9 \u03C3\u03C5\u03BC\u03B2\u03B1\u03C4\u03AE \u03BC\u03B5 \u03C4\u03BF\u03BD \u03C4\u03C1\u03AD\u03C7\u03BF\u03BD\u03C4\u03B1 browser.","camera_missing_description":" \u03A0\u03B1\u03C1\u03B1\u03BA\u03B1\u03BB\u03CE \u03B4\u03BF\u03BA\u03B9\u03BC\u03AC\u03C3\u03C4\u03B5 \u03C4\u03B7\u03BD \u03BA\u03AC\u03BC\u03B5\u03C1\u03B1 \u03C4\u03BF\u03C5 \u03BA\u03B9\u03BD\u03B7\u03C4\u03BF\u03CD \u03C3\u03B1\u03C2 \u03B1\u03BD\u03C4\u03AF \u03B3\u03B9\' \u03B1\u03C5\u03C4\u03CC \uD83D\uDCF8\uD83D\uDCF1","set_default_time":"\u039F\u03C1\u03B9\u03C3\u03BC\u03CC\u03C2 \u03A0\u03C1\u03BF\u03B5\u03C0\u03B9\u03BB\u03BF\u03B3\u03AE\u03C2"},"staff":{"past_workers":"\u03A0\u03B1\u03BB\u03B9\u03BF\u03AF \u0395\u03C1\u03B3\u03B1\u03B6\u03CC\u03BC\u03B5\u03BD\u03BF\u03B9","hours_worked":"\u038F\u03C1\u03B5\u03C2 \u0395\u03C1\u03B3\u03B1\u03C3\u03AF\u03B1\u03C2","n_hours":"{{hoursAmount}} \u038F\u03C1\u03B5\u03C2","n_shifts":"{{shiftsAmount}} \u0392\u03AC\u03C1\u03B4\u03B9\u03B5\u03C2","last_job":"\u03A0\u03C1\u03BF\u03B7\u03B3\u03BF\u03CD\u03BC\u03B5\u03BD\u03B7 \u0394\u03BF\u03C5\u03BB\u03B5\u03B9\u03AC","locations_worked":"\u03A4\u03BF\u03C0\u03BF\u03B8\u03B5\u03C3\u03AF\u03B5\u03C2 \u03C0\u03BF\u03C5 \u03AD\u03C7\u03B5\u03B9 \u03B5\u03C1\u03B3\u03B1\u03C3\u03C4\u03B5\u03AF","plus_n_locations":"+ {{locationsAmount}} \u03A4\u03BF\u03C0\u03BF\u03B8\u03B5\u03C3\u03AF\u03B5\u03C2","enter_notes_on_worker":"\u039A\u03C1\u03B1\u03C4\u03AE\u03C3\u03C4\u03B5 \u03C3\u03B7\u03BC\u03B5\u03B9\u03CE\u03C3\u03B5\u03B9\u03C2 \u03B3\u03B9\u03B1 \u03C4\u03BF\u03BD \u03B5\u03C1\u03B3\u03B1\u03B6\u03CC\u03BC\u03B5\u03BD\u03BF","favorite_only":"\u039C\u03CC\u03BD\u03BF \u0391\u03B3\u03B1\u03C0\u03B7\u03BC\u03AD\u03BD\u03BF\u03B9","apply":"\u0395\u03C6\u03B1\u03C1\u03BC\u03BF\u03B3\u03AE","reset":"Reset","how_was_the_worker":"\u03A0\u03C9\u03C2 \u03AE\u03C4\u03B1\u03BD \u03BF OG?","rating_submitted":"\u0397 \u03B2\u03B1\u03B8\u03BC\u03BF\u03BB\u03BF\u03B3\u03AF\u03B1 \u03BA\u03B1\u03C4\u03B1\u03C7\u03C9\u03C1\u03AE\u03B8\u03B7\u03BA\u03B5!","search_worker_by_id_or_name":"\u0391\u03BD\u03B1\u03B6\u03B7\u03C4\u03AE\u03C3\u03C4\u03B5 \u03B5\u03C1\u03B3\u03B1\u03B6\u03CC\u03BC\u03B5\u03BD\u03BF \u03BC\u03B5 \u03C4\u03BF ID \u03AE \u03C4\u03BF \u03CC\u03BD\u03BF\u03BC\u03B1","worker_name":"\u038C\u03BD\u03BF\u03BC\u03B1 \u0395\u03C1\u03B3\u03B1\u03B6\u03CC\u03BC\u03B5\u03BD\u03BF\u03C5","designations":"\u0395\u03B9\u03B4\u03B9\u03BA\u03CC\u03C4\u03B7\u03C4\u03B5\u03C2","your_rating":"\u0397 \u03B2\u03B1\u03B8\u03BC\u03BF\u03BB\u03BF\u03B3\u03AF\u03B1 \u03C3\u03B1\u03C2","notes":"Notes","no_workers_found":"\u0394\u03B5\u03BD \u03B2\u03C1\u03AD\u03B8\u03B7\u03BA\u03B1\u03BD \u03B5\u03C1\u03B3\u03B1\u03B6\u03CC\u03BC\u03B5\u03BD\u03BF\u03B9","note_validation_length":"\u039F\u03B9 \u03C3\u03B7\u03BC\u03B5\u03B9\u03CE\u03C3\u03B5\u03B9\u03C2 \u03B4\u03B5\u03BD \u03BC\u03C0\u03BF\u03C1\u03BF\u03CD\u03BD \u03BD\u03B1 \u03BE\u03B5\u03C0\u03B5\u03C1\u03BD\u03BF\u03CD\u03BD \u03C4\u03BF\u03C5\u03C2 499 \u03C7\u03B1\u03C1\u03B1\u03BA\u03C4\u03AE\u03C1\u03B5\u03C2","n_more":"{{ amount }} \u03B1\u03BA\u03CC\u03BC\u03B1","last_designation":"\u03A4\u03B5\u03BB\u03B5\u03C5\u03C4\u03B1\u03AF\u03B1 \u0395\u03B9\u03B4\u03B9\u03BA\u03CC\u03C4\u03B7\u03C4\u03B1","shifts_worked":"\u0394\u03B5\u03B4\u03BF\u03C5\u03BB\u03B5\u03C5\u03BC\u03AD\u03BD\u03B5\u03C2 \u0392\u03AC\u03C1\u03B4\u03B9\u03B5\u03C2","last_location":"\u03A4\u03B5\u03BB\u03B5\u03C5\u03C4\u03B1\u03AF\u03B1 \u03A4\u03BF\u03C0\u03BF\u03B8\u03B5\u03C3\u03AF\u03B1"},"invited_sps":{"quantity_must_not_be_greater":"\u039C\u03C0\u03BF\u03C1\u03B5\u03AF\u03C4\u03B5 \u03BD\u03B1 \u03C3\u03C4\u03B5\u03AF\u03BB\u03B5\u03C4\u03B5 \u03AD\u03C9\u03C2 3 \u03C0\u03C1\u03BF\u03C3\u03BA\u03BB\u03AE\u03C3\u03B5\u03B9\u03C2 \u03B1\u03BD\u03AC \u03B1\u03BD\u03BF\u03B9\u03C7\u03C4\u03AE \u03B8\u03AD\u03C3\u03B7 \u03B5\u03C1\u03B3\u03B1\u03C3\u03AF\u03B1\u03C2. \u0391\u03BD \u03B8\u03AD\u03BB\u03B5\u03C4\u03B5 \u03BD\u03B1 \u03C0\u03C1\u03BF\u03C3\u03BA\u03B1\u03BB\u03AD\u03C3\u03B5\u03C4\u03B5 \u03C0\u03B5\u03C1\u03B9\u03C3\u03C3\u03CC\u03C4\u03B5\u03C1\u03BF\u03C5\u03C2 OGs, \u03B1\u03C5\u03BE\u03AE\u03C3\u03C4\u03B5 \u03C4\u03B7\u03BD \u03B1\u03C0\u03B1\u03B9\u03C4\u03BF\u03CD\u03BC\u03B5\u03BD\u03B7 \u03C0\u03BF\u03C3\u03CC\u03C4\u03B7\u03C4\u03B1 \u03B8\u03AD\u03C3\u03B5\u03C9\u03BD \u03B5\u03C1\u03B3\u03B1\u03C3\u03AF\u03B1\u03C2","form_title":"\u0398\u03B1 \u03B8\u03AD\u03BB\u03B1\u03C4\u03B5 \u03BD\u03B1 \u03C0\u03C1\u03BF\u03C3\u03BA\u03B1\u03BB\u03AD\u03C3\u03B5\u03C4\u03B5 \u03C4\u03BF\u03C5\u03C2 \u03C0\u03C1\u03BF\u03B7\u03B3\u03BF\u03CD\u03BC\u03B5\u03BD\u03BF\u03C5\u03C2 Ogrammers \u03C3\u03B1\u03C2;","form_subtitle":"\u0391\u03C5\u03C4\u03CC \u03C4\u03BF \u03B2\u03AE\u03BC\u03B1 \u03B5\u03AF\u03BD\u03B1\u03B9 \u03C0\u03C1\u03BF\u03B1\u03B9\u03C1\u03B5\u03C4\u03B9\u03BA\u03CC. \u0391\u03BD \u03C0\u03C1\u03BF\u03C3\u03BA\u03B1\u03BB\u03AD\u03C3\u03B5\u03C4\u03B5 \u03BB\u03B9\u03B3\u03CC\u03C4\u03B5\u03C1\u03BF\u03C5\u03C2 Ogrammers \u03B1\u03C0\u03CC \u03CC\u03C3\u03BF\u03C5\u03C2 \u03C7\u03C1\u03B5\u03B9\u03AC\u03B6\u03B5\u03C3\u03C4\u03B5, \u03B7 Ogram \u03B8\u03B1 \u03BA\u03B1\u03BB\u03CD\u03C8\u03B5\u03B9 \u03C4\u03B9\u03C2 \u03C5\u03C0\u03CC\u03BB\u03BF\u03B9\u03C0\u03B5\u03C2 \u03B8\u03AD\u03C3\u03B5\u03B9\u03C2","select_required_data":"\u03A0\u03B1\u03C1\u03B1\u03BA\u03B1\u03BB\u03BF\u03CD\u03BC\u03B5 \u03B5\u03C0\u03B9\u03BB\u03AD\u03BE\u03C4\u03B5 \u03C0\u03C1\u03CE\u03C4\u03B1 \u03C0\u03BF\u03C3\u03CC\u03C4\u03B7\u03C4\u03B1, \u03C4\u03BF\u03C0\u03BF\u03B8\u03B5\u03C3\u03AF\u03B1, \u03B8\u03AD\u03C3\u03B7 \u03BA\u03B1\u03B9 \u03C0\u03C1\u03CC\u03B3\u03C1\u03B1\u03BC\u03BC\u03B1","invited_sps":"\u03A0\u03C1\u03BF\u03C4\u03B9\u03BC\u03CE\u03BC\u03B5\u03BD\u03BF\u03B9 Ogrammers","worked_at_current_location":"\u0388\u03C7\u03B5\u03B9 \u03B5\u03C1\u03B3\u03B1\u03C3\u03C4\u03B5\u03AF \u03C3\u03C4\u03B7\u03BD \u03C4\u03C1\u03AD\u03C7\u03BF\u03C5\u03C3\u03B1 \u03C4\u03BF\u03C0\u03BF\u03B8\u03B5\u03C3\u03AF\u03B1"},"pagination":{"page":"Page","of":"of"},"rating_popup":{"title":"\u03A0\u03B1\u03C1\u03B1\u03BA\u03B1\u03BB\u03CE \u03B1\u03BE\u03B9\u03BF\u03BB\u03BF\u03B3\u03AE\u03C3\u03C4\u03B5 \u03C4\u03B7\u03BD \u03B5\u03BC\u03C0\u03B5\u03B9\u03C1\u03AF\u03B1 \u03C3\u03B1\u03C2 \u03BC\u03B5 \u03C4\u03BF\u03C5\u03C2 Ogrammers","subtitle_1":"\u0394\u03AF\u03BD\u03BF\u03C5\u03BC\u03B5 \u03C0\u03C1\u03BF\u03C4\u03B5\u03C1\u03B1\u03B9\u03CC\u03C4\u03B7\u03C4\u03B1 \u03C3\u03C4\u03BF\u03C5\u03C2 \u03B5\u03C1\u03B3\u03B1\u03B6\u03BF\u03BC\u03AD\u03BD\u03BF\u03C5\u03C2 \u03BC\u03B5 \u03C4\u03B9\u03C2 \u03BA\u03B1\u03BB\u03CD\u03C4\u03B5\u03C1\u03B5\u03C2 \u03B1\u03BE\u03B9\u03BF\u03BB\u03BF\u03B3\u03AE\u03C3\u03B5\u03B9\u03C2 \u03B3\u03B9\u03B1 \u03C4\u03B9\u03C2 \u03BC\u03B5\u03BB\u03BB\u03BF\u03BD\u03C4\u03B9\u03BA\u03AD\u03C2 \u03C3\u03B1\u03C2 \u03B8\u03AD\u03C3\u03B5\u03B9\u03C2 \u03B5\u03C1\u03B3\u03B1\u03C3\u03AF\u03B1\u03C2. ","subtitle_2":"\u039F\u03B9 \u03B1\u03BE\u03B9\u03BF\u03BB\u03BF\u03B3\u03AE\u03C3\u03B5\u03B9\u03C2 \u03C3\u03B1\u03C2 \u03BC\u03B1\u03C2 \u03B2\u03BF\u03B7\u03B8\u03BF\u03CD\u03BD \u03BD\u03B1 \u03B4\u03AF\u03BD\u03BF\u03C5\u03BC\u03B5 \u03C0\u03C1\u03BF\u03C4\u03B5\u03C1\u03B1\u03B9\u03CC\u03C4\u03B7\u03C4\u03B1 \u03C3\u03C4\u03BF\u03C5\u03C2 \u03BA\u03B1\u03BB\u03CD\u03C4\u03B5\u03C1\u03BF\u03C5\u03C2 \u03B5\u03C1\u03B3\u03B1\u03B6\u03BF\u03BC\u03AD\u03BD\u03BF\u03C5\u03C2, \u03B5\u03BE\u03B1\u03C3\u03C6\u03B1\u03BB\u03AF\u03B6\u03BF\u03BD\u03C4\u03B1\u03C2 \u03CC\u03C4\u03B9 \u03B8\u03B1 \u03BB\u03B1\u03BC\u03B2\u03AC\u03BD\u03B5\u03C4\u03B5 \u03C4\u03B7\u03BD \u03BA\u03B1\u03BB\u03CD\u03C4\u03B5\u03C1\u03B7 \u03B5\u03BE\u03C5\u03C0\u03B7\u03C1\u03AD\u03C4\u03B7\u03C3\u03B7 \u03BA\u03AC\u03B8\u03B5 \u03C6\u03BF\u03C1\u03AC","ogs_to_rate":"OGs \u03C0\u03C1\u03BF\u03C2 \u0391\u03BE\u03B9\u03BF\u03BB\u03CC\u03B3\u03B7\u03C3\u03B7","will_be_prioritized":"\u0391\u03C5\u03C4\u03CC\u03C2 \u03BF OG \u03B8\u03B1 \u03AD\u03C7\u03B5\u03B9 \u03C0\u03C1\u03BF\u03C4\u03B5\u03C1\u03B1\u03B9\u03CC\u03C4\u03B7\u03C4\u03B1 \u03B3\u03B9\u03B1 \u03B5\u03C3\u03AC\u03C2","will_not_be_assigned":"\u0391\u03C5\u03C4\u03CC\u03C2 \u03BF OG \u03B4\u03B5\u03BD \u03B8\u03B1 \u03B1\u03BD\u03B1\u03BB\u03AC\u03B2\u03B5\u03B9 \u03AC\u03BB\u03BB\u03B7 \u03B2\u03AC\u03C1\u03B4\u03B9\u03B1."},"disputes":{"overtime":"Overtime","no_show":"No-show","og_attendance":"OG attendance","check_in":"Check In","check_out":"Check Out","total_hours":"Total Hours","n_hours":"{{ count }} hours","your_attendance":"Your attendance","og_claims_n_hours_more":"OG claims they worked {{ count }} hours more","og_claims_show_up":"You cancelled the shift, but OG claims they did work","og_comment":"\u03A3\u03C7\u03CC\u03BB\u03B9\u03BF OG","view_attached_file":"\u03A0\u03C1\u03BF\u03B2\u03BF\u03BB\u03AE \u03C3\u03C5\u03BD\u03B7\u03BC\u03BC\u03AD\u03BD\u03BF\u03C5 \u03B1\u03C1\u03C7\u03B5\u03AF\u03BF\u03C5","are_you_sure_to_agree":"Are you sure you want to agree with the OG?","dispute_resolved":"Dispute resolved successfully","i_agree":"I agree with the OG","are_you_sure_to_decline":"Are you sure you want to decline the OG dispute?","dispute_declined":"Dispute declined successfully","i_dont_agree":"I don\'t agree"}}');


var $2ffde788e1a5e27e$exports = {};
$2ffde788e1a5e27e$exports = JSON.parse('{"common":{"ogram":"Ogram","start_now":"\u0627\u0628\u062F\u0623 \u0627\u0644\u0622\u0646","dismiss":"\u062A\u062E\u0637\u0649","continue":"\u0627\u0643\u0645\u0644","text_copied":"\u062A\u0645 \u0646\u0633\u062E \u0627\u0644\u0646\u0635 \u0625\u0644\u0649 \u0627\u0644\u062D\u0627\u0641\u0638\u0629","tc":"\u0627\u0644\u0634\u0631\u0648\u0637 \u0648 \u0627\u0644\u0623\u062D\u0643\u0627\u0645","shifts":"\u0645\u0646\u0627\u0648\u0628\u0627\u062A","show_more":"\u0639\u0631\u0636 \u0627\u0644\u0645\u0632\u064A\u062F","ogs":"\u0645\u0648\u0638\u0641\u064A \u0623\u0648\u063A\u0631\u0627\u0645","i_accept_terms":"\u0627\u0646\u0627 \u0627\u0648\u0627\u0641\u0642 \u0639\u0644\u0649 <1>\u0634\u0631\u0648\u0637 \u0627\u0644\u062E\u062F\u0645\u0629</1>","i_accept":"\u0627\u0646\u0627 \u0627\u0648\u0627\u0641\u0642 \u0639\u0644\u0649","terms_of_service":"\u0634\u0631\u0648\u0637 \u0627\u0644\u062E\u062F\u0645\u0629","yes":"\u0646\u0639\u0645","no":"\u0644\u0627","id_n":"\u0631\u0642\u0645 \u0627\u0644\u062A\u0639\u0631\u064A\u0641\u064A#{{id}}","loading":"\u064A\u062A\u0645 \u0627\u0644\u062A\u062D\u0645\u064A\u0644...","app_version":"\u0625\u0635\u062F\u0627\u0631 \u0627\u0644\u062A\u0637\u0628\u064A\u0642: {{version}}","select":"\u0627\u062E\u062A\u0627\u0631","job_n":"\u0648\u0638\u064A\u0641\u0629 #{{id}}","filters":"\u062A\u0635\u0641\u064A\u0629","filter":"\u062A\u0635\u0641\u064A\u0629","location":"\u0627\u0644\u0645\u0648\u0642\u0639","designation":"\u0646\u0648\u0639 \u0627\u0644\u0648\u0638\u064A\u0641\u0629","change":"\u062A\u063A\u064A\u064A\u0631","cancel":"\u0625\u0644\u063A\u0627\u0621","order_id":"\u0631\u0642\u0645 \u0627\u0644\u0637\u0644\u0628","is_overdue":"\u062A\u062C\u0627\u0648\u0632 \u062A\u0627\u0631\u064A\u062E \u0627\u0644\u0627\u0633\u062A\u062D\u0642\u0627\u0642","date_from":"\u0627\u0644\u062A\u0627\u0631\u064A\u062E \u0645\u0646","date_to":"\u0627\u0644\u062A\u0627\u0631\u064A\u062E \u0625\u0644\u0649","now":"\u0627\u0644\u0622\u0646","no_data_found":"\u0644\u0645 \u064A\u062A\u0645 \u0627\u0644\u0639\u062B\u0648\u0631 \u0639\u0644\u0649 \u0628\u064A\u0627\u0646\u0627\u062A","not_available":"\u063A\u064A\u0631 \u0645\u062A\u0648\u0641\u0631","clear":"\u0645\u0633\u062D","done":"\u062A\u0645","optional":"Optional","industry":"Industry","employees_amount_tier":"How many employees does your company have?","n_selected":"{{count}} Selected","ended_at":"Ended at {{date}}"},"password":{"minimumChars":"6+ \u0623\u062D\u0631\u0641","oneLowercase":"\u062D\u0631\u0641 \u0635\u063A\u064A\u0631","oneNumber":"\u0631\u0642\u0645 \u0648\u0627\u062D\u062F","oneUppercase":"\u062D\u0631\u0641 \u0643\u0628\u064A\u0631"},"login":{"good_to_see_you_back":"\u064A\u0633\u0639\u062F\u0646\u0627 \u0631\u0624\u064A\u062A\u0643 \u0645\u0631\u0629 \u0623\u062E\u0631\u0649","sign_in_to_account":"\u064A\u0631\u062C\u0649 \u062A\u0633\u062C\u064A\u0644 \u0627\u0644\u062F\u062E\u0648\u0644 \u0625\u0644\u0649 \u062D\u0633\u0627\u0628\u0643","enter_email":"\u0627\u0644\u0631\u062C\u0627\u0621 \u0625\u062F\u062E\u0627\u0644 \u0628\u0631\u064A\u062F\u0643 \u0627\u0644\u0625\u0644\u0643\u062A\u0631\u0648\u0646\u064A","enter_password":"\u0627\u0644\u0631\u062C\u0627\u0621 \u0625\u062F\u062E\u0627\u0644 \u0643\u0644\u0645\u0629 \u0627\u0644\u0645\u0631\u0648\u0631","email":"\u0628\u0631\u064A\u062F \u0625\u0644\u0643\u062A\u0631\u0648\u0646\u064A","password":"\u0643\u0644\u0645\u0629 \u0627\u0644\u0645\u0631\u0648\u0631","remember_me":"\u062A\u0630\u0643\u0631\u0646\u064A","forgot_password_question":"\u0646\u0633\u064A\u062A \u0643\u0644\u0645\u0629 \u0627\u0644\u0645\u0631\u0648\u0631\u061F","sign_in":"\u062A\u0633\u062C\u064A\u0644 \u0627\u0644\u062F\u062E\u0648\u0644","signin_in":"\u064A\u062A\u0645 \u062A\u0633\u062C\u064A\u0644 \u062F\u062E\u0648\u0644\u0643...","sign_up_link_text":"\u062A\u0633\u062C\u064A\u0644 \u0627\u0644\u062F\u062E\u0648\u0644","test_string":"\u0627\u062E\u062A\u0628\u0627\u0631 \u0627\u0644\u0646\u0638\u0627\u0645"},"create_password":{"title":"\u0625\u0646\u0634\u0627\u0621 \u0643\u0644\u0645\u0629 \u0645\u0631\u0648\u0631","description":"\u0627\u0644\u0631\u062C\u0627\u0621 \u0645\u0646\u0643 \u0625\u0646\u0634\u0627\u0621 \u0643\u0644\u0645\u0629 \u0627\u0644\u0645\u0631\u0648\u0631 \u0644\u062A\u0633\u062A\u0637\u064A\u0639 \u0645\u0646 \u062A\u0633\u062C\u064A\u0644 \u0627\u0644\u062F\u062E\u0648\u0644 \u0628\u0633\u062A\u062E\u062F\u0627\u0645 \u0628\u0631\u064A\u062F\u0643 \u0627\u0644\u0625\u0644\u0643\u062A\u0631\u0648\u0646\u064A \u0641\u064A \u0627\u0644\u0645\u0631\u0629 \u0627\u0644\u0642\u0627\u062F\u0645\u0629","please_enter_password":"\u0627\u0644\u0631\u062C\u0627\u0621 \u0625\u062F\u062E\u0627\u0644 \u0643\u0644\u0645\u0629 \u0627\u0644\u0645\u0631\u0648\u0631","please_confirm_password":"\u0627\u0644\u0631\u062C\u0627\u0621 \u062A\u0623\u0643\u064A\u062F \u0643\u0644\u0645\u0629 \u0627\u0644\u0645\u0631\u0648\u0631","confirm_password":"\u062A\u0623\u0643\u064A\u062F \u0643\u0644\u0645\u0629 \u0627\u0644\u0645\u0631\u0648\u0631","password":"\u0643\u0644\u0645\u0629 \u0627\u0644\u0645\u0631\u0648\u0631","password_matched":"\u062A\u0645 \u062A\u0637\u0627\u0628\u0642 \u0643\u0644\u0645\u0629 \u0627\u0644\u0645\u0631\u0648\u0631","password_not_matched":"\u0644\u0645 \u062A\u0637\u0627\u0628\u0642 \u0643\u0644\u0645\u0629 \u0627\u0644\u0645\u0631\u0648\u0631","resend_modal_button":"\u0625\u0639\u0627\u062F\u0629 \u0627\u0644\u0625\u0631\u0633\u0627\u0644 \u0644\u0644\u0628\u0631\u064A\u062F \u0627\u0644\u0625\u0644\u0643\u062A\u0631\u0648\u0646\u064A","sending":"\u064A\u062A\u0645 \u0627\u0644\u0625\u0631\u0633\u0627\u0644...","email_invalid":"\u0628\u0631\u064A\u062F\u0643 \u0627\u0644\u0625\u0644\u0643\u062A\u0631\u0648\u0646\u064A \u063A\u064A\u0631 \u0635\u0627\u0644\u062D","email_required":"\u064A\u0631\u062C\u0649 \u062A\u0648\u0641\u064A\u0631 \u0628\u0631\u064A\u062F\u0643 \u0627\u0644\u0625\u0644\u0643\u062A\u0631\u0648\u0646\u064A","email":"\u0628\u0631\u064A\u062F \u0625\u0644\u0643\u062A\u0631\u0648\u0646\u064A","email_is_sent":"\u0644\u0642\u062F \u062A\u0645 \u0625\u0631\u0633\u0627\u0644 \u0631\u0627\u0628\u0637 \u062C\u062F\u064A\u062F \u0625\u0644\u0649 \u0628\u0631\u064A\u062F\u0643 \u0627\u0644\u0625\u0644\u0643\u062A\u0631\u0648\u0646\u064A.","submit":"\u062A\u0642\u062F\u064A\u0645"},"forgot_password":{"title":"\u0646\u0633\u064A\u062A \u0643\u0644\u0645\u0629 \u0627\u0644\u0645\u0631\u0648\u0631\u061F","description":"\u0623\u062F\u062E\u0644 \u0628\u0631\u064A\u062F\u0643 \u0627\u0644\u0625\u0644\u0643\u062A\u0631\u0648\u0646\u064A \u0627\u0644\u0645\u0631\u062A\u0628\u0637 \u0628\u062D\u0633\u0627\u0628\u0643","please_enter_email":"\u0627\u0644\u0631\u062C\u0627\u0621 \u0625\u062F\u062E\u0627\u0644 \u0628\u0631\u064A\u062F\u0643 \u0627\u0644\u0625\u0644\u0643\u062A\u0631\u0648\u0646\u064A","email_must_be_valid":"\u0627\u0644\u0628\u0631\u064A\u062F \u0627\u0644\u0625\u0644\u0643\u062A\u0631\u0648\u0646\u064A \u064A\u062C\u0628 \u0627\u0646 \u064A\u0643\u0648\u0646 \u0635\u0627\u0644\u062D\u0627\u064B","email":"\u0628\u0631\u064A\u062F \u0627\u0644\u0625\u0644\u0643\u062A\u0631\u0648\u0646\u064A","submit":"\u062A\u0642\u062F\u064A\u0645","back_to_sign_in":"\u0627\u0644\u0639\u0648\u062F\u0629 \u0625\u0644\u0649 \u0635\u0641\u062D\u0629 \u062A\u0633\u062C\u064A\u0644 \u0627\u0644\u062F\u062E\u0648\u0644","forgot_password":"\u0646\u0633\u064A\u062A \u0643\u0644\u0645\u0629 \u0627\u0644\u0645\u0631\u0648\u0631","password_sent_to_email":"\u062A\u0645 \u0625\u0631\u0633\u0627\u0644 \u0643\u0644\u0645\u0629 \u0627\u0644\u0645\u0631\u0648\u0631 \u0627\u0644\u062C\u062F\u064A\u062F\u0629 \u0625\u0644\u0649 \u0627\u0644\u0628\u0631\u064A\u062F \u0627\u0644\u0625\u0644\u0643\u062A\u0631\u0648\u0646\u064A.","resend":"\u0625\u0639\u0627\u062F\u0629 \u0627\u0644\u0625\u0631\u0633\u0627\u0644","reset_password":"\u0625\u0639\u0627\u062F\u0629 \u062A\u0639\u064A\u064A\u0646 \u0643\u0644\u0645\u0629 \u0627\u0644\u0645\u0631\u0648\u0631","email_sent":"\u062A\u0645 \u0625\u0631\u0633\u0627\u0644 \u0631\u0627\u0628\u0637 \u0625\u0639\u0627\u062F\u0629 \u062A\u0639\u064A\u064A\u0646 \u0643\u0644\u0645\u0629 \u0627\u0644\u0645\u0631\u0648\u0631 \u0625\u0644\u0649 \u0628\u0631\u064A\u062F\u0643 \u0627\u0644\u0625\u0644\u0643\u062A\u0631\u0648\u0646\u064A"},"validation_messages":{"email_invalid":"\u0628\u0631\u064A\u062F\u0643 \u0627\u0644\u0625\u0644\u0643\u062A\u0631\u0648\u0646\u064A \u063A\u064A\u0631 \u0635\u0627\u0644\u062D"},"reset_password":{"title":"\u0625\u0639\u0627\u062F\u0629 \u062A\u0639\u064A\u064A\u0646 \u0643\u0644\u0645\u0629 \u0627\u0644\u0645\u0631\u0648\u0631","description":"\u0623\u062F\u062E\u0644 \u0643\u0644\u0645\u0629 \u0645\u0631\u0648\u0631 \u0627\u0644\u062C\u062F\u064A\u062F\u0629","please_enter_password":"\u0627\u0644\u0631\u062C\u0627\u0621 \u0625\u062F\u062E\u0644 \u0643\u0644\u0645\u0629 \u0645\u0631\u0648\u0631 \u0627\u0644\u062C\u062F\u064A\u062F\u0629","please_confirm_password":"\u0627\u0644\u0631\u062C\u0627\u0621 \u062A\u0623\u0643\u064A\u062F \u0643\u0644\u0645\u0629 \u0627\u0644\u0645\u0631\u0648\u0631","password":"\u0643\u0644\u0645\u0629 \u0627\u0644\u0645\u0631\u0648\u0631","confirm_password":"\u062A\u0623\u0643\u064A\u062F \u0643\u0644\u0645\u0629 \u0627\u0644\u0645\u0631\u0648\u0631","password_mathched":"\u062A\u0645 \u062A\u0637\u0627\u0628\u0642 \u0643\u0644\u0645\u0629 \u0627\u0644\u0645\u0631\u0648\u0631","password_not_matched":"\u0644\u0645 \u062A\u0637\u0627\u0628\u0642 \u0643\u0644\u0645\u0629 \u0627\u0644\u0645\u0631\u0648\u0631","submit":"\u062A\u0642\u062F\u064A\u0645"},"change_password":{"title":"\u062A\u063A\u064A\u064A\u0631 \u0643\u0644\u0645\u0629 \u0627\u0644\u0645\u0631\u0648\u0631","description":"\u0623\u062F\u062E\u0644 \u0643\u0644\u0645\u0629 \u0645\u0631\u0648\u0631 \u0642\u062F\u064A\u0645\u0629 \u0648 \u062C\u062F\u064A\u062F\u0629","please_enter_old_password":"\u0627\u0644\u0631\u062C\u0627\u0621 \u0625\u062F\u062E\u0627\u0644 \u0643\u0644\u0645\u0629 \u0627\u0644\u0645\u0631\u0648\u0631 \u0627\u0644\u0642\u062F\u064A\u0645\u0629","please_enter_password":"\u0627\u0644\u0631\u062C\u0627\u0621 \u0625\u062F\u062E\u0627\u0644 \u0643\u0644\u0645\u0629 \u0627\u0644\u0645\u0631\u0648\u0631 \u0627\u0644\u062C\u062F\u064A\u062F\u0629","please_confirm_password":"\u0627\u0644\u0631\u062C\u0627\u0621 \u062A\u0623\u0643\u064A\u062F \u0643\u0644\u0645\u0629 \u0627\u0644\u0645\u0631\u0648\u0631 \u0627\u0644\u062C\u062F\u064A\u062F\u0629","old_password":"\u0643\u0644\u0645\u0629 \u0627\u0644\u0645\u0631\u0648\u0631 \u0627\u0644\u0642\u062F\u064A\u0645\u0629","new_password":"\u0643\u0644\u0645\u0629 \u0627\u0644\u0645\u0631\u0648\u0631 \u0627\u0644\u062C\u062F\u064A\u062F\u0629","confirm_new_password":"\u062A\u0623\u0643\u064A\u062F \u0643\u0644\u0645\u0629 \u0627\u0644\u0645\u0631\u0648\u0631 \u0627\u0644\u062C\u062F\u064A\u062F\u0629","password_matched":"\u062A\u0645 \u062A\u0637\u0627\u0628\u0642 \u0643\u0644\u0645\u0629 \u0627\u0644\u0645\u0631\u0648\u0631","password_not_matched":"\u0644\u0645 \u062A\u0637\u0627\u0628\u0642 \u0643\u0644\u0645\u0629 \u0627\u0644\u0645\u0631\u0648\u0631","submit":"\u062A\u0642\u062F\u064A\u0645","password_changed_successfully":"\u0644\u0642\u062F \u062A\u0645 \u062A\u063A\u064A\u064A\u0631 \u0643\u0644\u0645\u0629 \u0627\u0644\u0645\u0631\u0648\u0631 \u0628\u0646\u062C\u0627\u062D"},"sign_up":{"title":"\u062A\u0633\u062C\u064A\u0644 \u0627\u0644\u0639\u0645\u064A\u0644","subtitle":"\u064A\u0631\u062C\u0649 \u0627\u0644\u062A\u0633\u062C\u064A\u0644 \u0644\u062A\u062A\u0645\u0643\u0646 \u0645\u0646 \u0625\u0646\u0634\u0627\u0621 \u0648 \u0627\u0644\u062A\u062D\u0643\u0645 \u0628\u0637\u0644\u0628\u0627\u062A\u0643","sign_up":"\u0627\u0634\u062A\u0631\u0627\u0643","first_name":"\u0627\u0644\u0627\u0633\u0645 \u0627\u0644\u0623\u0648\u0644","last_name":"\u0627\u0633\u0645 \u0627\u0644\u0639\u0627\u0626\u0644\u0629","phone":"\u0631\u0642\u0645 \u0627\u0644\u0647\u0627\u062A\u0641","email":"\u0627\u0644\u0628\u0631\u064A\u062F \u0627\u0644\u0625\u0644\u0643\u062A\u0631\u0648\u0646\u064A","password":"\u0643\u0644\u0645\u0629 \u0627\u0644\u0645\u0631\u0648\u0631","city":"\u0627\u0644\u0645\u062F\u064A\u0646\u0629","company_name_optional":"\u0627\u0633\u0645 \u0627\u0644\u0634\u0631\u0643\u0629 (\u0645\u0637\u0644\u0648\u0628\u0629 \u0644\u0644\u0634\u0631\u0643\u0627\u062A)","company_name":"\u0627\u0633\u0645 \u0627\u0644\u0634\u0631\u0643\u0629","agree_to_emails":"\u0623\u0648\u0627\u0641\u0642 \u0639\u0644\u0649 \u062A\u0644\u0642\u064A \u0625\u0634\u0639\u0627\u0631\u0627\u062A \u062A\u0633\u0648\u064A\u0642\u064A\u0629 \u0645\u0646 \u0623\u0648\u063A\u0631\u0627\u0645","are_you_corporate_question":"\u0647\u0644 \u0627\u0646\u062A \u0634\u0631\u0643\u0629\u061F","back_to_sign_in":"\u0627\u0644\u0639\u0648\u062F\u0629 \u0625\u0644\u0649 \u0635\u0641\u062D\u0629 \u062A\u0633\u062C\u064A\u0644 \u0627\u0644\u062F\u062E\u0648\u0644","first_name_required":"\u0627\u0644\u0631\u062C\u0627\u0621 \u0625\u062F\u062E\u0627\u0644 \u0627\u0633\u0645\u0643 \u0627\u0644\u0623\u0648\u0644","last_name_required":"\u0627\u0644\u0631\u062C\u0627\u0621 \u0625\u062F\u062E\u0627\u0644 \u0627\u0633\u0645 \u0627\u0644\u0639\u0627\u0626\u0644\u0629","industry_required":"Please select your industry","employees_amount_tier_required":"Please select amount of employees","phone_required":"\u0627\u0644\u0631\u062C\u0627\u0621 \u0625\u062F\u062E\u0627\u0644 \u0631\u0642\u0645 \u0647\u0627\u062A\u0641\u0643","email_required":"\u0627\u0644\u0631\u062C\u0627\u0621 \u0625\u062F\u062E\u0627\u0644 \u0628\u0631\u064A\u062F\u0643 \u0627\u0644\u0625\u0644\u0643\u062A\u0631\u0648\u0646\u064A","company_name_required":"\u0627\u0633\u0645 \u0627\u0644\u0634\u0631\u0643\u0629 \u0645\u0637\u0644\u0648\u0628 \u0644\u0645\u0633\u062A\u062E\u062F\u0645\u064A \u0627\u0644\u0634\u0631\u0643\u0627\u062A","city_required":"\u0627\u0644\u0631\u062C\u0627\u0621 \u0625\u062F\u062E\u0627\u0644 \u0645\u062F\u064A\u0646\u062A\u0643","submitting":"\u064A\u062A\u0645 \u0627\u0644\u062A\u0642\u062F\u064A\u0645...","choose_work_category_title":"\u0645\u0627 \u0627\u0644\u0645\u0648\u0638\u0641\u064A\u0646 \u0627\u0644\u0630\u064A\u0646 \u062A\u062D\u062A\u0627\u062C\u0647\u0645\u061F","choose_work_category_subtitle":"\u0627\u062E\u0628\u0631\u0646\u0627 \u0639\u0646 \u0648\u0638\u064A\u0641\u062A\u0643 \u0627\u0644\u0623\u0648\u0644\u0649","create_new_order_title":"\u0627\u0628\u062F\u0623 \u0628\u0627\u0644\u062A\u0648\u0638\u064A\u0641","contact_details_title":"\u0645\u0627\u0647\u064A \u0628\u064A\u0627\u0646\u0627\u062A \u0627\u0644\u0627\u062A\u0635\u0627\u0644 \u0644\u0644\u062A\u0648\u0627\u0635\u0644 \u0645\u0639\u0643\u061F","contact_details_subtitle":"\u0627\u0636\u0641 \u062A\u0641\u0627\u0635\u064A\u0644 \u0627\u0644\u0627\u062A\u0635\u0627\u0644 \u0627\u0644\u062E\u0627\u0635\u0629 \u0628\u0643 \u062D\u062A\u0649 \u0646\u062A\u0645\u0643\u0646 \u0645\u0646 \u0627\u0644\u062A\u0648\u0627\u0635\u0644 \u0645\u0639\u0643","how_to_reach_title":"\u0643\u064A\u0641 \u064A\u0645\u0643\u0646\u0646\u0627 \u0627\u0644\u062A\u0648\u0627\u0635\u0644 \u0645\u0639\u0643\u061F","next":"\u0627\u0644\u062A\u0627\u0644\u064A","phone_invalid":"\u0627\u0644\u0631\u062C\u0627\u0621 \u0643\u062A\u0627\u0628\u0629 \u0631\u0642\u0645 \u0647\u0627\u062A\u0641 \u0635\u0627\u0644\u062D \u0627\u0644\u0627\u0633\u062A\u062E\u062F\u0627\u0645","already_registered":"\u0647\u0644 \u0644\u062F\u064A\u0643 \u062D\u0633\u0627\u0628\u061F","sign_in":"\u062A\u0633\u062C\u064A\u0644 \u0627\u0644\u062F\u062E\u0648\u0644","consent":"\u0628\u0627\u0644\u0636\u063A\u0637 \u0639\u0644\u0649 \u0632\u0631 \\"\u0627\u0644\u0627\u0634\u062A\u0631\u0627\u0643\u060C \u0641\u0625\u0646\u0643 \u062A\u0645\u0646\u062D \u0634\u0631\u0643\u062A\u0646\u0627 \u0627\u0644\u0625\u0630\u0646 \u0628\u0627\u0633\u062A\u062E\u062F\u0627\u0645 \u0645\u0639\u0644\u0648\u0645\u0627\u062A\u0643 \u0627\u0644\u0634\u062E\u0635\u064A\u0629 \u0644\u0625\u0646\u0634\u0627\u0621 \u0627\u0644\u062D\u0633\u0627\u0628 \u0648 \u0645\u0639\u0627\u0644\u062C\u0629 \u0627\u0644\u0637\u0644\u0628\u0627\u062A.","thank_you":"\u0634\u0643\u0631\u0627 \u0644\u0643!"},"verify_email":{"title":"\u062A\u062D\u0642\u0642 \u0645\u0646 \u0628\u0631\u064A\u062F\u0643 \u0627\u0644\u0625\u0644\u0643\u062A\u0631\u0648\u0646\u064A","description":"\u0644\u0642\u062F \u062A\u0645 \u0625\u0631\u0633\u0627\u0644 \u0631\u0645\u0632 \u0627\u0644\u062A\u062D\u0642\u0642 \u0625\u0644\u0649 \u0628\u0631\u064A\u062F\u0643 \u0627\u0644\u0625\u0644\u0643\u062A\u0631\u0648\u0646\u064A","we_sent_code_to_email":"\u062A\u0645 \u0625\u0631\u0633\u0627\u0644 \u0627\u0644\u0631\u0645\u0632 \u0625\u0644\u0649 {{email}}. \u064A\u0631\u062C\u0629 \u0627\u0644\u062A\u062D\u0642\u0642 \u0645\u0646 \u0635\u0646\u062F\u0648\u0642 \u0627\u0644\u0648\u0627\u0631\u062F \u0648\u0625\u062F\u062E\u0627\u0644 \u0631\u0645\u0632 \u0627\u0644\u062A\u062D\u0642\u0642 \u0644\u0625\u0643\u0645\u0627\u0644 \u0625\u0639\u062F\u0627\u062F \u062D\u0633\u0627\u0628\u0643.","please_enter_code":"\u0627\u0644\u0631\u062C\u0627\u0621 \u0625\u062F\u062E\u0627\u0644 \u0627\u0644\u0631\u0645\u0632","verification_code":"\u0631\u0645\u0632 \u0627\u0644\u062A\u062D\u0642\u0642","verify":"\u062A\u0623\u0643\u064A\u062F","did_not_receive_email_question":"\u0644\u0645 \u062A\u0633\u062A\u0644\u0645 \u0639\u0644\u0649 \u0631\u0633\u0627\u0644\u0629 \u0625\u0644\u0649 \u0628\u0631\u064A\u062F\u0643 \u0627\u0644\u0625\u0644\u0643\u062A\u0631\u0648\u0646\u064A\u061F \u0623\u0639\u062F \u0625\u0631\u0633\u0627\u0644 \u0627\u0644\u0631\u0645\u0632 \u062E\u0644\u0627\u0644 3:00 \u062F\u0642\u064A\u0642\u0629","not_your_email_question":"\u0644\u064A\u0633 \u0628\u0631\u064A\u062F\u0643 \u0627\u0644\u0625\u0644\u0643\u062A\u0631\u0648\u0646\u064A\u061F","change_email":"\u062A\u063A\u064A\u064A\u0631 \u0627\u0644\u0628\u0631\u064A\u062F \u0627\u0644\u0625\u0644\u0643\u062A\u0631\u0648\u0646\u064A"},"applicant_details":{"n_shifts_completed":"{{count}} \u200C\u0645\u0646\u0627\u0648\u0628\u0627\u062A \u062A\u0645 \u0625\u0643\u0645\u0627\u0644\u0647\u0627","years_of_experience":"{{count}} \u0633\u0646\u0648\u0627\u062A","information":"\u0645\u0639\u0644\u0648\u0645\u0627\u062A","work_experience":"\u062E\u0628\u0631\u0627\u062A \u0627\u0644\u0639\u0645\u0644","education":"\u0645\u0633\u062A\u0648\u0649 \u0627\u0644\u062A\u0639\u0644\u064A\u0645\u064A","get_next_applicant":"\u0627\u062D\u0635\u0644 \u0639\u0644\u0649 \u0627\u0644\u0639\u0645\u064A\u0644 \u0627\u0644\u062A\u0627\u0644\u064A","in":"\u0641\u064A","chief_og":"\u0631\u0626\u064A\u0633 \u0645\u0648\u0638\u0641\u064A \u0623\u0648\u063A\u0631\u0627\u0645","skills":"\u0627\u0644\u0645\u0647\u0627\u0631\u0627\u062A","added_as_favourite":"\u0623\u0635\u0628\u062D {{spName}} \u0627\u0644\u0622\u0646 \u0636\u0645\u0646 \u0642\u0627\u0626\u0645\u062A\u0646\u0627 \u0627\u0644\u0645\u0641\u0636\u0644\u0629. \u0648\u0633\u0648\u0641 \u0646\u0639\u0637\u064A {{spName}} \u0627\u0644\u0623\u0648\u0644\u0648\u064A\u0629 \u0641\u064A \u062E\u0648\u0627\u0631\u0632\u0645\u064A\u0627\u062A\u0646\u0627 .","chief":"<1>\u0631\u0626\u064A\u0633 \u0639\u0645\u0644\u0627\u0621 \u0623\u0648\u063A\u0631\u0627\u0645</1><2>\u0647\u0645 \u0642\u0627\u062F\u0629 \u0641\u0631\u064A\u0642 \u0630\u0648 \u062E\u0628\u0631\u0629\u060C \u062A\u0645 \u0627\u062E\u062A\u064A\u0627\u0631\u0647\u0645 \u0628\u0639\u0646\u0627\u064A\u0629 \u0645\u0646 \u0627\u062C\u0644 \u062A\u0646\u0633\u064A\u0642 \u0627\u0641\u0631\u0642\u0629 \u0639\u0645\u0627\u0644 \u0623\u0648\u063A\u0631\u0627\u0645 \u0628\u0634\u0643\u0644 \u0627\u0641\u0636\u0644.</2>","interview":"\u0645\u0642\u0627\u0628\u0644\u0629","view_answer":"\u0639\u0631\u0636 \u0627\u0644\u0625\u062C\u0627\u0628\u0629","job_history_with_you":"\u0633\u062C\u0644 \u0627\u0644\u0639\u0645\u0644 \u0645\u0639\u0643","work_category_experience":"{{ workCategoryName }} Experience","other_experience":"Other Experience"},"sp_rating":{"novice":"\u0645\u0628\u062A\u062F\u0626","advanced_beginner":"\u0645\u0628\u062A\u062F\u0626 \u0645\u062A\u0642\u062F\u0645","competent":"\u0639\u0627\u0645\u0644 \u0645\u0624\u0647\u0644","proficient":"\u0645\u0627\u0647\u0631","expert":"\u0645\u062D\u062A\u0631\u0641"},"applicants_review":{"title":"\u0645\u0631\u0627\u062C\u0639\u0629 \u0627\u0644\u0645\u062A\u0642\u062F\u0645\u064A\u0646","no_applicants_to_reivew":"\u0644\u0627 \u064A\u0648\u062C\u062F \u0645\u062A\u0642\u062F\u0645\u064A\u0646 \u0644\u0644\u0645\u0631\u0627\u062C\u0639\u0629","percent_filled":"{{percent}}% \u0645\u0645\u062A\u0644\u0626"},"job_cherry_picking":{"title":"\u062A\u0641\u0627\u0635\u064A\u0644 \u0627\u0644\u0648\u0638\u064A\u0641\u0629","accepted":"\u062A\u0645 \u0627\u0644\u0642\u0628\u0648\u0644","rejected":"\u062A\u0645 \u0627\u0644\u0631\u0641\u0636","reject":"\u0631\u0641\u0636","accept":"\u0642\u0628\u0648\u0644","exp":"\u062E\u0628\u0631\u0629","age":"\u0639\u0645\u0631","language":"\u0644\u063A\u0629","nationality":"\u062C\u0646\u0633\u064A\u0629","years_of_experience":"{{count}} \u0633\u0646\u0648\u0627\u062A","experience":"\u062E\u0628\u0631\u0629","height":"\u0627\u0644\u0637\u0648\u0644","gender":"Gender","height_cm":"{{count}} \u0633\u0645","years_old":"{{count}} \u0633\u0646\u0648\u0627\u062A","total_applicants":"\u0627\u0644\u0645\u062A\u0642\u062F\u0645\u064A\u0646 ({{count}})","sort_by":"\u0641\u0631\u0632 \u062D\u0633\u0628:","rating":"\u0627\u0644\u062A\u0642\u064A\u0645","see_more":"\u0639\u0631\u0636 \u0627\u0644\u0645\u0632\u064A\u062F","confirmation":"\u062A\u0623\u0643\u064A\u062F","you_are_about_to_accept":"\u0627\u0646\u062A \u0627\u0644\u0622\u0646 \u0639\u0644\u0649 \u0648\u0634\u0643 \u0642\u0628\u0648\u0644 <1>{{name}}</1> \u0644\u0644\u0648\u0638\u064A\u0641\u0629","you_are_about_to_reject":"\u0627\u0646\u062A \u0627\u0644\u0622\u0646 \u0639\u0644\u0649 \u0648\u0634\u0643 \u0631\u0641\u0636 <1>{{name}}</1> \u0633\u0648\u0641 \u064A\u062A\u0645 \u0625\u0632\u0627\u0644\u062A\u0647 \u0645\u0646 \u0627\u0644\u0642\u0627\u0626\u0645\u0629","confirm":"\u062A\u0623\u0643\u064A\u062F","cancel":"\u0625\u0644\u063A\u0627\u0621","jobID":"\u0631\u0642\u0645 \u0627\u0644\u062A\u0639\u0631\u064A\u0641\u064A \u0644\u0644\u0648\u0638\u064A\u0641\u0629","designation":"\u0646\u0648\u0639 \u0627\u0644\u0648\u0638\u064A\u0641\u0629","location":"\u0627\u0644\u0645\u0643\u0627\u0646","required_quantity":"\u0627\u0644\u0643\u0645\u064A\u0629 \u0627\u0644\u0645\u0637\u0644\u0648\u0628\u0629","fulfillment":"\u062A\u0645 \u0625\u0646\u062C\u0627\u0632","fulfillmentRatio":"{{percent}}%","start_date":"\u062A\u0627\u0631\u064A\u062E \u0627\u0644\u0628\u062F\u0621","end_date":"\u062A\u0627\u0631\u064A\u062E \u0627\u0644\u0625\u0646\u062A\u0647\u0627\u0621","seniority_level":"\u0645\u0633\u062A\u0648\u0649 \u0627\u0644\u062E\u0628\u0631\u0629","congratulation_exclamation":"\u0645\u0628\u0631\u0648\u0643!","you_have_assigned_staff":"\u0644\u0642\u062F \u0642\u0645\u062A \u0628\u062A\u0639\u064A\u064A\u0646 \u062C\u0645\u064A\u0639 \u0627\u0644\u0645\u0648\u0638\u0641\u064A\u0646 \u0627\u0644\u0645\u0637\u0644\u0648\u0628\u064A\u0646","done":"\u062A\u0645","skill_match":"\u062A\u0637\u0627\u0628\u0642 \u0644\u0644\u0645\u0647\u0627\u0631\u0627\u062A","chief_title":"\u0639\u0646\u062F\u0646\u0627 \u0634\u064A\u0621 \u0644\u0643","chief_subtitle":"\u0623\u0636\u0641 \u0631\u0626\u064A\u0633 \u0645\u0648\u0638\u0641\u064A \u0623\u0648\u063A\u0631\u0627\u0645 \u0625\u0644\u0649 \u0641\u0631\u064A\u0642\u0643 - \u0645\u062C\u0627\u0646\u0627\u064B!","chief_og":"\u0631\u0626\u064A\u0633 \u0645\u0648\u0638\u0641\u064A \u0623\u0648\u063A\u0631\u0627\u0645","what_is_chief":"\u0645\u0646 \u0647\u0648 \u0631\u0626\u064A\u0633 \u0645\u0648\u0638\u0641\u064A \u0623\u0648\u063A\u0631\u0627\u0645\u061F","chief_definition":"\u0631\u0626\u064A\u0633 \u0645\u0648\u0638\u0641\u064A \u0623\u0648\u063A\u0631\u0627\u0645 \u0647\u0648 \u0642\u0627\u0626\u062F \u0627\u0644\u0641\u0631\u064A\u0642\u060C \u062A\u0645 \u0625\u062E\u062A\u064A\u0627\u0631\u0647 \u0628\u0639\u0646\u0627\u064A\u0629 \u0645\u0646 \u0642\u0628\u0644\u0646\u0627 \u0644\u0644\u0645\u0633\u0627\u0639\u062F\u0629 \u0641\u064A \u0625\u062F\u0627\u0631\u0629 \u0641\u0631\u064A\u0642 \u0623\u0643\u0628\u0631 \u062D\u062C\u0645\u0627\u064B \u0645\u0646 \u0639\u0645\u0644\u0627\u0621 \u0623\u0648\u063A\u0631\u0627\u0645. \u0639\u0644\u0649 \u0633\u0628\u064A\u0644 \u0627\u0644\u0645\u062B\u0627\u0644\u060C \u0645\u0646 \u062E\u0644\u0627\u0644 \u062D\u0644 \u0646\u0632\u0627\u0639\u0627\u062A \u0648\u062A\u0646\u0633\u064A\u0642 \u0627\u0639\u0636\u0627\u0621 \u0627\u0644\u0641\u0631\u064A\u0642 - \u062F\u0648\u0646 \u0623\u064A \u062A\u0643\u0644\u0641\u0629 \u0625\u0636\u0627\u0641\u064A\u0629 \u0645\u0646\u0643 .\\n\u0648\u0643\u0644 \u0647\u0630\u0627 <1>\u0645\u062C\u0627\u0646\u0627\u064B \u0628\u0634\u0643\u0644 \u0643\u0627\u0645\u0644 \u0644\u0643.</1>","chief_button_label":"\u0634\u064A\u0621 \u062C\u064A\u062F","time":"\u0627\u0644\u0648\u0642\u062A","applicant_assigned":"\u062A\u0645 \u062A\u0639\u064A\u064A\u0646 \u0627\u0644\u0645\u062A\u0642\u062F\u0645!","shortlisted":"\u0642\u0627\u0626\u0645\u0629 \u0627\u0644\u0645\u062A\u0623\u0647\u0644\u064A\u0646"},"interview":{"applicants_finished":"\u0644\u0627 \u064A\u0648\u062C\u062F \u0627\u0644\u0645\u0632\u064A\u062F \u0645\u0646 \u0645\u0631\u0627\u062C\u0639\u0627\u062A \u0644\u064A\u062A\u0645 \u0627\u0644\u0625\u062C\u0627\u0628\u0629 \u0639\u0644\u064A\u0647\u0627","applicant_id":"\u0631\u0642\u0645 \u0627\u0644\u062A\u0639\u0631\u064A\u0641\u064A#{{id}}","next_question":"\u0627\u0644\u0633\u0624\u0627\u0644 \u0627\u0644\u062A\u0627\u0644\u064A","accept":"\u0642\u0628\u0648\u0644","assigned":"\u0639\u064F\u064A\u0651\u0646","next_applicant":"\u0627\u0644\u0645\u062A\u0642\u062F\u0645 \u0627\u0644\u062A\u0627\u0644\u064A","question_short":"\u0633\u0624\u0627\u0644{{index}}:","rating_question_short":"\u062A\u0642\u064A\u064A\u0645 \u0633\u0624\u0627\u0644{{index}}:","recommended_to_hire":"\u064A\u0646\u0635\u062D \u0628\u0627\u0644\u062A\u0648\u0638\u064A\u0641","overall_rating":"\u0627\u0644\u062A\u0642\u064A\u064A\u0645 \u0627\u0644\u0643\u0627\u0645\u0644","video_player_not_supported":"\u0627\u0646 \u0645\u062A\u0635\u0641\u062D\u0643 \u0644\u0627 \u064A\u062F\u0639\u0645 \u0645\u0634\u063A\u0644 \u0627\u0644\u0641\u062F\u064A\u0648\u060C \u0627\u0644\u0631\u062C\u0627\u0621 \u0642\u0645 \u0628\u062A\u062D\u062F\u064A\u062B \u0627\u0644\u0645\u062A\u0635\u0641\u062D \u0623\u0648 \u0642\u0645 \u0628\u0625\u0633\u062A\u062E\u062F\u0627\u0645 \u0645\u062A\u0635\u0641\u062D \u0622\u062E\u0631.","submitting_rating":"\u064A\u062A\u0645 \u0627\u0631\u0633\u0627\u0644 \u0627\u0644\u062A\u0642\u064A\u064A\u0645...","rating_applied":"\u062A\u0645 \u0642\u0628\u0648\u0644 \u0627\u0644\u062A\u0642\u064A\u0645!"},"complete_registration":{"title":"\u062A\u0633\u062C\u064A\u0644 \u0634\u0631\u0643\u0629","legal_information":"\u0645\u0639\u0644\u0648\u0645\u0627\u062A \u0642\u0627\u0646\u0648\u0646\u064A\u0629","field_required":"\u0647\u0630\u0647 \u0627\u0644\u062E\u0627\u0646\u0629 \u0645\u0637\u0644\u0648\u0628\u0629","yes":"\u0646\u0639\u0645","no":"\u0644\u0627","company_name":"\u0627\u0633\u0645 \u0627\u0644\u0634\u0631\u0643\u0629","trade_name_as_license":"\u0627\u0644\u0627\u0633\u0645 \u0627\u0644\u062A\u062C\u0627\u0631\u064A \u062D\u0633\u0628 \u0627\u0644\u0631\u062E\u0635\u0629 \u0627\u0644\u062A\u062C\u0627\u0631\u064A\u0629","trade_license_number":"\u0631\u0642\u0645 \u0627\u0644\u0631\u062E\u0635\u0629 \u0627\u0644\u062A\u062C\u0627\u0631\u064A\u0629","legal_address":"\u0627\u0644\u0639\u0646\u0648\u0627\u0646 \u0627\u0644\u0642\u0627\u0646\u0648\u0646\u064A","po_box":"\u0627\u0644\u0639\u0646\u0648\u0627\u0646 \u0627\u0644\u0628\u0631\u064A\u062F\u064A","free_zone":"\u0627\u0644\u0645\u0646\u0637\u0642\u0629 \u0627\u0644\u062D\u0631\u0629","lpo_required":"\u0637\u0644\u0628 \u0627\u0644\u0634\u0631\u0627\u0621 \u0627\u0644\u0645\u062D\u0644\u064A \u0645\u0637\u0644\u0648\u0628","region":"\u0627\u0644\u0645\u0646\u0637\u0642\u0629","vat_certificate":"\u0634\u0647\u0627\u062F\u0629 \u0636\u0631\u064A\u0628\u0629 \u0627\u0644\u0642\u064A\u0645\u0629 \u0627\u0644\u0645\u0636\u0627\u0641\u0629","upload_vat":"\u0631\u0641\u0639 \u0634\u0647\u0627\u062F\u0629 \u0636\u0631\u064A\u0628\u0629 \u0627\u0644\u0642\u064A\u0645\u0629 \u0627\u0644\u0645\u0636\u0627\u0641\u0629","i_agree_with_terms":"\u0623\u0648\u0627\u0641\u0642 \u0639\u0644\u0649 <1>\u0633\u064A\u0627\u0633\u0629 \u0627\u0644\u062E\u0635\u0648\u0635\u064A\u0629</1>","i_agree_with_company_pp":"\u0623\u0648\u0627\u0641\u0642 \u0639\u0644\u0649 <1>\u0633\u064A\u0627\u0633\u064A\u0629 \u0627\u0644\u062E\u0635\u0648\u0635\u064A\u0629 \u0644\u0644\u0634\u0631\u0643\u0627\u062A</1>","i_agree_with_company_terms":"\u0623\u0648\u0627\u0642\u0642 \u0639\u0644\u0649 <1>\u0627\u0644\u0634\u0631\u0648\u0637 \u0648 \u0627\u0644\u0623\u062D\u0643\u0627\u0645</1>","continue":"\u0627\u0643\u0645\u0644","gr":{"company_name":"\u0627\u0633\u0645 \u0627\u0644\u0634\u0631\u0643\u0629","address":"\u0627\u0644\u0639\u0646\u0648\u0627\u0646 \u0645\u0639 \u0623\u0633\u0645 \u0627\u0644\u0634\u0627\u0631\u0639 - \u0627\u0644\u0631\u0642\u0645 - \u0627\u0644\u0645\u062F\u064A\u0646\u0629","tax_jurisdiction":"\u0627\u0644\u0633\u0644\u0637\u0629 \u0627\u0644\u0636\u0631\u064A\u0628\u064A\u0629 (DOY)","registry_number":"\u0631\u0642\u0645 \u0633\u062C\u0644 \u0627\u0644\u0634\u0631\u0643\u0629","zip_code":"\u0627\u0644\u0631\u0645\u0632 \u0627\u0644\u0628\u0631\u064A\u062F\u064A","industry":"\u0646\u0648\u0639 \u0627\u0644\u0635\u0646\u0627\u0639\u0629","industry_retail":"\u062A\u062C\u0627\u0631\u0629 \u0627\u0644\u062A\u062C\u0632\u0626\u0629","industry_hotels":"\u0627\u0644\u0641\u0646\u0627\u062F\u0642","industry_brc":"\u062D\u0627\u0646\u0629/\u0645\u0637\u0639\u0645/\u0645\u0642\u0647\u0649"},"document_selected":"\u062A\u0645 \u0627\u062E\u062A\u064A\u0627\u0631 \u0627\u0644\u0645\u0633\u062A\u0646\u062F","document_submitted":"\u062A\u0645 \u062A\u0642\u062F\u064A\u0645 \u0627\u0644\u0645\u0633\u062A\u0646\u062F"},"change_schedule_options":{"all_dates_from_date":"\u062C\u0645\u064A\u0639 \u0627\u0644\u0623\u064A\u0627\u0645 \u0645\u0646 {{date}}","date_only":"{{date}} \u0641\u0642\u0637","every_day_from_date":"\u0643\u0644{{day}} \u0645\u0646{{date}}","custom":"\u0645\u062E\u0635\u0635"},"onboarding_complete":{"title":"\u0634\u0643\u0631\u0627 \u0644\u0643!","description":"\u0644\u0642\u062F \u062A\u0644\u0642\u064A\u0646\u0627 \u062A\u0641\u0627\u0635\u064A\u0644 \u0634\u0631\u0643\u062A\u0643.","done":"\u062A\u0645"},"sign_sla":{"title":"\u062A\u0648\u0642\u064A\u0639 \u0627\u062A\u0641\u0627\u0642\u064A\u0629\u0645\u0633\u062A\u0648\u0649 \u0627\u0644\u062E\u062F\u0645\u0629","i_agree":"\u0623\u0646\u0627 \u0645\u0648\u0627\u0641\u0642"},"home":{"hello_name":"\u0627\u0647\u0644\u0627\u064B \u0648\u0633\u0647\u0644\u0627\u064B, <1>{{name}}</1>","hello":"\u0627\u0647\u0644\u0627\u064B \u0648\u0633\u0647\u0644\u0627\u064B","shifts_attendance_review":"\u0645\u0631\u0627\u062C\u0639 \u062D\u0636\u0648\u0631 \u0627\u0644\u0645\u0646\u0627\u0648\u0628\u0627\u062A","orders_to_confirm":"\u0623\u0648\u0627\u0645\u0631 \u0639\u0644\u064A\u0643 \u0627\u0644\u062A\u0623\u0643\u064A\u062F \u0639\u0644\u064A\u0647\u0627","rating_requests":"\u0637\u0644\u0628\u0627\u062A \u0627\u0644\u062A\u0642\u064A\u064A\u0645","applicant_review":"\u0645\u0631\u0627\u062C\u0639\u0629 \u0627\u0644\u0645\u062A\u0642\u062F\u0645\u0648\u0646","pending_payments":"\u0627\u0644\u0645\u062F\u0641\u0648\u0639\u0627\u062A \u0627\u0644\u0645\u0639\u0644\u0642\u0629","error_failed_to_load_statistics":"\u0641\u0634\u0644 \u062A\u062D\u0645\u064A\u0644 \u0627\u0644\u0625\u062D\u0635\u0627\u0626\u064A\u0627\u062A","error_failed_to_load_home_page":"\u0641\u0634\u0644 \u062A\u062D\u0645\u064A\u0644 \u0639\u0644\u0649 \u0627\u0644\u0635\u0641\u062D\u0629 \u0627\u0644\u0631\u0626\u064A\u0633\u064A\u0629","coming_soon":{"hello":"\u0627\u0647\u0644\u0627\u064B \u0648\u0633\u0647\u0644\u0627\u064B","we_are_coming_soon":"\u0646\u062D\u0646 \u0642\u0627\u062F\u0645\u0648\u0646 \u0642\u0631\u064A\u0628\u0627","prepare_for_launch":"\u0645\u0631\u062D\u0628\u0627! \u0646\u062D\u0646 \u0646\u0633\u062A\u0639\u062F \u0644\u0644\u0627\u0641\u062A\u062A\u0627\u062D\u064A\u0629 \u0627\u0644\u0643\u0628\u064A\u0631\u0629.","on_demand_staff":"\u0645\u0648\u0638\u0641\u0648\u0646 \u0645\u062A\u0648\u0641\u0631\u0648\u0646 \u062D\u0633\u0628 \u0627\u0644\u0637\u0644\u0628","find_workers":"\u0627\u0628\u062D\u062B \u0648 \u0627\u062F\u064A\u0631 \u0627\u0644\u0639\u0645\u0627\u0644 \u0630\u0648\u064A \u0627\u0644\u062C\u0648\u062F\u0629 \u0627\u0644\u0639\u0627\u0644\u064A\u0629 \u0641\u064A \u0645\u0646\u0635\u0629 \u0648\u0627\u062D\u062F\u0629 \u0628\u0633\u064A\u0637\u0647 \u0648 \u0645\u0631\u0643\u0632\u064A\u0629.","short_term_contracts":"\u0639\u0642\u0648\u062F \u0642\u0635\u064A\u0631\u0629 \u0627\u0644\u0623\u062C\u0644","post_jobs":"\u0642\u0645 \u0628\u0646\u0634\u0631 \u0648\u0638\u0627\u0626\u0641 \u0645\u0624\u0642\u062A\u0629 \u0623\u0648 \u0637\u0648\u064A\u0644\u0629 \u0627\u0644\u0623\u062C\u0644 \u0648\u0623\u0645\u0644\u0627 \u0645\u0646\u0627\u0648\u0628\u0627\u062A\u0643 \u0627\u0644\u062A\u0627\u0644\u064A\u0629 \u062E\u0644\u0627\u0644 48 \u0633\u0627\u0639\u0629 \u0645\u0646 \u0627\u0644\u062A\u0633\u062C\u064A\u0644.","incredible_savings":"\u0645\u0633\u062A\u0648\u0649 \u062A\u0648\u0641\u064A\u0631 \u0631\u0627\u0626\u0639","save_money":"\u0627\u062F\u0641\u0639 \u0627\u0644\u0627\u062C\u0631 \u0641\u0642\u0637 \u0645\u0642\u0627\u0628\u0644 \u0633\u0627\u0639\u0627\u062A \u0627\u0644\u0639\u0645\u0644 \u0627\u0644\u062A\u064A \u062A\u0645 \u0627\u0644\u0639\u0645\u0644 \u0628\u0647\u0627"}},"interview_popup":{"title":"\u0645\u0642\u0627\u0628\u0644\u0629 \u0641\u062F\u064A\u0648","description":"\u0642\u0645 \u0628\u0625\u062F\u0631\u0627\u062C \u0627\u0644\u0645\u0642\u0627\u0628\u0644\u0627\u062A \u0639\u0628\u0631 \u0627\u0644\u0641\u062F\u064A\u0648 \u0644\u062A\u0648\u0641\u064A\u0631 \u0627\u0644\u0648\u0642\u062A \u0644\u0641\u0631\u064A\u0642\u0643 \u0648 \u0627\u0644\u0625\u0646\u062C\u0627\u0632 \u0628\u0634\u0643\u0644 \u0627\u0633\u0631\u0639.","create_order_button":"\u0625\u0646\u0634\u0627\u0621 \u0627\u0644\u0637\u0644\u0628"},"sidebar":{"company":"\u0634\u0631\u0643\u0629","error_failed_to_load_sidebar":"\u0641\u0634\u0644 \u062A\u062D\u0645\u064A\u0644 \u0627\u0644\u0634\u0631\u064A\u0637 \u0627\u0644\u062C\u0627\u0646\u0628\u064A. \u0627\u0644\u0631\u062C\u0627\u0621 \u0627\u0644\u0645\u062D\u0627\u0648\u0644\u0629 \u0645\u0631\u0629 \u0627\u062E\u0631\u0649","create_order":"\u0625\u0646\u0634\u0627\u0621 \u0627\u0644\u0637\u0644\u0628","register_corporate":"\u062A\u0633\u062C\u064A\u0644 \u0634\u0631\u0643\u0629","account":"\u062D\u0633\u0627\u0628","manage_locations":"\u0625\u062F\u0627\u0631\u0629 \u0627\u0644\u0623\u0645\u0627\u0643\u0646","users":"\u0627\u0644\u0645\u0633\u062A\u062E\u062F\u0645\u0648\u0646","knowledge_center":"\u0645\u0631\u0643\u0632 \u0627\u0644\u0645\u0639\u0631\u0641\u0629","home":"\u0635\u0641\u062D\u0629 \u0627\u0644\u0631\u0626\u064A\u0633\u064A\u0629","all_jobs":"\u062C\u0645\u064A\u0639 \u0627\u0644\u0648\u0638\u0627\u0626\u0641","attendance_review":"\u0645\u0631\u0627\u062C\u0639\u0629 \u0627\u0644\u062D\u0636\u0648\u0631","orders":"\u0637\u0644\u0628\u0627\u062A","applicants_review":"\u0645\u0631\u0627\u062C\u0639\u0629 \u0627\u0644\u0645\u062A\u0642\u062F\u0645\u064A\u0646","rating_requests":"\u0637\u0644\u0628\u0627\u062A \u0627\u0644\u062A\u0642\u064A\u064A\u0645","invoices":"\u0627\u0644\u0641\u0648\u0627\u062A\u064A\u0631","payments":"\u0627\u0644\u0645\u062F\u0641\u0648\u0639\u0627\u062A","payment_methods":"\u0637\u0631\u0642 \u0627\u0644\u062F\u0641\u0639","billing":"\u0641\u0648\u0627\u062A\u064A\u0631","orders_uppercase":"\u0627\u0644\u0637\u0644\u0628\u0627\u062A","disputes":"Disputes"},"all_jobs":{"title":"\u062A\u0642\u0648\u064A\u0645","day":"\u064A\u0648\u0645","3_days":"\u064A\u0648\u0645 3","week":"\u0623\u0633\u0628\u0648\u0639","month":"\u0634\u0647\u0631","percent_filled":"{{count}}% \u0645\u0645\u0644\u0648\u0621","start":"\u064A\u0628\u062F\u0621","end":"\u064A\u0646\u062A\u0647\u064A","manage_shift":"\u0625\u062F\u0627\u0631\u0629 \u0627\u0644\u0645\u0646\u0627\u0648\u0628\u0629","unsaved_changes":"\u0644\u062F\u064A\u0643 \u062A\u063A\u064A\u064A\u0631\u0627\u062A \u0644\u0645 \u062A\u062D\u0641\u0638 \u0628\u0639\u062F\u060C \u0647\u0644 \u0623\u0646\u062A \u0645\u062A\u0623\u0643\u062F \u0645\u0646 \u0623\u0646\u0643 \u062A\u0631\u064A\u062F \u0627\u0646 \u062A\u063A\u0627\u062F\u0631 \u0647\u0630\u0647 \u0627\u0644\u0635\u0641\u062D\u0629\u061F","shift_canceled":"\u062A\u0645 \u0625\u0644\u063A\u0627\u0621 \u0627\u0644\u0645\u0646\u0627\u0648\u0628\u0629","og_checked_in":"\u0639\u0645\u064A\u0644 \u0623\u0648\u063A\u0631\u0627\u0645 \u0642\u062F \u0633\u062C\u0644 \u062D\u0636\u0648\u0631\u0647","og_checked_out":"\u0639\u0645\u064A\u0644 \u0623\u0648\u063A\u0631\u0627\u0645 \u0642\u062F \u0633\u062C\u0644 \u062E\u0631\u0648\u062C\u0647","assigned_to":"\u0643\u064F\u0644\u0641 \u0625\u0644\u0649","no_zero":"","no_one":"\u0648\u0627\u062D\u062F","no_two":"","no_few":"","no_many":"","no_other":"\u0627\u062E\u0631\u0649","empty_slot":"\u0645\u0643\u0627\u0646 \u0634\u0627\u063A\u0631 {{count}}","select_OG":"\u0627\u062E\u062A\u0627\u0631 \u0645\u0648\u0638\u0641 \u0627\u0648\u063A\u0631\u0627\u0645","cancel":"\u0627\u0644\u063A\u0627\u0621","save_changes_count":"\u062D\u0641\u0638 \u0627\u0644\u062A\u063A\u064A\u064A\u0631\u0627\u062A ({{count}})","update_success":"\u062A\u0645 \u0627\u0644\u062A\u062D\u062F\u064A\u062B \u0628\u0646\u062C\u0627\u062D","accepted":"\u062A\u0645 \u0627\u0644\u0642\u0628\u0648\u0644","canceled":"\u062A\u0645 \u0627\u0644\u0625\u0644\u063A\u0627\u0621","completed":"\u062A\u0645 \u0627\u0644\u0625\u0643\u0645\u0627\u0644","irrelevant":"\u0644\u064A\u0633 \u0645\u0647\u0645","pending":"\u0642\u064A\u062F \u0627\u0644\u0627\u0646\u062A\u0638\u0627\u0631","started":"\u0642\u062F \u0628\u062F\u0621","extension_announcement":"\u064A\u0645\u0643\u0646\u0643 \u0627\u0644\u0622\u0646 \u062A\u0645\u062F\u064A\u062F \u0627\u0644\u0637\u0644\u0628\u0627\u062A \u0645\u0628\u0627\u0634\u0631\u0629\u064B \u0645\u0646 \u0647\u0630\u0647 \u0627\u0644\u0635\u0641\u062D\u0629. \u0627\u0646\u0642\u0631 \u0639\u0644\u0649 \u0627\u0644\u0646\u0642\u0627\u0637 \u0627\u0644\u062B\u0644\u0627\u062B \u0628\u062C\u0648\u0627\u0631 \u0627\u0644\u0637\u0644\u0628 \u0648\u0627\u062E\u062A\u0631 \\"\u062A\u0645\u062F\u064A\u062F \u0627\u0644\u0637\u0644\u0628.\\"","current_week":"Go to current week","filter_location":"Filter Location","filter_designation":"Filter Designation","sps_required":"{{amount}} OGs required","bulk_apply":"Bulk Apply","apply_to_sp_only":"Apply to {{spName}} only","select_ogs_to_apply":"Select OGs to apply changes","copy_changes_to_more_ogs_on":"Copy changes to more OGs on"},"job_shifts":{"title":"\u0645\u0646\u0627\u0648\u0628\u0627\u062A \u0627\u0644\u0648\u0638\u064A\u0641\u0629","change_schedule":"\u062A\u063A\u064A\u064A\u0631 \u0627\u0644\u062C\u062F\u0648\u0644 \u0627\u0644\u0632\u0645\u0646\u064A","cancel_shift":"\u0625\u0644\u063A\u0627\u0621 \u0627\u0644\u0645\u0646\u0627\u0648\u0628\u0629","confirmation_question":"\u0627\u0646\u062A \u0639\u0644\u0649 \u0648\u0634\u0643 \u0625\u0644\u063A\u0627\u0621 \u0627\u0644\u0648\u0638\u064A\u0641\u0629 \u0644\u062C\u0645\u064A\u0639 \u0639\u0645\u0627\u0644 \u0623\u0648\u063A\u0631\u0627\u0645\u060C \u0647\u0644 \u0627\u0646\u062A \u0645\u062A\u0623\u0643\u062F \u0645\u0646 \u0630\u0644\u0643\u061F","i_have_capacity":"\u0644\u062F\u064A \u0645\u0633\u0627\u062D\u0629","select_reason":"\u062D\u062F\u062F \u0627\u0644\u0633\u0628\u0628","other":"\u0623\u062E\u0631\u0649","comment_here":"\u0639\u0644\u0642 \u0647\u0646\u0627 (\u0627\u062E\u062A\u064A\u0627\u0631\u064A)","cancel_job":"\u0625\u0644\u063A\u0627\u0621 \u0627\u0644\u0648\u0638\u064A\u0641\u0629","cancel":"\u0625\u0644\u063A\u0627\u0621","set_start_time":"\u0627\u0644\u0631\u062C\u0627\u0621 \u0636\u0628\u0637 \u0648\u0642\u062A \u0627\u0644\u0628\u062F\u0621","set_end_time":"\u0627\u0644\u0631\u062C\u0627\u0621 \u0636\u0628\u0637 \u0648\u0642\u062A \u0627\u0644\u0625\u0646\u062A\u0647\u0627\u0621","start_time":"\u0648\u0642\u062A \u0627\u0644\u0628\u062F\u0621","end_time":"\u0648\u0642\u062A \u0627\u0644\u0625\u0646\u062A\u0647\u0627\u0621","apply_schedule":"\u062A\u0637\u0628\u064A\u0642 \u0627\u0644\u062C\u062F\u0648\u0644 \u0627\u0644\u0632\u0645\u0646\u064A","apply_on_days":"\u0642\u062F\u0645 \u0639\u0644\u0649 \u0627\u0644\u0627\u064A\u0627\u0645 \u0627\u0644\u0645\u062D\u062F\u062F\u0629 \u0645\u0646 {{date}}","confirm":"\u062A\u0623\u0643\u064A\u062F","pending":"\u0642\u064A\u062F \u0627\u0644\u0627\u0646\u062A\u0638\u0627\u0631","started":"\u0642\u062F \u0628\u062F\u0621","check_in":"\u062A\u0633\u062C\u064A\u0644 \u0627\u0644\u062D\u0636\u0648\u0631","check_out":"\u062A\u0633\u062C\u064A\u0644 \u0627\u0644\u0645\u063A\u0627\u062F\u0631\u0629","extend_shift":"\u062A\u0645\u062F\u064A\u062F \u0627\u0644\u0645\u0646\u0627\u0648\u0628\u0629","call":"\u0627\u062A\u0635\u0644","whatsapp":"\u0648\u0627\u062A\u0633\u0627\u0628","remove_from_favourites":"\u062D\u0630\u0641 \u0645\u0646 \u0627\u0644\u0645\u0641\u0636\u0644\u0629","add_to_favourites":"\u0625\u0636\u0627\u0641\u0629 \u0625\u0644\u0649 \u0627\u0644\u0645\u0641\u0636\u0644\u0629","extra_time":"\u0648\u0642\u062A \u0625\u0636\u0627\u0641\u064A","percent_filled":"{{percent}}% \u0645\u0645\u0644\u0648\u0621","for_the_job":"\u0644\u0644\u0648\u0638\u064A\u0641\u0629","cancel_all_following_shifts":"\u0625\u0644\u063A\u0627\u0621 \u062C\u0645\u064A\u0639 \u0627\u0644\u0645\u0646\u0627\u0648\u0628\u0627\u062A \u0627\u0644\u062A\u0627\u0644\u064A\u0629","block_ogrammer":"\u062D\u0638\u0631 \u0639\u0627\u0645\u0644 \u0623\u0648\u063A\u0631\u0627\u0645"},"location_list":{"title":"\u0627\u0644\u0645\u0648\u0627\u0642\u0639","add_location":"\u0625\u0636\u0627\u0641\u0629 \u0645\u0648\u0642\u0639","location_required":"\u0627\u0633\u0645 \u0627\u0644\u0645\u0648\u0642\u0639 \u0645\u0637\u0644\u0648\u0628","address_required":"\u0627\u0644\u0639\u0646\u0648\u0627\u0646 \u0645\u0637\u0644\u0648\u0628","address_details_required":"\u062A\u0641\u0627\u0635\u064A\u0644 \u0645\u0639\u0644\u0648\u0645\u0627\u062A \u0627\u0644\u0639\u0646\u0648\u0627\u0646 \u0645\u0637\u0644\u0648\u0628\u0629","region_required":"\u0627\u0644\u0645\u0646\u0642\u0637\u0629 \u0645\u0637\u0644\u0648\u0628\u0629","location_name":"\u0627\u0633\u0645 \u0627\u0644\u0645\u0648\u0642\u0639","region":"\u0627\u0644\u0645\u0646\u0637\u0642\u0629","location_address":"\u0639\u0646\u0648\u0627\u0646 \u0627\u0644\u0645\u0648\u0642\u0639","address_details":"\u062A\u0641\u0627\u0635\u064A\u0644 \u0627\u0644\u0639\u0646\u0648\u0627\u0646 \u0627\u0644\u0625\u0636\u0627\u0641\u064A\u0629","upload_location_image":"\u0631\u0641\u0639 \u0635\u0648\u0631\u0629 \u0644\u0644\u0645\u0648\u0642\u0639 (\u0627\u062E\u062A\u064A\u0627\u0631\u064A)","save":"\u062D\u0641\u0638","delete":"\u062D\u0630\u0641","check_in_restrictions_title":"\u0642\u064A\u0648\u062F \u062A\u0633\u062C\u064A\u0644 \u0627\u0644\u062D\u0636\u0648\u0631","large_area":"\u0645\u0631\u0643\u0632 \u062A\u062C\u0627\u0631\u064A \u0623\u0648 \u0645\u062C\u0645\u0639 \u0643\u0628\u064A\u0631","no_restrictions":"\u062A\u0639\u0637\u064A\u0644 \u062A\u0642\u064A\u064A\u062F \u0627\u0644\u0645\u0648\u0642\u0639 \u0627\u0644\u062C\u063A\u0631\u0627\u0641\u064A","additional_details":"\u062A\u0641\u0627\u0635\u064A\u0644 \u0625\u0636\u0627\u0641\u064A\u0629","restrictions_info_modal_text":"\u0627\u0644\u0631\u062C\u0627\u0621 \u0642\u0645 \u0628\u062A\u0634\u063A\u064A\u0644 \u062E\u064A\u0627\u0631 \u201C<strong>\u0645\u0631\u0643\u0632 \u062A\u062C\u0627\u0631\u064A \u0623\u0648 \u0645\u062C\u0645\u0639 \u0643\u0628\u064A\u0631</strong>\u201D \u0625\u0630\u0627 \u0643\u0627\u0646 \u0627\u0644\u0645\u0637\u0644\u0648\u0628 \u0645\u0646 \u0627\u0644\u0645\u0648\u0638\u0641 \u0627\u0646 \u064A\u0639\u0645\u0644 \u0641\u064A \u0645\u0646\u0637\u0642\u0629 \u0643\u0628\u064A\u0631\u0629. \u0633\u0648\u0641 \u0646\u0642\u0648\u0645 \u0628\u062A\u0639\u062F\u064A\u0644 \u0645\u0633\u0627\u062D\u0629 \u0645\u0646\u0637\u0642\u0629 \u062A\u0633\u062C\u064A\u0644 \u0627\u0644\u062D\u0636\u0648\u0631 \u0648 \u062A\u0633\u062C\u064A\u0644 \u0627\u0644\u0645\u063A\u0627\u062F\u0631\u0629. \u062E\u064A\u0627\u0631 <br/><br/>\u201C<strong>\u062A\u0639\u0637\u064A\u0644 \u062A\u0642\u064A\u064A\u062F \u0627\u0644\u0645\u0648\u0642\u0639 \u0627\u0644\u062C\u063A\u0631\u0627\u0641\u064A</strong>\u201D \u0633\u064A\u0624\u062F\u064A \u0625\u0644\u0649 \u0625\u0632\u0627\u0644\u0629 \u0642\u064A\u0648\u062F \u0627\u0644\u062C\u063A\u0631\u0627\u0641\u064A\u0629 \u0641\u064A \u062D\u0627\u0644\u0629 \u0627\u0644\u0639\u0645\u0644 \u0639\u0646 \u0628\u0639\u062F \u0623\u0648 \u0625\u0630\u0627 \u0643\u0627\u0646 \u0627\u0644\u0639\u0645\u0644 \u0633\u064A\u062A\u0645 \u0641\u064A \u0639\u062F\u0629 \u0627\u0645\u0627\u0643\u0646.","you_have_n_locations":"\u0644\u062F\u064A\u0643 {{locationsCount}} \u0645\u0648\u0642\u0639"},"add_location":{"title":"\u0625\u0636\u0627\u0641\u0629 \u0645\u0648\u0642\u0639"},"edit_location":{"title":"\u062A\u0639\u062F\u064A\u0644 \u0627\u0644\u0645\u0648\u0642\u0639"},"orders_list":{"title":"\u0627\u0644\u0637\u0644\u0628\u0627\u062A","empty_list_title":"\u0627\u0628\u062F\u0623 \u0628\u0627\u0644\u062A\u0648\u0638\u064A\u0641 \u0627\u0644\u064A\u0648\u0645!","empty_list_description":"\u0647\u0644 \u062A\u0628\u062D\u062B \u0639\u0646 \u0645\u0648\u0638\u0641 \u0628\u062F\u0648\u0627\u0645 \u062C\u0632\u0626\u064A\u061F\\n\u0623\u062E\u0628\u0631\u0646\u0627 \u0639\u0646 \u0645\u062A\u0637\u0644\u0628\u0627\u062A \u0639\u0645\u0644\u0643.","create_order":"\u0625\u0646\u0634\u0627\u0621 \u0627\u0644\u0637\u0644\u0628","tab_title_pending":"\u0642\u064A\u062F \u0627\u0644\u0627\u0646\u062A\u0638\u0627\u0631","tab_title_active":"\u0641\u0639\u0627\u0644","tab_title_completed":"\u0642\u062F \u0627\u0643\u062A\u0645\u0644"},"order":{"order_number":"\u0637\u0644\u0628 #{{id}}","order_summary":"\u0645\u0644\u062E\u0635 \u0627\u0644\u0637\u0644\u0628","jobs":"\u0627\u0644\u0648\u0638\u0627\u0626\u0641","cost":"\u0627\u0644\u062A\u0643\u0644\u0641\u0629","i_accept_terms":"\u0623\u0648\u0627\u0641\u0642 \u0639\u0644\u0649 <1>\u0634\u0631\u0648\u0637 \u0627\u0644\u062E\u062F\u0645\u0629</1>","confirm":"\u062A\u0623\u0643\u064A\u062F","order_confirmed":"\u062A\u0645 \u062A\u0623\u0643\u064A\u062F \u0627\u0644\u0637\u0644\u0628","thank_you_for_confirming_order":"\u0634\u0643\u0631\u0627 \u0639\u0644\u0649 \u062A\u0623\u0643\u064A\u062F \u0627\u0644\u0637\u0644\u0628.","done":"\u062A\u0645","payment_terms":"\u0634\u0631\u0648\u0637 \u0627\u0644\u062F\u0641\u0639","complete_company_details":"\u0627\u0643\u0645\u0644 \u062A\u0641\u0627\u0635\u064A\u0644 \u0627\u0644\u0634\u0631\u0643\u0629 \u0644\u062A\u063A\u064A\u064A\u0631 \u0634\u0631\u0648\u0637 \u0627\u0644\u062F\u0641\u0639","change_terms":"\u062A\u063A\u064A\u064A\u0631 \u0627\u0644\u0634\u0631\u0648\u0637","location":"\u0627\u0644\u0645\u0648\u0642\u0639","end_date":"\u062A\u0627\u0631\u064A\u062E \u0627\u0644\u0625\u0646\u062A\u0647\u0627\u0621","start_date":"\u062A\u0627\u0631\u064A\u062E \u0627\u0644\u0628\u062F\u0621","subtotal":"\u0627\u0644\u0645\u062C\u0645\u0648\u0639 \u0627\u0644\u0641\u0631\u0639\u064A","transportations":"\u0627\u0644\u0645\u0648\u0627\u0635\u0644\u0627\u062A","vat_percent":"\u0636\u0631\u064A\u0628\u0629 \u0627\u0644\u0642\u064A\u0645\u0629 \u0627\u0644\u0645\u0636\u0627\u0641\u0629 ({{count}}%)","estimated_total":"\u0627\u0644\u0645\u062C\u0645\u0648\u0639 \u0627\u0644\u062A\u0642\u062F\u064A\u0631\u064A","dates":"\u0627\u0644\u062A\u0648\u0627\u0631\u064A\u062E","days_count":"({{count}} \u064A\u0648\u0645)","hours":"\u0633\u0627\u0639\u0629","hours_amount":"{{hours}} \u0633\u0627\u0639\u0629","hours_per_day":"({{hoursPerDay}} \u0633/\u064A\u0648\u0645)","rate":"\u0645\u0639\u062F\u0644 \u0627\u0644\u0627\u062C\u0631","hour_rate":"{{currency}} {{hourRate}}/\u0633","transportation_cost":"{{currency}} {{cost}}/\u064A\u0648\u0645","category_schedule":"{{category}} \u062C\u062F\u0648\u0644","order_summary_days_count":"({{count}} \u0627\u064A\u0627\u0645)","hello_name":"\u0645\u0631\u062D\u0628\u0627, <1>{{name}}</1>","confirm_order":"\u0642\u062F \u062A\u0644\u0642\u064A\u0646\u0627 \u0645\u0646\u0643 \u0637\u0644\u0628\u064B\u0627 \u062C\u062F\u064A\u062F\u064B\u0627. \u0644\u0644\u0645\u062A\u0627\u0628\u0639\u0629\u060C \u064A\u0631\u062C\u0649 \u0645\u0631\u0627\u062C\u0639\u0629 \u0648\u062A\u0623\u0643\u064A\u062F \u0627\u0644\u062A\u0641\u0627\u0635\u064A\u0644 \u0623\u062F\u0646\u0627\u0647.","pending_rates_review":"\u0637\u0644\u0628\u0643 \u0642\u064A\u062F \u0627\u0644\u0645\u0631\u0627\u062C\u0639\u0629\u060C \u0633\u0648\u0641 \u064A\u062A\u0645 \u0628\u0625\u0639\u0644\u0627\u0645\u0643 \u0628\u0645\u062C\u0631\u062F \u062A\u062D\u062F\u064A\u062F \u0645\u0639\u062F\u0644 \u0627\u0644\u0623\u062C\u0648\u0631.","send_for_review":"\u0627\u0644\u0625\u0631\u0633\u0627\u0644 \u0644\u0644\u0645\u0631\u0627\u062C\u0639\u0629","under_review":"\u062A\u062D\u062A \u0627\u0644\u0645\u0631\u0627\u062C\u0639\u0629","final_amount_will_be_based":"*\u0633\u0648\u0641 \u064A\u062A\u0645 \u062A\u062D\u062F\u064A\u062F \u0627\u0644\u0645\u0628\u0644\u063A \u0627\u0644\u0625\u062C\u0645\u0627\u0644\u064A \u0627\u0644\u0646\u0647\u0627\u0626\u064A \u0628\u0646\u0627\u0621\u064B \u0639\u0644\u0649 \u0627\u0644\u062D\u0636\u0648\u0631 \u0627\u0644\u0641\u0639\u0644\u064A","amend_order":"\u062A\u0639\u062F\u064A\u0644 \u0627\u0644\u0637\u0644\u0628","i_accept":"\u0627\u0646\u0627 \u0623\u0648\u0627\u0641\u0642 \u0639\u0644\u0649","terms_of_service":"\u0634\u0631\u0648\u0637 \u0627\u0644\u062E\u062F\u0645\u0629","select_amend_reason":"\u062D\u062F\u062F \u0633\u0628\u0628 \u0627\u0644\u062A\u0639\u062F\u064A\u0644","select_reason":"\u062D\u062F\u062F \u0627\u0644\u0633\u0628\u0628","submitting":"\u064A\u062A\u0645 \u0627\u0644\u062A\u0642\u062F\u064A\u0645...","continue":"\u0627\u0643\u0645\u0644","cancel":"\u0625\u0644\u063A\u0627\u0621","quotation_download_title":"\u062A\u062D\u0645\u064A\u0644 \u0627\u0644\u062A\u0633\u0639\u064A\u0631\u0629","quotation_download_action_text":"\u062A\u062D\u0645\u064A\u0644","quotation_download_in_progress_text":"\u064A\u062A\u0645 \u0627\u0644\u062A\u0646\u0632\u064A\u0644...","lpo_upload_title":"\u0642\u0645 \u0628\u0631\u0641\u0639 \u0648\u062B\u064A\u0642\u0629 \u0645\u0648\u0642\u0639\u0647 \u0644\u0637\u0644\u0628 \u0627\u0644\u0634\u0631\u0627\u0621 \u0627\u0644\u0645\u062D\u0644\u064A","lpo_upload_action_text":"\u0631\u0641\u0639","lpo_upload_in_progress_text":"\u064A\u062A\u0645 \u0627\u0644\u0631\u0641\u0639...","lpo_upload_success_message":"\u062A\u0645 \u0631\u0641\u0639 \u0648\u062B\u064A\u0642\u0629 \\"\u0637\u0644\u0628 \u0634\u0631\u0627\u0621 \u0645\u062D\u0644\u064A\\" \u0628\u0646\u062C\u0627\u062D","menu_download_quote":"\u062A\u062D\u0645\u064A\u0644 \u0627\u0642\u062A\u0628\u0627\u0633","menu_upload_lpo":"\u0631\u0641\u0639 \u0645\u0633\u062A\u0646\u062F \\"\u0637\u0644\u0628 \u0634\u0631\u0627\u0621 \u0645\u062D\u0644\u064A\\"","lpo_download_title":"\u062A\u062D\u0645\u064A\u0644 \\"\u0637\u0644\u0628 \u0634\u0631\u0627\u0621 \u0645\u062D\u0644\u064A\\"","lpo_download_in_progress_text":"\u064A\u062A\u0645 \u0627\u0644\u062A\u062D\u0645\u064A\u0644...","menu_duplicate_order":"\u0646\u0633\u062E \u0627\u0644\u0637\u0644\u0628","draft_order_title":"\u0645\u0633\u0648\u062F\u0629 \u0627\u0644\u0637\u0644\u0628\u0627\u062A","job_to_duplicate":"\u0648\u0638\u064A\u0641\u0629 \u0644\u0644\u0646\u0633\u062E","need_to_review_corporate_details":"\u0642\u062F \u062A\u0644\u0642\u064A\u0646\u0627 \u0645\u0646\u0643 \u0637\u0644\u0628\u064B\u0627 \u062C\u062F\u064A\u062F\u064B\u0627. \u0644\u0644\u0645\u062A\u0627\u0628\u0639\u0629\u060C \u064A\u0631\u062C\u0649 \u0645\u0631\u0627\u062C\u0639\u0629 \u0648\u0627\u0643\u0645\u0627\u0644 \u062A\u0641\u0627\u0635\u064A\u0644 \u0627\u0644\u0634\u0631\u0643\u0629","corporate_details_are_being_reviewed":"\u0646\u062D\u0646 \u0646\u0642\u0648\u0645 \u0628\u0645\u0631\u0627\u062C\u0639\u0629 \u062A\u0641\u0627\u0635\u064A\u0644 \u0634\u0631\u0643\u062A\u0643 \u0627\u0644\u062A\u064A \u0623\u0631\u0633\u0644\u062A\u0647\u0627 \u0625\u0644\u064A\u0646\u0627","complete_company_details_link":"\u0627\u0643\u0645\u0644 \u062A\u0641\u0627\u0635\u064A\u0644 \u0627\u0644\u0634\u0631\u0643\u0629","duplicate_order":"\u0646\u0633\u062E \u0627\u0644\u0637\u0644\u0628","days":"\u0627\u0644\u0623\u064A\u0627\u0645","to_end":"\u0644\u0644\u0646\u0647\u0627\u064A\u0629","suggest_extension":"\u0646\u0634\u0643\u0631\u0643 \u0639\u0644\u0649 \u0627\u062E\u062A\u064A\u0627\u0631 \u062E\u062F\u0645\u0627\u062A\u0646\u0627. \u064A\u0645\u0643\u0646\u0643 \u062A\u0645\u062F\u064A\u062F \u0637\u0644\u0628\u0643 \u0644\u0644\u062D\u0635\u0648\u0644 \u0639\u0644\u0649 \u062E\u062F\u0645\u0627\u062A \u0623\u0648 \u0645\u0646\u062A\u062C\u0627\u062A \u0625\u0636\u0627\u0641\u064A\u0629.","extend_your_order":"\u062A\u0645\u062F\u064A\u062F \u0627\u0644\u0637\u0644\u0628 \u0627\u0644\u062E\u0627\u0635 \u0628\u0643"},"job_draft_category":{"title":"\u0625\u0646\u0634\u0627\u0621 \u0637\u0644\u0628 \u062C\u062F\u064A\u062F","tell_about_job":"\u0623\u062E\u0628\u0631\u0646\u0627 \u0639\u0646 \u0627\u0644\u0648\u0638\u064A\u0641\u0629","tell_about_first_job":"\u0623\u062E\u0628\u0631\u0646\u0627 \u0639\u0646 \u0627\u0648\u0644 \u0648\u0638\u064A\u0641\u0629","find_staff":"\u0627\u0628\u062D\u062B \u0639\u0646 \u0645\u0648\u0638\u0641\u064A\u0646 \u0645\u0624\u0647\u0644\u064A\u0646 \u0644\u0643\u0644 \u0627\u062D\u062A\u064A\u0627\u062C\u0627\u062A\u064A\u0643"},"job_draft_price":{"title":"Set the Hourly Rates","subtitle":"Attract best workers with competitive rates","low_rate_og_message":"\u26A0\uFE0F Significantly below market standard","low_rate_fill_message":"\uD83D\uDC22 High risk of low fill rate","middle_rate_og_message":"\uD83D\uDC65 Below market standard","middle_rate_fill_message":"\u23F3 Moderate fill rate","good_rate_og_message":"\uD83C\uDF1F Competitive hourly rate","good_rate_fill_message":"\uD83D\uDE80 Good fill rate","money_amount":"{{currency}} {{amount}}","rate_is_less_than_min":"Rate is less than minimal allowed of {{min}}","input_label":"Hour Rate, {{currency}}","decrease_rate":"decrease rate","increase_rate":"increase rate","short_explanation":"The recommended rate is dynamically calculated based on demand, timing, and job specifics, and already includes our commission","estimated_total":"Estimated total*","includes_vat":"*Includes {{vat}}% VAT"},"job_draft_details":{"title":"{{category}} \u0648\u0638\u064A\u0641\u0629","fill_job_details":"\u0627\u0644\u0631\u062C\u0627\u0621 \u0627\u0645\u0644\u0627\u0621 \u062A\u0641\u0627\u0635\u064A\u0644 \u0627\u0644\u0648\u0638\u064A\u0641\u0629","staff":"\u0645\u0648\u0638\u0641","quantity":"\u0643\u0645\u064A\u0629","location":"\u0645\u0648\u0642\u0639","start_date":"\u062A\u0627\u0631\u064A\u062E \u0627\u0644\u0628\u062F\u0621","end_date":"\u062A\u0627\u0631\u064A\u062E \u0627\u0644\u0625\u0646\u062A\u0647\u0627\u0621","days":"\u0623\u064A\u0627\u0645","start_time":"\u0648\u0642\u062A \u0627\u0644\u0628\u062F\u0621","end_time":"\u0648\u0642\u062A \u0627\u0644\u0625\u0646\u062A\u0647\u0627\u0621","requirements":"\u0627\u0644\u0645\u062A\u0637\u0644\u0628\u0627\u062A","job_description":"\u0648\u0635\u0641 \u0627\u0644\u0648\u0638\u064A\u0641\u0629","experience":"\u0627\u0644\u062E\u0628\u0631\u0629","dresscode":"\u0627\u0644\u0632\u064A \u0627\u0644\u0631\u0633\u0645\u064A","additional_preferences":"\u0627\u0644\u062A\u0641\u0636\u064A\u0644\u0627\u062A \u0627\u0644\u0625\u0636\u0627\u0641\u064A\u0629","languages":"\u0627\u0644\u0644\u063A\u0627\u062A","gender":"\u0627\u0644\u062C\u0646\u0633","additional_documents":"\u0645\u0633\u062A\u0646\u062F\u0627\u062A \u0625\u0636\u0627\u0641\u064A\u0629","video_interview":"\u0645\u0642\u0627\u0628\u0644\u0629 \u0639\u0646 \u0637\u0631\u064A\u0642 \u0627\u0644\u0641\u062F\u064A\u0648","manual_selection":"\u0627\u062E\u062A\u064A\u0627\u0631 \u0627\u0644\u0645\u0648\u0638\u0641\u064A\u0646 \u064A\u062F\u0648\u064A\u0627","accreditation":"\u0627\u0644\u062A\u0635\u062F\u064A\u0642 \u0645\u0637\u0644\u0648\u0628","submitting":"\u064A\u062A\u0645 \u0627\u0644\u062A\u0642\u062F\u064A\u0645...","save":"\u062A\u0642\u062F\u064A\u0645","finish":"\u0627\u0646\u0647\u064A","next":"\u0627\u0644\u062A\u0627\u0644\u064A","create_duplicate":"\u062D\u0641\u0638","step_n_of_m_steps":"{{objectNameLabel}} {{index}} \u0645\u0646 {{count}}","work_category_required":"\u0627\u0644\u0631\u062C\u0627\u0621 \u0627\u062E\u062A\u064A\u0627\u0631 \u0641\u0626\u0629 \u0627\u0644\u0639\u0645\u0644","quantity_required":"\u064A\u0631\u062C\u0649 \u062A\u062D\u062F\u064A\u062F \u0639\u062F\u062F \u0627\u0644\u0645\u0648\u0638\u0641\u064A\u0646 \u0627\u0644\u0630\u064A\u0646 \u062A\u062D\u062A\u0627\u062C\u0647\u0645","location_required":"\u064A\u0631\u062C\u0649 \u062A\u062D\u062F\u064A\u062F \u0627\u0644\u0645\u0648\u0642\u0639","schedule_type_required":"\u064A\u0631\u062C\u0649 \u062A\u062D\u062F\u064A\u062F \u0646\u0648\u0639 \u062C\u062F\u0648\u0644\u0643","same_time_prompt_required":"\u0627\u0644\u0631\u062C\u0627\u0621 \u0625\u062E\u0628\u0627\u0631\u0646\u0627 \u0625\u0630\u0627 \u0643\u0627\u0646\u062A \u062C\u0645\u064A\u0639 \u0627\u0644\u0627\u064A\u0627\u0645 \u0644\u062F\u064A\u0647\u0627 \u0646\u0641\u0633 \u0648\u0642\u062A \u0627\u0644\u0628\u062F\u0621/\u0627\u0644\u0625\u0646\u062A\u0647\u0627\u0621","start_date_required":"\u064A\u0631\u062C\u0649 \u062A\u062D\u062F\u064A\u062F \u0648\u0642\u062A \u0627\u0644\u0628\u062F\u0621","end_date_required":"\u064A\u0631\u062C\u0649 \u062A\u062D\u062F\u064A\u062F \u0648\u0642\u062A \u0627\u0644\u0625\u0646\u062A\u0647\u0627\u0621 \u0623\u0648 \u0627\u0646 \u062A\u062C\u0639\u0644 \u0627\u0644\u0648\u0638\u064A\u0641\u0629 \u0645\u0641\u062A\u0648\u062D\u0629 \u0627\u0644\u0627\u0645\u062F","end_date_cannot_be_before_start_date":"\u0644\u0627 \u064A\u0645\u0643\u0646 \u0627\u0646 \u064A\u0643\u0648\u0646 \u062A\u0627\u0631\u064A\u062E \u0627\u0644\u0625\u0646\u062A\u0647\u0627\u0621 \u0642\u0628\u0644 \u062A\u0627\u0631\u064A\u062E \u0627\u0644\u0628\u062F\u0621","start_time_required":"\u064A\u0631\u062C\u0649 \u062A\u062D\u062F\u064A\u062F \u0648\u0642\u062A \u0627\u0644\u0628\u062F\u0621","end_time_required":"\u064A\u0631\u062C\u0649 \u062A\u062D\u062F\u064A\u062F \u0648\u0642\u062A \u0627\u0644\u0625\u0646\u062A\u0647\u0627\u0621","select_one_date_at_least":"\u064A\u0631\u062C\u0649 \u0627\u062E\u062A\u064A\u0627\u0631 \u064A\u0648\u0645 \u0648\u0627\u062D\u062F \u0639\u0644\u0649 \u0627\u0644\u0623\u0642\u0644","fill_all_selected_dates":"\u064A\u0631\u062C\u0649 \u0645\u0644\u0621 \u062C\u0645\u064A\u0639 \u0627\u0644\u0645\u062F\u062E\u0644\u0627\u062A \u0644\u0644\u062A\u0627\u0631\u064A\u062E \u0627\u0644\u0645\u062D\u062F\u062F","job_cant_start_early":"\u0644\u0627 \u064A\u0645\u0643\u0646 \u0644\u0644\u0648\u0638\u064A\u0641\u0629 \u0627\u0646 \u062A\u0628\u062F\u0621 \u0641\u064A \u0627\u0642\u0644 \u0645\u0646 24 \u0633\u0627\u0639\u0629","must_include_day_of_start_date":"\u064A\u062C\u0628 \u062A\u0636\u0645\u064A\u0646 \u062A\u0627\u0631\u064A\u062E \u064A\u0648\u0645 \u0627\u0644\u0628\u062F\u0621","must_include_day_of_end_date":"\u064A\u062C\u0628 \u062A\u0636\u0645\u064A\u0646 \u062A\u0627\u0631\u064A\u062E \u064A\u0648\u0645 \u0627\u0644\u0625\u0646\u062A\u0647\u0627\u0621","description_required":"\u064A\u0631\u062C\u0649 \u0636\u0628\u0637 \u0627\u0644\u0648\u0635\u0641","description_too_long":"\u0627\u0646 \u0627\u0644\u0648\u0635\u0641 \u0637\u0648\u064A\u0644 \u062C\u062F\u0627\u064B\u060C \u064A\u0631\u062C\u0649 \u062C\u0639\u0644\u0647 \u0623\u0642\u0635\u0631","experience_required":"\u0627\u0644\u0631\u062C\u0627\u0621 \u0627\u062E\u062A\u064A\u0627\u0631 \u0645\u0633\u062A\u0648\u0649 \u0627\u0644\u062E\u0628\u0631\u0629","dresscode_required":"\u0627\u0644\u0631\u062C\u0627\u0621 \u0627\u062E\u062A\u064A\u0627\u0631 \u0627\u0644\u0632\u064A \u0627\u0644\u0631\u0633\u0645\u064A","languages_required":"\u062D\u062F\u062F \u0627\u0644\u0644\u063A\u0627\u062A \u0623\u0648 \u0642\u0645 \u0628\u062D\u0630\u0641 \u0627\u0644\u062A\u0635\u0641\u064A\u0629","documents_required":"\u062D\u062F\u062F \u0627\u0644\u0645\u0633\u062A\u0646\u062F\u0627\u062A \u0623\u0648 \u0642\u0645 \u0628\u062D\u0630\u0641 \u0627\u0644\u062A\u0635\u0641\u064A\u0629","interview_required":"\u062D\u062F\u062F \u0627\u0644\u0623\u0633\u0626\u0644\u0629 \u0623\u0648 \u0642\u0645 \u0628\u062D\u0630\u0641 \u0627\u0644\u062A\u0635\u0641\u064A\u0629","manual_selection_required":"\u062D\u062F\u062F \u0627\u062E\u062A\u064A\u0627\u0631 \u0627\u0644\u062A\u062D\u062F\u064A\u062F \u0627\u0644\u064A\u062F\u0648\u064A \u0623\u0648 \u0642\u0645 \u0628\u062D\u0630\u0641 \u0627\u0644\u062A\u0635\u0641\u064A\u0629","accreditation_required":"\u062D\u062F\u062F \u0627\u062E\u062A\u064A\u0627\u0631 \u0627\u0644\u0627\u0639\u062A\u0645\u0627\u062F \u0623\u0648 \u0642\u0645 \u0628\u062D\u0630\u0641 \u0627\u0644\u062A\u0635\u0641\u064A\u0629","staff_amount_title":"\u0643\u0645 \u0639\u062F\u062F \u0627\u0644\u0645\u0648\u0638\u0641\u064A\u0646 \u0627\u0644\u0630\u064A\u0646 \u062A\u062D\u062A\u0627\u062C\u0647\u0645\u061F","staff_amount_subtitle":"\u062D\u062F\u062F \u0627\u0644\u0639\u062F\u062F \u0627\u0644\u0630\u064A \u062A\u062D\u062A\u0627\u062C\u0647 \u0623\u0648 \u0642\u0645 \u0628\u0643\u062A\u0627\u0628\u062A\u0647\u0627","location_title":"\u0627\u064A\u0646 \u062A\u062D\u062A\u0627\u062C \u0627\u0644\u0645\u0648\u0638\u0641\u064A\u0646\u061F","location_subtitle":"\u062D\u062F\u062F \u0627\u0644\u0645\u0648\u0642\u0639 \u0623\u0648 \u0627\u0644\u0645\u0643\u0627\u0646 \u0627\u0644\u0630\u064A \u062A\u062D\u062A\u0627\u062C \u0641\u064A\u0647 \u0625\u0644\u0649 \u0627\u0644\u0645\u0648\u0638\u0641\u064A\u0646.","location_add_new":"\u0625\u0636\u0627\u0641\u0629 \u0645\u0648\u0642\u0639 \u062C\u062F\u064A\u062F","location_add":"\u0625\u0636\u0627\u0641\u0629 \u0645\u0648\u0642\u0639","dates_title":"\u0645\u062A\u0649 \u062A\u062D\u062A\u0627\u062C \u0625\u0644\u0649 \u0627\u0644\u0645\u0648\u0638\u0641\u064A\u0646\u061F","dates_subtitle":"\u0627\u062E\u062A\u0627\u0631 \u062A\u0627\u0631\u064A\u062E/\u062A\u0648\u0627\u0631\u064A\u062E \u0639\u0646\u062F\u0645\u0627 \u062A\u062D\u062A\u0627\u062C \u0625\u0644\u064A\u0647\u0645.","dates_open_ended":"\u0645\u0641\u062A\u0648\u062D (\u0644\u0627 \u064A\u0648\u062C\u062F \u062A\u0627\u0631\u064A\u062E \u0625\u0646\u062A\u0647\u0627\u0621)","schedule_title":"\u0647\u0644 \u0633\u0648\u0641 \u064A\u0639\u0645\u0644\u0648\u0646 \u0641\u064A \u0646\u0641\u0633 \u0627\u0644\u0623\u064A\u0627\u0645 \u0643\u0644 \u0623\u0633\u0628\u0648\u0639\u061F","schedule_subtitle":"\u0639\u0644\u0649 \u0633\u0628\u064A\u0644 \u0627\u0644\u0645\u062B\u0627\u0644\u060C \u0645\u0646 \u0627\u0644\u0627\u062B\u0646\u064A\u0646 \u0625\u0644\u0649 \u0627\u0644\u062C\u0645\u0639\u0629 \u0643\u0644 \u0627\u0633\u0628\u0648\u0639.","schedule_i_have_same_weekly":"\u0644\u062F\u064A \u0646\u0641\u0633 \u0627\u0644\u062C\u062F\u0648\u0644 \u0643\u0644 \u0627\u0633\u0628\u0648\u0639","schedule_schedule_weekly":"\u0627\u0644\u062C\u062F\u0648\u0644 \u0627\u0644\u0632\u0645\u0646\u064A \u0639\u0644\u0649 \u0623\u0633\u0627\u0633 \u0623\u0633\u0628\u0648\u0639\u064A","schedule_i_need_schedule_daily":"\u0623\u062D\u062A\u0627\u062C \u0625\u0644\u0649 \u0627\u0644\u062C\u062F\u0648\u0644\u0629 \u0639\u0644\u0649 \u0623\u0633\u0627\u0633 \u064A\u0648\u0645\u064A","schedule_schedule_daily":"\u0627\u0644\u062C\u062F\u0648\u0644 \u0627\u0644\u0632\u0645\u0646\u064A \u0639\u0644\u0649 \u0623\u0633\u0627\u0633 \u064A\u0648\u0645\u064A","time_title":"\u0645\u0627\u0647\u064A \u0627\u0644\u0641\u062A\u0631\u0629 \u0627\u0644\u0632\u0645\u0646\u064A\u0629 \u0628\u0627\u0644\u0633\u0627\u0639\u0627\u062A \u0627\u0644\u0645\u062C\u062F\u0648\u0644\u0629 \u0641\u064A \u0627\u0644\u0639\u0645\u0644\u061F","time_subtitle":"\u062D\u062F\u062F \u0627\u0644\u0623\u064A\u0627\u0645 \u0627\u0644\u062A\u064A \u062A\u0631\u064A\u062F \u0623\u0646 \u064A\u0639\u0645\u0644 \u0641\u064A\u0647\u0627 \u0627\u0644\u0645\u0648\u0638\u0641\u064A\u0646","time_select_dates_schedule":"\u0627\u0644\u0631\u062C\u0627\u0621 \u062A\u062D\u062F\u064A\u062F \u0627\u0644\u062A\u0648\u0627\u0631\u064A\u062E \u0648 \u0646\u0648\u0639 \u0627\u0644\u062C\u062F\u0648\u0644 \u0623\u0648\u0644\u0627\u064B","time_days_selected":"\u062A\u0645 \u0627\u062E\u062A\u064A\u0627\u0631{{count}} \u064A\u0648\u0645\u0627\u064B","time_dates_selected":"\u062A\u0645 \u0627\u062E\u062A\u064A\u0627\u0631 {{count}} \u062A\u0627\u0631\u064A\u062E","requirements_title":"Do the workers need a specific specialization?","requirements_subtitle":"\u0641\u062D\u0635 \u0627\u0644\u0645\u0648\u0638\u0641\u064A\u0646 \u0645\u0646 \u062E\u0644\u0627\u0644 \u0633\u0624\u0627\u0644\u0647\u0645 \u0644\u0623\u062C\u0644 \u0627\u0644\u062A\u062D\u0642\u0642 \u0639\u0644\u0649 \u0645\u0647\u0627\u0631\u0627\u062A\u0647\u0645","requirements_add_new":"\u0625\u0636\u0627\u0641\u0629 \u0645\u062A\u0637\u0644\u0628\u0627\u062A \u062C\u062F\u064A\u062F\u0629","requirements_create":"\u0625\u0646\u0634\u0627\u0621 \u0645\u062A\u0637\u0644\u0628\u0627\u062A \u0627\u0644\u0639\u0645\u0644","requirement_requirement":"\u0645\u062A\u0637\u0644\u0628\u0627\u062A","requirement_add_requirement":"\u0625\u0636\u0627\u0641\u0629 \u0645\u062A\u0637\u0644\u0628\u0627\u062A","description_title":"\u062A\u0641\u0627\u0635\u064A\u0644 \u0627\u0644\u0648\u0638\u064A\u0641\u0629","description_subtitle":"\u0623\u0636\u0641 \u0648\u0635\u0641\u0627\u064B \u0644\u0644\u0648\u0638\u064A\u0641\u0629 \u0644\u0623\u062C\u0644 \u0627\u0644\u0645\u0648\u0638\u0641\u064A\u0646 (\u0627\u0635\u0641 \u0627\u0644\u0645\u0647\u0627\u0645 \u0648 \u0627\u0644\u0645\u0633\u0624\u0648\u0644\u064A\u0627\u062A \u0627\u0644\u0645\u062A\u0648\u0642\u0639\u0629 \u0645\u0646 \u0627\u0644\u0645\u0648\u0638\u0641\u064A\u0646)","description_placeholder":"\u0648\u0635\u0641 \u062A\u0641\u0627\u0635\u064A\u0644 \u0627\u0644\u0648\u0638\u064A\u0641\u0629","experience_title":"\u0645\u0627 \u0645\u062F\u0649 \u0627\u0644\u062E\u0628\u0631\u0629 \u0627\u0644\u062A\u064A \u062A\u062D\u062A\u0627\u062C\u0647\u0627 \u0644\u0644\u0645\u0648\u0638\u0641\u064A\u0646\u061F","experience_subtitle":"\u062D\u062F\u062F \u0645\u0633\u062A\u0648\u0649 \u0627\u0644\u062E\u0628\u0631\u0629 \u0627\u0644\u0630\u064A \u062A\u0631\u064A\u062F\u0647 \u0644\u062F\u0649 \u0627\u0644\u0645\u0648\u0638\u0641\u064A\u0646","experience_student":"\u0637\u0627\u0644\u0628","experience_beginner":"\u0645\u0628\u062A\u062F\u0626","experience_junior":"\u0645\u0628\u062A\u062F\u0626","experience_middle":"\u0645\u062A\u0648\u0633\u0637","experience_senior":"\u062E\u0628\u064A\u0631","experience_hint":"*\u0643\u0644\u0645\u0627 \u0627\u0631\u062A\u0641\u0639\u062A \u062E\u0628\u0631\u0629 \u0627\u0644\u0645\u0648\u0638\u0641\u060C \u0627\u0631\u062A\u0641\u0639 \u0627\u062C\u0631\u0647 \u0628\u0627\u0644\u0633\u0627\u0639\u0627\u062A.","experience_years":"\u0633\u0646\u0648\u0627\u062A","uniform_title":"\u0647\u0644 \u0644\u062F\u064A\u0643 \u062A\u0641\u0636\u064A\u0644\u0627\u062A \u0645\u062D\u062F\u062F\u0647 \u0644\u0644\u0628\u0627\u0633 \u0627\u0644\u0631\u0633\u0645\u064A\u061F","uniform_subtitle":"\u0623\u062E\u0628\u0631\u0646\u0627 \u0625\u0630\u0627 \u0643\u0646\u062A \u062A\u062D\u062A\u0627\u062C \u0625\u0644\u0649 \u0645\u0644\u0627\u0628\u0633 \u0631\u0633\u0645\u064A\u0629 \u0623\u0648 \u063A\u064A\u0631 \u0631\u0633\u0645\u064A\u0629","uniform_dresscode":"\u0627\u0644\u0644\u0628\u0627\u0633 \u0627\u0644\u0631\u0633\u0645\u064A","preferences_title":"\u0647\u0644 \u0644\u062F\u064A\u0643 \u0627\u064A \u062A\u0641\u0636\u064A\u0644\u0627\u062A \u0625\u0636\u0627\u0641\u064A\u0629\u061F","preferences_subtitle":"\u062D\u062F\u062F \u0642\u0631\u0627\u0631\u0643 \u0641\u064A \u0627\u0644\u062A\u0641\u0636\u064A\u0644\u0627\u062A \u0627\u0644\u0625\u0636\u0627\u0641\u064A\u0629.","preferences_languages":"\u0627\u0644\u0644\u063A\u0629","preferences_gender":"\u0627\u0644\u062C\u0646\u0633","preferences_documents":"\u0645\u0633\u062A\u0646\u062F\u0627\u062A \u0625\u0636\u0627\u0641\u064A\u0629","preferences_interview":"\u0645\u0642\u0627\u0628\u0644\u0629 \u0641\u062F\u064A\u0648","nationalities":"Nationality","nationalities_title":"What are your preferred nationalities?","nationalities_subtitle":"Select specific nationalities that align with your hiring needs","nationalities_option_any":"Hire the best talent, regardless of nationality","preferences_manual_staff_selection":"\u0627\u062E\u062A\u064A\u0627\u0631 \u0627\u0644\u0645\u0648\u0638\u0641\u064A\u0646 \u064A\u062F\u0648\u064A\u0627","preferences_accreditation_required":"\u0627\u0644\u0627\u0639\u062A\u0645\u0627\u062F\u064A\u0629 \u0645\u0637\u0644\u0648\u0628\u0629","preferences_accommodation_offered":"\u0633\u0643\u0646 \u0645\u0624\u0645\u0646","accommodation_required":"\u0627\u0644\u0633\u0643\u0646 \u0645\u0637\u0644\u0648\u0628","accommodation_yes":"\u0646\u0639\u0645","accommodation_no":"\u0644\u0627","boarding_required":"\u062E\u062F\u0645\u0627\u062A \u0627\u0644\u062A\u063A\u0630\u064A\u0629 \u0645\u0637\u0644\u0648\u0628\u0629","transport_accessibility_required":"\u0627\u0644\u0645\u0648\u0627\u0635\u0644\u0627\u062A \u0645\u0637\u0644\u0648\u0628\u0629","preferences_boarding_offered":"\u062E\u062F\u0645\u0627\u062A \u0627\u0644\u062A\u063A\u0630\u064A\u0629 \u0645\u0624\u0645\u0646\u0629","accommodation_title":"\u0647\u0644 \u062A\u0624\u0645\u0646 \u062E\u062F\u0645\u0627\u062A \u0627\u0644\u062A\u0639\u0630\u064A\u0629 \u0644\u0647\u0630\u0627 \u0627\u0644\u062F\u0648\u0631\u061F","do_you_offer_accommodation":"\u0647\u0644 \u062A\u0642\u062F\u0645\u0648\u0646 \u0633\u0643\u0646\u0627\u064B \u0644\u0647\u0630\u0627 \u0627\u0644\u062F\u0648\u0631\u061F","no_boarding":"\u0644\u0627 \u064A\u0648\u062C\u062F \u062A\u0623\u0645\u064A\u0646 \u0644\u062E\u062F\u0645\u0627\u062A \u0627\u0644\u062A\u063A\u0630\u064A\u0629","half_boarding":"\u0648\u062C\u0628\u0629 \u0648\u0627\u062D\u062F\u0629","full_boarding":"\u062E\u062F\u0645\u0627\u062A \u062A\u063A\u0630\u064A\u0629 \u0643\u0627\u0645\u0644\u0629","languages_title":"\u0645\u0627 \u0647\u064A \u0627\u0644\u0644\u063A\u0629 \u0627\u0644\u062A\u064A \u062A\u0641\u0636\u0644\u0647\u0627\u061F","languages_subtitle":"\u0627\u062E\u062A\u0627\u0631 \u0627\u0644\u0644\u063A\u0627\u062A \u0627\u0644\u0645\u062D\u062F\u062F\u0629 \u0627\u0644\u062A\u064A \u064A\u062C\u0628 \u0623\u0646 \u064A\u062A\u062D\u062F\u062B \u0628\u0647\u0627 \u0627\u0644\u0645\u0648\u0638\u0641\u064A\u0646","gender_title":"\u0645\u0627 \u0647\u0648 \u062A\u0641\u0636\u064A\u0644\u0643 \u0644\u0644\u062C\u0646\u0633\u061F","gender_subtitle":"\u0627\u0644\u0631\u062C\u0627\u0621 \u0636\u0639 \u0627\u0644\u062C\u0646\u0633 \u0627\u0644\u0630\u064A \u062A\u0641\u0636\u0644\u0647 \u0625\u0646 \u0648\u062C\u062F","gender_male":"\u0630\u0643\u0631","gender_female":"\u0623\u0646\u062B\u0649","gender_no_preference":"\u0644\u0627","documents_title":"\u0645\u0627\u0647\u064A \u0645\u062A\u0637\u0644\u0628\u0627\u062A\u0643 \u0644\u0644\u0645\u0633\u062A\u0646\u062F\u0627\u062A \u0627\u0644\u0625\u0636\u0627\u0641\u064A\u0629\u061F","documents_subtitle":"\u062D\u062F\u062F \u0623\u0646\u0648\u0627\u0639 \u0627\u0644\u0645\u0633\u062A\u0646\u062F\u0627\u062A \u0627\u0644\u0625\u0636\u0627\u0641\u064A\u0629 \u0627\u0644\u0645\u0637\u0644\u0648\u0628\u0629","manual_selectinon_title":"\u0647\u0644 \u062A\u0631\u063A\u0628 \u0641\u064A \u0623\u0646 \u0646\u0642\u0648\u0645 \u0628\u062E\u062A\u064A\u0627\u0631 \u0627\u0644\u062A\u0644\u0642\u0627\u0626\u064A \u0644\u0623\u0641\u0636\u0644 \u0645\u0648\u0638\u0641\u064A \u0623\u0648\u063A\u0631\u0627\u0645 \u0644\u0644\u0639\u0645\u0644\u061F","manual_selectinon_subtitle":"\u0625\u0630\u0627 \u0627\u062E\u062A\u0631\u062A \\"\u0644\u0627\\"\u060C \u0641\u0633\u0648\u0641 \u064A\u062A\u0639\u064A\u0646 \u0644\u0643 \u0627\u0646 \u062A\u062E\u062A\u0627\u0631 \u0628\u0646\u0641\u0633\u0643 \u0645\u0648\u0638\u0641\u064A \u0623\u0648\u063A\u0631\u0627\u0645 \u0648 \u0644\u0646 \u062A\u0633\u062A\u0641\u064A\u062F \u0645\u0646 \u062E\u0648\u0631\u0627\u0632\u0645\u064A\u0629 \u0627\u062E\u062A\u064A\u0627\u0631 \u0627\u0644\u0645\u0648\u0638\u0641\u064A\u0646 \u0627\u0644\u0630\u0643\u064A\u0629 \u0644\u062F\u064A\u0646\u0627","manual_selectinon_yes":"\u0646\u0639\u0645","manual_selectinon_no":"\u0644\u0627","accreditation_title":"\u0647\u0644 \u064A\u062D\u062A\u0627\u062C \u0627\u0644\u0645\u0648\u0638\u0641\u0648\u0646 \u0625\u0644\u0649 \u0627\u0644\u0627\u0639\u062A\u0645\u0627\u062F \u0644\u062F\u062E\u0648\u0644 \u0627\u0644\u0645\u0643\u0627\u0646 \u0623\u0648 \u0627\u0644\u062D\u062F\u062B\u061F","accreditation_subtitle":"\u064A\u0631\u062C\u0649 \u0627\u0644\u0645\u0644\u0627\u062D\u0638\u0629 \u0623\u0646 \u0627\u0644\u0627\u0639\u062A\u0645\u0627\u062F \u0633\u064A\u0624\u062B\u0631 \u0639\u0644\u0649 \u0648\u0642\u062A \u0627\u0644\u062A\u0646\u0641\u064A\u0630 \u0644\u062F\u064A\u0646\u0627","accreditation_yes":"\u0646\u0639\u0645","accreditation_no":"\u0644\u0627","poc_title":"\u0645\u0646 \u0633\u064A\u062A\u0648\u0644\u0649 \u0623\u0645\u0631 \u0627\u0644\u062D\u0636\u0648\u0631\u061F","poc_subtitle":"\u0627\u062E\u062A\u0631 \u0634\u062E\u0635\u0627\u064B \u0627\u0644\u0630\u064A \u0633\u0648\u0641 \u064A\u0643\u0648\u0646 \u0646\u0642\u0637\u0629 \u0627\u0644\u0627\u062A\u0635\u0627\u0644 \u0627\u0644\u0631\u0626\u064A\u0633\u064A\u0629 \u0644\u0644\u0648\u0638\u064A\u0641\u0629","point_of_contact":"\u0646\u0642\u0637\u0629 \u0627\u0644\u0627\u062A\u0635\u0627\u0644","add_poc":"\u0625\u0636\u0627\u0641\u0629 \u0646\u0642\u0637\u0629 \u0627\u062A\u0635\u0627\u0644 \u062C\u062F\u064A\u062F\u0629","select_location_first":"\u0627\u0644\u0631\u062C\u0627\u0621 \u062A\u062D\u062F\u064A\u062F \u0645\u0648\u0642\u0639 \u0627\u0644\u0648\u0638\u064A\u0641\u0629 \u0623\u0648\u0644\u0627\u064B","poc_required":"\u0627\u0644\u0631\u062C\u0627\u0621 \u062A\u062D\u062F\u064A\u062F \u062C\u0647\u0629 \u0627\u0644\u0627\u062A\u0635\u0627\u0644","start_date_must_be_at_least_today":"\u062A\u0627\u0631\u064A\u062E \u0627\u0644\u0628\u062F\u0621 \u064A\u062C\u0628 \u0627\u0646 \u064A\u0628\u062F\u0621 \u0627\u0644\u064A\u0648\u0645 \u0639\u0644\u0649 \u0627\u0644\u0623\u0642\u0644","end_date_must_be_at_least_today":"\u062A\u0627\u0631\u064A\u062E \u0627\u0644\u0625\u0646\u062A\u0647\u0627\u0621 \u064A\u062C\u0628 \u0627\u0646 \u064A\u0628\u062F\u0621 \u0627\u0644\u064A\u0648\u0645 \u0639\u0644\u0649 \u0627\u0644\u0623\u0642\u0644","greece_launch_info":"\u064A\u0631\u062C\u0649 \u0627\u0644\u0645\u0644\u0627\u062D\u0638\u0629 \u0628\u0625\u0646 \u0627\u0644\u0637\u0644\u0628\u0627\u062A \u0644\u0627 \u064A\u0645\u0643\u0646 \u062A\u0642\u062F\u064A\u0645\u0647\u0627 \u0625\u0644\u0627 \u0627\u0639\u062A\u0628\u0627\u0631\u0627\u064B \u0645\u0646 1 \u064A\u0648\u0646\u064A\u0648. \u0641\u0646\u062D\u0646 \u0646\u0642\u0648\u0645 \u0628\u0645\u0639\u0627\u0644\u062C\u0629 \u0627\u0644\u0637\u0644\u0628\u0627\u062A \u062E\u0644\u0627\u0644 72 \u0633\u0627\u0639\u0629. \u0627\u064A \u0637\u0644\u0628\u0627\u062A \u0642\u062F \u062A\u0645 \u062A\u0642\u062F\u064A\u0645\u0647\u0627 \u0642\u0628\u0644 \u0647\u0630\u0627 \u0627\u0644\u062A\u0627\u0631\u064A\u062E \u0644\u0646 \u064A\u062A\u0645 \u0645\u0639\u0627\u0644\u062C\u062A\u0647\u0627. \u0634\u0643\u0631\u0627 \u0639\u0644\u0649 \u062A\u0641\u0647\u0645\u0643\u0645","select_document":"\u0627\u062E\u062A\u0627\u0631 \u0645\u0633\u062A\u0646\u062F","junior":"\u0645\u0628\u062A\u062F\u0626","midSenior":"\u0645\u0633\u062A\u0648\u0649 \u0645\u062A\u0648\u0633\u0637","senior":"\u0645\u0633\u062A\u0648\u0649 \u0639\u0627\u0644\u064A","student":"\u0637\u0627\u0644\u0628","beginner":"\u062C\u062F\u064A\u062F","interview_title":"\u0645\u0627 \u0647\u064A \u0627\u0644\u0645\u0648\u0627\u0636\u064A\u0639 \u0627\u0644\u0631\u0626\u064A\u0633\u064A\u0629 \u0627\u0644\u062A\u064A \u062A\u0631\u064A\u062F \u0627\u0646 \u062A\u0646\u0627\u0642\u0634\u0647\u0627 \u0645\u0639 \u0627\u0644\u0645\u062A\u0642\u062F\u0645\u064A\u0646\u061F","interview_subtitle":"\u0633\u0648\u0641 \u064A\u0642\u0648\u0645 \u0639\u0627\u0645\u0644 \u0623\u0648\u063A\u0631\u0627\u0645 \u0628\u062A\u0642\u062F\u064A\u0645 \u062A\u0633\u062C\u064A\u0644\u0627\u062A \u0627\u0644\u0641\u062F\u064A\u0648 \u0644\u0644\u0625\u062C\u0627\u0628\u0629 \u0639\u0644\u0649 \u0627\u0644\u0623\u0633\u0626\u0644\u0629","interview_new_question":"\u0625\u0636\u0627\u0641\u0629 \u0633\u0624\u0627\u0644 \u062C\u062F\u064A\u062F\u061F","interview_question_form_title":"\u0625\u0636\u0627\u0641\u0629 \u0633\u0624\u0627\u0644 \u062C\u062F\u064A\u062F","interview_question_form_placeholder":"\u0627\u0643\u062A\u0628 \u0627\u0644\u0648\u0635\u0641 \u0647\u0646\u0627","interview_question_form_submit":"\u062A\u0642\u062F\u064A\u0645","interview_question_created":"\u062A\u0645 \u0625\u0646\u0634\u0627\u0621 \u0627\u0644\u0633\u0624\u0627\u0644!","start_and_end_date_must_be_selected":"\u064A\u062C\u0628 \u0627\u0646 \u064A\u062A\u0645 \u0625\u062E\u062A\u064A\u0627\u0631 \u062A\u0627\u0631\u064A\u062E \u0627\u0644\u0628\u062F\u0621 {{startDate}} \u0648\u062A\u0627\u0631\u064A\u062E \u0627\u0644\u0625\u0646\u062A\u0647\u0627\u0621 {{endDate}}","what_are_the_shifts_timings":"\u0623\u062E\u0628\u0631\u0646\u0627 \u0639\u0646 \u0627\u0644\u062C\u062F\u0648\u0644 \u0627\u0644\u0632\u0645\u0646\u064A \u0644\u0647\u0630\u0647 \u0627\u0644\u0648\u0638\u064A\u0641\u0629:","what_are_job_timings":"\u0645\u0627 \u0647\u064A \u0645\u0648\u0627\u0639\u064A\u062F \u0627\u0644\u0639\u0645\u0644\u061F","select_same_time":"\u062D\u062F\u062F \u0627\u0644\u0648\u0642\u062A \u0627\u0644\u0630\u064A \u062A\u0631\u064A\u062F \u0623\u0646 \u064A\u0639\u0645\u0644 \u0641\u064A\u0647 \u0627\u0644\u0645\u0648\u0638\u0641\u064A\u0646 \u0643\u0644 \u064A\u0648\u0645","start_and_ends_are_same":"\u0627\u0644\u0645\u0646\u0627\u0648\u0628\u0627\u062A \u0633\u062A\u0628\u062F\u0623 \u0648 \u062A\u0646\u062A\u0647\u064A \u0641\u064A \u0646\u0641\u0633 \u0627\u0644\u0648\u0642\u062A \u0643\u0644 \u064A\u0648\u0645","time_vary":"\u062A\u062E\u062A\u0644\u0641 \u0627\u0644\u0645\u0646\u0627\u0648\u0628\u0627\u062A \u0645\u0646 \u064A\u0648\u0645 \u0644\u0622\u062E\u0631","less_than_24h_warning":"\u0633\u064A\u0628\u062F\u0627 \u0627\u0644\u0639\u0645\u0644 \u0641\u064A \u0623\u0642\u0644 \u0645\u0646 24 \u0633\u0627\u0639\u0629 \u0648\u0642\u062F \u0644\u0627 \u064A\u0643\u0648\u0646 \u0644\u062F\u064A\u0646\u0627 \u0627\u0644\u0648\u0642\u062A \u0627\u0644\u0643\u0627\u0641\u064A \u0644\u0625\u0646\u062C\u0627\u0632\u0647\u0627.","job_was_prefilled":"The form was pre-filled based on the last job data","invited_quantity_more_than_required_quantity":"You have selected more OGs than required in the job. In this case, the first who accepts will be assigned to the job"},"order_requested":{"title":"\u0634\u0643\u0631\u0627 \u0644\u0643!","subtitle":"\u0644\u0642\u062F \u062A\u0644\u0642\u0649 \u0641\u0631\u064A\u0642\u0646\u0627 \u0637\u0644\u0628\u0643 \u0648\u0633\u0646\u0642\u0648\u0645 \u0628\u0627\u0644\u0631\u062F \u0639\u0644\u064A\u0643 \u0642\u0631\u064A\u0628\u064B\u0627!","done":"\u062A\u0645","complete_registration":"\u0627\u0643\u0645\u0644 \u0627\u0644\u062A\u0633\u062C\u064A\u0644","later":"\u0644\u0627\u062D\u0642\u0627\u064B"},"order_draft":{"title":"\u0625\u0646\u0634\u0627\u0621 \u0637\u0644\u0628 \u062C\u062F\u064A\u062F","jobs":"\u0627\u0644\u0648\u0638\u0627\u0626\u0641","confirm_delete_job":"\u0647\u0644 \u0627\u0646\u062A \u0645\u062A\u0623\u0643\u062F \u0645\u0646 \u0627\u0646\u0643 \u062A\u0631\u064A\u062F \u062D\u0630\u0641 \u0648\u0638\u064A\u0641\u0629 {{name}} ?","add_another_job":"+ \u0623\u0636\u0641 \u0648\u0638\u064A\u0641\u0629 \u0623\u062E\u0631\u0649","add_another_job_with_plus":"\u0623\u0636\u0641 \u0648\u0638\u064A\u0641\u0629 \u0623\u062E\u0631\u0649","add_first_job":"\u0625\u0636\u0627\u0641\u0629 \u0627\u0644\u0648\u0638\u064A\u0641\u0629 \u0627\u0644\u0623\u0648\u0644\u0649","continue":"\u0627\u0643\u0645\u0644","quantity":"\u0627\u0644\u0643\u0645\u064A\u0629","days":"\u0623\u064A\u0627\u0645","days_amount":"{{count}} \u064A\u0648\u0645","location":"\u0627\u0644\u0645\u0648\u0642\u0639","what_to_copy":"\u0645\u0627 \u0627\u0644\u0648\u0638\u064A\u0641\u0629 \u0627\u0644\u062A\u064A \u062A\u0641\u0636\u0644 \u0645\u0646 {{category}} \u0623\u0646 \u062A\u0631\u063A\u0628 \u0628\u0623\u0646 \u062A\u0642\u0648\u0645 \u0627\u0644\u0646\u0633\u062E \u0645\u0646\u0647\u0627 \u061F","select_preferences":"\u0627\u0644\u0631\u062C\u0627\u0621 \u0627\u062E\u062A\u064A\u0627\u0631 \u0645\u0627 \u062A\u062D\u062A\u0627\u062C\u0647 \u0644\u0644\u0646\u0633\u062E \u0625\u0644\u064A\u0647 \u0645\u0646 \u0627\u0644\u062A\u0641\u0636\u064A\u0644\u0627\u062A","schedule":"\u0627\u0644\u062C\u062F\u0648\u0644","requirements":"\u0627\u0644\u0645\u062A\u0637\u0644\u0628\u0627\u062A","job_description":"\u0648\u0635\u0641 \u0627\u0644\u0648\u0638\u064A\u0641\u0629","seniority_level":"\u0645\u0633\u062A\u0648\u0649 \u0627\u0644\u062E\u0628\u0631\u0629","dresscode":"\u0627\u0644\u0632\u064A \u0627\u0644\u0631\u0633\u0645\u064A","language":"\u0627\u0644\u0644\u063A\u0629","gender":"\u0627\u0644\u062C\u0646\u0633","documents":"\u0645\u0633\u062A\u0646\u062F\u0627\u062A \u0625\u0636\u0627\u0641\u064A\u0629","manual_selection":"\u0627\u062E\u062A\u064A\u0627\u0631 \u0627\u0644\u0645\u0648\u0638\u0641\u064A\u0646 \u064A\u062F\u0648\u064A\u0627","accreditation_requried":"\u0627\u0644\u0627\u0639\u062A\u0645\u0627\u062F\u064A\u0629 \u0645\u0637\u0644\u0648\u0628\u0629","accommodation_offered":"\u0633\u0643\u0646 \u0645\u0624\u0645\u0646","interview_required":"\u0645\u0642\u0627\u0628\u0644\u0629 \u0641\u062F\u064A\u0648","boarding_offered":"\u062E\u062F\u0645\u0627\u062A \u0627\u0644\u062A\u063A\u0630\u064A\u0629 \u0645\u0624\u0645\u0646\u0629","duplicate_job":"\u0646\u0633\u062E \u0627\u0644\u0648\u0638\u064A\u0641\u0629","blank_job":"\u0648\u0638\u064A\u0641\u0629 \u0641\u0627\u0631\u063A\u0629","workers":"\u0639\u0645\u0627\u0644","jobs_count":"{{count}} \u0648\u0638\u064A\u0641\u0629","public_transport_accessibility":"\u0625\u0645\u0643\u0627\u0646\u064A\u0629 \u0627\u0644\u0648\u0635\u0648\u0644 \u0625\u0644\u0649 \u0648\u0633\u0627\u0626\u0644 \u0627\u0644\u0646\u0642\u0644 \u0627\u0644\u0639\u0627\u0645","public_transport_accessibility_accessible":"\u0646\u0639\u0645\u060C \u0625\u0646\u0647 \u0628\u0627\u0644\u0642\u0631\u0628 \u0645\u0646 \u0645\u062D\u0637\u0629 \u062D\u0627\u0641\u0644\u0627\u062A / \u0645\u062D\u0637\u0629 \u0645\u062A\u0631\u0648","public_transport_accessibility_not_accessible":"\u0644\u0627\u060C \u0644\u064A\u0633 \u0645\u0646 \u0627\u0644\u0633\u0647\u0644 \u0627\u0644\u0648\u0635\u0648\u0644 \u0625\u0644\u064A\u0647 \u0639\u0646 \u0637\u0631\u064A\u0642 \u0648\u0633\u0627\u0626\u0644 \u0627\u0644\u0646\u0642\u0644 \u0627\u0644\u0639\u0627\u0645\u0629","is_location_accessible_by_transport":"\u0647\u0644 \u064A\u0645\u0643\u0646 \u0627\u0644\u0648\u0635\u0648\u0644 \u0625\u0644\u0649 \u0647\u0630\u0627 \u0627\u0644\u0645\u0648\u0642\u0639 \u0639\u0646 \u0637\u0631\u064A\u0642 \u0648\u0633\u0627\u0626\u0644 \u0627\u0644\u0646\u0642\u0644 \u0627\u0644\u0639\u0627\u0645\u061F","tell_if_location_is_reachable":"\u0623\u062E\u0628\u0631\u0646\u0627 \u0625\u0630\u0627 \u0643\u0627\u0646 \u0645\u0646 \u0627\u0644\u0645\u0645\u0643\u0646 \u0627\u0644\u0648\u0635\u0648\u0644 \u0625\u0644\u0649 \u0645\u0648\u0642\u0639\u0643 \u0628\u0627\u0644\u062D\u0627\u0641\u0644\u0629 \u0623\u0648 \u0627\u0644\u0645\u062A\u0631\u0648.","pricing":{"best_price_1":"\u0623\u0641\u0636\u0644 \u0633\u0639\u0631 \u0645\u0636\u0645\u0648\u0646","best_price_2":"\u0646\u0645\u0648\u0630\u062C \u0627\u0644\u062A\u0633\u0639\u064A\u0631 \u0644\u062F\u064A\u0646\u0627 \u0645\u0635\u0645\u0645 \u0628\u0634\u0643\u0644 \u062F\u064A\u0646\u0627\u0645\u064A\u0643\u064A\u060C \u0645\u0639 \u0627\u0644\u0623\u062E\u0630 \u0641\u064A \u0627\u0644\u0627\u0639\u062A\u0628\u0627\u0631 \u0627\u0644\u0637\u0644\u0628 \u0627\u0644\u062D\u0627\u0644\u064A \u0641\u064A \u0627\u0644\u0633\u0648\u0642.","best_price_3":"\u0647\u0630\u0627 \u0627\u0644\u0623\u0633\u0644\u0648\u0628 \u064A\u062A\u064A\u062D \u0644\u0646\u0627 \u0623\u0646 \u0646\u0642\u062F\u0645 \u0644\u0643 \u0628\u0627\u0633\u062A\u0645\u0631\u0627\u0631 \u0623\u0641\u0636\u0644 \u0642\u064A\u0645\u0629 \u0648\u062E\u062F\u0645\u0627\u062A \u062A\u062A\u0648\u0642\u0639\u0647\u0627 \u0645\u0646\u0627. \u062A\u0648\u0627\u0635\u0644 \u0645\u0639\u0646\u0627 \u0641\u064A \u0623\u064A \u0648\u0642\u062A \u0644\u0644\u062D\u0635\u0648\u0644 \u0639\u0644\u0649 \u0645\u0632\u064A\u062F \u0645\u0646 \u0627\u0644\u0645\u0639\u0644\u0648\u0645\u0627\u062A.","best_price_4":"\u0627\u0637\u0644\u0628 \u0645\u0643\u0627\u0644\u0645\u0629 \u0645\u0646 \u0642\u0633\u0645 \u0641\u0631\u064A\u0642 \u0627\u0644\u0645\u0628\u064A\u0639\u0627\u062A","estimated_total":"\u0627\u0644\u0645\u062C\u0645\u0648\u0639 \u0627\u0644\u062A\u0642\u062F\u064A\u0631\u064A*","type":"\u0627\u0644\u0646\u0648\u0639","hours":"\u0633\u0627\u0639\u0627\u062A","hourly_rate":"\u0645\u0639\u062F\u0644 \u0627\u0644\u0633\u0639\u0631 \u0628\u0627\u0644\u0633\u0627\u0639\u0629"},"callback_request_sent":"\u0644\u0642\u062F \u062A\u0645 \u0625\u0631\u0633\u0627\u0644 \u0637\u0644\u0628\u0643 \u0628\u0646\u062C\u0627\u062D","end_date":"\u062A\u0627\u0631\u064A\u062E \u0627\u0644\u0625\u0646\u062A\u0647\u0627\u0621","start_date":"\u062A\u0627\u0631\u064A\u062E \u0627\u0644\u0628\u062F\u0621","updated":"\u062A\u0645 \u062A\u062D\u062F\u064A\u062B","n_hours":"{{hours}} \u0633\u0627\u0639\u0627\u062A","edit_job":"\u062A\u0639\u062F\u064A\u0644 \u0639\u0644\u0649 \u0627\u0644\u0648\u0638\u064A\u0641\u0629"},"order_extension":{"how_to_extend":"\u0643\u064A\u0641 \u062A\u0631\u064A\u062F \u062A\u0645\u062F\u064A\u062F \u062A\u0648\u0627\u0631\u064A\u062E \u0627\u0644\u0648\u0638\u0627\u0626\u0641\u061F","you_can_extend_order":"\u0644\u062F\u064A\u0643 \u0627\u0644\u0642\u062F\u0631\u0629 \u0639\u0644\u0649 \u062A\u0645\u062F\u064A\u062F \u062A\u0648\u0627\u0631\u064A\u062E \u0627\u0644\u0648\u0638\u0627\u0626\u0641","same_extension_date":"\u062A\u0627\u0631\u064A\u062E \u0627\u0644\u0625\u0646\u062A\u0647\u0627\u0621 \u0627\u0644\u062C\u062F\u064A\u062F \u0647\u0648 \u0646\u0641\u0633\u0647 \u0644\u062C\u0645\u064A\u0639 \u0627\u0644\u0648\u0638\u0627\u0626\u0641","different_extension_dates":"\u062A\u0645\u062F\u064A\u062F \u0627\u0644\u0648\u0638\u0627\u0626\u0641 \u0644\u0641\u062A\u0631\u0627\u062A \u0645\u062E\u062A\u0644\u0641\u0629","for_how_long_extend":"\u0625\u0644\u0649 \u0645\u062A\u0649 \u062A\u0631\u064A\u062F \u0627\u0646 \u062A\u0645\u062F\u062F \u0648\u0638\u0627\u0626\u0641\u0643\u061F","do_not_extend":"\u0644\u0627 \u062A\u0645\u062F\u062F","select_date":"\u062D\u062F\u062F \u0627\u0644\u062A\u0627\u0631\u064A\u062E","select_start_date":"\u062D\u062F\u062F \u062A\u0627\u0631\u064A\u062E \u0627\u0644\u0628\u062F\u0621","select_end_date":"\u062D\u062F\u062F \u062A\u0627\u0631\u064A\u062E \u0627\u0644\u0625\u0646\u062A\u0647\u0627\u0621","extend_order":"\u062A\u0645\u062F\u064A\u062F \u0627\u0644\u0637\u0644\u0628","schedule_description":"\u0627\u0644\u0623\u064A\u0627\u0645 \u0627\u0644\u062A\u064A \u062A\u062D\u062A\u0627\u062C \u0625\u0644\u064A\u0647\u0627 \u0627\u0644\u0645\u0648\u0638\u0641\u064A\u0646 \u0644\u0644\u0639\u0645\u0644","edit":"\u062A\u0639\u062F\u064A\u0644","done":"\u062A\u0645","full_schedule":"\u0627\u0644\u062C\u062F\u0648\u0644 \u0627\u0644\u0643\u0627\u0645\u0644","current_end_date":"Current End Date:","select_sps":"Select Ogrammers","select_sps_to_extend":"Select Ogrammers you want to extend"},"order_confirmed":{"title":"\u062A\u0645 \u062A\u0623\u0643\u064A\u062F \u0627\u0644\u0637\u0644\u0628","description":"\u0634\u0643\u0631\u0627 \u0644\u0643 \u0639\u0644\u0649 \u062A\u0623\u0643\u064A\u062F \u0627\u0644\u0637\u0644\u0628.","done":"\u062A\u0645"},"attendance_manager_form":{"first_name":"\u0627\u0644\u0627\u0633\u0645 \u0627\u0644\u0623\u0648\u0644","last_name":"\u0627\u0633\u0645 \u0627\u0644\u0639\u0627\u0626\u0644\u0629","phone":"\u0631\u0642\u0645 \u0627\u0644\u0647\u0627\u062A\u0641","email":"\u0627\u0644\u0628\u0631\u064A\u062F \u0627\u0644\u0625\u0644\u0643\u062A\u0631\u0648\u0646\u064A","job_role":"\u0627\u0644\u062F\u0648\u0631 \u0627\u0644\u0648\u0638\u064A\u0641\u064A","save":"\u062D\u0641\u0638","edit_attendance_manager":"\u062A\u0639\u062F\u064A\u0644 \u0645\u062F\u064A\u0631 \u0627\u0644\u062D\u0636\u0648\u0631","add_attendance_manager":"\u0625\u0636\u0627\u0641\u0629 \u0645\u062F\u064A\u0631 \u0627\u0644\u062D\u0636\u0648\u0631"},"attendance_manager_list":{"title":"\u0645\u062F\u0631\u0627\u0621 \u0627\u0644\u062D\u0636\u0648\u0631","add_manager":"\u0625\u0636\u0627\u0641\u0629 \u0645\u062F\u064A\u0631","edit":"\u062A\u0639\u062F\u064A\u0644"},"company_form":{"title":"\u062A\u0641\u0627\u0635\u064A\u0644 \u0627\u0644\u0634\u0631\u0643\u0629","saved":"\u062A\u0645 \u0627\u0644\u062D\u0641\u0638","company_name":"\u0627\u0633\u0645 \u0627\u0644\u0634\u0631\u0643\u0629","company_name_as_in_license":"\u0627\u0633\u0645 \u0627\u0644\u0634\u0631\u0643\u0629 \u0643\u0645\u0627 \u0647\u0648 \u0645\u0630\u0643\u0648\u0631 \u0641\u064A \u0627\u0644\u0631\u062E\u0635\u0629 \u0627\u0644\u062A\u062C\u0627\u0631\u064A\u0629","address":"\u0627\u0644\u0639\u0646\u0648\u0627\u0646","po_box":"\u0635\u0646\u062F\u0648\u0642 \u0627\u0644\u0628\u0631\u064A\u062F","vat_certificate":"\u0634\u0647\u0627\u062F\u0629 \u0636\u0631\u064A\u0628\u0629 \u0627\u0644\u0642\u064A\u0645\u0629 \u0627\u0644\u0645\u0636\u0627\u0641\u0629","trade_license":"\u0627\u0644\u0631\u062E\u0635\u0629 \u0627\u0644\u062A\u062C\u0627\u0631\u064A\u0629","finance_first_name":"\u0627\u0644\u0627\u0633\u0645 \u0627\u0644\u0623\u0648\u0644 \u0644\u0645\u0648\u0638\u0641 \u0627\u0644\u0645\u0627\u0644\u064A\u0629","finance_last_name":"\u0627\u0633\u0645 \u0627\u0644\u0639\u0627\u0626\u0644\u0629 \u0644\u0645\u0648\u0638\u0641 \u0627\u0644\u0645\u0627\u0644\u064A\u0629","finance_phone":"\u0647\u0627\u062A\u0641 \u0645\u0648\u0638\u0641 \u0627\u0644\u0645\u0627\u0644\u064A\u0629","finance_email":"\u0627\u0644\u0628\u0631\u064A\u062F \u0627\u0644\u0625\u0644\u0643\u062A\u0631\u0648\u0646\u064A \u0644\u0645\u0648\u0638\u0641 \u0627\u0644\u0645\u0627\u0644\u064A\u0629","extension":"\u0625\u0636\u0627\u0641\u0629","save":"\u062D\u0641\u0638"},"invoice":{"invoice_#":"\u0641\u0627\u062A\u0648\u0631\u0629#{{index}}","export_pdf":"\u062A\u0635\u062F\u064A\u0631 \u0645\u0644\u0641 (PDF)","exporting":"\u062C\u0627\u0631\u064A \u0627\u0644\u062A\u0635\u062F\u064A\u0631...","report_issue":"\u0627\u0644\u0625\u0628\u0644\u0627\u063A \u0639\u0646 \u0645\u0634\u0643\u0644\u0629","details":"\u062A\u0641\u0627\u0635\u064A\u0644","invoice_number":"\u0631\u0642\u0645 \u0627\u0644\u0641\u0627\u062A\u0648\u0631\u0629","date":"\u0627\u0644\u062A\u0627\u0631\u064A\u062E","due_date":"\u062A\u0627\u0631\u064A\u062E \u0627\u0644\u0627\u0633\u062A\u062D\u0642\u0627\u0642","status":"\u0627\u0644\u062D\u0627\u0644\u0629","pending":"\u0642\u064A\u062F \u0627\u0644\u0627\u0646\u062A\u0638\u0627\u0631","paid":"\u062A\u0645 \u0627\u0644\u062F\u0641\u0639","costs":"\u0627\u0644\u062A\u0643\u0627\u0644\u064A\u0641","subtotal":"\u0627\u0644\u0645\u062C\u0645\u0648\u0639 \u0627\u0644\u0641\u0631\u0639\u064A","transportation":"\u0648\u0633\u0627\u0626\u0644 \u0627\u0644\u0646\u0642\u0644","vat_percent":"\u0636\u0631\u064A\u0628\u0629 \u0627\u0644\u0642\u064A\u0645\u0629 \u0627\u0644\u0645\u0636\u0627\u0641\u0629({{count}}%)","total":"\u0627\u0644\u0645\u062C\u0645\u0648\u0639","breakdown":"\u0627\u0644\u062A\u0641\u0627\u0635\u064A\u0644","pay_now":"\u0633\u062F\u062F \u0627\u0644\u0622\u0646","total_shifts":"\u0645\u062C\u0645\u0648\u0639 \u0627\u0644\u0645\u0646\u0627\u0648\u0628\u0627\u062A","total_hours":"\u0645\u062C\u0645\u0648\u0639 \u0627\u0644\u0633\u0627\u0639\u0627\u062A","total_ogs":"\u0645\u062C\u0645\u0648\u0639 \u0639\u0645\u0627\u0644 \u0623\u0648\u063A\u0631\u0627\u0645","shifts":"\u0627\u0644\u0645\u0646\u0627\u0648\u0628\u0627\u062A","hours":"\u0627\u0644\u0633\u0627\u0639\u0627\u062A","amount":"\u0627\u0644\u0645\u0628\u0627\u0644\u063A","report_issue_modal_title":"\u0627\u0644\u0625\u0628\u0644\u0627\u063A \u0639\u0646 \u0645\u0634\u0643\u0644\u0629","report_issue_message_required":"\u0627\u0644\u0631\u0633\u0627\u0644\u0629 \u0645\u0637\u0644\u0648\u0628\u0629","report_issue_message_placeholder":"\u064A\u0631\u062C\u0649 \u0648\u0635\u0641 \u0645\u0634\u0643\u0644\u062A\u0643","report_issue_submit":"\u062A\u0642\u062F\u064A\u0645","report_issue_cancel":"\u0625\u0644\u063A\u0627\u0621","issue_was_reported":"\u062A\u0645 \u0627\u0644\u0625\u0628\u0644\u0627\u063A \u0639\u0646 \u0645\u0634\u0643\u0644\u062A\u0643","issue_is_submitting":"\u064A\u062A\u0645 \u0627\u0644\u062A\u062D\u0645\u064A\u0644..."},"invoice_card":{"invoice_#":"\u0631\u0642\u0645 #{{index}}","due_days_ago":"\u062A\u0633\u062A\u062D\u0642 \u0645\u0646\u0630 {{count}} \u0627\u064A\u0627\u0645","due_today":"\u062A\u0633\u062A\u062D\u0642 \u0627\u0644\u064A\u0648\u0645","due_tomorrow":"\u062A\u0633\u062A\u062D\u0642 \u063A\u062F\u0627\u064B","due_days_ahead":"\u062A\u0633\u062A\u062D\u0642 \u0641\u064A {{count}} \u0623\u064A\u0627\u0645 \u0627\u0644\u0642\u0627\u062F\u0645\u0629"},"invoice_ogrammer":{"og_details":"\u062A\u0641\u0627\u0635\u064A\u0644 \u0645\u0648\u0638\u0641 \u0623\u0648\u063A\u0631\u0627\u0645","job":"\u0627\u0644\u0648\u0638\u064A\u0641\u0629","location":"\u0627\u0644\u0645\u0648\u0642\u0639","shifts":"\u0627\u0644\u0645\u0646\u0627\u0648\u0628\u0627\u062A","hours":"\u0627\u0644\u0633\u0627\u0639\u0627\u062A","amount_due":"\u0627\u0644\u0645\u0628\u0644\u063A \u0627\u0644\u0645\u0633\u062A\u062D\u0642","shift_details":"\u062A\u0641\u0627\u0635\u064A\u0644 \u0627\u0644\u0645\u0646\u0627\u0648\u0628\u0627\u062A","day":"\u064A\u0648\u0645","approved_by":"\u062A\u0645\u062A \u0627\u0644\u0645\u0648\u0627\u0641\u0642\u0629 \u0645\u0646 \u0642\u0628\u0644"},"profile_form":{"title":"\u062A\u0639\u062F\u064A\u0644 \u0627\u0644\u0645\u0644\u0641 \u0627\u0644\u0634\u062E\u0635\u064A","first_name_required":"\u0627\u0644\u0627\u0633\u0645 \u0627\u0644\u0623\u0648\u0644 \u0645\u0637\u0644\u0648\u0628","last_name_required":"\u0627\u0633\u0645 \u0627\u0644\u0639\u0627\u0626\u0644\u0629 \u0645\u0637\u0644\u0648\u0628","phone_required":"\u0631\u0642\u0645 \u0627\u0644\u0647\u0627\u062A\u0641 \u0645\u0637\u0644\u0648\u0628","email_required":"\u0627\u0644\u0628\u0631\u064A\u062F \u0627\u0644\u0625\u0644\u0643\u062A\u0631\u0648\u0646\u064A \u0645\u0637\u0644\u0648\u0628","upload_photo":"\u0631\u0641\u0639 \u0627\u0644\u0635\u0648\u0631\u0629","private":"\u062E\u0627\u0635","corporate":"\u0634\u0631\u0643\u0629","register_corporate":"\u062A\u0633\u062C\u064A\u0644 \u0634\u0631\u0643\u0629","first_name":"\u0627\u0644\u0627\u0633\u0645 \u0627\u0644\u0623\u0648\u0644","last_name":"\u0627\u0633\u0645 \u0627\u0644\u0639\u0627\u0626\u0644\u0629","phone":"\u0631\u0642\u0645 \u0627\u0644\u0647\u0627\u062A\u0641","email":"\u0627\u0644\u0628\u0631\u064A\u062F \u0627\u0644\u0625\u0644\u0643\u062A\u0631\u0648\u0646\u064A","save":"\u062D\u0641\u0638","cancel":"\u0625\u0644\u063A\u0627\u0621","sign_out":"\u062A\u0633\u062C\u064A\u0644 \u0627\u0644\u062E\u0631\u0648\u062C","agree_to_emails":"\u0623\u0648\u0627\u0641\u0642 \u0639\u0644\u0649 \u062A\u0644\u0642\u064A \u0625\u0634\u0639\u0627\u0631\u0627\u062A \u0627\u0644\u062A\u0633\u0648\u064A\u0642 \u0645\u0646 \u0623\u0648\u063A\u0631\u0627\u0645"},"rating_request_list":{"title":"\u0637\u0644\u0628\u0627\u062A \u0627\u0644\u062A\u0642\u064A\u064A\u0645","empty_list":"\u0644\u0627 \u062A\u0648\u062C\u062F \u0637\u0644\u0628\u0627\u062A \u0645\u0639\u0644\u0642\u0629"},"rating_request_panel":{"title":"\u0637\u0644\u0628\u0627\u062A \u0627\u0644\u062A\u0642\u064A\u064A\u0645","action":"\u0642\u064A\u0645 \u0627\u0644\u0622\u0646"},"job_rating":{"title":"\u062A\u0642\u064A\u064A\u0645 \u0627\u062F\u0627\u0621 \u0627\u0644\u0648\u0638\u064A\u0641\u0629","how_was_experience_question":"\u0643\u064A\u0641 \u0643\u0627\u0646\u062A \u062A\u062C\u0631\u0628\u062A\u0643 \u0628\u0634\u0643\u0644 \u0639\u0627\u0645\u061F","please_rate_team":"\u064A\u0631\u062C\u0649 \u062A\u0642\u064A\u064A\u0645 \u062C\u0645\u064A\u0639 \u0623\u0639\u0636\u0627\u0621 \u0627\u0644\u0641\u0631\u064A\u0642","tell_us_about_ogs":"\u0627\u062E\u0628\u0631\u0646\u0627 \u0627\u0644\u0645\u0632\u064A\u062F \u0639\u0646 \u0623\u0639\u0636\u0627\u0621 \u0623\u0648\u063A\u0631\u0627\u0645","tell_us_which_stood_out":"\u0623\u062E\u0628\u0631\u0646\u0627 \u0627\u064A \u0645\u0646\u0647\u0645 \u0628\u0631\u0632 \u0627\u0643\u062B\u0631\u060C \u0648 \u0627\u064A \u0645\u0646\u0647\u0645 \u064A\u062D\u062A\u0627\u062C \u0627\u0644\u0639\u0645\u0644 \u0639\u0644\u0649 \u062A\u062D\u0633\u064A\u0646 \u0627\u062F\u0627\u0647","confirm":"\u062A\u0623\u0643\u064A\u062F","comment":"\u062A\u0639\u0644\u064A\u0642","provide_overall_rating":"\u064A\u0631\u062C\u0649 \u062A\u0642\u062F\u064A\u0645 \u062A\u0642\u064A\u064A\u0645 \u0634\u0627\u0645\u0644","provide_og_rating":"\u064A\u0631\u062C\u0649 \u062A\u0642\u062F\u064A\u0645 \u062A\u0642\u064A\u064A\u0645 \u0644\u0639\u0636\u0648 \u0623\u0648\u063A\u0631\u0627\u0645","provide_ogrammers_rating":"\u064A\u0631\u062C\u0649 \u062A\u0642\u062F\u064A\u0645 \u062A\u0642\u064A\u064A\u0645 \u0644\u0623\u0639\u0636\u0627\u0621 \u0623\u0648\u063A\u0631\u0627\u0645","thank_you_for_submitting":"\u0634\u0643\u0631\u0627 \u0644\u0643 \u0639\u0644\u0649 \u062A\u0642\u062F\u064A\u0645 \u0627\u0644\u062A\u0642\u064A\u064A\u0645!","rate_workers":"Rate Your Recent Workers","importance_of_rating":"Your feedback helps us <strong>match you with top workers</strong> and supports Ogrammers in <strong>growing their careers</strong>. Take a moment to rate now!","rating_submitted":"Rating submitted. Thank you!"},"shifts_attendance_list":{"title":"\u0645\u0631\u0627\u062C\u0639\u0629 \u0627\u0644\u062D\u0636\u0648\u0631","empty_list":"\u0644\u0627 \u064A\u0648\u062C\u062F \u062A\u0642\u0627\u0631\u064A\u0631 \u062D\u0636\u0648\u0631 \u0645\u0639\u0644\u0642\u0629","review_now":"\u0642\u0645 \u0628\u0627\u0644\u0645\u0631\u0627\u062C\u0639\u0629 \u0627\u0644\u0622\u0646","all_designations":"\u062C\u0645\u064A\u0639 \u0627\u0644\u0645\u0633\u0645\u064A\u0627\u062A \u0627\u0644\u0648\u0638\u064A\u0641\u064A\u0629"},"shifts_attendance_details":{"attended_question":"\u062D\u0636\u0631\u061F","attended":"\u062D\u0636\u0631","not_attended":"\u0644\u0645 \u064A\u062D\u0636\u0631","did_not":"\u0644\u0645","confirm_amount":"\u062A\u0623\u0643\u064A\u062F({{count}})"},"shift_attendance_common":{"are_you_sure_og_worked_n_hours":"\u0647\u0644 \u0623\u0646\u062A \u0645\u062A\u0623\u0643\u062F \u0645\u0646 \u0623\u0646 {{name}} \u0639\u0645\u0644 \u0644\u0645\u062F\u0629 {{hours}} \u0633\u0627\u0639\u0627\u062A\u061F \u0625\u0646\u0647 \u0623\u0642\u0644 \u0645\u0646 {{difference}} \u0633\u0627\u0639\u0629 \u0645\u0646 \u0627\u0644\u0645\u062F\u0629 \u0627\u0644\u0645\u062D\u062C\u0648\u0632\u0629.","no_show":"\u0639\u062F\u0645 \u0627\u0644\u0638\u0647\u0648\u0631","limited_time_to_confirm":"\u0648\u0642\u062A \u0645\u062D\u062F\u062F \u0644\u0644\u062A\u0623\u0643\u064A\u062F","time_to_review_description":"\u0642\u0645 \u0628\u062A\u0623\u0643\u064A\u062F \u0627\u0644\u062D\u0636\u0648\u0631 \u0641\u064A \u0623\u0642\u0631\u0628 \u0648\u0642\u062A \u0645\u0645\u0643\u0646 \u0644\u062A\u062C\u0646\u0628 \u0627\u0644\u0641\u0648\u0627\u062A\u064A\u0631 \u063A\u064A\u0631 \u0627\u0644\u0635\u062D\u064A\u062D\u0629","i_understand":"\u0642\u062F \u0641\u0647\u0645\u062A","n_minutes":"{{count}} \u062F\u0642\u064A\u0642\u0629","n_hours":"{{hours}} \u0633\u0627\u0639\u0629","select_reason":"\u0627\u062E\u062A\u0627\u0631 \u0627\u0644\u0633\u0628\u0628","update":"\u062A\u062D\u062F\u064A\u062B","cancel":"\u0625\u0644\u063A\u0627\u0621","hours_left":"{{count}} \u0633\u0627\u0639\u0629 \u0645\u062A\u0628\u0642\u064A\u0629","urgent":"\u0639\u0627\u062C\u0644","check_in":"\u062A\u0633\u062C\u064A\u0644 \u0627\u0644\u062D\u0636\u0648\u0631","check_out":"\u062A\u0633\u062C\u064A\u0644 \u0627\u0644\u0645\u063A\u0627\u062F\u0631\u0629","update_hours":"\u062A\u062D\u062F\u064A\u062B {{count}} \u0633\u0627\u0639\u0627\u062A","add_hours":"\u0625\u0636\u0627\u0641\u0629 {{count}} \u0633\u0627\u0639\u0629","attendance_confirmed":"\u062A\u0645 \u062A\u0623\u0643\u064A\u062F \u0627\u0644\u062D\u0636\u0648\u0631","thanks_for_confirming":"\u0634\u0643\u0631\u0627 \u0644\u0643 \u0639\u0644\u0649 \u062A\u0623\u0643\u064A\u062F \u062D\u0636\u0648\u0631 \u0623\u0639\u0636\u0627\u0621 \u0623\u0648\u063A\u0631\u0627\u0645.","done":"\u062A\u0645","day_off":"\u064A\u0648\u0645 \u0639\u0637\u0644\u0629","total_hours":"\u0645\u062C\u0645\u0648\u0639 \u0627\u0644\u0633\u0627\u0639\u0627\u062A","shift_duration_too_long":"\u0644\u0627 \u064A\u062C\u0628 \u0627\u0646 \u062A\u062A\u062C\u0627\u0648\u0632 \u0627\u0644\u0645\u0646\u0627\u0648\u0628\u0629 \u0645\u062F\u0629 12 \u0633\u0627\u0639\u0629"},"user_management":{"users":"\u0627\u0644\u0645\u0633\u062A\u062E\u062F\u0645\u0648\u0646","add_new_user":"\u0625\u0636\u0627\u0641\u0629 \u0645\u0633\u062A\u062E\u062F\u0645 \u062C\u062F\u064A\u062F","invite_user":"\u062F\u0639\u0648\u0629 \u0645\u0633\u062A\u062E\u062F\u0645","confirm_deletion_question":"\u0647\u0644 \u0623\u0646\u062A \u0645\u062A\u0623\u0643\u062F \u0623\u0646\u0643 \u062A\u0631\u064A\u062F \u062D\u0630\u0641 \u062C\u0647\u0629 \u0627\u0644\u0627\u062A\u0635\u0627\u0644 \u0647\u0630\u0647\u061F","enter_first_name":"\u0627\u0644\u0631\u062C\u0627\u0621 \u0625\u062F\u062E\u0627\u0644 \u0627\u0644\u0627\u0633\u0645 \u0627\u0644\u0623\u0648\u0644","enter_last_name":"\u0627\u0644\u0631\u062C\u0627\u0621 \u0625\u062F\u062E\u0627\u0644 \u0627\u0633\u0645 \u0627\u0644\u0639\u0627\u0626\u0644\u0629","enter_phone":"\u0627\u0644\u0631\u062C\u0627\u0621 \u0625\u062F\u062E\u0627\u0644 \u0631\u0642\u0645 \u0627\u0644\u0647\u0627\u062A\u0641","enter_email":"\u0627\u0644\u0631\u062C\u0627\u0621 \u0625\u062F\u062E\u0627\u0644 \u0627\u0644\u0628\u0631\u064A\u062F \u0627\u0644\u0625\u0644\u0643\u062A\u0631\u0648\u0646\u064A","choose_role":"\u0627\u0644\u0631\u062C\u0627\u0621 \u0627\u062E\u062A\u064A\u0627\u0631 \u0627\u0644\u062F\u0648\u0631","choose_location":"\u0627\u0644\u0631\u062C\u0627\u0621 \u0627\u062E\u062A\u064A\u0627\u0631 \u0627\u0644\u0645\u0648\u0642\u0639","first_name":"\u0627\u0644\u0627\u0633\u0645 \u0627\u0644\u0623\u0648\u0644","last_name":"\u0627\u0633\u0645 \u0627\u0644\u0639\u0627\u0626\u0644\u0629","phone":"\u0631\u0642\u0645 \u0627\u0644\u0647\u0627\u062A\u0641","email":"\u0627\u0644\u0628\u0631\u064A\u062F \u0627\u0644\u0625\u0644\u0643\u062A\u0631\u0648\u0646\u064A","invite_user_exclamation":"\u0642\u0645 \u0628\u062F\u0639\u0648\u0629 \u0645\u0633\u062A\u062E\u062F\u0645 \u0627\u0644\u0622\u0646!","job_role":"\u0627\u0644\u062F\u0648\u0631 \u0627\u0644\u0648\u0638\u064A\u0641\u064A","location":"\u0627\u0644\u0645\u0648\u0642\u0639","save":"\u062D\u0641\u0638","delete":"\u062D\u0630\u0641","cancel":"\u0625\u0644\u063A\u0627\u0621","you_have_n_users":"\u0644\u062F\u064A\u0643 {{count}} \u0645\u0633\u062A\u062E\u062F\u0645\u0648\u0646","add_user":"\u0625\u0636\u0627\u0641\u0629 \u0645\u0633\u062A\u062E\u062F\u0645 \u062C\u062F\u064A\u062F","or":"\u0623\u0648","invite_existing_user":"\u062F\u0639\u0648\u0629 \u0645\u0633\u062A\u062E\u062F\u0645 \u0645\u0648\u062C\u0648\u062F","invitation_confirmed":"\u062A\u0645 \u062A\u0623\u0643\u064A\u062F \u0627\u0644\u062F\u0639\u0648\u0629!","invitation_alert_text":"\u062A\u0645 \u0625\u0631\u0633\u0627\u0644 \u0627\u0644\u062F\u0639\u0648\u0629 \u0628\u0646\u062C\u0627\u062D. \u0633\u064A\u062A\u0645 \u0625\u0636\u0627\u0641\u0629 \u0627\u0644\u0645\u0633\u062A\u062E\u062F\u0645 \u0625\u0644\u0649 \u0634\u0631\u0643\u062A\u0643 \u0628\u0639\u062F \u0642\u0628\u0648\u0644\u0647 \u0644\u0644\u062F\u0639\u0648\u0629.","users_tab_active_users":"\u0627\u0644\u0645\u0633\u062A\u062E\u062F\u0645\u0648\u0646","users_tab_invitations":"\u0627\u0644\u062F\u0639\u0648\u0627\u062A","role_admin":"\u0645\u0633\u0624\u0648\u0644","role_owner":"\u0627\u0644\u0645\u0627\u0644\u0643","role_manager":"\u0645\u062F\u064A\u0631","role_finance":"\u0627\u0644\u0645\u0627\u0644\u064A\u0629"},"onboarding":{"knowledge_center":"\u0645\u0631\u0643\u0632 \u0627\u0644\u0645\u0639\u0631\u0641\u0629","create_password":"\u0625\u0646\u0634\u0627\u0621 \u0643\u0644\u0645\u0629 \u0627\u0644\u0645\u0631\u0648\u0631","register_corporate":"\u062A\u0633\u062C\u064A\u0644 \u0634\u0631\u0643\u0629","click_here_to_close":"\u0627\u0636\u063A\u0637 \u0647\u0646\u0627 \u0644\u0644\u0625\u063A\u0644\u0627\u0642"},"lead_widget":{"looking_for_staff":"\u0647\u0644 \u062A\u0628\u062D\u062B \u0639\u0646\\n\u0645\u0648\u0638\u0641\u064A\u0646 \u0628\u062F\u0648\u0627\u0645 \u062C\u0632\u0626\u064A\u061F","hire_now":"\u0642\u0645 \u0628\u0627\u0644\u062A\u0648\u0638\u064A\u0641 \u0627\u0644\u0622\u0646"},"uncompleted_actions_carousel":{"looking_for_staff":"\u0647\u0644 \u062A\u0628\u062D\u062B \u0639\u0646 \u0645\u0648\u0638\u0641\u064A\u0646 \u0628\u062F\u0648\u0627\u0645 \u062C\u0632\u0626\u064A\u061F","hire_now":"\u0642\u0645 \u0628\u0627\u0644\u062A\u0648\u0638\u064A\u0641 \u0627\u0644\u0622\u0646","edit_company":"\u0642\u0645 \u0628\u062A\u0648\u0641\u064A\u0631 \u062A\u0641\u0627\u0635\u064A\u0644 \u0627\u0644\u0634\u0631\u0643\u0629\\n \u0644\u0641\u062A\u062D \u0637\u0631\u0642 \u062F\u0641\u0639 \u0645\u0631\u0646\u0629","start_edit_company":"\u0627\u0628\u062F\u0623 \u0627\u0644\u0622\u0646","add_poc":"\u062A\u0639\u064A\u064A\u0646 \u0627\u0644\u0623\u062F\u0648\u0627\u0631 \\n\u0644\u0623\u0639\u0636\u0627\u0621 \u0641\u0631\u064A\u0642\u0643","start_add_poc":"\u0627\u0628\u062F\u0623 \u0627\u0644\u0622\u0646","dismiss_add_poc":"\u062A\u062E\u0637\u064A","error_failed_to_load":"\u0641\u0634\u0644 \u0641\u064A \u062A\u062D\u0645\u064A\u0644 \u0643\u0627\u0631\u0648\u0633\u064A\u0644","connect":"\u0631\u0628\u0637","connect_your_bank_account":"\u0642\u0645 \u0628\u0631\u0628\u0637 \u062D\u0633\u0627\u0628\u0643 \u0628\u0627\u0644\u0628\u0646\u0643 \u0627\u0644\u062E\u0627\u0635 \u0628\u0643","become_affiliate":"\u0642\u0645 \u0628\u062F\u0639\u0648\u0629 \u0645\u0648\u0638\u0641\u064A\u0643 \u0644\u0644\u0627\u0646\u0636\u0645\u0627\u0645 \u0625\u0644\u0649 \u0623\u0648\u063A\u0631\u0627\u0645"},"not_authorized_error":{"title":"\u062A\u0645 \u0631\u0641\u0636 \u0627\u0644\u062F\u062E\u0648\u0644","description":"\u0644\u064A\u0633 \u0644\u062F\u064A\u0643 \u0627\u0644\u0625\u0630\u0646 \u0644\u0644\u0648\u0635\u0648\u0644 \u0625\u0644\u0649 \u0627\u0644\u0635\u0641\u062D\u0629 \u0627\u0644\u0645\u0637\u0644\u0648\u0628\u0629...","sign_in":"\u062A\u0633\u062C\u064A\u0644 \u0627\u0644\u062F\u062E\u0648\u0644","toast_title":"Your session has expired. Please log in again to continue."},"page_not_found":{"title":"\u0644\u0645 \u064A\u062A\u0645 \u0627\u0644\u0639\u062B\u0648\u0631 \u0639\u0644\u0649 \u0627\u0644\u0635\u0641\u062D\u0629!","description":"\u064A\u0628\u062F\u0648 \u0623\u0646 \u0627\u0644\u0635\u0641\u062D\u0629 \u0627\u0644\u062A\u064A \u062A\u0628\u062D\u062B \u0639\u0646\u0647\u0627 \u063A\u064A\u0631 \u0645\u0648\u062C\u0648\u062F\u0629...","go_back":"\u0627\u0644\u0639\u0648\u062F\u0629"},"permission_error":{"title":"\u0644\u064A\u0633 \u0644\u062F\u064A\u0643 \u0627\u0644\u0625\u0630\u0646 \u0644\u0639\u0631\u0636 \u0647\u0630\u0647 \u0627\u0644\u0635\u0641\u062D\u0629","back":"\u0627\u0644\u0639\u0648\u062F\u0629"},"too_many_attempts":{"title":"\u0645\u062D\u0627\u0648\u0644\u0627\u062A \u0643\u062B\u064A\u0631\u0629 \u062C\u062F\u0627\u064B!","description":"\u064A\u0631\u062C\u0649 \u0627\u0644\u0645\u062D\u0627\u0648\u0644\u0629 \u0645\u0631\u0629 \u0623\u062E\u0631\u0649 \u0628\u0639\u062F \u0642\u0644\u064A\u0644.","ok":"\u062D\u0633\u0646\u0627\u064B"},"notifications":{"title":"\u0625\u0634\u0639\u0627\u0631\u0627\u062A","load_more":"\u062A\u062D\u0645\u064A\u0644 \u0627\u0644\u0645\u0632\u064A\u062F","no_more_notifications":"\u0644\u0627 \u064A\u0648\u062C\u062F \u0625\u0634\u0639\u0627\u0631\u0627\u062A","no_notifications_yet":"\u0644\u0627 \u064A\u0648\u062C\u062F \u0625\u0634\u0639\u0627\u0631\u0627\u062A \u062D\u062A\u0649 \u0627\u0644\u0622\u0646","error_failed_to_load_notifications":"\u0641\u0634\u0644 \u0641\u064A \u062A\u062D\u0645\u064A\u0644 \u0627\u0644\u0625\u0634\u0639\u0627\u0631\u0627\u062A. \u064A\u0631\u062C\u0649 \u0627\u0644\u0645\u062D\u0627\u0648\u0644\u0629 \u0645\u0631\u0629 \u0623\u062E\u0631\u0649"},"home_onboarding":{"title":"\u0627\u0644\u0635\u0641\u062D\u0629 \u0627\u0644\u0631\u0626\u064A\u0633\u064A\u0629","intro_title":"\u0627\u0647\u0644\u0627\u064B \u0648\u0633\u0647\u0644\u0627\u064B \u0641\u064A \u0623\u0648\u063A\u0631\u0627\u0645!","intro_description":"\u0627\u0644\u0645\u0646\u0635\u0629 \u0627\u0644\u0630\u0643\u064A\u0629 \u0627\u0644\u062A\u064A \u062A\u0633\u062A\u062E\u062F\u0645\u0647\u0627 \u0627\u0644\u0634\u0631\u0643\u0627\u062A \u0648\u0627\u0644\u0623\u0641\u0631\u0627\u062F \u0644\u062A\u0644\u0628\u064A\u0629 \u0627\u062D\u062A\u064A\u0627\u062C\u0627\u062A\u0647\u0645 \u0645\u0646 \u0627\u0644\u062A\u0648\u0638\u064A\u0641 \u0628\u062F\u0648\u0627\u0645 \u062C\u0632\u0626\u064A .","intro_footer":"\u0639\u0646\u062F\u0645\u0627 \u062A\u0633\u062A\u062E\u062F\u0645 \u0627\u062D\u062F \u0627\u0644\u0645\u0645\u064A\u0632\u0627\u062A \u0644\u0623\u0648\u0644\u0649 \u0645\u0631\u0629\u060C \u0633\u062A\u0638\u0647\u0631 \u0644\u0643 \u0631\u0633\u0627\u0644\u0629 \u0645\u0634\u0627\u0628\u0647\u0629 \u0644\u062A\u0642\u0648\u0645 \u0628\u0625\u0631\u0634\u062F\u0627\u0643.","hire_title":"\u062A\u0648\u0638\u064A\u0641 \u0645\u0648\u0638\u0641\u064A\u0646 \u0628\u062F\u0648\u0627\u0645 \u062C\u0632\u0626\u064A","hire":"\u062A\u062A\u064A\u062D \u0644\u0643 \u0645\u064A\u0632\u0629 \\"\u062A\u0648\u0638\u064A\u0641 \u0627\u0644\u0622\u0646\\" \u062D\u062C\u0632 \u0627\u0644\u0645\u0648\u0638\u0641\u064A\u0646 \u0628\u062F\u0648\u0627\u0645 \u062C\u0632\u0626\u064A. \u0648\u0628\u0647\u0630\u0647 \u0627\u0644\u0637\u0631\u064A\u0642\u0629 \u064A\u0645\u0643\u0646\u0643 \u0625\u062E\u0628\u0627\u0631\u0646\u0627\u060C \u0628\u0645\u0627\u0630\u0627 \u0648 \u0623\u064A\u0646 \u0648 \u0645\u062A\u0649 \u062A\u062D\u062A\u0627\u062C\u0647\u0645 \u0648 \u062A\u0631\u064A\u062F\u0647\u0645.","attendance_title":"\u0645\u0643\u0627\u0646 \u0645\u0631\u0627\u062C\u0639\u0629 \u0627\u0644\u062D\u0636\u0648\u0631","attendance":"\u0647\u0630\u0627 \u0647\u0648 \u0627\u0644\u0645\u0643\u0627\u0646 \u0627\u0644\u0630\u064A \u064A\u0645\u0643\u0646\u0643 \u0641\u064A\u0647 \u0645\u0631\u0627\u062C\u0639\u0629 \u062A\u0642\u0627\u0631\u064A\u0631 \u0627\u0644\u062D\u0636\u0648\u0631 \u0627\u0644\u0631\u0642\u0645\u064A\u0629 \u0648 \u0627\u0644\u062A\u0648\u0642\u064A\u0639 \u0639\u0644\u064A\u0647\u0627. \u064A\u0634\u064A\u0631 \u0627\u0644\u0631\u0642\u0645 \u0627\u0644\u0645\u0648\u062C\u0648\u062F \u0641\u064A \u0627\u0644\u0645\u0631\u0628\u0639 \u0625\u0644\u0649 \u0627\u0644\u062A\u0642\u0627\u0631\u064A\u0631 \u0627\u0644\u0645\u0639\u0644\u0642\u0629 \u0627\u0644\u062A\u064A \u064A\u062C\u0628 \u0645\u0631\u0627\u062C\u0639\u062A\u0647\u0627.","orders_title":"\u0645\u0643\u0627\u0646 \u062A\u0623\u0643\u064A\u062F \u0627\u0644\u0637\u0644\u0628\u0627\u062A","orders":"\u0639\u0646\u062F\u0645\u0627 \u064A\u062A\u0637\u0644\u0628 \u0637\u0644\u0628 \u0627\u0644\u0645\u0648\u0638\u0641\u064A\u0646 \u0627\u0644\u062A\u0633\u0639\u064A\u0631 \u0627\u0644\u064A\u062F\u0648\u064A\u060C \u0646\u062D\u062A\u0627\u062C \u0625\u0644\u064A \u062A\u0623\u0643\u064A\u062F\u0643 \u0627\u0644\u0646\u0647\u0627\u0626\u064A \u0642\u0628\u0644 \u0623\u0646 \u0646\u062A\u0645\u0643\u0646 \u0645\u0646 \u0646\u0634\u0631 \u0627\u0644\u0645\u0648\u0638\u0641\u064A\u0646. \u0647\u0646\u0627 \u064A\u0645\u0643\u0646\u0643 \u0627\u0644\u0648\u0635\u0648\u0644 \u0625\u0644\u0649 \u062C\u0645\u064A\u0639 \u0627\u0644\u0637\u0644\u0628\u0627\u062A \u0627\u0644\u0645\u0639\u0644\u0642\u0629.","ratings_title":"\u0645\u0643\u0627\u0646 \u0637\u0644\u0628\u0627\u062A \u0627\u0644\u062A\u0642\u064A\u064A\u0645","ratings":"\u062A\u0639\u0644\u064A\u0642\u0627\u062A\u0643 \u0645\u0647\u0645\u0629 \u062C\u062F\u0627\u064B \u0628\u0627\u0644\u0646\u0633\u0628\u0629 \u0644\u0646\u0627 \u0648\u064A\u062A\u0645 \u0627\u0644\u0627\u0633\u062A\u0641\u0627\u062F\u0629 \u0645\u0646\u0647\u0627 \u0645\u0646 \u062E\u0644\u0627\u0644 \u0627\u0644\u062A\u0643\u0646\u0648\u0644\u0648\u062C\u064A\u0627 \u0627\u0644\u0645\u062A\u0637\u0648\u0631\u0629 \u0627\u0644\u062A\u064A \u062A\u0639\u0645\u0644 \u0639\u0644\u0649 \u0627\u0644\u0627\u0631\u062A\u0642\u0627\u0621 \u0628\u0627\u0644\u062E\u062F\u0645\u0629 \u0628\u0627\u0633\u062A\u0645\u0631\u0627\u0631. \u0625\u0644\u064A\u0643 \u0627\u0644\u0645\u0643\u0627\u0646 \u0627\u0644\u0630\u064A \u064A\u0645\u0643\u0646\u0643 \u0645\u0646 \u062E\u0644\u0627\u0644\u0647 \u062A\u0642\u064A\u064A\u0645 \u0627\u0644\u062E\u062F\u0645\u0629.","applicants_review_title":"\u0645\u0643\u0627\u0646 \u0627\u0644\u0645\u062A\u0642\u062F\u0645\u064A\u0646 \u0644\u0644\u0648\u0638\u0627\u0626\u0641","applicants_review":"\u062A\u062E\u062A\u0627\u0631 \u0627\u0644\u0645\u0646\u0635\u0629 \u0627\u0644\u0645\u0648\u0638\u0641\u064A\u0646 \u0648 \u062A\u0646\u0634\u0631\u0647\u0645 \u062A\u0644\u0642\u0627\u0626\u064A\u0627. \u064A\u0645\u0643\u0646\u0643 \u0627\u064A\u0636\u0627\u064B \u0627\u062E\u062A\u064A\u0627\u0631 \u0627\u0644\u0645\u0648\u0638\u0641\u064A\u0646 \u0628\u0646\u0627\u0621\u064B \u0639\u0644\u0649 \u062E\u0628\u0631\u062A\u0647\u0645. \u0647\u0646\u0627 \u064A\u0645\u0643\u0646\u0643 \u0645\u0631\u0627\u062C\u0639\u0629 \u0627\u0644\u0645\u0631\u0634\u062D\u064A\u0646 \u0648 \u0627\u062E\u062A\u064A\u0627\u0631\u0647\u0645.","outro":"\u0647\u0644 \u0623\u0646\u062A \u0645\u0633\u062A\u0639\u062F \u0644\u062A\u0628\u062F\u0621\u061F\\n\u064A\u0645\u0643\u0646\u0643 \u062F\u0627\u0626\u0645\u0627 \u0627\u0644\u0648\u0635\u0648\u0644 \u0625\u0644\u0649 \\"\u0645\u0631\u0643\u0632 \u0627\u0644\u0645\u0639\u0631\u0641\u0629\\" \u0645\u0646 \u0642\u0627\u0626\u0645\u0629 \u0627\u0644\u0635\u0641\u062D\u0629 \u0627\u0644\u0631\u0626\u064A\u0633\u064A\u0629 \u0623\u0648 \u0628\u0627\u0644\u0636\u063A\u0637 \u0641\u0648\u0642 \u0639\u0644\u0627\u0645\u0629 \u0627\u0644\u0623\u0633\u062A\u0641\u0627\u0647\u0645 \\"\u061F\\" \u0643\u0644\u0645\u0627 \u0627\u062E\u062A\u062C\u062A \u0625\u0644\u0649 \u0625\u0631\u0634\u0627\u062F\u0627\u062A."},"all_jobs_onboarding":{"title":"\u062C\u0645\u064A\u0639 \u0627\u0644\u0648\u0638\u0627\u0626\u0641","jobs_list_title":"\u0642\u0627\u0626\u0645\u0629 \u0627\u0644\u0648\u0638\u0627\u0626\u0641","jobs_list":"\\"\u0643\u0644 \u0627\u0644\u0648\u0638\u0627\u0626\u0641\\" \u0639\u0628\u0627\u0631\u0629 \u0639\u0646 \u0642\u0627\u0626\u0645\u0629 \u0628\u0627\u0644\u0648\u0638\u0627\u0626\u0641 \u0627\u0644\u0645\u062D\u062C\u0648\u0632\u0629 \u0644\u062F\u064A\u0643 \u0645\u0642\u0633\u0645\u0629 \u062D\u0633\u0628 \u0627\u0644\u0623\u064A\u0627\u0645. \u0628\u0627\u0644\u0646\u0642\u0631 \u0639\u0644\u0649 \u0627\u0644\u0648\u0638\u064A\u0641\u0629\u060C \u062A\u0633\u062A\u0637\u064A\u0639 \u0631\u0624\u064A\u0629 \u0642\u0627\u0626\u0645\u0629 \u0645\u0648\u0638\u0641\u064A \u0623\u0648\u063A\u0631\u0627\u0645 \u0627\u0644\u0645\u0639\u064A\u0646\u064A\u0646.","job_details_title":"\u062A\u0641\u0627\u0635\u064A\u0644 \u0627\u0644\u0648\u0638\u064A\u0641\u0629","job_details":"\u0641\u064A \u0635\u0641\u062D\u0629 \u0627\u0644\u0648\u0638\u064A\u0641\u0629\u060C \u064A\u0645\u0643\u0646\u0643 \u062A\u0633\u062C\u064A\u0644 \u062D\u0636\u0648\u0631 \u0627\u0644\u0645\u0648\u0638\u0641\u064A\u0646\u060C \u062A\u0645\u062F\u064A\u062F \u0623\u0648 \u0625\u0644\u063A\u0627\u0621 \u0645\u0646\u0627\u0648\u0628\u0627\u062A \u0627\u0644\u0639\u0645\u0644. \u0648 \u062A\u0633\u062A\u0637\u064A\u0639 \u0625\u0636\u0627\u0641\u0629 \u0645\u0648\u0638\u0641 \u0623\u0648\u063A\u0631\u0627\u0645 \u0625\u0644\u0649 \u0627\u0644\u0645\u0641\u0636\u0644\u0629 \u064A\u0636\u0645\u0646 \u0644\u0643 \u0627\u062E\u062A\u064A\u0627\u0631\u0647 \u0641\u064A \u0627\u0644\u0645\u0631\u0629 \u0627\u0644\u0642\u0627\u062F\u0645\u0629.","change_schedule_title":"\u062A\u063A\u064A\u0631 \u0627\u0644\u062C\u062F\u0648\u0644","change_schedule":"\u064A\u0645\u0643\u0646\u0643 \u062A\u0639\u062F\u064A\u0644 \u062C\u062F\u0648\u0644 \u0645\u0646\u0627\u0648\u0628\u0627\u062A \u0627\u0644\u0639\u0645\u0644 \u0644\u062F\u064A\u0643. \u0641\u0625\u0646 \u062A\u062D\u062F\u064A\u062B \u0627\u0644\u062C\u062F\u0648\u0644 \u0623\u0645\u0631\u0627\u064B \u0647\u0645\u0627 \u0644\u0644\u063A\u0627\u064A\u0629\u060C \u0644\u064A\u0645\u0643\u0646 \u0645\u0648\u0638\u0641\u064A \u0623\u0648\u063A\u0631\u0627\u0645 \u0627\u0633\u062A\u062E\u062F\u0627\u0645 \u062A\u0637\u0628\u064A\u0642\u0647\u0645 \u0644\u062A\u0633\u062C\u064A\u0644 \u0627\u0644\u062D\u0636\u0648\u0631.","bulk_schedule_change_title":"\u062A\u063A\u064A\u064A\u0631 \u062C\u062F\u0627\u0648\u0644 \u0627\u0644\u0639\u0645\u0644","bulk_schedule_change":"\u0642\u062F \u064A\u062A\u0645 \u062A\u063A\u064A\u064A\u0631 \u0627\u0644\u062C\u062F\u0648\u0644 \u0627\u0644\u0632\u0645\u0646\u064A \u0644\u064A\u0648\u0645 \u0645\u062D\u062F\u062F \u0623\u0648 \u0644\u0639\u062F\u0629 \u0623\u064A\u0627\u0645. \u064A\u0631\u062C\u0649 \u0645\u0644\u0627\u062D\u0638\u0629 \u0623\u0646\u0647 \u0644\u0627 \u064A\u0645\u0643\u0646 \u062A\u0642\u0644\u064A\u0644 \u0645\u062F\u0629 \u0627\u0644\u0645\u0646\u0627\u0648\u0628\u0629.","cancel_shift_title":"\u0625\u0644\u063A\u0627\u0621 \u0646\u0648\u0628\u0629 \u0639\u0645\u0644","cancel_shift":"\u062A\u0633\u062A\u0637\u064A\u0639 \u0625\u0644\u063A\u0627\u0621 \u0645\u0646\u0627\u0648\u0628\u0629 \u0639\u0645\u0644 \u0644\u0639\u0636\u0648 \u0641\u0631\u062F\u064A \u0644\u0645\u0648\u0638\u0641 \u0623\u0648\u063A\u0631\u0627\u0645\u061B \u0628\u0627\u0644\u0625\u0636\u0627\u0641\u0629 \u0625\u0644\u0649 \u0645\u0646\u0639\u0647 \u0645\u0646 \u0627\u0644\u062A\u0642\u062F\u0645 \u0628\u0637\u0644\u0628 \u0627\u0644\u0639\u0645\u0644 \u0644\u062C\u0645\u064A\u0639 \u0627\u0644\u0645\u0646\u0627\u0648\u0628\u0627\u062A \u0627\u0644\u0645\u0633\u062A\u0642\u0628\u0644\u064A\u0629."},"attendance_review_onboarding":{"title":"\u0645\u0631\u0627\u062C\u0639\u0629 \u0627\u0644\u062D\u0636\u0648\u0631","jobs_pending_review_title":"\u0648\u0638\u0627\u0626\u0641 \u0642\u064A\u062F \u0627\u0646\u062A\u0638\u0627\u0631 \u0637\u0644\u0628\u0627\u062A \u0627\u0644\u062A\u0648\u0638\u064A\u0641","jobs_pending_review":"\u064A\u062A\u064A\u062D \u0644\u0643 \u0642\u0633\u0645 \\"\u0645\u0631\u0627\u062C\u0639\u0629 \u0627\u0644\u062D\u0636\u0648\u0631\\" \u062A\u0639\u062F\u064A\u0644 \u0648\u062A\u0623\u0643\u064A\u062F \u062D\u0636\u0648\u0631 \u0623\u0639\u0636\u0627\u0621 \u0645\u0648\u0638\u0641\u064A \u0623\u0648\u063A\u0631\u0627\u0645 \u0639\u0644\u0649 \u0634\u0643\u0644 \u064A\u0648\u0645\u064A. \u0633\u064A\u062A\u0645 \u0645\u062D\u0627\u0633\u0628\u0643 \u0648\u0641\u0642\u0627\u064B \u0644\u0644\u0648\u0642\u062A \u0627\u0644\u0645\u0633\u062C\u0644.","attendance_details_title":"\u062A\u0641\u0627\u0635\u064A\u0644 \u0627\u0644\u062D\u0636\u0648\u0631","attendance_details":"\u0635\u0641\u062D\u0629 \u0627\u0644\u0648\u0638\u064A\u0641\u0629 \u062A\u0639\u0631\u0636 \u0644\u0643 \u0642\u0627\u0626\u0645\u0629 \u0627\u0644\u062A\u064A \u062A\u0645 \u062A\u0633\u062C\u064A\u0644 \u0641\u064A\u0647\u0627 \u0623\u0648\u0642\u0627\u062A \u0645\u0648\u0638\u0641\u064A \u0623\u0648\u063A\u0631\u0627\u0645 \u0627\u0644\u0645\u0639\u064A\u0646\u0648\u0646. \u064A\u0645\u0643\u0646\u0643 \u062A\u0635\u062D\u064A\u062D \u0627\u0644\u0648\u0642\u062A \u0628\u0627\u0644\u0646\u0642\u0631 \u0639\u0644\u064A\u0647\u0627.","attendance_status_title":"\u062A\u063A\u064A\u064A\u0631 \u062D\u0627\u0644\u0629 \u0627\u0644\u062D\u0636\u0648\u0631","attendance_status":"\u064A\u0645\u0643\u0646\u0643 \u0627\u064A\u0636\u0627\u064B \u062A\u0635\u062D\u064A\u062D \u062D\u0627\u0644\u0629 \u062D\u0636\u0648\u0631 \u0645\u0648\u0638\u0641\u064A \u0623\u0648\u063A\u0631\u0627\u0645 \u0625\u0630\u0627 \u062A\u0645 \u0628\u0627\u0644\u062E\u0637\u0623 \u0648\u0636\u0639 \u0639\u0644\u0627\u0645\u0629 \u0627\u0646\u0647 \u0644\u0645 \u064A\u062D\u0636\u0631.","attendance_time_title":"\u062A\u063A\u064A\u064A\u0631 \u0648\u0642\u062A \u0627\u0644\u062D\u0636\u0648\u0631","attendance_time":"\u0633\u064A\u062A\u0645 \u0645\u0637\u0627\u0644\u0628\u062A\u0643 \u0628\u0625\u062F\u062E\u0627\u0644 \u062A\u0648\u0642\u064A\u062A \u0627\u0644\u062D\u0636\u0648\u0631 \u0627\u0644\u0635\u062D\u064A\u062D\u060C \u0627\u0644\u0630\u064A \u0633\u064A\u062A\u0645 \u0636\u0628\u0637\u0647 \u0639\u0644\u0649 \u0627\u0644\u0633\u0627\u0639\u0627\u062A \u0627\u0644\u0645\u062C\u062F\u0648\u0644\u0629 \u0628\u0634\u0643\u0644 \u0627\u0641\u062A\u0631\u0627\u0636\u064A.","not_attended_reason_title":"\u062A\u063A\u064A\u064A\u0631 \u0633\u0628\u0628 \\"\u0639\u062F\u0645 \u0627\u0644\u062D\u0636\u0648\u0631\\"","not_attended_reason":"\u0625\u0630\u0627 \u0644\u0645 \u064A\u062D\u0636\u0631 \u0623\u062D\u062F \u0623\u0639\u0636\u0627\u0621 \u0623\u0648\u063A\u0631\u0627\u0645\u060C \u064A\u0645\u0643\u0646\u0643 \u0623\u064A\u0636\u0627\u064B \u062A\u063A\u064A\u064A\u0631 \u0627\u0644\u0633\u0628\u0628\u061B \u0633\u0648\u0627\u0621 \u0643\u0627\u0646 \u064A\u0648\u0645 \u0625\u062C\u0627\u0632\u0629 \u0623\u0648 \u0625\u062C\u0627\u0632\u0629 \u0645\u0631\u0636\u064A\u0629.","confirmation_time_title":"\u062A\u0623\u0643\u064A\u062F \u0627\u0644\u0648\u0642\u062A","confirmation_time":"\u0645\u0646 \u0627\u0644\u0645\u0647\u0645 \u0644\u0644\u063A\u0627\u064A\u0629 \u0627\u0646 \u062A\u0623\u0643\u062F \u0627\u0644\u062D\u0636\u0648\u0631 \u0628\u0627\u0646\u062A\u0638\u0627\u0645 \u062D\u064A\u062B \u0627\u0646\u0647 \u0633\u064A\u062A\u0645 \u062A\u0623\u0643\u064A\u062F\u0647 \u062A\u0644\u0642\u0627\u0626\u064A\u0627 \u062E\u0644\u0627\u0644 72 \u0633\u0627\u0639\u0629. \u0641\u064A \u062D\u0627\u0644\u0629 \u0641\u0634\u0644 \u0627\u0644\u0642\u064A\u0627\u0645 \u0628\u0630\u0644\u0643 \u0633\u064A\u062A\u0645 \u0645\u062D\u0627\u0633\u0628\u062A\u0643 \u0648\u0641\u0642\u0627 \u0644\u0630\u0644\u0643."},"order_confirmation_onboarding":{"title":"\u0627\u0644\u0637\u0644\u0628\u0627\u062A","pending_confirmation_title":"\u0637\u0644\u0628\u0627\u062A \u0641\u064A \u0627\u0646\u062A\u0627\u0638\u0631 \u0627\u0644\u062A\u0623\u0643\u064A\u062F","pending_confirmation":"\u064A\u062D\u062A\u0648\u064A \u0642\u0633\u0645 \\"\u0627\u0644\u0637\u0644\u0628\u0627\u062A\\" \u0639\u0644\u0649 \u0642\u0627\u0626\u0645\u0629 \u0628\u0627\u0644\u0637\u0644\u0628\u0627\u062A \u0627\u0644\u0645\u062D\u062C\u0648\u0632\u0629 \u0645\u0633\u0628\u0642\u0627\u064B \u0648\u0627\u0644\u062A\u064A \u062A\u0646\u062A\u0638\u0631 \u0645\u0646\u0643 \u0645\u0631\u0627\u062C\u0639\u062A\u0647\u0627 \u0648\u062A\u0623\u0643\u064A\u062F\u0647\u0627.","order_confirmation_title":"\u062A\u0623\u0643\u064A\u062F \u0627\u0644\u0637\u0644\u0628","order_confirmation":"\u0641\u064A \u0635\u0641\u062D\u0629 \u062A\u0623\u0643\u064A\u062F \u0627\u0644\u0637\u0644\u0628 \u0627\u0644\u0645\u0639\u0644\u0642\u0629\u060C \u064A\u0631\u062C\u0649 \u0645\u0631\u0627\u062C\u0639\u0629 \u062A\u0641\u0627\u0635\u064A\u0644 \u0627\u0644\u0637\u0644\u0628 \u0648\u0627\u0644\u0623\u0633\u0639\u0627\u0631 \u0627\u0644\u0646\u0647\u0627\u0626\u064A\u0629 \u0628\u0639\u0646\u0627\u064A\u0629. \u0633\u064A\u062A\u0645 \u062A\u0648\u0632\u064A\u0639 \u0627\u0644\u0645\u0648\u0638\u0641\u064A\u0646 \u0628\u0645\u062C\u0631\u062F \u062A\u0623\u0643\u064A\u062F \u0627\u0644\u0637\u0644\u0628.","order_amend_title":"\u062A\u0639\u062F\u064A\u0644 \u0627\u0644\u0637\u0644\u0628","order_amend":"\u0625\u0630\u0627 \u062A\u063A\u064A\u0631\u062A \u0645\u062A\u0637\u0644\u0628\u0627\u062A\u0643 \u0623\u0648 \u0643\u0646\u062A \u0642\u0644\u0642 \u0628\u0634\u0623\u0646 \u0627\u0644\u0645\u064A\u0632\u0627\u0646\u064A\u0629\u060C \u0641\u0644\u0627 \u062A\u062A\u0631\u062F\u062F \u0641\u064A \u062A\u0639\u062F\u064A\u0644 \u0627\u0644\u0645\u062A\u0637\u0628\u0627\u062A."},"order_creation_onboarding":{"title":"\u0625\u0646\u0634\u0627\u0621 \u0627\u0644\u0637\u0644\u0628","select_designation_title":"\u0627\u062E\u062A\u0627\u0631 \u0646\u0648\u0639 \u0627\u0644\u0648\u0638\u064A\u0641\u0629","select_designation":"\u062A\u0628\u062F\u0623 \u0639\u0645\u0644\u064A\u0629 \u0625\u0646\u0634\u0627\u0621 \u0627\u0644\u0637\u0644\u0628 \u0628\u0627\u062E\u062A\u064A\u0627\u0631 \u062A\u0633\u0645\u064A\u0629 \u0644\u0644\u0648\u0638\u0641\u064A\u0629 \u0627\u0644\u0623\u0648\u0644\u0649. \u0648\u064A\u0645\u0643\u0646\u0643 \u0627\u062E\u062A\u064A\u0627\u0631 \u062A\u0633\u0645\u064A\u0627\u062A \u0625\u0636\u0627\u0641\u064A\u0629 \u0628\u0645\u062C\u0631\u062F \u0625\u0646\u0634\u0627\u0621 \u0627\u0644\u0648\u0638\u064A\u0641\u0629 \u0627\u0644\u0623\u0648\u0644\u0649.","job_details_title":"\u062A\u0641\u0627\u0635\u064A\u0644 \u0627\u0644\u0648\u0638\u064A\u0641\u0629","job_details":"\u0628\u0639\u062F \u0627\u062E\u062A\u064A\u0627\u0631\u0643 \u0644\u0644\u0645\u0633\u0645\u0649 \u0627\u0644\u0648\u0638\u064A\u0641\u064A\u060C \u064A\u0645\u0643\u0646\u0643 \u0645\u0644\u0621 \u062A\u0641\u0627\u0635\u064A\u0644 \u0627\u0644\u0648\u0638\u064A\u0641\u0629 \u0628\u0627\u0644\u0628\u062F\u0621 \u0628\u0627\u0644\u0643\u0645\u064A\u0629 \u0627\u0644\u0645\u0637\u0644\u0648\u0628\u0629.","job_duration_title":"\u0645\u062F\u0629 \u0627\u0644\u0648\u0638\u064A\u0641\u0629","job_duration":"\u0625\u0630\u0627 \u0643\u0627\u0646\u062A \u0627\u0644\u0648\u0638\u064A\u0641\u0629 \u0645\u062A\u0643\u0631\u0631\u0629 \u0648\u0644\u064A\u0633 \u0644\u0647\u0627 \u062A\u0627\u0631\u064A\u062E \u0625\u0646\u062A\u0647\u0627\u0621\u060C \u0641\u0628\u0625\u0645\u0643\u0627\u0646\u0643 \u0625\u0632\u0627\u0644\u0629 \u062A\u0627\u0631\u064A\u062E \u0627\u0644\u0627\u0646\u062A\u0647\u0627\u0621 \u0648\u0625\u0628\u0642\u0627\u0621 \u0627\u0644\u0648\u0638\u064A\u0641\u0629 \u0645\u0641\u062A\u0648\u062D\u0629.","scheduling_options_title":"\u062E\u064A\u0627\u0631\u0627\u062A \u0627\u0644\u062C\u062F\u0648\u0644\u0629","scheduling_options":"\u0625\u0630\u0627 \u0643\u0627\u0646 \u062C\u062F\u0648\u0644 \u0648\u0638\u064A\u0641\u062A\u0643 \u064A\u062A\u0643\u0631\u0631 \u0643\u0644 \u0623\u0633\u0628\u0648\u0639\u060C \u0641\u0639\u0644\u064A\u0643 \u0627\u062E\u062A\u064A\u0627\u0631 \u0627\u0644\u062E\u064A\u0627\u0631 \\"\u0623\u0633\u0628\u0648\u0639\u064A\\" \u0648\u0623\u062F\u062E\u0644 \u0627\u0644\u062A\u0648\u0642\u064A\u062A\u0627\u062A \u0644\u0643\u0644 \u064A\u0648\u0645 \u0645\u0646 \u0623\u064A\u0627\u0645 \u0627\u0644\u0623\u0633\u0628\u0648\u0639. \u0625\u0630\u0627 \u0643\u0627\u0646 \u062E\u0644\u0627\u0641 \u0630\u0644\u0643 \u0641\u064A\u0645\u0643\u0646\u0643 \u062C\u062F\u0648\u0644\u0629 \u0627\u0644\u0639\u0645\u0644 \u0639\u0644\u0649 \u0623\u0633\u0627\u0633 \u064A\u0648\u0645\u064A","job_requirements_title":"\u0645\u062A\u0637\u0644\u0628\u0627\u062A \u0627\u0644\u0648\u0638\u064A\u0641\u0629","job_requirements":"\u064A\u0645\u0643\u0646\u0643 \u062A\u062D\u062F\u064A\u062F \u0627\u0644\u0645\u062A\u0637\u0628\u0627\u062A \u0645\u0646 \u0642\u0627\u0626\u0645\u0629 \u0645\u062D\u062F\u062F\u0629 \u0645\u0633\u0628\u0642\u0627\u064B \u0623\u0648 \u0625\u0636\u0627\u0641\u0629 \u0645\u0647\u0627\u0631\u0627\u062A/\u0645\u0647\u0627\u0645 \u0645\u062D\u062F\u062F\u0629 \u0645\u0637\u0644\u0648\u0628\u0629 \u0644\u0644\u0648\u0638\u064A\u0641\u0629.","shifts_breakdown_title":"\u062A\u0641\u0627\u0635\u064A\u0644 \u0627\u0644\u0645\u0646\u0627\u0648\u0628\u0627\u062A","shifts_breakdown":"\u0628\u0645\u062C\u0631\u062F \u062A\u062D\u062F\u064A\u062F\u0643 \u0644\u062A\u0641\u0627\u0635\u064A\u0644 \u0648\u0638\u064A\u0641\u062A\u0643 \u0627\u0644\u0623\u0648\u0644\u0649 \u0633\u0648\u0641 \u064A\u062A\u0645 \u0625\u0646\u0634\u0627\u0621 \u0645\u0633\u0648\u062F\u0629 \u0644\u0644\u0637\u0644\u0628\u0627\u062A. \u062A\u0633\u062A\u0637\u064A\u0639 \u0625\u0636\u0627\u0641\u0629 \u0627\u0644\u0645\u0632\u064A\u062F \u0645\u0646 \u0627\u0644\u0648\u0638\u0627\u0626\u0641/\u0627\u0644\u0645\u0633\u0645\u064A\u0627\u062A \u0625\u0644\u0649 \u0627\u0644\u0637\u0644\u0628 \u0628\u0645\u062C\u0631\u062F \u0627\u0644\u0636\u063A\u0637 \u0639\u0644\u0649 \\"\u0625\u0636\u0627\u0641\u0629 \u0648\u0638\u064A\u0641\u0629 \u0623\u062E\u0631\u0649\\".","duplicate_job_title":"\u0646\u0633\u062E \u0627\u0644\u0648\u0638\u064A\u0641\u0629","duplicate_job":"\u0625\u0630\u0627 \u0643\u0646\u062A \u062A\u0631\u064A\u062F \u0625\u0646\u0634\u0627\u0621 \u0648\u0638\u064A\u0641\u0629 \u0623\u062E\u0631\u0649 \u0628\u0646\u0641\u0633 \u0623\u0648 \u0645\u0634\u0627\u0628\u0647\u0629 \u0627\u0644\u0645\u062A\u0637\u0644\u0628\u0627\u062A\u060C \u0641\u064A\u0645\u0643\u0646\u0643 \u0627\u0644\u0636\u063A\u0637 \u0639\u0644\u0649 \u0632\u0631 \u0627\u0644\u0646\u0633\u062E \u0644\u0644\u0648\u0638\u064A\u0641\u0629. \u0633\u0648\u0641 \u062A\u062A\u0645\u0643\u0646 \u0645\u0646 \u062A\u062D\u062F\u064A\u062F \u0627\u0644\u062A\u0641\u0627\u0635\u064A\u0644 \u0627\u0644\u062A\u064A \u062A\u0631\u064A\u062F \u0646\u0633\u062E\u0647\u0627.","send_for_review_title":"\u0625\u0631\u0633\u0627\u0644 \u0644\u0644\u0645\u0631\u0627\u062C\u0639\u0629","send_for_review":"\u0628\u0627\u0644\u0636\u063A\u0637 \u0639\u0644\u0649 \u0632\u0631 \\"\u0625\u0631\u0633\u0627\u0644 \u0644\u0644\u0645\u0631\u0627\u062C\u0639\u0629\\"\u060C \u0633\u062A\u0631\u0633\u0644 \u0627\u0644\u0637\u0644\u0628 \u0625\u0644\u0649 \u0641\u0631\u064A\u0642 \u0627\u0644\u0645\u0628\u064A\u0639\u0627\u062A \u0644\u062F\u064A\u0646\u0627 \u0644\u0644\u0645\u0631\u0627\u062C\u0639\u0629. \u0648\u0633\u0646\u0642\u0648\u0645 \u0628\u062A\u0633\u0639\u064A\u0631 \u0637\u0644\u0628\u0643 \u062B\u0645 \u0627\u0639\u0644\u0627\u0645\u0643 \u0644\u062A\u062D\u0635\u0644 \u0639\u0644\u0649 \u0627\u0644\u062A\u0623\u0643\u064A\u062F \u0627\u0644\u0646\u0647\u0627\u0626\u064A."},"applicants_review_onboarding":{"title":"\u0645\u0631\u0627\u062C\u0639\u0629 \u0627\u0644\u0645\u062A\u0642\u062F\u0645\u064A\u0646","pending_applicant_review_title":"\u0648\u0638\u0627\u0626\u0641 \u0641\u064A \u0627\u0646\u062A\u0638\u0627\u0631 \u0645\u0631\u0627\u062C\u0639\u0629 \u0627\u0644\u0645\u062A\u0642\u062F\u0645\u064A\u0646","pending_applicant_review":"\u064A\u062D\u062A\u0648\u064A \u0642\u0633\u0645 \\"\u0645\u0631\u0627\u062C\u0639\u0629 \u0627\u0644\u0645\u062A\u0642\u062F\u0645\u064A\u0646\\" \u0639\u0644\u0649 \u0642\u0627\u0626\u0645\u0629 \u0628\u0627\u0644\u0648\u0638\u0627\u0626\u0641 \u0627\u0644\u062A\u064A \u062A\u062D\u062A\u0648\u064A \u0639\u0644\u0649 \u0627\u0644\u0645\u062A\u0642\u062F\u0645\u064A\u0646 \u0641\u064A \u062D\u0627\u0644\u0629 \u0627\u0646\u062A\u0638\u0627\u0631 \u0627\u0644\u0645\u0631\u0627\u062C\u0639\u0629. \u0628\u0645\u062C\u0631\u062F \u0627\u0643\u062A\u0645\u0627\u0644 \u0627\u0644\u0648\u0638\u064A\u0641\u0629 \u0633\u0648\u0641 \u0633\u062A\u062E\u062A\u0641\u064A \u0645\u0646 \u0647\u0630\u0647 \u0627\u0644\u0642\u0627\u0626\u0645\u0629.","applicant_list_title":"\u0642\u0627\u0626\u0645\u0629 \u0627\u0644\u0645\u062A\u0642\u062F\u0645\u064A\u0646 \u0644\u0644\u0648\u0638\u0627\u0626\u0641","applicant_list":"\u062A\u0639\u0631\u0636 \u0635\u0641\u062D\u0629 \u0627\u0644\u0648\u0638\u064A\u0641\u0629 \u0642\u0627\u0626\u0645\u0629 \u0628\u0645\u0648\u0638\u0641\u064A \u0623\u0648\u063A\u0631\u0627\u0645 \u0627\u0644\u0630\u064A\u0646 \u062A\u0642\u062F\u0645\u0648\u0627 \u0628\u0637\u0644\u0628 \u0627\u0644\u0648\u0638\u064A\u0641\u0629. \u064A\u0645\u0643\u0646\u0643 \u0642\u0628\u0648\u0644\u0647\u0645 \u0623\u0648 \u0631\u0641\u0636\u0647\u0645 \u0641\u0648\u0631\u0627\u064B \u0623\u0648 \u0642\u0645 \u0645\u0631\u0627\u062C\u0639\u0629 \u062A\u0641\u0627\u0635\u064A\u0644 \u0645\u0644\u0641\u0627\u062A\u0647\u0645 \u0627\u0644\u0634\u062E\u0635\u064A\u0629.","applicant_details_title":"\u062A\u0641\u0627\u0635\u064A\u0644 \u0645\u0642\u062F\u0645 \u0627\u0644\u0637\u0644\u0628","applicant_details":"\u062A\u0639\u0631\u0636 \u0635\u0641\u062D\u0629 \u062A\u0641\u0627\u0635\u064A\u0644 \u0645\u0648\u0638\u0641 \u0623\u0648\u063A\u0631\u0627\u0645 \u062A\u0635\u0646\u064A\u0641\u0647\u0645 \u0648 \u0623\u0641\u0636\u0644 \u0627\u0644\u0645\u0647\u0627\u0631\u0627\u062A \u0648 \u0645\u0633\u062A\u0648\u0649 \u0627\u0644\u062E\u0628\u0631\u0629 \u0648 \u0627\u0644\u0633\u064A\u0631\u0629 \u0627\u0644\u0630\u0627\u062A\u064A\u0629 \u0648\u062E\u0628\u0631\u0629 \u0627\u0644\u0639\u0645\u0644 \u0648 \u0645\u0633\u062A\u0648\u0649 \u0627\u0644\u062A\u0639\u0644\u064A\u0645\u064A."},"locations_onboarding":{"title":"\u0627\u0644\u0645\u0648\u0627\u0642\u0639","location_list_title":"\u0642\u0627\u0626\u0645\u0629 \u0627\u0644\u0645\u0648\u0627\u0642\u0639","location_list":"\u064A\u062D\u062A\u0648\u064A \u0642\u0633\u0645 \\"\u0627\u0644\u0645\u0648\u0627\u0642\u0639\\" \u0639\u0644\u0649 \u0642\u0627\u0626\u0645\u0629 \u0628\u0645\u0648\u0627\u0642\u0639 \u0645\u0646\u0627\u0641\u0630 \u0627\u0644\u0628\u064A\u0639 \u0627\u0644\u062E\u0627\u0635\u0629 \u0628\u0643.","location_details_title":"\u062A\u0641\u0627\u0635\u064A\u0644 \u0627\u0644\u0645\u0648\u0642\u0639","location_details":"\u064A\u0631\u062C\u0649 \u0627\u0644\u062A\u0623\u0643\u062F \u0645\u0646 \u062F\u0642\u0629 \u0645\u0648\u0642\u0639\u0643 \u0639\u0644\u0649 \u0627\u0644\u062E\u0631\u064A\u0637\u0629. \u0644\u0623\u0646 \u0645\u0648\u0638\u0641\u064A \u0623\u0648\u063A\u0631\u0627\u0645 \u0644\u0646 \u064A\u062A\u0645\u0643\u0646\u0648\u0627 \u0645\u0646 \u062A\u0633\u062C\u064A\u0644 \u062D\u0636\u0648\u0631\u0647\u0645 \u062E\u0627\u0631\u062C \u0627\u0644\u0646\u0642\u0637\u0629 \u0627\u0644\u0645\u062D\u062F\u062F\u0629."},"users_onboarding":{"title":"\u0627\u0644\u0645\u0633\u062A\u062E\u062F\u0645\u0648\u0646","user_list_title":"\u0642\u0627\u0626\u0645\u0629 \u0627\u0644\u0645\u0633\u062A\u062E\u062F\u0645\u064A\u0646","user_list":"\u064A\u062A\u064A\u062D \u0644\u0643 \u0642\u0633\u0645 \\"\u0627\u0644\u0645\u0633\u062A\u062E\u062F\u0645\u0648\u0646\\" \u0627\u0644\u062A\u062D\u0643\u0645 \u0641\u064A \u0645\u0646 \u0644\u062F\u064A\u0647 \u062D\u0642 \u0627\u0644\u0648\u0635\u0648\u0644 \u0625\u0644\u0649 \u0634\u0631\u0643\u062A\u0643. \u064A\u0645\u0643\u0646\u0643 \u0625\u0646\u0634\u0627\u0621 \u0645\u0633\u062A\u062E\u062F\u0645\u064A\u0646 \u062C\u062F\u062F \u0623\u0648 \u062F\u0639\u0648\u0629 \u0645\u0633\u062A\u062E\u062F\u0645\u064A\u0646 \u0645\u0648\u062C\u0648\u062F\u064A\u0646.","user_details_title":"\u062A\u0641\u0627\u0635\u064A\u0644 \u0627\u0644\u0645\u0633\u062A\u062E\u062F\u0645","user_details":"\u064A\u0645\u0643\u0646\u0643 \u062A\u0639\u064A\u064A\u0646 \u0623\u062D\u062F \u0627\u0644\u0623\u062F\u0648\u0627\u0631 \u0627\u0644\u062A\u0627\u0644\u064A\u0629: \u0645\u0633\u0624\u0648\u0644\u060C \u0645\u062F\u064A\u0631 \u0627\u0644\u062D\u0636\u0648\u0631\u060C \u0645\u0633\u0624\u0648\u0644 \u0627\u0644\u0645\u0627\u0644\u064A\u0629. \u0648\u064A\u0645\u0643\u0646 \u062A\u062D\u062F\u064A\u062F \u0627\u0644\u0623\u062F\u0648\u0627\u0631 \u062D\u0633\u0628 \u0627\u0644\u0645\u0648\u0642\u0639."},"rating_requests_onboarding":{"title":"\u0637\u0644\u0628\u0627\u062A \u0627\u0644\u062A\u0642\u064A\u064A\u0645","pending_feedback_title":"\u0641\u064A \u0627\u0646\u062A\u0638\u0627\u0631 \u062A\u0639\u0644\u064A\u0642 \u0639\u0644\u0649 \u0627\u0644\u0648\u0638\u0627\u0626\u0641","pending_feedback":"\u064A\u062D\u062A\u0648\u064A \u0642\u0633\u0645 \\"\u0637\u0644\u0628\u0627\u062A \u0627\u0644\u062A\u0642\u064A\u064A\u0645\\" \u0639\u0644\u0649 \u0642\u0627\u0626\u0645\u0629 \u0628\u0627\u0644\u0648\u0638\u0627\u0626\u0641 \u0627\u0644\u062A\u064A \u062A\u062A\u0637\u0644\u0628 \u062A\u0639\u0644\u064A\u0642\u0627\u062A\u0643. \u0628\u0639\u062F \u0627\u0644\u0627\u0646\u062A\u0647\u0627\u0621 \u0645\u0646 \u0627\u0644\u0648\u0638\u064A\u0641\u0629\u060C \u0646\u0648\u062F \u0645\u0646\u0643 \u062A\u0642\u064A\u064A\u0645 \u062A\u062C\u0631\u0628\u062A\u0643.","rating_details_title":"\u062A\u0641\u0627\u0635\u064A\u0644 \u062A\u0642\u064A\u064A\u0645 \u0627\u0644\u0648\u0638\u064A\u0641\u0629","rating_details":"\u064A\u0645\u0643\u0646\u0643 \u062A\u0642\u064A\u064A\u0645 \u062A\u062C\u0631\u0628\u062A\u0643 \u0627\u0644\u0648\u0638\u064A\u0641\u064A\u0629 \u0627\u0644\u0625\u062C\u0645\u0627\u0644\u064A\u0629\u060C \u0648\u0643\u0630\u0644\u0643 \u0627\u064A\u0636\u0627 \u062A\u0642\u064A\u064A\u0645 \u0623\u0641\u0631\u0627\u062F \u0645\u0648\u0638\u0641\u064A \u0623\u0648\u063A\u0631\u0627\u0645. \u0648\u064A\u062D\u0642 \u0644\u0643 \u062A\u0642\u062F\u064A\u0645 \u0627\u0644\u062B\u0646\u0627\u0621 \u0648 \u0627\u0644\u0642\u0627\u0621 \u0627\u0644\u0636\u0648\u0621 \u0639\u0644\u0649 \u0627\u0644\u0645\u0634\u0643\u0644\u0627\u062A \u0648 \u062A\u0631\u0643 \u0627\u0644\u062A\u0639\u0644\u064A\u0642\u0627\u062A."},"invoices_onboarding":{"title":"\u0627\u0644\u0641\u0648\u0627\u062A\u064A\u0631","invoice_list_title":"\u0642\u0627\u0626\u0645\u0629 \u0627\u0644\u0641\u0648\u0627\u062A\u064A\u0631","invoice_list":"\u062A\u062D\u062A\u0648\u064A \\"\u0627\u0644\u0641\u0648\u0627\u062A\u064A\u0631\\" \u0639\u0644\u0649 \u0642\u0627\u0626\u0645\u0629 \u0644\u0641\u0648\u0627\u062A\u064A\u0631\u0643 \u0627\u0644\u062D\u0627\u0644\u064A\u0629 \u0648 \u0627\u0644\u0633\u0627\u0628\u0642\u0629. \u0625\u0630\u0627 \u0643\u0627\u0646\u062A \u0623\u064A \u0641\u0627\u062A\u0648\u0631\u0629 \u0641\u064A \u062D\u0627\u0644\u0629 \\"\u0642\u064A\u062F \u0627\u0644\u0627\u0646\u062A\u0638\u0627\u0631\\"\u060C \u0641\u0647\u0630\u0627 \u064A\u0639\u0646\u064A \u0623\u0646\u0646\u0627 \u0646\u062A\u0648\u0642\u0639 \u0633\u062F\u0627\u062F\u0627\u064B \u0645\u0646\u0643.","invoice_breakdown_title":"\u062A\u0641\u0627\u0635\u064A\u0644 \u0627\u0644\u0641\u0627\u062A\u0648\u0631\u0629","invoice_breakdown":"\u062A\u062D\u062A\u0648\u064A \u0635\u0641\u062D\u0629 \u0627\u0644\u0637\u0644\u0628 \u0639\u0644\u0649 \u0645\u0644\u062E\u0635 \u0628\u0627\u0644\u0625\u0636\u0627\u0641\u0629 \u0625\u0644\u0649 \u062A\u0641\u0635\u064A\u0644 \u0644\u0644\u0648\u0638\u0627\u0626\u0641. \u0645\u0646 \u062E\u0644\u0627\u0644 \u062A\u0648\u0633\u064A\u0639 \u062E\u064A\u0627\u0631 \u0627\u0644\u0648\u0638\u0627\u0626\u0641\u060C \u0633\u062A\u062A\u0645\u0643\u0646 \u0645\u0646 \u0627\u0644\u0639\u062B\u0648\u0631 \u0639\u0644\u0649 \u0645\u0644\u062E\u0635 \u0627\u0644\u0645\u0646\u0627\u0648\u0628\u0627\u062A \u0645\u0642\u0633\u0645\u0629 \u062D\u0633\u0628 \u0645\u0648\u0638\u0641\u064A \u0623\u0648\u063A\u0631\u0627\u0645.","shifts_breakdown_title":"\u062A\u0641\u0627\u0635\u064A\u0644 \u0641\u0648\u062A\u0631\u0629 \u0627\u0644\u0645\u0646\u0627\u0648\u0628\u0627\u062A","shifts_breakdown":"\u0645\u0646 \u062E\u0644\u0627\u0644 \u0627\u0644\u0636\u063A\u0637 \u0639\u0644\u0649 \u0645\u0648\u0638\u0641 \u0623\u0648\u063A\u0631\u0627\u0645\u060C \u064A\u0645\u0643\u0646\u0643 \u0631\u0624\u064A\u0629 \u0639\u062F\u062F \u0627\u0644\u0633\u0627\u0639\u0627\u062A \u0627\u0644\u062A\u064A \u0639\u0645\u0644 \u0628\u0647\u0627 \u0645\u0648\u0638\u0641 \u0623\u0648\u063A\u0631\u0627\u0645 \u0641\u064A \u0643\u0644 \u064A\u0648\u0645.","export_invoice_title":"\u062A\u0635\u062F\u064A\u0631 \u0627\u0644\u0641\u0627\u062A\u0648\u0631\u0629","export_invoice":"\u0645\u0646 \u0642\u0627\u0626\u0645\u0629 \u0627\u0644\u0641\u0627\u062A\u0648\u0631\u0629\u060C \u064A\u0645\u0643\u0646\u0643 \u062A\u062D\u0645\u064A\u0644 \u062A\u0641\u0627\u0635\u064A\u0644 \u0627\u0644\u0641\u0627\u062A\u0648\u0631\u0629 \u0628\u0635\u064A\u063A\u0629 PDF\u061B \u0628\u0627\u0644\u0625\u0636\u0627\u0641\u0629 \u0625\u0644\u0649 \u0627\u0644\u0625\u0628\u0644\u0627\u063A \u0639\u0646 \u0623\u064A \u0645\u0634\u0643\u0644\u0627\u062A \u0645\u062A\u0639\u0644\u0642\u0629 \u0628\u0627\u0644\u0641\u0627\u062A\u0648\u0631\u0629."},"duplicate_order":{"choose_jobs_main_title":"\u0623\u0648\u0644\u0627\u064B\u060C \u062D\u062F\u062F\u0627\u0644\u0648\u0638\u0627\u0626\u0641 \u0627\u0644\u062A\u064A \u062A\u0631\u064A\u062F\u0647\u0627","choose_jobs_secondary_title":"\u0627\u062E\u062A\u0631 \u0648\u062D\u062F\u062F \u0627\u0644\u0648\u0638\u0627\u0626\u0641 \u0627\u0644\u062A\u064A \u062A\u062D\u062A\u0627\u062C \u0625\u0644\u0649 \u062A\u0645\u062F\u064A\u062F\u0647\u0627","choose_jobs_confirm":"\u062A\u0623\u0643\u064A\u062F","duplicate_job_subtitle":"\u064A\u0631\u062C\u0649 \u0645\u0631\u0627\u062C\u0639\u0629 \u062A\u0641\u0627\u0635\u064A\u0644 \u0627\u0644\u0648\u0638\u064A\u0641\u0629","duplicate_order":"\u0646\u0633\u062E \u0627\u0644\u0637\u0644\u0628"},"payment":{"payment":"\u062F\u0641\u0639","card_payment":"\u0627\u0644\u062F\u0641\u0639","was_successful":"\u0634\u0643\u0631\u0627 \u0644\u0643\u060C \u0644\u0642\u062F \u062A\u0645 \u0627\u0644\u062F\u0641\u0639 \u0628\u0646\u062C\u0627\u062D.","email_was_sent_to":"\u0644\u0642\u062F \u062A\u0645 \u0625\u0631\u0633\u0627\u0644 \u0628\u0631\u064A\u062F \u0625\u0644\u0643\u062A\u0631\u0648\u0646\u064A \u0644\u0644\u062A\u0623\u0643\u064A\u062F \u0625\u0644\u0649 ","can_go_to_payments_list_page":"\u064A\u0645\u0643\u0646\u0643 \u0627\u0644\u0630\u0647\u0627\u0628 \u0625\u0644\u0649 \u0635\u0641\u062D\u0629 \u0627\u0644\u0645\u062F\u0641\u0648\u0639\u0627\u062A \u0648\u0627\u0644\u062A\u062D\u0642\u0642 \u0645\u0646 \u062D\u0627\u0644\u062A\u0647\u0627 \u0647\u0646\u0627\u0643","transaction_id":"\u0631\u0642\u0645 \u0627\u0644\u0639\u0645\u0644\u064A\u0629","date":"\u0627\u0644\u062A\u0627\u0631\u064A\u062E","payment_method":"\u0637\u0631\u064A\u0642\u0629 \u0627\u0644\u062F\u0641\u0639","amount":"\u0627\u0644\u0645\u0628\u0644\u063A","status":"\u0627\u0644\u062D\u0627\u0644\u0629","go_to_payments_list_page":"\u0627\u0644\u0630\u0647\u0627\u0628 \u0625\u0644\u0649 \u0627\u0644\u0645\u062F\u0641\u0648\u0639\u0627\u062A","status_unpaid":"\u063A\u064A\u0631 \u0645\u062F\u0641\u0648\u0639\u0629","status_processing":"\u064A\u062A\u0645 \u0627\u0644\u0645\u0639\u0627\u0644\u062C\u0629","status_paid":"\u0645\u062F\u0641\u0648\u0639","status_cancelled":"\u0623\u0644\u063A\u064A\u062A","status_refunded":"\u062A\u0645 \u0627\u0633\u062A\u0631\u062F\u0627\u062F \u0627\u0644\u0645\u0628\u0644\u063A","payment_method_card_title":"\u0628\u0637\u0627\u0642\u0629","payment_method_card_wide_title":"\u0627\u0644\u062F\u0641\u0639 \u0628\u0627\u0644\u0628\u0637\u0627\u0642\u0629","payment_method_card_description":"\u0628\u0637\u0627\u0642\u0629 \u0627\u0626\u062A\u0645\u0627\u0646/\u0628\u0637\u0627\u0642\u0629 \u0633\u062D\u0628","payment_method_lean_description":"\u0627\u0644\u062A\u062D\u0648\u064A\u0644 \u0627\u0644\u0628\u0646\u0643\u064A \u0627\u0644\u0641\u0648\u0631\u064A","processing_running":"\u064A\u062A\u0645 \u0627\u0644\u0645\u0639\u0627\u0644\u062C\u0629...","save_card_for_future":"\u0627\u062D\u0641\u0638 \u0647\u0630\u0647 \u0627\u0644\u0628\u0637\u0627\u0642\u0629 \u0644\u0644\u0645\u0639\u0627\u0645\u0644\u0627\u062A \u0627\u0644\u0645\u0633\u062A\u0642\u0628\u0644\u064A\u0629","all_transactions_are_secured":"\u062C\u0645\u064A\u0639 \u0627\u0644\u0645\u0639\u0627\u0645\u0644\u0627\u062A \u0622\u0645\u0646\u0629 \u0648\u0645\u0634\u0641\u0631\u0629","details":"\u062A\u0641\u0627\u0635\u064A\u0644","payment_number":"\u0631\u0642\u0645 \u0645\u0639\u0627\u0645\u0644\u0629 \u0627\u0644\u062F\u0641\u0639","due_date":"\u062A\u0627\u0631\u064A\u062E \u0627\u0644\u0627\u0633\u062A\u062D\u0642\u0627\u0642","invoices":"\u0627\u0644\u0641\u0648\u0627\u062A\u064A\u0631","total_payment":"\u0627\u0644\u0645\u0628\u0644\u063A \u0627\u0644\u0625\u062C\u0645\u0627\u0644\u064A ","pay_now":"\u0627\u062F\u0641\u0639 \u0627\u0644\u0622\u0646","authorize":"\u0648\u0627\u0641\u0642 \u0627\u0644\u0622\u0646","pending":"\u0642\u064A\u062F \u0627\u0644\u0627\u0646\u062A\u0638\u0627\u0631","processing":"\u064A\u062A\u0645 \u0627\u0644\u0645\u0639\u0627\u0644\u062C\u0629","completed":"\u0627\u0643\u062A\u0645\u0644","invoice":"\u0641\u0627\u062A\u0648\u0631\u0629","payment_details_title":"\u062F\u0641\u0639\u0629#{{paymentId}}","payments":"\u0627\u0644\u0645\u062F\u0641\u0648\u0639\u0627\u062A","payment_methods":"\u0637\u0631\u0642 \u0627\u0644\u062F\u0641\u0639","select_payment_method":"\u0627\u062E\u062A\u0627\u0631 \u0637\u0631\u064A\u0642\u0629 \u0627\u0644\u062F\u0641\u0639 \u0627\u0644\u062A\u064A \u062A\u0631\u064A\u062F \u0627\u0633\u062A\u062E\u062F\u0627\u0645\u0647\u0627","continue":"\u0627\u0643\u0645\u0644","pay":"\u062F\u0641\u0639","payment_completed":"\u062A\u0645 \u0627\u0644\u062F\u0641\u0639","payment_processing":"\u062C\u0627\u0631\u064A \u0645\u0639\u0627\u0644\u062C\u0629 \u0627\u0644\u062F\u0641\u0639","updating_status":"\u062A\u062D\u062F\u064A\u062B \u0627\u0644\u062D\u0627\u0644\u0629...","empty_pending_list":"\u0644\u0627 \u062A\u0648\u062C\u062F \u0645\u062F\u0641\u0648\u0639\u0627\u062A \u0645\u0639\u0644\u0642\u0629","empty_processing_list":"\u0644\u0627 \u064A\u0648\u062C\u062F \u0645\u062F\u0641\u0648\u0639\u0627\u062A \u064A\u062A\u0645 \u0645\u0639\u0627\u0644\u062C\u062A\u0647\u0627","empty_completed_list":"\u0644\u0627 \u064A\u0648\u062C\u062F \u0645\u062F\u0641\u0648\u0639\u0627\u062A \u062A\u0645 \u0625\u0643\u0645\u0627\u0644\u0647\u0627","back_to_order":"\u0627\u0644\u0639\u0648\u062F\u0629 \u0625\u0644\u0649 \u0627\u0644\u0637\u0644\u0628","overdue_balance":"\u0627\u0644\u0631\u0635\u064A\u062F \u0627\u0644\u0645\u0633\u062A\u062D\u0642","payment_method_wire_transfer_title":"\u0627\u0644\u062A\u062D\u0648\u064A\u0644 \u0627\u0644\u0628\u0646\u0643\u064A","payment_method_wire_transfer_description":"\u0627\u0644\u062A\u062D\u0648\u064A\u0644 \u0627\u0644\u0628\u0646\u0643\u064A","text_copied":"\u062A\u0645 \u0646\u0633\u062E \u0627\u0644\u0646\u0635 \u0625\u0644\u0649 \u0627\u0644\u062D\u0627\u0641\u0638\u0629","checkout":"\u0627\u0644\u062F\u0641\u0639","wire_transfer_details":"\u062A\u0641\u0627\u0635\u064A\u0644 \u0627\u0644\u062A\u062D\u0648\u064A\u0644 \u0627\u0644\u0628\u0646\u0643\u064A","wire_transfer_amount":"\u0627\u0644\u0642\u064A\u0645\u0629","wire_transfer_bank_account_name":"\u0627\u0633\u0645 \u0627\u0644\u062D\u0633\u0627\u0628","wire_transfer_bank_account_bank_name":"\u0627\u0633\u0645 \u0627\u0644\u0628\u0646\u0643","wire_transfer_bank_account_number":"\u0631\u0642\u0645 \u0627\u0644\u062D\u0633\u0627\u0628","wire_transfer_bank_account_iban":"IBAN","wire_transfer_bank_account_bank_address":"\u0639\u0646\u0648\u0627\u0646 \u0627\u0644\u0628\u0646\u0643","wire_transfer_upload_alert_text":"\u064A\u0631\u062C\u0649 \u0631\u0641\u0639 \u0646\u0633\u062E\u0629 \u0645\u0646 \u0625\u062B\u0628\u0627\u062A \u0627\u0644\u062F\u0641\u0639 \u0627\u0644\u0628\u0646\u0643\u064A \u0627\u0644\u062E\u0627\u0635 \u0628\u0643 \u0641\u064A \u0627\u0644\u0625\u064A\u0635\u0627\u0644","next":"\u0627\u0644\u062A\u0627\u0644\u064A","wire_transfer_has_been_canceled":"\u062A\u0645 \u0625\u0644\u063A\u0627\u0621 \u0639\u0645\u0644\u064A\u0629 \u0627\u0644\u062A\u062D\u0648\u064A\u0644 \u0627\u0644\u0628\u0646\u0643\u064A","wire_transfer_slip_was_uploaded":"\u062A\u0645 \u0631\u0641\u0639 \u0627\u0644\u0625\u064A\u0635\u0627\u0644","please_upload_slip":"\u064A\u0631\u062C\u0649 \u0631\u0641\u0639 \u0642\u0633\u064A\u0645\u0629 \u0627\u0644\u0628\u0646\u0643","bank_slip_info_in_alert":"\u064A\u062C\u0628 \u0623\u0646 \u064A\u0634\u0645\u0644 \u0625\u064A\u0635\u0627\u0644 \u0627\u0644\u0628\u0646\u0643 \u0645\u0628\u0644\u063A \u0627\u0644\u062F\u0641\u0639 \u0648\u062E\u062A\u0645 \u0627\u0644\u0628\u0646\u0643 \u0628\u0634\u0643\u0644 \u0648\u0627\u0636\u062D","payment_slip":"\u0642\u0633\u064A\u0645\u0629 \u0627\u0644\u0631\u0627\u062A\u0628","upload_payment_slip":"\u0631\u0641\u0639 \u0628\u064A\u0627\u0646 \u0627\u0644\u0631\u0627\u062A\u0628","document_selected":"\u062A\u0645 \u0627\u062E\u062A\u064A\u0627\u0631 \u0627\u0644\u0645\u0633\u062A\u0646\u062F","you_can_upload_slip_now_or_later":"\u064A\u0645\u0643\u0646\u0643 \u0631\u0641\u0639 \u0648\u0631\u0642\u0629 \u0627\u0644\u0642\u0633\u064A\u0645\u0629 \u0627\u0644\u0622\u0646 \u0623\u0648 \u0644\u0627\u062D\u0642\u0627\u064B \u0628\u0627\u0633\u062A\u062E\u062F\u0627\u0645 \u0627\u0644\u0632\u0631 \u0623\u0639\u0644\u0627\u0647. \u0633\u0646\u0630\u0643\u0631\u0643 \u0628\u0631\u0641\u0639 \u0648\u0631\u0642\u0629 \u0627\u0644\u0642\u0633\u064A\u0645\u0629 \u062D\u062A\u0649 \u062A\u0642\u0648\u0645 \u0628\u0631\u0641\u0639\u0647\u0627.","you_can_select_another_payment_method":"\u0625\u0630\u0627 \u0643\u0646\u062A \u062A\u0631\u064A\u062F \u0641\u064A \u0627\u062E\u062A\u064A\u0627\u0631 \u0637\u0631\u064A\u0642\u0629 \u062F\u0641\u0639 \u0623\u062E\u0631\u0649\u060C \u064A\u0631\u062C\u0649 \u0625\u0644\u063A\u0627\u0621 \u0627\u0644\u062A\u062D\u0648\u064A\u0644 \u0627\u0644\u0628\u0646\u0643\u064A \u0628\u0627\u0633\u062A\u062E\u062F\u0627\u0645 \u0647\u0630\u0627 \u0627\u0644\u0631\u0627\u0628\u0637.","wire_transfer_cancel_button":"\u0625\u0644\u063A\u0627\u0621 \u0627\u0644\u062A\u062D\u0648\u064A\u0644 \u0627\u0644\u0628\u0646\u0643\u064A \u0648\u0627\u062E\u062A\u064A\u0627\u0631 \u0637\u0631\u064A\u0642\u0629 \u062F\u0641\u0639 \u0623\u062E\u0631\u0649","wire_transfer_remind_later_button":"\u0630\u0643\u0631\u0646\u064A \u0644\u0627\u062D\u0642\u0627","wire_transfer_i_have_sent_money":"\u0644\u0642\u062F \u0623\u0631\u0633\u0644\u062A \u0627\u0644\u0645\u0627\u0644","wire_transfer_slip_uploading":"\u064A\u062A\u0645 \u0627\u0644\u062A\u062D\u0645\u064A\u0644...","wire_transfer_slip_under_review":"\u0627\u0644\u0642\u0633\u064A\u0645\u0629 \u0642\u064A\u062F \u0627\u0644\u0645\u0631\u0627\u062C\u0639\u0629","wire_transfer_out_team_is_checking_slip":"\u0633\u064A\u0642\u0648\u0645 \u0641\u0631\u064A\u0642\u0646\u0627 \u0628\u0641\u062D\u0635 \u0627\u0644\u0642\u0633\u064A\u0645\u0629 \u0628\u0639\u062F \u0642\u0644\u064A\u0644.","download_slip":"\u062A\u062D\u0645\u064A\u0644 \u0627\u0644\u0642\u0633\u064A\u0645\u0629","card_payment_cancel_button":"\u0625\u0644\u063A\u0627\u0621 \u0627\u0644\u062F\u0641\u0639 \u0628\u0627\u0644\u0628\u0637\u0627\u0642\u0629 \u0648\u0627\u062E\u062A\u064A\u0627\u0631 \u0637\u0631\u064A\u0642\u0629 \u062F\u0641\u0639 \u0623\u062E\u0631\u0649","card_payment_has_been_canceled":"\u062A\u0645 \u0625\u0644\u063A\u0627\u0621 \u0627\u0644\u062F\u0641\u0639 \u0628\u0627\u0644\u0628\u0637\u0627\u0642\u0629","error_failed_to_load_panel":"\u0641\u0634\u0644 \u062A\u062D\u0645\u064A\u0644 \u0635\u0641\u062D\u0629 \u0627\u0644\u062F\u0641\u0639","add_account":"\u0625\u0636\u0627\u0641\u0629 \u062D\u0633\u0627\u0628","learn_more_about":"\u062A\u0639\u0631\u0641 \u0627\u0644\u0645\u0632\u064A\u062F \u062D\u0648\u0644","lean_payment":"\u0627\u0644\u062F\u0641\u0639 \u0627\u0644\u0644\u064A\u0646","lean_modal_title_1":"\u0644\u0645\u0627\u0630\u0627 \u062A\u0633\u062A\u062E\u062F\u0645 \u0627\u0644\u062A\u062D\u0648\u064A\u0644 \u0627\u0644\u0628\u0646\u0643\u064A \u0627\u0644\u0641\u0648\u0631\u064A\u061F","lean_modal_title_2":"\u0627\u0646\u0642\u0644 \u0627\u0644\u0623\u0645\u0648\u0627\u0644 \u0639\u0644\u0649 \u0627\u0644\u0641\u0648\u0631 \u0645\u0639 \u0627\u0644\u0628\u0646\u0643 \u0627\u0644\u062E\u0627\u0635 \u0628\u0643","lean_modal_title_3":"\u062A\u062A\u064A\u062D \u0644\u0643 \u0637\u0631\u064A\u0642\u0629 \u0627\u0644\u062F\u0641\u0639 \u0647\u0630\u0647 \u0625\u062C\u0631\u0627\u0621 \u062A\u062D\u0648\u064A\u0644 \u0645\u0635\u0631\u0641\u064A \u0641\u0648\u0631\u064A \u0645\u0646 \u062D\u0633\u0627\u0628\u0643 \u0627\u0644\u0645\u0635\u0631\u0641\u064A \u0627\u0644\u062A\u062C\u0627\u0631\u064A. \u0645\u0627 \u0639\u0644\u064A\u0643 \u0633\u0648\u0649 \u0631\u0628\u0637 \u062D\u0633\u0627\u0628\u0643 \u0645\u0631\u0629 \u0648\u0627\u062D\u062F\u0629 \u062B\u0645 \u064A\u0645\u0643\u0646\u0643 \u0627\u0633\u062A\u062E\u062F\u0627\u0645\u0647 \u0644\u0623\u064A \u0645\u062F\u0641\u0648\u0639\u0627\u062A \u0645\u0633\u062A\u0642\u0628\u0644\u064A\u0629.","lean_modal_action_1":"\u0642\u0645 \u0628\u0631\u0628\u0637 \u062D\u0633\u0627\u0628\u0643 \u0627\u0644\u0628\u0646\u0643\u064A","lean_modal_action_2":"\u0627\u0644\u062F\u0641\u0639 \u0627\u0644\u0641\u0648\u0631\u064A","lean_modal_title_4":"\u0633\u064A\u062A\u0645 \u062A\u0623\u0645\u064A\u0646 \u0645\u062F\u0641\u0648\u0639\u0627\u062A\u0643 \u062F\u0627\u0626\u0645\u0627 \u0645\u0646 \u062E\u0644\u0627\u0644 \u0627\u0644\u0645\u0635\u0627\u062F\u0642\u0629 \u0645\u062A\u0639\u062F\u062F\u0629 \u0627\u0644\u0639\u0648\u0627\u0645\u0644 (MFA)\u060C \u0628\u0646\u0641\u0633 \u0627\u0644\u0637\u0631\u064A\u0642\u0629 \u0643\u0645\u0627 \u0644\u0648 \u0643\u0646\u062A \u062A\u0633\u062A\u062E\u062F\u0645 \u062D\u0633\u0627\u0628\u0643 \u0627\u0644\u0645\u0635\u0631\u0641\u064A.","payment_awaiting_authorization":"\u0627\u0644\u062F\u0641\u0639 \u0641\u064A \u0627\u0646\u062A\u0638\u0627\u0631 \u0627\u0644\u0645\u0648\u0627\u0641\u0642\u0629","will_be_paid_after_authorize":"\u0633\u064A\u062A\u0645 \u062F\u0641\u0639 \u0645\u0633\u062A\u062D\u0642\u0627\u062A\u0643 \u0628\u0639\u062F \u0645\u0648\u0627\u0641\u0642\u062A\u0643 \u0639\u0644\u064A\u0647\u0627.","loading":"\u0627\u0646\u062A\u0638\u0631...","connect_lean_account":"\u0627\u0631\u0628\u0637 \u062D\u0633\u0627\u0628\u0643 \u0627\u0644\u0645\u0631\u0646","successfully_connected_bank":"\u062A\u0645 \u0631\u0628\u0637 \u0627\u0644\u062D\u0633\u0627\u0628 \u0627\u0644\u0645\u0635\u0631\u0641\u064A \u0628\u0646\u062C\u0627\u062D","payment_has_been_queued":"\u062A\u0645 \u0648\u0636\u0639 \u0627\u0644\u062F\u0641\u0639 \u0641\u064A \u0642\u0627\u0626\u0645\u0629 \u0627\u0644\u0627\u0646\u062A\u0638\u0627\u0631","successfully_paid":"\u062A\u0645 \u0627\u0644\u062F\u0641\u0639 \u0628\u0646\u062C\u0627\u062D","cannot_pay":"\u0641\u0634\u0644 \u0639\u0645\u0644\u064A\u0629 \u0627\u0644\u062F\u0641\u0639","lean":{"setup_status_active":"\u0642\u064A\u062F \u0627\u0644\u0639\u0645\u0644","setup_status_pending":"\u0645\u0639\u0644\u0642\u0629","setup_status_not_connected":"\u063A\u064A\u0631 \u0645\u062A\u0635\u0644","account_is_being_connected":"\u064A\u062A\u0645 \u0627\u0644\u0622\u0646 \u0631\u0628\u0637 \u062D\u0633\u0627\u0628\u0643. \u064A\u0631\u062C\u0649 \u0627\u062E\u062A\u064A\u0627\u0631 \u0637\u0631\u064A\u0642\u0629 \u062F\u0641\u0639 \u0623\u062E\u0631\u0649 \u0623\u0648 \u0627\u0644\u0645\u062D\u0627\u0648\u0644\u0629 \u0645\u0631\u0629 \u0623\u062E\u0631\u0649 \u0644\u0627\u062D\u0642\u0627\u064B"}},"account_statement":{"recent_activities":"\u0627\u0644\u0623\u0646\u0634\u0637\u0629 \u0627\u0644\u0623\u062E\u064A\u0631\u0629","account_statement":"\u0643\u0634\u0641 \u0627\u0644\u062D\u0633\u0627\u0628","currency":"\u062F\u0631\u0647\u0645 \u0625\u0645\u0627\u0631\u0627\u062A\u064A","from":"\u0645\u0646","to":"\u0625\u0644\u0649","starts_from":"\u064A\u0628\u062F\u0623 \u0645\u0646","downloading":"\u062C\u0627\u0631\u064A \u0627\u0644\u062A\u062D\u0645\u064A\u0644...","download":"\u062A\u062D\u0645\u064A\u0644","invoice":"\u0641\u0627\u062A\u0648\u0631\u0629","credit_note":"\u0645\u0630\u0643\u0631\u0629 \u0627\u0644\u0627\u0626\u062A\u0645\u0627\u0646","empty_list":"\u0644\u0627 \u062A\u0648\u062C\u062F \u0628\u064A\u0627\u0646\u0627\u062A \u0644\u0644\u0641\u062A\u0631\u0629 \u0627\u0644\u0645\u062E\u062A\u0627\u0631\u0629"},"calendar":{"month_january":"\u064A\u0646\u0627\u064A\u0631","month_february":"\u0641\u0628\u0631\u0627\u064A\u0631","month_march":"\u0622\u0630\u0627\u0631","month_april":"\u0623\u0628\u0631\u064A\u0644","month_may":"\u0645\u0627\u064A\u0648","month_june":"\u064A\u0648\u0646\u064A\u0648","month_july":"\u062A\u0645\u0648\u0632","month_august":"\u0623\u063A\u0633\u0637\u0633","month_september":"\u0623\u064A\u0644\u0648\u0644","month_october":"\u0623\u0643\u062A\u0648\u0628\u0631","month_november":"\u0646\u0648\u0641\u0645\u0628\u0631","month_december":"\u062F\u064A\u0633\u0645\u0628\u0631","month":"\u0634\u0647\u0631","year":"\u0633\u0646\u0629","cancel":"\u0625\u0644\u063A\u0627\u0621","set":"\u062A\u0639\u064A\u064A\u0646","clear":"\u0645\u0633\u062D","all_locations":"\u062C\u0645\u064A\u0639 \u0627\u0644\u0645\u0648\u0627\u0642\u0639"},"payment_item":{"status_draft":"\u0645\u0633\u0648\u062F\u0629","status_paid":"\u0645\u062F\u0641\u0648\u0639","status_unpaid":"\u0645\u0639\u0644\u0642\u0629","status_processed":"\u062A\u0645\u062A \u0645\u0639\u0627\u0644\u062C\u062A\u0647","status_voided":"\u0645\u0644\u063A\u0649"},"saved_payment_methods":{"method_has_been_added":"\u062A\u0645\u062A \u0625\u0636\u0627\u0641\u0629 \u0637\u0631\u064A\u0642\u0629 \u0627\u0644\u062F\u0641\u0639 \u0628\u0646\u062C\u0627\u062D","save_card":"\u062D\u0641\u0638 \u0627\u0644\u0628\u0637\u0627\u0642\u0629","saving_progress":"\u064A\u062A\u0645 \u0627\u0644\u062D\u0641\u0638...","remove_payment_method":"\u0625\u0632\u0627\u0644\u0629 \u0637\u0631\u064A\u0642\u0629 \u0627\u0644\u062F\u0641\u0639","method_has_been_deleted":"\u062A\u0645 \u062D\u0630\u0641 \u0637\u0631\u064A\u0642\u0629 \u0627\u0644\u062F\u0641\u0639 \u0628\u0646\u062C\u0627\u062D","payment_methods":"\u0637\u0631\u0642 \u0627\u0644\u062F\u0641\u0639","no_payment_methods_added":"\u0644\u0645 \u064A\u062A\u0645 \u0625\u0636\u0627\u0641\u0629 \u0637\u0631\u0642 \u0644\u0644\u062F\u0641\u0639 \u0628\u0639\u062F","add_new_card":"\u0625\u0636\u0627\u0641\u0629 \u0628\u0637\u0627\u0642\u0629 \u062C\u062F\u064A\u062F\u0629"},"error_boundary":{"default":{"server_error":"\u062E\u0637\u0623 \u0641\u064A \u0627\u0644\u062E\u0627\u062F\u0645 \u0627\u0644\u062F\u0627\u062E\u0644\u064A","permission_error":"\u062A\u0645 \u0631\u0641\u0636 \u0627\u0644\u0625\u0630\u0646","client_error":"\u062E\u0637\u0623 \u0641\u064A \u0627\u0644\u062A\u0637\u0628\u064A\u0642","not_found_error":"\u0644\u0645 \u064A\u062A\u0645 \u0627\u0644\u0639\u062B\u0648\u0631 \u0639\u0644\u064A\u0647","not_authorized_error":"\u063A\u064A\u0631 \u0645\u0635\u0631\u062D \u0644\u0647","connection_error":"\u062E\u0637\u0623 \u0641\u064A \u0627\u0644\u0627\u062A\u0635\u0627\u0644. \u062A\u062D\u0642\u0642 \u0645\u0646 \u0627\u062A\u0635\u0627\u0644\u0643 \u0628\u0627\u0644\u0625\u0646\u062A\u0631\u0646\u062A","too_many_requests_error":"\u0645\u062D\u0627\u0648\u0644\u0627\u062A \u0643\u062B\u064A\u0631\u0629. \u062D\u0627\u0648\u0644 \u0645\u0631\u0629 \u0623\u062E\u0631\u0649 \u0644\u0627\u062D\u0642\u0627\u064B","default_error":"\u062D\u062F\u062B \u062E\u0637\u0623 \u0645\u0627. \u064A\u0631\u062C\u0649 \u0627\u0644\u0645\u062D\u0627\u0648\u0644\u0629 \u0645\u0631\u0629 \u0623\u062E\u0631\u0649","try_again":"\u062D\u0627\u0648\u0644 \u0645\u0631\u0629 \u0623\u062E\u0631\u0649"},"payment":{"cannot_fetch_overdue_server_error":"\u0644\u0645 \u0646\u062A\u0645\u0643\u0646 \u0645\u0646 \u062C\u0644\u0628 \u0628\u064A\u0627\u0646\u0627\u062A \u0627\u0644\u0645\u062F\u0641\u0648\u0639\u0627\u062A \u0627\u0644\u0645\u062A\u0623\u062E\u0631\u0629"}},"pending_orders_panel":{"pending_confirmation":"\u0641\u064A \u0627\u0646\u062A\u0638\u0627\u0631 \u0627\u0644\u062A\u0623\u0643\u064A\u062F","n_orders":"{{count}} \u0637\u0644\u0628","confirm_now":"\u062A\u0623\u0643\u064A\u062F \u0627\u0644\u0622\u0646"},"raised_disputes_panel":{"title":"\u0627\u0644\u0646\u0632\u0627\u0639\u0627\u062A \u0627\u0644\u0645\u0631\u0641\u0648\u0639\u0629","n_disputes":"{{count}} \u0646\u0632\u0627\u0639","review_now":"\u0631\u0627\u062C\u0639 \u0627\u0644\u0622\u0646"},"step_indicator":{"step_of":"\u062E\u0637\u0648\u0629{{currentStepNumber}} \u0645\u0646 {{stepsCount}}"},"page_stepper":{"next":"\u0627\u0644\u062A\u0627\u0644\u064A","previous":"\u0627\u0644\u0633\u0627\u0628\u0642","finish":"\u0625\u0646\u062A\u0647\u0627\u0621","of":"\u0645\u0646"},"order_status":{"draft":"\u0645\u0633\u0648\u062F\u0629","pending_confirmation":"\u0641\u064A \u0627\u0646\u062A\u0638\u0627\u0631 \u0627\u0644\u062A\u0623\u0643\u064A\u062F","under_review":"\u062A\u062D\u062A \u0627\u0644\u0645\u0631\u0627\u062C\u0639\u0629","started":"\u0628\u062F\u0623\u062A","upcoming":"\u0627\u0644\u0642\u0627\u062F\u0645\u0629"},"toggle":{"yes_short":"\u0646\u0639\u0645","no_short":"\u0644\u0627"},"time":{"mon":"\u0627\u0644\u0625\u062B\u0646\u064A\u0646","tue":"\u0627\u0644\u062B\u0644\u0627\u062B\u0627\u0621","wed":"\u0627\u0644\u0623\u0631\u0628\u0639\u0627\u0621","thu":"\u0627\u0644\u062E\u0645\u064A\u0633","fri":"\u0627\u0644\u062C\u0645\u0639\u0629","sat":"\u0627\u0644\u0633\u0628\u062A","sun":"\u0627\u0644\u0623\u062D\u062F"},"time_picker":{"hour":"\u0633\u0627\u0639\u0629","minute":"\u062F\u0642\u064A\u0642\u0629","cancel":"\u0625\u0644\u063A\u0627\u0621","set":"\u062A\u0639\u064A\u064A\u0646"},"become_affiliate":{"modal_title":"\u0643\u0646 \u0634\u0631\u064A\u0643\u0627\u064B","modal_subtitle":"\u0642\u0645 \u0628\u062F\u0639\u0648\u0629 \u0645\u0648\u0638\u0641\u064A\u0643 \u0644\u0644\u0627\u0646\u0636\u0645\u0627\u0645 \u0625\u0644\u0649 \u0623\u0648\u063A\u0631\u0627\u0645 \u0648\u0643\u0633\u0628 \u0623\u0645\u0648\u0627\u0644 \u0625\u0636\u0627\u0641\u064A\u0629!","accept_tc":"\u0627\u0644\u0634\u0631\u0648\u0637 \u0648\u0627\u0644\u0623\u062D\u0643\u0627\u0645"},"common_affiliate":{"join_ogram":"\u0627\u0646\u0636\u0645 \u0625\u0644\u0649 \u0623\u0648\u063A\u0631\u0627\u0645 \u0628\u0627\u0633\u062A\u062E\u062F\u0627\u0645 \u0631\u0627\u0628\u0637\u064A","my_referrals":"\u0625\u062D\u0627\u0644\u0627\u062A\u064A","send_invitation":"\u0625\u0631\u0633\u0627\u0644 \u062F\u0639\u0648\u0629","share_link":"\u0642\u0645 \u0628\u062F\u0639\u0648\u0629 \u0641\u0631\u064A\u0642\u0643 \u0625\u0644\u0649 \u062A\u0637\u0628\u064A\u0642 \u0623\u0648\u063A\u0631\u0627\u0645 \u0648\u0627\u0628\u062F\u0623 \u0641\u064A \u0627\u0644\u0643\u0633\u0628!","copy_and_send_link":"\u0623\u0648 \u0642\u0645 \u0628\u0646\u0633\u062E \u0627\u0644\u0631\u0627\u0628\u0637 \u0623\u062F\u0646\u0627\u0647 \u0648\u0625\u0631\u0633\u0627\u0644\u0647","tc_1":"\u0647\u0630\u0647 \u0627\u0644\u0645\u0635\u0637\u0644\u062D\u0627\u062A \u0644\u0627 \u062A\u0631\u062A\u0628\u0637 \u0628\u0634\u0643\u0644 \u0645\u0628\u0627\u0634\u0631 \u0628\u0628\u0631\u0627\u0645\u062C \u0627\u0644\u0625\u062D\u0627\u0644\u0629\u060C \u0648\u0644\u0643\u0646 \u0647\u064A \u0642\u0631\u064A\u0628\u0629 \u0628\u0645\u0627 \u064A\u0643\u0641\u064A \u0644\u0646\u0634\u0645\u0644\u0647\u0627 \u0647\u0646\u0627","tc_2":"\u064A\u0633\u0627\u0639\u062F \u062A\u0639\u0631\u064A\u0641 \u0647\u0630\u0647 \u0627\u0644\u0645\u0635\u0637\u0644\u062D\u0627\u062A \u0641\u064A \u062A\u062E\u0641\u064A\u0641 \u0628\u0639\u0636 \u0627\u0644\u062D\u064A\u0631\u0629 \u062D\u0648\u0644 \u0645\u0627\u0647\u0648 \u0628\u0631\u0646\u0627\u0645\u062C \u0625\u062D\u0627\u0644\u0629 \u0648\u0645\u0627 \u0644\u064A\u0633 \u0628\u0630\u0644\u0643.","section_title":"\u0634\u0631\u064A\u0643","dashboard":"\u0644\u0648\u062D\u0629 \u0627\u0644\u0645\u0639\u0644\u0648\u0645\u0627\u062A","referrals":"\u0627\u0644\u0625\u062D\u0627\u0644\u0627\u062A","earnings":"\u0627\u0644\u0623\u0631\u0628\u0627\u062D","designation":"\u0645\u0633\u0645\u0649 \u0627\u0644\u0648\u0638\u064A\u0641\u064A","payout":"\u0627\u0644\u0645\u0628\u0644\u063A \u0627\u0644\u0645\u0633\u062A\u062D\u0642","due_date":"\u062A\u0627\u0631\u064A\u062E \u0627\u0644\u0627\u0633\u062A\u062D\u0642\u0627\u0642","join_date":"\u062A\u0627\u0631\u064A\u062E \u0627\u0644\u0627\u0646\u0636\u0645\u0627\u0645","this_month":"\u0647\u0630\u0627 \u0627\u0644\u0634\u0647\u0631","invite_more_staff":"\u062F\u0639\u0648\u0629 \u0627\u0644\u0645\u0632\u064A\u062F \u0645\u0646 \u0627\u0644\u0645\u0648\u0638\u0641\u064A\u0646","margin_split":"\u0627\u0644\u0647\u0627\u0645\u0634","invite_your_staff":"\u0642\u0645 \u0628\u062F\u0639\u0648\u0629 \u0645\u0648\u0638\u0641\u064A\u0643","invite_staff_more_details":"\u0642\u0645 \u0628\u062F\u0639\u0648\u0629 \u0632\u0645\u0644\u0627\u0626\u0643 \u0641\u064A \u0627\u0644\u0639\u0645\u0644 \u0644\u0644\u0627\u0646\u0636\u0645\u0627\u0645 \u0625\u0644\u0649 \u0623\u0648\u063A\u0631\u0627\u0645 \u0644\u0643\u0633\u0628 \u0623\u0645\u0648\u0627\u0644 \u0625\u0636\u0627\u0641\u064A\u0629!","invite_now":"\u0642\u0645 \u0628\u062F\u0639\u0648\u0629 \u0627\u0644\u0622\u0646","earning_history":"\u062A\u0627\u0631\u064A\u062E \u0627\u0644\u0623\u0631\u0628\u0627\u062D","total_earnings":"\u0645\u062C\u0645\u0648\u0639 \u0627\u0644\u0623\u0631\u0628\u0627\u062D","status_profile_created":"\u062A\u0645 \u0625\u0646\u0634\u0627\u0621 \u0627\u0644\u0645\u0644\u0641 \u0627\u0644\u0634\u062E\u0635\u064A","status_activated":"\u062A\u0645 \u0627\u0644\u062A\u0641\u0639\u064A\u0644","status_booked_shifts":"\u0627\u0644\u0645\u0646\u0627\u0648\u0628\u0627\u062A \u0627\u0644\u0645\u062D\u062C\u0648\u0632\u0629","status_shifts_done":"\u0627\u0644\u0645\u0646\u0627\u0648\u0628\u0627\u062A \u062A\u0645 \u0627\u0644\u0625\u0646\u062A\u0647\u0627\u0621 \u0645\u0646\u0647\u0627","status_unknown":"\u0645\u062C\u0647\u0648\u0644","referrals_list":"\u0642\u0627\u0626\u0645\u0629 \u0627\u0644\u0625\u062D\u0627\u0644\u0627\u062A"},"affiliate_instructions":{"how_it_works":"\u0643\u064A\u0641 \u062A\u0639\u0645\u0644","instruction_1_title":"\u0625\u0631\u0633\u0627\u0644 \u062F\u0639\u0648\u0629","instruction_1_subtitle":"\u0634\u0627\u0631\u0643 \u0627\u0644\u0631\u0627\u0628\u0637 \u0627\u0644\u062E\u0627\u0635 \u0628\u0643","instruction_2_title":"\u064A\u0646\u0636\u0645\u0648\u0627","instruction_2_subtitle":"\u0648 \u0627\u0628\u062F\u0623 \u0625\u0643\u0645\u0627\u0644 \u0627\u0644\u0645\u0646\u0627\u0648\u0628\u0627\u062A \u0627\u0644\u0645\u062F\u0641\u0648\u0639\u0629","instruction_3_title":"\u0627\u0628\u062F\u0623 \u0628\u0627\u0644\u0643\u0633\u0628!","instruction_3_subtitle":"\u0627\u062D\u0635\u0644 \u0639\u0644\u0649 \u0639\u0645\u0648\u0644\u0629 \u0645\u0642\u0627\u0628\u0644 \u0639\u0645\u0644\u0647\u0645","instruction_4_title":"\u062A\u062A\u0628\u0639 \u0645\u0648\u0638\u0641\u064A\u0643","instruction_4_subtitle":"\u0627\u0633\u062A\u062E\u062F\u0627\u0645 \u0644\u0648\u062D\u0629 \u0627\u0644\u0645\u0639\u0644\u0648\u0645\u0627\u062A \u0644\u0634\u0631\u0643\u0627\u062A \u0627\u0644\u062A\u0627\u0628\u0639\u0629 \u0644\u0646\u0627"},"qr_scan":{"invalid_qr_code_provided":"\u062A\u0645 \u062A\u0648\u0641\u064A\u0631 \u0631\u0645\u0632 QR \u063A\u064A\u0631 \u0635\u0627\u0644\u062D. \u064A\u0631\u062C\u0649 \u062A\u0642\u062F\u064A\u0645 \u0627\u0644\u0631\u0645\u0632 \u0627\u0644\u0630\u064A \u0642\u062F\u0645\u0647 \u0623\u062D\u062F \u0645\u0633\u062A\u062E\u062F\u0645\u064A \u0623\u0648\u063A\u0631\u0627\u0645","camera_permission_required":"\u0645\u0637\u0644\u0648\u0628 \u0625\u0630\u0646 \u0644\u0644\u0643\u0627\u0645\u064A\u0631\u0627","access_denied":"\u062A\u0645 \u0631\u0641\u0636 \u0627\u0644\u0648\u0635\u0648\u0644 \u0625\u0644\u0649 \u0627\u0644\u0643\u0627\u0645\u064A\u0631\u0627.","enable_permission":"\u0644\u0645\u0633\u062D \u0631\u0645\u0632 QR\u060C \u064A\u0631\u062C\u0649 \u062A\u0641\u0639\u064A\u0644 \u0625\u0630\u0646 \u0644\u0644\u0643\u0627\u0645\u064A\u0631\u0627 \u0623\u0648 \u0628\u062F\u0644\u0627 \u0645\u0646 \u0630\u0644\u0643 \u0627\u0633\u062A\u062E\u062F\u0645 \u0643\u0627\u0645\u064A\u0631\u0627 \u0627\u0644\u0647\u0627\u062A\u0641 \u0627\u0644\u0645\u062D\u0645\u0648\u0644.","instruction_title":"\u0645\u0627 \u0647\u064A \u0627\u0644\u0639\u0645\u0644\u064A\u0629\u061F","step_1":"\u0627\u0644\u062E\u0637\u0648\u0629 \u0627\u0644\u0623\u0648\u0644\u0649","to_scan":"\u0645\u0633\u062D","step_1_text":"\u0642\u0645 \u0628\u0645\u0633\u062D \u0627\u0644\u0631\u0645\u0632 \u0627\u0644\u0645\u0642\u062F\u0645 \u0645\u0646 \u0645\u0648\u0638\u0641 \u0623\u0648\u063A\u0631\u0627\u0645.","step_2":"\u0627\u0644\u062E\u0637\u0648\u0629 \u0627\u0644\u062B\u0627\u0646\u064A\u0629","check_in_or_out":"\u062A\u0633\u062C\u064A\u0644 \u0627\u0644\u062D\u0636\u0648\u0631 \u0623\u0648 \u0627\u0644\u0645\u063A\u0627\u062F\u0631\u0629","step_2_text":"\u0642\u0645 \u0628\u062A\u0633\u062C\u064A\u0644 \u0627\u0644\u062D\u0636\u0648\u0631 \u0623\u0648 \u0627\u0644\u0645\u063A\u0627\u062F\u0631\u0629\u060C \u0648\u0631\u0624\u064A\u0629 \u062A\u0641\u0627\u0635\u064A\u0644 \u0627\u0644\u0648\u0638\u064A\u0641\u0629.","sp_id_form_title":"\u0625\u0630\u0627 \u0644\u0645 \u064A\u0639\u0645\u0644 \u0631\u0645\u0632 QR\u060C \u064A\u0631\u062C\u0649 \u0625\u062F\u062E\u0627\u0644 \u0631\u0642\u0645 \u0627\u0644\u0647\u0648\u064A\u0629 \u0627\u0644\u062E\u0627\u0635 \u0628\u0645\u0648\u0638\u0641 \u0623\u0648\u063A\u0631\u0627\u0645","sp_id_label":"\u0623\u062F\u062E\u0644 \u0631\u0642\u0645 \u0647\u0648\u064A\u0629 \u0645\u0648\u0638\u0641 \u0623\u0648\u063A\u0631\u0627\u0645","scan_qr":"\u0645\u0633\u062D \u0631\u0645\u0632 QR","sp_cant_be_checked_in_or_out":"\u0644\u0627 \u064A\u0645\u0643\u0646 \u062A\u0633\u062C\u064A\u0644 \u062D\u0636\u0648\u0631/\u0627\u0644\u0645\u063A\u0627\u062F\u0631\u0629 \u0645\u0646 \u0645\u0648\u0638\u0641 \u0623\u0648\u063A\u0631\u0627\u0645 \u0647\u0630\u0627","qr":"QR","scan_next_qr":"\u0645\u0633\u062D \u0631\u0645\u0632 QR \u0622\u062E\u0631","success_modal_text":"\u0644\u0642\u062F \u062A\u0645 \u0625\u0643\u0645\u0627\u0644 \u0639\u0645\u0644\u064A\u0629 {{processTitle}} \u0628\u0646\u062C\u0627\u062D.","carousel_title":"\u062A\u0633\u062C\u064A\u0644 \u062D\u0636\u0648\u0631 \u0648 \u0645\u063A\u0627\u062F\u0631\u0629 \u0627\u0644\u0645\u0648\u0638\u0641\u064A\u0646 \u0628\u0648\u0627\u0633\u0637\u0629 \u0627\u0633\u062A\u062E\u062F\u0627\u0645 \u0631\u0645\u0632 QR","sp_id_form_title_1":"\u0631\u0645\u0632 QR \u0644\u0627 \u064A\u0639\u0645\u0644\u061F","sp_id_form_title_2":"\u0623\u062F\u062E\u0644 \u0631\u0642\u0645 \u0647\u0648\u064A\u0629 \u0645\u0648\u0638\u0641 \u0623\u0648\u063A\u0631\u0627\u0645 \u0623\u062F\u0646\u0627\u0647","camera_missing_title":"\u0643\u0627\u0645\u064A\u0631\u0627 \u0627\u0644\u0648\u064A\u0628 \u0627\u0644\u062E\u0627\u0635\u0629 \u0628\u0643 \u063A\u064A\u0631 \u0645\u062A\u0648\u0627\u0641\u0642\u0629 \u0645\u0639 \u0627\u0644\u0645\u062A\u0635\u0641\u062D \u0627\u0644\u062D\u0627\u0644\u064A.","camera_missing_description":" \u0627\u0644\u0631\u062C\u0627\u0621 \u062A\u062C\u0631\u0628\u0629 \u0643\u0627\u0645\u064A\u0631\u0627 \u0647\u0627\u062A\u0641\u0643 \u0627\u0644\u0645\u062D\u0645\u0648\u0644 \uD83D\uDCF8\uD83D\uDCF1","set_default_time":"\u062A\u0639\u064A\u064A\u0646 \u0627\u0644\u0627\u0641\u062A\u0631\u0627\u0636\u064A"},"staff":{"past_workers":"\u0627\u0644\u0645\u0648\u0638\u0641\u0648\u0646 \u0627\u0644\u0633\u0627\u0628\u0642\u0648\u0646","hours_worked":"\u0633\u0627\u0639\u0627\u062A \u0627\u0644\u0639\u0645\u0644","n_hours":"{{hoursAmount}} \u0633\u0627\u0639\u0629","n_shifts":"{{shiftsAmount}} \u0645\u0646\u0627\u0648\u0628\u0627\u062A","last_job":"\u0623\u062E\u0631 \u0639\u0645\u0644","locations_worked":"\u0623\u0645\u0627\u0643\u0646 \u062A\u0645 \u0627\u0644\u0639\u0645\u0644 \u0641\u064A\u0647\u0627","plus_n_locations":"+ {{locationsAmount}} \u0645\u0648\u0627\u0642\u0639","enter_notes_on_worker":"\u0623\u062F\u062E\u0644 \u0645\u0644\u0627\u062D\u0638\u0627\u062A\u0643 \u0639\u0644\u0649 \u0627\u0644\u0645\u0648\u0638\u0641","favorite_only":"\u0627\u0644\u0645\u0641\u0636\u0644\u0629 \u0641\u0642\u0637","apply":"\u0642\u062F\u0645","reset":"\u0625\u0639\u0627\u062F\u0629","how_was_the_worker":"\u0643\u064A\u0641 \u0643\u0627\u0646 \u0645\u0648\u0638\u0641 \u0623\u0648\u063A\u0631\u0627\u0645\u061F","rating_submitted":"\u062A\u0645 \u0627\u0644\u062A\u0642\u064A\u064A\u0645!","search_worker_by_id_or_name":"\u0627\u0644\u0628\u062D\u062B \u0639\u0646 \u0639\u0627\u0645\u0644 \u062D\u0633\u0628 \u0631\u0642\u0645 \u0627\u0644\u0647\u0648\u064A\u0629 \u0623\u0648 \u0627\u0644\u0623\u0633\u0645","worker_name":"\u0627\u0633\u0645 \u0627\u0644\u0639\u0627\u0645\u0644","designations":"\u0627\u0644\u0645\u0633\u0645\u0649 \u0627\u0644\u0648\u0638\u064A\u0641\u064A","your_rating":"\u062A\u0642\u064A\u064A\u0645\u0643","notes":"\u0645\u0644\u0627\u062D\u0638\u0627\u062A","no_workers_found":"\u0644\u0645 \u064A\u062A\u0645 \u0627\u0644\u0639\u062B\u0648\u0631 \u0639\u0644\u0649 \u0639\u0645\u0627\u0644","note_validation_length":"\u064A\u062C\u0628 \u0623\u0644\u0627 \u064A\u0632\u064A\u062F \u0637\u0648\u0644 \u0627\u0644\u0645\u0644\u0627\u062D\u0638\u0627\u062A \u0639\u0646 499 \u062D\u0631\u0641\u064B\u0627","n_more":"{{ amount }} \u0623\u0643\u062B\u0631","last_designation":"\u0623\u062E\u0631 \u0648\u0638\u064A\u0641\u0629","shifts_worked":"\u0639\u062F\u062F \u0627\u0644\u0645\u0646\u0627\u0648\u0628\u0627\u062A","last_location":"\u0623\u062E\u0631 \u0645\u0643\u0627\u0646"},"invited_sps":{"quantity_must_not_be_greater":"\u0644\u0627 \u064A\u0645\u0643\u0646 \u0627\u0646 \u064A\u0643\u0648\u0646 \u0639\u062F\u062F \u0645\u0648\u0638\u0641\u064A \u0623\u0648\u063A\u0631\u0627\u0645 \u0627\u0644\u0645\u062F\u0639\u0648\u064A\u0646 \u0623\u0643\u0628\u0631 \u0645\u0646 \u0627\u0644\u0639\u062F\u062F \u0627\u0644\u0630\u064A \u0642\u062F \u0637\u0644\u0628.\u0625\u0630\u0627 \u0643\u0646\u062A \u0628\u062D\u0627\u062C\u0629 \u0625\u0644\u0649 \u0627\u0644\u0645\u0632\u064A\u062F \u0645\u0646 \u0639\u0645\u0644\u0627\u0621 \u0623\u0648\u063A\u0631\u0627\u0645\u060C \u0641\u064A\u0631\u062C\u0649 \u0632\u064A\u0627\u062F\u0629 \u0639\u062F\u062F \u0627\u0644\u0645\u0648\u0638\u0641\u064A\u0646 \u0644\u0644\u0648\u0638\u064A\u0641\u0629 \u0641\u064A \u0627\u0644\u062E\u0637\u0648\u0629 \u0627\u0644\u0623\u0648\u0644\u0649","form_title":"\u0647\u0644 \u062A\u0631\u063A\u0628 \u0641\u064A \u062F\u0639\u0648\u0629 \u0645\u0648\u0638\u0641\u064A \u0623\u0648\u063A\u0631\u0627\u0645 \u0627\u0644\u0633\u0627\u0628\u0642\u064A\u0646\u061F","form_subtitle":"\u0647\u0630\u0647 \u0627\u0644\u062E\u0637\u0648\u0629 \u0627\u062E\u062A\u064A\u0627\u0631\u064A\u0629. \u0625\u0630\u0627 \u0642\u0645\u062A \u0628\u062F\u0639\u0648\u0629 \u0639\u062F\u062F \u0623\u0642\u0644 \u0645\u0646 \u0645\u0648\u0638\u0641\u064A \u0623\u0648\u063A\u0631\u0627\u0645 \u0645\u0645\u0627 \u062A\u062D\u062A\u0627\u062C\u0647\u060C \u0641\u0633\u0648\u0641 \u062A\u0642\u0648\u0645 \u0623\u0648\u063A\u0631\u0627\u0645 \u0628\u0634\u063A\u0644 \u0627\u0644\u0648\u0638\u0627\u0626\u0641 \u0627\u0644\u0645\u062A\u0627\u062D\u0629 \u0627\u0644\u0645\u062A\u0628\u0642\u064A\u0629","select_required_data":"\u0627\u0644\u0631\u062C\u0627\u0621 \u062A\u062D\u062F\u064A\u062F \u0627\u0644\u0639\u062F\u062F \u0648 \u0627\u0644\u0645\u0648\u0642\u0639 \u0648 \u0627\u0644\u062C\u062F\u0648\u0644 \u0623\u0648\u0644\u0627\u064B","invited_sps":"\u0645\u0648\u0638\u0641\u064A \u0623\u0648\u063A\u0631\u0627\u0645 \u0627\u0644\u0645\u0641\u0636\u0644\u064A\u0646","worked_at_current_location":"\u0639\u0645\u0644 \u0641\u064A \u0627\u0644\u0645\u0648\u0642\u0639 \u0627\u0644\u062D\u0627\u0644\u064A"},"pagination":{"page":"\u0635\u0641\u062D\u0629","of":"\u0645\u0646"},"rating_popup":{"title":"Please Rate Your Experience with Ogrammers","subtitle_1":"We prioritize the best-rated workers for your future jobs. ","subtitle_2":"Your ratings help us prioritize top performers, ensuring you get the best service every time","ogs_to_rate":"OGs to Rate","will_be_prioritized":"This OG will be prioritized for you","will_not_be_assigned":"This OG won\u2019t be assigned again."},"disputes":{"overtime":"Overtime","no_show":"No-show","og_attendance":"OG attendance","check_in":"Check In","check_out":"Check Out","total_hours":"Total Hours","n_hours":"{{ count }} hours","your_attendance":"Your attendance","og_claims_n_hours_more":"OG claims they worked {{ count }} hours more","og_claims_show_up":"You cancelled the shift, but OG claims they did work","og_comment":"\u062A\u0639\u0644\u064A\u0642 OG","view_attached_file":"\u0639\u0631\u0636 \u0627\u0644\u0645\u0644\u0641 \u0627\u0644\u0645\u0631\u0641\u0642","are_you_sure_to_agree":"Are you sure you want to agree with the OG?","dispute_resolved":"Dispute resolved successfully","i_agree":"I agree with the OG","are_you_sure_to_decline":"Are you sure you want to decline the OG dispute?","dispute_declined":"Dispute declined successfully","i_dont_agree":"I don\'t agree"}}');



(0, $673ff3dfc4a496de$export$2e2bcd8739ae039).use((0, $60196a4650e96cb1$export$2e2bcd8739ae039)).use((0, $26bfda595e5aa141$export$ae7e14d40d89f296)).init({
    resources: {
        en: {
            translation: (0, (/*@__PURE__*/$parcel$interopDefault($0c3ba772772ffc54$exports)))
        },
        el: {
            translation: (0, (/*@__PURE__*/$parcel$interopDefault($92ad81250484a30b$exports)))
        },
        ar: {
            translation: (0, (/*@__PURE__*/$parcel$interopDefault($2ffde788e1a5e27e$exports)))
        }
    },
    interpolation: {
        escapeValue: false
    },
    fallbackLng: "en",
    supportedLngs: [
        "en",
        "el",
        "ar"
    ],
    load: "languageOnly"
});
(0, $34dcbefa7de5eb80$export$a1544dad697b423d)("userLanguage", (0, $673ff3dfc4a496de$export$2e2bcd8739ae039).language);
const { t: $2b1f0855f2f3a952$export$625550452a3fa3ec } = (0, $673ff3dfc4a496de$export$2e2bcd8739ae039);


const $9ea0b9c28eae13fc$export$edb889f0799652d1 = $cd7706ce94a8dfd1$export$185802fd694ee1f5().shape({
    email: $bcc252d93ab3046c$export$185802fd694ee1f5().email((0, $2b1f0855f2f3a952$export$625550452a3fa3ec)("validation_messages.email_invalid")).required((0, $2b1f0855f2f3a952$export$625550452a3fa3ec)("login.enter_email")),
    password: $bcc252d93ab3046c$export$185802fd694ee1f5().required((0, $2b1f0855f2f3a952$export$625550452a3fa3ec)("login.enter_password"))
});


function $a5511b7baaaa1d7d$export$fdaf0fa3d19f8eed(UIComponent) {
    return (0, $aca50e9407ba89c9$export$b6ae1bc530f4c149)(({ onLogin: onLogin })=>{
        const firebaseToken = (0, $7af34371d75563b6$export$5a8e049606f4bc34)();
        const store = (0, $4671947198ddd366$export$6ccbb43953eebf8)();
        const [loginResult, login] = (0, $4671947198ddd366$export$609860bf8b0084c)(store.data.login, {
            onSuccess: (account)=>{
                (0, $c74a0566d4b0fd6d$export$e9db7d6e73593439).identifyUser(Number(account.user_id));
                (0, $c74a0566d4b0fd6d$export$e9db7d6e73593439).assignUserProperties(account.id, account.roles, account.email);
                onLogin?.();
            },
            filterError: [
                (0, $9ad33fbf770c55a1$export$9696fcf1798e1cb5).ClientError
            ]
        });
        const remoteErrors = loginResult.error?.data.errors;
        const submitting = loginResult.isLoading;
        return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7YFi7.Formik), {
            initialValues: {
                email: "",
                password: "",
                remember_me: true
            },
            onSubmit: (values)=>{
                login({
                    ...values,
                    device_id: (0, $32ef62acd40089c4$export$1da4558c59cbf0b1)(),
                    firebase_token: firebaseToken
                });
            },
            validationSchema: (0, $9ea0b9c28eae13fc$export$edb889f0799652d1),
            children: ({ values: values, errors: errors, setFieldValue: setFieldValue, handleSubmit: handleSubmit })=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)(UIComponent, {
                    submitting: submitting,
                    email: values.email,
                    emailErrors: errors.email ?? remoteErrors?.email,
                    password: values.password,
                    passwordErrors: errors.password ?? remoteErrors?.password,
                    handlEmailChange: (email)=>{
                        setFieldValue("email", email);
                    },
                    handlPasswordChange: (password)=>{
                        setFieldValue("password", password);
                    },
                    handleLoginButtonPress: ()=>{
                        handleSubmit();
                        (0, $c74a0566d4b0fd6d$export$e9db7d6e73593439).conversion((0, $c74a0566d4b0fd6d$export$4690203fd259f070).SignInClicked);
                    },
                    handleSignUpLinkPress: ()=>{
                        (0, $c74a0566d4b0fd6d$export$e9db7d6e73593439).conversion((0, $c74a0566d4b0fd6d$export$4690203fd259f070).SignUpClicked);
                    }
                })
        });
    });
}








var $acw62 = parcelRequire("acw62");


function $4c4587947033fde9$export$a455218a85c89869(props) {
    const children = /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
        children: [
            props.children,
            props.rightPos && props.label,
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "Field__description",
                children: props.description
            }),
            props.errors && props.errors.length > 0 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "Field__errors",
                children: props.errors.map((err, i)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "Field__error",
                        children: err
                    }, i))
            })
        ]
    });
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        className: "Field",
        children: props.label ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
            children: children
        }) : children
    });
}



function $4e342c5928158118$var$getDirectionByInputType(type) {
    switch(type){
        case "email":
        case "number":
        case "tel":
        case "url":
            return "ltr";
        default:
            return "undefined" // will by set by css instead
            ;
    }
}
function $4e342c5928158118$export$f5b8910cec6cf069(props) {
    const { label: label, multiline: multiline, image: image, handleChange: handleChange, ...rest } = props;
    const ref = /*#__PURE__*/ (0, $acw62.createRef)();
    const [focused, setFocused] = (0, $acw62.useState)(false);
    const Tag = props.multiline ? "textarea" : "input";
    const hasLabel = label !== undefined;
    const hasValue = props.value !== undefined && props.value !== "";
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: `Input ${rest.className ?? ""}`,
        dir: $4e342c5928158118$var$getDirectionByInputType(props.type),
        children: [
            hasLabel && (focused || hasValue) ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "Input__labelContainer",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                    className: "Input__labelContainer__label",
                    children: label
                })
            }) : null,
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)(Tag, {
                ...rest,
                placeholder: focused ? "" : label,
                ref: ref,
                className: `Input__input ${focused || hasValue ? "active" : ""}`,
                type: props.type,
                // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
                value: props.value ?? "",
                onChange: (e)=>handleChange?.(e.target.value),
                onFocus: (e)=>{
                    setFocused(true);
                    rest.onFocus?.(e);
                },
                onBlur: (e)=>{
                    setFocused(false);
                    rest.onBlur?.(e);
                }
            }),
            image && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "Input__imgContainer",
                children: image
            })
        ]
    });
}
function $4e342c5928158118$export$dd2171e2b7d3bc5b(props) {
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4c4587947033fde9$export$a455218a85c89869), {
        description: props.description,
        required: props.required,
        errors: props.errors ?? props.field?.errors,
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($4e342c5928158118$export$f5b8910cec6cf069, {
            ...props,
            value: props.value ?? props.field?.value ?? "",
            handleChange: (value)=>{
                if (props.field) props.field.setData(value);
                else props.handleChange?.(value);
            }
        })
    });
}




var $acw62 = parcelRequire("acw62");


var $2f83714863fb7e41$exports = {};
$2f83714863fb7e41$exports = new URL("opened-eye.85d73370.png", import.meta.url).toString();


var $ac7a1b4663748f6b$exports = {};
$ac7a1b4663748f6b$exports = new URL("closed-eye.36585058.png", import.meta.url).toString();


var $35795701fc918885$exports = {};
$35795701fc918885$exports = new URL("checkmark.d57b3eea.svg", import.meta.url).toString();



const $621096805b6f645e$export$b28585a458fee016 = ({ showHints: showHints = false, hidePasswordByDefault: hidePasswordByDefault = false, ...props })=>{
    const [passwordVisible, setPasswordVisible] = (0, $acw62.useState)(!hidePasswordByDefault);
    const { t: t } = (0, $3765cebd031b52c0$export$9fc83ad70ead8663)();
    const passwordValue = props.value ?? "";
    const has6Chars = passwordValue.length >= 6;
    const hasLowercase = passwordValue.toUpperCase() !== passwordValue;
    const hasUppercase = passwordValue.toLowerCase() !== passwordValue;
    const hasNumber = /\d/.test(passwordValue);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "PasswordInput",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4e342c5928158118$export$f5b8910cec6cf069), {
                type: passwordVisible ? "text" : "password",
                image: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                    onClick: ()=>{
                        setPasswordVisible((prev)=>!prev);
                    },
                    src: passwordVisible ? (0, (/*@__PURE__*/$parcel$interopDefault($ac7a1b4663748f6b$exports))) : (0, (/*@__PURE__*/$parcel$interopDefault($2f83714863fb7e41$exports))),
                    className: "PasswordInput__img"
                }),
                ...props
            }),
            showHints && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "PasswordInput__hints",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: `PasswordInput__hints__item ${has6Chars ? "active" : ""}`,
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                                src: (0, (/*@__PURE__*/$parcel$interopDefault($35795701fc918885$exports))),
                                className: `PasswordInput__hints__item__checkmark ${has6Chars ? "visible" : ""}`
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                className: `PasswordInput__hints__item__label ${has6Chars ? "active" : ""}`,
                                children: t("password.minimumChars")
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: `PasswordInput__hints__item ${hasLowercase ? "active" : ""}`,
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                                src: (0, (/*@__PURE__*/$parcel$interopDefault($35795701fc918885$exports))),
                                className: `PasswordInput__hints__item__checkmark ${hasLowercase ? "visible" : ""}`
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                className: `PasswordInput__hints__item__label ${hasLowercase ? "active" : ""}`,
                                children: t("password.oneLowercase")
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: `PasswordInput__hints__item ${hasNumber ? "active" : ""}`,
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                                src: (0, (/*@__PURE__*/$parcel$interopDefault($35795701fc918885$exports))),
                                className: `PasswordInput__hints__item__checkmark ${hasNumber ? "visible" : ""}`
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                className: `PasswordInput__hints__item__label ${hasNumber ? "active" : ""}`,
                                children: t("password.oneNumber")
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: `PasswordInput__hints__item ${hasUppercase ? "active" : ""}`,
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                                src: (0, (/*@__PURE__*/$parcel$interopDefault($35795701fc918885$exports))),
                                className: `PasswordInput__hints__item__checkmark ${hasUppercase ? "visible" : ""}`
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                className: `PasswordInput__hints__item__label ${hasUppercase ? "active" : ""}`,
                                children: t("password.oneUppercase")
                            })
                        ]
                    })
                ]
            })
        ]
    });
};








var $e56c86bed33f8664$exports = {};
$e56c86bed33f8664$exports = new URL("angle-down.cff97579.svg", import.meta.url).toString();





const $4d6ef32c8371c7fc$export$a06f1c675e846f6f = (0, $aca50e9407ba89c9$export$b6ae1bc530f4c149)(()=>{
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        className: "Footer",
        children: "Footer"
    });
});






var $acw62 = parcelRequire("acw62");



var $acw62 = parcelRequire("acw62");














const $2ab88429e3384d30$export$353f5b6fc5456de1 = ({ title: title, type: type, onClick: onClick, className: className, disabled: disabled, children: children, style: style })=>{
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
        disabled: disabled,
        type: type,
        onClick: onClick,
        className: `Button ${className ?? ""} ${disabled ? "disabled" : ""}`,
        style: style,
        children: children ?? title
    });
};


var $6e1e3042c507f114$exports = {};
$6e1e3042c507f114$exports = new URL("new-order.5eb9ede8.svg", import.meta.url).toString();



const $4349266f95d58365$export$32030c589b013e3c = (0, $aca50e9407ba89c9$export$b6ae1bc530f4c149)(()=>{
    const redirect = (0, $7df35e9df335b1c8$export$602eaf6d5314ce55)();
    const { t: t } = (0, $3765cebd031b52c0$export$9fc83ad70ead8663)();
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $2ab88429e3384d30$export$353f5b6fc5456de1), {
        onClick: ()=>{
            redirect((0, $0534349ae8731d0b$export$66b32f6f30eb4b4).setJobCategory, {});
        },
        className: "OrderButton",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                src: (0, (/*@__PURE__*/$parcel$interopDefault($6e1e3042c507f114$exports))),
                alt: ""
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $660b2ca422e0e2ae$export$1ff3c3f08ae963c0).Horizontal, {
                width: 15
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                className: "OrderButton__title",
                children: t("sidebar.create_order")
            })
        ]
    });
});




var $acw62 = parcelRequire("acw62");










const $bb163e67e22b912e$export$81c00e56345baf4c = ()=>{
    const { t: t } = (0, $3765cebd031b52c0$export$9fc83ad70ead8663)();
    const handleButtonClick = ()=>{
        window.history.back();
    };
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "FallbackUI",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                className: "FallbackUI__title",
                children: t("permission_error.title")
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $660b2ca422e0e2ae$export$1ff3c3f08ae963c0).Spacer, {
                flex: 0.1
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $2ab88429e3384d30$export$353f5b6fc5456de1), {
                title: t("page_not_found.go_back"),
                onClick: handleButtonClick
            })
        ]
    });
};


const $4ae5ab5371178941$export$f01b3d7c7bbe3997 = (0, $aca50e9407ba89c9$export$b6ae1bc530f4c149)(({ allowedRoles: allowedRoles, children: children, showDefaultFallbackUI: showDefaultFallbackUI = true, FallbackComponent: FallbackComponent })=>{
    const { account: account } = (0, $4671947198ddd366$export$6ccbb43953eebf8)().data;
    const userRoles = account?.roles ?? [];
    const rolesIntersectionArray = userRoles.filter((userRole)=>allowedRoles.includes(userRole));
    const routeIsAllowed = rolesIntersectionArray.length > 0;
    if (userRoles.length === 0 || routeIsAllowed) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7b02d682eb115277$exports.Fragment), {
        children: children
    });
    if (FallbackComponent) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)(FallbackComponent, {});
    if (showDefaultFallbackUI) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $bb163e67e22b912e$export$81c00e56345baf4c), {});
    return null;
});




var $acw62 = parcelRequire("acw62");



const $80f2c11fb41d1456$export$a6c7ac8248d6e38a = ({ title: title, route: route, imageSource: imageSource, params: params, children: children })=>{
    const { url: { path: path } } = (0, $acw62.useContext)((0, $7df35e9df335b1c8$export$e21aa10ba666c75b));
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("li", {
        className: "LinkItem",
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7df35e9df335b1c8$export$a6c7ac8248d6e38a), {
            route: route,
            params: params,
            className: `LinkItem__link ${path === route.path && "active"}`,
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                    src: imageSource,
                    alt: ""
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $660b2ca422e0e2ae$export$1ff3c3f08ae963c0).Horizontal, {
                    width: 16
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                    className: path === route.path ? "active" : "",
                    children: title
                }),
                children
            ]
        })
    });
};


var $3719a9587f337adb$exports = {};
$3719a9587f337adb$exports = new URL("dropdown-arrow-outlined.dc7a0f84.svg", import.meta.url).toString();



const $b811929e1c110dae$export$49229ebf838c159b = ({ items: items, sectionTitle: sectionTitle })=>{
    const [active, setActive] = (0, $acw62.useState)(true);
    const { t: t } = (0, $3765cebd031b52c0$export$9fc83ad70ead8663)();
    const toggleState = ()=>{
        setActive((value)=>!value);
    };
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "Submenu",
        children: [
            Boolean(sectionTitle) && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                onClick: toggleState,
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "Submenu__horizontal-separator"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $660b2ca422e0e2ae$export$1ff3c3f08ae963c0).Vertical, {
                        height: 25
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "Submenu__row Submenu__list-header",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                children: t(sectionTitle)
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                                src: (0, (/*@__PURE__*/$parcel$interopDefault($3719a9587f337adb$exports))),
                                alt: ""
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $660b2ca422e0e2ae$export$1ff3c3f08ae963c0).Vertical, {
                        height: 15
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("ul", {
                className: `Submenu__list ${active ? "active" : ""}`,
                children: [
                    items.map((item, i)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4ae5ab5371178941$export$f01b3d7c7bbe3997), {
                            allowedRoles: item.allowedRoles,
                            showDefaultFallbackUI: false,
                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $80f2c11fb41d1456$export$a6c7ac8248d6e38a), {
                                title: t(item.title),
                                route: item.route,
                                imageSource: item.imgSource,
                                params: item.params ?? {},
                                children: Number(item.counter) > 0 ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                    className: "Submenu__counter",
                                    children: Number(item.counter) > 99 ? "99+" : Number(item.counter)
                                }) : null
                            })
                        }, i)),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $660b2ca422e0e2ae$export$1ff3c3f08ae963c0).Vertical, {
                        height: 16
                    })
                ]
            })
        ]
    });
};




var $acw62 = parcelRequire("acw62");





var $7b48f5a7f435f1a5$exports = {};
$7b48f5a7f435f1a5$exports = new URL("dropdown-arrow.5ae70663.svg", import.meta.url).toString();



const $404cf9ad665a992a$export$e21e2be31f67ad59 = (0, $aca50e9407ba89c9$export$b6ae1bc530f4c149)(()=>{
    const [dropdownVisible, setDropdownVisible] = (0, $acw62.useState)(false);
    const { account: account, switchProfile: switchProfile } = (0, $4671947198ddd366$export$6ccbb43953eebf8)().data;
    const [switchProfileResult, requestSwitchProfile] = (0, $4671947198ddd366$export$609860bf8b0084c)(switchProfile, {
        filterError: [
            (0, $9ad33fbf770c55a1$export$9696fcf1798e1cb5).ClientError,
            (0, $9ad33fbf770c55a1$export$9696fcf1798e1cb5).NotFound
        ],
        onError: (err)=>alert(err.data.message)
    });
    const { t: t } = (0, $3765cebd031b52c0$export$9fc83ad70ead8663)();
    if (!account) return null;
    const [listProfiles, currentProfile] = account.profiles.reduce((acc, item)=>{
        if (item.id === account.id) acc[1] = item;
        else acc[0].push(item);
        return acc;
    }, [
        [],
        account.profiles[0]
    ]);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "CompanyName",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $660b2ca422e0e2ae$export$1ff3c3f08ae963c0).Vertical, {
                height: 21
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                onClick: ()=>{
                    if (listProfiles.length < 1) return;
                    setDropdownVisible((prevState)=>!prevState);
                },
                className: `CompanyName__row ${listProfiles.length >= 1 ? "clickable" : ""}`,
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "CompanyName__column",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                className: "CompanyName__row__label",
                                children: t("sidebar.company")
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                className: "CompanyName__row__company-name",
                                children: switchProfileResult.isLoading ? "loading..." : currentProfile.company_name
                            })
                        ]
                    }),
                    listProfiles.length >= 1 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                        src: (0, (/*@__PURE__*/$parcel$interopDefault($7b48f5a7f435f1a5$exports))),
                        alt: "",
                        className: `CompanyName__row__img ${dropdownVisible ? "turned" : ""}`
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: `CompanyName__dropdown ${dropdownVisible ? "" : "collapsed"}`,
                children: listProfiles.map((profile)=>{
                    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        onClick: ()=>{
                            requestSwitchProfile(profile.id);
                            setDropdownVisible(false);
                        },
                        className: "CompanyName__dropdown__item",
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                            className: "CompanyName__dropdown__item__label",
                            children: profile.company_name
                        })
                    }, profile.id);
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $660b2ca422e0e2ae$export$1ff3c3f08ae963c0).Vertical, {
                height: 11
            })
        ]
    });
});





var $acw62 = parcelRequire("acw62");

var $i56po = parcelRequire("i56po");


var $i56po = parcelRequire("i56po");


var $i56po = parcelRequire("i56po");

var $4f362 = parcelRequire("4f362");

var $45fvw = parcelRequire("45fvw");
var $3c5155092adf0860$exports = {};

!function(t, e) {
    $3c5155092adf0860$exports = e((parcelRequire("45fvw")));
}($3c5155092adf0860$exports, function(t) {
    return function(t) {
        function e(r) {
            if (n[r]) return n[r].exports;
            var o = n[r] = {
                i: r,
                l: !1,
                exports: {}
            };
            return t[r].call(o.exports, o, o.exports, e), o.l = !0, o.exports;
        }
        var n = {};
        return e.m = t, e.c = n, e.i = function(t) {
            return t;
        }, e.d = function(t, n, r) {
            e.o(t, n) || Object.defineProperty(t, n, {
                configurable: !1,
                enumerable: !0,
                get: r
            });
        }, e.n = function(t) {
            var n = t && t.__esModule ? function() {
                return t.default;
            } : function() {
                return t;
            };
            return e.d(n, "a", n), n;
        }, e.o = function(t, e) {
            return Object.prototype.hasOwnProperty.call(t, e);
        }, e.p = "", e(e.s = 3);
    }([
        function(t, e, n) {
            "use strict";
            var r = n(5)();
            t.exports = function(t) {
                return t !== r && null !== t;
            };
        },
        function(t, e, n) {
            "use strict";
            t.exports = n(18)() ? Symbol : n(20);
        },
        function(e, n) {
            e.exports = t;
        },
        function(t, e, n) {
            "use strict";
            function r(t) {
                return t && t.__esModule ? t : {
                    default: t
                };
            }
            function o(t, e, n) {
                return e in t ? Object.defineProperty(t, e, {
                    value: n,
                    enumerable: !0,
                    configurable: !0,
                    writable: !0
                }) : t[e] = n, t;
            }
            function i(t, e) {
                if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
            }
            function u(t) {
                return t.range = function(e, n) {
                    var r = this;
                    return "string" == typeof e && y.hasOwnProperty(e) ? new h(t(r).startOf(e), t(r).endOf(e)) : new h(e, n);
                }, t.rangeFromInterval = function(e) {
                    var n = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 1, r = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : t();
                    if (t.isMoment(r) || (r = t(r)), !r.isValid()) throw new Error("Invalid date.");
                    var o = r.clone().add(n, e), i = [];
                    return i.push(t.min(r, o)), i.push(t.max(r, o)), new h(i);
                }, t.rangeFromISOString = function(e) {
                    var n = a(e), r = t.parseZone(n[0]), o = t.parseZone(n[1]);
                    return new h(r, o);
                }, t.parseZoneRange = t.rangeFromISOString, t.fn.range = t.range, t.range.constructor = h, t.isRange = function(t) {
                    return t instanceof h;
                }, t.fn.within = function(t) {
                    return t.contains(this.toDate());
                }, t;
            }
            function a(t) {
                return t.split("/");
            }
            Object.defineProperty(e, "__esModule", {
                value: !0
            }), e.DateRange = void 0;
            var s = function() {
                function t(t, e) {
                    var n = [], r = !0, o = !1, i = void 0;
                    try {
                        for(var u, a = t[Symbol.iterator](); !(r = (u = a.next()).done) && (n.push(u.value), !e || n.length !== e); r = !0);
                    } catch (t) {
                        o = !0, i = t;
                    } finally{
                        try {
                            !r && a.return && a.return();
                        } finally{
                            if (o) throw i;
                        }
                    }
                    return n;
                }
                return function(e, n) {
                    if (Array.isArray(e)) return e;
                    if (Symbol.iterator in Object(e)) return t(e, n);
                    throw new TypeError("Invalid attempt to destructure non-iterable instance");
                };
            }(), c = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(t) {
                return typeof t;
            } : function(t) {
                return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
            }, f = function() {
                function t(t, e) {
                    for(var n = 0; n < e.length; n++){
                        var r = e[n];
                        r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(t, r.key, r);
                    }
                }
                return function(e, n, r) {
                    return n && t(e.prototype, n), r && t(e, r), e;
                };
            }();
            e.extendMoment = u;
            var l = n(2), v = r(l), d = n(1), p = r(d), y = {
                year: !0,
                quarter: !0,
                month: !0,
                week: !0,
                day: !0,
                hour: !0,
                minute: !0,
                second: !0
            }, h = e.DateRange = function() {
                function t(e, n) {
                    i(this, t);
                    var r = e, o = n;
                    if (1 === arguments.length || void 0 === n) {
                        if ("object" === (void 0 === e ? "undefined" : c(e)) && 2 === e.length) {
                            var u = s(e, 2);
                            r = u[0], o = u[1];
                        } else if ("string" == typeof e) {
                            var f = a(e), l = s(f, 2);
                            r = l[0], o = l[1];
                        }
                    }
                    this.start = r || 0 === r ? (0, v.default)(r) : (0, v.default)(-8640000000000000), this.end = o || 0 === o ? (0, v.default)(o) : (0, v.default)(864e13);
                }
                return f(t, [
                    {
                        key: "adjacent",
                        value: function(t) {
                            var e = this.start.isSame(t.end), n = this.end.isSame(t.start);
                            return e && t.start.valueOf() <= this.start.valueOf() || n && t.end.valueOf() >= this.end.valueOf();
                        }
                    },
                    {
                        key: "add",
                        value: function(t) {
                            var e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {
                                adjacent: !1
                            };
                            return this.overlaps(t, e) ? new this.constructor(v.default.min(this.start, t.start), v.default.max(this.end, t.end)) : null;
                        }
                    },
                    {
                        key: "by",
                        value: function(t) {
                            var e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {
                                excludeEnd: !1,
                                step: 1
                            }, n = this;
                            return o({}, p.default.iterator, function() {
                                var r = e.step || 1, o = Math.abs(n.start.diff(n.end, t)) / r, i = e.excludeEnd || !1, u = 0;
                                return e.hasOwnProperty("exclusive") && (i = e.exclusive), {
                                    next: function() {
                                        var e = n.start.clone().add(u * r, t), a = i ? !(u < o) : !(u <= o);
                                        return u++, {
                                            done: a,
                                            value: a ? void 0 : e
                                        };
                                    }
                                };
                            });
                        }
                    },
                    {
                        key: "byRange",
                        value: function(t) {
                            var e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {
                                excludeEnd: !1,
                                step: 1
                            }, n = this, r = e.step || 1, i = this.valueOf() / t.valueOf() / r, u = Math.floor(i), a = e.excludeEnd || !1, s = 0;
                            return e.hasOwnProperty("exclusive") && (a = e.exclusive), o({}, p.default.iterator, function() {
                                return u === 1 / 0 ? {
                                    done: !0
                                } : {
                                    next: function() {
                                        var e = (0, v.default)(n.start.valueOf() + t.valueOf() * s * r), o = u === i && a ? !(s < u) : !(s <= u);
                                        return s++, {
                                            done: o,
                                            value: o ? void 0 : e
                                        };
                                    }
                                };
                            });
                        }
                    },
                    {
                        key: "center",
                        value: function() {
                            var t = this.start.valueOf() + this.diff() / 2;
                            return (0, v.default)(t);
                        }
                    },
                    {
                        key: "clone",
                        value: function() {
                            return new this.constructor(this.start.clone(), this.end.clone());
                        }
                    },
                    {
                        key: "contains",
                        value: function(e) {
                            var n = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {
                                excludeStart: !1,
                                excludeEnd: !1
                            }, r = this.start.valueOf(), o = this.end.valueOf(), i = e.valueOf(), u = e.valueOf(), a = n.excludeStart || !1, s = n.excludeEnd || !1;
                            n.hasOwnProperty("exclusive") && (a = s = n.exclusive), e instanceof t && (i = e.start.valueOf(), u = e.end.valueOf());
                            var c = r < i || r <= i && !a, f = o > u || o >= u && !s;
                            return c && f;
                        }
                    },
                    {
                        key: "diff",
                        value: function(t, e) {
                            return this.end.diff(this.start, t, e);
                        }
                    },
                    {
                        key: "duration",
                        value: function(t, e) {
                            return this.diff(t, e);
                        }
                    },
                    {
                        key: "intersect",
                        value: function(t) {
                            var e = this.start.valueOf(), n = this.end.valueOf(), r = t.start.valueOf(), o = t.end.valueOf(), i = e == n, u = r == o;
                            if (i) {
                                var a = e;
                                if (a == r || a == o) return null;
                                if (a > r && a < o) return this.clone();
                            } else if (u) {
                                var s = r;
                                if (s == e || s == n) return null;
                                if (s > e && s < n) return new this.constructor(s, s);
                            }
                            return e <= r && r < n && n < o ? new this.constructor(r, n) : r < e && e < o && o <= n ? new this.constructor(e, o) : r < e && e <= n && n < o ? this.clone() : e <= r && r <= o && o <= n ? new this.constructor(r, o) : null;
                        }
                    },
                    {
                        key: "isEqual",
                        value: function(t) {
                            return this.start.isSame(t.start) && this.end.isSame(t.end);
                        }
                    },
                    {
                        key: "isSame",
                        value: function(t) {
                            return this.isEqual(t);
                        }
                    },
                    {
                        key: "overlaps",
                        value: function(t) {
                            var e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {
                                adjacent: !1
                            }, n = null !== this.intersect(t);
                            return e.adjacent && !n ? this.adjacent(t) : n;
                        }
                    },
                    {
                        key: "reverseBy",
                        value: function(t) {
                            var e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {
                                excludeStart: !1,
                                step: 1
                            }, n = this;
                            return o({}, p.default.iterator, function() {
                                var r = e.step || 1, o = Math.abs(n.start.diff(n.end, t)) / r, i = e.excludeStart || !1, u = 0;
                                return e.hasOwnProperty("exclusive") && (i = e.exclusive), {
                                    next: function() {
                                        var e = n.end.clone().subtract(u * r, t), a = i ? !(u < o) : !(u <= o);
                                        return u++, {
                                            done: a,
                                            value: a ? void 0 : e
                                        };
                                    }
                                };
                            });
                        }
                    },
                    {
                        key: "reverseByRange",
                        value: function(t) {
                            var e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {
                                excludeStart: !1,
                                step: 1
                            }, n = this, r = e.step || 1, i = this.valueOf() / t.valueOf() / r, u = Math.floor(i), a = e.excludeStart || !1, s = 0;
                            return e.hasOwnProperty("exclusive") && (a = e.exclusive), o({}, p.default.iterator, function() {
                                return u === 1 / 0 ? {
                                    done: !0
                                } : {
                                    next: function() {
                                        var e = (0, v.default)(n.end.valueOf() - t.valueOf() * s * r), o = u === i && a ? !(s < u) : !(s <= u);
                                        return s++, {
                                            done: o,
                                            value: o ? void 0 : e
                                        };
                                    }
                                };
                            });
                        }
                    },
                    {
                        key: "snapTo",
                        value: function(t) {
                            var e = this.clone();
                            return e.start.isSame((0, v.default)(-8640000000000000)) || (e.start = e.start.startOf(t)), e.end.isSame((0, v.default)(864e13)) || (e.end = e.end.endOf(t)), e;
                        }
                    },
                    {
                        key: "subtract",
                        value: function(t) {
                            var e = this.start.valueOf(), n = this.end.valueOf(), r = t.start.valueOf(), o = t.end.valueOf();
                            return null === this.intersect(t) ? [
                                this
                            ] : r <= e && e < n && n <= o ? [] : r <= e && e < o && o < n ? [
                                new this.constructor(o, n)
                            ] : e < r && r < n && n <= o ? [
                                new this.constructor(e, r)
                            ] : e < r && r < o && o < n ? [
                                new this.constructor(e, r),
                                new this.constructor(o, n)
                            ] : e < r && r < n && o < n ? [
                                new this.constructor(e, r),
                                new this.constructor(r, n)
                            ] : [];
                        }
                    },
                    {
                        key: "toDate",
                        value: function() {
                            return [
                                this.start.toDate(),
                                this.end.toDate()
                            ];
                        }
                    },
                    {
                        key: "toString",
                        value: function() {
                            return this.start.format() + "/" + this.end.format();
                        }
                    },
                    {
                        key: "valueOf",
                        value: function() {
                            return this.end.valueOf() - this.start.valueOf();
                        }
                    }
                ]), t;
            }();
        },
        function(t, e, n) {
            "use strict";
            var r, o = n(6), i = n(13), u = n(9), a = n(15);
            r = t.exports = function(t, e) {
                var n, r, u, s, c;
                return arguments.length < 2 || "string" != typeof t ? (s = e, e = t, t = null) : s = arguments[2], null == t ? (n = u = !0, r = !1) : (n = a.call(t, "c"), r = a.call(t, "e"), u = a.call(t, "w")), c = {
                    value: e,
                    configurable: n,
                    enumerable: r,
                    writable: u
                }, s ? o(i(s), c) : c;
            }, r.gs = function(t, e, n) {
                var r, s, c, f;
                return "string" != typeof t ? (c = n, n = e, e = t, t = null) : c = arguments[3], null == e ? e = void 0 : u(e) ? null == n ? n = void 0 : u(n) || (c = n, n = void 0) : (c = e, e = n = void 0), null == t ? (r = !0, s = !1) : (r = a.call(t, "c"), s = a.call(t, "e")), f = {
                    get: e,
                    set: n,
                    configurable: r,
                    enumerable: s
                }, c ? o(i(c), f) : f;
            };
        },
        function(t, e, n) {
            "use strict";
            t.exports = function() {};
        },
        function(t, e, n) {
            "use strict";
            t.exports = n(7)() ? Object.assign : n(8);
        },
        function(t, e, n) {
            "use strict";
            t.exports = function() {
                var t, e = Object.assign;
                return "function" == typeof e && (t = {
                    foo: "raz"
                }, e(t, {
                    bar: "dwa"
                }, {
                    trzy: "trzy"
                }), t.foo + t.bar + t.trzy === "razdwatrzy");
            };
        },
        function(t, e, n) {
            "use strict";
            var r = n(10), o = n(14), i = Math.max;
            t.exports = function(t, e) {
                var n, u, a, s = i(arguments.length, 2);
                for(t = Object(o(t)), a = function(r) {
                    try {
                        t[r] = e[r];
                    } catch (t) {
                        n || (n = t);
                    }
                }, u = 1; u < s; ++u)e = arguments[u], r(e).forEach(a);
                if (void 0 !== n) throw n;
                return t;
            };
        },
        function(t, e, n) {
            "use strict";
            t.exports = function(t) {
                return "function" == typeof t;
            };
        },
        function(t, e, n) {
            "use strict";
            t.exports = n(11)() ? Object.keys : n(12);
        },
        function(t, e, n) {
            "use strict";
            t.exports = function() {
                try {
                    return Object.keys("primitive"), !0;
                } catch (t) {
                    return !1;
                }
            };
        },
        function(t, e, n) {
            "use strict";
            var r = n(0), o = Object.keys;
            t.exports = function(t) {
                return o(r(t) ? Object(t) : t);
            };
        },
        function(t, e, n) {
            "use strict";
            var r = n(0), o = Array.prototype.forEach, i = Object.create, u = function(t, e) {
                var n;
                for(n in t)e[n] = t[n];
            };
            t.exports = function(t) {
                var e = i(null);
                return o.call(arguments, function(t) {
                    r(t) && u(Object(t), e);
                }), e;
            };
        },
        function(t, e, n) {
            "use strict";
            var r = n(0);
            t.exports = function(t) {
                if (!r(t)) throw new TypeError("Cannot use null or undefined");
                return t;
            };
        },
        function(t, e, n) {
            "use strict";
            t.exports = n(16)() ? String.prototype.contains : n(17);
        },
        function(t, e, n) {
            "use strict";
            var r = "razdwatrzy";
            t.exports = function() {
                return "function" == typeof r.contains && !0 === r.contains("dwa") && !1 === r.contains("foo");
            };
        },
        function(t, e, n) {
            "use strict";
            var r = String.prototype.indexOf;
            t.exports = function(t) {
                return r.call(this, t, arguments[1]) > -1;
            };
        },
        function(t, e, n) {
            "use strict";
            var r = {
                object: !0,
                symbol: !0
            };
            t.exports = function() {
                var t;
                if ("function" != typeof Symbol) return !1;
                t = Symbol("test symbol");
                try {
                    String(t);
                } catch (t) {
                    return !1;
                }
                return !!r[typeof Symbol.iterator] && !!r[typeof Symbol.toPrimitive] && !!r[typeof Symbol.toStringTag];
            };
        },
        function(t, e, n) {
            "use strict";
            t.exports = function(t) {
                return !!t && ("symbol" == typeof t || !!t.constructor && "Symbol" === t.constructor.name && "Symbol" === t[t.constructor.toStringTag]);
            };
        },
        function(t, e, n) {
            "use strict";
            var r, o, i, u, a = n(4), s = n(21), c = Object.create, f = Object.defineProperties, l = Object.defineProperty, v = Object.prototype, d = c(null);
            if ("function" == typeof Symbol) {
                r = Symbol;
                try {
                    String(r()), u = !0;
                } catch (t) {}
            }
            var p = function() {
                var t = c(null);
                return function(e) {
                    for(var n, r, o = 0; t[e + (o || "")];)++o;
                    return e += o || "", t[e] = !0, n = "@@" + e, l(v, n, a.gs(null, function(t) {
                        r || (r = !0, l(this, n, a(t)), r = !1);
                    })), n;
                };
            }();
            i = function(t) {
                if (this instanceof i) throw new TypeError("Symbol is not a constructor");
                return o(t);
            }, t.exports = o = function t(e) {
                var n;
                if (this instanceof t) throw new TypeError("Symbol is not a constructor");
                return u ? r(e) : (n = c(i.prototype), e = void 0 === e ? "" : String(e), f(n, {
                    __description__: a("", e),
                    __name__: a("", p(e))
                }));
            }, f(o, {
                for: a(function(t) {
                    return d[t] ? d[t] : d[t] = o(String(t));
                }),
                keyFor: a(function(t) {
                    var e;
                    s(t);
                    for(e in d)if (d[e] === t) return e;
                }),
                hasInstance: a("", r && r.hasInstance || o("hasInstance")),
                isConcatSpreadable: a("", r && r.isConcatSpreadable || o("isConcatSpreadable")),
                iterator: a("", r && r.iterator || o("iterator")),
                match: a("", r && r.match || o("match")),
                replace: a("", r && r.replace || o("replace")),
                search: a("", r && r.search || o("search")),
                species: a("", r && r.species || o("species")),
                split: a("", r && r.split || o("split")),
                toPrimitive: a("", r && r.toPrimitive || o("toPrimitive")),
                toStringTag: a("", r && r.toStringTag || o("toStringTag")),
                unscopables: a("", r && r.unscopables || o("unscopables"))
            }), f(i.prototype, {
                constructor: a(o),
                toString: a("", function() {
                    return this.__name__;
                })
            }), f(o.prototype, {
                toString: a(function() {
                    return "Symbol (" + s(this).__description__ + ")";
                }),
                valueOf: a(function() {
                    return s(this);
                })
            }), l(o.prototype, o.toPrimitive, a("", function() {
                var t = s(this);
                return "symbol" == typeof t ? t : t.toString();
            })), l(o.prototype, o.toStringTag, a("c", "Symbol")), l(i.prototype, o.toStringTag, a("c", o.prototype[o.toStringTag])), l(i.prototype, o.toPrimitive, a("c", o.prototype[o.toPrimitive]));
        },
        function(t, e, n) {
            "use strict";
            var r = n(19);
            t.exports = function(t) {
                if (!r(t)) throw new TypeError(t + " is not a symbol");
                return t;
            };
        }
    ]);
});



var $i56po = parcelRequire("i56po");

var $i56po = parcelRequire("i56po");


var $i56po = parcelRequire("i56po");

function $9fa563bb6e56262b$export$2efbfd0050b0667(arr, index) {
    if (index < 0 || index >= arr.length) return arr // Return the original array if the index is out of range
    ;
    // Create a copy of the given array using spread operator
    const copiedArr = [
        ...arr
    ];
    // Get the object at the given index
    const objectToMove = copiedArr.splice(index, 1)[0];
    // Add the object to the beginning of the copied array
    copiedArr.unshift(objectToMove);
    // Return the modified copy of the array
    return copiedArr;
}
function $9fa563bb6e56262b$export$cda8558a7b277940(originalArr, orderArr) {
    const orderMap = new Map();
    orderArr.forEach((element, index)=>{
        orderMap.set(element, index);
    });
    originalArr.sort((a, b)=>{
        const indexA = orderMap.get(a);
        const indexB = orderMap.get(b);
        if (indexA === undefined) return 1;
        if (indexB === undefined) return -1;
        return indexA - indexB;
    });
    return originalArr;
}
function $9fa563bb6e56262b$export$9c3202b2987ae26b(arr) {
    return arr.join(", ");
}


var $39b712c8a7a8ea7b$export$21cdfbdd9a861522;
(function(DraftJobFields) {
    DraftJobFields["requirements"] = "requirements";
    DraftJobFields["category"] = "category";
    DraftJobFields["quantity"] = "quantity";
    DraftJobFields["location"] = "location";
    DraftJobFields["transport"] = "transport";
    DraftJobFields["dateBoundaries"] = "dateBoundaries";
    DraftJobFields["scheduleType"] = "scheduleType";
    DraftJobFields["sameOrDynamicTimingPrompt"] = "sameOrDynamicTimingPrompt";
    DraftJobFields["sameTimeSchedule"] = "sameTimeSchedule";
    DraftJobFields["daysSelect"] = "daysSelect";
    DraftJobFields["description"] = "description";
    DraftJobFields["contact"] = "contact";
    DraftJobFields["experience"] = "experience";
    DraftJobFields["dresscode"] = "dresscode";
    DraftJobFields["invitedSPs"] = "invitedSPs";
    DraftJobFields["preferences"] = "preferences";
    DraftJobFields["languages"] = "languages";
    DraftJobFields["nationalities"] = "nationalities";
    DraftJobFields["gender"] = "gender";
    DraftJobFields["documents"] = "documents";
    DraftJobFields["videoInterviews"] = "videoInterviews";
    DraftJobFields["accreditation"] = "accreditation";
    DraftJobFields["accommodation"] = "accommodation";
    DraftJobFields["boarding"] = "boarding";
})($39b712c8a7a8ea7b$export$21cdfbdd9a861522 || ($39b712c8a7a8ea7b$export$21cdfbdd9a861522 = {}));
const $39b712c8a7a8ea7b$export$164345136e266caa = [
    "requirements",
    "quantity",
    "transport",
    "dateBoundaries",
    "scheduleType",
    "sameOrDynamicTimingPrompt",
    "description",
    "experience",
    "dresscode",
    "contact",
    "invitedSPs",
    "preferences"
];
const $39b712c8a7a8ea7b$export$97e86e9060b42a83 = [
    "languages",
    "gender",
    "documents",
    "videoInterviews",
    "accreditation",
    "boarding",
    "nationalities"
];
const $39b712c8a7a8ea7b$export$28a0d92815e0bb4d = $39b712c8a7a8ea7b$export$97e86e9060b42a83.filter((field)=>{
    return (0, $73ccb33f5de6f5aa$export$8707029d024490c9)().order.includeGenderField || field !== "gender";
});
const $39b712c8a7a8ea7b$export$1078d012a5dd88cf = [
    ...$39b712c8a7a8ea7b$export$164345136e266caa.filter((field)=>{
        return (0, $73ccb33f5de6f5aa$export$8707029d024490c9)().order.includePublicTransportationField || field !== "transport";
    })
];
const $39b712c8a7a8ea7b$export$99dfb0d64235688a = (0, $i56po.types).model("Fields", {
    list: (0, $i56po.types).optional((0, $i56po.types).array((0, $i56po.types).enumeration("DraftJobFields", Object.values($39b712c8a7a8ea7b$export$21cdfbdd9a861522))), $39b712c8a7a8ea7b$export$1078d012a5dd88cf)
}).views((self)=>({
        hasField (field) {
            return self.list.includes(field);
        },
        get preferenceFieldIndex () {
            return self.list.indexOf("preferences");
        }
    })).views((self)=>({
        get preferenceFields () {
            return self.list.slice(self.preferenceFieldIndex + 1);
        },
        get defaultFields () {
            return self.list.slice(0, self.preferenceFieldIndex + 1);
        }
    })).actions((self)=>({
        reset () {
            self.list.clear();
            self.list = (0, $i56po.clone)($39b712c8a7a8ea7b$export$99dfb0d64235688a.create().list);
        },
        insertTimeFields (fields) {
            const insertToIndex = self.list.findIndex((field)=>field === "sameOrDynamicTimingPrompt") + 1;
            self.list.splice(insertToIndex, 0, ...fields);
        },
        replaceFields (firstFieldToRemove, fieldsCount, pasteFields) {
            const currentTimeFieldIndex = self.list.findIndex((field)=>field === firstFieldToRemove);
            const numberOfFieldsToRemove = fieldsCount;
            self.list.splice(currentTimeFieldIndex, numberOfFieldsToRemove, ...pasteFields);
        },
        removeFields (fields) {
            // @ts-ignore
            self.list = (0, $i56po.cast)(self.list.filter((field)=>!fields.includes(field)));
        },
        orderPreferenceFields () {
            // sort them to be in correct order
            (0, $9fa563bb6e56262b$export$cda8558a7b277940)(self.preferenceFields, $39b712c8a7a8ea7b$export$28a0d92815e0bb4d);
            // and paste sorted preference fields in place of the old ones
            self.list.splice(self.preferenceFieldIndex + 1, self.preferenceFields.length, ...self.preferenceFields);
        },
        orderDefaultFields () {
            (0, $9fa563bb6e56262b$export$cda8558a7b277940)(self.defaultFields, $39b712c8a7a8ea7b$export$1078d012a5dd88cf);
            self.list.splice(0, self.defaultFields.length, ...self.defaultFields);
        },
        orderFields () {
            this.orderDefaultFields();
            this.orderPreferenceFields();
        }
    })).actions((self)=>({
        addAccreditationField () {
            if (!self.hasField("accreditation")) {
                self.preferenceFields.push("accreditation");
                self.orderPreferenceFields();
            }
        },
        removeAccreditationField () {
            self.list = (0, $i56po.cast)(self.list.filter((item)=>item !== "accreditation"));
        },
        addLanguagesField () {
            if (!self.hasField("languages")) {
                self.preferenceFields.push("languages");
                self.orderPreferenceFields();
            }
        },
        removeLanguagesField () {
            self.list = (0, $i56po.cast)(self.list.filter((item)=>item !== "languages"));
        },
        addGenderField () {
            if (!self.hasField("gender")) {
                self.preferenceFields.push("gender");
                self.orderPreferenceFields();
            }
        },
        removeGenderField () {
            self.list = (0, $i56po.cast)(self.list.filter((item)=>item !== "gender"));
        },
        addPublicTransportAccessibilityField () {
            if (!self.hasField("transport")) {
                self.defaultFields.push("transport");
                self.orderDefaultFields();
            }
        },
        removePublicTransportAccessibilityField () {
            self.list = (0, $i56po.cast)(self.list.filter((item)=>item !== "transport"));
        },
        addInvitedSPsField () {
            if (!self.hasField("invitedSPs")) {
                self.defaultFields.push("invitedSPs");
                self.orderDefaultFields();
            }
        },
        removeInvitedSPsField () {
            self.list = (0, $i56po.cast)(self.list.filter((item)=>item !== "invitedSPs"));
        },
        addRequirementsField () {
            if (!self.hasField("requirements")) {
                self.defaultFields.push("requirements");
                self.orderDefaultFields();
            }
        },
        removeRequirementsField () {
            self.list = (0, $i56po.cast)(self.list.filter((item)=>item !== "requirements"));
        },
        addDocumentsField () {
            if (!self.hasField("documents")) {
                self.preferenceFields.push("documents");
                self.orderPreferenceFields();
            }
        },
        removeDocumentsField () {
            self.list = (0, $i56po.cast)(self.list.filter((item)=>item !== "documents"));
        },
        addInterviewField () {
            if (!self.hasField("videoInterviews")) {
                self.preferenceFields.push("videoInterviews");
                self.orderPreferenceFields();
            }
        },
        removeInterviewField () {
            self.list = (0, $i56po.cast)(self.list.filter((item)=>item !== "videoInterviews"));
        },
        addBoardingField () {
            if (!self.hasField("boarding")) {
                self.preferenceFields.push("boarding");
                self.orderPreferenceFields();
            }
        },
        removeBoardingField () {
            self.list = (0, $i56po.cast)(self.list.filter((item)=>item !== "boarding"));
        },
        addNationalitiesField () {
            if (!self.hasField("nationalities")) {
                self.preferenceFields.push("nationalities");
                self.orderPreferenceFields();
                console.log(self.list);
            }
        },
        removeNationalitiesField () {
            self.list = (0, $i56po.cast)(self.list.filter((item)=>item !== "nationalities"));
        }
    }));
function $39b712c8a7a8ea7b$export$9e08febd70b7af30(targetInstance) {
    (0, $i56po.addMiddleware)(targetInstance, (call, next, abort)=>{
        switch(call.name){
            case "useAccreditation":
                if (call.args[0]) targetInstance.fields.addAccreditationField();
                else targetInstance.fields.removeAccreditationField();
                break;
            case "useLanguages":
                if (call.args[0]) targetInstance.fields.addLanguagesField();
                else targetInstance.fields.removeLanguagesField();
                break;
            case "useGender":
                if (call.args[0]) targetInstance.fields.addGenderField();
                else targetInstance.fields.removeGenderField();
                break;
            case "useDocuments":
                if (call.args[0]) targetInstance.fields.addDocumentsField();
                else targetInstance.fields.removeDocumentsField();
                break;
            case "useInterview":
                if (call.args[0]) targetInstance.fields.addInterviewField();
                else targetInstance.fields.removeInterviewField();
                break;
            case "useBoarding":
                if (call.args[0]) targetInstance.fields.addBoardingField();
                else targetInstance.fields.removeBoardingField();
                break;
            case "useNationalities":
                if (call.args[0]) targetInstance.fields.addNationalitiesField();
                else targetInstance.fields.removeNationalitiesField();
                break;
            default:
                break;
        }
        return next(call);
    });
}



var $45fvw = parcelRequire("45fvw");

const $ddf12117b815a7c3$export$94f4d87fad5dcf9a = "hh:mm a";
const $ddf12117b815a7c3$export$4e4cb19dd88cd821 = "D MMM YYYY";
const $ddf12117b815a7c3$export$1fc008235d8960f4 = (start, end)=>{
    if (!start || !end) return [];
    const startDate = new Date(start.valueOf());
    startDate.setMilliseconds(0);
    const endDate = new Date(end.valueOf());
    endDate.setMilliseconds(0);
    const arr = [];
    while(startDate <= endDate){
        arr.push((0, (/*@__PURE__*/$parcel$interopDefault($45fvw)))(startDate).format("YYYY-MM-DD"));
        startDate.setDate(startDate.getDate() + 1);
    }
    return arr;
};
const $ddf12117b815a7c3$export$81fa0da0c2fba503 = new Date().getTimezoneOffset() * 60;
const $ddf12117b815a7c3$export$548d0356db7f67bf = (0, $73ccb33f5de6f5aa$export$8707029d024490c9)().firstDayOfWeek === "Sun" ? [
    "Sun",
    "Mon",
    "Tue",
    "Wed",
    "Thu",
    "Fri",
    "Sat"
] : [
    "Sun",
    "Mon",
    "Tue",
    "Wed",
    "Thu",
    "Fri",
    "Sat"
];
const $ddf12117b815a7c3$export$16352d1b10c5eb38 = [
    "jan",
    "feb",
    "mar",
    "apr",
    "may",
    "jun",
    "jul",
    "aug",
    "sep",
    "oct",
    "nov",
    "dec"
];
const $ddf12117b815a7c3$export$5fd200c30d9d61b7 = (yyyyMmDd)=>{
    return $ddf12117b815a7c3$export$548d0356db7f67bf[new Date(yyyyMmDd).getUTCDay()];
};
const $ddf12117b815a7c3$export$28daf0b8a647a8fb = (date)=>{
    return $ddf12117b815a7c3$export$548d0356db7f67bf[date.getUTCDay()];
};
const $ddf12117b815a7c3$export$7a581aa89cac4350 = (yyyyMmDd)=>{
    return !isNaN(new Date(yyyyMmDd).getTime());
};
const $ddf12117b815a7c3$export$95e9511383207484 = (ddd)=>{
    return $ddf12117b815a7c3$export$548d0356db7f67bf.includes(ddd);
};
const $ddf12117b815a7c3$export$c97e4eac19acee06 = (yyyyMmDd)=>{
    const currentDate = new Date();
    const compareDate = new Date(yyyyMmDd);
    compareDate.setHours(0, 0, 0, 0);
    return compareDate < new Date(currentDate.getFullYear(), currentDate.getMonth(), currentDate.getDate());
};
const $ddf12117b815a7c3$export$c5e384ef955d8e74 = (startDate, endDate)=>{
    const range = [];
    const currentDate = new Date(startDate);
    while(currentDate <= endDate){
        range.push(new Date(currentDate));
        currentDate.setDate(currentDate.getDate() + 1);
    }
    return range;
};
const $ddf12117b815a7c3$export$255008033397e701 = (time12h)=>{
    const [time, modifier] = time12h.split(" ");
    const timeComponents = time.split(":");
    let hours = timeComponents[0];
    const minutes = timeComponents[1];
    if (hours === "12") hours = "00";
    if (modifier === "PM") hours = String(Number(hours) + 12);
    return `${hours}:${minutes}`;
};
const $ddf12117b815a7c3$export$8737c5d1f7692c0e = (time24h)=>{
    const hours24 = Number(time24h.slice(0, 2));
    const minutes = time24h.slice(-2);
    const hours12 = hours24 % 12 || 12;
    const hours12WithPrefix = hours12 >= 10 ? hours12 : `0${hours12}`;
    const modifier = hours24 < 12 || hours24 === 24 ? "AM" : "PM";
    return `${hours12WithPrefix}:${minutes} ${modifier}`;
};
const $ddf12117b815a7c3$export$d5ed68591eccfcf8 = (date, addOrSubtractDays = 1)=>{
    const currentDay = date.getDate();
    const nextDay = new Date(date.getTime());
    nextDay.setDate(currentDay + addOrSubtractDays);
    return nextDay;
};
const $ddf12117b815a7c3$export$8a5160aad7ff40be = (date)=>{
    const firstDayOfWeek = $ddf12117b815a7c3$export$f9258517a71b34d8(date);
    return new Array(7).fill(0).map((_, index)=>{
        return $ddf12117b815a7c3$export$d5ed68591eccfcf8(firstDayOfWeek, index);
    });
};
const $ddf12117b815a7c3$export$f9258517a71b34d8 = (currentDate)=>{
    const isSundayFirstDayOfWeek = (0, $73ccb33f5de6f5aa$export$8707029d024490c9)().firstDayOfWeek === "Sun";
    const currentDayOfWeekIndex = currentDate.getDay();
    const firstDayDate = new Date(currentDate);
    if (isSundayFirstDayOfWeek) firstDayDate.setDate(currentDate.getDate() - currentDayOfWeekIndex);
    else {
        const diff = currentDayOfWeekIndex === 0 ? 6 : currentDayOfWeekIndex - 1;
        firstDayDate.setDate(currentDate.getDate() - diff);
    }
    return firstDayDate;
};
const $ddf12117b815a7c3$export$efb113ee57e9edfb = (date)=>{
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const day = String(date.getDate()).padStart(2, "0");
    return `${year}-${month}-${day}`;
};
const $ddf12117b815a7c3$export$91a13d8e2d73e0bc = ()=>{
    return $ddf12117b815a7c3$export$efb113ee57e9edfb(new Date());
};
const $ddf12117b815a7c3$export$d944ce49c26cbd64 = (date)=>{
    const hours = `0${date.getHours()}`.slice(-2);
    const minutes = `0${date.getMinutes()}`.slice(-2);
    return `${hours}:${minutes}`;
};
function $ddf12117b815a7c3$export$802fdf70ef4e2893(startTimeString = "00:00", gapInMinutes = 15) {
    const times = [];
    let currentHour = 0;
    let currentMinute = 0;
    while(currentHour < 24){
        times.push(`${String(currentHour).padStart(2, "0")}:${String(currentMinute).padStart(2, "0")}`);
        currentMinute += gapInMinutes;
        if (currentMinute >= 60) {
            currentHour++;
            currentMinute -= 60;
        }
    }
    const indexOfStartTime = times.indexOf(startTimeString);
    const firstPartOfArray = times.slice(indexOfStartTime);
    const secondPartOfArray = times.slice(0, indexOfStartTime);
    return [
        ...firstPartOfArray,
        ...secondPartOfArray
    ];
}
const $ddf12117b815a7c3$export$f169b154f61f164e = (dateString)=>{
    return (0, (/*@__PURE__*/$parcel$interopDefault($45fvw)))(dateString, "YYYY-MM-DD").format("DD MMM YYYY");
};
const $ddf12117b815a7c3$export$69db29514b384dcc = (epoch)=>{
    return new Date(epoch * 1000);
};
const $ddf12117b815a7c3$export$6d5a760082fd65aa = (time)=>{
    const momentTimeTomorrow = (0, (/*@__PURE__*/$parcel$interopDefault($45fvw)))(time, "HH:mm").add(1, "days");
    const timeNow = (0, (/*@__PURE__*/$parcel$interopDefault($45fvw)))();
    const duration = (0, (/*@__PURE__*/$parcel$interopDefault($45fvw))).duration(momentTimeTomorrow.diff(timeNow));
    // if actual hours difference is i.g. 26 hours moment.js will treat it as 1 day, 2 hours
    // so if omit duration.days() === 0 it can return true for tomorrow
    // same for duration.months() === 0 it can return true for the date exactly one month ahead
    const isLessThan24 = duration.months() === 0 && duration.days() === 0 && duration.hours() < 24;
    return isLessThan24;
};
const $ddf12117b815a7c3$export$f2f3a08532b4f1b5 = (date)=>{
    const nextDay = new Date(date);
    nextDay.setDate(nextDay.getDate() + 1);
    return nextDay;
};
const $ddf12117b815a7c3$var$localeDateString = new Date().toLocaleString();
const $ddf12117b815a7c3$export$725c94c55ade8c95 = $ddf12117b815a7c3$var$localeDateString.includes("PM") || $ddf12117b815a7c3$var$localeDateString.includes("AM");


const $7877ded9826ff0ce$export$9cf635b1fa79e9d5 = (0, $i56po.types).model("JobDatesDateBoundaries", {
    open_ended: (0, $i56po.types).optional((0, $i56po.types).boolean, false),
    start_date: (0, $i56po.types).maybeNull((0, $i56po.types).string),
    end_date: (0, $i56po.types).maybeNull((0, $i56po.types).string),
    start_date_error: (0, $i56po.types).maybeNull((0, $i56po.types).string),
    end_date_or_open_ended_error: (0, $i56po.types).maybeNull((0, $i56po.types).string)
}).views((self)=>({
        get startDateHasError () {
            return self.start_date_error !== null;
        },
        get endDateOrOpenEndedHasError () {
            return self.end_date_or_open_ended_error !== null;
        },
        get isValid () {
            return self.start_date && (self.end_date ?? self.open_ended);
        }
    })).actions((self)=>({
        setStartDate (startDate) {
            self.start_date = startDate;
            self.start_date_error = null;
        },
        setEndDate (endDate) {
            self.end_date = endDate;
            self.end_date_or_open_ended_error = null;
        },
        clearErors () {
            self.start_date_error = null;
            self.end_date_or_open_ended_error = null;
        },
        validateStartDate () {
            if (self.start_date && (0, $ddf12117b815a7c3$export$c97e4eac19acee06)(self.start_date)) {
                // check if date is at least today or later
                self.start_date_error = (0, $2b1f0855f2f3a952$export$625550452a3fa3ec)("job_draft_details.start_date_must_be_at_least_today");
                return false;
            } else if (self.start_date) {
                self.start_date_error = null;
                return true;
            } else {
                self.start_date_error = (0, $2b1f0855f2f3a952$export$625550452a3fa3ec)("job_draft_details.start_date_required");
                return false;
            }
        },
        validateEndDate () {
            if (self.end_date && (0, $ddf12117b815a7c3$export$c97e4eac19acee06)(self.end_date)) {
                self.end_date_or_open_ended_error = (0, $2b1f0855f2f3a952$export$625550452a3fa3ec)("job_draft_details.end_date_must_be_at_least_today");
                return false;
            } else if (self.start_date && self.end_date && new Date(self.end_date) < new Date(self.start_date)) {
                self.end_date = (0, $2b1f0855f2f3a952$export$625550452a3fa3ec)("job_draft_details.end_date_cannot_be_before_start_date");
                return false;
            } else if (!self.end_date && !self.open_ended) {
                self.end_date_or_open_ended_error = (0, $2b1f0855f2f3a952$export$625550452a3fa3ec)("job_draft_details.end_date_required");
                return false;
            } else {
                self.end_date_or_open_ended_error = null;
                return true;
            }
        }
    })).actions((self)=>({
        validate () {
            const isStartDateValid = self.validateStartDate();
            const isEndDateValid = self.validateEndDate();
            return isStartDateValid && isEndDateValid;
        }
    }));
function $7877ded9826ff0ce$export$94e1034eee61e50e(targetInstance) {
    (0, $i56po.addMiddleware)(targetInstance, (call, next, abort)=>{
        if (call.type === "action" && call.args[0] === (0, $39b712c8a7a8ea7b$export$21cdfbdd9a861522).dateBoundaries) return abort(targetInstance.schedule.dateBoundaries.validate());
        return next(call);
    });
}



var $i56po = parcelRequire("i56po");


var $a4e7aca7274b573e$export$38e26ec75b48a88c;
(function(ScheduleType) {
    ScheduleType["weekly"] = "weekly";
    ScheduleType["daily"] = "daily";
})($a4e7aca7274b573e$export$38e26ec75b48a88c || ($a4e7aca7274b573e$export$38e26ec75b48a88c = {}));


const $a9d76bb020691cd5$export$5a5183b33efcf43e = (0, $i56po.types).model("JobDatesScheduleType", {
    value: (0, $i56po.types).maybeNull((0, $i56po.types).enumeration("ScheduleType", Object.values((0, $a4e7aca7274b573e$export$38e26ec75b48a88c)))),
    error: (0, $i56po.types).maybeNull((0, $i56po.types).string)
}).views((self)=>({
        get hasError () {
            return self.error !== null;
        }
    })).actions((self)=>({
        set (type) {
            $a9d76bb020691cd5$var$checkValueIsInEnum(type);
            self.value = type;
            self.error = null;
        },
        validate () {
            if (self.value === null) {
                self.error = (0, $2b1f0855f2f3a952$export$625550452a3fa3ec)("job_draft_details.schedule_type_required");
                return false;
            }
            $a9d76bb020691cd5$var$checkValueIsInEnum(self.value);
            return true;
        }
    }));
function $a9d76bb020691cd5$var$checkValueIsInEnum(value) {
    if (!Object.values((0, $a4e7aca7274b573e$export$38e26ec75b48a88c)).includes(value)) throw new Error(`Unexpected id ${value} for schedule type`);
}
function $a9d76bb020691cd5$export$239b624427feacb3(targetInstance) {
    (0, $i56po.addMiddleware)(targetInstance, (call, next, abort)=>{
        if (call.type === "action" && call.args[0] === (0, $39b712c8a7a8ea7b$export$21cdfbdd9a861522).scheduleType) return abort(targetInstance.schedule.scheduleType.validate());
        return next(call);
    });
}



var $i56po = parcelRequire("i56po");



const $e1f74a26db852f67$export$d221aa1ebfdcd0fe = (0, $i56po.types).model("JobDatesSameTimeSchedule", {
    all_days_have_same_time: (0, $i56po.types).maybeNull((0, $i56po.types).boolean),
    all_days_have_same_time_error: (0, $i56po.types).maybeNull((0, $i56po.types).string),
    same_start_time: (0, $i56po.types).maybeNull((0, $i56po.types).string),
    same_start_time_error: (0, $i56po.types).maybeNull((0, $i56po.types).string),
    same_end_time: (0, $i56po.types).maybeNull((0, $i56po.types).string),
    same_end_time_error: (0, $i56po.types).maybeNull((0, $i56po.types).string),
    is_less_than_24h: (0, $i56po.types).maybeNull((0, $i56po.types).boolean)
}).views((self)=>({
        get didSelectTimingType () {
            return self.all_days_have_same_time !== null;
        },
        get allDaysHaveSameTime () {
            return self.all_days_have_same_time;
        },
        get sameTimePromptHasErrors () {
            return self.all_days_have_same_time_error !== null;
        },
        get startTimeHasErrors () {
            return self.same_start_time_error !== null;
        },
        get endTimeHasErrors () {
            return self.same_end_time_error !== null;
        }
    })).actions((self)=>({
        setStartTime (startTime) {
            self.same_start_time = startTime;
            self.same_start_time_error = null;
            const dateBoundaries = (0, $i56po.getParent)(self).dateBoundaries;
            // check if submitted timing applies to tomorrow
            if (dateBoundaries.start_date === (0, $ddf12117b815a7c3$export$91a13d8e2d73e0bc)()) // check if start time is not earlier than 24 hours from now
            self.is_less_than_24h = (0, $ddf12117b815a7c3$export$6d5a760082fd65aa)(self.same_start_time);
        },
        setEndTime (endTime) {
            self.same_end_time = endTime;
            self.same_end_time_error = null;
        },
        reset () {
            self.all_days_have_same_time = null;
            self.all_days_have_same_time_error = null;
            self.same_start_time = null;
            self.same_start_time_error = null;
            self.same_end_time = null;
            self.same_end_time_error = null;
        }
    })).actions((self)=>({
        setIsSameTiming (isSameTiming) {
            self.reset();
            self.all_days_have_same_time = isSameTiming;
        },
        validateTypeSelection () {
            if (self.allDaysHaveSameTime === null) {
                self.all_days_have_same_time_error = (0, $2b1f0855f2f3a952$export$625550452a3fa3ec)("job_draft_details.same_time_prompt_required");
                return false;
            } else {
                self.all_days_have_same_time_error = null;
                return true;
            }
        },
        validateStartTime () {
            if (self.all_days_have_same_time && self.same_start_time === null) {
                self.same_start_time_error = (0, $2b1f0855f2f3a952$export$625550452a3fa3ec)("job_draft_details.start_time_required");
                return false;
            } else {
                self.same_start_time_error = null;
                return true;
            }
        },
        validateEndTime () {
            if (self.all_days_have_same_time && self.same_end_time === null) {
                self.same_end_time_error = (0, $2b1f0855f2f3a952$export$625550452a3fa3ec)("job_draft_details.end_time_required");
                return false;
            } else {
                self.same_end_time_error = null;
                return true;
            }
        }
    })).actions((self)=>({
        validateTimings () {
            const isStartTimeValid = self.validateStartTime();
            const isEndTimeValid = self.validateEndTime();
            return isStartTimeValid && isEndTimeValid;
        }
    }));
function $e1f74a26db852f67$export$83b9f4169c544cc2(targetInstance) {
    (0, $i56po.addMiddleware)(targetInstance, (call, next, abort)=>{
        if (call.type === "action" && call.args[0] === (0, $39b712c8a7a8ea7b$export$21cdfbdd9a861522).sameTimeSchedule) return abort(targetInstance.schedule.sameTimeSchedule.validateTimings());
        else if (call.type === "action" && call.args[0] === (0, $39b712c8a7a8ea7b$export$21cdfbdd9a861522).sameOrDynamicTimingPrompt) return abort(targetInstance.schedule.sameTimeSchedule.validateTypeSelection());
        else if (call.type === "action" && (call.name === "setStartDate" || call.name === "setEndDate")) targetInstance.clearSameTimeFields();
        return next(call);
    });
}



var $i56po = parcelRequire("i56po");



/* eslint-disable @typescript-eslint/no-empty-interface */ 
var $i56po = parcelRequire("i56po");

const $2488805795be3a44$export$f387fa08f69f11d4 = (0, $i56po.types).model("JobDatesSingleDate", {
    start_time: (0, $i56po.types).maybeNull((0, $i56po.types).string),
    start_time_error: (0, $i56po.types).maybeNull((0, $i56po.types).string),
    end_time: (0, $i56po.types).maybeNull((0, $i56po.types).string),
    end_time_error: (0, $i56po.types).maybeNull((0, $i56po.types).string),
    selected: (0, $i56po.types).optional((0, $i56po.types).boolean, false),
    is_less_than_24h: (0, $i56po.types).maybeNull((0, $i56po.types).boolean)
}).actions((self)=>({
        validate () {
            if (self.selected && (!self.start_time || !self.end_time)) {
                if (!self.start_time) self.start_time_error = (0, $2b1f0855f2f3a952$export$625550452a3fa3ec)("job_draft_details.start_time_required");
                if (!self.end_time) self.end_time_error = (0, $2b1f0855f2f3a952$export$625550452a3fa3ec)("job_draft_details.end_time_required");
                return false;
            }
            self.start_time_error = null;
            self.end_time_error = null;
            return true;
        }
    }));


const $7187cc442ab66cc5$export$6c40df1476827a1d = (0, $i56po.types).model("JobDatesDistinctTimeSchedule", {
    /**
     * keeps Record<date, SingleDateModel>, where date is in one of two formats:
     * 'ddd' ('Mon', 'Tue', etc.) or 'YYYY-MM-DD'
     */ map: (0, $i56po.types).map((0, $2488805795be3a44$export$f387fa08f69f11d4)),
    /**
     * overall indicator that there is an error related to distinct schedule
     * can be a general message or a duplicate error message applied to particular date
     */ error: (0, $i56po.types).maybeNull((0, $i56po.types).string)
}).views((self)=>({
        get jobDates () {
            return Array.from(self.map.entries());
        },
        get jobDatesKeys () {
            return Array.from(self.map.keys()).filter((key)=>self.map.get(key)?.selected);
        },
        get jobDatesValues () {
            return Array.from(self.map.values()).filter((value)=>value.selected);
        },
        get filledJobDatesCount () {
            return Array.from(self.map.values()).filter((item)=>item.selected).length;
        },
        get isLessThan24Hours () {
            return Array.from(self.map.values()).filter((item)=>item.is_less_than_24h).length > 0;
        }
    })).actions((self)=>({
        setDateTime (dateTime) {
            const { date: date, ...dateObj } = dateTime;
            self.map.set(date, dateObj);
        },
        setDateStartTime ({ date: date, start_time: start_time }) {
            const existingDate = self.map.get(date);
            self.map.set(date, {
                start_time: start_time,
                end_time: existingDate?.end_time ?? null,
                selected: existingDate?.selected,
                start_time_error: null
            });
            if (start_time) {
                const dateInstance = self.map.get(date);
                const parent = (0, $i56po.getParent)(self);
                const dateBoundaries = parent.dateBoundaries;
                const nextDaySameTime = (0, $ddf12117b815a7c3$export$f2f3a08532b4f1b5)(new Date());
                const tomorrowYyyyMmDd = (0, $ddf12117b815a7c3$export$efb113ee57e9edfb)(nextDaySameTime);
                const tomorrowDdd = (0, $ddf12117b815a7c3$export$28daf0b8a647a8fb)(nextDaySameTime);
                // check if submitted timing applies to tomorrow
                if (dateBoundaries.start_date === tomorrowYyyyMmDd && (date === tomorrowYyyyMmDd || date === tomorrowDdd)) dateInstance.is_less_than_24h = (0, $ddf12117b815a7c3$export$6d5a760082fd65aa)(start_time);
                return true;
            }
            self.error = null;
        },
        setDateEndTime ({ date: date, end_time: end_time }) {
            const existingDate = self.map.get(date);
            self.map.set(date, {
                start_time: existingDate?.start_time ?? null,
                end_time: end_time,
                selected: existingDate?.selected,
                end_time_error: null
            });
            self.error = null;
        },
        setDateTimes ({ dates: dates }) {
            self.map = (0, $i56po.cast)(dates);
        },
        selectDate ({ date: date }) {
            const existingDate = self.map.get(date);
            self.map.set(date, {
                start_time: existingDate?.start_time,
                end_time: existingDate?.end_time,
                selected: true,
                start_time_error: null,
                end_time_error: null
            });
        },
        clearDate (date) {
            self.map.set(date, {
                start_time: null,
                end_time: null,
                start_time_error: null,
                end_time_error: null
            });
        },
        removeDates () {
            self.map.clear();
        },
        validateSelections () {
            const parent = (0, $i56po.getParent)(self);
            const dateBoundaries = parent.dateBoundaries;
            if (self.map.size === 0 || self.filledJobDatesCount === 0) {
                self.error = (0, $2b1f0855f2f3a952$export$625550452a3fa3ec)("job_draft_details.select_one_date_at_least");
                return false;
            }
            const scheduleType = parent.scheduleType;
            const startDateKey = scheduleType.value === "weekly" ? (0, $ddf12117b815a7c3$export$5fd200c30d9d61b7)(dateBoundaries.start_date) : dateBoundaries.start_date;
            const endDateKey = scheduleType.value === "weekly" ? (0, $ddf12117b815a7c3$export$5fd200c30d9d61b7)(dateBoundaries.end_date) : dateBoundaries.end_date;
            if (!self.map.get(startDateKey)?.selected) {
                self.error = (0, $2b1f0855f2f3a952$export$625550452a3fa3ec)("job_draft_details.must_include_day_of_start_date");
                return false;
            } else if (!dateBoundaries.open_ended && !self.map.get(endDateKey)?.selected) {
                self.error = (0, $2b1f0855f2f3a952$export$625550452a3fa3ec)("job_draft_details.must_include_day_of_end_date");
                return false;
            }
            return true;
        }
    })).actions((self)=>({
        putEmptyTimesForWeekdays () {
            self.removeDates();
            (0, $ddf12117b815a7c3$export$548d0356db7f67bf).forEach((date)=>{
                self.setDateStartTime({
                    date: date,
                    start_time: null
                });
                self.setDateEndTime({
                    date: date,
                    end_time: null
                });
            });
        },
        validate () {
            if (!self.validateSelections()) return false;
            let hasAtLeastOneDateError = false;
            for (const [date, singleDateInstance] of self.map.entries()){
                $7187cc442ab66cc5$var$checkDateFormat(date);
                if (!singleDateInstance.validate()) hasAtLeastOneDateError = true;
            }
            if (hasAtLeastOneDateError) {
                self.error = (0, $2b1f0855f2f3a952$export$625550452a3fa3ec)("job_draft_details.fill_all_selected_dates");
                return false;
            }
            self.error = null;
            return true;
        }
    }));
/**
 * Validates that date has valid format
 * @param date 'YYYY-MM-DD' or 'ddd' ('Mon', 'Tue', 'Wed', etc) string
 */ function $7187cc442ab66cc5$var$checkDateFormat(date) {
    if (!(0, $ddf12117b815a7c3$export$7a581aa89cac4350)(date) && !(0, $ddf12117b815a7c3$export$95e9511383207484)(date)) throw new Error(`Invalid format of date: ${date}, expected one of: YYYY-MM-DD or ddd`);
}
function $7187cc442ab66cc5$export$f98f8472f3dc850f(targetInstance) {
    (0, $i56po.addMiddleware)(targetInstance, (call, next, abort)=>{
        if (call.type === "action" && call.args[0] === (0, $39b712c8a7a8ea7b$export$21cdfbdd9a861522).daysSelect && !targetInstance.schedule.sameTimeSchedule.allDaysHaveSameTime) return abort(targetInstance.schedule.distinctTimeSchedule.validate());
        else if (call.type === "action" && call.args[0] === (0, $39b712c8a7a8ea7b$export$21cdfbdd9a861522).daysSelect && targetInstance.schedule.sameTimeSchedule.allDaysHaveSameTime) return abort(targetInstance.schedule.distinctTimeSchedule.validateSelections());
        else if (call.type === "action" && (call.name === "setStartDate" || call.name === "setEndDate")) targetInstance.clearDistinctTimeFields();
        return next(call);
    });
}





// @ts-ignore
const $c8d84e5894c5bfbd$var$moment = (0, $3c5155092adf0860$exports.extendMoment)((0, (/*@__PURE__*/$parcel$interopDefault($45fvw))));
const $c8d84e5894c5bfbd$export$e5b094170864a75f = [
    (0, $39b712c8a7a8ea7b$export$21cdfbdd9a861522).sameTimeSchedule,
    (0, $39b712c8a7a8ea7b$export$21cdfbdd9a861522).daysSelect
];
const $c8d84e5894c5bfbd$export$48f94b164c9d6cc2 = [
    (0, $39b712c8a7a8ea7b$export$21cdfbdd9a861522).daysSelect
];
const $c8d84e5894c5bfbd$export$ec7d5ddad8453d42 = (0, $i56po.types).model("JobSchedule", {
    dateBoundaries: (0, $i56po.types).optional((0, $7877ded9826ff0ce$export$9cf635b1fa79e9d5), {}),
    scheduleType: (0, $i56po.types).optional((0, $a9d76bb020691cd5$export$5a5183b33efcf43e), {}),
    sameTimeSchedule: (0, $i56po.types).optional((0, $e1f74a26db852f67$export$d221aa1ebfdcd0fe), {}),
    distinctTimeSchedule: (0, $i56po.types).optional((0, $7187cc442ab66cc5$export$6c40df1476827a1d), {})
}).views((self)=>({
        get anyScheduleError () {
            return self.scheduleType.error ?? self.sameTimeSchedule.all_days_have_same_time_error ?? self.sameTimeSchedule.same_start_time_error ?? self.sameTimeSchedule.same_end_time_error ?? self.distinctTimeSchedule.error;
        }
    })).actions((self)=>({
        preselectDate (date) {
            self.distinctTimeSchedule.setDateTime({
                date: date,
                start_time: self.sameTimeSchedule.same_start_time ?? null,
                end_time: self.sameTimeSchedule.same_end_time ?? null,
                selected: true
            });
        }
    })).actions((self)=>({
        setSameStartTime (time) {
            self.sameTimeSchedule.setStartTime(time);
            self.distinctTimeSchedule.map.forEach((dateObj, key)=>{
                if (dateObj.selected) self.distinctTimeSchedule.setDateStartTime({
                    date: String(key),
                    start_time: time
                });
            });
        },
        setSameEndTime (time) {
            self.sameTimeSchedule.setEndTime(time);
            self.distinctTimeSchedule.map.forEach((dateObj, key)=>{
                if (dateObj.selected) self.distinctTimeSchedule.setDateEndTime({
                    date: String(key),
                    end_time: time
                });
            });
        },
        setRangeOfDays () {
            if (!self.dateBoundaries.start_date || !self.dateBoundaries.end_date) return;
            self.distinctTimeSchedule.removeDates();
            const dateRanges = (0, $ddf12117b815a7c3$export$c5e384ef955d8e74)(new Date(self.dateBoundaries.start_date), new Date(self.dateBoundaries.end_date));
            if (self.scheduleType.value === (0, $a4e7aca7274b573e$export$38e26ec75b48a88c).daily) dateRanges.forEach((date)=>{
                const formatted = (0, $ddf12117b815a7c3$export$efb113ee57e9edfb)(date);
                self.distinctTimeSchedule.setDateStartTime({
                    date: formatted,
                    start_time: null
                });
                self.distinctTimeSchedule.setDateEndTime({
                    date: formatted,
                    end_time: null
                });
                self.preselectDate(formatted);
            });
            else {
                self.distinctTimeSchedule.putEmptyTimesForWeekdays();
                dateRanges.forEach((date)=>{
                    self.preselectDate((0, $ddf12117b815a7c3$export$5fd200c30d9d61b7)((0, $ddf12117b815a7c3$export$efb113ee57e9edfb)(date)));
                });
            }
        }
    })).actions((self)=>({
        setScheduleType (type) {
            self.scheduleType.set(type);
            if (self.dateBoundaries.isValid) self.setRangeOfDays();
        },
        setEndDate (endDate) {
            self.dateBoundaries.setEndDate(endDate);
            if (self.dateBoundaries.start_date && self.scheduleType.value) self.setRangeOfDays();
            self.sameTimeSchedule.reset();
        }
    })).actions((self)=>({
        setStartDate (startDate) {
            self.dateBoundaries.setStartDate(startDate);
            if (self.dateBoundaries.open_ended) self.dateBoundaries.setEndDate($c8d84e5894c5bfbd$var$moment(self.dateBoundaries.start_date, "YYYY-MM-DD").endOf("month").format("YYYY-MM-DD"));
            if (self.dateBoundaries.end_date && self.scheduleType.value) self.setRangeOfDays();
            self.sameTimeSchedule.reset();
        },
        setIfOpenEnded (isOpenEnded) {
            self.dateBoundaries.open_ended = isOpenEnded;
            if (!isOpenEnded) {
                self.setEndDate(null);
                return;
            }
            if (self.dateBoundaries.start_date) self.setEndDate($c8d84e5894c5bfbd$var$moment(self.dateBoundaries.start_date, "YYYY-MM-DD").endOf("month").format("YYYY-MM-DD"));
        }
    }));



var $i56po = parcelRequire("i56po");


const $4ee97a2e5c21154b$export$ff080064f5d67c0d = (0, $i56po.types).model("Quantity", {
    value: (0, $i56po.types).maybeNull((0, $i56po.types).number),
    error: (0, $i56po.types).maybeNull((0, $i56po.types).string)
}).views((self)=>({
        get hasError () {
            return self.error !== null;
        }
    })).actions((self)=>({
        set (quantity) {
            self.value = quantity;
            self.error = null;
        },
        validate () {
            if (self.value === null || self.value < 1) {
                self.error = (0, $2b1f0855f2f3a952$export$625550452a3fa3ec)("job_draft_details.quantity_required");
                return false;
            }
            self.error = null;
            return true;
        }
    }));
function $4ee97a2e5c21154b$export$9fc4593f3c0bc884(targetInstance) {
    (0, $i56po.addMiddleware)(targetInstance, (call, next, abort)=>{
        if (call.type === "action" && call.args[0] === (0, $39b712c8a7a8ea7b$export$21cdfbdd9a861522).quantity) return abort(targetInstance.quantity.validate());
        return next(call);
    });
}



var $i56po = parcelRequire("i56po");

const $ccb6750122854e33$export$23eb54e04d607842 = (0, $i56po.types).model("Requirements", {
    list: (0, $i56po.types).maybeNull((0, $i56po.types).array((0, $i56po.types).number)),
    error: (0, $i56po.types).maybeNull((0, $i56po.types).string)
}).actions((self)=>({
        add (id) {
            self.list = (0, $i56po.cast)([
                id
            ]);
        },
        remove (id) {
            self.list = (0, $i56po.cast)(self.list?.filter((item)=>item !== id));
        },
        set (requirements) {
            self.list = (0, $i56po.cast)(requirements);
        },
        validate () {
            self.error = null;
            return true;
        }
    })).views((self)=>({
        has (id) {
            return Boolean(self.list?.includes(id));
        }
    }));
function $ccb6750122854e33$export$627c67ab826e12f5(targetInstance) {
    (0, $i56po.addMiddleware)(targetInstance, (call, next, abort)=>{
        if (call.type === "action" && call.args[0] === (0, $39b712c8a7a8ea7b$export$21cdfbdd9a861522).requirements) return abort(targetInstance.requirements.validate());
        return next(call);
    });
}



var $i56po = parcelRequire("i56po");


const $c9c9debe097eccfb$export$baac34607d7ba0da = (0, $i56po.types).model("WorkCategory", {
    id: (0, $i56po.types).maybeNull((0, $i56po.types).number),
    error: (0, $i56po.types).maybeNull((0, $i56po.types).string)
}).views((self)=>({
        get workCategoryId () {
            return self.id;
        }
    })).actions((self)=>({
        set (categoryId) {
            self.id = categoryId;
        },
        validate () {
            if (self.id === null) {
                self.error = (0, $2b1f0855f2f3a952$export$625550452a3fa3ec)("job_draft_details.work_category_required");
                return false;
            }
            self.error = null;
            return true;
        }
    }));
function $c9c9debe097eccfb$export$57c50951bb03e52b(targetInstance) {
    (0, $i56po.addMiddleware)(targetInstance, (call, next, abort)=>{
        if (call.type === "action" && call.args[0] === (0, $39b712c8a7a8ea7b$export$21cdfbdd9a861522).category) return abort(targetInstance.category.validate());
        return next(call);
    });
}



var $i56po = parcelRequire("i56po");


var $262fe7de1e230770$export$e97f944cf44dfd60;
(function(PublicTransportAccessibility) {
    PublicTransportAccessibility[PublicTransportAccessibility["accessible"] = 1] = "accessible";
    PublicTransportAccessibility[PublicTransportAccessibility["notAccessible"] = 2] = "notAccessible";
})($262fe7de1e230770$export$e97f944cf44dfd60 || ($262fe7de1e230770$export$e97f944cf44dfd60 = {}));
const $262fe7de1e230770$export$af17d1d0e4bda836 = (0, $i56po.types).model("TransportAccessibility", {
    value: (0, $i56po.types).maybeNull((0, $i56po.types).number),
    error: (0, $i56po.types).maybeNull((0, $i56po.types).string)
}).views((self)=>({
        get hasError () {
            return self.error !== null;
        }
    })).actions((self)=>({
        set (publicTransportAccessibility) {
            if (publicTransportAccessibility !== null) $262fe7de1e230770$var$checkValueIsInEnum(publicTransportAccessibility);
            self.value = publicTransportAccessibility;
            self.error = null;
        },
        validate () {
            if (self.value === null) {
                self.error = (0, $2b1f0855f2f3a952$export$625550452a3fa3ec)("job_draft_details.transport_accessibility_required");
                return false;
            }
            $262fe7de1e230770$var$checkValueIsInEnum(self.value);
            self.error = null;
            return true;
        }
    }));
function $262fe7de1e230770$var$checkValueIsInEnum(value) {
    if (!Object.values($262fe7de1e230770$export$e97f944cf44dfd60).includes(value)) throw new Error(`Unexpected id ${value} for transport accessibility`);
}
function $262fe7de1e230770$export$5964981bf7a004a3(targetInstance) {
    (0, $i56po.addMiddleware)(targetInstance, (call, next, abort)=>{
        if (call.type === "action" && call.args[0] === (0, $39b712c8a7a8ea7b$export$21cdfbdd9a861522).transport) {
            if (!targetInstance.fields.list.includes((0, $39b712c8a7a8ea7b$export$21cdfbdd9a861522).transport)) return abort(true);
            else return abort(targetInstance.transport.validate());
        }
        return next(call);
    });
}



var $i56po = parcelRequire("i56po");


const $de4e75ce8db41aeb$export$6ce27559f2db7e74 = (0, $i56po.types).model("Location", {
    value: (0, $i56po.types).maybeNull((0, $i56po.types).model({
        id: (0, $i56po.types).number,
        name: (0, $i56po.types).string
    })),
    error: (0, $i56po.types).maybeNull((0, $i56po.types).string)
}).actions((self)=>({
        clearError () {
            self.error = null;
        },
        set (location) {
            self.value = location;
            self.error = null;
        },
        validate () {
            if (self.value === null) {
                self.error = (0, $2b1f0855f2f3a952$export$625550452a3fa3ec)("job_draft_details.location_required");
                return false;
            }
            self.error = null;
            return true;
        }
    }));
function $de4e75ce8db41aeb$export$1720ac7c59c4a873(targetInstance) {
    (0, $i56po.addMiddleware)(targetInstance, (call, next, abort)=>{
        if (call.type === "action" && call.args[0] === (0, $39b712c8a7a8ea7b$export$21cdfbdd9a861522).location) return abort(targetInstance.location.validate());
        return next(call);
    });
}



var $i56po = parcelRequire("i56po");


const $3963ef8c5411d760$export$3b2d79fac574aae2 = (0, $i56po.types).model("Description", {
    value: (0, $i56po.types).maybeNull((0, $i56po.types).string),
    error: (0, $i56po.types).maybeNull((0, $i56po.types).string)
}).views((self)=>({
        get hasError () {
            return self.error !== null;
        }
    })).actions((self)=>({
        set (description) {
            self.value = description;
            self.error = null;
        },
        validate () {
            if (self.value === null || self.value.length < 1) {
                self.error = (0, $2b1f0855f2f3a952$export$625550452a3fa3ec)("job_draft_details.description_required");
                return false;
            } else if (self.value.length > 20000) self.error = (0, $2b1f0855f2f3a952$export$625550452a3fa3ec)("job_draft_details.description_too_long");
            else {
                self.error = null;
                return true;
            }
        }
    }));
function $3963ef8c5411d760$export$9e293848a261fea7(targetInstance) {
    (0, $i56po.addMiddleware)(targetInstance, (call, next, abort)=>{
        if (call.type === "action" && call.args[0] === (0, $39b712c8a7a8ea7b$export$21cdfbdd9a861522).description) return abort(targetInstance.description.validate());
        return next(call);
    });
}



var $i56po = parcelRequire("i56po");


const $8096f3364a23b114$export$8078d4c71537d0dd = (0, $i56po.types).model("Manager", {
    id: (0, $i56po.types).maybeNull((0, $i56po.types).number),
    error: (0, $i56po.types).maybeNull((0, $i56po.types).string)
}).views((self)=>({
        get hasError () {
            return self.error !== null;
        }
    })).actions((self)=>({
        set (id) {
            self.id = id;
            self.error = null;
        },
        validate () {
            if (self.id === null) {
                self.error = (0, $2b1f0855f2f3a952$export$625550452a3fa3ec)("job_draft_details.poc_required");
                return false;
            }
            self.error = null;
            return true;
        }
    }));
function $8096f3364a23b114$export$fce4bdb4f2a2526e(targetInstance) {
    (0, $i56po.addMiddleware)(targetInstance, (call, next, abort)=>{
        if (call.type === "action" && call.args[0] === (0, $39b712c8a7a8ea7b$export$21cdfbdd9a861522).contact) return abort(targetInstance.manager.validate());
        return next(call);
    });
}



var $i56po = parcelRequire("i56po");


var $i56po = parcelRequire("i56po");
const $f62ebabca0bf67f2$export$4a2ba27f19da2665 = (0, $i56po.types).model("SeniorityLevels", {
    levelId: (0, $i56po.types).integer,
    minYears: (0, $i56po.types).maybeNull((0, $i56po.types).integer),
    maxYears: (0, $i56po.types).maybeNull((0, $i56po.types).integer)
});
const $f62ebabca0bf67f2$export$2d1fb1416bb87cf5 = (self)=>({
        getSeniorityLevels: (0, $i56po.flow)(function*(workCategoryId) {
            const seniorityLevels = yield self.request("get", `common/work-categories/${workCategoryId}/seniority-levels`);
            self.workCategorySeniorityLevels.set(String(workCategoryId), seniorityLevels);
        })
    });
const $f62ebabca0bf67f2$export$4248aa50bece1418 = (self)=>({
        getSeniorityLevelById (workCategoryId, levelId) {
            return self.workCategorySeniorityLevels.get(String(workCategoryId))?.filter((item)=>item.levelId === levelId)[0] ?? null;
        }
    });
var $f62ebabca0bf67f2$export$c90b54e658fc4d7c;
(function(Experience) {
    Experience["junior"] = "1";
    Experience["middle"] = "2";
    Experience["senior"] = "3";
    Experience["beginnerOrStudent"] = "4";
})($f62ebabca0bf67f2$export$c90b54e658fc4d7c || ($f62ebabca0bf67f2$export$c90b54e658fc4d7c = {}));



const $1c5622ce8cfef0fe$export$b734afef3d61e1aa = (0, $i56po.types).model("Experience", {
    value: (0, $i56po.types).maybeNull((0, $i56po.types).enumeration("Experience", Object.values((0, $f62ebabca0bf67f2$export$c90b54e658fc4d7c)))),
    error: (0, $i56po.types).maybeNull((0, $i56po.types).string)
}).views((self)=>({
        get hasError () {
            return self.error !== null;
        }
    })).actions((self)=>({
        set (experience) {
            if (experience) $1c5622ce8cfef0fe$var$checkValueIsInEnum(experience);
            self.value = experience;
            self.error = null;
        },
        validate () {
            if (self.value === null) {
                self.error = (0, $2b1f0855f2f3a952$export$625550452a3fa3ec)("job_draft_details.experience_required");
                return false;
            }
            $1c5622ce8cfef0fe$var$checkValueIsInEnum(self.value);
            self.error = null;
            return true;
        }
    }));
function $1c5622ce8cfef0fe$var$checkValueIsInEnum(value) {
    if (!Object.values((0, $f62ebabca0bf67f2$export$c90b54e658fc4d7c)).includes(value)) throw new Error(`Unexpected id ${value} for experience`);
}
function $1c5622ce8cfef0fe$export$748ad72541dfe0fe(targetInstance) {
    (0, $i56po.addMiddleware)(targetInstance, (call, next, abort)=>{
        if (call.type === "action" && call.args[0] === (0, $39b712c8a7a8ea7b$export$21cdfbdd9a861522).experience) return abort(targetInstance.experience.validate());
        return next(call);
    });
}



var $i56po = parcelRequire("i56po");


const $87c7ad4601fc98c0$export$140323cf2cc09f4e = (0, $i56po.types).model("Dresscode", {
    id: (0, $i56po.types).maybeNull((0, $i56po.types).number),
    error: (0, $i56po.types).maybeNull((0, $i56po.types).string)
}).views((self)=>({
        get hasError () {
            return self.error !== null;
        }
    })).actions((self)=>({
        set (id) {
            self.id = id;
            self.error = null;
        },
        validate () {
            if (self.id === null) {
                self.error = (0, $2b1f0855f2f3a952$export$625550452a3fa3ec)("job_draft_details.dresscode_required");
                return false;
            }
            self.error = null;
            return true;
        }
    }));
function $87c7ad4601fc98c0$export$9db3acfc2fdcef75(targetInstance) {
    (0, $i56po.addMiddleware)(targetInstance, (call, next, abort)=>{
        if (call.type === "action" && call.args[0] === (0, $39b712c8a7a8ea7b$export$21cdfbdd9a861522).dresscode) return abort(targetInstance.dresscode.validate());
        return next(call);
    });
}



var $i56po = parcelRequire("i56po");


const $589d5cd371f5a769$export$45cd80e4c48c5df6 = (0, $i56po.types).model("Languages", {
    use_languages: (0, $i56po.types).optional((0, $i56po.types).boolean, false),
    list: (0, $i56po.types).maybeNull((0, $i56po.types).array((0, $i56po.types).number)),
    error: (0, $i56po.types).maybeNull((0, $i56po.types).string)
}).views((self)=>({
        get hasError () {
            return self.error !== null;
        },
        has (id) {
            return Boolean(self.list?.includes(id));
        }
    })).actions((self)=>({
        clear () {
            self.list?.clear();
        }
    })).actions((self)=>({
        add (id) {
            if (self.list) self.list.push(id);
            else self.list = (0, $i56po.cast)([
                id
            ]);
            self.error = null;
        },
        remove (id) {
            self.list = (0, $i56po.cast)(self.list?.filter((item)=>item !== id));
        },
        set (languages) {
            self.list = (0, $i56po.cast)(languages);
            self.error = null;
        },
        useLanguages (languagesRequired) {
            self.use_languages = languagesRequired;
            if (!languagesRequired) self.clear();
            self.error = null;
        },
        validate () {
            if (self.use_languages && (self.list === null || self.list.length === 0)) {
                self.error = (0, $2b1f0855f2f3a952$export$625550452a3fa3ec)("job_draft_details.languages_required");
                return false;
            }
            self.error = null;
            return true;
        }
    }));
function $589d5cd371f5a769$export$caff2727d5eefbe9(targetInstance) {
    (0, $i56po.addMiddleware)(targetInstance, (call, next, abort)=>{
        if (call.type === "action" && call.args[0] === (0, $39b712c8a7a8ea7b$export$21cdfbdd9a861522).languages) return abort(targetInstance.languages.validate());
        return next(call);
    });
}



var $i56po = parcelRequire("i56po");

var $9940b994a7a3bcd1$export$87cdbc5104bfce47;
(function(Genders) {
    Genders["other"] = "0";
    Genders["male"] = "1";
    Genders["female"] = "2";
})($9940b994a7a3bcd1$export$87cdbc5104bfce47 || ($9940b994a7a3bcd1$export$87cdbc5104bfce47 = {}));
const $9940b994a7a3bcd1$export$e8663837bc22bac6 = (0, $i56po.types).model("Gender", {
    use_gender: (0, $i56po.types).optional((0, $i56po.types).boolean, false),
    value: (0, $i56po.types).maybeNull((0, $i56po.types).enumeration("Genders", Object.values($9940b994a7a3bcd1$export$87cdbc5104bfce47))),
    error: (0, $i56po.types).maybeNull((0, $i56po.types).string)
}).views((self)=>({
        get hasError () {
            return self.error !== null;
        }
    })).actions((self)=>({
        set (gender) {
            if (gender !== null) $9940b994a7a3bcd1$var$checkValueIsInEnum(gender);
            self.value = gender;
            self.error = null;
        },
        useGender (genderRequired) {
            self.use_gender = genderRequired;
            if (!genderRequired) self.value = null;
            self.error = null;
        },
        validate () {
            if (self.use_gender && self.value !== null) $9940b994a7a3bcd1$var$checkValueIsInEnum(self.value);
            self.error = null;
            return true;
        }
    }));
function $9940b994a7a3bcd1$var$checkValueIsInEnum(value) {
    if (!Object.values($9940b994a7a3bcd1$export$87cdbc5104bfce47).includes(value)) throw new Error(`Unexpected id ${value} for gender`);
}
function $9940b994a7a3bcd1$export$16df66d991d160b1(targetInstance) {
    (0, $i56po.addMiddleware)(targetInstance, (call, next, abort)=>{
        if (call.type === "action" && call.args[0] === (0, $39b712c8a7a8ea7b$export$21cdfbdd9a861522).gender) return abort(targetInstance.gender.validate());
        return next(call);
    });
}



var $i56po = parcelRequire("i56po");


const $fd45550c396b2386$export$9b3fc1bf5dc4b7c6 = (0, $i56po.types).model("Documents", {
    use_documents: (0, $i56po.types).optional((0, $i56po.types).boolean, false),
    list: (0, $i56po.types).maybeNull((0, $i56po.types).array((0, $i56po.types).number)),
    error: (0, $i56po.types).maybeNull((0, $i56po.types).string)
}).views((self)=>({
        get hasError () {
            return self.error !== null;
        },
        has (id) {
            return Boolean(self.list?.includes(id));
        }
    })).actions((self)=>({
        clear () {
            self.list?.clear();
        }
    })).actions((self)=>({
        useDocuments (documentsRequired) {
            self.use_documents = documentsRequired;
            if (!documentsRequired) self.clear();
            self.error = null;
        },
        add (id) {
            if (self.list) self.list.push(id);
            else self.list = (0, $i56po.cast)([
                id
            ]);
            self.error = null;
        },
        remove (id) {
            self.list = (0, $i56po.cast)(self.list?.filter((item)=>item !== id));
            self.error = null;
        },
        set (documents) {
            self.list = (0, $i56po.cast)(documents);
            self.error = null;
        },
        validate () {
            if (self.use_documents && (self.list === null || self.list.length === 0)) {
                self.error = (0, $2b1f0855f2f3a952$export$625550452a3fa3ec)("job_draft_details.documents_required");
                return false;
            }
            self.error = null;
            return true;
        }
    }));
function $fd45550c396b2386$export$6bb198439341976c(targetInstance) {
    (0, $i56po.addMiddleware)(targetInstance, (call, next, abort)=>{
        if (call.type === "action" && call.args[0] === (0, $39b712c8a7a8ea7b$export$21cdfbdd9a861522).documents) return abort(targetInstance.documents.validate());
        return next(call);
    });
}



var $i56po = parcelRequire("i56po");


const $ce30bba666a32457$export$fafbe2f2f150aa35 = (0, $i56po.types).model("Accreditation", {
    use_accreditation: (0, $i56po.types).optional((0, $i56po.types).boolean, false),
    value: (0, $i56po.types).maybeNull((0, $i56po.types).boolean),
    error: (0, $i56po.types).maybeNull((0, $i56po.types).string)
}).views((self)=>({
        get hasError () {
            return self.error !== null;
        }
    })).actions((self)=>({
        set (requireAccreditation) {
            self.value = requireAccreditation;
            self.error = null;
        },
        useAccreditation (requireAccreditation) {
            self.use_accreditation = requireAccreditation;
            if (!requireAccreditation) self.value = null;
            self.error = null;
        },
        validate () {
            if (self.use_accreditation && self.value === null) {
                self.error = (0, $2b1f0855f2f3a952$export$625550452a3fa3ec)("job_draft_details.accreditation_required");
                return false;
            }
            self.error = null;
            return true;
        }
    }));
function $ce30bba666a32457$export$a8ad1e96f4a33d60(targetInstance) {
    (0, $i56po.addMiddleware)(targetInstance, (call, next, abort)=>{
        if (call.type === "action" && call.args[0] === (0, $39b712c8a7a8ea7b$export$21cdfbdd9a861522).accreditation) return abort(targetInstance.accreditation.validate());
        return next(call);
    });
}



var $i56po = parcelRequire("i56po");


const $0aaa17d83156a379$export$26abd256c2735654 = (0, $i56po.types).model("Accomodation", {
    use_accommodation: (0, $i56po.types).optional((0, $i56po.types).boolean, false),
    value: (0, $i56po.types).maybeNull((0, $i56po.types).boolean),
    error: (0, $i56po.types).maybeNull((0, $i56po.types).string)
}).views((self)=>({
        get hasError () {
            return self.error !== null;
        }
    })).actions((self)=>({
        useAccommodation (accommodationOffered) {
            self.use_accommodation = accommodationOffered;
            self.value = accommodationOffered;
            self.error = null;
        },
        validate () {
            if (self.use_accommodation && self.value === null) {
                self.error = (0, $2b1f0855f2f3a952$export$625550452a3fa3ec)("job_draft_details.accommodation_required");
                return false;
            }
            self.error = null;
            return true;
        }
    }));
function $0aaa17d83156a379$export$ddf1705ea1999477(targetInstance) {
    (0, $i56po.addMiddleware)(targetInstance, (call, next, abort)=>{
        if (call.type === "action" && call.args[0] === (0, $39b712c8a7a8ea7b$export$21cdfbdd9a861522).accommodation) return abort(targetInstance.accommodation.validate());
        return next(call);
    });
}



var $i56po = parcelRequire("i56po");


var $i56po = parcelRequire("i56po");
const $862a04ca6e0d681b$export$8c11478261578efd = (0, $i56po.types).model("Job", {
    id: (0, $i56po.types).identifierNumber,
    title: (0, $i56po.types).string,
    order_id: (0, $i56po.types).number,
    work_category_id: (0, $i56po.types).number,
    quantity: (0, $i56po.types).number,
    instructions: (0, $i56po.types).string,
    start_date: (0, $i56po.types).string,
    end_date: (0, $i56po.types).string,
    uniform_provided: (0, $i56po.types).string,
    job_status: (0, $i56po.types).string,
    job_status_id: (0, $i56po.types).number,
    price: (0, $i56po.types).number,
    currency: (0, $i56po.types).string,
    hours: (0, $i56po.types).number,
    hourly_rate: (0, $i56po.types).number,
    rate_type: (0, $i56po.types).string,
    is_automatic_checkout: (0, $i56po.types).number,
    commission: (0, $i56po.types).number,
    order_name: (0, $i56po.types).string,
    work_category_name: (0, $i56po.types).string,
    shifts_count: (0, $i56po.types).string,
    description: (0, $i56po.types).string,
    event_description: (0, $i56po.types).string,
    fulfilment_rate: (0, $i56po.types).number,
    no_of_completed_shifts: (0, $i56po.types).number,
    client: (0, $i56po.types).model({
        name: (0, $i56po.types).string,
        image_url: (0, $i56po.types).string
    }),
    is_client_rates_allowed: (0, $i56po.types).optional((0, $i56po.types).boolean, false),
    recommended_client_rate: (0, $i56po.types).optional((0, $i56po.types).maybeNull((0, $i56po.types).number), null),
    min_recommended_client_rate: (0, $i56po.types).optional((0, $i56po.types).maybeNull((0, $i56po.types).number), null),
    max_recommended_client_rate: (0, $i56po.types).optional((0, $i56po.types).maybeNull((0, $i56po.types).number), null),
    bottom_client_rate: (0, $i56po.types).optional((0, $i56po.types).maybeNull((0, $i56po.types).number), null),
    top_client_rate: (0, $i56po.types).optional((0, $i56po.types).maybeNull((0, $i56po.types).number), null)
});
const $862a04ca6e0d681b$export$c38f30dcbe2bbd3a = (params)=>{
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const form = {
        filter: {},
        intervals: {}
    };
    for (const [field, value] of Object.entries(params)){
        if (field === "languages") form.filter.languages = params.languages?.length ? params.languages : null;
        else if (field === "gender") form.filter.gender = params.gender;
        else if (field === "certificates") form.filter.certificates = params.certificates?.length ? params.certificates : null;
        else if (field === "work_requirement_ids") form.work_requirement_ids = params.work_requirement_ids ?? null;
        else if (field === "intervals") {
            for (const [day, { start_time: start_time, end_time: end_time, selected: selected }] of params.intervals)if (selected) form.intervals[day] = {
                start_time: start_time,
                end_time: end_time
            };
        } else if (field === "nationalities") {
            form.filter.nationalities = params.nationalities?.length ? params.nationalities : null;
            form.filter.ethnicities = params.ethnicities?.length ? params.ethnicities : null;
        } else form[field] = value;
    }
    return form;
};
const $862a04ca6e0d681b$export$b10bdded6ffd14bc = (self)=>({
        createJob: (0, $i56po.flow)(function*(params) {
            const form = $862a04ca6e0d681b$export$c38f30dcbe2bbd3a(params);
            return yield self.request("post", `client/order/jobs/post`, form);
        }),
        updateJob: (0, $i56po.flow)(function*(params) {
            const form = $862a04ca6e0d681b$export$c38f30dcbe2bbd3a(params);
            return yield self.request("post", "client/order/jobs/update", form);
        }),
        removeJob: (0, $i56po.flow)(function*(params) {
            self.jobs.delete(String(params.jobId));
            yield self.request("post", `client/order/jobs/delete`, {
                job_id: params.jobId
            });
        }),
        setRates: (0, $i56po.flow)(function*({ job_id: job_id, client_rate: client_rate }) {
            yield self.request("post", `client/order/jobs/set-rate`, {
                job_id: job_id,
                client_rate: client_rate
            });
        }),
        getRates: (0, $i56po.flow)(function*({ job_id: job_id }) {
            return yield self.request("post", `client/order/jobs/get-rate`, {
                job_id: job_id
            });
        })
    });
const $862a04ca6e0d681b$export$b88cbba80470a808 = (self)=>({
        getJobsForOrder (orderId) {
            if (!orderId) return [];
            return Array.from(self.jobs.values()).filter((job)=>job.order_id === orderId);
        },
        get jobsList () {
            return Array.from(self.jobs.values());
        }
    });
var $862a04ca6e0d681b$export$3456ae8ade9eb8c;
(function(BoardingStatus) {
    BoardingStatus[BoardingStatus["noBoarding"] = 0] = "noBoarding";
    BoardingStatus[BoardingStatus["halfBoarding"] = 1] = "halfBoarding";
    BoardingStatus[BoardingStatus["fullBoarding"] = 2] = "fullBoarding";
})($862a04ca6e0d681b$export$3456ae8ade9eb8c || ($862a04ca6e0d681b$export$3456ae8ade9eb8c = {}));
var $862a04ca6e0d681b$export$27a7f855854fa13d;
(function(JobScheduleType) {
    JobScheduleType[JobScheduleType["oneTime"] = 0] = "oneTime";
    JobScheduleType[JobScheduleType["recurring"] = 1] = "recurring";
    JobScheduleType[JobScheduleType["permanent"] = 2] = "permanent";
})($862a04ca6e0d681b$export$27a7f855854fa13d || ($862a04ca6e0d681b$export$27a7f855854fa13d = {}));



const $c5a2367b3c7dcffd$export$6bcbdb2ad9229988 = (0, $i56po.types).model("Boarding", {
    use_boarding: (0, $i56po.types).optional((0, $i56po.types).boolean, false),
    value: (0, $i56po.types).maybeNull((0, $i56po.types).number),
    error: (0, $i56po.types).maybeNull((0, $i56po.types).string)
}).views((self)=>({
        get hasError () {
            return self.error !== null;
        }
    })).actions((self)=>({
        set (boardingStatus) {
            $c5a2367b3c7dcffd$var$checkValueIsInEnum(boardingStatus);
            self.value = boardingStatus;
            self.error = null;
        },
        useBoarding (boardingOffered) {
            self.use_boarding = boardingOffered;
            if (!boardingOffered) self.value = null;
            self.error = null;
        },
        validate () {
            if (self.value !== null) $c5a2367b3c7dcffd$var$checkValueIsInEnum(self.value);
            if (self.use_boarding && self.value === null) {
                self.error = (0, $2b1f0855f2f3a952$export$625550452a3fa3ec)("job_draft_details.boarding_required");
                return false;
            }
            self.error = null;
            return true;
        }
    }));
function $c5a2367b3c7dcffd$var$checkValueIsInEnum(value) {
    if (!Object.values((0, $862a04ca6e0d681b$export$3456ae8ade9eb8c)).includes(value)) throw new Error(`Unexpected id ${value} for boarding`);
}
function $c5a2367b3c7dcffd$export$9875411c3aec3df8(targetInstance) {
    (0, $i56po.addMiddleware)(targetInstance, (call, next, abort)=>{
        if (call.type === "action" && call.args[0] === (0, $39b712c8a7a8ea7b$export$21cdfbdd9a861522).boarding) return abort(targetInstance.boarding.validate());
        return next(call);
    });
}



var $i56po = parcelRequire("i56po");


var $2f3b82cb4dad5a8c$export$549bf6aa45c2da5;
(function(AssignmentType) {
    AssignmentType["preApproval"] = "1";
    AssignmentType["autoAccept"] = "2";
    AssignmentType["autoInviteDesignationSP"] = "3";
    AssignmentType["autoInviteClientSP"] = "4";
})($2f3b82cb4dad5a8c$export$549bf6aa45c2da5 || ($2f3b82cb4dad5a8c$export$549bf6aa45c2da5 = {}));
const $2f3b82cb4dad5a8c$export$7d84ec5c01fe828c = (0, $i56po.types).model("ManualTools", {
    use_interview: (0, $i56po.types).optional((0, $i56po.types).boolean, false),
    interview_questions: (0, $i56po.types).maybeNull((0, $i56po.types).array((0, $i56po.types).number)),
    interview_error: (0, $i56po.types).maybeNull((0, $i56po.types).string),
    use_manual_selection: (0, $i56po.types).optional((0, $i56po.types).boolean, false),
    manual_selection: (0, $i56po.types).maybeNull((0, $i56po.types).enumeration("AssignmentType", Object.values($2f3b82cb4dad5a8c$export$549bf6aa45c2da5))),
    manual_selection_error: (0, $i56po.types).maybeNull((0, $i56po.types).string)
}).views((self)=>({
        get hasInterviewError () {
            return self.interview_error !== null;
        },
        get hasManualSelectionError () {
            return self.manual_selection_error !== null;
        },
        hasQuestion (id) {
            return Boolean(self.interview_questions?.includes(id));
        }
    })).actions((self)=>({
        setManualSelection (selectManually) {
            self.manual_selection = selectManually ? "1" : "2";
            if (!selectManually) {
                self.use_interview = false;
                self.interview_questions = null;
            }
            self.manual_selection_error = null;
        }
    })).actions((self)=>({
        useInterview (interviewRequired) {
            self.use_interview = interviewRequired;
            if (interviewRequired) {
                self.use_manual_selection = interviewRequired;
                self.manual_selection = "1";
            } else self.interview_questions = null;
            self.interview_error = null;
        },
        addQuestion (id) {
            if (self.interview_questions) self.interview_questions.push(id);
            else self.interview_questions = (0, $i56po.cast)([
                id
            ]);
            self.interview_error = null;
        },
        removeQuestion (id) {
            self.interview_questions = (0, $i56po.cast)(self.interview_questions?.filter((item)=>item !== id));
            self.interview_error = null;
        },
        setQuestions (ids) {
            self.interview_questions = (0, $i56po.cast)(ids);
            self.interview_error = null;
        },
        validateInterview () {
            if (self.use_interview && (self.interview_questions === null || self.interview_questions.length === 0)) {
                self.interview_error = (0, $2b1f0855f2f3a952$export$625550452a3fa3ec)("job_draft_details.interview_required");
                return false;
            }
            self.interview_error = null;
            return true;
        }
    })).actions((self)=>({
        validate () {
            self.validateInterview();
            return true;
        }
    }));
function $2f3b82cb4dad5a8c$export$96c293e5a7346c28(targetInstance) {
    (0, $i56po.addMiddleware)(targetInstance, (call, next, abort)=>{
        if (call.type === "action" && call.args[0] === (0, $39b712c8a7a8ea7b$export$21cdfbdd9a861522).videoInterviews) return abort(targetInstance.manualSelection.validateInterview());
        return next(call);
    });
}

























var $i56po = parcelRequire("i56po");

const $cdbebd4a48ecd4e9$export$667923abf59f1fec = (0, $i56po.types).model("InvitedSPs", {
    list: (0, $i56po.types).maybeNull((0, $i56po.types).array((0, $i56po.types).number)),
    error: (0, $i56po.types).maybeNull((0, $i56po.types).string)
}).actions((self)=>({
        add (id) {
            if (self.list) self.list.push(id);
            else self.list = (0, $i56po.cast)([
                id
            ]);
        },
        remove (id) {
            self.list = (0, $i56po.cast)(self.list?.filter((item)=>item !== id));
        },
        set (invitedSPs) {
            self.list = (0, $i56po.cast)(invitedSPs);
        },
        validate () {
            self.error = null;
            return true;
        }
    })).views((self)=>({
        has (id) {
            return Boolean(self.list?.includes(id));
        }
    }));
function $cdbebd4a48ecd4e9$export$eeb6d22d0af909d9(targetInstance) {
    (0, $i56po.addMiddleware)(targetInstance, (call, next, abort)=>{
        if (call.type === "action" && call.args[0] === (0, $39b712c8a7a8ea7b$export$21cdfbdd9a861522).invitedSPs) return abort(targetInstance.invitedSPs.validate());
        return next(call);
    });
}



var $i56po = parcelRequire("i56po");

const $2f30ab930b6390a9$export$94217bdfb02e6fe0 = (0, $i56po.types).model("Nationalities", {
    use_nationalities: (0, $i56po.types).optional((0, $i56po.types).boolean, false),
    nationalities_list: (0, $i56po.types).maybeNull((0, $i56po.types).array((0, $i56po.types).number)),
    ethnicities_list: (0, $i56po.types).maybeNull((0, $i56po.types).array((0, $i56po.types).number)),
    allow_any_nationality: (0, $i56po.types).optional((0, $i56po.types).boolean, true),
    error: (0, $i56po.types).maybeNull((0, $i56po.types).string)
}).views((self)=>({
        get hasError () {
            return self.error !== null;
        },
        hasNationality (id) {
            return Boolean(self.nationalities_list?.includes(id));
        },
        hasEthnicity (id) {
            return Boolean(self.ethnicities_list?.includes(id));
        }
    })).actions((self)=>({
        clear () {
            self.nationalities_list?.clear();
            self.ethnicities_list?.clear();
        }
    })).actions((self)=>({
        addNationality (id) {
            if (self.nationalities_list) self.nationalities_list.push(id);
            else self.nationalities_list = (0, $i56po.cast)([
                id
            ]);
            self.error = null;
        },
        addEthnicity (id) {
            if (self.ethnicities_list) self.ethnicities_list.push(id);
            else self.ethnicities_list = (0, $i56po.cast)([
                id
            ]);
            self.error = null;
        },
        removeNationality (id) {
            self.nationalities_list = (0, $i56po.cast)(self.nationalities_list?.filter((item)=>item !== id));
        },
        removeEthnicity (id) {
            self.ethnicities_list = (0, $i56po.cast)(self.ethnicities_list?.filter((item)=>item !== id));
        },
        setNationalities (nationalities) {
            self.nationalities_list = (0, $i56po.cast)(nationalities);
            self.error = null;
        },
        setEthnicities (ethnicities) {
            self.ethnicities_list = (0, $i56po.cast)(ethnicities);
            self.error = null;
        },
        useNationalities (value) {
            self.use_nationalities = value;
            if (!value) self.clear();
            self.error = null;
        },
        setAllowAnyNationality (value) {
            self.allow_any_nationality = value;
        },
        validate () {
            return true;
        }
    }));
function $2f30ab930b6390a9$export$a0cbdcde977436a7(targetInstance) {
    (0, $i56po.addMiddleware)(targetInstance, (call, next, abort)=>{
        if (call.type === "action" && call.args[0] === (0, $39b712c8a7a8ea7b$export$21cdfbdd9a861522).nationalities) return abort(targetInstance.nationalities.validate());
        return next(call);
    });
}


function $aedc6e187ea61ba2$export$d80b89520d9dda7b(toInstance) {
    (0, $ccb6750122854e33$export$627c67ab826e12f5)(toInstance);
    (0, $4ee97a2e5c21154b$export$9fc4593f3c0bc884)(toInstance);
    (0, $c9c9debe097eccfb$export$57c50951bb03e52b)(toInstance);
    (0, $262fe7de1e230770$export$5964981bf7a004a3)(toInstance);
    (0, $de4e75ce8db41aeb$export$1720ac7c59c4a873)(toInstance);
    (0, $7877ded9826ff0ce$export$94e1034eee61e50e)(toInstance);
    (0, $e1f74a26db852f67$export$83b9f4169c544cc2)(toInstance);
    (0, $a9d76bb020691cd5$export$239b624427feacb3)(toInstance);
    (0, $7187cc442ab66cc5$export$f98f8472f3dc850f)(toInstance);
    (0, $3963ef8c5411d760$export$9e293848a261fea7)(toInstance);
    (0, $cdbebd4a48ecd4e9$export$eeb6d22d0af909d9)(toInstance);
    (0, $8096f3364a23b114$export$fce4bdb4f2a2526e)(toInstance);
    (0, $1c5622ce8cfef0fe$export$748ad72541dfe0fe)(toInstance);
    (0, $87c7ad4601fc98c0$export$9db3acfc2fdcef75)(toInstance);
    (0, $589d5cd371f5a769$export$caff2727d5eefbe9)(toInstance);
    (0, $9940b994a7a3bcd1$export$16df66d991d160b1)(toInstance);
    (0, $fd45550c396b2386$export$6bb198439341976c)(toInstance);
    (0, $2f3b82cb4dad5a8c$export$96c293e5a7346c28)(toInstance);
    (0, $ce30bba666a32457$export$a8ad1e96f4a33d60)(toInstance);
    (0, $0aaa17d83156a379$export$ddf1705ea1999477)(toInstance);
    (0, $c5a2367b3c7dcffd$export$9875411c3aec3df8)(toInstance);
    (0, $2f30ab930b6390a9$export$a0cbdcde977436a7)(toInstance);
    (0, $39b712c8a7a8ea7b$export$9e08febd70b7af30)(toInstance);
}







const $dbd014043758bf06$var$DRAFT_JOB = "DraftJob";
const $dbd014043758bf06$export$e7bcefd487eab617 = (0, $i56po.types).model($dbd014043758bf06$var$DRAFT_JOB, {
    id: (0, $i56po.types).identifier,
    existing_job_id: (0, $i56po.types).maybeNull((0, $i56po.types).number),
    duplicated_job_id: (0, $i56po.types).maybeNull((0, $i56po.types).number),
    fields: (0, $i56po.types).optional((0, $39b712c8a7a8ea7b$export$99dfb0d64235688a), {}),
    category: (0, $i56po.types).optional((0, $c9c9debe097eccfb$export$baac34607d7ba0da), {}),
    quantity: (0, $i56po.types).optional((0, $4ee97a2e5c21154b$export$ff080064f5d67c0d), {}),
    transport: (0, $i56po.types).optional((0, $262fe7de1e230770$export$af17d1d0e4bda836), {}),
    location: (0, $i56po.types).optional((0, $de4e75ce8db41aeb$export$6ce27559f2db7e74), {}),
    schedule: (0, $i56po.types).optional((0, $c8d84e5894c5bfbd$export$ec7d5ddad8453d42), {}),
    requirements: (0, $i56po.types).optional((0, $ccb6750122854e33$export$23eb54e04d607842), {}),
    description: (0, $i56po.types).optional((0, $3963ef8c5411d760$export$3b2d79fac574aae2), {}),
    manager: (0, $i56po.types).optional((0, $8096f3364a23b114$export$8078d4c71537d0dd), {}),
    experience: (0, $i56po.types).optional((0, $1c5622ce8cfef0fe$export$b734afef3d61e1aa), {}),
    dresscode: (0, $i56po.types).optional((0, $87c7ad4601fc98c0$export$140323cf2cc09f4e), {}),
    invitedSPs: (0, $i56po.types).optional((0, $cdbebd4a48ecd4e9$export$667923abf59f1fec), {}),
    languages: (0, $i56po.types).optional((0, $589d5cd371f5a769$export$45cd80e4c48c5df6), {}),
    nationalities: (0, $i56po.types).optional((0, $2f30ab930b6390a9$export$94217bdfb02e6fe0), {}),
    gender: (0, $i56po.types).optional((0, $9940b994a7a3bcd1$export$e8663837bc22bac6), {}),
    documents: (0, $i56po.types).optional((0, $fd45550c396b2386$export$9b3fc1bf5dc4b7c6), {}),
    manualSelection: (0, $i56po.types).optional((0, $2f3b82cb4dad5a8c$export$7d84ec5c01fe828c), {}),
    accreditation: (0, $i56po.types).optional((0, $ce30bba666a32457$export$fafbe2f2f150aa35), {}),
    accommodation: (0, $i56po.types).optional((0, $0aaa17d83156a379$export$26abd256c2735654), {}),
    boarding: (0, $i56po.types).optional((0, $c5a2367b3c7dcffd$export$6bcbdb2ad9229988), {}),
    is_automatic_checkout: 1,
    is_validating_form: (0, $i56po.types).optional((0, $i56po.types).boolean, false),
    error: (0, $i56po.types).maybeNull((0, $i56po.types).string)
}).actions((self)=>({
        setDuplicatedJob (id) {
            self.duplicated_job_id = id;
        },
        clear () {
            self.quantity.set(null);
            self.schedule.dateBoundaries.start_date = null;
            self.schedule.dateBoundaries.end_date = null;
            self.schedule.distinctTimeSchedule.removeDates();
            self.schedule.sameTimeSchedule.same_start_time = null;
            self.schedule.sameTimeSchedule.same_end_time = null;
            self.description.set(null);
            self.requirements.set([]);
            self.experience.set(null);
            self.dresscode.set(null);
            self.manager.set(null);
            self.languages.set([]);
            self.gender.set(null);
            self.documents.set([]);
            self.accreditation.set(false);
            self.accommodation.value = false;
            self.boarding.set((0, $862a04ca6e0d681b$export$3456ae8ade9eb8c).noBoarding);
            self.nationalities.setNationalities([]);
            self.nationalities.setEthnicities([]);
            self.nationalities.setAllowAnyNationality(true);
            self.fields.reset();
        },
        // @ts-ignore
        fillBasedOnTemplateJob (templateJob) {
            self.quantity.set(templateJob.quantity.value);
            self.description.set(templateJob.description.value);
            self.requirements = (0, $i56po.clone)(templateJob.requirements);
            self.experience.set(templateJob.experience.value);
            self.dresscode.set(templateJob.dresscode.id);
            self.manager.set(templateJob.manager.id);
            self.languages = (0, $i56po.clone)(templateJob.languages);
            self.gender.set(templateJob.gender.value);
            self.documents = (0, $i56po.clone)(templateJob.documents);
            self.accreditation.set(templateJob.accreditation.value);
            self.accommodation.value = templateJob.accommodation.value;
            self.boarding.set(templateJob.boarding.value);
            const shouldHavePublicTransportField = self.fields.hasField((0, $39b712c8a7a8ea7b$export$21cdfbdd9a861522).transport);
            self.fields = (0, $i56po.clone)(templateJob.fields);
            if (shouldHavePublicTransportField) self.fields.addPublicTransportAccessibilityField();
            else self.fields.removePublicTransportAccessibilityField();
        },
        clearSameTimeFields () {
            self.schedule.sameTimeSchedule.reset();
            self.fields.removeFields((0, $c8d84e5894c5bfbd$export$e5b094170864a75f));
        },
        clearDistinctTimeFields () {
            self.schedule.distinctTimeSchedule.removeDates();
            self.fields.removeFields((0, $c8d84e5894c5bfbd$export$48f94b164c9d6cc2));
        },
        setAllDaysHaveSameTime (shouldUseSameTiming) {
            // The field is already applied, no need to update it again
            if (shouldUseSameTiming === self.schedule.sameTimeSchedule.all_days_have_same_time) return;
            const fieldsToPaste = shouldUseSameTiming ? (0, $c8d84e5894c5bfbd$export$e5b094170864a75f) : (0, $c8d84e5894c5bfbd$export$48f94b164c9d6cc2);
            if (!self.schedule.sameTimeSchedule.didSelectTimingType) /**
         * It's the first time when time field(s) is inserted, there's nothing to replace yet
         * Thus insert the field(s) right after "shiftTimingsPrompt" field
         */ self.fields.insertTimeFields(fieldsToPaste);
            else {
                /**
         * The form already has time field(s).
         * Remove old and paste new fields in place of the old ones.
         */ const firstFieldToRemove = shouldUseSameTiming ? (0, $c8d84e5894c5bfbd$export$48f94b164c9d6cc2)[0] : (0, $c8d84e5894c5bfbd$export$e5b094170864a75f)[0];
                const numberOfFieldsToRemove = shouldUseSameTiming ? (0, $c8d84e5894c5bfbd$export$48f94b164c9d6cc2).length : (0, $c8d84e5894c5bfbd$export$e5b094170864a75f).length;
                const currentTimeFieldIndex = self.fields.list.findIndex((field)=>field === firstFieldToRemove);
                self.fields.list.splice(currentTimeFieldIndex, numberOfFieldsToRemove, ...fieldsToPaste);
            }
            self.schedule.sameTimeSchedule.setIsSameTiming(shouldUseSameTiming);
        },
        validateField (field) {
            // do nothing, the action will be intercepted by relevant store's middleware and return boolean
            throw new Error(`Unexpected invokation of validateField method in the ${$dbd014043758bf06$var$DRAFT_JOB} store`);
        }
    })).actions((self)=>({
        /**
     * Validates the entire form field-by-field
     * Each field puts its own errors and returns a boolean
     * Returns true if all fields return true, false otherwise
     */ validateForm () {
            self.is_validating_form = true;
            const fieldsToValidate = Object.values((0, $39b712c8a7a8ea7b$export$21cdfbdd9a861522)).filter((field)=>field !== (0, $39b712c8a7a8ea7b$export$21cdfbdd9a861522).preferences && field !== (0, $39b712c8a7a8ea7b$export$21cdfbdd9a861522).transport);
            const hasValidationErrors = fieldsToValidate.map(self.validateField).findIndex((isValid)=>!isValid) !== -1;
            console.log(fieldsToValidate.map(self.validateField));
            if (hasValidationErrors) (0, $0c0f53a5cea85ce7$export$efda9a273d7a036d)({
                message: "Job Creation validation errors (frontend)",
                category: "create job form",
                data: (0, $4f362.toJS)(self)
            });
            self.is_validating_form = false;
            return !hasValidationErrors;
        },
        assignApiErrorsToJob (errors) {
            (0, $0c0f53a5cea85ce7$export$efda9a273d7a036d)({
                message: "Job Creation validation errors (API)",
                category: "create job form",
                data: errors
            });
            Object.entries(errors).forEach(([fieldKey, fieldErrors])=>{
                const formattedError = Array.isArray(fieldErrors) ? (0, $9fa563bb6e56262b$export$9c3202b2987ae26b)(fieldErrors) : fieldErrors;
                switch(fieldKey){
                    case "quantity":
                        self.quantity.error = formattedError;
                        break;
                    case "work_category_id":
                        self.category.error = formattedError;
                        break;
                    case "instructions":
                        self.description.error = formattedError;
                        break;
                    case "transportation_rate":
                        self.transport.error = formattedError;
                        break;
                    case "assignment_type":
                        self.manualSelection.manual_selection_error = formattedError;
                        break;
                    case "client_location_id":
                        self.location.error = formattedError;
                        break;
                    case "work_requirement_ids":
                        self.requirements.error = formattedError;
                        break;
                    case "start_date":
                        self.schedule.dateBoundaries.start_date_error = formattedError;
                        break;
                    case "end_date":
                        self.schedule.dateBoundaries.end_date_or_open_ended_error = formattedError;
                        break;
                    case "is_accommodation_offered":
                        self.accommodation.error = formattedError;
                        break;
                    case "is_interview_required":
                        self.manualSelection.interview_error = formattedError;
                        break;
                    case "boarding_type":
                        self.boarding.error = formattedError;
                        break;
                    case "intervals":
                        if (Array.isArray(fieldErrors)) self.schedule.distinctTimeSchedule.error = formattedError;
                        else {
                            let anyError = null;
                            Object.entries(fieldErrors).forEach(([date, dateConfig])=>{
                                const dateInstance = self.schedule.distinctTimeSchedule.map.get(date);
                                if (dateConfig.start_time) dateInstance.start_time_error = dateConfig.start_time.join(", ");
                                if (dateConfig.end_time) dateInstance.end_time_error = dateConfig.end_time.join(", ");
                                anyError = dateInstance.start_time_error ?? dateInstance.end_time_error;
                            });
                            self.schedule.distinctTimeSchedule.error = anyError;
                        }
                        break;
                    case "seniority_level":
                        self.experience.error = formattedError;
                        break;
                    case "filter":
                        const filterErrorsObj = fieldErrors;
                        Object.entries(filterErrorsObj).forEach(([filterKey, filterErrors])=>{
                            const formattedFilterError = (0, $9fa563bb6e56262b$export$9c3202b2987ae26b)(filterErrors);
                            switch(filterKey){
                                case "gender":
                                    self.gender.error = formattedFilterError;
                                    break;
                                case "languages":
                                    self.languages.error = formattedFilterError;
                                    break;
                                case "certificates":
                                    self.documents.error = formattedFilterError;
                                    break;
                                default:
                                    throw new Error(`Unexpected filter validation error: ${filterKey}`);
                            }
                        });
                        break;
                    case "uniform_id":
                        self.dresscode.error = formattedError;
                        break;
                    case "order_id":
                        self.error = formattedError;
                        break;
                    case "contact_user_id":
                        self.manager.error = formattedError;
                        break;
                    default:
                        self.error = formattedError;
                        break;
                }
            });
        }
    }));
function $dbd014043758bf06$export$dc71f78f25dc8d5(snapshot) {
    const instance = $dbd014043758bf06$export$e7bcefd487eab617.create(snapshot);
    (0, $aedc6e187ea61ba2$export$d80b89520d9dda7b)(instance);
    return instance;
}



const $b8bc598510b99881$export$df3a013960f23f75 = (0, $i56po.types).model("DraftJobs", {
    jobs: (0, $i56po.types).map((0, $dbd014043758bf06$export$e7bcefd487eab617))
}).actions((self)=>({
        createDraftJob (job) {
            const jobDraftId = (0, $3fa3ae484854b431$export$2e2bcd8739ae039)();
            const draftJob = (0, $dbd014043758bf06$export$dc71f78f25dc8d5)(job ? {
                ...job,
                id: jobDraftId
            } : {
                id: jobDraftId
            });
            self.jobs.set(jobDraftId, draftJob);
            return draftJob;
        }
    })).views((self)=>({
        getDraftJob (id) {
            const job = self.jobs.get(id);
            (0, $aedc6e187ea61ba2$export$d80b89520d9dda7b)(job);
            return job;
        }
    }));



var $i56po = parcelRequire("i56po");

var $45fvw = parcelRequire("45fvw");
var $dd3a61673d234628$export$4a260f4ad74ba8c2;
(function(ExtensionStep) {
    ExtensionStep[ExtensionStep["ExtensionTypeSelection"] = 0] = "ExtensionTypeSelection";
    ExtensionStep[ExtensionStep["DateSelection"] = 1] = "DateSelection";
})($dd3a61673d234628$export$4a260f4ad74ba8c2 || ($dd3a61673d234628$export$4a260f4ad74ba8c2 = {}));
const $dd3a61673d234628$export$35ea69340b11d51b = 5;
const $dd3a61673d234628$var$JobExtensionModel = (0, $i56po.types).model("JobExtensionModel", {
    id: (0, $i56po.types).identifierNumber,
    location: (0, $i56po.types).string,
    designation: (0, $i56po.types).string,
    staffAmount: (0, $i56po.types).number,
    startTime: (0, $i56po.types).string,
    endTime: (0, $i56po.types).string,
    minExtensionDate: (0, $i56po.types).string,
    minStartDate: (0, $i56po.types).string,
    startDate: (0, $i56po.types).maybeNull((0, $i56po.types).string),
    extensionDate: (0, $i56po.types).maybeNull((0, $i56po.types).string),
    shouldBeExtended: (0, $i56po.types).boolean
});
const $dd3a61673d234628$export$27505c86ef3638fe = (0, $i56po.types).model("OrderExtensionModel", {
    id: (0, $i56po.types).maybeNull((0, $i56po.types).number),
    minStartDateForAllJobs: (0, $i56po.types).maybeNull((0, $i56po.types).string),
    useSameExtensionDateForAllJobs: (0, $i56po.types).boolean,
    extensionStartDateForAllJobs: (0, $i56po.types).maybeNull((0, $i56po.types).string),
    extensionDateForAllJobs: (0, $i56po.types).maybeNull((0, $i56po.types).string),
    extensionStep: (0, $i56po.types).maybeNull((0, $i56po.types).number),
    jobs: (0, $i56po.types).map($dd3a61673d234628$var$JobExtensionModel)
}).actions((self)=>({
        createFromOrderModel (orderModel) {
            self.id = orderModel.id;
            self.minStartDateForAllJobs = (0, (/*@__PURE__*/$parcel$interopDefault($45fvw)))(orderModel.end_date, "YYYY-MM-DD").add(1, "days").format("YYYY-MM-DD");
            orderModel.jobs.forEach((job)=>{
                self.jobs.set(String(job.id), $dd3a61673d234628$var$JobExtensionModel.create({
                    id: job.id,
                    location: job.location_name,
                    designation: job.work_category_name,
                    staffAmount: job.quantity,
                    startTime: job.start_date,
                    endTime: job.end_date,
                    minExtensionDate: job.min_extension_date,
                    shouldBeExtended: true,
                    startDate: null,
                    extensionDate: null,
                    minStartDate: (0, (/*@__PURE__*/$parcel$interopDefault($45fvw)))(job.end_date, "YYYY-MM-DD").add(1, "days").format("YYYY-MM-DD")
                }));
            });
        },
        setUseSameExtensionDateForAllJobs (value) {
            self.useSameExtensionDateForAllJobs = value;
        },
        setExtensionStartDateForAllJobs (value) {
            self.extensionStartDateForAllJobs = value;
        },
        setExtensionDateForAllJobs (value) {
            self.extensionDateForAllJobs = value;
        },
        setExtensionStep (value) {
            self.extensionStep = value;
        },
        goToNextStep () {
            if (self.extensionStep !== null) self.extensionStep++;
        },
        goToPreviousStep () {
            if (self.extensionStep !== null) self.extensionStep--;
        },
        setJobExtensionDate (jobId, extensionDate) {
            const job = self.jobs.get(String(jobId));
            if (job) {
                job.extensionDate = extensionDate;
                const shouldBeExtended = Boolean(extensionDate);
                job.shouldBeExtended = shouldBeExtended;
                if (!shouldBeExtended) job.startDate = null;
            }
        },
        setJobExtensionStartDate (jobId, startDate) {
            const job = self.jobs.get(String(jobId));
            if (job) {
                job.startDate = startDate;
                const shouldBeExtended = Boolean(startDate);
                job.shouldBeExtended = Boolean(startDate);
                if (!shouldBeExtended) job.extensionDate = null;
            }
        },
        clear () {
            self.id = null;
            self.minStartDateForAllJobs = null;
            self.extensionDateForAllJobs = null;
            self.extensionStartDateForAllJobs = null;
            self.extensionStep = 0;
            self.jobs.clear();
        }
    })).views((self)=>({
        get jobsList () {
            return Array.from(self.jobs.values());
        },
        get dataForApiCall () {
            return {
                id: Number(self.id),
                jobsToExtend: Array.from(self.jobs.values()).filter((job)=>self.useSameExtensionDateForAllJobs || job.extensionDate !== null).map((job)=>{
                    return {
                        id: job.id,
                        startDate: self.useSameExtensionDateForAllJobs ? String(self.extensionStartDateForAllJobs) : String(job.startDate),
                        extensionDate: self.useSameExtensionDateForAllJobs ? String(self.extensionDateForAllJobs) : String(job.extensionDate)
                    };
                })
            };
        },
        get jobsForExtensionExist () {
            const jobs = Array.from(self.jobs.values());
            if (self.useSameExtensionDateForAllJobs) return self.extensionStartDateForAllJobs !== null && self.extensionDateForAllJobs !== null;
            return jobs.filter((job)=>job.startDate !== null && job.extensionDate !== null).length > 0;
        },
        get minOrderExtensionDate () {
            const maxTimestamp = Math.max(...Array.from(self.jobs.values()).map((job)=>(0, (/*@__PURE__*/$parcel$interopDefault($45fvw)))(job.minExtensionDate).valueOf()));
            return (0, (/*@__PURE__*/$parcel$interopDefault($45fvw)))(maxTimestamp).format("YYYY-MM-DD");
        }
    }));


let $d6286036be37a1b2$export$9931f407af1661c3 = (0, $b8bc598510b99881$export$df3a013960f23f75).create();
const $d6286036be37a1b2$export$cfb849cb1a33bd13 = "draftJobs";
const $d6286036be37a1b2$var$savedStorageData = (0, $34dcbefa7de5eb80$export$11e63f7b0f3d9900)($d6286036be37a1b2$export$cfb849cb1a33bd13);
if ($d6286036be37a1b2$var$savedStorageData) {
    const json = JSON.parse($d6286036be37a1b2$var$savedStorageData);
    if ((0, $b8bc598510b99881$export$df3a013960f23f75).is(json)) $d6286036be37a1b2$export$9931f407af1661c3 = (0, $b8bc598510b99881$export$df3a013960f23f75).create(json);
}
const $d6286036be37a1b2$var$DraftJobsStoreContext = (0, $acw62.createContext)(null);
const $d6286036be37a1b2$export$65f7aeb92040da96 = $d6286036be37a1b2$var$DraftJobsStoreContext.Provider;
function $d6286036be37a1b2$export$6feca3f67f446ef2() {
    const store = (0, $acw62.useContext)($d6286036be37a1b2$var$DraftJobsStoreContext);
    if (store === null) throw new Error("Store cannot be null, please add a context provider");
    return store;
}
const $d6286036be37a1b2$export$957fdea8025b4555 = (0, $dd3a61673d234628$export$27505c86ef3638fe).create({
    useSameExtensionDateForAllJobs: true,
    extensionStep: Number((0, $dd3a61673d234628$export$4a260f4ad74ba8c2).ExtensionTypeSelection)
});
(0, $i56po.onSnapshot)($d6286036be37a1b2$export$9931f407af1661c3, (snapshot)=>{
    (0, $34dcbefa7de5eb80$export$a1544dad697b423d)($d6286036be37a1b2$export$cfb849cb1a33bd13, JSON.stringify(snapshot));
});





















const $9dbd8b2d97322b81$export$6c746a5570b8b35c = {
    allJobsImg: (parcelRequire("cKmnI")),
    applicantsReviewImg: (parcelRequire("8vIg3")),
    attendanceReviewImg: (parcelRequire("gBUUB")),
    homeImg: (parcelRequire("jZLRF")),
    manageLocationsImg: (parcelRequire("6Q2tT")),
    registerCorporateImg: (parcelRequire("dy8LX")),
    usersImg: (parcelRequire("hjM4b")),
    ordersImg: (parcelRequire("gUHwc")),
    activeOrdersImg: (parcelRequire("9zBTl")),
    allUsersImg: (parcelRequire("jCzbX")),
    closeSideBarImg: (parcelRequire("6LaZs")),
    draftOrdersImg: (parcelRequire("kMouu")),
    favouriteUsersImg: (parcelRequire("kMouu")),
    myStaffUsersImg: (parcelRequire("dtbix")),
    pastOrdersImg: (parcelRequire("8qQHC")),
    starImg: (parcelRequire("d1nVj")),
    invoiceImg: (parcelRequire("68Yas")),
    paymentImg: (parcelRequire("hCzH7"))
};



var $b82c52bd08df11af$exports = {};
$b82c52bd08df11af$exports = new URL("logo-small.824c2555.png", import.meta.url).toString();



var $6LaZs = parcelRequire("6LaZs");
var $3a143bfbcd303fc6$exports = {};
$3a143bfbcd303fc6$exports = new URL("close-sidebar-dark.b459f9bd.svg", import.meta.url).toString();


var $fa428e66cd440bff$exports = {};
$fa428e66cd440bff$exports = new URL("sidebar-toggle.aaa1744e.svg", import.meta.url).toString();




var $i56po = parcelRequire("i56po");
var $0f571f43d43ce782$export$819724757aafc79;
(function(OrderState) {
    OrderState["Unconfirmed"] = "unconfirmed";
    OrderState["Active"] = "active";
    OrderState["Completed"] = "completed";
})($0f571f43d43ce782$export$819724757aafc79 || ($0f571f43d43ce782$export$819724757aafc79 = {}));
const $0f571f43d43ce782$export$7f55036407033923 = (0, $i56po.types).model("ListItemOrder", {
    id: (0, $i56po.types).identifierNumber,
    start_date: (0, $i56po.types).maybeNull((0, $i56po.types).string),
    end_date: (0, $i56po.types).maybeNull((0, $i56po.types).string),
    is_draft: (0, $i56po.types).boolean,
    is_pending_rates_review: (0, $i56po.types).maybeNull((0, $i56po.types).number),
    is_pending_client_approval: (0, $i56po.types).maybeNull((0, $i56po.types).number),
    days_till_end_count: (0, $i56po.types).number,
    jobs: (0, $i56po.types).array((0, $i56po.types).model({
        id: (0, $i56po.types).number,
        work_category_name: (0, $i56po.types).string,
        quantity: (0, $i56po.types).number,
        location_name: (0, $i56po.types).string,
        start_date: (0, $i56po.types).string,
        end_date: (0, $i56po.types).string,
        completeness: (0, $i56po.types).number,
        days_till_end_count: (0, $i56po.types).number,
        min_extension_date: (0, $i56po.types).string
    }))
});
const $0f571f43d43ce782$export$f458f607c63e3159 = (self)=>({
        getOrders: (0, $i56po.flow)(function*(ordersState, locationId, designationId, startDate, endDate, page) {
            if (page === 1) {
                self.order.ordersList.map.clear();
                self.order.ordersList.nextPage = 1;
            }
            const nextPage = self.order.ordersList.nextPage;
            if (nextPage) {
                let url = `client/order/find-by-state/${ordersState}?page=${nextPage}`;
                if (locationId) url += `&location_id=${locationId}`;
                if (designationId) url += `&designation_id=${designationId}`;
                if (startDate) url += `&start_date=${startDate}`;
                if (endDate) url += `&end_date=${endDate}`;
                const { list: list, paginator: paginator } = yield self.request("get", url);
                list.forEach((item)=>{
                    self.order.ordersList.map.set(String(item.id), item);
                });
                self.order.ordersList.nextPage = paginator?.next_page ?? null;
            }
        })
    });
const $0f571f43d43ce782$export$e507873dda3f69c9 = (self)=>({
        get orders () {
            return Array.from(self.order.ordersList.map.values());
        }
    });



var $i56po = parcelRequire("i56po");
var $ace4c335912c9e96$export$999f810846f9d31d;
(function(PaymentStatus) {
    PaymentStatus["Pending"] = "1";
    PaymentStatus["Processing"] = "2";
    PaymentStatus["Completed"] = "3";
    PaymentStatus["Cancelled"] = "4";
    PaymentStatus["Refunded"] = "5";
})($ace4c335912c9e96$export$999f810846f9d31d || ($ace4c335912c9e96$export$999f810846f9d31d = {}));
var $ace4c335912c9e96$export$1672d1da93b9da0f;
(function(LeanStatus) {
    LeanStatus["SUCCESS"] = "SUCCESS";
    LeanStatus["CANCELLED"] = "CANCELLED";
    LeanStatus["ERROR"] = "ERROR";
})($ace4c335912c9e96$export$1672d1da93b9da0f || ($ace4c335912c9e96$export$1672d1da93b9da0f = {}));
var $ace4c335912c9e96$export$c35a3f1cb87c9eaa;
(function(LeanSetupStatus) {
    LeanSetupStatus[LeanSetupStatus["LEAN_SETUP_STATUS_AWAITING_BENEFICIARY_COOL_OFF"] = 1] = "LEAN_SETUP_STATUS_AWAITING_BENEFICIARY_COOL_OFF";
    LeanSetupStatus[LeanSetupStatus["LEAN_SETUP_STATUS_ACTIVE"] = 2] = "LEAN_SETUP_STATUS_ACTIVE";
})($ace4c335912c9e96$export$c35a3f1cb87c9eaa || ($ace4c335912c9e96$export$c35a3f1cb87c9eaa = {}));
var $ace4c335912c9e96$export$ddddacbee104bbf3;
(function(LeanSetupExternalStatus) {
    LeanSetupExternalStatus["ACTIVE"] = "OK";
    LeanSetupExternalStatus["PENDING_BENEFICIARY_COOL_OFF"] = "PENDING_BENEFICIARY_COOL_OFF";
})($ace4c335912c9e96$export$ddddacbee104bbf3 || ($ace4c335912c9e96$export$ddddacbee104bbf3 = {}));
var $ace4c335912c9e96$export$9766185993094fd2;
(function(LeanSecondaryStatus) {
    LeanSecondaryStatus["AWAITING_AUTHORIZATION"] = "AWAITING_AUTHORIZATION";
    LeanSecondaryStatus["ACCEPTED_BY_BANK"] = "ACCEPTED_BY_BANK";
})($ace4c335912c9e96$export$9766185993094fd2 || ($ace4c335912c9e96$export$9766185993094fd2 = {}));
var $ace4c335912c9e96$export$9bde2038e0377af5;
(function(PaymentExternalStatus) {
    PaymentExternalStatus[PaymentExternalStatus["AWAITING_AUTHORIZATION"] = 2] = "AWAITING_AUTHORIZATION";
})($ace4c335912c9e96$export$9bde2038e0377af5 || ($ace4c335912c9e96$export$9bde2038e0377af5 = {}));
var $ace4c335912c9e96$export$1e5507a06cab5709;
(function(CardBrand) {
    CardBrand["Mastercard"] = "mastercard";
    CardBrand["Visa"] = "visa";
})($ace4c335912c9e96$export$1e5507a06cab5709 || ($ace4c335912c9e96$export$1e5507a06cab5709 = {}));
var $ace4c335912c9e96$export$34b52ce9cfcb0a39;
(function(PaymentMethod) {
    PaymentMethod["Card"] = "1";
    PaymentMethod["Lean"] = "2";
    PaymentMethod["Wire"] = "3";
})($ace4c335912c9e96$export$34b52ce9cfcb0a39 || ($ace4c335912c9e96$export$34b52ce9cfcb0a39 = {}));
const $ace4c335912c9e96$export$3f047a646a42be2 = [
    "1",
    "2",
    "3"
];
const $ace4c335912c9e96$export$15d578a12aa13e9c = (0, $i56po.types).model("Invoice", {
    id: (0, $i56po.types).identifierNumber,
    invoice_number: (0, $i56po.types).maybeNull((0, $i56po.types).string),
    status: (0, $i56po.types).number,
    date: (0, $i56po.types).maybeNull((0, $i56po.types).string),
    due_date: (0, $i56po.types).maybeNull((0, $i56po.types).string),
    amount: (0, $i56po.types).number,
    currency_code: (0, $i56po.types).string,
    type: (0, $i56po.types).number
});
const $ace4c335912c9e96$export$eabf9099b179af62 = (0, $i56po.types).model("PaymentItem", {
    id: (0, $i56po.types).identifierNumber,
    payment_number: (0, $i56po.types).string,
    status: (0, $i56po.types).number,
    date: (0, $i56po.types).string,
    due_date: (0, $i56po.types).string,
    amount: (0, $i56po.types).number,
    currency_code: (0, $i56po.types).string,
    invoices_count: (0, $i56po.types).optional((0, $i56po.types).number, 0),
    invoices: (0, $i56po.types).array($ace4c335912c9e96$export$15d578a12aa13e9c),
    type_id: (0, $i56po.types).maybeNull((0, $i56po.types).number),
    fulfilled_at: (0, $i56po.types).maybeNull((0, $i56po.types).string),
    client: (0, $i56po.types).maybeNull((0, $i56po.types).model("Client", {
        email: (0, $i56po.types).string
    })),
    file: (0, $i56po.types).maybeNull((0, $i56po.types).string),
    external_status: (0, $i56po.types).maybeNull((0, $i56po.types).number),
    external_id: (0, $i56po.types).maybeNull((0, $i56po.types).string)
});
const $ace4c335912c9e96$export$f763a8b75993bd76 = (0, $i56po.types).model("SavedCard", {
    id: (0, $i56po.types).identifier,
    card_number_last4: (0, $i56po.types).string,
    brand: (0, $i56po.types).string,
    fingerprint: (0, $i56po.types).string
});
const $ace4c335912c9e96$var$OverdueModel = (0, $i56po.types).model("OverdueModel", {
    amount: (0, $i56po.types).number,
    currency_code: (0, $i56po.types).string,
    payment_id: (0, $i56po.types).maybeNull((0, $i56po.types).number),
    pending_payments_count: (0, $i56po.types).number
});
const $ace4c335912c9e96$export$f2d165df9c67c2a8 = (0, $i56po.types).model("PaymentStore", {
    paymentMethods: (0, $i56po.types).maybeNull((0, $i56po.types).model("PaymentMethods", {
        methods: (0, $i56po.types).array((0, $i56po.types).number),
        cards: (0, $i56po.types).array($ace4c335912c9e96$export$f763a8b75993bd76),
        config: (0, $i56po.types).maybeNull((0, $i56po.types).model({
            lean_setup_completed: (0, $i56po.types).maybeNull((0, $i56po.types).boolean),
            lean_setup_status: (0, $i56po.types).maybeNull((0, $i56po.types).number),
            lean_status_updated_at: (0, $i56po.types).maybeNull((0, $i56po.types).string)
        }))
    })),
    paymentsList: (0, $i56po.types).optional((0, $i56po.types).model({
        map: (0, $i56po.types).map($ace4c335912c9e96$export$eabf9099b179af62),
        nextPage: (0, $i56po.types).optional((0, $i56po.types).maybeNull((0, $i56po.types).number), 1)
    }), {
        map: {},
        nextPage: null
    }),
    currentPayment: (0, $i56po.types).maybeNull($ace4c335912c9e96$export$eabf9099b179af62),
    overdue: (0, $i56po.types).maybeNull($ace4c335912c9e96$var$OverdueModel),
    savedCards: (0, $i56po.types).map($ace4c335912c9e96$export$f763a8b75993bd76)
});
const $ace4c335912c9e96$export$db0db1a13a78f4ba = (self)=>({
        getPaymentsList: (0, $i56po.flow)(function*(paymentStatus, page) {
            if (page === 1) {
                self.payments.paymentsList.map.clear();
                self.payments.paymentsList.nextPage = 1;
            }
            const nextPage = self.payments.paymentsList.nextPage;
            if (nextPage) {
                const { list: list, paginator: paginator } = yield self.request("get", `client/payments?status=${paymentStatus}&page=${nextPage}`);
                list.forEach((item)=>{
                    self.payments.paymentsList.map.set(String(item.id), item);
                });
                self.payments.paymentsList.nextPage = paginator?.next_page ?? null;
            }
        }),
        getPayment: (0, $i56po.flow)(function*(paymentId) {
            const payment = yield self.request("get", `client/payments/${paymentId}`);
            self.payments.currentPayment = $ace4c335912c9e96$export$eabf9099b179af62.create({
                ...payment,
                invoices: payment.invoices.map((invoice)=>invoice)
            });
        }),
        initPaymentIntent: (0, $i56po.flow)(function*(paymentId, paymentMethod) {
            return yield self.request("post", `client/payments/${paymentId}/init-intent`, {
                payment_method: paymentMethod
            });
        }),
        initSetupIntent: (0, $i56po.flow)(function*() {
            return yield self.request("post", "client/payments/create-setup-intent");
        }),
        initLeanPaymentIntent: (0, $i56po.flow)(function*(paymentId, endUserId) {
            const paymentIntent = yield self.request("post", `client/payments/${paymentId}/init-intent`, {
                payment_method: "2"
            });
            return {
                ...paymentIntent,
                endUserId: endUserId,
                paymentId: paymentId
            };
        }),
        processPayment: (0, $i56po.flow)(function*(paymentId, slipFile) {
            yield self.request("post", `client/payments/${paymentId}/process`, slipFile ? {
                slip: slipFile
            } : {}, slipFile ? {
                headers: {
                    "Content-Type": "multipart/form-data"
                }
            } : {});
            return {
                paymentId: paymentId
            };
        }),
        resetPayment: (0, $i56po.flow)(function*(paymentId) {
            yield self.request("post", `client/payments/${paymentId}/reset`);
        }),
        resetPaymentStatus: (0, $i56po.flow)(function*(paymentId) {
            yield self.request("post", `client/payments/${paymentId}/reset-status`);
        }),
        getPaymentMethods: (0, $i56po.flow)(function*(paymentId) {
            self.payments.paymentMethods = yield self.request("get", `client/payments/${paymentId}/payment-methods`);
            return self.payments.paymentMethods;
        }),
        getSavedCards: (0, $i56po.flow)(function*() {
            const response = yield self.request("get", "client/payments/saved-cards");
            const savedCards = response["cards"];
            savedCards.forEach((savedCard)=>{
                self.payments.savedCards.set(String(savedCard.id), savedCard);
            });
        }),
        deleteSavedCard: (0, $i56po.flow)(function*(cardId) {
            self.payments.savedCards.delete(cardId);
            yield self.request("post", `client/payments/delete-card/${cardId}`);
        }),
        getOverdue: (0, $i56po.flow)(function*() {
            self.payments.overdue = yield self.request("get", "client/payments/overdue");
        }),
        initLeanClient: (0, $i56po.flow)(function*() {
            const data = yield self.request("post", "client/payments/init-client", {
                payment_method: Number("2")
            });
            return data;
        }),
        initLeanClientForPayment: (0, $i56po.flow)(function*(paymentId, externalId) {
            const data = yield self.request("post", "client/payments/init-client", {
                payment_method: Number("2")
            });
            return {
                ...data,
                paymentId: paymentId,
                externalId: externalId
            };
        }),
        setPaymentExternalStatus: function(paymentId, externalStatus) {
            if (self.payments.currentPayment) self.payments.currentPayment.external_status = externalStatus;
            const paymentItem = self.payments.paymentsList.map.get(String(paymentId));
            if (paymentItem) paymentItem.external_status = externalStatus;
        },
        setPaymentExternalId: function(paymentId, externalId) {
            if (self.payments.currentPayment) self.payments.currentPayment.external_id = externalId;
            const paymentItem = self.payments.paymentsList.map.get(String(paymentId));
            if (paymentItem) paymentItem.external_id = externalId;
        },
        setPaymentStatus: function(paymentId, status) {
            if (self.payments.currentPayment) self.payments.currentPayment.status = status;
            const paymentItem = self.payments.paymentsList.map.get(String(paymentId));
            if (paymentItem) paymentItem.status = status;
        },
        setLeanSetupStatus: function(status) {
            if (self.payments.paymentMethods?.config) self.payments.paymentMethods.config.lean_setup_status = status;
        },
        setLeanSetupStatusUpdatedAt: function(updatedAt) {
            if (self.payments.paymentMethods?.config) self.payments.paymentMethods.config.lean_status_updated_at = updatedAt;
        }
    });
const $ace4c335912c9e96$export$4a24d597afab22e1 = (self)=>({
        get paymentsList () {
            return Array.from(self.payments.paymentsList.map.values());
        },
        get currentPayment () {
            return self.payments.currentPayment;
        },
        get paymentMethods () {
            return self.payments.paymentMethods;
        },
        get cards () {
            const addedCards = new Set();
            return self.payments.paymentMethods?.cards.filter((card)=>{
                if (addedCards.has(card.fingerprint)) return false;
                addedCards.add(card.fingerprint);
                return true;
            }) ?? [];
        },
        get overdue () {
            return self.payments.overdue;
        },
        get savedCards () {
            return Array.from(self.payments.savedCards.values());
        }
    });








var $acw62 = parcelRequire("acw62");
function $8e804a82739c7971$export$6cfc2d1b06699e89(Component, config) {
    return class Boundary extends (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Component {
        static getDerivedStateFromError(error) {
            return {
                error: error
            };
        }
        render() {
            return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)(Component, {
                error: this.state.error,
                resetError: this.reset,
                children: this.props.children
            });
        }
        constructor(...args){
            super(...args);
            this.state = {
                error: null
            };
            this.componentDidCatch = config?.didCatch;
            this.reset = ()=>this.setState({
                    error: null
                });
        }
    };
}



const $a4963babae245ff9$var$defaultErrorMessages = {
    [(0, $9ad33fbf770c55a1$export$9696fcf1798e1cb5).ServerError]: "error_boundary.default.server_error",
    [(0, $9ad33fbf770c55a1$export$9696fcf1798e1cb5).PermissionError]: "error_boundary.default.permission_error",
    [(0, $9ad33fbf770c55a1$export$9696fcf1798e1cb5).ClientError]: "error_boundary.default.client_error",
    [(0, $9ad33fbf770c55a1$export$9696fcf1798e1cb5).NotFound]: "error_boundary.default.not_found_error",
    [(0, $9ad33fbf770c55a1$export$9696fcf1798e1cb5).AuthError]: "error_boundary.default.not_authorized_error",
    [(0, $9ad33fbf770c55a1$export$9696fcf1798e1cb5).ConnectionError]: "error_boundary.default.connection_error",
    [(0, $9ad33fbf770c55a1$export$9696fcf1798e1cb5).TooManyRequestsError]: "error_boundary.default.too_many_requests_error"
};
const $a4963babae245ff9$var$defaultErrorTypesToCatch = [
    (0, $9ad33fbf770c55a1$export$9696fcf1798e1cb5).ServerError,
    (0, $9ad33fbf770c55a1$export$9696fcf1798e1cb5).ConnectionError,
    (0, $9ad33fbf770c55a1$export$9696fcf1798e1cb5).ClientError,
    (0, $9ad33fbf770c55a1$export$9696fcf1798e1cb5).TooManyRequestsError
];
function $a4963babae245ff9$export$f0c7a449e0cfaec7(Component, apiErrorMessages, messageToAlwaysShow, errorTypesToCatch = $a4963babae245ff9$var$defaultErrorTypesToCatch, ignoreComponentOnError = false) {
    const ErrorBoundary = (0, $8e804a82739c7971$export$6cfc2d1b06699e89)((props)=>{
        const { t: t } = (0, $3765cebd031b52c0$export$9fc83ad70ead8663)();
        const error = props.error;
        if (error !== null) {
            if (error instanceof (0, $9ad33fbf770c55a1$export$f2e832acab1bdd79)) {
                if (errorTypesToCatch.includes(error.type)) {
                    const errorMessage = // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
                    messageToAlwaysShow ?? (apiErrorMessages ? apiErrorMessages[error.type] : null) ?? $a4963babae245ff9$var$defaultErrorMessages[error.type] ?? "error_boundary.default.default_error";
                    if (!ignoreComponentOnError) (0, $60f27fc97e29822a$export$b410431fab84fa58).error(t(errorMessage), {
                        onClick: props.resetError
                    });
                    return null;
                }
            }
        }
        return props.children;
    }, {
        didCatch: (error, errorInfo)=>{
            if (error instanceof (0, $9ad33fbf770c55a1$export$f2e832acab1bdd79)) {
                if (!errorTypesToCatch.includes(error.type)) throw error;
                return (0, $0c0f53a5cea85ce7$export$9e0ff99299d29cce)(error, errorInfo);
            }
            throw error;
        }
    });
    return function BoundaryWrapper(props) {
        return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)(ErrorBoundary, {
            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)(Component, {
                ...props
            })
        });
    };
}



var $kLorN = parcelRequire("kLorN");



var $acw62 = parcelRequire("acw62");
var $21cb684f7af51aab$exports = {};
$21cb684f7af51aab$exports = new URL("scanner.58a27a2e.svg", import.meta.url).toString();




var $acw62 = parcelRequire("acw62");
const $392d2c14aa582458$var$initialUIState = {
    isRtl: false,
    showHelpButton: true,
    setShowHelpButton: (value)=>{},
    showPendingPaymentsPanel: true,
    setShowPendingPaymentsPanel: (value)=>{},
    showQRScanner: false,
    setShowQRScanner: (value)=>{}
};
const $392d2c14aa582458$export$9e7c8e903bb56df9 = /*#__PURE__*/ (0, $acw62.createContext)($392d2c14aa582458$var$initialUIState);
const $392d2c14aa582458$export$68e3991a9ee3f43c = ({ isRtl: isRtl, children: children })=>{
    const [showHelpButton, setShowHelpButton] = (0, $acw62.useState)(true);
    const [showPendingPaymentsPanel, setShowPendingPaymentsPanel] = (0, $acw62.useState)(true);
    const [showQRScanner, setShowQRScanner] = (0, $acw62.useState)(false);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($392d2c14aa582458$export$9e7c8e903bb56df9.Provider, {
        value: {
            isRtl: isRtl,
            showHelpButton: showHelpButton,
            setShowHelpButton: setShowHelpButton,
            showPendingPaymentsPanel: showPendingPaymentsPanel,
            setShowPendingPaymentsPanel: setShowPendingPaymentsPanel,
            showQRScanner: showQRScanner,
            setShowQRScanner: setShowQRScanner
        },
        children: children
    });
};



const $d836dbae630d7085$export$d96d49503bc30c36 = ({ style: style, textStyle: textStyle })=>{
    const { t: t } = (0, $3765cebd031b52c0$export$9fc83ad70ead8663)();
    const { setShowQRScanner: setShowQRScanner } = (0, $acw62.useContext)((0, $392d2c14aa582458$export$9e7c8e903bb56df9));
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("button", {
        className: "ScanQRButton",
        onClick: ()=>setShowQRScanner(true),
        style: style,
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                src: (0, (/*@__PURE__*/$parcel$interopDefault($21cb684f7af51aab$exports)))
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                style: textStyle,
                children: t("qr_scan.scan_qr")
            })
        ]
    });
};



const $862384c1dc0db62b$var$defaultUserMenu = [
    {
        title: "sidebar.register_corporate",
        route: (0, $0534349ae8731d0b$export$66b32f6f30eb4b4).completeRegistration,
        imgSource: (0, $9dbd8b2d97322b81$export$6c746a5570b8b35c).registerCorporateImg,
        allowedRoles: [
            (0, $97fa7686fb8e51ed$export$eb3485a690c2f0b8).Admin,
            (0, $97fa7686fb8e51ed$export$eb3485a690c2f0b8).Owner
        ]
    },
    {
        title: "sidebar.manage_locations",
        route: (0, $0534349ae8731d0b$export$66b32f6f30eb4b4).locations,
        imgSource: (0, $9dbd8b2d97322b81$export$6c746a5570b8b35c).manageLocationsImg,
        allowedRoles: [
            (0, $97fa7686fb8e51ed$export$eb3485a690c2f0b8).Admin,
            (0, $97fa7686fb8e51ed$export$eb3485a690c2f0b8).Owner
        ]
    },
    {
        title: "sidebar.users",
        route: (0, $0534349ae8731d0b$export$66b32f6f30eb4b4).users,
        imgSource: (0, $9dbd8b2d97322b81$export$6c746a5570b8b35c).usersImg,
        allowedRoles: [
            (0, $97fa7686fb8e51ed$export$eb3485a690c2f0b8).Admin,
            (0, $97fa7686fb8e51ed$export$eb3485a690c2f0b8).Owner
        ]
    },
    {
        title: "sidebar.knowledge_center",
        route: (0, $0534349ae8731d0b$export$66b32f6f30eb4b4).knowledgeCenter,
        imgSource: (0, $9dbd8b2d97322b81$export$6c746a5570b8b35c).registerCorporateImg,
        allowedRoles: [
            (0, $97fa7686fb8e51ed$export$eb3485a690c2f0b8).Admin,
            (0, $97fa7686fb8e51ed$export$eb3485a690c2f0b8).Owner,
            (0, $97fa7686fb8e51ed$export$eb3485a690c2f0b8).Manager,
            (0, $97fa7686fb8e51ed$export$eb3485a690c2f0b8).Finance
        ]
    }
];
const $862384c1dc0db62b$export$1ba59dacbcbf90fe = (0, $a4963babae245ff9$export$f0c7a449e0cfaec7)((0, $aca50e9407ba89c9$export$b6ae1bc530f4c149)(({ active: active, setActive: setActive })=>{
    const redirect = (0, $7df35e9df335b1c8$export$602eaf6d5314ce55)();
    const { companyDetails: companyDetails, "get\u0421ompanyDetails": get\u0421ompanyDetails, statistics: statistics, getStatistics: getStatistics } = (0, $4671947198ddd366$export$6ccbb43953eebf8)().data;
    (0, $4671947198ddd366$export$dd0a697e1782aedd)(get\u0421ompanyDetails);
    (0, $4671947198ddd366$export$dd0a697e1782aedd)(getStatistics);
    const isCorporate = Boolean(companyDetails?.is_corporate);
    const isCorporateDetailsIncomplete = isCorporate && (0, $kLorN.CLIENT_STATUSES_ALLOWED_TO_CHANGE_CORPORATE_DETAILS).includes(Number(companyDetails?.status_id));
    const showRegisterCorporateMenuItem = !isCorporate || isCorporateDetailsIncomplete;
    const accountMenuItems = (0, $acw62.useMemo)(()=>{
        return $862384c1dc0db62b$var$defaultUserMenu.filter((menuItem)=>showRegisterCorporateMenuItem || menuItem.route !== (0, $0534349ae8731d0b$export$66b32f6f30eb4b4).completeRegistration);
    }, [
        showRegisterCorporateMenuItem
    ]);
    const hideInvoices = (0, $acw62.useMemo)(()=>!(0, $73ccb33f5de6f5aa$export$8707029d024490c9)().finance.showInvoices, []);
    const toggle = ()=>setActive(!active);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                onClick: toggle,
                src: (0, (/*@__PURE__*/$parcel$interopDefault($fa428e66cd440bff$exports))),
                className: "toggleImg"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: `Sidebar ${active ? "mobile-active" : "desktop-collapsed"}`,
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "desktop",
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                            className: "Sidebar__desktop-header",
                            children: active ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                                        onClick: ()=>{
                                            redirect((0, $0534349ae8731d0b$export$66b32f6f30eb4b4).index, {});
                                        },
                                        src: (0, (/*@__PURE__*/$parcel$interopDefault($3279ad32455be7ff$exports))),
                                        alt: "app logo",
                                        className: "Sidebar__desktop-header__app-logo"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                                        onClick: toggle,
                                        src: (0, (/*@__PURE__*/$parcel$interopDefault($6LaZs))),
                                        alt: "menu button",
                                        className: "Sidebar__header__close-sidebar-img"
                                    })
                                ]
                            }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                                        src: (0, (/*@__PURE__*/$parcel$interopDefault($b82c52bd08df11af$exports))),
                                        alt: "",
                                        className: "Sidebar__desktop-header__app-logo-small"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                                        onClick: toggle,
                                        src: (0, (/*@__PURE__*/$parcel$interopDefault($3a143bfbcd303fc6$exports))),
                                        alt: "menu button",
                                        className: "Sidebar__header__app-logo"
                                    })
                                ]
                            })
                        })
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "Sidebar__mobile-container",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                className: "Sidebar__mobile-inner-container mobile",
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                    className: "Sidebar__mobile-inner-container__header",
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                                            src: (0, (/*@__PURE__*/$parcel$interopDefault($3279ad32455be7ff$exports))),
                                            alt: "app logo",
                                            className: "Sidebar__mobile-app-logo"
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                                            onClick: toggle,
                                            src: (0, (/*@__PURE__*/$parcel$interopDefault($6LaZs))),
                                            alt: "",
                                            className: "MobileSidebar__close-sidebar-img"
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $404cf9ad665a992a$export$e21e2be31f67ad59), {}),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $660b2ca422e0e2ae$export$1ff3c3f08ae963c0).Vertical, {
                                height: 15
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4ae5ab5371178941$export$f01b3d7c7bbe3997), {
                                allowedRoles: [
                                    (0, $97fa7686fb8e51ed$export$eb3485a690c2f0b8).Admin,
                                    (0, $97fa7686fb8e51ed$export$eb3485a690c2f0b8).Owner,
                                    (0, $97fa7686fb8e51ed$export$eb3485a690c2f0b8).Manager,
                                    (0, $97fa7686fb8e51ed$export$eb3485a690c2f0b8).Finance
                                ],
                                showDefaultFallbackUI: false,
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $d6286036be37a1b2$export$65f7aeb92040da96), {
                                    value: (0, $d6286036be37a1b2$export$9931f407af1661c3),
                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        className: "Sidebar__inner-container",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4349266f95d58365$export$32030c589b013e3c), {}),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $d836dbae630d7085$export$d96d49503bc30c36), {
                                                style: {
                                                    width: "100%",
                                                    marginTop: "10px",
                                                    padding: "10px 0"
                                                },
                                                textStyle: {
                                                    fontSize: "16px",
                                                    fontWeight: "400"
                                                }
                                            })
                                        ]
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $660b2ca422e0e2ae$export$1ff3c3f08ae963c0).Vertical, {
                                height: 15
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b811929e1c110dae$export$49229ebf838c159b), {
                                items: [
                                    {
                                        title: "sidebar.home",
                                        route: (0, $0534349ae8731d0b$export$66b32f6f30eb4b4).index,
                                        imgSource: (0, $9dbd8b2d97322b81$export$6c746a5570b8b35c).homeImg,
                                        allowedRoles: [
                                            (0, $97fa7686fb8e51ed$export$eb3485a690c2f0b8).Admin,
                                            (0, $97fa7686fb8e51ed$export$eb3485a690c2f0b8).Owner,
                                            (0, $97fa7686fb8e51ed$export$eb3485a690c2f0b8).Finance,
                                            (0, $97fa7686fb8e51ed$export$eb3485a690c2f0b8).Manager
                                        ]
                                    }
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                className: "mobile",
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $660b2ca422e0e2ae$export$1ff3c3f08ae963c0).Vertical, {
                                    height: 9
                                })
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b811929e1c110dae$export$49229ebf838c159b), {
                                    sectionTitle: "sidebar.orders_uppercase",
                                    items: [
                                        {
                                            title: "sidebar.all_jobs",
                                            route: (0, $0534349ae8731d0b$export$66b32f6f30eb4b4).allJobs,
                                            params: {
                                                date: (0, $ddf12117b815a7c3$export$efb113ee57e9edfb)(new Date())
                                            },
                                            imgSource: (0, $9dbd8b2d97322b81$export$6c746a5570b8b35c).allJobsImg,
                                            allowedRoles: [
                                                (0, $97fa7686fb8e51ed$export$eb3485a690c2f0b8).Admin,
                                                (0, $97fa7686fb8e51ed$export$eb3485a690c2f0b8).Owner,
                                                (0, $97fa7686fb8e51ed$export$eb3485a690c2f0b8).Manager
                                            ]
                                        },
                                        {
                                            title: "sidebar.rating_requests",
                                            route: (0, $0534349ae8731d0b$export$66b32f6f30eb4b4).jobRatingRequests,
                                            imgSource: (0, $9dbd8b2d97322b81$export$6c746a5570b8b35c).starImg,
                                            allowedRoles: [
                                                (0, $97fa7686fb8e51ed$export$eb3485a690c2f0b8).Admin,
                                                (0, $97fa7686fb8e51ed$export$eb3485a690c2f0b8).Owner,
                                                (0, $97fa7686fb8e51ed$export$eb3485a690c2f0b8).Manager
                                            ],
                                            counter: Number(statistics?.pending_ratings_count)
                                        },
                                        {
                                            title: "staff.past_workers",
                                            route: (0, $0534349ae8731d0b$export$66b32f6f30eb4b4).pastWorkers,
                                            imgSource: (0, $9dbd8b2d97322b81$export$6c746a5570b8b35c).applicantsReviewImg,
                                            allowedRoles: [
                                                (0, $97fa7686fb8e51ed$export$eb3485a690c2f0b8).Admin,
                                                (0, $97fa7686fb8e51ed$export$eb3485a690c2f0b8).Owner,
                                                (0, $97fa7686fb8e51ed$export$eb3485a690c2f0b8).Manager
                                            ]
                                        },
                                        {
                                            title: "sidebar.attendance_review",
                                            route: (0, $0534349ae8731d0b$export$66b32f6f30eb4b4).attendanceShiftsList,
                                            imgSource: (0, $9dbd8b2d97322b81$export$6c746a5570b8b35c).attendanceReviewImg,
                                            allowedRoles: [
                                                (0, $97fa7686fb8e51ed$export$eb3485a690c2f0b8).Admin,
                                                (0, $97fa7686fb8e51ed$export$eb3485a690c2f0b8).Owner,
                                                (0, $97fa7686fb8e51ed$export$eb3485a690c2f0b8).Manager,
                                                (0, $97fa7686fb8e51ed$export$eb3485a690c2f0b8).Finance
                                            ]
                                        },
                                        {
                                            title: "sidebar.orders",
                                            route: (0, $0534349ae8731d0b$export$66b32f6f30eb4b4).orders,
                                            params: {
                                                ordersState: (0, $0f571f43d43ce782$export$819724757aafc79).Unconfirmed
                                            },
                                            imgSource: (0, $9dbd8b2d97322b81$export$6c746a5570b8b35c).ordersImg,
                                            allowedRoles: [
                                                (0, $97fa7686fb8e51ed$export$eb3485a690c2f0b8).Admin,
                                                (0, $97fa7686fb8e51ed$export$eb3485a690c2f0b8).Owner,
                                                (0, $97fa7686fb8e51ed$export$eb3485a690c2f0b8).Manager,
                                                (0, $97fa7686fb8e51ed$export$eb3485a690c2f0b8).Finance
                                            ]
                                        },
                                        {
                                            title: "sidebar.applicants_review",
                                            route: (0, $0534349ae8731d0b$export$66b32f6f30eb4b4).applicantsReview,
                                            imgSource: (0, $9dbd8b2d97322b81$export$6c746a5570b8b35c).applicantsReviewImg,
                                            allowedRoles: [
                                                (0, $97fa7686fb8e51ed$export$eb3485a690c2f0b8).Admin,
                                                (0, $97fa7686fb8e51ed$export$eb3485a690c2f0b8).Owner,
                                                (0, $97fa7686fb8e51ed$export$eb3485a690c2f0b8).Manager
                                            ]
                                        },
                                        {
                                            title: "sidebar.disputes",
                                            route: (0, $0534349ae8731d0b$export$66b32f6f30eb4b4).disputes,
                                            imgSource: (0, $9dbd8b2d97322b81$export$6c746a5570b8b35c).invoiceImg,
                                            allowedRoles: [
                                                (0, $97fa7686fb8e51ed$export$eb3485a690c2f0b8).Admin,
                                                (0, $97fa7686fb8e51ed$export$eb3485a690c2f0b8).Owner,
                                                (0, $97fa7686fb8e51ed$export$eb3485a690c2f0b8).Manager
                                            ]
                                        }
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4ae5ab5371178941$export$f01b3d7c7bbe3997), {
                                allowedRoles: [
                                    (0, $97fa7686fb8e51ed$export$eb3485a690c2f0b8).Admin,
                                    (0, $97fa7686fb8e51ed$export$eb3485a690c2f0b8).Owner,
                                    (0, $97fa7686fb8e51ed$export$eb3485a690c2f0b8).Finance
                                ],
                                showDefaultFallbackUI: false,
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b811929e1c110dae$export$49229ebf838c159b), {
                                        sectionTitle: "sidebar.billing",
                                        items: [
                                            ...hideInvoices ? [] : [
                                                {
                                                    title: "sidebar.invoices",
                                                    route: (0, $0534349ae8731d0b$export$66b32f6f30eb4b4).invoices,
                                                    imgSource: (0, $9dbd8b2d97322b81$export$6c746a5570b8b35c).invoiceImg,
                                                    allowedRoles: [
                                                        (0, $97fa7686fb8e51ed$export$eb3485a690c2f0b8).Admin,
                                                        (0, $97fa7686fb8e51ed$export$eb3485a690c2f0b8).Owner,
                                                        (0, $97fa7686fb8e51ed$export$eb3485a690c2f0b8).Finance
                                                    ]
                                                }
                                            ],
                                            {
                                                title: "sidebar.payments",
                                                route: (0, $0534349ae8731d0b$export$66b32f6f30eb4b4).paymentList,
                                                params: {
                                                    paymentStatus: String((0, $ace4c335912c9e96$export$999f810846f9d31d).Pending)
                                                },
                                                imgSource: (0, $9dbd8b2d97322b81$export$6c746a5570b8b35c).paymentImg,
                                                allowedRoles: [
                                                    (0, $97fa7686fb8e51ed$export$eb3485a690c2f0b8).Admin,
                                                    (0, $97fa7686fb8e51ed$export$eb3485a690c2f0b8).Owner,
                                                    (0, $97fa7686fb8e51ed$export$eb3485a690c2f0b8).Finance
                                                ]
                                            },
                                            {
                                                title: "sidebar.payment_methods",
                                                route: (0, $0534349ae8731d0b$export$66b32f6f30eb4b4).savedPaymentMethods,
                                                imgSource: (0, $9dbd8b2d97322b81$export$6c746a5570b8b35c).invoiceImg,
                                                allowedRoles: [
                                                    (0, $97fa7686fb8e51ed$export$eb3485a690c2f0b8).Admin,
                                                    (0, $97fa7686fb8e51ed$export$eb3485a690c2f0b8).Owner,
                                                    (0, $97fa7686fb8e51ed$export$eb3485a690c2f0b8).Finance
                                                ]
                                            }
                                        ]
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b811929e1c110dae$export$49229ebf838c159b), {
                                sectionTitle: "sidebar.account",
                                items: accountMenuItems
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                onClick: toggle,
                className: "Sidebar__overlay-foreground"
            })
        ]
    });
}), {
    [(0, $9ad33fbf770c55a1$export$9696fcf1798e1cb5).ServerError]: "sidebar.error_failed_to_load_sidebar"
});




var $acw62 = parcelRequire("acw62");







var $45fvw = parcelRequire("45fvw");

var $acw62 = parcelRequire("acw62");

var $ec5358cfa55bb1e3$exports = {};
$ec5358cfa55bb1e3$exports = new URL("bell.cfb96305.svg", import.meta.url).toString();



const $fec47df4ab20e4ba$var$getTimeFormatted = (seconds)=>{
    const notificationDate = new Date(seconds * 1000);
    const notificationMomentDate = (0, (/*@__PURE__*/$parcel$interopDefault($45fvw)))(notificationDate);
    const currentMomentDate = (0, (/*@__PURE__*/$parcel$interopDefault($45fvw)))(new Date());
    const isNotificationDateToday = notificationMomentDate.isSame(currentMomentDate, "day");
    if (isNotificationDateToday) return (0, (/*@__PURE__*/$parcel$interopDefault($45fvw)))(notificationDate).format("hh:mm a");
    return (0, (/*@__PURE__*/$parcel$interopDefault($45fvw)))(notificationDate).format("YYYY-MM-DD hh:mm a");
};
const $fec47df4ab20e4ba$export$cbcaa222b8817b56 = ({ title: title, description: description, url: url, secondsSinceNotification: secondsSinceNotification, onClick: onClick })=>{
    const notificationContent = /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $acw62.Fragment), {
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "NotificationItem__left",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                    src: (0, (/*@__PURE__*/$parcel$interopDefault($ec5358cfa55bb1e3$exports)))
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $660b2ca422e0e2ae$export$1ff3c3f08ae963c0).Horizontal, {
                width: 15
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "NotificationItem__center",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                        className: "NotificationItem__center__title",
                        children: title
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                        className: "NotificationItem__center__subtitle",
                        dangerouslySetInnerHTML: {
                            __html: description
                        }
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $660b2ca422e0e2ae$export$1ff3c3f08ae963c0).Horizontal, {
                width: 15
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "NotificationItem__right",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                    className: "NotificationItem__center__subtitle",
                    children: $fec47df4ab20e4ba$var$getTimeFormatted(secondsSinceNotification)
                })
            })
        ]
    });
    if (url === null) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        className: "NotificationItem",
        children: notificationContent
    });
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("a", {
        href: url,
        onClick: onClick,
        className: "NotificationItem",
        children: notificationContent
    });
};




const $57fb8f45c69e1681$export$b08b517936747730 = ()=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        className: "loader-container",
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
            className: "loadingio-spinner-eclipse-zqbi37icss9",
            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "ldio-28vulqui936",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {})
            })
        })
    });
var $57fb8f45c69e1681$export$2e2bcd8739ae039 = $57fb8f45c69e1681$export$b08b517936747730;



var $da1f8dcd382c855c$exports = {};
$da1f8dcd382c855c$exports = new URL("notification-bell.7250bce3.svg", import.meta.url).toString();


var $643036c0178b7628$exports = {};
$643036c0178b7628$exports = new URL("unread-indicator.eac0cb04.svg", import.meta.url).toString();


var $84fec7f2054de8d5$exports = {};
$84fec7f2054de8d5$exports = new URL("cross.5334afee.svg", import.meta.url).toString();




const $078111f863688379$export$8a92d876e077621 = (0, $a4963babae245ff9$export$f0c7a449e0cfaec7)((0, $aca50e9407ba89c9$export$b6ae1bc530f4c149)(()=>{
    const [active, setActive] = (0, $acw62.useState)(false);
    const { notification: notification, notifications: notifications, fetchNotifications: fetchNotifications, readNotification: readNotification, getUnreadNotificationsCount: getUnreadNotificationsCount, isMoreNotifications: isMoreNotifications } = (0, $4671947198ddd366$export$6ccbb43953eebf8)().data;
    const notificationQuery = (0, $4671947198ddd366$export$dd0a697e1782aedd)(()=>fetchNotifications({
            page: 1
        }));
    (0, $4671947198ddd366$export$dd0a697e1782aedd)(getUnreadNotificationsCount, {
        filterError: [
            (0, $9ad33fbf770c55a1$export$9696fcf1798e1cb5).ClientError,
            (0, $9ad33fbf770c55a1$export$9696fcf1798e1cb5).NotFound,
            (0, $9ad33fbf770c55a1$export$9696fcf1798e1cb5).ConnectionError,
            (0, $9ad33fbf770c55a1$export$9696fcf1798e1cb5).ServerError
        ]
    });
    const [, requestReadNotification] = (0, $4671947198ddd366$export$609860bf8b0084c)(readNotification, {
        filterError: [
            (0, $9ad33fbf770c55a1$export$9696fcf1798e1cb5).ClientError,
            (0, $9ad33fbf770c55a1$export$9696fcf1798e1cb5).NotFound,
            (0, $9ad33fbf770c55a1$export$9696fcf1798e1cb5).ConnectionError
        ]
    });
    const [loadMoreNotificationsResult, loadMoreNotifications] = (0, $4671947198ddd366$export$609860bf8b0084c)(fetchNotifications);
    const { t: t } = (0, $3765cebd031b52c0$export$9fc83ad70ead8663)();
    const toggleVisibility = ()=>{
        setActive((prevState)=>!prevState);
    };
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                onClick: toggleVisibility,
                className: "NotificationsBar__bell-container",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                        src: (0, (/*@__PURE__*/$parcel$interopDefault($da1f8dcd382c855c$exports)))
                    }),
                    notification.unreadCount > 0 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                        src: (0, (/*@__PURE__*/$parcel$interopDefault($643036c0178b7628$exports))),
                        className: "NotificationsBar__bell-container__bell-indicator"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, (/*@__PURE__*/$parcel$interopDefault($81292b5b491156fc$exports))), {
                isOpen: active,
                onRequestClose: ()=>{
                    setActive(false);
                },
                closeTimeoutMS: 400,
                className: "NotificationsBar",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "NotificationsBar__header",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                className: "NotificationsBar__header__title",
                                children: [
                                    t("notifications.title"),
                                    " ",
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                        className: "NotificationsBar__header__title__amount",
                                        children: [
                                            "(",
                                            notification.unreadCount,
                                            ")"
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                                src: (0, (/*@__PURE__*/$parcel$interopDefault($84fec7f2054de8d5$exports))),
                                onClick: toggleVisibility,
                                className: "NotificationsBar__header__close-img"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $660b2ca422e0e2ae$export$1ff3c3f08ae963c0).Vertical, {
                        height: 25
                    }),
                    !notificationQuery.isLoading && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                        children: [
                            notifications.map((notificationItem)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $fec47df4ab20e4ba$export$cbcaa222b8817b56), {
                                    title: notificationItem.subject,
                                    description: notificationItem.message,
                                    url: notificationItem.url,
                                    secondsSinceNotification: notificationItem.date,
                                    onClick: ()=>{
                                        requestReadNotification(notificationItem.id);
                                    }
                                }, notificationItem.id)),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $660b2ca422e0e2ae$export$1ff3c3f08ae963c0).Vertical, {
                                height: 28
                            }),
                            loadMoreNotificationsResult.isLoading ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $57fb8f45c69e1681$export$2e2bcd8739ae039), {}) : notifications.length > 0 && isMoreNotifications ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                className: "NotificationsBar__loadMoreButton",
                                onClick: ()=>loadMoreNotifications({}),
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                    className: "NotificationsBar__loadMoreButton__label",
                                    children: t("notifications.load_more")
                                })
                            }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                className: "NotificationsBar__noNotifications",
                                children: notifications.length > 0 ? t("notifications.no_more_notifications") : t("notifications.no_notifications_yet")
                            })
                        ]
                    })
                ]
            })
        ]
    });
}), {
    [(0, $9ad33fbf770c55a1$export$9696fcf1798e1cb5).ServerError]: "notifications.error_failed_to_load_notifications"
});















var $acw62 = parcelRequire("acw62");
const $04012d5b0475752e$export$e44a253a59704894 = ({ outerComponent: outerComponent, items: items, hideMenuOnItemClick: hideMenuOnItemClick = false })=>{
    const [isContentVisible, setIsContentVisible] = (0, $acw62.useState)(false);
    if (items.length === 0) return null;
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "DropdownMenu",
        onMouseOver: ()=>setIsContentVisible(true),
        onMouseOut: ()=>setIsContentVisible(false),
        children: [
            outerComponent,
            isContentVisible && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("ul", {
                className: "DropdownMenu__content",
                onClick: ()=>{
                    if (hideMenuOnItemClick) setIsContentVisible(false);
                },
                children: items.map((item, index)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("li", {
                        className: "DropdownMenu__item",
                        children: item
                    }, index))
            })
        ]
    });
};



var $i56po = parcelRequire("i56po");



var $bsQZT = parcelRequire("bsQZT");

var $bsQZT = parcelRequire("bsQZT");
const $78389efdabbe964c$export$9a65832edee28fa6 = {
    url: (0, $bsQZT.config).API_URL,
    timeout: 40000,
    lang: "en-us",
    refreshURL: "client/auth/refresh"
};





var $i56po = parcelRequire("i56po");
const $c58d6738097efc6a$var$InvoicePaymentModel = (0, $i56po.types).model("InvoicePayment", {
    id: (0, $i56po.types).identifierNumber,
    payment_number: (0, $i56po.types).string,
    type_id: (0, $i56po.types).maybeNull((0, $i56po.types).number),
    due_date: (0, $i56po.types).string,
    amount: (0, $i56po.types).number,
    status: (0, $i56po.types).number,
    currency_code: (0, $i56po.types).string
});
const $c58d6738097efc6a$export$6c0d5a83c7b8801f = (0, $i56po.types).model("InvoiceDetailsModel", {
    id: (0, $i56po.types).identifierNumber,
    invoice_number: (0, $i56po.types).maybeNull((0, $i56po.types).string),
    status: (0, $i56po.types).number,
    date: (0, $i56po.types).maybeNull((0, $i56po.types).string),
    due_date: (0, $i56po.types).maybeNull((0, $i56po.types).string),
    currency_code: (0, $i56po.types).string,
    total_amount: (0, $i56po.types).number,
    sub_total_amount: (0, $i56po.types).number,
    tax_percentage: (0, $i56po.types).maybeNull((0, $i56po.types).number),
    total_tax_amount: (0, $i56po.types).number,
    total_transportation_amount: (0, $i56po.types).number,
    payment: (0, $i56po.types).maybeNull($c58d6738097efc6a$var$InvoicePaymentModel),
    items: (0, $i56po.types).array((0, $i56po.types).model({
        id: (0, $i56po.types).number,
        order_id: (0, $i56po.types).maybeNull((0, $i56po.types).number),
        title: (0, $i56po.types).maybeNull((0, $i56po.types).string),
        location: (0, $i56po.types).string,
        total_shifts: (0, $i56po.types).number,
        total_hours: (0, $i56po.types).number,
        total_sps: (0, $i56po.types).number,
        sps: (0, $i56po.types).array((0, $i56po.types).model({
            id: (0, $i56po.types).number,
            full_name: (0, $i56po.types).string,
            image_url: (0, $i56po.types).string,
            shifts_count: (0, $i56po.types).maybeNull((0, $i56po.types).number),
            hours: (0, $i56po.types).maybeNull((0, $i56po.types).number),
            earnings: (0, $i56po.types).maybeNull((0, $i56po.types).number)
        }))
    }))
});
var $c58d6738097efc6a$export$57fb8c26bdd292d0;
(function(InvoiceStatusType) {
    InvoiceStatusType[InvoiceStatusType["Draft"] = 1] = "Draft";
    InvoiceStatusType[InvoiceStatusType["Sent"] = 2] = "Sent";
    InvoiceStatusType[InvoiceStatusType["Paid"] = 3] = "Paid";
    InvoiceStatusType[InvoiceStatusType["Delayed"] = 4] = "Delayed";
    InvoiceStatusType[InvoiceStatusType["Blocked"] = 5] = "Blocked";
    InvoiceStatusType[InvoiceStatusType["Processed"] = 6] = "Processed";
    InvoiceStatusType[InvoiceStatusType["Voided"] = 7] = "Voided";
})($c58d6738097efc6a$export$57fb8c26bdd292d0 || ($c58d6738097efc6a$export$57fb8c26bdd292d0 = {}));
var $c58d6738097efc6a$export$d9ed4832cbd2bab3;
(function(InvoiceType) {
    InvoiceType[InvoiceType["BillingInvoice"] = 1] = "BillingInvoice";
    InvoiceType[InvoiceType["SalesInvoice"] = 2] = "SalesInvoice";
    InvoiceType[InvoiceType["CreditNote"] = 3] = "CreditNote";
    InvoiceType[InvoiceType["BillingCreditNote"] = 4] = "BillingCreditNote";
})($c58d6738097efc6a$export$d9ed4832cbd2bab3 || ($c58d6738097efc6a$export$d9ed4832cbd2bab3 = {}));
const $c58d6738097efc6a$export$bf24389781b8fcdd = [
    2,
    5,
    4
];
const $c58d6738097efc6a$export$15d578a12aa13e9c = (0, $i56po.types).model("InvoiceModel", {
    id: (0, $i56po.types).identifierNumber,
    invoice_number: (0, $i56po.types).maybeNull((0, $i56po.types).string),
    status: (0, $i56po.types).number,
    date: (0, $i56po.types).maybeNull((0, $i56po.types).string),
    due_date: (0, $i56po.types).maybeNull((0, $i56po.types).string),
    total_amount: (0, $i56po.types).number,
    currency_code: (0, $i56po.types).string,
    order_ids: (0, $i56po.types).array((0, $i56po.types).number)
});
const $c58d6738097efc6a$export$895e46a089a55afc = (0, $i56po.types).model("InvoiceStoreModel", {
    map: (0, $i56po.types).map($c58d6738097efc6a$export$15d578a12aa13e9c),
    detailsMap: (0, $i56po.types).map($c58d6738097efc6a$export$6c0d5a83c7b8801f),
    nextPage: (0, $i56po.types).optional((0, $i56po.types).maybeNull((0, $i56po.types).number), 1)
});
const $c58d6738097efc6a$export$81162ff1b7fa6b4b = (self)=>({
        getInvoices: (0, $i56po.flow)(function*(pointOfContactId, locationId, designationId, dateFrom, dateTo, orderId, isOverdue, page) {
            if (page === 1) {
                self.invoices.map.clear();
                self.invoices.nextPage = 1;
            }
            const nextPage = self.invoices.nextPage;
            if (nextPage) {
                let url = `client/invoices?page=${nextPage}`;
                if (pointOfContactId) url += `&poc_id=${pointOfContactId}`;
                if (locationId) url += `&location_id=${locationId}`;
                if (designationId) url += `&designation_id=${designationId}`;
                if (dateFrom) url += `&date_from=${dateFrom}`;
                if (dateTo) url += `&date_to=${dateTo}`;
                if (orderId) url += `&order_id=${orderId}`;
                if (isOverdue) url += `&is_overdue=${Number(isOverdue)}`;
                const { list: invoicesList, paginator: paginator } = yield self.request("get", url);
                invoicesList.forEach((invoice)=>{
                    self.invoices.map.set(String(invoice.id), invoice);
                });
                self.invoices.nextPage = paginator.next_page;
            }
        }),
        getInvoice: (0, $i56po.flow)(function*(id) {
            const invoiceWithDetails = yield self.request("get", `client/invoices/${id}`);
            self.invoices.detailsMap.set(String(id), invoiceWithDetails);
        }),
        getInvoiceJobShfits: (0, $i56po.flow)(function*(params) {
            return yield self.request("get", `client/invoice-items/${params.invoiceItemId}/shifts/${params.ogrammerId}`);
        }),
        downloadInvoice: (0, $i56po.flow)(function*(id) {
            return yield self.request("get", `client/invoices/${id}/download`, undefined, {
                responseType: "blob"
            });
        }),
        reportIssue: (0, $i56po.flow)(function*(params) {
            yield self.request("post", `client/invoices/${params.id}/issue`, {
                message: params.message
            });
        })
    });
const $c58d6738097efc6a$export$cea948f728596db6 = (self)=>({
        get invoiceList () {
            return Array.from(self.invoices.map.values());
        },
        getInvoiceDetails (id) {
            return self.invoices.detailsMap.get(id);
        },
        getInvoicesByStatus (statusId) {
            return Array.from(self.invoices.map.values()).filter((item)=>item.status === statusId);
        }
    });



// TODO: fix ts-issues
// @ts-nocheck
const $0dfe3399c688b02f$var$managers = [
    {
        email: "bar@foo",
        id: 1,
        locations: [],
        first_name: "Donald",
        last_name: "Trump",
        job_role: "manager",
        status: "active",
        phone: "2423424"
    },
    {
        email: "foo@bar",
        id: 2,
        locations: [],
        first_name: "John",
        last_name: "Fride",
        phone: "1231412",
        status: "active",
        job_role: "manager"
    }
];
const $0dfe3399c688b02f$var$loginData = {
    id: "439392e4-f32c-4ea1-8c5d-f739877cl222",
    token: "23a803fa627c006eb0ddca6d660c7684",
    name: "Artur",
    account_type: "C",
    is_basic_info_complete: true,
    is_corporate_details_complete: false
};
const $0dfe3399c688b02f$var$profile = {
    id: 123,
    first_name: "Artur",
    last_name: "Mukminov",
    email: "client1@gmail.com",
    phone: "01000700386",
    image: "https://www.drupal.org/files/user-pictures/picture-54136-1489672154.jpg",
    total_jobs_count: 10,
    inprogress_jobs_count: 5,
    unpaid_invoices_count: 3,
    rating_request_count: 2
};
const $0dfe3399c688b02f$var$ok = {
    status: "ok",
    message: "ok"
};
const $0dfe3399c688b02f$var$location1 = {
    id: 1,
    address: "Indianapolis, IN 46225",
    address_details: "1903 Winifred Way ",
    image: null,
    delete_image: 0,
    lat: 37.4,
    lng: -122,
    name: "Home",
    region: "USA",
    is_georestriction_large: false,
    is_georestriction_disabled: false
};
const $0dfe3399c688b02f$var$location2 = {
    id: 2,
    address: "581 Oxford Court",
    address_details: "Amory, MS 38821",
    image: null,
    delete_image: 0,
    lat: 0,
    lng: 0,
    name: "Work",
    region: "USA",
    is_georestriction_large: false,
    is_georestriction_disabled: false
};
const $0dfe3399c688b02f$var$locations = [
    $0dfe3399c688b02f$var$location1,
    $0dfe3399c688b02f$var$location2
];
const $0dfe3399c688b02f$var$companyDetails = {
    company_name: "Google",
    address: "1600 Amphitheatre Parkway",
    region_id: 1,
    is_corporate: 0,
    is_document_complete: 0,
    is_pocs_created: 0,
    po_box: "01000700386",
    finance_first_name: "Ivan",
    finance_last_name: "Volovikov",
    trade_name: "",
    free_zone: "",
    license_number: "",
    is_lpo_required: 0,
    is_sla_accepted: 0,
    finance_extension: null,
    finance_email: "inbox@google.com",
    status_id: 1,
    trade: null,
    vat: "http://134.209.26.2:88/dashboard/images/avatar_client.png",
    finance_phone: "+1 (123) 345-23-23",
    is_custom_sla: 0
};
const $0dfe3399c688b02f$var$ratingRequests = {
    list: [
        {
            id: 1,
            title: "Mock Admin Assistant job",
            client_address: "Abu Dhabi",
            start_date: "2021-03-03",
            end_date: "2021-03-05",
            sp_max_quantity: 3
        },
        {
            id: 2,
            title: "Mock Waiter job",
            client_address: "Dubai",
            start_date: "2022-02-02",
            end_date: "2022-02-04",
            sp_max_quantity: 5
        }
    ]
};
const $0dfe3399c688b02f$var$uniforms = [
    {
        id: 1,
        name: "We will provide uniform for service providers.",
        description: "",
        image_url: "https://encrypted-tbn0.gstatic.com/images?q=tbn%3AANd9GcQMd5xgHHeTRsvHE7IPrNqKMfZkRtsC2ySQWG2jLIf85hTHBht_&usqp=CAU"
    },
    {
        id: 2,
        name: "Formal",
        description: "black trousers/ Black shirt/ Black shoes",
        image_url: "https://5.imimg.com/data5/OY/RK/QJ/SELLER-43660254/mens-formal-uniform-250x250.jpg"
    },
    {
        id: 3,
        name: "Formal white",
        description: "black trousers/ white shirt",
        image_url: "https://4.imimg.com/data4/JO/RK/MY-20259882/mens-college-uniforms-250x250.jpg"
    },
    {
        id: 3,
        name: "Casual",
        description: "Jeans/ white shirt",
        image_url: "https://i.pinimg.com/474x/13/d2/dc/13d2dc9225a59b99af73c4fed295df08--restaurant-uniforms-casual.jpg"
    }
];
const $0dfe3399c688b02f$var$professions = [
    {
        "id": 1,
        "name": "Accountant",
        "image": "http://134.209.26.2:88/professions/Accountant-1.png",
        "description": "Description",
        "job_description": "Job description"
    },
    {
        "id": 2,
        "name": "Actor",
        "image": "http://134.209.26.2:88/professions/actor-1.png",
        "description": "Description",
        "job_description": "Job description"
    },
    {
        "id": 3,
        "name": "Admin Assistant",
        "image": "http://134.209.26.2:88/professions/Admin-Assistant-1.png",
        "description": "Description",
        "job_description": "Job description"
    },
    {
        "id": 4,
        "name": "Barback",
        "image": "http://134.209.26.2:88/professions/barber.png",
        "description": "Description",
        "job_description": "Job description"
    },
    {
        "id": 5,
        "name": "Barista",
        "image": "http://134.209.26.2:88/professions/barista-1.png",
        "description": "Description",
        "job_description": "Job description"
    },
    {
        "id": 6,
        "name": "Bartender",
        "image": "http://134.209.26.2:88/professions/bouncer-1.png",
        "description": "Description",
        "job_description": "Job description"
    }
];
const $0dfe3399c688b02f$var$jobs = [];
const $0dfe3399c688b02f$var$unpaidInvoices = {
    list: [
        {
            id: 1,
            date: "2020-02-25",
            due_date: "2020-02-25",
            total_amount: 200,
            currency_code: "USD",
            invoice_number: "33",
            status: 2
        }
    ]
};
const $0dfe3399c688b02f$var$paidInvoices = {
    list: [
        {
            id: 1,
            date: "2020-02-25",
            due_date: "2020-02-25",
            total_amount: 200,
            currency_code: "USD",
            invoice_number: "34",
            status: 3
        }
    ]
};
const $0dfe3399c688b02f$var$invoiceWithDetails = {
    id: 3,
    invoice_number: "33",
    currency_code: "AED",
    status: 2,
    date: "2020-05-05",
    due_date: "2020-05-12",
    total_amount: 450
};
const $0dfe3399c688b02f$var$sps = {
    list: []
};
const $0dfe3399c688b02f$export$91bfd9bdbb33b473 = {
    managers: $0dfe3399c688b02f$var$managers,
    locations: $0dfe3399c688b02f$var$locations,
    logedIn: $0dfe3399c688b02f$var$loginData,
    profile: $0dfe3399c688b02f$var$profile,
    companyDetails: $0dfe3399c688b02f$var$companyDetails,
    ratingRequests: $0dfe3399c688b02f$var$ratingRequests,
    uniforms: $0dfe3399c688b02f$var$uniforms,
    professions: $0dfe3399c688b02f$var$professions,
    jobs: $0dfe3399c688b02f$var$jobs,
    ok: $0dfe3399c688b02f$var$ok,
    unpaidInvoices: $0dfe3399c688b02f$var$unpaidInvoices,
    paidInvoices: $0dfe3399c688b02f$var$paidInvoices,
    invoiceWithDetails: $0dfe3399c688b02f$var$invoiceWithDetails,
    sps: $0dfe3399c688b02f$var$sps
};


class $33bc0fc4aa1801f1$export$a8aac3f35099abd7 extends (0, $447a9f947dafe1f5$export$bf71da7aebe9ddc1) {
    constructor(/** Configurable options.*/ config = (0, $78389efdabbe964c$export$9a65832edee28fa6)){
        super();
        this.config = config;
        this.isLogged = false;
        this.id = 10;
    }
    sleep(ms) {
        return new Promise((resolve)=>setTimeout(resolve, ms));
    }
    response(config, status, data) {
        return this.sleep(300).then(()=>{
            const res = {
                status: status,
                data: JSON.parse(JSON.stringify(data)),
                headers: {}
            };
            return res;
        });
    }
    error(config, status, data) {
        return this.response(config, status, data);
    }
    /**
   * Send an API call
   * @param config
   */ async request(config) {
        if (!config.url?.match(/client\/auth/) && config.url !== "client/forgot_password" && !this.isLogged) return this.error(config, 401, {
            code: "token_invalid",
            message: "Invalid token"
        });
        switch((0, $dacbeb7af41d49ec$export$16841e8ae6ecdfed)(config.url)){
            case "client/auth/login":
                // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
                if (config.data.email !== "client1@gmail.com" || config.data.password !== "password") return this.error(config, 400, {
                    code: "invalid_login",
                    message: "Please enter correct email and password"
                });
                this.isLogged = true;
                return this.response(config, 200, (0, $0dfe3399c688b02f$export$91bfd9bdbb33b473).logedIn);
            case "client/auth/logout":
                this.isLogged = false;
                return this.response(config, 200, (0, $0dfe3399c688b02f$export$91bfd9bdbb33b473).ok);
            case "client/profile/summary":
                return this.response(config, 200, (0, $0dfe3399c688b02f$export$91bfd9bdbb33b473).profile);
            case "client/profile/basic/update":
                (0, $0dfe3399c688b02f$export$91bfd9bdbb33b473).profile = config.data;
                return this.response(config, 200, (0, $0dfe3399c688b02f$export$91bfd9bdbb33b473).profile);
            case "client/attendance_managers":
                if (config.method === "post") {
                    const man = config.data;
                    const newData = {
                        ...man,
                        id: this.id++
                    };
                    (0, $0dfe3399c688b02f$export$91bfd9bdbb33b473).managers.push(newData);
                    return this.response(config, 200, (0, $0dfe3399c688b02f$export$91bfd9bdbb33b473).ok);
                }
                return this.response(config, 200, (0, $0dfe3399c688b02f$export$91bfd9bdbb33b473).managers);
            case "client/attendance_managers/1":
                if (config.method === "put") {
                    const man = config.data;
                    (0, $0dfe3399c688b02f$export$91bfd9bdbb33b473).managers[0] = man;
                }
                return this.response(config, 200, (0, $0dfe3399c688b02f$export$91bfd9bdbb33b473).managers[0]);
            case "client/attendance_managers/2":
                return this.response(config, 200, (0, $0dfe3399c688b02f$export$91bfd9bdbb33b473).managers[1]);
            case "client/locations":
                if (config.method === "post") {
                    (0, $0dfe3399c688b02f$export$91bfd9bdbb33b473).locations.push(config.data);
                    return this.response(config, 200, {});
                }
                return this.response(config, 200, (0, $0dfe3399c688b02f$export$91bfd9bdbb33b473).locations);
            case "client/locations/1":
                if (config.method === "put") (0, $0dfe3399c688b02f$export$91bfd9bdbb33b473).locations[0] = config.data;
                return this.response(config, 200, (0, $0dfe3399c688b02f$export$91bfd9bdbb33b473).locations[0]);
            case "client/locations/2":
                if (config.method === "delete") {
                    (0, $0dfe3399c688b02f$export$91bfd9bdbb33b473).locations.pop();
                    return this.response(config, 200, {});
                }
                if (config.method === "put") (0, $0dfe3399c688b02f$export$91bfd9bdbb33b473).locations[1] = config.data;
                return this.response(config, 200, (0, $0dfe3399c688b02f$export$91bfd9bdbb33b473).locations[1]);
            case "client/profile/company_details":
                return this.response(config, 200, (0, $0dfe3399c688b02f$export$91bfd9bdbb33b473).companyDetails);
            case "client/profile/company_details/update":
                (0, $0dfe3399c688b02f$export$91bfd9bdbb33b473).companyDetails = config.data;
                return this.response(config, 200, {});
            case "client/rating/request_list":
                return this.response(config, 200, (0, $0dfe3399c688b02f$export$91bfd9bdbb33b473).ratingRequests);
            case "client/rating/submit":
                $33bc0fc4aa1801f1$var$removeById((0, $0dfe3399c688b02f$export$91bfd9bdbb33b473).ratingRequests.list, config.data.id);
                return this.response(config, 200, {});
            case "client/rating/skip":
                $33bc0fc4aa1801f1$var$removeById((0, $0dfe3399c688b02f$export$91bfd9bdbb33b473).ratingRequests.list, config.data.id);
                return this.response(config, 200, {});
            case "common/uniform":
                return this.response(config, 200, (0, $0dfe3399c688b02f$export$91bfd9bdbb33b473).uniforms);
            case "common/professions":
                return this.response(config, 200, (0, $0dfe3399c688b02f$export$91bfd9bdbb33b473).professions);
            case "client/order/basic/post":
                return this.response(config, 200, {
                    order_id: $33bc0fc4aa1801f1$var$nextId++
                });
            case "client/order/jobs/get":
                return this.response(config, 200, (0, $0dfe3399c688b02f$export$91bfd9bdbb33b473).jobs);
            case "client/order/jobs/post":
                $33bc0fc4aa1801f1$var$add((0, $0dfe3399c688b02f$export$91bfd9bdbb33b473).jobs, config.data);
                return this.response(config, 200, {});
            case "client/order/jobs/update":
                $33bc0fc4aa1801f1$var$updateById((0, $0dfe3399c688b02f$export$91bfd9bdbb33b473).jobs, config.data);
                return this.response(config, 200, {});
            case "client/order/jobs/delete":
                $33bc0fc4aa1801f1$var$removeById((0, $0dfe3399c688b02f$export$91bfd9bdbb33b473).jobs, config.data.id);
                return this.response(config, 200, {});
            case "client/auth/signup":
                return this.response(config, 200, {});
            case "client/forgot_password":
                return this.response(config, 200, {});
            case "client/auth/resend_email_verification":
                return this.response(config, 200, {});
            case "client/auth/social_signup":
                this.isLogged = true;
                return this.response(config, 200, {});
            case "client/auth/verifyemail/foobar":
                this.isLogged = true;
                return this.response(config, 200, {});
            case "client/invoices":
                const responseData = config.data.statusId === (0, $c58d6738097efc6a$export$57fb8c26bdd292d0).Sent ? (0, $0dfe3399c688b02f$export$91bfd9bdbb33b473).unpaidInvoices : (0, $0dfe3399c688b02f$export$91bfd9bdbb33b473).paidInvoices;
                return this.response(config, 200, responseData);
            case "client/invoices/display":
                return this.response(config, 200, {
                    ...(0, $0dfe3399c688b02f$export$91bfd9bdbb33b473).invoiceWithDetails,
                    id: config.data.id
                });
            case "client/sp/search":
                return this.response(config, 200, (0, $0dfe3399c688b02f$export$91bfd9bdbb33b473).sps);
            case "client/sp/saved":
                return this.response(config, 200, (0, $0dfe3399c688b02f$export$91bfd9bdbb33b473).sps);
        }
        throw new Error(`Mock response is not implemented: ${config.url}`);
    }
}
function $33bc0fc4aa1801f1$var$removeById(list, id) {
    // eslint-disable-next-line eqeqeq
    const pos = list.findIndex((it)=>it.id == id);
    if (pos > -1) list.splice(pos, 1);
}
function $33bc0fc4aa1801f1$var$updateById(list, item) {
    // eslint-disable-next-line eqeqeq
    const pos = list.findIndex((it)=>it.id == item.id);
    if (pos > -1) list[pos] = item;
}
let $33bc0fc4aa1801f1$var$nextId = 100;
function $33bc0fc4aa1801f1$var$add(list, item) {
    item.id = $33bc0fc4aa1801f1$var$nextId++;
    list.push(item);
}





const $6aa3cb544149be44$var$TOKEN_LOGIN_URL = "client/token";
const $6aa3cb544149be44$var$MAX_LOGIN_ATTEMPTS = 3;
// A token the backend turned down stays turned down, so retrying it only adds failing requests.
const $6aa3cb544149be44$var$PERMANENT_ERROR_TYPES = [
    (0, $9ad33fbf770c55a1$export$9696fcf1798e1cb5).AuthError,
    (0, $9ad33fbf770c55a1$export$9696fcf1798e1cb5).ClientError,
    (0, $9ad33fbf770c55a1$export$9696fcf1798e1cb5).NotFound,
    (0, $9ad33fbf770c55a1$export$9696fcf1798e1cb5).PermissionError
];
let $6aa3cb544149be44$var$loggedInByToken = false;
let $6aa3cb544149be44$var$tokenRejected = false;
let $6aa3cb544149be44$var$attemptsMade = 0;
let $6aa3cb544149be44$var$loginRequest = null;
async function $6aa3cb544149be44$export$2161161c7e4dcc7(request) {
    const urlParams = new URLSearchParams(window.location.search);
    const token = urlParams.get("token");
    const shouldLogIn = Boolean(token) && !$6aa3cb544149be44$var$loggedInByToken && !$6aa3cb544149be44$var$tokenRejected && $6aa3cb544149be44$var$attemptsMade < $6aa3cb544149be44$var$MAX_LOGIN_ATTEMPTS && request.url !== $6aa3cb544149be44$var$TOKEN_LOGIN_URL;
    if (shouldLogIn) {
        let pendingLogin = $6aa3cb544149be44$var$loginRequest;
        // Requests fired before the log in resolves share its result instead of each spending the token.
        const startsAttempt = pendingLogin === null;
        if (pendingLogin === null) {
            $6aa3cb544149be44$var$attemptsMade += 1;
            pendingLogin = (0, $1c0cc537f6748418$export$6f57813fe9f31bf9).data.logInByToken({
                token: String(token)
            });
            $6aa3cb544149be44$var$loginRequest = pendingLogin;
        }
        try {
            await pendingLogin;
            $6aa3cb544149be44$var$loggedInByToken = true;
        } catch (error) {
            // Let the next request start a new attempt, in case the failure was a transient one.
            $6aa3cb544149be44$var$loginRequest = null;
            // Only the request that started the attempt reports it, so one failure is one report.
            if (startsAttempt) $6aa3cb544149be44$var$reportTokenLoginFailure(error);
        }
    }
    return request;
}
/**
 * A failed token log in leaves the app rendering pages while its store still holds no account,
 * which is silent to the user, so it has to be loud in Sentry.
 * @param error
 * @returns void
 */ function $6aa3cb544149be44$var$reportTokenLoginFailure(error) {
    const apiError = error instanceof (0, $9ad33fbf770c55a1$export$f2e832acab1bdd79) ? error : null;
    $6aa3cb544149be44$var$tokenRejected = apiError !== null && $6aa3cb544149be44$var$PERMANENT_ERROR_TYPES.includes(apiError.type);
    (0, $0c0f53a5cea85ce7$export$3e205fbb5df021e0)("Token link login failed", {
        // window.location.search is left out on purpose - it carries the token, which is a credential.
        path: window.location.pathname,
        errorType: apiError?.type ?? (error instanceof Error ? error.name : typeof error),
        errorCode: apiError?.data.code,
        errorMessage: apiError?.data.message ?? String(error),
        attempt: $6aa3cb544149be44$var$attemptsMade,
        willRetry: !$6aa3cb544149be44$var$tokenRejected && $6aa3cb544149be44$var$attemptsMade < $6aa3cb544149be44$var$MAX_LOGIN_ATTEMPTS
    });
}




const $b1f1a2a8ecd5871f$export$79371dedea1bd47a = (response)=>{
    if (response.config.url === (0, $78389efdabbe964c$export$9a65832edee28fa6).refreshURL && response.status === 200) // remove if check when backend adds payload to refresh response
    {
        if (response.data.data) (0, $1c0cc537f6748418$export$6f57813fe9f31bf9).data.setAccount(response.data.data);
    }
    return response;
};



const $2fc07828b7aed174$export$cc496ac3ba915e95 = (response)=>{
    (0, $0c0f53a5cea85ce7$export$efda9a273d7a036d)({
        message: "API request/response",
        category: "network",
        data: {
            status: response.status,
            serverResponse: response.data,
            requestData: {
                data: response.config.data,
                baseURL: response.config.baseURL,
                headers: response.config.headers,
                method: response.config.method
            }
        }
    });
    return response;
};


(0, (/*@__PURE__*/$parcel$interopDefault($b302555736d21bd7$exports))).defaults.withCredentials = true;
class $b4a8ac180c7f34fc$export$7dc6752a22ab011a {
    constructor(){
        /**
   * Our api.
   */ this.api = (0, (0, $bsQZT.config).USE_REAL_API) ? new (0, $42168642299f176a$export$159faee26ec5badf)({
            ...(0, $78389efdabbe964c$export$9a65832edee28fa6),
            requestInterceptors: [
                (0, $6aa3cb544149be44$export$2161161c7e4dcc7)
            ],
            responseInterceptors: [
                (0, $b1f1a2a8ecd5871f$export$79371dedea1bd47a),
                (0, $2fc07828b7aed174$export$cc496ac3ba915e95)
            ],
            lang: navigator.language,
            withCredentials: true
        }) : new (0, $33bc0fc4aa1801f1$export$a8aac3f35099abd7)();
        this.rawApi = (0, (/*@__PURE__*/$parcel$interopDefault($b302555736d21bd7$exports))).create({});
    }
}



var $i56po = parcelRequire("i56po");

var $i56po = parcelRequire("i56po");

var $i56po = parcelRequire("i56po");

const $c27e024f7cd31ca5$export$39f36b94c3034e99 = (self)=>{
    return {
        actions: {
            request: (method, url, data, options = {})=>{
                let sendData = data;
                if (options.headers?.["Content-Type"] === "multipart/form-data") {
                    const formData = new FormData();
                    for(const key in data)formData.append(key, (0, $i56po.cast)(data[key]));
                    sendData = formData;
                }
                if (!options.headers?.["x-lang-code"]) options.headers = {
                    ...options.headers,
                    ["x-lang-code"]: (0, $73ccb33f5de6f5aa$export$daa49e131b652e5b).getCurrentLanguage()
                };
                return (0, $i56po.getEnv)(self).api.makeRequest({
                    method: method,
                    url: url,
                    data: sendData,
                    ...options
                });
            },
            rawRequest: (method, url, data)=>{
                return (0, $i56po.getEnv)(self).rawApi.request({
                    method: method,
                    url: url,
                    data: data
                });
            }
        }
    };
};



var $i56po = parcelRequire("i56po");

var $i56po = parcelRequire("i56po");

var $bsQZT = parcelRequire("bsQZT");
const $689c0f02660e8d18$export$939fc8ffec2e5277 = (0, $i56po.types).model("Location", {
    id: (0, $i56po.types).identifierNumber,
    name: (0, $i56po.types).string,
    address: (0, $i56po.types).string,
    address_details: (0, $i56po.types).string,
    lat: (0, $i56po.types).maybeNull((0, $i56po.types).number),
    lng: (0, $i56po.types).maybeNull((0, $i56po.types).number),
    region: (0, $i56po.types).string,
    image: (0, $i56po.types).maybeNull((0, $i56po.types).string),
    delete_image: (0, $i56po.types).maybe((0, $i56po.types).number),
    is_georestriction_large: (0, $i56po.types).maybeNull((0, $i56po.types).boolean),
    is_georestriction_disabled: (0, $i56po.types).maybeNull((0, $i56po.types).boolean),
    public_transport_accessibility: (0, $i56po.types).maybeNull((0, $i56po.types).number)
});
const $689c0f02660e8d18$export$58f55a6020265313 = (self)=>({
        getLocations: (0, $i56po.flow)(function*({ hasShiftsFrom: hasShiftsFrom, hasShiftsTo: hasShiftsTo }) {
            let queryString = "client/locations?";
            if (hasShiftsFrom) queryString += `&hasShiftsFrom=${hasShiftsFrom}`;
            if (hasShiftsTo) queryString += `&hasShiftsTo=${hasShiftsTo}`;
            const locations = yield self.request("get", queryString);
            self.locations.clear();
            locations.map((location)=>{
                self.locations.set(String(location.id), location);
            });
        }),
        getLocation: (0, $i56po.flow)(function*(id) {
            const location = yield self.request("get", `client/locations/${id}`);
            self.locations.set(String(location.id), location);
        }),
        addLocation: (0, $i56po.flow)(function*(location, optConfig) {
            const createdLocation = yield self.request("post", "client/locations", {
                ...location,
                is_georestriction_large: Number(location.is_georestriction_large),
                is_georestriction_disabled: Number(location.is_georestriction_disabled)
            }, {
                headers: {
                    "Content-Type": "multipart/form-data"
                },
                ...optConfig
            });
            self.locations.set(String(createdLocation.id), createdLocation);
            // eslint-disable-next-line @typescript-eslint/no-unsafe-return
            return createdLocation;
        }),
        updateLocation: (0, $i56po.flow)(function*(id, location, optConfig) {
            const updatedLocation = yield self.request("put", `client/locations/${id}`, {
                ...location,
                is_georestriction_large: Number(location.is_georestriction_large),
                is_georestriction_disabled: Number(location.is_georestriction_disabled)
            }, {
                ...optConfig
            });
            self.locations.set(String(updatedLocation.id), updatedLocation);
        }),
        deleteLocation: (0, $i56po.flow)(function*(id) {
            self.locations.delete(id);
            yield self.request("delete", `client/locations/${id}`);
        }),
        getGeoCode: (0, $i56po.flow)(function*(address) {
            return yield self.rawRequest("get", `https://maps.googleapis.com/maps/api/geocode/json?address=${encodeURIComponent(address)}&key=${(0, $bsQZT.config).GOOGLE_API_KEY}`);
        }),
        getPlaces: (0, $i56po.flow)(function*(address) {
            return yield self.rawRequest("get", `https://maps.googleapis.com/maps/api/place/autocomplete/json?input=${encodeURIComponent(address)}&key=${(0, $bsQZT.config).GOOGLE_API_KEY}&language=en`);
        })
    });
const $689c0f02660e8d18$export$e4bb51118bc761f9 = (self)=>({
        getLocationIdByName (name) {
            return Array.from(self.locations.values()).find((location)=>location.name === name)?.id;
        },
        getLocationNameById (id) {
            return Array.from(self.locations.values()).find((location)=>location.id === Number(id))?.name;
        },
        getLocationByName (name) {
            return Array.from(self.locations.values()).find((location)=>location.name === name);
        },
        get locationsDataView () {
            return Array.from(self.locations.values());
        }
    });


const $e792d82719edd3fb$export$471d9f92b0d0c1e8 = (0, $i56po.types).model("AttendanceManager", {
    id: (0, $i56po.types).identifierNumber,
    first_name: (0, $i56po.types).optional((0, $i56po.types).string, ""),
    last_name: (0, $i56po.types).optional((0, $i56po.types).string, ""),
    email: (0, $i56po.types).string,
    job_role: (0, $i56po.types).optional((0, $i56po.types).string, ""),
    status: (0, $i56po.types).optional((0, $i56po.types).string, ""),
    phone: (0, $i56po.types).optional((0, $i56po.types).string, ""),
    locations: (0, $i56po.types).array((0, $689c0f02660e8d18$export$939fc8ffec2e5277))
});
const $e792d82719edd3fb$export$dc606b4712afc945 = (self)=>{
    const actions = {
        getAttendanceManagers: (0, $i56po.flow)(function*() {
            const managers = yield self.request("get", "client/attendance_managers");
            self.attendanceManagers.clear();
            managers.map((manager)=>{
                self.attendanceManagers.set(String(manager.id), manager);
            });
        }),
        getAttendanceManager: (0, $i56po.flow)(function*(id) {
            const manager = yield self.request("get", `client/attendance_managers/${id}`);
            self.attendanceManagers.set(String(manager.id), manager);
        }),
        addAttendanceManager: (0, $i56po.flow)(function*(manager) {
            yield self.request("post", "client/attendance_managers", manager);
            // TODO: check if added manager is returned as response then add it instead of `getAttendanceManagers` api call
            actions.getAttendanceManagers();
        }),
        updateAttendanceManager: (0, $i56po.flow)(function*(id, manager) {
            yield self.request("put", `client/attendance_managers/${id}`, manager);
            actions.getAttendanceManagers();
        }),
        deleteAttendanceManager: (0, $i56po.flow)(function*(id) {
            yield self.request("delete", `client/attendance_managers/${id}`);
            self.attendanceManagers.delete(String(id));
        })
    };
    return actions;
};
const $e792d82719edd3fb$export$2631bb987f6c84f2 = (self)=>({
        get attendanceManagersList () {
            return Array.from(self.attendanceManagers.values());
        }
    });



var $i56po = parcelRequire("i56po");

const $85250b9063617b2f$export$413526750d373c55 = "1";
const $85250b9063617b2f$export$b70c2a98db84ffea = "2";
const $85250b9063617b2f$export$e453ba41a58a1258 = "3";
const $85250b9063617b2f$export$a595236b0bffe864 = 0;
const $85250b9063617b2f$export$72098cb19cc2b31c = 1;
const $85250b9063617b2f$export$f67e42527e0ac052 = 2;
const $85250b9063617b2f$export$4b5e1596426e9e1b = (0, $i56po.types).model("CompanyDetails", {
    company_name: (0, $i56po.types).maybeNull((0, $i56po.types).string),
    industry: (0, $i56po.types).maybeNull((0, $i56po.types).string),
    region: (0, $i56po.types).maybeNull((0, $i56po.types).string),
    trade_name: (0, $i56po.types).maybeNull((0, $i56po.types).string),
    region_id: (0, $i56po.types).maybeNull((0, $i56po.types).number),
    is_corporate: (0, $i56po.types).maybeNull((0, $i56po.types).number),
    is_document_complete: (0, $i56po.types).maybeNull((0, $i56po.types).number),
    is_custom_sla: (0, $i56po.types).maybeNull((0, $i56po.types).number),
    is_pocs_created: (0, $i56po.types).maybeNull((0, $i56po.types).number),
    is_lpo_required: (0, $i56po.types).maybeNull((0, $i56po.types).number),
    is_affiliate: (0, $i56po.types).maybeNull((0, $i56po.types).number),
    is_affiliate_tc_accepted: (0, $i56po.types).boolean,
    address: (0, $i56po.types).maybeNull((0, $i56po.types).string),
    po_box: (0, $i56po.types).maybeNull((0, $i56po.types).string),
    status_id: (0, $i56po.types).number,
    free_zone: (0, $i56po.types).maybeNull((0, $i56po.types).string),
    license_number: (0, $i56po.types).maybeNull((0, $i56po.types).string),
    vat: (0, $i56po.types).maybeNull((0, $i56po.types).string),
    trade: (0, $i56po.types).maybeNull((0, $i56po.types).string),
    is_sla_accepted: (0, $i56po.types).maybeNull((0, $i56po.types).number),
    finance_first_name: (0, $i56po.types).maybeNull((0, $i56po.types).string),
    finance_last_name: (0, $i56po.types).maybeNull((0, $i56po.types).string),
    finance_extension: (0, $i56po.types).maybeNull((0, $i56po.types).string),
    finance_phone: (0, $i56po.types).maybeNull((0, $i56po.types).string),
    finance_email: (0, $i56po.types).maybeNull((0, $i56po.types).string)
});
const $85250b9063617b2f$export$c567f576b2bf86d3 = (self)=>({
        "update\u0421ompanyDetails": (0, $i56po.flow)(function*(data, optConfig) {
            const dataWithoutNullValues = Object.fromEntries(Object.entries(data).filter(([_, v])=>v !== null));
            yield self.request("post", "client/corporates", dataWithoutNullValues, {
                headers: {
                    "Content-Type": "multipart/form-data"
                },
                ...optConfig
            });
            if (self.account) {
                self.account.is_corporate_details_complete = true;
                self.account.account_type = (0, $97fa7686fb8e51ed$export$b8ca5fa4899cbfc7).CORPORATE;
            }
        }),
        "get\u0421ompanyDetails": (0, $i56po.flow)(function*() {
            self.companyDetails = yield self.request("post", "client/profile/company_details");
        }),
        markAffiliateTCAsAccepted: function() {
            if (self.companyDetails) self.companyDetails.is_affiliate_tc_accepted = true;
        }
    });





var $i56po = parcelRequire("i56po");
const $bef4c0ded377ea3c$export$b526d87d51b2fbf6 = (0, $i56po.types).model("Profession", {
    id: (0, $i56po.types).identifierNumber,
    name: (0, $i56po.types).string,
    image: (0, $i56po.types).string,
    description: (0, $i56po.types).string,
    job_description: (0, $i56po.types).string,
    is_students_allowed: (0, $i56po.types).number,
    is_disabled_in_apps: (0, $i56po.types).number
});
const $bef4c0ded377ea3c$export$f89d5009abbd80f9 = (self)=>({
        getProfessions: (0, $i56po.flow)(function*({ hasShiftsFrom: hasShiftsFrom, hasShiftsTo: hasShiftsTo, hasShiftsAtLocationIds: hasShiftsAtLocationIds }) {
            let queryString = "common/professions?";
            if (hasShiftsFrom) queryString += `&hasShiftsFrom=${hasShiftsFrom}`;
            if (hasShiftsTo) queryString += `&hasShiftsTo=${hasShiftsTo}`;
            if (hasShiftsAtLocationIds) hasShiftsAtLocationIds.forEach((locationId)=>{
                queryString += `&hasShiftsAtLocationIds[]=${locationId}`;
            });
            const professions = yield self.request("get", queryString);
            self.professions.clear();
            professions.forEach((profession)=>{
                self.professions.set(String(profession.id), profession);
            });
        })
    });
const $bef4c0ded377ea3c$export$ece1a5d73f5c47b0 = (self)=>({
        getProfessionIdByTitle (title) {
            return Array.from(self.professions.values()).find((profession)=>profession.name === title)?.id;
        },
        getProfessionName (id) {
            return Array.from(self.professions.values()).find((role)=>role.id === id)?.name;
        },
        getProfession (id) {
            return Array.from(self.professions.values()).find((role)=>role.id === id);
        },
        get professionList () {
            return Array.from(self.professions.values()).filter((profession)=>profession.is_disabled_in_apps !== 1);
        }
    });



var $i56po = parcelRequire("i56po");

const $9fe0c86e68f7e764$export$1330ce17378df8ff = "__allow_nationality_option";
const $9fe0c86e68f7e764$export$e0e97806e9b2009b = (0, $i56po.types).model("Profile", {
    id: (0, $i56po.types).identifierNumber,
    user_id: (0, $i56po.types).number,
    first_name: (0, $i56po.types).string,
    last_name: (0, $i56po.types).maybeNull((0, $i56po.types).string),
    email: (0, $i56po.types).string,
    phone: (0, $i56po.types).maybeNull((0, $i56po.types).string),
    image: (0, $i56po.types).string,
    total_jobs_count: (0, $i56po.types).optional((0, $i56po.types).number, 0),
    inprogress_jobs_count: (0, $i56po.types).optional((0, $i56po.types).number, 0),
    unpaid_invoices_count: (0, $i56po.types).optional((0, $i56po.types).number, 0),
    rating_request_count: (0, $i56po.types).optional((0, $i56po.types).number, 0),
    lean_setup_completed: (0, $i56po.types).maybeNull((0, $i56po.types).number),
    lean_setup_status: (0, $i56po.types).maybeNull((0, $i56po.types).number),
    allow_marketing_emails: (0, $i56po.types).number,
    roles: (0, $i56po.types).array((0, $i56po.types).number),
    tags: (0, $i56po.types).array((0, $i56po.types).string)
});
const $9fe0c86e68f7e764$export$13e13f83d4c0e6c7 = (self)=>({
        getProfile: (0, $i56po.flow)(function*() {
            self.profile = yield self.request("post", "client/profile/summary");
            return self.profile;
        }),
        updateProfile: (0, $i56po.flow)(function*(data) {
            yield self.request("post", "client/profile/basic/update", data, {
                headers: {
                    "Content-Type": "multipart/form-data"
                }
            });
            if (self.account) {
                self.account.is_basic_info_complete = true;
                self.account.name = `${data.first_name} ${data.last_name}`;
            }
        }),
        changePassword: (0, $i56po.flow)(function*(params) {
            yield self.request("post", "client/password/change", params);
        }),
        acceptSLA: (0, $i56po.flow)(function*() {
            yield self.request("post", "client/profile/sla/accept");
        }),
        switchProfile: (0, $i56po.flow)(function*(id) {
            self.account = yield self.request("post", `client/profile/switch/${id}`);
        }),
        setLeanSetupCompleted: function(value) {
            if (self.profile) self.profile.lean_setup_status = (0, $ace4c335912c9e96$export$c35a3f1cb87c9eaa).LEAN_SETUP_STATUS_ACTIVE;
        }
    });



var $i56po = parcelRequire("i56po");
const $c3993e4dfdaadbe2$export$2b4c6dd0b4533a88 = (self)=>{
    const actions = {
        login: (0, $i56po.flow)(function*(params) {
            self.account = yield self.request("post", "client/auth/login", params);
            self.logged = true;
            return self.account;
        }),
        register: (0, $i56po.flow)(function*(params) {
            self.account = yield self.request("post", "client/auth/signup", params);
            self.logged = true;
            return self.account;
        }),
        verifyEmail: (0, $i56po.flow)(function*(params) {
            yield self.request("get", `client/auth/verifyemail/${params.hash}`);
            self.logged = true;
        }),
        logInByToken: (0, $i56po.flow)(function*(params) {
            self.account = yield self.request("post", "client/token", params);
            self.logged = true;
        }),
        socialRegister: (0, $i56po.flow)(function*(params) {
            yield self.request("post", "client/auth/social_signup", params);
            self.logged = true;
        }),
        forgotPassword: (0, $i56po.flow)(function*(params) {
            yield self.request("post", "client/auth/forgot_password", params);
        }),
        resendEmailVerification: (0, $i56po.flow)(function*(params) {
            yield self.request("post", "client/auth/resend_email_verification", params);
        }),
        verifyEmailByCode: (0, $i56po.flow)(function*(params) {
            yield self.request("post", "client/auth/verify_email", params);
            self.logged = true;
        }),
        resetPassword: (0, $i56po.flow)(function*(params) {
            yield self.request("post", "client/auth/reset_password", params);
            self.logged = true;
        }),
        resendOnboardingEmail: (0, $i56po.flow)(function*(email) {
            yield self.request("post", "client/auth/resend_email_verification", {
                email: email
            });
        }),
        logout: (0, $i56po.flow)(function*(params) {
            yield self.request("post", "client/auth/logout", params);
            actions.logoutLocal();
        }),
        logoutLocal: function() {
            (0, $i56po.getEnv)(self).api.setAuthKey(null);
            (0, $i56po.applySnapshot)(self, {});
        },
        refreshToken: (0, $i56po.flow)(function*() {
            self.account = yield self.request("post", "client/auth/refresh");
            self.logged = true;
        })
    };
    return actions;
};



var $i56po = parcelRequire("i56po");
const $7502a05bfd737216$export$fec1c3aa0a78ac0d = (0, $i56po.types).model("Uniform", {
    id: (0, $i56po.types).identifierNumber,
    name: (0, $i56po.types).string,
    description: (0, $i56po.types).string,
    image_url: (0, $i56po.types).string
});
const $7502a05bfd737216$export$38b905ec97b2baa4 = (self)=>({
        getUniforms: (0, $i56po.flow)(function*() {
            const uniforms = yield self.request("get", `common/uniforms`);
            uniforms.forEach((uniform)=>{
                self.uniforms.set(String(uniform.id), uniform);
            });
        })
    });
const $7502a05bfd737216$export$801f3abbeddfd49 = (self)=>({
        getUniformIdByTitle (title) {
            return Array.from(self.uniforms.values()).find((uniform)=>uniform.name === title)?.id;
        },
        getUniformName (id) {
            return self.uniforms.get(String(id))?.name;
        },
        getUniformById (id) {
            return self.uniforms.get(String(id));
        },
        get uniformList () {
            return Array.from(self.uniforms.values());
        }
    });



var $4f362 = parcelRequire("4f362");

var $i56po = parcelRequire("i56po");
const $71538133e39294ef$var$WorkCategoryModel = (0, $i56po.types).model({
    id: (0, $i56po.types).number,
    name: (0, $i56po.types).string,
    min_rate: (0, $i56po.types).number,
    max_rate: (0, $i56po.types).number,
    min_years: (0, $i56po.types).number,
    max_years: (0, $i56po.types).number
});
const $71538133e39294ef$export$481f08521fe36ad0 = (0, $i56po.types).model("FilterDictionaryModel", {
    languages: (0, $i56po.types).array((0, $i56po.types).model({
        id: (0, $i56po.types).number,
        name: (0, $i56po.types).string
    })),
    nationalities: (0, $i56po.types).array((0, $i56po.types).model({
        id: (0, $i56po.types).number,
        name: (0, $i56po.types).string
    })),
    certificates: (0, $i56po.types).array((0, $i56po.types).model({
        id: (0, $i56po.types).number,
        display_name: (0, $i56po.types).string
    })),
    work_categories: (0, $i56po.types).array($71538133e39294ef$var$WorkCategoryModel),
    gender: (0, $i56po.types).array((0, $i56po.types).model({
        id: (0, $i56po.types).number,
        name: (0, $i56po.types).string
    })),
    age: (0, $i56po.types).model({
        min: (0, $i56po.types).number,
        max: (0, $i56po.types).number
    }),
    height: (0, $i56po.types).model({
        min: (0, $i56po.types).number,
        max: (0, $i56po.types).number
    })
});
const $71538133e39294ef$export$5ee8ec36330b5d09 = (self)=>({
        getFiltersDictionary: (0, $i56po.flow)(function*() {
            self.filterDictionary = yield self.request("post", "common/filter/lists");
        })
    });
const $71538133e39294ef$export$a1baae9b8b605186 = (self)=>({
        getNationalityIdByTitle (title) {
            if (!self.filterDictionary) return [];
            return (0, $4f362.values)(self.filterDictionary.nationalities).find((nationality)=>nationality.name === title)?.id;
        }
    });
const $71538133e39294ef$export$5e231e9e0d84884d = {
    "Male": 1,
    "Female": 2,
    "Mixed": 3
};
var $71538133e39294ef$export$87cdbc5104bfce47;
(function(Genders) {
    Genders["Male"] = "Male";
    Genders["Female"] = "Female";
    Genders["Mixed"] = "Mixed";
})($71538133e39294ef$export$87cdbc5104bfce47 || ($71538133e39294ef$export$87cdbc5104bfce47 = {}));



var $i56po = parcelRequire("i56po");
const $76f97430ce9c28fd$export$d02753406c974acf = (0, $i56po.types).model("RatingRequest", {
    id: (0, $i56po.types).identifierNumber,
    order_id: (0, $i56po.types).number,
    title: (0, $i56po.types).string,
    client_address: (0, $i56po.types).string,
    start_date: (0, $i56po.types).string,
    end_date: (0, $i56po.types).string,
    sp_max_quantity: (0, $i56po.types).number
});
const $76f97430ce9c28fd$export$1b0cc98aec45b456 = (0, $i56po.types).model("LastRating", {
    id: (0, $i56po.types).identifierNumber,
    image_url: (0, $i56po.types).string,
    name: (0, $i56po.types).string,
    completed_at: (0, $i56po.types).string,
    location_id: (0, $i56po.types).number,
    designation_id: (0, $i56po.types).number,
    location_name: (0, $i56po.types).string,
    designation_name: (0, $i56po.types).string,
    job_id: (0, $i56po.types).number
});
const $76f97430ce9c28fd$export$cacda00ce6d92680 = (self)=>({
        getRatingRequests: (0, $i56po.flow)(function*(includeActiveJobs) {
            const ratingRequestArray = yield self.request("get", `client/rating/pending?includeActiveJobs=${Number(includeActiveJobs)}`);
            if (self.ratingRequests.size > 0) self.ratingRequests.clear();
            ratingRequestArray.forEach((ratingRequest)=>{
                self.ratingRequests.set(String(ratingRequest.id), ratingRequest);
            });
        }),
        getLastRatings: (0, $i56po.flow)(function*() {
            const data = yield self.request("get", `client/rating/latest`);
            if (self.lastRatings.size > 0) self.lastRatings.clear();
            data.forEach((rating)=>{
                self.lastRatings.set(String(rating.id), rating);
            });
        }),
        getRatingRequestDetails: (0, $i56po.flow)(function*(id) {
            return yield self.request("get", `client/rating/${id}`);
        }),
        submitRating: (0, $i56po.flow)(function*(params) {
            const formData = new FormData();
            formData.append("job_id", String(params.job_id));
            formData.append("job_rating", String(params.job_rating));
            params.ogrammerRates.forEach((ogRate, index)=>{
                formData.append(`sps[${index}][sp_id]`, String(ogRate.sp_id));
                formData.append(`sps[${index}][rating]`, String(ogRate.rating));
                formData.append(`sps[${index}][comment]`, ogRate.comment ?? "");
                let criteriaIndex = 0;
                ogRate.criterias.forEach((criteria)=>{
                    formData.append(`sps[${index}][criterias][${criteriaIndex}]`, String(criteria));
                    criteriaIndex++;
                });
            });
            yield self.request("post", "client/rating", formData);
        })
    });
const $76f97430ce9c28fd$export$81d9c7b03dec473f = (self)=>({
        get ratingRequestList () {
            return Array.from(self.ratingRequests.values());
        },
        get groupedLastRatings () {
            const result = [];
            const lastRatingsArray = Array.from(self.lastRatings.values());
            lastRatingsArray.forEach((rating)=>{
                const existingGroup = result.find((group)=>group.location_id === rating.location_id && group.designation_id === rating.designation_id);
                if (existingGroup) existingGroup.ratings.push(rating);
                else result.push({
                    location_id: rating.location_id,
                    designation_id: rating.designation_id,
                    location_name: rating.location_name,
                    designation_name: rating.designation_name,
                    ratings: [
                        rating
                    ]
                });
            });
            return result;
        },
        get ratingRequestsCount () {
            return self.ratingRequests.size;
        }
    });




var $i56po = parcelRequire("i56po");

var $i56po = parcelRequire("i56po");
var $487f9fae786cd5fa$export$d04232ab73db0cc8;
(function(ShiftRepeatType) {
    ShiftRepeatType[ShiftRepeatType["NoRepeat"] = 0] = "NoRepeat";
    ShiftRepeatType[ShiftRepeatType["EveryDay"] = 1] = "EveryDay";
    ShiftRepeatType[ShiftRepeatType["EveryWeek"] = 2] = "EveryWeek";
})($487f9fae786cd5fa$export$d04232ab73db0cc8 || ($487f9fae786cd5fa$export$d04232ab73db0cc8 = {}));
const $487f9fae786cd5fa$var$PricingMultiplierModel = (0, $i56po.types).model("PricingMultiplier", {
    type: (0, $i56po.types).string,
    hours: (0, $i56po.types).maybeNull((0, $i56po.types).number),
    value: (0, $i56po.types).maybeNull((0, $i56po.types).number),
    valueType: (0, $i56po.types).string
});
const $487f9fae786cd5fa$var$PricingModel = (0, $i56po.types).model("Pricing", {
    total: (0, $i56po.types).maybeNull((0, $i56po.types).number),
    final_total: (0, $i56po.types).maybeNull((0, $i56po.types).number),
    details: (0, $i56po.types).array($487f9fae786cd5fa$var$PricingMultiplierModel)
});
const $487f9fae786cd5fa$var$IntervalModel = (0, $i56po.types).model("Interval", {
    start_time: (0, $i56po.types).string,
    end_time: (0, $i56po.types).string,
    day_of_month: (0, $i56po.types).string,
    month: (0, $i56po.types).string,
    day: (0, $i56po.types).string,
    duration: (0, $i56po.types).number
});
const $487f9fae786cd5fa$export$4970faf62e67ab48 = (0, $i56po.types).model("JobDetails", {
    id: (0, $i56po.types).identifierNumber,
    work_category_id: (0, $i56po.types).number,
    category_name: (0, $i56po.types).string,
    quantity: (0, $i56po.types).number,
    public_transport_accessibility: (0, $i56po.types).maybeNull((0, $i56po.types).number),
    instructions: (0, $i56po.types).string,
    is_automatic_checkout: (0, $i56po.types).number,
    invited_sp_ids: (0, $i56po.types).array((0, $i56po.types).number),
    is_accreditation_required: (0, $i56po.types).number,
    is_accommodation_offered: (0, $i56po.types).number,
    is_interview_required: (0, $i56po.types).number,
    boarding_type: (0, $i56po.types).number,
    start_date: (0, $i56po.types).string,
    end_date: (0, $i56po.types).string,
    uniform_id: (0, $i56po.types).number,
    uniform_provided: (0, $i56po.types).string,
    client_location_id: (0, $i56po.types).number,
    client_location_name: (0, $i56po.types).string,
    contact_user_id: (0, $i56po.types).maybeNull((0, $i56po.types).number),
    seniority_level: (0, $i56po.types).number,
    filter: (0, $i56po.types).model({
        languages: (0, $i56po.types).maybeNull((0, $i56po.types).array((0, $i56po.types).number)),
        nationalities: (0, $i56po.types).maybeNull((0, $i56po.types).array((0, $i56po.types).number)),
        certificates: (0, $i56po.types).maybeNull((0, $i56po.types).array((0, $i56po.types).number)),
        gender: (0, $i56po.types).maybeNull((0, $i56po.types).number)
    }),
    assignment_type: (0, $i56po.types).number,
    work_requirement_ids: (0, $i56po.types).array((0, $i56po.types).number),
    intervals: (0, $i56po.types).maybeNull((0, $i56po.types).map($487f9fae786cd5fa$var$IntervalModel)),
    is_recurring: (0, $i56po.types).number,
    pricing: $487f9fae786cd5fa$var$PricingModel,
    repeat_type: (0, $i56po.types).maybeNull((0, $i56po.types).number)
});
const $487f9fae786cd5fa$export$16fcdeb939f4f772 = (self)=>({
        getOrderJobs: (0, $i56po.flow)(function*(params) {
            const order = self.order.draft.get(String(params.order_id));
            if (!order) {
                const updatedOrder = yield self.request("post", "client/order/basic/get", {
                    order_id: params.order_id
                });
                self.order.draft.set(String(updatedOrder.id), updatedOrder);
            }
            const jobs = yield self.request("post", `client/order/jobs/get`, params);
            jobs.forEach((job)=>{
                self.order.draft.get(String(params.order_id))?.jobs.set(String(job.id), job);
            });
        }),
        getLastJob: (0, $i56po.flow)(function*(locationId, workCategoryId) {
            return yield self.request("get", `client/order/jobs/template?location_id=${locationId}&work_category_id=${workCategoryId}`);
        }),
        cancelJob: (0, $i56po.flow)(function*({ orderId: orderId, jobId: jobId }) {
            yield self.request("post", "client/order/jobs/delete", {
                job_id: jobId
            });
            self.order.draft.get(orderId)?.jobs.delete(String(jobId));
        })
    });
const $487f9fae786cd5fa$export$6240ef84ad28581a = (self)=>({
        getOrderIdJobs (orderId) {
            const order = self.order.draft.get(String(orderId));
            if (!order) return [];
            return Array.from(order.jobs.values());
        },
        getOrderIdJob (orderId, jobId) {
            const order = self.order.draft.get(String(orderId));
            return order?.jobs.get(jobId);
        },
        getJobIntervals (orderId, jobId) {
            const order = self.order.draft.get(String(orderId));
            const job = order?.jobs.get(jobId);
            if (!job) return [];
            return Array.from(job.intervals?.entries() ?? []);
        }
    });



var $i56po = parcelRequire("i56po");
const $4667362fc55c08ef$export$ddeb147e905cd03f = (0, $i56po.types).model("Statistics", {
    unpaid_invoices: (0, $i56po.types).number,
    active_orders: (0, $i56po.types).number
});



var $i56po = parcelRequire("i56po");


var $i56po = parcelRequire("i56po");
const $eb9dd261ab6fbb6b$export$235fa5d8659ea760 = (0, $i56po.types).model("OrderSummary", {
    id: (0, $i56po.types).number,
    is_dynamic_priced: (0, $i56po.types).boolean,
    event_name: (0, $i56po.types).string,
    client_name: (0, $i56po.types).string,
    is_draft: (0, $i56po.types).boolean,
    is_upfront: (0, $i56po.types).boolean,
    is_paid: (0, $i56po.types).boolean,
    is_pending_rates_review: (0, $i56po.types).number,
    is_pending_client_approval: (0, $i56po.types).number,
    is_pending_lpo_upload: (0, $i56po.types).boolean,
    quote_was_downloaded: (0, $i56po.types).boolean,
    locations: (0, $i56po.types).array((0, $i56po.types).model({
        name: (0, $i56po.types).string,
        address: (0, $i56po.types).string,
        lat: (0, $i56po.types).number,
        lng: (0, $i56po.types).number
    })),
    sub_total: (0, $i56po.types).maybeNull((0, $i56po.types).number),
    tax: (0, $i56po.types).maybeNull((0, $i56po.types).number),
    tax_percentage: (0, $i56po.types).maybeNull((0, $i56po.types).number),
    payment_terms_days: (0, $i56po.types).number,
    total: (0, $i56po.types).maybeNull((0, $i56po.types).number),
    transportation_total: (0, $i56po.types).maybeNull((0, $i56po.types).number),
    client_confirmed_at: (0, $i56po.types).maybeNull((0, $i56po.types).number),
    currency: (0, $i56po.types).maybeNull((0, $i56po.types).string),
    start_date: (0, $i56po.types).maybeNull((0, $i56po.types).string),
    end_date: (0, $i56po.types).maybeNull((0, $i56po.types).string),
    lpo_was_uploaded: (0, $i56po.types).boolean,
    is_terms_and_conditions_accepted: (0, $i56po.types).boolean,
    corporate_details_verification_status: (0, $i56po.types).number,
    days_till_end_count: (0, $i56po.types).number,
    is_published: (0, $i56po.types).boolean,
    jobs: (0, $i56po.types).array((0, $i56po.types).model({
        id: (0, $i56po.types).identifierNumber,
        start_date: (0, $i56po.types).string,
        end_date: (0, $i56po.types).string,
        quantity: (0, $i56po.types).number,
        invited_sp_ids: (0, $i56po.types).array((0, $i56po.types).number),
        shifts: (0, $i56po.types).array((0, $i56po.types).model({
            timezone_offset: (0, $i56po.types).number,
            start_time: (0, $i56po.types).number,
            end_time: (0, $i56po.types).number
        })),
        transportation_costs: (0, $i56po.types).number,
        price: (0, $i56po.types).number,
        currency: (0, $i56po.types).string,
        hours: (0, $i56po.types).number,
        hourly_rate: (0, $i56po.types).number,
        location_name: (0, $i56po.types).string,
        work_category_name: (0, $i56po.types).string,
        min_extension_date: (0, $i56po.types).string
    }))
});
const $eb9dd261ab6fbb6b$export$540a316914de0473 = (self)=>({
        getOrderSummary: (0, $i56po.flow)(function*({ orderId: orderId }) {
            const summary = yield self.request("get", `client/order/summary?order_id=${orderId}`);
            if (!self.order.draft.has(orderId)) {
                const basicOrder = yield self.request("post", "client/order/basic/get", {
                    order_id: orderId
                });
                self.order.draft.set(orderId, {
                    ...basicOrder,
                    is_draft: Boolean(basicOrder.is_draft)
                });
            }
            const order = self.order.draft.get(orderId);
            order.summary = $eb9dd261ab6fbb6b$export$235fa5d8659ea760.create(summary);
            return order.summary;
        }),
        confirmOrder: (0, $i56po.flow)(function*({ orderId: orderId }) {
            yield self.request("post", "client/order/confirm", {
                order_id: orderId
            });
        }),
        confirmOrderTermsConditions: (0, $i56po.flow)(function*() {
            yield self.request("post", "client/terms-and-conditions/accept");
        }),
        downloadQuotation: (0, $i56po.flow)(function*(id) {
            return yield self.request("get", `client/order/${id}/quote`, undefined, {
                responseType: "blob"
            });
        }),
        downloadLPO: (0, $i56po.flow)(function*(id) {
            return yield self.request("get", `client/order/${id}/lpo`, undefined, {
                responseType: "blob"
            });
        }),
        uploadLPO: (0, $i56po.flow)(function*(orderId, lpoFile) {
            yield self.request("post", `client/order/${orderId}/lpo`, {
                file: lpoFile
            }, {
                headers: {
                    "Content-Type": "multipart/form-data"
                }
            });
        }),
        setIsPendingLPOUpload: function(orderId, isPendingLPOUpload) {
            const order = self.order.draft.get(orderId);
            if (order.summary) order.summary.is_pending_lpo_upload = isPendingLPOUpload;
        },
        setQuoteWasDownloaded: function(orderId, quoteWasDownloaded) {
            const order = self.order.draft.get(orderId);
            if (order.summary) order.summary.quote_was_downloaded = quoteWasDownloaded;
        },
        setLPOWasUploaded: function(orderId, lPOWasUploaded) {
            const order = self.order.draft.get(orderId);
            if (order.summary) order.summary.lpo_was_uploaded = lPOWasUploaded;
        },
        setIsTermsAndConditionsAccepted: function(orderId, isTermsAndConditionsAccepted) {
            const order = self.order.draft.get(orderId);
            if (order.summary) order.summary.is_terms_and_conditions_accepted = isTermsAndConditionsAccepted;
        },
        getUpfrontPaymentId: (0, $i56po.flow)(function*(orderId) {
            const result = yield self.request("get", `client/order/${orderId}/upfront-payment`);
            return result.payment_id;
        }),
        requestCallback: (0, $i56po.flow)(function*({ orderId: orderId }) {
            yield self.request("post", `client/order/${orderId}/request-callback`);
        }),
        createExtendedOrder: (0, $i56po.flow)(function*({ id: id, jobsToExtend: jobsToExtend }) {
            const result = yield self.request("post", `client/order/${id}/create-extended-order`, {
                jobsToExtend: jobsToExtend
            });
            return result.order_id;
        }),
        bulkExtendJobs: (0, $i56po.flow)(function*({ jobs: jobs }) {
            const result = yield self.request("post", `client/order/jobs/extend`, {
                jobs: jobs
            });
            return result.order_id;
        })
    });
const $eb9dd261ab6fbb6b$export$635ae09819efb3c8 = (self)=>({
        getOrderIdSummary (orderId) {
            return self.order.draft.get(orderId)?.summary;
        }
    });


const $08dd3df3ae1a0b30$export$fa5e91128f02e047 = (0, $i56po.types).model("Order", {
    id: (0, $i56po.types).identifierNumber,
    name: (0, $i56po.types).string,
    is_draft: (0, $i56po.types).boolean,
    is_pending_client_approval: (0, $i56po.types).maybeNull((0, $i56po.types).number),
    is_pending_rates_review: (0, $i56po.types).maybeNull((0, $i56po.types).number),
    jobs: (0, $i56po.types).map((0, $487f9fae786cd5fa$export$4970faf62e67ab48)),
    summary: (0, $i56po.types).maybeNull((0, $eb9dd261ab6fbb6b$export$235fa5d8659ea760))
});
const $08dd3df3ae1a0b30$export$aa3aa2a3a328a091 = (self)=>({
        getBasicOrder: (0, $i56po.flow)(function*(orderId) {
            const order = yield self.request("post", "client/order/basic/get", {
                order_id: orderId
            });
            self.order.draft.set(String(order.id), {
                ...order,
                is_draft: Boolean(order.is_draft)
            });
        }),
        createOrder: (0, $i56po.flow)(function*(lpoNumber) {
            const order = yield self.request("post", "client/order/basic/post", lpoNumber ? {
                lpo_number: lpoNumber
            } : undefined);
            self.order.draft.set(String(order.id), {
                ...order,
                is_draft: Boolean(order.is_draft)
            });
            return order.id;
        }),
        submitOrder: (0, $i56po.flow)(function*(orderId) {
            yield self.request("post", `client/order/${orderId}/submit`);
        })
    });
const $08dd3df3ae1a0b30$export$d2497be51a9b7c53 = (self)=>({
        get basicOrders () {
            return Array.from(self.order.draft.values());
        },
        getBasicOrderJobs (orderId) {
            const order = self.order.draft.get(orderId);
            return order?.jobs ? Array.from(order.jobs.values()) : [];
        }
    });




const $41e1cbb67f22c5a1$export$58004edee0d8a9a8 = (0, $i56po.types).model("OrderStore", {
    draft: (0, $i56po.types).map((0, $08dd3df3ae1a0b30$export$fa5e91128f02e047)),
    jobDetails: (0, $i56po.types).maybeNull((0, $i56po.types).maybe((0, $487f9fae786cd5fa$export$4970faf62e67ab48))),
    statistics: (0, $i56po.types).maybeNull((0, $4667362fc55c08ef$export$ddeb147e905cd03f)),
    ordersList: (0, $i56po.types).optional((0, $i56po.types).model({
        map: (0, $i56po.types).map((0, $0f571f43d43ce782$export$7f55036407033923)),
        nextPage: (0, $i56po.types).optional((0, $i56po.types).maybeNull((0, $i56po.types).number), 1)
    }), {
        map: {},
        nextPage: null
    })
});
const $41e1cbb67f22c5a1$export$ca9ea14a9f873218 = (self)=>({
        ...(0, $08dd3df3ae1a0b30$export$aa3aa2a3a328a091)(self),
        ...(0, $487f9fae786cd5fa$export$16fcdeb939f4f772)(self),
        ...(0, $eb9dd261ab6fbb6b$export$540a316914de0473)(self),
        ...(0, $0f571f43d43ce782$export$f458f607c63e3159)(self)
    });







var $i56po = parcelRequire("i56po");

var $4f362 = parcelRequire("4f362");
const $c415d859b0209fa5$var$SPFilterModel = (0, $i56po.types).model("SPFilter", {
    name: (0, $i56po.types).maybe((0, $i56po.types).string),
    nationality_ids: (0, $i56po.types).optional((0, $i56po.types).array((0, $i56po.types).number), []),
    languages_ids: (0, $i56po.types).optional((0, $i56po.types).array((0, $i56po.types).number), []),
    gender: (0, $i56po.types).maybe((0, $i56po.types).number),
    min_age: (0, $i56po.types).maybe((0, $i56po.types).number),
    max_age: (0, $i56po.types).maybe((0, $i56po.types).number),
    work_category_id: (0, $i56po.types).maybe((0, $i56po.types).number),
    order_id: (0, $i56po.types).maybe((0, $i56po.types).number),
    min_experience: (0, $i56po.types).maybe((0, $i56po.types).number),
    max_experience: (0, $i56po.types).maybe((0, $i56po.types).number),
    min_hourly_rate: (0, $i56po.types).maybe((0, $i56po.types).number),
    max_hourly_rate: (0, $i56po.types).maybe((0, $i56po.types).number),
    min_height: (0, $i56po.types).maybe((0, $i56po.types).number),
    max_height: (0, $i56po.types).maybe((0, $i56po.types).number)
});
const $c415d859b0209fa5$var$LanguageModel = (0, $i56po.types).model("Language", {
    id: (0, $i56po.types).optional((0, $i56po.types).number, 0),
    name: (0, $i56po.types).string
});
const $c415d859b0209fa5$var$ExperienceModel = (0, $i56po.types).model("Experience", {
    name: (0, $i56po.types).string,
    years_experience: (0, $i56po.types).maybeNull((0, $i56po.types).number),
    hourly_rate: (0, $i56po.types).maybeNull((0, $i56po.types).number),
    work_locations: (0, $i56po.types).optional((0, $i56po.types).array((0, $i56po.types).model("WorkLocation", {
        name: (0, $i56po.types).string,
        lat: (0, $i56po.types).maybeNull((0, $i56po.types).number),
        lng: (0, $i56po.types).maybeNull((0, $i56po.types).number)
    })), [])
});
const $c415d859b0209fa5$var$RatingModel = (0, $i56po.types).model("Rating", {
    id: (0, $i56po.types).number,
    rating: (0, $i56po.types).number,
    comment: (0, $i56po.types).string,
    criteria: (0, $i56po.types).optional((0, $i56po.types).array((0, $i56po.types).model({
        id: (0, $i56po.types).number,
        name: (0, $i56po.types).string
    })), []),
    work_category: (0, $i56po.types).model("WorkCategory", {
        id: (0, $i56po.types).number,
        name: (0, $i56po.types).string,
        description: (0, $i56po.types).string,
        image: (0, $i56po.types).string
    })
});
const $c415d859b0209fa5$var$JobModel = (0, $i56po.types).model("Job", {
    id: (0, $i56po.types).number,
    title: (0, $i56po.types).string,
    order_id: (0, $i56po.types).number,
    start_date: (0, $i56po.types).string,
    end_date: (0, $i56po.types).string,
    work_category: (0, $i56po.types).model({
        id: (0, $i56po.types).number,
        name: (0, $i56po.types).string
    })
});
const $c415d859b0209fa5$export$b3ebe8d72f04bb4d = (0, $i56po.types).model("SPDetails", {
    id: (0, $i56po.types).number,
    first_name: (0, $i56po.types).string,
    last_name: (0, $i56po.types).string,
    full_name: (0, $i56po.types).maybe((0, $i56po.types).string),
    image_url: (0, $i56po.types).maybe((0, $i56po.types).string),
    email: (0, $i56po.types).maybe((0, $i56po.types).string),
    phone: (0, $i56po.types).maybeNull((0, $i56po.types).string),
    rating: (0, $i56po.types).optional((0, $i56po.types).number, 0),
    gender: (0, $i56po.types).optional((0, $i56po.types).string, "None"),
    is_saved: (0, $i56po.types).boolean,
    jobs_count: (0, $i56po.types).number,
    nationality: (0, $i56po.types).maybe((0, $i56po.types).model("Nationality", {
        id: (0, $i56po.types).maybeNull((0, $i56po.types).number),
        name: (0, $i56po.types).maybeNull((0, $i56po.types).string)
    })),
    languages: (0, $i56po.types).optional((0, $i56po.types).array($c415d859b0209fa5$var$LanguageModel), []),
    experiences: (0, $i56po.types).optional((0, $i56po.types).array($c415d859b0209fa5$var$ExperienceModel), []),
    rating_list: (0, $i56po.types).optional((0, $i56po.types).array($c415d859b0209fa5$var$RatingModel), []),
    job: (0, $i56po.types).optional((0, $i56po.types).array($c415d859b0209fa5$var$JobModel), []),
    age: (0, $i56po.types).maybeNull((0, $i56po.types).number),
    height: (0, $i56po.types).maybeNull((0, $i56po.types).number),
    resume: (0, $i56po.types).maybeNull((0, $i56po.types).string)
});
const $c415d859b0209fa5$export$a4d9732e3db970da = (0, $i56po.types).model("SP", {
    id: (0, $i56po.types).number,
    first_name: (0, $i56po.types).string,
    last_name: (0, $i56po.types).string,
    image_url: (0, $i56po.types).maybe((0, $i56po.types).string),
    email: (0, $i56po.types).maybe((0, $i56po.types).string),
    rating: (0, $i56po.types).optional((0, $i56po.types).number, 0),
    is_saved: (0, $i56po.types).boolean,
    nationality: (0, $i56po.types).maybe((0, $i56po.types).model("Nationality", {
        id: (0, $i56po.types).number,
        name: (0, $i56po.types).string
    })),
    languages: (0, $i56po.types).optional((0, $i56po.types).array($c415d859b0209fa5$var$LanguageModel), []),
    job: (0, $i56po.types).optional((0, $i56po.types).array($c415d859b0209fa5$var$JobModel), []),
    experiences: (0, $i56po.types).array((0, $i56po.types).model({
        name: (0, $i56po.types).string
    }))
});
const $c415d859b0209fa5$export$2d46b25e5c49986d = (0, $i56po.types).model("SPStore", {
    SPs: (0, $i56po.types).map($c415d859b0209fa5$export$a4d9732e3db970da),
    staff: (0, $i56po.types).optional((0, $i56po.types).array((0, $i56po.types).number), []),
    saved: (0, $i56po.types).optional((0, $i56po.types).array((0, $i56po.types).number), []),
    search: (0, $i56po.types).optional((0, $i56po.types).array((0, $i56po.types).number), []),
    details: (0, $i56po.types).maybe($c415d859b0209fa5$export$b3ebe8d72f04bb4d),
    filter: (0, $i56po.types).optional((0, $i56po.types).model({
        staff: (0, $i56po.types).optional($c415d859b0209fa5$var$SPFilterModel, {}),
        search: (0, $i56po.types).optional($c415d859b0209fa5$var$SPFilterModel, {}),
        saved: (0, $i56po.types).optional($c415d859b0209fa5$var$SPFilterModel, {})
    }), {}),
    nextPage: (0, $i56po.types).optional((0, $i56po.types).model({
        staff: (0, $i56po.types).optional((0, $i56po.types).maybeNull((0, $i56po.types).number), 1),
        saved: (0, $i56po.types).optional((0, $i56po.types).maybeNull((0, $i56po.types).number), 1),
        search: (0, $i56po.types).optional((0, $i56po.types).maybeNull((0, $i56po.types).number), 1)
    }), {})
});
const $c415d859b0209fa5$export$ce62b6119e6bdb6d = (self)=>({
        setSPFilter (spType, filter) {
            self.sp.filter[spType] = $c415d859b0209fa5$var$SPFilterModel.create(filter);
        },
        resetSPFilter (spType) {
            (0, $i56po.destroy)(self.sp.filter[spType]);
        },
        fetchSPs: (0, $i56po.flow)(function*(type, firstPage) {
            if (!firstPage && !self.sp.nextPage[type]) return;
            const { list: SPs = [], paginator: paginator } = yield self.request("post", `client/sp/${type}?page=${firstPage ? 1 : self.sp.nextPage[type]}`, self.sp.filter[type]);
            if (firstPage) {
                self.sp[type].forEach((spId)=>{
                    self.sp.SPs.delete(String(spId));
                });
                self.sp[type].clear();
            }
            SPs.forEach((sp)=>{
                self.sp.SPs.set(String(sp.id), sp);
                self.sp[type].push(sp.id);
            });
            self.sp.nextPage[type] = paginator?.next_page ?? null;
        }),
        saveSP: (0, $i56po.flow)(function*(id) {
            const sp = self.sp.SPs.get(String(id));
            if (sp) sp.is_saved = true;
            self.sp.saved.push(id);
            yield self.request("post", "client/sp/save", {
                sp_id: id
            });
        }),
        unSaveSP: (0, $i56po.flow)(function*(id) {
            const sp = self.sp.SPs.get(String(id));
            if (sp) sp.is_saved = false;
            self.sp.saved = (0, $i56po.cast)(self.sp.saved.filter((spId)=>spId !== id));
            yield self.request("post", "client/sp/un-save", {
                sp_id: id
            });
        }),
        getSPDetails: (0, $i56po.flow)(function*(id) {
            const details = yield self.request("post", "client/sp/details", {
                sp_id: id
            });
            self.sp.details = $c415d859b0209fa5$export$b3ebe8d72f04bb4d.create(details);
        }),
        updateSPDetailsSaved: (0, $i56po.flow)(function*() {
            if (self.sp.details) self.sp.details.is_saved = !self.sp.details.is_saved;
        })
    });
const $c415d859b0209fa5$export$f332f9c7bdef4d = (self)=>({
        getSPs (type) {
            return self.sp[type].map((spId)=>self.sp.SPs.get(String(spId)));
        },
        getSPFilters (type) {
            return self.sp.filter[type];
        },
        getUsedFilters (type) {
            const filter = self.sp.filter[type];
            let count = 0;
            let field;
            for(field in filter){
                const fieldValue = filter[field];
                if ((0, $4f362.isObservableArray)(fieldValue)) count += fieldValue.length > 0 ? 1 : 0;
                else count += fieldValue ? 1 : 0;
            }
            // otherwise it adds up 2 instead of 1 for these properties
            if (filter.min_experience && filter.max_experience) count -= 1;
            if (filter.min_hourly_rate && filter.max_hourly_rate) count -= 1;
            if (filter.min_height && filter.max_height) count -= 1;
            if (filter.min_age && filter.max_age) count -= 1;
            return count;
        }
    });
var $c415d859b0209fa5$export$68e7f0c69d9b78f1;
(function(SPTypes) {
    SPTypes["STAFF"] = "staff";
    SPTypes["SAVED"] = "saved";
    SPTypes["SEACH"] = "search";
})($c415d859b0209fa5$export$68e7f0c69d9b78f1 || ($c415d859b0209fa5$export$68e7f0c69d9b78f1 = {}));



var $i56po = parcelRequire("i56po");
const $0af49bfecdfb34e0$export$fbb0bcf77e3d5535 = (0, $i56po.types).model("InvitationFilter", {
    id: (0, $i56po.types).maybeNull((0, $i56po.types).number),
    JobId: (0, $i56po.types).maybeNull((0, $i56po.types).number),
    favorite_staff: (0, $i56po.types).maybeNull((0, $i56po.types).number),
    nationalilities: (0, $i56po.types).maybeNull((0, $i56po.types).array((0, $i56po.types).number)),
    certificates: (0, $i56po.types).maybeNull((0, $i56po.types).array((0, $i56po.types).number)),
    languages: (0, $i56po.types).maybeNull((0, $i56po.types).array((0, $i56po.types).number)),
    gender: (0, $i56po.types).maybeNull((0, $i56po.types).number),
    male_count: (0, $i56po.types).maybeNull((0, $i56po.types).number),
    female_count: (0, $i56po.types).maybeNull((0, $i56po.types).number),
    min_age: (0, $i56po.types).maybeNull((0, $i56po.types).number),
    max_age: (0, $i56po.types).maybeNull((0, $i56po.types).number),
    min_height: (0, $i56po.types).maybeNull((0, $i56po.types).number),
    max_height: (0, $i56po.types).maybeNull((0, $i56po.types).number),
    min_experience: (0, $i56po.types).maybeNull((0, $i56po.types).number),
    max_experience: (0, $i56po.types).maybeNull((0, $i56po.types).number),
    min_hour_rate: (0, $i56po.types).maybeNull((0, $i56po.types).number),
    max_hour_rate: (0, $i56po.types).maybeNull((0, $i56po.types).number),
    min_rate: (0, $i56po.types).maybeNull((0, $i56po.types).number),
    max_rate: (0, $i56po.types).maybeNull((0, $i56po.types).number),
    fix_rate: (0, $i56po.types).maybeNull((0, $i56po.types).number),
    created_at: (0, $i56po.types).maybeNull((0, $i56po.types).string),
    updated_at: (0, $i56po.types).maybeNull((0, $i56po.types).string),
    deleted_at: (0, $i56po.types).maybeNull((0, $i56po.types).string)
});
const $0af49bfecdfb34e0$export$b3b0ab81c5820cfe = (0, $i56po.types).model("InvitationSP", {
    SPId: (0, $i56po.types).number,
    first_name: (0, $i56po.types).string,
    last_name: (0, $i56po.types).string,
    image_url: (0, $i56po.types).maybeNull((0, $i56po.types).string),
    gender: (0, $i56po.types).number,
    nationality: (0, $i56po.types).maybeNull((0, $i56po.types).string),
    currency: (0, $i56po.types).string,
    rating: (0, $i56po.types).string,
    rate: (0, $i56po.types).maybeNull((0, $i56po.types).number),
    avalilable_shifts_ids: (0, $i56po.types).string,
    shifts_count: (0, $i56po.types).number,
    availability_count: (0, $i56po.types).number
});
const $0af49bfecdfb34e0$export$e1e469ecbc2d7652 = (0, $i56po.types).model("InvitationSPList", {
    list: (0, $i56po.types).array($0af49bfecdfb34e0$export$b3b0ab81c5820cfe),
    paginator: (0, $i56po.types).model({
        current_page: (0, $i56po.types).number,
        next_page: (0, $i56po.types).maybeNull((0, $i56po.types).number),
        per_page: (0, $i56po.types).number
    })
});
const $0af49bfecdfb34e0$export$7cc4e1865fc4ab4d = (0, $i56po.types).model("Invitation", {
    job_id: (0, $i56po.types).number,
    RateType: (0, $i56po.types).number,
    work_category_name: (0, $i56po.types).string,
    work_category_id: (0, $i56po.types).number,
    quantity: (0, $i56po.types).number,
    min_invited: (0, $i56po.types).number,
    max_invited: (0, $i56po.types).number,
    invited: (0, $i56po.types).number,
    shifts: (0, $i56po.types).array((0, $i56po.types).number),
    filter: (0, $i56po.types).maybeNull($0af49bfecdfb34e0$export$fbb0bcf77e3d5535),
    sps: (0, $i56po.types).maybe($0af49bfecdfb34e0$export$e1e469ecbc2d7652),
    invited_sps: (0, $i56po.types).maybeNull((0, $i56po.types).array($0af49bfecdfb34e0$export$b3b0ab81c5820cfe)),
    invitedIds: (0, $i56po.types).optional((0, $i56po.types).array((0, $i56po.types).number), [])
});
const $0af49bfecdfb34e0$export$f801a1977490caa6 = (self)=>({
        getInvitation: (0, $i56po.flow)(function*({ orderId: orderId, jobId: jobId, filter: filter }) {
            const SPsForJobs = yield self.request("post", "client/order/invitation/sps_list", {
                order_id: orderId,
                job_id: jobId,
                filter: filter
            });
            SPsForJobs.forEach((invitation)=>{
                if (invitation.job_id !== jobId) return;
                const storeInvitation = self.invitations.get(String(invitation.job_id));
                const previouslyInvitedIds = storeInvitation?.invitedIds ?? [];
                const apiInvitatedSPs = invitation.invited_sps ?? [];
                const invitedSPIds = apiInvitatedSPs.filter((sp)=>!previouslyInvitedIds.includes(sp.SPId)).map((sp)=>sp.SPId);
                self.invitations.set(String(invitation.job_id), {
                    ...invitation,
                    sps: invitation.sps ?? storeInvitation?.sps,
                    invitedIds: [
                        ...invitedSPIds,
                        ...previouslyInvitedIds
                    ]
                });
            });
        }),
        sendInvitations: (0, $i56po.flow)(function*(invitations) {
            yield self.request("post", "client/order/invitation/send", {
                invitations: invitations
            });
        }),
        addInvitation ({ jobId: jobId, SPId: SPId }) {
            const invitation = self.invitations.get(String(jobId));
            invitation.invitedIds = [
                ...invitation.invitedIds,
                SPId
            ];
        }
    });
const $0af49bfecdfb34e0$export$eb266b27659945da = (self)=>({
        getFiltersCountForJob (jobId) {
            const filter = self.invitations.get(String(jobId))?.filter;
            if (!filter) return 0;
            const uselessFilterProperties = [
                "JobId",
                "id",
                "created_at",
                "deleted_at",
                "updated_at",
                "min_rate",
                "max_rate"
            ];
            const switchFilterProperties = [
                "favorite_staff",
                "fix_rate"
            ];
            let filtersAmount = 0;
            Object.keys(filter).forEach((filterProperty)=>{
                if (uselessFilterProperties.includes(filterProperty)) return;
                if (switchFilterProperties.includes(filterProperty)) {
                    filtersAmount += filter[filterProperty];
                    return;
                }
                if (filter[filterProperty] !== null) filtersAmount++;
            });
            return filtersAmount;
        }
    });



var $i56po = parcelRequire("i56po");
const $c3100d78b7efbef1$export$c4f22f1eb7457697 = (0, $i56po.types).model("Region", {
    id: (0, $i56po.types).identifierNumber,
    name: (0, $i56po.types).string
});
const $c3100d78b7efbef1$export$2a558753224bf1db = (self)=>({
        getRegions: (0, $i56po.flow)(function*() {
            const regions = yield self.request("get", "common/regions?with_hidden=1");
            regions.forEach((region)=>{
                self.regions.set(String(region.id), region);
            });
        })
    });
const $c3100d78b7efbef1$export$e5a26b430e454aea = (self)=>({
        getRegionId (name) {
            return Array.from(self.regions.values()).find((region)=>region.name === name)?.id;
        },
        getRegionName (id) {
            return Array.from(self.regions.values()).find((region)=>region.id === id)?.name;
        },
        get regionsData () {
            return Array.from(self.regions.values());
        }
    });



var $i56po = parcelRequire("i56po");
const $6013d7e45fc085c9$export$ce30082d1032ee4d = (0, $i56po.types).model("Language", {
    id: (0, $i56po.types).identifierNumber,
    name: (0, $i56po.types).string
});
const $6013d7e45fc085c9$export$dac4489c49a31c05 = (self)=>({
        getLanguages: (0, $i56po.flow)(function*() {
            const languages = yield self.request("get", `common/languages`);
            languages.forEach((language)=>{
                self.languages.set(String(language.id), language);
            });
        }),
        updateUserLanguage: (0, $i56po.flow)(function*(lang) {
            yield self.request("post", "common/user/lang", undefined, {
                headers: {
                    "x-lang-code": lang
                }
            });
        })
    });
const $6013d7e45fc085c9$export$30fc06c43908889d = (self)=>({
        get languageList () {
            return Array.from(self.languages.values());
        },
        getLanguagesNames (ids) {
            return Array.from(self.languages.values()).filter((item)=>ids.includes(item.id)).map((item)=>item.name);
        },
        getLanguageIdByTitle (title) {
            return Array.from(self.languages.values()).find((language)=>language.name === title)?.id;
        }
    });




var $i56po = parcelRequire("i56po");
const $83994bbdd5d8865b$var$NotificationDataModel = (0, $i56po.types).model("data", {
    shift_id: (0, $i56po.types).maybe((0, $i56po.types).number),
    sp_id: (0, $i56po.types).maybe((0, $i56po.types).number),
    sp_ids: (0, $i56po.types).optional((0, $i56po.types).array((0, $i56po.types).number), []),
    job_id: (0, $i56po.types).maybe((0, $i56po.types).number),
    order_id: (0, $i56po.types).maybe((0, $i56po.types).number),
    document_type_id: (0, $i56po.types).maybe((0, $i56po.types).number),
    status: (0, $i56po.types).maybe((0, $i56po.types).string),
    channelId: (0, $i56po.types).maybe((0, $i56po.types).string)
});
const $83994bbdd5d8865b$var$NotificationModel = (0, $i56po.types).model("Notification", {
    id: (0, $i56po.types).identifier,
    message: (0, $i56po.types).string,
    data: $83994bbdd5d8865b$var$NotificationDataModel,
    is_read: (0, $i56po.types).optional((0, $i56po.types).boolean, false),
    popup: (0, $i56po.types).optional((0, $i56po.types).number, 0),
    popup_image: (0, $i56po.types).optional((0, $i56po.types).string, ""),
    subject: (0, $i56po.types).string,
    url: (0, $i56po.types).maybeNull((0, $i56po.types).string),
    date: (0, $i56po.types).number,
    entity_id: (0, $i56po.types).number
});
const $83994bbdd5d8865b$export$d8c5f668d71664bd = (0, $i56po.types).model("NotificationList", {
    list: (0, $i56po.types).map($83994bbdd5d8865b$var$NotificationModel),
    unreadCount: (0, $i56po.types).optional((0, $i56po.types).number, 0),
    nextPage: (0, $i56po.types).optional((0, $i56po.types).maybeNull((0, $i56po.types).number), 1)
});
const $83994bbdd5d8865b$export$c6c09ae6704c9377 = (self)=>{
    const actions = {
        fetchNotifications: (0, $i56po.flow)(function*({ page: page }) {
            if (page === 1) {
                self.notification.list.clear();
                self.notification.nextPage = 1;
            }
            if (self.notification.nextPage) {
                const { list: notifications = [], paginator: paginator } = yield self.request("post", `client/notifications/list?page=${self.notification.nextPage}`);
                notifications.forEach((notification)=>{
                    self.notification.list.set(String(notification.id), notification);
                });
                if (paginator) self.notification.nextPage = paginator.next_page;
            }
        }),
        readNotification: (0, $i56po.flow)(function*(id) {
            const notification = self.notification.list.get(id);
            yield self.request("post", "client/notifications/mark-as-read", {
                id: id
            });
            self.notification.list.set(id, {
                ...notification,
                is_read: true
            });
            return notification;
        }),
        readPushedNotification: (0, $i56po.flow)(function*(id) {
            yield self.request("post", "client/notifications/mark-as-read", {
                id: id
            });
            actions.decrementUnreadNotifications();
        }),
        getUnreadNotificationsCount: (0, $i56po.flow)(function*() {
            self.notification.unreadCount = (yield self.request("post", "client/notifications/new")).count;
        }),
        incrementUnreadNotifications: function() {
            self.notification.unreadCount++;
        },
        decrementUnreadNotifications: function() {
            self.notification.unreadCount--;
        },
        resetUnreadNotificationsCount: function(count = 0) {
            self.notification.unreadCount = count;
        }
    };
    return actions;
};
const $83994bbdd5d8865b$export$65d5f47879c8751a = (self)=>({
        get notifications () {
            return Array.from(self.notification.list.values());
        },
        get isMoreNotifications () {
            return Boolean(self.notification.nextPage);
        }
    });



var $i56po = parcelRequire("i56po");
const $726e391db8a1d625$export$c048ab2a4e893657 = 13;
const $726e391db8a1d625$export$c8968b1dd199f684 = (0, $i56po.types).model("ShiftCancelReason", {
    id: (0, $i56po.types).number,
    name: (0, $i56po.types).string
});
const $726e391db8a1d625$export$1fda8508bf6c6b0b = (self)=>({
        fetchShiftCancelReasons: (0, $i56po.flow)(function*() {
            const reasons = yield self.request("get", "common/shift-cancel-reasons");
            reasons.forEach((reason)=>{
                self.shiftCancelReasons.set(String(reason.id), reason);
            });
        })
    });
const $726e391db8a1d625$export$b6b78ea7734a9166 = (self)=>({
        get cancelReasons () {
            return Array.from(self.shiftCancelReasons.values());
        },
        getReasonIdByTitle (title) {
            return Array.from(self.shiftCancelReasons.values()).find((reason)=>reason.name === title)?.id;
        }
    });



var $i56po = parcelRequire("i56po");
const $8c029a5346b265a7$var$OrderModel = (0, $i56po.types).model({
    id: (0, $i56po.types).number,
    name: (0, $i56po.types).string,
    eventTypeName: (0, $i56po.types).string,
    locationId: (0, $i56po.types).number
});
const $8c029a5346b265a7$var$LocationModel = (0, $i56po.types).model({
    id: (0, $i56po.types).number,
    name: (0, $i56po.types).string,
    imageUrl: (0, $i56po.types).maybeNull((0, $i56po.types).string)
});
const $8c029a5346b265a7$var$WorkCategory = (0, $i56po.types).model({
    id: (0, $i56po.types).number,
    name: (0, $i56po.types).string,
    imageUrl: (0, $i56po.types).maybeNull((0, $i56po.types).string)
});
const $8c029a5346b265a7$export$4cfa4433cc872329 = (0, $i56po.types).model("ContactFilters", {
    orders: (0, $i56po.types).array($8c029a5346b265a7$var$OrderModel),
    locations: (0, $i56po.types).array($8c029a5346b265a7$var$LocationModel),
    workCategories: (0, $i56po.types).array($8c029a5346b265a7$var$WorkCategory)
});
const $8c029a5346b265a7$export$49c8bfde45b70d38 = (self)=>({
        getContactFilters: (0, $i56po.flow)(function*() {
            self.contactFilters = yield self.request("get", "common/chat/contacts/filters");
        })
    });




var $i56po = parcelRequire("i56po");
const $1dbbc2907cfe3211$var$ChannelModel = (0, $i56po.types).model({
    sid: (0, $i56po.types).string,
    friendly_name: (0, $i56po.types).string,
    last_message: (0, $i56po.types).maybe((0, $i56po.types).string),
    last_message_index: (0, $i56po.types).maybe((0, $i56po.types).number),
    last_message_time: (0, $i56po.types).maybe((0, $i56po.types).Date),
    created_at: (0, $i56po.types).maybe((0, $i56po.types).Date),
    updated_at: (0, $i56po.types).maybe((0, $i56po.types).Date),
    order_id: (0, $i56po.types).maybe((0, $i56po.types).number),
    created_by: (0, $i56po.types).string,
    unread_count: (0, $i56po.types).optional((0, $i56po.types).number, 0),
    images: (0, $i56po.types).optional((0, $i56po.types).array((0, $i56po.types).string), [])
});
const $1dbbc2907cfe3211$var$ContactJobModel = (0, $i56po.types).model({
    id: (0, $i56po.types).number,
    title: (0, $i56po.types).string,
    orderId: (0, $i56po.types).number,
    workCategoryId: (0, $i56po.types).number,
    locationId: (0, $i56po.types).number,
    startDate: (0, $i56po.types).string,
    endDate: (0, $i56po.types).string
});
const $1dbbc2907cfe3211$var$ContactModel = (0, $i56po.types).model({
    identity: (0, $i56po.types).number,
    type: (0, $i56po.types).string,
    firstName: (0, $i56po.types).string,
    lastName: (0, $i56po.types).string,
    imageUrl: (0, $i56po.types).maybeNull((0, $i56po.types).string),
    jobs: (0, $i56po.types).optional((0, $i56po.types).array($1dbbc2907cfe3211$var$ContactJobModel), [])
});
const $1dbbc2907cfe3211$var$ChatContactsFilterModel = (0, $i56po.types).model("ChatContactsFilter", {
    order_id: (0, $i56po.types).maybeNull((0, $i56po.types).number),
    location_id: (0, $i56po.types).maybeNull((0, $i56po.types).number),
    work_category_id: (0, $i56po.types).maybeNull((0, $i56po.types).number)
});
const $1dbbc2907cfe3211$export$40c4488a0e0be8c4 = (0, $i56po.types).model("ChatStore", {
    channels: (0, $i56po.types).map($1dbbc2907cfe3211$var$ChannelModel),
    contacts: (0, $i56po.types).map($1dbbc2907cfe3211$var$ContactModel),
    contactsNextPage: (0, $i56po.types).optional((0, $i56po.types).maybeNull((0, $i56po.types).number), 1),
    filter: (0, $i56po.types).optional($1dbbc2907cfe3211$var$ChatContactsFilterModel, {})
});
const $1dbbc2907cfe3211$export$9161057cd6914172 = (self)=>({
        getToken: (0, $i56po.flow)(function*() {
            return yield self.request("post", "common/chat/twilio/token");
        }),
        setChannels (channels) {
            self.chat.channels.clear();
            channels.forEach((channel)=>{
                self.chat.channels.set(channel.sid, channel);
            });
        },
        addChannel (channel) {
            self.chat.channels.set(channel.sid, channel);
        },
        addChannels (channels) {
            channels.forEach((channel)=>{
                self.chat.channels.set(channel.sid, channel);
            });
        },
        updateChannel: (0, $i56po.flow)(function*(channel) {
            const foundChannel = self.chat.channels.get(channel.sid);
            self.chat.channels.set(channel.sid, {
                ...foundChannel,
                ...channel
            });
        }),
        updateChannelLastMessage (channelId, last_message, last_message_time) {
            const channel = self.chat.channels.get(channelId);
            self.chat.channels.set(channelId, {
                ...channel,
                last_message: last_message,
                last_message_time: new Date(last_message_time)
            });
        },
        removeChannel (channelId) {
            self.chat.channels.delete(channelId);
        },
        getChatContacts: (0, $i56po.flow)(function*(firstPage) {
            if (!firstPage && !self.chat.contactsNextPage) return;
            const url = new URL("common/chat/contacts");
            url.searchParams.append("page", String(firstPage ? 1 : self.chat.contactsNextPage));
            const filter = self.chat.filter;
            if (filter.order_id) url.searchParams.append("order_id", String(filter.order_id));
            if (filter.location_id) url.searchParams.append("location_id", String(filter.location_id));
            if (filter.work_category_id) url.searchParams.append("work_category_id", String(filter.work_category_id));
            const { list: contacts = [], paginator: paginator } = yield self.request("get", url.toString());
            if (firstPage) self.chat.contacts.clear();
            contacts.forEach((contact)=>{
                self.chat.contacts.set(String(contact.identity), contact);
            });
            self.chat.contactsNextPage = paginator?.next_page ?? null;
        }),
        createChatChannel: (0, $i56po.flow)(function*(params) {
            const chatChannel = yield self.request("post", "common/chat/channels", params);
            const createdChannel = {
                ...chatChannel,
                created_by: "system"
            };
            self.chat.channels.set(String(chatChannel.sid), createdChannel);
            return chatChannel;
        }),
        getChatMembers: (0, $i56po.flow)(function*(channelId) {
            const chatMembers = yield self.request("get", `common/chat/channels/${channelId}/members`);
            return chatMembers;
        }),
        setChatContactsFilter (filter) {
            self.chat.filter = $1dbbc2907cfe3211$var$ChatContactsFilterModel.create(filter);
        },
        resetChatContactsFilter () {
            (0, $i56po.destroy)(self.chat.filter);
        }
    });
const $1dbbc2907cfe3211$export$4a1fb45ec758d706 = (self)=>({
        get channels () {
            const channels = Array.from(self.chat.channels.values());
            return channels.sort((channelA, channelB)=>Number(channelB.last_message_time) - Number(channelA.last_message_time));
        },
        get chatContacts () {
            const chatContacts = Array.from(self.chat.contacts.values());
            return chatContacts.reduce((orderGroups, contact)=>contact.jobs.reduce((orders, job)=>{
                    const foundOrder = orders.find((order)=>order.orderId === job.orderId);
                    if (foundOrder) {
                        const foundWorkCategory = foundOrder.workCategories.find((workCategory)=>workCategory.workCategoryId === job.workCategoryId);
                        const foundSP = foundWorkCategory?.sps.find((sp)=>sp.id === contact.identity);
                        if (foundWorkCategory && foundSP) return orders;
                        const sp = $1dbbc2907cfe3211$var$createNewSP(contact);
                        if (foundWorkCategory) {
                            foundWorkCategory.sps = foundWorkCategory.sps.concat(sp);
                            return orders.map((order)=>order.orderId === foundOrder.orderId ? {
                                    ...order,
                                    workCategories: order.workCategories.map((w)=>w.workCategoryId === foundWorkCategory.workCategoryId ? foundWorkCategory : w)
                                } : order);
                        }
                        const newWorkCategory = $1dbbc2907cfe3211$var$createNewWorkCategory(job, sp);
                        return orders.map((order)=>order.orderId === foundOrder.orderId ? {
                                ...order,
                                workCategories: order.workCategories.concat(newWorkCategory)
                            } : order);
                    }
                    const sp = $1dbbc2907cfe3211$var$createNewSP(contact);
                    const newWorkCategory = $1dbbc2907cfe3211$var$createNewWorkCategory(job, sp);
                    const newOrder = {
                        orderId: job.orderId,
                        title: job.title,
                        workCategories: [
                            newWorkCategory
                        ]
                    };
                    return orders.concat(newOrder);
                }, orderGroups), []);
        },
        get chatContactsFilterCount () {
            let count = 0;
            count += self.chat.filter.order_id ? 1 : 0;
            count += self.chat.filter.location_id ? 1 : 0;
            count += self.chat.filter.work_category_id ? 1 : 0;
            return count;
        },
        get unreadCounts () {
            let count = 0;
            self.chat.channels.forEach((channel)=>{
                count += channel.unread_count;
            });
            return count;
        }
    });
function $1dbbc2907cfe3211$var$createNewSP(contact) {
    return {
        id: contact.identity,
        name: `${contact.firstName} ${contact.lastName}`,
        imageUrl: contact.imageUrl
    };
}
function $1dbbc2907cfe3211$var$createNewWorkCategory(job, sp) {
    return {
        workCategoryId: job.workCategoryId,
        title: job.title,
        sps: [
            sp
        ]
    };
}



var $i56po = parcelRequire("i56po");
const $36e83141adffbc68$export$65354c902f10533e = (self)=>({
        submitLeadForm: (0, $i56po.flow)(function*(params) {
            const { categories: categories, days: days, language_ids: language_ids, location: location, gender: gender, ...form } = params;
            for (const [work_category_id, sp_max_quantity] of Object.entries(categories)){
                const formData = new FormData();
                const submitObject = {
                    ...form,
                    work_category_id: work_category_id,
                    sp_max_quantity: sp_max_quantity
                };
                Object.entries(submitObject).forEach(([key, value])=>{
                    formData.append(key, String(value));
                });
                days.forEach((day)=>{
                    formData.append("days[]", day);
                });
                language_ids.forEach((lang)=>{
                    formData.append("language_ids[]", String(lang));
                });
                formData.append("location[address]", location.address);
                formData.append("location[lat]", String(location.lat));
                formData.append("location[lng]", String(location.lng));
                if (gender !== null) formData.append("gender", String(gender));
                yield self.request("post", "common/lead/create", formData);
            }
        })
    });



var $i56po = parcelRequire("i56po");
const $dec578872418ee32$var$SPModel = (0, $i56po.types).model("SPModel", {
    id: (0, $i56po.types).number,
    name: (0, $i56po.types).string,
    image: (0, $i56po.types).string
});
const $dec578872418ee32$var$ActiveShiftModel = (0, $i56po.types).model("ActiveShiftModel", {
    id: (0, $i56po.types).number,
    status_id: (0, $i56po.types).number,
    client_checkin_time: (0, $i56po.types).maybeNull((0, $i56po.types).string),
    client_checkout_time: (0, $i56po.types).maybeNull((0, $i56po.types).string),
    hours: (0, $i56po.types).number,
    sp: $dec578872418ee32$var$SPModel
});
const $dec578872418ee32$export$1cef7f4f17f9157e = (0, $i56po.types).model("Shift", {
    id: (0, $i56po.types).number,
    start_time: (0, $i56po.types).string,
    end_time: (0, $i56po.types).string,
    time_to_auto_confirm: (0, $i56po.types).number,
    pending_shifts: (0, $i56po.types).number,
    job_id: (0, $i56po.types).number,
    work_category_name: (0, $i56po.types).string,
    client_location_name: (0, $i56po.types).string,
    order_id: (0, $i56po.types).number,
    active_shifts: (0, $i56po.types).array($dec578872418ee32$var$ActiveShiftModel)
});
const $dec578872418ee32$export$45d0b9d18688f34e = (self)=>({
        fetchAttendanceReportJob: (0, $i56po.flow)(function*({ clientLocationId: clientLocationId, workCategoryId: workCategoryId }) {
            const params = new URLSearchParams();
            if (clientLocationId) params.set("client_location_id", String(clientLocationId));
            if (workCategoryId) params.set("work_category_id", String(workCategoryId));
            const query = params.toString();
            const url = query ? `client/attendance/shifts/v2?${query}` : "client/attendance/shifts/v2";
            const shifts = (yield self.request("get", url)).list;
            self.attendanceReportJob.clear();
            shifts.forEach((shift)=>{
                self.attendanceReportJob.set(String(shift.id), shift);
            });
        }),
        updateAttendanceReportShift: (0, $i56po.flow)(function*(updatedAttendance) {
            yield self.request("post", `client/attendance/shifts/process`, updatedAttendance);
        })
    });
const $dec578872418ee32$export$8f2dcdc01d41ca0e = (self)=>({
        attendanceReportJobView () {
            return Array.from(self.attendanceReportJob.values());
        }
    });



var $i56po = parcelRequire("i56po");
const $d112073eb1ddf143$export$e6eb6b5fe06b58e7 = (0, $i56po.types).model("CherryPickingJob", {
    id: (0, $i56po.types).identifierNumber,
    type: (0, $i56po.types).number,
    work_category_name: (0, $i56po.types).string,
    location_name: (0, $i56po.types).string,
    required_quantity: (0, $i56po.types).maybeNull((0, $i56po.types).number),
    quantity: (0, $i56po.types).maybeNull((0, $i56po.types).number),
    start_date: (0, $i56po.types).string,
    end_date: (0, $i56po.types).string,
    shifts_count: (0, $i56po.types).number,
    shifts_fulfilled_count: (0, $i56po.types).number,
    applicants_count: (0, $i56po.types).maybeNull((0, $i56po.types).number)
});
const $d112073eb1ddf143$export$338b1993d9f8ba6f = (0, $i56po.types).model("CherryPickingJobList", {
    map: (0, $i56po.types).map($d112073eb1ddf143$export$e6eb6b5fe06b58e7),
    nextPage: (0, $i56po.types).optional((0, $i56po.types).maybeNull((0, $i56po.types).number), 1)
});
const $d112073eb1ddf143$export$df058e6cff1e9883 = (self)=>({
        getCherryPickingJob: (0, $i56po.flow)(function*(jobId) {
            const job = yield self.request("get", `client/cherry-picking/job-details?job_id=${jobId}`);
            self.cherryPickingJobs.map.set(String(job.id), job);
        }),
        getUnFullfilledJobList: (0, $i56po.flow)(function*(page) {
            if (page === 1) {
                self.cherryPickingJobs.map.clear();
                self.cherryPickingJobs.nextPage = 1;
            }
            const nextPage = self.cherryPickingJobs.nextPage;
            if (nextPage) {
                const { list: list, paginator: paginator } = yield self.request("get", `client/cherry-picking/unfulfilled-jobs?page=${nextPage}`);
                list.forEach((item)=>{
                    self.cherryPickingJobs.map.set(String(item.id), item);
                });
                self.cherryPickingJobs.nextPage = paginator?.next_page ?? null;
            }
        })
    });
const $d112073eb1ddf143$export$78d794ee0dee8822 = (self)=>({
        getCherryPickingByIdView: (jobId)=>{
            return self.cherryPickingJobs.map.get(jobId);
        },
        get cherryPickingListView () {
            return Array.from(self.cherryPickingJobs.map.values());
        }
    });



var $i56po = parcelRequire("i56po");


var $i56po = parcelRequire("i56po");
const $22cd03eac392c42d$export$e65529098bfba2da = (0, $i56po.types).model("Paginator", {
    current_page: (0, $i56po.types).number,
    next_page: (0, $i56po.types).maybeNull((0, $i56po.types).number),
    per_page: (0, $i56po.types).number,
    last_page: (0, $i56po.types).number,
    total: (0, $i56po.types).number
});
const $22cd03eac392c42d$export$2ffdb49739e859c0 = (self)=>({
        get apiHost () {
            return (0, $i56po.getEnv)(self).api.api.defaults.baseURL;
        }
    });


var $1a7db182178118f7$export$41c5030382f95eb6;
(function(ApplicantStatus) {
    ApplicantStatus[ApplicantStatus["PENDING"] = 1] = "PENDING";
    ApplicantStatus[ApplicantStatus["SHORTLISTED"] = 2] = "SHORTLISTED";
    ApplicantStatus[ApplicantStatus["REJECTED"] = 3] = "REJECTED";
})($1a7db182178118f7$export$41c5030382f95eb6 || ($1a7db182178118f7$export$41c5030382f95eb6 = {}));
const $1a7db182178118f7$var$SkillModel = (0, $i56po.types).model("SkillModel", {
    id: (0, $i56po.types).identifierNumber,
    name: (0, $i56po.types).string,
    rating: (0, $i56po.types).number,
    work_category_name: (0, $i56po.types).string,
    icon: (0, $i56po.types).maybeNull((0, $i56po.types).string),
    is_matched: (0, $i56po.types).boolean
});
const $1a7db182178118f7$var$CheeryPickingApplicantModel = (0, $i56po.types).model("CheeryPickingApplicant", {
    applicant_id: (0, $i56po.types).identifierNumber,
    applicant_name: (0, $i56po.types).string,
    image_url: (0, $i56po.types).maybeNull((0, $i56po.types).string),
    rating: (0, $i56po.types).maybeNull((0, $i56po.types).number),
    nationality: (0, $i56po.types).maybeNull((0, $i56po.types).string),
    years_experience: (0, $i56po.types).number,
    seniority_level: (0, $i56po.types).model({
        name: (0, $i56po.types).string,
        id: (0, $i56po.types).number
    }),
    past_jobs: (0, $i56po.types).array((0, $i56po.types).model({
        id: (0, $i56po.types).number,
        designation_name: (0, $i56po.types).string,
        location_name: (0, $i56po.types).string,
        start_date: (0, $i56po.types).string,
        end_date: (0, $i56po.types).maybeNull((0, $i56po.types).string)
    })),
    applicant_languages: (0, $i56po.types).array((0, $i56po.types).string),
    age: (0, $i56po.types).maybeNull((0, $i56po.types).number),
    height: (0, $i56po.types).maybeNull((0, $i56po.types).number),
    completed_shifts_count: (0, $i56po.types).number,
    top_qualities: (0, $i56po.types).maybeNull((0, $i56po.types).array((0, $i56po.types).string)),
    is_favorite: 1,
    is_accepted: 1,
    is_chief: (0, $i56po.types).boolean,
    skills: (0, $i56po.types).array($1a7db182178118f7$var$SkillModel),
    skillMatch: (0, $i56po.types).number
}).views((self)=>({
        get id () {
            return self.applicant_id;
        },
        get image () {
            return self.image_url;
        },
        get name () {
            return self.applicant_name;
        },
        get languages () {
            return self.applicant_languages;
        },
        get isAccepted () {
            return self.is_accepted === 1;
        },
        get isRejected () {
            return false;
        }
    }));
const $1a7db182178118f7$var$CherryPickingApplicantOfPermanentJobModel = (0, $i56po.types).model("CherryPickingApplicantOfPermanentJob", {
    job_application_id: (0, $i56po.types).identifierNumber,
    client_status_id: (0, $i56po.types).number,
    full_name: (0, $i56po.types).maybeNull((0, $i56po.types).string),
    profile_photo: (0, $i56po.types).maybeNull((0, $i56po.types).string),
    fullbody_photo: (0, $i56po.types).maybeNull((0, $i56po.types).string),
    age: (0, $i56po.types).maybeNull((0, $i56po.types).number),
    spoken_languages: (0, $i56po.types).array((0, $i56po.types).string),
    nationality: (0, $i56po.types).maybeNull((0, $i56po.types).string),
    location: (0, $i56po.types).maybeNull((0, $i56po.types).string),
    gender: (0, $i56po.types).maybeNull((0, $i56po.types).string),
    education: (0, $i56po.types).maybeNull((0, $i56po.types).string),
    video: (0, $i56po.types).maybeNull((0, $i56po.types).string),
    experience: (0, $i56po.types).maybeNull((0, $i56po.types).array((0, $i56po.types).model("ApplicantExperience", {
        work_category_name: (0, $i56po.types).maybeNull((0, $i56po.types).string),
        company_name: (0, $i56po.types).maybeNull((0, $i56po.types).string),
        location_name: (0, $i56po.types).maybeNull((0, $i56po.types).string),
        description: (0, $i56po.types).maybeNull((0, $i56po.types).string),
        duration: (0, $i56po.types).maybeNull((0, $i56po.types).string)
    })))
}).views((self)=>({
        get id () {
            return self.job_application_id;
        },
        get image () {
            return self.profile_photo;
        },
        get name () {
            return self.full_name;
        },
        get languages () {
            return self.spoken_languages;
        },
        get isAccepted () {
            return self.client_status_id === 2;
        },
        get isRejected () {
            return self.client_status_id === 3;
        }
    }));
const $1a7db182178118f7$export$6269ca0bb51d3a14 = (0, $i56po.types).model("CherryPickingApplicants", {
    list: (0, $i56po.types).optional((0, $i56po.types).map($1a7db182178118f7$var$CheeryPickingApplicantModel), {}),
    currentApplicant: (0, $i56po.types).maybeNull((0, $i56po.types).reference($1a7db182178118f7$var$CheeryPickingApplicantModel)),
    paginator: (0, $i56po.types).maybeNull((0, $22cd03eac392c42d$export$e65529098bfba2da))
});
const $1a7db182178118f7$export$ef971fd9f34b465c = (0, $i56po.types).model("CherryPickingApplicantsOfPermanentJob", {
    list: (0, $i56po.types).optional((0, $i56po.types).map($1a7db182178118f7$var$CherryPickingApplicantOfPermanentJobModel), {}),
    currentApplicant: (0, $i56po.types).maybeNull((0, $i56po.types).reference($1a7db182178118f7$var$CherryPickingApplicantOfPermanentJobModel)),
    paginator: (0, $i56po.types).maybeNull((0, $22cd03eac392c42d$export$e65529098bfba2da))
});
const $1a7db182178118f7$export$6557d250a0badf3f = (self)=>({
        getCherryPickingApplicantsApiCall: (0, $i56po.flow)(function*({ jobId: jobId, jobType: jobType, page: page = 1, sortBy: sortBy, sortDirection: sortDirection = "DESC", shiftId: shiftId }) {
            if (jobType === (0, $862a04ca6e0d681b$export$27a7f855854fa13d).permanent) {
                const response = yield self.request("get", `client/cherry-picking/permanent-jobs/${jobId}/applicants`, undefined, {
                    params: {
                        page: page,
                        sort_by: sortBy,
                        sort_direction: sortDirection
                    }
                });
                if (page === 1) {
                    self.cherryPickingApplicantsOfPermanentJob.list.clear();
                    self.cherryPickingApplicantsOfPermanentJob.currentApplicant = null;
                }
                response.list.forEach((applicant)=>{
                    const age = applicant.age !== null ? Number(applicant.age) : null;
                    self.cherryPickingApplicantsOfPermanentJob.list.set(String(applicant.job_application_id), {
                        ...applicant,
                        age: age
                    });
                });
                self.cherryPickingApplicantsOfPermanentJob.paginator = response.paginator;
            } else {
                const response = yield self.request("get", "client/cherry-picking/applicants", undefined, {
                    params: {
                        job_id: jobId,
                        shift_id: shiftId,
                        sort_by: sortBy,
                        sort_direction: sortDirection,
                        page: page
                    }
                });
                if (page === 1) {
                    self.cherryPickingApplicants.list.clear();
                    self.cherryPickingApplicants.currentApplicant = null;
                }
                response.list.forEach((applicant)=>{
                    self.cherryPickingApplicants.list.set(String(applicant.id), {
                        ...applicant,
                        applicant_id: applicant.id,
                        applicant_name: applicant.name,
                        applicant_languages: applicant.languages
                    });
                });
                self.cherryPickingApplicants.paginator = response.paginator;
            }
        }),
        acceptApplicantApiCall: (0, $i56po.flow)(function*({ job_id: job_id, sp_id: sp_id, shift_ids: shift_ids }) {
            const response = yield self.request("post", `client/cherry-picking/applicants/accept`, {
                job_id: job_id,
                sp_id: sp_id,
                shift_ids: shift_ids
            });
            const job = self.cherryPickingJobs.map.get(String(job_id));
            if (job) {
                job.shifts_fulfilled_count = response.shifts_fulfilled_count;
                self.cherryPickingJobs.map.set(String(job.id), job);
            }
            const applicant = self.cherryPickingApplicants.list.get(sp_id);
            if (applicant) {
                applicant.is_accepted = 1;
                self.cherryPickingApplicants.list.set(String(applicant.id), applicant);
            }
        }),
        acceptApplicantOfPermanentJob: (0, $i56po.flow)(function*({ job_application_id: job_application_id }) {
            yield self.request("post", "client/cherry-picking/permanent-jobs/applicants/change-status", {
                job_application_id: job_application_id,
                client_status_id: 2
            });
            const applicant = self.cherryPickingApplicantsOfPermanentJob.list.get(job_application_id);
            if (applicant) applicant.client_status_id = 2;
        }),
        rejectApplicantApiCall: (0, $i56po.flow)(function*({ job_id: job_id, sp_id: sp_id }) {
            yield self.request("post", `client/cherry-picking/applicants/reject`, {
                job_id: job_id,
                sp_id: sp_id
            });
            self.cherryPickingApplicants.currentApplicant = null;
            self.cherryPickingApplicants.list.delete(sp_id);
            if (self.cherryPickingApplicants.paginator) self.cherryPickingApplicants.paginator.total = self.cherryPickingApplicants.paginator.total - 1;
        }),
        rejectApplicantOfPermanentJob: (0, $i56po.flow)(function*({ job_application_id: job_application_id }) {
            yield self.request("post", "client/cherry-picking/permanent-jobs/applicants/change-status", {
                job_application_id: job_application_id,
                client_status_id: 3
            });
            const applicant = self.cherryPickingApplicantsOfPermanentJob.list.get(job_application_id);
            if (applicant) applicant.client_status_id = 3;
        }),
        toggleApplicantAsFavouriteApiCall: (0, $i56po.flow)(function*(sp_id) {
            const applicant = self.cherryPickingApplicants.list.get(sp_id);
            if (applicant) {
                if (applicant.is_favorite) {
                    applicant.is_favorite = 0;
                    yield self.request("post", "client/sp/un-save", {
                        sp_id: sp_id
                    });
                } else {
                    applicant.is_favorite = 1;
                    yield self.request("post", "client/sp/save", {
                        sp_id: sp_id
                    });
                }
                self.cherryPickingApplicants.list.set(String(applicant.id), applicant);
            }
        }),
        toggleCurrentApplicantAsFavouriteApiCall: (0, $i56po.flow)(function*() {
            const applicant = self.cherryPickingApplicants.currentApplicant;
            if (applicant) {
                if (applicant.is_favorite) {
                    applicant.is_favorite = 0;
                    yield self.request("post", "client/sp/un-save", {
                        sp_id: applicant.id
                    });
                } else {
                    applicant.is_favorite = 1;
                    yield self.request("post", "client/sp/save", {
                        sp_id: applicant.id
                    });
                }
            }
        }),
        getApplicant: (0, $i56po.flow)(function*(jobId, spId) {
            const currentApplicant = yield self.request("get", `client/cherry-picking/jobs/${jobId}/applicants/${spId}`);
            if (!self.cherryPickingApplicants.list.has(currentApplicant.id)) self.cherryPickingApplicants.list.set(String(currentApplicant.id), {
                ...currentApplicant,
                applicant_id: currentApplicant.id,
                applicant_name: currentApplicant.name,
                applicant_languages: currentApplicant.languages
            });
            self.cherryPickingApplicants.currentApplicant = self.cherryPickingApplicants.list.get(currentApplicant.id);
            return currentApplicant;
        }),
        setCurrentApplicant (applicantId, jobType) {
            if (jobType === (0, $862a04ca6e0d681b$export$27a7f855854fa13d).permanent) {
                const applicant = self.cherryPickingApplicantsOfPermanentJob.list.get(String(applicantId));
                if (!applicant) throw new Error(`Applicant with id ${applicantId} not found`);
                self.cherryPickingApplicantsOfPermanentJob.currentApplicant = applicant;
                return;
            }
            const applicant = self.cherryPickingApplicants.list.get(String(applicantId));
            if (!applicant) throw new Error(`Applicant with id ${applicantId} not found`);
            self.cherryPickingApplicants.currentApplicant = applicant;
        },
        clearCurrentApplicant (jobType) {
            if (jobType === (0, $862a04ca6e0d681b$export$27a7f855854fa13d).permanent) self.cherryPickingApplicantsOfPermanentJob.currentApplicant = null;
            else self.cherryPickingApplicants.currentApplicant = null;
        }
    });
const $1a7db182178118f7$export$7f5f084e8d9a78d3 = (self)=>({
        applicantsView (jobType) {
            if (jobType === (0, $862a04ca6e0d681b$export$27a7f855854fa13d).permanent) return {
                list: Array.from(self.cherryPickingApplicantsOfPermanentJob.list.values()),
                paginator: self.cherryPickingApplicantsOfPermanentJob.paginator
            };
            return {
                list: Array.from(self.cherryPickingApplicants.list.values()),
                paginator: self.cherryPickingApplicants.paginator
            };
        },
        getApplicantById (id, jobType) {
            if (jobType === (0, $862a04ca6e0d681b$export$27a7f855854fa13d).permanent) return Array.from(self.cherryPickingApplicantsOfPermanentJob.list.values()).find((item)=>item.job_application_id === id);
            return Array.from(self.cherryPickingApplicants.list.values()).find((item)=>item.id === id);
        },
        getNotAcceptedApplicantsList (jobType) {
            if (jobType === (0, $862a04ca6e0d681b$export$27a7f855854fa13d).permanent) return Array.from(self.cherryPickingApplicantsOfPermanentJob.list.values()).filter((applicant)=>applicant.client_status_id !== 2);
            return Array.from(self.cherryPickingApplicants.list.values()).filter((applicant)=>applicant.is_accepted === 0);
        },
        getCurrentApplicant (jobType) {
            if (jobType === (0, $862a04ca6e0d681b$export$27a7f855854fa13d).permanent) return self.cherryPickingApplicantsOfPermanentJob.currentApplicant;
            return self.cherryPickingApplicants.currentApplicant;
        },
        get skillsGroupedByCategory () {
            const applicant = self.cherryPickingApplicants.currentApplicant;
            if (!applicant) return [];
            const groupedSkills = applicant.skills.reduce((result, skill)=>{
                const workCategoryName = skill.work_category_name;
                // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
                if (!result[workCategoryName]) result[workCategoryName] = {
                    workCategoryName: workCategoryName,
                    skills: []
                };
                result[workCategoryName].skills.push(skill);
                return result;
            }, {});
            return Object.values(groupedSkills);
        }
    });



var $i56po = parcelRequire("i56po");
const $8816855e34c181f6$export$ddeb147e905cd03f = (0, $i56po.types).model("Statistics", {
    pending_payments_count: (0, $i56po.types).number,
    shifts_need_confirm_count: (0, $i56po.types).number,
    orders_need_confirm_count: (0, $i56po.types).number,
    unfulfilled_jobs_count: (0, $i56po.types).number,
    pending_ratings_count: (0, $i56po.types).number,
    referrals_count: (0, $i56po.types).number,
    raised_disputes_count: (0, $i56po.types).number
});
const $8816855e34c181f6$export$bfcbf8ecd6763f36 = (self)=>({
        getStatistics: (0, $i56po.flow)(function*() {
            self.statistics = yield self.request("get", "client/home/statistics");
        }),
        decreasePendingRatingsCount: ()=>{
            if (self.statistics) self.statistics.pending_ratings_count -= 1;
        }
    });



var $i56po = parcelRequire("i56po");
const $1307fd361ee59300$export$1beca27353df06fb = (0, $i56po.types).model("PointsOfContacts", {
    id: (0, $i56po.types).identifierNumber,
    first_name: (0, $i56po.types).string,
    last_name: (0, $i56po.types).string,
    phone: (0, $i56po.types).string,
    email: (0, $i56po.types).string,
    image: (0, $i56po.types).maybeNull((0, $i56po.types).string),
    roles: (0, $i56po.types).array((0, $i56po.types).number),
    client_locations: (0, $i56po.types).maybeNull((0, $i56po.types).array((0, $i56po.types).number))
});
const $1307fd361ee59300$export$5472e97408541162 = (self)=>({
        getPointsOfContact: (0, $i56po.flow)(function*({ locationId: locationId }) {
            self.pointsOfContact = yield self.request("get", `client/pocs${locationId !== undefined ? `?location_id=${locationId}` : ""}`);
            return self.pointsOfContact;
        }),
        addNewContact: (0, $i56po.flow)(function*(form) {
            yield self.request("post", "client/pocs", form, {
                headers: {
                    "Content-Type": "multipart/form-data"
                }
            });
        }),
        updateContact: (0, $i56po.flow)(function*(form) {
            yield self.request("post", `client/pocs/${form.id}`, form, {
                headers: {
                    "Content-Type": "multipart/form-data"
                }
            });
        }),
        inviteUser: (0, $i56po.flow)(function*(form) {
            yield self.request("post", "client/pocs/invite", form, {
                headers: {
                    "Content-Type": "multipart/form-data"
                }
            });
        }),
        deleteContact: (0, $i56po.flow)(function*(id) {
            const indexOfContact = self.pointsOfContact?.findIndex((contact)=>contact.id === id);
            if (indexOfContact) self.pointsOfContact?.splice(indexOfContact, 1);
            yield self.request("delete", `client/pocs/${id}`);
        }),
        markClientCreatedPOCs: (0, $i56po.flow)(function*() {
            if (self.companyDetails) self.companyDetails.is_pocs_created = 1;
            yield self.request("post", "client/pocs/mark-client-created-pocs");
        }),
        confirmClientInvitation: (0, $i56po.flow)(function*(invitedClientId) {
            yield self.request("post", `client/pocs/confirm-client-invitation/${invitedClientId}`);
        })
    });
const $1307fd361ee59300$export$d1d7b6b2a980356d = (self)=>({
        getContactById (id) {
            return self.pointsOfContact?.find((contact)=>contact.id === id);
        },
        getContactIdByTitle (fullName) {
            const [firstName, lastName] = fullName.split(" ");
            return self.pointsOfContact?.find((contact)=>contact.first_name === firstName && contact.last_name === lastName)?.id;
        },
        getContactFullName (id) {
            const poc = self.pointsOfContact?.find((contact)=>contact.id === id);
            if (poc) return `${poc.first_name} ${poc.last_name}`;
        }
    });



var $i56po = parcelRequire("i56po");
const $2f5f7352d371bb4d$export$598357dd273a64fc = (0, $i56po.types).model("ApplicantExperience", {
    experiences: (0, $i56po.types).array((0, $i56po.types).model({
        work_category_name: (0, $i56po.types).string,
        image_url: (0, $i56po.types).string,
        company_name: (0, $i56po.types).string,
        location_name: (0, $i56po.types).string,
        start_year: (0, $i56po.types).maybeNull((0, $i56po.types).number),
        end_year: (0, $i56po.types).maybeNull((0, $i56po.types).number),
        description: (0, $i56po.types).maybeNull((0, $i56po.types).string),
        experience_months: (0, $i56po.types).maybeNull((0, $i56po.types).number),
        is_main_experience: (0, $i56po.types).boolean
    })),
    educations: (0, $i56po.types).array((0, $i56po.types).model({
        school: (0, $i56po.types).string,
        degree: (0, $i56po.types).string,
        study: (0, $i56po.types).string
    }))
});
const $2f5f7352d371bb4d$export$f8ce80a0ae476c88 = (self)=>({
        getSPExperience: (0, $i56po.flow)(function*({ jobId: jobId, spId: spId }) {
            const experiences = yield self.request("get", `client/cherry-picking/experiences?job_id=${jobId}&sp_id=${spId}`);
            self.applicantsExperience.set(spId, experiences);
        })
    });
const $2f5f7352d371bb4d$export$7969e5a5385f7df2 = (self)=>({
        getExperienceBySpId (id) {
            return self.applicantsExperience.get(id);
        }
    });



var $i56po = parcelRequire("i56po");
const $8d3f5ea5772a905b$export$c6691e946810bd1d = (0, $i56po.types).model("RatingCriteria", {
    id: (0, $i56po.types).identifierNumber,
    name: (0, $i56po.types).string,
    type: (0, $i56po.types).string
});
const $8d3f5ea5772a905b$export$f74f7ae84d2af7f4 = (self)=>({
        getRatingCriteries: (0, $i56po.flow)(function*() {
            const criterias = yield self.request("get", "common/rating_criteria");
            criterias.forEach((criteria)=>{
                self.ratingCriteries.set(String(criteria.id), criteria);
            });
        })
    });
const $8d3f5ea5772a905b$export$6fba4e5cdd7f005c = (self)=>({
        get criteriesArray () {
            return Array.from(self.ratingCriteries.values());
        },
        get negativeCriteries () {
            return Array.from(self.ratingCriteries.values()).filter((criteria)=>criteria.type === "negative");
        },
        get positiveCriteries () {
            return Array.from(self.ratingCriteries.values()).filter((criteria)=>criteria.type === "positive");
        }
    });



var $i56po = parcelRequire("i56po");
const $a3de59097f70cb47$export$14a4eb6b50dd28fe = (0, $i56po.types).model("WorkRequirement", {
    id: (0, $i56po.types).identifierNumber,
    name: (0, $i56po.types).string,
    is_default: (0, $i56po.types).number
});
const $a3de59097f70cb47$export$a3bd37b1644ab6a6 = (self)=>({
        getWorkRequirements: (0, $i56po.flow)(function*(workCategoryId) {
            const workRequirements = yield self.request("get", `client/work-requirements?work_category_id=${workCategoryId}`);
            self.workCategoryRequirements.set(String(workCategoryId), workRequirements);
            return self.workCategoryRequirements.get(String(workCategoryId));
        }),
        addRequirement: (0, $i56po.flow)(function*(params) {
            yield self.request("post", "client/work-requirements", {
                work_category_id: params.workCategoryId,
                name: params.name
            });
        })
    });
const $a3de59097f70cb47$export$68c1757e9db1e843 = (self)=>({
        getWorkCategoryRequirements (workCategoryId) {
            return self.workCategoryRequirements.get(String(workCategoryId));
        },
        getWorkCategoryRequirementsNames (workCategoryId, ids) {
            return self.workCategoryRequirements.get(String(workCategoryId))?.filter((item)=>ids.includes(item.id)).map((item)=>item.name);
        },
        workCategoryHasSpecializations (workCategoryId) {
            const specializations = self.workCategoryRequirements.get(String(workCategoryId))?.filter((item)=>item.is_default !== 1) ?? [];
            return specializations.length > 1;
        }
    });



var $i56po = parcelRequire("i56po");
const $ef22a2a50bd6fe1f$export$ac98711d2bef8423 = (0, $i56po.types).model("Nationality", {
    id: (0, $i56po.types).identifierNumber,
    name: (0, $i56po.types).string,
    ethnicity_id: (0, $i56po.types).maybeNull((0, $i56po.types).number),
    ethnicity_name: (0, $i56po.types).maybeNull((0, $i56po.types).string),
    is_ethnicity: (0, $i56po.types).boolean
});
const $ef22a2a50bd6fe1f$export$bd8c36c59889cd78 = (self)=>({
        getNationalities: (0, $i56po.flow)(function*() {
            const nationalities = yield self.request("get", "common/nationalities?with_ethnicity=1");
            nationalities.forEach((nationality)=>{
                self.nationalities.set(String(nationality.id), {
                    ...nationality,
                    is_ethnicity: false
                });
            });
        })
    });
const $ef22a2a50bd6fe1f$export$a31645b7ae0fc8a6 = (self)=>({
        get allNationalities () {
            return Array.from(self.nationalities.values());
        },
        nationalitiesList (onlyEthnicities = true) {
            const nationalities = Array.from(self.nationalities.values());
            const ethnicities = [];
            nationalities.forEach((nationality)=>{
                if (nationality.ethnicity_id && !ethnicities.find((item)=>item.id === nationality.ethnicity_id)) ethnicities.push({
                    id: nationality.ethnicity_id,
                    name: String(nationality.ethnicity_name),
                    ethnicity_id: null,
                    ethnicity_name: null,
                    is_ethnicity: true
                });
            });
            return [
                ...ethnicities,
                ...onlyEthnicities ? [] : nationalities
            ];
        },
        getNationalitiesNames (ids) {
            return Array.from(self.nationalities.values()).filter((item)=>ids.includes(item.id)).map((item)=>item.name);
        }
    });



var $i56po = parcelRequire("i56po");
const $50655aa55bc5063c$export$af44425426d54511 = (0, $i56po.types).model("JobDocuments", {
    id: (0, $i56po.types).identifierNumber,
    name: (0, $i56po.types).string
});
const $50655aa55bc5063c$export$dd7d667f7298c20f = (self)=>({
        getJobDocuments: (0, $i56po.flow)(function*() {
            const documents = yield self.request("get", "client/order/certificates/all");
            documents.forEach((docItem)=>{
                self.job_documents.set(String(docItem.id), docItem);
            });
        })
    });
const $50655aa55bc5063c$export$423d681166241a19 = (self)=>({
        get jobDocumentsList () {
            return Array.from(self.job_documents.values());
        },
        getJobDocumentsNames (ids) {
            return Array.from(self.job_documents.values()).filter((item)=>ids.includes(item.id)).map((item)=>item.name);
        }
    });



var $i56po = parcelRequire("i56po");
const $db37c565727bd6af$export$61e61f6415d6c028 = (0, $i56po.types).model("amend", {
    id: (0, $i56po.types).identifierNumber,
    name: (0, $i56po.types).string
});
const $db37c565727bd6af$export$9f67b1dd033c066a = (self)=>({
        getAmendReasons: (0, $i56po.flow)(function*() {
            const amendReasons = yield self.request("get", "client/order/adjustment-reasons/all");
            amendReasons.forEach((reason)=>{
                self.amendReasons.set(String(reason.id), reason);
            });
        }),
        setOrderAmendReason: (0, $i56po.flow)(function*({ orderId: orderId, reasonId: reasonId }) {
            yield self.request("post", "client/order/adjustment-reasons", {
                order_id: orderId,
                adjustment_reason_id: reasonId
            });
        })
    });
const $db37c565727bd6af$export$9dedde004efe52c2 = (self)=>({
        get amendReasonList () {
            return Array.from(self.amendReasons.values());
        },
        getAmendReasonIdByName (name) {
            return Array.from(self.amendReasons.values()).find((item)=>item.name === name)?.id;
        }
    });




var $i56po = parcelRequire("i56po");
const $955357bdb5003be6$export$d93b1fc9b61b2371 = (0, $i56po.types).model("SignUpWithOrderData", {
    workCategoryId: (0, $i56po.types).maybeNull((0, $i56po.types).number),
    firstName: (0, $i56po.types).maybeNull((0, $i56po.types).string),
    lastName: (0, $i56po.types).maybeNull((0, $i56po.types).string),
    companyName: (0, $i56po.types).maybeNull((0, $i56po.types).string),
    phone: (0, $i56po.types).maybeNull((0, $i56po.types).string),
    email: (0, $i56po.types).maybeNull((0, $i56po.types).string),
    allow_marketing_emails: (0, $i56po.types).maybeNull((0, $i56po.types).number),
    industry: (0, $i56po.types).maybeNull((0, $i56po.types).number),
    employeesAmountTier: (0, $i56po.types).maybeNull((0, $i56po.types).number)
});
const $955357bdb5003be6$export$51131a62b4850058 = (self)=>({
        setWorkCategoryId: (workCategoryId)=>{
            self.signUpWithOrderData.workCategoryId = workCategoryId;
        },
        setFirstName: (firstName)=>{
            self.signUpWithOrderData.firstName = firstName;
        },
        setLastName: (lastName)=>{
            self.signUpWithOrderData.lastName = lastName;
        },
        setCompanyName: (companyName)=>{
            self.signUpWithOrderData.companyName = companyName;
        },
        setPhone: (phone)=>{
            self.signUpWithOrderData.phone = phone;
        },
        setEmail: (email)=>{
            self.signUpWithOrderData.email = email;
        },
        toggleEmailAgreement: ()=>{
            self.signUpWithOrderData.allow_marketing_emails = self.signUpWithOrderData.allow_marketing_emails ? 0 : 1;
        },
        setIndustry: (industry)=>{
            self.signUpWithOrderData.industry = industry;
        },
        setEmployeesAmountTier: (employeesAmountTier)=>{
            self.signUpWithOrderData.employeesAmountTier = employeesAmountTier;
        }
    });



var $i56po = parcelRequire("i56po");
const $6874e2c293a32d97$export$fce79585f79c7ac7 = {
    id: 1,
    code: "uae",
    name: "United Arab Emirates",
    icon: "https://d9eoc87hwocgp.cloudfront.net/assets/markets/uae.png"
};
const $6874e2c293a32d97$export$971ffce69c407e92 = {
    id: 2,
    code: "gr",
    name: "Greece",
    icon: "https://d9eoc87hwocgp.cloudfront.net/assets/markets/gr.png"
};
const $6874e2c293a32d97$export$cbc0c7bd5e199960 = {
    id: 3,
    code: "sa",
    name: "KSA",
    icon: "https://d9eoc87hwocgp.cloudfront.net/assets/markets/sa.png"
};
const $6874e2c293a32d97$export$1163140340aed06c = (0, $i56po.types).model("MarketModel", {
    id: (0, $i56po.types).identifierNumber,
    code: (0, $i56po.types).string,
    name: (0, $i56po.types).string,
    icon: (0, $i56po.types).string,
    api_endpoint: (0, $i56po.types).string
});
const $6874e2c293a32d97$export$e4e1d16eb23c37de = (self)=>({
        getMarkets: (0, $i56po.flow)(function*() {
            const markets = yield self.request("get", "common/markets");
            markets.forEach((market)=>{
                self.marketsStore.set(String(market.id), market);
            });
        }),
        setMarket (id, market) {
            self.marketsStore.set(id, market);
        }
    });
const $6874e2c293a32d97$export$fdad2d9cf4189ed5 = (self)=>({
        get marketList () {
            return Array.from(self.marketsStore.values());
        },
        getMarketByCode (code) {
            return Array.from(self.marketsStore.values()).find((market)=>market.code === code);
        }
    });



var $i56po = parcelRequire("i56po");
const $4aacc0c4bebd2869$export$1ae440e0c6673958 = (0, $i56po.types).model("UnconfirmedPointsOfContacts", {
    email: (0, $i56po.types).string,
    roles: (0, $i56po.types).array((0, $i56po.types).number),
    client_locations: (0, $i56po.types).maybeNull((0, $i56po.types).array((0, $i56po.types).number))
});
const $4aacc0c4bebd2869$export$ff3eff6ceb842a92 = (self)=>({
        getUnconfirmedPointsOfContact: (0, $i56po.flow)(function*({ locationId: locationId }) {
            self.unconfirmedPointsOfContact = yield self.request("get", `client/pocs/unconfirmed${locationId !== undefined ? `?location_id=${locationId}` : ""}`);
            return self.unconfirmedPointsOfContact;
        })
    });



var $i56po = parcelRequire("i56po");
const $86127672cb41ff4f$export$623ee9312ec8bd76 = (0, $i56po.types).model("DuplicatedOrderJobIds", {
    jobIds: (0, $i56po.types).array((0, $i56po.types).number)
});
const $86127672cb41ff4f$export$dcf81577e3967195 = (self)=>({
        getDuplicatedOrderJobs: (0, $i56po.flow)(function*(duplicatedOrderId) {
            return yield self.request("post", `client/order/jobs/get`, {
                order_id: duplicatedOrderId
            });
        }),
        duplicateOrder: (0, $i56po.flow)(function*(jobs) {
            return yield self.request("post", "client/order/jobs/bulk/post", {
                jobs: jobs
            });
        }),
        addDuplicatedJobId: function(jobId) {
            self.duplicatedOrder.jobIds.push(jobId);
        },
        removeDuplicatedJobId: function(jobId) {
            self.duplicatedOrder.jobIds = (0, $i56po.cast)(self.duplicatedOrder.jobIds.filter((addedJobId)=>jobId !== addedJobId));
        }
    });
const $86127672cb41ff4f$export$4f82fdd4d54ff300 = (self)=>({
        get duplicatedOrderJobIds () {
            return self.duplicatedOrder.jobIds;
        }
    });



var $i56po = parcelRequire("i56po");

var $45fvw = parcelRequire("45fvw");
var $879d9c16c27ed178$export$d5c1d4491a804016;
(function(InvoiceStatus) {
    InvoiceStatus[InvoiceStatus["Unpaid"] = 2] = "Unpaid";
    InvoiceStatus[InvoiceStatus["Paid"] = 3] = "Paid";
})($879d9c16c27ed178$export$d5c1d4491a804016 || ($879d9c16c27ed178$export$d5c1d4491a804016 = {}));
var $879d9c16c27ed178$export$ac0e44b2a93b443;
(function(StatementItemType) {
    StatementItemType["Invoice"] = "invoice";
})($879d9c16c27ed178$export$ac0e44b2a93b443 || ($879d9c16c27ed178$export$ac0e44b2a93b443 = {}));
const $879d9c16c27ed178$var$StatementItem = (0, $i56po.types).model("StatementItem", {
    type: (0, $i56po.types).string,
    id: (0, $i56po.types).identifierNumber,
    status: (0, $i56po.types).number,
    description: (0, $i56po.types).string,
    amount: (0, $i56po.types).number,
    currency_code: (0, $i56po.types).string,
    date: (0, $i56po.types).string,
    due_date: (0, $i56po.types).string
});
const $879d9c16c27ed178$export$d85a7604a5c6ff09 = (0, $i56po.types).model("AccountStatement", {
    data: (0, $i56po.types).optional((0, $i56po.types).model({
        start_balance: (0, $i56po.types).maybeNull((0, $i56po.types).number),
        end_balance: (0, $i56po.types).maybeNull((0, $i56po.types).number),
        items: (0, $i56po.types).map($879d9c16c27ed178$var$StatementItem)
    }), {}),
    filters: (0, $i56po.types).optional((0, $i56po.types).model({
        date_from: (0, $i56po.types).maybeNull((0, $i56po.types).string),
        date_to: (0, $i56po.types).maybeNull((0, $i56po.types).string)
    }), {
        date_from: (0, (/*@__PURE__*/$parcel$interopDefault($45fvw)))().startOf("month").format("YYYY-MM-DD"),
        date_to: (0, (/*@__PURE__*/$parcel$interopDefault($45fvw)))().endOf("month").format("YYYY-MM-DD")
    })
});
const $879d9c16c27ed178$export$71b76ee226aa450a = (self)=>({
        loadAccountStatement: (0, $i56po.flow)(function*() {
            const result = yield self.request("get", `client/account-statement?date_from=${self.accountStatement.filters.date_from}&date_to=${self.accountStatement.filters.date_to}`);
            self.accountStatement.data.start_balance = result.start_balance;
            self.accountStatement.data.end_balance = result.end_balance;
            self.accountStatement.data.items.clear();
            result.items.forEach((item)=>{
                self.accountStatement.data.items.set(String(item.id), item);
            });
        }),
        downloadAccountStatementFile: (0, $i56po.flow)(function*() {
            return yield self.request("get", `client/account-statement/download?date_from=${self.accountStatement.filters.date_from}&date_to=${self.accountStatement.filters.date_to}`, undefined, {
                responseType: "blob"
            });
        }),
        setDateFrom: function(dateFrom) {
            self.accountStatement.filters.date_from = dateFrom;
        },
        setDateTo: function(dateTo) {
            self.accountStatement.filters.date_to = dateTo;
        }
    });
const $879d9c16c27ed178$export$8aed7b1f3b7d95e8 = (self)=>({
        get statementItems () {
            return Array.from(self.accountStatement.data.items.values()).filter((item)=>item.type !== "payment");
        },
        get startBalance () {
            return self.accountStatement.data.start_balance;
        },
        get endBalance () {
            return self.accountStatement.data.end_balance;
        },
        get dateFrom () {
            return self.accountStatement.filters.date_from;
        },
        get dateTo () {
            return self.accountStatement.filters.date_to;
        }
    });



var $i56po = parcelRequire("i56po");
var $d28b592401b34c77$export$9ff3c61eb01645e4;
(function(UnseenUpdateType) {
    UnseenUpdateType[UnseenUpdateType["NewPendingPayment"] = 1] = "NewPendingPayment";
    UnseenUpdateType[UnseenUpdateType["NewProcessingPayment"] = 2] = "NewProcessingPayment";
    UnseenUpdateType[UnseenUpdateType["NewPaidPayment"] = 3] = "NewPaidPayment";
})($d28b592401b34c77$export$9ff3c61eb01645e4 || ($d28b592401b34c77$export$9ff3c61eb01645e4 = {}));
const $d28b592401b34c77$export$66d4603a63b1ac89 = (0, $i56po.types).model("UnseenUpdateModel", {
    type: (0, $i56po.types).identifierNumber,
    seen: (0, $i56po.types).boolean
});
const $d28b592401b34c77$export$7e90d1f3ec3cbd17 = (self)=>({
        getUnseenUpdates: (0, $i56po.flow)(function*() {
            const unseenUpdates = yield self.request("get", "client/unseen-updates");
            unseenUpdates.forEach((unseenUpdate)=>{
                self.unseenUpdates.set(String(unseenUpdate.type), unseenUpdate);
            });
        }),
        markUpdateAsSeen: (0, $i56po.flow)(function*(updateType) {
            yield self.request("post", `client/unseen-updates/mark-as-seen/${updateType}`);
            const update = self.unseenUpdates.get(String(updateType));
            if (update) update.seen = true;
        })
    });
const $d28b592401b34c77$export$a417a04550b26651 = (self)=>({
        isUpdateSeen (updateType) {
            return self.unseenUpdates.get(String(updateType))?.seen ?? true;
        }
    });



var $i56po = parcelRequire("i56po");

var $45fvw = parcelRequire("45fvw");


var $i56po = parcelRequire("i56po");

var $i56po = parcelRequire("i56po");
const $e478e10c2ca41575$export$339dd38da01029ee = (0, $i56po.types).model("ScheduleActiveShift", {
    shift_id: (0, $i56po.types).number,
    active_shift_id: (0, $i56po.types).number,
    start_time: (0, $i56po.types).maybeNull((0, $i56po.types).number),
    end_time: (0, $i56po.types).maybeNull((0, $i56po.types).number),
    client_checkin_time: (0, $i56po.types).maybeNull((0, $i56po.types).number),
    client_checkout_time: (0, $i56po.types).maybeNull((0, $i56po.types).number),
    is_available_for_confirmation: (0, $i56po.types).boolean,
    status: (0, $i56po.types).model("ScheduleActiveShiftStatus", {
        id: (0, $i56po.types).number,
        title: (0, $i56po.types).string
    })
});


const $b8cfcadf882ca44a$export$6353582413d37f64 = (0, $i56po.types).model("ScheduleSp", {
    id: (0, $i56po.types).identifierNumber,
    name: (0, $i56po.types).string,
    image: (0, $i56po.types).string,
    phone: (0, $i56po.types).maybeNull((0, $i56po.types).string),
    is_favorite: (0, $i56po.types).boolean,
    active_shifts: (0, $i56po.types).map((0, $e478e10c2ca41575$export$339dd38da01029ee))
}).views((self)=>({
        getSpModelActiveShifts () {
            return Array.from(self.active_shifts.values());
        }
    }));



var $i56po = parcelRequire("i56po");
var $fc070fb25f7982a6$export$a99e0dd4ead620e;
(function(ShiftStatus) {
    ShiftStatus["Upcoming"] = "Upcoming";
    ShiftStatus["Started"] = "Started";
    ShiftStatus["Completed"] = "Completed";
})($fc070fb25f7982a6$export$a99e0dd4ead620e || ($fc070fb25f7982a6$export$a99e0dd4ead620e = {}));
const $fc070fb25f7982a6$export$752341d495c023b8 = (0, $i56po.types).model("ScheduleShift", {
    // Record<shift_id, model>
    id: (0, $i56po.types).identifierNumber,
    start_time: (0, $i56po.types).number,
    end_time: (0, $i56po.types).number,
    fulfilled_count: (0, $i56po.types).number,
    required_quantity: (0, $i56po.types).number,
    status: (0, $i56po.types).enumeration(Object.values($fc070fb25f7982a6$export$a99e0dd4ead620e))
});



var $i56po = parcelRequire("i56po");

var $i56po = parcelRequire("i56po");
const $7830a0fd1f0f6f27$export$83a72eeb720d8872 = (0, $i56po.types).model("ScheduleSingleDateData", {
    shift_id: (0, $i56po.types).maybeNull((0, $i56po.types).number),
    sps: (0, $i56po.types).map((0, $i56po.types).number)
});


const $b77781e554ea468f$export$33a2c73180e1b08e = (0, $i56po.types).map((0, $7830a0fd1f0f6f27$export$83a72eeb720d8872));



function $6d21117937ba7fb8$export$a04c6c6965dd4709(arr, fn) {
    const newArr = [];
    for (const el of arr){
        const r = fn(el);
        if (r !== undefined) newArr.push(r);
    }
    return newArr;
}
function $6d21117937ba7fb8$export$259b4dd69e654a7a(obj) {
    return Object.keys(obj);
}
function $6d21117937ba7fb8$export$d02631cccf789723(from, to, step = 1) {
    const arr = [];
    for(let i = from; i <= to; i += step)arr.push(i);
    if (from <= to && arr[arr.length - 1] !== to) arr.push(to);
    return arr;
}
function $6d21117937ba7fb8$export$5ed2d08173f8a798(date) {
    date.setHours(0);
    date.setMinutes(0);
    date.setSeconds(0);
    date.setMilliseconds(0);
    return date;
}
function $6d21117937ba7fb8$export$87779c0c97a6c3df(obj, partial) {
    const newObj = {
        ...obj
    };
    for(const key in partial){
        const k = key;
        const val = partial[key];
        newObj[k] = $6d21117937ba7fb8$export$a6cdc56e425d0d0a(val) && !(val instanceof Date) ? $6d21117937ba7fb8$export$87779c0c97a6c3df((0, $dacbeb7af41d49ec$export$f2db7d5238e1d23f)(obj[k]), val) : val;
    }
    return newObj;
}
function $6d21117937ba7fb8$export$58aefef1ff9edd34(obj, fn) {
    const newObj = {};
    for(const key in obj)newObj[key] = fn(key, obj[key]);
    return newObj;
}
function $6d21117937ba7fb8$export$20e5ee212c1724b2(key, array) {
    return array.reduce((acc, object)=>{
        const id = object[key];
        if (typeof id !== "undefined") {
            acc[id] = object // id can be different type but will be converted into string
            ;
            return {
                ...acc,
                [id]: object
            };
        }
        return acc;
    }, {});
}
function $6d21117937ba7fb8$export$357523c63a2253b9(obj, keys) {
    const newObj = {};
    for(const key in obj)if (keys.indexOf(key) > -1) newObj[key] = obj[key];
    return newObj;
}
function $6d21117937ba7fb8$export$30a06c8d3562193f(obj, keys) {
    const newObj = {};
    for(const key in obj)if (keys.indexOf(key) === -1) newObj[key] = obj[key];
    return newObj;
}
function $6d21117937ba7fb8$export$a6cdc56e425d0d0a(obj) {
    return typeof obj === "object" && obj !== null;
}
const $6d21117937ba7fb8$export$b70dcce1c70696bf = (str)=>str.replace(/([-_][a-z])/g, (group)=>group.toUpperCase().replace("-", "").replace("_", ""));



function $5dd13c12c6781a8e$export$a65b43d8cb5a3456(input, date) {
    return input.map((item)=>{
        const { shifts: shifts, assigned_sps: assigned_sps, ...fieldsToCopy } = item;
        // convert shifts to origin time
        const shiftsInOriginTime = shifts.map((shiftItem)=>({
                ...shiftItem,
                start_time: shiftItem.start_time + shiftItem.timezone_offset + (0, $ddf12117b815a7c3$export$81fa0da0c2fba503),
                end_time: shiftItem.end_time + shiftItem.timezone_offset + (0, $ddf12117b815a7c3$export$81fa0da0c2fba503)
            }));
        const transformedAssignedSps = (0, $6d21117937ba7fb8$export$20e5ee212c1724b2)("id", assigned_sps.map((spItem)=>{
            // convert active shifts to origin time
            const activeShiftsInOriginTime = spItem.active_shifts.map((activeShiftItem)=>({
                    ...activeShiftItem,
                    start_time: activeShiftItem.start_time ? activeShiftItem.start_time + activeShiftItem.timezone_offset + (0, $ddf12117b815a7c3$export$81fa0da0c2fba503) : null,
                    end_time: activeShiftItem.end_time ? activeShiftItem.end_time + activeShiftItem.timezone_offset + (0, $ddf12117b815a7c3$export$81fa0da0c2fba503) : null,
                    client_checkin_time: activeShiftItem.client_checkin_time ? activeShiftItem.client_checkin_time + activeShiftItem.timezone_offset + (0, $ddf12117b815a7c3$export$81fa0da0c2fba503) : null,
                    client_checkout_time: activeShiftItem.client_checkout_time ? activeShiftItem.client_checkout_time + activeShiftItem.timezone_offset + (0, $ddf12117b815a7c3$export$81fa0da0c2fba503) : null
                }));
            return {
                ...spItem,
                active_shifts: (0, $6d21117937ba7fb8$export$20e5ee212c1724b2)("shift_id", activeShiftsInOriginTime)
            };
        }));
        const transformedShifts = (0, $6d21117937ba7fb8$export$20e5ee212c1724b2)("id", shiftsInOriginTime);
        const dates = (0, $ddf12117b815a7c3$export$8a5160aad7ff40be)(date).reduce((map, dateItem)=>{
            return {
                ...map,
                [(0, $ddf12117b815a7c3$export$efb113ee57e9edfb)(dateItem)]: {
                    shift_id: shifts.find((shift)=>(0, $ddf12117b815a7c3$export$69db29514b384dcc)(shift.start_time).getDate() === dateItem.getDate())?.id,
                    sps: assigned_sps.reduce((acc, sp)=>({
                            ...acc,
                            [sp.id]: sp.id
                        }), {})
                }
            };
        }, {});
        return {
            ...fieldsToCopy,
            shifts: transformedShifts,
            assigned_sps: transformedAssignedSps,
            dates: dates,
            modifications: {
                shifts: {},
                assigned_sps: {}
            }
        };
    });
}



var $d5e0253b28c033d7$export$f7cfb7426aa37f1a;
(function(SpShiftStatus) {
    SpShiftStatus[SpShiftStatus["irrelevant"] = 0] = "irrelevant";
    SpShiftStatus[SpShiftStatus["accepted"] = 1] = "accepted";
    SpShiftStatus[SpShiftStatus["completed"] = 4] = "completed";
    SpShiftStatus[SpShiftStatus["canceled"] = 5] = "canceled";
    SpShiftStatus[SpShiftStatus["started"] = 7] = "started";
    SpShiftStatus[SpShiftStatus["pendingConfirmation"] = 8] = "pendingConfirmation";
})($d5e0253b28c033d7$export$f7cfb7426aa37f1a || ($d5e0253b28c033d7$export$f7cfb7426aa37f1a = {}));



function $fb757d382f0a5bc0$export$eab7af94a0da5f2c(statusId) {
    switch(statusId){
        case (0, $d5e0253b28c033d7$export$f7cfb7426aa37f1a).accepted:
            return (0, $2b1f0855f2f3a952$export$625550452a3fa3ec)("all_jobs.accepted");
        case (0, $d5e0253b28c033d7$export$f7cfb7426aa37f1a).canceled:
            return (0, $2b1f0855f2f3a952$export$625550452a3fa3ec)("all_jobs.canceled");
        case (0, $d5e0253b28c033d7$export$f7cfb7426aa37f1a).completed:
            return (0, $2b1f0855f2f3a952$export$625550452a3fa3ec)("all_jobs.completed");
        case (0, $d5e0253b28c033d7$export$f7cfb7426aa37f1a).irrelevant:
            return (0, $2b1f0855f2f3a952$export$625550452a3fa3ec)("all_jobs.irrelevant");
        case (0, $d5e0253b28c033d7$export$f7cfb7426aa37f1a).pendingConfirmation:
            return (0, $2b1f0855f2f3a952$export$625550452a3fa3ec)("all_jobs.pending");
        case (0, $d5e0253b28c033d7$export$f7cfb7426aa37f1a).started:
            return (0, $2b1f0855f2f3a952$export$625550452a3fa3ec)("all_jobs.started");
    }
}


const $bc28e5fa09cb7751$export$dc52edd9c08369ad = (0, $i56po.types).model("Schedule", {
    // Record<'YYYY-MM-DD', model>
    job_id: (0, $i56po.types).identifierNumber,
    order_id: (0, $i56po.types).number,
    location_id: (0, $i56po.types).number,
    start_date: (0, $i56po.types).string,
    end_date: (0, $i56po.types).string,
    work_category_name: (0, $i56po.types).string,
    location_name: (0, $i56po.types).string,
    quantity: (0, $i56po.types).number,
    shifts: (0, $i56po.types).map((0, $fc070fb25f7982a6$export$752341d495c023b8)),
    assigned_sps: (0, $i56po.types).map((0, $b8cfcadf882ca44a$export$6353582413d37f64)),
    dates: (0, $b77781e554ea468f$export$33a2c73180e1b08e),
    applicants_count: (0, $i56po.types).number,
    modifications: (0, $i56po.types).model("ScheduleModifications", {
        shifts: (0, $i56po.types).map((0, $fc070fb25f7982a6$export$752341d495c023b8)),
        assigned_sps: (0, $i56po.types).map((0, $b8cfcadf882ca44a$export$6353582413d37f64))
    })
}).views((self)=>({
        get spList () {
            return Array.from(self.assigned_sps.values());
        },
        getDateShift (date) {
            return self.dates.get((0, $ddf12117b815a7c3$export$efb113ee57e9edfb)(date));
        },
        getJobShift (shiftId) {
            const modifiedShift = self.modifications.shifts.get(String(shiftId));
            return modifiedShift ?? self.shifts.get(String(shiftId));
        },
        getSp ({ spId: spId }) {
            return self.assigned_sps.get(String(spId));
        },
        getSpShift ({ spId: spId, shiftId: shiftId }) {
            const assignedSp = self.modifications.assigned_sps.get(String(spId));
            if (assignedSp?.active_shifts.has(String(shiftId))) return assignedSp.active_shifts.get(String(shiftId));
            else return self.assigned_sps.get(String(spId))?.active_shifts.get(String(shiftId));
        }
    })).views((self)=>({
        getSpTime ({ spId: spId, shiftId: shiftId }) {
            const spShift = self.getSpShift({
                spId: spId,
                shiftId: shiftId
            });
            return {
                startTime: spShift?.client_checkin_time ?? spShift?.start_time ?? null,
                endTime: spShift?.client_checkout_time ?? spShift?.end_time ?? null
            };
        }
    })).actions((self)=>({
        modifySpTime ({ spId: spId, shiftId: shiftId, startTime: startTime, endTime: endTime }) {
            const sp = self.assigned_sps.get(String(spId));
            const shift = sp.active_shifts.get(String(shiftId));
            if (shift) {
                if (self.modifications.assigned_sps.has(String(spId))) {
                    const assignedSp = self.modifications.assigned_sps.get(String(spId));
                    const modifiedShift = assignedSp.active_shifts.get(String(shiftId));
                    const shiftToCopy = modifiedShift ?? shift;
                    assignedSp.active_shifts.set(String(shiftId), {
                        ...shiftToCopy,
                        start_time: startTime ?? shiftToCopy.start_time,
                        end_time: endTime ?? shiftToCopy.end_time,
                        status: {
                            ...shiftToCopy.status
                        }
                    });
                } else self.modifications.assigned_sps.set(String(spId), (0, $b8cfcadf882ca44a$export$6353582413d37f64).create({
                    ...sp,
                    active_shifts: {
                        [shiftId]: {
                            ...shift,
                            start_time: startTime ?? shift.start_time,
                            end_time: endTime ?? shift.end_time,
                            status: {
                                ...shift.status
                            }
                        }
                    }
                }));
            }
        },
        setOgrammerCheckInTime: function({ spId: spId, shiftId: shiftId, time: time }) {
            const spShift = self.getSpShift({
                spId: spId,
                shiftId: shiftId
            });
            if (spShift) spShift.client_checkin_time = time;
        },
        setOgrammerCheckOutTime: function({ spId: spId, shiftId: shiftId, time: time }) {
            const spShift = self.getSpShift({
                spId: spId,
                shiftId: shiftId
            });
            if (spShift) spShift.client_checkout_time = time;
        },
        setOgrammerStatus: function({ spId: spId, shiftId: shiftId, status: status }) {
            const spShift = self.getSpShift({
                spId: spId,
                shiftId: shiftId
            });
            if (spShift) {
                spShift.status.id = status;
                spShift.status.title = (0, $fb757d382f0a5bc0$export$eab7af94a0da5f2c)(status);
            }
        },
        toogleOgrammerFavouriteStatus: function({ spId: spId }) {
            const sp = self.assigned_sps.get(String(spId));
            if (sp) sp.is_favorite = !sp.is_favorite;
        },
        applyModification () {
            for (const shift of self.modifications.shifts.values())self.shifts.set(String(shift.id), {
                ...shift
            });
            for (const assignedSp of self.modifications.assigned_sps.values()){
                const originSp = self.assigned_sps.get(String(assignedSp.id));
                if (originSp) for (const activeShift of assignedSp.active_shifts.values())originSp.active_shifts.set(String(activeShift.shift_id), {
                    ...activeShift,
                    status: {
                        ...activeShift.status
                    }
                });
            }
        }
    })).actions((self)=>({
        modifyActiveShiftsTime ({ shiftId: shiftId, startTime: startTime, endTime: endTime }) {
            for (const assignedSp of self.assigned_sps.values()){
                for (const shift of assignedSp.active_shifts.values())if (shift.shift_id === shiftId) self.modifySpTime({
                    spId: assignedSp.id,
                    shiftId: shiftId,
                    startTime: startTime,
                    endTime: endTime
                });
            }
            const shift = self.modifications.shifts.get(String(shiftId)) ?? self.shifts.get(String(shiftId));
            if (shift) self.modifications.shifts.set(String(shiftId), {
                ...shift,
                id: shiftId,
                start_time: startTime ?? shift.start_time,
                end_time: endTime ?? shift.end_time
            });
        }
    }));
const $bc28e5fa09cb7751$export$80faac4e40793f3b = (self)=>({
        modifyWorkCategoryDateSchedule ({ workCategoryName: workCategoryName, locationId: locationId, date: date, spIds: spIds, startTime: startTime, endTime: endTime }) {
            self.schedule.forEach((scheduleArray)=>{
                scheduleArray.forEach((scheduleItem)=>{
                    if (scheduleItem.work_category_name === workCategoryName && scheduleItem.location_id === locationId) scheduleItem.assigned_sps.forEach((assignedSP)=>{
                        if (spIds.includes(assignedSP.id)) assignedSP.active_shifts.forEach((activeShift)=>{
                            if (activeShift.start_time) {
                                const startDate = (0, (/*@__PURE__*/$parcel$interopDefault($45fvw))).unix(activeShift.start_time).format("YYYY-MM-DD");
                                if (startDate === date) scheduleItem.modifySpTime({
                                    spId: assignedSP.id,
                                    shiftId: activeShift.shift_id,
                                    startTime: startTime,
                                    endTime: endTime
                                });
                            }
                        });
                    });
                });
            });
        },
        getSchedule: (0, $i56po.flow)(function*(date, locationIds, designationIds) {
            const formattedDate = (0, $ddf12117b815a7c3$export$efb113ee57e9edfb)(date);
            let uri = `client/advanced-scheduling?date=${formattedDate}`;
            locationIds.forEach((locationId)=>{
                uri += `&location_id[]=${locationId}`;
            });
            designationIds.forEach((designationId)=>{
                uri += `&designation_id[]=${designationId}`;
            });
            const schedule = yield self.request("get", uri);
            self.schedule.clear();
            self.schedule.set(formattedDate, (0, $5dd13c12c6781a8e$export$a65b43d8cb5a3456)(schedule, date));
            return schedule;
        }),
        checkInOgrammer: (0, $i56po.flow)(function*({ id: id, time: time }) {
            yield self.request("post", `client/active-shift/${id}/checkin`, {
                time: time
            });
        }),
        checkOutOgrammer: (0, $i56po.flow)(function*({ id: id, time: time }) {
            yield self.request("post", `client/active-shift/${id}/checkout`, {
                time: time
            });
        }),
        checkInOgrammerWithQR: (0, $i56po.flow)(function*({ id: id, time: time }) {
            yield self.request("post", `client/active-shift/${id}/checkin`, {
                time: time,
                is_qr: 1
            });
        }),
        checkOutOgrammerWithQR: (0, $i56po.flow)(function*({ id: id, time: time }) {
            yield self.request("post", `client/active-shift/${id}/checkout`, {
                time: time,
                is_qr: 1
            });
        }),
        extendShift: (0, $i56po.flow)(function*({ id: id, time: time }) {
            yield self.request("post", `client/active-shift/${id}/extend`, {
                extend_time: time
            });
        }),
        makeOgrammerFavourite: (0, $i56po.flow)(function*({ spId: spId }) {
            yield self.request("post", "client/sp/save", {
                sp_id: spId
            });
        }),
        removeOgrammerFromFavourites: (0, $i56po.flow)(function*({ spId: spId }) {
            yield self.request("post", "client/sp/un-save", {
                sp_id: spId
            });
        }),
        cancelShift: (0, $i56po.flow)(function*({ id: id, reasonId: reasonId, reasonDetails: reasonDetails, cancelFollowing: cancelFollowing, blockOgrammer: blockOgrammer }) {
            const requestBody = {
                cancellation_reason_id: reasonId,
                cancel_following: cancelFollowing ? 1 : 0,
                is_block: blockOgrammer ? 1 : 0
            };
            if (reasonDetails.length > 0) requestBody.cancellation_reason_details = reasonDetails;
            yield self.request("post", `client/active-shift/${id}/cancel`, requestBody);
        }),
        clearScheduleData () {
            self.schedule.clear();
        },
        clearScheduleChanges () {
            for (const jobSchedules of self.schedule.values())jobSchedules.forEach((jobItemSchedule)=>{
                jobItemSchedule.modifications.shifts.clear();
                jobItemSchedule.modifications.assigned_sps.clear();
            });
        },
        applyScheduleChanges: (0, $i56po.flow)(function*() {
            const jobs = [];
            const jobActions = new Map();
            // Iterate over all date periods (I.g. 01 Sept - 07 Sept)
            Array.from(self.schedule.values()).forEach((dateJobs)=>{
                // Iterate over all jobs that belong to the date period
                dateJobs.forEach((jobSchedule)=>{
                    if (!jobActions.has(jobSchedule.job_id)) jobActions.set(jobSchedule.job_id, []);
                    const actions = jobActions.get(jobSchedule.job_id);
                    // Modify shift times only if no OGs assigned (otherwise OGs will be canceled)
                    Array.from(jobSchedule.modifications.shifts.values()).forEach((shift)=>{
                        if (shift.fulfilled_count === 0) addAction(actions, {
                            start_time: shift.start_time,
                            end_time: shift.end_time,
                            sps: []
                        });
                    });
                    // Modify active shift times
                    Array.from(jobSchedule.modifications.assigned_sps.values()).forEach((assignedSp)=>{
                        Array.from(assignedSp.active_shifts.values()).forEach((shift)=>{
                            addAction(actions, {
                                start_time: shift.start_time,
                                end_time: shift.end_time,
                                sps: [
                                    assignedSp.id
                                ]
                            });
                        });
                    });
                });
            });
            // Fill jobs with non-empty actions
            Array.from(jobActions.entries()).forEach(([jobId, actions])=>{
                if (actions.length > 0) jobs.push({
                    id: jobId,
                    actions: actions
                });
            });
            yield self.request("post", "client/advanced-scheduling/jobs/modify", {
                jobs: jobs
            });
            // Apply modifications as saved time
            Array.from(self.schedule.values()).forEach((dateJobs)=>{
                dateJobs.forEach((jobSchedule)=>{
                    jobSchedule.applyModification();
                });
            });
            /**
     * Adds a modification to apply in the request
     * @param actions - array of shift actions to be applied to a job
     * @param shift - shift or active_shift being modified
     */ function addAction(actions, shift) {
                const shiftDate = (0, $ddf12117b815a7c3$export$efb113ee57e9edfb)(new Date(shift.start_time * 1000));
                actions.push({
                    start_date: shiftDate,
                    end_date: shiftDate,
                    type: "replace",
                    start_time: (0, $ddf12117b815a7c3$export$d944ce49c26cbd64)(new Date(shift.start_time * 1000)),
                    end_time: (0, $ddf12117b815a7c3$export$d944ce49c26cbd64)(new Date(shift.end_time * 1000)),
                    sp_ids: shift.sps
                });
            }
        })
    });
const $bc28e5fa09cb7751$export$dd99ec40cf6d8434 = (self)=>({
        getSPsByWorkCategoryNameAndDate ({ workCategoryName: workCategoryName, locationId: locationId, date: date }) {
            const result = [];
            self.schedule.forEach((scheduleArray)=>{
                scheduleArray.forEach((scheduleItem)=>{
                    if (scheduleItem.work_category_name === workCategoryName && scheduleItem.location_id === locationId) scheduleItem.assigned_sps.forEach((assignedSP)=>{
                        assignedSP.active_shifts.forEach((activeShift)=>{
                            if (activeShift.start_time) {
                                const startDate = (0, (/*@__PURE__*/$parcel$interopDefault($45fvw))).unix(activeShift.start_time).format("YYYY-MM-DD");
                                if (startDate === date) {
                                    const item = {
                                        key: String(assignedSP.id),
                                        label: assignedSP.name,
                                        value: assignedSP.id
                                    };
                                    const existingItem = result.find((checkedItem)=>checkedItem.value === item.value);
                                    if (!existingItem) result.push(item);
                                }
                            }
                        });
                    });
                });
            });
            return result;
        },
        getJobsScheduleForWeek (date) {
            return self.schedule.get(date) ?? [];
        },
        getJobShift (jobId, weekDate, shiftId) {
            const weekSchedule = self.schedule.get(weekDate);
            return weekSchedule?.find((job)=>job.job_id === jobId)?.getJobShift(shiftId) ?? null;
        },
        // collects all active_shift modifications of jobs
        get scheduleModificationsAmount () {
            return Array.from(self.schedule.values()).reduce((overallModifications, jobSchedules)=>{
                return overallModifications + jobSchedules.reduce((weekModifications, jobItemSchedule)=>{
                    const shiftModifications = Array.from(jobItemSchedule.modifications.shifts.values()).reduce((modifiedShiftsCount, shift)=>{
                        return modifiedShiftsCount + 1;
                    }, 0);
                    const activeShiftModifications = weekModifications + Array.from(jobItemSchedule.modifications.assigned_sps.values()).reduce((modifiedActiveShiftsCount, assignedSp)=>{
                        return modifiedActiveShiftsCount + assignedSp.active_shifts.size;
                    }, 0);
                    return shiftModifications + activeShiftModifications;
                }, 0);
            }, 0);
        },
        get groupedSchedule () {
            const groupedResult = [];
            self.schedule.forEach((scheduleArray)=>{
                scheduleArray.forEach((schedule)=>{
                    const { location_id: location_id, location_name: location_name, work_category_name: work_category_name, job_id: job_id, order_id: order_id, spList: spList, quantity: quantity } = schedule;
                    // Find or create location group
                    let locationGroup = groupedResult.find((location)=>location.location_id === location_id);
                    if (!locationGroup) {
                        locationGroup = {
                            location_id: location_id,
                            location_name: location_name,
                            work_categories: []
                        };
                        groupedResult.push(locationGroup);
                    }
                    const requiredActiveShiftsCount = Array.from(schedule.shifts.values()).reduce((count, shiftItem)=>{
                        return count + shiftItem.required_quantity;
                    }, 0);
                    const fulfilledActiveShiftsCount = Array.from(schedule.shifts.values()).reduce((count, shiftItem)=>{
                        return count + shiftItem.fulfilled_count;
                    }, 0);
                    let isScheduleUnfulfilled = fulfilledActiveShiftsCount < requiredActiveShiftsCount;
                    // Find or create work category group
                    let workCategoryGroup = locationGroup.work_categories.find((wc)=>wc.work_category_name === work_category_name);
                    if (!workCategoryGroup) {
                        workCategoryGroup = {
                            work_category_name: work_category_name,
                            quantity: quantity,
                            default_schedule: schedule,
                            unfulfilled_schedules: isScheduleUnfulfilled ? [
                                schedule
                            ] : [],
                            assigned_sps: []
                        };
                        locationGroup.work_categories.push(workCategoryGroup);
                    } else {
                        workCategoryGroup.quantity += quantity;
                        if (isScheduleUnfulfilled) workCategoryGroup.unfulfilled_schedules.push(schedule);
                    }
                    // Aggregate assigned service providers
                    Object.entries(spList).forEach(([sp_id, sp])=>{
                        if (!sp.getSpModelActiveShifts().length) return;
                        let spGroup = workCategoryGroup?.assigned_sps.find((spg)=>spg.sp_id === sp.id);
                        if (!spGroup && workCategoryGroup) {
                            spGroup = {
                                sp_id: sp.id,
                                name: sp.name,
                                image: sp.image,
                                phone: sp.phone,
                                is_favorite: sp.is_favorite,
                                original_schedule: [
                                    schedule
                                ],
                                active_shifts: sp.getSpModelActiveShifts().map((activeShift)=>{
                                    return {
                                        job_id: job_id,
                                        order_id: order_id,
                                        shift_id: activeShift.shift_id,
                                        active_shift_id: activeShift.active_shift_id,
                                        start_time: activeShift.start_time,
                                        end_time: activeShift.end_time,
                                        client_checkin_time: activeShift.client_checkin_time,
                                        client_checkout_time: activeShift.client_checkout_time,
                                        is_available_for_confirmation: activeShift.is_available_for_confirmation,
                                        status: {
                                            id: activeShift.status.id,
                                            title: activeShift.status.title
                                        }
                                    };
                                })
                            };
                            workCategoryGroup.assigned_sps.push(spGroup);
                        }
                        if (spGroup && workCategoryGroup) workCategoryGroup.assigned_sps = workCategoryGroup.assigned_sps.map((assignedSpItem)=>{
                            if (assignedSpItem.sp_id !== sp.id) return assignedSpItem;
                            const activeShifts = assignedSpItem.active_shifts;
                            sp.getSpModelActiveShifts().map((activeShiftItem)=>{
                                const activeShift = {
                                    job_id: job_id,
                                    order_id: order_id,
                                    shift_id: activeShiftItem.shift_id,
                                    active_shift_id: activeShiftItem.active_shift_id,
                                    start_time: activeShiftItem.start_time,
                                    end_time: activeShiftItem.end_time,
                                    client_checkin_time: activeShiftItem.client_checkin_time,
                                    client_checkout_time: activeShiftItem.client_checkout_time,
                                    is_available_for_confirmation: activeShiftItem.is_available_for_confirmation,
                                    status: {
                                        id: activeShiftItem.status.id,
                                        title: activeShiftItem.status.title
                                    }
                                };
                                const existingActiveShift = activeShifts.find((item)=>item.active_shift_id === activeShift.active_shift_id);
                                if (!existingActiveShift) activeShifts.push(activeShift);
                            });
                            const originalSchedules = assignedSpItem.original_schedule;
                            const originalScheduleExists = originalSchedules.map((item)=>item.job_id).includes(schedule.job_id);
                            if (!originalScheduleExists) originalSchedules.push(schedule);
                            return {
                                ...assignedSpItem,
                                original_schedule: originalSchedules,
                                active_shifts: activeShifts
                            };
                        });
                    });
                });
            });
            return groupedResult;
        }
    });




var $i56po = parcelRequire("i56po");
const $69027d6fa5335b45$var$SHIFT_EXTENSION_DEFAULT_TIME = 30;
const $69027d6fa5335b45$var$ShiftExtensionTimeOptionModel = (0, $i56po.types).model("ShiftExtensionTimeOption", {
    label: (0, $i56po.types).string,
    value: (0, $i56po.types).number,
    key: (0, $i56po.types).string
});
const $69027d6fa5335b45$export$13083d6efac4ea56 = (0, $i56po.types).model("Config", {
    shift_extension_time_options: (0, $i56po.types).model({
        default: (0, $i56po.types).number,
        options: (0, $i56po.types).array($69027d6fa5335b45$var$ShiftExtensionTimeOptionModel)
    })
});
const $69027d6fa5335b45$export$2f258cee1d0b9187 = (self)=>({
        getConfig: (0, $i56po.flow)(function*() {
            self.config = yield self.request("get", "client/config");
        })
    });
const $69027d6fa5335b45$export$eb758c674dc4f923 = (self)=>({
        get shiftExtensionTimeOptions () {
            return self.config ? self.config.shift_extension_time_options.options : [];
        },
        get shiftExtensionDefaultTime () {
            return self.config ? self.config.shift_extension_time_options.default : $69027d6fa5335b45$var$SHIFT_EXTENSION_DEFAULT_TIME;
        }
    });



var $i56po = parcelRequire("i56po");

var $kLorN = parcelRequire("kLorN");
var $17c96b9e379c43fb$export$232a731a3a0fd0f1;
(function(ReferralStatus) {
    ReferralStatus[ReferralStatus["ProfileCreated"] = 1] = "ProfileCreated";
    ReferralStatus[ReferralStatus["Activated"] = 2] = "Activated";
    ReferralStatus[ReferralStatus["BookedShifts"] = 3] = "BookedShifts";
    ReferralStatus[ReferralStatus["ShiftsDone"] = 4] = "ShiftsDone";
})($17c96b9e379c43fb$export$232a731a3a0fd0f1 || ($17c96b9e379c43fb$export$232a731a3a0fd0f1 = {}));
const $17c96b9e379c43fb$export$96ffa04df5389097 = (0, $i56po.types).model("AffiliateStats", {
    currentMonthIncome: (0, $i56po.types).number,
    currency: (0, $i56po.types).string,
    referralsCount: (0, $i56po.types).number,
    invitationLink: (0, $i56po.types).string,
    marginSplit: (0, $i56po.types).maybeNull((0, $i56po.types).number)
});
const $17c96b9e379c43fb$var$AffiliateReferralModel = (0, $i56po.types).model("AffiliateReferral", {
    id: (0, $i56po.types).number,
    image: (0, $i56po.types).maybeNull((0, $i56po.types).string),
    fullName: (0, $i56po.types).maybeNull((0, $i56po.types).string),
    shiftsCompletedCount: (0, $i56po.types).number,
    shiftsTotalCount: (0, $i56po.types).number,
    designations: (0, $i56po.types).array((0, $i56po.types).string),
    currency: (0, $i56po.types).string,
    payoutAmount: (0, $i56po.types).maybeNull((0, $i56po.types).number),
    payoutDate: (0, $i56po.types).maybeNull((0, $i56po.types).string),
    joinDate: (0, $i56po.types).string,
    status: (0, $i56po.types).number
});
const $17c96b9e379c43fb$export$1ad21265da07886e = (0, $i56po.types).model("AffiliateReferralsModel", {
    list: (0, $i56po.types).array($17c96b9e379c43fb$var$AffiliateReferralModel),
    currentPage: (0, $i56po.types).number,
    totalPages: (0, $i56po.types).number
});
const $17c96b9e379c43fb$export$6227f861c3b381fa = (0, $i56po.types).model("AffiliateStatus", {
    status: (0, $i56po.types).number,
    referralsCount: (0, $i56po.types).number
});
const $17c96b9e379c43fb$export$e8ca60c181f7eb81 = (0, $i56po.types).model("AffiliateEarnings", {
    currency: (0, $i56po.types).string,
    totalAmount: (0, $i56po.types).number,
    periods: (0, $i56po.types).array((0, $i56po.types).model({
        title: (0, $i56po.types).string,
        amount: (0, $i56po.types).number
    }))
});
const $17c96b9e379c43fb$export$b2c85071de075c0d = (self)=>({
        markClientAsAffiliate: (0, $i56po.flow)(function*() {
            yield self.request("post", "client/affiliate");
        }),
        getAffiliateStats: (0, $i56po.flow)(function*() {
            self.affiliateStats = yield self.request("get", "client/affiliate/stats");
        }),
        getAffiliateReferrals: (0, $i56po.flow)(function*(page = 1) {
            self.affiliateReferrals.list.clear();
            const { list: list, paginator: paginator } = yield self.request("get", `client/affiliate/referrals?page=${page}`);
            list.forEach((item)=>{
                self.affiliateReferrals.list.push(item);
            });
            self.affiliateReferrals.totalPages = Number(paginator?.last_page);
            self.affiliateReferrals.currentPage = page;
        }),
        getAffiliateStatuses: (0, $i56po.flow)(function*() {
            self.affiliateReferralStatuses = yield self.request("get", "client/affiliate/statuses");
        }),
        getAffiliateEarnings: (0, $i56po.flow)(function*() {
            self.affiliateEarnings = yield self.request("get", "client/affiliate/earnings");
        }),
        confirmAffiliateTermsAndConditions: (0, $i56po.flow)(function*() {
            yield self.request("post", `client/terms-and-conditions/accept?tc_type=${(0, $kLorN.TERMS_AND_CONDITIONS_TYPE_AFFILIATE_CLIENT)}`);
        })
    });
const $17c96b9e379c43fb$export$bb84d66f0d8b5a1d = (self)=>({
        get affiliateReferralsList () {
            return self.affiliateReferrals.list;
        },
        get affiliateReferralsPagesCount () {
            return self.affiliateReferrals.totalPages;
        }
    });



var $i56po = parcelRequire("i56po");
const $f042c5f614d4793e$var$InterviewModel = (0, $i56po.types).model("Interview", {
    id: (0, $i56po.types).identifierNumber,
    job_id: (0, $i56po.types).number,
    questions: (0, $i56po.types).array((0, $i56po.types).number)
});
const $f042c5f614d4793e$var$QuestionModel = (0, $i56po.types).model("Question", {
    id: (0, $i56po.types).identifierNumber,
    description: (0, $i56po.types).string,
    answers: (0, $i56po.types).array((0, $i56po.types).number)
});
const $f042c5f614d4793e$var$AnswerModel = (0, $i56po.types).model("Answer", {
    id: (0, $i56po.types).identifierNumber,
    sp_id: (0, $i56po.types).number,
    answer_time: (0, $i56po.types).number,
    file_url: (0, $i56po.types).string,
    rating: (0, $i56po.types).maybeNull((0, $i56po.types).number)
});
const $f042c5f614d4793e$export$d72d48294dba8e6 = (0, $i56po.types).model("InterviewStore", {
    interviews: (0, $i56po.types).map($f042c5f614d4793e$var$InterviewModel),
    questions: (0, $i56po.types).map($f042c5f614d4793e$var$QuestionModel),
    answers: (0, $i56po.types).map($f042c5f614d4793e$var$AnswerModel),
    sps: (0, $i56po.types).map((0, $i56po.types).map((0, $i56po.types).map((0, $i56po.types).reference($f042c5f614d4793e$var$AnswerModel)))),
    questionListStore: (0, $i56po.types).model("InterviewQuestions", {
        list: (0, $i56po.types).array((0, $i56po.types).number),
        paginator: (0, $i56po.types).model({
            current_page: (0, $i56po.types).number,
            next_page: (0, $i56po.types).maybeNull((0, $i56po.types).number),
            per_page: (0, $i56po.types).number,
            last_page: (0, $i56po.types).number,
            total: (0, $i56po.types).number
        })
    })
});
const $f042c5f614d4793e$export$75696a71ffd27dc5 = (self)=>({
        getQuestions: (0, $i56po.flow)(function*({ page: page }) {
            const { list: questions, paginator: paginator } = yield self.request("get", "interviews/v1/client/questions", undefined, {
                params: {
                    page: page
                }
            });
            if (page === 1) self.interviewStore.questionListStore.list.clear();
            questions.forEach((q)=>{
                self.interviewStore.questions.set(String(q.id), q);
            });
            self.interviewStore.questionListStore.list.push(...questions.map((q)=>q.id));
            self.interviewStore.questionListStore.paginator = paginator;
            return questions;
        }),
        addQuestion: (0, $i56po.flow)(function*({ description: description }) {
            const createdQuestion = yield self.request("post", "interviews/v1/client/questions", {
                description: description
            });
            self.interviewStore.questionListStore.list.push(createdQuestion.id);
            self.interviewStore.questions.set(String(createdQuestion.id), createdQuestion);
            return createdQuestion;
        }),
        getInterview: (0, $i56po.flow)(function*({ jobId: jobId }) {
            const interview = yield self.request("get", "interviews/v1/client/interviews", undefined, {
                params: {
                    job_id: jobId
                }
            });
            self.interviewStore.interviews.set(String(interview.id), {
                id: interview.id,
                job_id: jobId,
                questions: interview.questions.map((q)=>{
                    self.interviewStore.questions.set(String(q.id), {
                        id: q.id,
                        description: q.description,
                        answers: q.answers.map((a)=>{
                            self.interviewStore.answers.set(String(a.id), a);
                            const existingSp = self.interviewStore.sps.get(String(a.sp_id));
                            if (existingSp) {
                                const existingInterview = existingSp.get(String(interview.id));
                                if (existingInterview) existingInterview.set(String(q.id), a.id);
                                else existingSp.set(String(interview.id), {
                                    [q.id]: a.id
                                });
                            } else self.interviewStore.sps.set(String(a.sp_id), {
                                [interview.id]: {
                                    [q.id]: a.id
                                }
                            });
                            return a.id;
                        })
                    });
                    return q.id;
                })
            });
            return interview;
        }),
        createInterview: (0, $i56po.flow)(function*({ jobId: jobId, workCategoryId: workCategoryId, questions: questions }) {
            yield self.request("post", "interviews/v1/client/interviews", {
                job_id: jobId,
                work_category_id: workCategoryId,
                questions: questions
            });
        }),
        updateInterview: (0, $i56po.flow)(function*({ interviewId: interviewId, jobId: jobId, workCategoryId: workCategoryId, questions: questions }) {
            yield self.request("put", `interviews/v1/client/interviews/${interviewId}`, {
                work_category_id: workCategoryId,
                job_id: jobId,
                questions: questions
            });
        }),
        deleteInterview: (0, $i56po.flow)(function*({ interviewId: interviewId }) {
            yield self.request("delete", `interviews/v1/client/interviews/${interviewId}`);
            self.interviewStore.interviews.delete(String(interviewId));
        }),
        rateAnswer: (0, $i56po.flow)(function*({ answerId: answerId, rating: rating }) {
            yield self.request("post", `interviews/v1/client/answers/${answerId}`, {
                rating: rating
            });
            if (self.interviewStore.answers.has(String(answerId))) self.interviewStore.answers.get(String(answerId)).rating = rating;
        })
    });
const $f042c5f614d4793e$export$5ee8dd6674aab337 = (self)=>({
        get questionList () {
            return Array.from(self.interviewStore.questionListStore.list.values());
        },
        get nextQuestionPage () {
            return self.interviewStore.questionListStore.paginator.next_page;
        },
        getSpRating ({ interviewId: interviewId, spId: spId }) {
            const sp = self.interviewStore.sps.get(String(spId));
            const questions = sp?.get(String(interviewId));
            if (!questions) return null;
            let answers = 0;
            let sum = 0;
            Array.from(questions.values()).forEach((item)=>{
                if (item.rating !== null) {
                    answers++;
                    sum += item.rating;
                }
            });
            if (sum === 0 || answers === 0) return null;
            return sum / answers;
        },
        getSpAnswer ({ spId: spId, interviewId: interviewId, questionId: questionId }) {
            const sp = self.interviewStore.sps.get(String(spId));
            const interview = sp?.get(String(interviewId));
            return interview?.get(String(questionId)) ?? null;
        },
        spHasAnswers ({ spId: spId, interviewId: interviewId }) {
            const sp = self.interviewStore.sps.get(String(spId));
            return sp?.has(String(interviewId)) ?? false;
        },
        getQuestionNames (ids) {
            return new Array(ids.length).fill("").map((_, index)=>self.interviewStore.questions.get(String(ids[index]))?.description ?? "");
        },
        getQuestionById (id) {
            return self.interviewStore.questions.get(String(id));
        },
        getInterviewQuestions (interviewId) {
            return self.interviewStore.interviews.get(String(interviewId))?.questions ?? [];
        },
        getInterviewById (id) {
            return self.interviewStore.interviews.get(String(id));
        },
        getInterviewByJobId (id) {
            return Array.from(self.interviewStore.interviews.values()).find((i)=>i.job_id === id);
        }
    });
const $f042c5f614d4793e$export$ba04272e4e952b95 = (0, $i56po.types).optional($f042c5f614d4793e$export$d72d48294dba8e6, {
    interviews: {},
    questions: {},
    answers: {},
    sps: {},
    questionListStore: {
        list: [],
        paginator: {
            current_page: 1,
            next_page: null,
            per_page: 20,
            last_page: 1,
            total: 0
        }
    }
});



var $i56po = parcelRequire("i56po");
const $2506287961012ba2$export$3b8abbc8101fa09c = (0, $i56po.types).model("QrAttendanceModel", {
    sp_active_shift_id: (0, $i56po.types).identifierNumber,
    shift_id: (0, $i56po.types).number,
    is_checkin: (0, $i56po.types).boolean,
    sp_id: (0, $i56po.types).number,
    sp_full_name: (0, $i56po.types).string,
    sp_image: (0, $i56po.types).maybeNull((0, $i56po.types).string),
    order_id: (0, $i56po.types).number,
    job_amount: (0, $i56po.types).number,
    work_category_name: (0, $i56po.types).string,
    location_name: (0, $i56po.types).string,
    shift_start_time: (0, $i56po.types).number,
    shift_end_time: (0, $i56po.types).number,
    timezone_offset: (0, $i56po.types).number
});
const $2506287961012ba2$export$b5cb0cc30f68cb2e = (self)=>({
        getCheckinEligibility: (0, $i56po.flow)(function*({ spId: spId }) {
            self.qrAttendance = yield self.request("post", `client/attendance/shifts/checkin-eligibility?sp_id=${spId}`);
            return self.qrAttendance;
        })
    });



var $i56po = parcelRequire("i56po");
const $b85cce87524a4e0b$export$555900f8c568d22c = "last_job_start_date";
const $b85cce87524a4e0b$export$827cdec97a8508ca = "client_rating_for_last_job";
const $b85cce87524a4e0b$var$PastWorkerModel = (0, $i56po.types).model("PastWorkerModel", {
    id: (0, $i56po.types).identifierNumber,
    name: (0, $i56po.types).string,
    image_url: (0, $i56po.types).maybeNull((0, $i56po.types).string),
    is_favorite: (0, $i56po.types).boolean,
    designations: (0, $i56po.types).array((0, $i56po.types).string),
    locations: (0, $i56po.types).array((0, $i56po.types).string),
    hours_amount_worked_for_client: (0, $i56po.types).number,
    shifts_amount_worked_for_client: (0, $i56po.types).integer,
    client_rating_for_last_job: (0, $i56po.types).maybeNull((0, $i56po.types).number),
    last_job_id: (0, $i56po.types).maybeNull((0, $i56po.types).number),
    last_job_start_date: (0, $i56po.types).maybeNull((0, $i56po.types).string),
    last_job_end_date: (0, $i56po.types).maybeNull((0, $i56po.types).string),
    is_available: (0, $i56po.types).maybeNull((0, $i56po.types).boolean),
    note: (0, $i56po.types).maybeNull((0, $i56po.types).string)
});
const $b85cce87524a4e0b$export$e06975bd4579bd1d = (0, $i56po.types).model("PastWorkersModel", {
    list: (0, $i56po.types).map($b85cce87524a4e0b$var$PastWorkerModel),
    invitedSPs: (0, $i56po.types).map($b85cce87524a4e0b$var$PastWorkerModel),
    currentPage: (0, $i56po.types).number,
    totalPages: (0, $i56po.types).number,
    nextPage: (0, $i56po.types).maybeNull((0, $i56po.types).number),
    total: (0, $i56po.types).number
});
const $b85cce87524a4e0b$export$4af1045d54ccef23 = (self)=>({
        getInvitedPastSPsByIds: (0, $i56po.flow)(function*(ids = []) {
            let url = `client/sp/past?`;
            ids.forEach((id)=>{
                url += `&sp_ids[]=${id}`;
            });
            const { list: list } = yield self.request("get", url);
            list.forEach((item)=>{
                self.pastWorkers.invitedSPs.set(item.id, item);
            });
        }),
        getPastSPs: (0, $i56po.flow)(function*({ page: page = 1, ids: ids = [], searchString: searchString = "", collect: collect = true, availableFrom: availableFrom = null, availableTo: availableTo = null, sortBy: sortBy = $b85cce87524a4e0b$export$555900f8c568d22c, orderBy: orderBy = "DESC", locationId: locationId = null, designationId: designationId = null, isFavorite: isFavorite = null, preferredLocationId: preferredLocationId = null, preferredDesignationId: preferredDesignationId = null, jobId: jobId = null }) {
            let url = `client/sp/past?page=${page}&sort_by=${sortBy}&order_by=${orderBy}`;
            if (locationId) url += `&location_id=${locationId}`;
            if (designationId) url += `&designation_id=${designationId}`;
            if (isFavorite) url += `&is_favorite=${1}`;
            if (searchString !== "") url += `&search_string=${searchString}`;
            if (availableFrom) url += `&available_from=${availableFrom}`;
            if (availableTo) url += `&available_to=${availableTo}`;
            if (preferredLocationId) url += `&preferred_location_id=${preferredLocationId}`;
            if (preferredDesignationId) url += `&preferred_designation_id=${preferredDesignationId}`;
            if (jobId) url += `&job_id=${jobId}`;
            ids.forEach((id)=>{
                url += `&sp_ids[]=${id}`;
            });
            const { list: list, paginator: paginator } = yield self.request("get", url);
            if (!collect) self.pastWorkers.list.clear();
            list.forEach((item)=>{
                self.pastWorkers.list.set(item.id, item);
            });
            self.pastWorkers.totalPages = Number(paginator?.last_page);
            self.pastWorkers.currentPage = page;
            self.pastWorkers.total = Number(paginator?.total);
            self.pastWorkers.nextPage = paginator?.next_page ?? null;
        }),
        setSPNote: (0, $i56po.flow)(function*(spId, note) {
            const sp = self.pastWorkers.list.get(spId);
            // eslint-disable-next-line
            if (!!sp) sp.note = note;
            yield self.request("post", `client/sp/${spId}/note`, {
                note: note
            });
        }),
        setSPLastJobRating: (0, $i56po.flow)(function*(spId, rating, locationId, workCategoryId, jobId) {
            const sp = self.pastWorkers.list.get(spId);
            // eslint-disable-next-line
            if (!!sp) sp.client_rating_for_last_job = rating;
            yield self.request("post", `client/sp/${spId}/last-job-rating`, {
                rating: rating,
                locationId: locationId,
                workCategoryId: workCategoryId,
                jobId: jobId
            });
        }),
        toggleIsFavorite: (0, $i56po.flow)(function*(spId) {
            const sp = self.pastWorkers.list.get(spId);
            // eslint-disable-next-line
            if (!!sp) {
                const isFavorite = sp.is_favorite;
                if (isFavorite) {
                    // eslint-disable-next-line
                    sp.is_favorite = false;
                    yield self.request("post", `client/sp/un-save`, {
                        sp_id: spId
                    });
                } else {
                    // eslint-disable-next-line
                    sp.is_favorite = true;
                    yield self.request("post", `client/sp/save`, {
                        sp_id: spId
                    });
                }
            }
        })
    });
const $b85cce87524a4e0b$export$16fcde8e8dc295fd = (self)=>({
        get pastSPsList () {
            return Array.from(self.pastWorkers.list.values());
        },
        get invitedPastSPsList () {
            return Array.from(self.pastWorkers.invitedSPs.values());
        },
        get pastSPsPagesCount () {
            return self.pastWorkers.totalPages;
        },
        get pastSPsTotalCount () {
            return self.pastWorkers.total;
        },
        get pastSPsNextPage () {
            return self.pastWorkers.nextPage;
        }
    });



var $i56po = parcelRequire("i56po");
const $dd1a31861ca94462$export$129a7aab47203040 = (0, $i56po.types).model("Industry", {
    value: (0, $i56po.types).identifierNumber,
    label: (0, $i56po.types).string,
    key: (0, $i56po.types).string
});
const $dd1a31861ca94462$export$15268d7d686d8ecb = (self)=>({
        getIndustries: (0, $i56po.flow)(function*() {
            const industries = yield self.request("get", `common/industries`);
            industries.forEach((industry)=>{
                self.industries.set(String(industry.value), {
                    ...industry,
                    key: String(industry.value)
                });
            });
        })
    });
const $dd1a31861ca94462$export$54f5371207c7d558 = (self)=>({
        get industriesList () {
            return Array.from(self.industries.values());
        }
    });



var $i56po = parcelRequire("i56po");
const $ed68460ae54fa45a$var$SPToRateModel = (0, $i56po.types).model("SPToRateModel", {
    id: (0, $i56po.types).identifierNumber,
    name: (0, $i56po.types).string,
    image_url: (0, $i56po.types).maybeNull((0, $i56po.types).string),
    rating: (0, $i56po.types).maybeNull((0, $i56po.types).number)
});
const $ed68460ae54fa45a$export$a9531909c60f5add = (0, $i56po.types).model("SPsToRateModel", {
    list: (0, $i56po.types).map($ed68460ae54fa45a$var$SPToRateModel),
    currentPage: (0, $i56po.types).number,
    totalPages: (0, $i56po.types).number,
    nextPage: (0, $i56po.types).maybeNull((0, $i56po.types).number),
    total: (0, $i56po.types).number
});
const $ed68460ae54fa45a$export$3422f0aa4527c6e9 = (self)=>({
        getSPsToRate: (0, $i56po.flow)(function*({ page: page = 1, jobId: jobId, collect: collect }) {
            const { list: list, paginator: paginator } = yield self.request("get", `client/rating/jobs/${jobId}/sps??page=${page}`);
            if (!collect) self.spsToRate.list.clear();
            list.forEach((item)=>{
                self.spsToRate.list.set(item.id, item);
            });
            self.spsToRate.totalPages = Number(paginator?.last_page);
            self.spsToRate.currentPage = page;
            self.spsToRate.total = Number(paginator?.total);
            self.spsToRate.nextPage = paginator?.next_page ?? null;
        })
    });
const $ed68460ae54fa45a$export$1dcc0a3b1caf4b96 = (self)=>({
        get spsToRateList () {
            return Array.from(self.spsToRate.list.values());
        },
        get spsToRateNextPage () {
            return self.pastWorkers.nextPage;
        }
    });



var $i56po = parcelRequire("i56po");
const $225618fae8526134$export$f98490c1049dba98 = (0, $i56po.types).model("EmployeesAmountTierModel", {
    value: (0, $i56po.types).identifierNumber,
    label: (0, $i56po.types).string,
    key: (0, $i56po.types).string
});
const $225618fae8526134$export$1316b7290a25ce42 = (self)=>({
        getEmployeesAmountTiers: (0, $i56po.flow)(function*() {
            const data = yield self.request("get", `common/employee-amount-tiers`);
            data.forEach((item)=>{
                self.employeesAmountTier.set(String(item.value), {
                    ...item,
                    key: String(item.value)
                });
            });
        })
    });
const $225618fae8526134$export$b25120175c842242 = (self)=>({
        get employeesAmountTierList () {
            return Array.from(self.employeesAmountTier.values());
        }
    });



var $i56po = parcelRequire("i56po");
const $068089025ba7790f$export$ec4f5d5ed2b8555c = 1;
const $068089025ba7790f$export$2b5208cb0453d005 = 2;
const $068089025ba7790f$export$f4e13e4cb382a08b = 2;
const $068089025ba7790f$export$bb355e251db77a4b = 3;
const $068089025ba7790f$export$cbef048cd87bfeef = 4;
const $068089025ba7790f$var$DisputeModel = (0, $i56po.types).model("Dispute", {
    id: (0, $i56po.types).identifierNumber,
    type: (0, $i56po.types).number,
    designation_id: (0, $i56po.types).number,
    designation_name: (0, $i56po.types).string,
    designation_image: (0, $i56po.types).maybeNull((0, $i56po.types).string),
    client_name: (0, $i56po.types).string,
    location: (0, $i56po.types).string,
    shift_start_time: (0, $i56po.types).number,
    sp_checkin_time: (0, $i56po.types).maybeNull((0, $i56po.types).number),
    sp_checkout_time: (0, $i56po.types).maybeNull((0, $i56po.types).number),
    sp_name: (0, $i56po.types).string,
    sp_image: (0, $i56po.types).maybeNull((0, $i56po.types).string),
    sp_total_hours: (0, $i56po.types).maybeNull((0, $i56po.types).number),
    client_checkin_time: (0, $i56po.types).maybeNull((0, $i56po.types).number),
    client_checkout_time: (0, $i56po.types).maybeNull((0, $i56po.types).number),
    client_total_hours: (0, $i56po.types).maybeNull((0, $i56po.types).number),
    status: (0, $i56po.types).number,
    expires_at: (0, $i56po.types).number,
    sp_comment: (0, $i56po.types).maybeNull((0, $i56po.types).string),
    sp_file: (0, $i56po.types).maybeNull((0, $i56po.types).string)
});
const $068089025ba7790f$export$2ef14f3fd5157ce6 = (0, $i56po.types).model("DisputesModel", {
    list: (0, $i56po.types).map($068089025ba7790f$var$DisputeModel),
    currentPage: (0, $i56po.types).number,
    totalPages: (0, $i56po.types).number,
    nextPage: (0, $i56po.types).maybeNull((0, $i56po.types).number),
    total: (0, $i56po.types).number
});
const $068089025ba7790f$export$fa63dc8ee4dea120 = (self)=>({
        getDisputes: (0, $i56po.flow)(function*({ page: page }) {
            if (page === 1) {
                self.disputes.list.clear();
                self.disputes.nextPage = 1;
            }
            const nextPage = self.disputes.nextPage;
            if (nextPage) {
                const { list: list, paginator: paginator } = yield self.request("get", `client/disputes?page=${nextPage}`);
                list.forEach((item)=>{
                    self.disputes.list.set(item.id, item);
                });
                self.disputes.totalPages = Number(paginator?.last_page);
                self.disputes.currentPage = nextPage;
                self.disputes.total = Number(paginator?.total);
                self.disputes.nextPage = paginator?.next_page ?? null;
            }
        }),
        resolveDispute: (0, $i56po.flow)(function*({ id: id }) {
            yield self.request("post", `client/disputes/${id}/resolve`);
            const dispute = self.disputes.list.get(String(id));
            if (dispute) dispute.status = $068089025ba7790f$export$f4e13e4cb382a08b;
        }),
        declineDispute: (0, $i56po.flow)(function*({ id: id }) {
            yield self.request("post", `client/disputes/${id}/decline`);
            const dispute = self.disputes.list.get(String(id));
            if (dispute) dispute.status = $068089025ba7790f$export$cbef048cd87bfeef;
        })
    });
const $068089025ba7790f$export$4b25ce4849150462 = (self)=>({
        get disputesList () {
            return Array.from(self.disputes.list.values());
        },
        get disputesNextPage () {
            return self.disputes.nextPage;
        }
    });


const $698b1c14995d32f9$export$7da2e3ad755c8eb6 = (0, $i56po.types).model("DataStore", {
    logged: (0, $i56po.types).optional((0, $i56po.types).boolean, false),
    account: (0, $i56po.types).maybeNull((0, $97fa7686fb8e51ed$export$a304486d272e5789)),
    profile: (0, $i56po.types).maybeNull((0, $9fe0c86e68f7e764$export$e0e97806e9b2009b)),
    companyDetails: (0, $i56po.types).maybeNull((0, $85250b9063617b2f$export$4b5e1596426e9e1b)),
    attendanceManagers: (0, $i56po.types).map((0, $e792d82719edd3fb$export$471d9f92b0d0c1e8)),
    locations: (0, $i56po.types).map((0, $689c0f02660e8d18$export$939fc8ffec2e5277)),
    ratingRequests: (0, $i56po.types).map((0, $76f97430ce9c28fd$export$d02753406c974acf)),
    lastRatings: (0, $i56po.types).map((0, $76f97430ce9c28fd$export$1b0cc98aec45b456)),
    ratingCriteries: (0, $i56po.types).map((0, $8d3f5ea5772a905b$export$c6691e946810bd1d)),
    uniforms: (0, $i56po.types).map((0, $7502a05bfd737216$export$fec1c3aa0a78ac0d)),
    industries: (0, $i56po.types).map((0, $dd1a31861ca94462$export$129a7aab47203040)),
    employeesAmountTier: (0, $i56po.types).map((0, $225618fae8526134$export$f98490c1049dba98)),
    languages: (0, $i56po.types).map((0, $6013d7e45fc085c9$export$ce30082d1032ee4d)),
    nationalities: (0, $i56po.types).map((0, $ef22a2a50bd6fe1f$export$ac98711d2bef8423)),
    professions: (0, $i56po.types).map((0, $bef4c0ded377ea3c$export$b526d87d51b2fbf6)),
    jobs: (0, $i56po.types).map((0, $862a04ca6e0d681b$export$8c11478261578efd)),
    invoices: (0, $i56po.types).optional((0, $c58d6738097efc6a$export$895e46a089a55afc), {}),
    order: (0, $i56po.types).optional((0, $41e1cbb67f22c5a1$export$58004edee0d8a9a8), {}),
    sp: (0, $i56po.types).optional((0, $c415d859b0209fa5$export$2d46b25e5c49986d), {}),
    filterDictionary: (0, $i56po.types).maybeNull((0, $71538133e39294ef$export$481f08521fe36ad0)),
    invitations: (0, $i56po.types).map((0, $0af49bfecdfb34e0$export$7cc4e1865fc4ab4d)),
    regions: (0, $i56po.types).map((0, $c3100d78b7efbef1$export$c4f22f1eb7457697)),
    payments: (0, $i56po.types).optional((0, $ace4c335912c9e96$export$f2d165df9c67c2a8), {
        paymentMethods: {}
    }),
    notification: (0, $i56po.types).optional((0, $83994bbdd5d8865b$export$d8c5f668d71664bd), {}),
    shiftCancelReasons: (0, $i56po.types).map((0, $726e391db8a1d625$export$c8968b1dd199f684)),
    attendanceReportJob: (0, $i56po.types).map((0, $dec578872418ee32$export$1cef7f4f17f9157e)),
    contactFilters: (0, $i56po.types).maybeNull((0, $8c029a5346b265a7$export$4cfa4433cc872329)),
    cherryPickingJobs: (0, $i56po.types).optional((0, $d112073eb1ddf143$export$338b1993d9f8ba6f), {
        map: {},
        nextPage: null
    }),
    cherryPickingApplicants: (0, $i56po.types).optional((0, $1a7db182178118f7$export$6269ca0bb51d3a14), {}),
    cherryPickingApplicantsOfPermanentJob: (0, $i56po.types).optional((0, $1a7db182178118f7$export$ef971fd9f34b465c), {}),
    chat: (0, $i56po.types).optional((0, $1dbbc2907cfe3211$export$40c4488a0e0be8c4), {}),
    statistics: (0, $i56po.types).maybeNull((0, $8816855e34c181f6$export$ddeb147e905cd03f)),
    pointsOfContact: (0, $i56po.types).maybeNull((0, $i56po.types).array((0, $1307fd361ee59300$export$1beca27353df06fb))),
    applicantsExperience: (0, $i56po.types).map((0, $2f5f7352d371bb4d$export$598357dd273a64fc)),
    workCategoryRequirements: (0, $i56po.types).map((0, $i56po.types).array((0, $a3de59097f70cb47$export$14a4eb6b50dd28fe))),
    workCategorySeniorityLevels: (0, $i56po.types).map((0, $i56po.types).array((0, $f62ebabca0bf67f2$export$4a2ba27f19da2665))),
    job_documents: (0, $i56po.types).map((0, $50655aa55bc5063c$export$af44425426d54511)),
    amendReasons: (0, $i56po.types).map((0, $db37c565727bd6af$export$61e61f6415d6c028)),
    signUpWithOrderData: (0, $i56po.types).optional((0, $955357bdb5003be6$export$d93b1fc9b61b2371), {}),
    marketsStore: (0, $i56po.types).map((0, $6874e2c293a32d97$export$1163140340aed06c)),
    unconfirmedPointsOfContact: (0, $i56po.types).maybeNull((0, $i56po.types).array((0, $4aacc0c4bebd2869$export$1ae440e0c6673958))),
    duplicatedOrder: (0, $i56po.types).optional((0, $86127672cb41ff4f$export$623ee9312ec8bd76), {}),
    accountStatement: (0, $i56po.types).optional((0, $879d9c16c27ed178$export$d85a7604a5c6ff09), {}),
    unseenUpdates: (0, $i56po.types).map((0, $d28b592401b34c77$export$66d4603a63b1ac89)),
    schedule: (0, $i56po.types).map((0, $i56po.types).array((0, $bc28e5fa09cb7751$export$dc52edd9c08369ad))),
    config: (0, $i56po.types).maybeNull((0, $69027d6fa5335b45$export$13083d6efac4ea56)),
    affiliateStats: (0, $i56po.types).maybeNull((0, $17c96b9e379c43fb$export$96ffa04df5389097)),
    affiliateReferrals: (0, $i56po.types).optional((0, $17c96b9e379c43fb$export$1ad21265da07886e), {
        list: [],
        currentPage: 1,
        totalPages: 1
    }),
    affiliateReferralStatuses: (0, $i56po.types).array((0, $17c96b9e379c43fb$export$6227f861c3b381fa)),
    affiliateEarnings: (0, $i56po.types).maybeNull((0, $17c96b9e379c43fb$export$e8ca60c181f7eb81)),
    interviewStore: (0, $f042c5f614d4793e$export$ba04272e4e952b95),
    qrAttendance: (0, $i56po.types).maybeNull((0, $2506287961012ba2$export$3b8abbc8101fa09c)),
    pastWorkers: (0, $i56po.types).optional((0, $b85cce87524a4e0b$export$e06975bd4579bd1d), {
        list: {},
        currentPage: 1,
        totalPages: 1,
        total: 0
    }),
    spsToRate: (0, $i56po.types).optional((0, $ed68460ae54fa45a$export$a9531909c60f5add), {
        list: {},
        currentPage: 1,
        totalPages: 1,
        total: 0
    }),
    disputes: (0, $i56po.types).optional((0, $068089025ba7790f$export$2ef14f3fd5157ce6), {
        list: {},
        currentPage: 1,
        totalPages: 1,
        total: 0
    })
}).extend((0, $c27e024f7cd31ca5$export$39f36b94c3034e99));
const $698b1c14995d32f9$export$c675a423f801c19f = $698b1c14995d32f9$export$7da2e3ad755c8eb6.actions((0, $9fe0c86e68f7e764$export$13e13f83d4c0e6c7)).actions((0, $97fa7686fb8e51ed$export$2094fea184162489)).actions((0, $85250b9063617b2f$export$c567f576b2bf86d3)).actions((0, $e792d82719edd3fb$export$dc606b4712afc945)).actions((0, $76f97430ce9c28fd$export$cacda00ce6d92680)).actions((0, $7502a05bfd737216$export$38b905ec97b2baa4)).actions((0, $862a04ca6e0d681b$export$b10bdded6ffd14bc)).actions((0, $c3993e4dfdaadbe2$export$2b4c6dd0b4533a88)).actions((0, $689c0f02660e8d18$export$58f55a6020265313)).actions((0, $41e1cbb67f22c5a1$export$ca9ea14a9f873218)).actions((0, $bef4c0ded377ea3c$export$f89d5009abbd80f9)).actions((0, $c58d6738097efc6a$export$81162ff1b7fa6b4b)).actions((0, $c415d859b0209fa5$export$ce62b6119e6bdb6d)).actions((0, $71538133e39294ef$export$5ee8ec36330b5d09)).actions((0, $0af49bfecdfb34e0$export$f801a1977490caa6)).actions((0, $c3100d78b7efbef1$export$2a558753224bf1db)).actions((0, $ace4c335912c9e96$export$db0db1a13a78f4ba)).actions((0, $83994bbdd5d8865b$export$c6c09ae6704c9377)).actions((0, $726e391db8a1d625$export$1fda8508bf6c6b0b)).actions((0, $8c029a5346b265a7$export$49c8bfde45b70d38)).actions((0, $1dbbc2907cfe3211$export$9161057cd6914172)).actions((0, $dec578872418ee32$export$45d0b9d18688f34e)).actions((0, $d112073eb1ddf143$export$df058e6cff1e9883)).actions((0, $1a7db182178118f7$export$6557d250a0badf3f)).actions((0, $8816855e34c181f6$export$bfcbf8ecd6763f36)).actions((0, $1307fd361ee59300$export$5472e97408541162)).actions((0, $36e83141adffbc68$export$65354c902f10533e)).actions((0, $2f5f7352d371bb4d$export$f8ce80a0ae476c88)).actions((0, $8d3f5ea5772a905b$export$f74f7ae84d2af7f4)).actions((0, $6013d7e45fc085c9$export$dac4489c49a31c05)).actions((0, $a3de59097f70cb47$export$a3bd37b1644ab6a6)).actions((0, $f62ebabca0bf67f2$export$2d1fb1416bb87cf5)).actions((0, $ef22a2a50bd6fe1f$export$bd8c36c59889cd78)).actions((0, $50655aa55bc5063c$export$dd7d667f7298c20f)).actions((0, $db37c565727bd6af$export$9f67b1dd033c066a)).actions((0, $955357bdb5003be6$export$51131a62b4850058)).actions((0, $6874e2c293a32d97$export$e4e1d16eb23c37de)).actions((0, $4aacc0c4bebd2869$export$ff3eff6ceb842a92)).actions((0, $86127672cb41ff4f$export$dcf81577e3967195)).actions((0, $879d9c16c27ed178$export$71b76ee226aa450a)).actions((0, $d28b592401b34c77$export$7e90d1f3ec3cbd17)).actions((0, $69027d6fa5335b45$export$2f258cee1d0b9187)).actions((0, $bc28e5fa09cb7751$export$80faac4e40793f3b)).actions((0, $17c96b9e379c43fb$export$b2c85071de075c0d)).actions((0, $f042c5f614d4793e$export$75696a71ffd27dc5)).actions((0, $2506287961012ba2$export$b5cb0cc30f68cb2e)).actions((0, $b85cce87524a4e0b$export$4af1045d54ccef23)).actions((0, $dd1a31861ca94462$export$15268d7d686d8ecb)).actions((0, $225618fae8526134$export$1316b7290a25ce42)).actions((0, $ed68460ae54fa45a$export$3422f0aa4527c6e9)).actions((0, $068089025ba7790f$export$fa63dc8ee4dea120)).views((0, $76f97430ce9c28fd$export$81d9c7b03dec473f)).views((0, $689c0f02660e8d18$export$e4bb51118bc761f9)).views((0, $08dd3df3ae1a0b30$export$d2497be51a9b7c53)).views((0, $487f9fae786cd5fa$export$6240ef84ad28581a)).views((0, $eb9dd261ab6fbb6b$export$635ae09819efb3c8)).views((0, $bef4c0ded377ea3c$export$ece1a5d73f5c47b0)).views((0, $c58d6738097efc6a$export$cea948f728596db6)).views((0, $7502a05bfd737216$export$801f3abbeddfd49)).views((0, $862a04ca6e0d681b$export$b88cbba80470a808)).views((0, $71538133e39294ef$export$a1baae9b8b605186)).views((0, $c415d859b0209fa5$export$f332f9c7bdef4d)).views((0, $c3100d78b7efbef1$export$e5a26b430e454aea)).views((0, $e792d82719edd3fb$export$2631bb987f6c84f2)).views((0, $ace4c335912c9e96$export$4a24d597afab22e1)).views((0, $83994bbdd5d8865b$export$65d5f47879c8751a)).views((0, $726e391db8a1d625$export$b6b78ea7734a9166)).views((0, $0af49bfecdfb34e0$export$eb266b27659945da)).views((0, $1dbbc2907cfe3211$export$4a1fb45ec758d706)).views((0, $dec578872418ee32$export$8f2dcdc01d41ca0e)).views((0, $d112073eb1ddf143$export$78d794ee0dee8822)).views((0, $1a7db182178118f7$export$7f5f084e8d9a78d3)).views((0, $2f5f7352d371bb4d$export$7969e5a5385f7df2)).views((0, $1307fd361ee59300$export$d1d7b6b2a980356d)).views((0, $8d3f5ea5772a905b$export$6fba4e5cdd7f005c)).views((0, $6013d7e45fc085c9$export$30fc06c43908889d)).views((0, $a3de59097f70cb47$export$68c1757e9db1e843)).views((0, $f62ebabca0bf67f2$export$4248aa50bece1418)).views((0, $ef22a2a50bd6fe1f$export$a31645b7ae0fc8a6)).views((0, $50655aa55bc5063c$export$423d681166241a19)).views((0, $db37c565727bd6af$export$9dedde004efe52c2)).views((0, $0f571f43d43ce782$export$e507873dda3f69c9)).views((0, $6874e2c293a32d97$export$fdad2d9cf4189ed5)).views((0, $86127672cb41ff4f$export$4f82fdd4d54ff300)).views((0, $879d9c16c27ed178$export$8aed7b1f3b7d95e8)).views((0, $d28b592401b34c77$export$a417a04550b26651)).views((0, $22cd03eac392c42d$export$2ffdb49739e859c0)).views((0, $69027d6fa5335b45$export$eb758c674dc4f923)).views((0, $bc28e5fa09cb7751$export$dd99ec40cf6d8434)).views((0, $17c96b9e379c43fb$export$bb84d66f0d8b5a1d)).views((0, $f042c5f614d4793e$export$5ee8dd6674aab337)).views((0, $b85cce87524a4e0b$export$16fcde8e8dc295fd)).views((0, $dd1a31861ca94462$export$54f5371207c7d558)).views((0, $225618fae8526134$export$b25120175c842242)).views((0, $ed68460ae54fa45a$export$1dcc0a3b1caf4b96)).views((0, $068089025ba7790f$export$4b25ce4849150462));


const $bc745d3d067097a1$export$8d3520d001d68500 = (0, $i56po.types).model({
    data: (0, $698b1c14995d32f9$export$c675a423f801c19f)
});






var $bsQZT = parcelRequire("bsQZT");
const $7aceeb47c0737ee6$export$27753d0cccbc03ed = "root-storage";
/**
 * Setup the environment that all the models will be sharing.
 *
 * The environment includes other functions that will be picked from some
 * of the models that get created later. This is how we loosly couple things
 * like events between models.
 */ function $7aceeb47c0737ee6$var$createEnvironment() {
    return new (0, $b4a8ac180c7f34fc$export$7dc6752a22ab011a)();
}
function $7aceeb47c0737ee6$export$7efad43d6906781a() {
    const env = $7aceeb47c0737ee6$var$createEnvironment();
    let rootStore;
    try {
        const data = $34dcbefa7de5eb80$export$11e63f7b0f3d9900($7aceeb47c0737ee6$export$27753d0cccbc03ed) || {
            data: {}
        };
        rootStore = (0, $bc745d3d067097a1$export$8d3520d001d68500).create(data, env);
    } catch (e) {
        // if there's any problems loading, then let's at least fallback to an empty state
        // instead of crashing.
        rootStore = (0, $bc745d3d067097a1$export$8d3520d001d68500).create({
            data: {}
        }, env);
    }
    rootStore.data.setMarket(String((0, $6874e2c293a32d97$export$fce79585f79c7ac7).id), (0, $6874e2c293a32d97$export$1163140340aed06c).create({
        ...(0, $6874e2c293a32d97$export$fce79585f79c7ac7),
        api_endpoint: (0, $bsQZT.config).API_URL.slice(0, -1)
    }));
    rootStore.data.setMarket(String((0, $6874e2c293a32d97$export$971ffce69c407e92).id), (0, $6874e2c293a32d97$export$1163140340aed06c).create({
        ...(0, $6874e2c293a32d97$export$971ffce69c407e92),
        api_endpoint: (0, $bsQZT.config).API_GR_URL.slice(0, -1)
    }));
    rootStore.data.setMarket(String((0, $6874e2c293a32d97$export$cbc0c7bd5e199960).id), (0, $6874e2c293a32d97$export$1163140340aed06c).create({
        ...(0, $6874e2c293a32d97$export$cbc0c7bd5e199960),
        api_endpoint: (0, $bsQZT.config).API_SA_URL.slice(0, -1)
    }));
    $7aceeb47c0737ee6$var$setEnvBaseUrl(env, rootStore);
    // track changes & save to storage
    // eslint-disable-next-line @typescript-eslint/no-misused-promises
    (0, $i56po.onSnapshot)(rootStore, (snapshot)=>{
        $34dcbefa7de5eb80$export$a1544dad697b423d($7aceeb47c0737ee6$export$27753d0cccbc03ed, snapshot);
        $7aceeb47c0737ee6$var$setEnvBaseUrl(env, rootStore);
    });
    return rootStore;
}
function $7aceeb47c0737ee6$var$setEnvBaseUrl(env, store) {
    const marketCode = (0, $73ccb33f5de6f5aa$export$daa49e131b652e5b).getCurrentMarketCode();
    if (!marketCode) return;
    const selectedMarket = store.data.getMarketByCode(marketCode);
    if (!selectedMarket) return;
    if (!(0, $bsQZT.isLocalDevelopmentEnvironment)()) // @ts-ignore
    env.api.api.defaults.baseURL = `${selectedMarket.api_endpoint}/`;
}





const $ee10b48b1a4ae429$export$5b639964e6e432d6 = (0, $a4963babae245ff9$export$f0c7a449e0cfaec7)((0, $aca50e9407ba89c9$export$b6ae1bc530f4c149)(({ imageURL: imageURL })=>{
    const store = (0, $4671947198ddd366$export$6ccbb43953eebf8)();
    const redirect = (0, $7df35e9df335b1c8$export$602eaf6d5314ce55)();
    const { t: t } = (0, $3765cebd031b52c0$export$9fc83ad70ead8663)();
    const [, logout] = (0, $4671947198ddd366$export$609860bf8b0084c)(()=>store.data.logout({
            device_id: (0, $32ef62acd40089c4$export$1da4558c59cbf0b1)()
        }), {
        onSuccess: ()=>{
            redirect((0, $0534349ae8731d0b$export$66b32f6f30eb4b4).login, {});
            (0, $34dcbefa7de5eb80$export$cd7f480d6b8286c3)((0, $7aceeb47c0737ee6$export$27753d0cccbc03ed));
            (0, $34dcbefa7de5eb80$export$cd7f480d6b8286c3)((0, $d6286036be37a1b2$export$cfb849cb1a33bd13));
            (0, $c74a0566d4b0fd6d$export$e9db7d6e73593439).resetUser();
        }
    });
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $04012d5b0475752e$export$e44a253a59704894), {
        outerComponent: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
            src: imageURL,
            className: "Dropdown__main-avatar"
        }),
        items: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                onClick: ()=>redirect((0, $0534349ae8731d0b$export$66b32f6f30eb4b4).editProfile, {}),
                className: "Dropdown__link",
                children: t("profile_form.title")
            }, "edit-profile"),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                onClick: ()=>redirect((0, $0534349ae8731d0b$export$66b32f6f30eb4b4).changePassword, {}),
                className: "Dropdown__link",
                children: t("change_password.title")
            }, "change-password"),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                onClick: logout,
                className: "Dropdown__link",
                children: t("profile_form.sign_out")
            }, "sign-out")
        ]
    });
}));



var $44d71c4ff22dfd33$exports = {};
$44d71c4ff22dfd33$exports = new URL("back.aaa9932c.svg", import.meta.url).toString();




const $4a0377827412e4e6$export$494cf78290fbe4c7 = ({ profileImgURL: profileImgURL, title: title, subTitle: subTitle, showBack: showBack, handleBackClick: handleBackClick, rightComponent: rightComponent, bottomComponent: bottomComponent, containerStyle: containerStyle, logged: logged })=>{
    const [sidebarActive, setSidebarActive] = (0, $acw62.useState)(false);
    const navigateBack = ()=>window.history.back();
    const isCurrentScreenMain = (0, $7df35e9df335b1c8$export$e8c52816aa4ad75a)();
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        className: "MobileHeaderBox",
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
            className: "MobileHeaderBox__container",
            style: containerStyle,
            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "MobileHeader",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                    className: "MobileHeader__container",
                    style: {
                        flexDirection: isCurrentScreenMain ? "row" : "column",
                        justifyContent: isCurrentScreenMain ? "space-between" : "center"
                    },
                    children: isCurrentScreenMain ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "MobileHeader__main-left",
                                children: [
                                    logged && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $862384c1dc0db62b$export$1ba59dacbcbf90fe), {
                                        active: sidebarActive,
                                        setActive: setSidebarActive
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $660b2ca422e0e2ae$export$1ff3c3f08ae963c0).Horizontal, {
                                        width: 11
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                                        src: (0, (/*@__PURE__*/$parcel$interopDefault($b82c52bd08df11af$exports))),
                                        className: "MobileHeader__logo"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "MobileHeader__main-right",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $d836dbae630d7085$export$d96d49503bc30c36), {
                                        style: {
                                            marginRight: "50px"
                                        }
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $078111f863688379$export$8a92d876e077621), {}),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $660b2ca422e0e2ae$export$1ff3c3f08ae963c0).Horizontal, {
                                        width: 23
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ee10b48b1a4ae429$export$5b639964e6e432d6), {
                                        imageURL: profileImgURL ?? ""
                                    })
                                ]
                            })
                        ]
                    }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "MobileHeader__top",
                                children: [
                                    showBack ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                                        className: "MobileHeader__back rtl-x-flipped",
                                        src: (0, (/*@__PURE__*/$parcel$interopDefault($44d71c4ff22dfd33$exports))),
                                        alt: "go back",
                                        onClick: handleBackClick ?? navigateBack
                                    }) : logged && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $862384c1dc0db62b$export$1ba59dacbcbf90fe), {
                                        active: sidebarActive,
                                        setActive: setSidebarActive
                                    }),
                                    Boolean(title) && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        className: "MobileHeader__titleContainer",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h1", {
                                                className: "MobileHeader__title",
                                                children: title
                                            }),
                                            Boolean(subTitle) && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                className: "MobileHeader__subTitle",
                                                children: subTitle
                                            })
                                        ]
                                    }),
                                    rightComponent ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                        className: "MobileHeader__main-right",
                                        children: rightComponent
                                    }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                        className: "MobileHeader__main__separator"
                                    })
                                ]
                            }),
                            bottomComponent && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                className: "MobileHeader__bottom",
                                children: bottomComponent
                            })
                        ]
                    })
                })
            })
        })
    });
};












const $e117b901d9a87e1b$export$57edc697ae8c38e = ({ profileImgURL: profileImgURL, title: title, showBack: showBack, handleBackClick: handleBackClick, subTitle: subTitle, rightComponent: rightComponent, bottomComponent: bottomComponent, containerStyle: containerStyle, hideLogo: hideLogo })=>{
    const navigateBack = ()=>window.history.back();
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        className: "DesktopHeaderBox",
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
            className: "DesktopHeaderBox__container",
            style: containerStyle,
            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "DesktopHeader",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $660b2ca422e0e2ae$export$1ff3c3f08ae963c0).Vertical, {
                        height: 24
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "DesktopHeader__container",
                        children: (0, $7df35e9df335b1c8$export$e8c52816aa4ad75a)() ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: "DesktopHeader__main-controls",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                    className: "DesktopHeader__main-left",
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $660b2ca422e0e2ae$export$1ff3c3f08ae963c0).Horizontal, {
                                            width: 11
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                                            src: (0, (/*@__PURE__*/$parcel$interopDefault($b82c52bd08df11af$exports))),
                                            className: `DesktopHeader__logo ${hideLogo ? "hidden" : ""}`
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                    className: "DesktopHeader__main-right",
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $d836dbae630d7085$export$d96d49503bc30c36), {
                                            style: {
                                                marginInlineEnd: "50px"
                                            }
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $078111f863688379$export$8a92d876e077621), {}),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $660b2ca422e0e2ae$export$1ff3c3f08ae963c0).Horizontal, {
                                            width: 23
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ee10b48b1a4ae429$export$5b639964e6e432d6), {
                                            imageURL: profileImgURL ?? ""
                                        })
                                    ]
                                })
                            ]
                        }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                    className: "DesktopHeader__top",
                                    children: [
                                        showBack ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                                            className: "DesktopHeader__back rtl-x-flipped",
                                            src: (0, (/*@__PURE__*/$parcel$interopDefault($44d71c4ff22dfd33$exports))),
                                            alt: "go back",
                                            onClick: handleBackClick ?? navigateBack
                                        }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                            className: "DesktopHeader__main__separator"
                                        }),
                                        Boolean(title) && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h1", {
                                                    className: "DesktopHeader__title",
                                                    children: title
                                                }),
                                                Boolean(subTitle) && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                    className: "MobileHeader__subTitle",
                                                    children: subTitle
                                                })
                                            ]
                                        }),
                                        rightComponent ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                            className: "DesktopHeader__main-right",
                                            children: rightComponent
                                        }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                            className: "DesktopHeader__main__separator"
                                        })
                                    ]
                                }),
                                bottomComponent && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                    className: "DesktopHeader__bottom",
                                    children: bottomComponent
                                })
                            ]
                        })
                    })
                ]
            })
        })
    });
};





const $7ae42b63183f30b4$export$8b251419efc915eb = (0, $aca50e9407ba89c9$export$b6ae1bc530f4c149)(({ handleBackClick: handleBackClick, title: title, subTitle: subTitle, showBack: showBack, rightComponent: rightComponent, bottomComponent: bottomComponent, desktopContainerStyle: desktopContainerStyle, mobileContainerStyle: mobileContainerStyle, hideLogo: hideLogo = false })=>{
    const store = (0, $4671947198ddd366$export$6ccbb43953eebf8)();
    const redirect = (0, $7df35e9df335b1c8$export$602eaf6d5314ce55)();
    const onBackClick = handleBackClick ? handleBackClick : ()=>{
        const isFirstVisit = [
            1,
            2
        ].includes(window.history.length);
        if (isFirstVisit) {
            redirect((0, $0534349ae8731d0b$export$66b32f6f30eb4b4).index, {});
            return;
        }
        window.history.back();
    };
    if (!(0, $73ccb33f5de6f5aa$export$1d82b0dbb491a5f4)()) return null;
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4a0377827412e4e6$export$494cf78290fbe4c7), {
                handleBackClick: onBackClick,
                title: title,
                subTitle: subTitle,
                profileImgURL: store.data.profile?.image,
                showBack: showBack,
                rightComponent: rightComponent,
                bottomComponent: bottomComponent,
                containerStyle: mobileContainerStyle,
                logged: store.data.logged
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e117b901d9a87e1b$export$57edc697ae8c38e), {
                handleBackClick: onBackClick,
                title: title,
                subTitle: subTitle,
                profileImgURL: store.data.profile?.image,
                showBack: showBack,
                rightComponent: rightComponent,
                bottomComponent: bottomComponent,
                containerStyle: desktopContainerStyle,
                hideLogo: hideLogo
            })
        ]
    });
});











const $96de59b951af76cc$export$eeb15ad990050873 = (0, $a4963babae245ff9$export$f0c7a449e0cfaec7)((0, $aca50e9407ba89c9$export$b6ae1bc530f4c149)(({ redirectPath: redirectPath })=>{
    const store = (0, $4671947198ddd366$export$6ccbb43953eebf8)();
    (0, $4671947198ddd366$export$dd0a697e1782aedd)(store.data.getMarkets);
    if ((0, $73ccb33f5de6f5aa$export$3297dfed24c77062).length < 2) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {});
    const marketList = store.data.marketList;
    const currentMarketCode = (0, $73ccb33f5de6f5aa$export$daa49e131b652e5b).getCurrentMarketCode();
    const selectedMarket = !currentMarketCode ? marketList[0] ?? null : store.data.getMarketByCode(currentMarketCode);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $04012d5b0475752e$export$e44a253a59704894), {
        outerComponent: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
            className: "MarketSelector",
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                    src: selectedMarket?.icon,
                    className: "MarketSelector__countryImg"
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: "MarketSelector__codeContainer",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                            className: "MarketSelector__countryCode",
                            children: selectedMarket?.code
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                            src: (0, (/*@__PURE__*/$parcel$interopDefault($e56c86bed33f8664$exports))),
                            className: "MarketSelector__countryArrowDown"
                        })
                    ]
                })
            ]
        }),
        items: marketList.map((market)=>{
            return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                onClick: ()=>{
                    window.location.href = `/${market.code}/${redirectPath}${window.location.search}`;
                },
                className: `MarketSelector__item${market.id === selectedMarket?.id ? " MarketSelector__item--active" : ""}`,
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                        src: market.icon
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $660b2ca422e0e2ae$export$1ff3c3f08ae963c0).Horizontal, {
                        width: 16
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                        className: "MarketSelector__item__title",
                        children: market.name
                    })
                ]
            }, market.id);
        })
    });
}));



const $3d8e0803e82eb4e3$export$8f90322179de297 = (props)=>{
    const { t: t } = (0, $3765cebd031b52c0$export$9fc83ad70ead8663)();
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "Login",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "Login__topContainer",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                        src: (0, (/*@__PURE__*/$parcel$interopDefault($3279ad32455be7ff$exports))),
                        className: "Login__logo"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $96de59b951af76cc$export$eeb15ad990050873), {
                        redirectPath: "login"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $660b2ca422e0e2ae$export$1ff3c3f08ae963c0).Vertical, {
                height: 45
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h1", {
                className: "Login__title",
                children: t("login.good_to_see_you_back")
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $660b2ca422e0e2ae$export$1ff3c3f08ae963c0).Vertical, {
                height: 5
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h2", {
                className: "Login__subtitle",
                children: t("login.sign_in_to_account")
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $660b2ca422e0e2ae$export$1ff3c3f08ae963c0).Vertical, {
                height: 53
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $1067a74e1c3483e2$export$f551688fc98f2e09), {
                errors: props.emailErrors,
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4e342c5928158118$export$f5b8910cec6cf069), {
                    type: "email",
                    label: t("login.email"),
                    value: props.email,
                    handleChange: props.handlEmailChange
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $660b2ca422e0e2ae$export$1ff3c3f08ae963c0).Vertical, {
                height: 29
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $1067a74e1c3483e2$export$f551688fc98f2e09), {
                errors: props.passwordErrors,
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $621096805b6f645e$export$b28585a458fee016), {
                    label: t("login.password"),
                    value: props.password,
                    handleChange: props.handlPasswordChange,
                    hidePasswordByDefault: true
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $660b2ca422e0e2ae$export$1ff3c3f08ae963c0).Vertical, {
                height: 36
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "Login__underform",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7df35e9df335b1c8$export$a6c7ac8248d6e38a), {
                    route: (0, $0534349ae8731d0b$export$66b32f6f30eb4b4).forgotPassword,
                    params: {},
                    children: t("login.forgot_password_question")
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $660b2ca422e0e2ae$export$1ff3c3f08ae963c0).Vertical, {
                height: 53
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                onClick: props.handleLoginButtonPress,
                type: "submit",
                className: "Login__button",
                children: props.submitting ? t("login.signin_in") : t("login.sign_in")
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7df35e9df335b1c8$export$a6c7ac8248d6e38a), {
                route: (0, $73ccb33f5de6f5aa$export$1d82b0dbb491a5f4)() ? (0, $0534349ae8731d0b$export$66b32f6f30eb4b4).signUpWithOrder : (0, $0534349ae8731d0b$export$66b32f6f30eb4b4).signUp,
                params: {},
                className: "Login__SignUp_link",
                handleClick: (e)=>props.handleSignUpLinkPress(),
                children: t("login.sign_up_link_text")
            })
        ]
    });
};


const $f24bfaf5bd0db3a1$var$LoginContainer = (0, $a5511b7baaaa1d7d$export$fdaf0fa3d19f8eed)((0, $3d8e0803e82eb4e3$export$8f90322179de297));
const $f24bfaf5bd0db3a1$export$f14c0e3f98d164c0 = (props)=>{
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($f24bfaf5bd0db3a1$var$LoginContainer, {
        onLogin: props.onLogin
    });
};




var $acw62 = parcelRequire("acw62");



var $7YFi7 = parcelRequire("7YFi7");










const $c5ed36b134b2d50e$export$847b1abaf17f2c47 = {
    "af": {
        "name": "Afghanistan",
        "iso2": "af",
        "dialCode": "93",
        "mask": null,
        "priority": null,
        "regionCodes": [],
        "minLocalPhonePartLength": null,
        "maxLocalPhonePartLength": null
    },
    "al": {
        "name": "Albania",
        "iso2": "al",
        "dialCode": "355",
        "mask": null,
        "priority": null,
        "regionCodes": [],
        "minLocalPhonePartLength": null,
        "maxLocalPhonePartLength": null
    },
    "dz": {
        "name": "Algeria",
        "iso2": "dz",
        "dialCode": "213",
        "mask": null,
        "priority": null,
        "regionCodes": [],
        "minLocalPhonePartLength": null,
        "maxLocalPhonePartLength": null
    },
    "ad": {
        "name": "Andorra",
        "iso2": "ad",
        "dialCode": "376",
        "mask": null,
        "priority": null,
        "regionCodes": [],
        "minLocalPhonePartLength": null,
        "maxLocalPhonePartLength": null
    },
    "ao": {
        "name": "Angola",
        "iso2": "ao",
        "dialCode": "244",
        "mask": null,
        "priority": null,
        "regionCodes": [],
        "minLocalPhonePartLength": null,
        "maxLocalPhonePartLength": null
    },
    "ag": {
        "name": "Antigua and Barbuda",
        "iso2": "ag",
        "dialCode": "1268",
        "mask": null,
        "priority": null,
        "regionCodes": [],
        "minLocalPhonePartLength": null,
        "maxLocalPhonePartLength": null
    },
    "ar": {
        "name": "Argentina",
        "iso2": "ar",
        "dialCode": "54",
        "mask": "(..) ........",
        "priority": 0,
        "regionCodes": [
            "11",
            "221",
            "223",
            "261",
            "264",
            "2652",
            "280",
            "2905",
            "291",
            "2920",
            "2966",
            "299",
            "341",
            "342",
            "343",
            "351",
            "376",
            "379",
            "381",
            "3833",
            "385",
            "387",
            "388"
        ],
        "minLocalPhonePartLength": null,
        "maxLocalPhonePartLength": null
    },
    "am": {
        "name": "Armenia",
        "iso2": "am",
        "dialCode": "374",
        "mask": ".. ......",
        "priority": null,
        "regionCodes": [],
        "minLocalPhonePartLength": null,
        "maxLocalPhonePartLength": null
    },
    "aw": {
        "name": "Aruba",
        "iso2": "aw",
        "dialCode": "297",
        "mask": null,
        "priority": null,
        "regionCodes": [],
        "minLocalPhonePartLength": null,
        "maxLocalPhonePartLength": null
    },
    "au": {
        "name": "Australia",
        "iso2": "au",
        "dialCode": "61",
        "mask": "(..) .... ....",
        "priority": 0,
        "regionCodes": [
            "2",
            "3",
            "4",
            "7",
            "8",
            "02",
            "03",
            "04",
            "07",
            "08"
        ],
        "minLocalPhonePartLength": null,
        "maxLocalPhonePartLength": null
    },
    "at": {
        "name": "Austria",
        "iso2": "at",
        "dialCode": "43",
        "mask": null,
        "priority": null,
        "regionCodes": [],
        "minLocalPhonePartLength": null,
        "maxLocalPhonePartLength": null
    },
    "az": {
        "name": "Azerbaijan",
        "iso2": "az",
        "dialCode": "994",
        "mask": "(..) ... .. ..",
        "priority": null,
        "regionCodes": [],
        "minLocalPhonePartLength": null,
        "maxLocalPhonePartLength": null
    },
    "bs": {
        "name": "Bahamas",
        "iso2": "bs",
        "dialCode": "1242",
        "mask": null,
        "priority": null,
        "regionCodes": [],
        "minLocalPhonePartLength": null,
        "maxLocalPhonePartLength": null
    },
    "bh": {
        "name": "Bahrain",
        "iso2": "bh",
        "dialCode": "973",
        "mask": null,
        "priority": null,
        "regionCodes": [],
        "minLocalPhonePartLength": null,
        "maxLocalPhonePartLength": null
    },
    "bd": {
        "name": "Bangladesh",
        "iso2": "bd",
        "dialCode": "880",
        "mask": null,
        "priority": null,
        "regionCodes": [],
        "minLocalPhonePartLength": null,
        "maxLocalPhonePartLength": null
    },
    "bb": {
        "name": "Barbados",
        "iso2": "bb",
        "dialCode": "1246",
        "mask": null,
        "priority": null,
        "regionCodes": [],
        "minLocalPhonePartLength": null,
        "maxLocalPhonePartLength": null
    },
    "by": {
        "name": "Belarus",
        "iso2": "by",
        "dialCode": "375",
        "mask": "(..) ... .. ..",
        "priority": null,
        "regionCodes": [],
        "minLocalPhonePartLength": null,
        "maxLocalPhonePartLength": null
    },
    "be": {
        "name": "Belgium",
        "iso2": "be",
        "dialCode": "32",
        "mask": "... .. .. ..",
        "priority": null,
        "regionCodes": [],
        "minLocalPhonePartLength": null,
        "maxLocalPhonePartLength": null
    },
    "bz": {
        "name": "Belize",
        "iso2": "bz",
        "dialCode": "501",
        "mask": null,
        "priority": null,
        "regionCodes": [],
        "minLocalPhonePartLength": null,
        "maxLocalPhonePartLength": null
    },
    "bj": {
        "name": "Benin",
        "iso2": "bj",
        "dialCode": "229",
        "mask": null,
        "priority": null,
        "regionCodes": [],
        "minLocalPhonePartLength": null,
        "maxLocalPhonePartLength": null
    },
    "bt": {
        "name": "Bhutan",
        "iso2": "bt",
        "dialCode": "975",
        "mask": null,
        "priority": null,
        "regionCodes": [],
        "minLocalPhonePartLength": null,
        "maxLocalPhonePartLength": null
    },
    "bo": {
        "name": "Bolivia",
        "iso2": "bo",
        "dialCode": "591",
        "mask": null,
        "priority": null,
        "regionCodes": [],
        "minLocalPhonePartLength": null,
        "maxLocalPhonePartLength": null
    },
    "ba": {
        "name": "Bosnia and Herzegovina",
        "iso2": "ba",
        "dialCode": "387",
        "mask": null,
        "priority": null,
        "regionCodes": [],
        "minLocalPhonePartLength": null,
        "maxLocalPhonePartLength": null
    },
    "bw": {
        "name": "Botswana",
        "iso2": "bw",
        "dialCode": "267",
        "mask": null,
        "priority": null,
        "regionCodes": [],
        "minLocalPhonePartLength": null,
        "maxLocalPhonePartLength": null
    },
    "br": {
        "name": "Brazil",
        "iso2": "br",
        "dialCode": "55",
        "mask": "(..) .........",
        "priority": null,
        "regionCodes": [],
        "minLocalPhonePartLength": null,
        "maxLocalPhonePartLength": null
    },
    "io": {
        "name": "British Indian Ocean Territory",
        "iso2": "io",
        "dialCode": "246",
        "mask": null,
        "priority": null,
        "regionCodes": [],
        "minLocalPhonePartLength": null,
        "maxLocalPhonePartLength": null
    },
    "bn": {
        "name": "Brunei",
        "iso2": "bn",
        "dialCode": "673",
        "mask": null,
        "priority": null,
        "regionCodes": [],
        "minLocalPhonePartLength": null,
        "maxLocalPhonePartLength": null
    },
    "bg": {
        "name": "Bulgaria",
        "iso2": "bg",
        "dialCode": "359",
        "mask": null,
        "priority": null,
        "regionCodes": [],
        "minLocalPhonePartLength": null,
        "maxLocalPhonePartLength": null
    },
    "bf": {
        "name": "Burkina Faso",
        "iso2": "bf",
        "dialCode": "226",
        "mask": null,
        "priority": null,
        "regionCodes": [],
        "minLocalPhonePartLength": null,
        "maxLocalPhonePartLength": null
    },
    "bi": {
        "name": "Burundi",
        "iso2": "bi",
        "dialCode": "257",
        "mask": null,
        "priority": null,
        "regionCodes": [],
        "minLocalPhonePartLength": null,
        "maxLocalPhonePartLength": null
    },
    "kh": {
        "name": "Cambodia",
        "iso2": "kh",
        "dialCode": "855",
        "mask": null,
        "priority": null,
        "regionCodes": [],
        "minLocalPhonePartLength": null,
        "maxLocalPhonePartLength": null
    },
    "cm": {
        "name": "Cameroon",
        "iso2": "cm",
        "dialCode": "237",
        "mask": null,
        "priority": null,
        "regionCodes": [],
        "minLocalPhonePartLength": null,
        "maxLocalPhonePartLength": null
    },
    "ca": {
        "name": "Canada",
        "iso2": "ca",
        "dialCode": "1",
        "mask": "(...) ...-....",
        "priority": 1,
        "regionCodes": [
            "204",
            "226",
            "236",
            "249",
            "250",
            "289",
            "306",
            "343",
            "365",
            "387",
            "403",
            "416",
            "418",
            "431",
            "437",
            "438",
            "450",
            "506",
            "514",
            "519",
            "548",
            "579",
            "581",
            "587",
            "604",
            "613",
            "639",
            "647",
            "672",
            "705",
            "709",
            "742",
            "778",
            "780",
            "782",
            "807",
            "819",
            "825",
            "867",
            "873",
            "902",
            "905"
        ],
        "minLocalPhonePartLength": null,
        "maxLocalPhonePartLength": null
    },
    "cv": {
        "name": "Cape Verde",
        "iso2": "cv",
        "dialCode": "238",
        "mask": null,
        "priority": null,
        "regionCodes": [],
        "minLocalPhonePartLength": null,
        "maxLocalPhonePartLength": null
    },
    "bq": {
        "name": "Caribbean Netherlands",
        "iso2": "bq",
        "dialCode": "599",
        "mask": "",
        "priority": 1,
        "regionCodes": [],
        "minLocalPhonePartLength": null,
        "maxLocalPhonePartLength": null
    },
    "cf": {
        "name": "Central African Republic",
        "iso2": "cf",
        "dialCode": "236",
        "mask": null,
        "priority": null,
        "regionCodes": [],
        "minLocalPhonePartLength": null,
        "maxLocalPhonePartLength": null
    },
    "td": {
        "name": "Chad",
        "iso2": "td",
        "dialCode": "235",
        "mask": null,
        "priority": null,
        "regionCodes": [],
        "minLocalPhonePartLength": null,
        "maxLocalPhonePartLength": null
    },
    "cl": {
        "name": "Chile",
        "iso2": "cl",
        "dialCode": "56",
        "mask": null,
        "priority": null,
        "regionCodes": [],
        "minLocalPhonePartLength": null,
        "maxLocalPhonePartLength": null
    },
    "cn": {
        "name": "China",
        "iso2": "cn",
        "dialCode": "86",
        "mask": "..-.........",
        "priority": null,
        "regionCodes": [],
        "minLocalPhonePartLength": null,
        "maxLocalPhonePartLength": null
    },
    "co": {
        "name": "Colombia",
        "iso2": "co",
        "dialCode": "57",
        "mask": "... ... ....",
        "priority": null,
        "regionCodes": [],
        "minLocalPhonePartLength": null,
        "maxLocalPhonePartLength": null
    },
    "km": {
        "name": "Comoros",
        "iso2": "km",
        "dialCode": "269",
        "mask": null,
        "priority": null,
        "regionCodes": [],
        "minLocalPhonePartLength": null,
        "maxLocalPhonePartLength": null
    },
    "cd": {
        "name": "Congo",
        "iso2": "cd",
        "dialCode": "243",
        "mask": null,
        "priority": null,
        "regionCodes": [],
        "minLocalPhonePartLength": null,
        "maxLocalPhonePartLength": null
    },
    "cg": {
        "name": "Congo",
        "iso2": "cg",
        "dialCode": "242",
        "mask": null,
        "priority": null,
        "regionCodes": [],
        "minLocalPhonePartLength": null,
        "maxLocalPhonePartLength": null
    },
    "cr": {
        "name": "Costa Rica",
        "iso2": "cr",
        "dialCode": "506",
        "mask": "....-....",
        "priority": null,
        "regionCodes": [],
        "minLocalPhonePartLength": null,
        "maxLocalPhonePartLength": null
    },
    "ci": {
        "name": "C\xf4te d\u2019Ivoire",
        "iso2": "ci",
        "dialCode": "225",
        "mask": ".. .. .. ..",
        "priority": null,
        "regionCodes": [],
        "minLocalPhonePartLength": null,
        "maxLocalPhonePartLength": null
    },
    "hr": {
        "name": "Croatia",
        "iso2": "hr",
        "dialCode": "385",
        "mask": null,
        "priority": null,
        "regionCodes": [],
        "minLocalPhonePartLength": null,
        "maxLocalPhonePartLength": null
    },
    "cu": {
        "name": "Cuba",
        "iso2": "cu",
        "dialCode": "53",
        "mask": null,
        "priority": null,
        "regionCodes": [],
        "minLocalPhonePartLength": null,
        "maxLocalPhonePartLength": null
    },
    "cw": {
        "name": "Cura\xe7ao",
        "iso2": "cw",
        "dialCode": "599",
        "mask": "",
        "priority": 0,
        "regionCodes": [],
        "minLocalPhonePartLength": null,
        "maxLocalPhonePartLength": null
    },
    "cy": {
        "name": "Cyprus",
        "iso2": "cy",
        "dialCode": "357",
        "mask": ".. ......",
        "priority": null,
        "regionCodes": [],
        "minLocalPhonePartLength": null,
        "maxLocalPhonePartLength": null
    },
    "cz": {
        "name": "Czech Republic",
        "iso2": "cz",
        "dialCode": "420",
        "mask": "... ... ...",
        "priority": null,
        "regionCodes": [],
        "minLocalPhonePartLength": null,
        "maxLocalPhonePartLength": null
    },
    "dk": {
        "name": "Denmark",
        "iso2": "dk",
        "dialCode": "45",
        "mask": ".. .. .. ..",
        "priority": null,
        "regionCodes": [],
        "minLocalPhonePartLength": null,
        "maxLocalPhonePartLength": null
    },
    "dj": {
        "name": "Djibouti",
        "iso2": "dj",
        "dialCode": "253",
        "mask": null,
        "priority": null,
        "regionCodes": [],
        "minLocalPhonePartLength": null,
        "maxLocalPhonePartLength": null
    },
    "dm": {
        "name": "Dominica",
        "iso2": "dm",
        "dialCode": "1767",
        "mask": null,
        "priority": null,
        "regionCodes": [],
        "minLocalPhonePartLength": null,
        "maxLocalPhonePartLength": null
    },
    "do": {
        "name": "Dominican Republic",
        "iso2": "do",
        "dialCode": "1",
        "mask": "",
        "priority": 2,
        "regionCodes": [
            "809",
            "829",
            "849"
        ],
        "minLocalPhonePartLength": null,
        "maxLocalPhonePartLength": null
    },
    "ec": {
        "name": "Ecuador",
        "iso2": "ec",
        "dialCode": "593",
        "mask": null,
        "priority": null,
        "regionCodes": [],
        "minLocalPhonePartLength": null,
        "maxLocalPhonePartLength": null
    },
    "eg": {
        "name": "Egypt",
        "iso2": "eg",
        "dialCode": "20",
        "mask": null,
        "priority": null,
        "regionCodes": [],
        "minLocalPhonePartLength": null,
        "maxLocalPhonePartLength": null
    },
    "sv": {
        "name": "El Salvador",
        "iso2": "sv",
        "dialCode": "503",
        "mask": "....-....",
        "priority": null,
        "regionCodes": [],
        "minLocalPhonePartLength": null,
        "maxLocalPhonePartLength": null
    },
    "gq": {
        "name": "Equatorial Guinea",
        "iso2": "gq",
        "dialCode": "240",
        "mask": null,
        "priority": null,
        "regionCodes": [],
        "minLocalPhonePartLength": null,
        "maxLocalPhonePartLength": null
    },
    "er": {
        "name": "Eritrea",
        "iso2": "er",
        "dialCode": "291",
        "mask": null,
        "priority": null,
        "regionCodes": [],
        "minLocalPhonePartLength": null,
        "maxLocalPhonePartLength": null
    },
    "ee": {
        "name": "Estonia",
        "iso2": "ee",
        "dialCode": "372",
        "mask": ".... ......",
        "priority": null,
        "regionCodes": [],
        "minLocalPhonePartLength": null,
        "maxLocalPhonePartLength": null
    },
    "et": {
        "name": "Ethiopia",
        "iso2": "et",
        "dialCode": "251",
        "mask": null,
        "priority": null,
        "regionCodes": [],
        "minLocalPhonePartLength": null,
        "maxLocalPhonePartLength": null
    },
    "fj": {
        "name": "Fiji",
        "iso2": "fj",
        "dialCode": "679",
        "mask": null,
        "priority": null,
        "regionCodes": [],
        "minLocalPhonePartLength": null,
        "maxLocalPhonePartLength": null
    },
    "fi": {
        "name": "Finland",
        "iso2": "fi",
        "dialCode": "358",
        "mask": ".. ... .. ..",
        "priority": null,
        "regionCodes": [],
        "minLocalPhonePartLength": null,
        "maxLocalPhonePartLength": null
    },
    "fr": {
        "name": "France",
        "iso2": "fr",
        "dialCode": "33",
        "mask": ". .. .. .. ..",
        "priority": null,
        "regionCodes": [],
        "minLocalPhonePartLength": null,
        "maxLocalPhonePartLength": null
    },
    "gf": {
        "name": "French Guiana",
        "iso2": "gf",
        "dialCode": "594",
        "mask": null,
        "priority": null,
        "regionCodes": [],
        "minLocalPhonePartLength": null,
        "maxLocalPhonePartLength": null
    },
    "pf": {
        "name": "French Polynesia",
        "iso2": "pf",
        "dialCode": "689",
        "mask": null,
        "priority": null,
        "regionCodes": [],
        "minLocalPhonePartLength": null,
        "maxLocalPhonePartLength": null
    },
    "ga": {
        "name": "Gabon",
        "iso2": "ga",
        "dialCode": "241",
        "mask": null,
        "priority": null,
        "regionCodes": [],
        "minLocalPhonePartLength": null,
        "maxLocalPhonePartLength": null
    },
    "gm": {
        "name": "Gambia",
        "iso2": "gm",
        "dialCode": "220",
        "mask": null,
        "priority": null,
        "regionCodes": [],
        "minLocalPhonePartLength": null,
        "maxLocalPhonePartLength": null
    },
    "ge": {
        "name": "Georgia",
        "iso2": "ge",
        "dialCode": "995",
        "mask": null,
        "priority": null,
        "regionCodes": [],
        "minLocalPhonePartLength": null,
        "maxLocalPhonePartLength": null
    },
    "de": {
        "name": "Germany",
        "iso2": "de",
        "dialCode": "49",
        "mask": ".... ........",
        "priority": null,
        "regionCodes": [],
        "minLocalPhonePartLength": null,
        "maxLocalPhonePartLength": null
    },
    "gh": {
        "name": "Ghana",
        "iso2": "gh",
        "dialCode": "233",
        "mask": null,
        "priority": null,
        "regionCodes": [],
        "minLocalPhonePartLength": null,
        "maxLocalPhonePartLength": null
    },
    "gr": {
        "name": "Greece",
        "iso2": "gr",
        "dialCode": "30",
        "mask": "..........",
        "priority": null,
        "regionCodes": [],
        "minLocalPhonePartLength": 10,
        "maxLocalPhonePartLength": 10
    },
    "gd": {
        "name": "Grenada",
        "iso2": "gd",
        "dialCode": "1473",
        "mask": null,
        "priority": null,
        "regionCodes": [],
        "minLocalPhonePartLength": null,
        "maxLocalPhonePartLength": null
    },
    "gp": {
        "name": "Guadeloupe",
        "iso2": "gp",
        "dialCode": "590",
        "mask": "",
        "priority": 0,
        "regionCodes": [],
        "minLocalPhonePartLength": null,
        "maxLocalPhonePartLength": null
    },
    "gu": {
        "name": "Guam",
        "iso2": "gu",
        "dialCode": "1671",
        "mask": null,
        "priority": null,
        "regionCodes": [],
        "minLocalPhonePartLength": null,
        "maxLocalPhonePartLength": null
    },
    "gt": {
        "name": "Guatemala",
        "iso2": "gt",
        "dialCode": "502",
        "mask": "....-....",
        "priority": null,
        "regionCodes": [],
        "minLocalPhonePartLength": null,
        "maxLocalPhonePartLength": null
    },
    "gn": {
        "name": "Guinea",
        "iso2": "gn",
        "dialCode": "224",
        "mask": null,
        "priority": null,
        "regionCodes": [],
        "minLocalPhonePartLength": null,
        "maxLocalPhonePartLength": null
    },
    "gw": {
        "name": "Guinea-Bissau",
        "iso2": "gw",
        "dialCode": "245",
        "mask": null,
        "priority": null,
        "regionCodes": [],
        "minLocalPhonePartLength": null,
        "maxLocalPhonePartLength": null
    },
    "gy": {
        "name": "Guyana",
        "iso2": "gy",
        "dialCode": "592",
        "mask": null,
        "priority": null,
        "regionCodes": [],
        "minLocalPhonePartLength": null,
        "maxLocalPhonePartLength": null
    },
    "ht": {
        "name": "Haiti",
        "iso2": "ht",
        "dialCode": "509",
        "mask": "....-....",
        "priority": null,
        "regionCodes": [],
        "minLocalPhonePartLength": null,
        "maxLocalPhonePartLength": null
    },
    "hn": {
        "name": "Honduras",
        "iso2": "hn",
        "dialCode": "504",
        "mask": null,
        "priority": null,
        "regionCodes": [],
        "minLocalPhonePartLength": null,
        "maxLocalPhonePartLength": null
    },
    "hk": {
        "name": "Hong Kong",
        "iso2": "hk",
        "dialCode": "852",
        "mask": ".... ....",
        "priority": null,
        "regionCodes": [],
        "minLocalPhonePartLength": null,
        "maxLocalPhonePartLength": null
    },
    "hu": {
        "name": "Hungary",
        "iso2": "hu",
        "dialCode": "36",
        "mask": null,
        "priority": null,
        "regionCodes": [],
        "minLocalPhonePartLength": null,
        "maxLocalPhonePartLength": null
    },
    "is": {
        "name": "Iceland",
        "iso2": "is",
        "dialCode": "354",
        "mask": "... ....",
        "priority": null,
        "regionCodes": [],
        "minLocalPhonePartLength": null,
        "maxLocalPhonePartLength": null
    },
    "in": {
        "name": "India",
        "iso2": "in",
        "dialCode": "91",
        "mask": ".....-.....",
        "priority": null,
        "regionCodes": [],
        "minLocalPhonePartLength": null,
        "maxLocalPhonePartLength": null
    },
    "id": {
        "name": "Indonesia",
        "iso2": "id",
        "dialCode": "62",
        "mask": null,
        "priority": null,
        "regionCodes": [],
        "minLocalPhonePartLength": null,
        "maxLocalPhonePartLength": null
    },
    "ir": {
        "name": "Iran",
        "iso2": "ir",
        "dialCode": "98",
        "mask": "... ... ....",
        "priority": null,
        "regionCodes": [],
        "minLocalPhonePartLength": null,
        "maxLocalPhonePartLength": null
    },
    "iq": {
        "name": "Iraq",
        "iso2": "iq",
        "dialCode": "964",
        "mask": null,
        "priority": null,
        "regionCodes": [],
        "minLocalPhonePartLength": null,
        "maxLocalPhonePartLength": null
    },
    "ie": {
        "name": "Ireland",
        "iso2": "ie",
        "dialCode": "353",
        "mask": ".. .......",
        "priority": null,
        "regionCodes": [],
        "minLocalPhonePartLength": null,
        "maxLocalPhonePartLength": null
    },
    "il": {
        "name": "Israel",
        "iso2": "il",
        "dialCode": "972",
        "mask": "... ... ....",
        "priority": null,
        "regionCodes": [],
        "minLocalPhonePartLength": null,
        "maxLocalPhonePartLength": null
    },
    "it": {
        "name": "Italy",
        "iso2": "it",
        "dialCode": "39",
        "mask": "... .......",
        "priority": 0,
        "regionCodes": [],
        "minLocalPhonePartLength": null,
        "maxLocalPhonePartLength": null
    },
    "jm": {
        "name": "Jamaica",
        "iso2": "jm",
        "dialCode": "1876",
        "mask": null,
        "priority": null,
        "regionCodes": [],
        "minLocalPhonePartLength": null,
        "maxLocalPhonePartLength": null
    },
    "jp": {
        "name": "Japan",
        "iso2": "jp",
        "dialCode": "81",
        "mask": ".. .... ....",
        "priority": null,
        "regionCodes": [],
        "minLocalPhonePartLength": null,
        "maxLocalPhonePartLength": null
    },
    "jo": {
        "name": "Jordan",
        "iso2": "jo",
        "dialCode": "962",
        "mask": null,
        "priority": null,
        "regionCodes": [],
        "minLocalPhonePartLength": null,
        "maxLocalPhonePartLength": null
    },
    "kz": {
        "name": "Kazakhstan",
        "iso2": "kz",
        "dialCode": "7",
        "mask": "... ...-..-..",
        "priority": 1,
        "regionCodes": [
            "310",
            "311",
            "312",
            "313",
            "315",
            "318",
            "321",
            "324",
            "325",
            "326",
            "327",
            "336",
            "7172",
            "73622"
        ],
        "minLocalPhonePartLength": null,
        "maxLocalPhonePartLength": null
    },
    "ke": {
        "name": "Kenya",
        "iso2": "ke",
        "dialCode": "254",
        "mask": null,
        "priority": null,
        "regionCodes": [],
        "minLocalPhonePartLength": null,
        "maxLocalPhonePartLength": null
    },
    "ki": {
        "name": "Kiribati",
        "iso2": "ki",
        "dialCode": "686",
        "mask": null,
        "priority": null,
        "regionCodes": [],
        "minLocalPhonePartLength": null,
        "maxLocalPhonePartLength": null
    },
    "xk": {
        "name": "Kosovo",
        "iso2": "xk",
        "dialCode": "383",
        "mask": null,
        "priority": null,
        "regionCodes": [],
        "minLocalPhonePartLength": null,
        "maxLocalPhonePartLength": null
    },
    "kw": {
        "name": "Kuwait",
        "iso2": "kw",
        "dialCode": "965",
        "mask": null,
        "priority": null,
        "regionCodes": [],
        "minLocalPhonePartLength": null,
        "maxLocalPhonePartLength": null
    },
    "kg": {
        "name": "Kyrgyzstan",
        "iso2": "kg",
        "dialCode": "996",
        "mask": "... ... ...",
        "priority": null,
        "regionCodes": [],
        "minLocalPhonePartLength": null,
        "maxLocalPhonePartLength": null
    },
    "la": {
        "name": "Laos",
        "iso2": "la",
        "dialCode": "856",
        "mask": null,
        "priority": null,
        "regionCodes": [],
        "minLocalPhonePartLength": null,
        "maxLocalPhonePartLength": null
    },
    "lv": {
        "name": "Latvia",
        "iso2": "lv",
        "dialCode": "371",
        "mask": ".. ... ...",
        "priority": null,
        "regionCodes": [],
        "minLocalPhonePartLength": null,
        "maxLocalPhonePartLength": null
    },
    "lb": {
        "name": "Lebanon",
        "iso2": "lb",
        "dialCode": "961",
        "mask": null,
        "priority": null,
        "regionCodes": [],
        "minLocalPhonePartLength": null,
        "maxLocalPhonePartLength": null
    },
    "ls": {
        "name": "Lesotho",
        "iso2": "ls",
        "dialCode": "266",
        "mask": null,
        "priority": null,
        "regionCodes": [],
        "minLocalPhonePartLength": null,
        "maxLocalPhonePartLength": null
    },
    "lr": {
        "name": "Liberia",
        "iso2": "lr",
        "dialCode": "231",
        "mask": null,
        "priority": null,
        "regionCodes": [],
        "minLocalPhonePartLength": null,
        "maxLocalPhonePartLength": null
    },
    "ly": {
        "name": "Libya",
        "iso2": "ly",
        "dialCode": "218",
        "mask": null,
        "priority": null,
        "regionCodes": [],
        "minLocalPhonePartLength": null,
        "maxLocalPhonePartLength": null
    },
    "li": {
        "name": "Liechtenstein",
        "iso2": "li",
        "dialCode": "423",
        "mask": null,
        "priority": null,
        "regionCodes": [],
        "minLocalPhonePartLength": null,
        "maxLocalPhonePartLength": null
    },
    "lt": {
        "name": "Lithuania",
        "iso2": "lt",
        "dialCode": "370",
        "mask": null,
        "priority": null,
        "regionCodes": [],
        "minLocalPhonePartLength": null,
        "maxLocalPhonePartLength": null
    },
    "lu": {
        "name": "Luxembourg",
        "iso2": "lu",
        "dialCode": "352",
        "mask": null,
        "priority": null,
        "regionCodes": [],
        "minLocalPhonePartLength": null,
        "maxLocalPhonePartLength": null
    },
    "mo": {
        "name": "Macau",
        "iso2": "mo",
        "dialCode": "853",
        "mask": null,
        "priority": null,
        "regionCodes": [],
        "minLocalPhonePartLength": null,
        "maxLocalPhonePartLength": null
    },
    "mk": {
        "name": "Macedonia",
        "iso2": "mk",
        "dialCode": "389",
        "mask": null,
        "priority": null,
        "regionCodes": [],
        "minLocalPhonePartLength": null,
        "maxLocalPhonePartLength": null
    },
    "mg": {
        "name": "Madagascar",
        "iso2": "mg",
        "dialCode": "261",
        "mask": null,
        "priority": null,
        "regionCodes": [],
        "minLocalPhonePartLength": null,
        "maxLocalPhonePartLength": null
    },
    "mw": {
        "name": "Malawi",
        "iso2": "mw",
        "dialCode": "265",
        "mask": null,
        "priority": null,
        "regionCodes": [],
        "minLocalPhonePartLength": null,
        "maxLocalPhonePartLength": null
    },
    "my": {
        "name": "Malaysia",
        "iso2": "my",
        "dialCode": "60",
        "mask": "..-....-....",
        "priority": null,
        "regionCodes": [],
        "minLocalPhonePartLength": null,
        "maxLocalPhonePartLength": null
    },
    "mv": {
        "name": "Maldives",
        "iso2": "mv",
        "dialCode": "960",
        "mask": null,
        "priority": null,
        "regionCodes": [],
        "minLocalPhonePartLength": null,
        "maxLocalPhonePartLength": null
    },
    "ml": {
        "name": "Mali",
        "iso2": "ml",
        "dialCode": "223",
        "mask": null,
        "priority": null,
        "regionCodes": [],
        "minLocalPhonePartLength": null,
        "maxLocalPhonePartLength": null
    },
    "mt": {
        "name": "Malta",
        "iso2": "mt",
        "dialCode": "356",
        "mask": null,
        "priority": null,
        "regionCodes": [],
        "minLocalPhonePartLength": null,
        "maxLocalPhonePartLength": null
    },
    "mh": {
        "name": "Marshall Islands",
        "iso2": "mh",
        "dialCode": "692",
        "mask": null,
        "priority": null,
        "regionCodes": [],
        "minLocalPhonePartLength": null,
        "maxLocalPhonePartLength": null
    },
    "mq": {
        "name": "Martinique",
        "iso2": "mq",
        "dialCode": "596",
        "mask": null,
        "priority": null,
        "regionCodes": [],
        "minLocalPhonePartLength": null,
        "maxLocalPhonePartLength": null
    },
    "mr": {
        "name": "Mauritania",
        "iso2": "mr",
        "dialCode": "222",
        "mask": null,
        "priority": null,
        "regionCodes": [],
        "minLocalPhonePartLength": null,
        "maxLocalPhonePartLength": null
    },
    "mu": {
        "name": "Mauritius",
        "iso2": "mu",
        "dialCode": "230",
        "mask": null,
        "priority": null,
        "regionCodes": [],
        "minLocalPhonePartLength": null,
        "maxLocalPhonePartLength": null
    },
    "mx": {
        "name": "Mexico",
        "iso2": "mx",
        "dialCode": "52",
        "mask": "... ... ....",
        "priority": 0,
        "regionCodes": [
            "55",
            "81",
            "33",
            "656",
            "664",
            "998",
            "774",
            "229"
        ],
        "minLocalPhonePartLength": null,
        "maxLocalPhonePartLength": null
    },
    "fm": {
        "name": "Micronesia",
        "iso2": "fm",
        "dialCode": "691",
        "mask": null,
        "priority": null,
        "regionCodes": [],
        "minLocalPhonePartLength": null,
        "maxLocalPhonePartLength": null
    },
    "md": {
        "name": "Moldova",
        "iso2": "md",
        "dialCode": "373",
        "mask": "(..) ..-..-..",
        "priority": null,
        "regionCodes": [],
        "minLocalPhonePartLength": null,
        "maxLocalPhonePartLength": null
    },
    "mc": {
        "name": "Monaco",
        "iso2": "mc",
        "dialCode": "377",
        "mask": null,
        "priority": null,
        "regionCodes": [],
        "minLocalPhonePartLength": null,
        "maxLocalPhonePartLength": null
    },
    "mn": {
        "name": "Mongolia",
        "iso2": "mn",
        "dialCode": "976",
        "mask": null,
        "priority": null,
        "regionCodes": [],
        "minLocalPhonePartLength": null,
        "maxLocalPhonePartLength": null
    },
    "me": {
        "name": "Montenegro",
        "iso2": "me",
        "dialCode": "382",
        "mask": null,
        "priority": null,
        "regionCodes": [],
        "minLocalPhonePartLength": null,
        "maxLocalPhonePartLength": null
    },
    "ma": {
        "name": "Morocco",
        "iso2": "ma",
        "dialCode": "212",
        "mask": null,
        "priority": null,
        "regionCodes": [],
        "minLocalPhonePartLength": null,
        "maxLocalPhonePartLength": null
    },
    "mz": {
        "name": "Mozambique",
        "iso2": "mz",
        "dialCode": "258",
        "mask": null,
        "priority": null,
        "regionCodes": [],
        "minLocalPhonePartLength": null,
        "maxLocalPhonePartLength": null
    },
    "mm": {
        "name": "Myanmar",
        "iso2": "mm",
        "dialCode": "95",
        "mask": null,
        "priority": null,
        "regionCodes": [],
        "minLocalPhonePartLength": null,
        "maxLocalPhonePartLength": null
    },
    "na": {
        "name": "Namibia",
        "iso2": "na",
        "dialCode": "264",
        "mask": null,
        "priority": null,
        "regionCodes": [],
        "minLocalPhonePartLength": null,
        "maxLocalPhonePartLength": null
    },
    "nr": {
        "name": "Nauru",
        "iso2": "nr",
        "dialCode": "674",
        "mask": null,
        "priority": null,
        "regionCodes": [],
        "minLocalPhonePartLength": null,
        "maxLocalPhonePartLength": null
    },
    "np": {
        "name": "Nepal",
        "iso2": "np",
        "dialCode": "977",
        "mask": null,
        "priority": null,
        "regionCodes": [],
        "minLocalPhonePartLength": null,
        "maxLocalPhonePartLength": null
    },
    "nl": {
        "name": "Netherlands",
        "iso2": "nl",
        "dialCode": "31",
        "mask": ".. ........",
        "priority": null,
        "regionCodes": [],
        "minLocalPhonePartLength": null,
        "maxLocalPhonePartLength": null
    },
    "nc": {
        "name": "New Caledonia",
        "iso2": "nc",
        "dialCode": "687",
        "mask": null,
        "priority": null,
        "regionCodes": [],
        "minLocalPhonePartLength": null,
        "maxLocalPhonePartLength": null
    },
    "nz": {
        "name": "New Zealand",
        "iso2": "nz",
        "dialCode": "64",
        "mask": "...-...-....",
        "priority": null,
        "regionCodes": [],
        "minLocalPhonePartLength": null,
        "maxLocalPhonePartLength": null
    },
    "ni": {
        "name": "Nicaragua",
        "iso2": "ni",
        "dialCode": "505",
        "mask": null,
        "priority": null,
        "regionCodes": [],
        "minLocalPhonePartLength": null,
        "maxLocalPhonePartLength": null
    },
    "ne": {
        "name": "Niger",
        "iso2": "ne",
        "dialCode": "227",
        "mask": null,
        "priority": null,
        "regionCodes": [],
        "minLocalPhonePartLength": null,
        "maxLocalPhonePartLength": null
    },
    "ng": {
        "name": "Nigeria",
        "iso2": "ng",
        "dialCode": "234",
        "mask": null,
        "priority": null,
        "regionCodes": [],
        "minLocalPhonePartLength": null,
        "maxLocalPhonePartLength": null
    },
    "kp": {
        "name": "North Korea",
        "iso2": "kp",
        "dialCode": "850",
        "mask": null,
        "priority": null,
        "regionCodes": [],
        "minLocalPhonePartLength": null,
        "maxLocalPhonePartLength": null
    },
    "no": {
        "name": "Norway",
        "iso2": "no",
        "dialCode": "47",
        "mask": "... .. ...",
        "priority": null,
        "regionCodes": [],
        "minLocalPhonePartLength": null,
        "maxLocalPhonePartLength": null
    },
    "om": {
        "name": "Oman",
        "iso2": "om",
        "dialCode": "968",
        "mask": null,
        "priority": null,
        "regionCodes": [],
        "minLocalPhonePartLength": null,
        "maxLocalPhonePartLength": null
    },
    "pk": {
        "name": "Pakistan",
        "iso2": "pk",
        "dialCode": "92",
        "mask": "...-.......",
        "priority": null,
        "regionCodes": [],
        "minLocalPhonePartLength": null,
        "maxLocalPhonePartLength": null
    },
    "pw": {
        "name": "Palau",
        "iso2": "pw",
        "dialCode": "680",
        "mask": null,
        "priority": null,
        "regionCodes": [],
        "minLocalPhonePartLength": null,
        "maxLocalPhonePartLength": null
    },
    "ps": {
        "name": "Palestine",
        "iso2": "ps",
        "dialCode": "970",
        "mask": null,
        "priority": null,
        "regionCodes": [],
        "minLocalPhonePartLength": null,
        "maxLocalPhonePartLength": null
    },
    "pa": {
        "name": "Panama",
        "iso2": "pa",
        "dialCode": "507",
        "mask": null,
        "priority": null,
        "regionCodes": [],
        "minLocalPhonePartLength": null,
        "maxLocalPhonePartLength": null
    },
    "pg": {
        "name": "Papua New Guinea",
        "iso2": "pg",
        "dialCode": "675",
        "mask": null,
        "priority": null,
        "regionCodes": [],
        "minLocalPhonePartLength": null,
        "maxLocalPhonePartLength": null
    },
    "py": {
        "name": "Paraguay",
        "iso2": "py",
        "dialCode": "595",
        "mask": null,
        "priority": null,
        "regionCodes": [],
        "minLocalPhonePartLength": null,
        "maxLocalPhonePartLength": null
    },
    "pe": {
        "name": "Peru",
        "iso2": "pe",
        "dialCode": "51",
        "mask": null,
        "priority": null,
        "regionCodes": [],
        "minLocalPhonePartLength": null,
        "maxLocalPhonePartLength": null
    },
    "ph": {
        "name": "Philippines",
        "iso2": "ph",
        "dialCode": "63",
        "mask": ".... .......",
        "priority": null,
        "regionCodes": [],
        "minLocalPhonePartLength": null,
        "maxLocalPhonePartLength": null
    },
    "pl": {
        "name": "Poland",
        "iso2": "pl",
        "dialCode": "48",
        "mask": "...-...-...",
        "priority": null,
        "regionCodes": [],
        "minLocalPhonePartLength": null,
        "maxLocalPhonePartLength": null
    },
    "pt": {
        "name": "Portugal",
        "iso2": "pt",
        "dialCode": "351",
        "mask": null,
        "priority": null,
        "regionCodes": [],
        "minLocalPhonePartLength": null,
        "maxLocalPhonePartLength": null
    },
    "pr": {
        "name": "Puerto Rico",
        "iso2": "pr",
        "dialCode": "1",
        "mask": "",
        "priority": 3,
        "regionCodes": [
            "787",
            "939"
        ],
        "minLocalPhonePartLength": null,
        "maxLocalPhonePartLength": null
    },
    "qa": {
        "name": "Qatar",
        "iso2": "qa",
        "dialCode": "974",
        "mask": null,
        "priority": null,
        "regionCodes": [],
        "minLocalPhonePartLength": null,
        "maxLocalPhonePartLength": null
    },
    "re": {
        "name": "R\xe9union",
        "iso2": "re",
        "dialCode": "262",
        "mask": null,
        "priority": null,
        "regionCodes": [],
        "minLocalPhonePartLength": null,
        "maxLocalPhonePartLength": null
    },
    "ro": {
        "name": "Romania",
        "iso2": "ro",
        "dialCode": "40",
        "mask": null,
        "priority": null,
        "regionCodes": [],
        "minLocalPhonePartLength": null,
        "maxLocalPhonePartLength": null
    },
    "ru": {
        "name": "Russia",
        "iso2": "ru",
        "dialCode": "7",
        "mask": "(...) ...-..-..",
        "priority": 0,
        "regionCodes": [],
        "minLocalPhonePartLength": null,
        "maxLocalPhonePartLength": null
    },
    "rw": {
        "name": "Rwanda",
        "iso2": "rw",
        "dialCode": "250",
        "mask": null,
        "priority": null,
        "regionCodes": [],
        "minLocalPhonePartLength": null,
        "maxLocalPhonePartLength": null
    },
    "kn": {
        "name": "Saint Kitts and Nevis",
        "iso2": "kn",
        "dialCode": "1869",
        "mask": null,
        "priority": null,
        "regionCodes": [],
        "minLocalPhonePartLength": null,
        "maxLocalPhonePartLength": null
    },
    "lc": {
        "name": "Saint Lucia",
        "iso2": "lc",
        "dialCode": "1758",
        "mask": null,
        "priority": null,
        "regionCodes": [],
        "minLocalPhonePartLength": null,
        "maxLocalPhonePartLength": null
    },
    "vc": {
        "name": "Saint Vincent and the Grenadines",
        "iso2": "vc",
        "dialCode": "1784",
        "mask": null,
        "priority": null,
        "regionCodes": [],
        "minLocalPhonePartLength": null,
        "maxLocalPhonePartLength": null
    },
    "ws": {
        "name": "Samoa",
        "iso2": "ws",
        "dialCode": "685",
        "mask": null,
        "priority": null,
        "regionCodes": [],
        "minLocalPhonePartLength": null,
        "maxLocalPhonePartLength": null
    },
    "sm": {
        "name": "San Marino",
        "iso2": "sm",
        "dialCode": "378",
        "mask": null,
        "priority": null,
        "regionCodes": [],
        "minLocalPhonePartLength": null,
        "maxLocalPhonePartLength": null
    },
    "st": {
        "name": "S\xe3o Tom\xe9 and Pr\xedncipe",
        "iso2": "st",
        "dialCode": "239",
        "mask": null,
        "priority": null,
        "regionCodes": [],
        "minLocalPhonePartLength": null,
        "maxLocalPhonePartLength": null
    },
    "sa": {
        "name": "Saudi Arabia",
        "iso2": "sa",
        "dialCode": "966",
        "mask": "...........",
        "priority": null,
        "regionCodes": [],
        "minLocalPhonePartLength": null,
        "maxLocalPhonePartLength": null
    },
    "sn": {
        "name": "Senegal",
        "iso2": "sn",
        "dialCode": "221",
        "mask": null,
        "priority": null,
        "regionCodes": [],
        "minLocalPhonePartLength": null,
        "maxLocalPhonePartLength": null
    },
    "rs": {
        "name": "Serbia",
        "iso2": "rs",
        "dialCode": "381",
        "mask": null,
        "priority": null,
        "regionCodes": [],
        "minLocalPhonePartLength": null,
        "maxLocalPhonePartLength": null
    },
    "sc": {
        "name": "Seychelles",
        "iso2": "sc",
        "dialCode": "248",
        "mask": null,
        "priority": null,
        "regionCodes": [],
        "minLocalPhonePartLength": null,
        "maxLocalPhonePartLength": null
    },
    "sl": {
        "name": "Sierra Leone",
        "iso2": "sl",
        "dialCode": "232",
        "mask": null,
        "priority": null,
        "regionCodes": [],
        "minLocalPhonePartLength": null,
        "maxLocalPhonePartLength": null
    },
    "sg": {
        "name": "Singapore",
        "iso2": "sg",
        "dialCode": "65",
        "mask": "....-....",
        "priority": null,
        "regionCodes": [],
        "minLocalPhonePartLength": null,
        "maxLocalPhonePartLength": null
    },
    "sk": {
        "name": "Slovakia",
        "iso2": "sk",
        "dialCode": "421",
        "mask": null,
        "priority": null,
        "regionCodes": [],
        "minLocalPhonePartLength": null,
        "maxLocalPhonePartLength": null
    },
    "si": {
        "name": "Slovenia",
        "iso2": "si",
        "dialCode": "386",
        "mask": null,
        "priority": null,
        "regionCodes": [],
        "minLocalPhonePartLength": null,
        "maxLocalPhonePartLength": null
    },
    "sb": {
        "name": "Solomon Islands",
        "iso2": "sb",
        "dialCode": "677",
        "mask": null,
        "priority": null,
        "regionCodes": [],
        "minLocalPhonePartLength": null,
        "maxLocalPhonePartLength": null
    },
    "so": {
        "name": "Somalia",
        "iso2": "so",
        "dialCode": "252",
        "mask": null,
        "priority": null,
        "regionCodes": [],
        "minLocalPhonePartLength": null,
        "maxLocalPhonePartLength": null
    },
    "za": {
        "name": "South Africa",
        "iso2": "za",
        "dialCode": "27",
        "mask": null,
        "priority": null,
        "regionCodes": [],
        "minLocalPhonePartLength": null,
        "maxLocalPhonePartLength": null
    },
    "kr": {
        "name": "South Korea",
        "iso2": "kr",
        "dialCode": "82",
        "mask": "... .... ....",
        "priority": null,
        "regionCodes": [],
        "minLocalPhonePartLength": null,
        "maxLocalPhonePartLength": null
    },
    "ss": {
        "name": "South Sudan",
        "iso2": "ss",
        "dialCode": "211",
        "mask": null,
        "priority": null,
        "regionCodes": [],
        "minLocalPhonePartLength": null,
        "maxLocalPhonePartLength": null
    },
    "es": {
        "name": "Spain",
        "iso2": "es",
        "dialCode": "34",
        "mask": "... ... ...",
        "priority": null,
        "regionCodes": [],
        "minLocalPhonePartLength": null,
        "maxLocalPhonePartLength": null
    },
    "lk": {
        "name": "Sri Lanka",
        "iso2": "lk",
        "dialCode": "94",
        "mask": null,
        "priority": null,
        "regionCodes": [],
        "minLocalPhonePartLength": null,
        "maxLocalPhonePartLength": null
    },
    "sd": {
        "name": "Sudan",
        "iso2": "sd",
        "dialCode": "249",
        "mask": null,
        "priority": null,
        "regionCodes": [],
        "minLocalPhonePartLength": null,
        "maxLocalPhonePartLength": null
    },
    "sr": {
        "name": "Suriname",
        "iso2": "sr",
        "dialCode": "597",
        "mask": null,
        "priority": null,
        "regionCodes": [],
        "minLocalPhonePartLength": null,
        "maxLocalPhonePartLength": null
    },
    "sz": {
        "name": "Swaziland",
        "iso2": "sz",
        "dialCode": "268",
        "mask": null,
        "priority": null,
        "regionCodes": [],
        "minLocalPhonePartLength": null,
        "maxLocalPhonePartLength": null
    },
    "se": {
        "name": "Sweden",
        "iso2": "se",
        "dialCode": "46",
        "mask": "(...) ...-...",
        "priority": null,
        "regionCodes": [],
        "minLocalPhonePartLength": null,
        "maxLocalPhonePartLength": null
    },
    "ch": {
        "name": "Switzerland",
        "iso2": "ch",
        "dialCode": "41",
        "mask": ".. ... .. ..",
        "priority": null,
        "regionCodes": [],
        "minLocalPhonePartLength": null,
        "maxLocalPhonePartLength": null
    },
    "sy": {
        "name": "Syria",
        "iso2": "sy",
        "dialCode": "963",
        "mask": null,
        "priority": null,
        "regionCodes": [],
        "minLocalPhonePartLength": null,
        "maxLocalPhonePartLength": null
    },
    "tw": {
        "name": "Taiwan",
        "iso2": "tw",
        "dialCode": "886",
        "mask": null,
        "priority": null,
        "regionCodes": [],
        "minLocalPhonePartLength": null,
        "maxLocalPhonePartLength": null
    },
    "tj": {
        "name": "Tajikistan",
        "iso2": "tj",
        "dialCode": "992",
        "mask": null,
        "priority": null,
        "regionCodes": [],
        "minLocalPhonePartLength": null,
        "maxLocalPhonePartLength": null
    },
    "tz": {
        "name": "Tanzania",
        "iso2": "tz",
        "dialCode": "255",
        "mask": null,
        "priority": null,
        "regionCodes": [],
        "minLocalPhonePartLength": null,
        "maxLocalPhonePartLength": null
    },
    "th": {
        "name": "Thailand",
        "iso2": "th",
        "dialCode": "66",
        "mask": null,
        "priority": null,
        "regionCodes": [],
        "minLocalPhonePartLength": null,
        "maxLocalPhonePartLength": null
    },
    "tl": {
        "name": "Timor-Leste",
        "iso2": "tl",
        "dialCode": "670",
        "mask": null,
        "priority": null,
        "regionCodes": [],
        "minLocalPhonePartLength": null,
        "maxLocalPhonePartLength": null
    },
    "tg": {
        "name": "Togo",
        "iso2": "tg",
        "dialCode": "228",
        "mask": null,
        "priority": null,
        "regionCodes": [],
        "minLocalPhonePartLength": null,
        "maxLocalPhonePartLength": null
    },
    "to": {
        "name": "Tonga",
        "iso2": "to",
        "dialCode": "676",
        "mask": null,
        "priority": null,
        "regionCodes": [],
        "minLocalPhonePartLength": null,
        "maxLocalPhonePartLength": null
    },
    "tt": {
        "name": "Trinidad and Tobago",
        "iso2": "tt",
        "dialCode": "1868",
        "mask": null,
        "priority": null,
        "regionCodes": [],
        "minLocalPhonePartLength": null,
        "maxLocalPhonePartLength": null
    },
    "tn": {
        "name": "Tunisia",
        "iso2": "tn",
        "dialCode": "216",
        "mask": null,
        "priority": null,
        "regionCodes": [],
        "minLocalPhonePartLength": null,
        "maxLocalPhonePartLength": null
    },
    "tr": {
        "name": "Turkey",
        "iso2": "tr",
        "dialCode": "90",
        "mask": "... ... .. ..",
        "priority": null,
        "regionCodes": [],
        "minLocalPhonePartLength": null,
        "maxLocalPhonePartLength": null
    },
    "tm": {
        "name": "Turkmenistan",
        "iso2": "tm",
        "dialCode": "993",
        "mask": null,
        "priority": null,
        "regionCodes": [],
        "minLocalPhonePartLength": null,
        "maxLocalPhonePartLength": null
    },
    "tv": {
        "name": "Tuvalu",
        "iso2": "tv",
        "dialCode": "688",
        "mask": null,
        "priority": null,
        "regionCodes": [],
        "minLocalPhonePartLength": null,
        "maxLocalPhonePartLength": null
    },
    "ug": {
        "name": "Uganda",
        "iso2": "ug",
        "dialCode": "256",
        "mask": null,
        "priority": null,
        "regionCodes": [],
        "minLocalPhonePartLength": null,
        "maxLocalPhonePartLength": null
    },
    "ua": {
        "name": "Ukraine",
        "iso2": "ua",
        "dialCode": "380",
        "mask": "(..) ... .. ..",
        "priority": null,
        "regionCodes": [],
        "minLocalPhonePartLength": null,
        "maxLocalPhonePartLength": null
    },
    "ae": {
        "name": "United Arab Emirates",
        "iso2": "ae",
        "dialCode": "971",
        "mask": "(.) ...-....",
        "priority": 1,
        "regionCodes": [
            "1",
            "2",
            "3",
            "4",
            "6",
            "7",
            "9",
            "50",
            "52",
            "54",
            "55",
            "56",
            "58"
        ],
        "minLocalPhonePartLength": 7,
        "maxLocalPhonePartLength": 7
    },
    "gb": {
        "name": "United Kingdom",
        "iso2": "gb",
        "dialCode": "44",
        "mask": ".... ......",
        "priority": null,
        "regionCodes": [],
        "minLocalPhonePartLength": null,
        "maxLocalPhonePartLength": null
    },
    "us": {
        "name": "United States",
        "iso2": "us",
        "dialCode": "1",
        "mask": "(...) ...-....",
        "priority": 0,
        "regionCodes": [
            "907",
            "205",
            "251",
            "256",
            "334",
            "479",
            "501",
            "870",
            "480",
            "520",
            "602",
            "623",
            "928",
            "209",
            "213",
            "310",
            "323",
            "408",
            "415",
            "510",
            "530",
            "559",
            "562",
            "619",
            "626",
            "650",
            "661",
            "707",
            "714",
            "760",
            "805",
            "818",
            "831",
            "858",
            "909",
            "916",
            "925",
            "949",
            "951",
            "303",
            "719",
            "970",
            "203",
            "860",
            "202",
            "302",
            "239",
            "305",
            "321",
            "352",
            "386",
            "407",
            "561",
            "727",
            "772",
            "813",
            "850",
            "863",
            "904",
            "941",
            "954",
            "229",
            "404",
            "478",
            "706",
            "770",
            "912",
            "808",
            "319",
            "515",
            "563",
            "641",
            "712",
            "208",
            "217",
            "309",
            "312",
            "618",
            "630",
            "708",
            "773",
            "815",
            "847",
            "219",
            "260",
            "317",
            "574",
            "765",
            "812",
            "316",
            "620",
            "785",
            "913",
            "270",
            "502",
            "606",
            "859",
            "225",
            "318",
            "337",
            "504",
            "985",
            "413",
            "508",
            "617",
            "781",
            "978",
            "301",
            "410",
            "207",
            "231",
            "248",
            "269",
            "313",
            "517",
            "586",
            "616",
            "734",
            "810",
            "906",
            "989",
            "218",
            "320",
            "507",
            "612",
            "651",
            "763",
            "952",
            "314",
            "417",
            "573",
            "636",
            "660",
            "816",
            "228",
            "601",
            "662",
            "406",
            "252",
            "336",
            "704",
            "828",
            "910",
            "919",
            "701",
            "308",
            "402",
            "603",
            "201",
            "609",
            "732",
            "856",
            "908",
            "973",
            "505",
            "575",
            "702",
            "775",
            "212",
            "315",
            "516",
            "518",
            "585",
            "607",
            "631",
            "716",
            "718",
            "845",
            "914",
            "216",
            "330",
            "419",
            "440",
            "513",
            "614",
            "740",
            "937",
            "405",
            "580",
            "918",
            "503",
            "541",
            "215",
            "412",
            "570",
            "610",
            "717",
            "724",
            "814",
            "401",
            "803",
            "843",
            "864",
            "605",
            "423",
            "615",
            "731",
            "865",
            "901",
            "931",
            "210",
            "214",
            "254",
            "281",
            "325",
            "361",
            "409",
            "432",
            "512",
            "713",
            "806",
            "817",
            "830",
            "903",
            "915",
            "936",
            "940",
            "956",
            "972",
            "979",
            "435",
            "801",
            "276",
            "434",
            "540",
            "703",
            "757",
            "804",
            "802",
            "206",
            "253",
            "360",
            "425",
            "509",
            "262",
            "414",
            "608",
            "715",
            "920",
            "304",
            "307"
        ],
        "minLocalPhonePartLength": null,
        "maxLocalPhonePartLength": null
    },
    "uy": {
        "name": "Uruguay",
        "iso2": "uy",
        "dialCode": "598",
        "mask": null,
        "priority": null,
        "regionCodes": [],
        "minLocalPhonePartLength": null,
        "maxLocalPhonePartLength": null
    },
    "uz": {
        "name": "Uzbekistan",
        "iso2": "uz",
        "dialCode": "998",
        "mask": ".. ... .. ..",
        "priority": null,
        "regionCodes": [],
        "minLocalPhonePartLength": null,
        "maxLocalPhonePartLength": null
    },
    "vu": {
        "name": "Vanuatu",
        "iso2": "vu",
        "dialCode": "678",
        "mask": null,
        "priority": null,
        "regionCodes": [],
        "minLocalPhonePartLength": null,
        "maxLocalPhonePartLength": null
    },
    "va": {
        "name": "Vatican City",
        "iso2": "va",
        "dialCode": "39",
        "mask": ".. .... ....",
        "priority": 1,
        "regionCodes": [],
        "minLocalPhonePartLength": null,
        "maxLocalPhonePartLength": null
    },
    "ve": {
        "name": "Venezuela",
        "iso2": "ve",
        "dialCode": "58",
        "mask": null,
        "priority": null,
        "regionCodes": [],
        "minLocalPhonePartLength": null,
        "maxLocalPhonePartLength": null
    },
    "vn": {
        "name": "Vietnam",
        "iso2": "vn",
        "dialCode": "84",
        "mask": null,
        "priority": null,
        "regionCodes": [],
        "minLocalPhonePartLength": null,
        "maxLocalPhonePartLength": null
    },
    "ye": {
        "name": "Yemen",
        "iso2": "ye",
        "dialCode": "967",
        "mask": null,
        "priority": null,
        "regionCodes": [],
        "minLocalPhonePartLength": null,
        "maxLocalPhonePartLength": null
    },
    "zm": {
        "name": "Zambia",
        "iso2": "zm",
        "dialCode": "260",
        "mask": null,
        "priority": null,
        "regionCodes": [],
        "minLocalPhonePartLength": null,
        "maxLocalPhonePartLength": null
    },
    "zw": {
        "name": "Zimbabwe",
        "iso2": "zw",
        "dialCode": "263",
        "mask": null,
        "priority": null,
        "regionCodes": [],
        "minLocalPhonePartLength": null,
        "maxLocalPhonePartLength": null
    }
};



const $bddccaaa89e8fa20$var$getValidationRules = (phoneRequiredText, phoneInvalidText, country)=>{
    return $bcc252d93ab3046c$export$185802fd694ee1f5().required(phoneRequiredText).test("isValidPhone", phoneInvalidText, (value)=>{
        const regExpStart = country.regionCodes.length > 0 ? `^${country.dialCode}(${country.regionCodes.join("|")})` : `^${country.dialCode}`;
        const regExpEnd = Boolean(country.minLocalPhonePartLength) && Boolean(country.maxLocalPhonePartLength) ? `\\d{${country.minLocalPhonePartLength},${country.maxLocalPhonePartLength}}` : `\\d+`;
        const regExp = new RegExp(`${regExpStart}${regExpEnd}`);
        return regExp.test(value);
    });
};
var $bddccaaa89e8fa20$export$2e2bcd8739ae039 = $bddccaaa89e8fa20$var$getValidationRules;



function $bd957970431a3ba0$export$b6ed00066e3625b3() {
    const params = new URLSearchParams(window.location.search);
    const utmParams = {};
    // Extract UTMs from query params
    params.forEach((value, key)=>{
        if (key.startsWith("utm_")) utmParams[key] = value;
    });
    // If no UTMs found in URL, get them from localStorage
    if (Object.keys(utmParams).length === 0) {
        const storedUtmParams = String((0, $34dcbefa7de5eb80$export$11e63f7b0f3d9900)("utm_data"));
        if (storedUtmParams) return JSON.parse(storedUtmParams);
    } else // Store UTMs in localStorage if they were found in the query params
    (0, $34dcbefa7de5eb80$export$a1544dad697b423d)("utm_data", JSON.stringify(utmParams));
    return utmParams;
}


function $926d262689c0d7db$export$9c9fb46caed06943(UIComponent) {
    return (0, $aca50e9407ba89c9$export$b6ae1bc530f4c149)(({ redirectTo: redirectTo })=>{
        const [isConsentAccepted, setIsConsentAccepted] = (0, $acw62.useState)(false);
        const [selectedCountry, setSelectedCountry] = (0, $acw62.useState)(null);
        const firebaseToken = (0, $7af34371d75563b6$export$5a8e049606f4bc34)();
        const { register: register } = (0, $4671947198ddd366$export$6ccbb43953eebf8)().data;
        const [signUpResult, requestSignUp] = (0, $4671947198ddd366$export$609860bf8b0084c)(register, {
            filterError: [
                (0, $9ad33fbf770c55a1$export$9696fcf1798e1cb5).ClientError
            ],
            onSuccess: (account)=>{
                (0, $c74a0566d4b0fd6d$export$e9db7d6e73593439).identifyUser(Number(account.user_id));
                (0, $c74a0566d4b0fd6d$export$e9db7d6e73593439).assignUserProperties(account.id, account.roles, account.email);
                redirect(redirectTo ? (0, $0534349ae8731d0b$export$66b32f6f30eb4b4)[redirectTo] : (0, $0534349ae8731d0b$export$66b32f6f30eb4b4).index, {});
                (0, $60f27fc97e29822a$export$b410431fab84fa58).success((0, $2b1f0855f2f3a952$export$625550452a3fa3ec)("sign_up.thank_you"));
            }
        });
        const redirect = (0, $7df35e9df335b1c8$export$602eaf6d5314ce55)();
        const remoteErrors = signUpResult.error?.data.errors;
        const submitting = signUpResult.isLoading;
        return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7YFi7.Formik), {
            initialValues: {
                firstName: "",
                lastName: "",
                phone: "",
                email: "",
                password: "",
                companyName: "",
                allow_marketing_emails: false
            },
            validationSchema: $cd7706ce94a8dfd1$export$185802fd694ee1f5().shape({
                firstName: $bcc252d93ab3046c$export$185802fd694ee1f5().required((0, $2b1f0855f2f3a952$export$625550452a3fa3ec)("sign_up.first_name_required")),
                lastName: $bcc252d93ab3046c$export$185802fd694ee1f5().required((0, $2b1f0855f2f3a952$export$625550452a3fa3ec)("sign_up.last_name_required")),
                phone: (0, $bddccaaa89e8fa20$export$2e2bcd8739ae039)((0, $2b1f0855f2f3a952$export$625550452a3fa3ec)("sign_up.phone_required"), (0, $2b1f0855f2f3a952$export$625550452a3fa3ec)("sign_up.phone_invalid"), (0, $c5ed36b134b2d50e$export$847b1abaf17f2c47)[selectedCountry]),
                email: $bcc252d93ab3046c$export$185802fd694ee1f5().email((0, $2b1f0855f2f3a952$export$625550452a3fa3ec)("validation_messages.email_invalid")).required((0, $2b1f0855f2f3a952$export$625550452a3fa3ec)("sign_up.email_required")),
                isCorporate: $0237b22d97657ad7$export$185802fd694ee1f5(),
                companyName: (0, $73ccb33f5de6f5aa$export$8707029d024490c9)().registration.allowOnlyCorporate ? $bcc252d93ab3046c$export$185802fd694ee1f5().required((0, $2b1f0855f2f3a952$export$625550452a3fa3ec)("sign_up.company_name_required")) : $bcc252d93ab3046c$export$185802fd694ee1f5().when("isCorporate", {
                    is: true,
                    then: $bcc252d93ab3046c$export$185802fd694ee1f5().required((0, $2b1f0855f2f3a952$export$625550452a3fa3ec)("sign_up.company_name_required"))
                })
            }),
            enableReinitialize: true,
            onSubmit: (values)=>{
                const submitObject = {
                    first_name: values.firstName,
                    last_name: values.lastName,
                    phone: values.phone,
                    email: values.email,
                    password: values.password,
                    allow_marketing_emails: Number(values.allow_marketing_emails),
                    is_corporate: values.companyName.length > 0 ? 1 : 0,
                    device_id: (0, $32ef62acd40089c4$export$1da4558c59cbf0b1)(),
                    firebase_token: firebaseToken,
                    utm: (0, $bd957970431a3ba0$export$b6ed00066e3625b3)()
                };
                if (values.companyName.length > 0) submitObject.company_name = values.companyName;
                requestSignUp(submitObject);
            },
            validateOnChange: false,
            children: ({ values: values, setFieldValue: setFieldValue, handleSubmit: handleSubmit, errors: errors })=>{
                return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)(UIComponent, {
                    submitting: submitting,
                    firstName: values.firstName,
                    firstNameErrors: errors.firstName ?? remoteErrors?.first_name,
                    lastName: values.lastName,
                    lastNameErrors: errors.lastName ?? remoteErrors?.last_name,
                    email: values.email,
                    emailErrors: errors.email ?? remoteErrors?.email,
                    phone: values.phone,
                    phoneErrors: errors.phone ?? remoteErrors?.phone,
                    password: values.password,
                    passwordErrors: errors.password ?? remoteErrors?.password,
                    companyName: values.companyName,
                    companyNameErrors: errors.companyName ?? remoteErrors?.company_name,
                    allow_marketing_emails: values.allow_marketing_emails,
                    allow_marketing_emailsErrors: errors.allow_marketing_emails ?? remoteErrors?.allow_marketing_emails,
                    handleFirstNameChange: (firstName)=>{
                        setFieldValue("firstName", firstName);
                    },
                    handleLastNameChange: (lastName)=>{
                        setFieldValue("lastName", lastName);
                    },
                    handleEmailNameChange: (email)=>{
                        setFieldValue("email", email);
                    },
                    handlePhoneNameChange: (phone)=>{
                        setFieldValue("phone", phone);
                    },
                    handlePasswordChange: (password)=>{
                        setFieldValue("password", password);
                    },
                    handleCityChange: (city)=>{
                        setFieldValue("city", city);
                    },
                    handleCompanyNameChange: (companyName)=>{
                        setFieldValue("companyName", companyName);
                    },
                    handleAllowEmailsToggle: ()=>{
                        setFieldValue("allow_marketing_emails", !values.allow_marketing_emails);
                    },
                    handleSubmitButtonPress: ()=>{
                        handleSubmit();
                        (0, $c74a0566d4b0fd6d$export$e9db7d6e73593439).conversion((0, $c74a0566d4b0fd6d$export$4690203fd259f070).SignUpClicked);
                    },
                    handleLoginButtonPress: ()=>{
                        redirect((0, $0534349ae8731d0b$export$66b32f6f30eb4b4).login, {});
                    },
                    isConsentAccepted: isConsentAccepted,
                    setIsConsentAccepted: setIsConsentAccepted,
                    setSelectedCountry: setSelectedCountry
                });
            }
        });
    });
}




var $acw62 = parcelRequire("acw62");











var $fd0172319154660f$exports = {};

$fd0172319154660f$exports = function(e) {
    var t = {};
    function r(n) {
        if (t[n]) return t[n].exports;
        var a = t[n] = {
            i: n,
            l: !1,
            exports: {}
        };
        return e[n].call(a.exports, a, a.exports, r), a.l = !0, a.exports;
    }
    return r.m = e, r.c = t, r.d = function(e, t, n) {
        r.o(e, t) || Object.defineProperty(e, t, {
            enumerable: !0,
            get: n
        });
    }, r.r = function(e) {
        "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(e, Symbol.toStringTag, {
            value: "Module"
        }), Object.defineProperty(e, "__esModule", {
            value: !0
        });
    }, r.t = function(e, t) {
        if (1 & t && (e = r(e)), 8 & t) return e;
        if (4 & t && "object" == typeof e && e && e.__esModule) return e;
        var n = Object.create(null);
        if (r.r(n), Object.defineProperty(n, "default", {
            enumerable: !0,
            value: e
        }), 2 & t && "string" != typeof e) for(var a in e)r.d(n, a, (function(t) {
            return e[t];
        }).bind(null, a));
        return n;
    }, r.n = function(e) {
        var t = e && e.__esModule ? function() {
            return e.default;
        } : function() {
            return e;
        };
        return r.d(t, "a", t), t;
    }, r.o = function(e, t) {
        return Object.prototype.hasOwnProperty.call(e, t);
    }, r.p = "", r(r.s = 9);
}([
    function(e, t) {
        e.exports = (parcelRequire("acw62"));
    },
    function(e, t, r) {
        var n;
        /*!
  Copyright (c) 2018 Jed Watson.
  Licensed under the MIT License (MIT), see
  http://jedwatson.github.io/classnames
*/ !function() {
            "use strict";
            var r = {}.hasOwnProperty;
            function a() {
                for(var e = [], t = 0; t < arguments.length; t++){
                    var n = arguments[t];
                    if (n) {
                        var o = typeof n;
                        if ("string" === o || "number" === o) e.push(n);
                        else if (Array.isArray(n)) {
                            if (n.length) {
                                var i = a.apply(null, n);
                                i && e.push(i);
                            }
                        } else if ("object" === o) {
                            if (n.toString === Object.prototype.toString) for(var u in n)r.call(n, u) && n[u] && e.push(u);
                            else e.push(n.toString());
                        }
                    }
                }
                return e.join(" ");
            }
            e.exports ? (a.default = a, e.exports = a) : void 0 === (n = (function() {
                return a;
            }).apply(t, [])) || (e.exports = n);
        }();
    },
    function(e, t, r) {
        (function(t) {
            var r = /^\s+|\s+$/g, n = /^[-+]0x[0-9a-f]+$/i, a = /^0b[01]+$/i, o = /^0o[0-7]+$/i, i = parseInt, u = "object" == typeof t && t && t.Object === Object && t, c = "object" == typeof self && self && self.Object === Object && self, s = u || c || Function("return this")(), l = Object.prototype.toString, f = s.Symbol, d = f ? f.prototype : void 0, p = d ? d.toString : void 0;
            function h(e) {
                if ("string" == typeof e) return e;
                if (y(e)) return p ? p.call(e) : "";
                var t = e + "";
                return "0" == t && 1 / e == -1 / 0 ? "-0" : t;
            }
            function m(e) {
                var t = typeof e;
                return !!e && ("object" == t || "function" == t);
            }
            function y(e) {
                return "symbol" == typeof e || function(e) {
                    return !!e && "object" == typeof e;
                }(e) && "[object Symbol]" == l.call(e);
            }
            function b(e) {
                return e ? (e = function(e) {
                    if ("number" == typeof e) return e;
                    if (y(e)) return NaN;
                    if (m(e)) {
                        var t = "function" == typeof e.valueOf ? e.valueOf() : e;
                        e = m(t) ? t + "" : t;
                    }
                    if ("string" != typeof e) return 0 === e ? e : +e;
                    e = e.replace(r, "");
                    var u = a.test(e);
                    return u || o.test(e) ? i(e.slice(2), u ? 2 : 8) : n.test(e) ? NaN : +e;
                }(e)) === 1 / 0 || e === -1 / 0 ? 17976931348623157e292 * (e < 0 ? -1 : 1) : e == e ? e : 0 : 0 === e ? e : 0;
            }
            e.exports = function(e, t, r) {
                var n, a, o, i;
                return e = null == (n = e) ? "" : h(n), a = function(e) {
                    var t = b(e), r = t % 1;
                    return t == t ? r ? t - r : t : 0;
                }(r), o = 0, i = e.length, a == a && (void 0 !== i && (a = a <= i ? a : i), void 0 !== o && (a = a >= o ? a : o)), r = a, t = h(t), e.slice(r, r + t.length) == t;
            };
        }).call(this, r(3));
    },
    function(e, t) {
        var r;
        r = function() {
            return this;
        }();
        try {
            r = r || new Function("return this")();
        } catch (e) {
            "object" == typeof window && (r = window);
        }
        e.exports = r;
    },
    function(e, t, r) {
        (function(t) {
            var r = /^\[object .+?Constructor\]$/, n = "object" == typeof t && t && t.Object === Object && t, a = "object" == typeof self && self && self.Object === Object && self, o = n || a || Function("return this")();
            var i, u = Array.prototype, c = Function.prototype, s = Object.prototype, l = o["__core-js_shared__"], f = (i = /[^.]+$/.exec(l && l.keys && l.keys.IE_PROTO || "")) ? "Symbol(src)_1." + i : "", d = c.toString, p = s.hasOwnProperty, h = s.toString, m = RegExp("^" + d.call(p).replace(/[\\^$.*+?()[\]{}|]/g, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"), y = u.splice, b = x(o, "Map"), g = x(Object, "create");
            function v(e) {
                var t = -1, r = e ? e.length : 0;
                for(this.clear(); ++t < r;){
                    var n = e[t];
                    this.set(n[0], n[1]);
                }
            }
            function C(e) {
                var t = -1, r = e ? e.length : 0;
                for(this.clear(); ++t < r;){
                    var n = e[t];
                    this.set(n[0], n[1]);
                }
            }
            function _(e) {
                var t = -1, r = e ? e.length : 0;
                for(this.clear(); ++t < r;){
                    var n = e[t];
                    this.set(n[0], n[1]);
                }
            }
            function w(e, t) {
                for(var r, n, a = e.length; a--;)if ((r = e[a][0]) === (n = t) || r != r && n != n) return a;
                return -1;
            }
            function S(e) {
                var t;
                return !(!O(e) || (t = e, f && f in t)) && ((function(e) {
                    var t = O(e) ? h.call(e) : "";
                    return "[object Function]" == t || "[object GeneratorFunction]" == t;
                })(e) || function(e) {
                    var t = !1;
                    if (null != e && "function" != typeof e.toString) try {
                        t = !!(e + "");
                    } catch (e) {}
                    return t;
                }(e) ? m : r).test(function(e) {
                    if (null != e) {
                        try {
                            return d.call(e);
                        } catch (e) {}
                        try {
                            return e + "";
                        } catch (e) {}
                    }
                    return "";
                }(e));
            }
            function j(e, t) {
                var r, n, a = e.__data__;
                return ("string" == (n = typeof (r = t)) || "number" == n || "symbol" == n || "boolean" == n ? "__proto__" !== r : null === r) ? a["string" == typeof t ? "string" : "hash"] : a.map;
            }
            function x(e, t) {
                var r = function(e, t) {
                    return null == e ? void 0 : e[t];
                }(e, t);
                return S(r) ? r : void 0;
            }
            function N(e, t) {
                if ("function" != typeof e || t && "function" != typeof t) throw new TypeError("Expected a function");
                var r = function() {
                    var n = arguments, a = t ? t.apply(this, n) : n[0], o = r.cache;
                    if (o.has(a)) return o.get(a);
                    var i = e.apply(this, n);
                    return r.cache = o.set(a, i), i;
                };
                return r.cache = new (N.Cache || _), r;
            }
            function O(e) {
                var t = typeof e;
                return !!e && ("object" == t || "function" == t);
            }
            v.prototype.clear = function() {
                this.__data__ = g ? g(null) : {};
            }, v.prototype.delete = function(e) {
                return this.has(e) && delete this.__data__[e];
            }, v.prototype.get = function(e) {
                var t = this.__data__;
                if (g) {
                    var r = t[e];
                    return "__lodash_hash_undefined__" === r ? void 0 : r;
                }
                return p.call(t, e) ? t[e] : void 0;
            }, v.prototype.has = function(e) {
                var t = this.__data__;
                return g ? void 0 !== t[e] : p.call(t, e);
            }, v.prototype.set = function(e, t) {
                return this.__data__[e] = g && void 0 === t ? "__lodash_hash_undefined__" : t, this;
            }, C.prototype.clear = function() {
                this.__data__ = [];
            }, C.prototype.delete = function(e) {
                var t = this.__data__, r = w(t, e);
                return !(r < 0) && (r == t.length - 1 ? t.pop() : y.call(t, r, 1), !0);
            }, C.prototype.get = function(e) {
                var t = this.__data__, r = w(t, e);
                return r < 0 ? void 0 : t[r][1];
            }, C.prototype.has = function(e) {
                return w(this.__data__, e) > -1;
            }, C.prototype.set = function(e, t) {
                var r = this.__data__, n = w(r, e);
                return n < 0 ? r.push([
                    e,
                    t
                ]) : r[n][1] = t, this;
            }, _.prototype.clear = function() {
                this.__data__ = {
                    hash: new v,
                    map: new (b || C),
                    string: new v
                };
            }, _.prototype.delete = function(e) {
                return j(this, e).delete(e);
            }, _.prototype.get = function(e) {
                return j(this, e).get(e);
            }, _.prototype.has = function(e) {
                return j(this, e).has(e);
            }, _.prototype.set = function(e, t) {
                return j(this, e).set(e, t), this;
            }, N.Cache = _, e.exports = N;
        }).call(this, r(3));
    },
    function(e, t, r) {
        (function(t) {
            var r = /^\s+|\s+$/g, n = /^[-+]0x[0-9a-f]+$/i, a = /^0b[01]+$/i, o = /^0o[0-7]+$/i, i = parseInt, u = "object" == typeof t && t && t.Object === Object && t, c = "object" == typeof self && self && self.Object === Object && self, s = u || c || Function("return this")(), l = Object.prototype.toString, f = Math.max, d = Math.min, p = function() {
                return s.Date.now();
            };
            function h(e) {
                var t = typeof e;
                return !!e && ("object" == t || "function" == t);
            }
            function m(e) {
                if ("number" == typeof e) return e;
                if (function(e) {
                    return "symbol" == typeof e || function(e) {
                        return !!e && "object" == typeof e;
                    }(e) && "[object Symbol]" == l.call(e);
                }(e)) return NaN;
                if (h(e)) {
                    var t = "function" == typeof e.valueOf ? e.valueOf() : e;
                    e = h(t) ? t + "" : t;
                }
                if ("string" != typeof e) return 0 === e ? e : +e;
                e = e.replace(r, "");
                var u = a.test(e);
                return u || o.test(e) ? i(e.slice(2), u ? 2 : 8) : n.test(e) ? NaN : +e;
            }
            e.exports = function(e, t, r) {
                var n, a, o, i, u, c, s = 0, l = !1, y = !1, b = !0;
                if ("function" != typeof e) throw new TypeError("Expected a function");
                function g(t) {
                    var r = n, o = a;
                    return n = a = void 0, s = t, i = e.apply(o, r);
                }
                function v(e) {
                    return s = e, u = setTimeout(_, t), l ? g(e) : i;
                }
                function C(e) {
                    var r = e - c;
                    return void 0 === c || r >= t || r < 0 || y && e - s >= o;
                }
                function _() {
                    var e = p();
                    if (C(e)) return w(e);
                    u = setTimeout(_, function(e) {
                        var r = t - (e - c);
                        return y ? d(r, o - (e - s)) : r;
                    }(e));
                }
                function w(e) {
                    return u = void 0, b && n ? g(e) : (n = a = void 0, i);
                }
                function S() {
                    var e = p(), r = C(e);
                    if (n = arguments, a = this, c = e, r) {
                        if (void 0 === u) return v(c);
                        if (y) return u = setTimeout(_, t), g(c);
                    }
                    return void 0 === u && (u = setTimeout(_, t)), i;
                }
                return t = m(t) || 0, h(r) && (l = !!r.leading, o = (y = "maxWait" in r) ? f(m(r.maxWait) || 0, t) : o, b = "trailing" in r ? !!r.trailing : b), S.cancel = function() {
                    void 0 !== u && clearTimeout(u), s = 0, n = c = a = u = void 0;
                }, S.flush = function() {
                    return void 0 === u ? i : w(p());
                }, S;
            };
        }).call(this, r(3));
    },
    function(e, t, r) {
        (function(e, r) {
            var n = "[object Arguments]", a = "[object Map]", o = "[object Object]", i = "[object Set]", u = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, c = /^\w*$/, s = /^\./, l = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g, f = /\\(\\)?/g, d = /^\[object .+?Constructor\]$/, p = /^(?:0|[1-9]\d*)$/, h = {};
            h["[object Float32Array]"] = h["[object Float64Array]"] = h["[object Int8Array]"] = h["[object Int16Array]"] = h["[object Int32Array]"] = h["[object Uint8Array]"] = h["[object Uint8ClampedArray]"] = h["[object Uint16Array]"] = h["[object Uint32Array]"] = !0, h[n] = h["[object Array]"] = h["[object ArrayBuffer]"] = h["[object Boolean]"] = h["[object DataView]"] = h["[object Date]"] = h["[object Error]"] = h["[object Function]"] = h[a] = h["[object Number]"] = h[o] = h["[object RegExp]"] = h[i] = h["[object String]"] = h["[object WeakMap]"] = !1;
            var m = "object" == typeof e && e && e.Object === Object && e, y = "object" == typeof self && self && self.Object === Object && self, b = m || y || Function("return this")(), g = t && !t.nodeType && t, v = g && "object" == typeof r && r && !r.nodeType && r, C = v && v.exports === g && m.process, _ = function() {
                try {
                    return C && C.binding("util");
                } catch (e) {}
            }(), w = _ && _.isTypedArray;
            function S(e, t, r, n) {
                var a = -1, o = e ? e.length : 0;
                for(n && o && (r = e[++a]); ++a < o;)r = t(r, e[a], a, e);
                return r;
            }
            function j(e, t) {
                for(var r = -1, n = e ? e.length : 0; ++r < n;)if (t(e[r], r, e)) return !0;
                return !1;
            }
            function x(e, t, r, n, a) {
                return a(e, function(e, a, o) {
                    r = n ? (n = !1, e) : t(r, e, a, o);
                }), r;
            }
            function N(e) {
                var t = !1;
                if (null != e && "function" != typeof e.toString) try {
                    t = !!(e + "");
                } catch (e) {}
                return t;
            }
            function O(e) {
                var t = -1, r = Array(e.size);
                return e.forEach(function(e, n) {
                    r[++t] = [
                        n,
                        e
                    ];
                }), r;
            }
            function E(e) {
                var t = -1, r = Array(e.size);
                return e.forEach(function(e) {
                    r[++t] = e;
                }), r;
            }
            var k, T, A, I = Array.prototype, D = Function.prototype, P = Object.prototype, F = b["__core-js_shared__"], M = (k = /[^.]+$/.exec(F && F.keys && F.keys.IE_PROTO || "")) ? "Symbol(src)_1." + k : "", R = D.toString, L = P.hasOwnProperty, z = P.toString, B = RegExp("^" + R.call(L).replace(/[\\^$.*+?()[\]{}|]/g, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"), G = b.Symbol, $ = b.Uint8Array, V = P.propertyIsEnumerable, K = I.splice, U = (T = Object.keys, A = Object, function(e) {
                return T(A(e));
            }), q = Ne(b, "DataView"), H = Ne(b, "Map"), W = Ne(b, "Promise"), J = Ne(b, "Set"), Z = Ne(b, "WeakMap"), Q = Ne(Object, "create"), Y = Pe(q), X = Pe(H), ee = Pe(W), te = Pe(J), re = Pe(Z), ne = G ? G.prototype : void 0, ae = ne ? ne.valueOf : void 0, oe = ne ? ne.toString : void 0;
            function ie(e) {
                var t = -1, r = e ? e.length : 0;
                for(this.clear(); ++t < r;){
                    var n = e[t];
                    this.set(n[0], n[1]);
                }
            }
            function ue(e) {
                var t = -1, r = e ? e.length : 0;
                for(this.clear(); ++t < r;){
                    var n = e[t];
                    this.set(n[0], n[1]);
                }
            }
            function ce(e) {
                var t = -1, r = e ? e.length : 0;
                for(this.clear(); ++t < r;){
                    var n = e[t];
                    this.set(n[0], n[1]);
                }
            }
            function se(e) {
                var t = -1, r = e ? e.length : 0;
                for(this.__data__ = new ce; ++t < r;)this.add(e[t]);
            }
            function le(e) {
                this.__data__ = new ue(e);
            }
            function fe(e, t) {
                var r = Le(e) || Re(e) ? function(e, t) {
                    for(var r = -1, n = Array(e); ++r < e;)n[r] = t(r);
                    return n;
                }(e.length, String) : [], n = r.length, a = !!n;
                for(var o in e)!t && !L.call(e, o) || a && ("length" == o || Ee(o, n)) || r.push(o);
                return r;
            }
            function de(e, t) {
                for(var r = e.length; r--;)if (Me(e[r][0], t)) return r;
                return -1;
            }
            ie.prototype.clear = function() {
                this.__data__ = Q ? Q(null) : {};
            }, ie.prototype.delete = function(e) {
                return this.has(e) && delete this.__data__[e];
            }, ie.prototype.get = function(e) {
                var t = this.__data__;
                if (Q) {
                    var r = t[e];
                    return "__lodash_hash_undefined__" === r ? void 0 : r;
                }
                return L.call(t, e) ? t[e] : void 0;
            }, ie.prototype.has = function(e) {
                var t = this.__data__;
                return Q ? void 0 !== t[e] : L.call(t, e);
            }, ie.prototype.set = function(e, t) {
                return this.__data__[e] = Q && void 0 === t ? "__lodash_hash_undefined__" : t, this;
            }, ue.prototype.clear = function() {
                this.__data__ = [];
            }, ue.prototype.delete = function(e) {
                var t = this.__data__, r = de(t, e);
                return !(r < 0) && (r == t.length - 1 ? t.pop() : K.call(t, r, 1), !0);
            }, ue.prototype.get = function(e) {
                var t = this.__data__, r = de(t, e);
                return r < 0 ? void 0 : t[r][1];
            }, ue.prototype.has = function(e) {
                return de(this.__data__, e) > -1;
            }, ue.prototype.set = function(e, t) {
                var r = this.__data__, n = de(r, e);
                return n < 0 ? r.push([
                    e,
                    t
                ]) : r[n][1] = t, this;
            }, ce.prototype.clear = function() {
                this.__data__ = {
                    hash: new ie,
                    map: new (H || ue),
                    string: new ie
                };
            }, ce.prototype.delete = function(e) {
                return xe(this, e).delete(e);
            }, ce.prototype.get = function(e) {
                return xe(this, e).get(e);
            }, ce.prototype.has = function(e) {
                return xe(this, e).has(e);
            }, ce.prototype.set = function(e, t) {
                return xe(this, e).set(e, t), this;
            }, se.prototype.add = se.prototype.push = function(e) {
                return this.__data__.set(e, "__lodash_hash_undefined__"), this;
            }, se.prototype.has = function(e) {
                return this.__data__.has(e);
            }, le.prototype.clear = function() {
                this.__data__ = new ue;
            }, le.prototype.delete = function(e) {
                return this.__data__.delete(e);
            }, le.prototype.get = function(e) {
                return this.__data__.get(e);
            }, le.prototype.has = function(e) {
                return this.__data__.has(e);
            }, le.prototype.set = function(e, t) {
                var r = this.__data__;
                if (r instanceof ue) {
                    var n = r.__data__;
                    if (!H || n.length < 199) return n.push([
                        e,
                        t
                    ]), this;
                    r = this.__data__ = new ce(n);
                }
                return r.set(e, t), this;
            };
            var pe, he, me = (pe = function(e, t) {
                return e && ye(e, t, qe);
            }, function(e, t) {
                if (null == e) return e;
                if (!ze(e)) return pe(e, t);
                for(var r = e.length, n = he ? r : -1, a = Object(e); (he ? n-- : ++n < r) && !1 !== t(a[n], n, a););
                return e;
            }), ye = function(e) {
                return function(t, r, n) {
                    for(var a = -1, o = Object(t), i = n(t), u = i.length; u--;){
                        var c = i[e ? u : ++a];
                        if (!1 === r(o[c], c, o)) break;
                    }
                    return t;
                };
            }();
            function be(e, t) {
                for(var r = 0, n = (t = ke(t, e) ? [
                    t
                ] : Se(t)).length; null != e && r < n;)e = e[De(t[r++])];
                return r && r == n ? e : void 0;
            }
            function ge(e, t) {
                return null != e && t in Object(e);
            }
            function ve(e, t, r, u, c) {
                return e === t || (null == e || null == t || !$e(e) && !Ve(t) ? e != e && t != t : function(e, t, r, u, c, s) {
                    var l = Le(e), f = Le(t), d = "[object Array]", p = "[object Array]";
                    l || (d = (d = Oe(e)) == n ? o : d);
                    f || (p = (p = Oe(t)) == n ? o : p);
                    var h = d == o && !N(e), m = p == o && !N(t), y = d == p;
                    if (y && !h) return s || (s = new le), l || Ue(e) ? je(e, t, r, u, c, s) : function(e, t, r, n, o, u, c) {
                        switch(r){
                            case "[object DataView]":
                                if (e.byteLength != t.byteLength || e.byteOffset != t.byteOffset) return !1;
                                e = e.buffer, t = t.buffer;
                            case "[object ArrayBuffer]":
                                return !(e.byteLength != t.byteLength || !n(new $(e), new $(t)));
                            case "[object Boolean]":
                            case "[object Date]":
                            case "[object Number]":
                                return Me(+e, +t);
                            case "[object Error]":
                                return e.name == t.name && e.message == t.message;
                            case "[object RegExp]":
                            case "[object String]":
                                return e == t + "";
                            case a:
                                var s = O;
                            case i:
                                var l = 2 & u;
                                if (s || (s = E), e.size != t.size && !l) return !1;
                                var f = c.get(e);
                                if (f) return f == t;
                                u |= 1, c.set(e, t);
                                var d = je(s(e), s(t), n, o, u, c);
                                return c.delete(e), d;
                            case "[object Symbol]":
                                if (ae) return ae.call(e) == ae.call(t);
                        }
                        return !1;
                    }(e, t, d, r, u, c, s);
                    if (!(2 & c)) {
                        var b = h && L.call(e, "__wrapped__"), g = m && L.call(t, "__wrapped__");
                        if (b || g) {
                            var v = b ? e.value() : e, C = g ? t.value() : t;
                            return s || (s = new le), r(v, C, u, c, s);
                        }
                    }
                    if (!y) return !1;
                    return s || (s = new le), function(e, t, r, n, a, o) {
                        var i = 2 & a, u = qe(e), c = u.length, s = qe(t).length;
                        if (c != s && !i) return !1;
                        var l = c;
                        for(; l--;){
                            var f = u[l];
                            if (!(i ? f in t : L.call(t, f))) return !1;
                        }
                        var d = o.get(e);
                        if (d && o.get(t)) return d == t;
                        var p = !0;
                        o.set(e, t), o.set(t, e);
                        var h = i;
                        for(; ++l < c;){
                            f = u[l];
                            var m = e[f], y = t[f];
                            if (n) var b = i ? n(y, m, f, t, e, o) : n(m, y, f, e, t, o);
                            if (!(void 0 === b ? m === y || r(m, y, n, a, o) : b)) {
                                p = !1;
                                break;
                            }
                            h || (h = "constructor" == f);
                        }
                        if (p && !h) {
                            var g = e.constructor, v = t.constructor;
                            g == v || !("constructor" in e) || !("constructor" in t) || "function" == typeof g && g instanceof g && "function" == typeof v && v instanceof v || (p = !1);
                        }
                        return o.delete(e), o.delete(t), p;
                    }(e, t, r, u, c, s);
                }(e, t, ve, r, u, c));
            }
            function Ce(e) {
                return !(!$e(e) || function(e) {
                    return !!M && M in e;
                }(e)) && (Be(e) || N(e) ? B : d).test(Pe(e));
            }
            function _e(e) {
                var t, r;
                return "function" == typeof e ? e : null == e ? He : "object" == typeof e ? Le(e) ? function(e, t) {
                    if (ke(e) && Te(t)) return Ae(De(e), t);
                    return function(r) {
                        var n = function(e, t, r) {
                            var n = null == e ? void 0 : be(e, t);
                            return void 0 === n ? r : n;
                        }(r, e);
                        return void 0 === n && n === t ? function(e, t) {
                            return null != e && function(e, t, r) {
                                t = ke(t, e) ? [
                                    t
                                ] : Se(t);
                                var n, a = -1, o = t.length;
                                for(; ++a < o;){
                                    var i = De(t[a]);
                                    if (!(n = null != e && r(e, i))) break;
                                    e = e[i];
                                }
                                if (n) return n;
                                return !!(o = e ? e.length : 0) && Ge(o) && Ee(i, o) && (Le(e) || Re(e));
                            }(e, t, ge);
                        }(r, e) : ve(t, n, void 0, 3);
                    };
                }(e[0], e[1]) : function(e) {
                    var t = function(e) {
                        var t = qe(e), r = t.length;
                        for(; r--;){
                            var n = t[r], a = e[n];
                            t[r] = [
                                n,
                                a,
                                Te(a)
                            ];
                        }
                        return t;
                    }(e);
                    if (1 == t.length && t[0][2]) return Ae(t[0][0], t[0][1]);
                    return function(r) {
                        return r === e || function(e, t, r, n) {
                            var a = r.length, o = a, i = !n;
                            if (null == e) return !o;
                            for(e = Object(e); a--;){
                                var u = r[a];
                                if (i && u[2] ? u[1] !== e[u[0]] : !(u[0] in e)) return !1;
                            }
                            for(; ++a < o;){
                                var c = (u = r[a])[0], s = e[c], l = u[1];
                                if (i && u[2]) {
                                    if (void 0 === s && !(c in e)) return !1;
                                } else {
                                    var f = new le;
                                    if (n) var d = n(s, l, c, e, t, f);
                                    if (!(void 0 === d ? ve(l, s, n, 3, f) : d)) return !1;
                                }
                            }
                            return !0;
                        }(r, e, t);
                    };
                }(e) : ke(t = e) ? (r = De(t), function(e) {
                    return null == e ? void 0 : e[r];
                }) : function(e) {
                    return function(t) {
                        return be(t, e);
                    };
                }(t);
            }
            function we(e) {
                if (r = (t = e) && t.constructor, n = "function" == typeof r && r.prototype || P, t !== n) return U(e);
                var t, r, n, a = [];
                for(var o in Object(e))L.call(e, o) && "constructor" != o && a.push(o);
                return a;
            }
            function Se(e) {
                return Le(e) ? e : Ie(e);
            }
            function je(e, t, r, n, a, o) {
                var i = 2 & a, u = e.length, c = t.length;
                if (u != c && !(i && c > u)) return !1;
                var s = o.get(e);
                if (s && o.get(t)) return s == t;
                var l = -1, f = !0, d = 1 & a ? new se : void 0;
                for(o.set(e, t), o.set(t, e); ++l < u;){
                    var p = e[l], h = t[l];
                    if (n) var m = i ? n(h, p, l, t, e, o) : n(p, h, l, e, t, o);
                    if (void 0 !== m) {
                        if (m) continue;
                        f = !1;
                        break;
                    }
                    if (d) {
                        if (!j(t, function(e, t) {
                            if (!d.has(t) && (p === e || r(p, e, n, a, o))) return d.add(t);
                        })) {
                            f = !1;
                            break;
                        }
                    } else if (p !== h && !r(p, h, n, a, o)) {
                        f = !1;
                        break;
                    }
                }
                return o.delete(e), o.delete(t), f;
            }
            function xe(e, t) {
                var r, n, a = e.__data__;
                return ("string" == (n = typeof (r = t)) || "number" == n || "symbol" == n || "boolean" == n ? "__proto__" !== r : null === r) ? a["string" == typeof t ? "string" : "hash"] : a.map;
            }
            function Ne(e, t) {
                var r = function(e, t) {
                    return null == e ? void 0 : e[t];
                }(e, t);
                return Ce(r) ? r : void 0;
            }
            var Oe = function(e) {
                return z.call(e);
            };
            function Ee(e, t) {
                return !!(t = null == t ? 9007199254740991 : t) && ("number" == typeof e || p.test(e)) && e > -1 && e % 1 == 0 && e < t;
            }
            function ke(e, t) {
                if (Le(e)) return !1;
                var r = typeof e;
                return !("number" != r && "symbol" != r && "boolean" != r && null != e && !Ke(e)) || c.test(e) || !u.test(e) || null != t && e in Object(t);
            }
            function Te(e) {
                return e == e && !$e(e);
            }
            function Ae(e, t) {
                return function(r) {
                    return null != r && r[e] === t && (void 0 !== t || e in Object(r));
                };
            }
            (q && "[object DataView]" != Oe(new q(new ArrayBuffer(1))) || H && Oe(new H) != a || W && "[object Promise]" != Oe(W.resolve()) || J && Oe(new J) != i || Z && "[object WeakMap]" != Oe(new Z)) && (Oe = function(e) {
                var t = z.call(e), r = t == o ? e.constructor : void 0, n = r ? Pe(r) : void 0;
                if (n) switch(n){
                    case Y:
                        return "[object DataView]";
                    case X:
                        return a;
                    case ee:
                        return "[object Promise]";
                    case te:
                        return i;
                    case re:
                        return "[object WeakMap]";
                }
                return t;
            });
            var Ie = Fe(function(e) {
                var t;
                e = null == (t = e) ? "" : function(e) {
                    if ("string" == typeof e) return e;
                    if (Ke(e)) return oe ? oe.call(e) : "";
                    var t = e + "";
                    return "0" == t && 1 / e == -1 / 0 ? "-0" : t;
                }(t);
                var r = [];
                return s.test(e) && r.push(""), e.replace(l, function(e, t, n, a) {
                    r.push(n ? a.replace(f, "$1") : t || e);
                }), r;
            });
            function De(e) {
                if ("string" == typeof e || Ke(e)) return e;
                var t = e + "";
                return "0" == t && 1 / e == -1 / 0 ? "-0" : t;
            }
            function Pe(e) {
                if (null != e) {
                    try {
                        return R.call(e);
                    } catch (e) {}
                    try {
                        return e + "";
                    } catch (e) {}
                }
                return "";
            }
            function Fe(e, t) {
                if ("function" != typeof e || t && "function" != typeof t) throw new TypeError("Expected a function");
                var r = function() {
                    var n = arguments, a = t ? t.apply(this, n) : n[0], o = r.cache;
                    if (o.has(a)) return o.get(a);
                    var i = e.apply(this, n);
                    return r.cache = o.set(a, i), i;
                };
                return r.cache = new (Fe.Cache || ce), r;
            }
            function Me(e, t) {
                return e === t || e != e && t != t;
            }
            function Re(e) {
                return function(e) {
                    return Ve(e) && ze(e);
                }(e) && L.call(e, "callee") && (!V.call(e, "callee") || z.call(e) == n);
            }
            Fe.Cache = ce;
            var Le = Array.isArray;
            function ze(e) {
                return null != e && Ge(e.length) && !Be(e);
            }
            function Be(e) {
                var t = $e(e) ? z.call(e) : "";
                return "[object Function]" == t || "[object GeneratorFunction]" == t;
            }
            function Ge(e) {
                return "number" == typeof e && e > -1 && e % 1 == 0 && e <= 9007199254740991;
            }
            function $e(e) {
                var t = typeof e;
                return !!e && ("object" == t || "function" == t);
            }
            function Ve(e) {
                return !!e && "object" == typeof e;
            }
            function Ke(e) {
                return "symbol" == typeof e || Ve(e) && "[object Symbol]" == z.call(e);
            }
            var Ue = w ? function(e) {
                return function(t) {
                    return e(t);
                };
            }(w) : function(e) {
                return Ve(e) && Ge(e.length) && !!h[z.call(e)];
            };
            function qe(e) {
                return ze(e) ? fe(e) : we(e);
            }
            function He(e) {
                return e;
            }
            r.exports = function(e, t, r) {
                var n = Le(e) ? S : x, a = arguments.length < 3;
                return n(e, _e(t), r, a, me);
            };
        }).call(this, r(3), r(7)(e));
    },
    function(e, t) {
        e.exports = function(e) {
            return e.webpackPolyfill || (e.deprecate = function() {}, e.paths = [], e.children || (e.children = []), Object.defineProperty(e, "loaded", {
                enumerable: !0,
                get: function() {
                    return e.l;
                }
            }), Object.defineProperty(e, "id", {
                enumerable: !0,
                get: function() {
                    return e.i;
                }
            }), e.webpackPolyfill = 1), e;
        };
    },
    function(e, t) {
        String.prototype.padEnd || (String.prototype.padEnd = function(e, t) {
            return e >>= 0, t = String(void 0 !== t ? t : " "), this.length > e ? String(this) : ((e -= this.length) > t.length && (t += t.repeat(e / t.length)), String(this) + t.slice(0, e));
        });
    },
    function(e, t, r) {
        "use strict";
        function n(e, t, r) {
            return t in e ? Object.defineProperty(e, t, {
                value: r,
                enumerable: !0,
                configurable: !0,
                writable: !0
            }) : e[t] = r, e;
        }
        function a(e) {
            if (Symbol.iterator in Object(e) || "[object Arguments]" === Object.prototype.toString.call(e)) return Array.from(e);
        }
        function o(e) {
            return function(e) {
                if (Array.isArray(e)) {
                    for(var t = 0, r = new Array(e.length); t < e.length; t++)r[t] = e[t];
                    return r;
                }
            }(e) || a(e) || function() {
                throw new TypeError("Invalid attempt to spread non-iterable instance");
            }();
        }
        function i(e) {
            if (Array.isArray(e)) return e;
        }
        function u() {
            throw new TypeError("Invalid attempt to destructure non-iterable instance");
        }
        function c(e, t) {
            if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }
        function s(e, t) {
            for(var r = 0; r < t.length; r++){
                var n = t[r];
                n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, n.key, n);
            }
        }
        function l(e) {
            return (l = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(e) {
                return typeof e;
            } : function(e) {
                return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
            })(e);
        }
        function f(e) {
            return (f = "function" == typeof Symbol && "symbol" === l(Symbol.iterator) ? function(e) {
                return l(e);
            } : function(e) {
                return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : l(e);
            })(e);
        }
        function d(e) {
            if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
            return e;
        }
        function p(e) {
            return (p = Object.setPrototypeOf ? Object.getPrototypeOf : function(e) {
                return e.__proto__ || Object.getPrototypeOf(e);
            })(e);
        }
        function h(e, t) {
            return (h = Object.setPrototypeOf || function(e, t) {
                return e.__proto__ = t, e;
            })(e, t);
        }
        r.r(t);
        var m = r(0), y = r.n(m), b = r(5), g = r.n(b), v = r(4), C = r.n(v), _ = r(6), w = r.n(_), S = r(2), j = r.n(S), x = r(1), N = r.n(x);
        r(8);
        function O(e, t) {
            return i(e) || function(e, t) {
                var r = [], n = !0, a = !1, o = void 0;
                try {
                    for(var i, u = e[Symbol.iterator](); !(n = (i = u.next()).done) && (r.push(i.value), !t || r.length !== t); n = !0);
                } catch (e) {
                    a = !0, o = e;
                } finally{
                    try {
                        n || null == u.return || u.return();
                    } finally{
                        if (a) throw o;
                    }
                }
                return r;
            }(e, t) || u();
        }
        var E = [
            [
                "Afghanistan",
                [
                    "asia"
                ],
                "af",
                "93"
            ],
            [
                "Albania",
                [
                    "europe"
                ],
                "al",
                "355"
            ],
            [
                "Algeria",
                [
                    "africa",
                    "north-africa"
                ],
                "dz",
                "213"
            ],
            [
                "Andorra",
                [
                    "europe"
                ],
                "ad",
                "376"
            ],
            [
                "Angola",
                [
                    "africa"
                ],
                "ao",
                "244"
            ],
            [
                "Antigua and Barbuda",
                [
                    "america",
                    "carribean"
                ],
                "ag",
                "1268"
            ],
            [
                "Argentina",
                [
                    "america",
                    "south-america"
                ],
                "ar",
                "54",
                "(..) ........",
                0,
                [
                    "11",
                    "221",
                    "223",
                    "261",
                    "264",
                    "2652",
                    "280",
                    "2905",
                    "291",
                    "2920",
                    "2966",
                    "299",
                    "341",
                    "342",
                    "343",
                    "351",
                    "376",
                    "379",
                    "381",
                    "3833",
                    "385",
                    "387",
                    "388"
                ]
            ],
            [
                "Armenia",
                [
                    "asia",
                    "ex-ussr"
                ],
                "am",
                "374",
                ".. ......"
            ],
            [
                "Aruba",
                [
                    "america",
                    "carribean"
                ],
                "aw",
                "297"
            ],
            [
                "Australia",
                [
                    "oceania"
                ],
                "au",
                "61",
                "(..) .... ....",
                0,
                [
                    "2",
                    "3",
                    "4",
                    "7",
                    "8",
                    "02",
                    "03",
                    "04",
                    "07",
                    "08"
                ]
            ],
            [
                "Austria",
                [
                    "europe",
                    "eu-union"
                ],
                "at",
                "43"
            ],
            [
                "Azerbaijan",
                [
                    "asia",
                    "ex-ussr"
                ],
                "az",
                "994",
                "(..) ... .. .."
            ],
            [
                "Bahamas",
                [
                    "america",
                    "carribean"
                ],
                "bs",
                "1242"
            ],
            [
                "Bahrain",
                [
                    "middle-east"
                ],
                "bh",
                "973"
            ],
            [
                "Bangladesh",
                [
                    "asia"
                ],
                "bd",
                "880"
            ],
            [
                "Barbados",
                [
                    "america",
                    "carribean"
                ],
                "bb",
                "1246"
            ],
            [
                "Belarus",
                [
                    "europe",
                    "ex-ussr"
                ],
                "by",
                "375",
                "(..) ... .. .."
            ],
            [
                "Belgium",
                [
                    "europe",
                    "eu-union"
                ],
                "be",
                "32",
                "... .. .. .."
            ],
            [
                "Belize",
                [
                    "america",
                    "central-america"
                ],
                "bz",
                "501"
            ],
            [
                "Benin",
                [
                    "africa"
                ],
                "bj",
                "229"
            ],
            [
                "Bhutan",
                [
                    "asia"
                ],
                "bt",
                "975"
            ],
            [
                "Bolivia",
                [
                    "america",
                    "south-america"
                ],
                "bo",
                "591"
            ],
            [
                "Bosnia and Herzegovina",
                [
                    "europe",
                    "ex-yugos"
                ],
                "ba",
                "387"
            ],
            [
                "Botswana",
                [
                    "africa"
                ],
                "bw",
                "267"
            ],
            [
                "Brazil",
                [
                    "america",
                    "south-america"
                ],
                "br",
                "55",
                "(..) ........."
            ],
            [
                "British Indian Ocean Territory",
                [
                    "asia"
                ],
                "io",
                "246"
            ],
            [
                "Brunei",
                [
                    "asia"
                ],
                "bn",
                "673"
            ],
            [
                "Bulgaria",
                [
                    "europe",
                    "eu-union"
                ],
                "bg",
                "359"
            ],
            [
                "Burkina Faso",
                [
                    "africa"
                ],
                "bf",
                "226"
            ],
            [
                "Burundi",
                [
                    "africa"
                ],
                "bi",
                "257"
            ],
            [
                "Cambodia",
                [
                    "asia"
                ],
                "kh",
                "855"
            ],
            [
                "Cameroon",
                [
                    "africa"
                ],
                "cm",
                "237"
            ],
            [
                "Canada",
                [
                    "america",
                    "north-america"
                ],
                "ca",
                "1",
                "(...) ...-....",
                1,
                [
                    "204",
                    "226",
                    "236",
                    "249",
                    "250",
                    "289",
                    "306",
                    "343",
                    "365",
                    "387",
                    "403",
                    "416",
                    "418",
                    "431",
                    "437",
                    "438",
                    "450",
                    "506",
                    "514",
                    "519",
                    "548",
                    "579",
                    "581",
                    "587",
                    "604",
                    "613",
                    "639",
                    "647",
                    "672",
                    "705",
                    "709",
                    "742",
                    "778",
                    "780",
                    "782",
                    "807",
                    "819",
                    "825",
                    "867",
                    "873",
                    "902",
                    "905"
                ]
            ],
            [
                "Cape Verde",
                [
                    "africa"
                ],
                "cv",
                "238"
            ],
            [
                "Caribbean Netherlands",
                [
                    "america",
                    "carribean"
                ],
                "bq",
                "599",
                "",
                1
            ],
            [
                "Central African Republic",
                [
                    "africa"
                ],
                "cf",
                "236"
            ],
            [
                "Chad",
                [
                    "africa"
                ],
                "td",
                "235"
            ],
            [
                "Chile",
                [
                    "america",
                    "south-america"
                ],
                "cl",
                "56"
            ],
            [
                "China",
                [
                    "asia"
                ],
                "cn",
                "86",
                "..-........."
            ],
            [
                "Colombia",
                [
                    "america",
                    "south-america"
                ],
                "co",
                "57",
                "... ... ...."
            ],
            [
                "Comoros",
                [
                    "africa"
                ],
                "km",
                "269"
            ],
            [
                "Congo",
                [
                    "africa"
                ],
                "cd",
                "243"
            ],
            [
                "Congo",
                [
                    "africa"
                ],
                "cg",
                "242"
            ],
            [
                "Costa Rica",
                [
                    "america",
                    "central-america"
                ],
                "cr",
                "506",
                "....-...."
            ],
            [
                "C\xf4te d\u2019Ivoire",
                [
                    "africa"
                ],
                "ci",
                "225",
                ".. .. .. .."
            ],
            [
                "Croatia",
                [
                    "europe",
                    "eu-union",
                    "ex-yugos"
                ],
                "hr",
                "385"
            ],
            [
                "Cuba",
                [
                    "america",
                    "carribean"
                ],
                "cu",
                "53"
            ],
            [
                "Cura\xe7ao",
                [
                    "america",
                    "carribean"
                ],
                "cw",
                "599",
                "",
                0
            ],
            [
                "Cyprus",
                [
                    "europe",
                    "eu-union"
                ],
                "cy",
                "357",
                ".. ......"
            ],
            [
                "Czech Republic",
                [
                    "europe",
                    "eu-union"
                ],
                "cz",
                "420",
                "... ... ..."
            ],
            [
                "Denmark",
                [
                    "europe",
                    "eu-union",
                    "baltic"
                ],
                "dk",
                "45",
                ".. .. .. .."
            ],
            [
                "Djibouti",
                [
                    "africa"
                ],
                "dj",
                "253"
            ],
            [
                "Dominica",
                [
                    "america",
                    "carribean"
                ],
                "dm",
                "1767"
            ],
            [
                "Dominican Republic",
                [
                    "america",
                    "carribean"
                ],
                "do",
                "1",
                "",
                2,
                [
                    "809",
                    "829",
                    "849"
                ]
            ],
            [
                "Ecuador",
                [
                    "america",
                    "south-america"
                ],
                "ec",
                "593"
            ],
            [
                "Egypt",
                [
                    "africa",
                    "north-africa"
                ],
                "eg",
                "20"
            ],
            [
                "El Salvador",
                [
                    "america",
                    "central-america"
                ],
                "sv",
                "503",
                "....-...."
            ],
            [
                "Equatorial Guinea",
                [
                    "africa"
                ],
                "gq",
                "240"
            ],
            [
                "Eritrea",
                [
                    "africa"
                ],
                "er",
                "291"
            ],
            [
                "Estonia",
                [
                    "europe",
                    "eu-union",
                    "ex-ussr",
                    "baltic"
                ],
                "ee",
                "372",
                ".... ......"
            ],
            [
                "Ethiopia",
                [
                    "africa"
                ],
                "et",
                "251"
            ],
            [
                "Fiji",
                [
                    "oceania"
                ],
                "fj",
                "679"
            ],
            [
                "Finland",
                [
                    "europe",
                    "eu-union",
                    "baltic"
                ],
                "fi",
                "358",
                ".. ... .. .."
            ],
            [
                "France",
                [
                    "europe",
                    "eu-union"
                ],
                "fr",
                "33",
                ". .. .. .. .."
            ],
            [
                "French Guiana",
                [
                    "america",
                    "south-america"
                ],
                "gf",
                "594"
            ],
            [
                "French Polynesia",
                [
                    "oceania"
                ],
                "pf",
                "689"
            ],
            [
                "Gabon",
                [
                    "africa"
                ],
                "ga",
                "241"
            ],
            [
                "Gambia",
                [
                    "africa"
                ],
                "gm",
                "220"
            ],
            [
                "Georgia",
                [
                    "asia",
                    "ex-ussr"
                ],
                "ge",
                "995"
            ],
            [
                "Germany",
                [
                    "europe",
                    "eu-union",
                    "baltic"
                ],
                "de",
                "49",
                ".... ........"
            ],
            [
                "Ghana",
                [
                    "africa"
                ],
                "gh",
                "233"
            ],
            [
                "Greece",
                [
                    "europe",
                    "eu-union"
                ],
                "gr",
                "30"
            ],
            [
                "Grenada",
                [
                    "america",
                    "carribean"
                ],
                "gd",
                "1473"
            ],
            [
                "Guadeloupe",
                [
                    "america",
                    "carribean"
                ],
                "gp",
                "590",
                "",
                0
            ],
            [
                "Guam",
                [
                    "oceania"
                ],
                "gu",
                "1671"
            ],
            [
                "Guatemala",
                [
                    "america",
                    "central-america"
                ],
                "gt",
                "502",
                "....-...."
            ],
            [
                "Guinea",
                [
                    "africa"
                ],
                "gn",
                "224"
            ],
            [
                "Guinea-Bissau",
                [
                    "africa"
                ],
                "gw",
                "245"
            ],
            [
                "Guyana",
                [
                    "america",
                    "south-america"
                ],
                "gy",
                "592"
            ],
            [
                "Haiti",
                [
                    "america",
                    "carribean"
                ],
                "ht",
                "509",
                "....-...."
            ],
            [
                "Honduras",
                [
                    "america",
                    "central-america"
                ],
                "hn",
                "504"
            ],
            [
                "Hong Kong",
                [
                    "asia"
                ],
                "hk",
                "852",
                ".... ...."
            ],
            [
                "Hungary",
                [
                    "europe",
                    "eu-union"
                ],
                "hu",
                "36"
            ],
            [
                "Iceland",
                [
                    "europe"
                ],
                "is",
                "354",
                "... ...."
            ],
            [
                "India",
                [
                    "asia"
                ],
                "in",
                "91",
                ".....-....."
            ],
            [
                "Indonesia",
                [
                    "asia"
                ],
                "id",
                "62"
            ],
            [
                "Iran",
                [
                    "middle-east"
                ],
                "ir",
                "98",
                "... ... ...."
            ],
            [
                "Iraq",
                [
                    "middle-east"
                ],
                "iq",
                "964"
            ],
            [
                "Ireland",
                [
                    "europe",
                    "eu-union"
                ],
                "ie",
                "353",
                ".. ......."
            ],
            [
                "Israel",
                [
                    "middle-east"
                ],
                "il",
                "972",
                "... ... ...."
            ],
            [
                "Italy",
                [
                    "europe",
                    "eu-union"
                ],
                "it",
                "39",
                "... .......",
                0
            ],
            [
                "Jamaica",
                [
                    "america",
                    "carribean"
                ],
                "jm",
                "1876"
            ],
            [
                "Japan",
                [
                    "asia"
                ],
                "jp",
                "81",
                ".. .... ...."
            ],
            [
                "Jordan",
                [
                    "middle-east"
                ],
                "jo",
                "962"
            ],
            [
                "Kazakhstan",
                [
                    "asia",
                    "ex-ussr"
                ],
                "kz",
                "7",
                "... ...-..-..",
                1,
                [
                    "310",
                    "311",
                    "312",
                    "313",
                    "315",
                    "318",
                    "321",
                    "324",
                    "325",
                    "326",
                    "327",
                    "336",
                    "7172",
                    "73622"
                ]
            ],
            [
                "Kenya",
                [
                    "africa"
                ],
                "ke",
                "254"
            ],
            [
                "Kiribati",
                [
                    "oceania"
                ],
                "ki",
                "686"
            ],
            [
                "Kosovo",
                [
                    "europe",
                    "ex-yugos"
                ],
                "xk",
                "383"
            ],
            [
                "Kuwait",
                [
                    "middle-east"
                ],
                "kw",
                "965"
            ],
            [
                "Kyrgyzstan",
                [
                    "asia",
                    "ex-ussr"
                ],
                "kg",
                "996",
                "... ... ..."
            ],
            [
                "Laos",
                [
                    "asia"
                ],
                "la",
                "856"
            ],
            [
                "Latvia",
                [
                    "europe",
                    "eu-union",
                    "ex-ussr",
                    "baltic"
                ],
                "lv",
                "371",
                ".. ... ..."
            ],
            [
                "Lebanon",
                [
                    "middle-east"
                ],
                "lb",
                "961"
            ],
            [
                "Lesotho",
                [
                    "africa"
                ],
                "ls",
                "266"
            ],
            [
                "Liberia",
                [
                    "africa"
                ],
                "lr",
                "231"
            ],
            [
                "Libya",
                [
                    "africa",
                    "north-africa"
                ],
                "ly",
                "218"
            ],
            [
                "Liechtenstein",
                [
                    "europe"
                ],
                "li",
                "423"
            ],
            [
                "Lithuania",
                [
                    "europe",
                    "eu-union",
                    "ex-ussr",
                    "baltic"
                ],
                "lt",
                "370"
            ],
            [
                "Luxembourg",
                [
                    "europe",
                    "eu-union"
                ],
                "lu",
                "352"
            ],
            [
                "Macau",
                [
                    "asia"
                ],
                "mo",
                "853"
            ],
            [
                "Macedonia",
                [
                    "europe",
                    "ex-yugos"
                ],
                "mk",
                "389"
            ],
            [
                "Madagascar",
                [
                    "africa"
                ],
                "mg",
                "261"
            ],
            [
                "Malawi",
                [
                    "africa"
                ],
                "mw",
                "265"
            ],
            [
                "Malaysia",
                [
                    "asia"
                ],
                "my",
                "60",
                "..-....-...."
            ],
            [
                "Maldives",
                [
                    "asia"
                ],
                "mv",
                "960"
            ],
            [
                "Mali",
                [
                    "africa"
                ],
                "ml",
                "223"
            ],
            [
                "Malta",
                [
                    "europe",
                    "eu-union"
                ],
                "mt",
                "356"
            ],
            [
                "Marshall Islands",
                [
                    "oceania"
                ],
                "mh",
                "692"
            ],
            [
                "Martinique",
                [
                    "america",
                    "carribean"
                ],
                "mq",
                "596"
            ],
            [
                "Mauritania",
                [
                    "africa"
                ],
                "mr",
                "222"
            ],
            [
                "Mauritius",
                [
                    "africa"
                ],
                "mu",
                "230"
            ],
            [
                "Mexico",
                [
                    "america",
                    "central-america"
                ],
                "mx",
                "52",
                "... ... ....",
                0,
                [
                    "55",
                    "81",
                    "33",
                    "656",
                    "664",
                    "998",
                    "774",
                    "229"
                ]
            ],
            [
                "Micronesia",
                [
                    "oceania"
                ],
                "fm",
                "691"
            ],
            [
                "Moldova",
                [
                    "europe"
                ],
                "md",
                "373",
                "(..) ..-..-.."
            ],
            [
                "Monaco",
                [
                    "europe"
                ],
                "mc",
                "377"
            ],
            [
                "Mongolia",
                [
                    "asia"
                ],
                "mn",
                "976"
            ],
            [
                "Montenegro",
                [
                    "europe",
                    "ex-yugos"
                ],
                "me",
                "382"
            ],
            [
                "Morocco",
                [
                    "africa",
                    "north-africa"
                ],
                "ma",
                "212"
            ],
            [
                "Mozambique",
                [
                    "africa"
                ],
                "mz",
                "258"
            ],
            [
                "Myanmar",
                [
                    "asia"
                ],
                "mm",
                "95"
            ],
            [
                "Namibia",
                [
                    "africa"
                ],
                "na",
                "264"
            ],
            [
                "Nauru",
                [
                    "africa"
                ],
                "nr",
                "674"
            ],
            [
                "Nepal",
                [
                    "asia"
                ],
                "np",
                "977"
            ],
            [
                "Netherlands",
                [
                    "europe",
                    "eu-union"
                ],
                "nl",
                "31",
                ".. ........"
            ],
            [
                "New Caledonia",
                [
                    "oceania"
                ],
                "nc",
                "687"
            ],
            [
                "New Zealand",
                [
                    "oceania"
                ],
                "nz",
                "64",
                "...-...-...."
            ],
            [
                "Nicaragua",
                [
                    "america",
                    "central-america"
                ],
                "ni",
                "505"
            ],
            [
                "Niger",
                [
                    "africa"
                ],
                "ne",
                "227"
            ],
            [
                "Nigeria",
                [
                    "africa"
                ],
                "ng",
                "234"
            ],
            [
                "North Korea",
                [
                    "asia"
                ],
                "kp",
                "850"
            ],
            [
                "Norway",
                [
                    "europe",
                    "baltic"
                ],
                "no",
                "47",
                "... .. ..."
            ],
            [
                "Oman",
                [
                    "middle-east"
                ],
                "om",
                "968"
            ],
            [
                "Pakistan",
                [
                    "asia"
                ],
                "pk",
                "92",
                "...-......."
            ],
            [
                "Palau",
                [
                    "oceania"
                ],
                "pw",
                "680"
            ],
            [
                "Palestine",
                [
                    "middle-east"
                ],
                "ps",
                "970"
            ],
            [
                "Panama",
                [
                    "america",
                    "central-america"
                ],
                "pa",
                "507"
            ],
            [
                "Papua New Guinea",
                [
                    "oceania"
                ],
                "pg",
                "675"
            ],
            [
                "Paraguay",
                [
                    "america",
                    "south-america"
                ],
                "py",
                "595"
            ],
            [
                "Peru",
                [
                    "america",
                    "south-america"
                ],
                "pe",
                "51"
            ],
            [
                "Philippines",
                [
                    "asia"
                ],
                "ph",
                "63",
                ".... ......."
            ],
            [
                "Poland",
                [
                    "europe",
                    "eu-union",
                    "baltic"
                ],
                "pl",
                "48",
                "...-...-..."
            ],
            [
                "Portugal",
                [
                    "europe",
                    "eu-union"
                ],
                "pt",
                "351"
            ],
            [
                "Puerto Rico",
                [
                    "america",
                    "carribean"
                ],
                "pr",
                "1",
                "",
                3,
                [
                    "787",
                    "939"
                ]
            ],
            [
                "Qatar",
                [
                    "middle-east"
                ],
                "qa",
                "974"
            ],
            [
                "R\xe9union",
                [
                    "africa"
                ],
                "re",
                "262"
            ],
            [
                "Romania",
                [
                    "europe",
                    "eu-union"
                ],
                "ro",
                "40"
            ],
            [
                "Russia",
                [
                    "europe",
                    "asia",
                    "ex-ussr",
                    "baltic"
                ],
                "ru",
                "7",
                "(...) ...-..-..",
                0
            ],
            [
                "Rwanda",
                [
                    "africa"
                ],
                "rw",
                "250"
            ],
            [
                "Saint Kitts and Nevis",
                [
                    "america",
                    "carribean"
                ],
                "kn",
                "1869"
            ],
            [
                "Saint Lucia",
                [
                    "america",
                    "carribean"
                ],
                "lc",
                "1758"
            ],
            [
                "Saint Vincent and the Grenadines",
                [
                    "america",
                    "carribean"
                ],
                "vc",
                "1784"
            ],
            [
                "Samoa",
                [
                    "oceania"
                ],
                "ws",
                "685"
            ],
            [
                "San Marino",
                [
                    "europe"
                ],
                "sm",
                "378"
            ],
            [
                "S\xe3o Tom\xe9 and Pr\xedncipe",
                [
                    "africa"
                ],
                "st",
                "239"
            ],
            [
                "Saudi Arabia",
                [
                    "middle-east"
                ],
                "sa",
                "966"
            ],
            [
                "Senegal",
                [
                    "africa"
                ],
                "sn",
                "221"
            ],
            [
                "Serbia",
                [
                    "europe",
                    "ex-yugos"
                ],
                "rs",
                "381"
            ],
            [
                "Seychelles",
                [
                    "africa"
                ],
                "sc",
                "248"
            ],
            [
                "Sierra Leone",
                [
                    "africa"
                ],
                "sl",
                "232"
            ],
            [
                "Singapore",
                [
                    "asia"
                ],
                "sg",
                "65",
                "....-...."
            ],
            [
                "Slovakia",
                [
                    "europe",
                    "eu-union"
                ],
                "sk",
                "421"
            ],
            [
                "Slovenia",
                [
                    "europe",
                    "eu-union",
                    "ex-yugos"
                ],
                "si",
                "386"
            ],
            [
                "Solomon Islands",
                [
                    "oceania"
                ],
                "sb",
                "677"
            ],
            [
                "Somalia",
                [
                    "africa"
                ],
                "so",
                "252"
            ],
            [
                "South Africa",
                [
                    "africa"
                ],
                "za",
                "27"
            ],
            [
                "South Korea",
                [
                    "asia"
                ],
                "kr",
                "82",
                "... .... ...."
            ],
            [
                "South Sudan",
                [
                    "africa",
                    "north-africa"
                ],
                "ss",
                "211"
            ],
            [
                "Spain",
                [
                    "europe",
                    "eu-union"
                ],
                "es",
                "34",
                "... ... ..."
            ],
            [
                "Sri Lanka",
                [
                    "asia"
                ],
                "lk",
                "94"
            ],
            [
                "Sudan",
                [
                    "africa"
                ],
                "sd",
                "249"
            ],
            [
                "Suriname",
                [
                    "america",
                    "south-america"
                ],
                "sr",
                "597"
            ],
            [
                "Swaziland",
                [
                    "africa"
                ],
                "sz",
                "268"
            ],
            [
                "Sweden",
                [
                    "europe",
                    "eu-union",
                    "baltic"
                ],
                "se",
                "46",
                "(...) ...-..."
            ],
            [
                "Switzerland",
                [
                    "europe"
                ],
                "ch",
                "41",
                ".. ... .. .."
            ],
            [
                "Syria",
                [
                    "middle-east"
                ],
                "sy",
                "963"
            ],
            [
                "Taiwan",
                [
                    "asia"
                ],
                "tw",
                "886"
            ],
            [
                "Tajikistan",
                [
                    "asia",
                    "ex-ussr"
                ],
                "tj",
                "992"
            ],
            [
                "Tanzania",
                [
                    "africa"
                ],
                "tz",
                "255"
            ],
            [
                "Thailand",
                [
                    "asia"
                ],
                "th",
                "66"
            ],
            [
                "Timor-Leste",
                [
                    "asia"
                ],
                "tl",
                "670"
            ],
            [
                "Togo",
                [
                    "africa"
                ],
                "tg",
                "228"
            ],
            [
                "Tonga",
                [
                    "oceania"
                ],
                "to",
                "676"
            ],
            [
                "Trinidad and Tobago",
                [
                    "america",
                    "carribean"
                ],
                "tt",
                "1868"
            ],
            [
                "Tunisia",
                [
                    "africa",
                    "north-africa"
                ],
                "tn",
                "216"
            ],
            [
                "Turkey",
                [
                    "europe"
                ],
                "tr",
                "90",
                "... ... .. .."
            ],
            [
                "Turkmenistan",
                [
                    "asia",
                    "ex-ussr"
                ],
                "tm",
                "993"
            ],
            [
                "Tuvalu",
                [
                    "asia"
                ],
                "tv",
                "688"
            ],
            [
                "Uganda",
                [
                    "africa"
                ],
                "ug",
                "256"
            ],
            [
                "Ukraine",
                [
                    "europe",
                    "ex-ussr"
                ],
                "ua",
                "380",
                "(..) ... .. .."
            ],
            [
                "United Arab Emirates",
                [
                    "middle-east"
                ],
                "ae",
                "971",
                "(.) ...-....",
                1,
                [
                    "1",
                    "2",
                    "3",
                    "4",
                    "6",
                    "7",
                    "9",
                    "50",
                    "52",
                    "54",
                    "55",
                    "56",
                    "58"
                ]
            ],
            [
                "United Kingdom",
                [
                    "europe",
                    "eu-union"
                ],
                "gb",
                "44",
                ".... ......"
            ],
            [
                "United States",
                [
                    "america",
                    "north-america"
                ],
                "us",
                "1",
                "(...) ...-....",
                0,
                [
                    "907",
                    "205",
                    "251",
                    "256",
                    "334",
                    "479",
                    "501",
                    "870",
                    "480",
                    "520",
                    "602",
                    "623",
                    "928",
                    "209",
                    "213",
                    "310",
                    "323",
                    "408",
                    "415",
                    "510",
                    "530",
                    "559",
                    "562",
                    "619",
                    "626",
                    "650",
                    "661",
                    "707",
                    "714",
                    "760",
                    "805",
                    "818",
                    "831",
                    "858",
                    "909",
                    "916",
                    "925",
                    "949",
                    "951",
                    "303",
                    "719",
                    "970",
                    "203",
                    "860",
                    "202",
                    "302",
                    "239",
                    "305",
                    "321",
                    "352",
                    "386",
                    "407",
                    "561",
                    "727",
                    "772",
                    "813",
                    "850",
                    "863",
                    "904",
                    "941",
                    "954",
                    "229",
                    "404",
                    "478",
                    "706",
                    "770",
                    "912",
                    "808",
                    "319",
                    "515",
                    "563",
                    "641",
                    "712",
                    "208",
                    "217",
                    "309",
                    "312",
                    "618",
                    "630",
                    "708",
                    "773",
                    "815",
                    "847",
                    "219",
                    "260",
                    "317",
                    "574",
                    "765",
                    "812",
                    "316",
                    "620",
                    "785",
                    "913",
                    "270",
                    "502",
                    "606",
                    "859",
                    "225",
                    "318",
                    "337",
                    "504",
                    "985",
                    "413",
                    "508",
                    "617",
                    "781",
                    "978",
                    "301",
                    "410",
                    "207",
                    "231",
                    "248",
                    "269",
                    "313",
                    "517",
                    "586",
                    "616",
                    "734",
                    "810",
                    "906",
                    "989",
                    "218",
                    "320",
                    "507",
                    "612",
                    "651",
                    "763",
                    "952",
                    "314",
                    "417",
                    "573",
                    "636",
                    "660",
                    "816",
                    "228",
                    "601",
                    "662",
                    "406",
                    "252",
                    "336",
                    "704",
                    "828",
                    "910",
                    "919",
                    "701",
                    "308",
                    "402",
                    "603",
                    "201",
                    "609",
                    "732",
                    "856",
                    "908",
                    "973",
                    "505",
                    "575",
                    "702",
                    "775",
                    "212",
                    "315",
                    "516",
                    "518",
                    "585",
                    "607",
                    "631",
                    "716",
                    "718",
                    "845",
                    "914",
                    "216",
                    "330",
                    "419",
                    "440",
                    "513",
                    "614",
                    "740",
                    "937",
                    "405",
                    "580",
                    "918",
                    "503",
                    "541",
                    "215",
                    "412",
                    "570",
                    "610",
                    "717",
                    "724",
                    "814",
                    "401",
                    "803",
                    "843",
                    "864",
                    "605",
                    "423",
                    "615",
                    "731",
                    "865",
                    "901",
                    "931",
                    "210",
                    "214",
                    "254",
                    "281",
                    "325",
                    "361",
                    "409",
                    "432",
                    "512",
                    "713",
                    "806",
                    "817",
                    "830",
                    "903",
                    "915",
                    "936",
                    "940",
                    "956",
                    "972",
                    "979",
                    "435",
                    "801",
                    "276",
                    "434",
                    "540",
                    "703",
                    "757",
                    "804",
                    "802",
                    "206",
                    "253",
                    "360",
                    "425",
                    "509",
                    "262",
                    "414",
                    "608",
                    "715",
                    "920",
                    "304",
                    "307"
                ]
            ],
            [
                "Uruguay",
                [
                    "america",
                    "south-america"
                ],
                "uy",
                "598"
            ],
            [
                "Uzbekistan",
                [
                    "asia",
                    "ex-ussr"
                ],
                "uz",
                "998",
                ".. ... .. .."
            ],
            [
                "Vanuatu",
                [
                    "oceania"
                ],
                "vu",
                "678"
            ],
            [
                "Vatican City",
                [
                    "europe"
                ],
                "va",
                "39",
                ".. .... ....",
                1
            ],
            [
                "Venezuela",
                [
                    "america",
                    "south-america"
                ],
                "ve",
                "58"
            ],
            [
                "Vietnam",
                [
                    "asia"
                ],
                "vn",
                "84"
            ],
            [
                "Yemen",
                [
                    "middle-east"
                ],
                "ye",
                "967"
            ],
            [
                "Zambia",
                [
                    "africa"
                ],
                "zm",
                "260"
            ],
            [
                "Zimbabwe",
                [
                    "africa"
                ],
                "zw",
                "263"
            ]
        ], k = [
            [
                "American Samoa",
                [
                    "oceania"
                ],
                "as",
                "1684"
            ],
            [
                "Anguilla",
                [
                    "america",
                    "carribean"
                ],
                "ai",
                "1264"
            ],
            [
                "Bermuda",
                [
                    "america",
                    "north-america"
                ],
                "bm",
                "1441"
            ],
            [
                "British Virgin Islands",
                [
                    "america",
                    "carribean"
                ],
                "vg",
                "1284"
            ],
            [
                "Cayman Islands",
                [
                    "america",
                    "carribean"
                ],
                "ky",
                "1345"
            ],
            [
                "Cook Islands",
                [
                    "oceania"
                ],
                "ck",
                "682"
            ],
            [
                "Falkland Islands",
                [
                    "america",
                    "south-america"
                ],
                "fk",
                "500"
            ],
            [
                "Faroe Islands",
                [
                    "europe"
                ],
                "fo",
                "298"
            ],
            [
                "Gibraltar",
                [
                    "europe"
                ],
                "gi",
                "350"
            ],
            [
                "Greenland",
                [
                    "america"
                ],
                "gl",
                "299"
            ],
            [
                "Jersey",
                [
                    "europe",
                    "eu-union"
                ],
                "je",
                "44",
                ".... ......"
            ],
            [
                "Montserrat",
                [
                    "america",
                    "carribean"
                ],
                "ms",
                "1664"
            ],
            [
                "Niue",
                [
                    "asia"
                ],
                "nu",
                "683"
            ],
            [
                "Norfolk Island",
                [
                    "oceania"
                ],
                "nf",
                "672"
            ],
            [
                "Northern Mariana Islands",
                [
                    "oceania"
                ],
                "mp",
                "1670"
            ],
            [
                "Saint Barth\xe9lemy",
                [
                    "america",
                    "carribean"
                ],
                "bl",
                "590",
                "",
                1
            ],
            [
                "Saint Helena",
                [
                    "africa"
                ],
                "sh",
                "290"
            ],
            [
                "Saint Martin",
                [
                    "america",
                    "carribean"
                ],
                "mf",
                "590",
                "",
                2
            ],
            [
                "Saint Pierre and Miquelon",
                [
                    "america",
                    "north-america"
                ],
                "pm",
                "508"
            ],
            [
                "Sint Maarten",
                [
                    "america",
                    "carribean"
                ],
                "sx",
                "1721"
            ],
            [
                "Tokelau",
                [
                    "oceania"
                ],
                "tk",
                "690"
            ],
            [
                "Turks and Caicos Islands",
                [
                    "america",
                    "carribean"
                ],
                "tc",
                "1649"
            ],
            [
                "U.S. Virgin Islands",
                [
                    "america",
                    "carribean"
                ],
                "vi",
                "1340"
            ],
            [
                "Wallis and Futuna",
                [
                    "oceania"
                ],
                "wf",
                "681"
            ]
        ];
        function T(e, t, r, n, a) {
            return !r || a ? e + "".padEnd(t.length, ".") + " " + n : e + "".padEnd(t.length, ".") + " " + r;
        }
        function A(e, t, r, a, i, u) {
            var c, s, l = [];
            return s = !0 === t, [
                (c = []).concat.apply(c, o(e.map(function(e) {
                    var o = {
                        name: e[0],
                        regions: e[1],
                        iso2: e[2],
                        countryCode: e[3],
                        dialCode: e[3],
                        format: T(r, e[3], e[4], a, i),
                        priority: e[5] || 0
                    }, u = [];
                    return e[6] && e[6].map(function(t) {
                        var r = function(e) {
                            for(var t = 1; t < arguments.length; t++){
                                var r = null != arguments[t] ? arguments[t] : {}, a = Object.keys(r);
                                "function" == typeof Object.getOwnPropertySymbols && (a = a.concat(Object.getOwnPropertySymbols(r).filter(function(e) {
                                    return Object.getOwnPropertyDescriptor(r, e).enumerable;
                                }))), a.forEach(function(t) {
                                    n(e, t, r[t]);
                                });
                            }
                            return e;
                        }({}, o);
                        r.dialCode = e[3] + t, r.isAreaCode = !0, r.areaCodeLength = t.length, s && (r.hasAreaCodes = !0), u.push(r);
                    }), u.length > 0 ? (o.mainCode = !0, s || "Array" === t.constructor.name && t.includes(e[2]) ? (o.hasAreaCodes = !0, [
                        o
                    ].concat(u)) : (l = l.concat(u), [
                        o
                    ])) : [
                        o
                    ];
                }))),
                l
            ];
        }
        function I(e, t, r, n) {
            if (null !== r) {
                var a = Object.keys(r), o = Object.values(r);
                a.forEach(function(r, a) {
                    if (n) return e.push([
                        r,
                        o[a]
                    ]);
                    var i = e.findIndex(function(e) {
                        return e[0] === r;
                    });
                    if (-1 === i) {
                        var u = [
                            r
                        ];
                        u[t] = o[a], e.push(u);
                    } else e[i][t] = o[a];
                });
            }
        }
        function D(e, t) {
            return 0 === t.length ? e : e.map(function(e) {
                var r = t.findIndex(function(t) {
                    return t[0] === e[2];
                });
                if (-1 === r) return e;
                var n = t[r];
                return n[1] && (e[4] = n[1]), n[3] && (e[5] = n[3]), n[2] && (e[6] = n[2]), e;
            });
        }
        var P = function e(t, r, n, a, i, u, s, l, f, d, p, h, m, y, b) {
            c(this, e), this.filterRegions = function(e, t) {
                if ("string" == typeof e) {
                    var r = e;
                    return t.filter(function(e) {
                        return e.regions.some(function(e) {
                            return e === r;
                        });
                    });
                }
                return t.filter(function(t) {
                    return e.map(function(e) {
                        return t.regions.some(function(t) {
                            return t === e;
                        });
                    }).some(function(e) {
                        return e;
                    });
                });
            }, this.sortTerritories = function(e, t) {
                var r = [].concat(o(e), o(t));
                return r.sort(function(e, t) {
                    return e.name < t.name ? -1 : e.name > t.name ? 1 : 0;
                }), r;
            }, this.getFilteredCountryList = function(e, t, r) {
                return 0 === e.length ? t : r ? e.map(function(e) {
                    var r = t.find(function(t) {
                        return t.iso2 === e;
                    });
                    if (r) return r;
                }).filter(function(e) {
                    return e;
                }) : t.filter(function(t) {
                    return e.some(function(e) {
                        return e === t.iso2;
                    });
                });
            }, this.localizeCountries = function(e, t, r) {
                for(var n = 0; n < e.length; n++)void 0 !== t[e[n].iso2] ? e[n].localName = t[e[n].iso2] : void 0 !== t[e[n].name] && (e[n].localName = t[e[n].name]);
                return r || e.sort(function(e, t) {
                    return e.localName < t.localName ? -1 : e.localName > t.localName ? 1 : 0;
                }), e;
            }, this.getCustomAreas = function(e, t) {
                for(var r = [], n = 0; n < t.length; n++){
                    var a = JSON.parse(JSON.stringify(e));
                    a.dialCode += t[n], r.push(a);
                }
                return r;
            }, this.excludeCountries = function(e, t) {
                return 0 === t.length ? e : e.filter(function(e) {
                    return !t.includes(e.iso2);
                });
            };
            var g = function(e, t, r) {
                var n = [];
                return I(n, 1, e, !0), I(n, 3, t), I(n, 2, r), n;
            }(l, f, d), v = D(JSON.parse(JSON.stringify(E)), g), C = D(JSON.parse(JSON.stringify(k)), g), _ = O(A(v, t, h, m, y), 2), w = _[0], S = _[1];
            if (r) {
                var j = O(A(C, t, h, m, y), 2), x = j[0];
                j[1];
                w = this.sortTerritories(x, w);
            }
            n && (w = this.filterRegions(n, w)), this.onlyCountries = this.localizeCountries(this.excludeCountries(this.getFilteredCountryList(a, w, s.includes("onlyCountries")), u), p, s.includes("onlyCountries")), this.preferredCountries = 0 === i.length ? [] : this.localizeCountries(this.getFilteredCountryList(i, w, s.includes("preferredCountries")), p, s.includes("preferredCountries")), this.hiddenAreaCodes = this.excludeCountries(this.getFilteredCountryList(a, S), u);
        }, F = function(e) {
            function t(e) {
                var r;
                c(this, t), (r = function(e, t) {
                    return !t || "object" !== f(t) && "function" != typeof t ? d(e) : t;
                }(this, p(t).call(this, e))).getProbableCandidate = C()(function(e) {
                    return e && 0 !== e.length ? r.state.onlyCountries.filter(function(t) {
                        return j()(t.name.toLowerCase(), e.toLowerCase());
                    }, d(d(r)))[0] : null;
                }), r.guessSelectedCountry = C()(function(e, t, n, a) {
                    var o;
                    if (!1 === r.props.enableAreaCodes && (a.some(function(t) {
                        if (j()(e, t.dialCode)) return n.some(function(e) {
                            if (t.iso2 === e.iso2 && e.mainCode) return o = e, !0;
                        }), !0;
                    }), o)) return o;
                    var i = n.find(function(e) {
                        return e.iso2 == t;
                    });
                    if ("" === e.trim()) return i;
                    var u = n.reduce(function(t, r) {
                        if (j()(e, r.dialCode)) {
                            if (r.dialCode.length > t.dialCode.length) return r;
                            if (r.dialCode.length === t.dialCode.length && r.priority < t.priority) return r;
                        }
                        return t;
                    }, {
                        dialCode: "",
                        priority: 10001
                    }, d(d(r)));
                    return u.name ? u : i;
                }), r.updateCountry = function(e) {
                    var t, n = r.state.onlyCountries;
                    (t = e.indexOf(0) >= "0" && e.indexOf(0) <= "9" ? n.find(function(t) {
                        return t.dialCode == +e;
                    }) : n.find(function(t) {
                        return t.iso2 == e;
                    })) && t.dialCode && r.setState({
                        selectedCountry: t,
                        formattedNumber: r.props.disableCountryCode ? "" : r.formatNumber(t.dialCode, t)
                    });
                }, r.scrollTo = function(e, t) {
                    if (e) {
                        var n = r.dropdownRef;
                        if (n && document.body) {
                            var a = n.offsetHeight, o = n.getBoundingClientRect().top + document.body.scrollTop, i = o + a, u = e, c = u.getBoundingClientRect(), s = u.offsetHeight, l = c.top + document.body.scrollTop, f = l + s, d = l - o + n.scrollTop, p = a / 2 - s / 2;
                            if (r.props.enableSearch ? l < o + 32 : l < o) t && (d -= p), n.scrollTop = d;
                            else if (f > i) {
                                t && (d += p);
                                var h = a - s;
                                n.scrollTop = d - h;
                            }
                        }
                    }
                }, r.scrollToTop = function() {
                    var e = r.dropdownRef;
                    e && document.body && (e.scrollTop = 0);
                }, r.formatNumber = function(e, t) {
                    if (!t) return e;
                    var n, o = t.format, c = r.props, s = c.disableCountryCode, l = c.enableAreaCodeStretch, f = c.enableLongNumbers, d = c.autoFormat;
                    if (s ? ((n = o.split(" ")).shift(), n = n.join(" ")) : l && t.isAreaCode ? ((n = o.split(" "))[1] = n[1].replace(/\.+/, "".padEnd(t.areaCodeLength, ".")), n = n.join(" ")) : n = o, !e || 0 === e.length) return s ? "" : r.props.prefix;
                    if (e && e.length < 2 || !n || !d) return s ? e : r.props.prefix + e;
                    var p, h = w()(n, function(e, t) {
                        if (0 === e.remainingText.length) return e;
                        if ("." !== t) return {
                            formattedText: e.formattedText + t,
                            remainingText: e.remainingText
                        };
                        var r, n = i(r = e.remainingText) || a(r) || u(), o = n[0], c = n.slice(1);
                        return {
                            formattedText: e.formattedText + o,
                            remainingText: c
                        };
                    }, {
                        formattedText: "",
                        remainingText: e.split("")
                    });
                    return (p = f ? h.formattedText + h.remainingText.join("") : h.formattedText).includes("(") && !p.includes(")") && (p += ")"), p;
                }, r.cursorToEnd = function() {
                    var e = r.numberInputRef;
                    if (document.activeElement === e) {
                        e.focus();
                        var t = e.value.length;
                        ")" === e.value.charAt(t - 1) && (t -= 1), e.setSelectionRange(t, t);
                    }
                }, r.getElement = function(e) {
                    return r["flag_no_".concat(e)];
                }, r.getCountryData = function() {
                    return r.state.selectedCountry ? {
                        name: r.state.selectedCountry.name || "",
                        dialCode: r.state.selectedCountry.dialCode || "",
                        countryCode: r.state.selectedCountry.iso2 || "",
                        format: r.state.selectedCountry.format || ""
                    } : {};
                }, r.handleFlagDropdownClick = function(e) {
                    if (e.preventDefault(), r.state.showDropdown || !r.props.disabled) {
                        var t = r.state, n = t.preferredCountries, a = t.onlyCountries, o = t.selectedCountry, i = r.concatPreferredCountries(n, a).findIndex(function(e) {
                            return e.dialCode === o.dialCode && e.iso2 === o.iso2;
                        });
                        r.setState({
                            showDropdown: !r.state.showDropdown,
                            highlightCountryIndex: i
                        }, function() {
                            r.state.showDropdown && r.scrollTo(r.getElement(r.state.highlightCountryIndex));
                        });
                    }
                }, r.handleInput = function(e) {
                    var t = e.target.value, n = r.props, a = n.prefix, o = n.onChange, i = r.props.disableCountryCode ? "" : a, u = r.state.selectedCountry, c = r.state.freezeSelection;
                    if (!r.props.countryCodeEditable) {
                        var s = a + (u.hasAreaCodes ? r.state.onlyCountries.find(function(e) {
                            return e.iso2 === u.iso2 && e.mainCode;
                        }).dialCode : u.dialCode);
                        if (t.slice(0, s.length) !== s) return;
                    }
                    if (t === a) return o && o("", r.getCountryData(), e, ""), r.setState({
                        formattedNumber: ""
                    });
                    if (t.replace(/\D/g, "").length > 15) {
                        if (!1 === r.props.enableLongNumbers) return;
                        if ("number" == typeof r.props.enableLongNumbers && t.replace(/\D/g, "").length > r.props.enableLongNumbers) return;
                    }
                    if (t !== r.state.formattedNumber) {
                        e.preventDefault ? e.preventDefault() : e.returnValue = !1;
                        var l = r.props.country, f = r.state, d = f.onlyCountries, p = f.selectedCountry, h = f.hiddenAreaCodes;
                        if (o && e.persist(), t.length > 0) {
                            var m = t.replace(/\D/g, "");
                            (!r.state.freezeSelection || p && p.dialCode.length > m.length) && (u = r.props.disableCountryGuess ? p : r.guessSelectedCountry(m.substring(0, 6), l, d, h) || p, c = !1), i = r.formatNumber(m, u), u = u.dialCode ? u : p;
                        }
                        var y = e.target.selectionStart, b = e.target.selectionStart, g = r.state.formattedNumber, v = i.length - g.length;
                        r.setState({
                            formattedNumber: i,
                            freezeSelection: c,
                            selectedCountry: u
                        }, function() {
                            v > 0 && (b -= v), ")" == i.charAt(i.length - 1) ? r.numberInputRef.setSelectionRange(i.length - 1, i.length - 1) : b > 0 && g.length >= i.length ? r.numberInputRef.setSelectionRange(b, b) : y < g.length && r.numberInputRef.setSelectionRange(y, y), o && o(i.replace(/[^0-9]+/g, ""), r.getCountryData(), e, i);
                        });
                    }
                }, r.handleInputClick = function(e) {
                    r.setState({
                        showDropdown: !1
                    }), r.props.onClick && r.props.onClick(e, r.getCountryData());
                }, r.handleDoubleClick = function(e) {
                    var t = e.target.value.length;
                    e.target.setSelectionRange(0, t);
                }, r.handleFlagItemClick = function(e, t) {
                    var n = r.state.selectedCountry, a = r.state.onlyCountries.find(function(t) {
                        return t == e;
                    });
                    if (a) {
                        var o = r.state.formattedNumber.replace(" ", "").replace("(", "").replace(")", "").replace("-", ""), i = o.length > 1 ? o.replace(n.dialCode, a.dialCode) : a.dialCode, u = r.formatNumber(i.replace(/\D/g, ""), a);
                        r.setState({
                            showDropdown: !1,
                            selectedCountry: a,
                            freezeSelection: !0,
                            formattedNumber: u,
                            searchValue: ""
                        }, function() {
                            r.cursorToEnd(), r.props.onChange && r.props.onChange(u.replace(/[^0-9]+/g, ""), r.getCountryData(), t, u), r.props.onCountryChange && r.props.onCountryChange(a);
                        });
                    }
                }, r.handleInputFocus = function(e) {
                    r.setState({
                        isInputActive: !0
                    }), r.numberInputRef && r.numberInputRef.value === r.props.prefix && r.state.selectedCountry && !r.props.disableCountryCode && r.setState({
                        formattedNumber: r.props.prefix + r.state.selectedCountry.dialCode
                    }, function() {
                        r.props.jumpCursorToEnd && setTimeout(r.cursorToEnd, 0);
                    }), r.setState({
                        placeholder: ""
                    }), r.props.onFocus && r.props.onFocus(e, r.getCountryData()), r.props.jumpCursorToEnd && setTimeout(r.cursorToEnd, 0);
                }, r.handleInputBlur = function(e) {
                    r.setState({
                        isInputActive: !1
                    }), e.target.value || r.setState({
                        placeholder: r.props.placeholder
                    }), r.props.onBlur && r.props.onBlur(e, r.getCountryData());
                }, r.handleInputCopy = function(e) {
                    if (r.props.copyNumbersOnly) {
                        var t = window.getSelection().toString().replace(/[^0-9]+/g, "");
                        e.clipboardData.setData("text/plain", t), e.preventDefault();
                    }
                }, r.getHighlightCountryIndex = function(e) {
                    var t = r.state.highlightCountryIndex + e;
                    return t < 0 || t >= r.state.onlyCountries.length + r.state.preferredCountries.length ? t - e : r.props.enableSearch && t > r.getSearchFilteredCountries().length ? 0 : t;
                }, r.searchCountry = function() {
                    var e = r.getProbableCandidate(r.state.queryString) || r.state.onlyCountries[0], t = r.state.onlyCountries.findIndex(function(t) {
                        return t == e;
                    }) + r.state.preferredCountries.length;
                    r.scrollTo(r.getElement(t), !0), r.setState({
                        queryString: "",
                        highlightCountryIndex: t
                    });
                }, r.handleKeydown = function(e) {
                    var t = r.props.keys, n = e.target.className;
                    if (n.includes("selected-flag") && e.which === t.ENTER && !r.state.showDropdown) return r.handleFlagDropdownClick(e);
                    if (n.includes("form-control") && (e.which === t.ENTER || e.which === t.ESC)) return e.target.blur();
                    if (r.state.showDropdown && !r.props.disabled && (!n.includes("search-box") || e.which === t.UP || e.which === t.DOWN || e.which === t.ENTER || e.which === t.ESC && "" === e.target.value)) {
                        e.preventDefault ? e.preventDefault() : e.returnValue = !1;
                        var a = function(e) {
                            r.setState({
                                highlightCountryIndex: r.getHighlightCountryIndex(e)
                            }, function() {
                                r.scrollTo(r.getElement(r.state.highlightCountryIndex), !0);
                            });
                        };
                        switch(e.which){
                            case t.DOWN:
                                a(1);
                                break;
                            case t.UP:
                                a(-1);
                                break;
                            case t.ENTER:
                                r.props.enableSearch ? r.handleFlagItemClick(r.getSearchFilteredCountries()[r.state.highlightCountryIndex] || r.getSearchFilteredCountries()[0], e) : r.handleFlagItemClick([].concat(o(r.state.preferredCountries), o(r.state.onlyCountries))[r.state.highlightCountryIndex], e);
                                break;
                            case t.ESC:
                            case t.TAB:
                                r.setState({
                                    showDropdown: !1
                                }, r.cursorToEnd);
                                break;
                            default:
                                (e.which >= t.A && e.which <= t.Z || e.which === t.SPACE) && r.setState({
                                    queryString: r.state.queryString + String.fromCharCode(e.which)
                                }, r.state.debouncedQueryStingSearcher);
                        }
                    }
                }, r.handleInputKeyDown = function(e) {
                    var t = r.props, n = t.keys, a = t.onEnterKeyPress, o = t.onKeyDown;
                    e.which === n.ENTER && a && a(e), o && o(e);
                }, r.handleClickOutside = function(e) {
                    r.dropdownRef && !r.dropdownContainerRef.contains(e.target) && r.state.showDropdown && r.setState({
                        showDropdown: !1
                    });
                }, r.handleSearchChange = function(e) {
                    var t = e.currentTarget.value, n = r.state, a = n.preferredCountries, o = n.selectedCountry, i = 0;
                    if ("" === t && o) {
                        var u = r.state.onlyCountries;
                        i = r.concatPreferredCountries(a, u).findIndex(function(e) {
                            return e == o;
                        }), setTimeout(function() {
                            return r.scrollTo(r.getElement(i));
                        }, 100);
                    }
                    r.setState({
                        searchValue: t,
                        highlightCountryIndex: i
                    });
                }, r.concatPreferredCountries = function(e, t) {
                    return e.length > 0 ? o(new Set(e.concat(t))) : t;
                }, r.getDropdownCountryName = function(e) {
                    return e.localName || e.name;
                }, r.getSearchFilteredCountries = function() {
                    var e = r.state, t = e.preferredCountries, n = e.onlyCountries, a = e.searchValue, i = r.props.enableSearch, u = r.concatPreferredCountries(t, n), c = a.trim().toLowerCase().replace("+", "");
                    if (i && c) {
                        if (/^\d+$/.test(c)) return u.filter(function(e) {
                            var t = e.dialCode;
                            return [
                                "".concat(t)
                            ].some(function(e) {
                                return e.toLowerCase().includes(c);
                            });
                        });
                        var s = u.filter(function(e) {
                            var t = e.iso2;
                            return [
                                "".concat(t)
                            ].some(function(e) {
                                return e.toLowerCase().includes(c);
                            });
                        }), l = u.filter(function(e) {
                            var t = e.name, r = e.localName;
                            e.iso2;
                            return [
                                "".concat(t),
                                "".concat(r || "")
                            ].some(function(e) {
                                return e.toLowerCase().includes(c);
                            });
                        });
                        return r.scrollToTop(), o(new Set([].concat(s, l))).filter(function(e) {
                            return r.props.hideAreaCodes && !e.isAreaCode;
                        });
                    }
                    return u.filter(function(e) {
                        return r.props.hideAreaCodes && !e.isAreaCode;
                    });
                }, r.getCountryDropdownList = function() {
                    var e = r.state, t = e.preferredCountries, a = e.highlightCountryIndex, o = e.showDropdown, i = e.searchValue, u = r.props, c = u.disableDropdown, s = u.prefix, l = r.props, f = l.enableSearch, d = l.searchNotFound, p = l.disableSearchIcon, h = l.searchClass, m = l.searchStyle, b = l.searchPlaceholder, g = l.autocompleteSearch, v = r.getSearchFilteredCountries().map(function(e, t) {
                        var n = a === t, o = N()({
                            country: !0,
                            preferred: "us" === e.iso2 || "gb" === e.iso2,
                            active: "us" === e.iso2,
                            highlight: n
                        }), i = "flag ".concat(e.iso2);
                        return y.a.createElement("li", Object.assign({
                            ref: function(e) {
                                return r["flag_no_".concat(t)] = e;
                            },
                            key: "flag_no_".concat(t),
                            "data-flag-key": "flag_no_".concat(t),
                            className: o,
                            "data-dial-code": "1",
                            tabIndex: c ? "-1" : "0",
                            "data-country-code": e.iso2,
                            onClick: function(t) {
                                return r.handleFlagItemClick(e, t);
                            },
                            role: "option"
                        }, n ? {
                            "aria-selected": !0
                        } : {}), y.a.createElement("div", {
                            className: i
                        }), y.a.createElement("span", {
                            className: "country-name"
                        }, r.getDropdownCountryName(e)), y.a.createElement("span", {
                            className: "dial-code"
                        }, e.format ? r.formatNumber(e.dialCode, e) : s + e.dialCode));
                    }), C = y.a.createElement("li", {
                        key: "dashes",
                        className: "divider"
                    });
                    t.length > 0 && (!f || f && !i.trim()) && v.splice(t.length, 0, C);
                    var _ = N()(n({
                        "country-list": !0,
                        hide: !o
                    }, r.props.dropdownClass, !0));
                    return y.a.createElement("ul", {
                        ref: function(e) {
                            return !f && e && e.focus(), r.dropdownRef = e;
                        },
                        className: _,
                        style: r.props.dropdownStyle,
                        role: "listbox",
                        tabIndex: "0"
                    }, f && y.a.createElement("li", {
                        className: N()(n({
                            search: !0
                        }, h, h))
                    }, !p && y.a.createElement("span", {
                        className: N()(n({
                            "search-emoji": !0
                        }, "".concat(h, "-emoji"), h)),
                        role: "img",
                        "aria-label": "Magnifying glass"
                    }, "\uD83D\uDD0E"), y.a.createElement("input", {
                        className: N()(n({
                            "search-box": !0
                        }, "".concat(h, "-box"), h)),
                        style: m,
                        type: "search",
                        placeholder: b,
                        autoFocus: !0,
                        autoComplete: g ? "on" : "off",
                        value: i,
                        onChange: r.handleSearchChange
                    })), v.length > 0 ? v : y.a.createElement("li", {
                        className: "no-entries-message"
                    }, y.a.createElement("span", null, d)));
                };
                var s, l = new P(e.enableAreaCodes, e.enableTerritories, e.regions, e.onlyCountries, e.preferredCountries, e.excludeCountries, e.preserveOrder, e.masks, e.priority, e.areaCodes, e.localization, e.prefix, e.defaultMask, e.alwaysDefaultMask, e.hideAreaCodes), h = l.onlyCountries, m = l.preferredCountries, b = l.hiddenAreaCodes, v = e.value ? e.value.replace(/\D/g, "") : "";
                s = e.disableInitialCountryGuess ? 0 : v.length > 1 ? r.guessSelectedCountry(v.substring(0, 6), e.country, h, b) || 0 : e.country && h.find(function(t) {
                    return t.iso2 == e.country;
                }) || 0;
                var _, S = v.length < 2 && s && !j()(v, s.dialCode) ? s.dialCode : "";
                _ = "" === v && 0 === s ? "" : r.formatNumber((e.disableCountryCode ? "" : S) + v, s.name ? s : void 0);
                var x = h.findIndex(function(e) {
                    return e == s;
                });
                return r.state = {
                    showDropdown: e.showDropdown,
                    formattedNumber: _,
                    onlyCountries: h,
                    preferredCountries: m,
                    hiddenAreaCodes: b,
                    selectedCountry: s,
                    highlightCountryIndex: x,
                    queryString: "",
                    freezeSelection: !1,
                    debouncedQueryStingSearcher: g()(r.searchCountry, 250),
                    searchValue: "",
                    isInputActive: !1
                }, r;
            }
            var r, l, m;
            return function(e, t) {
                if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
                e.prototype = Object.create(t && t.prototype, {
                    constructor: {
                        value: e,
                        writable: !0,
                        configurable: !0
                    }
                }), t && h(e, t);
            }(t, e), r = t, l = [
                {
                    key: "componentDidMount",
                    value: function() {
                        document.addEventListener && this.props.enableClickOutside && document.addEventListener("mousedown", this.handleClickOutside), this.props.onMount && this.props.onMount(this.state.formattedNumber.replace(/[^0-9]+/g, ""), this.getCountryData(), this.state.formattedNumber);
                    }
                },
                {
                    key: "componentWillUnmount",
                    value: function() {
                        document.removeEventListener && this.props.enableClickOutside && document.removeEventListener("mousedown", this.handleClickOutside);
                    }
                },
                {
                    key: "componentDidUpdate",
                    value: function(e, t, r) {
                        e.country !== this.props.country ? this.updateCountry(this.props.country) : e.value !== this.props.value && this.updateFormattedNumber(this.props.value);
                    }
                },
                {
                    key: "updateFormattedNumber",
                    value: function(e) {
                        if (null === e) return this.setState({
                            selectedCountry: 0,
                            formattedNumber: ""
                        });
                        var t = this.state, r = t.onlyCountries, n = t.selectedCountry, a = t.hiddenAreaCodes, o = this.props, i = o.country, u = o.prefix;
                        if ("" === e) return this.setState({
                            selectedCountry: n,
                            formattedNumber: ""
                        });
                        var c, s, l = e.replace(/\D/g, "");
                        if (n && j()(e, u + n.dialCode)) s = this.formatNumber(l, n), this.setState({
                            formattedNumber: s
                        });
                        else {
                            var f = (c = this.props.disableCountryGuess ? n : this.guessSelectedCountry(l.substring(0, 6), i, r, a) || n) && j()(l, u + c.dialCode) ? c.dialCode : "";
                            s = this.formatNumber((this.props.disableCountryCode ? "" : f) + l, c || void 0), this.setState({
                                selectedCountry: c,
                                formattedNumber: s
                            });
                        }
                    }
                },
                {
                    key: "render",
                    value: function() {
                        var e, t, r, a = this, o = this.state, i = o.onlyCountries, u = o.selectedCountry, c = o.showDropdown, s = o.formattedNumber, l = o.hiddenAreaCodes, f = this.props, d = f.disableDropdown, p = f.renderStringAsFlag, h = f.isValid, m = f.defaultErrorMessage, b = f.specialLabel;
                        if ("boolean" == typeof h) t = h;
                        else {
                            var g = h(s.replace(/\D/g, ""), u, i, l);
                            "boolean" == typeof g ? !1 === (t = g) && (r = m) : (t = !1, r = g);
                        }
                        var v = N()((n(e = {}, this.props.containerClass, !0), n(e, "react-tel-input", !0), e)), C = N()({
                            arrow: !0,
                            up: c
                        }), _ = N()(n({
                            "form-control": !0,
                            "invalid-number": !t,
                            open: c
                        }, this.props.inputClass, !0)), w = N()({
                            "selected-flag": !0,
                            open: c
                        }), S = N()(n({
                            "flag-dropdown": !0,
                            "invalid-number": !t,
                            open: c
                        }, this.props.buttonClass, !0)), j = "flag ".concat(u && u.iso2), x = !this.props.alwaysShowPlaceholderOnEmptyValue || this.props.value && this.props.value !== this.state.selectedCountry.countryCode || this.state.isInputActive ? s : "";
                        return y.a.createElement("div", {
                            className: "".concat(v, " ").concat(this.props.className),
                            style: this.props.style || this.props.containerStyle,
                            onKeyDown: this.handleKeydown
                        }, b && y.a.createElement("div", {
                            className: "special-label"
                        }, b), r && y.a.createElement("div", {
                            className: "invalid-number-message"
                        }, r), y.a.createElement("input", Object.assign({
                            className: _,
                            style: this.props.inputStyle,
                            onChange: this.handleInput,
                            onClick: this.handleInputClick,
                            onDoubleClick: this.handleDoubleClick,
                            onFocus: this.handleInputFocus,
                            onBlur: this.handleInputBlur,
                            onCopy: this.handleInputCopy,
                            value: x,
                            onKeyDown: this.handleInputKeyDown,
                            placeholder: this.props.placeholder,
                            disabled: this.props.disabled,
                            type: "tel"
                        }, this.props.inputProps, {
                            ref: function(e) {
                                a.numberInputRef = e, "function" == typeof a.props.inputProps.ref ? a.props.inputProps.ref(e) : "object" == typeof a.props.inputProps.ref && (a.props.inputProps.ref.current = e);
                            }
                        })), y.a.createElement("div", {
                            className: S,
                            style: this.props.buttonStyle,
                            ref: function(e) {
                                return a.dropdownContainerRef = e;
                            }
                        }, p ? y.a.createElement("div", {
                            className: w
                        }, p) : y.a.createElement("div", {
                            onClick: d ? void 0 : this.handleFlagDropdownClick,
                            className: w,
                            title: u ? "".concat(u.localName || u.name, ": + ").concat(u.dialCode) : "",
                            tabIndex: d ? "-1" : "0",
                            role: "button",
                            "aria-haspopup": "listbox",
                            "aria-expanded": !!c || void 0
                        }, y.a.createElement("div", {
                            className: j
                        }, !d && y.a.createElement("div", {
                            className: C
                        }))), c && this.getCountryDropdownList()));
                    }
                }
            ], s(r.prototype, l), m && s(r, m), t;
        }(y.a.Component);
        F.defaultProps = {
            country: "",
            value: "",
            onlyCountries: [],
            preferredCountries: [],
            excludeCountries: [],
            placeholder: "1 (702) 123-4567",
            searchPlaceholder: "search",
            searchNotFound: "No entries to show",
            flagsImagePath: "./flags.png",
            disabled: !1,
            containerStyle: {},
            inputStyle: {},
            buttonStyle: {},
            dropdownStyle: {},
            searchStyle: {},
            containerClass: "",
            inputClass: "",
            buttonClass: "",
            dropdownClass: "",
            searchClass: "",
            className: "",
            autoFormat: !0,
            enableAreaCodes: !1,
            enableTerritories: !1,
            disableCountryCode: !1,
            disableDropdown: !1,
            enableLongNumbers: !1,
            countryCodeEditable: !0,
            enableSearch: !1,
            disableSearchIcon: !1,
            disableInitialCountryGuess: !1,
            disableCountryGuess: !1,
            regions: "",
            inputProps: {},
            localization: {},
            masks: null,
            priority: null,
            areaCodes: null,
            preserveOrder: [],
            defaultMask: "... ... ... ... ..",
            alwaysDefaultMask: !1,
            prefix: "+",
            copyNumbersOnly: !0,
            renderStringAsFlag: "",
            autocompleteSearch: !1,
            jumpCursorToEnd: !0,
            enableAreaCodeStretch: !1,
            enableClickOutside: !0,
            showDropdown: !1,
            hideAreaCodes: !1,
            alwaysShowPlaceholderOnEmptyValue: !1,
            isValid: !0,
            defaultErrorMessage: "",
            specialLabel: "Phone",
            onEnterKeyPress: null,
            keys: {
                UP: 38,
                DOWN: 40,
                RIGHT: 39,
                LEFT: 37,
                ENTER: 13,
                ESC: 27,
                PLUS: 43,
                A: 65,
                Z: 90,
                SPACE: 32,
                TAB: 9
            }
        };
        t.default = F;
    }
]);




const $3fc4af5be640bf7d$var$currentMarketCode = (0, $73ccb33f5de6f5aa$export$daa49e131b652e5b).getCurrentMarketCode();
const $3fc4af5be640bf7d$var$EMIRATES_CODE = "ae";
const $3fc4af5be640bf7d$var$enabledCodes = Object.values((0, $73ccb33f5de6f5aa$export$5ee3c680189caa8f));
const $3fc4af5be640bf7d$export$e506a1d27d1eaa20 = {
    enabledCountries: $3fc4af5be640bf7d$var$enabledCodes,
    defaultCountry: $3fc4af5be640bf7d$var$currentMarketCode ? (0, $73ccb33f5de6f5aa$export$5ee3c680189caa8f)[$3fc4af5be640bf7d$var$currentMarketCode] : $3fc4af5be640bf7d$var$EMIRATES_CODE,
    defaultMask: "... ... ... ... .."
};
const $3fc4af5be640bf7d$export$57dd614efe4dbb6c = {};
$3fc4af5be640bf7d$export$e506a1d27d1eaa20.enabledCountries.forEach((enabledCountryCode)=>{
    $3fc4af5be640bf7d$export$57dd614efe4dbb6c[enabledCountryCode] = (0, $c5ed36b134b2d50e$export$847b1abaf17f2c47)[enabledCountryCode].mask ?? $3fc4af5be640bf7d$export$e506a1d27d1eaa20.defaultMask;
});
const $3fc4af5be640bf7d$export$f73c15c1951488b6 = {};
$3fc4af5be640bf7d$export$e506a1d27d1eaa20.enabledCountries.forEach((enabledCountryCode)=>{
    $3fc4af5be640bf7d$export$f73c15c1951488b6[enabledCountryCode] = (0, $c5ed36b134b2d50e$export$847b1abaf17f2c47)[enabledCountryCode].regionCodes;
});




const $7ded17d344b4400d$export$d9c67ff858089902 = ({ phone: phone, handlePhoneChange: handlePhoneChange, setSelectedCountry: setSelectedCountry })=>{
    const { t: t } = (0, $3765cebd031b52c0$export$9fc83ad70ead8663)();
    const marketCode = (0, $73ccb33f5de6f5aa$export$8707029d024490c9)().iso2Code;
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($fd0172319154660f$exports))), {
        defaultMask: (0, $3fc4af5be640bf7d$export$e506a1d27d1eaa20).defaultMask,
        onMount: (value, data)=>{
            setSelectedCountry(data.countryCode);
        },
        onCountryChange: (country)=>{
            setSelectedCountry(country.iso2);
        },
        alwaysShowPlaceholderOnEmptyValue: true,
        containerClass: "SignUp__phoneContainer",
        inputClass: "SignUp__phone",
        buttonClass: "SignUp__phoneDropdownButton",
        placeholder: t("sign_up.phone"),
        value: phone,
        onChange: handlePhoneChange,
        country: (0, $3fc4af5be640bf7d$export$e506a1d27d1eaa20).defaultCountry,
        countryCodeEditable: false,
        onlyCountries: [
            marketCode
        ],
        enableAreaCodes: true,
        enableAreaCodeStretch: true,
        hideAreaCodes: true,
        masks: (0, $3fc4af5be640bf7d$export$57dd614efe4dbb6c),
        areaCodes: (0, $3fc4af5be640bf7d$export$f73c15c1951488b6),
        disableDropdown: (0, $3fc4af5be640bf7d$export$e506a1d27d1eaa20).enabledCountries.length < 2
    });
};



const $ea14079709b2418c$export$4a5eb409672b4803 = (props)=>{
    const { t: t } = (0, $3765cebd031b52c0$export$9fc83ad70ead8663)();
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        className: "SignUp",
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: "SignUp__topContainer",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                            src: (0, (/*@__PURE__*/$parcel$interopDefault($3279ad32455be7ff$exports))),
                            className: "Login__logo"
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $96de59b951af76cc$export$eeb15ad990050873), {
                            redirectPath: "sign-up"
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $660b2ca422e0e2ae$export$1ff3c3f08ae963c0).Vertical, {
                    height: 45
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                    className: "SignUp__title",
                    children: t("sign_up.title")
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $660b2ca422e0e2ae$export$1ff3c3f08ae963c0).Vertical, {
                    height: 9
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                    className: "SignUp__subtitle",
                    children: t("sign_up.subtitle")
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $660b2ca422e0e2ae$export$1ff3c3f08ae963c0).Vertical, {
                    height: 16
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: "SignUp__row",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $1067a74e1c3483e2$export$f551688fc98f2e09), {
                            errors: props.firstNameErrors,
                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4e342c5928158118$export$f5b8910cec6cf069), {
                                label: t("sign_up.first_name"),
                                value: props.firstName,
                                handleChange: props.handleFirstNameChange
                            })
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $660b2ca422e0e2ae$export$1ff3c3f08ae963c0).Horizontal, {
                            width: 7
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $1067a74e1c3483e2$export$f551688fc98f2e09), {
                            errors: props.lastNameErrors,
                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4e342c5928158118$export$f5b8910cec6cf069), {
                                label: t("sign_up.last_name"),
                                value: props.lastName,
                                handleChange: props.handleLastNameChange
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $660b2ca422e0e2ae$export$1ff3c3f08ae963c0).Vertical, {
                    height: 16
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $1067a74e1c3483e2$export$f551688fc98f2e09), {
                    errors: props.companyNameErrors,
                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4e342c5928158118$export$f5b8910cec6cf069), {
                        label: t("sign_up.company_name_optional"),
                        value: props.companyName,
                        handleChange: props.handleCompanyNameChange
                    })
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $660b2ca422e0e2ae$export$1ff3c3f08ae963c0).Vertical, {
                    height: 16
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $1067a74e1c3483e2$export$f551688fc98f2e09), {
                    errors: props.phoneErrors,
                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7ded17d344b4400d$export$d9c67ff858089902), {
                        phone: props.phone,
                        handlePhoneChange: props.handlePhoneNameChange,
                        setSelectedCountry: props.setSelectedCountry
                    })
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $660b2ca422e0e2ae$export$1ff3c3f08ae963c0).Vertical, {
                    height: 16
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $1067a74e1c3483e2$export$f551688fc98f2e09), {
                    errors: props.emailErrors,
                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4e342c5928158118$export$f5b8910cec6cf069), {
                        label: t("sign_up.email"),
                        value: props.email,
                        handleChange: props.handleEmailNameChange
                    })
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $660b2ca422e0e2ae$export$1ff3c3f08ae963c0).Vertical, {
                    height: 16
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $1067a74e1c3483e2$export$f551688fc98f2e09), {
                    errors: props.passwordErrors,
                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $621096805b6f645e$export$b28585a458fee016), {
                        label: t("sign_up.password"),
                        value: props.password,
                        autoComplete: "new-password",
                        handleChange: props.handlePasswordChange,
                        showHints: true
                    })
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $660b2ca422e0e2ae$export$1ff3c3f08ae963c0).Vertical, {
                    height: 16
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $1067a74e1c3483e2$export$f551688fc98f2e09), {
                    errors: props.allow_marketing_emailsErrors,
                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "SignUp__row",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                type: "checkbox",
                                onClick: props.handleAllowEmailsToggle,
                                checked: props.allow_marketing_emails,
                                className: "SignUp__checkboxContainer__checkbox"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $660b2ca422e0e2ae$export$1ff3c3f08ae963c0).Horizontal, {
                                width: 10
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                className: "SignUp__checkboxContainer__container",
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                    onClick: props.handleAllowEmailsToggle,
                                    className: "SignUp__checkboxContainer__container__label",
                                    children: t("sign_up.agree_to_emails")
                                })
                            })
                        ]
                    })
                }),
                (0, $73ccb33f5de6f5aa$export$8707029d024490c9)().registration.requireConsentAcceptance && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $acw62.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $660b2ca422e0e2ae$export$1ff3c3f08ae963c0).Vertical, {
                            height: 16
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: "SignUp__checkboxContainer",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                    type: "checkbox",
                                    onClick: ()=>props.setIsConsentAccepted(!props.isConsentAccepted),
                                    checked: props.isConsentAccepted,
                                    className: "SignUp__checkboxContainer__checkbox"
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $660b2ca422e0e2ae$export$1ff3c3f08ae963c0).Horizontal, {
                                    width: 10
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                    className: "SignUp__checkboxContainer__container",
                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                        className: "SignUp__checkboxContainer__container__label",
                                        children: "\u039A\u03AC\u03BD\u03BF\u03BD\u03C4\u03B1\u03C2 \u03BA\u03BB\u03B9\u03BA \u03C3\u03C4\u03BF \u03BA\u03BF\u03C5\u03BC\u03C0\u03AF \u03B5\u03B3\u03B3\u03C1\u03B1\u03C6\u03AE\u03C2, \u03C3\u03C5\u03BD\u03B1\u03B9\u03BD\u03B5\u03AF\u03C4\u03B5 \u03C3\u03C4\u03B7 \u03C7\u03C1\u03AE\u03C3\u03B7 \u03C4\u03C9\u03BD \u03C0\u03C1\u03BF\u03C3\u03C9\u03C0\u03B9\u03BA\u03CE\u03BD \u03C3\u03B1\u03C2 \u03B4\u03B5\u03B4\u03BF\u03BC\u03AD\u03BD\u03C9\u03BD \u03B1\u03C0\u03CC \u03C4\u03B7\u03BD \u03B5\u03C4\u03B1\u03B9\u03C1\u03B5\u03AF\u03B1 \u03BC\u03B1\u03C2 \u03BC\u03B5 \u03C3\u03BA\u03BF\u03C0\u03CC \u03C4\u03B7 \u03B4\u03B7\u03BC\u03B9\u03BF\u03C5\u03C1\u03B3\u03AF\u03B1 \u03C4\u03BF\u03C5 \u03BB\u03BF\u03B3\u03B1\u03C1\u03B9\u03B1\u03C3\u03BC\u03BF\u03CD \u03C3\u03B1\u03C2 \u03BA\u03B1\u03B9 \u03C4\u03B7\u03BD \u03C4\u03BF\u03C0\u03BF\u03B8\u03AD\u03C4\u03B7\u03C3\u03B7 \u03C4\u03C9\u03BD \u03C0\u03B1\u03C1\u03B1\u03B3\u03B3\u03B5\u03BB\u03B9\u03CE\u03BD \u03C3\u03B1\u03C2"
                                    })
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $660b2ca422e0e2ae$export$1ff3c3f08ae963c0).Vertical, {
                    height: 27
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $2ab88429e3384d30$export$353f5b6fc5456de1), {
                    disabled: (0, $73ccb33f5de6f5aa$export$8707029d024490c9)().registration.requireConsentAcceptance && !props.isConsentAccepted,
                    title: props.submitting ? t("sign_up.submitting") : t("sign_up.sign_up"),
                    onClick: props.handleSubmitButtonPress,
                    type: "submit",
                    className: "SignUp__button"
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $660b2ca422e0e2ae$export$1ff3c3f08ae963c0).Vertical, {
                    height: 22
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $2ab88429e3384d30$export$353f5b6fc5456de1), {
                    title: t("sign_up.back_to_sign_in"),
                    onClick: props.handleLoginButtonPress,
                    className: "SignUp__backButton"
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $660b2ca422e0e2ae$export$1ff3c3f08ae963c0).Vertical, {
                    height: 40
                })
            ]
        })
    });
};





var $acw62 = parcelRequire("acw62");









var $acw62 = parcelRequire("acw62");






const $554154a452d41ffe$export$97e061281fd13080 = ({ showHints: showHints = false, hidePasswordByDefault: hidePasswordByDefault = false, ...props })=>{
    const [passwordVisible, setPasswordVisible] = (0, $acw62.useState)(!hidePasswordByDefault);
    const { t: t } = (0, $3765cebd031b52c0$export$9fc83ad70ead8663)();
    const passwordValue = props.value ?? "";
    const has6Chars = passwordValue.length >= 6;
    const hasLowercase = passwordValue.toUpperCase() !== passwordValue;
    const hasUppercase = passwordValue.toLowerCase() !== passwordValue;
    const hasNumber = /\d/.test(passwordValue);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "PasswordInput",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4e342c5928158118$export$f5b8910cec6cf069), {
                type: passwordVisible ? "text" : "password",
                image: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                    onClick: ()=>{
                        setPasswordVisible((prev)=>!prev);
                    },
                    src: passwordVisible ? (0, (/*@__PURE__*/$parcel$interopDefault($ac7a1b4663748f6b$exports))) : (0, (/*@__PURE__*/$parcel$interopDefault($2f83714863fb7e41$exports))),
                    className: "PasswordInput__img"
                }),
                ...props
            }),
            showHints && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "PasswordInput__hints",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: `PasswordInput__hints__item ${has6Chars ? "active" : ""}`,
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                                src: (0, (/*@__PURE__*/$parcel$interopDefault($35795701fc918885$exports))),
                                className: `PasswordInput__hints__item__checkmark ${has6Chars ? "visible" : ""}`
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                className: `PasswordInput__hints__item__label ${has6Chars ? "active" : ""}`,
                                children: t("password.minimumChars")
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: `PasswordInput__hints__item ${hasLowercase ? "active" : ""}`,
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                                src: (0, (/*@__PURE__*/$parcel$interopDefault($35795701fc918885$exports))),
                                className: `PasswordInput__hints__item__checkmark ${hasLowercase ? "visible" : ""}`
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                className: `PasswordInput__hints__item__label ${hasLowercase ? "active" : ""}`,
                                children: t("password.oneLowercase")
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: `PasswordInput__hints__item ${hasNumber ? "active" : ""}`,
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                                src: (0, (/*@__PURE__*/$parcel$interopDefault($35795701fc918885$exports))),
                                className: `PasswordInput__hints__item__checkmark ${hasNumber ? "visible" : ""}`
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                className: `PasswordInput__hints__item__label ${hasNumber ? "active" : ""}`,
                                children: t("password.oneNumber")
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: `PasswordInput__hints__item ${hasUppercase ? "active" : ""}`,
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                                src: (0, (/*@__PURE__*/$parcel$interopDefault($35795701fc918885$exports))),
                                className: `PasswordInput__hints__item__checkmark ${hasUppercase ? "visible" : ""}`
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                className: `PasswordInput__hints__item__label ${hasUppercase ? "active" : ""}`,
                                children: t("password.oneUppercase")
                            })
                        ]
                    })
                ]
            })
        ]
    });
};





const $cb7e2e603b9728da$export$8df5d3f2b9a339e9 = (props)=>{
    const { t: t } = (0, $3765cebd031b52c0$export$9fc83ad70ead8663)();
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        className: "SignUp",
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: "SignUp__topContainer",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                            src: (0, (/*@__PURE__*/$parcel$interopDefault($3279ad32455be7ff$exports))),
                            className: "Login__logo"
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $96de59b951af76cc$export$eeb15ad990050873), {
                            redirectPath: "sign-up"
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $660b2ca422e0e2ae$export$1ff3c3f08ae963c0).Vertical, {
                    height: 45
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                    className: "SignUp__title",
                    children: t("sign_up.title")
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $660b2ca422e0e2ae$export$1ff3c3f08ae963c0).Vertical, {
                    height: 9
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                    className: "SignUp__subtitle",
                    children: t("sign_up.subtitle")
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $660b2ca422e0e2ae$export$1ff3c3f08ae963c0).Vertical, {
                    height: 16
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: "SignUp__row",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $1067a74e1c3483e2$export$f551688fc98f2e09), {
                            errors: props.firstNameErrors,
                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4e342c5928158118$export$f5b8910cec6cf069), {
                                label: t("sign_up.first_name"),
                                value: props.firstName,
                                handleChange: props.handleFirstNameChange
                            })
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $660b2ca422e0e2ae$export$1ff3c3f08ae963c0).Horizontal, {
                            width: 7
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $1067a74e1c3483e2$export$f551688fc98f2e09), {
                            errors: props.lastNameErrors,
                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4e342c5928158118$export$f5b8910cec6cf069), {
                                label: t("sign_up.last_name"),
                                value: props.lastName,
                                handleChange: props.handleLastNameChange
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $660b2ca422e0e2ae$export$1ff3c3f08ae963c0).Vertical, {
                    height: 16
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $1067a74e1c3483e2$export$f551688fc98f2e09), {
                    errors: props.companyNameErrors,
                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4e342c5928158118$export$f5b8910cec6cf069), {
                        label: t("sign_up.company_name"),
                        value: props.companyName,
                        handleChange: props.handleCompanyNameChange
                    })
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $660b2ca422e0e2ae$export$1ff3c3f08ae963c0).Vertical, {
                    height: 16
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $1067a74e1c3483e2$export$f551688fc98f2e09), {
                    errors: props.phoneErrors,
                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7ded17d344b4400d$export$d9c67ff858089902), {
                        phone: props.phone,
                        handlePhoneChange: props.handlePhoneNameChange,
                        setSelectedCountry: props.setSelectedCountry
                    })
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $660b2ca422e0e2ae$export$1ff3c3f08ae963c0).Vertical, {
                    height: 16
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $1067a74e1c3483e2$export$f551688fc98f2e09), {
                    errors: props.emailErrors,
                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4e342c5928158118$export$f5b8910cec6cf069), {
                        label: t("sign_up.email"),
                        value: props.email,
                        handleChange: props.handleEmailNameChange
                    })
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $660b2ca422e0e2ae$export$1ff3c3f08ae963c0).Vertical, {
                    height: 16
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $1067a74e1c3483e2$export$f551688fc98f2e09), {
                    errors: props.passwordErrors,
                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $554154a452d41ffe$export$97e061281fd13080), {
                        label: t("sign_up.password"),
                        value: props.password,
                        autoComplete: "new-password",
                        handleChange: props.handlePasswordChange,
                        showHints: true
                    })
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $660b2ca422e0e2ae$export$1ff3c3f08ae963c0).Vertical, {
                    height: 16
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $1067a74e1c3483e2$export$f551688fc98f2e09), {
                    errors: props.allow_marketing_emailsErrors,
                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "SignUp__row",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                type: "checkbox",
                                onClick: props.handleAllowEmailsToggle,
                                checked: props.allow_marketing_emails,
                                className: "SignUp__checkboxContainer__checkbox"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $660b2ca422e0e2ae$export$1ff3c3f08ae963c0).Horizontal, {
                                width: 10
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                className: "SignUp__checkboxContainer__container",
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                    onClick: props.handleAllowEmailsToggle,
                                    className: "SignUp__checkboxContainer__container__label",
                                    children: t("sign_up.agree_to_emails")
                                })
                            })
                        ]
                    })
                }),
                (0, $73ccb33f5de6f5aa$export$8707029d024490c9)().registration.requireConsentAcceptance && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $acw62.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $660b2ca422e0e2ae$export$1ff3c3f08ae963c0).Vertical, {
                            height: 16
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: "SignUp__row",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                    type: "checkbox",
                                    onClick: ()=>props.setIsConsentAccepted(!props.isConsentAccepted),
                                    checked: props.isConsentAccepted,
                                    className: "SignUp__checkboxContainer__checkbox"
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $660b2ca422e0e2ae$export$1ff3c3f08ae963c0).Horizontal, {
                                    width: 10
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                    className: "SignUp__checkboxContainer__container",
                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                        onClick: ()=>props.setIsConsentAccepted(!props.isConsentAccepted),
                                        className: "SignUp__checkboxContainer__container__label",
                                        children: t("sign_up.consent")
                                    })
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $660b2ca422e0e2ae$export$1ff3c3f08ae963c0).Vertical, {
                    height: 27
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $2ab88429e3384d30$export$353f5b6fc5456de1), {
                    disabled: (0, $73ccb33f5de6f5aa$export$8707029d024490c9)().registration.requireConsentAcceptance && !props.isConsentAccepted,
                    title: props.submitting ? t("sign_up.submitting") : t("sign_up.sign_up"),
                    onClick: props.handleSubmitButtonPress,
                    type: "submit",
                    className: "SignUp__button"
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $660b2ca422e0e2ae$export$1ff3c3f08ae963c0).Vertical, {
                    height: 22
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $2ab88429e3384d30$export$353f5b6fc5456de1), {
                    title: t("sign_up.back_to_sign_in"),
                    onClick: props.handleLoginButtonPress,
                    className: "SignUp__backButton"
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $660b2ca422e0e2ae$export$1ff3c3f08ae963c0).Vertical, {
                    height: 40
                })
            ]
        })
    });
};


const $7f8da85ae0126012$var$allowOnlyCorporate = (0, $73ccb33f5de6f5aa$export$8707029d024490c9)().registration.allowOnlyCorporate;
const $7f8da85ae0126012$export$265471dcab9022d3 = (0, $926d262689c0d7db$export$9c9fb46caed06943)($7f8da85ae0126012$var$allowOnlyCorporate ? (0, $cb7e2e603b9728da$export$8df5d3f2b9a339e9) : (0, $ea14079709b2418c$export$4a5eb409672b4803));




var $acw62 = parcelRequire("acw62");




var $7YFi7 = parcelRequire("7YFi7");










const $8f2345bbacf83df9$export$3d3197b723615cc = (0, $aca50e9407ba89c9$export$b6ae1bc530f4c149)(({ email: email })=>{
    const store = (0, $4671947198ddd366$export$6ccbb43953eebf8)();
    const [codeSentAt, setCodeSentAt] = (0, $acw62.useState)(null);
    const [verifyResult, verify] = (0, $4671947198ddd366$export$609860bf8b0084c)(store.data.verifyEmailByCode, {
        filterError: [
            (0, $9ad33fbf770c55a1$export$9696fcf1798e1cb5).ClientError,
            (0, $9ad33fbf770c55a1$export$9696fcf1798e1cb5).NotFound
        ],
        onError: (err)=>{
            if (err.type === (0, $9ad33fbf770c55a1$export$9696fcf1798e1cb5).NotFound) alert("No such code for the user");
            else if (err.type !== (0, $9ad33fbf770c55a1$export$9696fcf1798e1cb5).ClientError) alert(err.data.message);
        },
        onSuccess: ()=>{
            setCodeSentAt(Date.now());
        }
    });
    const [, resendCode] = (0, $4671947198ddd366$export$609860bf8b0084c)(store.data.resendEmailVerification, {
        filterError: [
            (0, $9ad33fbf770c55a1$export$9696fcf1798e1cb5).ClientError,
            (0, $9ad33fbf770c55a1$export$9696fcf1798e1cb5).NotFound,
            (0, $9ad33fbf770c55a1$export$9696fcf1798e1cb5).ServerError
        ],
        onError: (err)=>{
            alert(err.data.message);
        }
    });
    const errors = verifyResult.error?.data.errors;
    const { t: t } = (0, $3765cebd031b52c0$export$9fc83ad70ead8663)();
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "VerifyEmail",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                src: (0, (/*@__PURE__*/$parcel$interopDefault($3279ad32455be7ff$exports))),
                className: "VerifyEmail__logo"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $660b2ca422e0e2ae$export$1ff3c3f08ae963c0).Vertical, {
                height: 45
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h1", {
                className: "VerifyEmail__title",
                children: t("verify_email.title")
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $660b2ca422e0e2ae$export$1ff3c3f08ae963c0).Vertical, {
                height: 5
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h2", {
                className: "VerifyEmail__subtitle",
                children: t("verify_email.description")
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $660b2ca422e0e2ae$export$1ff3c3f08ae963c0).Vertical, {
                height: 53
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                className: "VerifyEmail__subtitle",
                children: t("verify_email.we_sent_code_to_email", {
                    email: email
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $660b2ca422e0e2ae$export$1ff3c3f08ae963c0).Vertical, {
                height: 43
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7YFi7.Formik), {
                initialValues: {
                    token: "",
                    device_id: (0, $32ef62acd40089c4$export$1da4558c59cbf0b1)(),
                    firebase_token: "11"
                },
                validationSchema: $cd7706ce94a8dfd1$export$185802fd694ee1f5().shape({
                    token: $bcc252d93ab3046c$export$185802fd694ee1f5().required(t("verify_email.please_enter_code"))
                }),
                onSubmit: codeSentAt === null ? verify : ()=>resendCode({
                        email: email
                    }),
                children: (formikProps)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7YFi7.Form), {
                        noValidate: true,
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $1067a74e1c3483e2$export$f551688fc98f2e09), {
                                errors: errors?.token,
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $79dd68e96d831dee$export$2e2bcd8739ae039), {
                                    type: "email",
                                    label: t("verify_email.verification_code"),
                                    formikProps: formikProps,
                                    formikKey: "token"
                                })
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $660b2ca422e0e2ae$export$1ff3c3f08ae963c0).Vertical, {
                                height: 25
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                type: "submit",
                                className: "VerifyEmail__button",
                                children: t("verify_email.verify")
                            })
                        ]
                    })
            }),
            codeSentAt !== null && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $660b2ca422e0e2ae$export$1ff3c3f08ae963c0).Vertical, {
                        height: 25
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                        className: "VerifyEmail__subtitle VerifyEmail__resend-description",
                        children: t("verify_email.did_not_receive_email_question")
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $660b2ca422e0e2ae$export$1ff3c3f08ae963c0).Vertical, {
                height: 26
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                className: "VerifyEmail__subtitle VerifyEmail__resend-description",
                children: [
                    t("verify_email.not_your_email_question"),
                    " ",
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7df35e9df335b1c8$export$a6c7ac8248d6e38a), {
                        route: (0, $0534349ae8731d0b$export$66b32f6f30eb4b4).login,
                        params: {},
                        className: "VerifyEmail__change-email-link",
                        children: t("verify_email.change_email")
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $660b2ca422e0e2ae$export$1ff3c3f08ae963c0).Vertical, {
                height: 25
            })
        ]
    });
});







var $7YFi7 = parcelRequire("7YFi7");












const $d36159a0c12e9a70$export$a4c3d56613a57187 = (0, $aca50e9407ba89c9$export$b6ae1bc530f4c149)(()=>{
    const firebaseToken = (0, $7af34371d75563b6$export$5a8e049606f4bc34)();
    const store = (0, $4671947198ddd366$export$6ccbb43953eebf8)();
    const redirect = (0, $7df35e9df335b1c8$export$602eaf6d5314ce55)();
    const urlParams = new URLSearchParams(window.location.search);
    const changePasswordToken = String(urlParams.get("changePasswordToken"));
    const [resetResult, reset] = (0, $4671947198ddd366$export$609860bf8b0084c)(store.data.resetPassword, {
        onSuccess: ()=>{
            redirect((0, $0534349ae8731d0b$export$66b32f6f30eb4b4).index, {});
        },
        onError: (err)=>{
            if (err.data.message) alert(err.data.message);
        },
        filterError: [
            (0, $9ad33fbf770c55a1$export$9696fcf1798e1cb5).ClientError
        ]
    });
    const errors = resetResult.error?.data.errors;
    const { t: t } = (0, $3765cebd031b52c0$export$9fc83ad70ead8663)();
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "ResetPassword",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                src: (0, (/*@__PURE__*/$parcel$interopDefault($3279ad32455be7ff$exports))),
                className: "ResetPassword__logo"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $660b2ca422e0e2ae$export$1ff3c3f08ae963c0).Vertical, {
                height: 45
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h1", {
                className: "ResetPassword__title",
                children: t("reset_password.title")
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $660b2ca422e0e2ae$export$1ff3c3f08ae963c0).Vertical, {
                height: 5
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h2", {
                className: "ResetPassword__subtitle",
                children: t("reset_password.description")
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $660b2ca422e0e2ae$export$1ff3c3f08ae963c0).Vertical, {
                height: 53
            }),
            resetResult.isLoading ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $57fb8f45c69e1681$export$b08b517936747730), {}) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7YFi7.Formik), {
                initialValues: {
                    password: "",
                    confirm_password: ""
                },
                validationSchema: $cd7706ce94a8dfd1$export$185802fd694ee1f5().shape({
                    password: $bcc252d93ab3046c$export$185802fd694ee1f5().required(t("reset_password.please_enter_password")),
                    confirm_password: $bcc252d93ab3046c$export$185802fd694ee1f5().required(t("reset_password.please_confirm_password"))
                }),
                onSubmit: ({ password: password, confirm_password: confirm_password })=>{
                    if (password === confirm_password) reset({
                        password: password,
                        token: changePasswordToken,
                        device_id: (0, $32ef62acd40089c4$export$1da4558c59cbf0b1)(),
                        firebase_token: firebaseToken
                    });
                },
                children: (formikProps)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7YFi7.Form), {
                        noValidate: true,
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $1067a74e1c3483e2$export$f551688fc98f2e09), {
                                errors: errors?.password,
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $79dd68e96d831dee$export$c86715117507e8e5), {
                                    type: "password",
                                    label: t("reset_password.password"),
                                    formikProps: formikProps,
                                    formikKey: "password"
                                })
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $660b2ca422e0e2ae$export$1ff3c3f08ae963c0).Vertical, {
                                height: 15
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $79dd68e96d831dee$export$c86715117507e8e5), {
                                type: "password",
                                label: t("reset_password.confirm_password"),
                                formikProps: formikProps,
                                formikKey: "confirm_password"
                            }),
                            formikProps.touched.password && formikProps.values.confirm_password && (formikProps.values.password === formikProps.values.confirm_password ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                className: "ResetPassword__matchedText",
                                children: t("reset_password.password_mathched")
                            }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                className: "ResetPassword__notMatchedText",
                                children: t("reset_password.password_not_matched")
                            })),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $660b2ca422e0e2ae$export$1ff3c3f08ae963c0).Vertical, {
                                height: 25
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                type: "submit",
                                className: "ResetPassword__button",
                                children: t("reset_password.submit")
                            })
                        ]
                    })
            })
        ]
    });
});




var $acw62 = parcelRequire("acw62");




var $7YFi7 = parcelRequire("7YFi7");














var $7YFi7 = parcelRequire("7YFi7");








const $c786671f641538e1$export$446bb0a5366f9068 = ({ modalVisible: modalVisible, onClose: onClose, children: children, className: className, overlayStyle: overlayStyle = {}, contentStyle: contentStyle = {} })=>{
    if (!modalVisible) return null;
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($81292b5b491156fc$exports))), {
        isOpen: modalVisible,
        onRequestClose: onClose,
        style: {
            overlay: {
                zIndex: 350,
                backgroundColor: "rgba(50,50,70,.2)",
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
                ...overlayStyle
            },
            content: {
                maxHeight: "90vh",
                left: 0,
                right: 0,
                marginLeft: "auto",
                marginRight: "auto",
                top: "unset",
                bottom: "unset",
                borderRadius: 20,
                backgroundColor: "white",
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                ...contentStyle
            }
        },
        className: `OgramModal ${className ?? ""}`,
        children: children
    });
};



const $3a75165057ec337c$export$ce98e8d596263169 = ({ visible: visible, loading: loading, title: title, emailError: emailError, showSuccessLabel: showSuccessLabel, close: close, handleResendPress: handleResendPress })=>{
    const { t: t } = (0, $3765cebd031b52c0$export$9fc83ad70ead8663)();
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c786671f641538e1$export$446bb0a5366f9068), {
        modalVisible: visible,
        onClose: close,
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7YFi7.Formik), {
            initialValues: {
                email: ""
            },
            validationSchema: $cd7706ce94a8dfd1$export$185802fd694ee1f5().shape({
                email: $bcc252d93ab3046c$export$185802fd694ee1f5().email(t("validation_messages.email_invalid")).required(t("create_password.email_required"))
            }),
            onSubmit: (values)=>{
                handleResendPress(values.email);
            },
            validateOnChange: false,
            children: (formikProps)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: "ResendOnboardingEmail",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                            className: "ResendOnboardingEmail__title",
                            children: title
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $660b2ca422e0e2ae$export$1ff3c3f08ae963c0).Vertical, {
                            height: 20
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $1067a74e1c3483e2$export$f551688fc98f2e09), {
                            errors: formikProps.errors.email ?? emailError,
                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4e342c5928158118$export$f5b8910cec6cf069), {
                                label: t("create_password.email"),
                                value: formikProps.values.email,
                                handleChange: (val)=>{
                                    formikProps.setFieldValue("email", val);
                                }
                            })
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $660b2ca422e0e2ae$export$1ff3c3f08ae963c0).Vertical, {
                            height: 20
                        }),
                        showSuccessLabel ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                            className: "ResendOnboardingEmail__successLabel",
                            children: t("create_password.email_is_sent")
                        }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $2ab88429e3384d30$export$353f5b6fc5456de1), {
                            title: loading ? t("create_password.sending") : t("create_password.resend_modal_button"),
                            type: "submit",
                            disabled: !formikProps.values.email,
                            onClick: formikProps.handleSubmit
                        })
                    ]
                })
        })
    });
};




const $0e4e332a68f1e7e0$export$14e6dbe0dfa9b9c6 = (0, $aca50e9407ba89c9$export$b6ae1bc530f4c149)(({ navigateToScreenName: navigateToScreenName })=>{
    const firebaseToken = (0, $7af34371d75563b6$export$5a8e049606f4bc34)();
    const [resendModalTitle, setResendModalTitle] = (0, $acw62.useState)("");
    const [isEmailSent, setEmailIsSent] = (0, $acw62.useState)(false);
    const [resendErrors, setResendErrors] = (0, $acw62.useState)();
    const { account: account, resetPassword: resetPassword, resendOnboardingEmail: resendOnboardingEmail, logged: logged } = (0, $4671947198ddd366$export$6ccbb43953eebf8)().data;
    const redirect = (0, $7df35e9df335b1c8$export$602eaf6d5314ce55)();
    const urlParams = new URLSearchParams(window.location.search);
    const changePasswordToken = String(urlParams.get("changePasswordToken"));
    const navigateToNextScreen = ()=>{
        if (account?.account_type === (0, $97fa7686fb8e51ed$export$b8ca5fa4899cbfc7).NOT_CORPORATE || account?.is_corporate_details_complete) redirect((0, $0534349ae8731d0b$export$66b32f6f30eb4b4).onboardingFinish, {
            navigateToScreenName: navigateToScreenName
        });
        else redirect((0, $0534349ae8731d0b$export$66b32f6f30eb4b4).completeRegistration, {
            navigateToScreenName: navigateToScreenName
        });
    };
    const [setPasswordResult, setPassword] = (0, $4671947198ddd366$export$609860bf8b0084c)(resetPassword, {
        onSuccess: navigateToNextScreen,
        onError: (err)=>{
            if (err.data.code === "token_invalid") setResendModalTitle(err.data.message);
            else if (err.data.message) alert(err.data.message);
        },
        filterError: [
            (0, $9ad33fbf770c55a1$export$9696fcf1798e1cb5).ClientError
        ]
    });
    const [resendEmailResult, requestResendEmail] = (0, $4671947198ddd366$export$609860bf8b0084c)(resendOnboardingEmail, {
        onSuccess: ()=>setEmailIsSent(true),
        onError: (err)=>{
            if (err.data.errors) setResendErrors(err.data.errors.email);
            else alert(err.data.message);
        },
        filterError: [
            (0, $9ad33fbf770c55a1$export$9696fcf1798e1cb5).ClientError
        ]
    });
    (0, $acw62.useEffect)(()=>{
        if (logged) redirect((0, $0534349ae8731d0b$export$66b32f6f30eb4b4).index, {});
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    const errors = setPasswordResult.error?.data.errors;
    const { t: t } = (0, $3765cebd031b52c0$export$9fc83ad70ead8663)();
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "CreatePassword",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                src: (0, (/*@__PURE__*/$parcel$interopDefault($3279ad32455be7ff$exports))),
                className: "CreatePassword__logo"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $660b2ca422e0e2ae$export$1ff3c3f08ae963c0).Vertical, {
                height: 45
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h1", {
                className: "CreatePassword__title",
                children: t("create_password.title")
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $660b2ca422e0e2ae$export$1ff3c3f08ae963c0).Vertical, {
                height: 5
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h2", {
                className: "CreatePassword__subtitle",
                children: t("create_password.description")
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $660b2ca422e0e2ae$export$1ff3c3f08ae963c0).Vertical, {
                height: 53
            }),
            setPasswordResult.isLoading ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $57fb8f45c69e1681$export$b08b517936747730), {}) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7YFi7.Formik), {
                initialValues: {
                    password: "",
                    confirm_password: ""
                },
                validationSchema: $cd7706ce94a8dfd1$export$185802fd694ee1f5().shape({
                    password: $bcc252d93ab3046c$export$185802fd694ee1f5().required(t("create_password.please_enter_password")),
                    confirm_password: $bcc252d93ab3046c$export$185802fd694ee1f5().required(t("create_password.please_confirm_password"))
                }),
                onSubmit: ({ password: password })=>{
                    setPassword({
                        password: password,
                        token: changePasswordToken,
                        device_id: (0, $32ef62acd40089c4$export$1da4558c59cbf0b1)(),
                        firebase_token: firebaseToken
                    });
                },
                children: (formikProps)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7YFi7.Form), {
                        noValidate: true,
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $1067a74e1c3483e2$export$f551688fc98f2e09), {
                                errors: errors?.password,
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $79dd68e96d831dee$export$c86715117507e8e5), {
                                    type: "password",
                                    label: t("create_password.password"),
                                    formikProps: formikProps,
                                    formikKey: "password"
                                })
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $660b2ca422e0e2ae$export$1ff3c3f08ae963c0).Vertical, {
                                height: 15
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $79dd68e96d831dee$export$c86715117507e8e5), {
                                type: "password",
                                label: t("create_password.confirm_password"),
                                formikProps: formikProps,
                                formikKey: "confirm_password"
                            }),
                            formikProps.touched.password && formikProps.values.confirm_password && (formikProps.values.password === formikProps.values.confirm_password ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                className: "CreatePassword__matchedText",
                                children: t("create_password.password_matched")
                            }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                className: "CreatePassword__notMatchedText",
                                children: t("create_password.password_not_matched")
                            })),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $660b2ca422e0e2ae$export$1ff3c3f08ae963c0).Vertical, {
                                height: 25
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                type: "submit",
                                className: "CreatePassword__button",
                                disabled: formikProps.values.password !== formikProps.values.confirm_password || !formikProps.values.password,
                                children: t("create_password.submit")
                            })
                        ]
                    })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $3a75165057ec337c$export$ce98e8d596263169), {
                visible: Boolean(resendModalTitle),
                loading: resendEmailResult.isLoading,
                title: resendModalTitle,
                close: ()=>setResendModalTitle(""),
                emailError: resendErrors,
                handleResendPress: requestResendEmail,
                showSuccessLabel: isEmailSent
            })
        ]
    });
});







var $7YFi7 = parcelRequire("7YFi7");












const $8ddbd6a7716989cd$export$9ba90c23173739d1 = (0, $a4963babae245ff9$export$f0c7a449e0cfaec7)((0, $aca50e9407ba89c9$export$b6ae1bc530f4c149)(()=>{
    const store = (0, $4671947198ddd366$export$6ccbb43953eebf8)();
    const redirect = (0, $7df35e9df335b1c8$export$602eaf6d5314ce55)();
    const [changeResult, change] = (0, $4671947198ddd366$export$609860bf8b0084c)(store.data.changePassword, {
        onSuccess: ()=>{
            (0, $60f27fc97e29822a$export$b410431fab84fa58).success(t("change_password.password_changed_successfully"));
            redirect((0, $0534349ae8731d0b$export$66b32f6f30eb4b4).index, {});
        },
        onError: (err)=>{
            if (err.data.message) alert(err.data.message);
        },
        filterError: [
            (0, $9ad33fbf770c55a1$export$9696fcf1798e1cb5).ClientError
        ]
    });
    const errors = changeResult.error?.data.errors;
    const { t: t } = (0, $3765cebd031b52c0$export$9fc83ad70ead8663)();
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "ResetPassword",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                src: (0, (/*@__PURE__*/$parcel$interopDefault($3279ad32455be7ff$exports))),
                className: "ResetPassword__logo"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $660b2ca422e0e2ae$export$1ff3c3f08ae963c0).Vertical, {
                height: 45
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h1", {
                className: "ResetPassword__title",
                children: t("change_password.title")
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $660b2ca422e0e2ae$export$1ff3c3f08ae963c0).Vertical, {
                height: 5
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h2", {
                className: "ResetPassword__subtitle",
                children: t("change_password.description")
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $660b2ca422e0e2ae$export$1ff3c3f08ae963c0).Vertical, {
                height: 53
            }),
            changeResult.isLoading ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $57fb8f45c69e1681$export$b08b517936747730), {}) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7YFi7.Formik), {
                initialValues: {
                    old_password: "",
                    password: "",
                    confirm_password: ""
                },
                validationSchema: $cd7706ce94a8dfd1$export$185802fd694ee1f5().shape({
                    old_password: $bcc252d93ab3046c$export$185802fd694ee1f5().required(t("change_password.please_enter_old_password")),
                    password: $bcc252d93ab3046c$export$185802fd694ee1f5().required(t("change_password.please_enter_password")),
                    confirm_password: $bcc252d93ab3046c$export$185802fd694ee1f5().required(t("change_password.please_confirm_password"))
                }),
                onSubmit: ({ old_password: old_password, password: password, confirm_password: confirm_password })=>{
                    if (password === confirm_password) change({
                        password: password,
                        old_password: old_password
                    });
                },
                children: (formikProps)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7YFi7.Form), {
                        noValidate: true,
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $1067a74e1c3483e2$export$f551688fc98f2e09), {
                                errors: errors?.old_password,
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $79dd68e96d831dee$export$c86715117507e8e5), {
                                    type: "password",
                                    label: t("change_password.old_password"),
                                    formikProps: formikProps,
                                    formikKey: "old_password"
                                })
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $660b2ca422e0e2ae$export$1ff3c3f08ae963c0).Vertical, {
                                height: 15
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $1067a74e1c3483e2$export$f551688fc98f2e09), {
                                errors: errors?.password,
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $79dd68e96d831dee$export$c86715117507e8e5), {
                                    type: "password",
                                    label: t("change_password.new_password"),
                                    formikProps: formikProps,
                                    formikKey: "password"
                                })
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $660b2ca422e0e2ae$export$1ff3c3f08ae963c0).Vertical, {
                                height: 15
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $79dd68e96d831dee$export$c86715117507e8e5), {
                                type: "password",
                                label: t("change_password.confirm_new_password"),
                                formikProps: formikProps,
                                formikKey: "confirm_password"
                            }),
                            formikProps.touched.password && formikProps.values.confirm_password && (formikProps.values.password === formikProps.values.confirm_password ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                className: "ResetPassword__matchedText",
                                children: t("change_password.password_matched")
                            }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                className: "ResetPassword__notMatchedText",
                                children: t("change_password.password_not_matched")
                            })),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $660b2ca422e0e2ae$export$1ff3c3f08ae963c0).Vertical, {
                                height: 25
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                type: "submit",
                                className: "ResetPassword__button",
                                children: t("change_password.submit")
                            })
                        ]
                    })
            })
        ]
    });
}));


const $e0e24e1e278716af$export$7867ff792998e7e4 = {
    ForgotPasswordPage: (0, $db33374530818377$export$dc075a807a8c61e8)((0, $db88d867bf4ae88f$export$b597ee422a3143dc)),
    LoginPage: (0, $db33374530818377$export$dc075a807a8c61e8)((0, $f24bfaf5bd0db3a1$export$f14c0e3f98d164c0)),
    SignUpPage: (0, $db33374530818377$export$dc075a807a8c61e8)((0, $7f8da85ae0126012$export$265471dcab9022d3)),
    VerifyEmailPage: $8f2345bbacf83df9$export$3d3197b723615cc,
    ResetPasswordPage: $d36159a0c12e9a70$export$a4c3d56613a57187,
    CreatePasswordPage: $0e4e332a68f1e7e0$export$14e6dbe0dfa9b9c6,
    ChangePasswordPage: $8ddbd6a7716989cd$export$9ba90c23173739d1
};






var $acw62 = parcelRequire("acw62");

var $7YFi7 = parcelRequire("7YFi7");



var $kLorN = parcelRequire("kLorN");













var $7YFi7 = parcelRequire("7YFi7");





var $c0139fd98e0c57a9$exports = {};
$c0139fd98e0c57a9$exports = new URL("down-arrow-grey.80834d49.svg", import.meta.url).toString();


function $dbddeb8cbc4bc37f$var$SelectInput({ formikProps: formikProps, label: label, formikKey: formikKey, options: options, disabled: disabled, getValue: getValue }) {
    const handleSelect = (event)=>{
        const value = event.target.value;
        formikProps.setFieldValue(String(formikKey), value);
        if (getValue) getValue(value, formikProps);
    };
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "SelectInput",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "SelectInput__inputText",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $79dd68e96d831dee$export$2e2bcd8739ae039), {
                    label: label,
                    formikKey: formikKey,
                    formikProps: formikProps
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("select", {
                disabled: disabled,
                value: String(formikProps.values[formikKey]),
                onChange: handleSelect,
                className: "SelectInput__options",
                id: "select_input",
                children: [
                    Boolean(formikProps.values[formikKey]) ? null : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                        value: undefined,
                        children: "-- Select Option --"
                    }),
                    options.map((option)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                            value: option.name,
                            children: option.name
                        }, option.id))
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                src: (0, (/*@__PURE__*/$parcel$interopDefault($c0139fd98e0c57a9$exports)))
            })
        ]
    });
}
var $dbddeb8cbc4bc37f$export$2e2bcd8739ae039 = $dbddeb8cbc4bc37f$var$SelectInput;




var $acw62 = parcelRequire("acw62");


const $1ba814d56c45ce44$var$UploadDocument = ({ onSelectFile: onSelectFile, hasFile: hasFile, placeholder: placeholder, name: name, maxFileSize: maxFileSize, showErrorRequiredMessage: showErrorRequiredMessage })=>{
    const [isFileSelected, setIsFileSelected] = (0, $acw62.useState)(false);
    const [showErrorMesssage, setShowErrorMesssage] = (0, $acw62.useState)(false);
    const [errorMessage, setErrorMessage] = (0, $acw62.useState)("This Field is Required");
    const { t: t } = (0, $3765cebd031b52c0$export$9fc83ad70ead8663)();
    const handleFileSelected = ({ target: target })=>{
        onSelectFile(null);
        const files = target.files;
        if (files) {
            const fileSizeInMB = files[0].size / 1000000;
            if (fileSizeInMB <= maxFileSize) {
                onSelectFile(files[0]);
                setShowErrorMesssage(false);
                setIsFileSelected(true);
            } else {
                setShowErrorMesssage(true);
                setErrorMessage(`File size canot exceed ${maxFileSize}mb`);
            }
        }
    };
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "UploadDocument",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                        accept: ".doc,.docx,.pdf,image/*",
                        onChange: handleFileSelected,
                        value: "",
                        id: name,
                        type: "file",
                        className: "UploadDocument__uploadInput"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                        htmlFor: name,
                        className: "UploadDocument__upload",
                        children: isFileSelected ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                            className: "UploadDocument__uploadText",
                            children: t("complete_registration.document_selected")
                        }) : hasFile ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                            className: "UploadDocument__uploadText",
                            children: t("complete_registration.document_submitted")
                        }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                            className: "UploadDocument__placeholder",
                            children: placeholder
                        })
                    })
                ]
            }),
            showErrorMesssage || showErrorRequiredMessage ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                className: "UploadDocument__errorMessage",
                children: errorMessage
            }) : null
        ]
    });
};
var $1ba814d56c45ce44$export$2e2bcd8739ae039 = $1ba814d56c45ce44$var$UploadDocument;



var $kLorN = parcelRequire("kLorN");


var $acw62 = parcelRequire("acw62");

var $7YFi7 = parcelRequire("7YFi7");

var $00cf24b3d10c26ba$exports = {};
"use strict";

$00cf24b3d10c26ba$exports = (parcelRequire("ghXKL"));



var $bsQZT = parcelRequire("bsQZT");

const $3137fcd9cdcdec90$var$market = (0, $73ccb33f5de6f5aa$export$8707029d024490c9)().iso2Code;
function $3137fcd9cdcdec90$var$LocationAutoComplete({ label: label, getValue: getValue, formikKey: formikKey, formikProps: formikProps, disabled: disabled, onPlaceSelected: onPlaceSelected, autocompleteType: autocompleteType = "establishment" }) {
    const { ref: ref } = (0, $00cf24b3d10c26ba$exports.usePlacesWidget)({
        apiKey: (0, $bsQZT.config).GOOGLE_API_KEY,
        onPlaceSelected: onPlaceSelected,
        options: {
            componentRestrictions: {
                country: $3137fcd9cdcdec90$var$market
            },
            types: [
                autocompleteType
            ],
            fields: [
                "name",
                "address_components",
                "geometry.location",
                "place_id",
                "formatted_address"
            ]
        }
    });
    const handleKeyUp = (event)=>{
        if (getValue) getValue(event.target.value);
    };
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "LocationAutoComplete",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7YFi7.Field), {
                placeholder: "",
                disabled: disabled,
                name: formikKey,
                autoComplete: "off",
                className: "LocationAutoComplete__input",
                onKeyUp: handleKeyUp,
                type: "text",
                required: true,
                innerRef: ref
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                className: `input-label ${Boolean(formikProps.getFieldProps(formikKey).value) && "active"}`,
                children: label
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                className: "error-msg",
                children: formikProps.touched[formikKey] && formikProps.errors[formikKey]
            })
        ]
    });
}
var // @ts-nocheck
/* eslint-disable */ $3137fcd9cdcdec90$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $acw62.forwardRef)($3137fcd9cdcdec90$var$LocationAutoComplete);


const $dd1fbf78cfe16cee$export$a6fd9f62ed2c0b4c = ({ formikProps: formikProps, regionsData: regionsData, maxFileSizeMB: maxFileSizeMB, showVATErrorMessage: showVATErrorMessage, onSelectVAT: onSelectVAT, errorMessages: errorMessages, togglePrivacyPolicy: togglePrivacyPolicy, privacyPolicyAccepted: privacyPolicyAccepted, vat: vat, apiHost: apiHost })=>{
    const { t: t } = (0, $3765cebd031b52c0$export$9fc83ad70ead8663)();
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7YFi7.Form), {
        noValidate: true,
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $79dd68e96d831dee$export$2e2bcd8739ae039), {
                label: t("complete_registration.company_name"),
                formikProps: formikProps,
                formikKey: "company_name"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $660b2ca422e0e2ae$export$1ff3c3f08ae963c0).Vertical, {
                height: 10
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $79dd68e96d831dee$export$2e2bcd8739ae039), {
                label: t("complete_registration.trade_name_as_license"),
                formikProps: formikProps,
                formikKey: "trade_name"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $660b2ca422e0e2ae$export$1ff3c3f08ae963c0).Vertical, {
                height: 10
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $79dd68e96d831dee$export$2e2bcd8739ae039), {
                type: "number",
                label: t("complete_registration.trade_license_number"),
                formikProps: formikProps,
                formikKey: "license_number"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $660b2ca422e0e2ae$export$1ff3c3f08ae963c0).Vertical, {
                height: 10
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $3137fcd9cdcdec90$export$2e2bcd8739ae039), {
                type: "text",
                label: t("complete_registration.legal_address"),
                autocompleteType: "address",
                onPlaceSelected: (p)=>{
                    const address = p.formatted_address;
                    const city = p.address_components.find((component)=>component.types.includes("locality"))?.long_name;
                    formikProps.setFieldValue("address", address);
                    if (Boolean(city)) formikProps.setFieldValue("region", city);
                },
                formikProps: formikProps,
                formikKey: "address"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $660b2ca422e0e2ae$export$1ff3c3f08ae963c0).Vertical, {
                height: 10
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $79dd68e96d831dee$export$2e2bcd8739ae039), {
                label: t("complete_registration.po_box"),
                formikProps: formikProps,
                formikKey: "po_box"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $660b2ca422e0e2ae$export$1ff3c3f08ae963c0).Vertical, {
                height: 10
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $79dd68e96d831dee$export$2e2bcd8739ae039), {
                label: t("complete_registration.free_zone"),
                formikProps: formikProps,
                formikKey: "free_zone"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $660b2ca422e0e2ae$export$1ff3c3f08ae963c0).Vertical, {
                height: 10
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $dbddeb8cbc4bc37f$export$2e2bcd8739ae039), {
                options: [
                    {
                        name: t("complete_registration.yes"),
                        id: 1
                    },
                    {
                        name: t("complete_registration.no"),
                        id: 0
                    }
                ],
                label: t("complete_registration.lpo_required"),
                formikKey: "is_lpo_required",
                formikProps: formikProps
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $660b2ca422e0e2ae$export$1ff3c3f08ae963c0).Vertical, {
                height: 40
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h4", {
                className: "CompleteRegisteration__uploadInputLable",
                children: t("complete_registration.vat_certificate")
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $660b2ca422e0e2ae$export$1ff3c3f08ae963c0).Vertical, {
                height: 15
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $1ba814d56c45ce44$export$2e2bcd8739ae039), {
                maxFileSize: maxFileSizeMB,
                showErrorRequiredMessage: showVATErrorMessage,
                name: "vat",
                hasFile: Boolean(vat),
                onSelectFile: onSelectVAT,
                placeholder: t("complete_registration.upload_vat")
            }),
            errorMessages.map((error, i)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                    className: "CompleteRegisteration__errorMessage",
                    children: error
                }, i)),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $660b2ca422e0e2ae$export$1ff3c3f08ae963c0).Vertical, {
                height: 15
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "CompleteRegisteration__termsConditions",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                        type: "checkbox",
                        onClick: togglePrivacyPolicy,
                        checked: privacyPolicyAccepted,
                        className: "CompleteRegisteration__termsConditions__checkbox"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $660b2ca422e0e2ae$export$1ff3c3f08ae963c0).Horizontal, {
                        width: 10
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "CompleteRegisteration__termsConditions__container",
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $e04d9533328ca578$export$8d6a9236f2e3f2ce), {
                            i18nKey: "complete_registration.i_agree_with_terms",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                    className: "CompleteRegisteration__termsConditions__container__label",
                                    children: "I agree to the"
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("a", {
                                    href: `${apiHost}client/profile/sla?type=html&tc_type=${(0, $kLorN.TERMS_AND_CONDITIONS_TYPE_PRIVACY_POLICY_CLIENT)}`,
                                    target: "_blank",
                                    rel: "noreferrer",
                                    className: "CompleteRegisteration__termsConditions__container__link",
                                    children: "Privacy Policy"
                                })
                            ]
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $660b2ca422e0e2ae$export$1ff3c3f08ae963c0).Vertical, {
                height: 5
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                disabled: !privacyPolicyAccepted,
                className: "CompleteRegisteration__submitButton",
                type: "submit",
                children: t("complete_registration.continue")
            })
        ]
    });
};





var $7YFi7 = parcelRequire("7YFi7");




var $kLorN = parcelRequire("kLorN");




function $f329557dcab6d0bb$export$2e2bcd8739ae039(obj, key, value) {
    key = (0, $3a21fd50cbcd11cf$export$2e2bcd8739ae039)(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}


function $983350b7b3960a26$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $983350b7b3960a26$export$2e2bcd8739ae039(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $983350b7b3960a26$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $983350b7b3960a26$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}


function $1167ce760980f343$export$2e2bcd8739ae039(arr) {
    if (Array.isArray(arr)) return arr;
}


function $c029ce1ef065e371$export$2e2bcd8739ae039(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}


function $5a337bca9556bfe7$export$2e2bcd8739ae039(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}


function $76af8a05551d5f25$export$2e2bcd8739ae039(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return (0, $5a337bca9556bfe7$export$2e2bcd8739ae039)(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return (0, $5a337bca9556bfe7$export$2e2bcd8739ae039)(o, minLen);
}


function $530b88ff20858fe6$export$2e2bcd8739ae039() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}


function $adaabbc18727b3e6$export$2e2bcd8739ae039(arr, i) {
    return (0, $1167ce760980f343$export$2e2bcd8739ae039)(arr) || (0, $c029ce1ef065e371$export$2e2bcd8739ae039)(arr, i) || (0, $76af8a05551d5f25$export$2e2bcd8739ae039)(arr, i) || (0, $530b88ff20858fe6$export$2e2bcd8739ae039)();
}


function $133b6e059b2f6d5e$export$2e2bcd8739ae039(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}


function $73ef9ce1c41fc0c0$export$2e2bcd8739ae039(source, excluded) {
    if (source == null) return {};
    var target = (0, $133b6e059b2f6d5e$export$2e2bcd8739ae039)(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}



var $acw62 = parcelRequire("acw62");
var $9d88f0746ba78f85$var$_excluded = [
    "defaultInputValue",
    "defaultMenuIsOpen",
    "defaultValue",
    "inputValue",
    "menuIsOpen",
    "onChange",
    "onInputChange",
    "onMenuClose",
    "onMenuOpen",
    "value"
];
function $9d88f0746ba78f85$export$3b14a55fb2447963(_ref) {
    var _ref$defaultInputValu = _ref.defaultInputValue, defaultInputValue = _ref$defaultInputValu === void 0 ? "" : _ref$defaultInputValu, _ref$defaultMenuIsOpe = _ref.defaultMenuIsOpen, defaultMenuIsOpen = _ref$defaultMenuIsOpe === void 0 ? false : _ref$defaultMenuIsOpe, _ref$defaultValue = _ref.defaultValue, defaultValue = _ref$defaultValue === void 0 ? null : _ref$defaultValue, propsInputValue = _ref.inputValue, propsMenuIsOpen = _ref.menuIsOpen, propsOnChange = _ref.onChange, propsOnInputChange = _ref.onInputChange, propsOnMenuClose = _ref.onMenuClose, propsOnMenuOpen = _ref.onMenuOpen, propsValue = _ref.value, restSelectProps = (0, $73ef9ce1c41fc0c0$export$2e2bcd8739ae039)(_ref, $9d88f0746ba78f85$var$_excluded);
    var _useState = (0, $acw62.useState)(propsInputValue !== undefined ? propsInputValue : defaultInputValue), _useState2 = (0, $adaabbc18727b3e6$export$2e2bcd8739ae039)(_useState, 2), stateInputValue = _useState2[0], setStateInputValue = _useState2[1];
    var _useState3 = (0, $acw62.useState)(propsMenuIsOpen !== undefined ? propsMenuIsOpen : defaultMenuIsOpen), _useState4 = (0, $adaabbc18727b3e6$export$2e2bcd8739ae039)(_useState3, 2), stateMenuIsOpen = _useState4[0], setStateMenuIsOpen = _useState4[1];
    var _useState5 = (0, $acw62.useState)(propsValue !== undefined ? propsValue : defaultValue), _useState6 = (0, $adaabbc18727b3e6$export$2e2bcd8739ae039)(_useState5, 2), stateValue = _useState6[0], setStateValue = _useState6[1];
    var onChange = (0, $acw62.useCallback)(function(value, actionMeta) {
        if (typeof propsOnChange === "function") propsOnChange(value, actionMeta);
        setStateValue(value);
    }, [
        propsOnChange
    ]);
    var onInputChange = (0, $acw62.useCallback)(function(value, actionMeta) {
        var newValue;
        if (typeof propsOnInputChange === "function") newValue = propsOnInputChange(value, actionMeta);
        setStateInputValue(newValue !== undefined ? newValue : value);
    }, [
        propsOnInputChange
    ]);
    var onMenuOpen = (0, $acw62.useCallback)(function() {
        if (typeof propsOnMenuOpen === "function") propsOnMenuOpen();
        setStateMenuIsOpen(true);
    }, [
        propsOnMenuOpen
    ]);
    var onMenuClose = (0, $acw62.useCallback)(function() {
        if (typeof propsOnMenuClose === "function") propsOnMenuClose();
        setStateMenuIsOpen(false);
    }, [
        propsOnMenuClose
    ]);
    var inputValue = propsInputValue !== undefined ? propsInputValue : stateInputValue;
    var menuIsOpen = propsMenuIsOpen !== undefined ? propsMenuIsOpen : stateMenuIsOpen;
    var value = propsValue !== undefined ? propsValue : stateValue;
    return (0, $983350b7b3960a26$export$2e2bcd8739ae039)((0, $983350b7b3960a26$export$2e2bcd8739ae039)({}, restSelectProps), {}, {
        inputValue: inputValue,
        menuIsOpen: menuIsOpen,
        onChange: onChange,
        onInputChange: onInputChange,
        onMenuClose: onMenuClose,
        onMenuOpen: onMenuOpen,
        value: value
    });
}


function $618a8e53233cd9fa$export$2e2bcd8739ae039() {
    $618a8e53233cd9fa$export$2e2bcd8739ae039 = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $618a8e53233cd9fa$export$2e2bcd8739ae039.apply(this, arguments);
}



var $acw62 = parcelRequire("acw62");




function $0ad5d8b55fe970db$export$2e2bcd8739ae039(o, p) {
    $0ad5d8b55fe970db$export$2e2bcd8739ae039 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $0ad5d8b55fe970db$export$2e2bcd8739ae039(o, p);
}


function $0ed648f7bbaf3aff$export$2e2bcd8739ae039(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    Object.defineProperty(subClass, "prototype", {
        writable: false
    });
    if (superClass) (0, $0ad5d8b55fe970db$export$2e2bcd8739ae039)(subClass, superClass);
}


function $e4c5ebe502337db0$export$2e2bcd8739ae039(o) {
    $e4c5ebe502337db0$export$2e2bcd8739ae039 = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $e4c5ebe502337db0$export$2e2bcd8739ae039(o);
}


function $b2099f49db83e2df$export$2e2bcd8739ae039() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}



function $cd69a1d4c6210e44$export$2e2bcd8739ae039(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}


function $6a259df8fa92dc4a$export$2e2bcd8739ae039(self, call) {
    if (call && ((0, $b8f57191916382d3$export$2e2bcd8739ae039)(call) === "object" || typeof call === "function")) return call;
    else if (call !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
    return (0, $cd69a1d4c6210e44$export$2e2bcd8739ae039)(self);
}


function $a76f20fb39fa9d46$export$2e2bcd8739ae039(Derived) {
    var hasNativeReflectConstruct = (0, $b2099f49db83e2df$export$2e2bcd8739ae039)();
    return function _createSuperInternal() {
        var Super = (0, $e4c5ebe502337db0$export$2e2bcd8739ae039)(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = (0, $e4c5ebe502337db0$export$2e2bcd8739ae039)(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return (0, $6a259df8fa92dc4a$export$2e2bcd8739ae039)(this, result);
    };
}



function $95003165623aa54c$export$2e2bcd8739ae039(arr) {
    if (Array.isArray(arr)) return (0, $5a337bca9556bfe7$export$2e2bcd8739ae039)(arr);
}


function $a0df324e6f81ee90$export$2e2bcd8739ae039(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}



function $b5aec8b8da7ac2f2$export$2e2bcd8739ae039() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}


function $eb1ed927433e7e98$export$2e2bcd8739ae039(arr) {
    return (0, $95003165623aa54c$export$2e2bcd8739ae039)(arr) || (0, $a0df324e6f81ee90$export$2e2bcd8739ae039)(arr) || (0, $76af8a05551d5f25$export$2e2bcd8739ae039)(arr) || (0, $b5aec8b8da7ac2f2$export$2e2bcd8739ae039)();
}



var $acw62 = parcelRequire("acw62");



var $acw62 = parcelRequire("acw62");
/*

Based off glamor's StyleSheet, thanks Sunil ❤️

high performance StyleSheet for css-in-js systems

- uses multiple style tags behind the scenes for millions of rules
- uses `insertRule` for appending in production for *much* faster performance

// usage

import { StyleSheet } from '@emotion/sheet'

let styleSheet = new StyleSheet({ key: '', container: document.head })

styleSheet.insert('#box { border: 1px solid red; }')
- appends a css rule into the stylesheet

styleSheet.flush()
- empties the stylesheet of all its contents

*/ // $FlowFixMe
function $e18645ac1956fbe6$var$sheetForTag(tag) {
    if (tag.sheet) // $FlowFixMe
    return tag.sheet;
     // this weirdness brought to you by firefox
    /* istanbul ignore next */ for(var i = 0; i < document.styleSheets.length; i++){
        if (document.styleSheets[i].ownerNode === tag) // $FlowFixMe
        return document.styleSheets[i];
    }
}
function $e18645ac1956fbe6$var$createStyleElement(options) {
    var tag = document.createElement("style");
    tag.setAttribute("data-emotion", options.key);
    if (options.nonce !== undefined) tag.setAttribute("nonce", options.nonce);
    tag.appendChild(document.createTextNode(""));
    tag.setAttribute("data-s", "");
    return tag;
}
var $e18645ac1956fbe6$export$9d753cd7ae895cce = /*#__PURE__*/ function() {
    // Using Node instead of HTMLElement since container may be a ShadowRoot
    function StyleSheet(options) {
        var _this = this;
        this._insertTag = function(tag) {
            var before;
            if (_this.tags.length === 0) {
                if (_this.insertionPoint) before = _this.insertionPoint.nextSibling;
                else if (_this.prepend) before = _this.container.firstChild;
                else before = _this.before;
            } else before = _this.tags[_this.tags.length - 1].nextSibling;
            _this.container.insertBefore(tag, before);
            _this.tags.push(tag);
        };
        this.isSpeedy = options.speedy === undefined ? false : options.speedy;
        this.tags = [];
        this.ctr = 0;
        this.nonce = options.nonce; // key is the value of the data-emotion attribute, it's used to identify different sheets
        this.key = options.key;
        this.container = options.container;
        this.prepend = options.prepend;
        this.insertionPoint = options.insertionPoint;
        this.before = null;
    }
    var _proto = StyleSheet.prototype;
    _proto.hydrate = function hydrate(nodes) {
        nodes.forEach(this._insertTag);
    };
    _proto.insert = function insert(rule) {
        // the max length is how many rules we have per style tag, it's 65000 in speedy mode
        // it's 1 in dev because we insert source maps that map a single rule to a location
        // and you can only have one source map per style tag
        if (this.ctr % (this.isSpeedy ? 65000 : 1) === 0) this._insertTag($e18645ac1956fbe6$var$createStyleElement(this));
        var tag = this.tags[this.tags.length - 1];
        var isImportRule = rule.charCodeAt(0) === 64 && rule.charCodeAt(1) === 105;
        if (isImportRule && this._alreadyInsertedOrderInsensitiveRule) // this would only cause problem in speedy mode
        // but we don't want enabling speedy to affect the observable behavior
        // so we report this error at all times
        console.error("You're attempting to insert the following rule:\n" + rule + "\n\n`@import` rules must be before all other types of rules in a stylesheet but other rules have already been inserted. Please ensure that `@import` rules are before all other rules.");
        this._alreadyInsertedOrderInsensitiveRule = this._alreadyInsertedOrderInsensitiveRule || !isImportRule;
        if (this.isSpeedy) {
            var sheet = $e18645ac1956fbe6$var$sheetForTag(tag);
            try {
                // this is the ultrafast version, works across browsers
                // the big drawback is that the css won't be editable in devtools
                sheet.insertRule(rule, sheet.cssRules.length);
            } catch (e) {
                if (!/:(-moz-placeholder|-moz-focus-inner|-moz-focusring|-ms-input-placeholder|-moz-read-write|-moz-read-only|-ms-clear|-ms-expand|-ms-reveal){/.test(rule)) console.error('There was a problem inserting the following rule: "' + rule + '"', e);
            }
        } else tag.appendChild(document.createTextNode(rule));
        this.ctr++;
    };
    _proto.flush = function flush() {
        // $FlowFixMe
        this.tags.forEach(function(tag) {
            return tag.parentNode && tag.parentNode.removeChild(tag);
        });
        this.tags = [];
        this.ctr = 0;
        this._alreadyInsertedOrderInsensitiveRule = false;
    };
    return StyleSheet;
}();


var $298fb931ed4fbf8b$export$71ad59f2e432cfe8 = "-ms-";
var $298fb931ed4fbf8b$export$2c0f367103c8d01c = "-moz-";
var $298fb931ed4fbf8b$export$39dfd62a25e0fe93 = "-webkit-";
var $298fb931ed4fbf8b$export$a29989082612d0d9 = "comm";
var $298fb931ed4fbf8b$export$aa3a2e812ca8570d = "rule";
var $298fb931ed4fbf8b$export$527d108ccf083c2b = "decl";
var $298fb931ed4fbf8b$export$d3d35020fa5b54f0 = "@page";
var $298fb931ed4fbf8b$export$500415a86c544f73 = "@media";
var $298fb931ed4fbf8b$export$a763edbf796b780a = "@import";
var $298fb931ed4fbf8b$export$2790aeb8b4e5c826 = "@charset";
var $298fb931ed4fbf8b$export$1cc683e23b84b133 = "@viewport";
var $298fb931ed4fbf8b$export$9447a5efea57e862 = "@supports";
var $298fb931ed4fbf8b$export$ef011b4e114b1fba = "@document";
var $298fb931ed4fbf8b$export$6aad947bda0f3f46 = "@namespace";
var $298fb931ed4fbf8b$export$b44a8529a35fcb60 = "@keyframes";
var $298fb931ed4fbf8b$export$2c16de31893252e6 = "@font-face";
var $298fb931ed4fbf8b$export$3d846dd52e150c6f = "@counter-style";
var $298fb931ed4fbf8b$export$22314bfbb57653fe = "@font-feature-values";
var $298fb931ed4fbf8b$export$d773506282b3cfe6 = "@layer";
var $298fb931ed4fbf8b$export$2335f513bbd82c6d = Math.abs;
var $298fb931ed4fbf8b$export$6788812c4e6611e6 = String.fromCharCode;
var $298fb931ed4fbf8b$export$e6e34fd1f2686227 = Object.assign;
function $298fb931ed4fbf8b$export$d6af199866bfb566(e, r) {
    return $298fb931ed4fbf8b$export$a9db5e087081082d(e, 0) ^ 45 ? (((r << 2 ^ $298fb931ed4fbf8b$export$a9db5e087081082d(e, 0)) << 2 ^ $298fb931ed4fbf8b$export$a9db5e087081082d(e, 1)) << 2 ^ $298fb931ed4fbf8b$export$a9db5e087081082d(e, 2)) << 2 ^ $298fb931ed4fbf8b$export$a9db5e087081082d(e, 3) : 0;
}
function $298fb931ed4fbf8b$export$87c2784dc9fc4ab(e) {
    return e.trim();
}
function $298fb931ed4fbf8b$export$4659b591c19bdf3d(e, r) {
    return (e = r.exec(e)) ? e[0] : e;
}
function $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(e, r, a) {
    return e.replace(r, a);
}
function $298fb931ed4fbf8b$export$f8e21b1e77979a08(e, r) {
    return e.indexOf(r);
}
function $298fb931ed4fbf8b$export$a9db5e087081082d(e, r) {
    return e.charCodeAt(r) | 0;
}
function $298fb931ed4fbf8b$export$2f35ab04d2335697(e, r, a) {
    return e.slice(r, a);
}
function $298fb931ed4fbf8b$export$36776f635604f274(e) {
    return e.length;
}
function $298fb931ed4fbf8b$export$f9084667e487ed46(e) {
    return e.length;
}
function $298fb931ed4fbf8b$export$10d8903dec122b9d(e, r) {
    return r.push(e), e;
}
function $298fb931ed4fbf8b$export$1be1fc439b849fdf(e, r) {
    return e.map(r).join("");
}
var $298fb931ed4fbf8b$export$53f1d5ea8de3d7c = 1;
var $298fb931ed4fbf8b$export$4e0c71f277ca26b3 = 1;
var $298fb931ed4fbf8b$export$f24224f1c91d8156 = 0;
var $298fb931ed4fbf8b$export$5880b8b5730aff45 = 0;
var $298fb931ed4fbf8b$export$c0306caf338ac095 = 0;
var $298fb931ed4fbf8b$export$30a86d91af8ff6e6 = "";
function $298fb931ed4fbf8b$export$35059013cd4a06db(e, r, a, n, c, s, t) {
    return {
        value: e,
        root: r,
        parent: a,
        type: n,
        props: c,
        children: s,
        line: $298fb931ed4fbf8b$export$53f1d5ea8de3d7c,
        column: $298fb931ed4fbf8b$export$4e0c71f277ca26b3,
        length: t,
        return: ""
    };
}
function $298fb931ed4fbf8b$export$784d13d8ee351f07(e, r) {
    return $298fb931ed4fbf8b$export$e6e34fd1f2686227($298fb931ed4fbf8b$export$35059013cd4a06db("", null, null, "", null, null, 0), e, {
        length: -e.length
    }, r);
}
function $298fb931ed4fbf8b$export$eba6f6f03b0a92e7() {
    return $298fb931ed4fbf8b$export$c0306caf338ac095;
}
function $298fb931ed4fbf8b$export$232faf9add678146() {
    $298fb931ed4fbf8b$export$c0306caf338ac095 = $298fb931ed4fbf8b$export$5880b8b5730aff45 > 0 ? $298fb931ed4fbf8b$export$a9db5e087081082d($298fb931ed4fbf8b$export$30a86d91af8ff6e6, --$298fb931ed4fbf8b$export$5880b8b5730aff45) : 0;
    if ($298fb931ed4fbf8b$export$4e0c71f277ca26b3--, $298fb931ed4fbf8b$export$c0306caf338ac095 === 10) $298fb931ed4fbf8b$export$4e0c71f277ca26b3 = 1, $298fb931ed4fbf8b$export$53f1d5ea8de3d7c--;
    return $298fb931ed4fbf8b$export$c0306caf338ac095;
}
function $298fb931ed4fbf8b$export$48cfd1e771a65c4f() {
    $298fb931ed4fbf8b$export$c0306caf338ac095 = $298fb931ed4fbf8b$export$5880b8b5730aff45 < $298fb931ed4fbf8b$export$f24224f1c91d8156 ? $298fb931ed4fbf8b$export$a9db5e087081082d($298fb931ed4fbf8b$export$30a86d91af8ff6e6, $298fb931ed4fbf8b$export$5880b8b5730aff45++) : 0;
    if ($298fb931ed4fbf8b$export$4e0c71f277ca26b3++, $298fb931ed4fbf8b$export$c0306caf338ac095 === 10) $298fb931ed4fbf8b$export$4e0c71f277ca26b3 = 1, $298fb931ed4fbf8b$export$53f1d5ea8de3d7c++;
    return $298fb931ed4fbf8b$export$c0306caf338ac095;
}
function $298fb931ed4fbf8b$export$4d3fb11e950abb9e() {
    return $298fb931ed4fbf8b$export$a9db5e087081082d($298fb931ed4fbf8b$export$30a86d91af8ff6e6, $298fb931ed4fbf8b$export$5880b8b5730aff45);
}
function $298fb931ed4fbf8b$export$e88cb2efb12ae807() {
    return $298fb931ed4fbf8b$export$5880b8b5730aff45;
}
function $298fb931ed4fbf8b$export$58adb3bec8346d0f(e, r) {
    return $298fb931ed4fbf8b$export$2f35ab04d2335697($298fb931ed4fbf8b$export$30a86d91af8ff6e6, e, r);
}
function $298fb931ed4fbf8b$export$9e1725a4cfeada27(e) {
    switch(e){
        case 0:
        case 9:
        case 10:
        case 13:
        case 32:
            return 5;
        case 33:
        case 43:
        case 44:
        case 47:
        case 62:
        case 64:
        case 126:
        case 59:
        case 123:
        case 125:
            return 4;
        case 58:
            return 3;
        case 34:
        case 39:
        case 40:
        case 91:
            return 2;
        case 41:
        case 93:
            return 1;
    }
    return 0;
}
function $298fb931ed4fbf8b$export$2de70f21292aac9e(e) {
    return $298fb931ed4fbf8b$export$53f1d5ea8de3d7c = $298fb931ed4fbf8b$export$4e0c71f277ca26b3 = 1, $298fb931ed4fbf8b$export$f24224f1c91d8156 = $298fb931ed4fbf8b$export$36776f635604f274($298fb931ed4fbf8b$export$30a86d91af8ff6e6 = e), $298fb931ed4fbf8b$export$5880b8b5730aff45 = 0, [];
}
function $298fb931ed4fbf8b$export$45918ac1574455b1(e) {
    return $298fb931ed4fbf8b$export$30a86d91af8ff6e6 = "", e;
}
function $298fb931ed4fbf8b$export$410ac95b9ec204b8(e) {
    return $298fb931ed4fbf8b$export$87c2784dc9fc4ab($298fb931ed4fbf8b$export$58adb3bec8346d0f($298fb931ed4fbf8b$export$5880b8b5730aff45 - 1, $298fb931ed4fbf8b$export$c889f2fcc19dbf12(e === 91 ? e + 2 : e === 40 ? e + 1 : e)));
}
function $298fb931ed4fbf8b$export$660b2ee2d4fb4eff(e) {
    return $298fb931ed4fbf8b$export$45918ac1574455b1($298fb931ed4fbf8b$export$5f8c09e3ae6f64e1($298fb931ed4fbf8b$export$2de70f21292aac9e(e)));
}
function $298fb931ed4fbf8b$export$7af1228ff777d175(e) {
    while($298fb931ed4fbf8b$export$c0306caf338ac095 = $298fb931ed4fbf8b$export$4d3fb11e950abb9e())if ($298fb931ed4fbf8b$export$c0306caf338ac095 < 33) $298fb931ed4fbf8b$export$48cfd1e771a65c4f();
    else break;
    return $298fb931ed4fbf8b$export$9e1725a4cfeada27(e) > 2 || $298fb931ed4fbf8b$export$9e1725a4cfeada27($298fb931ed4fbf8b$export$c0306caf338ac095) > 3 ? "" : " ";
}
function $298fb931ed4fbf8b$export$5f8c09e3ae6f64e1(e) {
    while($298fb931ed4fbf8b$export$48cfd1e771a65c4f())switch($298fb931ed4fbf8b$export$9e1725a4cfeada27($298fb931ed4fbf8b$export$c0306caf338ac095)){
        case 0:
            $298fb931ed4fbf8b$export$10d8903dec122b9d($298fb931ed4fbf8b$export$c2ab62c7bf24634($298fb931ed4fbf8b$export$5880b8b5730aff45 - 1), e);
            break;
        case 2:
            $298fb931ed4fbf8b$export$10d8903dec122b9d($298fb931ed4fbf8b$export$410ac95b9ec204b8($298fb931ed4fbf8b$export$c0306caf338ac095), e);
            break;
        default:
            $298fb931ed4fbf8b$export$10d8903dec122b9d($298fb931ed4fbf8b$export$6788812c4e6611e6($298fb931ed4fbf8b$export$c0306caf338ac095), e);
    }
    return e;
}
function $298fb931ed4fbf8b$export$955ba06d119e085e(e, r) {
    while(--r && $298fb931ed4fbf8b$export$48cfd1e771a65c4f())if ($298fb931ed4fbf8b$export$c0306caf338ac095 < 48 || $298fb931ed4fbf8b$export$c0306caf338ac095 > 102 || $298fb931ed4fbf8b$export$c0306caf338ac095 > 57 && $298fb931ed4fbf8b$export$c0306caf338ac095 < 65 || $298fb931ed4fbf8b$export$c0306caf338ac095 > 70 && $298fb931ed4fbf8b$export$c0306caf338ac095 < 97) break;
    return $298fb931ed4fbf8b$export$58adb3bec8346d0f(e, $298fb931ed4fbf8b$export$e88cb2efb12ae807() + (r < 6 && $298fb931ed4fbf8b$export$4d3fb11e950abb9e() == 32 && $298fb931ed4fbf8b$export$48cfd1e771a65c4f() == 32));
}
function $298fb931ed4fbf8b$export$c889f2fcc19dbf12(e) {
    while($298fb931ed4fbf8b$export$48cfd1e771a65c4f())switch($298fb931ed4fbf8b$export$c0306caf338ac095){
        case e:
            return $298fb931ed4fbf8b$export$5880b8b5730aff45;
        case 34:
        case 39:
            if (e !== 34 && e !== 39) $298fb931ed4fbf8b$export$c889f2fcc19dbf12($298fb931ed4fbf8b$export$c0306caf338ac095);
            break;
        case 40:
            if (e === 41) $298fb931ed4fbf8b$export$c889f2fcc19dbf12(e);
            break;
        case 92:
            $298fb931ed4fbf8b$export$48cfd1e771a65c4f();
            break;
    }
    return $298fb931ed4fbf8b$export$5880b8b5730aff45;
}
function $298fb931ed4fbf8b$export$4254d4e2b3745c4c(e, r) {
    while($298fb931ed4fbf8b$export$48cfd1e771a65c4f())if (e + $298fb931ed4fbf8b$export$c0306caf338ac095 === 57) break;
    else if (e + $298fb931ed4fbf8b$export$c0306caf338ac095 === 84 && $298fb931ed4fbf8b$export$4d3fb11e950abb9e() === 47) break;
    return "/*" + $298fb931ed4fbf8b$export$58adb3bec8346d0f(r, $298fb931ed4fbf8b$export$5880b8b5730aff45 - 1) + "*" + $298fb931ed4fbf8b$export$6788812c4e6611e6(e === 47 ? e : $298fb931ed4fbf8b$export$48cfd1e771a65c4f());
}
function $298fb931ed4fbf8b$export$c2ab62c7bf24634(e) {
    while(!$298fb931ed4fbf8b$export$9e1725a4cfeada27($298fb931ed4fbf8b$export$4d3fb11e950abb9e()))$298fb931ed4fbf8b$export$48cfd1e771a65c4f();
    return $298fb931ed4fbf8b$export$58adb3bec8346d0f(e, $298fb931ed4fbf8b$export$5880b8b5730aff45);
}
function $298fb931ed4fbf8b$export$ef7acd7185315e22(e) {
    return $298fb931ed4fbf8b$export$45918ac1574455b1($298fb931ed4fbf8b$export$98e6a39c04603d36("", null, null, null, [
        ""
    ], e = $298fb931ed4fbf8b$export$2de70f21292aac9e(e), 0, [
        0
    ], e));
}
function $298fb931ed4fbf8b$export$98e6a39c04603d36(e, r, a, n, c, s, t, u, i) {
    var f = 0;
    var o = 0;
    var l = t;
    var v = 0;
    var p = 0;
    var h = 0;
    var b = 1;
    var w = 1;
    var d = 1;
    var $ = 0;
    var g = "";
    var m = c;
    var x = s;
    var y = n;
    var j = g;
    while(w)switch(h = $, $ = $298fb931ed4fbf8b$export$48cfd1e771a65c4f()){
        case 40:
            if (h != 108 && $298fb931ed4fbf8b$export$a9db5e087081082d(j, l - 1) == 58) {
                if ($298fb931ed4fbf8b$export$f8e21b1e77979a08(j += $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed($298fb931ed4fbf8b$export$410ac95b9ec204b8($), "&", "&\f"), "&\f") != -1) d = -1;
                break;
            }
        case 34:
        case 39:
        case 91:
            j += $298fb931ed4fbf8b$export$410ac95b9ec204b8($);
            break;
        case 9:
        case 10:
        case 13:
        case 32:
            j += $298fb931ed4fbf8b$export$7af1228ff777d175(h);
            break;
        case 92:
            j += $298fb931ed4fbf8b$export$955ba06d119e085e($298fb931ed4fbf8b$export$e88cb2efb12ae807() - 1, 7);
            continue;
        case 47:
            switch($298fb931ed4fbf8b$export$4d3fb11e950abb9e()){
                case 42:
                case 47:
                    $298fb931ed4fbf8b$export$10d8903dec122b9d($298fb931ed4fbf8b$export$4a34f930e789283c($298fb931ed4fbf8b$export$4254d4e2b3745c4c($298fb931ed4fbf8b$export$48cfd1e771a65c4f(), $298fb931ed4fbf8b$export$e88cb2efb12ae807()), r, a), i);
                    break;
                default:
                    j += "/";
            }
            break;
        case 123 * b:
            u[f++] = $298fb931ed4fbf8b$export$36776f635604f274(j) * d;
        case 125 * b:
        case 59:
        case 0:
            switch($){
                case 0:
                case 125:
                    w = 0;
                case 59 + o:
                    if (d == -1) j = $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(j, /\f/g, "");
                    if (p > 0 && $298fb931ed4fbf8b$export$36776f635604f274(j) - l) $298fb931ed4fbf8b$export$10d8903dec122b9d(p > 32 ? $298fb931ed4fbf8b$export$f8483753829ec8f3(j + ";", n, a, l - 1) : $298fb931ed4fbf8b$export$f8483753829ec8f3($298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(j, " ", "") + ";", n, a, l - 2), i);
                    break;
                case 59:
                    j += ";";
                default:
                    $298fb931ed4fbf8b$export$10d8903dec122b9d(y = $298fb931ed4fbf8b$export$3307ffa7023ede1e(j, r, a, f, o, c, u, g, m = [], x = [], l), s);
                    if ($ === 123) {
                        if (o === 0) $298fb931ed4fbf8b$export$98e6a39c04603d36(j, r, y, y, m, s, l, u, x);
                        else switch(v === 99 && $298fb931ed4fbf8b$export$a9db5e087081082d(j, 3) === 110 ? 100 : v){
                            case 100:
                            case 108:
                            case 109:
                            case 115:
                                $298fb931ed4fbf8b$export$98e6a39c04603d36(e, y, y, n && $298fb931ed4fbf8b$export$10d8903dec122b9d($298fb931ed4fbf8b$export$3307ffa7023ede1e(e, y, y, 0, 0, c, u, g, c, m = [], l), x), c, x, l, u, n ? m : x);
                                break;
                            default:
                                $298fb931ed4fbf8b$export$98e6a39c04603d36(j, y, y, y, [
                                    ""
                                ], x, 0, u, x);
                        }
                    }
            }
            f = o = p = 0, b = d = 1, g = j = "", l = t;
            break;
        case 58:
            l = 1 + $298fb931ed4fbf8b$export$36776f635604f274(j), p = h;
        default:
            if (b < 1) {
                if ($ == 123) --b;
                else if ($ == 125 && b++ == 0 && $298fb931ed4fbf8b$export$232faf9add678146() == 125) continue;
            }
            switch(j += $298fb931ed4fbf8b$export$6788812c4e6611e6($), $ * b){
                case 38:
                    d = o > 0 ? 1 : (j += "\f", -1);
                    break;
                case 44:
                    u[f++] = ($298fb931ed4fbf8b$export$36776f635604f274(j) - 1) * d, d = 1;
                    break;
                case 64:
                    if ($298fb931ed4fbf8b$export$4d3fb11e950abb9e() === 45) j += $298fb931ed4fbf8b$export$410ac95b9ec204b8($298fb931ed4fbf8b$export$48cfd1e771a65c4f());
                    v = $298fb931ed4fbf8b$export$4d3fb11e950abb9e(), o = l = $298fb931ed4fbf8b$export$36776f635604f274(g = j += $298fb931ed4fbf8b$export$c2ab62c7bf24634($298fb931ed4fbf8b$export$e88cb2efb12ae807())), $++;
                    break;
                case 45:
                    if (h === 45 && $298fb931ed4fbf8b$export$36776f635604f274(j) == 2) b = 0;
            }
    }
    return s;
}
function $298fb931ed4fbf8b$export$3307ffa7023ede1e(e, r, a, n, s, t, u, i, f, o, l) {
    var v = s - 1;
    var p = s === 0 ? t : [
        ""
    ];
    var h = $298fb931ed4fbf8b$export$f9084667e487ed46(p);
    for(var b = 0, w = 0, d = 0; b < n; ++b)for(var $ = 0, k = $298fb931ed4fbf8b$export$2f35ab04d2335697(e, v + 1, v = $298fb931ed4fbf8b$export$2335f513bbd82c6d(w = u[b])), m = e; $ < h; ++$)if (m = $298fb931ed4fbf8b$export$87c2784dc9fc4ab(w > 0 ? p[$] + " " + k : $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(k, /&\f/g, p[$]))) f[d++] = m;
    return $298fb931ed4fbf8b$export$35059013cd4a06db(e, r, a, s === 0 ? $298fb931ed4fbf8b$export$aa3a2e812ca8570d : i, f, o, l);
}
function $298fb931ed4fbf8b$export$4a34f930e789283c(e, r, a) {
    return $298fb931ed4fbf8b$export$35059013cd4a06db(e, r, a, $298fb931ed4fbf8b$export$a29989082612d0d9, $298fb931ed4fbf8b$export$6788812c4e6611e6($298fb931ed4fbf8b$export$eba6f6f03b0a92e7()), $298fb931ed4fbf8b$export$2f35ab04d2335697(e, 2, -2), 0);
}
function $298fb931ed4fbf8b$export$f8483753829ec8f3(e, r, a, n) {
    return $298fb931ed4fbf8b$export$35059013cd4a06db(e, r, a, $298fb931ed4fbf8b$export$527d108ccf083c2b, $298fb931ed4fbf8b$export$2f35ab04d2335697(e, 0, n), $298fb931ed4fbf8b$export$2f35ab04d2335697(e, n + 1, -1), n);
}
function $298fb931ed4fbf8b$export$82e9f45cca5ba907(n, c, s) {
    switch($298fb931ed4fbf8b$export$d6af199866bfb566(n, c)){
        case 5103:
            return $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + "print-" + n + n;
        case 5737:
        case 4201:
        case 3177:
        case 3433:
        case 1641:
        case 4457:
        case 2921:
        case 5572:
        case 6356:
        case 5844:
        case 3191:
        case 6645:
        case 3005:
        case 6391:
        case 5879:
        case 5623:
        case 6135:
        case 4599:
        case 4855:
        case 4215:
        case 6389:
        case 5109:
        case 5365:
        case 5621:
        case 3829:
            return $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + n + n;
        case 4789:
            return $298fb931ed4fbf8b$export$2c0f367103c8d01c + n + n;
        case 5349:
        case 4246:
        case 4810:
        case 6968:
        case 2756:
            return $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + n + $298fb931ed4fbf8b$export$2c0f367103c8d01c + n + $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + n + n;
        case 5936:
            switch($298fb931ed4fbf8b$export$a9db5e087081082d(n, c + 11)){
                case 114:
                    return $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + n + $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, /[svh]\w+-[tblr]{2}/, "tb") + n;
                case 108:
                    return $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + n + $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, /[svh]\w+-[tblr]{2}/, "tb-rl") + n;
                case 45:
                    return $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + n + $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, /[svh]\w+-[tblr]{2}/, "lr") + n;
            }
        case 6828:
        case 4268:
        case 2903:
            return $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + n + $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + n + n;
        case 6165:
            return $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + n + $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + "flex-" + n + n;
        case 5187:
            return $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + n + $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, /(\w+).+(:[^]+)/, $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + "box-$1$2" + $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + "flex-$1$2") + n;
        case 5443:
            return $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + n + $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + "flex-item-" + $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, /flex-|-self/g, "") + (!$298fb931ed4fbf8b$export$4659b591c19bdf3d(n, /flex-|baseline/) ? $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + "grid-row-" + $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, /flex-|-self/g, "") : "") + n;
        case 4675:
            return $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + n + $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + "flex-line-pack" + $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, /align-content|flex-|-self/g, "") + n;
        case 5548:
            return $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + n + $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, "shrink", "negative") + n;
        case 5292:
            return $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + n + $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, "basis", "preferred-size") + n;
        case 6060:
            return $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + "box-" + $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, "-grow", "") + $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + n + $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, "grow", "positive") + n;
        case 4554:
            return $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, /([^-])(transform)/g, "$1" + $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + "$2") + n;
        case 6187:
            return $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed($298fb931ed4fbf8b$export$77ad94ebf1c2b9ed($298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, /(zoom-|grab)/, $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + "$1"), /(image-set)/, $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + "$1"), n, "") + n;
        case 5495:
        case 3959:
            return $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, /(image-set\([^]*)/, $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + "$1" + "$`$1");
        case 4968:
            return $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed($298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, /(.+:)(flex-)?(.*)/, $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + "box-pack:$3" + $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + "flex-pack:$3"), /s.+-b[^;]+/, "justify") + $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + n + n;
        case 4200:
            if (!$298fb931ed4fbf8b$export$4659b591c19bdf3d(n, /flex-|baseline/)) return $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + "grid-column-align" + $298fb931ed4fbf8b$export$2f35ab04d2335697(n, c) + n;
            break;
        case 2592:
        case 3360:
            return $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, "template-", "") + n;
        case 4384:
        case 3616:
            if (s && s.some(function(e, r) {
                return c = r, $298fb931ed4fbf8b$export$4659b591c19bdf3d(e.props, /grid-\w+-end/);
            })) return ~$298fb931ed4fbf8b$export$f8e21b1e77979a08(n + (s = s[c].value), "span") ? n : $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, "-start", "") + n + $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + "grid-row-span:" + (~$298fb931ed4fbf8b$export$f8e21b1e77979a08(s, "span") ? $298fb931ed4fbf8b$export$4659b591c19bdf3d(s, /\d+/) : +$298fb931ed4fbf8b$export$4659b591c19bdf3d(s, /\d+/) - +$298fb931ed4fbf8b$export$4659b591c19bdf3d(n, /\d+/)) + ";";
            return $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, "-start", "") + n;
        case 4896:
        case 4128:
            return s && s.some(function(e) {
                return $298fb931ed4fbf8b$export$4659b591c19bdf3d(e.props, /grid-\w+-start/);
            }) ? n : $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed($298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, "-end", "-span"), "span ", "") + n;
        case 4095:
        case 3583:
        case 4068:
        case 2532:
            return $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, /(.+)-inline(.+)/, $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + "$1$2") + n;
        case 8116:
        case 7059:
        case 5753:
        case 5535:
        case 5445:
        case 5701:
        case 4933:
        case 4677:
        case 5533:
        case 5789:
        case 5021:
        case 4765:
            if ($298fb931ed4fbf8b$export$36776f635604f274(n) - 1 - c > 6) switch($298fb931ed4fbf8b$export$a9db5e087081082d(n, c + 1)){
                case 109:
                    if ($298fb931ed4fbf8b$export$a9db5e087081082d(n, c + 4) !== 45) break;
                case 102:
                    return $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, /(.+:)(.+)-([^]+)/, "$1" + $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + "$2-$3" + "$1" + $298fb931ed4fbf8b$export$2c0f367103c8d01c + ($298fb931ed4fbf8b$export$a9db5e087081082d(n, c + 3) == 108 ? "$3" : "$2-$3")) + n;
                case 115:
                    return ~$298fb931ed4fbf8b$export$f8e21b1e77979a08(n, "stretch") ? $298fb931ed4fbf8b$export$82e9f45cca5ba907($298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, "stretch", "fill-available"), c, s) + n : n;
            }
            break;
        case 5152:
        case 5920:
            return $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, /(.+?):(\d+)(\s*\/\s*(span)?\s*(\d+))?(.*)/, function(r, a, c, s, t, u, i) {
                return $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + a + ":" + c + i + (s ? $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + a + "-span:" + (t ? u : +u - +c) + i : "") + n;
            });
        case 4949:
            if ($298fb931ed4fbf8b$export$a9db5e087081082d(n, c + 6) === 121) return $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, ":", ":" + $298fb931ed4fbf8b$export$39dfd62a25e0fe93) + n;
            break;
        case 6444:
            switch($298fb931ed4fbf8b$export$a9db5e087081082d(n, $298fb931ed4fbf8b$export$a9db5e087081082d(n, 14) === 45 ? 18 : 11)){
                case 120:
                    return $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, /(.+:)([^;\s!]+)(;|(\s+)?!.+)?/, "$1" + $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + ($298fb931ed4fbf8b$export$a9db5e087081082d(n, 14) === 45 ? "inline-" : "") + "box$3" + "$1" + $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + "$2$3" + "$1" + $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + "$2box$3") + n;
                case 100:
                    return $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, ":", ":" + $298fb931ed4fbf8b$export$71ad59f2e432cfe8) + n;
            }
            break;
        case 5719:
        case 2647:
        case 2135:
        case 3927:
        case 2391:
            return $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, "scroll-", "scroll-snap-") + n;
    }
    return n;
}
function $298fb931ed4fbf8b$export$dfdc1655ccc5b9cb(e, r) {
    var a = "";
    var n = $298fb931ed4fbf8b$export$f9084667e487ed46(e);
    for(var c = 0; c < n; c++)a += r(e[c], c, e, r) || "";
    return a;
}
function $298fb931ed4fbf8b$export$fac44ee5b035f737(e, r, a, t) {
    switch(e.type){
        case $298fb931ed4fbf8b$export$d773506282b3cfe6:
            if (e.children.length) break;
        case $298fb931ed4fbf8b$export$a763edbf796b780a:
        case $298fb931ed4fbf8b$export$527d108ccf083c2b:
            return e.return = e.return || e.value;
        case $298fb931ed4fbf8b$export$a29989082612d0d9:
            return "";
        case $298fb931ed4fbf8b$export$b44a8529a35fcb60:
            return e.return = e.value + "{" + $298fb931ed4fbf8b$export$dfdc1655ccc5b9cb(e.children, t) + "}";
        case $298fb931ed4fbf8b$export$aa3a2e812ca8570d:
            e.value = e.props.join(",");
    }
    return $298fb931ed4fbf8b$export$36776f635604f274(a = $298fb931ed4fbf8b$export$dfdc1655ccc5b9cb(e.children, t)) ? e.return = e.value + "{" + a + "}" : "";
}
function $298fb931ed4fbf8b$export$5a7767152ae0305f(e) {
    var r = $298fb931ed4fbf8b$export$f9084667e487ed46(e);
    return function(a, n, c, s) {
        var t = "";
        for(var u = 0; u < r; u++)t += e[u](a, n, c, s) || "";
        return t;
    };
}
function $298fb931ed4fbf8b$export$38bcb760f1d4871c(e) {
    return function(r) {
        if (!r.root) {
            if (r = r.return) e(r);
        }
    };
}
function $298fb931ed4fbf8b$export$e08c7d021b829b7a(n, t, u, i) {
    if (n.length > -1) {
        if (!n.return) switch(n.type){
            case $298fb931ed4fbf8b$export$527d108ccf083c2b:
                n.return = $298fb931ed4fbf8b$export$82e9f45cca5ba907(n.value, n.length, u);
                return;
            case $298fb931ed4fbf8b$export$b44a8529a35fcb60:
                return $298fb931ed4fbf8b$export$dfdc1655ccc5b9cb([
                    $298fb931ed4fbf8b$export$784d13d8ee351f07(n, {
                        value: $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n.value, "@", "@" + $298fb931ed4fbf8b$export$39dfd62a25e0fe93)
                    })
                ], i);
            case $298fb931ed4fbf8b$export$aa3a2e812ca8570d:
                if (n.length) return $298fb931ed4fbf8b$export$1be1fc439b849fdf(n.props, function(c) {
                    switch($298fb931ed4fbf8b$export$4659b591c19bdf3d(c, /(::plac\w+|:read-\w+)/)){
                        case ":read-only":
                        case ":read-write":
                            return $298fb931ed4fbf8b$export$dfdc1655ccc5b9cb([
                                $298fb931ed4fbf8b$export$784d13d8ee351f07(n, {
                                    props: [
                                        $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(c, /:(read-\w+)/, ":" + $298fb931ed4fbf8b$export$2c0f367103c8d01c + "$1")
                                    ]
                                })
                            ], i);
                        case "::placeholder":
                            return $298fb931ed4fbf8b$export$dfdc1655ccc5b9cb([
                                $298fb931ed4fbf8b$export$784d13d8ee351f07(n, {
                                    props: [
                                        $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(c, /:(plac\w+)/, ":" + $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + "input-$1")
                                    ]
                                }),
                                $298fb931ed4fbf8b$export$784d13d8ee351f07(n, {
                                    props: [
                                        $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(c, /:(plac\w+)/, ":" + $298fb931ed4fbf8b$export$2c0f367103c8d01c + "$1")
                                    ]
                                }),
                                $298fb931ed4fbf8b$export$784d13d8ee351f07(n, {
                                    props: [
                                        $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(c, /:(plac\w+)/, $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + "input-$1")
                                    ]
                                })
                            ], i);
                    }
                    return "";
                });
        }
    }
}
function $298fb931ed4fbf8b$export$76a88f7de6507443(e) {
    switch(e.type){
        case $298fb931ed4fbf8b$export$aa3a2e812ca8570d:
            e.props = e.props.map(function(r) {
                return $298fb931ed4fbf8b$export$1be1fc439b849fdf($298fb931ed4fbf8b$export$660b2ee2d4fb4eff(r), function(r, a, n) {
                    switch($298fb931ed4fbf8b$export$a9db5e087081082d(r, 0)){
                        case 12:
                            return $298fb931ed4fbf8b$export$2f35ab04d2335697(r, 1, $298fb931ed4fbf8b$export$36776f635604f274(r));
                        case 0:
                        case 40:
                        case 43:
                        case 62:
                        case 126:
                            return r;
                        case 58:
                            if (n[++a] === "global") n[a] = "", n[++a] = "\f" + $298fb931ed4fbf8b$export$2f35ab04d2335697(n[a], a = 1, -1);
                        case 32:
                            return a === 1 ? "" : r;
                        default:
                            switch(a){
                                case 0:
                                    e = r;
                                    return $298fb931ed4fbf8b$export$f9084667e487ed46(n) > 1 ? "" : r;
                                case a = $298fb931ed4fbf8b$export$f9084667e487ed46(n) - 1:
                                case 2:
                                    return a === 2 ? r + e + e : r + e;
                                default:
                                    return r;
                            }
                    }
                });
            });
    }
}


var $d68ffb0773f38e18$export$2e2bcd8739ae039 = function weakMemoize(func) {
    // $FlowFixMe flow doesn't include all non-primitive types as allowed for weakmaps
    var cache = new WeakMap();
    return function(arg) {
        if (cache.has(arg)) // $FlowFixMe
        return cache.get(arg);
        var ret = func(arg);
        cache.set(arg, ret);
        return ret;
    };
};


function $6bb1e54ce1bc6efa$export$2e2bcd8739ae039(fn) {
    var cache = Object.create(null);
    return function(arg) {
        if (cache[arg] === undefined) cache[arg] = fn(arg);
        return cache[arg];
    };
}


var $fc182b1f84212d3f$var$identifierWithPointTracking = function identifierWithPointTracking(begin, points, index) {
    var previous = 0;
    var character = 0;
    while(true){
        previous = character;
        character = (0, $298fb931ed4fbf8b$export$4d3fb11e950abb9e)(); // &\f
        if (previous === 38 && character === 12) points[index] = 1;
        if ((0, $298fb931ed4fbf8b$export$9e1725a4cfeada27)(character)) break;
        (0, $298fb931ed4fbf8b$export$48cfd1e771a65c4f)();
    }
    return (0, $298fb931ed4fbf8b$export$58adb3bec8346d0f)(begin, (0, $298fb931ed4fbf8b$export$5880b8b5730aff45));
};
var $fc182b1f84212d3f$var$toRules = function toRules(parsed, points) {
    // pretend we've started with a comma
    var index = -1;
    var character = 44;
    do switch((0, $298fb931ed4fbf8b$export$9e1725a4cfeada27)(character)){
        case 0:
            // &\f
            if (character === 38 && (0, $298fb931ed4fbf8b$export$4d3fb11e950abb9e)() === 12) // this is not 100% correct, we don't account for literal sequences here - like for example quoted strings
            // stylis inserts \f after & to know when & where it should replace this sequence with the context selector
            // and when it should just concatenate the outer and inner selectors
            // it's very unlikely for this sequence to actually appear in a different context, so we just leverage this fact here
            points[index] = 1;
            parsed[index] += $fc182b1f84212d3f$var$identifierWithPointTracking((0, $298fb931ed4fbf8b$export$5880b8b5730aff45) - 1, points, index);
            break;
        case 2:
            parsed[index] += (0, $298fb931ed4fbf8b$export$410ac95b9ec204b8)(character);
            break;
        case 4:
            // comma
            if (character === 44) {
                // colon
                parsed[++index] = (0, $298fb931ed4fbf8b$export$4d3fb11e950abb9e)() === 58 ? "&\f" : "";
                points[index] = parsed[index].length;
                break;
            }
        // fallthrough
        default:
            parsed[index] += (0, $298fb931ed4fbf8b$export$6788812c4e6611e6)(character);
    }
    while (character = (0, $298fb931ed4fbf8b$export$48cfd1e771a65c4f)());
    return parsed;
};
var $fc182b1f84212d3f$var$getRules = function getRules(value, points) {
    return (0, $298fb931ed4fbf8b$export$45918ac1574455b1)($fc182b1f84212d3f$var$toRules((0, $298fb931ed4fbf8b$export$2de70f21292aac9e)(value), points));
}; // WeakSet would be more appropriate, but only WeakMap is supported in IE11
var $fc182b1f84212d3f$var$fixedElements = /* #__PURE__ */ new WeakMap();
var $fc182b1f84212d3f$var$compat = function compat(element) {
    if (element.type !== "rule" || !element.parent || // positive .length indicates that this rule contains pseudo
    // negative .length indicates that this rule has been already prefixed
    element.length < 1) return;
    var value = element.value, parent = element.parent;
    var isImplicitRule = element.column === parent.column && element.line === parent.line;
    while(parent.type !== "rule"){
        parent = parent.parent;
        if (!parent) return;
    } // short-circuit for the simplest case
    if (element.props.length === 1 && value.charCodeAt(0) !== 58 && !$fc182b1f84212d3f$var$fixedElements.get(parent)) return;
     // if this is an implicitly inserted rule (the one eagerly inserted at the each new nested level)
    // then the props has already been manipulated beforehand as they that array is shared between it and its "rule parent"
    if (isImplicitRule) return;
    $fc182b1f84212d3f$var$fixedElements.set(element, true);
    var points = [];
    var rules = $fc182b1f84212d3f$var$getRules(value, points);
    var parentRules = parent.props;
    for(var i = 0, k = 0; i < rules.length; i++)for(var j = 0; j < parentRules.length; j++, k++)element.props[k] = points[i] ? rules[i].replace(/&\f/g, parentRules[j]) : parentRules[j] + " " + rules[i];
};
var $fc182b1f84212d3f$var$removeLabel = function removeLabel(element) {
    if (element.type === "decl") {
        var value = element.value;
        if (value.charCodeAt(0) === 108 && // charcode for b
        value.charCodeAt(2) === 98) {
            // this ignores label
            element["return"] = "";
            element.value = "";
        }
    }
};
var $fc182b1f84212d3f$var$ignoreFlag = "emotion-disable-server-rendering-unsafe-selector-warning-please-do-not-use-this-the-warning-exists-for-a-reason";
var $fc182b1f84212d3f$var$isIgnoringComment = function isIgnoringComment(element) {
    return element.type === "comm" && element.children.indexOf($fc182b1f84212d3f$var$ignoreFlag) > -1;
};
var $fc182b1f84212d3f$var$createUnsafeSelectorsAlarm = function createUnsafeSelectorsAlarm(cache) {
    return function(element, index, children) {
        if (element.type !== "rule" || cache.compat) return;
        var unsafePseudoClasses = element.value.match(/(:first|:nth|:nth-last)-child/g);
        if (unsafePseudoClasses) {
            var isNested = !!element.parent; // in nested rules comments become children of the "auto-inserted" rule and that's always the `element.parent`
            //
            // considering this input:
            // .a {
            //   .b /* comm */ {}
            //   color: hotpink;
            // }
            // we get output corresponding to this:
            // .a {
            //   & {
            //     /* comm */
            //     color: hotpink;
            //   }
            //   .b {}
            // }
            var commentContainer = isNested ? element.parent.children : children;
            for(var i = commentContainer.length - 1; i >= 0; i--){
                var node = commentContainer[i];
                if (node.line < element.line) break;
                 // it is quite weird but comments are *usually* put at `column: element.column - 1`
                // so we seek *from the end* for the node that is earlier than the rule's `element` and check that
                // this will also match inputs like this:
                // .a {
                //   /* comm */
                //   .b {}
                // }
                //
                // but that is fine
                //
                // it would be the easiest to change the placement of the comment to be the first child of the rule:
                // .a {
                //   .b { /* comm */ }
                // }
                // with such inputs we wouldn't have to search for the comment at all
                // TODO: consider changing this comment placement in the next major version
                if (node.column < element.column) {
                    if ($fc182b1f84212d3f$var$isIgnoringComment(node)) return;
                    break;
                }
            }
            unsafePseudoClasses.forEach(function(unsafePseudoClass) {
                console.error('The pseudo class "' + unsafePseudoClass + '" is potentially unsafe when doing server-side rendering. Try changing it to "' + unsafePseudoClass.split("-child")[0] + '-of-type".');
            });
        }
    };
};
var $fc182b1f84212d3f$var$isImportRule = function isImportRule(element) {
    return element.type.charCodeAt(1) === 105 && element.type.charCodeAt(0) === 64;
};
var $fc182b1f84212d3f$var$isPrependedWithRegularRules = function isPrependedWithRegularRules(index, children) {
    for(var i = index - 1; i >= 0; i--){
        if (!$fc182b1f84212d3f$var$isImportRule(children[i])) return true;
    }
    return false;
}; // use this to remove incorrect elements from further processing
// so they don't get handed to the `sheet` (or anything else)
// as that could potentially lead to additional logs which in turn could be overhelming to the user
var $fc182b1f84212d3f$var$nullifyElement = function nullifyElement(element) {
    element.type = "";
    element.value = "";
    element["return"] = "";
    element.children = "";
    element.props = "";
};
var $fc182b1f84212d3f$var$incorrectImportAlarm = function incorrectImportAlarm(element, index, children) {
    if (!$fc182b1f84212d3f$var$isImportRule(element)) return;
    if (element.parent) {
        console.error("`@import` rules can't be nested inside other rules. Please move it to the top level and put it before regular rules. Keep in mind that they can only be used within global styles.");
        $fc182b1f84212d3f$var$nullifyElement(element);
    } else if ($fc182b1f84212d3f$var$isPrependedWithRegularRules(index, children)) {
        console.error("`@import` rules can't be after other rules. Please put your `@import` rules before your other rules.");
        $fc182b1f84212d3f$var$nullifyElement(element);
    }
};
/* eslint-disable no-fallthrough */ function $fc182b1f84212d3f$var$prefix(value, length) {
    switch((0, $298fb931ed4fbf8b$export$d6af199866bfb566)(value, length)){
        // color-adjust
        case 5103:
            return (0, $298fb931ed4fbf8b$export$39dfd62a25e0fe93) + "print-" + value + value;
        // animation, animation-(delay|direction|duration|fill-mode|iteration-count|name|play-state|timing-function)
        case 5737:
        case 4201:
        case 3177:
        case 3433:
        case 1641:
        case 4457:
        case 2921:
        case 5572:
        case 6356:
        case 5844:
        case 3191:
        case 6645:
        case 3005:
        case 6391:
        case 5879:
        case 5623:
        case 6135:
        case 4599:
        case 4855:
        case 4215:
        case 6389:
        case 5109:
        case 5365:
        case 5621:
        case 3829:
            return (0, $298fb931ed4fbf8b$export$39dfd62a25e0fe93) + value + value;
        // appearance, user-select, transform, hyphens, text-size-adjust
        case 5349:
        case 4246:
        case 4810:
        case 6968:
        case 2756:
            return (0, $298fb931ed4fbf8b$export$39dfd62a25e0fe93) + value + (0, $298fb931ed4fbf8b$export$2c0f367103c8d01c) + value + (0, $298fb931ed4fbf8b$export$71ad59f2e432cfe8) + value + value;
        // flex, flex-direction
        case 6828:
        case 4268:
            return (0, $298fb931ed4fbf8b$export$39dfd62a25e0fe93) + value + (0, $298fb931ed4fbf8b$export$71ad59f2e432cfe8) + value + value;
        // order
        case 6165:
            return (0, $298fb931ed4fbf8b$export$39dfd62a25e0fe93) + value + (0, $298fb931ed4fbf8b$export$71ad59f2e432cfe8) + "flex-" + value + value;
        // align-items
        case 5187:
            return (0, $298fb931ed4fbf8b$export$39dfd62a25e0fe93) + value + (0, $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed)(value, /(\w+).+(:[^]+)/, (0, $298fb931ed4fbf8b$export$39dfd62a25e0fe93) + "box-$1$2" + (0, $298fb931ed4fbf8b$export$71ad59f2e432cfe8) + "flex-$1$2") + value;
        // align-self
        case 5443:
            return (0, $298fb931ed4fbf8b$export$39dfd62a25e0fe93) + value + (0, $298fb931ed4fbf8b$export$71ad59f2e432cfe8) + "flex-item-" + (0, $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed)(value, /flex-|-self/, "") + value;
        // align-content
        case 4675:
            return (0, $298fb931ed4fbf8b$export$39dfd62a25e0fe93) + value + (0, $298fb931ed4fbf8b$export$71ad59f2e432cfe8) + "flex-line-pack" + (0, $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed)(value, /align-content|flex-|-self/, "") + value;
        // flex-shrink
        case 5548:
            return (0, $298fb931ed4fbf8b$export$39dfd62a25e0fe93) + value + (0, $298fb931ed4fbf8b$export$71ad59f2e432cfe8) + (0, $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed)(value, "shrink", "negative") + value;
        // flex-basis
        case 5292:
            return (0, $298fb931ed4fbf8b$export$39dfd62a25e0fe93) + value + (0, $298fb931ed4fbf8b$export$71ad59f2e432cfe8) + (0, $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed)(value, "basis", "preferred-size") + value;
        // flex-grow
        case 6060:
            return (0, $298fb931ed4fbf8b$export$39dfd62a25e0fe93) + "box-" + (0, $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed)(value, "-grow", "") + (0, $298fb931ed4fbf8b$export$39dfd62a25e0fe93) + value + (0, $298fb931ed4fbf8b$export$71ad59f2e432cfe8) + (0, $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed)(value, "grow", "positive") + value;
        // transition
        case 4554:
            return (0, $298fb931ed4fbf8b$export$39dfd62a25e0fe93) + (0, $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed)(value, /([^-])(transform)/g, "$1" + (0, $298fb931ed4fbf8b$export$39dfd62a25e0fe93) + "$2") + value;
        // cursor
        case 6187:
            return (0, $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed)((0, $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed)((0, $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed)(value, /(zoom-|grab)/, (0, $298fb931ed4fbf8b$export$39dfd62a25e0fe93) + "$1"), /(image-set)/, (0, $298fb931ed4fbf8b$export$39dfd62a25e0fe93) + "$1"), value, "") + value;
        // background, background-image
        case 5495:
        case 3959:
            return (0, $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed)(value, /(image-set\([^]*)/, (0, $298fb931ed4fbf8b$export$39dfd62a25e0fe93) + "$1" + "$`$1");
        // justify-content
        case 4968:
            return (0, $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed)((0, $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed)(value, /(.+:)(flex-)?(.*)/, (0, $298fb931ed4fbf8b$export$39dfd62a25e0fe93) + "box-pack:$3" + (0, $298fb931ed4fbf8b$export$71ad59f2e432cfe8) + "flex-pack:$3"), /s.+-b[^;]+/, "justify") + (0, $298fb931ed4fbf8b$export$39dfd62a25e0fe93) + value + value;
        // (margin|padding)-inline-(start|end)
        case 4095:
        case 3583:
        case 4068:
        case 2532:
            return (0, $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed)(value, /(.+)-inline(.+)/, (0, $298fb931ed4fbf8b$export$39dfd62a25e0fe93) + "$1$2") + value;
        // (min|max)?(width|height|inline-size|block-size)
        case 8116:
        case 7059:
        case 5753:
        case 5535:
        case 5445:
        case 5701:
        case 4933:
        case 4677:
        case 5533:
        case 5789:
        case 5021:
        case 4765:
            // stretch, max-content, min-content, fill-available
            if ((0, $298fb931ed4fbf8b$export$36776f635604f274)(value) - 1 - length > 6) switch((0, $298fb931ed4fbf8b$export$a9db5e087081082d)(value, length + 1)){
                // (m)ax-content, (m)in-content
                case 109:
                    // -
                    if ((0, $298fb931ed4fbf8b$export$a9db5e087081082d)(value, length + 4) !== 45) break;
                // (f)ill-available, (f)it-content
                case 102:
                    return (0, $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed)(value, /(.+:)(.+)-([^]+)/, "$1" + (0, $298fb931ed4fbf8b$export$39dfd62a25e0fe93) + "$2-$3" + "$1" + (0, $298fb931ed4fbf8b$export$2c0f367103c8d01c) + ((0, $298fb931ed4fbf8b$export$a9db5e087081082d)(value, length + 3) == 108 ? "$3" : "$2-$3")) + value;
                // (s)tretch
                case 115:
                    return ~(0, $298fb931ed4fbf8b$export$f8e21b1e77979a08)(value, "stretch") ? $fc182b1f84212d3f$var$prefix((0, $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed)(value, "stretch", "fill-available"), length) + value : value;
            }
            break;
        // position: sticky
        case 4949:
            // (s)ticky?
            if ((0, $298fb931ed4fbf8b$export$a9db5e087081082d)(value, length + 1) !== 115) break;
        // display: (flex|inline-flex)
        case 6444:
            switch((0, $298fb931ed4fbf8b$export$a9db5e087081082d)(value, (0, $298fb931ed4fbf8b$export$36776f635604f274)(value) - 3 - (~(0, $298fb931ed4fbf8b$export$f8e21b1e77979a08)(value, "!important") && 10))){
                // stic(k)y
                case 107:
                    return (0, $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed)(value, ":", ":" + (0, $298fb931ed4fbf8b$export$39dfd62a25e0fe93)) + value;
                // (inline-)?fl(e)x
                case 101:
                    return (0, $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed)(value, /(.+:)([^;!]+)(;|!.+)?/, "$1" + (0, $298fb931ed4fbf8b$export$39dfd62a25e0fe93) + ((0, $298fb931ed4fbf8b$export$a9db5e087081082d)(value, 14) === 45 ? "inline-" : "") + "box$3" + "$1" + (0, $298fb931ed4fbf8b$export$39dfd62a25e0fe93) + "$2$3" + "$1" + (0, $298fb931ed4fbf8b$export$71ad59f2e432cfe8) + "$2box$3") + value;
            }
            break;
        // writing-mode
        case 5936:
            switch((0, $298fb931ed4fbf8b$export$a9db5e087081082d)(value, length + 11)){
                // vertical-l(r)
                case 114:
                    return (0, $298fb931ed4fbf8b$export$39dfd62a25e0fe93) + value + (0, $298fb931ed4fbf8b$export$71ad59f2e432cfe8) + (0, $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed)(value, /[svh]\w+-[tblr]{2}/, "tb") + value;
                // vertical-r(l)
                case 108:
                    return (0, $298fb931ed4fbf8b$export$39dfd62a25e0fe93) + value + (0, $298fb931ed4fbf8b$export$71ad59f2e432cfe8) + (0, $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed)(value, /[svh]\w+-[tblr]{2}/, "tb-rl") + value;
                // horizontal(-)tb
                case 45:
                    return (0, $298fb931ed4fbf8b$export$39dfd62a25e0fe93) + value + (0, $298fb931ed4fbf8b$export$71ad59f2e432cfe8) + (0, $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed)(value, /[svh]\w+-[tblr]{2}/, "lr") + value;
            }
            return (0, $298fb931ed4fbf8b$export$39dfd62a25e0fe93) + value + (0, $298fb931ed4fbf8b$export$71ad59f2e432cfe8) + value + value;
    }
    return value;
}
var $fc182b1f84212d3f$var$prefixer = function prefixer(element, index, children, callback) {
    if (element.length > -1) {
        if (!element["return"]) switch(element.type){
            case 0, $298fb931ed4fbf8b$export$527d108ccf083c2b:
                element["return"] = $fc182b1f84212d3f$var$prefix(element.value, element.length);
                break;
            case 0, $298fb931ed4fbf8b$export$b44a8529a35fcb60:
                return (0, $298fb931ed4fbf8b$export$dfdc1655ccc5b9cb)([
                    (0, $298fb931ed4fbf8b$export$784d13d8ee351f07)(element, {
                        value: (0, $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed)(element.value, "@", "@" + (0, $298fb931ed4fbf8b$export$39dfd62a25e0fe93))
                    })
                ], callback);
            case 0, $298fb931ed4fbf8b$export$aa3a2e812ca8570d:
                if (element.length) return (0, $298fb931ed4fbf8b$export$1be1fc439b849fdf)(element.props, function(value) {
                    switch((0, $298fb931ed4fbf8b$export$4659b591c19bdf3d)(value, /(::plac\w+|:read-\w+)/)){
                        // :read-(only|write)
                        case ":read-only":
                        case ":read-write":
                            return (0, $298fb931ed4fbf8b$export$dfdc1655ccc5b9cb)([
                                (0, $298fb931ed4fbf8b$export$784d13d8ee351f07)(element, {
                                    props: [
                                        (0, $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed)(value, /:(read-\w+)/, ":" + (0, $298fb931ed4fbf8b$export$2c0f367103c8d01c) + "$1")
                                    ]
                                })
                            ], callback);
                        // :placeholder
                        case "::placeholder":
                            return (0, $298fb931ed4fbf8b$export$dfdc1655ccc5b9cb)([
                                (0, $298fb931ed4fbf8b$export$784d13d8ee351f07)(element, {
                                    props: [
                                        (0, $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed)(value, /:(plac\w+)/, ":" + (0, $298fb931ed4fbf8b$export$39dfd62a25e0fe93) + "input-$1")
                                    ]
                                }),
                                (0, $298fb931ed4fbf8b$export$784d13d8ee351f07)(element, {
                                    props: [
                                        (0, $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed)(value, /:(plac\w+)/, ":" + (0, $298fb931ed4fbf8b$export$2c0f367103c8d01c) + "$1")
                                    ]
                                }),
                                (0, $298fb931ed4fbf8b$export$784d13d8ee351f07)(element, {
                                    props: [
                                        (0, $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed)(value, /:(plac\w+)/, (0, $298fb931ed4fbf8b$export$71ad59f2e432cfe8) + "input-$1")
                                    ]
                                })
                            ], callback);
                    }
                    return "";
                });
        }
    }
};
var $fc182b1f84212d3f$var$defaultStylisPlugins = [
    $fc182b1f84212d3f$var$prefixer
];
var $fc182b1f84212d3f$export$2e2bcd8739ae039 = function createCache(options) {
    var key = options.key;
    if (!key) throw new Error("You have to configure `key` for your cache. Please make sure it's unique (and not equal to 'css') as it's used for linking styles to your cache.\nIf multiple caches share the same key they might \"fight\" for each other's style elements.");
    if (key === "css") {
        var ssrStyles = document.querySelectorAll("style[data-emotion]:not([data-s])"); // get SSRed styles out of the way of React's hydration
        // document.head is a safe place to move them to(though note document.head is not necessarily the last place they will be)
        // note this very very intentionally targets all style elements regardless of the key to ensure
        // that creating a cache works inside of render of a React component
        Array.prototype.forEach.call(ssrStyles, function(node) {
            // we want to only move elements which have a space in the data-emotion attribute value
            // because that indicates that it is an Emotion 11 server-side rendered style elements
            // while we will already ignore Emotion 11 client-side inserted styles because of the :not([data-s]) part in the selector
            // Emotion 10 client-side inserted styles did not have data-s (but importantly did not have a space in their data-emotion attributes)
            // so checking for the space ensures that loading Emotion 11 after Emotion 10 has inserted some styles
            // will not result in the Emotion 10 styles being destroyed
            var dataEmotionAttribute = node.getAttribute("data-emotion");
            if (dataEmotionAttribute.indexOf(" ") === -1) return;
            document.head.appendChild(node);
            node.setAttribute("data-s", "");
        });
    }
    var stylisPlugins = options.stylisPlugins || $fc182b1f84212d3f$var$defaultStylisPlugins;
    // $FlowFixMe
    if (/[^a-z-]/.test(key)) throw new Error('Emotion key must only contain lower case alphabetical characters and - but "' + key + '" was passed');
    var inserted = {};
    var container;
    var nodesToHydrate = [];
    container = options.container || document.head;
    Array.prototype.forEach.call(// means that the style elements we're looking at are only Emotion 11 server-rendered style elements
    document.querySelectorAll('style[data-emotion^="' + key + ' "]'), function(node) {
        var attrib = node.getAttribute("data-emotion").split(" "); // $FlowFixMe
        for(var i = 1; i < attrib.length; i++)inserted[attrib[i]] = true;
        nodesToHydrate.push(node);
    });
    var _insert;
    var omnipresentPlugins = [
        $fc182b1f84212d3f$var$compat,
        $fc182b1f84212d3f$var$removeLabel
    ];
    omnipresentPlugins.push($fc182b1f84212d3f$var$createUnsafeSelectorsAlarm({
        get compat () {
            return cache.compat;
        }
    }), $fc182b1f84212d3f$var$incorrectImportAlarm);
    var currentSheet;
    var finalizingPlugins = [
        (0, $298fb931ed4fbf8b$export$fac44ee5b035f737),
        function(element) {
            if (!element.root) {
                if (element["return"]) currentSheet.insert(element["return"]);
                else if (element.value && element.type !== (0, $298fb931ed4fbf8b$export$a29989082612d0d9)) // insert empty rule in non-production environments
                // so @emotion/jest can grab `key` from the (JS)DOM for caches without any rules inserted yet
                currentSheet.insert(element.value + "{}");
            }
        }
    ];
    var serializer = (0, $298fb931ed4fbf8b$export$5a7767152ae0305f)(omnipresentPlugins.concat(stylisPlugins, finalizingPlugins));
    var stylis = function stylis(styles) {
        return (0, $298fb931ed4fbf8b$export$dfdc1655ccc5b9cb)((0, $298fb931ed4fbf8b$export$ef7acd7185315e22)(styles), serializer);
    };
    _insert = function insert(selector, serialized, sheet, shouldCache) {
        currentSheet = sheet;
        if (serialized.map !== undefined) currentSheet = {
            insert: function insert(rule) {
                sheet.insert(rule + serialized.map);
            }
        };
        stylis(selector ? selector + "{" + serialized.styles + "}" : serialized.styles);
        if (shouldCache) cache.inserted[serialized.name] = true;
    };
    var cache = {
        key: key,
        sheet: new (0, $e18645ac1956fbe6$export$9d753cd7ae895cce)({
            key: key,
            container: container,
            nonce: options.nonce,
            speedy: options.speedy,
            prepend: options.prepend,
            insertionPoint: options.insertionPoint
        }),
        nonce: options.nonce,
        inserted: inserted,
        registered: {},
        insert: _insert
    };
    cache.sheet.hydrate(nodesToHydrate);
    return cache;
};





var $9ORqK = parcelRequire("9ORqK");
// this file isolates this package that is not tree-shakeable
// and if this module doesn't actually contain any logic of its own
// then Rollup just use 'hoist-non-react-statics' directly in other chunks
var $f1be2661c8fac766$export$2e2bcd8739ae039 = function(targetComponent, sourceComponent) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($9ORqK)))(targetComponent, sourceComponent);
};


var $1f6791d0a193b918$var$isBrowser = true;
function $1f6791d0a193b918$export$95d99596f328fd52(registered, registeredStyles, classNames) {
    var rawClassName = "";
    classNames.split(" ").forEach(function(className) {
        if (registered[className] !== undefined) registeredStyles.push(registered[className] + ";");
        else rawClassName += className + " ";
    });
    return rawClassName;
}
var $1f6791d0a193b918$export$580009a5da2a8b4b = function registerStyles(cache, serialized, isStringTag) {
    var className = cache.key + "-" + serialized.name;
    if (// class name could be used further down
    // the tree but if it's a string tag, we know it won't
    // so we don't have to add it to registered cache.
    // this improves memory usage since we can avoid storing the whole style string
    (isStringTag === false || // we need to always store it if we're in compat mode and
    // in node since emotion-server relies on whether a style is in
    // the registered cache to know whether a style is global or not
    // also, note that this check will be dead code eliminated in the browser
    $1f6791d0a193b918$var$isBrowser === false) && cache.registered[className] === undefined) cache.registered[className] = serialized.styles;
};
var $1f6791d0a193b918$export$6f077d94b33a01aa = function insertStyles(cache, serialized, isStringTag) {
    $1f6791d0a193b918$export$580009a5da2a8b4b(cache, serialized, isStringTag);
    var className = cache.key + "-" + serialized.name;
    if (cache.inserted[serialized.name] === undefined) {
        var current = serialized;
        do {
            cache.insert(serialized === current ? "." + className : "", current, cache.sheet, true);
            current = current.next;
        }while (current !== undefined);
    }
};


/* eslint-disable */ // Inspired by https://github.com/garycourt/murmurhash-js
// Ported from https://github.com/aappleby/smhasher/blob/61a0530f28277f2e850bfc39600ce61d02b518de/src/MurmurHash2.cpp#L37-L86
function $3629985b3ecf741f$export$2e2bcd8739ae039(str) {
    // 'm' and 'r' are mixing constants generated offline.
    // They're not really 'magic', they just happen to work well.
    // const m = 0x5bd1e995;
    // const r = 24;
    // Initialize the hash
    var h = 0; // Mix 4 bytes at a time into the hash
    var k, i = 0, len = str.length;
    for(; len >= 4; ++i, len -= 4){
        k = str.charCodeAt(i) & 0xff | (str.charCodeAt(++i) & 0xff) << 8 | (str.charCodeAt(++i) & 0xff) << 16 | (str.charCodeAt(++i) & 0xff) << 24;
        k = /* Math.imul(k, m): */ (k & 0xffff) * 0x5bd1e995 + ((k >>> 16) * 0xe995 << 16);
        k ^= /* k >>> r: */ k >>> 24;
        h = /* Math.imul(k, m): */ (k & 0xffff) * 0x5bd1e995 + ((k >>> 16) * 0xe995 << 16) ^ /* Math.imul(h, m): */ (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
    } // Handle the last few bytes of the input array
    switch(len){
        case 3:
            h ^= (str.charCodeAt(i + 2) & 0xff) << 16;
        case 2:
            h ^= (str.charCodeAt(i + 1) & 0xff) << 8;
        case 1:
            h ^= str.charCodeAt(i) & 0xff;
            h = /* Math.imul(h, m): */ (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
    } // Do a few final mixes of the hash to ensure the last few
    // bytes are well-incorporated.
    h ^= h >>> 13;
    h = /* Math.imul(h, m): */ (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
    return ((h ^ h >>> 15) >>> 0).toString(36);
}


var $936be3b045ab836e$export$2e2bcd8739ae039 = {
    animationIterationCount: 1,
    aspectRatio: 1,
    borderImageOutset: 1,
    borderImageSlice: 1,
    borderImageWidth: 1,
    boxFlex: 1,
    boxFlexGroup: 1,
    boxOrdinalGroup: 1,
    columnCount: 1,
    columns: 1,
    flex: 1,
    flexGrow: 1,
    flexPositive: 1,
    flexShrink: 1,
    flexNegative: 1,
    flexOrder: 1,
    gridRow: 1,
    gridRowEnd: 1,
    gridRowSpan: 1,
    gridRowStart: 1,
    gridColumn: 1,
    gridColumnEnd: 1,
    gridColumnSpan: 1,
    gridColumnStart: 1,
    msGridRow: 1,
    msGridRowSpan: 1,
    msGridColumn: 1,
    msGridColumnSpan: 1,
    fontWeight: 1,
    lineHeight: 1,
    opacity: 1,
    order: 1,
    orphans: 1,
    tabSize: 1,
    widows: 1,
    zIndex: 1,
    zoom: 1,
    WebkitLineClamp: 1,
    // SVG-related properties
    fillOpacity: 1,
    floodOpacity: 1,
    stopOpacity: 1,
    strokeDasharray: 1,
    strokeDashoffset: 1,
    strokeMiterlimit: 1,
    strokeOpacity: 1,
    strokeWidth: 1
};



var $90ba2da1f62e5f1b$var$ILLEGAL_ESCAPE_SEQUENCE_ERROR = "You have illegal escape sequence in your template literal, most likely inside content's property value.\nBecause you write your CSS inside a JavaScript string you actually have to do double escaping, so for example \"content: '\\00d7';\" should become \"content: '\\\\00d7';\".\nYou can read more about this here:\nhttps://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Template_literals#ES2018_revision_of_illegal_escape_sequences";
var $90ba2da1f62e5f1b$var$UNDEFINED_AS_OBJECT_KEY_ERROR = "You have passed in falsy value as style object's key (can happen when in example you pass unexported component as computed key).";
var $90ba2da1f62e5f1b$var$hyphenateRegex = /[A-Z]|^ms/g;
var $90ba2da1f62e5f1b$var$animationRegex = /_EMO_([^_]+?)_([^]*?)_EMO_/g;
var $90ba2da1f62e5f1b$var$isCustomProperty = function isCustomProperty(property) {
    return property.charCodeAt(1) === 45;
};
var $90ba2da1f62e5f1b$var$isProcessableValue = function isProcessableValue(value) {
    return value != null && typeof value !== "boolean";
};
var $90ba2da1f62e5f1b$var$processStyleName = /* #__PURE__ */ (0, $6bb1e54ce1bc6efa$export$2e2bcd8739ae039)(function(styleName) {
    return $90ba2da1f62e5f1b$var$isCustomProperty(styleName) ? styleName : styleName.replace($90ba2da1f62e5f1b$var$hyphenateRegex, "-$&").toLowerCase();
});
var $90ba2da1f62e5f1b$var$processStyleValue = function processStyleValue(key, value) {
    switch(key){
        case "animation":
        case "animationName":
            if (typeof value === "string") return value.replace($90ba2da1f62e5f1b$var$animationRegex, function(match, p1, p2) {
                $90ba2da1f62e5f1b$var$cursor = {
                    name: p1,
                    styles: p2,
                    next: $90ba2da1f62e5f1b$var$cursor
                };
                return p1;
            });
    }
    if ((0, $936be3b045ab836e$export$2e2bcd8739ae039)[key] !== 1 && !$90ba2da1f62e5f1b$var$isCustomProperty(key) && typeof value === "number" && value !== 0) return value + "px";
    return value;
};
var $90ba2da1f62e5f1b$var$contentValuePattern = /(var|attr|counters?|url|element|(((repeating-)?(linear|radial))|conic)-gradient)\(|(no-)?(open|close)-quote/;
var $90ba2da1f62e5f1b$var$contentValues = [
    "normal",
    "none",
    "initial",
    "inherit",
    "unset"
];
var $90ba2da1f62e5f1b$var$oldProcessStyleValue = $90ba2da1f62e5f1b$var$processStyleValue;
var $90ba2da1f62e5f1b$var$msPattern = /^-ms-/;
var $90ba2da1f62e5f1b$var$hyphenPattern = /-(.)/g;
var $90ba2da1f62e5f1b$var$hyphenatedCache = {};
$90ba2da1f62e5f1b$var$processStyleValue = function processStyleValue(key, value) {
    if (key === "content") {
        if (typeof value !== "string" || $90ba2da1f62e5f1b$var$contentValues.indexOf(value) === -1 && !$90ba2da1f62e5f1b$var$contentValuePattern.test(value) && (value.charAt(0) !== value.charAt(value.length - 1) || value.charAt(0) !== '"' && value.charAt(0) !== "'")) throw new Error("You seem to be using a value for 'content' without quotes, try replacing it with `content: '\"" + value + "\"'`");
    }
    var processed = $90ba2da1f62e5f1b$var$oldProcessStyleValue(key, value);
    if (processed !== "" && !$90ba2da1f62e5f1b$var$isCustomProperty(key) && key.indexOf("-") !== -1 && $90ba2da1f62e5f1b$var$hyphenatedCache[key] === undefined) {
        $90ba2da1f62e5f1b$var$hyphenatedCache[key] = true;
        console.error("Using kebab-case for css properties in objects is not supported. Did you mean " + key.replace($90ba2da1f62e5f1b$var$msPattern, "ms-").replace($90ba2da1f62e5f1b$var$hyphenPattern, function(str, _char) {
            return _char.toUpperCase();
        }) + "?");
    }
    return processed;
};
var $90ba2da1f62e5f1b$var$noComponentSelectorMessage = "Component selectors can only be used in conjunction with @emotion/babel-plugin, the swc Emotion plugin, or another Emotion-aware compiler transform.";
function $90ba2da1f62e5f1b$var$handleInterpolation(mergedProps, registered, interpolation) {
    if (interpolation == null) return "";
    if (interpolation.__emotion_styles !== undefined) {
        if (interpolation.toString() === "NO_COMPONENT_SELECTOR") throw new Error($90ba2da1f62e5f1b$var$noComponentSelectorMessage);
        return interpolation;
    }
    switch(typeof interpolation){
        case "boolean":
            return "";
        case "object":
            if (interpolation.anim === 1) {
                $90ba2da1f62e5f1b$var$cursor = {
                    name: interpolation.name,
                    styles: interpolation.styles,
                    next: $90ba2da1f62e5f1b$var$cursor
                };
                return interpolation.name;
            }
            if (interpolation.styles !== undefined) {
                var next = interpolation.next;
                if (next !== undefined) // not the most efficient thing ever but this is a pretty rare case
                // and there will be very few iterations of this generally
                while(next !== undefined){
                    $90ba2da1f62e5f1b$var$cursor = {
                        name: next.name,
                        styles: next.styles,
                        next: $90ba2da1f62e5f1b$var$cursor
                    };
                    next = next.next;
                }
                var styles = interpolation.styles + ";";
                if (interpolation.map !== undefined) styles += interpolation.map;
                return styles;
            }
            return $90ba2da1f62e5f1b$var$createStringFromObject(mergedProps, registered, interpolation);
        case "function":
            if (mergedProps !== undefined) {
                var previousCursor = $90ba2da1f62e5f1b$var$cursor;
                var result = interpolation(mergedProps);
                $90ba2da1f62e5f1b$var$cursor = previousCursor;
                return $90ba2da1f62e5f1b$var$handleInterpolation(mergedProps, registered, result);
            } else console.error("Functions that are interpolated in css calls will be stringified.\nIf you want to have a css call based on props, create a function that returns a css call like this\nlet dynamicStyle = (props) => css`color: ${props.color}`\nIt can be called directly with props or interpolated in a styled call like this\nlet SomeComponent = styled('div')`${dynamicStyle}`");
            break;
        case "string":
            var matched = [];
            var replaced = interpolation.replace($90ba2da1f62e5f1b$var$animationRegex, function(match, p1, p2) {
                var fakeVarName = "animation" + matched.length;
                matched.push("const " + fakeVarName + " = keyframes`" + p2.replace(/^@keyframes animation-\w+/, "") + "`");
                return "${" + fakeVarName + "}";
            });
            if (matched.length) console.error("`keyframes` output got interpolated into plain string, please wrap it with `css`.\n\nInstead of doing this:\n\n" + [].concat(matched, [
                "`" + replaced + "`"
            ]).join("\n") + "\n\nYou should wrap it with `css` like this:\n\n" + ("css`" + replaced + "`"));
            break;
    } // finalize string values (regular strings and functions interpolated into css calls)
    if (registered == null) return interpolation;
    var cached = registered[interpolation];
    return cached !== undefined ? cached : interpolation;
}
function $90ba2da1f62e5f1b$var$createStringFromObject(mergedProps, registered, obj) {
    var string = "";
    if (Array.isArray(obj)) for(var i = 0; i < obj.length; i++)string += $90ba2da1f62e5f1b$var$handleInterpolation(mergedProps, registered, obj[i]) + ";";
    else for(var _key in obj){
        var value = obj[_key];
        if (typeof value !== "object") {
            if (registered != null && registered[value] !== undefined) string += _key + "{" + registered[value] + "}";
            else if ($90ba2da1f62e5f1b$var$isProcessableValue(value)) string += $90ba2da1f62e5f1b$var$processStyleName(_key) + ":" + $90ba2da1f62e5f1b$var$processStyleValue(_key, value) + ";";
        } else {
            if (_key === "NO_COMPONENT_SELECTOR" && true) throw new Error($90ba2da1f62e5f1b$var$noComponentSelectorMessage);
            if (Array.isArray(value) && typeof value[0] === "string" && (registered == null || registered[value[0]] === undefined)) {
                for(var _i = 0; _i < value.length; _i++)if ($90ba2da1f62e5f1b$var$isProcessableValue(value[_i])) string += $90ba2da1f62e5f1b$var$processStyleName(_key) + ":" + $90ba2da1f62e5f1b$var$processStyleValue(_key, value[_i]) + ";";
            } else {
                var interpolated = $90ba2da1f62e5f1b$var$handleInterpolation(mergedProps, registered, value);
                switch(_key){
                    case "animation":
                    case "animationName":
                        string += $90ba2da1f62e5f1b$var$processStyleName(_key) + ":" + interpolated + ";";
                        break;
                    default:
                        if (_key === "undefined") console.error($90ba2da1f62e5f1b$var$UNDEFINED_AS_OBJECT_KEY_ERROR);
                        string += _key + "{" + interpolated + "}";
                }
            }
        }
    }
    return string;
}
var $90ba2da1f62e5f1b$var$labelPattern = /label:\s*([^\s;\n{]+)\s*(;|$)/g;
var $90ba2da1f62e5f1b$var$sourceMapPattern;
$90ba2da1f62e5f1b$var$sourceMapPattern = /\/\*#\ssourceMappingURL=data:application\/json;\S+\s+\*\//g;
// keyframes are stored on the SerializedStyles object as a linked list
var $90ba2da1f62e5f1b$var$cursor;
var $90ba2da1f62e5f1b$export$6321afa313b251b5 = function serializeStyles(args, registered, mergedProps) {
    if (args.length === 1 && typeof args[0] === "object" && args[0] !== null && args[0].styles !== undefined) return args[0];
    var stringMode = true;
    var styles = "";
    $90ba2da1f62e5f1b$var$cursor = undefined;
    var strings = args[0];
    if (strings == null || strings.raw === undefined) {
        stringMode = false;
        styles += $90ba2da1f62e5f1b$var$handleInterpolation(mergedProps, registered, strings);
    } else {
        if (strings[0] === undefined) console.error($90ba2da1f62e5f1b$var$ILLEGAL_ESCAPE_SEQUENCE_ERROR);
        styles += strings[0];
    } // we start at 1 since we've already handled the first arg
    for(var i = 1; i < args.length; i++){
        styles += $90ba2da1f62e5f1b$var$handleInterpolation(mergedProps, registered, args[i]);
        if (stringMode) {
            if (strings[i] === undefined) console.error($90ba2da1f62e5f1b$var$ILLEGAL_ESCAPE_SEQUENCE_ERROR);
            styles += strings[i];
        }
    }
    var sourceMap;
    styles = styles.replace($90ba2da1f62e5f1b$var$sourceMapPattern, function(match) {
        sourceMap = match;
        return "";
    });
    $90ba2da1f62e5f1b$var$labelPattern.lastIndex = 0;
    var identifierName = "";
    var match; // https://esbench.com/bench/5b809c2cf2949800a0f61fb5
    while((match = $90ba2da1f62e5f1b$var$labelPattern.exec(styles)) !== null)identifierName += "-" + // $FlowFixMe we know it's not null
    match[1];
    var name = (0, $3629985b3ecf741f$export$2e2bcd8739ae039)(styles) + identifierName;
    // $FlowFixMe SerializedStyles type doesn't have toString property (and we don't want to add it)
    return {
        name: name,
        styles: styles,
        map: sourceMap,
        next: $90ba2da1f62e5f1b$var$cursor,
        toString: function toString() {
            return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
        }
    };
};



var $acw62 = parcelRequire("acw62");
var $19b532704a3a90e7$var$syncFallback = function syncFallback(create) {
    return create();
};
var $19b532704a3a90e7$var$useInsertionEffect = $acw62.useInsertionEffect ? $acw62.useInsertionEffect : false;
var $19b532704a3a90e7$export$db21c7ffa21794e7 = $19b532704a3a90e7$var$useInsertionEffect || $19b532704a3a90e7$var$syncFallback;
var $19b532704a3a90e7$export$811a713a7276cb9d = $19b532704a3a90e7$var$useInsertionEffect || $acw62.useLayoutEffect;


var $a25287fda858c019$export$23f2a1d2818174ef = true;
var $a25287fda858c019$export$dda1d9f60106f0e9 = {}.hasOwnProperty;
var $a25287fda858c019$var$EmotionCacheContext = /* #__PURE__ */ $acw62.createContext(// because this module is primarily intended for the browser and node
// but it's also required in react native and similar environments sometimes
// and we could have a special build just for that
// but this is much easier and the native packages
// might use a different theme context in the future anyway
typeof HTMLElement !== "undefined" ? /* #__PURE__ */ (0, $fc182b1f84212d3f$export$2e2bcd8739ae039)({
    key: "css"
}) : null);
$a25287fda858c019$var$EmotionCacheContext.displayName = "EmotionCacheContext";
var $a25287fda858c019$export$e7094788287c5e9b = $a25287fda858c019$var$EmotionCacheContext.Provider;
var $a25287fda858c019$export$71511d61b312f219 = function useEmotionCache() {
    return (0, $acw62.useContext)($a25287fda858c019$var$EmotionCacheContext);
};
var $a25287fda858c019$export$efccba1c4a2ef57b = function withEmotionCache(func) {
    // $FlowFixMe
    return /*#__PURE__*/ (0, $acw62.forwardRef)(function(props, ref) {
        // the cache will never be null in the browser
        var cache = (0, $acw62.useContext)($a25287fda858c019$var$EmotionCacheContext);
        return func(props, cache, ref);
    });
};
if (!$a25287fda858c019$export$23f2a1d2818174ef) $a25287fda858c019$export$efccba1c4a2ef57b = function withEmotionCache(func) {
    return function(props) {
        var cache = (0, $acw62.useContext)($a25287fda858c019$var$EmotionCacheContext);
        if (cache === null) {
            // yes, we're potentially creating this on every render
            // it doesn't actually matter though since it's only on the server
            // so there will only every be a single render
            // that could change in the future because of suspense and etc. but for now,
            // this works and i don't want to optimise for a future thing that we aren't sure about
            cache = (0, $fc182b1f84212d3f$export$2e2bcd8739ae039)({
                key: "css"
            });
            return /*#__PURE__*/ $acw62.createElement($a25287fda858c019$var$EmotionCacheContext.Provider, {
                value: cache
            }, func(props, cache));
        } else return func(props, cache);
    };
};
var $a25287fda858c019$export$971d5caa766a69d7 = /* #__PURE__ */ $acw62.createContext({});
$a25287fda858c019$export$971d5caa766a69d7.displayName = "EmotionThemeContext";
var $a25287fda858c019$export$3b14a55fb2447963 = function useTheme() {
    return $acw62.useContext($a25287fda858c019$export$971d5caa766a69d7);
};
var $a25287fda858c019$var$getTheme = function getTheme(outerTheme, theme) {
    if (typeof theme === "function") {
        var mergedTheme = theme(outerTheme);
        if (mergedTheme == null || typeof mergedTheme !== "object" || Array.isArray(mergedTheme)) throw new Error("[ThemeProvider] Please return an object from your theme function, i.e. theme={() => ({})}!");
        return mergedTheme;
    }
    if (theme == null || typeof theme !== "object" || Array.isArray(theme)) throw new Error("[ThemeProvider] Please make your theme prop a plain object");
    return (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, outerTheme, theme);
};
var $a25287fda858c019$var$createCacheWithTheme = /* #__PURE__ */ (0, $d68ffb0773f38e18$export$2e2bcd8739ae039)(function(outerTheme) {
    return (0, $d68ffb0773f38e18$export$2e2bcd8739ae039)(function(theme) {
        return $a25287fda858c019$var$getTheme(outerTheme, theme);
    });
});
var $a25287fda858c019$export$407448d2b89b1813 = function ThemeProvider(props) {
    var theme = $acw62.useContext($a25287fda858c019$export$971d5caa766a69d7);
    if (props.theme !== theme) theme = $a25287fda858c019$var$createCacheWithTheme(theme)(props.theme);
    return /*#__PURE__*/ $acw62.createElement($a25287fda858c019$export$971d5caa766a69d7.Provider, {
        value: theme
    }, props.children);
};
function $a25287fda858c019$export$8b22cf2602fb60ce(Component) {
    var componentName = Component.displayName || Component.name || "Component";
    var render = function render(props, ref) {
        var theme = $acw62.useContext($a25287fda858c019$export$971d5caa766a69d7);
        return /*#__PURE__*/ $acw62.createElement(Component, (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({
            theme: theme,
            ref: ref
        }, props));
    }; // $FlowFixMe
    var WithTheme = /*#__PURE__*/ $acw62.forwardRef(render);
    WithTheme.displayName = "WithTheme(" + componentName + ")";
    return (0, $f1be2661c8fac766$export$2e2bcd8739ae039)(WithTheme, Component);
}
var $a25287fda858c019$var$getLastPart = function getLastPart(functionName) {
    // The match may be something like 'Object.createEmotionProps' or
    // 'Loader.prototype.render'
    var parts = functionName.split(".");
    return parts[parts.length - 1];
};
var $a25287fda858c019$var$getFunctionNameFromStackTraceLine = function getFunctionNameFromStackTraceLine(line) {
    // V8
    var match = /^\s+at\s+([A-Za-z0-9$.]+)\s/.exec(line);
    if (match) return $a25287fda858c019$var$getLastPart(match[1]); // Safari / Firefox
    match = /^([A-Za-z0-9$.]+)@/.exec(line);
    if (match) return $a25287fda858c019$var$getLastPart(match[1]);
    return undefined;
};
var $a25287fda858c019$var$internalReactFunctionNames = /* #__PURE__ */ new Set([
    "renderWithHooks",
    "processChild",
    "finishClassComponent",
    "renderToString"
]); // These identifiers come from error stacks, so they have to be valid JS
// identifiers, thus we only need to replace what is a valid character for JS,
// but not for CSS.
var $a25287fda858c019$var$sanitizeIdentifier = function sanitizeIdentifier(identifier) {
    return identifier.replace(/\$/g, "-");
};
var $a25287fda858c019$var$getLabelFromStackTrace = function getLabelFromStackTrace(stackTrace) {
    if (!stackTrace) return undefined;
    var lines = stackTrace.split("\n");
    for(var i = 0; i < lines.length; i++){
        var functionName = $a25287fda858c019$var$getFunctionNameFromStackTraceLine(lines[i]); // The first line of V8 stack traces is just "Error"
        if (!functionName) continue; // If we reach one of these, we have gone too far and should quit
        if ($a25287fda858c019$var$internalReactFunctionNames.has(functionName)) break; // The component name is the first function in the stack that starts with an
        // uppercase letter
        if (/^[A-Z]/.test(functionName)) return $a25287fda858c019$var$sanitizeIdentifier(functionName);
    }
    return undefined;
};
var $a25287fda858c019$var$typePropName = "__EMOTION_TYPE_PLEASE_DO_NOT_USE__";
var $a25287fda858c019$var$labelPropName = "__EMOTION_LABEL_PLEASE_DO_NOT_USE__";
var $a25287fda858c019$export$db3b6bfb95261072 = function createEmotionProps(type, props) {
    if (typeof props.css === "string" && // check if there is a css declaration
    props.css.indexOf(":") !== -1) throw new Error("Strings are not allowed as css prop values, please wrap it in a css template literal from '@emotion/react' like this: css`" + props.css + "`");
    var newProps = {};
    for(var key in props)if ($a25287fda858c019$export$dda1d9f60106f0e9.call(props, key)) newProps[key] = props[key];
    newProps[$a25287fda858c019$var$typePropName] = type; // For performance, only call getLabelFromStackTrace in development and when
    // the label hasn't already been computed
    if (!!props.css && (typeof props.css !== "object" || typeof props.css.name !== "string" || props.css.name.indexOf("-") === -1)) {
        var label = $a25287fda858c019$var$getLabelFromStackTrace(new Error().stack);
        if (label) newProps[$a25287fda858c019$var$labelPropName] = label;
    }
    return newProps;
};
var $a25287fda858c019$var$Insertion = function Insertion(_ref) {
    var cache = _ref.cache, serialized = _ref.serialized, isStringTag = _ref.isStringTag;
    (0, $1f6791d0a193b918$export$580009a5da2a8b4b)(cache, serialized, isStringTag);
    (0, $19b532704a3a90e7$export$db21c7ffa21794e7)(function() {
        return (0, $1f6791d0a193b918$export$6f077d94b33a01aa)(cache, serialized, isStringTag);
    });
    return null;
};
var $a25287fda858c019$var$Emotion = /* #__PURE__ */ $a25287fda858c019$export$efccba1c4a2ef57b(function(props, cache, ref) {
    var cssProp = props.css; // so that using `css` from `emotion` and passing the result to the css prop works
    // not passing the registered cache to serializeStyles because it would
    // make certain babel optimisations not possible
    if (typeof cssProp === "string" && cache.registered[cssProp] !== undefined) cssProp = cache.registered[cssProp];
    var WrappedComponent = props[$a25287fda858c019$var$typePropName];
    var registeredStyles = [
        cssProp
    ];
    var className = "";
    if (typeof props.className === "string") className = (0, $1f6791d0a193b918$export$95d99596f328fd52)(cache.registered, registeredStyles, props.className);
    else if (props.className != null) className = props.className + " ";
    var serialized = (0, $90ba2da1f62e5f1b$export$6321afa313b251b5)(registeredStyles, undefined, $acw62.useContext($a25287fda858c019$export$971d5caa766a69d7));
    if (serialized.name.indexOf("-") === -1) {
        var labelFromStack = props[$a25287fda858c019$var$labelPropName];
        if (labelFromStack) serialized = (0, $90ba2da1f62e5f1b$export$6321afa313b251b5)([
            serialized,
            "label:" + labelFromStack + ";"
        ]);
    }
    className += cache.key + "-" + serialized.name;
    var newProps = {};
    for(var key in props)if ($a25287fda858c019$export$dda1d9f60106f0e9.call(props, key) && key !== "css" && key !== $a25287fda858c019$var$typePropName && key !== $a25287fda858c019$var$labelPropName) newProps[key] = props[key];
    newProps.ref = ref;
    newProps.className = className;
    return /*#__PURE__*/ $acw62.createElement($acw62.Fragment, null, /*#__PURE__*/ $acw62.createElement($a25287fda858c019$var$Insertion, {
        cache: cache,
        serialized: serialized,
        isStringTag: typeof WrappedComponent === "string"
    }), /*#__PURE__*/ $acw62.createElement(WrappedComponent, newProps));
});
$a25287fda858c019$var$Emotion.displayName = "EmotionCssPropInternal";
var $a25287fda858c019$export$a9c23c6ac3fc3eca = $a25287fda858c019$var$Emotion;



var $acw62 = parcelRequire("acw62");







parcelRequire("9ORqK");
var $63d46a01db878c10$var$pkg = {
    name: "@emotion/react",
    version: "11.11.4",
    main: "dist/emotion-react.cjs.js",
    module: "dist/emotion-react.esm.js",
    browser: {
        "./dist/emotion-react.esm.js": "./dist/emotion-react.browser.esm.js"
    },
    exports: {
        ".": {
            module: {
                worker: "./dist/emotion-react.worker.esm.js",
                browser: "./dist/emotion-react.browser.esm.js",
                "default": "./dist/emotion-react.esm.js"
            },
            "import": "./dist/emotion-react.cjs.mjs",
            "default": "./dist/emotion-react.cjs.js"
        },
        "./jsx-runtime": {
            module: {
                worker: "./jsx-runtime/dist/emotion-react-jsx-runtime.worker.esm.js",
                browser: "./jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js",
                "default": "./jsx-runtime/dist/emotion-react-jsx-runtime.esm.js"
            },
            "import": "./jsx-runtime/dist/emotion-react-jsx-runtime.cjs.mjs",
            "default": "./jsx-runtime/dist/emotion-react-jsx-runtime.cjs.js"
        },
        "./_isolated-hnrs": {
            module: {
                worker: "./_isolated-hnrs/dist/emotion-react-_isolated-hnrs.worker.esm.js",
                browser: "./_isolated-hnrs/dist/emotion-react-_isolated-hnrs.browser.esm.js",
                "default": "./_isolated-hnrs/dist/emotion-react-_isolated-hnrs.esm.js"
            },
            "import": "./_isolated-hnrs/dist/emotion-react-_isolated-hnrs.cjs.mjs",
            "default": "./_isolated-hnrs/dist/emotion-react-_isolated-hnrs.cjs.js"
        },
        "./jsx-dev-runtime": {
            module: {
                worker: "./jsx-dev-runtime/dist/emotion-react-jsx-dev-runtime.worker.esm.js",
                browser: "./jsx-dev-runtime/dist/emotion-react-jsx-dev-runtime.browser.esm.js",
                "default": "./jsx-dev-runtime/dist/emotion-react-jsx-dev-runtime.esm.js"
            },
            "import": "./jsx-dev-runtime/dist/emotion-react-jsx-dev-runtime.cjs.mjs",
            "default": "./jsx-dev-runtime/dist/emotion-react-jsx-dev-runtime.cjs.js"
        },
        "./package.json": "./package.json",
        "./types/css-prop": "./types/css-prop.d.ts",
        "./macro": {
            types: {
                "import": "./macro.d.mts",
                "default": "./macro.d.ts"
            },
            "default": "./macro.js"
        }
    },
    types: "types/index.d.ts",
    files: [
        "src",
        "dist",
        "jsx-runtime",
        "jsx-dev-runtime",
        "_isolated-hnrs",
        "types/*.d.ts",
        "macro.*"
    ],
    sideEffects: false,
    author: "Emotion Contributors",
    license: "MIT",
    scripts: {
        "test:typescript": "dtslint types"
    },
    dependencies: {
        "@babel/runtime": "^7.18.3",
        "@emotion/babel-plugin": "^11.11.0",
        "@emotion/cache": "^11.11.0",
        "@emotion/serialize": "^1.1.3",
        "@emotion/use-insertion-effect-with-fallbacks": "^1.0.1",
        "@emotion/utils": "^1.2.1",
        "@emotion/weak-memoize": "^0.3.1",
        "hoist-non-react-statics": "^3.3.1"
    },
    peerDependencies: {
        react: ">=16.8.0"
    },
    peerDependenciesMeta: {
        "@types/react": {
            optional: true
        }
    },
    devDependencies: {
        "@definitelytyped/dtslint": "0.0.112",
        "@emotion/css": "11.11.2",
        "@emotion/css-prettifier": "1.1.3",
        "@emotion/server": "11.11.0",
        "@emotion/styled": "11.11.0",
        "html-tag-names": "^1.1.2",
        react: "16.14.0",
        "svg-tag-names": "^1.1.1",
        typescript: "^4.5.5"
    },
    repository: "https://github.com/emotion-js/emotion/tree/main/packages/react",
    publishConfig: {
        access: "public"
    },
    "umd:main": "dist/emotion-react.umd.min.js",
    preconstruct: {
        entrypoints: [
            "./index.js",
            "./jsx-runtime.js",
            "./jsx-dev-runtime.js",
            "./_isolated-hnrs.js"
        ],
        umdName: "emotionReact",
        exports: {
            envConditions: [
                "browser",
                "worker"
            ],
            extra: {
                "./types/css-prop": "./types/css-prop.d.ts",
                "./macro": {
                    types: {
                        "import": "./macro.d.mts",
                        "default": "./macro.d.ts"
                    },
                    "default": "./macro.js"
                }
            }
        }
    }
};
var $63d46a01db878c10$export$c8a8987d4410bf2d = function jsx(type, props) {
    var args = arguments;
    if (props == null || !(0, $a25287fda858c019$export$dda1d9f60106f0e9).call(props, "css")) // $FlowFixMe
    return $acw62.createElement.apply(undefined, args);
    var argsLength = args.length;
    var createElementArgArray = new Array(argsLength);
    createElementArgArray[0] = (0, $a25287fda858c019$export$a9c23c6ac3fc3eca);
    createElementArgArray[1] = (0, $a25287fda858c019$export$db3b6bfb95261072)(type, props);
    for(var i = 2; i < argsLength; i++)createElementArgArray[i] = args[i];
     // $FlowFixMe
    return $acw62.createElement.apply(null, createElementArgArray);
};
var $63d46a01db878c10$var$warnedAboutCssPropForGlobal = false; // maintain place over rerenders.
// initial render from browser, insertBefore context.sheet.tags[0] or if a style hasn't been inserted there yet, appendChild
// initial client-side render from SSR, use place of hydrating tag
var $63d46a01db878c10$export$98f03c5d19621d70 = /* #__PURE__ */ (0, $a25287fda858c019$export$efccba1c4a2ef57b)(function(props, cache) {
    if (!$63d46a01db878c10$var$warnedAboutCssPropForGlobal && // probably using the custom createElement which
    // means it will be turned into a className prop
    // $FlowFixMe I don't really want to add it to the type since it shouldn't be used
    (props.className || props.css)) {
        console.error("It looks like you're using the css prop on Global, did you mean to use the styles prop instead?");
        $63d46a01db878c10$var$warnedAboutCssPropForGlobal = true;
    }
    var styles = props.styles;
    var serialized = (0, $90ba2da1f62e5f1b$export$6321afa313b251b5)([
        styles
    ], undefined, $acw62.useContext((0, $a25287fda858c019$export$971d5caa766a69d7)));
    if (!(0, $a25287fda858c019$export$23f2a1d2818174ef)) {
        var _ref;
        var serializedNames = serialized.name;
        var serializedStyles = serialized.styles;
        var next = serialized.next;
        while(next !== undefined){
            serializedNames += " " + next.name;
            serializedStyles += next.styles;
            next = next.next;
        }
        var shouldCache = cache.compat === true;
        var rules = cache.insert("", {
            name: serializedNames,
            styles: serializedStyles
        }, cache.sheet, shouldCache);
        if (shouldCache) return null;
        return /*#__PURE__*/ $acw62.createElement("style", (_ref = {}, _ref["data-emotion"] = cache.key + "-global " + serializedNames, _ref.dangerouslySetInnerHTML = {
            __html: rules
        }, _ref.nonce = cache.sheet.nonce, _ref));
    } // yes, i know these hooks are used conditionally
    // but it is based on a constant that will never change at runtime
    // it's effectively like having two implementations and switching them out
    // so it's not actually breaking anything
    var sheetRef = $acw62.useRef();
    (0, $19b532704a3a90e7$export$811a713a7276cb9d)(function() {
        var key = cache.key + "-global"; // use case of https://github.com/emotion-js/emotion/issues/2675
        var sheet = new cache.sheet.constructor({
            key: key,
            nonce: cache.sheet.nonce,
            container: cache.sheet.container,
            speedy: cache.sheet.isSpeedy
        });
        var rehydrating = false; // $FlowFixMe
        var node = document.querySelector('style[data-emotion="' + key + " " + serialized.name + '"]');
        if (cache.sheet.tags.length) sheet.before = cache.sheet.tags[0];
        if (node !== null) {
            rehydrating = true; // clear the hash so this node won't be recognizable as rehydratable by other <Global/>s
            node.setAttribute("data-emotion", key);
            sheet.hydrate([
                node
            ]);
        }
        sheetRef.current = [
            sheet,
            rehydrating
        ];
        return function() {
            sheet.flush();
        };
    }, [
        cache
    ]);
    (0, $19b532704a3a90e7$export$811a713a7276cb9d)(function() {
        var sheetRefCurrent = sheetRef.current;
        var sheet = sheetRefCurrent[0], rehydrating = sheetRefCurrent[1];
        if (rehydrating) {
            sheetRefCurrent[1] = false;
            return;
        }
        if (serialized.next !== undefined) // insert keyframes
        (0, $1f6791d0a193b918$export$6f077d94b33a01aa)(cache, serialized.next, true);
        if (sheet.tags.length) {
            // if this doesn't exist then it will be null so the style element will be appended
            var element = sheet.tags[sheet.tags.length - 1].nextElementSibling;
            sheet.before = element;
            sheet.flush();
        }
        cache.insert("", serialized, sheet, false);
    }, [
        cache,
        serialized.name
    ]);
    return null;
});
$63d46a01db878c10$export$98f03c5d19621d70.displayName = "EmotionGlobal";
function $63d46a01db878c10$export$dbf350e5966cf602() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
    return (0, $90ba2da1f62e5f1b$export$6321afa313b251b5)(args);
}
var $63d46a01db878c10$export$d25ddfdf17c3ad3e = function keyframes() {
    var insertable = $63d46a01db878c10$export$dbf350e5966cf602.apply(void 0, arguments);
    var name = "animation-" + insertable.name; // $FlowFixMe
    return {
        name: name,
        styles: "@keyframes " + name + "{" + insertable.styles + "}",
        anim: 1,
        toString: function toString() {
            return "_EMO_" + this.name + "_" + this.styles + "_EMO_";
        }
    };
};
var $63d46a01db878c10$var$classnames = function classnames(args) {
    var len = args.length;
    var i = 0;
    var cls = "";
    for(; i < len; i++){
        var arg = args[i];
        if (arg == null) continue;
        var toAdd = void 0;
        switch(typeof arg){
            case "boolean":
                break;
            case "object":
                if (Array.isArray(arg)) toAdd = classnames(arg);
                else {
                    if (arg.styles !== undefined && arg.name !== undefined) console.error("You have passed styles created with `css` from `@emotion/react` package to the `cx`.\n`cx` is meant to compose class names (strings) so you should convert those styles to a class name by passing them to the `css` received from <ClassNames/> component.");
                    toAdd = "";
                    for(var k in arg)if (arg[k] && k) {
                        toAdd && (toAdd += " ");
                        toAdd += k;
                    }
                }
                break;
            default:
                toAdd = arg;
        }
        if (toAdd) {
            cls && (cls += " ");
            cls += toAdd;
        }
    }
    return cls;
};
function $63d46a01db878c10$var$merge(registered, css, className) {
    var registeredStyles = [];
    var rawClassName = (0, $1f6791d0a193b918$export$95d99596f328fd52)(registered, registeredStyles, className);
    if (registeredStyles.length < 2) return className;
    return rawClassName + css(registeredStyles);
}
var $63d46a01db878c10$var$Insertion = function Insertion(_ref) {
    var cache = _ref.cache, serializedArr = _ref.serializedArr;
    (0, $19b532704a3a90e7$export$db21c7ffa21794e7)(function() {
        for(var i = 0; i < serializedArr.length; i++)(0, $1f6791d0a193b918$export$6f077d94b33a01aa)(cache, serializedArr[i], false);
    });
    return null;
};
var $63d46a01db878c10$export$9b9c0f9d9f3552b8 = /* #__PURE__ */ (0, $a25287fda858c019$export$efccba1c4a2ef57b)(function(props, cache) {
    var hasRendered = false;
    var serializedArr = [];
    var css = function css() {
        if (hasRendered && true) throw new Error("css can only be used during render");
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        var serialized = (0, $90ba2da1f62e5f1b$export$6321afa313b251b5)(args, cache.registered);
        serializedArr.push(serialized); // registration has to happen here as the result of this might get consumed by `cx`
        (0, $1f6791d0a193b918$export$580009a5da2a8b4b)(cache, serialized, false);
        return cache.key + "-" + serialized.name;
    };
    var cx = function cx() {
        if (hasRendered && true) throw new Error("cx can only be used during render");
        for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
        return $63d46a01db878c10$var$merge(cache.registered, css, $63d46a01db878c10$var$classnames(args));
    };
    var content = {
        css: css,
        cx: cx,
        theme: $acw62.useContext((0, $a25287fda858c019$export$971d5caa766a69d7))
    };
    var ele = props.children(content);
    hasRendered = true;
    return /*#__PURE__*/ $acw62.createElement($acw62.Fragment, null, /*#__PURE__*/ $acw62.createElement($63d46a01db878c10$var$Insertion, {
        cache: cache,
        serializedArr: serializedArr
    }), ele);
});
$63d46a01db878c10$export$9b9c0f9d9f3552b8.displayName = "EmotionClassNames";
var $63d46a01db878c10$var$isBrowser = true; // #1727, #2905 for some reason Jest and Vitest evaluate modules twice if some consuming module gets mocked
var $63d46a01db878c10$var$isTestEnv = typeof jest !== "undefined" || typeof vi !== "undefined";
if ($63d46a01db878c10$var$isBrowser && !$63d46a01db878c10$var$isTestEnv) {
    // globalThis has wide browser support - https://caniuse.com/?search=globalThis, Node.js 12 and later
    var $63d46a01db878c10$var$globalContext = typeof globalThis !== "undefined" ? globalThis // eslint-disable-line no-undef
     : $63d46a01db878c10$var$isBrowser ? window : $parcel$global;
    var $63d46a01db878c10$var$globalKey = "__EMOTION_REACT_" + $63d46a01db878c10$var$pkg.version.split(".")[0] + "__";
    if ($63d46a01db878c10$var$globalContext[$63d46a01db878c10$var$globalKey]) console.warn("You are loading @emotion/react when it is already loaded. Running multiple instances may cause problems. This can happen if multiple versions are used, or if multiple builds of the same version are used.");
    $63d46a01db878c10$var$globalContext[$63d46a01db878c10$var$globalKey] = true;
}





function $cbe7edbf3ccb8828$export$2e2bcd8739ae039(strings, raw) {
    if (!raw) raw = strings.slice(0);
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}




var $acw62 = parcelRequire("acw62");

var $1u0KT = parcelRequire("1u0KT");
/**
 * Custom positioning reference element.
 * @see https://floating-ui.com/docs/virtual-elements
 */ const $10310cf078d13212$export$832b6fa47fa053d2 = [
    "top",
    "right",
    "bottom",
    "left"
];
const $10310cf078d13212$export$27b07d8a310ed8b5 = [
    "start",
    "end"
];
const $10310cf078d13212$export$803cd8101b6c182b = /*#__PURE__*/ $10310cf078d13212$export$832b6fa47fa053d2.reduce((acc, side)=>acc.concat(side, side + "-" + $10310cf078d13212$export$27b07d8a310ed8b5[0], side + "-" + $10310cf078d13212$export$27b07d8a310ed8b5[1]), []);
const $10310cf078d13212$export$96ec731ed4dcb222 = Math.min;
const $10310cf078d13212$export$8960430cfd85939f = Math.max;
const $10310cf078d13212$export$2077e0241d6afd3c = Math.round;
const $10310cf078d13212$export$a3fe094919f356fd = Math.floor;
const $10310cf078d13212$export$a397704b5e280835 = (v)=>({
        x: v,
        y: v
    });
const $10310cf078d13212$var$oppositeSideMap = {
    left: "right",
    right: "left",
    bottom: "top",
    top: "bottom"
};
const $10310cf078d13212$var$oppositeAlignmentMap = {
    start: "end",
    end: "start"
};
function $10310cf078d13212$export$7d15b64cf5a3a4c4(start, value, end) {
    return $10310cf078d13212$export$8960430cfd85939f(start, $10310cf078d13212$export$96ec731ed4dcb222(value, end));
}
function $10310cf078d13212$export$fef61f332f2c0afc(value, param) {
    return typeof value === "function" ? value(param) : value;
}
function $10310cf078d13212$export$3c915306cb7fc97a(placement) {
    return placement.split("-")[0];
}
function $10310cf078d13212$export$f0989780f32bfcda(placement) {
    return placement.split("-")[1];
}
function $10310cf078d13212$export$8a000a963141ac32(axis) {
    return axis === "x" ? "y" : "x";
}
function $10310cf078d13212$export$320bd9d53520c68a(axis) {
    return axis === "y" ? "height" : "width";
}
function $10310cf078d13212$export$f28e8f882010718a(placement) {
    return [
        "top",
        "bottom"
    ].includes($10310cf078d13212$export$3c915306cb7fc97a(placement)) ? "y" : "x";
}
function $10310cf078d13212$export$2b57e0052a6d6d4c(placement) {
    return $10310cf078d13212$export$8a000a963141ac32($10310cf078d13212$export$f28e8f882010718a(placement));
}
function $10310cf078d13212$export$be42861551f17911(placement, rects, rtl) {
    if (rtl === void 0) rtl = false;
    const alignment = $10310cf078d13212$export$f0989780f32bfcda(placement);
    const alignmentAxis = $10310cf078d13212$export$2b57e0052a6d6d4c(placement);
    const length = $10310cf078d13212$export$320bd9d53520c68a(alignmentAxis);
    let mainAlignmentSide = alignmentAxis === "x" ? alignment === (rtl ? "end" : "start") ? "right" : "left" : alignment === "start" ? "bottom" : "top";
    if (rects.reference[length] > rects.floating[length]) mainAlignmentSide = $10310cf078d13212$export$9c5e28bad23365fa(mainAlignmentSide);
    return [
        mainAlignmentSide,
        $10310cf078d13212$export$9c5e28bad23365fa(mainAlignmentSide)
    ];
}
function $10310cf078d13212$export$496432a3699e50b1(placement) {
    const oppositePlacement = $10310cf078d13212$export$9c5e28bad23365fa(placement);
    return [
        $10310cf078d13212$export$2b182c584985588b(placement),
        oppositePlacement,
        $10310cf078d13212$export$2b182c584985588b(oppositePlacement)
    ];
}
function $10310cf078d13212$export$2b182c584985588b(placement) {
    return placement.replace(/start|end/g, (alignment)=>$10310cf078d13212$var$oppositeAlignmentMap[alignment]);
}
function $10310cf078d13212$var$getSideList(side, isStart, rtl) {
    const lr = [
        "left",
        "right"
    ];
    const rl = [
        "right",
        "left"
    ];
    const tb = [
        "top",
        "bottom"
    ];
    const bt = [
        "bottom",
        "top"
    ];
    switch(side){
        case "top":
        case "bottom":
            if (rtl) return isStart ? rl : lr;
            return isStart ? lr : rl;
        case "left":
        case "right":
            return isStart ? tb : bt;
        default:
            return [];
    }
}
function $10310cf078d13212$export$a9b6fb18fd92c3ec(placement, flipAlignment, direction, rtl) {
    const alignment = $10310cf078d13212$export$f0989780f32bfcda(placement);
    let list = $10310cf078d13212$var$getSideList($10310cf078d13212$export$3c915306cb7fc97a(placement), direction === "start", rtl);
    if (alignment) {
        list = list.map((side)=>side + "-" + alignment);
        if (flipAlignment) list = list.concat(list.map($10310cf078d13212$export$2b182c584985588b));
    }
    return list;
}
function $10310cf078d13212$export$9c5e28bad23365fa(placement) {
    return placement.replace(/left|right|bottom|top/g, (side)=>$10310cf078d13212$var$oppositeSideMap[side]);
}
function $10310cf078d13212$export$1c66dbf1a9e34223(padding) {
    return {
        top: 0,
        right: 0,
        bottom: 0,
        left: 0,
        ...padding
    };
}
function $10310cf078d13212$export$598c291c29bc2e71(padding) {
    return typeof padding !== "number" ? $10310cf078d13212$export$1c66dbf1a9e34223(padding) : {
        top: padding,
        right: padding,
        bottom: padding,
        left: padding
    };
}
function $10310cf078d13212$export$ee05aea0aeecbad4(rect) {
    const { x: x, y: y, width: width, height: height } = rect;
    return {
        width: width,
        height: height,
        top: y,
        left: x,
        right: x + width,
        bottom: y + height,
        x: x,
        y: y
    };
}


function $973e4da43f2a375d$var$computeCoordsFromPlacement(_ref, placement, rtl) {
    let { reference: reference, floating: floating } = _ref;
    const sideAxis = (0, $10310cf078d13212$export$f28e8f882010718a)(placement);
    const alignmentAxis = (0, $10310cf078d13212$export$2b57e0052a6d6d4c)(placement);
    const alignLength = (0, $10310cf078d13212$export$320bd9d53520c68a)(alignmentAxis);
    const side = (0, $10310cf078d13212$export$3c915306cb7fc97a)(placement);
    const isVertical = sideAxis === "y";
    const commonX = reference.x + reference.width / 2 - floating.width / 2;
    const commonY = reference.y + reference.height / 2 - floating.height / 2;
    const commonAlign = reference[alignLength] / 2 - floating[alignLength] / 2;
    let coords;
    switch(side){
        case "top":
            coords = {
                x: commonX,
                y: reference.y - floating.height
            };
            break;
        case "bottom":
            coords = {
                x: commonX,
                y: reference.y + reference.height
            };
            break;
        case "right":
            coords = {
                x: reference.x + reference.width,
                y: commonY
            };
            break;
        case "left":
            coords = {
                x: reference.x - floating.width,
                y: commonY
            };
            break;
        default:
            coords = {
                x: reference.x,
                y: reference.y
            };
    }
    switch((0, $10310cf078d13212$export$f0989780f32bfcda)(placement)){
        case "start":
            coords[alignmentAxis] -= commonAlign * (rtl && isVertical ? -1 : 1);
            break;
        case "end":
            coords[alignmentAxis] += commonAlign * (rtl && isVertical ? -1 : 1);
            break;
    }
    return coords;
}
/**
 * Computes the `x` and `y` coordinates that will place the floating element
 * next to a given reference element.
 *
 * This export does not have any `platform` interface logic. You will need to
 * write one for the platform you are using Floating UI with.
 */ const $973e4da43f2a375d$export$48a53dcb22e581d0 = async (reference, floating, config)=>{
    const { placement: placement = "bottom", strategy: strategy = "absolute", middleware: middleware = [], platform: platform } = config;
    const validMiddleware = middleware.filter(Boolean);
    const rtl = await (platform.isRTL == null ? void 0 : platform.isRTL(floating));
    let rects = await platform.getElementRects({
        reference: reference,
        floating: floating,
        strategy: strategy
    });
    let { x: x, y: y } = $973e4da43f2a375d$var$computeCoordsFromPlacement(rects, placement, rtl);
    let statefulPlacement = placement;
    let middlewareData = {};
    let resetCount = 0;
    for(let i = 0; i < validMiddleware.length; i++){
        const { name: name, fn: fn } = validMiddleware[i];
        const { x: nextX, y: nextY, data: data, reset: reset } = await fn({
            x: x,
            y: y,
            initialPlacement: placement,
            placement: statefulPlacement,
            strategy: strategy,
            middlewareData: middlewareData,
            rects: rects,
            platform: platform,
            elements: {
                reference: reference,
                floating: floating
            }
        });
        x = nextX != null ? nextX : x;
        y = nextY != null ? nextY : y;
        middlewareData = {
            ...middlewareData,
            [name]: {
                ...middlewareData[name],
                ...data
            }
        };
        if (reset && resetCount <= 50) {
            resetCount++;
            if (typeof reset === "object") {
                if (reset.placement) statefulPlacement = reset.placement;
                if (reset.rects) rects = reset.rects === true ? await platform.getElementRects({
                    reference: reference,
                    floating: floating,
                    strategy: strategy
                }) : reset.rects;
                ({ x: x, y: y } = $973e4da43f2a375d$var$computeCoordsFromPlacement(rects, statefulPlacement, rtl));
            }
            i = -1;
        }
    }
    return {
        x: x,
        y: y,
        placement: statefulPlacement,
        strategy: strategy,
        middlewareData: middlewareData
    };
};
/**
 * Resolves with an object of overflow side offsets that determine how much the
 * element is overflowing a given clipping boundary on each side.
 * - positive = overflowing the boundary by that number of pixels
 * - negative = how many pixels left before it will overflow
 * - 0 = lies flush with the boundary
 * @see https://floating-ui.com/docs/detectOverflow
 */ async function $973e4da43f2a375d$export$37b6bde19b108ecc(state, options) {
    var _await$platform$isEle;
    if (options === void 0) options = {};
    const { x: x, y: y, platform: platform, rects: rects, elements: elements, strategy: strategy } = state;
    const { boundary: boundary = "clippingAncestors", rootBoundary: rootBoundary = "viewport", elementContext: elementContext = "floating", altBoundary: altBoundary = false, padding: padding = 0 } = (0, $10310cf078d13212$export$fef61f332f2c0afc)(options, state);
    const paddingObject = (0, $10310cf078d13212$export$598c291c29bc2e71)(padding);
    const altContext = elementContext === "floating" ? "reference" : "floating";
    const element = elements[altBoundary ? altContext : elementContext];
    const clippingClientRect = (0, $10310cf078d13212$export$ee05aea0aeecbad4)(await platform.getClippingRect({
        element: ((_await$platform$isEle = await (platform.isElement == null ? void 0 : platform.isElement(element))) != null ? _await$platform$isEle : true) ? element : element.contextElement || await (platform.getDocumentElement == null ? void 0 : platform.getDocumentElement(elements.floating)),
        boundary: boundary,
        rootBoundary: rootBoundary,
        strategy: strategy
    }));
    const rect = elementContext === "floating" ? {
        ...rects.floating,
        x: x,
        y: y
    } : rects.reference;
    const offsetParent = await (platform.getOffsetParent == null ? void 0 : platform.getOffsetParent(elements.floating));
    const offsetScale = await (platform.isElement == null ? void 0 : platform.isElement(offsetParent)) ? await (platform.getScale == null ? void 0 : platform.getScale(offsetParent)) || {
        x: 1,
        y: 1
    } : {
        x: 1,
        y: 1
    };
    const elementClientRect = (0, $10310cf078d13212$export$ee05aea0aeecbad4)(platform.convertOffsetParentRelativeRectToViewportRelativeRect ? await platform.convertOffsetParentRelativeRectToViewportRelativeRect({
        elements: elements,
        rect: rect,
        offsetParent: offsetParent,
        strategy: strategy
    }) : rect);
    return {
        top: (clippingClientRect.top - elementClientRect.top + paddingObject.top) / offsetScale.y,
        bottom: (elementClientRect.bottom - clippingClientRect.bottom + paddingObject.bottom) / offsetScale.y,
        left: (clippingClientRect.left - elementClientRect.left + paddingObject.left) / offsetScale.x,
        right: (elementClientRect.right - clippingClientRect.right + paddingObject.right) / offsetScale.x
    };
}
/**
 * Provides data to position an inner element of the floating element so that it
 * appears centered to the reference element.
 * @see https://floating-ui.com/docs/arrow
 */ const $973e4da43f2a375d$export$f2120bbfa5450bd2 = (options)=>({
        name: "arrow",
        options: options,
        async fn (state) {
            const { x: x, y: y, placement: placement, rects: rects, platform: platform, elements: elements, middlewareData: middlewareData } = state;
            // Since `element` is required, we don't Partial<> the type.
            const { element: element, padding: padding = 0 } = (0, $10310cf078d13212$export$fef61f332f2c0afc)(options, state) || {};
            if (element == null) return {};
            const paddingObject = (0, $10310cf078d13212$export$598c291c29bc2e71)(padding);
            const coords = {
                x: x,
                y: y
            };
            const axis = (0, $10310cf078d13212$export$2b57e0052a6d6d4c)(placement);
            const length = (0, $10310cf078d13212$export$320bd9d53520c68a)(axis);
            const arrowDimensions = await platform.getDimensions(element);
            const isYAxis = axis === "y";
            const minProp = isYAxis ? "top" : "left";
            const maxProp = isYAxis ? "bottom" : "right";
            const clientProp = isYAxis ? "clientHeight" : "clientWidth";
            const endDiff = rects.reference[length] + rects.reference[axis] - coords[axis] - rects.floating[length];
            const startDiff = coords[axis] - rects.reference[axis];
            const arrowOffsetParent = await (platform.getOffsetParent == null ? void 0 : platform.getOffsetParent(element));
            let clientSize = arrowOffsetParent ? arrowOffsetParent[clientProp] : 0;
            // DOM platform can return `window` as the `offsetParent`.
            if (!clientSize || !await (platform.isElement == null ? void 0 : platform.isElement(arrowOffsetParent))) clientSize = elements.floating[clientProp] || rects.floating[length];
            const centerToReference = endDiff / 2 - startDiff / 2;
            // If the padding is large enough that it causes the arrow to no longer be
            // centered, modify the padding so that it is centered.
            const largestPossiblePadding = clientSize / 2 - arrowDimensions[length] / 2 - 1;
            const minPadding = (0, $10310cf078d13212$export$96ec731ed4dcb222)(paddingObject[minProp], largestPossiblePadding);
            const maxPadding = (0, $10310cf078d13212$export$96ec731ed4dcb222)(paddingObject[maxProp], largestPossiblePadding);
            // Make sure the arrow doesn't overflow the floating element if the center
            // point is outside the floating element's bounds.
            const min$1 = minPadding;
            const max = clientSize - arrowDimensions[length] - maxPadding;
            const center = clientSize / 2 - arrowDimensions[length] / 2 + centerToReference;
            const offset = (0, $10310cf078d13212$export$7d15b64cf5a3a4c4)(min$1, center, max);
            // If the reference is small enough that the arrow's padding causes it to
            // to point to nothing for an aligned placement, adjust the offset of the
            // floating element itself. To ensure `shift()` continues to take action,
            // a single reset is performed when this is true.
            const shouldAddOffset = !middlewareData.arrow && (0, $10310cf078d13212$export$f0989780f32bfcda)(placement) != null && center !== offset && rects.reference[length] / 2 - (center < min$1 ? minPadding : maxPadding) - arrowDimensions[length] / 2 < 0;
            const alignmentOffset = shouldAddOffset ? center < min$1 ? center - min$1 : center - max : 0;
            return {
                [axis]: coords[axis] + alignmentOffset,
                data: {
                    [axis]: offset,
                    centerOffset: center - offset - alignmentOffset,
                    ...shouldAddOffset && {
                        alignmentOffset: alignmentOffset
                    }
                },
                reset: shouldAddOffset
            };
        }
    });
function $973e4da43f2a375d$var$getPlacementList(alignment, autoAlignment, allowedPlacements) {
    const allowedPlacementsSortedByAlignment = alignment ? [
        ...allowedPlacements.filter((placement)=>(0, $10310cf078d13212$export$f0989780f32bfcda)(placement) === alignment),
        ...allowedPlacements.filter((placement)=>(0, $10310cf078d13212$export$f0989780f32bfcda)(placement) !== alignment)
    ] : allowedPlacements.filter((placement)=>(0, $10310cf078d13212$export$3c915306cb7fc97a)(placement) === placement);
    return allowedPlacementsSortedByAlignment.filter((placement)=>{
        if (alignment) return (0, $10310cf078d13212$export$f0989780f32bfcda)(placement) === alignment || (autoAlignment ? (0, $10310cf078d13212$export$2b182c584985588b)(placement) !== placement : false);
        return true;
    });
}
/**
 * Optimizes the visibility of the floating element by choosing the placement
 * that has the most space available automatically, without needing to specify a
 * preferred placement. Alternative to `flip`.
 * @see https://floating-ui.com/docs/autoPlacement
 */ const $973e4da43f2a375d$export$91fb6ecbd551914 = function(options) {
    if (options === void 0) options = {};
    return {
        name: "autoPlacement",
        options: options,
        async fn (state) {
            var _middlewareData$autoP, _middlewareData$autoP2, _placementsThatFitOnE;
            const { rects: rects, middlewareData: middlewareData, placement: placement, platform: platform, elements: elements } = state;
            const { crossAxis: crossAxis = false, alignment: alignment, allowedPlacements: allowedPlacements = (0, $10310cf078d13212$export$803cd8101b6c182b), autoAlignment: autoAlignment = true, ...detectOverflowOptions } = (0, $10310cf078d13212$export$fef61f332f2c0afc)(options, state);
            const placements$1 = alignment !== undefined || allowedPlacements === (0, $10310cf078d13212$export$803cd8101b6c182b) ? $973e4da43f2a375d$var$getPlacementList(alignment || null, autoAlignment, allowedPlacements) : allowedPlacements;
            const overflow = await $973e4da43f2a375d$export$37b6bde19b108ecc(state, detectOverflowOptions);
            const currentIndex = ((_middlewareData$autoP = middlewareData.autoPlacement) == null ? void 0 : _middlewareData$autoP.index) || 0;
            const currentPlacement = placements$1[currentIndex];
            if (currentPlacement == null) return {};
            const alignmentSides = (0, $10310cf078d13212$export$be42861551f17911)(currentPlacement, rects, await (platform.isRTL == null ? void 0 : platform.isRTL(elements.floating)));
            // Make `computeCoords` start from the right place.
            if (placement !== currentPlacement) return {
                reset: {
                    placement: placements$1[0]
                }
            };
            const currentOverflows = [
                overflow[(0, $10310cf078d13212$export$3c915306cb7fc97a)(currentPlacement)],
                overflow[alignmentSides[0]],
                overflow[alignmentSides[1]]
            ];
            const allOverflows = [
                ...((_middlewareData$autoP2 = middlewareData.autoPlacement) == null ? void 0 : _middlewareData$autoP2.overflows) || [],
                {
                    placement: currentPlacement,
                    overflows: currentOverflows
                }
            ];
            const nextPlacement = placements$1[currentIndex + 1];
            // There are more placements to check.
            if (nextPlacement) return {
                data: {
                    index: currentIndex + 1,
                    overflows: allOverflows
                },
                reset: {
                    placement: nextPlacement
                }
            };
            const placementsSortedByMostSpace = allOverflows.map((d)=>{
                const alignment = (0, $10310cf078d13212$export$f0989780f32bfcda)(d.placement);
                return [
                    d.placement,
                    alignment && crossAxis ? // Check along the mainAxis and main crossAxis side.
                    d.overflows.slice(0, 2).reduce((acc, v)=>acc + v, 0) : // Check only the mainAxis.
                    d.overflows[0],
                    d.overflows
                ];
            }).sort((a, b)=>a[1] - b[1]);
            const placementsThatFitOnEachSide = placementsSortedByMostSpace.filter((d)=>d[2].slice(0, // Aligned placements should not check their opposite crossAxis
                // side.
                (0, $10310cf078d13212$export$f0989780f32bfcda)(d[0]) ? 2 : 3).every((v)=>v <= 0));
            const resetPlacement = ((_placementsThatFitOnE = placementsThatFitOnEachSide[0]) == null ? void 0 : _placementsThatFitOnE[0]) || placementsSortedByMostSpace[0][0];
            if (resetPlacement !== placement) return {
                data: {
                    index: currentIndex + 1,
                    overflows: allOverflows
                },
                reset: {
                    placement: resetPlacement
                }
            };
            return {};
        }
    };
};
/**
 * Optimizes the visibility of the floating element by flipping the `placement`
 * in order to keep it in view when the preferred placement(s) will overflow the
 * clipping boundary. Alternative to `autoPlacement`.
 * @see https://floating-ui.com/docs/flip
 */ const $973e4da43f2a375d$export$8a83211c878a3f1f = function(options) {
    if (options === void 0) options = {};
    return {
        name: "flip",
        options: options,
        async fn (state) {
            var _middlewareData$arrow, _middlewareData$flip;
            const { placement: placement, middlewareData: middlewareData, rects: rects, initialPlacement: initialPlacement, platform: platform, elements: elements } = state;
            const { mainAxis: checkMainAxis = true, crossAxis: checkCrossAxis = true, fallbackPlacements: specifiedFallbackPlacements, fallbackStrategy: fallbackStrategy = "bestFit", fallbackAxisSideDirection: fallbackAxisSideDirection = "none", flipAlignment: flipAlignment = true, ...detectOverflowOptions } = (0, $10310cf078d13212$export$fef61f332f2c0afc)(options, state);
            // If a reset by the arrow was caused due to an alignment offset being
            // added, we should skip any logic now since `flip()` has already done its
            // work.
            // https://github.com/floating-ui/floating-ui/issues/2549#issuecomment-1719601643
            if ((_middlewareData$arrow = middlewareData.arrow) != null && _middlewareData$arrow.alignmentOffset) return {};
            const side = (0, $10310cf078d13212$export$3c915306cb7fc97a)(placement);
            const isBasePlacement = (0, $10310cf078d13212$export$3c915306cb7fc97a)(initialPlacement) === initialPlacement;
            const rtl = await (platform.isRTL == null ? void 0 : platform.isRTL(elements.floating));
            const fallbackPlacements = specifiedFallbackPlacements || (isBasePlacement || !flipAlignment ? [
                (0, $10310cf078d13212$export$9c5e28bad23365fa)(initialPlacement)
            ] : (0, $10310cf078d13212$export$496432a3699e50b1)(initialPlacement));
            if (!specifiedFallbackPlacements && fallbackAxisSideDirection !== "none") fallbackPlacements.push(...(0, $10310cf078d13212$export$a9b6fb18fd92c3ec)(initialPlacement, flipAlignment, fallbackAxisSideDirection, rtl));
            const placements = [
                initialPlacement,
                ...fallbackPlacements
            ];
            const overflow = await $973e4da43f2a375d$export$37b6bde19b108ecc(state, detectOverflowOptions);
            const overflows = [];
            let overflowsData = ((_middlewareData$flip = middlewareData.flip) == null ? void 0 : _middlewareData$flip.overflows) || [];
            if (checkMainAxis) overflows.push(overflow[side]);
            if (checkCrossAxis) {
                const sides = (0, $10310cf078d13212$export$be42861551f17911)(placement, rects, rtl);
                overflows.push(overflow[sides[0]], overflow[sides[1]]);
            }
            overflowsData = [
                ...overflowsData,
                {
                    placement: placement,
                    overflows: overflows
                }
            ];
            // One or more sides is overflowing.
            if (!overflows.every((side)=>side <= 0)) {
                var _middlewareData$flip2, _overflowsData$filter;
                const nextIndex = (((_middlewareData$flip2 = middlewareData.flip) == null ? void 0 : _middlewareData$flip2.index) || 0) + 1;
                const nextPlacement = placements[nextIndex];
                if (nextPlacement) // Try next placement and re-run the lifecycle.
                return {
                    data: {
                        index: nextIndex,
                        overflows: overflowsData
                    },
                    reset: {
                        placement: nextPlacement
                    }
                };
                // First, find the candidates that fit on the mainAxis side of overflow,
                // then find the placement that fits the best on the main crossAxis side.
                let resetPlacement = (_overflowsData$filter = overflowsData.filter((d)=>d.overflows[0] <= 0).sort((a, b)=>a.overflows[1] - b.overflows[1])[0]) == null ? void 0 : _overflowsData$filter.placement;
                // Otherwise fallback.
                if (!resetPlacement) switch(fallbackStrategy){
                    case "bestFit":
                        {
                            var _overflowsData$map$so;
                            const placement = (_overflowsData$map$so = overflowsData.map((d)=>[
                                    d.placement,
                                    d.overflows.filter((overflow)=>overflow > 0).reduce((acc, overflow)=>acc + overflow, 0)
                                ]).sort((a, b)=>a[1] - b[1])[0]) == null ? void 0 : _overflowsData$map$so[0];
                            if (placement) resetPlacement = placement;
                            break;
                        }
                    case "initialPlacement":
                        resetPlacement = initialPlacement;
                        break;
                }
                if (placement !== resetPlacement) return {
                    reset: {
                        placement: resetPlacement
                    }
                };
            }
            return {};
        }
    };
};
function $973e4da43f2a375d$var$getSideOffsets(overflow, rect) {
    return {
        top: overflow.top - rect.height,
        right: overflow.right - rect.width,
        bottom: overflow.bottom - rect.height,
        left: overflow.left - rect.width
    };
}
function $973e4da43f2a375d$var$isAnySideFullyClipped(overflow) {
    return (0, $10310cf078d13212$export$832b6fa47fa053d2).some((side)=>overflow[side] >= 0);
}
/**
 * Provides data to hide the floating element in applicable situations, such as
 * when it is not in the same clipping context as the reference element.
 * @see https://floating-ui.com/docs/hide
 */ const $973e4da43f2a375d$export$fe8985bb6374093c = function(options) {
    if (options === void 0) options = {};
    return {
        name: "hide",
        options: options,
        async fn (state) {
            const { rects: rects } = state;
            const { strategy: strategy = "referenceHidden", ...detectOverflowOptions } = (0, $10310cf078d13212$export$fef61f332f2c0afc)(options, state);
            switch(strategy){
                case "referenceHidden":
                    {
                        const overflow = await $973e4da43f2a375d$export$37b6bde19b108ecc(state, {
                            ...detectOverflowOptions,
                            elementContext: "reference"
                        });
                        const offsets = $973e4da43f2a375d$var$getSideOffsets(overflow, rects.reference);
                        return {
                            data: {
                                referenceHiddenOffsets: offsets,
                                referenceHidden: $973e4da43f2a375d$var$isAnySideFullyClipped(offsets)
                            }
                        };
                    }
                case "escaped":
                    {
                        const overflow = await $973e4da43f2a375d$export$37b6bde19b108ecc(state, {
                            ...detectOverflowOptions,
                            altBoundary: true
                        });
                        const offsets = $973e4da43f2a375d$var$getSideOffsets(overflow, rects.floating);
                        return {
                            data: {
                                escapedOffsets: offsets,
                                escaped: $973e4da43f2a375d$var$isAnySideFullyClipped(offsets)
                            }
                        };
                    }
                default:
                    return {};
            }
        }
    };
};
function $973e4da43f2a375d$var$getBoundingRect(rects) {
    const minX = (0, $10310cf078d13212$export$96ec731ed4dcb222)(...rects.map((rect)=>rect.left));
    const minY = (0, $10310cf078d13212$export$96ec731ed4dcb222)(...rects.map((rect)=>rect.top));
    const maxX = (0, $10310cf078d13212$export$8960430cfd85939f)(...rects.map((rect)=>rect.right));
    const maxY = (0, $10310cf078d13212$export$8960430cfd85939f)(...rects.map((rect)=>rect.bottom));
    return {
        x: minX,
        y: minY,
        width: maxX - minX,
        height: maxY - minY
    };
}
function $973e4da43f2a375d$var$getRectsByLine(rects) {
    const sortedRects = rects.slice().sort((a, b)=>a.y - b.y);
    const groups = [];
    let prevRect = null;
    for(let i = 0; i < sortedRects.length; i++){
        const rect = sortedRects[i];
        if (!prevRect || rect.y - prevRect.y > prevRect.height / 2) groups.push([
            rect
        ]);
        else groups[groups.length - 1].push(rect);
        prevRect = rect;
    }
    return groups.map((rect)=>(0, $10310cf078d13212$export$ee05aea0aeecbad4)($973e4da43f2a375d$var$getBoundingRect(rect)));
}
/**
 * Provides improved positioning for inline reference elements that can span
 * over multiple lines, such as hyperlinks or range selections.
 * @see https://floating-ui.com/docs/inline
 */ const $973e4da43f2a375d$export$18c8ad048e32c7d5 = function(options) {
    if (options === void 0) options = {};
    return {
        name: "inline",
        options: options,
        async fn (state) {
            const { placement: placement, elements: elements, rects: rects, platform: platform, strategy: strategy } = state;
            // A MouseEvent's client{X,Y} coords can be up to 2 pixels off a
            // ClientRect's bounds, despite the event listener being triggered. A
            // padding of 2 seems to handle this issue.
            const { padding: padding = 2, x: x, y: y } = (0, $10310cf078d13212$export$fef61f332f2c0afc)(options, state);
            const nativeClientRects = Array.from(await (platform.getClientRects == null ? void 0 : platform.getClientRects(elements.reference)) || []);
            const clientRects = $973e4da43f2a375d$var$getRectsByLine(nativeClientRects);
            const fallback = (0, $10310cf078d13212$export$ee05aea0aeecbad4)($973e4da43f2a375d$var$getBoundingRect(nativeClientRects));
            const paddingObject = (0, $10310cf078d13212$export$598c291c29bc2e71)(padding);
            function getBoundingClientRect() {
                // There are two rects and they are disjoined.
                if (clientRects.length === 2 && clientRects[0].left > clientRects[1].right && x != null && y != null) // Find the first rect in which the point is fully inside.
                return clientRects.find((rect)=>x > rect.left - paddingObject.left && x < rect.right + paddingObject.right && y > rect.top - paddingObject.top && y < rect.bottom + paddingObject.bottom) || fallback;
                // There are 2 or more connected rects.
                if (clientRects.length >= 2) {
                    if ((0, $10310cf078d13212$export$f28e8f882010718a)(placement) === "y") {
                        const firstRect = clientRects[0];
                        const lastRect = clientRects[clientRects.length - 1];
                        const isTop = (0, $10310cf078d13212$export$3c915306cb7fc97a)(placement) === "top";
                        const top = firstRect.top;
                        const bottom = lastRect.bottom;
                        const left = isTop ? firstRect.left : lastRect.left;
                        const right = isTop ? firstRect.right : lastRect.right;
                        const width = right - left;
                        const height = bottom - top;
                        return {
                            top: top,
                            bottom: bottom,
                            left: left,
                            right: right,
                            width: width,
                            height: height,
                            x: left,
                            y: top
                        };
                    }
                    const isLeftSide = (0, $10310cf078d13212$export$3c915306cb7fc97a)(placement) === "left";
                    const maxRight = (0, $10310cf078d13212$export$8960430cfd85939f)(...clientRects.map((rect)=>rect.right));
                    const minLeft = (0, $10310cf078d13212$export$96ec731ed4dcb222)(...clientRects.map((rect)=>rect.left));
                    const measureRects = clientRects.filter((rect)=>isLeftSide ? rect.left === minLeft : rect.right === maxRight);
                    const top = measureRects[0].top;
                    const bottom = measureRects[measureRects.length - 1].bottom;
                    const left = minLeft;
                    const right = maxRight;
                    const width = right - left;
                    const height = bottom - top;
                    return {
                        top: top,
                        bottom: bottom,
                        left: left,
                        right: right,
                        width: width,
                        height: height,
                        x: left,
                        y: top
                    };
                }
                return fallback;
            }
            const resetRects = await platform.getElementRects({
                reference: {
                    getBoundingClientRect: getBoundingClientRect
                },
                floating: elements.floating,
                strategy: strategy
            });
            if (rects.reference.x !== resetRects.reference.x || rects.reference.y !== resetRects.reference.y || rects.reference.width !== resetRects.reference.width || rects.reference.height !== resetRects.reference.height) return {
                reset: {
                    rects: resetRects
                }
            };
            return {};
        }
    };
};
// For type backwards-compatibility, the `OffsetOptions` type was also
// Derivable.
async function $973e4da43f2a375d$var$convertValueToCoords(state, options) {
    const { placement: placement, platform: platform, elements: elements } = state;
    const rtl = await (platform.isRTL == null ? void 0 : platform.isRTL(elements.floating));
    const side = (0, $10310cf078d13212$export$3c915306cb7fc97a)(placement);
    const alignment = (0, $10310cf078d13212$export$f0989780f32bfcda)(placement);
    const isVertical = (0, $10310cf078d13212$export$f28e8f882010718a)(placement) === "y";
    const mainAxisMulti = [
        "left",
        "top"
    ].includes(side) ? -1 : 1;
    const crossAxisMulti = rtl && isVertical ? -1 : 1;
    const rawValue = (0, $10310cf078d13212$export$fef61f332f2c0afc)(options, state);
    let { mainAxis: mainAxis, crossAxis: crossAxis, alignmentAxis: alignmentAxis } = typeof rawValue === "number" ? {
        mainAxis: rawValue,
        crossAxis: 0,
        alignmentAxis: null
    } : {
        mainAxis: 0,
        crossAxis: 0,
        alignmentAxis: null,
        ...rawValue
    };
    if (alignment && typeof alignmentAxis === "number") crossAxis = alignment === "end" ? alignmentAxis * -1 : alignmentAxis;
    return isVertical ? {
        x: crossAxis * crossAxisMulti,
        y: mainAxis * mainAxisMulti
    } : {
        x: mainAxis * mainAxisMulti,
        y: crossAxis * crossAxisMulti
    };
}
/**
 * Modifies the placement by translating the floating element along the
 * specified axes.
 * A number (shorthand for `mainAxis` or distance), or an axes configuration
 * object may be passed.
 * @see https://floating-ui.com/docs/offset
 */ const $973e4da43f2a375d$export$cc800923e997bb8 = function(options) {
    if (options === void 0) options = 0;
    return {
        name: "offset",
        options: options,
        async fn (state) {
            var _middlewareData$offse, _middlewareData$arrow;
            const { x: x, y: y, placement: placement, middlewareData: middlewareData } = state;
            const diffCoords = await $973e4da43f2a375d$var$convertValueToCoords(state, options);
            // If the placement is the same and the arrow caused an alignment offset
            // then we don't need to change the positioning coordinates.
            if (placement === ((_middlewareData$offse = middlewareData.offset) == null ? void 0 : _middlewareData$offse.placement) && (_middlewareData$arrow = middlewareData.arrow) != null && _middlewareData$arrow.alignmentOffset) return {};
            return {
                x: x + diffCoords.x,
                y: y + diffCoords.y,
                data: {
                    ...diffCoords,
                    placement: placement
                }
            };
        }
    };
};
/**
 * Optimizes the visibility of the floating element by shifting it in order to
 * keep it in view when it will overflow the clipping boundary.
 * @see https://floating-ui.com/docs/shift
 */ const $973e4da43f2a375d$export$fba63a578e423eb = function(options) {
    if (options === void 0) options = {};
    return {
        name: "shift",
        options: options,
        async fn (state) {
            const { x: x, y: y, placement: placement } = state;
            const { mainAxis: checkMainAxis = true, crossAxis: checkCrossAxis = false, limiter: limiter = {
                fn: (_ref)=>{
                    let { x: x, y: y } = _ref;
                    return {
                        x: x,
                        y: y
                    };
                }
            }, ...detectOverflowOptions } = (0, $10310cf078d13212$export$fef61f332f2c0afc)(options, state);
            const coords = {
                x: x,
                y: y
            };
            const overflow = await $973e4da43f2a375d$export$37b6bde19b108ecc(state, detectOverflowOptions);
            const crossAxis = (0, $10310cf078d13212$export$f28e8f882010718a)((0, $10310cf078d13212$export$3c915306cb7fc97a)(placement));
            const mainAxis = (0, $10310cf078d13212$export$8a000a963141ac32)(crossAxis);
            let mainAxisCoord = coords[mainAxis];
            let crossAxisCoord = coords[crossAxis];
            if (checkMainAxis) {
                const minSide = mainAxis === "y" ? "top" : "left";
                const maxSide = mainAxis === "y" ? "bottom" : "right";
                const min = mainAxisCoord + overflow[minSide];
                const max = mainAxisCoord - overflow[maxSide];
                mainAxisCoord = (0, $10310cf078d13212$export$7d15b64cf5a3a4c4)(min, mainAxisCoord, max);
            }
            if (checkCrossAxis) {
                const minSide = crossAxis === "y" ? "top" : "left";
                const maxSide = crossAxis === "y" ? "bottom" : "right";
                const min = crossAxisCoord + overflow[minSide];
                const max = crossAxisCoord - overflow[maxSide];
                crossAxisCoord = (0, $10310cf078d13212$export$7d15b64cf5a3a4c4)(min, crossAxisCoord, max);
            }
            const limitedCoords = limiter.fn({
                ...state,
                [mainAxis]: mainAxisCoord,
                [crossAxis]: crossAxisCoord
            });
            return {
                ...limitedCoords,
                data: {
                    x: limitedCoords.x - x,
                    y: limitedCoords.y - y
                }
            };
        }
    };
};
/**
 * Built-in `limiter` that will stop `shift()` at a certain point.
 */ const $973e4da43f2a375d$export$7bf07e38f3dc4b69 = function(options) {
    if (options === void 0) options = {};
    return {
        options: options,
        fn (state) {
            const { x: x, y: y, placement: placement, rects: rects, middlewareData: middlewareData } = state;
            const { offset: offset = 0, mainAxis: checkMainAxis = true, crossAxis: checkCrossAxis = true } = (0, $10310cf078d13212$export$fef61f332f2c0afc)(options, state);
            const coords = {
                x: x,
                y: y
            };
            const crossAxis = (0, $10310cf078d13212$export$f28e8f882010718a)(placement);
            const mainAxis = (0, $10310cf078d13212$export$8a000a963141ac32)(crossAxis);
            let mainAxisCoord = coords[mainAxis];
            let crossAxisCoord = coords[crossAxis];
            const rawOffset = (0, $10310cf078d13212$export$fef61f332f2c0afc)(offset, state);
            const computedOffset = typeof rawOffset === "number" ? {
                mainAxis: rawOffset,
                crossAxis: 0
            } : {
                mainAxis: 0,
                crossAxis: 0,
                ...rawOffset
            };
            if (checkMainAxis) {
                const len = mainAxis === "y" ? "height" : "width";
                const limitMin = rects.reference[mainAxis] - rects.floating[len] + computedOffset.mainAxis;
                const limitMax = rects.reference[mainAxis] + rects.reference[len] - computedOffset.mainAxis;
                if (mainAxisCoord < limitMin) mainAxisCoord = limitMin;
                else if (mainAxisCoord > limitMax) mainAxisCoord = limitMax;
            }
            if (checkCrossAxis) {
                var _middlewareData$offse, _middlewareData$offse2;
                const len = mainAxis === "y" ? "width" : "height";
                const isOriginSide = [
                    "top",
                    "left"
                ].includes((0, $10310cf078d13212$export$3c915306cb7fc97a)(placement));
                const limitMin = rects.reference[crossAxis] - rects.floating[len] + (isOriginSide ? ((_middlewareData$offse = middlewareData.offset) == null ? void 0 : _middlewareData$offse[crossAxis]) || 0 : 0) + (isOriginSide ? 0 : computedOffset.crossAxis);
                const limitMax = rects.reference[crossAxis] + rects.reference[len] + (isOriginSide ? 0 : ((_middlewareData$offse2 = middlewareData.offset) == null ? void 0 : _middlewareData$offse2[crossAxis]) || 0) - (isOriginSide ? computedOffset.crossAxis : 0);
                if (crossAxisCoord < limitMin) crossAxisCoord = limitMin;
                else if (crossAxisCoord > limitMax) crossAxisCoord = limitMax;
            }
            return {
                [mainAxis]: mainAxisCoord,
                [crossAxis]: crossAxisCoord
            };
        }
    };
};
/**
 * Provides data that allows you to change the size of the floating element —
 * for instance, prevent it from overflowing the clipping boundary or match the
 * width of the reference element.
 * @see https://floating-ui.com/docs/size
 */ const $973e4da43f2a375d$export$346677f925de839c = function(options) {
    if (options === void 0) options = {};
    return {
        name: "size",
        options: options,
        async fn (state) {
            const { placement: placement, rects: rects, platform: platform, elements: elements } = state;
            const { apply: apply = ()=>{}, ...detectOverflowOptions } = (0, $10310cf078d13212$export$fef61f332f2c0afc)(options, state);
            const overflow = await $973e4da43f2a375d$export$37b6bde19b108ecc(state, detectOverflowOptions);
            const side = (0, $10310cf078d13212$export$3c915306cb7fc97a)(placement);
            const alignment = (0, $10310cf078d13212$export$f0989780f32bfcda)(placement);
            const isYAxis = (0, $10310cf078d13212$export$f28e8f882010718a)(placement) === "y";
            const { width: width, height: height } = rects.floating;
            let heightSide;
            let widthSide;
            if (side === "top" || side === "bottom") {
                heightSide = side;
                widthSide = alignment === (await (platform.isRTL == null ? void 0 : platform.isRTL(elements.floating)) ? "start" : "end") ? "left" : "right";
            } else {
                widthSide = side;
                heightSide = alignment === "end" ? "top" : "bottom";
            }
            const overflowAvailableHeight = height - overflow[heightSide];
            const overflowAvailableWidth = width - overflow[widthSide];
            const noShift = !state.middlewareData.shift;
            let availableHeight = overflowAvailableHeight;
            let availableWidth = overflowAvailableWidth;
            if (isYAxis) {
                const maximumClippingWidth = width - overflow.left - overflow.right;
                availableWidth = alignment || noShift ? (0, $10310cf078d13212$export$96ec731ed4dcb222)(overflowAvailableWidth, maximumClippingWidth) : maximumClippingWidth;
            } else {
                const maximumClippingHeight = height - overflow.top - overflow.bottom;
                availableHeight = alignment || noShift ? (0, $10310cf078d13212$export$96ec731ed4dcb222)(overflowAvailableHeight, maximumClippingHeight) : maximumClippingHeight;
            }
            if (noShift && !alignment) {
                const xMin = (0, $10310cf078d13212$export$8960430cfd85939f)(overflow.left, 0);
                const xMax = (0, $10310cf078d13212$export$8960430cfd85939f)(overflow.right, 0);
                const yMin = (0, $10310cf078d13212$export$8960430cfd85939f)(overflow.top, 0);
                const yMax = (0, $10310cf078d13212$export$8960430cfd85939f)(overflow.bottom, 0);
                if (isYAxis) availableWidth = width - 2 * (xMin !== 0 || xMax !== 0 ? xMin + xMax : (0, $10310cf078d13212$export$8960430cfd85939f)(overflow.left, overflow.right));
                else availableHeight = height - 2 * (yMin !== 0 || yMax !== 0 ? yMin + yMax : (0, $10310cf078d13212$export$8960430cfd85939f)(overflow.top, overflow.bottom));
            }
            await apply({
                ...state,
                availableWidth: availableWidth,
                availableHeight: availableHeight
            });
            const nextDimensions = await platform.getDimensions(elements.floating);
            if (width !== nextDimensions.width || height !== nextDimensions.height) return {
                reset: {
                    rects: true
                }
            };
            return {};
        }
    };
};



function $238ac70369f38756$var$hasWindow() {
    return typeof window !== "undefined";
}
function $238ac70369f38756$export$651544f548703224(node) {
    if ($238ac70369f38756$export$8ee0fc9ee280b4ee(node)) return (node.nodeName || "").toLowerCase();
    // Mocked nodes in testing environments may not be instances of Node. By
    // returning `#document` an infinite loop won't occur.
    // https://github.com/floating-ui/floating-ui/issues/2317
    return "#document";
}
function $238ac70369f38756$export$38b2d434cce3ea22(node) {
    var _node$ownerDocument;
    return (node == null || (_node$ownerDocument = node.ownerDocument) == null ? void 0 : _node$ownerDocument.defaultView) || window;
}
function $238ac70369f38756$export$e495491855dc5418(node) {
    var _ref;
    return (_ref = ($238ac70369f38756$export$8ee0fc9ee280b4ee(node) ? node.ownerDocument : node.document) || window.document) == null ? void 0 : _ref.documentElement;
}
function $238ac70369f38756$export$8ee0fc9ee280b4ee(value) {
    if (!$238ac70369f38756$var$hasWindow()) return false;
    return value instanceof Node || value instanceof $238ac70369f38756$export$38b2d434cce3ea22(value).Node;
}
function $238ac70369f38756$export$45a5e7f76e0caa8d(value) {
    if (!$238ac70369f38756$var$hasWindow()) return false;
    return value instanceof Element || value instanceof $238ac70369f38756$export$38b2d434cce3ea22(value).Element;
}
function $238ac70369f38756$export$1b3bfaa9684536aa(value) {
    if (!$238ac70369f38756$var$hasWindow()) return false;
    return value instanceof HTMLElement || value instanceof $238ac70369f38756$export$38b2d434cce3ea22(value).HTMLElement;
}
function $238ac70369f38756$export$af51f0f06c0f328a(value) {
    if (!$238ac70369f38756$var$hasWindow() || typeof ShadowRoot === "undefined") return false;
    return value instanceof ShadowRoot || value instanceof $238ac70369f38756$export$38b2d434cce3ea22(value).ShadowRoot;
}
function $238ac70369f38756$export$989e911fa9af580a(element) {
    const { overflow: overflow, overflowX: overflowX, overflowY: overflowY, display: display } = $238ac70369f38756$export$3735103072e4a80(element);
    return /auto|scroll|overlay|hidden|clip/.test(overflow + overflowY + overflowX) && ![
        "inline",
        "contents"
    ].includes(display);
}
function $238ac70369f38756$export$71535ffaa902797f(element) {
    return [
        "table",
        "td",
        "th"
    ].includes($238ac70369f38756$export$651544f548703224(element));
}
function $238ac70369f38756$export$89e651af02346cd4(element) {
    return [
        ":popover-open",
        ":modal"
    ].some((selector)=>{
        try {
            return element.matches(selector);
        } catch (e) {
            return false;
        }
    });
}
function $238ac70369f38756$export$d6c4e8150c35fed1(elementOrCss) {
    const webkit = $238ac70369f38756$export$78551043582a6a98();
    const css = $238ac70369f38756$export$45a5e7f76e0caa8d(elementOrCss) ? $238ac70369f38756$export$3735103072e4a80(elementOrCss) : elementOrCss;
    // https://developer.mozilla.org/en-US/docs/Web/CSS/Containing_block#identifying_the_containing_block
    // https://drafts.csswg.org/css-transforms-2/#individual-transforms
    return [
        "transform",
        "translate",
        "scale",
        "rotate",
        "perspective"
    ].some((value)=>css[value] ? css[value] !== "none" : false) || (css.containerType ? css.containerType !== "normal" : false) || !webkit && (css.backdropFilter ? css.backdropFilter !== "none" : false) || !webkit && (css.filter ? css.filter !== "none" : false) || [
        "transform",
        "translate",
        "scale",
        "rotate",
        "perspective",
        "filter"
    ].some((value)=>(css.willChange || "").includes(value)) || [
        "paint",
        "layout",
        "strict",
        "content"
    ].some((value)=>(css.contain || "").includes(value));
}
function $238ac70369f38756$export$940d8225183e1404(element) {
    let currentNode = $238ac70369f38756$export$4e12058fc4d51d56(element);
    while($238ac70369f38756$export$1b3bfaa9684536aa(currentNode) && !$238ac70369f38756$export$d1162fb0b6d4cd51(currentNode)){
        if ($238ac70369f38756$export$d6c4e8150c35fed1(currentNode)) return currentNode;
        else if ($238ac70369f38756$export$89e651af02346cd4(currentNode)) return null;
        currentNode = $238ac70369f38756$export$4e12058fc4d51d56(currentNode);
    }
    return null;
}
function $238ac70369f38756$export$78551043582a6a98() {
    if (typeof CSS === "undefined" || !CSS.supports) return false;
    return CSS.supports("-webkit-backdrop-filter", "none");
}
function $238ac70369f38756$export$d1162fb0b6d4cd51(node) {
    return [
        "html",
        "body",
        "#document"
    ].includes($238ac70369f38756$export$651544f548703224(node));
}
function $238ac70369f38756$export$3735103072e4a80(element) {
    return $238ac70369f38756$export$38b2d434cce3ea22(element).getComputedStyle(element);
}
function $238ac70369f38756$export$dc8fc79fa2800137(element) {
    if ($238ac70369f38756$export$45a5e7f76e0caa8d(element)) return {
        scrollLeft: element.scrollLeft,
        scrollTop: element.scrollTop
    };
    return {
        scrollLeft: element.scrollX,
        scrollTop: element.scrollY
    };
}
function $238ac70369f38756$export$4e12058fc4d51d56(node) {
    if ($238ac70369f38756$export$651544f548703224(node) === "html") return node;
    const result = // Step into the shadow DOM of the parent of a slotted node.
    node.assignedSlot || // DOM Element detected.
    node.parentNode || // ShadowRoot detected.
    $238ac70369f38756$export$af51f0f06c0f328a(node) && node.host || // Fallback.
    $238ac70369f38756$export$e495491855dc5418(node);
    return $238ac70369f38756$export$af51f0f06c0f328a(result) ? result.host : result;
}
function $238ac70369f38756$export$7cd01a57c8ca906c(node) {
    const parentNode = $238ac70369f38756$export$4e12058fc4d51d56(node);
    if ($238ac70369f38756$export$d1162fb0b6d4cd51(parentNode)) return node.ownerDocument ? node.ownerDocument.body : node.body;
    if ($238ac70369f38756$export$1b3bfaa9684536aa(parentNode) && $238ac70369f38756$export$989e911fa9af580a(parentNode)) return parentNode;
    return $238ac70369f38756$export$7cd01a57c8ca906c(parentNode);
}
function $238ac70369f38756$export$3b57c1601291186b(node, list, traverseIframes) {
    var _node$ownerDocument2;
    if (list === void 0) list = [];
    if (traverseIframes === void 0) traverseIframes = true;
    const scrollableAncestor = $238ac70369f38756$export$7cd01a57c8ca906c(node);
    const isBody = scrollableAncestor === ((_node$ownerDocument2 = node.ownerDocument) == null ? void 0 : _node$ownerDocument2.body);
    const win = $238ac70369f38756$export$38b2d434cce3ea22(scrollableAncestor);
    if (isBody) {
        const frameElement = $238ac70369f38756$export$7bf1f8740e3e34af(win);
        return list.concat(win, win.visualViewport || [], $238ac70369f38756$export$989e911fa9af580a(scrollableAncestor) ? scrollableAncestor : [], frameElement && traverseIframes ? $238ac70369f38756$export$3b57c1601291186b(frameElement) : []);
    }
    return list.concat(scrollableAncestor, $238ac70369f38756$export$3b57c1601291186b(scrollableAncestor, [], traverseIframes));
}
function $238ac70369f38756$export$7bf1f8740e3e34af(win) {
    return win.parent && Object.getPrototypeOf(win.parent) ? win.frameElement : null;
}


function $461947879dcdbcd4$var$getCssDimensions(element) {
    const css = (0, $238ac70369f38756$export$3735103072e4a80)(element);
    // In testing environments, the `width` and `height` properties are empty
    // strings for SVG elements, returning NaN. Fallback to `0` in this case.
    let width = parseFloat(css.width) || 0;
    let height = parseFloat(css.height) || 0;
    const hasOffset = (0, $238ac70369f38756$export$1b3bfaa9684536aa)(element);
    const offsetWidth = hasOffset ? element.offsetWidth : width;
    const offsetHeight = hasOffset ? element.offsetHeight : height;
    const shouldFallback = (0, $10310cf078d13212$export$2077e0241d6afd3c)(width) !== offsetWidth || (0, $10310cf078d13212$export$2077e0241d6afd3c)(height) !== offsetHeight;
    if (shouldFallback) {
        width = offsetWidth;
        height = offsetHeight;
    }
    return {
        width: width,
        height: height,
        $: shouldFallback
    };
}
function $461947879dcdbcd4$var$unwrapElement(element) {
    return !(0, $238ac70369f38756$export$45a5e7f76e0caa8d)(element) ? element.contextElement : element;
}
function $461947879dcdbcd4$var$getScale(element) {
    const domElement = $461947879dcdbcd4$var$unwrapElement(element);
    if (!(0, $238ac70369f38756$export$1b3bfaa9684536aa)(domElement)) return (0, $10310cf078d13212$export$a397704b5e280835)(1);
    const rect = domElement.getBoundingClientRect();
    const { width: width, height: height, $: $ } = $461947879dcdbcd4$var$getCssDimensions(domElement);
    let x = ($ ? (0, $10310cf078d13212$export$2077e0241d6afd3c)(rect.width) : rect.width) / width;
    let y = ($ ? (0, $10310cf078d13212$export$2077e0241d6afd3c)(rect.height) : rect.height) / height;
    // 0, NaN, or Infinity should always fallback to 1.
    if (!x || !Number.isFinite(x)) x = 1;
    if (!y || !Number.isFinite(y)) y = 1;
    return {
        x: x,
        y: y
    };
}
const $461947879dcdbcd4$var$noOffsets = /*#__PURE__*/ (0, $10310cf078d13212$export$a397704b5e280835)(0);
function $461947879dcdbcd4$var$getVisualOffsets(element) {
    const win = (0, $238ac70369f38756$export$38b2d434cce3ea22)(element);
    if (!(0, $238ac70369f38756$export$78551043582a6a98)() || !win.visualViewport) return $461947879dcdbcd4$var$noOffsets;
    return {
        x: win.visualViewport.offsetLeft,
        y: win.visualViewport.offsetTop
    };
}
function $461947879dcdbcd4$var$shouldAddVisualOffsets(element, isFixed, floatingOffsetParent) {
    if (isFixed === void 0) isFixed = false;
    if (!floatingOffsetParent || isFixed && floatingOffsetParent !== (0, $238ac70369f38756$export$38b2d434cce3ea22)(element)) return false;
    return isFixed;
}
function $461947879dcdbcd4$var$getBoundingClientRect(element, includeScale, isFixedStrategy, offsetParent) {
    if (includeScale === void 0) includeScale = false;
    if (isFixedStrategy === void 0) isFixedStrategy = false;
    const clientRect = element.getBoundingClientRect();
    const domElement = $461947879dcdbcd4$var$unwrapElement(element);
    let scale = (0, $10310cf078d13212$export$a397704b5e280835)(1);
    if (includeScale) {
        if (offsetParent) {
            if ((0, $238ac70369f38756$export$45a5e7f76e0caa8d)(offsetParent)) scale = $461947879dcdbcd4$var$getScale(offsetParent);
        } else scale = $461947879dcdbcd4$var$getScale(element);
    }
    const visualOffsets = $461947879dcdbcd4$var$shouldAddVisualOffsets(domElement, isFixedStrategy, offsetParent) ? $461947879dcdbcd4$var$getVisualOffsets(domElement) : (0, $10310cf078d13212$export$a397704b5e280835)(0);
    let x = (clientRect.left + visualOffsets.x) / scale.x;
    let y = (clientRect.top + visualOffsets.y) / scale.y;
    let width = clientRect.width / scale.x;
    let height = clientRect.height / scale.y;
    if (domElement) {
        const win = (0, $238ac70369f38756$export$38b2d434cce3ea22)(domElement);
        const offsetWin = offsetParent && (0, $238ac70369f38756$export$45a5e7f76e0caa8d)(offsetParent) ? (0, $238ac70369f38756$export$38b2d434cce3ea22)(offsetParent) : offsetParent;
        let currentWin = win;
        let currentIFrame = currentWin.frameElement;
        while(currentIFrame && offsetParent && offsetWin !== currentWin){
            const iframeScale = $461947879dcdbcd4$var$getScale(currentIFrame);
            const iframeRect = currentIFrame.getBoundingClientRect();
            const css = (0, $238ac70369f38756$export$3735103072e4a80)(currentIFrame);
            const left = iframeRect.left + (currentIFrame.clientLeft + parseFloat(css.paddingLeft)) * iframeScale.x;
            const top = iframeRect.top + (currentIFrame.clientTop + parseFloat(css.paddingTop)) * iframeScale.y;
            x *= iframeScale.x;
            y *= iframeScale.y;
            width *= iframeScale.x;
            height *= iframeScale.y;
            x += left;
            y += top;
            currentWin = (0, $238ac70369f38756$export$38b2d434cce3ea22)(currentIFrame);
            currentIFrame = currentWin.frameElement;
        }
    }
    return (0, $10310cf078d13212$export$ee05aea0aeecbad4)({
        width: width,
        height: height,
        x: x,
        y: y
    });
}
const $461947879dcdbcd4$var$topLayerSelectors = [
    ":popover-open",
    ":modal"
];
function $461947879dcdbcd4$var$isTopLayer(floating) {
    return $461947879dcdbcd4$var$topLayerSelectors.some((selector)=>{
        try {
            return floating.matches(selector);
        } catch (e) {
            return false;
        }
    });
}
function $461947879dcdbcd4$var$convertOffsetParentRelativeRectToViewportRelativeRect(_ref) {
    let { elements: elements, rect: rect, offsetParent: offsetParent, strategy: strategy } = _ref;
    const isFixed = strategy === "fixed";
    const documentElement = (0, $238ac70369f38756$export$e495491855dc5418)(offsetParent);
    const topLayer = elements ? $461947879dcdbcd4$var$isTopLayer(elements.floating) : false;
    if (offsetParent === documentElement || topLayer && isFixed) return rect;
    let scroll = {
        scrollLeft: 0,
        scrollTop: 0
    };
    let scale = (0, $10310cf078d13212$export$a397704b5e280835)(1);
    const offsets = (0, $10310cf078d13212$export$a397704b5e280835)(0);
    const isOffsetParentAnElement = (0, $238ac70369f38756$export$1b3bfaa9684536aa)(offsetParent);
    if (isOffsetParentAnElement || !isOffsetParentAnElement && !isFixed) {
        if ((0, $238ac70369f38756$export$651544f548703224)(offsetParent) !== "body" || (0, $238ac70369f38756$export$989e911fa9af580a)(documentElement)) scroll = (0, $238ac70369f38756$export$dc8fc79fa2800137)(offsetParent);
        if ((0, $238ac70369f38756$export$1b3bfaa9684536aa)(offsetParent)) {
            const offsetRect = $461947879dcdbcd4$var$getBoundingClientRect(offsetParent);
            scale = $461947879dcdbcd4$var$getScale(offsetParent);
            offsets.x = offsetRect.x + offsetParent.clientLeft;
            offsets.y = offsetRect.y + offsetParent.clientTop;
        }
    }
    return {
        width: rect.width * scale.x,
        height: rect.height * scale.y,
        x: rect.x * scale.x - scroll.scrollLeft * scale.x + offsets.x,
        y: rect.y * scale.y - scroll.scrollTop * scale.y + offsets.y
    };
}
function $461947879dcdbcd4$var$getClientRects(element) {
    return Array.from(element.getClientRects());
}
function $461947879dcdbcd4$var$getWindowScrollBarX(element) {
    // If <html> has a CSS width greater than the viewport, then this will be
    // incorrect for RTL.
    return $461947879dcdbcd4$var$getBoundingClientRect((0, $238ac70369f38756$export$e495491855dc5418)(element)).left + (0, $238ac70369f38756$export$dc8fc79fa2800137)(element).scrollLeft;
}
// Gets the entire size of the scrollable document area, even extending outside
// of the `<html>` and `<body>` rect bounds if horizontally scrollable.
function $461947879dcdbcd4$var$getDocumentRect(element) {
    const html = (0, $238ac70369f38756$export$e495491855dc5418)(element);
    const scroll = (0, $238ac70369f38756$export$dc8fc79fa2800137)(element);
    const body = element.ownerDocument.body;
    const width = (0, $10310cf078d13212$export$8960430cfd85939f)(html.scrollWidth, html.clientWidth, body.scrollWidth, body.clientWidth);
    const height = (0, $10310cf078d13212$export$8960430cfd85939f)(html.scrollHeight, html.clientHeight, body.scrollHeight, body.clientHeight);
    let x = -scroll.scrollLeft + $461947879dcdbcd4$var$getWindowScrollBarX(element);
    const y = -scroll.scrollTop;
    if ((0, $238ac70369f38756$export$3735103072e4a80)(body).direction === "rtl") x += (0, $10310cf078d13212$export$8960430cfd85939f)(html.clientWidth, body.clientWidth) - width;
    return {
        width: width,
        height: height,
        x: x,
        y: y
    };
}
function $461947879dcdbcd4$var$getViewportRect(element, strategy) {
    const win = (0, $238ac70369f38756$export$38b2d434cce3ea22)(element);
    const html = (0, $238ac70369f38756$export$e495491855dc5418)(element);
    const visualViewport = win.visualViewport;
    let width = html.clientWidth;
    let height = html.clientHeight;
    let x = 0;
    let y = 0;
    if (visualViewport) {
        width = visualViewport.width;
        height = visualViewport.height;
        const visualViewportBased = (0, $238ac70369f38756$export$78551043582a6a98)();
        if (!visualViewportBased || visualViewportBased && strategy === "fixed") {
            x = visualViewport.offsetLeft;
            y = visualViewport.offsetTop;
        }
    }
    return {
        width: width,
        height: height,
        x: x,
        y: y
    };
}
// Returns the inner client rect, subtracting scrollbars if present.
function $461947879dcdbcd4$var$getInnerBoundingClientRect(element, strategy) {
    const clientRect = $461947879dcdbcd4$var$getBoundingClientRect(element, true, strategy === "fixed");
    const top = clientRect.top + element.clientTop;
    const left = clientRect.left + element.clientLeft;
    const scale = (0, $238ac70369f38756$export$1b3bfaa9684536aa)(element) ? $461947879dcdbcd4$var$getScale(element) : (0, $10310cf078d13212$export$a397704b5e280835)(1);
    const width = element.clientWidth * scale.x;
    const height = element.clientHeight * scale.y;
    const x = left * scale.x;
    const y = top * scale.y;
    return {
        width: width,
        height: height,
        x: x,
        y: y
    };
}
function $461947879dcdbcd4$var$getClientRectFromClippingAncestor(element, clippingAncestor, strategy) {
    let rect;
    if (clippingAncestor === "viewport") rect = $461947879dcdbcd4$var$getViewportRect(element, strategy);
    else if (clippingAncestor === "document") rect = $461947879dcdbcd4$var$getDocumentRect((0, $238ac70369f38756$export$e495491855dc5418)(element));
    else if ((0, $238ac70369f38756$export$45a5e7f76e0caa8d)(clippingAncestor)) rect = $461947879dcdbcd4$var$getInnerBoundingClientRect(clippingAncestor, strategy);
    else {
        const visualOffsets = $461947879dcdbcd4$var$getVisualOffsets(element);
        rect = {
            ...clippingAncestor,
            x: clippingAncestor.x - visualOffsets.x,
            y: clippingAncestor.y - visualOffsets.y
        };
    }
    return (0, $10310cf078d13212$export$ee05aea0aeecbad4)(rect);
}
function $461947879dcdbcd4$var$hasFixedPositionAncestor(element, stopNode) {
    const parentNode = (0, $238ac70369f38756$export$4e12058fc4d51d56)(element);
    if (parentNode === stopNode || !(0, $238ac70369f38756$export$45a5e7f76e0caa8d)(parentNode) || (0, $238ac70369f38756$export$d1162fb0b6d4cd51)(parentNode)) return false;
    return (0, $238ac70369f38756$export$3735103072e4a80)(parentNode).position === "fixed" || $461947879dcdbcd4$var$hasFixedPositionAncestor(parentNode, stopNode);
}
// A "clipping ancestor" is an `overflow` element with the characteristic of
// clipping (or hiding) child elements. This returns all clipping ancestors
// of the given element up the tree.
function $461947879dcdbcd4$var$getClippingElementAncestors(element, cache) {
    const cachedResult = cache.get(element);
    if (cachedResult) return cachedResult;
    let result = (0, $238ac70369f38756$export$3b57c1601291186b)(element, [], false).filter((el)=>(0, $238ac70369f38756$export$45a5e7f76e0caa8d)(el) && (0, $238ac70369f38756$export$651544f548703224)(el) !== "body");
    let currentContainingBlockComputedStyle = null;
    const elementIsFixed = (0, $238ac70369f38756$export$3735103072e4a80)(element).position === "fixed";
    let currentNode = elementIsFixed ? (0, $238ac70369f38756$export$4e12058fc4d51d56)(element) : element;
    // https://developer.mozilla.org/en-US/docs/Web/CSS/Containing_block#identifying_the_containing_block
    while((0, $238ac70369f38756$export$45a5e7f76e0caa8d)(currentNode) && !(0, $238ac70369f38756$export$d1162fb0b6d4cd51)(currentNode)){
        const computedStyle = (0, $238ac70369f38756$export$3735103072e4a80)(currentNode);
        const currentNodeIsContaining = (0, $238ac70369f38756$export$d6c4e8150c35fed1)(currentNode);
        if (!currentNodeIsContaining && computedStyle.position === "fixed") currentContainingBlockComputedStyle = null;
        const shouldDropCurrentNode = elementIsFixed ? !currentNodeIsContaining && !currentContainingBlockComputedStyle : !currentNodeIsContaining && computedStyle.position === "static" && !!currentContainingBlockComputedStyle && [
            "absolute",
            "fixed"
        ].includes(currentContainingBlockComputedStyle.position) || (0, $238ac70369f38756$export$989e911fa9af580a)(currentNode) && !currentNodeIsContaining && $461947879dcdbcd4$var$hasFixedPositionAncestor(element, currentNode);
        if (shouldDropCurrentNode) // Drop non-containing blocks.
        result = result.filter((ancestor)=>ancestor !== currentNode);
        else // Record last containing block for next iteration.
        currentContainingBlockComputedStyle = computedStyle;
        currentNode = (0, $238ac70369f38756$export$4e12058fc4d51d56)(currentNode);
    }
    cache.set(element, result);
    return result;
}
// Gets the maximum area that the element is visible in due to any number of
// clipping ancestors.
function $461947879dcdbcd4$var$getClippingRect(_ref) {
    let { element: element, boundary: boundary, rootBoundary: rootBoundary, strategy: strategy } = _ref;
    const elementClippingAncestors = boundary === "clippingAncestors" ? $461947879dcdbcd4$var$getClippingElementAncestors(element, this._c) : [].concat(boundary);
    const clippingAncestors = [
        ...elementClippingAncestors,
        rootBoundary
    ];
    const firstClippingAncestor = clippingAncestors[0];
    const clippingRect = clippingAncestors.reduce((accRect, clippingAncestor)=>{
        const rect = $461947879dcdbcd4$var$getClientRectFromClippingAncestor(element, clippingAncestor, strategy);
        accRect.top = (0, $10310cf078d13212$export$8960430cfd85939f)(rect.top, accRect.top);
        accRect.right = (0, $10310cf078d13212$export$96ec731ed4dcb222)(rect.right, accRect.right);
        accRect.bottom = (0, $10310cf078d13212$export$96ec731ed4dcb222)(rect.bottom, accRect.bottom);
        accRect.left = (0, $10310cf078d13212$export$8960430cfd85939f)(rect.left, accRect.left);
        return accRect;
    }, $461947879dcdbcd4$var$getClientRectFromClippingAncestor(element, firstClippingAncestor, strategy));
    return {
        width: clippingRect.right - clippingRect.left,
        height: clippingRect.bottom - clippingRect.top,
        x: clippingRect.left,
        y: clippingRect.top
    };
}
function $461947879dcdbcd4$var$getDimensions(element) {
    const { width: width, height: height } = $461947879dcdbcd4$var$getCssDimensions(element);
    return {
        width: width,
        height: height
    };
}
function $461947879dcdbcd4$var$getRectRelativeToOffsetParent(element, offsetParent, strategy) {
    const isOffsetParentAnElement = (0, $238ac70369f38756$export$1b3bfaa9684536aa)(offsetParent);
    const documentElement = (0, $238ac70369f38756$export$e495491855dc5418)(offsetParent);
    const isFixed = strategy === "fixed";
    const rect = $461947879dcdbcd4$var$getBoundingClientRect(element, true, isFixed, offsetParent);
    let scroll = {
        scrollLeft: 0,
        scrollTop: 0
    };
    const offsets = (0, $10310cf078d13212$export$a397704b5e280835)(0);
    if (isOffsetParentAnElement || !isOffsetParentAnElement && !isFixed) {
        if ((0, $238ac70369f38756$export$651544f548703224)(offsetParent) !== "body" || (0, $238ac70369f38756$export$989e911fa9af580a)(documentElement)) scroll = (0, $238ac70369f38756$export$dc8fc79fa2800137)(offsetParent);
        if (isOffsetParentAnElement) {
            const offsetRect = $461947879dcdbcd4$var$getBoundingClientRect(offsetParent, true, isFixed, offsetParent);
            offsets.x = offsetRect.x + offsetParent.clientLeft;
            offsets.y = offsetRect.y + offsetParent.clientTop;
        } else if (documentElement) offsets.x = $461947879dcdbcd4$var$getWindowScrollBarX(documentElement);
    }
    const x = rect.left + scroll.scrollLeft - offsets.x;
    const y = rect.top + scroll.scrollTop - offsets.y;
    return {
        x: x,
        y: y,
        width: rect.width,
        height: rect.height
    };
}
function $461947879dcdbcd4$var$getTrueOffsetParent(element, polyfill) {
    if (!(0, $238ac70369f38756$export$1b3bfaa9684536aa)(element) || (0, $238ac70369f38756$export$3735103072e4a80)(element).position === "fixed") return null;
    if (polyfill) return polyfill(element);
    return element.offsetParent;
}
// Gets the closest ancestor positioned element. Handles some edge cases,
// such as table ancestors and cross browser bugs.
function $461947879dcdbcd4$var$getOffsetParent(element, polyfill) {
    const window = (0, $238ac70369f38756$export$38b2d434cce3ea22)(element);
    if (!(0, $238ac70369f38756$export$1b3bfaa9684536aa)(element) || $461947879dcdbcd4$var$isTopLayer(element)) return window;
    let offsetParent = $461947879dcdbcd4$var$getTrueOffsetParent(element, polyfill);
    while(offsetParent && (0, $238ac70369f38756$export$71535ffaa902797f)(offsetParent) && (0, $238ac70369f38756$export$3735103072e4a80)(offsetParent).position === "static")offsetParent = $461947879dcdbcd4$var$getTrueOffsetParent(offsetParent, polyfill);
    if (offsetParent && ((0, $238ac70369f38756$export$651544f548703224)(offsetParent) === "html" || (0, $238ac70369f38756$export$651544f548703224)(offsetParent) === "body" && (0, $238ac70369f38756$export$3735103072e4a80)(offsetParent).position === "static" && !(0, $238ac70369f38756$export$d6c4e8150c35fed1)(offsetParent))) return window;
    return offsetParent || (0, $238ac70369f38756$export$940d8225183e1404)(element) || window;
}
const $461947879dcdbcd4$var$getElementRects = async function(data) {
    const getOffsetParentFn = this.getOffsetParent || $461947879dcdbcd4$var$getOffsetParent;
    const getDimensionsFn = this.getDimensions;
    return {
        reference: $461947879dcdbcd4$var$getRectRelativeToOffsetParent(data.reference, await getOffsetParentFn(data.floating), data.strategy),
        floating: {
            x: 0,
            y: 0,
            ...await getDimensionsFn(data.floating)
        }
    };
};
function $461947879dcdbcd4$var$isRTL(element) {
    return (0, $238ac70369f38756$export$3735103072e4a80)(element).direction === "rtl";
}
const $461947879dcdbcd4$export$722a64dea1b767dc = {
    convertOffsetParentRelativeRectToViewportRelativeRect: $461947879dcdbcd4$var$convertOffsetParentRelativeRectToViewportRelativeRect,
    getDocumentElement: $238ac70369f38756$export$e495491855dc5418,
    getClippingRect: $461947879dcdbcd4$var$getClippingRect,
    getOffsetParent: $461947879dcdbcd4$var$getOffsetParent,
    getElementRects: $461947879dcdbcd4$var$getElementRects,
    getClientRects: $461947879dcdbcd4$var$getClientRects,
    getDimensions: $461947879dcdbcd4$var$getDimensions,
    getScale: $461947879dcdbcd4$var$getScale,
    isElement: $238ac70369f38756$export$45a5e7f76e0caa8d,
    isRTL: $461947879dcdbcd4$var$isRTL
};
// https://samthor.au/2021/observing-dom/
function $461947879dcdbcd4$var$observeMove(element, onMove) {
    let io = null;
    let timeoutId;
    const root = (0, $238ac70369f38756$export$e495491855dc5418)(element);
    function cleanup() {
        var _io;
        clearTimeout(timeoutId);
        (_io = io) == null || _io.disconnect();
        io = null;
    }
    function refresh(skip, threshold) {
        if (skip === void 0) skip = false;
        if (threshold === void 0) threshold = 1;
        cleanup();
        const { left: left, top: top, width: width, height: height } = element.getBoundingClientRect();
        if (!skip) onMove();
        if (!width || !height) return;
        const insetTop = (0, $10310cf078d13212$export$a3fe094919f356fd)(top);
        const insetRight = (0, $10310cf078d13212$export$a3fe094919f356fd)(root.clientWidth - (left + width));
        const insetBottom = (0, $10310cf078d13212$export$a3fe094919f356fd)(root.clientHeight - (top + height));
        const insetLeft = (0, $10310cf078d13212$export$a3fe094919f356fd)(left);
        const rootMargin = -insetTop + "px " + -insetRight + "px " + -insetBottom + "px " + -insetLeft + "px";
        const options = {
            rootMargin: rootMargin,
            threshold: (0, $10310cf078d13212$export$8960430cfd85939f)(0, (0, $10310cf078d13212$export$96ec731ed4dcb222)(1, threshold)) || 1
        };
        let isFirstUpdate = true;
        function handleObserve(entries) {
            const ratio = entries[0].intersectionRatio;
            if (ratio !== threshold) {
                if (!isFirstUpdate) return refresh();
                if (!ratio) timeoutId = setTimeout(()=>{
                    refresh(false, 1e-7);
                }, 100);
                else refresh(false, ratio);
            }
            isFirstUpdate = false;
        }
        // Older browsers don't support a `document` as the root and will throw an
        // error.
        try {
            io = new IntersectionObserver(handleObserve, {
                ...options,
                // Handle <iframe>s
                root: root.ownerDocument
            });
        } catch (e) {
            io = new IntersectionObserver(handleObserve, options);
        }
        io.observe(element);
    }
    refresh(true);
    return cleanup;
}
/**
 * Automatically updates the position of the floating element when necessary.
 * Should only be called when the floating element is mounted on the DOM or
 * visible on the screen.
 * @returns cleanup function that should be invoked when the floating element is
 * removed from the DOM or hidden from the screen.
 * @see https://floating-ui.com/docs/autoUpdate
 */ function $461947879dcdbcd4$export$deee3a793edee05f(reference, floating, update, options) {
    if (options === void 0) options = {};
    const { ancestorScroll: ancestorScroll = true, ancestorResize: ancestorResize = true, elementResize: elementResize = typeof ResizeObserver === "function", layoutShift: layoutShift = typeof IntersectionObserver === "function", animationFrame: animationFrame = false } = options;
    const referenceEl = $461947879dcdbcd4$var$unwrapElement(reference);
    const ancestors = ancestorScroll || ancestorResize ? [
        ...referenceEl ? (0, $238ac70369f38756$export$3b57c1601291186b)(referenceEl) : [],
        ...(0, $238ac70369f38756$export$3b57c1601291186b)(floating)
    ] : [];
    ancestors.forEach((ancestor)=>{
        ancestorScroll && ancestor.addEventListener("scroll", update, {
            passive: true
        });
        ancestorResize && ancestor.addEventListener("resize", update);
    });
    const cleanupIo = referenceEl && layoutShift ? $461947879dcdbcd4$var$observeMove(referenceEl, update) : null;
    let reobserveFrame = -1;
    let resizeObserver = null;
    if (elementResize) {
        resizeObserver = new ResizeObserver((_ref)=>{
            let [firstEntry] = _ref;
            if (firstEntry && firstEntry.target === referenceEl && resizeObserver) {
                // Prevent update loops when using the `size` middleware.
                // https://github.com/floating-ui/floating-ui/issues/1740
                resizeObserver.unobserve(floating);
                cancelAnimationFrame(reobserveFrame);
                reobserveFrame = requestAnimationFrame(()=>{
                    var _resizeObserver;
                    (_resizeObserver = resizeObserver) == null || _resizeObserver.observe(floating);
                });
            }
            update();
        });
        if (referenceEl && !animationFrame) resizeObserver.observe(referenceEl);
        resizeObserver.observe(floating);
    }
    let frameId;
    let prevRefRect = animationFrame ? $461947879dcdbcd4$var$getBoundingClientRect(reference) : null;
    if (animationFrame) frameLoop();
    function frameLoop() {
        const nextRefRect = $461947879dcdbcd4$var$getBoundingClientRect(reference);
        if (prevRefRect && (nextRefRect.x !== prevRefRect.x || nextRefRect.y !== prevRefRect.y || nextRefRect.width !== prevRefRect.width || nextRefRect.height !== prevRefRect.height)) update();
        prevRefRect = nextRefRect;
        frameId = requestAnimationFrame(frameLoop);
    }
    update();
    return ()=>{
        var _resizeObserver2;
        ancestors.forEach((ancestor)=>{
            ancestorScroll && ancestor.removeEventListener("scroll", update);
            ancestorResize && ancestor.removeEventListener("resize", update);
        });
        cleanupIo == null || cleanupIo();
        (_resizeObserver2 = resizeObserver) == null || _resizeObserver2.disconnect();
        resizeObserver = null;
        if (animationFrame) cancelAnimationFrame(frameId);
    };
}
/**
 * Optimizes the visibility of the floating element by choosing the placement
 * that has the most space available automatically, without needing to specify a
 * preferred placement. Alternative to `flip`.
 * @see https://floating-ui.com/docs/autoPlacement
 */ const $461947879dcdbcd4$export$91fb6ecbd551914 = (0, $973e4da43f2a375d$export$91fb6ecbd551914);
/**
 * Optimizes the visibility of the floating element by shifting it in order to
 * keep it in view when it will overflow the clipping boundary.
 * @see https://floating-ui.com/docs/shift
 */ const $461947879dcdbcd4$export$fba63a578e423eb = (0, $973e4da43f2a375d$export$fba63a578e423eb);
/**
 * Optimizes the visibility of the floating element by flipping the `placement`
 * in order to keep it in view when the preferred placement(s) will overflow the
 * clipping boundary. Alternative to `autoPlacement`.
 * @see https://floating-ui.com/docs/flip
 */ const $461947879dcdbcd4$export$8a83211c878a3f1f = (0, $973e4da43f2a375d$export$8a83211c878a3f1f);
/**
 * Provides data that allows you to change the size of the floating element —
 * for instance, prevent it from overflowing the clipping boundary or match the
 * width of the reference element.
 * @see https://floating-ui.com/docs/size
 */ const $461947879dcdbcd4$export$346677f925de839c = (0, $973e4da43f2a375d$export$346677f925de839c);
/**
 * Provides data to hide the floating element in applicable situations, such as
 * when it is not in the same clipping context as the reference element.
 * @see https://floating-ui.com/docs/hide
 */ const $461947879dcdbcd4$export$fe8985bb6374093c = (0, $973e4da43f2a375d$export$fe8985bb6374093c);
/**
 * Provides data to position an inner element of the floating element so that it
 * appears centered to the reference element.
 * @see https://floating-ui.com/docs/arrow
 */ const $461947879dcdbcd4$export$f2120bbfa5450bd2 = (0, $973e4da43f2a375d$export$f2120bbfa5450bd2);
/**
 * Provides improved positioning for inline reference elements that can span
 * over multiple lines, such as hyperlinks or range selections.
 * @see https://floating-ui.com/docs/inline
 */ const $461947879dcdbcd4$export$18c8ad048e32c7d5 = (0, $973e4da43f2a375d$export$18c8ad048e32c7d5);
/**
 * Built-in `limiter` that will stop `shift()` at a certain point.
 */ const $461947879dcdbcd4$export$7bf07e38f3dc4b69 = (0, $973e4da43f2a375d$export$7bf07e38f3dc4b69);
/**
 * Computes the `x` and `y` coordinates that will place the floating element
 * next to a given reference element.
 */ const $461947879dcdbcd4$export$48a53dcb22e581d0 = (reference, floating, options)=>{
    // This caches the expensive `getClippingElementAncestors` function so that
    // multiple lifecycle resets re-use the same result. It only lives for a
    // single call. If other functions become expensive, we can add them as well.
    const cache = new Map();
    const mergedOptions = {
        platform: $461947879dcdbcd4$export$722a64dea1b767dc,
        ...options
    };
    const platformWithCache = {
        ...mergedOptions.platform,
        _c: cache
    };
    return (0, $973e4da43f2a375d$export$48a53dcb22e581d0)(reference, floating, {
        ...mergedOptions,
        platform: platformWithCache
    });
};



var $acw62 = parcelRequire("acw62");
var $e62b4578a0a2b358$var$index = (0, $acw62.useLayoutEffect);
var $e62b4578a0a2b358$export$2e2bcd8739ae039 = $e62b4578a0a2b358$var$index;


var $a9284aba291bbde9$var$_excluded$4 = [
    "className",
    "clearValue",
    "cx",
    "getStyles",
    "getClassNames",
    "getValue",
    "hasValue",
    "isMulti",
    "isRtl",
    "options",
    "selectOption",
    "selectProps",
    "setValue",
    "theme"
];
// ==============================
// NO OP
// ==============================
var $a9284aba291bbde9$export$b4171a6734a65d42 = function noop() {};
// ==============================
// Class Name Prefixer
// ==============================
/**
 String representation of component state for styling with class names.

 Expects an array of strings OR a string/object pair:
 - className(['comp', 'comp-arg', 'comp-arg-2'])
   @returns 'react-select__comp react-select__comp-arg react-select__comp-arg-2'
 - className('comp', { some: true, state: false })
   @returns 'react-select__comp react-select__comp--some'
*/ function $a9284aba291bbde9$var$applyPrefixToName(prefix, name) {
    if (!name) return prefix;
    else if (name[0] === "-") return prefix + name;
    else return prefix + "__" + name;
}
function $a9284aba291bbde9$export$a9c23c6ac3fc3eca(prefix, state) {
    for(var _len = arguments.length, classNameList = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++)classNameList[_key - 2] = arguments[_key];
    var arr = [].concat(classNameList);
    if (state && prefix) {
        for(var key in state)if (state.hasOwnProperty(key) && state[key]) arr.push("".concat($a9284aba291bbde9$var$applyPrefixToName(prefix, key)));
    }
    return arr.filter(function(i) {
        return i;
    }).map(function(i) {
        return String(i).trim();
    }).join(" ");
}
// ==============================
// Clean Value
// ==============================
var $a9284aba291bbde9$export$7f8ddf7c7c20b3cd = function cleanValue(value) {
    if ($a9284aba291bbde9$var$isArray(value)) return value.filter(Boolean);
    if ((0, $b8f57191916382d3$export$2e2bcd8739ae039)(value) === "object" && value !== null) return [
        value
    ];
    return [];
};
// ==============================
// Clean Common Props
// ==============================
var $a9284aba291bbde9$var$cleanCommonProps = function cleanCommonProps(props) {
    //className
    props.className;
    props.clearValue;
    props.cx;
    props.getStyles;
    props.getClassNames;
    props.getValue;
    props.hasValue;
    props.isMulti;
    props.isRtl;
    props.options;
    props.selectOption;
    props.selectProps;
    props.setValue;
    props.theme;
    var innerProps = (0, $73ef9ce1c41fc0c0$export$2e2bcd8739ae039)(props, $a9284aba291bbde9$var$_excluded$4);
    return (0, $983350b7b3960a26$export$2e2bcd8739ae039)({}, innerProps);
};
// ==============================
// Get Style Props
// ==============================
var $a9284aba291bbde9$var$getStyleProps = function getStyleProps(props, name, classNamesState) {
    var cx = props.cx, getStyles = props.getStyles, getClassNames = props.getClassNames, className = props.className;
    return {
        css: getStyles(name, props),
        className: cx(classNamesState !== null && classNamesState !== void 0 ? classNamesState : {}, getClassNames(name, props), className)
    };
};
// ==============================
// Handle Input Change
// ==============================
function $a9284aba291bbde9$export$61196ced6d74a310(inputValue, actionMeta, onInputChange) {
    if (onInputChange) {
        var _newValue = onInputChange(inputValue, actionMeta);
        if (typeof _newValue === "string") return _newValue;
    }
    return inputValue;
}
// ==============================
// Scroll Helpers
// ==============================
function $a9284aba291bbde9$export$2329c99376c9d0a4(el) {
    return [
        document.documentElement,
        document.body,
        window
    ].indexOf(el) > -1;
}
// Normalized Scroll Top
// ------------------------------
function $a9284aba291bbde9$var$normalizedHeight(el) {
    if ($a9284aba291bbde9$export$2329c99376c9d0a4(el)) return window.innerHeight;
    return el.clientHeight;
}
// Normalized scrollTo & scrollTop
// ------------------------------
function $a9284aba291bbde9$var$getScrollTop(el) {
    if ($a9284aba291bbde9$export$2329c99376c9d0a4(el)) return window.pageYOffset;
    return el.scrollTop;
}
function $a9284aba291bbde9$var$scrollTo(el, top) {
    // with a scroll distance, we perform scroll on the element
    if ($a9284aba291bbde9$export$2329c99376c9d0a4(el)) {
        window.scrollTo(0, top);
        return;
    }
    el.scrollTop = top;
}
// Get Scroll Parent
// ------------------------------
function $a9284aba291bbde9$var$getScrollParent(element) {
    var style = getComputedStyle(element);
    var excludeStaticParent = style.position === "absolute";
    var overflowRx = /(auto|scroll)/;
    if (style.position === "fixed") return document.documentElement;
    for(var parent = element; parent = parent.parentElement;){
        style = getComputedStyle(parent);
        if (excludeStaticParent && style.position === "static") continue;
        if (overflowRx.test(style.overflow + style.overflowY + style.overflowX)) return parent;
    }
    return document.documentElement;
}
// Animated Scroll To
// ------------------------------
/**
  @param t: time (elapsed)
  @param b: initial value
  @param c: amount of change
  @param d: duration
*/ function $a9284aba291bbde9$var$easeOutCubic(t, b, c, d) {
    return c * ((t = t / d - 1) * t * t + 1) + b;
}
function $a9284aba291bbde9$var$animatedScrollTo(element, to) {
    var duration = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 200;
    var callback = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : $a9284aba291bbde9$export$b4171a6734a65d42;
    var start = $a9284aba291bbde9$var$getScrollTop(element);
    var change = to - start;
    var increment = 10;
    var currentTime = 0;
    function animateScroll() {
        currentTime += increment;
        var val = $a9284aba291bbde9$var$easeOutCubic(currentTime, start, change, duration);
        $a9284aba291bbde9$var$scrollTo(element, val);
        if (currentTime < duration) window.requestAnimationFrame(animateScroll);
        else callback(element);
    }
    animateScroll();
}
// Scroll Into View
// ------------------------------
function $a9284aba291bbde9$export$9bb611d729802a56(menuEl, focusedEl) {
    var menuRect = menuEl.getBoundingClientRect();
    var focusedRect = focusedEl.getBoundingClientRect();
    var overScroll = focusedEl.offsetHeight / 3;
    if (focusedRect.bottom + overScroll > menuRect.bottom) $a9284aba291bbde9$var$scrollTo(menuEl, Math.min(focusedEl.offsetTop + focusedEl.clientHeight - menuEl.offsetHeight + overScroll, menuEl.scrollHeight));
    else if (focusedRect.top - overScroll < menuRect.top) $a9284aba291bbde9$var$scrollTo(menuEl, Math.max(focusedEl.offsetTop - overScroll, 0));
}
// ==============================
// Get bounding client object
// ==============================
// cannot get keys using array notation with DOMRect
function $a9284aba291bbde9$var$getBoundingClientObj(element) {
    var rect = element.getBoundingClientRect();
    return {
        bottom: rect.bottom,
        height: rect.height,
        left: rect.left,
        right: rect.right,
        top: rect.top,
        width: rect.width
    };
}
// ==============================
// Touch Capability Detector
// ==============================
function $a9284aba291bbde9$export$df995fae86a55f06() {
    try {
        document.createEvent("TouchEvent");
        return true;
    } catch (e) {
        return false;
    }
}
// ==============================
// Mobile Device Detector
// ==============================
function $a9284aba291bbde9$export$ebd11618f299a286() {
    try {
        return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
    } catch (e) {
        return false;
    }
}
// ==============================
// Passive Event Detector
// ==============================
// https://github.com/rafgraph/detect-it/blob/main/src/index.ts#L19-L36
var $a9284aba291bbde9$var$passiveOptionAccessed = false;
var $a9284aba291bbde9$var$options = {
    get passive () {
        return $a9284aba291bbde9$var$passiveOptionAccessed = true;
    }
};
// check for SSR
var $a9284aba291bbde9$var$w = typeof window !== "undefined" ? window : {};
if ($a9284aba291bbde9$var$w.addEventListener && $a9284aba291bbde9$var$w.removeEventListener) {
    $a9284aba291bbde9$var$w.addEventListener("p", $a9284aba291bbde9$export$b4171a6734a65d42, $a9284aba291bbde9$var$options);
    $a9284aba291bbde9$var$w.removeEventListener("p", $a9284aba291bbde9$export$b4171a6734a65d42, false);
}
var $a9284aba291bbde9$export$2408f22a0fab9ae5 = $a9284aba291bbde9$var$passiveOptionAccessed;
function $a9284aba291bbde9$export$3466f893ebf79586(item) {
    return item != null;
}
function $a9284aba291bbde9$var$isArray(arg) {
    return Array.isArray(arg);
}
function $a9284aba291bbde9$export$96f57966bedc81b4(isMulti, multiValue, singleValue) {
    return isMulti ? multiValue : singleValue;
}
function $a9284aba291bbde9$export$e7094788287c5e9b(singleValue) {
    return singleValue;
}
function $a9284aba291bbde9$export$ef35774e6d314e91(multiValue) {
    return multiValue;
}
var $a9284aba291bbde9$export$43caf9889c228507 = function removeProps(propsObj) {
    for(var _len2 = arguments.length, properties = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++)properties[_key2 - 1] = arguments[_key2];
    var propsMap = Object.entries(propsObj).filter(function(_ref) {
        var _ref2 = (0, $adaabbc18727b3e6$export$2e2bcd8739ae039)(_ref, 1), key = _ref2[0];
        return !properties.includes(key);
    });
    return propsMap.reduce(function(newProps, _ref3) {
        var _ref4 = (0, $adaabbc18727b3e6$export$2e2bcd8739ae039)(_ref3, 2), key = _ref4[0], val = _ref4[1];
        newProps[key] = val;
        return newProps;
    }, {});
};
var $a9284aba291bbde9$var$_excluded$3 = [
    "children",
    "innerProps"
], $a9284aba291bbde9$var$_excluded2$1 = [
    "children",
    "innerProps"
];
function $a9284aba291bbde9$var$getMenuPlacement(_ref) {
    var preferredMaxHeight = _ref.maxHeight, menuEl = _ref.menuEl, minHeight = _ref.minHeight, preferredPlacement = _ref.placement, shouldScroll = _ref.shouldScroll, isFixedPosition = _ref.isFixedPosition, controlHeight = _ref.controlHeight;
    var scrollParent = $a9284aba291bbde9$var$getScrollParent(menuEl);
    var defaultState = {
        placement: "bottom",
        maxHeight: preferredMaxHeight
    };
    // something went wrong, return default state
    if (!menuEl || !menuEl.offsetParent) return defaultState;
    // we can't trust `scrollParent.scrollHeight` --> it may increase when
    // the menu is rendered
    var _scrollParent$getBoun = scrollParent.getBoundingClientRect(), scrollHeight = _scrollParent$getBoun.height;
    var _menuEl$getBoundingCl = menuEl.getBoundingClientRect(), menuBottom = _menuEl$getBoundingCl.bottom, menuHeight = _menuEl$getBoundingCl.height, menuTop = _menuEl$getBoundingCl.top;
    var _menuEl$offsetParent$ = menuEl.offsetParent.getBoundingClientRect(), containerTop = _menuEl$offsetParent$.top;
    var viewHeight = isFixedPosition ? window.innerHeight : $a9284aba291bbde9$var$normalizedHeight(scrollParent);
    var scrollTop = $a9284aba291bbde9$var$getScrollTop(scrollParent);
    var marginBottom = parseInt(getComputedStyle(menuEl).marginBottom, 10);
    var marginTop = parseInt(getComputedStyle(menuEl).marginTop, 10);
    var viewSpaceAbove = containerTop - marginTop;
    var viewSpaceBelow = viewHeight - menuTop;
    var scrollSpaceAbove = viewSpaceAbove + scrollTop;
    var scrollSpaceBelow = scrollHeight - scrollTop - menuTop;
    var scrollDown = menuBottom - viewHeight + scrollTop + marginBottom;
    var scrollUp = scrollTop + menuTop - marginTop;
    var scrollDuration = 160;
    switch(preferredPlacement){
        case "auto":
        case "bottom":
            // 1: the menu will fit, do nothing
            if (viewSpaceBelow >= menuHeight) return {
                placement: "bottom",
                maxHeight: preferredMaxHeight
            };
            // 2: the menu will fit, if scrolled
            if (scrollSpaceBelow >= menuHeight && !isFixedPosition) {
                if (shouldScroll) $a9284aba291bbde9$var$animatedScrollTo(scrollParent, scrollDown, scrollDuration);
                return {
                    placement: "bottom",
                    maxHeight: preferredMaxHeight
                };
            }
            // 3: the menu will fit, if constrained
            if (!isFixedPosition && scrollSpaceBelow >= minHeight || isFixedPosition && viewSpaceBelow >= minHeight) {
                if (shouldScroll) $a9284aba291bbde9$var$animatedScrollTo(scrollParent, scrollDown, scrollDuration);
                // we want to provide as much of the menu as possible to the user,
                // so give them whatever is available below rather than the minHeight.
                var constrainedHeight = isFixedPosition ? viewSpaceBelow - marginBottom : scrollSpaceBelow - marginBottom;
                return {
                    placement: "bottom",
                    maxHeight: constrainedHeight
                };
            }
            // 4. Forked beviour when there isn't enough space below
            // AUTO: flip the menu, render above
            if (preferredPlacement === "auto" || isFixedPosition) {
                // may need to be constrained after flipping
                var _constrainedHeight = preferredMaxHeight;
                var spaceAbove = isFixedPosition ? viewSpaceAbove : scrollSpaceAbove;
                if (spaceAbove >= minHeight) _constrainedHeight = Math.min(spaceAbove - marginBottom - controlHeight, preferredMaxHeight);
                return {
                    placement: "top",
                    maxHeight: _constrainedHeight
                };
            }
            // BOTTOM: allow browser to increase scrollable area and immediately set scroll
            if (preferredPlacement === "bottom") {
                if (shouldScroll) $a9284aba291bbde9$var$scrollTo(scrollParent, scrollDown);
                return {
                    placement: "bottom",
                    maxHeight: preferredMaxHeight
                };
            }
            break;
        case "top":
            // 1: the menu will fit, do nothing
            if (viewSpaceAbove >= menuHeight) return {
                placement: "top",
                maxHeight: preferredMaxHeight
            };
            // 2: the menu will fit, if scrolled
            if (scrollSpaceAbove >= menuHeight && !isFixedPosition) {
                if (shouldScroll) $a9284aba291bbde9$var$animatedScrollTo(scrollParent, scrollUp, scrollDuration);
                return {
                    placement: "top",
                    maxHeight: preferredMaxHeight
                };
            }
            // 3: the menu will fit, if constrained
            if (!isFixedPosition && scrollSpaceAbove >= minHeight || isFixedPosition && viewSpaceAbove >= minHeight) {
                var _constrainedHeight2 = preferredMaxHeight;
                // we want to provide as much of the menu as possible to the user,
                // so give them whatever is available below rather than the minHeight.
                if (!isFixedPosition && scrollSpaceAbove >= minHeight || isFixedPosition && viewSpaceAbove >= minHeight) _constrainedHeight2 = isFixedPosition ? viewSpaceAbove - marginTop : scrollSpaceAbove - marginTop;
                if (shouldScroll) $a9284aba291bbde9$var$animatedScrollTo(scrollParent, scrollUp, scrollDuration);
                return {
                    placement: "top",
                    maxHeight: _constrainedHeight2
                };
            }
            // 4. not enough space, the browser WILL NOT increase scrollable area when
            // absolutely positioned element rendered above the viewport (only below).
            // Flip the menu, render below
            return {
                placement: "bottom",
                maxHeight: preferredMaxHeight
            };
        default:
            throw new Error('Invalid placement provided "'.concat(preferredPlacement, '".'));
    }
    return defaultState;
}
// Menu Component
// ------------------------------
function $a9284aba291bbde9$var$alignToControl(placement) {
    var placementToCSSProp = {
        bottom: "top",
        top: "bottom"
    };
    return placement ? placementToCSSProp[placement] : "bottom";
}
var $a9284aba291bbde9$var$coercePlacement = function coercePlacement(p) {
    return p === "auto" ? "bottom" : p;
};
var $a9284aba291bbde9$export$953cecd6e717a553 = function menuCSS(_ref2, unstyled) {
    var _objectSpread2;
    var placement = _ref2.placement, _ref2$theme = _ref2.theme, borderRadius = _ref2$theme.borderRadius, spacing = _ref2$theme.spacing, colors = _ref2$theme.colors;
    return (0, $983350b7b3960a26$export$2e2bcd8739ae039)((_objectSpread2 = {
        label: "menu"
    }, (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)(_objectSpread2, $a9284aba291bbde9$var$alignToControl(placement), "100%"), (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)(_objectSpread2, "position", "absolute"), (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)(_objectSpread2, "width", "100%"), (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)(_objectSpread2, "zIndex", 1), _objectSpread2), unstyled ? {} : {
        backgroundColor: colors.neutral0,
        borderRadius: borderRadius,
        boxShadow: "0 0 0 1px hsla(0, 0%, 0%, 0.1), 0 4px 11px hsla(0, 0%, 0%, 0.1)",
        marginBottom: spacing.menuGutter,
        marginTop: spacing.menuGutter
    });
};
var $a9284aba291bbde9$var$PortalPlacementContext = /*#__PURE__*/ (0, $acw62.createContext)(null);
// NOTE: internal only
var $a9284aba291bbde9$export$3a1a48c8f6ef640e = function MenuPlacer(props) {
    var children = props.children, minMenuHeight = props.minMenuHeight, maxMenuHeight = props.maxMenuHeight, menuPlacement = props.menuPlacement, menuPosition = props.menuPosition, menuShouldScrollIntoView = props.menuShouldScrollIntoView, theme = props.theme;
    var _ref3 = (0, $acw62.useContext)($a9284aba291bbde9$var$PortalPlacementContext) || {}, setPortalPlacement = _ref3.setPortalPlacement;
    var ref = (0, $acw62.useRef)(null);
    var _useState = (0, $acw62.useState)(maxMenuHeight), _useState2 = (0, $adaabbc18727b3e6$export$2e2bcd8739ae039)(_useState, 2), maxHeight = _useState2[0], setMaxHeight = _useState2[1];
    var _useState3 = (0, $acw62.useState)(null), _useState4 = (0, $adaabbc18727b3e6$export$2e2bcd8739ae039)(_useState3, 2), placement = _useState4[0], setPlacement = _useState4[1];
    var controlHeight = theme.spacing.controlHeight;
    (0, $e62b4578a0a2b358$export$2e2bcd8739ae039)(function() {
        var menuEl = ref.current;
        if (!menuEl) return;
        // DO NOT scroll if position is fixed
        var isFixedPosition = menuPosition === "fixed";
        var shouldScroll = menuShouldScrollIntoView && !isFixedPosition;
        var state = $a9284aba291bbde9$var$getMenuPlacement({
            maxHeight: maxMenuHeight,
            menuEl: menuEl,
            minHeight: minMenuHeight,
            placement: menuPlacement,
            shouldScroll: shouldScroll,
            isFixedPosition: isFixedPosition,
            controlHeight: controlHeight
        });
        setMaxHeight(state.maxHeight);
        setPlacement(state.placement);
        setPortalPlacement === null || setPortalPlacement === void 0 || setPortalPlacement(state.placement);
    }, [
        maxMenuHeight,
        menuPlacement,
        menuPosition,
        menuShouldScrollIntoView,
        minMenuHeight,
        setPortalPlacement,
        controlHeight
    ]);
    return children({
        ref: ref,
        placerProps: (0, $983350b7b3960a26$export$2e2bcd8739ae039)((0, $983350b7b3960a26$export$2e2bcd8739ae039)({}, props), {}, {
            placement: placement || $a9284aba291bbde9$var$coercePlacement(menuPlacement),
            maxHeight: maxHeight
        })
    });
};
var $a9284aba291bbde9$var$Menu = function Menu(props) {
    var children = props.children, innerRef = props.innerRef, innerProps = props.innerProps;
    return (0, $63d46a01db878c10$export$c8a8987d4410bf2d)("div", (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, $a9284aba291bbde9$var$getStyleProps(props, "menu", {
        menu: true
    }), {
        ref: innerRef
    }, innerProps), children);
};
var $a9284aba291bbde9$var$Menu$1 = $a9284aba291bbde9$var$Menu;
// ==============================
// Menu List
// ==============================
var $a9284aba291bbde9$export$7ccc53e8f1e7dfc5 = function menuListCSS(_ref4, unstyled) {
    var maxHeight = _ref4.maxHeight, baseUnit = _ref4.theme.spacing.baseUnit;
    return (0, $983350b7b3960a26$export$2e2bcd8739ae039)({
        maxHeight: maxHeight,
        overflowY: "auto",
        position: "relative",
        // required for offset[Height, Top] > keyboard scroll
        WebkitOverflowScrolling: "touch"
    }, unstyled ? {} : {
        paddingBottom: baseUnit,
        paddingTop: baseUnit
    });
};
var $a9284aba291bbde9$var$MenuList = function MenuList(props) {
    var children = props.children, innerProps = props.innerProps, innerRef = props.innerRef, isMulti = props.isMulti;
    return (0, $63d46a01db878c10$export$c8a8987d4410bf2d)("div", (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, $a9284aba291bbde9$var$getStyleProps(props, "menuList", {
        "menu-list": true,
        "menu-list--is-multi": isMulti
    }), {
        ref: innerRef
    }, innerProps), children);
};
// ==============================
// Menu Notices
// ==============================
var $a9284aba291bbde9$var$noticeCSS = function noticeCSS(_ref5, unstyled) {
    var _ref5$theme = _ref5.theme, baseUnit = _ref5$theme.spacing.baseUnit, colors = _ref5$theme.colors;
    return (0, $983350b7b3960a26$export$2e2bcd8739ae039)({
        textAlign: "center"
    }, unstyled ? {} : {
        color: colors.neutral40,
        padding: "".concat(baseUnit * 2, "px ").concat(baseUnit * 3, "px")
    });
};
var $a9284aba291bbde9$export$3b14a55fb2447963 = $a9284aba291bbde9$var$noticeCSS;
var $a9284aba291bbde9$export$342063e11d6c3cad = $a9284aba291bbde9$var$noticeCSS;
var $a9284aba291bbde9$var$NoOptionsMessage = function NoOptionsMessage(_ref6) {
    var _ref6$children = _ref6.children, children = _ref6$children === void 0 ? "No options" : _ref6$children, innerProps = _ref6.innerProps, restProps = (0, $73ef9ce1c41fc0c0$export$2e2bcd8739ae039)(_ref6, $a9284aba291bbde9$var$_excluded$3);
    return (0, $63d46a01db878c10$export$c8a8987d4410bf2d)("div", (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, $a9284aba291bbde9$var$getStyleProps((0, $983350b7b3960a26$export$2e2bcd8739ae039)((0, $983350b7b3960a26$export$2e2bcd8739ae039)({}, restProps), {}, {
        children: children,
        innerProps: innerProps
    }), "noOptionsMessage", {
        "menu-notice": true,
        "menu-notice--no-options": true
    }), innerProps), children);
};
var $a9284aba291bbde9$var$LoadingMessage = function LoadingMessage(_ref7) {
    var _ref7$children = _ref7.children, children = _ref7$children === void 0 ? "Loading..." : _ref7$children, innerProps = _ref7.innerProps, restProps = (0, $73ef9ce1c41fc0c0$export$2e2bcd8739ae039)(_ref7, $a9284aba291bbde9$var$_excluded2$1);
    return (0, $63d46a01db878c10$export$c8a8987d4410bf2d)("div", (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, $a9284aba291bbde9$var$getStyleProps((0, $983350b7b3960a26$export$2e2bcd8739ae039)((0, $983350b7b3960a26$export$2e2bcd8739ae039)({}, restProps), {}, {
        children: children,
        innerProps: innerProps
    }), "loadingMessage", {
        "menu-notice": true,
        "menu-notice--loading": true
    }), innerProps), children);
};
// ==============================
// Menu Portal
// ==============================
var $a9284aba291bbde9$export$ae1af26003f05816 = function menuPortalCSS(_ref8) {
    var rect = _ref8.rect, offset = _ref8.offset, position = _ref8.position;
    return {
        left: rect.left,
        position: position,
        top: offset,
        width: rect.width,
        zIndex: 1
    };
};
var $a9284aba291bbde9$var$MenuPortal = function MenuPortal(props) {
    var appendTo = props.appendTo, children = props.children, controlElement = props.controlElement, innerProps = props.innerProps, menuPlacement = props.menuPlacement, menuPosition = props.menuPosition;
    var menuPortalRef = (0, $acw62.useRef)(null);
    var cleanupRef = (0, $acw62.useRef)(null);
    var _useState5 = (0, $acw62.useState)($a9284aba291bbde9$var$coercePlacement(menuPlacement)), _useState6 = (0, $adaabbc18727b3e6$export$2e2bcd8739ae039)(_useState5, 2), placement = _useState6[0], setPortalPlacement = _useState6[1];
    var portalPlacementContext = (0, $acw62.useMemo)(function() {
        return {
            setPortalPlacement: setPortalPlacement
        };
    }, []);
    var _useState7 = (0, $acw62.useState)(null), _useState8 = (0, $adaabbc18727b3e6$export$2e2bcd8739ae039)(_useState7, 2), computedPosition = _useState8[0], setComputedPosition = _useState8[1];
    var updateComputedPosition = (0, $acw62.useCallback)(function() {
        if (!controlElement) return;
        var rect = $a9284aba291bbde9$var$getBoundingClientObj(controlElement);
        var scrollDistance = menuPosition === "fixed" ? 0 : window.pageYOffset;
        var offset = rect[placement] + scrollDistance;
        if (offset !== (computedPosition === null || computedPosition === void 0 ? void 0 : computedPosition.offset) || rect.left !== (computedPosition === null || computedPosition === void 0 ? void 0 : computedPosition.rect.left) || rect.width !== (computedPosition === null || computedPosition === void 0 ? void 0 : computedPosition.rect.width)) setComputedPosition({
            offset: offset,
            rect: rect
        });
    }, [
        controlElement,
        menuPosition,
        placement,
        computedPosition === null || computedPosition === void 0 ? void 0 : computedPosition.offset,
        computedPosition === null || computedPosition === void 0 ? void 0 : computedPosition.rect.left,
        computedPosition === null || computedPosition === void 0 ? void 0 : computedPosition.rect.width
    ]);
    (0, $e62b4578a0a2b358$export$2e2bcd8739ae039)(function() {
        updateComputedPosition();
    }, [
        updateComputedPosition
    ]);
    var runAutoUpdate = (0, $acw62.useCallback)(function() {
        if (typeof cleanupRef.current === "function") {
            cleanupRef.current();
            cleanupRef.current = null;
        }
        if (controlElement && menuPortalRef.current) cleanupRef.current = (0, $461947879dcdbcd4$export$deee3a793edee05f)(controlElement, menuPortalRef.current, updateComputedPosition, {
            elementResize: "ResizeObserver" in window
        });
    }, [
        controlElement,
        updateComputedPosition
    ]);
    (0, $e62b4578a0a2b358$export$2e2bcd8739ae039)(function() {
        runAutoUpdate();
    }, [
        runAutoUpdate
    ]);
    var setMenuPortalElement = (0, $acw62.useCallback)(function(menuPortalElement) {
        menuPortalRef.current = menuPortalElement;
        runAutoUpdate();
    }, [
        runAutoUpdate
    ]);
    // bail early if required elements aren't present
    if (!appendTo && menuPosition !== "fixed" || !computedPosition) return null;
    // same wrapper element whether fixed or portalled
    var menuWrapper = (0, $63d46a01db878c10$export$c8a8987d4410bf2d)("div", (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({
        ref: setMenuPortalElement
    }, $a9284aba291bbde9$var$getStyleProps((0, $983350b7b3960a26$export$2e2bcd8739ae039)((0, $983350b7b3960a26$export$2e2bcd8739ae039)({}, props), {}, {
        offset: computedPosition.offset,
        position: menuPosition,
        rect: computedPosition.rect
    }), "menuPortal", {
        "menu-portal": true
    }), innerProps), children);
    return (0, $63d46a01db878c10$export$c8a8987d4410bf2d)($a9284aba291bbde9$var$PortalPlacementContext.Provider, {
        value: portalPlacementContext
    }, appendTo ? /*#__PURE__*/ (0, $1u0KT.createPortal)(menuWrapper, appendTo) : menuWrapper);
};
// ==============================
// Root Container
// ==============================
var $a9284aba291bbde9$export$8b22cf2602fb60ce = function containerCSS(_ref) {
    var isDisabled = _ref.isDisabled, isRtl = _ref.isRtl;
    return {
        label: "container",
        direction: isRtl ? "rtl" : undefined,
        pointerEvents: isDisabled ? "none" : undefined,
        // cancel mouse events when disabled
        position: "relative"
    };
};
var $a9284aba291bbde9$var$SelectContainer = function SelectContainer(props) {
    var children = props.children, innerProps = props.innerProps, isDisabled = props.isDisabled, isRtl = props.isRtl;
    return (0, $63d46a01db878c10$export$c8a8987d4410bf2d)("div", (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, $a9284aba291bbde9$var$getStyleProps(props, "container", {
        "--is-disabled": isDisabled,
        "--is-rtl": isRtl
    }), innerProps), children);
};
// ==============================
// Value Container
// ==============================
var $a9284aba291bbde9$export$4a5767248b18ef41 = function valueContainerCSS(_ref2, unstyled) {
    var spacing = _ref2.theme.spacing, isMulti = _ref2.isMulti, hasValue = _ref2.hasValue, controlShouldRenderValue = _ref2.selectProps.controlShouldRenderValue;
    return (0, $983350b7b3960a26$export$2e2bcd8739ae039)({
        alignItems: "center",
        display: isMulti && hasValue && controlShouldRenderValue ? "flex" : "grid",
        flex: 1,
        flexWrap: "wrap",
        WebkitOverflowScrolling: "touch",
        position: "relative",
        overflow: "hidden"
    }, unstyled ? {} : {
        padding: "".concat(spacing.baseUnit / 2, "px ").concat(spacing.baseUnit * 2, "px")
    });
};
var $a9284aba291bbde9$var$ValueContainer = function ValueContainer(props) {
    var children = props.children, innerProps = props.innerProps, isMulti = props.isMulti, hasValue = props.hasValue;
    return (0, $63d46a01db878c10$export$c8a8987d4410bf2d)("div", (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, $a9284aba291bbde9$var$getStyleProps(props, "valueContainer", {
        "value-container": true,
        "value-container--is-multi": isMulti,
        "value-container--has-value": hasValue
    }), innerProps), children);
};
// ==============================
// Indicator Container
// ==============================
var $a9284aba291bbde9$export$23f2a1d2818174ef = function indicatorsContainerCSS() {
    return {
        alignItems: "center",
        alignSelf: "stretch",
        display: "flex",
        flexShrink: 0
    };
};
var $a9284aba291bbde9$var$IndicatorsContainer = function IndicatorsContainer(props) {
    var children = props.children, innerProps = props.innerProps;
    return (0, $63d46a01db878c10$export$c8a8987d4410bf2d)("div", (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, $a9284aba291bbde9$var$getStyleProps(props, "indicatorsContainer", {
        indicators: true
    }), innerProps), children);
};
var $a9284aba291bbde9$var$_templateObject;
var $a9284aba291bbde9$var$_excluded$2 = [
    "size"
], $a9284aba291bbde9$var$_excluded2 = [
    "innerProps",
    "isRtl",
    "size"
];
function $a9284aba291bbde9$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
// ==============================
// Dropdown & Clear Icons
// ==============================
var $a9284aba291bbde9$var$_ref2 = {
    name: "tj5bde-Svg",
    styles: "display:inline-block;fill:currentColor;line-height:1;stroke:currentColor;stroke-width:0;label:Svg;",
    map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */",
    toString: $a9284aba291bbde9$var$_EMOTION_STRINGIFIED_CSS_ERROR__
};
var $a9284aba291bbde9$var$Svg = function Svg(_ref) {
    var size = _ref.size, props = (0, $73ef9ce1c41fc0c0$export$2e2bcd8739ae039)(_ref, $a9284aba291bbde9$var$_excluded$2);
    return (0, $63d46a01db878c10$export$c8a8987d4410bf2d)("svg", (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({
        height: size,
        width: size,
        viewBox: "0 0 20 20",
        "aria-hidden": "true",
        focusable: "false",
        css: $a9284aba291bbde9$var$_ref2
    }, props));
};
var $a9284aba291bbde9$var$CrossIcon = function CrossIcon(props) {
    return (0, $63d46a01db878c10$export$c8a8987d4410bf2d)($a9284aba291bbde9$var$Svg, (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({
        size: 20
    }, props), (0, $63d46a01db878c10$export$c8a8987d4410bf2d)("path", {
        d: "M14.348 14.849c-0.469 0.469-1.229 0.469-1.697 0l-2.651-3.030-2.651 3.029c-0.469 0.469-1.229 0.469-1.697 0-0.469-0.469-0.469-1.229 0-1.697l2.758-3.15-2.759-3.152c-0.469-0.469-0.469-1.228 0-1.697s1.228-0.469 1.697 0l2.652 3.031 2.651-3.031c0.469-0.469 1.228-0.469 1.697 0s0.469 1.229 0 1.697l-2.758 3.152 2.758 3.15c0.469 0.469 0.469 1.229 0 1.698z"
    }));
};
var $a9284aba291bbde9$var$DownChevron = function DownChevron(props) {
    return (0, $63d46a01db878c10$export$c8a8987d4410bf2d)($a9284aba291bbde9$var$Svg, (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({
        size: 20
    }, props), (0, $63d46a01db878c10$export$c8a8987d4410bf2d)("path", {
        d: "M4.516 7.548c0.436-0.446 1.043-0.481 1.576 0l3.908 3.747 3.908-3.747c0.533-0.481 1.141-0.446 1.574 0 0.436 0.445 0.408 1.197 0 1.615-0.406 0.418-4.695 4.502-4.695 4.502-0.217 0.223-0.502 0.335-0.787 0.335s-0.57-0.112-0.789-0.335c0 0-4.287-4.084-4.695-4.502s-0.436-1.17 0-1.615z"
    }));
};
// ==============================
// Dropdown & Clear Buttons
// ==============================
var $a9284aba291bbde9$var$baseCSS = function baseCSS(_ref3, unstyled) {
    var isFocused = _ref3.isFocused, _ref3$theme = _ref3.theme, baseUnit = _ref3$theme.spacing.baseUnit, colors = _ref3$theme.colors;
    return (0, $983350b7b3960a26$export$2e2bcd8739ae039)({
        label: "indicatorContainer",
        display: "flex",
        transition: "color 150ms"
    }, unstyled ? {} : {
        color: isFocused ? colors.neutral60 : colors.neutral20,
        padding: baseUnit * 2,
        ":hover": {
            color: isFocused ? colors.neutral80 : colors.neutral40
        }
    });
};
var $a9284aba291bbde9$export$f1e1789686576879 = $a9284aba291bbde9$var$baseCSS;
var $a9284aba291bbde9$var$DropdownIndicator = function DropdownIndicator(props) {
    var children = props.children, innerProps = props.innerProps;
    return (0, $63d46a01db878c10$export$c8a8987d4410bf2d)("div", (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, $a9284aba291bbde9$var$getStyleProps(props, "dropdownIndicator", {
        indicator: true,
        "dropdown-indicator": true
    }), innerProps), children || (0, $63d46a01db878c10$export$c8a8987d4410bf2d)($a9284aba291bbde9$var$DownChevron, null));
};
var $a9284aba291bbde9$export$407448d2b89b1813 = $a9284aba291bbde9$var$baseCSS;
var $a9284aba291bbde9$var$ClearIndicator = function ClearIndicator(props) {
    var children = props.children, innerProps = props.innerProps;
    return (0, $63d46a01db878c10$export$c8a8987d4410bf2d)("div", (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, $a9284aba291bbde9$var$getStyleProps(props, "clearIndicator", {
        indicator: true,
        "clear-indicator": true
    }), innerProps), children || (0, $63d46a01db878c10$export$c8a8987d4410bf2d)($a9284aba291bbde9$var$CrossIcon, null));
};
// ==============================
// Separator
// ==============================
var $a9284aba291bbde9$export$dda1d9f60106f0e9 = function indicatorSeparatorCSS(_ref4, unstyled) {
    var isDisabled = _ref4.isDisabled, _ref4$theme = _ref4.theme, baseUnit = _ref4$theme.spacing.baseUnit, colors = _ref4$theme.colors;
    return (0, $983350b7b3960a26$export$2e2bcd8739ae039)({
        label: "indicatorSeparator",
        alignSelf: "stretch",
        width: 1
    }, unstyled ? {} : {
        backgroundColor: isDisabled ? colors.neutral10 : colors.neutral20,
        marginBottom: baseUnit * 2,
        marginTop: baseUnit * 2
    });
};
var $a9284aba291bbde9$var$IndicatorSeparator = function IndicatorSeparator(props) {
    var innerProps = props.innerProps;
    return (0, $63d46a01db878c10$export$c8a8987d4410bf2d)("span", (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, innerProps, $a9284aba291bbde9$var$getStyleProps(props, "indicatorSeparator", {
        "indicator-separator": true
    })));
};
// ==============================
// Loading
// ==============================
var $a9284aba291bbde9$var$loadingDotAnimations = (0, $63d46a01db878c10$export$d25ddfdf17c3ad3e)($a9284aba291bbde9$var$_templateObject || ($a9284aba291bbde9$var$_templateObject = (0, $cbe7edbf3ccb8828$export$2e2bcd8739ae039)([
    "\n  0%, 80%, 100% { opacity: 0; }\n  40% { opacity: 1; }\n"
])));
var $a9284aba291bbde9$export$882b5998b3b9117c = function loadingIndicatorCSS(_ref5, unstyled) {
    var isFocused = _ref5.isFocused, size = _ref5.size, _ref5$theme = _ref5.theme, colors = _ref5$theme.colors, baseUnit = _ref5$theme.spacing.baseUnit;
    return (0, $983350b7b3960a26$export$2e2bcd8739ae039)({
        label: "loadingIndicator",
        display: "flex",
        transition: "color 150ms",
        alignSelf: "center",
        fontSize: size,
        lineHeight: 1,
        marginRight: size,
        textAlign: "center",
        verticalAlign: "middle"
    }, unstyled ? {} : {
        color: isFocused ? colors.neutral60 : colors.neutral20,
        padding: baseUnit * 2
    });
};
var $a9284aba291bbde9$var$LoadingDot = function LoadingDot(_ref6) {
    var delay = _ref6.delay, offset = _ref6.offset;
    return (0, $63d46a01db878c10$export$c8a8987d4410bf2d)("span", {
        css: /*#__PURE__*/ (0, $63d46a01db878c10$export$dbf350e5966cf602)({
            animation: "".concat($a9284aba291bbde9$var$loadingDotAnimations, " 1s ease-in-out ").concat(delay, "ms infinite;"),
            backgroundColor: "currentColor",
            borderRadius: "1em",
            display: "inline-block",
            marginLeft: offset ? "1em" : undefined,
            height: "1em",
            verticalAlign: "top",
            width: "1em"
        }, ";label:LoadingDot;", "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */")
    });
};
var $a9284aba291bbde9$var$LoadingIndicator = function LoadingIndicator(_ref7) {
    var innerProps = _ref7.innerProps, isRtl = _ref7.isRtl, _ref7$size = _ref7.size, size = _ref7$size === void 0 ? 4 : _ref7$size, restProps = (0, $73ef9ce1c41fc0c0$export$2e2bcd8739ae039)(_ref7, $a9284aba291bbde9$var$_excluded2);
    return (0, $63d46a01db878c10$export$c8a8987d4410bf2d)("div", (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, $a9284aba291bbde9$var$getStyleProps((0, $983350b7b3960a26$export$2e2bcd8739ae039)((0, $983350b7b3960a26$export$2e2bcd8739ae039)({}, restProps), {}, {
        innerProps: innerProps,
        isRtl: isRtl,
        size: size
    }), "loadingIndicator", {
        indicator: true,
        "loading-indicator": true
    }), innerProps), (0, $63d46a01db878c10$export$c8a8987d4410bf2d)($a9284aba291bbde9$var$LoadingDot, {
        delay: 0,
        offset: isRtl
    }), (0, $63d46a01db878c10$export$c8a8987d4410bf2d)($a9284aba291bbde9$var$LoadingDot, {
        delay: 160,
        offset: true
    }), (0, $63d46a01db878c10$export$c8a8987d4410bf2d)($a9284aba291bbde9$var$LoadingDot, {
        delay: 320,
        offset: !isRtl
    }));
};
var $a9284aba291bbde9$export$4368d992c4eafac0 = function css(_ref, unstyled) {
    var isDisabled = _ref.isDisabled, isFocused = _ref.isFocused, _ref$theme = _ref.theme, colors = _ref$theme.colors, borderRadius = _ref$theme.borderRadius, spacing = _ref$theme.spacing;
    return (0, $983350b7b3960a26$export$2e2bcd8739ae039)({
        label: "control",
        alignItems: "center",
        cursor: "default",
        display: "flex",
        flexWrap: "wrap",
        justifyContent: "space-between",
        minHeight: spacing.controlHeight,
        outline: "0 !important",
        position: "relative",
        transition: "all 100ms"
    }, unstyled ? {} : {
        backgroundColor: isDisabled ? colors.neutral5 : colors.neutral0,
        borderColor: isDisabled ? colors.neutral10 : isFocused ? colors.primary : colors.neutral20,
        borderRadius: borderRadius,
        borderStyle: "solid",
        borderWidth: 1,
        boxShadow: isFocused ? "0 0 0 1px ".concat(colors.primary) : undefined,
        "&:hover": {
            borderColor: isFocused ? colors.primary : colors.neutral30
        }
    });
};
var $a9284aba291bbde9$var$Control = function Control(props) {
    var children = props.children, isDisabled = props.isDisabled, isFocused = props.isFocused, innerRef = props.innerRef, innerProps = props.innerProps, menuIsOpen = props.menuIsOpen;
    return (0, $63d46a01db878c10$export$c8a8987d4410bf2d)("div", (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({
        ref: innerRef
    }, $a9284aba291bbde9$var$getStyleProps(props, "control", {
        control: true,
        "control--is-disabled": isDisabled,
        "control--is-focused": isFocused,
        "control--menu-is-open": menuIsOpen
    }), innerProps, {
        "aria-disabled": isDisabled || undefined
    }), children);
};
var $a9284aba291bbde9$var$Control$1 = $a9284aba291bbde9$var$Control;
var $a9284aba291bbde9$var$_excluded$1 = [
    "data"
];
var $a9284aba291bbde9$export$39b482c5e57630a8 = function groupCSS(_ref, unstyled) {
    var spacing = _ref.theme.spacing;
    return unstyled ? {} : {
        paddingBottom: spacing.baseUnit * 2,
        paddingTop: spacing.baseUnit * 2
    };
};
var $a9284aba291bbde9$var$Group = function Group(props) {
    var children = props.children, cx = props.cx, getStyles = props.getStyles, getClassNames = props.getClassNames, Heading = props.Heading, headingProps = props.headingProps, innerProps = props.innerProps, label = props.label, theme = props.theme, selectProps = props.selectProps;
    return (0, $63d46a01db878c10$export$c8a8987d4410bf2d)("div", (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, $a9284aba291bbde9$var$getStyleProps(props, "group", {
        group: true
    }), innerProps), (0, $63d46a01db878c10$export$c8a8987d4410bf2d)(Heading, (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, headingProps, {
        selectProps: selectProps,
        theme: theme,
        getStyles: getStyles,
        getClassNames: getClassNames,
        cx: cx
    }), label), (0, $63d46a01db878c10$export$c8a8987d4410bf2d)("div", null, children));
};
var $a9284aba291bbde9$export$2d1720544b23b823 = function groupHeadingCSS(_ref2, unstyled) {
    var _ref2$theme = _ref2.theme, colors = _ref2$theme.colors, spacing = _ref2$theme.spacing;
    return (0, $983350b7b3960a26$export$2e2bcd8739ae039)({
        label: "group",
        cursor: "default",
        display: "block"
    }, unstyled ? {} : {
        color: colors.neutral40,
        fontSize: "75%",
        fontWeight: 500,
        marginBottom: "0.25em",
        paddingLeft: spacing.baseUnit * 3,
        paddingRight: spacing.baseUnit * 3,
        textTransform: "uppercase"
    });
};
var $a9284aba291bbde9$var$GroupHeading = function GroupHeading(props) {
    var _cleanCommonProps = $a9284aba291bbde9$var$cleanCommonProps(props);
    _cleanCommonProps.data;
    var innerProps = (0, $73ef9ce1c41fc0c0$export$2e2bcd8739ae039)(_cleanCommonProps, $a9284aba291bbde9$var$_excluded$1);
    return (0, $63d46a01db878c10$export$c8a8987d4410bf2d)("div", (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, $a9284aba291bbde9$var$getStyleProps(props, "groupHeading", {
        "group-heading": true
    }), innerProps));
};
var $a9284aba291bbde9$var$Group$1 = $a9284aba291bbde9$var$Group;
var $a9284aba291bbde9$var$_excluded = [
    "innerRef",
    "isDisabled",
    "isHidden",
    "inputClassName"
];
var $a9284aba291bbde9$export$35e795649ee09318 = function inputCSS(_ref, unstyled) {
    var isDisabled = _ref.isDisabled, value = _ref.value, _ref$theme = _ref.theme, spacing = _ref$theme.spacing, colors = _ref$theme.colors;
    return (0, $983350b7b3960a26$export$2e2bcd8739ae039)((0, $983350b7b3960a26$export$2e2bcd8739ae039)({
        visibility: isDisabled ? "hidden" : "visible",
        // force css to recompute when value change due to @emotion bug.
        // We can remove it whenever the bug is fixed.
        transform: value ? "translateZ(0)" : ""
    }, $a9284aba291bbde9$var$containerStyle), unstyled ? {} : {
        margin: spacing.baseUnit / 2,
        paddingBottom: spacing.baseUnit / 2,
        paddingTop: spacing.baseUnit / 2,
        color: colors.neutral80
    });
};
var $a9284aba291bbde9$var$spacingStyle = {
    gridArea: "1 / 2",
    font: "inherit",
    minWidth: "2px",
    border: 0,
    margin: 0,
    outline: 0,
    padding: 0
};
var $a9284aba291bbde9$var$containerStyle = {
    flex: "1 1 auto",
    display: "inline-grid",
    gridArea: "1 / 1 / 2 / 3",
    gridTemplateColumns: "0 min-content",
    "&:after": (0, $983350b7b3960a26$export$2e2bcd8739ae039)({
        content: 'attr(data-value) " "',
        visibility: "hidden",
        whiteSpace: "pre"
    }, $a9284aba291bbde9$var$spacingStyle)
};
var $a9284aba291bbde9$var$inputStyle = function inputStyle(isHidden) {
    return (0, $983350b7b3960a26$export$2e2bcd8739ae039)({
        label: "input",
        color: "inherit",
        background: 0,
        opacity: isHidden ? 0 : 1,
        width: "100%"
    }, $a9284aba291bbde9$var$spacingStyle);
};
var $a9284aba291bbde9$var$Input = function Input(props) {
    var cx = props.cx, value = props.value;
    var _cleanCommonProps = $a9284aba291bbde9$var$cleanCommonProps(props), innerRef = _cleanCommonProps.innerRef, isDisabled = _cleanCommonProps.isDisabled, isHidden = _cleanCommonProps.isHidden, inputClassName = _cleanCommonProps.inputClassName, innerProps = (0, $73ef9ce1c41fc0c0$export$2e2bcd8739ae039)(_cleanCommonProps, $a9284aba291bbde9$var$_excluded);
    return (0, $63d46a01db878c10$export$c8a8987d4410bf2d)("div", (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, $a9284aba291bbde9$var$getStyleProps(props, "input", {
        "input-container": true
    }), {
        "data-value": value || ""
    }), (0, $63d46a01db878c10$export$c8a8987d4410bf2d)("input", (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({
        className: cx({
            input: true
        }, inputClassName),
        ref: innerRef,
        style: $a9284aba291bbde9$var$inputStyle(isHidden),
        disabled: isDisabled
    }, innerProps)));
};
var $a9284aba291bbde9$var$Input$1 = $a9284aba291bbde9$var$Input;
var $a9284aba291bbde9$export$ffb5f4729a158638 = function multiValueCSS(_ref, unstyled) {
    var _ref$theme = _ref.theme, spacing = _ref$theme.spacing, borderRadius = _ref$theme.borderRadius, colors = _ref$theme.colors;
    return (0, $983350b7b3960a26$export$2e2bcd8739ae039)({
        label: "multiValue",
        display: "flex",
        minWidth: 0
    }, unstyled ? {} : {
        backgroundColor: colors.neutral10,
        borderRadius: borderRadius / 2,
        margin: spacing.baseUnit / 2
    });
};
var $a9284aba291bbde9$export$9e5f44173e64f162 = function multiValueLabelCSS(_ref2, unstyled) {
    var _ref2$theme = _ref2.theme, borderRadius = _ref2$theme.borderRadius, colors = _ref2$theme.colors, cropWithEllipsis = _ref2.cropWithEllipsis;
    return (0, $983350b7b3960a26$export$2e2bcd8739ae039)({
        overflow: "hidden",
        textOverflow: cropWithEllipsis || cropWithEllipsis === undefined ? "ellipsis" : undefined,
        whiteSpace: "nowrap"
    }, unstyled ? {} : {
        borderRadius: borderRadius / 2,
        color: colors.neutral80,
        fontSize: "85%",
        padding: 3,
        paddingLeft: 6
    });
};
var $a9284aba291bbde9$export$625550452a3fa3ec = function multiValueRemoveCSS(_ref3, unstyled) {
    var _ref3$theme = _ref3.theme, spacing = _ref3$theme.spacing, borderRadius = _ref3$theme.borderRadius, colors = _ref3$theme.colors, isFocused = _ref3.isFocused;
    return (0, $983350b7b3960a26$export$2e2bcd8739ae039)({
        alignItems: "center",
        display: "flex"
    }, unstyled ? {} : {
        borderRadius: borderRadius / 2,
        backgroundColor: isFocused ? colors.dangerLight : undefined,
        paddingLeft: spacing.baseUnit,
        paddingRight: spacing.baseUnit,
        ":hover": {
            backgroundColor: colors.dangerLight,
            color: colors.danger
        }
    });
};
var $a9284aba291bbde9$var$MultiValueGeneric = function MultiValueGeneric(_ref4) {
    var children = _ref4.children, innerProps = _ref4.innerProps;
    return (0, $63d46a01db878c10$export$c8a8987d4410bf2d)("div", innerProps, children);
};
var $a9284aba291bbde9$var$MultiValueContainer = $a9284aba291bbde9$var$MultiValueGeneric;
var $a9284aba291bbde9$var$MultiValueLabel = $a9284aba291bbde9$var$MultiValueGeneric;
function $a9284aba291bbde9$var$MultiValueRemove(_ref5) {
    var children = _ref5.children, innerProps = _ref5.innerProps;
    return (0, $63d46a01db878c10$export$c8a8987d4410bf2d)("div", (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({
        role: "button"
    }, innerProps), children || (0, $63d46a01db878c10$export$c8a8987d4410bf2d)($a9284aba291bbde9$var$CrossIcon, {
        size: 14
    }));
}
var $a9284aba291bbde9$var$MultiValue = function MultiValue(props) {
    var children = props.children, components = props.components, data = props.data, innerProps = props.innerProps, isDisabled = props.isDisabled, removeProps = props.removeProps, selectProps = props.selectProps;
    var Container = components.Container, Label = components.Label, Remove = components.Remove;
    return (0, $63d46a01db878c10$export$c8a8987d4410bf2d)(Container, {
        data: data,
        innerProps: (0, $983350b7b3960a26$export$2e2bcd8739ae039)((0, $983350b7b3960a26$export$2e2bcd8739ae039)({}, $a9284aba291bbde9$var$getStyleProps(props, "multiValue", {
            "multi-value": true,
            "multi-value--is-disabled": isDisabled
        })), innerProps),
        selectProps: selectProps
    }, (0, $63d46a01db878c10$export$c8a8987d4410bf2d)(Label, {
        data: data,
        innerProps: (0, $983350b7b3960a26$export$2e2bcd8739ae039)({}, $a9284aba291bbde9$var$getStyleProps(props, "multiValueLabel", {
            "multi-value__label": true
        })),
        selectProps: selectProps
    }, children), (0, $63d46a01db878c10$export$c8a8987d4410bf2d)(Remove, {
        data: data,
        innerProps: (0, $983350b7b3960a26$export$2e2bcd8739ae039)((0, $983350b7b3960a26$export$2e2bcd8739ae039)({}, $a9284aba291bbde9$var$getStyleProps(props, "multiValueRemove", {
            "multi-value__remove": true
        })), {}, {
            "aria-label": "Remove ".concat(children || "option")
        }, removeProps),
        selectProps: selectProps
    }));
};
var $a9284aba291bbde9$var$MultiValue$1 = $a9284aba291bbde9$var$MultiValue;
var $a9284aba291bbde9$export$90a7f3efeed30595 = function optionCSS(_ref, unstyled) {
    var isDisabled = _ref.isDisabled, isFocused = _ref.isFocused, isSelected = _ref.isSelected, _ref$theme = _ref.theme, spacing = _ref$theme.spacing, colors = _ref$theme.colors;
    return (0, $983350b7b3960a26$export$2e2bcd8739ae039)({
        label: "option",
        cursor: "default",
        display: "block",
        fontSize: "inherit",
        width: "100%",
        userSelect: "none",
        WebkitTapHighlightColor: "rgba(0, 0, 0, 0)"
    }, unstyled ? {} : {
        backgroundColor: isSelected ? colors.primary : isFocused ? colors.primary25 : "transparent",
        color: isDisabled ? colors.neutral20 : isSelected ? colors.neutral0 : "inherit",
        padding: "".concat(spacing.baseUnit * 2, "px ").concat(spacing.baseUnit * 3, "px"),
        // provide some affordance on touch devices
        ":active": {
            backgroundColor: !isDisabled ? isSelected ? colors.primary : colors.primary50 : undefined
        }
    });
};
var $a9284aba291bbde9$var$Option = function Option(props) {
    var children = props.children, isDisabled = props.isDisabled, isFocused = props.isFocused, isSelected = props.isSelected, innerRef = props.innerRef, innerProps = props.innerProps;
    return (0, $63d46a01db878c10$export$c8a8987d4410bf2d)("div", (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, $a9284aba291bbde9$var$getStyleProps(props, "option", {
        option: true,
        "option--is-disabled": isDisabled,
        "option--is-focused": isFocused,
        "option--is-selected": isSelected
    }), {
        ref: innerRef,
        "aria-disabled": isDisabled
    }, innerProps), children);
};
var $a9284aba291bbde9$var$Option$1 = $a9284aba291bbde9$var$Option;
var $a9284aba291bbde9$export$efccba1c4a2ef57b = function placeholderCSS(_ref, unstyled) {
    var _ref$theme = _ref.theme, spacing = _ref$theme.spacing, colors = _ref$theme.colors;
    return (0, $983350b7b3960a26$export$2e2bcd8739ae039)({
        label: "placeholder",
        gridArea: "1 / 1 / 2 / 3"
    }, unstyled ? {} : {
        color: colors.neutral50,
        marginLeft: spacing.baseUnit / 2,
        marginRight: spacing.baseUnit / 2
    });
};
var $a9284aba291bbde9$var$Placeholder = function Placeholder(props) {
    var children = props.children, innerProps = props.innerProps;
    return (0, $63d46a01db878c10$export$c8a8987d4410bf2d)("div", (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, $a9284aba291bbde9$var$getStyleProps(props, "placeholder", {
        placeholder: true
    }), innerProps), children);
};
var $a9284aba291bbde9$var$Placeholder$1 = $a9284aba291bbde9$var$Placeholder;
var $a9284aba291bbde9$export$d141bba7fdc215a3 = function css(_ref, unstyled) {
    var isDisabled = _ref.isDisabled, _ref$theme = _ref.theme, spacing = _ref$theme.spacing, colors = _ref$theme.colors;
    return (0, $983350b7b3960a26$export$2e2bcd8739ae039)({
        label: "singleValue",
        gridArea: "1 / 1 / 2 / 3",
        maxWidth: "100%",
        overflow: "hidden",
        textOverflow: "ellipsis",
        whiteSpace: "nowrap"
    }, unstyled ? {} : {
        color: isDisabled ? colors.neutral40 : colors.neutral80,
        marginLeft: spacing.baseUnit / 2,
        marginRight: spacing.baseUnit / 2
    });
};
var $a9284aba291bbde9$var$SingleValue = function SingleValue(props) {
    var children = props.children, isDisabled = props.isDisabled, innerProps = props.innerProps;
    return (0, $63d46a01db878c10$export$c8a8987d4410bf2d)("div", (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, $a9284aba291bbde9$var$getStyleProps(props, "singleValue", {
        "single-value": true,
        "single-value--is-disabled": isDisabled
    }), innerProps), children);
};
var $a9284aba291bbde9$var$SingleValue$1 = $a9284aba291bbde9$var$SingleValue;
var $a9284aba291bbde9$export$db3b6bfb95261072 = {
    ClearIndicator: $a9284aba291bbde9$var$ClearIndicator,
    Control: $a9284aba291bbde9$var$Control$1,
    DropdownIndicator: $a9284aba291bbde9$var$DropdownIndicator,
    DownChevron: $a9284aba291bbde9$var$DownChevron,
    CrossIcon: $a9284aba291bbde9$var$CrossIcon,
    Group: $a9284aba291bbde9$var$Group$1,
    GroupHeading: $a9284aba291bbde9$var$GroupHeading,
    IndicatorsContainer: $a9284aba291bbde9$var$IndicatorsContainer,
    IndicatorSeparator: $a9284aba291bbde9$var$IndicatorSeparator,
    Input: $a9284aba291bbde9$var$Input$1,
    LoadingIndicator: $a9284aba291bbde9$var$LoadingIndicator,
    Menu: $a9284aba291bbde9$var$Menu$1,
    MenuList: $a9284aba291bbde9$var$MenuList,
    MenuPortal: $a9284aba291bbde9$var$MenuPortal,
    LoadingMessage: $a9284aba291bbde9$var$LoadingMessage,
    NoOptionsMessage: $a9284aba291bbde9$var$NoOptionsMessage,
    MultiValue: $a9284aba291bbde9$var$MultiValue$1,
    MultiValueContainer: $a9284aba291bbde9$var$MultiValueContainer,
    MultiValueLabel: $a9284aba291bbde9$var$MultiValueLabel,
    MultiValueRemove: $a9284aba291bbde9$var$MultiValueRemove,
    Option: $a9284aba291bbde9$var$Option$1,
    Placeholder: $a9284aba291bbde9$var$Placeholder$1,
    SelectContainer: $a9284aba291bbde9$var$SelectContainer,
    SingleValue: $a9284aba291bbde9$var$SingleValue$1,
    ValueContainer: $a9284aba291bbde9$var$ValueContainer
};
var $a9284aba291bbde9$export$d66501df72047452 = function defaultComponents(props) {
    return (0, $983350b7b3960a26$export$2e2bcd8739ae039)((0, $983350b7b3960a26$export$2e2bcd8739ae039)({}, $a9284aba291bbde9$export$db3b6bfb95261072), props.components);
};



var $e111773323c0bcc0$var$safeIsNaN = Number.isNaN || function ponyfill(value) {
    return typeof value === "number" && value !== value;
};
function $e111773323c0bcc0$var$isEqual(first, second) {
    if (first === second) return true;
    if ($e111773323c0bcc0$var$safeIsNaN(first) && $e111773323c0bcc0$var$safeIsNaN(second)) return true;
    return false;
}
function $e111773323c0bcc0$var$areInputsEqual(newInputs, lastInputs) {
    if (newInputs.length !== lastInputs.length) return false;
    for(var i = 0; i < newInputs.length; i++){
        if (!$e111773323c0bcc0$var$isEqual(newInputs[i], lastInputs[i])) return false;
    }
    return true;
}
function $e111773323c0bcc0$export$2e2bcd8739ae039(resultFn, isEqual) {
    if (isEqual === void 0) isEqual = $e111773323c0bcc0$var$areInputsEqual;
    var cache = null;
    function memoized() {
        var newArgs = [];
        for(var _i = 0; _i < arguments.length; _i++)newArgs[_i] = arguments[_i];
        if (cache && cache.lastThis === this && isEqual(newArgs, cache.lastArgs)) return cache.lastResult;
        var lastResult = resultFn.apply(this, newArgs);
        cache = {
            lastResult: lastResult,
            lastArgs: newArgs,
            lastThis: this
        };
        return lastResult;
    }
    memoized.clear = function clear() {
        cache = null;
    };
    return memoized;
}



function $02a6ea8308eefe55$var$_EMOTION_STRINGIFIED_CSS_ERROR__$2() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
// Assistive text to describe visual elements. Hidden for sighted users.
var $02a6ea8308eefe55$var$_ref = {
    name: "1f43avz-a11yText-A11yText",
    styles: "label:a11yText;z-index:9999;border:0;clip:rect(1px, 1px, 1px, 1px);height:1px;width:1px;position:absolute;overflow:hidden;padding:0;white-space:nowrap;label:A11yText;",
    map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIkExMXlUZXh0LnRzeCJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFNSSIsImZpbGUiOiJBMTF5VGV4dC50c3giLCJzb3VyY2VzQ29udGVudCI6WyIvKiogQGpzeCBqc3ggKi9cbmltcG9ydCB7IGpzeCB9IGZyb20gJ0BlbW90aW9uL3JlYWN0JztcblxuLy8gQXNzaXN0aXZlIHRleHQgdG8gZGVzY3JpYmUgdmlzdWFsIGVsZW1lbnRzLiBIaWRkZW4gZm9yIHNpZ2h0ZWQgdXNlcnMuXG5jb25zdCBBMTF5VGV4dCA9IChwcm9wczogSlNYLkludHJpbnNpY0VsZW1lbnRzWydzcGFuJ10pID0+IChcbiAgPHNwYW5cbiAgICBjc3M9e3tcbiAgICAgIGxhYmVsOiAnYTExeVRleHQnLFxuICAgICAgekluZGV4OiA5OTk5LFxuICAgICAgYm9yZGVyOiAwLFxuICAgICAgY2xpcDogJ3JlY3QoMXB4LCAxcHgsIDFweCwgMXB4KScsXG4gICAgICBoZWlnaHQ6IDEsXG4gICAgICB3aWR0aDogMSxcbiAgICAgIHBvc2l0aW9uOiAnYWJzb2x1dGUnLFxuICAgICAgb3ZlcmZsb3c6ICdoaWRkZW4nLFxuICAgICAgcGFkZGluZzogMCxcbiAgICAgIHdoaXRlU3BhY2U6ICdub3dyYXAnLFxuICAgIH19XG4gICAgey4uLnByb3BzfVxuICAvPlxuKTtcblxuZXhwb3J0IGRlZmF1bHQgQTExeVRleHQ7XG4iXX0= */",
    toString: $02a6ea8308eefe55$var$_EMOTION_STRINGIFIED_CSS_ERROR__$2
};
var $02a6ea8308eefe55$var$A11yText = function A11yText(props) {
    return (0, $63d46a01db878c10$export$c8a8987d4410bf2d)("span", (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({
        css: $02a6ea8308eefe55$var$_ref
    }, props));
};
var $02a6ea8308eefe55$var$A11yText$1 = $02a6ea8308eefe55$var$A11yText;
var $02a6ea8308eefe55$var$defaultAriaLiveMessages = {
    guidance: function guidance(props) {
        var isSearchable = props.isSearchable, isMulti = props.isMulti, tabSelectsValue = props.tabSelectsValue, context = props.context, isInitialFocus = props.isInitialFocus;
        switch(context){
            case "menu":
                return "Use Up and Down to choose options, press Enter to select the currently focused option, press Escape to exit the menu".concat(tabSelectsValue ? ", press Tab to select the option and exit the menu" : "", ".");
            case "input":
                return isInitialFocus ? "".concat(props["aria-label"] || "Select", " is focused ").concat(isSearchable ? ",type to refine list" : "", ", press Down to open the menu, ").concat(isMulti ? " press left to focus selected values" : "") : "";
            case "value":
                return "Use left and right to toggle between focused values, press Backspace to remove the currently focused value";
            default:
                return "";
        }
    },
    onChange: function onChange(props) {
        var action = props.action, _props$label = props.label, label = _props$label === void 0 ? "" : _props$label, labels = props.labels, isDisabled = props.isDisabled;
        switch(action){
            case "deselect-option":
            case "pop-value":
            case "remove-value":
                return "option ".concat(label, ", deselected.");
            case "clear":
                return "All selected options have been cleared.";
            case "initial-input-focus":
                return "option".concat(labels.length > 1 ? "s" : "", " ").concat(labels.join(","), ", selected.");
            case "select-option":
                return isDisabled ? "option ".concat(label, " is disabled. Select another option.") : "option ".concat(label, ", selected.");
            default:
                return "";
        }
    },
    onFocus: function onFocus(props) {
        var context = props.context, focused = props.focused, options = props.options, _props$label2 = props.label, label = _props$label2 === void 0 ? "" : _props$label2, selectValue = props.selectValue, isDisabled = props.isDisabled, isSelected = props.isSelected, isAppleDevice = props.isAppleDevice;
        var getArrayIndex = function getArrayIndex(arr, item) {
            return arr && arr.length ? "".concat(arr.indexOf(item) + 1, " of ").concat(arr.length) : "";
        };
        if (context === "value" && selectValue) return "value ".concat(label, " focused, ").concat(getArrayIndex(selectValue, focused), ".");
        if (context === "menu" && isAppleDevice) {
            var disabled = isDisabled ? " disabled" : "";
            var status = "".concat(isSelected ? " selected" : "").concat(disabled);
            return "".concat(label).concat(status, ", ").concat(getArrayIndex(options, focused), ".");
        }
        return "";
    },
    onFilter: function onFilter(props) {
        var inputValue = props.inputValue, resultsMessage = props.resultsMessage;
        return "".concat(resultsMessage).concat(inputValue ? " for search term " + inputValue : "", ".");
    }
};
var $02a6ea8308eefe55$var$LiveRegion = function LiveRegion(props) {
    var ariaSelection = props.ariaSelection, focusedOption = props.focusedOption, focusedValue = props.focusedValue, focusableOptions = props.focusableOptions, isFocused = props.isFocused, selectValue = props.selectValue, selectProps = props.selectProps, id = props.id, isAppleDevice = props.isAppleDevice;
    var ariaLiveMessages = selectProps.ariaLiveMessages, getOptionLabel = selectProps.getOptionLabel, inputValue = selectProps.inputValue, isMulti = selectProps.isMulti, isOptionDisabled = selectProps.isOptionDisabled, isSearchable = selectProps.isSearchable, menuIsOpen = selectProps.menuIsOpen, options = selectProps.options, screenReaderStatus = selectProps.screenReaderStatus, tabSelectsValue = selectProps.tabSelectsValue, isLoading = selectProps.isLoading;
    var ariaLabel = selectProps["aria-label"];
    var ariaLive = selectProps["aria-live"];
    // Update aria live message configuration when prop changes
    var messages = (0, $acw62.useMemo)(function() {
        return (0, $983350b7b3960a26$export$2e2bcd8739ae039)((0, $983350b7b3960a26$export$2e2bcd8739ae039)({}, $02a6ea8308eefe55$var$defaultAriaLiveMessages), ariaLiveMessages || {});
    }, [
        ariaLiveMessages
    ]);
    // Update aria live selected option when prop changes
    var ariaSelected = (0, $acw62.useMemo)(function() {
        var message = "";
        if (ariaSelection && messages.onChange) {
            var option = ariaSelection.option, selectedOptions = ariaSelection.options, removedValue = ariaSelection.removedValue, removedValues = ariaSelection.removedValues, value = ariaSelection.value;
            // select-option when !isMulti does not return option so we assume selected option is value
            var asOption = function asOption(val) {
                return !Array.isArray(val) ? val : null;
            };
            // If there is just one item from the action then get its label
            var selected = removedValue || option || asOption(value);
            var label = selected ? getOptionLabel(selected) : "";
            // If there are multiple items from the action then return an array of labels
            var multiSelected = selectedOptions || removedValues || undefined;
            var labels = multiSelected ? multiSelected.map(getOptionLabel) : [];
            var onChangeProps = (0, $983350b7b3960a26$export$2e2bcd8739ae039)({
                // multiSelected items are usually items that have already been selected
                // or set by the user as a default value so we assume they are not disabled
                isDisabled: selected && isOptionDisabled(selected, selectValue),
                label: label,
                labels: labels
            }, ariaSelection);
            message = messages.onChange(onChangeProps);
        }
        return message;
    }, [
        ariaSelection,
        messages,
        isOptionDisabled,
        selectValue,
        getOptionLabel
    ]);
    var ariaFocused = (0, $acw62.useMemo)(function() {
        var focusMsg = "";
        var focused = focusedOption || focusedValue;
        var isSelected = !!(focusedOption && selectValue && selectValue.includes(focusedOption));
        if (focused && messages.onFocus) {
            var onFocusProps = {
                focused: focused,
                label: getOptionLabel(focused),
                isDisabled: isOptionDisabled(focused, selectValue),
                isSelected: isSelected,
                options: focusableOptions,
                context: focused === focusedOption ? "menu" : "value",
                selectValue: selectValue,
                isAppleDevice: isAppleDevice
            };
            focusMsg = messages.onFocus(onFocusProps);
        }
        return focusMsg;
    }, [
        focusedOption,
        focusedValue,
        getOptionLabel,
        isOptionDisabled,
        messages,
        focusableOptions,
        selectValue,
        isAppleDevice
    ]);
    var ariaResults = (0, $acw62.useMemo)(function() {
        var resultsMsg = "";
        if (menuIsOpen && options.length && !isLoading && messages.onFilter) {
            var resultsMessage = screenReaderStatus({
                count: focusableOptions.length
            });
            resultsMsg = messages.onFilter({
                inputValue: inputValue,
                resultsMessage: resultsMessage
            });
        }
        return resultsMsg;
    }, [
        focusableOptions,
        inputValue,
        menuIsOpen,
        messages,
        options,
        screenReaderStatus,
        isLoading
    ]);
    var isInitialFocus = (ariaSelection === null || ariaSelection === void 0 ? void 0 : ariaSelection.action) === "initial-input-focus";
    var ariaGuidance = (0, $acw62.useMemo)(function() {
        var guidanceMsg = "";
        if (messages.guidance) {
            var context = focusedValue ? "value" : menuIsOpen ? "menu" : "input";
            guidanceMsg = messages.guidance({
                "aria-label": ariaLabel,
                context: context,
                isDisabled: focusedOption && isOptionDisabled(focusedOption, selectValue),
                isMulti: isMulti,
                isSearchable: isSearchable,
                tabSelectsValue: tabSelectsValue,
                isInitialFocus: isInitialFocus
            });
        }
        return guidanceMsg;
    }, [
        ariaLabel,
        focusedOption,
        focusedValue,
        isMulti,
        isOptionDisabled,
        isSearchable,
        menuIsOpen,
        messages,
        selectValue,
        tabSelectsValue,
        isInitialFocus
    ]);
    var ScreenReaderText = (0, $63d46a01db878c10$export$c8a8987d4410bf2d)((0, $acw62.Fragment), null, (0, $63d46a01db878c10$export$c8a8987d4410bf2d)("span", {
        id: "aria-selection"
    }, ariaSelected), (0, $63d46a01db878c10$export$c8a8987d4410bf2d)("span", {
        id: "aria-focused"
    }, ariaFocused), (0, $63d46a01db878c10$export$c8a8987d4410bf2d)("span", {
        id: "aria-results"
    }, ariaResults), (0, $63d46a01db878c10$export$c8a8987d4410bf2d)("span", {
        id: "aria-guidance"
    }, ariaGuidance));
    return (0, $63d46a01db878c10$export$c8a8987d4410bf2d)((0, $acw62.Fragment), null, (0, $63d46a01db878c10$export$c8a8987d4410bf2d)($02a6ea8308eefe55$var$A11yText$1, {
        id: id
    }, isInitialFocus && ScreenReaderText), (0, $63d46a01db878c10$export$c8a8987d4410bf2d)($02a6ea8308eefe55$var$A11yText$1, {
        "aria-live": ariaLive,
        "aria-atomic": "false",
        "aria-relevant": "additions text",
        role: "log"
    }, isFocused && !isInitialFocus && ScreenReaderText));
};
var $02a6ea8308eefe55$var$LiveRegion$1 = $02a6ea8308eefe55$var$LiveRegion;
var $02a6ea8308eefe55$var$diacritics = [
    {
        base: "A",
        letters: "A\u24B6\uFF21\xc0\xc1\xc2\u1EA6\u1EA4\u1EAA\u1EA8\xc3\u0100\u0102\u1EB0\u1EAE\u1EB4\u1EB2\u0226\u01E0\xc4\u01DE\u1EA2\xc5\u01FA\u01CD\u0200\u0202\u1EA0\u1EAC\u1EB6\u1E00\u0104\u023A\u2C6F"
    },
    {
        base: "AA",
        letters: "\uA732"
    },
    {
        base: "AE",
        letters: "\xc6\u01FC\u01E2"
    },
    {
        base: "AO",
        letters: "\uA734"
    },
    {
        base: "AU",
        letters: "\uA736"
    },
    {
        base: "AV",
        letters: "\uA738\uA73A"
    },
    {
        base: "AY",
        letters: "\uA73C"
    },
    {
        base: "B",
        letters: "B\u24B7\uFF22\u1E02\u1E04\u1E06\u0243\u0182\u0181"
    },
    {
        base: "C",
        letters: "C\u24B8\uFF23\u0106\u0108\u010A\u010C\xc7\u1E08\u0187\u023B\uA73E"
    },
    {
        base: "D",
        letters: "D\u24B9\uFF24\u1E0A\u010E\u1E0C\u1E10\u1E12\u1E0E\u0110\u018B\u018A\u0189\uA779"
    },
    {
        base: "DZ",
        letters: "\u01F1\u01C4"
    },
    {
        base: "Dz",
        letters: "\u01F2\u01C5"
    },
    {
        base: "E",
        letters: "E\u24BA\uFF25\xc8\xc9\xca\u1EC0\u1EBE\u1EC4\u1EC2\u1EBC\u0112\u1E14\u1E16\u0114\u0116\xcb\u1EBA\u011A\u0204\u0206\u1EB8\u1EC6\u0228\u1E1C\u0118\u1E18\u1E1A\u0190\u018E"
    },
    {
        base: "F",
        letters: "F\u24BB\uFF26\u1E1E\u0191\uA77B"
    },
    {
        base: "G",
        letters: "G\u24BC\uFF27\u01F4\u011C\u1E20\u011E\u0120\u01E6\u0122\u01E4\u0193\uA7A0\uA77D\uA77E"
    },
    {
        base: "H",
        letters: "H\u24BD\uFF28\u0124\u1E22\u1E26\u021E\u1E24\u1E28\u1E2A\u0126\u2C67\u2C75\uA78D"
    },
    {
        base: "I",
        letters: "I\u24BE\uFF29\xcc\xcd\xce\u0128\u012A\u012C\u0130\xcf\u1E2E\u1EC8\u01CF\u0208\u020A\u1ECA\u012E\u1E2C\u0197"
    },
    {
        base: "J",
        letters: "J\u24BF\uFF2A\u0134\u0248"
    },
    {
        base: "K",
        letters: "K\u24C0\uFF2B\u1E30\u01E8\u1E32\u0136\u1E34\u0198\u2C69\uA740\uA742\uA744\uA7A2"
    },
    {
        base: "L",
        letters: "L\u24C1\uFF2C\u013F\u0139\u013D\u1E36\u1E38\u013B\u1E3C\u1E3A\u0141\u023D\u2C62\u2C60\uA748\uA746\uA780"
    },
    {
        base: "LJ",
        letters: "\u01C7"
    },
    {
        base: "Lj",
        letters: "\u01C8"
    },
    {
        base: "M",
        letters: "M\u24C2\uFF2D\u1E3E\u1E40\u1E42\u2C6E\u019C"
    },
    {
        base: "N",
        letters: "N\u24C3\uFF2E\u01F8\u0143\xd1\u1E44\u0147\u1E46\u0145\u1E4A\u1E48\u0220\u019D\uA790\uA7A4"
    },
    {
        base: "NJ",
        letters: "\u01CA"
    },
    {
        base: "Nj",
        letters: "\u01CB"
    },
    {
        base: "O",
        letters: "O\u24C4\uFF2F\xd2\xd3\xd4\u1ED2\u1ED0\u1ED6\u1ED4\xd5\u1E4C\u022C\u1E4E\u014C\u1E50\u1E52\u014E\u022E\u0230\xd6\u022A\u1ECE\u0150\u01D1\u020C\u020E\u01A0\u1EDC\u1EDA\u1EE0\u1EDE\u1EE2\u1ECC\u1ED8\u01EA\u01EC\xd8\u01FE\u0186\u019F\uA74A\uA74C"
    },
    {
        base: "OI",
        letters: "\u01A2"
    },
    {
        base: "OO",
        letters: "\uA74E"
    },
    {
        base: "OU",
        letters: "\u0222"
    },
    {
        base: "P",
        letters: "P\u24C5\uFF30\u1E54\u1E56\u01A4\u2C63\uA750\uA752\uA754"
    },
    {
        base: "Q",
        letters: "Q\u24C6\uFF31\uA756\uA758\u024A"
    },
    {
        base: "R",
        letters: "R\u24C7\uFF32\u0154\u1E58\u0158\u0210\u0212\u1E5A\u1E5C\u0156\u1E5E\u024C\u2C64\uA75A\uA7A6\uA782"
    },
    {
        base: "S",
        letters: "S\u24C8\uFF33\u1E9E\u015A\u1E64\u015C\u1E60\u0160\u1E66\u1E62\u1E68\u0218\u015E\u2C7E\uA7A8\uA784"
    },
    {
        base: "T",
        letters: "T\u24C9\uFF34\u1E6A\u0164\u1E6C\u021A\u0162\u1E70\u1E6E\u0166\u01AC\u01AE\u023E\uA786"
    },
    {
        base: "TZ",
        letters: "\uA728"
    },
    {
        base: "U",
        letters: "U\u24CA\uFF35\xd9\xda\xdb\u0168\u1E78\u016A\u1E7A\u016C\xdc\u01DB\u01D7\u01D5\u01D9\u1EE6\u016E\u0170\u01D3\u0214\u0216\u01AF\u1EEA\u1EE8\u1EEE\u1EEC\u1EF0\u1EE4\u1E72\u0172\u1E76\u1E74\u0244"
    },
    {
        base: "V",
        letters: "V\u24CB\uFF36\u1E7C\u1E7E\u01B2\uA75E\u0245"
    },
    {
        base: "VY",
        letters: "\uA760"
    },
    {
        base: "W",
        letters: "W\u24CC\uFF37\u1E80\u1E82\u0174\u1E86\u1E84\u1E88\u2C72"
    },
    {
        base: "X",
        letters: "X\u24CD\uFF38\u1E8A\u1E8C"
    },
    {
        base: "Y",
        letters: "Y\u24CE\uFF39\u1EF2\xdd\u0176\u1EF8\u0232\u1E8E\u0178\u1EF6\u1EF4\u01B3\u024E\u1EFE"
    },
    {
        base: "Z",
        letters: "Z\u24CF\uFF3A\u0179\u1E90\u017B\u017D\u1E92\u1E94\u01B5\u0224\u2C7F\u2C6B\uA762"
    },
    {
        base: "a",
        letters: "a\u24D0\uFF41\u1E9A\xe0\xe1\xe2\u1EA7\u1EA5\u1EAB\u1EA9\xe3\u0101\u0103\u1EB1\u1EAF\u1EB5\u1EB3\u0227\u01E1\xe4\u01DF\u1EA3\xe5\u01FB\u01CE\u0201\u0203\u1EA1\u1EAD\u1EB7\u1E01\u0105\u2C65\u0250"
    },
    {
        base: "aa",
        letters: "\uA733"
    },
    {
        base: "ae",
        letters: "\xe6\u01FD\u01E3"
    },
    {
        base: "ao",
        letters: "\uA735"
    },
    {
        base: "au",
        letters: "\uA737"
    },
    {
        base: "av",
        letters: "\uA739\uA73B"
    },
    {
        base: "ay",
        letters: "\uA73D"
    },
    {
        base: "b",
        letters: "b\u24D1\uFF42\u1E03\u1E05\u1E07\u0180\u0183\u0253"
    },
    {
        base: "c",
        letters: "c\u24D2\uFF43\u0107\u0109\u010B\u010D\xe7\u1E09\u0188\u023C\uA73F\u2184"
    },
    {
        base: "d",
        letters: "d\u24D3\uFF44\u1E0B\u010F\u1E0D\u1E11\u1E13\u1E0F\u0111\u018C\u0256\u0257\uA77A"
    },
    {
        base: "dz",
        letters: "\u01F3\u01C6"
    },
    {
        base: "e",
        letters: "e\u24D4\uFF45\xe8\xe9\xea\u1EC1\u1EBF\u1EC5\u1EC3\u1EBD\u0113\u1E15\u1E17\u0115\u0117\xeb\u1EBB\u011B\u0205\u0207\u1EB9\u1EC7\u0229\u1E1D\u0119\u1E19\u1E1B\u0247\u025B\u01DD"
    },
    {
        base: "f",
        letters: "f\u24D5\uFF46\u1E1F\u0192\uA77C"
    },
    {
        base: "g",
        letters: "g\u24D6\uFF47\u01F5\u011D\u1E21\u011F\u0121\u01E7\u0123\u01E5\u0260\uA7A1\u1D79\uA77F"
    },
    {
        base: "h",
        letters: "h\u24D7\uFF48\u0125\u1E23\u1E27\u021F\u1E25\u1E29\u1E2B\u1E96\u0127\u2C68\u2C76\u0265"
    },
    {
        base: "hv",
        letters: "\u0195"
    },
    {
        base: "i",
        letters: "i\u24D8\uFF49\xec\xed\xee\u0129\u012B\u012D\xef\u1E2F\u1EC9\u01D0\u0209\u020B\u1ECB\u012F\u1E2D\u0268\u0131"
    },
    {
        base: "j",
        letters: "j\u24D9\uFF4A\u0135\u01F0\u0249"
    },
    {
        base: "k",
        letters: "k\u24DA\uFF4B\u1E31\u01E9\u1E33\u0137\u1E35\u0199\u2C6A\uA741\uA743\uA745\uA7A3"
    },
    {
        base: "l",
        letters: "l\u24DB\uFF4C\u0140\u013A\u013E\u1E37\u1E39\u013C\u1E3D\u1E3B\u017F\u0142\u019A\u026B\u2C61\uA749\uA781\uA747"
    },
    {
        base: "lj",
        letters: "\u01C9"
    },
    {
        base: "m",
        letters: "m\u24DC\uFF4D\u1E3F\u1E41\u1E43\u0271\u026F"
    },
    {
        base: "n",
        letters: "n\u24DD\uFF4E\u01F9\u0144\xf1\u1E45\u0148\u1E47\u0146\u1E4B\u1E49\u019E\u0272\u0149\uA791\uA7A5"
    },
    {
        base: "nj",
        letters: "\u01CC"
    },
    {
        base: "o",
        letters: "o\u24DE\uFF4F\xf2\xf3\xf4\u1ED3\u1ED1\u1ED7\u1ED5\xf5\u1E4D\u022D\u1E4F\u014D\u1E51\u1E53\u014F\u022F\u0231\xf6\u022B\u1ECF\u0151\u01D2\u020D\u020F\u01A1\u1EDD\u1EDB\u1EE1\u1EDF\u1EE3\u1ECD\u1ED9\u01EB\u01ED\xf8\u01FF\u0254\uA74B\uA74D\u0275"
    },
    {
        base: "oi",
        letters: "\u01A3"
    },
    {
        base: "ou",
        letters: "\u0223"
    },
    {
        base: "oo",
        letters: "\uA74F"
    },
    {
        base: "p",
        letters: "p\u24DF\uFF50\u1E55\u1E57\u01A5\u1D7D\uA751\uA753\uA755"
    },
    {
        base: "q",
        letters: "q\u24E0\uFF51\u024B\uA757\uA759"
    },
    {
        base: "r",
        letters: "r\u24E1\uFF52\u0155\u1E59\u0159\u0211\u0213\u1E5B\u1E5D\u0157\u1E5F\u024D\u027D\uA75B\uA7A7\uA783"
    },
    {
        base: "s",
        letters: "s\u24E2\uFF53\xdf\u015B\u1E65\u015D\u1E61\u0161\u1E67\u1E63\u1E69\u0219\u015F\u023F\uA7A9\uA785\u1E9B"
    },
    {
        base: "t",
        letters: "t\u24E3\uFF54\u1E6B\u1E97\u0165\u1E6D\u021B\u0163\u1E71\u1E6F\u0167\u01AD\u0288\u2C66\uA787"
    },
    {
        base: "tz",
        letters: "\uA729"
    },
    {
        base: "u",
        letters: "u\u24E4\uFF55\xf9\xfa\xfb\u0169\u1E79\u016B\u1E7B\u016D\xfc\u01DC\u01D8\u01D6\u01DA\u1EE7\u016F\u0171\u01D4\u0215\u0217\u01B0\u1EEB\u1EE9\u1EEF\u1EED\u1EF1\u1EE5\u1E73\u0173\u1E77\u1E75\u0289"
    },
    {
        base: "v",
        letters: "v\u24E5\uFF56\u1E7D\u1E7F\u028B\uA75F\u028C"
    },
    {
        base: "vy",
        letters: "\uA761"
    },
    {
        base: "w",
        letters: "w\u24E6\uFF57\u1E81\u1E83\u0175\u1E87\u1E85\u1E98\u1E89\u2C73"
    },
    {
        base: "x",
        letters: "x\u24E7\uFF58\u1E8B\u1E8D"
    },
    {
        base: "y",
        letters: "y\u24E8\uFF59\u1EF3\xfd\u0177\u1EF9\u0233\u1E8F\xff\u1EF7\u1E99\u1EF5\u01B4\u024F\u1EFF"
    },
    {
        base: "z",
        letters: "z\u24E9\uFF5A\u017A\u1E91\u017C\u017E\u1E93\u1E95\u01B6\u0225\u0240\u2C6C\uA763"
    }
];
var $02a6ea8308eefe55$var$anyDiacritic = new RegExp("[" + $02a6ea8308eefe55$var$diacritics.map(function(d) {
    return d.letters;
}).join("") + "]", "g");
var $02a6ea8308eefe55$var$diacriticToBase = {};
for(var $02a6ea8308eefe55$var$i = 0; $02a6ea8308eefe55$var$i < $02a6ea8308eefe55$var$diacritics.length; $02a6ea8308eefe55$var$i++){
    var $02a6ea8308eefe55$var$diacritic = $02a6ea8308eefe55$var$diacritics[$02a6ea8308eefe55$var$i];
    for(var $02a6ea8308eefe55$var$j = 0; $02a6ea8308eefe55$var$j < $02a6ea8308eefe55$var$diacritic.letters.length; $02a6ea8308eefe55$var$j++)$02a6ea8308eefe55$var$diacriticToBase[$02a6ea8308eefe55$var$diacritic.letters[$02a6ea8308eefe55$var$j]] = $02a6ea8308eefe55$var$diacritic.base;
}
var $02a6ea8308eefe55$var$stripDiacritics = function stripDiacritics(str) {
    return str.replace($02a6ea8308eefe55$var$anyDiacritic, function(match) {
        return $02a6ea8308eefe55$var$diacriticToBase[match];
    });
};
var $02a6ea8308eefe55$var$memoizedStripDiacriticsForInput = (0, $e111773323c0bcc0$export$2e2bcd8739ae039)($02a6ea8308eefe55$var$stripDiacritics);
var $02a6ea8308eefe55$var$trimString = function trimString(str) {
    return str.replace(/^\s+|\s+$/g, "");
};
var $02a6ea8308eefe55$var$defaultStringify = function defaultStringify(option) {
    return "".concat(option.label, " ").concat(option.value);
};
var $02a6ea8308eefe55$export$db3b6bfb95261072 = function createFilter(config) {
    return function(option, rawInput) {
        // eslint-disable-next-line no-underscore-dangle
        if (option.data.__isNew__) return true;
        var _ignoreCase$ignoreAcc = (0, $983350b7b3960a26$export$2e2bcd8739ae039)({
            ignoreCase: true,
            ignoreAccents: true,
            stringify: $02a6ea8308eefe55$var$defaultStringify,
            trim: true,
            matchFrom: "any"
        }, config), ignoreCase = _ignoreCase$ignoreAcc.ignoreCase, ignoreAccents = _ignoreCase$ignoreAcc.ignoreAccents, stringify = _ignoreCase$ignoreAcc.stringify, trim = _ignoreCase$ignoreAcc.trim, matchFrom = _ignoreCase$ignoreAcc.matchFrom;
        var input = trim ? $02a6ea8308eefe55$var$trimString(rawInput) : rawInput;
        var candidate = trim ? $02a6ea8308eefe55$var$trimString(stringify(option)) : stringify(option);
        if (ignoreCase) {
            input = input.toLowerCase();
            candidate = candidate.toLowerCase();
        }
        if (ignoreAccents) {
            input = $02a6ea8308eefe55$var$memoizedStripDiacriticsForInput(input);
            candidate = $02a6ea8308eefe55$var$stripDiacritics(candidate);
        }
        return matchFrom === "start" ? candidate.substr(0, input.length) === input : candidate.indexOf(input) > -1;
    };
};
var $02a6ea8308eefe55$var$_excluded = [
    "innerRef"
];
function $02a6ea8308eefe55$var$DummyInput(_ref) {
    var innerRef = _ref.innerRef, props = (0, $73ef9ce1c41fc0c0$export$2e2bcd8739ae039)(_ref, $02a6ea8308eefe55$var$_excluded);
    // Remove animation props not meant for HTML elements
    var filteredProps = (0, $a9284aba291bbde9$export$43caf9889c228507)(props, "onExited", "in", "enter", "exit", "appear");
    return (0, $63d46a01db878c10$export$c8a8987d4410bf2d)("input", (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({
        ref: innerRef
    }, filteredProps, {
        css: /*#__PURE__*/ (0, $63d46a01db878c10$export$dbf350e5966cf602)({
            label: "dummyInput",
            // get rid of any default styles
            background: 0,
            border: 0,
            // important! this hides the flashing cursor
            caretColor: "transparent",
            fontSize: "inherit",
            gridArea: "1 / 1 / 2 / 3",
            outline: 0,
            padding: 0,
            // important! without `width` browsers won't allow focus
            width: 1,
            // remove cursor on desktop
            color: "transparent",
            // remove cursor on mobile whilst maintaining "scroll into view" behaviour
            left: -100,
            opacity: 0,
            position: "relative",
            transform: "scale(.01)"
        }, ";label:DummyInput;", "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIkR1bW15SW5wdXQudHN4Il0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQXlCTSIsImZpbGUiOiJEdW1teUlucHV0LnRzeCIsInNvdXJjZXNDb250ZW50IjpbIi8qKiBAanN4IGpzeCAqL1xuaW1wb3J0IHsgUmVmIH0gZnJvbSAncmVhY3QnO1xuaW1wb3J0IHsganN4IH0gZnJvbSAnQGVtb3Rpb24vcmVhY3QnO1xuaW1wb3J0IHsgcmVtb3ZlUHJvcHMgfSBmcm9tICcuLi91dGlscyc7XG5cbmV4cG9ydCBkZWZhdWx0IGZ1bmN0aW9uIER1bW15SW5wdXQoe1xuICBpbm5lclJlZixcbiAgLi4ucHJvcHNcbn06IEpTWC5JbnRyaW5zaWNFbGVtZW50c1snaW5wdXQnXSAmIHtcbiAgcmVhZG9ubHkgaW5uZXJSZWY6IFJlZjxIVE1MSW5wdXRFbGVtZW50Pjtcbn0pIHtcbiAgLy8gUmVtb3ZlIGFuaW1hdGlvbiBwcm9wcyBub3QgbWVhbnQgZm9yIEhUTUwgZWxlbWVudHNcbiAgY29uc3QgZmlsdGVyZWRQcm9wcyA9IHJlbW92ZVByb3BzKFxuICAgIHByb3BzLFxuICAgICdvbkV4aXRlZCcsXG4gICAgJ2luJyxcbiAgICAnZW50ZXInLFxuICAgICdleGl0JyxcbiAgICAnYXBwZWFyJ1xuICApO1xuXG4gIHJldHVybiAoXG4gICAgPGlucHV0XG4gICAgICByZWY9e2lubmVyUmVmfVxuICAgICAgey4uLmZpbHRlcmVkUHJvcHN9XG4gICAgICBjc3M9e3tcbiAgICAgICAgbGFiZWw6ICdkdW1teUlucHV0JyxcbiAgICAgICAgLy8gZ2V0IHJpZCBvZiBhbnkgZGVmYXVsdCBzdHlsZXNcbiAgICAgICAgYmFja2dyb3VuZDogMCxcbiAgICAgICAgYm9yZGVyOiAwLFxuICAgICAgICAvLyBpbXBvcnRhbnQhIHRoaXMgaGlkZXMgdGhlIGZsYXNoaW5nIGN1cnNvclxuICAgICAgICBjYXJldENvbG9yOiAndHJhbnNwYXJlbnQnLFxuICAgICAgICBmb250U2l6ZTogJ2luaGVyaXQnLFxuICAgICAgICBncmlkQXJlYTogJzEgLyAxIC8gMiAvIDMnLFxuICAgICAgICBvdXRsaW5lOiAwLFxuICAgICAgICBwYWRkaW5nOiAwLFxuICAgICAgICAvLyBpbXBvcnRhbnQhIHdpdGhvdXQgYHdpZHRoYCBicm93c2VycyB3b24ndCBhbGxvdyBmb2N1c1xuICAgICAgICB3aWR0aDogMSxcblxuICAgICAgICAvLyByZW1vdmUgY3Vyc29yIG9uIGRlc2t0b3BcbiAgICAgICAgY29sb3I6ICd0cmFuc3BhcmVudCcsXG5cbiAgICAgICAgLy8gcmVtb3ZlIGN1cnNvciBvbiBtb2JpbGUgd2hpbHN0IG1haW50YWluaW5nIFwic2Nyb2xsIGludG8gdmlld1wiIGJlaGF2aW91clxuICAgICAgICBsZWZ0OiAtMTAwLFxuICAgICAgICBvcGFjaXR5OiAwLFxuICAgICAgICBwb3NpdGlvbjogJ3JlbGF0aXZlJyxcbiAgICAgICAgdHJhbnNmb3JtOiAnc2NhbGUoLjAxKScsXG4gICAgICB9fVxuICAgIC8+XG4gICk7XG59XG4iXX0= */")
    }));
}
var $02a6ea8308eefe55$var$cancelScroll = function cancelScroll(event) {
    if (event.cancelable) event.preventDefault();
    event.stopPropagation();
};
function $02a6ea8308eefe55$var$useScrollCapture(_ref) {
    var isEnabled = _ref.isEnabled, onBottomArrive = _ref.onBottomArrive, onBottomLeave = _ref.onBottomLeave, onTopArrive = _ref.onTopArrive, onTopLeave = _ref.onTopLeave;
    var isBottom = (0, $acw62.useRef)(false);
    var isTop = (0, $acw62.useRef)(false);
    var touchStart = (0, $acw62.useRef)(0);
    var scrollTarget = (0, $acw62.useRef)(null);
    var handleEventDelta = (0, $acw62.useCallback)(function(event, delta) {
        if (scrollTarget.current === null) return;
        var _scrollTarget$current = scrollTarget.current, scrollTop = _scrollTarget$current.scrollTop, scrollHeight = _scrollTarget$current.scrollHeight, clientHeight = _scrollTarget$current.clientHeight;
        var target = scrollTarget.current;
        var isDeltaPositive = delta > 0;
        var availableScroll = scrollHeight - clientHeight - scrollTop;
        var shouldCancelScroll = false;
        // reset bottom/top flags
        if (availableScroll > delta && isBottom.current) {
            if (onBottomLeave) onBottomLeave(event);
            isBottom.current = false;
        }
        if (isDeltaPositive && isTop.current) {
            if (onTopLeave) onTopLeave(event);
            isTop.current = false;
        }
        // bottom limit
        if (isDeltaPositive && delta > availableScroll) {
            if (onBottomArrive && !isBottom.current) onBottomArrive(event);
            target.scrollTop = scrollHeight;
            shouldCancelScroll = true;
            isBottom.current = true;
        // top limit
        } else if (!isDeltaPositive && -delta > scrollTop) {
            if (onTopArrive && !isTop.current) onTopArrive(event);
            target.scrollTop = 0;
            shouldCancelScroll = true;
            isTop.current = true;
        }
        // cancel scroll
        if (shouldCancelScroll) $02a6ea8308eefe55$var$cancelScroll(event);
    }, [
        onBottomArrive,
        onBottomLeave,
        onTopArrive,
        onTopLeave
    ]);
    var onWheel = (0, $acw62.useCallback)(function(event) {
        handleEventDelta(event, event.deltaY);
    }, [
        handleEventDelta
    ]);
    var onTouchStart = (0, $acw62.useCallback)(function(event) {
        // set touch start so we can calculate touchmove delta
        touchStart.current = event.changedTouches[0].clientY;
    }, []);
    var onTouchMove = (0, $acw62.useCallback)(function(event) {
        var deltaY = touchStart.current - event.changedTouches[0].clientY;
        handleEventDelta(event, deltaY);
    }, [
        handleEventDelta
    ]);
    var startListening = (0, $acw62.useCallback)(function(el) {
        // bail early if no element is available to attach to
        if (!el) return;
        var notPassive = (0, $a9284aba291bbde9$export$2408f22a0fab9ae5) ? {
            passive: false
        } : false;
        el.addEventListener("wheel", onWheel, notPassive);
        el.addEventListener("touchstart", onTouchStart, notPassive);
        el.addEventListener("touchmove", onTouchMove, notPassive);
    }, [
        onTouchMove,
        onTouchStart,
        onWheel
    ]);
    var stopListening = (0, $acw62.useCallback)(function(el) {
        // bail early if no element is available to detach from
        if (!el) return;
        el.removeEventListener("wheel", onWheel, false);
        el.removeEventListener("touchstart", onTouchStart, false);
        el.removeEventListener("touchmove", onTouchMove, false);
    }, [
        onTouchMove,
        onTouchStart,
        onWheel
    ]);
    (0, $acw62.useEffect)(function() {
        if (!isEnabled) return;
        var element = scrollTarget.current;
        startListening(element);
        return function() {
            stopListening(element);
        };
    }, [
        isEnabled,
        startListening,
        stopListening
    ]);
    return function(element) {
        scrollTarget.current = element;
    };
}
var $02a6ea8308eefe55$var$STYLE_KEYS = [
    "boxSizing",
    "height",
    "overflow",
    "paddingRight",
    "position"
];
var $02a6ea8308eefe55$var$LOCK_STYLES = {
    boxSizing: "border-box",
    // account for possible declaration `width: 100%;` on body
    overflow: "hidden",
    position: "relative",
    height: "100%"
};
function $02a6ea8308eefe55$var$preventTouchMove(e) {
    e.preventDefault();
}
function $02a6ea8308eefe55$var$allowTouchMove(e) {
    e.stopPropagation();
}
function $02a6ea8308eefe55$var$preventInertiaScroll() {
    var top = this.scrollTop;
    var totalScroll = this.scrollHeight;
    var currentScroll = top + this.offsetHeight;
    if (top === 0) this.scrollTop = 1;
    else if (currentScroll === totalScroll) this.scrollTop = top - 1;
}
// `ontouchstart` check works on most browsers
// `maxTouchPoints` works on IE10/11 and Surface
function $02a6ea8308eefe55$var$isTouchDevice() {
    return "ontouchstart" in window || navigator.maxTouchPoints;
}
var $02a6ea8308eefe55$var$canUseDOM = !!(typeof window !== "undefined" && window.document && window.document.createElement);
var $02a6ea8308eefe55$var$activeScrollLocks = 0;
var $02a6ea8308eefe55$var$listenerOptions = {
    capture: false,
    passive: false
};
function $02a6ea8308eefe55$var$useScrollLock(_ref) {
    var isEnabled = _ref.isEnabled, _ref$accountForScroll = _ref.accountForScrollbars, accountForScrollbars = _ref$accountForScroll === void 0 ? true : _ref$accountForScroll;
    var originalStyles = (0, $acw62.useRef)({});
    var scrollTarget = (0, $acw62.useRef)(null);
    var addScrollLock = (0, $acw62.useCallback)(function(touchScrollTarget) {
        if (!$02a6ea8308eefe55$var$canUseDOM) return;
        var target = document.body;
        var targetStyle = target && target.style;
        if (accountForScrollbars) // store any styles already applied to the body
        $02a6ea8308eefe55$var$STYLE_KEYS.forEach(function(key) {
            var val = targetStyle && targetStyle[key];
            originalStyles.current[key] = val;
        });
        // apply the lock styles and padding if this is the first scroll lock
        if (accountForScrollbars && $02a6ea8308eefe55$var$activeScrollLocks < 1) {
            var currentPadding = parseInt(originalStyles.current.paddingRight, 10) || 0;
            var clientWidth = document.body ? document.body.clientWidth : 0;
            var adjustedPadding = window.innerWidth - clientWidth + currentPadding || 0;
            Object.keys($02a6ea8308eefe55$var$LOCK_STYLES).forEach(function(key) {
                var val = $02a6ea8308eefe55$var$LOCK_STYLES[key];
                if (targetStyle) targetStyle[key] = val;
            });
            if (targetStyle) targetStyle.paddingRight = "".concat(adjustedPadding, "px");
        }
        // account for touch devices
        if (target && $02a6ea8308eefe55$var$isTouchDevice()) {
            // Mobile Safari ignores { overflow: hidden } declaration on the body.
            target.addEventListener("touchmove", $02a6ea8308eefe55$var$preventTouchMove, $02a6ea8308eefe55$var$listenerOptions);
            // Allow scroll on provided target
            if (touchScrollTarget) {
                touchScrollTarget.addEventListener("touchstart", $02a6ea8308eefe55$var$preventInertiaScroll, $02a6ea8308eefe55$var$listenerOptions);
                touchScrollTarget.addEventListener("touchmove", $02a6ea8308eefe55$var$allowTouchMove, $02a6ea8308eefe55$var$listenerOptions);
            }
        }
        // increment active scroll locks
        $02a6ea8308eefe55$var$activeScrollLocks += 1;
    }, [
        accountForScrollbars
    ]);
    var removeScrollLock = (0, $acw62.useCallback)(function(touchScrollTarget) {
        if (!$02a6ea8308eefe55$var$canUseDOM) return;
        var target = document.body;
        var targetStyle = target && target.style;
        // safely decrement active scroll locks
        $02a6ea8308eefe55$var$activeScrollLocks = Math.max($02a6ea8308eefe55$var$activeScrollLocks - 1, 0);
        // reapply original body styles, if any
        if (accountForScrollbars && $02a6ea8308eefe55$var$activeScrollLocks < 1) $02a6ea8308eefe55$var$STYLE_KEYS.forEach(function(key) {
            var val = originalStyles.current[key];
            if (targetStyle) targetStyle[key] = val;
        });
        // remove touch listeners
        if (target && $02a6ea8308eefe55$var$isTouchDevice()) {
            target.removeEventListener("touchmove", $02a6ea8308eefe55$var$preventTouchMove, $02a6ea8308eefe55$var$listenerOptions);
            if (touchScrollTarget) {
                touchScrollTarget.removeEventListener("touchstart", $02a6ea8308eefe55$var$preventInertiaScroll, $02a6ea8308eefe55$var$listenerOptions);
                touchScrollTarget.removeEventListener("touchmove", $02a6ea8308eefe55$var$allowTouchMove, $02a6ea8308eefe55$var$listenerOptions);
            }
        }
    }, [
        accountForScrollbars
    ]);
    (0, $acw62.useEffect)(function() {
        if (!isEnabled) return;
        var element = scrollTarget.current;
        addScrollLock(element);
        return function() {
            removeScrollLock(element);
        };
    }, [
        isEnabled,
        addScrollLock,
        removeScrollLock
    ]);
    return function(element) {
        scrollTarget.current = element;
    };
}
function $02a6ea8308eefe55$var$_EMOTION_STRINGIFIED_CSS_ERROR__$1() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
var $02a6ea8308eefe55$var$blurSelectInput = function blurSelectInput(event) {
    var element = event.target;
    return element.ownerDocument.activeElement && element.ownerDocument.activeElement.blur();
};
var $02a6ea8308eefe55$var$_ref2$1 = {
    name: "bp8cua-ScrollManager",
    styles: "position:fixed;left:0;bottom:0;right:0;top:0;label:ScrollManager;",
    map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */",
    toString: $02a6ea8308eefe55$var$_EMOTION_STRINGIFIED_CSS_ERROR__$1
};
function $02a6ea8308eefe55$var$ScrollManager(_ref) {
    var children = _ref.children, lockEnabled = _ref.lockEnabled, _ref$captureEnabled = _ref.captureEnabled, captureEnabled = _ref$captureEnabled === void 0 ? true : _ref$captureEnabled, onBottomArrive = _ref.onBottomArrive, onBottomLeave = _ref.onBottomLeave, onTopArrive = _ref.onTopArrive, onTopLeave = _ref.onTopLeave;
    var setScrollCaptureTarget = $02a6ea8308eefe55$var$useScrollCapture({
        isEnabled: captureEnabled,
        onBottomArrive: onBottomArrive,
        onBottomLeave: onBottomLeave,
        onTopArrive: onTopArrive,
        onTopLeave: onTopLeave
    });
    var setScrollLockTarget = $02a6ea8308eefe55$var$useScrollLock({
        isEnabled: lockEnabled
    });
    var targetRef = function targetRef(element) {
        setScrollCaptureTarget(element);
        setScrollLockTarget(element);
    };
    return (0, $63d46a01db878c10$export$c8a8987d4410bf2d)((0, $acw62.Fragment), null, lockEnabled && (0, $63d46a01db878c10$export$c8a8987d4410bf2d)("div", {
        onClick: $02a6ea8308eefe55$var$blurSelectInput,
        css: $02a6ea8308eefe55$var$_ref2$1
    }), children(targetRef));
}
function $02a6ea8308eefe55$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
var $02a6ea8308eefe55$var$_ref2 = {
    name: "5kkxb2-requiredInput-RequiredInput",
    styles: "label:requiredInput;opacity:0;pointer-events:none;position:absolute;bottom:0;left:0;right:0;width:100%;label:RequiredInput;",
    map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIlJlcXVpcmVkSW5wdXQudHN4Il0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQWNJIiwiZmlsZSI6IlJlcXVpcmVkSW5wdXQudHN4Iiwic291cmNlc0NvbnRlbnQiOlsiLyoqIEBqc3gganN4ICovXG5pbXBvcnQgeyBGb2N1c0V2ZW50SGFuZGxlciwgRnVuY3Rpb25Db21wb25lbnQgfSBmcm9tICdyZWFjdCc7XG5pbXBvcnQgeyBqc3ggfSBmcm9tICdAZW1vdGlvbi9yZWFjdCc7XG5cbmNvbnN0IFJlcXVpcmVkSW5wdXQ6IEZ1bmN0aW9uQ29tcG9uZW50PHtcbiAgcmVhZG9ubHkgbmFtZT86IHN0cmluZztcbiAgcmVhZG9ubHkgb25Gb2N1czogRm9jdXNFdmVudEhhbmRsZXI8SFRNTElucHV0RWxlbWVudD47XG59PiA9ICh7IG5hbWUsIG9uRm9jdXMgfSkgPT4gKFxuICA8aW5wdXRcbiAgICByZXF1aXJlZFxuICAgIG5hbWU9e25hbWV9XG4gICAgdGFiSW5kZXg9ey0xfVxuICAgIGFyaWEtaGlkZGVuPVwidHJ1ZVwiXG4gICAgb25Gb2N1cz17b25Gb2N1c31cbiAgICBjc3M9e3tcbiAgICAgIGxhYmVsOiAncmVxdWlyZWRJbnB1dCcsXG4gICAgICBvcGFjaXR5OiAwLFxuICAgICAgcG9pbnRlckV2ZW50czogJ25vbmUnLFxuICAgICAgcG9zaXRpb246ICdhYnNvbHV0ZScsXG4gICAgICBib3R0b206IDAsXG4gICAgICBsZWZ0OiAwLFxuICAgICAgcmlnaHQ6IDAsXG4gICAgICB3aWR0aDogJzEwMCUnLFxuICAgIH19XG4gICAgLy8gUHJldmVudCBgU3dpdGNoaW5nIGZyb20gdW5jb250cm9sbGVkIHRvIGNvbnRyb2xsZWRgIGVycm9yXG4gICAgdmFsdWU9XCJcIlxuICAgIG9uQ2hhbmdlPXsoKSA9PiB7fX1cbiAgLz5cbik7XG5cbmV4cG9ydCBkZWZhdWx0IFJlcXVpcmVkSW5wdXQ7XG4iXX0= */",
    toString: $02a6ea8308eefe55$var$_EMOTION_STRINGIFIED_CSS_ERROR__
};
var $02a6ea8308eefe55$var$RequiredInput = function RequiredInput(_ref) {
    var name = _ref.name, onFocus = _ref.onFocus;
    return (0, $63d46a01db878c10$export$c8a8987d4410bf2d)("input", {
        required: true,
        name: name,
        tabIndex: -1,
        "aria-hidden": "true",
        onFocus: onFocus,
        css: $02a6ea8308eefe55$var$_ref2,
        value: "",
        onChange: function onChange() {}
    });
};
var $02a6ea8308eefe55$var$RequiredInput$1 = $02a6ea8308eefe55$var$RequiredInput;
/// <reference types="user-agent-data-types" />
function $02a6ea8308eefe55$var$testPlatform(re) {
    var _window$navigator$use;
    return typeof window !== "undefined" && window.navigator != null ? re.test(((_window$navigator$use = window.navigator["userAgentData"]) === null || _window$navigator$use === void 0 ? void 0 : _window$navigator$use.platform) || window.navigator.platform) : false;
}
function $02a6ea8308eefe55$var$isIPhone() {
    return $02a6ea8308eefe55$var$testPlatform(/^iPhone/i);
}
function $02a6ea8308eefe55$var$isMac() {
    return $02a6ea8308eefe55$var$testPlatform(/^Mac/i);
}
function $02a6ea8308eefe55$var$isIPad() {
    return $02a6ea8308eefe55$var$testPlatform(/^iPad/i) || // iPadOS 13 lies and says it's a Mac, but we can distinguish by detecting touch support.
    $02a6ea8308eefe55$var$isMac() && navigator.maxTouchPoints > 1;
}
function $02a6ea8308eefe55$var$isIOS() {
    return $02a6ea8308eefe55$var$isIPhone() || $02a6ea8308eefe55$var$isIPad();
}
function $02a6ea8308eefe55$var$isAppleDevice() {
    return $02a6ea8308eefe55$var$isMac() || $02a6ea8308eefe55$var$isIOS();
}
var $02a6ea8308eefe55$var$formatGroupLabel = function formatGroupLabel(group) {
    return group.label;
};
var $02a6ea8308eefe55$export$8b22cf2602fb60ce = function getOptionLabel(option) {
    return option.label;
};
var $02a6ea8308eefe55$export$39b482c5e57630a8 = function getOptionValue(option) {
    return option.value;
};
var $02a6ea8308eefe55$var$isOptionDisabled = function isOptionDisabled(option) {
    return !!option.isDisabled;
};
var $02a6ea8308eefe55$var$defaultStyles = {
    clearIndicator: (0, $a9284aba291bbde9$export$407448d2b89b1813),
    container: (0, $a9284aba291bbde9$export$8b22cf2602fb60ce),
    control: (0, $a9284aba291bbde9$export$4368d992c4eafac0),
    dropdownIndicator: (0, $a9284aba291bbde9$export$f1e1789686576879),
    group: (0, $a9284aba291bbde9$export$39b482c5e57630a8),
    groupHeading: (0, $a9284aba291bbde9$export$2d1720544b23b823),
    indicatorsContainer: (0, $a9284aba291bbde9$export$23f2a1d2818174ef),
    indicatorSeparator: (0, $a9284aba291bbde9$export$dda1d9f60106f0e9),
    input: (0, $a9284aba291bbde9$export$35e795649ee09318),
    loadingIndicator: (0, $a9284aba291bbde9$export$882b5998b3b9117c),
    loadingMessage: (0, $a9284aba291bbde9$export$342063e11d6c3cad),
    menu: (0, $a9284aba291bbde9$export$953cecd6e717a553),
    menuList: (0, $a9284aba291bbde9$export$7ccc53e8f1e7dfc5),
    menuPortal: (0, $a9284aba291bbde9$export$ae1af26003f05816),
    multiValue: (0, $a9284aba291bbde9$export$ffb5f4729a158638),
    multiValueLabel: (0, $a9284aba291bbde9$export$9e5f44173e64f162),
    multiValueRemove: (0, $a9284aba291bbde9$export$625550452a3fa3ec),
    noOptionsMessage: (0, $a9284aba291bbde9$export$3b14a55fb2447963),
    option: (0, $a9284aba291bbde9$export$90a7f3efeed30595),
    placeholder: (0, $a9284aba291bbde9$export$efccba1c4a2ef57b),
    singleValue: (0, $a9284aba291bbde9$export$d141bba7fdc215a3),
    valueContainer: (0, $a9284aba291bbde9$export$4a5767248b18ef41)
};
// Merge Utility
// Allows consumers to extend a base Select with additional styles
function $02a6ea8308eefe55$export$953cecd6e717a553(source) {
    var target = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    // initialize with source styles
    var styles = (0, $983350b7b3960a26$export$2e2bcd8739ae039)({}, source);
    // massage in target styles
    Object.keys(target).forEach(function(keyAsString) {
        var key = keyAsString;
        if (source[key]) styles[key] = function(rsCss, props) {
            return target[key](source[key](rsCss, props), props);
        };
        else styles[key] = target[key];
    });
    return styles;
}
var $02a6ea8308eefe55$var$colors = {
    primary: "#2684FF",
    primary75: "#4C9AFF",
    primary50: "#B2D4FF",
    primary25: "#DEEBFF",
    danger: "#DE350B",
    dangerLight: "#FFBDAD",
    neutral0: "hsl(0, 0%, 100%)",
    neutral5: "hsl(0, 0%, 95%)",
    neutral10: "hsl(0, 0%, 90%)",
    neutral20: "hsl(0, 0%, 80%)",
    neutral30: "hsl(0, 0%, 70%)",
    neutral40: "hsl(0, 0%, 60%)",
    neutral50: "hsl(0, 0%, 50%)",
    neutral60: "hsl(0, 0%, 40%)",
    neutral70: "hsl(0, 0%, 30%)",
    neutral80: "hsl(0, 0%, 20%)",
    neutral90: "hsl(0, 0%, 10%)"
};
var $02a6ea8308eefe55$var$borderRadius = 4;
// Used to calculate consistent margin/padding on elements
var $02a6ea8308eefe55$var$baseUnit = 4;
// The minimum height of the control
var $02a6ea8308eefe55$var$controlHeight = 38;
// The amount of space between the control and menu */
var $02a6ea8308eefe55$var$menuGutter = $02a6ea8308eefe55$var$baseUnit * 2;
var $02a6ea8308eefe55$var$spacing = {
    baseUnit: $02a6ea8308eefe55$var$baseUnit,
    controlHeight: $02a6ea8308eefe55$var$controlHeight,
    menuGutter: $02a6ea8308eefe55$var$menuGutter
};
var $02a6ea8308eefe55$export$4368d992c4eafac0 = {
    borderRadius: $02a6ea8308eefe55$var$borderRadius,
    colors: $02a6ea8308eefe55$var$colors,
    spacing: $02a6ea8308eefe55$var$spacing
};
var $02a6ea8308eefe55$export$407448d2b89b1813 = {
    "aria-live": "polite",
    backspaceRemovesValue: true,
    blurInputOnSelect: (0, $a9284aba291bbde9$export$df995fae86a55f06)(),
    captureMenuScroll: !(0, $a9284aba291bbde9$export$df995fae86a55f06)(),
    classNames: {},
    closeMenuOnSelect: true,
    closeMenuOnScroll: false,
    components: {},
    controlShouldRenderValue: true,
    escapeClearsValue: false,
    filterOption: $02a6ea8308eefe55$export$db3b6bfb95261072(),
    formatGroupLabel: $02a6ea8308eefe55$var$formatGroupLabel,
    getOptionLabel: $02a6ea8308eefe55$export$8b22cf2602fb60ce,
    getOptionValue: $02a6ea8308eefe55$export$39b482c5e57630a8,
    isDisabled: false,
    isLoading: false,
    isMulti: false,
    isRtl: false,
    isSearchable: true,
    isOptionDisabled: $02a6ea8308eefe55$var$isOptionDisabled,
    loadingMessage: function loadingMessage() {
        return "Loading...";
    },
    maxMenuHeight: 300,
    minMenuHeight: 140,
    menuIsOpen: false,
    menuPlacement: "bottom",
    menuPosition: "absolute",
    menuShouldBlockScroll: false,
    menuShouldScrollIntoView: !(0, $a9284aba291bbde9$export$ebd11618f299a286)(),
    noOptionsMessage: function noOptionsMessage() {
        return "No options";
    },
    openMenuOnFocus: false,
    openMenuOnClick: true,
    options: [],
    pageSize: 5,
    placeholder: "Select...",
    screenReaderStatus: function screenReaderStatus(_ref) {
        var count = _ref.count;
        return "".concat(count, " result").concat(count !== 1 ? "s" : "", " available");
    },
    styles: {},
    tabIndex: 0,
    tabSelectsValue: true,
    unstyled: false
};
function $02a6ea8308eefe55$var$toCategorizedOption(props, option, selectValue, index) {
    var isDisabled = $02a6ea8308eefe55$var$_isOptionDisabled(props, option, selectValue);
    var isSelected = $02a6ea8308eefe55$var$_isOptionSelected(props, option, selectValue);
    var label = $02a6ea8308eefe55$var$getOptionLabel(props, option);
    var value = $02a6ea8308eefe55$var$getOptionValue(props, option);
    return {
        type: "option",
        data: option,
        isDisabled: isDisabled,
        isSelected: isSelected,
        label: label,
        value: value,
        index: index
    };
}
function $02a6ea8308eefe55$var$buildCategorizedOptions(props, selectValue) {
    return props.options.map(function(groupOrOption, groupOrOptionIndex) {
        if ("options" in groupOrOption) {
            var categorizedOptions = groupOrOption.options.map(function(option, optionIndex) {
                return $02a6ea8308eefe55$var$toCategorizedOption(props, option, selectValue, optionIndex);
            }).filter(function(categorizedOption) {
                return $02a6ea8308eefe55$var$isFocusable(props, categorizedOption);
            });
            return categorizedOptions.length > 0 ? {
                type: "group",
                data: groupOrOption,
                options: categorizedOptions,
                index: groupOrOptionIndex
            } : undefined;
        }
        var categorizedOption = $02a6ea8308eefe55$var$toCategorizedOption(props, groupOrOption, selectValue, groupOrOptionIndex);
        return $02a6ea8308eefe55$var$isFocusable(props, categorizedOption) ? categorizedOption : undefined;
    }).filter((0, $a9284aba291bbde9$export$3466f893ebf79586));
}
function $02a6ea8308eefe55$var$buildFocusableOptionsFromCategorizedOptions(categorizedOptions) {
    return categorizedOptions.reduce(function(optionsAccumulator, categorizedOption) {
        if (categorizedOption.type === "group") optionsAccumulator.push.apply(optionsAccumulator, (0, $eb1ed927433e7e98$export$2e2bcd8739ae039)(categorizedOption.options.map(function(option) {
            return option.data;
        })));
        else optionsAccumulator.push(categorizedOption.data);
        return optionsAccumulator;
    }, []);
}
function $02a6ea8308eefe55$var$buildFocusableOptionsWithIds(categorizedOptions, optionId) {
    return categorizedOptions.reduce(function(optionsAccumulator, categorizedOption) {
        if (categorizedOption.type === "group") optionsAccumulator.push.apply(optionsAccumulator, (0, $eb1ed927433e7e98$export$2e2bcd8739ae039)(categorizedOption.options.map(function(option) {
            return {
                data: option.data,
                id: "".concat(optionId, "-").concat(categorizedOption.index, "-").concat(option.index)
            };
        })));
        else optionsAccumulator.push({
            data: categorizedOption.data,
            id: "".concat(optionId, "-").concat(categorizedOption.index)
        });
        return optionsAccumulator;
    }, []);
}
function $02a6ea8308eefe55$var$buildFocusableOptions(props, selectValue) {
    return $02a6ea8308eefe55$var$buildFocusableOptionsFromCategorizedOptions($02a6ea8308eefe55$var$buildCategorizedOptions(props, selectValue));
}
function $02a6ea8308eefe55$var$isFocusable(props, categorizedOption) {
    var _props$inputValue = props.inputValue, inputValue = _props$inputValue === void 0 ? "" : _props$inputValue;
    var data = categorizedOption.data, isSelected = categorizedOption.isSelected, label = categorizedOption.label, value = categorizedOption.value;
    return (!$02a6ea8308eefe55$var$shouldHideSelectedOptions(props) || !isSelected) && $02a6ea8308eefe55$var$_filterOption(props, {
        label: label,
        value: value,
        data: data
    }, inputValue);
}
function $02a6ea8308eefe55$var$getNextFocusedValue(state, nextSelectValue) {
    var focusedValue = state.focusedValue, lastSelectValue = state.selectValue;
    var lastFocusedIndex = lastSelectValue.indexOf(focusedValue);
    if (lastFocusedIndex > -1) {
        var nextFocusedIndex = nextSelectValue.indexOf(focusedValue);
        if (nextFocusedIndex > -1) // the focused value is still in the selectValue, return it
        return focusedValue;
        else if (lastFocusedIndex < nextSelectValue.length) // the focusedValue is not present in the next selectValue array by
        // reference, so return the new value at the same index
        return nextSelectValue[lastFocusedIndex];
    }
    return null;
}
function $02a6ea8308eefe55$var$getNextFocusedOption(state, options) {
    var lastFocusedOption = state.focusedOption;
    return lastFocusedOption && options.indexOf(lastFocusedOption) > -1 ? lastFocusedOption : options[0];
}
var $02a6ea8308eefe55$var$getFocusedOptionId = function getFocusedOptionId(focusableOptionsWithIds, focusedOption) {
    var _focusableOptionsWith;
    var focusedOptionId = (_focusableOptionsWith = focusableOptionsWithIds.find(function(option) {
        return option.data === focusedOption;
    })) === null || _focusableOptionsWith === void 0 ? void 0 : _focusableOptionsWith.id;
    return focusedOptionId || null;
};
var $02a6ea8308eefe55$var$getOptionLabel = function getOptionLabel(props, data) {
    return props.getOptionLabel(data);
};
var $02a6ea8308eefe55$var$getOptionValue = function getOptionValue(props, data) {
    return props.getOptionValue(data);
};
function $02a6ea8308eefe55$var$_isOptionDisabled(props, option, selectValue) {
    return typeof props.isOptionDisabled === "function" ? props.isOptionDisabled(option, selectValue) : false;
}
function $02a6ea8308eefe55$var$_isOptionSelected(props, option, selectValue) {
    if (selectValue.indexOf(option) > -1) return true;
    if (typeof props.isOptionSelected === "function") return props.isOptionSelected(option, selectValue);
    var candidate = $02a6ea8308eefe55$var$getOptionValue(props, option);
    return selectValue.some(function(i) {
        return $02a6ea8308eefe55$var$getOptionValue(props, i) === candidate;
    });
}
function $02a6ea8308eefe55$var$_filterOption(props, option, inputValue) {
    return props.filterOption ? props.filterOption(option, inputValue) : true;
}
var $02a6ea8308eefe55$var$shouldHideSelectedOptions = function shouldHideSelectedOptions(props) {
    var hideSelectedOptions = props.hideSelectedOptions, isMulti = props.isMulti;
    if (hideSelectedOptions === undefined) return isMulti;
    return hideSelectedOptions;
};
var $02a6ea8308eefe55$var$instanceId = 1;
var $02a6ea8308eefe55$export$25ce5a424b770e84 = /*#__PURE__*/ function(_Component) {
    (0, $0ed648f7bbaf3aff$export$2e2bcd8739ae039)(Select, _Component);
    var _super = (0, $a76f20fb39fa9d46$export$2e2bcd8739ae039)(Select);
    // Misc. Instance Properties
    // ------------------------------
    // TODO
    // Refs
    // ------------------------------
    // Lifecycle
    // ------------------------------
    function Select(_props) {
        var _this;
        (0, $4d35ca0862055760$export$2e2bcd8739ae039)(this, Select);
        _this = _super.call(this, _props);
        _this.state = {
            ariaSelection: null,
            focusedOption: null,
            focusedOptionId: null,
            focusableOptionsWithIds: [],
            focusedValue: null,
            inputIsHidden: false,
            isFocused: false,
            selectValue: [],
            clearFocusValueOnUpdate: false,
            prevWasFocused: false,
            inputIsHiddenAfterUpdate: undefined,
            prevProps: undefined,
            instancePrefix: ""
        };
        _this.blockOptionHover = false;
        _this.isComposing = false;
        _this.commonProps = void 0;
        _this.initialTouchX = 0;
        _this.initialTouchY = 0;
        _this.openAfterFocus = false;
        _this.scrollToFocusedOptionOnUpdate = false;
        _this.userIsDragging = void 0;
        _this.isAppleDevice = $02a6ea8308eefe55$var$isAppleDevice();
        _this.controlRef = null;
        _this.getControlRef = function(ref) {
            _this.controlRef = ref;
        };
        _this.focusedOptionRef = null;
        _this.getFocusedOptionRef = function(ref) {
            _this.focusedOptionRef = ref;
        };
        _this.menuListRef = null;
        _this.getMenuListRef = function(ref) {
            _this.menuListRef = ref;
        };
        _this.inputRef = null;
        _this.getInputRef = function(ref) {
            _this.inputRef = ref;
        };
        _this.focus = _this.focusInput;
        _this.blur = _this.blurInput;
        _this.onChange = function(newValue, actionMeta) {
            var _this$props = _this.props, onChange = _this$props.onChange, name = _this$props.name;
            actionMeta.name = name;
            _this.ariaOnChange(newValue, actionMeta);
            onChange(newValue, actionMeta);
        };
        _this.setValue = function(newValue, action, option) {
            var _this$props2 = _this.props, closeMenuOnSelect = _this$props2.closeMenuOnSelect, isMulti = _this$props2.isMulti, inputValue = _this$props2.inputValue;
            _this.onInputChange("", {
                action: "set-value",
                prevInputValue: inputValue
            });
            if (closeMenuOnSelect) {
                _this.setState({
                    inputIsHiddenAfterUpdate: !isMulti
                });
                _this.onMenuClose();
            }
            // when the select value should change, we should reset focusedValue
            _this.setState({
                clearFocusValueOnUpdate: true
            });
            _this.onChange(newValue, {
                action: action,
                option: option
            });
        };
        _this.selectOption = function(newValue) {
            var _this$props3 = _this.props, blurInputOnSelect = _this$props3.blurInputOnSelect, isMulti = _this$props3.isMulti, name = _this$props3.name;
            var selectValue = _this.state.selectValue;
            var deselected = isMulti && _this.isOptionSelected(newValue, selectValue);
            var isDisabled = _this.isOptionDisabled(newValue, selectValue);
            if (deselected) {
                var candidate = _this.getOptionValue(newValue);
                _this.setValue((0, $a9284aba291bbde9$export$ef35774e6d314e91)(selectValue.filter(function(i) {
                    return _this.getOptionValue(i) !== candidate;
                })), "deselect-option", newValue);
            } else if (!isDisabled) {
                // Select option if option is not disabled
                if (isMulti) _this.setValue((0, $a9284aba291bbde9$export$ef35774e6d314e91)([].concat((0, $eb1ed927433e7e98$export$2e2bcd8739ae039)(selectValue), [
                    newValue
                ])), "select-option", newValue);
                else _this.setValue((0, $a9284aba291bbde9$export$e7094788287c5e9b)(newValue), "select-option");
            } else {
                _this.ariaOnChange((0, $a9284aba291bbde9$export$e7094788287c5e9b)(newValue), {
                    action: "select-option",
                    option: newValue,
                    name: name
                });
                return;
            }
            if (blurInputOnSelect) _this.blurInput();
        };
        _this.removeValue = function(removedValue) {
            var isMulti = _this.props.isMulti;
            var selectValue = _this.state.selectValue;
            var candidate = _this.getOptionValue(removedValue);
            var newValueArray = selectValue.filter(function(i) {
                return _this.getOptionValue(i) !== candidate;
            });
            var newValue = (0, $a9284aba291bbde9$export$96f57966bedc81b4)(isMulti, newValueArray, newValueArray[0] || null);
            _this.onChange(newValue, {
                action: "remove-value",
                removedValue: removedValue
            });
            _this.focusInput();
        };
        _this.clearValue = function() {
            var selectValue = _this.state.selectValue;
            _this.onChange((0, $a9284aba291bbde9$export$96f57966bedc81b4)(_this.props.isMulti, [], null), {
                action: "clear",
                removedValues: selectValue
            });
        };
        _this.popValue = function() {
            var isMulti = _this.props.isMulti;
            var selectValue = _this.state.selectValue;
            var lastSelectedValue = selectValue[selectValue.length - 1];
            var newValueArray = selectValue.slice(0, selectValue.length - 1);
            var newValue = (0, $a9284aba291bbde9$export$96f57966bedc81b4)(isMulti, newValueArray, newValueArray[0] || null);
            _this.onChange(newValue, {
                action: "pop-value",
                removedValue: lastSelectedValue
            });
        };
        _this.getFocusedOptionId = function(focusedOption) {
            return $02a6ea8308eefe55$var$getFocusedOptionId(_this.state.focusableOptionsWithIds, focusedOption);
        };
        _this.getFocusableOptionsWithIds = function() {
            return $02a6ea8308eefe55$var$buildFocusableOptionsWithIds($02a6ea8308eefe55$var$buildCategorizedOptions(_this.props, _this.state.selectValue), _this.getElementId("option"));
        };
        _this.getValue = function() {
            return _this.state.selectValue;
        };
        _this.cx = function() {
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
            return (0, $a9284aba291bbde9$export$a9c23c6ac3fc3eca).apply(void 0, [
                _this.props.classNamePrefix
            ].concat(args));
        };
        _this.getOptionLabel = function(data) {
            return $02a6ea8308eefe55$var$getOptionLabel(_this.props, data);
        };
        _this.getOptionValue = function(data) {
            return $02a6ea8308eefe55$var$getOptionValue(_this.props, data);
        };
        _this.getStyles = function(key, props) {
            var unstyled = _this.props.unstyled;
            var base = $02a6ea8308eefe55$var$defaultStyles[key](props, unstyled);
            base.boxSizing = "border-box";
            var custom = _this.props.styles[key];
            return custom ? custom(base, props) : base;
        };
        _this.getClassNames = function(key, props) {
            var _this$props$className, _this$props$className2;
            return (_this$props$className = (_this$props$className2 = _this.props.classNames)[key]) === null || _this$props$className === void 0 ? void 0 : _this$props$className.call(_this$props$className2, props);
        };
        _this.getElementId = function(element) {
            return "".concat(_this.state.instancePrefix, "-").concat(element);
        };
        _this.getComponents = function() {
            return (0, $a9284aba291bbde9$export$d66501df72047452)(_this.props);
        };
        _this.buildCategorizedOptions = function() {
            return $02a6ea8308eefe55$var$buildCategorizedOptions(_this.props, _this.state.selectValue);
        };
        _this.getCategorizedOptions = function() {
            return _this.props.menuIsOpen ? _this.buildCategorizedOptions() : [];
        };
        _this.buildFocusableOptions = function() {
            return $02a6ea8308eefe55$var$buildFocusableOptionsFromCategorizedOptions(_this.buildCategorizedOptions());
        };
        _this.getFocusableOptions = function() {
            return _this.props.menuIsOpen ? _this.buildFocusableOptions() : [];
        };
        _this.ariaOnChange = function(value, actionMeta) {
            _this.setState({
                ariaSelection: (0, $983350b7b3960a26$export$2e2bcd8739ae039)({
                    value: value
                }, actionMeta)
            });
        };
        _this.onMenuMouseDown = function(event) {
            if (event.button !== 0) return;
            event.stopPropagation();
            event.preventDefault();
            _this.focusInput();
        };
        _this.onMenuMouseMove = function(event) {
            _this.blockOptionHover = false;
        };
        _this.onControlMouseDown = function(event) {
            // Event captured by dropdown indicator
            if (event.defaultPrevented) return;
            var openMenuOnClick = _this.props.openMenuOnClick;
            if (!_this.state.isFocused) {
                if (openMenuOnClick) _this.openAfterFocus = true;
                _this.focusInput();
            } else if (!_this.props.menuIsOpen) {
                if (openMenuOnClick) _this.openMenu("first");
            } else if (event.target.tagName !== "INPUT" && event.target.tagName !== "TEXTAREA") _this.onMenuClose();
            if (event.target.tagName !== "INPUT" && event.target.tagName !== "TEXTAREA") event.preventDefault();
        };
        _this.onDropdownIndicatorMouseDown = function(event) {
            // ignore mouse events that weren't triggered by the primary button
            if (event && event.type === "mousedown" && event.button !== 0) return;
            if (_this.props.isDisabled) return;
            var _this$props4 = _this.props, isMulti = _this$props4.isMulti, menuIsOpen = _this$props4.menuIsOpen;
            _this.focusInput();
            if (menuIsOpen) {
                _this.setState({
                    inputIsHiddenAfterUpdate: !isMulti
                });
                _this.onMenuClose();
            } else _this.openMenu("first");
            event.preventDefault();
        };
        _this.onClearIndicatorMouseDown = function(event) {
            // ignore mouse events that weren't triggered by the primary button
            if (event && event.type === "mousedown" && event.button !== 0) return;
            _this.clearValue();
            event.preventDefault();
            _this.openAfterFocus = false;
            if (event.type === "touchend") _this.focusInput();
            else setTimeout(function() {
                return _this.focusInput();
            });
        };
        _this.onScroll = function(event) {
            if (typeof _this.props.closeMenuOnScroll === "boolean") {
                if (event.target instanceof HTMLElement && (0, $a9284aba291bbde9$export$2329c99376c9d0a4)(event.target)) _this.props.onMenuClose();
            } else if (typeof _this.props.closeMenuOnScroll === "function") {
                if (_this.props.closeMenuOnScroll(event)) _this.props.onMenuClose();
            }
        };
        _this.onCompositionStart = function() {
            _this.isComposing = true;
        };
        _this.onCompositionEnd = function() {
            _this.isComposing = false;
        };
        _this.onTouchStart = function(_ref2) {
            var touches = _ref2.touches;
            var touch = touches && touches.item(0);
            if (!touch) return;
            _this.initialTouchX = touch.clientX;
            _this.initialTouchY = touch.clientY;
            _this.userIsDragging = false;
        };
        _this.onTouchMove = function(_ref3) {
            var touches = _ref3.touches;
            var touch = touches && touches.item(0);
            if (!touch) return;
            var deltaX = Math.abs(touch.clientX - _this.initialTouchX);
            var deltaY = Math.abs(touch.clientY - _this.initialTouchY);
            var moveThreshold = 5;
            _this.userIsDragging = deltaX > moveThreshold || deltaY > moveThreshold;
        };
        _this.onTouchEnd = function(event) {
            if (_this.userIsDragging) return;
            // close the menu if the user taps outside
            // we're checking on event.target here instead of event.currentTarget, because we want to assert information
            // on events on child elements, not the document (which we've attached this handler to).
            if (_this.controlRef && !_this.controlRef.contains(event.target) && _this.menuListRef && !_this.menuListRef.contains(event.target)) _this.blurInput();
            // reset move vars
            _this.initialTouchX = 0;
            _this.initialTouchY = 0;
        };
        _this.onControlTouchEnd = function(event) {
            if (_this.userIsDragging) return;
            _this.onControlMouseDown(event);
        };
        _this.onClearIndicatorTouchEnd = function(event) {
            if (_this.userIsDragging) return;
            _this.onClearIndicatorMouseDown(event);
        };
        _this.onDropdownIndicatorTouchEnd = function(event) {
            if (_this.userIsDragging) return;
            _this.onDropdownIndicatorMouseDown(event);
        };
        _this.handleInputChange = function(event) {
            var prevInputValue = _this.props.inputValue;
            var inputValue = event.currentTarget.value;
            _this.setState({
                inputIsHiddenAfterUpdate: false
            });
            _this.onInputChange(inputValue, {
                action: "input-change",
                prevInputValue: prevInputValue
            });
            if (!_this.props.menuIsOpen) _this.onMenuOpen();
        };
        _this.onInputFocus = function(event) {
            if (_this.props.onFocus) _this.props.onFocus(event);
            _this.setState({
                inputIsHiddenAfterUpdate: false,
                isFocused: true
            });
            if (_this.openAfterFocus || _this.props.openMenuOnFocus) _this.openMenu("first");
            _this.openAfterFocus = false;
        };
        _this.onInputBlur = function(event) {
            var prevInputValue = _this.props.inputValue;
            if (_this.menuListRef && _this.menuListRef.contains(document.activeElement)) {
                _this.inputRef.focus();
                return;
            }
            if (_this.props.onBlur) _this.props.onBlur(event);
            _this.onInputChange("", {
                action: "input-blur",
                prevInputValue: prevInputValue
            });
            _this.onMenuClose();
            _this.setState({
                focusedValue: null,
                isFocused: false
            });
        };
        _this.onOptionHover = function(focusedOption) {
            if (_this.blockOptionHover || _this.state.focusedOption === focusedOption) return;
            var options = _this.getFocusableOptions();
            var focusedOptionIndex = options.indexOf(focusedOption);
            _this.setState({
                focusedOption: focusedOption,
                focusedOptionId: focusedOptionIndex > -1 ? _this.getFocusedOptionId(focusedOption) : null
            });
        };
        _this.shouldHideSelectedOptions = function() {
            return $02a6ea8308eefe55$var$shouldHideSelectedOptions(_this.props);
        };
        _this.onValueInputFocus = function(e) {
            e.preventDefault();
            e.stopPropagation();
            _this.focus();
        };
        _this.onKeyDown = function(event) {
            var _this$props5 = _this.props, isMulti = _this$props5.isMulti, backspaceRemovesValue = _this$props5.backspaceRemovesValue, escapeClearsValue = _this$props5.escapeClearsValue, inputValue = _this$props5.inputValue, isClearable = _this$props5.isClearable, isDisabled = _this$props5.isDisabled, menuIsOpen = _this$props5.menuIsOpen, onKeyDown = _this$props5.onKeyDown, tabSelectsValue = _this$props5.tabSelectsValue, openMenuOnFocus = _this$props5.openMenuOnFocus;
            var _this$state = _this.state, focusedOption = _this$state.focusedOption, focusedValue = _this$state.focusedValue, selectValue = _this$state.selectValue;
            if (isDisabled) return;
            if (typeof onKeyDown === "function") {
                onKeyDown(event);
                if (event.defaultPrevented) return;
            }
            // Block option hover events when the user has just pressed a key
            _this.blockOptionHover = true;
            switch(event.key){
                case "ArrowLeft":
                    if (!isMulti || inputValue) return;
                    _this.focusValue("previous");
                    break;
                case "ArrowRight":
                    if (!isMulti || inputValue) return;
                    _this.focusValue("next");
                    break;
                case "Delete":
                case "Backspace":
                    if (inputValue) return;
                    if (focusedValue) _this.removeValue(focusedValue);
                    else {
                        if (!backspaceRemovesValue) return;
                        if (isMulti) _this.popValue();
                        else if (isClearable) _this.clearValue();
                    }
                    break;
                case "Tab":
                    if (_this.isComposing) return;
                    if (event.shiftKey || !menuIsOpen || !tabSelectsValue || !focusedOption || // don't capture the event if the menu opens on focus and the focused
                    // option is already selected; it breaks the flow of navigation
                    openMenuOnFocus && _this.isOptionSelected(focusedOption, selectValue)) return;
                    _this.selectOption(focusedOption);
                    break;
                case "Enter":
                    if (event.keyCode === 229) break;
                    if (menuIsOpen) {
                        if (!focusedOption) return;
                        if (_this.isComposing) return;
                        _this.selectOption(focusedOption);
                        break;
                    }
                    return;
                case "Escape":
                    if (menuIsOpen) {
                        _this.setState({
                            inputIsHiddenAfterUpdate: false
                        });
                        _this.onInputChange("", {
                            action: "menu-close",
                            prevInputValue: inputValue
                        });
                        _this.onMenuClose();
                    } else if (isClearable && escapeClearsValue) _this.clearValue();
                    break;
                case " ":
                    // space
                    if (inputValue) return;
                    if (!menuIsOpen) {
                        _this.openMenu("first");
                        break;
                    }
                    if (!focusedOption) return;
                    _this.selectOption(focusedOption);
                    break;
                case "ArrowUp":
                    if (menuIsOpen) _this.focusOption("up");
                    else _this.openMenu("last");
                    break;
                case "ArrowDown":
                    if (menuIsOpen) _this.focusOption("down");
                    else _this.openMenu("first");
                    break;
                case "PageUp":
                    if (!menuIsOpen) return;
                    _this.focusOption("pageup");
                    break;
                case "PageDown":
                    if (!menuIsOpen) return;
                    _this.focusOption("pagedown");
                    break;
                case "Home":
                    if (!menuIsOpen) return;
                    _this.focusOption("first");
                    break;
                case "End":
                    if (!menuIsOpen) return;
                    _this.focusOption("last");
                    break;
                default:
                    return;
            }
            event.preventDefault();
        };
        _this.state.instancePrefix = "react-select-" + (_this.props.instanceId || ++$02a6ea8308eefe55$var$instanceId);
        _this.state.selectValue = (0, $a9284aba291bbde9$export$7f8ddf7c7c20b3cd)(_props.value);
        // Set focusedOption if menuIsOpen is set on init (e.g. defaultMenuIsOpen)
        if (_props.menuIsOpen && _this.state.selectValue.length) {
            var focusableOptionsWithIds = _this.getFocusableOptionsWithIds();
            var focusableOptions = _this.buildFocusableOptions();
            var optionIndex = focusableOptions.indexOf(_this.state.selectValue[0]);
            _this.state.focusableOptionsWithIds = focusableOptionsWithIds;
            _this.state.focusedOption = focusableOptions[optionIndex];
            _this.state.focusedOptionId = $02a6ea8308eefe55$var$getFocusedOptionId(focusableOptionsWithIds, focusableOptions[optionIndex]);
        }
        return _this;
    }
    (0, $94019358ecbcf36b$export$2e2bcd8739ae039)(Select, [
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                this.startListeningComposition();
                this.startListeningToTouch();
                if (this.props.closeMenuOnScroll && document && document.addEventListener) // Listen to all scroll events, and filter them out inside of 'onScroll'
                document.addEventListener("scroll", this.onScroll, true);
                if (this.props.autoFocus) this.focusInput();
                // Scroll focusedOption into view if menuIsOpen is set on mount (e.g. defaultMenuIsOpen)
                if (this.props.menuIsOpen && this.state.focusedOption && this.menuListRef && this.focusedOptionRef) (0, $a9284aba291bbde9$export$9bb611d729802a56)(this.menuListRef, this.focusedOptionRef);
            }
        },
        {
            key: "componentDidUpdate",
            value: function componentDidUpdate(prevProps) {
                var _this$props6 = this.props, isDisabled = _this$props6.isDisabled, menuIsOpen = _this$props6.menuIsOpen;
                var isFocused = this.state.isFocused;
                if (// ensure focus is restored correctly when the control becomes enabled
                isFocused && !isDisabled && prevProps.isDisabled || // ensure focus is on the Input when the menu opens
                isFocused && menuIsOpen && !prevProps.menuIsOpen) this.focusInput();
                if (isFocused && isDisabled && !prevProps.isDisabled) // ensure select state gets blurred in case Select is programmatically disabled while focused
                // eslint-disable-next-line react/no-did-update-set-state
                this.setState({
                    isFocused: false
                }, this.onMenuClose);
                else if (!isFocused && !isDisabled && prevProps.isDisabled && this.inputRef === document.activeElement) // ensure select state gets focused in case Select is programatically re-enabled while focused (Firefox)
                // eslint-disable-next-line react/no-did-update-set-state
                this.setState({
                    isFocused: true
                });
                // scroll the focused option into view if necessary
                if (this.menuListRef && this.focusedOptionRef && this.scrollToFocusedOptionOnUpdate) {
                    (0, $a9284aba291bbde9$export$9bb611d729802a56)(this.menuListRef, this.focusedOptionRef);
                    this.scrollToFocusedOptionOnUpdate = false;
                }
            }
        },
        {
            key: "componentWillUnmount",
            value: function componentWillUnmount() {
                this.stopListeningComposition();
                this.stopListeningToTouch();
                document.removeEventListener("scroll", this.onScroll, true);
            }
        },
        {
            key: "onMenuOpen",
            value: function onMenuOpen() {
                this.props.onMenuOpen();
            }
        },
        {
            key: "onMenuClose",
            value: function onMenuClose() {
                this.onInputChange("", {
                    action: "menu-close",
                    prevInputValue: this.props.inputValue
                });
                this.props.onMenuClose();
            }
        },
        {
            key: "onInputChange",
            value: function onInputChange(newValue, actionMeta) {
                this.props.onInputChange(newValue, actionMeta);
            }
        },
        {
            key: "focusInput",
            value: function focusInput() {
                if (!this.inputRef) return;
                this.inputRef.focus();
            }
        },
        {
            key: "blurInput",
            value: function blurInput() {
                if (!this.inputRef) return;
                this.inputRef.blur();
            }
        },
        {
            key: "openMenu",
            value: function openMenu(focusOption) {
                var _this2 = this;
                var _this$state2 = this.state, selectValue = _this$state2.selectValue, isFocused = _this$state2.isFocused;
                var focusableOptions = this.buildFocusableOptions();
                var openAtIndex = focusOption === "first" ? 0 : focusableOptions.length - 1;
                if (!this.props.isMulti) {
                    var selectedIndex = focusableOptions.indexOf(selectValue[0]);
                    if (selectedIndex > -1) openAtIndex = selectedIndex;
                }
                // only scroll if the menu isn't already open
                this.scrollToFocusedOptionOnUpdate = !(isFocused && this.menuListRef);
                this.setState({
                    inputIsHiddenAfterUpdate: false,
                    focusedValue: null,
                    focusedOption: focusableOptions[openAtIndex],
                    focusedOptionId: this.getFocusedOptionId(focusableOptions[openAtIndex])
                }, function() {
                    return _this2.onMenuOpen();
                });
            }
        },
        {
            key: "focusValue",
            value: function focusValue(direction) {
                var _this$state3 = this.state, selectValue = _this$state3.selectValue, focusedValue = _this$state3.focusedValue;
                // Only multiselects support value focusing
                if (!this.props.isMulti) return;
                this.setState({
                    focusedOption: null
                });
                var focusedIndex = selectValue.indexOf(focusedValue);
                if (!focusedValue) focusedIndex = -1;
                var lastIndex = selectValue.length - 1;
                var nextFocus = -1;
                if (!selectValue.length) return;
                switch(direction){
                    case "previous":
                        if (focusedIndex === 0) // don't cycle from the start to the end
                        nextFocus = 0;
                        else if (focusedIndex === -1) // if nothing is focused, focus the last value first
                        nextFocus = lastIndex;
                        else nextFocus = focusedIndex - 1;
                        break;
                    case "next":
                        if (focusedIndex > -1 && focusedIndex < lastIndex) nextFocus = focusedIndex + 1;
                        break;
                }
                this.setState({
                    inputIsHidden: nextFocus !== -1,
                    focusedValue: selectValue[nextFocus]
                });
            }
        },
        {
            key: "focusOption",
            value: function focusOption() {
                var direction = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "first";
                var pageSize = this.props.pageSize;
                var focusedOption = this.state.focusedOption;
                var options = this.getFocusableOptions();
                if (!options.length) return;
                var nextFocus = 0; // handles 'first'
                var focusedIndex = options.indexOf(focusedOption);
                if (!focusedOption) focusedIndex = -1;
                if (direction === "up") nextFocus = focusedIndex > 0 ? focusedIndex - 1 : options.length - 1;
                else if (direction === "down") nextFocus = (focusedIndex + 1) % options.length;
                else if (direction === "pageup") {
                    nextFocus = focusedIndex - pageSize;
                    if (nextFocus < 0) nextFocus = 0;
                } else if (direction === "pagedown") {
                    nextFocus = focusedIndex + pageSize;
                    if (nextFocus > options.length - 1) nextFocus = options.length - 1;
                } else if (direction === "last") nextFocus = options.length - 1;
                this.scrollToFocusedOptionOnUpdate = true;
                this.setState({
                    focusedOption: options[nextFocus],
                    focusedValue: null,
                    focusedOptionId: this.getFocusedOptionId(options[nextFocus])
                });
            }
        },
        {
            key: "getTheme",
            value: // ==============================
            // Getters
            // ==============================
            function getTheme() {
                // Use the default theme if there are no customisations.
                if (!this.props.theme) return $02a6ea8308eefe55$export$4368d992c4eafac0;
                // If the theme prop is a function, assume the function
                // knows how to merge the passed-in default theme with
                // its own modifications.
                if (typeof this.props.theme === "function") return this.props.theme($02a6ea8308eefe55$export$4368d992c4eafac0);
                // Otherwise, if a plain theme object was passed in,
                // overlay it with the default theme.
                return (0, $983350b7b3960a26$export$2e2bcd8739ae039)((0, $983350b7b3960a26$export$2e2bcd8739ae039)({}, $02a6ea8308eefe55$export$4368d992c4eafac0), this.props.theme);
            }
        },
        {
            key: "getCommonProps",
            value: function getCommonProps() {
                var clearValue = this.clearValue, cx = this.cx, getStyles = this.getStyles, getClassNames = this.getClassNames, getValue = this.getValue, selectOption = this.selectOption, setValue = this.setValue, props = this.props;
                var isMulti = props.isMulti, isRtl = props.isRtl, options = props.options;
                var hasValue = this.hasValue();
                return {
                    clearValue: clearValue,
                    cx: cx,
                    getStyles: getStyles,
                    getClassNames: getClassNames,
                    getValue: getValue,
                    hasValue: hasValue,
                    isMulti: isMulti,
                    isRtl: isRtl,
                    options: options,
                    selectOption: selectOption,
                    selectProps: props,
                    setValue: setValue,
                    theme: this.getTheme()
                };
            }
        },
        {
            key: "hasValue",
            value: function hasValue() {
                var selectValue = this.state.selectValue;
                return selectValue.length > 0;
            }
        },
        {
            key: "hasOptions",
            value: function hasOptions() {
                return !!this.getFocusableOptions().length;
            }
        },
        {
            key: "isClearable",
            value: function isClearable() {
                var _this$props7 = this.props, isClearable = _this$props7.isClearable, isMulti = _this$props7.isMulti;
                // single select, by default, IS NOT clearable
                // multi select, by default, IS clearable
                if (isClearable === undefined) return isMulti;
                return isClearable;
            }
        },
        {
            key: "isOptionDisabled",
            value: function isOptionDisabled(option, selectValue) {
                return $02a6ea8308eefe55$var$_isOptionDisabled(this.props, option, selectValue);
            }
        },
        {
            key: "isOptionSelected",
            value: function isOptionSelected(option, selectValue) {
                return $02a6ea8308eefe55$var$_isOptionSelected(this.props, option, selectValue);
            }
        },
        {
            key: "filterOption",
            value: function filterOption(option, inputValue) {
                return $02a6ea8308eefe55$var$_filterOption(this.props, option, inputValue);
            }
        },
        {
            key: "formatOptionLabel",
            value: function formatOptionLabel(data, context) {
                if (typeof this.props.formatOptionLabel === "function") {
                    var _inputValue = this.props.inputValue;
                    var _selectValue = this.state.selectValue;
                    return this.props.formatOptionLabel(data, {
                        context: context,
                        inputValue: _inputValue,
                        selectValue: _selectValue
                    });
                } else return this.getOptionLabel(data);
            }
        },
        {
            key: "formatGroupLabel",
            value: function formatGroupLabel(data) {
                return this.props.formatGroupLabel(data);
            }
        },
        {
            key: "startListeningComposition",
            value: // ==============================
            // Composition Handlers
            // ==============================
            function startListeningComposition() {
                if (document && document.addEventListener) {
                    document.addEventListener("compositionstart", this.onCompositionStart, false);
                    document.addEventListener("compositionend", this.onCompositionEnd, false);
                }
            }
        },
        {
            key: "stopListeningComposition",
            value: function stopListeningComposition() {
                if (document && document.removeEventListener) {
                    document.removeEventListener("compositionstart", this.onCompositionStart);
                    document.removeEventListener("compositionend", this.onCompositionEnd);
                }
            }
        },
        {
            key: "startListeningToTouch",
            value: // ==============================
            // Touch Handlers
            // ==============================
            function startListeningToTouch() {
                if (document && document.addEventListener) {
                    document.addEventListener("touchstart", this.onTouchStart, false);
                    document.addEventListener("touchmove", this.onTouchMove, false);
                    document.addEventListener("touchend", this.onTouchEnd, false);
                }
            }
        },
        {
            key: "stopListeningToTouch",
            value: function stopListeningToTouch() {
                if (document && document.removeEventListener) {
                    document.removeEventListener("touchstart", this.onTouchStart);
                    document.removeEventListener("touchmove", this.onTouchMove);
                    document.removeEventListener("touchend", this.onTouchEnd);
                }
            }
        },
        {
            key: "renderInput",
            value: // ==============================
            // Renderers
            // ==============================
            function renderInput() {
                var _this$props8 = this.props, isDisabled = _this$props8.isDisabled, isSearchable = _this$props8.isSearchable, inputId = _this$props8.inputId, inputValue = _this$props8.inputValue, tabIndex = _this$props8.tabIndex, form = _this$props8.form, menuIsOpen = _this$props8.menuIsOpen, required = _this$props8.required;
                var _this$getComponents = this.getComponents(), Input = _this$getComponents.Input;
                var _this$state4 = this.state, inputIsHidden = _this$state4.inputIsHidden, ariaSelection = _this$state4.ariaSelection;
                var commonProps = this.commonProps;
                var id = inputId || this.getElementId("input");
                // aria attributes makes the JSX "noisy", separated for clarity
                var ariaAttributes = (0, $983350b7b3960a26$export$2e2bcd8739ae039)((0, $983350b7b3960a26$export$2e2bcd8739ae039)((0, $983350b7b3960a26$export$2e2bcd8739ae039)({
                    "aria-autocomplete": "list",
                    "aria-expanded": menuIsOpen,
                    "aria-haspopup": true,
                    "aria-errormessage": this.props["aria-errormessage"],
                    "aria-invalid": this.props["aria-invalid"],
                    "aria-label": this.props["aria-label"],
                    "aria-labelledby": this.props["aria-labelledby"],
                    "aria-required": required,
                    role: "combobox",
                    "aria-activedescendant": this.isAppleDevice ? undefined : this.state.focusedOptionId || ""
                }, menuIsOpen && {
                    "aria-controls": this.getElementId("listbox")
                }), !isSearchable && {
                    "aria-readonly": true
                }), this.hasValue() ? (ariaSelection === null || ariaSelection === void 0 ? void 0 : ariaSelection.action) === "initial-input-focus" && {
                    "aria-describedby": this.getElementId("live-region")
                } : {
                    "aria-describedby": this.getElementId("placeholder")
                });
                if (!isSearchable) // use a dummy input to maintain focus/blur functionality
                return /*#__PURE__*/ $acw62.createElement($02a6ea8308eefe55$var$DummyInput, (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({
                    id: id,
                    innerRef: this.getInputRef,
                    onBlur: this.onInputBlur,
                    onChange: (0, $a9284aba291bbde9$export$b4171a6734a65d42),
                    onFocus: this.onInputFocus,
                    disabled: isDisabled,
                    tabIndex: tabIndex,
                    inputMode: "none",
                    form: form,
                    value: ""
                }, ariaAttributes));
                return /*#__PURE__*/ $acw62.createElement(Input, (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, commonProps, {
                    autoCapitalize: "none",
                    autoComplete: "off",
                    autoCorrect: "off",
                    id: id,
                    innerRef: this.getInputRef,
                    isDisabled: isDisabled,
                    isHidden: inputIsHidden,
                    onBlur: this.onInputBlur,
                    onChange: this.handleInputChange,
                    onFocus: this.onInputFocus,
                    spellCheck: "false",
                    tabIndex: tabIndex,
                    form: form,
                    type: "text",
                    value: inputValue
                }, ariaAttributes));
            }
        },
        {
            key: "renderPlaceholderOrValue",
            value: function renderPlaceholderOrValue() {
                var _this3 = this;
                var _this$getComponents2 = this.getComponents(), MultiValue = _this$getComponents2.MultiValue, MultiValueContainer = _this$getComponents2.MultiValueContainer, MultiValueLabel = _this$getComponents2.MultiValueLabel, MultiValueRemove = _this$getComponents2.MultiValueRemove, SingleValue = _this$getComponents2.SingleValue, Placeholder = _this$getComponents2.Placeholder;
                var commonProps = this.commonProps;
                var _this$props9 = this.props, controlShouldRenderValue = _this$props9.controlShouldRenderValue, isDisabled = _this$props9.isDisabled, isMulti = _this$props9.isMulti, inputValue = _this$props9.inputValue, placeholder = _this$props9.placeholder;
                var _this$state5 = this.state, selectValue = _this$state5.selectValue, focusedValue = _this$state5.focusedValue, isFocused = _this$state5.isFocused;
                if (!this.hasValue() || !controlShouldRenderValue) return inputValue ? null : /*#__PURE__*/ $acw62.createElement(Placeholder, (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, commonProps, {
                    key: "placeholder",
                    isDisabled: isDisabled,
                    isFocused: isFocused,
                    innerProps: {
                        id: this.getElementId("placeholder")
                    }
                }), placeholder);
                if (isMulti) return selectValue.map(function(opt, index) {
                    var isOptionFocused = opt === focusedValue;
                    var key = "".concat(_this3.getOptionLabel(opt), "-").concat(_this3.getOptionValue(opt));
                    return /*#__PURE__*/ $acw62.createElement(MultiValue, (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, commonProps, {
                        components: {
                            Container: MultiValueContainer,
                            Label: MultiValueLabel,
                            Remove: MultiValueRemove
                        },
                        isFocused: isOptionFocused,
                        isDisabled: isDisabled,
                        key: key,
                        index: index,
                        removeProps: {
                            onClick: function onClick() {
                                return _this3.removeValue(opt);
                            },
                            onTouchEnd: function onTouchEnd() {
                                return _this3.removeValue(opt);
                            },
                            onMouseDown: function onMouseDown(e) {
                                e.preventDefault();
                            }
                        },
                        data: opt
                    }), _this3.formatOptionLabel(opt, "value"));
                });
                if (inputValue) return null;
                var singleValue = selectValue[0];
                return /*#__PURE__*/ $acw62.createElement(SingleValue, (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, commonProps, {
                    data: singleValue,
                    isDisabled: isDisabled
                }), this.formatOptionLabel(singleValue, "value"));
            }
        },
        {
            key: "renderClearIndicator",
            value: function renderClearIndicator() {
                var _this$getComponents3 = this.getComponents(), ClearIndicator = _this$getComponents3.ClearIndicator;
                var commonProps = this.commonProps;
                var _this$props10 = this.props, isDisabled = _this$props10.isDisabled, isLoading = _this$props10.isLoading;
                var isFocused = this.state.isFocused;
                if (!this.isClearable() || !ClearIndicator || isDisabled || !this.hasValue() || isLoading) return null;
                var innerProps = {
                    onMouseDown: this.onClearIndicatorMouseDown,
                    onTouchEnd: this.onClearIndicatorTouchEnd,
                    "aria-hidden": "true"
                };
                return /*#__PURE__*/ $acw62.createElement(ClearIndicator, (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, commonProps, {
                    innerProps: innerProps,
                    isFocused: isFocused
                }));
            }
        },
        {
            key: "renderLoadingIndicator",
            value: function renderLoadingIndicator() {
                var _this$getComponents4 = this.getComponents(), LoadingIndicator = _this$getComponents4.LoadingIndicator;
                var commonProps = this.commonProps;
                var _this$props11 = this.props, isDisabled = _this$props11.isDisabled, isLoading = _this$props11.isLoading;
                var isFocused = this.state.isFocused;
                if (!LoadingIndicator || !isLoading) return null;
                var innerProps = {
                    "aria-hidden": "true"
                };
                return /*#__PURE__*/ $acw62.createElement(LoadingIndicator, (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, commonProps, {
                    innerProps: innerProps,
                    isDisabled: isDisabled,
                    isFocused: isFocused
                }));
            }
        },
        {
            key: "renderIndicatorSeparator",
            value: function renderIndicatorSeparator() {
                var _this$getComponents5 = this.getComponents(), DropdownIndicator = _this$getComponents5.DropdownIndicator, IndicatorSeparator = _this$getComponents5.IndicatorSeparator;
                // separator doesn't make sense without the dropdown indicator
                if (!DropdownIndicator || !IndicatorSeparator) return null;
                var commonProps = this.commonProps;
                var isDisabled = this.props.isDisabled;
                var isFocused = this.state.isFocused;
                return /*#__PURE__*/ $acw62.createElement(IndicatorSeparator, (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, commonProps, {
                    isDisabled: isDisabled,
                    isFocused: isFocused
                }));
            }
        },
        {
            key: "renderDropdownIndicator",
            value: function renderDropdownIndicator() {
                var _this$getComponents6 = this.getComponents(), DropdownIndicator = _this$getComponents6.DropdownIndicator;
                if (!DropdownIndicator) return null;
                var commonProps = this.commonProps;
                var isDisabled = this.props.isDisabled;
                var isFocused = this.state.isFocused;
                var innerProps = {
                    onMouseDown: this.onDropdownIndicatorMouseDown,
                    onTouchEnd: this.onDropdownIndicatorTouchEnd,
                    "aria-hidden": "true"
                };
                return /*#__PURE__*/ $acw62.createElement(DropdownIndicator, (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, commonProps, {
                    innerProps: innerProps,
                    isDisabled: isDisabled,
                    isFocused: isFocused
                }));
            }
        },
        {
            key: "renderMenu",
            value: function renderMenu() {
                var _this4 = this;
                var _this$getComponents7 = this.getComponents(), Group = _this$getComponents7.Group, GroupHeading = _this$getComponents7.GroupHeading, Menu = _this$getComponents7.Menu, MenuList = _this$getComponents7.MenuList, MenuPortal = _this$getComponents7.MenuPortal, LoadingMessage = _this$getComponents7.LoadingMessage, NoOptionsMessage = _this$getComponents7.NoOptionsMessage, Option = _this$getComponents7.Option;
                var commonProps = this.commonProps;
                var focusedOption = this.state.focusedOption;
                var _this$props12 = this.props, captureMenuScroll = _this$props12.captureMenuScroll, inputValue = _this$props12.inputValue, isLoading = _this$props12.isLoading, loadingMessage = _this$props12.loadingMessage, minMenuHeight = _this$props12.minMenuHeight, maxMenuHeight = _this$props12.maxMenuHeight, menuIsOpen = _this$props12.menuIsOpen, menuPlacement = _this$props12.menuPlacement, menuPosition = _this$props12.menuPosition, menuPortalTarget = _this$props12.menuPortalTarget, menuShouldBlockScroll = _this$props12.menuShouldBlockScroll, menuShouldScrollIntoView = _this$props12.menuShouldScrollIntoView, noOptionsMessage = _this$props12.noOptionsMessage, onMenuScrollToTop = _this$props12.onMenuScrollToTop, onMenuScrollToBottom = _this$props12.onMenuScrollToBottom;
                if (!menuIsOpen) return null;
                // TODO: Internal Option Type here
                var render = function render(props, id) {
                    var type = props.type, data = props.data, isDisabled = props.isDisabled, isSelected = props.isSelected, label = props.label, value = props.value;
                    var isFocused = focusedOption === data;
                    var onHover = isDisabled ? undefined : function() {
                        return _this4.onOptionHover(data);
                    };
                    var onSelect = isDisabled ? undefined : function() {
                        return _this4.selectOption(data);
                    };
                    var optionId = "".concat(_this4.getElementId("option"), "-").concat(id);
                    var innerProps = {
                        id: optionId,
                        onClick: onSelect,
                        onMouseMove: onHover,
                        onMouseOver: onHover,
                        tabIndex: -1,
                        role: "option",
                        "aria-selected": _this4.isAppleDevice ? undefined : isSelected // is not supported on Apple devices
                    };
                    return /*#__PURE__*/ $acw62.createElement(Option, (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, commonProps, {
                        innerProps: innerProps,
                        data: data,
                        isDisabled: isDisabled,
                        isSelected: isSelected,
                        key: optionId,
                        label: label,
                        type: type,
                        value: value,
                        isFocused: isFocused,
                        innerRef: isFocused ? _this4.getFocusedOptionRef : undefined
                    }), _this4.formatOptionLabel(props.data, "menu"));
                };
                var menuUI;
                if (this.hasOptions()) menuUI = this.getCategorizedOptions().map(function(item) {
                    if (item.type === "group") {
                        var _data = item.data, options = item.options, groupIndex = item.index;
                        var groupId = "".concat(_this4.getElementId("group"), "-").concat(groupIndex);
                        var headingId = "".concat(groupId, "-heading");
                        return /*#__PURE__*/ $acw62.createElement(Group, (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, commonProps, {
                            key: groupId,
                            data: _data,
                            options: options,
                            Heading: GroupHeading,
                            headingProps: {
                                id: headingId,
                                data: item.data
                            },
                            label: _this4.formatGroupLabel(item.data)
                        }), item.options.map(function(option) {
                            return render(option, "".concat(groupIndex, "-").concat(option.index));
                        }));
                    } else if (item.type === "option") return render(item, "".concat(item.index));
                });
                else if (isLoading) {
                    var message = loadingMessage({
                        inputValue: inputValue
                    });
                    if (message === null) return null;
                    menuUI = /*#__PURE__*/ $acw62.createElement(LoadingMessage, commonProps, message);
                } else {
                    var _message = noOptionsMessage({
                        inputValue: inputValue
                    });
                    if (_message === null) return null;
                    menuUI = /*#__PURE__*/ $acw62.createElement(NoOptionsMessage, commonProps, _message);
                }
                var menuPlacementProps = {
                    minMenuHeight: minMenuHeight,
                    maxMenuHeight: maxMenuHeight,
                    menuPlacement: menuPlacement,
                    menuPosition: menuPosition,
                    menuShouldScrollIntoView: menuShouldScrollIntoView
                };
                var menuElement = /*#__PURE__*/ $acw62.createElement((0, $a9284aba291bbde9$export$3a1a48c8f6ef640e), (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, commonProps, menuPlacementProps), function(_ref4) {
                    var ref = _ref4.ref, _ref4$placerProps = _ref4.placerProps, placement = _ref4$placerProps.placement, maxHeight = _ref4$placerProps.maxHeight;
                    return /*#__PURE__*/ $acw62.createElement(Menu, (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, commonProps, menuPlacementProps, {
                        innerRef: ref,
                        innerProps: {
                            onMouseDown: _this4.onMenuMouseDown,
                            onMouseMove: _this4.onMenuMouseMove
                        },
                        isLoading: isLoading,
                        placement: placement
                    }), /*#__PURE__*/ $acw62.createElement($02a6ea8308eefe55$var$ScrollManager, {
                        captureEnabled: captureMenuScroll,
                        onTopArrive: onMenuScrollToTop,
                        onBottomArrive: onMenuScrollToBottom,
                        lockEnabled: menuShouldBlockScroll
                    }, function(scrollTargetRef) {
                        return /*#__PURE__*/ $acw62.createElement(MenuList, (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, commonProps, {
                            innerRef: function innerRef(instance) {
                                _this4.getMenuListRef(instance);
                                scrollTargetRef(instance);
                            },
                            innerProps: {
                                role: "listbox",
                                "aria-multiselectable": commonProps.isMulti,
                                id: _this4.getElementId("listbox")
                            },
                            isLoading: isLoading,
                            maxHeight: maxHeight,
                            focusedOption: focusedOption
                        }), menuUI);
                    }));
                });
                // positioning behaviour is almost identical for portalled and fixed,
                // so we use the same component. the actual portalling logic is forked
                // within the component based on `menuPosition`
                return menuPortalTarget || menuPosition === "fixed" ? /*#__PURE__*/ $acw62.createElement(MenuPortal, (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, commonProps, {
                    appendTo: menuPortalTarget,
                    controlElement: this.controlRef,
                    menuPlacement: menuPlacement,
                    menuPosition: menuPosition
                }), menuElement) : menuElement;
            }
        },
        {
            key: "renderFormField",
            value: function renderFormField() {
                var _this5 = this;
                var _this$props13 = this.props, delimiter = _this$props13.delimiter, isDisabled = _this$props13.isDisabled, isMulti = _this$props13.isMulti, name = _this$props13.name, required = _this$props13.required;
                var selectValue = this.state.selectValue;
                if (required && !this.hasValue() && !isDisabled) return /*#__PURE__*/ $acw62.createElement($02a6ea8308eefe55$var$RequiredInput$1, {
                    name: name,
                    onFocus: this.onValueInputFocus
                });
                if (!name || isDisabled) return;
                if (isMulti) {
                    if (delimiter) {
                        var value = selectValue.map(function(opt) {
                            return _this5.getOptionValue(opt);
                        }).join(delimiter);
                        return /*#__PURE__*/ $acw62.createElement("input", {
                            name: name,
                            type: "hidden",
                            value: value
                        });
                    } else {
                        var input = selectValue.length > 0 ? selectValue.map(function(opt, i) {
                            return /*#__PURE__*/ $acw62.createElement("input", {
                                key: "i-".concat(i),
                                name: name,
                                type: "hidden",
                                value: _this5.getOptionValue(opt)
                            });
                        }) : /*#__PURE__*/ $acw62.createElement("input", {
                            name: name,
                            type: "hidden",
                            value: ""
                        });
                        return /*#__PURE__*/ $acw62.createElement("div", null, input);
                    }
                } else {
                    var _value = selectValue[0] ? this.getOptionValue(selectValue[0]) : "";
                    return /*#__PURE__*/ $acw62.createElement("input", {
                        name: name,
                        type: "hidden",
                        value: _value
                    });
                }
            }
        },
        {
            key: "renderLiveRegion",
            value: function renderLiveRegion() {
                var commonProps = this.commonProps;
                var _this$state6 = this.state, ariaSelection = _this$state6.ariaSelection, focusedOption = _this$state6.focusedOption, focusedValue = _this$state6.focusedValue, isFocused = _this$state6.isFocused, selectValue = _this$state6.selectValue;
                var focusableOptions = this.getFocusableOptions();
                return /*#__PURE__*/ $acw62.createElement($02a6ea8308eefe55$var$LiveRegion$1, (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, commonProps, {
                    id: this.getElementId("live-region"),
                    ariaSelection: ariaSelection,
                    focusedOption: focusedOption,
                    focusedValue: focusedValue,
                    isFocused: isFocused,
                    selectValue: selectValue,
                    focusableOptions: focusableOptions,
                    isAppleDevice: this.isAppleDevice
                }));
            }
        },
        {
            key: "render",
            value: function render() {
                var _this$getComponents8 = this.getComponents(), Control = _this$getComponents8.Control, IndicatorsContainer = _this$getComponents8.IndicatorsContainer, SelectContainer = _this$getComponents8.SelectContainer, ValueContainer = _this$getComponents8.ValueContainer;
                var _this$props14 = this.props, className = _this$props14.className, id = _this$props14.id, isDisabled = _this$props14.isDisabled, menuIsOpen = _this$props14.menuIsOpen;
                var isFocused = this.state.isFocused;
                var commonProps = this.commonProps = this.getCommonProps();
                return /*#__PURE__*/ $acw62.createElement(SelectContainer, (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, commonProps, {
                    className: className,
                    innerProps: {
                        id: id,
                        onKeyDown: this.onKeyDown
                    },
                    isDisabled: isDisabled,
                    isFocused: isFocused
                }), this.renderLiveRegion(), /*#__PURE__*/ $acw62.createElement(Control, (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, commonProps, {
                    innerRef: this.getControlRef,
                    innerProps: {
                        onMouseDown: this.onControlMouseDown,
                        onTouchEnd: this.onControlTouchEnd
                    },
                    isDisabled: isDisabled,
                    isFocused: isFocused,
                    menuIsOpen: menuIsOpen
                }), /*#__PURE__*/ $acw62.createElement(ValueContainer, (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, commonProps, {
                    isDisabled: isDisabled
                }), this.renderPlaceholderOrValue(), this.renderInput()), /*#__PURE__*/ $acw62.createElement(IndicatorsContainer, (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, commonProps, {
                    isDisabled: isDisabled
                }), this.renderClearIndicator(), this.renderLoadingIndicator(), this.renderIndicatorSeparator(), this.renderDropdownIndicator())), this.renderMenu(), this.renderFormField());
            }
        }
    ], [
        {
            key: "getDerivedStateFromProps",
            value: function getDerivedStateFromProps(props, state) {
                var prevProps = state.prevProps, clearFocusValueOnUpdate = state.clearFocusValueOnUpdate, inputIsHiddenAfterUpdate = state.inputIsHiddenAfterUpdate, ariaSelection = state.ariaSelection, isFocused = state.isFocused, prevWasFocused = state.prevWasFocused, instancePrefix = state.instancePrefix;
                var options = props.options, value = props.value, menuIsOpen = props.menuIsOpen, inputValue = props.inputValue, isMulti = props.isMulti;
                var selectValue = (0, $a9284aba291bbde9$export$7f8ddf7c7c20b3cd)(value);
                var newMenuOptionsState = {};
                if (prevProps && (value !== prevProps.value || options !== prevProps.options || menuIsOpen !== prevProps.menuIsOpen || inputValue !== prevProps.inputValue)) {
                    var focusableOptions = menuIsOpen ? $02a6ea8308eefe55$var$buildFocusableOptions(props, selectValue) : [];
                    var focusableOptionsWithIds = menuIsOpen ? $02a6ea8308eefe55$var$buildFocusableOptionsWithIds($02a6ea8308eefe55$var$buildCategorizedOptions(props, selectValue), "".concat(instancePrefix, "-option")) : [];
                    var focusedValue = clearFocusValueOnUpdate ? $02a6ea8308eefe55$var$getNextFocusedValue(state, selectValue) : null;
                    var focusedOption = $02a6ea8308eefe55$var$getNextFocusedOption(state, focusableOptions);
                    var focusedOptionId = $02a6ea8308eefe55$var$getFocusedOptionId(focusableOptionsWithIds, focusedOption);
                    newMenuOptionsState = {
                        selectValue: selectValue,
                        focusedOption: focusedOption,
                        focusedOptionId: focusedOptionId,
                        focusableOptionsWithIds: focusableOptionsWithIds,
                        focusedValue: focusedValue,
                        clearFocusValueOnUpdate: false
                    };
                }
                // some updates should toggle the state of the input visibility
                var newInputIsHiddenState = inputIsHiddenAfterUpdate != null && props !== prevProps ? {
                    inputIsHidden: inputIsHiddenAfterUpdate,
                    inputIsHiddenAfterUpdate: undefined
                } : {};
                var newAriaSelection = ariaSelection;
                var hasKeptFocus = isFocused && prevWasFocused;
                if (isFocused && !hasKeptFocus) {
                    // If `value` or `defaultValue` props are not empty then announce them
                    // when the Select is initially focused
                    newAriaSelection = {
                        value: (0, $a9284aba291bbde9$export$96f57966bedc81b4)(isMulti, selectValue, selectValue[0] || null),
                        options: selectValue,
                        action: "initial-input-focus"
                    };
                    hasKeptFocus = !prevWasFocused;
                }
                // If the 'initial-input-focus' action has been set already
                // then reset the ariaSelection to null
                if ((ariaSelection === null || ariaSelection === void 0 ? void 0 : ariaSelection.action) === "initial-input-focus") newAriaSelection = null;
                return (0, $983350b7b3960a26$export$2e2bcd8739ae039)((0, $983350b7b3960a26$export$2e2bcd8739ae039)((0, $983350b7b3960a26$export$2e2bcd8739ae039)({}, newMenuOptionsState), newInputIsHiddenState), {}, {
                    prevProps: props,
                    ariaSelection: newAriaSelection,
                    prevWasFocused: hasKeptFocus
                });
            }
        }
    ]);
    return Select;
}((0, $acw62.Component));
$02a6ea8308eefe55$export$25ce5a424b770e84.defaultProps = $02a6ea8308eefe55$export$407448d2b89b1813;





var $8de12fa6a893dcd1$exports = {};
var $bb7ca61ce45563c4$exports = {};
var $010f4e0e13c82e16$exports = {};
var $2ef66ab8c52ac1c0$exports = {};
function $2ef66ab8c52ac1c0$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $2ef66ab8c52ac1c0$exports = $2ef66ab8c52ac1c0$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $2ef66ab8c52ac1c0$exports.__esModule = true, $2ef66ab8c52ac1c0$exports["default"] = $2ef66ab8c52ac1c0$exports, $2ef66ab8c52ac1c0$var$_typeof(o);
}
$2ef66ab8c52ac1c0$exports = $2ef66ab8c52ac1c0$var$_typeof, $2ef66ab8c52ac1c0$exports.__esModule = true, $2ef66ab8c52ac1c0$exports["default"] = $2ef66ab8c52ac1c0$exports;


var $010f4e0e13c82e16$var$_typeof = $2ef66ab8c52ac1c0$exports.default;
var $b77c8068776c2a21$exports = {};

var $b77c8068776c2a21$var$_typeof = $2ef66ab8c52ac1c0$exports.default;
function $b77c8068776c2a21$var$_toPrimitive(input, hint) {
    if ($b77c8068776c2a21$var$_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ($b77c8068776c2a21$var$_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
$b77c8068776c2a21$exports = $b77c8068776c2a21$var$_toPrimitive, $b77c8068776c2a21$exports.__esModule = true, $b77c8068776c2a21$exports["default"] = $b77c8068776c2a21$exports;


function $010f4e0e13c82e16$var$_toPropertyKey(arg) {
    var key = $b77c8068776c2a21$exports(arg, "string");
    return $010f4e0e13c82e16$var$_typeof(key) === "symbol" ? key : String(key);
}
$010f4e0e13c82e16$exports = $010f4e0e13c82e16$var$_toPropertyKey, $010f4e0e13c82e16$exports.__esModule = true, $010f4e0e13c82e16$exports["default"] = $010f4e0e13c82e16$exports;


function $bb7ca61ce45563c4$var$_defineProperty(obj, key, value) {
    key = $010f4e0e13c82e16$exports(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
$bb7ca61ce45563c4$exports = $bb7ca61ce45563c4$var$_defineProperty, $bb7ca61ce45563c4$exports.__esModule = true, $bb7ca61ce45563c4$exports["default"] = $bb7ca61ce45563c4$exports;


function $8de12fa6a893dcd1$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $8de12fa6a893dcd1$var$_objectSpread2(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $8de12fa6a893dcd1$var$ownKeys(Object(t), !0).forEach(function(r) {
            $bb7ca61ce45563c4$exports(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $8de12fa6a893dcd1$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
$8de12fa6a893dcd1$exports = $8de12fa6a893dcd1$var$_objectSpread2, $8de12fa6a893dcd1$exports.__esModule = true, $8de12fa6a893dcd1$exports["default"] = $8de12fa6a893dcd1$exports;


var $008fdf6f13d86ab1$exports = {};
var $bf2dbd940d8d1ee7$exports = {};
function $bf2dbd940d8d1ee7$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
$bf2dbd940d8d1ee7$exports = $bf2dbd940d8d1ee7$var$_arrayWithHoles, $bf2dbd940d8d1ee7$exports.__esModule = true, $bf2dbd940d8d1ee7$exports["default"] = $bf2dbd940d8d1ee7$exports;


var $efa3fde0b6100532$exports = {};
function $efa3fde0b6100532$var$_iterableToArrayLimit(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}
$efa3fde0b6100532$exports = $efa3fde0b6100532$var$_iterableToArrayLimit, $efa3fde0b6100532$exports.__esModule = true, $efa3fde0b6100532$exports["default"] = $efa3fde0b6100532$exports;


var $51f08ebed50a2438$exports = {};
var $1e0ecff44bad0ea1$exports = {};
function $1e0ecff44bad0ea1$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
$1e0ecff44bad0ea1$exports = $1e0ecff44bad0ea1$var$_arrayLikeToArray, $1e0ecff44bad0ea1$exports.__esModule = true, $1e0ecff44bad0ea1$exports["default"] = $1e0ecff44bad0ea1$exports;


function $51f08ebed50a2438$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $1e0ecff44bad0ea1$exports(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $1e0ecff44bad0ea1$exports(o, minLen);
}
$51f08ebed50a2438$exports = $51f08ebed50a2438$var$_unsupportedIterableToArray, $51f08ebed50a2438$exports.__esModule = true, $51f08ebed50a2438$exports["default"] = $51f08ebed50a2438$exports;


var $9fdae42208ebda05$exports = {};
function $9fdae42208ebda05$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
$9fdae42208ebda05$exports = $9fdae42208ebda05$var$_nonIterableRest, $9fdae42208ebda05$exports.__esModule = true, $9fdae42208ebda05$exports["default"] = $9fdae42208ebda05$exports;


function $008fdf6f13d86ab1$var$_slicedToArray(arr, i) {
    return $bf2dbd940d8d1ee7$exports(arr) || $efa3fde0b6100532$exports(arr, i) || $51f08ebed50a2438$exports(arr, i) || $9fdae42208ebda05$exports();
}
$008fdf6f13d86ab1$exports = $008fdf6f13d86ab1$var$_slicedToArray, $008fdf6f13d86ab1$exports.__esModule = true, $008fdf6f13d86ab1$exports["default"] = $008fdf6f13d86ab1$exports;


var $c5fdcdd8d5286ae7$exports = {};
var $8bc9a7bbcf9a2a3b$exports = {};
function $8bc9a7bbcf9a2a3b$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
$8bc9a7bbcf9a2a3b$exports = $8bc9a7bbcf9a2a3b$var$_objectWithoutPropertiesLoose, $8bc9a7bbcf9a2a3b$exports.__esModule = true, $8bc9a7bbcf9a2a3b$exports["default"] = $8bc9a7bbcf9a2a3b$exports;


function $c5fdcdd8d5286ae7$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $8bc9a7bbcf9a2a3b$exports(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
$c5fdcdd8d5286ae7$exports = $c5fdcdd8d5286ae7$var$_objectWithoutProperties, $c5fdcdd8d5286ae7$exports.__esModule = true, $c5fdcdd8d5286ae7$exports["default"] = $c5fdcdd8d5286ae7$exports;


var $b45a6abf916bff88$exports = {};
function $b45a6abf916bff88$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
$b45a6abf916bff88$exports = $b45a6abf916bff88$var$_classCallCheck, $b45a6abf916bff88$exports.__esModule = true, $b45a6abf916bff88$exports["default"] = $b45a6abf916bff88$exports;


var $fe9438347a673ba6$exports = {};

function $fe9438347a673ba6$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, $010f4e0e13c82e16$exports(descriptor.key), descriptor);
    }
}
function $fe9438347a673ba6$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $fe9438347a673ba6$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $fe9438347a673ba6$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
$fe9438347a673ba6$exports = $fe9438347a673ba6$var$_createClass, $fe9438347a673ba6$exports.__esModule = true, $fe9438347a673ba6$exports["default"] = $fe9438347a673ba6$exports;


var $b050fc8434f4a0e1$exports = {};
var $7b4ac2338b8e8f97$exports = {};
function $7b4ac2338b8e8f97$var$_setPrototypeOf(o, p) {
    $7b4ac2338b8e8f97$exports = $7b4ac2338b8e8f97$var$_setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    }, $7b4ac2338b8e8f97$exports.__esModule = true, $7b4ac2338b8e8f97$exports["default"] = $7b4ac2338b8e8f97$exports;
    return $7b4ac2338b8e8f97$var$_setPrototypeOf(o, p);
}
$7b4ac2338b8e8f97$exports = $7b4ac2338b8e8f97$var$_setPrototypeOf, $7b4ac2338b8e8f97$exports.__esModule = true, $7b4ac2338b8e8f97$exports["default"] = $7b4ac2338b8e8f97$exports;


function $b050fc8434f4a0e1$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    Object.defineProperty(subClass, "prototype", {
        writable: false
    });
    if (superClass) $7b4ac2338b8e8f97$exports(subClass, superClass);
}
$b050fc8434f4a0e1$exports = $b050fc8434f4a0e1$var$_inherits, $b050fc8434f4a0e1$exports.__esModule = true, $b050fc8434f4a0e1$exports["default"] = $b050fc8434f4a0e1$exports;


var $6c89cb228f797fa5$exports = {};
var $93d4339c80153a6a$exports = {};
function $93d4339c80153a6a$var$_getPrototypeOf(o) {
    $93d4339c80153a6a$exports = $93d4339c80153a6a$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    }, $93d4339c80153a6a$exports.__esModule = true, $93d4339c80153a6a$exports["default"] = $93d4339c80153a6a$exports;
    return $93d4339c80153a6a$var$_getPrototypeOf(o);
}
$93d4339c80153a6a$exports = $93d4339c80153a6a$var$_getPrototypeOf, $93d4339c80153a6a$exports.__esModule = true, $93d4339c80153a6a$exports["default"] = $93d4339c80153a6a$exports;


var $426f299ee58329c3$exports = {};
function $426f299ee58329c3$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
$426f299ee58329c3$exports = $426f299ee58329c3$var$_isNativeReflectConstruct, $426f299ee58329c3$exports.__esModule = true, $426f299ee58329c3$exports["default"] = $426f299ee58329c3$exports;


var $ac4cd79166dac6e4$exports = {};

var $ac4cd79166dac6e4$var$_typeof = $2ef66ab8c52ac1c0$exports.default;
var $4c93951af9bb8a88$exports = {};
function $4c93951af9bb8a88$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
$4c93951af9bb8a88$exports = $4c93951af9bb8a88$var$_assertThisInitialized, $4c93951af9bb8a88$exports.__esModule = true, $4c93951af9bb8a88$exports["default"] = $4c93951af9bb8a88$exports;


function $ac4cd79166dac6e4$var$_possibleConstructorReturn(self, call) {
    if (call && ($ac4cd79166dac6e4$var$_typeof(call) === "object" || typeof call === "function")) return call;
    else if (call !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
    return $4c93951af9bb8a88$exports(self);
}
$ac4cd79166dac6e4$exports = $ac4cd79166dac6e4$var$_possibleConstructorReturn, $ac4cd79166dac6e4$exports.__esModule = true, $ac4cd79166dac6e4$exports["default"] = $ac4cd79166dac6e4$exports;


function $6c89cb228f797fa5$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $426f299ee58329c3$exports();
    return function _createSuperInternal() {
        var Super = $93d4339c80153a6a$exports(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = $93d4339c80153a6a$exports(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return $ac4cd79166dac6e4$exports(this, result);
    };
}
$6c89cb228f797fa5$exports = $6c89cb228f797fa5$var$_createSuper, $6c89cb228f797fa5$exports.__esModule = true, $6c89cb228f797fa5$exports["default"] = $6c89cb228f797fa5$exports;


var $b95e04f2d4c66124$exports = {};
var $41f5c206613f56c9$exports = {};

function $41f5c206613f56c9$var$_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return $1e0ecff44bad0ea1$exports(arr);
}
$41f5c206613f56c9$exports = $41f5c206613f56c9$var$_arrayWithoutHoles, $41f5c206613f56c9$exports.__esModule = true, $41f5c206613f56c9$exports["default"] = $41f5c206613f56c9$exports;


var $cce79e023a3a67e7$exports = {};
function $cce79e023a3a67e7$var$_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
$cce79e023a3a67e7$exports = $cce79e023a3a67e7$var$_iterableToArray, $cce79e023a3a67e7$exports.__esModule = true, $cce79e023a3a67e7$exports["default"] = $cce79e023a3a67e7$exports;



var $67c90abe6042aecd$exports = {};
function $67c90abe6042aecd$var$_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
$67c90abe6042aecd$exports = $67c90abe6042aecd$var$_nonIterableSpread, $67c90abe6042aecd$exports.__esModule = true, $67c90abe6042aecd$exports["default"] = $67c90abe6042aecd$exports;


function $b95e04f2d4c66124$var$_toConsumableArray(arr) {
    return $41f5c206613f56c9$exports(arr) || $cce79e023a3a67e7$exports(arr) || $51f08ebed50a2438$exports(arr) || $67c90abe6042aecd$exports();
}
$b95e04f2d4c66124$exports = $b95e04f2d4c66124$var$_toConsumableArray, $b95e04f2d4c66124$exports.__esModule = true, $b95e04f2d4c66124$exports["default"] = $b95e04f2d4c66124$exports;




var $c4870074adc2be76$exports = {};
function $c4870074adc2be76$var$_taggedTemplateLiteral(strings, raw) {
    if (!raw) raw = strings.slice(0);
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
$c4870074adc2be76$exports = $c4870074adc2be76$var$_taggedTemplateLiteral, $c4870074adc2be76$exports.__esModule = true, $c4870074adc2be76$exports["default"] = $c4870074adc2be76$exports;



parcelRequire("1u0KT");


var $7532f3e29d96fa2a$var$StateManagedSelect = /*#__PURE__*/ (0, $acw62.forwardRef)(function(props, ref) {
    var baseSelectProps = (0, $9d88f0746ba78f85$export$3b14a55fb2447963)(props);
    return /*#__PURE__*/ $acw62.createElement((0, $02a6ea8308eefe55$export$25ce5a424b770e84), (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({
        ref: ref
    }, baseSelectProps));
});
var $7532f3e29d96fa2a$export$2e2bcd8739ae039 = $7532f3e29d96fa2a$var$StateManagedSelect;
var $7532f3e29d96fa2a$export$a7deb1594c5ce10e = function(_ref) {
    var nonce = _ref.nonce, children = _ref.children, cacheKey = _ref.cacheKey;
    var emotionCache = (0, $acw62.useMemo)(function() {
        return (0, $fc182b1f84212d3f$export$2e2bcd8739ae039)({
            key: cacheKey,
            nonce: nonce
        });
    }, [
        cacheKey,
        nonce
    ]);
    return /*#__PURE__*/ $acw62.createElement((0, $a25287fda858c019$export$e7094788287c5e9b), {
        value: emotionCache
    }, children);
};



function $f2c1b8699595d8c0$export$ef9b1a59e592288f(props) {
    const { t: t } = (0, $3765cebd031b52c0$export$9fc83ad70ead8663)();
    const handleChange = (value)=>{
        props.field?.setData(value);
        props.onChange?.(value);
    };
    const controlDefaultClassNames = `CustomSelect__control${props.className ? ` ${props.className}` : ""}`;
    const options = props.options.map((val)=>{
        return {
            value: val.value,
            label: val.label
        };
    });
    const item = options.find((val)=>val.value === (props.value ?? props.field?.value));
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7b02d682eb115277$exports.Fragment), {
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7532f3e29d96fa2a$export$2e2bcd8739ae039), {
            defaultValue: item,
            onChange: (selectedOption)=>{
                handleChange((0, $dacbeb7af41d49ec$export$16841e8ae6ecdfed)(props.options.find((val)=>val.value === selectedOption?.value)).value);
            },
            required: props.required,
            options: options,
            placeholder: props.label ?? t("common.select"),
            classNames: {
                control: (state)=>!state.isFocused ? controlDefaultClassNames : `${controlDefaultClassNames} CustomSelect__control--focused`,
                menu: (state)=>"CustomSelect__menu",
                placeholder: (state)=>props.placeholderClassName ?? "CustomSelect__placeholder",
                singleValue: (state)=>"CustomSelect__singleValue"
            },
            className: "CustomSelect"
        })
    });
}




const $b48a42831d26f5f3$var$industryOptions = [
    {
        value: (0, $85250b9063617b2f$export$413526750d373c55),
        key: (0, $85250b9063617b2f$export$413526750d373c55),
        label: "complete_registration.gr.industry_retail"
    },
    {
        value: (0, $85250b9063617b2f$export$b70c2a98db84ffea),
        key: (0, $85250b9063617b2f$export$b70c2a98db84ffea),
        label: "complete_registration.gr.industry_hotels"
    },
    {
        value: (0, $85250b9063617b2f$export$e453ba41a58a1258),
        key: (0, $85250b9063617b2f$export$e453ba41a58a1258),
        label: "complete_registration.gr.industry_brc"
    }
];
const $b48a42831d26f5f3$export$a374bc167ca51860 = ({ formikProps: formikProps, regionsData: regionsData, maxFileSizeMB: maxFileSizeMB, showVATErrorMessage: showVATErrorMessage, onSelectVAT: onSelectVAT, errorMessages: errorMessages, toggleTermsAndConditions: toggleTermsAndConditions, termsAndConditionsAccepted: termsAndConditionsAccepted, togglePrivacyPolicy: togglePrivacyPolicy, privacyPolicyAccepted: privacyPolicyAccepted, vat: vat, apiHost: apiHost })=>{
    const { t: t } = (0, $3765cebd031b52c0$export$9fc83ad70ead8663)();
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7YFi7.Form), {
        noValidate: true,
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $79dd68e96d831dee$export$2e2bcd8739ae039), {
                label: t("complete_registration.gr.company_name"),
                formikProps: formikProps,
                formikKey: "company_name"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $660b2ca422e0e2ae$export$1ff3c3f08ae963c0).Vertical, {
                height: 10
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $1067a74e1c3483e2$export$f551688fc98f2e09), {
                errors: formikProps.errors.industry,
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f2c1b8699595d8c0$export$ef9b1a59e592288f), {
                    label: t("complete_registration.gr.industry"),
                    value: formikProps.values.industry,
                    onChange: (value)=>{
                        formikProps.setFieldValue("industry", value);
                    },
                    options: $b48a42831d26f5f3$var$industryOptions.map((option)=>{
                        return {
                            ...option,
                            label: t(option.label)
                        };
                    })
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $660b2ca422e0e2ae$export$1ff3c3f08ae963c0).Vertical, {
                height: 10
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $79dd68e96d831dee$export$2e2bcd8739ae039), {
                type: "number",
                label: t("complete_registration.gr.registry_number"),
                formikProps: formikProps,
                formikKey: "license_number"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $660b2ca422e0e2ae$export$1ff3c3f08ae963c0).Vertical, {
                height: 10
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $79dd68e96d831dee$export$2e2bcd8739ae039), {
                label: t("complete_registration.gr.address"),
                formikProps: formikProps,
                formikKey: "address"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $660b2ca422e0e2ae$export$1ff3c3f08ae963c0).Vertical, {
                height: 10
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $79dd68e96d831dee$export$2e2bcd8739ae039), {
                label: t("complete_registration.gr.zip_code"),
                formikProps: formikProps,
                formikKey: "po_box"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $660b2ca422e0e2ae$export$1ff3c3f08ae963c0).Vertical, {
                height: 10
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $79dd68e96d831dee$export$2e2bcd8739ae039), {
                label: t("complete_registration.gr.tax_jurisdiction"),
                formikProps: formikProps,
                formikKey: "free_zone"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $660b2ca422e0e2ae$export$1ff3c3f08ae963c0).Vertical, {
                height: 10
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $79dd68e96d831dee$export$2e2bcd8739ae039), {
                label: t("complete_registration.region"),
                formikProps: formikProps,
                formikKey: "region"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $660b2ca422e0e2ae$export$1ff3c3f08ae963c0).Vertical, {
                height: 40
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h4", {
                className: "CompleteRegisteration__uploadInputLable",
                children: t("complete_registration.vat_certificate")
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $660b2ca422e0e2ae$export$1ff3c3f08ae963c0).Vertical, {
                height: 15
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $1ba814d56c45ce44$export$2e2bcd8739ae039), {
                maxFileSize: maxFileSizeMB,
                showErrorRequiredMessage: showVATErrorMessage,
                name: "vat",
                hasFile: Boolean(vat),
                onSelectFile: (file)=>{
                    onSelectVAT(file);
                    formikProps.setFieldValue("vat", file);
                },
                placeholder: t("complete_registration.upload_vat")
            }),
            errorMessages.map((error, i)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                    className: "CompleteRegisteration__errorMessage",
                    children: error
                }, i)),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $660b2ca422e0e2ae$export$1ff3c3f08ae963c0).Vertical, {
                height: 15
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "CompleteRegisteration__termsConditions",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                        type: "checkbox",
                        onClick: togglePrivacyPolicy,
                        checked: privacyPolicyAccepted,
                        className: "CompleteRegisteration__termsConditions__checkbox"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $660b2ca422e0e2ae$export$1ff3c3f08ae963c0).Horizontal, {
                        width: 10
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "CompleteRegisteration__termsConditions__container",
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $e04d9533328ca578$export$8d6a9236f2e3f2ce), {
                            i18nKey: "complete_registration.i_agree_with_company_pp",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                    className: "CompleteRegisteration__termsConditions__container__label",
                                    children: "I agree to the"
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("a", {
                                    href: `${apiHost}client/profile/sla?type=html&tc_type=${(0, $kLorN.TERMS_AND_CONDITIONS_TYPE_PRIVACY_POLICY_CLIENT)}`,
                                    target: "_blank",
                                    rel: "noreferrer",
                                    className: "CompleteRegisteration__termsConditions__container__link",
                                    children: "Privacy Policy for Companies"
                                })
                            ]
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $660b2ca422e0e2ae$export$1ff3c3f08ae963c0).Vertical, {
                height: 20
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "CompleteRegisteration__termsConditions",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                        type: "checkbox",
                        onClick: toggleTermsAndConditions,
                        checked: termsAndConditionsAccepted,
                        disabled: termsAndConditionsAccepted,
                        className: "CompleteRegisteration__termsConditions__checkbox"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $660b2ca422e0e2ae$export$1ff3c3f08ae963c0).Horizontal, {
                        width: 10
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "CompleteRegisteration__termsConditions__container",
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $e04d9533328ca578$export$8d6a9236f2e3f2ce), {
                            i18nKey: "complete_registration.i_agree_with_company_terms",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                    className: "CompleteRegisteration__termsConditions__container__label",
                                    children: "I agree to the"
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("a", {
                                    href: `${apiHost}client/profile/sla?type=html`,
                                    target: "_blank",
                                    rel: "noreferrer",
                                    className: "CompleteRegisteration__termsConditions__container__link",
                                    children: "Terms and Conditions"
                                })
                            ]
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $660b2ca422e0e2ae$export$1ff3c3f08ae963c0).Vertical, {
                height: 5
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                disabled: !privacyPolicyAccepted || !termsAndConditionsAccepted,
                className: "CompleteRegisteration__submitButton",
                type: "submit",
                children: t("complete_registration.continue")
            })
        ]
    });
};


const $48d506725607730f$export$49c0db5597e6b46e = (props)=>{
    const marketCode = (0, $73ccb33f5de6f5aa$export$daa49e131b652e5b).getCurrentMarketCode();
    if (marketCode === (0, $73ccb33f5de6f5aa$export$8cee2ea722248f16)) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b48a42831d26f5f3$export$a374bc167ca51860), {
        ...props
    });
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $dd1fbf78cfe16cee$export$a6fd9f62ed2c0b4c), {
        ...props
    });
};




const $fc61ac85297a16ea$var$REQUIRED_ERROR = (0, $2b1f0855f2f3a952$export$625550452a3fa3ec)("complete_registration.field_required");
const $fc61ac85297a16ea$var$MAX_FILE_SIZE_MB = 10;
const $fc61ac85297a16ea$var$validationSchema = {};
(0, $73ccb33f5de6f5aa$export$8707029d024490c9)().registration.requiredCorporateFields.forEach((field)=>{
    $fc61ac85297a16ea$var$validationSchema[field] = $bcc252d93ab3046c$export$185802fd694ee1f5().required($fc61ac85297a16ea$var$REQUIRED_ERROR);
});
const $fc61ac85297a16ea$export$29fdb44dfb63b6a9 = (0, $aca50e9407ba89c9$export$b6ae1bc530f4c149)(({ navigateToScreenName: navigateToScreenName, ...params })=>{
    const { t: t } = (0, $3765cebd031b52c0$export$9fc83ad70ead8663)();
    const { "get\u0421ompanyDetails": get\u0421ompanyDetails, companyDetails: companyDetails, regionsData: regionsData, getRegions: getRegions, getRegionName: getRegionName, getRegionId: getRegionId, "update\u0421ompanyDetails": update\u0421ompanyDetails, apiHost: apiHost, confirmOrderTermsConditions: confirmOrderTermsConditions } = (0, $4671947198ddd366$export$6ccbb43953eebf8)().data;
    const [vat, setVat] = (0, $acw62.useState)();
    const [termsAndConditionsAccepted, setTermsAndConditionsAccepted] = (0, $acw62.useState)(false);
    const [privacyPolicyAccepted, setPrivacyPolicyAccepted] = (0, $acw62.useState)(false);
    const [showVATErrorMesssage, setShowVATErrorMesssage] = (0, $acw62.useState)(false);
    const [initialValues, setInitialValues] = (0, $acw62.useState)({
        company_name: companyDetails?.company_name ?? "",
        industry: companyDetails?.industry ?? (0, $85250b9063617b2f$export$413526750d373c55),
        address: companyDetails?.address ?? "",
        po_box: companyDetails?.po_box ?? "",
        free_zone: companyDetails?.free_zone ?? "",
        trade_name: companyDetails?.trade_name ?? "",
        license_number: companyDetails?.license_number ?? "",
        is_lpo_required: companyDetails?.is_lpo_required ? t("complete_registration.yes") : t("complete_registration.no"),
        region_id: companyDetails?.region_id ? getRegionName(companyDetails.region_id) : undefined,
        region: companyDetails?.region ?? "",
        vat: null
    });
    const [, toggleTermsAndConditions] = (0, $4671947198ddd366$export$609860bf8b0084c)(confirmOrderTermsConditions, {
        onSuccess: ()=>{
            setTermsAndConditionsAccepted(true);
        },
        onError: (err)=>alert(err.data.message),
        filterError: [
            (0, $9ad33fbf770c55a1$export$9696fcf1798e1cb5).ClientError
        ]
    });
    const togglePrivacyPolicy = ()=>{
        setPrivacyPolicyAccepted((state)=>!state);
    };
    const [errorMessages, setErrorMessages] = (0, $acw62.useState)([]);
    const redirect = (0, $7df35e9df335b1c8$export$602eaf6d5314ce55)();
    const getRegionsQuery = (0, $4671947198ddd366$export$dd0a697e1782aedd)(getRegions);
    const getCorporateDataQuery = (0, $4671947198ddd366$export$dd0a697e1782aedd)(get\u0421ompanyDetails, {
        filterError: [
            (0, $9ad33fbf770c55a1$export$9696fcf1798e1cb5).ClientError
        ]
    });
    (0, $acw62.useEffect)(()=>{
        if (companyDetails && regionsData.length > 0) {
            if (companyDetails.is_corporate === 1 && !(0, $kLorN.CLIENT_STATUSES_ALLOWED_TO_CHANGE_CORPORATE_DETAILS).includes(companyDetails.status_id)) {
                redirect((0, $0534349ae8731d0b$export$66b32f6f30eb4b4).onboardingFinish, {
                    navigateToScreenName: navigateToScreenName
                });
                return;
            }
            setInitialValues({
                company_name: companyDetails.company_name ?? "",
                industry: companyDetails.industry ?? (0, $85250b9063617b2f$export$413526750d373c55),
                region: companyDetails.region ?? "",
                address: companyDetails.address ?? "",
                po_box: companyDetails.po_box ?? "",
                free_zone: companyDetails.free_zone ?? "",
                trade_name: companyDetails.trade_name ?? "",
                license_number: companyDetails.license_number ?? "",
                is_lpo_required: companyDetails.is_lpo_required ? t("complete_registration.yes") : t("complete_registration.no"),
                region_id: companyDetails.region_id ? getRegionName(companyDetails.region_id) : undefined,
                vat: null
            });
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        companyDetails,
        regionsData.length
    ]);
    const [updateCorporateDataQuery, updateCorporateData] = (0, $4671947198ddd366$export$609860bf8b0084c)((values)=>update\u0421ompanyDetails(values, {
            timeout: 40000
        }), {
        filterError: [
            (0, $9ad33fbf770c55a1$export$9696fcf1798e1cb5).ClientError
        ],
        onSuccess: ()=>{
            if (params.orderId && params.showAmend && navigateToScreenName === "orderDraftSummary") redirect((0, $0534349ae8731d0b$export$66b32f6f30eb4b4).orderDraftSummary, params);
            else redirect((0, $0534349ae8731d0b$export$66b32f6f30eb4b4).onboardingFinish, {
                navigateToScreenName: navigateToScreenName
            });
        },
        onError: (error)=>{
            const { errors: errors } = error.data;
            if (errors) {
                const errorTextMessages = [];
                for(const property in errors)if (errors.hasOwnProperty(property)) errors[property].forEach((errorText)=>errorTextMessages.push(errorText));
                setErrorMessages(errorTextMessages);
            } else setErrorMessages([
                error.data.message
            ]);
        }
    });
    const onSelectVAT = (file)=>{
        setVat(file);
        setShowVATErrorMesssage(false);
    };
    const constructDataObject = (values)=>{
        const companyInfo = {
            vat: null,
            ...companyDetails,
            ...values,
            is_lpo_required: values.is_lpo_required === t("complete_registration.yes") ? 1 : 0
        };
        if (!vat && companyDetails?.vat) delete companyInfo.vat;
        return companyInfo;
    };
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        className: "CompleteRegisteration",
        children: getCorporateDataQuery.isLoading || getRegionsQuery.isLoading || updateCorporateDataQuery.isLoading ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $57fb8f45c69e1681$export$2e2bcd8739ae039), {}) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7ae42b63183f30b4$export$8b251419efc915eb), {
                    title: t("onboarding.register_corporate")
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $660b2ca422e0e2ae$export$1ff3c3f08ae963c0).Vertical, {
                    height: 35
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: "CompleteRegisteration__body",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h4", {
                            className: "CompleteRegisteration__subTitle",
                            children: t("complete_registration.legal_information")
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $660b2ca422e0e2ae$export$1ff3c3f08ae963c0).Vertical, {
                            height: 15
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7YFi7.Formik), {
                            initialValues: initialValues,
                            onSubmit: (values)=>{
                                updateCorporateData(constructDataObject({
                                    ...values,
                                    region_id: getRegionId(values.region_id)
                                }));
                            },
                            validationSchema: $cd7706ce94a8dfd1$export$185802fd694ee1f5().shape($fc61ac85297a16ea$var$validationSchema),
                            children: (formikProps)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $48d506725607730f$export$49c0db5597e6b46e), {
                                    formikProps: formikProps,
                                    regionsData: regionsData,
                                    maxFileSizeMB: $fc61ac85297a16ea$var$MAX_FILE_SIZE_MB,
                                    showVATErrorMessage: showVATErrorMesssage || Boolean(formikProps.errors.vat),
                                    onSelectVAT: onSelectVAT,
                                    errorMessages: errorMessages,
                                    toggleTermsAndConditions: ()=>toggleTermsAndConditions({}),
                                    termsAndConditionsAccepted: termsAndConditionsAccepted,
                                    togglePrivacyPolicy: togglePrivacyPolicy,
                                    privacyPolicyAccepted: privacyPolicyAccepted,
                                    apiHost: apiHost,
                                    vat: companyDetails?.vat
                                })
                        })
                    ]
                })
            ]
        })
    });
});




var $e3993b62a3e754bd$exports = {};
$e3993b62a3e754bd$exports = new URL("confirmed.b3c1d0a9.svg", import.meta.url).toString();






function $677661c9496f0f07$export$d5992c1fec905475({ url: url, title: title, params: params, children: children, className: className }) {
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7df35e9df335b1c8$export$a6c7ac8248d6e38a), {
        route: url,
        params: params ?? {},
        className: "ButtonLink",
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
            className: `ButtonLink__container ${className ?? ""}`,
            children: children ?? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                className: "ButtonLink__label",
                children: title
            })
        })
    });
}




const $73e7c2e4991fb662$export$c9f3df9a0dde23a1 = ({ navigateToScreenName: navigateToScreenName })=>{
    const buttonLinkRoute = navigateToScreenName === "home" ? (0, $0534349ae8731d0b$export$66b32f6f30eb4b4).index : (0, $0534349ae8731d0b$export$66b32f6f30eb4b4).allJobs;
    const { t: t } = (0, $3765cebd031b52c0$export$9fc83ad70ead8663)();
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "OnboardingFinished",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $660b2ca422e0e2ae$export$1ff3c3f08ae963c0).Spacer, {
                flex: 0.06
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "OnboardingFinished__container",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                        src: (0, (/*@__PURE__*/$parcel$interopDefault($e3993b62a3e754bd$exports)))
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h2", {
                        className: "OnboardingFinished__modalTitle",
                        children: t("onboarding_complete.title")
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                        children: t("onboarding_complete.description")
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $677661c9496f0f07$export$d5992c1fec905475), {
                        url: buttonLinkRoute,
                        title: t("onboarding_complete.done"),
                        params: {},
                        className: "OnboardingFinished__closeButton"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $660b2ca422e0e2ae$export$1ff3c3f08ae963c0).Spacer, {
                flex: 0.04
            })
        ]
    });
};







var $260b96790bddd603$exports = {};
$260b96790bddd603$exports = new URL("signature.dad1d5a4.svg", import.meta.url).toString();







const $7b5cc7ebccc32803$export$72408f4fbc2d7564 = (0, $aca50e9407ba89c9$export$b6ae1bc530f4c149)(()=>{
    const { acceptSLA: acceptSLA, apiHost: apiHost } = (0, $4671947198ddd366$export$6ccbb43953eebf8)().data;
    const redirect = (0, $7df35e9df335b1c8$export$602eaf6d5314ce55)();
    const [acceptSLAQuery, submitSLA] = (0, $4671947198ddd366$export$609860bf8b0084c)(acceptSLA, {
        filterError: [
            (0, $9ad33fbf770c55a1$export$9696fcf1798e1cb5).ClientError
        ],
        onSuccess: ()=>{
            redirect((0, $0534349ae8731d0b$export$66b32f6f30eb4b4).onboardingFinish, {
                navigateToScreenName: "home"
            });
        }
    });
    const { t: t } = (0, $3765cebd031b52c0$export$9fc83ad70ead8663)();
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        className: "SignSLA",
        children: acceptSLAQuery.isLoading ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $57fb8f45c69e1681$export$2e2bcd8739ae039), {}) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $660b2ca422e0e2ae$export$1ff3c3f08ae963c0).Vertical, {
                    height: 20
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: "SignSLA__body",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                            className: "SignSLA__terms",
                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("iframe", {
                                src: `${apiHost}client/profile/sla`,
                                frameBorder: "0",
                                height: "100%",
                                width: "100%"
                            })
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("button", {
                            onClick: submitSLA,
                            className: "SignSLA__agreeButton",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                                    src: (0, (/*@__PURE__*/$parcel$interopDefault($260b96790bddd603$exports)))
                                }),
                                " ",
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                    children: t("sign_sla.i_agree")
                                })
                            ]
                        })
                    ]
                })
            ]
        })
    });
});


const $c2a180471e5e35a3$export$3cc38c065785b1c5 = {
    CompleteRegistrationPage: $fc61ac85297a16ea$export$29fdb44dfb63b6a9,
    OnboardingFinishedPage: $73e7c2e4991fb662$export$c9f3df9a0dde23a1,
    SignSLAPage: $7b5cc7ebccc32803$export$72408f4fbc2d7564
};




var $acw62 = parcelRequire("acw62");










var $acw62 = parcelRequire("acw62");




var $kLorN = parcelRequire("kLorN");








var $bsQZT = parcelRequire("bsQZT");
class $3334b6a760b6b30c$var$LeanService {
    connect(customerId, endUserId, onConnected) {
        // @ts-ignore
        window.Lean.connect({
            app_token: (0, $bsQZT.config).LEAN_APP_TOKEN,
            permissions: [
                "identity",
                "transactions",
                "balance",
                "accounts",
                "payments"
            ],
            customer_id: customerId,
            end_user_id: endUserId,
            payment_destination_id: (0, $bsQZT.config).LEAN_PAYMENT_DESTINATION_ID,
            sandbox: !(0, $bsQZT.isProductionEnvironment)(),
            callback: onConnected
        });
    }
    pay(paymentIntentId, endUserId, onPaid) {
        // @ts-ignore
        window.Lean.pay({
            app_token: (0, $bsQZT.config).LEAN_APP_TOKEN,
            payment_intent_id: paymentIntentId,
            end_user_id: endUserId,
            sandbox: !(0, $bsQZT.isProductionEnvironment)(),
            callback: onPaid
        });
    }
    authorize(paymentIntentId, customerId, endUserId, onAuthorized) {
        // @ts-ignore
        window.Lean.authorize({
            app_token: (0, $bsQZT.config).LEAN_APP_TOKEN,
            payment_intent_ids: [
                paymentIntentId
            ],
            customer_id: customerId,
            end_user_id: endUserId,
            sandbox: !(0, $bsQZT.isProductionEnvironment)(),
            callback: onAuthorized
        });
    }
}
const $3334b6a760b6b30c$export$1c4d57436149c6eb = new $3334b6a760b6b30c$var$LeanService();



const $2994e7b5ba509fe3$export$b6630b826aa95580 = ()=>{
    const redirect = (0, $7df35e9df335b1c8$export$602eaf6d5314ce55)();
    const { initLeanPayment: initLeanPayment } = $2994e7b5ba509fe3$export$9324d2d622b917b2();
    const { authorizeLeanPayment: authorizeLeanPayment } = $2994e7b5ba509fe3$export$a0cf82ff46fe368d();
    return ({ id: id, type_id: type_id, external_status: external_status, external_id: external_id })=>{
        const routeParams = {
            paymentId: String(id)
        };
        if (type_id === Number((0, $ace4c335912c9e96$export$34b52ce9cfcb0a39).Wire)) {
            redirect((0, $0534349ae8731d0b$export$66b32f6f30eb4b4).wireTransferUploadSlip, routeParams);
            return;
        }
        if (type_id === Number((0, $ace4c335912c9e96$export$34b52ce9cfcb0a39).Lean)) {
            if (external_status === (0, $ace4c335912c9e96$export$9bde2038e0377af5).AWAITING_AUTHORIZATION) {
                authorizeLeanPayment(id, external_id);
                return;
            }
            initLeanPayment(id, external_id);
            return;
        }
        if (type_id === Number((0, $ace4c335912c9e96$export$34b52ce9cfcb0a39).Card)) {
            redirect((0, $0534349ae8731d0b$export$66b32f6f30eb4b4).payWithCard, routeParams);
            return;
        }
        redirect((0, $0534349ae8731d0b$export$66b32f6f30eb4b4).paymentMethodsList, routeParams);
    };
};
const $2994e7b5ba509fe3$export$f506dd16e02779a7 = ()=>{
    return ()=>{
        return true;
    };
};
const $2994e7b5ba509fe3$export$5798ef4f23d27f5e = ()=>{
    return ()=>{
        return false;
    };
};
const $2994e7b5ba509fe3$export$6ec841cd447cf192 = (onConnect)=>{
    const redirect = (0, $7df35e9df335b1c8$export$602eaf6d5314ce55)();
    const { t: t } = (0, $3765cebd031b52c0$export$9fc83ad70ead8663)();
    const { initLeanClient: initLeanClient } = (0, $4671947198ddd366$export$6ccbb43953eebf8)().data;
    const onConnectSuccess = onConnect ? onConnect : (responseObject)=>{
        if (responseObject.status === String((0, $ace4c335912c9e96$export$1672d1da93b9da0f).SUCCESS)) {
            redirect((0, $0534349ae8731d0b$export$66b32f6f30eb4b4).paymentList, {
                paymentStatus: String((0, $ace4c335912c9e96$export$999f810846f9d31d).Pending)
            });
            (0, $60f27fc97e29822a$export$b410431fab84fa58).success(t("payment.successfully_connected_bank"));
        }
    };
    const [initLeanClientResult, initLeanClientRequest] = (0, $4671947198ddd366$export$609860bf8b0084c)(initLeanClient, {
        onSuccess: (result)=>(0, $3334b6a760b6b30c$export$1c4d57436149c6eb).connect(result.client_lean_id, result.user_lean_id, onConnectSuccess)
    });
    const isLoading = initLeanClientResult.isLoading;
    const connectLean = ()=>{
        initLeanClientRequest({});
    };
    return {
        connectLean: connectLean,
        isLoading: isLoading
    };
};
const $2994e7b5ba509fe3$export$9324d2d622b917b2 = ()=>{
    const redirect = (0, $7df35e9df335b1c8$export$602eaf6d5314ce55)();
    const { t: t } = (0, $3765cebd031b52c0$export$9fc83ad70ead8663)();
    const { initLeanClientForPayment: initLeanClientForPayment, initLeanPaymentIntent: initLeanPaymentIntent, resetPayment: resetPayment, setPaymentExternalStatus: setPaymentExternalStatus, setPaymentExternalId: setPaymentExternalId, setPaymentStatus: setPaymentStatus } = (0, $4671947198ddd366$export$6ccbb43953eebf8)().data;
    const [resetPaymentResult, resetPaymentRequest] = (0, $4671947198ddd366$export$609860bf8b0084c)((paymentId)=>resetPayment(paymentId));
    const [initLeanPaymentIntentResult, initLeanPaymentIntentRequest] = (0, $4671947198ddd366$export$609860bf8b0084c)((params)=>initLeanPaymentIntent(params.paymentId, params.endUserId), {
        onSuccess: (result)=>{
            const onPaySuccess = (response)=>{
                if ([
                    String((0, $ace4c335912c9e96$export$1672d1da93b9da0f).CANCELLED),
                    String((0, $ace4c335912c9e96$export$1672d1da93b9da0f).ERROR)
                ].includes(String(response.status))) resetPaymentRequest(result.paymentId);
                if (response.status === String((0, $ace4c335912c9e96$export$1672d1da93b9da0f).SUCCESS)) {
                    if (response.secondary_status === String((0, $ace4c335912c9e96$export$9766185993094fd2).AWAITING_AUTHORIZATION)) {
                        setPaymentExternalStatus(result.paymentId, (0, $ace4c335912c9e96$export$9bde2038e0377af5).AWAITING_AUTHORIZATION);
                        redirect((0, $0534349ae8731d0b$export$66b32f6f30eb4b4).paymentDetails, {
                            paymentId: String(result.paymentId)
                        });
                        (0, $60f27fc97e29822a$export$b410431fab84fa58).success(t("payment.payment_has_been_queued"));
                    }
                    if (response.secondary_status === String((0, $ace4c335912c9e96$export$9766185993094fd2).ACCEPTED_BY_BANK)) {
                        (0, $c74a0566d4b0fd6d$export$e9db7d6e73593439).track(String((0, $c74a0566d4b0fd6d$export$5e27155e276f6d1c).LeanPaymentPaid), {
                            paymentId: result.paymentId
                        });
                        setPaymentStatus(result.paymentId, Number((0, $ace4c335912c9e96$export$999f810846f9d31d).Completed));
                        setPaymentExternalStatus(result.paymentId, null);
                        redirect((0, $0534349ae8731d0b$export$66b32f6f30eb4b4).cardPaymentStatus, {
                            paymentId: String(result.paymentId)
                        });
                        (0, $60f27fc97e29822a$export$b410431fab84fa58).success(t("payment.successfully_paid"));
                    }
                }
            };
            setPaymentExternalId(result.paymentId, result.id);
            (0, $c74a0566d4b0fd6d$export$e9db7d6e73593439).track(String((0, $c74a0566d4b0fd6d$export$5e27155e276f6d1c).LeanPaymentMethodChosen), {
                paymentId: result.paymentId
            });
            (0, $3334b6a760b6b30c$export$1c4d57436149c6eb).pay(result.id, result.endUserId, onPaySuccess);
        }
    });
    const [initLeanClientResult, initLeanClientRequest] = (0, $4671947198ddd366$export$609860bf8b0084c)((params)=>initLeanClientForPayment(params.paymentId, params.externalId), {
        onSuccess: (result)=>{
            initLeanPaymentIntentRequest({
                endUserId: result.user_lean_id,
                paymentId: result.paymentId
            });
        }
    });
    const isLoading = initLeanClientResult.isLoading || initLeanPaymentIntentResult.isLoading;
    const isResettingPayment = resetPaymentResult.isLoading;
    const initLeanPayment = (paymentId, externalId)=>{
        initLeanClientRequest({
            paymentId: paymentId,
            externalId: externalId
        });
    };
    return {
        initLeanPayment: initLeanPayment,
        isLoading: isLoading,
        isResettingPayment: isResettingPayment
    };
};
const $2994e7b5ba509fe3$export$a0cf82ff46fe368d = ()=>{
    const redirect = (0, $7df35e9df335b1c8$export$602eaf6d5314ce55)();
    const { t: t } = (0, $3765cebd031b52c0$export$9fc83ad70ead8663)();
    const { initLeanClientForPayment: initLeanClientForPayment, setPaymentStatus: setPaymentStatus, setPaymentExternalStatus: setPaymentExternalStatus } = (0, $4671947198ddd366$export$6ccbb43953eebf8)().data;
    const [initLeanClientResult, initLeanClientRequest] = (0, $4671947198ddd366$export$609860bf8b0084c)((params)=>initLeanClientForPayment(params.paymentId, params.externalId), {
        onSuccess: (result)=>{
            const onAuthorizeSuccess = (response)=>{
                if (response.status === String((0, $ace4c335912c9e96$export$1672d1da93b9da0f).SUCCESS)) {
                    if (response.secondary_status === String((0, $ace4c335912c9e96$export$9766185993094fd2).ACCEPTED_BY_BANK)) {
                        (0, $c74a0566d4b0fd6d$export$e9db7d6e73593439).track(String((0, $c74a0566d4b0fd6d$export$5e27155e276f6d1c).LeanPaymentPaid), {
                            paymentId: result.paymentId
                        });
                        setPaymentStatus(result.paymentId, Number((0, $ace4c335912c9e96$export$999f810846f9d31d).Completed));
                        setPaymentExternalStatus(result.paymentId, (0, $ace4c335912c9e96$export$9bde2038e0377af5).AWAITING_AUTHORIZATION);
                        (0, $60f27fc97e29822a$export$b410431fab84fa58).success(t("payment.successfully_paid"));
                    }
                    redirect((0, $0534349ae8731d0b$export$66b32f6f30eb4b4).cardPaymentStatus, {
                        paymentId: String(result.paymentId)
                    });
                }
            };
            (0, $3334b6a760b6b30c$export$1c4d57436149c6eb).authorize(result.externalId, result.client_lean_id, result.user_lean_id, onAuthorizeSuccess);
        }
    });
    const isLoading = initLeanClientResult.isLoading;
    const authorizeLeanPayment = (paymentId, externalId)=>{
        (0, $c74a0566d4b0fd6d$export$e9db7d6e73593439).track(String((0, $c74a0566d4b0fd6d$export$5e27155e276f6d1c).LeanPaymentAuthorizationInitiated), {
            paymentId: paymentId
        });
        initLeanClientRequest({
            paymentId: paymentId,
            externalId: externalId
        });
    };
    return {
        authorizeLeanPayment: authorizeLeanPayment,
        isLoading: isLoading
    };
};
const $2994e7b5ba509fe3$export$b3047a41e8ba7963 = (leanSetupStatus)=>{
    return [
        (0, $ace4c335912c9e96$export$c35a3f1cb87c9eaa).LEAN_SETUP_STATUS_AWAITING_BENEFICIARY_COOL_OFF,
        (0, $ace4c335912c9e96$export$c35a3f1cb87c9eaa).LEAN_SETUP_STATUS_ACTIVE
    ].includes(Number(leanSetupStatus));
};






function $1d4eb1be4983b805$export$1b87ac28858f953e(UIComponent) {
    return (0, $a4963babae245ff9$export$f0c7a449e0cfaec7)((0, $aca50e9407ba89c9$export$b6ae1bc530f4c149)(({ openBecomeAffiliateModal: openBecomeAffiliateModal })=>{
        const { companyDetails: companyDetails, "get\u0421ompanyDetails": get\u0421ompanyDetails, markClientCreatedPOCs: markClientCreatedPOCs, profile: profile, setLeanSetupCompleted: setLeanSetupCompleted } = (0, $4671947198ddd366$export$6ccbb43953eebf8)().data;
        const [hideBecomeAffiliateSlide, setHideBecomeAffiliateSlide] = (0, $acw62.useState)(Boolean((0, $34dcbefa7de5eb80$export$11e63f7b0f3d9900)("hideBecomeAffiliateSlide")));
        const [hideScanQRSlide, setHideScanQRSlide] = (0, $acw62.useState)(Boolean((0, $34dcbefa7de5eb80$export$11e63f7b0f3d9900)("hideScanQRSlide")));
        const { isLoading: isCompanyDetailsLoading } = (0, $4671947198ddd366$export$dd0a697e1782aedd)(get\u0421ompanyDetails);
        const [, markClientCreatedPOCsSubmit] = (0, $4671947198ddd366$export$609860bf8b0084c)(markClientCreatedPOCs);
        const isLeanPaymentsEnabled = (0, $2994e7b5ba509fe3$export$5798ef4f23d27f5e)();
        const { t: t } = (0, $3765cebd031b52c0$export$9fc83ad70ead8663)();
        const redirect = (0, $7df35e9df335b1c8$export$602eaf6d5314ce55)();
        const { connectLean: connectLean } = (0, $2994e7b5ba509fe3$export$6ec841cd447cf192)((responseObject)=>{
            if (responseObject.status === String((0, $ace4c335912c9e96$export$1672d1da93b9da0f).SUCCESS)) {
                setLeanSetupCompleted(1);
                (0, $60f27fc97e29822a$export$b410431fab84fa58).success(t("payment.successfully_connected_bank"));
            }
        });
        const { setShowQRScanner: setShowQRScanner } = (0, $acw62.useContext)((0, $392d2c14aa582458$export$9e7c8e903bb56df9));
        const hireActions = [
            {
                classNames: "CarouselSlide__rightContainer__button--hire",
                onClick: ()=>{
                    (0, $c74a0566d4b0fd6d$export$e9db7d6e73593439).track((0, $c74a0566d4b0fd6d$export$5e27155e276f6d1c).HomeCarouselHireNowClicked);
                    redirect((0, $0534349ae8731d0b$export$66b32f6f30eb4b4).setJobCategory, {});
                },
                title: t("uncompleted_actions_carousel.hire_now")
            }
        ];
        const editCompanyActions = [
            {
                classNames: "CarouselSlide__rightContainer__button--edit-company",
                onClick: ()=>{
                    (0, $c74a0566d4b0fd6d$export$e9db7d6e73593439).track((0, $c74a0566d4b0fd6d$export$5e27155e276f6d1c).HomeCarouselRegisterCorporateClicked);
                    redirect((0, $0534349ae8731d0b$export$66b32f6f30eb4b4).completeRegistration, {});
                },
                title: t("uncompleted_actions_carousel.start_edit_company")
            }
        ];
        const addPocActions = [
            {
                classNames: "CarouselSlide__rightContainer__button--add-poc",
                onClick: ()=>{
                    (0, $c74a0566d4b0fd6d$export$e9db7d6e73593439).track((0, $c74a0566d4b0fd6d$export$5e27155e276f6d1c).HomeCarouselInviteStaffStartClicked);
                    redirect((0, $0534349ae8731d0b$export$66b32f6f30eb4b4).users, {});
                },
                title: t("uncompleted_actions_carousel.start_add_poc")
            },
            {
                classNames: "CarouselSlide__rightContainer__button--dismiss-add-poc",
                onClick: ()=>{
                    (0, $c74a0566d4b0fd6d$export$e9db7d6e73593439).track((0, $c74a0566d4b0fd6d$export$5e27155e276f6d1c).HomeCarouselInviteStaffDismissClicked);
                    markClientCreatedPOCsSubmit({});
                },
                title: t("uncompleted_actions_carousel.dismiss_add_poc")
            }
        ];
        const connectLeanActions = [
            {
                classNames: "CarouselSlide__rightContainer__button--hire",
                onClick: ()=>{
                    connectLean();
                },
                title: t("uncompleted_actions_carousel.connect")
            }
        ];
        const becomeAffiliateActions = [
            {
                classNames: "CarouselSlide__rightContainer__button--add-poc",
                onClick: openBecomeAffiliateModal,
                title: t("common.start_now")
            },
            {
                classNames: "CarouselSlide__rightContainer__button--dismiss-add-poc",
                onClick: ()=>{
                    (0, $34dcbefa7de5eb80$export$a1544dad697b423d)("hideBecomeAffiliateSlide", true);
                    setHideBecomeAffiliateSlide(true);
                },
                title: t("common.dismiss")
            }
        ];
        const scanQRActions = [
            {
                classNames: "CarouselSlide__rightContainer__button--scan-qr",
                onClick: ()=>setShowQRScanner(true),
                title: t("qr_scan.scan_qr")
            },
            {
                classNames: "CarouselSlide__rightContainer__button--dismiss-scan-qr",
                onClick: ()=>{
                    (0, $34dcbefa7de5eb80$export$a1544dad697b423d)("hideScanQRSlide", true);
                    setHideScanQRSlide(true);
                },
                title: t("common.dismiss")
            }
        ];
        const isCorporate = Boolean(companyDetails?.is_corporate);
        const isPocsCreated = Boolean(companyDetails?.is_pocs_created);
        const showEditCompanySlide = isCorporate && (0, $kLorN.CLIENT_STATUSES_ALLOWED_TO_CHANGE_CORPORATE_DETAILS).includes(Number(companyDetails?.status_id));
        const showAddPocSlide = !isPocsCreated;
        const showConnectLeanSlide = Boolean(isLeanPaymentsEnabled() && !(0, $2994e7b5ba509fe3$export$b3047a41e8ba7963)(profile?.lean_setup_status));
        return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)(UIComponent, {
            isLoading: isCompanyDetailsLoading,
            showEditCompanySlide: showEditCompanySlide,
            showAddPocSlide: showAddPocSlide,
            showConnectLeanSlide: showConnectLeanSlide,
            showBecomeAffiliateSlide: !hideBecomeAffiliateSlide,
            showScanQRSlide: !hideScanQRSlide,
            editCompanyActions: editCompanyActions,
            hireActions: hireActions,
            addPocActions: addPocActions,
            connectLeanActions: connectLeanActions,
            becomeAffiliateActions: becomeAffiliateActions,
            scanQRActions: scanQRActions
        });
    }), {
        [(0, $9ad33fbf770c55a1$export$9696fcf1798e1cb5).ServerError]: "uncompleted_actions_carousel.error_failed_to_load"
    });
}














var $acw62 = parcelRequire("acw62");











var $acw62 = parcelRequire("acw62");
var $352e3c72aa01b533$var$initialState = {
    animating: false,
    autoplaying: null,
    currentDirection: 0,
    currentLeft: null,
    currentSlide: 0,
    direction: 1,
    dragging: false,
    edgeDragged: false,
    initialized: false,
    lazyLoadedList: [],
    listHeight: null,
    listWidth: null,
    scrolling: false,
    slideCount: null,
    slideHeight: null,
    slideWidth: null,
    swipeLeft: null,
    swiped: false,
    // used by swipeEvent. differentites between touch and swipe.
    swiping: false,
    touchObject: {
        startX: 0,
        startY: 0,
        curX: 0,
        curY: 0
    },
    trackStyle: {},
    trackWidth: 0,
    targetSlide: 0
};
var $352e3c72aa01b533$export$2e2bcd8739ae039 = $352e3c72aa01b533$var$initialState;


/* eslint-disable no-undefined,no-param-reassign,no-shadow */ /**
 * Throttle execution of a function. Especially useful for rate limiting
 * execution of handlers on events like resize and scroll.
 *
 * @param {number} delay -                  A zero-or-greater delay in milliseconds. For event callbacks, values around 100 or 250 (or even higher)
 *                                            are most useful.
 * @param {Function} callback -               A function to be executed after delay milliseconds. The `this` context and all arguments are passed through,
 *                                            as-is, to `callback` when the throttled-function is executed.
 * @param {object} [options] -              An object to configure options.
 * @param {boolean} [options.noTrailing] -   Optional, defaults to false. If noTrailing is true, callback will only execute every `delay` milliseconds
 *                                            while the throttled-function is being called. If noTrailing is false or unspecified, callback will be executed
 *                                            one final time after the last throttled-function call. (After the throttled-function has not been called for
 *                                            `delay` milliseconds, the internal counter is reset).
 * @param {boolean} [options.noLeading] -   Optional, defaults to false. If noLeading is false, the first throttled-function call will execute callback
 *                                            immediately. If noLeading is true, the first the callback execution will be skipped. It should be noted that
 *                                            callback will never executed if both noLeading = true and noTrailing = true.
 * @param {boolean} [options.debounceMode] - If `debounceMode` is true (at begin), schedule `clear` to execute after `delay` ms. If `debounceMode` is
 *                                            false (at end), schedule `callback` to execute after `delay` ms.
 *
 * @returns {Function} A new, throttled, function.
 */ function $5d4cd9f8bc92bd41$export$de363e709c412c8a(delay, callback, options) {
    var _ref = options || {}, _ref$noTrailing = _ref.noTrailing, noTrailing = _ref$noTrailing === void 0 ? false : _ref$noTrailing, _ref$noLeading = _ref.noLeading, noLeading = _ref$noLeading === void 0 ? false : _ref$noLeading, _ref$debounceMode = _ref.debounceMode, debounceMode = _ref$debounceMode === void 0 ? undefined : _ref$debounceMode;
    /*
   * After wrapper has stopped being called, this timeout ensures that
   * `callback` is executed at the proper times in `throttle` and `end`
   * debounce modes.
   */ var timeoutID;
    var cancelled = false; // Keep track of the last time `callback` was executed.
    var lastExec = 0; // Function to clear existing timeout
    function clearExistingTimeout() {
        if (timeoutID) clearTimeout(timeoutID);
    } // Function to cancel next exec
    function cancel(options) {
        var _ref2 = options || {}, _ref2$upcomingOnly = _ref2.upcomingOnly, upcomingOnly = _ref2$upcomingOnly === void 0 ? false : _ref2$upcomingOnly;
        clearExistingTimeout();
        cancelled = !upcomingOnly;
    }
    /*
   * The `wrapper` function encapsulates all of the throttling / debouncing
   * functionality and when executed will limit the rate at which `callback`
   * is executed.
   */ function wrapper() {
        for(var _len = arguments.length, arguments_ = new Array(_len), _key = 0; _key < _len; _key++)arguments_[_key] = arguments[_key];
        var self = this;
        var elapsed = Date.now() - lastExec;
        if (cancelled) return;
         // Execute `callback` and update the `lastExec` timestamp.
        function exec() {
            lastExec = Date.now();
            callback.apply(self, arguments_);
        }
        /*
     * If `debounceMode` is true (at begin) this is used to clear the flag
     * to allow future `callback` executions.
     */ function clear() {
            timeoutID = undefined;
        }
        if (!noLeading && debounceMode && !timeoutID) /*
       * Since `wrapper` is being called for the first time and
       * `debounceMode` is true (at begin), execute `callback`
       * and noLeading != true.
       */ exec();
        clearExistingTimeout();
        if (debounceMode === undefined && elapsed > delay) {
            if (noLeading) {
                /*
         * In throttle mode with noLeading, if `delay` time has
         * been exceeded, update `lastExec` and schedule `callback`
         * to execute after `delay` ms.
         */ lastExec = Date.now();
                if (!noTrailing) timeoutID = setTimeout(debounceMode ? clear : exec, delay);
            } else /*
         * In throttle mode without noLeading, if `delay` time has been exceeded, execute
         * `callback`.
         */ exec();
        } else if (noTrailing !== true) /*
       * In trailing throttle mode, since `delay` time has not been
       * exceeded, schedule `callback` to execute `delay` ms after most
       * recent execution.
       *
       * If `debounceMode` is true (at begin), schedule `clear` to execute
       * after `delay` ms.
       *
       * If `debounceMode` is false (at end), schedule `callback` to
       * execute after `delay` ms.
       */ timeoutID = setTimeout(debounceMode ? clear : exec, debounceMode === undefined ? delay - elapsed : delay);
    }
    wrapper.cancel = cancel; // Return the wrapper function.
    return wrapper;
}
/* eslint-disable no-undefined */ /**
 * Debounce execution of a function. Debouncing, unlike throttling,
 * guarantees that a function is only executed a single time, either at the
 * very beginning of a series of calls, or at the very end.
 *
 * @param {number} delay -               A zero-or-greater delay in milliseconds. For event callbacks, values around 100 or 250 (or even higher) are most useful.
 * @param {Function} callback -          A function to be executed after delay milliseconds. The `this` context and all arguments are passed through, as-is,
 *                                        to `callback` when the debounced-function is executed.
 * @param {object} [options] -           An object to configure options.
 * @param {boolean} [options.atBegin] -  Optional, defaults to false. If atBegin is false or unspecified, callback will only be executed `delay` milliseconds
 *                                        after the last debounced-function call. If atBegin is true, callback will be executed only at the first debounced-function call.
 *                                        (After the throttled-function has not been called for `delay` milliseconds, the internal counter is reset).
 *
 * @returns {Function} A new, debounced function.
 */ function $5d4cd9f8bc92bd41$export$61fc7d43ac8f84b0(delay, callback, options) {
    var _ref = options || {}, _ref$atBegin = _ref.atBegin, atBegin = _ref$atBegin === void 0 ? false : _ref$atBegin;
    return $5d4cd9f8bc92bd41$export$de363e709c412c8a(delay, callback, {
        debounceMode: atBegin !== false
    });
}


var $60313e3b9e75c852$exports = {};
/*!
	Copyright (c) 2018 Jed Watson.
	Licensed under the MIT License (MIT), see
	http://jedwatson.github.io/classnames
*/ /* global define */ (function() {
    "use strict";
    var hasOwn = {}.hasOwnProperty;
    var nativeCodeString = "[native code]";
    function classNames() {
        var classes = [];
        for(var i = 0; i < arguments.length; i++){
            var arg = arguments[i];
            if (!arg) continue;
            var argType = typeof arg;
            if (argType === "string" || argType === "number") classes.push(arg);
            else if (Array.isArray(arg)) {
                if (arg.length) {
                    var inner = classNames.apply(null, arg);
                    if (inner) classes.push(inner);
                }
            } else if (argType === "object") {
                if (arg.toString !== Object.prototype.toString && !arg.toString.toString().includes("[native code]")) {
                    classes.push(arg.toString());
                    continue;
                }
                for(var key in arg)if (hasOwn.call(arg, key) && arg[key]) classes.push(key);
            }
        }
        return classes.join(" ");
    }
    if (0, $60313e3b9e75c852$exports) {
        classNames.default = classNames;
        $60313e3b9e75c852$exports = classNames;
    } else if (typeof define === "function" && typeof define.amd === "object" && define.amd) // register as 'classnames', consistent with npm package name
    define("classnames", [], function() {
        return classNames;
    });
    else window.classNames = classNames;
})();




var $acw62 = parcelRequire("acw62");
function $e1b381ed4609728f$export$7d15b64cf5a3a4c4(number, lowerBound, upperBound) {
    return Math.max(lowerBound, Math.min(number, upperBound));
}
var $e1b381ed4609728f$export$ed7b1178205ba7d = function safePreventDefault(event) {
    var passiveEvents = [
        "onTouchStart",
        "onTouchMove",
        "onWheel"
    ];
    if (!passiveEvents.includes(event._reactName)) event.preventDefault();
};
var $e1b381ed4609728f$export$62701ea96990f316 = function getOnDemandLazySlides(spec) {
    var onDemandSlides = [];
    var startIndex = $e1b381ed4609728f$export$8931689ba1e6a542(spec);
    var endIndex = $e1b381ed4609728f$export$fc4e3e46621b5503(spec);
    for(var slideIndex = startIndex; slideIndex < endIndex; slideIndex++)if (spec.lazyLoadedList.indexOf(slideIndex) < 0) onDemandSlides.push(slideIndex);
    return onDemandSlides;
};
var $e1b381ed4609728f$export$61de20028e4bc291 = function getRequiredLazySlides(spec) {
    var requiredSlides = [];
    var startIndex = $e1b381ed4609728f$export$8931689ba1e6a542(spec);
    var endIndex = $e1b381ed4609728f$export$fc4e3e46621b5503(spec);
    for(var slideIndex = startIndex; slideIndex < endIndex; slideIndex++)requiredSlides.push(slideIndex);
    return requiredSlides;
};
var $e1b381ed4609728f$export$8931689ba1e6a542 = function lazyStartIndex(spec) {
    return spec.currentSlide - $e1b381ed4609728f$export$2c85b0e65618cf24(spec);
};
var $e1b381ed4609728f$export$fc4e3e46621b5503 = function lazyEndIndex(spec) {
    return spec.currentSlide + $e1b381ed4609728f$export$d4d84a0677f3a05c(spec);
};
var $e1b381ed4609728f$export$2c85b0e65618cf24 = function lazySlidesOnLeft(spec) {
    return spec.centerMode ? Math.floor(spec.slidesToShow / 2) + (parseInt(spec.centerPadding) > 0 ? 1 : 0) : 0;
};
var $e1b381ed4609728f$export$d4d84a0677f3a05c = function lazySlidesOnRight(spec) {
    return spec.centerMode ? Math.floor((spec.slidesToShow - 1) / 2) + 1 + (parseInt(spec.centerPadding) > 0 ? 1 : 0) : spec.slidesToShow;
};
var $e1b381ed4609728f$export$3c49c185de0c2bfc = function getWidth(elem) {
    return elem && elem.offsetWidth || 0;
};
var $e1b381ed4609728f$export$c08559766941f856 = function getHeight(elem) {
    return elem && elem.offsetHeight || 0;
};
var $e1b381ed4609728f$export$67fc172604a155ba = function getSwipeDirection(touchObject) {
    var verticalSwiping = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    var xDist, yDist, r, swipeAngle;
    xDist = touchObject.startX - touchObject.curX;
    yDist = touchObject.startY - touchObject.curY;
    r = Math.atan2(yDist, xDist);
    swipeAngle = Math.round(r * 180 / Math.PI);
    if (swipeAngle < 0) swipeAngle = 360 - Math.abs(swipeAngle);
    if (swipeAngle <= 45 && swipeAngle >= 0 || swipeAngle <= 360 && swipeAngle >= 315) return "left";
    if (swipeAngle >= 135 && swipeAngle <= 225) return "right";
    if (verticalSwiping === true) {
        if (swipeAngle >= 35 && swipeAngle <= 135) return "up";
        else return "down";
    }
    return "vertical";
};
var $e1b381ed4609728f$export$30e977044f8f3618 = function canGoNext(spec) {
    var canGo = true;
    if (!spec.infinite) {
        if (spec.centerMode && spec.currentSlide >= spec.slideCount - 1) canGo = false;
        else if (spec.slideCount <= spec.slidesToShow || spec.currentSlide >= spec.slideCount - spec.slidesToShow) canGo = false;
    }
    return canGo;
};
var $e1b381ed4609728f$export$e9dd1a4ab6b7c5b0 = function extractObject(spec, keys) {
    var newObject = {};
    keys.forEach(function(key) {
        return newObject[key] = spec[key];
    });
    return newObject;
};
var $e1b381ed4609728f$export$446226dbc576c3ab = function initializedState(spec) {
    // spec also contains listRef, trackRef
    var slideCount = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Children.count(spec.children);
    var listNode = spec.listRef;
    var listWidth = Math.ceil($e1b381ed4609728f$export$3c49c185de0c2bfc(listNode));
    var trackNode = spec.trackRef && spec.trackRef.node;
    var trackWidth = Math.ceil($e1b381ed4609728f$export$3c49c185de0c2bfc(trackNode));
    var slideWidth;
    if (!spec.vertical) {
        var centerPaddingAdj = spec.centerMode && parseInt(spec.centerPadding) * 2;
        if (typeof spec.centerPadding === "string" && spec.centerPadding.slice(-1) === "%") centerPaddingAdj *= listWidth / 100;
        slideWidth = Math.ceil((listWidth - centerPaddingAdj) / spec.slidesToShow);
    } else slideWidth = listWidth;
    var slideHeight = listNode && $e1b381ed4609728f$export$c08559766941f856(listNode.querySelector('[data-index="0"]'));
    var listHeight = slideHeight * spec.slidesToShow;
    var currentSlide = spec.currentSlide === undefined ? spec.initialSlide : spec.currentSlide;
    if (spec.rtl && spec.currentSlide === undefined) currentSlide = slideCount - 1 - spec.initialSlide;
    var lazyLoadedList = spec.lazyLoadedList || [];
    var slidesToLoad = $e1b381ed4609728f$export$62701ea96990f316((0, $983350b7b3960a26$export$2e2bcd8739ae039)((0, $983350b7b3960a26$export$2e2bcd8739ae039)({}, spec), {}, {
        currentSlide: currentSlide,
        lazyLoadedList: lazyLoadedList
    }));
    lazyLoadedList = lazyLoadedList.concat(slidesToLoad);
    var state = {
        slideCount: slideCount,
        slideWidth: slideWidth,
        listWidth: listWidth,
        trackWidth: trackWidth,
        currentSlide: currentSlide,
        slideHeight: slideHeight,
        listHeight: listHeight,
        lazyLoadedList: lazyLoadedList
    };
    if (spec.autoplaying === null && spec.autoplay) state["autoplaying"] = "playing";
    return state;
};
var $e1b381ed4609728f$export$961f912fd58954b = function slideHandler(spec) {
    var waitForAnimate = spec.waitForAnimate, animating = spec.animating, fade = spec.fade, infinite = spec.infinite, index = spec.index, slideCount = spec.slideCount, lazyLoad = spec.lazyLoad, currentSlide = spec.currentSlide, centerMode = spec.centerMode, slidesToScroll = spec.slidesToScroll, slidesToShow = spec.slidesToShow, useCSS = spec.useCSS;
    var lazyLoadedList = spec.lazyLoadedList;
    if (waitForAnimate && animating) return {};
    var animationSlide = index, finalSlide, animationLeft, finalLeft;
    var state = {}, nextState = {};
    var targetSlide = infinite ? index : $e1b381ed4609728f$export$7d15b64cf5a3a4c4(index, 0, slideCount - 1);
    if (fade) {
        if (!infinite && (index < 0 || index >= slideCount)) return {};
        if (index < 0) animationSlide = index + slideCount;
        else if (index >= slideCount) animationSlide = index - slideCount;
        if (lazyLoad && lazyLoadedList.indexOf(animationSlide) < 0) lazyLoadedList = lazyLoadedList.concat(animationSlide);
        state = {
            animating: true,
            currentSlide: animationSlide,
            lazyLoadedList: lazyLoadedList,
            targetSlide: animationSlide
        };
        nextState = {
            animating: false,
            targetSlide: animationSlide
        };
    } else {
        finalSlide = animationSlide;
        if (animationSlide < 0) {
            finalSlide = animationSlide + slideCount;
            if (!infinite) finalSlide = 0;
            else if (slideCount % slidesToScroll !== 0) finalSlide = slideCount - slideCount % slidesToScroll;
        } else if (!$e1b381ed4609728f$export$30e977044f8f3618(spec) && animationSlide > currentSlide) animationSlide = finalSlide = currentSlide;
        else if (centerMode && animationSlide >= slideCount) {
            animationSlide = infinite ? slideCount : slideCount - 1;
            finalSlide = infinite ? 0 : slideCount - 1;
        } else if (animationSlide >= slideCount) {
            finalSlide = animationSlide - slideCount;
            if (!infinite) finalSlide = slideCount - slidesToShow;
            else if (slideCount % slidesToScroll !== 0) finalSlide = 0;
        }
        if (!infinite && animationSlide + slidesToShow >= slideCount) finalSlide = slideCount - slidesToShow;
        animationLeft = $e1b381ed4609728f$export$e6afb656f970c8d4((0, $983350b7b3960a26$export$2e2bcd8739ae039)((0, $983350b7b3960a26$export$2e2bcd8739ae039)({}, spec), {}, {
            slideIndex: animationSlide
        }));
        finalLeft = $e1b381ed4609728f$export$e6afb656f970c8d4((0, $983350b7b3960a26$export$2e2bcd8739ae039)((0, $983350b7b3960a26$export$2e2bcd8739ae039)({}, spec), {}, {
            slideIndex: finalSlide
        }));
        if (!infinite) {
            if (animationLeft === finalLeft) animationSlide = finalSlide;
            animationLeft = finalLeft;
        }
        if (lazyLoad) lazyLoadedList = lazyLoadedList.concat($e1b381ed4609728f$export$62701ea96990f316((0, $983350b7b3960a26$export$2e2bcd8739ae039)((0, $983350b7b3960a26$export$2e2bcd8739ae039)({}, spec), {}, {
            currentSlide: animationSlide
        })));
        if (!useCSS) state = {
            currentSlide: finalSlide,
            trackStyle: $e1b381ed4609728f$export$a56204438fe3ba9e((0, $983350b7b3960a26$export$2e2bcd8739ae039)((0, $983350b7b3960a26$export$2e2bcd8739ae039)({}, spec), {}, {
                left: finalLeft
            })),
            lazyLoadedList: lazyLoadedList,
            targetSlide: targetSlide
        };
        else {
            state = {
                animating: true,
                currentSlide: finalSlide,
                trackStyle: $e1b381ed4609728f$export$529c0c74aae30645((0, $983350b7b3960a26$export$2e2bcd8739ae039)((0, $983350b7b3960a26$export$2e2bcd8739ae039)({}, spec), {}, {
                    left: animationLeft
                })),
                lazyLoadedList: lazyLoadedList,
                targetSlide: targetSlide
            };
            nextState = {
                animating: false,
                currentSlide: finalSlide,
                trackStyle: $e1b381ed4609728f$export$a56204438fe3ba9e((0, $983350b7b3960a26$export$2e2bcd8739ae039)((0, $983350b7b3960a26$export$2e2bcd8739ae039)({}, spec), {}, {
                    left: finalLeft
                })),
                swipeLeft: null,
                targetSlide: targetSlide
            };
        }
    }
    return {
        state: state,
        nextState: nextState
    };
};
var $e1b381ed4609728f$export$2b178751aa586095 = function changeSlide(spec, options) {
    var indexOffset, previousInt, slideOffset, unevenOffset, targetSlide;
    var slidesToScroll = spec.slidesToScroll, slidesToShow = spec.slidesToShow, slideCount = spec.slideCount, currentSlide = spec.currentSlide, previousTargetSlide = spec.targetSlide, lazyLoad = spec.lazyLoad, infinite = spec.infinite;
    unevenOffset = slideCount % slidesToScroll !== 0;
    indexOffset = unevenOffset ? 0 : (slideCount - currentSlide) % slidesToScroll;
    if (options.message === "previous") {
        slideOffset = indexOffset === 0 ? slidesToScroll : slidesToShow - indexOffset;
        targetSlide = currentSlide - slideOffset;
        if (lazyLoad && !infinite) {
            previousInt = currentSlide - slideOffset;
            targetSlide = previousInt === -1 ? slideCount - 1 : previousInt;
        }
        if (!infinite) targetSlide = previousTargetSlide - slidesToScroll;
    } else if (options.message === "next") {
        slideOffset = indexOffset === 0 ? slidesToScroll : indexOffset;
        targetSlide = currentSlide + slideOffset;
        if (lazyLoad && !infinite) targetSlide = (currentSlide + slidesToScroll) % slideCount + indexOffset;
        if (!infinite) targetSlide = previousTargetSlide + slidesToScroll;
    } else if (options.message === "dots") // Click on dots
    targetSlide = options.index * options.slidesToScroll;
    else if (options.message === "children") {
        // Click on the slides
        targetSlide = options.index;
        if (infinite) {
            var direction = $e1b381ed4609728f$export$660692989fc3ca25((0, $983350b7b3960a26$export$2e2bcd8739ae039)((0, $983350b7b3960a26$export$2e2bcd8739ae039)({}, spec), {}, {
                targetSlide: targetSlide
            }));
            if (targetSlide > options.currentSlide && direction === "left") targetSlide = targetSlide - slideCount;
            else if (targetSlide < options.currentSlide && direction === "right") targetSlide = targetSlide + slideCount;
        }
    } else if (options.message === "index") targetSlide = Number(options.index);
    return targetSlide;
};
var $e1b381ed4609728f$export$53be3f01be2e49ac = function keyHandler(e, accessibility, rtl) {
    if (e.target.tagName.match("TEXTAREA|INPUT|SELECT") || !accessibility) return "";
    if (e.keyCode === 37) return rtl ? "next" : "previous";
    if (e.keyCode === 39) return rtl ? "previous" : "next";
    return "";
};
var $e1b381ed4609728f$export$517240397a2d6b8e = function swipeStart(e, swipe, draggable) {
    e.target.tagName === "IMG" && $e1b381ed4609728f$export$ed7b1178205ba7d(e);
    if (!swipe || !draggable && e.type.indexOf("mouse") !== -1) return "";
    return {
        dragging: true,
        touchObject: {
            startX: e.touches ? e.touches[0].pageX : e.clientX,
            startY: e.touches ? e.touches[0].pageY : e.clientY,
            curX: e.touches ? e.touches[0].pageX : e.clientX,
            curY: e.touches ? e.touches[0].pageY : e.clientY
        }
    };
};
var $e1b381ed4609728f$export$b6bbad7797799ea9 = function swipeMove(e, spec) {
    // spec also contains, trackRef and slideIndex
    var scrolling = spec.scrolling, animating = spec.animating, vertical = spec.vertical, swipeToSlide = spec.swipeToSlide, verticalSwiping = spec.verticalSwiping, rtl = spec.rtl, currentSlide = spec.currentSlide, edgeFriction = spec.edgeFriction, edgeDragged = spec.edgeDragged, onEdge = spec.onEdge, swiped = spec.swiped, swiping = spec.swiping, slideCount = spec.slideCount, slidesToScroll = spec.slidesToScroll, infinite = spec.infinite, touchObject = spec.touchObject, swipeEvent = spec.swipeEvent, listHeight = spec.listHeight, listWidth = spec.listWidth;
    if (scrolling) return;
    if (animating) return $e1b381ed4609728f$export$ed7b1178205ba7d(e);
    if (vertical && swipeToSlide && verticalSwiping) $e1b381ed4609728f$export$ed7b1178205ba7d(e);
    var swipeLeft, state = {};
    var curLeft = $e1b381ed4609728f$export$e6afb656f970c8d4(spec);
    touchObject.curX = e.touches ? e.touches[0].pageX : e.clientX;
    touchObject.curY = e.touches ? e.touches[0].pageY : e.clientY;
    touchObject.swipeLength = Math.round(Math.sqrt(Math.pow(touchObject.curX - touchObject.startX, 2)));
    var verticalSwipeLength = Math.round(Math.sqrt(Math.pow(touchObject.curY - touchObject.startY, 2)));
    if (!verticalSwiping && !swiping && verticalSwipeLength > 10) return {
        scrolling: true
    };
    if (verticalSwiping) touchObject.swipeLength = verticalSwipeLength;
    var positionOffset = (!rtl ? 1 : -1) * (touchObject.curX > touchObject.startX ? 1 : -1);
    if (verticalSwiping) positionOffset = touchObject.curY > touchObject.startY ? 1 : -1;
    var dotCount = Math.ceil(slideCount / slidesToScroll);
    var swipeDirection = $e1b381ed4609728f$export$67fc172604a155ba(spec.touchObject, verticalSwiping);
    var touchSwipeLength = touchObject.swipeLength;
    if (!infinite) {
        if (currentSlide === 0 && (swipeDirection === "right" || swipeDirection === "down") || currentSlide + 1 >= dotCount && (swipeDirection === "left" || swipeDirection === "up") || !$e1b381ed4609728f$export$30e977044f8f3618(spec) && (swipeDirection === "left" || swipeDirection === "up")) {
            touchSwipeLength = touchObject.swipeLength * edgeFriction;
            if (edgeDragged === false && onEdge) {
                onEdge(swipeDirection);
                state["edgeDragged"] = true;
            }
        }
    }
    if (!swiped && swipeEvent) {
        swipeEvent(swipeDirection);
        state["swiped"] = true;
    }
    if (!vertical) {
        if (!rtl) swipeLeft = curLeft + touchSwipeLength * positionOffset;
        else swipeLeft = curLeft - touchSwipeLength * positionOffset;
    } else swipeLeft = curLeft + touchSwipeLength * (listHeight / listWidth) * positionOffset;
    if (verticalSwiping) swipeLeft = curLeft + touchSwipeLength * positionOffset;
    state = (0, $983350b7b3960a26$export$2e2bcd8739ae039)((0, $983350b7b3960a26$export$2e2bcd8739ae039)({}, state), {}, {
        touchObject: touchObject,
        swipeLeft: swipeLeft,
        trackStyle: $e1b381ed4609728f$export$a56204438fe3ba9e((0, $983350b7b3960a26$export$2e2bcd8739ae039)((0, $983350b7b3960a26$export$2e2bcd8739ae039)({}, spec), {}, {
            left: swipeLeft
        }))
    });
    if (Math.abs(touchObject.curX - touchObject.startX) < Math.abs(touchObject.curY - touchObject.startY) * 0.8) return state;
    if (touchObject.swipeLength > 10) {
        state["swiping"] = true;
        $e1b381ed4609728f$export$ed7b1178205ba7d(e);
    }
    return state;
};
var $e1b381ed4609728f$export$a1cf77dc3a4b9ee0 = function swipeEnd(e, spec) {
    var dragging = spec.dragging, swipe = spec.swipe, touchObject = spec.touchObject, listWidth = spec.listWidth, touchThreshold = spec.touchThreshold, verticalSwiping = spec.verticalSwiping, listHeight = spec.listHeight, swipeToSlide = spec.swipeToSlide, scrolling = spec.scrolling, onSwipe = spec.onSwipe, targetSlide = spec.targetSlide, currentSlide = spec.currentSlide, infinite = spec.infinite;
    if (!dragging) {
        if (swipe) $e1b381ed4609728f$export$ed7b1178205ba7d(e);
        return {};
    }
    var minSwipe = verticalSwiping ? listHeight / touchThreshold : listWidth / touchThreshold;
    var swipeDirection = $e1b381ed4609728f$export$67fc172604a155ba(touchObject, verticalSwiping);
    // reset the state of touch related state variables.
    var state = {
        dragging: false,
        edgeDragged: false,
        scrolling: false,
        swiping: false,
        swiped: false,
        swipeLeft: null,
        touchObject: {}
    };
    if (scrolling) return state;
    if (!touchObject.swipeLength) return state;
    if (touchObject.swipeLength > minSwipe) {
        $e1b381ed4609728f$export$ed7b1178205ba7d(e);
        if (onSwipe) onSwipe(swipeDirection);
        var slideCount, newSlide;
        var activeSlide = infinite ? currentSlide : targetSlide;
        switch(swipeDirection){
            case "left":
            case "up":
                newSlide = activeSlide + $e1b381ed4609728f$export$d5dbde6ad0a0e1f2(spec);
                slideCount = swipeToSlide ? $e1b381ed4609728f$export$17fa202e6fecedb5(spec, newSlide) : newSlide;
                state["currentDirection"] = 0;
                break;
            case "right":
            case "down":
                newSlide = activeSlide - $e1b381ed4609728f$export$d5dbde6ad0a0e1f2(spec);
                slideCount = swipeToSlide ? $e1b381ed4609728f$export$17fa202e6fecedb5(spec, newSlide) : newSlide;
                state["currentDirection"] = 1;
                break;
            default:
                slideCount = activeSlide;
        }
        state["triggerSlideHandler"] = slideCount;
    } else {
        // Adjust the track back to it's original position.
        var currentLeft = $e1b381ed4609728f$export$e6afb656f970c8d4(spec);
        state["trackStyle"] = $e1b381ed4609728f$export$529c0c74aae30645((0, $983350b7b3960a26$export$2e2bcd8739ae039)((0, $983350b7b3960a26$export$2e2bcd8739ae039)({}, spec), {}, {
            left: currentLeft
        }));
    }
    return state;
};
var $e1b381ed4609728f$export$51be2376bcc08466 = function getNavigableIndexes(spec) {
    var max = spec.infinite ? spec.slideCount * 2 : spec.slideCount;
    var breakpoint = spec.infinite ? spec.slidesToShow * -1 : 0;
    var counter = spec.infinite ? spec.slidesToShow * -1 : 0;
    var indexes = [];
    while(breakpoint < max){
        indexes.push(breakpoint);
        breakpoint = counter + spec.slidesToScroll;
        counter += Math.min(spec.slidesToScroll, spec.slidesToShow);
    }
    return indexes;
};
var $e1b381ed4609728f$export$17fa202e6fecedb5 = function checkNavigable(spec, index) {
    var navigables = $e1b381ed4609728f$export$51be2376bcc08466(spec);
    var prevNavigable = 0;
    if (index > navigables[navigables.length - 1]) index = navigables[navigables.length - 1];
    else for(var n in navigables){
        if (index < navigables[n]) {
            index = prevNavigable;
            break;
        }
        prevNavigable = navigables[n];
    }
    return index;
};
var $e1b381ed4609728f$export$d5dbde6ad0a0e1f2 = function getSlideCount(spec) {
    var centerOffset = spec.centerMode ? spec.slideWidth * Math.floor(spec.slidesToShow / 2) : 0;
    if (spec.swipeToSlide) {
        var swipedSlide;
        var slickList = spec.listRef;
        var slides = slickList.querySelectorAll && slickList.querySelectorAll(".slick-slide") || [];
        Array.from(slides).every(function(slide) {
            if (!spec.vertical) {
                if (slide.offsetLeft - centerOffset + $e1b381ed4609728f$export$3c49c185de0c2bfc(slide) / 2 > spec.swipeLeft * -1) {
                    swipedSlide = slide;
                    return false;
                }
            } else if (slide.offsetTop + $e1b381ed4609728f$export$c08559766941f856(slide) / 2 > spec.swipeLeft * -1) {
                swipedSlide = slide;
                return false;
            }
            return true;
        });
        if (!swipedSlide) return 0;
        var currentIndex = spec.rtl === true ? spec.slideCount - spec.currentSlide : spec.currentSlide;
        var slidesTraversed = Math.abs(swipedSlide.dataset.index - currentIndex) || 1;
        return slidesTraversed;
    } else return spec.slidesToScroll;
};
var $e1b381ed4609728f$export$86da4920db51899b = function checkSpecKeys(spec, keysArray) {
    return(// eslint-disable-next-line no-prototype-builtins
    keysArray.reduce(function(value, key) {
        return value && spec.hasOwnProperty(key);
    }, true) ? null : console.error("Keys Missing:", spec));
};
var $e1b381ed4609728f$export$a56204438fe3ba9e = function getTrackCSS(spec) {
    $e1b381ed4609728f$export$86da4920db51899b(spec, [
        "left",
        "variableWidth",
        "slideCount",
        "slidesToShow",
        "slideWidth"
    ]);
    var trackWidth, trackHeight;
    var trackChildren = spec.slideCount + 2 * spec.slidesToShow;
    if (!spec.vertical) trackWidth = $e1b381ed4609728f$export$f865154a8ab21780(spec) * spec.slideWidth;
    else trackHeight = trackChildren * spec.slideHeight;
    var style = {
        opacity: 1,
        transition: "",
        WebkitTransition: ""
    };
    if (spec.useTransform) {
        var WebkitTransform = !spec.vertical ? "translate3d(" + spec.left + "px, 0px, 0px)" : "translate3d(0px, " + spec.left + "px, 0px)";
        var transform = !spec.vertical ? "translate3d(" + spec.left + "px, 0px, 0px)" : "translate3d(0px, " + spec.left + "px, 0px)";
        var msTransform = !spec.vertical ? "translateX(" + spec.left + "px)" : "translateY(" + spec.left + "px)";
        style = (0, $983350b7b3960a26$export$2e2bcd8739ae039)((0, $983350b7b3960a26$export$2e2bcd8739ae039)({}, style), {}, {
            WebkitTransform: WebkitTransform,
            transform: transform,
            msTransform: msTransform
        });
    } else if (spec.vertical) style["top"] = spec.left;
    else style["left"] = spec.left;
    if (spec.fade) style = {
        opacity: 1
    };
    if (trackWidth) style.width = trackWidth;
    if (trackHeight) style.height = trackHeight;
    // Fallback for IE8
    if (window && !window.addEventListener && window.attachEvent) {
        if (!spec.vertical) style.marginLeft = spec.left + "px";
        else style.marginTop = spec.left + "px";
    }
    return style;
};
var $e1b381ed4609728f$export$529c0c74aae30645 = function getTrackAnimateCSS(spec) {
    $e1b381ed4609728f$export$86da4920db51899b(spec, [
        "left",
        "variableWidth",
        "slideCount",
        "slidesToShow",
        "slideWidth",
        "speed",
        "cssEase"
    ]);
    var style = $e1b381ed4609728f$export$a56204438fe3ba9e(spec);
    // useCSS is true by default so it can be undefined
    if (spec.useTransform) {
        style.WebkitTransition = "-webkit-transform " + spec.speed + "ms " + spec.cssEase;
        style.transition = "transform " + spec.speed + "ms " + spec.cssEase;
    } else if (spec.vertical) style.transition = "top " + spec.speed + "ms " + spec.cssEase;
    else style.transition = "left " + spec.speed + "ms " + spec.cssEase;
    return style;
};
var $e1b381ed4609728f$export$e6afb656f970c8d4 = function getTrackLeft(spec) {
    if (spec.unslick) return 0;
    $e1b381ed4609728f$export$86da4920db51899b(spec, [
        "slideIndex",
        "trackRef",
        "infinite",
        "centerMode",
        "slideCount",
        "slidesToShow",
        "slidesToScroll",
        "slideWidth",
        "listWidth",
        "variableWidth",
        "slideHeight"
    ]);
    var slideIndex = spec.slideIndex, trackRef = spec.trackRef, infinite = spec.infinite, centerMode = spec.centerMode, slideCount = spec.slideCount, slidesToShow = spec.slidesToShow, slidesToScroll = spec.slidesToScroll, slideWidth = spec.slideWidth, listWidth = spec.listWidth, variableWidth = spec.variableWidth, slideHeight = spec.slideHeight, fade = spec.fade, vertical = spec.vertical;
    var slideOffset = 0;
    var targetLeft;
    var targetSlide;
    var verticalOffset = 0;
    if (fade || spec.slideCount === 1) return 0;
    var slidesToOffset = 0;
    if (infinite) {
        slidesToOffset = -$e1b381ed4609728f$export$b7c426bbf733f421(spec); // bring active slide to the beginning of visual area
        // if next scroll doesn't have enough children, just reach till the end of original slides instead of shifting slidesToScroll children
        if (slideCount % slidesToScroll !== 0 && slideIndex + slidesToScroll > slideCount) slidesToOffset = -(slideIndex > slideCount ? slidesToShow - (slideIndex - slideCount) : slideCount % slidesToScroll);
        // shift current slide to center of the frame
        if (centerMode) slidesToOffset += parseInt(slidesToShow / 2);
    } else {
        if (slideCount % slidesToScroll !== 0 && slideIndex + slidesToScroll > slideCount) slidesToOffset = slidesToShow - slideCount % slidesToScroll;
        if (centerMode) slidesToOffset = parseInt(slidesToShow / 2);
    }
    slideOffset = slidesToOffset * slideWidth;
    verticalOffset = slidesToOffset * slideHeight;
    if (!vertical) targetLeft = slideIndex * slideWidth * -1 + slideOffset;
    else targetLeft = slideIndex * slideHeight * -1 + verticalOffset;
    if (variableWidth === true) {
        var targetSlideIndex;
        var trackElem = trackRef && trackRef.node;
        targetSlideIndex = slideIndex + $e1b381ed4609728f$export$b7c426bbf733f421(spec);
        targetSlide = trackElem && trackElem.childNodes[targetSlideIndex];
        targetLeft = targetSlide ? targetSlide.offsetLeft * -1 : 0;
        if (centerMode === true) {
            targetSlideIndex = infinite ? slideIndex + $e1b381ed4609728f$export$b7c426bbf733f421(spec) : slideIndex;
            targetSlide = trackElem && trackElem.children[targetSlideIndex];
            targetLeft = 0;
            for(var slide = 0; slide < targetSlideIndex; slide++)targetLeft -= trackElem && trackElem.children[slide] && trackElem.children[slide].offsetWidth;
            targetLeft -= parseInt(spec.centerPadding);
            targetLeft += targetSlide && (listWidth - targetSlide.offsetWidth) / 2;
        }
    }
    return targetLeft;
};
var $e1b381ed4609728f$export$b7c426bbf733f421 = function getPreClones(spec) {
    if (spec.unslick || !spec.infinite) return 0;
    if (spec.variableWidth) return spec.slideCount;
    return spec.slidesToShow + (spec.centerMode ? 1 : 0);
};
var $e1b381ed4609728f$export$50a387a8fd3c60d = function getPostClones(spec) {
    if (spec.unslick || !spec.infinite) return 0;
    return spec.slideCount;
};
var $e1b381ed4609728f$export$f865154a8ab21780 = function getTotalSlides(spec) {
    return spec.slideCount === 1 ? 1 : $e1b381ed4609728f$export$b7c426bbf733f421(spec) + spec.slideCount + $e1b381ed4609728f$export$50a387a8fd3c60d(spec);
};
var $e1b381ed4609728f$export$660692989fc3ca25 = function siblingDirection(spec) {
    if (spec.targetSlide > spec.currentSlide) {
        if (spec.targetSlide > spec.currentSlide + $e1b381ed4609728f$export$10cb311a34b9e55b(spec)) return "left";
        return "right";
    } else {
        if (spec.targetSlide < spec.currentSlide - $e1b381ed4609728f$export$56584c3df96565e5(spec)) return "right";
        return "left";
    }
};
var $e1b381ed4609728f$export$10cb311a34b9e55b = function slidesOnRight(_ref) {
    var slidesToShow = _ref.slidesToShow, centerMode = _ref.centerMode, rtl = _ref.rtl, centerPadding = _ref.centerPadding;
    // returns no of slides on the right of active slide
    if (centerMode) {
        var right = (slidesToShow - 1) / 2 + 1;
        if (parseInt(centerPadding) > 0) right += 1;
        if (rtl && slidesToShow % 2 === 0) right += 1;
        return right;
    }
    if (rtl) return 0;
    return slidesToShow - 1;
};
var $e1b381ed4609728f$export$56584c3df96565e5 = function slidesOnLeft(_ref2) {
    var slidesToShow = _ref2.slidesToShow, centerMode = _ref2.centerMode, rtl = _ref2.rtl, centerPadding = _ref2.centerPadding;
    // returns no of slides on the left of active slide
    if (centerMode) {
        var left = (slidesToShow - 1) / 2 + 1;
        if (parseInt(centerPadding) > 0) left += 1;
        if (!rtl && slidesToShow % 2 === 0) left += 1;
        return left;
    }
    if (rtl) return slidesToShow - 1;
    return 0;
};
var $e1b381ed4609728f$export$71594e8a50f746f4 = function canUseDOM() {
    return !!(typeof window !== "undefined" && window.document && window.document.createElement);
};











var $acw62 = parcelRequire("acw62");


"use strict";
// given specifications/props for a slide, fetch all the classes that need to be applied to the slide
var $c54e460f3b42546f$var$getSlideClasses = function getSlideClasses(spec) {
    var slickActive, slickCenter, slickCloned;
    var centerOffset, index;
    if (spec.rtl) index = spec.slideCount - 1 - spec.index;
    else index = spec.index;
    slickCloned = index < 0 || index >= spec.slideCount;
    if (spec.centerMode) {
        centerOffset = Math.floor(spec.slidesToShow / 2);
        slickCenter = (index - spec.currentSlide) % spec.slideCount === 0;
        if (index > spec.currentSlide - centerOffset - 1 && index <= spec.currentSlide + centerOffset) slickActive = true;
    } else slickActive = spec.currentSlide <= index && index < spec.currentSlide + spec.slidesToShow;
    var focusedSlide;
    if (spec.targetSlide < 0) focusedSlide = spec.targetSlide + spec.slideCount;
    else if (spec.targetSlide >= spec.slideCount) focusedSlide = spec.targetSlide - spec.slideCount;
    else focusedSlide = spec.targetSlide;
    var slickCurrent = index === focusedSlide;
    return {
        "slick-slide": true,
        "slick-active": slickActive,
        "slick-center": slickCenter,
        "slick-cloned": slickCloned,
        "slick-current": slickCurrent // dubious in case of RTL
    };
};
var $c54e460f3b42546f$var$getSlideStyle = function getSlideStyle(spec) {
    var style = {};
    if (spec.variableWidth === undefined || spec.variableWidth === false) style.width = spec.slideWidth;
    if (spec.fade) {
        style.position = "relative";
        if (spec.vertical && spec.slideHeight) style.top = -spec.index * parseInt(spec.slideHeight);
        else style.left = -spec.index * parseInt(spec.slideWidth);
        style.opacity = spec.currentSlide === spec.index ? 1 : 0;
        if (spec.useCSS) style.transition = "opacity " + spec.speed + "ms " + spec.cssEase + ", " + "visibility " + spec.speed + "ms " + spec.cssEase;
    }
    return style;
};
var $c54e460f3b42546f$var$getKey = function getKey(child, fallbackKey) {
    return child.key + "-" + fallbackKey;
};
var $c54e460f3b42546f$var$renderSlides = function renderSlides(spec) {
    var key;
    var slides = [];
    var preCloneSlides = [];
    var postCloneSlides = [];
    var childrenCount = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Children.count(spec.children);
    var startIndex = (0, $e1b381ed4609728f$export$8931689ba1e6a542)(spec);
    var endIndex = (0, $e1b381ed4609728f$export$fc4e3e46621b5503)(spec);
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Children.forEach(spec.children, function(elem, index) {
        var child;
        var childOnClickOptions = {
            message: "children",
            index: index,
            slidesToScroll: spec.slidesToScroll,
            currentSlide: spec.currentSlide
        };
        // in case of lazyLoad, whether or not we want to fetch the slide
        if (!spec.lazyLoad || spec.lazyLoad && spec.lazyLoadedList.indexOf(index) >= 0) child = elem;
        else child = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", null);
        var childStyle = $c54e460f3b42546f$var$getSlideStyle((0, $983350b7b3960a26$export$2e2bcd8739ae039)((0, $983350b7b3960a26$export$2e2bcd8739ae039)({}, spec), {}, {
            index: index
        }));
        var slideClass = child.props.className || "";
        var slideClasses = $c54e460f3b42546f$var$getSlideClasses((0, $983350b7b3960a26$export$2e2bcd8739ae039)((0, $983350b7b3960a26$export$2e2bcd8739ae039)({}, spec), {}, {
            index: index
        }));
        // push a cloned element of the desired slide
        slides.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).cloneElement(child, {
            key: "original" + $c54e460f3b42546f$var$getKey(child, index),
            "data-index": index,
            className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))(slideClasses, slideClass),
            tabIndex: "-1",
            "aria-hidden": !slideClasses["slick-active"],
            style: (0, $983350b7b3960a26$export$2e2bcd8739ae039)((0, $983350b7b3960a26$export$2e2bcd8739ae039)({
                outline: "none"
            }, child.props.style || {}), childStyle),
            onClick: function onClick(e) {
                child.props && child.props.onClick && child.props.onClick(e);
                if (spec.focusOnSelect) spec.focusOnSelect(childOnClickOptions);
            }
        }));
        // if slide needs to be precloned or postcloned
        if (spec.infinite && spec.fade === false) {
            var preCloneNo = childrenCount - index;
            if (preCloneNo <= (0, $e1b381ed4609728f$export$b7c426bbf733f421)(spec) && childrenCount !== spec.slidesToShow) {
                key = -preCloneNo;
                if (key >= startIndex) child = elem;
                slideClasses = $c54e460f3b42546f$var$getSlideClasses((0, $983350b7b3960a26$export$2e2bcd8739ae039)((0, $983350b7b3960a26$export$2e2bcd8739ae039)({}, spec), {}, {
                    index: key
                }));
                preCloneSlides.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).cloneElement(child, {
                    key: "precloned" + $c54e460f3b42546f$var$getKey(child, key),
                    "data-index": key,
                    tabIndex: "-1",
                    className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))(slideClasses, slideClass),
                    "aria-hidden": !slideClasses["slick-active"],
                    style: (0, $983350b7b3960a26$export$2e2bcd8739ae039)((0, $983350b7b3960a26$export$2e2bcd8739ae039)({}, child.props.style || {}), childStyle),
                    onClick: function onClick(e) {
                        child.props && child.props.onClick && child.props.onClick(e);
                        if (spec.focusOnSelect) spec.focusOnSelect(childOnClickOptions);
                    }
                }));
            }
            if (childrenCount !== spec.slidesToShow) {
                key = childrenCount + index;
                if (key < endIndex) child = elem;
                slideClasses = $c54e460f3b42546f$var$getSlideClasses((0, $983350b7b3960a26$export$2e2bcd8739ae039)((0, $983350b7b3960a26$export$2e2bcd8739ae039)({}, spec), {}, {
                    index: key
                }));
                postCloneSlides.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).cloneElement(child, {
                    key: "postcloned" + $c54e460f3b42546f$var$getKey(child, key),
                    "data-index": key,
                    tabIndex: "-1",
                    className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))(slideClasses, slideClass),
                    "aria-hidden": !slideClasses["slick-active"],
                    style: (0, $983350b7b3960a26$export$2e2bcd8739ae039)((0, $983350b7b3960a26$export$2e2bcd8739ae039)({}, child.props.style || {}), childStyle),
                    onClick: function onClick(e) {
                        child.props && child.props.onClick && child.props.onClick(e);
                        if (spec.focusOnSelect) spec.focusOnSelect(childOnClickOptions);
                    }
                }));
            }
        }
    });
    if (spec.rtl) return preCloneSlides.concat(slides, postCloneSlides).reverse();
    else return preCloneSlides.concat(slides, postCloneSlides);
};
var $c54e460f3b42546f$export$13921ac0cc260818 = /*#__PURE__*/ function(_React$PureComponent) {
    (0, $0ed648f7bbaf3aff$export$2e2bcd8739ae039)(Track, _React$PureComponent);
    var _super = (0, $a76f20fb39fa9d46$export$2e2bcd8739ae039)(Track);
    function Track() {
        var _this;
        (0, $4d35ca0862055760$export$2e2bcd8739ae039)(this, Track);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)((0, $cd69a1d4c6210e44$export$2e2bcd8739ae039)(_this), "node", null);
        (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)((0, $cd69a1d4c6210e44$export$2e2bcd8739ae039)(_this), "handleRef", function(ref) {
            _this.node = ref;
        });
        return _this;
    }
    (0, $94019358ecbcf36b$export$2e2bcd8739ae039)(Track, [
        {
            key: "render",
            value: function render() {
                var slides = $c54e460f3b42546f$var$renderSlides(this.props);
                var _this$props = this.props, onMouseEnter = _this$props.onMouseEnter, onMouseOver = _this$props.onMouseOver, onMouseLeave = _this$props.onMouseLeave;
                var mouseEvents = {
                    onMouseEnter: onMouseEnter,
                    onMouseOver: onMouseOver,
                    onMouseLeave: onMouseLeave
                };
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({
                    ref: this.handleRef,
                    className: "slick-track",
                    style: this.props.trackStyle
                }, mouseEvents), slides);
            }
        }
    ]);
    return Track;
}((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).PureComponent);








var $acw62 = parcelRequire("acw62");


"use strict";
var $daf3c8f464a58d8b$var$getDotCount = function getDotCount(spec) {
    var dots;
    if (spec.infinite) dots = Math.ceil(spec.slideCount / spec.slidesToScroll);
    else dots = Math.ceil((spec.slideCount - spec.slidesToShow) / spec.slidesToScroll) + 1;
    return dots;
};
var $daf3c8f464a58d8b$export$8da50d3722682be0 = /*#__PURE__*/ function(_React$PureComponent) {
    (0, $0ed648f7bbaf3aff$export$2e2bcd8739ae039)(Dots, _React$PureComponent);
    var _super = (0, $a76f20fb39fa9d46$export$2e2bcd8739ae039)(Dots);
    function Dots() {
        (0, $4d35ca0862055760$export$2e2bcd8739ae039)(this, Dots);
        return _super.apply(this, arguments);
    }
    (0, $94019358ecbcf36b$export$2e2bcd8739ae039)(Dots, [
        {
            key: "clickHandler",
            value: function clickHandler(options, e) {
                // In Autoplay the focus stays on clicked button even after transition
                // to next slide. That only goes away by click somewhere outside
                e.preventDefault();
                this.props.clickHandler(options);
            }
        },
        {
            key: "render",
            value: function render() {
                var _this$props = this.props, onMouseEnter = _this$props.onMouseEnter, onMouseOver = _this$props.onMouseOver, onMouseLeave = _this$props.onMouseLeave, infinite = _this$props.infinite, slidesToScroll = _this$props.slidesToScroll, slidesToShow = _this$props.slidesToShow, slideCount = _this$props.slideCount, currentSlide = _this$props.currentSlide;
                var dotCount = $daf3c8f464a58d8b$var$getDotCount({
                    slideCount: slideCount,
                    slidesToScroll: slidesToScroll,
                    slidesToShow: slidesToShow,
                    infinite: infinite
                });
                var mouseEvents = {
                    onMouseEnter: onMouseEnter,
                    onMouseOver: onMouseOver,
                    onMouseLeave: onMouseLeave
                };
                var dots = [];
                for(var i = 0; i < dotCount; i++){
                    var _rightBound = (i + 1) * slidesToScroll - 1;
                    var rightBound = infinite ? _rightBound : (0, $e1b381ed4609728f$export$7d15b64cf5a3a4c4)(_rightBound, 0, slideCount - 1);
                    var _leftBound = rightBound - (slidesToScroll - 1);
                    var leftBound = infinite ? _leftBound : (0, $e1b381ed4609728f$export$7d15b64cf5a3a4c4)(_leftBound, 0, slideCount - 1);
                    var className = (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))({
                        "slick-active": infinite ? currentSlide >= leftBound && currentSlide <= rightBound : currentSlide === leftBound
                    });
                    var dotOptions = {
                        message: "dots",
                        index: i,
                        slidesToScroll: slidesToScroll,
                        currentSlide: currentSlide
                    };
                    var onClick = this.clickHandler.bind(this, dotOptions);
                    dots = dots.concat(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("li", {
                        key: i,
                        className: className
                    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).cloneElement(this.props.customPaging(i), {
                        onClick: onClick
                    })));
                }
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).cloneElement(this.props.appendDots(dots), (0, $983350b7b3960a26$export$2e2bcd8739ae039)({
                    className: this.props.dotsClass
                }, mouseEvents));
            }
        }
    ]);
    return Dots;
}((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).PureComponent);









var $acw62 = parcelRequire("acw62");


"use strict";
var $5033b9b74f3646cf$export$9c1f62bf9cbb344b = /*#__PURE__*/ function(_React$PureComponent) {
    (0, $0ed648f7bbaf3aff$export$2e2bcd8739ae039)(PrevArrow, _React$PureComponent);
    var _super = (0, $a76f20fb39fa9d46$export$2e2bcd8739ae039)(PrevArrow);
    function PrevArrow() {
        (0, $4d35ca0862055760$export$2e2bcd8739ae039)(this, PrevArrow);
        return _super.apply(this, arguments);
    }
    (0, $94019358ecbcf36b$export$2e2bcd8739ae039)(PrevArrow, [
        {
            key: "clickHandler",
            value: function clickHandler(options, e) {
                if (e) e.preventDefault();
                this.props.clickHandler(options, e);
            }
        },
        {
            key: "render",
            value: function render() {
                var prevClasses = {
                    "slick-arrow": true,
                    "slick-prev": true
                };
                var prevHandler = this.clickHandler.bind(this, {
                    message: "previous"
                });
                if (!this.props.infinite && (this.props.currentSlide === 0 || this.props.slideCount <= this.props.slidesToShow)) {
                    prevClasses["slick-disabled"] = true;
                    prevHandler = null;
                }
                var prevArrowProps = {
                    key: "0",
                    "data-role": "none",
                    className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))(prevClasses),
                    style: {
                        display: "block"
                    },
                    onClick: prevHandler
                };
                var customProps = {
                    currentSlide: this.props.currentSlide,
                    slideCount: this.props.slideCount
                };
                var prevArrow;
                if (this.props.prevArrow) prevArrow = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).cloneElement(this.props.prevArrow, (0, $983350b7b3960a26$export$2e2bcd8739ae039)((0, $983350b7b3960a26$export$2e2bcd8739ae039)({}, prevArrowProps), customProps));
                else prevArrow = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("button", (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({
                    key: "0",
                    type: "button"
                }, prevArrowProps), " ", "Previous");
                return prevArrow;
            }
        }
    ]);
    return PrevArrow;
}((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).PureComponent);
var $5033b9b74f3646cf$export$40405f1f48d6dbd = /*#__PURE__*/ function(_React$PureComponent2) {
    (0, $0ed648f7bbaf3aff$export$2e2bcd8739ae039)(NextArrow, _React$PureComponent2);
    var _super2 = (0, $a76f20fb39fa9d46$export$2e2bcd8739ae039)(NextArrow);
    function NextArrow() {
        (0, $4d35ca0862055760$export$2e2bcd8739ae039)(this, NextArrow);
        return _super2.apply(this, arguments);
    }
    (0, $94019358ecbcf36b$export$2e2bcd8739ae039)(NextArrow, [
        {
            key: "clickHandler",
            value: function clickHandler(options, e) {
                if (e) e.preventDefault();
                this.props.clickHandler(options, e);
            }
        },
        {
            key: "render",
            value: function render() {
                var nextClasses = {
                    "slick-arrow": true,
                    "slick-next": true
                };
                var nextHandler = this.clickHandler.bind(this, {
                    message: "next"
                });
                if (!(0, $e1b381ed4609728f$export$30e977044f8f3618)(this.props)) {
                    nextClasses["slick-disabled"] = true;
                    nextHandler = null;
                }
                var nextArrowProps = {
                    key: "1",
                    "data-role": "none",
                    className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))(nextClasses),
                    style: {
                        display: "block"
                    },
                    onClick: nextHandler
                };
                var customProps = {
                    currentSlide: this.props.currentSlide,
                    slideCount: this.props.slideCount
                };
                var nextArrow;
                if (this.props.nextArrow) nextArrow = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).cloneElement(this.props.nextArrow, (0, $983350b7b3960a26$export$2e2bcd8739ae039)((0, $983350b7b3960a26$export$2e2bcd8739ae039)({}, nextArrowProps), customProps));
                else nextArrow = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("button", (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({
                    key: "1",
                    type: "button"
                }, nextArrowProps), " ", "Next");
                return nextArrow;
            }
        }
    ]);
    return NextArrow;
}((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).PureComponent);


/**
 * A collection of shims that provide minimal functionality of the ES6 collections.
 *
 * These implementations are not meant to be used outside of the ResizeObserver
 * modules as they cover only a limited range of use cases.
 */ /* eslint-disable require-jsdoc, valid-jsdoc */ var $87c2a74187854fda$var$MapShim = function() {
    if (typeof Map !== "undefined") return Map;
    /**
     * Returns index in provided array that matches the specified key.
     *
     * @param {Array<Array>} arr
     * @param {*} key
     * @returns {number}
     */ function getIndex(arr, key) {
        var result = -1;
        arr.some(function(entry, index) {
            if (entry[0] === key) {
                result = index;
                return true;
            }
            return false;
        });
        return result;
    }
    return /** @class */ function() {
        function class_1() {
            this.__entries__ = [];
        }
        Object.defineProperty(class_1.prototype, "size", {
            /**
             * @returns {boolean}
             */ get: function() {
                return this.__entries__.length;
            },
            enumerable: true,
            configurable: true
        });
        /**
         * @param {*} key
         * @returns {*}
         */ class_1.prototype.get = function(key) {
            var index = getIndex(this.__entries__, key);
            var entry = this.__entries__[index];
            return entry && entry[1];
        };
        /**
         * @param {*} key
         * @param {*} value
         * @returns {void}
         */ class_1.prototype.set = function(key, value) {
            var index = getIndex(this.__entries__, key);
            if (~index) this.__entries__[index][1] = value;
            else this.__entries__.push([
                key,
                value
            ]);
        };
        /**
         * @param {*} key
         * @returns {void}
         */ class_1.prototype.delete = function(key) {
            var entries = this.__entries__;
            var index = getIndex(entries, key);
            if (~index) entries.splice(index, 1);
        };
        /**
         * @param {*} key
         * @returns {void}
         */ class_1.prototype.has = function(key) {
            return !!~getIndex(this.__entries__, key);
        };
        /**
         * @returns {void}
         */ class_1.prototype.clear = function() {
            this.__entries__.splice(0);
        };
        /**
         * @param {Function} callback
         * @param {*} [ctx=null]
         * @returns {void}
         */ class_1.prototype.forEach = function(callback, ctx) {
            if (ctx === void 0) ctx = null;
            for(var _i = 0, _a = this.__entries__; _i < _a.length; _i++){
                var entry = _a[_i];
                callback.call(ctx, entry[1], entry[0]);
            }
        };
        return class_1;
    }();
}();
/**
 * Detects whether window and document objects are available in current environment.
 */ var $87c2a74187854fda$var$isBrowser = typeof window !== "undefined" && typeof document !== "undefined" && window.document === document;
// Returns global object of a current environment.
var $87c2a74187854fda$var$global$1 = function() {
    if (typeof $parcel$global !== "undefined" && $parcel$global.Math === Math) return $parcel$global;
    if (typeof self !== "undefined" && self.Math === Math) return self;
    if (typeof window !== "undefined" && window.Math === Math) return window;
    // eslint-disable-next-line no-new-func
    return Function("return this")();
}();
/**
 * A shim for the requestAnimationFrame which falls back to the setTimeout if
 * first one is not supported.
 *
 * @returns {number} Requests' identifier.
 */ var $87c2a74187854fda$var$requestAnimationFrame$1 = function() {
    if (typeof requestAnimationFrame === "function") // It's required to use a bounded function because IE sometimes throws
    // an "Invalid calling object" error if rAF is invoked without the global
    // object on the left hand side.
    return requestAnimationFrame.bind($87c2a74187854fda$var$global$1);
    return function(callback) {
        return setTimeout(function() {
            return callback(Date.now());
        }, 1000 / 60);
    };
}();
// Defines minimum timeout before adding a trailing call.
var $87c2a74187854fda$var$trailingTimeout = 2;
/**
 * Creates a wrapper function which ensures that provided callback will be
 * invoked only once during the specified delay period.
 *
 * @param {Function} callback - Function to be invoked after the delay period.
 * @param {number} delay - Delay after which to invoke callback.
 * @returns {Function}
 */ function $87c2a74187854fda$var$throttle(callback, delay) {
    var leadingCall = false, trailingCall = false, lastCallTime = 0;
    /**
     * Invokes the original callback function and schedules new invocation if
     * the "proxy" was called during current request.
     *
     * @returns {void}
     */ function resolvePending() {
        if (leadingCall) {
            leadingCall = false;
            callback();
        }
        if (trailingCall) proxy();
    }
    /**
     * Callback invoked after the specified delay. It will further postpone
     * invocation of the original function delegating it to the
     * requestAnimationFrame.
     *
     * @returns {void}
     */ function timeoutCallback() {
        $87c2a74187854fda$var$requestAnimationFrame$1(resolvePending);
    }
    /**
     * Schedules invocation of the original function.
     *
     * @returns {void}
     */ function proxy() {
        var timeStamp = Date.now();
        if (leadingCall) {
            // Reject immediately following calls.
            if (timeStamp - lastCallTime < $87c2a74187854fda$var$trailingTimeout) return;
            // Schedule new call to be in invoked when the pending one is resolved.
            // This is important for "transitions" which never actually start
            // immediately so there is a chance that we might miss one if change
            // happens amids the pending invocation.
            trailingCall = true;
        } else {
            leadingCall = true;
            trailingCall = false;
            setTimeout(timeoutCallback, delay);
        }
        lastCallTime = timeStamp;
    }
    return proxy;
}
// Minimum delay before invoking the update of observers.
var $87c2a74187854fda$var$REFRESH_DELAY = 20;
// A list of substrings of CSS properties used to find transition events that
// might affect dimensions of observed elements.
var $87c2a74187854fda$var$transitionKeys = [
    "top",
    "right",
    "bottom",
    "left",
    "width",
    "height",
    "size",
    "weight"
];
// Check if MutationObserver is available.
var $87c2a74187854fda$var$mutationObserverSupported = typeof MutationObserver !== "undefined";
/**
 * Singleton controller class which handles updates of ResizeObserver instances.
 */ var $87c2a74187854fda$var$ResizeObserverController = /** @class */ function() {
    /**
     * Creates a new instance of ResizeObserverController.
     *
     * @private
     */ function ResizeObserverController() {
        /**
         * Indicates whether DOM listeners have been added.
         *
         * @private {boolean}
         */ this.connected_ = false;
        /**
         * Tells that controller has subscribed for Mutation Events.
         *
         * @private {boolean}
         */ this.mutationEventsAdded_ = false;
        /**
         * Keeps reference to the instance of MutationObserver.
         *
         * @private {MutationObserver}
         */ this.mutationsObserver_ = null;
        /**
         * A list of connected observers.
         *
         * @private {Array<ResizeObserverSPI>}
         */ this.observers_ = [];
        this.onTransitionEnd_ = this.onTransitionEnd_.bind(this);
        this.refresh = $87c2a74187854fda$var$throttle(this.refresh.bind(this), $87c2a74187854fda$var$REFRESH_DELAY);
    }
    /**
     * Adds observer to observers list.
     *
     * @param {ResizeObserverSPI} observer - Observer to be added.
     * @returns {void}
     */ ResizeObserverController.prototype.addObserver = function(observer) {
        if (!~this.observers_.indexOf(observer)) this.observers_.push(observer);
        // Add listeners if they haven't been added yet.
        if (!this.connected_) this.connect_();
    };
    /**
     * Removes observer from observers list.
     *
     * @param {ResizeObserverSPI} observer - Observer to be removed.
     * @returns {void}
     */ ResizeObserverController.prototype.removeObserver = function(observer) {
        var observers = this.observers_;
        var index = observers.indexOf(observer);
        // Remove observer if it's present in registry.
        if (~index) observers.splice(index, 1);
        // Remove listeners if controller has no connected observers.
        if (!observers.length && this.connected_) this.disconnect_();
    };
    /**
     * Invokes the update of observers. It will continue running updates insofar
     * it detects changes.
     *
     * @returns {void}
     */ ResizeObserverController.prototype.refresh = function() {
        var changesDetected = this.updateObservers_();
        // Continue running updates if changes have been detected as there might
        // be future ones caused by CSS transitions.
        if (changesDetected) this.refresh();
    };
    /**
     * Updates every observer from observers list and notifies them of queued
     * entries.
     *
     * @private
     * @returns {boolean} Returns "true" if any observer has detected changes in
     *      dimensions of it's elements.
     */ ResizeObserverController.prototype.updateObservers_ = function() {
        // Collect observers that have active observations.
        var activeObservers = this.observers_.filter(function(observer) {
            return observer.gatherActive(), observer.hasActive();
        });
        // Deliver notifications in a separate cycle in order to avoid any
        // collisions between observers, e.g. when multiple instances of
        // ResizeObserver are tracking the same element and the callback of one
        // of them changes content dimensions of the observed target. Sometimes
        // this may result in notifications being blocked for the rest of observers.
        activeObservers.forEach(function(observer) {
            return observer.broadcastActive();
        });
        return activeObservers.length > 0;
    };
    /**
     * Initializes DOM listeners.
     *
     * @private
     * @returns {void}
     */ ResizeObserverController.prototype.connect_ = function() {
        // Do nothing if running in a non-browser environment or if listeners
        // have been already added.
        if (!$87c2a74187854fda$var$isBrowser || this.connected_) return;
        // Subscription to the "Transitionend" event is used as a workaround for
        // delayed transitions. This way it's possible to capture at least the
        // final state of an element.
        document.addEventListener("transitionend", this.onTransitionEnd_);
        window.addEventListener("resize", this.refresh);
        if ($87c2a74187854fda$var$mutationObserverSupported) {
            this.mutationsObserver_ = new MutationObserver(this.refresh);
            this.mutationsObserver_.observe(document, {
                attributes: true,
                childList: true,
                characterData: true,
                subtree: true
            });
        } else {
            document.addEventListener("DOMSubtreeModified", this.refresh);
            this.mutationEventsAdded_ = true;
        }
        this.connected_ = true;
    };
    /**
     * Removes DOM listeners.
     *
     * @private
     * @returns {void}
     */ ResizeObserverController.prototype.disconnect_ = function() {
        // Do nothing if running in a non-browser environment or if listeners
        // have been already removed.
        if (!$87c2a74187854fda$var$isBrowser || !this.connected_) return;
        document.removeEventListener("transitionend", this.onTransitionEnd_);
        window.removeEventListener("resize", this.refresh);
        if (this.mutationsObserver_) this.mutationsObserver_.disconnect();
        if (this.mutationEventsAdded_) document.removeEventListener("DOMSubtreeModified", this.refresh);
        this.mutationsObserver_ = null;
        this.mutationEventsAdded_ = false;
        this.connected_ = false;
    };
    /**
     * "Transitionend" event handler.
     *
     * @private
     * @param {TransitionEvent} event
     * @returns {void}
     */ ResizeObserverController.prototype.onTransitionEnd_ = function(_a) {
        var _b = _a.propertyName, propertyName = _b === void 0 ? "" : _b;
        // Detect whether transition may affect dimensions of an element.
        var isReflowProperty = $87c2a74187854fda$var$transitionKeys.some(function(key) {
            return !!~propertyName.indexOf(key);
        });
        if (isReflowProperty) this.refresh();
    };
    /**
     * Returns instance of the ResizeObserverController.
     *
     * @returns {ResizeObserverController}
     */ ResizeObserverController.getInstance = function() {
        if (!this.instance_) this.instance_ = new ResizeObserverController();
        return this.instance_;
    };
    /**
     * Holds reference to the controller's instance.
     *
     * @private {ResizeObserverController}
     */ ResizeObserverController.instance_ = null;
    return ResizeObserverController;
}();
/**
 * Defines non-writable/enumerable properties of the provided target object.
 *
 * @param {Object} target - Object for which to define properties.
 * @param {Object} props - Properties to be defined.
 * @returns {Object} Target object.
 */ var $87c2a74187854fda$var$defineConfigurable = function(target, props) {
    for(var _i = 0, _a = Object.keys(props); _i < _a.length; _i++){
        var key = _a[_i];
        Object.defineProperty(target, key, {
            value: props[key],
            enumerable: false,
            writable: false,
            configurable: true
        });
    }
    return target;
};
/**
 * Returns the global object associated with provided element.
 *
 * @param {Object} target
 * @returns {Object}
 */ var $87c2a74187854fda$var$getWindowOf = function(target) {
    // Assume that the element is an instance of Node, which means that it
    // has the "ownerDocument" property from which we can retrieve a
    // corresponding global object.
    var ownerGlobal = target && target.ownerDocument && target.ownerDocument.defaultView;
    // Return the local global object if it's not possible extract one from
    // provided element.
    return ownerGlobal || $87c2a74187854fda$var$global$1;
};
// Placeholder of an empty content rectangle.
var $87c2a74187854fda$var$emptyRect = $87c2a74187854fda$var$createRectInit(0, 0, 0, 0);
/**
 * Converts provided string to a number.
 *
 * @param {number|string} value
 * @returns {number}
 */ function $87c2a74187854fda$var$toFloat(value) {
    return parseFloat(value) || 0;
}
/**
 * Extracts borders size from provided styles.
 *
 * @param {CSSStyleDeclaration} styles
 * @param {...string} positions - Borders positions (top, right, ...)
 * @returns {number}
 */ function $87c2a74187854fda$var$getBordersSize(styles) {
    var positions = [];
    for(var _i = 1; _i < arguments.length; _i++)positions[_i - 1] = arguments[_i];
    return positions.reduce(function(size, position) {
        var value = styles["border-" + position + "-width"];
        return size + $87c2a74187854fda$var$toFloat(value);
    }, 0);
}
/**
 * Extracts paddings sizes from provided styles.
 *
 * @param {CSSStyleDeclaration} styles
 * @returns {Object} Paddings box.
 */ function $87c2a74187854fda$var$getPaddings(styles) {
    var positions = [
        "top",
        "right",
        "bottom",
        "left"
    ];
    var paddings = {};
    for(var _i = 0, positions_1 = positions; _i < positions_1.length; _i++){
        var position = positions_1[_i];
        var value = styles["padding-" + position];
        paddings[position] = $87c2a74187854fda$var$toFloat(value);
    }
    return paddings;
}
/**
 * Calculates content rectangle of provided SVG element.
 *
 * @param {SVGGraphicsElement} target - Element content rectangle of which needs
 *      to be calculated.
 * @returns {DOMRectInit}
 */ function $87c2a74187854fda$var$getSVGContentRect(target) {
    var bbox = target.getBBox();
    return $87c2a74187854fda$var$createRectInit(0, 0, bbox.width, bbox.height);
}
/**
 * Calculates content rectangle of provided HTMLElement.
 *
 * @param {HTMLElement} target - Element for which to calculate the content rectangle.
 * @returns {DOMRectInit}
 */ function $87c2a74187854fda$var$getHTMLElementContentRect(target) {
    // Client width & height properties can't be
    // used exclusively as they provide rounded values.
    var clientWidth = target.clientWidth, clientHeight = target.clientHeight;
    // By this condition we can catch all non-replaced inline, hidden and
    // detached elements. Though elements with width & height properties less
    // than 0.5 will be discarded as well.
    //
    // Without it we would need to implement separate methods for each of
    // those cases and it's not possible to perform a precise and performance
    // effective test for hidden elements. E.g. even jQuery's ':visible' filter
    // gives wrong results for elements with width & height less than 0.5.
    if (!clientWidth && !clientHeight) return $87c2a74187854fda$var$emptyRect;
    var styles = $87c2a74187854fda$var$getWindowOf(target).getComputedStyle(target);
    var paddings = $87c2a74187854fda$var$getPaddings(styles);
    var horizPad = paddings.left + paddings.right;
    var vertPad = paddings.top + paddings.bottom;
    // Computed styles of width & height are being used because they are the
    // only dimensions available to JS that contain non-rounded values. It could
    // be possible to utilize the getBoundingClientRect if only it's data wasn't
    // affected by CSS transformations let alone paddings, borders and scroll bars.
    var width = $87c2a74187854fda$var$toFloat(styles.width), height = $87c2a74187854fda$var$toFloat(styles.height);
    // Width & height include paddings and borders when the 'border-box' box
    // model is applied (except for IE).
    if (styles.boxSizing === "border-box") {
        // Following conditions are required to handle Internet Explorer which
        // doesn't include paddings and borders to computed CSS dimensions.
        //
        // We can say that if CSS dimensions + paddings are equal to the "client"
        // properties then it's either IE, and thus we don't need to subtract
        // anything, or an element merely doesn't have paddings/borders styles.
        if (Math.round(width + horizPad) !== clientWidth) width -= $87c2a74187854fda$var$getBordersSize(styles, "left", "right") + horizPad;
        if (Math.round(height + vertPad) !== clientHeight) height -= $87c2a74187854fda$var$getBordersSize(styles, "top", "bottom") + vertPad;
    }
    // Following steps can't be applied to the document's root element as its
    // client[Width/Height] properties represent viewport area of the window.
    // Besides, it's as well not necessary as the <html> itself neither has
    // rendered scroll bars nor it can be clipped.
    if (!$87c2a74187854fda$var$isDocumentElement(target)) {
        // In some browsers (only in Firefox, actually) CSS width & height
        // include scroll bars size which can be removed at this step as scroll
        // bars are the only difference between rounded dimensions + paddings
        // and "client" properties, though that is not always true in Chrome.
        var vertScrollbar = Math.round(width + horizPad) - clientWidth;
        var horizScrollbar = Math.round(height + vertPad) - clientHeight;
        // Chrome has a rather weird rounding of "client" properties.
        // E.g. for an element with content width of 314.2px it sometimes gives
        // the client width of 315px and for the width of 314.7px it may give
        // 314px. And it doesn't happen all the time. So just ignore this delta
        // as a non-relevant.
        if (Math.abs(vertScrollbar) !== 1) width -= vertScrollbar;
        if (Math.abs(horizScrollbar) !== 1) height -= horizScrollbar;
    }
    return $87c2a74187854fda$var$createRectInit(paddings.left, paddings.top, width, height);
}
/**
 * Checks whether provided element is an instance of the SVGGraphicsElement.
 *
 * @param {Element} target - Element to be checked.
 * @returns {boolean}
 */ var $87c2a74187854fda$var$isSVGGraphicsElement = function() {
    // Some browsers, namely IE and Edge, don't have the SVGGraphicsElement
    // interface.
    if (typeof SVGGraphicsElement !== "undefined") return function(target) {
        return target instanceof $87c2a74187854fda$var$getWindowOf(target).SVGGraphicsElement;
    };
    // If it's so, then check that element is at least an instance of the
    // SVGElement and that it has the "getBBox" method.
    // eslint-disable-next-line no-extra-parens
    return function(target) {
        return target instanceof $87c2a74187854fda$var$getWindowOf(target).SVGElement && typeof target.getBBox === "function";
    };
}();
/**
 * Checks whether provided element is a document element (<html>).
 *
 * @param {Element} target - Element to be checked.
 * @returns {boolean}
 */ function $87c2a74187854fda$var$isDocumentElement(target) {
    return target === $87c2a74187854fda$var$getWindowOf(target).document.documentElement;
}
/**
 * Calculates an appropriate content rectangle for provided html or svg element.
 *
 * @param {Element} target - Element content rectangle of which needs to be calculated.
 * @returns {DOMRectInit}
 */ function $87c2a74187854fda$var$getContentRect(target) {
    if (!$87c2a74187854fda$var$isBrowser) return $87c2a74187854fda$var$emptyRect;
    if ($87c2a74187854fda$var$isSVGGraphicsElement(target)) return $87c2a74187854fda$var$getSVGContentRect(target);
    return $87c2a74187854fda$var$getHTMLElementContentRect(target);
}
/**
 * Creates rectangle with an interface of the DOMRectReadOnly.
 * Spec: https://drafts.fxtf.org/geometry/#domrectreadonly
 *
 * @param {DOMRectInit} rectInit - Object with rectangle's x/y coordinates and dimensions.
 * @returns {DOMRectReadOnly}
 */ function $87c2a74187854fda$var$createReadOnlyRect(_a) {
    var x = _a.x, y = _a.y, width = _a.width, height = _a.height;
    // If DOMRectReadOnly is available use it as a prototype for the rectangle.
    var Constr = typeof DOMRectReadOnly !== "undefined" ? DOMRectReadOnly : Object;
    var rect = Object.create(Constr.prototype);
    // Rectangle's properties are not writable and non-enumerable.
    $87c2a74187854fda$var$defineConfigurable(rect, {
        x: x,
        y: y,
        width: width,
        height: height,
        top: y,
        right: x + width,
        bottom: height + y,
        left: x
    });
    return rect;
}
/**
 * Creates DOMRectInit object based on the provided dimensions and the x/y coordinates.
 * Spec: https://drafts.fxtf.org/geometry/#dictdef-domrectinit
 *
 * @param {number} x - X coordinate.
 * @param {number} y - Y coordinate.
 * @param {number} width - Rectangle's width.
 * @param {number} height - Rectangle's height.
 * @returns {DOMRectInit}
 */ function $87c2a74187854fda$var$createRectInit(x, y, width, height) {
    return {
        x: x,
        y: y,
        width: width,
        height: height
    };
}
/**
 * Class that is responsible for computations of the content rectangle of
 * provided DOM element and for keeping track of it's changes.
 */ var $87c2a74187854fda$var$ResizeObservation = /** @class */ function() {
    /**
     * Creates an instance of ResizeObservation.
     *
     * @param {Element} target - Element to be observed.
     */ function ResizeObservation(target) {
        /**
         * Broadcasted width of content rectangle.
         *
         * @type {number}
         */ this.broadcastWidth = 0;
        /**
         * Broadcasted height of content rectangle.
         *
         * @type {number}
         */ this.broadcastHeight = 0;
        /**
         * Reference to the last observed content rectangle.
         *
         * @private {DOMRectInit}
         */ this.contentRect_ = $87c2a74187854fda$var$createRectInit(0, 0, 0, 0);
        this.target = target;
    }
    /**
     * Updates content rectangle and tells whether it's width or height properties
     * have changed since the last broadcast.
     *
     * @returns {boolean}
     */ ResizeObservation.prototype.isActive = function() {
        var rect = $87c2a74187854fda$var$getContentRect(this.target);
        this.contentRect_ = rect;
        return rect.width !== this.broadcastWidth || rect.height !== this.broadcastHeight;
    };
    /**
     * Updates 'broadcastWidth' and 'broadcastHeight' properties with a data
     * from the corresponding properties of the last observed content rectangle.
     *
     * @returns {DOMRectInit} Last observed content rectangle.
     */ ResizeObservation.prototype.broadcastRect = function() {
        var rect = this.contentRect_;
        this.broadcastWidth = rect.width;
        this.broadcastHeight = rect.height;
        return rect;
    };
    return ResizeObservation;
}();
var $87c2a74187854fda$var$ResizeObserverEntry = /** @class */ function() {
    /**
     * Creates an instance of ResizeObserverEntry.
     *
     * @param {Element} target - Element that is being observed.
     * @param {DOMRectInit} rectInit - Data of the element's content rectangle.
     */ function ResizeObserverEntry(target, rectInit) {
        var contentRect = $87c2a74187854fda$var$createReadOnlyRect(rectInit);
        // According to the specification following properties are not writable
        // and are also not enumerable in the native implementation.
        //
        // Property accessors are not being used as they'd require to define a
        // private WeakMap storage which may cause memory leaks in browsers that
        // don't support this type of collections.
        $87c2a74187854fda$var$defineConfigurable(this, {
            target: target,
            contentRect: contentRect
        });
    }
    return ResizeObserverEntry;
}();
var $87c2a74187854fda$var$ResizeObserverSPI = /** @class */ function() {
    /**
     * Creates a new instance of ResizeObserver.
     *
     * @param {ResizeObserverCallback} callback - Callback function that is invoked
     *      when one of the observed elements changes it's content dimensions.
     * @param {ResizeObserverController} controller - Controller instance which
     *      is responsible for the updates of observer.
     * @param {ResizeObserver} callbackCtx - Reference to the public
     *      ResizeObserver instance which will be passed to callback function.
     */ function ResizeObserverSPI(callback, controller, callbackCtx) {
        /**
         * Collection of resize observations that have detected changes in dimensions
         * of elements.
         *
         * @private {Array<ResizeObservation>}
         */ this.activeObservations_ = [];
        /**
         * Registry of the ResizeObservation instances.
         *
         * @private {Map<Element, ResizeObservation>}
         */ this.observations_ = new $87c2a74187854fda$var$MapShim();
        if (typeof callback !== "function") throw new TypeError("The callback provided as parameter 1 is not a function.");
        this.callback_ = callback;
        this.controller_ = controller;
        this.callbackCtx_ = callbackCtx;
    }
    /**
     * Starts observing provided element.
     *
     * @param {Element} target - Element to be observed.
     * @returns {void}
     */ ResizeObserverSPI.prototype.observe = function(target) {
        if (!arguments.length) throw new TypeError("1 argument required, but only 0 present.");
        // Do nothing if current environment doesn't have the Element interface.
        if (typeof Element === "undefined" || !(Element instanceof Object)) return;
        if (!(target instanceof $87c2a74187854fda$var$getWindowOf(target).Element)) throw new TypeError('parameter 1 is not of type "Element".');
        var observations = this.observations_;
        // Do nothing if element is already being observed.
        if (observations.has(target)) return;
        observations.set(target, new $87c2a74187854fda$var$ResizeObservation(target));
        this.controller_.addObserver(this);
        // Force the update of observations.
        this.controller_.refresh();
    };
    /**
     * Stops observing provided element.
     *
     * @param {Element} target - Element to stop observing.
     * @returns {void}
     */ ResizeObserverSPI.prototype.unobserve = function(target) {
        if (!arguments.length) throw new TypeError("1 argument required, but only 0 present.");
        // Do nothing if current environment doesn't have the Element interface.
        if (typeof Element === "undefined" || !(Element instanceof Object)) return;
        if (!(target instanceof $87c2a74187854fda$var$getWindowOf(target).Element)) throw new TypeError('parameter 1 is not of type "Element".');
        var observations = this.observations_;
        // Do nothing if element is not being observed.
        if (!observations.has(target)) return;
        observations.delete(target);
        if (!observations.size) this.controller_.removeObserver(this);
    };
    /**
     * Stops observing all elements.
     *
     * @returns {void}
     */ ResizeObserverSPI.prototype.disconnect = function() {
        this.clearActive();
        this.observations_.clear();
        this.controller_.removeObserver(this);
    };
    /**
     * Collects observation instances the associated element of which has changed
     * it's content rectangle.
     *
     * @returns {void}
     */ ResizeObserverSPI.prototype.gatherActive = function() {
        var _this = this;
        this.clearActive();
        this.observations_.forEach(function(observation) {
            if (observation.isActive()) _this.activeObservations_.push(observation);
        });
    };
    /**
     * Invokes initial callback function with a list of ResizeObserverEntry
     * instances collected from active resize observations.
     *
     * @returns {void}
     */ ResizeObserverSPI.prototype.broadcastActive = function() {
        // Do nothing if observer doesn't have active observations.
        if (!this.hasActive()) return;
        var ctx = this.callbackCtx_;
        // Create ResizeObserverEntry instance for every active observation.
        var entries = this.activeObservations_.map(function(observation) {
            return new $87c2a74187854fda$var$ResizeObserverEntry(observation.target, observation.broadcastRect());
        });
        this.callback_.call(ctx, entries, ctx);
        this.clearActive();
    };
    /**
     * Clears the collection of active observations.
     *
     * @returns {void}
     */ ResizeObserverSPI.prototype.clearActive = function() {
        this.activeObservations_.splice(0);
    };
    /**
     * Tells whether observer has active observations.
     *
     * @returns {boolean}
     */ ResizeObserverSPI.prototype.hasActive = function() {
        return this.activeObservations_.length > 0;
    };
    return ResizeObserverSPI;
}();
// Registry of internal observers. If WeakMap is not available use current shim
// for the Map collection as it has all required methods and because WeakMap
// can't be fully polyfilled anyway.
var $87c2a74187854fda$var$observers = typeof WeakMap !== "undefined" ? new WeakMap() : new $87c2a74187854fda$var$MapShim();
/**
 * ResizeObserver API. Encapsulates the ResizeObserver SPI implementation
 * exposing only those methods and properties that are defined in the spec.
 */ var $87c2a74187854fda$var$ResizeObserver = /** @class */ function() {
    /**
     * Creates a new instance of ResizeObserver.
     *
     * @param {ResizeObserverCallback} callback - Callback that is invoked when
     *      dimensions of the observed elements change.
     */ function ResizeObserver(callback) {
        if (!(this instanceof ResizeObserver)) throw new TypeError("Cannot call a class as a function.");
        if (!arguments.length) throw new TypeError("1 argument required, but only 0 present.");
        var controller = $87c2a74187854fda$var$ResizeObserverController.getInstance();
        var observer = new $87c2a74187854fda$var$ResizeObserverSPI(callback, controller, this);
        $87c2a74187854fda$var$observers.set(this, observer);
    }
    return ResizeObserver;
}();
// Expose public methods of ResizeObserver.
[
    "observe",
    "unobserve",
    "disconnect"
].forEach(function(method) {
    $87c2a74187854fda$var$ResizeObserver.prototype[method] = function() {
        var _a;
        return (_a = $87c2a74187854fda$var$observers.get(this))[method].apply(_a, arguments);
    };
});
var $87c2a74187854fda$var$index = function() {
    // Export existing implementation if available.
    if (typeof $87c2a74187854fda$var$global$1.ResizeObserver !== "undefined") return $87c2a74187854fda$var$global$1.ResizeObserver;
    return $87c2a74187854fda$var$ResizeObserver;
}();
var $87c2a74187854fda$export$2e2bcd8739ae039 = $87c2a74187854fda$var$index;


"use strict";
var $ace5bccb6d54a3d1$var$_excluded = [
    "animating"
];
var $ace5bccb6d54a3d1$export$14a303763f47951d = /*#__PURE__*/ function(_React$Component) {
    (0, $0ed648f7bbaf3aff$export$2e2bcd8739ae039)(InnerSlider, _React$Component);
    var _super = (0, $a76f20fb39fa9d46$export$2e2bcd8739ae039)(InnerSlider);
    function InnerSlider(props) {
        var _this;
        (0, $4d35ca0862055760$export$2e2bcd8739ae039)(this, InnerSlider);
        _this = _super.call(this, props);
        (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)((0, $cd69a1d4c6210e44$export$2e2bcd8739ae039)(_this), "listRefHandler", function(ref) {
            return _this.list = ref;
        });
        (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)((0, $cd69a1d4c6210e44$export$2e2bcd8739ae039)(_this), "trackRefHandler", function(ref) {
            return _this.track = ref;
        });
        (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)((0, $cd69a1d4c6210e44$export$2e2bcd8739ae039)(_this), "adaptHeight", function() {
            if (_this.props.adaptiveHeight && _this.list) {
                var elem = _this.list.querySelector('[data-index="'.concat(_this.state.currentSlide, '"]'));
                _this.list.style.height = (0, $e1b381ed4609728f$export$c08559766941f856)(elem) + "px";
            }
        });
        (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)((0, $cd69a1d4c6210e44$export$2e2bcd8739ae039)(_this), "componentDidMount", function() {
            _this.props.onInit && _this.props.onInit();
            if (_this.props.lazyLoad) {
                var slidesToLoad = (0, $e1b381ed4609728f$export$62701ea96990f316)((0, $983350b7b3960a26$export$2e2bcd8739ae039)((0, $983350b7b3960a26$export$2e2bcd8739ae039)({}, _this.props), _this.state));
                if (slidesToLoad.length > 0) {
                    _this.setState(function(prevState) {
                        return {
                            lazyLoadedList: prevState.lazyLoadedList.concat(slidesToLoad)
                        };
                    });
                    if (_this.props.onLazyLoad) _this.props.onLazyLoad(slidesToLoad);
                }
            }
            var spec = (0, $983350b7b3960a26$export$2e2bcd8739ae039)({
                listRef: _this.list,
                trackRef: _this.track
            }, _this.props);
            _this.updateState(spec, true, function() {
                _this.adaptHeight();
                _this.props.autoplay && _this.autoPlay("playing");
            });
            if (_this.props.lazyLoad === "progressive") _this.lazyLoadTimer = setInterval(_this.progressiveLazyLoad, 1000);
            _this.ro = new (0, $87c2a74187854fda$export$2e2bcd8739ae039)(function() {
                if (_this.state.animating) {
                    _this.onWindowResized(false); // don't set trackStyle hence don't break animation
                    _this.callbackTimers.push(setTimeout(function() {
                        return _this.onWindowResized();
                    }, _this.props.speed));
                } else _this.onWindowResized();
            });
            _this.ro.observe(_this.list);
            document.querySelectorAll && Array.prototype.forEach.call(document.querySelectorAll(".slick-slide"), function(slide) {
                slide.onfocus = _this.props.pauseOnFocus ? _this.onSlideFocus : null;
                slide.onblur = _this.props.pauseOnFocus ? _this.onSlideBlur : null;
            });
            if (window.addEventListener) window.addEventListener("resize", _this.onWindowResized);
            else window.attachEvent("onresize", _this.onWindowResized);
        });
        (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)((0, $cd69a1d4c6210e44$export$2e2bcd8739ae039)(_this), "componentWillUnmount", function() {
            if (_this.animationEndCallback) clearTimeout(_this.animationEndCallback);
            if (_this.lazyLoadTimer) clearInterval(_this.lazyLoadTimer);
            if (_this.callbackTimers.length) {
                _this.callbackTimers.forEach(function(timer) {
                    return clearTimeout(timer);
                });
                _this.callbackTimers = [];
            }
            if (window.addEventListener) window.removeEventListener("resize", _this.onWindowResized);
            else window.detachEvent("onresize", _this.onWindowResized);
            if (_this.autoplayTimer) clearInterval(_this.autoplayTimer);
            _this.ro.disconnect();
        });
        (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)((0, $cd69a1d4c6210e44$export$2e2bcd8739ae039)(_this), "componentDidUpdate", function(prevProps) {
            _this.checkImagesLoad();
            _this.props.onReInit && _this.props.onReInit();
            if (_this.props.lazyLoad) {
                var slidesToLoad = (0, $e1b381ed4609728f$export$62701ea96990f316)((0, $983350b7b3960a26$export$2e2bcd8739ae039)((0, $983350b7b3960a26$export$2e2bcd8739ae039)({}, _this.props), _this.state));
                if (slidesToLoad.length > 0) {
                    _this.setState(function(prevState) {
                        return {
                            lazyLoadedList: prevState.lazyLoadedList.concat(slidesToLoad)
                        };
                    });
                    if (_this.props.onLazyLoad) _this.props.onLazyLoad(slidesToLoad);
                }
            }
            // if (this.props.onLazyLoad) {
            //   this.props.onLazyLoad([leftMostSlide])
            // }
            _this.adaptHeight();
            var spec = (0, $983350b7b3960a26$export$2e2bcd8739ae039)((0, $983350b7b3960a26$export$2e2bcd8739ae039)({
                listRef: _this.list,
                trackRef: _this.track
            }, _this.props), _this.state);
            var setTrackStyle = _this.didPropsChange(prevProps);
            setTrackStyle && _this.updateState(spec, setTrackStyle, function() {
                if (_this.state.currentSlide >= (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Children.count(_this.props.children)) _this.changeSlide({
                    message: "index",
                    index: (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Children.count(_this.props.children) - _this.props.slidesToShow,
                    currentSlide: _this.state.currentSlide
                });
                if (prevProps.autoplay !== _this.props.autoplay || prevProps.autoplaySpeed !== _this.props.autoplaySpeed) {
                    if (!prevProps.autoplay && _this.props.autoplay) _this.autoPlay("playing");
                    else if (_this.props.autoplay) _this.autoPlay("update");
                    else _this.pause("paused");
                }
            });
        });
        (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)((0, $cd69a1d4c6210e44$export$2e2bcd8739ae039)(_this), "onWindowResized", function(setTrackStyle) {
            if (_this.debouncedResize) _this.debouncedResize.cancel();
            _this.debouncedResize = (0, $5d4cd9f8bc92bd41$export$61fc7d43ac8f84b0)(50, function() {
                return _this.resizeWindow(setTrackStyle);
            });
            _this.debouncedResize();
        });
        (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)((0, $cd69a1d4c6210e44$export$2e2bcd8739ae039)(_this), "resizeWindow", function() {
            var setTrackStyle = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
            var isTrackMounted = Boolean(_this.track && _this.track.node);
            // prevent warning: setting state on unmounted component (server side rendering)
            if (!isTrackMounted) return;
            var spec = (0, $983350b7b3960a26$export$2e2bcd8739ae039)((0, $983350b7b3960a26$export$2e2bcd8739ae039)({
                listRef: _this.list,
                trackRef: _this.track
            }, _this.props), _this.state);
            _this.updateState(spec, setTrackStyle, function() {
                if (_this.props.autoplay) _this.autoPlay("update");
                else _this.pause("paused");
            });
            // animating state should be cleared while resizing, otherwise autoplay stops working
            _this.setState({
                animating: false
            });
            clearTimeout(_this.animationEndCallback);
            delete _this.animationEndCallback;
        });
        (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)((0, $cd69a1d4c6210e44$export$2e2bcd8739ae039)(_this), "updateState", function(spec, setTrackStyle, callback) {
            var updatedState = (0, $e1b381ed4609728f$export$446226dbc576c3ab)(spec);
            spec = (0, $983350b7b3960a26$export$2e2bcd8739ae039)((0, $983350b7b3960a26$export$2e2bcd8739ae039)((0, $983350b7b3960a26$export$2e2bcd8739ae039)({}, spec), updatedState), {}, {
                slideIndex: updatedState.currentSlide
            });
            var targetLeft = (0, $e1b381ed4609728f$export$e6afb656f970c8d4)(spec);
            spec = (0, $983350b7b3960a26$export$2e2bcd8739ae039)((0, $983350b7b3960a26$export$2e2bcd8739ae039)({}, spec), {}, {
                left: targetLeft
            });
            var trackStyle = (0, $e1b381ed4609728f$export$a56204438fe3ba9e)(spec);
            if (setTrackStyle || (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Children.count(_this.props.children) !== (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Children.count(spec.children)) updatedState["trackStyle"] = trackStyle;
            _this.setState(updatedState, callback);
        });
        (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)((0, $cd69a1d4c6210e44$export$2e2bcd8739ae039)(_this), "ssrInit", function() {
            if (_this.props.variableWidth) {
                var _trackWidth = 0, _trackLeft = 0;
                var childrenWidths = [];
                var preClones = (0, $e1b381ed4609728f$export$b7c426bbf733f421)((0, $983350b7b3960a26$export$2e2bcd8739ae039)((0, $983350b7b3960a26$export$2e2bcd8739ae039)((0, $983350b7b3960a26$export$2e2bcd8739ae039)({}, _this.props), _this.state), {}, {
                    slideCount: _this.props.children.length
                }));
                var postClones = (0, $e1b381ed4609728f$export$50a387a8fd3c60d)((0, $983350b7b3960a26$export$2e2bcd8739ae039)((0, $983350b7b3960a26$export$2e2bcd8739ae039)((0, $983350b7b3960a26$export$2e2bcd8739ae039)({}, _this.props), _this.state), {}, {
                    slideCount: _this.props.children.length
                }));
                _this.props.children.forEach(function(child) {
                    childrenWidths.push(child.props.style.width);
                    _trackWidth += child.props.style.width;
                });
                for(var i = 0; i < preClones; i++){
                    _trackLeft += childrenWidths[childrenWidths.length - 1 - i];
                    _trackWidth += childrenWidths[childrenWidths.length - 1 - i];
                }
                for(var _i = 0; _i < postClones; _i++)_trackWidth += childrenWidths[_i];
                for(var _i2 = 0; _i2 < _this.state.currentSlide; _i2++)_trackLeft += childrenWidths[_i2];
                var _trackStyle = {
                    width: _trackWidth + "px",
                    left: -_trackLeft + "px"
                };
                if (_this.props.centerMode) {
                    var currentWidth = "".concat(childrenWidths[_this.state.currentSlide], "px");
                    _trackStyle.left = "calc(".concat(_trackStyle.left, " + (100% - ").concat(currentWidth, ") / 2 ) ");
                }
                return {
                    trackStyle: _trackStyle
                };
            }
            var childrenCount = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Children.count(_this.props.children);
            var spec = (0, $983350b7b3960a26$export$2e2bcd8739ae039)((0, $983350b7b3960a26$export$2e2bcd8739ae039)((0, $983350b7b3960a26$export$2e2bcd8739ae039)({}, _this.props), _this.state), {}, {
                slideCount: childrenCount
            });
            var slideCount = (0, $e1b381ed4609728f$export$b7c426bbf733f421)(spec) + (0, $e1b381ed4609728f$export$50a387a8fd3c60d)(spec) + childrenCount;
            var trackWidth = 100 / _this.props.slidesToShow * slideCount;
            var slideWidth = 100 / slideCount;
            var trackLeft = -slideWidth * ((0, $e1b381ed4609728f$export$b7c426bbf733f421)(spec) + _this.state.currentSlide) * trackWidth / 100;
            if (_this.props.centerMode) trackLeft += (100 - slideWidth * trackWidth / 100) / 2;
            var trackStyle = {
                width: trackWidth + "%",
                left: trackLeft + "%"
            };
            return {
                slideWidth: slideWidth + "%",
                trackStyle: trackStyle
            };
        });
        (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)((0, $cd69a1d4c6210e44$export$2e2bcd8739ae039)(_this), "checkImagesLoad", function() {
            var images = _this.list && _this.list.querySelectorAll && _this.list.querySelectorAll(".slick-slide img") || [];
            var imagesCount = images.length, loadedCount = 0;
            Array.prototype.forEach.call(images, function(image) {
                var handler = function handler() {
                    return ++loadedCount && loadedCount >= imagesCount && _this.onWindowResized();
                };
                if (!image.onclick) image.onclick = function() {
                    return image.parentNode.focus();
                };
                else {
                    var prevClickHandler = image.onclick;
                    image.onclick = function(e) {
                        prevClickHandler(e);
                        image.parentNode.focus();
                    };
                }
                if (!image.onload) {
                    if (_this.props.lazyLoad) image.onload = function() {
                        _this.adaptHeight();
                        _this.callbackTimers.push(setTimeout(_this.onWindowResized, _this.props.speed));
                    };
                    else {
                        image.onload = handler;
                        image.onerror = function() {
                            handler();
                            _this.props.onLazyLoadError && _this.props.onLazyLoadError();
                        };
                    }
                }
            });
        });
        (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)((0, $cd69a1d4c6210e44$export$2e2bcd8739ae039)(_this), "progressiveLazyLoad", function() {
            var slidesToLoad = [];
            var spec = (0, $983350b7b3960a26$export$2e2bcd8739ae039)((0, $983350b7b3960a26$export$2e2bcd8739ae039)({}, _this.props), _this.state);
            for(var index = _this.state.currentSlide; index < _this.state.slideCount + (0, $e1b381ed4609728f$export$50a387a8fd3c60d)(spec); index++)if (_this.state.lazyLoadedList.indexOf(index) < 0) {
                slidesToLoad.push(index);
                break;
            }
            for(var _index = _this.state.currentSlide - 1; _index >= -(0, $e1b381ed4609728f$export$b7c426bbf733f421)(spec); _index--)if (_this.state.lazyLoadedList.indexOf(_index) < 0) {
                slidesToLoad.push(_index);
                break;
            }
            if (slidesToLoad.length > 0) {
                _this.setState(function(state) {
                    return {
                        lazyLoadedList: state.lazyLoadedList.concat(slidesToLoad)
                    };
                });
                if (_this.props.onLazyLoad) _this.props.onLazyLoad(slidesToLoad);
            } else if (_this.lazyLoadTimer) {
                clearInterval(_this.lazyLoadTimer);
                delete _this.lazyLoadTimer;
            }
        });
        (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)((0, $cd69a1d4c6210e44$export$2e2bcd8739ae039)(_this), "slideHandler", function(index) {
            var dontAnimate = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
            var _this$props = _this.props, asNavFor = _this$props.asNavFor, beforeChange = _this$props.beforeChange, onLazyLoad = _this$props.onLazyLoad, speed = _this$props.speed, afterChange = _this$props.afterChange;
            // capture currentslide before state is updated
            var currentSlide = _this.state.currentSlide;
            var _slideHandler = (0, $e1b381ed4609728f$export$961f912fd58954b)((0, $983350b7b3960a26$export$2e2bcd8739ae039)((0, $983350b7b3960a26$export$2e2bcd8739ae039)((0, $983350b7b3960a26$export$2e2bcd8739ae039)({
                index: index
            }, _this.props), _this.state), {}, {
                trackRef: _this.track,
                useCSS: _this.props.useCSS && !dontAnimate
            })), state = _slideHandler.state, nextState = _slideHandler.nextState;
            if (!state) return;
            beforeChange && beforeChange(currentSlide, state.currentSlide);
            var slidesToLoad = state.lazyLoadedList.filter(function(value) {
                return _this.state.lazyLoadedList.indexOf(value) < 0;
            });
            onLazyLoad && slidesToLoad.length > 0 && onLazyLoad(slidesToLoad);
            if (!_this.props.waitForAnimate && _this.animationEndCallback) {
                clearTimeout(_this.animationEndCallback);
                afterChange && afterChange(currentSlide);
                delete _this.animationEndCallback;
            }
            _this.setState(state, function() {
                // asNavForIndex check is to avoid recursive calls of slideHandler in waitForAnimate=false mode
                if (asNavFor && _this.asNavForIndex !== index) {
                    _this.asNavForIndex = index;
                    asNavFor.innerSlider.slideHandler(index);
                }
                if (!nextState) return;
                _this.animationEndCallback = setTimeout(function() {
                    var animating = nextState.animating, firstBatch = (0, $73ef9ce1c41fc0c0$export$2e2bcd8739ae039)(nextState, $ace5bccb6d54a3d1$var$_excluded);
                    _this.setState(firstBatch, function() {
                        _this.callbackTimers.push(setTimeout(function() {
                            return _this.setState({
                                animating: animating
                            });
                        }, 10));
                        afterChange && afterChange(state.currentSlide);
                        delete _this.animationEndCallback;
                    });
                }, speed);
            });
        });
        (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)((0, $cd69a1d4c6210e44$export$2e2bcd8739ae039)(_this), "changeSlide", function(options) {
            var dontAnimate = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
            var spec = (0, $983350b7b3960a26$export$2e2bcd8739ae039)((0, $983350b7b3960a26$export$2e2bcd8739ae039)({}, _this.props), _this.state);
            var targetSlide = (0, $e1b381ed4609728f$export$2b178751aa586095)(spec, options);
            if (targetSlide !== 0 && !targetSlide) return;
            if (dontAnimate === true) _this.slideHandler(targetSlide, dontAnimate);
            else _this.slideHandler(targetSlide);
            _this.props.autoplay && _this.autoPlay("update");
            if (_this.props.focusOnSelect) {
                var nodes = _this.list.querySelectorAll(".slick-current");
                nodes[0] && nodes[0].focus();
            }
        });
        (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)((0, $cd69a1d4c6210e44$export$2e2bcd8739ae039)(_this), "clickHandler", function(e) {
            if (_this.clickable === false) {
                e.stopPropagation();
                e.preventDefault();
            }
            _this.clickable = true;
        });
        (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)((0, $cd69a1d4c6210e44$export$2e2bcd8739ae039)(_this), "keyHandler", function(e) {
            var dir = (0, $e1b381ed4609728f$export$53be3f01be2e49ac)(e, _this.props.accessibility, _this.props.rtl);
            dir !== "" && _this.changeSlide({
                message: dir
            });
        });
        (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)((0, $cd69a1d4c6210e44$export$2e2bcd8739ae039)(_this), "selectHandler", function(options) {
            _this.changeSlide(options);
        });
        (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)((0, $cd69a1d4c6210e44$export$2e2bcd8739ae039)(_this), "disableBodyScroll", function() {
            var preventDefault = function preventDefault(e) {
                e = e || window.event;
                if (e.preventDefault) e.preventDefault();
                e.returnValue = false;
            };
            window.ontouchmove = preventDefault;
        });
        (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)((0, $cd69a1d4c6210e44$export$2e2bcd8739ae039)(_this), "enableBodyScroll", function() {
            window.ontouchmove = null;
        });
        (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)((0, $cd69a1d4c6210e44$export$2e2bcd8739ae039)(_this), "swipeStart", function(e) {
            if (_this.props.verticalSwiping) _this.disableBodyScroll();
            var state = (0, $e1b381ed4609728f$export$517240397a2d6b8e)(e, _this.props.swipe, _this.props.draggable);
            state !== "" && _this.setState(state);
        });
        (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)((0, $cd69a1d4c6210e44$export$2e2bcd8739ae039)(_this), "swipeMove", function(e) {
            var state = (0, $e1b381ed4609728f$export$b6bbad7797799ea9)(e, (0, $983350b7b3960a26$export$2e2bcd8739ae039)((0, $983350b7b3960a26$export$2e2bcd8739ae039)((0, $983350b7b3960a26$export$2e2bcd8739ae039)({}, _this.props), _this.state), {}, {
                trackRef: _this.track,
                listRef: _this.list,
                slideIndex: _this.state.currentSlide
            }));
            if (!state) return;
            if (state["swiping"]) _this.clickable = false;
            _this.setState(state);
        });
        (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)((0, $cd69a1d4c6210e44$export$2e2bcd8739ae039)(_this), "swipeEnd", function(e) {
            var state = (0, $e1b381ed4609728f$export$a1cf77dc3a4b9ee0)(e, (0, $983350b7b3960a26$export$2e2bcd8739ae039)((0, $983350b7b3960a26$export$2e2bcd8739ae039)((0, $983350b7b3960a26$export$2e2bcd8739ae039)({}, _this.props), _this.state), {}, {
                trackRef: _this.track,
                listRef: _this.list,
                slideIndex: _this.state.currentSlide
            }));
            if (!state) return;
            var triggerSlideHandler = state["triggerSlideHandler"];
            delete state["triggerSlideHandler"];
            _this.setState(state);
            if (triggerSlideHandler === undefined) return;
            _this.slideHandler(triggerSlideHandler);
            if (_this.props.verticalSwiping) _this.enableBodyScroll();
        });
        (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)((0, $cd69a1d4c6210e44$export$2e2bcd8739ae039)(_this), "touchEnd", function(e) {
            _this.swipeEnd(e);
            _this.clickable = true;
        });
        (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)((0, $cd69a1d4c6210e44$export$2e2bcd8739ae039)(_this), "slickPrev", function() {
            // this and fellow methods are wrapped in setTimeout
            // to make sure initialize setState has happened before
            // any of such methods are called
            _this.callbackTimers.push(setTimeout(function() {
                return _this.changeSlide({
                    message: "previous"
                });
            }, 0));
        });
        (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)((0, $cd69a1d4c6210e44$export$2e2bcd8739ae039)(_this), "slickNext", function() {
            _this.callbackTimers.push(setTimeout(function() {
                return _this.changeSlide({
                    message: "next"
                });
            }, 0));
        });
        (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)((0, $cd69a1d4c6210e44$export$2e2bcd8739ae039)(_this), "slickGoTo", function(slide) {
            var dontAnimate = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
            slide = Number(slide);
            if (isNaN(slide)) return "";
            _this.callbackTimers.push(setTimeout(function() {
                return _this.changeSlide({
                    message: "index",
                    index: slide,
                    currentSlide: _this.state.currentSlide
                }, dontAnimate);
            }, 0));
        });
        (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)((0, $cd69a1d4c6210e44$export$2e2bcd8739ae039)(_this), "play", function() {
            var nextIndex;
            if (_this.props.rtl) nextIndex = _this.state.currentSlide - _this.props.slidesToScroll;
            else {
                if ((0, $e1b381ed4609728f$export$30e977044f8f3618)((0, $983350b7b3960a26$export$2e2bcd8739ae039)((0, $983350b7b3960a26$export$2e2bcd8739ae039)({}, _this.props), _this.state))) nextIndex = _this.state.currentSlide + _this.props.slidesToScroll;
                else return false;
            }
            _this.slideHandler(nextIndex);
        });
        (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)((0, $cd69a1d4c6210e44$export$2e2bcd8739ae039)(_this), "autoPlay", function(playType) {
            if (_this.autoplayTimer) clearInterval(_this.autoplayTimer);
            var autoplaying = _this.state.autoplaying;
            if (playType === "update") {
                if (autoplaying === "hovered" || autoplaying === "focused" || autoplaying === "paused") return;
            } else if (playType === "leave") {
                if (autoplaying === "paused" || autoplaying === "focused") return;
            } else if (playType === "blur") {
                if (autoplaying === "paused" || autoplaying === "hovered") return;
            }
            _this.autoplayTimer = setInterval(_this.play, _this.props.autoplaySpeed + 50);
            _this.setState({
                autoplaying: "playing"
            });
        });
        (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)((0, $cd69a1d4c6210e44$export$2e2bcd8739ae039)(_this), "pause", function(pauseType) {
            if (_this.autoplayTimer) {
                clearInterval(_this.autoplayTimer);
                _this.autoplayTimer = null;
            }
            var autoplaying = _this.state.autoplaying;
            if (pauseType === "paused") _this.setState({
                autoplaying: "paused"
            });
            else if (pauseType === "focused") {
                if (autoplaying === "hovered" || autoplaying === "playing") _this.setState({
                    autoplaying: "focused"
                });
            } else // pauseType  is 'hovered'
            if (autoplaying === "playing") _this.setState({
                autoplaying: "hovered"
            });
        });
        (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)((0, $cd69a1d4c6210e44$export$2e2bcd8739ae039)(_this), "onDotsOver", function() {
            return _this.props.autoplay && _this.pause("hovered");
        });
        (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)((0, $cd69a1d4c6210e44$export$2e2bcd8739ae039)(_this), "onDotsLeave", function() {
            return _this.props.autoplay && _this.state.autoplaying === "hovered" && _this.autoPlay("leave");
        });
        (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)((0, $cd69a1d4c6210e44$export$2e2bcd8739ae039)(_this), "onTrackOver", function() {
            return _this.props.autoplay && _this.pause("hovered");
        });
        (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)((0, $cd69a1d4c6210e44$export$2e2bcd8739ae039)(_this), "onTrackLeave", function() {
            return _this.props.autoplay && _this.state.autoplaying === "hovered" && _this.autoPlay("leave");
        });
        (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)((0, $cd69a1d4c6210e44$export$2e2bcd8739ae039)(_this), "onSlideFocus", function() {
            return _this.props.autoplay && _this.pause("focused");
        });
        (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)((0, $cd69a1d4c6210e44$export$2e2bcd8739ae039)(_this), "onSlideBlur", function() {
            return _this.props.autoplay && _this.state.autoplaying === "focused" && _this.autoPlay("blur");
        });
        (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)((0, $cd69a1d4c6210e44$export$2e2bcd8739ae039)(_this), "render", function() {
            var className = (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))("slick-slider", _this.props.className, {
                "slick-vertical": _this.props.vertical,
                "slick-initialized": true
            });
            var spec = (0, $983350b7b3960a26$export$2e2bcd8739ae039)((0, $983350b7b3960a26$export$2e2bcd8739ae039)({}, _this.props), _this.state);
            var trackProps = (0, $e1b381ed4609728f$export$e9dd1a4ab6b7c5b0)(spec, [
                "fade",
                "cssEase",
                "speed",
                "infinite",
                "centerMode",
                "focusOnSelect",
                "currentSlide",
                "lazyLoad",
                "lazyLoadedList",
                "rtl",
                "slideWidth",
                "slideHeight",
                "listHeight",
                "vertical",
                "slidesToShow",
                "slidesToScroll",
                "slideCount",
                "trackStyle",
                "variableWidth",
                "unslick",
                "centerPadding",
                "targetSlide",
                "useCSS"
            ]);
            var pauseOnHover = _this.props.pauseOnHover;
            trackProps = (0, $983350b7b3960a26$export$2e2bcd8739ae039)((0, $983350b7b3960a26$export$2e2bcd8739ae039)({}, trackProps), {}, {
                onMouseEnter: pauseOnHover ? _this.onTrackOver : null,
                onMouseLeave: pauseOnHover ? _this.onTrackLeave : null,
                onMouseOver: pauseOnHover ? _this.onTrackOver : null,
                focusOnSelect: _this.props.focusOnSelect && _this.clickable ? _this.selectHandler : null
            });
            var dots;
            if (_this.props.dots === true && _this.state.slideCount >= _this.props.slidesToShow) {
                var dotProps = (0, $e1b381ed4609728f$export$e9dd1a4ab6b7c5b0)(spec, [
                    "dotsClass",
                    "slideCount",
                    "slidesToShow",
                    "currentSlide",
                    "slidesToScroll",
                    "clickHandler",
                    "children",
                    "customPaging",
                    "infinite",
                    "appendDots"
                ]);
                var pauseOnDotsHover = _this.props.pauseOnDotsHover;
                dotProps = (0, $983350b7b3960a26$export$2e2bcd8739ae039)((0, $983350b7b3960a26$export$2e2bcd8739ae039)({}, dotProps), {}, {
                    clickHandler: _this.changeSlide,
                    onMouseEnter: pauseOnDotsHover ? _this.onDotsLeave : null,
                    onMouseOver: pauseOnDotsHover ? _this.onDotsOver : null,
                    onMouseLeave: pauseOnDotsHover ? _this.onDotsLeave : null
                });
                dots = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $daf3c8f464a58d8b$export$8da50d3722682be0), dotProps);
            }
            var prevArrow, nextArrow;
            var arrowProps = (0, $e1b381ed4609728f$export$e9dd1a4ab6b7c5b0)(spec, [
                "infinite",
                "centerMode",
                "currentSlide",
                "slideCount",
                "slidesToShow",
                "prevArrow",
                "nextArrow"
            ]);
            arrowProps.clickHandler = _this.changeSlide;
            if (_this.props.arrows) {
                prevArrow = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $5033b9b74f3646cf$export$9c1f62bf9cbb344b), arrowProps);
                nextArrow = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $5033b9b74f3646cf$export$40405f1f48d6dbd), arrowProps);
            }
            var verticalHeightStyle = null;
            if (_this.props.vertical) verticalHeightStyle = {
                height: _this.state.listHeight
            };
            var centerPaddingStyle = null;
            if (_this.props.vertical === false) {
                if (_this.props.centerMode === true) centerPaddingStyle = {
                    padding: "0px " + _this.props.centerPadding
                };
            } else if (_this.props.centerMode === true) centerPaddingStyle = {
                padding: _this.props.centerPadding + " 0px"
            };
            var listStyle = (0, $983350b7b3960a26$export$2e2bcd8739ae039)((0, $983350b7b3960a26$export$2e2bcd8739ae039)({}, verticalHeightStyle), centerPaddingStyle);
            var touchMove = _this.props.touchMove;
            var listProps = {
                className: "slick-list",
                style: listStyle,
                onClick: _this.clickHandler,
                onMouseDown: touchMove ? _this.swipeStart : null,
                onMouseMove: _this.state.dragging && touchMove ? _this.swipeMove : null,
                onMouseUp: touchMove ? _this.swipeEnd : null,
                onMouseLeave: _this.state.dragging && touchMove ? _this.swipeEnd : null,
                onTouchStart: touchMove ? _this.swipeStart : null,
                onTouchMove: _this.state.dragging && touchMove ? _this.swipeMove : null,
                onTouchEnd: touchMove ? _this.touchEnd : null,
                onTouchCancel: _this.state.dragging && touchMove ? _this.swipeEnd : null,
                onKeyDown: _this.props.accessibility ? _this.keyHandler : null
            };
            var innerSliderProps = {
                className: className,
                dir: "ltr",
                style: _this.props.style
            };
            if (_this.props.unslick) {
                listProps = {
                    className: "slick-list"
                };
                innerSliderProps = {
                    className: className,
                    style: _this.props.style
                };
            }
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", innerSliderProps, !_this.props.unslick ? prevArrow : "", /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({
                ref: _this.listRefHandler
            }, listProps), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $c54e460f3b42546f$export$13921ac0cc260818), (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({
                ref: _this.trackRefHandler
            }, trackProps), _this.props.children)), !_this.props.unslick ? nextArrow : "", !_this.props.unslick ? dots : "");
        });
        _this.list = null;
        _this.track = null;
        _this.state = (0, $983350b7b3960a26$export$2e2bcd8739ae039)((0, $983350b7b3960a26$export$2e2bcd8739ae039)({}, (0, $352e3c72aa01b533$export$2e2bcd8739ae039)), {}, {
            currentSlide: _this.props.initialSlide,
            slideCount: (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Children.count(_this.props.children)
        });
        _this.callbackTimers = [];
        _this.clickable = true;
        _this.debouncedResize = null;
        var ssrState = _this.ssrInit();
        _this.state = (0, $983350b7b3960a26$export$2e2bcd8739ae039)((0, $983350b7b3960a26$export$2e2bcd8739ae039)({}, _this.state), ssrState);
        return _this;
    }
    (0, $94019358ecbcf36b$export$2e2bcd8739ae039)(InnerSlider, [
        {
            key: "didPropsChange",
            value: function didPropsChange(prevProps) {
                var setTrackStyle = false;
                for(var _i3 = 0, _Object$keys = Object.keys(this.props); _i3 < _Object$keys.length; _i3++){
                    var key = _Object$keys[_i3];
                    // eslint-disable-next-line no-prototype-builtins
                    if (!prevProps.hasOwnProperty(key)) {
                        setTrackStyle = true;
                        break;
                    }
                    if ((0, $b8f57191916382d3$export$2e2bcd8739ae039)(prevProps[key]) === "object" || typeof prevProps[key] === "function") continue;
                    if (prevProps[key] !== this.props[key]) {
                        setTrackStyle = true;
                        break;
                    }
                }
                return setTrackStyle || (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Children.count(this.props.children) !== (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Children.count(prevProps.children);
            }
        }
    ]);
    return InnerSlider;
}((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Component);


var $7983ea218c17033a$exports = {};
var $67289f82dff91124$exports = {};
var $67289f82dff91124$var$camel2hyphen = function(str) {
    return str.replace(/[A-Z]/g, function(match) {
        return "-" + match.toLowerCase();
    }).toLowerCase();
};
$67289f82dff91124$exports = $67289f82dff91124$var$camel2hyphen;


var $7983ea218c17033a$var$isDimension = function(feature) {
    var re = /[height|width]$/;
    return re.test(feature);
};
var $7983ea218c17033a$var$obj2mq = function(obj) {
    var mq = "";
    var features = Object.keys(obj);
    features.forEach(function(feature, index) {
        var value = obj[feature];
        feature = $67289f82dff91124$exports(feature);
        // Add px to dimension features
        if ($7983ea218c17033a$var$isDimension(feature) && typeof value === "number") value = value + "px";
        if (value === true) mq += feature;
        else if (value === false) mq += "not " + feature;
        else mq += "(" + feature + ": " + value + ")";
        if (index < features.length - 1) mq += " and ";
    });
    return mq;
};
var $7983ea218c17033a$var$json2mq = function(query) {
    var mq = "";
    if (typeof query === "string") return query;
    // Handling array of media queries
    if (query instanceof Array) {
        query.forEach(function(q, index) {
            mq += $7983ea218c17033a$var$obj2mq(q);
            if (index < query.length - 1) mq += ", ";
        });
        return mq;
    }
    // Handling single media query
    return $7983ea218c17033a$var$obj2mq(query);
};
$7983ea218c17033a$exports = $7983ea218c17033a$var$json2mq;



var $acw62 = parcelRequire("acw62");
var $9bc00d7d7191e5f4$var$defaultProps = {
    accessibility: true,
    adaptiveHeight: false,
    afterChange: null,
    appendDots: function appendDots(dots) {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("ul", {
            style: {
                display: "block"
            }
        }, dots);
    },
    arrows: true,
    autoplay: false,
    autoplaySpeed: 3000,
    beforeChange: null,
    centerMode: false,
    centerPadding: "50px",
    className: "",
    cssEase: "ease",
    customPaging: function customPaging(i) {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("button", null, i + 1);
    },
    dots: false,
    dotsClass: "slick-dots",
    draggable: true,
    easing: "linear",
    edgeFriction: 0.35,
    fade: false,
    focusOnSelect: false,
    infinite: true,
    initialSlide: 0,
    lazyLoad: null,
    nextArrow: null,
    onEdge: null,
    onInit: null,
    onLazyLoadError: null,
    onReInit: null,
    pauseOnDotsHover: false,
    pauseOnFocus: false,
    pauseOnHover: true,
    prevArrow: null,
    responsive: null,
    rows: 1,
    rtl: false,
    slide: "div",
    slidesPerRow: 1,
    slidesToScroll: 1,
    slidesToShow: 1,
    speed: 500,
    swipe: true,
    swipeEvent: null,
    swipeToSlide: false,
    touchMove: true,
    touchThreshold: 5,
    useCSS: true,
    useTransform: true,
    variableWidth: false,
    vertical: false,
    waitForAnimate: true
};
var $9bc00d7d7191e5f4$export$2e2bcd8739ae039 = $9bc00d7d7191e5f4$var$defaultProps;



"use strict";
var $2e5dddd03a477967$export$2e2bcd8739ae039 = /*#__PURE__*/ function(_React$Component) {
    (0, $0ed648f7bbaf3aff$export$2e2bcd8739ae039)(Slider, _React$Component);
    var _super = (0, $a76f20fb39fa9d46$export$2e2bcd8739ae039)(Slider);
    function Slider(props) {
        var _this;
        (0, $4d35ca0862055760$export$2e2bcd8739ae039)(this, Slider);
        _this = _super.call(this, props);
        (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)((0, $cd69a1d4c6210e44$export$2e2bcd8739ae039)(_this), "innerSliderRefHandler", function(ref) {
            return _this.innerSlider = ref;
        });
        (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)((0, $cd69a1d4c6210e44$export$2e2bcd8739ae039)(_this), "slickPrev", function() {
            return _this.innerSlider.slickPrev();
        });
        (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)((0, $cd69a1d4c6210e44$export$2e2bcd8739ae039)(_this), "slickNext", function() {
            return _this.innerSlider.slickNext();
        });
        (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)((0, $cd69a1d4c6210e44$export$2e2bcd8739ae039)(_this), "slickGoTo", function(slide) {
            var dontAnimate = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
            return _this.innerSlider.slickGoTo(slide, dontAnimate);
        });
        (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)((0, $cd69a1d4c6210e44$export$2e2bcd8739ae039)(_this), "slickPause", function() {
            return _this.innerSlider.pause("paused");
        });
        (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)((0, $cd69a1d4c6210e44$export$2e2bcd8739ae039)(_this), "slickPlay", function() {
            return _this.innerSlider.autoPlay("play");
        });
        _this.state = {
            breakpoint: null
        };
        _this._responsiveMediaHandlers = [];
        return _this;
    }
    (0, $94019358ecbcf36b$export$2e2bcd8739ae039)(Slider, [
        {
            key: "media",
            value: function media(query, handler) {
                // javascript handler for  css media query
                var mql = window.matchMedia(query);
                var listener = function listener(_ref) {
                    var matches = _ref.matches;
                    if (matches) handler();
                };
                mql.addListener(listener);
                listener(mql);
                this._responsiveMediaHandlers.push({
                    mql: mql,
                    query: query,
                    listener: listener
                });
            }
        },
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                var _this2 = this;
                // performance monitoring
                //if (process.env.NODE_ENV !== 'production') {
                //const { whyDidYouUpdate } = require('why-did-you-update')
                //whyDidYouUpdate(React)
                //}
                if (this.props.responsive) {
                    var breakpoints = this.props.responsive.map(function(breakpt) {
                        return breakpt.breakpoint;
                    });
                    // sort them in increasing order of their numerical value
                    breakpoints.sort(function(x, y) {
                        return x - y;
                    });
                    breakpoints.forEach(function(breakpoint, index) {
                        // media query for each breakpoint
                        var bQuery;
                        if (index === 0) bQuery = (0, (/*@__PURE__*/$parcel$interopDefault($7983ea218c17033a$exports)))({
                            minWidth: 0,
                            maxWidth: breakpoint
                        });
                        else bQuery = (0, (/*@__PURE__*/$parcel$interopDefault($7983ea218c17033a$exports)))({
                            minWidth: breakpoints[index - 1] + 1,
                            maxWidth: breakpoint
                        });
                        // when not using server side rendering
                        (0, $e1b381ed4609728f$export$71594e8a50f746f4)() && _this2.media(bQuery, function() {
                            _this2.setState({
                                breakpoint: breakpoint
                            });
                        });
                    });
                    // Register media query for full screen. Need to support resize from small to large
                    // convert javascript object to media query string
                    var query = (0, (/*@__PURE__*/$parcel$interopDefault($7983ea218c17033a$exports)))({
                        minWidth: breakpoints.slice(-1)[0]
                    });
                    (0, $e1b381ed4609728f$export$71594e8a50f746f4)() && this.media(query, function() {
                        _this2.setState({
                            breakpoint: null
                        });
                    });
                }
            }
        },
        {
            key: "componentWillUnmount",
            value: function componentWillUnmount() {
                this._responsiveMediaHandlers.forEach(function(obj) {
                    obj.mql.removeListener(obj.listener);
                });
            }
        },
        {
            key: "render",
            value: function render() {
                var _this3 = this;
                var settings;
                var newProps;
                if (this.state.breakpoint) {
                    newProps = this.props.responsive.filter(function(resp) {
                        return resp.breakpoint === _this3.state.breakpoint;
                    });
                    settings = newProps[0].settings === "unslick" ? "unslick" : (0, $983350b7b3960a26$export$2e2bcd8739ae039)((0, $983350b7b3960a26$export$2e2bcd8739ae039)((0, $983350b7b3960a26$export$2e2bcd8739ae039)({}, (0, $9bc00d7d7191e5f4$export$2e2bcd8739ae039)), this.props), newProps[0].settings);
                } else settings = (0, $983350b7b3960a26$export$2e2bcd8739ae039)((0, $983350b7b3960a26$export$2e2bcd8739ae039)({}, (0, $9bc00d7d7191e5f4$export$2e2bcd8739ae039)), this.props);
                // force scrolling by one if centerMode is on
                if (settings.centerMode) {
                    if (settings.slidesToScroll > 1 && true) console.warn("slidesToScroll should be equal to 1 in centerMode, you are using ".concat(settings.slidesToScroll));
                    settings.slidesToScroll = 1;
                }
                // force showing one slide and scrolling by one if the fade mode is on
                if (settings.fade) {
                    if (settings.slidesToShow > 1 && true) console.warn("slidesToShow should be equal to 1 when fade is true, you're using ".concat(settings.slidesToShow));
                    if (settings.slidesToScroll > 1 && true) console.warn("slidesToScroll should be equal to 1 when fade is true, you're using ".concat(settings.slidesToScroll));
                    settings.slidesToShow = 1;
                    settings.slidesToScroll = 1;
                }
                // makes sure that children is an array, even when there is only 1 child
                var children = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Children.toArray(this.props.children);
                // Children may contain false or null, so we should filter them
                // children may also contain string filled with spaces (in certain cases where we use jsx strings)
                children = children.filter(function(child) {
                    if (typeof child === "string") return !!child.trim();
                    return !!child;
                });
                // rows and slidesPerRow logic is handled here
                if (settings.variableWidth && (settings.rows > 1 || settings.slidesPerRow > 1)) {
                    console.warn("variableWidth is not supported in case of rows > 1 or slidesPerRow > 1");
                    settings.variableWidth = false;
                }
                var newChildren = [];
                var currentWidth = null;
                for(var i = 0; i < children.length; i += settings.rows * settings.slidesPerRow){
                    var newSlide = [];
                    for(var j = i; j < i + settings.rows * settings.slidesPerRow; j += settings.slidesPerRow){
                        var row = [];
                        for(var k = j; k < j + settings.slidesPerRow; k += 1){
                            if (settings.variableWidth && children[k].props.style) currentWidth = children[k].props.style.width;
                            if (k >= children.length) break;
                            row.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).cloneElement(children[k], {
                                key: 100 * i + 10 * j + k,
                                tabIndex: -1,
                                style: {
                                    width: "".concat(100 / settings.slidesPerRow, "%"),
                                    display: "inline-block"
                                }
                            }));
                        }
                        newSlide.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
                            key: 10 * i + j
                        }, row));
                    }
                    if (settings.variableWidth) newChildren.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
                        key: i,
                        style: {
                            width: currentWidth
                        }
                    }, newSlide));
                    else newChildren.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
                        key: i
                    }, newSlide));
                }
                if (settings === "unslick") {
                    var className = "regular slider " + (this.props.className || "");
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
                        className: className
                    }, children);
                } else if (newChildren.length <= settings.slidesToShow) settings.unslick = true;
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $ace5bccb6d54a3d1$export$14a303763f47951d), (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({
                    style: this.props.style,
                    ref: this.innerSliderRefHandler
                }, settings), newChildren);
            }
        }
    ]);
    return Slider;
}((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Component);


var $dcbb38da091da394$export$2e2bcd8739ae039 = (0, $2e5dddd03a477967$export$2e2bcd8739ae039);




var $acw62 = parcelRequire("acw62");


var $acw62 = parcelRequire("acw62");
var $6bacc63174d40f3c$var$IconContext = /*#__PURE__*/ (0, $acw62.createContext)({});
var $6bacc63174d40f3c$export$2e2bcd8739ae039 = $6bacc63174d40f3c$var$IconContext;



var $acw62 = parcelRequire("acw62");
function $2e4d16a6147a082d$export$2e2bcd8739ae039(getValue, condition, shouldUpdate) {
    var cacheRef = $acw62.useRef({});
    if (!("value" in cacheRef.current) || shouldUpdate(cacheRef.current.condition, condition)) {
        cacheRef.current.value = getValue();
        cacheRef.current.condition = condition;
    }
    return cacheRef.current.value;
}



var $acw62 = parcelRequire("acw62");







function $7d110e739ae14cc6$export$2e2bcd8739ae039(arr) {
    return (0, $1167ce760980f343$export$2e2bcd8739ae039)(arr) || (0, $a0df324e6f81ee90$export$2e2bcd8739ae039)(arr) || (0, $76af8a05551d5f25$export$2e2bcd8739ae039)(arr) || (0, $530b88ff20858fe6$export$2e2bcd8739ae039)();
}


function $17fcde5782384c29$export$2e2bcd8739ae039(entity, path) {
    var current = entity;
    for(var i = 0; i < path.length; i += 1){
        if (current === null || current === undefined) return undefined;
        current = current[path[i]];
    }
    return current;
}


function $4bc24eaedd2a47a4$var$internalSet(entity, paths, value, removeIfUndefined) {
    if (!paths.length) return value;
    var _paths = (0, $7d110e739ae14cc6$export$2e2bcd8739ae039)(paths), path = _paths[0], restPath = _paths.slice(1);
    var clone;
    if (!entity && typeof path === "number") clone = [];
    else if (Array.isArray(entity)) clone = (0, $eb1ed927433e7e98$export$2e2bcd8739ae039)(entity);
    else clone = (0, $983350b7b3960a26$export$2e2bcd8739ae039)({}, entity);
    // Delete prop if `removeIfUndefined` and value is undefined
    if (removeIfUndefined && value === undefined && restPath.length === 1) delete clone[path][restPath[0]];
    else clone[path] = $4bc24eaedd2a47a4$var$internalSet(clone[path], restPath, value, removeIfUndefined);
    return clone;
}
function $4bc24eaedd2a47a4$export$2e2bcd8739ae039(entity, paths, value) {
    var removeIfUndefined = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
    // Do nothing if `removeIfUndefined` and parent object not exist
    if (paths.length && removeIfUndefined && value === undefined && !(0, $17fcde5782384c29$export$2e2bcd8739ae039)(entity, paths.slice(0, -1))) return entity;
    return $4bc24eaedd2a47a4$var$internalSet(entity, paths, value, removeIfUndefined);
}
function $4bc24eaedd2a47a4$var$isObject(obj) {
    return (0, $b8f57191916382d3$export$2e2bcd8739ae039)(obj) === "object" && obj !== null && Object.getPrototypeOf(obj) === Object.prototype;
}
function $4bc24eaedd2a47a4$var$createEmpty(source) {
    return Array.isArray(source) ? [] : {};
}
var $4bc24eaedd2a47a4$var$keys = typeof Reflect === "undefined" ? Object.keys : Reflect.ownKeys;
function $4bc24eaedd2a47a4$export$4950aa0f605343fb() {
    for(var _len = arguments.length, sources = new Array(_len), _key = 0; _key < _len; _key++)sources[_key] = arguments[_key];
    var clone = $4bc24eaedd2a47a4$var$createEmpty(sources[0]);
    sources.forEach(function(src) {
        function internalMerge(path, parentLoopSet) {
            var loopSet = new Set(parentLoopSet);
            var value = (0, $17fcde5782384c29$export$2e2bcd8739ae039)(src, path);
            var isArr = Array.isArray(value);
            if (isArr || $4bc24eaedd2a47a4$var$isObject(value)) // Only add not loop obj
            {
                if (!loopSet.has(value)) {
                    loopSet.add(value);
                    var originValue = (0, $17fcde5782384c29$export$2e2bcd8739ae039)(clone, path);
                    if (isArr) // Array will always be override
                    clone = $4bc24eaedd2a47a4$export$2e2bcd8739ae039(clone, path, []);
                    else if (!originValue || (0, $b8f57191916382d3$export$2e2bcd8739ae039)(originValue) !== "object") // Init container if not exist
                    clone = $4bc24eaedd2a47a4$export$2e2bcd8739ae039(clone, path, $4bc24eaedd2a47a4$var$createEmpty(value));
                    $4bc24eaedd2a47a4$var$keys(value).forEach(function(key) {
                        internalMerge([].concat((0, $eb1ed927433e7e98$export$2e2bcd8739ae039)(path), [
                            key
                        ]), loopSet);
                    });
                }
            } else clone = $4bc24eaedd2a47a4$export$2e2bcd8739ae039(clone, path, value);
        }
        internalMerge([]);
    });
    return clone;
}



var $acw62 = parcelRequire("acw62");
var // ZombieJ: We export single file here since
// ConfigProvider use this which will make loop deps
// to import whole `rc-field-form`
$efabd6732f69a6da$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $acw62.createContext)(undefined);




var $acw62 = parcelRequire("acw62");
/* eslint-disable no-console */ var $05a5f2c645683a81$var$warned = {};
var $05a5f2c645683a81$var$preWarningFns = [];
var $05a5f2c645683a81$export$61616f168f0e5a05 = function preMessage(fn) {
    $05a5f2c645683a81$var$preWarningFns.push(fn);
};
function $05a5f2c645683a81$export$491112666e282270(valid, message) {
    // Support uglify
    if (!valid && console !== undefined) {
        var finalMessage = $05a5f2c645683a81$var$preWarningFns.reduce(function(msg, preMessageFn) {
            return preMessageFn(msg !== null && msg !== void 0 ? msg : "", "warning");
        }, message);
        if (finalMessage) console.error("Warning: ".concat(finalMessage));
    }
}
function $05a5f2c645683a81$export$a92e4c44d367d0af(valid, message) {
    // Support uglify
    if (!valid && console !== undefined) {
        var finalMessage = $05a5f2c645683a81$var$preWarningFns.reduce(function(msg, preMessageFn) {
            return preMessageFn(msg !== null && msg !== void 0 ? msg : "", "note");
        }, message);
        if (finalMessage) console.warn("Note: ".concat(finalMessage));
    }
}
function $05a5f2c645683a81$export$60eef1277fe463e4() {
    $05a5f2c645683a81$var$warned = {};
}
function $05a5f2c645683a81$export$848feb93d8f32b9b(method, valid, message) {
    if (!valid && !$05a5f2c645683a81$var$warned[message]) {
        method(false, message);
        $05a5f2c645683a81$var$warned[message] = true;
    }
}
function $05a5f2c645683a81$export$82934adf09101657(valid, message) {
    $05a5f2c645683a81$export$848feb93d8f32b9b($05a5f2c645683a81$export$491112666e282270, valid, message);
}
function $05a5f2c645683a81$export$89ff31684837bbbf(valid, message) {
    $05a5f2c645683a81$export$848feb93d8f32b9b($05a5f2c645683a81$export$a92e4c44d367d0af, valid, message);
}
$05a5f2c645683a81$export$82934adf09101657.preMessage = $05a5f2c645683a81$export$61616f168f0e5a05;
$05a5f2c645683a81$export$82934adf09101657.resetWarned = $05a5f2c645683a81$export$60eef1277fe463e4;
$05a5f2c645683a81$export$82934adf09101657.noteOnce = $05a5f2c645683a81$export$89ff31684837bbbf;
var $05a5f2c645683a81$export$2e2bcd8739ae039 /* eslint-enable */  = $05a5f2c645683a81$export$82934adf09101657;


function $5bd796dbed593bbb$export$8793edee2d425525() {}
// eslint-disable-next-line import/no-mutable-exports
var $5bd796dbed593bbb$var$warning = $5bd796dbed593bbb$export$8793edee2d425525;
$5bd796dbed593bbb$var$warning = function warning(valid, component, message) {
    (0, $05a5f2c645683a81$export$2e2bcd8739ae039)(valid, "[antd: ".concat(component, "] ").concat(message));
};
var $5bd796dbed593bbb$export$2e2bcd8739ae039 = $5bd796dbed593bbb$var$warning;



/* eslint-disable no-template-curly-in-string */ var $864f21d08855a737$export$2e2bcd8739ae039 = {
    // Options.jsx
    items_per_page: "/ page",
    jump_to: "Go to",
    jump_to_confirm: "confirm",
    page: "Page",
    // Pagination.jsx
    prev_page: "Previous Page",
    next_page: "Next Page",
    prev_5: "Previous 5 Pages",
    next_5: "Next 5 Pages",
    prev_3: "Previous 3 Pages",
    next_3: "Next 3 Pages",
    page_size: "Page Size"
};



var $0309ef2dc8eb0939$var$locale = {
    locale: "en_US",
    today: "Today",
    now: "Now",
    backToToday: "Back to today",
    ok: "OK",
    clear: "Clear",
    month: "Month",
    year: "Year",
    timeSelect: "select time",
    dateSelect: "select date",
    weekSelect: "Choose a week",
    monthSelect: "Choose a month",
    yearSelect: "Choose a year",
    decadeSelect: "Choose a decade",
    yearFormat: "YYYY",
    dateFormat: "M/D/YYYY",
    dayFormat: "D",
    dateTimeFormat: "M/D/YYYY HH:mm:ss",
    monthBeforeYear: true,
    previousMonth: "Previous month (PageUp)",
    nextMonth: "Next month (PageDown)",
    previousYear: "Last year (Control + left)",
    nextYear: "Next year (Control + right)",
    previousDecade: "Last decade",
    nextDecade: "Next decade",
    previousCentury: "Last century",
    nextCentury: "Next century"
};
var $0309ef2dc8eb0939$export$2e2bcd8739ae039 = $0309ef2dc8eb0939$var$locale;


var $594a5cf7899ad7e1$var$locale = {
    placeholder: "Select time",
    rangePlaceholder: [
        "Start time",
        "End time"
    ]
};
var $594a5cf7899ad7e1$export$2e2bcd8739ae039 = $594a5cf7899ad7e1$var$locale;


// Merge into a locale object
var $74a89c57a3cfafd2$var$locale = {
    lang: (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({
        placeholder: "Select date",
        yearPlaceholder: "Select year",
        quarterPlaceholder: "Select quarter",
        monthPlaceholder: "Select month",
        weekPlaceholder: "Select week",
        rangePlaceholder: [
            "Start date",
            "End date"
        ],
        rangeYearPlaceholder: [
            "Start year",
            "End year"
        ],
        rangeQuarterPlaceholder: [
            "Start quarter",
            "End quarter"
        ],
        rangeMonthPlaceholder: [
            "Start month",
            "End month"
        ],
        rangeWeekPlaceholder: [
            "Start week",
            "End week"
        ]
    }, (0, $0309ef2dc8eb0939$export$2e2bcd8739ae039)),
    timePickerLocale: (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, (0, $594a5cf7899ad7e1$export$2e2bcd8739ae039))
};
var // All settings at:
// https://github.com/ant-design/ant-design/blob/master/components/date-picker/locale/example.json
$74a89c57a3cfafd2$export$2e2bcd8739ae039 = $74a89c57a3cfafd2$var$locale;


var $32ded69f6ae6c615$export$2e2bcd8739ae039 = (0, $74a89c57a3cfafd2$export$2e2bcd8739ae039);




var $8cffcf0f0d1231b6$var$typeTemplate = "${label} is not a valid ${type}";
var $8cffcf0f0d1231b6$var$localeValues = {
    locale: "en",
    Pagination: (0, $864f21d08855a737$export$2e2bcd8739ae039),
    DatePicker: (0, $74a89c57a3cfafd2$export$2e2bcd8739ae039),
    TimePicker: (0, $594a5cf7899ad7e1$export$2e2bcd8739ae039),
    Calendar: (0, $32ded69f6ae6c615$export$2e2bcd8739ae039),
    global: {
        placeholder: "Please select"
    },
    Table: {
        filterTitle: "Filter menu",
        filterConfirm: "OK",
        filterReset: "Reset",
        filterEmptyText: "No filters",
        filterCheckall: "Select all items",
        filterSearchPlaceholder: "Search in filters",
        emptyText: "No data",
        selectAll: "Select current page",
        selectInvert: "Invert current page",
        selectNone: "Clear all data",
        selectionAll: "Select all data",
        sortTitle: "Sort",
        expand: "Expand row",
        collapse: "Collapse row",
        triggerDesc: "Click to sort descending",
        triggerAsc: "Click to sort ascending",
        cancelSort: "Click to cancel sorting"
    },
    Modal: {
        okText: "OK",
        cancelText: "Cancel",
        justOkText: "OK"
    },
    Popconfirm: {
        okText: "OK",
        cancelText: "Cancel"
    },
    Transfer: {
        titles: [
            "",
            ""
        ],
        searchPlaceholder: "Search here",
        itemUnit: "item",
        itemsUnit: "items",
        remove: "Remove",
        selectCurrent: "Select current page",
        removeCurrent: "Remove current page",
        selectAll: "Select all data",
        removeAll: "Remove all data",
        selectInvert: "Invert current page"
    },
    Upload: {
        uploading: "Uploading...",
        removeFile: "Remove file",
        uploadError: "Upload error",
        previewFile: "Preview file",
        downloadFile: "Download file"
    },
    Empty: {
        description: "No data"
    },
    Icon: {
        icon: "icon"
    },
    Text: {
        edit: "Edit",
        copy: "Copy",
        copied: "Copied",
        expand: "Expand"
    },
    PageHeader: {
        back: "Back"
    },
    Form: {
        optional: "(optional)",
        defaultValidateMessages: {
            "default": "Field validation error for ${label}",
            required: "Please enter ${label}",
            "enum": "${label} must be one of [${enum}]",
            whitespace: "${label} cannot be a blank character",
            date: {
                format: "${label} date format is invalid",
                parse: "${label} cannot be converted to a date",
                invalid: "${label} is an invalid date"
            },
            types: {
                string: $8cffcf0f0d1231b6$var$typeTemplate,
                method: $8cffcf0f0d1231b6$var$typeTemplate,
                array: $8cffcf0f0d1231b6$var$typeTemplate,
                object: $8cffcf0f0d1231b6$var$typeTemplate,
                number: $8cffcf0f0d1231b6$var$typeTemplate,
                date: $8cffcf0f0d1231b6$var$typeTemplate,
                "boolean": $8cffcf0f0d1231b6$var$typeTemplate,
                integer: $8cffcf0f0d1231b6$var$typeTemplate,
                "float": $8cffcf0f0d1231b6$var$typeTemplate,
                regexp: $8cffcf0f0d1231b6$var$typeTemplate,
                email: $8cffcf0f0d1231b6$var$typeTemplate,
                url: $8cffcf0f0d1231b6$var$typeTemplate,
                hex: $8cffcf0f0d1231b6$var$typeTemplate
            },
            string: {
                len: "${label} must be ${len} characters",
                min: "${label} must be at least ${min} characters",
                max: "${label} must be up to ${max} characters",
                range: "${label} must be between ${min}-${max} characters"
            },
            number: {
                len: "${label} must be equal to ${len}",
                min: "${label} must be minimum ${min}",
                max: "${label} must be maximum ${max}",
                range: "${label} must be between ${min}-${max}"
            },
            array: {
                len: "Must be ${len} ${label}",
                min: "At least ${min} ${label}",
                max: "At most ${max} ${label}",
                range: "The amount of ${label} must be between ${min}-${max}"
            },
            pattern: {
                mismatch: "${label} does not match the pattern ${pattern}"
            }
        }
    },
    Image: {
        preview: "Preview"
    }
};
var $8cffcf0f0d1231b6$export$2e2bcd8739ae039 = $8cffcf0f0d1231b6$var$localeValues;


var $466e4bebfd7443ca$var$runtimeLocale = (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, (0, $8cffcf0f0d1231b6$export$2e2bcd8739ae039).Modal);
function $466e4bebfd7443ca$export$9485ecb9d81a550c(newLocale) {
    if (newLocale) $466e4bebfd7443ca$var$runtimeLocale = (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)((0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, $466e4bebfd7443ca$var$runtimeLocale), newLocale);
    else $466e4bebfd7443ca$var$runtimeLocale = (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, (0, $8cffcf0f0d1231b6$export$2e2bcd8739ae039).Modal);
}
function $466e4bebfd7443ca$export$1b6004afda18cd51() {
    return $466e4bebfd7443ca$var$runtimeLocale;
}



var $acw62 = parcelRequire("acw62");
var $f6e1632e0da0417b$var$LocaleContext = /*#__PURE__*/ (0, $acw62.createContext)(undefined);
var $f6e1632e0da0417b$export$2e2bcd8739ae039 = $f6e1632e0da0417b$var$LocaleContext;


var $fab4cbd3d1c845d7$export$b2f162cd5c15ea3e = "internalMark";
var $fab4cbd3d1c845d7$var$LocaleProvider = function LocaleProvider(props) {
    var _props$locale = props.locale, locale = _props$locale === void 0 ? {} : _props$locale, children = props.children, _ANT_MARK__ = props._ANT_MARK__;
    (0, $5bd796dbed593bbb$export$2e2bcd8739ae039)(_ANT_MARK__ === $fab4cbd3d1c845d7$export$b2f162cd5c15ea3e, "LocaleProvider", "`LocaleProvider` is deprecated. Please use `locale` with `ConfigProvider` instead: http://u.ant.design/locale");
    $acw62.useEffect(function() {
        (0, $466e4bebfd7443ca$export$9485ecb9d81a550c)(locale && locale.Modal);
        return function() {
            (0, $466e4bebfd7443ca$export$9485ecb9d81a550c)();
        };
    }, [
        locale
    ]);
    var getMemoizedContextValue = $acw62.useMemo(function() {
        return (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)((0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, locale), {
            exist: true
        });
    }, [
        locale
    ]);
    return /*#__PURE__*/ $acw62.createElement((0, $f6e1632e0da0417b$export$2e2bcd8739ae039).Provider, {
        value: getMemoizedContextValue
    }, children);
};
var $fab4cbd3d1c845d7$export$2e2bcd8739ae039 = $fab4cbd3d1c845d7$var$LocaleProvider;




var $acw62 = parcelRequire("acw62");


var $55cb264146668d16$export$2e2bcd8739ae039 = (0, $8cffcf0f0d1231b6$export$2e2bcd8739ae039);


var $715b7b8518c4616e$var$LocaleReceiver = function LocaleReceiver(props) {
    var _props$componentName = props.componentName, componentName = _props$componentName === void 0 ? "global" : _props$componentName, defaultLocale = props.defaultLocale, children = props.children;
    var antLocale = $acw62.useContext((0, $f6e1632e0da0417b$export$2e2bcd8739ae039));
    var getLocale = $acw62.useMemo(function() {
        var _a;
        var locale = defaultLocale || (0, $55cb264146668d16$export$2e2bcd8739ae039)[componentName];
        var localeFromContext = (_a = antLocale === null || antLocale === void 0 ? void 0 : antLocale[componentName]) !== null && _a !== void 0 ? _a : {};
        return (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)((0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, locale instanceof Function ? locale() : locale), localeFromContext || {});
    }, [
        componentName,
        defaultLocale,
        antLocale
    ]);
    var getLocaleCode = $acw62.useMemo(function() {
        var localeCode = antLocale && antLocale.locale;
        // Had use LocaleProvide but didn't set locale
        if (antLocale && antLocale.exist && !localeCode) return (0, $55cb264146668d16$export$2e2bcd8739ae039).locale;
        return localeCode;
    }, [
        antLocale
    ]);
    return children(getLocale, getLocaleCode, antLocale);
};
var $715b7b8518c4616e$export$2e2bcd8739ae039 = $715b7b8518c4616e$var$LocaleReceiver;
var $715b7b8518c4616e$export$52f95bab0279a481 = function useLocaleReceiver(componentName, defaultLocale) {
    var antLocale = $acw62.useContext((0, $f6e1632e0da0417b$export$2e2bcd8739ae039));
    var getLocale = $acw62.useMemo(function() {
        var _a;
        var locale = defaultLocale || (0, $55cb264146668d16$export$2e2bcd8739ae039)[componentName];
        var localeFromContext = (_a = antLocale === null || antLocale === void 0 ? void 0 : antLocale[componentName]) !== null && _a !== void 0 ? _a : {};
        return (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)((0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, typeof locale === "function" ? locale() : locale), localeFromContext || {});
    }, [
        componentName,
        defaultLocale,
        antLocale
    ]);
    return [
        getLocale
    ];
};







var $acw62 = parcelRequire("acw62");
// This icon file is generated automatically.
var $8e7f784a29e9449d$var$CheckCircleFilled = {
    "icon": {
        "tag": "svg",
        "attrs": {
            "viewBox": "64 64 896 896",
            "focusable": "false"
        },
        "children": [
            {
                "tag": "path",
                "attrs": {
                    "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm193.5 301.7l-210.6 292a31.8 31.8 0 01-51.7 0L318.5 484.9c-3.8-5.3 0-12.7 6.5-12.7h46.9c10.2 0 19.9 4.9 25.9 13.3l71.2 98.8 157.2-218c6-8.3 15.6-13.3 25.9-13.3H699c6.5 0 10.3 7.4 6.5 12.7z"
                }
            }
        ]
    },
    "name": "check-circle",
    "theme": "filled"
};
var $8e7f784a29e9449d$export$2e2bcd8739ae039 = $8e7f784a29e9449d$var$CheckCircleFilled;







var $acw62 = parcelRequire("acw62");






/* eslint-disable @typescript-eslint/no-redundant-type-constituents */ /**
 * Take input from [0, n] and return it as [0, 1]
 * @hidden
 */ function $89c3f0c2cde0477f$export$b0e60b43d1d059f0(n, max) {
    if ($89c3f0c2cde0477f$export$7bf7d6849640691b(n)) n = "100%";
    var isPercent = $89c3f0c2cde0477f$export$d86432a85610ea90(n);
    n = max === 360 ? n : Math.min(max, Math.max(0, parseFloat(n)));
    // Automatically convert percentage into number
    if (isPercent) n = parseInt(String(n * max), 10) / 100;
    // Handle floating point rounding errors
    if (Math.abs(n - max) < 0.000001) return 1;
    // Convert into [0, 1] range if it isn't already
    if (max === 360) // If n is a hue given in degrees,
    // wrap around out-of-range values into [0, 360] range
    // then convert into [0, 1].
    n = (n < 0 ? n % max + max : n % max) / parseFloat(String(max));
    else // If n not a hue given in degrees
    // Convert into [0, 1] range if it isn't already.
    n = n % max / parseFloat(String(max));
    return n;
}
function $89c3f0c2cde0477f$export$5c5ee632c52bc4a2(val) {
    return Math.min(1, Math.max(0, val));
}
function $89c3f0c2cde0477f$export$7bf7d6849640691b(n) {
    return typeof n === "string" && n.indexOf(".") !== -1 && parseFloat(n) === 1;
}
function $89c3f0c2cde0477f$export$d86432a85610ea90(n) {
    return typeof n === "string" && n.indexOf("%") !== -1;
}
function $89c3f0c2cde0477f$export$3ae665204365318d(a) {
    a = parseFloat(a);
    if (isNaN(a) || a < 0 || a > 1) a = 1;
    return a;
}
function $89c3f0c2cde0477f$export$8ba0754c08bd5ca8(n) {
    if (n <= 1) return "".concat(Number(n) * 100, "%");
    return n;
}
function $89c3f0c2cde0477f$export$9decc9dc70e2c76f(c) {
    return c.length === 1 ? "0" + c : String(c);
}


function $5dbaaddf372549d4$export$1a0d7f039f803cb(r, g, b) {
    return {
        r: (0, $89c3f0c2cde0477f$export$b0e60b43d1d059f0)(r, 255) * 255,
        g: (0, $89c3f0c2cde0477f$export$b0e60b43d1d059f0)(g, 255) * 255,
        b: (0, $89c3f0c2cde0477f$export$b0e60b43d1d059f0)(b, 255) * 255
    };
}
function $5dbaaddf372549d4$export$c85ca4f4753af384(r, g, b) {
    r = (0, $89c3f0c2cde0477f$export$b0e60b43d1d059f0)(r, 255);
    g = (0, $89c3f0c2cde0477f$export$b0e60b43d1d059f0)(g, 255);
    b = (0, $89c3f0c2cde0477f$export$b0e60b43d1d059f0)(b, 255);
    var max = Math.max(r, g, b);
    var min = Math.min(r, g, b);
    var h = 0;
    var s = 0;
    var l = (max + min) / 2;
    if (max === min) {
        s = 0;
        h = 0; // achromatic
    } else {
        var d = max - min;
        s = l > 0.5 ? d / (2 - max - min) : d / (max + min);
        switch(max){
            case r:
                h = (g - b) / d + (g < b ? 6 : 0);
                break;
            case g:
                h = (b - r) / d + 2;
                break;
            case b:
                h = (r - g) / d + 4;
                break;
            default:
                break;
        }
        h /= 6;
    }
    return {
        h: h,
        s: s,
        l: l
    };
}
function $5dbaaddf372549d4$var$hue2rgb(p, q, t) {
    if (t < 0) t += 1;
    if (t > 1) t -= 1;
    if (t < 1 / 6) return p + (q - p) * (6 * t);
    if (t < 0.5) return q;
    if (t < 2 / 3) return p + (q - p) * (2 / 3 - t) * 6;
    return p;
}
function $5dbaaddf372549d4$export$29fb7152bd3f781a(h, s, l) {
    var r;
    var g;
    var b;
    h = (0, $89c3f0c2cde0477f$export$b0e60b43d1d059f0)(h, 360);
    s = (0, $89c3f0c2cde0477f$export$b0e60b43d1d059f0)(s, 100);
    l = (0, $89c3f0c2cde0477f$export$b0e60b43d1d059f0)(l, 100);
    if (s === 0) {
        // achromatic
        g = l;
        b = l;
        r = l;
    } else {
        var q = l < 0.5 ? l * (1 + s) : l + s - l * s;
        var p = 2 * l - q;
        r = $5dbaaddf372549d4$var$hue2rgb(p, q, h + 1 / 3);
        g = $5dbaaddf372549d4$var$hue2rgb(p, q, h);
        b = $5dbaaddf372549d4$var$hue2rgb(p, q, h - 1 / 3);
    }
    return {
        r: r * 255,
        g: g * 255,
        b: b * 255
    };
}
function $5dbaaddf372549d4$export$f76e85ca00a47f5c(r, g, b) {
    r = (0, $89c3f0c2cde0477f$export$b0e60b43d1d059f0)(r, 255);
    g = (0, $89c3f0c2cde0477f$export$b0e60b43d1d059f0)(g, 255);
    b = (0, $89c3f0c2cde0477f$export$b0e60b43d1d059f0)(b, 255);
    var max = Math.max(r, g, b);
    var min = Math.min(r, g, b);
    var h = 0;
    var v = max;
    var d = max - min;
    var s = max === 0 ? 0 : d / max;
    if (max === min) h = 0; // achromatic
    else {
        switch(max){
            case r:
                h = (g - b) / d + (g < b ? 6 : 0);
                break;
            case g:
                h = (b - r) / d + 2;
                break;
            case b:
                h = (r - g) / d + 4;
                break;
            default:
                break;
        }
        h /= 6;
    }
    return {
        h: h,
        s: s,
        v: v
    };
}
function $5dbaaddf372549d4$export$210753cfeec758a5(h, s, v) {
    h = (0, $89c3f0c2cde0477f$export$b0e60b43d1d059f0)(h, 360) * 6;
    s = (0, $89c3f0c2cde0477f$export$b0e60b43d1d059f0)(s, 100);
    v = (0, $89c3f0c2cde0477f$export$b0e60b43d1d059f0)(v, 100);
    var i = Math.floor(h);
    var f = h - i;
    var p = v * (1 - s);
    var q = v * (1 - f * s);
    var t = v * (1 - (1 - f) * s);
    var mod = i % 6;
    var r = [
        v,
        q,
        p,
        p,
        t,
        v
    ][mod];
    var g = [
        t,
        v,
        v,
        q,
        p,
        p
    ][mod];
    var b = [
        p,
        p,
        t,
        v,
        v,
        q
    ][mod];
    return {
        r: r * 255,
        g: g * 255,
        b: b * 255
    };
}
function $5dbaaddf372549d4$export$34d09c4a771c46ef(r, g, b, allow3Char) {
    var hex = [
        (0, $89c3f0c2cde0477f$export$9decc9dc70e2c76f)(Math.round(r).toString(16)),
        (0, $89c3f0c2cde0477f$export$9decc9dc70e2c76f)(Math.round(g).toString(16)),
        (0, $89c3f0c2cde0477f$export$9decc9dc70e2c76f)(Math.round(b).toString(16))
    ];
    // Return a 3 character hex if possible
    if (allow3Char && hex[0].startsWith(hex[0].charAt(1)) && hex[1].startsWith(hex[1].charAt(1)) && hex[2].startsWith(hex[2].charAt(1))) return hex[0].charAt(0) + hex[1].charAt(0) + hex[2].charAt(0);
    return hex.join("");
}
function $5dbaaddf372549d4$export$ffee5509a14af63d(r, g, b, a, allow4Char) {
    var hex = [
        (0, $89c3f0c2cde0477f$export$9decc9dc70e2c76f)(Math.round(r).toString(16)),
        (0, $89c3f0c2cde0477f$export$9decc9dc70e2c76f)(Math.round(g).toString(16)),
        (0, $89c3f0c2cde0477f$export$9decc9dc70e2c76f)(Math.round(b).toString(16)),
        (0, $89c3f0c2cde0477f$export$9decc9dc70e2c76f)($5dbaaddf372549d4$export$51dcdea396f3aff6(a))
    ];
    // Return a 4 character hex if possible
    if (allow4Char && hex[0].startsWith(hex[0].charAt(1)) && hex[1].startsWith(hex[1].charAt(1)) && hex[2].startsWith(hex[2].charAt(1)) && hex[3].startsWith(hex[3].charAt(1))) return hex[0].charAt(0) + hex[1].charAt(0) + hex[2].charAt(0) + hex[3].charAt(0);
    return hex.join("");
}
function $5dbaaddf372549d4$export$ce6645f7d73030f4(r, g, b, a) {
    var hex = [
        (0, $89c3f0c2cde0477f$export$9decc9dc70e2c76f)($5dbaaddf372549d4$export$51dcdea396f3aff6(a)),
        (0, $89c3f0c2cde0477f$export$9decc9dc70e2c76f)(Math.round(r).toString(16)),
        (0, $89c3f0c2cde0477f$export$9decc9dc70e2c76f)(Math.round(g).toString(16)),
        (0, $89c3f0c2cde0477f$export$9decc9dc70e2c76f)(Math.round(b).toString(16))
    ];
    return hex.join("");
}
function $5dbaaddf372549d4$export$51dcdea396f3aff6(d) {
    return Math.round(parseFloat(d) * 255).toString(16);
}
function $5dbaaddf372549d4$export$616da979ad1c2414(h) {
    return $5dbaaddf372549d4$export$262b3ba788b4d07c(h) / 255;
}
function $5dbaaddf372549d4$export$262b3ba788b4d07c(val) {
    return parseInt(val, 16);
}
function $5dbaaddf372549d4$export$4076ec82b665900d(color) {
    return {
        r: color >> 16,
        g: (color & 0xff00) >> 8,
        b: color & 0xff
    };
}


// https://github.com/bahamas10/css-color-names/blob/master/css-color-names.json
/**
 * @hidden
 */ var $7c1331a6b98e7de3$export$e4b2ac9215619f8d = {
    aliceblue: "#f0f8ff",
    antiquewhite: "#faebd7",
    aqua: "#00ffff",
    aquamarine: "#7fffd4",
    azure: "#f0ffff",
    beige: "#f5f5dc",
    bisque: "#ffe4c4",
    black: "#000000",
    blanchedalmond: "#ffebcd",
    blue: "#0000ff",
    blueviolet: "#8a2be2",
    brown: "#a52a2a",
    burlywood: "#deb887",
    cadetblue: "#5f9ea0",
    chartreuse: "#7fff00",
    chocolate: "#d2691e",
    coral: "#ff7f50",
    cornflowerblue: "#6495ed",
    cornsilk: "#fff8dc",
    crimson: "#dc143c",
    cyan: "#00ffff",
    darkblue: "#00008b",
    darkcyan: "#008b8b",
    darkgoldenrod: "#b8860b",
    darkgray: "#a9a9a9",
    darkgreen: "#006400",
    darkgrey: "#a9a9a9",
    darkkhaki: "#bdb76b",
    darkmagenta: "#8b008b",
    darkolivegreen: "#556b2f",
    darkorange: "#ff8c00",
    darkorchid: "#9932cc",
    darkred: "#8b0000",
    darksalmon: "#e9967a",
    darkseagreen: "#8fbc8f",
    darkslateblue: "#483d8b",
    darkslategray: "#2f4f4f",
    darkslategrey: "#2f4f4f",
    darkturquoise: "#00ced1",
    darkviolet: "#9400d3",
    deeppink: "#ff1493",
    deepskyblue: "#00bfff",
    dimgray: "#696969",
    dimgrey: "#696969",
    dodgerblue: "#1e90ff",
    firebrick: "#b22222",
    floralwhite: "#fffaf0",
    forestgreen: "#228b22",
    fuchsia: "#ff00ff",
    gainsboro: "#dcdcdc",
    ghostwhite: "#f8f8ff",
    goldenrod: "#daa520",
    gold: "#ffd700",
    gray: "#808080",
    green: "#008000",
    greenyellow: "#adff2f",
    grey: "#808080",
    honeydew: "#f0fff0",
    hotpink: "#ff69b4",
    indianred: "#cd5c5c",
    indigo: "#4b0082",
    ivory: "#fffff0",
    khaki: "#f0e68c",
    lavenderblush: "#fff0f5",
    lavender: "#e6e6fa",
    lawngreen: "#7cfc00",
    lemonchiffon: "#fffacd",
    lightblue: "#add8e6",
    lightcoral: "#f08080",
    lightcyan: "#e0ffff",
    lightgoldenrodyellow: "#fafad2",
    lightgray: "#d3d3d3",
    lightgreen: "#90ee90",
    lightgrey: "#d3d3d3",
    lightpink: "#ffb6c1",
    lightsalmon: "#ffa07a",
    lightseagreen: "#20b2aa",
    lightskyblue: "#87cefa",
    lightslategray: "#778899",
    lightslategrey: "#778899",
    lightsteelblue: "#b0c4de",
    lightyellow: "#ffffe0",
    lime: "#00ff00",
    limegreen: "#32cd32",
    linen: "#faf0e6",
    magenta: "#ff00ff",
    maroon: "#800000",
    mediumaquamarine: "#66cdaa",
    mediumblue: "#0000cd",
    mediumorchid: "#ba55d3",
    mediumpurple: "#9370db",
    mediumseagreen: "#3cb371",
    mediumslateblue: "#7b68ee",
    mediumspringgreen: "#00fa9a",
    mediumturquoise: "#48d1cc",
    mediumvioletred: "#c71585",
    midnightblue: "#191970",
    mintcream: "#f5fffa",
    mistyrose: "#ffe4e1",
    moccasin: "#ffe4b5",
    navajowhite: "#ffdead",
    navy: "#000080",
    oldlace: "#fdf5e6",
    olive: "#808000",
    olivedrab: "#6b8e23",
    orange: "#ffa500",
    orangered: "#ff4500",
    orchid: "#da70d6",
    palegoldenrod: "#eee8aa",
    palegreen: "#98fb98",
    paleturquoise: "#afeeee",
    palevioletred: "#db7093",
    papayawhip: "#ffefd5",
    peachpuff: "#ffdab9",
    peru: "#cd853f",
    pink: "#ffc0cb",
    plum: "#dda0dd",
    powderblue: "#b0e0e6",
    purple: "#800080",
    rebeccapurple: "#663399",
    red: "#ff0000",
    rosybrown: "#bc8f8f",
    royalblue: "#4169e1",
    saddlebrown: "#8b4513",
    salmon: "#fa8072",
    sandybrown: "#f4a460",
    seagreen: "#2e8b57",
    seashell: "#fff5ee",
    sienna: "#a0522d",
    silver: "#c0c0c0",
    skyblue: "#87ceeb",
    slateblue: "#6a5acd",
    slategray: "#708090",
    slategrey: "#708090",
    snow: "#fffafa",
    springgreen: "#00ff7f",
    steelblue: "#4682b4",
    tan: "#d2b48c",
    teal: "#008080",
    thistle: "#d8bfd8",
    tomato: "#ff6347",
    turquoise: "#40e0d0",
    violet: "#ee82ee",
    wheat: "#f5deb3",
    white: "#ffffff",
    whitesmoke: "#f5f5f5",
    yellow: "#ffff00",
    yellowgreen: "#9acd32"
};



function $4146cacf0fc753c3$export$87de337d8199f22c(color) {
    var rgb = {
        r: 0,
        g: 0,
        b: 0
    };
    var a = 1;
    var s = null;
    var v = null;
    var l = null;
    var ok = false;
    var format = false;
    if (typeof color === "string") color = $4146cacf0fc753c3$export$56237d872eed15a0(color);
    if (typeof color === "object") {
        if ($4146cacf0fc753c3$export$80d4d71a83d4526d(color.r) && $4146cacf0fc753c3$export$80d4d71a83d4526d(color.g) && $4146cacf0fc753c3$export$80d4d71a83d4526d(color.b)) {
            rgb = (0, $5dbaaddf372549d4$export$1a0d7f039f803cb)(color.r, color.g, color.b);
            ok = true;
            format = String(color.r).substr(-1) === "%" ? "prgb" : "rgb";
        } else if ($4146cacf0fc753c3$export$80d4d71a83d4526d(color.h) && $4146cacf0fc753c3$export$80d4d71a83d4526d(color.s) && $4146cacf0fc753c3$export$80d4d71a83d4526d(color.v)) {
            s = (0, $89c3f0c2cde0477f$export$8ba0754c08bd5ca8)(color.s);
            v = (0, $89c3f0c2cde0477f$export$8ba0754c08bd5ca8)(color.v);
            rgb = (0, $5dbaaddf372549d4$export$210753cfeec758a5)(color.h, s, v);
            ok = true;
            format = "hsv";
        } else if ($4146cacf0fc753c3$export$80d4d71a83d4526d(color.h) && $4146cacf0fc753c3$export$80d4d71a83d4526d(color.s) && $4146cacf0fc753c3$export$80d4d71a83d4526d(color.l)) {
            s = (0, $89c3f0c2cde0477f$export$8ba0754c08bd5ca8)(color.s);
            l = (0, $89c3f0c2cde0477f$export$8ba0754c08bd5ca8)(color.l);
            rgb = (0, $5dbaaddf372549d4$export$29fb7152bd3f781a)(color.h, s, l);
            ok = true;
            format = "hsl";
        }
        if (Object.prototype.hasOwnProperty.call(color, "a")) a = color.a;
    }
    a = (0, $89c3f0c2cde0477f$export$3ae665204365318d)(a);
    return {
        ok: ok,
        format: color.format || format,
        r: Math.min(255, Math.max(rgb.r, 0)),
        g: Math.min(255, Math.max(rgb.g, 0)),
        b: Math.min(255, Math.max(rgb.b, 0)),
        a: a
    };
}
// <http://www.w3.org/TR/css3-values/#integers>
var $4146cacf0fc753c3$var$CSS_INTEGER = "[-\\+]?\\d+%?";
// <http://www.w3.org/TR/css3-values/#number-value>
var $4146cacf0fc753c3$var$CSS_NUMBER = "[-\\+]?\\d*\\.\\d+%?";
// Allow positive/negative integer/number.  Don't capture the either/or, just the entire outcome.
var $4146cacf0fc753c3$var$CSS_UNIT = "(?:".concat($4146cacf0fc753c3$var$CSS_NUMBER, ")|(?:").concat($4146cacf0fc753c3$var$CSS_INTEGER, ")");
// Actual matching.
// Parentheses and commas are optional, but not required.
// Whitespace can take the place of commas or opening paren
var $4146cacf0fc753c3$var$PERMISSIVE_MATCH3 = "[\\s|\\(]+(".concat($4146cacf0fc753c3$var$CSS_UNIT, ")[,|\\s]+(").concat($4146cacf0fc753c3$var$CSS_UNIT, ")[,|\\s]+(").concat($4146cacf0fc753c3$var$CSS_UNIT, ")\\s*\\)?");
var $4146cacf0fc753c3$var$PERMISSIVE_MATCH4 = "[\\s|\\(]+(".concat($4146cacf0fc753c3$var$CSS_UNIT, ")[,|\\s]+(").concat($4146cacf0fc753c3$var$CSS_UNIT, ")[,|\\s]+(").concat($4146cacf0fc753c3$var$CSS_UNIT, ")[,|\\s]+(").concat($4146cacf0fc753c3$var$CSS_UNIT, ")\\s*\\)?");
var $4146cacf0fc753c3$var$matchers = {
    CSS_UNIT: new RegExp($4146cacf0fc753c3$var$CSS_UNIT),
    rgb: new RegExp("rgb" + $4146cacf0fc753c3$var$PERMISSIVE_MATCH3),
    rgba: new RegExp("rgba" + $4146cacf0fc753c3$var$PERMISSIVE_MATCH4),
    hsl: new RegExp("hsl" + $4146cacf0fc753c3$var$PERMISSIVE_MATCH3),
    hsla: new RegExp("hsla" + $4146cacf0fc753c3$var$PERMISSIVE_MATCH4),
    hsv: new RegExp("hsv" + $4146cacf0fc753c3$var$PERMISSIVE_MATCH3),
    hsva: new RegExp("hsva" + $4146cacf0fc753c3$var$PERMISSIVE_MATCH4),
    hex3: /^#?([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})$/,
    hex6: /^#?([0-9a-fA-F]{2})([0-9a-fA-F]{2})([0-9a-fA-F]{2})$/,
    hex4: /^#?([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})$/,
    hex8: /^#?([0-9a-fA-F]{2})([0-9a-fA-F]{2})([0-9a-fA-F]{2})([0-9a-fA-F]{2})$/
};
function $4146cacf0fc753c3$export$56237d872eed15a0(color) {
    color = color.trim().toLowerCase();
    if (color.length === 0) return false;
    var named = false;
    if ((0, $7c1331a6b98e7de3$export$e4b2ac9215619f8d)[color]) {
        color = (0, $7c1331a6b98e7de3$export$e4b2ac9215619f8d)[color];
        named = true;
    } else if (color === "transparent") return {
        r: 0,
        g: 0,
        b: 0,
        a: 0,
        format: "name"
    };
    // Try to match string input using regular expressions.
    // Keep most of the number bounding out of this function - don't worry about [0,1] or [0,100] or [0,360]
    // Just return an object and let the conversion functions handle that.
    // This way the result will be the same whether the tinycolor is initialized with string or object.
    var match = $4146cacf0fc753c3$var$matchers.rgb.exec(color);
    if (match) return {
        r: match[1],
        g: match[2],
        b: match[3]
    };
    match = $4146cacf0fc753c3$var$matchers.rgba.exec(color);
    if (match) return {
        r: match[1],
        g: match[2],
        b: match[3],
        a: match[4]
    };
    match = $4146cacf0fc753c3$var$matchers.hsl.exec(color);
    if (match) return {
        h: match[1],
        s: match[2],
        l: match[3]
    };
    match = $4146cacf0fc753c3$var$matchers.hsla.exec(color);
    if (match) return {
        h: match[1],
        s: match[2],
        l: match[3],
        a: match[4]
    };
    match = $4146cacf0fc753c3$var$matchers.hsv.exec(color);
    if (match) return {
        h: match[1],
        s: match[2],
        v: match[3]
    };
    match = $4146cacf0fc753c3$var$matchers.hsva.exec(color);
    if (match) return {
        h: match[1],
        s: match[2],
        v: match[3],
        a: match[4]
    };
    match = $4146cacf0fc753c3$var$matchers.hex8.exec(color);
    if (match) return {
        r: (0, $5dbaaddf372549d4$export$262b3ba788b4d07c)(match[1]),
        g: (0, $5dbaaddf372549d4$export$262b3ba788b4d07c)(match[2]),
        b: (0, $5dbaaddf372549d4$export$262b3ba788b4d07c)(match[3]),
        a: (0, $5dbaaddf372549d4$export$616da979ad1c2414)(match[4]),
        format: named ? "name" : "hex8"
    };
    match = $4146cacf0fc753c3$var$matchers.hex6.exec(color);
    if (match) return {
        r: (0, $5dbaaddf372549d4$export$262b3ba788b4d07c)(match[1]),
        g: (0, $5dbaaddf372549d4$export$262b3ba788b4d07c)(match[2]),
        b: (0, $5dbaaddf372549d4$export$262b3ba788b4d07c)(match[3]),
        format: named ? "name" : "hex"
    };
    match = $4146cacf0fc753c3$var$matchers.hex4.exec(color);
    if (match) return {
        r: (0, $5dbaaddf372549d4$export$262b3ba788b4d07c)(match[1] + match[1]),
        g: (0, $5dbaaddf372549d4$export$262b3ba788b4d07c)(match[2] + match[2]),
        b: (0, $5dbaaddf372549d4$export$262b3ba788b4d07c)(match[3] + match[3]),
        a: (0, $5dbaaddf372549d4$export$616da979ad1c2414)(match[4] + match[4]),
        format: named ? "name" : "hex8"
    };
    match = $4146cacf0fc753c3$var$matchers.hex3.exec(color);
    if (match) return {
        r: (0, $5dbaaddf372549d4$export$262b3ba788b4d07c)(match[1] + match[1]),
        g: (0, $5dbaaddf372549d4$export$262b3ba788b4d07c)(match[2] + match[2]),
        b: (0, $5dbaaddf372549d4$export$262b3ba788b4d07c)(match[3] + match[3]),
        format: named ? "name" : "hex"
    };
    return false;
}
function $4146cacf0fc753c3$export$80d4d71a83d4526d(color) {
    return Boolean($4146cacf0fc753c3$var$matchers.CSS_UNIT.exec(String(color)));
}


var $9ec4f31fbae764a3$var$hueStep = 2; // 色相阶梯
var $9ec4f31fbae764a3$var$saturationStep = 0.16; // 饱和度阶梯，浅色部分
var $9ec4f31fbae764a3$var$saturationStep2 = 0.05; // 饱和度阶梯，深色部分
var $9ec4f31fbae764a3$var$brightnessStep1 = 0.05; // 亮度阶梯，浅色部分
var $9ec4f31fbae764a3$var$brightnessStep2 = 0.15; // 亮度阶梯，深色部分
var $9ec4f31fbae764a3$var$lightColorCount = 5; // 浅色数量，主色上
var $9ec4f31fbae764a3$var$darkColorCount = 4; // 深色数量，主色下
// 暗色主题颜色映射关系表
var $9ec4f31fbae764a3$var$darkColorMap = [
    {
        index: 7,
        opacity: 0.15
    },
    {
        index: 6,
        opacity: 0.25
    },
    {
        index: 5,
        opacity: 0.3
    },
    {
        index: 5,
        opacity: 0.45
    },
    {
        index: 5,
        opacity: 0.65
    },
    {
        index: 5,
        opacity: 0.85
    },
    {
        index: 4,
        opacity: 0.9
    },
    {
        index: 3,
        opacity: 0.95
    },
    {
        index: 2,
        opacity: 0.97
    },
    {
        index: 1,
        opacity: 0.98
    }
]; // Wrapper function ported from TinyColor.prototype.toHsv
// Keep it here because of `hsv.h * 360`
function $9ec4f31fbae764a3$var$toHsv(_ref) {
    var r = _ref.r, g = _ref.g, b = _ref.b;
    var hsv = (0, $5dbaaddf372549d4$export$f76e85ca00a47f5c)(r, g, b);
    return {
        h: hsv.h * 360,
        s: hsv.s,
        v: hsv.v
    };
} // Wrapper function ported from TinyColor.prototype.toHexString
// Keep it here because of the prefix `#`
function $9ec4f31fbae764a3$var$toHex(_ref2) {
    var r = _ref2.r, g = _ref2.g, b = _ref2.b;
    return "#".concat((0, $5dbaaddf372549d4$export$34d09c4a771c46ef)(r, g, b, false));
} // Wrapper function ported from TinyColor.prototype.mix, not treeshakable.
// Amount in range [0, 1]
// Assume color1 & color2 has no alpha, since the following src code did so.
function $9ec4f31fbae764a3$var$mix(rgb1, rgb2, amount) {
    var p = amount / 100;
    var rgb = {
        r: (rgb2.r - rgb1.r) * p + rgb1.r,
        g: (rgb2.g - rgb1.g) * p + rgb1.g,
        b: (rgb2.b - rgb1.b) * p + rgb1.b
    };
    return rgb;
}
function $9ec4f31fbae764a3$var$getHue(hsv, i, light) {
    var hue; // 根据色相不同，色相转向不同
    if (Math.round(hsv.h) >= 60 && Math.round(hsv.h) <= 240) hue = light ? Math.round(hsv.h) - $9ec4f31fbae764a3$var$hueStep * i : Math.round(hsv.h) + $9ec4f31fbae764a3$var$hueStep * i;
    else hue = light ? Math.round(hsv.h) + $9ec4f31fbae764a3$var$hueStep * i : Math.round(hsv.h) - $9ec4f31fbae764a3$var$hueStep * i;
    if (hue < 0) hue += 360;
    else if (hue >= 360) hue -= 360;
    return hue;
}
function $9ec4f31fbae764a3$var$getSaturation(hsv, i, light) {
    // grey color don't change saturation
    if (hsv.h === 0 && hsv.s === 0) return hsv.s;
    var saturation;
    if (light) saturation = hsv.s - $9ec4f31fbae764a3$var$saturationStep * i;
    else if (i === $9ec4f31fbae764a3$var$darkColorCount) saturation = hsv.s + $9ec4f31fbae764a3$var$saturationStep;
    else saturation = hsv.s + $9ec4f31fbae764a3$var$saturationStep2 * i;
     // 边界值修正
    if (saturation > 1) saturation = 1;
     // 第一格的 s 限制在 0.06-0.1 之间
    if (light && i === $9ec4f31fbae764a3$var$lightColorCount && saturation > 0.1) saturation = 0.1;
    if (saturation < 0.06) saturation = 0.06;
    return Number(saturation.toFixed(2));
}
function $9ec4f31fbae764a3$var$getValue(hsv, i, light) {
    var value;
    if (light) value = hsv.v + $9ec4f31fbae764a3$var$brightnessStep1 * i;
    else value = hsv.v - $9ec4f31fbae764a3$var$brightnessStep2 * i;
    if (value > 1) value = 1;
    return Number(value.toFixed(2));
}
function $9ec4f31fbae764a3$export$80d376111cc09ad7(color) {
    var opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var patterns = [];
    var pColor = (0, $4146cacf0fc753c3$export$87de337d8199f22c)(color);
    for(var i = $9ec4f31fbae764a3$var$lightColorCount; i > 0; i -= 1){
        var hsv = $9ec4f31fbae764a3$var$toHsv(pColor);
        var colorString = $9ec4f31fbae764a3$var$toHex((0, $4146cacf0fc753c3$export$87de337d8199f22c)({
            h: $9ec4f31fbae764a3$var$getHue(hsv, i, true),
            s: $9ec4f31fbae764a3$var$getSaturation(hsv, i, true),
            v: $9ec4f31fbae764a3$var$getValue(hsv, i, true)
        }));
        patterns.push(colorString);
    }
    patterns.push($9ec4f31fbae764a3$var$toHex(pColor));
    for(var _i = 1; _i <= $9ec4f31fbae764a3$var$darkColorCount; _i += 1){
        var _hsv = $9ec4f31fbae764a3$var$toHsv(pColor);
        var _colorString = $9ec4f31fbae764a3$var$toHex((0, $4146cacf0fc753c3$export$87de337d8199f22c)({
            h: $9ec4f31fbae764a3$var$getHue(_hsv, _i),
            s: $9ec4f31fbae764a3$var$getSaturation(_hsv, _i),
            v: $9ec4f31fbae764a3$var$getValue(_hsv, _i)
        }));
        patterns.push(_colorString);
    } // dark theme patterns
    if (opts.theme === "dark") return $9ec4f31fbae764a3$var$darkColorMap.map(function(_ref3) {
        var index = _ref3.index, opacity = _ref3.opacity;
        var darkColorString = $9ec4f31fbae764a3$var$toHex($9ec4f31fbae764a3$var$mix((0, $4146cacf0fc753c3$export$87de337d8199f22c)(opts.backgroundColor || "#141414"), (0, $4146cacf0fc753c3$export$87de337d8199f22c)(patterns[index]), opacity * 100));
        return darkColorString;
    });
    return patterns;
}
var $9ec4f31fbae764a3$export$3968a3afc810b5f5 = {
    red: "#F5222D",
    volcano: "#FA541C",
    orange: "#FA8C16",
    gold: "#FAAD14",
    yellow: "#FADB14",
    lime: "#A0D911",
    green: "#52C41A",
    cyan: "#13C2C2",
    blue: "#1890FF",
    geekblue: "#2F54EB",
    purple: "#722ED1",
    magenta: "#EB2F96",
    grey: "#666666"
};
var $9ec4f31fbae764a3$export$36ad6df0f83f284d = {};
var $9ec4f31fbae764a3$export$24617255e4daf647 = {};
Object.keys($9ec4f31fbae764a3$export$3968a3afc810b5f5).forEach(function(key) {
    $9ec4f31fbae764a3$export$36ad6df0f83f284d[key] = $9ec4f31fbae764a3$export$80d376111cc09ad7($9ec4f31fbae764a3$export$3968a3afc810b5f5[key]);
    $9ec4f31fbae764a3$export$36ad6df0f83f284d[key].primary = $9ec4f31fbae764a3$export$36ad6df0f83f284d[key][5]; // dark presetPalettes
    $9ec4f31fbae764a3$export$24617255e4daf647[key] = $9ec4f31fbae764a3$export$80d376111cc09ad7($9ec4f31fbae764a3$export$3968a3afc810b5f5[key], {
        theme: "dark",
        backgroundColor: "#141414"
    });
    $9ec4f31fbae764a3$export$24617255e4daf647[key].primary = $9ec4f31fbae764a3$export$24617255e4daf647[key][5];
});
var $9ec4f31fbae764a3$export$a90204d1394caf30 = $9ec4f31fbae764a3$export$36ad6df0f83f284d.red;
var $9ec4f31fbae764a3$export$e63a1643b2f79b16 = $9ec4f31fbae764a3$export$36ad6df0f83f284d.volcano;
var $9ec4f31fbae764a3$export$c24201f7fe3571d8 = $9ec4f31fbae764a3$export$36ad6df0f83f284d.gold;
var $9ec4f31fbae764a3$export$ad766f34ace1cafd = $9ec4f31fbae764a3$export$36ad6df0f83f284d.orange;
var $9ec4f31fbae764a3$export$594c5a8758200c32 = $9ec4f31fbae764a3$export$36ad6df0f83f284d.yellow;
var $9ec4f31fbae764a3$export$221d31baf2636aad = $9ec4f31fbae764a3$export$36ad6df0f83f284d.lime;
var $9ec4f31fbae764a3$export$955a2ebd2fb142ae = $9ec4f31fbae764a3$export$36ad6df0f83f284d.green;
var $9ec4f31fbae764a3$export$7474046f446842ee = $9ec4f31fbae764a3$export$36ad6df0f83f284d.cyan;
var $9ec4f31fbae764a3$export$2aa0182783e7e9de = $9ec4f31fbae764a3$export$36ad6df0f83f284d.blue;
var $9ec4f31fbae764a3$export$4138d3aeddcbf415 = $9ec4f31fbae764a3$export$36ad6df0f83f284d.geekblue;
var $9ec4f31fbae764a3$export$e13cce2a2d16a9d4 = $9ec4f31fbae764a3$export$36ad6df0f83f284d.purple;
var $9ec4f31fbae764a3$export$2a9ca2e383622e18 = $9ec4f31fbae764a3$export$36ad6df0f83f284d.magenta;
var $9ec4f31fbae764a3$export$e4c89085febbc618 = $9ec4f31fbae764a3$export$36ad6df0f83f284d.grey;



var $acw62 = parcelRequire("acw62");

function $c6daeb3adc2b0e60$export$2e2bcd8739ae039() {
    return !!(typeof window !== "undefined" && window.document && window.document.createElement);
}


function $97b4b0194c593c05$export$2e2bcd8739ae039(root, n) {
    if (!root) return false;
    // Use native if support
    if (root.contains) return root.contains(n);
    // `document.contains` not support with IE11
    var node = n;
    while(node){
        if (node === root) return true;
        node = node.parentNode;
    }
    return false;
}


var $3a22468320d7d808$var$APPEND_ORDER = "data-rc-order";
var $3a22468320d7d808$var$APPEND_PRIORITY = "data-rc-priority";
var $3a22468320d7d808$var$MARK_KEY = "rc-util-key";
var $3a22468320d7d808$var$containerCache = new Map();
function $3a22468320d7d808$var$getMark() {
    var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {}, mark = _ref.mark;
    if (mark) return mark.startsWith("data-") ? mark : "data-".concat(mark);
    return $3a22468320d7d808$var$MARK_KEY;
}
function $3a22468320d7d808$var$getContainer(option) {
    if (option.attachTo) return option.attachTo;
    var head = document.querySelector("head");
    return head || document.body;
}
function $3a22468320d7d808$var$getOrder(prepend) {
    if (prepend === "queue") return "prependQueue";
    return prepend ? "prepend" : "append";
}
/**
 * Find style which inject by rc-util
 */ function $3a22468320d7d808$var$findStyles(container) {
    return Array.from(($3a22468320d7d808$var$containerCache.get(container) || container).children).filter(function(node) {
        return node.tagName === "STYLE";
    });
}
function $3a22468320d7d808$export$1ab5838465dbd10a(css) {
    var option = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    if (!(0, $c6daeb3adc2b0e60$export$2e2bcd8739ae039)()) return null;
    var csp = option.csp, prepend = option.prepend, _option$priority = option.priority, priority = _option$priority === void 0 ? 0 : _option$priority;
    var mergedOrder = $3a22468320d7d808$var$getOrder(prepend);
    var isPrependQueue = mergedOrder === "prependQueue";
    var styleNode = document.createElement("style");
    styleNode.setAttribute($3a22468320d7d808$var$APPEND_ORDER, mergedOrder);
    if (isPrependQueue && priority) styleNode.setAttribute($3a22468320d7d808$var$APPEND_PRIORITY, "".concat(priority));
    if (csp !== null && csp !== void 0 && csp.nonce) styleNode.nonce = csp === null || csp === void 0 ? void 0 : csp.nonce;
    styleNode.innerHTML = css;
    var container = $3a22468320d7d808$var$getContainer(option);
    var firstChild = container.firstChild;
    if (prepend) {
        // If is queue `prepend`, it will prepend first style and then append rest style
        if (isPrependQueue) {
            var existStyle = $3a22468320d7d808$var$findStyles(container).filter(function(node) {
                // Ignore style which not injected by rc-util with prepend
                if (![
                    "prepend",
                    "prependQueue"
                ].includes(node.getAttribute($3a22468320d7d808$var$APPEND_ORDER))) return false;
                // Ignore style which priority less then new style
                var nodePriority = Number(node.getAttribute($3a22468320d7d808$var$APPEND_PRIORITY) || 0);
                return priority >= nodePriority;
            });
            if (existStyle.length) {
                container.insertBefore(styleNode, existStyle[existStyle.length - 1].nextSibling);
                return styleNode;
            }
        }
        // Use `insertBefore` as `prepend`
        container.insertBefore(styleNode, firstChild);
    } else container.appendChild(styleNode);
    return styleNode;
}
function $3a22468320d7d808$var$findExistNode(key) {
    var option = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var container = $3a22468320d7d808$var$getContainer(option);
    return $3a22468320d7d808$var$findStyles(container).find(function(node) {
        return node.getAttribute($3a22468320d7d808$var$getMark(option)) === key;
    });
}
function $3a22468320d7d808$export$2232e336aecaa80a(key) {
    var option = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var existNode = $3a22468320d7d808$var$findExistNode(key, option);
    if (existNode) {
        var container = $3a22468320d7d808$var$getContainer(option);
        container.removeChild(existNode);
    }
}
/**
 * qiankun will inject `appendChild` to insert into other
 */ function $3a22468320d7d808$var$syncRealContainer(container, option) {
    var cachedRealContainer = $3a22468320d7d808$var$containerCache.get(container);
    // Find real container when not cached or cached container removed
    if (!cachedRealContainer || !(0, $97b4b0194c593c05$export$2e2bcd8739ae039)(document, cachedRealContainer)) {
        var placeholderStyle = $3a22468320d7d808$export$1ab5838465dbd10a("", option);
        var parentNode = placeholderStyle.parentNode;
        $3a22468320d7d808$var$containerCache.set(container, parentNode);
        container.removeChild(placeholderStyle);
    }
}
function $3a22468320d7d808$export$f80df667f2f5a272() {
    $3a22468320d7d808$var$containerCache.clear();
}
function $3a22468320d7d808$export$4d99a2890bb989f0(css, key) {
    var option = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    var container = $3a22468320d7d808$var$getContainer(option);
    // Sync real parent
    $3a22468320d7d808$var$syncRealContainer(container, option);
    var existNode = $3a22468320d7d808$var$findExistNode(key, option);
    if (existNode) {
        var _option$csp, _option$csp2;
        if ((_option$csp = option.csp) !== null && _option$csp !== void 0 && _option$csp.nonce && existNode.nonce !== ((_option$csp2 = option.csp) === null || _option$csp2 === void 0 ? void 0 : _option$csp2.nonce)) {
            var _option$csp3;
            existNode.nonce = (_option$csp3 = option.csp) === null || _option$csp3 === void 0 ? void 0 : _option$csp3.nonce;
        }
        if (existNode.innerHTML !== css) existNode.innerHTML = css;
        return existNode;
    }
    var newNode = $3a22468320d7d808$export$1ab5838465dbd10a(css, option);
    newNode.setAttribute($3a22468320d7d808$var$getMark(option), key);
    return newNode;
}




function $1beccdf56290315b$export$491112666e282270(valid, message) {
    (0, $05a5f2c645683a81$export$2e2bcd8739ae039)(valid, "[@ant-design/icons] ".concat(message));
}
function $1beccdf56290315b$export$ab652842c37578f4(target) {
    return (0, $b8f57191916382d3$export$2e2bcd8739ae039)(target) === "object" && typeof target.name === "string" && typeof target.theme === "string" && ((0, $b8f57191916382d3$export$2e2bcd8739ae039)(target.icon) === "object" || typeof target.icon === "function");
}
function $1beccdf56290315b$export$9f5073e7201cc21c() {
    var attrs = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    return Object.keys(attrs).reduce(function(acc, key) {
        var val = attrs[key];
        switch(key){
            case "class":
                acc.className = val;
                delete acc.class;
                break;
            default:
                delete acc[key];
                acc[(0, (/*@__PURE__*/$parcel$interopDefault($d57e6f3349076887$exports)))(key)] = val;
        }
        return acc;
    }, {});
}
function $1beccdf56290315b$export$80d376111cc09ad7(node, key, rootProps) {
    if (!rootProps) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(node.tag, (0, $983350b7b3960a26$export$2e2bcd8739ae039)({
        key: key
    }, $1beccdf56290315b$export$9f5073e7201cc21c(node.attrs)), (node.children || []).map(function(child, index) {
        return $1beccdf56290315b$export$80d376111cc09ad7(child, "".concat(key, "-").concat(node.tag, "-").concat(index));
    }));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(node.tag, (0, $983350b7b3960a26$export$2e2bcd8739ae039)((0, $983350b7b3960a26$export$2e2bcd8739ae039)({
        key: key
    }, $1beccdf56290315b$export$9f5073e7201cc21c(node.attrs)), rootProps), (node.children || []).map(function(child, index) {
        return $1beccdf56290315b$export$80d376111cc09ad7(child, "".concat(key, "-").concat(node.tag, "-").concat(index));
    }));
}
function $1beccdf56290315b$export$b71c93f469694483(primaryColor) {
    // choose the second color
    return (0, $9ec4f31fbae764a3$export$80d376111cc09ad7)(primaryColor)[0];
}
function $1beccdf56290315b$export$b5b464c3d8433a9b(twoToneColor) {
    if (!twoToneColor) return [];
    return Array.isArray(twoToneColor) ? twoToneColor : [
        twoToneColor
    ];
}
var $1beccdf56290315b$export$960a899a9cccb2d5 = {
    width: "1em",
    height: "1em",
    fill: "currentColor",
    "aria-hidden": "true",
    focusable: "false"
};
var $1beccdf56290315b$export$2c99b98b77550cb4 = "\n.anticon {\n  display: inline-block;\n  color: inherit;\n  font-style: normal;\n  line-height: 0;\n  text-align: center;\n  text-transform: none;\n  vertical-align: -0.125em;\n  text-rendering: optimizeLegibility;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n}\n\n.anticon > * {\n  line-height: 1;\n}\n\n.anticon svg {\n  display: inline-block;\n}\n\n.anticon::before {\n  display: none;\n}\n\n.anticon .anticon-icon {\n  display: block;\n}\n\n.anticon[tabindex] {\n  cursor: pointer;\n}\n\n.anticon-spin::before,\n.anticon-spin {\n  display: inline-block;\n  -webkit-animation: loadingCircle 1s infinite linear;\n  animation: loadingCircle 1s infinite linear;\n}\n\n@-webkit-keyframes loadingCircle {\n  100% {\n    -webkit-transform: rotate(360deg);\n    transform: rotate(360deg);\n  }\n}\n\n@keyframes loadingCircle {\n  100% {\n    -webkit-transform: rotate(360deg);\n    transform: rotate(360deg);\n  }\n}\n";
var $1beccdf56290315b$export$938b1f86b61613d0 = function useInsertStyles() {
    var styleStr = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : $1beccdf56290315b$export$2c99b98b77550cb4;
    var _useContext = (0, $acw62.useContext)((0, $6bacc63174d40f3c$export$2e2bcd8739ae039)), csp = _useContext.csp;
    (0, $acw62.useEffect)(function() {
        (0, $3a22468320d7d808$export$4d99a2890bb989f0)(styleStr, "@ant-design-icons", {
            prepend: true,
            csp: csp
        });
    }, []);
};


var $c52e7cd4d4f30fad$var$_excluded = [
    "icon",
    "className",
    "onClick",
    "style",
    "primaryColor",
    "secondaryColor"
];
var $c52e7cd4d4f30fad$var$twoToneColorPalette = {
    primaryColor: "#333",
    secondaryColor: "#E6E6E6",
    calculated: false
};
function $c52e7cd4d4f30fad$var$setTwoToneColors(_ref) {
    var primaryColor = _ref.primaryColor, secondaryColor = _ref.secondaryColor;
    $c52e7cd4d4f30fad$var$twoToneColorPalette.primaryColor = primaryColor;
    $c52e7cd4d4f30fad$var$twoToneColorPalette.secondaryColor = secondaryColor || (0, $1beccdf56290315b$export$b71c93f469694483)(primaryColor);
    $c52e7cd4d4f30fad$var$twoToneColorPalette.calculated = !!secondaryColor;
}
function $c52e7cd4d4f30fad$var$getTwoToneColors() {
    return (0, $983350b7b3960a26$export$2e2bcd8739ae039)({}, $c52e7cd4d4f30fad$var$twoToneColorPalette);
}
var $c52e7cd4d4f30fad$var$IconBase = function IconBase(props) {
    var icon = props.icon, className = props.className, onClick = props.onClick, style = props.style, primaryColor = props.primaryColor, secondaryColor = props.secondaryColor, restProps = (0, $73ef9ce1c41fc0c0$export$2e2bcd8739ae039)(props, $c52e7cd4d4f30fad$var$_excluded);
    var colors = $c52e7cd4d4f30fad$var$twoToneColorPalette;
    if (primaryColor) colors = {
        primaryColor: primaryColor,
        secondaryColor: secondaryColor || (0, $1beccdf56290315b$export$b71c93f469694483)(primaryColor)
    };
    (0, $1beccdf56290315b$export$938b1f86b61613d0)();
    (0, $1beccdf56290315b$export$491112666e282270)((0, $1beccdf56290315b$export$ab652842c37578f4)(icon), "icon should be icon definiton, but got ".concat(icon));
    if (!(0, $1beccdf56290315b$export$ab652842c37578f4)(icon)) return null;
    var target = icon;
    if (target && typeof target.icon === "function") target = (0, $983350b7b3960a26$export$2e2bcd8739ae039)((0, $983350b7b3960a26$export$2e2bcd8739ae039)({}, target), {}, {
        icon: target.icon(colors.primaryColor, colors.secondaryColor)
    });
    return (0, $1beccdf56290315b$export$80d376111cc09ad7)(target.icon, "svg-".concat(target.name), (0, $983350b7b3960a26$export$2e2bcd8739ae039)({
        className: className,
        onClick: onClick,
        style: style,
        "data-icon": target.name,
        width: "1em",
        height: "1em",
        fill: "currentColor",
        "aria-hidden": "true"
    }, restProps));
};
$c52e7cd4d4f30fad$var$IconBase.displayName = "IconReact";
$c52e7cd4d4f30fad$var$IconBase.getTwoToneColors = $c52e7cd4d4f30fad$var$getTwoToneColors;
$c52e7cd4d4f30fad$var$IconBase.setTwoToneColors = $c52e7cd4d4f30fad$var$setTwoToneColors;
var $c52e7cd4d4f30fad$export$2e2bcd8739ae039 = $c52e7cd4d4f30fad$var$IconBase;





function $27dd37ce58e7c6e8$export$8a145f34580ff02b(twoToneColor) {
    var _normalizeTwoToneColo = (0, $1beccdf56290315b$export$b5b464c3d8433a9b)(twoToneColor), _normalizeTwoToneColo2 = (0, $adaabbc18727b3e6$export$2e2bcd8739ae039)(_normalizeTwoToneColo, 2), primaryColor = _normalizeTwoToneColo2[0], secondaryColor = _normalizeTwoToneColo2[1];
    return (0, $c52e7cd4d4f30fad$export$2e2bcd8739ae039).setTwoToneColors({
        primaryColor: primaryColor,
        secondaryColor: secondaryColor
    });
}
function $27dd37ce58e7c6e8$export$abc7c554784cb4a7() {
    var colors = (0, $c52e7cd4d4f30fad$export$2e2bcd8739ae039).getTwoToneColors();
    if (!colors.calculated) return colors.primaryColor;
    return [
        colors.primaryColor,
        colors.secondaryColor
    ];
}



var $7714637e9c1f1f3f$var$_excluded = [
    "className",
    "icon",
    "spin",
    "rotate",
    "tabIndex",
    "onClick",
    "twoToneColor"
];
// Initial setting
// should move it to antd main repo?
(0, $27dd37ce58e7c6e8$export$8a145f34580ff02b)("#1890ff");
var $7714637e9c1f1f3f$var$Icon = /*#__PURE__*/ $acw62.forwardRef(function(props, ref) {
    var _classNames;
    var className = props.className, icon = props.icon, spin = props.spin, rotate = props.rotate, tabIndex = props.tabIndex, onClick = props.onClick, twoToneColor = props.twoToneColor, restProps = (0, $73ef9ce1c41fc0c0$export$2e2bcd8739ae039)(props, $7714637e9c1f1f3f$var$_excluded);
    var _React$useContext = $acw62.useContext((0, $6bacc63174d40f3c$export$2e2bcd8739ae039)), _React$useContext$pre = _React$useContext.prefixCls, prefixCls = _React$useContext$pre === void 0 ? "anticon" : _React$useContext$pre, rootClassName = _React$useContext.rootClassName;
    var classString = (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))(rootClassName, prefixCls, (_classNames = {}, (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)(_classNames, "".concat(prefixCls, "-").concat(icon.name), !!icon.name), (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)(_classNames, "".concat(prefixCls, "-spin"), !!spin || icon.name === "loading"), _classNames), className);
    var iconTabIndex = tabIndex;
    if (iconTabIndex === undefined && onClick) iconTabIndex = -1;
    var svgStyle = rotate ? {
        msTransform: "rotate(".concat(rotate, "deg)"),
        transform: "rotate(".concat(rotate, "deg)")
    } : undefined;
    var _normalizeTwoToneColo = (0, $1beccdf56290315b$export$b5b464c3d8433a9b)(twoToneColor), _normalizeTwoToneColo2 = (0, $adaabbc18727b3e6$export$2e2bcd8739ae039)(_normalizeTwoToneColo, 2), primaryColor = _normalizeTwoToneColo2[0], secondaryColor = _normalizeTwoToneColo2[1];
    return /*#__PURE__*/ $acw62.createElement("span", (0, $983350b7b3960a26$export$2e2bcd8739ae039)((0, $983350b7b3960a26$export$2e2bcd8739ae039)({
        role: "img",
        "aria-label": icon.name
    }, restProps), {}, {
        ref: ref,
        tabIndex: iconTabIndex,
        onClick: onClick,
        className: classString
    }), /*#__PURE__*/ $acw62.createElement((0, $c52e7cd4d4f30fad$export$2e2bcd8739ae039), {
        icon: icon,
        primaryColor: primaryColor,
        secondaryColor: secondaryColor,
        style: svgStyle
    }));
});
$7714637e9c1f1f3f$var$Icon.displayName = "AntdIcon";
$7714637e9c1f1f3f$var$Icon.getTwoToneColor = (0, $27dd37ce58e7c6e8$export$abc7c554784cb4a7);
$7714637e9c1f1f3f$var$Icon.setTwoToneColor = (0, $27dd37ce58e7c6e8$export$8a145f34580ff02b);
var $7714637e9c1f1f3f$export$2e2bcd8739ae039 = $7714637e9c1f1f3f$var$Icon;


var $9149fdfb4424d1d9$var$CheckCircleFilled = function CheckCircleFilled(props, ref) {
    return /*#__PURE__*/ $acw62.createElement((0, $7714637e9c1f1f3f$export$2e2bcd8739ae039), (0, $983350b7b3960a26$export$2e2bcd8739ae039)((0, $983350b7b3960a26$export$2e2bcd8739ae039)({}, props), {}, {
        ref: ref,
        icon: (0, $8e7f784a29e9449d$export$2e2bcd8739ae039)
    }));
};
$9149fdfb4424d1d9$var$CheckCircleFilled.displayName = "CheckCircleFilled";
var $9149fdfb4424d1d9$export$2e2bcd8739ae039 = /*#__PURE__*/ $acw62.forwardRef($9149fdfb4424d1d9$var$CheckCircleFilled);




var $acw62 = parcelRequire("acw62");
// This icon file is generated automatically.
var $0c349e8b6d22460f$var$CloseCircleFilled = {
    "icon": {
        "tag": "svg",
        "attrs": {
            "fill-rule": "evenodd",
            "viewBox": "64 64 896 896",
            "focusable": "false"
        },
        "children": [
            {
                "tag": "path",
                "attrs": {
                    "d": "M512 64c247.4 0 448 200.6 448 448S759.4 960 512 960 64 759.4 64 512 264.6 64 512 64zm127.98 274.82h-.04l-.08.06L512 466.75 384.14 338.88c-.04-.05-.06-.06-.08-.06a.12.12 0 00-.07 0c-.03 0-.05.01-.09.05l-45.02 45.02a.2.2 0 00-.05.09.12.12 0 000 .07v.02a.27.27 0 00.06.06L466.75 512 338.88 639.86c-.05.04-.06.06-.06.08a.12.12 0 000 .07c0 .03.01.05.05.09l45.02 45.02a.2.2 0 00.09.05.12.12 0 00.07 0c.02 0 .04-.01.08-.05L512 557.25l127.86 127.87c.04.04.06.05.08.05a.12.12 0 00.07 0c.03 0 .05-.01.09-.05l45.02-45.02a.2.2 0 00.05-.09.12.12 0 000-.07v-.02a.27.27 0 00-.05-.06L557.25 512l127.87-127.86c.04-.04.05-.06.05-.08a.12.12 0 000-.07c0-.03-.01-.05-.05-.09l-45.02-45.02a.2.2 0 00-.09-.05.12.12 0 00-.07 0z"
                }
            }
        ]
    },
    "name": "close-circle",
    "theme": "filled"
};
var $0c349e8b6d22460f$export$2e2bcd8739ae039 = $0c349e8b6d22460f$var$CloseCircleFilled;



var $81ff9dc68eb84eda$var$CloseCircleFilled = function CloseCircleFilled(props, ref) {
    return /*#__PURE__*/ $acw62.createElement((0, $7714637e9c1f1f3f$export$2e2bcd8739ae039), (0, $983350b7b3960a26$export$2e2bcd8739ae039)((0, $983350b7b3960a26$export$2e2bcd8739ae039)({}, props), {}, {
        ref: ref,
        icon: (0, $0c349e8b6d22460f$export$2e2bcd8739ae039)
    }));
};
$81ff9dc68eb84eda$var$CloseCircleFilled.displayName = "CloseCircleFilled";
var $81ff9dc68eb84eda$export$2e2bcd8739ae039 = /*#__PURE__*/ $acw62.forwardRef($81ff9dc68eb84eda$var$CloseCircleFilled);




var $acw62 = parcelRequire("acw62");
// This icon file is generated automatically.
var $ce0f95a23ea8b20d$var$ExclamationCircleFilled = {
    "icon": {
        "tag": "svg",
        "attrs": {
            "viewBox": "64 64 896 896",
            "focusable": "false"
        },
        "children": [
            {
                "tag": "path",
                "attrs": {
                    "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm-32 232c0-4.4 3.6-8 8-8h48c4.4 0 8 3.6 8 8v272c0 4.4-3.6 8-8 8h-48c-4.4 0-8-3.6-8-8V296zm32 440a48.01 48.01 0 010-96 48.01 48.01 0 010 96z"
                }
            }
        ]
    },
    "name": "exclamation-circle",
    "theme": "filled"
};
var $ce0f95a23ea8b20d$export$2e2bcd8739ae039 = $ce0f95a23ea8b20d$var$ExclamationCircleFilled;



var $2444f6da62064575$var$ExclamationCircleFilled = function ExclamationCircleFilled(props, ref) {
    return /*#__PURE__*/ $acw62.createElement((0, $7714637e9c1f1f3f$export$2e2bcd8739ae039), (0, $983350b7b3960a26$export$2e2bcd8739ae039)((0, $983350b7b3960a26$export$2e2bcd8739ae039)({}, props), {}, {
        ref: ref,
        icon: (0, $ce0f95a23ea8b20d$export$2e2bcd8739ae039)
    }));
};
$2444f6da62064575$var$ExclamationCircleFilled.displayName = "ExclamationCircleFilled";
var $2444f6da62064575$export$2e2bcd8739ae039 = /*#__PURE__*/ $acw62.forwardRef($2444f6da62064575$var$ExclamationCircleFilled);




var $acw62 = parcelRequire("acw62");
// This icon file is generated automatically.
var $57a9c466662aed09$var$InfoCircleFilled = {
    "icon": {
        "tag": "svg",
        "attrs": {
            "viewBox": "64 64 896 896",
            "focusable": "false"
        },
        "children": [
            {
                "tag": "path",
                "attrs": {
                    "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm32 664c0 4.4-3.6 8-8 8h-48c-4.4 0-8-3.6-8-8V456c0-4.4 3.6-8 8-8h48c4.4 0 8 3.6 8 8v272zm-32-344a48.01 48.01 0 010-96 48.01 48.01 0 010 96z"
                }
            }
        ]
    },
    "name": "info-circle",
    "theme": "filled"
};
var $57a9c466662aed09$export$2e2bcd8739ae039 = $57a9c466662aed09$var$InfoCircleFilled;



var $b5d5d018bfa4ba6e$var$InfoCircleFilled = function InfoCircleFilled(props, ref) {
    return /*#__PURE__*/ $acw62.createElement((0, $7714637e9c1f1f3f$export$2e2bcd8739ae039), (0, $983350b7b3960a26$export$2e2bcd8739ae039)((0, $983350b7b3960a26$export$2e2bcd8739ae039)({}, props), {}, {
        ref: ref,
        icon: (0, $57a9c466662aed09$export$2e2bcd8739ae039)
    }));
};
$b5d5d018bfa4ba6e$var$InfoCircleFilled.displayName = "InfoCircleFilled";
var $b5d5d018bfa4ba6e$export$2e2bcd8739ae039 = /*#__PURE__*/ $acw62.forwardRef($b5d5d018bfa4ba6e$var$InfoCircleFilled);




var $acw62 = parcelRequire("acw62");
// This icon file is generated automatically.
var $2b0f3084756e08d0$var$LoadingOutlined = {
    "icon": {
        "tag": "svg",
        "attrs": {
            "viewBox": "0 0 1024 1024",
            "focusable": "false"
        },
        "children": [
            {
                "tag": "path",
                "attrs": {
                    "d": "M988 548c-19.9 0-36-16.1-36-36 0-59.4-11.6-117-34.6-171.3a440.45 440.45 0 00-94.3-139.9 437.71 437.71 0 00-139.9-94.3C629 83.6 571.4 72 512 72c-19.9 0-36-16.1-36-36s16.1-36 36-36c69.1 0 136.2 13.5 199.3 40.3C772.3 66 827 103 874 150c47 47 83.9 101.8 109.7 162.7 26.7 63.1 40.2 130.2 40.2 199.3.1 19.9-16 36-35.9 36z"
                }
            }
        ]
    },
    "name": "loading",
    "theme": "outlined"
};
var $2b0f3084756e08d0$export$2e2bcd8739ae039 = $2b0f3084756e08d0$var$LoadingOutlined;



var $d8d56e1090f62915$var$LoadingOutlined = function LoadingOutlined(props, ref) {
    return /*#__PURE__*/ $acw62.createElement((0, $7714637e9c1f1f3f$export$2e2bcd8739ae039), (0, $983350b7b3960a26$export$2e2bcd8739ae039)((0, $983350b7b3960a26$export$2e2bcd8739ae039)({}, props), {}, {
        ref: ref,
        icon: (0, $2b0f3084756e08d0$export$2e2bcd8739ae039)
    }));
};
$d8d56e1090f62915$var$LoadingOutlined.displayName = "LoadingOutlined";
var $d8d56e1090f62915$export$2e2bcd8739ae039 = /*#__PURE__*/ $acw62.forwardRef($d8d56e1090f62915$var$LoadingOutlined);











var $acw62 = parcelRequire("acw62");

function $90d00d496f52c75c$export$2e2bcd8739ae039() {
    "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ 
    $90d00d496f52c75c$export$2e2bcd8739ae039 = function _regeneratorRuntime() {
        return e;
    };
    var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function(t, e, r) {
        t[e] = r.value;
    }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag";
    function define(t, e, r) {
        return Object.defineProperty(t, e, {
            value: r,
            enumerable: !0,
            configurable: !0,
            writable: !0
        }), t[e];
    }
    try {
        define({}, "");
    } catch (t) {
        define = function define(t, e, r) {
            return t[e] = r;
        };
    }
    function wrap(t, e, r, n) {
        var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []);
        return o(a, "_invoke", {
            value: makeInvokeMethod(t, r, c)
        }), a;
    }
    function tryCatch(t, e, r) {
        try {
            return {
                type: "normal",
                arg: t.call(e, r)
            };
        } catch (t) {
            return {
                type: "throw",
                arg: t
            };
        }
    }
    e.wrap = wrap;
    var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {};
    function Generator() {}
    function GeneratorFunction() {}
    function GeneratorFunctionPrototype() {}
    var p = {};
    define(p, a, function() {
        return this;
    });
    var d = Object.getPrototypeOf, v = d && d(d(values([])));
    v && v !== r && n.call(v, a) && (p = v);
    var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p);
    function defineIteratorMethods(t) {
        [
            "next",
            "throw",
            "return"
        ].forEach(function(e) {
            define(t, e, function(t) {
                return this._invoke(e, t);
            });
        });
    }
    function AsyncIterator(t, e) {
        function invoke(r, o, i, a) {
            var c = tryCatch(t[r], t, o);
            if ("throw" !== c.type) {
                var u = c.arg, h = u.value;
                return h && "object" == (0, $b8f57191916382d3$export$2e2bcd8739ae039)(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function(t) {
                    invoke("next", t, i, a);
                }, function(t) {
                    invoke("throw", t, i, a);
                }) : e.resolve(h).then(function(t) {
                    u.value = t, i(u);
                }, function(t) {
                    return invoke("throw", t, i, a);
                });
            }
            a(c.arg);
        }
        var r;
        o(this, "_invoke", {
            value: function value(t, n) {
                function callInvokeWithMethodAndArg() {
                    return new e(function(e, r) {
                        invoke(t, n, e, r);
                    });
                }
                return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg();
            }
        });
    }
    function makeInvokeMethod(e, r, n) {
        var o = h;
        return function(i, a) {
            if (o === f) throw new Error("Generator is already running");
            if (o === s) {
                if ("throw" === i) throw a;
                return {
                    value: t,
                    done: !0
                };
            }
            for(n.method = i, n.arg = a;;){
                var c = n.delegate;
                if (c) {
                    var u = maybeInvokeDelegate(c, n);
                    if (u) {
                        if (u === y) continue;
                        return u;
                    }
                }
                if ("next" === n.method) n.sent = n._sent = n.arg;
                else if ("throw" === n.method) {
                    if (o === h) throw o = s, n.arg;
                    n.dispatchException(n.arg);
                } else "return" === n.method && n.abrupt("return", n.arg);
                o = f;
                var p = tryCatch(e, r, n);
                if ("normal" === p.type) {
                    if (o = n.done ? s : l, p.arg === y) continue;
                    return {
                        value: p.arg,
                        done: n.done
                    };
                }
                "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg);
            }
        };
    }
    function maybeInvokeDelegate(e, r) {
        var n = r.method, o = e.iterator[n];
        if (o === t) return r.delegate = null, "throw" === n && e.iterator["return"] && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y;
        var i = tryCatch(o, e.iterator, r.arg);
        if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y;
        var a = i.arg;
        return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y);
    }
    function pushTryEntry(t) {
        var e = {
            tryLoc: t[0]
        };
        1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e);
    }
    function resetTryEntry(t) {
        var e = t.completion || {};
        e.type = "normal", delete e.arg, t.completion = e;
    }
    function Context(t) {
        this.tryEntries = [
            {
                tryLoc: "root"
            }
        ], t.forEach(pushTryEntry, this), this.reset(!0);
    }
    function values(e) {
        if (e || "" === e) {
            var r = e[a];
            if (r) return r.call(e);
            if ("function" == typeof e.next) return e;
            if (!isNaN(e.length)) {
                var o = -1, i = function next() {
                    for(; ++o < e.length;)if (n.call(e, o)) return next.value = e[o], next.done = !1, next;
                    return next.value = t, next.done = !0, next;
                };
                return i.next = i;
            }
        }
        throw new TypeError((0, $b8f57191916382d3$export$2e2bcd8739ae039)(e) + " is not iterable");
    }
    return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", {
        value: GeneratorFunctionPrototype,
        configurable: !0
    }), o(GeneratorFunctionPrototype, "constructor", {
        value: GeneratorFunction,
        configurable: !0
    }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function(t) {
        var e = "function" == typeof t && t.constructor;
        return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name));
    }, e.mark = function(t) {
        return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t;
    }, e.awrap = function(t) {
        return {
            __await: t
        };
    }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function() {
        return this;
    }), e.AsyncIterator = AsyncIterator, e.async = function(t, r, n, o, i) {
        void 0 === i && (i = Promise);
        var a = new AsyncIterator(wrap(t, r, n, o), i);
        return e.isGeneratorFunction(r) ? a : a.next().then(function(t) {
            return t.done ? t.value : a.next();
        });
    }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function() {
        return this;
    }), define(g, "toString", function() {
        return "[object Generator]";
    }), e.keys = function(t) {
        var e = Object(t), r = [];
        for(var n in e)r.push(n);
        return r.reverse(), function next() {
            for(; r.length;){
                var t = r.pop();
                if (t in e) return next.value = t, next.done = !1, next;
            }
            return next.done = !0, next;
        };
    }, e.values = values, Context.prototype = {
        constructor: Context,
        reset: function reset(e) {
            if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for(var r in this)"t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t);
        },
        stop: function stop() {
            this.done = !0;
            var t = this.tryEntries[0].completion;
            if ("throw" === t.type) throw t.arg;
            return this.rval;
        },
        dispatchException: function dispatchException(e) {
            if (this.done) throw e;
            var r = this;
            function handle(n, o) {
                return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o;
            }
            for(var o = this.tryEntries.length - 1; o >= 0; --o){
                var i = this.tryEntries[o], a = i.completion;
                if ("root" === i.tryLoc) return handle("end");
                if (i.tryLoc <= this.prev) {
                    var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc");
                    if (c && u) {
                        if (this.prev < i.catchLoc) return handle(i.catchLoc, !0);
                        if (this.prev < i.finallyLoc) return handle(i.finallyLoc);
                    } else if (c) {
                        if (this.prev < i.catchLoc) return handle(i.catchLoc, !0);
                    } else {
                        if (!u) throw new Error("try statement without catch or finally");
                        if (this.prev < i.finallyLoc) return handle(i.finallyLoc);
                    }
                }
            }
        },
        abrupt: function abrupt(t, e) {
            for(var r = this.tryEntries.length - 1; r >= 0; --r){
                var o = this.tryEntries[r];
                if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) {
                    var i = o;
                    break;
                }
            }
            i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null);
            var a = i ? i.completion : {};
            return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a);
        },
        complete: function complete(t, e) {
            if ("throw" === t.type) throw t.arg;
            return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y;
        },
        finish: function finish(t) {
            for(var e = this.tryEntries.length - 1; e >= 0; --e){
                var r = this.tryEntries[e];
                if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y;
            }
        },
        "catch": function _catch(t) {
            for(var e = this.tryEntries.length - 1; e >= 0; --e){
                var r = this.tryEntries[e];
                if (r.tryLoc === t) {
                    var n = r.completion;
                    if ("throw" === n.type) {
                        var o = n.arg;
                        resetTryEntry(r);
                    }
                    return o;
                }
            }
            throw new Error("illegal catch attempt");
        },
        delegateYield: function delegateYield(e, r, n) {
            return this.delegate = {
                iterator: values(e),
                resultName: r,
                nextLoc: n
            }, "next" === this.method && (this.arg = t), y;
        }
    }, e;
}


function $4051039ece381ef4$var$asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) resolve(value);
    else Promise.resolve(value).then(_next, _throw);
}
function $4051039ece381ef4$export$2e2bcd8739ae039(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                $4051039ece381ef4$var$asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                $4051039ece381ef4$var$asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}





var $1u0KT = parcelRequire("1u0KT");
// Let compiler not to search module usage
var $db3659e597d7eb55$var$fullClone = (0, $983350b7b3960a26$export$2e2bcd8739ae039)({}, $1u0KT);
var $db3659e597d7eb55$var$version = $db3659e597d7eb55$var$fullClone.version, $db3659e597d7eb55$var$reactRender = $db3659e597d7eb55$var$fullClone.render, $db3659e597d7eb55$var$unmountComponentAtNode = $db3659e597d7eb55$var$fullClone.unmountComponentAtNode;
var $db3659e597d7eb55$var$createRoot;
try {
    var $db3659e597d7eb55$var$mainVersion = Number(($db3659e597d7eb55$var$version || "").split(".")[0]);
    if ($db3659e597d7eb55$var$mainVersion >= 18) $db3659e597d7eb55$var$createRoot = $db3659e597d7eb55$var$fullClone.createRoot;
} catch (e) {
// Do nothing;
}
function $db3659e597d7eb55$var$toggleWarning(skip) {
    var __SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED = $db3659e597d7eb55$var$fullClone.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    if (__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED && (0, $b8f57191916382d3$export$2e2bcd8739ae039)(__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED) === "object") __SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.usingClientEntryPoint = skip;
}
var $db3659e597d7eb55$var$MARK = "__rc_react_root__";
// ========================== Render ==========================
function $db3659e597d7eb55$var$modernRender(node, container) {
    $db3659e597d7eb55$var$toggleWarning(true);
    var root = container[$db3659e597d7eb55$var$MARK] || $db3659e597d7eb55$var$createRoot(container);
    $db3659e597d7eb55$var$toggleWarning(false);
    root.render(node);
    container[$db3659e597d7eb55$var$MARK] = root;
}
function $db3659e597d7eb55$var$legacyRender(node, container) {
    $db3659e597d7eb55$var$reactRender(node, container);
}
function $db3659e597d7eb55$export$892c6608f54d7438(node, container) {
    return $db3659e597d7eb55$var$legacyRender(node, container);
}
function $db3659e597d7eb55$export$b3890eb0ae9dca99(node, container) {
    if ($db3659e597d7eb55$var$createRoot) {
        $db3659e597d7eb55$var$modernRender(node, container);
        return;
    }
    $db3659e597d7eb55$var$legacyRender(node, container);
}
// ========================= Unmount ==========================
function $db3659e597d7eb55$var$modernUnmount(_x) {
    return $db3659e597d7eb55$var$_modernUnmount.apply(this, arguments);
}
function $db3659e597d7eb55$var$_modernUnmount() {
    $db3659e597d7eb55$var$_modernUnmount = (0, $4051039ece381ef4$export$2e2bcd8739ae039)(/*#__PURE__*/ (0, $90d00d496f52c75c$export$2e2bcd8739ae039)().mark(function _callee(container) {
        return (0, $90d00d496f52c75c$export$2e2bcd8739ae039)().wrap(function _callee$(_context) {
            while(true)switch(_context.prev = _context.next){
                case 0:
                    return _context.abrupt("return", Promise.resolve().then(function() {
                        var _container$MARK;
                        (_container$MARK = container[$db3659e597d7eb55$var$MARK]) === null || _container$MARK === void 0 || _container$MARK.unmount();
                        delete container[$db3659e597d7eb55$var$MARK];
                    }));
                case 1:
                case "end":
                    return _context.stop();
            }
        }, _callee);
    }));
    return $db3659e597d7eb55$var$_modernUnmount.apply(this, arguments);
}
function $db3659e597d7eb55$var$legacyUnmount(container) {
    $db3659e597d7eb55$var$unmountComponentAtNode(container);
}
function $db3659e597d7eb55$export$fd39fe14445b207a(container) {
    return $db3659e597d7eb55$var$legacyUnmount(container);
}
function $db3659e597d7eb55$export$121e2d597d222bad(_x2) {
    return $db3659e597d7eb55$var$_unmount.apply(this, arguments);
}
function $db3659e597d7eb55$var$_unmount() {
    $db3659e597d7eb55$var$_unmount = (0, $4051039ece381ef4$export$2e2bcd8739ae039)(/*#__PURE__*/ (0, $90d00d496f52c75c$export$2e2bcd8739ae039)().mark(function _callee2(container) {
        return (0, $90d00d496f52c75c$export$2e2bcd8739ae039)().wrap(function _callee2$(_context2) {
            while(true)switch(_context2.prev = _context2.next){
                case 0:
                    if (!($db3659e597d7eb55$var$createRoot !== undefined)) {
                        _context2.next = 2;
                        break;
                    }
                    return _context2.abrupt("return", $db3659e597d7eb55$var$modernUnmount(container));
                case 2:
                    $db3659e597d7eb55$var$legacyUnmount(container);
                case 3:
                case "end":
                    return _context2.stop();
            }
        }, _callee2);
    }));
    return $db3659e597d7eb55$var$_unmount.apply(this, arguments);
}









var $acw62 = parcelRequire("acw62");

var $1u0KT = parcelRequire("1u0KT");
function $808ab7b8a87ab771$export$41e30d8dd0ba7a50(node) {
    // https://developer.mozilla.org/en-US/docs/Web/API/Element
    // Since XULElement is also subclass of Element, we only need HTMLElement and SVGElement
    return node instanceof HTMLElement || node instanceof SVGElement;
}
function $808ab7b8a87ab771$export$2e2bcd8739ae039(node) {
    if ($808ab7b8a87ab771$export$41e30d8dd0ba7a50(node)) return node;
    if (node instanceof (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Component) return (0, (/*@__PURE__*/$parcel$interopDefault($1u0KT))).findDOMNode(node);
    return null;
}




var $acw62 = parcelRequire("acw62");
var $faafdfae2a498d83$exports = {};
"use strict";

$faafdfae2a498d83$exports = (parcelRequire("kTOWR"));



function $5e297877593af644$export$f17fd18fa51dcb5b(ref, node) {
    if (typeof ref === "function") ref(node);
    else if ((0, $b8f57191916382d3$export$2e2bcd8739ae039)(ref) === "object" && ref && "current" in ref) ref.current = node;
}
function $5e297877593af644$export$ab452c34e8e05029() {
    for(var _len = arguments.length, refs = new Array(_len), _key = 0; _key < _len; _key++)refs[_key] = arguments[_key];
    var refList = refs.filter(function(ref) {
        return ref;
    });
    if (refList.length <= 1) return refList[0];
    return function(node) {
        refs.forEach(function(ref) {
            $5e297877593af644$export$f17fd18fa51dcb5b(ref, node);
        });
    };
}
function $5e297877593af644$export$1d1c999670a1285d() {
    for(var _len2 = arguments.length, refs = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)refs[_key2] = arguments[_key2];
    return (0, $2e4d16a6147a082d$export$2e2bcd8739ae039)(function() {
        return $5e297877593af644$export$ab452c34e8e05029.apply(void 0, refs);
    }, refs, function(prev, next) {
        return prev.length !== next.length || prev.every(function(ref, i) {
            return ref !== next[i];
        });
    });
}
function $5e297877593af644$export$c1cec34af06bcf7(nodeOrComponent) {
    var _type$prototype, _nodeOrComponent$prot;
    var type = (0, $faafdfae2a498d83$exports.isMemo)(nodeOrComponent) ? nodeOrComponent.type.type : nodeOrComponent.type;
    // Function component node
    if (typeof type === "function" && !((_type$prototype = type.prototype) !== null && _type$prototype !== void 0 && _type$prototype.render)) return false;
    // Class component
    if (typeof nodeOrComponent === "function" && !((_nodeOrComponent$prot = nodeOrComponent.prototype) !== null && _nodeOrComponent$prot !== void 0 && _nodeOrComponent$prot.render)) return false;
    return true;
}
function $5e297877593af644$export$b51ae67c7882a242(node) {
    if (!/*#__PURE__*/ (0, $acw62.isValidElement)(node)) return false;
    if ((0, $faafdfae2a498d83$exports.isFragment)(node)) return false;
    return $5e297877593af644$export$c1cec34af06bcf7(node);
} /* eslint-enable */ 



var $acw62 = parcelRequire("acw62");


var $acw62 = parcelRequire("acw62");
var $7b776f21b7918d7b$var$_excluded = [
    "children"
];
var $7b776f21b7918d7b$export$841858b892ce1f4c = /*#__PURE__*/ $acw62.createContext({});
function $7b776f21b7918d7b$export$2e2bcd8739ae039(_ref) {
    var children = _ref.children, props = (0, $73ef9ce1c41fc0c0$export$2e2bcd8739ae039)(_ref, $7b776f21b7918d7b$var$_excluded);
    return /*#__PURE__*/ $acw62.createElement($7b776f21b7918d7b$export$841858b892ce1f4c.Provider, {
        value: props
    }, children);
}







var $acw62 = parcelRequire("acw62");
var $e37a565edd3e4d81$var$DomWrapper = /*#__PURE__*/ function(_React$Component) {
    (0, $0ed648f7bbaf3aff$export$2e2bcd8739ae039)(DomWrapper, _React$Component);
    var _super = (0, $a76f20fb39fa9d46$export$2e2bcd8739ae039)(DomWrapper);
    function DomWrapper() {
        (0, $4d35ca0862055760$export$2e2bcd8739ae039)(this, DomWrapper);
        return _super.apply(this, arguments);
    }
    (0, $94019358ecbcf36b$export$2e2bcd8739ae039)(DomWrapper, [
        {
            key: "render",
            value: function render() {
                return this.props.children;
            }
        }
    ]);
    return DomWrapper;
}($acw62.Component);
var $e37a565edd3e4d81$export$2e2bcd8739ae039 = $e37a565edd3e4d81$var$DomWrapper;







var $acw62 = parcelRequire("acw62");
function $25e137fc56329ad1$export$2e2bcd8739ae039(defaultValue) {
    var destroyRef = $acw62.useRef(false);
    var _React$useState = $acw62.useState(defaultValue), _React$useState2 = (0, $adaabbc18727b3e6$export$2e2bcd8739ae039)(_React$useState, 2), value = _React$useState2[0], setValue = _React$useState2[1];
    $acw62.useEffect(function() {
        destroyRef.current = false;
        return function() {
            destroyRef.current = true;
        };
    }, []);
    function safeSetState(updater, ignoreDestroy) {
        if (ignoreDestroy && destroyRef.current) return;
        setValue(updater);
    }
    return [
        value,
        safeSetState
    ];
}



var $acw62 = parcelRequire("acw62");
var $0e817525d7f1f474$export$de71442bbf2143da = "none";
var $0e817525d7f1f474$export$4fc3521687bcacd2 = "appear";
var $0e817525d7f1f474$export$5d6af549241fe2e8 = "enter";
var $0e817525d7f1f474$export$59b1c493d29f68e4 = "leave";
var $0e817525d7f1f474$export$40b34dd77d5522bf = "none";
var $0e817525d7f1f474$export$1b792916a5fac4fc = "prepare";
var $0e817525d7f1f474$export$9563153dd25a3ce8 = "start";
var $0e817525d7f1f474$export$e205886172277ec6 = "active";
var $0e817525d7f1f474$export$3a846c3d2fac10b8 = "end";
var $0e817525d7f1f474$export$98351fa4e6b4f204 = "prepared";



var $acw62 = parcelRequire("acw62");


// ================= Transition =================
// Event wrapper. Copy from react source code
function $c24d790a085c6d93$var$makePrefixMap(styleProp, eventName) {
    var prefixes = {};
    prefixes[styleProp.toLowerCase()] = eventName.toLowerCase();
    prefixes["Webkit".concat(styleProp)] = "webkit".concat(eventName);
    prefixes["Moz".concat(styleProp)] = "moz".concat(eventName);
    prefixes["ms".concat(styleProp)] = "MS".concat(eventName);
    prefixes["O".concat(styleProp)] = "o".concat(eventName.toLowerCase());
    return prefixes;
}
function $c24d790a085c6d93$export$6e8b350b1a8958a0(domSupport, win) {
    var prefixes = {
        animationend: $c24d790a085c6d93$var$makePrefixMap("Animation", "AnimationEnd"),
        transitionend: $c24d790a085c6d93$var$makePrefixMap("Transition", "TransitionEnd")
    };
    if (domSupport) {
        if (!("AnimationEvent" in win)) delete prefixes.animationend.animation;
        if (!("TransitionEvent" in win)) delete prefixes.transitionend.transition;
    }
    return prefixes;
}
var $c24d790a085c6d93$var$vendorPrefixes = $c24d790a085c6d93$export$6e8b350b1a8958a0((0, $c6daeb3adc2b0e60$export$2e2bcd8739ae039)(), typeof window !== "undefined" ? window : {});
var $c24d790a085c6d93$var$style = {};
if ((0, $c6daeb3adc2b0e60$export$2e2bcd8739ae039)()) {
    var $c24d790a085c6d93$var$_document$createEleme = document.createElement("div");
    $c24d790a085c6d93$var$style = $c24d790a085c6d93$var$_document$createEleme.style;
}
var $c24d790a085c6d93$var$prefixedEventNames = {};
function $c24d790a085c6d93$export$a032e4f39350c1d8(eventName) {
    if ($c24d790a085c6d93$var$prefixedEventNames[eventName]) return $c24d790a085c6d93$var$prefixedEventNames[eventName];
    var prefixMap = $c24d790a085c6d93$var$vendorPrefixes[eventName];
    if (prefixMap) {
        var stylePropList = Object.keys(prefixMap);
        var len = stylePropList.length;
        for(var i = 0; i < len; i += 1){
            var styleProp = stylePropList[i];
            if (Object.prototype.hasOwnProperty.call(prefixMap, styleProp) && styleProp in $c24d790a085c6d93$var$style) {
                $c24d790a085c6d93$var$prefixedEventNames[eventName] = prefixMap[styleProp];
                return $c24d790a085c6d93$var$prefixedEventNames[eventName];
            }
        }
    }
    return "";
}
var $c24d790a085c6d93$var$internalAnimationEndName = $c24d790a085c6d93$export$a032e4f39350c1d8("animationend");
var $c24d790a085c6d93$var$internalTransitionEndName = $c24d790a085c6d93$export$a032e4f39350c1d8("transitionend");
var $c24d790a085c6d93$export$d28133ed3ad06c8b = !!($c24d790a085c6d93$var$internalAnimationEndName && $c24d790a085c6d93$var$internalTransitionEndName);
var $c24d790a085c6d93$export$760cc9769c51b738 = $c24d790a085c6d93$var$internalAnimationEndName || "animationend";
var $c24d790a085c6d93$export$44baea64b8602e3c = $c24d790a085c6d93$var$internalTransitionEndName || "transitionend";
function $c24d790a085c6d93$export$27c72201b1d09951(transitionName, transitionType) {
    if (!transitionName) return null;
    if ((0, $b8f57191916382d3$export$2e2bcd8739ae039)(transitionName) === "object") {
        var type = transitionType.replace(/-\w/g, function(match) {
            return match[1].toUpperCase();
        });
        return transitionName[type];
    }
    return "".concat(transitionName, "-").concat(transitionType);
}


var $7ccb217d091ef41f$export$2e2bcd8739ae039 = function(callback) {
    var cacheElementRef = (0, $acw62.useRef)();
    // Cache callback
    var callbackRef = (0, $acw62.useRef)(callback);
    callbackRef.current = callback;
    // Internal motion event handler
    var onInternalMotionEnd = $acw62.useCallback(function(event) {
        callbackRef.current(event);
    }, []);
    // Remove events
    function removeMotionEvents(element) {
        if (element) {
            element.removeEventListener((0, $c24d790a085c6d93$export$44baea64b8602e3c), onInternalMotionEnd);
            element.removeEventListener((0, $c24d790a085c6d93$export$760cc9769c51b738), onInternalMotionEnd);
        }
    }
    // Patch events
    function patchMotionEvents(element) {
        if (cacheElementRef.current && cacheElementRef.current !== element) removeMotionEvents(cacheElementRef.current);
        if (element && element !== cacheElementRef.current) {
            element.addEventListener((0, $c24d790a085c6d93$export$44baea64b8602e3c), onInternalMotionEnd);
            element.addEventListener((0, $c24d790a085c6d93$export$760cc9769c51b738), onInternalMotionEnd);
            // Save as cache in case dom removed trigger by `motionDeadline`
            cacheElementRef.current = element;
        }
    }
    // Clean up when removed
    $acw62.useEffect(function() {
        return function() {
            removeMotionEvents(cacheElementRef.current);
        };
    }, []);
    return [
        patchMotionEvents,
        removeMotionEvents
    ];
};




var $acw62 = parcelRequire("acw62");
// It's safe to use `useLayoutEffect` but the warning is annoying
var $fb24c0ebe270f6f6$var$useIsomorphicLayoutEffect = (0, $c6daeb3adc2b0e60$export$2e2bcd8739ae039)() ? (0, $acw62.useLayoutEffect) : (0, $acw62.useEffect);
var $fb24c0ebe270f6f6$export$2e2bcd8739ae039 = $fb24c0ebe270f6f6$var$useIsomorphicLayoutEffect;





var $acw62 = parcelRequire("acw62");


var $a1ced7b983ea61a4$var$raf = function raf(callback) {
    return +setTimeout(callback, 16);
};
var $a1ced7b983ea61a4$var$caf = function caf(num) {
    return clearTimeout(num);
};
if (typeof window !== "undefined" && "requestAnimationFrame" in window) {
    $a1ced7b983ea61a4$var$raf = function raf(callback) {
        return window.requestAnimationFrame(callback);
    };
    $a1ced7b983ea61a4$var$caf = function caf(handle) {
        return window.cancelAnimationFrame(handle);
    };
}
var $a1ced7b983ea61a4$var$rafUUID = 0;
var $a1ced7b983ea61a4$var$rafIds = new Map();
function $a1ced7b983ea61a4$var$cleanup(id) {
    $a1ced7b983ea61a4$var$rafIds.delete(id);
}
var $a1ced7b983ea61a4$var$wrapperRaf = function wrapperRaf(callback) {
    var times = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
    $a1ced7b983ea61a4$var$rafUUID += 1;
    var id = $a1ced7b983ea61a4$var$rafUUID;
    function callRef(leftTimes) {
        if (leftTimes === 0) {
            // Clean up
            $a1ced7b983ea61a4$var$cleanup(id);
            // Trigger
            callback();
        } else {
            // Next raf
            var realId = $a1ced7b983ea61a4$var$raf(function() {
                callRef(leftTimes - 1);
            });
            // Bind real raf id
            $a1ced7b983ea61a4$var$rafIds.set(id, realId);
        }
    }
    callRef(times);
    return id;
};
$a1ced7b983ea61a4$var$wrapperRaf.cancel = function(id) {
    var realId = $a1ced7b983ea61a4$var$rafIds.get(id);
    $a1ced7b983ea61a4$var$cleanup(id);
    return $a1ced7b983ea61a4$var$caf(realId);
};
$a1ced7b983ea61a4$var$wrapperRaf.ids = function() {
    return $a1ced7b983ea61a4$var$rafIds;
};
var $a1ced7b983ea61a4$export$2e2bcd8739ae039 = $a1ced7b983ea61a4$var$wrapperRaf;



var $acw62 = parcelRequire("acw62");
var $dd21c0d0173075f3$export$2e2bcd8739ae039 = function() {
    var nextFrameRef = $acw62.useRef(null);
    function cancelNextFrame() {
        (0, $a1ced7b983ea61a4$export$2e2bcd8739ae039).cancel(nextFrameRef.current);
    }
    function nextFrame(callback) {
        var delay = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 2;
        cancelNextFrame();
        var nextFrameId = (0, $a1ced7b983ea61a4$export$2e2bcd8739ae039)(function() {
            if (delay <= 1) callback({
                isCanceled: function isCanceled() {
                    return nextFrameId !== nextFrameRef.current;
                }
            });
            else nextFrame(callback, delay - 1);
        });
        nextFrameRef.current = nextFrameId;
    }
    $acw62.useEffect(function() {
        return function() {
            cancelNextFrame();
        };
    }, []);
    return [
        nextFrame,
        cancelNextFrame
    ];
};


var $1e0427d97d69e92c$var$FULL_STEP_QUEUE = [
    (0, $0e817525d7f1f474$export$1b792916a5fac4fc),
    (0, $0e817525d7f1f474$export$9563153dd25a3ce8),
    (0, $0e817525d7f1f474$export$e205886172277ec6),
    (0, $0e817525d7f1f474$export$3a846c3d2fac10b8)
];
var $1e0427d97d69e92c$var$SIMPLE_STEP_QUEUE = [
    (0, $0e817525d7f1f474$export$1b792916a5fac4fc),
    (0, $0e817525d7f1f474$export$98351fa4e6b4f204)
];
var $1e0427d97d69e92c$export$c2029bf6cfdbc28a = false;
var $1e0427d97d69e92c$export$dbee1e282e8c4830 = true;
function $1e0427d97d69e92c$export$39e04e72f972b885(step) {
    return step === (0, $0e817525d7f1f474$export$e205886172277ec6) || step === (0, $0e817525d7f1f474$export$3a846c3d2fac10b8);
}
var $1e0427d97d69e92c$export$2e2bcd8739ae039 = function(status, prepareOnly, callback) {
    var _useState = (0, $25e137fc56329ad1$export$2e2bcd8739ae039)((0, $0e817525d7f1f474$export$40b34dd77d5522bf)), _useState2 = (0, $adaabbc18727b3e6$export$2e2bcd8739ae039)(_useState, 2), step = _useState2[0], setStep = _useState2[1];
    var _useNextFrame = (0, $dd21c0d0173075f3$export$2e2bcd8739ae039)(), _useNextFrame2 = (0, $adaabbc18727b3e6$export$2e2bcd8739ae039)(_useNextFrame, 2), nextFrame = _useNextFrame2[0], cancelNextFrame = _useNextFrame2[1];
    function startQueue() {
        setStep((0, $0e817525d7f1f474$export$1b792916a5fac4fc), true);
    }
    var STEP_QUEUE = prepareOnly ? $1e0427d97d69e92c$var$SIMPLE_STEP_QUEUE : $1e0427d97d69e92c$var$FULL_STEP_QUEUE;
    (0, $fb24c0ebe270f6f6$export$2e2bcd8739ae039)(function() {
        if (step !== (0, $0e817525d7f1f474$export$40b34dd77d5522bf) && step !== (0, $0e817525d7f1f474$export$3a846c3d2fac10b8)) {
            var index = STEP_QUEUE.indexOf(step);
            var nextStep = STEP_QUEUE[index + 1];
            var result = callback(step);
            if (result === $1e0427d97d69e92c$export$c2029bf6cfdbc28a) // Skip when no needed
            setStep(nextStep, true);
            else if (nextStep) // Do as frame for step update
            nextFrame(function(info) {
                function doNext() {
                    // Skip since current queue is ood
                    if (info.isCanceled()) return;
                    setStep(nextStep, true);
                }
                if (result === true) doNext();
                else // Only promise should be async
                Promise.resolve(result).then(doNext);
            });
        }
    }, [
        status,
        step
    ]);
    $acw62.useEffect(function() {
        return function() {
            cancelNextFrame();
        };
    }, []);
    return [
        startQueue,
        step
    ];
};


function $1df598d21d8025e6$export$2e2bcd8739ae039(supportMotion, visible, getElement, _ref) {
    var _ref$motionEnter = _ref.motionEnter, motionEnter = _ref$motionEnter === void 0 ? true : _ref$motionEnter, _ref$motionAppear = _ref.motionAppear, motionAppear = _ref$motionAppear === void 0 ? true : _ref$motionAppear, _ref$motionLeave = _ref.motionLeave, motionLeave = _ref$motionLeave === void 0 ? true : _ref$motionLeave, motionDeadline = _ref.motionDeadline, motionLeaveImmediately = _ref.motionLeaveImmediately, onAppearPrepare = _ref.onAppearPrepare, onEnterPrepare = _ref.onEnterPrepare, onLeavePrepare = _ref.onLeavePrepare, onAppearStart = _ref.onAppearStart, onEnterStart = _ref.onEnterStart, onLeaveStart = _ref.onLeaveStart, onAppearActive = _ref.onAppearActive, onEnterActive = _ref.onEnterActive, onLeaveActive = _ref.onLeaveActive, onAppearEnd = _ref.onAppearEnd, onEnterEnd = _ref.onEnterEnd, onLeaveEnd = _ref.onLeaveEnd, onVisibleChanged = _ref.onVisibleChanged;
    // Used for outer render usage to avoid `visible: false & status: none` to render nothing
    var _useState = (0, $25e137fc56329ad1$export$2e2bcd8739ae039)(), _useState2 = (0, $adaabbc18727b3e6$export$2e2bcd8739ae039)(_useState, 2), asyncVisible = _useState2[0], setAsyncVisible = _useState2[1];
    var _useState3 = (0, $25e137fc56329ad1$export$2e2bcd8739ae039)((0, $0e817525d7f1f474$export$de71442bbf2143da)), _useState4 = (0, $adaabbc18727b3e6$export$2e2bcd8739ae039)(_useState3, 2), status = _useState4[0], setStatus = _useState4[1];
    var _useState5 = (0, $25e137fc56329ad1$export$2e2bcd8739ae039)(null), _useState6 = (0, $adaabbc18727b3e6$export$2e2bcd8739ae039)(_useState5, 2), style = _useState6[0], setStyle = _useState6[1];
    var mountedRef = (0, $acw62.useRef)(false);
    var deadlineRef = (0, $acw62.useRef)(null);
    // =========================== Dom Node ===========================
    function getDomElement() {
        return getElement();
    }
    // ========================== Motion End ==========================
    var activeRef = (0, $acw62.useRef)(false);
    /**
   * Clean up status & style
   */ function updateMotionEndStatus() {
        setStatus((0, $0e817525d7f1f474$export$de71442bbf2143da), true);
        setStyle(null, true);
    }
    function onInternalMotionEnd(event) {
        var element = getDomElement();
        if (event && !event.deadline && event.target !== element) // event exists
        // not initiated by deadline
        // transitionEnd not fired by inner elements
        return;
        var currentActive = activeRef.current;
        var canEnd;
        if (status === (0, $0e817525d7f1f474$export$4fc3521687bcacd2) && currentActive) canEnd = onAppearEnd === null || onAppearEnd === void 0 ? void 0 : onAppearEnd(element, event);
        else if (status === (0, $0e817525d7f1f474$export$5d6af549241fe2e8) && currentActive) canEnd = onEnterEnd === null || onEnterEnd === void 0 ? void 0 : onEnterEnd(element, event);
        else if (status === (0, $0e817525d7f1f474$export$59b1c493d29f68e4) && currentActive) canEnd = onLeaveEnd === null || onLeaveEnd === void 0 ? void 0 : onLeaveEnd(element, event);
        // Only update status when `canEnd` and not destroyed
        if (status !== (0, $0e817525d7f1f474$export$de71442bbf2143da) && currentActive && canEnd !== false) updateMotionEndStatus();
    }
    var _useDomMotionEvents = (0, $7ccb217d091ef41f$export$2e2bcd8739ae039)(onInternalMotionEnd), _useDomMotionEvents2 = (0, $adaabbc18727b3e6$export$2e2bcd8739ae039)(_useDomMotionEvents, 1), patchMotionEvents = _useDomMotionEvents2[0];
    // ============================= Step =============================
    var getEventHandlers = function getEventHandlers(targetStatus) {
        var _ref2, _ref3, _ref4;
        switch(targetStatus){
            case 0, $0e817525d7f1f474$export$4fc3521687bcacd2:
                return _ref2 = {}, (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)(_ref2, (0, $0e817525d7f1f474$export$1b792916a5fac4fc), onAppearPrepare), (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)(_ref2, (0, $0e817525d7f1f474$export$9563153dd25a3ce8), onAppearStart), (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)(_ref2, (0, $0e817525d7f1f474$export$e205886172277ec6), onAppearActive), _ref2;
            case 0, $0e817525d7f1f474$export$5d6af549241fe2e8:
                return _ref3 = {}, (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)(_ref3, (0, $0e817525d7f1f474$export$1b792916a5fac4fc), onEnterPrepare), (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)(_ref3, (0, $0e817525d7f1f474$export$9563153dd25a3ce8), onEnterStart), (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)(_ref3, (0, $0e817525d7f1f474$export$e205886172277ec6), onEnterActive), _ref3;
            case 0, $0e817525d7f1f474$export$59b1c493d29f68e4:
                return _ref4 = {}, (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)(_ref4, (0, $0e817525d7f1f474$export$1b792916a5fac4fc), onLeavePrepare), (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)(_ref4, (0, $0e817525d7f1f474$export$9563153dd25a3ce8), onLeaveStart), (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)(_ref4, (0, $0e817525d7f1f474$export$e205886172277ec6), onLeaveActive), _ref4;
            default:
                return {};
        }
    };
    var eventHandlers = $acw62.useMemo(function() {
        return getEventHandlers(status);
    }, [
        status
    ]);
    var _useStepQueue = (0, $1e0427d97d69e92c$export$2e2bcd8739ae039)(status, !supportMotion, function(newStep) {
        // Only prepare step can be skip
        if (newStep === (0, $0e817525d7f1f474$export$1b792916a5fac4fc)) {
            var onPrepare = eventHandlers[0, $0e817525d7f1f474$export$1b792916a5fac4fc];
            if (!onPrepare) return 0, $1e0427d97d69e92c$export$c2029bf6cfdbc28a;
            return onPrepare(getDomElement());
        }
        // Rest step is sync update
        if (step in eventHandlers) {
            var _eventHandlers$step;
            setStyle(((_eventHandlers$step = eventHandlers[step]) === null || _eventHandlers$step === void 0 ? void 0 : _eventHandlers$step.call(eventHandlers, getDomElement(), null)) || null);
        }
        if (step === (0, $0e817525d7f1f474$export$e205886172277ec6)) {
            // Patch events when motion needed
            patchMotionEvents(getDomElement());
            if (motionDeadline > 0) {
                clearTimeout(deadlineRef.current);
                deadlineRef.current = setTimeout(function() {
                    onInternalMotionEnd({
                        deadline: true
                    });
                }, motionDeadline);
            }
        }
        if (step === (0, $0e817525d7f1f474$export$98351fa4e6b4f204)) updateMotionEndStatus();
        return 0, $1e0427d97d69e92c$export$dbee1e282e8c4830;
    }), _useStepQueue2 = (0, $adaabbc18727b3e6$export$2e2bcd8739ae039)(_useStepQueue, 2), startStep = _useStepQueue2[0], step = _useStepQueue2[1];
    var active = (0, $1e0427d97d69e92c$export$39e04e72f972b885)(step);
    activeRef.current = active;
    // ============================ Status ============================
    // Update with new status
    (0, $fb24c0ebe270f6f6$export$2e2bcd8739ae039)(function() {
        setAsyncVisible(visible);
        var isMounted = mountedRef.current;
        mountedRef.current = true;
        // if (!supportMotion) {
        //   return;
        // }
        var nextStatus;
        // Appear
        if (!isMounted && visible && motionAppear) nextStatus = (0, $0e817525d7f1f474$export$4fc3521687bcacd2);
        // Enter
        if (isMounted && visible && motionEnter) nextStatus = (0, $0e817525d7f1f474$export$5d6af549241fe2e8);
        // Leave
        if (isMounted && !visible && motionLeave || !isMounted && motionLeaveImmediately && !visible && motionLeave) nextStatus = (0, $0e817525d7f1f474$export$59b1c493d29f68e4);
        var nextEventHandlers = getEventHandlers(nextStatus);
        // Update to next status
        if (nextStatus && (supportMotion || nextEventHandlers[0, $0e817525d7f1f474$export$1b792916a5fac4fc])) {
            setStatus(nextStatus);
            startStep();
        } else // Set back in case no motion but prev status has prepare step
        setStatus((0, $0e817525d7f1f474$export$de71442bbf2143da));
    }, [
        visible
    ]);
    // ============================ Effect ============================
    // Reset when motion changed
    (0, $acw62.useEffect)(function() {
        if (// Cancel appear
        status === (0, $0e817525d7f1f474$export$4fc3521687bcacd2) && !motionAppear || // Cancel enter
        status === (0, $0e817525d7f1f474$export$5d6af549241fe2e8) && !motionEnter || // Cancel leave
        status === (0, $0e817525d7f1f474$export$59b1c493d29f68e4) && !motionLeave) setStatus((0, $0e817525d7f1f474$export$de71442bbf2143da));
    }, [
        motionAppear,
        motionEnter,
        motionLeave
    ]);
    (0, $acw62.useEffect)(function() {
        return function() {
            mountedRef.current = false;
            clearTimeout(deadlineRef.current);
        };
    }, []);
    // Trigger `onVisibleChanged`
    var firstMountChangeRef = $acw62.useRef(false);
    (0, $acw62.useEffect)(function() {
        // [visible & motion not end] => [!visible & motion end] still need trigger onVisibleChanged
        if (asyncVisible) firstMountChangeRef.current = true;
        if (asyncVisible !== undefined && status === (0, $0e817525d7f1f474$export$de71442bbf2143da)) {
            // Skip first render is invisible since it's nothing changed
            if (firstMountChangeRef.current || asyncVisible) onVisibleChanged === null || onVisibleChanged === void 0 || onVisibleChanged(asyncVisible);
            firstMountChangeRef.current = true;
        }
    }, [
        asyncVisible,
        status
    ]);
    // ============================ Styles ============================
    var mergedStyle = style;
    if (eventHandlers[0, $0e817525d7f1f474$export$1b792916a5fac4fc] && step === (0, $0e817525d7f1f474$export$9563153dd25a3ce8)) mergedStyle = (0, $983350b7b3960a26$export$2e2bcd8739ae039)({
        transition: "none"
    }, mergedStyle);
    return [
        status,
        step,
        mergedStyle,
        asyncVisible !== null && asyncVisible !== void 0 ? asyncVisible : visible
    ];
}





function $084772fb8d80df29$export$e265d52a86a9f199(config) {
    var transitionSupport = config;
    if ((0, $b8f57191916382d3$export$2e2bcd8739ae039)(config) === "object") transitionSupport = config.transitionSupport;
    function isSupportTransition(props, contextMotion) {
        return !!(props.motionName && transitionSupport && contextMotion !== false);
    }
    var CSSMotion = /*#__PURE__*/ $acw62.forwardRef(function(props, ref) {
        var _props$visible = props.visible, visible = _props$visible === void 0 ? true : _props$visible, _props$removeOnLeave = props.removeOnLeave, removeOnLeave = _props$removeOnLeave === void 0 ? true : _props$removeOnLeave, forceRender = props.forceRender, children = props.children, motionName = props.motionName, leavedClassName = props.leavedClassName, eventProps = props.eventProps;
        var _React$useContext = $acw62.useContext((0, $7b776f21b7918d7b$export$841858b892ce1f4c)), contextMotion = _React$useContext.motion;
        var supportMotion = isSupportTransition(props, contextMotion);
        // Ref to the react node, it may be a HTMLElement
        var nodeRef = (0, $acw62.useRef)();
        // Ref to the dom wrapper in case ref can not pass to HTMLElement
        var wrapperNodeRef = (0, $acw62.useRef)();
        function getDomElement() {
            try {
                // Here we're avoiding call for findDOMNode since it's deprecated
                // in strict mode. We're calling it only when node ref is not
                // an instance of DOM HTMLElement. Otherwise use
                // findDOMNode as a final resort
                return nodeRef.current instanceof HTMLElement ? nodeRef.current : (0, $808ab7b8a87ab771$export$2e2bcd8739ae039)(wrapperNodeRef.current);
            } catch (e) {
                // Only happen when `motionDeadline` trigger but element removed.
                return null;
            }
        }
        var _useStatus = (0, $1df598d21d8025e6$export$2e2bcd8739ae039)(supportMotion, visible, getDomElement, props), _useStatus2 = (0, $adaabbc18727b3e6$export$2e2bcd8739ae039)(_useStatus, 4), status = _useStatus2[0], statusStep = _useStatus2[1], statusStyle = _useStatus2[2], mergedVisible = _useStatus2[3];
        // Record whether content has rendered
        // Will return null for un-rendered even when `removeOnLeave={false}`
        var renderedRef = $acw62.useRef(mergedVisible);
        if (mergedVisible) renderedRef.current = true;
        // ====================== Refs ======================
        var setNodeRef = $acw62.useCallback(function(node) {
            nodeRef.current = node;
            (0, $5e297877593af644$export$f17fd18fa51dcb5b)(ref, node);
        }, [
            ref
        ]);
        // ===================== Render =====================
        var motionChildren;
        var mergedProps = (0, $983350b7b3960a26$export$2e2bcd8739ae039)((0, $983350b7b3960a26$export$2e2bcd8739ae039)({}, eventProps), {}, {
            visible: visible
        });
        if (!children) // No children
        motionChildren = null;
        else if (status === (0, $0e817525d7f1f474$export$de71442bbf2143da)) {
            // Stable children
            if (mergedVisible) motionChildren = children((0, $983350b7b3960a26$export$2e2bcd8739ae039)({}, mergedProps), setNodeRef);
            else if (!removeOnLeave && renderedRef.current && leavedClassName) motionChildren = children((0, $983350b7b3960a26$export$2e2bcd8739ae039)((0, $983350b7b3960a26$export$2e2bcd8739ae039)({}, mergedProps), {}, {
                className: leavedClassName
            }), setNodeRef);
            else if (forceRender || !removeOnLeave && !leavedClassName) motionChildren = children((0, $983350b7b3960a26$export$2e2bcd8739ae039)((0, $983350b7b3960a26$export$2e2bcd8739ae039)({}, mergedProps), {}, {
                style: {
                    display: "none"
                }
            }), setNodeRef);
            else motionChildren = null;
        } else {
            var _classNames;
            // In motion
            var statusSuffix;
            if (statusStep === (0, $0e817525d7f1f474$export$1b792916a5fac4fc)) statusSuffix = "prepare";
            else if ((0, $1e0427d97d69e92c$export$39e04e72f972b885)(statusStep)) statusSuffix = "active";
            else if (statusStep === (0, $0e817525d7f1f474$export$9563153dd25a3ce8)) statusSuffix = "start";
            var motionCls = (0, $c24d790a085c6d93$export$27c72201b1d09951)(motionName, "".concat(status, "-").concat(statusSuffix));
            motionChildren = children((0, $983350b7b3960a26$export$2e2bcd8739ae039)((0, $983350b7b3960a26$export$2e2bcd8739ae039)({}, mergedProps), {}, {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))((0, $c24d790a085c6d93$export$27c72201b1d09951)(motionName, status), (_classNames = {}, (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)(_classNames, motionCls, motionCls && statusSuffix), (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)(_classNames, motionName, typeof motionName === "string"), _classNames)),
                style: statusStyle
            }), setNodeRef);
        }
        // Auto inject ref if child node not have `ref` props
        if (/*#__PURE__*/ $acw62.isValidElement(motionChildren) && (0, $5e297877593af644$export$c1cec34af06bcf7)(motionChildren)) {
            var _ref = motionChildren, originNodeRef = _ref.ref;
            if (!originNodeRef) motionChildren = /*#__PURE__*/ $acw62.cloneElement(motionChildren, {
                ref: setNodeRef
            });
        }
        return /*#__PURE__*/ $acw62.createElement((0, $e37a565edd3e4d81$export$2e2bcd8739ae039), {
            ref: wrapperNodeRef
        }, motionChildren);
    });
    CSSMotion.displayName = "CSSMotion";
    return CSSMotion;
}
var $084772fb8d80df29$export$2e2bcd8739ae039 = $084772fb8d80df29$export$e265d52a86a9f199((0, $c24d790a085c6d93$export$d28133ed3ad06c8b));












var $acw62 = parcelRequire("acw62");



var $16994a73d43ee3a4$export$3904baa009bc026e = "add";
var $16994a73d43ee3a4$export$851162f0adad2cbc = "keep";
var $16994a73d43ee3a4$export$c8b3fb08b68cfc85 = "remove";
var $16994a73d43ee3a4$export$2ac1bd1808d2e43a = "removed";
function $16994a73d43ee3a4$export$c47fd798e598c85c(key) {
    var keyObj;
    if (key && (0, $b8f57191916382d3$export$2e2bcd8739ae039)(key) === "object" && "key" in key) keyObj = key;
    else keyObj = {
        key: key
    };
    return (0, $983350b7b3960a26$export$2e2bcd8739ae039)((0, $983350b7b3960a26$export$2e2bcd8739ae039)({}, keyObj), {}, {
        key: String(keyObj.key)
    });
}
function $16994a73d43ee3a4$export$84bd7bd42ccc0f72() {
    var keys = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
    return keys.map($16994a73d43ee3a4$export$c47fd798e598c85c);
}
function $16994a73d43ee3a4$export$14527669107aa301() {
    var prevKeys = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
    var currentKeys = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
    var list = [];
    var currentIndex = 0;
    var currentLen = currentKeys.length;
    var prevKeyObjects = $16994a73d43ee3a4$export$84bd7bd42ccc0f72(prevKeys);
    var currentKeyObjects = $16994a73d43ee3a4$export$84bd7bd42ccc0f72(currentKeys);
    // Check prev keys to insert or keep
    prevKeyObjects.forEach(function(keyObj) {
        var hit = false;
        for(var i = currentIndex; i < currentLen; i += 1){
            var currentKeyObj = currentKeyObjects[i];
            if (currentKeyObj.key === keyObj.key) {
                // New added keys should add before current key
                if (currentIndex < i) {
                    list = list.concat(currentKeyObjects.slice(currentIndex, i).map(function(obj) {
                        return (0, $983350b7b3960a26$export$2e2bcd8739ae039)((0, $983350b7b3960a26$export$2e2bcd8739ae039)({}, obj), {}, {
                            status: $16994a73d43ee3a4$export$3904baa009bc026e
                        });
                    }));
                    currentIndex = i;
                }
                list.push((0, $983350b7b3960a26$export$2e2bcd8739ae039)((0, $983350b7b3960a26$export$2e2bcd8739ae039)({}, currentKeyObj), {}, {
                    status: $16994a73d43ee3a4$export$851162f0adad2cbc
                }));
                currentIndex += 1;
                hit = true;
                break;
            }
        }
        // If not hit, it means key is removed
        if (!hit) list.push((0, $983350b7b3960a26$export$2e2bcd8739ae039)((0, $983350b7b3960a26$export$2e2bcd8739ae039)({}, keyObj), {}, {
            status: $16994a73d43ee3a4$export$c8b3fb08b68cfc85
        }));
    });
    // Add rest to the list
    if (currentIndex < currentLen) list = list.concat(currentKeyObjects.slice(currentIndex).map(function(obj) {
        return (0, $983350b7b3960a26$export$2e2bcd8739ae039)((0, $983350b7b3960a26$export$2e2bcd8739ae039)({}, obj), {}, {
            status: $16994a73d43ee3a4$export$3904baa009bc026e
        });
    }));
    /**
   * Merge same key when it remove and add again:
   *    [1 - add, 2 - keep, 1 - remove] -> [1 - keep, 2 - keep]
   */ var keys = {};
    list.forEach(function(_ref) {
        var key = _ref.key;
        keys[key] = (keys[key] || 0) + 1;
    });
    var duplicatedKeys = Object.keys(keys).filter(function(key) {
        return keys[key] > 1;
    });
    duplicatedKeys.forEach(function(matchKey) {
        // Remove `STATUS_REMOVE` node.
        list = list.filter(function(_ref2) {
            var key = _ref2.key, status = _ref2.status;
            return key !== matchKey || status !== $16994a73d43ee3a4$export$c8b3fb08b68cfc85;
        });
        // Update `STATUS_ADD` to `STATUS_KEEP`
        list.forEach(function(node) {
            if (node.key === matchKey) // eslint-disable-next-line no-param-reassign
            node.status = $16994a73d43ee3a4$export$851162f0adad2cbc;
        });
    });
    return list;
}



var $ab0f5c5a9767e13d$var$_excluded = [
    "component",
    "children",
    "onVisibleChanged",
    "onAllRemoved"
], $ab0f5c5a9767e13d$var$_excluded2 = [
    "status"
];
var $ab0f5c5a9767e13d$var$MOTION_PROP_NAMES = [
    "eventProps",
    "visible",
    "children",
    "motionName",
    "motionAppear",
    "motionEnter",
    "motionLeave",
    "motionLeaveImmediately",
    "motionDeadline",
    "removeOnLeave",
    "leavedClassName",
    "onAppearPrepare",
    "onAppearStart",
    "onAppearActive",
    "onAppearEnd",
    "onEnterStart",
    "onEnterActive",
    "onEnterEnd",
    "onLeaveStart",
    "onLeaveActive",
    "onLeaveEnd"
];
function $ab0f5c5a9767e13d$export$fcfc62c1d33d5e2e(transitionSupport) {
    var CSSMotion = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : (0, $084772fb8d80df29$export$2e2bcd8739ae039);
    var CSSMotionList = /*#__PURE__*/ function(_React$Component) {
        (0, $0ed648f7bbaf3aff$export$2e2bcd8739ae039)(CSSMotionList, _React$Component);
        var _super = (0, $a76f20fb39fa9d46$export$2e2bcd8739ae039)(CSSMotionList);
        function CSSMotionList() {
            var _this;
            (0, $4d35ca0862055760$export$2e2bcd8739ae039)(this, CSSMotionList);
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
            _this = _super.call.apply(_super, [
                this
            ].concat(args));
            (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)((0, $cd69a1d4c6210e44$export$2e2bcd8739ae039)(_this), "state", {
                keyEntities: []
            });
            // ZombieJ: Return the count of rest keys. It's safe to refactor if need more info.
            (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)((0, $cd69a1d4c6210e44$export$2e2bcd8739ae039)(_this), "removeKey", function(removeKey) {
                var keyEntities = _this.state.keyEntities;
                var nextKeyEntities = keyEntities.map(function(entity) {
                    if (entity.key !== removeKey) return entity;
                    return (0, $983350b7b3960a26$export$2e2bcd8739ae039)((0, $983350b7b3960a26$export$2e2bcd8739ae039)({}, entity), {}, {
                        status: (0, $16994a73d43ee3a4$export$2ac1bd1808d2e43a)
                    });
                });
                _this.setState({
                    keyEntities: nextKeyEntities
                });
                return nextKeyEntities.filter(function(_ref) {
                    var status = _ref.status;
                    return status !== (0, $16994a73d43ee3a4$export$2ac1bd1808d2e43a);
                }).length;
            });
            return _this;
        }
        (0, $94019358ecbcf36b$export$2e2bcd8739ae039)(CSSMotionList, [
            {
                key: "render",
                value: function render() {
                    var _this2 = this;
                    var keyEntities = this.state.keyEntities;
                    var _this$props = this.props, component = _this$props.component, children = _this$props.children, _onVisibleChanged = _this$props.onVisibleChanged, onAllRemoved = _this$props.onAllRemoved, restProps = (0, $73ef9ce1c41fc0c0$export$2e2bcd8739ae039)(_this$props, $ab0f5c5a9767e13d$var$_excluded);
                    var Component = component || $acw62.Fragment;
                    var motionProps = {};
                    $ab0f5c5a9767e13d$var$MOTION_PROP_NAMES.forEach(function(prop) {
                        motionProps[prop] = restProps[prop];
                        delete restProps[prop];
                    });
                    delete restProps.keys;
                    return /*#__PURE__*/ $acw62.createElement(Component, restProps, keyEntities.map(function(_ref2, index) {
                        var status = _ref2.status, eventProps = (0, $73ef9ce1c41fc0c0$export$2e2bcd8739ae039)(_ref2, $ab0f5c5a9767e13d$var$_excluded2);
                        var visible = status === (0, $16994a73d43ee3a4$export$3904baa009bc026e) || status === (0, $16994a73d43ee3a4$export$851162f0adad2cbc);
                        return /*#__PURE__*/ $acw62.createElement(CSSMotion, (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, motionProps, {
                            key: eventProps.key,
                            visible: visible,
                            eventProps: eventProps,
                            onVisibleChanged: function onVisibleChanged(changedVisible) {
                                _onVisibleChanged === null || _onVisibleChanged === void 0 || _onVisibleChanged(changedVisible, {
                                    key: eventProps.key
                                });
                                if (!changedVisible) {
                                    var restKeysCount = _this2.removeKey(eventProps.key);
                                    if (restKeysCount === 0 && onAllRemoved) onAllRemoved();
                                }
                            }
                        }), function(props, ref) {
                            return children((0, $983350b7b3960a26$export$2e2bcd8739ae039)((0, $983350b7b3960a26$export$2e2bcd8739ae039)({}, props), {}, {
                                index: index
                            }), ref);
                        });
                    }));
                }
            }
        ], [
            {
                key: "getDerivedStateFromProps",
                value: function getDerivedStateFromProps(_ref3, _ref4) {
                    var keys = _ref3.keys;
                    var keyEntities = _ref4.keyEntities;
                    var parsedKeyObjects = (0, $16994a73d43ee3a4$export$84bd7bd42ccc0f72)(keys);
                    var mixedKeyEntities = (0, $16994a73d43ee3a4$export$14527669107aa301)(keyEntities, parsedKeyObjects);
                    return {
                        keyEntities: mixedKeyEntities.filter(function(entity) {
                            var prevEntity = keyEntities.find(function(_ref5) {
                                var key = _ref5.key;
                                return entity.key === key;
                            });
                            // Remove if already mark as removed
                            if (prevEntity && prevEntity.status === (0, $16994a73d43ee3a4$export$2ac1bd1808d2e43a) && entity.status === (0, $16994a73d43ee3a4$export$c8b3fb08b68cfc85)) return false;
                            return true;
                        })
                    };
                }
            }
        ]);
        return CSSMotionList;
    }($acw62.Component);
    (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)(CSSMotionList, "defaultProps", {
        component: "div"
    });
    return CSSMotionList;
}
var $ab0f5c5a9767e13d$export$2e2bcd8739ae039 = $ab0f5c5a9767e13d$export$fcfc62c1d33d5e2e((0, $c24d790a085c6d93$export$d28133ed3ad06c8b));



var $609e894acbce1933$export$2e2bcd8739ae039 = (0, $084772fb8d80df29$export$2e2bcd8739ae039);









var $acw62 = parcelRequire("acw62");

var $1u0KT = parcelRequire("1u0KT");

var $6be5862818f90611$export$2e2bcd8739ae039 = /*#__PURE__*/ function(_Component) {
    (0, $0ed648f7bbaf3aff$export$2e2bcd8739ae039)(Notice, _Component);
    var _super = (0, $a76f20fb39fa9d46$export$2e2bcd8739ae039)(Notice);
    function Notice() {
        var _this;
        (0, $4d35ca0862055760$export$2e2bcd8739ae039)(this, Notice);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        _this.closeTimer = null;
        _this.close = function(e) {
            if (e) e.stopPropagation();
            _this.clearCloseTimer();
            var _this$props = _this.props, onClose = _this$props.onClose, noticeKey = _this$props.noticeKey;
            if (onClose) onClose(noticeKey);
        };
        _this.startCloseTimer = function() {
            if (_this.props.duration) _this.closeTimer = window.setTimeout(function() {
                _this.close();
            }, _this.props.duration * 1000);
        };
        _this.clearCloseTimer = function() {
            if (_this.closeTimer) {
                clearTimeout(_this.closeTimer);
                _this.closeTimer = null;
            }
        };
        return _this;
    }
    (0, $94019358ecbcf36b$export$2e2bcd8739ae039)(Notice, [
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                this.startCloseTimer();
            }
        },
        {
            key: "componentDidUpdate",
            value: function componentDidUpdate(prevProps) {
                if (this.props.duration !== prevProps.duration || this.props.updateMark !== prevProps.updateMark || // Visible again need reset timer
                this.props.visible !== prevProps.visible && this.props.visible) this.restartCloseTimer();
            }
        },
        {
            key: "componentWillUnmount",
            value: function componentWillUnmount() {
                this.clearCloseTimer();
            }
        },
        {
            key: "restartCloseTimer",
            value: function restartCloseTimer() {
                this.clearCloseTimer();
                this.startCloseTimer();
            }
        },
        {
            key: "render",
            value: function render() {
                var _this2 = this;
                var _this$props2 = this.props, prefixCls = _this$props2.prefixCls, className = _this$props2.className, closable = _this$props2.closable, closeIcon = _this$props2.closeIcon, style = _this$props2.style, onClick = _this$props2.onClick, children = _this$props2.children, holder = _this$props2.holder;
                var componentClass = "".concat(prefixCls, "-notice");
                var dataOrAriaAttributeProps = Object.keys(this.props).reduce(function(acc, key) {
                    if (key.substr(0, 5) === "data-" || key.substr(0, 5) === "aria-" || key === "role") acc[key] = _this2.props[key];
                    return acc;
                }, {});
                var node = /*#__PURE__*/ $acw62.createElement("div", (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({
                    className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))(componentClass, className, (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)({}, "".concat(componentClass, "-closable"), closable)),
                    style: style,
                    onMouseEnter: this.clearCloseTimer,
                    onMouseLeave: this.startCloseTimer,
                    onClick: onClick
                }, dataOrAriaAttributeProps), /*#__PURE__*/ $acw62.createElement("div", {
                    className: "".concat(componentClass, "-content")
                }, children), closable ? /*#__PURE__*/ $acw62.createElement("a", {
                    tabIndex: 0,
                    onClick: this.close,
                    className: "".concat(componentClass, "-close")
                }, closeIcon || /*#__PURE__*/ $acw62.createElement("span", {
                    className: "".concat(componentClass, "-close-x")
                })) : null);
                if (holder) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1u0KT))).createPortal(node, holder);
                return node;
            }
        }
    ]);
    return Notice;
}((0, $acw62.Component));
$6be5862818f90611$export$2e2bcd8739ae039.defaultProps = {
    onClose: function onClose() {},
    duration: 1.5
};






var $acw62 = parcelRequire("acw62");

function $b5312ad231aadb4b$export$2e2bcd8739ae039(notificationInstance) {
    var createdRef = $acw62.useRef({});
    var _React$useState = $acw62.useState([]), _React$useState2 = (0, $adaabbc18727b3e6$export$2e2bcd8739ae039)(_React$useState, 2), elements = _React$useState2[0], setElements = _React$useState2[1];
    function notify(noticeProps) {
        var firstMount = true;
        notificationInstance.add(noticeProps, function(div, props) {
            var key = props.key;
            if (div && (!createdRef.current[key] || firstMount)) {
                var noticeEle = /*#__PURE__*/ $acw62.createElement((0, $6be5862818f90611$export$2e2bcd8739ae039), (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, props, {
                    holder: div
                }));
                createdRef.current[key] = noticeEle;
                setElements(function(originElements) {
                    var index = originElements.findIndex(function(ele) {
                        return ele.key === props.key;
                    });
                    if (index === -1) return [].concat((0, $eb1ed927433e7e98$export$2e2bcd8739ae039)(originElements), [
                        noticeEle
                    ]);
                    var cloneList = (0, $eb1ed927433e7e98$export$2e2bcd8739ae039)(originElements);
                    cloneList[index] = noticeEle;
                    return cloneList;
                });
            }
            firstMount = false;
        });
    }
    return [
        notify,
        /*#__PURE__*/ $acw62.createElement($acw62.Fragment, null, elements)
    ];
}


var $486904b4df561ec3$var$_excluded = [
    "getContainer"
];
var $486904b4df561ec3$var$seed = 0;
var $486904b4df561ec3$var$now = Date.now();
function $486904b4df561ec3$var$getUuid() {
    var id = $486904b4df561ec3$var$seed;
    $486904b4df561ec3$var$seed += 1;
    return "rcNotification_".concat($486904b4df561ec3$var$now, "_").concat(id);
}
var $486904b4df561ec3$var$Notification = /*#__PURE__*/ function(_Component) {
    (0, $0ed648f7bbaf3aff$export$2e2bcd8739ae039)(Notification, _Component);
    var _super = (0, $a76f20fb39fa9d46$export$2e2bcd8739ae039)(Notification);
    function Notification() {
        var _this;
        (0, $4d35ca0862055760$export$2e2bcd8739ae039)(this, Notification);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        _this.state = {
            notices: []
        };
        _this.hookRefs = new Map();
        _this.add = function(originNotice, holderCallback) {
            var _originNotice$key;
            var key = (_originNotice$key = originNotice.key) !== null && _originNotice$key !== void 0 ? _originNotice$key : $486904b4df561ec3$var$getUuid();
            var notice = (0, $983350b7b3960a26$export$2e2bcd8739ae039)((0, $983350b7b3960a26$export$2e2bcd8739ae039)({}, originNotice), {}, {
                key: key
            });
            var maxCount = _this.props.maxCount;
            _this.setState(function(previousState) {
                var notices = previousState.notices;
                var noticeIndex = notices.map(function(v) {
                    return v.notice.key;
                }).indexOf(key);
                var updatedNotices = notices.concat();
                if (noticeIndex !== -1) updatedNotices.splice(noticeIndex, 1, {
                    notice: notice,
                    holderCallback: holderCallback
                });
                else {
                    if (maxCount && notices.length >= maxCount) {
                        // XXX, use key of first item to update new added (let React to move exsiting
                        // instead of remove and mount). Same key was used before for both a) external
                        // manual control and b) internal react 'key' prop , which is not that good.
                        // eslint-disable-next-line no-param-reassign
                        // zombieJ: Not know why use `updateKey`. This makes Notice infinite loop in jest.
                        // Change to `updateMark` for compare instead.
                        // https://github.com/react-component/notification/commit/32299e6be396f94040bfa82517eea940db947ece
                        notice.key = updatedNotices[0].notice.key;
                        notice.updateMark = $486904b4df561ec3$var$getUuid();
                        // zombieJ: That's why. User may close by key directly.
                        // We need record this but not re-render to avoid upper issue
                        // https://github.com/react-component/notification/issues/129
                        notice.userPassKey = key;
                        updatedNotices.shift();
                    }
                    updatedNotices.push({
                        notice: notice,
                        holderCallback: holderCallback
                    });
                }
                return {
                    notices: updatedNotices
                };
            });
        };
        _this.remove = function(removeKey) {
            _this.setState(function(_ref) {
                var notices = _ref.notices;
                return {
                    notices: notices.filter(function(_ref2) {
                        var _ref2$notice = _ref2.notice, key = _ref2$notice.key, userPassKey = _ref2$notice.userPassKey;
                        var mergedKey = userPassKey !== null && userPassKey !== void 0 ? userPassKey : key;
                        return mergedKey !== removeKey;
                    })
                };
            });
        };
        _this.noticePropsMap = {};
        return _this;
    }
    (0, $94019358ecbcf36b$export$2e2bcd8739ae039)(Notification, [
        {
            key: "getTransitionName",
            value: function getTransitionName() {
                var _this$props = this.props, prefixCls = _this$props.prefixCls, animation = _this$props.animation;
                var transitionName = this.props.transitionName;
                if (!transitionName && animation) transitionName = "".concat(prefixCls, "-").concat(animation);
                return transitionName;
            }
        },
        {
            key: "render",
            value: function render() {
                var _this2 = this;
                var notices = this.state.notices;
                var _this$props2 = this.props, prefixCls = _this$props2.prefixCls, className = _this$props2.className, closeIcon = _this$props2.closeIcon, style = _this$props2.style;
                var noticeKeys = [];
                notices.forEach(function(_ref3, index) {
                    var notice = _ref3.notice, holderCallback = _ref3.holderCallback;
                    var updateMark = index === notices.length - 1 ? notice.updateMark : undefined;
                    var key = notice.key, userPassKey = notice.userPassKey;
                    var noticeProps = (0, $983350b7b3960a26$export$2e2bcd8739ae039)((0, $983350b7b3960a26$export$2e2bcd8739ae039)((0, $983350b7b3960a26$export$2e2bcd8739ae039)({
                        prefixCls: prefixCls,
                        closeIcon: closeIcon
                    }, notice), notice.props), {}, {
                        key: key,
                        noticeKey: userPassKey || key,
                        updateMark: updateMark,
                        onClose: function onClose(noticeKey) {
                            var _notice$onClose;
                            _this2.remove(noticeKey);
                            (_notice$onClose = notice.onClose) === null || _notice$onClose === void 0 || _notice$onClose.call(notice);
                        },
                        onClick: notice.onClick,
                        children: notice.content
                    });
                    // Give to motion
                    noticeKeys.push(key);
                    _this2.noticePropsMap[key] = {
                        props: noticeProps,
                        holderCallback: holderCallback
                    };
                });
                return /*#__PURE__*/ $acw62.createElement("div", {
                    className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))(prefixCls, className),
                    style: style
                }, /*#__PURE__*/ $acw62.createElement((0, $ab0f5c5a9767e13d$export$2e2bcd8739ae039), {
                    keys: noticeKeys,
                    motionName: this.getTransitionName(),
                    onVisibleChanged: function onVisibleChanged(changedVisible, _ref4) {
                        var key = _ref4.key;
                        if (!changedVisible) delete _this2.noticePropsMap[key];
                    }
                }, function(_ref5) {
                    var key = _ref5.key, motionClassName = _ref5.className, motionStyle = _ref5.style, visible = _ref5.visible;
                    var _this2$noticePropsMap = _this2.noticePropsMap[key], noticeProps = _this2$noticePropsMap.props, holderCallback = _this2$noticePropsMap.holderCallback;
                    if (holderCallback) return /*#__PURE__*/ $acw62.createElement("div", {
                        key: key,
                        className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))(motionClassName, "".concat(prefixCls, "-hook-holder")),
                        style: (0, $983350b7b3960a26$export$2e2bcd8739ae039)({}, motionStyle),
                        ref: function ref(div) {
                            if (typeof key === "undefined") return;
                            if (div) {
                                _this2.hookRefs.set(key, div);
                                holderCallback(div, noticeProps);
                            } else _this2.hookRefs.delete(key);
                        }
                    });
                    return /*#__PURE__*/ $acw62.createElement((0, $6be5862818f90611$export$2e2bcd8739ae039), (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, noticeProps, {
                        className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))(motionClassName, noticeProps === null || noticeProps === void 0 ? void 0 : noticeProps.className),
                        style: (0, $983350b7b3960a26$export$2e2bcd8739ae039)((0, $983350b7b3960a26$export$2e2bcd8739ae039)({}, motionStyle), noticeProps === null || noticeProps === void 0 ? void 0 : noticeProps.style),
                        visible: visible
                    }));
                }));
            }
        }
    ]);
    return Notification;
}((0, $acw62.Component));
$486904b4df561ec3$var$Notification.newInstance = void 0;
$486904b4df561ec3$var$Notification.defaultProps = {
    prefixCls: "rc-notification",
    animation: "fade",
    style: {
        top: 65,
        left: "50%"
    }
};
$486904b4df561ec3$var$Notification.newInstance = function newNotificationInstance(properties, callback) {
    var _ref6 = properties || {}, getContainer = _ref6.getContainer, props = (0, $73ef9ce1c41fc0c0$export$2e2bcd8739ae039)(_ref6, $486904b4df561ec3$var$_excluded);
    var div = document.createElement("div");
    if (getContainer) {
        var root = getContainer();
        root.appendChild(div);
    } else document.body.appendChild(div);
    var called = false;
    function ref(notification) {
        if (called) return;
        called = true;
        callback({
            notice: function notice(noticeProps) {
                notification.add(noticeProps);
            },
            removeNotice: function removeNotice(key) {
                notification.remove(key);
            },
            component: notification,
            destroy: function destroy() {
                (0, $db3659e597d7eb55$export$121e2d597d222bad)(div);
                if (div.parentNode) div.parentNode.removeChild(div);
            },
            // Hooks
            useNotification: function useNotification() {
                return (0, $b5312ad231aadb4b$export$2e2bcd8739ae039)(notification);
            }
        });
    }
    (0, $db3659e597d7eb55$export$b3890eb0ae9dca99)(/*#__PURE__*/ $acw62.createElement($486904b4df561ec3$var$Notification, (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, props, {
        ref: ref
    })), div);
};
var $486904b4df561ec3$export$2e2bcd8739ae039 = $486904b4df561ec3$var$Notification;


var $2a738245fbef5f76$export$2e2bcd8739ae039 = (0, $486904b4df561ec3$export$2e2bcd8739ae039);



var $acw62 = parcelRequire("acw62");





var $acw62 = parcelRequire("acw62");


function $c44e7f7175cd2535$export$2e2bcd8739ae039(getRcNotificationInstance, getRCNoticeProps) {
    var useMessage = function useMessage() {
        // We can only get content by render
        var getPrefixCls;
        var getPopupContainer;
        // We create a proxy to handle delay created instance
        var innerInstance = null;
        var proxy = {
            add: function add(noticeProps, holderCallback) {
                innerInstance === null || innerInstance === void 0 || innerInstance.component.add(noticeProps, holderCallback);
            }
        };
        var _useRCNotification = (0, $b5312ad231aadb4b$export$2e2bcd8739ae039)(proxy), _useRCNotification2 = (0, $adaabbc18727b3e6$export$2e2bcd8739ae039)(_useRCNotification, 2), hookNotify = _useRCNotification2[0], holder = _useRCNotification2[1];
        function notify(args) {
            var customizePrefixCls = args.prefixCls;
            var mergedPrefixCls = getPrefixCls("message", customizePrefixCls);
            var rootPrefixCls = getPrefixCls();
            var target = args.key || (0, $dc31f36873c2f472$export$ab227b2024307500)();
            var closePromise = new Promise(function(resolve) {
                var callback = function callback() {
                    if (typeof args.onClose === "function") args.onClose();
                    return resolve(true);
                };
                getRcNotificationInstance((0, $618a8e53233cd9fa$export$2e2bcd8739ae039)((0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, args), {
                    prefixCls: mergedPrefixCls,
                    rootPrefixCls: rootPrefixCls,
                    getPopupContainer: getPopupContainer
                }), function(_ref) {
                    var prefixCls = _ref.prefixCls, instance = _ref.instance;
                    innerInstance = instance;
                    hookNotify(getRCNoticeProps((0, $618a8e53233cd9fa$export$2e2bcd8739ae039)((0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, args), {
                        key: target,
                        onClose: callback
                    }), prefixCls));
                });
            });
            var result = function result() {
                if (innerInstance) innerInstance.removeNotice(target);
            };
            result.then = function(filled, rejected) {
                return closePromise.then(filled, rejected);
            };
            result.promise = closePromise;
            return result;
        }
        // Fill functions
        var hookApiRef = $acw62.useRef({});
        hookApiRef.current.open = notify;
        (0, $dc31f36873c2f472$export$37928ca2918d853b).forEach(function(type) {
            return (0, $dc31f36873c2f472$export$63b017493c112c94)(hookApiRef.current, type);
        });
        return [
            hookApiRef.current,
            /*#__PURE__*/ $acw62.createElement((0, $a18b2f6f56546238$export$cd5442f2b8da7663), {
                key: "holder"
            }, function(context) {
                getPrefixCls = context.getPrefixCls;
                getPopupContainer = context.getPopupContainer;
                return holder;
            })
        ];
    };
    return useMessage;
}


var $dc31f36873c2f472$var$messageInstance;
var $dc31f36873c2f472$var$defaultDuration = 3;
var $dc31f36873c2f472$var$defaultTop;
var $dc31f36873c2f472$var$key = 1;
var $dc31f36873c2f472$var$localPrefixCls = "";
var $dc31f36873c2f472$var$transitionName = "move-up";
var $dc31f36873c2f472$var$hasTransitionName = false;
var $dc31f36873c2f472$var$getContainer;
var $dc31f36873c2f472$var$maxCount;
var $dc31f36873c2f472$var$rtl = false;
function $dc31f36873c2f472$export$ab227b2024307500() {
    return $dc31f36873c2f472$var$key++;
}
function $dc31f36873c2f472$var$setMessageConfig(options) {
    if (options.top !== undefined) {
        $dc31f36873c2f472$var$defaultTop = options.top;
        $dc31f36873c2f472$var$messageInstance = null; // delete messageInstance for new defaultTop
    }
    if (options.duration !== undefined) $dc31f36873c2f472$var$defaultDuration = options.duration;
    if (options.prefixCls !== undefined) $dc31f36873c2f472$var$localPrefixCls = options.prefixCls;
    if (options.getContainer !== undefined) {
        $dc31f36873c2f472$var$getContainer = options.getContainer;
        $dc31f36873c2f472$var$messageInstance = null; // delete messageInstance for new getContainer
    }
    if (options.transitionName !== undefined) {
        $dc31f36873c2f472$var$transitionName = options.transitionName;
        $dc31f36873c2f472$var$messageInstance = null; // delete messageInstance for new transitionName
        $dc31f36873c2f472$var$hasTransitionName = true;
    }
    if (options.maxCount !== undefined) {
        $dc31f36873c2f472$var$maxCount = options.maxCount;
        $dc31f36873c2f472$var$messageInstance = null;
    }
    if (options.rtl !== undefined) $dc31f36873c2f472$var$rtl = options.rtl;
}
function $dc31f36873c2f472$var$getRCNotificationInstance(args, callback) {
    var customizePrefixCls = args.prefixCls, getContextPopupContainer = args.getPopupContainer;
    var _globalConfig = (0, $7ed5e10e08c170f8$export$f9cd1e43211d8a4a)(), getPrefixCls = _globalConfig.getPrefixCls, getRootPrefixCls = _globalConfig.getRootPrefixCls, getIconPrefixCls = _globalConfig.getIconPrefixCls;
    var prefixCls = getPrefixCls("message", customizePrefixCls || $dc31f36873c2f472$var$localPrefixCls);
    var rootPrefixCls = getRootPrefixCls(args.rootPrefixCls, prefixCls);
    var iconPrefixCls = getIconPrefixCls();
    if ($dc31f36873c2f472$var$messageInstance) {
        callback({
            prefixCls: prefixCls,
            rootPrefixCls: rootPrefixCls,
            iconPrefixCls: iconPrefixCls,
            instance: $dc31f36873c2f472$var$messageInstance
        });
        return;
    }
    var instanceConfig = {
        prefixCls: prefixCls,
        transitionName: $dc31f36873c2f472$var$hasTransitionName ? $dc31f36873c2f472$var$transitionName : "".concat(rootPrefixCls, "-").concat($dc31f36873c2f472$var$transitionName),
        style: {
            top: $dc31f36873c2f472$var$defaultTop
        },
        getContainer: $dc31f36873c2f472$var$getContainer || getContextPopupContainer,
        maxCount: $dc31f36873c2f472$var$maxCount
    };
    (0, $2a738245fbef5f76$export$2e2bcd8739ae039).newInstance(instanceConfig, function(instance) {
        if ($dc31f36873c2f472$var$messageInstance) {
            callback({
                prefixCls: prefixCls,
                rootPrefixCls: rootPrefixCls,
                iconPrefixCls: iconPrefixCls,
                instance: $dc31f36873c2f472$var$messageInstance
            });
            return;
        }
        $dc31f36873c2f472$var$messageInstance = instance;
        callback({
            prefixCls: prefixCls,
            rootPrefixCls: rootPrefixCls,
            iconPrefixCls: iconPrefixCls,
            instance: instance
        });
    });
}
var $dc31f36873c2f472$var$typeToIcon = {
    info: (0, $b5d5d018bfa4ba6e$export$2e2bcd8739ae039),
    success: (0, $9149fdfb4424d1d9$export$2e2bcd8739ae039),
    error: (0, $81ff9dc68eb84eda$export$2e2bcd8739ae039),
    warning: (0, $2444f6da62064575$export$2e2bcd8739ae039),
    loading: (0, $d8d56e1090f62915$export$2e2bcd8739ae039)
};
var $dc31f36873c2f472$export$37928ca2918d853b = Object.keys($dc31f36873c2f472$var$typeToIcon);
function $dc31f36873c2f472$var$getRCNoticeProps(args, prefixCls, iconPrefixCls) {
    var duration = args.duration !== undefined ? args.duration : $dc31f36873c2f472$var$defaultDuration;
    var IconComponent = $dc31f36873c2f472$var$typeToIcon[args.type];
    var messageClass = (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))("".concat(prefixCls, "-custom-content"), (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)((0, $f329557dcab6d0bb$export$2e2bcd8739ae039)({}, "".concat(prefixCls, "-").concat(args.type), args.type), "".concat(prefixCls, "-rtl"), $dc31f36873c2f472$var$rtl === true));
    return {
        key: args.key,
        duration: duration,
        style: args.style || {},
        className: args.className,
        content: /*#__PURE__*/ $acw62.createElement((0, $7ed5e10e08c170f8$export$2e2bcd8739ae039), {
            iconPrefixCls: iconPrefixCls
        }, /*#__PURE__*/ $acw62.createElement("div", {
            className: messageClass
        }, args.icon || IconComponent && /*#__PURE__*/ $acw62.createElement(IconComponent, null), /*#__PURE__*/ $acw62.createElement("span", null, args.content))),
        onClose: args.onClose,
        onClick: args.onClick
    };
}
function $dc31f36873c2f472$var$notice(args) {
    var target = args.key || $dc31f36873c2f472$export$ab227b2024307500();
    var closePromise = new Promise(function(resolve) {
        var callback = function callback() {
            if (typeof args.onClose === "function") args.onClose();
            return resolve(true);
        };
        $dc31f36873c2f472$var$getRCNotificationInstance(args, function(_ref) {
            var prefixCls = _ref.prefixCls, iconPrefixCls = _ref.iconPrefixCls, instance = _ref.instance;
            instance.notice($dc31f36873c2f472$var$getRCNoticeProps((0, $618a8e53233cd9fa$export$2e2bcd8739ae039)((0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, args), {
                key: target,
                onClose: callback
            }), prefixCls, iconPrefixCls));
        });
    });
    var result = function result() {
        var _a;
        if ($dc31f36873c2f472$var$messageInstance) {
            $dc31f36873c2f472$var$messageInstance.removeNotice(target);
            (_a = args.onClose) === null || _a === void 0 || _a.call(args);
        }
    };
    result.then = function(filled, rejected) {
        return closePromise.then(filled, rejected);
    };
    result.promise = closePromise;
    return result;
}
function $dc31f36873c2f472$var$isArgsProps(content) {
    return Object.prototype.toString.call(content) === "[object Object]" && !!content.content;
}
var $dc31f36873c2f472$var$api = {
    open: $dc31f36873c2f472$var$notice,
    config: $dc31f36873c2f472$var$setMessageConfig,
    destroy: function destroy(messageKey) {
        if ($dc31f36873c2f472$var$messageInstance) {
            if (messageKey) {
                var _messageInstance = $dc31f36873c2f472$var$messageInstance, removeNotice = _messageInstance.removeNotice;
                removeNotice(messageKey);
            } else {
                var _messageInstance2 = $dc31f36873c2f472$var$messageInstance, destroy = _messageInstance2.destroy;
                destroy();
                $dc31f36873c2f472$var$messageInstance = null;
            }
        }
    }
};
function $dc31f36873c2f472$export$63b017493c112c94(originalApi, type) {
    originalApi[type] = function(content, duration, onClose) {
        if ($dc31f36873c2f472$var$isArgsProps(content)) return originalApi.open((0, $618a8e53233cd9fa$export$2e2bcd8739ae039)((0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, content), {
            type: type
        }));
        if (typeof duration === "function") {
            onClose = duration;
            duration = undefined;
        }
        return originalApi.open({
            content: content,
            duration: duration,
            type: type,
            onClose: onClose
        });
    };
}
$dc31f36873c2f472$export$37928ca2918d853b.forEach(function(type) {
    return $dc31f36873c2f472$export$63b017493c112c94($dc31f36873c2f472$var$api, type);
});
$dc31f36873c2f472$var$api.warn = $dc31f36873c2f472$var$api.warning;
$dc31f36873c2f472$var$api.useMessage = (0, $c44e7f7175cd2535$export$2e2bcd8739ae039)($dc31f36873c2f472$var$getRCNotificationInstance, $dc31f36873c2f472$var$getRCNoticeProps);
var $dc31f36873c2f472$export$8bedcca5bbd73999 = function getInstance() {
    return null;
};
var $dc31f36873c2f472$export$2e2bcd8739ae039 = $dc31f36873c2f472$var$api;







var $acw62 = parcelRequire("acw62");
// This icon file is generated automatically.
var $915890149dc0569a$var$CheckCircleOutlined = {
    "icon": {
        "tag": "svg",
        "attrs": {
            "viewBox": "64 64 896 896",
            "focusable": "false"
        },
        "children": [
            {
                "tag": "path",
                "attrs": {
                    "d": "M699 353h-46.9c-10.2 0-19.9 4.9-25.9 13.3L469 584.3l-71.2-98.8c-6-8.3-15.6-13.3-25.9-13.3H325c-6.5 0-10.3 7.4-6.5 12.7l124.6 172.8a31.8 31.8 0 0051.7 0l210.6-292c3.9-5.3.1-12.7-6.4-12.7z"
                }
            },
            {
                "tag": "path",
                "attrs": {
                    "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372z"
                }
            }
        ]
    },
    "name": "check-circle",
    "theme": "outlined"
};
var $915890149dc0569a$export$2e2bcd8739ae039 = $915890149dc0569a$var$CheckCircleOutlined;



var $f98060e25b81d381$var$CheckCircleOutlined = function CheckCircleOutlined(props, ref) {
    return /*#__PURE__*/ $acw62.createElement((0, $7714637e9c1f1f3f$export$2e2bcd8739ae039), (0, $983350b7b3960a26$export$2e2bcd8739ae039)((0, $983350b7b3960a26$export$2e2bcd8739ae039)({}, props), {}, {
        ref: ref,
        icon: (0, $915890149dc0569a$export$2e2bcd8739ae039)
    }));
};
$f98060e25b81d381$var$CheckCircleOutlined.displayName = "CheckCircleOutlined";
var $f98060e25b81d381$export$2e2bcd8739ae039 = /*#__PURE__*/ $acw62.forwardRef($f98060e25b81d381$var$CheckCircleOutlined);




var $acw62 = parcelRequire("acw62");
// This icon file is generated automatically.
var $f986f8662437b397$var$CloseCircleOutlined = {
    "icon": {
        "tag": "svg",
        "attrs": {
            "fill-rule": "evenodd",
            "viewBox": "64 64 896 896",
            "focusable": "false"
        },
        "children": [
            {
                "tag": "path",
                "attrs": {
                    "d": "M512 64c247.4 0 448 200.6 448 448S759.4 960 512 960 64 759.4 64 512 264.6 64 512 64zm0 76c-205.4 0-372 166.6-372 372s166.6 372 372 372 372-166.6 372-372-166.6-372-372-372zm128.01 198.83c.03 0 .05.01.09.06l45.02 45.01a.2.2 0 01.05.09.12.12 0 010 .07c0 .02-.01.04-.05.08L557.25 512l127.87 127.86a.27.27 0 01.05.06v.02a.12.12 0 010 .07c0 .03-.01.05-.05.09l-45.02 45.02a.2.2 0 01-.09.05.12.12 0 01-.07 0c-.02 0-.04-.01-.08-.05L512 557.25 384.14 685.12c-.04.04-.06.05-.08.05a.12.12 0 01-.07 0c-.03 0-.05-.01-.09-.05l-45.02-45.02a.2.2 0 01-.05-.09.12.12 0 010-.07c0-.02.01-.04.06-.08L466.75 512 338.88 384.14a.27.27 0 01-.05-.06l-.01-.02a.12.12 0 010-.07c0-.03.01-.05.05-.09l45.02-45.02a.2.2 0 01.09-.05.12.12 0 01.07 0c.02 0 .04.01.08.06L512 466.75l127.86-127.86c.04-.05.06-.06.08-.06a.12.12 0 01.07 0z"
                }
            }
        ]
    },
    "name": "close-circle",
    "theme": "outlined"
};
var $f986f8662437b397$export$2e2bcd8739ae039 = $f986f8662437b397$var$CloseCircleOutlined;



var $f99ae66c06c40ef9$var$CloseCircleOutlined = function CloseCircleOutlined(props, ref) {
    return /*#__PURE__*/ $acw62.createElement((0, $7714637e9c1f1f3f$export$2e2bcd8739ae039), (0, $983350b7b3960a26$export$2e2bcd8739ae039)((0, $983350b7b3960a26$export$2e2bcd8739ae039)({}, props), {}, {
        ref: ref,
        icon: (0, $f986f8662437b397$export$2e2bcd8739ae039)
    }));
};
$f99ae66c06c40ef9$var$CloseCircleOutlined.displayName = "CloseCircleOutlined";
var $f99ae66c06c40ef9$export$2e2bcd8739ae039 = /*#__PURE__*/ $acw62.forwardRef($f99ae66c06c40ef9$var$CloseCircleOutlined);




var $acw62 = parcelRequire("acw62");
// This icon file is generated automatically.
var $91321edc6c28da63$var$CloseOutlined = {
    "icon": {
        "tag": "svg",
        "attrs": {
            "fill-rule": "evenodd",
            "viewBox": "64 64 896 896",
            "focusable": "false"
        },
        "children": [
            {
                "tag": "path",
                "attrs": {
                    "d": "M799.86 166.31c.02 0 .04.02.08.06l57.69 57.7c.04.03.05.05.06.08a.12.12 0 010 .06c0 .03-.02.05-.06.09L569.93 512l287.7 287.7c.04.04.05.06.06.09a.12.12 0 010 .07c0 .02-.02.04-.06.08l-57.7 57.69c-.03.04-.05.05-.07.06a.12.12 0 01-.07 0c-.03 0-.05-.02-.09-.06L512 569.93l-287.7 287.7c-.04.04-.06.05-.09.06a.12.12 0 01-.07 0c-.02 0-.04-.02-.08-.06l-57.69-57.7c-.04-.03-.05-.05-.06-.07a.12.12 0 010-.07c0-.03.02-.05.06-.09L454.07 512l-287.7-287.7c-.04-.04-.05-.06-.06-.09a.12.12 0 010-.07c0-.02.02-.04.06-.08l57.7-57.69c.03-.04.05-.05.07-.06a.12.12 0 01.07 0c.03 0 .05.02.09.06L512 454.07l287.7-287.7c.04-.04.06-.05.09-.06a.12.12 0 01.07 0z"
                }
            }
        ]
    },
    "name": "close",
    "theme": "outlined"
};
var $91321edc6c28da63$export$2e2bcd8739ae039 = $91321edc6c28da63$var$CloseOutlined;



var $06f117eb9481f34c$var$CloseOutlined = function CloseOutlined(props, ref) {
    return /*#__PURE__*/ $acw62.createElement((0, $7714637e9c1f1f3f$export$2e2bcd8739ae039), (0, $983350b7b3960a26$export$2e2bcd8739ae039)((0, $983350b7b3960a26$export$2e2bcd8739ae039)({}, props), {}, {
        ref: ref,
        icon: (0, $91321edc6c28da63$export$2e2bcd8739ae039)
    }));
};
$06f117eb9481f34c$var$CloseOutlined.displayName = "CloseOutlined";
var $06f117eb9481f34c$export$2e2bcd8739ae039 = /*#__PURE__*/ $acw62.forwardRef($06f117eb9481f34c$var$CloseOutlined);




var $acw62 = parcelRequire("acw62");
// This icon file is generated automatically.
var $fd02a96d61da437a$var$ExclamationCircleOutlined = {
    "icon": {
        "tag": "svg",
        "attrs": {
            "viewBox": "64 64 896 896",
            "focusable": "false"
        },
        "children": [
            {
                "tag": "path",
                "attrs": {
                    "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372z"
                }
            },
            {
                "tag": "path",
                "attrs": {
                    "d": "M464 688a48 48 0 1096 0 48 48 0 10-96 0zm24-112h48c4.4 0 8-3.6 8-8V296c0-4.4-3.6-8-8-8h-48c-4.4 0-8 3.6-8 8v272c0 4.4 3.6 8 8 8z"
                }
            }
        ]
    },
    "name": "exclamation-circle",
    "theme": "outlined"
};
var $fd02a96d61da437a$export$2e2bcd8739ae039 = $fd02a96d61da437a$var$ExclamationCircleOutlined;



var $270cb982fcb46e96$var$ExclamationCircleOutlined = function ExclamationCircleOutlined(props, ref) {
    return /*#__PURE__*/ $acw62.createElement((0, $7714637e9c1f1f3f$export$2e2bcd8739ae039), (0, $983350b7b3960a26$export$2e2bcd8739ae039)((0, $983350b7b3960a26$export$2e2bcd8739ae039)({}, props), {}, {
        ref: ref,
        icon: (0, $fd02a96d61da437a$export$2e2bcd8739ae039)
    }));
};
$270cb982fcb46e96$var$ExclamationCircleOutlined.displayName = "ExclamationCircleOutlined";
var $270cb982fcb46e96$export$2e2bcd8739ae039 = /*#__PURE__*/ $acw62.forwardRef($270cb982fcb46e96$var$ExclamationCircleOutlined);




var $acw62 = parcelRequire("acw62");
// This icon file is generated automatically.
var $a37b6e3a9f9e4b6a$var$InfoCircleOutlined = {
    "icon": {
        "tag": "svg",
        "attrs": {
            "viewBox": "64 64 896 896",
            "focusable": "false"
        },
        "children": [
            {
                "tag": "path",
                "attrs": {
                    "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372z"
                }
            },
            {
                "tag": "path",
                "attrs": {
                    "d": "M464 336a48 48 0 1096 0 48 48 0 10-96 0zm72 112h-48c-4.4 0-8 3.6-8 8v272c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8V456c0-4.4-3.6-8-8-8z"
                }
            }
        ]
    },
    "name": "info-circle",
    "theme": "outlined"
};
var $a37b6e3a9f9e4b6a$export$2e2bcd8739ae039 = $a37b6e3a9f9e4b6a$var$InfoCircleOutlined;



var $f40f87e4967cd996$var$InfoCircleOutlined = function InfoCircleOutlined(props, ref) {
    return /*#__PURE__*/ $acw62.createElement((0, $7714637e9c1f1f3f$export$2e2bcd8739ae039), (0, $983350b7b3960a26$export$2e2bcd8739ae039)((0, $983350b7b3960a26$export$2e2bcd8739ae039)({}, props), {}, {
        ref: ref,
        icon: (0, $a37b6e3a9f9e4b6a$export$2e2bcd8739ae039)
    }));
};
$f40f87e4967cd996$var$InfoCircleOutlined.displayName = "InfoCircleOutlined";
var $f40f87e4967cd996$export$2e2bcd8739ae039 = /*#__PURE__*/ $acw62.forwardRef($f40f87e4967cd996$var$InfoCircleOutlined);





var $acw62 = parcelRequire("acw62");





var $acw62 = parcelRequire("acw62");

function $d6dca93a7303bb6b$export$2e2bcd8739ae039(getNotificationInstance, getRCNoticeProps) {
    var useNotification = function useNotification() {
        // We can only get content by render
        var getPrefixCls;
        // We create a proxy to handle delay created instance
        var innerInstance = null;
        var proxy = {
            add: function add(noticeProps, holderCallback) {
                innerInstance === null || innerInstance === void 0 || innerInstance.component.add(noticeProps, holderCallback);
            }
        };
        var _useRCNotification = (0, $b5312ad231aadb4b$export$2e2bcd8739ae039)(proxy), _useRCNotification2 = (0, $adaabbc18727b3e6$export$2e2bcd8739ae039)(_useRCNotification, 2), hookNotify = _useRCNotification2[0], holder = _useRCNotification2[1];
        function notify(args) {
            var customizePrefixCls = args.prefixCls;
            var mergedPrefixCls = getPrefixCls("notification", customizePrefixCls);
            getNotificationInstance((0, $618a8e53233cd9fa$export$2e2bcd8739ae039)((0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, args), {
                prefixCls: mergedPrefixCls
            }), function(_ref) {
                var prefixCls = _ref.prefixCls, instance = _ref.instance;
                innerInstance = instance;
                hookNotify(getRCNoticeProps(args, prefixCls));
            });
        }
        // Fill functions
        var hookApiRef = $acw62.useRef({});
        hookApiRef.current.open = notify;
        [
            "success",
            "info",
            "warning",
            "error"
        ].forEach(function(type) {
            hookApiRef.current[type] = function(args) {
                return hookApiRef.current.open((0, $618a8e53233cd9fa$export$2e2bcd8739ae039)((0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, args), {
                    type: type
                }));
            };
        });
        return [
            hookApiRef.current,
            /*#__PURE__*/ $acw62.createElement((0, $a18b2f6f56546238$export$cd5442f2b8da7663), {
                key: "holder"
            }, function(context) {
                getPrefixCls = context.getPrefixCls;
                return holder;
            })
        ];
    };
    return useNotification;
}


var $b5c555d97e03a3da$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $b5c555d97e03a3da$var$notificationInstance = {};
var $b5c555d97e03a3da$var$defaultDuration = 4.5;
var $b5c555d97e03a3da$var$defaultTop = 24;
var $b5c555d97e03a3da$var$defaultBottom = 24;
var $b5c555d97e03a3da$var$defaultPrefixCls = "";
var $b5c555d97e03a3da$var$defaultPlacement = "topRight";
var $b5c555d97e03a3da$var$defaultGetContainer;
var $b5c555d97e03a3da$var$defaultCloseIcon;
var $b5c555d97e03a3da$var$rtl = false;
var $b5c555d97e03a3da$var$maxCount;
function $b5c555d97e03a3da$var$setNotificationConfig(options) {
    var duration = options.duration, placement = options.placement, bottom = options.bottom, top = options.top, getContainer = options.getContainer, closeIcon = options.closeIcon, prefixCls = options.prefixCls;
    if (prefixCls !== undefined) $b5c555d97e03a3da$var$defaultPrefixCls = prefixCls;
    if (duration !== undefined) $b5c555d97e03a3da$var$defaultDuration = duration;
    if (placement !== undefined) $b5c555d97e03a3da$var$defaultPlacement = placement;
    else if (options.rtl) $b5c555d97e03a3da$var$defaultPlacement = "topLeft";
    if (bottom !== undefined) $b5c555d97e03a3da$var$defaultBottom = bottom;
    if (top !== undefined) $b5c555d97e03a3da$var$defaultTop = top;
    if (getContainer !== undefined) $b5c555d97e03a3da$var$defaultGetContainer = getContainer;
    if (closeIcon !== undefined) $b5c555d97e03a3da$var$defaultCloseIcon = closeIcon;
    if (options.rtl !== undefined) $b5c555d97e03a3da$var$rtl = options.rtl;
    if (options.maxCount !== undefined) $b5c555d97e03a3da$var$maxCount = options.maxCount;
}
function $b5c555d97e03a3da$var$getPlacementStyle(placement) {
    var top = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : $b5c555d97e03a3da$var$defaultTop;
    var bottom = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : $b5c555d97e03a3da$var$defaultBottom;
    var style;
    switch(placement){
        case "top":
            style = {
                left: "50%",
                transform: "translateX(-50%)",
                right: "auto",
                top: top,
                bottom: "auto"
            };
            break;
        case "topLeft":
            style = {
                left: 0,
                top: top,
                bottom: "auto"
            };
            break;
        case "topRight":
            style = {
                right: 0,
                top: top,
                bottom: "auto"
            };
            break;
        case "bottom":
            style = {
                left: "50%",
                transform: "translateX(-50%)",
                right: "auto",
                top: "auto",
                bottom: bottom
            };
            break;
        case "bottomLeft":
            style = {
                left: 0,
                top: "auto",
                bottom: bottom
            };
            break;
        default:
            style = {
                right: 0,
                top: "auto",
                bottom: bottom
            };
            break;
    }
    return style;
}
function $b5c555d97e03a3da$var$getNotificationInstance(args, callback) {
    var _args$placement = args.placement, placement = _args$placement === void 0 ? $b5c555d97e03a3da$var$defaultPlacement : _args$placement, top = args.top, bottom = args.bottom, _args$getContainer = args.getContainer, getContainer = _args$getContainer === void 0 ? $b5c555d97e03a3da$var$defaultGetContainer : _args$getContainer, customizePrefixCls = args.prefixCls;
    var _globalConfig = (0, $7ed5e10e08c170f8$export$f9cd1e43211d8a4a)(), getPrefixCls = _globalConfig.getPrefixCls, getIconPrefixCls = _globalConfig.getIconPrefixCls;
    var prefixCls = getPrefixCls("notification", customizePrefixCls || $b5c555d97e03a3da$var$defaultPrefixCls);
    var iconPrefixCls = getIconPrefixCls();
    var cacheKey = "".concat(prefixCls, "-").concat(placement);
    var cacheInstance = $b5c555d97e03a3da$var$notificationInstance[cacheKey];
    if (cacheInstance) {
        Promise.resolve(cacheInstance).then(function(instance) {
            callback({
                prefixCls: "".concat(prefixCls, "-notice"),
                iconPrefixCls: iconPrefixCls,
                instance: instance
            });
        });
        return;
    }
    var notificationClass = (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))("".concat(prefixCls, "-").concat(placement), (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)({}, "".concat(prefixCls, "-rtl"), $b5c555d97e03a3da$var$rtl === true));
    $b5c555d97e03a3da$var$notificationInstance[cacheKey] = new Promise(function(resolve) {
        (0, $2a738245fbef5f76$export$2e2bcd8739ae039).newInstance({
            prefixCls: prefixCls,
            className: notificationClass,
            style: $b5c555d97e03a3da$var$getPlacementStyle(placement, top, bottom),
            getContainer: getContainer,
            maxCount: $b5c555d97e03a3da$var$maxCount
        }, function(notification) {
            resolve(notification);
            callback({
                prefixCls: "".concat(prefixCls, "-notice"),
                iconPrefixCls: iconPrefixCls,
                instance: notification
            });
        });
    });
}
var $b5c555d97e03a3da$var$typeToIcon = {
    success: (0, $f98060e25b81d381$export$2e2bcd8739ae039),
    info: (0, $f40f87e4967cd996$export$2e2bcd8739ae039),
    error: (0, $f99ae66c06c40ef9$export$2e2bcd8739ae039),
    warning: (0, $270cb982fcb46e96$export$2e2bcd8739ae039)
};
function $b5c555d97e03a3da$var$getRCNoticeProps(args, prefixCls, iconPrefixCls) {
    var durationArg = args.duration, icon = args.icon, type = args.type, description = args.description, message = args.message, btn = args.btn, onClose = args.onClose, onClick = args.onClick, key = args.key, style = args.style, className = args.className, _args$closeIcon = args.closeIcon, closeIcon = _args$closeIcon === void 0 ? $b5c555d97e03a3da$var$defaultCloseIcon : _args$closeIcon, props = args.props;
    var duration = durationArg === undefined ? $b5c555d97e03a3da$var$defaultDuration : durationArg;
    var iconNode = null;
    if (icon) iconNode = /*#__PURE__*/ $acw62.createElement("span", {
        className: "".concat(prefixCls, "-icon")
    }, args.icon);
    else if (type) iconNode = /*#__PURE__*/ $acw62.createElement($b5c555d97e03a3da$var$typeToIcon[type] || null, {
        className: "".concat(prefixCls, "-icon ").concat(prefixCls, "-icon-").concat(type)
    });
    var closeIconToRender = typeof closeIcon === "undefined" ? /*#__PURE__*/ $acw62.createElement("span", {
        className: "".concat(prefixCls, "-close-x")
    }, /*#__PURE__*/ $acw62.createElement((0, $06f117eb9481f34c$export$2e2bcd8739ae039), {
        className: "".concat(prefixCls, "-close-icon")
    })) : closeIcon;
    var autoMarginTag = !description && iconNode ? /*#__PURE__*/ $acw62.createElement("span", {
        className: "".concat(prefixCls, "-message-single-line-auto-margin")
    }) : null;
    return {
        content: /*#__PURE__*/ $acw62.createElement((0, $7ed5e10e08c170f8$export$2e2bcd8739ae039), {
            iconPrefixCls: iconPrefixCls
        }, /*#__PURE__*/ $acw62.createElement("div", {
            className: iconNode ? "".concat(prefixCls, "-with-icon") : "",
            role: "alert"
        }, iconNode, /*#__PURE__*/ $acw62.createElement("div", {
            className: "".concat(prefixCls, "-message")
        }, autoMarginTag, message), /*#__PURE__*/ $acw62.createElement("div", {
            className: "".concat(prefixCls, "-description")
        }, description), btn ? /*#__PURE__*/ $acw62.createElement("span", {
            className: "".concat(prefixCls, "-btn")
        }, btn) : null)),
        duration: duration,
        closable: true,
        closeIcon: closeIconToRender,
        onClose: onClose,
        onClick: onClick,
        key: key,
        style: style || {},
        className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))(className, (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)({}, "".concat(prefixCls, "-").concat(type), !!type)),
        props: props
    };
}
function $b5c555d97e03a3da$var$notice(args) {
    $b5c555d97e03a3da$var$getNotificationInstance(args, function(_ref) {
        var prefixCls = _ref.prefixCls, iconPrefixCls = _ref.iconPrefixCls, instance = _ref.instance;
        instance.notice($b5c555d97e03a3da$var$getRCNoticeProps(args, prefixCls, iconPrefixCls));
    });
}
var $b5c555d97e03a3da$var$api = {
    open: $b5c555d97e03a3da$var$notice,
    close: function close(key) {
        Object.keys($b5c555d97e03a3da$var$notificationInstance).forEach(function(cacheKey) {
            return Promise.resolve($b5c555d97e03a3da$var$notificationInstance[cacheKey]).then(function(instance) {
                instance.removeNotice(key);
            });
        });
    },
    config: $b5c555d97e03a3da$var$setNotificationConfig,
    destroy: function destroy() {
        Object.keys($b5c555d97e03a3da$var$notificationInstance).forEach(function(cacheKey) {
            Promise.resolve($b5c555d97e03a3da$var$notificationInstance[cacheKey]).then(function(instance) {
                instance.destroy();
            });
            delete $b5c555d97e03a3da$var$notificationInstance[cacheKey]; // lgtm[js/missing-await]
        });
    }
};
[
    "success",
    "info",
    "warning",
    "error"
].forEach(function(type) {
    $b5c555d97e03a3da$var$api[type] = function(args) {
        return $b5c555d97e03a3da$var$api.open((0, $618a8e53233cd9fa$export$2e2bcd8739ae039)((0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, args), {
            type: type
        }));
    };
});
$b5c555d97e03a3da$var$api.warn = $b5c555d97e03a3da$var$api.warning;
$b5c555d97e03a3da$var$api.useNotification = (0, $d6dca93a7303bb6b$export$2e2bcd8739ae039)($b5c555d97e03a3da$var$getNotificationInstance, $b5c555d97e03a3da$var$getRCNoticeProps);
var $b5c555d97e03a3da$export$8bedcca5bbd73999 = function getInstance(cacheKey) {
    return $b5c555d97e03a3da$var$__awaiter(void 0, void 0, void 0, /*#__PURE__*/ (0, $90d00d496f52c75c$export$2e2bcd8739ae039)().mark(function _callee() {
        return (0, $90d00d496f52c75c$export$2e2bcd8739ae039)().wrap(function _callee$(_context) {
            while(true)switch(_context.prev = _context.next){
                case 0:
                    return _context.abrupt("return", null);
                case 1:
                case "end":
                    return _context.stop();
            }
        }, _callee);
    }));
};
var $b5c555d97e03a3da$export$2e2bcd8739ae039 = $b5c555d97e03a3da$var$api;




var $acw62 = parcelRequire("acw62");
var $a18b2f6f56546238$var$defaultGetPrefixCls = function defaultGetPrefixCls(suffixCls, customizePrefixCls) {
    if (customizePrefixCls) return customizePrefixCls;
    return suffixCls ? "ant-".concat(suffixCls) : "ant";
};
var $a18b2f6f56546238$export$a92f85ab3e9ad68b = /*#__PURE__*/ $acw62.createContext({
    // We provide a default function for Context without provider
    getPrefixCls: $a18b2f6f56546238$var$defaultGetPrefixCls
});
var $a18b2f6f56546238$export$cd5442f2b8da7663 = $a18b2f6f56546238$export$a92f85ab3e9ad68b.Consumer;
function $a18b2f6f56546238$export$ac719629fc076fcb(config) {
    return function withConfigConsumerFunc(Component) {
        // Wrap with ConfigConsumer. Since we need compatible with react 15, be care when using ref methods
        var SFC = function SFC(props) {
            return /*#__PURE__*/ $acw62.createElement($a18b2f6f56546238$export$cd5442f2b8da7663, null, function(configProps) {
                var basicPrefixCls = config.prefixCls;
                var getPrefixCls = configProps.getPrefixCls;
                var customizePrefixCls = props.prefixCls;
                var prefixCls = getPrefixCls(basicPrefixCls, customizePrefixCls);
                return /*#__PURE__*/ $acw62.createElement(Component, (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, configProps, props, {
                    prefixCls: prefixCls
                }));
            });
        };
        var cons = Component.constructor;
        var name = cons && cons.displayName || Component.name || "Component";
        SFC.displayName = "withConfigConsumer(".concat(name, ")");
        return SFC;
    };
}


/* eslint-disable import/prefer-default-export, prefer-destructuring */ 




var $6d2f60b2591128fc$export$d850312fc213f33e = /** @class */ function() {
    function TinyColor(color, opts) {
        if (color === void 0) color = "";
        if (opts === void 0) opts = {};
        var _a;
        // If input is already a tinycolor, return itself
        if (color instanceof TinyColor) // eslint-disable-next-line no-constructor-return
        return color;
        if (typeof color === "number") color = (0, $5dbaaddf372549d4$export$4076ec82b665900d)(color);
        this.originalInput = color;
        var rgb = (0, $4146cacf0fc753c3$export$87de337d8199f22c)(color);
        this.originalInput = color;
        this.r = rgb.r;
        this.g = rgb.g;
        this.b = rgb.b;
        this.a = rgb.a;
        this.roundA = Math.round(100 * this.a) / 100;
        this.format = (_a = opts.format) !== null && _a !== void 0 ? _a : rgb.format;
        this.gradientType = opts.gradientType;
        // Don't let the range of [0,255] come back in [0,1].
        // Potentially lose a little bit of precision here, but will fix issues where
        // .5 gets interpreted as half of the total, instead of half of 1
        // If it was supposed to be 128, this was already taken care of by `inputToRgb`
        if (this.r < 1) this.r = Math.round(this.r);
        if (this.g < 1) this.g = Math.round(this.g);
        if (this.b < 1) this.b = Math.round(this.b);
        this.isValid = rgb.ok;
    }
    TinyColor.prototype.isDark = function() {
        return this.getBrightness() < 128;
    };
    TinyColor.prototype.isLight = function() {
        return !this.isDark();
    };
    /**
     * Returns the perceived brightness of the color, from 0-255.
     */ TinyColor.prototype.getBrightness = function() {
        // http://www.w3.org/TR/AERT#color-contrast
        var rgb = this.toRgb();
        return (rgb.r * 299 + rgb.g * 587 + rgb.b * 114) / 1000;
    };
    /**
     * Returns the perceived luminance of a color, from 0-1.
     */ TinyColor.prototype.getLuminance = function() {
        // http://www.w3.org/TR/2008/REC-WCAG20-20081211/#relativeluminancedef
        var rgb = this.toRgb();
        var R;
        var G;
        var B;
        var RsRGB = rgb.r / 255;
        var GsRGB = rgb.g / 255;
        var BsRGB = rgb.b / 255;
        if (RsRGB <= 0.03928) R = RsRGB / 12.92;
        else // eslint-disable-next-line prefer-exponentiation-operator
        R = Math.pow((RsRGB + 0.055) / 1.055, 2.4);
        if (GsRGB <= 0.03928) G = GsRGB / 12.92;
        else // eslint-disable-next-line prefer-exponentiation-operator
        G = Math.pow((GsRGB + 0.055) / 1.055, 2.4);
        if (BsRGB <= 0.03928) B = BsRGB / 12.92;
        else // eslint-disable-next-line prefer-exponentiation-operator
        B = Math.pow((BsRGB + 0.055) / 1.055, 2.4);
        return 0.2126 * R + 0.7152 * G + 0.0722 * B;
    };
    /**
     * Returns the alpha value of a color, from 0-1.
     */ TinyColor.prototype.getAlpha = function() {
        return this.a;
    };
    /**
     * Sets the alpha value on the current color.
     *
     * @param alpha - The new alpha value. The accepted range is 0-1.
     */ TinyColor.prototype.setAlpha = function(alpha) {
        this.a = (0, $89c3f0c2cde0477f$export$3ae665204365318d)(alpha);
        this.roundA = Math.round(100 * this.a) / 100;
        return this;
    };
    /**
     * Returns whether the color is monochrome.
     */ TinyColor.prototype.isMonochrome = function() {
        var s = this.toHsl().s;
        return s === 0;
    };
    /**
     * Returns the object as a HSVA object.
     */ TinyColor.prototype.toHsv = function() {
        var hsv = (0, $5dbaaddf372549d4$export$f76e85ca00a47f5c)(this.r, this.g, this.b);
        return {
            h: hsv.h * 360,
            s: hsv.s,
            v: hsv.v,
            a: this.a
        };
    };
    /**
     * Returns the hsva values interpolated into a string with the following format:
     * "hsva(xxx, xxx, xxx, xx)".
     */ TinyColor.prototype.toHsvString = function() {
        var hsv = (0, $5dbaaddf372549d4$export$f76e85ca00a47f5c)(this.r, this.g, this.b);
        var h = Math.round(hsv.h * 360);
        var s = Math.round(hsv.s * 100);
        var v = Math.round(hsv.v * 100);
        return this.a === 1 ? "hsv(".concat(h, ", ").concat(s, "%, ").concat(v, "%)") : "hsva(".concat(h, ", ").concat(s, "%, ").concat(v, "%, ").concat(this.roundA, ")");
    };
    /**
     * Returns the object as a HSLA object.
     */ TinyColor.prototype.toHsl = function() {
        var hsl = (0, $5dbaaddf372549d4$export$c85ca4f4753af384)(this.r, this.g, this.b);
        return {
            h: hsl.h * 360,
            s: hsl.s,
            l: hsl.l,
            a: this.a
        };
    };
    /**
     * Returns the hsla values interpolated into a string with the following format:
     * "hsla(xxx, xxx, xxx, xx)".
     */ TinyColor.prototype.toHslString = function() {
        var hsl = (0, $5dbaaddf372549d4$export$c85ca4f4753af384)(this.r, this.g, this.b);
        var h = Math.round(hsl.h * 360);
        var s = Math.round(hsl.s * 100);
        var l = Math.round(hsl.l * 100);
        return this.a === 1 ? "hsl(".concat(h, ", ").concat(s, "%, ").concat(l, "%)") : "hsla(".concat(h, ", ").concat(s, "%, ").concat(l, "%, ").concat(this.roundA, ")");
    };
    /**
     * Returns the hex value of the color.
     * @param allow3Char will shorten hex value to 3 char if possible
     */ TinyColor.prototype.toHex = function(allow3Char) {
        if (allow3Char === void 0) allow3Char = false;
        return (0, $5dbaaddf372549d4$export$34d09c4a771c46ef)(this.r, this.g, this.b, allow3Char);
    };
    /**
     * Returns the hex value of the color -with a # prefixed.
     * @param allow3Char will shorten hex value to 3 char if possible
     */ TinyColor.prototype.toHexString = function(allow3Char) {
        if (allow3Char === void 0) allow3Char = false;
        return "#" + this.toHex(allow3Char);
    };
    /**
     * Returns the hex 8 value of the color.
     * @param allow4Char will shorten hex value to 4 char if possible
     */ TinyColor.prototype.toHex8 = function(allow4Char) {
        if (allow4Char === void 0) allow4Char = false;
        return (0, $5dbaaddf372549d4$export$ffee5509a14af63d)(this.r, this.g, this.b, this.a, allow4Char);
    };
    /**
     * Returns the hex 8 value of the color -with a # prefixed.
     * @param allow4Char will shorten hex value to 4 char if possible
     */ TinyColor.prototype.toHex8String = function(allow4Char) {
        if (allow4Char === void 0) allow4Char = false;
        return "#" + this.toHex8(allow4Char);
    };
    /**
     * Returns the shorter hex value of the color depends on its alpha -with a # prefixed.
     * @param allowShortChar will shorten hex value to 3 or 4 char if possible
     */ TinyColor.prototype.toHexShortString = function(allowShortChar) {
        if (allowShortChar === void 0) allowShortChar = false;
        return this.a === 1 ? this.toHexString(allowShortChar) : this.toHex8String(allowShortChar);
    };
    /**
     * Returns the object as a RGBA object.
     */ TinyColor.prototype.toRgb = function() {
        return {
            r: Math.round(this.r),
            g: Math.round(this.g),
            b: Math.round(this.b),
            a: this.a
        };
    };
    /**
     * Returns the RGBA values interpolated into a string with the following format:
     * "RGBA(xxx, xxx, xxx, xx)".
     */ TinyColor.prototype.toRgbString = function() {
        var r = Math.round(this.r);
        var g = Math.round(this.g);
        var b = Math.round(this.b);
        return this.a === 1 ? "rgb(".concat(r, ", ").concat(g, ", ").concat(b, ")") : "rgba(".concat(r, ", ").concat(g, ", ").concat(b, ", ").concat(this.roundA, ")");
    };
    /**
     * Returns the object as a RGBA object.
     */ TinyColor.prototype.toPercentageRgb = function() {
        var fmt = function(x) {
            return "".concat(Math.round((0, $89c3f0c2cde0477f$export$b0e60b43d1d059f0)(x, 255) * 100), "%");
        };
        return {
            r: fmt(this.r),
            g: fmt(this.g),
            b: fmt(this.b),
            a: this.a
        };
    };
    /**
     * Returns the RGBA relative values interpolated into a string
     */ TinyColor.prototype.toPercentageRgbString = function() {
        var rnd = function(x) {
            return Math.round((0, $89c3f0c2cde0477f$export$b0e60b43d1d059f0)(x, 255) * 100);
        };
        return this.a === 1 ? "rgb(".concat(rnd(this.r), "%, ").concat(rnd(this.g), "%, ").concat(rnd(this.b), "%)") : "rgba(".concat(rnd(this.r), "%, ").concat(rnd(this.g), "%, ").concat(rnd(this.b), "%, ").concat(this.roundA, ")");
    };
    /**
     * The 'real' name of the color -if there is one.
     */ TinyColor.prototype.toName = function() {
        if (this.a === 0) return "transparent";
        if (this.a < 1) return false;
        var hex = "#" + (0, $5dbaaddf372549d4$export$34d09c4a771c46ef)(this.r, this.g, this.b, false);
        for(var _i = 0, _a = Object.entries((0, $7c1331a6b98e7de3$export$e4b2ac9215619f8d)); _i < _a.length; _i++){
            var _b = _a[_i], key = _b[0], value = _b[1];
            if (hex === value) return key;
        }
        return false;
    };
    TinyColor.prototype.toString = function(format) {
        var formatSet = Boolean(format);
        format = format !== null && format !== void 0 ? format : this.format;
        var formattedString = false;
        var hasAlpha = this.a < 1 && this.a >= 0;
        var needsAlphaFormat = !formatSet && hasAlpha && (format.startsWith("hex") || format === "name");
        if (needsAlphaFormat) {
            // Special case for "transparent", all other non-alpha formats
            // will return rgba when there is transparency.
            if (format === "name" && this.a === 0) return this.toName();
            return this.toRgbString();
        }
        if (format === "rgb") formattedString = this.toRgbString();
        if (format === "prgb") formattedString = this.toPercentageRgbString();
        if (format === "hex" || format === "hex6") formattedString = this.toHexString();
        if (format === "hex3") formattedString = this.toHexString(true);
        if (format === "hex4") formattedString = this.toHex8String(true);
        if (format === "hex8") formattedString = this.toHex8String();
        if (format === "name") formattedString = this.toName();
        if (format === "hsl") formattedString = this.toHslString();
        if (format === "hsv") formattedString = this.toHsvString();
        return formattedString || this.toHexString();
    };
    TinyColor.prototype.toNumber = function() {
        return (Math.round(this.r) << 16) + (Math.round(this.g) << 8) + Math.round(this.b);
    };
    TinyColor.prototype.clone = function() {
        return new TinyColor(this.toString());
    };
    /**
     * Lighten the color a given amount. Providing 100 will always return white.
     * @param amount - valid between 1-100
     */ TinyColor.prototype.lighten = function(amount) {
        if (amount === void 0) amount = 10;
        var hsl = this.toHsl();
        hsl.l += amount / 100;
        hsl.l = (0, $89c3f0c2cde0477f$export$5c5ee632c52bc4a2)(hsl.l);
        return new TinyColor(hsl);
    };
    /**
     * Brighten the color a given amount, from 0 to 100.
     * @param amount - valid between 1-100
     */ TinyColor.prototype.brighten = function(amount) {
        if (amount === void 0) amount = 10;
        var rgb = this.toRgb();
        rgb.r = Math.max(0, Math.min(255, rgb.r - Math.round(255 * -(amount / 100))));
        rgb.g = Math.max(0, Math.min(255, rgb.g - Math.round(255 * -(amount / 100))));
        rgb.b = Math.max(0, Math.min(255, rgb.b - Math.round(255 * -(amount / 100))));
        return new TinyColor(rgb);
    };
    /**
     * Darken the color a given amount, from 0 to 100.
     * Providing 100 will always return black.
     * @param amount - valid between 1-100
     */ TinyColor.prototype.darken = function(amount) {
        if (amount === void 0) amount = 10;
        var hsl = this.toHsl();
        hsl.l -= amount / 100;
        hsl.l = (0, $89c3f0c2cde0477f$export$5c5ee632c52bc4a2)(hsl.l);
        return new TinyColor(hsl);
    };
    /**
     * Mix the color with pure white, from 0 to 100.
     * Providing 0 will do nothing, providing 100 will always return white.
     * @param amount - valid between 1-100
     */ TinyColor.prototype.tint = function(amount) {
        if (amount === void 0) amount = 10;
        return this.mix("white", amount);
    };
    /**
     * Mix the color with pure black, from 0 to 100.
     * Providing 0 will do nothing, providing 100 will always return black.
     * @param amount - valid between 1-100
     */ TinyColor.prototype.shade = function(amount) {
        if (amount === void 0) amount = 10;
        return this.mix("black", amount);
    };
    /**
     * Desaturate the color a given amount, from 0 to 100.
     * Providing 100 will is the same as calling greyscale
     * @param amount - valid between 1-100
     */ TinyColor.prototype.desaturate = function(amount) {
        if (amount === void 0) amount = 10;
        var hsl = this.toHsl();
        hsl.s -= amount / 100;
        hsl.s = (0, $89c3f0c2cde0477f$export$5c5ee632c52bc4a2)(hsl.s);
        return new TinyColor(hsl);
    };
    /**
     * Saturate the color a given amount, from 0 to 100.
     * @param amount - valid between 1-100
     */ TinyColor.prototype.saturate = function(amount) {
        if (amount === void 0) amount = 10;
        var hsl = this.toHsl();
        hsl.s += amount / 100;
        hsl.s = (0, $89c3f0c2cde0477f$export$5c5ee632c52bc4a2)(hsl.s);
        return new TinyColor(hsl);
    };
    /**
     * Completely desaturates a color into greyscale.
     * Same as calling `desaturate(100)`
     */ TinyColor.prototype.greyscale = function() {
        return this.desaturate(100);
    };
    /**
     * Spin takes a positive or negative amount within [-360, 360] indicating the change of hue.
     * Values outside of this range will be wrapped into this range.
     */ TinyColor.prototype.spin = function(amount) {
        var hsl = this.toHsl();
        var hue = (hsl.h + amount) % 360;
        hsl.h = hue < 0 ? 360 + hue : hue;
        return new TinyColor(hsl);
    };
    /**
     * Mix the current color a given amount with another color, from 0 to 100.
     * 0 means no mixing (return current color).
     */ TinyColor.prototype.mix = function(color, amount) {
        if (amount === void 0) amount = 50;
        var rgb1 = this.toRgb();
        var rgb2 = new TinyColor(color).toRgb();
        var p = amount / 100;
        var rgba = {
            r: (rgb2.r - rgb1.r) * p + rgb1.r,
            g: (rgb2.g - rgb1.g) * p + rgb1.g,
            b: (rgb2.b - rgb1.b) * p + rgb1.b,
            a: (rgb2.a - rgb1.a) * p + rgb1.a
        };
        return new TinyColor(rgba);
    };
    TinyColor.prototype.analogous = function(results, slices) {
        if (results === void 0) results = 6;
        if (slices === void 0) slices = 30;
        var hsl = this.toHsl();
        var part = 360 / slices;
        var ret = [
            this
        ];
        for(hsl.h = (hsl.h - (part * results >> 1) + 720) % 360; --results;){
            hsl.h = (hsl.h + part) % 360;
            ret.push(new TinyColor(hsl));
        }
        return ret;
    };
    /**
     * taken from https://github.com/infusion/jQuery-xcolor/blob/master/jquery.xcolor.js
     */ TinyColor.prototype.complement = function() {
        var hsl = this.toHsl();
        hsl.h = (hsl.h + 180) % 360;
        return new TinyColor(hsl);
    };
    TinyColor.prototype.monochromatic = function(results) {
        if (results === void 0) results = 6;
        var hsv = this.toHsv();
        var h = hsv.h;
        var s = hsv.s;
        var v = hsv.v;
        var res = [];
        var modification = 1 / results;
        while(results--){
            res.push(new TinyColor({
                h: h,
                s: s,
                v: v
            }));
            v = (v + modification) % 1;
        }
        return res;
    };
    TinyColor.prototype.splitcomplement = function() {
        var hsl = this.toHsl();
        var h = hsl.h;
        return [
            this,
            new TinyColor({
                h: (h + 72) % 360,
                s: hsl.s,
                l: hsl.l
            }),
            new TinyColor({
                h: (h + 216) % 360,
                s: hsl.s,
                l: hsl.l
            })
        ];
    };
    /**
     * Compute how the color would appear on a background
     */ TinyColor.prototype.onBackground = function(background) {
        var fg = this.toRgb();
        var bg = new TinyColor(background).toRgb();
        var alpha = fg.a + bg.a * (1 - fg.a);
        return new TinyColor({
            r: (fg.r * fg.a + bg.r * bg.a * (1 - fg.a)) / alpha,
            g: (fg.g * fg.a + bg.g * bg.a * (1 - fg.a)) / alpha,
            b: (fg.b * fg.a + bg.b * bg.a * (1 - fg.a)) / alpha,
            a: alpha
        });
    };
    /**
     * Alias for `polyad(3)`
     */ TinyColor.prototype.triad = function() {
        return this.polyad(3);
    };
    /**
     * Alias for `polyad(4)`
     */ TinyColor.prototype.tetrad = function() {
        return this.polyad(4);
    };
    /**
     * Get polyad colors, like (for 1, 2, 3, 4, 5, 6, 7, 8, etc...)
     * monad, dyad, triad, tetrad, pentad, hexad, heptad, octad, etc...
     */ TinyColor.prototype.polyad = function(n) {
        var hsl = this.toHsl();
        var h = hsl.h;
        var result = [
            this
        ];
        var increment = 360 / n;
        for(var i = 1; i < n; i++)result.push(new TinyColor({
            h: (h + i * increment) % 360,
            s: hsl.s,
            l: hsl.l
        }));
        return result;
    };
    /**
     * compare color vs current color
     */ TinyColor.prototype.equals = function(color) {
        return this.toRgbString() === new TinyColor(color).toRgbString();
    };
    return TinyColor;
}();
function $6d2f60b2591128fc$export$6325b328a5266d34(color, opts) {
    if (color === void 0) color = "";
    if (opts === void 0) opts = {};
    return new $6d2f60b2591128fc$export$d850312fc213f33e(color, opts);
}





var $e1ca56936d2d2b32$var$dynamicStyleMark = "-ant-".concat(Date.now(), "-").concat(Math.random());
function $e1ca56936d2d2b32$export$3d2f074408bd1b82(globalPrefixCls, theme) {
    var variables = {};
    var formatColor = function formatColor(color, updater) {
        var clone = color.clone();
        clone = (updater === null || updater === void 0 ? void 0 : updater(clone)) || clone;
        return clone.toRgbString();
    };
    var fillColor = function fillColor(colorVal, type) {
        var baseColor = new (0, $6d2f60b2591128fc$export$d850312fc213f33e)(colorVal);
        var colorPalettes = (0, $9ec4f31fbae764a3$export$80d376111cc09ad7)(baseColor.toRgbString());
        variables["".concat(type, "-color")] = formatColor(baseColor);
        variables["".concat(type, "-color-disabled")] = colorPalettes[1];
        variables["".concat(type, "-color-hover")] = colorPalettes[4];
        variables["".concat(type, "-color-active")] = colorPalettes[6];
        variables["".concat(type, "-color-outline")] = baseColor.clone().setAlpha(0.2).toRgbString();
        variables["".concat(type, "-color-deprecated-bg")] = colorPalettes[0];
        variables["".concat(type, "-color-deprecated-border")] = colorPalettes[2];
    };
    // ================ Primary Color ================
    if (theme.primaryColor) {
        fillColor(theme.primaryColor, "primary");
        var primaryColor = new (0, $6d2f60b2591128fc$export$d850312fc213f33e)(theme.primaryColor);
        var primaryColors = (0, $9ec4f31fbae764a3$export$80d376111cc09ad7)(primaryColor.toRgbString());
        // Legacy - We should use semantic naming standard
        primaryColors.forEach(function(color, index) {
            variables["primary-".concat(index + 1)] = color;
        });
        // Deprecated
        variables["primary-color-deprecated-l-35"] = formatColor(primaryColor, function(c) {
            return c.lighten(35);
        });
        variables["primary-color-deprecated-l-20"] = formatColor(primaryColor, function(c) {
            return c.lighten(20);
        });
        variables["primary-color-deprecated-t-20"] = formatColor(primaryColor, function(c) {
            return c.tint(20);
        });
        variables["primary-color-deprecated-t-50"] = formatColor(primaryColor, function(c) {
            return c.tint(50);
        });
        variables["primary-color-deprecated-f-12"] = formatColor(primaryColor, function(c) {
            return c.setAlpha(c.getAlpha() * 0.12);
        });
        var primaryActiveColor = new (0, $6d2f60b2591128fc$export$d850312fc213f33e)(primaryColors[0]);
        variables["primary-color-active-deprecated-f-30"] = formatColor(primaryActiveColor, function(c) {
            return c.setAlpha(c.getAlpha() * 0.3);
        });
        variables["primary-color-active-deprecated-d-02"] = formatColor(primaryActiveColor, function(c) {
            return c.darken(2);
        });
    }
    // ================ Success Color ================
    if (theme.successColor) fillColor(theme.successColor, "success");
    // ================ Warning Color ================
    if (theme.warningColor) fillColor(theme.warningColor, "warning");
    // ================= Error Color =================
    if (theme.errorColor) fillColor(theme.errorColor, "error");
    // ================= Info Color ==================
    if (theme.infoColor) fillColor(theme.infoColor, "info");
    // Convert to css variables
    var cssList = Object.keys(variables).map(function(key) {
        return "--".concat(globalPrefixCls, "-").concat(key, ": ").concat(variables[key], ";");
    });
    return "\n  :root {\n    ".concat(cssList.join("\n"), "\n  }\n  ").trim();
}
function $e1ca56936d2d2b32$export$f9c59eed5de5ff80(globalPrefixCls, theme) {
    var style = $e1ca56936d2d2b32$export$3d2f074408bd1b82(globalPrefixCls, theme);
    if ((0, $c6daeb3adc2b0e60$export$2e2bcd8739ae039)()) (0, $3a22468320d7d808$export$4d99a2890bb989f0)(style, "".concat($e1ca56936d2d2b32$var$dynamicStyleMark, "-dynamic-theme"));
    else (0, $5bd796dbed593bbb$export$2e2bcd8739ae039)(false, "ConfigProvider", "SSR do not support dynamic theme with css variables.");
}



var $acw62 = parcelRequire("acw62");
var $6ba6819805fb0a44$var$DisabledContext = /*#__PURE__*/ $acw62.createContext(false);
var $6ba6819805fb0a44$export$6adb5f3b918b11bb = function DisabledContextProvider(_ref) {
    var children = _ref.children, disabled = _ref.disabled;
    var originDisabled = $acw62.useContext($6ba6819805fb0a44$var$DisabledContext);
    return /*#__PURE__*/ $acw62.createElement($6ba6819805fb0a44$var$DisabledContext.Provider, {
        value: disabled !== null && disabled !== void 0 ? disabled : originDisabled
    }, children);
};
var $6ba6819805fb0a44$export$2e2bcd8739ae039 = $6ba6819805fb0a44$var$DisabledContext;



var $acw62 = parcelRequire("acw62");
var $3e100f55cf8f3689$var$SizeContext = /*#__PURE__*/ $acw62.createContext(undefined);
var $3e100f55cf8f3689$export$dbc92d89fabc8ebe = function SizeContextProvider(_ref) {
    var children = _ref.children, size = _ref.size;
    return /*#__PURE__*/ $acw62.createElement($3e100f55cf8f3689$var$SizeContext.Consumer, null, function(originSize) {
        return /*#__PURE__*/ $acw62.createElement($3e100f55cf8f3689$var$SizeContext.Provider, {
            value: size || originSize
        }, children);
    });
};
var $3e100f55cf8f3689$export$2e2bcd8739ae039 = $3e100f55cf8f3689$var$SizeContext;


var $7ed5e10e08c170f8$export$e7f14a745e5c386a = [
    "getTargetContainer",
    "getPopupContainer",
    "rootPrefixCls",
    "getPrefixCls",
    "renderEmpty",
    "csp",
    "autoInsertSpaceInButton",
    "locale",
    "pageHeader"
];
// These props is used by `useContext` directly in sub component
var $7ed5e10e08c170f8$var$PASSED_PROPS = [
    "getTargetContainer",
    "getPopupContainer",
    "renderEmpty",
    "pageHeader",
    "input",
    "pagination",
    "form"
];
var $7ed5e10e08c170f8$export$e4ec87ea71f29b41 = "ant";
var $7ed5e10e08c170f8$export$eaca8ee5ed21b4e9 = "anticon";
var $7ed5e10e08c170f8$var$globalPrefixCls;
var $7ed5e10e08c170f8$var$globalIconPrefixCls;
function $7ed5e10e08c170f8$var$getGlobalPrefixCls() {
    return $7ed5e10e08c170f8$var$globalPrefixCls || $7ed5e10e08c170f8$export$e4ec87ea71f29b41;
}
function $7ed5e10e08c170f8$var$getGlobalIconPrefixCls() {
    return $7ed5e10e08c170f8$var$globalIconPrefixCls || $7ed5e10e08c170f8$export$eaca8ee5ed21b4e9;
}
var $7ed5e10e08c170f8$var$setGlobalConfig = function setGlobalConfig(_ref) {
    var prefixCls = _ref.prefixCls, iconPrefixCls = _ref.iconPrefixCls, theme = _ref.theme;
    if (prefixCls !== undefined) $7ed5e10e08c170f8$var$globalPrefixCls = prefixCls;
    if (iconPrefixCls !== undefined) $7ed5e10e08c170f8$var$globalIconPrefixCls = iconPrefixCls;
    if (theme) (0, $e1ca56936d2d2b32$export$f9c59eed5de5ff80)($7ed5e10e08c170f8$var$getGlobalPrefixCls(), theme);
};
var $7ed5e10e08c170f8$export$f9cd1e43211d8a4a = function globalConfig() {
    return {
        getPrefixCls: function getPrefixCls(suffixCls, customizePrefixCls) {
            if (customizePrefixCls) return customizePrefixCls;
            return suffixCls ? "".concat($7ed5e10e08c170f8$var$getGlobalPrefixCls(), "-").concat(suffixCls) : $7ed5e10e08c170f8$var$getGlobalPrefixCls();
        },
        getIconPrefixCls: $7ed5e10e08c170f8$var$getGlobalIconPrefixCls,
        getRootPrefixCls: function getRootPrefixCls(rootPrefixCls, customizePrefixCls) {
            // Customize rootPrefixCls is first priority
            if (rootPrefixCls) return rootPrefixCls;
            // If Global prefixCls provided, use this
            if ($7ed5e10e08c170f8$var$globalPrefixCls) return $7ed5e10e08c170f8$var$globalPrefixCls;
            // [Legacy] If customize prefixCls provided, we cut it to get the prefixCls
            if (customizePrefixCls && customizePrefixCls.includes("-")) return customizePrefixCls.replace(/^(.*)-[^-]*$/, "$1");
            // Fallback to default prefixCls
            return $7ed5e10e08c170f8$var$getGlobalPrefixCls();
        }
    };
};
var $7ed5e10e08c170f8$var$ProviderChildren = function ProviderChildren(props) {
    var children = props.children, csp = props.csp, autoInsertSpaceInButton = props.autoInsertSpaceInButton, form = props.form, locale = props.locale, componentSize = props.componentSize, direction = props.direction, space = props.space, virtual = props.virtual, dropdownMatchSelectWidth = props.dropdownMatchSelectWidth, legacyLocale = props.legacyLocale, parentContext = props.parentContext, iconPrefixCls = props.iconPrefixCls, componentDisabled = props.componentDisabled;
    var getPrefixCls = $acw62.useCallback(function(suffixCls, customizePrefixCls) {
        var prefixCls = props.prefixCls;
        if (customizePrefixCls) return customizePrefixCls;
        var mergedPrefixCls = prefixCls || parentContext.getPrefixCls("");
        return suffixCls ? "".concat(mergedPrefixCls, "-").concat(suffixCls) : mergedPrefixCls;
    }, [
        parentContext.getPrefixCls,
        props.prefixCls
    ]);
    var config = (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)((0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, parentContext), {
        csp: csp,
        autoInsertSpaceInButton: autoInsertSpaceInButton,
        locale: locale || legacyLocale,
        direction: direction,
        space: space,
        virtual: virtual,
        dropdownMatchSelectWidth: dropdownMatchSelectWidth,
        getPrefixCls: getPrefixCls
    });
    // Pass the props used by `useContext` directly with child component.
    // These props should merged into `config`.
    $7ed5e10e08c170f8$var$PASSED_PROPS.forEach(function(propName) {
        var propValue = props[propName];
        if (propValue) config[propName] = propValue;
    });
    // https://github.com/ant-design/ant-design/issues/27617
    var memoedConfig = (0, $2e4d16a6147a082d$export$2e2bcd8739ae039)(function() {
        return config;
    }, config, function(prevConfig, currentConfig) {
        var prevKeys = Object.keys(prevConfig);
        var currentKeys = Object.keys(currentConfig);
        return prevKeys.length !== currentKeys.length || prevKeys.some(function(key) {
            return prevConfig[key] !== currentConfig[key];
        });
    });
    var memoIconContextValue = $acw62.useMemo(function() {
        return {
            prefixCls: iconPrefixCls,
            csp: csp
        };
    }, [
        iconPrefixCls,
        csp
    ]);
    var childNode = children;
    var validateMessages = $acw62.useMemo(function() {
        var _a, _b, _c, _d;
        return (0, $4bc24eaedd2a47a4$export$4950aa0f605343fb)(((_a = (0, $8cffcf0f0d1231b6$export$2e2bcd8739ae039).Form) === null || _a === void 0 ? void 0 : _a.defaultValidateMessages) || {}, ((_c = (_b = memoedConfig.locale) === null || _b === void 0 ? void 0 : _b.Form) === null || _c === void 0 ? void 0 : _c.defaultValidateMessages) || {}, ((_d = memoedConfig.form) === null || _d === void 0 ? void 0 : _d.validateMessages) || {}, (form === null || form === void 0 ? void 0 : form.validateMessages) || {});
    }, [
        memoedConfig,
        form === null || form === void 0 ? void 0 : form.validateMessages
    ]);
    if (Object.keys(validateMessages).length > 0) childNode = /*#__PURE__*/ $acw62.createElement((0, $efabd6732f69a6da$export$2e2bcd8739ae039).Provider, {
        value: validateMessages
    }, children);
    if (locale) childNode = /*#__PURE__*/ $acw62.createElement((0, $fab4cbd3d1c845d7$export$2e2bcd8739ae039), {
        locale: locale,
        _ANT_MARK__: (0, $fab4cbd3d1c845d7$export$b2f162cd5c15ea3e)
    }, childNode);
    if (iconPrefixCls || csp) childNode = /*#__PURE__*/ $acw62.createElement((0, $6bacc63174d40f3c$export$2e2bcd8739ae039).Provider, {
        value: memoIconContextValue
    }, childNode);
    if (componentSize) childNode = /*#__PURE__*/ $acw62.createElement((0, $3e100f55cf8f3689$export$dbc92d89fabc8ebe), {
        size: componentSize
    }, childNode);
    if (componentDisabled !== undefined) childNode = /*#__PURE__*/ $acw62.createElement((0, $6ba6819805fb0a44$export$6adb5f3b918b11bb), {
        disabled: componentDisabled
    }, childNode);
    return /*#__PURE__*/ $acw62.createElement((0, $a18b2f6f56546238$export$a92f85ab3e9ad68b).Provider, {
        value: memoedConfig
    }, childNode);
};
var $7ed5e10e08c170f8$var$ConfigProvider = function ConfigProvider(props) {
    $acw62.useEffect(function() {
        if (props.direction) {
            (0, $dc31f36873c2f472$export$2e2bcd8739ae039).config({
                rtl: props.direction === "rtl"
            });
            (0, $b5c555d97e03a3da$export$2e2bcd8739ae039).config({
                rtl: props.direction === "rtl"
            });
        }
    }, [
        props.direction
    ]);
    return /*#__PURE__*/ $acw62.createElement((0, $715b7b8518c4616e$export$2e2bcd8739ae039), null, function(_, __, legacyLocale) {
        return /*#__PURE__*/ $acw62.createElement((0, $a18b2f6f56546238$export$cd5442f2b8da7663), null, function(context) {
            return /*#__PURE__*/ $acw62.createElement($7ed5e10e08c170f8$var$ProviderChildren, (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({
                parentContext: context,
                legacyLocale: legacyLocale
            }, props));
        });
    });
};
/** @private internal Usage. do not use in your production */ $7ed5e10e08c170f8$var$ConfigProvider.ConfigContext = (0, $a18b2f6f56546238$export$a92f85ab3e9ad68b);
$7ed5e10e08c170f8$var$ConfigProvider.SizeContext = (0, $3e100f55cf8f3689$export$2e2bcd8739ae039);
$7ed5e10e08c170f8$var$ConfigProvider.config = $7ed5e10e08c170f8$var$setGlobalConfig;
var $7ed5e10e08c170f8$export$2e2bcd8739ae039 = $7ed5e10e08c170f8$var$ConfigProvider;


var $80ed0340bf7aa3fb$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $80ed0340bf7aa3fb$var$Carousel = /*#__PURE__*/ $acw62.forwardRef(function(_a, ref) {
    var _a$dots = _a.dots, dots = _a$dots === void 0 ? true : _a$dots, _a$arrows = _a.arrows, arrows = _a$arrows === void 0 ? false : _a$arrows, _a$draggable = _a.draggable, draggable = _a$draggable === void 0 ? false : _a$draggable, _a$dotPosition = _a.dotPosition, dotPosition = _a$dotPosition === void 0 ? "bottom" : _a$dotPosition, _a$vertical = _a.vertical, vertical = _a$vertical === void 0 ? dotPosition === "left" || dotPosition === "right" : _a$vertical, props = $80ed0340bf7aa3fb$var$__rest(_a, [
        "dots",
        "arrows",
        "draggable",
        "dotPosition",
        "vertical"
    ]);
    var _React$useContext = $acw62.useContext((0, $a18b2f6f56546238$export$a92f85ab3e9ad68b)), getPrefixCls = _React$useContext.getPrefixCls, direction = _React$useContext.direction;
    var slickRef = $acw62.useRef();
    var goTo = function goTo(slide) {
        var dontAnimate = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
        slickRef.current.slickGoTo(slide, dontAnimate);
    };
    $acw62.useImperativeHandle(ref, function() {
        return {
            goTo: goTo,
            autoPlay: slickRef.current.innerSlider.autoPlay,
            innerSlider: slickRef.current.innerSlider,
            prev: slickRef.current.slickPrev,
            next: slickRef.current.slickNext
        };
    }, [
        slickRef.current
    ]);
    var prevCount = $acw62.useRef($acw62.Children.count(props.children));
    $acw62.useEffect(function() {
        if (prevCount.current !== $acw62.Children.count(props.children)) {
            goTo(props.initialSlide || 0, false);
            prevCount.current = $acw62.Children.count(props.children);
        }
    }, [
        props.children
    ]);
    var newProps = (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({
        vertical: vertical
    }, props);
    if (newProps.effect === "fade") newProps.fade = true;
    var prefixCls = getPrefixCls("carousel", newProps.prefixCls);
    var dotsClass = "slick-dots";
    var enableDots = !!dots;
    var dsClass = (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))(dotsClass, "".concat(dotsClass, "-").concat(dotPosition), typeof dots === "boolean" ? false : dots === null || dots === void 0 ? void 0 : dots.className);
    var className = (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))(prefixCls, (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)((0, $f329557dcab6d0bb$export$2e2bcd8739ae039)({}, "".concat(prefixCls, "-rtl"), direction === "rtl"), "".concat(prefixCls, "-vertical"), dotPosition === "left" || dotPosition === "right"));
    return /*#__PURE__*/ $acw62.createElement("div", {
        className: className
    }, /*#__PURE__*/ $acw62.createElement((0, $dcbb38da091da394$export$2e2bcd8739ae039), (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({
        ref: slickRef
    }, newProps, {
        dots: enableDots,
        dotsClass: dsClass,
        arrows: arrows,
        draggable: draggable
    })));
});
var $80ed0340bf7aa3fb$export$2e2bcd8739ae039 = $80ed0340bf7aa3fb$var$Carousel;



var $acw62 = parcelRequire("acw62");

var $463be31eb7b3fca8$exports = {};
$463be31eb7b3fca8$exports = new URL("hire_1.c711d03d.svg", import.meta.url).toString();


var $2c97810175f3c8de$exports = {};
$2c97810175f3c8de$exports = new URL("edit-company.091ac09d.svg", import.meta.url).toString();


var $4bef3b2b35623a04$exports = {};
$4bef3b2b35623a04$exports = new URL("add-poc.fae6b8cf.svg", import.meta.url).toString();


var $467750f60c3549bc$exports = {};
$467750f60c3549bc$exports = new URL("lean.a1dceb7a.svg", import.meta.url).toString();


var $e668d826b297c199$exports = {};
$e668d826b297c199$exports = new URL("qr-scan.b66bc1f3.svg", import.meta.url).toString();


var $7f27be6c97315018$exports = {};
$7f27be6c97315018$exports = new URL("become-affiliate.0139a0b1.svg", import.meta.url).toString();




var $acw62 = parcelRequire("acw62");

const $1edebf0ebb95fed3$export$cabb5ccfbd60cbd4 = ({ containerClassNames: containerClassNames, icon: icon, title: title, actions: actions, imageStyle: imageStyle })=>{
    const { isRtl: isRtl } = (0, $acw62.useContext)((0, $392d2c14aa582458$export$9e7c8e903bb56df9));
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: `CarouselSlide ${containerClassNames}`,
        dir: isRtl ? "rtl" : "ltr",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                src: icon,
                className: "CarouselSlide__img",
                style: imageStyle
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "CarouselSlide__rightContainer",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                        className: "CarouselSlide__rightContainer__title",
                        children: title
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "CarouselSlide__rightContainer__actions",
                        children: actions.map((action, key)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                onClick: action.onClick,
                                className: `CarouselSlide__rightContainer__button ${action.classNames}`,
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                    children: action.title
                                })
                            }, key))
                    })
                ]
            })
        ]
    });
};





const $1bc587c9b2910747$var$AUTOPLAY_DURATION = 5000;
const $1bc587c9b2910747$export$4417311e0c30ffed = (props)=>{
    const { t: t } = (0, $3765cebd031b52c0$export$9fc83ad70ead8663)();
    const { isRtl: isRtl } = (0, $acw62.useContext)((0, $392d2c14aa582458$export$9e7c8e903bb56df9));
    if (props.isLoading) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $57fb8f45c69e1681$export$2e2bcd8739ae039), {});
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $80ed0340bf7aa3fb$export$2e2bcd8739ae039), {
        swipe: true,
        draggable: true,
        autoplay: true,
        autoplaySpeed: $1bc587c9b2910747$var$AUTOPLAY_DURATION,
        rtl: isRtl,
        children: [
            props.showConnectLeanSlide && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $1edebf0ebb95fed3$export$cabb5ccfbd60cbd4), {
                containerClassNames: "CarouselSlide--hire",
                icon: (0, (/*@__PURE__*/$parcel$interopDefault($467750f60c3549bc$exports))),
                title: t("uncompleted_actions_carousel.connect_your_bank_account"),
                actions: props.connectLeanActions,
                imageStyle: {
                    width: "60px",
                    marginLeft: "30px",
                    marginRight: "15px"
                }
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $1edebf0ebb95fed3$export$cabb5ccfbd60cbd4), {
                containerClassNames: "CarouselSlide--hire",
                icon: (0, (/*@__PURE__*/$parcel$interopDefault($463be31eb7b3fca8$exports))),
                title: t("uncompleted_actions_carousel.looking_for_staff"),
                actions: props.hireActions
            }),
            props.showEditCompanySlide && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $1edebf0ebb95fed3$export$cabb5ccfbd60cbd4), {
                containerClassNames: "CarouselSlide--edit-company",
                icon: (0, (/*@__PURE__*/$parcel$interopDefault($2c97810175f3c8de$exports))),
                title: t("uncompleted_actions_carousel.edit_company"),
                actions: props.editCompanyActions
            }),
            props.showAddPocSlide && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $1edebf0ebb95fed3$export$cabb5ccfbd60cbd4), {
                containerClassNames: "CarouselSlide--add-poc",
                icon: (0, (/*@__PURE__*/$parcel$interopDefault($4bef3b2b35623a04$exports))),
                title: t("uncompleted_actions_carousel.add_poc"),
                actions: props.addPocActions
            }),
            props.showBecomeAffiliateSlide && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $1edebf0ebb95fed3$export$cabb5ccfbd60cbd4), {
                containerClassNames: "CarouselSlide--become-affiliate",
                icon: (0, (/*@__PURE__*/$parcel$interopDefault($7f27be6c97315018$exports))),
                title: t("uncompleted_actions_carousel.become_affiliate"),
                actions: props.becomeAffiliateActions
            }),
            props.showScanQRSlide && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $1edebf0ebb95fed3$export$cabb5ccfbd60cbd4), {
                containerClassNames: "CarouselSlide--scan-qr",
                icon: (0, (/*@__PURE__*/$parcel$interopDefault($e668d826b297c199$exports))),
                title: t("qr_scan.carousel_title"),
                actions: props.scanQRActions
            })
        ]
    });
};


const $24db3b11bdd0fa3c$var$UncompletedActionsCarouselContainer = (0, $1d4eb1be4983b805$export$1b87ac28858f953e)((0, $1bc587c9b2910747$export$4417311e0c30ffed));
const $24db3b11bdd0fa3c$export$4417311e0c30ffed = ({ openBecomeAffiliateModal: openBecomeAffiliateModal })=>{
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($24db3b11bdd0fa3c$var$UncompletedActionsCarouselContainer, {
        openBecomeAffiliateModal: openBecomeAffiliateModal
    });
};




var $acw62 = parcelRequire("acw62");





const $75280a546f53cf50$export$60332b2344f7fe41 = ({ amount: amount, title: title, backgroundColor: backgroundColor, color: color, image: image, onPress: onPress })=>{
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        onClick: onPress,
        className: "Card",
        style: {
            backgroundColor: backgroundColor
        },
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                src: image,
                alt: "",
                className: "img"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "Card__right-container",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                        className: "amount",
                        style: {
                            color: color
                        },
                        children: amount
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                        className: "title",
                        style: {
                            color: color
                        },
                        children: title
                    })
                ]
            })
        ]
    });
};


var $44f9a27fa15a1f6c$exports = {};
$44f9a27fa15a1f6c$exports = new URL("shifts_attendance_review.e7f77c23.svg", import.meta.url).toString();


var $7f67a4ee704a4553$exports = {};
$7f67a4ee704a4553$exports = new URL("jobs_applicant_review.f4908f35.svg", import.meta.url).toString();


var $34feaf4b1369b3ac$exports = {};
$34feaf4b1369b3ac$exports = new URL("rating_requests.8b119076.svg", import.meta.url).toString();


var $d25ee7778ec74c63$exports = {};
$d25ee7778ec74c63$exports = new URL("orders_to_confirm.bfa990ed.svg", import.meta.url).toString();


var $69a7970a340a07f3$exports = {};
$69a7970a340a07f3$exports = new URL("pending_payments.aebc2446.svg", import.meta.url).toString();


var $cfd2ff2799038f02$exports = {};
$cfd2ff2799038f02$exports = new URL("referrals.d9e9f189.svg", import.meta.url).toString();


var $960c8ae35dc32a36$exports = {};
$960c8ae35dc32a36$exports = new URL("video_interview.5e6ccd3c.png", import.meta.url).toString();


const $2f63a99ac8c43a0e$export$6c746a5570b8b35c = {
    shiftsAttendanceImg: (/*@__PURE__*/$parcel$interopDefault($44f9a27fa15a1f6c$exports)),
    applicantsReviewImg: (/*@__PURE__*/$parcel$interopDefault($7f67a4ee704a4553$exports)),
    ratingRequestsImg: (/*@__PURE__*/$parcel$interopDefault($34feaf4b1369b3ac$exports)),
    ordersToConfirmImg: (/*@__PURE__*/$parcel$interopDefault($d25ee7778ec74c63$exports)),
    pendingPaymentsImg: (/*@__PURE__*/$parcel$interopDefault($69a7970a340a07f3$exports)),
    referralsImg: (/*@__PURE__*/$parcel$interopDefault($cfd2ff2799038f02$exports)),
    videoInterviewImg: (/*@__PURE__*/$parcel$interopDefault($960c8ae35dc32a36$exports))
};











const $2dc7baffef70b858$export$bac3506438e44f8d = (0, $a4963babae245ff9$export$f0c7a449e0cfaec7)((0, $aca50e9407ba89c9$export$b6ae1bc530f4c149)(()=>{
    const { statistics: statistics, getStatistics: getStatistics } = (0, $4671947198ddd366$export$6ccbb43953eebf8)().data;
    const { isLoading: statisticsLoading } = (0, $4671947198ddd366$export$dd0a697e1782aedd)(getStatistics);
    const redirect = (0, $7df35e9df335b1c8$export$602eaf6d5314ce55)();
    const { t: t } = (0, $3765cebd031b52c0$export$9fc83ad70ead8663)();
    return statisticsLoading ? null : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        className: "Home__cards-container",
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $acw62.Fragment), {
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4ae5ab5371178941$export$f01b3d7c7bbe3997), {
                    allowedRoles: [
                        (0, $97fa7686fb8e51ed$export$eb3485a690c2f0b8).Owner,
                        (0, $97fa7686fb8e51ed$export$eb3485a690c2f0b8).Admin,
                        (0, $97fa7686fb8e51ed$export$eb3485a690c2f0b8).Finance
                    ],
                    showDefaultFallbackUI: false,
                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $75280a546f53cf50$export$60332b2344f7fe41), {
                        amount: statistics?.pending_payments_count ?? 0,
                        backgroundColor: "rgba(234, 111, 126, 0.1)",
                        color: "rgb(234, 111, 126)",
                        image: (0, $2f63a99ac8c43a0e$export$6c746a5570b8b35c).pendingPaymentsImg,
                        title: t("home.pending_payments"),
                        onPress: ()=>{
                            (0, $c74a0566d4b0fd6d$export$e9db7d6e73593439).track((0, $c74a0566d4b0fd6d$export$5e27155e276f6d1c).HomeStatsPendingPaymentsClicked);
                            redirect((0, $0534349ae8731d0b$export$66b32f6f30eb4b4).paymentList, {
                                paymentStatus: String((0, $ace4c335912c9e96$export$999f810846f9d31d).Pending)
                            });
                        }
                    })
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $75280a546f53cf50$export$60332b2344f7fe41), {
                    amount: statistics?.shifts_need_confirm_count ?? 0,
                    backgroundColor: "rgba(252, 179, 92, 0.1)",
                    color: "rgb(252, 179, 92)",
                    image: (0, $2f63a99ac8c43a0e$export$6c746a5570b8b35c).shiftsAttendanceImg,
                    title: t("home.shifts_attendance_review"),
                    onPress: ()=>{
                        (0, $c74a0566d4b0fd6d$export$e9db7d6e73593439).track((0, $c74a0566d4b0fd6d$export$5e27155e276f6d1c).HomeStatsShiftsAttendanceClicked);
                        redirect((0, $0534349ae8731d0b$export$66b32f6f30eb4b4).attendanceShiftsList, {});
                    }
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4ae5ab5371178941$export$f01b3d7c7bbe3997), {
                    allowedRoles: [
                        (0, $97fa7686fb8e51ed$export$eb3485a690c2f0b8).Owner,
                        (0, $97fa7686fb8e51ed$export$eb3485a690c2f0b8).Admin,
                        (0, $97fa7686fb8e51ed$export$eb3485a690c2f0b8).Finance
                    ],
                    showDefaultFallbackUI: false,
                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $75280a546f53cf50$export$60332b2344f7fe41), {
                        amount: statistics?.orders_need_confirm_count ?? 0,
                        backgroundColor: "rgba(71, 117, 245, 0.1)",
                        color: "rgb(71, 117, 245)",
                        image: (0, $2f63a99ac8c43a0e$export$6c746a5570b8b35c).ordersToConfirmImg,
                        title: t("home.orders_to_confirm"),
                        onPress: ()=>{
                            (0, $c74a0566d4b0fd6d$export$e9db7d6e73593439).track((0, $c74a0566d4b0fd6d$export$5e27155e276f6d1c).HomeStatsOrdersToConfirmClicked);
                            redirect((0, $0534349ae8731d0b$export$66b32f6f30eb4b4).orders, {
                                ordersState: (0, $0f571f43d43ce782$export$819724757aafc79).Unconfirmed
                            });
                        }
                    })
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $75280a546f53cf50$export$60332b2344f7fe41), {
                    amount: statistics?.pending_ratings_count ?? 0,
                    backgroundColor: "rgba(70, 78, 95, 0.1)",
                    color: "rgb(70, 78, 95)",
                    image: (0, $2f63a99ac8c43a0e$export$6c746a5570b8b35c).ratingRequestsImg,
                    title: t("home.rating_requests"),
                    onPress: ()=>{
                        (0, $c74a0566d4b0fd6d$export$e9db7d6e73593439).track((0, $c74a0566d4b0fd6d$export$5e27155e276f6d1c).HomeStatsRatingsClicked);
                        redirect((0, $0534349ae8731d0b$export$66b32f6f30eb4b4).jobRatingRequests, {});
                    }
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $75280a546f53cf50$export$60332b2344f7fe41), {
                    amount: statistics?.unfulfilled_jobs_count ?? 0,
                    backgroundColor: "rgba(94, 170, 111, 0.1)",
                    color: "rgb(94, 170, 111)",
                    image: (0, $2f63a99ac8c43a0e$export$6c746a5570b8b35c).applicantsReviewImg,
                    title: t("home.applicant_review"),
                    onPress: ()=>{
                        (0, $c74a0566d4b0fd6d$export$e9db7d6e73593439).track((0, $c74a0566d4b0fd6d$export$5e27155e276f6d1c).HomeStatsApplicantsClicked);
                        redirect((0, $0534349ae8731d0b$export$66b32f6f30eb4b4).applicantsReview, {});
                    }
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                    className: "LastCardSeparator"
                })
            ]
        })
    });
}), {
    [(0, $9ad33fbf770c55a1$export$9696fcf1798e1cb5).ServerError]: "home.error_failed_to_load_statistics"
});






const $87ac06c71d2a40a6$export$23191e4434a9e834 = (0, $aca50e9407ba89c9$export$b6ae1bc530f4c149)(()=>{
    const { profile: profile, getProfile: getProfile } = (0, $4671947198ddd366$export$6ccbb43953eebf8)().data;
    const { isLoading: profileLoading } = (0, $4671947198ddd366$export$dd0a697e1782aedd)(getProfile);
    const { t: t } = (0, $3765cebd031b52c0$export$9fc83ad70ead8663)();
    return profileLoading ? null : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("h1", {
        className: "Home__title",
        children: [
            t("home.hello"),
            ", ",
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                className: "highlighted",
                children: profile?.first_name
            }),
            "\uD83D\uDC4B"
        ]
    });
});





var $acw62 = parcelRequire("acw62");






var $caf3732a030b2ae8$exports = {};
$caf3732a030b2ae8$exports = new URL("modal-image.adac993f.svg", import.meta.url).toString();




const $2c46e9e1f89bee75$export$2b47962e4e24eb4d = ({ text: text, action: action, additionalStyle: additionalStyle, disabled: disabled = false })=>{
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
        className: `Button__primary${disabled ? " Button__primary--disabled" : ""}`,
        onClick: action,
        style: additionalStyle,
        disabled: disabled,
        children: text
    });
};






var $kLorN = parcelRequire("kLorN");
const $3ac90b6d608c1141$export$d3fa8faf524123 = ({ isTermsAndConditionsAccepted: isTermsAndConditionsAccepted, requestConfirmTerms: requestConfirmTerms, apiHost: apiHost })=>{
    const { t: t } = (0, $3765cebd031b52c0$export$9fc83ad70ead8663)();
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "AcceptTerms",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                checked: isTermsAndConditionsAccepted,
                type: "checkbox",
                disabled: isTermsAndConditionsAccepted,
                onChange: requestConfirmTerms
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $e04d9533328ca578$export$8d6a9236f2e3f2ce), {
                    children: [
                        t("common.i_accept"),
                        " ",
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("a", {
                            href: `${apiHost}client/profile/sla?type=html&tc_type=${(0, $kLorN.TERMS_AND_CONDITIONS_TYPE_AFFILIATE_CLIENT)}`,
                            target: "_blank",
                            rel: "noreferrer",
                            children: t("common.terms_of_service")
                        })
                    ]
                }, "common.i_accept_terms")
            })
        ]
    });
};




const $cb09c16bc08d7fbd$export$a011eb31e72a119c = (0, $aca50e9407ba89c9$export$b6ae1bc530f4c149)(({ showBecomeAffiliateModal: showBecomeAffiliateModal, setShowBecomeAffiliateModal: setShowBecomeAffiliateModal, onSuccess: onSuccess })=>{
    const { t: t } = (0, $3765cebd031b52c0$export$9fc83ad70ead8663)();
    const redirect = (0, $7df35e9df335b1c8$export$602eaf6d5314ce55)();
    const [isTermsAndConditionsAccepted, setIsTermsAndConditionsAccepted] = (0, $acw62.useState)(false);
    const { markClientAsAffiliate: markClientAsAffiliate, confirmAffiliateTermsAndConditions: confirmAffiliateTermsAndConditions, apiHost: apiHost } = (0, $4671947198ddd366$export$6ccbb43953eebf8)().data;
    const [, markClientAsAffiliateRequest] = (0, $4671947198ddd366$export$609860bf8b0084c)(markClientAsAffiliate, {
        onSuccess: (result)=>{
            if (onSuccess) onSuccess();
            else redirect((0, $0534349ae8731d0b$export$66b32f6f30eb4b4).affiliateDashboard, {});
        }
    });
    const [, requestConfirmTerms] = (0, $4671947198ddd366$export$609860bf8b0084c)(confirmAffiliateTermsAndConditions, {
        onSuccess: ()=>{
            setIsTermsAndConditionsAccepted(true);
        },
        onError: (err)=>alert(err.data.message),
        filterError: [
            (0, $9ad33fbf770c55a1$export$9696fcf1798e1cb5).ClientError
        ]
    });
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c786671f641538e1$export$446bb0a5366f9068), {
        overlayStyle: {
            overflow: "hidden"
        },
        contentStyle: {
            overflow: "hidden"
        },
        modalVisible: showBecomeAffiliateModal,
        onClose: ()=>setShowBecomeAffiliateModal(false),
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
            className: "BecomeAffiliateModal__content",
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                    className: "BecomeAffiliateModal__content__title",
                    children: t("become_affiliate.modal_title")
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                    className: "BecomeAffiliateModal__content__subtitle",
                    children: t("become_affiliate.modal_subtitle")
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                    className: "BecomeAffiliateModal__content__image",
                    src: (0, (/*@__PURE__*/$parcel$interopDefault($caf3732a030b2ae8$exports)))
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $3ac90b6d608c1141$export$d3fa8faf524123), {
                    isTermsAndConditionsAccepted: isTermsAndConditionsAccepted,
                    requestConfirmTerms: requestConfirmTerms,
                    apiHost: apiHost
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $660b2ca422e0e2ae$export$1ff3c3f08ae963c0).Vertical, {
                    height: 15
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $2c46e9e1f89bee75$export$2b47962e4e24eb4d), {
                    text: t("common.continue"),
                    action: ()=>markClientAsAffiliateRequest({}),
                    additionalStyle: {
                        minWidth: "304px"
                    },
                    disabled: !isTermsAndConditionsAccepted
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $660b2ca422e0e2ae$export$1ff3c3f08ae963c0).Vertical, {
                    height: 15
                })
            ]
        })
    });
});





var $84c25a4525e69df9$exports = {};
$84c25a4525e69df9$exports = new URL("modal-image.05a7a67d.svg", import.meta.url).toString();




const $6c6a436a5a333492$export$80764a139e65d5c0 = ({ showModal: showModal, setShowModal: setShowModal, onContinue: onContinue })=>{
    const { t: t } = (0, $3765cebd031b52c0$export$9fc83ad70ead8663)();
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c786671f641538e1$export$446bb0a5366f9068), {
        overlayStyle: {
            overflow: "hidden"
        },
        contentStyle: {
            overflow: "hidden"
        },
        modalVisible: showModal,
        onClose: ()=>setShowModal(false),
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
            className: "AffiliateTcModal__content",
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                    className: "AffiliateTcModal__content__title",
                    children: t("common.tc")
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                    className: "AffiliateTcModal__content__image",
                    src: (0, (/*@__PURE__*/$parcel$interopDefault($84c25a4525e69df9$exports)))
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                    className: "AffiliateTcModal__content__subtitle",
                    children: t("common_affiliate.tc_1")
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                    className: "AffiliateTcModal__content__subtitle",
                    children: t("common_affiliate.tc_2")
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $2c46e9e1f89bee75$export$2b47962e4e24eb4d), {
                    text: t("common.continue"),
                    action: onContinue,
                    additionalStyle: {
                        minWidth: "304px",
                        marginTop: "12px"
                    }
                })
            ]
        })
    });
};








var $acw62 = parcelRequire("acw62");


var $1b07a87da3e1fef3$exports = {};
$1b07a87da3e1fef3$exports = new URL("ogram-icon.5f9bbec1.svg", import.meta.url).toString();


var $921655d79b67c1e3$exports = {};
$921655d79b67c1e3$exports = new URL("burger.4e4fe775.svg", import.meta.url).toString();


var $a83625552506827e$exports = {};
$a83625552506827e$exports = new URL("phone.9ed0053b.svg", import.meta.url).toString();


var $00d9ef3d9322190a$exports = {};
$00d9ef3d9322190a$exports = new URL("close.d9091ee5.svg", import.meta.url).toString();


const $43e9cf2d4e3db974$export$2ba0965ec1ed2c9e = ({ showBanner: showBanner, closeBanner: closeBanner })=>{
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c786671f641538e1$export$446bb0a5366f9068), {
        overlayStyle: {
            overflow: "hidden"
        },
        contentStyle: {
            overflow: "hidden"
        },
        modalVisible: showBanner,
        onClose: ()=>closeBanner(),
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
            className: "InstallAppBanner",
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                    className: "InstallAppBanner__top",
                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                        src: (0, (/*@__PURE__*/$parcel$interopDefault($00d9ef3d9322190a$exports))),
                        onClick: ()=>closeBanner()
                    })
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: "InstallAppBanner__content",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                            className: "InstallAppBanner__content__logo",
                            src: (0, (/*@__PURE__*/$parcel$interopDefault($1b07a87da3e1fef3$exports)))
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                            className: "InstallAppBanner__content__description",
                            children: [
                                "Add ",
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                    className: "InstallAppBanner__content__description__ogram",
                                    children: "Ogram"
                                }),
                                " app to your screen for easy access, and better experience"
                            ]
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: "InstallAppBanner__content__panelAndroid",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                    className: "InstallAppBanner__content__panelAndroid__tap",
                                    children: "Tap"
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                                    className: "InstallAppBanner__content__panelAndroid__burger",
                                    src: (0, (/*@__PURE__*/$parcel$interopDefault($921655d79b67c1e3$exports)))
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                    className: "InstallAppBanner__content__panelAndroid__then",
                                    children: "then"
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                                    className: "InstallAppBanner__content__panelAndroid__phone",
                                    src: (0, (/*@__PURE__*/$parcel$interopDefault($a83625552506827e$exports)))
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                    className: "InstallAppBanner__content__panelAndroid__add",
                                    children: "Add to Home Screen"
                                })
                            ]
                        })
                    ]
                })
            ]
        })
    });
};





var $1a7d35ec57abdaa3$exports = {};
$1a7d35ec57abdaa3$exports = new URL("ogram-icon.4120f491.svg", import.meta.url).toString();


var $a45eacac69a3930c$exports = {};
$a45eacac69a3930c$exports = new URL("burger.fbf2a308.svg", import.meta.url).toString();


var $6a218e05c4b43a2d$exports = {};
$6a218e05c4b43a2d$exports = new URL("phone.a359c1f0.svg", import.meta.url).toString();



const $b1aec9518cac75a8$export$b73b2ac2260fb33e = ({ showBanner: showBanner, closeBanner: closeBanner })=>{
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c786671f641538e1$export$446bb0a5366f9068), {
        overlayStyle: {
            overflow: "hidden"
        },
        contentStyle: {
            overflow: "hidden"
        },
        modalVisible: showBanner,
        onClose: ()=>closeBanner(),
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
            className: "InstallAppBanner",
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                    className: "InstallAppBanner__top",
                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                        src: (0, (/*@__PURE__*/$parcel$interopDefault($00d9ef3d9322190a$exports))),
                        onClick: ()=>closeBanner()
                    })
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: "InstallAppBanner__content",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                            className: "InstallAppBanner__content__logo",
                            src: (0, (/*@__PURE__*/$parcel$interopDefault($1a7d35ec57abdaa3$exports)))
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                            className: "InstallAppBanner__content__description",
                            children: [
                                "Add ",
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                    className: "InstallAppBanner__content__description__ogram",
                                    children: "Ogram"
                                }),
                                " app to your screen for easy access, and better experience"
                            ]
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: "InstallAppBanner__content__panelIos",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                    className: "InstallAppBanner__content__panelIos__tap",
                                    children: "Tap"
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                                    className: "InstallAppBanner__content__panelIos__burger",
                                    src: (0, (/*@__PURE__*/$parcel$interopDefault($a45eacac69a3930c$exports)))
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                    className: "InstallAppBanner__content__panelIos__then",
                                    children: "then"
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                                    className: "InstallAppBanner__content__panelIos__phone",
                                    src: (0, (/*@__PURE__*/$parcel$interopDefault($6a218e05c4b43a2d$exports)))
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                    className: "InstallAppBanner__content__panelIos__add",
                                    children: "Add to Home Screen"
                                })
                            ]
                        })
                    ]
                })
            ]
        })
    });
};




const $87e457a798e9750e$export$dbdb83eee5e834f1 = ()=>{
    const [showBanner, setShowBanner] = (0, $acw62.useState)(!Boolean((0, $34dcbefa7de5eb80$export$11e63f7b0f3d9900)("installAppBannerWasShown")));
    (0, $acw62.useEffect)(()=>{
        (0, $c74a0566d4b0fd6d$export$e9db7d6e73593439).track((0, $c74a0566d4b0fd6d$export$5e27155e276f6d1c).ViewedInstallProgressiveAppBanner);
    }, []);
    // @ts-ignore
    const isIos = /ipad|iphone|ipod/.test(navigator.userAgent.toLowerCase()) && !window.MSStream;
    // @ts-ignore
    const isAndroid = /android/.test(navigator.userAgent.toLowerCase()) && !window.MSStream;
    const closeBanner = ()=>{
        (0, $34dcbefa7de5eb80$export$a1544dad697b423d)("installAppBannerWasShown", true);
        setShowBanner(false);
    };
    if (!showBanner) return null;
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
        children: [
            isAndroid && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $43e9cf2d4e3db974$export$2ba0965ec1ed2c9e), {
                showBanner: showBanner,
                closeBanner: closeBanner
            }),
            isIos && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b1aec9518cac75a8$export$b73b2ac2260fb33e), {
                showBanner: showBanner,
                closeBanner: closeBanner
            })
        ]
    });
};


const $beb02b4d16eaba7f$export$b94310965bed44e6 = (0, $aca50e9407ba89c9$export$b6ae1bc530f4c149)(({ hideLogo: hideLogo })=>{
    const [showBecomeAffiliateModal, setShowBecomeAffiliateModal] = (0, $acw62.useState)(false);
    const [showAffiliateTcModal, setShowAffiliateTcModal] = (0, $acw62.useState)(false);
    const redirect = (0, $7df35e9df335b1c8$export$602eaf6d5314ce55)();
    const { logged: logged, markClientAsAffiliate: markClientAsAffiliate } = (0, $4671947198ddd366$export$6ccbb43953eebf8)().data;
    const [, markClientAsAffiliateRequest] = (0, $4671947198ddd366$export$609860bf8b0084c)(markClientAsAffiliate, {
        onSuccess: ()=>{
            redirect((0, $0534349ae8731d0b$export$66b32f6f30eb4b4).affiliateDashboard, {});
        }
    });
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "Home",
        children: [
            logged && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $87e457a798e9750e$export$dbdb83eee5e834f1), {}),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7ae42b63183f30b4$export$8b251419efc915eb), {
                hideLogo: hideLogo
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $660b2ca422e0e2ae$export$1ff3c3f08ae963c0).Vertical, {
                height: 40
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $87ac06c71d2a40a6$export$23191e4434a9e834), {}),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $660b2ca422e0e2ae$export$1ff3c3f08ae963c0).Vertical, {
                height: 23
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $24db3b11bdd0fa3c$export$4417311e0c30ffed), {
                openBecomeAffiliateModal: ()=>setShowBecomeAffiliateModal(true)
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $660b2ca422e0e2ae$export$1ff3c3f08ae963c0).Vertical, {
                height: 37
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $2dc7baffef70b858$export$bac3506438e44f8d), {}),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $660b2ca422e0e2ae$export$1ff3c3f08ae963c0).Vertical, {
                height: 200
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $cb09c16bc08d7fbd$export$a011eb31e72a119c), {
                showBecomeAffiliateModal: showBecomeAffiliateModal,
                setShowBecomeAffiliateModal: setShowBecomeAffiliateModal
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $6c6a436a5a333492$export$80764a139e65d5c0), {
                onContinue: ()=>{
                    setShowBecomeAffiliateModal(false);
                    setShowAffiliateTcModal(false);
                    markClientAsAffiliateRequest({});
                },
                showModal: showAffiliateTcModal,
                setShowModal: setShowAffiliateTcModal
            })
        ]
    });
});




var $acw62 = parcelRequire("acw62");



var $acw62 = parcelRequire("acw62");







var $acw62 = parcelRequire("acw62");


var $acw62 = parcelRequire("acw62");




const $4a1895475c466679$export$c072955bb62eb0e2 = ({ children: children, style: style, contentStyle: contentStyle, onClick: onClick })=>{
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("section", {
        className: "StickyPanel",
        style: style,
        onClick: onClick,
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
            className: "StickyPanel__content",
            style: contentStyle,
            children: children
        })
    });
};


const $b3926a89bab8b1bc$export$7dfaa78f18820bbf = ({ amount: amount, action: action, actionTitle: actionTitle })=>{
    const { t: t } = (0, $3765cebd031b52c0$export$9fc83ad70ead8663)();
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4a1895475c466679$export$c072955bb62eb0e2), {
        contentStyle: {
            justifyContent: "space-between"
        },
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $acw62.Fragment), {
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: "StickPayButton__description",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                            className: "StickPayButton__description__title",
                            children: t("payment.overdue_balance")
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                            className: "StickPayButton__description__amount",
                            children: amount
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                    className: "StickPayButton__button",
                    onClick: action,
                    children: actionTitle
                })
            ]
        })
    });
};







const $6e30bb218e0b3a5d$var$errorTypesToCatch = [
    (0, $9ad33fbf770c55a1$export$9696fcf1798e1cb5).ServerError,
    (0, $9ad33fbf770c55a1$export$9696fcf1798e1cb5).ConnectionError,
    (0, $9ad33fbf770c55a1$export$9696fcf1798e1cb5).ClientError,
    (0, $9ad33fbf770c55a1$export$9696fcf1798e1cb5).TooManyRequestsError,
    (0, $9ad33fbf770c55a1$export$9696fcf1798e1cb5).PermissionError
];
const $6e30bb218e0b3a5d$export$3bc03f6691d38c16 = (0, $a4963babae245ff9$export$f0c7a449e0cfaec7)(({ overdue: overdue })=>{
    const { t: t } = (0, $3765cebd031b52c0$export$9fc83ad70ead8663)();
    const redirect = (0, $7df35e9df335b1c8$export$602eaf6d5314ce55)();
    (0, $acw62.useEffect)(()=>{
        (0, $c74a0566d4b0fd6d$export$e9db7d6e73593439).track((0, $c74a0566d4b0fd6d$export$5e27155e276f6d1c).StickyPanelPendingPaymentsShown);
    }, []);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("section", {
        style: {
            position: "absolute",
            zIndex: 99
        },
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b3926a89bab8b1bc$export$7dfaa78f18820bbf), {
            amount: `${overdue.currency_code} ${overdue.amount}`,
            action: ()=>{
                (0, $c74a0566d4b0fd6d$export$e9db7d6e73593439).track((0, $c74a0566d4b0fd6d$export$5e27155e276f6d1c).StickyPanelPendingPaymentsClicked);
                if (overdue.pending_payments_count === 1) {
                    redirect((0, $0534349ae8731d0b$export$66b32f6f30eb4b4).paymentDetails, {
                        paymentId: String(overdue.payment_id)
                    });
                    return;
                }
                redirect((0, $0534349ae8731d0b$export$66b32f6f30eb4b4).paymentList, {
                    paymentStatus: String((0, $ace4c335912c9e96$export$999f810846f9d31d).Pending)
                });
            },
            actionTitle: overdue.pending_payments_count === 1 ? t("payment.pay_now") : t("payment.go_to_payments_list_page")
        })
    });
}, null, null, $6e30bb218e0b3a5d$var$errorTypesToCatch, true);







var $acw62 = parcelRequire("acw62");





var $acw62 = parcelRequire("acw62");


const $59ebd31b84062ce0$export$462d33da641971a3 = ({ actionTitle: actionTitle, actionSubtitle: actionSubtitle, action: action, buttonTitle: buttonTitle, buttonStyle: buttonStyle })=>{
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4a1895475c466679$export$c072955bb62eb0e2), {
        contentStyle: {
            justifyContent: "space-between"
        },
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $acw62.Fragment), {
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: "StickPayButton__description",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                            className: "StickPayButton__description__title",
                            children: actionTitle
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                            className: "StickPayButton__description__amount",
                            children: actionSubtitle
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                    className: "StickPayButton__button",
                    onClick: action,
                    style: buttonStyle,
                    children: buttonTitle
                })
            ]
        })
    });
};




const $ad4b8cf07c860b8a$var$errorTypesToCatch = [
    (0, $9ad33fbf770c55a1$export$9696fcf1798e1cb5).ServerError,
    (0, $9ad33fbf770c55a1$export$9696fcf1798e1cb5).ConnectionError,
    (0, $9ad33fbf770c55a1$export$9696fcf1798e1cb5).ClientError,
    (0, $9ad33fbf770c55a1$export$9696fcf1798e1cb5).TooManyRequestsError,
    (0, $9ad33fbf770c55a1$export$9696fcf1798e1cb5).PermissionError
];
const $ad4b8cf07c860b8a$export$a981fd1e0d56eaa0 = (0, $a4963babae245ff9$export$f0c7a449e0cfaec7)((0, $aca50e9407ba89c9$export$b6ae1bc530f4c149)(({ ordersNeedConfirmCount: ordersNeedConfirmCount })=>{
    const redirect = (0, $7df35e9df335b1c8$export$602eaf6d5314ce55)();
    const { t: t } = (0, $3765cebd031b52c0$export$9fc83ad70ead8663)();
    (0, $acw62.useEffect)(()=>{
        (0, $c74a0566d4b0fd6d$export$e9db7d6e73593439).track((0, $c74a0566d4b0fd6d$export$5e27155e276f6d1c).StickyPanelPendingOrdersShown);
    }, []);
    const action = ()=>{
        redirect((0, $0534349ae8731d0b$export$66b32f6f30eb4b4).orders, {
            ordersState: (0, $0f571f43d43ce782$export$819724757aafc79).Unconfirmed
        });
        return;
    };
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("section", {
        style: {
            position: "absolute",
            zIndex: 99
        },
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $59ebd31b84062ce0$export$462d33da641971a3), {
            actionTitle: t("pending_orders_panel.pending_confirmation"),
            actionSubtitle: t("pending_orders_panel.n_orders", {
                count: ordersNeedConfirmCount
            }),
            action: ()=>{
                action();
                (0, $c74a0566d4b0fd6d$export$e9db7d6e73593439).track((0, $c74a0566d4b0fd6d$export$5e27155e276f6d1c).StickyPanelPendingOrdersClicked);
            },
            buttonTitle: t("pending_orders_panel.confirm_now")
        })
    });
}), null, null, $ad4b8cf07c860b8a$var$errorTypesToCatch, true);





var $acw62 = parcelRequire("acw62");





const $10450749d31b580c$export$5b7fa48babe205ae = (0, $a4963babae245ff9$export$f0c7a449e0cfaec7)(({ shifts: shifts })=>{
    const redirect = (0, $7df35e9df335b1c8$export$602eaf6d5314ce55)();
    const { t: t } = (0, $3765cebd031b52c0$export$9fc83ad70ead8663)();
    (0, $acw62.useEffect)(()=>{
        (0, $c74a0566d4b0fd6d$export$e9db7d6e73593439).track((0, $c74a0566d4b0fd6d$export$5e27155e276f6d1c).StickyPanelPendingAttendanceShown);
    }, []);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("section", {
        style: {
            position: "absolute",
            zIndex: 99
        },
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $59ebd31b84062ce0$export$462d33da641971a3), {
            actionTitle: t("shifts_attendance_list.title"),
            actionSubtitle: t("order.order_number", {
                id: shifts[0].order_id
            }),
            action: ()=>{
                (0, $c74a0566d4b0fd6d$export$e9db7d6e73593439).track((0, $c74a0566d4b0fd6d$export$5e27155e276f6d1c).StickyPanelPendingAttendanceClicked);
                redirect((0, $0534349ae8731d0b$export$66b32f6f30eb4b4).attendanceShiftsList, {});
            },
            buttonTitle: t("shifts_attendance_list.review_now"),
            buttonStyle: {
                background: "#FCB35C"
            }
        })
    });
});





var $acw62 = parcelRequire("acw62");





const $6fbd4ba3d14552a8$export$19267ec389772ed8 = (0, $a4963babae245ff9$export$f0c7a449e0cfaec7)(({ raisedDisputesCount: raisedDisputesCount })=>{
    const redirect = (0, $7df35e9df335b1c8$export$602eaf6d5314ce55)();
    const { t: t } = (0, $3765cebd031b52c0$export$9fc83ad70ead8663)();
    (0, $acw62.useEffect)(()=>{
        (0, $c74a0566d4b0fd6d$export$e9db7d6e73593439).track((0, $c74a0566d4b0fd6d$export$5e27155e276f6d1c).StickyPanelRaisedDisputesShown);
    }, []);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("section", {
        style: {
            position: "absolute",
            zIndex: 99
        },
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $59ebd31b84062ce0$export$462d33da641971a3), {
            actionTitle: t("raised_disputes_panel.title"),
            actionSubtitle: t("raised_disputes_panel.n_disputes", {
                count: raisedDisputesCount
            }),
            action: ()=>{
                (0, $c74a0566d4b0fd6d$export$e9db7d6e73593439).track((0, $c74a0566d4b0fd6d$export$5e27155e276f6d1c).StickyPanelRaisedDisputesClicked);
                redirect((0, $0534349ae8731d0b$export$66b32f6f30eb4b4).disputes, {});
            },
            buttonTitle: t("raised_disputes_panel.review_now"),
            buttonStyle: {
                background: "#D92D20"
            }
        })
    });
});




const $9727507ce5e8bf21$var$userRolesToShowPaymentPanel = [
    Number((0, $97fa7686fb8e51ed$export$eb3485a690c2f0b8).Owner),
    Number((0, $97fa7686fb8e51ed$export$eb3485a690c2f0b8).Admin),
    Number((0, $97fa7686fb8e51ed$export$eb3485a690c2f0b8).Finance)
];
const $9727507ce5e8bf21$var$userRolesToShowDisputesPanel = [
    Number((0, $97fa7686fb8e51ed$export$eb3485a690c2f0b8).Owner),
    Number((0, $97fa7686fb8e51ed$export$eb3485a690c2f0b8).Admin),
    Number((0, $97fa7686fb8e51ed$export$eb3485a690c2f0b8).Manager)
];
const $9727507ce5e8bf21$export$1facaeb58ab65ca = (0, $a4963babae245ff9$export$f0c7a449e0cfaec7)((0, $aca50e9407ba89c9$export$b6ae1bc530f4c149)(()=>{
    const { setShowHelpButton: setShowHelpButton } = (0, $acw62.useContext)((0, $392d2c14aa582458$export$9e7c8e903bb56df9));
    const { account: account, getProfile: getProfile, profile: profile, overdue: overdue, getOverdue: getOverdue, logged: logged, statistics: statistics, getStatistics: getStatistics, fetchAttendanceReportJob: fetchAttendanceReportJob, attendanceReportJobView: attendanceReportJobView } = (0, $4671947198ddd366$export$6ccbb43953eebf8)().data;
    (0, $4671947198ddd366$export$dd0a697e1782aedd)(getProfile);
    (0, $4671947198ddd366$export$dd0a697e1782aedd)(getStatistics);
    (0, $4671947198ddd366$export$dd0a697e1782aedd)(()=>fetchAttendanceReportJob({}));
    const { enableQuery: getOverdueQuery } = (0, $4671947198ddd366$export$517ca4f7fee4e226)(getOverdue);
    (0, $acw62.useEffect)(()=>{
        if (Boolean(profile)) {
            const isAllowedToSeePaymentPanel = profile?.roles.reduce((allowed, role)=>{
                return $9727507ce5e8bf21$var$userRolesToShowPaymentPanel.includes(role) ? true : allowed;
            }, false);
            if (isAllowedToSeePaymentPanel) getOverdueQuery();
        }
    }, [
        profile
    ]);
    const userRoles = account?.roles ?? [];
    const isAllowedToSeeDisputesPanel = userRoles.length === 0 || userRoles.some((role)=>$9727507ce5e8bf21$var$userRolesToShowDisputesPanel.includes(role));
    const raisedDisputesCount = Number(statistics?.raised_disputes_count);
    const showRaisedDisputesPanel = logged && isAllowedToSeeDisputesPanel && raisedDisputesCount > 0;
    const isPaymentsEnabled = (0, $2994e7b5ba509fe3$export$f506dd16e02779a7)();
    const showPaymentPanel = logged && isPaymentsEnabled() && overdue && overdue.pending_payments_count;
    const ordersNeedConfirmCount = Number(statistics?.orders_need_confirm_count);
    const showOrderConfirmPanel = logged && ordersNeedConfirmCount > 0;
    const shifts = attendanceReportJobView();
    const showAttendanceReviewPanel = logged && shifts.length > 0;
    (0, $acw62.useEffect)(()=>{
        setShowHelpButton(!showRaisedDisputesPanel && !showPaymentPanel && !showOrderConfirmPanel && !showAttendanceReviewPanel);
    }, [
        showRaisedDisputesPanel,
        showPaymentPanel,
        showOrderConfirmPanel,
        showAttendanceReviewPanel
    ]);
    if (showRaisedDisputesPanel) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $6fbd4ba3d14552a8$export$19267ec389772ed8), {
        raisedDisputesCount: raisedDisputesCount
    });
    if (showPaymentPanel) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $6e30bb218e0b3a5d$export$3bc03f6691d38c16), {
        overdue: overdue
    });
    if (showOrderConfirmPanel) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ad4b8cf07c860b8a$export$a981fd1e0d56eaa0), {
        ordersNeedConfirmCount: ordersNeedConfirmCount
    });
    if (showAttendanceReviewPanel) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $10450749d31b580c$export$5b7fa48babe205ae), {
        shifts: shifts
    });
    return null;
}));


function $117941c7d0c20f79$export$c722bd9b00544782(Component) {
    return function BottomPanelWrapper(props) {
        return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $acw62.Fragment), {
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)(Component, {
                    ...props
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $9727507ce5e8bf21$export$1facaeb58ab65ca), {})
            ]
        });
    };
}


const $27a686021bcba3a9$export$9fee8767af850feb = {
    HomePage: (0, $117941c7d0c20f79$export$c722bd9b00544782)((0, $beb02b4d16eaba7f$export$b94310965bed44e6))
};




var $acw62 = parcelRequire("acw62");

var $45fvw = parcelRequire("45fvw");












const $a9d8c7b2777a204d$var$getWelcomeText = (pendingConfirmation, pendingRates, corporateDetailsVerificationStatus, corporateDetailsRequired)=>{
    if (corporateDetailsRequired && corporateDetailsVerificationStatus === (0, $85250b9063617b2f$export$a595236b0bffe864)) return "order.need_to_review_corporate_details";
    if (corporateDetailsRequired && corporateDetailsVerificationStatus === (0, $85250b9063617b2f$export$72098cb19cc2b31c)) return "order.corporate_details_are_being_reviewed";
    if (pendingRates) return "order.pending_rates_review";
    if (pendingConfirmation) return "order.confirm_order";
    return "order.suggest_extension";
};
const $a9d8c7b2777a204d$var$OrderSummaryWelcome = ({ pendingConfirmation: pendingConfirmation, pendingRates: pendingRates, corporateDetailsVerificationStatus: corporateDetailsVerificationStatus, openOrderExtensionPopup: openOrderExtensionPopup })=>{
    const { t: t } = (0, $3765cebd031b52c0$export$9fc83ad70ead8663)();
    const isCorporateDetailsRequiredAndNotFilled = (0, $73ccb33f5de6f5aa$export$8707029d024490c9)().registration.allowOnlyCorporate && corporateDetailsVerificationStatus === (0, $85250b9063617b2f$export$a595236b0bffe864);
    const showExtensionOption = !pendingConfirmation && !pendingRates;
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "OrderSummaryWelcome orange",
        children: [
            showExtensionOption && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h1", {
                children: t("order.extend_your_order")
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                children: t($a9d8c7b2777a204d$var$getWelcomeText(pendingConfirmation, pendingRates, corporateDetailsVerificationStatus, (0, $73ccb33f5de6f5aa$export$8707029d024490c9)().registration.allowOnlyCorporate))
            }),
            isCorporateDetailsRequiredAndNotFilled && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7df35e9df335b1c8$export$a6c7ac8248d6e38a), {
                route: (0, $0534349ae8731d0b$export$66b32f6f30eb4b4).completeRegistration,
                params: {},
                className: "OrderSummaryWelcome__completeRegistrationLink",
                children: t("order.complete_company_details_link")
            }),
            showExtensionOption && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                onClick: openOrderExtensionPopup,
                className: "OrderSummaryWelcome__completeRegistrationLink",
                children: t("order_extension.extend_order")
            })
        ]
    });
};
var $a9d8c7b2777a204d$export$2e2bcd8739ae039 = $a9d8c7b2777a204d$var$OrderSummaryWelcome;


var $2c242e74e2590f15$exports = {};
$2c242e74e2590f15$exports = new URL("file-icon.2cbf2b1a.svg", import.meta.url).toString();


var $0d100698f4ff6bc8$exports = {};
$0d100698f4ff6bc8$exports = new URL("invite-user-icon.95e475c0.svg", import.meta.url).toString();


var $5e254c5a797c259d$exports = {};
$5e254c5a797c259d$exports = new URL("cost-icon.528be0ed.svg", import.meta.url).toString();




const $ec2248901324e8a8$var$SectionTitle = ({ image: image, title: title })=>{
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "SectionTitle",
        children: [
            image && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                src: image
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h3", {
                children: title
            })
        ]
    });
};
var $ec2248901324e8a8$export$2e2bcd8739ae039 = $ec2248901324e8a8$var$SectionTitle;








const $4a112c2694b1fd4a$var$OrderSummaryCard = ({ orderId: orderId, showAmend: showAmend, location: location, startDate: startDate, endDate: endDate, paymentTerms: paymentTerms, showCompleteDetails: showCompleteDetails, isExtension: isExtension = false })=>{
    const { t: t } = (0, $3765cebd031b52c0$export$9fc83ad70ead8663)();
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "OrderSummaryCard",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "OrderSummaryCard__column",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: `OrderSummaryCard__row ${showCompleteDetails ? "withWidget" : ""}`,
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                className: "OrderSummaryCard__label",
                                children: [
                                    t("order.payment_terms"),
                                    " "
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $660b2ca422e0e2ae$export$1ff3c3f08ae963c0).Spacer, {
                                minWidth: 20
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                className: "OrderSummaryCard__data",
                                children: [
                                    paymentTerms ? `${paymentTerms} Day` : "Upfront",
                                    " "
                                ]
                            })
                        ]
                    }),
                    showCompleteDetails && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "OrderSummaryCard__column__completeCompanyDetails",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                className: "OrderSummaryCard__column__completeCompanyDetails__description",
                                children: t("order.complete_company_details")
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7df35e9df335b1c8$export$a6c7ac8248d6e38a), {
                                route: (0, $0534349ae8731d0b$export$66b32f6f30eb4b4).completeCompanyDetailsForPaymentTerms,
                                params: {
                                    orderId: orderId,
                                    showAmend: String(showAmend)
                                },
                                className: "OrderSummaryCard__column__completeCompanyDetails__link",
                                children: t("order.change_terms")
                            })
                        ]
                    })
                ]
            }),
            location !== undefined && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "OrderSummaryCard__row",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                        className: "OrderSummaryCard__label",
                        children: [
                            t("order.location"),
                            " "
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $660b2ca422e0e2ae$export$1ff3c3f08ae963c0).Spacer, {
                        minWidth: 20
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                        className: "OrderSummaryCard__data",
                        children: location
                    })
                ]
            }),
            startDate && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "OrderSummaryCard__row",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                        className: "OrderSummaryCard__label",
                        children: [
                            t("order.start_date"),
                            " "
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $660b2ca422e0e2ae$export$1ff3c3f08ae963c0).Spacer, {
                        minWidth: 20
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                        className: "OrderSummaryCard__data",
                        children: startDate.format("DD MMM YYYY")
                    })
                ]
            }),
            endDate && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "OrderSummaryCard__row",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                        className: "OrderSummaryCard__label",
                        children: [
                            t("order.end_date"),
                            " ",
                            isExtension && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                className: "OrderSummaryCard__data__label",
                                children: [
                                    "[",
                                    t("order_draft.updated"),
                                    "]"
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $660b2ca422e0e2ae$export$1ff3c3f08ae963c0).Spacer, {
                        minWidth: 20
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                        className: "OrderSummaryCard__data",
                        children: endDate.format("DD MMM YYYY")
                    })
                ]
            })
        ]
    });
};
var $4a112c2694b1fd4a$export$2e2bcd8739ae039 = $4a112c2694b1fd4a$var$OrderSummaryCard;





var $acw62 = parcelRequire("acw62");
var $698881d75a318034$exports = {};
$698881d75a318034$exports = new URL("exclamination-circle-icon.95d50aef.svg", import.meta.url).toString();




var $45fvw = parcelRequire("45fvw");



const $61076bfc19b3ff31$var$Spacer = ({ space: space })=>{
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        style: {
            marginTop: space
        }
    });
};
var $61076bfc19b3ff31$export$2e2bcd8739ae039 = $61076bfc19b3ff31$var$Spacer;


var $58d2ff1cd1bbb5be$exports = {};
$58d2ff1cd1bbb5be$exports = new URL("drag-icon.c8d2e6f3.svg", import.meta.url).toString();



const $ac9246dc7e4258f8$var$OrderSummaryShiftsModal = ({ modalIsOpen: modalIsOpen, closeModal: closeModal, start_date: start_date, end_date: end_date, shifts: shifts, work_category_name: work_category_name })=>{
    const { t: t } = (0, $3765cebd031b52c0$export$9fc83ad70ead8663)();
    const sortedShifts = shifts.slice().sort((a, b)=>a.start_time - b.start_time);
    const countOfShifts = end_date.diff(start_date, "d");
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $c786671f641538e1$export$446bb0a5366f9068), {
        modalVisible: modalIsOpen,
        className: "OrderSummaryShiftsModal",
        onClose: closeModal,
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("h2", {
                className: "OrderSummaryShiftsModal__modalTitle",
                children: [
                    work_category_name,
                    " Schedule"
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("h5", {
                className: "OrderSummaryShiftsModal__subTitle",
                children: [
                    start_date.format("ddd, MMM DD"),
                    " - ",
                    end_date.format("ddd, MMM DD"),
                    " ",
                    t("order.order_summary_days_count", {
                        count: countOfShifts + 1
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $61076bfc19b3ff31$export$2e2bcd8739ae039), {
                space: 26
            }),
            sortedShifts.map((shift, i)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: "OrderSummaryShiftsModal__shifts",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                            className: "OrderSummaryShiftsModal__day",
                            children: (0, (/*@__PURE__*/$parcel$interopDefault($45fvw)))(shift.start_time * 1000).format("ddd,DD MMM")
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                            className: "OrderSummaryShiftsModal__time",
                            children: [
                                (0, (/*@__PURE__*/$parcel$interopDefault($45fvw)))(shift.start_time * 1000).format("hh:mm A"),
                                " - ",
                                (0, (/*@__PURE__*/$parcel$interopDefault($45fvw)))(shift.end_time * 1000).format("hh:mm A")
                            ]
                        })
                    ]
                }, i)),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $61076bfc19b3ff31$export$2e2bcd8739ae039), {
                space: 30
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                className: "OrderSummaryShiftsModal__dragIcon",
                src: (0, (/*@__PURE__*/$parcel$interopDefault($58d2ff1cd1bbb5be$exports)))
            })
        ]
    });
};
var $ac9246dc7e4258f8$export$2e2bcd8739ae039 = $ac9246dc7e4258f8$var$OrderSummaryShiftsModal;







var $940db1236f8252d1$exports = {};
$940db1236f8252d1$exports = new URL("rating-star.891ee144.svg", import.meta.url).toString();


var $bd469af94eb4ff30$exports = {};
$bd469af94eb4ff30$exports = new URL("rating-empty-star.9b77f1b0.svg", import.meta.url).toString();



const $647b8b1a309a1295$var$Rating = ({ rating: rating, editable: editable = false, size: size, filledIcon: filledIcon, emptyIcon: emptyIcon, onRatingChange: onRatingChange, starsGap: starsGap })=>{
    const ratingRounded = Math.round(rating);
    const onChange = (newRating)=>{
        if (editable) onRatingChange?.(newRating);
    };
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: `Rating ${editable ? "Rating_editable" : ""}`,
        children: [
            Array.from(Array(ratingRounded)).map((_, i)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                    style: {
                        width: size,
                        ...starsGap ? {
                            marginInlineEnd: starsGap
                        } : {}
                    },
                    onClick: ()=>onChange(i + 1),
                    src: filledIcon ?? (0, (/*@__PURE__*/$parcel$interopDefault($940db1236f8252d1$exports)))
                }, i)),
            Array.from(Array(5 - ratingRounded)).map((_, i)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                    style: {
                        width: size,
                        ...starsGap ? {
                            marginInlineEnd: starsGap
                        } : {}
                    },
                    onClick: ()=>onChange(i + 1 + rating),
                    src: emptyIcon ?? (0, (/*@__PURE__*/$parcel$interopDefault($bd469af94eb4ff30$exports)))
                }, i))
        ]
    });
};
var $647b8b1a309a1295$export$2e2bcd8739ae039 = $647b8b1a309a1295$var$Rating;



var $ddac5ff0025664ad$exports = {};
$ddac5ff0025664ad$exports = new URL("checkmark.4b813873.svg", import.meta.url).toString();


var $7067695799b1b421$exports = {};
$7067695799b1b421$exports = new URL("disabled.6b2ed836.svg", import.meta.url).toString();



const $f224f10e61e1d993$export$48513f6b9f8ce62d = ({ isActive: isActive, onChange: onChange, type: type = "square", disabled: disabled })=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        onClick: ()=>{
            onChange?.();
        },
        className: `Checkbox ${type === "square" ? "square" : "circle"} ${isActive ? "active" : ""}`,
        children: !disabled ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7b02d682eb115277$exports.Fragment), {
            children: isActive && (type === "square" ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                src: (0, (/*@__PURE__*/$parcel$interopDefault($ddac5ff0025664ad$exports))),
                className: "Checkbox__image"
            }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "Checkbox__centerCircle"
            }))
        }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7b02d682eb115277$exports.Fragment), {
            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                src: (0, (/*@__PURE__*/$parcel$interopDefault($7067695799b1b421$exports)))
            })
        })
    });



var $baf20d0c535f1edd$exports = {};
$baf20d0c535f1edd$exports = new URL("heart.31f0c813.svg", import.meta.url).toString();



const $487c9a2e5b754624$export$7e23a963ec4768e3 = (0, $aca50e9407ba89c9$export$b6ae1bc530f4c149)(({ disabled: disabled, withCheckbox: withCheckbox, onClick: onClick, sp: sp, selected: selected, showDesignation: showDesignation, jobDesignation: jobDesignation, jobLocation: jobLocation, showRatingNote: showRatingNote, showFavoriteIcon: showFavoriteIcon = true, ratingStarsSize: ratingStarsSize = 20, ratingEditable: ratingEditable = false, changeRating: changeRating })=>{
    const { t: t } = (0, $3765cebd031b52c0$export$9fc83ad70ead8663)();
    const designation = jobDesignation ? sp.designations.find((name)=>name === jobDesignation) ?? sp.designations[0] : sp.designations[0];
    const workedAtJobLocation = jobLocation ? sp.locations.includes(jobLocation) : false;
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        onClick: onClick,
        className: `InvitedSP${!disabled ? "" : " InvitedSP--disabled"}`,
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "InvitedSP__body",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                        className: "InvitedSP__body__image",
                        src: String(sp.image_url)
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "InvitedSP__content",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "InvitedSP__titleContainer",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                        className: "InvitedSP__title",
                                        children: sp.name
                                    }),
                                    showFavoriteIcon && sp.is_favorite && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                                        src: (0, (/*@__PURE__*/$parcel$interopDefault($baf20d0c535f1edd$exports)))
                                    })
                                ]
                            }),
                            showDesignation ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                className: "InvitedSP__subtitle",
                                children: [
                                    designation,
                                    workedAtJobLocation && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("strong", {
                                        children: [
                                            " - ",
                                            t("invited_sps.worked_at_current_location")
                                        ]
                                    })
                                ]
                            }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $660b2ca422e0e2ae$export$1ff3c3f08ae963c0).Vertical, {
                                height: 10
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $647b8b1a309a1295$export$2e2bcd8739ae039), {
                                rating: Number(sp.client_rating_for_last_job),
                                size: ratingStarsSize ?? 20,
                                editable: Boolean(ratingEditable),
                                onRatingChange: changeRating
                            }),
                            showRatingNote && sp.client_rating_for_last_job !== null && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                className: `InvitedSP__ratingNote${sp.client_rating_for_last_job > 3 ? " InvitedSP__ratingNote--positive" : " InvitedSP__ratingNote--negative"}`,
                                children: sp.client_rating_for_last_job > 3 ? t("rating_popup.will_be_prioritized") : t("rating_popup.will_not_be_assigned")
                            })
                        ]
                    })
                ]
            }),
            withCheckbox && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f224f10e61e1d993$export$48513f6b9f8ce62d), {
                isActive: selected,
                type: "square",
                disabled: disabled
            }),
            sp.is_available === false && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                className: "InvitedSP__status",
                children: t("common.not_available")
            })
        ]
    }, sp.id);
});




const $d65ef9483570d398$var$OrderSummaryJobsCard = ({ work_category_name: work_category_name, start_date: start_date, end_date: end_date, hours: hours, hourly_rate: hourly_rate, transportation_costs: transportation_costs, quantity: quantity, currency: currency, shifts: shifts, underReview: underReview, showRate: showRate = true, showTransportations: showTransportations = true, invitedSPs: invitedSPs })=>{
    const [shiftsModalIsOpen, setShiftsModalIsOpen] = (0, $acw62.useState)(false);
    const shiftHoursPerDay = hours / shifts.length / quantity;
    const shiftHoursPerDayLabel = Number.isInteger(shiftHoursPerDay) ? String(shiftHoursPerDay) : shiftHoursPerDay.toFixed(2);
    const openShiftsModal = ()=>setShiftsModalIsOpen(true);
    const { t: t } = (0, $3765cebd031b52c0$export$9fc83ad70ead8663)();
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "OrderSummaryJobsCard",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "OrderSummaryJobsCard__name",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h3", {
                        children: work_category_name
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                        children: [
                            "(",
                            quantity,
                            ")"
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "OrderSummaryJobsCard__row",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                        className: "OrderSummaryJobsCard__label",
                        children: t("order.dates")
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                        className: "OrderSummaryJobsCard__data",
                        children: [
                            start_date.format("MMM DD"),
                            " - ",
                            end_date.format("MMM DD"),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                children: t("order.days_count", {
                                    count: shifts.length
                                })
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                                src: (0, (/*@__PURE__*/$parcel$interopDefault($698881d75a318034$exports))),
                                onClick: openShiftsModal
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "OrderSummaryJobsCard__row",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                        className: "OrderSummaryJobsCard__label",
                        children: t("order.hours")
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                        className: "OrderSummaryJobsCard__data",
                        children: [
                            t("order.hours_amount", {
                                hours: hours
                            }),
                            " ",
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                children: t("order.hours_per_day", {
                                    hoursPerDay: shiftHoursPerDayLabel
                                })
                            })
                        ]
                    })
                ]
            }),
            Boolean(showRate) && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4ae5ab5371178941$export$f01b3d7c7bbe3997), {
                allowedRoles: [
                    (0, $97fa7686fb8e51ed$export$eb3485a690c2f0b8).Owner,
                    (0, $97fa7686fb8e51ed$export$eb3485a690c2f0b8).Admin,
                    (0, $97fa7686fb8e51ed$export$eb3485a690c2f0b8).Finance
                ],
                showDefaultFallbackUI: false,
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: "OrderSummaryJobsCard__row",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                            className: "OrderSummaryJobsCard__label",
                            children: t("order.rate")
                        }),
                        underReview ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                            className: "OrderSummaryJobsCard__reviewContainer",
                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                className: "OrderSummaryJobsCard__reviewContainer__label",
                                children: t("order.under_review")
                            })
                        }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                            className: "OrderSummaryJobsCard__data",
                            children: t("order.hour_rate", {
                                currency: currency,
                                hourRate: hourly_rate
                            })
                        })
                    ]
                })
            }),
            Boolean(showTransportations) && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4ae5ab5371178941$export$f01b3d7c7bbe3997), {
                allowedRoles: [
                    (0, $97fa7686fb8e51ed$export$eb3485a690c2f0b8).Owner,
                    (0, $97fa7686fb8e51ed$export$eb3485a690c2f0b8).Admin,
                    (0, $97fa7686fb8e51ed$export$eb3485a690c2f0b8).Finance
                ],
                showDefaultFallbackUI: false,
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: "OrderSummaryJobsCard__row",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                            className: "OrderSummaryJobsCard__label",
                            children: t("order.transportations")
                        }),
                        underReview ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                            className: "OrderSummaryJobsCard__reviewContainer",
                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                className: "OrderSummaryJobsCard__reviewContainer__label",
                                children: t("order.under_review")
                            })
                        }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                            className: "OrderSummaryJobsCard__data",
                            children: t("order.transportation_cost", {
                                currency: currency,
                                cost: transportation_costs
                            })
                        })
                    ]
                })
            }),
            Boolean(invitedSPs.length) && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "OrderSummaryJobsCard__row OrderSummaryJobsCard__row--vertical",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                        className: "OrderSummaryJobsCard__label",
                        children: t("invited_sps.invited_sps")
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        children: invitedSPs.map((sp)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $487c9a2e5b754624$export$7e23a963ec4768e3), {
                                disabled: false,
                                withCheckbox: false,
                                sp: sp,
                                selected: true,
                                showDesignation: false
                            }, sp.id))
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ac9246dc7e4258f8$export$2e2bcd8739ae039), {
                modalIsOpen: shiftsModalIsOpen,
                closeModal: ()=>setShiftsModalIsOpen(false),
                start_date: start_date,
                shifts: shifts,
                end_date: end_date,
                work_category_name: work_category_name
            })
        ]
    });
};
var $d65ef9483570d398$export$2e2bcd8739ae039 = $d65ef9483570d398$var$OrderSummaryJobsCard;





const $a5e8fce3ee993db4$var$OrderSummaryCostCard = ({ sub_total: sub_total, tax: tax, tax_percent: tax_percent, transportation_total: transportation_total, total: total, currency: currency })=>{
    const { t: t } = (0, $3765cebd031b52c0$export$9fc83ad70ead8663)();
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "OrderSummaryCostCard",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "OrderSummaryCostCard__row",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                        className: "OrderSummaryCostCard__label",
                        children: t("order.subtotal")
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                        className: "OrderSummaryCostCard__data",
                        children: [
                            sub_total,
                            " ",
                            currency
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "OrderSummaryCostCard__row",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                        className: "OrderSummaryCostCard__label",
                        children: t("order.transportations")
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                        className: "OrderSummaryCostCard__data",
                        children: [
                            transportation_total,
                            " ",
                            currency
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "OrderSummaryCostCard__row",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                        className: "OrderSummaryCostCard__label",
                        children: t("order.vat_percent", {
                            count: tax_percent
                        })
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                        className: "OrderSummaryCostCard__data",
                        children: [
                            tax,
                            " ",
                            currency
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "OrderSummaryCostCard__row",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                        className: "OrderSummaryCostCard__label bold",
                        children: t("order.estimated_total")
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                        className: "OrderSummaryCostCard__data bold",
                        children: [
                            total,
                            " ",
                            currency
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "OrderSummaryCostCard__hint",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                    className: "OrderSummaryCostCard__hint__label",
                    children: t("order.final_amount_will_be_based")
                })
            })
        ]
    });
};
var $a5e8fce3ee993db4$export$2e2bcd8739ae039 = $a5e8fce3ee993db4$var$OrderSummaryCostCard;










var $fad8d8af5e59da33$exports = {};
$fad8d8af5e59da33$exports = new URL("vertical-dropdown.03e082d9.svg", import.meta.url).toString();






const $bd25114c2c6a2977$export$2ce376c2cc3355c8 = ({ img: img, title: title, onClick: onClick, additionalTitleStyle: additionalTitleStyle })=>{
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        onClick: onClick,
        className: "MenuItem",
        children: [
            img,
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $660b2ca422e0e2ae$export$1ff3c3f08ae963c0).Horizontal, {
                width: 16
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                className: "MenuItem__title",
                style: additionalTitleStyle,
                children: title
            })
        ]
    });
};


var $c3508c9e208f0598$exports = {};
$c3508c9e208f0598$exports = new URL("download.3c460ed7.svg", import.meta.url).toString();


var $f12a10c32f79d84c$exports = {};
$f12a10c32f79d84c$exports = new URL("upload.8fa4dd18.svg", import.meta.url).toString();


var $4e96de822fbb359c$exports = {};
$4e96de822fbb359c$exports = new URL("duplicate.cdb5ff3f.svg", import.meta.url).toString();





const $c9058233d024dfd7$export$8b251419efc915eb = ({ orderId: orderId, isQuoteDownloading: isQuoteDownloading, downloadQuote: downloadQuote, isPendingLPOUpload: isPendingLPOUpload, isLPOUploading: isLPOUploading, uploadLPO: uploadLPO, downloadLPO: downloadLPO, isLPODownloading: isLPODownloading, lpoWasUploaded: lpoWasUploaded, duplicateOrder: duplicateOrder, showQuoteDownload: showQuoteDownload })=>{
    const menuItems = [
        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $bd25114c2c6a2977$export$2ce376c2cc3355c8), {
            title: (0, $2b1f0855f2f3a952$export$625550452a3fa3ec)("order.menu_duplicate_order"),
            img: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                src: (0, (/*@__PURE__*/$parcel$interopDefault($4e96de822fbb359c$exports)))
            }),
            onClick: duplicateOrder
        }, 0)
    ];
    if (showQuoteDownload) menuItems.push(/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $bd25114c2c6a2977$export$2ce376c2cc3355c8), {
        title: isQuoteDownloading ? (0, $2b1f0855f2f3a952$export$625550452a3fa3ec)("order.quotation_download_in_progress_text") : (0, $2b1f0855f2f3a952$export$625550452a3fa3ec)("order.menu_download_quote"),
        img: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
            src: (0, (/*@__PURE__*/$parcel$interopDefault($c3508c9e208f0598$exports)))
        }),
        onClick: downloadQuote
    }, 1));
    if (Boolean(isPendingLPOUpload)) menuItems.push(/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $bd25114c2c6a2977$export$2ce376c2cc3355c8), {
        title: isLPOUploading ? (0, $2b1f0855f2f3a952$export$625550452a3fa3ec)("order.lpo_upload_in_progress_text") : (0, $2b1f0855f2f3a952$export$625550452a3fa3ec)("order.menu_upload_lpo"),
        img: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
            src: (0, (/*@__PURE__*/$parcel$interopDefault($f12a10c32f79d84c$exports)))
        }),
        onClick: uploadLPO
    }, 2));
    if (Boolean(lpoWasUploaded)) menuItems.push(/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $bd25114c2c6a2977$export$2ce376c2cc3355c8), {
        title: isLPODownloading ? (0, $2b1f0855f2f3a952$export$625550452a3fa3ec)("order.lpo_download_in_progress_text") : (0, $2b1f0855f2f3a952$export$625550452a3fa3ec)("order.lpo_download_title"),
        img: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
            src: (0, (/*@__PURE__*/$parcel$interopDefault($f12a10c32f79d84c$exports)))
        }),
        onClick: downloadLPO
    }, 3));
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7ae42b63183f30b4$export$8b251419efc915eb), {
        showBack: true,
        title: (0, $2b1f0855f2f3a952$export$625550452a3fa3ec)("order.order_number", {
            id: orderId
        }),
        rightComponent: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4ae5ab5371178941$export$f01b3d7c7bbe3997), {
            allowedRoles: [
                (0, $97fa7686fb8e51ed$export$eb3485a690c2f0b8).Owner,
                (0, $97fa7686fb8e51ed$export$eb3485a690c2f0b8).Admin,
                (0, $97fa7686fb8e51ed$export$eb3485a690c2f0b8).Finance
            ],
            showDefaultFallbackUI: false,
            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $04012d5b0475752e$export$e44a253a59704894), {
                outerComponent: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                    src: (0, (/*@__PURE__*/$parcel$interopDefault($fad8d8af5e59da33$exports)))
                }),
                items: menuItems
            })
        })
    });
};





var $acw62 = parcelRequire("acw62");












const $6786bdc1b3bfab18$export$34e8fb8cb149ae41 = (0, $a4963babae245ff9$export$f0c7a449e0cfaec7)((0, $aca50e9407ba89c9$export$b6ae1bc530f4c149)(({ modalVisible: modalVisible, orderId: orderId, onClose: onClose })=>{
    const [reason, setReason] = (0, $acw62.useState)("");
    const { amendReasonList: amendReasonList, getAmendReasons: getAmendReasons, setOrderAmendReason: setOrderAmendReason, getAmendReasonIdByName: getAmendReasonIdByName } = (0, $4671947198ddd366$export$6ccbb43953eebf8)().data;
    const { isLoading: loadingReasons } = (0, $4671947198ddd366$export$dd0a697e1782aedd)(getAmendReasons);
    (0, $acw62.useEffect)(()=>{
        if (amendReasonList.length > 0) setReason(amendReasonList[0].name);
    }, [
        amendReasonList,
        amendReasonList.length
    ]);
    const redirect = (0, $7df35e9df335b1c8$export$602eaf6d5314ce55)();
    const [{ isLoading: submittingAmendReason }, sendAmendReason] = (0, $4671947198ddd366$export$609860bf8b0084c)(setOrderAmendReason, {
        onSuccess: ()=>{
            redirect((0, $0534349ae8731d0b$export$66b32f6f30eb4b4).orderDraft, {
                orderId: orderId
            });
        }
    });
    const { t: t } = (0, $3765cebd031b52c0$export$9fc83ad70ead8663)();
    const options = amendReasonList.map((reasonItem)=>({
            key: String(reasonItem.id),
            label: reasonItem.name,
            value: reasonItem.name
        }));
    if (!modalVisible) return null;
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c786671f641538e1$export$446bb0a5366f9068), {
        modalVisible: modalVisible,
        onClose: onClose,
        className: "AmendModal",
        children: loadingReasons ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $57fb8f45c69e1681$export$b08b517936747730), {}) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $660b2ca422e0e2ae$export$1ff3c3f08ae963c0).Vertical, {
                    height: 29
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                    className: "AmendModal__title",
                    children: t("order.select_amend_reason")
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $660b2ca422e0e2ae$export$1ff3c3f08ae963c0).Vertical, {
                    height: 28
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f2c1b8699595d8c0$export$ef9b1a59e592288f), {
                    label: t("order.select_reason"),
                    value: reason,
                    onChange: setReason,
                    options: options
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $660b2ca422e0e2ae$export$1ff3c3f08ae963c0).Vertical, {
                    height: 31
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $2ab88429e3384d30$export$353f5b6fc5456de1), {
                    onClick: ()=>{
                        sendAmendReason({
                            orderId: orderId,
                            reasonId: getAmendReasonIdByName(reason)
                        });
                    },
                    disabled: !reason || submittingAmendReason,
                    title: submittingAmendReason ? t("order.submitting") : t("order.continue"),
                    className: "AmendModal__confirmButton"
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $660b2ca422e0e2ae$export$1ff3c3f08ae963c0).Vertical, {
                    height: 16
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $2ab88429e3384d30$export$353f5b6fc5456de1), {
                    title: t("order.cancel"),
                    onClick: onClose,
                    className: "AmendModal__cancelButton"
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $660b2ca422e0e2ae$export$1ff3c3f08ae963c0).Vertical, {
                    height: 30
                })
            ]
        })
    });
}));




var $acw62 = parcelRequire("acw62");


const $b62c5e2d204939d7$export$2957fc44b3d2481 = ({ color: color })=>{
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M11.9997 4C7.58197 4 4 7.58197 4 11.9997C4 16.4174 7.58197 20 11.9997 20C16.4174 20 20 16.4174 20 11.9997C20 7.58197 16.4174 4 11.9997 4ZM13.665 16.3984C13.2532 16.5609 12.9255 16.6842 12.6796 16.7695C12.4345 16.8549 12.1493 16.8975 11.8249 16.8975C11.3265 16.8975 10.9384 16.7756 10.6621 16.5325C10.3858 16.2894 10.2483 15.9812 10.2483 15.6067C10.2483 15.4611 10.2585 15.3121 10.2788 15.1604C10.2998 15.0087 10.333 14.838 10.3783 14.6463L10.8937 12.8259C10.9391 12.6512 10.9784 12.4852 11.0095 12.3308C11.0407 12.1751 11.0556 12.0322 11.0556 11.9021C11.0556 11.6705 11.0075 11.508 10.912 11.4166C10.8152 11.3251 10.633 11.2804 10.3614 11.2804C10.2287 11.2804 10.0919 11.3001 9.95166 11.3414C9.81283 11.384 9.69228 11.4226 9.5934 11.4606L9.72952 10.8998C10.0668 10.7623 10.3898 10.6445 10.698 10.547C11.0061 10.4481 11.2974 10.3993 11.5716 10.3993C12.0667 10.3993 12.4487 10.5199 12.7175 10.7583C12.9851 10.9973 13.1198 11.3082 13.1198 11.6902C13.1198 11.7694 13.1103 11.9089 13.0921 12.108C13.0738 12.3078 13.0392 12.49 12.9891 12.6573L12.4764 14.4723C12.4345 14.6179 12.3972 14.7845 12.3633 14.9708C12.3302 15.157 12.3139 15.2992 12.3139 15.3947C12.3139 15.6358 12.3674 15.8004 12.4758 15.8877C12.5828 15.9751 12.7704 16.0191 13.0359 16.0191C13.1611 16.0191 13.3013 15.9968 13.4598 15.9534C13.6169 15.9101 13.7307 15.8715 13.8025 15.8383L13.665 16.3984ZM13.5743 9.03128C13.3352 9.25342 13.0474 9.36449 12.7108 9.36449C12.3749 9.36449 12.085 9.25342 11.8439 9.03128C11.6041 8.80914 11.4829 8.53892 11.4829 8.22332C11.4829 7.9084 11.6048 7.6375 11.8439 7.41333C12.085 7.18849 12.3749 7.07674 12.7108 7.07674C13.0474 7.07674 13.3359 7.18849 13.5743 7.41333C13.8133 7.6375 13.9332 7.9084 13.9332 8.22332C13.9332 8.5396 13.8133 8.80914 13.5743 9.03128Z",
            fill: color
        })
    });
};



const $20928959f7ecf969$export$cae179f078f4b4a4 = ({ color: color })=>{
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M13.2475 11.9995L16.7418 15.493C16.9009 15.6532 17 15.8733 17 16.1168C17 16.6048 16.6045 17 16.118 17C15.8734 17 15.6534 16.9007 15.4934 16.7415L12 13.2471L8.50664 16.7415C8.34661 16.9007 8.12566 17 7.88198 17C7.39462 17 7 16.6048 7 16.1168C7 15.8733 7.09911 15.6532 7.25823 15.493L10.7525 11.9995L7.25823 8.50604C7.09911 8.34682 7 8.12578 7 7.88227C7 7.39524 7.39462 7 7.88198 7C8.12566 7 8.34661 7.09928 8.50664 7.2585L12 10.752L15.4934 7.2585C15.6534 7.09928 15.8734 7 16.118 7C16.6045 7 17 7.39524 17 7.88227C17 8.12578 16.9009 8.34682 16.7418 8.50604L13.2475 11.9995Z",
            fill: color
        })
    });
};


var $7a26230deaaf6920$export$14faa19a0f3bbeb2;
(function(Theme) {
    Theme["Blue"] = "blue";
    Theme["Orange"] = "orange";
})($7a26230deaaf6920$export$14faa19a0f3bbeb2 || ($7a26230deaaf6920$export$14faa19a0f3bbeb2 = {}));
const $7a26230deaaf6920$var$themes = {
    ["blue"]: {
        primaryColor: "#7094F7",
        secondaryColor: "#F4FAFF"
    },
    ["orange"]: {
        primaryColor: "#FCB35C",
        secondaryColor: "#FFFFFF"
    }
};
const $7a26230deaaf6920$export$944fe0ec49485b21 = ({ theme: theme, title: title, actionText: actionText, action: action = ()=>{}, isActionInProgress: isActionInProgress = false, actionInProgressText: actionInProgressText, withCloseButton: withCloseButton = true, style: style, textStyle: textStyle })=>{
    const [isShown, setIsShown] = (0, $acw62.useState)(true);
    if (!isShown) return null;
    const containerStyle = {
        border: `1px solid ${$7a26230deaaf6920$var$themes[theme].primaryColor}`,
        background: $7a26230deaaf6920$var$themes[theme].secondaryColor,
        ...style
    };
    return isActionInProgress ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        className: "ActionAlert",
        style: containerStyle,
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
            className: "ActionAlert__actionText",
            children: actionInProgressText
        })
    }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        onClick: action,
        className: "ActionAlert",
        style: containerStyle,
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "ActionAlert__left",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "ActionAlert__icon",
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b62c5e2d204939d7$export$2957fc44b3d2481), {
                            color: $7a26230deaaf6920$var$themes[theme].primaryColor
                        })
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                        className: "ActionAlert__title",
                        style: textStyle,
                        children: title
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "ActionAlert__right",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                    className: "ActionAlert__actionText",
                    children: actionText
                })
            }),
            withCloseButton && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "ActionAlert__close",
                onClick: ()=>setIsShown(false),
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $20928959f7ecf969$export$cae179f078f4b4a4), {
                    color: $7a26230deaaf6920$var$themes[theme].primaryColor
                })
            })
        ]
    });
};









var $kLorN = parcelRequire("kLorN");


const $c6f05f53c1840e94$export$d3fa8faf524123 = ({ isTermsAndConditionsAccepted: isTermsAndConditionsAccepted, requestConfirmTerms: requestConfirmTerms, apiHost: apiHost })=>{
    const { t: t } = (0, $3765cebd031b52c0$export$9fc83ad70ead8663)();
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "OrderSummary__terms",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                checked: isTermsAndConditionsAccepted,
                type: "checkbox",
                disabled: isTermsAndConditionsAccepted,
                onChange: requestConfirmTerms
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $e04d9533328ca578$export$8d6a9236f2e3f2ce), {
                    children: [
                        t("order.i_accept"),
                        " ",
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("a", {
                            href: `${apiHost}client/profile/sla?type=html`,
                            target: "_blank",
                            rel: "noreferrer",
                            children: t("order.terms_of_service")
                        })
                    ]
                }, "order.i_accept_terms")
            })
        ]
    });
};











var $11bf87642d69b3f7$exports = {};
$11bf87642d69b3f7$exports = new URL("next-arrow.cc62850d.svg", import.meta.url).toString();


var $a28e768811cea843$exports = {};
$a28e768811cea843$exports = new URL("back-arrow.72b0950b.svg", import.meta.url).toString();


const $975e752f6db25d7b$export$6c746a5570b8b35c = {
    nextArrowImg: (/*@__PURE__*/$parcel$interopDefault($11bf87642d69b3f7$exports)),
    backArrowImg: (/*@__PURE__*/$parcel$interopDefault($a28e768811cea843$exports))
};



const $9dfc32a0a996fa14$export$ed8ca599049e8881 = ({ stepsCount: stepsCount, currentStep: currentStep, nextDisabled: nextDisabled, backDisabled: backDisabled, nextButtonLabel: nextButtonLabel, handleNextPress: handleNextPress, handleBackPress: handleBackPress, shouldNextButtonSubmitForm: shouldNextButtonSubmitForm, objectNameLabel: objectNameLabel, className: className })=>{
    const { t: t } = (0, $3765cebd031b52c0$export$9fc83ad70ead8663)();
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: `Stepper ${className}`,
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "Stepper__leftContainer",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                        className: "Stepper__leftContainer__label",
                        children: t("job_draft_details.step_n_of_m_steps", {
                            objectNameLabel: objectNameLabel ?? "Step",
                            index: currentStep + 1,
                            count: stepsCount
                        })
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "Stepper__leftContainer__progressBar",
                        children: new Array(currentStep + 1).fill(undefined).map((_, index)=>{
                            const isLastActiveItem = index === currentStep;
                            return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                className: `Stepper__leftContainer__progressBar__step rtl-x-flipped ${index === 0 ? "first" : ""} ${isLastActiveItem ? "last" : ""}`,
                                style: {
                                    width: `${1 / stepsCount * 100}%`
                                }
                            }, index);
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "Stepper__rightContainer",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $2ab88429e3384d30$export$353f5b6fc5456de1), {
                        onClick: handleBackPress,
                        className: `Stepper__rightContainer__backButton ${backDisabled ? "disabled" : ""}`,
                        disabled: backDisabled,
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                            src: (0, $975e752f6db25d7b$export$6c746a5570b8b35c).backArrowImg,
                            className: "Stepper__rightContainer__backButton__img rtl-x-flipped"
                        })
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $2ab88429e3384d30$export$353f5b6fc5456de1), {
                        onClick: handleNextPress,
                        className: `Stepper__rightContainer__nextButton ${nextDisabled ? "disabled" : ""}`,
                        disabled: nextDisabled,
                        type: shouldNextButtonSubmitForm ? "submit" : "button",
                        children: nextButtonLabel === "Next" ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                    className: "Stepper__rightContainer__nextButton__label",
                                    children: nextButtonLabel
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                                    src: (0, $975e752f6db25d7b$export$6c746a5570b8b35c).nextArrowImg,
                                    className: "Stepper__rightContainer__nextButton__img rtl-x-flipped"
                                })
                            ]
                        }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                            className: "Stepper__rightContainer__nextButton__label",
                            children: nextButtonLabel
                        })
                    })
                ]
            })
        ]
    });
};





var $d3eaa022e9b999b1$exports = {};
$d3eaa022e9b999b1$exports = new URL("cross.37f5f887.svg", import.meta.url).toString();



const $9c16b10bbbe042e5$export$129a32eedafa97c5 = (0, $aca50e9407ba89c9$export$b6ae1bc530f4c149)(({ isActive: isActive, content: content, close: close })=>{
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, (/*@__PURE__*/$parcel$interopDefault($81292b5b491156fc$exports))), {
        isOpen: isActive,
        onRequestClose: close,
        closeTimeoutMS: 400,
        className: "Popup",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "Popup__header",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "Popup__header__spacer"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "Popup__header__topBar"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        onClick: close,
                        className: "Popup__header__closeContainer",
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                            src: (0, (/*@__PURE__*/$parcel$interopDefault($d3eaa022e9b999b1$exports))),
                            className: "Popup__header__closeContainer__img",
                            alt: "close"
                        })
                    })
                ]
            }),
            content
        ]
    });
});












const $075bb8309516ffda$export$4f037c6ec2da4eeb = (0, $aca50e9407ba89c9$export$b6ae1bc530f4c149)(()=>{
    const { t: t } = (0, $3765cebd031b52c0$export$9fc83ad70ead8663)();
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                className: "Popup__title",
                children: t("order_extension.how_to_extend")
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                className: "Popup__subtitle",
                children: t("order_extension.you_can_extend_order")
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "OrderExtension__popup__innerContainer",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $2ab88429e3384d30$export$353f5b6fc5456de1), {
                        onClick: ()=>{
                            (0, $d6286036be37a1b2$export$957fdea8025b4555).setUseSameExtensionDateForAllJobs(true);
                        },
                        className: `OrderExtension__popup__innerContainer__button ${(0, $d6286036be37a1b2$export$957fdea8025b4555).useSameExtensionDateForAllJobs ? "active" : ""}`,
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                            className: "OrderExtension__popup__innerContainer__button__content",
                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                children: t("order_extension.same_extension_date")
                            })
                        })
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $660b2ca422e0e2ae$export$1ff3c3f08ae963c0).Vertical, {
                        height: 10
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $2ab88429e3384d30$export$353f5b6fc5456de1), {
                        onClick: ()=>(0, $d6286036be37a1b2$export$957fdea8025b4555).setUseSameExtensionDateForAllJobs(false),
                        className: `OrderExtension__popup__innerContainer__button ${!(0, $d6286036be37a1b2$export$957fdea8025b4555).useSameExtensionDateForAllJobs ? "active" : ""}`,
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                            className: "OrderExtension__popup__innerContainer__button__content",
                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                children: t("order_extension.different_extension_dates")
                            })
                        })
                    })
                ]
            })
        ]
    });
});







var $acw62 = parcelRequire("acw62");
var $0dd61daa778d34c9$exports = {};
$0dd61daa778d34c9$exports = new URL("date-input-icon.0d1738e9.svg", import.meta.url).toString();





var $45fvw = parcelRequire("45fvw");

var $acw62 = parcelRequire("acw62");


var $acw62 = parcelRequire("acw62");

var $c9Z8w = parcelRequire("c9Z8w");
function $0a37892229a7559c$export$2e2bcd8739ae039() {
    return Array.prototype.slice.call(arguments).reduce(function(classList, arg) {
        return classList.concat(arg);
    }, []).filter(function(arg) {
        return typeof arg === "string";
    }).join(" ");
}



var $acw62 = parcelRequire("acw62");

var $c9Z8w = parcelRequire("c9Z8w");
var $b2c937a9c7fcec3b$exports = {};
/**
 * lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */ /** Used as the `TypeError` message for "Functions" methods. */ var $b2c937a9c7fcec3b$var$FUNC_ERROR_TEXT = "Expected a function";
/** Used to stand-in for `undefined` hash values. */ var $b2c937a9c7fcec3b$var$HASH_UNDEFINED = "__lodash_hash_undefined__";
/** `Object#toString` result references. */ var $b2c937a9c7fcec3b$var$funcTag = "[object Function]", $b2c937a9c7fcec3b$var$genTag = "[object GeneratorFunction]";
/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */ var $b2c937a9c7fcec3b$var$reRegExpChar = /[\\^$.*+?()[\]{}|]/g;
/** Used to detect host constructors (Safari). */ var $b2c937a9c7fcec3b$var$reIsHostCtor = /^\[object .+?Constructor\]$/;
/** Detect free variable `global` from Node.js. */ var $b2c937a9c7fcec3b$var$freeGlobal = typeof $parcel$global == "object" && $parcel$global && $parcel$global.Object === Object && $parcel$global;
/** Detect free variable `self`. */ var $b2c937a9c7fcec3b$var$freeSelf = typeof self == "object" && self && self.Object === Object && self;
/** Used as a reference to the global object. */ var $b2c937a9c7fcec3b$var$root = $b2c937a9c7fcec3b$var$freeGlobal || $b2c937a9c7fcec3b$var$freeSelf || Function("return this")();
/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */ function $b2c937a9c7fcec3b$var$getValue(object, key) {
    return object == null ? undefined : object[key];
}
/**
 * Checks if `value` is a host object in IE < 9.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a host object, else `false`.
 */ function $b2c937a9c7fcec3b$var$isHostObject(value) {
    // Many host objects are `Object` objects that can coerce to strings
    // despite having improperly defined `toString` methods.
    var result = false;
    if (value != null && typeof value.toString != "function") try {
        result = !!(value + "");
    } catch (e) {}
    return result;
}
/** Used for built-in method references. */ var $b2c937a9c7fcec3b$var$arrayProto = Array.prototype, $b2c937a9c7fcec3b$var$funcProto = Function.prototype, $b2c937a9c7fcec3b$var$objectProto = Object.prototype;
/** Used to detect overreaching core-js shims. */ var $b2c937a9c7fcec3b$var$coreJsData = $b2c937a9c7fcec3b$var$root["__core-js_shared__"];
/** Used to detect methods masquerading as native. */ var $b2c937a9c7fcec3b$var$maskSrcKey = function() {
    var uid = /[^.]+$/.exec($b2c937a9c7fcec3b$var$coreJsData && $b2c937a9c7fcec3b$var$coreJsData.keys && $b2c937a9c7fcec3b$var$coreJsData.keys.IE_PROTO || "");
    return uid ? "Symbol(src)_1." + uid : "";
}();
/** Used to resolve the decompiled source of functions. */ var $b2c937a9c7fcec3b$var$funcToString = $b2c937a9c7fcec3b$var$funcProto.toString;
/** Used to check objects for own properties. */ var $b2c937a9c7fcec3b$var$hasOwnProperty = $b2c937a9c7fcec3b$var$objectProto.hasOwnProperty;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var $b2c937a9c7fcec3b$var$objectToString = $b2c937a9c7fcec3b$var$objectProto.toString;
/** Used to detect if a method is native. */ var $b2c937a9c7fcec3b$var$reIsNative = RegExp("^" + $b2c937a9c7fcec3b$var$funcToString.call($b2c937a9c7fcec3b$var$hasOwnProperty).replace($b2c937a9c7fcec3b$var$reRegExpChar, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$");
/** Built-in value references. */ var $b2c937a9c7fcec3b$var$splice = $b2c937a9c7fcec3b$var$arrayProto.splice;
/* Built-in method references that are verified to be native. */ var $b2c937a9c7fcec3b$var$Map = $b2c937a9c7fcec3b$var$getNative($b2c937a9c7fcec3b$var$root, "Map"), $b2c937a9c7fcec3b$var$nativeCreate = $b2c937a9c7fcec3b$var$getNative(Object, "create");
/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function $b2c937a9c7fcec3b$var$Hash(entries) {
    var index = -1, length = entries ? entries.length : 0;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */ function $b2c937a9c7fcec3b$var$hashClear() {
    this.__data__ = $b2c937a9c7fcec3b$var$nativeCreate ? $b2c937a9c7fcec3b$var$nativeCreate(null) : {};
}
/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function $b2c937a9c7fcec3b$var$hashDelete(key) {
    return this.has(key) && delete this.__data__[key];
}
/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function $b2c937a9c7fcec3b$var$hashGet(key) {
    var data = this.__data__;
    if ($b2c937a9c7fcec3b$var$nativeCreate) {
        var result = data[key];
        return result === $b2c937a9c7fcec3b$var$HASH_UNDEFINED ? undefined : result;
    }
    return $b2c937a9c7fcec3b$var$hasOwnProperty.call(data, key) ? data[key] : undefined;
}
/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $b2c937a9c7fcec3b$var$hashHas(key) {
    var data = this.__data__;
    return $b2c937a9c7fcec3b$var$nativeCreate ? data[key] !== undefined : $b2c937a9c7fcec3b$var$hasOwnProperty.call(data, key);
}
/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */ function $b2c937a9c7fcec3b$var$hashSet(key, value) {
    var data = this.__data__;
    data[key] = $b2c937a9c7fcec3b$var$nativeCreate && value === undefined ? $b2c937a9c7fcec3b$var$HASH_UNDEFINED : value;
    return this;
}
// Add methods to `Hash`.
$b2c937a9c7fcec3b$var$Hash.prototype.clear = $b2c937a9c7fcec3b$var$hashClear;
$b2c937a9c7fcec3b$var$Hash.prototype["delete"] = $b2c937a9c7fcec3b$var$hashDelete;
$b2c937a9c7fcec3b$var$Hash.prototype.get = $b2c937a9c7fcec3b$var$hashGet;
$b2c937a9c7fcec3b$var$Hash.prototype.has = $b2c937a9c7fcec3b$var$hashHas;
$b2c937a9c7fcec3b$var$Hash.prototype.set = $b2c937a9c7fcec3b$var$hashSet;
/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function $b2c937a9c7fcec3b$var$ListCache(entries) {
    var index = -1, length = entries ? entries.length : 0;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */ function $b2c937a9c7fcec3b$var$listCacheClear() {
    this.__data__ = [];
}
/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function $b2c937a9c7fcec3b$var$listCacheDelete(key) {
    var data = this.__data__, index = $b2c937a9c7fcec3b$var$assocIndexOf(data, key);
    if (index < 0) return false;
    var lastIndex = data.length - 1;
    if (index == lastIndex) data.pop();
    else $b2c937a9c7fcec3b$var$splice.call(data, index, 1);
    return true;
}
/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function $b2c937a9c7fcec3b$var$listCacheGet(key) {
    var data = this.__data__, index = $b2c937a9c7fcec3b$var$assocIndexOf(data, key);
    return index < 0 ? undefined : data[index][1];
}
/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $b2c937a9c7fcec3b$var$listCacheHas(key) {
    return $b2c937a9c7fcec3b$var$assocIndexOf(this.__data__, key) > -1;
}
/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */ function $b2c937a9c7fcec3b$var$listCacheSet(key, value) {
    var data = this.__data__, index = $b2c937a9c7fcec3b$var$assocIndexOf(data, key);
    if (index < 0) data.push([
        key,
        value
    ]);
    else data[index][1] = value;
    return this;
}
// Add methods to `ListCache`.
$b2c937a9c7fcec3b$var$ListCache.prototype.clear = $b2c937a9c7fcec3b$var$listCacheClear;
$b2c937a9c7fcec3b$var$ListCache.prototype["delete"] = $b2c937a9c7fcec3b$var$listCacheDelete;
$b2c937a9c7fcec3b$var$ListCache.prototype.get = $b2c937a9c7fcec3b$var$listCacheGet;
$b2c937a9c7fcec3b$var$ListCache.prototype.has = $b2c937a9c7fcec3b$var$listCacheHas;
$b2c937a9c7fcec3b$var$ListCache.prototype.set = $b2c937a9c7fcec3b$var$listCacheSet;
/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function $b2c937a9c7fcec3b$var$MapCache(entries) {
    var index = -1, length = entries ? entries.length : 0;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */ function $b2c937a9c7fcec3b$var$mapCacheClear() {
    this.__data__ = {
        "hash": new $b2c937a9c7fcec3b$var$Hash,
        "map": new ($b2c937a9c7fcec3b$var$Map || $b2c937a9c7fcec3b$var$ListCache),
        "string": new $b2c937a9c7fcec3b$var$Hash
    };
}
/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function $b2c937a9c7fcec3b$var$mapCacheDelete(key) {
    return $b2c937a9c7fcec3b$var$getMapData(this, key)["delete"](key);
}
/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function $b2c937a9c7fcec3b$var$mapCacheGet(key) {
    return $b2c937a9c7fcec3b$var$getMapData(this, key).get(key);
}
/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $b2c937a9c7fcec3b$var$mapCacheHas(key) {
    return $b2c937a9c7fcec3b$var$getMapData(this, key).has(key);
}
/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */ function $b2c937a9c7fcec3b$var$mapCacheSet(key, value) {
    $b2c937a9c7fcec3b$var$getMapData(this, key).set(key, value);
    return this;
}
// Add methods to `MapCache`.
$b2c937a9c7fcec3b$var$MapCache.prototype.clear = $b2c937a9c7fcec3b$var$mapCacheClear;
$b2c937a9c7fcec3b$var$MapCache.prototype["delete"] = $b2c937a9c7fcec3b$var$mapCacheDelete;
$b2c937a9c7fcec3b$var$MapCache.prototype.get = $b2c937a9c7fcec3b$var$mapCacheGet;
$b2c937a9c7fcec3b$var$MapCache.prototype.has = $b2c937a9c7fcec3b$var$mapCacheHas;
$b2c937a9c7fcec3b$var$MapCache.prototype.set = $b2c937a9c7fcec3b$var$mapCacheSet;
/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */ function $b2c937a9c7fcec3b$var$assocIndexOf(array, key) {
    var length = array.length;
    while(length--){
        if ($b2c937a9c7fcec3b$var$eq(array[length][0], key)) return length;
    }
    return -1;
}
/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */ function $b2c937a9c7fcec3b$var$baseIsNative(value) {
    if (!$b2c937a9c7fcec3b$var$isObject(value) || $b2c937a9c7fcec3b$var$isMasked(value)) return false;
    var pattern = $b2c937a9c7fcec3b$var$isFunction(value) || $b2c937a9c7fcec3b$var$isHostObject(value) ? $b2c937a9c7fcec3b$var$reIsNative : $b2c937a9c7fcec3b$var$reIsHostCtor;
    return pattern.test($b2c937a9c7fcec3b$var$toSource(value));
}
/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */ function $b2c937a9c7fcec3b$var$getMapData(map, key) {
    var data = map.__data__;
    return $b2c937a9c7fcec3b$var$isKeyable(key) ? data[typeof key == "string" ? "string" : "hash"] : data.map;
}
/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */ function $b2c937a9c7fcec3b$var$getNative(object, key) {
    var value = $b2c937a9c7fcec3b$var$getValue(object, key);
    return $b2c937a9c7fcec3b$var$baseIsNative(value) ? value : undefined;
}
/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */ function $b2c937a9c7fcec3b$var$isKeyable(value) {
    var type = typeof value;
    return type == "string" || type == "number" || type == "symbol" || type == "boolean" ? value !== "__proto__" : value === null;
}
/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */ function $b2c937a9c7fcec3b$var$isMasked(func) {
    return !!$b2c937a9c7fcec3b$var$maskSrcKey && $b2c937a9c7fcec3b$var$maskSrcKey in func;
}
/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to process.
 * @returns {string} Returns the source code.
 */ function $b2c937a9c7fcec3b$var$toSource(func) {
    if (func != null) {
        try {
            return $b2c937a9c7fcec3b$var$funcToString.call(func);
        } catch (e) {}
        try {
            return func + "";
        } catch (e) {}
    }
    return "";
}
/**
 * Creates a function that memoizes the result of `func`. If `resolver` is
 * provided, it determines the cache key for storing the result based on the
 * arguments provided to the memoized function. By default, the first argument
 * provided to the memoized function is used as the map cache key. The `func`
 * is invoked with the `this` binding of the memoized function.
 *
 * **Note:** The cache is exposed as the `cache` property on the memoized
 * function. Its creation may be customized by replacing the `_.memoize.Cache`
 * constructor with one whose instances implement the
 * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
 * method interface of `delete`, `get`, `has`, and `set`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to have its output memoized.
 * @param {Function} [resolver] The function to resolve the cache key.
 * @returns {Function} Returns the new memoized function.
 * @example
 *
 * var object = { 'a': 1, 'b': 2 };
 * var other = { 'c': 3, 'd': 4 };
 *
 * var values = _.memoize(_.values);
 * values(object);
 * // => [1, 2]
 *
 * values(other);
 * // => [3, 4]
 *
 * object.a = 2;
 * values(object);
 * // => [1, 2]
 *
 * // Modify the result cache.
 * values.cache.set(object, ['a', 'b']);
 * values(object);
 * // => ['a', 'b']
 *
 * // Replace `_.memoize.Cache`.
 * _.memoize.Cache = WeakMap;
 */ function $b2c937a9c7fcec3b$var$memoize(func, resolver) {
    if (typeof func != "function" || resolver && typeof resolver != "function") throw new TypeError($b2c937a9c7fcec3b$var$FUNC_ERROR_TEXT);
    var memoized = function() {
        var args = arguments, key = resolver ? resolver.apply(this, args) : args[0], cache = memoized.cache;
        if (cache.has(key)) return cache.get(key);
        var result = func.apply(this, args);
        memoized.cache = cache.set(key, result);
        return result;
    };
    memoized.cache = new ($b2c937a9c7fcec3b$var$memoize.Cache || $b2c937a9c7fcec3b$var$MapCache);
    return memoized;
}
// Assign cache to `_.memoize`.
$b2c937a9c7fcec3b$var$memoize.Cache = $b2c937a9c7fcec3b$var$MapCache;
/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */ function $b2c937a9c7fcec3b$var$eq(value, other) {
    return value === other || value !== value && other !== other;
}
/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */ function $b2c937a9c7fcec3b$var$isFunction(value) {
    // The use of `Object#toString` avoids issues with the `typeof` operator
    // in Safari 8-9 which returns 'object' for typed array and other constructors.
    var tag = $b2c937a9c7fcec3b$var$isObject(value) ? $b2c937a9c7fcec3b$var$objectToString.call(value) : "";
    return tag == $b2c937a9c7fcec3b$var$funcTag || tag == $b2c937a9c7fcec3b$var$genTag;
}
/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */ function $b2c937a9c7fcec3b$var$isObject(value) {
    var type = typeof value;
    return !!value && (type == "object" || type == "function");
}
$b2c937a9c7fcec3b$exports = $b2c937a9c7fcec3b$var$memoize;


function $3cee2524baeacc16$var$resolver(options) {
    return JSON.stringify(options);
}
function $3cee2524baeacc16$var$uniqDefined(arr) {
    return arr.filter(function(el, index) {
        return el && arr.indexOf(el) === index;
    });
}
function $3cee2524baeacc16$var$normalizeLocales(arr) {
    return arr.map(function(el) {
        if (!el || el.indexOf("-") === -1 || el.toLowerCase() !== el) return el;
        var splitEl = el.split("-");
        return splitEl[0] + "-" + splitEl[1].toUpperCase();
    });
}
function $3cee2524baeacc16$var$getUserLocalesInternal(_temp) {
    var _ref = _temp === void 0 ? {} : _temp, _ref$useFallbackLocal = _ref.useFallbackLocale, useFallbackLocale = _ref$useFallbackLocal === void 0 ? true : _ref$useFallbackLocal, _ref$fallbackLocale = _ref.fallbackLocale, fallbackLocale = _ref$fallbackLocale === void 0 ? "en-US" : _ref$fallbackLocale;
    var languageList = [];
    if (typeof window !== "undefined") {
        var _window = window, navigator = _window.navigator;
        languageList = languageList.concat(navigator.languages, navigator.language, navigator.userLanguage, navigator.browserLanguage, navigator.systemLanguage);
    }
    if (useFallbackLocale) languageList.push(fallbackLocale);
    return $3cee2524baeacc16$var$normalizeLocales($3cee2524baeacc16$var$uniqDefined(languageList));
}
var $3cee2524baeacc16$export$2709d88c05bbce73 = (0, (/*@__PURE__*/$parcel$interopDefault($b2c937a9c7fcec3b$exports)))($3cee2524baeacc16$var$getUserLocalesInternal, $3cee2524baeacc16$var$resolver);
function $3cee2524baeacc16$var$getUserLocaleInternal(options) {
    return $3cee2524baeacc16$export$2709d88c05bbce73(options)[0] || null;
}
var $3cee2524baeacc16$export$a6ea185b366483aa = (0, (/*@__PURE__*/$parcel$interopDefault($b2c937a9c7fcec3b$exports)))($3cee2524baeacc16$var$getUserLocaleInternal, $3cee2524baeacc16$var$resolver);
var $3cee2524baeacc16$export$2e2bcd8739ae039 = $3cee2524baeacc16$export$a6ea185b366483aa;


/**
 * Utils
 */ function $78fdc7949801ab2a$var$makeGetEdgeOfNeighbor(getPeriod, getEdgeOfPeriod, defaultOffset) {
    return function makeGetEdgeOfNeighborInternal(date, offset) {
        if (offset === void 0) offset = defaultOffset;
        var previousPeriod = getPeriod(date) + offset;
        return getEdgeOfPeriod(previousPeriod);
    };
}
function $78fdc7949801ab2a$var$makeGetEnd(getBeginOfNextPeriod) {
    return function makeGetEndInternal(date) {
        return new Date(getBeginOfNextPeriod(date).getTime() - 1);
    };
}
function $78fdc7949801ab2a$var$makeGetRange(getStart, getEnd) {
    return function makeGetRangeInternal(date) {
        return [
            getStart(date),
            getEnd(date)
        ];
    };
}
function $78fdc7949801ab2a$export$5846dc2d57a5c860(date) {
    if (date instanceof Date) return date.getFullYear();
    if (typeof date === "number") return date;
    var year = parseInt(date, 10);
    if (typeof date === "string" && !isNaN(year)) return year;
    throw new Error("Failed to get year from date: ".concat(date, "."));
}
function $78fdc7949801ab2a$export$6ce1b5acc29cb53b(date) {
    if (date instanceof Date) return date.getMonth();
    throw new Error("Failed to get month from date: ".concat(date, "."));
}
function $78fdc7949801ab2a$export$a8575fd59bc333e3(date) {
    if (date instanceof Date) return date.getMonth() + 1;
    throw new Error("Failed to get human-readable month from date: ".concat(date, "."));
}
function $78fdc7949801ab2a$export$aa350b96d91cd94(date) {
    if (date instanceof Date) return date.getDate();
    throw new Error("Failed to get year from date: ".concat(date, "."));
}
function $78fdc7949801ab2a$export$257b40f71c07d58f(date) {
    if (date instanceof Date) return date.getHours();
    if (typeof date === "string") {
        var datePieces = date.split(":");
        if (datePieces.length >= 2) {
            var hoursString = datePieces[0];
            if (hoursString) {
                var hours = parseInt(hoursString, 10);
                if (!isNaN(hours)) return hours;
            }
        }
    }
    throw new Error("Failed to get hours from date: ".concat(date, "."));
}
function $78fdc7949801ab2a$export$b7f1bc3ea3ac4145(date) {
    if (date instanceof Date) return date.getMinutes();
    if (typeof date === "string") {
        var datePieces = date.split(":");
        if (datePieces.length >= 2) {
            var minutesString = datePieces[1] || "0";
            var minutes = parseInt(minutesString, 10);
            if (!isNaN(minutes)) return minutes;
        }
    }
    throw new Error("Failed to get minutes from date: ".concat(date, "."));
}
function $78fdc7949801ab2a$export$5e9417507ff28427(date) {
    if (date instanceof Date) return date.getSeconds();
    if (typeof date === "string") {
        var datePieces = date.split(":");
        if (datePieces.length >= 2) {
            var secondsWithMillisecondsString = datePieces[2] || "0";
            var seconds = parseInt(secondsWithMillisecondsString, 10);
            if (!isNaN(seconds)) return seconds;
        }
    }
    throw new Error("Failed to get seconds from date: ".concat(date, "."));
}
function $78fdc7949801ab2a$export$b8e4380f312797af(date) {
    if (date instanceof Date) return date.getMilliseconds();
    if (typeof date === "string") {
        var datePieces = date.split(":");
        if (datePieces.length >= 2) {
            var secondsWithMillisecondsString = datePieces[2] || "0";
            var millisecondsString = secondsWithMillisecondsString.split(".")[1] || "0";
            var milliseconds = parseInt(millisecondsString, 10);
            if (!isNaN(milliseconds)) return milliseconds;
        }
    }
    throw new Error("Failed to get seconds from date: ".concat(date, "."));
}
function $78fdc7949801ab2a$export$34dd42d02ca37c6b(date) {
    var year = $78fdc7949801ab2a$export$5846dc2d57a5c860(date);
    var centuryStartYear = year + (-year + 1) % 100;
    var centuryStartDate = new Date();
    centuryStartDate.setFullYear(centuryStartYear, 0, 1);
    centuryStartDate.setHours(0, 0, 0, 0);
    return centuryStartDate;
}
var $78fdc7949801ab2a$export$e65b64b0f80e225a = $78fdc7949801ab2a$var$makeGetEdgeOfNeighbor($78fdc7949801ab2a$export$5846dc2d57a5c860, $78fdc7949801ab2a$export$34dd42d02ca37c6b, -100);
var $78fdc7949801ab2a$export$3e300bd96d747c8a = $78fdc7949801ab2a$var$makeGetEdgeOfNeighbor($78fdc7949801ab2a$export$5846dc2d57a5c860, $78fdc7949801ab2a$export$34dd42d02ca37c6b, 100);
var $78fdc7949801ab2a$export$43c2109e18ca667b = $78fdc7949801ab2a$var$makeGetEnd($78fdc7949801ab2a$export$3e300bd96d747c8a);
var $78fdc7949801ab2a$export$4d124431cf7f00b5 = $78fdc7949801ab2a$var$makeGetEdgeOfNeighbor($78fdc7949801ab2a$export$5846dc2d57a5c860, $78fdc7949801ab2a$export$43c2109e18ca667b, -100);
var $78fdc7949801ab2a$export$2663e0ade48d35a9 = $78fdc7949801ab2a$var$makeGetEdgeOfNeighbor($78fdc7949801ab2a$export$5846dc2d57a5c860, $78fdc7949801ab2a$export$43c2109e18ca667b, 100);
var $78fdc7949801ab2a$export$a4332dc3f9de051f = $78fdc7949801ab2a$var$makeGetRange($78fdc7949801ab2a$export$34dd42d02ca37c6b, $78fdc7949801ab2a$export$43c2109e18ca667b);
function $78fdc7949801ab2a$export$8bb35b885d308e78(date) {
    var year = $78fdc7949801ab2a$export$5846dc2d57a5c860(date);
    var decadeStartYear = year + (-year + 1) % 10;
    var decadeStartDate = new Date();
    decadeStartDate.setFullYear(decadeStartYear, 0, 1);
    decadeStartDate.setHours(0, 0, 0, 0);
    return decadeStartDate;
}
var $78fdc7949801ab2a$export$e43f83f55f1766fa = $78fdc7949801ab2a$var$makeGetEdgeOfNeighbor($78fdc7949801ab2a$export$5846dc2d57a5c860, $78fdc7949801ab2a$export$8bb35b885d308e78, -10);
var $78fdc7949801ab2a$export$8266d1a140c33d17 = $78fdc7949801ab2a$var$makeGetEdgeOfNeighbor($78fdc7949801ab2a$export$5846dc2d57a5c860, $78fdc7949801ab2a$export$8bb35b885d308e78, 10);
var $78fdc7949801ab2a$export$aa0bfba5bfc33956 = $78fdc7949801ab2a$var$makeGetEnd($78fdc7949801ab2a$export$8266d1a140c33d17);
var $78fdc7949801ab2a$export$93edec1b41903921 = $78fdc7949801ab2a$var$makeGetEdgeOfNeighbor($78fdc7949801ab2a$export$5846dc2d57a5c860, $78fdc7949801ab2a$export$aa0bfba5bfc33956, -10);
var $78fdc7949801ab2a$export$112141384c9d3d6b = $78fdc7949801ab2a$var$makeGetEdgeOfNeighbor($78fdc7949801ab2a$export$5846dc2d57a5c860, $78fdc7949801ab2a$export$aa0bfba5bfc33956, 10);
var $78fdc7949801ab2a$export$35cef0a1278b17e1 = $78fdc7949801ab2a$var$makeGetRange($78fdc7949801ab2a$export$8bb35b885d308e78, $78fdc7949801ab2a$export$aa0bfba5bfc33956);
function $78fdc7949801ab2a$export$bbcf6a6951bb3c3a(date) {
    var year = $78fdc7949801ab2a$export$5846dc2d57a5c860(date);
    var yearStartDate = new Date();
    yearStartDate.setFullYear(year, 0, 1);
    yearStartDate.setHours(0, 0, 0, 0);
    return yearStartDate;
}
var $78fdc7949801ab2a$export$97fe927b771a6825 = $78fdc7949801ab2a$var$makeGetEdgeOfNeighbor($78fdc7949801ab2a$export$5846dc2d57a5c860, $78fdc7949801ab2a$export$bbcf6a6951bb3c3a, -1);
var $78fdc7949801ab2a$export$fed82860795beff7 = $78fdc7949801ab2a$var$makeGetEdgeOfNeighbor($78fdc7949801ab2a$export$5846dc2d57a5c860, $78fdc7949801ab2a$export$bbcf6a6951bb3c3a, 1);
var $78fdc7949801ab2a$export$248ddd7fb95e4a56 = $78fdc7949801ab2a$var$makeGetEnd($78fdc7949801ab2a$export$fed82860795beff7);
var $78fdc7949801ab2a$export$639fe5fbfbb704d0 = $78fdc7949801ab2a$var$makeGetEdgeOfNeighbor($78fdc7949801ab2a$export$5846dc2d57a5c860, $78fdc7949801ab2a$export$248ddd7fb95e4a56, -1);
var $78fdc7949801ab2a$export$952396487caf69e5 = $78fdc7949801ab2a$var$makeGetEdgeOfNeighbor($78fdc7949801ab2a$export$5846dc2d57a5c860, $78fdc7949801ab2a$export$248ddd7fb95e4a56, 1);
var $78fdc7949801ab2a$export$17e213d8c10b7032 = $78fdc7949801ab2a$var$makeGetRange($78fdc7949801ab2a$export$bbcf6a6951bb3c3a, $78fdc7949801ab2a$export$248ddd7fb95e4a56);
/**
 * Month
 */ function $78fdc7949801ab2a$var$makeGetEdgeOfNeighborMonth(getEdgeOfPeriod, defaultOffset) {
    return function makeGetEdgeOfNeighborMonthInternal(date, offset) {
        if (offset === void 0) offset = defaultOffset;
        var year = $78fdc7949801ab2a$export$5846dc2d57a5c860(date);
        var month = $78fdc7949801ab2a$export$6ce1b5acc29cb53b(date) + offset;
        var previousPeriod = new Date();
        previousPeriod.setFullYear(year, month, 1);
        previousPeriod.setHours(0, 0, 0, 0);
        return getEdgeOfPeriod(previousPeriod);
    };
}
function $78fdc7949801ab2a$export$c7002b157c9b9e95(date) {
    var year = $78fdc7949801ab2a$export$5846dc2d57a5c860(date);
    var month = $78fdc7949801ab2a$export$6ce1b5acc29cb53b(date);
    var monthStartDate = new Date();
    monthStartDate.setFullYear(year, month, 1);
    monthStartDate.setHours(0, 0, 0, 0);
    return monthStartDate;
}
var $78fdc7949801ab2a$export$e1815383d4029267 = $78fdc7949801ab2a$var$makeGetEdgeOfNeighborMonth($78fdc7949801ab2a$export$c7002b157c9b9e95, -1);
var $78fdc7949801ab2a$export$21b7c773284d5b43 = $78fdc7949801ab2a$var$makeGetEdgeOfNeighborMonth($78fdc7949801ab2a$export$c7002b157c9b9e95, 1);
var $78fdc7949801ab2a$export$6f306f93ccbcd612 = $78fdc7949801ab2a$var$makeGetEnd($78fdc7949801ab2a$export$21b7c773284d5b43);
var $78fdc7949801ab2a$export$b4b5df1ab9a8303b = $78fdc7949801ab2a$var$makeGetEdgeOfNeighborMonth($78fdc7949801ab2a$export$6f306f93ccbcd612, -1);
var $78fdc7949801ab2a$export$98f1c9e60dc0189 = $78fdc7949801ab2a$var$makeGetEdgeOfNeighborMonth($78fdc7949801ab2a$export$6f306f93ccbcd612, 1);
var $78fdc7949801ab2a$export$c59fdbf3ad20e694 = $78fdc7949801ab2a$var$makeGetRange($78fdc7949801ab2a$export$c7002b157c9b9e95, $78fdc7949801ab2a$export$6f306f93ccbcd612);
/**
 * Day
 */ function $78fdc7949801ab2a$var$makeGetEdgeOfNeighborDay(getEdgeOfPeriod, defaultOffset) {
    return function makeGetEdgeOfNeighborDayInternal(date, offset) {
        if (offset === void 0) offset = defaultOffset;
        var year = $78fdc7949801ab2a$export$5846dc2d57a5c860(date);
        var month = $78fdc7949801ab2a$export$6ce1b5acc29cb53b(date);
        var day = $78fdc7949801ab2a$export$aa350b96d91cd94(date) + offset;
        var previousPeriod = new Date();
        previousPeriod.setFullYear(year, month, day);
        previousPeriod.setHours(0, 0, 0, 0);
        return getEdgeOfPeriod(previousPeriod);
    };
}
function $78fdc7949801ab2a$export$ef6b506418c2b397(date) {
    var year = $78fdc7949801ab2a$export$5846dc2d57a5c860(date);
    var month = $78fdc7949801ab2a$export$6ce1b5acc29cb53b(date);
    var day = $78fdc7949801ab2a$export$aa350b96d91cd94(date);
    var dayStartDate = new Date();
    dayStartDate.setFullYear(year, month, day);
    dayStartDate.setHours(0, 0, 0, 0);
    return dayStartDate;
}
var $78fdc7949801ab2a$export$4f27323eaab2ccfd = $78fdc7949801ab2a$var$makeGetEdgeOfNeighborDay($78fdc7949801ab2a$export$ef6b506418c2b397, -1);
var $78fdc7949801ab2a$export$78c5682078b46db4 = $78fdc7949801ab2a$var$makeGetEdgeOfNeighborDay($78fdc7949801ab2a$export$ef6b506418c2b397, 1);
var $78fdc7949801ab2a$export$7b798396f3e38cd7 = $78fdc7949801ab2a$var$makeGetEnd($78fdc7949801ab2a$export$78c5682078b46db4);
var $78fdc7949801ab2a$export$fde0c09caefdfd4a = $78fdc7949801ab2a$var$makeGetEdgeOfNeighborDay($78fdc7949801ab2a$export$7b798396f3e38cd7, -1);
var $78fdc7949801ab2a$export$f991202e82da93a1 = $78fdc7949801ab2a$var$makeGetEdgeOfNeighborDay($78fdc7949801ab2a$export$7b798396f3e38cd7, 1);
var $78fdc7949801ab2a$export$adb5aef569605e64 = $78fdc7949801ab2a$var$makeGetRange($78fdc7949801ab2a$export$ef6b506418c2b397, $78fdc7949801ab2a$export$7b798396f3e38cd7);
function $78fdc7949801ab2a$export$f645ddd439eb259d(date) {
    return $78fdc7949801ab2a$export$aa350b96d91cd94($78fdc7949801ab2a$export$6f306f93ccbcd612(date));
}
function $78fdc7949801ab2a$var$padStart(num, val) {
    if (val === void 0) val = 2;
    var numStr = "".concat(num);
    if (numStr.length >= val) return num;
    return "0000".concat(numStr).slice(-val);
}
function $78fdc7949801ab2a$export$aefe158a7bd76d23(date) {
    var hours = $78fdc7949801ab2a$var$padStart($78fdc7949801ab2a$export$257b40f71c07d58f(date));
    var minutes = $78fdc7949801ab2a$var$padStart($78fdc7949801ab2a$export$b7f1bc3ea3ac4145(date));
    return "".concat(hours, ":").concat(minutes);
}
function $78fdc7949801ab2a$export$52113457154e5fc(date) {
    var hours = $78fdc7949801ab2a$var$padStart($78fdc7949801ab2a$export$257b40f71c07d58f(date));
    var minutes = $78fdc7949801ab2a$var$padStart($78fdc7949801ab2a$export$b7f1bc3ea3ac4145(date));
    var seconds = $78fdc7949801ab2a$var$padStart($78fdc7949801ab2a$export$5e9417507ff28427(date));
    return "".concat(hours, ":").concat(minutes, ":").concat(seconds);
}
function $78fdc7949801ab2a$export$6f885d58ae224c35(date) {
    var year = $78fdc7949801ab2a$var$padStart($78fdc7949801ab2a$export$5846dc2d57a5c860(date), 4);
    var month = $78fdc7949801ab2a$var$padStart($78fdc7949801ab2a$export$a8575fd59bc333e3(date));
    return "".concat(year, "-").concat(month);
}
function $78fdc7949801ab2a$export$ce780a31b7197841(date) {
    var year = $78fdc7949801ab2a$var$padStart($78fdc7949801ab2a$export$5846dc2d57a5c860(date), 4);
    var month = $78fdc7949801ab2a$var$padStart($78fdc7949801ab2a$export$a8575fd59bc333e3(date));
    var day = $78fdc7949801ab2a$var$padStart($78fdc7949801ab2a$export$aa350b96d91cd94(date));
    return "".concat(year, "-").concat(month, "-").concat(day);
}
function $78fdc7949801ab2a$export$98f36b76519fd86(date) {
    return "".concat($78fdc7949801ab2a$export$ce780a31b7197841(date), "T").concat($78fdc7949801ab2a$export$52113457154e5fc(date));
}


var $6ede4d444f78ee44$var$_CALENDAR_TYPE_LOCALE;
function $6ede4d444f78ee44$var$_toConsumableArray(arr) {
    return $6ede4d444f78ee44$var$_arrayWithoutHoles(arr) || $6ede4d444f78ee44$var$_iterableToArray(arr) || $6ede4d444f78ee44$var$_unsupportedIterableToArray(arr) || $6ede4d444f78ee44$var$_nonIterableSpread();
}
function $6ede4d444f78ee44$var$_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $6ede4d444f78ee44$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $6ede4d444f78ee44$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $6ede4d444f78ee44$var$_arrayLikeToArray(o, minLen);
}
function $6ede4d444f78ee44$var$_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function $6ede4d444f78ee44$var$_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return $6ede4d444f78ee44$var$_arrayLikeToArray(arr);
}
function $6ede4d444f78ee44$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $6ede4d444f78ee44$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
var $6ede4d444f78ee44$export$26fa441040070c35 = {
    ARABIC: "Arabic",
    HEBREW: "Hebrew",
    ISO_8601: "ISO 8601",
    US: "US"
};
var $6ede4d444f78ee44$export$e4e5576db5b8e30f = ($6ede4d444f78ee44$var$_CALENDAR_TYPE_LOCALE = {}, $6ede4d444f78ee44$var$_defineProperty($6ede4d444f78ee44$var$_CALENDAR_TYPE_LOCALE, $6ede4d444f78ee44$export$26fa441040070c35.US, [
    "en-CA",
    "en-US",
    "es-AR",
    "es-BO",
    "es-CL",
    "es-CO",
    "es-CR",
    "es-DO",
    "es-EC",
    "es-GT",
    "es-HN",
    "es-MX",
    "es-NI",
    "es-PA",
    "es-PE",
    "es-PR",
    "es-SV",
    "es-VE",
    "pt-BR"
]), $6ede4d444f78ee44$var$_defineProperty($6ede4d444f78ee44$var$_CALENDAR_TYPE_LOCALE, $6ede4d444f78ee44$export$26fa441040070c35.ARABIC, [
    "ar",
    "ar-AE",
    "ar-BH",
    "ar-DZ",
    "ar-EG",
    "ar-IQ",
    "ar-JO",
    "ar-KW",
    "ar-LY",
    "ar-OM",
    "ar-QA",
    "ar-SA",
    "ar-SD",
    "ar-SY",
    "ar-YE",
    "dv",
    "dv-MV",
    "ps",
    "ps-AR"
]), $6ede4d444f78ee44$var$_defineProperty($6ede4d444f78ee44$var$_CALENDAR_TYPE_LOCALE, $6ede4d444f78ee44$export$26fa441040070c35.HEBREW, [
    "he",
    "he-IL"
]), $6ede4d444f78ee44$var$_CALENDAR_TYPE_LOCALE);
var $6ede4d444f78ee44$export$ecc24ef5795d74f8 = $6ede4d444f78ee44$var$_toConsumableArray(Array(7)).map(function(el, index) {
    return index;
});



var $5398151a7800b344$var$formatterCache = new Map();
function $5398151a7800b344$var$getFormatter(options) {
    return function(locale, date) {
        var localeWithDefault = locale || (0, $3cee2524baeacc16$export$2e2bcd8739ae039)();
        if (!$5398151a7800b344$var$formatterCache.has(localeWithDefault)) $5398151a7800b344$var$formatterCache.set(localeWithDefault, new Map());
        var formatterCacheLocale = $5398151a7800b344$var$formatterCache.get(localeWithDefault);
        if (!formatterCacheLocale.has(options)) formatterCacheLocale.set(options, new Intl.DateTimeFormat(localeWithDefault, options).format);
        return formatterCacheLocale.get(options)(date);
    };
}
/**
 * Changes the hour in a Date to ensure right date formatting even if DST is messed up.
 * Workaround for bug in WebKit and Firefox with historical dates.
 * For more details, see:
 * https://bugs.chromium.org/p/chromium/issues/detail?id=750465
 * https://bugzilla.mozilla.org/show_bug.cgi?id=1385643
 *
 * @param {Date} date Date.
 */ function $5398151a7800b344$var$toSafeHour(date) {
    var safeDate = new Date(date);
    return new Date(safeDate.setHours(12));
}
function $5398151a7800b344$var$getSafeFormatter(options) {
    return function(locale, date) {
        return $5398151a7800b344$var$getFormatter(options)(locale, $5398151a7800b344$var$toSafeHour(date));
    };
}
var $5398151a7800b344$var$formatDateOptions = {
    day: "numeric",
    month: "numeric",
    year: "numeric"
};
var $5398151a7800b344$var$formatDayOptions = {
    day: "numeric"
};
var $5398151a7800b344$var$formatLongDateOptions = {
    day: "numeric",
    month: "long",
    year: "numeric"
};
var $5398151a7800b344$var$formatMonthOptions = {
    month: "long"
};
var $5398151a7800b344$var$formatMonthYearOptions = {
    month: "long",
    year: "numeric"
};
var $5398151a7800b344$var$formatShortWeekdayOptions = {
    weekday: "short"
};
var $5398151a7800b344$var$formatWeekdayOptions = {
    weekday: "long"
};
var $5398151a7800b344$var$formatYearOptions = {
    year: "numeric"
};
var $5398151a7800b344$export$3ae94a2503e890a1 = $5398151a7800b344$var$getSafeFormatter($5398151a7800b344$var$formatDateOptions);
var $5398151a7800b344$export$a7f242eff11c1345 = $5398151a7800b344$var$getSafeFormatter($5398151a7800b344$var$formatDayOptions);
var $5398151a7800b344$export$322b36d80aef60ca = $5398151a7800b344$var$getSafeFormatter($5398151a7800b344$var$formatLongDateOptions);
var $5398151a7800b344$export$d0536c8e7f45796e = $5398151a7800b344$var$getSafeFormatter($5398151a7800b344$var$formatMonthOptions);
var $5398151a7800b344$export$18f8ccbe37e54acd = $5398151a7800b344$var$getSafeFormatter($5398151a7800b344$var$formatMonthYearOptions);
var $5398151a7800b344$export$7ebe25e42481bc02 = $5398151a7800b344$var$getSafeFormatter($5398151a7800b344$var$formatShortWeekdayOptions);
var $5398151a7800b344$export$407180b957f39d7e = $5398151a7800b344$var$getSafeFormatter($5398151a7800b344$var$formatWeekdayOptions);
var $5398151a7800b344$export$2979e79cc7cbf15b = $5398151a7800b344$var$getSafeFormatter($5398151a7800b344$var$formatYearOptions);


var $f0256d0d4f3b1098$var$SUNDAY = (0, $6ede4d444f78ee44$export$ecc24ef5795d74f8)[0];
var $f0256d0d4f3b1098$var$FRIDAY = (0, $6ede4d444f78ee44$export$ecc24ef5795d74f8)[5];
var $f0256d0d4f3b1098$var$SATURDAY = (0, $6ede4d444f78ee44$export$ecc24ef5795d74f8)[6];
function $f0256d0d4f3b1098$export$2061056d06d7cdf7(date) {
    var calendarType = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : (0, $6ede4d444f78ee44$export$26fa441040070c35).ISO_8601;
    var weekday = date.getDay();
    switch(calendarType){
        case (0, $6ede4d444f78ee44$export$26fa441040070c35).ISO_8601:
            // Shifts days of the week so that Monday is 0, Sunday is 6
            return (weekday + 6) % 7;
        case (0, $6ede4d444f78ee44$export$26fa441040070c35).ARABIC:
            return (weekday + 1) % 7;
        case (0, $6ede4d444f78ee44$export$26fa441040070c35).HEBREW:
        case (0, $6ede4d444f78ee44$export$26fa441040070c35).US:
            return weekday;
        default:
            throw new Error("Unsupported calendar type.");
    }
}
function $f0256d0d4f3b1098$export$5fc0cc931278f768(date) {
    var beginOfCentury = (0, $78fdc7949801ab2a$export$34dd42d02ca37c6b)(date);
    return (0, $78fdc7949801ab2a$export$5846dc2d57a5c860)(beginOfCentury);
}
function $f0256d0d4f3b1098$export$59fb6e4ffa904295(date) {
    var beginOfDecade = (0, $78fdc7949801ab2a$export$8bb35b885d308e78)(date);
    return (0, $78fdc7949801ab2a$export$5846dc2d57a5c860)(beginOfDecade);
}
function $f0256d0d4f3b1098$export$84e707e5f485f282(date) {
    var calendarType = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : (0, $6ede4d444f78ee44$export$26fa441040070c35).ISO_8601;
    var year = (0, $78fdc7949801ab2a$export$5846dc2d57a5c860)(date);
    var monthIndex = (0, $78fdc7949801ab2a$export$6ce1b5acc29cb53b)(date);
    var day = date.getDate() - $f0256d0d4f3b1098$export$2061056d06d7cdf7(date, calendarType);
    return new Date(year, monthIndex, day);
}
function $f0256d0d4f3b1098$export$b59889984706b7a7(date) {
    var calendarType = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : (0, $6ede4d444f78ee44$export$26fa441040070c35).ISO_8601;
    var calendarTypeForWeekNumber = calendarType === (0, $6ede4d444f78ee44$export$26fa441040070c35).US ? (0, $6ede4d444f78ee44$export$26fa441040070c35).US : (0, $6ede4d444f78ee44$export$26fa441040070c35).ISO_8601;
    var beginOfWeek = $f0256d0d4f3b1098$export$84e707e5f485f282(date, calendarType);
    var year = (0, $78fdc7949801ab2a$export$5846dc2d57a5c860)(date) + 1;
    var dayInWeekOne;
    var beginOfFirstWeek; // Look for the first week one that does not come after a given date
    do {
        dayInWeekOne = new Date(year, 0, calendarTypeForWeekNumber === (0, $6ede4d444f78ee44$export$26fa441040070c35).ISO_8601 ? 4 : 1);
        beginOfFirstWeek = $f0256d0d4f3b1098$export$84e707e5f485f282(dayInWeekOne, calendarType);
        year -= 1;
    }while (date < beginOfFirstWeek);
    return Math.round((beginOfWeek - beginOfFirstWeek) / (8.64e7 * 7)) + 1;
}
function $f0256d0d4f3b1098$export$700a64ae37cbc741(rangeType, date) {
    switch(rangeType){
        case "century":
            return (0, $78fdc7949801ab2a$export$34dd42d02ca37c6b)(date);
        case "decade":
            return (0, $78fdc7949801ab2a$export$8bb35b885d308e78)(date);
        case "year":
            return (0, $78fdc7949801ab2a$export$bbcf6a6951bb3c3a)(date);
        case "month":
            return (0, $78fdc7949801ab2a$export$c7002b157c9b9e95)(date);
        case "day":
            return (0, $78fdc7949801ab2a$export$ef6b506418c2b397)(date);
        default:
            throw new Error("Invalid rangeType: ".concat(rangeType));
    }
}
function $f0256d0d4f3b1098$export$fac7f4c8b12617ff(rangeType, date) {
    switch(rangeType){
        case "century":
            return (0, $78fdc7949801ab2a$export$e65b64b0f80e225a)(date);
        case "decade":
            return (0, $78fdc7949801ab2a$export$e43f83f55f1766fa)(date);
        case "year":
            return (0, $78fdc7949801ab2a$export$97fe927b771a6825)(date);
        case "month":
            return (0, $78fdc7949801ab2a$export$e1815383d4029267)(date);
        default:
            throw new Error("Invalid rangeType: ".concat(rangeType));
    }
}
function $f0256d0d4f3b1098$export$19193c1f2d841d47(rangeType, date) {
    switch(rangeType){
        case "century":
            return (0, $78fdc7949801ab2a$export$3e300bd96d747c8a)(date);
        case "decade":
            return (0, $78fdc7949801ab2a$export$8266d1a140c33d17)(date);
        case "year":
            return (0, $78fdc7949801ab2a$export$fed82860795beff7)(date);
        case "month":
            return (0, $78fdc7949801ab2a$export$21b7c773284d5b43)(date);
        default:
            throw new Error("Invalid rangeType: ".concat(rangeType));
    }
}
var $f0256d0d4f3b1098$export$b514bf5935bed2bf = function getBeginPrevious2(rangeType, date) {
    switch(rangeType){
        case "decade":
            return (0, $78fdc7949801ab2a$export$e43f83f55f1766fa)(date, -100);
        case "year":
            return (0, $78fdc7949801ab2a$export$97fe927b771a6825)(date, -10);
        case "month":
            return (0, $78fdc7949801ab2a$export$e1815383d4029267)(date, -12);
        default:
            throw new Error("Invalid rangeType: ".concat(rangeType));
    }
};
var $f0256d0d4f3b1098$export$2805b7ce8402b644 = function getBeginNext2(rangeType, date) {
    switch(rangeType){
        case "decade":
            return (0, $78fdc7949801ab2a$export$8266d1a140c33d17)(date, 100);
        case "year":
            return (0, $78fdc7949801ab2a$export$fed82860795beff7)(date, 10);
        case "month":
            return (0, $78fdc7949801ab2a$export$21b7c773284d5b43)(date, 12);
        default:
            throw new Error("Invalid rangeType: ".concat(rangeType));
    }
};
function $f0256d0d4f3b1098$export$946298ccd438a697(rangeType, date) {
    switch(rangeType){
        case "century":
            return (0, $78fdc7949801ab2a$export$43c2109e18ca667b)(date);
        case "decade":
            return (0, $78fdc7949801ab2a$export$aa0bfba5bfc33956)(date);
        case "year":
            return (0, $78fdc7949801ab2a$export$248ddd7fb95e4a56)(date);
        case "month":
            return (0, $78fdc7949801ab2a$export$6f306f93ccbcd612)(date);
        case "day":
            return (0, $78fdc7949801ab2a$export$7b798396f3e38cd7)(date);
        default:
            throw new Error("Invalid rangeType: ".concat(rangeType));
    }
}
function $f0256d0d4f3b1098$export$3030eb755e02a078(rangeType, date) {
    switch(rangeType){
        case "century":
            return (0, $78fdc7949801ab2a$export$4d124431cf7f00b5)(date);
        case "decade":
            return (0, $78fdc7949801ab2a$export$93edec1b41903921)(date);
        case "year":
            return (0, $78fdc7949801ab2a$export$639fe5fbfbb704d0)(date);
        case "month":
            return (0, $78fdc7949801ab2a$export$b4b5df1ab9a8303b)(date);
        default:
            throw new Error("Invalid rangeType: ".concat(rangeType));
    }
}
var $f0256d0d4f3b1098$export$d34b1dc45bd5f1d3 = function getEndPrevious2(rangeType, date) {
    switch(rangeType){
        case "decade":
            return (0, $78fdc7949801ab2a$export$93edec1b41903921)(date, -100);
        case "year":
            return (0, $78fdc7949801ab2a$export$639fe5fbfbb704d0)(date, -10);
        case "month":
            return (0, $78fdc7949801ab2a$export$b4b5df1ab9a8303b)(date, -12);
        default:
            throw new Error("Invalid rangeType: ".concat(rangeType));
    }
};
function $f0256d0d4f3b1098$export$fef151b94550e9f5(rangeType, date) {
    switch(rangeType){
        case "century":
            return (0, $78fdc7949801ab2a$export$a4332dc3f9de051f)(date);
        case "decade":
            return (0, $78fdc7949801ab2a$export$35cef0a1278b17e1)(date);
        case "year":
            return (0, $78fdc7949801ab2a$export$17e213d8c10b7032)(date);
        case "month":
            return (0, $78fdc7949801ab2a$export$c59fdbf3ad20e694)(date);
        case "day":
            return (0, $78fdc7949801ab2a$export$adb5aef569605e64)(date);
        default:
            throw new Error("Invalid rangeType: ".concat(rangeType));
    }
}
function $f0256d0d4f3b1098$export$3a3e6dbcaf74641d(rangeType, date1, date2) {
    var rawNextValue = [
        date1,
        date2
    ].sort(function(a, b) {
        return a - b;
    });
    return [
        $f0256d0d4f3b1098$export$700a64ae37cbc741(rangeType, rawNextValue[0]),
        $f0256d0d4f3b1098$export$946298ccd438a697(rangeType, rawNextValue[1])
    ];
}
function $f0256d0d4f3b1098$var$toYearLabel(locale) {
    var formatYear = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : (0, $5398151a7800b344$export$2979e79cc7cbf15b);
    var dates = arguments.length > 2 ? arguments[2] : undefined;
    return dates.map(function(date) {
        return formatYear(locale, date);
    }).join(" \u2013 ");
}
function $f0256d0d4f3b1098$export$a05bb87f2c518835(locale, formatYear, date) {
    return $f0256d0d4f3b1098$var$toYearLabel(locale, formatYear, (0, $78fdc7949801ab2a$export$a4332dc3f9de051f)(date));
}
function $f0256d0d4f3b1098$export$2e69ef6076209750(locale, formatYear, date) {
    return $f0256d0d4f3b1098$var$toYearLabel(locale, formatYear, (0, $78fdc7949801ab2a$export$35cef0a1278b17e1)(date));
}
function $f0256d0d4f3b1098$export$618d60ea299da42(date) {
    var calendarType = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : (0, $6ede4d444f78ee44$export$26fa441040070c35).ISO_8601;
    var weekday = date.getDay();
    switch(calendarType){
        case (0, $6ede4d444f78ee44$export$26fa441040070c35).ARABIC:
        case (0, $6ede4d444f78ee44$export$26fa441040070c35).HEBREW:
            return weekday === $f0256d0d4f3b1098$var$FRIDAY || weekday === $f0256d0d4f3b1098$var$SATURDAY;
        case (0, $6ede4d444f78ee44$export$26fa441040070c35).ISO_8601:
        case (0, $6ede4d444f78ee44$export$26fa441040070c35).US:
            return weekday === $f0256d0d4f3b1098$var$SATURDAY || weekday === $f0256d0d4f3b1098$var$SUNDAY;
        default:
            throw new Error("Unsupported calendar type.");
    }
}




var $c9Z8w = parcelRequire("c9Z8w");

function $42f0853312470faa$var$_typeof(obj) {
    "@babel/helpers - typeof";
    return $42f0853312470faa$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, $42f0853312470faa$var$_typeof(obj);
}
var $42f0853312470faa$var$calendarTypes = Object.values((0, $6ede4d444f78ee44$export$26fa441040070c35));
var $42f0853312470faa$var$allViews = [
    "century",
    "decade",
    "year",
    "month"
];
var $42f0853312470faa$export$9780328ce60eac34 = (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOf($42f0853312470faa$var$calendarTypes);
var $42f0853312470faa$export$d53f3db2f43345df = (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOfType([
    (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
    (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string)
]);
var $42f0853312470faa$export$283839a53860a2f5 = function isMinDate(props, propName, componentName) {
    var minDate = props[propName];
    if (!minDate) return null;
    if (!(minDate instanceof Date)) return new Error("Invalid prop `".concat(propName, "` of type `").concat($42f0853312470faa$var$_typeof(minDate), "` supplied to `").concat(componentName, "`, expected instance of `Date`."));
    var maxDate = props.maxDate;
    if (maxDate && minDate > maxDate) return new Error("Invalid prop `".concat(propName, "` of type `").concat($42f0853312470faa$var$_typeof(minDate), "` supplied to `").concat(componentName, "`, minDate cannot be larger than maxDate."));
    return null;
};
var $42f0853312470faa$export$20075fd45e42d41c = function isMaxDate(props, propName, componentName) {
    var maxDate = props[propName];
    if (!maxDate) return null;
    if (!(maxDate instanceof Date)) return new Error("Invalid prop `".concat(propName, "` of type `").concat($42f0853312470faa$var$_typeof(maxDate), "` supplied to `").concat(componentName, "`, expected instance of `Date`."));
    var minDate = props.minDate;
    if (minDate && maxDate < minDate) return new Error("Invalid prop `".concat(propName, "` of type `").concat($42f0853312470faa$var$_typeof(maxDate), "` supplied to `").concat(componentName, "`, maxDate cannot be smaller than minDate."));
    return null;
};
var $42f0853312470faa$export$4f9f5282de18fc69 = (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOfType([
    (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
    (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).shape({
        current: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).any
    })
]);
var $42f0853312470faa$export$2fb7a00a48619649 = (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOfType([
    (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).instanceOf(Date),
    (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).instanceOf(Date))
]);
var $42f0853312470faa$export$bf6a8a97c2633c68 = (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOf($42f0853312470faa$var$allViews));
var $42f0853312470faa$export$7c1393839656cd16 = function isView(props, propName, componentName) {
    var view = props[propName];
    var views = props.views;
    var allowedViews = views || $42f0853312470faa$var$allViews;
    if (view !== undefined && allowedViews.indexOf(view) === -1) return new Error("Invalid prop `".concat(propName, "` of value `").concat(view, "` supplied to `").concat(componentName, "`, expected one of [").concat(allowedViews.map(function(a) {
        return '"'.concat(a, '"');
    }).join(", "), "]."));
     // Everything is fine
    return null;
};
$42f0853312470faa$export$7c1393839656cd16.isRequired = function(props, propName, componentName) {
    var view = props[propName];
    if (!view) return new Error("The prop `".concat(propName, "` is marked as required in `").concat(componentName, "`, but its value is `").concat(view, "`."));
    return $42f0853312470faa$export$7c1393839656cd16(props, propName, componentName);
};
var $42f0853312470faa$export$61cce6a131f71246 = {
    activeStartDate: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).instanceOf(Date).isRequired,
    hover: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).instanceOf(Date),
    locale: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
    maxDate: $42f0853312470faa$export$20075fd45e42d41c,
    minDate: $42f0853312470faa$export$283839a53860a2f5,
    onClick: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
    onMouseOver: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
    tileClassName: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
        $42f0853312470faa$export$d53f3db2f43345df
    ]),
    tileContent: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).node
    ]),
    value: $42f0853312470faa$export$2fb7a00a48619649,
    valueType: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string
};
var $42f0853312470faa$export$8571f7299c7936ad = {
    activeStartDate: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).instanceOf(Date).isRequired,
    classes: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string).isRequired,
    date: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).instanceOf(Date).isRequired,
    locale: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
    maxDate: $42f0853312470faa$export$20075fd45e42d41c,
    minDate: $42f0853312470faa$export$283839a53860a2f5,
    onClick: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
    onMouseOver: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
    style: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).objectOf((0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).number
    ])),
    tileClassName: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
        $42f0853312470faa$export$d53f3db2f43345df
    ]),
    tileContent: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).node
    ]),
    tileDisabled: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func
};


var $cfbfa00fe9577c18$var$className = "react-calendar__navigation";
function $cfbfa00fe9577c18$export$2e2bcd8739ae039(_ref) {
    var activeStartDate = _ref.activeStartDate, drillUp = _ref.drillUp, _ref$formatMonthYear = _ref.formatMonthYear, formatMonthYear = _ref$formatMonthYear === void 0 ? (0, $5398151a7800b344$export$18f8ccbe37e54acd) : _ref$formatMonthYear, _ref$formatYear = _ref.formatYear, formatYear = _ref$formatYear === void 0 ? (0, $5398151a7800b344$export$2979e79cc7cbf15b) : _ref$formatYear, locale = _ref.locale, maxDate = _ref.maxDate, minDate = _ref.minDate, _ref$navigationAriaLa = _ref.navigationAriaLabel, navigationAriaLabel = _ref$navigationAriaLa === void 0 ? "" : _ref$navigationAriaLa, navigationAriaLive = _ref.navigationAriaLive, navigationLabel = _ref.navigationLabel, _ref$next2AriaLabel = _ref.next2AriaLabel, next2AriaLabel = _ref$next2AriaLabel === void 0 ? "" : _ref$next2AriaLabel, _ref$next2Label = _ref.next2Label, next2Label = _ref$next2Label === void 0 ? "\xbb" : _ref$next2Label, _ref$nextAriaLabel = _ref.nextAriaLabel, nextAriaLabel = _ref$nextAriaLabel === void 0 ? "" : _ref$nextAriaLabel, _ref$nextLabel = _ref.nextLabel, nextLabel = _ref$nextLabel === void 0 ? "\u203A" : _ref$nextLabel, _ref$prev2AriaLabel = _ref.prev2AriaLabel, prev2AriaLabel = _ref$prev2AriaLabel === void 0 ? "" : _ref$prev2AriaLabel, _ref$prev2Label = _ref.prev2Label, prev2Label = _ref$prev2Label === void 0 ? "\xab" : _ref$prev2Label, _ref$prevAriaLabel = _ref.prevAriaLabel, prevAriaLabel = _ref$prevAriaLabel === void 0 ? "" : _ref$prevAriaLabel, _ref$prevLabel = _ref.prevLabel, prevLabel = _ref$prevLabel === void 0 ? "\u2039" : _ref$prevLabel, setActiveStartDate = _ref.setActiveStartDate, showDoubleView = _ref.showDoubleView, view = _ref.view, views = _ref.views;
    var drillUpAvailable = views.indexOf(view) > 0;
    var shouldShowPrevNext2Buttons = view !== "century";
    var previousActiveStartDate = (0, $f0256d0d4f3b1098$export$fac7f4c8b12617ff)(view, activeStartDate);
    var previousActiveStartDate2 = shouldShowPrevNext2Buttons && (0, $f0256d0d4f3b1098$export$b514bf5935bed2bf)(view, activeStartDate);
    var nextActiveStartDate = (0, $f0256d0d4f3b1098$export$19193c1f2d841d47)(view, activeStartDate);
    var nextActiveStartDate2 = shouldShowPrevNext2Buttons && (0, $f0256d0d4f3b1098$export$2805b7ce8402b644)(view, activeStartDate);
    var prevButtonDisabled = function() {
        if (previousActiveStartDate.getFullYear() < 0) return true;
        var previousActiveEndDate = (0, $f0256d0d4f3b1098$export$3030eb755e02a078)(view, activeStartDate);
        return minDate && minDate >= previousActiveEndDate;
    }();
    var prev2ButtonDisabled = shouldShowPrevNext2Buttons && function() {
        if (previousActiveStartDate2.getFullYear() < 0) return true;
        var previousActiveEndDate = (0, $f0256d0d4f3b1098$export$d34b1dc45bd5f1d3)(view, activeStartDate);
        return minDate && minDate >= previousActiveEndDate;
    }();
    var nextButtonDisabled = maxDate && maxDate < nextActiveStartDate;
    var next2ButtonDisabled = shouldShowPrevNext2Buttons && maxDate && maxDate < nextActiveStartDate2;
    function onClickPrevious() {
        setActiveStartDate(previousActiveStartDate, "prev");
    }
    function onClickPrevious2() {
        setActiveStartDate(previousActiveStartDate2, "prev2");
    }
    function onClickNext() {
        setActiveStartDate(nextActiveStartDate, "next");
    }
    function onClickNext2() {
        setActiveStartDate(nextActiveStartDate2, "next2");
    }
    function renderLabel(date) {
        var label = function() {
            switch(view){
                case "century":
                    return (0, $f0256d0d4f3b1098$export$a05bb87f2c518835)(locale, formatYear, date);
                case "decade":
                    return (0, $f0256d0d4f3b1098$export$2e69ef6076209750)(locale, formatYear, date);
                case "year":
                    return formatYear(locale, date);
                case "month":
                    return formatMonthYear(locale, date);
                default:
                    throw new Error("Invalid view: ".concat(view, "."));
            }
        }();
        return navigationLabel ? navigationLabel({
            date: date,
            label: label,
            locale: locale || (0, $3cee2524baeacc16$export$a6ea185b366483aa)(),
            view: view
        }) : label;
    }
    function renderButton() {
        var labelClassName = "".concat($cfbfa00fe9577c18$var$className, "__label");
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("button", {
            "aria-label": navigationAriaLabel,
            "aria-live": navigationAriaLive,
            className: labelClassName,
            disabled: !drillUpAvailable,
            onClick: drillUp,
            style: {
                flexGrow: 1
            },
            type: "button"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            className: "".concat(labelClassName, "__labelText ").concat(labelClassName, "__labelText--from")
        }, renderLabel(activeStartDate)), showDoubleView && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            className: "".concat(labelClassName, "__divider")
        }, " \u2013 "), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            className: "".concat(labelClassName, "__labelText ").concat(labelClassName, "__labelText--to")
        }, renderLabel(nextActiveStartDate))));
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: $cfbfa00fe9577c18$var$className
    }, prev2Label !== null && shouldShowPrevNext2Buttons && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("button", {
        "aria-label": prev2AriaLabel,
        className: "".concat($cfbfa00fe9577c18$var$className, "__arrow ").concat($cfbfa00fe9577c18$var$className, "__prev2-button"),
        disabled: prev2ButtonDisabled,
        onClick: onClickPrevious2,
        type: "button"
    }, prev2Label), prevLabel !== null && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("button", {
        "aria-label": prevAriaLabel,
        className: "".concat($cfbfa00fe9577c18$var$className, "__arrow ").concat($cfbfa00fe9577c18$var$className, "__prev-button"),
        disabled: prevButtonDisabled,
        onClick: onClickPrevious,
        type: "button"
    }, prevLabel), renderButton(), nextLabel !== null && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("button", {
        "aria-label": nextAriaLabel,
        className: "".concat($cfbfa00fe9577c18$var$className, "__arrow ").concat($cfbfa00fe9577c18$var$className, "__next-button"),
        disabled: nextButtonDisabled,
        onClick: onClickNext,
        type: "button"
    }, nextLabel), next2Label !== null && shouldShowPrevNext2Buttons && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("button", {
        "aria-label": next2AriaLabel,
        className: "".concat($cfbfa00fe9577c18$var$className, "__arrow ").concat($cfbfa00fe9577c18$var$className, "__next2-button"),
        disabled: next2ButtonDisabled,
        onClick: onClickNext2,
        type: "button"
    }, next2Label));
}
$cfbfa00fe9577c18$export$2e2bcd8739ae039.propTypes = {
    activeStartDate: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).instanceOf(Date).isRequired,
    drillUp: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func.isRequired,
    formatMonthYear: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
    formatYear: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
    locale: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
    maxDate: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).instanceOf(Date),
    minDate: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).instanceOf(Date),
    navigationAriaLabel: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
    navigationAriaLive: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
    navigationLabel: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
    next2AriaLabel: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
    next2Label: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).node,
    nextAriaLabel: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
    nextLabel: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).node,
    prev2AriaLabel: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
    prev2Label: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).node,
    prevAriaLabel: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
    prevLabel: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).node,
    setActiveStartDate: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func.isRequired,
    showDoubleView: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    view: (0, $42f0853312470faa$export$7c1393839656cd16).isRequired,
    views: (0, $42f0853312470faa$export$bf6a8a97c2633c68).isRequired
};



var $acw62 = parcelRequire("acw62");

var $acw62 = parcelRequire("acw62");


var $acw62 = parcelRequire("acw62");

var $c9Z8w = parcelRequire("c9Z8w");

var $acw62 = parcelRequire("acw62");

var $c9Z8w = parcelRequire("c9Z8w");
var $19228e875a5c8531$var$_excluded = [
    "children",
    "className",
    "direction",
    "count",
    "offset",
    "style",
    "wrap"
];
function $19228e875a5c8531$var$_extends() {
    $19228e875a5c8531$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $19228e875a5c8531$var$_extends.apply(this, arguments);
}
function $19228e875a5c8531$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $19228e875a5c8531$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $19228e875a5c8531$var$ownKeys(Object(source), !0).forEach(function(key) {
            $19228e875a5c8531$var$_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $19228e875a5c8531$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $19228e875a5c8531$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $19228e875a5c8531$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $19228e875a5c8531$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $19228e875a5c8531$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $19228e875a5c8531$var$toPercent(num) {
    return "".concat(num, "%");
}
function $19228e875a5c8531$export$2e2bcd8739ae039(_ref) {
    var children = _ref.children, className = _ref.className, direction = _ref.direction, count = _ref.count, offset = _ref.offset, style = _ref.style, wrap = _ref.wrap, otherProps = $19228e875a5c8531$var$_objectWithoutProperties(_ref, $19228e875a5c8531$var$_excluded);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", $19228e875a5c8531$var$_extends({
        className: className,
        style: $19228e875a5c8531$var$_objectSpread({
            display: "flex",
            flexDirection: direction,
            flexWrap: wrap ? "wrap" : "no-wrap"
        }, style)
    }, otherProps), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Children.map(children, function(child, index) {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).cloneElement(child, $19228e875a5c8531$var$_objectSpread($19228e875a5c8531$var$_objectSpread({}, child.props), {}, {
            style: {
                flexBasis: $19228e875a5c8531$var$toPercent(100 / count),
                flexShrink: 0,
                flexGrow: 0,
                overflow: "hidden",
                marginLeft: offset && index === 0 ? $19228e875a5c8531$var$toPercent(100 * offset / count) : null
            }
        }));
    }));
}
$19228e875a5c8531$export$2e2bcd8739ae039.propTypes = {
    children: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).node,
    className: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
    count: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).number.isRequired,
    direction: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
    offset: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).number,
    style: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).objectOf((0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).number
    ])),
    wrap: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool
};



function $31b103f03d6f0116$var$_toConsumableArray(arr) {
    return $31b103f03d6f0116$var$_arrayWithoutHoles(arr) || $31b103f03d6f0116$var$_iterableToArray(arr) || $31b103f03d6f0116$var$_unsupportedIterableToArray(arr) || $31b103f03d6f0116$var$_nonIterableSpread();
}
function $31b103f03d6f0116$var$_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $31b103f03d6f0116$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $31b103f03d6f0116$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $31b103f03d6f0116$var$_arrayLikeToArray(o, minLen);
}
function $31b103f03d6f0116$var$_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function $31b103f03d6f0116$var$_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return $31b103f03d6f0116$var$_arrayLikeToArray(arr);
}
function $31b103f03d6f0116$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $31b103f03d6f0116$export$cf95c51b03f10bae(value, min, max) {
    if (min && min > value) return min;
    if (max && max < value) return max;
    return value;
}
function $31b103f03d6f0116$export$7c4e06fee2f75722(value, range) {
    return range[0] <= value && range[1] >= value;
}
function $31b103f03d6f0116$export$eecb2aa703319c46(greaterRange, smallerRange) {
    return greaterRange[0] <= smallerRange[0] && greaterRange[1] >= smallerRange[1];
}
function $31b103f03d6f0116$export$2e215bb7f5401ba1(range1, range2) {
    return $31b103f03d6f0116$export$7c4e06fee2f75722(range1[0], range2) || $31b103f03d6f0116$export$7c4e06fee2f75722(range1[1], range2);
}
function $31b103f03d6f0116$var$getRangeClassNames(valueRange, dateRange, baseClassName) {
    var isRange = $31b103f03d6f0116$export$2e215bb7f5401ba1(dateRange, valueRange);
    var classes = [];
    if (isRange) {
        classes.push(baseClassName);
        var isRangeStart = $31b103f03d6f0116$export$7c4e06fee2f75722(valueRange[0], dateRange);
        var isRangeEnd = $31b103f03d6f0116$export$7c4e06fee2f75722(valueRange[1], dateRange);
        if (isRangeStart) classes.push("".concat(baseClassName, "Start"));
        if (isRangeEnd) classes.push("".concat(baseClassName, "End"));
        if (isRangeStart && isRangeEnd) classes.push("".concat(baseClassName, "BothEnds"));
    }
    return classes;
}
function $31b103f03d6f0116$export$8b25b190354ee282() {
    var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {}, value = _ref.value, valueType = _ref.valueType, date = _ref.date, dateType = _ref.dateType, hover = _ref.hover;
    var className = "react-calendar__tile";
    var classes = [
        className
    ];
    if (!date) return classes;
    if (!Array.isArray(date) && !dateType) throw new Error("getTileClasses(): Unable to get tile activity classes because one or more required arguments were not passed.");
    var now = new Date();
    var dateRange = Array.isArray(date) ? date : (0, $f0256d0d4f3b1098$export$fef151b94550e9f5)(dateType, date);
    if ($31b103f03d6f0116$export$7c4e06fee2f75722(now, dateRange)) classes.push("".concat(className, "--now"));
    if (!value) return classes;
    if (!Array.isArray(value) && !valueType) throw new Error("getTileClasses(): Unable to get tile activity classes because one or more required arguments were not passed.");
    var valueRange = Array.isArray(value) ? value : (0, $f0256d0d4f3b1098$export$fef151b94550e9f5)(valueType, value);
    if ($31b103f03d6f0116$export$eecb2aa703319c46(valueRange, dateRange)) classes.push("".concat(className, "--active"));
    else if ($31b103f03d6f0116$export$2e215bb7f5401ba1(valueRange, dateRange)) classes.push("".concat(className, "--hasActive"));
    var valueRangeClassNames = $31b103f03d6f0116$var$getRangeClassNames(valueRange, dateRange, "".concat(className, "--range"));
    classes.push.apply(classes, $31b103f03d6f0116$var$_toConsumableArray(valueRangeClassNames));
    var valueArray = [].concat(value);
    if (hover && valueArray.length === 1) {
        var hoverRange = hover > valueRange[0] ? [
            valueRange[0],
            hover
        ] : [
            hover,
            valueRange[0]
        ];
        var hoverRangeClassNames = $31b103f03d6f0116$var$getRangeClassNames(hoverRange, dateRange, "".concat(className, "--hover"));
        classes.push.apply(classes, $31b103f03d6f0116$var$_toConsumableArray(hoverRangeClassNames));
    }
    return classes;
}



var $89388808b0fcfc7d$var$_excluded = [
    "className",
    "count",
    "dateTransform",
    "dateType",
    "end",
    "hover",
    "offset",
    "start",
    "step",
    "tile",
    "value",
    "valueType"
];
function $89388808b0fcfc7d$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $89388808b0fcfc7d$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $89388808b0fcfc7d$var$ownKeys(Object(source), !0).forEach(function(key) {
            $89388808b0fcfc7d$var$_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $89388808b0fcfc7d$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $89388808b0fcfc7d$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $89388808b0fcfc7d$var$_extends() {
    $89388808b0fcfc7d$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $89388808b0fcfc7d$var$_extends.apply(this, arguments);
}
function $89388808b0fcfc7d$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $89388808b0fcfc7d$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $89388808b0fcfc7d$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $89388808b0fcfc7d$export$2e2bcd8739ae039(_ref) {
    var className = _ref.className, _ref$count = _ref.count, count = _ref$count === void 0 ? 3 : _ref$count, dateTransform = _ref.dateTransform, dateType = _ref.dateType, end = _ref.end, hover = _ref.hover, offset = _ref.offset, start = _ref.start, _ref$step = _ref.step, step = _ref$step === void 0 ? 1 : _ref$step, Tile = _ref.tile, value = _ref.value, valueType = _ref.valueType, tileProps = $89388808b0fcfc7d$var$_objectWithoutProperties(_ref, $89388808b0fcfc7d$var$_excluded);
    var tiles = [];
    for(var point = start; point <= end; point += step){
        var date = dateTransform(point);
        tiles.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(Tile, $89388808b0fcfc7d$var$_extends({
            key: date.getTime(),
            classes: (0, $31b103f03d6f0116$export$8b25b190354ee282)({
                value: value,
                valueType: valueType,
                date: date,
                dateType: dateType,
                hover: hover
            }),
            date: date,
            point: point
        }, tileProps)));
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $19228e875a5c8531$export$2e2bcd8739ae039), {
        className: className,
        count: count,
        offset: offset,
        wrap: true
    }, tiles);
}
$89388808b0fcfc7d$export$2e2bcd8739ae039.propTypes = $89388808b0fcfc7d$var$_objectSpread($89388808b0fcfc7d$var$_objectSpread({}, (0, $42f0853312470faa$export$61cce6a131f71246)), {}, {
    activeStartDate: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).instanceOf(Date),
    count: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).number,
    dateTransform: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func.isRequired,
    dateType: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
    offset: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).number,
    step: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).number,
    tile: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func.isRequired
});



var $acw62 = parcelRequire("acw62");

var $c9Z8w = parcelRequire("c9Z8w");


var $acw62 = parcelRequire("acw62");

var $c9Z8w = parcelRequire("c9Z8w");


function $96d05e9cc89df7f5$var$_typeof(obj) {
    "@babel/helpers - typeof";
    return $96d05e9cc89df7f5$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, $96d05e9cc89df7f5$var$_typeof(obj);
}
function $96d05e9cc89df7f5$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $96d05e9cc89df7f5$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $96d05e9cc89df7f5$var$ownKeys(Object(source), !0).forEach(function(key) {
            $96d05e9cc89df7f5$var$_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $96d05e9cc89df7f5$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $96d05e9cc89df7f5$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $96d05e9cc89df7f5$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $96d05e9cc89df7f5$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $96d05e9cc89df7f5$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $96d05e9cc89df7f5$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function $96d05e9cc89df7f5$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    Object.defineProperty(subClass, "prototype", {
        writable: false
    });
    if (superClass) $96d05e9cc89df7f5$var$_setPrototypeOf(subClass, superClass);
}
function $96d05e9cc89df7f5$var$_setPrototypeOf(o, p) {
    $96d05e9cc89df7f5$var$_setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $96d05e9cc89df7f5$var$_setPrototypeOf(o, p);
}
function $96d05e9cc89df7f5$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $96d05e9cc89df7f5$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = $96d05e9cc89df7f5$var$_getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = $96d05e9cc89df7f5$var$_getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return $96d05e9cc89df7f5$var$_possibleConstructorReturn(this, result);
    };
}
function $96d05e9cc89df7f5$var$_possibleConstructorReturn(self, call) {
    if (call && ($96d05e9cc89df7f5$var$_typeof(call) === "object" || typeof call === "function")) return call;
    else if (call !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
    return $96d05e9cc89df7f5$var$_assertThisInitialized(self);
}
function $96d05e9cc89df7f5$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $96d05e9cc89df7f5$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function $96d05e9cc89df7f5$var$_getPrototypeOf(o) {
    $96d05e9cc89df7f5$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $96d05e9cc89df7f5$var$_getPrototypeOf(o);
}
function $96d05e9cc89df7f5$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $96d05e9cc89df7f5$var$datesAreDifferent(date1, date2) {
    return date1 && !date2 || !date1 && date2 || date1 && date2 && date1.getTime() !== date2.getTime();
}
function $96d05e9cc89df7f5$var$getValue(nextProps, prop) {
    var activeStartDate = nextProps.activeStartDate, date = nextProps.date, view = nextProps.view;
    return typeof prop === "function" ? prop({
        activeStartDate: activeStartDate,
        date: date,
        view: view
    }) : prop;
}
var $96d05e9cc89df7f5$export$2e2bcd8739ae039 = /*#__PURE__*/ function(_Component) {
    $96d05e9cc89df7f5$var$_inherits(Tile, _Component);
    var _super = $96d05e9cc89df7f5$var$_createSuper(Tile);
    function Tile() {
        var _this;
        $96d05e9cc89df7f5$var$_classCallCheck(this, Tile);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        $96d05e9cc89df7f5$var$_defineProperty($96d05e9cc89df7f5$var$_assertThisInitialized(_this), "state", {});
        return _this;
    }
    $96d05e9cc89df7f5$var$_createClass(Tile, [
        {
            key: "render",
            value: function render() {
                var _this$props = this.props, activeStartDate = _this$props.activeStartDate, children = _this$props.children, classes = _this$props.classes, date = _this$props.date, formatAbbr = _this$props.formatAbbr, locale = _this$props.locale, maxDate = _this$props.maxDate, maxDateTransform = _this$props.maxDateTransform, minDate = _this$props.minDate, minDateTransform = _this$props.minDateTransform, onClick = _this$props.onClick, onMouseOver = _this$props.onMouseOver, style = _this$props.style, tileDisabled = _this$props.tileDisabled, view = _this$props.view;
                var _this$state = this.state, tileClassName = _this$state.tileClassName, tileContent = _this$state.tileContent;
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("button", {
                    className: (0, $0a37892229a7559c$export$2e2bcd8739ae039)(classes, tileClassName),
                    disabled: minDate && minDateTransform(minDate) > date || maxDate && maxDateTransform(maxDate) < date || tileDisabled && tileDisabled({
                        activeStartDate: activeStartDate,
                        date: date,
                        view: view
                    }),
                    onClick: onClick && function(event) {
                        return onClick(date, event);
                    },
                    onFocus: onMouseOver && function() {
                        return onMouseOver(date);
                    },
                    onMouseOver: onMouseOver && function() {
                        return onMouseOver(date);
                    },
                    style: style,
                    type: "button"
                }, formatAbbr ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("abbr", {
                    "aria-label": formatAbbr(locale, date)
                }, children) : children, tileContent);
            }
        }
    ], [
        {
            key: "getDerivedStateFromProps",
            value: function getDerivedStateFromProps(nextProps, prevState) {
                var activeStartDate = nextProps.activeStartDate, tileClassName = nextProps.tileClassName, tileContent = nextProps.tileContent;
                var nextState = {};
                if (tileClassName !== prevState.tileClassNameProps || $96d05e9cc89df7f5$var$datesAreDifferent(activeStartDate, prevState.activeStartDateProps)) {
                    nextState.tileClassName = $96d05e9cc89df7f5$var$getValue(nextProps, tileClassName);
                    nextState.tileClassNameProps = tileClassName;
                }
                if (tileContent !== prevState.tileContentProps || $96d05e9cc89df7f5$var$datesAreDifferent(activeStartDate, prevState.activeStartDateProps)) {
                    nextState.tileContent = $96d05e9cc89df7f5$var$getValue(nextProps, tileContent);
                    nextState.tileContentProps = tileContent;
                }
                nextState.activeStartDateProps = activeStartDate;
                return nextState;
            }
        }
    ]);
    return Tile;
}((0, $acw62.Component));
$96d05e9cc89df7f5$export$2e2bcd8739ae039.propTypes = $96d05e9cc89df7f5$var$_objectSpread($96d05e9cc89df7f5$var$_objectSpread({}, (0, $42f0853312470faa$export$8571f7299c7936ad)), {}, {
    children: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).node.isRequired,
    formatAbbr: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
    maxDateTransform: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func.isRequired,
    minDateTransform: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func.isRequired
});





var $a4987d626034a3cd$var$_excluded = [
    "classes",
    "formatYear"
];
function $a4987d626034a3cd$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $a4987d626034a3cd$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $a4987d626034a3cd$var$ownKeys(Object(source), !0).forEach(function(key) {
            $a4987d626034a3cd$var$_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $a4987d626034a3cd$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $a4987d626034a3cd$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $a4987d626034a3cd$var$_extends() {
    $a4987d626034a3cd$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $a4987d626034a3cd$var$_extends.apply(this, arguments);
}
function $a4987d626034a3cd$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $a4987d626034a3cd$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $a4987d626034a3cd$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var $a4987d626034a3cd$var$className = "react-calendar__century-view__decades__decade";
function $a4987d626034a3cd$export$2e2bcd8739ae039(_ref) {
    var classes = _ref.classes, _ref$formatYear = _ref.formatYear, formatYear = _ref$formatYear === void 0 ? (0, $5398151a7800b344$export$2979e79cc7cbf15b) : _ref$formatYear, otherProps = $a4987d626034a3cd$var$_objectWithoutProperties(_ref, $a4987d626034a3cd$var$_excluded);
    var date = otherProps.date, locale = otherProps.locale;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $96d05e9cc89df7f5$export$2e2bcd8739ae039), $a4987d626034a3cd$var$_extends({}, otherProps, {
        classes: [].concat(classes, $a4987d626034a3cd$var$className),
        maxDateTransform: (0, $78fdc7949801ab2a$export$aa0bfba5bfc33956),
        minDateTransform: (0, $78fdc7949801ab2a$export$8bb35b885d308e78),
        view: "century"
    }), (0, $f0256d0d4f3b1098$export$2e69ef6076209750)(locale, formatYear, date));
}
$a4987d626034a3cd$export$2e2bcd8739ae039.propTypes = $a4987d626034a3cd$var$_objectSpread($a4987d626034a3cd$var$_objectSpread({}, (0, $42f0853312470faa$export$8571f7299c7936ad)), {}, {
    formatYear: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func
});




function $ddd6edd34bb52616$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $ddd6edd34bb52616$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $ddd6edd34bb52616$var$ownKeys(Object(source), !0).forEach(function(key) {
            $ddd6edd34bb52616$var$_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $ddd6edd34bb52616$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $ddd6edd34bb52616$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $ddd6edd34bb52616$var$_extends() {
    $ddd6edd34bb52616$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $ddd6edd34bb52616$var$_extends.apply(this, arguments);
}
function $ddd6edd34bb52616$export$2e2bcd8739ae039(props) {
    var activeStartDate = props.activeStartDate;
    var start = (0, $f0256d0d4f3b1098$export$5fc0cc931278f768)(activeStartDate);
    var end = start + 99;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $89388808b0fcfc7d$export$2e2bcd8739ae039), $ddd6edd34bb52616$var$_extends({}, props, {
        className: "react-calendar__century-view__decades",
        dateTransform: (0, $78fdc7949801ab2a$export$8bb35b885d308e78),
        dateType: "decade",
        end: end,
        start: start,
        step: 10,
        tile: (0, $a4987d626034a3cd$export$2e2bcd8739ae039)
    }));
}
$ddd6edd34bb52616$export$2e2bcd8739ae039.propTypes = $ddd6edd34bb52616$var$_objectSpread({}, (0, $42f0853312470faa$export$61cce6a131f71246));


function $69d85f028a6b153b$export$2e2bcd8739ae039(props) {
    function renderDecades() {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $ddd6edd34bb52616$export$2e2bcd8739ae039), props);
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: "react-calendar__century-view"
    }, renderDecades());
}



var $acw62 = parcelRequire("acw62");

var $acw62 = parcelRequire("acw62");


var $acw62 = parcelRequire("acw62");

var $c9Z8w = parcelRequire("c9Z8w");




var $c225ef028b1ac835$var$_excluded = [
    "classes",
    "formatYear"
];
function $c225ef028b1ac835$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $c225ef028b1ac835$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $c225ef028b1ac835$var$ownKeys(Object(source), !0).forEach(function(key) {
            $c225ef028b1ac835$var$_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $c225ef028b1ac835$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $c225ef028b1ac835$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $c225ef028b1ac835$var$_extends() {
    $c225ef028b1ac835$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $c225ef028b1ac835$var$_extends.apply(this, arguments);
}
function $c225ef028b1ac835$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $c225ef028b1ac835$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $c225ef028b1ac835$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var $c225ef028b1ac835$var$className = "react-calendar__decade-view__years__year";
function $c225ef028b1ac835$export$2e2bcd8739ae039(_ref) {
    var classes = _ref.classes, _ref$formatYear = _ref.formatYear, formatYear = _ref$formatYear === void 0 ? (0, $5398151a7800b344$export$2979e79cc7cbf15b) : _ref$formatYear, otherProps = $c225ef028b1ac835$var$_objectWithoutProperties(_ref, $c225ef028b1ac835$var$_excluded);
    var date = otherProps.date, locale = otherProps.locale;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $96d05e9cc89df7f5$export$2e2bcd8739ae039), $c225ef028b1ac835$var$_extends({}, otherProps, {
        classes: [].concat(classes, $c225ef028b1ac835$var$className),
        maxDateTransform: (0, $78fdc7949801ab2a$export$248ddd7fb95e4a56),
        minDateTransform: (0, $78fdc7949801ab2a$export$bbcf6a6951bb3c3a),
        view: "decade"
    }), formatYear(locale, date));
}
$c225ef028b1ac835$export$2e2bcd8739ae039.propTypes = $c225ef028b1ac835$var$_objectSpread($c225ef028b1ac835$var$_objectSpread({}, (0, $42f0853312470faa$export$8571f7299c7936ad)), {}, {
    formatYear: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func
});




function $40801898d3cba4b0$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $40801898d3cba4b0$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $40801898d3cba4b0$var$ownKeys(Object(source), !0).forEach(function(key) {
            $40801898d3cba4b0$var$_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $40801898d3cba4b0$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $40801898d3cba4b0$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $40801898d3cba4b0$var$_extends() {
    $40801898d3cba4b0$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $40801898d3cba4b0$var$_extends.apply(this, arguments);
}
function $40801898d3cba4b0$export$2e2bcd8739ae039(props) {
    var activeStartDate = props.activeStartDate;
    var start = (0, $f0256d0d4f3b1098$export$59fb6e4ffa904295)(activeStartDate);
    var end = start + 9;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $89388808b0fcfc7d$export$2e2bcd8739ae039), $40801898d3cba4b0$var$_extends({}, props, {
        className: "react-calendar__decade-view__years",
        dateTransform: function dateTransform(year) {
            var date = new Date();
            date.setFullYear(year, 0, 1);
            date.setHours(0, 0, 0, 0);
            return date;
        },
        dateType: "year",
        end: end,
        start: start,
        tile: (0, $c225ef028b1ac835$export$2e2bcd8739ae039)
    }));
}
$40801898d3cba4b0$export$2e2bcd8739ae039.propTypes = $40801898d3cba4b0$var$_objectSpread({}, (0, $42f0853312470faa$export$61cce6a131f71246));


function $389ea55df3c2dae8$export$2e2bcd8739ae039(props) {
    function renderYears() {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $40801898d3cba4b0$export$2e2bcd8739ae039), props);
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: "react-calendar__decade-view"
    }, renderYears());
}



var $acw62 = parcelRequire("acw62");

var $acw62 = parcelRequire("acw62");

var $c9Z8w = parcelRequire("c9Z8w");



var $acw62 = parcelRequire("acw62");

var $c9Z8w = parcelRequire("c9Z8w");




var $3770b516c35c9a94$var$_excluded = [
    "classes",
    "formatMonth",
    "formatMonthYear"
];
function $3770b516c35c9a94$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $3770b516c35c9a94$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $3770b516c35c9a94$var$ownKeys(Object(source), !0).forEach(function(key) {
            $3770b516c35c9a94$var$_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $3770b516c35c9a94$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $3770b516c35c9a94$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $3770b516c35c9a94$var$_extends() {
    $3770b516c35c9a94$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $3770b516c35c9a94$var$_extends.apply(this, arguments);
}
function $3770b516c35c9a94$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $3770b516c35c9a94$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $3770b516c35c9a94$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var $3770b516c35c9a94$var$className = "react-calendar__year-view__months__month";
function $3770b516c35c9a94$export$2e2bcd8739ae039(_ref) {
    var classes = _ref.classes, _ref$formatMonth = _ref.formatMonth, formatMonth = _ref$formatMonth === void 0 ? (0, $5398151a7800b344$export$d0536c8e7f45796e) : _ref$formatMonth, _ref$formatMonthYear = _ref.formatMonthYear, formatMonthYear = _ref$formatMonthYear === void 0 ? (0, $5398151a7800b344$export$18f8ccbe37e54acd) : _ref$formatMonthYear, otherProps = $3770b516c35c9a94$var$_objectWithoutProperties(_ref, $3770b516c35c9a94$var$_excluded);
    var date = otherProps.date, locale = otherProps.locale;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $96d05e9cc89df7f5$export$2e2bcd8739ae039), $3770b516c35c9a94$var$_extends({}, otherProps, {
        classes: [].concat(classes, $3770b516c35c9a94$var$className),
        formatAbbr: formatMonthYear,
        maxDateTransform: (0, $78fdc7949801ab2a$export$6f306f93ccbcd612),
        minDateTransform: (0, $78fdc7949801ab2a$export$c7002b157c9b9e95),
        view: "year"
    }), formatMonth(locale, date));
}
$3770b516c35c9a94$export$2e2bcd8739ae039.propTypes = $3770b516c35c9a94$var$_objectSpread($3770b516c35c9a94$var$_objectSpread({}, (0, $42f0853312470faa$export$8571f7299c7936ad)), {}, {
    formatMonth: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
    formatMonthYear: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func
});



function $fe4d2a338d069e69$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $fe4d2a338d069e69$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $fe4d2a338d069e69$var$ownKeys(Object(source), !0).forEach(function(key) {
            $fe4d2a338d069e69$var$_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $fe4d2a338d069e69$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $fe4d2a338d069e69$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $fe4d2a338d069e69$var$_extends() {
    $fe4d2a338d069e69$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $fe4d2a338d069e69$var$_extends.apply(this, arguments);
}
function $fe4d2a338d069e69$export$2e2bcd8739ae039(props) {
    var activeStartDate = props.activeStartDate;
    var start = 0;
    var end = 11;
    var year = (0, $78fdc7949801ab2a$export$5846dc2d57a5c860)(activeStartDate);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $89388808b0fcfc7d$export$2e2bcd8739ae039), $fe4d2a338d069e69$var$_extends({}, props, {
        className: "react-calendar__year-view__months",
        dateTransform: function dateTransform(monthIndex) {
            var date = new Date();
            date.setFullYear(year, monthIndex, 1);
            date.setHours(0, 0, 0, 0);
            return date;
        },
        dateType: "month",
        end: end,
        start: start,
        tile: (0, $3770b516c35c9a94$export$2e2bcd8739ae039)
    }));
}
$fe4d2a338d069e69$export$2e2bcd8739ae039.propTypes = $fe4d2a338d069e69$var$_objectSpread($fe4d2a338d069e69$var$_objectSpread({}, (0, $42f0853312470faa$export$61cce6a131f71246)), {}, {
    locale: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string
});


function $f9aea9fc51f771c2$export$2e2bcd8739ae039(props) {
    function renderMonths() {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $fe4d2a338d069e69$export$2e2bcd8739ae039), props);
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: "react-calendar__year-view"
    }, renderMonths());
}



var $acw62 = parcelRequire("acw62");

var $c9Z8w = parcelRequire("c9Z8w");


var $acw62 = parcelRequire("acw62");

var $c9Z8w = parcelRequire("c9Z8w");



var $acw62 = parcelRequire("acw62");

var $c9Z8w = parcelRequire("c9Z8w");





var $539df20092d410b7$var$_excluded = [
    "formatDay",
    "formatLongDate",
    "calendarType",
    "classes",
    "currentMonthIndex"
];
function $539df20092d410b7$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $539df20092d410b7$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $539df20092d410b7$var$ownKeys(Object(source), !0).forEach(function(key) {
            $539df20092d410b7$var$_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $539df20092d410b7$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $539df20092d410b7$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $539df20092d410b7$var$_extends() {
    $539df20092d410b7$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $539df20092d410b7$var$_extends.apply(this, arguments);
}
function $539df20092d410b7$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $539df20092d410b7$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $539df20092d410b7$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var $539df20092d410b7$var$className = "react-calendar__month-view__days__day";
function $539df20092d410b7$export$2e2bcd8739ae039(_ref) {
    var _ref$formatDay = _ref.formatDay, formatDay = _ref$formatDay === void 0 ? (0, $5398151a7800b344$export$a7f242eff11c1345) : _ref$formatDay, _ref$formatLongDate = _ref.formatLongDate, formatLongDate = _ref$formatLongDate === void 0 ? (0, $5398151a7800b344$export$322b36d80aef60ca) : _ref$formatLongDate, calendarType = _ref.calendarType, classes = _ref.classes, currentMonthIndex = _ref.currentMonthIndex, otherProps = $539df20092d410b7$var$_objectWithoutProperties(_ref, $539df20092d410b7$var$_excluded);
    var date = otherProps.date, locale = otherProps.locale;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $96d05e9cc89df7f5$export$2e2bcd8739ae039), $539df20092d410b7$var$_extends({}, otherProps, {
        classes: [].concat(classes, $539df20092d410b7$var$className, (0, $f0256d0d4f3b1098$export$618d60ea299da42)(date, calendarType) ? "".concat($539df20092d410b7$var$className, "--weekend") : null, date.getMonth() !== currentMonthIndex ? "".concat($539df20092d410b7$var$className, "--neighboringMonth") : null),
        formatAbbr: formatLongDate,
        maxDateTransform: (0, $78fdc7949801ab2a$export$7b798396f3e38cd7),
        minDateTransform: (0, $78fdc7949801ab2a$export$ef6b506418c2b397),
        view: "month"
    }), formatDay(locale, date));
}
$539df20092d410b7$export$2e2bcd8739ae039.propTypes = $539df20092d410b7$var$_objectSpread($539df20092d410b7$var$_objectSpread({}, (0, $42f0853312470faa$export$8571f7299c7936ad)), {}, {
    currentMonthIndex: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).number.isRequired,
    formatDay: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
    formatLongDate: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func
});




var $201b2cf16ef2651c$var$_excluded = [
    "showFixedNumberOfWeeks",
    "showNeighboringMonth"
];
function $201b2cf16ef2651c$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $201b2cf16ef2651c$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $201b2cf16ef2651c$var$ownKeys(Object(source), !0).forEach(function(key) {
            $201b2cf16ef2651c$var$_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $201b2cf16ef2651c$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $201b2cf16ef2651c$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $201b2cf16ef2651c$var$_extends() {
    $201b2cf16ef2651c$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $201b2cf16ef2651c$var$_extends.apply(this, arguments);
}
function $201b2cf16ef2651c$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $201b2cf16ef2651c$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $201b2cf16ef2651c$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $201b2cf16ef2651c$export$2e2bcd8739ae039(props) {
    var activeStartDate = props.activeStartDate, calendarType = props.calendarType;
    var showFixedNumberOfWeeks = props.showFixedNumberOfWeeks, showNeighboringMonth = props.showNeighboringMonth, otherProps = $201b2cf16ef2651c$var$_objectWithoutProperties(props, $201b2cf16ef2651c$var$_excluded);
    var year = (0, $78fdc7949801ab2a$export$5846dc2d57a5c860)(activeStartDate);
    var monthIndex = (0, $78fdc7949801ab2a$export$6ce1b5acc29cb53b)(activeStartDate);
    var hasFixedNumberOfWeeks = showFixedNumberOfWeeks || showNeighboringMonth;
    var dayOfWeek = (0, $f0256d0d4f3b1098$export$2061056d06d7cdf7)(activeStartDate, calendarType);
    var offset = hasFixedNumberOfWeeks ? 0 : dayOfWeek;
    /**
   * Defines on which day of the month the grid shall start. If we simply show current
   * month, we obviously start on day one, but if showNeighboringMonth is set to
   * true, we need to find the beginning of the week the first day of the month is in.
   */ var start = (hasFixedNumberOfWeeks ? -dayOfWeek : 0) + 1;
    /**
   * Defines on which day of the month the grid shall end. If we simply show current
   * month, we need to stop on the last day of the month, but if showNeighboringMonth
   * is set to true, we need to find the end of the week the last day of the month is in.
   */ var end = function() {
        if (showFixedNumberOfWeeks) // Always show 6 weeks
        return start + 42 - 1;
        var daysInMonth = (0, $78fdc7949801ab2a$export$f645ddd439eb259d)(activeStartDate);
        if (showNeighboringMonth) {
            var activeEndDate = new Date();
            activeEndDate.setFullYear(year, monthIndex, daysInMonth);
            activeEndDate.setHours(0, 0, 0, 0);
            var daysUntilEndOfTheWeek = 7 - (0, $f0256d0d4f3b1098$export$2061056d06d7cdf7)(activeEndDate, calendarType) - 1;
            return daysInMonth + daysUntilEndOfTheWeek;
        }
        return daysInMonth;
    }();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $89388808b0fcfc7d$export$2e2bcd8739ae039), $201b2cf16ef2651c$var$_extends({}, otherProps, {
        className: "react-calendar__month-view__days",
        count: 7,
        currentMonthIndex: monthIndex,
        dateTransform: function dateTransform(day) {
            var date = new Date();
            date.setFullYear(year, monthIndex, day);
            date.setHours(0, 0, 0, 0);
            return date;
        },
        dateType: "day",
        end: end,
        offset: offset,
        start: start,
        tile: (0, $539df20092d410b7$export$2e2bcd8739ae039)
    }));
}
$201b2cf16ef2651c$export$2e2bcd8739ae039.propTypes = $201b2cf16ef2651c$var$_objectSpread({
    calendarType: (0, $42f0853312470faa$export$9780328ce60eac34).isRequired,
    showFixedNumberOfWeeks: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    showNeighboringMonth: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool
}, (0, $42f0853312470faa$export$61cce6a131f71246));



var $acw62 = parcelRequire("acw62");

var $c9Z8w = parcelRequire("c9Z8w");






var $39e2786eb9f92c54$var$className = "react-calendar__month-view__weekdays";
var $39e2786eb9f92c54$var$weekdayClassName = "".concat($39e2786eb9f92c54$var$className, "__weekday");
function $39e2786eb9f92c54$export$2e2bcd8739ae039(props) {
    var calendarType = props.calendarType, _props$formatShortWee = props.formatShortWeekday, formatShortWeekday = _props$formatShortWee === void 0 ? (0, $5398151a7800b344$export$7ebe25e42481bc02) : _props$formatShortWee, _props$formatWeekday = props.formatWeekday, formatWeekday = _props$formatWeekday === void 0 ? (0, $5398151a7800b344$export$407180b957f39d7e) : _props$formatWeekday, locale = props.locale, onMouseLeave = props.onMouseLeave;
    var anyDate = new Date();
    var beginOfMonth = (0, $78fdc7949801ab2a$export$c7002b157c9b9e95)(anyDate);
    var year = (0, $78fdc7949801ab2a$export$5846dc2d57a5c860)(beginOfMonth);
    var monthIndex = (0, $78fdc7949801ab2a$export$6ce1b5acc29cb53b)(beginOfMonth);
    var weekdays = [];
    for(var weekday = 1; weekday <= 7; weekday += 1){
        var weekdayDate = new Date(year, monthIndex, weekday - (0, $f0256d0d4f3b1098$export$2061056d06d7cdf7)(beginOfMonth, calendarType));
        var abbr = formatWeekday(locale, weekdayDate);
        weekdays.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            key: weekday,
            className: (0, $0a37892229a7559c$export$2e2bcd8739ae039)($39e2786eb9f92c54$var$weekdayClassName, (0, $f0256d0d4f3b1098$export$618d60ea299da42)(weekdayDate, calendarType) && "".concat($39e2786eb9f92c54$var$weekdayClassName, "--weekend"))
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("abbr", {
            "aria-label": abbr,
            title: abbr
        }, formatShortWeekday(locale, weekdayDate).replace(".", ""))));
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $19228e875a5c8531$export$2e2bcd8739ae039), {
        className: $39e2786eb9f92c54$var$className,
        count: 7,
        onFocus: onMouseLeave,
        onMouseOver: onMouseLeave
    }, weekdays);
}
$39e2786eb9f92c54$export$2e2bcd8739ae039.propTypes = {
    calendarType: (0, $42f0853312470faa$export$9780328ce60eac34).isRequired,
    formatShortWeekday: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
    formatWeekday: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
    locale: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
    onMouseLeave: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func
};



var $acw62 = parcelRequire("acw62");

var $c9Z8w = parcelRequire("c9Z8w");


var $acw62 = parcelRequire("acw62");

var $c9Z8w = parcelRequire("c9Z8w");
var $ae17ba4d0b6e707b$var$_excluded = [
    "date",
    "onClickWeekNumber",
    "weekNumber"
];
function $ae17ba4d0b6e707b$var$_extends() {
    $ae17ba4d0b6e707b$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $ae17ba4d0b6e707b$var$_extends.apply(this, arguments);
}
function $ae17ba4d0b6e707b$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $ae17ba4d0b6e707b$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $ae17ba4d0b6e707b$var$ownKeys(Object(source), !0).forEach(function(key) {
            $ae17ba4d0b6e707b$var$_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $ae17ba4d0b6e707b$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $ae17ba4d0b6e707b$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $ae17ba4d0b6e707b$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $ae17ba4d0b6e707b$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $ae17ba4d0b6e707b$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var $ae17ba4d0b6e707b$var$className = "react-calendar__tile";
function $ae17ba4d0b6e707b$export$2e2bcd8739ae039(_ref) {
    var date = _ref.date, onClickWeekNumber = _ref.onClickWeekNumber, weekNumber = _ref.weekNumber, otherProps = $ae17ba4d0b6e707b$var$_objectWithoutProperties(_ref, $ae17ba4d0b6e707b$var$_excluded);
    var props = $ae17ba4d0b6e707b$var$_objectSpread({
        className: $ae17ba4d0b6e707b$var$className
    }, otherProps);
    var children = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", null, weekNumber);
    return onClickWeekNumber ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("button", $ae17ba4d0b6e707b$var$_extends({}, props, {
        onClick: function onClick(event) {
            return onClickWeekNumber(weekNumber, date, event);
        },
        type: "button"
    }), children) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", props, children);
}
$ae17ba4d0b6e707b$export$2e2bcd8739ae039.propTypes = {
    date: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).instanceOf(Date).isRequired,
    onClickWeekNumber: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
    weekNumber: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).node.isRequired
};





function $5256b69244056cde$export$2e2bcd8739ae039(props) {
    var activeStartDate = props.activeStartDate, calendarType = props.calendarType, onClickWeekNumber = props.onClickWeekNumber, onMouseLeave = props.onMouseLeave, showFixedNumberOfWeeks = props.showFixedNumberOfWeeks;
    var numberOfWeeks = function() {
        if (showFixedNumberOfWeeks) return 6;
        var numberOfDays = (0, $78fdc7949801ab2a$export$f645ddd439eb259d)(activeStartDate);
        var startWeekday = (0, $f0256d0d4f3b1098$export$2061056d06d7cdf7)(activeStartDate, calendarType);
        var days = numberOfDays - (7 - startWeekday);
        return 1 + Math.ceil(days / 7);
    }();
    var dates = function() {
        var year = (0, $78fdc7949801ab2a$export$5846dc2d57a5c860)(activeStartDate);
        var monthIndex = (0, $78fdc7949801ab2a$export$6ce1b5acc29cb53b)(activeStartDate);
        var day = (0, $78fdc7949801ab2a$export$aa350b96d91cd94)(activeStartDate);
        var result = [];
        for(var index = 0; index < numberOfWeeks; index += 1)result.push((0, $f0256d0d4f3b1098$export$84e707e5f485f282)(new Date(year, monthIndex, day + index * 7), calendarType));
        return result;
    }();
    var weekNumbers = dates.map(function(date) {
        return (0, $f0256d0d4f3b1098$export$b59889984706b7a7)(date, calendarType);
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $19228e875a5c8531$export$2e2bcd8739ae039), {
        className: "react-calendar__month-view__weekNumbers",
        count: numberOfWeeks,
        direction: "column",
        onFocus: onMouseLeave,
        onMouseOver: onMouseLeave,
        style: {
            flexBasis: "calc(100% * (1 / 8)",
            flexShrink: 0
        }
    }, weekNumbers.map(function(weekNumber, weekIndex) {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $ae17ba4d0b6e707b$export$2e2bcd8739ae039), {
            key: weekNumber,
            date: dates[weekIndex],
            onClickWeekNumber: onClickWeekNumber,
            weekNumber: weekNumber
        });
    }));
}
$5256b69244056cde$export$2e2bcd8739ae039.propTypes = {
    activeStartDate: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).instanceOf(Date).isRequired,
    calendarType: (0, $42f0853312470faa$export$9780328ce60eac34).isRequired,
    onClickWeekNumber: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
    onMouseLeave: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
    showFixedNumberOfWeeks: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool
};




var $f0b3612df8f4d50d$var$_excluded = [
    "calendarType",
    "formatShortWeekday",
    "formatWeekday",
    "onClickWeekNumber",
    "showWeekNumbers"
];
function $f0b3612df8f4d50d$var$_extends() {
    $f0b3612df8f4d50d$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $f0b3612df8f4d50d$var$_extends.apply(this, arguments);
}
function $f0b3612df8f4d50d$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $f0b3612df8f4d50d$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $f0b3612df8f4d50d$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $f0b3612df8f4d50d$var$getCalendarTypeFromLocale(locale) {
    return Object.keys((0, $6ede4d444f78ee44$export$e4e5576db5b8e30f)).find(function(calendarType) {
        return (0, $6ede4d444f78ee44$export$e4e5576db5b8e30f)[calendarType].includes(locale);
    }) || (0, $6ede4d444f78ee44$export$26fa441040070c35).ISO_8601;
}
function $f0b3612df8f4d50d$export$2e2bcd8739ae039(props) {
    var activeStartDate = props.activeStartDate, locale = props.locale, onMouseLeave = props.onMouseLeave, showFixedNumberOfWeeks = props.showFixedNumberOfWeeks;
    var _props$calendarType = props.calendarType, calendarType = _props$calendarType === void 0 ? $f0b3612df8f4d50d$var$getCalendarTypeFromLocale(locale) : _props$calendarType, formatShortWeekday = props.formatShortWeekday, formatWeekday = props.formatWeekday, onClickWeekNumber = props.onClickWeekNumber, showWeekNumbers = props.showWeekNumbers, childProps = $f0b3612df8f4d50d$var$_objectWithoutProperties(props, $f0b3612df8f4d50d$var$_excluded);
    function renderWeekdays() {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $39e2786eb9f92c54$export$2e2bcd8739ae039), {
            calendarType: calendarType,
            formatShortWeekday: formatShortWeekday,
            formatWeekday: formatWeekday,
            locale: locale,
            onMouseLeave: onMouseLeave
        });
    }
    function renderWeekNumbers() {
        if (!showWeekNumbers) return null;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $5256b69244056cde$export$2e2bcd8739ae039), {
            activeStartDate: activeStartDate,
            calendarType: calendarType,
            onClickWeekNumber: onClickWeekNumber,
            onMouseLeave: onMouseLeave,
            showFixedNumberOfWeeks: showFixedNumberOfWeeks
        });
    }
    function renderDays() {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $201b2cf16ef2651c$export$2e2bcd8739ae039), $f0b3612df8f4d50d$var$_extends({
            calendarType: calendarType
        }, childProps));
    }
    var className = "react-calendar__month-view";
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: (0, $0a37892229a7559c$export$2e2bcd8739ae039)(className, showWeekNumbers ? "".concat(className, "--weekNumbers") : "")
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            display: "flex",
            alignItems: "flex-end"
        }
    }, renderWeekNumbers(), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            flexGrow: 1,
            width: "100%"
        }
    }, renderWeekdays(), renderDays())));
}
$f0b3612df8f4d50d$export$2e2bcd8739ae039.propTypes = {
    activeStartDate: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).instanceOf(Date).isRequired,
    calendarType: (0, $42f0853312470faa$export$9780328ce60eac34),
    formatShortWeekday: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
    formatWeekday: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
    locale: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
    onClickWeekNumber: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
    onMouseLeave: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
    showFixedNumberOfWeeks: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    showWeekNumbers: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool
};





var $1c0e8dbf87fa9d2a$var$_excluded = [
    "activeStartDate",
    "defaultActiveStartDate",
    "defaultValue",
    "defaultView",
    "maxDetail",
    "minDetail",
    "value",
    "view"
];
function $1c0e8dbf87fa9d2a$var$_extends() {
    $1c0e8dbf87fa9d2a$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $1c0e8dbf87fa9d2a$var$_extends.apply(this, arguments);
}
function $1c0e8dbf87fa9d2a$var$_typeof(obj) {
    "@babel/helpers - typeof";
    return $1c0e8dbf87fa9d2a$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, $1c0e8dbf87fa9d2a$var$_typeof(obj);
}
function $1c0e8dbf87fa9d2a$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $1c0e8dbf87fa9d2a$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $1c0e8dbf87fa9d2a$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $1c0e8dbf87fa9d2a$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $1c0e8dbf87fa9d2a$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function $1c0e8dbf87fa9d2a$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    Object.defineProperty(subClass, "prototype", {
        writable: false
    });
    if (superClass) $1c0e8dbf87fa9d2a$var$_setPrototypeOf(subClass, superClass);
}
function $1c0e8dbf87fa9d2a$var$_setPrototypeOf(o, p) {
    $1c0e8dbf87fa9d2a$var$_setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $1c0e8dbf87fa9d2a$var$_setPrototypeOf(o, p);
}
function $1c0e8dbf87fa9d2a$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $1c0e8dbf87fa9d2a$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = $1c0e8dbf87fa9d2a$var$_getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = $1c0e8dbf87fa9d2a$var$_getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return $1c0e8dbf87fa9d2a$var$_possibleConstructorReturn(this, result);
    };
}
function $1c0e8dbf87fa9d2a$var$_possibleConstructorReturn(self, call) {
    if (call && ($1c0e8dbf87fa9d2a$var$_typeof(call) === "object" || typeof call === "function")) return call;
    else if (call !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
    return $1c0e8dbf87fa9d2a$var$_assertThisInitialized(self);
}
function $1c0e8dbf87fa9d2a$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $1c0e8dbf87fa9d2a$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function $1c0e8dbf87fa9d2a$var$_getPrototypeOf(o) {
    $1c0e8dbf87fa9d2a$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $1c0e8dbf87fa9d2a$var$_getPrototypeOf(o);
}
function $1c0e8dbf87fa9d2a$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $1c0e8dbf87fa9d2a$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $1c0e8dbf87fa9d2a$var$ownKeys(Object(source), !0).forEach(function(key) {
            $1c0e8dbf87fa9d2a$var$_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $1c0e8dbf87fa9d2a$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $1c0e8dbf87fa9d2a$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $1c0e8dbf87fa9d2a$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $1c0e8dbf87fa9d2a$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $1c0e8dbf87fa9d2a$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $1c0e8dbf87fa9d2a$var$_toConsumableArray(arr) {
    return $1c0e8dbf87fa9d2a$var$_arrayWithoutHoles(arr) || $1c0e8dbf87fa9d2a$var$_iterableToArray(arr) || $1c0e8dbf87fa9d2a$var$_unsupportedIterableToArray(arr) || $1c0e8dbf87fa9d2a$var$_nonIterableSpread();
}
function $1c0e8dbf87fa9d2a$var$_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $1c0e8dbf87fa9d2a$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $1c0e8dbf87fa9d2a$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $1c0e8dbf87fa9d2a$var$_arrayLikeToArray(o, minLen);
}
function $1c0e8dbf87fa9d2a$var$_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function $1c0e8dbf87fa9d2a$var$_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return $1c0e8dbf87fa9d2a$var$_arrayLikeToArray(arr);
}
function $1c0e8dbf87fa9d2a$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
var $1c0e8dbf87fa9d2a$var$defaultMinDate = new Date();
$1c0e8dbf87fa9d2a$var$defaultMinDate.setFullYear(1, 0, 1);
$1c0e8dbf87fa9d2a$var$defaultMinDate.setHours(0, 0, 0, 0);
var $1c0e8dbf87fa9d2a$var$defaultMaxDate = new Date(8.64e15);
var $1c0e8dbf87fa9d2a$var$baseClassName = "react-calendar";
var $1c0e8dbf87fa9d2a$var$allViews = [
    "century",
    "decade",
    "year",
    "month"
];
var $1c0e8dbf87fa9d2a$var$allValueTypes = [].concat($1c0e8dbf87fa9d2a$var$_toConsumableArray($1c0e8dbf87fa9d2a$var$allViews.slice(1)), [
    "day"
]);
function $1c0e8dbf87fa9d2a$var$toDate(value) {
    if (value instanceof Date) return value;
    return new Date(value);
}
/**
 * Returns views array with disallowed values cut off.
 */ function $1c0e8dbf87fa9d2a$var$getLimitedViews(minDetail, maxDetail) {
    return $1c0e8dbf87fa9d2a$var$allViews.slice($1c0e8dbf87fa9d2a$var$allViews.indexOf(minDetail), $1c0e8dbf87fa9d2a$var$allViews.indexOf(maxDetail) + 1);
}
/**
 * Determines whether a given view is allowed with currently applied settings.
 */ function $1c0e8dbf87fa9d2a$var$isViewAllowed(view, minDetail, maxDetail) {
    var views = $1c0e8dbf87fa9d2a$var$getLimitedViews(minDetail, maxDetail);
    return views.indexOf(view) !== -1;
}
/**
 * Gets either provided view if allowed by minDetail and maxDetail, or gets
 * the default view if not allowed.
 */ function $1c0e8dbf87fa9d2a$var$getView(view, minDetail, maxDetail) {
    if ($1c0e8dbf87fa9d2a$var$isViewAllowed(view, minDetail, maxDetail)) return view;
    return maxDetail;
}
/**
 * Returns value type that can be returned with currently applied settings.
 */ function $1c0e8dbf87fa9d2a$var$getValueType(maxDetail) {
    return $1c0e8dbf87fa9d2a$var$allValueTypes[$1c0e8dbf87fa9d2a$var$allViews.indexOf(maxDetail)];
}
function $1c0e8dbf87fa9d2a$var$getValue(value, index) {
    if (!value) return null;
    var rawValue = Array.isArray(value) && value.length === 2 ? value[index] : value;
    if (!rawValue) return null;
    var valueDate = $1c0e8dbf87fa9d2a$var$toDate(rawValue);
    if (isNaN(valueDate.getTime())) throw new Error("Invalid date: ".concat(value));
    return valueDate;
}
function $1c0e8dbf87fa9d2a$var$getDetailValue(_ref, index) {
    var value = _ref.value, minDate = _ref.minDate, maxDate = _ref.maxDate, maxDetail = _ref.maxDetail;
    var valuePiece = $1c0e8dbf87fa9d2a$var$getValue(value, index);
    if (!valuePiece) return null;
    var valueType = $1c0e8dbf87fa9d2a$var$getValueType(maxDetail);
    var detailValueFrom = [
        (0, $f0256d0d4f3b1098$export$700a64ae37cbc741),
        (0, $f0256d0d4f3b1098$export$946298ccd438a697)
    ][index](valueType, valuePiece);
    return (0, $31b103f03d6f0116$export$cf95c51b03f10bae)(detailValueFrom, minDate, maxDate);
}
var $1c0e8dbf87fa9d2a$var$getDetailValueFrom = function getDetailValueFrom(args) {
    return $1c0e8dbf87fa9d2a$var$getDetailValue(args, 0);
};
var $1c0e8dbf87fa9d2a$var$getDetailValueTo = function getDetailValueTo(args) {
    return $1c0e8dbf87fa9d2a$var$getDetailValue(args, 1);
};
var $1c0e8dbf87fa9d2a$var$getDetailValueArray = function getDetailValueArray(args) {
    var value = args.value;
    if (Array.isArray(value)) return value;
    return [
        $1c0e8dbf87fa9d2a$var$getDetailValueFrom,
        $1c0e8dbf87fa9d2a$var$getDetailValueTo
    ].map(function(fn) {
        return fn(args);
    });
};
function $1c0e8dbf87fa9d2a$var$getActiveStartDate(props) {
    var maxDate = props.maxDate, maxDetail = props.maxDetail, minDate = props.minDate, minDetail = props.minDetail, value = props.value, view = props.view;
    var rangeType = $1c0e8dbf87fa9d2a$var$getView(view, minDetail, maxDetail);
    var valueFrom = $1c0e8dbf87fa9d2a$var$getDetailValueFrom({
        value: value,
        minDate: minDate,
        maxDate: maxDate,
        maxDetail: maxDetail
    }) || new Date();
    return (0, $f0256d0d4f3b1098$export$700a64ae37cbc741)(rangeType, valueFrom);
}
function $1c0e8dbf87fa9d2a$var$getInitialActiveStartDate(props) {
    var activeStartDate = props.activeStartDate, defaultActiveStartDate = props.defaultActiveStartDate, defaultValue = props.defaultValue, defaultView = props.defaultView, maxDetail = props.maxDetail, minDetail = props.minDetail, value = props.value, view = props.view, otherProps = $1c0e8dbf87fa9d2a$var$_objectWithoutProperties(props, $1c0e8dbf87fa9d2a$var$_excluded);
    var rangeType = $1c0e8dbf87fa9d2a$var$getView(view, minDetail, maxDetail);
    var valueFrom = activeStartDate || defaultActiveStartDate;
    if (valueFrom) return (0, $f0256d0d4f3b1098$export$700a64ae37cbc741)(rangeType, valueFrom);
    return $1c0e8dbf87fa9d2a$var$getActiveStartDate($1c0e8dbf87fa9d2a$var$_objectSpread({
        maxDetail: maxDetail,
        minDetail: minDetail,
        value: value || defaultValue,
        view: view || defaultView
    }, otherProps));
}
var $1c0e8dbf87fa9d2a$var$getIsSingleValue = function getIsSingleValue(value) {
    return value && [].concat(value).length === 1;
};
var $1c0e8dbf87fa9d2a$export$2e2bcd8739ae039 = /*#__PURE__*/ function(_Component) {
    $1c0e8dbf87fa9d2a$var$_inherits(Calendar, _Component);
    var _super = $1c0e8dbf87fa9d2a$var$_createSuper(Calendar);
    function Calendar() {
        var _this;
        $1c0e8dbf87fa9d2a$var$_classCallCheck(this, Calendar);
        for(var _len = arguments.length, _args = new Array(_len), _key = 0; _key < _len; _key++)_args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(_args));
        $1c0e8dbf87fa9d2a$var$_defineProperty($1c0e8dbf87fa9d2a$var$_assertThisInitialized(_this), "state", {
            activeStartDate: _this.props.defaultActiveStartDate,
            value: _this.props.defaultValue,
            view: _this.props.defaultView
        });
        $1c0e8dbf87fa9d2a$var$_defineProperty($1c0e8dbf87fa9d2a$var$_assertThisInitialized(_this), "setStateAndCallCallbacks", function(nextState, event, callback) {
            var _assertThisInitialize = $1c0e8dbf87fa9d2a$var$_assertThisInitialized(_this), previousActiveStartDate = _assertThisInitialize.activeStartDate, previousView = _assertThisInitialize.view;
            var _this$props = _this.props, allowPartialRange = _this$props.allowPartialRange, onActiveStartDateChange = _this$props.onActiveStartDateChange, onChange = _this$props.onChange, onViewChange = _this$props.onViewChange, selectRange = _this$props.selectRange;
            var prevArgs = {
                activeStartDate: previousActiveStartDate,
                view: previousView
            };
            _this.setState(nextState, function() {
                var args = {
                    action: nextState.action,
                    activeStartDate: nextState.activeStartDate || _this.activeStartDate,
                    value: nextState.value || _this.value,
                    view: nextState.view || _this.view
                };
                function shouldUpdate(key) {
                    return key in nextState && ($1c0e8dbf87fa9d2a$var$_typeof(nextState[key]) !== $1c0e8dbf87fa9d2a$var$_typeof(prevArgs[key]) || (nextState[key] instanceof Date ? nextState[key].getTime() !== prevArgs[key].getTime() : nextState[key] !== prevArgs[key]));
                }
                if (shouldUpdate("activeStartDate")) {
                    if (onActiveStartDateChange) onActiveStartDateChange(args);
                }
                if (shouldUpdate("view")) {
                    if (onViewChange) onViewChange(args);
                }
                if (shouldUpdate("value")) {
                    if (onChange) {
                        if (selectRange) {
                            var isSingleValue = $1c0e8dbf87fa9d2a$var$getIsSingleValue(nextState.value);
                            if (!isSingleValue) onChange(nextState.value, event);
                            else if (allowPartialRange) onChange([
                                nextState.value
                            ], event);
                        } else onChange(nextState.value, event);
                    }
                }
                if (callback) callback(args);
            });
        });
        $1c0e8dbf87fa9d2a$var$_defineProperty($1c0e8dbf87fa9d2a$var$_assertThisInitialized(_this), "setActiveStartDate", function(nextActiveStartDate, action) {
            _this.setStateAndCallCallbacks({
                action: action,
                activeStartDate: nextActiveStartDate
            });
        });
        $1c0e8dbf87fa9d2a$var$_defineProperty($1c0e8dbf87fa9d2a$var$_assertThisInitialized(_this), "drillDown", function(nextActiveStartDate, event) {
            if (!_this.drillDownAvailable) return;
            _this.onClickTile(nextActiveStartDate, event);
            var _assertThisInitialize2 = $1c0e8dbf87fa9d2a$var$_assertThisInitialized(_this), view = _assertThisInitialize2.view, views = _assertThisInitialize2.views;
            var onDrillDown = _this.props.onDrillDown;
            var nextView = views[views.indexOf(view) + 1];
            _this.setStateAndCallCallbacks({
                action: "drillDown",
                activeStartDate: nextActiveStartDate,
                view: nextView
            }, undefined, onDrillDown);
        });
        $1c0e8dbf87fa9d2a$var$_defineProperty($1c0e8dbf87fa9d2a$var$_assertThisInitialized(_this), "drillUp", function() {
            if (!_this.drillUpAvailable) return;
            var _assertThisInitialize3 = $1c0e8dbf87fa9d2a$var$_assertThisInitialized(_this), activeStartDate = _assertThisInitialize3.activeStartDate, view = _assertThisInitialize3.view, views = _assertThisInitialize3.views;
            var onDrillUp = _this.props.onDrillUp;
            var nextView = views[views.indexOf(view) - 1];
            var nextActiveStartDate = (0, $f0256d0d4f3b1098$export$700a64ae37cbc741)(nextView, activeStartDate);
            _this.setStateAndCallCallbacks({
                action: "drillUp",
                activeStartDate: nextActiveStartDate,
                view: nextView
            }, undefined, onDrillUp);
        });
        $1c0e8dbf87fa9d2a$var$_defineProperty($1c0e8dbf87fa9d2a$var$_assertThisInitialized(_this), "onChange", function(value, event) {
            var _assertThisInitialize4 = $1c0e8dbf87fa9d2a$var$_assertThisInitialized(_this), previousValue = _assertThisInitialize4.value;
            var _this$props2 = _this.props, goToRangeStartOnSelect = _this$props2.goToRangeStartOnSelect, selectRange = _this$props2.selectRange;
            _this.onClickTile(value, event);
            var isFirstValueInRange = selectRange && !$1c0e8dbf87fa9d2a$var$getIsSingleValue(previousValue);
            var nextValue;
            if (selectRange) {
                // Range selection turned on
                var _assertThisInitialize5 = $1c0e8dbf87fa9d2a$var$_assertThisInitialized(_this), valueType = _assertThisInitialize5.valueType;
                if (isFirstValueInRange) // Value has 0 or 2 elements - either way we're starting a new array
                // First value
                nextValue = (0, $f0256d0d4f3b1098$export$700a64ae37cbc741)(valueType, value);
                else // Second value
                nextValue = (0, $f0256d0d4f3b1098$export$3a3e6dbcaf74641d)(valueType, previousValue, value);
            } else // Range selection turned off
            nextValue = _this.getProcessedValue(value);
            var nextActiveStartDate = !selectRange || // Range selection turned on, first value
            isFirstValueInRange || // Range selection turned on, second value, goToRangeStartOnSelect toggled on
            goToRangeStartOnSelect ? $1c0e8dbf87fa9d2a$var$getActiveStartDate($1c0e8dbf87fa9d2a$var$_objectSpread($1c0e8dbf87fa9d2a$var$_objectSpread({}, _this.props), {}, {
                value: nextValue
            })) : null;
            event.persist();
            _this.setStateAndCallCallbacks({
                action: "onChange",
                activeStartDate: nextActiveStartDate,
                value: nextValue
            }, event);
        });
        $1c0e8dbf87fa9d2a$var$_defineProperty($1c0e8dbf87fa9d2a$var$_assertThisInitialized(_this), "onClickTile", function(value, event) {
            var _assertThisInitialize6 = $1c0e8dbf87fa9d2a$var$_assertThisInitialized(_this), view = _assertThisInitialize6.view;
            var _this$props3 = _this.props, onClickDay = _this$props3.onClickDay, onClickDecade = _this$props3.onClickDecade, onClickMonth = _this$props3.onClickMonth, onClickYear = _this$props3.onClickYear;
            var callback = function() {
                switch(view){
                    case "century":
                        return onClickDecade;
                    case "decade":
                        return onClickYear;
                    case "year":
                        return onClickMonth;
                    case "month":
                        return onClickDay;
                    default:
                        throw new Error("Invalid view: ".concat(view, "."));
                }
            }();
            if (callback) callback(value, event);
        });
        $1c0e8dbf87fa9d2a$var$_defineProperty($1c0e8dbf87fa9d2a$var$_assertThisInitialized(_this), "onMouseOver", function(value) {
            _this.setState(function(prevState) {
                if (prevState.hover && prevState.hover.getTime() === value.getTime()) return null;
                return {
                    hover: value
                };
            });
        });
        $1c0e8dbf87fa9d2a$var$_defineProperty($1c0e8dbf87fa9d2a$var$_assertThisInitialized(_this), "onMouseLeave", function() {
            _this.setState({
                hover: null
            });
        });
        return _this;
    }
    $1c0e8dbf87fa9d2a$var$_createClass(Calendar, [
        {
            key: "activeStartDate",
            get: function get() {
                var activeStartDateProps = this.props.activeStartDate;
                var activeStartDateState = this.state.activeStartDate;
                return activeStartDateProps || activeStartDateState || $1c0e8dbf87fa9d2a$var$getInitialActiveStartDate(this.props);
            }
        },
        {
            key: "value",
            get: function get() {
                var _this$props4 = this.props, selectRange = _this$props4.selectRange, valueProps = _this$props4.value;
                var valueState = this.state.value; // In the middle of range selection, use value from state
                if (selectRange && $1c0e8dbf87fa9d2a$var$getIsSingleValue(valueState)) return valueState;
                return valueProps !== undefined ? valueProps : valueState;
            }
        },
        {
            key: "valueType",
            get: function get() {
                var maxDetail = this.props.maxDetail;
                return $1c0e8dbf87fa9d2a$var$getValueType(maxDetail);
            }
        },
        {
            key: "view",
            get: function get() {
                var _this$props5 = this.props, minDetail = _this$props5.minDetail, maxDetail = _this$props5.maxDetail, viewProps = _this$props5.view;
                var viewState = this.state.view;
                return $1c0e8dbf87fa9d2a$var$getView(viewProps || viewState, minDetail, maxDetail);
            }
        },
        {
            key: "views",
            get: function get() {
                var _this$props6 = this.props, minDetail = _this$props6.minDetail, maxDetail = _this$props6.maxDetail;
                return $1c0e8dbf87fa9d2a$var$getLimitedViews(minDetail, maxDetail);
            }
        },
        {
            key: "hover",
            get: function get() {
                var selectRange = this.props.selectRange;
                var hover = this.state.hover;
                return selectRange ? hover : null;
            }
        },
        {
            key: "drillDownAvailable",
            get: function get() {
                var view = this.view, views = this.views;
                return views.indexOf(view) < views.length - 1;
            }
        },
        {
            key: "drillUpAvailable",
            get: function get() {
                var view = this.view, views = this.views;
                return views.indexOf(view) > 0;
            }
        },
        {
            key: "getProcessedValue",
            value: function getProcessedValue(value) {
                var _this$props7 = this.props, minDate = _this$props7.minDate, maxDate = _this$props7.maxDate, maxDetail = _this$props7.maxDetail, returnValue = _this$props7.returnValue;
                var processFunction = function() {
                    switch(returnValue){
                        case "start":
                            return $1c0e8dbf87fa9d2a$var$getDetailValueFrom;
                        case "end":
                            return $1c0e8dbf87fa9d2a$var$getDetailValueTo;
                        case "range":
                            return $1c0e8dbf87fa9d2a$var$getDetailValueArray;
                        default:
                            throw new Error("Invalid returnValue.");
                    }
                }();
                return processFunction({
                    value: value,
                    minDate: minDate,
                    maxDate: maxDate,
                    maxDetail: maxDetail
                });
            }
        },
        {
            key: "renderContent",
            value: function renderContent(next) {
                var currentActiveStartDate = this.activeStartDate, onMouseOver = this.onMouseOver, valueType = this.valueType, value = this.value, view = this.view;
                var _this$props8 = this.props, calendarType = _this$props8.calendarType, locale = _this$props8.locale, maxDate = _this$props8.maxDate, minDate = _this$props8.minDate, selectRange = _this$props8.selectRange, tileClassName = _this$props8.tileClassName, tileContent = _this$props8.tileContent, tileDisabled = _this$props8.tileDisabled;
                var hover = this.hover;
                var activeStartDate = next ? (0, $f0256d0d4f3b1098$export$19193c1f2d841d47)(view, currentActiveStartDate) : (0, $f0256d0d4f3b1098$export$700a64ae37cbc741)(view, currentActiveStartDate);
                var onClick = this.drillDownAvailable ? this.drillDown : this.onChange;
                var commonProps = {
                    activeStartDate: activeStartDate,
                    hover: hover,
                    locale: locale,
                    maxDate: maxDate,
                    minDate: minDate,
                    onClick: onClick,
                    onMouseOver: selectRange ? onMouseOver : null,
                    tileClassName: tileClassName,
                    tileContent: tileContent,
                    tileDisabled: tileDisabled,
                    value: value,
                    valueType: valueType
                };
                switch(view){
                    case "century":
                        var formatYear = this.props.formatYear;
                        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $69d85f028a6b153b$export$2e2bcd8739ae039), $1c0e8dbf87fa9d2a$var$_extends({
                            formatYear: formatYear
                        }, commonProps));
                    case "decade":
                        var _formatYear = this.props.formatYear;
                        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $389ea55df3c2dae8$export$2e2bcd8739ae039), $1c0e8dbf87fa9d2a$var$_extends({
                            formatYear: _formatYear
                        }, commonProps));
                    case "year":
                        var _this$props9 = this.props, formatMonth = _this$props9.formatMonth, formatMonthYear = _this$props9.formatMonthYear;
                        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $f9aea9fc51f771c2$export$2e2bcd8739ae039), $1c0e8dbf87fa9d2a$var$_extends({
                            formatMonth: formatMonth,
                            formatMonthYear: formatMonthYear
                        }, commonProps));
                    case "month":
                        var _this$props10 = this.props, formatDay = _this$props10.formatDay, formatLongDate = _this$props10.formatLongDate, formatShortWeekday = _this$props10.formatShortWeekday, formatWeekday = _this$props10.formatWeekday, onClickWeekNumber = _this$props10.onClickWeekNumber, showDoubleView = _this$props10.showDoubleView, showFixedNumberOfWeeks = _this$props10.showFixedNumberOfWeeks, showNeighboringMonth = _this$props10.showNeighboringMonth, showWeekNumbers = _this$props10.showWeekNumbers;
                        var onMouseLeave = this.onMouseLeave;
                        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $f0b3612df8f4d50d$export$2e2bcd8739ae039), $1c0e8dbf87fa9d2a$var$_extends({
                            calendarType: calendarType,
                            formatDay: formatDay,
                            formatLongDate: formatLongDate,
                            formatShortWeekday: formatShortWeekday,
                            formatWeekday: formatWeekday,
                            onClickWeekNumber: onClickWeekNumber,
                            onMouseLeave: selectRange ? onMouseLeave : null,
                            showFixedNumberOfWeeks: typeof showFixedNumberOfWeeks !== "undefined" ? showFixedNumberOfWeeks : showDoubleView,
                            showNeighboringMonth: showNeighboringMonth,
                            showWeekNumbers: showWeekNumbers
                        }, commonProps));
                    default:
                        throw new Error("Invalid view: ".concat(view, "."));
                }
            }
        },
        {
            key: "renderNavigation",
            value: function renderNavigation() {
                var showNavigation = this.props.showNavigation;
                if (!showNavigation) return null;
                var activeStartDate = this.activeStartDate, view = this.view, views = this.views;
                var _this$props11 = this.props, formatMonthYear = _this$props11.formatMonthYear, formatYear = _this$props11.formatYear, locale = _this$props11.locale, maxDate = _this$props11.maxDate, minDate = _this$props11.minDate, navigationAriaLabel = _this$props11.navigationAriaLabel, navigationAriaLive = _this$props11.navigationAriaLive, navigationLabel = _this$props11.navigationLabel, next2AriaLabel = _this$props11.next2AriaLabel, next2Label = _this$props11.next2Label, nextAriaLabel = _this$props11.nextAriaLabel, nextLabel = _this$props11.nextLabel, prev2AriaLabel = _this$props11.prev2AriaLabel, prev2Label = _this$props11.prev2Label, prevAriaLabel = _this$props11.prevAriaLabel, prevLabel = _this$props11.prevLabel, showDoubleView = _this$props11.showDoubleView;
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $cfbfa00fe9577c18$export$2e2bcd8739ae039), {
                    activeStartDate: activeStartDate,
                    drillUp: this.drillUp,
                    formatMonthYear: formatMonthYear,
                    formatYear: formatYear,
                    locale: locale,
                    maxDate: maxDate,
                    minDate: minDate,
                    navigationAriaLabel: navigationAriaLabel,
                    navigationAriaLive: navigationAriaLive,
                    navigationLabel: navigationLabel,
                    next2AriaLabel: next2AriaLabel,
                    next2Label: next2Label,
                    nextAriaLabel: nextAriaLabel,
                    nextLabel: nextLabel,
                    prev2AriaLabel: prev2AriaLabel,
                    prev2Label: prev2Label,
                    prevAriaLabel: prevAriaLabel,
                    prevLabel: prevLabel,
                    setActiveStartDate: this.setActiveStartDate,
                    showDoubleView: showDoubleView,
                    view: view,
                    views: views
                });
            }
        },
        {
            key: "render",
            value: function render() {
                var _this$props12 = this.props, className = _this$props12.className, inputRef = _this$props12.inputRef, selectRange = _this$props12.selectRange, showDoubleView = _this$props12.showDoubleView;
                var onMouseLeave = this.onMouseLeave, value = this.value;
                var valueArray = [].concat(value);
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
                    className: (0, $0a37892229a7559c$export$2e2bcd8739ae039)($1c0e8dbf87fa9d2a$var$baseClassName, selectRange && valueArray.length === 1 && "".concat($1c0e8dbf87fa9d2a$var$baseClassName, "--selectRange"), showDoubleView && "".concat($1c0e8dbf87fa9d2a$var$baseClassName, "--doubleView"), className),
                    ref: inputRef
                }, this.renderNavigation(), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
                    className: "".concat($1c0e8dbf87fa9d2a$var$baseClassName, "__viewContainer"),
                    onBlur: selectRange ? onMouseLeave : null,
                    onMouseLeave: selectRange ? onMouseLeave : null
                }, this.renderContent(), showDoubleView && this.renderContent(true)));
            }
        }
    ]);
    return Calendar;
}((0, $acw62.Component));
$1c0e8dbf87fa9d2a$export$2e2bcd8739ae039.defaultProps = {
    goToRangeStartOnSelect: true,
    maxDate: $1c0e8dbf87fa9d2a$var$defaultMaxDate,
    maxDetail: "month",
    minDate: $1c0e8dbf87fa9d2a$var$defaultMinDate,
    minDetail: "century",
    returnValue: "start",
    showNavigation: true,
    showNeighboringMonth: true
};
var $1c0e8dbf87fa9d2a$var$isActiveStartDate = (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).instanceOf(Date);
var $1c0e8dbf87fa9d2a$var$isLooseValue = (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOfType([
    (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
    (0, $42f0853312470faa$export$2fb7a00a48619649)
]);
$1c0e8dbf87fa9d2a$export$2e2bcd8739ae039.propTypes = {
    activeStartDate: $1c0e8dbf87fa9d2a$var$isActiveStartDate,
    allowPartialRange: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    calendarType: (0, $42f0853312470faa$export$9780328ce60eac34),
    className: (0, $42f0853312470faa$export$d53f3db2f43345df),
    defaultActiveStartDate: $1c0e8dbf87fa9d2a$var$isActiveStartDate,
    defaultValue: $1c0e8dbf87fa9d2a$var$isLooseValue,
    defaultView: (0, $42f0853312470faa$export$7c1393839656cd16),
    formatDay: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
    formatLongDate: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
    formatMonth: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
    formatMonthYear: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
    formatShortWeekday: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
    formatWeekday: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
    formatYear: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
    goToRangeStartOnSelect: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    inputRef: (0, $42f0853312470faa$export$4f9f5282de18fc69),
    locale: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
    maxDate: (0, $42f0853312470faa$export$20075fd45e42d41c),
    maxDetail: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOf($1c0e8dbf87fa9d2a$var$allViews),
    minDate: (0, $42f0853312470faa$export$283839a53860a2f5),
    minDetail: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOf($1c0e8dbf87fa9d2a$var$allViews),
    navigationAriaLabel: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
    navigationAriaLive: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOf([
        "off",
        "polite",
        "assertive"
    ]),
    navigationLabel: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
    next2AriaLabel: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
    next2Label: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).node,
    nextAriaLabel: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
    nextLabel: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).node,
    onActiveStartDateChange: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
    onChange: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
    onClickDay: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
    onClickDecade: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
    onClickMonth: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
    onClickWeekNumber: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
    onClickYear: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
    onDrillDown: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
    onDrillUp: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
    onViewChange: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
    prev2AriaLabel: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
    prev2Label: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).node,
    prevAriaLabel: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
    prevLabel: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).node,
    returnValue: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOf([
        "start",
        "end",
        "range"
    ]),
    selectRange: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    showDoubleView: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    showFixedNumberOfWeeks: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    showNavigation: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    showNeighboringMonth: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    showWeekNumbers: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    tileClassName: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
        (0, $42f0853312470faa$export$d53f3db2f43345df)
    ]),
    tileContent: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).node
    ]),
    tileDisabled: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
    value: $1c0e8dbf87fa9d2a$var$isLooseValue,
    view: (0, $42f0853312470faa$export$7c1393839656cd16)
};







var $5304fe6d5e1a96df$export$2e2bcd8739ae039 = (0, $1c0e8dbf87fa9d2a$export$2e2bcd8739ae039);





const $dd807b100864eab2$var$months = [
    "calendar.month_january",
    "calendar.month_february",
    "calendar.month_march",
    "calendar.month_april",
    "calendar.month_may",
    "calendar.month_june",
    "calendar.month_july",
    "calendar.month_august",
    "calendar.month_september",
    "calendar.month_october",
    "calendar.month_november",
    "calendar.month_december"
];
const $dd807b100864eab2$var$Calendar = /*#__PURE__*/ (0, $acw62.forwardRef)(({ value: value, setValue: setValue, minDate: minDate, maxDate: maxDate, containerClassName: containerClassName, containerStyle: containerStyle, hoveredDate: hoveredDate, setHoveredDate: setHoveredDate, highlightWeek: highlightWeek, bottomActionTitle: bottomActionTitle, bottomActionCallback: bottomActionCallback, showNeighboringMonth: showNeighboringMonth = false }, ref)=>{
    const getWeekRange = (date)=>{
        const startOfWeek = new Date(date);
        // Adjust day offset based on the week start preference
        const dayOffset = (0, $73ccb33f5de6f5aa$export$8707029d024490c9)().firstDayOfWeek === "Mon" ? 1 : 0;
        // Calculate the start of the week
        const day = startOfWeek.getDay();
        const diff = (day < dayOffset ? 7 : 0) + day - dayOffset;
        startOfWeek.setDate(date.getDate() - diff);
        // Calculate the end of the week
        const endOfWeek = new Date(startOfWeek);
        endOfWeek.setDate(startOfWeek.getDate() + 6);
        return {
            startOfWeek: startOfWeek,
            endOfWeek: endOfWeek
        };
    };
    const tileClassName = ({ date: date })=>{
        let className = "";
        if (!highlightWeek) return className;
        if (hoveredDate) {
            const { startOfWeek: startOfWeek, endOfWeek: endOfWeek } = getWeekRange(hoveredDate);
            if (date >= startOfWeek && date <= endOfWeek) className += "highlight-week";
        }
        const selectedValue = new Date(value);
        selectedValue.setHours(0, 0, 0, 0);
        const { startOfWeek: startOfWeek, endOfWeek: endOfWeek } = getWeekRange(selectedValue);
        if (date >= startOfWeek && date <= endOfWeek) className += " highlight-week";
        return className;
    };
    const years = (0, $acw62.useMemo)(()=>{
        const currentYear = Number((0, (/*@__PURE__*/$parcel$interopDefault($45fvw)))().format("YYYY"));
        return [
            {
                key: currentYear,
                value: String(currentYear)
            },
            {
                key: currentYear + 1,
                value: String(currentYear + 1)
            }
        ];
    }, []);
    const { t: t } = (0, $3765cebd031b52c0$export$9fc83ad70ead8663)();
    const [chosenMonth, setChosenMonth] = (0, $acw62.useState)(new Date().getMonth());
    const [chosenYear, setChosenYear] = (0, $acw62.useState)(new Date().getFullYear());
    const [chosenDate, setChosenDate] = (0, $acw62.useState)(new Date());
    const language = (0, $73ccb33f5de6f5aa$export$daa49e131b652e5b).getCurrentLanguage();
    const tileContent = ({ date: date })=>{
        if (!highlightWeek) return null;
        return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
            onMouseOver: ()=>setHoveredDate?.(date),
            onMouseLeave: ()=>setHoveredDate?.(null),
            style: {
                position: "absolute",
                top: "-173%",
                left: "-14%",
                width: "130%",
                height: "230%",
                backgroundColor: "transparent"
            }
        });
    };
    (0, $acw62.useEffect)(()=>{
        setChosenDate(new Date(chosenYear, chosenMonth));
    }, [
        chosenMonth,
        chosenYear
    ]);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        style: containerStyle,
        ref: ref,
        className: `Calendar__container${highlightWeek ? " Calendar--highlightWeek" : ""}${containerClassName ? ` ${containerClassName}` : ""}`,
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "Calendar__topActions",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f2c1b8699595d8c0$export$ef9b1a59e592288f), {
                        label: t("calendar.month"),
                        className: "Calendar__topActions__monthSelector",
                        value: chosenMonth,
                        onChange: (monthValue)=>{
                            setChosenMonth(monthValue);
                        },
                        options: $dd807b100864eab2$var$months.map((month, index)=>{
                            return {
                                key: String(index),
                                label: t(month),
                                value: index
                            };
                        })
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f2c1b8699595d8c0$export$ef9b1a59e592288f), {
                        label: t("calendar.year"),
                        value: chosenYear,
                        onChange: (yearValue)=>{
                            setChosenYear(yearValue);
                        },
                        options: years.map((year)=>{
                            return {
                                key: String(year.key),
                                label: year.value,
                                value: Number(year.key)
                            };
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $1c0e8dbf87fa9d2a$export$2e2bcd8739ae039), {
                locale: language ?? (0, $73ccb33f5de6f5aa$export$449b009f68cc9554),
                activeStartDate: chosenDate,
                onChange: (dateValue)=>{
                    setValue(dateValue);
                },
                calendarType: (0, $73ccb33f5de6f5aa$export$8707029d024490c9)().firstDayOfWeek === "Sun" ? "US" : "ISO 8601",
                showNavigation: false,
                showNeighboringMonth: showNeighboringMonth,
                minDate: minDate,
                maxDate: maxDate,
                value: value,
                tileClassName: tileClassName,
                tileContent: ({ date: date, view: view })=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        style: {
                            position: "relative",
                            width: "100%",
                            height: "100%"
                        },
                        children: tileContent({
                            date: date
                        })
                    })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "Calendar__bottomActions",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                    className: "Calendar__cancelButton",
                    onClick: ()=>{
                        if (bottomActionCallback) bottomActionCallback();
                        else setValue(null);
                    },
                    children: bottomActionTitle ?? t("calendar.clear")
                })
            })
        ]
    });
});
$dd807b100864eab2$var$Calendar.displayName = "Calendar";
var $dd807b100864eab2$export$2e2bcd8739ae039 = $dd807b100864eab2$var$Calendar;



var $acw62 = parcelRequire("acw62");
function $3820618f4f4eb2a5$export$aa79b0abe3dfeaba(ref, clickHandler) {
    (0, $acw62.useEffect)(()=>{
        function handleClickOutside(event) {
            if (ref.current && !ref.current.contains(event.target)) clickHandler();
        }
        document.addEventListener("mousedown", handleClickOutside);
        return ()=>{
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, [
        ref,
        clickHandler
    ]);
}




function $1579b0c3590d1ee8$export$7edc06cf1783b30f(props) {
    const [showCalendar, setShowCalendar] = (0, $acw62.useState)(false);
    const calendarRef = (0, $acw62.useRef)(null);
    (0, $3820618f4f4eb2a5$export$aa79b0abe3dfeaba)(calendarRef, ()=>setShowCalendar(false));
    const setCalendarValue = (value)=>{
        const formattedValue = value !== null ? (0, $ddf12117b815a7c3$export$efb113ee57e9edfb)(value) : "";
        props.handleChange(formattedValue);
        setShowCalendar(false);
    };
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7b02d682eb115277$exports.Fragment), {
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
            className: `DateInput ${props.className ? props.className : ""}`,
            children: [
                showCalendar && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $dd807b100864eab2$export$2e2bcd8739ae039), {
                    containerStyle: props.calendarContainerStyle,
                    value: new Date(String(props.value)),
                    setValue: setCalendarValue,
                    minDate: props.min ? new Date(props.min) : undefined,
                    maxDate: props.max ? new Date(props.max) : undefined,
                    containerClassName: "DateInput__Calendar",
                    ref: calendarRef
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                    style: props.hideBorder ? {
                        border: "none"
                    } : {},
                    onClick: ()=>{
                        setShowCalendar(true);
                    },
                    className: `DateInput__labelContainer ${!props.value || props.hideValue ? "fullContainer" : ""}`,
                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                        className: "DateInput__labelContainer__label",
                        style: props.hideValue ? {
                            color: "#323246"
                        } : {},
                        children: props.label
                    })
                }),
                !props.hideValue && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                    style: props.hideBorder ? {
                        border: "none"
                    } : {},
                    className: "DateInput__input",
                    type: "text",
                    value: props.value,
                    onClick: ()=>setShowCalendar(true),
                    onFocus: (e)=>props.onFocus?.(e),
                    onBlur: (e)=>props.onBlur?.(e),
                    readOnly: true
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                    className: "DateInput__icon-container",
                    onClick: ()=>setShowCalendar(true),
                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                        src: (0, (/*@__PURE__*/$parcel$interopDefault($0dd61daa778d34c9$exports))),
                        alt: "",
                        className: "DateInput__icon-container__icon"
                    })
                })
            ]
        })
    });
}




const $d91416d5d08ce679$export$6ce409b758b714ba = (0, $aca50e9407ba89c9$export$b6ae1bc530f4c149)(()=>{
    const { t: t } = (0, $3765cebd031b52c0$export$9fc83ad70ead8663)();
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                className: "Popup__title",
                children: t("order_extension.for_how_long_extend")
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                className: "Popup__subtitle",
                children: t("order_extension.you_can_extend_order")
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "OrderExtension__popup__innerContainer",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $1579b0c3590d1ee8$export$7edc06cf1783b30f), {
                    label: t("order_draft.start_date"),
                    value: (0, $d6286036be37a1b2$export$957fdea8025b4555).extensionStartDateForAllJobs ?? "",
                    handleChange: (0, $d6286036be37a1b2$export$957fdea8025b4555).setExtensionStartDateForAllJobs,
                    min: (0, $d6286036be37a1b2$export$957fdea8025b4555).minStartDateForAllJobs ?? undefined,
                    className: "Dates__dateInput"
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $660b2ca422e0e2ae$export$1ff3c3f08ae963c0).Vertical, {
                height: 10
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "OrderExtension__popup__innerContainer",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $1579b0c3590d1ee8$export$7edc06cf1783b30f), {
                    label: t("order_draft.end_date"),
                    value: (0, $d6286036be37a1b2$export$957fdea8025b4555).extensionDateForAllJobs ?? "",
                    handleChange: (0, $d6286036be37a1b2$export$957fdea8025b4555).setExtensionDateForAllJobs,
                    min: (0, $d6286036be37a1b2$export$957fdea8025b4555).extensionStartDateForAllJobs ?? undefined,
                    className: "Dates__dateInput"
                })
            })
        ]
    });
});







var $45fvw = parcelRequire("45fvw");
const $b53338bb4ad22450$export$92521769c5df59ad = (dateString)=>{
    return (0, (/*@__PURE__*/$parcel$interopDefault($45fvw)))(dateString, "YYYY-MM-DD").format("DD MMM");
};





var $acw62 = parcelRequire("acw62");
var $9ffc1f78be29cb32$exports = {};
$9ffc1f78be29cb32$exports = new URL("dropdown-arrow-down.416525a6.svg", import.meta.url).toString();



const $3ce20398feabcf7a$export$1fbc11c9739e5d57 = ({ label: label, items: items, value: value })=>{
    const [isOpen, setIsOpen] = (0, $acw62.useState)(false);
    const toggleIsOpen = ()=>{
        setIsOpen(!isOpen);
    };
    const selectRef = (0, $acw62.useRef)(null);
    (0, $3820618f4f4eb2a5$export$aa79b0abe3dfeaba)(selectRef, ()=>setIsOpen(false));
    if (items.length === 0) return null;
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "DropdownSelect",
        ref: selectRef,
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "DropdownSelect__selector",
                onClick: toggleIsOpen,
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "DropdownSelect__selector__content",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                className: value ? "DropdownSelect__selector__content__title" : "DropdownSelect__selector__content__title--no-value",
                                children: label
                            }),
                            value && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                className: "OrderExtension__job__selector__content__value",
                                children: value
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                        src: (0, (/*@__PURE__*/$parcel$interopDefault($9ffc1f78be29cb32$exports)))
                    })
                ]
            }),
            isOpen && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("ul", {
                className: "DropdownSelect__content",
                children: items.map((item, index)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("li", {
                        className: "DropdownSelect__item",
                        onClick: ()=>{
                            if (item.closeOnClick) setIsOpen(false);
                        },
                        children: item.element
                    }, index))
            })
        ]
    });
};






const $2e5f59aa411f699d$export$2ce376c2cc3355c8 = ({ img: img, title: title, onClick: onClick })=>{
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        onClick: onClick,
        className: "SelectItem",
        children: [
            img,
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $660b2ca422e0e2ae$export$1ff3c3f08ae963c0).Horizontal, {
                width: 16
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                className: "SelectItem__title",
                children: title
            })
        ]
    });
};


const $1be1732e35c33d25$export$74805e29d498a0c = (0, $aca50e9407ba89c9$export$b6ae1bc530f4c149)(()=>{
    const { t: t } = (0, $3765cebd031b52c0$export$9fc83ad70ead8663)();
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                className: "Popup__title",
                children: t("order_extension.for_how_long_extend")
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                className: "Popup__subtitle",
                children: t("order_extension.you_can_extend_order")
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "OrderExtension__popup__innerContainer",
                children: (0, $d6286036be37a1b2$export$957fdea8025b4555).jobsList.map((job, key)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "OrderExtension__job",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "OrderExtension__job__info",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                        className: "OrderExtension__job__location",
                                        children: job.location
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                        className: "OrderExtension__job__designation",
                                        children: [
                                            job.designation,
                                            " ",
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                                className: "OrderExtension__job__quantity",
                                                children: [
                                                    "(",
                                                    job.staffAmount,
                                                    ")"
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                        className: "OrderExtension__job__extensionDate",
                                        children: [
                                            "End Date: ",
                                            (0, $b53338bb4ad22450$export$92521769c5df59ad)(job.endTime)
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $3ce20398feabcf7a$export$1fbc11c9739e5d57), {
                                label: job.shouldBeExtended ? t("order_draft.start_date") : t("order_extension.do_not_extend"),
                                value: job.startDate,
                                items: [
                                    {
                                        element: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $1579b0c3590d1ee8$export$7edc06cf1783b30f), {
                                            calendarContainerStyle: {
                                                left: "-155px",
                                                top: "-15px"
                                            },
                                            hideBorder: true,
                                            hideValue: true,
                                            label: t("order_extension.select_start_date"),
                                            value: job.startDate ?? "",
                                            handleChange: (val)=>(0, $d6286036be37a1b2$export$957fdea8025b4555).setJobExtensionStartDate(job.id, val),
                                            min: job.minStartDate,
                                            className: "Dates__dateInput"
                                        }),
                                        closeOnClick: false
                                    },
                                    {
                                        element: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $2e5f59aa411f699d$export$2ce376c2cc3355c8), {
                                            img: null,
                                            title: t("order_extension.do_not_extend"),
                                            onClick: ()=>{
                                                (0, $d6286036be37a1b2$export$957fdea8025b4555).setJobExtensionStartDate(job.id, null);
                                            }
                                        }),
                                        closeOnClick: true
                                    }
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $3ce20398feabcf7a$export$1fbc11c9739e5d57), {
                                label: job.shouldBeExtended ? t("order_draft.end_date") : t("order_extension.do_not_extend"),
                                value: job.extensionDate,
                                items: [
                                    {
                                        element: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $1579b0c3590d1ee8$export$7edc06cf1783b30f), {
                                            calendarContainerStyle: {
                                                left: "-155px",
                                                top: "-15px"
                                            },
                                            hideBorder: true,
                                            hideValue: true,
                                            label: t("order_extension.select_end_date"),
                                            value: job.extensionDate ?? "",
                                            handleChange: (val)=>(0, $d6286036be37a1b2$export$957fdea8025b4555).setJobExtensionDate(job.id, val),
                                            min: job.startDate ?? undefined,
                                            className: "Dates__dateInput"
                                        }),
                                        closeOnClick: false
                                    },
                                    {
                                        element: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $2e5f59aa411f699d$export$2ce376c2cc3355c8), {
                                            img: null,
                                            title: t("order_extension.do_not_extend"),
                                            onClick: ()=>{
                                                (0, $d6286036be37a1b2$export$957fdea8025b4555).setJobExtensionDate(job.id, null);
                                            }
                                        }),
                                        closeOnClick: true
                                    }
                                ]
                            })
                        ]
                    }, key))
            })
        ]
    });
});




const $9c0551f59559aa01$export$c0bfcb316fefc2db = (0, $a4963babae245ff9$export$f0c7a449e0cfaec7)((0, $aca50e9407ba89c9$export$b6ae1bc530f4c149)(({ isOpen: isOpen, close: close, clearOnClose: clearOnClose, onSuccess: onSuccess = ()=>{} })=>{
    const { createExtendedOrder: createExtendedOrder } = (0, $4671947198ddd366$export$6ccbb43953eebf8)().data;
    const redirect = (0, $7df35e9df335b1c8$export$602eaf6d5314ce55)();
    const { t: t } = (0, $3765cebd031b52c0$export$9fc83ad70ead8663)();
    const [, createExtendedOrderApiCall] = (0, $4671947198ddd366$export$609860bf8b0084c)(({ orderExtension: orderExtension })=>createExtendedOrder(orderExtension), {
        onSuccess: (orderId)=>{
            (0, $d6286036be37a1b2$export$957fdea8025b4555).clear();
            onSuccess();
            redirect((0, $0534349ae8731d0b$export$66b32f6f30eb4b4).extendedOrderDraft, {
                orderId: orderId
            });
        }
    });
    const getNextDisabled = ()=>{
        if ((0, $d6286036be37a1b2$export$957fdea8025b4555).extensionStep === Number((0, $dd3a61673d234628$export$4a260f4ad74ba8c2).DateSelection)) return !(0, $d6286036be37a1b2$export$957fdea8025b4555).jobsForExtensionExist;
        return false;
    };
    const handleNextPress = ()=>{
        if ((0, $d6286036be37a1b2$export$957fdea8025b4555).extensionStep === Number((0, $dd3a61673d234628$export$4a260f4ad74ba8c2).DateSelection)) {
            createExtendedOrderApiCall({
                orderExtension: (0, $d6286036be37a1b2$export$957fdea8025b4555).dataForApiCall
            });
            return;
        }
        (0, $d6286036be37a1b2$export$957fdea8025b4555).goToNextStep();
    };
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $9c16b10bbbe042e5$export$129a32eedafa97c5), {
        isActive: isOpen,
        content: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: "OrderExtension__popup",
                    children: [
                        (0, $d6286036be37a1b2$export$957fdea8025b4555).extensionStep === Number((0, $dd3a61673d234628$export$4a260f4ad74ba8c2).ExtensionTypeSelection) && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $075bb8309516ffda$export$4f037c6ec2da4eeb), {}),
                        (0, $d6286036be37a1b2$export$957fdea8025b4555).extensionStep === Number((0, $dd3a61673d234628$export$4a260f4ad74ba8c2).DateSelection) && (0, $d6286036be37a1b2$export$957fdea8025b4555).useSameExtensionDateForAllJobs && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $d91416d5d08ce679$export$6ce409b758b714ba), {}),
                        (0, $d6286036be37a1b2$export$957fdea8025b4555).extensionStep === Number((0, $dd3a61673d234628$export$4a260f4ad74ba8c2).DateSelection) && !(0, $d6286036be37a1b2$export$957fdea8025b4555).useSameExtensionDateForAllJobs && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $1be1732e35c33d25$export$74805e29d498a0c), {})
                    ]
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $660b2ca422e0e2ae$export$1ff3c3f08ae963c0).Spacer, {}),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $9dfc32a0a996fa14$export$ed8ca599049e8881), {
                    currentStep: (0, $d6286036be37a1b2$export$957fdea8025b4555).extensionStep ?? Number((0, $dd3a61673d234628$export$4a260f4ad74ba8c2).ExtensionTypeSelection),
                    stepsCount: (0, $dd3a61673d234628$export$35ea69340b11d51b),
                    backDisabled: (0, $d6286036be37a1b2$export$957fdea8025b4555).extensionStep === Number((0, $dd3a61673d234628$export$4a260f4ad74ba8c2).ExtensionTypeSelection),
                    nextDisabled: getNextDisabled(),
                    handleNextPress: handleNextPress,
                    handleBackPress: (0, $d6286036be37a1b2$export$957fdea8025b4555).goToPreviousStep,
                    nextButtonLabel: t("page_stepper.next")
                })
            ]
        }),
        close: ()=>{
            close();
            if (clearOnClose) (0, $d6286036be37a1b2$export$957fdea8025b4555).clear();
        }
    });
}));



const $99c94337d4742182$var$OrderSummary = (0, $a4963babae245ff9$export$f0c7a449e0cfaec7)((0, $aca50e9407ba89c9$export$b6ae1bc530f4c149)(({ orderId: orderId })=>{
    const [amendModalVisible, setAmendModalVisible] = (0, $acw62.useState)(false);
    const [isTermsAndConditionsAccepted, setIsTermsAndConditionsAccepted] = (0, $acw62.useState)(false);
    const [orderExtensionPopupVisible, setOrderExtensionPopupVisible] = (0, $acw62.useState)(false);
    const { apiHost: apiHost, getOrderSummary: getOrderSummary, confirmOrder: confirmOrder, confirmOrderTermsConditions: confirmOrderTermsConditions, getOrderIdSummary: getOrderIdSummary, downloadQuotation: downloadQuotation, uploadLPO: uploadLPO, setIsPendingLPOUpload: setIsPendingLPOUpload, setQuoteWasDownloaded: setQuoteWasDownloaded, downloadLPO: downloadLPO, setLPOWasUploaded: setLPOWasUploaded, getUpfrontPaymentId: getUpfrontPaymentId, companyDetails: companyDetails, "get\u0421ompanyDetails": get\u0421ompanyDetails, getInvitedPastSPsByIds: getInvitedPastSPsByIds, invitedPastSPsList: invitedPastSPsList } = (0, $4671947198ddd366$export$6ccbb43953eebf8)().data;
    (0, $4671947198ddd366$export$dd0a697e1782aedd)(get\u0421ompanyDetails);
    const [, getInvitedPastSPsByIdsQuery] = (0, $4671947198ddd366$export$609860bf8b0084c)(({ ids: ids })=>getInvitedPastSPsByIds(ids), {
        onError: (err)=>{
            (0, $60f27fc97e29822a$export$b410431fab84fa58).error(err.data.message);
        }
    });
    const orderSummary = getOrderIdSummary(orderId);
    const orderSummaryQuery = (0, $4671947198ddd366$export$dd0a697e1782aedd)(()=>getOrderSummary({
            orderId: orderId
        }), {
        filterError: [
            (0, $9ad33fbf770c55a1$export$9696fcf1798e1cb5).ClientError
        ],
        onSuccess: (res)=>{
            const invitedSPIds = [];
            res.jobs.forEach((job)=>{
                job.invited_sp_ids.forEach((invitedSPId)=>{
                    if (!invitedSPIds.includes(invitedSPId)) invitedSPIds.push(invitedSPId);
                });
            });
            getInvitedPastSPsByIdsQuery({
                ids: invitedSPIds
            });
        },
        onError: (err)=>{
            (0, $60f27fc97e29822a$export$b410431fab84fa58).error(err.data.message);
        }
    });
    const [confirmOrderQuery, requestConfirmOrder] = (0, $4671947198ddd366$export$609860bf8b0084c)(confirmOrder, {
        onSuccess: ()=>{
            redirect((0, $0534349ae8731d0b$export$66b32f6f30eb4b4).orderCreateSuccess, {
                orderId: orderId
            });
        },
        onError: (err)=>{
            // Makes Sentry to have it as a separate error with all logs/breadcrumbs
            console.error("Confirm Order Summary API Error");
            alert(err.data.message);
        },
        filterError: [
            (0, $9ad33fbf770c55a1$export$9696fcf1798e1cb5).ClientError
        ]
    });
    const [confirmTermsQuery, requestConfirmTerms] = (0, $4671947198ddd366$export$609860bf8b0084c)(confirmOrderTermsConditions, {
        onSuccess: ()=>{
            setIsTermsAndConditionsAccepted(true);
        },
        onError: (err)=>alert(err.data.message),
        filterError: [
            (0, $9ad33fbf770c55a1$export$9696fcf1798e1cb5).ClientError
        ]
    });
    const redirect = (0, $7df35e9df335b1c8$export$602eaf6d5314ce55)();
    const { t: t } = (0, $3765cebd031b52c0$export$9fc83ad70ead8663)();
    const { download: saveFile } = (0, $8aadbb076e78b446$export$fdb90e0242959057)();
    const { enableQuery: downloadQuotationQuery, query: downloadQuotationResult } = (0, $4671947198ddd366$export$517ca4f7fee4e226)(()=>downloadQuotation(orderId), {
        onSuccess: (file)=>{
            saveFile(file, `order_quotation_${orderId}.pdf`);
            setQuoteWasDownloaded(orderId, true);
        }
    });
    const { enableQuery: downloadLPOQuery, query: downloadLPOResult } = (0, $4671947198ddd366$export$517ca4f7fee4e226)(()=>downloadLPO(orderId), {
        onSuccess: (file)=>{
            saveFile(file, `order_lpo_${orderId}.pdf`);
            setQuoteWasDownloaded(orderId, true);
        }
    });
    (0, $acw62.useEffect)(()=>{
        if (orderSummaryQuery.isLoading) return;
        if (!hideConfirmation && (showNonUpfrontConfirmationButton || showAcceptTerms)) (0, $c74a0566d4b0fd6d$export$e9db7d6e73593439).track((0, $c74a0566d4b0fd6d$export$5e27155e276f6d1c).ViewedConfirmOrderSummary);
        else (0, $c74a0566d4b0fd6d$export$e9db7d6e73593439).track((0, $c74a0566d4b0fd6d$export$5e27155e276f6d1c).ViewedSubmittedOrderSummary);
    }, [
        orderSummaryQuery.isLoading
    ]);
    (0, $acw62.useEffect)(()=>{
        if (orderSummary) {
            (0, $d6286036be37a1b2$export$957fdea8025b4555).clear();
            (0, $d6286036be37a1b2$export$957fdea8025b4555).createFromOrderModel(orderSummary);
        }
    }, [
        orderSummary
    ]);
    const LPOFileInputRef = (0, $acw62.useRef)(null);
    const [uploadLPOResult, uploadLPORequest] = (0, $4671947198ddd366$export$609860bf8b0084c)(({ file: file })=>uploadLPO(orderId, file), {
        onSuccess: ()=>{
            setIsPendingLPOUpload(orderId, false);
            setLPOWasUploaded(orderId, true);
            (0, $60f27fc97e29822a$export$b410431fab84fa58).success(t("order.lpo_upload_success_message"));
        },
        onError: (err)=>{
            const uploadLPOErrorMessage = err.data.message;
            const uploadLPOErrors = err.data.errors?.file ?? [];
            const uploadLPOErrorText = uploadLPOErrors.length > 0 ? uploadLPOErrors.join(";") : uploadLPOErrorMessage;
            (0, $60f27fc97e29822a$export$b410431fab84fa58).error(uploadLPOErrorText);
        },
        filterError: [
            (0, $9ad33fbf770c55a1$export$9696fcf1798e1cb5).ClientError
        ]
    });
    const handleUploadLPO = (event)=>{
        const file = event.target.files?.[0];
        if (!file) return;
        event.target.value = "";
        uploadLPORequest({
            file: file
        });
    };
    const showDownloadQuoteActionAlert = Boolean(orderSummary?.is_pending_client_approval) && !orderSummary?.quote_was_downloaded;
    const { enableQuery: pay, query: getUpfrontPaymentIdResult } = (0, $4671947198ddd366$export$517ca4f7fee4e226)(()=>getUpfrontPaymentId(orderId), {
        onSuccess: (paymentId)=>{
            redirect((0, $0534349ae8731d0b$export$66b32f6f30eb4b4).paymentMethodsList, {
                paymentId: String(paymentId),
                paymentOptions: JSON.stringify({
                    redirectToRouteAfterSuccess: "orderConfirmation",
                    redirectToRouteAfterSuccessParams: {
                        orderId: String(orderId)
                    },
                    redirectToRouteAfterSuccessTitle: t("payment.back_to_order")
                })
            });
        }
    });
    const showLoading = orderSummaryQuery.isLoading || confirmOrderQuery.isLoading;
    const disableConfirmButton = !isTermsAndConditionsAccepted || getUpfrontPaymentIdResult.isLoading;
    const isPaymentsEnabled = (0, $2994e7b5ba509fe3$export$f506dd16e02779a7)();
    const hidePaymentFunctionality = !isPaymentsEnabled();
    const isUserProfileCompleted = Boolean(companyDetails?.status_id === (0, $kLorN.CLIENT_STATUS_ACTIVE));
    const hideConfirmation = (0, $73ccb33f5de6f5aa$export$8707029d024490c9)().registration.allowOnlyCorporate && !isUserProfileCompleted;
    const showNonUpfrontConfirmationButton = !hidePaymentFunctionality && Boolean(orderSummary?.is_pending_client_approval) && !Boolean(orderSummary?.is_upfront) || hidePaymentFunctionality && Boolean(orderSummary?.is_pending_client_approval);
    const showAcceptTerms = !hidePaymentFunctionality && !Boolean(orderSummary?.is_draft) && !Boolean(orderSummary?.is_pending_rates_review) && orderSummary?.is_upfront && !orderSummary.is_paid;
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
        children: [
            showLoading ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $57fb8f45c69e1681$export$b08b517936747730), {}) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "OrderSummary",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $60f27fc97e29822a$export$f2815235e76a62b9), {
                        autoClose: 3000
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c9058233d024dfd7$export$8b251419efc915eb), {
                        orderId: orderId,
                        isQuoteDownloading: downloadQuotationResult.isLoading,
                        downloadQuote: downloadQuotationQuery,
                        isPendingLPOUpload: Boolean(orderSummary?.is_pending_lpo_upload),
                        isLPOUploading: uploadLPOResult.isLoading,
                        uploadLPO: ()=>{
                            LPOFileInputRef.current?.click();
                        },
                        downloadLPO: downloadLPOQuery,
                        isLPODownloading: downloadLPOResult.isLoading,
                        lpoWasUploaded: orderSummary?.lpo_was_uploaded ?? false,
                        duplicateOrder: ()=>redirect((0, $0534349ae8731d0b$export$66b32f6f30eb4b4).orderDuplicateChooseJobs, {
                                orderId: orderId
                            }),
                        showQuoteDownload: !orderSummary?.is_draft && !Boolean(orderSummary?.is_pending_rates_review)
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "OrderSummary__container",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4ae5ab5371178941$export$f01b3d7c7bbe3997), {
                                allowedRoles: [
                                    (0, $97fa7686fb8e51ed$export$eb3485a690c2f0b8).Owner,
                                    (0, $97fa7686fb8e51ed$export$eb3485a690c2f0b8).Admin,
                                    (0, $97fa7686fb8e51ed$export$eb3485a690c2f0b8).Finance
                                ],
                                showDefaultFallbackUI: false,
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $a9d8c7b2777a204d$export$2e2bcd8739ae039), {
                                    openOrderExtensionPopup: ()=>setOrderExtensionPopupVisible(true),
                                    pendingConfirmation: Boolean(orderSummary?.is_pending_client_approval),
                                    pendingRates: Boolean(orderSummary?.is_pending_rates_review),
                                    corporateDetailsVerificationStatus: Number(orderSummary?.corporate_details_verification_status)
                                })
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $660b2ca422e0e2ae$export$1ff3c3f08ae963c0).Vertical, {
                                height: 31
                            }),
                            showDownloadQuoteActionAlert && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4ae5ab5371178941$export$f01b3d7c7bbe3997), {
                                allowedRoles: [
                                    (0, $97fa7686fb8e51ed$export$eb3485a690c2f0b8).Owner,
                                    (0, $97fa7686fb8e51ed$export$eb3485a690c2f0b8).Admin,
                                    (0, $97fa7686fb8e51ed$export$eb3485a690c2f0b8).Finance
                                ],
                                showDefaultFallbackUI: false,
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $acw62.Fragment), {
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7a26230deaaf6920$export$944fe0ec49485b21), {
                                            theme: (0, $7a26230deaaf6920$export$14faa19a0f3bbeb2).Orange,
                                            withCloseButton: false,
                                            title: t("order.quotation_download_title"),
                                            actionText: t("order.quotation_download_action_text"),
                                            action: downloadQuotationQuery,
                                            isActionInProgress: downloadQuotationResult.isLoading,
                                            actionInProgressText: t("order.quotation_download_in_progress_text")
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $660b2ca422e0e2ae$export$1ff3c3f08ae963c0).Vertical, {
                                            height: Boolean(orderSummary?.is_pending_lpo_upload) ? 10 : 31
                                        })
                                    ]
                                })
                            }),
                            Boolean(orderSummary?.is_pending_lpo_upload) && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $acw62.Fragment), {
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7a26230deaaf6920$export$944fe0ec49485b21), {
                                        theme: (0, $7a26230deaaf6920$export$14faa19a0f3bbeb2).Orange,
                                        withCloseButton: false,
                                        title: t("order.lpo_upload_title"),
                                        actionText: t("order.lpo_upload_action_text"),
                                        action: ()=>{
                                            LPOFileInputRef.current?.click();
                                        },
                                        isActionInProgress: uploadLPOResult.isLoading,
                                        actionInProgressText: t("order.lpo_upload_in_progress_text")
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $660b2ca422e0e2ae$export$1ff3c3f08ae963c0).Vertical, {
                                        height: 31
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                type: "file",
                                style: {
                                    display: "none"
                                },
                                ref: LPOFileInputRef,
                                onChange: handleUploadLPO
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ec2248901324e8a8$export$2e2bcd8739ae039), {
                                image: (0, (/*@__PURE__*/$parcel$interopDefault($2c242e74e2590f15$exports))),
                                title: t("order.order_summary")
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $660b2ca422e0e2ae$export$1ff3c3f08ae963c0).Vertical, {
                                height: 14
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4a112c2694b1fd4a$export$2e2bcd8739ae039), {
                                orderId: orderId,
                                showCompleteDetails: false,
                                showAmend: false,
                                location: orderSummary?.locations[0].name,
                                paymentTerms: orderSummary?.payment_terms_days,
                                startDate: orderSummary?.start_date ? (0, (/*@__PURE__*/$parcel$interopDefault($45fvw)))(orderSummary.start_date) : null,
                                endDate: orderSummary?.start_date ? (0, (/*@__PURE__*/$parcel$interopDefault($45fvw)))(orderSummary.end_date) : null
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $660b2ca422e0e2ae$export$1ff3c3f08ae963c0).Vertical, {
                                height: 24
                            }),
                            orderSummary && orderSummary.jobs.length > 0 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ec2248901324e8a8$export$2e2bcd8739ae039), {
                                        image: (0, (/*@__PURE__*/$parcel$interopDefault($0d100698f4ff6bc8$exports))),
                                        title: t("order.jobs")
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $660b2ca422e0e2ae$export$1ff3c3f08ae963c0).Vertical, {
                                        height: 14
                                    })
                                ]
                            }),
                            orderSummary?.jobs.map((job, i)=>{
                                const invitedSPs = invitedPastSPsList.filter((sp)=>job.invited_sp_ids.includes(sp.id));
                                return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $acw62.Fragment), {
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $d65ef9483570d398$export$2e2bcd8739ae039), {
                                            work_category_name: job.work_category_name,
                                            start_date: (0, (/*@__PURE__*/$parcel$interopDefault($45fvw)))(job.start_date),
                                            end_date: (0, (/*@__PURE__*/$parcel$interopDefault($45fvw)))(job.end_date),
                                            hours: job.hours,
                                            currency: job.currency,
                                            shifts: job.shifts,
                                            hourly_rate: job.hourly_rate,
                                            quantity: job.quantity,
                                            transportation_costs: job.transportation_costs,
                                            underReview: Boolean(orderSummary.is_pending_rates_review),
                                            invitedSPs: invitedSPs
                                        }),
                                        i !== orderSummary.jobs.length - 1 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $660b2ca422e0e2ae$export$1ff3c3f08ae963c0).Vertical, {
                                            height: 14
                                        })
                                    ]
                                }, job.id);
                            }),
                            orderSummary?.is_pending_rates_review === 0 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7b02d682eb115277$exports.Fragment), {
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $4ae5ab5371178941$export$f01b3d7c7bbe3997), {
                                    allowedRoles: [
                                        (0, $97fa7686fb8e51ed$export$eb3485a690c2f0b8).Owner,
                                        (0, $97fa7686fb8e51ed$export$eb3485a690c2f0b8).Admin,
                                        (0, $97fa7686fb8e51ed$export$eb3485a690c2f0b8).Finance
                                    ],
                                    showDefaultFallbackUI: false,
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $660b2ca422e0e2ae$export$1ff3c3f08ae963c0).Vertical, {
                                            height: 24
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ec2248901324e8a8$export$2e2bcd8739ae039), {
                                            image: (0, (/*@__PURE__*/$parcel$interopDefault($5e254c5a797c259d$exports))),
                                            title: t("order.cost")
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $660b2ca422e0e2ae$export$1ff3c3f08ae963c0).Vertical, {
                                            height: 14
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $a5e8fce3ee993db4$export$2e2bcd8739ae039), {
                                            sub_total: orderSummary.sub_total,
                                            tax: orderSummary.tax,
                                            tax_percent: orderSummary.tax_percentage,
                                            transportation_total: orderSummary.transportation_total,
                                            total: orderSummary.total,
                                            currency: orderSummary.currency
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $660b2ca422e0e2ae$export$1ff3c3f08ae963c0).Vertical, {
                                height: 31
                            }),
                            !hideConfirmation && showNonUpfrontConfirmationButton && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $4ae5ab5371178941$export$f01b3d7c7bbe3997), {
                                        showDefaultFallbackUI: false,
                                        allowedRoles: [
                                            (0, $97fa7686fb8e51ed$export$eb3485a690c2f0b8).Admin,
                                            (0, $97fa7686fb8e51ed$export$eb3485a690c2f0b8).Owner,
                                            (0, $97fa7686fb8e51ed$export$eb3485a690c2f0b8).Finance
                                        ],
                                        children: [
                                            confirmTermsQuery.isLoading ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $57fb8f45c69e1681$export$b08b517936747730), {}) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c6f05f53c1840e94$export$d3fa8faf524123), {
                                                        isTermsAndConditionsAccepted: isTermsAndConditionsAccepted,
                                                        requestConfirmTerms: requestConfirmTerms,
                                                        apiHost: apiHost
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $660b2ca422e0e2ae$export$1ff3c3f08ae963c0).Vertical, {
                                                        height: 31
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $2ab88429e3384d30$export$353f5b6fc5456de1), {
                                                onClick: ()=>requestConfirmOrder({
                                                        orderId: orderId
                                                    }),
                                                disabled: disableConfirmButton,
                                                className: `OrderSummary__confirmButton ${disableConfirmButton ? "disabled" : ""}`,
                                                children: t("order.confirm")
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $660b2ca422e0e2ae$export$1ff3c3f08ae963c0).Vertical, {
                                        height: 24
                                    })
                                ]
                            }),
                            !Boolean(orderSummary?.is_published) && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4ae5ab5371178941$export$f01b3d7c7bbe3997), {
                                allowedRoles: [
                                    (0, $97fa7686fb8e51ed$export$eb3485a690c2f0b8).Owner,
                                    (0, $97fa7686fb8e51ed$export$eb3485a690c2f0b8).Admin,
                                    (0, $97fa7686fb8e51ed$export$eb3485a690c2f0b8).Finance
                                ],
                                showDefaultFallbackUI: false,
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $2ab88429e3384d30$export$353f5b6fc5456de1), {
                                    onClick: ()=>{
                                        if (orderSummary?.is_draft) redirect((0, $0534349ae8731d0b$export$66b32f6f30eb4b4).orderDraft, {
                                            orderId: orderId
                                        });
                                        else setAmendModalVisible(true);
                                    },
                                    className: "OrderSummary__amendButton",
                                    children: t("order.amend_order")
                                })
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $660b2ca422e0e2ae$export$1ff3c3f08ae963c0).Vertical, {
                                height: 140
                            })
                        ]
                    }),
                    !hideConfirmation && showAcceptTerms && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4ae5ab5371178941$export$f01b3d7c7bbe3997), {
                        allowedRoles: [
                            (0, $97fa7686fb8e51ed$export$eb3485a690c2f0b8).Owner,
                            (0, $97fa7686fb8e51ed$export$eb3485a690c2f0b8).Admin,
                            (0, $97fa7686fb8e51ed$export$eb3485a690c2f0b8).Finance
                        ],
                        showDefaultFallbackUI: false,
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $4a1895475c466679$export$c072955bb62eb0e2), {
                            contentStyle: {
                                flexDirection: "column",
                                alignItems: "flex-start"
                            },
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                    className: "OrderSummary__PayButton__termsBlock",
                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c6f05f53c1840e94$export$d3fa8faf524123), {
                                        isTermsAndConditionsAccepted: isTermsAndConditionsAccepted,
                                        requestConfirmTerms: requestConfirmTerms,
                                        apiHost: apiHost
                                    })
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                    className: "OrderSummary__PayButton__payBlock",
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                            className: "OrderSummary__PayButton__description",
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                    className: "OrderSummary__PayButton__description__title",
                                                    children: t("payment.overdue_balance")
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                                    className: "OrderSummary__PayButton__description__amount",
                                                    children: [
                                                        orderSummary.currency,
                                                        " ",
                                                        orderSummary.total
                                                    ]
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $2ab88429e3384d30$export$353f5b6fc5456de1), {
                                            onClick: pay,
                                            style: {
                                                margin: "0"
                                            },
                                            disabled: disableConfirmButton,
                                            className: `OrderSummary__confirmButton ${disableConfirmButton ? "disabled" : ""}`,
                                            children: getUpfrontPaymentIdResult.isLoading ? "loading" : t("payment.pay_now")
                                        })
                                    ]
                                })
                            ]
                        })
                    }),
                    !showAcceptTerms && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4ae5ab5371178941$export$f01b3d7c7bbe3997), {
                        allowedRoles: [
                            (0, $97fa7686fb8e51ed$export$eb3485a690c2f0b8).Owner,
                            (0, $97fa7686fb8e51ed$export$eb3485a690c2f0b8).Admin,
                            (0, $97fa7686fb8e51ed$export$eb3485a690c2f0b8).Finance
                        ],
                        showDefaultFallbackUI: false,
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4a1895475c466679$export$c072955bb62eb0e2), {
                            contentStyle: {
                                justifyContent: "center"
                            },
                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $2ab88429e3384d30$export$353f5b6fc5456de1), {
                                onClick: ()=>redirect((0, $0534349ae8731d0b$export$66b32f6f30eb4b4).orderDuplicateChooseJobs, {
                                        orderId: orderId
                                    }),
                                className: "OrderSummary__confirmButton",
                                children: t("duplicate_order.duplicate_order")
                            })
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $9c0551f59559aa01$export$c0bfcb316fefc2db), {
                isOpen: orderExtensionPopupVisible,
                close: ()=>setOrderExtensionPopupVisible(false),
                onSuccess: ()=>(0, $c74a0566d4b0fd6d$export$e9db7d6e73593439).track((0, $c74a0566d4b0fd6d$export$5e27155e276f6d1c).ExtendedOrderFromOrderDetails),
                clearOnClose: false
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $6786bdc1b3bfab18$export$34e8fb8cb149ae41), {
                modalVisible: amendModalVisible,
                onClose: ()=>{
                    setAmendModalVisible(false);
                },
                orderId: orderId
            })
        ]
    });
}));
var $99c94337d4742182$export$2e2bcd8739ae039 = $99c94337d4742182$var$OrderSummary;






var $45fvw = parcelRequire("45fvw");

var $acw62 = parcelRequire("acw62");



const $324dc7daf4e64dab$var$MIN_SPACE_TO_BOTTOM = 100;
const $324dc7daf4e64dab$export$5bd4c3b2b0a1aaf1 = (callback)=>{
    return (e)=>{
        const closeToBottom = e.currentTarget.scrollHeight - e.currentTarget.scrollTop - e.currentTarget.clientHeight < $324dc7daf4e64dab$var$MIN_SPACE_TO_BOTTOM;
        if (closeToBottom) callback();
    };
};







var $acw62 = parcelRequire("acw62");


var $bad31fa192b525ae$exports = {};
$bad31fa192b525ae$exports = new URL("calender-icon-grey.79d7ed69.svg", import.meta.url).toString();




var $7dbbbb6844d31f11$exports = {};
$7dbbbb6844d31f11$exports = new URL("3-dots.d2a22f59.svg", import.meta.url).toString();


var $c059f3362464885b$exports = {};
$c059f3362464885b$exports = new URL("calendar-next.563f168f.svg", import.meta.url).toString();


var $1792fb439084b800$exports = {};
$1792fb439084b800$exports = new URL("copy.0a90c4ec.svg", import.meta.url).toString();




const $799e106d98f81703$var$getProgressFillerColorByCompleteness = (completeness)=>{
    if (completeness >= 85) return "rgba(248, 140, 153, 1)";
    if (completeness >= 50) return "rgba(252, 179, 92, 1)";
    return "rgba(112, 148, 247, 1)";
};
const $799e106d98f81703$export$30f1a433d26febc2 = ({ id: id, startDateString: startDateString, endDateString: endDateString, jobs: jobs, status: status, daysTillEndCount: daysTillEndCount, showStatusLabel: showStatusLabel, openOrderExtensionPopup: openOrderExtensionPopup, openOrderDuplicationPage: openOrderDuplicationPage })=>{
    const { t: t } = (0, $3765cebd031b52c0$export$9fc83ad70ead8663)();
    const getLabelByStatus = ()=>{
        switch(status){
            case "draft":
                return "order_status.draft";
            case "pendingConfirmation":
                return "order_status.pending_confirmation";
            case "underReview":
                return "order_status.under_review";
            case "started":
                return "order_status.started";
            case "upcoming":
                return "order_status.upcoming";
        }
    };
    const showProgressBar = status === "started";
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "OrderCard",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "OrderCard__header",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                        className: "OrderCard__header__title",
                        children: t("order.order_number", {
                            id: id
                        })
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $04012d5b0475752e$export$e44a253a59704894), {
                        outerComponent: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                            src: (0, (/*@__PURE__*/$parcel$interopDefault($7dbbbb6844d31f11$exports)))
                        }),
                        items: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $bd25114c2c6a2977$export$2ce376c2cc3355c8), {
                                img: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                                    src: (0, (/*@__PURE__*/$parcel$interopDefault($1792fb439084b800$exports)))
                                }),
                                title: t("order.duplicate_order"),
                                onClick: (event)=>{
                                    event.stopPropagation();
                                    openOrderDuplicationPage();
                                }
                            }, "duplicate"),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $bd25114c2c6a2977$export$2ce376c2cc3355c8), {
                                img: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                                    src: (0, (/*@__PURE__*/$parcel$interopDefault($c059f3362464885b$exports)))
                                }),
                                title: t("order_extension.extend_order"),
                                onClick: (event)=>{
                                    event.stopPropagation();
                                    openOrderExtensionPopup();
                                }
                            }, "extend")
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $660b2ca422e0e2ae$export$1ff3c3f08ae963c0).Vertical, {
                height: 16
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "OrderCard__jobsList",
                children: jobs.map((job, index)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $acw62.Fragment), {
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "OrderCard__occupationRow",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                        className: "OrderCard__occupationRow__label",
                                        children: [
                                            job.work_category_name,
                                            " (",
                                            job.quantity,
                                            ")"
                                        ]
                                    }),
                                    showStatusLabel && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                        className: `OrderCard__occupationRow__status ${status}`,
                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                            className: "OrderCard__occupationRow__status__label",
                                            children: t(getLabelByStatus())
                                        })
                                    }),
                                    showProgressBar && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        className: "OrderCard__occupationRow__progressBar",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                                className: "OrderCard__occupationRow__progressBar__title",
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                                        className: "OrderCard__occupationRow__progressBar__titleDays",
                                                        children: [
                                                            job.days_till_end_count,
                                                            " ",
                                                            t("order.days")
                                                        ]
                                                    }),
                                                    " ",
                                                    t("order.to_end")
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                className: "OrderCard__occupationRow__progressBar__filledArea",
                                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                    className: "OrderCard__occupationRow__progressBar__filler",
                                                    style: {
                                                        width: `${job.completeness}%`,
                                                        background: $799e106d98f81703$var$getProgressFillerColorByCompleteness(job.completeness)
                                                    }
                                                })
                                            })
                                        ]
                                    })
                                ]
                            }),
                            index !== jobs.length - 1 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $660b2ca422e0e2ae$export$1ff3c3f08ae963c0).Vertical, {
                                height: 12
                            })
                        ]
                    }, job.id))
            }),
            Boolean(startDateString && endDateString) && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "OrderCard__dateContainer",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                        src: (0, (/*@__PURE__*/$parcel$interopDefault($bad31fa192b525ae$exports))),
                        alt: "",
                        className: "OrderCard__header__dateContainer__calendarImg"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $660b2ca422e0e2ae$export$1ff3c3f08ae963c0).Horizontal, {
                        width: 9
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                        className: "OrderCard__dateContainer__dateLabel",
                        children: [
                            (0, $b53338bb4ad22450$export$92521769c5df59ad)(startDateString),
                            " - ",
                            (0, $b53338bb4ad22450$export$92521769c5df59ad)(endDateString)
                        ]
                    })
                ]
            })
        ]
    });
};










var $3ef11b4624cb8bb1$exports = {};
$3ef11b4624cb8bb1$exports = new URL("calendar.2ba50970.svg", import.meta.url).toString();



const $f3b0af6dd5a3bf0c$export$9a2ee3ab5c2cc44 = (0, $aca50e9407ba89c9$export$b6ae1bc530f4c149)(()=>{
    const redirect = (0, $7df35e9df335b1c8$export$602eaf6d5314ce55)();
    const { t: t } = (0, $3765cebd031b52c0$export$9fc83ad70ead8663)();
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "EmptyOrderList",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $660b2ca422e0e2ae$export$1ff3c3f08ae963c0).Spacer, {
                flex: 0.5
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                src: (0, (/*@__PURE__*/$parcel$interopDefault($3ef11b4624cb8bb1$exports))),
                className: "EmptyOrderList__calendarImg"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $660b2ca422e0e2ae$export$1ff3c3f08ae963c0).Vertical, {
                height: 21
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                className: "EmptyOrderList__title",
                children: t("orders_list.empty_list_title")
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $660b2ca422e0e2ae$export$1ff3c3f08ae963c0).Vertical, {
                height: 6
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                className: "EmptyOrderList__description",
                children: t("orders_list.empty_list_description")
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $660b2ca422e0e2ae$export$1ff3c3f08ae963c0).Vertical, {
                height: 47
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $2ab88429e3384d30$export$353f5b6fc5456de1), {
                title: t("orders_list.create_order"),
                onClick: ()=>{
                    redirect((0, $0534349ae8731d0b$export$66b32f6f30eb4b4).setJobCategory, {});
                },
                className: "EmptyOrderList__createOrderButton"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $660b2ca422e0e2ae$export$1ff3c3f08ae963c0).Spacer, {})
        ]
    });
});




const $1517d97a0e4f4f9f$export$b2539bed5023c21c = ({ tabs: tabs })=>{
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        className: "tabs__container",
        children: tabs.map((tab, index)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("button", {
                className: `tabs__container__button${tab.isActive ? " tabs__container__button--active" : ""}`,
                onClick: tab.onClick,
                children: [
                    tab.title,
                    tab.showUpdatesIndicator && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "tabs__container__updates-indicator"
                    })
                ]
            }, index))
    });
};








var $acw62 = parcelRequire("acw62");

var $45fvw = parcelRequire("45fvw");




const $59702376b7305ab4$var$getFormattedDate = (dateString)=>{
    return (0, (/*@__PURE__*/$parcel$interopDefault($45fvw)))(dateString, "YYYY-MM-DD").format("DD MMM");
};
const $59702376b7305ab4$export$e4e14436bab98dc2 = ({ id: id, startDateString: startDateString, endDateString: endDateString, jobs: jobs, status: status, showStatusLabel: showStatusLabel })=>{
    const { t: t } = (0, $3765cebd031b52c0$export$9fc83ad70ead8663)();
    const getLabelByStatus = ()=>{
        switch(status){
            case "draft":
                return "order_status.draft";
            case "pendingConfirmation":
                return "order_status.pending_confirmation";
            case "underReview":
                return "order_status.under_review";
            case "started":
                return "order_status.started";
            case "upcoming":
                return "order_status.upcoming";
        }
    };
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "OrderCard",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "OrderCard__header",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                        className: "OrderCard__header__title",
                        children: t("order.order_number", {
                            id: id
                        })
                    }),
                    Boolean(startDateString && endDateString) && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "OrderCard__header__dateContainer",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                                src: (0, (/*@__PURE__*/$parcel$interopDefault($bad31fa192b525ae$exports))),
                                alt: "",
                                className: "OrderCard__header__dateContainer__calendarImg"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $660b2ca422e0e2ae$export$1ff3c3f08ae963c0).Horizontal, {
                                width: 9
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                className: "OrderCard__header__dateContainer__dateLabel",
                                children: [
                                    $59702376b7305ab4$var$getFormattedDate(startDateString),
                                    " - ",
                                    $59702376b7305ab4$var$getFormattedDate(endDateString)
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $660b2ca422e0e2ae$export$1ff3c3f08ae963c0).Vertical, {
                height: 16
            }),
            jobs.map((job, index)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $acw62.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: "OrderCard__occupationRow",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                    className: "OrderCard__occupationRow__label",
                                    children: [
                                        job.work_category_name,
                                        " (",
                                        job.quantity,
                                        ")"
                                    ]
                                }),
                                showStatusLabel && index === jobs.length - 1 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                    className: `OrderCard__occupationRow__status ${status}`,
                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                        className: "OrderCard__occupationRow__status__label",
                                        children: t(getLabelByStatus())
                                    })
                                })
                            ]
                        }),
                        index !== jobs.length - 1 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $660b2ca422e0e2ae$export$1ff3c3f08ae963c0).Vertical, {
                            height: 12
                        })
                    ]
                }, job.id))
        ]
    });
};





var $7df9700294eace29$exports = {};
$7df9700294eace29$exports = new URL("filter.82e16b38.svg", import.meta.url).toString();


const $1a76ba0c0e8a8aa8$export$16bac73b44412208 = ({ setShowFilters: setShowFilters, activeFiltersCount: activeFiltersCount, className: className })=>{
    const { t: t } = (0, $3765cebd031b52c0$export$9fc83ad70ead8663)();
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        onClick: ()=>setShowFilters(true),
        className: `filterButton ${className}`,
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                src: (0, (/*@__PURE__*/$parcel$interopDefault($7df9700294eace29$exports))),
                className: "filterButton__icon"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                className: "filterButton__title",
                children: t("common.filter")
            }),
            activeFiltersCount > 0 ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "filterButton__indicator",
                children: activeFiltersCount
            }) : null
        ]
    });
};










const $d931e957e209e988$export$bea8ebba691c5813 = ({ active: active, onToggle: onToggle })=>{
    const { t: t } = (0, $3765cebd031b52c0$export$9fc83ad70ead8663)();
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        onClick: onToggle,
        className: `Toggle ${active ? "active" : ""}`,
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "Toggle__background"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "Toggle__switch",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                    className: "Toggle__switch__label",
                    children: active ? t("toggle.yes_short") : t("toggle.no_short")
                })
            })
        ]
    });
};





const $009f3befb8e18271$export$2955d454eecc45c0 = ({ text: text, action: action, additionalStyle: additionalStyle })=>{
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
        className: "Button__secondary",
        onClick: action,
        style: additionalStyle,
        children: text
    });
};






const $66ad07cea274b3ca$export$bd5942e90f94bfa2 = (0, $aca50e9407ba89c9$export$b6ae1bc530f4c149)(({ label: label, value: value, onChange: onChange, className: className })=>{
    const { locationsDataView: locationsDataView, getLocations: getLocations } = (0, $4671947198ddd366$export$6ccbb43953eebf8)().data;
    const { isLoading: locationsLoading } = (0, $4671947198ddd366$export$dd0a697e1782aedd)(()=>getLocations({}));
    const locationOptions = locationsDataView.length > 0 ? locationsDataView.map((location)=>({
            key: String(location.id),
            label: location.name,
            value: location.id
        })) : [];
    if (locationsLoading) return null;
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f2c1b8699595d8c0$export$ef9b1a59e592288f), {
        label: label,
        value: value,
        onChange: onChange,
        options: locationOptions,
        className: className
    });
});






const $ecebdfe0fc8439b1$export$eff1d71c0b599d12 = (0, $aca50e9407ba89c9$export$b6ae1bc530f4c149)(({ label: label, value: value, onChange: onChange, className: className })=>{
    const { professionList: professionList, getProfessions: getProfessions } = (0, $4671947198ddd366$export$6ccbb43953eebf8)().data;
    const { isLoading: professionsLoading } = (0, $4671947198ddd366$export$dd0a697e1782aedd)(()=>getProfessions({}));
    const professionOptions = professionList.length > 0 ? professionList.map((designation)=>({
            key: String(designation.id),
            label: designation.name,
            value: designation.id
        })) : [];
    if (professionsLoading) return null;
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f2c1b8699595d8c0$export$ef9b1a59e592288f), {
        label: label,
        value: value,
        onChange: onChange,
        options: professionOptions,
        className: className
    });
});








const $4a5b5d2d463d2a80$export$7bd092201b7b7dda = (0, $aca50e9407ba89c9$export$b6ae1bc530f4c149)(({ label: label, value: value, onChange: onChange, className: className })=>{
    const { pointsOfContact: pointsOfContact, getPointsOfContact: getPointsOfContact } = (0, $4671947198ddd366$export$6ccbb43953eebf8)().data;
    const { isLoading: pointsOfContactLoading } = (0, $4671947198ddd366$export$dd0a697e1782aedd)(()=>getPointsOfContact({}));
    const pointsOfContactOptions = Number(pointsOfContact?.length) > 0 ? (pointsOfContact ?? []).map((pointOfContact)=>({
            key: String(pointOfContact.id),
            label: `${pointOfContact.first_name} ${pointOfContact.last_name}`,
            value: pointOfContact.id
        })) : [];
    if (pointsOfContactLoading) return null;
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f2c1b8699595d8c0$export$ef9b1a59e592288f), {
        label: label,
        value: value,
        onChange: onChange,
        options: pointsOfContactOptions,
        className: className
    });
});


const $a4b7c1ff8b9d775f$export$ac5177ff6a0d9687 = ({ isOpen: isOpen, close: close, pointOfContactId: pointOfContactId, setPointOfContactId: setPointOfContactId, locationId: locationId, setLocationId: setLocationId, designationId: designationId, setDesignationId: setDesignationId, isFavorite: isFavorite, setIsFavorite: setIsFavorite, orderId: orderId, setOrderId: setOrderId, isOverdue: isOverdue, setIsOverdue: setIsOverdue, reset: reset, apply: apply, startDate: startDate, setStartDate: setStartDate, startDateLabel: startDateLabel, endDate: endDate, setEndDate: setEndDate, endDateLabel: endDateLabel, fields: fields })=>{
    const { t: t } = (0, $3765cebd031b52c0$export$9fc83ad70ead8663)();
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $9c16b10bbbe042e5$export$129a32eedafa97c5), {
        isActive: isOpen,
        content: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
            className: "FiltersPopup",
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: "FiltersPopup__titleContainer",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                            src: (0, (/*@__PURE__*/$parcel$interopDefault($7df9700294eace29$exports)))
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                            children: t("common.filters")
                        })
                    ]
                }),
                fields.includes("pointOfContactId") && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                    className: "FiltersPopup__filterContainer",
                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4a5b5d2d463d2a80$export$7bd092201b7b7dda), {
                        label: t("job_draft_details.point_of_contact"),
                        value: pointOfContactId,
                        onChange: (value)=>{
                            setPointOfContactId?.(value);
                        },
                        className: "FiltersPopup__select"
                    })
                }),
                fields.includes("orderId") && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                    className: "FiltersPopup__filterContainer",
                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4e342c5928158118$export$f5b8910cec6cf069), {
                        label: t("common.order_id"),
                        type: "number",
                        value: orderId,
                        handleChange: (value)=>setOrderId?.(Number(value)),
                        className: "FiltersPopup__text"
                    })
                }),
                fields.includes("locationId") && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                    className: "FiltersPopup__filterContainer",
                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $66ad07cea274b3ca$export$bd5942e90f94bfa2), {
                        label: t("common.location"),
                        value: locationId,
                        onChange: (value)=>{
                            setLocationId?.(value);
                        },
                        className: "FiltersPopup__select"
                    })
                }),
                fields.includes("designationId") && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                    className: "FiltersPopup__filterContainer",
                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ecebdfe0fc8439b1$export$eff1d71c0b599d12), {
                        label: t("common.designation"),
                        value: designationId,
                        onChange: (value)=>{
                            setDesignationId?.(value);
                        },
                        className: "FiltersPopup__select"
                    })
                }),
                fields.includes("isFavorite") && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                    className: "FiltersPopup__filterContainer",
                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "FiltersPopup__toggle",
                        onClick: ()=>setIsFavorite?.(!isFavorite),
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                children: t("staff.favorite_only")
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $d931e957e209e988$export$bea8ebba691c5813), {
                                active: Boolean(isFavorite),
                                onToggle: ()=>{}
                            })
                        ]
                    })
                }),
                fields.includes("isOverdue") && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                    className: "FiltersPopup__filterContainer",
                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "FiltersPopup__toggle",
                        onClick: ()=>setIsOverdue?.(!isOverdue),
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                children: t("common.is_overdue")
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $d931e957e209e988$export$bea8ebba691c5813), {
                                active: Boolean(isOverdue),
                                onToggle: ()=>{}
                            })
                        ]
                    })
                }),
                fields.includes("startDate") && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                    className: "FiltersPopup__filterContainer",
                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $1579b0c3590d1ee8$export$7edc06cf1783b30f), {
                        label: startDateLabel ?? t("job_draft_details.start_date"),
                        value: startDate,
                        handleChange: (value)=>{
                            setStartDate?.(value);
                        }
                    })
                }),
                fields.includes("endDate") && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                    className: "FiltersPopup__filterContainer",
                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $1579b0c3590d1ee8$export$7edc06cf1783b30f), {
                        label: endDateLabel ?? t("job_draft_details.end_date"),
                        value: endDate,
                        handleChange: (value)=>{
                            setEndDate?.(value);
                        }
                    })
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: "FiltersPopup__actions",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $2c46e9e1f89bee75$export$2b47962e4e24eb4d), {
                            text: t("staff.apply"),
                            action: apply
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $009f3befb8e18271$export$2955d454eecc45c0), {
                            text: t("staff.reset"),
                            action: reset
                        })
                    ]
                })
            ]
        }),
        close: close
    });
};



var $i56po = parcelRequire("i56po");
const $782f894a7b2f8796$var$OrdersList = (0, $i56po.types).model("OrdersList", {
    searchFilters: (0, $i56po.types).model({
        locationId: (0, $i56po.types).maybeNull((0, $i56po.types).number),
        designationId: (0, $i56po.types).maybeNull((0, $i56po.types).number),
        startDate: (0, $i56po.types).maybeNull((0, $i56po.types).string),
        endDate: (0, $i56po.types).maybeNull((0, $i56po.types).string)
    })
}).actions((self)=>({
        setLocationId (locationId) {
            self.searchFilters.locationId = locationId;
        },
        setDesignationId (designationId) {
            self.searchFilters.designationId = designationId;
        },
        setStartDate (startDate) {
            self.searchFilters.startDate = startDate;
        },
        setEndDate (endDate) {
            self.searchFilters.endDate = endDate;
        },
        reset () {
            self.searchFilters.locationId = null;
            self.searchFilters.designationId = null;
            self.searchFilters.startDate = null;
            self.searchFilters.endDate = null;
        }
    })).views((self)=>({
        get activeFiltersCount () {
            return [
                self.searchFilters.locationId,
                self.searchFilters.designationId,
                self.searchFilters.startDate,
                self.searchFilters.endDate
            ].filter((value)=>Boolean(value)).length;
        }
    }));
const $782f894a7b2f8796$export$dccf14f226b0b9b5 = $782f894a7b2f8796$var$OrdersList.create({
    searchFilters: {
        locationId: null,
        designationId: null,
        startDate: null,
        endDate: null
    }
});



const $a7af6a8b471cb395$export$930ab85cf7ad0060 = (0, $a4963babae245ff9$export$f0c7a449e0cfaec7)((0, $aca50e9407ba89c9$export$b6ae1bc530f4c149)(({ ordersState: ordersState })=>{
    const redirect = (0, $7df35e9df335b1c8$export$602eaf6d5314ce55)();
    const { t: t } = (0, $3765cebd031b52c0$export$9fc83ad70ead8663)();
    const [isFiltersPopupOpen, setIsFiltersPopupOpen] = (0, $acw62.useState)(false);
    const [orderIdToExtend, setOrderIdToExtend] = (0, $acw62.useState)(null);
    const tabs = [
        {
            title: t("orders_list.tab_title_pending"),
            onClick: ()=>redirect((0, $0534349ae8731d0b$export$66b32f6f30eb4b4).orders, {
                    ordersState: (0, $0f571f43d43ce782$export$819724757aafc79).Unconfirmed
                }),
            isActive: ordersState === (0, $0f571f43d43ce782$export$819724757aafc79).Unconfirmed
        },
        {
            title: t("orders_list.tab_title_active"),
            onClick: ()=>redirect((0, $0534349ae8731d0b$export$66b32f6f30eb4b4).orders, {
                    ordersState: (0, $0f571f43d43ce782$export$819724757aafc79).Active
                }),
            isActive: ordersState === (0, $0f571f43d43ce782$export$819724757aafc79).Active
        },
        {
            title: t("orders_list.tab_title_completed"),
            onClick: ()=>redirect((0, $0534349ae8731d0b$export$66b32f6f30eb4b4).orders, {
                    ordersState: (0, $0f571f43d43ce782$export$819724757aafc79).Completed
                }),
            isActive: ordersState === (0, $0f571f43d43ce782$export$819724757aafc79).Completed
        }
    ];
    const { orders: orders, getOrders: getOrders } = (0, $4671947198ddd366$export$6ccbb43953eebf8)().data;
    const [getOrdersMutation, getOrdersApiCall] = (0, $4671947198ddd366$export$609860bf8b0084c)(({ state: state, locationId: locationId, designationId: designationId, startDate: startDate, endDate: endDate, page: page })=>getOrders(state, locationId, designationId, startDate, endDate, page));
    const fetchOrdersList = (page)=>{
        getOrdersApiCall({
            state: ordersState,
            locationId: (0, $782f894a7b2f8796$export$dccf14f226b0b9b5).searchFilters.locationId,
            designationId: (0, $782f894a7b2f8796$export$dccf14f226b0b9b5).searchFilters.designationId,
            startDate: (0, $782f894a7b2f8796$export$dccf14f226b0b9b5).searchFilters.startDate,
            endDate: (0, $782f894a7b2f8796$export$dccf14f226b0b9b5).searchFilters.endDate,
            ...page ? {
                page: page
            } : {}
        });
    };
    (0, $acw62.useEffect)(()=>{
        getOrdersApiCall({
            state: ordersState,
            locationId: (0, $782f894a7b2f8796$export$dccf14f226b0b9b5).searchFilters.locationId,
            designationId: (0, $782f894a7b2f8796$export$dccf14f226b0b9b5).searchFilters.designationId,
            startDate: (0, $782f894a7b2f8796$export$dccf14f226b0b9b5).searchFilters.startDate,
            endDate: (0, $782f894a7b2f8796$export$dccf14f226b0b9b5).searchFilters.endDate,
            page: 1
        });
    }, [
        ordersState
    ]);
    (0, $acw62.useEffect)(()=>{
        const order = orders.find((item)=>item.id === orderIdToExtend);
        if (order) {
            (0, $d6286036be37a1b2$export$957fdea8025b4555).clear();
            (0, $d6286036be37a1b2$export$957fdea8025b4555).createFromOrderModel(order);
        }
    }, [
        orderIdToExtend
    ]);
    const handleScroll = (0, $324dc7daf4e64dab$export$5bd4c3b2b0a1aaf1)(fetchOrdersList);
    const getOrderStatus = (order)=>{
        if (order.is_pending_rates_review) return "underReview";
        if (order.is_pending_client_approval) return "pendingConfirmation";
        if (order.is_draft) return "draft";
        if ((0, (/*@__PURE__*/$parcel$interopDefault($45fvw)))().isAfter(order.start_date)) return "started";
        return "upcoming";
    };
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "OrderConfirmationList",
        onScroll: handleScroll,
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7ae42b63183f30b4$export$8b251419efc915eb), {
                title: t("orders_list.title"),
                rightComponent: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $1a76ba0c0e8a8aa8$export$16bac73b44412208), {
                    setShowFilters: setIsFiltersPopupOpen,
                    activeFiltersCount: (0, $782f894a7b2f8796$export$dccf14f226b0b9b5).activeFiltersCount,
                    className: "OrderConfirmationList__filtersButton"
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $660b2ca422e0e2ae$export$1ff3c3f08ae963c0).Vertical, {
                height: 35
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "OrderConfirmationList__container",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $1517d97a0e4f4f9f$export$b2539bed5023c21c), {
                        tabs: tabs
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $660b2ca422e0e2ae$export$1ff3c3f08ae963c0).Vertical, {
                        height: 20
                    }),
                    !getOrdersMutation.isLoading && !orders.length && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f3b0af6dd5a3bf0c$export$9a2ee3ab5c2cc44), {}),
                    Boolean(orders.length) && orders.map((order)=>{
                        const orderStatus = getOrderStatus(order);
                        const innerComponent = ordersState === (0, $0f571f43d43ce782$export$819724757aafc79).Active ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $799e106d98f81703$export$30f1a433d26febc2), {
                            openOrderExtensionPopup: ()=>setOrderIdToExtend(order.id),
                            openOrderDuplicationPage: ()=>redirect((0, $0534349ae8731d0b$export$66b32f6f30eb4b4).orderDuplicateChooseJobs, {
                                    orderId: String(order.id)
                                }),
                            id: order.id,
                            startDateString: order.start_date,
                            endDateString: order.end_date,
                            daysTillEndCount: order.days_till_end_count,
                            jobs: order.jobs,
                            status: orderStatus,
                            showStatusLabel: orderStatus === "upcoming"
                        }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $59702376b7305ab4$export$e4e14436bab98dc2), {
                            id: order.id,
                            startDateString: order.start_date,
                            endDateString: order.end_date,
                            status: orderStatus,
                            jobs: order.jobs,
                            showStatusLabel: ordersState !== (0, $0f571f43d43ce782$export$819724757aafc79).Completed
                        });
                        if (order.is_draft) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                            onClick: ()=>redirect((0, $0534349ae8731d0b$export$66b32f6f30eb4b4).orderDraft, {
                                    orderId: String(order.id),
                                    title: t("order.amend_order")
                                }),
                            className: "OrderConfirmationList__container__cardContainer",
                            children: innerComponent
                        }, order.id);
                        return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                            onClick: ()=>redirect((0, $0534349ae8731d0b$export$66b32f6f30eb4b4).orderConfirmation, {
                                    orderId: String(order.id)
                                }),
                            className: "OrderConfirmationList__container__cardContainer",
                            children: innerComponent
                        }, order.id);
                    }),
                    getOrdersMutation.isLoading && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $57fb8f45c69e1681$export$b08b517936747730), {}),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $660b2ca422e0e2ae$export$1ff3c3f08ae963c0).Vertical, {
                        height: 30
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $9c0551f59559aa01$export$c0bfcb316fefc2db), {
                        isOpen: orderIdToExtend !== null,
                        close: ()=>setOrderIdToExtend(null),
                        onSuccess: ()=>(0, $c74a0566d4b0fd6d$export$e9db7d6e73593439).track((0, $c74a0566d4b0fd6d$export$5e27155e276f6d1c).ExtendedOrderFromOrdersList),
                        clearOnClose: true
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $a4b7c1ff8b9d775f$export$ac5177ff6a0d9687), {
                        isOpen: isFiltersPopupOpen,
                        close: ()=>setIsFiltersPopupOpen(false),
                        reset: ()=>{
                            (0, $782f894a7b2f8796$export$dccf14f226b0b9b5).reset();
                            setIsFiltersPopupOpen(false);
                            fetchOrdersList(1);
                        },
                        apply: ()=>{
                            setIsFiltersPopupOpen(false);
                            fetchOrdersList(1);
                        },
                        fields: [
                            "locationId",
                            "designationId",
                            "startDate",
                            "endDate"
                        ],
                        locationId: (0, $782f894a7b2f8796$export$dccf14f226b0b9b5).searchFilters.locationId ?? undefined,
                        setLocationId: (value)=>(0, $782f894a7b2f8796$export$dccf14f226b0b9b5).setLocationId(value ?? null),
                        designationId: (0, $782f894a7b2f8796$export$dccf14f226b0b9b5).searchFilters.designationId ?? undefined,
                        setDesignationId: (value)=>(0, $782f894a7b2f8796$export$dccf14f226b0b9b5).setDesignationId(value ?? null),
                        startDate: (0, $782f894a7b2f8796$export$dccf14f226b0b9b5).searchFilters.startDate ?? undefined,
                        setStartDate: (0, $782f894a7b2f8796$export$dccf14f226b0b9b5).setStartDate,
                        endDate: (0, $782f894a7b2f8796$export$dccf14f226b0b9b5).searchFilters.endDate ?? undefined,
                        setEndDate: (0, $782f894a7b2f8796$export$dccf14f226b0b9b5).setEndDate
                    })
                ]
            })
        ]
    });
}));




var $acw62 = parcelRequire("acw62");







var $acw62 = parcelRequire("acw62");





var $acw62 = parcelRequire("acw62");



var $45fvw = parcelRequire("45fvw");









const $2134a2142e2e4b73$export$4ce0bedef4e84bb7 = (experience)=>{
    switch(experience){
        case (0, $f62ebabca0bf67f2$export$c90b54e658fc4d7c).junior:
            return (0, $2b1f0855f2f3a952$export$625550452a3fa3ec)("job_draft_details.junior");
        case (0, $f62ebabca0bf67f2$export$c90b54e658fc4d7c).middle:
            return (0, $2b1f0855f2f3a952$export$625550452a3fa3ec)("job_draft_details.midSenior");
        case (0, $f62ebabca0bf67f2$export$c90b54e658fc4d7c).senior:
            return (0, $2b1f0855f2f3a952$export$625550452a3fa3ec)("job_draft_details.senior");
        case (0, $f62ebabca0bf67f2$export$c90b54e658fc4d7c).beginnerOrStudent:
            return (0, $2b1f0855f2f3a952$export$625550452a3fa3ec)((0, $73ccb33f5de6f5aa$export$8707029d024490c9)().order.nonExperiencedTitle);
    }
};




const $edfc4af3f03f3072$export$3a94abfa35f95811 = (job)=>{
    const additionalPreferences = [];
    if (job.languages.use_languages) additionalPreferences.push((0, $2b1f0855f2f3a952$export$625550452a3fa3ec)("job_draft_details.languages"));
    if (job.gender.use_gender) additionalPreferences.push((0, $2b1f0855f2f3a952$export$625550452a3fa3ec)("job_draft_details.gender"));
    if (job.documents.use_documents) additionalPreferences.push((0, $2b1f0855f2f3a952$export$625550452a3fa3ec)("job_draft_details.additional_documents"));
    if (job.manualSelection.use_interview) additionalPreferences.push((0, $2b1f0855f2f3a952$export$625550452a3fa3ec)("job_draft_details.video_interview"));
    if (job.accreditation.use_accreditation === true) additionalPreferences.push((0, $2b1f0855f2f3a952$export$625550452a3fa3ec)("job_draft_details.accreditation"));
    if (job.nationalities.use_nationalities === true && job.fields.hasField((0, $39b712c8a7a8ea7b$export$21cdfbdd9a861522).nationalities)) additionalPreferences.push((0, $2b1f0855f2f3a952$export$625550452a3fa3ec)("job_draft_details.nationalities"));
    return additionalPreferences.join(", ");
};



const $6e109b98b5578b45$export$3d44f8f77a575afc = (gender)=>{
    switch(gender){
        case (0, $9940b994a7a3bcd1$export$87cdbc5104bfce47).male:
            return "Male";
        case (0, $9940b994a7a3bcd1$export$87cdbc5104bfce47).female:
            return "Female";
        case (0, $9940b994a7a3bcd1$export$87cdbc5104bfce47).other:
            return "Other";
        case null:
            return "No preference";
    }
};



const $6a096b2e8cb6eefa$export$d441dac96c68c229 = (accessibility)=>{
    switch(accessibility){
        case Number((0, $262fe7de1e230770$export$e97f944cf44dfd60).accessible):
            return "order_draft.public_transport_accessibility_accessible";
        case Number((0, $262fe7de1e230770$export$e97f944cf44dfd60).notAccessible):
            return "order_draft.public_transport_accessibility_not_accessible";
        default:
            return "order_draft.public_transport_accessibility_accessible";
    }
};




function $ba63e4b5847b0648$export$69d0320343b717bf(UIComponent) {
    return (0, $aca50e9407ba89c9$export$b6ae1bc530f4c149)(({ orderId: orderId, activePopupField: activePopupField, job: job, onSubmit: onSubmit, getFormTitle: getFormTitle, formActions: formActions, formSubtitle: formSubtitle, orderDraftTitle: orderDraftTitle, showStepIndicator: showStepIndicator = false, stepNumber: stepNumber, isExtension: isExtension, isPrefilled: isPrefilled })=>{
        const { getProfessions: getProfessions, getProfessionName: getProfessionName, getInterview: getInterview, createOrder: createOrder, createJob: createJob, createInterview: createInterview, updateInterview: updateInterview, deleteInterview: deleteInterview, updateJob: updateJob, getWorkRequirements: getWorkRequirements, getJobDocumentsNames: getJobDocumentsNames, getQuestionNames: getQuestionNames, getLanguagesNames: getLanguagesNames, getUniformName: getUniformName, getProfession: getProfession, getPointsOfContact: getPointsOfContact, getContactFullName: getContactFullName, getUniforms: getUniforms, workCategoryHasSpecializations: workCategoryHasSpecializations, getWorkCategoryRequirementsNames: getWorkCategoryRequirementsNames, getOrderSummary: getOrderSummary, getOrderIdSummary: getOrderIdSummary, getInvitedPastSPsByIds: getInvitedPastSPsByIds, invitedPastSPsList: invitedPastSPsList, getPastSPs: getPastSPs, pastSPsList: pastSPsList, getLanguages: getLanguages, getJobDocuments: getJobDocuments } = (0, $4671947198ddd366$export$6ccbb43953eebf8)().data;
        const orderSummary = getOrderIdSummary(String(orderId));
        const { enableQuery: getOrderSummaryQuery } = (0, $4671947198ddd366$export$517ca4f7fee4e226)(()=>getOrderSummary({
                orderId: String(orderId)
            }), {
            filterError: [
                (0, $9ad33fbf770c55a1$export$9696fcf1798e1cb5).ClientError
            ]
        });
        const { enableQuery: requestInterview } = (0, $4671947198ddd366$export$517ca4f7fee4e226)(()=>getInterview({
                jobId: job.duplicated_job_id ?? job.existing_job_id
            }), {
            filterError: [
                (0, $9ad33fbf770c55a1$export$9696fcf1798e1cb5).NotFound
            ],
            onSuccess: (interview)=>{
                job.manualSelection.useInterview(true);
                job.manualSelection.setQuestions(interview.questions.map((q)=>q.id));
                interviewIdRef.current = interview.id;
            }
        });
        (0, $4671947198ddd366$export$dd0a697e1782aedd)(()=>getPastSPs({
                collect: false
            }), {
            onError: (err)=>{
                (0, $60f27fc97e29822a$export$b410431fab84fa58).error(err.data.message);
            },
            filterError: [
                (0, $9ad33fbf770c55a1$export$9696fcf1798e1cb5).ClientError
            ]
        });
        const { t: t } = (0, $3765cebd031b52c0$export$9fc83ad70ead8663)();
        const isCategoryWithSpecializations = workCategoryHasSpecializations(job.category.id);
        (0, $acw62.useEffect)(()=>{
            if (isCategoryWithSpecializations) job.fields.addRequirementsField();
            else job.fields.removeRequirementsField();
        }, [
            isCategoryWithSpecializations
        ]);
        (0, $acw62.useEffect)(()=>{
            if (Boolean(orderId)) getOrderSummaryQuery();
            if (job.manualSelection.use_interview) requestInterview();
        }, [
            orderId
        ]);
        (0, $acw62.useEffect)(()=>{
            if (pastSPsList.length > 0) job.fields.addInvitedSPsField();
            else job.fields.removeInvitedSPsField();
        }, [
            pastSPsList.length
        ]);
        const [popupField, setPopupField] = (0, $acw62.useState)(activePopupField ?? null);
        const [clientHasLocations, setClientHasLocations] = (0, $acw62.useState)(true);
        const formValuesRef = (0, $acw62.useRef)();
        const createdOrderIdRef = (0, $acw62.useRef)();
        const interviewIdRef = (0, $acw62.useRef)();
        const locationFormRef = (0, $acw62.useRef)(null);
        const formBottomRef = (0, $acw62.useRef)(null);
        (0, $4671947198ddd366$export$dd0a697e1782aedd)(()=>getPointsOfContact({}));
        (0, $4671947198ddd366$export$dd0a697e1782aedd)(getUniforms);
        (0, $4671947198ddd366$export$dd0a697e1782aedd)(getLanguages);
        (0, $4671947198ddd366$export$dd0a697e1782aedd)(getJobDocuments);
        const { isLoading: professionsLoading } = (0, $4671947198ddd366$export$dd0a697e1782aedd)(()=>getProfessions({}), {
            onSuccess: ()=>{
                const workCategory = getProfession(job.category.id);
                if (job.description.value) return;
                const defaultJobDescription = workCategory?.job_description ?? "";
                job.description.set(defaultJobDescription);
            }
        });
        const { enableQuery: loadRequirements, query: { isLoading: loadingRequirements } } = (0, $4671947198ddd366$export$517ca4f7fee4e226)(()=>getWorkRequirements(job.category.id));
        const currentStep = (0, $acw62.useMemo)(()=>{
            if (!popupField) return 0;
            return job.fields.list.findIndex((field)=>field === popupField);
        // eslint-disable-next-line react-hooks/exhaustive-deps
        }, [
            popupField
        ]);
        const [, getInvitedSPsQuery] = (0, $4671947198ddd366$export$609860bf8b0084c)(({ ids: ids })=>getInvitedPastSPsByIds(ids));
        (0, $acw62.useEffect)(()=>{
            loadRequirements();
            if (job.invitedSPs.list?.length) getInvitedSPsQuery({
                ids: job.invitedSPs.list
            });
            if (job.fields.list.length) job.fields.orderFields();
        // eslint-disable-next-line react-hooks/exhaustive-deps
        }, []);
        (0, $acw62.useEffect)(()=>{
            setPopupField(activePopupField ?? null);
        }, [
            activePopupField
        ]);
        const redirect = (0, $7df35e9df335b1c8$export$602eaf6d5314ce55)();
        const [createJobResult, requestCreateJob] = (0, $4671947198ddd366$export$609860bf8b0084c)(createJob, {
            onSuccess: (createdJob)=>{
                if (job.manualSelection.use_interview && job.manualSelection.interview_questions?.length) requestCreateInterview({
                    jobId: createdJob.id,
                    workCategoryId: createdJob.work_category_id,
                    questions: job.manualSelection.interview_questions
                });
                if (createdJob.is_client_rates_allowed) return redirect((0, $0534349ae8731d0b$export$66b32f6f30eb4b4).setJobPrice, {
                    orderId: String(createdOrderIdRef.current ?? orderId),
                    draftJobId: String(createdJob.id)
                });
                return redirect(isExtension ? (0, $0534349ae8731d0b$export$66b32f6f30eb4b4).extendedOrderDraft : (0, $0534349ae8731d0b$export$66b32f6f30eb4b4).orderDraft, {
                    orderId: String(createdOrderIdRef.current ?? orderId)
                });
            },
            onError: (err)=>{
                // Makes Sentry to have it as a separate error with all logs/breadcrumbs
                console.error("Create Job API Error");
                handleApiFormErrors(err);
            },
            filterError: [
                (0, $9ad33fbf770c55a1$export$9696fcf1798e1cb5).ClientError
            ]
        });
        const [createOrderResult, requestCreateOrder] = (0, $4671947198ddd366$export$609860bf8b0084c)(createOrder, {
            onSuccess: (createdOrderId)=>{
                createdOrderIdRef.current = createdOrderId;
                requestCreateJob({
                    ...formValuesRef.current,
                    order_id: createdOrderId
                });
            },
            onError: ()=>{
                // Makes Sentry to have it as a separate error with all logs/breadcrumbs
                console.error("Create Order API Error");
            }
        });
        const [updateJobResult, requestUpdateJob] = (0, $4671947198ddd366$export$609860bf8b0084c)(updateJob, {
            onSuccess: (result)=>{
                if (job.manualSelection.use_interview && job.manualSelection.interview_questions?.length) {
                    // user decided to use interview
                    if (interviewIdRef.current) // interview was created before this session, just update it
                    requestUpdateInterview({
                        interviewId: interviewIdRef.current,
                        workCategoryId: job.category.id,
                        jobId: job.existing_job_id,
                        questions: job.manualSelection.interview_questions
                    });
                    else // interview will be created in this session
                    requestCreateInterview({
                        jobId: job.existing_job_id,
                        workCategoryId: job.category.id,
                        questions: job.manualSelection.interview_questions
                    });
                } else if (interviewIdRef.current) // user decided not to use the interview anymore
                requestDeleteInterview({
                    interviewId: interviewIdRef.current
                });
                if (isExtension) redirect((0, $0534349ae8731d0b$export$66b32f6f30eb4b4).extendedOrderDraft, {
                    orderId: orderId
                });
                else {
                    if (result.is_client_rates_allowed) return redirect((0, $0534349ae8731d0b$export$66b32f6f30eb4b4).setJobPrice, {
                        orderId: String(createdOrderIdRef.current ?? orderId),
                        draftJobId: String(job.existing_job_id)
                    });
                    return redirect((0, $0534349ae8731d0b$export$66b32f6f30eb4b4).orderDraft, {
                        orderId: String(createdOrderIdRef.current ?? orderId)
                    });
                }
            },
            onError: (err)=>{
                // Makes Sentry to have it as a separate error with all logs/breadcrumbs
                console.error("Update Job API Error");
                handleApiFormErrors(err);
            },
            filterError: [
                (0, $9ad33fbf770c55a1$export$9696fcf1798e1cb5).ClientError
            ]
        });
        const [, requestCreateInterview] = (0, $4671947198ddd366$export$609860bf8b0084c)(createInterview, {
            filterError: Object.values((0, $9ad33fbf770c55a1$export$9696fcf1798e1cb5)),
            onError: ()=>{
                // Makes Sentry to have it as a separate error with all logs/breadcrumbs
                console.error("Create Interview API Error");
            }
        });
        const [, requestUpdateInterview] = (0, $4671947198ddd366$export$609860bf8b0084c)(updateInterview, {
            filterError: Object.values((0, $9ad33fbf770c55a1$export$9696fcf1798e1cb5)),
            onError: ()=>{
                // Makes Sentry to have it as a separate error with all logs/breadcrumbs
                console.error("Update Interview API Error");
            }
        });
        const [, requestDeleteInterview] = (0, $4671947198ddd366$export$609860bf8b0084c)(deleteInterview, {
            filterError: Object.values((0, $9ad33fbf770c55a1$export$9696fcf1798e1cb5)),
            onError: ()=>{
                // Makes Sentry to have it as a separate error with all logs/breadcrumbs
                console.error("Delete Interview API Error");
            }
        });
        const handleApiFormErrors = (err)=>{
            if (err.data.errors) {
                // indicate that there is at least one error
                (0, $60f27fc97e29822a$export$b410431fab84fa58).error(err.data.message);
                // show errors in the form
                job.assignApiErrorsToJob(err.data.errors);
            } else (0, $60f27fc97e29822a$export$b410431fab84fa58).error(err.data.message);
        };
        const getDaysLabel = ()=>{
            if (job.schedule.scheduleType.value === (0, $a4e7aca7274b573e$export$38e26ec75b48a88c).weekly) return job.schedule.distinctTimeSchedule.jobDatesKeys.map((key)=>t(`time.${key.toLowerCase()}`)).join(", ");
            else if (job.schedule.scheduleType.value === (0, $a4e7aca7274b573e$export$38e26ec75b48a88c).daily) return job.schedule.distinctTimeSchedule.jobDatesKeys.map((key)=>(0, (/*@__PURE__*/$parcel$interopDefault($45fvw)))(key, "YYYY-MM-DD").format("DD MMM")).join(", ");
            else return "";
        };
        const stepsLength = job.fields.list.length;
        const isSubmitting = createJobResult.isLoading || updateJobResult.isLoading || createOrderResult.isLoading;
        const isLoading = professionsLoading || loadingRequirements;
        const setNextField = ()=>{
            const nextField = job.fields.list[currentStep + 1];
            setPopupField(nextField);
        };
        const handleNextPress = async ()=>{
            if (popupField === (0, $39b712c8a7a8ea7b$export$21cdfbdd9a861522).location && !clientHasLocations) await locationFormRef.current?.submitForm();
            if (popupField !== (0, $39b712c8a7a8ea7b$export$21cdfbdd9a861522).preferences && !job.validateField(popupField)) return;
            if (currentStep === stepsLength - 1) {
                setPopupField(null);
                formBottomRef.current?.scrollIntoView({
                    behavior: "smooth"
                });
            } else setNextField();
        };
        const formComponentsParams = {
            orderId: orderId,
            locationFormRef: locationFormRef,
            onLocationsLoaded: setClientHasLocations,
            onLocationFormSubmit: ()=>{
                if (Boolean(locationFormRef.current?.errors)) return;
                else job.location.clearError();
                setNextField();
            },
            job: job
        };
        const submitForm = ()=>{
            const submitObject = {
                work_category_id: job.category.id,
                quantity: job.quantity.value,
                client_location_id: job.location.value?.id,
                start_date: job.schedule.dateBoundaries.start_date,
                end_date: job.schedule.dateBoundaries.end_date,
                is_recurring: job.schedule.dateBoundaries.open_ended ? 1 : 0,
                contact_user_id: job.manager.id,
                work_requirement_ids: job.requirements.list,
                instructions: job.description.value,
                seniority_level: Number(job.experience.value),
                gender: job.gender.value ? Number(job.gender.value) : null,
                nationalities: job.nationalities.nationalities_list,
                ethnicities: job.nationalities.ethnicities_list,
                uniform_id: job.dresscode.id,
                invited_sp_ids: job.invitedSPs.list,
                languages: job.languages.list,
                certificates: job.documents.list,
                is_automatic_checkout: 1,
                intervals: job.schedule.distinctTimeSchedule.map,
                assignment_type: 1,
                is_accreditation_required: job.accreditation.value ? 1 : 0,
                is_accommodation_offered: job.accommodation.value ? 1 : 0,
                is_interview_required: job.manualSelection.use_interview ? 1 : 0,
                boarding_type: job.boarding.value ?? 0,
                public_transport_accessibility: job.transport.value
            };
            if (job.existing_job_id) requestUpdateJob({
                ...submitObject,
                id: job.existing_job_id
            });
            else {
                const existingOrderId = Number(orderId);
                if (existingOrderId) requestCreateJob({
                    ...submitObject,
                    order_id: existingOrderId
                });
                else {
                    formValuesRef.current = {
                        ...submitObject,
                        order_id: Number(orderId)
                    };
                    requestCreateOrder(undefined);
                }
            }
            if (job.nationalities.use_nationalities && job.nationalities.nationalities_list?.length === 0 && job.nationalities.ethnicities_list?.length === 0) (0, $c74a0566d4b0fd6d$export$e9db7d6e73593439).track((0, $c74a0566d4b0fd6d$export$5e27155e276f6d1c).OrderFormNationalityAllowedAll);
        };
        return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)(UIComponent, {
            orderId: Number(orderId),
            formTitle: getFormTitle(getProfessionName(job.category.id)),
            formSubtitle: formSubtitle,
            isLoading: isLoading,
            isSubmitting: isSubmitting,
            job: job,
            onSubmit: onSubmit ?? submitForm,
            professionName: job.category.id ? getProfessionName(job.category.id) : null,
            openField: setPopupField,
            daysLabel: getDaysLabel(),
            workCategoryRequirementsNames: job.requirements.list ? getWorkCategoryRequirementsNames(job.category.id, job.requirements.list)?.join(", ") : null,
            invitedSPsNames: job.invitedSPs.list ? invitedPastSPsList.filter((sp)=>job.invitedSPs.list?.includes(sp.id)).map((sp)=>sp.name).join(", ") : null,
            experienceName: job.experience.value ? (0, $2134a2142e2e4b73$export$4ce0bedef4e84bb7)(job.experience.value) : null,
            publicTransportAccessibilityName: job.transport.value ? t((0, $6a096b2e8cb6eefa$export$d441dac96c68c229)(job.transport.value)) : null,
            uniformName: job.dresscode.id ? getUniformName(job.dresscode.id) : null,
            contactFullName: job.manager.id ? getContactFullName(job.manager.id) : null,
            optionalFieldsLabels: (0, $edfc4af3f03f3072$export$3a94abfa35f95811)(job),
            languagesNames: job.languages.list ? getLanguagesNames(job.languages.list).join(", ") : null,
            nationalitiesNames: Boolean(job.nationalities.ethnicities_list?.length) ? t("common.n_selected", {
                count: job.nationalities.ethnicities_list?.length
            }) : Boolean(job.nationalities.nationalities_list?.length) ? t("common.n_selected", {
                count: job.nationalities.nationalities_list?.length
            }) : null,
            genderName: (0, $6e109b98b5578b45$export$3d44f8f77a575afc)(job.gender.value),
            jobDocumentsNames: job.documents.list ? getJobDocumentsNames(job.documents.list).join(", ") : null,
            interviewQuestions: job.manualSelection.interview_questions ? getQuestionNames(job.manualSelection.interview_questions).join(", ") : null,
            formActions: formActions?.(isSubmitting),
            popupField: popupField,
            setPopupField: setPopupField,
            formComponentsParams: formComponentsParams,
            currentStep: currentStep,
            stepsLength: stepsLength,
            isStepDisabled: false,
            handleNextPress: ()=>{
                handleNextPress();
            },
            handleBackPress: ()=>{
                const prevField = job.fields.list[currentStep - 1];
                setPopupField(prevField);
            },
            formBottomRef: formBottomRef,
            showStepIndicator: showStepIndicator,
            stepNumber: stepNumber,
            jobsCount: (orderSummary?.jobs.length ?? 0) + 1,
            isPrefilled: isPrefilled
        });
    });
}






var $acw62 = parcelRequire("acw62");



const $4051a7847249a4a4$export$a455218a85c89869 = ({ content: content, placeholder: placeholder, error: error, onPress: onPress })=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        onClick: onPress,
        className: "JobDraftField",
        children: [
            content ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                        className: "JobDraftField__placeholder-minimized",
                        children: placeholder
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                        className: "JobDraftField__label",
                        children: content
                    })
                ]
            }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                className: "JobDraftField__placeholder",
                children: placeholder
            }),
            error?.length && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                className: "JobDraftField__errorLabel",
                children: Array.isArray(error) ? error.join(", ") : error
            })
        ]
    });











var $4f273a67caecd550$exports = {};
$4f273a67caecd550$exports = new URL("plus.fe6bc78d.svg", import.meta.url).toString();


var $de97bd15744206aa$exports = {};
$de97bd15744206aa$exports = new URL("minus.423ba4d6.svg", import.meta.url).toString();




function $17a27c6ba7085f84$export$57b95d3630b174f6({ error: error, style: style }) {
    if (!error) return null;
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        className: "JobDraftFieldError",
        style: style,
        children: error
    });
}



const $025e95aa4dd8f3fb$export$c8c1fd9e22ee3cee = (0, $aca50e9407ba89c9$export$b6ae1bc530f4c149)(({ job: job })=>{
    const { t: t } = (0, $3765cebd031b52c0$export$9fc83ad70ead8663)();
    const { getProfessionName: getProfessionName } = (0, $4671947198ddd366$export$6ccbb43953eebf8)().data;
    const quantity = job.quantity.value ?? 0;
    const increaseQuantity = ()=>{
        job.quantity.set(quantity + 1);
    };
    const decreaseQuantity = ()=>{
        if (quantity <= 1) return;
        job.quantity.set(quantity - 1);
    };
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "StaffAmount",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                className: "Popup__title",
                children: t("job_draft_details.staff_amount_title")
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                className: "Popup__subtitle",
                children: t("job_draft_details.staff_amount_subtitle")
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "StaffAmount__wrapper",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "StaffAmount__row",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $660b2ca422e0e2ae$export$1ff3c3f08ae963c0).Spacer, {}),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                onClick: decreaseQuantity,
                                title: "decrease quantity",
                                className: `StaffAmount__row__button ${job.quantity.hasError ? "StaffAmount__row__button_error" : ""}`,
                                style: {
                                    backgroundImage: `url(${(0, (/*@__PURE__*/$parcel$interopDefault($de97bd15744206aa$exports)))})`
                                }
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $660b2ca422e0e2ae$export$1ff3c3f08ae963c0).Horizontal, {
                                width: 18
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4e342c5928158118$export$f5b8910cec6cf069), {
                                label: getProfessionName(job.category.id),
                                value: quantity,
                                type: "number",
                                handleChange: (value)=>job.quantity.set(Number(value)),
                                className: `StaffAmount__row__input ${job.quantity.hasError ? "StaffAmount__row__input_error" : ""}`
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $660b2ca422e0e2ae$export$1ff3c3f08ae963c0).Horizontal, {
                                width: 18
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                onClick: increaseQuantity,
                                className: `StaffAmount__row__button ${job.quantity.hasError ? "StaffAmount__row__button_error" : ""}`,
                                title: "increase quantity",
                                style: {
                                    backgroundImage: `url(${(0, (/*@__PURE__*/$parcel$interopDefault($4f273a67caecd550$exports)))})`
                                }
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $660b2ca422e0e2ae$export$1ff3c3f08ae963c0).Spacer, {})
                        ]
                    }),
                    job.quantity.hasError && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $17a27c6ba7085f84$export$57b95d3630b174f6), {
                        error: job.quantity.error
                    })
                ]
            })
        ]
    });
});










const $eab194591fb32a95$var$DatesComponent = (0, $aca50e9407ba89c9$export$b6ae1bc530f4c149)(({ job: job })=>{
    const { t: t } = (0, $3765cebd031b52c0$export$9fc83ad70ead8663)();
    const startDate = job.schedule.dateBoundaries.start_date ?? "";
    const endDate = job.schedule.dateBoundaries.end_date ?? "";
    const toggleReccuringStatus = ()=>{
        job.schedule.setIfOpenEnded(!job.schedule.dateBoundaries.open_ended);
    };
    const today = new Date();
    const minDate = `${today.getFullYear()}-${(today.getMonth() + 1).toString().padStart(2, "0")}-${today.getDate().toString().padStart(2, "0")}`;
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "JobDraftDates",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                className: "Popup__title",
                children: t("job_draft_details.dates_title")
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                className: "Popup__subtitle",
                children: t("job_draft_details.dates_subtitle")
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "JobDraftDates__innerContainer",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "JobDraftDates__itemWrapper",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $1579b0c3590d1ee8$export$7edc06cf1783b30f), {
                                label: t("job_draft_details.start_date"),
                                value: startDate,
                                handleChange: job.schedule.setStartDate,
                                min: minDate,
                                max: endDate ? endDate : undefined,
                                className: `JobDraftDates__dateInput ${job.schedule.dateBoundaries.startDateHasError ? "error" : ""}`
                            }),
                            job.schedule.dateBoundaries.startDateHasError && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $17a27c6ba7085f84$export$57b95d3630b174f6), {
                                error: job.schedule.dateBoundaries.start_date_error
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $660b2ca422e0e2ae$export$1ff3c3f08ae963c0).Vertical, {
                        height: 15
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "JobDraftDates__innerContainer__jobToggleRow",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                className: "JobDraftDates__innerContainer__jobToggleRow__label",
                                children: t("job_draft_details.dates_open_ended")
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $d931e957e209e988$export$bea8ebba691c5813), {
                                active: job.schedule.dateBoundaries.open_ended,
                                onToggle: toggleReccuringStatus
                            })
                        ]
                    }),
                    !job.schedule.dateBoundaries.open_ended && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $660b2ca422e0e2ae$export$1ff3c3f08ae963c0).Vertical, {
                                height: 15
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $1579b0c3590d1ee8$export$7edc06cf1783b30f), {
                                label: t("job_draft_details.end_date"),
                                value: endDate,
                                handleChange: job.schedule.setEndDate,
                                min: startDate ? startDate : minDate,
                                className: `JobDraftDates__dateInput ${job.schedule.dateBoundaries.endDateOrOpenEndedHasError ? "error" : ""}`
                            }),
                            job.schedule.dateBoundaries.endDateOrOpenEndedHasError && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $17a27c6ba7085f84$export$57b95d3630b174f6), {
                                error: job.schedule.dateBoundaries.end_date_or_open_ended_error
                            })
                        ]
                    })
                ]
            })
        ]
    });
});
// @ts-ignore
$eab194591fb32a95$var$DatesComponent.displayName = "DatesComponent";
const $eab194591fb32a95$export$41c3ac8c866f31c8 = $eab194591fb32a95$var$DatesComponent;




var $acw62 = parcelRequire("acw62");




















var $acw62 = parcelRequire("acw62");


var $7YFi7 = parcelRequire("7YFi7");






var $acw62 = parcelRequire("acw62");
var $4688fe884598383f$exports = {};













(function(global, factory) {
    if (typeof define === "function" && define.amd) define([
        "exports",
        "./GoogleApiComponent",
        "./components/Marker",
        "./components/InfoWindow",
        "./components/HeatMap",
        "./components/Polygon",
        "./components/Polyline",
        "./components/Circle",
        "./components/Rectangle",
        "react",
        "prop-types",
        "react-dom",
        "./lib/String",
        "./lib/cancelablePromise"
    ], factory);
    else {
        var mod;
        factory($4688fe884598383f$exports, (parcelRequire("9My83")), (parcelRequire("iKDvV")), (parcelRequire("l5unh")), (parcelRequire("4l0Ad")), (parcelRequire("76QNe")), (parcelRequire("7CAz9")), (parcelRequire("3cI8p")), (parcelRequire("3pQuS")), (parcelRequire("acw62")), (parcelRequire("c9Z8w")), (parcelRequire("1u0KT")), (parcelRequire("7twkG")), (parcelRequire("9oAip")));
    }
})($4688fe884598383f$exports, function(exports1, _GoogleApiComponent, _Marker, _InfoWindow, _HeatMap, _Polygon, _Polyline, _Circle, _Rectangle, _react, _propTypes, _reactDom, _String, _cancelablePromise) {
    "use strict";
    Object.defineProperty(exports1, "__esModule", {
        value: true
    });
    exports1.Map = exports1.Rectangle = exports1.Circle = exports1.Polyline = exports1.Polygon = exports1.HeatMap = exports1.InfoWindow = exports1.Marker = exports1.GoogleApiWrapper = undefined;
    Object.defineProperty(exports1, "GoogleApiWrapper", {
        enumerable: true,
        get: function() {
            return _GoogleApiComponent.wrapper;
        }
    });
    Object.defineProperty(exports1, "Marker", {
        enumerable: true,
        get: function() {
            return _Marker.Marker;
        }
    });
    Object.defineProperty(exports1, "InfoWindow", {
        enumerable: true,
        get: function() {
            return _InfoWindow.InfoWindow;
        }
    });
    Object.defineProperty(exports1, "HeatMap", {
        enumerable: true,
        get: function() {
            return _HeatMap.HeatMap;
        }
    });
    Object.defineProperty(exports1, "Polygon", {
        enumerable: true,
        get: function() {
            return _Polygon.Polygon;
        }
    });
    Object.defineProperty(exports1, "Polyline", {
        enumerable: true,
        get: function() {
            return _Polyline.Polyline;
        }
    });
    Object.defineProperty(exports1, "Circle", {
        enumerable: true,
        get: function() {
            return _Circle.Circle;
        }
    });
    Object.defineProperty(exports1, "Rectangle", {
        enumerable: true,
        get: function() {
            return _Rectangle.Rectangle;
        }
    });
    var _react2 = _interopRequireDefault(_react);
    var _propTypes2 = _interopRequireDefault(_propTypes);
    var _reactDom2 = _interopRequireDefault(_reactDom);
    function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
            default: obj
        };
    }
    function _classCallCheck(instance, Constructor) {
        if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
    }
    var _createClass = function() {
        function defineProperties(target, props) {
            for(var i = 0; i < props.length; i++){
                var descriptor = props[i];
                descriptor.enumerable = descriptor.enumerable || false;
                descriptor.configurable = true;
                if ("value" in descriptor) descriptor.writable = true;
                Object.defineProperty(target, descriptor.key, descriptor);
            }
        }
        return function(Constructor, protoProps, staticProps) {
            if (protoProps) defineProperties(Constructor.prototype, protoProps);
            if (staticProps) defineProperties(Constructor, staticProps);
            return Constructor;
        };
    }();
    function _possibleConstructorReturn(self, call) {
        if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return call && (typeof call === "object" || typeof call === "function") ? call : self;
    }
    function _inherits(subClass, superClass) {
        if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
        subClass.prototype = Object.create(superClass && superClass.prototype, {
            constructor: {
                value: subClass,
                enumerable: false,
                writable: true,
                configurable: true
            }
        });
        if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
    }
    var mapStyles = {
        container: {
            position: "absolute",
            width: "100%",
            height: "100%"
        },
        map: {
            position: "absolute",
            left: 0,
            right: 0,
            bottom: 0,
            top: 0
        }
    };
    var evtNames = [
        "ready",
        "click",
        "dragend",
        "recenter",
        "bounds_changed",
        "center_changed",
        "dblclick",
        "dragstart",
        "heading_change",
        "idle",
        "maptypeid_changed",
        "mousemove",
        "mouseout",
        "mouseover",
        "projection_changed",
        "resize",
        "rightclick",
        "tilesloaded",
        "tilt_changed",
        "zoom_changed"
    ];
    var Map = exports1.Map = function(_React$Component) {
        _inherits(Map, _React$Component);
        function Map(props) {
            _classCallCheck(this, Map);
            var _this = _possibleConstructorReturn(this, (Map.__proto__ || Object.getPrototypeOf(Map)).call(this, props));
            if (!props.hasOwnProperty("google")) throw new Error("You must include a `google` prop");
            _this.listeners = {};
            _this.state = {
                currentLocation: {
                    lat: _this.props.initialCenter.lat,
                    lng: _this.props.initialCenter.lng
                }
            };
            _this.mapRef = _react2.default.createRef();
            return _this;
        }
        _createClass(Map, [
            {
                key: "componentDidMount",
                value: function componentDidMount() {
                    var _this2 = this;
                    if (this.props.centerAroundCurrentLocation) {
                        if (navigator && navigator.geolocation) {
                            this.geoPromise = (0, _cancelablePromise.makeCancelable)(new Promise(function(resolve, reject) {
                                navigator.geolocation.getCurrentPosition(resolve, reject);
                            }));
                            this.geoPromise.promise.then(function(pos) {
                                var coords = pos.coords;
                                _this2.setState({
                                    currentLocation: {
                                        lat: coords.latitude,
                                        lng: coords.longitude
                                    }
                                });
                            }).catch(function(e) {
                                return e;
                            });
                        }
                    }
                    this.loadMap();
                }
            },
            {
                key: "componentDidUpdate",
                value: function componentDidUpdate(prevProps, prevState) {
                    if (prevProps.google !== this.props.google) this.loadMap();
                    if (this.props.visible !== prevProps.visible) this.restyleMap();
                    if (this.props.zoom !== prevProps.zoom) this.map.setZoom(this.props.zoom);
                    if (this.props.center !== prevProps.center) this.setState({
                        currentLocation: this.props.center
                    });
                    if (prevState.currentLocation !== this.state.currentLocation) this.recenterMap();
                    if (this.props.bounds && this.props.bounds !== prevProps.bounds) this.map.fitBounds(this.props.bounds);
                }
            },
            {
                key: "componentWillUnmount",
                value: function componentWillUnmount() {
                    var _this3 = this;
                    var google = this.props.google;
                    if (this.geoPromise) this.geoPromise.cancel();
                    Object.keys(this.listeners).forEach(function(e) {
                        google.maps.event.removeListener(_this3.listeners[e]);
                    });
                }
            },
            {
                key: "loadMap",
                value: function loadMap() {
                    var _this4 = this;
                    if (this.props && this.props.google) {
                        var google = this.props.google;
                        var maps = google.maps;
                        var mapRef = this.mapRef.current;
                        var node = _reactDom2.default.findDOMNode(mapRef);
                        var curr = this.state.currentLocation;
                        var center = new maps.LatLng(curr.lat, curr.lng);
                        var mapTypeIds = this.props.google.maps.MapTypeId || {};
                        var mapTypeFromProps = String(this.props.mapType).toUpperCase();
                        var mapConfig = Object.assign({}, {
                            mapTypeId: mapTypeIds[mapTypeFromProps],
                            center: center,
                            zoom: this.props.zoom,
                            maxZoom: this.props.maxZoom,
                            minZoom: this.props.minZoom,
                            clickableIcons: !!this.props.clickableIcons,
                            disableDefaultUI: this.props.disableDefaultUI,
                            zoomControl: this.props.zoomControl,
                            zoomControlOptions: this.props.zoomControlOptions,
                            mapTypeControl: this.props.mapTypeControl,
                            mapTypeControlOptions: this.props.mapTypeControlOptions,
                            scaleControl: this.props.scaleControl,
                            streetViewControl: this.props.streetViewControl,
                            streetViewControlOptions: this.props.streetViewControlOptions,
                            panControl: this.props.panControl,
                            rotateControl: this.props.rotateControl,
                            fullscreenControl: this.props.fullscreenControl,
                            scrollwheel: this.props.scrollwheel,
                            draggable: this.props.draggable,
                            draggableCursor: this.props.draggableCursor,
                            keyboardShortcuts: this.props.keyboardShortcuts,
                            disableDoubleClickZoom: this.props.disableDoubleClickZoom,
                            noClear: this.props.noClear,
                            styles: this.props.styles,
                            gestureHandling: this.props.gestureHandling
                        });
                        Object.keys(mapConfig).forEach(function(key) {
                            // Allow to configure mapConfig with 'false'
                            if (mapConfig[key] === null) delete mapConfig[key];
                        });
                        this.map = new maps.Map(node, mapConfig);
                        evtNames.forEach(function(e) {
                            _this4.listeners[e] = _this4.map.addListener(e, _this4.handleEvent(e));
                        });
                        maps.event.trigger(this.map, "ready");
                        this.forceUpdate();
                    }
                }
            },
            {
                key: "handleEvent",
                value: function handleEvent(evtName) {
                    var _this5 = this;
                    var timeout = void 0;
                    var handlerName = "on" + (0, _String.camelize)(evtName);
                    return function(e) {
                        if (timeout) {
                            clearTimeout(timeout);
                            timeout = null;
                        }
                        timeout = setTimeout(function() {
                            if (_this5.props[handlerName]) _this5.props[handlerName](_this5.props, _this5.map, e);
                        }, 0);
                    };
                }
            },
            {
                key: "recenterMap",
                value: function recenterMap() {
                    var map = this.map;
                    var google = this.props.google;
                    if (!google) return;
                    var maps = google.maps;
                    if (map) {
                        var center = this.state.currentLocation;
                        if (!(center instanceof google.maps.LatLng)) center = new google.maps.LatLng(center.lat, center.lng);
                        // map.panTo(center)
                        map.setCenter(center);
                        maps.event.trigger(map, "recenter");
                    }
                }
            },
            {
                key: "restyleMap",
                value: function restyleMap() {
                    if (this.map) {
                        var google = this.props.google;
                        google.maps.event.trigger(this.map, "resize");
                    }
                }
            },
            {
                key: "renderChildren",
                value: function renderChildren() {
                    var _this6 = this;
                    var children = this.props.children;
                    if (!children) return;
                    return _react2.default.Children.map(children, function(c) {
                        if (!c) return;
                        return _react2.default.cloneElement(c, {
                            map: _this6.map,
                            google: _this6.props.google,
                            mapCenter: _this6.state.currentLocation
                        });
                    });
                }
            },
            {
                key: "render",
                value: function render() {
                    var style = Object.assign({}, mapStyles.map, this.props.style, {
                        display: this.props.visible ? "inherit" : "none"
                    });
                    var containerStyles = Object.assign({}, mapStyles.container, this.props.containerStyle);
                    return _react2.default.createElement("div", {
                        style: containerStyles,
                        className: this.props.className
                    }, _react2.default.createElement("div", {
                        style: style,
                        ref: this.mapRef
                    }, "Loading map..."), this.renderChildren());
                }
            }
        ]);
        return Map;
    }(_react2.default.Component);
    Map.propTypes = {
        google: _propTypes2.default.object,
        zoom: _propTypes2.default.number,
        centerAroundCurrentLocation: _propTypes2.default.bool,
        center: _propTypes2.default.object,
        initialCenter: _propTypes2.default.object,
        className: _propTypes2.default.string,
        style: _propTypes2.default.object,
        containerStyle: _propTypes2.default.object,
        visible: _propTypes2.default.bool,
        mapType: _propTypes2.default.string,
        maxZoom: _propTypes2.default.number,
        minZoom: _propTypes2.default.number,
        clickableIcons: _propTypes2.default.bool,
        disableDefaultUI: _propTypes2.default.bool,
        zoomControl: _propTypes2.default.bool,
        zoomControlOptions: _propTypes2.default.object,
        mapTypeControl: _propTypes2.default.bool,
        mapTypeControlOptions: _propTypes2.default.bool,
        scaleControl: _propTypes2.default.bool,
        streetViewControl: _propTypes2.default.bool,
        streetViewControlOptions: _propTypes2.default.object,
        panControl: _propTypes2.default.bool,
        rotateControl: _propTypes2.default.bool,
        fullscreenControl: _propTypes2.default.bool,
        scrollwheel: _propTypes2.default.bool,
        draggable: _propTypes2.default.bool,
        draggableCursor: _propTypes2.default.string,
        keyboardShortcuts: _propTypes2.default.bool,
        disableDoubleClickZoom: _propTypes2.default.bool,
        noClear: _propTypes2.default.bool,
        styles: _propTypes2.default.array,
        gestureHandling: _propTypes2.default.string,
        bounds: _propTypes2.default.object
    };
    evtNames.forEach(function(e) {
        return Map.propTypes[(0, _String.camelize)(e)] = _propTypes2.default.func;
    });
    Map.defaultProps = {
        zoom: 14,
        initialCenter: {
            lat: 37.774929,
            lng: -122.419416
        },
        center: {},
        centerAroundCurrentLocation: false,
        style: {},
        containerStyle: {},
        visible: true
    };
    exports1.default = Map;
});



var $bsQZT = parcelRequire("bsQZT");
var $95d3187d11b7b718$exports = {};
$95d3187d11b7b718$exports = new URL("location-icon.9d21d9cb.svg", import.meta.url).toString();


const $901847ca7cce8a9f$export$192b6e91c1441415 = [
    {
        elementType: "geometry",
        stylers: [
            {
                color: "#f8f8fc"
            }
        ]
    },
    {
        elementType: "labels.icon",
        stylers: [
            {
                visibility: "off"
            }
        ]
    },
    {
        elementType: "labels.text.fill",
        stylers: [
            {
                color: "#616161"
            }
        ]
    },
    {
        elementType: "labels.text.stroke",
        stylers: [
            {
                color: "#f5f5f5"
            }
        ]
    },
    {
        featureType: "administrative.land_parcel",
        elementType: "labels.text.fill",
        stylers: [
            {
                color: "#bdbdbd"
            }
        ]
    },
    {
        featureType: "poi",
        elementType: "geometry",
        stylers: [
            {
                color: "#eeeeee"
            }
        ]
    },
    {
        featureType: "poi",
        elementType: "labels.text.fill",
        stylers: [
            {
                color: "#757575"
            }
        ]
    },
    {
        featureType: "poi.park",
        elementType: "geometry",
        stylers: [
            {
                color: "#F5DEB3"
            }
        ]
    },
    {
        featureType: "poi.park",
        elementType: "labels.text.fill",
        stylers: [
            {
                color: "#9e9e9e"
            }
        ]
    },
    {
        featureType: "road",
        elementType: "geometry",
        stylers: [
            {
                color: "#ffffff"
            }
        ]
    },
    {
        featureType: "road.arterial",
        elementType: "labels.text.fill",
        stylers: [
            {
                color: "#757575"
            }
        ]
    },
    {
        featureType: "road.highway",
        elementType: "labels.text.fill",
        stylers: [
            {
                color: "#616161"
            }
        ]
    },
    {
        featureType: "road.local",
        elementType: "labels.text.fill",
        stylers: [
            {
                color: "#9e9e9e"
            }
        ]
    },
    {
        featureType: "transit.line",
        elementType: "geometry",
        stylers: [
            {
                color: "#e5e5e5"
            }
        ]
    },
    {
        featureType: "transit.station",
        elementType: "geometry",
        stylers: [
            {
                color: "#eeeeee"
            }
        ]
    },
    {
        featureType: "water",
        elementType: "geometry",
        stylers: [
            {
                color: "#ebebf9"
            }
        ]
    },
    {
        featureType: "water",
        elementType: "labels.text.fill",
        stylers: [
            {
                color: "#9e9e9e"
            }
        ]
    }
];



const $f8071f0cdb7e0173$var$comparison = (prevProps, nextProps)=>{
    return prevProps.markerLat === nextProps.markerLat && prevProps.markerLng === nextProps.markerLng;
};
const $f8071f0cdb7e0173$var$containerStyle = {
    position: "relative"
};
const $f8071f0cdb7e0173$var$GoogleMaps = (props)=>{
    const { centerCoordinatesOnMap: centerCoordinatesOnMap } = (0, $73ccb33f5de6f5aa$export$8707029d024490c9)();
    const onMapLoaded = (mapProps, map)=>{
        map.setOptions({
            styles: (0, $901847ca7cce8a9f$export$192b6e91c1441415),
            disableDefaultUI: true
        });
    };
    const onMarkerDrag = (_, marker)=>{
        props.onMarkerChange({
            lat: marker.position.lat(),
            lng: marker.position.lng()
        });
    };
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4688fe884598383f$exports.Map), {
        containerStyle: $f8071f0cdb7e0173$var$containerStyle,
        initialCenter: {
            lat: props.markerLat ?? centerCoordinatesOnMap.lat,
            lng: props.markerLng ?? centerCoordinatesOnMap.lng
        },
        center: {
            lat: props.markerLat ?? centerCoordinatesOnMap.lat,
            lng: props.markerLng ?? centerCoordinatesOnMap.lng
        },
        google: props.google,
        zoom: props.markerLat ? 15 : 7,
        onReady: (mapProps, map)=>onMapLoaded(mapProps, map),
        children: props.markerLat && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4688fe884598383f$exports.Marker), {
            // @ts-ignore
            icon: {
                url: (0, (/*@__PURE__*/$parcel$interopDefault($95d3187d11b7b718$exports))),
                scaledSize: new props.google.maps.Size(25, 30)
            },
            draggable: true,
            onDragend: onMarkerDrag,
            position: {
                lat: props.markerLat,
                lng: props.markerLng
            }
        })
    });
};
const $f8071f0cdb7e0173$var$GoogleMapsMemoized = /*#__PURE__*/ (0, $acw62.memo)($f8071f0cdb7e0173$var$GoogleMaps, $f8071f0cdb7e0173$var$comparison);
var $f8071f0cdb7e0173$export$2e2bcd8739ae039 = (0, $4688fe884598383f$exports.GoogleApiWrapper)({
    apiKey: (0, $bsQZT.config).GOOGLE_API_KEY
})($f8071f0cdb7e0173$var$GoogleMapsMemoized);






var $acw62 = parcelRequire("acw62");

var $ebdc3a370f4b42d2$exports = {};
$ebdc3a370f4b42d2$exports = new URL("info.9c1f15f5.svg", import.meta.url).toString();






var $03e37b34cc4506d2$exports = {};
$03e37b34cc4506d2$exports = new URL("info-modal-img.a0d02026.svg", import.meta.url).toString();




const $0c71f039762fa540$export$66a37bed9e99a9af = ({ isVisible: isVisible, setIsVisible: setIsVisible })=>{
    const { t: t } = (0, $3765cebd031b52c0$export$9fc83ad70ead8663)();
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c786671f641538e1$export$446bb0a5366f9068), {
        modalVisible: isVisible,
        onClose: ()=>setIsVisible(false),
        contentStyle: {
            overflow: "hidden",
            maxWidth: "530px",
            padding: "54px 12px 33px 12px"
        },
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
            className: "LocationForm__infoModal",
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                    src: (0, (/*@__PURE__*/$parcel$interopDefault($03e37b34cc4506d2$exports)))
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                    className: "LocationForm__infoModal__title",
                    children: t("location_list.check_in_restrictions_title")
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                    className: "LocationForm__infoModal__content",
                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e04d9533328ca578$export$8d6a9236f2e3f2ce), {
                        i18nKey: "location_list.restrictions_info_modal_text",
                        components: {
                            strong: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {}),
                            br: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("br", {})
                        }
                    })
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $2ab88429e3384d30$export$353f5b6fc5456de1), {
                    type: "button",
                    className: "LocationForm__infoModal__button",
                    onClick: ()=>setIsVisible(false),
                    children: "Okay"
                })
            ]
        })
    });
};


const $b4ddd0040d482170$export$c6b3f2257c7c8d17 = ({ isVisible: isVisible, isGeorestrictionLarge: isGeorestrictionLarge, isGeorestrictionDisabled: isGeorestrictionDisabled, setIsGeorestrictionLarge: setIsGeorestrictionLarge, setIsGeorestrictionDisabled: setIsGeorestrictionDisabled })=>{
    const [infoModalVisible, setInfoModalVisible] = (0, $acw62.useState)(false);
    const { t: t } = (0, $3765cebd031b52c0$export$9fc83ad70ead8663)();
    if (!isVisible) return null;
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $acw62.Fragment), {
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "LocationForm__additionalBlock",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "LocationForm__additionalBlock__header",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                className: "LocationForm__additionalBlock__title",
                                children: t("location_list.check_in_restrictions_title")
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                                src: (0, (/*@__PURE__*/$parcel$interopDefault($ebdc3a370f4b42d2$exports))),
                                className: "LocationForm__additionalBlock__icon",
                                onClick: ()=>setInfoModalVisible(true)
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "LocationForm__toggle",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                className: "LocationForm__toggle__label",
                                children: t("location_list.large_area")
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $d931e957e209e988$export$bea8ebba691c5813), {
                                active: isGeorestrictionLarge,
                                onToggle: ()=>setIsGeorestrictionLarge(!isGeorestrictionLarge)
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "LocationForm__toggle",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                className: "LocationForm__toggle__label",
                                children: t("location_list.no_restrictions")
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $d931e957e209e988$export$bea8ebba691c5813), {
                                active: isGeorestrictionDisabled,
                                onToggle: ()=>setIsGeorestrictionDisabled(!isGeorestrictionDisabled)
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $660b2ca422e0e2ae$export$1ff3c3f08ae963c0).Vertical, {
                height: 22
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $0c71f039762fa540$export$66a37bed9e99a9af), {
                isVisible: infoModalVisible,
                setIsVisible: setInfoModalVisible
            })
        ]
    });
};




var $acw62 = parcelRequire("acw62");





var $acw62 = parcelRequire("acw62");


var $c8242b1acdd8c5a0$exports = {};
$c8242b1acdd8c5a0$exports = new URL("cross-icon-black.69ca8f25.svg", import.meta.url).toString();


const $783f32cedf131fff$var$ImagePreview = ({ imageUrl: imageUrl, onDeletedSelectedImage: onDeletedSelectedImage })=>{
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "ImagePreview",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                onClick: onDeletedSelectedImage,
                type: "button",
                className: "ImagePreview__close",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                    src: (0, (/*@__PURE__*/$parcel$interopDefault($c8242b1acdd8c5a0$exports)))
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                className: "ImagePreview__image",
                src: String(imageUrl)
            })
        ]
    });
};
var $783f32cedf131fff$export$2e2bcd8739ae039 = $783f32cedf131fff$var$ImagePreview;



const $95ba30789215683a$var$ImageUploader = (props)=>{
    const [isFileSelected, setIsFileSelected] = (0, $acw62.useState)(props.hasFile);
    const [imageUrl, setImageUrl] = (0, $acw62.useState)(props.imageUrl);
    const handleSelectFile = (file)=>{
        if (file) {
            setIsFileSelected(true);
            setImageUrl(URL.createObjectURL(file));
        } else setIsFileSelected(false);
    };
    const handleDeleteSelectedImage = ()=>{
        setIsFileSelected(false);
        setImageUrl(undefined);
        props.onDeleteImage();
    };
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        className: "ImageUploader",
        children: isFileSelected ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $783f32cedf131fff$export$2e2bcd8739ae039), {
            onDeletedSelectedImage: handleDeleteSelectedImage,
            imageUrl: imageUrl
        }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $1ba814d56c45ce44$export$2e2bcd8739ae039), {
            ...props,
            hasFile: isFileSelected,
            onSelectFile: (file)=>{
                props.onSelectFile(file);
                handleSelectFile(file);
            }
        })
    });
};
var $95ba30789215683a$export$2e2bcd8739ae039 = $95ba30789215683a$var$ImageUploader;




const $2c37167707b90452$export$c61da9170de072f3 = ({ showAddressDetailsField: showAddressDetailsField, showImageField: showImageField, onDeleteImage: onDeleteImage, imageUrl: imageUrl, onSelectImage: onSelectImage, formikProps: formikProps })=>{
    const { t: t } = (0, $3765cebd031b52c0$export$9fc83ad70ead8663)();
    if (!(showAddressDetailsField || showImageField)) return null;
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "LocationForm__additionalBlock",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "LocationForm__additionalBlock__header",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                    className: "LocationForm__additionalBlock__title",
                    children: t("location_list.additional_details")
                })
            }),
            showAddressDetailsField && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $acw62.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $79dd68e96d831dee$export$2e2bcd8739ae039), {
                        label: t("location_list.address_details"),
                        formikProps: formikProps,
                        formikKey: "address_details"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $660b2ca422e0e2ae$export$1ff3c3f08ae963c0).Vertical, {
                        height: 16
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "LocationForm__toggle",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                        className: "LocationForm__toggle__label",
                        children: t("order_draft.is_location_accessible_by_transport")
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $d931e957e209e988$export$bea8ebba691c5813), {
                        active: formikProps.values.public_transport_accessibility === Number((0, $262fe7de1e230770$export$e97f944cf44dfd60).accessible),
                        onToggle: ()=>{
                            const newValue = formikProps.values.public_transport_accessibility === Number((0, $262fe7de1e230770$export$e97f944cf44dfd60).accessible) ? Number((0, $262fe7de1e230770$export$e97f944cf44dfd60).notAccessible) : Number((0, $262fe7de1e230770$export$e97f944cf44dfd60).accessible);
                            formikProps.setFieldValue("public_transport_accessibility", newValue);
                        }
                    })
                ]
            }),
            showImageField && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $acw62.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $95ba30789215683a$export$2e2bcd8739ae039), {
                        onDeleteImage: onDeleteImage,
                        placeholder: t("location_list.upload_location_image"),
                        name: "location_image",
                        imageUrl: imageUrl,
                        showErrorRequiredMessage: false,
                        hasFile: Boolean(imageUrl),
                        maxFileSize: 10,
                        onSelectFile: onSelectImage
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $660b2ca422e0e2ae$export$1ff3c3f08ae963c0).Vertical, {
                        height: 30
                    })
                ]
            })
        ]
    });
};



const $f89478b840ca1510$export$9266547375a7de3d = (0, $a4963babae245ff9$export$f0c7a449e0cfaec7)((0, $aca50e9407ba89c9$export$b6ae1bc530f4c149)(({ initialValues: initialValues, showDelete: showDelete, onSubmit: onSubmit, onDeleteLocation: onDeleteLocation, onLocationSelected: onLocationSelected, formRef: formRef, showSubmit: showSubmit, showLocationNameField: showLocationNameField, showAddressDetailsField: showAddressDetailsField, showImageField: showImageField, showCheckInRestrictionsBlock: showCheckInRestrictionsBlock })=>{
    const [selectedImage, setSelectedImage] = (0, $acw62.useState)(null);
    const [deleteImage, setDeleteImage] = (0, $acw62.useState)(0);
    const { t: t } = (0, $3765cebd031b52c0$export$9fc83ad70ead8663)();
    if (!formRef) /* eslint-disable no-param-reassign */ formRef = (0, $acw62.useRef)(null);
    const onMarkerChange = (position)=>{
        formRef?.current?.setFieldValue("lat", position.lat);
        formRef?.current?.setFieldValue("lng", position.lng);
    };
    const onPlaceSelected = (place)=>{
        onMarkerChange({
            lat: place.geometry.location.lat(),
            lng: place.geometry.location.lng()
        });
        formRef?.current?.setFieldValue("address", `${place.name} - ${place.formatted_address}`);
        onLocationSelected?.();
    };
    const onDeleteImage = ()=>{
        setDeleteImage(1);
    };
    const onSelectImage = (file)=>{
        setSelectedImage(file);
        setDeleteImage(0);
    };
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        className: "LocationForm",
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7YFi7.Formik), {
            innerRef: formRef,
            validationSchema: $cd7706ce94a8dfd1$export$185802fd694ee1f5().shape({
                name: $bcc252d93ab3046c$export$185802fd694ee1f5().required(t("location_list.location_required")),
                address: $bcc252d93ab3046c$export$185802fd694ee1f5().required(t("location_list.address_required"))
            }),
            initialValues: initialValues,
            onSubmit: (values)=>{
                const apiValues = {
                    ...values,
                    delete_image: deleteImage
                };
                if (selectedImage) {
                    apiValues.image = selectedImage;
                    onSubmit(apiValues);
                } else {
                    delete apiValues.image;
                    onSubmit(apiValues);
                }
            },
            children: (formikProps)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7YFi7.Form), {
                    autoComplete: "off",
                    noValidate: true,
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $3137fcd9cdcdec90$export$2e2bcd8739ae039), {
                            type: "text",
                            label: t("location_list.location_address"),
                            onPlaceSelected: (p)=>{
                                onPlaceSelected(p);
                                formikProps.setFieldValue("name", p.name);
                            },
                            getValue: (value)=>{
                                const matches = value.trim().match(/^[\w\s]+/i);
                                if (matches) formikProps.setFieldValue("name", matches[0].trim());
                            },
                            formikProps: formikProps,
                            formikKey: "address"
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $660b2ca422e0e2ae$export$1ff3c3f08ae963c0).Vertical, {
                            height: 16
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                            className: "LocationForm__map",
                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f8071f0cdb7e0173$export$2e2bcd8739ae039), {
                                markerLat: formikProps.values.lat,
                                markerLng: formikProps.values.lng,
                                onMarkerChange: onMarkerChange
                            })
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $660b2ca422e0e2ae$export$1ff3c3f08ae963c0).Vertical, {
                            height: 16
                        }),
                        showLocationNameField && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $acw62.Fragment), {
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $79dd68e96d831dee$export$2e2bcd8739ae039), {
                                    label: t("location_list.location_name"),
                                    formikProps: formikProps,
                                    formikKey: "name"
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $660b2ca422e0e2ae$export$1ff3c3f08ae963c0).Vertical, {
                                    height: 16
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b4ddd0040d482170$export$c6b3f2257c7c8d17), {
                            isVisible: Boolean(showCheckInRestrictionsBlock),
                            isGeorestrictionLarge: Boolean(formikProps.values.is_georestriction_large),
                            isGeorestrictionDisabled: Boolean(formikProps.values.is_georestriction_disabled),
                            setIsGeorestrictionLarge: (value)=>{
                                formikProps.setFieldValue("is_georestriction_large", value);
                            },
                            setIsGeorestrictionDisabled: (value)=>{
                                formikProps.setFieldValue("is_georestriction_disabled", value);
                            }
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $2c37167707b90452$export$c61da9170de072f3), {
                            showAddressDetailsField: Boolean(showAddressDetailsField),
                            showImageField: Boolean(showImageField),
                            onDeleteImage: onDeleteImage,
                            imageUrl: initialValues.image,
                            onSelectImage: onSelectImage,
                            formikProps: formikProps
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: "LocationForm__buttonsContainer",
                            children: [
                                showSubmit && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                    type: "submit",
                                    className: "LocationForm__save",
                                    children: t("location_list.save")
                                }),
                                showDelete && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $660b2ca422e0e2ae$export$1ff3c3f08ae963c0).Horizontal, {
                                            width: 10
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                            onClick: onDeleteLocation,
                                            type: "button",
                                            className: "LocationForm__delete",
                                            children: t("location_list.delete")
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                })
        })
    });
}));





const $606c9b8f795454be$var$AddLocationPage = (0, $a4963babae245ff9$export$f0c7a449e0cfaec7)((0, $aca50e9407ba89c9$export$b6ae1bc530f4c149)((props)=>{
    const store = (0, $4671947198ddd366$export$6ccbb43953eebf8)();
    const navigate = (0, $7df35e9df335b1c8$export$602eaf6d5314ce55)();
    const navigateToLocationsList = ()=>{
        navigate((0, $0534349ae8731d0b$export$66b32f6f30eb4b4).locations, {});
    };
    const { t: t } = (0, $3765cebd031b52c0$export$9fc83ad70ead8663)();
    const { isLoading: regionsLoading } = (0, $4671947198ddd366$export$dd0a697e1782aedd)(store.data.getRegions);
    const [saveResult, save] = (0, $4671947198ddd366$export$609860bf8b0084c)((data)=>store.data.addLocation(data), {
        onSuccess: (result)=>{
            if (props.onSubmit) props.onSubmit(result);
            else navigateToLocationsList();
        },
        onError: (err)=>{
            (0, $60f27fc97e29822a$export$b410431fab84fa58).error(err.data.message);
        },
        filterError: [
            (0, $9ad33fbf770c55a1$export$9696fcf1798e1cb5).ClientError
        ]
    });
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "AddLocationPage",
        children: [
            props.showHeader && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7ae42b63183f30b4$export$8b251419efc915eb), {
                title: t("add_location.title"),
                showBack: true
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $660b2ca422e0e2ae$export$1ff3c3f08ae963c0).Vertical, {
                height: 28,
                className: "AddLocationPage__topSeparator"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "AddLocationPage__container",
                children: [
                    regionsLoading || saveResult.isLoading ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $57fb8f45c69e1681$export$2e2bcd8739ae039), {}) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f89478b840ca1510$export$9266547375a7de3d), {
                        onSubmit: save,
                        onDeleteLocation: navigateToLocationsList,
                        initialValues: {
                            name: "",
                            address: "",
                            address_details: "",
                            lat: null,
                            lng: null,
                            delete_image: 0,
                            image: "",
                            region: "",
                            is_georestriction_large: false,
                            is_georestriction_disabled: false,
                            public_transport_accessibility: Number((0, $262fe7de1e230770$export$e97f944cf44dfd60).accessible)
                        },
                        showDelete: false,
                        showSubmit: props.showSubmit,
                        formRef: props.formRef,
                        showLocationNameField: props.showLocationNameField,
                        showAddressDetailsField: props.showAddressDetailsField,
                        showImageField: props.showImageField,
                        showCheckInRestrictionsBlock: props.showCheckInRestrictionsBlock,
                        onLocationSelected: props.onLocationSelected
                    }),
                    props.children
                ]
            })
        ]
    });
}));
var $606c9b8f795454be$export$2e2bcd8739ae039 = $606c9b8f795454be$var$AddLocationPage;



var $f4eec0b7d0a3dabc$exports = {};
$f4eec0b7d0a3dabc$exports = new URL("location.f3ca25a3.svg", import.meta.url).toString();




const $79ae7b4dc9946e5d$export$18a2be9195644f38 = (0, $aca50e9407ba89c9$export$b6ae1bc530f4c149)(({ locationFormRef: locationFormRef, onLocationsLoaded: onLocationsLoaded, onLocationFormSubmit: onLocationFormSubmit, job: job })=>{
    const { locationsDataView: locationsDataView, getLocations: getLocations, getLocationByName: getLocationByName } = (0, $4671947198ddd366$export$6ccbb43953eebf8)().data;
    const [regionsModalVisible, setRegionsModalVisible] = (0, $acw62.useState)(false);
    const { isLoading: locationsLoading } = (0, $4671947198ddd366$export$dd0a697e1782aedd)(()=>getLocations({}));
    (0, $acw62.useEffect)(()=>{
        if (!job.location.value && locationsDataView.length > 0) {
            const { id: id, name: name, public_transport_accessibility: public_transport_accessibility } = locationsDataView[0];
            job.location.set({
                id: id,
                name: name
            });
            job.manager.set(null);
            if (public_transport_accessibility !== null) job.fields.removePublicTransportAccessibilityField();
            else job.fields.addPublicTransportAccessibilityField();
        }
        if (onLocationsLoaded) onLocationsLoaded(Boolean(locationsDataView.length));
    }, [
        locationsDataView,
        locationsDataView.length
    ]);
    const locationOptions = locationsDataView.length > 0 ? locationsDataView.map((location)=>({
            key: String(location.id),
            label: location.name,
            value: location.name
        })) : null;
    const { t: t } = (0, $3765cebd031b52c0$export$9fc83ad70ead8663)();
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "JobDraftLocation",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                className: "Popup__title",
                children: t("job_draft_details.location_title")
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                className: "Popup__subtitle JobDraftLocation__Popup__subtitle",
                children: t("job_draft_details.location_subtitle")
            }),
            locationsLoading ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $57fb8f45c69e1681$export$b08b517936747730), {}) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7b02d682eb115277$exports.Fragment), {
                children: locationOptions === null ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $606c9b8f795454be$export$2e2bcd8739ae039), {
                    formRef: locationFormRef,
                    onSubmit: onLocationFormSubmit,
                    showSubmit: false,
                    showLocationNameField: false,
                    showAddressDetailsField: false,
                    showImageField: false,
                    showCheckInRestrictionsBlock: false,
                    onLocationSelected: job.location.clearError,
                    children: !locationFormRef?.current?.errors && job.location.error && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $17a27c6ba7085f84$export$57b95d3630b174f6), {
                        error: job.location.error,
                        style: {
                            position: "absolute"
                        }
                    })
                }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f2c1b8699595d8c0$export$ef9b1a59e592288f), {
                            label: t("job_draft_details.location"),
                            value: job.location.value?.name,
                            onChange: (value)=>{
                                const { id: id, name: name, public_transport_accessibility: public_transport_accessibility } = getLocationByName(value);
                                job.location.set({
                                    id: id,
                                    name: name
                                });
                                job.manager.set(null);
                                if (public_transport_accessibility !== null) job.fields.removePublicTransportAccessibilityField();
                                else job.fields.addPublicTransportAccessibilityField();
                            },
                            options: locationOptions,
                            className: "JobDraftLocation__locationSelect"
                        }),
                        job.location.error && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $17a27c6ba7085f84$export$57b95d3630b174f6), {
                            error: job.location.error
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $660b2ca422e0e2ae$export$1ff3c3f08ae963c0).Vertical, {
                            height: 35
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $2ab88429e3384d30$export$353f5b6fc5456de1), {
                            onClick: ()=>{
                                setRegionsModalVisible(true);
                            },
                            className: "JobDraftLocation__addLocationButton",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                                    src: (0, (/*@__PURE__*/$parcel$interopDefault($f4eec0b7d0a3dabc$exports))),
                                    className: "JobDraftLocation__addLocationButton__img"
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                    className: "JobDraftLocation__addLocationButton__title",
                                    children: t("job_draft_details.location_add_new")
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $c786671f641538e1$export$446bb0a5366f9068), {
                            modalVisible: regionsModalVisible,
                            onClose: ()=>{
                                setRegionsModalVisible(false);
                            },
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                    className: "JobDraftLocation__modalHeader",
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {}),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                            className: "JobDraftLocation__modalHeader__modalTitle",
                                            children: t("job_draft_details.location_add")
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                                            src: (0, (/*@__PURE__*/$parcel$interopDefault($c8242b1acdd8c5a0$exports))),
                                            onClick: ()=>{
                                                setRegionsModalVisible(false);
                                            },
                                            className: "JobDraftLocation__modalHeader__modalCloseImg"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $606c9b8f795454be$export$2e2bcd8739ae039), {
                                    onSubmit: ()=>{
                                        setRegionsModalVisible(false);
                                    },
                                    showSubmit: true,
                                    showLocationNameField: true,
                                    showAddressDetailsField: true,
                                    showImageField: true,
                                    showCheckInRestrictionsBlock: true
                                })
                            ]
                        })
                    ]
                })
            })
        ]
    });
});










const $d56d7ed0bcb79ff3$var$ScheduleTypeComponent = (0, $aca50e9407ba89c9$export$b6ae1bc530f4c149)(({ job: job })=>{
    const { t: t } = (0, $3765cebd031b52c0$export$9fc83ad70ead8663)();
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "ScheduleType",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                className: "Popup__title",
                children: t("job_draft_details.schedule_title")
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                className: "Popup__subtitle",
                children: t("job_draft_details.schedule_subtitle")
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "ScheduleType__innerContainer",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $2ab88429e3384d30$export$353f5b6fc5456de1), {
                        title: t("job_draft_details.schedule_i_have_same_weekly"),
                        onClick: ()=>{
                            job.schedule.setScheduleType((0, $a4e7aca7274b573e$export$38e26ec75b48a88c).weekly);
                        },
                        className: `ScheduleType__innerContainer__button ${job.schedule.scheduleType.value === (0, $a4e7aca7274b573e$export$38e26ec75b48a88c).weekly ? "active" : undefined} ${job.schedule.scheduleType.hasError ? "error" : ""}`,
                        children: t("common.yes")
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $660b2ca422e0e2ae$export$1ff3c3f08ae963c0).Vertical, {
                        height: 10
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $2ab88429e3384d30$export$353f5b6fc5456de1), {
                        title: t("job_draft_details.schedule_i_need_schedule_daily"),
                        onClick: ()=>{
                            job.schedule.setScheduleType((0, $a4e7aca7274b573e$export$38e26ec75b48a88c).daily);
                        },
                        className: `ScheduleType__innerContainer__button ${job.schedule.scheduleType.value === (0, $a4e7aca7274b573e$export$38e26ec75b48a88c).daily ? "active" : undefined} ${job.schedule.scheduleType.hasError ? "error" : ""}`,
                        children: t("common.no")
                    }),
                    job.schedule.scheduleType.hasError && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $17a27c6ba7085f84$export$57b95d3630b174f6), {
                        error: job.schedule.scheduleType.error
                    })
                ]
            })
        ]
    });
});
// @ts-ignore
$d56d7ed0bcb79ff3$var$ScheduleTypeComponent.displayName = "ScheduleTypeComponent";
const $d56d7ed0bcb79ff3$export$38e26ec75b48a88c = $d56d7ed0bcb79ff3$var$ScheduleTypeComponent;




var $acw62 = parcelRequire("acw62");


var $acw62 = parcelRequire("acw62");

var $acw62 = parcelRequire("acw62");
function $85953efa7e00ce5b$export$2e2bcd8739ae039(func, wait, options) {
    var _this = this;
    var lastCallTime = (0, $acw62.useRef)(null);
    var lastInvokeTime = (0, $acw62.useRef)(0);
    var timerId = (0, $acw62.useRef)(null);
    var lastArgs = (0, $acw62.useRef)([]);
    var lastThis = (0, $acw62.useRef)();
    var result = (0, $acw62.useRef)();
    var funcRef = (0, $acw62.useRef)(func);
    var mounted = (0, $acw62.useRef)(true);
    funcRef.current = func;
    // Bypass `requestAnimationFrame` by explicitly setting `wait=0`.
    var useRAF = !wait && wait !== 0 && typeof window !== "undefined";
    if (typeof func !== "function") throw new TypeError("Expected a function");
    wait = +wait || 0;
    options = options || {};
    var leading = !!options.leading;
    var trailing = "trailing" in options ? !!options.trailing : true; // `true` by default
    var maxing = "maxWait" in options;
    var maxWait = maxing ? Math.max(+options.maxWait || 0, wait) : null;
    (0, $acw62.useEffect)(function() {
        mounted.current = true;
        return function() {
            mounted.current = false;
        };
    }, []);
    // You may have a question, why we have so many code under the useMemo definition.
    //
    // This was made as we want to escape from useCallback hell and
    // not to initialize a number of functions each time useDebouncedCallback is called.
    //
    // It means that we have less garbage for our GC calls which improves performance.
    // Also, it makes this library smaller.
    //
    // And the last reason, that the code without lots of useCallback with deps is easier to read.
    // You have only one place for that.
    var debounced = (0, $acw62.useMemo)(function() {
        var invokeFunc = function(time) {
            var args = lastArgs.current;
            var thisArg = lastThis.current;
            lastArgs.current = lastThis.current = null;
            lastInvokeTime.current = time;
            return result.current = funcRef.current.apply(thisArg, args);
        };
        var startTimer = function(pendingFunc, wait) {
            if (useRAF) cancelAnimationFrame(timerId.current);
            timerId.current = useRAF ? requestAnimationFrame(pendingFunc) : setTimeout(pendingFunc, wait);
        };
        var shouldInvoke = function(time) {
            if (!mounted.current) return false;
            var timeSinceLastCall = time - lastCallTime.current;
            var timeSinceLastInvoke = time - lastInvokeTime.current;
            // Either this is the first call, activity has stopped and we're at the
            // trailing edge, the system time has gone backwards and we're treating
            // it as the trailing edge, or we've hit the `maxWait` limit.
            return !lastCallTime.current || timeSinceLastCall >= wait || timeSinceLastCall < 0 || maxing && timeSinceLastInvoke >= maxWait;
        };
        var trailingEdge = function(time) {
            timerId.current = null;
            // Only invoke if we have `lastArgs` which means `func` has been
            // debounced at least once.
            if (trailing && lastArgs.current) return invokeFunc(time);
            lastArgs.current = lastThis.current = null;
            return result.current;
        };
        var timerExpired = function() {
            var time = Date.now();
            if (shouldInvoke(time)) return trailingEdge(time);
            // https://github.com/xnimorz/use-debounce/issues/97
            if (!mounted.current) return;
            // Remaining wait calculation
            var timeSinceLastCall = time - lastCallTime.current;
            var timeSinceLastInvoke = time - lastInvokeTime.current;
            var timeWaiting = wait - timeSinceLastCall;
            var remainingWait = maxing ? Math.min(timeWaiting, maxWait - timeSinceLastInvoke) : timeWaiting;
            // Restart the timer
            startTimer(timerExpired, remainingWait);
        };
        var func = function() {
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            var time = Date.now();
            var isInvoking = shouldInvoke(time);
            lastArgs.current = args;
            lastThis.current = _this;
            lastCallTime.current = time;
            if (isInvoking) {
                if (!timerId.current && mounted.current) {
                    // Reset any `maxWait` timer.
                    lastInvokeTime.current = lastCallTime.current;
                    // Start the timer for the trailing edge.
                    startTimer(timerExpired, wait);
                    // Invoke the leading edge.
                    return leading ? invokeFunc(lastCallTime.current) : result.current;
                }
                if (maxing) {
                    // Handle invocations in a tight loop.
                    startTimer(timerExpired, wait);
                    return invokeFunc(lastCallTime.current);
                }
            }
            if (!timerId.current) startTimer(timerExpired, wait);
            return result.current;
        };
        func.cancel = function() {
            if (timerId.current) useRAF ? cancelAnimationFrame(timerId.current) : clearTimeout(timerId.current);
            lastInvokeTime.current = 0;
            lastArgs.current = lastCallTime.current = lastThis.current = timerId.current = null;
        };
        func.isPending = function() {
            return !!timerId.current;
        };
        func.flush = function() {
            return !timerId.current ? result.current : trailingEdge(Date.now());
        };
        return func;
    }, [
        leading,
        maxing,
        wait,
        maxWait,
        trailing,
        useRAF
    ]);
    return debounced;
}


function $28cfa09e9775cf8c$var$valueEquality(left, right) {
    return left === right;
}
function $28cfa09e9775cf8c$var$adjustFunctionValueOfSetState(value) {
    return typeof value === "function" ? function() {
        return value;
    } : value;
}
function $28cfa09e9775cf8c$var$useStateIgnoreCallback(initialState) {
    var _a = (0, $acw62.useState)($28cfa09e9775cf8c$var$adjustFunctionValueOfSetState(initialState)), state = _a[0], setState = _a[1];
    var setStateIgnoreCallback = (0, $acw62.useCallback)(function(value) {
        return setState($28cfa09e9775cf8c$var$adjustFunctionValueOfSetState(value));
    }, []);
    return [
        state,
        setStateIgnoreCallback
    ];
}
function $28cfa09e9775cf8c$export$2e2bcd8739ae039(value, delay, options) {
    var eq = options && options.equalityFn || $28cfa09e9775cf8c$var$valueEquality;
    var _a = $28cfa09e9775cf8c$var$useStateIgnoreCallback(value), state = _a[0], dispatch = _a[1];
    var debounced = (0, $85953efa7e00ce5b$export$2e2bcd8739ae039)((0, $acw62.useCallback)(function(value) {
        return dispatch(value);
    }, [
        dispatch
    ]), delay, options);
    var previousValue = (0, $acw62.useRef)(value);
    if (!eq(previousValue.current, value)) {
        debounced(value);
        previousValue.current = value;
    }
    return [
        state,
        debounced
    ];
}








var $3afbd6fe8f88cd01$exports = {};
$3afbd6fe8f88cd01$exports = new URL("search.2215eac8.svg", import.meta.url).toString();



const $db7fb73ce5c45471$export$55d7609a8f1eccd2 = ({ value: value, handleValueChange: handleValueChange, placeholder: placeholder = "Search...", className: className })=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: `SearchInput ${className ?? ""}`,
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                className: "SearchInput__input",
                value: value,
                onChange: (ev)=>handleValueChange(ev.target.value),
                placeholder: placeholder
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                src: (0, (/*@__PURE__*/$parcel$interopDefault($3afbd6fe8f88cd01$exports))),
                className: "SearchInput__searchImg"
            })
        ]
    });





const $f13ff0bdae325c20$export$b04be29aa201d4f5 = ({ title: title })=>{
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
        className: "Label",
        children: title
    });
};


const $2e3ce341f392f6fa$export$5ba68579d25663fd = (0, $aca50e9407ba89c9$export$b6ae1bc530f4c149)(({ job: job })=>{
    const { getWorkRequirements: getWorkRequirements, getWorkCategoryRequirements: getWorkCategoryRequirements } = (0, $4671947198ddd366$export$6ccbb43953eebf8)().data;
    const [filteredRequirements, setFilteredRequirements] = (0, $acw62.useState)([]);
    const [calculatingList, setCalculatingList] = (0, $acw62.useState)(false);
    const [searchValue, setSearchValue] = (0, $acw62.useState)("");
    const requirements = getWorkCategoryRequirements(job.category.id) ?? [];
    const { isLoading: requirementsLoading } = (0, $4671947198ddd366$export$dd0a697e1782aedd)(()=>getWorkRequirements(job.category.id), {
        onSuccess: (workRequirements)=>{
            workRequirements.filter((requirement)=>{
                if (requirement.is_default) job.requirements.add(requirement.id);
                return requirement.is_default;
            }).map((requirement)=>requirement.id);
            setFilteredRequirements(workRequirements);
        }
    });
    const filterRequirements = (0, $85953efa7e00ce5b$export$2e2bcd8739ae039)((value)=>{
        setFilteredRequirements(requirements.filter((item)=>item.name.toLowerCase().includes(value.toLowerCase())));
        setCalculatingList(false);
    }, 500);
    const [calculatingListDebounced] = (0, $28cfa09e9775cf8c$export$2e2bcd8739ae039)(calculatingList, 300);
    const { t: t } = (0, $3765cebd031b52c0$export$9fc83ad70ead8663)();
    const handleSearchChange = (value)=>{
        setCalculatingList(true);
        setSearchValue(value);
        filterRequirements(value);
    };
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "JobDraftRequirements",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                className: "Popup__title",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f13ff0bdae325c20$export$b04be29aa201d4f5), {
                        title: t("common.optional")
                    }),
                    " ",
                    t("job_draft_details.requirements_title")
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                className: "Popup__subtitle",
                children: t("job_draft_details.requirements_subtitle")
            }),
            requirementsLoading ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $57fb8f45c69e1681$export$b08b517936747730), {}) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $db7fb73ce5c45471$export$55d7609a8f1eccd2), {
                        value: searchValue,
                        handleValueChange: handleSearchChange,
                        className: "JobDraftRequirements__searchContainer"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $660b2ca422e0e2ae$export$1ff3c3f08ae963c0).Vertical, {
                        height: 18
                    }),
                    calculatingListDebounced ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $57fb8f45c69e1681$export$b08b517936747730), {}) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "JobDraftRequirements__list",
                        children: filteredRequirements.map((requirement)=>{
                            const selected = job.requirements.has(requirement.id);
                            return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                onClick: ()=>{
                                    if (selected) job.requirements.remove(requirement.id);
                                    else job.requirements.add(requirement.id);
                                },
                                className: "JobDraftRequirements__list__item",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                        className: "JobDraftRequirements__list__item__label",
                                        children: requirement.name
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f224f10e61e1d993$export$48513f6b9f8ce62d), {
                                        isActive: selected,
                                        type: "circle"
                                    })
                                ]
                            }, requirement.id);
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $660b2ca422e0e2ae$export$1ff3c3f08ae963c0).Vertical, {
                height: 24
            })
        ]
    });
});
// @ts-ignore
$2e3ce341f392f6fa$export$5ba68579d25663fd.displayName = "WorkRequirementsComponent";
const $2e3ce341f392f6fa$export$2799cbee04377fe0 = $2e3ce341f392f6fa$export$5ba68579d25663fd;




var $45fvw = parcelRequire("45fvw");

var $acw62 = parcelRequire("acw62");






var $acw62 = parcelRequire("acw62");

var $45fvw = parcelRequire("45fvw");


/*  don't use ?? on "value" prop because "value" can be an empty string
    which is false as boolean but not nullish */ /* eslint-disable @typescript-eslint/prefer-nullish-coalescing  */ 

var $45fvw = parcelRequire("45fvw");
var $9aaf1a8973220fa0$exports = {};

$9aaf1a8973220fa0$exports = (parcelRequire("bvEEJ"));











var $acw62 = parcelRequire("acw62");

var $1u0KT = parcelRequire("1u0KT");




var $acw62 = parcelRequire("acw62");
var $b422cebf586837cd$var$OrderContext = /*#__PURE__*/ $acw62.createContext(null);
var $b422cebf586837cd$export$2e2bcd8739ae039 = $b422cebf586837cd$var$OrderContext;





var $acw62 = parcelRequire("acw62");

var $acw62 = parcelRequire("acw62");

/**
 * Wrap `React.useLayoutEffect` which will not throw warning message in test env
 */ var $493347a9fd5d8394$var$useInternalLayoutEffect = (0, $c6daeb3adc2b0e60$export$2e2bcd8739ae039)() ? $acw62.useLayoutEffect : $acw62.useEffect;
var $493347a9fd5d8394$var$useLayoutEffect = function useLayoutEffect(callback, deps) {
    var firstMountRef = $acw62.useRef(true);
    $493347a9fd5d8394$var$useInternalLayoutEffect(function() {
        return callback(firstMountRef.current);
    }, deps);
    // We tell react that first mount has passed
    $493347a9fd5d8394$var$useInternalLayoutEffect(function() {
        firstMountRef.current = false;
        return function() {
            firstMountRef.current = true;
        };
    }, []);
};
var $493347a9fd5d8394$export$9283e56bae2f7b0f = function useLayoutUpdateEffect(callback, deps) {
    $493347a9fd5d8394$var$useLayoutEffect(function(firstMount) {
        if (!firstMount) return callback();
    }, deps);
};
var $493347a9fd5d8394$export$2e2bcd8739ae039 = $493347a9fd5d8394$var$useLayoutEffect;




var $172bd5bc03f91d44$var$EMPTY_LIST = [];
function $172bd5bc03f91d44$export$2e2bcd8739ae039(render, debug) {
    var _React$useState = $acw62.useState(function() {
        if (!(0, $c6daeb3adc2b0e60$export$2e2bcd8739ae039)()) return null;
        var defaultEle = document.createElement("div");
        if (debug) defaultEle.setAttribute("data-debug", debug);
        return defaultEle;
    }), _React$useState2 = (0, $adaabbc18727b3e6$export$2e2bcd8739ae039)(_React$useState, 1), ele = _React$useState2[0];
    // ========================== Order ==========================
    var appendedRef = $acw62.useRef(false);
    var queueCreate = $acw62.useContext((0, $b422cebf586837cd$export$2e2bcd8739ae039));
    var _React$useState3 = $acw62.useState($172bd5bc03f91d44$var$EMPTY_LIST), _React$useState4 = (0, $adaabbc18727b3e6$export$2e2bcd8739ae039)(_React$useState3, 2), queue = _React$useState4[0], setQueue = _React$useState4[1];
    var mergedQueueCreate = queueCreate || (appendedRef.current ? undefined : function(appendFn) {
        setQueue(function(origin) {
            var newQueue = [
                appendFn
            ].concat((0, $eb1ed927433e7e98$export$2e2bcd8739ae039)(origin));
            return newQueue;
        });
    });
    // =========================== DOM ===========================
    function append() {
        if (!ele.parentElement) document.body.appendChild(ele);
        appendedRef.current = true;
    }
    function cleanup() {
        var _ele$parentElement;
        (_ele$parentElement = ele.parentElement) === null || _ele$parentElement === void 0 || _ele$parentElement.removeChild(ele);
        appendedRef.current = false;
    }
    (0, $493347a9fd5d8394$export$2e2bcd8739ae039)(function() {
        if (render) {
            if (queueCreate) queueCreate(append);
            else append();
        } else cleanup();
        return cleanup;
    }, [
        render
    ]);
    (0, $493347a9fd5d8394$export$2e2bcd8739ae039)(function() {
        if (queue.length) {
            queue.forEach(function(appendFn) {
                return appendFn();
            });
            setQueue($172bd5bc03f91d44$var$EMPTY_LIST);
        }
    }, [
        queue
    ]);
    return [
        ele,
        mergedQueueCreate
    ];
}




var $acw62 = parcelRequire("acw62");


/* eslint-disable no-param-reassign */ var $217fa5593a6718d2$var$cached;
function $217fa5593a6718d2$export$2e2bcd8739ae039(fresh) {
    if (typeof document === "undefined") return 0;
    if (fresh || $217fa5593a6718d2$var$cached === undefined) {
        var inner = document.createElement("div");
        inner.style.width = "100%";
        inner.style.height = "200px";
        var outer = document.createElement("div");
        var outerStyle = outer.style;
        outerStyle.position = "absolute";
        outerStyle.top = "0";
        outerStyle.left = "0";
        outerStyle.pointerEvents = "none";
        outerStyle.visibility = "hidden";
        outerStyle.width = "200px";
        outerStyle.height = "150px";
        outerStyle.overflow = "hidden";
        outer.appendChild(inner);
        document.body.appendChild(outer);
        var widthContained = inner.offsetWidth;
        outer.style.overflow = "scroll";
        var widthScroll = inner.offsetWidth;
        if (widthContained === widthScroll) widthScroll = outer.clientWidth;
        document.body.removeChild(outer);
        $217fa5593a6718d2$var$cached = widthContained - widthScroll;
    }
    return $217fa5593a6718d2$var$cached;
}
function $217fa5593a6718d2$var$ensureSize(str) {
    var match = str.match(/^(.*)px$/);
    var value = Number(match === null || match === void 0 ? void 0 : match[1]);
    return Number.isNaN(value) ? $217fa5593a6718d2$export$2e2bcd8739ae039() : value;
}
function $217fa5593a6718d2$export$4f3ef2310365b56a(target) {
    if (typeof document === "undefined" || !target || !(target instanceof Element)) return {
        width: 0,
        height: 0
    };
    var _getComputedStyle = getComputedStyle(target, "::-webkit-scrollbar"), width = _getComputedStyle.width, height = _getComputedStyle.height;
    return {
        width: $217fa5593a6718d2$var$ensureSize(width),
        height: $217fa5593a6718d2$var$ensureSize(height)
    };
}


/**
 * Test usage export. Do not use in your production
 */ function $c9634f2c2418b2d0$export$31b5c8f1131a3a52() {
    return document.body.scrollHeight > (window.innerHeight || document.documentElement.clientHeight) && window.innerWidth > document.body.offsetWidth;
}


var $66bc1eccb2a603c3$var$UNIQUE_ID = "rc-util-locker-".concat(Date.now());
var $66bc1eccb2a603c3$var$uuid = 0;
function $66bc1eccb2a603c3$export$2e2bcd8739ae039(lock) {
    var mergedLock = !!lock;
    var _React$useState = $acw62.useState(function() {
        $66bc1eccb2a603c3$var$uuid += 1;
        return "".concat($66bc1eccb2a603c3$var$UNIQUE_ID, "_").concat($66bc1eccb2a603c3$var$uuid);
    }), _React$useState2 = (0, $adaabbc18727b3e6$export$2e2bcd8739ae039)(_React$useState, 1), id = _React$useState2[0];
    (0, $493347a9fd5d8394$export$2e2bcd8739ae039)(function() {
        if (mergedLock) {
            var scrollbarSize = (0, $217fa5593a6718d2$export$4f3ef2310365b56a)(document.body).width;
            var isOverflow = (0, $c9634f2c2418b2d0$export$31b5c8f1131a3a52)();
            (0, $3a22468320d7d808$export$4d99a2890bb989f0)("\nhtml body {\n  overflow-y: hidden;\n  ".concat(isOverflow ? "width: calc(100% - ".concat(scrollbarSize, "px);") : "", "\n}"), id);
        } else (0, $3a22468320d7d808$export$2232e336aecaa80a)(id);
        return function() {
            (0, $3a22468320d7d808$export$2232e336aecaa80a)(id);
        };
    }, [
        mergedLock,
        id
    ]);
}


var $2ccc34741b4bb73f$export$18c8ad048e32c7d5 = false;
function $2ccc34741b4bb73f$export$121d9fd0ca615463(nextInline) {
    if (typeof nextInline === "boolean") $2ccc34741b4bb73f$export$18c8ad048e32c7d5 = nextInline;
    return $2ccc34741b4bb73f$export$18c8ad048e32c7d5;
}


var $ae492a4c7ad9d4f3$var$getPortalContainer = function getPortalContainer(getContainer) {
    if (getContainer === false) return false;
    if (!(0, $c6daeb3adc2b0e60$export$2e2bcd8739ae039)() || !getContainer) return null;
    if (typeof getContainer === "string") return document.querySelector(getContainer);
    if (typeof getContainer === "function") return getContainer();
    return getContainer;
};
var $ae492a4c7ad9d4f3$var$Portal = /*#__PURE__*/ $acw62.forwardRef(function(props, ref) {
    var open = props.open, autoLock = props.autoLock, getContainer = props.getContainer, debug = props.debug, _props$autoDestroy = props.autoDestroy, autoDestroy = _props$autoDestroy === void 0 ? true : _props$autoDestroy, children = props.children;
    var _React$useState = $acw62.useState(open), _React$useState2 = (0, $adaabbc18727b3e6$export$2e2bcd8739ae039)(_React$useState, 2), shouldRender = _React$useState2[0], setShouldRender = _React$useState2[1];
    var mergedRender = shouldRender || open;
    (0, $05a5f2c645683a81$export$2e2bcd8739ae039)((0, $c6daeb3adc2b0e60$export$2e2bcd8739ae039)() || !open, "Portal only work in client side. Please call 'useEffect' to show Portal instead default render in SSR.");
    // ====================== Should Render ======================
    $acw62.useEffect(function() {
        if (autoDestroy || open) setShouldRender(open);
    }, [
        open,
        autoDestroy
    ]);
    // ======================== Container ========================
    var _React$useState3 = $acw62.useState(function() {
        return $ae492a4c7ad9d4f3$var$getPortalContainer(getContainer);
    }), _React$useState4 = (0, $adaabbc18727b3e6$export$2e2bcd8739ae039)(_React$useState3, 2), innerContainer = _React$useState4[0], setInnerContainer = _React$useState4[1];
    $acw62.useEffect(function() {
        var customizeContainer = $ae492a4c7ad9d4f3$var$getPortalContainer(getContainer);
        // Tell component that we check this in effect which is safe to be `null`
        setInnerContainer(customizeContainer !== null && customizeContainer !== void 0 ? customizeContainer : null);
    });
    var _useDom = (0, $172bd5bc03f91d44$export$2e2bcd8739ae039)(mergedRender && !innerContainer, debug), _useDom2 = (0, $adaabbc18727b3e6$export$2e2bcd8739ae039)(_useDom, 2), defaultContainer = _useDom2[0], queueCreate = _useDom2[1];
    var mergedContainer = innerContainer !== null && innerContainer !== void 0 ? innerContainer : defaultContainer;
    // ========================= Locker ==========================
    (0, $66bc1eccb2a603c3$export$2e2bcd8739ae039)(autoLock && open && (0, $c6daeb3adc2b0e60$export$2e2bcd8739ae039)() && (mergedContainer === defaultContainer || mergedContainer === document.body));
    // =========================== Ref ===========================
    var childRef = null;
    if (children && (0, $5e297877593af644$export$c1cec34af06bcf7)(children) && ref) {
        var _ref = children;
        childRef = _ref.ref;
    }
    var mergedRef = (0, $5e297877593af644$export$1d1c999670a1285d)(childRef, ref);
    // ========================= Render ==========================
    // Do not render when nothing need render
    // When innerContainer is `undefined`, it may not ready since user use ref in the same render
    if (!mergedRender || !(0, $c6daeb3adc2b0e60$export$2e2bcd8739ae039)() || innerContainer === undefined) return null;
    // Render inline
    var renderInline = mergedContainer === false || (0, $2ccc34741b4bb73f$export$121d9fd0ca615463)();
    var reffedChildren = children;
    if (ref) reffedChildren = /*#__PURE__*/ $acw62.cloneElement(children, {
        ref: mergedRef
    });
    return /*#__PURE__*/ $acw62.createElement((0, $b422cebf586837cd$export$2e2bcd8739ae039).Provider, {
        value: queueCreate
    }, renderInline ? reffedChildren : /*#__PURE__*/ (0, $1u0KT.createPortal)(reffedChildren, mergedContainer));
});
$ae492a4c7ad9d4f3$var$Portal.displayName = "Portal";
var $ae492a4c7ad9d4f3$export$2e2bcd8739ae039 = $ae492a4c7ad9d4f3$var$Portal;



var $5b46218595a40828$export$2e2bcd8739ae039 = (0, $ae492a4c7ad9d4f3$export$2e2bcd8739ae039);





var $acw62 = parcelRequire("acw62");

var $acw62 = parcelRequire("acw62");

function $e85c9ef0f09d251f$export$2e2bcd8739ae039(children) {
    var option = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var ret = [];
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Children.forEach(children, function(child) {
        if ((child === undefined || child === null) && !option.keepEmpty) return;
        if (Array.isArray(child)) ret = ret.concat($e85c9ef0f09d251f$export$2e2bcd8739ae039(child));
        else if ((0, $faafdfae2a498d83$exports.isFragment)(child) && child.props) ret = ret.concat($e85c9ef0f09d251f$export$2e2bcd8739ae039(child.props.children, option));
        else ret.push(child);
    });
    return ret;
}








var $acw62 = parcelRequire("acw62");

var $acw62 = parcelRequire("acw62");
var $3b6981416c8ff0a7$export$db36075d98ba73d3 = /*#__PURE__*/ $acw62.createContext(null);
function $3b6981416c8ff0a7$export$fb8073518f34e6ec(_ref) {
    var children = _ref.children, onBatchResize = _ref.onBatchResize;
    var resizeIdRef = $acw62.useRef(0);
    var resizeInfosRef = $acw62.useRef([]);
    var onCollectionResize = $acw62.useContext($3b6981416c8ff0a7$export$db36075d98ba73d3);
    var onResize = $acw62.useCallback(function(size, element, data) {
        resizeIdRef.current += 1;
        var currentId = resizeIdRef.current;
        resizeInfosRef.current.push({
            size: size,
            element: element,
            data: data
        });
        Promise.resolve().then(function() {
            if (currentId === resizeIdRef.current) {
                onBatchResize === null || onBatchResize === void 0 || onBatchResize(resizeInfosRef.current);
                resizeInfosRef.current = [];
            }
        });
        // Continue bubbling if parent exist
        onCollectionResize === null || onCollectionResize === void 0 || onCollectionResize(size, element, data);
    }, [
        onBatchResize,
        onCollectionResize
    ]);
    return /*#__PURE__*/ $acw62.createElement($3b6981416c8ff0a7$export$db36075d98ba73d3.Provider, {
        value: onResize
    }, children);
}



// =============================== Const ===============================
var $ed69d4f7f0510fbd$var$elementListeners = new Map();
function $ed69d4f7f0510fbd$var$onResize(entities) {
    entities.forEach(function(entity) {
        var _elementListeners$get;
        var target = entity.target;
        (_elementListeners$get = $ed69d4f7f0510fbd$var$elementListeners.get(target)) === null || _elementListeners$get === void 0 || _elementListeners$get.forEach(function(listener) {
            return listener(target);
        });
    });
}
// Note: ResizeObserver polyfill not support option to measure border-box resize
var $ed69d4f7f0510fbd$var$resizeObserver = new (0, $87c2a74187854fda$export$2e2bcd8739ae039)($ed69d4f7f0510fbd$var$onResize);
var $ed69d4f7f0510fbd$export$3fbe5a08fd9e4702 = $ed69d4f7f0510fbd$var$elementListeners; // eslint-disable-line
var $ed69d4f7f0510fbd$export$524f0fd3b47831a = $ed69d4f7f0510fbd$var$onResize; // eslint-disable-line
function $ed69d4f7f0510fbd$export$d1203567a167490e(element, callback) {
    if (!$ed69d4f7f0510fbd$var$elementListeners.has(element)) {
        $ed69d4f7f0510fbd$var$elementListeners.set(element, new Set());
        $ed69d4f7f0510fbd$var$resizeObserver.observe(element);
    }
    $ed69d4f7f0510fbd$var$elementListeners.get(element).add(callback);
}
function $ed69d4f7f0510fbd$export$23a2283368c55ea2(element, callback) {
    if ($ed69d4f7f0510fbd$var$elementListeners.has(element)) {
        $ed69d4f7f0510fbd$var$elementListeners.get(element).delete(callback);
        if (!$ed69d4f7f0510fbd$var$elementListeners.get(element).size) {
            $ed69d4f7f0510fbd$var$resizeObserver.unobserve(element);
            $ed69d4f7f0510fbd$var$elementListeners.delete(element);
        }
    }
}







var $acw62 = parcelRequire("acw62");
/**
 * Fallback to findDOMNode if origin ref do not provide any dom element
 */ var $1b24e2207f75c1d9$export$2e2bcd8739ae039 = /*#__PURE__*/ function(_React$Component) {
    (0, $0ed648f7bbaf3aff$export$2e2bcd8739ae039)(DomWrapper, _React$Component);
    var _super = (0, $a76f20fb39fa9d46$export$2e2bcd8739ae039)(DomWrapper);
    function DomWrapper() {
        (0, $4d35ca0862055760$export$2e2bcd8739ae039)(this, DomWrapper);
        return _super.apply(this, arguments);
    }
    (0, $94019358ecbcf36b$export$2e2bcd8739ae039)(DomWrapper, [
        {
            key: "render",
            value: function render() {
                return this.props.children;
            }
        }
    ]);
    return DomWrapper;
}($acw62.Component);


function $2f1485708e9ce0e2$var$SingleObserver(props, ref) {
    var children = props.children, disabled = props.disabled;
    var elementRef = $acw62.useRef(null);
    var wrapperRef = $acw62.useRef(null);
    var onCollectionResize = $acw62.useContext((0, $3b6981416c8ff0a7$export$db36075d98ba73d3));
    // =========================== Children ===========================
    var isRenderProps = typeof children === "function";
    var mergedChildren = isRenderProps ? children(elementRef) : children;
    // ============================= Size =============================
    var sizeRef = $acw62.useRef({
        width: -1,
        height: -1,
        offsetWidth: -1,
        offsetHeight: -1
    });
    // ============================= Ref ==============================
    var canRef = !isRenderProps && /*#__PURE__*/ $acw62.isValidElement(mergedChildren) && (0, $5e297877593af644$export$c1cec34af06bcf7)(mergedChildren);
    var originRef = canRef ? mergedChildren.ref : null;
    var mergedRef = (0, $5e297877593af644$export$1d1c999670a1285d)(originRef, elementRef);
    var getDom = function getDom() {
        var _elementRef$current;
        return (0, $808ab7b8a87ab771$export$2e2bcd8739ae039)(elementRef.current) || // Support `nativeElement` format
        (elementRef.current && (0, $b8f57191916382d3$export$2e2bcd8739ae039)(elementRef.current) === "object" ? (0, $808ab7b8a87ab771$export$2e2bcd8739ae039)((_elementRef$current = elementRef.current) === null || _elementRef$current === void 0 ? void 0 : _elementRef$current.nativeElement) : null) || (0, $808ab7b8a87ab771$export$2e2bcd8739ae039)(wrapperRef.current);
    };
    $acw62.useImperativeHandle(ref, function() {
        return getDom();
    });
    // =========================== Observe ============================
    var propsRef = $acw62.useRef(props);
    propsRef.current = props;
    // Handler
    var onInternalResize = $acw62.useCallback(function(target) {
        var _propsRef$current = propsRef.current, onResize = _propsRef$current.onResize, data = _propsRef$current.data;
        var _target$getBoundingCl = target.getBoundingClientRect(), width = _target$getBoundingCl.width, height = _target$getBoundingCl.height;
        var offsetWidth = target.offsetWidth, offsetHeight = target.offsetHeight;
        /**
     * Resize observer trigger when content size changed.
     * In most case we just care about element size,
     * let's use `boundary` instead of `contentRect` here to avoid shaking.
     */ var fixedWidth = Math.floor(width);
        var fixedHeight = Math.floor(height);
        if (sizeRef.current.width !== fixedWidth || sizeRef.current.height !== fixedHeight || sizeRef.current.offsetWidth !== offsetWidth || sizeRef.current.offsetHeight !== offsetHeight) {
            var size = {
                width: fixedWidth,
                height: fixedHeight,
                offsetWidth: offsetWidth,
                offsetHeight: offsetHeight
            };
            sizeRef.current = size;
            // IE is strange, right?
            var mergedOffsetWidth = offsetWidth === Math.round(width) ? width : offsetWidth;
            var mergedOffsetHeight = offsetHeight === Math.round(height) ? height : offsetHeight;
            var sizeInfo = (0, $983350b7b3960a26$export$2e2bcd8739ae039)((0, $983350b7b3960a26$export$2e2bcd8739ae039)({}, size), {}, {
                offsetWidth: mergedOffsetWidth,
                offsetHeight: mergedOffsetHeight
            });
            // Let collection know what happened
            onCollectionResize === null || onCollectionResize === void 0 || onCollectionResize(sizeInfo, target, data);
            if (onResize) // defer the callback but not defer to next frame
            Promise.resolve().then(function() {
                onResize(sizeInfo, target);
            });
        }
    }, []);
    // Dynamic observe
    $acw62.useEffect(function() {
        var currentElement = getDom();
        if (currentElement && !disabled) (0, $ed69d4f7f0510fbd$export$d1203567a167490e)(currentElement, onInternalResize);
        return function() {
            return (0, $ed69d4f7f0510fbd$export$23a2283368c55ea2)(currentElement, onInternalResize);
        };
    }, [
        elementRef.current,
        disabled
    ]);
    // ============================ Render ============================
    return /*#__PURE__*/ $acw62.createElement((0, $1b24e2207f75c1d9$export$2e2bcd8739ae039), {
        ref: wrapperRef
    }, canRef ? /*#__PURE__*/ $acw62.cloneElement(mergedChildren, {
        ref: mergedRef
    }) : mergedChildren);
}
var $2f1485708e9ce0e2$var$RefSingleObserver = /*#__PURE__*/ $acw62.forwardRef($2f1485708e9ce0e2$var$SingleObserver);
$2f1485708e9ce0e2$var$RefSingleObserver.displayName = "SingleObserver";
var $2f1485708e9ce0e2$export$2e2bcd8739ae039 = $2f1485708e9ce0e2$var$RefSingleObserver;




var $8aeee349dead8f85$var$INTERNAL_PREFIX_KEY = "rc-observer-key";
function $8aeee349dead8f85$var$ResizeObserver(props, ref) {
    var children = props.children;
    var childNodes = typeof children === "function" ? [
        children
    ] : (0, $e85c9ef0f09d251f$export$2e2bcd8739ae039)(children);
    if (childNodes.length > 1) (0, $05a5f2c645683a81$export$491112666e282270)(false, "Find more than one child node with `children` in ResizeObserver. Please use ResizeObserver.Collection instead.");
    else if (childNodes.length === 0) (0, $05a5f2c645683a81$export$491112666e282270)(false, "`children` of ResizeObserver is empty. Nothing is in observe.");
    return childNodes.map(function(child, index) {
        var key = (child === null || child === void 0 ? void 0 : child.key) || "".concat($8aeee349dead8f85$var$INTERNAL_PREFIX_KEY, "-").concat(index);
        return /*#__PURE__*/ $acw62.createElement((0, $2f1485708e9ce0e2$export$2e2bcd8739ae039), (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, props, {
            key: key,
            ref: index === 0 ? ref : undefined
        }), child);
    });
}
var $8aeee349dead8f85$var$RefResizeObserver = /*#__PURE__*/ $acw62.forwardRef($8aeee349dead8f85$var$ResizeObserver);
$8aeee349dead8f85$var$RefResizeObserver.displayName = "ResizeObserver";
$8aeee349dead8f85$var$RefResizeObserver.Collection = (0, $3b6981416c8ff0a7$export$fb8073518f34e6ec);
var $8aeee349dead8f85$export$2e2bcd8739ae039 = $8aeee349dead8f85$var$RefResizeObserver;



function $b9f59244e9def868$var$getRoot(ele) {
    var _ele$getRootNode;
    return ele === null || ele === void 0 || (_ele$getRootNode = ele.getRootNode) === null || _ele$getRootNode === void 0 ? void 0 : _ele$getRootNode.call(ele);
}
function $b9f59244e9def868$export$cca82218ea4431a(ele) {
    return $b9f59244e9def868$var$getRoot(ele) instanceof ShadowRoot;
}
function $b9f59244e9def868$export$70e8259662bb498b(ele) {
    return $b9f59244e9def868$export$cca82218ea4431a(ele) ? $b9f59244e9def868$var$getRoot(ele) : null;
}



var $acw62 = parcelRequire("acw62");
function $01e43e72865dc583$export$2e2bcd8739ae039(callback) {
    var fnRef = $acw62.useRef();
    fnRef.current = callback;
    var memoFn = $acw62.useCallback(function() {
        var _fnRef$current;
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        return (_fnRef$current = fnRef.current) === null || _fnRef$current === void 0 ? void 0 : _fnRef$current.call.apply(_fnRef$current, [
            fnRef
        ].concat(args));
    }, []);
    return memoFn;
}





var $acw62 = parcelRequire("acw62");
function $d23d006593dfab9c$var$getUseId() {
    // We need fully clone React function here to avoid webpack warning React 17 do not export `useId`
    var fullClone = (0, $983350b7b3960a26$export$2e2bcd8739ae039)({}, $acw62);
    return fullClone.useId;
}
var $d23d006593dfab9c$var$uuid = 0;
function $d23d006593dfab9c$export$2f0435a662835942() {
    $d23d006593dfab9c$var$uuid = 0;
}
var $d23d006593dfab9c$var$useOriginId = $d23d006593dfab9c$var$getUseId();
var $d23d006593dfab9c$export$2e2bcd8739ae039 = $d23d006593dfab9c$var$useOriginId ? // Use React `useId`
function useId(id) {
    var reactId = $d23d006593dfab9c$var$useOriginId();
    // Developer passed id is single source of truth
    if (id) return id;
    return reactId;
} : // Use compatible of `useId`
function useCompatId(id) {
    // Inner id for accessibility usage. Only work in client side
    var _React$useState = $acw62.useState("ssr-id"), _React$useState2 = (0, $adaabbc18727b3e6$export$2e2bcd8739ae039)(_React$useState, 2), innerId = _React$useState2[0], setInnerId = _React$useState2[1];
    $acw62.useEffect(function() {
        var nextId = $d23d006593dfab9c$var$uuid;
        $d23d006593dfab9c$var$uuid += 1;
        setInnerId("rc_unique_".concat(nextId));
    }, []);
    // Developer passed id is single source of truth
    if (id) return id;
    // Return react native id or inner id
    return innerId;
};



var $066d1680709fcf3c$export$2e2bcd8739ae039 = function() {
    if (typeof navigator === "undefined" || typeof window === "undefined") return false;
    var agent = navigator.userAgent || navigator.vendor || window.opera;
    return /(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino|android|ipad|playbook|silk/i.test(agent) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw-(n|u)|c55\/|capi|ccwa|cdm-|cell|chtm|cldc|cmd-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc-s|devi|dica|dmob|do(c|p)o|ds(12|-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(-|_)|g1 u|g560|gene|gf-5|g-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd-(m|p|t)|hei-|hi(pt|ta)|hp( i|ip)|hs-c|ht(c(-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i-(20|go|ma)|i230|iac( |-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|-[a-w])|libw|lynx|m1-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|-([1-8]|c))|phil|pire|pl(ay|uc)|pn-2|po(ck|rt|se)|prox|psio|pt-g|qa-a|qc(07|12|21|32|60|-[2-7]|i-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h-|oo|p-)|sdk\/|se(c(-|0|1)|47|mc|nd|ri)|sgh-|shar|sie(-|m)|sk-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h-|v-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl-|tdg-|tel(i|m)|tim-|t-mo|to(pl|sh)|ts(70|m-|m3|m5)|tx-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas-|your|zeto|zte-/i.test(agent === null || agent === void 0 ? void 0 : agent.substr(0, 4));
};



var $acw62 = parcelRequire("acw62");









var $acw62 = parcelRequire("acw62");


var $acw62 = parcelRequire("acw62");
function $c2c51b639b0318a5$export$2e2bcd8739ae039(props) {
    var prefixCls = props.prefixCls, align = props.align, arrow = props.arrow, arrowPos = props.arrowPos;
    var _ref = arrow || {}, className = _ref.className, content = _ref.content;
    var _arrowPos$x = arrowPos.x, x = _arrowPos$x === void 0 ? 0 : _arrowPos$x, _arrowPos$y = arrowPos.y, y = _arrowPos$y === void 0 ? 0 : _arrowPos$y;
    var arrowRef = $acw62.useRef();
    // Skip if no align
    if (!align || !align.points) return null;
    var alignStyle = {
        position: "absolute"
    };
    // Skip if no need to align
    if (align.autoArrow !== false) {
        var popupPoints = align.points[0];
        var targetPoints = align.points[1];
        var popupTB = popupPoints[0];
        var popupLR = popupPoints[1];
        var targetTB = targetPoints[0];
        var targetLR = targetPoints[1];
        // Top & Bottom
        if (popupTB === targetTB || ![
            "t",
            "b"
        ].includes(popupTB)) alignStyle.top = y;
        else if (popupTB === "t") alignStyle.top = 0;
        else alignStyle.bottom = 0;
        // Left & Right
        if (popupLR === targetLR || ![
            "l",
            "r"
        ].includes(popupLR)) alignStyle.left = x;
        else if (popupLR === "l") alignStyle.left = 0;
        else alignStyle.right = 0;
    }
    return /*#__PURE__*/ $acw62.createElement("div", {
        ref: arrowRef,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))("".concat(prefixCls, "-arrow"), className),
        style: alignStyle
    }, content);
}






var $acw62 = parcelRequire("acw62");
function $c69e7bbf660984b6$export$2e2bcd8739ae039(props) {
    var prefixCls = props.prefixCls, open = props.open, zIndex = props.zIndex, mask = props.mask, motion = props.motion;
    if (!mask) return null;
    return /*#__PURE__*/ $acw62.createElement((0, $609e894acbce1933$export$2e2bcd8739ae039), (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, motion, {
        motionAppear: true,
        visible: open,
        removeOnLeave: true
    }), function(_ref) {
        var className = _ref.className;
        return /*#__PURE__*/ $acw62.createElement("div", {
            style: {
                zIndex: zIndex
            },
            className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))("".concat(prefixCls, "-mask"), className)
        });
    });
}



var $acw62 = parcelRequire("acw62");
var $20a13834bc71bb31$var$PopupContent = /*#__PURE__*/ $acw62.memo(function(_ref) {
    var children = _ref.children;
    return children;
}, function(_, next) {
    return next.cache;
});
$20a13834bc71bb31$var$PopupContent.displayName = "PopupContent";
var $20a13834bc71bb31$export$2e2bcd8739ae039 = $20a13834bc71bb31$var$PopupContent;


var $d8446137fd226eb8$var$Popup = /*#__PURE__*/ $acw62.forwardRef(function(props, ref) {
    var popup = props.popup, className = props.className, prefixCls = props.prefixCls, style = props.style, target = props.target, _onVisibleChanged = props.onVisibleChanged, open = props.open, keepDom = props.keepDom, fresh = props.fresh, onClick = props.onClick, mask = props.mask, arrow = props.arrow, arrowPos = props.arrowPos, align = props.align, motion = props.motion, maskMotion = props.maskMotion, forceRender = props.forceRender, getPopupContainer = props.getPopupContainer, autoDestroy = props.autoDestroy, Portal = props.portal, zIndex = props.zIndex, onMouseEnter = props.onMouseEnter, onMouseLeave = props.onMouseLeave, onPointerEnter = props.onPointerEnter, ready = props.ready, offsetX = props.offsetX, offsetY = props.offsetY, offsetR = props.offsetR, offsetB = props.offsetB, onAlign = props.onAlign, onPrepare = props.onPrepare, stretch = props.stretch, targetWidth = props.targetWidth, targetHeight = props.targetHeight;
    var childNode = typeof popup === "function" ? popup() : popup;
    // We can not remove holder only when motion finished.
    var isNodeVisible = open || keepDom;
    // ======================= Container ========================
    var getPopupContainerNeedParams = (getPopupContainer === null || getPopupContainer === void 0 ? void 0 : getPopupContainer.length) > 0;
    var _React$useState = $acw62.useState(!getPopupContainer || !getPopupContainerNeedParams), _React$useState2 = (0, $adaabbc18727b3e6$export$2e2bcd8739ae039)(_React$useState, 2), show = _React$useState2[0], setShow = _React$useState2[1];
    // Delay to show since `getPopupContainer` need target element
    (0, $493347a9fd5d8394$export$2e2bcd8739ae039)(function() {
        if (!show && getPopupContainerNeedParams && target) setShow(true);
    }, [
        show,
        getPopupContainerNeedParams,
        target
    ]);
    // ========================= Render =========================
    if (!show) return null;
    // >>>>> Offset
    var AUTO = "auto";
    var offsetStyle = {
        left: "-1000vw",
        top: "-1000vh",
        right: AUTO,
        bottom: AUTO
    };
    // Set align style
    if (ready || !open) {
        var _experimental;
        var points = align.points;
        var dynamicInset = align.dynamicInset || ((_experimental = align._experimental) === null || _experimental === void 0 ? void 0 : _experimental.dynamicInset);
        var alignRight = dynamicInset && points[0][1] === "r";
        var alignBottom = dynamicInset && points[0][0] === "b";
        if (alignRight) {
            offsetStyle.right = offsetR;
            offsetStyle.left = AUTO;
        } else {
            offsetStyle.left = offsetX;
            offsetStyle.right = AUTO;
        }
        if (alignBottom) {
            offsetStyle.bottom = offsetB;
            offsetStyle.top = AUTO;
        } else {
            offsetStyle.top = offsetY;
            offsetStyle.bottom = AUTO;
        }
    }
    // >>>>> Misc
    var miscStyle = {};
    if (stretch) {
        if (stretch.includes("height") && targetHeight) miscStyle.height = targetHeight;
        else if (stretch.includes("minHeight") && targetHeight) miscStyle.minHeight = targetHeight;
        if (stretch.includes("width") && targetWidth) miscStyle.width = targetWidth;
        else if (stretch.includes("minWidth") && targetWidth) miscStyle.minWidth = targetWidth;
    }
    if (!open) miscStyle.pointerEvents = "none";
    return /*#__PURE__*/ $acw62.createElement(Portal, {
        open: forceRender || isNodeVisible,
        getContainer: getPopupContainer && function() {
            return getPopupContainer(target);
        },
        autoDestroy: autoDestroy
    }, /*#__PURE__*/ $acw62.createElement((0, $c69e7bbf660984b6$export$2e2bcd8739ae039), {
        prefixCls: prefixCls,
        open: open,
        zIndex: zIndex,
        mask: mask,
        motion: maskMotion
    }), /*#__PURE__*/ $acw62.createElement((0, $8aeee349dead8f85$export$2e2bcd8739ae039), {
        onResize: onAlign,
        disabled: !open
    }, function(resizeObserverRef) {
        return /*#__PURE__*/ $acw62.createElement((0, $609e894acbce1933$export$2e2bcd8739ae039), (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({
            motionAppear: true,
            motionEnter: true,
            motionLeave: true,
            removeOnLeave: false,
            forceRender: forceRender,
            leavedClassName: "".concat(prefixCls, "-hidden")
        }, motion, {
            onAppearPrepare: onPrepare,
            onEnterPrepare: onPrepare,
            visible: open,
            onVisibleChanged: function onVisibleChanged(nextVisible) {
                var _motion$onVisibleChan;
                motion === null || motion === void 0 || (_motion$onVisibleChan = motion.onVisibleChanged) === null || _motion$onVisibleChan === void 0 || _motion$onVisibleChan.call(motion, nextVisible);
                _onVisibleChanged(nextVisible);
            }
        }), function(_ref, motionRef) {
            var motionClassName = _ref.className, motionStyle = _ref.style;
            var cls = (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))(prefixCls, motionClassName, className);
            return /*#__PURE__*/ $acw62.createElement("div", {
                ref: (0, $5e297877593af644$export$ab452c34e8e05029)(resizeObserverRef, ref, motionRef),
                className: cls,
                style: (0, $983350b7b3960a26$export$2e2bcd8739ae039)((0, $983350b7b3960a26$export$2e2bcd8739ae039)((0, $983350b7b3960a26$export$2e2bcd8739ae039)((0, $983350b7b3960a26$export$2e2bcd8739ae039)({
                    "--arrow-x": "".concat(arrowPos.x || 0, "px"),
                    "--arrow-y": "".concat(arrowPos.y || 0, "px")
                }, offsetStyle), miscStyle), motionStyle), {}, {
                    boxSizing: "border-box",
                    zIndex: zIndex
                }, style),
                onMouseEnter: onMouseEnter,
                onMouseLeave: onMouseLeave,
                onPointerEnter: onPointerEnter,
                onClick: onClick
            }, arrow && /*#__PURE__*/ $acw62.createElement((0, $c2c51b639b0318a5$export$2e2bcd8739ae039), {
                prefixCls: prefixCls,
                arrow: arrow,
                arrowPos: arrowPos,
                align: align
            }), /*#__PURE__*/ $acw62.createElement((0, $20a13834bc71bb31$export$2e2bcd8739ae039), {
                cache: !open && !fresh
            }, childNode));
        });
    }));
});
$d8446137fd226eb8$var$Popup.displayName = "Popup";
var $d8446137fd226eb8$export$2e2bcd8739ae039 = $d8446137fd226eb8$var$Popup;




var $acw62 = parcelRequire("acw62");
var $afb5ff905a8de769$var$TriggerWrapper = /*#__PURE__*/ $acw62.forwardRef(function(props, ref) {
    var children = props.children, getTriggerDOMNode = props.getTriggerDOMNode;
    var canUseRef = (0, $5e297877593af644$export$c1cec34af06bcf7)(children);
    // When use `getTriggerDOMNode`, we should do additional work to get the real dom
    var setRef = $acw62.useCallback(function(node) {
        (0, $5e297877593af644$export$f17fd18fa51dcb5b)(ref, getTriggerDOMNode ? getTriggerDOMNode(node) : node);
    }, [
        getTriggerDOMNode
    ]);
    var mergedRef = (0, $5e297877593af644$export$1d1c999670a1285d)(setRef, children.ref);
    return canUseRef ? /*#__PURE__*/ $acw62.cloneElement(children, {
        ref: mergedRef
    }) : children;
});
$afb5ff905a8de769$var$TriggerWrapper.displayName = "TriggerWrapper";
var $afb5ff905a8de769$export$2e2bcd8739ae039 = $afb5ff905a8de769$var$TriggerWrapper;



var $acw62 = parcelRequire("acw62");
var $f9b439e1e53d6d59$var$TriggerContext = /*#__PURE__*/ $acw62.createContext(null);
var $f9b439e1e53d6d59$export$2e2bcd8739ae039 = $f9b439e1e53d6d59$var$TriggerContext;



var $acw62 = parcelRequire("acw62");
function $65f8789299df97eb$var$toArray(val) {
    return val ? Array.isArray(val) ? val : [
        val
    ] : [];
}
function $65f8789299df97eb$export$2e2bcd8739ae039(mobile, action, showAction, hideAction) {
    return $acw62.useMemo(function() {
        var mergedShowAction = $65f8789299df97eb$var$toArray(showAction !== null && showAction !== void 0 ? showAction : action);
        var mergedHideAction = $65f8789299df97eb$var$toArray(hideAction !== null && hideAction !== void 0 ? hideAction : action);
        var showActionSet = new Set(mergedShowAction);
        var hideActionSet = new Set(mergedHideAction);
        if (mobile) {
            if (showActionSet.has("hover")) {
                showActionSet.delete("hover");
                showActionSet.add("click");
            }
            if (hideActionSet.has("hover")) {
                hideActionSet.delete("hover");
                hideActionSet.add("click");
            }
        }
        return [
            showActionSet,
            hideActionSet
        ];
    }, [
        mobile,
        action,
        showAction,
        hideAction
    ]);
}





var $555b4eee2695f264$export$2e2bcd8739ae039 = function(element) {
    if (!element) return false;
    if (element instanceof Element) {
        if (element.offsetParent) return true;
        if (element.getBBox) {
            var _getBBox = element.getBBox(), width = _getBBox.width, height = _getBBox.height;
            if (width || height) return true;
        }
        if (element.getBoundingClientRect) {
            var _element$getBoundingC = element.getBoundingClientRect(), _width = _element$getBoundingC.width, _height = _element$getBoundingC.height;
            if (_width || _height) return true;
        }
    }
    return false;
};





var $acw62 = parcelRequire("acw62");

function $140ec2a5382714e1$var$isPointsEq() {
    var a1 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
    var a2 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
    var isAlignPoint = arguments.length > 2 ? arguments[2] : undefined;
    if (isAlignPoint) return a1[0] === a2[0];
    return a1[0] === a2[0] && a1[1] === a2[1];
}
function $140ec2a5382714e1$export$faa0aa8ed2fe6432(builtinPlacements, prefixCls, align, isAlignPoint) {
    var points = align.points;
    var placements = Object.keys(builtinPlacements);
    for(var i = 0; i < placements.length; i += 1){
        var _builtinPlacements$pl;
        var placement = placements[i];
        if ($140ec2a5382714e1$var$isPointsEq((_builtinPlacements$pl = builtinPlacements[placement]) === null || _builtinPlacements$pl === void 0 ? void 0 : _builtinPlacements$pl.points, points, isAlignPoint)) return "".concat(prefixCls, "-placement-").concat(placement);
    }
    return "";
}
function $140ec2a5382714e1$export$7b8936ddc277a29a(prefixCls, motion, animation, transitionName) {
    if (motion) return motion;
    if (animation) return {
        motionName: "".concat(prefixCls, "-").concat(animation)
    };
    if (transitionName) return {
        motionName: transitionName
    };
    return null;
}
function $140ec2a5382714e1$export$9c0584a7cc24d9e(ele) {
    return ele.ownerDocument.defaultView;
}
function $140ec2a5382714e1$export$ba21ed9400ca485b(ele) {
    var scrollerList = [];
    var current = ele === null || ele === void 0 ? void 0 : ele.parentElement;
    var scrollStyle = [
        "hidden",
        "scroll",
        "clip",
        "auto"
    ];
    while(current){
        var _getWin$getComputedSt = $140ec2a5382714e1$export$9c0584a7cc24d9e(current).getComputedStyle(current), overflowX = _getWin$getComputedSt.overflowX, overflowY = _getWin$getComputedSt.overflowY, overflow = _getWin$getComputedSt.overflow;
        if ([
            overflowX,
            overflowY,
            overflow
        ].some(function(o) {
            return scrollStyle.includes(o);
        })) scrollerList.push(current);
        current = current.parentElement;
    }
    return scrollerList;
}
function $140ec2a5382714e1$export$34dfc8f73bbb64ae(num) {
    var defaultValue = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
    return Number.isNaN(num) ? defaultValue : num;
}
function $140ec2a5382714e1$var$getPxValue(val) {
    return $140ec2a5382714e1$export$34dfc8f73bbb64ae(parseFloat(val), 0);
}
function $140ec2a5382714e1$export$94be9d7985092f2d(initArea, scrollerList) {
    var visibleArea = (0, $983350b7b3960a26$export$2e2bcd8739ae039)({}, initArea);
    (scrollerList || []).forEach(function(ele) {
        if (ele instanceof HTMLBodyElement || ele instanceof HTMLHtmlElement) return;
        // Skip if static position which will not affect visible area
        var _getWin$getComputedSt2 = $140ec2a5382714e1$export$9c0584a7cc24d9e(ele).getComputedStyle(ele), overflow = _getWin$getComputedSt2.overflow, overflowClipMargin = _getWin$getComputedSt2.overflowClipMargin, borderTopWidth = _getWin$getComputedSt2.borderTopWidth, borderBottomWidth = _getWin$getComputedSt2.borderBottomWidth, borderLeftWidth = _getWin$getComputedSt2.borderLeftWidth, borderRightWidth = _getWin$getComputedSt2.borderRightWidth;
        var eleRect = ele.getBoundingClientRect();
        var eleOutHeight = ele.offsetHeight, eleInnerHeight = ele.clientHeight, eleOutWidth = ele.offsetWidth, eleInnerWidth = ele.clientWidth;
        var borderTopNum = $140ec2a5382714e1$var$getPxValue(borderTopWidth);
        var borderBottomNum = $140ec2a5382714e1$var$getPxValue(borderBottomWidth);
        var borderLeftNum = $140ec2a5382714e1$var$getPxValue(borderLeftWidth);
        var borderRightNum = $140ec2a5382714e1$var$getPxValue(borderRightWidth);
        var scaleX = $140ec2a5382714e1$export$34dfc8f73bbb64ae(Math.round(eleRect.width / eleOutWidth * 1000) / 1000);
        var scaleY = $140ec2a5382714e1$export$34dfc8f73bbb64ae(Math.round(eleRect.height / eleOutHeight * 1000) / 1000);
        // Original visible area
        var eleScrollWidth = (eleOutWidth - eleInnerWidth - borderLeftNum - borderRightNum) * scaleX;
        var eleScrollHeight = (eleOutHeight - eleInnerHeight - borderTopNum - borderBottomNum) * scaleY;
        // Cut border size
        var scaledBorderTopWidth = borderTopNum * scaleY;
        var scaledBorderBottomWidth = borderBottomNum * scaleY;
        var scaledBorderLeftWidth = borderLeftNum * scaleX;
        var scaledBorderRightWidth = borderRightNum * scaleX;
        // Clip margin
        var clipMarginWidth = 0;
        var clipMarginHeight = 0;
        if (overflow === "clip") {
            var clipNum = $140ec2a5382714e1$var$getPxValue(overflowClipMargin);
            clipMarginWidth = clipNum * scaleX;
            clipMarginHeight = clipNum * scaleY;
        }
        // Region
        var eleLeft = eleRect.x + scaledBorderLeftWidth - clipMarginWidth;
        var eleTop = eleRect.y + scaledBorderTopWidth - clipMarginHeight;
        var eleRight = eleLeft + eleRect.width + 2 * clipMarginWidth - scaledBorderLeftWidth - scaledBorderRightWidth - eleScrollWidth;
        var eleBottom = eleTop + eleRect.height + 2 * clipMarginHeight - scaledBorderTopWidth - scaledBorderBottomWidth - eleScrollHeight;
        visibleArea.left = Math.max(visibleArea.left, eleLeft);
        visibleArea.top = Math.max(visibleArea.top, eleTop);
        visibleArea.right = Math.min(visibleArea.right, eleRight);
        visibleArea.bottom = Math.min(visibleArea.bottom, eleBottom);
    });
    return visibleArea;
}


function $a3ab468f9842aab3$var$getUnitOffset(size) {
    var offset = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
    var offsetStr = "".concat(offset);
    var cells = offsetStr.match(/^(.*)\%$/);
    if (cells) return size * (parseFloat(cells[1]) / 100);
    return parseFloat(offsetStr);
}
function $a3ab468f9842aab3$var$getNumberOffset(rect, offset) {
    var _ref = offset || [], _ref2 = (0, $adaabbc18727b3e6$export$2e2bcd8739ae039)(_ref, 2), offsetX = _ref2[0], offsetY = _ref2[1];
    return [
        $a3ab468f9842aab3$var$getUnitOffset(rect.width, offsetX),
        $a3ab468f9842aab3$var$getUnitOffset(rect.height, offsetY)
    ];
}
function $a3ab468f9842aab3$var$splitPoints() {
    var points = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "";
    return [
        points[0],
        points[1]
    ];
}
function $a3ab468f9842aab3$var$getAlignPoint(rect, points) {
    var topBottom = points[0];
    var leftRight = points[1];
    var x;
    var y;
    // Top & Bottom
    if (topBottom === "t") y = rect.y;
    else if (topBottom === "b") y = rect.y + rect.height;
    else y = rect.y + rect.height / 2;
    // Left & Right
    if (leftRight === "l") x = rect.x;
    else if (leftRight === "r") x = rect.x + rect.width;
    else x = rect.x + rect.width / 2;
    return {
        x: x,
        y: y
    };
}
function $a3ab468f9842aab3$var$reversePoints(points, index) {
    var reverseMap = {
        t: "b",
        b: "t",
        l: "r",
        r: "l"
    };
    return points.map(function(point, i) {
        if (i === index) return reverseMap[point] || "c";
        return point;
    }).join("");
}
function $a3ab468f9842aab3$export$2e2bcd8739ae039(open, popupEle, target, placement, builtinPlacements, popupAlign, onPopupAlign) {
    var _React$useState = $acw62.useState({
        ready: false,
        offsetX: 0,
        offsetY: 0,
        offsetR: 0,
        offsetB: 0,
        arrowX: 0,
        arrowY: 0,
        scaleX: 1,
        scaleY: 1,
        align: builtinPlacements[placement] || {}
    }), _React$useState2 = (0, $adaabbc18727b3e6$export$2e2bcd8739ae039)(_React$useState, 2), offsetInfo = _React$useState2[0], setOffsetInfo = _React$useState2[1];
    var alignCountRef = $acw62.useRef(0);
    var scrollerList = $acw62.useMemo(function() {
        if (!popupEle) return [];
        return (0, $140ec2a5382714e1$export$ba21ed9400ca485b)(popupEle);
    }, [
        popupEle
    ]);
    // ========================= Flip ==========================
    // We will memo flip info.
    // If size change to make flip, it will memo the flip info and use it in next align.
    var prevFlipRef = $acw62.useRef({});
    var resetFlipCache = function resetFlipCache() {
        prevFlipRef.current = {};
    };
    if (!open) resetFlipCache();
    // ========================= Align =========================
    var onAlign = (0, $01e43e72865dc583$export$2e2bcd8739ae039)(function() {
        if (popupEle && target && open) {
            var _popupElement$parentE, _popupElement$parentE2;
            var popupElement = popupEle;
            var doc = popupElement.ownerDocument;
            var win = (0, $140ec2a5382714e1$export$9c0584a7cc24d9e)(popupElement);
            var _win$getComputedStyle = win.getComputedStyle(popupElement), width = _win$getComputedStyle.width, height = _win$getComputedStyle.height, popupPosition = _win$getComputedStyle.position;
            var originLeft = popupElement.style.left;
            var originTop = popupElement.style.top;
            var originRight = popupElement.style.right;
            var originBottom = popupElement.style.bottom;
            var originOverflow = popupElement.style.overflow;
            // Placement
            var placementInfo = (0, $983350b7b3960a26$export$2e2bcd8739ae039)((0, $983350b7b3960a26$export$2e2bcd8739ae039)({}, builtinPlacements[placement]), popupAlign);
            // placeholder element
            var placeholderElement = doc.createElement("div");
            (_popupElement$parentE = popupElement.parentElement) === null || _popupElement$parentE === void 0 || _popupElement$parentE.appendChild(placeholderElement);
            placeholderElement.style.left = "".concat(popupElement.offsetLeft, "px");
            placeholderElement.style.top = "".concat(popupElement.offsetTop, "px");
            placeholderElement.style.position = popupPosition;
            placeholderElement.style.height = "".concat(popupElement.offsetHeight, "px");
            placeholderElement.style.width = "".concat(popupElement.offsetWidth, "px");
            // Reset first
            popupElement.style.left = "0";
            popupElement.style.top = "0";
            popupElement.style.right = "auto";
            popupElement.style.bottom = "auto";
            popupElement.style.overflow = "hidden";
            // Calculate align style, we should consider `transform` case
            var targetRect;
            if (Array.isArray(target)) targetRect = {
                x: target[0],
                y: target[1],
                width: 0,
                height: 0
            };
            else {
                var rect = target.getBoundingClientRect();
                targetRect = {
                    x: rect.x,
                    y: rect.y,
                    width: rect.width,
                    height: rect.height
                };
            }
            var popupRect = popupElement.getBoundingClientRect();
            var _doc$documentElement = doc.documentElement, clientWidth = _doc$documentElement.clientWidth, clientHeight = _doc$documentElement.clientHeight, scrollWidth = _doc$documentElement.scrollWidth, scrollHeight = _doc$documentElement.scrollHeight, scrollTop = _doc$documentElement.scrollTop, scrollLeft = _doc$documentElement.scrollLeft;
            var popupHeight = popupRect.height;
            var popupWidth = popupRect.width;
            var targetHeight = targetRect.height;
            var targetWidth = targetRect.width;
            // Get bounding of visible area
            var visibleRegion = {
                left: 0,
                top: 0,
                right: clientWidth,
                bottom: clientHeight
            };
            var scrollRegion = {
                left: -scrollLeft,
                top: -scrollTop,
                right: scrollWidth - scrollLeft,
                bottom: scrollHeight - scrollTop
            };
            var htmlRegion = placementInfo.htmlRegion;
            var VISIBLE = "visible";
            var VISIBLE_FIRST = "visibleFirst";
            if (htmlRegion !== "scroll" && htmlRegion !== VISIBLE_FIRST) htmlRegion = VISIBLE;
            var isVisibleFirst = htmlRegion === VISIBLE_FIRST;
            var scrollRegionArea = (0, $140ec2a5382714e1$export$94be9d7985092f2d)(scrollRegion, scrollerList);
            var visibleRegionArea = (0, $140ec2a5382714e1$export$94be9d7985092f2d)(visibleRegion, scrollerList);
            var visibleArea = htmlRegion === VISIBLE ? visibleRegionArea : scrollRegionArea;
            // When set to `visibleFirst`,
            // the check `adjust` logic will use `visibleRegion` for check first.
            var adjustCheckVisibleArea = isVisibleFirst ? visibleRegionArea : visibleArea;
            // Record right & bottom align data
            popupElement.style.left = "auto";
            popupElement.style.top = "auto";
            popupElement.style.right = "0";
            popupElement.style.bottom = "0";
            var popupMirrorRect = popupElement.getBoundingClientRect();
            // Reset back
            popupElement.style.left = originLeft;
            popupElement.style.top = originTop;
            popupElement.style.right = originRight;
            popupElement.style.bottom = originBottom;
            popupElement.style.overflow = originOverflow;
            (_popupElement$parentE2 = popupElement.parentElement) === null || _popupElement$parentE2 === void 0 || _popupElement$parentE2.removeChild(placeholderElement);
            // Calculate scale
            var _scaleX = (0, $140ec2a5382714e1$export$34dfc8f73bbb64ae)(Math.round(popupWidth / parseFloat(width) * 1000) / 1000);
            var _scaleY = (0, $140ec2a5382714e1$export$34dfc8f73bbb64ae)(Math.round(popupHeight / parseFloat(height) * 1000) / 1000);
            // No need to align since it's not visible in view
            if (_scaleX === 0 || _scaleY === 0 || (0, $808ab7b8a87ab771$export$41e30d8dd0ba7a50)(target) && !(0, $555b4eee2695f264$export$2e2bcd8739ae039)(target)) return;
            // Offset
            var offset = placementInfo.offset, targetOffset = placementInfo.targetOffset;
            var _getNumberOffset = $a3ab468f9842aab3$var$getNumberOffset(popupRect, offset), _getNumberOffset2 = (0, $adaabbc18727b3e6$export$2e2bcd8739ae039)(_getNumberOffset, 2), popupOffsetX = _getNumberOffset2[0], popupOffsetY = _getNumberOffset2[1];
            var _getNumberOffset3 = $a3ab468f9842aab3$var$getNumberOffset(targetRect, targetOffset), _getNumberOffset4 = (0, $adaabbc18727b3e6$export$2e2bcd8739ae039)(_getNumberOffset3, 2), targetOffsetX = _getNumberOffset4[0], targetOffsetY = _getNumberOffset4[1];
            targetRect.x -= targetOffsetX;
            targetRect.y -= targetOffsetY;
            // Points
            var _ref3 = placementInfo.points || [], _ref4 = (0, $adaabbc18727b3e6$export$2e2bcd8739ae039)(_ref3, 2), popupPoint = _ref4[0], targetPoint = _ref4[1];
            var targetPoints = $a3ab468f9842aab3$var$splitPoints(targetPoint);
            var popupPoints = $a3ab468f9842aab3$var$splitPoints(popupPoint);
            var targetAlignPoint = $a3ab468f9842aab3$var$getAlignPoint(targetRect, targetPoints);
            var popupAlignPoint = $a3ab468f9842aab3$var$getAlignPoint(popupRect, popupPoints);
            // Real align info may not same as origin one
            var nextAlignInfo = (0, $983350b7b3960a26$export$2e2bcd8739ae039)({}, placementInfo);
            // Next Offset
            var nextOffsetX = targetAlignPoint.x - popupAlignPoint.x + popupOffsetX;
            var nextOffsetY = targetAlignPoint.y - popupAlignPoint.y + popupOffsetY;
            // ============== Intersection ===============
            // Get area by position. Used for check if flip area is better
            function getIntersectionVisibleArea(offsetX, offsetY) {
                var area = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : visibleArea;
                var l = popupRect.x + offsetX;
                var t = popupRect.y + offsetY;
                var r = l + popupWidth;
                var b = t + popupHeight;
                var visibleL = Math.max(l, area.left);
                var visibleT = Math.max(t, area.top);
                var visibleR = Math.min(r, area.right);
                var visibleB = Math.min(b, area.bottom);
                return Math.max(0, (visibleR - visibleL) * (visibleB - visibleT));
            }
            var originIntersectionVisibleArea = getIntersectionVisibleArea(nextOffsetX, nextOffsetY);
            // As `visibleFirst`, we prepare this for check
            var originIntersectionRecommendArea = getIntersectionVisibleArea(nextOffsetX, nextOffsetY, visibleRegionArea);
            // ========================== Overflow ===========================
            var targetAlignPointTL = $a3ab468f9842aab3$var$getAlignPoint(targetRect, [
                "t",
                "l"
            ]);
            var popupAlignPointTL = $a3ab468f9842aab3$var$getAlignPoint(popupRect, [
                "t",
                "l"
            ]);
            var targetAlignPointBR = $a3ab468f9842aab3$var$getAlignPoint(targetRect, [
                "b",
                "r"
            ]);
            var popupAlignPointBR = $a3ab468f9842aab3$var$getAlignPoint(popupRect, [
                "b",
                "r"
            ]);
            var overflow = placementInfo.overflow || {};
            var adjustX = overflow.adjustX, adjustY = overflow.adjustY, shiftX = overflow.shiftX, shiftY = overflow.shiftY;
            var supportAdjust = function supportAdjust(val) {
                if (typeof val === "boolean") return val;
                return val >= 0;
            };
            // Prepare position
            var nextPopupY;
            var nextPopupBottom;
            var nextPopupX;
            var nextPopupRight;
            function syncNextPopupPosition() {
                nextPopupY = popupRect.y + nextOffsetY;
                nextPopupBottom = nextPopupY + popupHeight;
                nextPopupX = popupRect.x + nextOffsetX;
                nextPopupRight = nextPopupX + popupWidth;
            }
            syncNextPopupPosition();
            // >>>>>>>>>> Top & Bottom
            var needAdjustY = supportAdjust(adjustY);
            var sameTB = popupPoints[0] === targetPoints[0];
            // Bottom to Top
            if (needAdjustY && popupPoints[0] === "t" && (nextPopupBottom > adjustCheckVisibleArea.bottom || prevFlipRef.current.bt)) {
                var tmpNextOffsetY = nextOffsetY;
                if (sameTB) tmpNextOffsetY -= popupHeight - targetHeight;
                else tmpNextOffsetY = targetAlignPointTL.y - popupAlignPointBR.y - popupOffsetY;
                var newVisibleArea = getIntersectionVisibleArea(nextOffsetX, tmpNextOffsetY);
                var newVisibleRecommendArea = getIntersectionVisibleArea(nextOffsetX, tmpNextOffsetY, visibleRegionArea);
                if (// Of course use larger one
                newVisibleArea > originIntersectionVisibleArea || newVisibleArea === originIntersectionVisibleArea && (!isVisibleFirst || // Choose recommend one
                newVisibleRecommendArea >= originIntersectionRecommendArea)) {
                    prevFlipRef.current.bt = true;
                    nextOffsetY = tmpNextOffsetY;
                    popupOffsetY = -popupOffsetY;
                    nextAlignInfo.points = [
                        $a3ab468f9842aab3$var$reversePoints(popupPoints, 0),
                        $a3ab468f9842aab3$var$reversePoints(targetPoints, 0)
                    ];
                } else prevFlipRef.current.bt = false;
            }
            // Top to Bottom
            if (needAdjustY && popupPoints[0] === "b" && (nextPopupY < adjustCheckVisibleArea.top || prevFlipRef.current.tb)) {
                var _tmpNextOffsetY = nextOffsetY;
                if (sameTB) _tmpNextOffsetY += popupHeight - targetHeight;
                else _tmpNextOffsetY = targetAlignPointBR.y - popupAlignPointTL.y - popupOffsetY;
                var _newVisibleArea = getIntersectionVisibleArea(nextOffsetX, _tmpNextOffsetY);
                var _newVisibleRecommendArea = getIntersectionVisibleArea(nextOffsetX, _tmpNextOffsetY, visibleRegionArea);
                if (// Of course use larger one
                _newVisibleArea > originIntersectionVisibleArea || _newVisibleArea === originIntersectionVisibleArea && (!isVisibleFirst || // Choose recommend one
                _newVisibleRecommendArea >= originIntersectionRecommendArea)) {
                    prevFlipRef.current.tb = true;
                    nextOffsetY = _tmpNextOffsetY;
                    popupOffsetY = -popupOffsetY;
                    nextAlignInfo.points = [
                        $a3ab468f9842aab3$var$reversePoints(popupPoints, 0),
                        $a3ab468f9842aab3$var$reversePoints(targetPoints, 0)
                    ];
                } else prevFlipRef.current.tb = false;
            }
            // >>>>>>>>>> Left & Right
            var needAdjustX = supportAdjust(adjustX);
            // >>>>> Flip
            var sameLR = popupPoints[1] === targetPoints[1];
            // Right to Left
            if (needAdjustX && popupPoints[1] === "l" && (nextPopupRight > adjustCheckVisibleArea.right || prevFlipRef.current.rl)) {
                var tmpNextOffsetX = nextOffsetX;
                if (sameLR) tmpNextOffsetX -= popupWidth - targetWidth;
                else tmpNextOffsetX = targetAlignPointTL.x - popupAlignPointBR.x - popupOffsetX;
                var _newVisibleArea2 = getIntersectionVisibleArea(tmpNextOffsetX, nextOffsetY);
                var _newVisibleRecommendArea2 = getIntersectionVisibleArea(tmpNextOffsetX, nextOffsetY, visibleRegionArea);
                if (// Of course use larger one
                _newVisibleArea2 > originIntersectionVisibleArea || _newVisibleArea2 === originIntersectionVisibleArea && (!isVisibleFirst || // Choose recommend one
                _newVisibleRecommendArea2 >= originIntersectionRecommendArea)) {
                    prevFlipRef.current.rl = true;
                    nextOffsetX = tmpNextOffsetX;
                    popupOffsetX = -popupOffsetX;
                    nextAlignInfo.points = [
                        $a3ab468f9842aab3$var$reversePoints(popupPoints, 1),
                        $a3ab468f9842aab3$var$reversePoints(targetPoints, 1)
                    ];
                } else prevFlipRef.current.rl = false;
            }
            // Left to Right
            if (needAdjustX && popupPoints[1] === "r" && (nextPopupX < adjustCheckVisibleArea.left || prevFlipRef.current.lr)) {
                var _tmpNextOffsetX = nextOffsetX;
                if (sameLR) _tmpNextOffsetX += popupWidth - targetWidth;
                else _tmpNextOffsetX = targetAlignPointBR.x - popupAlignPointTL.x - popupOffsetX;
                var _newVisibleArea3 = getIntersectionVisibleArea(_tmpNextOffsetX, nextOffsetY);
                var _newVisibleRecommendArea3 = getIntersectionVisibleArea(_tmpNextOffsetX, nextOffsetY, visibleRegionArea);
                if (// Of course use larger one
                _newVisibleArea3 > originIntersectionVisibleArea || _newVisibleArea3 === originIntersectionVisibleArea && (!isVisibleFirst || // Choose recommend one
                _newVisibleRecommendArea3 >= originIntersectionRecommendArea)) {
                    prevFlipRef.current.lr = true;
                    nextOffsetX = _tmpNextOffsetX;
                    popupOffsetX = -popupOffsetX;
                    nextAlignInfo.points = [
                        $a3ab468f9842aab3$var$reversePoints(popupPoints, 1),
                        $a3ab468f9842aab3$var$reversePoints(targetPoints, 1)
                    ];
                } else prevFlipRef.current.lr = false;
            }
            // ============================ Shift ============================
            syncNextPopupPosition();
            var numShiftX = shiftX === true ? 0 : shiftX;
            if (typeof numShiftX === "number") {
                // Left
                if (nextPopupX < visibleRegionArea.left) {
                    nextOffsetX -= nextPopupX - visibleRegionArea.left - popupOffsetX;
                    if (targetRect.x + targetWidth < visibleRegionArea.left + numShiftX) nextOffsetX += targetRect.x - visibleRegionArea.left + targetWidth - numShiftX;
                }
                // Right
                if (nextPopupRight > visibleRegionArea.right) {
                    nextOffsetX -= nextPopupRight - visibleRegionArea.right - popupOffsetX;
                    if (targetRect.x > visibleRegionArea.right - numShiftX) nextOffsetX += targetRect.x - visibleRegionArea.right + numShiftX;
                }
            }
            var numShiftY = shiftY === true ? 0 : shiftY;
            if (typeof numShiftY === "number") {
                // Top
                if (nextPopupY < visibleRegionArea.top) {
                    nextOffsetY -= nextPopupY - visibleRegionArea.top - popupOffsetY;
                    // When target if far away from visible area
                    // Stop shift
                    if (targetRect.y + targetHeight < visibleRegionArea.top + numShiftY) nextOffsetY += targetRect.y - visibleRegionArea.top + targetHeight - numShiftY;
                }
                // Bottom
                if (nextPopupBottom > visibleRegionArea.bottom) {
                    nextOffsetY -= nextPopupBottom - visibleRegionArea.bottom - popupOffsetY;
                    if (targetRect.y > visibleRegionArea.bottom - numShiftY) nextOffsetY += targetRect.y - visibleRegionArea.bottom + numShiftY;
                }
            }
            // ============================ Arrow ============================
            // Arrow center align
            var popupLeft = popupRect.x + nextOffsetX;
            var popupRight = popupLeft + popupWidth;
            var popupTop = popupRect.y + nextOffsetY;
            var popupBottom = popupTop + popupHeight;
            var targetLeft = targetRect.x;
            var targetRight = targetLeft + targetWidth;
            var targetTop = targetRect.y;
            var targetBottom = targetTop + targetHeight;
            var maxLeft = Math.max(popupLeft, targetLeft);
            var minRight = Math.min(popupRight, targetRight);
            var xCenter = (maxLeft + minRight) / 2;
            var nextArrowX = xCenter - popupLeft;
            var maxTop = Math.max(popupTop, targetTop);
            var minBottom = Math.min(popupBottom, targetBottom);
            var yCenter = (maxTop + minBottom) / 2;
            var nextArrowY = yCenter - popupTop;
            onPopupAlign === null || onPopupAlign === void 0 || onPopupAlign(popupEle, nextAlignInfo);
            // Additional calculate right & bottom position
            var offsetX4Right = popupMirrorRect.right - popupRect.x - (nextOffsetX + popupRect.width);
            var offsetY4Bottom = popupMirrorRect.bottom - popupRect.y - (nextOffsetY + popupRect.height);
            setOffsetInfo({
                ready: true,
                offsetX: nextOffsetX / _scaleX,
                offsetY: nextOffsetY / _scaleY,
                offsetR: offsetX4Right / _scaleX,
                offsetB: offsetY4Bottom / _scaleY,
                arrowX: nextArrowX / _scaleX,
                arrowY: nextArrowY / _scaleY,
                scaleX: _scaleX,
                scaleY: _scaleY,
                align: nextAlignInfo
            });
        }
    });
    var triggerAlign = function triggerAlign() {
        alignCountRef.current += 1;
        var id = alignCountRef.current;
        // Merge all align requirement into one frame
        Promise.resolve().then(function() {
            if (alignCountRef.current === id) onAlign();
        });
    };
    // Reset ready status when placement & open changed
    var resetReady = function resetReady() {
        setOffsetInfo(function(ori) {
            return (0, $983350b7b3960a26$export$2e2bcd8739ae039)((0, $983350b7b3960a26$export$2e2bcd8739ae039)({}, ori), {}, {
                ready: false
            });
        });
    };
    (0, $493347a9fd5d8394$export$2e2bcd8739ae039)(resetReady, [
        placement
    ]);
    (0, $493347a9fd5d8394$export$2e2bcd8739ae039)(function() {
        if (!open) resetReady();
    }, [
        open
    ]);
    return [
        offsetInfo.ready,
        offsetInfo.offsetX,
        offsetInfo.offsetY,
        offsetInfo.offsetR,
        offsetInfo.offsetB,
        offsetInfo.arrowX,
        offsetInfo.arrowY,
        offsetInfo.scaleX,
        offsetInfo.scaleY,
        offsetInfo.align,
        triggerAlign
    ];
}





function $02923bfaa4b78dec$export$2e2bcd8739ae039(open, target, popup, onAlign, onScroll) {
    (0, $493347a9fd5d8394$export$2e2bcd8739ae039)(function() {
        if (open && target && popup) {
            var targetElement = target;
            var popupElement = popup;
            var targetScrollList = (0, $140ec2a5382714e1$export$ba21ed9400ca485b)(targetElement);
            var popupScrollList = (0, $140ec2a5382714e1$export$ba21ed9400ca485b)(popupElement);
            var win = (0, $140ec2a5382714e1$export$9c0584a7cc24d9e)(popupElement);
            var mergedList = new Set([
                win
            ].concat((0, $eb1ed927433e7e98$export$2e2bcd8739ae039)(targetScrollList), (0, $eb1ed927433e7e98$export$2e2bcd8739ae039)(popupScrollList)));
            function notifyScroll() {
                onAlign();
                onScroll();
            }
            mergedList.forEach(function(scroller) {
                scroller.addEventListener("scroll", notifyScroll, {
                    passive: true
                });
            });
            win.addEventListener("resize", notifyScroll, {
                passive: true
            });
            // First time always do align
            onAlign();
            return function() {
                mergedList.forEach(function(scroller) {
                    scroller.removeEventListener("scroll", notifyScroll);
                    win.removeEventListener("resize", notifyScroll);
                });
            };
        }
    }, [
        open,
        target,
        popup
    ]);
}







var $acw62 = parcelRequire("acw62");

function $81078b27d1014ac5$export$2e2bcd8739ae039(open, clickToHide, targetEle, popupEle, mask, maskClosable, inPopupOrChild, triggerOpen) {
    var openRef = $acw62.useRef(open);
    // Window click to hide should be lock to avoid trigger lock immediately
    var lockRef = $acw62.useRef(false);
    if (openRef.current !== open) {
        lockRef.current = true;
        openRef.current = open;
    }
    $acw62.useEffect(function() {
        var id = (0, $a1ced7b983ea61a4$export$2e2bcd8739ae039)(function() {
            lockRef.current = false;
        });
        return function() {
            (0, $a1ced7b983ea61a4$export$2e2bcd8739ae039).cancel(id);
        };
    }, [
        open
    ]);
    // Click to hide is special action since click popup element should not hide
    $acw62.useEffect(function() {
        if (clickToHide && popupEle && (!mask || maskClosable)) {
            var genClickEvents = function genClickEvents() {
                var clickInside = false;
                // User may mouseDown inside and drag out of popup and mouse up
                // Record here to prevent close
                var onWindowMouseDown = function onWindowMouseDown(_ref) {
                    var target = _ref.target;
                    clickInside = inPopupOrChild(target);
                };
                var onWindowClick = function onWindowClick(_ref2) {
                    var target = _ref2.target;
                    if (!lockRef.current && openRef.current && !clickInside && !inPopupOrChild(target)) triggerOpen(false);
                };
                return [
                    onWindowMouseDown,
                    onWindowClick
                ];
            };
            // Events
            var _genClickEvents = genClickEvents(), _genClickEvents2 = (0, $adaabbc18727b3e6$export$2e2bcd8739ae039)(_genClickEvents, 2), onWinMouseDown = _genClickEvents2[0], onWinClick = _genClickEvents2[1];
            var _genClickEvents3 = genClickEvents(), _genClickEvents4 = (0, $adaabbc18727b3e6$export$2e2bcd8739ae039)(_genClickEvents3, 2), onShadowMouseDown = _genClickEvents4[0], onShadowClick = _genClickEvents4[1];
            var win = (0, $140ec2a5382714e1$export$9c0584a7cc24d9e)(popupEle);
            win.addEventListener("mousedown", onWinMouseDown, true);
            win.addEventListener("click", onWinClick, true);
            win.addEventListener("contextmenu", onWinClick, true);
            // shadow root
            var targetShadowRoot = (0, $b9f59244e9def868$export$70e8259662bb498b)(targetEle);
            if (targetShadowRoot) {
                targetShadowRoot.addEventListener("mousedown", onShadowMouseDown, true);
                targetShadowRoot.addEventListener("click", onShadowClick, true);
                targetShadowRoot.addEventListener("contextmenu", onShadowClick, true);
            }
            var _targetEle$getRootNod, _popupEle$getRootNode;
            var targetRoot = targetEle === null || targetEle === void 0 || (_targetEle$getRootNod = targetEle.getRootNode) === null || _targetEle$getRootNod === void 0 ? void 0 : _targetEle$getRootNod.call(targetEle);
            var popupRoot = (_popupEle$getRootNode = popupEle.getRootNode) === null || _popupEle$getRootNode === void 0 ? void 0 : _popupEle$getRootNode.call(popupEle);
            (0, $05a5f2c645683a81$export$491112666e282270)(targetRoot === popupRoot, "trigger element and popup element should in same shadow root.");
            return function() {
                win.removeEventListener("mousedown", onWinMouseDown, true);
                win.removeEventListener("click", onWinClick, true);
                win.removeEventListener("contextmenu", onWinClick, true);
                if (targetShadowRoot) {
                    targetShadowRoot.removeEventListener("mousedown", onShadowMouseDown, true);
                    targetShadowRoot.removeEventListener("click", onShadowClick, true);
                    targetShadowRoot.removeEventListener("contextmenu", onShadowClick, true);
                }
            };
        }
    }, [
        clickToHide,
        targetEle,
        popupEle,
        mask,
        maskClosable
    ]);
}



var $a99c76d30a1f506f$var$_excluded = [
    "prefixCls",
    "children",
    "action",
    "showAction",
    "hideAction",
    "popupVisible",
    "defaultPopupVisible",
    "onPopupVisibleChange",
    "afterPopupVisibleChange",
    "mouseEnterDelay",
    "mouseLeaveDelay",
    "focusDelay",
    "blurDelay",
    "mask",
    "maskClosable",
    "getPopupContainer",
    "forceRender",
    "autoDestroy",
    "destroyPopupOnHide",
    "popup",
    "popupClassName",
    "popupStyle",
    "popupPlacement",
    "builtinPlacements",
    "popupAlign",
    "zIndex",
    "stretch",
    "getPopupClassNameFromAlign",
    "fresh",
    "alignPoint",
    "onPopupClick",
    "onPopupAlign",
    "arrow",
    "popupMotion",
    "maskMotion",
    "popupTransitionName",
    "popupAnimation",
    "maskTransitionName",
    "maskAnimation",
    "className",
    "getTriggerDOMNode"
];
function $a99c76d30a1f506f$export$55e99723d7f71b47() {
    var PortalComponent = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : (0, $5b46218595a40828$export$2e2bcd8739ae039);
    var Trigger = /*#__PURE__*/ $acw62.forwardRef(function(props, ref) {
        var _props$prefixCls = props.prefixCls, prefixCls = _props$prefixCls === void 0 ? "rc-trigger-popup" : _props$prefixCls, children = props.children, _props$action = props.action, action = _props$action === void 0 ? "hover" : _props$action, showAction = props.showAction, hideAction = props.hideAction, popupVisible = props.popupVisible, defaultPopupVisible = props.defaultPopupVisible, onPopupVisibleChange = props.onPopupVisibleChange, afterPopupVisibleChange = props.afterPopupVisibleChange, mouseEnterDelay = props.mouseEnterDelay, _props$mouseLeaveDela = props.mouseLeaveDelay, mouseLeaveDelay = _props$mouseLeaveDela === void 0 ? 0.1 : _props$mouseLeaveDela, focusDelay = props.focusDelay, blurDelay = props.blurDelay, mask = props.mask, _props$maskClosable = props.maskClosable, maskClosable = _props$maskClosable === void 0 ? true : _props$maskClosable, getPopupContainer = props.getPopupContainer, forceRender = props.forceRender, autoDestroy = props.autoDestroy, destroyPopupOnHide = props.destroyPopupOnHide, popup = props.popup, popupClassName = props.popupClassName, popupStyle = props.popupStyle, popupPlacement = props.popupPlacement, _props$builtinPlaceme = props.builtinPlacements, builtinPlacements = _props$builtinPlaceme === void 0 ? {} : _props$builtinPlaceme, popupAlign = props.popupAlign, zIndex = props.zIndex, stretch = props.stretch, getPopupClassNameFromAlign = props.getPopupClassNameFromAlign, fresh = props.fresh, alignPoint = props.alignPoint, onPopupClick = props.onPopupClick, onPopupAlign = props.onPopupAlign, arrow = props.arrow, popupMotion = props.popupMotion, maskMotion = props.maskMotion, popupTransitionName = props.popupTransitionName, popupAnimation = props.popupAnimation, maskTransitionName = props.maskTransitionName, maskAnimation = props.maskAnimation, className = props.className, getTriggerDOMNode = props.getTriggerDOMNode, restProps = (0, $73ef9ce1c41fc0c0$export$2e2bcd8739ae039)(props, $a99c76d30a1f506f$var$_excluded);
        var mergedAutoDestroy = autoDestroy || destroyPopupOnHide || false;
        // =========================== Mobile ===========================
        var _React$useState = $acw62.useState(false), _React$useState2 = (0, $adaabbc18727b3e6$export$2e2bcd8739ae039)(_React$useState, 2), mobile = _React$useState2[0], setMobile = _React$useState2[1];
        (0, $493347a9fd5d8394$export$2e2bcd8739ae039)(function() {
            setMobile((0, $066d1680709fcf3c$export$2e2bcd8739ae039)());
        }, []);
        // ========================== Context ===========================
        var subPopupElements = $acw62.useRef({});
        var parentContext = $acw62.useContext((0, $f9b439e1e53d6d59$export$2e2bcd8739ae039));
        var context = $acw62.useMemo(function() {
            return {
                registerSubPopup: function registerSubPopup(id, subPopupEle) {
                    subPopupElements.current[id] = subPopupEle;
                    parentContext === null || parentContext === void 0 || parentContext.registerSubPopup(id, subPopupEle);
                }
            };
        }, [
            parentContext
        ]);
        // =========================== Popup ============================
        var id = (0, $d23d006593dfab9c$export$2e2bcd8739ae039)();
        var _React$useState3 = $acw62.useState(null), _React$useState4 = (0, $adaabbc18727b3e6$export$2e2bcd8739ae039)(_React$useState3, 2), popupEle = _React$useState4[0], setPopupEle = _React$useState4[1];
        var setPopupRef = (0, $01e43e72865dc583$export$2e2bcd8739ae039)(function(node) {
            if ((0, $808ab7b8a87ab771$export$41e30d8dd0ba7a50)(node) && popupEle !== node) setPopupEle(node);
            parentContext === null || parentContext === void 0 || parentContext.registerSubPopup(id, node);
        });
        // =========================== Target ===========================
        // Use state to control here since `useRef` update not trigger render
        var _React$useState5 = $acw62.useState(null), _React$useState6 = (0, $adaabbc18727b3e6$export$2e2bcd8739ae039)(_React$useState5, 2), targetEle = _React$useState6[0], setTargetEle = _React$useState6[1];
        // Used for forwardRef target. Not use internal
        var externalForwardRef = $acw62.useRef(null);
        var setTargetRef = (0, $01e43e72865dc583$export$2e2bcd8739ae039)(function(node) {
            if ((0, $808ab7b8a87ab771$export$41e30d8dd0ba7a50)(node) && targetEle !== node) {
                setTargetEle(node);
                externalForwardRef.current = node;
            }
        });
        // ========================== Children ==========================
        var child = $acw62.Children.only(children);
        var originChildProps = (child === null || child === void 0 ? void 0 : child.props) || {};
        var cloneProps = {};
        var inPopupOrChild = (0, $01e43e72865dc583$export$2e2bcd8739ae039)(function(ele) {
            var _getShadowRoot, _getShadowRoot2;
            var childDOM = targetEle;
            return (childDOM === null || childDOM === void 0 ? void 0 : childDOM.contains(ele)) || ((_getShadowRoot = (0, $b9f59244e9def868$export$70e8259662bb498b)(childDOM)) === null || _getShadowRoot === void 0 ? void 0 : _getShadowRoot.host) === ele || ele === childDOM || (popupEle === null || popupEle === void 0 ? void 0 : popupEle.contains(ele)) || ((_getShadowRoot2 = (0, $b9f59244e9def868$export$70e8259662bb498b)(popupEle)) === null || _getShadowRoot2 === void 0 ? void 0 : _getShadowRoot2.host) === ele || ele === popupEle || Object.values(subPopupElements.current).some(function(subPopupEle) {
                return (subPopupEle === null || subPopupEle === void 0 ? void 0 : subPopupEle.contains(ele)) || ele === subPopupEle;
            });
        });
        // =========================== Motion ===========================
        var mergePopupMotion = (0, $140ec2a5382714e1$export$7b8936ddc277a29a)(prefixCls, popupMotion, popupAnimation, popupTransitionName);
        var mergeMaskMotion = (0, $140ec2a5382714e1$export$7b8936ddc277a29a)(prefixCls, maskMotion, maskAnimation, maskTransitionName);
        // ============================ Open ============================
        var _React$useState7 = $acw62.useState(defaultPopupVisible || false), _React$useState8 = (0, $adaabbc18727b3e6$export$2e2bcd8739ae039)(_React$useState7, 2), internalOpen = _React$useState8[0], setInternalOpen = _React$useState8[1];
        // Render still use props as first priority
        var mergedOpen = popupVisible !== null && popupVisible !== void 0 ? popupVisible : internalOpen;
        // We use effect sync here in case `popupVisible` back to `undefined`
        var setMergedOpen = (0, $01e43e72865dc583$export$2e2bcd8739ae039)(function(nextOpen) {
            if (popupVisible === undefined) setInternalOpen(nextOpen);
        });
        (0, $493347a9fd5d8394$export$2e2bcd8739ae039)(function() {
            setInternalOpen(popupVisible || false);
        }, [
            popupVisible
        ]);
        var openRef = $acw62.useRef(mergedOpen);
        openRef.current = mergedOpen;
        var lastTriggerRef = $acw62.useRef([]);
        lastTriggerRef.current = [];
        var internalTriggerOpen = (0, $01e43e72865dc583$export$2e2bcd8739ae039)(function(nextOpen) {
            var _lastTriggerRef$curre;
            setMergedOpen(nextOpen);
            // Enter or Pointer will both trigger open state change
            // We only need take one to avoid duplicated change event trigger
            // Use `lastTriggerRef` to record last open type
            if (((_lastTriggerRef$curre = lastTriggerRef.current[lastTriggerRef.current.length - 1]) !== null && _lastTriggerRef$curre !== void 0 ? _lastTriggerRef$curre : mergedOpen) !== nextOpen) {
                lastTriggerRef.current.push(nextOpen);
                onPopupVisibleChange === null || onPopupVisibleChange === void 0 || onPopupVisibleChange(nextOpen);
            }
        });
        // Trigger for delay
        var delayRef = $acw62.useRef();
        var clearDelay = function clearDelay() {
            clearTimeout(delayRef.current);
        };
        var triggerOpen = function triggerOpen(nextOpen) {
            var delay = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
            clearDelay();
            if (delay === 0) internalTriggerOpen(nextOpen);
            else delayRef.current = setTimeout(function() {
                internalTriggerOpen(nextOpen);
            }, delay * 1000);
        };
        $acw62.useEffect(function() {
            return clearDelay;
        }, []);
        // ========================== Motion ============================
        var _React$useState9 = $acw62.useState(false), _React$useState10 = (0, $adaabbc18727b3e6$export$2e2bcd8739ae039)(_React$useState9, 2), inMotion = _React$useState10[0], setInMotion = _React$useState10[1];
        (0, $493347a9fd5d8394$export$2e2bcd8739ae039)(function(firstMount) {
            if (!firstMount || mergedOpen) setInMotion(true);
        }, [
            mergedOpen
        ]);
        var _React$useState11 = $acw62.useState(null), _React$useState12 = (0, $adaabbc18727b3e6$export$2e2bcd8739ae039)(_React$useState11, 2), motionPrepareResolve = _React$useState12[0], setMotionPrepareResolve = _React$useState12[1];
        // =========================== Align ============================
        var _React$useState13 = $acw62.useState([
            0,
            0
        ]), _React$useState14 = (0, $adaabbc18727b3e6$export$2e2bcd8739ae039)(_React$useState13, 2), mousePos = _React$useState14[0], setMousePos = _React$useState14[1];
        var setMousePosByEvent = function setMousePosByEvent(event) {
            setMousePos([
                event.clientX,
                event.clientY
            ]);
        };
        var _useAlign = (0, $a3ab468f9842aab3$export$2e2bcd8739ae039)(mergedOpen, popupEle, alignPoint ? mousePos : targetEle, popupPlacement, builtinPlacements, popupAlign, onPopupAlign), _useAlign2 = (0, $adaabbc18727b3e6$export$2e2bcd8739ae039)(_useAlign, 11), ready = _useAlign2[0], offsetX = _useAlign2[1], offsetY = _useAlign2[2], offsetR = _useAlign2[3], offsetB = _useAlign2[4], arrowX = _useAlign2[5], arrowY = _useAlign2[6], scaleX = _useAlign2[7], scaleY = _useAlign2[8], alignInfo = _useAlign2[9], onAlign = _useAlign2[10];
        var _useAction = (0, $65f8789299df97eb$export$2e2bcd8739ae039)(mobile, action, showAction, hideAction), _useAction2 = (0, $adaabbc18727b3e6$export$2e2bcd8739ae039)(_useAction, 2), showActions = _useAction2[0], hideActions = _useAction2[1];
        var clickToShow = showActions.has("click");
        var clickToHide = hideActions.has("click") || hideActions.has("contextMenu");
        var triggerAlign = (0, $01e43e72865dc583$export$2e2bcd8739ae039)(function() {
            if (!inMotion) onAlign();
        });
        var onScroll = function onScroll() {
            if (openRef.current && alignPoint && clickToHide) triggerOpen(false);
        };
        (0, $02923bfaa4b78dec$export$2e2bcd8739ae039)(mergedOpen, targetEle, popupEle, triggerAlign, onScroll);
        (0, $493347a9fd5d8394$export$2e2bcd8739ae039)(function() {
            triggerAlign();
        }, [
            mousePos,
            popupPlacement
        ]);
        // When no builtinPlacements and popupAlign changed
        (0, $493347a9fd5d8394$export$2e2bcd8739ae039)(function() {
            if (mergedOpen && !(builtinPlacements !== null && builtinPlacements !== void 0 && builtinPlacements[popupPlacement])) triggerAlign();
        }, [
            JSON.stringify(popupAlign)
        ]);
        var alignedClassName = $acw62.useMemo(function() {
            var baseClassName = (0, $140ec2a5382714e1$export$faa0aa8ed2fe6432)(builtinPlacements, prefixCls, alignInfo, alignPoint);
            return (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))(baseClassName, getPopupClassNameFromAlign === null || getPopupClassNameFromAlign === void 0 ? void 0 : getPopupClassNameFromAlign(alignInfo));
        }, [
            alignInfo,
            getPopupClassNameFromAlign,
            builtinPlacements,
            prefixCls,
            alignPoint
        ]);
        // ============================ Refs ============================
        $acw62.useImperativeHandle(ref, function() {
            return {
                nativeElement: externalForwardRef.current,
                forceAlign: triggerAlign
            };
        });
        // ========================== Stretch ===========================
        var _React$useState15 = $acw62.useState(0), _React$useState16 = (0, $adaabbc18727b3e6$export$2e2bcd8739ae039)(_React$useState15, 2), targetWidth = _React$useState16[0], setTargetWidth = _React$useState16[1];
        var _React$useState17 = $acw62.useState(0), _React$useState18 = (0, $adaabbc18727b3e6$export$2e2bcd8739ae039)(_React$useState17, 2), targetHeight = _React$useState18[0], setTargetHeight = _React$useState18[1];
        var syncTargetSize = function syncTargetSize() {
            if (stretch && targetEle) {
                var rect = targetEle.getBoundingClientRect();
                setTargetWidth(rect.width);
                setTargetHeight(rect.height);
            }
        };
        var onTargetResize = function onTargetResize() {
            syncTargetSize();
            triggerAlign();
        };
        // ========================== Motion ============================
        var onVisibleChanged = function onVisibleChanged(visible) {
            setInMotion(false);
            onAlign();
            afterPopupVisibleChange === null || afterPopupVisibleChange === void 0 || afterPopupVisibleChange(visible);
        };
        // We will trigger align when motion is in prepare
        var onPrepare = function onPrepare() {
            return new Promise(function(resolve) {
                syncTargetSize();
                setMotionPrepareResolve(function() {
                    return resolve;
                });
            });
        };
        (0, $493347a9fd5d8394$export$2e2bcd8739ae039)(function() {
            if (motionPrepareResolve) {
                onAlign();
                motionPrepareResolve();
                setMotionPrepareResolve(null);
            }
        }, [
            motionPrepareResolve
        ]);
        // =========================== Action ===========================
        /**
     * Util wrapper for trigger action
     */ function wrapperAction(eventName, nextOpen, delay, preEvent) {
            cloneProps[eventName] = function(event) {
                var _originChildProps$eve;
                preEvent === null || preEvent === void 0 || preEvent(event);
                triggerOpen(nextOpen, delay);
                // Pass to origin
                for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)args[_key - 1] = arguments[_key];
                (_originChildProps$eve = originChildProps[eventName]) === null || _originChildProps$eve === void 0 || _originChildProps$eve.call.apply(_originChildProps$eve, [
                    originChildProps,
                    event
                ].concat(args));
            };
        }
        // ======================= Action: Click ========================
        if (clickToShow || clickToHide) cloneProps.onClick = function(event) {
            var _originChildProps$onC;
            if (openRef.current && clickToHide) triggerOpen(false);
            else if (!openRef.current && clickToShow) {
                setMousePosByEvent(event);
                triggerOpen(true);
            }
            // Pass to origin
            for(var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++)args[_key2 - 1] = arguments[_key2];
            (_originChildProps$onC = originChildProps.onClick) === null || _originChildProps$onC === void 0 || _originChildProps$onC.call.apply(_originChildProps$onC, [
                originChildProps,
                event
            ].concat(args));
        };
        // Click to hide is special action since click popup element should not hide
        (0, $81078b27d1014ac5$export$2e2bcd8739ae039)(mergedOpen, clickToHide, targetEle, popupEle, mask, maskClosable, inPopupOrChild, triggerOpen);
        // ======================= Action: Hover ========================
        var hoverToShow = showActions.has("hover");
        var hoverToHide = hideActions.has("hover");
        var onPopupMouseEnter;
        var onPopupMouseLeave;
        if (hoverToShow) {
            // Compatible with old browser which not support pointer event
            wrapperAction("onMouseEnter", true, mouseEnterDelay, function(event) {
                setMousePosByEvent(event);
            });
            wrapperAction("onPointerEnter", true, mouseEnterDelay, function(event) {
                setMousePosByEvent(event);
            });
            onPopupMouseEnter = function onPopupMouseEnter() {
                // Only trigger re-open when popup is visible
                if (mergedOpen || inMotion) triggerOpen(true, mouseEnterDelay);
            };
            // Align Point
            if (alignPoint) cloneProps.onMouseMove = function(event) {
                var _originChildProps$onM;
                // setMousePosByEvent(event);
                (_originChildProps$onM = originChildProps.onMouseMove) === null || _originChildProps$onM === void 0 || _originChildProps$onM.call(originChildProps, event);
            };
        }
        if (hoverToHide) {
            wrapperAction("onMouseLeave", false, mouseLeaveDelay);
            wrapperAction("onPointerLeave", false, mouseLeaveDelay);
            onPopupMouseLeave = function onPopupMouseLeave() {
                triggerOpen(false, mouseLeaveDelay);
            };
        }
        // ======================= Action: Focus ========================
        if (showActions.has("focus")) wrapperAction("onFocus", true, focusDelay);
        if (hideActions.has("focus")) wrapperAction("onBlur", false, blurDelay);
        // ==================== Action: ContextMenu =====================
        if (showActions.has("contextMenu")) cloneProps.onContextMenu = function(event) {
            var _originChildProps$onC2;
            if (openRef.current && hideActions.has("contextMenu")) triggerOpen(false);
            else {
                setMousePosByEvent(event);
                triggerOpen(true);
            }
            event.preventDefault();
            // Pass to origin
            for(var _len3 = arguments.length, args = new Array(_len3 > 1 ? _len3 - 1 : 0), _key3 = 1; _key3 < _len3; _key3++)args[_key3 - 1] = arguments[_key3];
            (_originChildProps$onC2 = originChildProps.onContextMenu) === null || _originChildProps$onC2 === void 0 || _originChildProps$onC2.call.apply(_originChildProps$onC2, [
                originChildProps,
                event
            ].concat(args));
        };
        // ========================= ClassName ==========================
        if (className) cloneProps.className = (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))(originChildProps.className, className);
        // =========================== Render ===========================
        var mergedChildrenProps = (0, $983350b7b3960a26$export$2e2bcd8739ae039)((0, $983350b7b3960a26$export$2e2bcd8739ae039)({}, originChildProps), cloneProps);
        // Pass props into cloneProps for nest usage
        var passedProps = {};
        var passedEventList = [
            "onContextMenu",
            "onClick",
            "onMouseDown",
            "onTouchStart",
            "onMouseEnter",
            "onMouseLeave",
            "onFocus",
            "onBlur"
        ];
        passedEventList.forEach(function(eventName) {
            if (restProps[eventName]) passedProps[eventName] = function() {
                var _mergedChildrenProps$;
                for(var _len4 = arguments.length, args = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++)args[_key4] = arguments[_key4];
                (_mergedChildrenProps$ = mergedChildrenProps[eventName]) === null || _mergedChildrenProps$ === void 0 || _mergedChildrenProps$.call.apply(_mergedChildrenProps$, [
                    mergedChildrenProps
                ].concat(args));
                restProps[eventName].apply(restProps, args);
            };
        });
        // Child Node
        var triggerNode = /*#__PURE__*/ $acw62.cloneElement(child, (0, $983350b7b3960a26$export$2e2bcd8739ae039)((0, $983350b7b3960a26$export$2e2bcd8739ae039)({}, mergedChildrenProps), passedProps));
        var arrowPos = {
            x: arrowX,
            y: arrowY
        };
        var innerArrow = arrow ? (0, $983350b7b3960a26$export$2e2bcd8739ae039)({}, arrow !== true ? arrow : {}) : null;
        // Render
        return /*#__PURE__*/ $acw62.createElement($acw62.Fragment, null, /*#__PURE__*/ $acw62.createElement((0, $8aeee349dead8f85$export$2e2bcd8739ae039), {
            disabled: !mergedOpen,
            ref: setTargetRef,
            onResize: onTargetResize
        }, /*#__PURE__*/ $acw62.createElement((0, $afb5ff905a8de769$export$2e2bcd8739ae039), {
            getTriggerDOMNode: getTriggerDOMNode
        }, triggerNode)), /*#__PURE__*/ $acw62.createElement((0, $f9b439e1e53d6d59$export$2e2bcd8739ae039).Provider, {
            value: context
        }, /*#__PURE__*/ $acw62.createElement((0, $d8446137fd226eb8$export$2e2bcd8739ae039), {
            portal: PortalComponent,
            ref: setPopupRef,
            prefixCls: prefixCls,
            popup: popup,
            className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))(popupClassName, alignedClassName),
            style: popupStyle,
            target: targetEle,
            onMouseEnter: onPopupMouseEnter,
            onMouseLeave: onPopupMouseLeave,
            onPointerEnter: onPopupMouseEnter,
            zIndex: zIndex,
            open: mergedOpen,
            keepDom: inMotion,
            fresh: fresh,
            onClick: onPopupClick,
            mask: mask,
            motion: mergePopupMotion,
            maskMotion: mergeMaskMotion,
            onVisibleChanged: onVisibleChanged,
            onPrepare: onPrepare,
            forceRender: forceRender,
            autoDestroy: mergedAutoDestroy,
            getPopupContainer: getPopupContainer,
            align: alignInfo,
            arrow: innerArrow,
            arrowPos: arrowPos,
            ready: ready,
            offsetX: offsetX,
            offsetY: offsetY,
            offsetR: offsetR,
            offsetB: offsetB,
            onAlign: triggerAlign,
            stretch: stretch,
            targetWidth: targetWidth / scaleX,
            targetHeight: targetHeight / scaleY
        })));
    });
    Trigger.displayName = "Trigger";
    return Trigger;
}
var $a99c76d30a1f506f$export$2e2bcd8739ae039 = $a99c76d30a1f506f$export$55e99723d7f71b47((0, $5b46218595a40828$export$2e2bcd8739ae039));





var $acw62 = parcelRequire("acw62");
/**
 * @ignore
 * some key-codes definition and utils from closure-library
 * @author yiminghe@gmail.com
 */ var $d8d9cb1a28007639$var$KeyCode = {
    /**
   * MAC_ENTER
   */ MAC_ENTER: 3,
    /**
   * BACKSPACE
   */ BACKSPACE: 8,
    /**
   * TAB
   */ TAB: 9,
    /**
   * NUMLOCK on FF/Safari Mac
   */ NUM_CENTER: 12,
    // NUMLOCK on FF/Safari Mac
    /**
   * ENTER
   */ ENTER: 13,
    /**
   * SHIFT
   */ SHIFT: 16,
    /**
   * CTRL
   */ CTRL: 17,
    /**
   * ALT
   */ ALT: 18,
    /**
   * PAUSE
   */ PAUSE: 19,
    /**
   * CAPS_LOCK
   */ CAPS_LOCK: 20,
    /**
   * ESC
   */ ESC: 27,
    /**
   * SPACE
   */ SPACE: 32,
    /**
   * PAGE_UP
   */ PAGE_UP: 33,
    // also NUM_NORTH_EAST
    /**
   * PAGE_DOWN
   */ PAGE_DOWN: 34,
    // also NUM_SOUTH_EAST
    /**
   * END
   */ END: 35,
    // also NUM_SOUTH_WEST
    /**
   * HOME
   */ HOME: 36,
    // also NUM_NORTH_WEST
    /**
   * LEFT
   */ LEFT: 37,
    // also NUM_WEST
    /**
   * UP
   */ UP: 38,
    // also NUM_NORTH
    /**
   * RIGHT
   */ RIGHT: 39,
    // also NUM_EAST
    /**
   * DOWN
   */ DOWN: 40,
    // also NUM_SOUTH
    /**
   * PRINT_SCREEN
   */ PRINT_SCREEN: 44,
    /**
   * INSERT
   */ INSERT: 45,
    // also NUM_INSERT
    /**
   * DELETE
   */ DELETE: 46,
    // also NUM_DELETE
    /**
   * ZERO
   */ ZERO: 48,
    /**
   * ONE
   */ ONE: 49,
    /**
   * TWO
   */ TWO: 50,
    /**
   * THREE
   */ THREE: 51,
    /**
   * FOUR
   */ FOUR: 52,
    /**
   * FIVE
   */ FIVE: 53,
    /**
   * SIX
   */ SIX: 54,
    /**
   * SEVEN
   */ SEVEN: 55,
    /**
   * EIGHT
   */ EIGHT: 56,
    /**
   * NINE
   */ NINE: 57,
    /**
   * QUESTION_MARK
   */ QUESTION_MARK: 63,
    // needs localization
    /**
   * A
   */ A: 65,
    /**
   * B
   */ B: 66,
    /**
   * C
   */ C: 67,
    /**
   * D
   */ D: 68,
    /**
   * E
   */ E: 69,
    /**
   * F
   */ F: 70,
    /**
   * G
   */ G: 71,
    /**
   * H
   */ H: 72,
    /**
   * I
   */ I: 73,
    /**
   * J
   */ J: 74,
    /**
   * K
   */ K: 75,
    /**
   * L
   */ L: 76,
    /**
   * M
   */ M: 77,
    /**
   * N
   */ N: 78,
    /**
   * O
   */ O: 79,
    /**
   * P
   */ P: 80,
    /**
   * Q
   */ Q: 81,
    /**
   * R
   */ R: 82,
    /**
   * S
   */ S: 83,
    /**
   * T
   */ T: 84,
    /**
   * U
   */ U: 85,
    /**
   * V
   */ V: 86,
    /**
   * W
   */ W: 87,
    /**
   * X
   */ X: 88,
    /**
   * Y
   */ Y: 89,
    /**
   * Z
   */ Z: 90,
    /**
   * META
   */ META: 91,
    // WIN_KEY_LEFT
    /**
   * WIN_KEY_RIGHT
   */ WIN_KEY_RIGHT: 92,
    /**
   * CONTEXT_MENU
   */ CONTEXT_MENU: 93,
    /**
   * NUM_ZERO
   */ NUM_ZERO: 96,
    /**
   * NUM_ONE
   */ NUM_ONE: 97,
    /**
   * NUM_TWO
   */ NUM_TWO: 98,
    /**
   * NUM_THREE
   */ NUM_THREE: 99,
    /**
   * NUM_FOUR
   */ NUM_FOUR: 100,
    /**
   * NUM_FIVE
   */ NUM_FIVE: 101,
    /**
   * NUM_SIX
   */ NUM_SIX: 102,
    /**
   * NUM_SEVEN
   */ NUM_SEVEN: 103,
    /**
   * NUM_EIGHT
   */ NUM_EIGHT: 104,
    /**
   * NUM_NINE
   */ NUM_NINE: 105,
    /**
   * NUM_MULTIPLY
   */ NUM_MULTIPLY: 106,
    /**
   * NUM_PLUS
   */ NUM_PLUS: 107,
    /**
   * NUM_MINUS
   */ NUM_MINUS: 109,
    /**
   * NUM_PERIOD
   */ NUM_PERIOD: 110,
    /**
   * NUM_DIVISION
   */ NUM_DIVISION: 111,
    /**
   * F1
   */ F1: 112,
    /**
   * F2
   */ F2: 113,
    /**
   * F3
   */ F3: 114,
    /**
   * F4
   */ F4: 115,
    /**
   * F5
   */ F5: 116,
    /**
   * F6
   */ F6: 117,
    /**
   * F7
   */ F7: 118,
    /**
   * F8
   */ F8: 119,
    /**
   * F9
   */ F9: 120,
    /**
   * F10
   */ F10: 121,
    /**
   * F11
   */ F11: 122,
    /**
   * F12
   */ F12: 123,
    /**
   * NUMLOCK
   */ NUMLOCK: 144,
    /**
   * SEMICOLON
   */ SEMICOLON: 186,
    // needs localization
    /**
   * DASH
   */ DASH: 189,
    // needs localization
    /**
   * EQUALS
   */ EQUALS: 187,
    // needs localization
    /**
   * COMMA
   */ COMMA: 188,
    // needs localization
    /**
   * PERIOD
   */ PERIOD: 190,
    // needs localization
    /**
   * SLASH
   */ SLASH: 191,
    // needs localization
    /**
   * APOSTROPHE
   */ APOSTROPHE: 192,
    // needs localization
    /**
   * SINGLE_QUOTE
   */ SINGLE_QUOTE: 222,
    // needs localization
    /**
   * OPEN_SQUARE_BRACKET
   */ OPEN_SQUARE_BRACKET: 219,
    // needs localization
    /**
   * BACKSLASH
   */ BACKSLASH: 220,
    // needs localization
    /**
   * CLOSE_SQUARE_BRACKET
   */ CLOSE_SQUARE_BRACKET: 221,
    // needs localization
    /**
   * WIN_KEY
   */ WIN_KEY: 224,
    /**
   * MAC_FF_META
   */ MAC_FF_META: 224,
    // Firefox (Gecko) fires this for the meta key instead of 91
    /**
   * WIN_IME
   */ WIN_IME: 229,
    // ======================== Function ========================
    /**
   * whether text and modified key is entered at the same time.
   */ isTextModifyingKeyEvent: function isTextModifyingKeyEvent(e) {
        var keyCode = e.keyCode;
        if (e.altKey && !e.ctrlKey || e.metaKey || // Function keys don't generate text
        keyCode >= $d8d9cb1a28007639$var$KeyCode.F1 && keyCode <= $d8d9cb1a28007639$var$KeyCode.F12) return false;
        // The following keys are quite harmless, even in combination with
        // CTRL, ALT or SHIFT.
        switch(keyCode){
            case $d8d9cb1a28007639$var$KeyCode.ALT:
            case $d8d9cb1a28007639$var$KeyCode.CAPS_LOCK:
            case $d8d9cb1a28007639$var$KeyCode.CONTEXT_MENU:
            case $d8d9cb1a28007639$var$KeyCode.CTRL:
            case $d8d9cb1a28007639$var$KeyCode.DOWN:
            case $d8d9cb1a28007639$var$KeyCode.END:
            case $d8d9cb1a28007639$var$KeyCode.ESC:
            case $d8d9cb1a28007639$var$KeyCode.HOME:
            case $d8d9cb1a28007639$var$KeyCode.INSERT:
            case $d8d9cb1a28007639$var$KeyCode.LEFT:
            case $d8d9cb1a28007639$var$KeyCode.MAC_FF_META:
            case $d8d9cb1a28007639$var$KeyCode.META:
            case $d8d9cb1a28007639$var$KeyCode.NUMLOCK:
            case $d8d9cb1a28007639$var$KeyCode.NUM_CENTER:
            case $d8d9cb1a28007639$var$KeyCode.PAGE_DOWN:
            case $d8d9cb1a28007639$var$KeyCode.PAGE_UP:
            case $d8d9cb1a28007639$var$KeyCode.PAUSE:
            case $d8d9cb1a28007639$var$KeyCode.PRINT_SCREEN:
            case $d8d9cb1a28007639$var$KeyCode.RIGHT:
            case $d8d9cb1a28007639$var$KeyCode.SHIFT:
            case $d8d9cb1a28007639$var$KeyCode.UP:
            case $d8d9cb1a28007639$var$KeyCode.WIN_KEY:
            case $d8d9cb1a28007639$var$KeyCode.WIN_KEY_RIGHT:
                return false;
            default:
                return true;
        }
    },
    /**
   * whether character is entered.
   */ isCharacterKey: function isCharacterKey(keyCode) {
        if (keyCode >= $d8d9cb1a28007639$var$KeyCode.ZERO && keyCode <= $d8d9cb1a28007639$var$KeyCode.NINE) return true;
        if (keyCode >= $d8d9cb1a28007639$var$KeyCode.NUM_ZERO && keyCode <= $d8d9cb1a28007639$var$KeyCode.NUM_MULTIPLY) return true;
        if (keyCode >= $d8d9cb1a28007639$var$KeyCode.A && keyCode <= $d8d9cb1a28007639$var$KeyCode.Z) return true;
        // Safari sends zero key code for non-latin characters.
        if (window.navigator.userAgent.indexOf("WebKit") !== -1 && keyCode === 0) return true;
        switch(keyCode){
            case $d8d9cb1a28007639$var$KeyCode.SPACE:
            case $d8d9cb1a28007639$var$KeyCode.QUESTION_MARK:
            case $d8d9cb1a28007639$var$KeyCode.NUM_PLUS:
            case $d8d9cb1a28007639$var$KeyCode.NUM_MINUS:
            case $d8d9cb1a28007639$var$KeyCode.NUM_PERIOD:
            case $d8d9cb1a28007639$var$KeyCode.NUM_DIVISION:
            case $d8d9cb1a28007639$var$KeyCode.SEMICOLON:
            case $d8d9cb1a28007639$var$KeyCode.DASH:
            case $d8d9cb1a28007639$var$KeyCode.EQUALS:
            case $d8d9cb1a28007639$var$KeyCode.COMMA:
            case $d8d9cb1a28007639$var$KeyCode.PERIOD:
            case $d8d9cb1a28007639$var$KeyCode.SLASH:
            case $d8d9cb1a28007639$var$KeyCode.APOSTROPHE:
            case $d8d9cb1a28007639$var$KeyCode.SINGLE_QUOTE:
            case $d8d9cb1a28007639$var$KeyCode.OPEN_SQUARE_BRACKET:
            case $d8d9cb1a28007639$var$KeyCode.BACKSLASH:
            case $d8d9cb1a28007639$var$KeyCode.CLOSE_SQUARE_BRACKET:
                return true;
            default:
                return false;
        }
    }
};
var $d8d9cb1a28007639$export$2e2bcd8739ae039 = $d8d9cb1a28007639$var$KeyCode;




var $acw62 = parcelRequire("acw62");
var $fd5c50d68a830e84$var$ESC = (0, $d8d9cb1a28007639$export$2e2bcd8739ae039).ESC, $fd5c50d68a830e84$var$TAB = (0, $d8d9cb1a28007639$export$2e2bcd8739ae039).TAB;
function $fd5c50d68a830e84$export$2e2bcd8739ae039(_ref) {
    var visible = _ref.visible, triggerRef = _ref.triggerRef, onVisibleChange = _ref.onVisibleChange, autoFocus = _ref.autoFocus, overlayRef = _ref.overlayRef;
    var focusMenuRef = $acw62.useRef(false);
    var handleCloseMenuAndReturnFocus = function handleCloseMenuAndReturnFocus() {
        if (visible) {
            var _triggerRef$current, _triggerRef$current$f;
            (_triggerRef$current = triggerRef.current) === null || _triggerRef$current === void 0 || (_triggerRef$current$f = _triggerRef$current.focus) === null || _triggerRef$current$f === void 0 || _triggerRef$current$f.call(_triggerRef$current);
            onVisibleChange === null || onVisibleChange === void 0 || onVisibleChange(false);
        }
    };
    var focusMenu = function focusMenu() {
        var _overlayRef$current;
        if ((_overlayRef$current = overlayRef.current) !== null && _overlayRef$current !== void 0 && _overlayRef$current.focus) {
            overlayRef.current.focus();
            focusMenuRef.current = true;
            return true;
        }
        return false;
    };
    var handleKeyDown = function handleKeyDown(event) {
        switch(event.keyCode){
            case $fd5c50d68a830e84$var$ESC:
                handleCloseMenuAndReturnFocus();
                break;
            case $fd5c50d68a830e84$var$TAB:
                var focusResult = false;
                if (!focusMenuRef.current) focusResult = focusMenu();
                if (focusResult) event.preventDefault();
                else handleCloseMenuAndReturnFocus();
                break;
        }
    };
    $acw62.useEffect(function() {
        if (visible) {
            window.addEventListener("keydown", handleKeyDown);
            if (autoFocus) // FIXME: hack with raf
            (0, $a1ced7b983ea61a4$export$2e2bcd8739ae039)(focusMenu, 3);
            return function() {
                window.removeEventListener("keydown", handleKeyDown);
                focusMenuRef.current = false;
            };
        }
        return function() {
            focusMenuRef.current = false;
        };
    }, [
        visible
    ]); // eslint-disable-line react-hooks/exhaustive-deps
}



var $acw62 = parcelRequire("acw62");

var $e68e305c80c7967c$var$Overlay = /*#__PURE__*/ (0, $acw62.forwardRef)(function(props, ref) {
    var overlay = props.overlay, arrow = props.arrow, prefixCls = props.prefixCls;
    var overlayNode = (0, $acw62.useMemo)(function() {
        var overlayElement;
        if (typeof overlay === "function") overlayElement = overlay();
        else overlayElement = overlay;
        return overlayElement;
    }, [
        overlay
    ]);
    var composedRef = (0, $5e297877593af644$export$ab452c34e8e05029)(ref, overlayNode === null || overlayNode === void 0 ? void 0 : overlayNode.ref);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, arrow && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: "".concat(prefixCls, "-arrow")
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).cloneElement(overlayNode, {
        ref: (0, $5e297877593af644$export$c1cec34af06bcf7)(overlayNode) ? composedRef : undefined
    }));
});
var $e68e305c80c7967c$export$2e2bcd8739ae039 = $e68e305c80c7967c$var$Overlay;


var $9a69693d1b18e39e$var$autoAdjustOverflow = {
    adjustX: 1,
    adjustY: 1
};
var $9a69693d1b18e39e$var$targetOffset = [
    0,
    0
];
var $9a69693d1b18e39e$var$placements = {
    topLeft: {
        points: [
            "bl",
            "tl"
        ],
        overflow: $9a69693d1b18e39e$var$autoAdjustOverflow,
        offset: [
            0,
            -4
        ],
        targetOffset: $9a69693d1b18e39e$var$targetOffset
    },
    top: {
        points: [
            "bc",
            "tc"
        ],
        overflow: $9a69693d1b18e39e$var$autoAdjustOverflow,
        offset: [
            0,
            -4
        ],
        targetOffset: $9a69693d1b18e39e$var$targetOffset
    },
    topRight: {
        points: [
            "br",
            "tr"
        ],
        overflow: $9a69693d1b18e39e$var$autoAdjustOverflow,
        offset: [
            0,
            -4
        ],
        targetOffset: $9a69693d1b18e39e$var$targetOffset
    },
    bottomLeft: {
        points: [
            "tl",
            "bl"
        ],
        overflow: $9a69693d1b18e39e$var$autoAdjustOverflow,
        offset: [
            0,
            4
        ],
        targetOffset: $9a69693d1b18e39e$var$targetOffset
    },
    bottom: {
        points: [
            "tc",
            "bc"
        ],
        overflow: $9a69693d1b18e39e$var$autoAdjustOverflow,
        offset: [
            0,
            4
        ],
        targetOffset: $9a69693d1b18e39e$var$targetOffset
    },
    bottomRight: {
        points: [
            "tr",
            "br"
        ],
        overflow: $9a69693d1b18e39e$var$autoAdjustOverflow,
        offset: [
            0,
            4
        ],
        targetOffset: $9a69693d1b18e39e$var$targetOffset
    }
};
var $9a69693d1b18e39e$export$2e2bcd8739ae039 = $9a69693d1b18e39e$var$placements;


var $efa0709bbe269de7$var$_excluded = [
    "arrow",
    "prefixCls",
    "transitionName",
    "animation",
    "align",
    "placement",
    "placements",
    "getPopupContainer",
    "showAction",
    "hideAction",
    "overlayClassName",
    "overlayStyle",
    "visible",
    "trigger",
    "autoFocus",
    "overlay",
    "children",
    "onVisibleChange"
];
function $efa0709bbe269de7$var$Dropdown(props, ref) {
    var _children$props;
    var _props$arrow = props.arrow, arrow = _props$arrow === void 0 ? false : _props$arrow, _props$prefixCls = props.prefixCls, prefixCls = _props$prefixCls === void 0 ? "rc-dropdown" : _props$prefixCls, transitionName = props.transitionName, animation = props.animation, align = props.align, _props$placement = props.placement, placement = _props$placement === void 0 ? "bottomLeft" : _props$placement, _props$placements = props.placements, placements = _props$placements === void 0 ? (0, $9a69693d1b18e39e$export$2e2bcd8739ae039) : _props$placements, getPopupContainer = props.getPopupContainer, showAction = props.showAction, hideAction = props.hideAction, overlayClassName = props.overlayClassName, overlayStyle = props.overlayStyle, visible = props.visible, _props$trigger = props.trigger, trigger = _props$trigger === void 0 ? [
        "hover"
    ] : _props$trigger, autoFocus = props.autoFocus, overlay = props.overlay, children = props.children, onVisibleChange = props.onVisibleChange, otherProps = (0, $73ef9ce1c41fc0c0$export$2e2bcd8739ae039)(props, $efa0709bbe269de7$var$_excluded);
    var _React$useState = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(), _React$useState2 = (0, $adaabbc18727b3e6$export$2e2bcd8739ae039)(_React$useState, 2), triggerVisible = _React$useState2[0], setTriggerVisible = _React$useState2[1];
    var mergedVisible = "visible" in props ? visible : triggerVisible;
    var triggerRef = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(null);
    var overlayRef = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(null);
    var childRef = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(null);
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useImperativeHandle(ref, function() {
        return triggerRef.current;
    });
    var handleVisibleChange = function handleVisibleChange(newVisible) {
        setTriggerVisible(newVisible);
        onVisibleChange === null || onVisibleChange === void 0 || onVisibleChange(newVisible);
    };
    (0, $fd5c50d68a830e84$export$2e2bcd8739ae039)({
        visible: mergedVisible,
        triggerRef: childRef,
        onVisibleChange: handleVisibleChange,
        autoFocus: autoFocus,
        overlayRef: overlayRef
    });
    var onClick = function onClick(e) {
        var onOverlayClick = props.onOverlayClick;
        setTriggerVisible(false);
        if (onOverlayClick) onOverlayClick(e);
    };
    var getMenuElement = function getMenuElement() {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $e68e305c80c7967c$export$2e2bcd8739ae039), {
            ref: overlayRef,
            overlay: overlay,
            prefixCls: prefixCls,
            arrow: arrow
        });
    };
    var getMenuElementOrLambda = function getMenuElementOrLambda() {
        if (typeof overlay === "function") return getMenuElement;
        return getMenuElement();
    };
    var getMinOverlayWidthMatchTrigger = function getMinOverlayWidthMatchTrigger() {
        var minOverlayWidthMatchTrigger = props.minOverlayWidthMatchTrigger, alignPoint = props.alignPoint;
        if ("minOverlayWidthMatchTrigger" in props) return minOverlayWidthMatchTrigger;
        return !alignPoint;
    };
    var getOpenClassName = function getOpenClassName() {
        var openClassName = props.openClassName;
        if (openClassName !== undefined) return openClassName;
        return "".concat(prefixCls, "-open");
    };
    var childrenNode = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).cloneElement(children, {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))((_children$props = children.props) === null || _children$props === void 0 ? void 0 : _children$props.className, mergedVisible && getOpenClassName()),
        ref: (0, $5e297877593af644$export$c1cec34af06bcf7)(children) ? (0, $5e297877593af644$export$ab452c34e8e05029)(childRef, children.ref) : undefined
    });
    var triggerHideAction = hideAction;
    if (!triggerHideAction && trigger.indexOf("contextMenu") !== -1) triggerHideAction = [
        "click"
    ];
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $a99c76d30a1f506f$export$2e2bcd8739ae039), (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({
        builtinPlacements: placements
    }, otherProps, {
        prefixCls: prefixCls,
        ref: triggerRef,
        popupClassName: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))(overlayClassName, (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)({}, "".concat(prefixCls, "-show-arrow"), arrow)),
        popupStyle: overlayStyle,
        action: trigger,
        showAction: showAction,
        hideAction: triggerHideAction,
        popupPlacement: placement,
        popupAlign: align,
        popupTransitionName: transitionName,
        popupAnimation: animation,
        popupVisible: mergedVisible,
        stretch: getMinOverlayWidthMatchTrigger() ? "minWidth" : "",
        popup: getMenuElementOrLambda(),
        onPopupVisibleChange: handleVisibleChange,
        onPopupClick: onClick,
        getPopupContainer: getPopupContainer
    }), childrenNode);
}
var $efa0709bbe269de7$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).forwardRef($efa0709bbe269de7$var$Dropdown);


var $e2ef3d42b101c489$export$2e2bcd8739ae039 = (0, $efa0709bbe269de7$export$2e2bcd8739ae039);



var $acw62 = parcelRequire("acw62");






const $5ce1d5308946b7cc$var$shouldUseDesktopInput = window.innerWidth >= 1200;
const $5ce1d5308946b7cc$var$HALF_DAY_HOURS = "12";
const $5ce1d5308946b7cc$var$HALF_HOUR_MINUTES = "30";
const $5ce1d5308946b7cc$var$MINUTES_IN_HOUR = 60;
const $5ce1d5308946b7cc$var$MIN_HOUR_DIFF_BETWEEN_START_END_TIME = 3;
const $5ce1d5308946b7cc$var$DEFAULT_PICKER_START_TIME = "00:00";
function $5ce1d5308946b7cc$export$a1af6f79df847fac({ value: value, label: label, disabled: disabled = false, className: className, onFocus: onFocus, onBlur: onBlur, handleChange: handleChange, useDropdownWithInput: useDropdownWithInput, pickerStartTime: pickerStartTime = null, pickerTimeGap: pickerTimeGap = 15, showDurationFromPickerStartTime: showDurationFromPickerStartTime = false }) {
    const timeSlots = (0, $acw62.useMemo)(()=>(0, $ddf12117b815a7c3$export$802fdf70ef4e2893)(pickerStartTime ?? $5ce1d5308946b7cc$var$DEFAULT_PICKER_START_TIME, pickerTimeGap), [
        pickerStartTime,
        pickerTimeGap
    ]);
    const defaultHours = $5ce1d5308946b7cc$var$shouldUseDesktopInput && !useDropdownWithInput ? "--" : $5ce1d5308946b7cc$var$HALF_DAY_HOURS;
    const defaultMinutes = $5ce1d5308946b7cc$var$shouldUseDesktopInput && !useDropdownWithInput ? "--" : $5ce1d5308946b7cc$var$HALF_HOUR_MINUTES;
    const [isVisible, setVisible] = (0, $acw62.useState)(false);
    const [timeInputElement, setTimeInputElement] = (0, $acw62.useState)(null);
    const pickerContainerId = (0, $acw62.useRef)(`a${(0, $3fa3ae484854b431$export$2e2bcd8739ae039)()}`).current;
    const inputId = (0, $acw62.useRef)(`a${(0, $3fa3ae484854b431$export$2e2bcd8739ae039)()}`).current;
    const pickerContainerRef = (0, $acw62.useRef)(null);
    const pickerValue = pickerStartTime !== null ? timeSlots[0 + $5ce1d5308946b7cc$var$MIN_HOUR_DIFF_BETWEEN_START_END_TIME * $5ce1d5308946b7cc$var$MINUTES_IN_HOUR / pickerTimeGap] : null;
    const currentValue = value || pickerValue || `${defaultHours}:${defaultMinutes}`;
    (0, $acw62.useEffect)(()=>{
        function handleClickOutside(event) {
            const target = event.target;
            const parentIsModal = target.closest(`#${pickerContainerId}`);
            const parentIsInput = target.closest(`#${inputId}`);
            if (!parentIsModal && !parentIsInput) setVisible(false);
        }
        document.addEventListener("mousedown", handleClickOutside);
        return ()=>{
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, []);
    (0, $acw62.useEffect)(()=>{
        if (isVisible) {
            const scrollTimeout = setTimeout(scrollToPickerSlot, 10);
            return ()=>clearTimeout(scrollTimeout);
        }
    }, [
        isVisible
    ]);
    const scrollToPickerSlot = ()=>{
        if (pickerContainerRef.current && currentValue) {
            const children = Array.from(pickerContainerRef.current.children);
            const targetItem = children.find((el)=>el.getAttribute("data-value") === currentValue) ?? children.find((el)=>el.getAttribute("data-value")?.startsWith(currentValue.slice(0, 2)));
            if (targetItem) targetItem.scrollIntoView({
                block: "start"
            });
        }
    };
    const getPickerSlotContent = (slotTime)=>{
        if (!showDurationFromPickerStartTime) return slotTime;
        const startTime = (0, (/*@__PURE__*/$parcel$interopDefault($45fvw)))(pickerStartTime ?? $5ce1d5308946b7cc$var$DEFAULT_PICKER_START_TIME, "HH:mm");
        const endTime = (0, (/*@__PURE__*/$parcel$interopDefault($45fvw)))(slotTime, "HH:mm");
        if (endTime.isSame(startTime)) return slotTime;
        const diff = endTime.isAfter(startTime) ? endTime.diff(startTime) : endTime.clone().add(1, "day").diff(startTime);
        const duration = (0, (/*@__PURE__*/$parcel$interopDefault($45fvw))).duration(diff);
        const hoursString = duration.hours() > 0 ? `${duration.hours()}h` : "";
        const minutesString = duration.minutes() > 0 ? `${duration.minutes()}m` : "";
        if (!hoursString && minutesString) return `${slotTime} (${minutesString})`;
        if (hoursString && !minutesString) return `${slotTime} (${hoursString})`;
        return `${slotTime} (${hoursString} ${minutesString})`;
    };
    const timeFieldComponent = /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($9aaf1a8973220fa0$exports))), {
        // @ts-ignore incorrect prop typing
        value: currentValue,
        // @ts-ignore incorrect function signature
        inputRef: (inputEl)=>{
            setTimeInputElement(inputEl);
        },
        onChange: (_, updatedValue)=>{
            handleChange(updatedValue);
            if (isVisible) scrollToPickerSlot();
        },
        // @ts-ignore the library lacks ts-types for default input props
        disabled: disabled,
        onClick: (ev)=>{
            // when input is clicked, we want cursor to be focused on the symbol it was clicked on
            // that's why we don't want parent's onClick() to be fired
            ev.stopPropagation();
        },
        onFocus: ()=>{
            setVisible(true);
            onFocus?.();
        },
        onBlur: ()=>{
            onBlur?.();
        },
        className: `TimeInput__timeInput TimeInput__value ${!value && !isVisible ? "TimeInput__timeInput_hidden" : ""}`
    });
    if ($5ce1d5308946b7cc$var$shouldUseDesktopInput && !useDropdownWithInput) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        className: className,
        onClick: ()=>{
            setVisible(true);
            // once clicked on the wrapper, focus on the input
            // and place cursor on the first symbol
            timeInputElement?.focus();
            if (timeInputElement) {
                timeInputElement.selectionStart = 0;
                timeInputElement.selectionEnd = 0;
            }
        },
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($5ce1d5308946b7cc$var$TimeContainer, {
            inputId: inputId,
            label: label,
            children: timeFieldComponent
        })
    });
    const innerComponent = /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        className: "TimeInput__list",
        id: pickerContainerId,
        ref: pickerContainerRef,
        children: timeSlots.map((timeSlot)=>{
            return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                onClick: ()=>{
                    handleChange(timeSlot);
                    setVisible(false);
                },
                "data-value": timeSlot,
                className: `TimeInput__list__item${currentValue === timeSlot ? " TimeInput__list__item--selected" : ""}`,
                children: getPickerSlotContent(timeSlot)
            }, timeSlot);
        })
    });
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e2ef3d42b101c489$export$2e2bcd8739ae039), {
        trigger: disabled ? [] : [
            "click"
        ],
        overlay: innerComponent,
        visible: isVisible,
        onVisibleChange: (newIsVisible)=>{
            if (newIsVisible) {
                setVisible(true);
                onFocus?.();
            } else onBlur?.();
        },
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
            className: className,
            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($5ce1d5308946b7cc$var$TimeContainer, {
                inputId: inputId,
                label: label,
                className: className,
                children: useDropdownWithInput ? timeFieldComponent : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                    className: "TimeInput__value",
                    children: value
                })
            })
        })
    });
}
function $5ce1d5308946b7cc$var$TimeContainer(props) {
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        className: `TimeInput ${props.className}`,
        id: props.inputId,
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
            className: "TimeInput__container",
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                            className: "TimeInput__label",
                            children: props.label
                        }),
                        props.children
                    ]
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                    src: (0, (/*@__PURE__*/$parcel$interopDefault($c0139fd98e0c57a9$exports))),
                    className: "TimeInput__toggleIcon"
                })
            ]
        })
    });
}
function $5ce1d5308946b7cc$export$9172899a6aeab37f(props) {
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4c4587947033fde9$export$a455218a85c89869), {
        required: props.required,
        errors: props.errors,
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($5ce1d5308946b7cc$export$a1af6f79df847fac, {
            ...props
        })
    });
}




function $a02f6c3f181f6659$var$TimeRowComponent({ job: job, isActive: isActive, isWeeklyType: isWeeklyType, day: day, startTime: startTime, startTimeError: startTimeError, endTime: endTime, endTimeError: endTimeError, lastStartTimeInput: lastStartTimeInput, lastEndTimeInput: lastEndTimeInput, updateLastStartTimeInput: updateLastStartTimeInput, updateLastEndTimeInput: updateLastEndTimeInput }) {
    const { t: t } = (0, $3765cebd031b52c0$export$9fc83ad70ead8663)();
    (0, $acw62.useEffect)(()=>{
        if (startTime && startTime.length > 0) updateLastStartTimeInput(startTime);
        if (startTime && isActive === false && endTime) job.schedule.distinctTimeSchedule.selectDate({
            date: day
        });
        if (endTime && endTime.length > 0) updateLastEndTimeInput(endTime);
        if (endTime && isActive === false && startTime) job.schedule.distinctTimeSchedule.selectDate({
            date: day
        });
    }, [
        startTime,
        endTime,
        isActive
    ]);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "JobDraftTime__dates__row",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                onClick: ()=>{
                    if (isActive) {
                        job.schedule.distinctTimeSchedule.clearDate(day);
                        return;
                    }
                    if (job.schedule.sameTimeSchedule.allDaysHaveSameTime) {
                        job.schedule.distinctTimeSchedule.setDateStartTime({
                            date: day,
                            start_time: job.schedule.sameTimeSchedule.same_start_time
                        });
                        job.schedule.distinctTimeSchedule.setDateEndTime({
                            date: day,
                            end_time: job.schedule.sameTimeSchedule.same_end_time
                        });
                    }
                    const shouldPasteDefaultStartValue = !startTime && lastStartTimeInput;
                    const shouldPasteDefaultEndValue = !endTime && lastEndTimeInput;
                    if (shouldPasteDefaultStartValue) job.schedule.distinctTimeSchedule.setDateStartTime({
                        date: day,
                        start_time: lastStartTimeInput
                    });
                    if (shouldPasteDefaultEndValue) job.schedule.distinctTimeSchedule.setDateEndTime({
                        date: day,
                        end_time: lastEndTimeInput
                    });
                    job.schedule.distinctTimeSchedule.selectDate({
                        date: day
                    });
                },
                className: `JobDraftTime__dates__row__day ${isActive ? "active" : ""}`,
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                    className: `JobDraftTime__dates__row__day__label ${isActive ? "active" : ""}`,
                    children: isWeeklyType ? t(`time.${day.toLowerCase()}`) : (0, (/*@__PURE__*/$parcel$interopDefault($45fvw)))(day, "YYYY-MM-DD").format("MMM DD")
                })
            }),
            !job.schedule.sameTimeSchedule.allDaysHaveSameTime && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "JobDraftTime__inputWrapper",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5ce1d5308946b7cc$export$a1af6f79df847fac), {
                                label: t("job_draft_details.start_time"),
                                value: startTime ?? "",
                                handleChange: (newStartTime)=>{
                                    job.schedule.distinctTimeSchedule.setDateStartTime({
                                        date: day,
                                        start_time: newStartTime
                                    });
                                    if (endTime) job.schedule.distinctTimeSchedule.selectDate({
                                        date: day
                                    });
                                },
                                className: "JobDraftTime__dates__row__input",
                                onFocus: ()=>{
                                    const shouldPasteDefaultStartValue = !startTime && lastStartTimeInput;
                                    if (shouldPasteDefaultStartValue) job.schedule.distinctTimeSchedule.setDateStartTime({
                                        date: day,
                                        start_time: lastStartTimeInput
                                    });
                                },
                                useDropdownWithInput: true,
                                required: true
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $17a27c6ba7085f84$export$57b95d3630b174f6), {
                                error: startTimeError
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "JobDraftTime__inputWrapper",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5ce1d5308946b7cc$export$a1af6f79df847fac), {
                                label: t("job_draft_details.end_time"),
                                value: endTime ?? "",
                                handleChange: (newEndTime)=>{
                                    job.schedule.distinctTimeSchedule.setDateEndTime({
                                        date: day,
                                        end_time: newEndTime
                                    });
                                    if (startTime) job.schedule.distinctTimeSchedule.selectDate({
                                        date: day
                                    });
                                },
                                className: "JobDraftTime__dates__row__input",
                                onFocus: ()=>{
                                    const shouldPasteDefaultEndValue = !endTime && lastEndTimeInput;
                                    if (shouldPasteDefaultEndValue) job.schedule.distinctTimeSchedule.setDateEndTime({
                                        date: day,
                                        end_time: lastEndTimeInput
                                    });
                                },
                                pickerStartTime: startTime ?? "00:00",
                                useDropdownWithInput: true,
                                showDurationFromPickerStartTime: true,
                                required: true
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $17a27c6ba7085f84$export$57b95d3630b174f6), {
                                error: endTimeError
                            })
                        ]
                    })
                ]
            })
        ]
    });
}
const $a02f6c3f181f6659$export$6310a9dc2162e26f = (0, $aca50e9407ba89c9$export$b6ae1bc530f4c149)($a02f6c3f181f6659$var$TimeRowComponent);





const $82e0ba380521c909$export$8808b6ffa95336f5 = (0, $aca50e9407ba89c9$export$b6ae1bc530f4c149)(({ job: job })=>{
    const [lastStartTimeInput, setLastStartTimeInput] = (0, $acw62.useState)(job.schedule.scheduleType.value ? job.schedule.distinctTimeSchedule.jobDatesValues.find((date)=>date.start_time)?.start_time ?? "" : "");
    const [lastEndTimeInput, setLastEndTimeInput] = (0, $acw62.useState)(job.schedule.scheduleType.value ? job.schedule.distinctTimeSchedule.jobDatesValues.find((date)=>date.end_time)?.end_time ?? "" : "");
    const { t: t } = (0, $3765cebd031b52c0$export$9fc83ad70ead8663)();
    const isWeeklyType = job.schedule.scheduleType.value === (0, $a4e7aca7274b573e$export$38e26ec75b48a88c).weekly;
    const noDatesSet = !job.schedule.dateBoundaries.start_date || !job.schedule.dateBoundaries.end_date && !job.schedule.dateBoundaries.open_ended;
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "JobDraftTime",
        children: [
            job.schedule.distinctTimeSchedule.isLessThan24Hours && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7a26230deaaf6920$export$944fe0ec49485b21), {
                theme: (0, $7a26230deaaf6920$export$14faa19a0f3bbeb2).Orange,
                title: t("job_draft_details.less_than_24h_warning"),
                action: ()=>{},
                isActionInProgress: false,
                withCloseButton: false,
                style: {
                    marginTop: "15px"
                }
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                className: "Popup__title",
                children: t("job_draft_details.time_title")
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                className: "Popup__subtitle",
                children: t("job_draft_details.time_subtitle")
            }),
            job.schedule.scheduleType.value === null || noDatesSet ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                className: "JobDraftTime__selectScheduleLabel",
                children: t("job_draft_details.time_select_dates_schedule")
            }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                        className: "JobDraftTime__obligatoryDates",
                        children: t("job_draft_details.start_and_end_date_must_be_selected", {
                            startDate: job.schedule.dateBoundaries.start_date ? (0, (/*@__PURE__*/$parcel$interopDefault($45fvw)))(job.schedule.dateBoundaries.start_date).format("MMM DD (dddd)") : "",
                            endDate: job.schedule.dateBoundaries.end_date ? (0, (/*@__PURE__*/$parcel$interopDefault($45fvw)))(job.schedule.dateBoundaries.end_date).format("MMM DD (dddd)") : ""
                        })
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $660b2ca422e0e2ae$export$1ff3c3f08ae963c0).Vertical, {
                        height: 16
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: `JobDraftTime__dates${job.schedule.sameTimeSchedule.allDaysHaveSameTime ? " JobDraftTime__dates--horizontally" : ""}`,
                        children: job.schedule.distinctTimeSchedule.jobDates.map(([day, time])=>{
                            return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $a02f6c3f181f6659$export$6310a9dc2162e26f), {
                                day: day,
                                startTime: time.start_time,
                                startTimeError: time.start_time_error,
                                endTime: time.end_time,
                                endTimeError: time.end_time_error,
                                isActive: time.selected,
                                isWeeklyType: isWeeklyType,
                                job: job,
                                lastStartTimeInput: lastStartTimeInput,
                                lastEndTimeInput: lastEndTimeInput,
                                updateLastStartTimeInput: setLastStartTimeInput,
                                updateLastEndTimeInput: setLastEndTimeInput
                            }, day);
                        })
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $17a27c6ba7085f84$export$57b95d3630b174f6), {
                        error: job.schedule.distinctTimeSchedule.error
                    })
                ]
            })
        ]
    });
});







const $9016c58210bf8902$export$393edc798c47379d = (0, $aca50e9407ba89c9$export$b6ae1bc530f4c149)(({ job: job })=>{
    const { t: t } = (0, $3765cebd031b52c0$export$9fc83ad70ead8663)();
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "JobDraftDescription",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                className: "Popup__title",
                children: t("job_draft_details.description_title")
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                className: "Popup__subtitle",
                children: t("job_draft_details.description_subtitle")
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("textarea", {
                value: job.description.value ?? "",
                onChange: (ev)=>job.description.set(ev.target.value),
                placeholder: t("job_draft_details.description_placeholder"),
                className: `JobDraftDescription__textarea ${job.description.hasError ? "error" : ""}`
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $17a27c6ba7085f84$export$57b95d3630b174f6), {
                error: job.description.error
            })
        ]
    });
});











const $66b2935bcece51ff$var$getYearsString = (seniorityLevel)=>{
    if (seniorityLevel.minYears === seniorityLevel.maxYears) return `${seniorityLevel.minYears}`;
    if (seniorityLevel.minYears && seniorityLevel.maxYears) return `${seniorityLevel.minYears}-${seniorityLevel.maxYears}`;
    if (!seniorityLevel.maxYears) return `${seniorityLevel.minYears}+`;
    return `0-${seniorityLevel.maxYears}`;
};
const $66b2935bcece51ff$export$6bc938989d1dfa99 = ({ onClick: onClick, isActive: isActive, title: title, seniorityLevel: seniorityLevel, isError: isError })=>{
    const { t: t } = (0, $3765cebd031b52c0$export$9fc83ad70ead8663)();
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $2ab88429e3384d30$export$353f5b6fc5456de1), {
        onClick: onClick,
        className: `JobDraftExperience__innerContainer__button ${isActive ? "active" : ""} ${isError ? "error" : ""}`,
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
            className: "JobDraftExperience__innerContainer__button__content",
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                    className: `JobDraftExperience__innerContainer__button__label ${isError ? "error" : ""}`,
                    children: title
                }),
                seniorityLevel && (seniorityLevel.minYears ?? seniorityLevel.maxYears) && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                    className: "JobDraftExperience__innerContainer__button__content__description",
                    children: [
                        $66b2935bcece51ff$var$getYearsString(seniorityLevel),
                        " ",
                        t("job_draft_details.experience_years")
                    ]
                })
            ]
        })
    });
};






const $72b0f3bbb42b9e27$export$c1928f0d366d76b4 = (0, $aca50e9407ba89c9$export$b6ae1bc530f4c149)(({ job: job })=>{
    const workCategory = job.category.id;
    const { getSeniorityLevels: getSeniorityLevels, getSeniorityLevelById: getSeniorityLevelById } = (0, $4671947198ddd366$export$6ccbb43953eebf8)().data;
    const { isLoading: seniorityLevelsLoading } = (0, $4671947198ddd366$export$dd0a697e1782aedd)(()=>getSeniorityLevels(workCategory));
    const seniorityLevelJunior = getSeniorityLevelById(workCategory, Number((0, $f62ebabca0bf67f2$export$c90b54e658fc4d7c).junior));
    const seniorityLevelMiddle = getSeniorityLevelById(workCategory, Number((0, $f62ebabca0bf67f2$export$c90b54e658fc4d7c).middle));
    const seniorityLevelSenior = getSeniorityLevelById(workCategory, Number((0, $f62ebabca0bf67f2$export$c90b54e658fc4d7c).senior));
    const seniorityLevelStudent = getSeniorityLevelById(workCategory, Number((0, $f62ebabca0bf67f2$export$c90b54e658fc4d7c).beginnerOrStudent));
    const { t: t } = (0, $3765cebd031b52c0$export$9fc83ad70ead8663)();
    const experience = job.experience.value;
    if (seniorityLevelsLoading) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $57fb8f45c69e1681$export$2e2bcd8739ae039), {});
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "JobDraftExperience",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                className: "Popup__title",
                children: t("job_draft_details.experience_title")
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                className: "Popup__subtitle",
                children: t("job_draft_details.experience_subtitle")
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "JobDraftExperience__innerContainer",
                children: [
                    seniorityLevelStudent && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $66b2935bcece51ff$export$6bc938989d1dfa99), {
                                onClick: ()=>{
                                    job.experience.set((0, $f62ebabca0bf67f2$export$c90b54e658fc4d7c).beginnerOrStudent);
                                },
                                isActive: experience === (0, $f62ebabca0bf67f2$export$c90b54e658fc4d7c).beginnerOrStudent,
                                title: t((0, $73ccb33f5de6f5aa$export$8707029d024490c9)().order.nonExperiencedTitle),
                                seniorityLevel: seniorityLevelStudent,
                                isError: job.experience.hasError
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $660b2ca422e0e2ae$export$1ff3c3f08ae963c0).Vertical, {
                                height: 10
                            })
                        ]
                    }),
                    seniorityLevelJunior && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $66b2935bcece51ff$export$6bc938989d1dfa99), {
                                onClick: ()=>{
                                    job.experience.set((0, $f62ebabca0bf67f2$export$c90b54e658fc4d7c).junior);
                                },
                                isActive: experience === (0, $f62ebabca0bf67f2$export$c90b54e658fc4d7c).junior,
                                title: t("job_draft_details.experience_junior"),
                                seniorityLevel: seniorityLevelJunior,
                                isError: job.experience.hasError
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $660b2ca422e0e2ae$export$1ff3c3f08ae963c0).Vertical, {
                                height: 10
                            })
                        ]
                    }),
                    seniorityLevelMiddle && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $66b2935bcece51ff$export$6bc938989d1dfa99), {
                                onClick: ()=>{
                                    job.experience.set((0, $f62ebabca0bf67f2$export$c90b54e658fc4d7c).middle);
                                },
                                isActive: experience === (0, $f62ebabca0bf67f2$export$c90b54e658fc4d7c).middle,
                                title: t("job_draft_details.experience_middle"),
                                seniorityLevel: seniorityLevelMiddle,
                                isError: job.experience.hasError
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $660b2ca422e0e2ae$export$1ff3c3f08ae963c0).Vertical, {
                                height: 10
                            })
                        ]
                    }),
                    seniorityLevelSenior && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $66b2935bcece51ff$export$6bc938989d1dfa99), {
                                onClick: ()=>{
                                    job.experience.set((0, $f62ebabca0bf67f2$export$c90b54e658fc4d7c).senior);
                                },
                                isActive: experience === (0, $f62ebabca0bf67f2$export$c90b54e658fc4d7c).senior,
                                title: t("job_draft_details.experience_senior"),
                                seniorityLevel: seniorityLevelSenior,
                                isError: job.experience.hasError
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $660b2ca422e0e2ae$export$1ff3c3f08ae963c0).Vertical, {
                                height: 15
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                        className: "JobDraftExperience__innerContainer__hint",
                        children: t("job_draft_details.experience_hint")
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $17a27c6ba7085f84$export$57b95d3630b174f6), {
                        error: job.experience.error
                    })
                ]
            })
        ]
    });
});




var $acw62 = parcelRequire("acw62");








const $0764795ac2d83f66$export$edbf66947951d8cd = (0, $aca50e9407ba89c9$export$b6ae1bc530f4c149)(({ job: job })=>{
    const { uniformList: uniformList, getUniforms: getUniforms, getUniformById: getUniformById, getUniformIdByTitle: getUniformIdByTitle } = (0, $4671947198ddd366$export$6ccbb43953eebf8)().data;
    const { isLoading: uniformsLoading } = (0, $4671947198ddd366$export$dd0a697e1782aedd)(getUniforms);
    (0, $acw62.useEffect)(()=>{
        if (!job.dresscode.id && uniformList.length > 0) job.dresscode.set(uniformList[0].id);
    }, [
        uniformList,
        uniformList.length
    ]);
    const { t: t } = (0, $3765cebd031b52c0$export$9fc83ad70ead8663)();
    const uniformOptions = uniformList.length > 0 ? uniformList.map((uniform)=>({
            key: uniform.name,
            label: uniform.name,
            value: uniform.name
        })) : null;
    const uniform = job.dresscode.id ? getUniformById(job.dresscode.id) : null;
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "JobDraftUniform",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                className: "Popup__title",
                children: t("job_draft_details.uniform_title")
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                className: "Popup__subtitle",
                children: t("job_draft_details.uniform_subtitle")
            }),
            uniformsLoading ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $57fb8f45c69e1681$export$b08b517936747730), {}) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f2c1b8699595d8c0$export$ef9b1a59e592288f), {
                        label: t("job_draft_details.uniform_dresscode"),
                        value: uniform?.name ?? "",
                        onChange: (name)=>{
                            const id = getUniformIdByTitle(name);
                            job.dresscode.set(id);
                        },
                        options: uniformOptions ?? [],
                        className: `JobDraftUniform__uniformSelect ${job.dresscode.hasError ? "error" : ""}`
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $660b2ca422e0e2ae$export$1ff3c3f08ae963c0).Vertical, {
                        height: 12
                    }),
                    uniform?.description && uniform.description.length > 0 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                        className: "JobDraftUniform__uniformDescription",
                        dangerouslySetInnerHTML: {
                            __html: uniform.description
                        }
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $17a27c6ba7085f84$export$57b95d3630b174f6), {
                        error: job.dresscode.error
                    })
                ]
            })
        ]
    });
});










const $67b8edc2d024d58e$export$208128cc8fac67 = (0, $aca50e9407ba89c9$export$b6ae1bc530f4c149)(({ job: job })=>{
    const { t: t } = (0, $3765cebd031b52c0$export$9fc83ad70ead8663)();
    const showNationalityOption = (0, $73ccb33f5de6f5aa$export$8707029d024490c9)().order.includeNationalityField;
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "JobDraftPreferences",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                className: "Popup__title",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f13ff0bdae325c20$export$b04be29aa201d4f5), {
                        title: t("common.optional")
                    }),
                    " ",
                    t("job_draft_details.preferences_title")
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                className: "Popup__subtitle",
                children: t("job_draft_details.preferences_subtitle")
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "JobDraftPreferences__toggles",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "JobDraftPreferences__toggles__item",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                className: "JobDraftPreferences__toggles__item__label",
                                children: t("job_draft_details.preferences_languages")
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $d931e957e209e988$export$bea8ebba691c5813), {
                                active: job.languages.use_languages,
                                onToggle: ()=>{
                                    job.languages.useLanguages(!job.languages.use_languages);
                                }
                            })
                        ]
                    }),
                    (0, $73ccb33f5de6f5aa$export$8707029d024490c9)().order.includeGenderField && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "JobDraftPreferences__toggles__item",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                className: "JobDraftPreferences__toggles__item__label",
                                children: t("job_draft_details.preferences_gender")
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $d931e957e209e988$export$bea8ebba691c5813), {
                                active: job.gender.use_gender,
                                onToggle: ()=>{
                                    job.gender.useGender(!job.gender.use_gender);
                                }
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "JobDraftPreferences__toggles__item",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                className: "JobDraftPreferences__toggles__item__label",
                                children: t("job_draft_details.preferences_documents")
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $d931e957e209e988$export$bea8ebba691c5813), {
                                active: job.documents.use_documents,
                                onToggle: ()=>{
                                    job.documents.useDocuments(!job.documents.use_documents);
                                }
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "JobDraftPreferences__toggles__item",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                className: "JobDraftPreferences__toggles__item__label",
                                children: t("job_draft_details.preferences_interview")
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $d931e957e209e988$export$bea8ebba691c5813), {
                                active: job.manualSelection.use_interview,
                                onToggle: ()=>{
                                    job.manualSelection.useInterview(!job.manualSelection.use_interview);
                                }
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "JobDraftPreferences__toggles__item",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                className: "JobDraftPreferences__toggles__item__label",
                                children: t("job_draft_details.preferences_accreditation_required")
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $d931e957e209e988$export$bea8ebba691c5813), {
                                active: job.accreditation.use_accreditation,
                                onToggle: ()=>{
                                    job.accreditation.useAccreditation(!job.accreditation.use_accreditation);
                                }
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "JobDraftPreferences__toggles__item",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                className: "JobDraftPreferences__toggles__item__label",
                                children: t("job_draft_details.preferences_accommodation_offered")
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $d931e957e209e988$export$bea8ebba691c5813), {
                                active: job.accommodation.use_accommodation,
                                onToggle: ()=>{
                                    job.accommodation.useAccommodation(!job.accommodation.use_accommodation);
                                }
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "JobDraftPreferences__toggles__item",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                className: "JobDraftPreferences__toggles__item__label",
                                children: t("job_draft_details.preferences_boarding_offered")
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $d931e957e209e988$export$bea8ebba691c5813), {
                                active: job.boarding.use_boarding,
                                onToggle: ()=>{
                                    job.boarding.useBoarding(!job.boarding.use_boarding);
                                }
                            })
                        ]
                    }),
                    showNationalityOption && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "JobDraftPreferences__toggles__item",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                className: "JobDraftPreferences__toggles__item__label",
                                children: t("job_draft_details.nationalities")
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $d931e957e209e988$export$bea8ebba691c5813), {
                                active: job.nationalities.use_nationalities,
                                onToggle: ()=>{
                                    if (!job.nationalities.use_nationalities) (0, $c74a0566d4b0fd6d$export$e9db7d6e73593439).track((0, $c74a0566d4b0fd6d$export$5e27155e276f6d1c).OrderFormToggledOnNationalityOption);
                                    job.nationalities.useNationalities(!job.nationalities.use_nationalities);
                                }
                            })
                        ]
                    })
                ]
            })
        ]
    });
});




var $acw62 = parcelRequire("acw62");










const $deb1048343eb7fb9$export$b01264a27da24c0a = (0, $aca50e9407ba89c9$export$b6ae1bc530f4c149)(({ job: job })=>{
    const { languageList: languageList, getLanguages: getLanguages } = (0, $4671947198ddd366$export$6ccbb43953eebf8)().data;
    const [filteredLanguages, setFilteredLanguages] = (0, $acw62.useState)([]);
    const [calculatingList, setCalculatingList] = (0, $acw62.useState)(false);
    const [searchValue, setSearchValue] = (0, $acw62.useState)("");
    const { isLoading: languagesLoading } = (0, $4671947198ddd366$export$dd0a697e1782aedd)(getLanguages);
    const filterLanguages = (0, $85953efa7e00ce5b$export$2e2bcd8739ae039)((value)=>{
        setFilteredLanguages(languageList.filter((item)=>item.name.toLowerCase().includes(value.toLowerCase())));
        setCalculatingList(false);
    }, 500);
    const [calculatingListDebounced] = (0, $28cfa09e9775cf8c$export$2e2bcd8739ae039)(calculatingList, 300);
    (0, $acw62.useEffect)(()=>{
        if (languageList.length > 0) setFilteredLanguages(languageList);
    }, [
        languageList,
        languageList.length
    ]);
    const { t: t } = (0, $3765cebd031b52c0$export$9fc83ad70ead8663)();
    const handleSearchChange = (value)=>{
        setCalculatingList(true);
        setSearchValue(value);
        filterLanguages(value);
    };
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "JobDraftLanguages",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                className: "Popup__title",
                children: t("job_draft_details.languages_title")
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                className: "Popup__subtitle",
                children: t("job_draft_details.languages_subtitle")
            }),
            languagesLoading ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $57fb8f45c69e1681$export$b08b517936747730), {}) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $db7fb73ce5c45471$export$55d7609a8f1eccd2), {
                        value: searchValue,
                        handleValueChange: handleSearchChange,
                        className: "JobDraftLanguages__searchContainer"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $660b2ca422e0e2ae$export$1ff3c3f08ae963c0).Vertical, {
                        height: 18
                    }),
                    calculatingListDebounced ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $57fb8f45c69e1681$export$b08b517936747730), {}) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: `JobDraftLanguages__list ${job.languages.hasError ? "error" : ""}`,
                        children: filteredLanguages.map((lang)=>{
                            const selected = job.languages.has(lang.id);
                            return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                onClick: ()=>{
                                    if (selected) job.languages.remove(lang.id);
                                    else job.languages.add(lang.id);
                                },
                                className: "JobDraftLanguages__list__item",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                        className: "JobDraftLanguages__list__item__label",
                                        children: lang.name
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f224f10e61e1d993$export$48513f6b9f8ce62d), {
                                        isActive: selected,
                                        type: "square"
                                    })
                                ]
                            }, lang.id);
                        })
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $17a27c6ba7085f84$export$57b95d3630b174f6), {
                        error: job.languages.error
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $660b2ca422e0e2ae$export$1ff3c3f08ae963c0).Vertical, {
                        height: 20
                    })
                ]
            })
        ]
    });
});










const $2d0b9b995996d6bc$export$89930abb48c00f4c = (0, $aca50e9407ba89c9$export$b6ae1bc530f4c149)(({ job: job })=>{
    const { t: t } = (0, $3765cebd031b52c0$export$9fc83ad70ead8663)();
    const gender = job.gender.value;
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "JobDraftGender",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                className: "Popup__title",
                children: t("job_draft_details.gender_title")
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                className: "Popup__subtitle",
                children: t("job_draft_details.gender_subtitle")
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "JobDraftGender__innerContainer",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $2ab88429e3384d30$export$353f5b6fc5456de1), {
                        title: t("job_draft_details.gender_male"),
                        onClick: ()=>{
                            job.gender.set((0, $9940b994a7a3bcd1$export$87cdbc5104bfce47).male);
                        },
                        className: `JobDraftGender__innerContainer__button ${gender === (0, $9940b994a7a3bcd1$export$87cdbc5104bfce47).male ? "active" : ""} ${job.gender.hasError ? "error" : ""}`
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $660b2ca422e0e2ae$export$1ff3c3f08ae963c0).Vertical, {
                        height: 10
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $2ab88429e3384d30$export$353f5b6fc5456de1), {
                        title: t("job_draft_details.gender_female"),
                        onClick: ()=>{
                            job.gender.set((0, $9940b994a7a3bcd1$export$87cdbc5104bfce47).female);
                        },
                        className: `JobDraftGender__innerContainer__button ${gender === (0, $9940b994a7a3bcd1$export$87cdbc5104bfce47).female ? "active" : ""} ${job.gender.hasError ? "error" : ""}`
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $660b2ca422e0e2ae$export$1ff3c3f08ae963c0).Vertical, {
                        height: 10
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $2ab88429e3384d30$export$353f5b6fc5456de1), {
                        title: t("job_draft_details.gender_no_preference"),
                        onClick: ()=>{
                            job.gender.set(null);
                        },
                        className: `JobDraftGender__innerContainer__button ${gender === null ? "active" : ""} ${job.gender.hasError ? "error" : ""}`
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $17a27c6ba7085f84$export$57b95d3630b174f6), {
                        error: job.gender.error
                    })
                ]
            })
        ]
    });
});




var $acw62 = parcelRequire("acw62");










const $db1ab873301a1a9e$export$f8ef8592b4a3f47d = (0, $aca50e9407ba89c9$export$b6ae1bc530f4c149)(({ job: job })=>{
    const { jobDocumentsList: jobDocumentsList, getJobDocuments: getJobDocuments } = (0, $4671947198ddd366$export$6ccbb43953eebf8)().data;
    const [filteredDocuments, setFilteredDocuments] = (0, $acw62.useState)([]);
    const [calculatingList, setCalculatingList] = (0, $acw62.useState)(false);
    const [searchValue, setSearchValue] = (0, $acw62.useState)("");
    const { isLoading: jobDocumentsLoading } = (0, $4671947198ddd366$export$dd0a697e1782aedd)(getJobDocuments);
    const filterDocuments = (0, $85953efa7e00ce5b$export$2e2bcd8739ae039)((value)=>{
        setFilteredDocuments(jobDocumentsList.filter((item)=>item.name.toLowerCase().includes(value.toLowerCase())));
        setCalculatingList(false);
    }, 500);
    const [calculatingListDebounced] = (0, $28cfa09e9775cf8c$export$2e2bcd8739ae039)(calculatingList, 300);
    (0, $acw62.useEffect)(()=>{
        if (jobDocumentsList.length > 0) setFilteredDocuments(jobDocumentsList);
    }, [
        jobDocumentsList,
        jobDocumentsList.length
    ]);
    const { t: t } = (0, $3765cebd031b52c0$export$9fc83ad70ead8663)();
    const handleSearchChange = (value)=>{
        setCalculatingList(true);
        setSearchValue(value);
        filterDocuments(value);
    };
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "JobDraftDocuments",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                className: "Popup__title",
                children: t("job_draft_details.documents_title")
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                className: "Popup__subtitle",
                children: t("job_draft_details.documents_subtitle")
            }),
            jobDocumentsLoading ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $57fb8f45c69e1681$export$b08b517936747730), {}) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $db7fb73ce5c45471$export$55d7609a8f1eccd2), {
                        value: searchValue,
                        handleValueChange: handleSearchChange,
                        placeholder: t("job_draft_details.select_document"),
                        className: "JobDraftDocuments__searchContainer"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $660b2ca422e0e2ae$export$1ff3c3f08ae963c0).Vertical, {
                        height: 18
                    }),
                    calculatingListDebounced ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $57fb8f45c69e1681$export$b08b517936747730), {}) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: `JobDraftDocuments__list ${job.documents.hasError ? "error" : ""}`,
                        children: filteredDocuments.map((doc)=>{
                            const selected = job.documents.has(doc.id);
                            return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                onClick: ()=>{
                                    if (selected) job.documents.remove(doc.id);
                                    else job.documents.add(doc.id);
                                },
                                className: "JobDraftDocuments__list__item",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                        className: "JobDraftDocuments__list__item__label",
                                        children: doc.name
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f224f10e61e1d993$export$48513f6b9f8ce62d), {
                                        isActive: selected,
                                        type: "square"
                                    })
                                ]
                            }, doc.id);
                        })
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $17a27c6ba7085f84$export$57b95d3630b174f6), {
                        error: job.documents.error
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $660b2ca422e0e2ae$export$1ff3c3f08ae963c0).Vertical, {
                        height: 20
                    })
                ]
            })
        ]
    });
});




var $acw62 = parcelRequire("acw62");














var $acw62 = parcelRequire("acw62");







function $23ab488b39f25cf5$var$QuestionCreateComponent({ visible: visible, onCreate: onCreate, onClose: onClose }) {
    const { t: t } = (0, $3765cebd031b52c0$export$9fc83ad70ead8663)();
    const { addQuestion: addQuestion } = (0, $4671947198ddd366$export$6ccbb43953eebf8)().data;
    const [addQuestionMutation, requestCreateMutation] = (0, $4671947198ddd366$export$609860bf8b0084c)(addQuestion, {
        filterError: [
            (0, $9ad33fbf770c55a1$export$9696fcf1798e1cb5).ClientError
        ],
        onSuccess: (question)=>{
            (0, $60f27fc97e29822a$export$b410431fab84fa58).success(t("job_draft_details.interview_question_created"));
            onCreate(question);
        },
        onError: (err)=>{
            (0, $60f27fc97e29822a$export$b410431fab84fa58).error(err.data.errors?.description?.[0] ?? err.data.message);
        }
    });
    const [description, setDescription] = (0, $acw62.useState)("");
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c786671f641538e1$export$446bb0a5366f9068), {
        modalVisible: visible,
        onClose: onClose,
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
            className: "QuestionCreate",
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h2", {
                    className: "QuestionCreate__title",
                    children: t("job_draft_details.interview_question_form_title")
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4e342c5928158118$export$f5b8910cec6cf069), {
                    className: "QuestionCreate__input",
                    label: t("job_draft_details.interview_question_form_placeholder"),
                    value: description,
                    handleChange: setDescription
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $2c46e9e1f89bee75$export$2b47962e4e24eb4d), {
                    text: t("job_draft_details.interview_question_form_submit"),
                    disabled: description.length === 0 || addQuestionMutation.isLoading,
                    action: ()=>{
                        requestCreateMutation({
                            description: description
                        });
                        setDescription("");
                    }
                })
            ]
        })
    });
}
const $23ab488b39f25cf5$export$dd07be74e352129f = (0, $aca50e9407ba89c9$export$b6ae1bc530f4c149)($23ab488b39f25cf5$var$QuestionCreateComponent);





const $8d357fa21b490d66$export$4fc38861141999c0 = (0, $aca50e9407ba89c9$export$b6ae1bc530f4c149)(({ job: job })=>{
    const { nextQuestionPage: nextQuestionPage, getQuestionById: getQuestionById, getQuestions: getQuestions } = (0, $4671947198ddd366$export$6ccbb43953eebf8)().data;
    const [filteredQuestions, setFilteredQuestions] = (0, $acw62.useState)([]);
    const [calculatingList, setCalculatingList] = (0, $acw62.useState)(false);
    const [searchValue, setSearchValue] = (0, $acw62.useState)("");
    const [questionModalVisible, setQuestionModalVisible] = (0, $acw62.useState)(false);
    const [localQuestions, setLocalQuestions] = (0, $acw62.useState)([]);
    const [{ isLoading: questionsLoading }, loadQuestions] = (0, $4671947198ddd366$export$609860bf8b0084c)(getQuestions, {
        onSuccess: (questions)=>{
            setLocalQuestions((oldQuestions)=>[
                    ...oldQuestions,
                    ...questions.map((q)=>q.id)
                ]);
        }
    });
    const filterQuestions = (0, $85953efa7e00ce5b$export$2e2bcd8739ae039)((value)=>{
        setFilteredQuestions(localQuestions.filter((id)=>{
            const question = getQuestionById(id);
            return question?.description.toLowerCase().includes(value.toLowerCase());
        }));
        setCalculatingList(false);
    }, 500);
    const [calculatingListDebounced] = (0, $28cfa09e9775cf8c$export$2e2bcd8739ae039)(calculatingList, 300);
    (0, $acw62.useEffect)(()=>{
        loadQuestions({
            page: 1
        });
    }, []);
    (0, $acw62.useEffect)(()=>{
        if (localQuestions.length > 0) setFilteredQuestions(localQuestions);
    }, [
        localQuestions,
        localQuestions.length
    ]);
    const handleScroll = (0, $324dc7daf4e64dab$export$5bd4c3b2b0a1aaf1)(()=>{
        if (nextQuestionPage !== null) loadQuestions({
            page: nextQuestionPage
        });
    });
    const { t: t } = (0, $3765cebd031b52c0$export$9fc83ad70ead8663)();
    const handleSearchChange = (value)=>{
        setCalculatingList(true);
        setSearchValue(value);
        filterQuestions(value);
    };
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "JobDraftInterview",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                className: "Popup__title",
                children: t("job_draft_details.interview_title")
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                className: "Popup__subtitle",
                children: t("job_draft_details.interview_subtitle")
            }),
            questionsLoading ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $57fb8f45c69e1681$export$b08b517936747730), {}) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $db7fb73ce5c45471$export$55d7609a8f1eccd2), {
                        value: searchValue,
                        handleValueChange: handleSearchChange,
                        className: "JobDraftInterview__searchContainer"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $660b2ca422e0e2ae$export$1ff3c3f08ae963c0).Vertical, {
                        height: 18
                    }),
                    calculatingListDebounced ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $57fb8f45c69e1681$export$b08b517936747730), {}) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: `JobDraftInterview__list ${job.manualSelection.hasInterviewError ? "error" : ""}`,
                        onScroll: handleScroll,
                        children: filteredQuestions.map((id)=>{
                            const selected = job.manualSelection.hasQuestion(id);
                            return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                onClick: ()=>{
                                    if (selected) job.manualSelection.removeQuestion(id);
                                    else job.manualSelection.addQuestion(id);
                                },
                                className: "JobDraftInterview__list__item",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                        className: "JobDraftInterview__list__item__label",
                                        children: getQuestionById(id)?.description
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f224f10e61e1d993$export$48513f6b9f8ce62d), {
                                        isActive: selected,
                                        type: "square"
                                    })
                                ]
                            }, String(id));
                        })
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $17a27c6ba7085f84$export$57b95d3630b174f6), {
                        error: job.manualSelection.interview_error
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $660b2ca422e0e2ae$export$1ff3c3f08ae963c0).Vertical, {
                        height: 16
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $2ab88429e3384d30$export$353f5b6fc5456de1), {
                        className: "JobDraftInterview__addQuestionContainer",
                        onClick: ()=>{
                            setQuestionModalVisible(true);
                        },
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                                src: (0, (/*@__PURE__*/$parcel$interopDefault($4f273a67caecd550$exports))),
                                className: ""
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $660b2ca422e0e2ae$export$1ff3c3f08ae963c0).Horizontal, {
                                width: 12
                            }),
                            t("job_draft_details.interview_new_question")
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $660b2ca422e0e2ae$export$1ff3c3f08ae963c0).Vertical, {
                        height: 20
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $23ab488b39f25cf5$export$dd07be74e352129f), {
                visible: questionModalVisible,
                onCreate: (newQuestion)=>{
                    setQuestionModalVisible(false);
                    setLocalQuestions((questions)=>[
                            ...questions,
                            newQuestion.id
                        ]);
                    job.manualSelection.addQuestion(newQuestion.id);
                },
                onClose: ()=>{
                    setQuestionModalVisible(false);
                }
            })
        ]
    });
});









const $60b1156ab371b627$export$54f4bb4787193dec = (0, $aca50e9407ba89c9$export$b6ae1bc530f4c149)(({ job: job })=>{
    const { t: t } = (0, $3765cebd031b52c0$export$9fc83ad70ead8663)();
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "JobDraftAccreditation",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                className: "Popup__title",
                children: t("job_draft_details.accreditation_title")
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                className: "JobDraftAccreditation__description",
                children: t("job_draft_details.accreditation_subtitle")
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "JobDraftAccreditation__innerContainer",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $2ab88429e3384d30$export$353f5b6fc5456de1), {
                        title: t("job_draft_details.accreditation_yes"),
                        onClick: ()=>{
                            job.accreditation.set(true);
                        },
                        className: `JobDraftAccreditation__innerContainer__button ${job.accreditation.value === true ? "active" : ""} ${job.accreditation.hasError ? "error" : ""}`
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $660b2ca422e0e2ae$export$1ff3c3f08ae963c0).Vertical, {
                        height: 10
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $2ab88429e3384d30$export$353f5b6fc5456de1), {
                        title: t("job_draft_details.accreditation_no"),
                        onClick: ()=>{
                            job.accreditation.set(false);
                        },
                        className: `JobDraftAccreditation__innerContainer__button ${job.accreditation.value === false ? "active" : ""} ${job.accreditation.hasError ? "error" : ""}`
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $17a27c6ba7085f84$export$57b95d3630b174f6), {
                        error: job.accreditation.error
                    })
                ]
            })
        ]
    });
});




var $acw62 = parcelRequire("acw62");













var $7YFi7 = parcelRequire("7YFi7");







var $acw62 = parcelRequire("acw62");



const $cff7620f776639a1$export$eae70af4b4e3f197 = ({ placeholder: placeholder, options: options, selectedOptions: selectedOptions, onSelect: onSelect, onDeselect: onDeselect })=>{
    const [showOptions, setShowOptions] = (0, $acw62.useState)(false);
    const selectRef = (0, $acw62.useRef)(null);
    (0, $acw62.useEffect)(()=>{
        function handleClickOutside(event) {
            if (selectRef.current && !selectRef.current.contains(event.target)) setShowOptions(false);
        }
        document.addEventListener("mousedown", handleClickOutside);
        return ()=>{
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, [
        selectRef
    ]);
    const handleSelectedOptionPressed = (option)=>{
        const newOptions = selectedOptions.filter((item)=>item.key !== option.key);
        onDeselect(newOptions);
    };
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        ref: selectRef,
        className: "Multiselect",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                onClick: ()=>{
                    setShowOptions((prevState)=>!prevState);
                },
                className: "Multiselect__inputPlug",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                    className: "Multiselect__inputPlug__label",
                    children: placeholder
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: `Multiselect__options ${showOptions ? "" : "hidden"}`,
                children: options.map((option)=>{
                    const selected = Boolean(selectedOptions.find((item)=>item.key === option.key));
                    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        onClick: ()=>{
                            if (selected) onSelect(selectedOptions.filter((item)=>item.key !== option.key));
                            else onSelect([
                                ...selectedOptions,
                                option
                            ]);
                        },
                        className: "Multiselect__options__item",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f224f10e61e1d993$export$48513f6b9f8ce62d), {
                                isActive: selected
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                className: "Multiselect__options__item__label",
                                children: option.name
                            })
                        ]
                    }, option.key);
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "Multiselect__selectedOptions",
                children: selectedOptions.map((option, index)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $acw62.Fragment), {
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                onClick: ()=>{
                                    handleSelectedOptionPressed(option);
                                },
                                className: "Multiselect__selectedOptions__option",
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                    className: "Multiselect__selectedOptions__option__name",
                                    children: option.name
                                })
                            }),
                            index !== selectedOptions.length - 1 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $660b2ca422e0e2ae$export$1ff3c3f08ae963c0).Horizontal, {
                                width: 10
                            })
                        ]
                    }, option.key))
            })
        ]
    });
};











const $a7218a7e9aa93e43$var$roleOptions = [
    {
        key: String((0, $97fa7686fb8e51ed$export$eb3485a690c2f0b8).Admin),
        label: "Admin",
        value: "Admin"
    },
    {
        key: String((0, $97fa7686fb8e51ed$export$eb3485a690c2f0b8).Manager),
        label: "Manager",
        value: "Manager"
    },
    {
        key: String((0, $97fa7686fb8e51ed$export$eb3485a690c2f0b8).Finance),
        label: "Finance",
        value: "Finance"
    }
];
const $a7218a7e9aa93e43$export$a2fae8d9b81b1013 = (0, $a4963babae245ff9$export$f0c7a449e0cfaec7)((0, $aca50e9407ba89c9$export$b6ae1bc530f4c149)(({ id: id, onSubmit: onSubmit, showHeader: showHeader = true })=>{
    const { locationsDataView: locationsDataView, getLocations: getLocations, addNewContact: addNewContact, updateContact: updateContact, deleteContact: deleteContact, getContactById: getContactById, getLocationNameById: getLocationNameById } = (0, $4671947198ddd366$export$6ccbb43953eebf8)().data;
    const { isLoading: locationsLoading } = (0, $4671947198ddd366$export$dd0a697e1782aedd)(()=>getLocations({}));
    const locationOptions = locationsDataView.length > 0 ? locationsDataView.map((location)=>({
            key: location.id,
            name: location.name
        })) : null;
    const handleMutationSuccess = ()=>{
        if (onSubmit) onSubmit();
        else window.history.back();
    };
    const [requestNewContactResult, requestNewContact] = (0, $4671947198ddd366$export$609860bf8b0084c)(addNewContact, {
        filterError: [
            (0, $9ad33fbf770c55a1$export$9696fcf1798e1cb5).ClientError
        ],
        onSuccess: handleMutationSuccess
    });
    const [requestUpdateContactResult, requestUpdateContact] = (0, $4671947198ddd366$export$609860bf8b0084c)(updateContact, {
        filterError: [
            (0, $9ad33fbf770c55a1$export$9696fcf1798e1cb5).ClientError
        ],
        onSuccess: handleMutationSuccess
    });
    const [, requestContactDeletion] = (0, $4671947198ddd366$export$609860bf8b0084c)(deleteContact, {
        filterError: [
            (0, $9ad33fbf770c55a1$export$9696fcf1798e1cb5).ClientError
        ],
        onSuccess: handleMutationSuccess,
        onError: (err)=>{
            alert(err.message);
        }
    });
    const { t: t } = (0, $3765cebd031b52c0$export$9fc83ad70ead8663)();
    const handleDeletePressed = ()=>{
        const agreedToDelete = confirm(t("user_management.confirm_deletion_question"));
        if (agreedToDelete) requestContactDeletion(Number(id));
    };
    const existingContact = typeof id === "string" ? getContactById(Number(id)) : null;
    const deletingExistingUserDisabled = existingContact?.roles.includes((0, $97fa7686fb8e51ed$export$eb3485a690c2f0b8).Owner);
    const errors = requestNewContactResult.error?.data.errors ?? requestUpdateContactResult.error?.data.errors;
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        className: "AddUser",
        children: locationsLoading || requestNewContactResult.isLoading || requestUpdateContactResult.isLoading ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $57fb8f45c69e1681$export$2e2bcd8739ae039), {}) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
            children: [
                showHeader && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7ae42b63183f30b4$export$8b251419efc915eb), {
                            title: t("user_management.add_new_user"),
                            showBack: true
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $660b2ca422e0e2ae$export$1ff3c3f08ae963c0).Vertical, {
                            height: 15
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                    className: "AddUser__container",
                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7YFi7.Formik), {
                        initialValues: {
                            first_name: existingContact?.first_name ?? "",
                            last_name: existingContact?.last_name ?? "",
                            phone: existingContact?.phone ?? "",
                            email: existingContact?.email ?? "",
                            roles: existingContact ? (0, $97fa7686fb8e51ed$export$eb3485a690c2f0b8)[existingContact.roles[0]] : $a7218a7e9aa93e43$var$roleOptions[0].value,
                            client_locations: existingContact?.client_locations?.length ? existingContact.client_locations.map((locationId)=>({
                                    key: locationId,
                                    name: getLocationNameById(String(locationId))
                                })) : []
                        },
                        onSubmit: (values)=>{
                            const formValues = Object.entries(values).reduce((accum, [fieldKey, fieldValue])=>{
                                if (fieldKey === "roles") accum[`roles[0]`] = Number($a7218a7e9aa93e43$var$roleOptions.find((role)=>role.value === values.roles)?.key);
                                else if (fieldKey === "client_locations") values.client_locations.forEach(({ key: key }, index)=>{
                                    accum[`client_locations[${index}]`] = key;
                                });
                                else accum[fieldKey] = fieldValue;
                                return accum;
                            }, {});
                            if (id) requestUpdateContact({
                                ...formValues,
                                id: id
                            });
                            else requestNewContact(formValues);
                        },
                        validationSchema: $cd7706ce94a8dfd1$export$185802fd694ee1f5().shape({
                            first_name: $bcc252d93ab3046c$export$185802fd694ee1f5().required(t("user_management.enter_first_name")),
                            last_name: $bcc252d93ab3046c$export$185802fd694ee1f5().required(t("user_management.enter_last_name")),
                            phone: $bcc252d93ab3046c$export$185802fd694ee1f5().required(t("user_management.enter_phone")),
                            email: $bcc252d93ab3046c$export$185802fd694ee1f5().email(t("validation_messages.email_invalid")).required(t("user_management.enter_email")),
                            roles: $bcc252d93ab3046c$export$185802fd694ee1f5().required(t("user_management.choose_role")),
                            client_locations: $e218604b96487b25$export$185802fd694ee1f5().of($cd7706ce94a8dfd1$export$185802fd694ee1f5().shape({
                                key: $425f4614c2bd74f2$export$185802fd694ee1f5(),
                                name: $bcc252d93ab3046c$export$185802fd694ee1f5()
                            })).required(t("user_management.choose_location")).typeError(t("user_management.choose_location"))
                        }),
                        children: (formikProps)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7YFi7.Form), {
                                noValidate: true,
                                className: "AddUser__container__form",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $1067a74e1c3483e2$export$f551688fc98f2e09), {
                                        errors: errors?.first_name,
                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $79dd68e96d831dee$export$2e2bcd8739ae039), {
                                            formikProps: formikProps,
                                            label: t("user_management.first_name"),
                                            formikKey: "first_name",
                                            disabled: Boolean(id)
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $660b2ca422e0e2ae$export$1ff3c3f08ae963c0).Vertical, {
                                        height: 20
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $1067a74e1c3483e2$export$f551688fc98f2e09), {
                                        errors: errors?.last_name,
                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $79dd68e96d831dee$export$2e2bcd8739ae039), {
                                            formikProps: formikProps,
                                            label: t("user_management.last_name"),
                                            formikKey: "last_name",
                                            disabled: Boolean(id)
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $660b2ca422e0e2ae$export$1ff3c3f08ae963c0).Vertical, {
                                        height: 20
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $1067a74e1c3483e2$export$f551688fc98f2e09), {
                                        errors: errors?.phone,
                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $79dd68e96d831dee$export$2e2bcd8739ae039), {
                                            formikProps: formikProps,
                                            label: t("user_management.phone"),
                                            formikKey: "phone",
                                            type: "tel"
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $660b2ca422e0e2ae$export$1ff3c3f08ae963c0).Vertical, {
                                        height: 20
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $1067a74e1c3483e2$export$f551688fc98f2e09), {
                                        errors: errors?.email,
                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $79dd68e96d831dee$export$2e2bcd8739ae039), {
                                            formikProps: formikProps,
                                            label: t("user_management.email"),
                                            formikKey: "email",
                                            type: "email"
                                        })
                                    }),
                                    errors?.email && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7df35e9df335b1c8$export$a6c7ac8248d6e38a), {
                                        route: (0, $0534349ae8731d0b$export$66b32f6f30eb4b4).inviteUser,
                                        params: {
                                            email: formikProps.values.email
                                        },
                                        className: "AddUser__inviteButton",
                                        children: t("user_management.invite_user_exclamation")
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $660b2ca422e0e2ae$export$1ff3c3f08ae963c0).Vertical, {
                                        height: 20
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $1067a74e1c3483e2$export$f551688fc98f2e09), {
                                        errors: errors?.roles,
                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f2c1b8699595d8c0$export$ef9b1a59e592288f), {
                                            label: t("user_management.job_role"),
                                            value: formikProps.getFieldProps("roles").value,
                                            onChange: (value)=>{
                                                formikProps.setFieldValue("roles", value);
                                            },
                                            options: $a7218a7e9aa93e43$var$roleOptions
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $660b2ca422e0e2ae$export$1ff3c3f08ae963c0).Vertical, {
                                        height: 20
                                    }),
                                    [
                                        "Manager",
                                        "Admin"
                                    ].includes(formikProps.values.roles) && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $1067a74e1c3483e2$export$f551688fc98f2e09), {
                                                errors: formikProps.errors.client_locations ?? errors?.client_locations,
                                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $cff7620f776639a1$export$eae70af4b4e3f197), {
                                                    placeholder: t("user_management.location"),
                                                    options: locationOptions ?? [],
                                                    selectedOptions: formikProps.getFieldProps("client_locations").value,
                                                    onSelect: (list)=>{
                                                        formikProps.setFieldValue("client_locations", list);
                                                    },
                                                    onDeselect: (list)=>{
                                                        formikProps.setFieldValue("client_locations", list);
                                                    }
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $660b2ca422e0e2ae$export$1ff3c3f08ae963c0).Vertical, {
                                                height: 34
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        className: "AddUser__container__form__buttons",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $2ab88429e3384d30$export$353f5b6fc5456de1), {
                                                type: "submit",
                                                title: t("user_management.save"),
                                                className: "AddUser__container__form__buttons__button submit"
                                            }),
                                            existingContact && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $660b2ca422e0e2ae$export$1ff3c3f08ae963c0).Horizontal, {
                                                        width: 10
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $2ab88429e3384d30$export$353f5b6fc5456de1), {
                                                        title: t("user_management.delete"),
                                                        className: `AddUser__container__form__buttons__button delete ${deletingExistingUserDisabled ? "disabled" : ""}`,
                                                        type: "button",
                                                        disabled: deletingExistingUserDisabled,
                                                        onClick: handleDeletePressed
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            })
                    })
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $660b2ca422e0e2ae$export$1ff3c3f08ae963c0).Vertical, {
                    height: 23
                })
            ]
        })
    });
}));





const $3c795d328a124550$export$1a3a3c76d9d50b4e = (0, $aca50e9407ba89c9$export$b6ae1bc530f4c149)(({ job: job })=>{
    const [addPocModalVisible, setAddPocModalVisible] = (0, $acw62.useState)(false);
    const { pointsOfContact: pointsOfContact, getPointsOfContact: getPointsOfContact, getContactById: getContactById } = (0, $4671947198ddd366$export$6ccbb43953eebf8)().data;
    const { query: pocQuery, enableQuery: enableQuery } = (0, $4671947198ddd366$export$517ca4f7fee4e226)(()=>getPointsOfContact({
            locationId: job.location.value?.id
        }), {
        onSuccess: (pocList)=>{
            if (!job.manager.id) job.manager.set(pocList[0].id);
        }
    });
    (0, $acw62.useEffect)(()=>{
        enableQuery();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        job.location.value?.id
    ]);
    const { t: t } = (0, $3765cebd031b52c0$export$9fc83ad70ead8663)();
    const pocOptions = pointsOfContact?.length ? pointsOfContact.map((poc)=>{
        const name = `${poc.first_name} ${poc.last_name}`;
        return {
            key: name,
            label: name,
            value: poc.id
        };
    }) : null;
    const poc = job.manager.id ? getContactById(job.manager.id) : null;
    if (!job.location.value && !job.manager.id) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "JobDraftPOC",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                className: "Popup__title",
                children: t("job_draft_details.poc_title")
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                className: "Popup__subtitle",
                children: t("job_draft_details.select_location_first")
            })
        ]
    });
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "JobDraftPOC",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                className: "Popup__title",
                children: t("job_draft_details.poc_title")
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                className: "Popup__subtitle",
                children: t("job_draft_details.poc_subtitle")
            }),
            pocQuery.isLoading ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $57fb8f45c69e1681$export$b08b517936747730), {}) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f2c1b8699595d8c0$export$ef9b1a59e592288f), {
                        label: t("job_draft_details.point_of_contact"),
                        value: poc?.id,
                        onChange: (id)=>{
                            job.manager.set(id);
                        },
                        options: pocOptions ?? [],
                        className: `JobDraftPOC__pocSelect ${job.manager.hasError ? "error" : ""}`
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $17a27c6ba7085f84$export$57b95d3630b174f6), {
                        error: job.manager.error
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $660b2ca422e0e2ae$export$1ff3c3f08ae963c0).Vertical, {
                        height: 35
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $2ab88429e3384d30$export$353f5b6fc5456de1), {
                        onClick: ()=>{
                            setAddPocModalVisible(true);
                        },
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                            children: t("job_draft_details.add_poc")
                        })
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $c786671f641538e1$export$446bb0a5366f9068), {
                        modalVisible: addPocModalVisible,
                        onClose: ()=>{
                            setAddPocModalVisible(false);
                        },
                        className: "JobDraftPOC__modal",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "JobDraftPOC__modal__header",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {}),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                        className: "JobDraftPOC__modal__header__modalTitle",
                                        children: t("job_draft_details.add_poc")
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                                        src: (0, (/*@__PURE__*/$parcel$interopDefault($c8242b1acdd8c5a0$exports))),
                                        onClick: ()=>{
                                            setAddPocModalVisible(false);
                                        },
                                        className: "JobDraftPOC__modal__header__modalCloseImg"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $a7218a7e9aa93e43$export$a2fae8d9b81b1013), {
                                onSubmit: ()=>{
                                    setAddPocModalVisible(false);
                                    pocQuery.reload();
                                },
                                showHeader: false
                            })
                        ]
                    })
                ]
            })
        ]
    });
});










function $88855a758cfdd8b4$export$b8ac4e99d51e17e1(status) {
    switch(status){
        case (0, $862a04ca6e0d681b$export$3456ae8ade9eb8c).noBoarding:
            return (0, $2b1f0855f2f3a952$export$625550452a3fa3ec)("job_draft_details.no_boarding");
        case (0, $862a04ca6e0d681b$export$3456ae8ade9eb8c).halfBoarding:
            return (0, $2b1f0855f2f3a952$export$625550452a3fa3ec)("job_draft_details.half_boarding");
        case (0, $862a04ca6e0d681b$export$3456ae8ade9eb8c).fullBoarding:
            return (0, $2b1f0855f2f3a952$export$625550452a3fa3ec)("job_draft_details.full_boarding");
    }
}




const $a579d3778586e181$export$56a762fdc756caea = (0, $aca50e9407ba89c9$export$b6ae1bc530f4c149)(({ job: job })=>{
    const { t: t } = (0, $3765cebd031b52c0$export$9fc83ad70ead8663)();
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "JobDraftBoarding",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                className: "Popup__title",
                children: t("job_draft_details.accommodation_title")
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "JobDraftBoarding__innerContainer",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $2ab88429e3384d30$export$353f5b6fc5456de1), {
                        title: (0, $88855a758cfdd8b4$export$b8ac4e99d51e17e1)((0, $862a04ca6e0d681b$export$3456ae8ade9eb8c).noBoarding),
                        onClick: ()=>{
                            job.boarding.set((0, $862a04ca6e0d681b$export$3456ae8ade9eb8c).noBoarding);
                        },
                        className: `JobDraftBoarding__innerContainer__button ${job.boarding.value === (0, $862a04ca6e0d681b$export$3456ae8ade9eb8c).noBoarding ? "active" : ""} ${job.boarding.hasError ? "error" : ""}`
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $660b2ca422e0e2ae$export$1ff3c3f08ae963c0).Vertical, {
                        height: 10
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $2ab88429e3384d30$export$353f5b6fc5456de1), {
                        title: (0, $88855a758cfdd8b4$export$b8ac4e99d51e17e1)((0, $862a04ca6e0d681b$export$3456ae8ade9eb8c).halfBoarding),
                        onClick: ()=>{
                            job.boarding.set((0, $862a04ca6e0d681b$export$3456ae8ade9eb8c).halfBoarding);
                        },
                        className: `JobDraftBoarding__innerContainer__button ${job.boarding.value === (0, $862a04ca6e0d681b$export$3456ae8ade9eb8c).halfBoarding ? "active" : ""} ${job.boarding.hasError ? "error" : ""}`
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $660b2ca422e0e2ae$export$1ff3c3f08ae963c0).Vertical, {
                        height: 10
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $2ab88429e3384d30$export$353f5b6fc5456de1), {
                        title: (0, $88855a758cfdd8b4$export$b8ac4e99d51e17e1)((0, $862a04ca6e0d681b$export$3456ae8ade9eb8c).fullBoarding),
                        onClick: ()=>{
                            job.boarding.set((0, $862a04ca6e0d681b$export$3456ae8ade9eb8c).fullBoarding);
                        },
                        className: `JobDraftBoarding__innerContainer__button ${job.boarding.value === (0, $862a04ca6e0d681b$export$3456ae8ade9eb8c).fullBoarding ? "active" : ""} ${job.boarding.hasError ? "error" : ""}`
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $17a27c6ba7085f84$export$57b95d3630b174f6), {
                        error: job.boarding.error
                    })
                ]
            })
        ]
    });
});











const $838a1b1b94c93ccd$export$f63ff7dda214a193 = (0, $aca50e9407ba89c9$export$b6ae1bc530f4c149)(({ job: job })=>{
    const { t: t } = (0, $3765cebd031b52c0$export$9fc83ad70ead8663)();
    const accessibility = job.transport.value;
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "JobDraftPublicTransportAccessibility",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                className: "Popup__title",
                children: t("order_draft.is_location_accessible_by_transport")
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                className: "Popup__subtitle",
                children: t("order_draft.tell_if_location_is_reachable")
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "JobDraftPublicTransportAccessibility__innerContainer",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $2ab88429e3384d30$export$353f5b6fc5456de1), {
                        title: t("order_draft.public_transport_accessibility_accessible"),
                        onClick: ()=>{
                            job.transport.set(Number((0, $262fe7de1e230770$export$e97f944cf44dfd60).accessible));
                        },
                        className: `JobDraftPublicTransportAccessibility__innerContainer__button ${accessibility === Number((0, $262fe7de1e230770$export$e97f944cf44dfd60).accessible) ? "active" : ""} ${job.transport.hasError ? "error" : ""}`
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $660b2ca422e0e2ae$export$1ff3c3f08ae963c0).Vertical, {
                        height: 10
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $2ab88429e3384d30$export$353f5b6fc5456de1), {
                        title: t("order_draft.public_transport_accessibility_not_accessible"),
                        onClick: ()=>{
                            job.transport.set(Number((0, $262fe7de1e230770$export$e97f944cf44dfd60).notAccessible));
                        },
                        className: `JobDraftPublicTransportAccessibility__innerContainer__button ${accessibility === Number((0, $262fe7de1e230770$export$e97f944cf44dfd60).notAccessible) ? "active" : ""} ${job.transport.hasError ? "error" : ""}`
                    }),
                    job.transport.hasError && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $17a27c6ba7085f84$export$57b95d3630b174f6), {
                        error: job.transport.error
                    })
                ]
            })
        ]
    });
});










const $18a426bf53367ec3$export$f699ec9d9cdde0e8 = (0, $aca50e9407ba89c9$export$b6ae1bc530f4c149)(({ job: job })=>{
    const { t: t } = (0, $3765cebd031b52c0$export$9fc83ad70ead8663)();
    const hasErrors = job.schedule.sameTimeSchedule.sameTimePromptHasErrors;
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "ShiftTimingsPrompt",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                className: "Popup__title",
                children: t("job_draft_details.what_are_the_shifts_timings")
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "ShiftTimingsPrompt__innerContainer",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $2ab88429e3384d30$export$353f5b6fc5456de1), {
                        onClick: ()=>{
                            job.setAllDaysHaveSameTime(true);
                        },
                        className: `ShiftTimingsPrompt__innerContainer__button ${job.schedule.sameTimeSchedule.allDaysHaveSameTime === true ? "active" : undefined} ${hasErrors ? "error" : ""}`,
                        children: t("job_draft_details.start_and_ends_are_same")
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $660b2ca422e0e2ae$export$1ff3c3f08ae963c0).Vertical, {
                        height: 10
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $2ab88429e3384d30$export$353f5b6fc5456de1), {
                        onClick: ()=>{
                            job.setAllDaysHaveSameTime(false);
                        },
                        className: `ShiftTimingsPrompt__innerContainer__button ${job.schedule.sameTimeSchedule.allDaysHaveSameTime === false ? "active" : undefined} ${hasErrors ? "error" : ""}`,
                        children: t("job_draft_details.time_vary")
                    }),
                    hasErrors && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $17a27c6ba7085f84$export$57b95d3630b174f6), {
                        error: job.schedule.sameTimeSchedule.all_days_have_same_time_error
                    })
                ]
            })
        ]
    });
});










const $72f29f4c6d53e550$export$f5412888a2b559de = (0, $aca50e9407ba89c9$export$b6ae1bc530f4c149)(({ job: job })=>{
    const { t: t } = (0, $3765cebd031b52c0$export$9fc83ad70ead8663)();
    const hasStartTimeErrors = job.schedule.sameTimeSchedule.startTimeHasErrors;
    const hasEndimeErrors = job.schedule.sameTimeSchedule.endTimeHasErrors;
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "SameTime",
        children: [
            job.schedule.sameTimeSchedule.is_less_than_24h && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7a26230deaaf6920$export$944fe0ec49485b21), {
                theme: (0, $7a26230deaaf6920$export$14faa19a0f3bbeb2).Orange,
                title: t("job_draft_details.less_than_24h_warning"),
                action: ()=>{},
                isActionInProgress: false,
                withCloseButton: false,
                style: {
                    marginTop: "15px"
                }
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                className: "Popup__title",
                children: t("job_draft_details.what_are_job_timings")
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                className: "Popup__subtitle",
                children: t("job_draft_details.select_same_time")
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "SameTime__innerContainer",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5ce1d5308946b7cc$export$a1af6f79df847fac), {
                        label: t("job_draft_details.start_time"),
                        value: job.schedule.sameTimeSchedule.same_start_time ?? "",
                        handleChange: (time)=>{
                            job.schedule.setSameStartTime(time);
                        },
                        className: `${job.schedule.sameTimeSchedule.same_start_time ?? "SameTime__timePicker wide"} ${hasStartTimeErrors ? "error" : ""}`,
                        useDropdownWithInput: true,
                        required: true
                    }),
                    hasStartTimeErrors && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $17a27c6ba7085f84$export$57b95d3630b174f6), {
                        error: job.schedule.sameTimeSchedule.same_start_time_error
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $660b2ca422e0e2ae$export$1ff3c3f08ae963c0).Vertical, {
                        height: 10
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5ce1d5308946b7cc$export$a1af6f79df847fac), {
                        label: t("job_draft_details.end_time"),
                        value: job.schedule.sameTimeSchedule.same_end_time ?? "",
                        handleChange: (time)=>{
                            job.schedule.setSameEndTime(time);
                        },
                        className: `${job.schedule.sameTimeSchedule.same_end_time ?? "SameTime__timePicker wide"} ${hasEndimeErrors ? "error" : ""}`,
                        pickerStartTime: job.schedule.sameTimeSchedule.same_start_time ?? "00:00",
                        useDropdownWithInput: true,
                        showDurationFromPickerStartTime: true,
                        required: true
                    }),
                    hasEndimeErrors && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $17a27c6ba7085f84$export$57b95d3630b174f6), {
                        error: job.schedule.sameTimeSchedule.same_end_time_error
                    })
                ]
            })
        ]
    });
});




var $acw62 = parcelRequire("acw62");








var $b2aa47be5050cdd8$exports = {};
$b2aa47be5050cdd8$exports = new URL("cross-icon-grey.21b346b0.svg", import.meta.url).toString();







const $c5d46928546d4215$export$1b81d4c3af05f916 = (0, $aca50e9407ba89c9$export$b6ae1bc530f4c149)(({ job: job })=>{
    const { getPastSPs: getPastSPs, pastSPsList: pastSPsList, getInvitedPastSPsByIds: getInvitedPastSPsByIds, invitedPastSPsList: invitedPastSPsList, pastSPsNextPage: pastSPsNextPage, getProfessionName: getProfessionName, getLocationNameById: getLocationNameById } = (0, $4671947198ddd366$export$6ccbb43953eebf8)().data;
    const [searchValue, setSearchValue] = (0, $acw62.useState)("");
    const { isLoading: spsLoading } = (0, $4671947198ddd366$export$dd0a697e1782aedd)(()=>getPastSPs({
            availableFrom: job.schedule.dateBoundaries.start_date,
            availableTo: job.schedule.dateBoundaries.end_date,
            preferredLocationId: job.location.value?.id,
            preferredDesignationId: job.category.id,
            collect: false
        }), {
        onError: (err)=>{
            (0, $60f27fc97e29822a$export$b410431fab84fa58).error(err.data.message);
        }
    });
    const [searchSPsResult, searchSPsRequest] = (0, $4671947198ddd366$export$609860bf8b0084c)(({ searchString: searchString, availableFrom: availableFrom, availableTo: availableTo, page: page, collect: collect })=>getPastSPs({
            searchString: searchString,
            availableFrom: availableFrom,
            availableTo: availableTo,
            page: page,
            collect: collect,
            preferredLocationId: job.location.value?.id,
            preferredDesignationId: job.category.id
        }), {
        onError: (err)=>{
            (0, $60f27fc97e29822a$export$b410431fab84fa58).error(err.data.message);
        }
    });
    const [, getInvitedSPsQuery] = (0, $4671947198ddd366$export$609860bf8b0084c)(({ ids: ids })=>getInvitedPastSPsByIds(ids), {
        onError: (err)=>{
            (0, $60f27fc97e29822a$export$b410431fab84fa58).error(err.data.message);
        }
    });
    const { t: t } = (0, $3765cebd031b52c0$export$9fc83ad70ead8663)();
    const addOrRemoveSP = (id)=>{
        const selected = job.invitedSPs.has(id);
        if (selected) {
            job.invitedSPs.remove(id);
            (0, $c74a0566d4b0fd6d$export$e9db7d6e73593439).track((0, $c74a0566d4b0fd6d$export$5e27155e276f6d1c).PreferredWorkerRemovedFromOrder);
        } else {
            if (Number(job.invitedSPs.list?.length) >= Number(job.quantity.value) * 3) {
                (0, $60f27fc97e29822a$export$b410431fab84fa58).warning(t("invited_sps.quantity_must_not_be_greater"));
                (0, $c74a0566d4b0fd6d$export$e9db7d6e73593439).track((0, $c74a0566d4b0fd6d$export$5e27155e276f6d1c).PreferredWorkerTriedToAddMoreThanPossible);
                return;
            }
            job.invitedSPs.add(id);
            (0, $c74a0566d4b0fd6d$export$e9db7d6e73593439).track((0, $c74a0566d4b0fd6d$export$5e27155e276f6d1c).PreferredWorkerAddedToOrder);
        }
        if (job.invitedSPs.list?.length) getInvitedSPsQuery({
            ids: job.invitedSPs.list
        });
    };
    const handleSearchChange = (value)=>{
        searchSPsRequest({
            searchString: value,
            availableFrom: job.schedule.dateBoundaries.start_date,
            availableTo: job.schedule.dateBoundaries.end_date,
            collect: false
        });
        setSearchValue(value);
        (0, $c74a0566d4b0fd6d$export$e9db7d6e73593439).track((0, $c74a0566d4b0fd6d$export$5e27155e276f6d1c).PreferredWorkerSearchStarted);
    };
    const handleScroll = (0, $324dc7daf4e64dab$export$5bd4c3b2b0a1aaf1)(()=>{
        if (pastSPsNextPage) {
            searchSPsRequest({
                page: pastSPsNextPage,
                searchString: searchValue,
                availableFrom: job.schedule.dateBoundaries.start_date,
                availableTo: job.schedule.dateBoundaries.end_date,
                collect: true
            });
            (0, $c74a0566d4b0fd6d$export$e9db7d6e73593439).track((0, $c74a0566d4b0fd6d$export$5e27155e276f6d1c).PreferredWorkerScrolled);
        }
    });
    const cantInvite = !job.quantity.value || !job.schedule.scheduleType.value || !job.location.value || !job.category.id;
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "JobDraftInvitedSPs",
        children: [
            Number(job.invitedSPs.list?.length) > Number(job.quantity.value) && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7a26230deaaf6920$export$944fe0ec49485b21), {
                theme: (0, $7a26230deaaf6920$export$14faa19a0f3bbeb2).Orange,
                title: t("job_draft_details.invited_quantity_more_than_required_quantity"),
                action: ()=>{},
                isActionInProgress: false,
                withCloseButton: false,
                style: {
                    marginTop: "15px"
                }
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                className: "Popup__title",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f13ff0bdae325c20$export$b04be29aa201d4f5), {
                        title: t("common.optional")
                    }),
                    t("invited_sps.form_title")
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                className: "Popup__subtitle",
                children: t("invited_sps.form_subtitle")
            }),
            cantInvite ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                    className: "JobDraftInvitedSPs__noDataProvided",
                    children: t("invited_sps.select_required_data")
                })
            }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                children: [
                    spsLoading ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $57fb8f45c69e1681$export$b08b517936747730), {}) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $db7fb73ce5c45471$export$55d7609a8f1eccd2), {
                                value: searchValue,
                                handleValueChange: handleSearchChange,
                                className: "JobDraftInvitedSPs__searchContainer"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $660b2ca422e0e2ae$export$1ff3c3f08ae963c0).Vertical, {
                                height: 18
                            }),
                            Number(job.invitedSPs.list?.length) > 0 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7b02d682eb115277$exports.Fragment), {
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                    className: "JobDraftInvitedSPs__addedList",
                                    onScroll: handleScroll,
                                    children: invitedPastSPsList.filter((sp)=>job.invitedSPs.has(sp.id)).map((sp)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                            onClick: ()=>addOrRemoveSP(sp.id),
                                            className: "JobDraftInvitedSPs__addedList__item",
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                    children: sp.name
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                                                    src: (0, (/*@__PURE__*/$parcel$interopDefault($b2aa47be5050cdd8$exports)))
                                                })
                                            ]
                                        }, sp.id))
                                })
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "JobDraftInvitedSPs__list",
                                onScroll: handleScroll,
                                children: [
                                    pastSPsList.map((sp)=>{
                                        const selected = job.invitedSPs.has(sp.id);
                                        return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $487c9a2e5b754624$export$7e23a963ec4768e3), {
                                            disabled: !sp.is_available,
                                            withCheckbox: Boolean(sp.is_available),
                                            onClick: ()=>{
                                                if (sp.is_available) addOrRemoveSP(sp.id);
                                            },
                                            sp: sp,
                                            selected: selected,
                                            jobDesignation: getProfessionName(Number(job.category.id)),
                                            jobLocation: getLocationNameById(String(job.location.value?.id)),
                                            showDesignation: true
                                        }, sp.id);
                                    }),
                                    searchSPsResult.isLoading && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $57fb8f45c69e1681$export$b08b517936747730), {})
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $660b2ca422e0e2ae$export$1ff3c3f08ae963c0).Vertical, {
                        height: 24
                    })
                ]
            })
        ]
    });
});
// @ts-ignore
$c5d46928546d4215$export$1b81d4c3af05f916.displayName = "InvitedSPsComponent";




var $acw62 = parcelRequire("acw62");











const $19ca424d8b5d86aa$export$58cabd1a782b8999 = (0, $aca50e9407ba89c9$export$b6ae1bc530f4c149)(({ job: job })=>{
    const { nationalitiesList: nationalitiesList, allNationalities: allNationalities, getNationalities: getNationalities } = (0, $4671947198ddd366$export$6ccbb43953eebf8)().data;
    const [originalNationalities, setOriginalNationalities] = (0, $acw62.useState)([]);
    const [filteredNationalities, setFilteredNationalities] = (0, $acw62.useState)([]);
    const [calculatingList, setCalculatingList] = (0, $acw62.useState)(false);
    const [searchValue, setSearchValue] = (0, $acw62.useState)("");
    const { isLoading: nationalitiesLoading } = (0, $4671947198ddd366$export$dd0a697e1782aedd)(getNationalities);
    const filterNationalities = (0, $85953efa7e00ce5b$export$2e2bcd8739ae039)((value)=>{
        setFilteredNationalities(originalNationalities.filter((item)=>item.name.toLowerCase().includes(value.toLowerCase())));
        setCalculatingList(false);
    }, 500);
    const [calculatingListDebounced] = (0, $28cfa09e9775cf8c$export$2e2bcd8739ae039)(calculatingList, 300);
    (0, $acw62.useEffect)(()=>{
        if (allNationalities.length > 0) {
            setOriginalNationalities(nationalitiesList(!job.existing_job_id));
            setFilteredNationalities(nationalitiesList(!job.existing_job_id));
        }
    }, [
        allNationalities,
        allNationalities.length
    ]);
    const { t: t } = (0, $3765cebd031b52c0$export$9fc83ad70ead8663)();
    const handleSearchChange = (value)=>{
        setCalculatingList(true);
        setSearchValue(value);
        filterNationalities(value);
    };
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "JobDraftNationalities",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                className: "Popup__title",
                children: t("job_draft_details.nationalities_title")
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                className: "Popup__subtitle",
                style: {
                    marginBottom: "20px"
                },
                children: t("job_draft_details.nationalities_subtitle")
            }),
            nationalitiesLoading ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $57fb8f45c69e1681$export$b08b517936747730), {}) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        style: {
                            display: "flex",
                            justifyContent: "space-between",
                            marginBottom: "56px",
                            width: "100%",
                            paddingRight: "10px"
                        },
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                style: {
                                    marginRight: "10px"
                                },
                                className: "JobField__label",
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                    children: t("job_draft_details.nationalities_option_any")
                                })
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $d931e957e209e988$export$bea8ebba691c5813), {
                                active: Boolean(job.nationalities.allow_any_nationality),
                                onToggle: ()=>{
                                    if (!job.nationalities.allow_any_nationality) {
                                        job.nationalities.setNationalities([]);
                                        job.nationalities.setEthnicities([]);
                                    }
                                    job.nationalities.setAllowAnyNationality(!job.nationalities.allow_any_nationality);
                                }
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $db7fb73ce5c45471$export$55d7609a8f1eccd2), {
                        value: searchValue,
                        handleValueChange: handleSearchChange,
                        className: "JobDraftNationalities__searchContainer"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $660b2ca422e0e2ae$export$1ff3c3f08ae963c0).Vertical, {
                        height: 18
                    }),
                    calculatingListDebounced ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $57fb8f45c69e1681$export$b08b517936747730), {}) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: `JobDraftNationalities__list ${job.nationalities.hasError ? "error" : ""}`,
                        children: filteredNationalities.map((nationality, idx)=>{
                            const selected = nationality.is_ethnicity ? job.nationalities.hasEthnicity(nationality.id) : job.nationalities.hasNationality(nationality.id);
                            return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                onClick: ()=>{
                                    if (selected) nationality.is_ethnicity ? job.nationalities.removeEthnicity(nationality.id) : job.nationalities.removeNationality(nationality.id);
                                    else nationality.is_ethnicity ? job.nationalities.addEthnicity(nationality.id) : job.nationalities.addNationality(nationality.id);
                                    job.nationalities.setAllowAnyNationality(job.nationalities.nationalities_list?.length === 0 && job.nationalities.ethnicities_list?.length === 0);
                                },
                                className: "JobDraftNationalities__list__item",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                        className: "JobDraftNationalities__list__item__label",
                                        children: nationality.name
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f224f10e61e1d993$export$48513f6b9f8ce62d), {
                                        isActive: selected,
                                        type: "square"
                                    })
                                ]
                            }, idx);
                        })
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $17a27c6ba7085f84$export$57b95d3630b174f6), {
                        error: job.nationalities.error
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $660b2ca422e0e2ae$export$1ff3c3f08ae963c0).Vertical, {
                        height: 20
                    })
                ]
            })
        ]
    });
});


const $447f5bfc313f8cd4$export$f6edbf2e679213e6 = {
    [(0, $39b712c8a7a8ea7b$export$21cdfbdd9a861522).category]: (params)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $22bb2188f5a9f92c$export$1737dc01b3801c1c), {
            orderId: params.orderId
        }),
    [(0, $39b712c8a7a8ea7b$export$21cdfbdd9a861522).quantity]: (params)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $025e95aa4dd8f3fb$export$c8c1fd9e22ee3cee), {
            job: params.job
        }),
    [(0, $39b712c8a7a8ea7b$export$21cdfbdd9a861522).location]: (params)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $79ae7b4dc9946e5d$export$18a2be9195644f38), {
            locationFormRef: params.locationFormRef,
            onLocationsLoaded: params.onLocationsLoaded,
            onLocationFormSubmit: params.onLocationFormSubmit,
            job: params.job
        }),
    [(0, $39b712c8a7a8ea7b$export$21cdfbdd9a861522).transport]: (params)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $838a1b1b94c93ccd$export$f63ff7dda214a193), {
            job: params.job
        }),
    [(0, $39b712c8a7a8ea7b$export$21cdfbdd9a861522).dateBoundaries]: (params)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $eab194591fb32a95$export$41c3ac8c866f31c8), {
            job: params.job
        }),
    [(0, $39b712c8a7a8ea7b$export$21cdfbdd9a861522).scheduleType]: (params)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $d56d7ed0bcb79ff3$export$38e26ec75b48a88c), {
            job: params.job
        }),
    [(0, $39b712c8a7a8ea7b$export$21cdfbdd9a861522).sameOrDynamicTimingPrompt]: (params)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $18a426bf53367ec3$export$f699ec9d9cdde0e8), {
            job: params.job
        }),
    [(0, $39b712c8a7a8ea7b$export$21cdfbdd9a861522).sameTimeSchedule]: (params)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $72f29f4c6d53e550$export$f5412888a2b559de), {
            job: params.job
        }),
    [(0, $39b712c8a7a8ea7b$export$21cdfbdd9a861522).daysSelect]: (params)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $82e0ba380521c909$export$8808b6ffa95336f5), {
            job: params.job
        }),
    [(0, $39b712c8a7a8ea7b$export$21cdfbdd9a861522).requirements]: (params)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $2e3ce341f392f6fa$export$2799cbee04377fe0), {
            job: params.job
        }),
    [(0, $39b712c8a7a8ea7b$export$21cdfbdd9a861522).description]: (params)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $9016c58210bf8902$export$393edc798c47379d), {
            job: params.job
        }),
    [(0, $39b712c8a7a8ea7b$export$21cdfbdd9a861522).contact]: (params)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $3c795d328a124550$export$1a3a3c76d9d50b4e), {
            job: params.job
        }),
    [(0, $39b712c8a7a8ea7b$export$21cdfbdd9a861522).experience]: (params)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $72b0f3bbb42b9e27$export$c1928f0d366d76b4), {
            job: params.job
        }),
    [(0, $39b712c8a7a8ea7b$export$21cdfbdd9a861522).dresscode]: (params)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $0764795ac2d83f66$export$edbf66947951d8cd), {
            job: params.job
        }),
    [(0, $39b712c8a7a8ea7b$export$21cdfbdd9a861522).invitedSPs]: (params)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c5d46928546d4215$export$1b81d4c3af05f916), {
            job: params.job
        }),
    [(0, $39b712c8a7a8ea7b$export$21cdfbdd9a861522).preferences]: (params)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $67b8edc2d024d58e$export$208128cc8fac67), {
            job: params.job
        }),
    [(0, $39b712c8a7a8ea7b$export$21cdfbdd9a861522).languages]: (params)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $deb1048343eb7fb9$export$b01264a27da24c0a), {
            job: params.job
        }),
    [(0, $39b712c8a7a8ea7b$export$21cdfbdd9a861522).gender]: (params)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $2d0b9b995996d6bc$export$89930abb48c00f4c), {
            job: params.job
        }),
    [(0, $39b712c8a7a8ea7b$export$21cdfbdd9a861522).documents]: (params)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $db1ab873301a1a9e$export$f8ef8592b4a3f47d), {
            job: params.job
        }),
    [(0, $39b712c8a7a8ea7b$export$21cdfbdd9a861522).videoInterviews]: (params)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $8d357fa21b490d66$export$4fc38861141999c0), {
            job: params.job
        }),
    [(0, $39b712c8a7a8ea7b$export$21cdfbdd9a861522).accreditation]: (params)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $60b1156ab371b627$export$54f4bb4787193dec), {
            job: params.job
        }),
    [(0, $39b712c8a7a8ea7b$export$21cdfbdd9a861522).boarding]: (params)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $a579d3778586e181$export$56a762fdc756caea), {
            job: params.job
        }),
    [(0, $39b712c8a7a8ea7b$export$21cdfbdd9a861522).nationalities]: (params)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $19ca424d8b5d86aa$export$58cabd1a782b8999), {
            job: params.job
        }),
    [(0, $39b712c8a7a8ea7b$export$21cdfbdd9a861522).accommodation]: ()=>null
};
const $447f5bfc313f8cd4$export$7d925dbb3e2c8021 = (key, params)=>{
    return $447f5bfc313f8cd4$export$f6edbf2e679213e6[key](params);
};








const $38509c18096ca465$export$a765b9dee96eca0e = ({ stepsCount: stepsCount, currentStepNumber: currentStepNumber })=>{
    const { t: t } = (0, $3765cebd031b52c0$export$9fc83ad70ead8663)();
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "StepIndicator__container",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "StepIndicator__stepNumber",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                    className: "StepIndicator__stepNumber__content",
                    children: t("step_indicator.step_of", {
                        currentStepNumber: currentStepNumber,
                        stepsCount: stepsCount
                    })
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "StepIndicator__steps",
                children: new Array(stepsCount).fill(undefined).map((_, index)=>{
                    const stepNumber = index + 1;
                    const isCurrentStep = stepNumber === currentStepNumber;
                    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "StepIndicator__stepContainer",
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                            className: `StepIndicator__step${isCurrentStep ? " StepIndicator__step--current" : ""}`,
                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                className: "StepIndicator__step__content",
                                children: stepNumber
                            })
                        })
                    }, index);
                })
            })
        ]
    });
};




var $5a928b40020c6085$exports = {};
$5a928b40020c6085$exports = new URL("user-icon.87e114c4.svg", import.meta.url).toString();




const $7aaa88adae16798b$var$MINIMUM_JOBS_COUNT_TO_SHOW_COUNTER = 2;
const $7aaa88adae16798b$export$ae1f41282e6c81da = ({ jobsCount: jobsCount, orderId: orderId })=>{
    const redirect = (0, $7df35e9df335b1c8$export$602eaf6d5314ce55)();
    if (jobsCount < $7aaa88adae16798b$var$MINIMUM_JOBS_COUNT_TO_SHOW_COUNTER) return null;
    const disabled = !orderId;
    const clickHandler = ()=>{
        if (disabled) return;
        redirect((0, $0534349ae8731d0b$export$66b32f6f30eb4b4).orderDraft, {
            orderId: String(orderId)
        });
    };
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        onClick: clickHandler,
        className: `HeaderJobsCounter__container${disabled ? " disabled" : ""}`,
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                src: (0, (/*@__PURE__*/$parcel$interopDefault($5a928b40020c6085$exports)))
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "HeaderJobsCounter__circle",
                children: jobsCount
            })
        ]
    });
};








const $cba7d27db0d4ac88$var$stepIndicatorConfig = {
    stepsCount: 4,
    currentStepNumber: 3
};
/**
 * TODO: - refactor Field components into subcomponents managing it's own logic
 *       - move popupField/setPopupField to job store
 */ function $cba7d27db0d4ac88$var$JobDraftDetailsFormUIComponent({ orderId: orderId, formTitle: formTitle, formSubtitle: formSubtitle, isLoading: isLoading, isSubmitting: isSubmitting, job: job, onSubmit: onSubmit, professionName: professionName, publicTransportAccessibilityName: publicTransportAccessibilityName, openField: openField, daysLabel: daysLabel, workCategoryRequirementsNames: workCategoryRequirementsNames, experienceName: experienceName, uniformName: uniformName, contactFullName: contactFullName, invitedSPsNames: invitedSPsNames, optionalFieldsLabels: optionalFieldsLabels, languagesNames: languagesNames, nationalitiesNames: nationalitiesNames, genderName: genderName, jobDocumentsNames: jobDocumentsNames, interviewQuestions: interviewQuestions, formActions: formActions, popupField: popupField, setPopupField: setPopupField, formComponentsParams: formComponentsParams, currentStep: currentStep, stepsLength: stepsLength, isStepDisabled: isStepDisabled, handleNextPress: handleNextPress, handleBackPress: handleBackPress, formBottomRef: formBottomRef, showStepIndicator: showStepIndicator, stepNumber: stepNumber, jobsCount: jobsCount, isPrefilled: isPrefilled }) {
    const { t: t } = (0, $3765cebd031b52c0$export$9fc83ad70ead8663)();
    const [showFilledAlert, setShowFilledAlert] = (0, $acw62.useState)(false);
    (0, $acw62.useEffect)(()=>{
        if (Boolean(isPrefilled)) {
            setShowFilledAlert(true);
            (0, $c74a0566d4b0fd6d$export$e9db7d6e73593439).track((0, $c74a0566d4b0fd6d$export$5e27155e276f6d1c).HiringJobWasPrefilled);
        }
    }, [
        isPrefilled
    ]);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "JobDraftDetails",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7ae42b63183f30b4$export$8b251419efc915eb), {
                title: formTitle,
                rightComponent: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7aaa88adae16798b$export$ae1f41282e6c81da), {
                    jobsCount: Number(jobsCount),
                    orderId: orderId
                }),
                showBack: true
            }),
            (job.schedule.sameTimeSchedule.is_less_than_24h ?? job.schedule.distinctTimeSchedule.isLessThan24Hours) && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7a26230deaaf6920$export$944fe0ec49485b21), {
                theme: (0, $7a26230deaaf6920$export$14faa19a0f3bbeb2).Orange,
                title: t("job_draft_details.less_than_24h_warning"),
                action: ()=>{},
                isActionInProgress: false,
                withCloseButton: false,
                style: {
                    marginTop: "50px"
                }
            }),
            isLoading ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $57fb8f45c69e1681$export$2e2bcd8739ae039), {}) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $660b2ca422e0e2ae$export$1ff3c3f08ae963c0).Vertical, {
                        height: 35
                    }),
                    showStepIndicator && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $38509c18096ca465$export$a765b9dee96eca0e), {
                        stepsCount: $cba7d27db0d4ac88$var$stepIndicatorConfig.stepsCount,
                        currentStepNumber: stepNumber ?? $cba7d27db0d4ac88$var$stepIndicatorConfig.currentStepNumber
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                        className: "JobDraftDetails__title",
                        children: formSubtitle
                    }),
                    showFilledAlert && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "JobDraftDetails__filledAlert",
                        onClick: ()=>{
                            job.clear();
                            setShowFilledAlert(false);
                            (0, $c74a0566d4b0fd6d$export$e9db7d6e73593439).track((0, $c74a0566d4b0fd6d$export$5e27155e276f6d1c).HiringPrefilledJobWasCleared);
                        },
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                children: t("job_draft_details.job_was_prefilled")
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                children: t("common.clear")
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $660b2ca422e0e2ae$export$1ff3c3f08ae963c0).Vertical, {
                        height: 16
                    }),
                    job.fields.hasField((0, $39b712c8a7a8ea7b$export$21cdfbdd9a861522).category) && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4051a7847249a4a4$export$a455218a85c89869), {
                        content: job.category.id ? professionName : null,
                        placeholder: t("job_draft_details.staff"),
                        onPress: ()=>openField((0, $39b712c8a7a8ea7b$export$21cdfbdd9a861522).category),
                        error: job.category.error
                    }),
                    job.fields.hasField((0, $39b712c8a7a8ea7b$export$21cdfbdd9a861522).requirements) && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4051a7847249a4a4$export$a455218a85c89869), {
                        content: workCategoryRequirementsNames,
                        placeholder: t("job_draft_details.requirements"),
                        onPress: ()=>openField((0, $39b712c8a7a8ea7b$export$21cdfbdd9a861522).requirements),
                        error: job.requirements.error
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4051a7847249a4a4$export$a455218a85c89869), {
                        content: job.quantity.value !== null ? String(job.quantity.value) : null,
                        placeholder: t("job_draft_details.quantity"),
                        onPress: ()=>openField((0, $39b712c8a7a8ea7b$export$21cdfbdd9a861522).quantity),
                        error: job.quantity.error
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "JobDraftDetails__row",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4051a7847249a4a4$export$a455218a85c89869), {
                                content: job.schedule.dateBoundaries.start_date ? (0, $ddf12117b815a7c3$export$f169b154f61f164e)(job.schedule.dateBoundaries.start_date) : null,
                                placeholder: t("job_draft_details.start_date"),
                                onPress: ()=>openField((0, $39b712c8a7a8ea7b$export$21cdfbdd9a861522).dateBoundaries),
                                error: job.schedule.dateBoundaries.start_date_error
                            }),
                            job.schedule.dateBoundaries.open_ended !== true && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $660b2ca422e0e2ae$export$1ff3c3f08ae963c0).Horizontal, {
                                        width: 11
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4051a7847249a4a4$export$a455218a85c89869), {
                                        content: job.schedule.dateBoundaries.end_date ? (0, $ddf12117b815a7c3$export$f169b154f61f164e)(job.schedule.dateBoundaries.end_date) : null,
                                        placeholder: t("job_draft_details.end_date"),
                                        onPress: ()=>openField((0, $39b712c8a7a8ea7b$export$21cdfbdd9a861522).dateBoundaries),
                                        error: job.schedule.dateBoundaries.end_date_or_open_ended_error
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4051a7847249a4a4$export$a455218a85c89869), {
                        content: daysLabel,
                        placeholder: t("job_draft_details.days"),
                        onPress: ()=>{
                            openField((0, $39b712c8a7a8ea7b$export$21cdfbdd9a861522).daysSelect);
                        },
                        error: job.schedule.anyScheduleError
                    }),
                    job.schedule.sameTimeSchedule.allDaysHaveSameTime && job.schedule.sameTimeSchedule.same_start_time && job.schedule.sameTimeSchedule.same_end_time && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "JobDraftDetails__row",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4051a7847249a4a4$export$a455218a85c89869), {
                                content: job.schedule.sameTimeSchedule.same_start_time,
                                placeholder: t("job_draft_details.start_time"),
                                onPress: ()=>openField((0, $39b712c8a7a8ea7b$export$21cdfbdd9a861522).sameTimeSchedule),
                                error: job.schedule.sameTimeSchedule.same_start_time_error
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $660b2ca422e0e2ae$export$1ff3c3f08ae963c0).Horizontal, {
                                width: 11
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4051a7847249a4a4$export$a455218a85c89869), {
                                content: job.schedule.sameTimeSchedule.same_end_time,
                                placeholder: t("job_draft_details.end_time"),
                                onPress: ()=>openField((0, $39b712c8a7a8ea7b$export$21cdfbdd9a861522).sameTimeSchedule),
                                error: job.schedule.sameTimeSchedule.same_end_time_error
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4051a7847249a4a4$export$a455218a85c89869), {
                        content: job.description.value,
                        placeholder: t("job_draft_details.job_description"),
                        onPress: ()=>openField((0, $39b712c8a7a8ea7b$export$21cdfbdd9a861522).description),
                        error: job.description.error
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4051a7847249a4a4$export$a455218a85c89869), {
                        content: experienceName,
                        placeholder: t("job_draft_details.experience"),
                        onPress: ()=>openField((0, $39b712c8a7a8ea7b$export$21cdfbdd9a861522).experience),
                        error: job.experience.error
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4051a7847249a4a4$export$a455218a85c89869), {
                        content: uniformName,
                        placeholder: t("job_draft_details.dresscode"),
                        onPress: ()=>openField((0, $39b712c8a7a8ea7b$export$21cdfbdd9a861522).dresscode),
                        error: job.dresscode.error
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4051a7847249a4a4$export$a455218a85c89869), {
                        content: contactFullName,
                        placeholder: t("job_draft_details.point_of_contact"),
                        onPress: ()=>openField((0, $39b712c8a7a8ea7b$export$21cdfbdd9a861522).contact),
                        error: job.manager.error
                    }),
                    job.fields.hasField((0, $39b712c8a7a8ea7b$export$21cdfbdd9a861522).invitedSPs) && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4051a7847249a4a4$export$a455218a85c89869), {
                        content: invitedSPsNames,
                        placeholder: t("invited_sps.invited_sps"),
                        onPress: ()=>openField((0, $39b712c8a7a8ea7b$export$21cdfbdd9a861522).invitedSPs),
                        error: job.invitedSPs.error
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4051a7847249a4a4$export$a455218a85c89869), {
                        content: optionalFieldsLabels,
                        placeholder: t("job_draft_details.additional_preferences"),
                        onPress: ()=>openField((0, $39b712c8a7a8ea7b$export$21cdfbdd9a861522).preferences)
                    }),
                    job.languages.use_languages && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4051a7847249a4a4$export$a455218a85c89869), {
                        content: languagesNames,
                        placeholder: t("job_draft_details.languages"),
                        onPress: ()=>openField((0, $39b712c8a7a8ea7b$export$21cdfbdd9a861522).languages),
                        error: job.languages.error
                    }),
                    job.gender.use_gender && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4051a7847249a4a4$export$a455218a85c89869), {
                        content: genderName,
                        placeholder: t("job_draft_details.gender"),
                        onPress: ()=>openField((0, $39b712c8a7a8ea7b$export$21cdfbdd9a861522).gender),
                        error: job.gender.error
                    }),
                    job.documents.use_documents && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4051a7847249a4a4$export$a455218a85c89869), {
                        content: jobDocumentsNames,
                        placeholder: t("job_draft_details.additional_documents"),
                        onPress: ()=>openField((0, $39b712c8a7a8ea7b$export$21cdfbdd9a861522).documents),
                        error: job.documents.error
                    }),
                    job.manualSelection.use_interview && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4051a7847249a4a4$export$a455218a85c89869), {
                        content: interviewQuestions,
                        placeholder: t("job_draft_details.preferences_interview"),
                        onPress: ()=>openField((0, $39b712c8a7a8ea7b$export$21cdfbdd9a861522).videoInterviews),
                        error: job.manualSelection.interview_error
                    }),
                    job.accreditation.use_accreditation && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4051a7847249a4a4$export$a455218a85c89869), {
                        content: job.accreditation.value === null ? "" : job.accreditation.value ? t("job_draft_details.accreditation_yes") : t("job_draft_details.accreditation_no"),
                        placeholder: t("job_draft_details.accreditation"),
                        onPress: ()=>openField((0, $39b712c8a7a8ea7b$export$21cdfbdd9a861522).accreditation),
                        error: job.accreditation.error
                    }),
                    job.accommodation.use_accommodation && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4051a7847249a4a4$export$a455218a85c89869), {
                        content: job.accommodation.value === null ? "" : job.accommodation.value ? t("job_draft_details.accommodation_yes") : t("job_draft_details.accommodation_no"),
                        placeholder: t("job_draft_details.preferences_accommodation_offered"),
                        onPress: ()=>openField((0, $39b712c8a7a8ea7b$export$21cdfbdd9a861522).preferences),
                        error: job.accommodation.error
                    }),
                    job.boarding.use_boarding && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4051a7847249a4a4$export$a455218a85c89869), {
                        content: job.boarding.value === null ? "" : (0, $88855a758cfdd8b4$export$b8ac4e99d51e17e1)(job.boarding.value),
                        placeholder: t("job_draft_details.preferences_boarding_offered"),
                        onPress: ()=>openField((0, $39b712c8a7a8ea7b$export$21cdfbdd9a861522).boarding),
                        error: job.boarding.error
                    }),
                    job.nationalities.use_nationalities && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4051a7847249a4a4$export$a455218a85c89869), {
                        content: nationalitiesNames,
                        placeholder: t("job_draft_details.nationalities"),
                        onPress: ()=>openField((0, $39b712c8a7a8ea7b$export$21cdfbdd9a861522).nationalities),
                        error: job.nationalities.error
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $17a27c6ba7085f84$export$57b95d3630b174f6), {
                        error: job.error
                    }),
                    formActions ?? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $660b2ca422e0e2ae$export$1ff3c3f08ae963c0).Vertical, {
                                height: 36
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $2ab88429e3384d30$export$353f5b6fc5456de1), {
                                disabled: job.is_validating_form || isSubmitting,
                                title: job.is_validating_form ? t("job_draft_details.submitting") : t("job_draft_details.save"),
                                type: "button",
                                className: "JobDraftDetails__submitButton",
                                onClick: ()=>{
                                    const isValid = job.validateForm();
                                    if (isValid) onSubmit();
                                }
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        ref: formBottomRef
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $660b2ca422e0e2ae$export$1ff3c3f08ae963c0).Vertical, {
                        height: 42
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $9c16b10bbbe042e5$export$129a32eedafa97c5), {
                isActive: popupField !== null,
                close: ()=>{
                    setPopupField(null);
                },
                content: popupField ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                    children: [
                        (0, $447f5bfc313f8cd4$export$7d925dbb3e2c8021)(popupField, formComponentsParams),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $660b2ca422e0e2ae$export$1ff3c3f08ae963c0).Vertical, {
                            height: 20
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $9dfc32a0a996fa14$export$ed8ca599049e8881), {
                            currentStep: currentStep,
                            stepsCount: stepsLength,
                            backDisabled: currentStep === 0,
                            nextDisabled: isStepDisabled,
                            handleNextPress: handleNextPress,
                            handleBackPress: handleBackPress,
                            nextButtonLabel: currentStep === stepsLength - 1 ? t("job_draft_details.finish") : t("job_draft_details.next"),
                            className: "JobDraftDetails__stepper"
                        })
                    ]
                }) : null
            })
        ]
    });
}
const $cba7d27db0d4ac88$export$d97c399809c98416 = (0, $aca50e9407ba89c9$export$b6ae1bc530f4c149)($cba7d27db0d4ac88$var$JobDraftDetailsFormUIComponent);


const $a65bc1b27fa6c508$export$3f3206c79d29743e = (0, $ba63e4b5847b0648$export$69d0320343b717bf)((0, $cba7d27db0d4ac88$export$d97c399809c98416));






/* eslint-disable @typescript-eslint/no-non-null-assertion */ 
var $45fvw = parcelRequire("45fvw");

var $4f362 = parcelRequire("4f362");










const $957237d860259090$export$1cb3d75b28286c28 = (id)=>{
    switch(id){
        case 1:
            return (0, $9940b994a7a3bcd1$export$87cdbc5104bfce47).male;
        case 2:
            return (0, $9940b994a7a3bcd1$export$87cdbc5104bfce47).female;
        default:
            return null;
    }
};
const $957237d860259090$export$54e37c44dc5bfc74 = (job)=>{
    const weekdays = (0, (/*@__PURE__*/$parcel$interopDefault($45fvw))).weekdaysShort();
    // @ts-ignore
    const momentRange = (0, $3c5155092adf0860$exports.extendMoment)((0, (/*@__PURE__*/$parcel$interopDefault($45fvw))));
    const getAllDaysHaveSameTime = (intervals, firstInterval)=>{
        if (!firstInterval) return null;
        return !intervals.find((item)=>item.start_time !== firstInterval.start_time || item.end_time !== firstInterval.end_time);
    };
    const intervalsArray = Array.from(job.intervals?.values() ?? []);
    const firstInterval = intervalsArray[0] ?? null;
    const allDaysHaveSameTime = getAllDaysHaveSameTime(intervalsArray, firstInterval);
    const sameStartTime = allDaysHaveSameTime ? firstInterval.start_time.slice(0, 5) : null;
    const sameEndTime = allDaysHaveSameTime ? firstInterval.end_time.slice(0, 5) : null;
    const fields = [
        ...(0, $39b712c8a7a8ea7b$export$164345136e266caa).filter((field)=>{
            return (0, $73ccb33f5de6f5aa$export$8707029d024490c9)().order.includePublicTransportationField || field !== (0, $39b712c8a7a8ea7b$export$21cdfbdd9a861522).transport;
        })
    ];
    const fieldsToPaste = allDaysHaveSameTime ? (0, $c8d84e5894c5bfbd$export$e5b094170864a75f) : (0, $c8d84e5894c5bfbd$export$48f94b164c9d6cc2);
    const insertToIndex = fields.findIndex((field)=>field === (0, $39b712c8a7a8ea7b$export$21cdfbdd9a861522).sameOrDynamicTimingPrompt) + 1;
    fields.splice(insertToIndex, 0, ...fieldsToPaste);
    if (job.filter.languages) fields.push((0, $39b712c8a7a8ea7b$export$21cdfbdd9a861522).languages);
    if (job.filter.gender) fields.push((0, $39b712c8a7a8ea7b$export$21cdfbdd9a861522).gender);
    if (job.filter.certificates) fields.push((0, $39b712c8a7a8ea7b$export$21cdfbdd9a861522).documents);
    if (job.is_accreditation_required === 1) fields.push((0, $39b712c8a7a8ea7b$export$21cdfbdd9a861522).accreditation);
    if (job.boarding_type !== 0) fields.push((0, $39b712c8a7a8ea7b$export$21cdfbdd9a861522).boarding);
    if (job.filter.nationalities) fields.push((0, $39b712c8a7a8ea7b$export$21cdfbdd9a861522).nationalities);
    const isWeeklyType = weekdays.includes(job.intervals?.keys().next().value);
    const getScheduleType = ()=>{
        if (isWeeklyType) return (0, $a4e7aca7274b573e$export$38e26ec75b48a88c).weekly;
        return (0, $a4e7aca7274b573e$export$38e26ec75b48a88c).daily;
    };
    const getDates = ()=>{
        const dates = {};
        // handle weekly type ('Sun', 'Mon', ...)
        if (isWeeklyType) {
            weekdays.forEach((weekday)=>{
                const weekdayIncluded = job.intervals?.has(weekday);
                dates[weekday] = {
                    start_time: weekdayIncluded ? job.intervals?.get(weekday).start_time.slice(0, 5) ?? null : null,
                    end_time: weekdayIncluded ? job.intervals?.get(weekday).end_time.slice(0, 5) ?? null : null,
                    selected: weekdayIncluded ?? false,
                    start_time_error: null,
                    end_time_error: null,
                    is_less_than_24h: false
                };
            });
            return dates;
        }
        // handle different type
        const jobMomentStartDate = (0, (/*@__PURE__*/$parcel$interopDefault($45fvw)))(job.start_date, "YYYY-MM-DD");
        const jobMomentEndDate = (0, (/*@__PURE__*/$parcel$interopDefault($45fvw)))(job.end_date, "YYYY-MM-DD");
        const dateRanges = momentRange.range(jobMomentStartDate, jobMomentEndDate);
        for (const date of dateRanges.by("days")){
            const formatted = date.format("YYYY-MM-DD");
            const hasDate = job.intervals?.has(formatted);
            dates[formatted] = {
                start_time: hasDate ? job.intervals?.get(formatted).start_time.slice(0, 5) ?? null : null,
                end_time: hasDate ? job.intervals?.get(formatted).end_time.slice(0, 5) ?? null : null,
                selected: hasDate ?? false,
                start_time_error: null,
                end_time_error: null,
                is_less_than_24h: false
            };
        }
        return dates;
    };
    return {
        existing_job_id: job.id,
        duplicated_job_id: null,
        fields: {
            list: fields
        },
        category: {
            id: job.work_category_id,
            error: null
        },
        quantity: {
            value: job.quantity,
            error: null
        },
        transport: {
            value: job.public_transport_accessibility,
            error: null
        },
        location: {
            value: {
                id: job.client_location_id,
                name: job.client_location_name
            },
            error: null
        },
        schedule: {
            dateBoundaries: {
                start_date: job.start_date,
                start_date_error: null,
                end_date: job.end_date,
                open_ended: Boolean(job.is_recurring),
                end_date_or_open_ended_error: null
            },
            scheduleType: {
                value: getScheduleType(),
                error: null
            },
            sameTimeSchedule: {
                all_days_have_same_time: allDaysHaveSameTime,
                all_days_have_same_time_error: null,
                same_end_time: sameEndTime,
                same_start_time_error: null,
                same_start_time: sameStartTime,
                same_end_time_error: null,
                is_less_than_24h: false
            },
            distinctTimeSchedule: {
                map: getDates(),
                error: null
            }
        },
        requirements: {
            list: (0, $4f362.toJS)(job.work_requirement_ids),
            error: null
        },
        description: {
            value: job.instructions,
            error: null
        },
        manager: {
            id: job.contact_user_id,
            error: null
        },
        experience: {
            value: job.seniority_level === 1 ? (0, $f62ebabca0bf67f2$export$c90b54e658fc4d7c).junior : job.seniority_level === 2 ? (0, $f62ebabca0bf67f2$export$c90b54e658fc4d7c).middle : job.seniority_level === 3 ? (0, $f62ebabca0bf67f2$export$c90b54e658fc4d7c).senior : (0, $f62ebabca0bf67f2$export$c90b54e658fc4d7c).beginnerOrStudent,
            error: null
        },
        dresscode: {
            id: job.uniform_id,
            error: null
        },
        languages: {
            list: (0, $4f362.toJS)(job.filter.languages),
            use_languages: Boolean(job.filter.languages),
            error: null
        },
        gender: {
            value: $957237d860259090$export$1cb3d75b28286c28(job.filter.gender),
            use_gender: Boolean(job.filter.gender),
            error: null
        },
        documents: {
            list: (0, $4f362.toJS)(job.filter.certificates),
            use_documents: Boolean(job.filter.certificates),
            error: null
        },
        manualSelection: {
            use_manual_selection: true,
            manual_selection: job.assignment_type.toString(),
            use_interview: Boolean(job.is_interview_required),
            interview_questions: null,
            interview_error: null,
            manual_selection_error: null
        },
        accreditation: {
            value: Boolean(job.is_accreditation_required),
            use_accreditation: Boolean(job.is_accreditation_required),
            error: null
        },
        accommodation: {
            value: Boolean(job.is_accommodation_offered),
            use_accommodation: Boolean(job.is_accommodation_offered),
            error: null
        },
        boarding: {
            value: job.boarding_type,
            use_boarding: job.boarding_type !== (0, $862a04ca6e0d681b$export$3456ae8ade9eb8c).noBoarding,
            error: null
        },
        nationalities: {
            nationalities_list: (0, $4f362.toJS)(job.filter.nationalities),
            ethnicities_list: [],
            allow_any_nationality: !Boolean(job.filter.nationalities?.length),
            use_nationalities: Boolean(job.filter.nationalities),
            error: null
        },
        is_validating_form: false,
        is_automatic_checkout: 1,
        error: null,
        invitedSPs: {
            list: (0, $4f362.toJS)(job.invited_sp_ids),
            error: null
        }
    };
};
const $957237d860259090$export$d9b822eccad2c4b0 = (job)=>{
    const draftJobData = $957237d860259090$export$54e37c44dc5bfc74(job);
    const jobDraftId = (0, $3fa3ae484854b431$export$2e2bcd8739ae039)();
    return (0, $dbd014043758bf06$export$dc71f78f25dc8d5)({
        ...draftJobData,
        id: jobDraftId
    });
};


const $5a954f40174a984b$export$78108cd43e2ad049 = /*#__PURE__*/ (0, $acw62.createContext)(null);
const $5a954f40174a984b$export$b20ecfb08c3bb285 = (0, $a4963babae245ff9$export$f0c7a449e0cfaec7)((0, $aca50e9407ba89c9$export$b6ae1bc530f4c149)(({ orderId: orderId, draftJobId: draftJobId, activePopupField: activePopupField, stepNumber: stepNumber, isExtension: isExtension })=>{
    const { t: t } = (0, $3765cebd031b52c0$export$9fc83ad70ead8663)();
    const { getDraftJob: getDraftJob } = (0, $d6286036be37a1b2$export$6feca3f67f446ef2)();
    const { getLastJob: getLastJob } = (0, $4671947198ddd366$export$6ccbb43953eebf8)().data;
    const job = getDraftJob(draftJobId);
    const [isPrefilled, setIsPrefilled] = (0, $acw62.useState)(false);
    const [, getLastJobQuery] = (0, $4671947198ddd366$export$609860bf8b0084c)(({ locationId: locationId, workCategoryId: workCategoryId })=>getLastJob(locationId, workCategoryId), {
        onSuccess: (result)=>{
            const lastJob = result.map((item)=>{
                const jobDetails = (0, $487f9fae786cd5fa$export$4970faf62e67ab48).create(item);
                return (0, $957237d860259090$export$d9b822eccad2c4b0)(jobDetails);
            })[0] ?? null;
            if (lastJob) {
                job.fillBasedOnTemplateJob(lastJob);
                setIsPrefilled(true);
            }
        }
    });
    (0, $acw62.useEffect)(()=>{
        const locationId = job.location.value?.id;
        const workCategoryId = job.category.id;
        if (locationId && workCategoryId) getLastJobQuery({
            locationId: locationId,
            workCategoryId: workCategoryId
        });
    }, [
        job.location.value?.id,
        job.category.id
    ]);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($5a954f40174a984b$export$78108cd43e2ad049.Provider, {
        value: job,
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $a65bc1b27fa6c508$export$3f3206c79d29743e), {
            isExtension: isExtension,
            orderId: orderId,
            orderDraftTitle: t("order_draft.title"),
            formSubtitle: t("job_draft_details.fill_job_details"),
            activePopupField: activePopupField,
            job: job,
            getFormTitle: (professionName)=>{
                return t("job_draft_details.title", {
                    category: professionName
                });
            },
            showStepIndicator: true,
            stepNumber: Number(stepNumber),
            isPrefilled: isPrefilled
        })
    });
}));






var $acw62 = parcelRequire("acw62");






var $6dd5c456119c9fc9$exports = {};
$6dd5c456119c9fc9$exports = new URL("arrow.b7935169.svg", import.meta.url).toString();




const $2378c40a8cf67257$var$stepIndicatorConfig = {
    stepsCount: 4,
    currentStepNumber: 1
};
const $2378c40a8cf67257$export$72cbc7178e72e13f = (0, $aca50e9407ba89c9$export$b6ae1bc530f4c149)(({ handleSelection: handleSelection, title: title, subtitle: subtitle, header: header, showStepIndicator: showStepIndicator = false, stepNumber: stepNumber })=>{
    const [searchValue, setSearchValue] = (0, $acw62.useState)("");
    const [calculatingList, setCalculatingList] = (0, $acw62.useState)(false);
    const [filteredCategories, setFilteredCategories] = (0, $acw62.useState)([]);
    const { professionList: professionList, getProfessions: getProfessions } = (0, $4671947198ddd366$export$6ccbb43953eebf8)().data;
    const { query: { isLoading: professionsLoading }, enableQuery: loadProfessions } = (0, $4671947198ddd366$export$517ca4f7fee4e226)(()=>getProfessions({}));
    (0, $acw62.useEffect)(()=>{
        loadProfessions();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    (0, $acw62.useEffect)(()=>{
        if (professionList.length > 0) setFilteredCategories(professionList);
    }, [
        professionList,
        professionList.length
    ]);
    const filterCategories = (0, $85953efa7e00ce5b$export$2e2bcd8739ae039)((value)=>{
        setFilteredCategories(professionList.filter((item)=>item.name.toLowerCase().includes(value.toLowerCase())));
        setCalculatingList(false);
    }, 500);
    const [calculatingListDebounced] = (0, $28cfa09e9775cf8c$export$2e2bcd8739ae039)(calculatingList, 300);
    const handleSearchChange = (value)=>{
        setCalculatingList(true);
        setSearchValue(value);
        filterCategories(value);
    };
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $acw62.Fragment), {
        children: [
            header,
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "JobDraftCategory",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $660b2ca422e0e2ae$export$1ff3c3f08ae963c0).Vertical, {
                        height: 24
                    }),
                    showStepIndicator && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $38509c18096ca465$export$a765b9dee96eca0e), {
                        stepsCount: $2378c40a8cf67257$var$stepIndicatorConfig.stepsCount,
                        currentStepNumber: stepNumber ?? $2378c40a8cf67257$var$stepIndicatorConfig.currentStepNumber
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                        className: "JobDraftCategory__title",
                        children: title
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                        className: "JobDraftCategory__subtitle",
                        children: subtitle
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $660b2ca422e0e2ae$export$1ff3c3f08ae963c0).Vertical, {
                        height: 24
                    }),
                    professionsLoading ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $57fb8f45c69e1681$export$b08b517936747730), {}) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $db7fb73ce5c45471$export$55d7609a8f1eccd2), {
                                value: searchValue,
                                handleValueChange: handleSearchChange
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $660b2ca422e0e2ae$export$1ff3c3f08ae963c0).Vertical, {
                                height: 16
                            }),
                            calculatingListDebounced ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $57fb8f45c69e1681$export$b08b517936747730), {}) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                className: "JobDraftCategory__list",
                                children: filteredCategories.map((profession)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        onClick: ()=>{
                                            handleSelection(profession.id);
                                        },
                                        className: "JobDraftCategory__list__row",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                className: "JobDraftCategory__list__row__left",
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                                                        src: profession.image,
                                                        className: "JobDraftCategory__list__row__image"
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                        className: "JobDraftCategory__list__row__title",
                                                        children: profession.name
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                                                src: (0, (/*@__PURE__*/$parcel$interopDefault($6dd5c456119c9fc9$exports))),
                                                className: "JobDraftCategory__list__row__img rtl-x-flipped"
                                            })
                                        ]
                                    }, profession.id))
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $660b2ca422e0e2ae$export$1ff3c3f08ae963c0).Vertical, {
                                height: 24
                            })
                        ]
                    })
                ]
            })
        ]
    });
});






const $22bb2188f5a9f92c$export$1737dc01b3801c1c = (0, $a4963babae245ff9$export$f0c7a449e0cfaec7)((0, $aca50e9407ba89c9$export$b6ae1bc530f4c149)(({ orderId: orderId, draftJobId: draftJobId, stepNumber: stepNumber })=>{
    const job = (0, $acw62.useContext)((0, $5a954f40174a984b$export$78108cd43e2ad049));
    const { getBasicOrderJobs: getBasicOrderJobs, getOrderSummary: getOrderSummary, getOrderIdSummary: getOrderIdSummary } = (0, $4671947198ddd366$export$6ccbb43953eebf8)().data;
    const orderSummary = getOrderIdSummary(String(orderId));
    const { enableQuery: getOrderSummaryQuery } = (0, $4671947198ddd366$export$517ca4f7fee4e226)(()=>getOrderSummary({
            orderId: String(orderId)
        }), {
        filterError: [
            (0, $9ad33fbf770c55a1$export$9696fcf1798e1cb5).ClientError
        ]
    });
    (0, $acw62.useEffect)(()=>{
        if (Boolean(orderId)) getOrderSummaryQuery();
    }, [
        orderId
    ]);
    const { createDraftJob: createDraftJob, getDraftJob: getDraftJob } = (0, $d6286036be37a1b2$export$6feca3f67f446ef2)();
    const redirect = (0, $7df35e9df335b1c8$export$602eaf6d5314ce55)();
    const { t: t } = (0, $3765cebd031b52c0$export$9fc83ad70ead8663)();
    const handleSelection = (id)=>{
        const draftJob = draftJobId ? getDraftJob(draftJobId) : createDraftJob();
        draftJob.category.set(id);
        redirect((0, $0534349ae8731d0b$export$66b32f6f30eb4b4).setJobLocation, {
            orderId: orderId,
            draftJobId: draftJob.id,
            stepNumber: "2"
        });
    };
    const orderHasJobs = Boolean(orderId ? getBasicOrderJobs(orderId).length : false);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5a954f40174a984b$export$78108cd43e2ad049).Provider, {
        value: job,
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $2378c40a8cf67257$export$72cbc7178e72e13f), {
            handleSelection: handleSelection,
            title: orderHasJobs ? t("job_draft_category.tell_about_job") : t("job_draft_category.tell_about_first_job"),
            subtitle: t("job_draft_category.find_staff"),
            header: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7ae42b63183f30b4$export$8b251419efc915eb), {
                title: t("job_draft_category.title"),
                rightComponent: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7aaa88adae16798b$export$ae1f41282e6c81da), {
                    jobsCount: (orderSummary?.jobs.length ?? 0) + 1,
                    orderId: Number(orderId)
                })
            }),
            showStepIndicator: true,
            stepNumber: Number(stepNumber)
        })
    });
}));





var $acw62 = parcelRequire("acw62");

var $45fvw = parcelRequire("45fvw");















var $acw62 = parcelRequire("acw62");

var $585d8dc750f2a37b$exports = {};
$585d8dc750f2a37b$exports = new URL("copy.f2ffcab9.svg", import.meta.url).toString();


var $4018bc7fe4f0f3b9$exports = {};
$4018bc7fe4f0f3b9$exports = new URL("trash.ecd79cbf.svg", import.meta.url).toString();






const $32076d96d859cbf9$var$formatMultiplierValue = (value, valueType)=>{
    if (valueType === "number") return value;
    if (valueType === "difference") return value === null || value <= 0 ? `${value}` : `+${value}`;
    return `${value}%`;
};
const $32076d96d859cbf9$export$bc75f5ddb26aac73 = ({ pricing: pricing, currency: currency })=>{
    const { t: t } = (0, $3765cebd031b52c0$export$9fc83ad70ead8663)();
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "JobCard__separator"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "JobCard__pricingTable",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("table", {
                    className: "JobCard__pricingTable__content",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("tr", {
                            className: "JobCard__pricingTable__header",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                    className: "JobCard__pricingTable__header__value",
                                    children: t("order_draft.pricing.type")
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                    className: "JobCard__pricingTable__header__value",
                                    children: t("order_draft.pricing.hours")
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                    className: "JobCard__pricingTable__header__value",
                                    children: t("order_draft.pricing.hourly_rate")
                                })
                            ]
                        }),
                        pricing.details.filter((item)=>item.valueType !== "percentage").map((item, key)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("tr", {
                                className: "JobCard__pricingTable__row",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                        className: "JobCard__pricingTable__row__type",
                                        children: item.type
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                        className: "JobCard__pricingTable__row__value",
                                        children: item.hours
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                        className: "JobCard__pricingTable__row__value",
                                        children: $32076d96d859cbf9$var$formatMultiplierValue(item.value, item.valueType)
                                    })
                                ]
                            }, key))
                    ]
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "JobCard__separator"
            }),
            pricing.details.filter((item)=>item.valueType === "percentage").map((item)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: "JobCard__row",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                    className: "JobCard__row__label JobCard__row__label--highlighted",
                                    children: item.type
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                    className: "JobCard__row__value",
                                    children: $32076d96d859cbf9$var$formatMultiplierValue(item.value, item.valueType)
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                            className: "JobCard__separator"
                        })
                    ]
                })),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "JobCard__pricingInfo",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("table", {
                        className: "JobCard__pricingInfo__table",
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("tr", {
                            className: "JobCard__pricingInfo__table__row",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                    className: "JobCard__pricingInfo__table__title",
                                    children: t("order_draft.pricing.estimated_total")
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                    className: "JobCard__pricingInfo__table__prevTotal",
                                    children: Number(pricing.total) > Number(pricing.final_total) ? `${pricing.total} ${currency}` : null
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                    className: "JobCard__pricingInfo__table__total",
                                    children: `${pricing.final_total} ${currency}`
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                        className: "JobCard__pricingInfo__note",
                        children: t("order.final_amount_will_be_based")
                    })
                ]
            })
        ]
    });
};




const $66d5d980e0643bf5$export$fc4189cae23292d8 = ({ startDate: startDate, endDate: endDate, daysCount: daysCount, intervals: intervals, showSchedulePopup: showSchedulePopup })=>{
    const { t: t } = (0, $3765cebd031b52c0$export$9fc83ad70ead8663)();
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "JobCard__separator"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "JobCard__row",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                        className: "JobCard__row__label",
                        children: t("order_draft.start_date")
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                        className: "JobCard__row__value",
                        children: startDate
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "JobCard__separator"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "JobCard__row",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                        className: "JobCard__row__label",
                        children: [
                            t("order_draft.end_date"),
                            " ",
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                className: "JobCard__row__label__note",
                                children: [
                                    "[",
                                    t("order_draft.updated"),
                                    "]"
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                        className: "JobCard__row__value",
                        children: [
                            endDate,
                            " ",
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                className: "JobCard__row__value__additional",
                                children: [
                                    "+",
                                    t("order_draft.days_amount", {
                                        count: daysCount
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            intervals.slice(0, 3).map(([_, interval], key)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: "JobCard__row",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                            className: "JobCard__row__label",
                            children: [
                                interval.day_of_month,
                                " ",
                                interval.month,
                                " ",
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                    className: "JobCard__row__value__additional",
                                    children: interval.day
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                            className: "JobCard__row__value",
                            children: [
                                interval.start_time,
                                " - ",
                                interval.end_time,
                                " ",
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                    className: "JobCard__row__value__additional",
                                    children: t("order_draft.n_hours", {
                                        hours: interval.duration
                                    })
                                })
                            ]
                        })
                    ]
                }, key)),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                className: "JobCard__bottomButton",
                onClick: (event)=>{
                    event.stopPropagation();
                    showSchedulePopup();
                },
                children: t("order_extension.full_schedule")
            })
        ]
    });
};




var $45fvw = parcelRequire("45fvw");






const $292a17fbae843c8f$export$93360a3d8bf67fd1 = ({ showPopup: showPopup, title: title, isScheduledWeekly: isScheduledWeekly, daysCount: daysCount, intervals: intervals, openEditSchedulePage: openEditSchedulePage, closePopup: closePopup })=>{
    const { t: t } = (0, $3765cebd031b52c0$export$9fc83ad70ead8663)();
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $9c16b10bbbe042e5$export$129a32eedafa97c5), {
        isActive: showPopup,
        content: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
            className: "JobDraftTime",
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                    className: "Popup__title",
                    children: title
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                    className: "Popup__subtitle",
                    children: t("order_extension.schedule_description")
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                            className: "JobDraftTime__selectionCount",
                            children: isScheduledWeekly ? t("job_draft_details.time_days_selected", {
                                count: daysCount
                            }) : t("job_draft_details.time_dates_selected", {
                                count: daysCount
                            })
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $660b2ca422e0e2ae$export$1ff3c3f08ae963c0).Vertical, {
                            height: 16
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                            className: "JobDraftTime__dates",
                            children: intervals.map(([day, time])=>{
                                return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                    className: "JobDraftTime__dates__row",
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                            className: `JobDraftTime__dates__row__day`,
                                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                className: `JobDraftTime__dates__row__day__label`,
                                                children: isScheduledWeekly ? t(`time.${day.toLowerCase()}`) : (0, (/*@__PURE__*/$parcel$interopDefault($45fvw)))(day, "YYYY-MM-DD").format("MMM DD")
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5ce1d5308946b7cc$export$a1af6f79df847fac), {
                                            label: t("job_draft_details.start_time"),
                                            value: time.start_time,
                                            handleChange: ()=>{},
                                            className: "JobDraftTime__dates__row__input",
                                            required: true,
                                            disabled: true
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5ce1d5308946b7cc$export$a1af6f79df847fac), {
                                            label: t("job_draft_details.end_time"),
                                            value: time.end_time,
                                            handleChange: ()=>{},
                                            className: "JobDraftTime__dates__row__input",
                                            required: true,
                                            disabled: true
                                        })
                                    ]
                                }, day);
                            })
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $660b2ca422e0e2ae$export$1ff3c3f08ae963c0).Vertical, {
                            height: 40
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: "JobCard__schedule",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $009f3befb8e18271$export$2955d454eecc45c0), {
                            text: t("order_extension.edit"),
                            action: openEditSchedulePage
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $2c46e9e1f89bee75$export$2b47962e4e24eb4d), {
                            text: t("order_extension.done"),
                            action: closePopup
                        })
                    ]
                })
            ]
        }),
        close: ()=>closePopup
    });
};




var $e883a683e4a79f0f$exports = {};
$e883a683e4a79f0f$exports = new URL("pen.815d5528.svg", import.meta.url).toString();


const $9ab8f89ab380438f$export$a00fdf9337c0b3ed = ({ onClick: onClick, containerStyle: containerStyle })=>{
    const { t: t } = (0, $3765cebd031b52c0$export$9fc83ad70ead8663)();
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "JobCard__header__editJob",
        onClick: onClick,
        style: containerStyle,
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                className: "JobCard__header__editJob__title",
                children: t("order_draft.edit_job")
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                src: (0, (/*@__PURE__*/$parcel$interopDefault($e883a683e4a79f0f$exports)))
            })
        ]
    });
};





const $37334feb7242a583$export$fd7ef5f41e59d9a0 = ({ title: title, quantity: quantity, startDate: startDate, endDate: endDate, daysCount: daysCount, locationName: locationName, onJobPress: onJobPress, onScheduleEdit: onScheduleEdit, onDelete: onDelete, onDuplicate: onDuplicate, isAutoPricingEnabled: isAutoPricingEnabled, pricing: pricing, currency: currency, isExtension: isExtension, intervals: intervals, repeatType: repeatType, shiftsCount: shiftsCount, invitedSPs: invitedSPs })=>{
    const [showSchedulePopup, setShowSchedulePopup] = (0, $acw62.useState)(false);
    const isScheduledWeekly = repeatType === (0, $487f9fae786cd5fa$export$d04232ab73db0cc8).EveryWeek;
    const { t: t } = (0, $3765cebd031b52c0$export$9fc83ad70ead8663)();
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        onClick: isExtension ? ()=>{} : onJobPress,
        className: "JobCard",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "JobCard__header",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                        className: "JobCard__header__title",
                        children: title
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "JobCard__header__rightContainer",
                        children: !isExtension ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $9ab8f89ab380438f$export$a00fdf9337c0b3ed), {
                                    onClick: onJobPress,
                                    containerStyle: {
                                        marginInlineEnd: "15px"
                                    }
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                                    onClick: (e)=>{
                                        e.stopPropagation();
                                        onDuplicate();
                                    },
                                    src: (0, (/*@__PURE__*/$parcel$interopDefault($585d8dc750f2a37b$exports))),
                                    className: "JobCard__header__rightContainer__copyImg"
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                                    onClick: (e)=>{
                                        e.stopPropagation();
                                        onDelete();
                                    },
                                    src: (0, (/*@__PURE__*/$parcel$interopDefault($4018bc7fe4f0f3b9$exports))),
                                    className: "JobCard__header__rightContainer__deleteImg"
                                })
                            ]
                        }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $9ab8f89ab380438f$export$a00fdf9337c0b3ed), {
                            onClick: onJobPress
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "JobCard__row",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                        className: "JobCard__row__label",
                        children: t("order_draft.quantity")
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                        className: "JobCard__row__value",
                        children: quantity
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "JobCard__separator"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "JobCard__row",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                        className: "JobCard__row__label",
                        children: t("order_draft.days")
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                className: "JobCard__row__value",
                                children: [
                                    startDate,
                                    " - ",
                                    endDate
                                ]
                            }),
                            " ",
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                className: "JobCard__row__hint",
                                children: t("order_draft.days_amount", {
                                    count: shiftsCount
                                })
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "JobCard__separator"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "JobCard__row",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                        className: "JobCard__row__label",
                        children: t("order_draft.location")
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                        className: "JobCard__row__value",
                        children: locationName
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "JobCard__separator"
            }),
            invitedSPs.length > 0 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "JobCard__row JobCard__row--vertical",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                        className: "JobCard__row__label",
                        children: t("invited_sps.invited_sps")
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        children: invitedSPs.map((sp)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $487c9a2e5b754624$export$7e23a963ec4768e3), {
                                disabled: false,
                                withCheckbox: false,
                                sp: sp,
                                selected: true,
                                showDesignation: false
                            }, sp.id))
                    })
                ]
            }),
            isExtension && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $66d5d980e0643bf5$export$fc4189cae23292d8), {
                startDate: startDate,
                endDate: endDate,
                daysCount: shiftsCount,
                intervals: intervals,
                showSchedulePopup: ()=>setShowSchedulePopup(true)
            }),
            isAutoPricingEnabled && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4ae5ab5371178941$export$f01b3d7c7bbe3997), {
                allowedRoles: [
                    (0, $97fa7686fb8e51ed$export$eb3485a690c2f0b8).Owner,
                    (0, $97fa7686fb8e51ed$export$eb3485a690c2f0b8).Admin,
                    (0, $97fa7686fb8e51ed$export$eb3485a690c2f0b8).Finance
                ],
                showDefaultFallbackUI: false,
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $32076d96d859cbf9$export$bc75f5ddb26aac73), {
                    pricing: pricing,
                    currency: currency
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $292a17fbae843c8f$export$93360a3d8bf67fd1), {
                showPopup: showSchedulePopup,
                title: `${title} (${quantity})`,
                isScheduledWeekly: isScheduledWeekly,
                daysCount: daysCount,
                intervals: intervals,
                openEditSchedulePage: onScheduleEdit,
                closePopup: ()=>setShowSchedulePopup(false)
            })
        ]
    });
};




var $acw62 = parcelRequire("acw62");

var $4f362 = parcelRequire("4f362");











const $8946ba190ca0b728$export$c9a1b96c23a3502d = ({ label: label, selected: selected, onToggle: onToggle })=>{
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "JobField",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                className: "JobField__label",
                children: label
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $d931e957e209e988$export$bea8ebba691c5813), {
                active: selected,
                onToggle: onToggle
            })
        ]
    });
};






const $ec31c720b6ba1f4b$export$2c2dd362eeffba67 = (0, $aca50e9407ba89c9$export$b6ae1bc530f4c149)(({ orderId: orderId, jobId: jobId, setJobId: setJobId, jobsList: jobsList, showSelectJob: showSelectJob })=>{
    const [designationSelected, setDesignationSelected] = (0, $acw62.useState)(false);
    const [quantitySelected, setQuantitySelected] = (0, $acw62.useState)(false);
    const [locationSelected, setLocationSelected] = (0, $acw62.useState)(false);
    const [publicTransportAccessibilitySelected, setPublicTransportAccessibilitySelected] = (0, $acw62.useState)(false);
    const [scheduleSelected, setScheduleSelected] = (0, $acw62.useState)(false);
    const [requirementsSelected, setRequirementsSelected] = (0, $acw62.useState)(false);
    const [jobDescriptionSelected, setJobDescriptionSelected] = (0, $acw62.useState)(false);
    const [experienceSelected, setExperienceSelected] = (0, $acw62.useState)(false);
    const [dresscodeSelected, setDresscodeSelected] = (0, $acw62.useState)(false);
    const [languageSelected, setLanguageSelected] = (0, $acw62.useState)(false);
    const [genderSelected, setGenderSelected] = (0, $acw62.useState)(false);
    const [documentsSelected, setDocumentsSelected] = (0, $acw62.useState)(false);
    const [manualSelectionSelected, setManualSelectionSelected] = (0, $acw62.useState)(false);
    const [accreditationSelected, setAccreditationSelected] = (0, $acw62.useState)(false);
    const [accomodationSelected, setAccommodationSelected] = (0, $acw62.useState)(false);
    const [boardingSelected, setBoardingSelected] = (0, $acw62.useState)(false);
    const [interviewSeleted, setInterviewSelected] = (0, $acw62.useState)(false);
    const { createDraftJob: createDraftJob } = (0, $d6286036be37a1b2$export$6feca3f67f446ef2)();
    const { getOrderIdJob: getOrderIdJob } = (0, $4671947198ddd366$export$6ccbb43953eebf8)().data;
    const job = getOrderIdJob(orderId, jobId);
    const redirect = (0, $7df35e9df335b1c8$export$602eaf6d5314ce55)();
    const { t: t } = (0, $3765cebd031b52c0$export$9fc83ad70ead8663)();
    const handleDuplicate = ()=>{
        if (!job) throw new Error("Job not found, unable to duplicate");
        const draftJob = createDraftJob();
        draftJob.setDuplicatedJob(parseInt(jobId));
        if (designationSelected) draftJob.category.set(job.work_category_id);
        if (quantitySelected) draftJob.quantity.set(job.quantity);
        if (locationSelected) draftJob.location.set({
            id: job.client_location_id,
            name: job.client_location_name
        });
        if (publicTransportAccessibilitySelected) draftJob.transport.set(job.public_transport_accessibility);
        if (scheduleSelected) {
            const firstDateKey = job.intervals?.keys().next().value;
            const weekdayLength = 3 // 'Mon', 'Tue', etc
            ;
            const scheduleType = firstDateKey.length > weekdayLength ? (0, $a4e7aca7274b573e$export$38e26ec75b48a88c).daily : (0, $a4e7aca7274b573e$export$38e26ec75b48a88c).weekly;
            draftJob.schedule.setStartDate(job.start_date);
            draftJob.schedule.setEndDate(job.end_date);
            draftJob.schedule.setScheduleType(scheduleType);
            draftJob.schedule.sameTimeSchedule.setIsSameTiming(false);
            Array.from((0, $4f362.toJS)(job.intervals ?? [])).forEach(([date, dateObj])=>{
                draftJob.schedule.distinctTimeSchedule.setDateTime({
                    date: date,
                    start_time: dateObj.start_time.slice(0, 5),
                    end_time: dateObj.end_time.slice(0, 5),
                    selected: true
                });
            });
        }
        if (requirementsSelected && designationSelected) draftJob.requirements.set((0, $4f362.toJS)(job.work_requirement_ids));
        if (jobDescriptionSelected) draftJob.description.set(job.instructions);
        if (experienceSelected) {
            const jobExperience = String(job.seniority_level);
            draftJob.experience.set(jobExperience);
        }
        if (dresscodeSelected) draftJob.dresscode.set(job.uniform_id);
        if (languageSelected && job.filter.languages) {
            draftJob.languages.set((0, $4f362.toJS)(job.filter.languages));
            draftJob.languages.useLanguages(true);
        }
        if (genderSelected && job.filter.gender) {
            draftJob.gender.set(String(job.filter.gender));
            draftJob.gender.useGender(true);
        }
        if (documentsSelected && job.filter.certificates) {
            draftJob.documents.set((0, $4f362.toJS)(job.filter.certificates));
            draftJob.documents.useDocuments(true);
        }
        if (manualSelectionSelected && job.assignment_type === 1) draftJob.manualSelection.setManualSelection(true);
        if (interviewSeleted) draftJob.manualSelection.useInterview(true);
        if (accreditationSelected && job.is_accreditation_required) {
            draftJob.accreditation.set(true);
            draftJob.accreditation.useAccreditation(true);
        }
        if (accomodationSelected && job.is_accommodation_offered) draftJob.accommodation.useAccommodation(true);
        if (boardingSelected) {
            draftJob.boarding.useBoarding(true);
            draftJob.boarding.set(job.boarding_type);
        }
        if (designationSelected) redirect((0, $0534349ae8731d0b$export$66b32f6f30eb4b4).jobDraftDetails, {
            orderId: orderId,
            draftJobId: draftJob.id,
            stepNumber: String(2)
        });
        else redirect((0, $0534349ae8731d0b$export$66b32f6f30eb4b4).setJobCategory, {
            orderId: orderId,
            draftJobId: draftJob.id,
            stepNumber: String(2)
        });
    };
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "DuplicateJob",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $660b2ca422e0e2ae$export$1ff3c3f08ae963c0).Vertical, {
                height: 13
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "DuplicateJob__header",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                        className: "DuplicateJob__header__title",
                        children: t("order_draft.what_to_copy", {
                            category: job?.category_name
                        })
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                        className: "DuplicateJob__header__subtitle",
                        children: t("order_draft.select_preferences")
                    })
                ]
            }),
            showSelectJob && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $660b2ca422e0e2ae$export$1ff3c3f08ae963c0).Vertical, {
                        height: 25
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f2c1b8699595d8c0$export$ef9b1a59e592288f), {
                        label: t("order.job_to_duplicate"),
                        value: jobId,
                        onChange: (value)=>setJobId(value),
                        options: jobsList.map((jobItem)=>({
                                key: String(jobItem.id),
                                value: String(jobItem.id),
                                label: `#${jobItem.id} - ${jobItem.category_name} (${jobItem.quantity} ${t("order_draft.workers")})`
                            }))
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $660b2ca422e0e2ae$export$1ff3c3f08ae963c0).Vertical, {
                height: 25
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $8946ba190ca0b728$export$c9a1b96c23a3502d), {
                label: "Designation",
                selected: designationSelected,
                onToggle: ()=>{
                    setDesignationSelected((prevValue)=>{
                        if (prevValue === true && requirementsSelected) setRequirementsSelected(false);
                        return !prevValue;
                    });
                }
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $660b2ca422e0e2ae$export$1ff3c3f08ae963c0).Vertical, {
                height: 25
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $8946ba190ca0b728$export$c9a1b96c23a3502d), {
                label: t("order_draft.quantity"),
                selected: quantitySelected,
                onToggle: ()=>{
                    setQuantitySelected((state)=>!state);
                }
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $660b2ca422e0e2ae$export$1ff3c3f08ae963c0).Vertical, {
                height: 25
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $8946ba190ca0b728$export$c9a1b96c23a3502d), {
                label: t("order_draft.location"),
                selected: locationSelected,
                onToggle: ()=>{
                    setLocationSelected((state)=>!state);
                }
            }),
            (0, $73ccb33f5de6f5aa$export$8707029d024490c9)().order.includePublicTransportationField && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $660b2ca422e0e2ae$export$1ff3c3f08ae963c0).Vertical, {
                        height: 25
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $8946ba190ca0b728$export$c9a1b96c23a3502d), {
                        label: t("order_draft.public_transport_accessibility"),
                        selected: publicTransportAccessibilitySelected,
                        onToggle: ()=>{
                            setPublicTransportAccessibilitySelected((state)=>!state);
                        }
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $660b2ca422e0e2ae$export$1ff3c3f08ae963c0).Vertical, {
                height: 25
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $8946ba190ca0b728$export$c9a1b96c23a3502d), {
                label: t("order_draft.schedule"),
                selected: scheduleSelected,
                onToggle: ()=>{
                    setScheduleSelected((state)=>!state);
                }
            }),
            designationSelected && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $660b2ca422e0e2ae$export$1ff3c3f08ae963c0).Vertical, {
                        height: 25
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $8946ba190ca0b728$export$c9a1b96c23a3502d), {
                        label: t("order_draft.requirements"),
                        selected: requirementsSelected,
                        onToggle: ()=>{
                            setRequirementsSelected((state)=>!state);
                        }
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $660b2ca422e0e2ae$export$1ff3c3f08ae963c0).Vertical, {
                height: 25
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $8946ba190ca0b728$export$c9a1b96c23a3502d), {
                label: t("order_draft.job_description"),
                selected: jobDescriptionSelected,
                onToggle: ()=>{
                    setJobDescriptionSelected((state)=>!state);
                }
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $660b2ca422e0e2ae$export$1ff3c3f08ae963c0).Vertical, {
                height: 25
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $8946ba190ca0b728$export$c9a1b96c23a3502d), {
                label: t("order_draft.seniority_level"),
                selected: experienceSelected,
                onToggle: ()=>{
                    setExperienceSelected((state)=>!state);
                }
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $660b2ca422e0e2ae$export$1ff3c3f08ae963c0).Vertical, {
                height: 25
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $8946ba190ca0b728$export$c9a1b96c23a3502d), {
                label: t("order_draft.dresscode"),
                selected: dresscodeSelected,
                onToggle: ()=>{
                    setDresscodeSelected((state)=>!state);
                }
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $660b2ca422e0e2ae$export$1ff3c3f08ae963c0).Vertical, {
                height: 25
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $8946ba190ca0b728$export$c9a1b96c23a3502d), {
                label: t("order_draft.language"),
                selected: languageSelected,
                onToggle: ()=>{
                    setLanguageSelected((state)=>!state);
                }
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $660b2ca422e0e2ae$export$1ff3c3f08ae963c0).Vertical, {
                height: 25
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $8946ba190ca0b728$export$c9a1b96c23a3502d), {
                label: t("order_draft.gender"),
                selected: genderSelected,
                onToggle: ()=>{
                    setGenderSelected((state)=>!state);
                }
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $660b2ca422e0e2ae$export$1ff3c3f08ae963c0).Vertical, {
                height: 25
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $8946ba190ca0b728$export$c9a1b96c23a3502d), {
                label: t("order_draft.documents"),
                selected: documentsSelected,
                onToggle: ()=>{
                    setDocumentsSelected((state)=>!state);
                }
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $660b2ca422e0e2ae$export$1ff3c3f08ae963c0).Vertical, {
                height: 25
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $8946ba190ca0b728$export$c9a1b96c23a3502d), {
                label: t("order_draft.manual_selection"),
                selected: manualSelectionSelected,
                onToggle: ()=>{
                    setManualSelectionSelected((state)=>!state);
                }
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $660b2ca422e0e2ae$export$1ff3c3f08ae963c0).Vertical, {
                height: 25
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $8946ba190ca0b728$export$c9a1b96c23a3502d), {
                label: t("order_draft.interview_required"),
                selected: interviewSeleted,
                onToggle: ()=>{
                    setInterviewSelected((state)=>!state);
                }
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $660b2ca422e0e2ae$export$1ff3c3f08ae963c0).Vertical, {
                height: 25
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $8946ba190ca0b728$export$c9a1b96c23a3502d), {
                label: t("order_draft.accreditation_requried"),
                selected: accreditationSelected,
                onToggle: ()=>{
                    setAccreditationSelected((state)=>!state);
                }
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $660b2ca422e0e2ae$export$1ff3c3f08ae963c0).Vertical, {
                height: 25
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $8946ba190ca0b728$export$c9a1b96c23a3502d), {
                label: t("order_draft.accommodation_offered"),
                selected: accomodationSelected,
                onToggle: ()=>{
                    setAccommodationSelected((state)=>!state);
                }
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $660b2ca422e0e2ae$export$1ff3c3f08ae963c0).Vertical, {
                height: 25
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $8946ba190ca0b728$export$c9a1b96c23a3502d), {
                label: t("order_draft.boarding_offered"),
                selected: boardingSelected,
                onToggle: ()=>{
                    setBoardingSelected((state)=>!state);
                }
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $660b2ca422e0e2ae$export$1ff3c3f08ae963c0).Spacer, {
                minHeight: 31
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $2ab88429e3384d30$export$353f5b6fc5456de1), {
                title: t("order_draft.duplicate_job"),
                onClick: handleDuplicate,
                className: "DuplicateJob__button"
            })
        ]
    });
});


var $cc67fc1bcd2a613e$exports = {};
$cc67fc1bcd2a613e$exports = new URL("jobs-icon.87e114c4.svg", import.meta.url).toString();



















const $8e08f9d49ea5841c$var$stepIndicatorConfig = {
    stepsCount: 4,
    currentStepNumber: 3
};
// @ts-ignore
const $8e08f9d49ea5841c$var$momentRange = (0, $3c5155092adf0860$exports.extendMoment)((0, (/*@__PURE__*/$parcel$interopDefault($45fvw))));
const $8e08f9d49ea5841c$export$c13a4208c8d4a907 = (0, $aca50e9407ba89c9$export$b6ae1bc530f4c149)(({ orderId: orderId, title: title, isExtension: isExtension })=>{
    const [jobIdToDuplicate, setJobIdToDuplicate] = (0, $acw62.useState)(null);
    const [newJobModalVisible, setNewJobModalVisible] = (0, $acw62.useState)(false);
    const [duplicateJobPopupVisible, setDuplicateJobPopupVisible] = (0, $acw62.useState)(false);
    const [allowSelectJobOnDuplicate, setAllowSelectJobOnDuplicate] = (0, $acw62.useState)(false);
    const [jobsCount, setJobsCount] = (0, $acw62.useState)(0);
    const [isTermsAndConditionsAccepted, setIsTermsAndConditionsAccepted] = (0, $acw62.useState)(false);
    const { getOrderJobs: getOrderJobs, getOrderIdJobs: getOrderIdJobs, getJobIntervals: getJobIntervals, cancelJob: cancelJob, account: account, getOrderSummary: getOrderSummary, getOrderIdSummary: getOrderIdSummary, submitOrder: submitOrder, getUpfrontPaymentId: getUpfrontPaymentId, confirmOrder: confirmOrder, confirmOrderTermsConditions: confirmOrderTermsConditions, apiHost: apiHost, getPastSPs: getPastSPs, pastSPsList: pastSPsList } = (0, $4671947198ddd366$export$6ccbb43953eebf8)().data;
    (0, $4671947198ddd366$export$dd0a697e1782aedd)(()=>getPastSPs({}));
    const orderSummary = getOrderIdSummary(orderId);
    const { isLoading: orderSummaryLoading } = (0, $4671947198ddd366$export$dd0a697e1782aedd)(()=>getOrderSummary({
            orderId: orderId
        }), {
        filterError: [
            (0, $9ad33fbf770c55a1$export$9696fcf1798e1cb5).ClientError
        ],
        onError: (err)=>{
            alert(err.data.message);
        }
    });
    (0, $acw62.useEffect)(()=>{
        setJobsCount(Number(orderSummary?.jobs.length));
    }, [
        orderSummary
    ]);
    const { isLoading: jobsLoading } = (0, $4671947198ddd366$export$dd0a697e1782aedd)(()=>getOrderJobs({
            order_id: Number(orderId)
        }));
    const [{ isLoading: deletingJob }, requestCancelJob] = (0, $4671947198ddd366$export$609860bf8b0084c)(cancelJob, {
        onSuccess: ()=>{
            const updatedJobs = getOrderIdJobs(Number(orderId));
            setJobsCount(updatedJobs.length);
            if (updatedJobs.length === 0) redirect((0, $0534349ae8731d0b$export$66b32f6f30eb4b4).orders, {
                ordersState: (0, $0f571f43d43ce782$export$819724757aafc79).Unconfirmed
            });
        }
    });
    const [submitOrderQuery, requestSubmitOrder] = (0, $4671947198ddd366$export$609860bf8b0084c)(submitOrder, {
        onSuccess: ()=>{
            redirect((0, $0534349ae8731d0b$export$66b32f6f30eb4b4).orderRequestSuccess, {
                orderId: orderId
            });
        },
        onError: (err)=>{
            // Makes Sentry to have it as a separate error with all logs/breadcrumbs
            console.error("Submit Order API Error");
            alert(err.data.message);
        },
        filterError: [
            (0, $9ad33fbf770c55a1$export$9696fcf1798e1cb5).ClientError
        ]
    });
    const { createDraftJob: createDraftJob } = (0, $d6286036be37a1b2$export$6feca3f67f446ef2)();
    const redirect = (0, $7df35e9df335b1c8$export$602eaf6d5314ce55)();
    const { t: t } = (0, $3765cebd031b52c0$export$9fc83ad70ead8663)();
    const jobs = getOrderIdJobs(Number(orderId));
    const loading = jobsLoading || deletingJob || orderSummaryLoading || submitOrderQuery.isLoading;
    const handleNewJob = (job, popupField)=>{
        const draftJob = createDraftJob((0, $957237d860259090$export$54e37c44dc5bfc74)(job));
        const route = popupField !== null ? (0, $0534349ae8731d0b$export$66b32f6f30eb4b4).jobDraftDetailsPopupField : (0, $0534349ae8731d0b$export$66b32f6f30eb4b4).jobDraftDetails;
        const routeParams = {
            orderId: orderId,
            draftJobId: draftJob.id,
            stepNumber: String($8e08f9d49ea5841c$var$stepIndicatorConfig.currentStepNumber),
            isExtension: String(isExtension),
            ...popupField !== null ? {
                popupField: popupField
            } : {}
        };
        redirect(route, routeParams);
    };
    const { query: { isLoading: isPayLoading }, enableQuery: pay } = (0, $4671947198ddd366$export$517ca4f7fee4e226)(()=>getUpfrontPaymentId(orderId), {
        onSuccess: (paymentId)=>{
            redirect((0, $0534349ae8731d0b$export$66b32f6f30eb4b4).paymentMethodsList, {
                paymentId: String(paymentId),
                paymentOptions: JSON.stringify({
                    redirectToRouteAfterSuccess: "orderRequestSuccess",
                    redirectToRouteAfterSuccessParams: {
                        orderId: String(orderId)
                    },
                    redirectToRouteAfterSuccessTitle: t("payment.back_to_order")
                })
            });
        },
        onError: (err)=>{
            // Makes Sentry to have it as a separate error with all logs/breadcrumbs
            console.error("Pay For Order API Error");
            alert(err.data.message);
        },
        filterError: [
            (0, $9ad33fbf770c55a1$export$9696fcf1798e1cb5).ClientError
        ]
    });
    const [confirmOrderQuery, requestConfirmOrder] = (0, $4671947198ddd366$export$609860bf8b0084c)(confirmOrder, {
        onSuccess: ()=>{
            redirect((0, $0534349ae8731d0b$export$66b32f6f30eb4b4).orderCreateSuccess, {
                orderId: orderId
            });
        },
        onError: (err)=>{
            // Makes Sentry to have it as a separate error with all logs/breadcrumbs
            console.error("Confirm Draft Order API Error");
            alert(err.data.message);
        },
        filterError: [
            (0, $9ad33fbf770c55a1$export$9696fcf1798e1cb5).ClientError
        ]
    });
    const [, requestConfirmTerms] = (0, $4671947198ddd366$export$609860bf8b0084c)(confirmOrderTermsConditions, {
        onSuccess: ()=>{
            setIsTermsAndConditionsAccepted(true);
        },
        onError: (err)=>alert(err.data.message),
        filterError: [
            (0, $9ad33fbf770c55a1$export$9696fcf1798e1cb5).ClientError
        ]
    });
    let allJobsArePriced = true;
    jobs.forEach((job)=>{
        if (!Boolean(job.pricing.final_total)) allJobsArePriced = false;
    });
    const isAutoPricingEnabled = !isExtension && (orderSummary?.is_dynamic_priced || allJobsArePriced);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7ae42b63183f30b4$export$8b251419efc915eb), {
                title: Boolean(title) ? title : t("order_draft.title"),
                rightComponent: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7aaa88adae16798b$export$ae1f41282e6c81da), {
                    jobsCount: jobsCount,
                    orderId: Number(orderId)
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "OrderDraft",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $660b2ca422e0e2ae$export$1ff3c3f08ae963c0).Vertical, {
                        height: 87
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $38509c18096ca465$export$a765b9dee96eca0e), {
                        stepsCount: $8e08f9d49ea5841c$var$stepIndicatorConfig.stepsCount,
                        currentStepNumber: $8e08f9d49ea5841c$var$stepIndicatorConfig.currentStepNumber
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $660b2ca422e0e2ae$export$1ff3c3f08ae963c0).Vertical, {
                        height: 14
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ec2248901324e8a8$export$2e2bcd8739ae039), {
                        image: (0, (/*@__PURE__*/$parcel$interopDefault($2c242e74e2590f15$exports))),
                        title: t("order.order_summary")
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $660b2ca422e0e2ae$export$1ff3c3f08ae963c0).Vertical, {
                        height: 14
                    }),
                    !loading ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4a112c2694b1fd4a$export$2e2bcd8739ae039), {
                        location: orderSummary?.locations[0].name,
                        paymentTerms: orderSummary?.payment_terms_days,
                        startDate: orderSummary?.start_date ? (0, (/*@__PURE__*/$parcel$interopDefault($45fvw)))(orderSummary.start_date) : null,
                        endDate: orderSummary?.start_date ? (0, (/*@__PURE__*/$parcel$interopDefault($45fvw)))(orderSummary.end_date) : null,
                        showCompleteDetails: account?.account_type === (0, $97fa7686fb8e51ed$export$b8ca5fa4899cbfc7).CORPORATE && account.is_corporate_details_complete === false,
                        orderId: orderId,
                        isExtension: isExtension,
                        showAmend: true
                    }) : null,
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $660b2ca422e0e2ae$export$1ff3c3f08ae963c0).Vertical, {
                        height: 28
                    }),
                    jobs.length > 0 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "OrderDraft__row",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                                        src: (0, (/*@__PURE__*/$parcel$interopDefault($cc67fc1bcd2a613e$exports))),
                                        className: "OrderDraft__row__icon"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                        className: "OrderDraft__row__label",
                                        children: t("order_draft.jobs")
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $660b2ca422e0e2ae$export$1ff3c3f08ae963c0).Vertical, {
                                height: 14
                            })
                        ]
                    }),
                    loading ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $57fb8f45c69e1681$export$b08b517936747730), {}) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                        children: [
                            jobs.map((job, index)=>{
                                const startDate = (0, (/*@__PURE__*/$parcel$interopDefault($45fvw)))(job.start_date, "YYYY-MM-DD");
                                const formattedStartDate = startDate.format("MMM DD");
                                const endDate = (0, (/*@__PURE__*/$parcel$interopDefault($45fvw)))(job.end_date, "YYYY-MM-DD");
                                const formattedEndDate = endDate.format("MMM DD");
                                const shiftsCount = Number(endDate.diff(startDate, "days"));
                                const invitedSPs = pastSPsList.filter((sp)=>job.invited_sp_ids.includes(sp.id));
                                return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $acw62.Fragment), {
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $37334feb7242a583$export$fd7ef5f41e59d9a0), {
                                            title: job.category_name,
                                            quantity: job.quantity,
                                            locationName: job.client_location_name,
                                            daysCount: job.intervals?.size ?? 0,
                                            startDate: formattedStartDate,
                                            endDate: formattedEndDate,
                                            onScheduleEdit: ()=>handleNewJob(job, (0, $39b712c8a7a8ea7b$export$21cdfbdd9a861522).daysSelect),
                                            onJobPress: ()=>handleNewJob(job, null),
                                            onDelete: ()=>{
                                                const confirmed = confirm(t("order_draft.confirm_delete_job", {
                                                    name: job.category_name
                                                }));
                                                if (confirmed) requestCancelJob({
                                                    orderId: orderId,
                                                    jobId: job.id
                                                });
                                            },
                                            onDuplicate: ()=>{
                                                setJobIdToDuplicate(job.id);
                                                setDuplicateJobPopupVisible(true);
                                            },
                                            isAutoPricingEnabled: isAutoPricingEnabled,
                                            pricing: job.pricing,
                                            currency: String(orderSummary?.currency),
                                            isExtension: isExtension,
                                            intervals: getJobIntervals(orderId, String(job.id)),
                                            repeatType: job.repeat_type,
                                            shiftsCount: shiftsCount,
                                            invitedSPs: invitedSPs
                                        }),
                                        index !== jobs.length - 1 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $660b2ca422e0e2ae$export$1ff3c3f08ae963c0).Vertical, {
                                            height: 20
                                        })
                                    ]
                                }, job.id);
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $660b2ca422e0e2ae$export$1ff3c3f08ae963c0).Vertical, {
                                height: 36
                            }),
                            isAutoPricingEnabled && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $4ae5ab5371178941$export$f01b3d7c7bbe3997), {
                                allowedRoles: [
                                    (0, $97fa7686fb8e51ed$export$eb3485a690c2f0b8).Owner,
                                    (0, $97fa7686fb8e51ed$export$eb3485a690c2f0b8).Admin,
                                    (0, $97fa7686fb8e51ed$export$eb3485a690c2f0b8).Finance
                                ],
                                showDefaultFallbackUI: false,
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ec2248901324e8a8$export$2e2bcd8739ae039), {
                                        image: (0, (/*@__PURE__*/$parcel$interopDefault($5e254c5a797c259d$exports))),
                                        title: t("order.cost")
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $660b2ca422e0e2ae$export$1ff3c3f08ae963c0).Vertical, {
                                        height: 14
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $a5e8fce3ee993db4$export$2e2bcd8739ae039), {
                                        sub_total: orderSummary?.sub_total,
                                        tax: orderSummary?.tax,
                                        tax_percent: orderSummary?.tax_percentage,
                                        transportation_total: orderSummary?.transportation_total,
                                        total: orderSummary?.total,
                                        currency: orderSummary?.currency
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $660b2ca422e0e2ae$export$1ff3c3f08ae963c0).Vertical, {
                                        height: 36
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $660b2ca422e0e2ae$export$1ff3c3f08ae963c0).Vertical, {
                                height: 36
                            }),
                            jobs.length > 0 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4a1895475c466679$export$c072955bb62eb0e2), {
                                contentStyle: {
                                    justifyContent: "center"
                                },
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                    children: [
                                        isAutoPricingEnabled && !orderSummary?.is_upfront && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4ae5ab5371178941$export$f01b3d7c7bbe3997), {
                                            allowedRoles: [
                                                (0, $97fa7686fb8e51ed$export$eb3485a690c2f0b8).Owner,
                                                (0, $97fa7686fb8e51ed$export$eb3485a690c2f0b8).Admin,
                                                (0, $97fa7686fb8e51ed$export$eb3485a690c2f0b8).Finance
                                            ],
                                            showDefaultFallbackUI: false,
                                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                style: {
                                                    marginBottom: "16px"
                                                },
                                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c6f05f53c1840e94$export$d3fa8faf524123), {
                                                    isTermsAndConditionsAccepted: isTermsAndConditionsAccepted,
                                                    requestConfirmTerms: requestConfirmTerms,
                                                    apiHost: apiHost
                                                })
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                            style: {
                                                display: "flex",
                                                justifyContent: "center"
                                            },
                                            children: [
                                                !isExtension && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $009f3befb8e18271$export$2955d454eecc45c0), {
                                                    text: t("order_draft.add_another_job_with_plus"),
                                                    action: ()=>setNewJobModalVisible(true)
                                                }),
                                                isAutoPricingEnabled && !orderSummary?.is_upfront && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4ae5ab5371178941$export$f01b3d7c7bbe3997), {
                                                    allowedRoles: [
                                                        (0, $97fa7686fb8e51ed$export$eb3485a690c2f0b8).Owner,
                                                        (0, $97fa7686fb8e51ed$export$eb3485a690c2f0b8).Admin,
                                                        (0, $97fa7686fb8e51ed$export$eb3485a690c2f0b8).Finance
                                                    ],
                                                    showDefaultFallbackUI: false,
                                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $2c46e9e1f89bee75$export$2b47962e4e24eb4d), {
                                                        text: t("order.confirm"),
                                                        disabled: !isTermsAndConditionsAccepted && confirmOrderQuery.isLoading,
                                                        action: ()=>requestConfirmOrder({
                                                                orderId: orderId
                                                            }),
                                                        additionalStyle: {
                                                            marginInlineStart: "12px"
                                                        }
                                                    })
                                                }),
                                                isAutoPricingEnabled && orderSummary?.is_upfront && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4ae5ab5371178941$export$f01b3d7c7bbe3997), {
                                                    allowedRoles: [
                                                        (0, $97fa7686fb8e51ed$export$eb3485a690c2f0b8).Owner,
                                                        (0, $97fa7686fb8e51ed$export$eb3485a690c2f0b8).Admin,
                                                        (0, $97fa7686fb8e51ed$export$eb3485a690c2f0b8).Finance
                                                    ],
                                                    showDefaultFallbackUI: false,
                                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $2c46e9e1f89bee75$export$2b47962e4e24eb4d), {
                                                        text: `${t("payment.pay")} ${orderSummary.currency} ${orderSummary.total}`,
                                                        disabled: isPayLoading,
                                                        action: pay,
                                                        additionalStyle: {
                                                            marginInlineStart: "12px"
                                                        }
                                                    })
                                                }),
                                                !isAutoPricingEnabled && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $2c46e9e1f89bee75$export$2b47962e4e24eb4d), {
                                                    text: t("order.send_for_review"),
                                                    action: ()=>requestSubmitOrder(orderId),
                                                    additionalStyle: {
                                                        marginInlineStart: "12px"
                                                    }
                                                })
                                            ]
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $660b2ca422e0e2ae$export$1ff3c3f08ae963c0).Vertical, {
                                height: 23
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c786671f641538e1$export$446bb0a5366f9068), {
                        contentStyle: {
                            overflow: "hidden",
                            maxWidth: "400px"
                        },
                        modalVisible: newJobModalVisible,
                        onClose: ()=>setNewJobModalVisible(false),
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: "OrderDraft__NewJobModal__container",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                    className: "OrderDraft__NewJobModal__title",
                                    children: t("order_draft.add_another_job")
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $009f3befb8e18271$export$2955d454eecc45c0), {
                                    text: t("order_draft.blank_job"),
                                    action: ()=>{
                                        redirect((0, $0534349ae8731d0b$export$66b32f6f30eb4b4).setJobCategory, {
                                            orderId: orderId,
                                            stepNumber: String(1)
                                        });
                                    },
                                    additionalStyle: {
                                        width: "80%"
                                    }
                                }),
                                jobs.length > 0 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $2c46e9e1f89bee75$export$2b47962e4e24eb4d), {
                                    text: t("order_draft.duplicate_job"),
                                    action: ()=>{
                                        setJobIdToDuplicate(jobs[0]?.id);
                                        setAllowSelectJobOnDuplicate(true);
                                        setDuplicateJobPopupVisible(true);
                                        setNewJobModalVisible(false);
                                    },
                                    additionalStyle: {
                                        width: "80%"
                                    }
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $9c16b10bbbe042e5$export$129a32eedafa97c5), {
                        close: ()=>{
                            setJobIdToDuplicate(null);
                            setAllowSelectJobOnDuplicate(false);
                            setDuplicateJobPopupVisible(false);
                        },
                        content: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ec31c720b6ba1f4b$export$2c2dd362eeffba67), {
                            showSelectJob: allowSelectJobOnDuplicate,
                            setJobId: (value)=>setJobIdToDuplicate(Number(value)),
                            jobsList: jobs.map((jobItem)=>{
                                return {
                                    id: jobItem.id,
                                    category_name: jobItem.category_name,
                                    quantity: jobItem.quantity
                                };
                            }),
                            orderId: orderId,
                            jobId: String(jobIdToDuplicate)
                        }),
                        isActive: duplicateJobPopupVisible
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $660b2ca422e0e2ae$export$1ff3c3f08ae963c0).Vertical, {
                        height: 80
                    })
                ]
            })
        ]
    });
});










const $323a86ff22145402$export$b2775b67f0963f7e = ()=>{
    const { t: t } = (0, $3765cebd031b52c0$export$9fc83ad70ead8663)();
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "OrderConfirmed",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $660b2ca422e0e2ae$export$1ff3c3f08ae963c0).Spacer, {
                minHeight: 20
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "OrderConfirmed__innerContainer",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $660b2ca422e0e2ae$export$1ff3c3f08ae963c0).Spacer, {}),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                        src: (0, (/*@__PURE__*/$parcel$interopDefault($e3993b62a3e754bd$exports))),
                        className: "OrderConfirmed__innerContainer__img"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $660b2ca422e0e2ae$export$1ff3c3f08ae963c0).Spacer, {
                        flex: 0.2
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h2", {
                        className: "OrderConfirmed__innerContainer__title",
                        children: t("order_confirmed.title")
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                        className: "OrderConfirmed__innerContainer__description",
                        children: t("order_confirmed.description")
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $660b2ca422e0e2ae$export$1ff3c3f08ae963c0).Spacer, {}),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $677661c9496f0f07$export$d5992c1fec905475), {
                        url: (0, $0534349ae8731d0b$export$66b32f6f30eb4b4).orders,
                        title: t("order_confirmed.done"),
                        params: {
                            ordersState: (0, $0f571f43d43ce782$export$819724757aafc79).Unconfirmed
                        },
                        className: "OrderConfirmed__innerContainer__closeButton"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $660b2ca422e0e2ae$export$1ff3c3f08ae963c0).Vertical, {
                        height: 40
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $660b2ca422e0e2ae$export$1ff3c3f08ae963c0).Spacer, {
                minHeight: 20
            })
        ]
    });
};




var $acw62 = parcelRequire("acw62");

var $45fvw = parcelRequire("45fvw");






















const $527d0d15a7b06b10$var$stepIndicatorConfig = {
    stepsCount: 4,
    currentStepNumber: 4
};
const $527d0d15a7b06b10$export$1bd72ef9703c72b5 = (0, $a4963babae245ff9$export$f0c7a449e0cfaec7)((0, $aca50e9407ba89c9$export$b6ae1bc530f4c149)(({ orderId: orderId, showAmend: showAmend })=>{
    const { account: account, getOrderSummary: getOrderSummary, getOrderIdSummary: getOrderIdSummary, submitOrder: submitOrder, getInvitedPastSPsByIds: getInvitedPastSPsByIds, invitedPastSPsList: invitedPastSPsList } = (0, $4671947198ddd366$export$6ccbb43953eebf8)().data;
    const [, getInvitedPastSPsByIdsQuery] = (0, $4671947198ddd366$export$609860bf8b0084c)(({ ids: ids })=>getInvitedPastSPsByIds(ids), {
        onError: (err)=>{
            (0, $60f27fc97e29822a$export$b410431fab84fa58).error(err.data.message);
        }
    });
    const orderSummary = getOrderIdSummary(orderId);
    const orderSummaryQuery = (0, $4671947198ddd366$export$dd0a697e1782aedd)(()=>getOrderSummary({
            orderId: orderId
        }), {
        filterError: [
            (0, $9ad33fbf770c55a1$export$9696fcf1798e1cb5).ClientError
        ],
        onSuccess: (res)=>{
            const invitedSPIds = [];
            res.jobs.forEach((job)=>{
                job.invited_sp_ids.forEach((invitedSPId)=>{
                    if (!invitedSPIds.includes(invitedSPId)) invitedSPIds.push(invitedSPId);
                });
            });
            getInvitedPastSPsByIdsQuery({
                ids: invitedSPIds
            });
        },
        onError: (err)=>{
            (0, $60f27fc97e29822a$export$b410431fab84fa58).error(err.data.message);
        }
    });
    const [submitOrderQuery, requestSubmitOrder] = (0, $4671947198ddd366$export$609860bf8b0084c)(submitOrder, {
        onSuccess: ()=>{
            redirect((0, $0534349ae8731d0b$export$66b32f6f30eb4b4).orderRequestSuccess, {
                orderId: orderId
            });
        },
        onError: (err)=>alert(err.data.message),
        filterError: [
            (0, $9ad33fbf770c55a1$export$9696fcf1798e1cb5).ClientError
        ]
    });
    (0, $acw62.useEffect)(()=>{
        (0, $c74a0566d4b0fd6d$export$e9db7d6e73593439).track((0, $c74a0566d4b0fd6d$export$5e27155e276f6d1c).ViewedNotSubmittedOrderSummary);
    }, []);
    const redirect = (0, $7df35e9df335b1c8$export$602eaf6d5314ce55)();
    const { t: t } = (0, $3765cebd031b52c0$export$9fc83ad70ead8663)();
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7b02d682eb115277$exports.Fragment), {
        children: orderSummaryQuery.isLoading || submitOrderQuery.isLoading ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $57fb8f45c69e1681$export$b08b517936747730), {}) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
            className: "OrderDraftSummary",
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7ae42b63183f30b4$export$8b251419efc915eb), {
                    showBack: true,
                    title: t("order.draft_order_title"),
                    rightComponent: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7aaa88adae16798b$export$ae1f41282e6c81da), {
                        jobsCount: orderSummary?.jobs.length,
                        orderId: Number(orderId)
                    })
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: "OrderDraftSummary__container",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $38509c18096ca465$export$a765b9dee96eca0e), {
                            stepsCount: $527d0d15a7b06b10$var$stepIndicatorConfig.stepsCount,
                            currentStepNumber: $527d0d15a7b06b10$var$stepIndicatorConfig.currentStepNumber
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $660b2ca422e0e2ae$export$1ff3c3f08ae963c0).Vertical, {
                            height: 14
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ec2248901324e8a8$export$2e2bcd8739ae039), {
                            image: (0, (/*@__PURE__*/$parcel$interopDefault($2c242e74e2590f15$exports))),
                            title: t("order.order_summary")
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $660b2ca422e0e2ae$export$1ff3c3f08ae963c0).Vertical, {
                            height: 14
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4a112c2694b1fd4a$export$2e2bcd8739ae039), {
                            location: orderSummary?.locations[0].name,
                            paymentTerms: orderSummary?.payment_terms_days,
                            startDate: orderSummary?.start_date ? (0, (/*@__PURE__*/$parcel$interopDefault($45fvw)))(orderSummary.start_date) : null,
                            endDate: orderSummary?.start_date ? (0, (/*@__PURE__*/$parcel$interopDefault($45fvw)))(orderSummary.end_date) : null,
                            showCompleteDetails: account?.account_type === (0, $97fa7686fb8e51ed$export$b8ca5fa4899cbfc7).CORPORATE && account.is_corporate_details_complete === false,
                            orderId: orderId,
                            showAmend: showAmend
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $660b2ca422e0e2ae$export$1ff3c3f08ae963c0).Vertical, {
                            height: 24
                        }),
                        orderSummary && orderSummary.jobs.length > 0 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ec2248901324e8a8$export$2e2bcd8739ae039), {
                                    image: (0, (/*@__PURE__*/$parcel$interopDefault($0d100698f4ff6bc8$exports))),
                                    title: t("order.jobs")
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $660b2ca422e0e2ae$export$1ff3c3f08ae963c0).Vertical, {
                                    height: 14
                                })
                            ]
                        }),
                        orderSummary?.jobs.map((job, i)=>{
                            const invitedSPs = invitedPastSPsList.filter((sp)=>job.invited_sp_ids.includes(sp.id));
                            return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $acw62.Fragment), {
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $d65ef9483570d398$export$2e2bcd8739ae039), {
                                        work_category_name: job.work_category_name,
                                        start_date: (0, (/*@__PURE__*/$parcel$interopDefault($45fvw)))(job.start_date),
                                        end_date: (0, (/*@__PURE__*/$parcel$interopDefault($45fvw)))(job.end_date),
                                        hours: job.hours,
                                        currency: job.currency,
                                        shifts: job.shifts,
                                        hourly_rate: job.hourly_rate,
                                        quantity: job.quantity,
                                        transportation_costs: job.transportation_costs,
                                        underReview: Boolean(orderSummary.is_pending_rates_review),
                                        showRate: false,
                                        showTransportations: false,
                                        invitedSPs: invitedSPs
                                    }),
                                    i !== orderSummary.jobs.length - 1 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $660b2ca422e0e2ae$export$1ff3c3f08ae963c0).Vertical, {
                                        height: 14
                                    })
                                ]
                            }, job.id);
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $660b2ca422e0e2ae$export$1ff3c3f08ae963c0).Vertical, {
                            height: 31
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $2ab88429e3384d30$export$353f5b6fc5456de1), {
                            onClick: ()=>requestSubmitOrder(orderId),
                            className: "OrderDraftSummary__sendForReviewButton",
                            children: t("order.send_for_review")
                        }),
                        showAmend && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $660b2ca422e0e2ae$export$1ff3c3f08ae963c0).Vertical, {
                                    height: 24
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $2ab88429e3384d30$export$353f5b6fc5456de1), {
                                    onClick: ()=>{
                                        redirect((0, $0534349ae8731d0b$export$66b32f6f30eb4b4).orderDraft, {
                                            orderId: orderId
                                        });
                                    },
                                    className: "OrderDraftSummary__amendButton",
                                    children: t("order.amend_order")
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $660b2ca422e0e2ae$export$1ff3c3f08ae963c0).Vertical, {
                            height: 30
                        })
                    ]
                })
            ]
        })
    });
}));













var $096ba0b0a3c9df15$exports = {};
$096ba0b0a3c9df15$exports = new URL("order_number.7683027d.svg", import.meta.url).toString();


var $3a84480327ad8d40$exports = {};
$3a84480327ad8d40$exports = new URL("jobs_count.87e114c4.svg", import.meta.url).toString();







const $af0ec91245c8228d$export$e942671312a13c88 = ({ backgroundColor: backgroundColor, text: text })=>{
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        className: "TextAlert__container",
        style: {
            backgroundColor: backgroundColor
        },
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
            className: "TextAlert__text",
            children: text
        })
    });
};








const $1a1da323b56f584f$var$stepIndicatorConfig = {
    stepsCount: 4,
    currentStepNumber: 4
};
const $1a1da323b56f584f$export$81f766471b94fc81 = (0, $a4963babae245ff9$export$f0c7a449e0cfaec7)((0, $aca50e9407ba89c9$export$b6ae1bc530f4c149)(({ orderId: orderId })=>{
    const { t: t } = (0, $3765cebd031b52c0$export$9fc83ad70ead8663)();
    const redirect = (0, $7df35e9df335b1c8$export$602eaf6d5314ce55)();
    const { getOrderSummary: getOrderSummary, getOrderIdSummary: getOrderIdSummary } = (0, $4671947198ddd366$export$6ccbb43953eebf8)().data;
    const orderSummary = getOrderIdSummary(String(orderId));
    const orderSummaryQuery = (0, $4671947198ddd366$export$dd0a697e1782aedd)(()=>getOrderSummary({
            orderId: String(orderId)
        }), {
        filterError: [
            (0, $9ad33fbf770c55a1$export$9696fcf1798e1cb5).ClientError
        ]
    });
    const isCorporateDetailsRequiredAndNotVerified = (0, $73ccb33f5de6f5aa$export$8707029d024490c9)().registration.allowOnlyCorporate && orderSummary?.corporate_details_verification_status !== (0, $85250b9063617b2f$export$f67e42527e0ac052);
    const hasInvitedSPs = Boolean(orderSummary?.jobs.filter((job)=>job.invited_sp_ids.length > 0).length);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "OrderRequested",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7ae42b63183f30b4$export$8b251419efc915eb), {
                showBack: true,
                title: t("order_draft.title")
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $660b2ca422e0e2ae$export$1ff3c3f08ae963c0).Vertical, {
                height: 50
            }),
            orderSummaryQuery.isLoading ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $57fb8f45c69e1681$export$2e2bcd8739ae039), {}) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "OrderRequested__innerContainer",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $38509c18096ca465$export$a765b9dee96eca0e), {
                        stepsCount: $1a1da323b56f584f$var$stepIndicatorConfig.stepsCount,
                        currentStepNumber: $1a1da323b56f584f$var$stepIndicatorConfig.currentStepNumber
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $660b2ca422e0e2ae$export$1ff3c3f08ae963c0).Vertical, {
                        height: 15
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h2", {
                        className: "OrderRequested__innerContainer__title",
                        children: t("order_requested.title")
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $660b2ca422e0e2ae$export$1ff3c3f08ae963c0).Vertical, {
                        height: 20
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "OrderRequested__horizontalStats",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "OrderRequested__horizontalStats__item",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                                        className: "OrderRequested__horizontalStats__item__image",
                                        src: (0, (/*@__PURE__*/$parcel$interopDefault($096ba0b0a3c9df15$exports)))
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                        className: "OrderRequested__horizontalStats__item__title",
                                        children: t("order.order_number", {
                                            id: orderId
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "OrderRequested__horizontalStats__item",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                                        className: "OrderRequested__horizontalStats__item__image",
                                        src: (0, (/*@__PURE__*/$parcel$interopDefault($3a84480327ad8d40$exports)))
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                        className: "OrderRequested__horizontalStats__item__title",
                                        children: t("order_draft.jobs_count", {
                                            count: orderSummary?.jobs.length
                                        })
                                    })
                                ]
                            })
                        ]
                    }),
                    isCorporateDetailsRequiredAndNotVerified && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $660b2ca422e0e2ae$export$1ff3c3f08ae963c0).Vertical, {
                                height: 14
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $af0ec91245c8228d$export$e942671312a13c88), {
                                backgroundColor: "rgba(252, 179, 92, 0.2)",
                                text: t("order.need_to_review_corporate_details")
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $660b2ca422e0e2ae$export$1ff3c3f08ae963c0).Vertical, {
                                height: 40
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                        src: (0, (/*@__PURE__*/$parcel$interopDefault($e3993b62a3e754bd$exports))),
                        className: "OrderRequested__innerContainer__img"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $660b2ca422e0e2ae$export$1ff3c3f08ae963c0).Spacer, {
                        flex: 0.2
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                        className: "OrderRequested__innerContainer__description",
                        children: t("order_requested.subtitle")
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $660b2ca422e0e2ae$export$1ff3c3f08ae963c0).Spacer, {}),
                    !isCorporateDetailsRequiredAndNotVerified && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7b02d682eb115277$exports.Fragment), {
                        children: hasInvitedSPs ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $677661c9496f0f07$export$d5992c1fec905475), {
                            url: (0, $0534349ae8731d0b$export$66b32f6f30eb4b4).allJobs,
                            title: t("order_requested.done"),
                            params: {
                                date: (0, $ddf12117b815a7c3$export$efb113ee57e9edfb)(new Date())
                            },
                            className: "OrderRequested__innerContainer__closeButton"
                        }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $677661c9496f0f07$export$d5992c1fec905475), {
                            url: (0, $0534349ae8731d0b$export$66b32f6f30eb4b4).orders,
                            title: t("order_requested.done"),
                            params: {
                                ordersState: String((0, $0f571f43d43ce782$export$819724757aafc79).Unconfirmed)
                            },
                            className: "OrderRequested__innerContainer__closeButton"
                        })
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $660b2ca422e0e2ae$export$1ff3c3f08ae963c0).Vertical, {
                        height: 40
                    }),
                    isCorporateDetailsRequiredAndNotVerified && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $4a1895475c466679$export$c072955bb62eb0e2), {
                        onClick: ()=>{},
                        style: {
                            justifyContent: "center"
                        },
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                className: "OrderRequested__actionPanel__secondaryButton",
                                onClick: ()=>redirect((0, $0534349ae8731d0b$export$66b32f6f30eb4b4).index, {}),
                                children: t("order_requested.later")
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                className: "OrderRequested__actionPanel__primaryButton",
                                onClick: ()=>redirect((0, $0534349ae8731d0b$export$66b32f6f30eb4b4).completeRegistration, {}),
                                children: t("order_requested.complete_registration")
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $660b2ca422e0e2ae$export$1ff3c3f08ae963c0).Spacer, {
                minHeight: 20
            })
        ]
    });
}));




var $acw62 = parcelRequire("acw62");










const $46423c6ee527c230$export$82631400ad40dac9 = (job)=>{
    return {
        work_category_id: job.category.id,
        quantity: job.quantity.value,
        client_location_id: job.location.value?.id,
        public_transport_accessibility: job.transport.value,
        start_date: job.schedule.dateBoundaries.start_date,
        end_date: job.schedule.dateBoundaries.end_date,
        is_recurring: job.schedule.dateBoundaries.open_ended ? 1 : 0,
        contact_user_id: job.manager.id,
        work_requirement_ids: job.requirements.list,
        instructions: job.description.value,
        seniority_level: Number(job.experience.value),
        gender: job.gender.value ? Number(job.gender.value) : null,
        uniform_id: job.dresscode.id,
        invited_sp_ids: job.invitedSPs.list,
        languages: job.languages.list,
        certificates: job.documents.list,
        is_automatic_checkout: 1,
        intervals: job.schedule.distinctTimeSchedule.map,
        assignment_type: 1,
        is_accreditation_required: job.accreditation.value ? 1 : 0,
        is_accommodation_offered: job.accommodation.value ? 1 : 0,
        is_interview_required: job.manualSelection.use_interview ? 1 : 0,
        boarding_type: job.boarding.value,
        nationalities: job.nationalities.nationalities_list,
        ethnicities: job.nationalities.ethnicities_list
    };
};



function $613af6860b59ef3f$export$d3e7046ad6c4aa78(UIComponent) {
    return (0, $a4963babae245ff9$export$f0c7a449e0cfaec7)((0, $aca50e9407ba89c9$export$b6ae1bc530f4c149)(({ duplicatedOrderId: duplicatedOrderId })=>{
        const [draftJobs, setDraftJobs] = (0, $acw62.useState)(null);
        const { getDuplicatedOrderJobs: getDuplicatedOrderJobs, duplicateOrder: duplicateOrder, createInterview: createInterview, duplicatedOrderJobIds: duplicatedOrderJobIds } = (0, $4671947198ddd366$export$6ccbb43953eebf8)().data;
        const getJobsQuery = (0, $4671947198ddd366$export$dd0a697e1782aedd)(()=>getDuplicatedOrderJobs(duplicatedOrderId), {
            onSuccess: (result)=>{
                setDraftJobs(result.filter((job)=>duplicatedOrderJobIds.includes(job.id)).map((job)=>{
                    const jobDetails = (0, $487f9fae786cd5fa$export$4970faf62e67ab48).create(job);
                    return (0, $957237d860259090$export$d9b822eccad2c4b0)(jobDetails);
                }));
            }
        });
        const [currentJobIndex, setCurrentJobIndex] = (0, $acw62.useState)(0);
        const { t: t } = (0, $3765cebd031b52c0$export$9fc83ad70ead8663)();
        const redirect = (0, $7df35e9df335b1c8$export$602eaf6d5314ce55)();
        const [, requestCreateInterview] = (0, $4671947198ddd366$export$609860bf8b0084c)(createInterview, {
            filterError: Object.values((0, $9ad33fbf770c55a1$export$9696fcf1798e1cb5)),
            onError: ()=>{
                // Makes Sentry to have it as a separate error with all logs/breadcrumbs
                console.error("Create Interview API Error (Order Duplication)");
            }
        });
        const [, duplicateOrderRequest] = (0, $4671947198ddd366$export$609860bf8b0084c)(duplicateOrder, {
            filterError: [
                (0, $9ad33fbf770c55a1$export$9696fcf1798e1cb5).ClientError
            ],
            onSuccess: (result)=>{
                if (draftJobs === null) throw new Error("Unexpected null instead of DraftJobInstance[]");
                draftJobs.forEach((job, index)=>{
                    if (job.manualSelection.use_interview && job.manualSelection.interview_questions?.length) requestCreateInterview({
                        jobId: result.job_ids[index],
                        workCategoryId: job.category.id,
                        questions: job.manualSelection.interview_questions
                    });
                });
                redirect((0, $0534349ae8731d0b$export$66b32f6f30eb4b4).orderDraft, {
                    orderId: String(result.id),
                    title: t("duplicate_order.duplicate_order")
                });
            },
            onError: (err)=>{
                const errorMessage = Object.values({
                    ...err.data.errors
                }).join(";");
                (0, $60f27fc97e29822a$export$b410431fab84fa58).error(errorMessage);
                setCurrentJobIndex(0);
            }
        });
        const isLatestJob = draftJobs ? currentJobIndex === draftJobs.length - 1 : true;
        const isFirstJob = currentJobIndex === 0;
        return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)(UIComponent, {
            isLoading: getJobsQuery.isLoading,
            draftJobs: draftJobs,
            currentJobIndex: currentJobIndex,
            duplicatedOrderId: duplicatedOrderId,
            isLatestJob: isLatestJob,
            onSubmit: (draftJob)=>{
                const isValid = draftJob.validateForm();
                if (!isValid) return;
                if (!isLatestJob) {
                    setCurrentJobIndex(currentJobIndex + 1);
                    return;
                }
                const jobsFormData = draftJobs.map((job)=>(0, $862a04ca6e0d681b$export$c38f30dcbe2bbd3a)((0, $46423c6ee527c230$export$82631400ad40dac9)(job)));
                duplicateOrderRequest(jobsFormData);
            },
            getFormTitle: (professionName)=>{
                return `Duplicate ${t("job_draft_details.title", {
                    category: professionName
                })}`;
            },
            isFirstJob: isFirstJob,
            handleBackPress: ()=>setCurrentJobIndex(currentJobIndex - 1)
        });
    }));
}







const $ad8eb8cf87f9ebb1$export$9822ba513b01839f = ({ isLoading: isLoading, draftJobs: draftJobs, currentJobIndex: currentJobIndex, duplicatedOrderId: duplicatedOrderId, isLatestJob: isLatestJob, onSubmit: onSubmit, getFormTitle: getFormTitle, isFirstJob: isFirstJob, handleBackPress: handleBackPress })=>{
    const { t: t } = (0, $3765cebd031b52c0$export$9fc83ad70ead8663)();
    const handleSubmit = ()=>{
        onSubmit(draftJobs[currentJobIndex]);
    };
    return isLoading || draftJobs === null ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $57fb8f45c69e1681$export$2e2bcd8739ae039), {}) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $a65bc1b27fa6c508$export$3f3206c79d29743e), {
        formSubtitle: t("duplicate_order.duplicate_job_subtitle"),
        orderDraftTitle: t("duplicate_order.duplicate_order"),
        job: draftJobs[currentJobIndex],
        orderId: String(duplicatedOrderId),
        isExtension: false,
        onSubmit: handleSubmit,
        getFormTitle: getFormTitle,
        formActions: (isSubmitting)=>{
            return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $9dfc32a0a996fa14$export$ed8ca599049e8881), {
                stepsCount: draftJobs.length,
                currentStep: currentJobIndex,
                nextDisabled: false,
                backDisabled: isFirstJob,
                nextButtonLabel: !isLatestJob ? t("job_draft_details.next") : t("job_draft_details.create_duplicate"),
                shouldNextButtonSubmitForm: true,
                handleNextPress: handleSubmit,
                handleBackPress: handleBackPress,
                objectNameLabel: "Job"
            });
        }
    });
};


const $3e21ec7453e6a2fe$export$597647c8a80ff697 = (0, $613af6860b59ef3f$export$d3e7046ad6c4aa78)((0, $ad8eb8cf87f9ebb1$export$9822ba513b01839f));




var $acw62 = parcelRequire("acw62");





function $1848171fdc9d3a72$export$32bd267de18a3078(UIComponent) {
    return (0, $a4963babae245ff9$export$f0c7a449e0cfaec7)((0, $aca50e9407ba89c9$export$b6ae1bc530f4c149)(({ duplicatedOrderId: duplicatedOrderId })=>{
        const [jobs, setJobs] = (0, $acw62.useState)([]);
        const { getDuplicatedOrderJobs: getDuplicatedOrderJobs, removeDuplicatedJobId: removeDuplicatedJobId, addDuplicatedJobId: addDuplicatedJobId, duplicatedOrderJobIds: duplicatedOrderJobIds } = (0, $4671947198ddd366$export$6ccbb43953eebf8)().data;
        const getJobsQuery = (0, $4671947198ddd366$export$dd0a697e1782aedd)(()=>getDuplicatedOrderJobs(duplicatedOrderId), {
            onSuccess: (result)=>{
                setJobs(result);
            }
        });
        const redirect = (0, $7df35e9df335b1c8$export$602eaf6d5314ce55)();
        const isJobChosen = (jobId)=>{
            return duplicatedOrderJobIds.includes(jobId);
        };
        return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)(UIComponent, {
            isLoading: getJobsQuery.isLoading,
            jobs: jobs,
            isJobChosen: isJobChosen,
            removeDuplicatedJobId: (jobId)=>removeDuplicatedJobId(jobId),
            addDuplicatedJobId: (jobId)=>addDuplicatedJobId(jobId),
            chosenJobsLength: duplicatedOrderJobIds.length,
            onSubmit: ()=>redirect((0, $0534349ae8731d0b$export$66b32f6f30eb4b4).orderDuplicate, {
                    orderId: String(duplicatedOrderId)
                })
        });
    }));
}




var $acw62 = parcelRequire("acw62");





var $d863fe99957c5935$exports = {};
$d863fe99957c5935$exports = new URL("check-mark.928885fa.svg", import.meta.url).toString();


const $6ba41a673c0feb22$export$fd7ef5f41e59d9a0 = ({ jobId: jobId, isJobChosen: isJobChosen, removeDuplicatedJobId: removeDuplicatedJobId, addDuplicatedJobId: addDuplicatedJobId, categoryName: categoryName, quantity: quantity, clientLocationName: clientLocationName })=>{
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: `ChooseJobs__jobContainer${isJobChosen ? " ChooseJobs__jobContainer--selected" : ""}`,
        onClick: ()=>{
            isJobChosen ? removeDuplicatedJobId() : addDuplicatedJobId();
        },
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "ChooseJobs__jobContainer__actions",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                        className: "ChooseJobs__jobContainer__jobTitle",
                        children: categoryName
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "ChooseJobs__jobContainer__actionSelect",
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                            src: (0, (/*@__PURE__*/$parcel$interopDefault($d863fe99957c5935$exports))),
                            className: "ChooseJobs__jobContainer__actionSelect__checkMark"
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "ChooseJobs__jobContainer__property",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                        className: "ChooseJobs__jobContainer__property__key",
                        children: "Quantity"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                        className: "ChooseJobs__jobContainer__property__value",
                        children: quantity
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "ChooseJobs__jobContainer__property",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                        className: "ChooseJobs__jobContainer__property__key",
                        children: "Location"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                        className: "ChooseJobs__jobContainer__property__value",
                        children: clientLocationName
                    })
                ]
            })
        ]
    }, jobId);
};



const $15297378488e8a1b$export$65eabf0218ea24be = ({ isLoading: isLoading, jobs: jobs, isJobChosen: isJobChosen, removeDuplicatedJobId: removeDuplicatedJobId, addDuplicatedJobId: addDuplicatedJobId, chosenJobsLength: chosenJobsLength, onSubmit: onSubmit })=>{
    const { t: t } = (0, $3765cebd031b52c0$export$9fc83ad70ead8663)();
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $acw62.Fragment), {
        children: isLoading ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $57fb8f45c69e1681$export$2e2bcd8739ae039), {}) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $acw62.Fragment), {
            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "ChooseJobs__container",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7ae42b63183f30b4$export$8b251419efc915eb), {
                        title: t("duplicate_order.duplicate_order")
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "ChooseJobs__titlesContainer",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                className: "ChooseJobs__titlesContainer__mainTitle",
                                children: t("duplicate_order.choose_jobs_main_title")
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                className: "ChooseJobs__titlesContainer__secondaryTitle",
                                children: t("duplicate_order.choose_jobs_secondary_title")
                            })
                        ]
                    }),
                    jobs.map((job)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $6ba41a673c0feb22$export$fd7ef5f41e59d9a0), {
                            jobId: job.id,
                            isJobChosen: isJobChosen(job.id),
                            removeDuplicatedJobId: ()=>removeDuplicatedJobId(job.id),
                            addDuplicatedJobId: ()=>addDuplicatedJobId(job.id),
                            categoryName: job.category_name,
                            quantity: job.quantity,
                            clientLocationName: job.client_location_name
                        }, job.id)),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $2ab88429e3384d30$export$353f5b6fc5456de1), {
                        disabled: chosenJobsLength === 0,
                        title: t("duplicate_order.choose_jobs_confirm"),
                        type: "button",
                        className: "ChooseJobs__confirmButton",
                        onClick: onSubmit
                    })
                ]
            })
        })
    });
};


const $df6108c3edfff4d4$export$225e10d6453da328 = (0, $1848171fdc9d3a72$export$32bd267de18a3078)((0, $15297378488e8a1b$export$65eabf0218ea24be));





var $acw62 = parcelRequire("acw62");

















const $1258019dec27db3d$var$stepIndicatorConfig = {
    stepsCount: 4,
    currentStepNumber: 2
};
const $1258019dec27db3d$export$ea4551635e903bcb = (0, $aca50e9407ba89c9$export$b6ae1bc530f4c149)(({ orderId: orderId, draftJobId: draftJobId, stepNumber: stepNumber, showStepIndicator: showStepIndicator })=>{
    const { t: t } = (0, $3765cebd031b52c0$export$9fc83ad70ead8663)();
    const { getProfessionName: getProfessionName, locationsDataView: locationsDataView, getLocations: getLocations, getLocationByName: getLocationByName } = (0, $4671947198ddd366$export$6ccbb43953eebf8)().data;
    const [regionsModalVisible, setRegionsModalVisible] = (0, $acw62.useState)(false);
    const { enableQuery: getLocationsQuery, query: locationsQuery } = (0, $4671947198ddd366$export$517ca4f7fee4e226)(()=>getLocations({}));
    (0, $acw62.useEffect)(()=>{
        getLocationsQuery();
    }, []);
    const { createDraftJob: createDraftJob, getDraftJob: getDraftJob } = (0, $d6286036be37a1b2$export$6feca3f67f446ef2)();
    const job = draftJobId ? getDraftJob(draftJobId) : createDraftJob();
    const redirect = (0, $7df35e9df335b1c8$export$602eaf6d5314ce55)();
    (0, $acw62.useEffect)(()=>{
        if (!job.location.value && locationsDataView.length > 0) {
            const { id: id, name: name, public_transport_accessibility: public_transport_accessibility } = locationsDataView[0];
            job.location.set({
                id: id,
                name: name
            });
            job.manager.set(null);
            if (public_transport_accessibility !== null) job.fields.removePublicTransportAccessibilityField();
            else job.fields.addPublicTransportAccessibilityField();
        }
    }, [
        locationsDataView,
        locationsDataView.length
    ]);
    const locationFormRef = (0, $acw62.useRef)(null);
    const onLocationFormSubmit = (location)=>{
        if (Boolean(locationFormRef.current?.errors)) return;
        else {
            job.location.clearError();
            job.location.set({
                id: location.id,
                name: location.name
            });
            job.manager.set(null);
            redirect((0, $0534349ae8731d0b$export$66b32f6f30eb4b4).jobDraftDetails, {
                orderId: orderId,
                draftJobId: String(draftJobId),
                stepNumber: "3"
            });
        }
    };
    const locationOptions = locationsDataView.length > 0 ? locationsDataView.map((location)=>({
            key: String(location.id),
            label: location.name,
            value: location.name
        })) : null;
    const onSubmit = async ()=>{
        if (job.location.value) redirect((0, $0534349ae8731d0b$export$66b32f6f30eb4b4).jobDraftDetails, {
            orderId: orderId,
            draftJobId: String(draftJobId),
            stepNumber: "3"
        });
        else await locationFormRef.current?.submitForm();
    };
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $5a954f40174a984b$export$78108cd43e2ad049).Provider, {
        value: job,
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7ae42b63183f30b4$export$8b251419efc915eb), {
                title: getProfessionName(Number(job.category.id))
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "JobDraftLocation",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $660b2ca422e0e2ae$export$1ff3c3f08ae963c0).Vertical, {
                        height: 24
                    }),
                    showStepIndicator && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $38509c18096ca465$export$a765b9dee96eca0e), {
                        stepsCount: $1258019dec27db3d$var$stepIndicatorConfig.stepsCount,
                        currentStepNumber: stepNumber ?? $1258019dec27db3d$var$stepIndicatorConfig.currentStepNumber
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                        className: "JobDraftCategory__title",
                        children: t("job_draft_details.location_title")
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                        className: "JobDraftCategory__subtitle",
                        children: t("job_draft_details.location_subtitle")
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $660b2ca422e0e2ae$export$1ff3c3f08ae963c0).Vertical, {
                        height: 24
                    }),
                    locationsQuery.isLoading ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $57fb8f45c69e1681$export$2e2bcd8739ae039), {}) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7b02d682eb115277$exports.Fragment), {
                        children: locationOptions === null ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $606c9b8f795454be$export$2e2bcd8739ae039), {
                            formRef: locationFormRef,
                            onSubmit: onLocationFormSubmit,
                            showSubmit: false,
                            showLocationNameField: false,
                            showAddressDetailsField: false,
                            showImageField: false,
                            showCheckInRestrictionsBlock: false,
                            onLocationSelected: job.location.clearError,
                            children: !locationFormRef.current?.errors && job.location.error && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $17a27c6ba7085f84$export$57b95d3630b174f6), {
                                error: job.location.error,
                                style: {
                                    position: "absolute"
                                }
                            })
                        }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f2c1b8699595d8c0$export$ef9b1a59e592288f), {
                                    label: t("job_draft_details.location"),
                                    value: job.location.value?.name,
                                    onChange: (value)=>{
                                        const { id: id, name: name, public_transport_accessibility: public_transport_accessibility } = getLocationByName(value);
                                        job.location.set({
                                            id: id,
                                            name: name
                                        });
                                        job.manager.set(null);
                                        if (public_transport_accessibility !== null) job.fields.removePublicTransportAccessibilityField();
                                        else job.fields.addPublicTransportAccessibilityField();
                                    },
                                    options: locationOptions,
                                    className: "JobDraftLocation__locationSelect"
                                }),
                                job.location.error && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $17a27c6ba7085f84$export$57b95d3630b174f6), {
                                    error: job.location.error
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $660b2ca422e0e2ae$export$1ff3c3f08ae963c0).Vertical, {
                                    height: 35
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $2ab88429e3384d30$export$353f5b6fc5456de1), {
                                    onClick: ()=>{
                                        setRegionsModalVisible(true);
                                    },
                                    className: "JobDraftLocation__addLocationButton",
                                    style: {
                                        width: "100%"
                                    },
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                                            src: (0, (/*@__PURE__*/$parcel$interopDefault($f4eec0b7d0a3dabc$exports))),
                                            className: "JobDraftLocation__addLocationButton__img"
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                            className: "JobDraftLocation__addLocationButton__title",
                                            children: t("job_draft_details.location_add_new")
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $c786671f641538e1$export$446bb0a5366f9068), {
                                    modalVisible: regionsModalVisible,
                                    onClose: ()=>{
                                        setRegionsModalVisible(false);
                                    },
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                            className: "JobDraftLocation__modalHeader",
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {}),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                    className: "JobDraftLocation__modalHeader__modalTitle",
                                                    children: t("job_draft_details.location_add")
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                                                    src: (0, (/*@__PURE__*/$parcel$interopDefault($c8242b1acdd8c5a0$exports))),
                                                    onClick: ()=>{
                                                        setRegionsModalVisible(false);
                                                    },
                                                    className: "JobDraftLocation__modalHeader__modalCloseImg"
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $606c9b8f795454be$export$2e2bcd8739ae039), {
                                            onSubmit: ()=>{
                                                setRegionsModalVisible(false);
                                            },
                                            showSubmit: true,
                                            showLocationNameField: true,
                                            showAddressDetailsField: true,
                                            showImageField: true,
                                            showCheckInRestrictionsBlock: true
                                        })
                                    ]
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $660b2ca422e0e2ae$export$1ff3c3f08ae963c0).Vertical, {
                        height: 12
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $2c46e9e1f89bee75$export$2b47962e4e24eb4d), {
                        text: t("sign_up.next"),
                        // eslint-disable-next-line @typescript-eslint/no-misused-promises
                        action: onSubmit
                    })
                ]
            })
        ]
    });
});













var $acw62 = parcelRequire("acw62");

var $d2b63732fb4ff365$exports = {};
//
$d2b63732fb4ff365$exports = function shallowEqual(objA, objB, compare, compareContext) {
    var ret = compare ? compare.call(compareContext, objA, objB) : void 0;
    if (ret !== void 0) return !!ret;
    if (objA === objB) return true;
    if (typeof objA !== "object" || !objA || typeof objB !== "object" || !objB) return false;
    var keysA = Object.keys(objA);
    var keysB = Object.keys(objB);
    if (keysA.length !== keysB.length) return false;
    var bHasOwnProperty = Object.prototype.hasOwnProperty.bind(objB);
    // Test for A's keys different from B.
    for(var idx = 0; idx < keysA.length; idx++){
        var key = keysA[idx];
        if (!bHasOwnProperty(key)) return false;
        var valueA = objA[key];
        var valueB = objB[key];
        ret = compare ? compare.call(compareContext, valueA, valueB, key) : void 0;
        if (ret === false || ret === void 0 && valueA !== valueB) return false;
    }
    return true;
};






/** We only think `undefined` is empty */ function $dbf5d1f4f4ecbb6a$var$hasValue(value) {
    return value !== undefined;
}
function $dbf5d1f4f4ecbb6a$export$2e2bcd8739ae039(defaultStateValue, option) {
    var _ref = option || {}, defaultValue = _ref.defaultValue, value = _ref.value, onChange = _ref.onChange, postState = _ref.postState;
    // ======================= Init =======================
    var _useState = (0, $25e137fc56329ad1$export$2e2bcd8739ae039)(function() {
        if ($dbf5d1f4f4ecbb6a$var$hasValue(value)) return value;
        else if ($dbf5d1f4f4ecbb6a$var$hasValue(defaultValue)) return typeof defaultValue === "function" ? defaultValue() : defaultValue;
        else return typeof defaultStateValue === "function" ? defaultStateValue() : defaultStateValue;
    }), _useState2 = (0, $adaabbc18727b3e6$export$2e2bcd8739ae039)(_useState, 2), innerValue = _useState2[0], setInnerValue = _useState2[1];
    var mergedValue = value !== undefined ? value : innerValue;
    var postMergedValue = postState ? postState(mergedValue) : mergedValue;
    // ====================== Change ======================
    var onChangeFn = (0, $01e43e72865dc583$export$2e2bcd8739ae039)(onChange);
    var _useState3 = (0, $25e137fc56329ad1$export$2e2bcd8739ae039)([
        mergedValue
    ]), _useState4 = (0, $adaabbc18727b3e6$export$2e2bcd8739ae039)(_useState3, 2), prevValue = _useState4[0], setPrevValue = _useState4[1];
    (0, $493347a9fd5d8394$export$9283e56bae2f7b0f)(function() {
        var prev = prevValue[0];
        if (innerValue !== prev) onChangeFn(innerValue, prev);
    }, [
        prevValue
    ]);
    // Sync value back to `undefined` when it from control to un-control
    (0, $493347a9fd5d8394$export$9283e56bae2f7b0f)(function() {
        if (!$dbf5d1f4f4ecbb6a$var$hasValue(value)) setInnerValue(value);
    }, [
        value
    ]);
    // ====================== Update ======================
    var triggerChange = (0, $01e43e72865dc583$export$2e2bcd8739ae039)(function(updater, ignoreDestroy) {
        setInnerValue(updater, ignoreDestroy);
        setPrevValue([
            mergedValue
        ], ignoreDestroy);
    });
    return [
        postMergedValue,
        triggerChange
    ];
}





var $acw62 = parcelRequire("acw62");





var $acw62 = parcelRequire("acw62");



var $acw62 = parcelRequire("acw62");
var $d315e37ebd8360d8$var$SliderContext = /*#__PURE__*/ $acw62.createContext({
    min: 0,
    max: 0,
    direction: "ltr",
    step: 1,
    includedStart: 0,
    includedEnd: 0,
    tabIndex: 0
});
var $d315e37ebd8360d8$export$2e2bcd8739ae039 = $d315e37ebd8360d8$var$SliderContext;


function $d9ddb32dfdf86c65$export$622cea445a1c5b7d(value, min, max) {
    return (value - min) / (max - min);
}
function $d9ddb32dfdf86c65$export$a41628415415e6e(direction, value, min, max) {
    var offset = $d9ddb32dfdf86c65$export$622cea445a1c5b7d(value, min, max);
    var positionStyle = {};
    switch(direction){
        case "rtl":
            positionStyle.right = "".concat(offset * 100, "%");
            positionStyle.transform = "translateX(50%)";
            break;
        case "btt":
            positionStyle.bottom = "".concat(offset * 100, "%");
            positionStyle.transform = "translateY(50%)";
            break;
        case "ttb":
            positionStyle.top = "".concat(offset * 100, "%");
            positionStyle.transform = "translateY(-50%)";
            break;
        default:
            positionStyle.left = "".concat(offset * 100, "%");
            positionStyle.transform = "translateX(-50%)";
            break;
    }
    return positionStyle;
}
function $d9ddb32dfdf86c65$export$ddfa24987dade61b(value, index) {
    return Array.isArray(value) ? value[index] : value;
}


var $ea6359646810a9a3$var$_excluded = [
    "prefixCls",
    "value",
    "valueIndex",
    "onStartMove",
    "style",
    "render",
    "dragging",
    "onOffsetChange"
];
var $ea6359646810a9a3$var$Handle = /*#__PURE__*/ $acw62.forwardRef(function(props, ref) {
    var _classNames, _getIndex;
    var prefixCls = props.prefixCls, value = props.value, valueIndex = props.valueIndex, onStartMove = props.onStartMove, style = props.style, render = props.render, dragging = props.dragging, onOffsetChange = props.onOffsetChange, restProps = (0, $73ef9ce1c41fc0c0$export$2e2bcd8739ae039)(props, $ea6359646810a9a3$var$_excluded);
    var _React$useContext = $acw62.useContext((0, $d315e37ebd8360d8$export$2e2bcd8739ae039)), min = _React$useContext.min, max = _React$useContext.max, direction = _React$useContext.direction, disabled = _React$useContext.disabled, range = _React$useContext.range, tabIndex = _React$useContext.tabIndex, ariaLabelForHandle = _React$useContext.ariaLabelForHandle, ariaLabelledByForHandle = _React$useContext.ariaLabelledByForHandle, ariaValueTextFormatterForHandle = _React$useContext.ariaValueTextFormatterForHandle;
    var handlePrefixCls = "".concat(prefixCls, "-handle"); // ============================ Events ============================
    var onInternalStartMove = function onInternalStartMove(e) {
        if (!disabled) onStartMove(e, valueIndex);
    }; // =========================== Keyboard ===========================
    var onKeyDown = function onKeyDown(e) {
        if (!disabled) {
            var offset = null; // Change the value
            switch(e.which || e.keyCode){
                case (0, $d8d9cb1a28007639$export$2e2bcd8739ae039).LEFT:
                    offset = direction === "ltr" || direction === "btt" ? -1 : 1;
                    break;
                case (0, $d8d9cb1a28007639$export$2e2bcd8739ae039).RIGHT:
                    offset = direction === "ltr" || direction === "btt" ? 1 : -1;
                    break;
                // Up is plus
                case (0, $d8d9cb1a28007639$export$2e2bcd8739ae039).UP:
                    offset = direction !== "ttb" ? 1 : -1;
                    break;
                // Down is minus
                case (0, $d8d9cb1a28007639$export$2e2bcd8739ae039).DOWN:
                    offset = direction !== "ttb" ? -1 : 1;
                    break;
                case (0, $d8d9cb1a28007639$export$2e2bcd8739ae039).HOME:
                    offset = "min";
                    break;
                case (0, $d8d9cb1a28007639$export$2e2bcd8739ae039).END:
                    offset = "max";
                    break;
                case (0, $d8d9cb1a28007639$export$2e2bcd8739ae039).PAGE_UP:
                    offset = 2;
                    break;
                case (0, $d8d9cb1a28007639$export$2e2bcd8739ae039).PAGE_DOWN:
                    offset = -2;
                    break;
            }
            if (offset !== null) {
                e.preventDefault();
                onOffsetChange(offset, valueIndex);
            }
        }
    }; // ============================ Offset ============================
    var positionStyle = (0, $d9ddb32dfdf86c65$export$a41628415415e6e)(direction, value, min, max); // ============================ Render ============================
    var handleNode = /*#__PURE__*/ $acw62.createElement("div", (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))(handlePrefixCls, (_classNames = {}, (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)(_classNames, "".concat(handlePrefixCls, "-").concat(valueIndex + 1), range), (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)(_classNames, "".concat(handlePrefixCls, "-dragging"), dragging), _classNames)),
        style: (0, $983350b7b3960a26$export$2e2bcd8739ae039)((0, $983350b7b3960a26$export$2e2bcd8739ae039)({}, positionStyle), style),
        onMouseDown: onInternalStartMove,
        onTouchStart: onInternalStartMove,
        onKeyDown: onKeyDown,
        tabIndex: disabled ? null : (0, $d9ddb32dfdf86c65$export$ddfa24987dade61b)(tabIndex, valueIndex),
        role: "slider",
        "aria-valuemin": min,
        "aria-valuemax": max,
        "aria-valuenow": value,
        "aria-disabled": disabled,
        "aria-label": (0, $d9ddb32dfdf86c65$export$ddfa24987dade61b)(ariaLabelForHandle, valueIndex),
        "aria-labelledby": (0, $d9ddb32dfdf86c65$export$ddfa24987dade61b)(ariaLabelledByForHandle, valueIndex),
        "aria-valuetext": (_getIndex = (0, $d9ddb32dfdf86c65$export$ddfa24987dade61b)(ariaValueTextFormatterForHandle, valueIndex)) === null || _getIndex === void 0 ? void 0 : _getIndex(value)
    }, restProps)); // Customize
    if (render) handleNode = render(handleNode, {
        index: valueIndex,
        prefixCls: prefixCls,
        value: value,
        dragging: dragging
    });
    return handleNode;
});
$ea6359646810a9a3$var$Handle.displayName = "Handle";
var $ea6359646810a9a3$export$2e2bcd8739ae039 = $ea6359646810a9a3$var$Handle;



var $33124806a04337b6$var$_excluded = [
    "prefixCls",
    "style",
    "onStartMove",
    "onOffsetChange",
    "values",
    "handleRender",
    "draggingIndex"
];
var $33124806a04337b6$var$Handles = /*#__PURE__*/ $acw62.forwardRef(function(props, ref) {
    var prefixCls = props.prefixCls, style = props.style, onStartMove = props.onStartMove, onOffsetChange = props.onOffsetChange, values = props.values, handleRender = props.handleRender, draggingIndex = props.draggingIndex, restProps = (0, $73ef9ce1c41fc0c0$export$2e2bcd8739ae039)(props, $33124806a04337b6$var$_excluded);
    var handlesRef = $acw62.useRef({});
    $acw62.useImperativeHandle(ref, function() {
        return {
            focus: function focus(index) {
                var _handlesRef$current$i;
                (_handlesRef$current$i = handlesRef.current[index]) === null || _handlesRef$current$i === void 0 || _handlesRef$current$i.focus();
            }
        };
    });
    return /*#__PURE__*/ $acw62.createElement($acw62.Fragment, null, values.map(function(value, index) {
        return /*#__PURE__*/ $acw62.createElement((0, $ea6359646810a9a3$export$2e2bcd8739ae039), (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({
            ref: function ref(node) {
                if (!node) delete handlesRef.current[index];
                else handlesRef.current[index] = node;
            },
            dragging: draggingIndex === index,
            prefixCls: prefixCls,
            style: (0, $d9ddb32dfdf86c65$export$ddfa24987dade61b)(style, index),
            key: index,
            value: value,
            valueIndex: index,
            onStartMove: onStartMove,
            onOffsetChange: onOffsetChange,
            render: handleRender
        }, restProps));
    }));
});
$33124806a04337b6$var$Handles.displayName = "Handles";
var $33124806a04337b6$export$2e2bcd8739ae039 = $33124806a04337b6$var$Handles;





var $acw62 = parcelRequire("acw62");
function $4f3717c6c62f79f1$var$getPosition(e) {
    var obj = "touches" in e ? e.touches[0] : e;
    return {
        pageX: obj.pageX,
        pageY: obj.pageY
    };
}
function $4f3717c6c62f79f1$export$2e2bcd8739ae039(containerRef, direction, rawValues, min, max, formatValue, triggerChange, finishChange, offsetValues) {
    var _React$useState = $acw62.useState(null), _React$useState2 = (0, $adaabbc18727b3e6$export$2e2bcd8739ae039)(_React$useState, 2), draggingValue = _React$useState2[0], setDraggingValue = _React$useState2[1];
    var _React$useState3 = $acw62.useState(-1), _React$useState4 = (0, $adaabbc18727b3e6$export$2e2bcd8739ae039)(_React$useState3, 2), draggingIndex = _React$useState4[0], setDraggingIndex = _React$useState4[1];
    var _React$useState5 = $acw62.useState(rawValues), _React$useState6 = (0, $adaabbc18727b3e6$export$2e2bcd8739ae039)(_React$useState5, 2), cacheValues = _React$useState6[0], setCacheValues = _React$useState6[1];
    var _React$useState7 = $acw62.useState(rawValues), _React$useState8 = (0, $adaabbc18727b3e6$export$2e2bcd8739ae039)(_React$useState7, 2), originValues = _React$useState8[0], setOriginValues = _React$useState8[1];
    var mouseMoveEventRef = $acw62.useRef(null);
    var mouseUpEventRef = $acw62.useRef(null);
    $acw62.useEffect(function() {
        if (draggingIndex === -1) setCacheValues(rawValues);
    }, [
        rawValues,
        draggingIndex
    ]); // Clean up event
    $acw62.useEffect(function() {
        return function() {
            document.removeEventListener("mousemove", mouseMoveEventRef.current);
            document.removeEventListener("mouseup", mouseUpEventRef.current);
            document.removeEventListener("touchmove", mouseMoveEventRef.current);
            document.removeEventListener("touchend", mouseUpEventRef.current);
        };
    }, []);
    var flushValues = function flushValues(nextValues, nextValue) {
        // Perf: Only update state when value changed
        if (cacheValues.some(function(val, i) {
            return val !== nextValues[i];
        })) {
            if (nextValue !== undefined) setDraggingValue(nextValue);
            setCacheValues(nextValues);
            triggerChange(nextValues);
        }
    };
    var updateCacheValue = function updateCacheValue(valueIndex, offsetPercent) {
        // Basic point offset
        if (valueIndex === -1) {
            // >>>> Dragging on the track
            var startValue = originValues[0];
            var endValue = originValues[originValues.length - 1];
            var maxStartOffset = min - startValue;
            var maxEndOffset = max - endValue; // Get valid offset
            var offset = offsetPercent * (max - min);
            offset = Math.max(offset, maxStartOffset);
            offset = Math.min(offset, maxEndOffset); // Use first value to revert back of valid offset (like steps marks)
            var formatStartValue = formatValue(startValue + offset);
            offset = formatStartValue - startValue;
            var cloneCacheValues = originValues.map(function(val) {
                return val + offset;
            });
            flushValues(cloneCacheValues);
        } else {
            // >>>> Dragging on the handle
            var offsetDist = (max - min) * offsetPercent; // Always start with the valueIndex origin value
            var cloneValues = (0, $eb1ed927433e7e98$export$2e2bcd8739ae039)(cacheValues);
            cloneValues[valueIndex] = originValues[valueIndex];
            var next = offsetValues(cloneValues, offsetDist, valueIndex, "dist");
            flushValues(next.values, next.value);
        }
    }; // Resolve closure
    var updateCacheValueRef = $acw62.useRef(updateCacheValue);
    updateCacheValueRef.current = updateCacheValue;
    var onStartMove = function onStartMove(e, valueIndex) {
        e.stopPropagation();
        var originValue = rawValues[valueIndex];
        setDraggingIndex(valueIndex);
        setDraggingValue(originValue);
        setOriginValues(rawValues);
        var _getPosition = $4f3717c6c62f79f1$var$getPosition(e), startX = _getPosition.pageX, startY = _getPosition.pageY; // Moving
        var onMouseMove = function onMouseMove(event) {
            event.preventDefault();
            var _getPosition2 = $4f3717c6c62f79f1$var$getPosition(event), moveX = _getPosition2.pageX, moveY = _getPosition2.pageY;
            var offsetX = moveX - startX;
            var offsetY = moveY - startY;
            var _containerRef$current = containerRef.current.getBoundingClientRect(), width = _containerRef$current.width, height = _containerRef$current.height;
            var offSetPercent;
            switch(direction){
                case "btt":
                    offSetPercent = -offsetY / height;
                    break;
                case "ttb":
                    offSetPercent = offsetY / height;
                    break;
                case "rtl":
                    offSetPercent = -offsetX / width;
                    break;
                default:
                    offSetPercent = offsetX / width;
            }
            updateCacheValueRef.current(valueIndex, offSetPercent);
        }; // End
        var onMouseUp = function onMouseUp(event) {
            event.preventDefault();
            document.removeEventListener("mouseup", onMouseUp);
            document.removeEventListener("mousemove", onMouseMove);
            document.removeEventListener("touchend", onMouseUp);
            document.removeEventListener("touchmove", onMouseMove);
            mouseMoveEventRef.current = null;
            mouseUpEventRef.current = null;
            setDraggingIndex(-1);
            finishChange();
        };
        document.addEventListener("mouseup", onMouseUp);
        document.addEventListener("mousemove", onMouseMove);
        document.addEventListener("touchend", onMouseUp);
        document.addEventListener("touchmove", onMouseMove);
        mouseMoveEventRef.current = onMouseMove;
        mouseUpEventRef.current = onMouseUp;
    }; // Only return cache value when it mapping with rawValues
    var returnValues = $acw62.useMemo(function() {
        var sourceValues = (0, $eb1ed927433e7e98$export$2e2bcd8739ae039)(rawValues).sort(function(a, b) {
            return a - b;
        });
        var targetValues = (0, $eb1ed927433e7e98$export$2e2bcd8739ae039)(cacheValues).sort(function(a, b) {
            return a - b;
        });
        return sourceValues.every(function(val, index) {
            return val === targetValues[index];
        }) ? cacheValues : rawValues;
    }, [
        rawValues,
        cacheValues
    ]);
    return [
        draggingIndex,
        draggingValue,
        returnValues,
        onStartMove
    ];
}




var $acw62 = parcelRequire("acw62");



var $acw62 = parcelRequire("acw62");



function $f96b888bd5109383$export$2e2bcd8739ae039(props) {
    var prefixCls = props.prefixCls, style = props.style, start = props.start, end = props.end, index = props.index, onStartMove = props.onStartMove;
    var _React$useContext = $acw62.useContext((0, $d315e37ebd8360d8$export$2e2bcd8739ae039)), direction = _React$useContext.direction, min = _React$useContext.min, max = _React$useContext.max, disabled = _React$useContext.disabled, range = _React$useContext.range;
    var trackPrefixCls = "".concat(prefixCls, "-track");
    var offsetStart = (0, $d9ddb32dfdf86c65$export$622cea445a1c5b7d)(start, min, max);
    var offsetEnd = (0, $d9ddb32dfdf86c65$export$622cea445a1c5b7d)(end, min, max); // ============================ Events ============================
    var onInternalStartMove = function onInternalStartMove(e) {
        if (!disabled && onStartMove) onStartMove(e, -1);
    }; // ============================ Render ============================
    var positionStyle = {};
    switch(direction){
        case "rtl":
            positionStyle.right = "".concat(offsetStart * 100, "%");
            positionStyle.width = "".concat(offsetEnd * 100 - offsetStart * 100, "%");
            break;
        case "btt":
            positionStyle.bottom = "".concat(offsetStart * 100, "%");
            positionStyle.height = "".concat(offsetEnd * 100 - offsetStart * 100, "%");
            break;
        case "ttb":
            positionStyle.top = "".concat(offsetStart * 100, "%");
            positionStyle.height = "".concat(offsetEnd * 100 - offsetStart * 100, "%");
            break;
        default:
            positionStyle.left = "".concat(offsetStart * 100, "%");
            positionStyle.width = "".concat(offsetEnd * 100 - offsetStart * 100, "%");
    }
    return /*#__PURE__*/ $acw62.createElement("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))(trackPrefixCls, range && "".concat(trackPrefixCls, "-").concat(index + 1)),
        style: (0, $983350b7b3960a26$export$2e2bcd8739ae039)((0, $983350b7b3960a26$export$2e2bcd8739ae039)({}, positionStyle), style),
        onMouseDown: onInternalStartMove,
        onTouchStart: onInternalStartMove
    });
}



function $b2dccf24aa11036a$export$2e2bcd8739ae039(props) {
    var prefixCls = props.prefixCls, style = props.style, values = props.values, startPoint = props.startPoint, onStartMove = props.onStartMove;
    var _React$useContext = $acw62.useContext((0, $d315e37ebd8360d8$export$2e2bcd8739ae039)), included = _React$useContext.included, range = _React$useContext.range, min = _React$useContext.min;
    var trackList = $acw62.useMemo(function() {
        if (!range) {
            // null value do not have track
            if (values.length === 0) return [];
            var startValue = startPoint !== null && startPoint !== void 0 ? startPoint : min;
            var endValue = values[0];
            return [
                {
                    start: Math.min(startValue, endValue),
                    end: Math.max(startValue, endValue)
                }
            ];
        } // Multiple
        var list = [];
        for(var i = 0; i < values.length - 1; i += 1)list.push({
            start: values[i],
            end: values[i + 1]
        });
        return list;
    }, [
        values,
        range,
        startPoint,
        min
    ]);
    return included ? trackList.map(function(_ref, index) {
        var start = _ref.start, end = _ref.end;
        return /*#__PURE__*/ $acw62.createElement((0, $f96b888bd5109383$export$2e2bcd8739ae039), {
            index: index,
            prefixCls: prefixCls,
            style: (0, $d9ddb32dfdf86c65$export$ddfa24987dade61b)(style, index),
            start: start,
            end: end,
            key: index,
            onStartMove: onStartMove
        });
    }) : null;
}



var $acw62 = parcelRequire("acw62");



var $acw62 = parcelRequire("acw62");



function $63cea05a8409ada9$export$2e2bcd8739ae039(props) {
    var prefixCls = props.prefixCls, style = props.style, children = props.children, value = props.value, _onClick = props.onClick;
    var _React$useContext = $acw62.useContext((0, $d315e37ebd8360d8$export$2e2bcd8739ae039)), min = _React$useContext.min, max = _React$useContext.max, direction = _React$useContext.direction, includedStart = _React$useContext.includedStart, includedEnd = _React$useContext.includedEnd, included = _React$useContext.included;
    var textCls = "".concat(prefixCls, "-text"); // ============================ Offset ============================
    var positionStyle = (0, $d9ddb32dfdf86c65$export$a41628415415e6e)(direction, value, min, max);
    return /*#__PURE__*/ $acw62.createElement("span", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))(textCls, (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)({}, "".concat(textCls, "-active"), included && includedStart <= value && value <= includedEnd)),
        style: (0, $983350b7b3960a26$export$2e2bcd8739ae039)((0, $983350b7b3960a26$export$2e2bcd8739ae039)({}, positionStyle), style),
        onMouseDown: function onMouseDown(e) {
            e.stopPropagation();
        },
        onClick: function onClick() {
            _onClick(value);
        }
    }, children);
}


function $6c5dd54af2d2fb84$export$2e2bcd8739ae039(props) {
    var prefixCls = props.prefixCls, marks = props.marks, onClick = props.onClick;
    var markPrefixCls = "".concat(prefixCls, "-mark"); // Not render mark if empty
    if (!marks.length) return null;
    return /*#__PURE__*/ $acw62.createElement("div", {
        className: markPrefixCls
    }, marks.map(function(_ref) {
        var value = _ref.value, style = _ref.style, label = _ref.label;
        return /*#__PURE__*/ $acw62.createElement((0, $63cea05a8409ada9$export$2e2bcd8739ae039), {
            key: value,
            prefixCls: markPrefixCls,
            style: style,
            value: value,
            onClick: onClick
        }, label);
    }));
}



var $acw62 = parcelRequire("acw62");




var $acw62 = parcelRequire("acw62");



function $5bd80ee77bd33d65$export$2e2bcd8739ae039(props) {
    var prefixCls = props.prefixCls, value = props.value, style = props.style, activeStyle = props.activeStyle;
    var _React$useContext = $acw62.useContext((0, $d315e37ebd8360d8$export$2e2bcd8739ae039)), min = _React$useContext.min, max = _React$useContext.max, direction = _React$useContext.direction, included = _React$useContext.included, includedStart = _React$useContext.includedStart, includedEnd = _React$useContext.includedEnd;
    var dotClassName = "".concat(prefixCls, "-dot");
    var active = included && includedStart <= value && value <= includedEnd; // ============================ Offset ============================
    var mergedStyle = (0, $983350b7b3960a26$export$2e2bcd8739ae039)((0, $983350b7b3960a26$export$2e2bcd8739ae039)({}, (0, $d9ddb32dfdf86c65$export$a41628415415e6e)(direction, value, min, max)), typeof style === "function" ? style(value) : style);
    if (active) mergedStyle = (0, $983350b7b3960a26$export$2e2bcd8739ae039)((0, $983350b7b3960a26$export$2e2bcd8739ae039)({}, mergedStyle), typeof activeStyle === "function" ? activeStyle(value) : activeStyle);
    return /*#__PURE__*/ $acw62.createElement("span", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))(dotClassName, (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)({}, "".concat(dotClassName, "-active"), active)),
        style: mergedStyle
    });
}


function $64ef0293c8d9c7de$export$2e2bcd8739ae039(props) {
    var prefixCls = props.prefixCls, marks = props.marks, dots = props.dots, style = props.style, activeStyle = props.activeStyle;
    var _React$useContext = $acw62.useContext((0, $d315e37ebd8360d8$export$2e2bcd8739ae039)), min = _React$useContext.min, max = _React$useContext.max, step = _React$useContext.step;
    var stepDots = $acw62.useMemo(function() {
        var dotSet = new Set(); // Add marks
        marks.forEach(function(mark) {
            dotSet.add(mark.value);
        }); // Fill dots
        if (dots && step !== null) {
            var current = min;
            while(current <= max){
                dotSet.add(current);
                current += step;
            }
        }
        return Array.from(dotSet);
    }, [
        min,
        max,
        step,
        dots,
        marks
    ]);
    return /*#__PURE__*/ $acw62.createElement("div", {
        className: "".concat(prefixCls, "-step")
    }, stepDots.map(function(dotValue) {
        return /*#__PURE__*/ $acw62.createElement((0, $5bd80ee77bd33d65$export$2e2bcd8739ae039), {
            prefixCls: prefixCls,
            key: dotValue,
            value: dotValue,
            style: style,
            activeStyle: activeStyle
        });
    }));
}




var $acw62 = parcelRequire("acw62");
function $32bdf9f49cee13d8$export$2e2bcd8739ae039(min, max, step, markList, allowCross, pushable) {
    var formatRangeValue = $acw62.useCallback(function(val) {
        var formatNextValue = isFinite(val) ? val : min;
        formatNextValue = Math.min(max, val);
        formatNextValue = Math.max(min, formatNextValue);
        return formatNextValue;
    }, [
        min,
        max
    ]);
    var formatStepValue = $acw62.useCallback(function(val) {
        if (step !== null) {
            var stepValue = min + Math.round((formatRangeValue(val) - min) / step) * step; // Cut number in case to be like 0.30000000000000004
            var getDecimal = function getDecimal(num) {
                return (String(num).split(".")[1] || "").length;
            };
            var maxDecimal = Math.max(getDecimal(step), getDecimal(max), getDecimal(min));
            var fixedValue = Number(stepValue.toFixed(maxDecimal));
            return min <= fixedValue && fixedValue <= max ? fixedValue : null;
        }
        return null;
    }, [
        step,
        min,
        max,
        formatRangeValue
    ]);
    var formatValue = $acw62.useCallback(function(val) {
        var formatNextValue = formatRangeValue(val); // List align values
        var alignValues = markList.map(function(mark) {
            return mark.value;
        });
        if (step !== null) alignValues.push(formatStepValue(val));
         // min & max
        alignValues.push(min, max); // Align with marks
        var closeValue = alignValues[0];
        var closeDist = max - min;
        alignValues.forEach(function(alignValue) {
            var dist = Math.abs(formatNextValue - alignValue);
            if (dist <= closeDist) {
                closeValue = alignValue;
                closeDist = dist;
            }
        });
        return closeValue;
    }, [
        min,
        max,
        markList,
        step,
        formatRangeValue,
        formatStepValue
    ]); // ========================== Offset ==========================
    // Single Value
    var offsetValue = function offsetValue(values, offset, valueIndex) {
        var mode = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : "unit";
        if (typeof offset === "number") {
            var nextValue;
            var originValue = values[valueIndex]; // Only used for `dist` mode
            var targetDistValue = originValue + offset; // Compare next step value & mark value which is best match
            var potentialValues = [];
            markList.forEach(function(mark) {
                potentialValues.push(mark.value);
            }); // Min & Max
            potentialValues.push(min, max); // In case origin value is align with mark but not with step
            potentialValues.push(formatStepValue(originValue)); // Put offset step value also
            var sign = offset > 0 ? 1 : -1;
            if (mode === "unit") potentialValues.push(formatStepValue(originValue + sign * step));
            else potentialValues.push(formatStepValue(targetDistValue));
             // Find close one
            potentialValues = potentialValues.filter(function(val) {
                return val !== null;
            }) // Remove reverse value
            .filter(function(val) {
                return offset < 0 ? val <= originValue : val >= originValue;
            });
            if (mode === "unit") // `unit` mode can not contain itself
            potentialValues = potentialValues.filter(function(val) {
                return val !== originValue;
            });
            var compareValue = mode === "unit" ? originValue : targetDistValue;
            nextValue = potentialValues[0];
            var valueDist = Math.abs(nextValue - compareValue);
            potentialValues.forEach(function(potentialValue) {
                var dist = Math.abs(potentialValue - compareValue);
                if (dist < valueDist) {
                    nextValue = potentialValue;
                    valueDist = dist;
                }
            }); // Out of range will back to range
            if (nextValue === undefined) return offset < 0 ? min : max;
             // `dist` mode
            if (mode === "dist") return nextValue;
             // `unit` mode may need another round
            if (Math.abs(offset) > 1) {
                var cloneValues = (0, $eb1ed927433e7e98$export$2e2bcd8739ae039)(values);
                cloneValues[valueIndex] = nextValue;
                return offsetValue(cloneValues, offset - sign, valueIndex, mode);
            }
            return nextValue;
        } else if (offset === "min") return min;
        else if (offset === "max") return max;
    };
    /** Same as `offsetValue` but return `changed` mark to tell value changed */ var offsetChangedValue = function offsetChangedValue(values, offset, valueIndex) {
        var mode = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : "unit";
        var originValue = values[valueIndex];
        var nextValue = offsetValue(values, offset, valueIndex, mode);
        return {
            value: nextValue,
            changed: nextValue !== originValue
        };
    };
    var needPush = function needPush(dist) {
        return pushable === null && dist === 0 || typeof pushable === "number" && dist < pushable;
    }; // Values
    var offsetValues = function offsetValues(values, offset, valueIndex) {
        var mode = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : "unit";
        var nextValues = values.map(formatValue);
        var originValue = nextValues[valueIndex];
        var nextValue = offsetValue(nextValues, offset, valueIndex, mode);
        nextValues[valueIndex] = nextValue;
        if (allowCross === false) {
            // >>>>> Allow Cross
            var pushNum = pushable || 0; // ============ AllowCross ===============
            if (valueIndex > 0 && nextValues[valueIndex - 1] !== originValue) nextValues[valueIndex] = Math.max(nextValues[valueIndex], nextValues[valueIndex - 1] + pushNum);
            if (valueIndex < nextValues.length - 1 && nextValues[valueIndex + 1] !== originValue) nextValues[valueIndex] = Math.min(nextValues[valueIndex], nextValues[valueIndex + 1] - pushNum);
        } else if (typeof pushable === "number" || pushable === null) {
            // >>>>> Pushable
            // =============== Push ==================
            // >>>>>> Basic push
            // End values
            for(var i = valueIndex + 1; i < nextValues.length; i += 1){
                var changed = true;
                while(needPush(nextValues[i] - nextValues[i - 1]) && changed){
                    var _offsetChangedValue = offsetChangedValue(nextValues, 1, i);
                    nextValues[i] = _offsetChangedValue.value;
                    changed = _offsetChangedValue.changed;
                }
            } // Start values
            for(var _i = valueIndex; _i > 0; _i -= 1){
                var _changed = true;
                while(needPush(nextValues[_i] - nextValues[_i - 1]) && _changed){
                    var _offsetChangedValue2 = offsetChangedValue(nextValues, -1, _i - 1);
                    nextValues[_i - 1] = _offsetChangedValue2.value;
                    _changed = _offsetChangedValue2.changed;
                }
            } // >>>>> Revert back to safe push range
            // End to Start
            for(var _i2 = nextValues.length - 1; _i2 > 0; _i2 -= 1){
                var _changed2 = true;
                while(needPush(nextValues[_i2] - nextValues[_i2 - 1]) && _changed2){
                    var _offsetChangedValue3 = offsetChangedValue(nextValues, -1, _i2 - 1);
                    nextValues[_i2 - 1] = _offsetChangedValue3.value;
                    _changed2 = _offsetChangedValue3.changed;
                }
            } // Start to End
            for(var _i3 = 0; _i3 < nextValues.length - 1; _i3 += 1){
                var _changed3 = true;
                while(needPush(nextValues[_i3 + 1] - nextValues[_i3]) && _changed3){
                    var _offsetChangedValue4 = offsetChangedValue(nextValues, 1, _i3 + 1);
                    nextValues[_i3 + 1] = _offsetChangedValue4.value;
                    _changed3 = _offsetChangedValue4.changed;
                }
            }
        }
        return {
            value: nextValues[valueIndex],
            values: nextValues
        };
    };
    return [
        formatValue,
        offsetValues
    ];
}



var $981acad438e43c15$var$Slider = /*#__PURE__*/ $acw62.forwardRef(function(props, ref) {
    var _classNames;
    var _props$prefixCls = props.prefixCls, prefixCls = _props$prefixCls === void 0 ? "rc-slider" : _props$prefixCls, className = props.className, style = props.style, _props$disabled = props.disabled, disabled = _props$disabled === void 0 ? false : _props$disabled, autoFocus = props.autoFocus, onFocus = props.onFocus, onBlur = props.onBlur, _props$min = props.min, min = _props$min === void 0 ? 0 : _props$min, _props$max = props.max, max = _props$max === void 0 ? 100 : _props$max, _props$step = props.step, step = _props$step === void 0 ? 1 : _props$step, value = props.value, defaultValue = props.defaultValue, range = props.range, count = props.count, onChange = props.onChange, onBeforeChange = props.onBeforeChange, onAfterChange = props.onAfterChange, _props$allowCross = props.allowCross, allowCross = _props$allowCross === void 0 ? true : _props$allowCross, _props$pushable = props.pushable, pushable = _props$pushable === void 0 ? false : _props$pushable, draggableTrack = props.draggableTrack, reverse = props.reverse, vertical = props.vertical, _props$included = props.included, included = _props$included === void 0 ? true : _props$included, startPoint = props.startPoint, trackStyle = props.trackStyle, handleStyle = props.handleStyle, railStyle = props.railStyle, dotStyle = props.dotStyle, activeDotStyle = props.activeDotStyle, marks = props.marks, dots = props.dots, handleRender = props.handleRender, _props$tabIndex = props.tabIndex, tabIndex = _props$tabIndex === void 0 ? 0 : _props$tabIndex, ariaLabelForHandle = props.ariaLabelForHandle, ariaLabelledByForHandle = props.ariaLabelledByForHandle, ariaValueTextFormatterForHandle = props.ariaValueTextFormatterForHandle;
    var handlesRef = $acw62.useRef();
    var containerRef = $acw62.useRef();
    var direction = $acw62.useMemo(function() {
        if (vertical) return reverse ? "ttb" : "btt";
        return reverse ? "rtl" : "ltr";
    }, [
        reverse,
        vertical
    ]); // ============================ Range =============================
    var mergedMin = $acw62.useMemo(function() {
        return isFinite(min) ? min : 0;
    }, [
        min
    ]);
    var mergedMax = $acw62.useMemo(function() {
        return isFinite(max) ? max : 100;
    }, [
        max
    ]); // ============================= Step =============================
    var mergedStep = $acw62.useMemo(function() {
        return step !== null && step <= 0 ? 1 : step;
    }, [
        step
    ]); // ============================= Push =============================
    var mergedPush = $acw62.useMemo(function() {
        if (pushable === true) return mergedStep;
        return pushable >= 0 ? pushable : false;
    }, [
        pushable,
        mergedStep
    ]); // ============================ Marks =============================
    var markList = $acw62.useMemo(function() {
        var keys = Object.keys(marks || {});
        return keys.map(function(key) {
            var mark = marks[key];
            var markObj = {
                value: Number(key)
            };
            if (mark && (0, $b8f57191916382d3$export$2e2bcd8739ae039)(mark) === "object" && !/*#__PURE__*/ $acw62.isValidElement(mark) && ("label" in mark || "style" in mark)) {
                markObj.style = mark.style;
                markObj.label = mark.label;
            } else markObj.label = mark;
            return markObj;
        }).filter(function(_ref) {
            var label = _ref.label;
            return label || typeof label === "number";
        }).sort(function(a, b) {
            return a.value - b.value;
        });
    }, [
        marks
    ]); // ============================ Format ============================
    var _useOffset = (0, $32bdf9f49cee13d8$export$2e2bcd8739ae039)(mergedMin, mergedMax, mergedStep, markList, allowCross, mergedPush), _useOffset2 = (0, $adaabbc18727b3e6$export$2e2bcd8739ae039)(_useOffset, 2), formatValue = _useOffset2[0], offsetValues = _useOffset2[1]; // ============================ Values ============================
    var _useMergedState = (0, $dbf5d1f4f4ecbb6a$export$2e2bcd8739ae039)(defaultValue, {
        value: value
    }), _useMergedState2 = (0, $adaabbc18727b3e6$export$2e2bcd8739ae039)(_useMergedState, 2), mergedValue = _useMergedState2[0], setValue = _useMergedState2[1];
    var rawValues = $acw62.useMemo(function() {
        var valueList = mergedValue === null || mergedValue === undefined ? [] : Array.isArray(mergedValue) ? mergedValue : [
            mergedValue
        ];
        var _valueList = (0, $adaabbc18727b3e6$export$2e2bcd8739ae039)(valueList, 1), _valueList$ = _valueList[0], val0 = _valueList$ === void 0 ? mergedMin : _valueList$;
        var returnValues = mergedValue === null ? [] : [
            val0
        ]; // Format as range
        if (range) {
            returnValues = (0, $eb1ed927433e7e98$export$2e2bcd8739ae039)(valueList); // When count provided or value is `undefined`, we fill values
            if (count || mergedValue === undefined) {
                var pointCount = count >= 0 ? count + 1 : 2;
                returnValues = returnValues.slice(0, pointCount); // Fill with count
                while(returnValues.length < pointCount){
                    var _returnValues;
                    returnValues.push((_returnValues = returnValues[returnValues.length - 1]) !== null && _returnValues !== void 0 ? _returnValues : mergedMin);
                }
            }
            returnValues.sort(function(a, b) {
                return a - b;
            });
        } // Align in range
        returnValues.forEach(function(val, index) {
            returnValues[index] = formatValue(val);
        });
        return returnValues;
    }, [
        mergedValue,
        range,
        mergedMin,
        count,
        formatValue
    ]); // =========================== onChange ===========================
    var rawValuesRef = $acw62.useRef(rawValues);
    rawValuesRef.current = rawValues;
    var getTriggerValue = function getTriggerValue(triggerValues) {
        return range ? triggerValues : triggerValues[0];
    };
    var triggerChange = function triggerChange(nextValues) {
        // Order first
        var cloneNextValues = (0, $eb1ed927433e7e98$export$2e2bcd8739ae039)(nextValues).sort(function(a, b) {
            return a - b;
        }); // Trigger event if needed
        if (onChange && !(0, (/*@__PURE__*/$parcel$interopDefault($d2b63732fb4ff365$exports)))(cloneNextValues, rawValuesRef.current)) onChange(getTriggerValue(cloneNextValues));
         // We set this later since it will re-render component immediately
        setValue(cloneNextValues);
    };
    var changeToCloseValue = function changeToCloseValue(newValue) {
        if (!disabled) {
            var valueIndex = 0;
            var valueDist = mergedMax - mergedMin;
            rawValues.forEach(function(val, index) {
                var dist = Math.abs(newValue - val);
                if (dist <= valueDist) {
                    valueDist = dist;
                    valueIndex = index;
                }
            }); // Create new values
            var cloneNextValues = (0, $eb1ed927433e7e98$export$2e2bcd8739ae039)(rawValues);
            cloneNextValues[valueIndex] = newValue; // Fill value to match default 2
            if (range && !rawValues.length && count === undefined) cloneNextValues.push(newValue);
            onBeforeChange === null || onBeforeChange === void 0 || onBeforeChange(getTriggerValue(cloneNextValues));
            triggerChange(cloneNextValues);
            onAfterChange === null || onAfterChange === void 0 || onAfterChange(getTriggerValue(cloneNextValues));
        }
    }; // ============================ Click =============================
    var onSliderMouseDown = function onSliderMouseDown(e) {
        e.preventDefault();
        var _containerRef$current = containerRef.current.getBoundingClientRect(), width = _containerRef$current.width, height = _containerRef$current.height, left = _containerRef$current.left, top = _containerRef$current.top, bottom = _containerRef$current.bottom, right = _containerRef$current.right;
        var clientX = e.clientX, clientY = e.clientY;
        var percent;
        switch(direction){
            case "btt":
                percent = (bottom - clientY) / height;
                break;
            case "ttb":
                percent = (clientY - top) / height;
                break;
            case "rtl":
                percent = (right - clientX) / width;
                break;
            default:
                percent = (clientX - left) / width;
        }
        var nextValue = mergedMin + percent * (mergedMax - mergedMin);
        changeToCloseValue(formatValue(nextValue));
    }; // =========================== Keyboard ===========================
    var _React$useState = $acw62.useState(null), _React$useState2 = (0, $adaabbc18727b3e6$export$2e2bcd8739ae039)(_React$useState, 2), keyboardValue = _React$useState2[0], setKeyboardValue = _React$useState2[1];
    var onHandleOffsetChange = function onHandleOffsetChange(offset, valueIndex) {
        if (!disabled) {
            var next = offsetValues(rawValues, offset, valueIndex);
            onBeforeChange === null || onBeforeChange === void 0 || onBeforeChange(getTriggerValue(rawValues));
            triggerChange(next.values);
            onAfterChange === null || onAfterChange === void 0 || onAfterChange(getTriggerValue(next.values));
            setKeyboardValue(next.value);
        }
    };
    $acw62.useEffect(function() {
        if (keyboardValue !== null) {
            var valueIndex = rawValues.indexOf(keyboardValue);
            if (valueIndex >= 0) handlesRef.current.focus(valueIndex);
        }
        setKeyboardValue(null);
    }, [
        keyboardValue
    ]); // ============================= Drag =============================
    var mergedDraggableTrack = $acw62.useMemo(function() {
        if (draggableTrack && mergedStep === null) {
            (0, $05a5f2c645683a81$export$2e2bcd8739ae039)(false, "`draggableTrack` is not supported when `step` is `null`.");
            return false;
        }
        return draggableTrack;
    }, [
        draggableTrack,
        mergedStep
    ]);
    var finishChange = function finishChange() {
        onAfterChange === null || onAfterChange === void 0 || onAfterChange(getTriggerValue(rawValuesRef.current));
    };
    var _useDrag = (0, $4f3717c6c62f79f1$export$2e2bcd8739ae039)(containerRef, direction, rawValues, mergedMin, mergedMax, formatValue, triggerChange, finishChange, offsetValues), _useDrag2 = (0, $adaabbc18727b3e6$export$2e2bcd8739ae039)(_useDrag, 4), draggingIndex = _useDrag2[0], draggingValue = _useDrag2[1], cacheValues = _useDrag2[2], onStartDrag = _useDrag2[3];
    var onStartMove = function onStartMove(e, valueIndex) {
        onStartDrag(e, valueIndex);
        onBeforeChange === null || onBeforeChange === void 0 || onBeforeChange(getTriggerValue(rawValuesRef.current));
    }; // Auto focus for updated handle
    var dragging = draggingIndex !== -1;
    $acw62.useEffect(function() {
        if (!dragging) {
            var valueIndex = rawValues.lastIndexOf(draggingValue);
            handlesRef.current.focus(valueIndex);
        }
    }, [
        dragging
    ]); // =========================== Included ===========================
    var sortedCacheValues = $acw62.useMemo(function() {
        return (0, $eb1ed927433e7e98$export$2e2bcd8739ae039)(cacheValues).sort(function(a, b) {
            return a - b;
        });
    }, [
        cacheValues
    ]); // Provide a range values with included [min, max]
    // Used for Track, Mark & Dot
    var _React$useMemo = $acw62.useMemo(function() {
        if (!range) return [
            mergedMin,
            sortedCacheValues[0]
        ];
        return [
            sortedCacheValues[0],
            sortedCacheValues[sortedCacheValues.length - 1]
        ];
    }, [
        sortedCacheValues,
        range,
        mergedMin
    ]), _React$useMemo2 = (0, $adaabbc18727b3e6$export$2e2bcd8739ae039)(_React$useMemo, 2), includedStart = _React$useMemo2[0], includedEnd = _React$useMemo2[1]; // ============================= Refs =============================
    $acw62.useImperativeHandle(ref, function() {
        return {
            focus: function focus() {
                handlesRef.current.focus(0);
            },
            blur: function blur() {
                var _document = document, activeElement = _document.activeElement;
                if (containerRef.current.contains(activeElement)) activeElement === null || activeElement === void 0 || activeElement.blur();
            }
        };
    }); // ========================== Auto Focus ==========================
    $acw62.useEffect(function() {
        if (autoFocus) handlesRef.current.focus(0);
    }, []); // =========================== Context ============================
    var context = $acw62.useMemo(function() {
        return {
            min: mergedMin,
            max: mergedMax,
            direction: direction,
            disabled: disabled,
            step: mergedStep,
            included: included,
            includedStart: includedStart,
            includedEnd: includedEnd,
            range: range,
            tabIndex: tabIndex,
            ariaLabelForHandle: ariaLabelForHandle,
            ariaLabelledByForHandle: ariaLabelledByForHandle,
            ariaValueTextFormatterForHandle: ariaValueTextFormatterForHandle
        };
    }, [
        mergedMin,
        mergedMax,
        direction,
        disabled,
        mergedStep,
        included,
        includedStart,
        includedEnd,
        range,
        tabIndex,
        ariaLabelForHandle,
        ariaLabelledByForHandle,
        ariaValueTextFormatterForHandle
    ]); // ============================ Render ============================
    return /*#__PURE__*/ $acw62.createElement((0, $d315e37ebd8360d8$export$2e2bcd8739ae039).Provider, {
        value: context
    }, /*#__PURE__*/ $acw62.createElement("div", {
        ref: containerRef,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))(prefixCls, className, (_classNames = {}, (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)(_classNames, "".concat(prefixCls, "-disabled"), disabled), (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)(_classNames, "".concat(prefixCls, "-vertical"), vertical), (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)(_classNames, "".concat(prefixCls, "-horizontal"), !vertical), (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)(_classNames, "".concat(prefixCls, "-with-marks"), markList.length), _classNames)),
        style: style,
        onMouseDown: onSliderMouseDown
    }, /*#__PURE__*/ $acw62.createElement("div", {
        className: "".concat(prefixCls, "-rail"),
        style: railStyle
    }), /*#__PURE__*/ $acw62.createElement((0, $b2dccf24aa11036a$export$2e2bcd8739ae039), {
        prefixCls: prefixCls,
        style: trackStyle,
        values: sortedCacheValues,
        startPoint: startPoint,
        onStartMove: mergedDraggableTrack ? onStartMove : null
    }), /*#__PURE__*/ $acw62.createElement((0, $64ef0293c8d9c7de$export$2e2bcd8739ae039), {
        prefixCls: prefixCls,
        marks: markList,
        dots: dots,
        style: dotStyle,
        activeStyle: activeDotStyle
    }), /*#__PURE__*/ $acw62.createElement((0, $33124806a04337b6$export$2e2bcd8739ae039), {
        ref: handlesRef,
        prefixCls: prefixCls,
        style: handleStyle,
        values: cacheValues,
        draggingIndex: draggingIndex,
        onStartMove: onStartMove,
        onOffsetChange: onHandleOffsetChange,
        onFocus: onFocus,
        onBlur: onBlur,
        handleRender: handleRender
    }), /*#__PURE__*/ $acw62.createElement((0, $6c5dd54af2d2fb84$export$2e2bcd8739ae039), {
        prefixCls: prefixCls,
        marks: markList,
        onClick: changeToCloseValue
    })));
});
$981acad438e43c15$var$Slider.displayName = "Slider";
var $981acad438e43c15$export$2e2bcd8739ae039 = $981acad438e43c15$var$Slider;


var $8913456de870b864$export$2e2bcd8739ae039 = (0, $981acad438e43c15$export$2e2bcd8739ae039);



var $acw62 = parcelRequire("acw62");






var $acw62 = parcelRequire("acw62");









var $acw62 = parcelRequire("acw62");









var $acw62 = parcelRequire("acw62");

var $1u0KT = parcelRequire("1u0KT");





var $1u0KT = parcelRequire("1u0KT");
function $0860008a706f6e42$export$2e2bcd8739ae039(target, eventType, cb, option) {
    /* eslint camelcase: 2 */ var callback = (0, (/*@__PURE__*/$parcel$interopDefault($1u0KT))).unstable_batchedUpdates ? function run(e) {
        (0, (/*@__PURE__*/$parcel$interopDefault($1u0KT))).unstable_batchedUpdates(cb, e);
    } : cb;
    if (target !== null && target !== void 0 && target.addEventListener) target.addEventListener(eventType, callback, option);
    return {
        remove: function remove() {
            if (target !== null && target !== void 0 && target.removeEventListener) target.removeEventListener(eventType, callback, option);
        }
    };
}



var $acw62 = parcelRequire("acw62");

var $1u0KT = parcelRequire("1u0KT");

var $2ef2430b7d6ce3e1$var$Portal = /*#__PURE__*/ (0, $acw62.forwardRef)(function(props, ref) {
    var didUpdate = props.didUpdate, getContainer = props.getContainer, children = props.children;
    var parentRef = (0, $acw62.useRef)();
    var containerRef = (0, $acw62.useRef)();
    // Ref return nothing, only for wrapper check exist
    (0, $acw62.useImperativeHandle)(ref, function() {
        return {};
    });
    // Create container in client side with sync to avoid useEffect not get ref
    var initRef = (0, $acw62.useRef)(false);
    if (!initRef.current && (0, $c6daeb3adc2b0e60$export$2e2bcd8739ae039)()) {
        containerRef.current = getContainer();
        parentRef.current = containerRef.current.parentNode;
        initRef.current = true;
    }
    // [Legacy] Used by `rc-trigger`
    (0, $acw62.useEffect)(function() {
        didUpdate === null || didUpdate === void 0 || didUpdate(props);
    });
    (0, $acw62.useEffect)(function() {
        // Restore container to original place
        // React 18 StrictMode will unmount first and mount back for effect test:
        // https://reactjs.org/blog/2022/03/29/react-v18.html#new-strict-mode-behaviors
        if (containerRef.current.parentNode === null && parentRef.current !== null) parentRef.current.appendChild(containerRef.current);
        return function() {
            var _containerRef$current;
            // [Legacy] This should not be handle by Portal but parent PortalWrapper instead.
            // Since some component use `Portal` directly, we have to keep the logic here.
            (_containerRef$current = containerRef.current) === null || _containerRef$current === void 0 || (_containerRef$current = _containerRef$current.parentNode) === null || _containerRef$current === void 0 || _containerRef$current.removeChild(containerRef.current);
        };
    }, []);
    return containerRef.current ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1u0KT))).createPortal(children, containerRef.current) : null;
});
var $2ef2430b7d6ce3e1$export$2e2bcd8739ae039 = $2ef2430b7d6ce3e1$var$Portal;




function $72bedf1023859414$var$isPointsEq(a1, a2, isAlignPoint) {
    if (isAlignPoint) return a1[0] === a2[0];
    return a1[0] === a2[0] && a1[1] === a2[1];
}
function $72bedf1023859414$export$44605b74f7c5d944(builtinPlacements, placementStr, align) {
    var baseAlign = builtinPlacements[placementStr] || {};
    return (0, $983350b7b3960a26$export$2e2bcd8739ae039)((0, $983350b7b3960a26$export$2e2bcd8739ae039)({}, baseAlign), align);
}
function $72bedf1023859414$export$faa0aa8ed2fe6432(builtinPlacements, prefixCls, align, isAlignPoint) {
    var points = align.points;
    var placements = Object.keys(builtinPlacements);
    for(var i = 0; i < placements.length; i += 1){
        var placement = placements[i];
        if ($72bedf1023859414$var$isPointsEq(builtinPlacements[placement].points, points, isAlignPoint)) return "".concat(prefixCls, "-placement-").concat(placement);
    }
    return "";
}







var $acw62 = parcelRequire("acw62");




var $acw62 = parcelRequire("acw62");


function $9c3c4b97fcaf5e46$export$7b8936ddc277a29a(_ref) {
    var prefixCls = _ref.prefixCls, motion = _ref.motion, animation = _ref.animation, transitionName = _ref.transitionName;
    if (motion) return motion;
    if (animation) return {
        motionName: "".concat(prefixCls, "-").concat(animation)
    };
    if (transitionName) return {
        motionName: transitionName
    };
    return null;
}


function $4ac29f08ce13555e$export$2e2bcd8739ae039(props) {
    var prefixCls = props.prefixCls, visible = props.visible, zIndex = props.zIndex, mask = props.mask, maskMotion = props.maskMotion, maskAnimation = props.maskAnimation, maskTransitionName = props.maskTransitionName;
    if (!mask) return null;
    var motion = {};
    if (maskMotion || maskTransitionName || maskAnimation) motion = (0, $983350b7b3960a26$export$2e2bcd8739ae039)({
        motionAppear: true
    }, (0, $9c3c4b97fcaf5e46$export$7b8936ddc277a29a)({
        motion: maskMotion,
        prefixCls: prefixCls,
        transitionName: maskTransitionName,
        animation: maskAnimation
    }));
    return /*#__PURE__*/ $acw62.createElement((0, $609e894acbce1933$export$2e2bcd8739ae039), (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, motion, {
        visible: visible,
        removeOnLeave: true
    }), function(_ref) {
        var className = _ref.className;
        return /*#__PURE__*/ $acw62.createElement("div", {
            style: {
                zIndex: zIndex
            },
            className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))("".concat(prefixCls, "-mask"), className)
        });
    });
}






var $acw62 = parcelRequire("acw62");
// export this package's api


function $e12d8e794315a3f6$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $e12d8e794315a3f6$var$_objectSpread2(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $e12d8e794315a3f6$var$ownKeys(Object(source), !0).forEach(function(key) {
            $e12d8e794315a3f6$var$_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $e12d8e794315a3f6$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $e12d8e794315a3f6$var$_typeof(obj) {
    "@babel/helpers - typeof";
    return $e12d8e794315a3f6$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, $e12d8e794315a3f6$var$_typeof(obj);
}
function $e12d8e794315a3f6$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
var $e12d8e794315a3f6$var$vendorPrefix;
var $e12d8e794315a3f6$var$jsCssMap = {
    Webkit: "-webkit-",
    Moz: "-moz-",
    // IE did it wrong again ...
    ms: "-ms-",
    O: "-o-"
};
function $e12d8e794315a3f6$var$getVendorPrefix() {
    if ($e12d8e794315a3f6$var$vendorPrefix !== undefined) return $e12d8e794315a3f6$var$vendorPrefix;
    $e12d8e794315a3f6$var$vendorPrefix = "";
    var style = document.createElement("p").style;
    var testProp = "Transform";
    for(var key in $e12d8e794315a3f6$var$jsCssMap)if (key + testProp in style) $e12d8e794315a3f6$var$vendorPrefix = key;
    return $e12d8e794315a3f6$var$vendorPrefix;
}
function $e12d8e794315a3f6$var$getTransitionName() {
    return $e12d8e794315a3f6$var$getVendorPrefix() ? "".concat($e12d8e794315a3f6$var$getVendorPrefix(), "TransitionProperty") : "transitionProperty";
}
function $e12d8e794315a3f6$var$getTransformName() {
    return $e12d8e794315a3f6$var$getVendorPrefix() ? "".concat($e12d8e794315a3f6$var$getVendorPrefix(), "Transform") : "transform";
}
function $e12d8e794315a3f6$var$setTransitionProperty(node, value) {
    var name = $e12d8e794315a3f6$var$getTransitionName();
    if (name) {
        node.style[name] = value;
        if (name !== "transitionProperty") node.style.transitionProperty = value;
    }
}
function $e12d8e794315a3f6$var$setTransform(node, value) {
    var name = $e12d8e794315a3f6$var$getTransformName();
    if (name) {
        node.style[name] = value;
        if (name !== "transform") node.style.transform = value;
    }
}
function $e12d8e794315a3f6$var$getTransitionProperty(node) {
    return node.style.transitionProperty || node.style[$e12d8e794315a3f6$var$getTransitionName()];
}
function $e12d8e794315a3f6$var$getTransformXY(node) {
    var style = window.getComputedStyle(node, null);
    var transform = style.getPropertyValue("transform") || style.getPropertyValue($e12d8e794315a3f6$var$getTransformName());
    if (transform && transform !== "none") {
        var matrix = transform.replace(/[^0-9\-.,]/g, "").split(",");
        return {
            x: parseFloat(matrix[12] || matrix[4], 0),
            y: parseFloat(matrix[13] || matrix[5], 0)
        };
    }
    return {
        x: 0,
        y: 0
    };
}
var $e12d8e794315a3f6$var$matrix2d = /matrix\((.*)\)/;
var $e12d8e794315a3f6$var$matrix3d = /matrix3d\((.*)\)/;
function $e12d8e794315a3f6$var$setTransformXY(node, xy) {
    var style = window.getComputedStyle(node, null);
    var transform = style.getPropertyValue("transform") || style.getPropertyValue($e12d8e794315a3f6$var$getTransformName());
    if (transform && transform !== "none") {
        var arr;
        var match2d = transform.match($e12d8e794315a3f6$var$matrix2d);
        if (match2d) {
            match2d = match2d[1];
            arr = match2d.split(",").map(function(item) {
                return parseFloat(item, 10);
            });
            arr[4] = xy.x;
            arr[5] = xy.y;
            $e12d8e794315a3f6$var$setTransform(node, "matrix(".concat(arr.join(","), ")"));
        } else {
            var match3d = transform.match($e12d8e794315a3f6$var$matrix3d)[1];
            arr = match3d.split(",").map(function(item) {
                return parseFloat(item, 10);
            });
            arr[12] = xy.x;
            arr[13] = xy.y;
            $e12d8e794315a3f6$var$setTransform(node, "matrix3d(".concat(arr.join(","), ")"));
        }
    } else $e12d8e794315a3f6$var$setTransform(node, "translateX(".concat(xy.x, "px) translateY(").concat(xy.y, "px) translateZ(0)"));
}
var $e12d8e794315a3f6$var$RE_NUM = /[\-+]?(?:\d*\.|)\d+(?:[eE][\-+]?\d+|)/.source;
var $e12d8e794315a3f6$var$getComputedStyleX;
// https://stackoverflow.com/a/3485654/3040605
function $e12d8e794315a3f6$var$forceRelayout(elem) {
    var originalStyle = elem.style.display;
    elem.style.display = "none";
    elem.offsetHeight; // eslint-disable-line
    elem.style.display = originalStyle;
}
function $e12d8e794315a3f6$var$css(el, name, v) {
    var value = v;
    if ($e12d8e794315a3f6$var$_typeof(name) === "object") {
        for(var i in name)if (name.hasOwnProperty(i)) $e12d8e794315a3f6$var$css(el, i, name[i]);
        return undefined;
    }
    if (typeof value !== "undefined") {
        if (typeof value === "number") value = "".concat(value, "px");
        el.style[name] = value;
        return undefined;
    }
    return $e12d8e794315a3f6$var$getComputedStyleX(el, name);
}
function $e12d8e794315a3f6$var$getClientPosition(elem) {
    var box;
    var x;
    var y;
    var doc = elem.ownerDocument;
    var body = doc.body;
    var docElem = doc && doc.documentElement;
    // 根据 GBS 最新数据，A-Grade Browsers 都已支持 getBoundingClientRect 方法，不用再考虑传统的实现方式
    box = elem.getBoundingClientRect();
    // 注：jQuery 还考虑减去 docElem.clientLeft/clientTop
    // 但测试发现，这样反而会导致当 html 和 body 有边距/边框样式时，获取的值不正确
    // 此外，ie6 会忽略 html 的 margin 值，幸运地是没有谁会去设置 html 的 margin
    x = Math.floor(box.left);
    y = Math.floor(box.top);
    // In IE, most of the time, 2 extra pixels are added to the top and left
    // due to the implicit 2-pixel inset border.  In IE6/7 quirks mode and
    // IE6 standards mode, this border can be overridden by setting the
    // document element's border to zero -- thus, we cannot rely on the
    // offset always being 2 pixels.
    // In quirks mode, the offset can be determined by querying the body's
    // clientLeft/clientTop, but in standards mode, it is found by querying
    // the document element's clientLeft/clientTop.  Since we already called
    // getClientBoundingRect we have already forced a reflow, so it is not
    // too expensive just to query them all.
    // ie 下应该减去窗口的边框吧，毕竟默认 absolute 都是相对窗口定位的
    // 窗口边框标准是设 documentElement ,quirks 时设置 body
    // 最好禁止在 body 和 html 上边框 ，但 ie < 9 html 默认有 2px ，减去
    // 但是非 ie 不可能设置窗口边框，body html 也不是窗口 ,ie 可以通过 html,body 设置
    // 标准 ie 下 docElem.clientTop 就是 border-top
    // ie7 html 即窗口边框改变不了。永远为 2
    // 但标准 firefox/chrome/ie9 下 docElem.clientTop 是窗口边框，即使设了 border-top 也为 0
    x -= docElem.clientLeft || body.clientLeft || 0;
    y -= docElem.clientTop || body.clientTop || 0;
    return {
        left: x,
        top: y
    };
}
function $e12d8e794315a3f6$var$getScroll(w, top) {
    var ret = w["page".concat(top ? "Y" : "X", "Offset")];
    var method = "scroll".concat(top ? "Top" : "Left");
    if (typeof ret !== "number") {
        var d = w.document;
        // ie6,7,8 standard mode
        ret = d.documentElement[method];
        if (typeof ret !== "number") // quirks mode
        ret = d.body[method];
    }
    return ret;
}
function $e12d8e794315a3f6$var$getScrollLeft(w) {
    return $e12d8e794315a3f6$var$getScroll(w);
}
function $e12d8e794315a3f6$var$getScrollTop(w) {
    return $e12d8e794315a3f6$var$getScroll(w, true);
}
function $e12d8e794315a3f6$var$getOffset(el) {
    var pos = $e12d8e794315a3f6$var$getClientPosition(el);
    var doc = el.ownerDocument;
    var w = doc.defaultView || doc.parentWindow;
    pos.left += $e12d8e794315a3f6$var$getScrollLeft(w);
    pos.top += $e12d8e794315a3f6$var$getScrollTop(w);
    return pos;
}
/**
 * A crude way of determining if an object is a window
 * @member util
 */ function $e12d8e794315a3f6$var$isWindow(obj) {
    // must use == for ie8
    /* eslint eqeqeq:0 */ return obj !== null && obj !== undefined && obj == obj.window;
}
function $e12d8e794315a3f6$var$getDocument(node) {
    if ($e12d8e794315a3f6$var$isWindow(node)) return node.document;
    if (node.nodeType === 9) return node;
    return node.ownerDocument;
}
function $e12d8e794315a3f6$var$_getComputedStyle(elem, name, cs) {
    var computedStyle = cs;
    var val = "";
    var d = $e12d8e794315a3f6$var$getDocument(elem);
    computedStyle = computedStyle || d.defaultView.getComputedStyle(elem, null);
    // https://github.com/kissyteam/kissy/issues/61
    if (computedStyle) val = computedStyle.getPropertyValue(name) || computedStyle[name];
    return val;
}
var $e12d8e794315a3f6$var$_RE_NUM_NO_PX = new RegExp("^(".concat($e12d8e794315a3f6$var$RE_NUM, ")(?!px)[a-z%]+$"), "i");
var $e12d8e794315a3f6$var$RE_POS = /^(top|right|bottom|left)$/;
var $e12d8e794315a3f6$var$CURRENT_STYLE = "currentStyle";
var $e12d8e794315a3f6$var$RUNTIME_STYLE = "runtimeStyle";
var $e12d8e794315a3f6$var$LEFT = "left";
var $e12d8e794315a3f6$var$PX = "px";
function $e12d8e794315a3f6$var$_getComputedStyleIE(elem, name) {
    // currentStyle maybe null
    // http://msdn.microsoft.com/en-us/library/ms535231.aspx
    var ret = elem[$e12d8e794315a3f6$var$CURRENT_STYLE] && elem[$e12d8e794315a3f6$var$CURRENT_STYLE][name];
    // 当 width/height 设置为百分比时，通过 pixelLeft 方式转换的 width/height 值
    // 一开始就处理了! CUSTOM_STYLE.height,CUSTOM_STYLE.width ,cssHook 解决@2011-08-19
    // 在 ie 下不对，需要直接用 offset 方式
    // borderWidth 等值也有问题，但考虑到 borderWidth 设为百分比的概率很小，这里就不考虑了
    // From the awesome hack by Dean Edwards
    // http://erik.eae.net/archives/2007/07/27/18.54.15/#comment-102291
    // If we're not dealing with a regular pixel number
    // but a number that has a weird ending, we need to convert it to pixels
    // exclude left right for relativity
    if ($e12d8e794315a3f6$var$_RE_NUM_NO_PX.test(ret) && !$e12d8e794315a3f6$var$RE_POS.test(name)) {
        // Remember the original values
        var style = elem.style;
        var left = style[$e12d8e794315a3f6$var$LEFT];
        var rsLeft = elem[$e12d8e794315a3f6$var$RUNTIME_STYLE][$e12d8e794315a3f6$var$LEFT];
        // prevent flashing of content
        elem[$e12d8e794315a3f6$var$RUNTIME_STYLE][$e12d8e794315a3f6$var$LEFT] = elem[$e12d8e794315a3f6$var$CURRENT_STYLE][$e12d8e794315a3f6$var$LEFT];
        // Put in the new values to get a computed value out
        style[$e12d8e794315a3f6$var$LEFT] = name === "fontSize" ? "1em" : ret || 0;
        ret = style.pixelLeft + $e12d8e794315a3f6$var$PX;
        // Revert the changed values
        style[$e12d8e794315a3f6$var$LEFT] = left;
        elem[$e12d8e794315a3f6$var$RUNTIME_STYLE][$e12d8e794315a3f6$var$LEFT] = rsLeft;
    }
    return ret === "" ? "auto" : ret;
}
if (typeof window !== "undefined") $e12d8e794315a3f6$var$getComputedStyleX = window.getComputedStyle ? $e12d8e794315a3f6$var$_getComputedStyle : $e12d8e794315a3f6$var$_getComputedStyleIE;
function $e12d8e794315a3f6$var$getOffsetDirection(dir, option) {
    if (dir === "left") return option.useCssRight ? "right" : dir;
    return option.useCssBottom ? "bottom" : dir;
}
function $e12d8e794315a3f6$var$oppositeOffsetDirection(dir) {
    if (dir === "left") return "right";
    else if (dir === "right") return "left";
    else if (dir === "top") return "bottom";
    else if (dir === "bottom") return "top";
}
// 设置 elem 相对 elem.ownerDocument 的坐标
function $e12d8e794315a3f6$var$setLeftTop(elem, offset, option) {
    // set position first, in-case top/left are set even on static elem
    if ($e12d8e794315a3f6$var$css(elem, "position") === "static") elem.style.position = "relative";
    var presetH = -999;
    var presetV = -999;
    var horizontalProperty = $e12d8e794315a3f6$var$getOffsetDirection("left", option);
    var verticalProperty = $e12d8e794315a3f6$var$getOffsetDirection("top", option);
    var oppositeHorizontalProperty = $e12d8e794315a3f6$var$oppositeOffsetDirection(horizontalProperty);
    var oppositeVerticalProperty = $e12d8e794315a3f6$var$oppositeOffsetDirection(verticalProperty);
    if (horizontalProperty !== "left") presetH = 999;
    if (verticalProperty !== "top") presetV = 999;
    var originalTransition = "";
    var originalOffset = $e12d8e794315a3f6$var$getOffset(elem);
    if ("left" in offset || "top" in offset) {
        originalTransition = $e12d8e794315a3f6$var$getTransitionProperty(elem) || "";
        $e12d8e794315a3f6$var$setTransitionProperty(elem, "none");
    }
    if ("left" in offset) {
        elem.style[oppositeHorizontalProperty] = "";
        elem.style[horizontalProperty] = "".concat(presetH, "px");
    }
    if ("top" in offset) {
        elem.style[oppositeVerticalProperty] = "";
        elem.style[verticalProperty] = "".concat(presetV, "px");
    }
    // force relayout
    $e12d8e794315a3f6$var$forceRelayout(elem);
    var old = $e12d8e794315a3f6$var$getOffset(elem);
    var originalStyle = {};
    for(var key in offset)if (offset.hasOwnProperty(key)) {
        var dir = $e12d8e794315a3f6$var$getOffsetDirection(key, option);
        var preset = key === "left" ? presetH : presetV;
        var off = originalOffset[key] - old[key];
        if (dir === key) originalStyle[dir] = preset + off;
        else originalStyle[dir] = preset - off;
    }
    $e12d8e794315a3f6$var$css(elem, originalStyle);
    // force relayout
    $e12d8e794315a3f6$var$forceRelayout(elem);
    if ("left" in offset || "top" in offset) $e12d8e794315a3f6$var$setTransitionProperty(elem, originalTransition);
    var ret = {};
    for(var _key in offset)if (offset.hasOwnProperty(_key)) {
        var _dir = $e12d8e794315a3f6$var$getOffsetDirection(_key, option);
        var _off = offset[_key] - originalOffset[_key];
        if (_key === _dir) ret[_dir] = originalStyle[_dir] + _off;
        else ret[_dir] = originalStyle[_dir] - _off;
    }
    $e12d8e794315a3f6$var$css(elem, ret);
}
function $e12d8e794315a3f6$var$setTransform$1(elem, offset) {
    var originalOffset = $e12d8e794315a3f6$var$getOffset(elem);
    var originalXY = $e12d8e794315a3f6$var$getTransformXY(elem);
    var resultXY = {
        x: originalXY.x,
        y: originalXY.y
    };
    if ("left" in offset) resultXY.x = originalXY.x + offset.left - originalOffset.left;
    if ("top" in offset) resultXY.y = originalXY.y + offset.top - originalOffset.top;
    $e12d8e794315a3f6$var$setTransformXY(elem, resultXY);
}
function $e12d8e794315a3f6$var$setOffset(elem, offset, option) {
    if (option.ignoreShake) {
        var oriOffset = $e12d8e794315a3f6$var$getOffset(elem);
        var oLeft = oriOffset.left.toFixed(0);
        var oTop = oriOffset.top.toFixed(0);
        var tLeft = offset.left.toFixed(0);
        var tTop = offset.top.toFixed(0);
        if (oLeft === tLeft && oTop === tTop) return;
    }
    if (option.useCssRight || option.useCssBottom) $e12d8e794315a3f6$var$setLeftTop(elem, offset, option);
    else if (option.useCssTransform && $e12d8e794315a3f6$var$getTransformName() in document.body.style) $e12d8e794315a3f6$var$setTransform$1(elem, offset);
    else $e12d8e794315a3f6$var$setLeftTop(elem, offset, option);
}
function $e12d8e794315a3f6$var$each(arr, fn) {
    for(var i = 0; i < arr.length; i++)fn(arr[i]);
}
function $e12d8e794315a3f6$var$isBorderBoxFn(elem) {
    return $e12d8e794315a3f6$var$getComputedStyleX(elem, "boxSizing") === "border-box";
}
var $e12d8e794315a3f6$var$BOX_MODELS = [
    "margin",
    "border",
    "padding"
];
var $e12d8e794315a3f6$var$CONTENT_INDEX = -1;
var $e12d8e794315a3f6$var$PADDING_INDEX = 2;
var $e12d8e794315a3f6$var$BORDER_INDEX = 1;
var $e12d8e794315a3f6$var$MARGIN_INDEX = 0;
function $e12d8e794315a3f6$var$swap(elem, options, callback) {
    var old = {};
    var style = elem.style;
    var name;
    // Remember the old values, and insert the new ones
    for(name in options)if (options.hasOwnProperty(name)) {
        old[name] = style[name];
        style[name] = options[name];
    }
    callback.call(elem);
    // Revert the old values
    for(name in options)if (options.hasOwnProperty(name)) style[name] = old[name];
}
function $e12d8e794315a3f6$var$getPBMWidth(elem, props, which) {
    var value = 0;
    var prop;
    var j;
    var i;
    for(j = 0; j < props.length; j++){
        prop = props[j];
        if (prop) for(i = 0; i < which.length; i++){
            var cssProp = void 0;
            if (prop === "border") cssProp = "".concat(prop).concat(which[i], "Width");
            else cssProp = prop + which[i];
            value += parseFloat($e12d8e794315a3f6$var$getComputedStyleX(elem, cssProp)) || 0;
        }
    }
    return value;
}
var $e12d8e794315a3f6$var$domUtils = {
    getParent: function getParent(element) {
        var parent = element;
        do if (parent.nodeType === 11 && parent.host) parent = parent.host;
        else parent = parent.parentNode;
        while (parent && parent.nodeType !== 1 && parent.nodeType !== 9);
        return parent;
    }
};
$e12d8e794315a3f6$var$each([
    "Width",
    "Height"
], function(name) {
    $e12d8e794315a3f6$var$domUtils["doc".concat(name)] = function(refWin) {
        var d = refWin.document;
        return Math.max(// firefox chrome documentElement.scrollHeight< body.scrollHeight
        // ie standard mode : documentElement.scrollHeight> body.scrollHeight
        d.documentElement["scroll".concat(name)], // quirks : documentElement.scrollHeight 最大等于可视窗口多一点？
        d.body["scroll".concat(name)], $e12d8e794315a3f6$var$domUtils["viewport".concat(name)](d));
    };
    $e12d8e794315a3f6$var$domUtils["viewport".concat(name)] = function(win) {
        // pc browser includes scrollbar in window.innerWidth
        var prop = "client".concat(name);
        var doc = win.document;
        var body = doc.body;
        var documentElement = doc.documentElement;
        var documentElementProp = documentElement[prop];
        // 标准模式取 documentElement
        // backcompat 取 body
        return doc.compatMode === "CSS1Compat" && documentElementProp || body && body[prop] || documentElementProp;
    };
});
/*
 得到元素的大小信息
 @param elem
 @param name
 @param {String} [extra]  'padding' : (css width) + padding
 'border' : (css width) + padding + border
 'margin' : (css width) + padding + border + margin
 */ function $e12d8e794315a3f6$var$getWH(elem, name, ex) {
    var extra = ex;
    if ($e12d8e794315a3f6$var$isWindow(elem)) return name === "width" ? $e12d8e794315a3f6$var$domUtils.viewportWidth(elem) : $e12d8e794315a3f6$var$domUtils.viewportHeight(elem);
    else if (elem.nodeType === 9) return name === "width" ? $e12d8e794315a3f6$var$domUtils.docWidth(elem) : $e12d8e794315a3f6$var$domUtils.docHeight(elem);
    var which = name === "width" ? [
        "Left",
        "Right"
    ] : [
        "Top",
        "Bottom"
    ];
    var borderBoxValue = name === "width" ? Math.floor(elem.getBoundingClientRect().width) : Math.floor(elem.getBoundingClientRect().height);
    var isBorderBox = $e12d8e794315a3f6$var$isBorderBoxFn(elem);
    var cssBoxValue = 0;
    if (borderBoxValue === null || borderBoxValue === undefined || borderBoxValue <= 0) {
        borderBoxValue = undefined;
        // Fall back to computed then un computed css if necessary
        cssBoxValue = $e12d8e794315a3f6$var$getComputedStyleX(elem, name);
        if (cssBoxValue === null || cssBoxValue === undefined || Number(cssBoxValue) < 0) cssBoxValue = elem.style[name] || 0;
        // Normalize '', auto, and prepare for extra
        cssBoxValue = Math.floor(parseFloat(cssBoxValue)) || 0;
    }
    if (extra === undefined) extra = isBorderBox ? $e12d8e794315a3f6$var$BORDER_INDEX : $e12d8e794315a3f6$var$CONTENT_INDEX;
    var borderBoxValueOrIsBorderBox = borderBoxValue !== undefined || isBorderBox;
    var val = borderBoxValue || cssBoxValue;
    if (extra === $e12d8e794315a3f6$var$CONTENT_INDEX) {
        if (borderBoxValueOrIsBorderBox) return val - $e12d8e794315a3f6$var$getPBMWidth(elem, [
            "border",
            "padding"
        ], which);
        return cssBoxValue;
    } else if (borderBoxValueOrIsBorderBox) {
        if (extra === $e12d8e794315a3f6$var$BORDER_INDEX) return val;
        return val + (extra === $e12d8e794315a3f6$var$PADDING_INDEX ? -$e12d8e794315a3f6$var$getPBMWidth(elem, [
            "border"
        ], which) : $e12d8e794315a3f6$var$getPBMWidth(elem, [
            "margin"
        ], which));
    }
    return cssBoxValue + $e12d8e794315a3f6$var$getPBMWidth(elem, $e12d8e794315a3f6$var$BOX_MODELS.slice(extra), which);
}
var $e12d8e794315a3f6$var$cssShow = {
    position: "absolute",
    visibility: "hidden",
    display: "block"
};
// fix #119 : https://github.com/kissyteam/kissy/issues/119
function $e12d8e794315a3f6$var$getWHIgnoreDisplay() {
    for(var _len = arguments.length, args = new Array(_len), _key2 = 0; _key2 < _len; _key2++)args[_key2] = arguments[_key2];
    var val;
    var elem = args[0];
    // in case elem is window
    // elem.offsetWidth === undefined
    if (elem.offsetWidth !== 0) val = $e12d8e794315a3f6$var$getWH.apply(undefined, args);
    else $e12d8e794315a3f6$var$swap(elem, $e12d8e794315a3f6$var$cssShow, function() {
        val = $e12d8e794315a3f6$var$getWH.apply(undefined, args);
    });
    return val;
}
$e12d8e794315a3f6$var$each([
    "width",
    "height"
], function(name) {
    var first = name.charAt(0).toUpperCase() + name.slice(1);
    $e12d8e794315a3f6$var$domUtils["outer".concat(first)] = function(el, includeMargin) {
        return el && $e12d8e794315a3f6$var$getWHIgnoreDisplay(el, name, includeMargin ? $e12d8e794315a3f6$var$MARGIN_INDEX : $e12d8e794315a3f6$var$BORDER_INDEX);
    };
    var which = name === "width" ? [
        "Left",
        "Right"
    ] : [
        "Top",
        "Bottom"
    ];
    $e12d8e794315a3f6$var$domUtils[name] = function(elem, v) {
        var val = v;
        if (val !== undefined) {
            if (elem) {
                var isBorderBox = $e12d8e794315a3f6$var$isBorderBoxFn(elem);
                if (isBorderBox) val += $e12d8e794315a3f6$var$getPBMWidth(elem, [
                    "padding",
                    "border"
                ], which);
                return $e12d8e794315a3f6$var$css(elem, name, val);
            }
            return undefined;
        }
        return elem && $e12d8e794315a3f6$var$getWHIgnoreDisplay(elem, name, $e12d8e794315a3f6$var$CONTENT_INDEX);
    };
});
function $e12d8e794315a3f6$var$mix(to, from) {
    for(var i in from)if (from.hasOwnProperty(i)) to[i] = from[i];
    return to;
}
var $e12d8e794315a3f6$var$utils = {
    getWindow: function getWindow(node) {
        if (node && node.document && node.setTimeout) return node;
        var doc = node.ownerDocument || node;
        return doc.defaultView || doc.parentWindow;
    },
    getDocument: $e12d8e794315a3f6$var$getDocument,
    offset: function offset(el, value, option) {
        if (typeof value !== "undefined") $e12d8e794315a3f6$var$setOffset(el, value, option || {});
        else return $e12d8e794315a3f6$var$getOffset(el);
    },
    isWindow: $e12d8e794315a3f6$var$isWindow,
    each: $e12d8e794315a3f6$var$each,
    css: $e12d8e794315a3f6$var$css,
    clone: function clone(obj) {
        var i;
        var ret = {};
        for(i in obj)if (obj.hasOwnProperty(i)) ret[i] = obj[i];
        var overflow = obj.overflow;
        if (overflow) {
            for(i in obj)if (obj.hasOwnProperty(i)) ret.overflow[i] = obj.overflow[i];
        }
        return ret;
    },
    mix: $e12d8e794315a3f6$var$mix,
    getWindowScrollLeft: function getWindowScrollLeft(w) {
        return $e12d8e794315a3f6$var$getScrollLeft(w);
    },
    getWindowScrollTop: function getWindowScrollTop(w) {
        return $e12d8e794315a3f6$var$getScrollTop(w);
    },
    merge: function merge() {
        var ret = {};
        for(var i = 0; i < arguments.length; i++)$e12d8e794315a3f6$var$utils.mix(ret, i < 0 || arguments.length <= i ? undefined : arguments[i]);
        return ret;
    },
    viewportWidth: 0,
    viewportHeight: 0
};
$e12d8e794315a3f6$var$mix($e12d8e794315a3f6$var$utils, $e12d8e794315a3f6$var$domUtils);
/**
 * 得到会导致元素显示不全的祖先元素
 */ var $e12d8e794315a3f6$var$getParent = $e12d8e794315a3f6$var$utils.getParent;
function $e12d8e794315a3f6$var$getOffsetParent(element) {
    if ($e12d8e794315a3f6$var$utils.isWindow(element) || element.nodeType === 9) return null;
    // ie 这个也不是完全可行
    /*
   <div style="width: 50px;height: 100px;overflow: hidden">
   <div style="width: 50px;height: 100px;position: relative;" id="d6">
   元素 6 高 100px 宽 50px<br/>
   </div>
   </div>
   */ // element.offsetParent does the right thing in ie7 and below. Return parent with layout!
    //  In other browsers it only includes elements with position absolute, relative or
    // fixed, not elements with overflow set to auto or scroll.
    //        if (UA.ie && ieMode < 8) {
    //            return element.offsetParent;
    //        }
    // 统一的 offsetParent 方法
    var doc = $e12d8e794315a3f6$var$utils.getDocument(element);
    var body = doc.body;
    var parent;
    var positionStyle = $e12d8e794315a3f6$var$utils.css(element, "position");
    var skipStatic = positionStyle === "fixed" || positionStyle === "absolute";
    if (!skipStatic) return element.nodeName.toLowerCase() === "html" ? null : $e12d8e794315a3f6$var$getParent(element);
    for(parent = $e12d8e794315a3f6$var$getParent(element); parent && parent !== body && parent.nodeType !== 9; parent = $e12d8e794315a3f6$var$getParent(parent)){
        positionStyle = $e12d8e794315a3f6$var$utils.css(parent, "position");
        if (positionStyle !== "static") return parent;
    }
    return null;
}
var $e12d8e794315a3f6$var$getParent$1 = $e12d8e794315a3f6$var$utils.getParent;
function $e12d8e794315a3f6$var$isAncestorFixed(element) {
    if ($e12d8e794315a3f6$var$utils.isWindow(element) || element.nodeType === 9) return false;
    var doc = $e12d8e794315a3f6$var$utils.getDocument(element);
    var body = doc.body;
    var parent = null;
    for(parent = $e12d8e794315a3f6$var$getParent$1(element); // 修复元素位于 document.documentElement 下导致崩溃问题
    parent && parent !== body && parent !== doc; parent = $e12d8e794315a3f6$var$getParent$1(parent)){
        var positionStyle = $e12d8e794315a3f6$var$utils.css(parent, "position");
        if (positionStyle === "fixed") return true;
    }
    return false;
}
/**
 * 获得元素的显示部分的区域
 */ function $e12d8e794315a3f6$var$getVisibleRectForElement(element, alwaysByViewport) {
    var visibleRect = {
        left: 0,
        right: Infinity,
        top: 0,
        bottom: Infinity
    };
    var el = $e12d8e794315a3f6$var$getOffsetParent(element);
    var doc = $e12d8e794315a3f6$var$utils.getDocument(element);
    var win = doc.defaultView || doc.parentWindow;
    var body = doc.body;
    var documentElement = doc.documentElement;
    // Determine the size of the visible rect by climbing the dom accounting for
    // all scrollable containers.
    while(el){
        // clientWidth is zero for inline block elements in ie.
        if ((navigator.userAgent.indexOf("MSIE") === -1 || el.clientWidth !== 0) && // body may have overflow set on it, yet we still get the entire
        // viewport. In some browsers, el.offsetParent may be
        // document.documentElement, so check for that too.
        el !== body && el !== documentElement && $e12d8e794315a3f6$var$utils.css(el, "overflow") !== "visible") {
            var pos = $e12d8e794315a3f6$var$utils.offset(el);
            // add border
            pos.left += el.clientLeft;
            pos.top += el.clientTop;
            visibleRect.top = Math.max(visibleRect.top, pos.top);
            visibleRect.right = Math.min(visibleRect.right, // consider area without scrollBar
            pos.left + el.clientWidth);
            visibleRect.bottom = Math.min(visibleRect.bottom, pos.top + el.clientHeight);
            visibleRect.left = Math.max(visibleRect.left, pos.left);
        } else if (el === body || el === documentElement) break;
        el = $e12d8e794315a3f6$var$getOffsetParent(el);
    }
    // Set element position to fixed
    // make sure absolute element itself don't affect it's visible area
    // https://github.com/ant-design/ant-design/issues/7601
    var originalPosition = null;
    if (!$e12d8e794315a3f6$var$utils.isWindow(element) && element.nodeType !== 9) {
        originalPosition = element.style.position;
        var position = $e12d8e794315a3f6$var$utils.css(element, "position");
        if (position === "absolute") element.style.position = "fixed";
    }
    var scrollX = $e12d8e794315a3f6$var$utils.getWindowScrollLeft(win);
    var scrollY = $e12d8e794315a3f6$var$utils.getWindowScrollTop(win);
    var viewportWidth = $e12d8e794315a3f6$var$utils.viewportWidth(win);
    var viewportHeight = $e12d8e794315a3f6$var$utils.viewportHeight(win);
    var documentWidth = documentElement.scrollWidth;
    var documentHeight = documentElement.scrollHeight;
    // scrollXXX on html is sync with body which means overflow: hidden on body gets wrong scrollXXX.
    // We should cut this ourself.
    var bodyStyle = window.getComputedStyle(body);
    if (bodyStyle.overflowX === "hidden") documentWidth = win.innerWidth;
    if (bodyStyle.overflowY === "hidden") documentHeight = win.innerHeight;
    // Reset element position after calculate the visible area
    if (element.style) element.style.position = originalPosition;
    if (alwaysByViewport || $e12d8e794315a3f6$var$isAncestorFixed(element)) {
        // Clip by viewport's size.
        visibleRect.left = Math.max(visibleRect.left, scrollX);
        visibleRect.top = Math.max(visibleRect.top, scrollY);
        visibleRect.right = Math.min(visibleRect.right, scrollX + viewportWidth);
        visibleRect.bottom = Math.min(visibleRect.bottom, scrollY + viewportHeight);
    } else {
        // Clip by document's size.
        var maxVisibleWidth = Math.max(documentWidth, scrollX + viewportWidth);
        visibleRect.right = Math.min(visibleRect.right, maxVisibleWidth);
        var maxVisibleHeight = Math.max(documentHeight, scrollY + viewportHeight);
        visibleRect.bottom = Math.min(visibleRect.bottom, maxVisibleHeight);
    }
    return visibleRect.top >= 0 && visibleRect.left >= 0 && visibleRect.bottom > visibleRect.top && visibleRect.right > visibleRect.left ? visibleRect : null;
}
function $e12d8e794315a3f6$var$adjustForViewport(elFuturePos, elRegion, visibleRect, overflow) {
    var pos = $e12d8e794315a3f6$var$utils.clone(elFuturePos);
    var size = {
        width: elRegion.width,
        height: elRegion.height
    };
    if (overflow.adjustX && pos.left < visibleRect.left) pos.left = visibleRect.left;
    // Left edge inside and right edge outside viewport, try to resize it.
    if (overflow.resizeWidth && pos.left >= visibleRect.left && pos.left + size.width > visibleRect.right) size.width -= pos.left + size.width - visibleRect.right;
    // Right edge outside viewport, try to move it.
    if (overflow.adjustX && pos.left + size.width > visibleRect.right) // 保证左边界和可视区域左边界对齐
    pos.left = Math.max(visibleRect.right - size.width, visibleRect.left);
    // Top edge outside viewport, try to move it.
    if (overflow.adjustY && pos.top < visibleRect.top) pos.top = visibleRect.top;
    // Top edge inside and bottom edge outside viewport, try to resize it.
    if (overflow.resizeHeight && pos.top >= visibleRect.top && pos.top + size.height > visibleRect.bottom) size.height -= pos.top + size.height - visibleRect.bottom;
    // Bottom edge outside viewport, try to move it.
    if (overflow.adjustY && pos.top + size.height > visibleRect.bottom) // 保证上边界和可视区域上边界对齐
    pos.top = Math.max(visibleRect.bottom - size.height, visibleRect.top);
    return $e12d8e794315a3f6$var$utils.mix(pos, size);
}
function $e12d8e794315a3f6$var$getRegion(node) {
    var offset;
    var w;
    var h;
    if (!$e12d8e794315a3f6$var$utils.isWindow(node) && node.nodeType !== 9) {
        offset = $e12d8e794315a3f6$var$utils.offset(node);
        w = $e12d8e794315a3f6$var$utils.outerWidth(node);
        h = $e12d8e794315a3f6$var$utils.outerHeight(node);
    } else {
        var win = $e12d8e794315a3f6$var$utils.getWindow(node);
        offset = {
            left: $e12d8e794315a3f6$var$utils.getWindowScrollLeft(win),
            top: $e12d8e794315a3f6$var$utils.getWindowScrollTop(win)
        };
        w = $e12d8e794315a3f6$var$utils.viewportWidth(win);
        h = $e12d8e794315a3f6$var$utils.viewportHeight(win);
    }
    offset.width = w;
    offset.height = h;
    return offset;
}
/**
 * 获取 node 上的 align 对齐点 相对于页面的坐标
 */ function $e12d8e794315a3f6$var$getAlignOffset(region, align) {
    var V = align.charAt(0);
    var H = align.charAt(1);
    var w = region.width;
    var h = region.height;
    var x = region.left;
    var y = region.top;
    if (V === "c") y += h / 2;
    else if (V === "b") y += h;
    if (H === "c") x += w / 2;
    else if (H === "r") x += w;
    return {
        left: x,
        top: y
    };
}
function $e12d8e794315a3f6$var$getElFuturePos(elRegion, refNodeRegion, points, offset, targetOffset) {
    var p1 = $e12d8e794315a3f6$var$getAlignOffset(refNodeRegion, points[1]);
    var p2 = $e12d8e794315a3f6$var$getAlignOffset(elRegion, points[0]);
    var diff = [
        p2.left - p1.left,
        p2.top - p1.top
    ];
    return {
        left: Math.round(elRegion.left - diff[0] + offset[0] - targetOffset[0]),
        top: Math.round(elRegion.top - diff[1] + offset[1] - targetOffset[1])
    };
}
/**
 * align dom node flexibly
 * @author yiminghe@gmail.com
 */ // http://yiminghe.iteye.com/blog/1124720
function $e12d8e794315a3f6$var$isFailX(elFuturePos, elRegion, visibleRect) {
    return elFuturePos.left < visibleRect.left || elFuturePos.left + elRegion.width > visibleRect.right;
}
function $e12d8e794315a3f6$var$isFailY(elFuturePos, elRegion, visibleRect) {
    return elFuturePos.top < visibleRect.top || elFuturePos.top + elRegion.height > visibleRect.bottom;
}
function $e12d8e794315a3f6$var$isCompleteFailX(elFuturePos, elRegion, visibleRect) {
    return elFuturePos.left > visibleRect.right || elFuturePos.left + elRegion.width < visibleRect.left;
}
function $e12d8e794315a3f6$var$isCompleteFailY(elFuturePos, elRegion, visibleRect) {
    return elFuturePos.top > visibleRect.bottom || elFuturePos.top + elRegion.height < visibleRect.top;
}
function $e12d8e794315a3f6$var$flip(points, reg, map) {
    var ret = [];
    $e12d8e794315a3f6$var$utils.each(points, function(p) {
        ret.push(p.replace(reg, function(m) {
            return map[m];
        }));
    });
    return ret;
}
function $e12d8e794315a3f6$var$flipOffset(offset, index) {
    offset[index] = -offset[index];
    return offset;
}
function $e12d8e794315a3f6$var$convertOffset(str, offsetLen) {
    var n;
    if (/%$/.test(str)) n = parseInt(str.substring(0, str.length - 1), 10) / 100 * offsetLen;
    else n = parseInt(str, 10);
    return n || 0;
}
function $e12d8e794315a3f6$var$normalizeOffset(offset, el) {
    offset[0] = $e12d8e794315a3f6$var$convertOffset(offset[0], el.width);
    offset[1] = $e12d8e794315a3f6$var$convertOffset(offset[1], el.height);
}
/**
 * @param el
 * @param tgtRegion 参照节点所占的区域: { left, top, width, height }
 * @param align
 */ function $e12d8e794315a3f6$var$doAlign(el, tgtRegion, align, isTgtRegionVisible) {
    var points = align.points;
    var offset = align.offset || [
        0,
        0
    ];
    var targetOffset = align.targetOffset || [
        0,
        0
    ];
    var overflow = align.overflow;
    var source = align.source || el;
    offset = [].concat(offset);
    targetOffset = [].concat(targetOffset);
    overflow = overflow || {};
    var newOverflowCfg = {};
    var fail = 0;
    var alwaysByViewport = !!(overflow && overflow.alwaysByViewport);
    // 当前节点可以被放置的显示区域
    var visibleRect = $e12d8e794315a3f6$var$getVisibleRectForElement(source, alwaysByViewport);
    // 当前节点所占的区域, left/top/width/height
    var elRegion = $e12d8e794315a3f6$var$getRegion(source);
    // 将 offset 转换成数值，支持百分比
    $e12d8e794315a3f6$var$normalizeOffset(offset, elRegion);
    $e12d8e794315a3f6$var$normalizeOffset(targetOffset, tgtRegion);
    // 当前节点将要被放置的位置
    var elFuturePos = $e12d8e794315a3f6$var$getElFuturePos(elRegion, tgtRegion, points, offset, targetOffset);
    // 当前节点将要所处的区域
    var newElRegion = $e12d8e794315a3f6$var$utils.merge(elRegion, elFuturePos);
    // 如果可视区域不能完全放置当前节点时允许调整
    if (visibleRect && (overflow.adjustX || overflow.adjustY) && isTgtRegionVisible) {
        if (overflow.adjustX) // 如果横向不能放下
        {
            if ($e12d8e794315a3f6$var$isFailX(elFuturePos, elRegion, visibleRect)) {
                // 对齐位置反下
                var newPoints = $e12d8e794315a3f6$var$flip(points, /[lr]/gi, {
                    l: "r",
                    r: "l"
                });
                // 偏移量也反下
                var newOffset = $e12d8e794315a3f6$var$flipOffset(offset, 0);
                var newTargetOffset = $e12d8e794315a3f6$var$flipOffset(targetOffset, 0);
                var newElFuturePos = $e12d8e794315a3f6$var$getElFuturePos(elRegion, tgtRegion, newPoints, newOffset, newTargetOffset);
                if (!$e12d8e794315a3f6$var$isCompleteFailX(newElFuturePos, elRegion, visibleRect)) {
                    fail = 1;
                    points = newPoints;
                    offset = newOffset;
                    targetOffset = newTargetOffset;
                }
            }
        }
        if (overflow.adjustY) // 如果纵向不能放下
        {
            if ($e12d8e794315a3f6$var$isFailY(elFuturePos, elRegion, visibleRect)) {
                // 对齐位置反下
                var _newPoints = $e12d8e794315a3f6$var$flip(points, /[tb]/gi, {
                    t: "b",
                    b: "t"
                });
                // 偏移量也反下
                var _newOffset = $e12d8e794315a3f6$var$flipOffset(offset, 1);
                var _newTargetOffset = $e12d8e794315a3f6$var$flipOffset(targetOffset, 1);
                var _newElFuturePos = $e12d8e794315a3f6$var$getElFuturePos(elRegion, tgtRegion, _newPoints, _newOffset, _newTargetOffset);
                if (!$e12d8e794315a3f6$var$isCompleteFailY(_newElFuturePos, elRegion, visibleRect)) {
                    fail = 1;
                    points = _newPoints;
                    offset = _newOffset;
                    targetOffset = _newTargetOffset;
                }
            }
        }
        // 如果失败，重新计算当前节点将要被放置的位置
        if (fail) {
            elFuturePos = $e12d8e794315a3f6$var$getElFuturePos(elRegion, tgtRegion, points, offset, targetOffset);
            $e12d8e794315a3f6$var$utils.mix(newElRegion, elFuturePos);
        }
        var isStillFailX = $e12d8e794315a3f6$var$isFailX(elFuturePos, elRegion, visibleRect);
        var isStillFailY = $e12d8e794315a3f6$var$isFailY(elFuturePos, elRegion, visibleRect);
        // 检查反下后的位置是否可以放下了，如果仍然放不下：
        // 1. 复原修改过的定位参数
        if (isStillFailX || isStillFailY) {
            var _newPoints2 = points;
            // 重置对应部分的翻转逻辑
            if (isStillFailX) _newPoints2 = $e12d8e794315a3f6$var$flip(points, /[lr]/gi, {
                l: "r",
                r: "l"
            });
            if (isStillFailY) _newPoints2 = $e12d8e794315a3f6$var$flip(points, /[tb]/gi, {
                t: "b",
                b: "t"
            });
            points = _newPoints2;
            offset = align.offset || [
                0,
                0
            ];
            targetOffset = align.targetOffset || [
                0,
                0
            ];
        }
        // 2. 只有指定了可以调整当前方向才调整
        newOverflowCfg.adjustX = overflow.adjustX && isStillFailX;
        newOverflowCfg.adjustY = overflow.adjustY && isStillFailY;
        // 确实要调整，甚至可能会调整高度宽度
        if (newOverflowCfg.adjustX || newOverflowCfg.adjustY) newElRegion = $e12d8e794315a3f6$var$adjustForViewport(elFuturePos, elRegion, visibleRect, newOverflowCfg);
    }
    // need judge to in case set fixed with in css on height auto element
    if (newElRegion.width !== elRegion.width) $e12d8e794315a3f6$var$utils.css(source, "width", $e12d8e794315a3f6$var$utils.width(source) + newElRegion.width - elRegion.width);
    if (newElRegion.height !== elRegion.height) $e12d8e794315a3f6$var$utils.css(source, "height", $e12d8e794315a3f6$var$utils.height(source) + newElRegion.height - elRegion.height);
    // https://github.com/kissyteam/kissy/issues/190
    // 相对于屏幕位置没变，而 left/top 变了
    // 例如 <div 'relative'><el absolute></div>
    $e12d8e794315a3f6$var$utils.offset(source, {
        left: newElRegion.left,
        top: newElRegion.top
    }, {
        useCssRight: align.useCssRight,
        useCssBottom: align.useCssBottom,
        useCssTransform: align.useCssTransform,
        ignoreShake: align.ignoreShake
    });
    return {
        points: points,
        offset: offset,
        targetOffset: targetOffset,
        overflow: newOverflowCfg
    };
}
/**
 *  2012-04-26 yiminghe@gmail.com
 *   - 优化智能对齐算法
 *   - 慎用 resizeXX
 *
 *  2011-07-13 yiminghe@gmail.com note:
 *   - 增加智能对齐，以及大小调整选项
 **/ function $e12d8e794315a3f6$var$isOutOfVisibleRect(target, alwaysByViewport) {
    var visibleRect = $e12d8e794315a3f6$var$getVisibleRectForElement(target, alwaysByViewport);
    var targetRegion = $e12d8e794315a3f6$var$getRegion(target);
    return !visibleRect || targetRegion.left + targetRegion.width <= visibleRect.left || targetRegion.top + targetRegion.height <= visibleRect.top || targetRegion.left >= visibleRect.right || targetRegion.top >= visibleRect.bottom;
}
function $e12d8e794315a3f6$export$ec21431d5ee6c534(el, refNode, align) {
    var target = align.target || refNode;
    var refNodeRegion = $e12d8e794315a3f6$var$getRegion(target);
    var isTargetNotOutOfVisible = !$e12d8e794315a3f6$var$isOutOfVisibleRect(target, align.overflow && align.overflow.alwaysByViewport);
    return $e12d8e794315a3f6$var$doAlign(el, refNodeRegion, align, isTargetNotOutOfVisible);
}
$e12d8e794315a3f6$export$ec21431d5ee6c534.__getOffsetParent = $e12d8e794315a3f6$var$getOffsetParent;
$e12d8e794315a3f6$export$ec21431d5ee6c534.__getVisibleRectForElement = $e12d8e794315a3f6$var$getVisibleRectForElement;
/**
 * `tgtPoint`: { pageX, pageY } or { clientX, clientY }.
 * If client position provided, will internal convert to page position.
 */ function $e12d8e794315a3f6$export$38f0e12f0aa28098(el, tgtPoint, align) {
    var pageX;
    var pageY;
    var doc = $e12d8e794315a3f6$var$utils.getDocument(el);
    var win = doc.defaultView || doc.parentWindow;
    var scrollX = $e12d8e794315a3f6$var$utils.getWindowScrollLeft(win);
    var scrollY = $e12d8e794315a3f6$var$utils.getWindowScrollTop(win);
    var viewportWidth = $e12d8e794315a3f6$var$utils.viewportWidth(win);
    var viewportHeight = $e12d8e794315a3f6$var$utils.viewportHeight(win);
    if ("pageX" in tgtPoint) pageX = tgtPoint.pageX;
    else pageX = scrollX + tgtPoint.clientX;
    if ("pageY" in tgtPoint) pageY = tgtPoint.pageY;
    else pageY = scrollY + tgtPoint.clientY;
    var tgtRegion = {
        left: pageX,
        top: pageY,
        width: 0,
        height: 0
    };
    var pointInView = pageX >= 0 && pageX <= scrollX + viewportWidth && pageY >= 0 && pageY <= scrollY + viewportHeight;
    // Provide default target point
    var points = [
        align.points[0],
        "cc"
    ];
    return $e12d8e794315a3f6$var$doAlign(el, tgtRegion, $e12d8e794315a3f6$var$_objectSpread2($e12d8e794315a3f6$var$_objectSpread2({}, align), {}, {
        points: points
    }), pointInView);
}
var $e12d8e794315a3f6$export$2e2bcd8739ae039 = $e12d8e794315a3f6$export$ec21431d5ee6c534;




/**
 * Deeply compares two object literals.
 * @param obj1 object 1
 * @param obj2 object 2
 * @param shallow shallow compare
 * @returns
 */ function $357adc8667cde522$var$isEqual(obj1, obj2) {
    var shallow = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
    // https://github.com/mapbox/mapbox-gl-js/pull/5979/files#diff-fde7145050c47cc3a306856efd5f9c3016e86e859de9afbd02c879be5067e58f
    var refSet = new Set();
    function deepEqual(a, b) {
        var level = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1;
        var circular = refSet.has(a);
        (0, $05a5f2c645683a81$export$2e2bcd8739ae039)(!circular, "Warning: There may be circular references");
        if (circular) return false;
        if (a === b) return true;
        if (shallow && level > 1) return false;
        refSet.add(a);
        var newLevel = level + 1;
        if (Array.isArray(a)) {
            if (!Array.isArray(b) || a.length !== b.length) return false;
            for(var i = 0; i < a.length; i++){
                if (!deepEqual(a[i], b[i], newLevel)) return false;
            }
            return true;
        }
        if (a && b && (0, $b8f57191916382d3$export$2e2bcd8739ae039)(a) === "object" && (0, $b8f57191916382d3$export$2e2bcd8739ae039)(b) === "object") {
            var keys = Object.keys(a);
            if (keys.length !== Object.keys(b).length) return false;
            return keys.every(function(key) {
                return deepEqual(a[key], b[key], newLevel);
            });
        }
        // other
        return false;
    }
    return deepEqual(obj1, obj2);
}
var $357adc8667cde522$export$2e2bcd8739ae039 = $357adc8667cde522$var$isEqual;







var $acw62 = parcelRequire("acw62");

var $acw62 = parcelRequire("acw62");
var $9f96e09361d71c30$export$2e2bcd8739ae039 = function(callback, buffer) {
    var calledRef = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(false);
    var timeoutRef = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(null);
    function cancelTrigger() {
        window.clearTimeout(timeoutRef.current);
    }
    function trigger(force) {
        cancelTrigger();
        if (!calledRef.current || force === true) {
            if (callback(force) === false) // Not delay since callback cancelled self
            return;
            calledRef.current = true;
            timeoutRef.current = window.setTimeout(function() {
                calledRef.current = false;
            }, buffer);
        } else timeoutRef.current = window.setTimeout(function() {
            calledRef.current = false;
            trigger();
        }, buffer);
    }
    return [
        trigger,
        function() {
            calledRef.current = false;
            cancelTrigger();
        }
    ];
};





function $ea6be2081db9532e$export$792a4d7b8e9efb33(prev, next) {
    if (prev === next) return true;
    if (!prev || !next) return false;
    if ("pageX" in next && "pageY" in next) return prev.pageX === next.pageX && prev.pageY === next.pageY;
    if ("clientX" in next && "clientY" in next) return prev.clientX === next.clientX && prev.clientY === next.clientY;
    return false;
}
function $ea6be2081db9532e$export$2284e449d64b22d5(activeElement, container) {
    // Focus back if is in the container
    if (activeElement !== document.activeElement && (0, $97b4b0194c593c05$export$2e2bcd8739ae039)(container, activeElement) && typeof activeElement.focus === "function") activeElement.focus();
}
function $ea6be2081db9532e$export$f56787db9e74dfe(element, callback) {
    var prevWidth = null;
    var prevHeight = null;
    function onResize(_ref) {
        var _ref2 = (0, $adaabbc18727b3e6$export$2e2bcd8739ae039)(_ref, 1), target = _ref2[0].target;
        if (!document.documentElement.contains(target)) return;
        var _target$getBoundingCl = target.getBoundingClientRect(), width = _target$getBoundingCl.width, height = _target$getBoundingCl.height;
        var fixedWidth = Math.floor(width);
        var fixedHeight = Math.floor(height);
        if (prevWidth !== fixedWidth || prevHeight !== fixedHeight) // https://webkit.org/blog/9997/resizeobserver-in-webkit/
        Promise.resolve().then(function() {
            callback({
                width: fixedWidth,
                height: fixedHeight
            });
        });
        prevWidth = fixedWidth;
        prevHeight = fixedHeight;
    }
    var resizeObserver = new (0, $87c2a74187854fda$export$2e2bcd8739ae039)(onResize);
    if (element) resizeObserver.observe(element);
    return function() {
        resizeObserver.disconnect();
    };
}


function $55d32bed2871d04e$var$getElement(func) {
    if (typeof func !== "function") return null;
    return func();
}
function $55d32bed2871d04e$var$getPoint(point) {
    if ((0, $b8f57191916382d3$export$2e2bcd8739ae039)(point) !== "object" || !point) return null;
    return point;
}
var $55d32bed2871d04e$var$Align = function Align(_ref, ref) {
    var children = _ref.children, disabled = _ref.disabled, target = _ref.target, align = _ref.align, onAlign = _ref.onAlign, monitorWindowResize = _ref.monitorWindowResize, _ref$monitorBufferTim = _ref.monitorBufferTime, monitorBufferTime = _ref$monitorBufferTim === void 0 ? 0 : _ref$monitorBufferTim;
    var cacheRef = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef({});
    /** Popup node ref */ var nodeRef = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef();
    var childNode = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Children.only(children); // ===================== Align ======================
    // We save the props here to avoid closure makes props ood
    var forceAlignPropsRef = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef({});
    forceAlignPropsRef.current.disabled = disabled;
    forceAlignPropsRef.current.target = target;
    forceAlignPropsRef.current.align = align;
    forceAlignPropsRef.current.onAlign = onAlign;
    var _useBuffer = (0, $9f96e09361d71c30$export$2e2bcd8739ae039)(function() {
        var _forceAlignPropsRef$c = forceAlignPropsRef.current, latestDisabled = _forceAlignPropsRef$c.disabled, latestTarget = _forceAlignPropsRef$c.target, latestAlign = _forceAlignPropsRef$c.align, latestOnAlign = _forceAlignPropsRef$c.onAlign;
        var source = nodeRef.current;
        if (!latestDisabled && latestTarget && source) {
            var _result;
            var _element = $55d32bed2871d04e$var$getElement(latestTarget);
            var _point = $55d32bed2871d04e$var$getPoint(latestTarget);
            cacheRef.current.element = _element;
            cacheRef.current.point = _point;
            cacheRef.current.align = latestAlign; // IE lose focus after element realign
            // We should record activeElement and restore later
            var _document = document, activeElement = _document.activeElement; // We only align when element is visible
            if (_element && (0, $555b4eee2695f264$export$2e2bcd8739ae039)(_element)) _result = (0, $e12d8e794315a3f6$export$ec21431d5ee6c534)(source, _element, latestAlign);
            else if (_point) _result = (0, $e12d8e794315a3f6$export$38f0e12f0aa28098)(source, _point, latestAlign);
            (0, $ea6be2081db9532e$export$2284e449d64b22d5)(activeElement, source);
            if (latestOnAlign && _result) latestOnAlign(source, _result);
            return true;
        }
        return false;
    }, monitorBufferTime), _useBuffer2 = (0, $adaabbc18727b3e6$export$2e2bcd8739ae039)(_useBuffer, 2), _forceAlign = _useBuffer2[0], cancelForceAlign = _useBuffer2[1]; // ===================== Effect =====================
    // Handle props change
    var _React$useState = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(), _React$useState2 = (0, $adaabbc18727b3e6$export$2e2bcd8739ae039)(_React$useState, 2), element = _React$useState2[0], setElement = _React$useState2[1];
    var _React$useState3 = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(), _React$useState4 = (0, $adaabbc18727b3e6$export$2e2bcd8739ae039)(_React$useState3, 2), point = _React$useState4[0], setPoint = _React$useState4[1];
    (0, $493347a9fd5d8394$export$2e2bcd8739ae039)(function() {
        setElement($55d32bed2871d04e$var$getElement(target));
        setPoint($55d32bed2871d04e$var$getPoint(target));
    });
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(function() {
        if (cacheRef.current.element !== element || !(0, $ea6be2081db9532e$export$792a4d7b8e9efb33)(cacheRef.current.point, point) || !(0, $357adc8667cde522$export$2e2bcd8739ae039)(cacheRef.current.align, align)) _forceAlign();
    }); // Watch popup element resize
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(function() {
        var cancelFn = (0, $ea6be2081db9532e$export$f56787db9e74dfe)(nodeRef.current, _forceAlign);
        return cancelFn;
    }, [
        nodeRef.current
    ]); // Watch target element resize
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(function() {
        var cancelFn = (0, $ea6be2081db9532e$export$f56787db9e74dfe)(element, _forceAlign);
        return cancelFn;
    }, [
        element
    ]); // Listen for disabled change
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(function() {
        if (!disabled) _forceAlign();
        else cancelForceAlign();
    }, [
        disabled
    ]); // Listen for window resize
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(function() {
        if (monitorWindowResize) {
            var cancelFn = (0, $0860008a706f6e42$export$2e2bcd8739ae039)(window, "resize", _forceAlign);
            return cancelFn.remove;
        }
    }, [
        monitorWindowResize
    ]); // Clear all if unmount
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(function() {
        return function() {
            cancelForceAlign();
        };
    }, []); // ====================== Ref =======================
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useImperativeHandle(ref, function() {
        return {
            forceAlign: function forceAlign() {
                return _forceAlign(true);
            }
        };
    }); // ===================== Render =====================
    if (/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).isValidElement(childNode)) childNode = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).cloneElement(childNode, {
        ref: (0, $5e297877593af644$export$ab452c34e8e05029)(childNode.ref, nodeRef)
    });
    return childNode;
};
var $55d32bed2871d04e$var$RcAlign = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).forwardRef($55d32bed2871d04e$var$Align);
$55d32bed2871d04e$var$RcAlign.displayName = "Align";
var $55d32bed2871d04e$export$2e2bcd8739ae039 = $55d32bed2871d04e$var$RcAlign;


var $59dd2406f90550fc$export$2e2bcd8739ae039 = (0, $55d32bed2871d04e$export$2e2bcd8739ae039);









var $acw62 = parcelRequire("acw62");


/**
 * Popup should follow the steps for each component work correctly:
 * measure - check for the current stretch size
 * align - let component align the position
 * aligned - re-align again in case additional className changed the size
 * afterAlign - choice next step is trigger motion or finished
 * beforeMotion - should reset motion to invisible so that CSSMotion can do normal motion
 * motion - play the motion
 * stable - everything is done
 */ var $693b209e865ba00a$var$StatusQueue = [
    "measure",
    "alignPre",
    "align",
    null,
    "motion"
];
var $693b209e865ba00a$export$2e2bcd8739ae039 = function(visible, doMeasure) {
    var _useState = (0, $25e137fc56329ad1$export$2e2bcd8739ae039)(null), _useState2 = (0, $adaabbc18727b3e6$export$2e2bcd8739ae039)(_useState, 2), status = _useState2[0], setInternalStatus = _useState2[1];
    var rafRef = (0, $acw62.useRef)();
    function setStatus(nextStatus) {
        setInternalStatus(nextStatus, true);
    }
    function cancelRaf() {
        (0, $a1ced7b983ea61a4$export$2e2bcd8739ae039).cancel(rafRef.current);
    }
    function goNextStatus(callback) {
        cancelRaf();
        rafRef.current = (0, $a1ced7b983ea61a4$export$2e2bcd8739ae039)(function() {
            // Only align should be manually trigger
            setStatus(function(prev) {
                switch(status){
                    case "align":
                        return "motion";
                    case "motion":
                        return "stable";
                    default:
                }
                return prev;
            });
            callback === null || callback === void 0 || callback();
        });
    } // Init status
    (0, $acw62.useEffect)(function() {
        setStatus("measure");
    }, [
        visible
    ]); // Go next status
    (0, $acw62.useEffect)(function() {
        switch(status){
            case "measure":
                doMeasure();
                break;
            default:
        }
        if (status) rafRef.current = (0, $a1ced7b983ea61a4$export$2e2bcd8739ae039)(/*#__PURE__*/ (0, $4051039ece381ef4$export$2e2bcd8739ae039)(/*#__PURE__*/ (0, $90d00d496f52c75c$export$2e2bcd8739ae039)().mark(function _callee() {
            var index, nextStatus;
            return (0, $90d00d496f52c75c$export$2e2bcd8739ae039)().wrap(function _callee$(_context) {
                while(true)switch(_context.prev = _context.next){
                    case 0:
                        index = $693b209e865ba00a$var$StatusQueue.indexOf(status);
                        nextStatus = $693b209e865ba00a$var$StatusQueue[index + 1];
                        if (nextStatus && index !== -1) setStatus(nextStatus);
                    case 3:
                    case "end":
                        return _context.stop();
                }
            }, _callee);
        })));
    }, [
        status
    ]);
    (0, $acw62.useEffect)(function() {
        return function() {
            cancelRaf();
        };
    }, []);
    return [
        status,
        goNextStatus
    ];
};





var $acw62 = parcelRequire("acw62");
var $714883682f77f849$export$2e2bcd8739ae039 = function(stretch) {
    var _React$useState = $acw62.useState({
        width: 0,
        height: 0
    }), _React$useState2 = (0, $adaabbc18727b3e6$export$2e2bcd8739ae039)(_React$useState, 2), targetSize = _React$useState2[0], setTargetSize = _React$useState2[1];
    function measureStretch(element) {
        var tgtWidth = element.offsetWidth, tgtHeight = element.offsetHeight;
        var _element$getBoundingC = element.getBoundingClientRect(), width = _element$getBoundingC.width, height = _element$getBoundingC.height; // Rect is more accurate than offset, use if near
        if (Math.abs(tgtWidth - width) < 1 && Math.abs(tgtHeight - height) < 1) {
            tgtWidth = width;
            tgtHeight = height;
        }
        setTargetSize({
            width: tgtWidth,
            height: tgtHeight
        });
    } // Merge stretch style
    var style = $acw62.useMemo(function() {
        var sizeStyle = {};
        if (stretch) {
            var width = targetSize.width, height = targetSize.height; // Stretch with target
            if (stretch.indexOf("height") !== -1 && height) sizeStyle.height = height;
            else if (stretch.indexOf("minHeight") !== -1 && height) sizeStyle.minHeight = height;
            if (stretch.indexOf("width") !== -1 && width) sizeStyle.width = width;
            else if (stretch.indexOf("minWidth") !== -1 && width) sizeStyle.minWidth = width;
        }
        return sizeStyle;
    }, [
        stretch,
        targetSize
    ]);
    return [
        style,
        measureStretch
    ];
};


var $70240df66fd05ad7$var$PopupInner = /*#__PURE__*/ $acw62.forwardRef(function(props, ref) {
    var visible = props.visible, prefixCls = props.prefixCls, className = props.className, style = props.style, children = props.children, zIndex = props.zIndex, stretch = props.stretch, destroyPopupOnHide = props.destroyPopupOnHide, forceRender = props.forceRender, align = props.align, point = props.point, getRootDomNode = props.getRootDomNode, getClassNameFromAlign = props.getClassNameFromAlign, onAlign = props.onAlign, onMouseEnter = props.onMouseEnter, onMouseLeave = props.onMouseLeave, onMouseDown = props.onMouseDown, onTouchStart = props.onTouchStart, onClick = props.onClick;
    var alignRef = (0, $acw62.useRef)();
    var elementRef = (0, $acw62.useRef)();
    var _useState = (0, $acw62.useState)(), _useState2 = (0, $adaabbc18727b3e6$export$2e2bcd8739ae039)(_useState, 2), alignedClassName = _useState2[0], setAlignedClassName = _useState2[1]; // ======================= Measure ========================
    var _useStretchStyle = (0, $714883682f77f849$export$2e2bcd8739ae039)(stretch), _useStretchStyle2 = (0, $adaabbc18727b3e6$export$2e2bcd8739ae039)(_useStretchStyle, 2), stretchStyle = _useStretchStyle2[0], measureStretchStyle = _useStretchStyle2[1];
    function doMeasure() {
        if (stretch) measureStretchStyle(getRootDomNode());
    } // ======================== Status ========================
    var _useVisibleStatus = (0, $693b209e865ba00a$export$2e2bcd8739ae039)(visible, doMeasure), _useVisibleStatus2 = (0, $adaabbc18727b3e6$export$2e2bcd8739ae039)(_useVisibleStatus, 2), status = _useVisibleStatus2[0], goNextStatus = _useVisibleStatus2[1]; // ======================== Aligns ========================
    /**
   * `alignedClassName` may modify `source` size,
   * which means one time align may not move to the correct position at once.
   *
   * We will reset `alignTimes` for each status switch to `alignPre`
   * and let `rc-align` to align for multiple times to ensure get final stable place.
   * Currently we mark `alignTimes < 2` repeat align, it will increase if user report for align issue.
   * 
   * Update:
   * In React 18. `rc-align` effect of align may faster than ref called trigger `forceAlign`.
   * We adjust this to `alignTimes < 2`.
   * We need refactor `rc-align` to support mark of `forceAlign` call if this still happen.
   */ var _useState3 = (0, $acw62.useState)(0), _useState4 = (0, $adaabbc18727b3e6$export$2e2bcd8739ae039)(_useState3, 2), alignTimes = _useState4[0], setAlignTimes = _useState4[1];
    var prepareResolveRef = (0, $acw62.useRef)();
    (0, $493347a9fd5d8394$export$2e2bcd8739ae039)(function() {
        if (status === "alignPre") setAlignTimes(0);
    }, [
        status
    ]); // `target` on `rc-align` can accept as a function to get the bind element or a point.
    // ref: https://www.npmjs.com/package/rc-align
    function getAlignTarget() {
        if (point) return point;
        return getRootDomNode;
    }
    function forceAlign() {
        var _alignRef$current;
        (_alignRef$current = alignRef.current) === null || _alignRef$current === void 0 || _alignRef$current.forceAlign();
    }
    function onInternalAlign(popupDomNode, matchAlign) {
        var nextAlignedClassName = getClassNameFromAlign(matchAlign);
        if (alignedClassName !== nextAlignedClassName) setAlignedClassName(nextAlignedClassName);
         // We will retry multi times to make sure that the element has been align in the right position.
        setAlignTimes(function(val) {
            return val + 1;
        });
        if (status === "align") onAlign === null || onAlign === void 0 || onAlign(popupDomNode, matchAlign);
    } // Delay to go to next status
    (0, $493347a9fd5d8394$export$2e2bcd8739ae039)(function() {
        if (status === "align") {
            // Repeat until not more align needed
            if (alignTimes < 3) forceAlign();
            else goNextStatus(function() {
                var _prepareResolveRef$cu;
                (_prepareResolveRef$cu = prepareResolveRef.current) === null || _prepareResolveRef$cu === void 0 || _prepareResolveRef$cu.call(prepareResolveRef);
            });
        }
    }, [
        alignTimes
    ]); // ======================== Motion ========================
    var motion = (0, $983350b7b3960a26$export$2e2bcd8739ae039)({}, (0, $9c3c4b97fcaf5e46$export$7b8936ddc277a29a)(props));
    [
        "onAppearEnd",
        "onEnterEnd",
        "onLeaveEnd"
    ].forEach(function(eventName) {
        var originHandler = motion[eventName];
        motion[eventName] = function(element, event) {
            goNextStatus();
            return originHandler === null || originHandler === void 0 ? void 0 : originHandler(element, event);
        };
    });
    function onShowPrepare() {
        return new Promise(function(resolve) {
            prepareResolveRef.current = resolve;
        });
    } // Go to stable directly when motion not provided
    $acw62.useEffect(function() {
        if (!motion.motionName && status === "motion") goNextStatus();
    }, [
        motion.motionName,
        status
    ]); // ========================= Refs =========================
    $acw62.useImperativeHandle(ref, function() {
        return {
            forceAlign: forceAlign,
            getElement: function getElement() {
                return elementRef.current;
            }
        };
    }); // ======================== Render ========================
    var mergedStyle = (0, $983350b7b3960a26$export$2e2bcd8739ae039)((0, $983350b7b3960a26$export$2e2bcd8739ae039)({}, stretchStyle), {}, {
        zIndex: zIndex,
        opacity: status === "motion" || status === "stable" || !visible ? undefined : 0,
        // Cannot interact with disappearing elements
        // https://github.com/ant-design/ant-design/issues/35051#issuecomment-1101340714
        pointerEvents: !visible && status !== "stable" ? "none" : undefined
    }, style); // Align status
    var alignDisabled = true;
    if (align !== null && align !== void 0 && align.points && (status === "align" || status === "stable")) alignDisabled = false;
    var childNode = children; // Wrapper when multiple children
    if ($acw62.Children.count(children) > 1) childNode = /*#__PURE__*/ $acw62.createElement("div", {
        className: "".concat(prefixCls, "-content")
    }, children);
    return /*#__PURE__*/ $acw62.createElement((0, $609e894acbce1933$export$2e2bcd8739ae039), (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({
        visible: visible,
        ref: elementRef,
        leavedClassName: "".concat(prefixCls, "-hidden")
    }, motion, {
        onAppearPrepare: onShowPrepare,
        onEnterPrepare: onShowPrepare,
        removeOnLeave: destroyPopupOnHide,
        forceRender: forceRender
    }), function(_ref, motionRef) {
        var motionClassName = _ref.className, motionStyle = _ref.style;
        var mergedClassName = (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))(prefixCls, className, alignedClassName, motionClassName);
        return /*#__PURE__*/ $acw62.createElement((0, $59dd2406f90550fc$export$2e2bcd8739ae039), {
            target: getAlignTarget(),
            key: "popup",
            ref: alignRef,
            monitorWindowResize: true,
            disabled: alignDisabled,
            align: align,
            onAlign: onInternalAlign
        }, /*#__PURE__*/ $acw62.createElement("div", {
            ref: motionRef,
            className: mergedClassName,
            onMouseEnter: onMouseEnter,
            onMouseLeave: onMouseLeave,
            onMouseDownCapture: onMouseDown,
            onTouchStartCapture: onTouchStart,
            onClick: onClick,
            style: (0, $983350b7b3960a26$export$2e2bcd8739ae039)((0, $983350b7b3960a26$export$2e2bcd8739ae039)({}, motionStyle), mergedStyle)
        }, childNode));
    });
});
$70240df66fd05ad7$var$PopupInner.displayName = "PopupInner";
var $70240df66fd05ad7$export$2e2bcd8739ae039 = $70240df66fd05ad7$var$PopupInner;





var $acw62 = parcelRequire("acw62");


var $5192f360d8c1ec4e$var$MobilePopupInner = /*#__PURE__*/ $acw62.forwardRef(function(props, ref) {
    var prefixCls = props.prefixCls, visible = props.visible, zIndex = props.zIndex, children = props.children, _props$mobile = props.mobile;
    _props$mobile = _props$mobile === void 0 ? {} : _props$mobile;
    var popupClassName = _props$mobile.popupClassName, popupStyle = _props$mobile.popupStyle, _props$mobile$popupMo = _props$mobile.popupMotion, popupMotion = _props$mobile$popupMo === void 0 ? {} : _props$mobile$popupMo, popupRender = _props$mobile.popupRender, onClick = props.onClick;
    var elementRef = $acw62.useRef(); // ========================= Refs =========================
    $acw62.useImperativeHandle(ref, function() {
        return {
            forceAlign: function forceAlign() {},
            getElement: function getElement() {
                return elementRef.current;
            }
        };
    }); // ======================== Render ========================
    var mergedStyle = (0, $983350b7b3960a26$export$2e2bcd8739ae039)({
        zIndex: zIndex
    }, popupStyle);
    var childNode = children; // Wrapper when multiple children
    if ($acw62.Children.count(children) > 1) childNode = /*#__PURE__*/ $acw62.createElement("div", {
        className: "".concat(prefixCls, "-content")
    }, children);
     // Mobile support additional render
    if (popupRender) childNode = popupRender(childNode);
    return /*#__PURE__*/ $acw62.createElement((0, $609e894acbce1933$export$2e2bcd8739ae039), (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({
        visible: visible,
        ref: elementRef,
        removeOnLeave: true
    }, popupMotion), function(_ref, motionRef) {
        var motionClassName = _ref.className, motionStyle = _ref.style;
        var mergedClassName = (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))(prefixCls, popupClassName, motionClassName);
        return /*#__PURE__*/ $acw62.createElement("div", {
            ref: motionRef,
            className: mergedClassName,
            onClick: onClick,
            style: (0, $983350b7b3960a26$export$2e2bcd8739ae039)((0, $983350b7b3960a26$export$2e2bcd8739ae039)({}, motionStyle), mergedStyle)
        }, childNode);
    });
});
$5192f360d8c1ec4e$var$MobilePopupInner.displayName = "MobilePopupInner";
var $5192f360d8c1ec4e$export$2e2bcd8739ae039 = $5192f360d8c1ec4e$var$MobilePopupInner;


var $05068faf00eec836$var$_excluded = [
    "visible",
    "mobile"
];
var $05068faf00eec836$var$Popup = /*#__PURE__*/ $acw62.forwardRef(function(_ref, ref) {
    var visible = _ref.visible, mobile = _ref.mobile, props = (0, $73ef9ce1c41fc0c0$export$2e2bcd8739ae039)(_ref, $05068faf00eec836$var$_excluded);
    var _useState = (0, $acw62.useState)(visible), _useState2 = (0, $adaabbc18727b3e6$export$2e2bcd8739ae039)(_useState, 2), innerVisible = _useState2[0], serInnerVisible = _useState2[1];
    var _useState3 = (0, $acw62.useState)(false), _useState4 = (0, $adaabbc18727b3e6$export$2e2bcd8739ae039)(_useState3, 2), inMobile = _useState4[0], setInMobile = _useState4[1];
    var cloneProps = (0, $983350b7b3960a26$export$2e2bcd8739ae039)((0, $983350b7b3960a26$export$2e2bcd8739ae039)({}, props), {}, {
        visible: innerVisible
    }); // We check mobile in visible changed here.
    // And this also delay set `innerVisible` to avoid popup component render flash
    (0, $acw62.useEffect)(function() {
        serInnerVisible(visible);
        if (visible && mobile) setInMobile((0, $066d1680709fcf3c$export$2e2bcd8739ae039)());
    }, [
        visible,
        mobile
    ]);
    var popupNode = inMobile ? /*#__PURE__*/ $acw62.createElement((0, $5192f360d8c1ec4e$export$2e2bcd8739ae039), (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, cloneProps, {
        mobile: mobile,
        ref: ref
    })) : /*#__PURE__*/ $acw62.createElement((0, $70240df66fd05ad7$export$2e2bcd8739ae039), (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, cloneProps, {
        ref: ref
    })); // We can use fragment directly but this may failed some selector usage. Keep as origin logic
    return /*#__PURE__*/ $acw62.createElement("div", null, /*#__PURE__*/ $acw62.createElement((0, $4ac29f08ce13555e$export$2e2bcd8739ae039), cloneProps), popupNode);
});
$05068faf00eec836$var$Popup.displayName = "Popup";
var $05068faf00eec836$export$2e2bcd8739ae039 = $05068faf00eec836$var$Popup;



var $acw62 = parcelRequire("acw62");
var $34a0dc940d0dd00d$var$TriggerContext = /*#__PURE__*/ $acw62.createContext(null);
var $34a0dc940d0dd00d$export$2e2bcd8739ae039 = $34a0dc940d0dd00d$var$TriggerContext;


function $bf97e04178e2dc31$var$noop() {}
function $bf97e04178e2dc31$var$returnEmptyString() {
    return "";
}
function $bf97e04178e2dc31$var$returnDocument(element) {
    if (element) return element.ownerDocument;
    return window.document;
}
var $bf97e04178e2dc31$var$ALL_HANDLERS = [
    "onClick",
    "onMouseDown",
    "onTouchStart",
    "onMouseEnter",
    "onMouseLeave",
    "onFocus",
    "onBlur",
    "onContextMenu"
];
function $bf97e04178e2dc31$export$55e99723d7f71b47(PortalComponent) {
    var Trigger = /*#__PURE__*/ function(_React$Component) {
        (0, $0ed648f7bbaf3aff$export$2e2bcd8739ae039)(Trigger, _React$Component);
        var _super = (0, $a76f20fb39fa9d46$export$2e2bcd8739ae039)(Trigger);
        // ensure `getContainer` will be called only once
        function Trigger(props) {
            var _this;
            (0, $4d35ca0862055760$export$2e2bcd8739ae039)(this, Trigger);
            _this = _super.call(this, props);
            (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)((0, $cd69a1d4c6210e44$export$2e2bcd8739ae039)(_this), "popupRef", /*#__PURE__*/ $acw62.createRef());
            (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)((0, $cd69a1d4c6210e44$export$2e2bcd8739ae039)(_this), "triggerRef", /*#__PURE__*/ $acw62.createRef());
            (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)((0, $cd69a1d4c6210e44$export$2e2bcd8739ae039)(_this), "portalContainer", void 0);
            (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)((0, $cd69a1d4c6210e44$export$2e2bcd8739ae039)(_this), "attachId", void 0);
            (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)((0, $cd69a1d4c6210e44$export$2e2bcd8739ae039)(_this), "clickOutsideHandler", void 0);
            (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)((0, $cd69a1d4c6210e44$export$2e2bcd8739ae039)(_this), "touchOutsideHandler", void 0);
            (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)((0, $cd69a1d4c6210e44$export$2e2bcd8739ae039)(_this), "contextMenuOutsideHandler1", void 0);
            (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)((0, $cd69a1d4c6210e44$export$2e2bcd8739ae039)(_this), "contextMenuOutsideHandler2", void 0);
            (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)((0, $cd69a1d4c6210e44$export$2e2bcd8739ae039)(_this), "mouseDownTimeout", void 0);
            (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)((0, $cd69a1d4c6210e44$export$2e2bcd8739ae039)(_this), "focusTime", void 0);
            (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)((0, $cd69a1d4c6210e44$export$2e2bcd8739ae039)(_this), "preClickTime", void 0);
            (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)((0, $cd69a1d4c6210e44$export$2e2bcd8739ae039)(_this), "preTouchTime", void 0);
            (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)((0, $cd69a1d4c6210e44$export$2e2bcd8739ae039)(_this), "delayTimer", void 0);
            (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)((0, $cd69a1d4c6210e44$export$2e2bcd8739ae039)(_this), "hasPopupMouseDown", void 0);
            (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)((0, $cd69a1d4c6210e44$export$2e2bcd8739ae039)(_this), "onMouseEnter", function(e) {
                var mouseEnterDelay = _this.props.mouseEnterDelay;
                _this.fireEvents("onMouseEnter", e);
                _this.delaySetPopupVisible(true, mouseEnterDelay, mouseEnterDelay ? null : e);
            });
            (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)((0, $cd69a1d4c6210e44$export$2e2bcd8739ae039)(_this), "onMouseMove", function(e) {
                _this.fireEvents("onMouseMove", e);
                _this.setPoint(e);
            });
            (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)((0, $cd69a1d4c6210e44$export$2e2bcd8739ae039)(_this), "onMouseLeave", function(e) {
                _this.fireEvents("onMouseLeave", e);
                _this.delaySetPopupVisible(false, _this.props.mouseLeaveDelay);
            });
            (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)((0, $cd69a1d4c6210e44$export$2e2bcd8739ae039)(_this), "onPopupMouseEnter", function() {
                _this.clearDelayTimer();
            });
            (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)((0, $cd69a1d4c6210e44$export$2e2bcd8739ae039)(_this), "onPopupMouseLeave", function(e) {
                var _this$popupRef$curren;
                // https://github.com/react-component/trigger/pull/13
                // react bug?
                if (e.relatedTarget && !e.relatedTarget.setTimeout && (0, $97b4b0194c593c05$export$2e2bcd8739ae039)((_this$popupRef$curren = _this.popupRef.current) === null || _this$popupRef$curren === void 0 ? void 0 : _this$popupRef$curren.getElement(), e.relatedTarget)) return;
                _this.delaySetPopupVisible(false, _this.props.mouseLeaveDelay);
            });
            (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)((0, $cd69a1d4c6210e44$export$2e2bcd8739ae039)(_this), "onFocus", function(e) {
                _this.fireEvents("onFocus", e); // incase focusin and focusout
                _this.clearDelayTimer();
                if (_this.isFocusToShow()) {
                    _this.focusTime = Date.now();
                    _this.delaySetPopupVisible(true, _this.props.focusDelay);
                }
            });
            (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)((0, $cd69a1d4c6210e44$export$2e2bcd8739ae039)(_this), "onMouseDown", function(e) {
                _this.fireEvents("onMouseDown", e);
                _this.preClickTime = Date.now();
            });
            (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)((0, $cd69a1d4c6210e44$export$2e2bcd8739ae039)(_this), "onTouchStart", function(e) {
                _this.fireEvents("onTouchStart", e);
                _this.preTouchTime = Date.now();
            });
            (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)((0, $cd69a1d4c6210e44$export$2e2bcd8739ae039)(_this), "onBlur", function(e) {
                _this.fireEvents("onBlur", e);
                _this.clearDelayTimer();
                if (_this.isBlurToHide()) _this.delaySetPopupVisible(false, _this.props.blurDelay);
            });
            (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)((0, $cd69a1d4c6210e44$export$2e2bcd8739ae039)(_this), "onContextMenu", function(e) {
                e.preventDefault();
                _this.fireEvents("onContextMenu", e);
                _this.setPopupVisible(true, e);
            });
            (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)((0, $cd69a1d4c6210e44$export$2e2bcd8739ae039)(_this), "onContextMenuClose", function() {
                if (_this.isContextMenuToShow()) _this.close();
            });
            (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)((0, $cd69a1d4c6210e44$export$2e2bcd8739ae039)(_this), "onClick", function(event) {
                _this.fireEvents("onClick", event); // focus will trigger click
                if (_this.focusTime) {
                    var preTime;
                    if (_this.preClickTime && _this.preTouchTime) preTime = Math.min(_this.preClickTime, _this.preTouchTime);
                    else if (_this.preClickTime) preTime = _this.preClickTime;
                    else if (_this.preTouchTime) preTime = _this.preTouchTime;
                    if (Math.abs(preTime - _this.focusTime) < 20) return;
                    _this.focusTime = 0;
                }
                _this.preClickTime = 0;
                _this.preTouchTime = 0; // Only prevent default when all the action is click.
                // https://github.com/ant-design/ant-design/issues/17043
                // https://github.com/ant-design/ant-design/issues/17291
                if (_this.isClickToShow() && (_this.isClickToHide() || _this.isBlurToHide()) && event && event.preventDefault) event.preventDefault();
                var nextVisible = !_this.state.popupVisible;
                if (_this.isClickToHide() && !nextVisible || nextVisible && _this.isClickToShow()) _this.setPopupVisible(!_this.state.popupVisible, event);
            });
            (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)((0, $cd69a1d4c6210e44$export$2e2bcd8739ae039)(_this), "onPopupMouseDown", function() {
                _this.hasPopupMouseDown = true;
                clearTimeout(_this.mouseDownTimeout);
                _this.mouseDownTimeout = window.setTimeout(function() {
                    _this.hasPopupMouseDown = false;
                }, 0);
                if (_this.context) {
                    var _this$context;
                    (_this$context = _this.context).onPopupMouseDown.apply(_this$context, arguments);
                }
            });
            (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)((0, $cd69a1d4c6210e44$export$2e2bcd8739ae039)(_this), "onDocumentClick", function(event) {
                if (_this.props.mask && !_this.props.maskClosable) return;
                var target = event.target;
                var root = _this.getRootDomNode();
                var popupNode = _this.getPopupDomNode();
                if (// https://github.com/ant-design/ant-design/issues/29853
                (!(0, $97b4b0194c593c05$export$2e2bcd8739ae039)(root, target) || _this.isContextMenuOnly()) && !(0, $97b4b0194c593c05$export$2e2bcd8739ae039)(popupNode, target) && !_this.hasPopupMouseDown) _this.close();
            });
            (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)((0, $cd69a1d4c6210e44$export$2e2bcd8739ae039)(_this), "getRootDomNode", function() {
                var getTriggerDOMNode = _this.props.getTriggerDOMNode;
                if (getTriggerDOMNode) return getTriggerDOMNode(_this.triggerRef.current);
                try {
                    var domNode = (0, $808ab7b8a87ab771$export$2e2bcd8739ae039)(_this.triggerRef.current);
                    if (domNode) return domNode;
                } catch (err) {}
                return (0, (/*@__PURE__*/$parcel$interopDefault($1u0KT))).findDOMNode((0, $cd69a1d4c6210e44$export$2e2bcd8739ae039)(_this));
            });
            (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)((0, $cd69a1d4c6210e44$export$2e2bcd8739ae039)(_this), "getPopupClassNameFromAlign", function(align) {
                var className = [];
                var _this$props = _this.props, popupPlacement = _this$props.popupPlacement, builtinPlacements = _this$props.builtinPlacements, prefixCls = _this$props.prefixCls, alignPoint = _this$props.alignPoint, getPopupClassNameFromAlign = _this$props.getPopupClassNameFromAlign;
                if (popupPlacement && builtinPlacements) className.push((0, $72bedf1023859414$export$faa0aa8ed2fe6432)(builtinPlacements, prefixCls, align, alignPoint));
                if (getPopupClassNameFromAlign) className.push(getPopupClassNameFromAlign(align));
                return className.join(" ");
            });
            (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)((0, $cd69a1d4c6210e44$export$2e2bcd8739ae039)(_this), "getComponent", function() {
                var _this$props2 = _this.props, prefixCls = _this$props2.prefixCls, destroyPopupOnHide = _this$props2.destroyPopupOnHide, popupClassName = _this$props2.popupClassName, onPopupAlign = _this$props2.onPopupAlign, popupMotion = _this$props2.popupMotion, popupAnimation = _this$props2.popupAnimation, popupTransitionName = _this$props2.popupTransitionName, popupStyle = _this$props2.popupStyle, mask = _this$props2.mask, maskAnimation = _this$props2.maskAnimation, maskTransitionName = _this$props2.maskTransitionName, maskMotion = _this$props2.maskMotion, zIndex = _this$props2.zIndex, popup = _this$props2.popup, stretch = _this$props2.stretch, alignPoint = _this$props2.alignPoint, mobile = _this$props2.mobile, forceRender = _this$props2.forceRender, onPopupClick = _this$props2.onPopupClick;
                var _this$state = _this.state, popupVisible = _this$state.popupVisible, point = _this$state.point;
                var align = _this.getPopupAlign();
                var mouseProps = {};
                if (_this.isMouseEnterToShow()) mouseProps.onMouseEnter = _this.onPopupMouseEnter;
                if (_this.isMouseLeaveToHide()) mouseProps.onMouseLeave = _this.onPopupMouseLeave;
                mouseProps.onMouseDown = _this.onPopupMouseDown;
                mouseProps.onTouchStart = _this.onPopupMouseDown;
                return /*#__PURE__*/ $acw62.createElement((0, $05068faf00eec836$export$2e2bcd8739ae039), (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({
                    prefixCls: prefixCls,
                    destroyPopupOnHide: destroyPopupOnHide,
                    visible: popupVisible,
                    point: alignPoint && point,
                    className: popupClassName,
                    align: align,
                    onAlign: onPopupAlign,
                    animation: popupAnimation,
                    getClassNameFromAlign: _this.getPopupClassNameFromAlign
                }, mouseProps, {
                    stretch: stretch,
                    getRootDomNode: _this.getRootDomNode,
                    style: popupStyle,
                    mask: mask,
                    zIndex: zIndex,
                    transitionName: popupTransitionName,
                    maskAnimation: maskAnimation,
                    maskTransitionName: maskTransitionName,
                    maskMotion: maskMotion,
                    ref: _this.popupRef,
                    motion: popupMotion,
                    mobile: mobile,
                    forceRender: forceRender,
                    onClick: onPopupClick
                }), typeof popup === "function" ? popup() : popup);
            });
            (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)((0, $cd69a1d4c6210e44$export$2e2bcd8739ae039)(_this), "attachParent", function(popupContainer) {
                (0, $a1ced7b983ea61a4$export$2e2bcd8739ae039).cancel(_this.attachId);
                var _this$props3 = _this.props, getPopupContainer = _this$props3.getPopupContainer, getDocument = _this$props3.getDocument;
                var domNode = _this.getRootDomNode();
                var mountNode;
                if (!getPopupContainer) mountNode = getDocument(_this.getRootDomNode()).body;
                else if (domNode || getPopupContainer.length === 0) // Compatible for legacy getPopupContainer with domNode argument.
                // If no need `domNode` argument, will call directly.
                // https://codesandbox.io/s/eloquent-mclean-ss93m?file=/src/App.js
                mountNode = getPopupContainer(domNode);
                if (mountNode) mountNode.appendChild(popupContainer);
                else // Retry after frame render in case parent not ready
                _this.attachId = (0, $a1ced7b983ea61a4$export$2e2bcd8739ae039)(function() {
                    _this.attachParent(popupContainer);
                });
            });
            (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)((0, $cd69a1d4c6210e44$export$2e2bcd8739ae039)(_this), "getContainer", function() {
                if (!_this.portalContainer) {
                    // In React.StrictMode component will call render multiple time in first mount.
                    // When you want to refactor with FC, useRef will also init multiple time and
                    // point to different useRef instance which will create multiple element
                    // (This multiple render will not trigger effect so you can not clean up this
                    // in effect). But this is safe with class component since it always point to same class instance.
                    var getDocument = _this.props.getDocument;
                    var popupContainer = getDocument(_this.getRootDomNode()).createElement("div"); // Make sure default popup container will never cause scrollbar appearing
                    // https://github.com/react-component/trigger/issues/41
                    popupContainer.style.position = "absolute";
                    popupContainer.style.top = "0";
                    popupContainer.style.left = "0";
                    popupContainer.style.width = "100%";
                    _this.portalContainer = popupContainer;
                }
                _this.attachParent(_this.portalContainer);
                return _this.portalContainer;
            });
            (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)((0, $cd69a1d4c6210e44$export$2e2bcd8739ae039)(_this), "setPoint", function(point) {
                var alignPoint = _this.props.alignPoint;
                if (!alignPoint || !point) return;
                _this.setState({
                    point: {
                        pageX: point.pageX,
                        pageY: point.pageY
                    }
                });
            });
            (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)((0, $cd69a1d4c6210e44$export$2e2bcd8739ae039)(_this), "handlePortalUpdate", function() {
                if (_this.state.prevPopupVisible !== _this.state.popupVisible) _this.props.afterPopupVisibleChange(_this.state.popupVisible);
            });
            (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)((0, $cd69a1d4c6210e44$export$2e2bcd8739ae039)(_this), "triggerContextValue", {
                onPopupMouseDown: _this.onPopupMouseDown
            });
            var _popupVisible;
            if ("popupVisible" in props) _popupVisible = !!props.popupVisible;
            else _popupVisible = !!props.defaultPopupVisible;
            _this.state = {
                prevPopupVisible: _popupVisible,
                popupVisible: _popupVisible
            };
            $bf97e04178e2dc31$var$ALL_HANDLERS.forEach(function(h) {
                _this["fire".concat(h)] = function(e) {
                    _this.fireEvents(h, e);
                };
            });
            return _this;
        }
        (0, $94019358ecbcf36b$export$2e2bcd8739ae039)(Trigger, [
            {
                key: "componentDidMount",
                value: function componentDidMount() {
                    this.componentDidUpdate();
                }
            },
            {
                key: "componentDidUpdate",
                value: function componentDidUpdate() {
                    var props = this.props;
                    var state = this.state; // We must listen to `mousedown` or `touchstart`, edge case:
                    // https://github.com/ant-design/ant-design/issues/5804
                    // https://github.com/react-component/calendar/issues/250
                    // https://github.com/react-component/trigger/issues/50
                    if (state.popupVisible) {
                        var currentDocument;
                        if (!this.clickOutsideHandler && (this.isClickToHide() || this.isContextMenuToShow())) {
                            currentDocument = props.getDocument(this.getRootDomNode());
                            this.clickOutsideHandler = (0, $0860008a706f6e42$export$2e2bcd8739ae039)(currentDocument, "mousedown", this.onDocumentClick);
                        } // always hide on mobile
                        if (!this.touchOutsideHandler) {
                            currentDocument = currentDocument || props.getDocument(this.getRootDomNode());
                            this.touchOutsideHandler = (0, $0860008a706f6e42$export$2e2bcd8739ae039)(currentDocument, "touchstart", this.onDocumentClick);
                        } // close popup when trigger type contains 'onContextMenu' and document is scrolling.
                        if (!this.contextMenuOutsideHandler1 && this.isContextMenuToShow()) {
                            currentDocument = currentDocument || props.getDocument(this.getRootDomNode());
                            this.contextMenuOutsideHandler1 = (0, $0860008a706f6e42$export$2e2bcd8739ae039)(currentDocument, "scroll", this.onContextMenuClose);
                        } // close popup when trigger type contains 'onContextMenu' and window is blur.
                        if (!this.contextMenuOutsideHandler2 && this.isContextMenuToShow()) this.contextMenuOutsideHandler2 = (0, $0860008a706f6e42$export$2e2bcd8739ae039)(window, "blur", this.onContextMenuClose);
                        return;
                    }
                    this.clearOutsideHandler();
                }
            },
            {
                key: "componentWillUnmount",
                value: function componentWillUnmount() {
                    this.clearDelayTimer();
                    this.clearOutsideHandler();
                    clearTimeout(this.mouseDownTimeout);
                    (0, $a1ced7b983ea61a4$export$2e2bcd8739ae039).cancel(this.attachId);
                }
            },
            {
                key: "getPopupDomNode",
                value: function getPopupDomNode() {
                    var _this$popupRef$curren2;
                    // for test
                    return ((_this$popupRef$curren2 = this.popupRef.current) === null || _this$popupRef$curren2 === void 0 ? void 0 : _this$popupRef$curren2.getElement()) || null;
                }
            },
            {
                key: "getPopupAlign",
                value: function getPopupAlign() {
                    var props = this.props;
                    var popupPlacement = props.popupPlacement, popupAlign = props.popupAlign, builtinPlacements = props.builtinPlacements;
                    if (popupPlacement && builtinPlacements) return (0, $72bedf1023859414$export$44605b74f7c5d944)(builtinPlacements, popupPlacement, popupAlign);
                    return popupAlign;
                }
            },
            {
                key: "setPopupVisible",
                value: /**
       * @param popupVisible    Show or not the popup element
       * @param event           SyntheticEvent, used for `pointAlign`
       */ function setPopupVisible(popupVisible, event) {
                    var alignPoint = this.props.alignPoint;
                    var prevPopupVisible = this.state.popupVisible;
                    this.clearDelayTimer();
                    if (prevPopupVisible !== popupVisible) {
                        if (!("popupVisible" in this.props)) this.setState({
                            popupVisible: popupVisible,
                            prevPopupVisible: prevPopupVisible
                        });
                        this.props.onPopupVisibleChange(popupVisible);
                    } // Always record the point position since mouseEnterDelay will delay the show
                    if (alignPoint && event && popupVisible) this.setPoint(event);
                }
            },
            {
                key: "delaySetPopupVisible",
                value: function delaySetPopupVisible(visible, delayS, event) {
                    var _this2 = this;
                    var delay = delayS * 1000;
                    this.clearDelayTimer();
                    if (delay) {
                        var point = event ? {
                            pageX: event.pageX,
                            pageY: event.pageY
                        } : null;
                        this.delayTimer = window.setTimeout(function() {
                            _this2.setPopupVisible(visible, point);
                            _this2.clearDelayTimer();
                        }, delay);
                    } else this.setPopupVisible(visible, event);
                }
            },
            {
                key: "clearDelayTimer",
                value: function clearDelayTimer() {
                    if (this.delayTimer) {
                        clearTimeout(this.delayTimer);
                        this.delayTimer = null;
                    }
                }
            },
            {
                key: "clearOutsideHandler",
                value: function clearOutsideHandler() {
                    if (this.clickOutsideHandler) {
                        this.clickOutsideHandler.remove();
                        this.clickOutsideHandler = null;
                    }
                    if (this.contextMenuOutsideHandler1) {
                        this.contextMenuOutsideHandler1.remove();
                        this.contextMenuOutsideHandler1 = null;
                    }
                    if (this.contextMenuOutsideHandler2) {
                        this.contextMenuOutsideHandler2.remove();
                        this.contextMenuOutsideHandler2 = null;
                    }
                    if (this.touchOutsideHandler) {
                        this.touchOutsideHandler.remove();
                        this.touchOutsideHandler = null;
                    }
                }
            },
            {
                key: "createTwoChains",
                value: function createTwoChains(event) {
                    var childPros = this.props.children.props;
                    var props = this.props;
                    if (childPros[event] && props[event]) return this["fire".concat(event)];
                    return childPros[event] || props[event];
                }
            },
            {
                key: "isClickToShow",
                value: function isClickToShow() {
                    var _this$props4 = this.props, action = _this$props4.action, showAction = _this$props4.showAction;
                    return action.indexOf("click") !== -1 || showAction.indexOf("click") !== -1;
                }
            },
            {
                key: "isContextMenuOnly",
                value: function isContextMenuOnly() {
                    var action = this.props.action;
                    return action === "contextMenu" || action.length === 1 && action[0] === "contextMenu";
                }
            },
            {
                key: "isContextMenuToShow",
                value: function isContextMenuToShow() {
                    var _this$props5 = this.props, action = _this$props5.action, showAction = _this$props5.showAction;
                    return action.indexOf("contextMenu") !== -1 || showAction.indexOf("contextMenu") !== -1;
                }
            },
            {
                key: "isClickToHide",
                value: function isClickToHide() {
                    var _this$props6 = this.props, action = _this$props6.action, hideAction = _this$props6.hideAction;
                    return action.indexOf("click") !== -1 || hideAction.indexOf("click") !== -1;
                }
            },
            {
                key: "isMouseEnterToShow",
                value: function isMouseEnterToShow() {
                    var _this$props7 = this.props, action = _this$props7.action, showAction = _this$props7.showAction;
                    return action.indexOf("hover") !== -1 || showAction.indexOf("mouseEnter") !== -1;
                }
            },
            {
                key: "isMouseLeaveToHide",
                value: function isMouseLeaveToHide() {
                    var _this$props8 = this.props, action = _this$props8.action, hideAction = _this$props8.hideAction;
                    return action.indexOf("hover") !== -1 || hideAction.indexOf("mouseLeave") !== -1;
                }
            },
            {
                key: "isFocusToShow",
                value: function isFocusToShow() {
                    var _this$props9 = this.props, action = _this$props9.action, showAction = _this$props9.showAction;
                    return action.indexOf("focus") !== -1 || showAction.indexOf("focus") !== -1;
                }
            },
            {
                key: "isBlurToHide",
                value: function isBlurToHide() {
                    var _this$props10 = this.props, action = _this$props10.action, hideAction = _this$props10.hideAction;
                    return action.indexOf("focus") !== -1 || hideAction.indexOf("blur") !== -1;
                }
            },
            {
                key: "forcePopupAlign",
                value: function forcePopupAlign() {
                    if (this.state.popupVisible) {
                        var _this$popupRef$curren3;
                        (_this$popupRef$curren3 = this.popupRef.current) === null || _this$popupRef$curren3 === void 0 || _this$popupRef$curren3.forceAlign();
                    }
                }
            },
            {
                key: "fireEvents",
                value: function fireEvents(type, e) {
                    var childCallback = this.props.children.props[type];
                    if (childCallback) childCallback(e);
                    var callback = this.props[type];
                    if (callback) callback(e);
                }
            },
            {
                key: "close",
                value: function close() {
                    this.setPopupVisible(false);
                }
            },
            {
                key: "render",
                value: function render() {
                    var popupVisible = this.state.popupVisible;
                    var _this$props11 = this.props, children = _this$props11.children, forceRender = _this$props11.forceRender, alignPoint = _this$props11.alignPoint, className = _this$props11.className, autoDestroy = _this$props11.autoDestroy;
                    var child = $acw62.Children.only(children);
                    var newChildProps = {
                        key: "trigger"
                    }; // ============================== Visible Handlers ==============================
                    // >>> ContextMenu
                    if (this.isContextMenuToShow()) newChildProps.onContextMenu = this.onContextMenu;
                    else newChildProps.onContextMenu = this.createTwoChains("onContextMenu");
                     // >>> Click
                    if (this.isClickToHide() || this.isClickToShow()) {
                        newChildProps.onClick = this.onClick;
                        newChildProps.onMouseDown = this.onMouseDown;
                        newChildProps.onTouchStart = this.onTouchStart;
                    } else {
                        newChildProps.onClick = this.createTwoChains("onClick");
                        newChildProps.onMouseDown = this.createTwoChains("onMouseDown");
                        newChildProps.onTouchStart = this.createTwoChains("onTouchStart");
                    } // >>> Hover(enter)
                    if (this.isMouseEnterToShow()) {
                        newChildProps.onMouseEnter = this.onMouseEnter; // Point align
                        if (alignPoint) newChildProps.onMouseMove = this.onMouseMove;
                    } else newChildProps.onMouseEnter = this.createTwoChains("onMouseEnter");
                     // >>> Hover(leave)
                    if (this.isMouseLeaveToHide()) newChildProps.onMouseLeave = this.onMouseLeave;
                    else newChildProps.onMouseLeave = this.createTwoChains("onMouseLeave");
                     // >>> Focus
                    if (this.isFocusToShow() || this.isBlurToHide()) {
                        newChildProps.onFocus = this.onFocus;
                        newChildProps.onBlur = this.onBlur;
                    } else {
                        newChildProps.onFocus = this.createTwoChains("onFocus");
                        newChildProps.onBlur = this.createTwoChains("onBlur");
                    } // =================================== Render ===================================
                    var childrenClassName = (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))(child && child.props && child.props.className, className);
                    if (childrenClassName) newChildProps.className = childrenClassName;
                    var cloneProps = (0, $983350b7b3960a26$export$2e2bcd8739ae039)({}, newChildProps);
                    if ((0, $5e297877593af644$export$c1cec34af06bcf7)(child)) cloneProps.ref = (0, $5e297877593af644$export$ab452c34e8e05029)(this.triggerRef, child.ref);
                    var trigger = /*#__PURE__*/ $acw62.cloneElement(child, cloneProps);
                    var portal; // prevent unmounting after it's rendered
                    if (popupVisible || this.popupRef.current || forceRender) portal = /*#__PURE__*/ $acw62.createElement(PortalComponent, {
                        key: "portal",
                        getContainer: this.getContainer,
                        didUpdate: this.handlePortalUpdate
                    }, this.getComponent());
                    if (!popupVisible && autoDestroy) portal = null;
                    return /*#__PURE__*/ $acw62.createElement((0, $34a0dc940d0dd00d$export$2e2bcd8739ae039).Provider, {
                        value: this.triggerContextValue
                    }, trigger, portal);
                }
            }
        ], [
            {
                key: "getDerivedStateFromProps",
                value: function getDerivedStateFromProps(_ref, prevState) {
                    var popupVisible = _ref.popupVisible;
                    var newState = {};
                    if (popupVisible !== undefined && prevState.popupVisible !== popupVisible) {
                        newState.popupVisible = popupVisible;
                        newState.prevPopupVisible = prevState.popupVisible;
                    }
                    return newState;
                }
            }
        ]);
        return Trigger;
    }($acw62.Component);
    (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)(Trigger, "contextType", (0, $34a0dc940d0dd00d$export$2e2bcd8739ae039));
    (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)(Trigger, "defaultProps", {
        prefixCls: "rc-trigger-popup",
        getPopupClassNameFromAlign: $bf97e04178e2dc31$var$returnEmptyString,
        getDocument: $bf97e04178e2dc31$var$returnDocument,
        onPopupVisibleChange: $bf97e04178e2dc31$var$noop,
        afterPopupVisibleChange: $bf97e04178e2dc31$var$noop,
        onPopupAlign: $bf97e04178e2dc31$var$noop,
        popupClassName: "",
        mouseEnterDelay: 0,
        mouseLeaveDelay: 0.1,
        focusDelay: 0,
        blurDelay: 0.15,
        popupStyle: {},
        destroyPopupOnHide: false,
        popupAlign: {},
        defaultPopupVisible: false,
        mask: false,
        maskClosable: true,
        action: [],
        showAction: [],
        hideAction: [],
        autoDestroy: false
    });
    return Trigger;
}
var $bf97e04178e2dc31$export$2e2bcd8739ae039 = $bf97e04178e2dc31$export$55e99723d7f71b47((0, $2ef2430b7d6ce3e1$export$2e2bcd8739ae039));


var $6c7c9d120875ff76$var$autoAdjustOverflow = {
    adjustX: 1,
    adjustY: 1
};
var $6c7c9d120875ff76$var$targetOffset = [
    0,
    0
];
var $6c7c9d120875ff76$export$803cd8101b6c182b = {
    left: {
        points: [
            "cr",
            "cl"
        ],
        overflow: $6c7c9d120875ff76$var$autoAdjustOverflow,
        offset: [
            -4,
            0
        ],
        targetOffset: $6c7c9d120875ff76$var$targetOffset
    },
    right: {
        points: [
            "cl",
            "cr"
        ],
        overflow: $6c7c9d120875ff76$var$autoAdjustOverflow,
        offset: [
            4,
            0
        ],
        targetOffset: $6c7c9d120875ff76$var$targetOffset
    },
    top: {
        points: [
            "bc",
            "tc"
        ],
        overflow: $6c7c9d120875ff76$var$autoAdjustOverflow,
        offset: [
            0,
            -4
        ],
        targetOffset: $6c7c9d120875ff76$var$targetOffset
    },
    bottom: {
        points: [
            "tc",
            "bc"
        ],
        overflow: $6c7c9d120875ff76$var$autoAdjustOverflow,
        offset: [
            0,
            4
        ],
        targetOffset: $6c7c9d120875ff76$var$targetOffset
    },
    topLeft: {
        points: [
            "bl",
            "tl"
        ],
        overflow: $6c7c9d120875ff76$var$autoAdjustOverflow,
        offset: [
            0,
            -4
        ],
        targetOffset: $6c7c9d120875ff76$var$targetOffset
    },
    leftTop: {
        points: [
            "tr",
            "tl"
        ],
        overflow: $6c7c9d120875ff76$var$autoAdjustOverflow,
        offset: [
            -4,
            0
        ],
        targetOffset: $6c7c9d120875ff76$var$targetOffset
    },
    topRight: {
        points: [
            "br",
            "tr"
        ],
        overflow: $6c7c9d120875ff76$var$autoAdjustOverflow,
        offset: [
            0,
            -4
        ],
        targetOffset: $6c7c9d120875ff76$var$targetOffset
    },
    rightTop: {
        points: [
            "tl",
            "tr"
        ],
        overflow: $6c7c9d120875ff76$var$autoAdjustOverflow,
        offset: [
            4,
            0
        ],
        targetOffset: $6c7c9d120875ff76$var$targetOffset
    },
    bottomRight: {
        points: [
            "tr",
            "br"
        ],
        overflow: $6c7c9d120875ff76$var$autoAdjustOverflow,
        offset: [
            0,
            4
        ],
        targetOffset: $6c7c9d120875ff76$var$targetOffset
    },
    rightBottom: {
        points: [
            "bl",
            "br"
        ],
        overflow: $6c7c9d120875ff76$var$autoAdjustOverflow,
        offset: [
            4,
            0
        ],
        targetOffset: $6c7c9d120875ff76$var$targetOffset
    },
    bottomLeft: {
        points: [
            "tl",
            "bl"
        ],
        overflow: $6c7c9d120875ff76$var$autoAdjustOverflow,
        offset: [
            0,
            4
        ],
        targetOffset: $6c7c9d120875ff76$var$targetOffset
    },
    leftBottom: {
        points: [
            "br",
            "bl"
        ],
        overflow: $6c7c9d120875ff76$var$autoAdjustOverflow,
        offset: [
            -4,
            0
        ],
        targetOffset: $6c7c9d120875ff76$var$targetOffset
    }
};
var $6c7c9d120875ff76$export$2e2bcd8739ae039 = $6c7c9d120875ff76$export$803cd8101b6c182b;



var $acw62 = parcelRequire("acw62");

function $576260377b469890$export$2e2bcd8739ae039(props) {
    var showArrow = props.showArrow, arrowContent = props.arrowContent, children = props.children, prefixCls = props.prefixCls, id = props.id, overlayInnerStyle = props.overlayInnerStyle, className = props.className, style = props.style;
    return /*#__PURE__*/ $acw62.createElement("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))("".concat(prefixCls, "-content"), className),
        style: style
    }, showArrow !== false && /*#__PURE__*/ $acw62.createElement("div", {
        className: "".concat(prefixCls, "-arrow"),
        key: "arrow"
    }, arrowContent), /*#__PURE__*/ $acw62.createElement("div", {
        className: "".concat(prefixCls, "-inner"),
        id: id,
        role: "tooltip",
        style: overlayInnerStyle
    }, typeof children === "function" ? children() : children));
}


var $870014fb7370caba$var$Tooltip = function Tooltip(props, ref) {
    var overlayClassName = props.overlayClassName, _props$trigger = props.trigger, trigger = _props$trigger === void 0 ? [
        "hover"
    ] : _props$trigger, _props$mouseEnterDela = props.mouseEnterDelay, mouseEnterDelay = _props$mouseEnterDela === void 0 ? 0 : _props$mouseEnterDela, _props$mouseLeaveDela = props.mouseLeaveDelay, mouseLeaveDelay = _props$mouseLeaveDela === void 0 ? 0.1 : _props$mouseLeaveDela, overlayStyle = props.overlayStyle, _props$prefixCls = props.prefixCls, prefixCls = _props$prefixCls === void 0 ? "rc-tooltip" : _props$prefixCls, children = props.children, onVisibleChange = props.onVisibleChange, afterVisibleChange = props.afterVisibleChange, transitionName = props.transitionName, animation = props.animation, motion = props.motion, _props$placement = props.placement, placement = _props$placement === void 0 ? "right" : _props$placement, _props$align = props.align, align = _props$align === void 0 ? {} : _props$align, _props$destroyTooltip = props.destroyTooltipOnHide, destroyTooltipOnHide = _props$destroyTooltip === void 0 ? false : _props$destroyTooltip, defaultVisible = props.defaultVisible, getTooltipContainer = props.getTooltipContainer, overlayInnerStyle = props.overlayInnerStyle, arrowContent = props.arrowContent, overlay = props.overlay, id = props.id, showArrow = props.showArrow, restProps = (0, $73ef9ce1c41fc0c0$export$2e2bcd8739ae039)(props, [
        "overlayClassName",
        "trigger",
        "mouseEnterDelay",
        "mouseLeaveDelay",
        "overlayStyle",
        "prefixCls",
        "children",
        "onVisibleChange",
        "afterVisibleChange",
        "transitionName",
        "animation",
        "motion",
        "placement",
        "align",
        "destroyTooltipOnHide",
        "defaultVisible",
        "getTooltipContainer",
        "overlayInnerStyle",
        "arrowContent",
        "overlay",
        "id",
        "showArrow"
    ]);
    var domRef = (0, $acw62.useRef)(null);
    (0, $acw62.useImperativeHandle)(ref, function() {
        return domRef.current;
    });
    var extraProps = (0, $983350b7b3960a26$export$2e2bcd8739ae039)({}, restProps);
    if ("visible" in props) extraProps.popupVisible = props.visible;
    var getPopupElement = function getPopupElement() {
        return /*#__PURE__*/ $acw62.createElement((0, $576260377b469890$export$2e2bcd8739ae039), {
            showArrow: showArrow,
            arrowContent: arrowContent,
            key: "content",
            prefixCls: prefixCls,
            id: id,
            overlayInnerStyle: overlayInnerStyle
        }, overlay);
    };
    var destroyTooltip = false;
    var autoDestroy = false;
    if (typeof destroyTooltipOnHide === "boolean") destroyTooltip = destroyTooltipOnHide;
    else if (destroyTooltipOnHide && (0, $b8f57191916382d3$export$2e2bcd8739ae039)(destroyTooltipOnHide) === "object") {
        var keepParent = destroyTooltipOnHide.keepParent;
        destroyTooltip = keepParent === true;
        autoDestroy = keepParent === false;
    }
    return /*#__PURE__*/ $acw62.createElement((0, $bf97e04178e2dc31$export$2e2bcd8739ae039), (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({
        popupClassName: overlayClassName,
        prefixCls: prefixCls,
        popup: getPopupElement,
        action: trigger,
        builtinPlacements: (0, $6c7c9d120875ff76$export$803cd8101b6c182b),
        popupPlacement: placement,
        ref: domRef,
        popupAlign: align,
        getPopupContainer: getTooltipContainer,
        onPopupVisibleChange: onVisibleChange,
        afterPopupVisibleChange: afterVisibleChange,
        popupTransitionName: transitionName,
        popupAnimation: animation,
        popupMotion: motion,
        defaultPopupVisible: defaultVisible,
        destroyPopupOnHide: destroyTooltip,
        autoDestroy: autoDestroy,
        mouseLeaveDelay: mouseLeaveDelay,
        popupStyle: overlayStyle,
        mouseEnterDelay: mouseEnterDelay
    }, extraProps), children);
};
var $870014fb7370caba$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $acw62.forwardRef)($870014fb7370caba$var$Tooltip);



var $d0136ab94ce7f56e$export$2e2bcd8739ae039 = (0, $870014fb7370caba$export$2e2bcd8739ae039);




var $acw62 = parcelRequire("acw62");

// https://stackoverflow.com/questions/46176165/ways-to-get-string-literal-type-of-array-values-without-enum-overhead
var $1ee8868d1993c67b$export$65e3907585753458 = function tuple() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
    return args;
};
var $1ee8868d1993c67b$export$1ada10640a0e4dad = function tupleNum() {
    for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
    return args;
};


var $1513ceb924eda9b6$export$bb684163c94c55ae = (0, $1ee8868d1993c67b$export$65e3907585753458)("success", "processing", "error", "default", "warning");
var $1513ceb924eda9b6$export$37ea70cc324d3d0e = (0, $1ee8868d1993c67b$export$65e3907585753458)("pink", "red", "yellow", "orange", "cyan", "green", "blue", "purple", "geekblue", "magenta", "volcano", "gold", "lime");



// ================== Collapse Motion ==================
var $2efb522a5615f01e$var$getCollapsedHeight = function getCollapsedHeight() {
    return {
        height: 0,
        opacity: 0
    };
};
var $2efb522a5615f01e$var$getRealHeight = function getRealHeight(node) {
    var scrollHeight = node.scrollHeight;
    return {
        height: scrollHeight,
        opacity: 1
    };
};
var $2efb522a5615f01e$var$getCurrentHeight = function getCurrentHeight(node) {
    return {
        height: node ? node.offsetHeight : 0
    };
};
var $2efb522a5615f01e$var$skipOpacityTransition = function skipOpacityTransition(_, event) {
    return (event === null || event === void 0 ? void 0 : event.deadline) === true || event.propertyName === "height";
};
var $2efb522a5615f01e$var$collapseMotion = {
    motionName: "ant-motion-collapse",
    onAppearStart: $2efb522a5615f01e$var$getCollapsedHeight,
    onEnterStart: $2efb522a5615f01e$var$getCollapsedHeight,
    onAppearActive: $2efb522a5615f01e$var$getRealHeight,
    onEnterActive: $2efb522a5615f01e$var$getRealHeight,
    onLeaveStart: $2efb522a5615f01e$var$getCurrentHeight,
    onLeaveActive: $2efb522a5615f01e$var$getCollapsedHeight,
    onAppearEnd: $2efb522a5615f01e$var$skipOpacityTransition,
    onEnterEnd: $2efb522a5615f01e$var$skipOpacityTransition,
    onLeaveEnd: $2efb522a5615f01e$var$skipOpacityTransition,
    motionDeadline: 500
};
var $2efb522a5615f01e$var$SelectPlacements = (0, $1ee8868d1993c67b$export$65e3907585753458)("bottomLeft", "bottomRight", "topLeft", "topRight");
var $2efb522a5615f01e$export$b2382d4a41c58fef = function getTransitionDirection(placement) {
    if (placement !== undefined && (placement === "topLeft" || placement === "topRight")) return "slide-down";
    return "slide-up";
};
var $2efb522a5615f01e$export$27c72201b1d09951 = function getTransitionName(rootPrefixCls, motion, transitionName) {
    if (transitionName !== undefined) return transitionName;
    return "".concat(rootPrefixCls, "-").concat(motion);
};
var $2efb522a5615f01e$export$2e2bcd8739ae039 = $2efb522a5615f01e$var$collapseMotion;




var $aa2151c32cec40fb$var$autoAdjustOverflowEnabled = {
    adjustX: 1,
    adjustY: 1
};
var $aa2151c32cec40fb$var$autoAdjustOverflowDisabled = {
    adjustX: 0,
    adjustY: 0
};
var $aa2151c32cec40fb$var$targetOffset = [
    0,
    0
];
function $aa2151c32cec40fb$export$fde75e5b410c093f(autoAdjustOverflow) {
    if (typeof autoAdjustOverflow === "boolean") return autoAdjustOverflow ? $aa2151c32cec40fb$var$autoAdjustOverflowEnabled : $aa2151c32cec40fb$var$autoAdjustOverflowDisabled;
    return (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)((0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, $aa2151c32cec40fb$var$autoAdjustOverflowDisabled), autoAdjustOverflow);
}
function $aa2151c32cec40fb$export$2e2bcd8739ae039(config) {
    var _config$arrowWidth = config.arrowWidth, arrowWidth = _config$arrowWidth === void 0 ? 4 : _config$arrowWidth, _config$horizontalArr = config.horizontalArrowShift, horizontalArrowShift = _config$horizontalArr === void 0 ? 16 : _config$horizontalArr, _config$verticalArrow = config.verticalArrowShift, verticalArrowShift = _config$verticalArrow === void 0 ? 8 : _config$verticalArrow, autoAdjustOverflow = config.autoAdjustOverflow, arrowPointAtCenter = config.arrowPointAtCenter;
    var placementMap = {
        left: {
            points: [
                "cr",
                "cl"
            ],
            offset: [
                -4,
                0
            ]
        },
        right: {
            points: [
                "cl",
                "cr"
            ],
            offset: [
                4,
                0
            ]
        },
        top: {
            points: [
                "bc",
                "tc"
            ],
            offset: [
                0,
                -4
            ]
        },
        bottom: {
            points: [
                "tc",
                "bc"
            ],
            offset: [
                0,
                4
            ]
        },
        topLeft: {
            points: [
                "bl",
                "tc"
            ],
            offset: [
                -(horizontalArrowShift + arrowWidth),
                -4
            ]
        },
        leftTop: {
            points: [
                "tr",
                "cl"
            ],
            offset: [
                -4,
                -(verticalArrowShift + arrowWidth)
            ]
        },
        topRight: {
            points: [
                "br",
                "tc"
            ],
            offset: [
                horizontalArrowShift + arrowWidth,
                -4
            ]
        },
        rightTop: {
            points: [
                "tl",
                "cr"
            ],
            offset: [
                4,
                -(verticalArrowShift + arrowWidth)
            ]
        },
        bottomRight: {
            points: [
                "tr",
                "bc"
            ],
            offset: [
                horizontalArrowShift + arrowWidth,
                4
            ]
        },
        rightBottom: {
            points: [
                "bl",
                "cr"
            ],
            offset: [
                4,
                verticalArrowShift + arrowWidth
            ]
        },
        bottomLeft: {
            points: [
                "tl",
                "bc"
            ],
            offset: [
                -(horizontalArrowShift + arrowWidth),
                4
            ]
        },
        leftBottom: {
            points: [
                "br",
                "cl"
            ],
            offset: [
                -4,
                verticalArrowShift + arrowWidth
            ]
        }
    };
    Object.keys(placementMap).forEach(function(key) {
        placementMap[key] = arrowPointAtCenter ? (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)((0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, placementMap[key]), {
            overflow: $aa2151c32cec40fb$export$fde75e5b410c093f(autoAdjustOverflow),
            targetOffset: $aa2151c32cec40fb$var$targetOffset
        }) : (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)((0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, (0, $6c7c9d120875ff76$export$803cd8101b6c182b)[key]), {
            overflow: $aa2151c32cec40fb$export$fde75e5b410c093f(autoAdjustOverflow)
        });
        placementMap[key].ignoreShake = true;
    });
    return placementMap;
}



var $acw62 = parcelRequire("acw62");
var $30796c32f374b477$export$a8257692ac88316c = $acw62.isValidElement;
function $30796c32f374b477$export$9522e17588c12572(child) {
    return child && $30796c32f374b477$export$a8257692ac88316c(child) && child.type === $acw62.Fragment;
}
function $30796c32f374b477$export$2dfe578f95754f6a(element, replacement, props) {
    if (!$30796c32f374b477$export$a8257692ac88316c(element)) return replacement;
    return /*#__PURE__*/ $acw62.cloneElement(element, typeof props === "function" ? props(element.props || {}) : props);
}
function $30796c32f374b477$export$e530037191fcd5d7(element, props) {
    return $30796c32f374b477$export$2dfe578f95754f6a(element, element, props);
}



var $0ac88bf86814a6e5$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $0ac88bf86814a6e5$var$splitObject = function splitObject(obj, keys) {
    var picked = {};
    var omitted = (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, obj);
    keys.forEach(function(key) {
        if (obj && key in obj) {
            picked[key] = obj[key];
            delete omitted[key];
        }
    });
    return {
        picked: picked,
        omitted: omitted
    };
};
var $0ac88bf86814a6e5$var$PresetColorRegex = new RegExp("^(".concat((0, $1513ceb924eda9b6$export$37ea70cc324d3d0e).join("|"), ")(-inverse)?$"));
// Fix Tooltip won't hide at disabled button
// mouse events don't trigger at disabled button in Chrome
// https://github.com/react-component/tooltip/issues/18
function $0ac88bf86814a6e5$var$getDisabledCompatibleChildren(element, prefixCls) {
    var elementType = element.type;
    if ((elementType.__ANT_BUTTON === true || element.type === "button") && element.props.disabled || elementType.__ANT_SWITCH === true && (element.props.disabled || element.props.loading) || elementType.__ANT_RADIO === true && element.props.disabled) {
        // Pick some layout related style properties up to span
        // Prevent layout bugs like https://github.com/ant-design/ant-design/issues/5254
        var _splitObject = $0ac88bf86814a6e5$var$splitObject(element.props.style, [
            "position",
            "left",
            "right",
            "top",
            "bottom",
            "float",
            "display",
            "zIndex"
        ]), picked = _splitObject.picked, omitted = _splitObject.omitted;
        var spanStyle = (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)((0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({
            display: "inline-block"
        }, picked), {
            cursor: "not-allowed",
            width: element.props.block ? "100%" : undefined
        });
        var buttonStyle = (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)((0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, omitted), {
            pointerEvents: "none"
        });
        var child = (0, $30796c32f374b477$export$e530037191fcd5d7)(element, {
            style: buttonStyle,
            className: null
        });
        return /*#__PURE__*/ $acw62.createElement("span", {
            style: spanStyle,
            className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))(element.props.className, "".concat(prefixCls, "-disabled-compatible-wrapper"))
        }, child);
    }
    return element;
}
var $0ac88bf86814a6e5$var$Tooltip = /*#__PURE__*/ $acw62.forwardRef(function(props, ref) {
    var _React$useContext = $acw62.useContext((0, $a18b2f6f56546238$export$a92f85ab3e9ad68b)), getContextPopupContainer = _React$useContext.getPopupContainer, getPrefixCls = _React$useContext.getPrefixCls, direction = _React$useContext.direction;
    [
        [
            "visible",
            "open"
        ],
        [
            "defaultVisible",
            "defaultOpen"
        ],
        [
            "onVisibleChange",
            "onOpenChange"
        ],
        [
            "afterVisibleChange",
            "afterOpenChange"
        ]
    ].forEach(function(_ref) {
        var _ref2 = (0, $adaabbc18727b3e6$export$2e2bcd8739ae039)(_ref, 2), deprecatedName = _ref2[0], newName = _ref2[1];
        (0, $5bd796dbed593bbb$export$2e2bcd8739ae039)(!(deprecatedName in props), "Tooltip", "`".concat(deprecatedName, "` is deprecated which will be removed in next major version, please use `").concat(newName, "` instead."));
    });
    var _useMergedState = (0, $dbf5d1f4f4ecbb6a$export$2e2bcd8739ae039)(false, {
        value: props.open !== undefined ? props.open : props.visible,
        defaultValue: props.defaultOpen !== undefined ? props.defaultOpen : props.defaultVisible
    }), _useMergedState2 = (0, $adaabbc18727b3e6$export$2e2bcd8739ae039)(_useMergedState, 2), open = _useMergedState2[0], setOpen = _useMergedState2[1];
    var isNoTitle = function isNoTitle() {
        var title = props.title, overlay = props.overlay;
        return !title && !overlay && title !== 0; // overlay for old version compatibility
    };
    var onOpenChange = function onOpenChange(vis) {
        var _a, _b;
        setOpen(isNoTitle() ? false : vis);
        if (!isNoTitle()) {
            (_a = props.onOpenChange) === null || _a === void 0 || _a.call(props, vis);
            (_b = props.onVisibleChange) === null || _b === void 0 || _b.call(props, vis);
        }
    };
    var getTooltipPlacements = function getTooltipPlacements() {
        var builtinPlacements = props.builtinPlacements, _props$arrowPointAtCe = props.arrowPointAtCenter, arrowPointAtCenter = _props$arrowPointAtCe === void 0 ? false : _props$arrowPointAtCe, _props$autoAdjustOver = props.autoAdjustOverflow, autoAdjustOverflow = _props$autoAdjustOver === void 0 ? true : _props$autoAdjustOver;
        return builtinPlacements || (0, $aa2151c32cec40fb$export$2e2bcd8739ae039)({
            arrowPointAtCenter: arrowPointAtCenter,
            autoAdjustOverflow: autoAdjustOverflow
        });
    };
    // 动态设置动画点
    var onPopupAlign = function onPopupAlign(domNode, align) {
        var placements = getTooltipPlacements();
        // 当前返回的位置
        var placement = Object.keys(placements).find(function(key) {
            var _a, _b;
            return placements[key].points[0] === ((_a = align.points) === null || _a === void 0 ? void 0 : _a[0]) && placements[key].points[1] === ((_b = align.points) === null || _b === void 0 ? void 0 : _b[1]);
        });
        if (!placement) return;
        // 根据当前坐标设置动画点
        var rect = domNode.getBoundingClientRect();
        var transformOrigin = {
            top: "50%",
            left: "50%"
        };
        if (/top|Bottom/.test(placement)) transformOrigin.top = "".concat(rect.height - align.offset[1], "px");
        else if (/Top|bottom/.test(placement)) transformOrigin.top = "".concat(-align.offset[1], "px");
        if (/left|Right/.test(placement)) transformOrigin.left = "".concat(rect.width - align.offset[0], "px");
        else if (/right|Left/.test(placement)) transformOrigin.left = "".concat(-align.offset[0], "px");
        domNode.style.transformOrigin = "".concat(transformOrigin.left, " ").concat(transformOrigin.top);
    };
    var getOverlay = function getOverlay() {
        var title = props.title, overlay = props.overlay;
        if (title === 0) return title;
        return overlay || title || "";
    };
    var getPopupContainer = props.getPopupContainer, _props$placement = props.placement, placement = _props$placement === void 0 ? "top" : _props$placement, _props$mouseEnterDela = props.mouseEnterDelay, mouseEnterDelay = _props$mouseEnterDela === void 0 ? 0.1 : _props$mouseEnterDela, _props$mouseLeaveDela = props.mouseLeaveDelay, mouseLeaveDelay = _props$mouseLeaveDela === void 0 ? 0.1 : _props$mouseLeaveDela, otherProps = $0ac88bf86814a6e5$var$__rest(props, [
        "getPopupContainer",
        "placement",
        "mouseEnterDelay",
        "mouseLeaveDelay"
    ]);
    var customizePrefixCls = props.prefixCls, openClassName = props.openClassName, getTooltipContainer = props.getTooltipContainer, overlayClassName = props.overlayClassName, color = props.color, overlayInnerStyle = props.overlayInnerStyle, children = props.children;
    var prefixCls = getPrefixCls("tooltip", customizePrefixCls);
    var rootPrefixCls = getPrefixCls();
    var tempOpen = open;
    // Hide tooltip when there is no title
    if (!("open" in props) && !("visible" in props) && isNoTitle()) tempOpen = false;
    var child = $0ac88bf86814a6e5$var$getDisabledCompatibleChildren((0, $30796c32f374b477$export$a8257692ac88316c)(children) && !(0, $30796c32f374b477$export$9522e17588c12572)(children) ? children : /*#__PURE__*/ $acw62.createElement("span", null, children), prefixCls);
    var childProps = child.props;
    var childCls = !childProps.className || typeof childProps.className === "string" ? (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))(childProps.className, (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)({}, openClassName || "".concat(prefixCls, "-open"), true)) : childProps.className;
    var customOverlayClassName = (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))(overlayClassName, (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)((0, $f329557dcab6d0bb$export$2e2bcd8739ae039)({}, "".concat(prefixCls, "-rtl"), direction === "rtl"), "".concat(prefixCls, "-").concat(color), color && $0ac88bf86814a6e5$var$PresetColorRegex.test(color)));
    var formattedOverlayInnerStyle = overlayInnerStyle;
    var arrowContentStyle = {};
    if (color && !$0ac88bf86814a6e5$var$PresetColorRegex.test(color)) {
        formattedOverlayInnerStyle = (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)((0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, overlayInnerStyle), {
            background: color
        });
        // @ts-ignore
        arrowContentStyle = {
            "--antd-arrow-background-color": color
        };
    }
    return /*#__PURE__*/ $acw62.createElement((0, $d0136ab94ce7f56e$export$2e2bcd8739ae039), (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, otherProps, {
        placement: placement,
        mouseEnterDelay: mouseEnterDelay,
        mouseLeaveDelay: mouseLeaveDelay,
        prefixCls: prefixCls,
        overlayClassName: customOverlayClassName,
        getTooltipContainer: getPopupContainer || getTooltipContainer || getContextPopupContainer,
        ref: ref,
        builtinPlacements: getTooltipPlacements(),
        overlay: getOverlay(),
        visible: tempOpen,
        onVisibleChange: onOpenChange,
        onPopupAlign: onPopupAlign,
        overlayInnerStyle: formattedOverlayInnerStyle,
        arrowContent: /*#__PURE__*/ $acw62.createElement("span", {
            className: "".concat(prefixCls, "-arrow-content"),
            style: arrowContentStyle
        }),
        motion: {
            motionName: (0, $2efb522a5615f01e$export$27c72201b1d09951)(rootPrefixCls, "zoom-big-fast", props.transitionName),
            motionDeadline: 1000
        }
    }), tempOpen ? (0, $30796c32f374b477$export$e530037191fcd5d7)(child, {
        className: childCls
    }) : child);
});
$0ac88bf86814a6e5$var$Tooltip.displayName = "Tooltip";
var $0ac88bf86814a6e5$export$2e2bcd8739ae039 = $0ac88bf86814a6e5$var$Tooltip;


var $df2ee388cfcac8e5$var$SliderTooltip = /*#__PURE__*/ $acw62.forwardRef(function(props, ref) {
    var open = props.open;
    var innerRef = (0, $acw62.useRef)(null);
    var rafRef = (0, $acw62.useRef)(null);
    function cancelKeepAlign() {
        (0, $a1ced7b983ea61a4$export$2e2bcd8739ae039).cancel(rafRef.current);
        rafRef.current = null;
    }
    function keepAlign() {
        rafRef.current = (0, $a1ced7b983ea61a4$export$2e2bcd8739ae039)(function() {
            var _a;
            (_a = innerRef.current) === null || _a === void 0 || _a.forcePopupAlign();
            rafRef.current = null;
        });
    }
    $acw62.useEffect(function() {
        if (open) keepAlign();
        else cancelKeepAlign();
        return cancelKeepAlign;
    }, [
        open,
        props.title
    ]);
    return /*#__PURE__*/ $acw62.createElement((0, $0ac88bf86814a6e5$export$2e2bcd8739ae039), (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({
        ref: (0, $5e297877593af644$export$ab452c34e8e05029)(innerRef, ref)
    }, props));
});
var $df2ee388cfcac8e5$export$2e2bcd8739ae039 = $df2ee388cfcac8e5$var$SliderTooltip;


var $3e379b7d04954998$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $3e379b7d04954998$var$Slider = /*#__PURE__*/ $acw62.forwardRef(function(props, ref) {
    var _React$useContext = $acw62.useContext((0, $a18b2f6f56546238$export$a92f85ab3e9ad68b)), getPrefixCls = _React$useContext.getPrefixCls, direction = _React$useContext.direction, getPopupContainer = _React$useContext.getPopupContainer;
    var _React$useState = $acw62.useState({}), _React$useState2 = (0, $adaabbc18727b3e6$export$2e2bcd8739ae039)(_React$useState, 2), opens = _React$useState2[0], setOpens = _React$useState2[1];
    var toggleTooltipOpen = function toggleTooltipOpen(index, open) {
        setOpens(function(prev) {
            return (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)((0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, prev), (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)({}, index, open));
        });
    };
    var getTooltipPlacement = function getTooltipPlacement(tooltipPlacement, vertical) {
        if (tooltipPlacement) return tooltipPlacement;
        if (!vertical) return "top";
        return direction === "rtl" ? "left" : "right";
    };
    var customizePrefixCls = props.prefixCls, range = props.range, className = props.className, restProps = $3e379b7d04954998$var$__rest(props, [
        "prefixCls",
        "range",
        "className"
    ]);
    var prefixCls = getPrefixCls("slider", customizePrefixCls);
    var cls = (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))(className, (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)({}, "".concat(prefixCls, "-rtl"), direction === "rtl"));
    // make reverse default on rtl direction
    if (direction === "rtl" && !restProps.vertical) restProps.reverse = !restProps.reverse;
    // Range config
    var _React$useMemo = $acw62.useMemo(function() {
        if (!range) return [
            false
        ];
        return (0, $b8f57191916382d3$export$2e2bcd8739ae039)(range) === "object" ? [
            true,
            range.draggableTrack
        ] : [
            true,
            false
        ];
    }, [
        range
    ]), _React$useMemo2 = (0, $adaabbc18727b3e6$export$2e2bcd8739ae039)(_React$useMemo, 2), mergedRange = _React$useMemo2[0], draggableTrack = _React$useMemo2[1];
    [
        [
            "tooltipPrefixCls",
            "prefixCls"
        ],
        [
            "getTooltipPopupContainer",
            "getPopupContainer"
        ],
        [
            "tipFormatter",
            "formatter"
        ],
        [
            "tooltipPlacement",
            "placement"
        ],
        [
            "tooltipVisible",
            "open"
        ]
    ].forEach(function(_ref) {
        var _ref2 = (0, $adaabbc18727b3e6$export$2e2bcd8739ae039)(_ref, 2), deprecatedName = _ref2[0], newName = _ref2[1];
        (0, $5bd796dbed593bbb$export$2e2bcd8739ae039)(!(deprecatedName in props), "Slider", "`".concat(deprecatedName, "` is deprecated which will be removed in next major version, please use `tooltip.").concat(newName, "` instead."));
    });
    var handleRender = function handleRender(node, info) {
        var _a;
        var index = info.index, dragging = info.dragging;
        var rootPrefixCls = getPrefixCls();
        var _props$tooltip = props.tooltip, tooltip = _props$tooltip === void 0 ? {} : _props$tooltip, vertical = props.vertical;
        var tooltipProps = (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({
            formatter: (_a = props.tipFormatter) !== null && _a !== void 0 ? _a : // eslint-disable-next-line func-names
            function(value) {
                return typeof value === "number" ? value.toString() : "";
            },
            open: props.tooltipVisible,
            placement: props.tooltipPlacement,
            getPopupContainer: props.getTooltipPopupContainer
        }, tooltip);
        var tooltipOpen = tooltipProps.open, tooltipPlacement = tooltipProps.placement, getTooltipPopupContainer = tooltipProps.getPopupContainer, customizeTooltipPrefixCls = tooltipProps.prefixCls, tipFormatter = tooltipProps.formatter;
        var isTipFormatter = tipFormatter ? opens[index] || dragging : false;
        var open = tooltipOpen || tooltipOpen === undefined && isTipFormatter;
        var passedProps = (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)((0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, node.props), {
            onMouseEnter: function onMouseEnter() {
                return toggleTooltipOpen(index, true);
            },
            onMouseLeave: function onMouseLeave() {
                return toggleTooltipOpen(index, false);
            }
        });
        var tooltipPrefixCls = getPrefixCls("tooltip", customizeTooltipPrefixCls);
        return /*#__PURE__*/ $acw62.createElement((0, $df2ee388cfcac8e5$export$2e2bcd8739ae039), {
            prefixCls: tooltipPrefixCls,
            title: tipFormatter ? tipFormatter(info.value) : "",
            open: open,
            placement: getTooltipPlacement(tooltipPlacement, vertical),
            transitionName: "".concat(rootPrefixCls, "-zoom-down"),
            key: index,
            overlayClassName: "".concat(prefixCls, "-tooltip"),
            getPopupContainer: getTooltipPopupContainer || getPopupContainer
        }, /*#__PURE__*/ $acw62.cloneElement(node, passedProps));
    };
    return /*#__PURE__*/ $acw62.createElement((0, $8913456de870b864$export$2e2bcd8739ae039), (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, restProps, {
        step: restProps.step,
        range: mergedRange,
        draggableTrack: draggableTrack,
        className: cls,
        ref: ref,
        prefixCls: prefixCls,
        handleRender: handleRender
    }));
});
$3e379b7d04954998$var$Slider.displayName = "Slider";
var $3e379b7d04954998$export$2e2bcd8739ae039 = $3e379b7d04954998$var$Slider;





var $acw62 = parcelRequire("acw62");







var $1208166956fe3e01$exports = {};
$1208166956fe3e01$exports = new URL("info-icon.d5809664.svg", import.meta.url).toString();






const $145522abc7e48114$export$e1bacf37acf6a5d9 = (0, $aca50e9407ba89c9$export$b6ae1bc530f4c149)(({ draftJobId: draftJobId, orderId: orderId })=>{
    const [currentValue, setCurrentValue] = (0, $acw62.useState)(0);
    const [recommendedRate, setRecommendedRate] = (0, $acw62.useState)(0);
    const [minRecommendedRate, setMinRecommendedRate] = (0, $acw62.useState)(0);
    const [maxRecommendedRate, setMaxRecommendedRate] = (0, $acw62.useState)(0);
    const [bottomRate, setBottomRate] = (0, $acw62.useState)(0);
    const [topRate, setTopRate] = (0, $acw62.useState)(0);
    const [totalHours, setTotalHours] = (0, $acw62.useState)(0);
    const [tax, setTax] = (0, $acw62.useState)(0);
    const redirect = (0, $7df35e9df335b1c8$export$602eaf6d5314ce55)();
    const { t: t } = (0, $3765cebd031b52c0$export$9fc83ad70ead8663)();
    const { setRates: setRates, getRates: getRates } = (0, $4671947198ddd366$export$6ccbb43953eebf8)().data;
    const [, setRatesRequest] = (0, $4671947198ddd366$export$609860bf8b0084c)(({ job_id: job_id, client_rate: client_rate })=>setRates({
            job_id: job_id,
            client_rate: client_rate
        }), {
        onSuccess: (result)=>{
            return redirect((0, $0534349ae8731d0b$export$66b32f6f30eb4b4).orderDraft, {
                orderId: String(orderId)
            });
        }
    });
    const [, getRatesRequest] = (0, $4671947198ddd366$export$609860bf8b0084c)(({ job_id: job_id })=>getRates({
            job_id: job_id
        }), {
        onSuccess: (result)=>{
            setCurrentValue(result.current_client_rate ?? result.recommended_client_rate);
            setRecommendedRate(result.recommended_client_rate);
            setMinRecommendedRate(result.min_recommended_client_rate);
            setMaxRecommendedRate(result.max_recommended_client_rate);
            setBottomRate(result.bottom_client_rate);
            setTopRate(result.top_client_rate);
            setTotalHours(result.total_hours);
            setTax(Number(result.tax));
        }
    });
    (0, $acw62.useEffect)(()=>{
        getRatesRequest({
            job_id: Number(draftJobId)
        });
    }, [
        draftJobId
    ]);
    const rateConfig = (0, $acw62.useMemo)(()=>{
        return {
            zones: [
                {
                    color: "#ff0000",
                    min: bottomRate,
                    max: minRecommendedRate,
                    ogText: t("job_draft_price.low_rate_og_message"),
                    fillRateText: t("job_draft_price.low_rate_fill_message"),
                    allowed: true
                },
                {
                    color: "#FCB35C",
                    min: minRecommendedRate,
                    max: recommendedRate,
                    ogText: t("job_draft_price.middle_rate_og_message"),
                    fillRateText: t("job_draft_price.middle_rate_fill_message"),
                    allowed: true
                },
                {
                    color: "#8ECD9C",
                    min: recommendedRate,
                    max: maxRecommendedRate,
                    ogText: t("job_draft_price.good_rate_og_message"),
                    fillRateText: t("job_draft_price.good_rate_fill_message"),
                    allowed: true
                },
                {
                    color: "#5EAA6F",
                    min: maxRecommendedRate,
                    max: topRate,
                    ogText: t("job_draft_price.good_rate_og_message"),
                    fillRateText: t("job_draft_price.good_rate_fill_message"),
                    allowed: true
                }
            ],
            marks: {
                [minRecommendedRate]: {
                    label: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "custom-mark-start",
                        children: t("job_draft_price.money_amount", {
                            currency: (0, $73ccb33f5de6f5aa$export$8707029d024490c9)().currency,
                            amount: minRecommendedRate
                        })
                    })
                },
                [recommendedRate]: {
                    label: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "custom-mark-end",
                        children: t("job_draft_price.money_amount", {
                            currency: (0, $73ccb33f5de6f5aa$export$8707029d024490c9)().currency,
                            amount: recommendedRate
                        })
                    })
                }
            },
            recommendedRate: recommendedRate,
            minRecommendedRate: minRecommendedRate,
            maxRecommendedRate: maxRecommendedRate,
            bottomRate: bottomRate,
            topRate: topRate
        };
    }, [
        recommendedRate,
        minRecommendedRate,
        maxRecommendedRate,
        bottomRate,
        topRate
    ]);
    const gradientParts = rateConfig.zones.map((zone)=>{
        return [
            `${zone.color} ${(zone.min - rateConfig.bottomRate) / (rateConfig.topRate - rateConfig.bottomRate) * 100}%`,
            `${zone.color} ${(zone.max - rateConfig.bottomRate) / (rateConfig.topRate - rateConfig.bottomRate) * 100}%`
        ];
    }).flat().join(", ");
    const gradientBackground = `linear-gradient(to right, ${gradientParts})`;
    const currentZone = rateConfig.zones.find((zone)=>zone.min <= currentValue && zone.max > currentValue) ?? {
        color: currentValue < rateConfig.bottomRate ? "#ff0000" : "#5EAA6F",
        ogText: currentValue < rateConfig.bottomRate ? t("job_draft_price.rate_is_less_than_min", {
            min: rateConfig.bottomRate
        }) : t("job_draft_price.good_rate_og_message"),
        fillRateText: currentValue < rateConfig.bottomRate ? t("job_draft_price.rate_is_less_than_min", {
            min: rateConfig.bottomRate
        }) : t("job_draft_price.good_rate_fill_message")
    };
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "JobDraftLocation__page",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7ae42b63183f30b4$export$8b251419efc915eb), {
                title: "Price",
                showBack: true
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "JobDraftLocation",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $660b2ca422e0e2ae$export$1ff3c3f08ae963c0).Vertical, {
                        height: 35
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $38509c18096ca465$export$a765b9dee96eca0e), {
                        stepsCount: 5,
                        currentStepNumber: 4
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                        className: "JobDraftCategory__title",
                        children: t("job_draft_price.title")
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                        className: "JobDraftCategory__subtitle",
                        children: t("job_draft_price.subtitle")
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $660b2ca422e0e2ae$export$1ff3c3f08ae963c0).Vertical, {
                        height: 24
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "JobDraftCategory__controls JobDraftCategory__slider",
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                            className: "JobDraftPrice__rateInput",
                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "JobDraftPrice__rateInput__wrapper",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        className: "JobDraftPrice__rateInput__row",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $660b2ca422e0e2ae$export$1ff3c3f08ae963c0).Spacer, {}),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                onClick: ()=>{
                                                    setCurrentValue((value)=>{
                                                        const newValue = Number((value - 0.5).toFixed(2));
                                                        if (newValue < rateConfig.bottomRate) return rateConfig.bottomRate;
                                                        return newValue;
                                                    });
                                                },
                                                title: t("job_draft_price.decrease_rate"),
                                                className: `JobDraftPrice__rateInput__row__button`,
                                                style: {
                                                    backgroundImage: `url(${(0, (/*@__PURE__*/$parcel$interopDefault($de97bd15744206aa$exports)))})`
                                                }
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $660b2ca422e0e2ae$export$1ff3c3f08ae963c0).Horizontal, {
                                                width: 18
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4e342c5928158118$export$f5b8910cec6cf069), {
                                                label: t("job_draft_price.input_label", {
                                                    currency: (0, $73ccb33f5de6f5aa$export$8707029d024490c9)().currency
                                                }),
                                                value: String(currentValue),
                                                type: "number",
                                                handleChange: (value)=>setCurrentValue(Number(value)),
                                                className: `JobDraftPrice__rateInput__row__input`
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $660b2ca422e0e2ae$export$1ff3c3f08ae963c0).Horizontal, {
                                                width: 18
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                onClick: ()=>{
                                                    setCurrentValue((value)=>{
                                                        return Number((value + 0.5).toFixed(2));
                                                    });
                                                },
                                                className: `JobDraftPrice__rateInput__row__button`,
                                                title: t("job_draft_price.increase_rate"),
                                                style: {
                                                    backgroundImage: `url(${(0, (/*@__PURE__*/$parcel$interopDefault($4f273a67caecd550$exports)))})`
                                                }
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $660b2ca422e0e2ae$export$1ff3c3f08ae963c0).Spacer, {})
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $3e379b7d04954998$export$2e2bcd8739ae039), {
                                        defaultValue: minRecommendedRate,
                                        min: rateConfig.bottomRate,
                                        max: rateConfig.topRate,
                                        step: 0.5,
                                        tooltip: {
                                            formatter: (value)=>t("job_draft_price.money_amount", {
                                                    currency: (0, $73ccb33f5de6f5aa$export$8707029d024490c9)().currency,
                                                    amount: value
                                                })
                                        },
                                        trackStyle: {
                                            backgroundColor: "transparent"
                                        },
                                        railStyle: {
                                            background: gradientBackground
                                        },
                                        value: currentValue,
                                        onChange: setCurrentValue,
                                        marks: rateConfig.marks
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        className: "JobDraftPrice__rateInput__labels",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                className: "JobDraftPrice__rateInput__label",
                                                style: {
                                                    color: currentZone.color
                                                },
                                                children: currentZone.ogText
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                className: "JobDraftPrice__rateInput__label",
                                                style: {
                                                    color: currentZone.color
                                                },
                                                children: currentZone.fillRateText
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        className: "JobDraftPrice__totalContainer",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                className: "JobDraftPrice__total__title",
                                                children: t("job_draft_price.estimated_total")
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                className: "JobDraftPrice__total__value",
                                                children: t("job_draft_price.money_amount", {
                                                    currency: (0, $73ccb33f5de6f5aa$export$8707029d024490c9)().currency,
                                                    amount: (totalHours * currentValue + totalHours * currentValue * tax).toFixed(2)
                                                })
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                        className: "JobDraftPrice__total__note",
                                        children: t("job_draft_price.includes_vat", {
                                            vat: tax * 100
                                        })
                                    })
                                ]
                            })
                        })
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "JobDraftPrice__alert",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                                src: (0, (/*@__PURE__*/$parcel$interopDefault($1208166956fe3e01$exports)))
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                className: "JobDraftPrice__alert__text",
                                children: t("job_draft_price.short_explanation")
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $660b2ca422e0e2ae$export$1ff3c3f08ae963c0).Vertical, {
                        height: 50
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $2c46e9e1f89bee75$export$2b47962e4e24eb4d), {
                        text: t("job_draft_details.save"),
                        action: ()=>{
                            setRatesRequest({
                                job_id: Number(draftJobId),
                                client_rate: currentValue
                            });
                        },
                        disabled: currentValue < rateConfig.bottomRate
                    })
                ]
            })
        ]
    });
});


const $c267d5bb6d73c4f3$export$31d56f5faa2670c6 = {
    OrderSummaryPage: $99c94337d4742182$export$2e2bcd8739ae039,
    OrdersListPage: $a7af6a8b471cb395$export$930ab85cf7ad0060,
    JobDraftCategoryPage: (0, $22bb2188f5a9f92c$export$1737dc01b3801c1c),
    JobDraftLocationPage: (0, $1258019dec27db3d$export$ea4551635e903bcb),
    JobDraftPricePage: (0, $145522abc7e48114$export$e1bacf37acf6a5d9),
    JobDraftDetailPage: $5a954f40174a984b$export$b20ecfb08c3bb285,
    OrderDraftPage: $8e08f9d49ea5841c$export$c13a4208c8d4a907,
    OrderConfirmedPage: $323a86ff22145402$export$b2775b67f0963f7e,
    OrderDraftSummaryPage: $527d0d15a7b06b10$export$1bd72ef9703c72b5,
    OrderRequestedPage: $1a1da323b56f584f$export$81f766471b94fc81,
    OrderDuplicatePage: $3e21ec7453e6a2fe$export$597647c8a80ff697,
    OrderDuplicateChooseJobsPage: $df6108c3edfff4d4$export$225e10d6453da328
};




var $acw62 = parcelRequire("acw62");






var $acw62 = parcelRequire("acw62");



const $d43267d0ed87d655$export$5176e9d4c30fcf2b = /*#__PURE__*/ (0, $acw62.createContext)({
    data: {},
    error: {},
    isLoading: false,
    setData: ()=>{}
});
function $d43267d0ed87d655$export$a7fed597f4b8afd8(props) {
    const { Provider: Provider } = $d43267d0ed87d655$export$5176e9d4c30fcf2b;
    const form = {
        data: (0, $dacbeb7af41d49ec$export$f2db7d5238e1d23f)(props.data),
        error: props.error,
        isLoading: props.isLoading,
        setData: (key, value)=>{
            props.setData?.({
                ...props.data,
                [key]: value
            });
        }
    };
    const handleSubmit = (e)=>{
        e.preventDefault();
        props.onSubmit(props.data);
    };
    const fields = (0, $0f5438aadff0af94$export$58aefef1ff9edd34)(props.data, (key, value)=>({
            name: String(key),
            value: value,
            errors: props.error?.errors?.[key] ?? [],
            setData: (newVal)=>{
                props.setData?.({
                    ...props.data,
                    [key]: newVal
                });
            }
        }));
    const commonError = props.error?.code !== "data_invalid" ? props.error?.message : undefined;
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)(Provider, {
        value: form,
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("form", {
            onSubmit: handleSubmit,
            children: [
                commonError && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                    className: "Form__errors",
                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "Form__error",
                        children: commonError
                    })
                }),
                props.children((0, $dacbeb7af41d49ec$export$f2db7d5238e1d23f)(fields))
            ]
        })
    });
}





var $acw62 = parcelRequire("acw62");


function $9ca5fd069b795964$export$2c4cf1f7b42ef78c(props) {
    const form = (0, $acw62.useContext)((0, $d43267d0ed87d655$export$5176e9d4c30fcf2b));
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
            disabled: form.isLoading,
            children: props.children
        })
    });
}



function $80c92b09a1d36be5$export$669f6ea7d267feaf() {
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        children: "Loading..."
    });
}






const $a71cca287b49b3c9$export$7e04db0cca8f605f = (0, $a4963babae245ff9$export$f0c7a449e0cfaec7)((0, $aca50e9407ba89c9$export$b6ae1bc530f4c149)((props)=>{
    const store = (0, $4671947198ddd366$export$6ccbb43953eebf8)();
    const redirect = (0, $7df35e9df335b1c8$export$602eaf6d5314ce55)();
    const [data, setData] = (0, $acw62.useState)(props.manager);
    const [saveResult, save] = (0, $4671947198ddd366$export$609860bf8b0084c)(()=>props.id ? store.data.updateAttendanceManager(props.id, data) : store.data.addAttendanceManager(data), {
        onSuccess: ()=>redirect((0, $0534349ae8731d0b$export$66b32f6f30eb4b4).attendanceManagers, {}),
        filterError: [
            (0, $9ad33fbf770c55a1$export$9696fcf1798e1cb5).ClientError
        ]
    });
    const { t: t } = (0, $3765cebd031b52c0$export$9fc83ad70ead8663)();
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "AttendanceManagerForm",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h1", {
                children: props.title
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $d43267d0ed87d655$export$a7fed597f4b8afd8), {
                data: data,
                setData: setData,
                error: saveResult.error?.data,
                onSubmit: save,
                isLoading: saveResult.isLoading,
                children: (fields)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4e342c5928158118$export$dd2171e2b7d3bc5b), {
                                label: t("attendance_manager_form.first_name"),
                                field: fields.first_name,
                                required: true
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4e342c5928158118$export$dd2171e2b7d3bc5b), {
                                label: t("attendance_manager_form.last_name"),
                                field: fields.last_name,
                                required: true
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4e342c5928158118$export$dd2171e2b7d3bc5b), {
                                label: t("attendance_manager_form.phone"),
                                type: "phone",
                                field: fields.phone,
                                required: true
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4e342c5928158118$export$dd2171e2b7d3bc5b), {
                                label: t("attendance_manager_form.email"),
                                type: "email",
                                field: fields.email,
                                required: true
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4e342c5928158118$export$dd2171e2b7d3bc5b), {
                                label: t("attendance_manager_form.job_role"),
                                field: fields.job_role,
                                required: true
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $9ca5fd069b795964$export$2c4cf1f7b42ef78c), {
                                children: t("attendance_manager_form.save")
                            })
                        ]
                    })
            })
        ]
    });
}));
const $a71cca287b49b3c9$export$d9b616c5a27511f7 = (0, $a4963babae245ff9$export$f0c7a449e0cfaec7)((0, $aca50e9407ba89c9$export$b6ae1bc530f4c149)((props)=>{
    const store = (0, $4671947198ddd366$export$6ccbb43953eebf8)();
    const {} = (0, $4671947198ddd366$export$dd0a697e1782aedd)(()=>store.data.getAttendanceManager(props.id));
    const { t: t } = (0, $3765cebd031b52c0$export$9fc83ad70ead8663)();
    const manager = store.data.attendanceManagers.get(props.id);
    if (!manager) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $80c92b09a1d36be5$export$669f6ea7d267feaf), {});
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($a71cca287b49b3c9$export$7e04db0cca8f605f, {
        id: props.id,
        manager: manager,
        title: t("attendance_manager_form.edit_attendance_manager")
    });
}));
function $a71cca287b49b3c9$export$4942e438700ac431() {
    const { t: t } = (0, $3765cebd031b52c0$export$9fc83ad70ead8663)();
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($a71cca287b49b3c9$export$7e04db0cca8f605f, {
        id: null,
        title: t("attendance_manager_form.add_attendance_manager"),
        manager: {
            email: "",
            first_name: "",
            job_role: "",
            last_name: "",
            phone: "",
            locations: []
        }
    });
}











const $db18af30341d8827$export$2e669a5968a43547 = (0, $a4963babae245ff9$export$f0c7a449e0cfaec7)((0, $aca50e9407ba89c9$export$b6ae1bc530f4c149)(()=>{
    const store = (0, $4671947198ddd366$export$6ccbb43953eebf8)();
    const { attendanceManagersList: attendanceManagersList } = store.data;
    const { isLoading: isLoading } = (0, $4671947198ddd366$export$dd0a697e1782aedd)(store.data.getAttendanceManagers);
    const { t: t } = (0, $3765cebd031b52c0$export$9fc83ad70ead8663)();
    if (isLoading) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $80c92b09a1d36be5$export$669f6ea7d267feaf), {});
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "AttendanceManagerList",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h1", {
                children: t("attendance_manager_list.title")
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7df35e9df335b1c8$export$a6c7ac8248d6e38a), {
                route: (0, $0534349ae8731d0b$export$66b32f6f30eb4b4).addAttendanceManagers,
                params: {},
                children: t("attendance_manager_list.add_manager")
            }),
            attendanceManagersList.map((manager)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($db18af30341d8827$var$AttendanceManagerRow, {
                    manager: manager
                }, manager.id))
        ]
    });
}));
const $db18af30341d8827$var$AttendanceManagerRow = (0, $a4963babae245ff9$export$f0c7a449e0cfaec7)((0, $aca50e9407ba89c9$export$b6ae1bc530f4c149)((props)=>{
    const { t: t } = (0, $3765cebd031b52c0$export$9fc83ad70ead8663)();
    const { manager: manager } = props;
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "AttendanceManagerRow",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "AttendanceManagerRow__main",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "AttendanceManagerRow__name",
                        children: [
                            manager.first_name,
                            " ",
                            manager.last_name
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        children: manager.email
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7df35e9df335b1c8$export$a6c7ac8248d6e38a), {
                route: (0, $0534349ae8731d0b$export$66b32f6f30eb4b4).editAttendanceManagers,
                params: {
                    id: String(manager.id)
                },
                children: t("attendance_manager_list.edit")
            })
        ]
    });
}));




var $acw62 = parcelRequire("acw62");








var $acw62 = parcelRequire("acw62");


var $196cb995d2aa6578$exports = {};
$196cb995d2aa6578$exports = new URL("doc.e6b5eece.svg", import.meta.url).toString();


var $cae3dec62e3fc487$exports = {};
$cae3dec62e3fc487$exports = new URL("upload.2564f625.svg", import.meta.url).toString();


var $18bda4ebb76132d2$exports = {};
$18bda4ebb76132d2$exports = new URL("photo.4271c8ec.svg", import.meta.url).toString();



const $2eb683d14bd8007e$export$48030d8a30a8103a = (0, $aca50e9407ba89c9$export$b6ae1bc530f4c149)((props)=>{
    const [file, setFile] = (0, $acw62.useState)(props.value);
    const inputRef = /*#__PURE__*/ (0, $acw62.createRef)();
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "UploadFile",
        children: [
            file ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "UploadFile__image-container",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                        src: file,
                        onError: ()=>setFile((0, (/*@__PURE__*/$parcel$interopDefault($196cb995d2aa6578$exports)))),
                        className: "UploadFile__image"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                        src: (0, (/*@__PURE__*/$parcel$interopDefault($18bda4ebb76132d2$exports))),
                        className: "UploadFile__photo-icon"
                    })
                ]
            }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                src: (0, (/*@__PURE__*/$parcel$interopDefault($cae3dec62e3fc487$exports))),
                className: "UploadFile__placeholderImage"
            }),
            !file && props.placeholder,
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                className: "UploadFile__input",
                type: "file",
                accept: props.accept ?? ".jpg,.jpeg,.png",
                ref: inputRef,
                onChange: (f)=>{
                    const node = f.target;
                    (0, $dacbeb7af41d49ec$export$804de46662e4ac95)(node);
                    if (node.files.length > 0) {
                        setFile(URL.createObjectURL(node.files[0]));
                        props.onChange?.(node.files[0]);
                    }
                }
            })
        ]
    });
});






const $cdd3da8d040d32dc$export$b1fb6ce97ea06efb = (0, $a4963babae245ff9$export$f0c7a449e0cfaec7)((0, $aca50e9407ba89c9$export$b6ae1bc530f4c149)(()=>{
    const store = (0, $4671947198ddd366$export$6ccbb43953eebf8)();
    const [data, setData] = (0, $acw62.useState)({
        ...store.data.companyDetails,
        trade: undefined,
        vat: undefined,
        trade_url: store.data.companyDetails?.trade,
        vat_url: store.data.companyDetails?.vat
    });
    const [saveResult, save] = (0, $4671947198ddd366$export$609860bf8b0084c)(()=>store.data.update\u0421ompanyDetails(data), {
        filterError: [
            (0, $9ad33fbf770c55a1$export$9696fcf1798e1cb5).ClientError
        ]
    });
    const { isLoading: isLoading } = (0, $4671947198ddd366$export$dd0a697e1782aedd)(()=>store.data.get\u0421ompanyDetails());
    const { t: t } = (0, $3765cebd031b52c0$export$9fc83ad70ead8663)();
    if (isLoading) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $80c92b09a1d36be5$export$669f6ea7d267feaf), {});
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "CompanyForm",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h1", {
                children: t("company_form.title")
            }),
            saveResult.status === "data" && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "CompanyForm__saved",
                children: t("company_form.saved")
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $d43267d0ed87d655$export$a7fed597f4b8afd8), {
                data: data,
                setData: setData,
                error: saveResult.error?.data,
                onSubmit: save,
                isLoading: saveResult.isLoading,
                children: (fields)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4e342c5928158118$export$dd2171e2b7d3bc5b), {
                                label: t("company_form.company_name"),
                                field: fields.company_name,
                                description: t("company_form.company_name_as_in_license"),
                                required: true
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4e342c5928158118$export$dd2171e2b7d3bc5b), {
                                label: t("company_form.address"),
                                field: fields.address,
                                required: true
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4e342c5928158118$export$dd2171e2b7d3bc5b), {
                                label: t("company_form.po_box"),
                                field: fields.po_box,
                                required: true
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "CompanyForm__files",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $2eb683d14bd8007e$export$48030d8a30a8103a), {
                                        placeholder: t("company_form.vat_certificate"),
                                        value: fields.vat_url?.value,
                                        onChange: fields.vat?.setData,
                                        required: true,
                                        accept: ".jpg,.jpeg,.png,.pdf"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $2eb683d14bd8007e$export$48030d8a30a8103a), {
                                        placeholder: t("company_form.trade_license"),
                                        value: fields.trade_url?.value,
                                        onChange: fields.trade?.setData,
                                        accept: ".jpg,.jpeg,.png,.pdf"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4e342c5928158118$export$dd2171e2b7d3bc5b), {
                                label: t("company_form.finance_first_name"),
                                field: fields.finance_first_name
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4e342c5928158118$export$dd2171e2b7d3bc5b), {
                                label: t("company_form.finance_last_name"),
                                field: fields.finance_last_name
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4e342c5928158118$export$dd2171e2b7d3bc5b), {
                                label: t("company_form.finance_phone"),
                                field: fields.finance_phone
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4e342c5928158118$export$dd2171e2b7d3bc5b), {
                                label: t("company_form.finance_email"),
                                field: fields.finance_email
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4e342c5928158118$export$dd2171e2b7d3bc5b), {
                                label: t("company_form.extension"),
                                field: fields.finance_extension
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $9ca5fd069b795964$export$2c4cf1f7b42ef78c), {
                                children: t("company_form.save")
                            })
                        ]
                    })
            })
        ]
    });
}));





var $acw62 = parcelRequire("acw62");



var $i56po = parcelRequire("i56po");
const $7e60b99ede774d99$var$InvoicesList = (0, $i56po.types).model("InvoicesList", {
    searchFilters: (0, $i56po.types).model({
        pointOfContactId: (0, $i56po.types).maybeNull((0, $i56po.types).number),
        locationId: (0, $i56po.types).maybeNull((0, $i56po.types).number),
        designationId: (0, $i56po.types).maybeNull((0, $i56po.types).number),
        dateFrom: (0, $i56po.types).maybeNull((0, $i56po.types).string),
        dateTo: (0, $i56po.types).maybeNull((0, $i56po.types).string),
        orderId: (0, $i56po.types).maybeNull((0, $i56po.types).number),
        isOverdue: (0, $i56po.types).boolean
    })
}).actions((self)=>({
        setPointOfContactId (pointOfContactId) {
            self.searchFilters.pointOfContactId = pointOfContactId;
        },
        setLocationId (locationId) {
            self.searchFilters.locationId = locationId;
        },
        setDesignationId (designationId) {
            self.searchFilters.designationId = designationId;
        },
        setDateFrom (dateFrom) {
            self.searchFilters.dateFrom = dateFrom;
        },
        setDateTo (dateTo) {
            self.searchFilters.dateTo = dateTo;
        },
        setOrderId (orderId) {
            self.searchFilters.orderId = orderId;
        },
        setIsOverdue (isOverdue) {
            self.searchFilters.isOverdue = isOverdue;
        },
        reset () {
            self.searchFilters.pointOfContactId = null;
            self.searchFilters.locationId = null;
            self.searchFilters.designationId = null;
            self.searchFilters.dateFrom = null;
            self.searchFilters.dateTo = null;
            self.searchFilters.orderId = null;
            self.searchFilters.isOverdue = false;
        }
    })).views((self)=>({
        get activeFiltersCount () {
            return [
                self.searchFilters.pointOfContactId,
                self.searchFilters.locationId,
                self.searchFilters.designationId,
                self.searchFilters.dateFrom,
                self.searchFilters.dateTo,
                self.searchFilters.orderId,
                self.searchFilters.isOverdue
            ].filter((value)=>Boolean(value)).length;
        }
    }));
const $7e60b99ede774d99$export$a5b661c0f16e73e7 = $7e60b99ede774d99$var$InvoicesList.create({
    searchFilters: {
        pointOfContactId: null,
        locationId: null,
        designationId: null,
        dateFrom: null,
        dateTo: null,
        orderId: null,
        isOverdue: false
    }
});


function $f24139f1c574946c$export$448bbd9024dcf006(UIComponent) {
    return (0, $a4963babae245ff9$export$f0c7a449e0cfaec7)((0, $aca50e9407ba89c9$export$b6ae1bc530f4c149)(()=>{
        const [isFiltersPopupOpen, setIsFiltersPopupOpen] = (0, $acw62.useState)(false);
        const { invoiceList: invoiceList, getInvoices: getInvoices } = (0, $4671947198ddd366$export$6ccbb43953eebf8)().data;
        const [getInvoicesMutation, getInvoicesApiCall] = (0, $4671947198ddd366$export$609860bf8b0084c)(({ pointOfContactId: pointOfContactId, locationId: locationId, designationId: designationId, dateFrom: dateFrom, dateTo: dateTo, orderId: orderId, isOverdue: isOverdue, page: page })=>getInvoices(pointOfContactId, locationId, designationId, dateFrom, dateTo, orderId, isOverdue, page));
        const fetchInvoicesList = (page)=>{
            getInvoicesApiCall({
                pointOfContactId: (0, $7e60b99ede774d99$export$a5b661c0f16e73e7).searchFilters.pointOfContactId,
                locationId: (0, $7e60b99ede774d99$export$a5b661c0f16e73e7).searchFilters.locationId,
                designationId: (0, $7e60b99ede774d99$export$a5b661c0f16e73e7).searchFilters.designationId,
                dateFrom: (0, $7e60b99ede774d99$export$a5b661c0f16e73e7).searchFilters.dateFrom,
                dateTo: (0, $7e60b99ede774d99$export$a5b661c0f16e73e7).searchFilters.dateTo,
                orderId: (0, $7e60b99ede774d99$export$a5b661c0f16e73e7).searchFilters.orderId,
                isOverdue: (0, $7e60b99ede774d99$export$a5b661c0f16e73e7).searchFilters.isOverdue,
                ...page ? {
                    page: page
                } : {}
            });
        };
        (0, $acw62.useEffect)(()=>{
            fetchInvoicesList(1);
        }, []);
        return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)(UIComponent, {
            loading: getInvoicesMutation.isLoading,
            invoiceList: invoiceList,
            loadNextPage: ()=>{
                fetchInvoicesList();
            },
            filters: {
                activeFiltersCount: (0, $7e60b99ede774d99$export$a5b661c0f16e73e7).activeFiltersCount,
                isFiltersPopupOpen: isFiltersPopupOpen,
                setIsFiltersPopupOpen: setIsFiltersPopupOpen,
                reset: ()=>{
                    (0, $7e60b99ede774d99$export$a5b661c0f16e73e7).reset();
                    setIsFiltersPopupOpen(false);
                    fetchInvoicesList(1);
                },
                apply: ()=>{
                    setIsFiltersPopupOpen(false);
                    fetchInvoicesList(1);
                },
                pointOfContactId: (0, $7e60b99ede774d99$export$a5b661c0f16e73e7).searchFilters.pointOfContactId ?? undefined,
                setPointOfContactId: (value)=>(0, $7e60b99ede774d99$export$a5b661c0f16e73e7).setPointOfContactId(value ?? null),
                locationId: (0, $7e60b99ede774d99$export$a5b661c0f16e73e7).searchFilters.locationId ?? undefined,
                setLocationId: (value)=>(0, $7e60b99ede774d99$export$a5b661c0f16e73e7).setLocationId(value ?? null),
                designationId: (0, $7e60b99ede774d99$export$a5b661c0f16e73e7).searchFilters.designationId ?? undefined,
                setDesignationId: (value)=>(0, $7e60b99ede774d99$export$a5b661c0f16e73e7).setDesignationId(value ?? null),
                dateFrom: (0, $7e60b99ede774d99$export$a5b661c0f16e73e7).searchFilters.dateFrom ?? undefined,
                setDateFrom: (0, $7e60b99ede774d99$export$a5b661c0f16e73e7).setDateFrom,
                dateTo: (0, $7e60b99ede774d99$export$a5b661c0f16e73e7).searchFilters.dateTo ?? undefined,
                setDateTo: (0, $7e60b99ede774d99$export$a5b661c0f16e73e7).setDateTo,
                orderId: (0, $7e60b99ede774d99$export$a5b661c0f16e73e7).searchFilters.orderId ?? undefined,
                setOrderId: (value)=>(0, $7e60b99ede774d99$export$a5b661c0f16e73e7).setOrderId(value ?? null),
                isOverdue: (0, $7e60b99ede774d99$export$a5b661c0f16e73e7).searchFilters.isOverdue,
                setIsOverdue: (0, $7e60b99ede774d99$export$a5b661c0f16e73e7).setIsOverdue
            }
        });
    }));
}




var $acw62 = parcelRequire("acw62");






var $acw62 = parcelRequire("acw62");

var $45fvw = parcelRequire("45fvw");





var $9ffab0d1b95d01e1$exports = {};
$9ffab0d1b95d01e1$exports = new URL("calendar.2e9c5c98.svg", import.meta.url).toString();


var $a3cbee8d6c1ffded$exports = {};
$a3cbee8d6c1ffded$exports = new URL("order.49dd9f62.svg", import.meta.url).toString();




var $45fvw = parcelRequire("45fvw");

function $a8b6e1b9cac4434c$export$89b32b61f5f60bea({ due_date: due_date }) {
    const currentDate = (0, (/*@__PURE__*/$parcel$interopDefault($45fvw)))(new Date());
    const momentDueDate = (0, (/*@__PURE__*/$parcel$interopDefault($45fvw)))(due_date, "YYYY-MM-DD");
    const diff = currentDate.diff(momentDueDate);
    const daysDuration = Math.floor((0, (/*@__PURE__*/$parcel$interopDefault($45fvw))).duration(diff).asDays());
    const isPastDate = daysDuration > 0;
    return {
        daysDuration: daysDuration,
        isPastDate: isPastDate
    };
}
function $a8b6e1b9cac4434c$export$6fdbeaa08f63a468({ status: status, due_date: due_date, type: type }, t) {
    if (null === due_date || Number(type) === (0, $c58d6738097efc6a$export$d9ed4832cbd2bab3).CreditNote) return null;
    if (status === (0, $c58d6738097efc6a$export$57fb8c26bdd292d0).Paid) return t("payment.status_paid");
    if (status === (0, $c58d6738097efc6a$export$57fb8c26bdd292d0).Draft) return t("payment_item.status_draft");
    if (status === (0, $c58d6738097efc6a$export$57fb8c26bdd292d0).Processed) return t("payment_item.status_processed");
    if ((0, $c58d6738097efc6a$export$bf24389781b8fcdd).includes(status)) {
        const { isPastDate: isPastDate, daysDuration: daysDuration } = $a8b6e1b9cac4434c$export$89b32b61f5f60bea({
            due_date: due_date
        });
        if (!isPastDate) return t("payment_item.status_unpaid");
        if (daysDuration > 0) return t("invoice_card.due_days_ago", {
            count: daysDuration
        });
        if (daysDuration === 0) return t("invoice_card.due_today");
        if (daysDuration === -1) return t("invoice_card.due_tomorrow");
        return t("invoice_card.due_days_ahead", {
            count: -daysDuration
        });
    }
    return t("payment_item.status_voided");
}
function $a8b6e1b9cac4434c$export$e36396b5f796d93a({ status: status, due_date: due_date }, t) {
    if (status === (0, $c58d6738097efc6a$export$57fb8c26bdd292d0).Paid) return t("payment.status_paid");
    if (status === (0, $c58d6738097efc6a$export$57fb8c26bdd292d0).Draft) return t("payment_item.status_draft");
    if (status === (0, $c58d6738097efc6a$export$57fb8c26bdd292d0).Processed) return t("payment_item.status_processed");
    if ((0, $c58d6738097efc6a$export$bf24389781b8fcdd).includes(status)) return t("payment_item.status_unpaid");
    return t("payment_item.status_voided");
}


const $7154029b2d631b4a$export$3ec0e7e2a513ed02 = ({ id: id, status: status, date: date, dueDate: dueDate, amount: amount, currency: currency, invoiceNumber: invoiceNumber, orderIds: orderIds })=>{
    const { t: t } = (0, $3765cebd031b52c0$export$9fc83ad70ead8663)();
    const currentDate = (0, $acw62.useRef)((0, (/*@__PURE__*/$parcel$interopDefault($45fvw)))(new Date())).current;
    const momentDueDate = (0, $acw62.useRef)((0, (/*@__PURE__*/$parcel$interopDefault($45fvw)))(dueDate, "YYYY-MM-DD")).current;
    const diff = currentDate.diff(momentDueDate);
    const daysDuration = Math.floor((0, (/*@__PURE__*/$parcel$interopDefault($45fvw))).duration(diff).asDays());
    const isPastDate = daysDuration > 0;
    const getDueDate = ()=>{
        if (daysDuration > 0) return t("invoice_card.due_days_ago", {
            count: daysDuration
        });
        if (daysDuration === 0) return t("invoice_card.due_today");
        if (daysDuration === -1) return t("invoice_card.due_tomorrow");
        return t("invoice_card.due_days_ahead", {
            count: -daysDuration
        });
    };
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7df35e9df335b1c8$export$a6c7ac8248d6e38a), {
        route: (0, $0534349ae8731d0b$export$66b32f6f30eb4b4).invoice,
        params: {
            id: String(id)
        },
        className: "InvoiceCard",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "InvoiceCard__row",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                        className: "InvoiceCard__numberLabel",
                        children: invoiceNumber ?? `INV-${id}`
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: `InvoiceCard__statusContainer ${status === (0, $c58d6738097efc6a$export$57fb8c26bdd292d0).Paid ? "success" : "warning"}`,
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                            className: `InvoiceCard__statusLabel ${status === (0, $c58d6738097efc6a$export$57fb8c26bdd292d0).Paid ? "success" : "warning"}`,
                            children: (0, $a8b6e1b9cac4434c$export$e36396b5f796d93a)({
                                status: status,
                                due_date: dueDate
                            }, t)
                        })
                    })
                ]
            }),
            orderIds.length > 0 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $660b2ca422e0e2ae$export$1ff3c3f08ae963c0).Vertical, {
                        height: 13
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: `InvoiceCard__ordersContainer${orderIds.length > 1 ? " InvoiceCard__ordersContainer--multipleOrders" : ""}`,
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                                src: (0, (/*@__PURE__*/$parcel$interopDefault($a3cbee8d6c1ffded$exports)))
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $660b2ca422e0e2ae$export$1ff3c3f08ae963c0).Horizontal, {
                                width: 9
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                className: "InvoiceCard__ordersContainer__orders",
                                children: orderIds.map((orderId)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7b02d682eb115277$exports.Fragment), {
                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7df35e9df335b1c8$export$a6c7ac8248d6e38a), {
                                            handleClick: (e)=>e?.stopPropagation(),
                                            route: (0, $0534349ae8731d0b$export$66b32f6f30eb4b4).orderConfirmation,
                                            params: {
                                                orderId: String(orderId)
                                            },
                                            className: "InvoiceCard__dateLabel",
                                            children: [
                                                "Order #",
                                                orderId
                                            ]
                                        })
                                    }))
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $660b2ca422e0e2ae$export$1ff3c3f08ae963c0).Vertical, {
                height: 13
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "InvoiceCard__dateContainer",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                        src: (0, (/*@__PURE__*/$parcel$interopDefault($9ffab0d1b95d01e1$exports)))
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $660b2ca422e0e2ae$export$1ff3c3f08ae963c0).Horizontal, {
                        width: 9
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                        className: "InvoiceCard__dateLabel",
                        children: (0, (/*@__PURE__*/$parcel$interopDefault($45fvw)))(date, "YYYY-MM-DD").format("DD MMMM YYYY")
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $660b2ca422e0e2ae$export$1ff3c3f08ae963c0).Vertical, {
                height: 8
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "InvoiceCard__row",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "InvoiceCard__row",
                        children: status === (0, $c58d6738097efc6a$export$57fb8c26bdd292d0).Sent && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $660b2ca422e0e2ae$export$1ff3c3f08ae963c0).Horizontal, {
                                    width: 23
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                    className: `InvoiceCard__timeTermLabel ${isPastDate ? "pastDate" : ""}`,
                                    children: getDueDate()
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                        className: "InvoiceCard__amountLabel",
                        children: [
                            String(amount).replace(".", ","),
                            " ",
                            currency
                        ]
                    })
                ]
            })
        ]
    });
};










const $28834efb7efd804d$export$f3f2e7ed2b6256b1 = ()=>{
    const { t: t } = (0, $3765cebd031b52c0$export$9fc83ad70ead8663)();
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "EmptyList",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $660b2ca422e0e2ae$export$1ff3c3f08ae963c0).Vertical, {
                height: 50
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                children: t("common.no_data_found")
            })
        ]
    });
};


const $dd060d70999cb37f$export$5f2350dabbeaf = ({ loading: loading, invoiceList: invoiceList, loadNextPage: loadNextPage, filters: filters })=>{
    const handleScroll = (0, $324dc7daf4e64dab$export$5bd4c3b2b0a1aaf1)(loadNextPage);
    const { t: t } = (0, $3765cebd031b52c0$export$9fc83ad70ead8663)();
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "InvoiceList",
        onScroll: handleScroll,
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7ae42b63183f30b4$export$8b251419efc915eb), {
                showBack: true,
                title: t("sidebar.invoices"),
                rightComponent: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $1a76ba0c0e8a8aa8$export$16bac73b44412208), {
                    setShowFilters: filters.setIsFiltersPopupOpen,
                    activeFiltersCount: filters.activeFiltersCount,
                    className: "OrderConfirmationList__filtersButton"
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $660b2ca422e0e2ae$export$1ff3c3f08ae963c0).Vertical, {
                height: 25
            }),
            invoiceList.map((invoice)=>{
                return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $acw62.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7154029b2d631b4a$export$3ec0e7e2a513ed02), {
                            id: invoice.id,
                            amount: invoice.total_amount,
                            currency: invoice.currency_code,
                            date: invoice.date,
                            dueDate: invoice.due_date,
                            status: invoice.status,
                            invoiceNumber: invoice.invoice_number,
                            orderIds: invoice.order_ids
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $660b2ca422e0e2ae$export$1ff3c3f08ae963c0).Vertical, {
                            height: 24
                        })
                    ]
                }, invoice.id);
            }),
            loading && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $57fb8f45c69e1681$export$b08b517936747730), {}),
            !loading && invoiceList.length === 0 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $28834efb7efd804d$export$f3f2e7ed2b6256b1), {}),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $a4b7c1ff8b9d775f$export$ac5177ff6a0d9687), {
                isOpen: filters.isFiltersPopupOpen,
                close: ()=>filters.setIsFiltersPopupOpen(false),
                reset: filters.reset,
                apply: filters.apply,
                fields: [
                    "pointOfContactId",
                    "designationId",
                    "locationId",
                    "startDate",
                    "endDate",
                    "orderId",
                    "isOverdue"
                ],
                pointOfContactId: filters.pointOfContactId,
                setPointOfContactId: filters.setPointOfContactId,
                locationId: filters.locationId,
                setLocationId: filters.setLocationId,
                designationId: filters.designationId,
                setDesignationId: filters.setDesignationId,
                startDate: filters.dateFrom,
                setStartDate: filters.setDateFrom,
                startDateLabel: t("common.date_from"),
                endDate: filters.dateTo,
                setEndDate: filters.setDateTo,
                endDateLabel: t("common.date_to"),
                orderId: filters.orderId,
                setOrderId: filters.setOrderId,
                isOverdue: filters.isOverdue,
                setIsOverdue: filters.setIsOverdue
            })
        ]
    });
};


const $20e7211a321eb2f7$export$511c99914a1a1c38 = (0, $f24139f1c574946c$export$448bbd9024dcf006)((0, $dd060d70999cb37f$export$5f2350dabbeaf));





var $acw62 = parcelRequire("acw62");








function $dda9d3335aefb0b9$export$f6d7122798e9cdac(UIComponent) {
    return (0, $a4963babae245ff9$export$f0c7a449e0cfaec7)((0, $aca50e9407ba89c9$export$b6ae1bc530f4c149)(({ id: id })=>{
        const { t: t } = (0, $3765cebd031b52c0$export$9fc83ad70ead8663)();
        const { getInvoice: getInvoice, getInvoiceDetails: getInvoiceDetails, downloadInvoice: downloadInvoice, reportIssue: reportIssue } = (0, $4671947198ddd366$export$6ccbb43953eebf8)().data;
        const { isLoading: loadingInvoice } = (0, $4671947198ddd366$export$dd0a697e1782aedd)(()=>getInvoice(id));
        const { download: saveFile } = (0, $8aadbb076e78b446$export$fdb90e0242959057)();
        const { enableQuery: enableQuery, query: downloadQuery } = (0, $4671947198ddd366$export$517ca4f7fee4e226)(()=>downloadInvoice(id), {
            onSuccess: (file)=>saveFile(file, `Invoice${invoice?.invoice_number ? ` ${invoice.invoice_number}` : ""}.pdf`)
        });
        const [isReportIssueFormVisible, setIsReportIssueFormVisible] = (0, $acw62.useState)(false);
        const [reportIssueMutation, reportIssueApiCall] = (0, $4671947198ddd366$export$609860bf8b0084c)(reportIssue, {
            filterError: [
                (0, $9ad33fbf770c55a1$export$9696fcf1798e1cb5).ClientError
            ],
            onSuccess: (result)=>{
                setIsReportIssueFormVisible(false);
                (0, $60f27fc97e29822a$export$b410431fab84fa58)(t("invoice.issue_was_reported"));
            }
        });
        const reportIssueSubmit = ({ message: message })=>{
            reportIssueApiCall({
                id: id,
                message: message
            });
        };
        const reportIssueErrors = reportIssueMutation.error?.data.errors ? Object.values(reportIssueMutation.error.data.errors).join(", ") : "";
        const invoice = getInvoiceDetails(id);
        const isPaymentsEnabled = (0, $2994e7b5ba509fe3$export$f506dd16e02779a7)();
        const hidePaymentFunctionality = !isPaymentsEnabled();
        return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)(UIComponent, {
            id: id,
            loadingInvoice: loadingInvoice,
            downloadingInvoice: downloadQuery.isLoading,
            invoice: invoice ? {
                currency: invoice.currency_code,
                date: invoice.date,
                dueDate: invoice.due_date,
                items: invoice.items,
                status: invoice.status,
                subtotalAmount: invoice.sub_total_amount,
                taxPercent: invoice.tax_percentage,
                taxAmount: invoice.total_tax_amount,
                totalAmount: invoice.total_amount,
                transportationAmount: invoice.total_transportation_amount,
                payment: invoice.payment,
                invoiceNumber: invoice.invoice_number
            } : null,
            handleDownload: enableQuery,
            isReportIssueFormVisible: isReportIssueFormVisible,
            setIsReportIssueFormVisible: setIsReportIssueFormVisible,
            handleReportIssue: reportIssueSubmit,
            reportIssueErrors: reportIssueErrors,
            isReportIssueSubmitting: reportIssueMutation.isLoading,
            hidePaymentFunctionality: hidePaymentFunctionality
        });
    }));
}




var $45fvw = parcelRequire("45fvw");






var $e5a4a690616a7d9e$exports = {};
$e5a4a690616a7d9e$exports = new URL("details.6c3cec7a.svg", import.meta.url).toString();


var $14efd0ddd32ba886$exports = {};
$14efd0ddd32ba886$exports = new URL("vertical-dropdown.5a3ecda8.svg", import.meta.url).toString();


var $cd9fb5b1922ea948$exports = {};
$cd9fb5b1922ea948$exports = new URL("costs.474cdbbc.svg", import.meta.url).toString();


var $12cb8af639ec5f87$exports = {};
$12cb8af639ec5f87$exports = new URL("breakdown.8dd11bae.svg", import.meta.url).toString();


var $372bc9c375543f36$exports = {};
$372bc9c375543f36$exports = new URL("arrow-up.b1ba9fe1.svg", import.meta.url).toString();


var $c391b67ef0170d92$exports = {};
$c391b67ef0170d92$exports = new URL("export.e492eef7.svg", import.meta.url).toString();


var $0fd09c58fc048eb4$exports = {};
$0fd09c58fc048eb4$exports = new URL("issue.ab81083d.svg", import.meta.url).toString();


const $3408a0a8ac969d23$export$6c746a5570b8b35c = {
    detailsImg: (/*@__PURE__*/$parcel$interopDefault($e5a4a690616a7d9e$exports)),
    verticalDropdownImg: (/*@__PURE__*/$parcel$interopDefault($14efd0ddd32ba886$exports)),
    costsImg: (/*@__PURE__*/$parcel$interopDefault($cd9fb5b1922ea948$exports)),
    breakdownImg: (/*@__PURE__*/$parcel$interopDefault($12cb8af639ec5f87$exports)),
    arrowUpImg: (/*@__PURE__*/$parcel$interopDefault($372bc9c375543f36$exports)),
    exportImg: (/*@__PURE__*/$parcel$interopDefault($c391b67ef0170d92$exports)),
    issueImg: (/*@__PURE__*/$parcel$interopDefault($0fd09c58fc048eb4$exports))
};




var $acw62 = parcelRequire("acw62");







var $71bef837d3a218d3$exports = {};
$71bef837d3a218d3$exports = new URL("arrow-right.b7935169.svg", import.meta.url).toString();



const $a606c810a5f77978$export$545323849a752e9b = ({ invoiceItemId: invoiceItemId, ogrammerId: ogrammerId, name: name, imageURL: imageURL, shifts: shifts, hours: hours, amount: amount, currency: currency })=>{
    const { t: t } = (0, $3765cebd031b52c0$export$9fc83ad70ead8663)();
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7df35e9df335b1c8$export$a6c7ac8248d6e38a), {
        route: (0, $0534349ae8731d0b$export$66b32f6f30eb4b4).invoiceOgrammer,
        params: {
            invoiceItemId: invoiceItemId,
            ogrammerId: String(ogrammerId),
            name: name
        },
        className: "Ogrammer",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                src: imageURL,
                className: "Ogrammer__photo"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $660b2ca422e0e2ae$export$1ff3c3f08ae963c0).Horizontal, {
                width: 16
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "Ogrammer__main",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                        className: "Ogrammer__main__name",
                        children: name
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $660b2ca422e0e2ae$export$1ff3c3f08ae963c0).Vertical, {
                        height: 13
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "Ogrammer__main__stats",
                        children: [
                            shifts !== null && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "Ogrammer__main__stats__item",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                        className: "Ogrammer__main__stats__item__label",
                                        children: t("invoice.shifts")
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                        className: "Ogrammer__main__stats__item__value",
                                        children: shifts
                                    })
                                ]
                            }),
                            hours !== null && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "Ogrammer__main__stats__item",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                        className: "Ogrammer__main__stats__item__label",
                                        children: t("invoice.hours")
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                        className: "Ogrammer__main__stats__item__value",
                                        children: hours
                                    })
                                ]
                            }),
                            amount !== null && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "Ogrammer__main__stats__item",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                        className: "Ogrammer__main__stats__item__label",
                                        children: t("invoice.amount")
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                        className: "Ogrammer__main__stats__item__value",
                                        children: [
                                            amount,
                                            " ",
                                            currency
                                        ]
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $660b2ca422e0e2ae$export$1ff3c3f08ae963c0).Spacer, {
                flex: 0.3
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                src: (0, (/*@__PURE__*/$parcel$interopDefault($71bef837d3a218d3$exports))),
                className: "Ogrammer__arrowImg"
            })
        ]
    });
};


var $3aef3e075c9708b9$exports = {};
$3aef3e075c9708b9$exports = new URL("arrow-down.15539fb3.svg", import.meta.url).toString();



const $f9252cf2b2d02cad$export$6e2c8f0811a474ce = ({ invoiceItemId: invoiceItemId, currency: currency, title: title, totalShifts: totalShifts, totalHours: totalHours, totalOG: totalOG, ogrammers: ogrammers, location: location })=>{
    const [collapsed, setCollapsed] = (0, $acw62.useState)(true);
    const { t: t } = (0, $3765cebd031b52c0$export$9fc83ad70ead8663)();
    const toggleOgrammersVisibility = ()=>{
        setCollapsed((prevState)=>!prevState);
    };
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $acw62.Fragment), {
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $660b2ca422e0e2ae$export$1ff3c3f08ae963c0).Vertical, {
                height: 14
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "Section",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "Section__header",
                        onClick: toggleOgrammersVisibility,
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                className: "Section__header__title",
                                children: [
                                    title,
                                    " (",
                                    location,
                                    ")"
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                                src: (0, (/*@__PURE__*/$parcel$interopDefault($3aef3e075c9708b9$exports))),
                                className: `Section__header__arrowImg ${collapsed ? "turned" : ""}`
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $660b2ca422e0e2ae$export$1ff3c3f08ae963c0).Vertical, {
                        height: 17
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "Section__statsContainer",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "Section__statsContainer__stat",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                        className: "Section__statsContainer__stat__label",
                                        children: t("invoice.total_shifts")
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                        className: "Section__statsContainer__stat__value",
                                        children: totalShifts
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "Section__statsContainer__stat",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                        className: "Section__statsContainer__stat__label",
                                        children: t("invoice.total_hours")
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                        className: "Section__statsContainer__stat__value",
                                        children: totalHours
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "Section__statsContainer__stat",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                        className: "Section__statsContainer__stat__label",
                                        children: t("invoice.total_ogs")
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                        className: "Section__statsContainer__stat__value",
                                        children: totalOG
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: `Section__ogrammers ${collapsed ? "collapsed" : ""}`,
                        style: {
                            maxHeight: `${ogrammers.length * 120}px`
                        },
                        children: ogrammers.map((ogrammer)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $a606c810a5f77978$export$545323849a752e9b), {
                                ogrammerId: ogrammer.id,
                                invoiceItemId: invoiceItemId,
                                name: ogrammer.full_name,
                                amount: ogrammer.earnings,
                                currency: currency,
                                hours: ogrammer.hours,
                                imageURL: ogrammer.image_url,
                                shifts: ogrammer.shifts_count
                            }, ogrammer.id))
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $660b2ca422e0e2ae$export$1ff3c3f08ae963c0).Vertical, {
                height: 30
            })
        ]
    });
};





const $e66cb3c36430f640$export$2ce376c2cc3355c8 = ({ img: img, title: title, onClick: onClick })=>{
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        onClick: onClick,
        className: "MenuItem",
        children: [
            img,
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $660b2ca422e0e2ae$export$1ff3c3f08ae963c0).Horizontal, {
                width: 16
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                className: "MenuItem__title",
                children: title
            })
        ]
    });
};






var $acw62 = parcelRequire("acw62");

var $7YFi7 = parcelRequire("7YFi7");



const $6e371c8ce6b71dd3$export$5a934765ce2bd6d7 = ({ onReportIssueSubmit: onReportIssueSubmit, setReportIssueModalVisible: setReportIssueModalVisible, errors: errors, isSubmitting: isSubmitting })=>{
    const { t: t } = (0, $3765cebd031b52c0$export$9fc83ad70ead8663)();
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $acw62.Fragment), {
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "modalReportIssue__header",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                    className: "modalReportIssue__title",
                    children: t("invoice.report_issue_modal_title")
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "modalReportIssue__body",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7YFi7.Formik), {
                    initialValues: {
                        message: ""
                    },
                    validationSchema: $cd7706ce94a8dfd1$export$185802fd694ee1f5().shape({
                        message: $bcc252d93ab3046c$export$185802fd694ee1f5().required(t("invoice.report_issue_message_required"))
                    }),
                    onSubmit: onReportIssueSubmit,
                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7YFi7.Form), {
                        autoComplete: "off",
                        noValidate: true,
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7YFi7.Field), {
                                name: "message",
                                children: ({ field: field, meta: meta })=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $acw62.Fragment), {
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("textarea", {
                                                ...field,
                                                placeholder: t("invoice.report_issue_message_placeholder"),
                                                className: "modalReportIssue__textArea"
                                            }),
                                            meta.error && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                className: "error-msg",
                                                children: meta.error
                                            })
                                        ]
                                    })
                            }),
                            errors && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                className: "error-msg",
                                children: errors
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "modalReportIssue__actions",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                        disabled: isSubmitting,
                                        type: "submit",
                                        className: "modalReportIssue__actions__button modalReportIssue__actions__button--submit",
                                        children: isSubmitting ? t("invoice.issue_is_submitting") : t("invoice.report_issue_submit")
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                        className: "modalReportIssue__actions__button modalReportIssue__actions__button--cancel",
                                        onClick: ()=>setReportIssueModalVisible(false),
                                        children: t("invoice.report_issue_cancel")
                                    })
                                ]
                            })
                        ]
                    })
                })
            })
        ]
    });
};





var $acw62 = parcelRequire("acw62");




var $45fvw = parcelRequire("45fvw");

var $adb8167ba548b918$exports = {};
$adb8167ba548b918$exports = new URL("new-card.eda141b5.svg", import.meta.url).toString();


var $68f8e752cefb17e0$exports = {};
$68f8e752cefb17e0$exports = new URL("wire.b9e0727d.svg", import.meta.url).toString();




const $810e278414a1540d$export$842954143681ce02 = (paymentStatus)=>{
    if (paymentStatus === (0, $ace4c335912c9e96$export$999f810846f9d31d).Pending) return "payment.status_unpaid";
    if (paymentStatus === (0, $ace4c335912c9e96$export$999f810846f9d31d).Processing) return "payment.status_processing";
    if (paymentStatus === (0, $ace4c335912c9e96$export$999f810846f9d31d).Completed) return "payment.status_paid";
    if (paymentStatus === (0, $ace4c335912c9e96$export$999f810846f9d31d).Cancelled) return "payment.status_cancelled";
    return "payment.status_refunded";
};
const $810e278414a1540d$export$c993e048c4e2c9b4 = (payment, t)=>{
    if (payment.status === Number((0, $ace4c335912c9e96$export$999f810846f9d31d).Processing)) return t("payment.status_processing");
    if (payment.status === Number((0, $ace4c335912c9e96$export$999f810846f9d31d).Completed)) return t("payment.status_paid");
    if (payment.status === Number((0, $ace4c335912c9e96$export$999f810846f9d31d).Cancelled)) return t("payment.status_cancelled");
    if (payment.status === Number((0, $ace4c335912c9e96$export$999f810846f9d31d).Refunded)) return t("payment.status_refunded");
    if (payment.status === Number((0, $ace4c335912c9e96$export$999f810846f9d31d).Pending)) {
        const { isPastDate: isPastDate, daysDuration: daysDuration } = (0, $a8b6e1b9cac4434c$export$89b32b61f5f60bea)(payment);
        if (!isPastDate) return t("payment.status_unpaid");
        if (daysDuration > 0) return t("invoice_card.due_days_ago", {
            count: daysDuration
        });
        if (daysDuration === 0) return t("invoice_card.due_today");
        if (daysDuration === -1) return t("invoice_card.due_tomorrow");
        return t("invoice_card.due_days_ahead", {
            count: -daysDuration
        });
    }
};
const $810e278414a1540d$export$980585fe0580c9bf = (payment)=>{
    if (payment.status === Number((0, $ace4c335912c9e96$export$999f810846f9d31d).Processing)) return {
        color: "rgba(252, 179, 92, 1)"
    };
    if (payment.status === Number((0, $ace4c335912c9e96$export$999f810846f9d31d).Completed)) return {
        color: "rgba(94, 170, 111, 1)"
    };
    if (payment.status === Number((0, $ace4c335912c9e96$export$999f810846f9d31d).Pending)) {
        const { isPastDate: isPastDate } = (0, $a8b6e1b9cac4434c$export$89b32b61f5f60bea)(payment);
        if (!isPastDate) return {
            color: "rgba(252, 179, 92, 1)"
        };
    }
    return {
        color: "rgba(234, 111, 126, 1)"
    };
};
const $810e278414a1540d$export$95dc18b5b2f97717 = {
    [(0, $ace4c335912c9e96$export$34b52ce9cfcb0a39).Card]: {
        title: "payment.payment_method_card_title",
        wideTitle: "payment.payment_method_card_wide_title",
        description: "payment.payment_method_card_description",
        image: (0, (/*@__PURE__*/$parcel$interopDefault($adb8167ba548b918$exports)))
    },
    [(0, $ace4c335912c9e96$export$34b52ce9cfcb0a39).Lean]: {
        title: "payment.payment_method_lean_description",
        wideTitle: "payment.payment_method_lean_description",
        description: "payment.payment_method_lean_description",
        image: (0, (/*@__PURE__*/$parcel$interopDefault($adb8167ba548b918$exports)))
    },
    [(0, $ace4c335912c9e96$export$34b52ce9cfcb0a39).Wire]: {
        title: "payment.payment_method_wire_transfer_title",
        wideTitle: "payment.payment_method_wire_transfer_title",
        description: "payment.payment_method_wire_transfer_description",
        image: (0, (/*@__PURE__*/$parcel$interopDefault($68f8e752cefb17e0$exports)))
    }
};
function $810e278414a1540d$export$cf24e9559eb569c7({ status: status, due_date: due_date }) {
    if (null === due_date) return {
        color: "rgba(234, 111, 126, 1)"
    };
    if (status === (0, $c58d6738097efc6a$export$57fb8c26bdd292d0).Paid) return {
        color: "rgba(94, 170, 111, 1)"
    };
    if ((0, $c58d6738097efc6a$export$bf24389781b8fcdd).includes(status)) {
        const { isPastDate: isPastDate } = (0, $a8b6e1b9cac4434c$export$89b32b61f5f60bea)({
            due_date: due_date
        });
        if (!isPastDate) return {
            color: "rgba(252, 179, 92, 1)"
        };
        return {
            color: "rgba(234, 111, 126, 1)"
        };
    }
    return {};
}
function $810e278414a1540d$export$92521769c5df59ad(date) {
    if (null === date) return null;
    return (0, (/*@__PURE__*/$parcel$interopDefault($45fvw)))(date).format("MMM DD, YYYY");
}




const $c570ddae4d4f38cd$export$ad8b2382ee557dc0 = ({ payment: payment })=>{
    const { t: t } = (0, $3765cebd031b52c0$export$9fc83ad70ead8663)();
    const onPayClick = (0, $2994e7b5ba509fe3$export$b6630b826aa95580)();
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $acw62.Fragment), {
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "Invoice__sectionHeader",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                        src: (0, $3408a0a8ac969d23$export$6c746a5570b8b35c).detailsImg,
                        className: "Invoice__sectionHeader__detailsImg "
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $660b2ca422e0e2ae$export$1ff3c3f08ae963c0).Horizontal, {
                        width: 8
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                        className: "Invoice__sectionHeader__title",
                        children: t("payment.payment")
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $660b2ca422e0e2ae$export$1ff3c3f08ae963c0).Vertical, {
                height: 14
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "Invoice__cardContainer",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "Invoice__cardContainer__row",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                className: "Invoice__cardContainer__row__label",
                                children: t("payment.payment_number")
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                className: "Invoice__cardContainer__row__value",
                                children: payment.payment_number
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "Invoice__cardContainer__row",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                className: "Invoice__cardContainer__row__label",
                                children: t("payment.amount")
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                className: "Invoice__cardContainer__row__value",
                                children: [
                                    payment.amount,
                                    " ",
                                    payment.currency_code
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "Invoice__cardContainer__row",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                className: "Invoice__cardContainer__row__label",
                                children: t("payment.status")
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                className: "Invoice__cardContainer__row__value",
                                children: t((0, $810e278414a1540d$export$842954143681ce02)(String(payment.status)))
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "Invoice__cardContainer__row last",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                className: "Invoice__cardContainer__row__label",
                                children: t("payment.due_date")
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                className: "Invoice__cardContainer__row__value",
                                children: (0, $810e278414a1540d$export$92521769c5df59ad)(String(payment.due_date))
                            })
                        ]
                    }),
                    payment.status === Number((0, $ace4c335912c9e96$export$999f810846f9d31d).Pending) && // TODO(A): fix wrong payment type
                    // @ts-ignore
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                        onClick: ()=>onPayClick(payment),
                        className: "Invoice__Payment__payButton",
                        children: t("invoice.pay_now")
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $660b2ca422e0e2ae$export$1ff3c3f08ae963c0).Vertical, {
                height: 14
            })
        ]
    });
};





const $749f1fad82b996cf$var$TOAST_BACKGROUND_COLOR = "#7f72d9";
const $749f1fad82b996cf$var$TOAST_AUTO_CLOSE = 3000;
const $749f1fad82b996cf$export$ba5f874f962e090e = ({ id: id, loadingInvoice: loadingInvoice, downloadingInvoice: downloadingInvoice, invoice: invoice, handleDownload: handleDownload, isReportIssueFormVisible: isReportIssueFormVisible, setIsReportIssueFormVisible: setIsReportIssueFormVisible, handleReportIssue: handleReportIssue, reportIssueErrors: reportIssueErrors, isReportIssueSubmitting: isReportIssueSubmitting, hidePaymentFunctionality: hidePaymentFunctionality })=>{
    const { t: t } = (0, $3765cebd031b52c0$export$9fc83ad70ead8663)();
    const orderIds = (invoice?.items ?? []).map((invoiceItem)=>invoiceItem.order_id);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "Invoice",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $60f27fc97e29822a$export$f2815235e76a62b9), {
                autoClose: $749f1fad82b996cf$var$TOAST_AUTO_CLOSE,
                progressStyle: {
                    background: $749f1fad82b996cf$var$TOAST_BACKGROUND_COLOR
                }
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c786671f641538e1$export$446bb0a5366f9068), {
                modalVisible: isReportIssueFormVisible,
                onClose: ()=>setIsReportIssueFormVisible(false),
                contentStyle: {
                    overflow: "hidden"
                },
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $6e371c8ce6b71dd3$export$5a934765ce2bd6d7), {
                    onReportIssueSubmit: handleReportIssue,
                    setReportIssueModalVisible: setIsReportIssueFormVisible,
                    errors: reportIssueErrors,
                    isSubmitting: isReportIssueSubmitting
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7ae42b63183f30b4$export$8b251419efc915eb), {
                showBack: true,
                title: t("invoice.invoice_#", {
                    index: invoice?.invoiceNumber ?? `#INV-${id}`
                }),
                rightComponent: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $04012d5b0475752e$export$e44a253a59704894), {
                    outerComponent: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                        src: (0, $3408a0a8ac969d23$export$6c746a5570b8b35c).verticalDropdownImg,
                        className: "Invoice__dropdownImg"
                    }),
                    items: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e66cb3c36430f640$export$2ce376c2cc3355c8), {
                            title: downloadingInvoice ? t("invoice.exporting") : t("invoice.export_pdf"),
                            img: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                                src: (0, $3408a0a8ac969d23$export$6c746a5570b8b35c).exportImg
                            }),
                            onClick: handleDownload
                        }, 0),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e66cb3c36430f640$export$2ce376c2cc3355c8), {
                            title: t("invoice.report_issue"),
                            img: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                                src: (0, $3408a0a8ac969d23$export$6c746a5570b8b35c).issueImg
                            }),
                            onClick: ()=>setIsReportIssueFormVisible(true)
                        }, 1)
                    ]
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $660b2ca422e0e2ae$export$1ff3c3f08ae963c0).Vertical, {
                height: 27
            }),
            loadingInvoice ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $57fb8f45c69e1681$export$b08b517936747730), {}) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "Invoice__sectionHeader",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                                src: (0, $3408a0a8ac969d23$export$6c746a5570b8b35c).detailsImg,
                                className: "Invoice__sectionHeader__detailsImg "
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $660b2ca422e0e2ae$export$1ff3c3f08ae963c0).Horizontal, {
                                width: 8
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                className: "Invoice__sectionHeader__title",
                                children: t("invoice.details")
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $660b2ca422e0e2ae$export$1ff3c3f08ae963c0).Vertical, {
                        height: 14
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "Invoice__cardContainer",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "Invoice__cardContainer__row",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                        className: "Invoice__cardContainer__row__label",
                                        children: t("invoice.invoice_number")
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                        className: "Invoice__cardContainer__row__value",
                                        children: invoice?.invoiceNumber ?? `#INV-${id}`
                                    })
                                ]
                            }),
                            orderIds.length > 0 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "Invoice__cardContainer__row",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                        className: "Invoice__cardContainer__row__label",
                                        children: t("orders_list.title")
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                        className: "Invoice__cardContainer__row__value",
                                        children: orderIds.map((orderId)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7df35e9df335b1c8$export$a6c7ac8248d6e38a), {
                                                        route: (0, $0534349ae8731d0b$export$66b32f6f30eb4b4).orderConfirmation,
                                                        params: {
                                                            orderId: String(orderId)
                                                        },
                                                        className: "Invoice__orderId",
                                                        children: orderId
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                        className: "Invoice__orderId__separator",
                                                        children: ","
                                                    })
                                                ]
                                            }))
                                    })
                                ]
                            }),
                            invoice?.date && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "Invoice__cardContainer__row",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                        className: "Invoice__cardContainer__row__label",
                                        children: t("invoice.date")
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                        className: "Invoice__cardContainer__row__value",
                                        children: (0, (/*@__PURE__*/$parcel$interopDefault($45fvw)))(invoice.date, "YYYY-MM-DD").format("DD MMM YYYY")
                                    })
                                ]
                            }),
                            invoice?.dueDate && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "Invoice__cardContainer__row",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                        className: "Invoice__cardContainer__row__label",
                                        children: t("invoice.due_date")
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                        className: "Invoice__cardContainer__row__value",
                                        children: (0, (/*@__PURE__*/$parcel$interopDefault($45fvw)))(invoice.dueDate, "YYYY-MM-DD").format("DD MMM YYYY")
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "Invoice__cardContainer__row last",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                        className: "Invoice__cardContainer__row__label",
                                        children: t("invoice.status")
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                        className: "Invoice__cardContainer__row__value",
                                        children: invoice && (0, $a8b6e1b9cac4434c$export$e36396b5f796d93a)({
                                            status: invoice.status,
                                            due_date: invoice.dueDate
                                        }, t)
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $660b2ca422e0e2ae$export$1ff3c3f08ae963c0).Vertical, {
                        height: 14
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "Invoice__sectionHeader",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                                src: (0, $3408a0a8ac969d23$export$6c746a5570b8b35c).costsImg,
                                className: "Invoice__sectionHeader__costsImg"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $660b2ca422e0e2ae$export$1ff3c3f08ae963c0).Horizontal, {
                                width: 8
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                className: "Invoice__sectionHeader__title",
                                children: t("invoice.costs")
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $660b2ca422e0e2ae$export$1ff3c3f08ae963c0).Vertical, {
                        height: 14
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "Invoice__cardContainer",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "Invoice__cardContainer__row",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                        className: "Invoice__cardContainer__row__label",
                                        children: t("invoice.subtotal")
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                        className: "Invoice__cardContainer__row__value",
                                        children: [
                                            invoice?.subtotalAmount,
                                            " ",
                                            invoice?.currency
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "Invoice__cardContainer__row",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                        className: "Invoice__cardContainer__row__label",
                                        children: t("invoice.transportation")
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                        className: "Invoice__cardContainer__row__value",
                                        children: [
                                            invoice?.transportationAmount,
                                            " ",
                                            invoice?.currency
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "Invoice__cardContainer__row",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                        className: "Invoice__cardContainer__row__label",
                                        children: t("invoice.vat_percent", {
                                            count: invoice?.taxPercent ?? 0
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                        className: "Invoice__cardContainer__row__value",
                                        children: [
                                            invoice?.taxAmount,
                                            " ",
                                            invoice?.currency
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "Invoice__cardContainer__row last",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                        className: "Invoice__cardContainer__row__label",
                                        children: t("invoice.total")
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                        className: "Invoice__cardContainer__row__value highlighted",
                                        children: [
                                            invoice?.totalAmount,
                                            " ",
                                            invoice?.currency
                                        ]
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $660b2ca422e0e2ae$export$1ff3c3f08ae963c0).Vertical, {
                        height: 14
                    }),
                    !hidePaymentFunctionality && invoice?.payment && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c570ddae4d4f38cd$export$ad8b2382ee557dc0), {
                        payment: invoice.payment
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "Invoice__sectionHeader",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                                src: (0, $3408a0a8ac969d23$export$6c746a5570b8b35c).breakdownImg,
                                className: "Invoice__sectionHeader__breakdownImg"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $660b2ca422e0e2ae$export$1ff3c3f08ae963c0).Horizontal, {
                                width: 8
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                className: "Invoice__sectionHeader__title",
                                children: t("invoice.breakdown")
                            })
                        ]
                    }),
                    invoice?.items.map((item)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f9252cf2b2d02cad$export$6e2c8f0811a474ce), {
                            invoiceItemId: String(item.id),
                            currency: invoice.currency,
                            title: item.title ?? "",
                            totalHours: item.total_hours,
                            totalOG: item.total_sps,
                            totalShifts: item.total_shifts,
                            ogrammers: item.sps,
                            location: item.location
                        }, item.id)),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $660b2ca422e0e2ae$export$1ff3c3f08ae963c0).Vertical, {
                        height: 40
                    })
                ]
            })
        ]
    });
};


const $71241f09058a408d$var$InvoiceContainer = (0, $dda9d3335aefb0b9$export$f6d7122798e9cdac)((0, $749f1fad82b996cf$export$ba5f874f962e090e));
const $71241f09058a408d$export$20b0e646f9b575db = ({ id: id })=>{
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($71241f09058a408d$var$InvoiceContainer, {
        id: id
    });
};




var $acw62 = parcelRequire("acw62");





var $80011e20bd62d989$exports = {};
$80011e20bd62d989$exports = new URL("og-details.8dd11bae.svg", import.meta.url).toString();


var $22a817bafaeb6a33$exports = {};
$22a817bafaeb6a33$exports = new URL("shift-details.6c3cec7a.svg", import.meta.url).toString();




const $651dbbae4b4572bb$export$cb59d7355d787dc6 = (0, $a4963babae245ff9$export$f0c7a449e0cfaec7)((0, $aca50e9407ba89c9$export$b6ae1bc530f4c149)(({ invoiceItemId: invoiceItemId, ogrammerId: ogrammerId })=>{
    const [invoiceJobShifts, setInvoiceJobShifts] = (0, $acw62.useState)();
    const { t: t } = (0, $3765cebd031b52c0$export$9fc83ad70ead8663)();
    const { getInvoiceJobShfits: getInvoiceJobShfits } = (0, $4671947198ddd366$export$6ccbb43953eebf8)().data;
    const { isLoading: isLoading } = (0, $4671947198ddd366$export$dd0a697e1782aedd)(()=>getInvoiceJobShfits({
            invoiceItemId: invoiceItemId,
            ogrammerId: ogrammerId
        }), {
        onSuccess: setInvoiceJobShifts
    });
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "InvoiceOgrammer",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $660b2ca422e0e2ae$export$1ff3c3f08ae963c0).Vertical, {
                height: 30
            }),
            isLoading ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $57fb8f45c69e1681$export$b08b517936747730), {}) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "InvoiceOgrammer__sectionHeader",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                                src: (0, (/*@__PURE__*/$parcel$interopDefault($80011e20bd62d989$exports))),
                                className: "InvoiceOgrammer__sectionHeader__img"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $660b2ca422e0e2ae$export$1ff3c3f08ae963c0).Horizontal, {
                                width: 10
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                className: "InvoiceOgrammer__sectionHeader__title",
                                children: t("invoice_ogrammer.og_details")
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $660b2ca422e0e2ae$export$1ff3c3f08ae963c0).Vertical, {
                        height: 16
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "InvoiceOgrammer__section",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "InvoiceOgrammer__section__row",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                        className: "InvoiceOgrammer__section__row__label",
                                        children: t("invoice_ogrammer.job")
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                        className: "InvoiceOgrammer__section__row__value",
                                        children: invoiceJobShifts?.invoice.title
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "InvoiceOgrammer__section__row",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                        className: "InvoiceOgrammer__section__row__label",
                                        children: t("invoice_ogrammer.location")
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                        className: "InvoiceOgrammer__section__row__value",
                                        children: invoiceJobShifts?.invoice.location
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "InvoiceOgrammer__section__row",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                        className: "InvoiceOgrammer__section__row__label",
                                        children: t("invoice_ogrammer.shifts")
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                        className: "InvoiceOgrammer__section__row__value",
                                        children: invoiceJobShifts?.shifts.length
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "InvoiceOgrammer__section__row",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                        className: "InvoiceOgrammer__section__row__label",
                                        children: t("invoice_ogrammer.hours")
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                        className: "InvoiceOgrammer__section__row__value",
                                        children: invoiceJobShifts?.invoice.hours
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "InvoiceOgrammer__section__row",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                        className: "InvoiceOgrammer__section__row__label",
                                        children: t("invoice_ogrammer.amount_due")
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                        className: "InvoiceOgrammer__section__row__value",
                                        children: [
                                            invoiceJobShifts?.invoice.price,
                                            " ",
                                            invoiceJobShifts?.invoice.currency_code
                                        ]
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $660b2ca422e0e2ae$export$1ff3c3f08ae963c0).Vertical, {
                        height: 30
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "InvoiceOgrammer__sectionHeader",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                                src: (0, (/*@__PURE__*/$parcel$interopDefault($22a817bafaeb6a33$exports))),
                                className: "InvoiceOgrammer__sectionHeader__img"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $660b2ca422e0e2ae$export$1ff3c3f08ae963c0).Horizontal, {
                                width: 10
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                className: "InvoiceOgrammer__sectionHeader__title",
                                children: t("invoice_ogrammer.shift_details")
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $660b2ca422e0e2ae$export$1ff3c3f08ae963c0).Vertical, {
                        height: 16
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "InvoiceOgrammer__shiftsSection",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "InvoiceOgrammer__shiftsSection__shiftRow",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                        className: "InvoiceOgrammer__shiftsSection__shiftRow__column",
                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                            className: "InvoiceOgrammer__shiftsSection__shiftRow__column__label",
                                            children: t("invoice_ogrammer.day")
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                        className: "InvoiceOgrammer__shiftsSection__shiftRow__column",
                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                            className: "InvoiceOgrammer__shiftsSection__shiftRow__column__label",
                                            children: t("invoice_ogrammer.hours")
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                        className: "InvoiceOgrammer__shiftsSection__shiftRow__column",
                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                            className: "InvoiceOgrammer__shiftsSection__shiftRow__column__label",
                                            children: t("invoice_ogrammer.approved_by")
                                        })
                                    })
                                ]
                            }),
                            invoiceJobShifts?.shifts.map((item, index)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                    className: `InvoiceOgrammer__shiftsSection__shiftRow ${index % 2 === 0 ? "even" : ""}`,
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                            className: "InvoiceOgrammer__shiftsSection__shiftRow__column",
                                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                className: "InvoiceOgrammer__shiftsSection__shiftRow__column__value",
                                                children: item.date
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                            className: "InvoiceOgrammer__shiftsSection__shiftRow__column",
                                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                className: "InvoiceOgrammer__shiftsSection__shiftRow__column__value",
                                                children: item.hours
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                            className: "InvoiceOgrammer__shiftsSection__shiftRow__column",
                                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                className: "InvoiceOgrammer__shiftsSection__shiftRow__column__value",
                                                children: item.approver.full_name
                                            })
                                        })
                                    ]
                                }, index))
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $660b2ca422e0e2ae$export$1ff3c3f08ae963c0).Vertical, {
                        height: 30
                    })
                ]
            })
        ]
    });
}));





const $e6f065ebb10a6725$export$c02cb95fd6115d1a = (0, $aca50e9407ba89c9$export$b6ae1bc530f4c149)(()=>{
    // const { store, isLoading } = useQuery(st => st.data.getProfile())
    // const [logoutResult, logout] = useMutation(mut => mut.data.logout())
    // if (isLoading) return <Loading />
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        children: "123"
    });
});





const $92d0b78710a42fc3$export$f397243e060e425 = (0, $aca50e9407ba89c9$export$b6ae1bc530f4c149)(()=>{
    // const { store, isLoading } = useQuery(st => st.data.getProfile())
    // const [logoutResult, logout] = useMutation(mut => mut.data.logout())
    // if (isLoading) return <Loading />
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        className: "PaymentMethodList",
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h1", {
            children: "Payment Methods"
        })
    });
});





const $9fcc7cc29e3601f3$export$6b7b6cff4ccb438b = (0, $aca50e9407ba89c9$export$b6ae1bc530f4c149)(()=>{
    // const { store, isLoading } = useQuery(st => st.data.getProfile())
    // const [logoutResult, logout] = useMutation(mut => mut.data.logout())
    // if (isLoading) return <Loading />
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        className: "Preferences",
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h1", {
            children: "Preferences"
        })
    });
});








var $7YFi7 = parcelRequire("7YFi7");











const $d117655b96b4f841$export$fd4f5ba7ecf9016f = (0, $a4963babae245ff9$export$f0c7a449e0cfaec7)((0, $aca50e9407ba89c9$export$b6ae1bc530f4c149)(()=>{
    const { profile: profile, companyDetails: companyDetails, getProfile: getProfile, "get\u0421ompanyDetails": get\u0421ompanyDetails, updateProfile: updateProfile } = (0, $4671947198ddd366$export$6ccbb43953eebf8)().data;
    const { isLoading: companyDetailsLoading } = (0, $4671947198ddd366$export$dd0a697e1782aedd)(get\u0421ompanyDetails);
    const { isLoading: profileLoading } = (0, $4671947198ddd366$export$dd0a697e1782aedd)(getProfile);
    const [saveResult, save] = (0, $4671947198ddd366$export$609860bf8b0084c)(updateProfile, {
        onSuccess: ()=>window.history.back(),
        filterError: [
            (0, $9ad33fbf770c55a1$export$9696fcf1798e1cb5).ClientError
        ]
    });
    const { t: t } = (0, $3765cebd031b52c0$export$9fc83ad70ead8663)();
    const errors = saveResult.error?.data.errors;
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        className: "ProfileForm",
        children: companyDetailsLoading || profileLoading ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $57fb8f45c69e1681$export$2e2bcd8739ae039), {}) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $660b2ca422e0e2ae$export$1ff3c3f08ae963c0).Vertical, {
                    height: 24.5
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7YFi7.Formik), {
                    initialValues: {
                        image: profile?.image,
                        first_name: profile?.first_name,
                        last_name: profile?.last_name ?? "",
                        phone: profile?.phone,
                        email: profile?.email,
                        allow_marketing_emails: Boolean(profile?.allow_marketing_emails)
                    },
                    onSubmit: (values)=>{
                        const submitObject = {
                            ...values,
                            allow_marketing_emails: Number(values.allow_marketing_emails)
                        };
                        if (values.image instanceof File) submitObject.image = values.image;
                        else delete submitObject.image;
                        save(submitObject);
                    },
                    validationSchema: $cd7706ce94a8dfd1$export$185802fd694ee1f5().shape({
                        first_name: $bcc252d93ab3046c$export$185802fd694ee1f5().required(t("profile_form.first_name_required")),
                        last_name: $bcc252d93ab3046c$export$185802fd694ee1f5().required(t("profile_form.last_name_required")),
                        phone: $bcc252d93ab3046c$export$185802fd694ee1f5().required(t("profile_form.phone_required")),
                        email: $bcc252d93ab3046c$export$185802fd694ee1f5().email(t("validation_messages.email_invalid")).required(t("profile_form.email_required"))
                    }),
                    children: (formikProps)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7YFi7.Form), {
                            noValidate: true,
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                    className: "ProfileForm__top-container",
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $2eb683d14bd8007e$export$48030d8a30a8103a), {
                                            placeholder: t("profile_form.upload_photo"),
                                            value: formikProps.getFieldProps("image").value,
                                            onChange: (value)=>{
                                                formikProps.setFieldValue("image", value);
                                            }
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $660b2ca422e0e2ae$export$1ff3c3f08ae963c0).Vertical, {
                                            height: 25
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("h2", {
                                            className: "ProfileForm__name",
                                            children: [
                                                profile?.first_name,
                                                " ",
                                                profile?.last_name
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                            className: "ProfileForm__status",
                                            children: companyDetails?.is_corporate === 0 ? t("profile_form.private") : t("profile_form.corporate")
                                        }),
                                        companyDetails?.is_corporate === 0 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $660b2ca422e0e2ae$export$1ff3c3f08ae963c0).Vertical, {
                                                    height: 31
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $677661c9496f0f07$export$d5992c1fec905475), {
                                                    title: t("profile_form.register_corporate"),
                                                    url: (0, $0534349ae8731d0b$export$66b32f6f30eb4b4).completeRegistration
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $660b2ca422e0e2ae$export$1ff3c3f08ae963c0).Vertical, {
                                    height: 24
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                    className: "ProfileForm__basic-container",
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $1067a74e1c3483e2$export$f551688fc98f2e09), {
                                            errors: errors?.first_name,
                                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $79dd68e96d831dee$export$2e2bcd8739ae039), {
                                                label: t("profile_form.first_name"),
                                                formikProps: formikProps,
                                                formikKey: "first_name"
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $660b2ca422e0e2ae$export$1ff3c3f08ae963c0).Vertical, {
                                            height: 15
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $1067a74e1c3483e2$export$f551688fc98f2e09), {
                                            errors: errors?.last_name,
                                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $79dd68e96d831dee$export$2e2bcd8739ae039), {
                                                label: t("profile_form.last_name"),
                                                formikProps: formikProps,
                                                formikKey: "last_name"
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $660b2ca422e0e2ae$export$1ff3c3f08ae963c0).Vertical, {
                                            height: 15
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $1067a74e1c3483e2$export$f551688fc98f2e09), {
                                            errors: errors?.phone,
                                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $79dd68e96d831dee$export$2e2bcd8739ae039), {
                                                label: t("profile_form.phone"),
                                                formikProps: formikProps,
                                                formikKey: "phone"
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $660b2ca422e0e2ae$export$1ff3c3f08ae963c0).Vertical, {
                                            height: 15
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $1067a74e1c3483e2$export$f551688fc98f2e09), {
                                            errors: errors?.email,
                                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $79dd68e96d831dee$export$2e2bcd8739ae039), {
                                                disabled: true,
                                                label: t("profile_form.email"),
                                                formikProps: formikProps,
                                                formikKey: "email"
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $660b2ca422e0e2ae$export$1ff3c3f08ae963c0).Vertical, {
                                            height: 15
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                            className: "ProfileForm__emailAgreementContainer",
                                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $1067a74e1c3483e2$export$f551688fc98f2e09), {
                                                errors: [],
                                                className: "ProfileForm__emailAgreementContainer__row",
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                                        type: "checkbox",
                                                        onClick: ()=>{
                                                            formikProps.setFieldValue("allow_marketing_emails", !formikProps.values.allow_marketing_emails);
                                                        },
                                                        checked: formikProps.values.allow_marketing_emails,
                                                        className: "ProfileForm__emailAgreementContainer__checkboxContainer__checkbox"
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $660b2ca422e0e2ae$export$1ff3c3f08ae963c0).Horizontal, {
                                                        width: 10
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                        className: "ProfileForm__emailAgreementContainer__checkboxContainer__labelContainer",
                                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                            className: "ProfileForm__emailAgreementContainer__checkboxContainer__labelContainer__label",
                                                            children: t("profile_form.agree_to_emails")
                                                        })
                                                    })
                                                ]
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $660b2ca422e0e2ae$export$1ff3c3f08ae963c0).Vertical, {
                                            height: 41
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                            className: "ProfileForm__buttons_container",
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $2ab88429e3384d30$export$353f5b6fc5456de1), {
                                                    type: "submit",
                                                    title: t("profile_form.save"),
                                                    className: "ProfileForm__save_button"
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $660b2ca422e0e2ae$export$1ff3c3f08ae963c0).Horizontal, {
                                                    width: 10
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $2ab88429e3384d30$export$353f5b6fc5456de1), {
                                                    type: "button",
                                                    title: t("profile_form.cancel"),
                                                    onClick: ()=>window.history.back()
                                                })
                                            ]
                                        })
                                    ]
                                })
                            ]
                        })
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $660b2ca422e0e2ae$export$1ff3c3f08ae963c0).Vertical, {
                    height: 37
                })
            ]
        })
    });
}));


const $651a1cb1639ca9ba$export$5382a454bcbe4573 = {
    AddAttendanceManagerFormPage: $a71cca287b49b3c9$export$4942e438700ac431,
    EditAttendanceManagerPage: $a71cca287b49b3c9$export$d9b616c5a27511f7,
    AttendanceManagerListPage: $db18af30341d8827$export$2e669a5968a43547,
    CompanyFormPage: $cdd3da8d040d32dc$export$b1fb6ce97ea06efb,
    InvoiceListPage: $20e7211a321eb2f7$export$511c99914a1a1c38,
    InvoiceDetailsPage: $71241f09058a408d$export$20b0e646f9b575db,
    InvoiceOgrammerPage: $651dbbae4b4572bb$export$cb59d7355d787dc6,
    PaymentMethodFormPage: $e6f065ebb10a6725$export$c02cb95fd6115d1a,
    PaymentMethodListPage: $92d0b78710a42fc3$export$f397243e060e425,
    PreferencesPage: $9fcc7cc29e3601f3$export$6b7b6cff4ccb438b,
    ProfileFormPage: $d117655b96b4f841$export$fd4f5ba7ecf9016f
};







var $acw62 = parcelRequire("acw62");




var $acw62 = parcelRequire("acw62");




var $8eedc87ae1272247$exports = {};
$8eedc87ae1272247$exports = new URL("check-icon-green.0b34ed97.svg", import.meta.url).toString();


var $3ad7df9a596be88f$exports = {};
$3ad7df9a596be88f$exports = new URL("cross-icon-red.7733e592.svg", import.meta.url).toString();




var $acw62 = parcelRequire("acw62");

var $45fvw = parcelRequire("45fvw");

var $cab7dbc8172ddafd$exports = {};
$cab7dbc8172ddafd$exports = new URL("location-icon-grey.5db3e0c5.svg", import.meta.url).toString();



var $af6db54c20ce46fa$exports = {};
$af6db54c20ce46fa$exports = new URL("info-icon-orange.2a50b9a8.svg", import.meta.url).toString();




var $ac2006f3afc8ae8f$exports = {};
$ac2006f3afc8ae8f$exports = new URL("limited-time.34b635fc.svg", import.meta.url).toString();




const $e176d22eecb6513b$var$AutoConfirmationModal = ({ closeModal: closeModal, modalIsOpen: modalIsOpen })=>{
    const { t: t } = (0, $3765cebd031b52c0$export$9fc83ad70ead8663)();
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $c786671f641538e1$export$446bb0a5366f9068), {
        modalVisible: modalIsOpen,
        className: "AutoConfirmationModal",
        onClose: closeModal,
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                src: (0, (/*@__PURE__*/$parcel$interopDefault($ac2006f3afc8ae8f$exports)))
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h2", {
                className: "AutoConfirmationModal__modalTitle",
                children: t("shift_attendance_common.limited_time_to_confirm")
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                children: t("shift_attendance_common.time_to_review_description")
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                onClick: closeModal,
                className: "AutoConfirmationModal__closeButton",
                children: t("shift_attendance_common.i_understand")
            })
        ]
    });
};
var $e176d22eecb6513b$export$2e2bcd8739ae039 = $e176d22eecb6513b$var$AutoConfirmationModal;




const $176f5b109efcc939$var$ShiftCard = ({ shiftData: shiftData, showLimitedTimeModal: showLimitedTimeModal })=>{
    const [modalIsOpen, setIsOpen] = (0, $acw62.useState)(false);
    const { t: t } = (0, $3765cebd031b52c0$export$9fc83ad70ead8663)();
    function openModal() {
        if (showLimitedTimeModal) setIsOpen(true);
    }
    function closeModal() {
        setIsOpen(false);
    }
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "ShiftCard",
                children: [
                    shiftData.time_to_auto_confirm != null && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("h6", {
                        onClick: openModal,
                        className: "ShiftCard__leftTime",
                        children: [
                            shiftData.time_to_auto_confirm <= 0 ? t("shift_attendance_common.urgent") : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                                children: [
                                    Math.floor(shiftData.time_to_auto_confirm / 3600),
                                    " :",
                                    t("shift_attendance_common.hours_left", {
                                        count: Math.floor(shiftData.time_to_auto_confirm % 3600 / 60)
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                                src: (0, (/*@__PURE__*/$parcel$interopDefault($af6db54c20ce46fa$exports)))
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("h5", {
                        className: "ShiftCard__name",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                children: shiftData.work_category_name
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $660b2ca422e0e2ae$export$1ff3c3f08ae963c0).Horizontal, {
                                width: 5
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                className: "ShiftCard__name__amount",
                                children: [
                                    "(",
                                    shiftData.pending_shifts,
                                    ")"
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "ShiftCard__details",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                                src: (0, (/*@__PURE__*/$parcel$interopDefault($cab7dbc8172ddafd$exports)))
                            }),
                            shiftData.client_location_name
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "ShiftCard__details",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                                src: (0, (/*@__PURE__*/$parcel$interopDefault($bad31fa192b525ae$exports)))
                            }),
                            (0, (/*@__PURE__*/$parcel$interopDefault($45fvw)))(shiftData.start_time).format("HH:mm"),
                            " - ",
                            (0, (/*@__PURE__*/$parcel$interopDefault($45fvw)))(shiftData.end_time).format("HH:mm"),
                            ",",
                            " ",
                            (0, (/*@__PURE__*/$parcel$interopDefault($45fvw)))(shiftData.start_time).format("DD MMM")
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e176d22eecb6513b$export$2e2bcd8739ae039), {
                closeModal: closeModal,
                modalIsOpen: modalIsOpen
            })
        ]
    });
};
var $176f5b109efcc939$export$2e2bcd8739ae039 = $176f5b109efcc939$var$ShiftCard;






const $fcab425d9daee0f5$var$ShiftConfirmed = ({ closeConfirmation: closeConfirmation })=>{
    const { t: t } = (0, $3765cebd031b52c0$export$9fc83ad70ead8663)();
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        className: "ShiftConfirmed",
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
            className: "ShiftConfirmed__container",
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                    src: (0, (/*@__PURE__*/$parcel$interopDefault($e3993b62a3e754bd$exports)))
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h2", {
                    className: "ShiftConfirmed__modalTitle",
                    children: t("shift_attendance_common.attendance_confirmed")
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                    children: t("shift_attendance_common.thanks_for_confirming")
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                    onClick: closeConfirmation,
                    className: "ShiftConfirmed__closeButton",
                    children: t("shift_attendance_common.done")
                })
            ]
        })
    });
};
var $fcab425d9daee0f5$export$2e2bcd8739ae039 = $fcab425d9daee0f5$var$ShiftConfirmed;




var $45fvw = parcelRequire("45fvw");

var $acw62 = parcelRequire("acw62");

var $b684288ffe9c79fd$exports = {};
$b684288ffe9c79fd$exports = new URL("not-attended-icon.fbd22a99.svg", import.meta.url).toString();












const $0c8da1601359ad2b$export$bea8ebba691c5813 = ({ active: active, onToggle: onToggle })=>{
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        onClick: onToggle,
        className: `AttendanceCard__Toggle ${active ? "AttendanceCard__Toggle--active" : ""}`,
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "AttendanceCard__Toggle__background"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "AttendanceCard__Toggle__switch"
            })
        ]
    });
};



const $7cc36798d8223d6c$var$AttendanceCard = ({ attendanceShift: attendanceShift, job: job, onUpdate: onUpdate })=>{
    const [attendanceState, setAttendanceState] = (0, $acw62.useState)(Boolean(attendanceShift.client_checkin_time) && Boolean(attendanceShift.client_checkout_time));
    const isActiveShift = attendanceShift.status_id === 8;
    const [shift, setShift] = (0, $acw62.useState)(attendanceShift);
    const [selectedReason, setSelectedReason] = (0, $acw62.useState)((0, $726e391db8a1d625$export$c048ab2a4e893657));
    const [shiftCheckInTime, setShiftCheckInTime] = (0, $acw62.useState)(()=>{
        const time = shift.client_checkin_time ?? job.start_time;
        return time ? (0, (/*@__PURE__*/$parcel$interopDefault($45fvw)))(time, "YYYY-MM-DD hh:mm:ss").format("HH:mm") : null;
    });
    const [shiftCheckOutTime, setShiftCheckOutTime] = (0, $acw62.useState)(()=>{
        const time = shift.client_checkout_time ?? job.end_time;
        return time ? (0, (/*@__PURE__*/$parcel$interopDefault($45fvw)))(time, "YYYY-MM-DD hh:mm:ss").format("HH:mm") : null;
    });
    const [showTimeErrorMessage, setShowTimeErrorMessage] = (0, $acw62.useState)(false);
    const [durationWarningText, setDurationWarningText] = (0, $acw62.useState)(null);
    const { cancelReasons: cancelReasons } = (0, $4671947198ddd366$export$6ccbb43953eebf8)().data;
    (0, $acw62.useEffect)(()=>{
        const checkInTimeMoment = (0, (/*@__PURE__*/$parcel$interopDefault($45fvw)))(shiftCheckInTime, "HH:mm");
        const checkOutTimeMoment = (0, (/*@__PURE__*/$parcel$interopDefault($45fvw)))(shiftCheckOutTime, "HH:mm");
        if (checkInTimeMoment.diff(checkOutTimeMoment, "h") > 0) checkOutTimeMoment.add(1, "day");
        const diff = Number(checkOutTimeMoment.diff(checkInTimeMoment, "h", true).toFixed(1));
        setShowTimeErrorMessage(diff > 12);
    }, [
        shiftCheckInTime,
        shiftCheckOutTime
    ]);
    const { t: t } = (0, $3765cebd031b52c0$export$9fc83ad70ead8663)();
    const redirect = (0, $7df35e9df335b1c8$export$602eaf6d5314ce55)();
    const toggleActiveState = ()=>{
        setAttendanceState(false);
        onUpdate({
            id: attendanceShift.id,
            action: "cancel",
            reason: cancelReasons.find((reason)=>reason.name.toLowerCase() === "no show")?.id
        });
    };
    function openSPProfile(spId, spName) {
        return redirect((0, $0534349ae8731d0b$export$66b32f6f30eb4b4).applicantDetails, {
            jobId: String(job.job_id),
            type: (0, $862a04ca6e0d681b$export$27a7f855854fa13d).oneTime,
            applicantId: String(spId),
            applicantName: spName
        });
    }
    function updateAttendanceTimeWithWarning(checkInTime, checkOutTime) {
        const checkinTime = (0, (/*@__PURE__*/$parcel$interopDefault($45fvw)))(checkInTime, "HH:mm");
        const checkoutTime = (0, (/*@__PURE__*/$parcel$interopDefault($45fvw)))(checkOutTime, "HH:mm");
        const duration = (0, (/*@__PURE__*/$parcel$interopDefault($45fvw))).duration(checkoutTime.diff(checkinTime));
        let hoursDuration = duration.asHours();
        let minutesDuration = duration.asMinutes();
        // handle crossing am/pm and vice-versa:
        if (hoursDuration < 0) hoursDuration = hoursDuration + 24;
        if (minutesDuration < 0) minutesDuration = minutesDuration + 1440;
        const jobDuration = Number(new Date(job.end_time)) - Number(new Date(job.start_time));
        const jobHoursDuration = jobDuration / 3600000;
        const jobMinutesDuration = jobDuration / 60000;
        if (minutesDuration < jobMinutesDuration) {
            const hoursDiff = (Number(jobHoursDuration) - hoursDuration).toFixed(2);
            setDurationWarningText(t("shift_attendance_common.are_you_sure_og_worked_n_hours", {
                name: attendanceShift.sp.name,
                hours: hoursDuration,
                difference: hoursDiff
            }));
        }
        setDurationWarningText(null);
        updateAttendanceTime(checkInTime, checkOutTime);
    }
    function updateAttendanceTime(checkInTime, checkOutTime) {
        const shiftCheckInDate = (0, (/*@__PURE__*/$parcel$interopDefault($45fvw)))(shift.client_checkin_time ? shift.client_checkin_time : job.start_time);
        const shiftCheckOutDate = (0, (/*@__PURE__*/$parcel$interopDefault($45fvw)))(shift.client_checkin_time ? shift.client_checkin_time : job.end_time) // reseting the checkout date as check in date
        ;
        const checkInTimeMoment = (0, (/*@__PURE__*/$parcel$interopDefault($45fvw)))(checkInTime, "HH:mm");
        const checkOutTimeMoment = (0, (/*@__PURE__*/$parcel$interopDefault($45fvw)))(checkOutTime, "HH:mm");
        setAttendanceState(true);
        shiftCheckInDate.set({
            hour: checkInTimeMoment.get("hour"),
            minute: checkInTimeMoment.get("minute")
        });
        shiftCheckOutDate.set({
            hour: checkOutTimeMoment.get("hour"),
            minute: checkOutTimeMoment.get("minute")
        });
        if (shiftCheckOutDate.isBefore(shiftCheckInDate)) shiftCheckOutDate.add(1, "day");
        onUpdate({
            check_in_time: shiftCheckInDate.format("YYYY-MM-DD HH:mm:ss"),
            check_out_time: shiftCheckOutDate.format("YYYY-MM-DD HH:mm:ss"),
            action: "confirm",
            id: shift.id
        });
        setShift((prevShift)=>({
                ...prevShift,
                client_checkin_time: shiftCheckInDate.format("YYYY-MM-DD HH:mm"),
                client_checkout_time: shiftCheckOutDate.format("YYYY-MM-DD HH:mm")
            }));
    }
    const calculateShiftHours = ()=>{
        const checkInMoment = (0, (/*@__PURE__*/$parcel$interopDefault($45fvw)))(shift.client_checkin_time);
        const checkOutMoment = (0, (/*@__PURE__*/$parcel$interopDefault($45fvw)))(shift.client_checkout_time);
        return `${checkOutMoment.diff(checkInMoment, "h", true).toFixed(1)} h`;
    };
    const submitAttendanceTime = (checkInTime, checkOutTime)=>{
        updateAttendanceTimeWithWarning(checkInTime, checkOutTime);
    };
    const handleReasonChange = (value)=>{
        setSelectedReason(Number(value));
        onUpdate({
            id: attendanceShift.id,
            action: "cancel",
            reason: Number(value)
        });
    };
    const cancelReasonOptions = cancelReasons.map((cancelReason)=>({
            key: String(cancelReason.id),
            label: cancelReason.name,
            value: String(cancelReason.id)
        }));
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "AttendanceCard",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "AttendanceCard__container",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "AttendanceCard__data",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                onClick: ()=>openSPProfile(shift.sp.id, shift.sp.name),
                                className: "AttendanceCard__avatar",
                                style: {
                                    backgroundImage: `url(${shift.sp.image})`
                                }
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "AttendanceCard__basic",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h4", {
                                        onClick: ()=>openSPProfile(shift.sp.id, shift.sp.name),
                                        children: shift.sp.name
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                        className: "AttendanceCard__time",
                                        children: attendanceState ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                            children: [
                                                (0, (/*@__PURE__*/$parcel$interopDefault($45fvw)))(shift.client_checkin_time).format((0, $ddf12117b815a7c3$export$94f4d87fad5dcf9a)),
                                                " -",
                                                " ",
                                                (0, (/*@__PURE__*/$parcel$interopDefault($45fvw)))(shift.client_checkout_time).format((0, $ddf12117b815a7c3$export$94f4d87fad5dcf9a)),
                                                " (",
                                                calculateShiftHours(),
                                                ")"
                                            ]
                                        }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                                                    src: (0, (/*@__PURE__*/$parcel$interopDefault($b684288ffe9c79fd$exports)))
                                                }),
                                                " ",
                                                cancelReasons.find((reason)=>reason.id === Number(selectedReason))?.name || t("shift_attendance_common.day_off")
                                            ]
                                        })
                                    })
                                ]
                            })
                        ]
                    }),
                    isActiveShift && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "AttendanceCard__attendance",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                className: `AttendanceCard__attendance__title ${attendanceState ? "AttendanceCard__attendance__title--attended" : null}`,
                                children: attendanceState ? t("shifts_attendance_details.attended") : t("shifts_attendance_details.not_attended")
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $0c8da1601359ad2b$export$bea8ebba691c5813), {
                                active: attendanceState,
                                onToggle: ()=>{
                                    if (attendanceState) {
                                        toggleActiveState();
                                        return;
                                    }
                                    submitAttendanceTime(shiftCheckInTime, shiftCheckOutTime);
                                }
                            })
                        ]
                    })
                ]
            }),
            isActiveShift && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "AttendanceCard__actions",
                children: [
                    attendanceState ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "AttendanceCard__timeForm__container",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "AttendanceCard__timeForm__inputs",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5ce1d5308946b7cc$export$a1af6f79df847fac), {
                                        label: t("shift_attendance_common.check_in"),
                                        value: shiftCheckInTime,
                                        handleChange: (time)=>{
                                            setShiftCheckInTime(time);
                                            submitAttendanceTime(time, shiftCheckOutTime);
                                        },
                                        className: "AttendanceCard__timeForm__input"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5ce1d5308946b7cc$export$a1af6f79df847fac), {
                                        label: t("shift_attendance_common.check_out"),
                                        value: shiftCheckOutTime,
                                        handleChange: (time)=>{
                                            setShiftCheckOutTime(time);
                                            submitAttendanceTime(shiftCheckInTime, time);
                                        },
                                        className: "AttendanceCard__timeForm__input"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "AttendanceCard__timeForm__total",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                        className: "AttendanceCard__timeForm__total__title",
                                        children: t("shift_attendance_common.total_hours")
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                        className: "AttendanceCard__timeForm__total__value",
                                        children: calculateShiftHours()
                                    })
                                ]
                            })
                        ]
                    }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "AttendanceCard__cancelForm__container",
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f2c1b8699595d8c0$export$ef9b1a59e592288f), {
                            value: String(selectedReason),
                            onChange: handleReasonChange,
                            className: "AttendanceCard__cancelForm__select",
                            label: t("shift_attendance_common.select_reason"),
                            options: cancelReasonOptions
                        })
                    }),
                    attendanceState && showTimeErrorMessage && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                        className: "AttendanceCard__error",
                        children: t("shift_attendance_common.shift_duration_too_long")
                    }),
                    attendanceState && durationWarningText && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                        className: "AttendanceCard__warning",
                        children: durationWarningText
                    })
                ]
            })
        ]
    });
};
var $7cc36798d8223d6c$export$2e2bcd8739ae039 = $7cc36798d8223d6c$var$AttendanceCard;









var $acw62 = parcelRequire("acw62");











var $acw62 = parcelRequire("acw62");




const $75ef3dbb0090cbb1$export$ded2298abc2a0f4 = (0, $aca50e9407ba89c9$export$b6ae1bc530f4c149)(({ sp: sp, changeRating: changeRating })=>{
    const [rating, setRating] = (0, $acw62.useState)(sp.rating);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        className: "SPItem",
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
            className: "SPItem__body",
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                    className: "SPItem__body__image",
                    src: String(sp.image_url)
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: "SPItem__content",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                            className: "SPItem__titleContainer",
                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                className: "SPItem__title",
                                children: sp.name
                            })
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $660b2ca422e0e2ae$export$1ff3c3f08ae963c0).Vertical, {
                            height: 10
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $647b8b1a309a1295$export$2e2bcd8739ae039), {
                            rating: Number(rating),
                            size: 25,
                            editable: true,
                            onRatingChange: (value)=>{
                                setRating(value);
                                changeRating(value);
                            }
                        })
                    ]
                })
            ]
        })
    }, sp.id);
});


const $620834d1c62fc3f0$export$a59616d8c1db77c4 = (0, $aca50e9407ba89c9$export$b6ae1bc530f4c149)(({ jobId: jobId, isActive: isActive, onClose: onClose, getSPsToRateRequest: getSPsToRateRequest, spsToRateList: spsToRateList, spsToRateNextPage: spsToRateNextPage, isLoadingSPs: isLoadingSPs })=>{
    const [atLeastOneOGRated, setAtLeastOneOGRated] = (0, $acw62.useState)(false);
    const [quantityOfOGsRated, setQuantityOfOGsRated] = (0, $acw62.useState)(0);
    const { t: t } = (0, $3765cebd031b52c0$export$9fc83ad70ead8663)();
    const { setSPLastJobRating: setSPLastJobRating } = (0, $4671947198ddd366$export$6ccbb43953eebf8)().data;
    const [, setSPLastJobRatingRequest] = (0, $4671947198ddd366$export$609860bf8b0084c)(({ spId: spId, rating: rating })=>setSPLastJobRating(spId, rating, null, null, jobId), {
        onSuccess: (result)=>{
            (0, $c74a0566d4b0fd6d$export$e9db7d6e73593439).track((0, $c74a0566d4b0fd6d$export$5e27155e276f6d1c).RatingSetAfterAttendanceReview);
            if (!atLeastOneOGRated) setAtLeastOneOGRated(true);
            setQuantityOfOGsRated((prevState)=>prevState + 1);
        },
        onError: (err)=>{
            (0, $60f27fc97e29822a$export$b410431fab84fa58).error(err.data.errors?.note[0]);
        },
        filterError: [
            (0, $9ad33fbf770c55a1$export$9696fcf1798e1cb5).ClientError,
            (0, $9ad33fbf770c55a1$export$9696fcf1798e1cb5).NotFound
        ]
    });
    (0, $acw62.useEffect)(()=>{
        if (isActive) (0, $c74a0566d4b0fd6d$export$e9db7d6e73593439).track((0, $c74a0566d4b0fd6d$export$5e27155e276f6d1c).RatingPopupAfterAttendanceReviewShown);
    }, [
        isActive
    ]);
    (0, $acw62.useEffect)(()=>{
        if (atLeastOneOGRated) (0, $c74a0566d4b0fd6d$export$e9db7d6e73593439).track((0, $c74a0566d4b0fd6d$export$5e27155e276f6d1c).RatingSetAfterAttendanceReviewAtLeastOnce);
    }, [
        atLeastOneOGRated
    ]);
    (0, $acw62.useEffect)(()=>{
        if (quantityOfOGsRated > 0 && quantityOfOGsRated === spsToRateList.length) (0, $c74a0566d4b0fd6d$export$e9db7d6e73593439).track((0, $c74a0566d4b0fd6d$export$5e27155e276f6d1c).RatingSetAfterAttendanceReviewForAllOGs);
    }, [
        quantityOfOGsRated
    ]);
    const handleScroll = (0, $324dc7daf4e64dab$export$5bd4c3b2b0a1aaf1)(()=>{
        if (spsToRateNextPage) getSPsToRateRequest({
            collect: true,
            jobId: jobId
        });
    });
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $9c16b10bbbe042e5$export$129a32eedafa97c5), {
        isActive: isActive,
        content: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
            className: "SpRatingPopup",
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                    className: "SpRatingPopup__title",
                    children: t("rating_popup.title")
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: "SpRatingPopup__alert",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                            src: (0, (/*@__PURE__*/$parcel$interopDefault($1208166956fe3e01$exports)))
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                            className: "SpRatingPopup__alert__text",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                    className: "SpRatingPopup__alert__text__highlight",
                                    children: t("rating_popup.subtitle_1")
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                    className: "SpRatingPopup__alert__text__common",
                                    children: t("rating_popup.subtitle_2")
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                    className: "SpRatingPopup__sectionTitle",
                    children: t("rating_popup.ogs_to_rate")
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: "SpRatingPopup__spList",
                    onScroll: handleScroll,
                    children: [
                        spsToRateList.map((sp)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $75ef3dbb0090cbb1$export$ded2298abc2a0f4), {
                                sp: sp,
                                changeRating: (rating)=>setSPLastJobRatingRequest({
                                        spId: sp.id,
                                        rating: rating
                                    })
                            }, sp.id)),
                        isLoadingSPs && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $57fb8f45c69e1681$export$2e2bcd8739ae039), {})
                    ]
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $2c46e9e1f89bee75$export$2b47962e4e24eb4d), {
                    text: t("common.done"),
                    action: onClose
                })
            ]
        }),
        close: onClose
    });
});



const $bb55abd8e9be7da4$var$ShiftAttendanceItem = (0, $aca50e9407ba89c9$export$b6ae1bc530f4c149)(({ shift: shift, cancelReasonsLoaded: cancelReasonsLoaded })=>{
    const { cancelReasons: cancelReasons, updateAttendanceReportShift: updateAttendanceReportShift, getSPsToRate: getSPsToRate, spsToRateList: spsToRateList, spsToRateNextPage: spsToRateNextPage } = (0, $4671947198ddd366$export$6ccbb43953eebf8)().data;
    const [attendanceData, setAttendanceData] = (0, $acw62.useState)([]);
    const [showConfirmationScreen, setShowConfirmationScreen] = (0, $acw62.useState)(false);
    const [withRatingPopup, setWithRatingPopup] = (0, $acw62.useState)(false);
    const [attendedCount, setAttendedCount] = (0, $acw62.useState)(0);
    const [notAttendedCount, setNotAttendedCount] = (0, $acw62.useState)(0);
    const [updateShiftAttendanceStatus, updateAttendance] = (0, $4671947198ddd366$export$609860bf8b0084c)(updateAttendanceReportShift, {
        onSuccess: ()=>setShowConfirmationScreen(true),
        filterError: [
            (0, $9ad33fbf770c55a1$export$9696fcf1798e1cb5).ClientError
        ]
    });
    const [getSPsToRateStatus, getSPsToRateRequest] = (0, $4671947198ddd366$export$609860bf8b0084c)(({ collect: collect, page: page, jobId: jobId })=>getSPsToRate({
            collect: collect,
            jobId: jobId,
            page: page ?? spsToRateNextPage ?? 1
        }), {
        onError: (err)=>{
            (0, $60f27fc97e29822a$export$b410431fab84fa58).error(err.data.errors?.note[0]);
        },
        filterError: [
            (0, $9ad33fbf770c55a1$export$9696fcf1798e1cb5).ClientError,
            (0, $9ad33fbf770c55a1$export$9696fcf1798e1cb5).NotFound
        ]
    });
    (0, $acw62.useEffect)(()=>{
        if (!cancelReasonsLoaded || !cancelReasons.length) return;
        setAttendedCount(shift.active_shifts.filter((s)=>Boolean(s.client_checkin_time)).length);
        setNotAttendedCount(shift.active_shifts.filter((s)=>!s.client_checkin_time).length);
        setAttendanceData(initiateShiftAttendance());
    }, [
        cancelReasonsLoaded
    ]);
    (0, $acw62.useEffect)(()=>{
        if (shift.job_id && showConfirmationScreen) getSPsToRateRequest({
            collect: false,
            page: 1,
            jobId: shift.job_id
        });
    }, [
        showConfirmationScreen
    ]);
    (0, $acw62.useEffect)(()=>{
        if (!showConfirmationScreen) return;
        const unratedSPsCount = spsToRateList.filter((sp)=>sp.rating === null).length;
        setWithRatingPopup(Boolean(unratedSPsCount));
    }, [
        spsToRateList,
        showConfirmationScreen
    ]);
    const { t: t } = (0, $3765cebd031b52c0$export$9fc83ad70ead8663)();
    function initiateShiftAttendance() {
        return shift.active_shifts.map((activeShift)=>{
            if (activeShift.client_checkin_time && activeShift.client_checkout_time) return {
                id: activeShift.id,
                check_in_time: activeShift.client_checkin_time,
                check_out_time: activeShift.client_checkout_time,
                action: "confirm"
            };
            return {
                id: activeShift.id,
                action: "cancel",
                reason: cancelReasons.find((reason)=>reason.id === (0, $726e391db8a1d625$export$c048ab2a4e893657))?.id
            };
        });
    }
    const retrieveAttendanceData = (shiftAttendanceData)=>{
        const existedAttendanceData = attendanceData.find((data)=>data.id === shiftAttendanceData.id);
        if (existedAttendanceData.action !== shiftAttendanceData.action) {
            if (shiftAttendanceData.action === "cancel") {
                setAttendedCount((count)=>count - 1 >= 0 ? count - 1 : 0);
                setNotAttendedCount((count)=>count + 1);
            } else if (shiftAttendanceData.action === "confirm") {
                setAttendedCount((count)=>count + 1);
                setNotAttendedCount((count)=>count - 1 >= 0 ? count - 1 : 0);
            }
        }
        setAttendanceData((data)=>{
            data[data.indexOf(existedAttendanceData)] = shiftAttendanceData;
            return [
                ...data
            ];
        });
    };
    const confirmShift = ()=>updateAttendance({
            shifts: attendanceData
        });
    if (showConfirmationScreen && !withRatingPopup) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "ShiftAttendanceItem ShiftAttendanceItem--confirmed",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $176f5b109efcc939$export$2e2bcd8739ae039), {
                showLimitedTimeModal: true,
                shiftData: shift
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "ShiftAttendanceItem__confirmedInline",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $fcab425d9daee0f5$export$2e2bcd8739ae039), {
                    closeConfirmation: ()=>{}
                })
            })
        ]
    });
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "ShiftAttendanceItem",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $176f5b109efcc939$export$2e2bcd8739ae039), {
                            showLimitedTimeModal: true,
                            shiftData: shift
                        })
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "ShiftAttendanceItem__attendanceList",
                        children: shift.active_shifts.map((activeShift)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7cc36798d8223d6c$export$2e2bcd8739ae039), {
                                onUpdate: retrieveAttendanceData,
                                attendanceShift: activeShift,
                                job: shift
                            }, activeShift.id))
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "ShiftAttendanceItem__confirm",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "ShiftAttendanceItem__attendanceCount",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                                                src: (0, (/*@__PURE__*/$parcel$interopDefault($8eedc87ae1272247$exports)))
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                                children: attendedCount
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                                children: [
                                                    " ",
                                                    t("shifts_attendance_details.attended")
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                                                src: (0, (/*@__PURE__*/$parcel$interopDefault($3ad7df9a596be88f$exports)))
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                                children: notAttendedCount
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                                children: [
                                                    " ",
                                                    t("shifts_attendance_details.did_not")
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            }),
                            updateShiftAttendanceStatus.isLoading ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                disabled: true,
                                className: "ShiftAttendanceItem__confirmButton",
                                children: t("shifts_attendance_details.confirm_amount", {
                                    count: shift.active_shifts.length
                                })
                            }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                onClick: confirmShift,
                                className: "ShiftAttendanceItem__confirmButton",
                                children: t("shifts_attendance_details.confirm_amount", {
                                    count: shift.active_shifts.length
                                })
                            })
                        ]
                    })
                ]
            }),
            Boolean(spsToRateList.length > 0) && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $620834d1c62fc3f0$export$a59616d8c1db77c4), {
                jobId: shift.job_id,
                isActive: showConfirmationScreen && withRatingPopup,
                onClose: ()=>{
                    setWithRatingPopup(false);
                },
                getSPsToRateRequest: getSPsToRateRequest,
                spsToRateList: spsToRateList,
                spsToRateNextPage: spsToRateNextPage,
                isLoadingSPs: getSPsToRateStatus.isLoading
            })
        ]
    });
});
var $bb55abd8e9be7da4$export$2e2bcd8739ae039 = $bb55abd8e9be7da4$var$ShiftAttendanceItem;







var $i56po = parcelRequire("i56po");
const $77ee8ec623c1d743$var$ShiftsList = (0, $i56po.types).model("OrdersList", {
    searchFilters: (0, $i56po.types).model({
        locationId: (0, $i56po.types).maybeNull((0, $i56po.types).number),
        workCategoryId: (0, $i56po.types).maybeNull((0, $i56po.types).number)
    })
}).actions((self)=>({
        setLocationId (locationId) {
            self.searchFilters.locationId = locationId;
        },
        setWorkCategoryId (workCategoryId) {
            self.searchFilters.workCategoryId = workCategoryId;
        },
        reset () {
            self.searchFilters.locationId = null;
            self.searchFilters.workCategoryId = null;
        }
    })).views((self)=>({
        get activeFiltersCount () {
            return [
                self.searchFilters.locationId,
                self.searchFilters.workCategoryId
            ].filter((value)=>Boolean(value)).length;
        }
    }));
const $77ee8ec623c1d743$export$f99c44113fd9aa5a = $77ee8ec623c1d743$var$ShiftsList.create({
    searchFilters: {
        locationId: null,
        workCategoryId: null
    }
});










const $fb7c41e5d7ebe051$var$ALL_LOCATIONS = -1;
const $fb7c41e5d7ebe051$export$6ef94fcf2b71ab35 = (0, $aca50e9407ba89c9$export$b6ae1bc530f4c149)(({ onLocationChange: onLocationChange })=>{
    const { t: t } = (0, $3765cebd031b52c0$export$9fc83ad70ead8663)();
    const { locationsDataView: locationsDataView, getLocations: getLocations } = (0, $4671947198ddd366$export$6ccbb43953eebf8)().data;
    const { isLoading: isLoading } = (0, $4671947198ddd366$export$dd0a697e1782aedd)(()=>getLocations({}));
    const locationOptions = [
        {
            key: String($fb7c41e5d7ebe051$var$ALL_LOCATIONS),
            label: t("calendar.all_locations"),
            value: $fb7c41e5d7ebe051$var$ALL_LOCATIONS
        },
        ...locationsDataView.map((location)=>({
                key: String(location.id),
                label: location.name,
                value: location.id
            }))
    ];
    if (isLoading) return null;
    const currentValue = (0, $77ee8ec623c1d743$export$f99c44113fd9aa5a).searchFilters.locationId ?? $fb7c41e5d7ebe051$var$ALL_LOCATIONS;
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        className: "ShiftsLocationFilter",
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f2c1b8699595d8c0$export$ef9b1a59e592288f), {
            value: currentValue,
            options: locationOptions,
            onChange: (value)=>{
                (0, $77ee8ec623c1d743$export$f99c44113fd9aa5a).setLocationId(value === $fb7c41e5d7ebe051$var$ALL_LOCATIONS ? null : value);
                onLocationChange();
            },
            className: "ShiftsLocationFilter__select"
        })
    });
});










const $8ffe1c5080209b6a$var$ALL_DESIGNATIONS = -1;
const $8ffe1c5080209b6a$export$b45432a29f6afcb0 = (0, $aca50e9407ba89c9$export$b6ae1bc530f4c149)(({ onDesignationChange: onDesignationChange })=>{
    const { t: t } = (0, $3765cebd031b52c0$export$9fc83ad70ead8663)();
    const { professionList: professionList, getProfessions: getProfessions } = (0, $4671947198ddd366$export$6ccbb43953eebf8)().data;
    const { isLoading: isLoading } = (0, $4671947198ddd366$export$dd0a697e1782aedd)(()=>getProfessions({}), {
        filterError: [
            (0, $9ad33fbf770c55a1$export$9696fcf1798e1cb5).ClientError
        ]
    });
    const options = [
        {
            key: String($8ffe1c5080209b6a$var$ALL_DESIGNATIONS),
            label: t("shifts_attendance_list.all_designations"),
            value: $8ffe1c5080209b6a$var$ALL_DESIGNATIONS
        },
        ...professionList.map((profession)=>({
                key: String(profession.id),
                label: profession.name,
                value: profession.id
            }))
    ];
    if (isLoading) return null;
    const currentValue = (0, $77ee8ec623c1d743$export$f99c44113fd9aa5a).searchFilters.workCategoryId ?? $8ffe1c5080209b6a$var$ALL_DESIGNATIONS;
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        className: "ShiftsDesignationFilter",
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f2c1b8699595d8c0$export$ef9b1a59e592288f), {
            value: currentValue,
            options: options,
            onChange: (value)=>{
                (0, $77ee8ec623c1d743$export$f99c44113fd9aa5a).setWorkCategoryId(value === $8ffe1c5080209b6a$var$ALL_DESIGNATIONS ? null : value);
                onDesignationChange();
            },
            className: "ShiftsDesignationFilter__select"
        })
    });
});



const $2c29f705efa4c7db$export$413d3fe3f69ffdde = ({ onChange: onChange })=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "ShiftsFilters",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $fb7c41e5d7ebe051$export$6ef94fcf2b71ab35), {
                onLocationChange: onChange
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $8ffe1c5080209b6a$export$b45432a29f6afcb0), {
                onDesignationChange: onChange
            })
        ]
    });


const $f790b4cddcb46dea$var$ShiftsList = (0, $a4963babae245ff9$export$f0c7a449e0cfaec7)((0, $aca50e9407ba89c9$export$b6ae1bc530f4c149)(()=>{
    const { fetchAttendanceReportJob: fetchAttendanceReportJob, attendanceReportJobView: attendanceReportJobView, fetchShiftCancelReasons: fetchShiftCancelReasons } = (0, $4671947198ddd366$export$6ccbb43953eebf8)().data;
    const shifts = attendanceReportJobView();
    const [getShiftsResult, getShiftsQuery] = (0, $4671947198ddd366$export$609860bf8b0084c)(()=>fetchAttendanceReportJob({
            clientLocationId: (0, $77ee8ec623c1d743$export$f99c44113fd9aa5a).searchFilters.locationId,
            workCategoryId: (0, $77ee8ec623c1d743$export$f99c44113fd9aa5a).searchFilters.workCategoryId
        }), {
        filterError: [
            (0, $9ad33fbf770c55a1$export$9696fcf1798e1cb5).ClientError
        ]
    });
    const fetchCancelReasonsQuery = (0, $4671947198ddd366$export$dd0a697e1782aedd)(fetchShiftCancelReasons);
    (0, $acw62.useEffect)(()=>{
        getShiftsQuery({});
    }, []);
    const { t: t } = (0, $3765cebd031b52c0$export$9fc83ad70ead8663)();
    const cancelReasonsLoaded = !fetchCancelReasonsQuery.isLoading;
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7b02d682eb115277$exports.Fragment), {
        children: getShiftsResult.isLoading ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $57fb8f45c69e1681$export$2e2bcd8739ae039), {}) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
            className: "ShiftsList",
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7ae42b63183f30b4$export$8b251419efc915eb), {
                    title: t("shifts_attendance_list.title")
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $660b2ca422e0e2ae$export$1ff3c3f08ae963c0).Vertical, {
                    height: 28
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $2c29f705efa4c7db$export$413d3fe3f69ffdde), {
                    onChange: ()=>getShiftsQuery({})
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $660b2ca422e0e2ae$export$1ff3c3f08ae963c0).Vertical, {
                    height: 16
                }),
                shifts.length ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                    className: "ShiftsList__list",
                    children: shifts.map((shift)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                            className: "ShiftsList__shiftItem",
                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $bb55abd8e9be7da4$export$2e2bcd8739ae039), {
                                shift: shift,
                                cancelReasonsLoaded: cancelReasonsLoaded
                            })
                        }, shift.id))
                }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                    className: "ShiftsList__hint",
                    children: t("shifts_attendance_list.empty_list")
                })
            ]
        })
    });
}));
var $f790b4cddcb46dea$export$2e2bcd8739ae039 = $f790b4cddcb46dea$var$ShiftsList;





var $acw62 = parcelRequire("acw62");


var $45fvw = parcelRequire("45fvw");



var $2d4024423d397f92$exports = {};
$2d4024423d397f92$exports = new URL("arrow-right.7d2681af.svg", import.meta.url).toString();
















var $0eb31e101faeae36$exports = {};
$0eb31e101faeae36$exports = new URL("arrow-left.56839720.svg", import.meta.url).toString();


var $5b646a0e3eab2cd4$exports = {};
$5b646a0e3eab2cd4$exports = new URL("checkmark.00948793.svg", import.meta.url).toString();


var $bfac4ceb18ac4357$exports = {};
$bfac4ceb18ac4357$exports = new URL("scanner-white.e4364804.svg", import.meta.url).toString();





const $87fc7e7d5c3dee30$export$2113e0e46f231d60 = ({ isSuccessModalVisible: isSuccessModalVisible, isCheckin: isCheckin, setShowQRScanner: setShowQRScanner })=>{
    const redirect = (0, $7df35e9df335b1c8$export$602eaf6d5314ce55)();
    const { t: t } = (0, $3765cebd031b52c0$export$9fc83ad70ead8663)();
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c786671f641538e1$export$446bb0a5366f9068), {
        overlayStyle: {
            overflow: "hidden"
        },
        contentStyle: {
            overflow: "hidden"
        },
        modalVisible: isSuccessModalVisible,
        onClose: ()=>{},
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
            className: "QrAttendance__success",
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    onClick: ()=>redirect((0, $0534349ae8731d0b$export$66b32f6f30eb4b4).index, {}),
                    className: "QrAttendance__success__back",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                            src: (0, (/*@__PURE__*/$parcel$interopDefault($0eb31e101faeae36$exports)))
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                            children: t("sidebar.home")
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                    className: "QrAttendance__success__checkmark",
                    src: (0, (/*@__PURE__*/$parcel$interopDefault($5b646a0e3eab2cd4$exports)))
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                    className: "QrAttendance__success__text",
                    children: t("qr_scan.success_modal_text", {
                        processTitle: isCheckin ? t("shift_attendance_common.check_in") : t("shift_attendance_common.check_out")
                    })
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("button", {
                    onClick: ()=>setShowQRScanner(true),
                    className: "QrAttendance__success__primaryAction",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                            src: (0, (/*@__PURE__*/$parcel$interopDefault($bfac4ceb18ac4357$exports)))
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                            children: t("qr_scan.scan_next_qr")
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                    onClick: ()=>redirect((0, $0534349ae8731d0b$export$66b32f6f30eb4b4).allJobs, {
                            date: (0, $ddf12117b815a7c3$export$efb113ee57e9edfb)(new Date())
                        }),
                    className: "QrAttendance__success__secondaryAction",
                    children: t("sidebar.all_jobs")
                })
            ]
        })
    });
};



const $a55d557e26ea1685$export$aed3011d91e6126 = (0, $a4963babae245ff9$export$f0c7a449e0cfaec7)((0, $aca50e9407ba89c9$export$b6ae1bc530f4c149)(({ spId: spId })=>{
    const { t: t } = (0, $3765cebd031b52c0$export$9fc83ad70ead8663)();
    const { qrAttendance: qrAttendance, getCheckinEligibility: getCheckinEligibility, checkInOgrammerWithQR: checkInOgrammerWithQR, checkOutOgrammerWithQR: checkOutOgrammerWithQR } = (0, $4671947198ddd366$export$6ccbb43953eebf8)().data;
    const [value, setValue] = (0, $acw62.useState)(null);
    const [isSuccessModalVisible, setIsSuccessModalVisible] = (0, $acw62.useState)(false);
    const { isLoading: isQrAttendanceLoading } = (0, $4671947198ddd366$export$dd0a697e1782aedd)(()=>getCheckinEligibility({
            spId: spId
        }), {
        onSuccess: (res)=>{
            const currentUnixInOriginLocale = Date.now() / 1000 + res.timezone_offset + (0, $ddf12117b815a7c3$export$81fa0da0c2fba503);
            setValue((0, (/*@__PURE__*/$parcel$interopDefault($45fvw))).unix(currentUnixInOriginLocale).format("HH:mm"));
        },
        onError: ()=>{
            (0, $60f27fc97e29822a$export$b410431fab84fa58).error(t("qr_scan.sp_cant_be_checked_in_or_out"));
            redirect((0, $0534349ae8731d0b$export$66b32f6f30eb4b4).allJobs, {
                date: (0, $ddf12117b815a7c3$export$efb113ee57e9edfb)(new Date())
            });
        },
        filterError: [
            (0, $9ad33fbf770c55a1$export$9696fcf1798e1cb5).ClientError,
            (0, $9ad33fbf770c55a1$export$9696fcf1798e1cb5).NotFound
        ]
    });
    const redirect = (0, $7df35e9df335b1c8$export$602eaf6d5314ce55)();
    const { setShowQRScanner: setShowQRScanner } = (0, $acw62.useContext)((0, $392d2c14aa582458$export$9e7c8e903bb56df9));
    (0, $acw62.useEffect)(()=>{
        setShowQRScanner(false);
    }, []);
    const [checkInResult, checkIn] = (0, $4671947198ddd366$export$609860bf8b0084c)((params)=>checkInOgrammerWithQR(params), {
        onSuccess: ()=>{
            setIsSuccessModalVisible(true);
        },
        onError: (err)=>{
            (0, $60f27fc97e29822a$export$b410431fab84fa58).error(err.data.message);
        },
        filterError: [
            (0, $9ad33fbf770c55a1$export$9696fcf1798e1cb5).ClientError,
            (0, $9ad33fbf770c55a1$export$9696fcf1798e1cb5).NotFound
        ]
    });
    const [checkOutResult, checkOut] = (0, $4671947198ddd366$export$609860bf8b0084c)((params)=>checkOutOgrammerWithQR(params), {
        onSuccess: ()=>{
            setIsSuccessModalVisible(true);
        },
        onError: (err)=>{
            (0, $60f27fc97e29822a$export$b410431fab84fa58).error(err.data.message);
        },
        filterError: [
            (0, $9ad33fbf770c55a1$export$9696fcf1798e1cb5).ClientError,
            (0, $9ad33fbf770c55a1$export$9696fcf1798e1cb5).NotFound
        ]
    });
    if (!qrAttendance) return null;
    const actionText = qrAttendance.is_checkin ? t("shift_attendance_common.check_in") : t("shift_attendance_common.check_out");
    const isLoading = checkInResult.isLoading || checkOutResult.isLoading;
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "QrAttendance",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7ae42b63183f30b4$export$8b251419efc915eb), {
                title: `${t("qr_scan.qr")} ${actionText}`,
                handleBackClick: ()=>redirect((0, $0534349ae8731d0b$export$66b32f6f30eb4b4).index, {}),
                showBack: true
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $660b2ca422e0e2ae$export$1ff3c3f08ae963c0).Vertical, {
                height: 35
            }),
            isQrAttendanceLoading || value === null ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $57fb8f45c69e1681$export$2e2bcd8739ae039), {}) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "QrAttendance__container",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "QrAttendance__content",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "QrAttendance__profile",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                                        className: "QrAttendance__profile__image",
                                        src: String(qrAttendance.sp_image)
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                        className: "QrAttendance__profile__name",
                                        children: qrAttendance.sp_full_name
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                        className: "QrAttendance__profile__id",
                                        children: t("common.id_n", {
                                            id: qrAttendance.sp_id
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $660b2ca422e0e2ae$export$1ff3c3f08ae963c0).Vertical, {
                                height: 20
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "QrAttendance__order",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        className: "QrAttendance__order__info",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                className: "QrAttendance__order__info__number",
                                                children: t("order.order_number", {
                                                    id: qrAttendance.order_id
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                                className: "QrAttendance__order__info__designation",
                                                children: [
                                                    qrAttendance.work_category_name,
                                                    " (",
                                                    qrAttendance.job_amount,
                                                    ")"
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                                        src: (0, (/*@__PURE__*/$parcel$interopDefault($2d4024423d397f92$exports)))
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $660b2ca422e0e2ae$export$1ff3c3f08ae963c0).Vertical, {
                                height: 12
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "QrAttendance__stat-item",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                                        src: (0, (/*@__PURE__*/$parcel$interopDefault($cab7dbc8172ddafd$exports)))
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                        children: qrAttendance.location_name
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $660b2ca422e0e2ae$export$1ff3c3f08ae963c0).Vertical, {
                                height: 12
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "QrAttendance__stat-item",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                                        src: (0, (/*@__PURE__*/$parcel$interopDefault($bad31fa192b525ae$exports)))
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                        children: (0, (/*@__PURE__*/$parcel$interopDefault($45fvw))).unix(qrAttendance.shift_start_time + qrAttendance.timezone_offset + (0, $ddf12117b815a7c3$export$81fa0da0c2fba503)).format("dddd, DD MMM")
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $660b2ca422e0e2ae$export$1ff3c3f08ae963c0).Vertical, {
                                height: 24
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $660b2ca422e0e2ae$export$1ff3c3f08ae963c0).Vertical, {
                        height: 200
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $4a1895475c466679$export$c072955bb62eb0e2), {
                        contentStyle: {
                            flexDirection: "column",
                            position: "relative"
                        },
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5ce1d5308946b7cc$export$a1af6f79df847fac), {
                                label: actionText,
                                value: value,
                                handleChange: (time)=>{
                                    setValue(time);
                                },
                                className: "QrAttendance__timePicker",
                                useDropdownWithInput: true,
                                required: true
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                className: "QrAttendance__buttonSetDefault",
                                onClick: ()=>{
                                    const originalTime = qrAttendance.is_checkin ? qrAttendance.shift_start_time + qrAttendance.timezone_offset + (0, $ddf12117b815a7c3$export$81fa0da0c2fba503) : qrAttendance.shift_end_time + qrAttendance.timezone_offset + (0, $ddf12117b815a7c3$export$81fa0da0c2fba503);
                                    const originalTimeValue = (0, (/*@__PURE__*/$parcel$interopDefault($45fvw))).unix(originalTime).format("HH:mm");
                                    setValue(originalTimeValue);
                                },
                                children: t("qr_scan.set_default_time")
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $660b2ca422e0e2ae$export$1ff3c3f08ae963c0).Vertical, {
                                height: 8
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                onClick: ()=>{
                                    const params = {
                                        id: qrAttendance.sp_active_shift_id,
                                        time: value
                                    };
                                    const action = qrAttendance.is_checkin ? checkIn : checkOut;
                                    action(params);
                                },
                                className: `QrAttendance__action ${qrAttendance.is_checkin ? "" : " QrAttendance__action--red"}`,
                                children: isLoading ? t("common.loading") : actionText
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $87fc7e7d5c3dee30$export$2113e0e46f231d60), {
                isSuccessModalVisible: isSuccessModalVisible,
                isCheckin: qrAttendance.is_checkin,
                setShowQRScanner: setShowQRScanner
            })
        ]
    });
}));


const $372643303f22e332$export$34eaa31063f764e9 = {
    ShiftListPage: $f790b4cddcb46dea$export$2e2bcd8739ae039,
    QrAttendancePage: $a55d557e26ea1685$export$aed3011d91e6126
};










var $acw62 = parcelRequire("acw62");






var $acw62 = parcelRequire("acw62");









var $acw62 = parcelRequire("acw62");










const $d09e0a5cfb6eb515$var$CherryPickingConfirmModal = ({ modalIsOpen: modalIsOpen, closeModal: closeModal, onConfirm: onConfirm, name: name, type: type })=>{
    const { t: t } = (0, $3765cebd031b52c0$export$9fc83ad70ead8663)();
    const formattedName = name ?? "Applicant";
    const getDescription = ()=>{
        if (type === "accept") return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $e04d9533328ca578$export$8d6a9236f2e3f2ce), {
            i18nKey: "job_cherry_picking.you_are_about_to_accept",
            name: formattedName,
            children: [
                "You are about to accept",
                " ",
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                    className: "CherryPickingConfirmModal__modalBoldText",
                    children: {
                        name: formattedName
                    }
                }),
                " for the job"
            ]
        });
        return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $e04d9533328ca578$export$8d6a9236f2e3f2ce), {
            i18nKey: "job_cherry_picking.you_are_about_to_reject",
            name: formattedName,
            children: [
                "You are about to reject",
                " ",
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                    className: "CherryPickingConfirmModal__modalBoldText",
                    children: {
                        name: formattedName
                    }
                }),
                " They will be removed from the list"
            ]
        });
    };
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $c786671f641538e1$export$446bb0a5366f9068), {
        modalVisible: modalIsOpen,
        className: "CherryPickingConfirmModal",
        onClose: closeModal,
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h2", {
                className: "CherryPickingConfirmModal__modalTitle",
                children: t("job_cherry_picking.confirmation")
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $61076bfc19b3ff31$export$2e2bcd8739ae039), {
                space: 29
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                className: "CherryPickingConfirmModal__modalText",
                children: getDescription()
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $61076bfc19b3ff31$export$2e2bcd8739ae039), {
                space: 35
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "CherryPickingConfirmModal__actionButtonsContainer",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                        className: "CherryPickingConfirmModal__confirm",
                        onClick: onConfirm,
                        children: t("job_cherry_picking.confirm")
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                        className: "CherryPickingConfirmModal__cancel",
                        onClick: closeModal,
                        children: t("job_cherry_picking.cancel")
                    })
                ]
            })
        ]
    });
};
var $d09e0a5cfb6eb515$export$2e2bcd8739ae039 = $d09e0a5cfb6eb515$var$CherryPickingConfirmModal;





var $d142fc8abbc0ccdf$exports = {};
$d142fc8abbc0ccdf$exports = new URL("success.1f669c79.svg", import.meta.url).toString();




const $da018dcee356b71f$var$CherryPickingSuccessModal = ({ modalIsOpen: modalIsOpen, closeModal: closeModal, onConfirm: onConfirm })=>{
    const { t: t } = (0, $3765cebd031b52c0$export$9fc83ad70ead8663)();
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $c786671f641538e1$export$446bb0a5366f9068), {
        modalVisible: modalIsOpen,
        className: "CherryPickingSuccessModal",
        onClose: closeModal,
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                src: (0, (/*@__PURE__*/$parcel$interopDefault($d142fc8abbc0ccdf$exports)))
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h2", {
                className: "CherryPickingSuccessModal__modalTitle",
                children: t("job_cherry_picking.congratulation_exclamation")
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                className: "CherryPickingSuccessModal__modalText",
                children: t("job_cherry_picking.you_have_assigned_staff")
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $61076bfc19b3ff31$export$2e2bcd8739ae039), {
                space: 35
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                className: "CherryPickingSuccessModal__done",
                onClick: onConfirm,
                children: t("job_cherry_picking.done")
            })
        ]
    });
};
var $da018dcee356b71f$export$2e2bcd8739ae039 = $da018dcee356b71f$var$CherryPickingSuccessModal;






const $72dc12639ac59e63$var$ErrorModal = ({ isModalVisible: isModalVisible, onClose: onClose, onConfirm: onConfirm, errorMessage: errorMessage })=>{
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $c786671f641538e1$export$446bb0a5366f9068), {
        className: "ErrorModal",
        modalVisible: isModalVisible,
        onClose: onClose,
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h3", {
                className: "ErrorModal__title",
                children: "Error"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                className: "ErrorModal__message",
                children: errorMessage
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $660b2ca422e0e2ae$export$1ff3c3f08ae963c0).Vertical, {
                height: 30
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                onClick: onConfirm,
                className: "ErrorModal__ok",
                children: "Okay"
            })
        ]
    });
};
var $72dc12639ac59e63$export$2e2bcd8739ae039 = $72dc12639ac59e63$var$ErrorModal;


var $893c48ee38f561c0$exports = {};
$893c48ee38f561c0$exports = new URL("accepted.3245b48d.svg", import.meta.url).toString();





var $acw62 = parcelRequire("acw62");


function $ed5bfb085f31ab7b$export$c377b10719f38eb2({ isPermanentJob: isPermanentJob, onAccepted: onAccepted, onAcceptFailed: onAcceptFailed, onRejected: onRejected, onRejectFailed: onRejectFailed }) {
    const { data: data } = (0, $4671947198ddd366$export$6ccbb43953eebf8)();
    const acceptAction = (0, $acw62.useCallback)((params)=>{
        if (isPermanentJob) return data.acceptApplicantOfPermanentJob(params);
        else return data.acceptApplicantApiCall(params);
    }, [
        isPermanentJob,
        data
    ]);
    const rejectAction = (0, $acw62.useCallback)((params)=>{
        if (isPermanentJob) return data.rejectApplicantOfPermanentJob(params);
        else return data.rejectApplicantApiCall(params);
    }, [
        isPermanentJob,
        data
    ]);
    const [acceptQuery, acceptApplicant] = (0, $4671947198ddd366$export$609860bf8b0084c)(acceptAction, {
        onSuccess: onAccepted,
        onError: onAcceptFailed,
        filterError: [
            (0, $9ad33fbf770c55a1$export$9696fcf1798e1cb5).ClientError
        ]
    });
    const [rejectQuery, rejectApplicant] = (0, $4671947198ddd366$export$609860bf8b0084c)(rejectAction, {
        onSuccess: onRejected,
        onError: onRejectFailed,
        filterError: [
            (0, $9ad33fbf770c55a1$export$9696fcf1798e1cb5).ClientError
        ]
    });
    return {
        acceptQuery: acceptQuery,
        rejectQuery: rejectQuery,
        acceptApplicant: acceptApplicant,
        rejectApplicant: rejectApplicant
    };
}




var $b3264728c057db61$var$ConfirmationModalTypes;
(function(ConfirmationModalTypes) {
    ConfirmationModalTypes["accept"] = "accept";
    ConfirmationModalTypes["reject"] = "reject";
})($b3264728c057db61$var$ConfirmationModalTypes || ($b3264728c057db61$var$ConfirmationModalTypes = {}));
const $b3264728c057db61$var$AcceptAndRejectSection = (0, $a4963babae245ff9$export$f0c7a449e0cfaec7)((0, $aca50e9407ba89c9$export$b6ae1bc530f4c149)(({ applicant: applicant, jobType: jobType, extendOnConfirm: extendOnConfirm, jobId: jobId, shiftId: shiftId, onAccepted: onAccepted })=>{
    const { getCherryPickingByIdView: getCherryPickingByIdView } = (0, $4671947198ddd366$export$6ccbb43953eebf8)().data;
    const cherryPickingJob = getCherryPickingByIdView(jobId);
    const navigate = (0, $7df35e9df335b1c8$export$602eaf6d5314ce55)();
    const [isConfirmationModalOpen, setIsConfirmationModalOpen] = (0, $acw62.useState)(false);
    const [isSuccessModalOpen, setIsSuccessModalOpen] = (0, $acw62.useState)(false);
    const [isErrorModalOpen, setIsErrorModalOpen] = (0, $acw62.useState)(false);
    const [errorMessage, setErrorMessage] = (0, $acw62.useState)("");
    const [modalType, setModalType] = (0, $acw62.useState)("accept");
    const closeConfirmationModal = ()=>setIsConfirmationModalOpen(false);
    const { acceptQuery: acceptQuery, rejectQuery: rejectQuery, acceptApplicant: acceptApplicant, rejectApplicant: rejectApplicant } = (0, $ed5bfb085f31ab7b$export$c377b10719f38eb2)({
        isPermanentJob: jobType === (0, $862a04ca6e0d681b$export$27a7f855854fa13d).permanent,
        onAccepted: ()=>{
            if (cherryPickingJob.shifts_count <= cherryPickingJob.shifts_fulfilled_count) openSuccessModal();
            onAccepted(applicant.id);
        },
        onAcceptFailed: (error)=>{
            setErrorMessage(error.data.message);
            openErrorModal();
        }
    });
    const onAccept = ()=>{
        setModalType("accept");
        openConfirmationModal();
    };
    const onReject = ()=>{
        setModalType("reject");
        openConfirmationModal();
    };
    const openConfirmationModal = ()=>setIsConfirmationModalOpen(true);
    const onConfirm = ()=>{
        if (modalType === "accept") acceptApplicant(jobType === (0, $862a04ca6e0d681b$export$27a7f855854fa13d).permanent ? {
            job_application_id: applicant.id
        } : {
            sp_id: String(applicant.id),
            job_id: Number(jobId),
            shift_ids: shiftId ? [
                shiftId
            ] : undefined
        });
        else rejectApplicant(jobType === (0, $862a04ca6e0d681b$export$27a7f855854fa13d).permanent ? {
            job_application_id: applicant.id
        } : {
            sp_id: String(applicant.id),
            job_id: Number(jobId)
        });
        if (extendOnConfirm) extendOnConfirm() // extra logic when confirm, more than just accept/reject
        ;
        closeConfirmationModal();
    };
    const openSuccessModal = ()=>{
        setIsSuccessModalOpen(true);
    };
    const closeSuccessModal = ()=>{
        setIsSuccessModalOpen(false);
    };
    const onConfirmSuccessModal = ()=>{
        navigate((0, $0534349ae8731d0b$export$66b32f6f30eb4b4).applicantsReview, {});
    };
    const openErrorModal = ()=>{
        setIsErrorModalOpen(true);
    };
    const closeErrorModal = ()=>{
        setIsErrorModalOpen(false);
    };
    const { t: t } = (0, $3765cebd031b52c0$export$9fc83ad70ead8663)();
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "AcceptAndRejectSection",
        children: [
            applicant.status === (0, $1a7db182178118f7$export$41c5030382f95eb6).SHORTLISTED ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("button", {
                disabled: true,
                className: "AcceptAndRejectSection__accepted",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                        src: (0, (/*@__PURE__*/$parcel$interopDefault($893c48ee38f561c0$exports)))
                    }),
                    " ",
                    t("job_cherry_picking.accepted")
                ]
            }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                children: [
                    !shiftId && applicant.status !== (0, $1a7db182178118f7$export$41c5030382f95eb6).REJECTED && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                        disabled: rejectQuery.isLoading || acceptQuery.isLoading,
                        className: "AcceptAndRejectSection__reject",
                        onClick: onReject,
                        children: t("job_cherry_picking.reject")
                    }),
                    applicant.status === (0, $1a7db182178118f7$export$41c5030382f95eb6).REJECTED && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                        disabled: true,
                        className: "AcceptAndRejectSection__reject AcceptAndRejectSection__reject--rejected",
                        children: t("job_cherry_picking.rejected")
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                        disabled: rejectQuery.isLoading || acceptQuery.isLoading,
                        className: "AcceptAndRejectSection__accept",
                        onClick: onAccept,
                        children: t("job_cherry_picking.accept")
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $d09e0a5cfb6eb515$export$2e2bcd8739ae039), {
                name: applicant.name,
                modalIsOpen: isConfirmationModalOpen,
                closeModal: closeConfirmationModal,
                onConfirm: onConfirm,
                type: modalType
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $da018dcee356b71f$export$2e2bcd8739ae039), {
                modalIsOpen: isSuccessModalOpen,
                closeModal: closeSuccessModal,
                onConfirm: onConfirmSuccessModal
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $72dc12639ac59e63$export$2e2bcd8739ae039), {
                errorMessage: errorMessage,
                onConfirm: closeErrorModal,
                isModalVisible: isErrorModalOpen,
                onClose: closeErrorModal
            })
        ]
    });
}));
var $b3264728c057db61$export$2e2bcd8739ae039 = $b3264728c057db61$var$AcceptAndRejectSection;




const $184f4ad97a7e55c9$var$TopQuality = ({ name: name, containerStyleClass: containerStyleClass })=>{
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        className: `TopQuality ${containerStyleClass}`,
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
            className: "TopQuality__name",
            children: name
        })
    });
};
var $184f4ad97a7e55c9$export$2e2bcd8739ae039 = $184f4ad97a7e55c9$var$TopQuality;



var $4826ef334bad3dc7$exports = {};
$4826ef334bad3dc7$exports = new URL("beacon.eaef60c3.svg", import.meta.url).toString();




const $e7dfff25265fe63f$var$AnimatedHeart = ({ checked: checked, id: id })=>{
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        id: "main-content",
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                    checked: checked,
                    onChange: ()=>{},
                    type: "checkbox",
                    id: id,
                    className: "animatedHeart__checkbox"
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                    htmlFor: id,
                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("svg", {
                        id: "heart-svg",
                        viewBox: "467 392 58 57",
                        xmlns: "http://www.w3.org/2000/svg",
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("g", {
                            id: "Group",
                            fill: "none",
                            fillRule: "evenodd",
                            transform: "translate(467 392)",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                                    d: "M29.144 20.773c-.063-.13-4.227-8.67-11.44-2.59C7.63 28.795 28.94 43.256 29.143 43.394c.204-.138 21.513-14.6 11.44-25.213-7.214-6.08-11.377 2.46-11.44 2.59z",
                                    id: "heart",
                                    fill: "#AAB8C2"
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("circle", {
                                    id: "main-circ",
                                    fill: "#E2264D",
                                    opacity: "0",
                                    cx: "29.5",
                                    cy: "29.5",
                                    r: "1.5"
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("g", {
                                    id: "grp7",
                                    opacity: "0",
                                    transform: "translate(7 6)",
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("circle", {
                                            id: "oval1",
                                            fill: "#9CD8C3",
                                            cx: "2",
                                            cy: "6",
                                            r: "2"
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("circle", {
                                            id: "oval2",
                                            fill: "#8CE8C3",
                                            cx: "5",
                                            cy: "2",
                                            r: "2"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("g", {
                                    id: "grp6",
                                    opacity: "0",
                                    transform: "translate(0 28)",
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("circle", {
                                            id: "oval1",
                                            fill: "#CC8EF5",
                                            cx: "2",
                                            cy: "7",
                                            r: "2"
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("circle", {
                                            id: "oval2",
                                            fill: "#91D2FA",
                                            cx: "3",
                                            cy: "2",
                                            r: "2"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("g", {
                                    id: "grp3",
                                    opacity: "0",
                                    transform: "translate(52 28)",
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("circle", {
                                            id: "oval2",
                                            fill: "#9CD8C3",
                                            cx: "2",
                                            cy: "7",
                                            r: "2"
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("circle", {
                                            id: "oval1",
                                            fill: "#8CE8C3",
                                            cx: "4",
                                            cy: "2",
                                            r: "2"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("g", {
                                    id: "grp2",
                                    opacity: "0",
                                    transform: "translate(44 6)",
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("circle", {
                                            id: "oval2",
                                            fill: "#CC8EF5",
                                            cx: "5",
                                            cy: "6",
                                            r: "2"
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("circle", {
                                            id: "oval1",
                                            fill: "#CC8EF5",
                                            cx: "2",
                                            cy: "2",
                                            r: "2"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("g", {
                                    id: "grp5",
                                    opacity: "0",
                                    transform: "translate(14 50)",
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("circle", {
                                            id: "oval1",
                                            fill: "#91D2FA",
                                            cx: "6",
                                            cy: "5",
                                            r: "2"
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("circle", {
                                            id: "oval2",
                                            fill: "#91D2FA",
                                            cx: "2",
                                            cy: "2",
                                            r: "2"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("g", {
                                    id: "grp4",
                                    opacity: "0",
                                    transform: "translate(35 50)",
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("circle", {
                                            id: "oval1",
                                            fill: "#F48EA7",
                                            cx: "6",
                                            cy: "5",
                                            r: "2"
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("circle", {
                                            id: "oval2",
                                            fill: "#F48EA7",
                                            cx: "2",
                                            cy: "2",
                                            r: "2"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("g", {
                                    id: "grp1",
                                    opacity: "0",
                                    transform: "translate(24)",
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("circle", {
                                            id: "oval1",
                                            fill: "#9FC7FA",
                                            cx: "2.5",
                                            cy: "3",
                                            r: "2"
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("circle", {
                                            id: "oval2",
                                            fill: "#9FC7FA",
                                            cx: "7.5",
                                            cy: "2",
                                            r: "2"
                                        })
                                    ]
                                })
                            ]
                        })
                    })
                })
            ]
        })
    });
};
var $e7dfff25265fe63f$export$2e2bcd8739ae039 = $e7dfff25265fe63f$var$AnimatedHeart;





var $acw62 = parcelRequire("acw62");
var $86f3053e83f201ef$exports = {};
$86f3053e83f201ef$exports = new URL("play-video.15247066.svg", import.meta.url).toString();



function $4c4ebfe8a55483a8$export$98e3c7b8da5643d9({ rating: rating, className: className, onClick: onClick }) {
    const modificator = (0, $acw62.useMemo)(()=>{
        if (rating === null) return "";
        else if (rating >= 4) return "_top";
        else if (rating >= 3) return "_middle";
        else return "_low";
    }, [
        rating
    ]);
    const getFormattedRating = ()=>{
        if (rating === null) return "Not rated";
        return rating % 2 === 0 ? rating : Math.round(rating * 10) / 10;
    };
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: `ApplicantInterview ApplicantInterview${modificator} ${className}`,
        onClick: onClick,
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "ApplicantInterview__side",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                        className: "ApplicantInterview__title",
                        children: "Interview:"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                        className: `ApplicantInterview__rating ApplicantInterview__rating${modificator}`,
                        children: getFormattedRating()
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "ApplicantInterview__side",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                        src: (0, (/*@__PURE__*/$parcel$interopDefault($86f3053e83f201ef$exports))),
                        className: "ApplicantInterview__playImg"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                        className: "ApplicantInterview__playLabel",
                        children: "Play Answers"
                    })
                ]
            })
        ]
    });
}







const $46878443689c447e$var$MIN_SKILL_MATCH_TO_RENDER_COMPONENT = 50;
const $46878443689c447e$export$acad17a0a2e93a43 = ({ skillMatch: skillMatch, skillIcons: skillIcons, className: className })=>{
    const { t: t } = (0, $3765cebd031b52c0$export$9fc83ad70ead8663)();
    if (skillMatch <= $46878443689c447e$var$MIN_SKILL_MATCH_TO_RENDER_COMPONENT || skillMatch === 100) return null;
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: `SkillMatch ${className ?? ""}`,
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                className: "SkillMatch__title",
                children: [
                    t("job_cherry_picking.skill_match"),
                    ": ",
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                        className: "SkillMatch__percent",
                        children: [
                            skillMatch,
                            "%"
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "SkillMatch__images",
                children: skillIcons.map((icon, key)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                        src: icon
                    }, key))
            })
        ]
    });
};




function $02fb6dbe124d4af6$var$extractGoogleDriveId(url) {
    if (!url || typeof url !== "string") return null;
    const match = url.match(/\/d\/([^\/]+)/);
    return match ? match[1] : null;
}
function $02fb6dbe124d4af6$export$be3082245f029840(fileUrl) {
    if (!fileUrl || typeof fileUrl !== "string") return null;
    if (fileUrl.includes("drive.google.com")) return `https://drive.google.com/file/d/${$02fb6dbe124d4af6$var$extractGoogleDriveId(fileUrl)}/preview`;
    else return fileUrl;
}
function $02fb6dbe124d4af6$export$a22ea4d9be220b2f(fileUrl) {
    if (!fileUrl || typeof fileUrl !== "string") return null;
    if (fileUrl.includes("drive.google.com")) return `https://drive.google.com/thumbnail?id=${$02fb6dbe124d4af6$var$extractGoogleDriveId(fileUrl)}`;
    else return fileUrl;
}


const $8ba84356426acf88$var$ApplicantCard = (0, $a4963babae245ff9$export$f0c7a449e0cfaec7)((0, $aca50e9407ba89c9$export$b6ae1bc530f4c149)(({ applicant: applicant, jobType: jobType, jobId: jobId, shiftId: shiftId, onPlayAnswersPress: onPlayAnswersPress, onAccepted: onAccepted })=>{
    const { toggleApplicantAsFavouriteApiCall: toggleApplicantAsFavouriteApiCall, getInterviewByJobId: getInterviewByJobId, getSpRating: getSpRating, spHasAnswers: spHasAnswers, setCurrentApplicant: setCurrentApplicant } = (0, $4671947198ddd366$export$6ccbb43953eebf8)().data;
    const [toggleApplicantAsFavouriteQuery, toggleApplicantAsFavourite] = (0, $4671947198ddd366$export$609860bf8b0084c)(toggleApplicantAsFavouriteApiCall);
    const markApplicantAsFavourite = ()=>{
        if (!applicant.is_favorite) (0, $60f27fc97e29822a$export$b410431fab84fa58).success(t("applicant_details.added_as_favourite", {
            spName: applicant.name
        }));
        toggleApplicantAsFavourite(String(applicant.id));
    };
    const isPhotoPDFType = (0, $acw62.useMemo)(()=>applicant.image_url?.includes(".pdf"), [
        applicant.image_url
    ]);
    const { t: t } = (0, $3765cebd031b52c0$export$9fc83ad70ead8663)();
    const showNationality = (0, $acw62.useMemo)(()=>(0, $73ccb33f5de6f5aa$export$8707029d024490c9)().applicantReview.includeNationality, []);
    const interview = getInterviewByJobId(parseInt(jobId));
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: applicant.status === (0, $1a7db182178118f7$export$41c5030382f95eb6).SHORTLISTED || applicant.skillMatch === 100 ? "ApplicantCard ApplicantCard--selected" : "ApplicantCard",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "ApplicantCard__header",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "ApplicantCard__avatarAndNameContainer",
                        onClick: ()=>{
                            setCurrentApplicant(applicant.id, jobType);
                        },
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "ApplicantCard__link",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                                        className: "ApplicantCard__avatar",
                                        src: isPhotoPDFType ? undefined : (0, $02fb6dbe124d4af6$export$a22ea4d9be220b2f)(applicant.image_url) ?? ""
                                    }),
                                    applicant.is_chief ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                                        className: "ApplicantCard__beacon",
                                        src: (0, (/*@__PURE__*/$parcel$interopDefault($4826ef334bad3dc7$exports)))
                                    }) : null
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "ApplicantCard__nameAndRatingContainer",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        className: "ApplicantCard__nameContainer",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h3", {
                                                className: "ApplicantCard__name",
                                                children: applicant.name
                                            }),
                                            applicant.skillMatch === 100 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                className: "ApplicantCard__tag",
                                                children: t("job_cherry_picking.shortlisted")
                                            })
                                        ]
                                    }),
                                    jobType !== (0, $862a04ca6e0d681b$export$27a7f855854fa13d).permanent && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $647b8b1a309a1295$export$2e2bcd8739ae039), {
                                        rating: applicant.rating ?? 0,
                                        editable: false
                                    })
                                ]
                            })
                        ]
                    }),
                    jobType !== (0, $862a04ca6e0d681b$export$27a7f855854fa13d).permanent && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "ApplicantCard__favourite",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                className: "ApplicantCard__favouriteIcon",
                                disabled: toggleApplicantAsFavouriteQuery.isLoading,
                                onClick: markApplicantAsFavourite,
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e7dfff25265fe63f$export$2e2bcd8739ae039), {
                                    id: String(applicant.id),
                                    checked: Boolean(applicant.is_favorite)
                                })
                            }),
                            applicant.top_qualities && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $184f4ad97a7e55c9$export$2e2bcd8739ae039), {
                                name: applicant.top_qualities[0]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $660b2ca422e0e2ae$export$1ff3c3f08ae963c0).Vertical, {
                height: 20
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7df35e9df335b1c8$export$a6c7ac8248d6e38a), {
                route: (0, $0534349ae8731d0b$export$66b32f6f30eb4b4).applicantDetails,
                params: {
                    applicantId: String(applicant.id),
                    applicantName: applicant.name ?? "",
                    jobId: jobId,
                    type: jobType
                },
                className: "ApplicantCard__info",
                children: [
                    jobType !== (0, $862a04ca6e0d681b$export$27a7f855854fa13d).permanent && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "ApplicantCard__infoColumn",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                className: "ApplicantCard__infoName",
                                children: t("job_cherry_picking.exp")
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                className: "ApplicantCard__infoValue",
                                children: t("job_cherry_picking.years_of_experience", {
                                    count: applicant.years_experience
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "ApplicantCard__infoColumn",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                className: "ApplicantCard__infoName",
                                children: t("job_cherry_picking.age")
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                className: "ApplicantCard__infoValue",
                                children: applicant.age
                            })
                        ]
                    }),
                    applicant.languages && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "ApplicantCard__infoColumn",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                className: "ApplicantCard__infoName",
                                children: t("job_cherry_picking.language")
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                className: "ApplicantCard__infoValue",
                                children: [
                                    applicant.languages[0],
                                    applicant.languages.length > 1 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                        className: "ApplicantCard__languageCount",
                                        children: [
                                            " + ",
                                            applicant.languages.length - 1
                                        ]
                                    })
                                ]
                            })
                        ]
                    }),
                    showNationality && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "ApplicantCard__infoColumn",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                className: "ApplicantCard__infoName",
                                children: t("job_cherry_picking.nationality")
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                className: "ApplicantCard__infoValue",
                                children: applicant.nationality
                            })
                        ]
                    })
                ]
            }),
            interview !== undefined && spHasAnswers({
                spId: applicant.id,
                interviewId: interview.id
            }) && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4c4ebfe8a55483a8$export$98e3c7b8da5643d9), {
                rating: getSpRating({
                    interviewId: interview.id,
                    spId: applicant.id
                }),
                className: "ApplicantCard__applicantInterview",
                onClick: onPlayAnswersPress
            }),
            applicant.skills && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $46878443689c447e$export$acad17a0a2e93a43), {
                skillMatch: applicant.skillMatch,
                skillIcons: applicant.skills.filter((skill)=>skill.is_matched).map((skill)=>skill.icon ?? "").slice(0, 3),
                className: "ApplicantCard__skillMatch"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b3264728c057db61$export$2e2bcd8739ae039), {
                jobId: jobId,
                jobType: jobType,
                applicant: applicant,
                shiftId: shiftId,
                onAccepted: onAccepted
            })
        ]
    });
}));
var $8ba84356426acf88$export$2e2bcd8739ae039 = $8ba84356426acf88$var$ApplicantCard;


var $83bf3c15862dc223$exports = {};
$83bf3c15862dc223$exports = new URL("applicants.80ef2471.svg", import.meta.url).toString();


var $2c36da916d923dd9$exports = {};
$2c36da916d923dd9$exports = new URL("down-arrow.5ae70663.svg", import.meta.url).toString();









var $1u0KT = parcelRequire("1u0KT");

const $2f054bf0e4f80151$export$2b77a92f1a5ad772 = (props)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1u0KT))).createPortal(/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "Modal",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "Modal__close",
                onClick: props.onClose,
                children: "X"
            }),
            props.children
        ]
    }), (0, $dacbeb7af41d49ec$export$c9fe13db74ed5944)(document.getElementById("modals")));
};





const $5470867b90519ae0$export$d13ecf3b0ae7b64d = ({ imgSrc: imgSrc, name: name, onClose: onClose })=>{
    const { t: t } = (0, $3765cebd031b52c0$export$9fc83ad70ead8663)();
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $2f054bf0e4f80151$export$2b77a92f1a5ad772), {
        onClose: onClose,
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
            className: "ChiefPopup",
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                    className: "ChiefPopup__title",
                    children: t("job_cherry_picking.chief_title")
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                    className: "ChiefPopup__subtitle",
                    children: t("job_cherry_picking.chief_subtitle")
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: "ChiefPopup__imageContainer",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                            src: imgSrc,
                            className: "ChiefPopup__imageContainer__avatar"
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                            src: (0, (/*@__PURE__*/$parcel$interopDefault($4826ef334bad3dc7$exports))),
                            className: "ChiefPopup__imageContainer__beacon"
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                    className: "ChiefPopup__name",
                    children: name
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                    className: "ChiefPopup__chiefLabel",
                    children: t("job_cherry_picking.chief_og")
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                    className: "ChiefPopup__instructionsTitle",
                    children: t("job_cherry_picking.what_is_chief")
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                    className: "ChiefPopup__instructionsDescription",
                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $e04d9533328ca578$export$8d6a9236f2e3f2ce), {
                        children: [
                            "A Chief OG is a team leader, carefully selected by us to help manage larger Ogram teams. For example, by resolving disputes and coordinating team members - at no extra cost to you.",
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("br", {}),
                            "And all this is",
                            " ",
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                className: "ChiefPopup__instructionsDescription__highlight",
                                children: "completely free for you."
                            })
                        ]
                    }, "job_cherry_picking.chief_definition")
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $2c46e9e1f89bee75$export$2b47962e4e24eb4d), {
                    text: t("job_cherry_picking.chief_button_label"),
                    action: onClose
                })
            ]
        })
    });
};







var $acw62 = parcelRequire("acw62");









var $91bc79a82856d8f1$exports = {};
$91bc79a82856d8f1$exports = new URL("favourite.3be4035d.svg", import.meta.url).toString();


var $ce95bcf772e57501$exports = {};
$ce95bcf772e57501$exports = new URL("not-favourite.c7838c07.svg", import.meta.url).toString();




function $dd6a69dbf87a4818$var$ToggleFavouriteComponent({ className: className = "" }) {
    const { getCurrentApplicant: getCurrentApplicant, toggleCurrentApplicantAsFavouriteApiCall: toggleCurrentApplicantAsFavouriteApiCall } = (0, $4671947198ddd366$export$6ccbb43953eebf8)().data;
    const currentApplicant = getCurrentApplicant((0, $862a04ca6e0d681b$export$27a7f855854fa13d).oneTime);
    const { t: t } = (0, $3765cebd031b52c0$export$9fc83ad70ead8663)();
    const [toggleMutation, triggerToggleMutation] = (0, $4671947198ddd366$export$609860bf8b0084c)(toggleCurrentApplicantAsFavouriteApiCall);
    const markApplicantAsFavourite = ()=>{
        if (!currentApplicant.is_favorite) (0, $60f27fc97e29822a$export$b410431fab84fa58).success(t("applicant_details.added_as_favourite", {
            spName: currentApplicant.name
        }));
        triggerToggleMutation(undefined);
    };
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        className: `ToggleFavourite ${className}`,
        onClick: ()=>{
            if (toggleMutation.isLoading) return;
            markApplicantAsFavourite();
        },
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
            src: currentApplicant.is_favorite ? (0, (/*@__PURE__*/$parcel$interopDefault($91bc79a82856d8f1$exports))) : (0, (/*@__PURE__*/$parcel$interopDefault($ce95bcf772e57501$exports)))
        })
    });
}
const $dd6a69dbf87a4818$export$567f003c75a59875 = (0, $aca50e9407ba89c9$export$b6ae1bc530f4c149)($dd6a69dbf87a4818$var$ToggleFavouriteComponent);





var $acw62 = parcelRequire("acw62");







function $2c6e0f023a02a62e$var$AnswerFormComponent({ visible: visible, interviewId: interviewId, questionId: questionId, questionIndex: questionIndex }) {
    const { t: t } = (0, $3765cebd031b52c0$export$9fc83ad70ead8663)();
    const [mounted, setMounted] = (0, $acw62.useState)(false);
    const { getCurrentApplicant: getCurrentApplicant, getQuestionById: getQuestionById, getSpAnswer: getSpAnswer, rateAnswer: rateAnswer } = (0, $4671947198ddd366$export$6ccbb43953eebf8)().data;
    const [rateMutation, submitRate] = (0, $4671947198ddd366$export$609860bf8b0084c)(rateAnswer, {
        filterError: [
            (0, $9ad33fbf770c55a1$export$9696fcf1798e1cb5).ClientError
        ],
        onSuccess: ()=>{
            (0, $60f27fc97e29822a$export$b410431fab84fa58).success(t("interview.rating_applied"));
        },
        onError: (err)=>{
            (0, $60f27fc97e29822a$export$b410431fab84fa58).error(err.data.errors?.rating?.[0] ?? err.data.message);
        }
    });
    (0, $acw62.useEffect)(()=>{
        if (visible && !mounted) setMounted(true);
    }, [
        visible
    ]);
    const applicant = getCurrentApplicant((0, $862a04ca6e0d681b$export$27a7f855854fa13d).oneTime);
    const question = getQuestionById(questionId);
    const answer = getSpAnswer({
        spId: applicant.id,
        interviewId: interviewId,
        questionId: questionId
    });
    if (!mounted) return null;
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "AnswerForm",
        hidden: !visible,
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "AnswerForm__question",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                        className: "AnswerForm__questionIndex",
                        children: t("interview.question_short", {
                            index: questionIndex + 1
                        })
                    }),
                    " ",
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                        className: "AnswerForm__questionText",
                        children: question?.description
                    })
                ]
            }),
            answer !== null && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("video", {
                controls: true,
                className: "AnswerForm__videoPlayer",
                width: "100%",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("source", {
                        src: answer.file_url,
                        type: "video/mp4"
                    }),
                    t("interview.video_player_not_supported")
                ]
            }, answer.file_url),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "AnswerForm__ratingContainer",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "AnswerForm__ratingLabel",
                        children: t("interview.rating_question_short", {
                            index: questionIndex + 1
                        })
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $647b8b1a309a1295$export$2e2bcd8739ae039), {
                        rating: answer?.rating ?? 0,
                        editable: !rateMutation.isLoading,
                        size: 14,
                        onRatingChange: (newRating)=>{
                            submitRate({
                                answerId: answer.id,
                                rating: newRating
                            });
                        }
                    })
                ]
            }),
            rateMutation.isLoading && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "AnswerForm__ratingLoading",
                children: t("interview.submitting_rating")
            })
        ]
    });
}
const $2c6e0f023a02a62e$export$966844a56509af42 = (0, $aca50e9407ba89c9$export$b6ae1bc530f4c149)($2c6e0f023a02a62e$var$AnswerFormComponent);










function $2fc50df8f10b7600$var$ResultFormComponent({ interviewId: interviewId, isVisible: isVisible }) {
    const { t: t } = (0, $3765cebd031b52c0$export$9fc83ad70ead8663)();
    const { getCurrentApplicant: getCurrentApplicant, getInterviewQuestions: getInterviewQuestions, getSpAnswer: getSpAnswer, getSpRating: getSpRating } = (0, $4671947198ddd366$export$6ccbb43953eebf8)().data;
    const questions = getInterviewQuestions(interviewId);
    const applicant = getCurrentApplicant((0, $862a04ca6e0d681b$export$27a7f855854fa13d).oneTime);
    const spId = applicant.id;
    const overalRating = getSpRating({
        interviewId: interviewId,
        spId: spId
    }) ?? 0;
    const isRecommended = overalRating >= 4;
    const questionsWithAnswers = questions.filter((id)=>Boolean(getSpAnswer({
            spId: spId,
            interviewId: interviewId,
            questionId: id
        })));
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        hidden: !isVisible,
        className: "ResultForm",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "ResultForm__header",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        hidden: !isRecommended,
                        className: "ResultForm__title",
                        children: t("interview.recommended_to_hire")
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                        className: "ResultForm__subtitle",
                        children: t("interview.overall_rating")
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "ResultForm__ratingContainer",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                                src: (0, (/*@__PURE__*/$parcel$interopDefault($940db1236f8252d1$exports))),
                                alt: "",
                                className: "ResultForm__overallStarImg"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                className: "ResultForm__overallRatingLabel",
                                children: overalRating % 2 === 0 ? overalRating : Math.round(overalRating * 10) / 10
                            })
                        ]
                    })
                ]
            }),
            questionsWithAnswers.map((questionId, index)=>{
                const answer = getSpAnswer({
                    spId: applicant.id,
                    interviewId: interviewId,
                    questionId: questionId
                });
                return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: "ResultForm__questionContainer",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                            className: "ResultForm__questionRatingLabel",
                            children: t("interview.rating_question_short", {
                                index: index + 1
                            })
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $647b8b1a309a1295$export$2e2bcd8739ae039), {
                            editable: false,
                            rating: answer.rating ?? 0,
                            size: 14
                        })
                    ]
                }, questionId);
            })
        ]
    });
}
const $2fc50df8f10b7600$export$3f0d565d9c136283 = (0, $aca50e9407ba89c9$export$b6ae1bc530f4c149)($2fc50df8f10b7600$var$ResultFormComponent);





var $62c9e56fdb451f8c$exports = {};
$62c9e56fdb451f8c$exports = new URL("arrow-left.389b889d.svg", import.meta.url).toString();



function $823457c290f05c22$export$9036c3d67267ee2a({ stepIndex: stepIndex, stepsLength: stepsLength, showAccepted: showAccepted, showAccept: showAccept, showNext: showNext, showNextApplicantButton: showNextApplicantButton, onBack: onBack, onNext: onNext, onNextApplicant: onNextApplicant, onAccept: onAccept, onShowResult: onShowResult }) {
    const { t: t } = (0, $3765cebd031b52c0$export$9fc83ad70ead8663)();
    const backDisabled = !showAccept && stepIndex === 0;
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "FormStepper",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $2ab88429e3384d30$export$353f5b6fc5456de1), {
                onClick: onBack,
                className: `FormStepper__backButton ${backDisabled ? "FormStepper__backButton_disabled" : ""}`,
                disabled: backDisabled,
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                    src: (0, (/*@__PURE__*/$parcel$interopDefault($62c9e56fdb451f8c$exports))),
                    className: "FormStepper__backImg"
                })
            }),
            showNext && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $2ab88429e3384d30$export$353f5b6fc5456de1), {
                onClick: stepIndex === stepsLength - 1 ? onShowResult : onNext,
                className: "FormStepper__nextButton",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                    className: "FormStepper__nextLabel",
                    children: t("interview.next_question")
                })
            }),
            showAccept && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $2ab88429e3384d30$export$353f5b6fc5456de1), {
                onClick: onAccept,
                className: "FormStepper__acceptButton",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                    className: "FormStepper__acceptLabel",
                    children: t("interview.accept")
                })
            }),
            showAccepted && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "FormStepper__assigned",
                children: t("interview.assigned")
            }),
            showNextApplicantButton && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $2ab88429e3384d30$export$353f5b6fc5456de1), {
                onClick: onNextApplicant,
                className: "FormStepper__nextApplicantButton",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                    className: "FormStepper__nextApplicantLabel",
                    children: t("interview.next_applicant")
                })
            })
        ]
    });
}




function $b796eeaf55507ebc$var$InterviewComponent({ applicantsType: applicantsType, jobId: jobId, showInitialQuestion: showInitialQuestion, onAcceptPress: onAcceptPress }) {
    const { t: t } = (0, $3765cebd031b52c0$export$9fc83ad70ead8663)();
    const { getCurrentApplicant: getCurrentApplicant, getNotAcceptedApplicantsList: getNotAcceptedApplicantsList, getInterviewByJobId: getInterviewByJobId, getInterviewQuestions: getInterviewQuestions, getQuestionById: getQuestionById, setCurrentApplicant: setCurrentApplicant, spHasAnswers: spHasAnswers, getSpAnswer: getSpAnswer } = (0, $4671947198ddd366$export$6ccbb43953eebf8)().data;
    const currentApplicant = getCurrentApplicant((0, $862a04ca6e0d681b$export$27a7f855854fa13d).oneTime);
    const notAcceptedApplicantsList = getNotAcceptedApplicantsList((0, $862a04ca6e0d681b$export$27a7f855854fa13d).oneTime);
    const [currentQuestion, setCurrentQuestion] = (0, $acw62.useState)(null);
    const [showResultRating, setShowResult] = (0, $acw62.useState)(false);
    (0, $acw62.useEffect)(()=>{
        if (showInitialQuestion?.qId !== currentQuestion?.qId) setCurrentQuestion(showInitialQuestion);
    }, [
        showInitialQuestion
    ]);
    const applicant = currentApplicant;
    const interview = getInterviewByJobId(jobId);
    if (!applicant || !interview) return null;
    const questions = getInterviewQuestions(interview.id);
    const questionsWithAnswers = questions.filter((questionId)=>{
        return Boolean(getSpAnswer({
            spId: applicant.id,
            interviewId: interview.id,
            questionId: questionId
        }));
    });
    const onClose = ()=>{
        setCurrentQuestion(null);
        setShowResult(false);
    };
    const findApplicantIndex = (checkCustomCondition)=>{
        return notAcceptedApplicantsList.findIndex((applicantItem, index)=>{
            const applicantHasAnswers = spHasAnswers({
                spId: applicantItem.id,
                interviewId: interview.id
            });
            return checkCustomCondition(index) && applicantItem.is_accepted === 0 && applicantHasAnswers;
        });
    };
    const onNextApplicant = ()=>{
        const currentApplicantIndex = notAcceptedApplicantsList.findIndex((applicantItem)=>applicantItem.id === applicant.id);
        // find the next not accepted applicant standing after the current one
        let nextApplicantIndex = findApplicantIndex((index)=>index > currentApplicantIndex);
        if (nextApplicantIndex === -1) {
            // find the first not accepted applicant standing before the current one
            nextApplicantIndex = findApplicantIndex((index)=>index < currentApplicantIndex);
            if (nextApplicantIndex === -1) {
                // if not-accepted applicants are not found, let user know about it and close
                (0, $60f27fc97e29822a$export$b410431fab84fa58).info(t("interview.applicants_finished"));
                onClose();
                return;
            }
        }
        const nextApplicantId = notAcceptedApplicantsList[nextApplicantIndex].id;
        setCurrentApplicant(nextApplicantId, (0, $862a04ca6e0d681b$export$27a7f855854fa13d).oneTime);
        const nextApplicantQuestions = questions.filter((questionId)=>Boolean(getSpAnswer({
                spId: nextApplicantId,
                interviewId: interview.id,
                questionId: questionId
            })));
        setCurrentQuestion({
            qIndex: 0,
            qId: nextApplicantQuestions[0]
        });
        setShowResult(false);
    };
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $9c16b10bbbe042e5$export$129a32eedafa97c5), {
        isActive: currentQuestion !== null || showResultRating,
        close: onClose,
        content: currentQuestion ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
            className: "Interview",
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: "Interview__header",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                    className: "Interview__headerLeft",
                                    children: [
                                        typeof applicant.image_url === "string" && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                                            src: applicant.image_url,
                                            alt: "",
                                            className: "Interview__avatar"
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                    className: "Interview__title",
                                                    children: applicant.name
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                    className: "Interview__subtitle",
                                                    children: t("interview.applicant_id", {
                                                        id: applicant.id
                                                    })
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $dd6a69dbf87a4818$export$567f003c75a59875), {})
                            ]
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                            className: "Interview__bottomSeparator"
                        }),
                        questionsWithAnswers.map((questionId, index)=>{
                            const question = getQuestionById(questionId);
                            return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $2c6e0f023a02a62e$export$966844a56509af42), {
                                visible: !showResultRating && currentQuestion.qId === questionId,
                                interviewId: interview.id,
                                questionId: question.id,
                                questionIndex: index
                            }, question.id);
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $2fc50df8f10b7600$export$3f0d565d9c136283), {
                            isVisible: showResultRating,
                            interviewId: interview.id
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $823457c290f05c22$export$9036c3d67267ee2a), {
                    stepIndex: currentQuestion.qIndex,
                    stepsLength: questionsWithAnswers.length,
                    showAccept: showResultRating && currentApplicant.is_accepted === 0,
                    showAccepted: showResultRating && currentApplicant.is_accepted === 1,
                    showNext: !showResultRating,
                    onBack: ()=>{
                        if (showResultRating) setShowResult(false);
                        else setCurrentQuestion((prevState)=>{
                            const prevIndex = (prevState?.qIndex ?? 1) - 1;
                            return {
                                qIndex: prevIndex,
                                qId: questionsWithAnswers[prevIndex]
                            };
                        });
                    },
                    onNext: ()=>{
                        setCurrentQuestion((prevState)=>{
                            const nextIndex = (prevState?.qIndex ?? 0) + 1;
                            return {
                                qIndex: nextIndex,
                                qId: questionsWithAnswers[nextIndex]
                            };
                        });
                    },
                    onShowResult: ()=>{
                        setShowResult(true);
                    },
                    onAccept: ()=>{
                        onAcceptPress();
                        onClose();
                    },
                    onNextApplicant: onNextApplicant,
                    showNextApplicantButton: showResultRating && applicantsType === "multiple"
                })
            ]
        }) : null
    });
}
const $b796eeaf55507ebc$export$7fe57d46322b10ad = (0, $aca50e9407ba89c9$export$b6ae1bc530f4c149)($b796eeaf55507ebc$var$InterviewComponent);







var $acw62 = parcelRequire("acw62");

var $45fvw = parcelRequire("45fvw");





const $3973f6144603dc7a$var$getRatio = (current, total)=>{
    return Math.round(current / total * 100);
};
const $3973f6144603dc7a$var$JobDetailsCard = (0, $a4963babae245ff9$export$f0c7a449e0cfaec7)((0, $aca50e9407ba89c9$export$b6ae1bc530f4c149)(({ jobDetails: jobDetails, showQuantity: showQuantity, showFulfillment: showFulfillment, showStartDate: showStartDate, showEndDate: showEndDate })=>{
    const formatedStartDate = (0, (/*@__PURE__*/$parcel$interopDefault($45fvw)))(jobDetails?.start_date).format((0, $ddf12117b815a7c3$export$4e4cb19dd88cd821));
    const formatedEndDate = (0, (/*@__PURE__*/$parcel$interopDefault($45fvw)))(jobDetails?.end_date).format((0, $ddf12117b815a7c3$export$4e4cb19dd88cd821));
    const fullFilmentRatio = (0, $acw62.useMemo)(()=>{
        if (jobDetails) return $3973f6144603dc7a$var$getRatio(jobDetails.shifts_fulfilled_count, jobDetails.shifts_count);
        return 0;
    }, [
        jobDetails
    ]);
    const { t: t } = (0, $3765cebd031b52c0$export$9fc83ad70ead8663)();
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "JobDetailsCard",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "JobDetailsCard__row",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h3", {
                        className: "JobDetailsCard__label",
                        children: t("job_cherry_picking.jobID")
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                        className: "JobDetailsCard__data",
                        children: jobDetails?.id
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "JobDetailsCard__row",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h3", {
                        className: "JobDetailsCard__label",
                        children: t("job_cherry_picking.designation")
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                        className: "JobDetailsCard__data",
                        children: jobDetails?.work_category_name
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "JobDetailsCard__row",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h3", {
                        className: "JobDetailsCard__label",
                        children: t("job_cherry_picking.location")
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                        className: "JobDetailsCard__data",
                        children: jobDetails?.location_name
                    })
                ]
            }),
            showQuantity && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "JobDetailsCard__row",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h3", {
                        className: "JobDetailsCard__label",
                        children: t("job_cherry_picking.required_quantity")
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                        className: "JobDetailsCard__data",
                        children: jobDetails?.required_quantity
                    })
                ]
            }),
            showFulfillment && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "JobDetailsCard__row",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h3", {
                        className: "JobDetailsCard__label",
                        children: t("job_cherry_picking.fulfillment")
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                        className: "JobDetailsCard__data",
                        children: t("job_cherry_picking.fulfillmentRatio", {
                            percent: fullFilmentRatio
                        })
                    })
                ]
            }),
            showStartDate && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "JobDetailsCard__row",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h3", {
                        className: "JobDetailsCard__label",
                        children: t("job_cherry_picking.start_date")
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                        className: "JobDetailsCard__data",
                        children: formatedStartDate
                    })
                ]
            }),
            showEndDate && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "JobDetailsCard__row",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h3", {
                        className: "JobDetailsCard__label",
                        children: t("job_cherry_picking.end_date")
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                        className: "JobDetailsCard__data",
                        children: formatedEndDate
                    })
                ]
            })
        ]
    });
}));
var $3973f6144603dc7a$export$2e2bcd8739ae039 = $3973f6144603dc7a$var$JobDetailsCard;







var $acw62 = parcelRequire("acw62");








var $acw62 = parcelRequire("acw62");
// This icon file is generated automatically.
var $b7bc758130af6b02$var$EyeOutlined = {
    "icon": {
        "tag": "svg",
        "attrs": {
            "viewBox": "64 64 896 896",
            "focusable": "false"
        },
        "children": [
            {
                "tag": "path",
                "attrs": {
                    "d": "M942.2 486.2C847.4 286.5 704.1 186 512 186c-192.2 0-335.4 100.5-430.2 300.3a60.3 60.3 0 000 51.5C176.6 737.5 319.9 838 512 838c192.2 0 335.4-100.5 430.2-300.3 7.7-16.2 7.7-35 0-51.5zM512 766c-161.3 0-279.4-81.8-362.7-254C232.6 339.8 350.7 258 512 258c161.3 0 279.4 81.8 362.7 254C791.5 684.2 673.4 766 512 766zm-4-430c-97.2 0-176 78.8-176 176s78.8 176 176 176 176-78.8 176-176-78.8-176-176-176zm0 288c-61.9 0-112-50.1-112-112s50.1-112 112-112 112 50.1 112 112-50.1 112-112 112z"
                }
            }
        ]
    },
    "name": "eye",
    "theme": "outlined"
};
var $b7bc758130af6b02$export$2e2bcd8739ae039 = $b7bc758130af6b02$var$EyeOutlined;



var $d8a9efd7a074f5f5$var$EyeOutlined = function EyeOutlined(props, ref) {
    return /*#__PURE__*/ $acw62.createElement((0, $7714637e9c1f1f3f$export$2e2bcd8739ae039), (0, $983350b7b3960a26$export$2e2bcd8739ae039)((0, $983350b7b3960a26$export$2e2bcd8739ae039)({}, props), {}, {
        ref: ref,
        icon: (0, $b7bc758130af6b02$export$2e2bcd8739ae039)
    }));
};
$d8a9efd7a074f5f5$var$EyeOutlined.displayName = "EyeOutlined";
var $d8a9efd7a074f5f5$export$2e2bcd8739ae039 = /*#__PURE__*/ $acw62.forwardRef($d8a9efd7a074f5f5$var$EyeOutlined);









var $acw62 = parcelRequire("acw62");

/* eslint-disable no-nested-ternary */ var $cbf8b6c8fd246421$var$PIXEL_PATTERN = /margin|padding|width|height|max|min|offset/;
var $cbf8b6c8fd246421$var$removePixel = {
    left: true,
    top: true
};
var $cbf8b6c8fd246421$var$floatMap = {
    cssFloat: 1,
    styleFloat: 1,
    float: 1
};
function $cbf8b6c8fd246421$var$getComputedStyle(node) {
    return node.nodeType === 1 ? node.ownerDocument.defaultView.getComputedStyle(node, null) : {};
}
function $cbf8b6c8fd246421$var$getStyleValue(node, type, value) {
    type = type.toLowerCase();
    if (value === "auto") {
        if (type === "height") return node.offsetHeight;
        if (type === "width") return node.offsetWidth;
    }
    if (!(type in $cbf8b6c8fd246421$var$removePixel)) $cbf8b6c8fd246421$var$removePixel[type] = $cbf8b6c8fd246421$var$PIXEL_PATTERN.test(type);
    return $cbf8b6c8fd246421$var$removePixel[type] ? parseFloat(value) || 0 : value;
}
function $cbf8b6c8fd246421$export$3988ae62b71be9a3(node, name) {
    var length = arguments.length;
    var style = $cbf8b6c8fd246421$var$getComputedStyle(node);
    name = $cbf8b6c8fd246421$var$floatMap[name] ? "cssFloat" in node.style ? "cssFloat" : "styleFloat" : name;
    return length === 1 ? style : $cbf8b6c8fd246421$var$getStyleValue(node, name, style[name] || node.style[name]);
}
function $cbf8b6c8fd246421$export$adaa4cf7ef1b65be(node, name, value) {
    var length = arguments.length;
    name = $cbf8b6c8fd246421$var$floatMap[name] ? "cssFloat" in node.style ? "cssFloat" : "styleFloat" : name;
    if (length === 3) {
        if (typeof value === "number" && $cbf8b6c8fd246421$var$PIXEL_PATTERN.test(name)) value = "".concat(value, "px");
        node.style[name] = value; // Number
        return value;
    }
    for(var x in name)if (name.hasOwnProperty(x)) $cbf8b6c8fd246421$export$adaa4cf7ef1b65be(node, x, name[x]);
    return $cbf8b6c8fd246421$var$getComputedStyle(node);
}
function $cbf8b6c8fd246421$export$18e9b0709c75d4c5(el) {
    if (el === document.body) return document.documentElement.clientWidth;
    return el.offsetWidth;
}
function $cbf8b6c8fd246421$export$3ef1368fc1aa92de(el) {
    if (el === document.body) return window.innerHeight || document.documentElement.clientHeight;
    return el.offsetHeight;
}
function $cbf8b6c8fd246421$export$fddbd22e9c622ca7() {
    var width = Math.max(document.documentElement.scrollWidth, document.body.scrollWidth);
    var height = Math.max(document.documentElement.scrollHeight, document.body.scrollHeight);
    return {
        width: width,
        height: height
    };
}
function $cbf8b6c8fd246421$export$1feb45891927fcb4() {
    var width = document.documentElement.clientWidth;
    var height = window.innerHeight || document.documentElement.clientHeight;
    return {
        width: width,
        height: height
    };
}
function $cbf8b6c8fd246421$export$ff41c598de81c14a() {
    return {
        scrollLeft: Math.max(document.documentElement.scrollLeft, document.body.scrollLeft),
        scrollTop: Math.max(document.documentElement.scrollTop, document.body.scrollTop)
    };
}
function $cbf8b6c8fd246421$export$622cea445a1c5b7d(node) {
    var box = node.getBoundingClientRect();
    var docElem = document.documentElement;
    // < ie8 不支持 win.pageXOffset, 则使用 docElem.scrollLeft
    return {
        left: box.left + (window.pageXOffset || docElem.scrollLeft) - (docElem.clientLeft || document.body.clientLeft || 0),
        top: box.top + (window.pageYOffset || docElem.scrollTop) - (docElem.clientTop || document.body.clientTop || 0)
    };
}









var $acw62 = parcelRequire("acw62");



var $acw62 = parcelRequire("acw62");





var $acw62 = parcelRequire("acw62");





var $281efe5882c936de$var$attributes = "accept acceptCharset accessKey action allowFullScreen allowTransparency\n    alt async autoComplete autoFocus autoPlay capture cellPadding cellSpacing challenge\n    charSet checked classID className colSpan cols content contentEditable contextMenu\n    controls coords crossOrigin data dateTime default defer dir disabled download draggable\n    encType form formAction formEncType formMethod formNoValidate formTarget frameBorder\n    headers height hidden high href hrefLang htmlFor httpEquiv icon id inputMode integrity\n    is keyParams keyType kind label lang list loop low manifest marginHeight marginWidth max maxLength media\n    mediaGroup method min minLength multiple muted name noValidate nonce open\n    optimum pattern placeholder poster preload radioGroup readOnly rel required\n    reversed role rowSpan rows sandbox scope scoped scrolling seamless selected\n    shape size sizes span spellCheck src srcDoc srcLang srcSet start step style\n    summary tabIndex target title type useMap value width wmode wrap";
var $281efe5882c936de$var$eventsName = "onCopy onCut onPaste onCompositionEnd onCompositionStart onCompositionUpdate onKeyDown\n    onKeyPress onKeyUp onFocus onBlur onChange onInput onSubmit onClick onContextMenu onDoubleClick\n    onDrag onDragEnd onDragEnter onDragExit onDragLeave onDragOver onDragStart onDrop onMouseDown\n    onMouseEnter onMouseLeave onMouseMove onMouseOut onMouseOver onMouseUp onSelect onTouchCancel\n    onTouchEnd onTouchMove onTouchStart onScroll onWheel onAbort onCanPlay onCanPlayThrough\n    onDurationChange onEmptied onEncrypted onEnded onError onLoadedData onLoadedMetadata\n    onLoadStart onPause onPlay onPlaying onProgress onRateChange onSeeked onSeeking onStalled onSuspend onTimeUpdate onVolumeChange onWaiting onLoad onError";
var $281efe5882c936de$var$propList = "".concat($281efe5882c936de$var$attributes, " ").concat($281efe5882c936de$var$eventsName).split(/[\s\n]+/);
/* eslint-enable max-len */ var $281efe5882c936de$var$ariaPrefix = "aria-";
var $281efe5882c936de$var$dataPrefix = "data-";
function $281efe5882c936de$var$match(key, prefix) {
    return key.indexOf(prefix) === 0;
}
function $281efe5882c936de$export$2e2bcd8739ae039(props) {
    var ariaOnly = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    var mergedConfig;
    if (ariaOnly === false) mergedConfig = {
        aria: true,
        data: true,
        attr: true
    };
    else if (ariaOnly === true) mergedConfig = {
        aria: true
    };
    else mergedConfig = (0, $983350b7b3960a26$export$2e2bcd8739ae039)({}, ariaOnly);
    var attrs = {};
    Object.keys(props).forEach(function(key) {
        if (// Aria
        mergedConfig.aria && (key === "role" || $281efe5882c936de$var$match(key, $281efe5882c936de$var$ariaPrefix)) || // Data
        mergedConfig.data && $281efe5882c936de$var$match(key, $281efe5882c936de$var$dataPrefix) || // Attr
        mergedConfig.attr && $281efe5882c936de$var$propList.includes(key)) attrs[key] = props[key];
    });
    return attrs;
}





var $acw62 = parcelRequire("acw62");


function $e10e3c44c896dc47$export$2e2bcd8739ae039(props) {
    var prefixCls = props.prefixCls, style = props.style, visible = props.visible, maskProps = props.maskProps, motionName = props.motionName;
    return /*#__PURE__*/ $acw62.createElement((0, $609e894acbce1933$export$2e2bcd8739ae039), {
        key: "mask",
        visible: visible,
        motionName: motionName,
        leavedClassName: "".concat(prefixCls, "-mask-hidden")
    }, function(_ref, ref) {
        var motionClassName = _ref.className, motionStyle = _ref.style;
        return /*#__PURE__*/ $acw62.createElement("div", (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({
            ref: ref,
            style: (0, $983350b7b3960a26$export$2e2bcd8739ae039)((0, $983350b7b3960a26$export$2e2bcd8739ae039)({}, motionStyle), style),
            className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))("".concat(prefixCls, "-mask"), motionClassName)
        }, maskProps));
    });
}


// =============================== Motion ===============================
function $90c55518cdbfc131$export$ec1a7ebf4579c1c3(prefixCls, transitionName, animationName) {
    var motionName = transitionName;
    if (!motionName && animationName) motionName = "".concat(prefixCls, "-").concat(animationName);
    return motionName;
}
// =============================== Offset ===============================
function $90c55518cdbfc131$var$getScroll(w, top) {
    var ret = w["page".concat(top ? "Y" : "X", "Offset")];
    var method = "scroll".concat(top ? "Top" : "Left");
    if (typeof ret !== "number") {
        var d = w.document;
        ret = d.documentElement[method];
        if (typeof ret !== "number") ret = d.body[method];
    }
    return ret;
}
function $90c55518cdbfc131$export$cc800923e997bb8(el) {
    var rect = el.getBoundingClientRect();
    var pos = {
        left: rect.left,
        top: rect.top
    };
    var doc = el.ownerDocument;
    var w = doc.defaultView || doc.parentWindow;
    pos.left += $90c55518cdbfc131$var$getScroll(w);
    pos.top += $90c55518cdbfc131$var$getScroll(w, true);
    return pos;
}






var $acw62 = parcelRequire("acw62");






var $acw62 = parcelRequire("acw62");


var $acw62 = parcelRequire("acw62");
var $112494d152ccd867$export$2e2bcd8739ae039 = /*#__PURE__*/ $acw62.memo(function(_ref) {
    var children = _ref.children;
    return children;
}, function(_, _ref2) {
    var shouldUpdate = _ref2.shouldUpdate;
    return !shouldUpdate;
});


var $d87bfeabd0b3848d$var$sentinelStyle = {
    width: 0,
    height: 0,
    overflow: "hidden",
    outline: "none"
};
var $d87bfeabd0b3848d$var$Panel = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).forwardRef(function(props, ref) {
    var prefixCls = props.prefixCls, className = props.className, style = props.style, title = props.title, ariaId = props.ariaId, footer = props.footer, closable = props.closable, closeIcon = props.closeIcon, onClose = props.onClose, children = props.children, bodyStyle = props.bodyStyle, bodyProps = props.bodyProps, modalRender = props.modalRender, onMouseDown = props.onMouseDown, onMouseUp = props.onMouseUp, holderRef = props.holderRef, visible = props.visible, forceRender = props.forceRender, width = props.width, height = props.height;
    // ================================= Refs =================================
    var sentinelStartRef = (0, $acw62.useRef)();
    var sentinelEndRef = (0, $acw62.useRef)();
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useImperativeHandle(ref, function() {
        return {
            focus: function focus() {
                var _sentinelStartRef$cur;
                (_sentinelStartRef$cur = sentinelStartRef.current) === null || _sentinelStartRef$cur === void 0 || _sentinelStartRef$cur.focus();
            },
            changeActive: function changeActive(next) {
                var _document = document, activeElement = _document.activeElement;
                if (next && activeElement === sentinelEndRef.current) sentinelStartRef.current.focus();
                else if (!next && activeElement === sentinelStartRef.current) sentinelEndRef.current.focus();
            }
        };
    });
    // ================================ Style =================================
    var contentStyle = {};
    if (width !== undefined) contentStyle.width = width;
    if (height !== undefined) contentStyle.height = height;
    // ================================ Render ================================
    var footerNode;
    if (footer) footerNode = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: "".concat(prefixCls, "-footer")
    }, footer);
    var headerNode;
    if (title) headerNode = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: "".concat(prefixCls, "-header")
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: "".concat(prefixCls, "-title"),
        id: ariaId
    }, title));
    var closer;
    if (closable) closer = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("button", {
        type: "button",
        onClick: onClose,
        "aria-label": "Close",
        className: "".concat(prefixCls, "-close")
    }, closeIcon || /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        className: "".concat(prefixCls, "-close-x")
    }));
    var content = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: "".concat(prefixCls, "-content")
    }, closer, headerNode, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({
        className: "".concat(prefixCls, "-body"),
        style: bodyStyle
    }, bodyProps), children), footerNode);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        key: "dialog-element",
        role: "dialog",
        "aria-labelledby": title ? ariaId : null,
        "aria-modal": "true",
        ref: holderRef,
        style: (0, $983350b7b3960a26$export$2e2bcd8739ae039)((0, $983350b7b3960a26$export$2e2bcd8739ae039)({}, style), contentStyle),
        className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))(prefixCls, className),
        onMouseDown: onMouseDown,
        onMouseUp: onMouseUp
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        tabIndex: 0,
        ref: sentinelStartRef,
        style: $d87bfeabd0b3848d$var$sentinelStyle,
        "aria-hidden": "true"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $112494d152ccd867$export$2e2bcd8739ae039), {
        shouldUpdate: visible || forceRender
    }, modalRender ? modalRender(content) : content), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        tabIndex: 0,
        ref: sentinelEndRef,
        style: $d87bfeabd0b3848d$var$sentinelStyle,
        "aria-hidden": "true"
    }));
});
$d87bfeabd0b3848d$var$Panel.displayName = "Panel";
var $d87bfeabd0b3848d$export$2e2bcd8739ae039 = $d87bfeabd0b3848d$var$Panel;


var $b02b23d234e320c9$var$Content = /*#__PURE__*/ $acw62.forwardRef(function(props, ref) {
    var prefixCls = props.prefixCls, title = props.title, style = props.style, className = props.className, visible = props.visible, forceRender = props.forceRender, destroyOnClose = props.destroyOnClose, motionName = props.motionName, ariaId = props.ariaId, onVisibleChanged = props.onVisibleChanged, mousePosition = props.mousePosition;
    var dialogRef = (0, $acw62.useRef)();
    // ============================= Style ==============================
    var _React$useState = $acw62.useState(), _React$useState2 = (0, $adaabbc18727b3e6$export$2e2bcd8739ae039)(_React$useState, 2), transformOrigin = _React$useState2[0], setTransformOrigin = _React$useState2[1];
    var contentStyle = {};
    if (transformOrigin) contentStyle.transformOrigin = transformOrigin;
    function onPrepare() {
        var elementOffset = (0, $90c55518cdbfc131$export$cc800923e997bb8)(dialogRef.current);
        setTransformOrigin(mousePosition ? "".concat(mousePosition.x - elementOffset.left, "px ").concat(mousePosition.y - elementOffset.top, "px") : "");
    }
    // ============================= Render =============================
    return /*#__PURE__*/ $acw62.createElement((0, $609e894acbce1933$export$2e2bcd8739ae039), {
        visible: visible,
        onVisibleChanged: onVisibleChanged,
        onAppearPrepare: onPrepare,
        onEnterPrepare: onPrepare,
        forceRender: forceRender,
        motionName: motionName,
        removeOnLeave: destroyOnClose,
        ref: dialogRef
    }, function(_ref, motionRef) {
        var motionClassName = _ref.className, motionStyle = _ref.style;
        return /*#__PURE__*/ $acw62.createElement((0, $d87bfeabd0b3848d$export$2e2bcd8739ae039), (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, props, {
            ref: ref,
            title: title,
            ariaId: ariaId,
            prefixCls: prefixCls,
            holderRef: motionRef,
            style: (0, $983350b7b3960a26$export$2e2bcd8739ae039)((0, $983350b7b3960a26$export$2e2bcd8739ae039)((0, $983350b7b3960a26$export$2e2bcd8739ae039)({}, motionStyle), style), contentStyle),
            className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))(className, motionClassName)
        }));
    });
});
$b02b23d234e320c9$var$Content.displayName = "Content";
var $b02b23d234e320c9$export$2e2bcd8739ae039 = $b02b23d234e320c9$var$Content;


function $850025f1cddd8729$export$2e2bcd8739ae039(props) {
    var _props$prefixCls = props.prefixCls, prefixCls = _props$prefixCls === void 0 ? "rc-dialog" : _props$prefixCls, zIndex = props.zIndex, _props$visible = props.visible, visible = _props$visible === void 0 ? false : _props$visible, _props$keyboard = props.keyboard, keyboard = _props$keyboard === void 0 ? true : _props$keyboard, _props$focusTriggerAf = props.focusTriggerAfterClose, focusTriggerAfterClose = _props$focusTriggerAf === void 0 ? true : _props$focusTriggerAf, wrapStyle = props.wrapStyle, wrapClassName = props.wrapClassName, wrapProps = props.wrapProps, onClose = props.onClose, afterClose = props.afterClose, transitionName = props.transitionName, animation = props.animation, _props$closable = props.closable, closable = _props$closable === void 0 ? true : _props$closable, _props$mask = props.mask, mask = _props$mask === void 0 ? true : _props$mask, maskTransitionName = props.maskTransitionName, maskAnimation = props.maskAnimation, _props$maskClosable = props.maskClosable, maskClosable = _props$maskClosable === void 0 ? true : _props$maskClosable, maskStyle = props.maskStyle, maskProps = props.maskProps, rootClassName = props.rootClassName;
    var lastOutSideActiveElementRef = (0, $acw62.useRef)();
    var wrapperRef = (0, $acw62.useRef)();
    var contentRef = (0, $acw62.useRef)();
    var _React$useState = $acw62.useState(visible), _React$useState2 = (0, $adaabbc18727b3e6$export$2e2bcd8739ae039)(_React$useState, 2), animatedVisible = _React$useState2[0], setAnimatedVisible = _React$useState2[1];
    // ========================== Init ==========================
    var ariaId = (0, $d23d006593dfab9c$export$2e2bcd8739ae039)();
    function saveLastOutSideActiveElementRef() {
        if (!(0, $97b4b0194c593c05$export$2e2bcd8739ae039)(wrapperRef.current, document.activeElement)) lastOutSideActiveElementRef.current = document.activeElement;
    }
    function focusDialogContent() {
        if (!(0, $97b4b0194c593c05$export$2e2bcd8739ae039)(wrapperRef.current, document.activeElement)) {
            var _contentRef$current;
            (_contentRef$current = contentRef.current) === null || _contentRef$current === void 0 || _contentRef$current.focus();
        }
    }
    // ========================= Events =========================
    function onDialogVisibleChanged(newVisible) {
        // Try to focus
        if (newVisible) focusDialogContent();
        else {
            // Clean up scroll bar & focus back
            setAnimatedVisible(false);
            if (mask && lastOutSideActiveElementRef.current && focusTriggerAfterClose) {
                try {
                    lastOutSideActiveElementRef.current.focus({
                        preventScroll: true
                    });
                } catch (e) {
                // Do nothing
                }
                lastOutSideActiveElementRef.current = null;
            }
            // Trigger afterClose only when change visible from true to false
            if (animatedVisible) afterClose === null || afterClose === void 0 || afterClose();
        }
    }
    function onInternalClose(e) {
        onClose === null || onClose === void 0 || onClose(e);
    }
    // >>> Content
    var contentClickRef = (0, $acw62.useRef)(false);
    var contentTimeoutRef = (0, $acw62.useRef)();
    // We need record content click incase content popup out of dialog
    var onContentMouseDown = function onContentMouseDown() {
        clearTimeout(contentTimeoutRef.current);
        contentClickRef.current = true;
    };
    var onContentMouseUp = function onContentMouseUp() {
        contentTimeoutRef.current = setTimeout(function() {
            contentClickRef.current = false;
        });
    };
    // >>> Wrapper
    // Close only when element not on dialog
    var onWrapperClick = null;
    if (maskClosable) onWrapperClick = function onWrapperClick(e) {
        if (contentClickRef.current) contentClickRef.current = false;
        else if (wrapperRef.current === e.target) onInternalClose(e);
    };
    function onWrapperKeyDown(e) {
        if (keyboard && e.keyCode === (0, $d8d9cb1a28007639$export$2e2bcd8739ae039).ESC) {
            e.stopPropagation();
            onInternalClose(e);
            return;
        }
        // keep focus inside dialog
        if (visible) {
            if (e.keyCode === (0, $d8d9cb1a28007639$export$2e2bcd8739ae039).TAB) contentRef.current.changeActive(!e.shiftKey);
        }
    }
    // ========================= Effect =========================
    (0, $acw62.useEffect)(function() {
        if (visible) {
            setAnimatedVisible(true);
            saveLastOutSideActiveElementRef();
        }
    }, [
        visible
    ]);
    // Remove direct should also check the scroll bar update
    (0, $acw62.useEffect)(function() {
        return function() {
            clearTimeout(contentTimeoutRef.current);
        };
    }, []);
    // ========================= Render =========================
    return /*#__PURE__*/ $acw62.createElement("div", (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({
        className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))("".concat(prefixCls, "-root"), rootClassName)
    }, (0, $281efe5882c936de$export$2e2bcd8739ae039)(props, {
        data: true
    })), /*#__PURE__*/ $acw62.createElement((0, $e10e3c44c896dc47$export$2e2bcd8739ae039), {
        prefixCls: prefixCls,
        visible: mask && visible,
        motionName: (0, $90c55518cdbfc131$export$ec1a7ebf4579c1c3)(prefixCls, maskTransitionName, maskAnimation),
        style: (0, $983350b7b3960a26$export$2e2bcd8739ae039)({
            zIndex: zIndex
        }, maskStyle),
        maskProps: maskProps
    }), /*#__PURE__*/ $acw62.createElement("div", (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({
        tabIndex: -1,
        onKeyDown: onWrapperKeyDown,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))("".concat(prefixCls, "-wrap"), wrapClassName),
        ref: wrapperRef,
        onClick: onWrapperClick,
        style: (0, $983350b7b3960a26$export$2e2bcd8739ae039)((0, $983350b7b3960a26$export$2e2bcd8739ae039)({
            zIndex: zIndex
        }, wrapStyle), {}, {
            display: !animatedVisible ? "none" : null
        })
    }, wrapProps), /*#__PURE__*/ $acw62.createElement((0, $b02b23d234e320c9$export$2e2bcd8739ae039), (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, props, {
        onMouseDown: onContentMouseDown,
        onMouseUp: onContentMouseUp,
        ref: contentRef,
        closable: closable,
        ariaId: ariaId,
        prefixCls: prefixCls,
        visible: visible && animatedVisible,
        onClose: onInternalClose,
        onVisibleChanged: onDialogVisibleChanged,
        motionName: (0, $90c55518cdbfc131$export$ec1a7ebf4579c1c3)(prefixCls, transitionName, animation)
    }))));
}


// fix issue #10656
/*
 * getContainer remarks
 * Custom container should not be return, because in the Portal component, it will remove the
 * return container element here, if the custom container is the only child of it's component,
 * like issue #10656, It will has a conflict with removeChild method in react-dom.
 * So here should add a child (div element) to custom container.
 * */ var $08b45dfd0eb11827$var$DialogWrap = function DialogWrap(props) {
    var visible = props.visible, getContainer = props.getContainer, forceRender = props.forceRender, _props$destroyOnClose = props.destroyOnClose, destroyOnClose = _props$destroyOnClose === void 0 ? false : _props$destroyOnClose, _afterClose = props.afterClose;
    var _React$useState = $acw62.useState(visible), _React$useState2 = (0, $adaabbc18727b3e6$export$2e2bcd8739ae039)(_React$useState, 2), animatedVisible = _React$useState2[0], setAnimatedVisible = _React$useState2[1];
    $acw62.useEffect(function() {
        if (visible) setAnimatedVisible(true);
    }, [
        visible
    ]);
    // // 渲染在当前 dom 里；
    // if (getContainer === false) {
    //   return (
    //     <Dialog
    //       {...props}
    //       getOpenCount={() => 2} // 不对 body 做任何操作。。
    //     />
    //   );
    // }
    // Destroy on close will remove wrapped div
    if (!forceRender && destroyOnClose && !animatedVisible) return null;
    return /*#__PURE__*/ $acw62.createElement((0, $5b46218595a40828$export$2e2bcd8739ae039), {
        open: visible || forceRender || animatedVisible,
        autoDestroy: false,
        getContainer: getContainer,
        autoLock: visible || animatedVisible
    }, /*#__PURE__*/ $acw62.createElement((0, $850025f1cddd8729$export$2e2bcd8739ae039), (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, props, {
        destroyOnClose: destroyOnClose,
        afterClose: function afterClose() {
            _afterClose === null || _afterClose === void 0 || _afterClose();
            setAnimatedVisible(false);
        }
    })));
};
$08b45dfd0eb11827$var$DialogWrap.displayName = "Dialog";
var $08b45dfd0eb11827$export$2e2bcd8739ae039 = $08b45dfd0eb11827$var$DialogWrap;



var $fc48b5916203bd39$export$2e2bcd8739ae039 = (0, $08b45dfd0eb11827$export$2e2bcd8739ae039);











var $acw62 = parcelRequire("acw62");


var $24a9b4d085f66d2e$var$_excluded = [
    "visible",
    "onVisibleChange",
    "getContainer",
    "current",
    "countRender"
];
var $24a9b4d085f66d2e$export$a078c61943f9dbbe = /*#__PURE__*/ $acw62.createContext({
    previewUrls: new Map(),
    setPreviewUrls: function setPreviewUrls() {
        return null;
    },
    current: null,
    setCurrent: function setCurrent() {
        return null;
    },
    setShowPreview: function setShowPreview() {
        return null;
    },
    setMousePosition: function setMousePosition() {
        return null;
    },
    registerImage: function registerImage() {
        return function() {
            return null;
        };
    },
    rootClassName: ""
});
var $24a9b4d085f66d2e$var$Provider = $24a9b4d085f66d2e$export$a078c61943f9dbbe.Provider;
var $24a9b4d085f66d2e$var$Group = function Group(_ref) {
    var _ref$previewPrefixCls = _ref.previewPrefixCls, previewPrefixCls = _ref$previewPrefixCls === void 0 ? "rc-image-preview" : _ref$previewPrefixCls, children = _ref.children, _ref$icons = _ref.icons, icons = _ref$icons === void 0 ? {} : _ref$icons, preview = _ref.preview;
    var _ref2 = (0, $b8f57191916382d3$export$2e2bcd8739ae039)(preview) === "object" ? preview : {}, _ref2$visible = _ref2.visible, previewVisible = _ref2$visible === void 0 ? undefined : _ref2$visible, _ref2$onVisibleChange = _ref2.onVisibleChange, onPreviewVisibleChange = _ref2$onVisibleChange === void 0 ? undefined : _ref2$onVisibleChange, _ref2$getContainer = _ref2.getContainer, getContainer = _ref2$getContainer === void 0 ? undefined : _ref2$getContainer, _ref2$current = _ref2.current, currentIndex = _ref2$current === void 0 ? 0 : _ref2$current, _ref2$countRender = _ref2.countRender, countRender = _ref2$countRender === void 0 ? undefined : _ref2$countRender, dialogProps = (0, $73ef9ce1c41fc0c0$export$2e2bcd8739ae039)(_ref2, $24a9b4d085f66d2e$var$_excluded);
    var _useState = (0, $acw62.useState)(new Map()), _useState2 = (0, $adaabbc18727b3e6$export$2e2bcd8739ae039)(_useState, 2), previewUrls = _useState2[0], setPreviewUrls = _useState2[1];
    var _useState3 = (0, $acw62.useState)(), _useState4 = (0, $adaabbc18727b3e6$export$2e2bcd8739ae039)(_useState3, 2), current = _useState4[0], setCurrent = _useState4[1];
    var _useMergedState = (0, $dbf5d1f4f4ecbb6a$export$2e2bcd8739ae039)(!!previewVisible, {
        value: previewVisible,
        onChange: onPreviewVisibleChange
    }), _useMergedState2 = (0, $adaabbc18727b3e6$export$2e2bcd8739ae039)(_useMergedState, 2), isShowPreview = _useMergedState2[0], setShowPreview = _useMergedState2[1];
    var _useState5 = (0, $acw62.useState)(null), _useState6 = (0, $adaabbc18727b3e6$export$2e2bcd8739ae039)(_useState5, 2), mousePosition = _useState6[0], setMousePosition = _useState6[1];
    var isControlled = previewVisible !== undefined;
    var previewUrlsKeys = Array.from(previewUrls.keys());
    var currentControlledKey = previewUrlsKeys[currentIndex];
    var canPreviewUrls = new Map(Array.from(previewUrls).filter(function(_ref3) {
        var _ref4 = (0, $adaabbc18727b3e6$export$2e2bcd8739ae039)(_ref3, 2), canPreview = _ref4[1].canPreview;
        return !!canPreview;
    }).map(function(_ref5) {
        var _ref6 = (0, $adaabbc18727b3e6$export$2e2bcd8739ae039)(_ref5, 2), id = _ref6[0], url = _ref6[1].url;
        return [
            id,
            url
        ];
    }));
    var registerImage = function registerImage(id, url) {
        var canPreview = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
        var unRegister = function unRegister() {
            setPreviewUrls(function(oldPreviewUrls) {
                var clonePreviewUrls = new Map(oldPreviewUrls);
                var deleteResult = clonePreviewUrls.delete(id);
                return deleteResult ? clonePreviewUrls : oldPreviewUrls;
            });
        };
        setPreviewUrls(function(oldPreviewUrls) {
            return new Map(oldPreviewUrls).set(id, {
                url: url,
                canPreview: canPreview
            });
        });
        return unRegister;
    };
    var onPreviewClose = function onPreviewClose(e) {
        e.stopPropagation();
        setShowPreview(false);
        setMousePosition(null);
    };
    $acw62.useEffect(function() {
        setCurrent(currentControlledKey);
    }, [
        currentControlledKey
    ]);
    $acw62.useEffect(function() {
        if (!isShowPreview && isControlled) setCurrent(currentControlledKey);
    }, [
        currentControlledKey,
        isControlled,
        isShowPreview
    ]);
    return /*#__PURE__*/ $acw62.createElement($24a9b4d085f66d2e$var$Provider, {
        value: {
            isPreviewGroup: true,
            previewUrls: canPreviewUrls,
            setPreviewUrls: setPreviewUrls,
            current: current,
            setCurrent: setCurrent,
            setShowPreview: setShowPreview,
            setMousePosition: setMousePosition,
            registerImage: registerImage
        }
    }, children, /*#__PURE__*/ $acw62.createElement((0, $642d0c4e097edefe$export$2e2bcd8739ae039), (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({
        "aria-hidden": !isShowPreview,
        visible: isShowPreview,
        prefixCls: previewPrefixCls,
        onClose: onPreviewClose,
        mousePosition: mousePosition,
        src: canPreviewUrls.get(current),
        icons: icons,
        getContainer: getContainer,
        countRender: countRender
    }, dialogProps)));
};
var $24a9b4d085f66d2e$export$2e2bcd8739ae039 = $24a9b4d085f66d2e$var$Group;




var $acw62 = parcelRequire("acw62");



/** Minimum scale */ var $e759751996a0e6db$export$e4985ca28e204935 = 1;
var $e759751996a0e6db$export$44e5bd0fef8d913c = 50;
var $e759751996a0e6db$export$6e76060232ffaf48 = 1;
var $e759751996a0e6db$export$137a7d87d4a2aae5 = 0.2;


var $ad989023bcb6c68a$var$Operations = function Operations(props) {
    var _countRender;
    var visible = props.visible, maskTransitionName = props.maskTransitionName, getContainer = props.getContainer, prefixCls = props.prefixCls, rootClassName = props.rootClassName, icons = props.icons, countRender = props.countRender, showSwitch = props.showSwitch, showProgress = props.showProgress, current = props.current, count = props.count, scale = props.scale, onSwitchLeft = props.onSwitchLeft, onSwitchRight = props.onSwitchRight, onClose = props.onClose, onZoomIn = props.onZoomIn, onZoomOut = props.onZoomOut, onRotateRight = props.onRotateRight, onRotateLeft = props.onRotateLeft;
    var rotateLeft = icons.rotateLeft, rotateRight = icons.rotateRight, zoomIn = icons.zoomIn, zoomOut = icons.zoomOut, close = icons.close, left = icons.left, right = icons.right;
    var toolClassName = "".concat(prefixCls, "-operations-operation");
    var iconClassName = "".concat(prefixCls, "-operations-icon");
    var tools = [
        {
            icon: close,
            onClick: onClose,
            type: "close"
        },
        {
            icon: zoomIn,
            onClick: onZoomIn,
            type: "zoomIn",
            disabled: scale === (0, $e759751996a0e6db$export$44e5bd0fef8d913c)
        },
        {
            icon: zoomOut,
            onClick: onZoomOut,
            type: "zoomOut",
            disabled: scale === (0, $e759751996a0e6db$export$e4985ca28e204935)
        },
        {
            icon: rotateRight,
            onClick: onRotateRight,
            type: "rotateRight"
        },
        {
            icon: rotateLeft,
            onClick: onRotateLeft,
            type: "rotateLeft"
        }
    ];
    var operations = /*#__PURE__*/ $acw62.createElement($acw62.Fragment, null, showSwitch && /*#__PURE__*/ $acw62.createElement($acw62.Fragment, null, /*#__PURE__*/ $acw62.createElement("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))("".concat(prefixCls, "-switch-left"), (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)({}, "".concat(prefixCls, "-switch-left-disabled"), current === 0)),
        onClick: onSwitchLeft
    }, left), /*#__PURE__*/ $acw62.createElement("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))("".concat(prefixCls, "-switch-right"), (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)({}, "".concat(prefixCls, "-switch-right-disabled"), current === count - 1)),
        onClick: onSwitchRight
    }, right)), /*#__PURE__*/ $acw62.createElement("ul", {
        className: "".concat(prefixCls, "-operations")
    }, showProgress && /*#__PURE__*/ $acw62.createElement("li", {
        className: "".concat(prefixCls, "-operations-progress")
    }, (_countRender = countRender === null || countRender === void 0 ? void 0 : countRender(current + 1, count)) !== null && _countRender !== void 0 ? _countRender : "".concat(current + 1, " / ").concat(count)), tools.map(function(_ref) {
        var _classnames3;
        var icon = _ref.icon, onClick = _ref.onClick, type = _ref.type, disabled = _ref.disabled;
        return /*#__PURE__*/ $acw62.createElement("li", {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))(toolClassName, (_classnames3 = {}, (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)(_classnames3, "".concat(prefixCls, "-operations-operation-").concat(type), true), (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)(_classnames3, "".concat(prefixCls, "-operations-operation-disabled"), !!disabled), _classnames3)),
            onClick: onClick,
            key: type
        }, /*#__PURE__*/ $acw62.isValidElement(icon) ? /*#__PURE__*/ $acw62.cloneElement(icon, {
            className: iconClassName
        }) : icon);
    })));
    return /*#__PURE__*/ $acw62.createElement((0, $609e894acbce1933$export$2e2bcd8739ae039), {
        visible: visible,
        motionName: maskTransitionName
    }, function(_ref2) {
        var className = _ref2.className, style = _ref2.style;
        return /*#__PURE__*/ $acw62.createElement((0, $5b46218595a40828$export$2e2bcd8739ae039), {
            open: true,
            getContainer: getContainer !== null && getContainer !== void 0 ? getContainer : document.body
        }, /*#__PURE__*/ $acw62.createElement("div", {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))("".concat(prefixCls, "-operations-wrapper"), className, rootClassName),
            style: style
        }, operations));
    });
};
var $ad989023bcb6c68a$export$2e2bcd8739ae039 = $ad989023bcb6c68a$var$Operations;





var $acw62 = parcelRequire("acw62");



var $8042920a8b955a80$var$initialTransform = {
    x: 0,
    y: 0,
    rotate: 0,
    scale: 1
};
function $8042920a8b955a80$export$2e2bcd8739ae039(imgRef) {
    var frame = (0, $acw62.useRef)(null);
    var queue = (0, $acw62.useRef)([]);
    var _useState = (0, $acw62.useState)($8042920a8b955a80$var$initialTransform), _useState2 = (0, $adaabbc18727b3e6$export$2e2bcd8739ae039)(_useState, 2), transform = _useState2[0], setTransform = _useState2[1];
    var resetTransform = function resetTransform() {
        setTransform($8042920a8b955a80$var$initialTransform);
    };
    /** Direct update transform */ var updateTransform = function updateTransform(newTransform) {
        if (frame.current === null) {
            queue.current = [];
            frame.current = (0, $a1ced7b983ea61a4$export$2e2bcd8739ae039)(function() {
                setTransform(function(preState) {
                    var memoState = preState;
                    queue.current.forEach(function(queueState) {
                        memoState = (0, $983350b7b3960a26$export$2e2bcd8739ae039)((0, $983350b7b3960a26$export$2e2bcd8739ae039)({}, memoState), queueState);
                    });
                    frame.current = null;
                    return memoState;
                });
            });
        }
        queue.current.push((0, $983350b7b3960a26$export$2e2bcd8739ae039)((0, $983350b7b3960a26$export$2e2bcd8739ae039)({}, transform), newTransform));
    };
    /** Scale according to the position of clientX and clientY */ var dispatchZoonChange = function dispatchZoonChange(ratio, clientX, clientY) {
        var _imgRef$current = imgRef.current, width = _imgRef$current.width, height = _imgRef$current.height, offsetWidth = _imgRef$current.offsetWidth, offsetHeight = _imgRef$current.offsetHeight, offsetLeft = _imgRef$current.offsetLeft, offsetTop = _imgRef$current.offsetTop;
        var newRatio = ratio;
        var newScale = transform.scale * ratio;
        if (newScale > (0, $e759751996a0e6db$export$44e5bd0fef8d913c)) {
            newRatio = (0, $e759751996a0e6db$export$44e5bd0fef8d913c) / transform.scale;
            newScale = (0, $e759751996a0e6db$export$44e5bd0fef8d913c);
        } else if (newScale < (0, $e759751996a0e6db$export$e4985ca28e204935)) {
            newRatio = (0, $e759751996a0e6db$export$e4985ca28e204935) / transform.scale;
            newScale = (0, $e759751996a0e6db$export$e4985ca28e204935);
        }
        /** Default center point scaling */ var mergedClientX = clientX !== null && clientX !== void 0 ? clientX : innerWidth / 2;
        var mergedClientY = clientY !== null && clientY !== void 0 ? clientY : innerHeight / 2;
        var diffRatio = newRatio - 1;
        /** Deviation calculated from image size */ var diffImgX = diffRatio * width * 0.5;
        var diffImgY = diffRatio * height * 0.5;
        /** The difference between the click position and the edge of the document */ var diffOffsetLeft = diffRatio * (mergedClientX - transform.x - offsetLeft);
        var diffOffsetTop = diffRatio * (mergedClientY - transform.y - offsetTop);
        /** Final positioning */ var newX = transform.x - (diffOffsetLeft - diffImgX);
        var newY = transform.y - (diffOffsetTop - diffImgY);
        /**
     * When zooming the image
     * When the image size is smaller than the width and height of the window, the position is initialized
     */ if (ratio < 1 && newScale === 1) {
            var mergedWidth = offsetWidth * newScale;
            var mergedHeight = offsetHeight * newScale;
            var _getClientSize = (0, $cbf8b6c8fd246421$export$1feb45891927fcb4)(), clientWidth = _getClientSize.width, clientHeight = _getClientSize.height;
            if (mergedWidth <= clientWidth && mergedHeight <= clientHeight) {
                newX = 0;
                newY = 0;
            }
        }
        updateTransform({
            x: newX,
            y: newY,
            scale: newScale
        });
    };
    return {
        transform: transform,
        resetTransform: resetTransform,
        updateTransform: updateTransform,
        dispatchZoonChange: dispatchZoonChange
    };
}





function $72833f9ac99418e5$var$fixPoint(key, start, width, clientWidth) {
    var startAddWidth = start + width;
    var offsetStart = (width - clientWidth) / 2;
    if (width > clientWidth) {
        if (start > 0) return (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)({}, key, offsetStart);
        if (start < 0 && startAddWidth < clientWidth) return (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)({}, key, -offsetStart);
    } else if (start < 0 || startAddWidth > clientWidth) return (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)({}, key, start < 0 ? offsetStart : -offsetStart);
    return {};
}
function $72833f9ac99418e5$export$2e2bcd8739ae039(width, height, left, top) {
    var _getClientSize = (0, $cbf8b6c8fd246421$export$1feb45891927fcb4)(), clientWidth = _getClientSize.width, clientHeight = _getClientSize.height;
    var fixPos = null;
    if (width <= clientWidth && height <= clientHeight) fixPos = {
        x: 0,
        y: 0
    };
    else if (width > clientWidth || height > clientHeight) fixPos = (0, $983350b7b3960a26$export$2e2bcd8739ae039)((0, $983350b7b3960a26$export$2e2bcd8739ae039)({}, $72833f9ac99418e5$var$fixPoint("x", left, width, clientWidth)), $72833f9ac99418e5$var$fixPoint("y", top, height, clientHeight));
    return fixPos;
}



var $642d0c4e097edefe$var$_excluded = [
    "prefixCls",
    "src",
    "alt",
    "onClose",
    "afterClose",
    "visible",
    "icons",
    "rootClassName",
    "getContainer",
    "countRender",
    "scaleStep",
    "transitionName",
    "maskTransitionName"
];
var $642d0c4e097edefe$var$Preview = function Preview(props) {
    var prefixCls = props.prefixCls, src = props.src, alt = props.alt, onClose = props.onClose, afterClose = props.afterClose, visible = props.visible, _props$icons = props.icons, icons = _props$icons === void 0 ? {} : _props$icons, rootClassName = props.rootClassName, getContainer = props.getContainer, countRender = props.countRender, _props$scaleStep = props.scaleStep, scaleStep = _props$scaleStep === void 0 ? 0.5 : _props$scaleStep, _props$transitionName = props.transitionName, transitionName = _props$transitionName === void 0 ? "zoom" : _props$transitionName, _props$maskTransition = props.maskTransitionName, maskTransitionName = _props$maskTransition === void 0 ? "fade" : _props$maskTransition, restProps = (0, $73ef9ce1c41fc0c0$export$2e2bcd8739ae039)(props, $642d0c4e097edefe$var$_excluded);
    var imgRef = (0, $acw62.useRef)();
    var downPositionRef = (0, $acw62.useRef)({
        deltaX: 0,
        deltaY: 0,
        transformX: 0,
        transformY: 0
    });
    var _useState = (0, $acw62.useState)(false), _useState2 = (0, $adaabbc18727b3e6$export$2e2bcd8739ae039)(_useState, 2), isMoving = _useState2[0], setMoving = _useState2[1];
    var _useContext = (0, $acw62.useContext)((0, $24a9b4d085f66d2e$export$a078c61943f9dbbe)), previewUrls = _useContext.previewUrls, current = _useContext.current, isPreviewGroup = _useContext.isPreviewGroup, setCurrent = _useContext.setCurrent;
    var previewGroupCount = previewUrls.size;
    var previewUrlsKeys = Array.from(previewUrls.keys());
    var currentPreviewIndex = previewUrlsKeys.indexOf(current);
    var combinationSrc = isPreviewGroup ? previewUrls.get(current) : src;
    var showLeftOrRightSwitches = isPreviewGroup && previewGroupCount > 1;
    var showOperationsProgress = isPreviewGroup && previewGroupCount >= 1;
    var _useImageTransform = (0, $8042920a8b955a80$export$2e2bcd8739ae039)(imgRef), transform = _useImageTransform.transform, resetTransform = _useImageTransform.resetTransform, updateTransform = _useImageTransform.updateTransform, dispatchZoonChange = _useImageTransform.dispatchZoonChange;
    var rotate = transform.rotate, scale = transform.scale;
    var wrapClassName = (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))((0, $f329557dcab6d0bb$export$2e2bcd8739ae039)({}, "".concat(prefixCls, "-moving"), isMoving));
    var onAfterClose = function onAfterClose() {
        resetTransform();
    };
    var onZoomIn = function onZoomIn() {
        dispatchZoonChange((0, $e759751996a0e6db$export$6e76060232ffaf48) + scaleStep);
    };
    var onZoomOut = function onZoomOut() {
        dispatchZoonChange((0, $e759751996a0e6db$export$6e76060232ffaf48) - scaleStep);
    };
    var onRotateRight = function onRotateRight() {
        updateTransform({
            rotate: rotate + 90
        });
    };
    var onRotateLeft = function onRotateLeft() {
        updateTransform({
            rotate: rotate - 90
        });
    };
    var onSwitchLeft = function onSwitchLeft(event) {
        event.preventDefault();
        event.stopPropagation();
        if (currentPreviewIndex > 0) setCurrent(previewUrlsKeys[currentPreviewIndex - 1]);
    };
    var onSwitchRight = function onSwitchRight(event) {
        event.preventDefault();
        event.stopPropagation();
        if (currentPreviewIndex < previewGroupCount - 1) setCurrent(previewUrlsKeys[currentPreviewIndex + 1]);
    };
    var onMouseUp = function onMouseUp() {
        if (visible && isMoving) {
            setMoving(false);
            /** No need to restore the position when the picture is not moved, So as not to interfere with the click */ var _downPositionRef$curr = downPositionRef.current, transformX = _downPositionRef$curr.transformX, transformY = _downPositionRef$curr.transformY;
            var hasChangedPosition = transform.x !== transformX && transform.y !== transformY;
            if (!hasChangedPosition) return;
            var width = imgRef.current.offsetWidth * scale;
            var height = imgRef.current.offsetHeight * scale; // eslint-disable-next-line @typescript-eslint/no-shadow
            var _imgRef$current$getBo = imgRef.current.getBoundingClientRect(), left = _imgRef$current$getBo.left, top = _imgRef$current$getBo.top;
            var isRotate = rotate % 180 !== 0;
            var fixState = (0, $72833f9ac99418e5$export$2e2bcd8739ae039)(isRotate ? height : width, isRotate ? width : height, left, top);
            if (fixState) updateTransform((0, $983350b7b3960a26$export$2e2bcd8739ae039)({}, fixState));
        }
    };
    var onMouseDown = function onMouseDown(event) {
        // Only allow main button
        if (event.button !== 0) return;
        event.preventDefault();
        event.stopPropagation();
        downPositionRef.current = {
            deltaX: event.pageX - transform.x,
            deltaY: event.pageY - transform.y,
            transformX: transform.x,
            transformY: transform.y
        };
        setMoving(true);
    };
    var onMouseMove = function onMouseMove(event) {
        if (visible && isMoving) updateTransform({
            x: event.pageX - downPositionRef.current.deltaX,
            y: event.pageY - downPositionRef.current.deltaY
        });
    };
    var onWheel = function onWheel(event) {
        if (!visible || event.deltaY == 0) return; // Scale ratio depends on the deltaY size
        var scaleRatio = Math.abs(event.deltaY / 100); // Limit the maximum scale ratio
        var mergedScaleRatio = Math.min(scaleRatio, (0, $e759751996a0e6db$export$137a7d87d4a2aae5)); // Scale the ratio each time
        var ratio = (0, $e759751996a0e6db$export$6e76060232ffaf48) + mergedScaleRatio * scaleStep;
        if (event.deltaY > 0) ratio = (0, $e759751996a0e6db$export$6e76060232ffaf48) / ratio;
        dispatchZoonChange(ratio, event.clientX, event.clientY);
    };
    var onKeyDown = (0, $acw62.useCallback)(function(event) {
        if (!visible || !showLeftOrRightSwitches) return;
        if (event.keyCode === (0, $d8d9cb1a28007639$export$2e2bcd8739ae039).LEFT) {
            if (currentPreviewIndex > 0) setCurrent(previewUrlsKeys[currentPreviewIndex - 1]);
        } else if (event.keyCode === (0, $d8d9cb1a28007639$export$2e2bcd8739ae039).RIGHT) {
            if (currentPreviewIndex < previewGroupCount - 1) setCurrent(previewUrlsKeys[currentPreviewIndex + 1]);
        }
    }, [
        currentPreviewIndex,
        previewGroupCount,
        previewUrlsKeys,
        setCurrent,
        showLeftOrRightSwitches,
        visible
    ]);
    var onDoubleClick = function onDoubleClick(event) {
        if (visible) {
            if (scale !== 1) updateTransform({
                x: 0,
                y: 0,
                scale: 1
            });
            else dispatchZoonChange((0, $e759751996a0e6db$export$6e76060232ffaf48) + scaleStep, event.clientX, event.clientY);
        }
    };
    (0, $acw62.useEffect)(function() {
        var onTopMouseUpListener;
        var onTopMouseMoveListener;
        var onMouseUpListener = (0, $0860008a706f6e42$export$2e2bcd8739ae039)(window, "mouseup", onMouseUp, false);
        var onMouseMoveListener = (0, $0860008a706f6e42$export$2e2bcd8739ae039)(window, "mousemove", onMouseMove, false);
        var onKeyDownListener = (0, $0860008a706f6e42$export$2e2bcd8739ae039)(window, "keydown", onKeyDown, false);
        try {
            // Resolve if in iframe lost event
            /* istanbul ignore next */ if (window.top !== window.self) {
                onTopMouseUpListener = (0, $0860008a706f6e42$export$2e2bcd8739ae039)(window.top, "mouseup", onMouseUp, false);
                onTopMouseMoveListener = (0, $0860008a706f6e42$export$2e2bcd8739ae039)(window.top, "mousemove", onMouseMove, false);
            }
        } catch (error) {
            /* istanbul ignore next */ (0, $05a5f2c645683a81$export$491112666e282270)(false, "[rc-image] ".concat(error));
        }
        return function() {
            var _onTopMouseUpListener, _onTopMouseMoveListen;
            onMouseUpListener.remove();
            onMouseMoveListener.remove();
            onKeyDownListener.remove();
            /* istanbul ignore next */ (_onTopMouseUpListener = onTopMouseUpListener) === null || _onTopMouseUpListener === void 0 || _onTopMouseUpListener.remove();
            /* istanbul ignore next */ (_onTopMouseMoveListen = onTopMouseMoveListener) === null || _onTopMouseMoveListen === void 0 || _onTopMouseMoveListen.remove();
        };
    }, [
        visible,
        isMoving,
        onKeyDown
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $fc48b5916203bd39$export$2e2bcd8739ae039), (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({
        transitionName: transitionName,
        maskTransitionName: maskTransitionName,
        closable: false,
        keyboard: true,
        prefixCls: prefixCls,
        onClose: onClose,
        afterClose: onAfterClose,
        visible: visible,
        wrapClassName: wrapClassName,
        rootClassName: rootClassName,
        getContainer: getContainer
    }, restProps), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: "".concat(prefixCls, "-img-wrapper")
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("img", {
        width: props.width,
        height: props.height,
        onWheel: onWheel,
        onMouseDown: onMouseDown,
        onDoubleClick: onDoubleClick,
        ref: imgRef,
        className: "".concat(prefixCls, "-img"),
        src: combinationSrc,
        alt: alt,
        style: {
            transform: "translate3d(".concat(transform.x, "px, ").concat(transform.y, "px, 0) scale3d(").concat(scale, ", ").concat(scale, ", 1) rotate(").concat(rotate, "deg)")
        }
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $ad989023bcb6c68a$export$2e2bcd8739ae039), {
        visible: visible,
        maskTransitionName: maskTransitionName,
        getContainer: getContainer,
        prefixCls: prefixCls,
        rootClassName: rootClassName,
        icons: icons,
        countRender: countRender,
        showSwitch: showLeftOrRightSwitches,
        showProgress: showOperationsProgress,
        current: currentPreviewIndex,
        count: previewGroupCount,
        scale: scale,
        onSwitchLeft: onSwitchLeft,
        onSwitchRight: onSwitchRight,
        onZoomIn: onZoomIn,
        onZoomOut: onZoomOut,
        onRotateRight: onRotateRight,
        onRotateLeft: onRotateLeft,
        onClose: onClose
    }));
};
var $642d0c4e097edefe$export$2e2bcd8739ae039 = $642d0c4e097edefe$var$Preview;



var $bca85f3e75975fa9$var$_excluded = [
    "src",
    "alt",
    "onPreviewClose",
    "prefixCls",
    "previewPrefixCls",
    "placeholder",
    "fallback",
    "width",
    "height",
    "style",
    "preview",
    "className",
    "onClick",
    "onError",
    "wrapperClassName",
    "wrapperStyle",
    "rootClassName",
    "crossOrigin",
    "decoding",
    "loading",
    "referrerPolicy",
    "sizes",
    "srcSet",
    "useMap",
    "draggable"
], $bca85f3e75975fa9$var$_excluded2 = [
    "src",
    "visible",
    "onVisibleChange",
    "getContainer",
    "mask",
    "maskClassName",
    "icons",
    "scaleStep"
];
var $bca85f3e75975fa9$var$uuid = 0;
var $bca85f3e75975fa9$var$ImageInternal = function ImageInternal(_ref) {
    var _imgCommonProps$style;
    var imgSrc = _ref.src, alt = _ref.alt, onInitialPreviewClose = _ref.onPreviewClose, _ref$prefixCls = _ref.prefixCls, prefixCls = _ref$prefixCls === void 0 ? "rc-image" : _ref$prefixCls, _ref$previewPrefixCls = _ref.previewPrefixCls, previewPrefixCls = _ref$previewPrefixCls === void 0 ? "".concat(prefixCls, "-preview") : _ref$previewPrefixCls, placeholder = _ref.placeholder, fallback = _ref.fallback, width = _ref.width, height = _ref.height, style = _ref.style, _ref$preview = _ref.preview, preview = _ref$preview === void 0 ? true : _ref$preview, className = _ref.className, onClick = _ref.onClick, onImageError = _ref.onError, wrapperClassName = _ref.wrapperClassName, wrapperStyle = _ref.wrapperStyle, rootClassName = _ref.rootClassName, crossOrigin = _ref.crossOrigin, decoding = _ref.decoding, loading = _ref.loading, referrerPolicy = _ref.referrerPolicy, sizes = _ref.sizes, srcSet = _ref.srcSet, useMap = _ref.useMap, draggable = _ref.draggable, otherProps = (0, $73ef9ce1c41fc0c0$export$2e2bcd8739ae039)(_ref, $bca85f3e75975fa9$var$_excluded);
    var isCustomPlaceholder = placeholder && placeholder !== true;
    var _ref2 = (0, $b8f57191916382d3$export$2e2bcd8739ae039)(preview) === "object" ? preview : {}, previewSrc = _ref2.src, _ref2$visible = _ref2.visible, previewVisible = _ref2$visible === void 0 ? undefined : _ref2$visible, _ref2$onVisibleChange = _ref2.onVisibleChange, onPreviewVisibleChange = _ref2$onVisibleChange === void 0 ? onInitialPreviewClose : _ref2$onVisibleChange, _ref2$getContainer = _ref2.getContainer, getPreviewContainer = _ref2$getContainer === void 0 ? undefined : _ref2$getContainer, previewMask = _ref2.mask, maskClassName = _ref2.maskClassName, icons = _ref2.icons, scaleStep = _ref2.scaleStep, dialogProps = (0, $73ef9ce1c41fc0c0$export$2e2bcd8739ae039)(_ref2, $bca85f3e75975fa9$var$_excluded2);
    var src = previewSrc !== null && previewSrc !== void 0 ? previewSrc : imgSrc;
    var isControlled = previewVisible !== undefined;
    var _useMergedState = (0, $dbf5d1f4f4ecbb6a$export$2e2bcd8739ae039)(!!previewVisible, {
        value: previewVisible,
        onChange: onPreviewVisibleChange
    }), _useMergedState2 = (0, $adaabbc18727b3e6$export$2e2bcd8739ae039)(_useMergedState, 2), isShowPreview = _useMergedState2[0], setShowPreview = _useMergedState2[1];
    var _useState = (0, $acw62.useState)(isCustomPlaceholder ? "loading" : "normal"), _useState2 = (0, $adaabbc18727b3e6$export$2e2bcd8739ae039)(_useState, 2), status = _useState2[0], setStatus = _useState2[1];
    var _useState3 = (0, $acw62.useState)(null), _useState4 = (0, $adaabbc18727b3e6$export$2e2bcd8739ae039)(_useState3, 2), mousePosition = _useState4[0], setMousePosition = _useState4[1];
    var isError = status === "error";
    var _React$useContext = $acw62.useContext((0, $24a9b4d085f66d2e$export$a078c61943f9dbbe)), isPreviewGroup = _React$useContext.isPreviewGroup, setCurrent = _React$useContext.setCurrent, setGroupShowPreview = _React$useContext.setShowPreview, setGroupMousePosition = _React$useContext.setMousePosition, registerImage = _React$useContext.registerImage;
    var _React$useState = $acw62.useState(function() {
        $bca85f3e75975fa9$var$uuid += 1;
        return $bca85f3e75975fa9$var$uuid;
    }), _React$useState2 = (0, $adaabbc18727b3e6$export$2e2bcd8739ae039)(_React$useState, 1), currentId = _React$useState2[0];
    var canPreview = !!preview;
    var isLoaded = $acw62.useRef(false);
    var onLoad = function onLoad() {
        setStatus("normal");
    };
    var onError = function onError(e) {
        if (onImageError) onImageError(e);
        setStatus("error");
    };
    var onPreview = function onPreview(e) {
        if (!isControlled) {
            var _getOffset = (0, $cbf8b6c8fd246421$export$622cea445a1c5b7d)(e.target), left = _getOffset.left, top = _getOffset.top;
            if (isPreviewGroup) {
                setCurrent(currentId);
                setGroupMousePosition({
                    x: left,
                    y: top
                });
            } else setMousePosition({
                x: left,
                y: top
            });
        }
        if (isPreviewGroup) setGroupShowPreview(true);
        else setShowPreview(true);
        if (onClick) onClick(e);
    };
    var onPreviewClose = function onPreviewClose(e) {
        e.stopPropagation();
        setShowPreview(false);
        if (!isControlled) setMousePosition(null);
    };
    var getImgRef = function getImgRef(img) {
        isLoaded.current = false;
        if (status !== "loading") return;
        if (img !== null && img !== void 0 && img.complete && (img.naturalWidth || img.naturalHeight)) {
            isLoaded.current = true;
            onLoad();
        }
    }; // Keep order start
    // Resolve https://github.com/ant-design/ant-design/issues/28881
    // Only need unRegister when component unMount
    $acw62.useEffect(function() {
        var unRegister = registerImage(currentId, src);
        return unRegister;
    }, []);
    $acw62.useEffect(function() {
        registerImage(currentId, src, canPreview);
    }, [
        src,
        canPreview
    ]); // Keep order end
    $acw62.useEffect(function() {
        if (isError) setStatus("normal");
        if (isCustomPlaceholder && !isLoaded.current) setStatus("loading");
    }, [
        imgSrc
    ]);
    var wrapperClass = (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))(prefixCls, wrapperClassName, rootClassName, (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)({}, "".concat(prefixCls, "-error"), isError));
    var mergedSrc = isError && fallback ? fallback : src;
    var imgCommonProps = {
        crossOrigin: crossOrigin,
        decoding: decoding,
        draggable: draggable,
        loading: loading,
        referrerPolicy: referrerPolicy,
        sizes: sizes,
        srcSet: srcSet,
        useMap: useMap,
        alt: alt,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))("".concat(prefixCls, "-img"), (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)({}, "".concat(prefixCls, "-img-placeholder"), placeholder === true), className),
        style: (0, $983350b7b3960a26$export$2e2bcd8739ae039)({
            height: height
        }, style)
    };
    return /*#__PURE__*/ $acw62.createElement($acw62.Fragment, null, /*#__PURE__*/ $acw62.createElement("div", (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, otherProps, {
        className: wrapperClass,
        onClick: canPreview ? onPreview : onClick,
        style: (0, $983350b7b3960a26$export$2e2bcd8739ae039)({
            width: width,
            height: height
        }, wrapperStyle)
    }), /*#__PURE__*/ $acw62.createElement("img", (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, imgCommonProps, {
        ref: getImgRef
    }, isError && fallback ? {
        src: fallback
    } : {
        onLoad: onLoad,
        onError: onError,
        src: imgSrc
    }, {
        width: width,
        height: height
    })), status === "loading" && /*#__PURE__*/ $acw62.createElement("div", {
        "aria-hidden": "true",
        className: "".concat(prefixCls, "-placeholder")
    }, placeholder), previewMask && canPreview && /*#__PURE__*/ $acw62.createElement("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))("".concat(prefixCls, "-mask"), maskClassName),
        style: {
            display: ((_imgCommonProps$style = imgCommonProps.style) === null || _imgCommonProps$style === void 0 ? void 0 : _imgCommonProps$style.display) === "none" ? "none" : undefined
        }
    }, previewMask)), !isPreviewGroup && canPreview && /*#__PURE__*/ $acw62.createElement((0, $642d0c4e097edefe$export$2e2bcd8739ae039), (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({
        "aria-hidden": !isShowPreview,
        visible: isShowPreview,
        prefixCls: previewPrefixCls,
        onClose: onPreviewClose,
        mousePosition: mousePosition,
        src: mergedSrc,
        alt: alt,
        getContainer: getPreviewContainer,
        icons: icons,
        scaleStep: scaleStep,
        rootClassName: rootClassName
    }, dialogProps)));
};
$bca85f3e75975fa9$var$ImageInternal.PreviewGroup = (0, $24a9b4d085f66d2e$export$2e2bcd8739ae039);
$bca85f3e75975fa9$var$ImageInternal.displayName = "Image";
var $bca85f3e75975fa9$export$2e2bcd8739ae039 = $bca85f3e75975fa9$var$ImageInternal;


var $b8e27e74b4085961$export$2e2bcd8739ae039 = (0, $bca85f3e75975fa9$export$2e2bcd8739ae039);



var $acw62 = parcelRequire("acw62");


var $c7d8dfeaf08e9faa$export$2e2bcd8739ae039 = (0, $8cffcf0f0d1231b6$export$2e2bcd8739ae039);








var $acw62 = parcelRequire("acw62");
// This icon file is generated automatically.
var $766a51baf3f136aa$var$LeftOutlined = {
    "icon": {
        "tag": "svg",
        "attrs": {
            "viewBox": "64 64 896 896",
            "focusable": "false"
        },
        "children": [
            {
                "tag": "path",
                "attrs": {
                    "d": "M724 218.3V141c0-6.7-7.7-10.4-12.9-6.3L260.3 486.8a31.86 31.86 0 000 50.3l450.8 352.1c5.3 4.1 12.9.4 12.9-6.3v-77.3c0-4.9-2.3-9.6-6.1-12.6l-360-281 360-281.1c3.8-3 6.1-7.7 6.1-12.6z"
                }
            }
        ]
    },
    "name": "left",
    "theme": "outlined"
};
var $766a51baf3f136aa$export$2e2bcd8739ae039 = $766a51baf3f136aa$var$LeftOutlined;



var $1e62197f718e4845$var$LeftOutlined = function LeftOutlined(props, ref) {
    return /*#__PURE__*/ $acw62.createElement((0, $7714637e9c1f1f3f$export$2e2bcd8739ae039), (0, $983350b7b3960a26$export$2e2bcd8739ae039)((0, $983350b7b3960a26$export$2e2bcd8739ae039)({}, props), {}, {
        ref: ref,
        icon: (0, $766a51baf3f136aa$export$2e2bcd8739ae039)
    }));
};
$1e62197f718e4845$var$LeftOutlined.displayName = "LeftOutlined";
var $1e62197f718e4845$export$2e2bcd8739ae039 = /*#__PURE__*/ $acw62.forwardRef($1e62197f718e4845$var$LeftOutlined);




var $acw62 = parcelRequire("acw62");
// This icon file is generated automatically.
var $73624b371df38195$var$RightOutlined = {
    "icon": {
        "tag": "svg",
        "attrs": {
            "viewBox": "64 64 896 896",
            "focusable": "false"
        },
        "children": [
            {
                "tag": "path",
                "attrs": {
                    "d": "M765.7 486.8L314.9 134.7A7.97 7.97 0 00302 141v77.3c0 4.9 2.3 9.6 6.1 12.6l360 281.1-360 281.1c-3.9 3-6.1 7.7-6.1 12.6V883c0 6.7 7.7 10.4 12.9 6.3l450.8-352.1a31.96 31.96 0 000-50.4z"
                }
            }
        ]
    },
    "name": "right",
    "theme": "outlined"
};
var $73624b371df38195$export$2e2bcd8739ae039 = $73624b371df38195$var$RightOutlined;



var $ae197ef38b34eab8$var$RightOutlined = function RightOutlined(props, ref) {
    return /*#__PURE__*/ $acw62.createElement((0, $7714637e9c1f1f3f$export$2e2bcd8739ae039), (0, $983350b7b3960a26$export$2e2bcd8739ae039)((0, $983350b7b3960a26$export$2e2bcd8739ae039)({}, props), {}, {
        ref: ref,
        icon: (0, $73624b371df38195$export$2e2bcd8739ae039)
    }));
};
$ae197ef38b34eab8$var$RightOutlined.displayName = "RightOutlined";
var $ae197ef38b34eab8$export$2e2bcd8739ae039 = /*#__PURE__*/ $acw62.forwardRef($ae197ef38b34eab8$var$RightOutlined);




var $acw62 = parcelRequire("acw62");
// This icon file is generated automatically.
var $ff15ac1227d2f2eb$var$RotateLeftOutlined = {
    "icon": {
        "tag": "svg",
        "attrs": {
            "viewBox": "64 64 896 896",
            "focusable": "false"
        },
        "children": [
            {
                "tag": "defs",
                "attrs": {},
                "children": [
                    {
                        "tag": "style",
                        "attrs": {}
                    }
                ]
            },
            {
                "tag": "path",
                "attrs": {
                    "d": "M672 418H144c-17.7 0-32 14.3-32 32v414c0 17.7 14.3 32 32 32h528c17.7 0 32-14.3 32-32V450c0-17.7-14.3-32-32-32zm-44 402H188V494h440v326z"
                }
            },
            {
                "tag": "path",
                "attrs": {
                    "d": "M819.3 328.5c-78.8-100.7-196-153.6-314.6-154.2l-.2-64c0-6.5-7.6-10.1-12.6-6.1l-128 101c-4 3.1-3.9 9.1 0 12.3L492 318.6c5.1 4 12.7.4 12.6-6.1v-63.9c12.9.1 25.9.9 38.8 2.5 42.1 5.2 82.1 18.2 119 38.7 38.1 21.2 71.2 49.7 98.4 84.3 27.1 34.7 46.7 73.7 58.1 115.8a325.95 325.95 0 016.5 140.9h74.9c14.8-103.6-11.3-213-81-302.3z"
                }
            }
        ]
    },
    "name": "rotate-left",
    "theme": "outlined"
};
var $ff15ac1227d2f2eb$export$2e2bcd8739ae039 = $ff15ac1227d2f2eb$var$RotateLeftOutlined;



var $91bc6521e9f91ff1$var$RotateLeftOutlined = function RotateLeftOutlined(props, ref) {
    return /*#__PURE__*/ $acw62.createElement((0, $7714637e9c1f1f3f$export$2e2bcd8739ae039), (0, $983350b7b3960a26$export$2e2bcd8739ae039)((0, $983350b7b3960a26$export$2e2bcd8739ae039)({}, props), {}, {
        ref: ref,
        icon: (0, $ff15ac1227d2f2eb$export$2e2bcd8739ae039)
    }));
};
$91bc6521e9f91ff1$var$RotateLeftOutlined.displayName = "RotateLeftOutlined";
var $91bc6521e9f91ff1$export$2e2bcd8739ae039 = /*#__PURE__*/ $acw62.forwardRef($91bc6521e9f91ff1$var$RotateLeftOutlined);




var $acw62 = parcelRequire("acw62");
// This icon file is generated automatically.
var $1745df0058500b69$var$RotateRightOutlined = {
    "icon": {
        "tag": "svg",
        "attrs": {
            "viewBox": "64 64 896 896",
            "focusable": "false"
        },
        "children": [
            {
                "tag": "defs",
                "attrs": {},
                "children": [
                    {
                        "tag": "style",
                        "attrs": {}
                    }
                ]
            },
            {
                "tag": "path",
                "attrs": {
                    "d": "M480.5 251.2c13-1.6 25.9-2.4 38.8-2.5v63.9c0 6.5 7.5 10.1 12.6 6.1L660 217.6c4-3.2 4-9.2 0-12.3l-128-101c-5.1-4-12.6-.4-12.6 6.1l-.2 64c-118.6.5-235.8 53.4-314.6 154.2A399.75 399.75 0 00123.5 631h74.9c-.9-5.3-1.7-10.7-2.4-16.1-5.1-42.1-2.1-84.1 8.9-124.8 11.4-42.2 31-81.1 58.1-115.8 27.2-34.7 60.3-63.2 98.4-84.3 37-20.6 76.9-33.6 119.1-38.8z"
                }
            },
            {
                "tag": "path",
                "attrs": {
                    "d": "M880 418H352c-17.7 0-32 14.3-32 32v414c0 17.7 14.3 32 32 32h528c17.7 0 32-14.3 32-32V450c0-17.7-14.3-32-32-32zm-44 402H396V494h440v326z"
                }
            }
        ]
    },
    "name": "rotate-right",
    "theme": "outlined"
};
var $1745df0058500b69$export$2e2bcd8739ae039 = $1745df0058500b69$var$RotateRightOutlined;



var $911f8997e634ac65$var$RotateRightOutlined = function RotateRightOutlined(props, ref) {
    return /*#__PURE__*/ $acw62.createElement((0, $7714637e9c1f1f3f$export$2e2bcd8739ae039), (0, $983350b7b3960a26$export$2e2bcd8739ae039)((0, $983350b7b3960a26$export$2e2bcd8739ae039)({}, props), {}, {
        ref: ref,
        icon: (0, $1745df0058500b69$export$2e2bcd8739ae039)
    }));
};
$911f8997e634ac65$var$RotateRightOutlined.displayName = "RotateRightOutlined";
var $911f8997e634ac65$export$2e2bcd8739ae039 = /*#__PURE__*/ $acw62.forwardRef($911f8997e634ac65$var$RotateRightOutlined);




var $acw62 = parcelRequire("acw62");
// This icon file is generated automatically.
var $729962fdaaeabdbf$var$ZoomInOutlined = {
    "icon": {
        "tag": "svg",
        "attrs": {
            "viewBox": "64 64 896 896",
            "focusable": "false"
        },
        "children": [
            {
                "tag": "path",
                "attrs": {
                    "d": "M637 443H519V309c0-4.4-3.6-8-8-8h-60c-4.4 0-8 3.6-8 8v134H325c-4.4 0-8 3.6-8 8v60c0 4.4 3.6 8 8 8h118v134c0 4.4 3.6 8 8 8h60c4.4 0 8-3.6 8-8V519h118c4.4 0 8-3.6 8-8v-60c0-4.4-3.6-8-8-8zm284 424L775 721c122.1-148.9 113.6-369.5-26-509-148-148.1-388.4-148.1-537 0-148.1 148.6-148.1 389 0 537 139.5 139.6 360.1 148.1 509 26l146 146c3.2 2.8 8.3 2.8 11 0l43-43c2.8-2.7 2.8-7.8 0-11zM696 696c-118.8 118.7-311.2 118.7-430 0-118.7-118.8-118.7-311.2 0-430 118.8-118.7 311.2-118.7 430 0 118.7 118.8 118.7 311.2 0 430z"
                }
            }
        ]
    },
    "name": "zoom-in",
    "theme": "outlined"
};
var $729962fdaaeabdbf$export$2e2bcd8739ae039 = $729962fdaaeabdbf$var$ZoomInOutlined;



var $be03b75194f902f8$var$ZoomInOutlined = function ZoomInOutlined(props, ref) {
    return /*#__PURE__*/ $acw62.createElement((0, $7714637e9c1f1f3f$export$2e2bcd8739ae039), (0, $983350b7b3960a26$export$2e2bcd8739ae039)((0, $983350b7b3960a26$export$2e2bcd8739ae039)({}, props), {}, {
        ref: ref,
        icon: (0, $729962fdaaeabdbf$export$2e2bcd8739ae039)
    }));
};
$be03b75194f902f8$var$ZoomInOutlined.displayName = "ZoomInOutlined";
var $be03b75194f902f8$export$2e2bcd8739ae039 = /*#__PURE__*/ $acw62.forwardRef($be03b75194f902f8$var$ZoomInOutlined);




var $acw62 = parcelRequire("acw62");
// This icon file is generated automatically.
var $d157258ac3afd907$var$ZoomOutOutlined = {
    "icon": {
        "tag": "svg",
        "attrs": {
            "viewBox": "64 64 896 896",
            "focusable": "false"
        },
        "children": [
            {
                "tag": "path",
                "attrs": {
                    "d": "M637 443H325c-4.4 0-8 3.6-8 8v60c0 4.4 3.6 8 8 8h312c4.4 0 8-3.6 8-8v-60c0-4.4-3.6-8-8-8zm284 424L775 721c122.1-148.9 113.6-369.5-26-509-148-148.1-388.4-148.1-537 0-148.1 148.6-148.1 389 0 537 139.5 139.6 360.1 148.1 509 26l146 146c3.2 2.8 8.3 2.8 11 0l43-43c2.8-2.7 2.8-7.8 0-11zM696 696c-118.8 118.7-311.2 118.7-430 0-118.7-118.8-118.7-311.2 0-430 118.8-118.7 311.2-118.7 430 0 118.7 118.8 118.7 311.2 0 430z"
                }
            }
        ]
    },
    "name": "zoom-out",
    "theme": "outlined"
};
var $d157258ac3afd907$export$2e2bcd8739ae039 = $d157258ac3afd907$var$ZoomOutOutlined;



var $2e50f5d8a03dff9a$var$ZoomOutOutlined = function ZoomOutOutlined(props, ref) {
    return /*#__PURE__*/ $acw62.createElement((0, $7714637e9c1f1f3f$export$2e2bcd8739ae039), (0, $983350b7b3960a26$export$2e2bcd8739ae039)((0, $983350b7b3960a26$export$2e2bcd8739ae039)({}, props), {}, {
        ref: ref,
        icon: (0, $d157258ac3afd907$export$2e2bcd8739ae039)
    }));
};
$2e50f5d8a03dff9a$var$ZoomOutOutlined.displayName = "ZoomOutOutlined";
var $2e50f5d8a03dff9a$export$2e2bcd8739ae039 = /*#__PURE__*/ $acw62.forwardRef($2e50f5d8a03dff9a$var$ZoomOutOutlined);




var $acw62 = parcelRequire("acw62");


var $01d7f5b7c8f36ad2$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $01d7f5b7c8f36ad2$export$df03f54e09e486fa = {
    rotateLeft: /*#__PURE__*/ $acw62.createElement((0, $91bc6521e9f91ff1$export$2e2bcd8739ae039), null),
    rotateRight: /*#__PURE__*/ $acw62.createElement((0, $911f8997e634ac65$export$2e2bcd8739ae039), null),
    zoomIn: /*#__PURE__*/ $acw62.createElement((0, $be03b75194f902f8$export$2e2bcd8739ae039), null),
    zoomOut: /*#__PURE__*/ $acw62.createElement((0, $2e50f5d8a03dff9a$export$2e2bcd8739ae039), null),
    close: /*#__PURE__*/ $acw62.createElement((0, $06f117eb9481f34c$export$2e2bcd8739ae039), null),
    left: /*#__PURE__*/ $acw62.createElement((0, $1e62197f718e4845$export$2e2bcd8739ae039), null),
    right: /*#__PURE__*/ $acw62.createElement((0, $ae197ef38b34eab8$export$2e2bcd8739ae039), null)
};
var $01d7f5b7c8f36ad2$var$InternalPreviewGroup = function InternalPreviewGroup(_a) {
    var customizePrefixCls = _a.previewPrefixCls, preview = _a.preview, props = $01d7f5b7c8f36ad2$var$__rest(_a, [
        "previewPrefixCls",
        "preview"
    ]);
    var _React$useContext = $acw62.useContext((0, $a18b2f6f56546238$export$a92f85ab3e9ad68b)), getPrefixCls = _React$useContext.getPrefixCls;
    var prefixCls = getPrefixCls("image-preview", customizePrefixCls);
    var rootPrefixCls = getPrefixCls();
    var mergedPreview = $acw62.useMemo(function() {
        if (preview === false) return preview;
        var _preview = (0, $b8f57191916382d3$export$2e2bcd8739ae039)(preview) === "object" ? preview : {};
        return (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)((0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, _preview), {
            transitionName: (0, $2efb522a5615f01e$export$27c72201b1d09951)(rootPrefixCls, "zoom", _preview.transitionName),
            maskTransitionName: (0, $2efb522a5615f01e$export$27c72201b1d09951)(rootPrefixCls, "fade", _preview.maskTransitionName)
        });
    }, [
        preview
    ]);
    return /*#__PURE__*/ $acw62.createElement((0, $b8e27e74b4085961$export$2e2bcd8739ae039).PreviewGroup, (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({
        preview: mergedPreview,
        previewPrefixCls: prefixCls,
        icons: $01d7f5b7c8f36ad2$export$df03f54e09e486fa
    }, props));
};
var $01d7f5b7c8f36ad2$export$2e2bcd8739ae039 = $01d7f5b7c8f36ad2$var$InternalPreviewGroup;


var $bdacfb30f3b10618$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $bdacfb30f3b10618$var$Image = function Image(_a) {
    var customizePrefixCls = _a.prefixCls, preview = _a.preview, otherProps = $bdacfb30f3b10618$var$__rest(_a, [
        "prefixCls",
        "preview"
    ]);
    var _useContext = (0, $acw62.useContext)((0, $a18b2f6f56546238$export$a92f85ab3e9ad68b)), getPrefixCls = _useContext.getPrefixCls, _useContext$locale = _useContext.locale, contextLocale = _useContext$locale === void 0 ? (0, $c7d8dfeaf08e9faa$export$2e2bcd8739ae039) : _useContext$locale, getContextPopupContainer = _useContext.getPopupContainer;
    var prefixCls = getPrefixCls("image", customizePrefixCls);
    var rootPrefixCls = getPrefixCls();
    var imageLocale = contextLocale.Image || (0, $c7d8dfeaf08e9faa$export$2e2bcd8739ae039).Image;
    var mergedPreview = $acw62.useMemo(function() {
        if (preview === false) return preview;
        var _preview = (0, $b8f57191916382d3$export$2e2bcd8739ae039)(preview) === "object" ? preview : {};
        var getContainer = _preview.getContainer, restPreviewProps = $bdacfb30f3b10618$var$__rest(_preview, [
            "getContainer"
        ]);
        return (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)((0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({
            mask: /*#__PURE__*/ $acw62.createElement("div", {
                className: "".concat(prefixCls, "-mask-info")
            }, /*#__PURE__*/ $acw62.createElement((0, $d8a9efd7a074f5f5$export$2e2bcd8739ae039), null), imageLocale === null || imageLocale === void 0 ? void 0 : imageLocale.preview),
            icons: (0, $01d7f5b7c8f36ad2$export$df03f54e09e486fa)
        }, restPreviewProps), {
            getContainer: getContainer || getContextPopupContainer,
            transitionName: (0, $2efb522a5615f01e$export$27c72201b1d09951)(rootPrefixCls, "zoom", _preview.transitionName),
            maskTransitionName: (0, $2efb522a5615f01e$export$27c72201b1d09951)(rootPrefixCls, "fade", _preview.maskTransitionName)
        });
    }, [
        preview,
        imageLocale
    ]);
    return /*#__PURE__*/ $acw62.createElement((0, $b8e27e74b4085961$export$2e2bcd8739ae039), (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({
        prefixCls: prefixCls,
        preview: mergedPreview
    }, otherProps));
};
$bdacfb30f3b10618$var$Image.PreviewGroup = (0, $01d7f5b7c8f36ad2$export$2e2bcd8739ae039);
var $bdacfb30f3b10618$export$2e2bcd8739ae039 = $bdacfb30f3b10618$var$Image;



var $45fvw = parcelRequire("45fvw");






const $c1b3bcb27dbef44d$export$c25acd513dcc8062 = ({ title: title = "button", type: type, onClick: onClick, className: className, icon: icon })=>{
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("button", {
        type: type,
        onClick: onClick,
        className: `Button ${className ?? ""}`,
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                src: icon,
                className: "Button__icon"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $660b2ca422e0e2ae$export$1ff3c3f08ae963c0).Horizontal, {
                width: 15
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                className: "Button__label",
                children: title
            })
        ]
    });
};






var $b812827552f696e3$exports = {};
$b812827552f696e3$exports = new URL("arrow-left.02422201.svg", import.meta.url).toString();


var $273484134c6066cd$exports = {};
$273484134c6066cd$exports = new URL("arrow-right.7799da54.svg", import.meta.url).toString();


var $01d68338a822b7c9$exports = {};
$01d68338a822b7c9$exports = new URL("accepted.fb8d2b66.svg", import.meta.url).toString();






const $6cffb5e2a67f2165$var$ApplicantInfo = (applicant)=>{
    const { t: t } = (0, $3765cebd031b52c0$export$9fc83ad70ead8663)();
    const getFields = ()=>{
        const experience = {
            lbl: t("job_cherry_picking.experience"),
            value: `${applicant.years_experience} ${t("job_draft_details.experience_years")}`
        };
        const initialFields = applicant.years_experience ? [
            experience
        ] : [];
        if ((0, $73ccb33f5de6f5aa$export$8707029d024490c9)().applicantReview.includeNationality && applicant.nationality?.length) initialFields.push({
            lbl: t("job_cherry_picking.nationality"),
            value: applicant.nationality
        });
        if (applicant.languages !== null && Array.isArray(applicant.languages)) {
            const filteredLanguages = applicant.languages.filter((l)=>l.length > 0);
            if (filteredLanguages.length > 0) initialFields.push({
                lbl: t("job_cherry_picking.language"),
                value: applicant.languages.join(", ")
            });
        }
        if ((0, $73ccb33f5de6f5aa$export$8707029d024490c9)().applicantReview.includeHeight && applicant.height !== null) initialFields.push({
            lbl: t("job_cherry_picking.height"),
            value: t("job_cherry_picking.height_cm", {
                count: applicant.height
            })
        });
        if (applicant.age !== null) initialFields.push({
            lbl: t("job_cherry_picking.age"),
            value: t("job_cherry_picking.years_old", {
                count: applicant.age
            })
        });
        if (applicant.gender !== null) initialFields.push({
            lbl: t("job_cherry_picking.gender"),
            value: applicant.gender
        });
        if (applicant.location !== null) initialFields.push({
            lbl: t("job_cherry_picking.location"),
            value: applicant.location
        });
        return initialFields;
    };
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        className: "ApplicantInfo",
        children: getFields().map((field)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "ApplicantInfo__row",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h3", {
                        className: "ApplicantInfo__label",
                        children: field.lbl
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                        className: "ApplicantInfo__data",
                        children: field.value
                    })
                ]
            }, field.lbl))
    });
};
var $6cffb5e2a67f2165$export$2e2bcd8739ae039 = $6cffb5e2a67f2165$var$ApplicantInfo;







const $0080eb6e03255993$var$getSeniorityName = (seniorityId)=>{
    switch(seniorityId){
        case Number((0, $f62ebabca0bf67f2$export$c90b54e658fc4d7c).beginnerOrStudent):
            return (0, $73ccb33f5de6f5aa$export$8707029d024490c9)().order.nonExperiencedTitle;
        case Number((0, $f62ebabca0bf67f2$export$c90b54e658fc4d7c).junior):
            return "job_draft_details.experience_junior";
        case Number((0, $f62ebabca0bf67f2$export$c90b54e658fc4d7c).middle):
            return "job_draft_details.experience_middle";
        default:
            return "job_draft_details.experience_senior";
    }
};
const $0080eb6e03255993$var$SeniorityLevel = ({ seniority: seniority, containerStyleClass: containerStyleClass })=>{
    const { t: t } = (0, $3765cebd031b52c0$export$9fc83ad70ead8663)();
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: `SeniorityLevel ${containerStyleClass}`,
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "SeniorityLevel__meterContainer",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                        className: "SeniorityLevel__title",
                        children: t("job_cherry_picking.seniority_level")
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "SeniorityLevel__meter",
                        children: seniority.id === Number((0, $f62ebabca0bf67f2$export$c90b54e658fc4d7c).beginnerOrStudent) ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                    className: "SeniorityLevel__meterStep SeniorityLevel__meterStep--active"
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                    className: "SeniorityLevel__meterStep"
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                    className: "SeniorityLevel__meterStep"
                                })
                            ]
                        }) : Array.from(Array(3)).map((_, i)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                className: `SeniorityLevel__meterStep ${i + 1 <= seniority.id ? "SeniorityLevel__meterStep--active" : ""}`
                            }, i))
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                className: "SeniorityLevel__levelName",
                children: t($0080eb6e03255993$var$getSeniorityName(seniority.id))
            })
        ]
    });
};
var $0080eb6e03255993$export$2e2bcd8739ae039 = $0080eb6e03255993$var$SeniorityLevel;







const $f08d6921ce348716$export$d61e810cec626ddd = ({ title: title, companyName: companyName, location: location, startYear: startYear, endYear: endYear, description: description, experienceInMonths: experienceInMonths, duration: duration, imageURL: imageURL })=>{
    const { t: t } = (0, $3765cebd031b52c0$export$9fc83ad70ead8663)();
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "WorkExperienceCard",
        children: [
            imageURL !== null && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "WorkExperienceCard__imgContainer",
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                            src: imageURL,
                            alt: ""
                        })
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $660b2ca422e0e2ae$export$1ff3c3f08ae963c0).Horizontal, {
                        width: 13
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "WorkExperienceCard__info",
                children: [
                    title !== null && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                        className: "WorkExperienceCard__info__title",
                        children: title
                    }),
                    companyName !== null && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                        className: "WorkExperienceCard__info__company",
                        children: companyName
                    }),
                    location !== null && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                        className: "WorkExperienceCard__info__location",
                        children: location
                    }),
                    (experienceInMonths !== null || startYear !== null && endYear !== null) && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                        className: "WorkExperienceCard__info__time",
                        children: startYear === null && endYear === null ? t("applicant_details.years_of_experience", {
                            count: Math.round(experienceInMonths / 12)
                        }) : `${startYear} - ${endYear}`
                    }),
                    duration !== null && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                        className: "WorkExperienceCard__info__time",
                        children: duration
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                        className: "WorkExperienceCard__info__description",
                        children: description
                    })
                ]
            })
        ]
    });
};





var $14b6cdc8ba876049$exports = {};
$14b6cdc8ba876049$exports = new URL("book.f53b1ef2.svg", import.meta.url).toString();



const $7c80020c8570a6d6$export$a8dbe0fd9664fe79 = ({ school: school, degree: degree, field: field })=>{
    const { t: t } = (0, $3765cebd031b52c0$export$9fc83ad70ead8663)();
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "EducationCard",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "EducationCard__imgContainer",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                    src: (0, (/*@__PURE__*/$parcel$interopDefault($14b6cdc8ba876049$exports))),
                    alt: ""
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $660b2ca422e0e2ae$export$1ff3c3f08ae963c0).Horizontal, {
                width: 13
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "EducationCard__info",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                        className: "EducationCard__info__title",
                        children: school
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "EducationCard__info__degreeContainer",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                className: "EducationCard__info__degreeContainer__degree",
                                children: degree
                            }),
                            " ",
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                className: "EducationCard__info__degreeContainer__text",
                                children: t("applicant_details.in")
                            }),
                            " ",
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                className: "EducationCard__info__degreeContainer__field",
                                children: field
                            })
                        ]
                    })
                ]
            })
        ]
    });
};






const $42e8de4486894ccf$export$d452f2c75c76df24 = ({ skills: skills })=>{
    const skillsFiltered = skills.filter((skill)=>skill.rating > 1);
    return skillsFiltered.length > 0 ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        className: "SkillsList",
        children: skillsFiltered.map((skill, key)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: `SkillsList__skill ${skill.rating >= 3 ? "SkillsList__skill--high" : "SkillsList__skill--medium"}`,
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                        className: "SkillsList__skill__name",
                        children: skill.name
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                        className: "SkillsList__skill__rating",
                        children: skill.rating
                    })
                ]
            }, key))
    }) : null;
};





var $acw62 = parcelRequire("acw62");



function $1a93ed1cbbe4435f$export$f429b98036d86710({ children: children }) {
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        className: "QuestionList",
        children: children
    });
}




var $a0ff79aff48e3cd7$exports = {};
$a0ff79aff48e3cd7$exports = new URL("camera.5d0db260.svg", import.meta.url).toString();


var $5d8d7c9753d1bbdd$exports = {};
$5d8d7c9753d1bbdd$exports = new URL("star.7c1d08a3.svg", import.meta.url).toString();



function $d35e4a1395a033df$export$2f31fc0a7a44451({ description: description, rating: rating, className: className, onClick: onClick }) {
    const { t: t } = (0, $3765cebd031b52c0$export$9fc83ad70ead8663)();
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: `QuestionItem ${className}`,
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                src: (0, (/*@__PURE__*/$parcel$interopDefault($a0ff79aff48e3cd7$exports))),
                alt: "camera",
                className: "QuestionItem__cameraImg"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "QuestionItem__content",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "QuestionItem__description",
                        children: description
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "QuestionItem__bottom",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                className: "QuestionItem__linkLabel",
                                onClick: onClick,
                                children: t("applicant_details.view_answer")
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: `QuestionItem__ratingContainer ${rating === null ? "QuestionItem__ratingContainer_hidden" : ""}`,
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                                        src: (0, (/*@__PURE__*/$parcel$interopDefault($5d8d7c9753d1bbdd$exports))),
                                        alt: "rating",
                                        className: "QuestionItem__starImg"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                        className: "QuestionItem__ratingLabel",
                                        children: rating
                                    })
                                ]
                            })
                        ]
                    })
                ]
            })
        ]
    });
}




var $a0f1ebc67df357b5$exports = {};
$a0f1ebc67df357b5$exports = new URL("chat-hollow.e49a33c1.svg", import.meta.url).toString();



function $39c817094c53120c$var$InterviewSectionComponent({ jobId: jobId, spId: spId, isLoading: isLoading, onAcceptPress: onAcceptPress }) {
    const { t: t } = (0, $3765cebd031b52c0$export$9fc83ad70ead8663)();
    const { getInterviewByJobId: getInterviewByJobId, getQuestionById: getQuestionById, spHasAnswers: spHasAnswers, getSpAnswer: getSpAnswer } = (0, $4671947198ddd366$export$6ccbb43953eebf8)().data;
    const [showInterviewQuestion, setShowInterviewQuestion] = (0, $acw62.useState)(null);
    const interview = getInterviewByJobId(jobId);
    if (isLoading || !interview) return null;
    const hasAnswers = spHasAnswers({
        interviewId: interview.id,
        spId: spId
    });
    if (!hasAnswers) return null;
    const questionsWithAnswers = interview.questions.filter((questionId)=>{
        const answer = getSpAnswer({
            interviewId: interview.id,
            questionId: questionId,
            spId: spId
        });
        return Boolean(answer);
    });
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "InterviewSection",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "InterviewSection__header",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                        src: (0, (/*@__PURE__*/$parcel$interopDefault($a0f1ebc67df357b5$exports))),
                        alt: "",
                        className: "InterviewSection__chatImg"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "InterviewSection__title",
                        children: t("applicant_details.interview")
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "InterviewSection__listContainer",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $1a93ed1cbbe4435f$export$f429b98036d86710), {
                    children: questionsWithAnswers.map((qId, qIndex)=>{
                        const question = getQuestionById(qId);
                        return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $d35e4a1395a033df$export$2f31fc0a7a44451), {
                            description: question.description,
                            rating: null,
                            className: "InterviewSection__listItem",
                            onClick: ()=>{
                                setShowInterviewQuestion({
                                    qId: qId,
                                    qIndex: qIndex
                                });
                            }
                        }, qId);
                    })
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b796eeaf55507ebc$export$7fe57d46322b10ad), {
                applicantsType: "single",
                jobId: jobId,
                showInitialQuestion: showInterviewQuestion,
                onAcceptPress: onAcceptPress
            })
        ]
    });
}
const $39c817094c53120c$export$4571ae58acbaaf56 = (0, $aca50e9407ba89c9$export$b6ae1bc530f4c149)($39c817094c53120c$var$InterviewSectionComponent);






const $d909634936413154$export$8ba663d22f9191ae = ({ rating: rating })=>{
    const ratingRounded = Math.round(rating);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "WorkCategorySkills__skillRating",
        children: [
            Array.from(Array(ratingRounded)).map((_, i)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                    className: "WorkCategorySkills__skillRatingBox"
                }, i)),
            Array.from(Array(5 - ratingRounded)).map((_, i)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                    className: "WorkCategorySkills__skillRatingBox WorkCategorySkills__skillRatingBox--empty"
                }, i))
        ]
    });
};


const $e341eb07f9723a10$var$ratingTitle = {
    1: "sp_rating.novice",
    2: "sp_rating.advanced_beginner",
    3: "sp_rating.competent",
    4: "sp_rating.proficient",
    5: "sp_rating.expert"
};
const $e341eb07f9723a10$export$118171a82d109c04 = ({ name: name, rating: rating, icon: icon })=>{
    const { t: t } = (0, $3765cebd031b52c0$export$9fc83ad70ead8663)();
    const ratingRounded = Math.round(rating);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "WorkCategorySkills__skill",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "WorkCategorySkills__skillLeft",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                        src: icon
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $d909634936413154$export$8ba663d22f9191ae), {
                        rating: rating
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "WorkCategorySkills__skillRight",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                        className: "WorkCategorySkills__skillLevel",
                        children: t($e341eb07f9723a10$var$ratingTitle[ratingRounded])
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                        className: "WorkCategorySkills__skillName",
                        children: name
                    })
                ]
            })
        ]
    });
};



const $a996baeebae8503a$export$3cc813157f8e09d5 = ({ categoryTitle: categoryTitle, skills: skills })=>{
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "WorkCategorySkills",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                className: "WorkCategorySkills__title",
                children: categoryTitle
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "WorkCategorySkills__skillsList",
                children: skills.map((skill, key)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e341eb07f9723a10$export$118171a82d109c04), {
                        name: skill.name,
                        rating: skill.rating,
                        icon: skill.icon ?? ""
                    }, key))
            })
        ]
    });
};




var $acw62 = parcelRequire("acw62");

var $0678e516950501cd$exports = {};
$0678e516950501cd$exports = new URL("info-italic.9cd6627d.svg", import.meta.url).toString();


var $a1d65e672e8d0713$exports = {};
$a1d65e672e8d0713$exports = new URL("cross-icon-blue.932791da.svg", import.meta.url).toString();



const $b80ae3ef49d7d6ee$export$ee6023df97282ad8 = ()=>{
    const [visible, setVisible] = (0, $acw62.useState)(true);
    if (!visible) return null;
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "CheifCard",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                src: (0, (/*@__PURE__*/$parcel$interopDefault($0678e516950501cd$exports))),
                alt: "",
                className: "CheifCard__infoIcon"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "CheifCard__text",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $e04d9533328ca578$export$8d6a9236f2e3f2ce), {
                    i18nKey: "applicant_details.chief",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                            children: "Chief OG's "
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                            className: "CheifCard__text__highlight",
                            children: "are experienced team leaders, hand picked to better coordinate Ogram teams on the ground."
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                src: (0, (/*@__PURE__*/$parcel$interopDefault($a1d65e672e8d0713$exports))),
                alt: "",
                className: "CheifCard__crossIcon",
                onClick: ()=>{
                    setVisible(false);
                }
            })
        ]
    });
};







const $aa740918b68db5e8$export$f8a945fb234aa5a5 = ({ title: title, location: location, jobId: jobId, startDate: startDate, endDate: endDate })=>{
    const { t: t } = (0, $3765cebd031b52c0$export$9fc83ad70ead8663)();
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        className: "WorkExperienceCard",
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
            className: "WorkExperienceCard__info",
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                    className: "WorkExperienceCard__info__title",
                    children: title
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                    className: "WorkExperienceCard__info__company",
                    children: location
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                    className: "WorkExperienceCard__info__location",
                    children: t("common.job_n", {
                        id: jobId
                    })
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                    className: "WorkExperienceCard__info__time",
                    children: [
                        startDate,
                        " - ",
                        endDate ?? t("common.now")
                    ]
                })
            ]
        })
    });
};





const $c665f284476b5703$var$ApplicantDetails = (0, $a4963babae245ff9$export$f0c7a449e0cfaec7)((0, $aca50e9407ba89c9$export$b6ae1bc530f4c149)(({ jobId: jobId, jobType: jobType, applicantId: initialApplicantId, shiftId: shiftId, showHeader: showHeader, showControls: showControls })=>{
    const { getNotAcceptedApplicantsList: getNotAcceptedApplicantsList, getSPExperience: getSPExperience, getExperienceBySpId: getExperienceBySpId, getApplicant: getApplicant, getInterview: getInterview, getCurrentApplicant: getCurrentApplicant, setCurrentApplicant: setCurrentApplicant, skillsGroupedByCategory: skillsGroupedByCategory } = (0, $4671947198ddd366$export$6ccbb43953eebf8)().data;
    const parsedJobId = parseInt(jobId);
    const notAcceptedApplicantsList = getNotAcceptedApplicantsList(jobType);
    const currentApplicant = getCurrentApplicant(jobType);
    const applicantId = String(initialApplicantId ?? currentApplicant?.id);
    const isPermanentJob = jobType === (0, $862a04ca6e0d681b$export$27a7f855854fa13d).permanent;
    const { enableQuery: loadApplicant, query: { isLoading: applicantLoading } } = (0, $4671947198ddd366$export$517ca4f7fee4e226)(()=>getApplicant(parsedJobId, Number(applicantId)));
    const { isLoading: isLoading } = (0, $4671947198ddd366$export$dd0a697e1782aedd)(()=>{
        if (isPermanentJob) return Promise.resolve();
        return getInterview({
            jobId: parsedJobId
        });
    }, {
        filterError: [
            (0, $9ad33fbf770c55a1$export$9696fcf1798e1cb5).NotFound
        ]
    });
    (0, $acw62.useEffect)(()=>{
        if (!isPermanentJob && !isNaN(parseInt(applicantId))) loadApplicant();
    }, [
        jobId,
        applicantId,
        jobType
    ]);
    const experienceList = getExperienceBySpId(applicantId);
    const applicant = currentApplicant;
    const [rating, setRating] = (0, $acw62.useState)(applicant?.rating ?? 0);
    const [, getExperience] = (0, $4671947198ddd366$export$609860bf8b0084c)(getSPExperience);
    const { acceptApplicant: acceptApplicant, rejectApplicant: rejectApplicant, acceptQuery: acceptQuery, rejectQuery: rejectQuery } = (0, $ed5bfb085f31ab7b$export$c377b10719f38eb2)({
        isPermanentJob: isPermanentJob,
        onAccepted: ()=>{
            (0, $60f27fc97e29822a$export$b410431fab84fa58).success("Ogrammer is accepted!");
        }
    });
    (0, $acw62.useEffect)(()=>{
        if (!isPermanentJob && !isNaN(parseInt(applicantId))) getExperience({
            jobId: jobId,
            spId: applicantId
        });
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        jobId,
        applicantId
    ]);
    const nextApplicant = (0, $acw62.useMemo)(()=>{
        const indexOfCurrentApplicant = notAcceptedApplicantsList.findIndex((item)=>item.id === Number(applicantId));
        return indexOfCurrentApplicant === notAcceptedApplicantsList.length - 1 ? notAcceptedApplicantsList[0] : notAcceptedApplicantsList[indexOfCurrentApplicant + 1];
    }, [
        notAcceptedApplicantsList,
        applicantId
    ]);
    const previousApplicant = (0, $acw62.useMemo)(()=>{
        const indexOfCurrentApplicant = notAcceptedApplicantsList.findIndex((item)=>item.id === Number(applicantId));
        return indexOfCurrentApplicant === 0 ? notAcceptedApplicantsList[notAcceptedApplicantsList.length - 1] : notAcceptedApplicantsList[indexOfCurrentApplicant - 1];
    }, [
        notAcceptedApplicantsList,
        applicantId
    ]);
    const isPhotoPDFType = (0, $acw62.useMemo)(()=>{
        if (isPermanentJob) return false;
        return applicant?.image_url?.includes(".pdf");
    }, [
        applicant
    ]);
    const changePage = (type)=>{
        if (type === "next" && nextApplicant) setCurrentApplicant(nextApplicant.id, jobType);
        else if (previousApplicant) setCurrentApplicant(previousApplicant.id, jobType);
    };
    const { t: t } = (0, $3765cebd031b52c0$export$9fc83ad70ead8663)();
    const skills = applicant?.skills ?? [];
    const onAccept = ()=>{
        acceptApplicant(jobType === (0, $862a04ca6e0d681b$export$27a7f855854fa13d).permanent ? {
            job_application_id: applicant?.id
        } : {
            sp_id: String(applicant?.id),
            job_id: Number(jobId),
            shift_ids: shiftId ? [
                shiftId
            ] : undefined
        });
    };
    const mainExperiences = experienceList?.experiences.filter((experience)=>experience.is_main_experience) ?? [];
    const mainWorkCategoryName = mainExperiences[0]?.work_category_name;
    if (applicantLoading) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        className: "ApplicantDetails",
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $57fb8f45c69e1681$export$2e2bcd8739ae039), {})
    });
    if (!applicant) return null;
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "ApplicantDetails",
        children: [
            (acceptQuery.isLoading || rejectQuery.isLoading) && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "ApplicantDetails__loading",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $57fb8f45c69e1681$export$2e2bcd8739ae039), {})
            }),
            showHeader && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7ae42b63183f30b4$export$8b251419efc915eb), {
                title: applicant.name ?? "Applicant",
                showBack: true
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "ApplicantDetails__header",
                children: [
                    !isPermanentJob && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $dd6a69dbf87a4818$export$567f003c75a59875), {
                        className: "ApplicantDetails__toggleFavourite"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "ApplicantDetails__imagesContainer",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "ApplicantDetails__avatarContainer",
                                children: [
                                    isPhotoPDFType ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                                        className: "ApplicantDetails__avatarContainer__avatar"
                                    }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $bdacfb30f3b10618$export$2e2bcd8739ae039), {
                                        src: (0, $02fb6dbe124d4af6$export$a22ea4d9be220b2f)(applicant.image),
                                        className: "ApplicantDetails__avatarContainer__avatar"
                                    }),
                                    applicant.is_chief ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                                        src: (0, (/*@__PURE__*/$parcel$interopDefault($4826ef334bad3dc7$exports))),
                                        className: "ApplicantDetails__avatarContainer__beacon"
                                    }) : null
                                ]
                            }),
                            "fullbody_photo" in applicant && applicant.fullbody_photo !== null && applicant.fullbody_photo.length > 0 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $bdacfb30f3b10618$export$2e2bcd8739ae039), {
                                src: (0, $02fb6dbe124d4af6$export$a22ea4d9be220b2f)(applicant.fullbody_photo),
                                className: "ApplicantDetails__avatarContainer__avatar"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "ApplicantDetails__nameAndRatingContainer",
                        children: [
                            applicant.name !== null && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h2", {
                                className: "ApplicantDetails__name",
                                children: applicant.name
                            }),
                            "completed_shifts_count" in applicant && applicant.completed_shifts_count > 0 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                className: "ApplicantDetails__shiftsCount",
                                children: t("applicant_details.n_shifts_completed", {
                                    count: applicant.completed_shifts_count
                                })
                            }),
                            !isPermanentJob && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $647b8b1a309a1295$export$2e2bcd8739ae039), {
                                size: 20,
                                editable: false,
                                onRatingChange: setRating,
                                rating: rating
                            }),
                            "is_chief" in applicant && applicant.is_chief && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "ApplicantDetails__nameAndRatingContainer__chiefContainer",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                                        src: (0, (/*@__PURE__*/$parcel$interopDefault($4826ef334bad3dc7$exports))),
                                        className: "ApplicantDetails__nameAndRatingContainer__chiefContainer__beacon"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                        className: "ApplicantDetails__nameAndRatingContainer__chiefContainer__label",
                                        children: t("applicant_details.chief_og")
                                    })
                                ]
                            })
                        ]
                    }),
                    "top_qualities" in applicant && applicant.top_qualities?.length && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "ApplicantDetails__topQualitiesContainer",
                        children: applicant.top_qualities.map((topQuality, i)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $184f4ad97a7e55c9$export$2e2bcd8739ae039), {
                                containerStyleClass: "ApplicantDetails__topQuality",
                                name: topQuality
                            }, i))
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $42e8de4486894ccf$export$d452f2c75c76df24), {
                        skills: skills
                    }),
                    skills.length > 0 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $61076bfc19b3ff31$export$2e2bcd8739ae039), {
                        space: 21
                    }),
                    "seniority_level" in applicant && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $0080eb6e03255993$export$2e2bcd8739ae039), {
                        containerStyleClass: "ApplicantDetails__seniorityLevel",
                        seniority: applicant.seniority_level
                    })
                ]
            }),
            "is_chief" in applicant && applicant.is_chief && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $61076bfc19b3ff31$export$2e2bcd8739ae039), {
                        space: 16
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b80ae3ef49d7d6ee$export$ee6023df97282ad8), {})
                ]
            }),
            isPermanentJob ? "video" in applicant && typeof applicant.video === "string" ? applicant.video.includes("drive.google.com") ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("iframe", {
                src: (0, $02fb6dbe124d4af6$export$be3082245f029840)(applicant.video),
                id: "applicantVideo",
                className: "ApplicantDetails__videoIframe"
            }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("video", {
                controls: true,
                className: "AnswerForm__videoPlayer",
                width: "100%",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("source", {
                        src: applicant.video,
                        type: "video/mp4"
                    }),
                    t("interview.video_player_not_supported")
                ]
            }, applicant.video) : null : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $39c817094c53120c$export$4571ae58acbaaf56), {
                jobId: parsedJobId,
                spId: applicant.id,
                isLoading: isLoading,
                onAcceptPress: onAccept
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "ApplicantDetails__informationContainer",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h3", {
                        className: "ApplicantDetails__infoTitle",
                        children: t("applicant_details.information")
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $6cffb5e2a67f2165$export$2e2bcd8739ae039), {
                        height: "height" in applicant ? applicant.height : null,
                        languages: applicant.languages,
                        years_experience: "years_experience" in applicant ? applicant.years_experience : null,
                        age: applicant.age,
                        nationality: applicant.nationality,
                        gender: "gender" in applicant ? applicant.gender : null,
                        location: "location" in applicant ? applicant.location : null
                    })
                ]
            }),
            skills.length > 0 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "ApplicantDetails__infoContainer",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                className: "ApplicantDetails__infoContainer__title",
                                children: t("applicant_details.skills")
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $61076bfc19b3ff31$export$2e2bcd8739ae039), {
                                space: 24
                            }),
                            skillsGroupedByCategory.map((item, key)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $a996baeebae8503a$export$3cc813157f8e09d5), {
                                    categoryTitle: item.workCategoryName,
                                    skills: item.skills
                                }, key))
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $61076bfc19b3ff31$export$2e2bcd8739ae039), {
                        space: 25
                    })
                ]
            }),
            "past_jobs" in applicant && Boolean(applicant.past_jobs.length) && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "ApplicantDetails__infoContainer",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                        className: "ApplicantDetails__infoContainer__title",
                        children: t("applicant_details.job_history_with_you")
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $61076bfc19b3ff31$export$2e2bcd8739ae039), {
                        space: 24
                    }),
                    applicant.past_jobs.map((pastJob, index)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $aa740918b68db5e8$export$f8a945fb234aa5a5), {
                                    title: pastJob.designation_name,
                                    location: pastJob.location_name,
                                    jobId: pastJob.id,
                                    startDate: (0, (/*@__PURE__*/$parcel$interopDefault($45fvw)))(pastJob.start_date).format("D MMM"),
                                    endDate: pastJob.end_date ? (0, (/*@__PURE__*/$parcel$interopDefault($45fvw)))(pastJob.end_date).format("D MMM") : null
                                }),
                                index !== applicant.past_jobs.length - 1 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                    className: "ApplicantDetails__infoContainer__separator"
                                })
                            ]
                        }))
                ]
            }),
            Boolean(mainExperiences.length) && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "ApplicantDetails__infoContainer",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                className: "ApplicantDetails__infoContainer__title",
                                children: t("applicant_details.work_category_experience", {
                                    workCategoryName: mainWorkCategoryName
                                })
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $61076bfc19b3ff31$export$2e2bcd8739ae039), {
                                space: 12
                            }),
                            mainExperiences.map((exp, index)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $acw62.Fragment), {
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f08d6921ce348716$export$d61e810cec626ddd), {
                                            title: exp.work_category_name,
                                            companyName: exp.company_name,
                                            location: exp.location_name,
                                            startYear: exp.start_year,
                                            endYear: exp.end_year,
                                            description: exp.description,
                                            experienceInMonths: exp.experience_months,
                                            imageURL: exp.image_url,
                                            duration: null
                                        }),
                                        index !== mainExperiences.length - 1 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                            className: "ApplicantDetails__infoContainer__separator"
                                        })
                                    ]
                                }, index))
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $61076bfc19b3ff31$export$2e2bcd8739ae039), {
                        space: 25
                    })
                ]
            }),
            Boolean(experienceList?.educations.length) && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "ApplicantDetails__infoContainer",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                        className: "ApplicantDetails__infoContainer__title",
                        children: t("applicant_details.education")
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $61076bfc19b3ff31$export$2e2bcd8739ae039), {
                        space: 12
                    }),
                    experienceList?.educations.map((item, index)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $acw62.Fragment), {
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7c80020c8570a6d6$export$a8dbe0fd9664fe79), {
                                    school: item.school,
                                    degree: item.degree,
                                    field: item.study
                                }),
                                index !== experienceList.educations.length - 1 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                    className: "ApplicantDetails__infoContainer__separator"
                                })
                            ]
                        }, index))
                ]
            }),
            "education" in applicant && applicant.education?.length && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "ApplicantDetails__infoContainer",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                        className: "ApplicantDetails__infoContainer__title",
                        children: t("applicant_details.education")
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $61076bfc19b3ff31$export$2e2bcd8739ae039), {
                        space: 12
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                        className: "EducationCard__info__degreeContainer__field",
                        children: applicant.education
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "ApplicantDetails__controls-separator"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $61076bfc19b3ff31$export$2e2bcd8739ae039), {
                space: 50
            }),
            showControls && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7b02d682eb115277$exports.Fragment), {
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                    className: "ApplicantDetails__controlContainer",
                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "ApplicantDetails__controlContainer__content",
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                    onClick: ()=>{
                                        changePage("previous");
                                    },
                                    className: "ApplicantDetails__controlContainer__imgContainer",
                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                                        src: (0, (/*@__PURE__*/$parcel$interopDefault($b812827552f696e3$exports))),
                                        alt: "get previous applicant"
                                    })
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                    className: "ApplicantDetails__controlContainer__buttonsContainer",
                                    children: [
                                        applicant.isRejected ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $2ab88429e3384d30$export$353f5b6fc5456de1), {
                                            title: t("job_cherry_picking.rejected"),
                                            disabled: true,
                                            className: "ApplicantDetails__controlContainer__buttonsContainer__rejectButton ApplicantDetails__controlContainer__buttonsContainer__rejectButton--rejected"
                                        }) : !shiftId ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7b02d682eb115277$exports.Fragment), {
                                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $2ab88429e3384d30$export$353f5b6fc5456de1), {
                                                title: t("job_cherry_picking.reject"),
                                                className: "ApplicantDetails__controlContainer__buttonsContainer__rejectButton",
                                                onClick: ()=>rejectApplicant(jobType === (0, $862a04ca6e0d681b$export$27a7f855854fa13d).permanent ? {
                                                        job_application_id: applicant.id
                                                    } : {
                                                        sp_id: String(applicantId),
                                                        job_id: Number(jobId)
                                                    })
                                            })
                                        }) : null,
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $660b2ca422e0e2ae$export$1ff3c3f08ae963c0).Horizontal, {
                                            width: 12
                                        }),
                                        applicant.isAccepted ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c1b3bcb27dbef44d$export$c25acd513dcc8062), {
                                            title: t("job_cherry_picking.accepted"),
                                            icon: (0, (/*@__PURE__*/$parcel$interopDefault($01d68338a822b7c9$exports))),
                                            className: "ApplicantDetails__controlContainer__accepted"
                                        }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $2ab88429e3384d30$export$353f5b6fc5456de1), {
                                            title: t("job_cherry_picking.accept"),
                                            className: "ApplicantDetails__controlContainer__buttonsContainer__acceptButton",
                                            onClick: onAccept
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                    onClick: ()=>{
                                        changePage("next");
                                    },
                                    className: "ApplicantDetails__controlContainer__imgContainer",
                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                                        src: (0, (/*@__PURE__*/$parcel$interopDefault($273484134c6066cd$exports))),
                                        alt: t("applicant_details.get_next_applicant")
                                    })
                                })
                            ]
                        })
                    })
                })
            })
        ]
    });
}));
var $c665f284476b5703$export$2e2bcd8739ae039 = $c665f284476b5703$var$ApplicantDetails;


var $8e9c336d82dad77e$var$sortByCategories;
(function(sortByCategories) {
    sortByCategories["rating"] = "rating";
    sortByCategories["experience"] = "years_experience";
    sortByCategories["age"] = "age";
})($8e9c336d82dad77e$var$sortByCategories || ($8e9c336d82dad77e$var$sortByCategories = {}));
const $8e9c336d82dad77e$var$ApplicantsSection = (0, $a4963babae245ff9$export$f0c7a449e0cfaec7)((0, $aca50e9407ba89c9$export$b6ae1bc530f4c149)(({ jobId: jobId, jobType: jobType, shiftId: shiftId, cherryPickingJob: cherryPickingJob })=>{
    const { getCurrentApplicant: getCurrentApplicant, applicantsView: applicantsView, setCurrentApplicant: setCurrentApplicant, clearCurrentApplicant: clearCurrentApplicant, getCherryPickingApplicantsApiCall: getCherryPickingApplicantsApiCall, getInterviewByJobId: getInterviewByJobId, getInterviewQuestions: getInterviewQuestions, getSpAnswer: getSpAnswer } = (0, $4671947198ddd366$export$6ccbb43953eebf8)().data;
    const isPermanentJob = jobType === (0, $862a04ca6e0d681b$export$27a7f855854fa13d).permanent;
    const applicants = applicantsView(jobType);
    const currentApplicant = getCurrentApplicant(jobType);
    const [sortBy, setSortBy] = (0, $acw62.useState)("rating");
    const [isSortingLoading, setIsSortingLoading] = (0, $acw62.useState)(false);
    const [isPaginationLoading, setIsPaginationLoading] = (0, $acw62.useState)(false);
    const [showChiefModal, setShowChiefModal] = (0, $acw62.useState)(false);
    const [currentQuestion, setCurrentQuestion] = (0, $acw62.useState)(null);
    const [prioritizedApplicantIds, setPrioritizedApplicantIds] = (0, $acw62.useState)([]);
    const [getCherryPickingApplicantsQuery, getCherryPickingApplicants] = (0, $4671947198ddd366$export$609860bf8b0084c)(getCherryPickingApplicantsApiCall, {
        onSuccess: ()=>{
            setIsSortingLoading(false);
            setIsPaginationLoading(false);
        }
    });
    const { acceptApplicant: acceptApplicant } = (0, $ed5bfb085f31ab7b$export$c377b10719f38eb2)({
        isPermanentJob: isPermanentJob,
        onAccepted: ()=>{
            (0, $60f27fc97e29822a$export$b410431fab84fa58).success(t("job_cherry_picking.applicant_assigned"));
        },
        onAcceptFailed: (error)=>{
            (0, $60f27fc97e29822a$export$b410431fab84fa58).error(error.data.message);
        }
    });
    const showedChief = (0, $acw62.useRef)(false);
    const chiefOg = (0, $acw62.useMemo)(()=>{
        if (isPermanentJob || applicants.list.length === 0) return null;
        return applicants.list.find((applicant)=>applicant.is_chief);
    }, [
        applicants
    ]);
    (0, $acw62.useEffect)(()=>{
        if (chiefOg && !showedChief.current) {
            setShowChiefModal(true);
            showedChief.current = true;
            (0, $c74a0566d4b0fd6d$export$e9db7d6e73593439).track((0, $c74a0566d4b0fd6d$export$5e27155e276f6d1c).ChiefCongratulationsPopupShown);
        }
    }, [
        chiefOg,
        showedChief.current
    ]);
    const onSortApplicants = ({ target: { value: value } })=>{
        setIsSortingLoading(true);
        setSortBy(value);
        getCherryPickingApplicants({
            jobId: Number(jobId),
            jobType: jobType,
            sortBy: value,
            shiftId: shiftId
        });
    };
    const onNextPage = ()=>{
        // Guard against duplicate requests while loading or when no next page
        if (isPaginationLoading || getCherryPickingApplicantsQuery.isLoading) return;
        const next = applicants.paginator?.next_page;
        if (!next) return;
        setIsPaginationLoading(true);
        getCherryPickingApplicants({
            jobId: Number(jobId),
            jobType: jobType,
            sortBy: sortBy,
            page: next,
            shiftId: shiftId
        });
    };
    const handleScroll = (0, $324dc7daf4e64dab$export$5bd4c3b2b0a1aaf1)(()=>{
        onNextPage();
    });
    const { t: t } = (0, $3765cebd031b52c0$export$9fc83ad70ead8663)();
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "ApplicantsSection",
        onScroll: handleScroll,
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $3973f6144603dc7a$export$2e2bcd8739ae039), {
                jobDetails: cherryPickingJob,
                showQuantity: !isPermanentJob,
                showFulfillment: !isPermanentJob,
                showStartDate: !isPermanentJob,
                showEndDate: !isPermanentJob
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $61076bfc19b3ff31$export$2e2bcd8739ae039), {
                space: 22
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "ApplicantsSection__headerContainer",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "ApplicantsSection__titleContainer",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                                src: (0, (/*@__PURE__*/$parcel$interopDefault($83bf3c15862dc223$exports)))
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h3", {
                                className: "ApplicantsSection__title",
                                children: t("job_cherry_picking.total_applicants", {
                                    count: applicants.paginator?.total
                                })
                            })
                        ]
                    }),
                    !isPermanentJob && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "ApplicantsSection__sorting",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("h4", {
                                className: "ApplicantsSection__sortBy",
                                children: [
                                    t("job_cherry_picking.sort_by"),
                                    " "
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("select", {
                                value: sortBy,
                                onChange: onSortApplicants,
                                className: "ApplicantsSection__sortingDropDown",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                        value: "rating",
                                        children: t("job_cherry_picking.rating")
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                        value: "years_experience",
                                        children: t("job_cherry_picking.experience")
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                        value: "age",
                                        children: t("job_cherry_picking.age")
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                                src: (0, (/*@__PURE__*/$parcel$interopDefault($2c36da916d923dd9$exports)))
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $61076bfc19b3ff31$export$2e2bcd8739ae039), {
                space: 24
            }),
            getCherryPickingApplicantsQuery.isLoading && isSortingLoading ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $57fb8f45c69e1681$export$2e2bcd8739ae039), {}) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7b02d682eb115277$exports.Fragment), {
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: "ApplicantsSection__list",
                    children: [
                        isPermanentJob ? applicants.list.length > 4 && applicants.list.filter((applicant)=>prioritizedApplicantIds.includes(applicant.id)).map((applicant, i)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $8ba84356426acf88$export$2e2bcd8739ae039), {
                                        jobId: jobId,
                                        jobType: jobType,
                                        applicant: {
                                            id: applicant.id,
                                            name: applicant.name,
                                            age: applicant.age,
                                            image_url: applicant.image_url,
                                            languages: applicant.languages,
                                            nationality: applicant.nationality,
                                            is_favorite: Boolean(applicant.is_favorite),
                                            skillMatch: applicant.skillMatch,
                                            is_chief: applicant.is_chief,
                                            rating: applicant.rating,
                                            top_qualities: applicant.top_qualities,
                                            years_experience: applicant.years_experience,
                                            skills: applicant.skills,
                                            status: applicant.isAccepted ? (0, $1a7db182178118f7$export$41c5030382f95eb6).SHORTLISTED : (0, $1a7db182178118f7$export$41c5030382f95eb6).PENDING
                                        },
                                        shiftId: shiftId,
                                        onPlayAnswersPress: ()=>{
                                            setCurrentApplicant(applicant.id, jobType);
                                            const interview = getInterviewByJobId(parseInt(jobId));
                                            const questionIds = getInterviewQuestions(interview.id);
                                            const applicantQuestions = questionIds.filter((q)=>{
                                                const answer = getSpAnswer({
                                                    spId: applicant.id,
                                                    interviewId: interview.id,
                                                    questionId: q
                                                });
                                                return Boolean(answer);
                                            });
                                            setCurrentQuestion({
                                                qId: applicantQuestions[0],
                                                qIndex: 0
                                            });
                                        },
                                        onAccepted: (applicantId)=>{
                                            if (!prioritizedApplicantIds.includes(applicantId)) setPrioritizedApplicantIds([
                                                ...prioritizedApplicantIds,
                                                applicantId
                                            ]);
                                        }
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $61076bfc19b3ff31$export$2e2bcd8739ae039), {
                                        space: i === applicants.list.length - 1 ? 28 : 14
                                    })
                                ]
                            }, i)) : null,
                        applicants.list.map((item, i)=>{
                            const applicantOfPermanentJob = item;
                            const applicant = item;
                            return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $8ba84356426acf88$export$2e2bcd8739ae039), {
                                        jobId: jobId,
                                        jobType: jobType,
                                        applicant: isPermanentJob ? {
                                            id: applicantOfPermanentJob.job_application_id,
                                            name: applicantOfPermanentJob.full_name,
                                            age: applicantOfPermanentJob.age,
                                            image_url: applicantOfPermanentJob.profile_photo,
                                            languages: applicantOfPermanentJob.spoken_languages,
                                            nationality: applicantOfPermanentJob.nationality,
                                            status: applicantOfPermanentJob.client_status_id
                                        } : {
                                            id: applicant.id,
                                            name: applicant.name,
                                            age: applicant.age,
                                            image_url: applicant.image_url,
                                            languages: applicant.languages,
                                            nationality: applicant.nationality,
                                            is_favorite: Boolean(applicant.is_favorite),
                                            skillMatch: applicant.skillMatch,
                                            is_chief: applicant.is_chief,
                                            rating: applicant.rating,
                                            top_qualities: applicant.top_qualities,
                                            years_experience: applicant.years_experience,
                                            skills: applicant.skills,
                                            status: applicant.isAccepted ? (0, $1a7db182178118f7$export$41c5030382f95eb6).SHORTLISTED : (0, $1a7db182178118f7$export$41c5030382f95eb6).PENDING
                                        },
                                        shiftId: shiftId,
                                        onPlayAnswersPress: ()=>{
                                            setCurrentApplicant(applicant.id, jobType);
                                            const interview = getInterviewByJobId(parseInt(jobId));
                                            const questionIds = getInterviewQuestions(interview.id);
                                            const applicantQuestions = questionIds.filter((q)=>{
                                                const answer = getSpAnswer({
                                                    spId: applicant.id,
                                                    interviewId: interview.id,
                                                    questionId: q
                                                });
                                                return Boolean(answer);
                                            });
                                            setCurrentQuestion({
                                                qId: applicantQuestions[0],
                                                qIndex: 0
                                            });
                                        },
                                        onAccepted: (applicantId)=>{
                                            if (!prioritizedApplicantIds.includes(applicantId)) setPrioritizedApplicantIds([
                                                ...prioritizedApplicantIds,
                                                applicantId
                                            ]);
                                        }
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $61076bfc19b3ff31$export$2e2bcd8739ae039), {
                                        space: i === applicants.list.length - 1 ? 28 : 14
                                    })
                                ]
                            }, i);
                        }),
                        applicants.paginator?.next_page ? getCherryPickingApplicantsQuery.isLoading && isPaginationLoading ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $57fb8f45c69e1681$export$2e2bcd8739ae039), {}) : null : null
                    ]
                })
            }),
            showChiefModal && chiefOg && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5470867b90519ae0$export$d13ecf3b0ae7b64d), {
                name: chiefOg.name ?? "Applicant",
                imgSrc: chiefOg.image ?? "",
                onClose: ()=>{
                    setShowChiefModal(false);
                }
            }),
            !isPermanentJob && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b796eeaf55507ebc$export$7fe57d46322b10ad), {
                applicantsType: "multiple",
                jobId: parseInt(jobId),
                showInitialQuestion: currentQuestion,
                onAcceptPress: ()=>{
                    acceptApplicant({
                        sp_id: String(currentApplicant?.id),
                        job_id: parseInt(jobId),
                        shift_ids: shiftId ? [
                            shiftId
                        ] : undefined
                    });
                }
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $9c16b10bbbe042e5$export$129a32eedafa97c5), {
                isActive: currentApplicant !== null,
                content: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c665f284476b5703$export$2e2bcd8739ae039), {
                    jobId: String(jobId),
                    jobType: jobType,
                    showHeader: false,
                    showControls: true
                }),
                close: ()=>clearCurrentApplicant(jobType)
            })
        ]
    });
}));
var $8e9c336d82dad77e$export$2e2bcd8739ae039 = $8e9c336d82dad77e$var$ApplicantsSection;





var $5f455a9731d87f46$exports = {};
$5f455a9731d87f46$exports = new URL("file-icon.bdab9ec6.svg", import.meta.url).toString();





const $fbcbc15b4811bea0$var$JobCherryPicking = (0, $a4963babae245ff9$export$f0c7a449e0cfaec7)((0, $aca50e9407ba89c9$export$b6ae1bc530f4c149)(({ jobId: jobId, shiftId: shiftId, type: type })=>{
    const parsedShiftId = shiftId ? parseInt(shiftId) : undefined;
    const { getCherryPickingByIdView: getCherryPickingByIdView, getCherryPickingJob: getCherryPickingJob, getCherryPickingApplicantsApiCall: getCherryPickingApplicantsApiCall, getInterview: getInterview } = (0, $4671947198ddd366$export$6ccbb43953eebf8)().data;
    const parsedJobId = parseInt(jobId);
    const cherryPickingJob = getCherryPickingByIdView(jobId);
    const getCherryPickingJobQuery = (0, $4671947198ddd366$export$dd0a697e1782aedd)(()=>getCherryPickingJob(jobId));
    const getCherryPickingApplicantsQuery = (0, $4671947198ddd366$export$dd0a697e1782aedd)(()=>getCherryPickingApplicantsApiCall({
            jobId: parsedJobId,
            sortBy: "rating",
            jobType: type ?? (0, $862a04ca6e0d681b$export$27a7f855854fa13d).oneTime,
            shiftId: parsedShiftId
        }));
    (0, $4671947198ddd366$export$dd0a697e1782aedd)(()=>getInterview({
            jobId: parsedJobId
        }), {
        filterError: [
            (0, $9ad33fbf770c55a1$export$9696fcf1798e1cb5).NotFound
        ]
    });
    const { t: t } = (0, $3765cebd031b52c0$export$9fc83ad70ead8663)();
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        className: "JobCherryPicking",
        children: !getCherryPickingJobQuery.isLoading && !getCherryPickingApplicantsQuery.isLoading ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
            className: "JobCherryPicking__container",
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7ae42b63183f30b4$export$8b251419efc915eb), {
                    showBack: true,
                    title: cherryPickingJob.work_category_name
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $660b2ca422e0e2ae$export$1ff3c3f08ae963c0).Vertical, {
                    height: 38
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ec2248901324e8a8$export$2e2bcd8739ae039), {
                    image: (0, (/*@__PURE__*/$parcel$interopDefault($5f455a9731d87f46$exports))),
                    title: t("job_cherry_picking.title")
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $61076bfc19b3ff31$export$2e2bcd8739ae039), {
                    space: 14
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $8e9c336d82dad77e$export$2e2bcd8739ae039), {
                    jobId: jobId,
                    jobType: type ?? (0, $862a04ca6e0d681b$export$27a7f855854fa13d).oneTime,
                    shiftId: parsedShiftId,
                    cherryPickingJob: cherryPickingJob
                })
            ]
        }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
            className: "spinner",
            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $57fb8f45c69e1681$export$2e2bcd8739ae039), {})
        })
    });
}));
var $fbcbc15b4811bea0$export$2e2bcd8739ae039 = $fbcbc15b4811bea0$var$JobCherryPicking;




var $acw62 = parcelRequire("acw62");









var $45fvw = parcelRequire("45fvw");

var $acw62 = parcelRequire("acw62");





const $ad9170bc1439ad01$var$MINIMUM_RATIO = 50 // minimum ration to turn fullfilment into green badge
;
const $ad9170bc1439ad01$var$getRatio = (current, total)=>{
    return Math.round(current / total * 100);
};
const $ad9170bc1439ad01$var$ApplicantReviewJobCard = ({ onClick: onClick, jobDetails: jobDetails })=>{
    const fullFilmentRatio = (0, $acw62.useMemo)(()=>{
        return $ad9170bc1439ad01$var$getRatio(jobDetails.shifts_fulfilled_count, jobDetails.shifts_count);
    }, [
        jobDetails
    ]);
    const { t: t } = (0, $3765cebd031b52c0$export$9fc83ad70ead8663)();
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        onClick: onClick,
        className: "ApplicantReviewJobCard",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h6", {
                className: `ApplicantReviewJobCard__fullfillmentPercentage ${fullFilmentRatio <= $ad9170bc1439ad01$var$MINIMUM_RATIO ? "" : "ApplicantReviewJobCard__fullfillmentPercentage--green"}`,
                children: t("applicants_review.percent_filled", {
                    percent: fullFilmentRatio
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("h5", {
                className: "ApplicantReviewJobCard__name",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                        children: jobDetails.work_category_name
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                        children: [
                            "(",
                            jobDetails.quantity ?? jobDetails.required_quantity,
                            ")"
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "ApplicantReviewJobCard__details",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                        src: (0, (/*@__PURE__*/$parcel$interopDefault($cab7dbc8172ddafd$exports)))
                    }),
                    jobDetails.location_name
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "ApplicantReviewJobCard__details",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                        src: (0, (/*@__PURE__*/$parcel$interopDefault($bad31fa192b525ae$exports)))
                    }),
                    (0, (/*@__PURE__*/$parcel$interopDefault($45fvw)))(jobDetails.start_date).format((0, $ddf12117b815a7c3$export$4e4cb19dd88cd821)),
                    " - ",
                    (0, (/*@__PURE__*/$parcel$interopDefault($45fvw)))(jobDetails.end_date).format((0, $ddf12117b815a7c3$export$4e4cb19dd88cd821))
                ]
            })
        ]
    });
};
var $ad9170bc1439ad01$export$2e2bcd8739ae039 = $ad9170bc1439ad01$var$ApplicantReviewJobCard;





const $947690a1ca4e1dc1$var$ApplicantsReviewPage = (0, $a4963babae245ff9$export$f0c7a449e0cfaec7)((0, $aca50e9407ba89c9$export$b6ae1bc530f4c149)(()=>{
    const { getUnFullfilledJobList: getUnFullfilledJobList, cherryPickingListView: cherryPickingListView } = (0, $4671947198ddd366$export$6ccbb43953eebf8)().data;
    const [getUnFullfilledJobsMutation, getUnFullfilledJobsApiCall] = (0, $4671947198ddd366$export$609860bf8b0084c)(({ page: page })=>getUnFullfilledJobList(page));
    (0, $acw62.useEffect)(()=>{
        getUnFullfilledJobsApiCall({
            page: 1
        });
    }, []);
    const handleScroll = (0, $324dc7daf4e64dab$export$5bd4c3b2b0a1aaf1)(()=>getUnFullfilledJobsApiCall({}));
    const navigate = (0, $7df35e9df335b1c8$export$602eaf6d5314ce55)();
    const { t: t } = (0, $3765cebd031b52c0$export$9fc83ad70ead8663)();
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "ApplicantsReviewPage",
        onScroll: handleScroll,
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7ae42b63183f30b4$export$8b251419efc915eb), {
                title: t("applicants_review.title")
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $660b2ca422e0e2ae$export$1ff3c3f08ae963c0).Vertical, {
                height: 28
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "ApplicantsReviewPage__container",
                children: [
                    Boolean(cherryPickingListView.length) && cherryPickingListView.map((job, i)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ad9170bc1439ad01$export$2e2bcd8739ae039), {
                                    jobDetails: job,
                                    onClick: ()=>navigate((0, $0534349ae8731d0b$export$66b32f6f30eb4b4).jobOGCherryPicker, {
                                            jobId: String(job.id),
                                            type: job.type
                                        })
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $660b2ca422e0e2ae$export$1ff3c3f08ae963c0).Vertical, {
                                    height: 16
                                })
                            ]
                        }, i)),
                    !getUnFullfilledJobsMutation.isLoading && !cherryPickingListView.length ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                        className: "ApplicantsReviewPage__noJobs",
                        children: t("applicants_review.no_applicants_to_reivew")
                    }) : null,
                    getUnFullfilledJobsMutation.isLoading && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $57fb8f45c69e1681$export$2e2bcd8739ae039), {})
                ]
            })
        ]
    });
}));
var $947690a1ca4e1dc1$export$2e2bcd8739ae039 = $947690a1ca4e1dc1$var$ApplicantsReviewPage;



const $a957d9f7f544561d$export$3d21776aad85d3f = {
    ApplicantsReviewPage: $947690a1ca4e1dc1$export$2e2bcd8739ae039,
    JobCherryPickingPage: $fbcbc15b4811bea0$export$2e2bcd8739ae039,
    ApplicantDetailsPage: $c665f284476b5703$export$2e2bcd8739ae039
};






var $acw62 = parcelRequire("acw62");




var $acw62 = parcelRequire("acw62");













function $86533ea03b238cc7$export$eae70af4b4e3f197(props) {
    const { t: t } = (0, $3765cebd031b52c0$export$9fc83ad70ead8663)();
    const controlDefaultClassNames = `MultiSelect__control${props.className ? ` ${props.className}` : ""}`;
    const options = props.options.map((val)=>{
        return {
            value: val.value,
            label: val.label
        };
    });
    const item = options.find((val)=>val.value === (props.value ?? props.field?.value));
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7b02d682eb115277$exports.Fragment), {
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7532f3e29d96fa2a$export$2e2bcd8739ae039), {
            defaultValue: props.preselectAll ? options : [
                item
            ],
            onChange: (selectedOptions)=>{
                props.onChange(selectedOptions.map((option)=>String(option?.value)));
            },
            required: props.required,
            options: options,
            placeholder: props.label ?? t("common.select"),
            classNames: {
                control: (state)=>!state.isFocused ? controlDefaultClassNames : `${controlDefaultClassNames} MultiSelect__control--focused`,
                menu: (state)=>"MultiSelect__menu"
            },
            className: "MultiSelect",
            isMulti: true
        })
    });
}





var $45fvw = parcelRequire("45fvw");

var $acw62 = parcelRequire("acw62");
function $ed784cdccdc5fac8$var$CalendarLocationFilterComponent({ locationIds: locationIds, setLocationIds: setLocationIds, selectedDate: selectedDate }) {
    (0, (/*@__PURE__*/$parcel$interopDefault($45fvw))).locale("en");
    const { t: t } = (0, $3765cebd031b52c0$export$9fc83ad70ead8663)();
    const { locationsDataView: locationsDataView, getLocations: getLocations, getLocationByName: getLocationByName } = (0, $4671947198ddd366$export$6ccbb43953eebf8)().data;
    const [locationsQueryResult, locationsQuery] = (0, $4671947198ddd366$export$609860bf8b0084c)(({ hasShiftsFrom: hasShiftsFrom, hasShiftsTo: hasShiftsTo })=>getLocations({
            hasShiftsFrom: hasShiftsFrom,
            hasShiftsTo: hasShiftsTo
        }));
    (0, $acw62.useEffect)(()=>{
        const weekDates = (0, $ddf12117b815a7c3$export$8a5160aad7ff40be)(selectedDate);
        const firstDayOfWeek = (0, (/*@__PURE__*/$parcel$interopDefault($45fvw)))(weekDates[0]).format("YYYY-MM-DD");
        const lastDayOfWeek = (0, (/*@__PURE__*/$parcel$interopDefault($45fvw)))(weekDates[weekDates.length - 1]).format("YYYY-MM-DD");
        locationsQuery({
            hasShiftsFrom: firstDayOfWeek,
            hasShiftsTo: lastDayOfWeek
        });
    }, [
        selectedDate
    ]);
    const locationOptions = locationsDataView.length > 0 ? locationsDataView.map((location)=>({
            key: String(location.id),
            label: location.name,
            value: location.name
        })) : [];
    if (locationsQueryResult.isLoading) return null;
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        className: "CalendarLocationFilter",
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $86533ea03b238cc7$export$eae70af4b4e3f197), {
            options: locationOptions,
            className: "CalendarLocationFilter__select",
            label: t("all_jobs.filter_location"),
            onChange: (values)=>{
                (0, $c74a0566d4b0fd6d$export$e9db7d6e73593439).track((0, $c74a0566d4b0fd6d$export$5e27155e276f6d1c).TimesheetLocationFilterUsed);
                setLocationIds(values.map((locationName)=>getLocationByName(locationName).id));
            }
        })
    });
}
const $ed784cdccdc5fac8$export$d5af917cda824109 = (0, $aca50e9407ba89c9$export$b6ae1bc530f4c149)($ed784cdccdc5fac8$var$CalendarLocationFilterComponent);





var $acw62 = parcelRequire("acw62");




const $6ed8efbd9650f642$export$cf4c5373545d9a45 = ({ onPreviousWeekPress: onPreviousWeekPress, onNextWeekPress: onNextWeekPress, additionalContainerClassName: additionalContainerClassName, selectedDate: selectedDate, setSelectedDate: setSelectedDate, setCurrentWeek: setCurrentWeek })=>{
    const { t: t } = (0, $3765cebd031b52c0$export$9fc83ad70ead8663)();
    const [showCalendar, setShowCalendar] = (0, $acw62.useState)(false);
    const [hoveredDate, setHoveredDate] = (0, $acw62.useState)(null);
    const calendarRef = (0, $acw62.useRef)(null);
    (0, $3820618f4f4eb2a5$export$aa79b0abe3dfeaba)(calendarRef, ()=>setShowCalendar(false));
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: `CalendarHeader__weekToggle ${additionalContainerClassName}`,
        children: [
            showCalendar && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $dd807b100864eab2$export$2e2bcd8739ae039), {
                value: selectedDate,
                setValue: (value)=>{
                    if (value) {
                        const res = new Date(value);
                        res.setHours(selectedDate.getHours(), selectedDate.getMinutes(), selectedDate.getSeconds());
                        setSelectedDate(res);
                    }
                    setShowCalendar(false);
                    (0, $c74a0566d4b0fd6d$export$e9db7d6e73593439).track((0, $c74a0566d4b0fd6d$export$5e27155e276f6d1c).TimesheetWeekSwitchedViaCalendar);
                },
                containerClassName: "DateInput__Calendar CalendarHeader__weekToggle__calendar",
                hoveredDate: hoveredDate,
                setHoveredDate: setHoveredDate,
                ref: calendarRef,
                bottomActionTitle: t("all_jobs.current_week"),
                bottomActionCallback: ()=>{
                    setCurrentWeek();
                    setShowCalendar(false);
                    (0, $c74a0566d4b0fd6d$export$e9db7d6e73593439).track((0, $c74a0566d4b0fd6d$export$5e27155e276f6d1c).TimesheetCurrentWeekClicked);
                },
                highlightWeek: true
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "CalendarHeader__right__toggle",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        onClick: ()=>{
                            (0, $c74a0566d4b0fd6d$export$e9db7d6e73593439).track((0, $c74a0566d4b0fd6d$export$5e27155e276f6d1c).TimesheetWeekBackClicked);
                            onPreviousWeekPress();
                        },
                        className: "CalendarHeader__right__toggle__arrowContainer CalendarHeader__right__toggle__arrowContainer--left",
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                            src: (0, (/*@__PURE__*/$parcel$interopDefault($62c9e56fdb451f8c$exports))),
                            className: "CalendarHeader__right__toggle__arrowContainer__arrow"
                        })
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("button", {
                        className: "CalendarHeader__right__currentWeekButton",
                        onClick: ()=>{
                            setShowCalendar(true);
                            (0, $c74a0566d4b0fd6d$export$e9db7d6e73593439).track((0, $c74a0566d4b0fd6d$export$5e27155e276f6d1c).TimesheetCalendarSwitcherOpened);
                        },
                        children: [
                            "\uD83D\uDDD3\uFE0F ",
                            t("all_jobs.week")
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        onClick: ()=>{
                            (0, $c74a0566d4b0fd6d$export$e9db7d6e73593439).track((0, $c74a0566d4b0fd6d$export$5e27155e276f6d1c).TimesheetWeekForwardClicked);
                            onNextWeekPress();
                        },
                        className: "CalendarHeader__right__toggle__arrowContainer CalendarHeader__right__toggle__arrowContainer--right",
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                            src: (0, (/*@__PURE__*/$parcel$interopDefault($62c9e56fdb451f8c$exports))),
                            className: "CalendarHeader__right__toggle__arrowContainer__arrow flipped"
                        })
                    })
                ]
            })
        ]
    });
};










var $acw62 = parcelRequire("acw62");


var $45fvw = parcelRequire("45fvw");
function $7abfb270acb2f518$var$CalendarDesignationFilterComponent({ designationIds: designationIds, setDesignationIds: setDesignationIds, selectedDate: selectedDate, locationIds: locationIds }) {
    (0, (/*@__PURE__*/$parcel$interopDefault($45fvw))).locale("en");
    const { t: t } = (0, $3765cebd031b52c0$export$9fc83ad70ead8663)();
    const { professionList: professionList, getProfessions: getProfessions } = (0, $4671947198ddd366$export$6ccbb43953eebf8)().data;
    const [professionsQueryResult, professionsQuery] = (0, $4671947198ddd366$export$609860bf8b0084c)(({ hasShiftsFrom: hasShiftsFrom, hasShiftsTo: hasShiftsTo, hasShiftsAtLocationIds: hasShiftsAtLocationIds })=>getProfessions({
            hasShiftsFrom: hasShiftsFrom,
            hasShiftsTo: hasShiftsTo,
            hasShiftsAtLocationIds: hasShiftsAtLocationIds
        }));
    (0, $acw62.useEffect)(()=>{
        const weekDates = (0, $ddf12117b815a7c3$export$8a5160aad7ff40be)(selectedDate);
        const firstDayOfWeek = (0, (/*@__PURE__*/$parcel$interopDefault($45fvw)))(weekDates[0]).format("YYYY-MM-DD");
        const lastDayOfWeek = (0, (/*@__PURE__*/$parcel$interopDefault($45fvw)))(weekDates[weekDates.length - 1]).format("YYYY-MM-DD");
        professionsQuery({
            hasShiftsFrom: firstDayOfWeek,
            hasShiftsTo: lastDayOfWeek,
            hasShiftsAtLocationIds: locationIds
        });
    }, [
        selectedDate,
        locationIds
    ]);
    const dataOptions = professionList.length > 0 ? professionList.map((item)=>({
            key: String(item.id),
            label: item.name,
            value: item.id
        })) : [];
    if (professionsQueryResult.isLoading) return null;
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        className: "CalendarLocationFilter",
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $86533ea03b238cc7$export$eae70af4b4e3f197), {
            options: dataOptions,
            className: "CalendarLocationFilter__select",
            label: t("all_jobs.filter_designation"),
            onChange: (values)=>{
                (0, $c74a0566d4b0fd6d$export$e9db7d6e73593439).track((0, $c74a0566d4b0fd6d$export$5e27155e276f6d1c).TimesheetDesignationFilterUsed);
                setDesignationIds(values.map((value)=>Number(value)));
            }
        })
    });
}
const $7abfb270acb2f518$export$b4c445ad9eafbafd = (0, $aca50e9407ba89c9$export$b6ae1bc530f4c149)($7abfb270acb2f518$var$CalendarDesignationFilterComponent);



function $6a9f0ca1529bcf13$export$9c75275274db0b56({ month: month, year: year, onPreviousWeekPress: onPreviousWeekPress, onNextWeekPress: onNextWeekPress, locationIds: locationIds, setLocationIds: setLocationIds, designationIds: designationIds, setDesignationIds: setDesignationIds, selectedDate: selectedDate, setSelectedDate: setSelectedDate, setCurrentWeek: setCurrentWeek }) {
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "CalendarHeader__container",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "CalendarHeader__top mobile-only",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                        className: "CalendarHeader__label",
                        onClick: ()=>(0, $c74a0566d4b0fd6d$export$e9db7d6e73593439).track((0, $c74a0566d4b0fd6d$export$5e27155e276f6d1c).TimesheetMonthTitleClicked),
                        children: [
                            month,
                            " ",
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                className: "CalendarHeader__label--dimmed",
                                children: year
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $6ed8efbd9650f642$export$cf4c5373545d9a45), {
                        onPreviousWeekPress: onPreviousWeekPress,
                        onNextWeekPress: onNextWeekPress,
                        selectedDate: selectedDate,
                        setSelectedDate: setSelectedDate,
                        setCurrentWeek: setCurrentWeek
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "CalendarHeader",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "CalendarHeader__left",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                className: "CalendarHeader__label desktop-only",
                                onClick: ()=>(0, $c74a0566d4b0fd6d$export$e9db7d6e73593439).track((0, $c74a0566d4b0fd6d$export$5e27155e276f6d1c).TimesheetMonthTitleClicked),
                                children: [
                                    month,
                                    " ",
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                        className: "CalendarHeader__label--dimmed",
                                        children: year
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $6ed8efbd9650f642$export$cf4c5373545d9a45), {
                                onPreviousWeekPress: onPreviousWeekPress,
                                onNextWeekPress: onNextWeekPress,
                                additionalContainerClassName: "desktop-only",
                                selectedDate: selectedDate,
                                setSelectedDate: setSelectedDate,
                                setCurrentWeek: setCurrentWeek
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "CalendarHeader__right",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ed784cdccdc5fac8$export$d5af917cda824109), {
                                locationIds: locationIds,
                                setLocationIds: setLocationIds,
                                selectedDate: selectedDate
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7abfb270acb2f518$export$b4c445ad9eafbafd), {
                                designationIds: designationIds,
                                setDesignationIds: setDesignationIds,
                                selectedDate: selectedDate,
                                locationIds: locationIds
                            })
                        ]
                    })
                ]
            })
        ]
    });
}




var $acw62 = parcelRequire("acw62");




function $dbc13932976f284e$export$e4f4428c231e7e81({ firstWeekDate: firstWeekDate }) {
    const todayDate = (0, $acw62.useRef)(new Date()).current;
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "CalendarWeek",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "CalendarWeek__emptyColumn"
            }),
            (0, $ddf12117b815a7c3$export$8a5160aad7ff40be)(firstWeekDate).map((date)=>{
                const weekdayName = (0, $ddf12117b815a7c3$export$28daf0b8a647a8fb)(date);
                const isActive = todayDate.getFullYear() === date.getFullYear() && todayDate.getMonth() === date.getMonth() && todayDate.getDate() === date.getDate();
                const day = date.getDate();
                return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $acw62.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                            className: "CalendarWeek__separator"
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                            className: `CalendarWeek__column ${isActive ? "active" : ""}`,
                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "CalendarWeek__column__container",
                                onClick: ()=>(0, $c74a0566d4b0fd6d$export$e9db7d6e73593439).track((0, $c74a0566d4b0fd6d$export$5e27155e276f6d1c).TimesheetDateTitleClicked),
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                        className: `CalendarWeek__column__container__day ${isActive ? "active" : ""}`,
                                        children: day
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                        className: `CalendarWeek__column__container__weekday ${isActive ? "active" : ""}`,
                                        children: weekdayName
                                    })
                                ]
                            })
                        })
                    ]
                }, day);
            })
        ]
    });
}
const $dbc13932976f284e$export$adf10f8fbb88fe03 = (0, $aca50e9407ba89c9$export$b6ae1bc530f4c149)($dbc13932976f284e$export$e4f4428c231e7e81);




var $acw62 = parcelRequire("acw62");


var $45fvw = parcelRequire("45fvw");




var $acw62 = parcelRequire("acw62");



function $d7d699d270b6e0ff$export$6eb0f7ddcda6131f({ collapsed: collapsed, children: children, maxHeight: maxHeight }) {
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        style: {
            maxHeight: maxHeight
        },
        className: `Collapsible${collapsed ? "__collapsed" : ""}`,
        children: children
    });
}



var $ad94f1ad0ce40ff8$exports = {};
$ad94f1ad0ce40ff8$exports = new URL("arrow-dropdown-right.8bf1c02a.svg", import.meta.url).toString();


var $3f358c88739d96d9$exports = {};
$3f358c88739d96d9$exports = new URL("arrow-dropdown-down.f5b77ebd.svg", import.meta.url).toString();


var $2cf662f6f197957c$exports = {};
$2cf662f6f197957c$exports = new URL("location-icon.119855be.svg", import.meta.url).toString();





var $acw62 = parcelRequire("acw62");




var $acw62 = parcelRequire("acw62");




var $141e2f05bdfd7113$exports = {};
$141e2f05bdfd7113$exports = new URL("candidates-icon.ffab295e.svg", import.meta.url).toString();





function $aedbca7c4de9cfc5$export$d41802dec660cc2b({ imageUrl: imageUrl, name: name, spId: spId, jobId: jobId, isAggregation: isAggregation = false, applicantsCount: applicantsCount }) {
    const [isProfileShown, setIsProfileShown] = (0, $acw62.useState)(false);
    const redirect = (0, $7df35e9df335b1c8$export$602eaf6d5314ce55)();
    const { t: t } = (0, $3765cebd031b52c0$export$9fc83ad70ead8663)();
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "SpColumn",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                onClick: ()=>{
                    if (!isAggregation) {
                        setIsProfileShown(true);
                        (0, $c74a0566d4b0fd6d$export$e9db7d6e73593439).track((0, $c74a0566d4b0fd6d$export$5e27155e276f6d1c).TimesheetSPProfileClicked);
                    } else redirect((0, $0534349ae8731d0b$export$66b32f6f30eb4b4).jobOGCherryPicker, {
                        jobId: String(jobId),
                        type: (0, $862a04ca6e0d681b$export$27a7f855854fa13d).oneTime
                    });
                },
                src: !isAggregation ? String(imageUrl) : (0, (/*@__PURE__*/$parcel$interopDefault($141e2f05bdfd7113$exports))),
                title: name,
                className: "SpColumn__img"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                onClick: ()=>{
                    if (!isAggregation) {
                        setIsProfileShown(true);
                        (0, $c74a0566d4b0fd6d$export$e9db7d6e73593439).track((0, $c74a0566d4b0fd6d$export$5e27155e276f6d1c).TimesheetSPProfileClicked);
                    } else redirect((0, $0534349ae8731d0b$export$66b32f6f30eb4b4).jobOGCherryPicker, {
                        jobId: String(jobId),
                        type: (0, $862a04ca6e0d681b$export$27a7f855854fa13d).oneTime
                    });
                },
                className: "SpColumn__textContainer",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                        className: "SpColumn__name",
                        children: name
                    }),
                    isAggregation && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                        className: "SpColumn__candidates",
                        children: `${Number(applicantsCount) > 99 ? "99+" : Number(applicantsCount)} Candidates`
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                        className: "SpColumn__id",
                        children: t("common.job_n", {
                            id: jobId
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $9c16b10bbbe042e5$export$129a32eedafa97c5), {
                isActive: isProfileShown,
                content: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c665f284476b5703$export$2e2bcd8739ae039), {
                    jobId: String(jobId),
                    jobType: (0, $862a04ca6e0d681b$export$27a7f855854fa13d).oneTime,
                    applicantId: spId,
                    showHeader: false,
                    showControls: false
                }),
                close: ()=>setIsProfileShown(false)
            })
        ]
    });
}




var $acw62 = parcelRequire("acw62");




function $c3e48ebea9c34168$export$816b5d811295e6bc({ children: children }) {
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        className: "ScheduleColumn",
        children: children
    });
}




function $7f0bcd362b4bc024$export$77aefc78c058cb5d() {
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        className: "RowSeparator"
    });
}



function $d138f1021db5629b$var$CellsComponent({ weekDates: weekDates, jobSchedules: jobSchedules, firstWeekDate: firstWeekDate, renderCell: renderContent }) {
    const { getJobShift: getJobShift } = (0, $4671947198ddd366$export$6ccbb43953eebf8)().data;
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7b02d682eb115277$exports.Fragment), {
        children: weekDates.map((date)=>{
            const formatedWeekDate = (0, $ddf12117b815a7c3$export$efb113ee57e9edfb)(firstWeekDate);
            let dateShift = null;
            let jobSchedule = null;
            jobSchedules.forEach((jobScheduleItem, key)=>{
                const existingDateShift = jobScheduleItem.getDateShift(date);
                if (existingDateShift?.shift_id) {
                    dateShift = existingDateShift;
                    jobSchedule = jobScheduleItem;
                }
            });
            const jobShift = dateShift && jobSchedule ? getJobShift(jobSchedule.job_id, formatedWeekDate, Number(dateShift.shift_id)) : null;
            return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $acw62.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7f0bcd362b4bc024$export$77aefc78c058cb5d), {}),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c3e48ebea9c34168$export$816b5d811295e6bc), {
                        children: renderContent({
                            jobSchedule: jobSchedule,
                            shift: jobShift,
                            dateShift: dateShift
                        })
                    })
                ]
            }, date.getDate());
        })
    });
}
const $d138f1021db5629b$export$99889833ab266a29 = (0, $aca50e9407ba89c9$export$b6ae1bc530f4c149)($d138f1021db5629b$var$CellsComponent);









var $45fvw = parcelRequire("45fvw");


var $acw62 = parcelRequire("acw62");


var $acw62 = parcelRequire("acw62");

var $1u0KT = parcelRequire("1u0KT");
var $23a8f689f1d4c3be$var$index = typeof document !== "undefined" ? (0, $acw62.useLayoutEffect) : (0, $acw62.useEffect);
// Fork of `fast-deep-equal` that only does the comparisons we need and compares
// functions
function $23a8f689f1d4c3be$var$deepEqual(a, b) {
    if (a === b) return true;
    if (typeof a !== typeof b) return false;
    if (typeof a === "function" && a.toString() === b.toString()) return true;
    let length;
    let i;
    let keys;
    if (a && b && typeof a === "object") {
        if (Array.isArray(a)) {
            length = a.length;
            if (length !== b.length) return false;
            for(i = length; i-- !== 0;){
                if (!$23a8f689f1d4c3be$var$deepEqual(a[i], b[i])) return false;
            }
            return true;
        }
        keys = Object.keys(a);
        length = keys.length;
        if (length !== Object.keys(b).length) return false;
        for(i = length; i-- !== 0;){
            if (!({}).hasOwnProperty.call(b, keys[i])) return false;
        }
        for(i = length; i-- !== 0;){
            const key = keys[i];
            if (key === "_owner" && a.$$typeof) continue;
            if (!$23a8f689f1d4c3be$var$deepEqual(a[key], b[key])) return false;
        }
        return true;
    }
    return a !== a && b !== b;
}
function $23a8f689f1d4c3be$var$getDPR(element) {
    if (typeof window === "undefined") return 1;
    const win = element.ownerDocument.defaultView || window;
    return win.devicePixelRatio || 1;
}
function $23a8f689f1d4c3be$var$roundByDPR(element, value) {
    const dpr = $23a8f689f1d4c3be$var$getDPR(element);
    return Math.round(value * dpr) / dpr;
}
function $23a8f689f1d4c3be$var$useLatestRef(value) {
    const ref = $acw62.useRef(value);
    $23a8f689f1d4c3be$var$index(()=>{
        ref.current = value;
    });
    return ref;
}
/**
 * Provides data to position a floating element.
 * @see https://floating-ui.com/docs/useFloating
 */ function $23a8f689f1d4c3be$export$4e02a5c1d08bac65(options) {
    if (options === void 0) options = {};
    const { placement: placement = "bottom", strategy: strategy = "absolute", middleware: middleware = [], platform: platform, elements: { reference: externalReference, floating: externalFloating } = {}, transform: transform = true, whileElementsMounted: whileElementsMounted, open: open } = options;
    const [data, setData] = $acw62.useState({
        x: 0,
        y: 0,
        strategy: strategy,
        placement: placement,
        middlewareData: {},
        isPositioned: false
    });
    const [latestMiddleware, setLatestMiddleware] = $acw62.useState(middleware);
    if (!$23a8f689f1d4c3be$var$deepEqual(latestMiddleware, middleware)) setLatestMiddleware(middleware);
    const [_reference, _setReference] = $acw62.useState(null);
    const [_floating, _setFloating] = $acw62.useState(null);
    const setReference = $acw62.useCallback((node)=>{
        if (node !== referenceRef.current) {
            referenceRef.current = node;
            _setReference(node);
        }
    }, []);
    const setFloating = $acw62.useCallback((node)=>{
        if (node !== floatingRef.current) {
            floatingRef.current = node;
            _setFloating(node);
        }
    }, []);
    const referenceEl = externalReference || _reference;
    const floatingEl = externalFloating || _floating;
    const referenceRef = $acw62.useRef(null);
    const floatingRef = $acw62.useRef(null);
    const dataRef = $acw62.useRef(data);
    const hasWhileElementsMounted = whileElementsMounted != null;
    const whileElementsMountedRef = $23a8f689f1d4c3be$var$useLatestRef(whileElementsMounted);
    const platformRef = $23a8f689f1d4c3be$var$useLatestRef(platform);
    const openRef = $23a8f689f1d4c3be$var$useLatestRef(open);
    const update = $acw62.useCallback(()=>{
        if (!referenceRef.current || !floatingRef.current) return;
        const config = {
            placement: placement,
            strategy: strategy,
            middleware: latestMiddleware
        };
        if (platformRef.current) config.platform = platformRef.current;
        (0, $461947879dcdbcd4$export$48a53dcb22e581d0)(referenceRef.current, floatingRef.current, config).then((data)=>{
            const fullData = {
                ...data,
                // The floating element's position may be recomputed while it's closed
                // but still mounted (such as when transitioning out). To ensure
                // `isPositioned` will be `false` initially on the next open, avoid
                // setting it to `true` when `open === false` (must be specified).
                isPositioned: openRef.current !== false
            };
            if (isMountedRef.current && !$23a8f689f1d4c3be$var$deepEqual(dataRef.current, fullData)) {
                dataRef.current = fullData;
                $1u0KT.flushSync(()=>{
                    setData(fullData);
                });
            }
        });
    }, [
        latestMiddleware,
        placement,
        strategy,
        platformRef,
        openRef
    ]);
    $23a8f689f1d4c3be$var$index(()=>{
        if (open === false && dataRef.current.isPositioned) {
            dataRef.current.isPositioned = false;
            setData((data)=>({
                    ...data,
                    isPositioned: false
                }));
        }
    }, [
        open
    ]);
    const isMountedRef = $acw62.useRef(false);
    $23a8f689f1d4c3be$var$index(()=>{
        isMountedRef.current = true;
        return ()=>{
            isMountedRef.current = false;
        };
    }, []);
    $23a8f689f1d4c3be$var$index(()=>{
        if (referenceEl) referenceRef.current = referenceEl;
        if (floatingEl) floatingRef.current = floatingEl;
        if (referenceEl && floatingEl) {
            if (whileElementsMountedRef.current) return whileElementsMountedRef.current(referenceEl, floatingEl, update);
            update();
        }
    }, [
        referenceEl,
        floatingEl,
        update,
        whileElementsMountedRef,
        hasWhileElementsMounted
    ]);
    const refs = $acw62.useMemo(()=>({
            reference: referenceRef,
            floating: floatingRef,
            setReference: setReference,
            setFloating: setFloating
        }), [
        setReference,
        setFloating
    ]);
    const elements = $acw62.useMemo(()=>({
            reference: referenceEl,
            floating: floatingEl
        }), [
        referenceEl,
        floatingEl
    ]);
    const floatingStyles = $acw62.useMemo(()=>{
        const initialStyles = {
            position: strategy,
            left: 0,
            top: 0
        };
        if (!elements.floating) return initialStyles;
        const x = $23a8f689f1d4c3be$var$roundByDPR(elements.floating, data.x);
        const y = $23a8f689f1d4c3be$var$roundByDPR(elements.floating, data.y);
        if (transform) return {
            ...initialStyles,
            transform: "translate(" + x + "px, " + y + "px)",
            ...$23a8f689f1d4c3be$var$getDPR(elements.floating) >= 1.5 && {
                willChange: "transform"
            }
        };
        return {
            position: strategy,
            left: x,
            top: y
        };
    }, [
        strategy,
        transform,
        elements.floating,
        data.x,
        data.y
    ]);
    return $acw62.useMemo(()=>({
            ...data,
            update: update,
            refs: refs,
            elements: elements,
            floatingStyles: floatingStyles
        }), [
        data,
        update,
        refs,
        elements,
        floatingStyles
    ]);
}
/**
 * Provides data to position an inner element of the floating element so that it
 * appears centered to the reference element.
 * This wraps the core `arrow` middleware to allow React refs as the element.
 * @see https://floating-ui.com/docs/arrow
 */ const $23a8f689f1d4c3be$var$arrow$1 = (options)=>{
    function isRef(value) {
        return ({}).hasOwnProperty.call(value, "current");
    }
    return {
        name: "arrow",
        options: options,
        fn (state) {
            const { element: element, padding: padding } = typeof options === "function" ? options(state) : options;
            if (element && isRef(element)) {
                if (element.current != null) return (0, $461947879dcdbcd4$export$f2120bbfa5450bd2)({
                    element: element.current,
                    padding: padding
                }).fn(state);
                return {};
            }
            if (element) return (0, $461947879dcdbcd4$export$f2120bbfa5450bd2)({
                element: element,
                padding: padding
            }).fn(state);
            return {};
        }
    };
};
/**
 * Modifies the placement by translating the floating element along the
 * specified axes.
 * A number (shorthand for `mainAxis` or distance), or an axes configuration
 * object may be passed.
 * @see https://floating-ui.com/docs/offset
 */ const $23a8f689f1d4c3be$export$cc800923e997bb8 = (options, deps)=>({
        ...(0, $973e4da43f2a375d$export$cc800923e997bb8)(options),
        options: [
            options,
            deps
        ]
    });
/**
 * Optimizes the visibility of the floating element by shifting it in order to
 * keep it in view when it will overflow the clipping boundary.
 * @see https://floating-ui.com/docs/shift
 */ const $23a8f689f1d4c3be$export$fba63a578e423eb = (options, deps)=>({
        ...(0, $461947879dcdbcd4$export$fba63a578e423eb)(options),
        options: [
            options,
            deps
        ]
    });
/**
 * Built-in `limiter` that will stop `shift()` at a certain point.
 */ const $23a8f689f1d4c3be$export$7bf07e38f3dc4b69 = (options, deps)=>({
        ...(0, $461947879dcdbcd4$export$7bf07e38f3dc4b69)(options),
        options: [
            options,
            deps
        ]
    });
/**
 * Optimizes the visibility of the floating element by flipping the `placement`
 * in order to keep it in view when the preferred placement(s) will overflow the
 * clipping boundary. Alternative to `autoPlacement`.
 * @see https://floating-ui.com/docs/flip
 */ const $23a8f689f1d4c3be$export$8a83211c878a3f1f = (options, deps)=>({
        ...(0, $461947879dcdbcd4$export$8a83211c878a3f1f)(options),
        options: [
            options,
            deps
        ]
    });
/**
 * Provides data that allows you to change the size of the floating element —
 * for instance, prevent it from overflowing the clipping boundary or match the
 * width of the reference element.
 * @see https://floating-ui.com/docs/size
 */ const $23a8f689f1d4c3be$export$346677f925de839c = (options, deps)=>({
        ...(0, $461947879dcdbcd4$export$346677f925de839c)(options),
        options: [
            options,
            deps
        ]
    });
/**
 * Optimizes the visibility of the floating element by choosing the placement
 * that has the most space available automatically, without needing to specify a
 * preferred placement. Alternative to `flip`.
 * @see https://floating-ui.com/docs/autoPlacement
 */ const $23a8f689f1d4c3be$export$91fb6ecbd551914 = (options, deps)=>({
        ...(0, $461947879dcdbcd4$export$91fb6ecbd551914)(options),
        options: [
            options,
            deps
        ]
    });
/**
 * Provides data to hide the floating element in applicable situations, such as
 * when it is not in the same clipping context as the reference element.
 * @see https://floating-ui.com/docs/hide
 */ const $23a8f689f1d4c3be$export$fe8985bb6374093c = (options, deps)=>({
        ...(0, $461947879dcdbcd4$export$fe8985bb6374093c)(options),
        options: [
            options,
            deps
        ]
    });
/**
 * Provides improved positioning for inline reference elements that can span
 * over multiple lines, such as hyperlinks or range selections.
 * @see https://floating-ui.com/docs/inline
 */ const $23a8f689f1d4c3be$export$18c8ad048e32c7d5 = (options, deps)=>({
        ...(0, $461947879dcdbcd4$export$18c8ad048e32c7d5)(options),
        options: [
            options,
            deps
        ]
    });
/**
 * Provides data to position an inner element of the floating element so that it
 * appears centered to the reference element.
 * This wraps the core `arrow` middleware to allow React refs as the element.
 * @see https://floating-ui.com/docs/arrow
 */ const $23a8f689f1d4c3be$export$f2120bbfa5450bd2 = (options, deps)=>({
        ...$23a8f689f1d4c3be$var$arrow$1(options),
        options: [
            options,
            deps
        ]
    });


var $acw62 = parcelRequire("acw62");

function $34bc2325b4db944b$export$da980962bd2147a4(doc) {
    let activeElement = doc.activeElement;
    while(((_activeElement = activeElement) == null || (_activeElement = _activeElement.shadowRoot) == null ? void 0 : _activeElement.activeElement) != null){
        var _activeElement;
        activeElement = activeElement.shadowRoot.activeElement;
    }
    return activeElement;
}
function $34bc2325b4db944b$export$2344b14b097df817(parent, child) {
    if (!parent || !child) return false;
    const rootNode = child.getRootNode == null ? void 0 : child.getRootNode();
    // First, attempt with faster native method
    if (parent.contains(child)) return true;
    // then fallback to custom implementation with Shadow DOM support
    if (rootNode && (0, $238ac70369f38756$export$af51f0f06c0f328a)(rootNode)) {
        let next = child;
        while(next){
            if (parent === next) return true;
            // @ts-ignore
            next = next.parentNode || next.host;
        }
    }
    // Give up, the result is false
    return false;
}
// Avoid Chrome DevTools blue warning.
function $34bc2325b4db944b$export$867a782338812cb4() {
    const uaData = navigator.userAgentData;
    if (uaData != null && uaData.platform) return uaData.platform;
    return navigator.platform;
}
function $34bc2325b4db944b$export$7935961ef7719cb0() {
    const uaData = navigator.userAgentData;
    if (uaData && Array.isArray(uaData.brands)) return uaData.brands.map((_ref)=>{
        let { brand: brand, version: version } = _ref;
        return brand + "/" + version;
    }).join(" ");
    return navigator.userAgent;
}
// License: https://github.com/adobe/react-spectrum/blob/b35d5c02fe900badccd0cf1a8f23bb593419f238/packages/@react-aria/utils/src/isVirtualEvent.ts
function $34bc2325b4db944b$export$60278871457622de(event) {
    // FIXME: Firefox is now emitting a deprecation warning for `mozInputSource`.
    // Try to find a workaround for this. `react-aria` source still has the check.
    if (event.mozInputSource === 0 && event.isTrusted) return true;
    if ($34bc2325b4db944b$export$a11b0059900ceec8() && event.pointerType) return event.type === "click" && event.buttons === 1;
    return event.detail === 0 && !event.pointerType;
}
function $34bc2325b4db944b$export$29bf1b5f2c56cf63(event) {
    if ($34bc2325b4db944b$export$c8f880a2d81914c4()) return false;
    return !$34bc2325b4db944b$export$a11b0059900ceec8() && event.width === 0 && event.height === 0 || $34bc2325b4db944b$export$a11b0059900ceec8() && event.width === 1 && event.height === 1 && event.pressure === 0 && event.detail === 0 && event.pointerType === "mouse" || // iOS VoiceOver returns 0.333• for width/height.
    event.width < 1 && event.height < 1 && event.pressure === 0 && event.detail === 0 && event.pointerType === "touch";
}
function $34bc2325b4db944b$export$95df08bae54cb4df() {
    // Chrome DevTools does not complain about navigator.vendor
    return /apple/i.test(navigator.vendor);
}
function $34bc2325b4db944b$export$a11b0059900ceec8() {
    const re = /android/i;
    return re.test($34bc2325b4db944b$export$867a782338812cb4()) || re.test($34bc2325b4db944b$export$7935961ef7719cb0());
}
function $34bc2325b4db944b$export$9ac100e40613ea10() {
    return $34bc2325b4db944b$export$867a782338812cb4().toLowerCase().startsWith("mac") && !navigator.maxTouchPoints;
}
function $34bc2325b4db944b$export$c8f880a2d81914c4() {
    return $34bc2325b4db944b$export$7935961ef7719cb0().includes("jsdom/");
}
function $34bc2325b4db944b$export$81cf264172d31e51(pointerType, strict) {
    // On some Linux machines with Chromium, mouse inputs return a `pointerType`
    // of "pen": https://github.com/floating-ui/floating-ui/issues/2015
    const values = [
        "mouse",
        "pen"
    ];
    if (!strict) values.push("", undefined);
    return values.includes(pointerType);
}
function $34bc2325b4db944b$export$94781ce41a161222(event) {
    return "nativeEvent" in event;
}
function $34bc2325b4db944b$export$7b296c28e0fa3aed(element) {
    return element.matches("html,body");
}
function $34bc2325b4db944b$export$f65ca476c09acec0(node) {
    return (node == null ? void 0 : node.ownerDocument) || document;
}
function $34bc2325b4db944b$export$43c3154d5bf2c6c2(event, node) {
    if (node == null) return false;
    if ("composedPath" in event) return event.composedPath().includes(node);
    // TS thinks `event` is of type never as it assumes all browsers support composedPath, but browsers without shadow dom don't
    const e = event;
    return e.target != null && node.contains(e.target);
}
function $34bc2325b4db944b$export$c22522a4dfa48e9c(event) {
    if ("composedPath" in event) return event.composedPath()[0];
    // TS thinks `event` is of type never as it assumes all browsers support
    // `composedPath()`, but browsers without shadow DOM don't.
    return event.target;
}
const $34bc2325b4db944b$export$78b3d091ff376bc = "input:not([type='hidden']):not([disabled]),[contenteditable]:not([contenteditable='false']),textarea:not([disabled])";
function $34bc2325b4db944b$export$42ad131c32f0fb8d(element) {
    return (0, $238ac70369f38756$export$1b3bfaa9684536aa)(element) && element.matches($34bc2325b4db944b$export$78b3d091ff376bc);
}
function $34bc2325b4db944b$export$7ae4cd3a66c1e050(event) {
    event.preventDefault();
    event.stopPropagation();
}
function $34bc2325b4db944b$export$259ba5ae38188551(element) {
    if (!element) return false;
    return element.getAttribute("role") === "combobox" && $34bc2325b4db944b$export$42ad131c32f0fb8d(element);
}





/*!
* tabbable 6.2.0
* @license MIT, https://github.com/focus-trap/tabbable/blob/master/LICENSE
*/ // NOTE: separate `:not()` selectors has broader browser support than the newer
//  `:not([inert], [inert] *)` (Feb 2023)
// CAREFUL: JSDom does not support `:not([inert] *)` as a selector; using it causes
//  the entire query to fail, resulting in no nodes found, which will break a lot
//  of things... so we have to rely on JS to identify nodes inside an inert container
var $a4b3b7902c9a987d$var$candidateSelectors = [
    "input:not([inert])",
    "select:not([inert])",
    "textarea:not([inert])",
    "a[href]:not([inert])",
    "button:not([inert])",
    "[tabindex]:not(slot):not([inert])",
    "audio[controls]:not([inert])",
    "video[controls]:not([inert])",
    '[contenteditable]:not([contenteditable="false"]):not([inert])',
    "details>summary:first-of-type:not([inert])",
    "details:not([inert])"
];
var $a4b3b7902c9a987d$var$candidateSelector = /* #__PURE__ */ $a4b3b7902c9a987d$var$candidateSelectors.join(",");
var $a4b3b7902c9a987d$var$NoElement = typeof Element === "undefined";
var $a4b3b7902c9a987d$var$matches = $a4b3b7902c9a987d$var$NoElement ? function() {} : Element.prototype.matches || Element.prototype.msMatchesSelector || Element.prototype.webkitMatchesSelector;
var $a4b3b7902c9a987d$var$getRootNode = !$a4b3b7902c9a987d$var$NoElement && Element.prototype.getRootNode ? function(element) {
    var _element$getRootNode;
    return element === null || element === void 0 ? void 0 : (_element$getRootNode = element.getRootNode) === null || _element$getRootNode === void 0 ? void 0 : _element$getRootNode.call(element);
} : function(element) {
    return element === null || element === void 0 ? void 0 : element.ownerDocument;
};
/**
 * Determines if a node is inert or in an inert ancestor.
 * @param {Element} [node]
 * @param {boolean} [lookUp] If true and `node` is not inert, looks up at ancestors to
 *  see if any of them are inert. If false, only `node` itself is considered.
 * @returns {boolean} True if inert itself or by way of being in an inert ancestor.
 *  False if `node` is falsy.
 */ var $a4b3b7902c9a987d$var$isInert = function isInert(node, lookUp) {
    var _node$getAttribute;
    if (lookUp === void 0) lookUp = true;
    // CAREFUL: JSDom does not support inert at all, so we can't use the `HTMLElement.inert`
    //  JS API property; we have to check the attribute, which can either be empty or 'true';
    //  if it's `null` (not specified) or 'false', it's an active element
    var inertAtt = node === null || node === void 0 ? void 0 : (_node$getAttribute = node.getAttribute) === null || _node$getAttribute === void 0 ? void 0 : _node$getAttribute.call(node, "inert");
    var inert = inertAtt === "" || inertAtt === "true";
    // NOTE: this could also be handled with `node.matches('[inert], :is([inert] *)')`
    //  if it weren't for `matches()` not being a function on shadow roots; the following
    //  code works for any kind of node
    // CAREFUL: JSDom does not appear to support certain selectors like `:not([inert] *)`
    //  so it likely would not support `:is([inert] *)` either...
    var result = inert || lookUp && node && isInert(node.parentNode); // recursive
    return result;
};
/**
 * Determines if a node's content is editable.
 * @param {Element} [node]
 * @returns True if it's content-editable; false if it's not or `node` is falsy.
 */ var $a4b3b7902c9a987d$var$isContentEditable = function isContentEditable(node) {
    var _node$getAttribute2;
    // CAREFUL: JSDom does not support the `HTMLElement.isContentEditable` API so we have
    //  to use the attribute directly to check for this, which can either be empty or 'true';
    //  if it's `null` (not specified) or 'false', it's a non-editable element
    var attValue = node === null || node === void 0 ? void 0 : (_node$getAttribute2 = node.getAttribute) === null || _node$getAttribute2 === void 0 ? void 0 : _node$getAttribute2.call(node, "contenteditable");
    return attValue === "" || attValue === "true";
};
/**
 * @param {Element} el container to check in
 * @param {boolean} includeContainer add container to check
 * @param {(node: Element) => boolean} filter filter candidates
 * @returns {Element[]}
 */ var $a4b3b7902c9a987d$var$getCandidates = function getCandidates(el, includeContainer, filter) {
    // even if `includeContainer=false`, we still have to check it for inertness because
    //  if it's inert, all its children are inert
    if ($a4b3b7902c9a987d$var$isInert(el)) return [];
    var candidates = Array.prototype.slice.apply(el.querySelectorAll($a4b3b7902c9a987d$var$candidateSelector));
    if (includeContainer && $a4b3b7902c9a987d$var$matches.call(el, $a4b3b7902c9a987d$var$candidateSelector)) candidates.unshift(el);
    candidates = candidates.filter(filter);
    return candidates;
};
/**
 * @callback GetShadowRoot
 * @param {Element} element to check for shadow root
 * @returns {ShadowRoot|boolean} ShadowRoot if available or boolean indicating if a shadowRoot is attached but not available.
 */ /**
 * @callback ShadowRootFilter
 * @param {Element} shadowHostNode the element which contains shadow content
 * @returns {boolean} true if a shadow root could potentially contain valid candidates.
 */ /**
 * @typedef {Object} CandidateScope
 * @property {Element} scopeParent contains inner candidates
 * @property {Element[]} candidates list of candidates found in the scope parent
 */ /**
 * @typedef {Object} IterativeOptions
 * @property {GetShadowRoot|boolean} getShadowRoot true if shadow support is enabled; falsy if not;
 *  if a function, implies shadow support is enabled and either returns the shadow root of an element
 *  or a boolean stating if it has an undisclosed shadow root
 * @property {(node: Element) => boolean} filter filter candidates
 * @property {boolean} flatten if true then result will flatten any CandidateScope into the returned list
 * @property {ShadowRootFilter} shadowRootFilter filter shadow roots;
 */ /**
 * @param {Element[]} elements list of element containers to match candidates from
 * @param {boolean} includeContainer add container list to check
 * @param {IterativeOptions} options
 * @returns {Array.<Element|CandidateScope>}
 */ var $a4b3b7902c9a987d$var$getCandidatesIteratively = function getCandidatesIteratively(elements, includeContainer, options) {
    var candidates = [];
    var elementsToCheck = Array.from(elements);
    while(elementsToCheck.length){
        var element = elementsToCheck.shift();
        if ($a4b3b7902c9a987d$var$isInert(element, false)) continue;
        if (element.tagName === "SLOT") {
            // add shadow dom slot scope (slot itself cannot be focusable)
            var assigned = element.assignedElements();
            var content = assigned.length ? assigned : element.children;
            var nestedCandidates = getCandidatesIteratively(content, true, options);
            if (options.flatten) candidates.push.apply(candidates, nestedCandidates);
            else candidates.push({
                scopeParent: element,
                candidates: nestedCandidates
            });
        } else {
            // check candidate element
            var validCandidate = $a4b3b7902c9a987d$var$matches.call(element, $a4b3b7902c9a987d$var$candidateSelector);
            if (validCandidate && options.filter(element) && (includeContainer || !elements.includes(element))) candidates.push(element);
            // iterate over shadow content if possible
            var shadowRoot = element.shadowRoot || // check for an undisclosed shadow
            typeof options.getShadowRoot === "function" && options.getShadowRoot(element);
            // no inert look up because we're already drilling down and checking for inertness
            //  on the way down, so all containers to this root node should have already been
            //  vetted as non-inert
            var validShadowRoot = !$a4b3b7902c9a987d$var$isInert(shadowRoot, false) && (!options.shadowRootFilter || options.shadowRootFilter(element));
            if (shadowRoot && validShadowRoot) {
                // add shadow dom scope IIF a shadow root node was given; otherwise, an undisclosed
                //  shadow exists, so look at light dom children as fallback BUT create a scope for any
                //  child candidates found because they're likely slotted elements (elements that are
                //  children of the web component element (which has the shadow), in the light dom, but
                //  slotted somewhere _inside_ the undisclosed shadow) -- the scope is created below,
                //  _after_ we return from this recursive call
                var _nestedCandidates = getCandidatesIteratively(shadowRoot === true ? element.children : shadowRoot.children, true, options);
                if (options.flatten) candidates.push.apply(candidates, _nestedCandidates);
                else candidates.push({
                    scopeParent: element,
                    candidates: _nestedCandidates
                });
            } else // there's not shadow so just dig into the element's (light dom) children
            //  __without__ giving the element special scope treatment
            elementsToCheck.unshift.apply(elementsToCheck, element.children);
        }
    }
    return candidates;
};
/**
 * @private
 * Determines if the node has an explicitly specified `tabindex` attribute.
 * @param {HTMLElement} node
 * @returns {boolean} True if so; false if not.
 */ var $a4b3b7902c9a987d$var$hasTabIndex = function hasTabIndex(node) {
    return !isNaN(parseInt(node.getAttribute("tabindex"), 10));
};
/**
 * Determine the tab index of a given node.
 * @param {HTMLElement} node
 * @returns {number} Tab order (negative, 0, or positive number).
 * @throws {Error} If `node` is falsy.
 */ var $a4b3b7902c9a987d$export$a4672efddb4181b8 = function getTabIndex(node) {
    if (!node) throw new Error("No node provided");
    if (node.tabIndex < 0) {
        // in Chrome, <details/>, <audio controls/> and <video controls/> elements get a default
        // `tabIndex` of -1 when the 'tabindex' attribute isn't specified in the DOM,
        // yet they are still part of the regular tab order; in FF, they get a default
        // `tabIndex` of 0; since Chrome still puts those elements in the regular tab
        // order, consider their tab index to be 0.
        // Also browsers do not return `tabIndex` correctly for contentEditable nodes;
        // so if they don't have a tabindex attribute specifically set, assume it's 0.
        if ((/^(AUDIO|VIDEO|DETAILS)$/.test(node.tagName) || $a4b3b7902c9a987d$var$isContentEditable(node)) && !$a4b3b7902c9a987d$var$hasTabIndex(node)) return 0;
    }
    return node.tabIndex;
};
/**
 * Determine the tab index of a given node __for sort order purposes__.
 * @param {HTMLElement} node
 * @param {boolean} [isScope] True for a custom element with shadow root or slot that, by default,
 *  has tabIndex -1, but needs to be sorted by document order in order for its content to be
 *  inserted into the correct sort position.
 * @returns {number} Tab order (negative, 0, or positive number).
 */ var $a4b3b7902c9a987d$var$getSortOrderTabIndex = function getSortOrderTabIndex(node, isScope) {
    var tabIndex = $a4b3b7902c9a987d$export$a4672efddb4181b8(node);
    if (tabIndex < 0 && isScope && !$a4b3b7902c9a987d$var$hasTabIndex(node)) return 0;
    return tabIndex;
};
var $a4b3b7902c9a987d$var$sortOrderedTabbables = function sortOrderedTabbables(a, b) {
    return a.tabIndex === b.tabIndex ? a.documentOrder - b.documentOrder : a.tabIndex - b.tabIndex;
};
var $a4b3b7902c9a987d$var$isInput = function isInput(node) {
    return node.tagName === "INPUT";
};
var $a4b3b7902c9a987d$var$isHiddenInput = function isHiddenInput(node) {
    return $a4b3b7902c9a987d$var$isInput(node) && node.type === "hidden";
};
var $a4b3b7902c9a987d$var$isDetailsWithSummary = function isDetailsWithSummary(node) {
    var r = node.tagName === "DETAILS" && Array.prototype.slice.apply(node.children).some(function(child) {
        return child.tagName === "SUMMARY";
    });
    return r;
};
var $a4b3b7902c9a987d$var$getCheckedRadio = function getCheckedRadio(nodes, form) {
    for(var i = 0; i < nodes.length; i++){
        if (nodes[i].checked && nodes[i].form === form) return nodes[i];
    }
};
var $a4b3b7902c9a987d$var$isTabbableRadio = function isTabbableRadio(node) {
    if (!node.name) return true;
    var radioScope = node.form || $a4b3b7902c9a987d$var$getRootNode(node);
    var queryRadios = function queryRadios(name) {
        return radioScope.querySelectorAll('input[type="radio"][name="' + name + '"]');
    };
    var radioSet;
    if (typeof window !== "undefined" && typeof window.CSS !== "undefined" && typeof window.CSS.escape === "function") radioSet = queryRadios(window.CSS.escape(node.name));
    else try {
        radioSet = queryRadios(node.name);
    } catch (err) {
        // eslint-disable-next-line no-console
        console.error("Looks like you have a radio button with a name attribute containing invalid CSS selector characters and need the CSS.escape polyfill: %s", err.message);
        return false;
    }
    var checked = $a4b3b7902c9a987d$var$getCheckedRadio(radioSet, node.form);
    return !checked || checked === node;
};
var $a4b3b7902c9a987d$var$isRadio = function isRadio(node) {
    return $a4b3b7902c9a987d$var$isInput(node) && node.type === "radio";
};
var $a4b3b7902c9a987d$var$isNonTabbableRadio = function isNonTabbableRadio(node) {
    return $a4b3b7902c9a987d$var$isRadio(node) && !$a4b3b7902c9a987d$var$isTabbableRadio(node);
};
// determines if a node is ultimately attached to the window's document
var $a4b3b7902c9a987d$var$isNodeAttached = function isNodeAttached(node) {
    var _nodeRoot;
    // The root node is the shadow root if the node is in a shadow DOM; some document otherwise
    //  (but NOT _the_ document; see second 'If' comment below for more).
    // If rootNode is shadow root, it'll have a host, which is the element to which the shadow
    //  is attached, and the one we need to check if it's in the document or not (because the
    //  shadow, and all nodes it contains, is never considered in the document since shadows
    //  behave like self-contained DOMs; but if the shadow's HOST, which is part of the document,
    //  is hidden, or is not in the document itself but is detached, it will affect the shadow's
    //  visibility, including all the nodes it contains). The host could be any normal node,
    //  or a custom element (i.e. web component). Either way, that's the one that is considered
    //  part of the document, not the shadow root, nor any of its children (i.e. the node being
    //  tested).
    // To further complicate things, we have to look all the way up until we find a shadow HOST
    //  that is attached (or find none) because the node might be in nested shadows...
    // If rootNode is not a shadow root, it won't have a host, and so rootNode should be the
    //  document (per the docs) and while it's a Document-type object, that document does not
    //  appear to be the same as the node's `ownerDocument` for some reason, so it's safer
    //  to ignore the rootNode at this point, and use `node.ownerDocument`. Otherwise,
    //  using `rootNode.contains(node)` will _always_ be true we'll get false-positives when
    //  node is actually detached.
    // NOTE: If `nodeRootHost` or `node` happens to be the `document` itself (which is possible
    //  if a tabbable/focusable node was quickly added to the DOM, focused, and then removed
    //  from the DOM as in https://github.com/focus-trap/focus-trap-react/issues/905), then
    //  `ownerDocument` will be `null`, hence the optional chaining on it.
    var nodeRoot = node && $a4b3b7902c9a987d$var$getRootNode(node);
    var nodeRootHost = (_nodeRoot = nodeRoot) === null || _nodeRoot === void 0 ? void 0 : _nodeRoot.host;
    // in some cases, a detached node will return itself as the root instead of a document or
    //  shadow root object, in which case, we shouldn't try to look further up the host chain
    var attached = false;
    if (nodeRoot && nodeRoot !== node) {
        var _nodeRootHost, _nodeRootHost$ownerDo, _node$ownerDocument;
        attached = !!((_nodeRootHost = nodeRootHost) !== null && _nodeRootHost !== void 0 && (_nodeRootHost$ownerDo = _nodeRootHost.ownerDocument) !== null && _nodeRootHost$ownerDo !== void 0 && _nodeRootHost$ownerDo.contains(nodeRootHost) || node !== null && node !== void 0 && (_node$ownerDocument = node.ownerDocument) !== null && _node$ownerDocument !== void 0 && _node$ownerDocument.contains(node));
        while(!attached && nodeRootHost){
            var _nodeRoot2, _nodeRootHost2, _nodeRootHost2$ownerD;
            // since it's not attached and we have a root host, the node MUST be in a nested shadow DOM,
            //  which means we need to get the host's host and check if that parent host is contained
            //  in (i.e. attached to) the document
            nodeRoot = $a4b3b7902c9a987d$var$getRootNode(nodeRootHost);
            nodeRootHost = (_nodeRoot2 = nodeRoot) === null || _nodeRoot2 === void 0 ? void 0 : _nodeRoot2.host;
            attached = !!((_nodeRootHost2 = nodeRootHost) !== null && _nodeRootHost2 !== void 0 && (_nodeRootHost2$ownerD = _nodeRootHost2.ownerDocument) !== null && _nodeRootHost2$ownerD !== void 0 && _nodeRootHost2$ownerD.contains(nodeRootHost));
        }
    }
    return attached;
};
var $a4b3b7902c9a987d$var$isZeroArea = function isZeroArea(node) {
    var _node$getBoundingClie = node.getBoundingClientRect(), width = _node$getBoundingClie.width, height = _node$getBoundingClie.height;
    return width === 0 && height === 0;
};
var $a4b3b7902c9a987d$var$isHidden = function isHidden(node, _ref) {
    var displayCheck = _ref.displayCheck, getShadowRoot = _ref.getShadowRoot;
    // NOTE: visibility will be `undefined` if node is detached from the document
    //  (see notes about this further down), which means we will consider it visible
    //  (this is legacy behavior from a very long way back)
    // NOTE: we check this regardless of `displayCheck="none"` because this is a
    //  _visibility_ check, not a _display_ check
    if (getComputedStyle(node).visibility === "hidden") return true;
    var isDirectSummary = $a4b3b7902c9a987d$var$matches.call(node, "details>summary:first-of-type");
    var nodeUnderDetails = isDirectSummary ? node.parentElement : node;
    if ($a4b3b7902c9a987d$var$matches.call(nodeUnderDetails, "details:not([open]) *")) return true;
    if (!displayCheck || displayCheck === "full" || displayCheck === "legacy-full") {
        if (typeof getShadowRoot === "function") {
            // figure out if we should consider the node to be in an undisclosed shadow and use the
            //  'non-zero-area' fallback
            var originalNode = node;
            while(node){
                var parentElement = node.parentElement;
                var rootNode = $a4b3b7902c9a987d$var$getRootNode(node);
                if (parentElement && !parentElement.shadowRoot && getShadowRoot(parentElement) === true // check if there's an undisclosed shadow
                ) // node has an undisclosed shadow which means we can only treat it as a black box, so we
                //  fall back to a non-zero-area test
                return $a4b3b7902c9a987d$var$isZeroArea(node);
                else if (node.assignedSlot) // iterate up slot
                node = node.assignedSlot;
                else if (!parentElement && rootNode !== node.ownerDocument) // cross shadow boundary
                node = rootNode.host;
                else // iterate up normal dom
                node = parentElement;
            }
            node = originalNode;
        }
        // else, `getShadowRoot` might be true, but all that does is enable shadow DOM support
        //  (i.e. it does not also presume that all nodes might have undisclosed shadows); or
        //  it might be a falsy value, which means shadow DOM support is disabled
        // Since we didn't find it sitting in an undisclosed shadow (or shadows are disabled)
        //  now we can just test to see if it would normally be visible or not, provided it's
        //  attached to the main document.
        // NOTE: We must consider case where node is inside a shadow DOM and given directly to
        //  `isTabbable()` or `isFocusable()` -- regardless of `getShadowRoot` option setting.
        if ($a4b3b7902c9a987d$var$isNodeAttached(node)) // this works wherever the node is: if there's at least one client rect, it's
        //  somehow displayed; it also covers the CSS 'display: contents' case where the
        //  node itself is hidden in place of its contents; and there's no need to search
        //  up the hierarchy either
        return !node.getClientRects().length;
        // Else, the node isn't attached to the document, which means the `getClientRects()`
        //  API will __always__ return zero rects (this can happen, for example, if React
        //  is used to render nodes onto a detached tree, as confirmed in this thread:
        //  https://github.com/facebook/react/issues/9117#issuecomment-284228870)
        //
        // It also means that even window.getComputedStyle(node).display will return `undefined`
        //  because styles are only computed for nodes that are in the document.
        //
        // NOTE: THIS HAS BEEN THE CASE FOR YEARS. It is not new, nor is it caused by tabbable
        //  somehow. Though it was never stated officially, anyone who has ever used tabbable
        //  APIs on nodes in detached containers has actually implicitly used tabbable in what
        //  was later (as of v5.2.0 on Apr 9, 2021) called `displayCheck="none"` mode -- essentially
        //  considering __everything__ to be visible because of the innability to determine styles.
        //
        // v6.0.0: As of this major release, the default 'full' option __no longer treats detached
        //  nodes as visible with the 'none' fallback.__
        if (displayCheck !== "legacy-full") return true; // hidden
    // else, fallback to 'none' mode and consider the node visible
    } else if (displayCheck === "non-zero-area") // NOTE: Even though this tests that the node's client rect is non-zero to determine
    //  whether it's displayed, and that a detached node will __always__ have a zero-area
    //  client rect, we don't special-case for whether the node is attached or not. In
    //  this mode, we do want to consider nodes that have a zero area to be hidden at all
    //  times, and that includes attached or not.
    return $a4b3b7902c9a987d$var$isZeroArea(node);
    // visible, as far as we can tell, or per current `displayCheck=none` mode, we assume
    //  it's visible
    return false;
};
// form fields (nested) inside a disabled fieldset are not focusable/tabbable
//  unless they are in the _first_ <legend> element of the top-most disabled
//  fieldset
var $a4b3b7902c9a987d$var$isDisabledFromFieldset = function isDisabledFromFieldset(node) {
    if (/^(INPUT|BUTTON|SELECT|TEXTAREA)$/.test(node.tagName)) {
        var parentNode = node.parentElement;
        // check if `node` is contained in a disabled <fieldset>
        while(parentNode){
            if (parentNode.tagName === "FIELDSET" && parentNode.disabled) {
                // look for the first <legend> among the children of the disabled <fieldset>
                for(var i = 0; i < parentNode.children.length; i++){
                    var child = parentNode.children.item(i);
                    // when the first <legend> (in document order) is found
                    if (child.tagName === "LEGEND") // if its parent <fieldset> is not nested in another disabled <fieldset>,
                    // return whether `node` is a descendant of its first <legend>
                    return $a4b3b7902c9a987d$var$matches.call(parentNode, "fieldset[disabled] *") ? true : !child.contains(node);
                }
                // the disabled <fieldset> containing `node` has no <legend>
                return true;
            }
            parentNode = parentNode.parentElement;
        }
    }
    // else, node's tabbable/focusable state should not be affected by a fieldset's
    //  enabled/disabled state
    return false;
};
var $a4b3b7902c9a987d$var$isNodeMatchingSelectorFocusable = function isNodeMatchingSelectorFocusable(options, node) {
    if (node.disabled || // we must do an inert look up to filter out any elements inside an inert ancestor
    //  because we're limited in the type of selectors we can use in JSDom (see related
    //  note related to `candidateSelectors`)
    $a4b3b7902c9a987d$var$isInert(node) || $a4b3b7902c9a987d$var$isHiddenInput(node) || $a4b3b7902c9a987d$var$isHidden(node, options) || // For a details element with a summary, the summary element gets the focus
    $a4b3b7902c9a987d$var$isDetailsWithSummary(node) || $a4b3b7902c9a987d$var$isDisabledFromFieldset(node)) return false;
    return true;
};
var $a4b3b7902c9a987d$var$isNodeMatchingSelectorTabbable = function isNodeMatchingSelectorTabbable(options, node) {
    if ($a4b3b7902c9a987d$var$isNonTabbableRadio(node) || $a4b3b7902c9a987d$export$a4672efddb4181b8(node) < 0 || !$a4b3b7902c9a987d$var$isNodeMatchingSelectorFocusable(options, node)) return false;
    return true;
};
var $a4b3b7902c9a987d$var$isValidShadowRootTabbable = function isValidShadowRootTabbable(shadowHostNode) {
    var tabIndex = parseInt(shadowHostNode.getAttribute("tabindex"), 10);
    if (isNaN(tabIndex) || tabIndex >= 0) return true;
    // If a custom element has an explicit negative tabindex,
    // browsers will not allow tab targeting said element's children.
    return false;
};
/**
 * @param {Array.<Element|CandidateScope>} candidates
 * @returns Element[]
 */ var $a4b3b7902c9a987d$var$sortByOrder = function sortByOrder(candidates) {
    var regularTabbables = [];
    var orderedTabbables = [];
    candidates.forEach(function(item, i) {
        var isScope = !!item.scopeParent;
        var element = isScope ? item.scopeParent : item;
        var candidateTabindex = $a4b3b7902c9a987d$var$getSortOrderTabIndex(element, isScope);
        var elements = isScope ? sortByOrder(item.candidates) : element;
        if (candidateTabindex === 0) isScope ? regularTabbables.push.apply(regularTabbables, elements) : regularTabbables.push(element);
        else orderedTabbables.push({
            documentOrder: i,
            tabIndex: candidateTabindex,
            item: item,
            isScope: isScope,
            content: elements
        });
    });
    return orderedTabbables.sort($a4b3b7902c9a987d$var$sortOrderedTabbables).reduce(function(acc, sortable) {
        sortable.isScope ? acc.push.apply(acc, sortable.content) : acc.push(sortable.content);
        return acc;
    }, []).concat(regularTabbables);
};
var $a4b3b7902c9a987d$export$17100aea90429aa7 = function tabbable(container, options) {
    options = options || {};
    var candidates;
    if (options.getShadowRoot) candidates = $a4b3b7902c9a987d$var$getCandidatesIteratively([
        container
    ], options.includeContainer, {
        filter: $a4b3b7902c9a987d$var$isNodeMatchingSelectorTabbable.bind(null, options),
        flatten: false,
        getShadowRoot: options.getShadowRoot,
        shadowRootFilter: $a4b3b7902c9a987d$var$isValidShadowRootTabbable
    });
    else candidates = $a4b3b7902c9a987d$var$getCandidates(container, options.includeContainer, $a4b3b7902c9a987d$var$isNodeMatchingSelectorTabbable.bind(null, options));
    return $a4b3b7902c9a987d$var$sortByOrder(candidates);
};
var $a4b3b7902c9a987d$export$ecc6d1fcdff4f700 = function focusable(container, options) {
    options = options || {};
    var candidates;
    if (options.getShadowRoot) candidates = $a4b3b7902c9a987d$var$getCandidatesIteratively([
        container
    ], options.includeContainer, {
        filter: $a4b3b7902c9a987d$var$isNodeMatchingSelectorFocusable.bind(null, options),
        flatten: true,
        getShadowRoot: options.getShadowRoot
    });
    else candidates = $a4b3b7902c9a987d$var$getCandidates(container, options.includeContainer, $a4b3b7902c9a987d$var$isNodeMatchingSelectorFocusable.bind(null, options));
    return candidates;
};
var $a4b3b7902c9a987d$export$bebd5a1431fec25d = function isTabbable(node, options) {
    options = options || {};
    if (!node) throw new Error("No node provided");
    if ($a4b3b7902c9a987d$var$matches.call(node, $a4b3b7902c9a987d$var$candidateSelector) === false) return false;
    return $a4b3b7902c9a987d$var$isNodeMatchingSelectorTabbable(options, node);
};
var $a4b3b7902c9a987d$var$focusableCandidateSelector = /* #__PURE__ */ $a4b3b7902c9a987d$var$candidateSelectors.concat("iframe").join(",");
var $a4b3b7902c9a987d$export$4c063cf1350e6fed = function isFocusable(node, options) {
    options = options || {};
    if (!node) throw new Error("No node provided");
    if ($a4b3b7902c9a987d$var$matches.call(node, $a4b3b7902c9a987d$var$focusableCandidateSelector) === false) return false;
    return $a4b3b7902c9a987d$var$isNodeMatchingSelectorFocusable(options, node);
};



var $1u0KT = parcelRequire("1u0KT");

/**
 * Merges an array of refs into a single memoized callback ref or `null`.
 * @see https://floating-ui.com/docs/react-utils#usemergerefs
 */ function $3f69993268aa5b7a$export$74665b213cb5c4cf(refs) {
    return $acw62.useMemo(()=>{
        if (refs.every((ref)=>ref == null)) return null;
        return (value)=>{
            refs.forEach((ref)=>{
                if (typeof ref === "function") ref(value);
                else if (ref != null) ref.current = value;
            });
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, refs);
}
// https://github.com/mui/material-ui/issues/41190#issuecomment-2040873379
const $3f69993268aa5b7a$var$SafeReact = {
    ...$acw62
};
const $3f69993268aa5b7a$var$useInsertionEffect = $3f69993268aa5b7a$var$SafeReact.useInsertionEffect;
const $3f69993268aa5b7a$var$useSafeInsertionEffect = $3f69993268aa5b7a$var$useInsertionEffect || ((fn)=>fn());
function $3f69993268aa5b7a$var$useEffectEvent(callback) {
    const ref = $acw62.useRef(()=>{
        throw new Error("Cannot call an event handler while rendering.");
    });
    $3f69993268aa5b7a$var$useSafeInsertionEffect(()=>{
        ref.current = callback;
    });
    return $acw62.useCallback(function() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        return ref.current == null ? void 0 : ref.current(...args);
    }, []);
}
const $3f69993268aa5b7a$var$ARROW_UP = "ArrowUp";
const $3f69993268aa5b7a$var$ARROW_DOWN = "ArrowDown";
const $3f69993268aa5b7a$var$ARROW_LEFT = "ArrowLeft";
const $3f69993268aa5b7a$var$ARROW_RIGHT = "ArrowRight";
function $3f69993268aa5b7a$var$isDifferentRow(index, cols, prevRow) {
    return Math.floor(index / cols) !== prevRow;
}
function $3f69993268aa5b7a$var$isIndexOutOfBounds(listRef, index) {
    return index < 0 || index >= listRef.current.length;
}
function $3f69993268aa5b7a$var$getMinIndex(listRef, disabledIndices) {
    return $3f69993268aa5b7a$var$findNonDisabledIndex(listRef, {
        disabledIndices: disabledIndices
    });
}
function $3f69993268aa5b7a$var$getMaxIndex(listRef, disabledIndices) {
    return $3f69993268aa5b7a$var$findNonDisabledIndex(listRef, {
        decrement: true,
        startingIndex: listRef.current.length,
        disabledIndices: disabledIndices
    });
}
function $3f69993268aa5b7a$var$findNonDisabledIndex(listRef, _temp) {
    let { startingIndex: startingIndex = -1, decrement: decrement = false, disabledIndices: disabledIndices, amount: amount = 1 } = _temp === void 0 ? {} : _temp;
    const list = listRef.current;
    let index = startingIndex;
    do index += decrement ? -amount : amount;
    while (index >= 0 && index <= list.length - 1 && $3f69993268aa5b7a$var$isDisabled(list, index, disabledIndices));
    return index;
}
function $3f69993268aa5b7a$var$getGridNavigatedIndex(elementsRef, _ref) {
    let { event: event, orientation: orientation, loop: loop, rtl: rtl, cols: cols, disabledIndices: disabledIndices, minIndex: minIndex, maxIndex: maxIndex, prevIndex: prevIndex, stopEvent: stop = false } = _ref;
    let nextIndex = prevIndex;
    if (event.key === $3f69993268aa5b7a$var$ARROW_UP) {
        stop && (0, $34bc2325b4db944b$export$7ae4cd3a66c1e050)(event);
        if (prevIndex === -1) nextIndex = maxIndex;
        else {
            nextIndex = $3f69993268aa5b7a$var$findNonDisabledIndex(elementsRef, {
                startingIndex: nextIndex,
                amount: cols,
                decrement: true,
                disabledIndices: disabledIndices
            });
            if (loop && (prevIndex - cols < minIndex || nextIndex < 0)) {
                const col = prevIndex % cols;
                const maxCol = maxIndex % cols;
                const offset = maxIndex - (maxCol - col);
                if (maxCol === col) nextIndex = maxIndex;
                else nextIndex = maxCol > col ? offset : offset - cols;
            }
        }
        if ($3f69993268aa5b7a$var$isIndexOutOfBounds(elementsRef, nextIndex)) nextIndex = prevIndex;
    }
    if (event.key === $3f69993268aa5b7a$var$ARROW_DOWN) {
        stop && (0, $34bc2325b4db944b$export$7ae4cd3a66c1e050)(event);
        if (prevIndex === -1) nextIndex = minIndex;
        else {
            nextIndex = $3f69993268aa5b7a$var$findNonDisabledIndex(elementsRef, {
                startingIndex: prevIndex,
                amount: cols,
                disabledIndices: disabledIndices
            });
            if (loop && prevIndex + cols > maxIndex) nextIndex = $3f69993268aa5b7a$var$findNonDisabledIndex(elementsRef, {
                startingIndex: prevIndex % cols - cols,
                amount: cols,
                disabledIndices: disabledIndices
            });
        }
        if ($3f69993268aa5b7a$var$isIndexOutOfBounds(elementsRef, nextIndex)) nextIndex = prevIndex;
    }
    // Remains on the same row/column.
    if (orientation === "both") {
        const prevRow = (0, $10310cf078d13212$export$a3fe094919f356fd)(prevIndex / cols);
        if (event.key === (rtl ? $3f69993268aa5b7a$var$ARROW_LEFT : $3f69993268aa5b7a$var$ARROW_RIGHT)) {
            stop && (0, $34bc2325b4db944b$export$7ae4cd3a66c1e050)(event);
            if (prevIndex % cols !== cols - 1) {
                nextIndex = $3f69993268aa5b7a$var$findNonDisabledIndex(elementsRef, {
                    startingIndex: prevIndex,
                    disabledIndices: disabledIndices
                });
                if (loop && $3f69993268aa5b7a$var$isDifferentRow(nextIndex, cols, prevRow)) nextIndex = $3f69993268aa5b7a$var$findNonDisabledIndex(elementsRef, {
                    startingIndex: prevIndex - prevIndex % cols - 1,
                    disabledIndices: disabledIndices
                });
            } else if (loop) nextIndex = $3f69993268aa5b7a$var$findNonDisabledIndex(elementsRef, {
                startingIndex: prevIndex - prevIndex % cols - 1,
                disabledIndices: disabledIndices
            });
            if ($3f69993268aa5b7a$var$isDifferentRow(nextIndex, cols, prevRow)) nextIndex = prevIndex;
        }
        if (event.key === (rtl ? $3f69993268aa5b7a$var$ARROW_RIGHT : $3f69993268aa5b7a$var$ARROW_LEFT)) {
            stop && (0, $34bc2325b4db944b$export$7ae4cd3a66c1e050)(event);
            if (prevIndex % cols !== 0) {
                nextIndex = $3f69993268aa5b7a$var$findNonDisabledIndex(elementsRef, {
                    startingIndex: prevIndex,
                    decrement: true,
                    disabledIndices: disabledIndices
                });
                if (loop && $3f69993268aa5b7a$var$isDifferentRow(nextIndex, cols, prevRow)) nextIndex = $3f69993268aa5b7a$var$findNonDisabledIndex(elementsRef, {
                    startingIndex: prevIndex + (cols - prevIndex % cols),
                    decrement: true,
                    disabledIndices: disabledIndices
                });
            } else if (loop) nextIndex = $3f69993268aa5b7a$var$findNonDisabledIndex(elementsRef, {
                startingIndex: prevIndex + (cols - prevIndex % cols),
                decrement: true,
                disabledIndices: disabledIndices
            });
            if ($3f69993268aa5b7a$var$isDifferentRow(nextIndex, cols, prevRow)) nextIndex = prevIndex;
        }
        const lastRow = (0, $10310cf078d13212$export$a3fe094919f356fd)(maxIndex / cols) === prevRow;
        if ($3f69993268aa5b7a$var$isIndexOutOfBounds(elementsRef, nextIndex)) {
            if (loop && lastRow) nextIndex = event.key === (rtl ? $3f69993268aa5b7a$var$ARROW_RIGHT : $3f69993268aa5b7a$var$ARROW_LEFT) ? maxIndex : $3f69993268aa5b7a$var$findNonDisabledIndex(elementsRef, {
                startingIndex: prevIndex - prevIndex % cols - 1,
                disabledIndices: disabledIndices
            });
            else nextIndex = prevIndex;
        }
    }
    return nextIndex;
}
/** For each cell index, gets the item index that occupies that cell */ function $3f69993268aa5b7a$var$buildCellMap(sizes, cols, dense) {
    const cellMap = [];
    let startIndex = 0;
    sizes.forEach((_ref2, index)=>{
        let { width: width, height: height } = _ref2;
        if (width > cols) throw new Error("[Floating UI]: Invalid grid - item width at index " + index + " is greater than grid columns");
        let itemPlaced = false;
        if (dense) startIndex = 0;
        while(!itemPlaced){
            const targetCells = [];
            for(let i = 0; i < width; i++)for(let j = 0; j < height; j++)targetCells.push(startIndex + i + j * cols);
            if (startIndex % cols + width <= cols && targetCells.every((cell)=>cellMap[cell] == null)) {
                targetCells.forEach((cell)=>{
                    cellMap[cell] = index;
                });
                itemPlaced = true;
            } else startIndex++;
        }
    });
    // convert into a non-sparse array
    return [
        ...cellMap
    ];
}
/** Gets cell index of an item's corner or -1 when index is -1. */ function $3f69993268aa5b7a$var$getCellIndexOfCorner(index, sizes, cellMap, cols, corner) {
    if (index === -1) return -1;
    const firstCellIndex = cellMap.indexOf(index);
    const sizeItem = sizes[index];
    switch(corner){
        case "tl":
            return firstCellIndex;
        case "tr":
            if (!sizeItem) return firstCellIndex;
            return firstCellIndex + sizeItem.width - 1;
        case "bl":
            if (!sizeItem) return firstCellIndex;
            return firstCellIndex + (sizeItem.height - 1) * cols;
        case "br":
            return cellMap.lastIndexOf(index);
    }
}
/** Gets all cell indices that correspond to the specified indices */ function $3f69993268aa5b7a$var$getCellIndices(indices, cellMap) {
    return cellMap.flatMap((index, cellIndex)=>indices.includes(index) ? [
            cellIndex
        ] : []);
}
function $3f69993268aa5b7a$var$isDisabled(list, index, disabledIndices) {
    if (disabledIndices) return disabledIndices.includes(index);
    const element = list[index];
    return element == null || element.hasAttribute("disabled") || element.getAttribute("aria-disabled") === "true";
}
var $3f69993268aa5b7a$var$index = typeof document !== "undefined" ? (0, $acw62.useLayoutEffect) : (0, $acw62.useEffect);
function $3f69993268aa5b7a$var$sortByDocumentPosition(a, b) {
    const position = a.compareDocumentPosition(b);
    if (position & Node.DOCUMENT_POSITION_FOLLOWING || position & Node.DOCUMENT_POSITION_CONTAINED_BY) return -1;
    if (position & Node.DOCUMENT_POSITION_PRECEDING || position & Node.DOCUMENT_POSITION_CONTAINS) return 1;
    return 0;
}
function $3f69993268aa5b7a$var$areMapsEqual(map1, map2) {
    if (map1.size !== map2.size) return false;
    for (const [key, value] of map1.entries()){
        if (value !== map2.get(key)) return false;
    }
    return true;
}
const $3f69993268aa5b7a$var$FloatingListContext = /*#__PURE__*/ $acw62.createContext({
    register: ()=>{},
    unregister: ()=>{},
    map: /*#__PURE__*/ new Map(),
    elementsRef: {
        current: []
    }
});
/**
 * Provides context for a list of items within the floating element.
 * @see https://floating-ui.com/docs/FloatingList
 */ function $3f69993268aa5b7a$export$ffe15b0e64951704(props) {
    const { children: children, elementsRef: elementsRef, labelsRef: labelsRef } = props;
    const [map, setMap] = $acw62.useState(()=>new Map());
    const register = $acw62.useCallback((node)=>{
        setMap((prevMap)=>new Map(prevMap).set(node, null));
    }, []);
    const unregister = $acw62.useCallback((node)=>{
        setMap((prevMap)=>{
            const map = new Map(prevMap);
            map.delete(node);
            return map;
        });
    }, []);
    $3f69993268aa5b7a$var$index(()=>{
        const newMap = new Map(map);
        const nodes = Array.from(newMap.keys()).sort($3f69993268aa5b7a$var$sortByDocumentPosition);
        nodes.forEach((node, index)=>{
            newMap.set(node, index);
        });
        if (!$3f69993268aa5b7a$var$areMapsEqual(map, newMap)) setMap(newMap);
    }, [
        map
    ]);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($3f69993268aa5b7a$var$FloatingListContext.Provider, {
        value: $acw62.useMemo(()=>({
                register: register,
                unregister: unregister,
                map: map,
                elementsRef: elementsRef,
                labelsRef: labelsRef
            }), [
            register,
            unregister,
            map,
            elementsRef,
            labelsRef
        ]),
        children: children
    });
}
/**
 * Used to register a list item and its index (DOM position) in the
 * `FloatingList`.
 * @see https://floating-ui.com/docs/FloatingList#uselistitem
 */ function $3f69993268aa5b7a$export$dcdc7ff5149f7d1a(props) {
    if (props === void 0) props = {};
    const { label: label } = props;
    const { register: register, unregister: unregister, map: map, elementsRef: elementsRef, labelsRef: labelsRef } = $acw62.useContext($3f69993268aa5b7a$var$FloatingListContext);
    const [index$1, setIndex] = $acw62.useState(null);
    const componentRef = $acw62.useRef(null);
    const ref = $acw62.useCallback((node)=>{
        componentRef.current = node;
        if (index$1 !== null) {
            elementsRef.current[index$1] = node;
            if (labelsRef) {
                var _node$textContent;
                const isLabelDefined = label !== undefined;
                labelsRef.current[index$1] = isLabelDefined ? label : (_node$textContent = node == null ? void 0 : node.textContent) != null ? _node$textContent : null;
            }
        }
    }, [
        index$1,
        elementsRef,
        labelsRef,
        label
    ]);
    $3f69993268aa5b7a$var$index(()=>{
        const node = componentRef.current;
        if (node) {
            register(node);
            return ()=>{
                unregister(node);
            };
        }
    }, [
        register,
        unregister
    ]);
    $3f69993268aa5b7a$var$index(()=>{
        const index = componentRef.current ? map.get(componentRef.current) : null;
        if (index != null) setIndex(index);
    }, [
        map
    ]);
    return $acw62.useMemo(()=>({
            ref: ref,
            index: index$1 == null ? -1 : index$1
        }), [
        index$1,
        ref
    ]);
}
function $3f69993268aa5b7a$var$renderJsx(render, computedProps) {
    if (typeof render === "function") return render(computedProps);
    if (render) return /*#__PURE__*/ $acw62.cloneElement(render, computedProps);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        ...computedProps
    });
}
const $3f69993268aa5b7a$var$CompositeContext = /*#__PURE__*/ $acw62.createContext({
    activeIndex: 0,
    onNavigate: ()=>{}
});
const $3f69993268aa5b7a$var$horizontalKeys = [
    $3f69993268aa5b7a$var$ARROW_LEFT,
    $3f69993268aa5b7a$var$ARROW_RIGHT
];
const $3f69993268aa5b7a$var$verticalKeys = [
    $3f69993268aa5b7a$var$ARROW_UP,
    $3f69993268aa5b7a$var$ARROW_DOWN
];
const $3f69993268aa5b7a$var$allKeys = [
    ...$3f69993268aa5b7a$var$horizontalKeys,
    ...$3f69993268aa5b7a$var$verticalKeys
];
/**
 * Creates a single tab stop whose items are navigated by arrow keys, which
 * provides list navigation outside of floating element contexts.
 *
 * This is useful to enable navigation of a list of items that aren’t part of a
 * floating element. A menubar is an example of a composite, with each reference
 * element being an item.
 * @see https://floating-ui.com/docs/Composite
 */ const $3f69993268aa5b7a$export$43586241d9db0c6d = /*#__PURE__*/ $acw62.forwardRef(function Composite(props, forwardedRef) {
    const { render: render, orientation: orientation = "both", loop: loop = true, rtl: rtl = false, cols: cols = 1, disabledIndices: disabledIndices, activeIndex: externalActiveIndex, onNavigate: externalSetActiveIndex, itemSizes: itemSizes, dense: dense = false, ...domProps } = props;
    const [internalActiveIndex, internalSetActiveIndex] = $acw62.useState(0);
    const activeIndex = externalActiveIndex != null ? externalActiveIndex : internalActiveIndex;
    const onNavigate = $3f69993268aa5b7a$var$useEffectEvent(externalSetActiveIndex != null ? externalSetActiveIndex : internalSetActiveIndex);
    const elementsRef = $acw62.useRef([]);
    const renderElementProps = render && typeof render !== "function" ? render.props : {};
    const contextValue = $acw62.useMemo(()=>({
            activeIndex: activeIndex,
            onNavigate: onNavigate
        }), [
        activeIndex,
        onNavigate
    ]);
    const isGrid = cols > 1;
    function handleKeyDown(event) {
        if (!$3f69993268aa5b7a$var$allKeys.includes(event.key)) return;
        let nextIndex = activeIndex;
        const minIndex = $3f69993268aa5b7a$var$getMinIndex(elementsRef, disabledIndices);
        const maxIndex = $3f69993268aa5b7a$var$getMaxIndex(elementsRef, disabledIndices);
        const horizontalEndKey = rtl ? $3f69993268aa5b7a$var$ARROW_LEFT : $3f69993268aa5b7a$var$ARROW_RIGHT;
        const horizontalStartKey = rtl ? $3f69993268aa5b7a$var$ARROW_RIGHT : $3f69993268aa5b7a$var$ARROW_LEFT;
        if (isGrid) {
            const sizes = itemSizes || Array.from({
                length: elementsRef.current.length
            }, ()=>({
                    width: 1,
                    height: 1
                }));
            // To calculate movements on the grid, we use hypothetical cell indices
            // as if every item was 1x1, then convert back to real indices.
            const cellMap = $3f69993268aa5b7a$var$buildCellMap(sizes, cols, dense);
            const minGridIndex = cellMap.findIndex((index)=>index != null && !$3f69993268aa5b7a$var$isDisabled(elementsRef.current, index, disabledIndices));
            // last enabled index
            const maxGridIndex = cellMap.reduce((foundIndex, index, cellIndex)=>index != null && !$3f69993268aa5b7a$var$isDisabled(elementsRef.current, index, disabledIndices) ? cellIndex : foundIndex, -1);
            const maybeNextIndex = cellMap[$3f69993268aa5b7a$var$getGridNavigatedIndex({
                current: cellMap.map((itemIndex)=>itemIndex ? elementsRef.current[itemIndex] : null)
            }, {
                event: event,
                orientation: orientation,
                loop: loop,
                rtl: rtl,
                cols: cols,
                // treat undefined (empty grid spaces) as disabled indices so we
                // don't end up in them
                disabledIndices: $3f69993268aa5b7a$var$getCellIndices([
                    ...disabledIndices || elementsRef.current.map((_, index)=>$3f69993268aa5b7a$var$isDisabled(elementsRef.current, index) ? index : undefined),
                    undefined
                ], cellMap),
                minIndex: minGridIndex,
                maxIndex: maxGridIndex,
                prevIndex: $3f69993268aa5b7a$var$getCellIndexOfCorner(activeIndex > maxIndex ? minIndex : activeIndex, sizes, cellMap, cols, // use a corner matching the edge closest to the direction we're
                // moving in so we don't end up in the same item. Prefer
                // top/left over bottom/right.
                event.key === $3f69993268aa5b7a$var$ARROW_DOWN ? "bl" : event.key === horizontalEndKey ? "tr" : "tl")
            })];
            if (maybeNextIndex != null) nextIndex = maybeNextIndex;
        }
        const toEndKeys = {
            horizontal: [
                horizontalEndKey
            ],
            vertical: [
                $3f69993268aa5b7a$var$ARROW_DOWN
            ],
            both: [
                horizontalEndKey,
                $3f69993268aa5b7a$var$ARROW_DOWN
            ]
        }[orientation];
        const toStartKeys = {
            horizontal: [
                horizontalStartKey
            ],
            vertical: [
                $3f69993268aa5b7a$var$ARROW_UP
            ],
            both: [
                horizontalStartKey,
                $3f69993268aa5b7a$var$ARROW_UP
            ]
        }[orientation];
        const preventedKeys = isGrid ? $3f69993268aa5b7a$var$allKeys : ({
            horizontal: $3f69993268aa5b7a$var$horizontalKeys,
            vertical: $3f69993268aa5b7a$var$verticalKeys,
            both: $3f69993268aa5b7a$var$allKeys
        })[orientation];
        if (nextIndex === activeIndex && [
            ...toEndKeys,
            ...toStartKeys
        ].includes(event.key)) {
            if (loop && nextIndex === maxIndex && toEndKeys.includes(event.key)) nextIndex = minIndex;
            else if (loop && nextIndex === minIndex && toStartKeys.includes(event.key)) nextIndex = maxIndex;
            else nextIndex = $3f69993268aa5b7a$var$findNonDisabledIndex(elementsRef, {
                startingIndex: nextIndex,
                decrement: toStartKeys.includes(event.key),
                disabledIndices: disabledIndices
            });
        }
        if (nextIndex !== activeIndex && !$3f69993268aa5b7a$var$isIndexOutOfBounds(elementsRef, nextIndex)) {
            var _elementsRef$current$;
            event.stopPropagation();
            if (preventedKeys.includes(event.key)) event.preventDefault();
            onNavigate(nextIndex);
            (_elementsRef$current$ = elementsRef.current[nextIndex]) == null || _elementsRef$current$.focus();
        }
    }
    const computedProps = {
        ...domProps,
        ...renderElementProps,
        ref: forwardedRef,
        "aria-orientation": orientation === "both" ? undefined : orientation,
        onKeyDown (e) {
            domProps.onKeyDown == null || domProps.onKeyDown(e);
            renderElementProps.onKeyDown == null || renderElementProps.onKeyDown(e);
            handleKeyDown(e);
        }
    };
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($3f69993268aa5b7a$var$CompositeContext.Provider, {
        value: contextValue,
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($3f69993268aa5b7a$export$ffe15b0e64951704, {
            elementsRef: elementsRef,
            children: $3f69993268aa5b7a$var$renderJsx(render, computedProps)
        })
    });
});
/**
 * @see https://floating-ui.com/docs/Composite
 */ const $3f69993268aa5b7a$export$ef1ef7a3a43ace8e = /*#__PURE__*/ $acw62.forwardRef(function CompositeItem(props, forwardedRef) {
    const { render: render, ...domProps } = props;
    const renderElementProps = render && typeof render !== "function" ? render.props : {};
    const { activeIndex: activeIndex, onNavigate: onNavigate } = $acw62.useContext($3f69993268aa5b7a$var$CompositeContext);
    const { ref: ref, index: index } = $3f69993268aa5b7a$export$dcdc7ff5149f7d1a();
    const mergedRef = $3f69993268aa5b7a$export$74665b213cb5c4cf([
        ref,
        forwardedRef,
        renderElementProps.ref
    ]);
    const isActive = activeIndex === index;
    const computedProps = {
        ...domProps,
        ...renderElementProps,
        ref: mergedRef,
        tabIndex: isActive ? 0 : -1,
        "data-active": isActive ? "" : undefined,
        onFocus (e) {
            domProps.onFocus == null || domProps.onFocus(e);
            renderElementProps.onFocus == null || renderElementProps.onFocus(e);
            onNavigate(index);
        }
    };
    return $3f69993268aa5b7a$var$renderJsx(render, computedProps);
});
let $3f69993268aa5b7a$var$serverHandoffComplete = false;
let $3f69993268aa5b7a$var$count = 0;
const $3f69993268aa5b7a$var$genId = ()=>// on <React 18
    "floating-ui-" + Math.random().toString(36).slice(2, 6) + $3f69993268aa5b7a$var$count++;
function $3f69993268aa5b7a$var$useFloatingId() {
    const [id, setId] = $acw62.useState(()=>$3f69993268aa5b7a$var$serverHandoffComplete ? $3f69993268aa5b7a$var$genId() : undefined);
    $3f69993268aa5b7a$var$index(()=>{
        if (id == null) setId($3f69993268aa5b7a$var$genId());
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    $acw62.useEffect(()=>{
        $3f69993268aa5b7a$var$serverHandoffComplete = true;
    }, []);
    return id;
}
const $3f69993268aa5b7a$var$useReactId = $3f69993268aa5b7a$var$SafeReact.useId;
/**
 * Uses React 18's built-in `useId()` when available, or falls back to a
 * slightly less performant (requiring a double render) implementation for
 * earlier React versions.
 * @see https://floating-ui.com/docs/react-utils#useid
 */ const $3f69993268aa5b7a$export$f680877a34711e37 = $3f69993268aa5b7a$var$useReactId || $3f69993268aa5b7a$var$useFloatingId;
let $3f69993268aa5b7a$var$devMessageSet;
$3f69993268aa5b7a$var$devMessageSet = /*#__PURE__*/ new Set();
function $3f69993268aa5b7a$var$warn() {
    var _devMessageSet;
    for(var _len = arguments.length, messages = new Array(_len), _key = 0; _key < _len; _key++)messages[_key] = arguments[_key];
    const message = "Floating UI: " + messages.join(" ");
    if (!((_devMessageSet = $3f69993268aa5b7a$var$devMessageSet) != null && _devMessageSet.has(message))) {
        var _devMessageSet2;
        (_devMessageSet2 = $3f69993268aa5b7a$var$devMessageSet) == null || _devMessageSet2.add(message);
        console.warn(message);
    }
}
function $3f69993268aa5b7a$var$error() {
    var _devMessageSet3;
    for(var _len2 = arguments.length, messages = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)messages[_key2] = arguments[_key2];
    const message = "Floating UI: " + messages.join(" ");
    if (!((_devMessageSet3 = $3f69993268aa5b7a$var$devMessageSet) != null && _devMessageSet3.has(message))) {
        var _devMessageSet4;
        (_devMessageSet4 = $3f69993268aa5b7a$var$devMessageSet) == null || _devMessageSet4.add(message);
        console.error(message);
    }
}
/**
 * Renders a pointing arrow triangle.
 * @see https://floating-ui.com/docs/FloatingArrow
 */ const $3f69993268aa5b7a$export$33511391554732bc = /*#__PURE__*/ $acw62.forwardRef(function FloatingArrow(props, ref) {
    const { context: { placement: placement, elements: { floating: floating }, middlewareData: { arrow: arrow, shift: shift } }, width: width = 14, height: height = 7, tipRadius: tipRadius = 0, strokeWidth: strokeWidth = 0, staticOffset: staticOffset, stroke: stroke, d: d, style: { transform: transform, ...restStyle } = {}, ...rest } = props;
    if (!ref) $3f69993268aa5b7a$var$warn("The `ref` prop is required for `FloatingArrow`.");
    const clipPathId = $3f69993268aa5b7a$export$f680877a34711e37();
    const [isRTL, setIsRTL] = $acw62.useState(false);
    // https://github.com/floating-ui/floating-ui/issues/2932
    $3f69993268aa5b7a$var$index(()=>{
        if (!floating) return;
        const isRTL = (0, $238ac70369f38756$export$3735103072e4a80)(floating).direction === "rtl";
        if (isRTL) setIsRTL(true);
    }, [
        floating
    ]);
    if (!floating) return null;
    const [side, alignment] = placement.split("-");
    const isVerticalSide = side === "top" || side === "bottom";
    let computedStaticOffset = staticOffset;
    if (isVerticalSide && shift != null && shift.x || !isVerticalSide && shift != null && shift.y) computedStaticOffset = null;
    // Strokes must be double the border width, this ensures the stroke's width
    // works as you'd expect.
    const computedStrokeWidth = strokeWidth * 2;
    const halfStrokeWidth = computedStrokeWidth / 2;
    const svgX = width / 2 * (tipRadius / -8 + 1);
    const svgY = height / 2 * tipRadius / 4;
    const isCustomShape = !!d;
    const yOffsetProp = computedStaticOffset && alignment === "end" ? "bottom" : "top";
    let xOffsetProp = computedStaticOffset && alignment === "end" ? "right" : "left";
    if (computedStaticOffset && isRTL) xOffsetProp = alignment === "end" ? "left" : "right";
    const arrowX = (arrow == null ? void 0 : arrow.x) != null ? computedStaticOffset || arrow.x : "";
    const arrowY = (arrow == null ? void 0 : arrow.y) != null ? computedStaticOffset || arrow.y : "";
    const dValue = d || "M0,0" + (" H" + width) + (" L" + (width - svgX) + "," + (height - svgY)) + (" Q" + width / 2 + "," + height + " " + svgX + "," + (height - svgY)) + " Z";
    const rotation = {
        top: isCustomShape ? "rotate(180deg)" : "",
        left: isCustomShape ? "rotate(90deg)" : "rotate(-90deg)",
        bottom: isCustomShape ? "" : "rotate(180deg)",
        right: isCustomShape ? "rotate(-90deg)" : "rotate(90deg)"
    }[side];
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("svg", {
        ...rest,
        "aria-hidden": true,
        ref: ref,
        width: isCustomShape ? width : width + computedStrokeWidth,
        height: width,
        viewBox: "0 0 " + width + " " + (height > width ? height : width),
        style: {
            position: "absolute",
            pointerEvents: "none",
            [xOffsetProp]: arrowX,
            [yOffsetProp]: arrowY,
            [side]: isVerticalSide || isCustomShape ? "100%" : "calc(100% - " + computedStrokeWidth / 2 + "px)",
            transform: [
                rotation,
                transform
            ].filter((t)=>!!t).join(" "),
            ...restStyle
        },
        children: [
            computedStrokeWidth > 0 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                clipPath: "url(#" + clipPathId + ")",
                fill: "none",
                stroke: stroke,
                strokeWidth: computedStrokeWidth + (d ? 0 : 1),
                d: dValue
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                stroke: computedStrokeWidth && !d ? rest.fill : "none",
                d: dValue
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("clipPath", {
                id: clipPathId,
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("rect", {
                    x: -halfStrokeWidth,
                    y: halfStrokeWidth * (isCustomShape ? -1 : 1),
                    width: width + computedStrokeWidth,
                    height: width
                })
            })
        ]
    });
});
function $3f69993268aa5b7a$var$createPubSub() {
    const map = new Map();
    return {
        emit (event, data) {
            var _map$get;
            (_map$get = map.get(event)) == null || _map$get.forEach((handler)=>handler(data));
        },
        on (event, listener) {
            map.set(event, [
                ...map.get(event) || [],
                listener
            ]);
        },
        off (event, listener) {
            var _map$get2;
            map.set(event, ((_map$get2 = map.get(event)) == null ? void 0 : _map$get2.filter((l)=>l !== listener)) || []);
        }
    };
}
const $3f69993268aa5b7a$var$FloatingNodeContext = /*#__PURE__*/ $acw62.createContext(null);
const $3f69993268aa5b7a$var$FloatingTreeContext = /*#__PURE__*/ $acw62.createContext(null);
/**
 * Returns the parent node id for nested floating elements, if available.
 * Returns `null` for top-level floating elements.
 */ const $3f69993268aa5b7a$export$165209eae06d3488 = ()=>{
    var _React$useContext;
    return ((_React$useContext = $acw62.useContext($3f69993268aa5b7a$var$FloatingNodeContext)) == null ? void 0 : _React$useContext.id) || null;
};
/**
 * Returns the nearest floating tree context, if available.
 */ const $3f69993268aa5b7a$export$db0c2a7c7a2a4f69 = ()=>$acw62.useContext($3f69993268aa5b7a$var$FloatingTreeContext);
/**
 * Registers a node into the `FloatingTree`, returning its id.
 * @see https://floating-ui.com/docs/FloatingTree
 */ function $3f69993268aa5b7a$export$9b136e0e758a42f4(customParentId) {
    const id = $3f69993268aa5b7a$export$f680877a34711e37();
    const tree = $3f69993268aa5b7a$export$db0c2a7c7a2a4f69();
    const reactParentId = $3f69993268aa5b7a$export$165209eae06d3488();
    const parentId = customParentId || reactParentId;
    $3f69993268aa5b7a$var$index(()=>{
        if (!id) return;
        const node = {
            id: id,
            parentId: parentId
        };
        tree == null || tree.addNode(node);
        return ()=>{
            tree == null || tree.removeNode(node);
        };
    }, [
        tree,
        id,
        parentId
    ]);
    return id;
}
/**
 * Provides parent node context for nested floating elements.
 * @see https://floating-ui.com/docs/FloatingTree
 */ function $3f69993268aa5b7a$export$ca00a83b5b253862(props) {
    const { children: children, id: id } = props;
    const parentId = $3f69993268aa5b7a$export$165209eae06d3488();
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($3f69993268aa5b7a$var$FloatingNodeContext.Provider, {
        value: $acw62.useMemo(()=>({
                id: id,
                parentId: parentId
            }), [
            id,
            parentId
        ]),
        children: children
    });
}
/**
 * Provides context for nested floating elements when they are not children of
 * each other on the DOM.
 * This is not necessary in all cases, except when there must be explicit communication between parent and child floating elements. It is necessary for:
 * - The `bubbles` option in the `useDismiss()` Hook
 * - Nested virtual list navigation
 * - Nested floating elements that each open on hover
 * - Custom communication between parent and child floating elements
 * @see https://floating-ui.com/docs/FloatingTree
 */ function $3f69993268aa5b7a$export$587b60129641c4c8(props) {
    const { children: children } = props;
    const nodesRef = $acw62.useRef([]);
    const addNode = $acw62.useCallback((node)=>{
        nodesRef.current = [
            ...nodesRef.current,
            node
        ];
    }, []);
    const removeNode = $acw62.useCallback((node)=>{
        nodesRef.current = nodesRef.current.filter((n)=>n !== node);
    }, []);
    const events = $acw62.useState(()=>$3f69993268aa5b7a$var$createPubSub())[0];
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($3f69993268aa5b7a$var$FloatingTreeContext.Provider, {
        value: $acw62.useMemo(()=>({
                nodesRef: nodesRef,
                addNode: addNode,
                removeNode: removeNode,
                events: events
            }), [
            addNode,
            removeNode,
            events
        ]),
        children: children
    });
}
function $3f69993268aa5b7a$var$createAttribute(name) {
    return "data-floating-ui-" + name;
}
function $3f69993268aa5b7a$var$useLatestRef(value) {
    const ref = (0, $acw62.useRef)(value);
    $3f69993268aa5b7a$var$index(()=>{
        ref.current = value;
    });
    return ref;
}
const $3f69993268aa5b7a$var$safePolygonIdentifier = /*#__PURE__*/ $3f69993268aa5b7a$var$createAttribute("safe-polygon");
function $3f69993268aa5b7a$var$getDelay(value, prop, pointerType) {
    if (pointerType && !(0, $34bc2325b4db944b$export$81cf264172d31e51)(pointerType)) return 0;
    if (typeof value === "number") return value;
    return value == null ? void 0 : value[prop];
}
/**
 * Opens the floating element while hovering over the reference element, like
 * CSS `:hover`.
 * @see https://floating-ui.com/docs/useHover
 */ function $3f69993268aa5b7a$export$ae780daf29e6d456(context, props) {
    if (props === void 0) props = {};
    const { open: open, onOpenChange: onOpenChange, dataRef: dataRef, events: events, elements: elements } = context;
    const { enabled: enabled = true, delay: delay = 0, handleClose: handleClose = null, mouseOnly: mouseOnly = false, restMs: restMs = 0, move: move = true } = props;
    const tree = $3f69993268aa5b7a$export$db0c2a7c7a2a4f69();
    const parentId = $3f69993268aa5b7a$export$165209eae06d3488();
    const handleCloseRef = $3f69993268aa5b7a$var$useLatestRef(handleClose);
    const delayRef = $3f69993268aa5b7a$var$useLatestRef(delay);
    const openRef = $3f69993268aa5b7a$var$useLatestRef(open);
    const pointerTypeRef = $acw62.useRef();
    const timeoutRef = $acw62.useRef(-1);
    const handlerRef = $acw62.useRef();
    const restTimeoutRef = $acw62.useRef(-1);
    const blockMouseMoveRef = $acw62.useRef(true);
    const performedPointerEventsMutationRef = $acw62.useRef(false);
    const unbindMouseMoveRef = $acw62.useRef(()=>{});
    const restTimeoutPendingRef = $acw62.useRef(false);
    const isHoverOpen = $acw62.useCallback(()=>{
        var _dataRef$current$open;
        const type = (_dataRef$current$open = dataRef.current.openEvent) == null ? void 0 : _dataRef$current$open.type;
        return (type == null ? void 0 : type.includes("mouse")) && type !== "mousedown";
    }, [
        dataRef
    ]);
    // When closing before opening, clear the delay timeouts to cancel it
    // from showing.
    $acw62.useEffect(()=>{
        if (!enabled) return;
        function onOpenChange(_ref) {
            let { open: open } = _ref;
            if (!open) {
                clearTimeout(timeoutRef.current);
                clearTimeout(restTimeoutRef.current);
                blockMouseMoveRef.current = true;
                restTimeoutPendingRef.current = false;
            }
        }
        events.on("openchange", onOpenChange);
        return ()=>{
            events.off("openchange", onOpenChange);
        };
    }, [
        enabled,
        events
    ]);
    $acw62.useEffect(()=>{
        if (!enabled) return;
        if (!handleCloseRef.current) return;
        if (!open) return;
        function onLeave(event) {
            if (isHoverOpen()) onOpenChange(false, event, "hover");
        }
        const html = (0, $34bc2325b4db944b$export$f65ca476c09acec0)(elements.floating).documentElement;
        html.addEventListener("mouseleave", onLeave);
        return ()=>{
            html.removeEventListener("mouseleave", onLeave);
        };
    }, [
        elements.floating,
        open,
        onOpenChange,
        enabled,
        handleCloseRef,
        isHoverOpen
    ]);
    const closeWithDelay = $acw62.useCallback(function(event, runElseBranch, reason) {
        if (runElseBranch === void 0) runElseBranch = true;
        if (reason === void 0) reason = "hover";
        const closeDelay = $3f69993268aa5b7a$var$getDelay(delayRef.current, "close", pointerTypeRef.current);
        if (closeDelay && !handlerRef.current) {
            clearTimeout(timeoutRef.current);
            timeoutRef.current = window.setTimeout(()=>onOpenChange(false, event, reason), closeDelay);
        } else if (runElseBranch) {
            clearTimeout(timeoutRef.current);
            onOpenChange(false, event, reason);
        }
    }, [
        delayRef,
        onOpenChange
    ]);
    const cleanupMouseMoveHandler = $3f69993268aa5b7a$var$useEffectEvent(()=>{
        unbindMouseMoveRef.current();
        handlerRef.current = undefined;
    });
    const clearPointerEvents = $3f69993268aa5b7a$var$useEffectEvent(()=>{
        if (performedPointerEventsMutationRef.current) {
            const body = (0, $34bc2325b4db944b$export$f65ca476c09acec0)(elements.floating).body;
            body.style.pointerEvents = "";
            body.removeAttribute($3f69993268aa5b7a$var$safePolygonIdentifier);
            performedPointerEventsMutationRef.current = false;
        }
    });
    const isClickLikeOpenEvent = $3f69993268aa5b7a$var$useEffectEvent(()=>{
        return dataRef.current.openEvent ? [
            "click",
            "mousedown"
        ].includes(dataRef.current.openEvent.type) : false;
    });
    // Registering the mouse events on the reference directly to bypass React's
    // delegation system. If the cursor was on a disabled element and then entered
    // the reference (no gap), `mouseenter` doesn't fire in the delegation system.
    $acw62.useEffect(()=>{
        if (!enabled) return;
        function onMouseEnter(event) {
            clearTimeout(timeoutRef.current);
            blockMouseMoveRef.current = false;
            if (mouseOnly && !(0, $34bc2325b4db944b$export$81cf264172d31e51)(pointerTypeRef.current) || restMs > 0 && !$3f69993268aa5b7a$var$getDelay(delayRef.current, "open")) return;
            const openDelay = $3f69993268aa5b7a$var$getDelay(delayRef.current, "open", pointerTypeRef.current);
            if (openDelay) timeoutRef.current = window.setTimeout(()=>{
                if (!openRef.current) onOpenChange(true, event, "hover");
            }, openDelay);
            else if (!open) onOpenChange(true, event, "hover");
        }
        function onMouseLeave(event) {
            if (isClickLikeOpenEvent()) return;
            unbindMouseMoveRef.current();
            const doc = (0, $34bc2325b4db944b$export$f65ca476c09acec0)(elements.floating);
            clearTimeout(restTimeoutRef.current);
            restTimeoutPendingRef.current = false;
            if (handleCloseRef.current && dataRef.current.floatingContext) {
                // Prevent clearing `onScrollMouseLeave` timeout.
                if (!open) clearTimeout(timeoutRef.current);
                handlerRef.current = handleCloseRef.current({
                    ...dataRef.current.floatingContext,
                    tree: tree,
                    x: event.clientX,
                    y: event.clientY,
                    onClose () {
                        clearPointerEvents();
                        cleanupMouseMoveHandler();
                        if (!isClickLikeOpenEvent()) closeWithDelay(event, true, "safe-polygon");
                    }
                });
                const handler = handlerRef.current;
                doc.addEventListener("mousemove", handler);
                unbindMouseMoveRef.current = ()=>{
                    doc.removeEventListener("mousemove", handler);
                };
                return;
            }
            // Allow interactivity without `safePolygon` on touch devices. With a
            // pointer, a short close delay is an alternative, so it should work
            // consistently.
            const shouldClose = pointerTypeRef.current === "touch" ? !(0, $34bc2325b4db944b$export$2344b14b097df817)(elements.floating, event.relatedTarget) : true;
            if (shouldClose) closeWithDelay(event);
        }
        // Ensure the floating element closes after scrolling even if the pointer
        // did not move.
        // https://github.com/floating-ui/floating-ui/discussions/1692
        function onScrollMouseLeave(event) {
            if (isClickLikeOpenEvent()) return;
            if (!dataRef.current.floatingContext) return;
            handleCloseRef.current == null || handleCloseRef.current({
                ...dataRef.current.floatingContext,
                tree: tree,
                x: event.clientX,
                y: event.clientY,
                onClose () {
                    clearPointerEvents();
                    cleanupMouseMoveHandler();
                    if (!isClickLikeOpenEvent()) closeWithDelay(event);
                }
            })(event);
        }
        if ((0, $238ac70369f38756$export$45a5e7f76e0caa8d)(elements.domReference)) {
            var _elements$floating;
            const ref = elements.domReference;
            open && ref.addEventListener("mouseleave", onScrollMouseLeave);
            (_elements$floating = elements.floating) == null || _elements$floating.addEventListener("mouseleave", onScrollMouseLeave);
            move && ref.addEventListener("mousemove", onMouseEnter, {
                once: true
            });
            ref.addEventListener("mouseenter", onMouseEnter);
            ref.addEventListener("mouseleave", onMouseLeave);
            return ()=>{
                var _elements$floating2;
                open && ref.removeEventListener("mouseleave", onScrollMouseLeave);
                (_elements$floating2 = elements.floating) == null || _elements$floating2.removeEventListener("mouseleave", onScrollMouseLeave);
                move && ref.removeEventListener("mousemove", onMouseEnter);
                ref.removeEventListener("mouseenter", onMouseEnter);
                ref.removeEventListener("mouseleave", onMouseLeave);
            };
        }
    }, [
        elements,
        enabled,
        context,
        mouseOnly,
        restMs,
        move,
        closeWithDelay,
        cleanupMouseMoveHandler,
        clearPointerEvents,
        onOpenChange,
        open,
        openRef,
        tree,
        delayRef,
        handleCloseRef,
        dataRef,
        isClickLikeOpenEvent
    ]);
    // Block pointer-events of every element other than the reference and floating
    // while the floating element is open and has a `handleClose` handler. Also
    // handles nested floating elements.
    // https://github.com/floating-ui/floating-ui/issues/1722
    $3f69993268aa5b7a$var$index(()=>{
        var _handleCloseRef$curre;
        if (!enabled) return;
        if (open && (_handleCloseRef$curre = handleCloseRef.current) != null && _handleCloseRef$curre.__options.blockPointerEvents && isHoverOpen()) {
            performedPointerEventsMutationRef.current = true;
            const floatingEl = elements.floating;
            if ((0, $238ac70369f38756$export$45a5e7f76e0caa8d)(elements.domReference) && floatingEl) {
                var _tree$nodesRef$curren;
                const body = (0, $34bc2325b4db944b$export$f65ca476c09acec0)(elements.floating).body;
                body.setAttribute($3f69993268aa5b7a$var$safePolygonIdentifier, "");
                const ref = elements.domReference;
                const parentFloating = tree == null || (_tree$nodesRef$curren = tree.nodesRef.current.find((node)=>node.id === parentId)) == null || (_tree$nodesRef$curren = _tree$nodesRef$curren.context) == null ? void 0 : _tree$nodesRef$curren.elements.floating;
                if (parentFloating) parentFloating.style.pointerEvents = "";
                body.style.pointerEvents = "none";
                ref.style.pointerEvents = "auto";
                floatingEl.style.pointerEvents = "auto";
                return ()=>{
                    body.style.pointerEvents = "";
                    ref.style.pointerEvents = "";
                    floatingEl.style.pointerEvents = "";
                };
            }
        }
    }, [
        enabled,
        open,
        parentId,
        elements,
        tree,
        handleCloseRef,
        isHoverOpen
    ]);
    $3f69993268aa5b7a$var$index(()=>{
        if (!open) {
            pointerTypeRef.current = undefined;
            restTimeoutPendingRef.current = false;
            cleanupMouseMoveHandler();
            clearPointerEvents();
        }
    }, [
        open,
        cleanupMouseMoveHandler,
        clearPointerEvents
    ]);
    $acw62.useEffect(()=>{
        return ()=>{
            cleanupMouseMoveHandler();
            clearTimeout(timeoutRef.current);
            clearTimeout(restTimeoutRef.current);
            clearPointerEvents();
        };
    }, [
        enabled,
        elements.domReference,
        cleanupMouseMoveHandler,
        clearPointerEvents
    ]);
    const reference = $acw62.useMemo(()=>{
        function setPointerRef(event) {
            pointerTypeRef.current = event.pointerType;
        }
        return {
            onPointerDown: setPointerRef,
            onPointerEnter: setPointerRef,
            onMouseMove (event) {
                const { nativeEvent: nativeEvent } = event;
                function handleMouseMove() {
                    if (!blockMouseMoveRef.current && !openRef.current) onOpenChange(true, nativeEvent, "hover");
                }
                if (mouseOnly && !(0, $34bc2325b4db944b$export$81cf264172d31e51)(pointerTypeRef.current)) return;
                if (open || restMs === 0) return;
                // Ignore insignificant movements to account for tremors.
                if (restTimeoutPendingRef.current && event.movementX ** 2 + event.movementY ** 2 < 2) return;
                clearTimeout(restTimeoutRef.current);
                if (pointerTypeRef.current === "touch") handleMouseMove();
                else {
                    restTimeoutPendingRef.current = true;
                    restTimeoutRef.current = window.setTimeout(handleMouseMove, restMs);
                }
            }
        };
    }, [
        mouseOnly,
        onOpenChange,
        open,
        openRef,
        restMs
    ]);
    const floating = $acw62.useMemo(()=>({
            onMouseEnter () {
                clearTimeout(timeoutRef.current);
            },
            onMouseLeave (event) {
                if (!isClickLikeOpenEvent()) closeWithDelay(event.nativeEvent, false);
            }
        }), [
        closeWithDelay,
        isClickLikeOpenEvent
    ]);
    return $acw62.useMemo(()=>enabled ? {
            reference: reference,
            floating: floating
        } : {}, [
        enabled,
        reference,
        floating
    ]);
}
const $3f69993268aa5b7a$var$NOOP = ()=>{};
const $3f69993268aa5b7a$var$FloatingDelayGroupContext = /*#__PURE__*/ $acw62.createContext({
    delay: 0,
    initialDelay: 0,
    timeoutMs: 0,
    currentId: null,
    setCurrentId: $3f69993268aa5b7a$var$NOOP,
    setState: $3f69993268aa5b7a$var$NOOP,
    isInstantPhase: false
});
/**
 * @deprecated
 * Use the return value of `useDelayGroup()` instead.
 */ const $3f69993268aa5b7a$export$e2411914b150383d = ()=>$acw62.useContext($3f69993268aa5b7a$var$FloatingDelayGroupContext);
/**
 * Provides context for a group of floating elements that should share a
 * `delay`.
 * @see https://floating-ui.com/docs/FloatingDelayGroup
 */ function $3f69993268aa5b7a$export$718279509ff1e241(props) {
    const { children: children, delay: delay, timeoutMs: timeoutMs = 0 } = props;
    const [state, setState] = $acw62.useReducer((prev, next)=>({
            ...prev,
            ...next
        }), {
        delay: delay,
        timeoutMs: timeoutMs,
        initialDelay: delay,
        currentId: null,
        isInstantPhase: false
    });
    const initialCurrentIdRef = $acw62.useRef(null);
    const setCurrentId = $acw62.useCallback((currentId)=>{
        setState({
            currentId: currentId
        });
    }, []);
    $3f69993268aa5b7a$var$index(()=>{
        if (state.currentId) {
            if (initialCurrentIdRef.current === null) initialCurrentIdRef.current = state.currentId;
            else if (!state.isInstantPhase) setState({
                isInstantPhase: true
            });
        } else {
            if (state.isInstantPhase) setState({
                isInstantPhase: false
            });
            initialCurrentIdRef.current = null;
        }
    }, [
        state.currentId,
        state.isInstantPhase
    ]);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($3f69993268aa5b7a$var$FloatingDelayGroupContext.Provider, {
        value: $acw62.useMemo(()=>({
                ...state,
                setState: setState,
                setCurrentId: setCurrentId
            }), [
            state,
            setCurrentId
        ]),
        children: children
    });
}
/**
 * Enables grouping when called inside a component that's a child of a
 * `FloatingDelayGroup`.
 * @see https://floating-ui.com/docs/FloatingDelayGroup
 */ function $3f69993268aa5b7a$export$560fc8be89c8b4a8(context, options) {
    if (options === void 0) options = {};
    const { open: open, onOpenChange: onOpenChange, floatingId: floatingId } = context;
    const { id: optionId, enabled: enabled = true } = options;
    const id = optionId != null ? optionId : floatingId;
    const groupContext = $3f69993268aa5b7a$export$e2411914b150383d();
    const { currentId: currentId, setCurrentId: setCurrentId, initialDelay: initialDelay, setState: setState, timeoutMs: timeoutMs } = groupContext;
    $3f69993268aa5b7a$var$index(()=>{
        if (!enabled) return;
        if (!currentId) return;
        setState({
            delay: {
                open: 1,
                close: $3f69993268aa5b7a$var$getDelay(initialDelay, "close")
            }
        });
        if (currentId !== id) onOpenChange(false);
    }, [
        enabled,
        id,
        onOpenChange,
        setState,
        currentId,
        initialDelay
    ]);
    $3f69993268aa5b7a$var$index(()=>{
        function unset() {
            onOpenChange(false);
            setState({
                delay: initialDelay,
                currentId: null
            });
        }
        if (!enabled) return;
        if (!currentId) return;
        if (!open && currentId === id) {
            if (timeoutMs) {
                const timeout = window.setTimeout(unset, timeoutMs);
                return ()=>{
                    clearTimeout(timeout);
                };
            }
            unset();
        }
    }, [
        enabled,
        open,
        setState,
        currentId,
        id,
        onOpenChange,
        initialDelay,
        timeoutMs
    ]);
    $3f69993268aa5b7a$var$index(()=>{
        if (!enabled) return;
        if (setCurrentId === $3f69993268aa5b7a$var$NOOP || !open) return;
        setCurrentId(id);
    }, [
        enabled,
        open,
        setCurrentId,
        id
    ]);
    return groupContext;
}
let $3f69993268aa5b7a$var$rafId = 0;
function $3f69993268aa5b7a$var$enqueueFocus(el, options) {
    if (options === void 0) options = {};
    const { preventScroll: preventScroll = false, cancelPrevious: cancelPrevious = true, sync: sync = false } = options;
    cancelPrevious && cancelAnimationFrame($3f69993268aa5b7a$var$rafId);
    const exec = ()=>el == null ? void 0 : el.focus({
            preventScroll: preventScroll
        });
    if (sync) exec();
    else $3f69993268aa5b7a$var$rafId = requestAnimationFrame(exec);
}
function $3f69993268aa5b7a$var$getAncestors(nodes, id) {
    var _nodes$find;
    let allAncestors = [];
    let currentParentId = (_nodes$find = nodes.find((node)=>node.id === id)) == null ? void 0 : _nodes$find.parentId;
    while(currentParentId){
        const currentNode = nodes.find((node)=>node.id === currentParentId);
        currentParentId = currentNode == null ? void 0 : currentNode.parentId;
        if (currentNode) allAncestors = allAncestors.concat(currentNode);
    }
    return allAncestors;
}
function $3f69993268aa5b7a$var$getChildren(nodes, id) {
    let allChildren = nodes.filter((node)=>{
        var _node$context;
        return node.parentId === id && ((_node$context = node.context) == null ? void 0 : _node$context.open);
    });
    let currentChildren = allChildren;
    while(currentChildren.length){
        currentChildren = nodes.filter((node)=>{
            var _currentChildren;
            return (_currentChildren = currentChildren) == null ? void 0 : _currentChildren.some((n)=>{
                var _node$context2;
                return node.parentId === n.id && ((_node$context2 = node.context) == null ? void 0 : _node$context2.open);
            });
        });
        allChildren = allChildren.concat(currentChildren);
    }
    return allChildren;
}
function $3f69993268aa5b7a$var$getDeepestNode(nodes, id) {
    let deepestNodeId;
    let maxDepth = -1;
    function findDeepest(nodeId, depth) {
        if (depth > maxDepth) {
            deepestNodeId = nodeId;
            maxDepth = depth;
        }
        const children = $3f69993268aa5b7a$var$getChildren(nodes, nodeId);
        children.forEach((child)=>{
            findDeepest(child.id, depth + 1);
        });
    }
    findDeepest(id, 0);
    return nodes.find((node)=>node.id === deepestNodeId);
}
// Modified to add conditional `aria-hidden` support:
// https://github.com/theKashey/aria-hidden/blob/9220c8f4a4fd35f63bee5510a9f41a37264382d4/src/index.ts
let $3f69993268aa5b7a$var$counterMap = /*#__PURE__*/ new WeakMap();
let $3f69993268aa5b7a$var$uncontrolledElementsSet = /*#__PURE__*/ new WeakSet();
let $3f69993268aa5b7a$var$markerMap = {};
let $3f69993268aa5b7a$var$lockCount$1 = 0;
const $3f69993268aa5b7a$var$supportsInert = ()=>typeof HTMLElement !== "undefined" && "inert" in HTMLElement.prototype;
const $3f69993268aa5b7a$var$unwrapHost = (node)=>node && (node.host || $3f69993268aa5b7a$var$unwrapHost(node.parentNode));
const $3f69993268aa5b7a$var$correctElements = (parent, targets)=>targets.map((target)=>{
        if (parent.contains(target)) return target;
        const correctedTarget = $3f69993268aa5b7a$var$unwrapHost(target);
        if (parent.contains(correctedTarget)) return correctedTarget;
        return null;
    }).filter((x)=>x != null);
function $3f69993268aa5b7a$var$applyAttributeToOthers(uncorrectedAvoidElements, body, ariaHidden, inert) {
    const markerName = "data-floating-ui-inert";
    const controlAttribute = inert ? "inert" : ariaHidden ? "aria-hidden" : null;
    const avoidElements = $3f69993268aa5b7a$var$correctElements(body, uncorrectedAvoidElements);
    const elementsToKeep = new Set();
    const elementsToStop = new Set(avoidElements);
    const hiddenElements = [];
    if (!$3f69993268aa5b7a$var$markerMap[markerName]) $3f69993268aa5b7a$var$markerMap[markerName] = new WeakMap();
    const markerCounter = $3f69993268aa5b7a$var$markerMap[markerName];
    avoidElements.forEach(keep);
    deep(body);
    elementsToKeep.clear();
    function keep(el) {
        if (!el || elementsToKeep.has(el)) return;
        elementsToKeep.add(el);
        el.parentNode && keep(el.parentNode);
    }
    function deep(parent) {
        if (!parent || elementsToStop.has(parent)) return;
        [].forEach.call(parent.children, (node)=>{
            if ((0, $238ac70369f38756$export$651544f548703224)(node) === "script") return;
            if (elementsToKeep.has(node)) deep(node);
            else {
                const attr = controlAttribute ? node.getAttribute(controlAttribute) : null;
                const alreadyHidden = attr !== null && attr !== "false";
                const currentCounterValue = $3f69993268aa5b7a$var$counterMap.get(node) || 0;
                const counterValue = controlAttribute ? currentCounterValue + 1 : currentCounterValue;
                const markerValue = (markerCounter.get(node) || 0) + 1;
                $3f69993268aa5b7a$var$counterMap.set(node, counterValue);
                markerCounter.set(node, markerValue);
                hiddenElements.push(node);
                if (counterValue === 1 && alreadyHidden) $3f69993268aa5b7a$var$uncontrolledElementsSet.add(node);
                if (markerValue === 1) node.setAttribute(markerName, "");
                if (!alreadyHidden && controlAttribute) node.setAttribute(controlAttribute, "true");
            }
        });
    }
    $3f69993268aa5b7a$var$lockCount$1++;
    return ()=>{
        hiddenElements.forEach((element)=>{
            const currentCounterValue = $3f69993268aa5b7a$var$counterMap.get(element) || 0;
            const counterValue = controlAttribute ? currentCounterValue - 1 : currentCounterValue;
            const markerValue = (markerCounter.get(element) || 0) - 1;
            $3f69993268aa5b7a$var$counterMap.set(element, counterValue);
            markerCounter.set(element, markerValue);
            if (!counterValue) {
                if (!$3f69993268aa5b7a$var$uncontrolledElementsSet.has(element) && controlAttribute) element.removeAttribute(controlAttribute);
                $3f69993268aa5b7a$var$uncontrolledElementsSet.delete(element);
            }
            if (!markerValue) element.removeAttribute(markerName);
        });
        $3f69993268aa5b7a$var$lockCount$1--;
        if (!$3f69993268aa5b7a$var$lockCount$1) {
            $3f69993268aa5b7a$var$counterMap = new WeakMap();
            $3f69993268aa5b7a$var$counterMap = new WeakMap();
            $3f69993268aa5b7a$var$uncontrolledElementsSet = new WeakSet();
            $3f69993268aa5b7a$var$markerMap = {};
        }
    };
}
function $3f69993268aa5b7a$var$markOthers(avoidElements, ariaHidden, inert) {
    if (ariaHidden === void 0) ariaHidden = false;
    if (inert === void 0) inert = false;
    const body = (0, $34bc2325b4db944b$export$f65ca476c09acec0)(avoidElements[0]).body;
    return $3f69993268aa5b7a$var$applyAttributeToOthers(avoidElements.concat(Array.from(body.querySelectorAll("[aria-live]"))), body, ariaHidden, inert);
}
const $3f69993268aa5b7a$var$getTabbableOptions = ()=>({
        getShadowRoot: true,
        displayCheck: // JSDOM does not support the `tabbable` library. To solve this we can
        // check if `ResizeObserver` is a real function (not polyfilled), which
        // determines if the current environment is JSDOM-like.
        typeof ResizeObserver === "function" && ResizeObserver.toString().includes("[native code]") ? "full" : "none"
    });
function $3f69993268aa5b7a$var$getTabbableIn(container, direction) {
    const allTabbable = (0, $a4b3b7902c9a987d$export$17100aea90429aa7)(container, $3f69993268aa5b7a$var$getTabbableOptions());
    if (direction === "prev") allTabbable.reverse();
    const activeIndex = allTabbable.indexOf((0, $34bc2325b4db944b$export$da980962bd2147a4)((0, $34bc2325b4db944b$export$f65ca476c09acec0)(container)));
    const nextTabbableElements = allTabbable.slice(activeIndex + 1);
    return nextTabbableElements[0];
}
function $3f69993268aa5b7a$var$getNextTabbable() {
    return $3f69993268aa5b7a$var$getTabbableIn(document.body, "next");
}
function $3f69993268aa5b7a$var$getPreviousTabbable() {
    return $3f69993268aa5b7a$var$getTabbableIn(document.body, "prev");
}
function $3f69993268aa5b7a$var$isOutsideEvent(event, container) {
    const containerElement = container || event.currentTarget;
    const relatedTarget = event.relatedTarget;
    return !relatedTarget || !(0, $34bc2325b4db944b$export$2344b14b097df817)(containerElement, relatedTarget);
}
function $3f69993268aa5b7a$var$disableFocusInside(container) {
    const tabbableElements = (0, $a4b3b7902c9a987d$export$17100aea90429aa7)(container, $3f69993268aa5b7a$var$getTabbableOptions());
    tabbableElements.forEach((element)=>{
        element.dataset.tabindex = element.getAttribute("tabindex") || "";
        element.setAttribute("tabindex", "-1");
    });
}
function $3f69993268aa5b7a$var$enableFocusInside(container) {
    const elements = container.querySelectorAll("[data-tabindex]");
    elements.forEach((element)=>{
        const tabindex = element.dataset.tabindex;
        delete element.dataset.tabindex;
        if (tabindex) element.setAttribute("tabindex", tabindex);
        else element.removeAttribute("tabindex");
    });
}
const $3f69993268aa5b7a$var$HIDDEN_STYLES = {
    border: 0,
    clip: "rect(0 0 0 0)",
    height: "1px",
    margin: "-1px",
    overflow: "hidden",
    padding: 0,
    position: "fixed",
    whiteSpace: "nowrap",
    width: "1px",
    top: 0,
    left: 0
};
let $3f69993268aa5b7a$var$timeoutId;
function $3f69993268aa5b7a$var$setActiveElementOnTab(event) {
    if (event.key === "Tab") {
        event.target;
        clearTimeout($3f69993268aa5b7a$var$timeoutId);
    }
}
const $3f69993268aa5b7a$var$FocusGuard = /*#__PURE__*/ $acw62.forwardRef(function FocusGuard(props, ref) {
    const [role, setRole] = $acw62.useState();
    $3f69993268aa5b7a$var$index(()=>{
        if ((0, $34bc2325b4db944b$export$95df08bae54cb4df)()) // Unlike other screen readers such as NVDA and JAWS, the virtual cursor
        // on VoiceOver does trigger the onFocus event, so we can use the focus
        // trap element. On Safari, only buttons trigger the onFocus event.
        // NB: "group" role in the Sandbox no longer appears to work, must be a
        // button role.
        setRole("button");
        document.addEventListener("keydown", $3f69993268aa5b7a$var$setActiveElementOnTab);
        return ()=>{
            document.removeEventListener("keydown", $3f69993268aa5b7a$var$setActiveElementOnTab);
        };
    }, []);
    const restProps = {
        ref: ref,
        tabIndex: 0,
        role: // Role is only for VoiceOver
        role,
        "aria-hidden": role ? undefined : true,
        [$3f69993268aa5b7a$var$createAttribute("focus-guard")]: "",
        style: $3f69993268aa5b7a$var$HIDDEN_STYLES
    };
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
        ...props,
        ...restProps
    });
});
const $3f69993268aa5b7a$var$PortalContext = /*#__PURE__*/ $acw62.createContext(null);
const $3f69993268aa5b7a$var$attr = /*#__PURE__*/ $3f69993268aa5b7a$var$createAttribute("portal");
/**
 * @see https://floating-ui.com/docs/FloatingPortal#usefloatingportalnode
 */ function $3f69993268aa5b7a$export$ac107512f3c5cca6(props) {
    if (props === void 0) props = {};
    const { id: id, root: root } = props;
    const uniqueId = $3f69993268aa5b7a$export$f680877a34711e37();
    const portalContext = $3f69993268aa5b7a$var$usePortalContext();
    const [portalNode, setPortalNode] = $acw62.useState(null);
    const portalNodeRef = $acw62.useRef(null);
    $3f69993268aa5b7a$var$index(()=>{
        return ()=>{
            portalNode == null || portalNode.remove();
            // Allow the subsequent layout effects to create a new node on updates.
            // The portal node will still be cleaned up on unmount.
            // https://github.com/floating-ui/floating-ui/issues/2454
            queueMicrotask(()=>{
                portalNodeRef.current = null;
            });
        };
    }, [
        portalNode
    ]);
    $3f69993268aa5b7a$var$index(()=>{
        // Wait for the uniqueId to be generated before creating the portal node in
        // React <18 (using `useFloatingId` instead of the native `useId`).
        // https://github.com/floating-ui/floating-ui/issues/2778
        if (!uniqueId) return;
        if (portalNodeRef.current) return;
        const existingIdRoot = id ? document.getElementById(id) : null;
        if (!existingIdRoot) return;
        const subRoot = document.createElement("div");
        subRoot.id = uniqueId;
        subRoot.setAttribute($3f69993268aa5b7a$var$attr, "");
        existingIdRoot.appendChild(subRoot);
        portalNodeRef.current = subRoot;
        setPortalNode(subRoot);
    }, [
        id,
        uniqueId
    ]);
    $3f69993268aa5b7a$var$index(()=>{
        // Wait for the root to exist before creating the portal node. The root must
        // be stored in state, not a ref, for this to work reactively.
        if (root === null) return;
        if (!uniqueId) return;
        if (portalNodeRef.current) return;
        let container = root || (portalContext == null ? void 0 : portalContext.portalNode);
        if (container && !(0, $238ac70369f38756$export$45a5e7f76e0caa8d)(container)) container = container.current;
        container = container || document.body;
        let idWrapper = null;
        if (id) {
            idWrapper = document.createElement("div");
            idWrapper.id = id;
            container.appendChild(idWrapper);
        }
        const subRoot = document.createElement("div");
        subRoot.id = uniqueId;
        subRoot.setAttribute($3f69993268aa5b7a$var$attr, "");
        container = idWrapper || container;
        container.appendChild(subRoot);
        portalNodeRef.current = subRoot;
        setPortalNode(subRoot);
    }, [
        id,
        root,
        uniqueId,
        portalContext
    ]);
    return portalNode;
}
/**
 * Portals the floating element into a given container element — by default,
 * outside of the app root and into the body.
 * This is necessary to ensure the floating element can appear outside any
 * potential parent containers that cause clipping (such as `overflow: hidden`),
 * while retaining its location in the React tree.
 * @see https://floating-ui.com/docs/FloatingPortal
 */ function $3f69993268aa5b7a$export$31fa5d718fa2ac09(props) {
    const { children: children, id: id, root: root, preserveTabOrder: preserveTabOrder = true } = props;
    const portalNode = $3f69993268aa5b7a$export$ac107512f3c5cca6({
        id: id,
        root: root
    });
    const [focusManagerState, setFocusManagerState] = $acw62.useState(null);
    const beforeOutsideRef = $acw62.useRef(null);
    const afterOutsideRef = $acw62.useRef(null);
    const beforeInsideRef = $acw62.useRef(null);
    const afterInsideRef = $acw62.useRef(null);
    const modal = focusManagerState == null ? void 0 : focusManagerState.modal;
    const open = focusManagerState == null ? void 0 : focusManagerState.open;
    const shouldRenderGuards = // The FocusManager and therefore floating element are currently open/
    // rendered.
    !!focusManagerState && // Guards are only for non-modal focus management.
    !focusManagerState.modal && // Don't render if unmount is transitioning.
    focusManagerState.open && preserveTabOrder && !!(root || portalNode);
    // https://codesandbox.io/s/tabbable-portal-f4tng?file=/src/TabbablePortal.tsx
    $acw62.useEffect(()=>{
        if (!portalNode || !preserveTabOrder || modal) return;
        // Make sure elements inside the portal element are tabbable only when the
        // portal has already been focused, either by tabbing into a focus trap
        // element outside or using the mouse.
        function onFocus(event) {
            if (portalNode && $3f69993268aa5b7a$var$isOutsideEvent(event)) {
                const focusing = event.type === "focusin";
                const manageFocus = focusing ? $3f69993268aa5b7a$var$enableFocusInside : $3f69993268aa5b7a$var$disableFocusInside;
                manageFocus(portalNode);
            }
        }
        // Listen to the event on the capture phase so they run before the focus
        // trap elements onFocus prop is called.
        portalNode.addEventListener("focusin", onFocus, true);
        portalNode.addEventListener("focusout", onFocus, true);
        return ()=>{
            portalNode.removeEventListener("focusin", onFocus, true);
            portalNode.removeEventListener("focusout", onFocus, true);
        };
    }, [
        portalNode,
        preserveTabOrder,
        modal
    ]);
    $acw62.useEffect(()=>{
        if (!portalNode) return;
        if (open) return;
        $3f69993268aa5b7a$var$enableFocusInside(portalNode);
    }, [
        open,
        portalNode
    ]);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)($3f69993268aa5b7a$var$PortalContext.Provider, {
        value: $acw62.useMemo(()=>({
                preserveTabOrder: preserveTabOrder,
                beforeOutsideRef: beforeOutsideRef,
                afterOutsideRef: afterOutsideRef,
                beforeInsideRef: beforeInsideRef,
                afterInsideRef: afterInsideRef,
                portalNode: portalNode,
                setFocusManagerState: setFocusManagerState
            }), [
            preserveTabOrder,
            portalNode
        ]),
        children: [
            shouldRenderGuards && portalNode && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($3f69993268aa5b7a$var$FocusGuard, {
                "data-type": "outside",
                ref: beforeOutsideRef,
                onFocus: (event)=>{
                    if ($3f69993268aa5b7a$var$isOutsideEvent(event, portalNode)) {
                        var _beforeInsideRef$curr;
                        (_beforeInsideRef$curr = beforeInsideRef.current) == null || _beforeInsideRef$curr.focus();
                    } else {
                        const prevTabbable = $3f69993268aa5b7a$var$getPreviousTabbable() || (focusManagerState == null ? void 0 : focusManagerState.domReference);
                        prevTabbable == null || prevTabbable.focus();
                    }
                }
            }),
            shouldRenderGuards && portalNode && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                "aria-owns": portalNode.id,
                style: $3f69993268aa5b7a$var$HIDDEN_STYLES
            }),
            portalNode && /*#__PURE__*/ $1u0KT.createPortal(children, portalNode),
            shouldRenderGuards && portalNode && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($3f69993268aa5b7a$var$FocusGuard, {
                "data-type": "outside",
                ref: afterOutsideRef,
                onFocus: (event)=>{
                    if ($3f69993268aa5b7a$var$isOutsideEvent(event, portalNode)) {
                        var _afterInsideRef$curre;
                        (_afterInsideRef$curre = afterInsideRef.current) == null || _afterInsideRef$curre.focus();
                    } else {
                        const nextTabbable = $3f69993268aa5b7a$var$getNextTabbable() || (focusManagerState == null ? void 0 : focusManagerState.domReference);
                        nextTabbable == null || nextTabbable.focus();
                        (focusManagerState == null ? void 0 : focusManagerState.closeOnFocusOut) && (focusManagerState == null || focusManagerState.onOpenChange(false, event.nativeEvent, "focus-out"));
                    }
                }
            })
        ]
    });
}
const $3f69993268aa5b7a$var$usePortalContext = ()=>$acw62.useContext($3f69993268aa5b7a$var$PortalContext);
const $3f69993268aa5b7a$var$FOCUSABLE_ATTRIBUTE = "data-floating-ui-focusable";
function $3f69993268aa5b7a$var$getFloatingFocusElement(floatingElement) {
    if (!floatingElement) return null;
    // Try to find the element that has `{...getFloatingProps()}` spread on it.
    // This indicates the floating element is acting as a positioning wrapper, and
    // so focus should be managed on the child element with the event handlers and
    // aria props.
    return floatingElement.hasAttribute($3f69993268aa5b7a$var$FOCUSABLE_ATTRIBUTE) ? floatingElement : floatingElement.querySelector("[" + $3f69993268aa5b7a$var$FOCUSABLE_ATTRIBUTE + "]") || floatingElement;
}
const $3f69993268aa5b7a$var$LIST_LIMIT = 20;
let $3f69993268aa5b7a$var$previouslyFocusedElements = [];
function $3f69993268aa5b7a$var$addPreviouslyFocusedElement(element) {
    $3f69993268aa5b7a$var$previouslyFocusedElements = $3f69993268aa5b7a$var$previouslyFocusedElements.filter((el)=>el.isConnected);
    if (element && (0, $238ac70369f38756$export$651544f548703224)(element) !== "body") {
        $3f69993268aa5b7a$var$previouslyFocusedElements.push(element);
        if ($3f69993268aa5b7a$var$previouslyFocusedElements.length > $3f69993268aa5b7a$var$LIST_LIMIT) $3f69993268aa5b7a$var$previouslyFocusedElements = $3f69993268aa5b7a$var$previouslyFocusedElements.slice(-$3f69993268aa5b7a$var$LIST_LIMIT);
    }
}
function $3f69993268aa5b7a$var$getPreviouslyFocusedElement() {
    return $3f69993268aa5b7a$var$previouslyFocusedElements.slice().reverse().find((el)=>el.isConnected);
}
function $3f69993268aa5b7a$var$getFirstTabbableElement(container) {
    const tabbableOptions = $3f69993268aa5b7a$var$getTabbableOptions();
    if ((0, $a4b3b7902c9a987d$export$bebd5a1431fec25d)(container, tabbableOptions)) return container;
    return (0, $a4b3b7902c9a987d$export$17100aea90429aa7)(container, tabbableOptions)[0] || container;
}
const $3f69993268aa5b7a$var$VisuallyHiddenDismiss = /*#__PURE__*/ $acw62.forwardRef(function VisuallyHiddenDismiss(props, ref) {
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
        ...props,
        type: "button",
        ref: ref,
        tabIndex: -1,
        style: $3f69993268aa5b7a$var$HIDDEN_STYLES
    });
});
/**
 * Provides focus management for the floating element.
 * @see https://floating-ui.com/docs/FloatingFocusManager
 */ function $3f69993268aa5b7a$export$8aeee49171ded61a(props) {
    const { context: context, children: children, disabled: disabled = false, order: order = [
        "content"
    ], guards: _guards = true, initialFocus: initialFocus = 0, returnFocus: returnFocus = true, restoreFocus: restoreFocus = false, modal: modal = true, visuallyHiddenDismiss: visuallyHiddenDismiss = false, closeOnFocusOut: closeOnFocusOut = true, outsideElementsInert: outsideElementsInert = false } = props;
    const { open: open, onOpenChange: onOpenChange, events: events, dataRef: dataRef, elements: { domReference: domReference, floating: floating } } = context;
    const getNodeId = $3f69993268aa5b7a$var$useEffectEvent(()=>{
        var _dataRef$current$floa;
        return (_dataRef$current$floa = dataRef.current.floatingContext) == null ? void 0 : _dataRef$current$floa.nodeId;
    });
    const ignoreInitialFocus = typeof initialFocus === "number" && initialFocus < 0;
    // If the reference is a combobox and is typeable (e.g. input/textarea),
    // there are different focus semantics. The guards should not be rendered, but
    // aria-hidden should be applied to all nodes still. Further, the visually
    // hidden dismiss button should only appear at the end of the list, not the
    // start.
    const isUntrappedTypeableCombobox = (0, $34bc2325b4db944b$export$259ba5ae38188551)(domReference) && ignoreInitialFocus;
    // Force the guards to be rendered if the `inert` attribute is not supported.
    const inertSupported = $3f69993268aa5b7a$var$supportsInert();
    const guards = inertSupported ? _guards : true;
    const useInert = !guards || inertSupported && outsideElementsInert;
    const orderRef = $3f69993268aa5b7a$var$useLatestRef(order);
    const initialFocusRef = $3f69993268aa5b7a$var$useLatestRef(initialFocus);
    const returnFocusRef = $3f69993268aa5b7a$var$useLatestRef(returnFocus);
    const tree = $3f69993268aa5b7a$export$db0c2a7c7a2a4f69();
    const portalContext = $3f69993268aa5b7a$var$usePortalContext();
    const startDismissButtonRef = $acw62.useRef(null);
    const endDismissButtonRef = $acw62.useRef(null);
    const preventReturnFocusRef = $acw62.useRef(false);
    const isPointerDownRef = $acw62.useRef(false);
    const tabbableIndexRef = $acw62.useRef(-1);
    const isInsidePortal = portalContext != null;
    const floatingFocusElement = $3f69993268aa5b7a$var$getFloatingFocusElement(floating);
    const getTabbableContent = $3f69993268aa5b7a$var$useEffectEvent(function(container) {
        if (container === void 0) container = floatingFocusElement;
        return container ? (0, $a4b3b7902c9a987d$export$17100aea90429aa7)(container, $3f69993268aa5b7a$var$getTabbableOptions()) : [];
    });
    const getTabbableElements = $3f69993268aa5b7a$var$useEffectEvent((container)=>{
        const content = getTabbableContent(container);
        return orderRef.current.map((type)=>{
            if (domReference && type === "reference") return domReference;
            if (floatingFocusElement && type === "floating") return floatingFocusElement;
            return content;
        }).filter(Boolean).flat();
    });
    $acw62.useEffect(()=>{
        if (disabled) return;
        if (!modal) return;
        function onKeyDown(event) {
            if (event.key === "Tab") {
                // The focus guards have nothing to focus, so we need to stop the event.
                if ((0, $34bc2325b4db944b$export$2344b14b097df817)(floatingFocusElement, (0, $34bc2325b4db944b$export$da980962bd2147a4)((0, $34bc2325b4db944b$export$f65ca476c09acec0)(floatingFocusElement))) && getTabbableContent().length === 0 && !isUntrappedTypeableCombobox) (0, $34bc2325b4db944b$export$7ae4cd3a66c1e050)(event);
                const els = getTabbableElements();
                const target = (0, $34bc2325b4db944b$export$c22522a4dfa48e9c)(event);
                if (orderRef.current[0] === "reference" && target === domReference) {
                    (0, $34bc2325b4db944b$export$7ae4cd3a66c1e050)(event);
                    if (event.shiftKey) $3f69993268aa5b7a$var$enqueueFocus(els[els.length - 1]);
                    else $3f69993268aa5b7a$var$enqueueFocus(els[1]);
                }
                if (orderRef.current[1] === "floating" && target === floatingFocusElement && event.shiftKey) {
                    (0, $34bc2325b4db944b$export$7ae4cd3a66c1e050)(event);
                    $3f69993268aa5b7a$var$enqueueFocus(els[0]);
                }
            }
        }
        const doc = (0, $34bc2325b4db944b$export$f65ca476c09acec0)(floatingFocusElement);
        doc.addEventListener("keydown", onKeyDown);
        return ()=>{
            doc.removeEventListener("keydown", onKeyDown);
        };
    }, [
        disabled,
        domReference,
        floatingFocusElement,
        modal,
        orderRef,
        isUntrappedTypeableCombobox,
        getTabbableContent,
        getTabbableElements
    ]);
    $acw62.useEffect(()=>{
        if (disabled) return;
        if (!floating) return;
        function handleFocusIn(event) {
            const target = (0, $34bc2325b4db944b$export$c22522a4dfa48e9c)(event);
            const tabbableContent = getTabbableContent();
            const tabbableIndex = tabbableContent.indexOf(target);
            if (tabbableIndex !== -1) tabbableIndexRef.current = tabbableIndex;
        }
        floating.addEventListener("focusin", handleFocusIn);
        return ()=>{
            floating.removeEventListener("focusin", handleFocusIn);
        };
    }, [
        disabled,
        floating,
        getTabbableContent
    ]);
    $acw62.useEffect(()=>{
        if (disabled) return;
        if (!closeOnFocusOut) return;
        // In Safari, buttons lose focus when pressing them.
        function handlePointerDown() {
            isPointerDownRef.current = true;
            setTimeout(()=>{
                isPointerDownRef.current = false;
            });
        }
        function handleFocusOutside(event) {
            const relatedTarget = event.relatedTarget;
            queueMicrotask(()=>{
                const nodeId = getNodeId();
                const movedToUnrelatedNode = !((0, $34bc2325b4db944b$export$2344b14b097df817)(domReference, relatedTarget) || (0, $34bc2325b4db944b$export$2344b14b097df817)(floating, relatedTarget) || (0, $34bc2325b4db944b$export$2344b14b097df817)(relatedTarget, floating) || (0, $34bc2325b4db944b$export$2344b14b097df817)(portalContext == null ? void 0 : portalContext.portalNode, relatedTarget) || relatedTarget != null && relatedTarget.hasAttribute($3f69993268aa5b7a$var$createAttribute("focus-guard")) || tree && ($3f69993268aa5b7a$var$getChildren(tree.nodesRef.current, nodeId).find((node)=>{
                    var _node$context, _node$context2;
                    return (0, $34bc2325b4db944b$export$2344b14b097df817)((_node$context = node.context) == null ? void 0 : _node$context.elements.floating, relatedTarget) || (0, $34bc2325b4db944b$export$2344b14b097df817)((_node$context2 = node.context) == null ? void 0 : _node$context2.elements.domReference, relatedTarget);
                }) || $3f69993268aa5b7a$var$getAncestors(tree.nodesRef.current, nodeId).find((node)=>{
                    var _node$context3, _node$context4, _node$context5;
                    return [
                        (_node$context3 = node.context) == null ? void 0 : _node$context3.elements.floating,
                        $3f69993268aa5b7a$var$getFloatingFocusElement((_node$context4 = node.context) == null ? void 0 : _node$context4.elements.floating)
                    ].includes(relatedTarget) || ((_node$context5 = node.context) == null ? void 0 : _node$context5.elements.domReference) === relatedTarget;
                })));
                // Restore focus to the previous tabbable element index to prevent
                // focus from being lost outside the floating tree.
                if (restoreFocus && movedToUnrelatedNode && (0, $34bc2325b4db944b$export$da980962bd2147a4)((0, $34bc2325b4db944b$export$f65ca476c09acec0)(floatingFocusElement)) === (0, $34bc2325b4db944b$export$f65ca476c09acec0)(floatingFocusElement).body) {
                    // Let `FloatingPortal` effect knows that focus is still inside the
                    // floating tree.
                    if ((0, $238ac70369f38756$export$1b3bfaa9684536aa)(floatingFocusElement)) floatingFocusElement.focus();
                    const prevTabbableIndex = tabbableIndexRef.current;
                    const tabbableContent = getTabbableContent();
                    const nodeToFocus = tabbableContent[prevTabbableIndex] || tabbableContent[tabbableContent.length - 1] || floatingFocusElement;
                    if ((0, $238ac70369f38756$export$1b3bfaa9684536aa)(nodeToFocus)) nodeToFocus.focus();
                }
                // Focus did not move inside the floating tree, and there are no tabbable
                // portal guards to handle closing.
                if ((isUntrappedTypeableCombobox ? true : !modal) && relatedTarget && movedToUnrelatedNode && !isPointerDownRef.current && // Fix React 18 Strict Mode returnFocus due to double rendering.
                relatedTarget !== $3f69993268aa5b7a$var$getPreviouslyFocusedElement()) {
                    preventReturnFocusRef.current = true;
                    onOpenChange(false, event, "focus-out");
                }
            });
        }
        if (floating && (0, $238ac70369f38756$export$1b3bfaa9684536aa)(domReference)) {
            domReference.addEventListener("focusout", handleFocusOutside);
            domReference.addEventListener("pointerdown", handlePointerDown);
            floating.addEventListener("focusout", handleFocusOutside);
            return ()=>{
                domReference.removeEventListener("focusout", handleFocusOutside);
                domReference.removeEventListener("pointerdown", handlePointerDown);
                floating.removeEventListener("focusout", handleFocusOutside);
            };
        }
    }, [
        disabled,
        domReference,
        floating,
        floatingFocusElement,
        modal,
        tree,
        portalContext,
        onOpenChange,
        closeOnFocusOut,
        restoreFocus,
        getTabbableContent,
        isUntrappedTypeableCombobox,
        getNodeId
    ]);
    const beforeGuardRef = $acw62.useRef(null);
    const afterGuardRef = $acw62.useRef(null);
    const mergedBeforeGuardRef = $3f69993268aa5b7a$export$74665b213cb5c4cf([
        beforeGuardRef,
        portalContext == null ? void 0 : portalContext.beforeInsideRef
    ]);
    const mergedAfterGuardRef = $3f69993268aa5b7a$export$74665b213cb5c4cf([
        afterGuardRef,
        portalContext == null ? void 0 : portalContext.afterInsideRef
    ]);
    $acw62.useEffect(()=>{
        var _portalContext$portal;
        if (disabled) return;
        if (!floating) return;
        // Don't hide portals nested within the parent portal.
        const portalNodes = Array.from((portalContext == null || (_portalContext$portal = portalContext.portalNode) == null ? void 0 : _portalContext$portal.querySelectorAll("[" + $3f69993268aa5b7a$var$createAttribute("portal") + "]")) || []);
        const ancestorFloatingNodes = tree && !modal ? $3f69993268aa5b7a$var$getAncestors(tree == null ? void 0 : tree.nodesRef.current, getNodeId()).map((node)=>{
            var _node$context6;
            return (_node$context6 = node.context) == null ? void 0 : _node$context6.elements.floating;
        }) : [];
        const insideElements = [
            floating,
            ...portalNodes,
            ...ancestorFloatingNodes,
            startDismissButtonRef.current,
            endDismissButtonRef.current,
            beforeGuardRef.current,
            afterGuardRef.current,
            portalContext == null ? void 0 : portalContext.beforeOutsideRef.current,
            portalContext == null ? void 0 : portalContext.afterOutsideRef.current,
            orderRef.current.includes("reference") || isUntrappedTypeableCombobox ? domReference : null
        ].filter((x)=>x != null);
        const cleanup = modal || isUntrappedTypeableCombobox ? $3f69993268aa5b7a$var$markOthers(insideElements, !useInert, useInert) : $3f69993268aa5b7a$var$markOthers(insideElements);
        return ()=>{
            cleanup();
        };
    }, [
        disabled,
        domReference,
        floating,
        modal,
        orderRef,
        portalContext,
        isUntrappedTypeableCombobox,
        guards,
        useInert,
        tree,
        getNodeId
    ]);
    $3f69993268aa5b7a$var$index(()=>{
        if (disabled || !(0, $238ac70369f38756$export$1b3bfaa9684536aa)(floatingFocusElement)) return;
        const doc = (0, $34bc2325b4db944b$export$f65ca476c09acec0)(floatingFocusElement);
        const previouslyFocusedElement = (0, $34bc2325b4db944b$export$da980962bd2147a4)(doc);
        // Wait for any layout effect state setters to execute to set `tabIndex`.
        queueMicrotask(()=>{
            const focusableElements = getTabbableElements(floatingFocusElement);
            const initialFocusValue = initialFocusRef.current;
            const elToFocus = (typeof initialFocusValue === "number" ? focusableElements[initialFocusValue] : initialFocusValue.current) || floatingFocusElement;
            const focusAlreadyInsideFloatingEl = (0, $34bc2325b4db944b$export$2344b14b097df817)(floatingFocusElement, previouslyFocusedElement);
            if (!ignoreInitialFocus && !focusAlreadyInsideFloatingEl && open) $3f69993268aa5b7a$var$enqueueFocus(elToFocus, {
                preventScroll: elToFocus === floatingFocusElement
            });
        });
    }, [
        disabled,
        open,
        floatingFocusElement,
        ignoreInitialFocus,
        getTabbableElements,
        initialFocusRef
    ]);
    $3f69993268aa5b7a$var$index(()=>{
        if (disabled || !floatingFocusElement) return;
        let preventReturnFocusScroll = false;
        const doc = (0, $34bc2325b4db944b$export$f65ca476c09acec0)(floatingFocusElement);
        const previouslyFocusedElement = (0, $34bc2325b4db944b$export$da980962bd2147a4)(doc);
        const contextData = dataRef.current;
        let openEvent = contextData.openEvent;
        $3f69993268aa5b7a$var$addPreviouslyFocusedElement(previouslyFocusedElement);
        // Dismissing via outside press should always ignore `returnFocus` to
        // prevent unwanted scrolling.
        function onOpenChange(_ref) {
            let { open: open, reason: reason, event: event, nested: nested } = _ref;
            if (open) openEvent = event;
            if (reason === "escape-key" && domReference) $3f69993268aa5b7a$var$addPreviouslyFocusedElement(domReference);
            if ([
                "hover",
                "safe-polygon"
            ].includes(reason) && event.type === "mouseleave") preventReturnFocusRef.current = true;
            if (reason !== "outside-press") return;
            if (nested) {
                preventReturnFocusRef.current = false;
                preventReturnFocusScroll = true;
            } else preventReturnFocusRef.current = !((0, $34bc2325b4db944b$export$60278871457622de)(event) || (0, $34bc2325b4db944b$export$29bf1b5f2c56cf63)(event));
        }
        events.on("openchange", onOpenChange);
        const fallbackEl = doc.createElement("span");
        fallbackEl.setAttribute("tabindex", "-1");
        fallbackEl.setAttribute("aria-hidden", "true");
        Object.assign(fallbackEl.style, $3f69993268aa5b7a$var$HIDDEN_STYLES);
        if (isInsidePortal && domReference) domReference.insertAdjacentElement("afterend", fallbackEl);
        function getReturnElement() {
            if (typeof returnFocusRef.current === "boolean") return $3f69993268aa5b7a$var$getPreviouslyFocusedElement() || fallbackEl;
            return returnFocusRef.current.current || fallbackEl;
        }
        return ()=>{
            events.off("openchange", onOpenChange);
            const activeEl = (0, $34bc2325b4db944b$export$da980962bd2147a4)(doc);
            const isFocusInsideFloatingTree = (0, $34bc2325b4db944b$export$2344b14b097df817)(floating, activeEl) || tree && $3f69993268aa5b7a$var$getChildren(tree.nodesRef.current, getNodeId()).some((node)=>{
                var _node$context7;
                return (0, $34bc2325b4db944b$export$2344b14b097df817)((_node$context7 = node.context) == null ? void 0 : _node$context7.elements.floating, activeEl);
            });
            const shouldFocusReference = isFocusInsideFloatingTree || openEvent && [
                "click",
                "mousedown"
            ].includes(openEvent.type);
            if (shouldFocusReference && domReference) $3f69993268aa5b7a$var$addPreviouslyFocusedElement(domReference);
            const returnElement = getReturnElement();
            queueMicrotask(()=>{
                // This is `returnElement`, if it's tabbable, or its first tabbable child.
                const tabbableReturnElement = $3f69993268aa5b7a$var$getFirstTabbableElement(returnElement);
                if (// eslint-disable-next-line react-hooks/exhaustive-deps
                returnFocusRef.current && !preventReturnFocusRef.current && (0, $238ac70369f38756$export$1b3bfaa9684536aa)(tabbableReturnElement) && // If the focus moved somewhere else after mount, avoid returning focus
                // since it likely entered a different element which should be
                // respected: https://github.com/floating-ui/floating-ui/issues/2607
                (tabbableReturnElement !== activeEl && activeEl !== doc.body ? isFocusInsideFloatingTree : true)) tabbableReturnElement.focus({
                    preventScroll: preventReturnFocusScroll
                });
                fallbackEl.remove();
            });
        };
    }, [
        disabled,
        floating,
        floatingFocusElement,
        returnFocusRef,
        dataRef,
        events,
        tree,
        isInsidePortal,
        domReference,
        getNodeId
    ]);
    $acw62.useEffect(()=>{
        // The `returnFocus` cleanup behavior is inside a microtask; ensure we
        // wait for it to complete before resetting the flag.
        queueMicrotask(()=>{
            preventReturnFocusRef.current = false;
        });
    }, [
        disabled
    ]);
    // Synchronize the `context` & `modal` value to the FloatingPortal context.
    // It will decide whether or not it needs to render its own guards.
    $3f69993268aa5b7a$var$index(()=>{
        if (disabled) return;
        if (!portalContext) return;
        portalContext.setFocusManagerState({
            modal: modal,
            closeOnFocusOut: closeOnFocusOut,
            open: open,
            onOpenChange: onOpenChange,
            domReference: domReference
        });
        return ()=>{
            portalContext.setFocusManagerState(null);
        };
    }, [
        disabled,
        portalContext,
        modal,
        open,
        onOpenChange,
        closeOnFocusOut,
        domReference
    ]);
    $3f69993268aa5b7a$var$index(()=>{
        if (disabled) return;
        if (!floatingFocusElement) return;
        if (typeof MutationObserver !== "function") return;
        if (ignoreInitialFocus) return;
        const handleMutation = ()=>{
            const tabIndex = floatingFocusElement.getAttribute("tabindex");
            const tabbableContent = getTabbableContent();
            const activeEl = (0, $34bc2325b4db944b$export$da980962bd2147a4)((0, $34bc2325b4db944b$export$f65ca476c09acec0)(floating));
            const tabbableIndex = tabbableContent.indexOf(activeEl);
            if (tabbableIndex !== -1) tabbableIndexRef.current = tabbableIndex;
            if (orderRef.current.includes("floating") || activeEl !== domReference && tabbableContent.length === 0) {
                if (tabIndex !== "0") floatingFocusElement.setAttribute("tabindex", "0");
            } else if (tabIndex !== "-1") floatingFocusElement.setAttribute("tabindex", "-1");
        };
        handleMutation();
        const observer = new MutationObserver(handleMutation);
        observer.observe(floatingFocusElement, {
            childList: true,
            subtree: true,
            attributes: true
        });
        return ()=>{
            observer.disconnect();
        };
    }, [
        disabled,
        floating,
        floatingFocusElement,
        domReference,
        orderRef,
        getTabbableContent,
        ignoreInitialFocus
    ]);
    function renderDismissButton(location) {
        if (disabled || !visuallyHiddenDismiss || !modal) return null;
        return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($3f69993268aa5b7a$var$VisuallyHiddenDismiss, {
            ref: location === "start" ? startDismissButtonRef : endDismissButtonRef,
            onClick: (event)=>onOpenChange(false, event.nativeEvent),
            children: typeof visuallyHiddenDismiss === "string" ? visuallyHiddenDismiss : "Dismiss"
        });
    }
    const shouldRenderGuards = !disabled && guards && (modal ? !isUntrappedTypeableCombobox : true) && (isInsidePortal || modal);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
        children: [
            shouldRenderGuards && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($3f69993268aa5b7a$var$FocusGuard, {
                "data-type": "inside",
                ref: mergedBeforeGuardRef,
                onFocus: (event)=>{
                    if (modal) {
                        const els = getTabbableElements();
                        $3f69993268aa5b7a$var$enqueueFocus(order[0] === "reference" ? els[0] : els[els.length - 1]);
                    } else if (portalContext != null && portalContext.preserveTabOrder && portalContext.portalNode) {
                        preventReturnFocusRef.current = false;
                        if ($3f69993268aa5b7a$var$isOutsideEvent(event, portalContext.portalNode)) {
                            const nextTabbable = $3f69993268aa5b7a$var$getNextTabbable() || domReference;
                            nextTabbable == null || nextTabbable.focus();
                        } else {
                            var _portalContext$before;
                            (_portalContext$before = portalContext.beforeOutsideRef.current) == null || _portalContext$before.focus();
                        }
                    }
                }
            }),
            !isUntrappedTypeableCombobox && renderDismissButton("start"),
            children,
            renderDismissButton("end"),
            shouldRenderGuards && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($3f69993268aa5b7a$var$FocusGuard, {
                "data-type": "inside",
                ref: mergedAfterGuardRef,
                onFocus: (event)=>{
                    if (modal) $3f69993268aa5b7a$var$enqueueFocus(getTabbableElements()[0]);
                    else if (portalContext != null && portalContext.preserveTabOrder && portalContext.portalNode) {
                        if (closeOnFocusOut) preventReturnFocusRef.current = true;
                        if ($3f69993268aa5b7a$var$isOutsideEvent(event, portalContext.portalNode)) {
                            const prevTabbable = $3f69993268aa5b7a$var$getPreviousTabbable() || domReference;
                            prevTabbable == null || prevTabbable.focus();
                        } else {
                            var _portalContext$afterO;
                            (_portalContext$afterO = portalContext.afterOutsideRef.current) == null || _portalContext$afterO.focus();
                        }
                    }
                }
            })
        ]
    });
}
let $3f69993268aa5b7a$var$lockCount = 0;
function $3f69993268aa5b7a$var$enableScrollLock() {
    const isIOS = /iP(hone|ad|od)|iOS/.test((0, $34bc2325b4db944b$export$867a782338812cb4)());
    const bodyStyle = document.body.style;
    // RTL <body> scrollbar
    const scrollbarX = Math.round(document.documentElement.getBoundingClientRect().left) + document.documentElement.scrollLeft;
    const paddingProp = scrollbarX ? "paddingLeft" : "paddingRight";
    const scrollbarWidth = window.innerWidth - document.documentElement.clientWidth;
    const scrollX = bodyStyle.left ? parseFloat(bodyStyle.left) : window.scrollX;
    const scrollY = bodyStyle.top ? parseFloat(bodyStyle.top) : window.scrollY;
    bodyStyle.overflow = "hidden";
    if (scrollbarWidth) bodyStyle[paddingProp] = scrollbarWidth + "px";
    // Only iOS doesn't respect `overflow: hidden` on document.body, and this
    // technique has fewer side effects.
    if (isIOS) {
        var _window$visualViewpor, _window$visualViewpor2;
        // iOS 12 does not support `visualViewport`.
        const offsetLeft = ((_window$visualViewpor = window.visualViewport) == null ? void 0 : _window$visualViewpor.offsetLeft) || 0;
        const offsetTop = ((_window$visualViewpor2 = window.visualViewport) == null ? void 0 : _window$visualViewpor2.offsetTop) || 0;
        Object.assign(bodyStyle, {
            position: "fixed",
            top: -(scrollY - Math.floor(offsetTop)) + "px",
            left: -(scrollX - Math.floor(offsetLeft)) + "px",
            right: "0"
        });
    }
    return ()=>{
        Object.assign(bodyStyle, {
            overflow: "",
            [paddingProp]: ""
        });
        if (isIOS) {
            Object.assign(bodyStyle, {
                position: "",
                top: "",
                left: "",
                right: ""
            });
            window.scrollTo(scrollX, scrollY);
        }
    };
}
let $3f69993268aa5b7a$var$cleanup = ()=>{};
/**
 * Provides base styling for a fixed overlay element to dim content or block
 * pointer events behind a floating element.
 * It's a regular `<div>`, so it can be styled via any CSS solution you prefer.
 * @see https://floating-ui.com/docs/FloatingOverlay
 */ const $3f69993268aa5b7a$export$a35954495955337b = /*#__PURE__*/ $acw62.forwardRef(function FloatingOverlay(props, ref) {
    const { lockScroll: lockScroll = false, ...rest } = props;
    $3f69993268aa5b7a$var$index(()=>{
        if (!lockScroll) return;
        $3f69993268aa5b7a$var$lockCount++;
        if ($3f69993268aa5b7a$var$lockCount === 1) $3f69993268aa5b7a$var$cleanup = $3f69993268aa5b7a$var$enableScrollLock();
        return ()=>{
            $3f69993268aa5b7a$var$lockCount--;
            if ($3f69993268aa5b7a$var$lockCount === 0) $3f69993268aa5b7a$var$cleanup();
        };
    }, [
        lockScroll
    ]);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        ref: ref,
        ...rest,
        style: {
            position: "fixed",
            overflow: "auto",
            top: 0,
            right: 0,
            bottom: 0,
            left: 0,
            ...rest.style
        }
    });
});
function $3f69993268aa5b7a$var$isButtonTarget(event) {
    return (0, $238ac70369f38756$export$1b3bfaa9684536aa)(event.target) && event.target.tagName === "BUTTON";
}
function $3f69993268aa5b7a$var$isSpaceIgnored(element) {
    return (0, $34bc2325b4db944b$export$42ad131c32f0fb8d)(element);
}
/**
 * Opens or closes the floating element when clicking the reference element.
 * @see https://floating-ui.com/docs/useClick
 */ function $3f69993268aa5b7a$export$98524f11226063fc(context, props) {
    if (props === void 0) props = {};
    const { open: open, onOpenChange: onOpenChange, dataRef: dataRef, elements: { domReference: domReference } } = context;
    const { enabled: enabled = true, event: eventOption = "click", toggle: toggle = true, ignoreMouse: ignoreMouse = false, keyboardHandlers: keyboardHandlers = true, stickIfOpen: stickIfOpen = true } = props;
    const pointerTypeRef = $acw62.useRef();
    const didKeyDownRef = $acw62.useRef(false);
    const reference = $acw62.useMemo(()=>({
            onPointerDown (event) {
                pointerTypeRef.current = event.pointerType;
            },
            onMouseDown (event) {
                const pointerType = pointerTypeRef.current;
                // Ignore all buttons except for the "main" button.
                // https://developer.mozilla.org/en-US/docs/Web/API/MouseEvent/button
                if (event.button !== 0) return;
                if (eventOption === "click") return;
                if ((0, $34bc2325b4db944b$export$81cf264172d31e51)(pointerType, true) && ignoreMouse) return;
                if (open && toggle && (dataRef.current.openEvent && stickIfOpen ? dataRef.current.openEvent.type === "mousedown" : true)) onOpenChange(false, event.nativeEvent, "click");
                else {
                    // Prevent stealing focus from the floating element
                    event.preventDefault();
                    onOpenChange(true, event.nativeEvent, "click");
                }
            },
            onClick (event) {
                const pointerType = pointerTypeRef.current;
                if (eventOption === "mousedown" && pointerTypeRef.current) {
                    pointerTypeRef.current = undefined;
                    return;
                }
                if ((0, $34bc2325b4db944b$export$81cf264172d31e51)(pointerType, true) && ignoreMouse) return;
                if (open && toggle && (dataRef.current.openEvent && stickIfOpen ? dataRef.current.openEvent.type === "click" : true)) onOpenChange(false, event.nativeEvent, "click");
                else onOpenChange(true, event.nativeEvent, "click");
            },
            onKeyDown (event) {
                pointerTypeRef.current = undefined;
                if (event.defaultPrevented || !keyboardHandlers || $3f69993268aa5b7a$var$isButtonTarget(event)) return;
                if (event.key === " " && !$3f69993268aa5b7a$var$isSpaceIgnored(domReference)) {
                    // Prevent scrolling
                    event.preventDefault();
                    didKeyDownRef.current = true;
                }
                if (event.key === "Enter") {
                    if (open && toggle) onOpenChange(false, event.nativeEvent, "click");
                    else onOpenChange(true, event.nativeEvent, "click");
                }
            },
            onKeyUp (event) {
                if (event.defaultPrevented || !keyboardHandlers || $3f69993268aa5b7a$var$isButtonTarget(event) || $3f69993268aa5b7a$var$isSpaceIgnored(domReference)) return;
                if (event.key === " " && didKeyDownRef.current) {
                    didKeyDownRef.current = false;
                    if (open && toggle) onOpenChange(false, event.nativeEvent, "click");
                    else onOpenChange(true, event.nativeEvent, "click");
                }
            }
        }), [
        dataRef,
        domReference,
        eventOption,
        ignoreMouse,
        keyboardHandlers,
        onOpenChange,
        open,
        stickIfOpen,
        toggle
    ]);
    return $acw62.useMemo(()=>enabled ? {
            reference: reference
        } : {}, [
        enabled,
        reference
    ]);
}
function $3f69993268aa5b7a$var$createVirtualElement(domElement, data) {
    let offsetX = null;
    let offsetY = null;
    let isAutoUpdateEvent = false;
    return {
        contextElement: domElement || undefined,
        getBoundingClientRect () {
            var _data$dataRef$current;
            const domRect = (domElement == null ? void 0 : domElement.getBoundingClientRect()) || {
                width: 0,
                height: 0,
                x: 0,
                y: 0
            };
            const isXAxis = data.axis === "x" || data.axis === "both";
            const isYAxis = data.axis === "y" || data.axis === "both";
            const canTrackCursorOnAutoUpdate = [
                "mouseenter",
                "mousemove"
            ].includes(((_data$dataRef$current = data.dataRef.current.openEvent) == null ? void 0 : _data$dataRef$current.type) || "") && data.pointerType !== "touch";
            let width = domRect.width;
            let height = domRect.height;
            let x = domRect.x;
            let y = domRect.y;
            if (offsetX == null && data.x && isXAxis) offsetX = domRect.x - data.x;
            if (offsetY == null && data.y && isYAxis) offsetY = domRect.y - data.y;
            x -= offsetX || 0;
            y -= offsetY || 0;
            width = 0;
            height = 0;
            if (!isAutoUpdateEvent || canTrackCursorOnAutoUpdate) {
                width = data.axis === "y" ? domRect.width : 0;
                height = data.axis === "x" ? domRect.height : 0;
                x = isXAxis && data.x != null ? data.x : x;
                y = isYAxis && data.y != null ? data.y : y;
            } else if (isAutoUpdateEvent && !canTrackCursorOnAutoUpdate) {
                height = data.axis === "x" ? domRect.height : height;
                width = data.axis === "y" ? domRect.width : width;
            }
            isAutoUpdateEvent = true;
            return {
                width: width,
                height: height,
                x: x,
                y: y,
                top: y,
                right: x + width,
                bottom: y + height,
                left: x
            };
        }
    };
}
function $3f69993268aa5b7a$var$isMouseBasedEvent(event) {
    return event != null && event.clientX != null;
}
/**
 * Positions the floating element relative to a client point (in the viewport),
 * such as the mouse position. By default, it follows the mouse cursor.
 * @see https://floating-ui.com/docs/useClientPoint
 */ function $3f69993268aa5b7a$export$7fe170a73a621816(context, props) {
    if (props === void 0) props = {};
    const { open: open, dataRef: dataRef, elements: { floating: floating, domReference: domReference }, refs: refs } = context;
    const { enabled: enabled = true, axis: axis = "both", x: x = null, y: y = null } = props;
    const initialRef = $acw62.useRef(false);
    const cleanupListenerRef = $acw62.useRef(null);
    const [pointerType, setPointerType] = $acw62.useState();
    const [reactive, setReactive] = $acw62.useState([]);
    const setReference = $3f69993268aa5b7a$var$useEffectEvent((x, y)=>{
        if (initialRef.current) return;
        // Prevent setting if the open event was not a mouse-like one
        // (e.g. focus to open, then hover over the reference element).
        // Only apply if the event exists.
        if (dataRef.current.openEvent && !$3f69993268aa5b7a$var$isMouseBasedEvent(dataRef.current.openEvent)) return;
        refs.setPositionReference($3f69993268aa5b7a$var$createVirtualElement(domReference, {
            x: x,
            y: y,
            axis: axis,
            dataRef: dataRef,
            pointerType: pointerType
        }));
    });
    const handleReferenceEnterOrMove = $3f69993268aa5b7a$var$useEffectEvent((event)=>{
        if (x != null || y != null) return;
        if (!open) setReference(event.clientX, event.clientY);
        else if (!cleanupListenerRef.current) // If there's no cleanup, there's no listener, but we want to ensure
        // we add the listener if the cursor landed on the floating element and
        // then back on the reference (i.e. it's interactive).
        setReactive([]);
    });
    // If the pointer is a mouse-like pointer, we want to continue following the
    // mouse even if the floating element is transitioning out. On touch
    // devices, this is undesirable because the floating element will move to
    // the dismissal touch point.
    const openCheck = (0, $34bc2325b4db944b$export$81cf264172d31e51)(pointerType) ? floating : open;
    const addListener = $acw62.useCallback(()=>{
        // Explicitly specified `x`/`y` coordinates shouldn't add a listener.
        if (!openCheck || !enabled || x != null || y != null) return;
        const win = (0, $238ac70369f38756$export$38b2d434cce3ea22)(floating);
        function handleMouseMove(event) {
            const target = (0, $34bc2325b4db944b$export$c22522a4dfa48e9c)(event);
            if (!(0, $34bc2325b4db944b$export$2344b14b097df817)(floating, target)) setReference(event.clientX, event.clientY);
            else {
                win.removeEventListener("mousemove", handleMouseMove);
                cleanupListenerRef.current = null;
            }
        }
        if (!dataRef.current.openEvent || $3f69993268aa5b7a$var$isMouseBasedEvent(dataRef.current.openEvent)) {
            win.addEventListener("mousemove", handleMouseMove);
            const cleanup = ()=>{
                win.removeEventListener("mousemove", handleMouseMove);
                cleanupListenerRef.current = null;
            };
            cleanupListenerRef.current = cleanup;
            return cleanup;
        }
        refs.setPositionReference(domReference);
    }, [
        openCheck,
        enabled,
        x,
        y,
        floating,
        dataRef,
        refs,
        domReference,
        setReference
    ]);
    $acw62.useEffect(()=>{
        return addListener();
    }, [
        addListener,
        reactive
    ]);
    $acw62.useEffect(()=>{
        if (enabled && !floating) initialRef.current = false;
    }, [
        enabled,
        floating
    ]);
    $acw62.useEffect(()=>{
        if (!enabled && open) initialRef.current = true;
    }, [
        enabled,
        open
    ]);
    $3f69993268aa5b7a$var$index(()=>{
        if (enabled && (x != null || y != null)) {
            initialRef.current = false;
            setReference(x, y);
        }
    }, [
        enabled,
        x,
        y,
        setReference
    ]);
    const reference = $acw62.useMemo(()=>{
        function setPointerTypeRef(_ref) {
            let { pointerType: pointerType } = _ref;
            setPointerType(pointerType);
        }
        return {
            onPointerDown: setPointerTypeRef,
            onPointerEnter: setPointerTypeRef,
            onMouseMove: handleReferenceEnterOrMove,
            onMouseEnter: handleReferenceEnterOrMove
        };
    }, [
        handleReferenceEnterOrMove
    ]);
    return $acw62.useMemo(()=>enabled ? {
            reference: reference
        } : {}, [
        enabled,
        reference
    ]);
}
const $3f69993268aa5b7a$var$bubbleHandlerKeys = {
    pointerdown: "onPointerDown",
    mousedown: "onMouseDown",
    click: "onClick"
};
const $3f69993268aa5b7a$var$captureHandlerKeys = {
    pointerdown: "onPointerDownCapture",
    mousedown: "onMouseDownCapture",
    click: "onClickCapture"
};
const $3f69993268aa5b7a$var$normalizeProp = (normalizable)=>{
    var _normalizable$escapeK, _normalizable$outside;
    return {
        escapeKey: typeof normalizable === "boolean" ? normalizable : (_normalizable$escapeK = normalizable == null ? void 0 : normalizable.escapeKey) != null ? _normalizable$escapeK : false,
        outsidePress: typeof normalizable === "boolean" ? normalizable : (_normalizable$outside = normalizable == null ? void 0 : normalizable.outsidePress) != null ? _normalizable$outside : true
    };
};
/**
 * Closes the floating element when a dismissal is requested — by default, when
 * the user presses the `escape` key or outside of the floating element.
 * @see https://floating-ui.com/docs/useDismiss
 */ function $3f69993268aa5b7a$export$fcdf1ba5fafc089b(context, props) {
    if (props === void 0) props = {};
    const { open: open, onOpenChange: onOpenChange, elements: elements, dataRef: dataRef } = context;
    const { enabled: enabled = true, escapeKey: escapeKey = true, outsidePress: unstable_outsidePress = true, outsidePressEvent: outsidePressEvent = "pointerdown", referencePress: referencePress = false, referencePressEvent: referencePressEvent = "pointerdown", ancestorScroll: ancestorScroll = false, bubbles: bubbles, capture: capture } = props;
    const tree = $3f69993268aa5b7a$export$db0c2a7c7a2a4f69();
    const outsidePressFn = $3f69993268aa5b7a$var$useEffectEvent(typeof unstable_outsidePress === "function" ? unstable_outsidePress : ()=>false);
    const outsidePress = typeof unstable_outsidePress === "function" ? outsidePressFn : unstable_outsidePress;
    const insideReactTreeRef = $acw62.useRef(false);
    const endedOrStartedInsideRef = $acw62.useRef(false);
    const { escapeKey: escapeKeyBubbles, outsidePress: outsidePressBubbles } = $3f69993268aa5b7a$var$normalizeProp(bubbles);
    const { escapeKey: escapeKeyCapture, outsidePress: outsidePressCapture } = $3f69993268aa5b7a$var$normalizeProp(capture);
    const isComposingRef = $acw62.useRef(false);
    const closeOnEscapeKeyDown = $3f69993268aa5b7a$var$useEffectEvent((event)=>{
        var _dataRef$current$floa;
        if (!open || !enabled || !escapeKey || event.key !== "Escape") return;
        // Wait until IME is settled. Pressing `Escape` while composing should
        // close the compose menu, but not the floating element.
        if (isComposingRef.current) return;
        const nodeId = (_dataRef$current$floa = dataRef.current.floatingContext) == null ? void 0 : _dataRef$current$floa.nodeId;
        const children = tree ? $3f69993268aa5b7a$var$getChildren(tree.nodesRef.current, nodeId) : [];
        if (!escapeKeyBubbles) {
            event.stopPropagation();
            if (children.length > 0) {
                let shouldDismiss = true;
                children.forEach((child)=>{
                    var _child$context;
                    if ((_child$context = child.context) != null && _child$context.open && !child.context.dataRef.current.__escapeKeyBubbles) {
                        shouldDismiss = false;
                        return;
                    }
                });
                if (!shouldDismiss) return;
            }
        }
        onOpenChange(false, (0, $34bc2325b4db944b$export$94781ce41a161222)(event) ? event.nativeEvent : event, "escape-key");
    });
    const closeOnEscapeKeyDownCapture = $3f69993268aa5b7a$var$useEffectEvent((event)=>{
        var _getTarget2;
        const callback = ()=>{
            var _getTarget;
            closeOnEscapeKeyDown(event);
            (_getTarget = (0, $34bc2325b4db944b$export$c22522a4dfa48e9c)(event)) == null || _getTarget.removeEventListener("keydown", callback);
        };
        (_getTarget2 = (0, $34bc2325b4db944b$export$c22522a4dfa48e9c)(event)) == null || _getTarget2.addEventListener("keydown", callback);
    });
    const closeOnPressOutside = $3f69993268aa5b7a$var$useEffectEvent((event)=>{
        var _dataRef$current$floa2;
        // Given developers can stop the propagation of the synthetic event,
        // we can only be confident with a positive value.
        const insideReactTree = insideReactTreeRef.current;
        insideReactTreeRef.current = false;
        // When click outside is lazy (`click` event), handle dragging.
        // Don't close if:
        // - The click started inside the floating element.
        // - The click ended inside the floating element.
        const endedOrStartedInside = endedOrStartedInsideRef.current;
        endedOrStartedInsideRef.current = false;
        if (outsidePressEvent === "click" && endedOrStartedInside) return;
        if (insideReactTree) return;
        if (typeof outsidePress === "function" && !outsidePress(event)) return;
        const target = (0, $34bc2325b4db944b$export$c22522a4dfa48e9c)(event);
        const inertSelector = "[" + $3f69993268aa5b7a$var$createAttribute("inert") + "]";
        const markers = (0, $34bc2325b4db944b$export$f65ca476c09acec0)(elements.floating).querySelectorAll(inertSelector);
        let targetRootAncestor = (0, $238ac70369f38756$export$45a5e7f76e0caa8d)(target) ? target : null;
        while(targetRootAncestor && !(0, $238ac70369f38756$export$d1162fb0b6d4cd51)(targetRootAncestor)){
            const nextParent = (0, $238ac70369f38756$export$4e12058fc4d51d56)(targetRootAncestor);
            if ((0, $238ac70369f38756$export$d1162fb0b6d4cd51)(nextParent) || !(0, $238ac70369f38756$export$45a5e7f76e0caa8d)(nextParent)) break;
            targetRootAncestor = nextParent;
        }
        // Check if the click occurred on a third-party element injected after the
        // floating element rendered.
        if (markers.length && (0, $238ac70369f38756$export$45a5e7f76e0caa8d)(target) && !(0, $34bc2325b4db944b$export$7b296c28e0fa3aed)(target) && // Clicked on a direct ancestor (e.g. FloatingOverlay).
        !(0, $34bc2325b4db944b$export$2344b14b097df817)(target, elements.floating) && // If the target root element contains none of the markers, then the
        // element was injected after the floating element rendered.
        Array.from(markers).every((marker)=>!(0, $34bc2325b4db944b$export$2344b14b097df817)(targetRootAncestor, marker))) return;
        // Check if the click occurred on the scrollbar
        if ((0, $238ac70369f38756$export$1b3bfaa9684536aa)(target) && floating) {
            const lastTraversableNode = (0, $238ac70369f38756$export$d1162fb0b6d4cd51)(target);
            const style = (0, $238ac70369f38756$export$3735103072e4a80)(target);
            const scrollRe = /auto|scroll/;
            const isScrollableX = lastTraversableNode || scrollRe.test(style.overflowX);
            const isScrollableY = lastTraversableNode || scrollRe.test(style.overflowY);
            const canScrollX = isScrollableX && target.clientWidth > 0 && target.scrollWidth > target.clientWidth;
            const canScrollY = isScrollableY && target.clientHeight > 0 && target.scrollHeight > target.clientHeight;
            const isRTL = style.direction === "rtl";
            // Check click position relative to scrollbar.
            // In some browsers it is possible to change the <body> (or window)
            // scrollbar to the left side, but is very rare and is difficult to
            // check for. Plus, for modal dialogs with backdrops, it is more
            // important that the backdrop is checked but not so much the window.
            const pressedVerticalScrollbar = canScrollY && (isRTL ? event.offsetX <= target.offsetWidth - target.clientWidth : event.offsetX > target.clientWidth);
            const pressedHorizontalScrollbar = canScrollX && event.offsetY > target.clientHeight;
            if (pressedVerticalScrollbar || pressedHorizontalScrollbar) return;
        }
        const nodeId = (_dataRef$current$floa2 = dataRef.current.floatingContext) == null ? void 0 : _dataRef$current$floa2.nodeId;
        const targetIsInsideChildren = tree && $3f69993268aa5b7a$var$getChildren(tree.nodesRef.current, nodeId).some((node)=>{
            var _node$context;
            return (0, $34bc2325b4db944b$export$43c3154d5bf2c6c2)(event, (_node$context = node.context) == null ? void 0 : _node$context.elements.floating);
        });
        if ((0, $34bc2325b4db944b$export$43c3154d5bf2c6c2)(event, elements.floating) || (0, $34bc2325b4db944b$export$43c3154d5bf2c6c2)(event, elements.domReference) || targetIsInsideChildren) return;
        const children = tree ? $3f69993268aa5b7a$var$getChildren(tree.nodesRef.current, nodeId) : [];
        if (children.length > 0) {
            let shouldDismiss = true;
            children.forEach((child)=>{
                var _child$context2;
                if ((_child$context2 = child.context) != null && _child$context2.open && !child.context.dataRef.current.__outsidePressBubbles) {
                    shouldDismiss = false;
                    return;
                }
            });
            if (!shouldDismiss) return;
        }
        onOpenChange(false, event, "outside-press");
    });
    const closeOnPressOutsideCapture = $3f69993268aa5b7a$var$useEffectEvent((event)=>{
        var _getTarget4;
        const callback = ()=>{
            var _getTarget3;
            closeOnPressOutside(event);
            (_getTarget3 = (0, $34bc2325b4db944b$export$c22522a4dfa48e9c)(event)) == null || _getTarget3.removeEventListener(outsidePressEvent, callback);
        };
        (_getTarget4 = (0, $34bc2325b4db944b$export$c22522a4dfa48e9c)(event)) == null || _getTarget4.addEventListener(outsidePressEvent, callback);
    });
    $acw62.useEffect(()=>{
        if (!open || !enabled) return;
        dataRef.current.__escapeKeyBubbles = escapeKeyBubbles;
        dataRef.current.__outsidePressBubbles = outsidePressBubbles;
        let compositionTimeout = -1;
        function onScroll(event) {
            onOpenChange(false, event, "ancestor-scroll");
        }
        function handleCompositionStart() {
            window.clearTimeout(compositionTimeout);
            isComposingRef.current = true;
        }
        function handleCompositionEnd() {
            // Safari fires `compositionend` before `keydown`, so we need to wait
            // until the next tick to set `isComposing` to `false`.
            // https://bugs.webkit.org/show_bug.cgi?id=165004
            compositionTimeout = window.setTimeout(()=>{
                isComposingRef.current = false;
            }, // 0ms or 1ms don't work in Safari. 5ms appears to consistently work.
            // Only apply to WebKit for the test to remain 0ms.
            (0, $238ac70369f38756$export$78551043582a6a98)() ? 5 : 0);
        }
        const doc = (0, $34bc2325b4db944b$export$f65ca476c09acec0)(elements.floating);
        if (escapeKey) {
            doc.addEventListener("keydown", escapeKeyCapture ? closeOnEscapeKeyDownCapture : closeOnEscapeKeyDown, escapeKeyCapture);
            doc.addEventListener("compositionstart", handleCompositionStart);
            doc.addEventListener("compositionend", handleCompositionEnd);
        }
        outsidePress && doc.addEventListener(outsidePressEvent, outsidePressCapture ? closeOnPressOutsideCapture : closeOnPressOutside, outsidePressCapture);
        let ancestors = [];
        if (ancestorScroll) {
            if ((0, $238ac70369f38756$export$45a5e7f76e0caa8d)(elements.domReference)) ancestors = (0, $238ac70369f38756$export$3b57c1601291186b)(elements.domReference);
            if ((0, $238ac70369f38756$export$45a5e7f76e0caa8d)(elements.floating)) ancestors = ancestors.concat((0, $238ac70369f38756$export$3b57c1601291186b)(elements.floating));
            if (!(0, $238ac70369f38756$export$45a5e7f76e0caa8d)(elements.reference) && elements.reference && elements.reference.contextElement) ancestors = ancestors.concat((0, $238ac70369f38756$export$3b57c1601291186b)(elements.reference.contextElement));
        }
        // Ignore the visual viewport for scrolling dismissal (allow pinch-zoom)
        ancestors = ancestors.filter((ancestor)=>{
            var _doc$defaultView;
            return ancestor !== ((_doc$defaultView = doc.defaultView) == null ? void 0 : _doc$defaultView.visualViewport);
        });
        ancestors.forEach((ancestor)=>{
            ancestor.addEventListener("scroll", onScroll, {
                passive: true
            });
        });
        return ()=>{
            if (escapeKey) {
                doc.removeEventListener("keydown", escapeKeyCapture ? closeOnEscapeKeyDownCapture : closeOnEscapeKeyDown, escapeKeyCapture);
                doc.removeEventListener("compositionstart", handleCompositionStart);
                doc.removeEventListener("compositionend", handleCompositionEnd);
            }
            outsidePress && doc.removeEventListener(outsidePressEvent, outsidePressCapture ? closeOnPressOutsideCapture : closeOnPressOutside, outsidePressCapture);
            ancestors.forEach((ancestor)=>{
                ancestor.removeEventListener("scroll", onScroll);
            });
            window.clearTimeout(compositionTimeout);
        };
    }, [
        dataRef,
        elements,
        escapeKey,
        outsidePress,
        outsidePressEvent,
        open,
        onOpenChange,
        ancestorScroll,
        enabled,
        escapeKeyBubbles,
        outsidePressBubbles,
        closeOnEscapeKeyDown,
        escapeKeyCapture,
        closeOnEscapeKeyDownCapture,
        closeOnPressOutside,
        outsidePressCapture,
        closeOnPressOutsideCapture
    ]);
    $acw62.useEffect(()=>{
        insideReactTreeRef.current = false;
    }, [
        outsidePress,
        outsidePressEvent
    ]);
    const reference = $acw62.useMemo(()=>({
            onKeyDown: closeOnEscapeKeyDown,
            ...referencePress && {
                [$3f69993268aa5b7a$var$bubbleHandlerKeys[referencePressEvent]]: (event)=>{
                    onOpenChange(false, event.nativeEvent, "reference-press");
                },
                ...referencePressEvent !== "click" && {
                    onClick (event) {
                        onOpenChange(false, event.nativeEvent, "reference-press");
                    }
                }
            }
        }), [
        closeOnEscapeKeyDown,
        onOpenChange,
        referencePress,
        referencePressEvent
    ]);
    const floating = $acw62.useMemo(()=>({
            onKeyDown: closeOnEscapeKeyDown,
            onMouseDown () {
                endedOrStartedInsideRef.current = true;
            },
            onMouseUp () {
                endedOrStartedInsideRef.current = true;
            },
            [$3f69993268aa5b7a$var$captureHandlerKeys[outsidePressEvent]]: ()=>{
                insideReactTreeRef.current = true;
            }
        }), [
        closeOnEscapeKeyDown,
        outsidePressEvent
    ]);
    return $acw62.useMemo(()=>enabled ? {
            reference: reference,
            floating: floating
        } : {}, [
        enabled,
        reference,
        floating
    ]);
}
function $3f69993268aa5b7a$export$1df81146f8ad8e4c(options) {
    const { open: open = false, onOpenChange: onOpenChangeProp, elements: elementsProp } = options;
    const floatingId = $3f69993268aa5b7a$export$f680877a34711e37();
    const dataRef = $acw62.useRef({});
    const [events] = $acw62.useState(()=>$3f69993268aa5b7a$var$createPubSub());
    const nested = $3f69993268aa5b7a$export$165209eae06d3488() != null;
    {
        const optionDomReference = elementsProp.reference;
        if (optionDomReference && !(0, $238ac70369f38756$export$45a5e7f76e0caa8d)(optionDomReference)) $3f69993268aa5b7a$var$error("Cannot pass a virtual element to the `elements.reference` option,", "as it must be a real DOM element. Use `refs.setPositionReference()`", "instead.");
    }
    const [positionReference, setPositionReference] = $acw62.useState(elementsProp.reference);
    const onOpenChange = $3f69993268aa5b7a$var$useEffectEvent((open, event, reason)=>{
        dataRef.current.openEvent = open ? event : undefined;
        events.emit("openchange", {
            open: open,
            event: event,
            reason: reason,
            nested: nested
        });
        onOpenChangeProp == null || onOpenChangeProp(open, event, reason);
    });
    const refs = $acw62.useMemo(()=>({
            setPositionReference: setPositionReference
        }), []);
    const elements = $acw62.useMemo(()=>({
            reference: positionReference || elementsProp.reference || null,
            floating: elementsProp.floating || null,
            domReference: elementsProp.reference
        }), [
        positionReference,
        elementsProp.reference,
        elementsProp.floating
    ]);
    return $acw62.useMemo(()=>({
            dataRef: dataRef,
            open: open,
            onOpenChange: onOpenChange,
            elements: elements,
            events: events,
            floatingId: floatingId,
            refs: refs
        }), [
        open,
        onOpenChange,
        elements,
        events,
        floatingId,
        refs
    ]);
}
/**
 * Provides data to position a floating element and context to add interactions.
 * @see https://floating-ui.com/docs/useFloating
 */ function $3f69993268aa5b7a$export$4e02a5c1d08bac65(options) {
    if (options === void 0) options = {};
    const { nodeId: nodeId } = options;
    const internalRootContext = $3f69993268aa5b7a$export$1df81146f8ad8e4c({
        ...options,
        elements: {
            reference: null,
            floating: null,
            ...options.elements
        }
    });
    const rootContext = options.rootContext || internalRootContext;
    const computedElements = rootContext.elements;
    const [_domReference, setDomReference] = $acw62.useState(null);
    const [positionReference, _setPositionReference] = $acw62.useState(null);
    const optionDomReference = computedElements == null ? void 0 : computedElements.domReference;
    const domReference = optionDomReference || _domReference;
    const domReferenceRef = $acw62.useRef(null);
    const tree = $3f69993268aa5b7a$export$db0c2a7c7a2a4f69();
    $3f69993268aa5b7a$var$index(()=>{
        if (domReference) domReferenceRef.current = domReference;
    }, [
        domReference
    ]);
    const position = (0, $23a8f689f1d4c3be$export$4e02a5c1d08bac65)({
        ...options,
        elements: {
            ...computedElements,
            ...positionReference && {
                reference: positionReference
            }
        }
    });
    const setPositionReference = $acw62.useCallback((node)=>{
        const computedPositionReference = (0, $238ac70369f38756$export$45a5e7f76e0caa8d)(node) ? {
            getBoundingClientRect: ()=>node.getBoundingClientRect(),
            contextElement: node
        } : node;
        // Store the positionReference in state if the DOM reference is specified externally via the
        // `elements.reference` option. This ensures that it won't be overridden on future renders.
        _setPositionReference(computedPositionReference);
        position.refs.setReference(computedPositionReference);
    }, [
        position.refs
    ]);
    const setReference = $acw62.useCallback((node)=>{
        if ((0, $238ac70369f38756$export$45a5e7f76e0caa8d)(node) || node === null) {
            domReferenceRef.current = node;
            setDomReference(node);
        }
        // Backwards-compatibility for passing a virtual element to `reference`
        // after it has set the DOM reference.
        if ((0, $238ac70369f38756$export$45a5e7f76e0caa8d)(position.refs.reference.current) || position.refs.reference.current === null || // Don't allow setting virtual elements using the old technique back to
        // `null` to support `positionReference` + an unstable `reference`
        // callback ref.
        node !== null && !(0, $238ac70369f38756$export$45a5e7f76e0caa8d)(node)) position.refs.setReference(node);
    }, [
        position.refs
    ]);
    const refs = $acw62.useMemo(()=>({
            ...position.refs,
            setReference: setReference,
            setPositionReference: setPositionReference,
            domReference: domReferenceRef
        }), [
        position.refs,
        setReference,
        setPositionReference
    ]);
    const elements = $acw62.useMemo(()=>({
            ...position.elements,
            domReference: domReference
        }), [
        position.elements,
        domReference
    ]);
    const context = $acw62.useMemo(()=>({
            ...position,
            ...rootContext,
            refs: refs,
            elements: elements,
            nodeId: nodeId
        }), [
        position,
        refs,
        elements,
        nodeId,
        rootContext
    ]);
    $3f69993268aa5b7a$var$index(()=>{
        rootContext.dataRef.current.floatingContext = context;
        const node = tree == null ? void 0 : tree.nodesRef.current.find((node)=>node.id === nodeId);
        if (node) node.context = context;
    });
    return $acw62.useMemo(()=>({
            ...position,
            context: context,
            refs: refs,
            elements: elements
        }), [
        position,
        refs,
        elements,
        context
    ]);
}
/**
 * Opens the floating element while the reference element has focus, like CSS
 * `:focus`.
 * @see https://floating-ui.com/docs/useFocus
 */ function $3f69993268aa5b7a$export$f8168d8dd8fd66e6(context, props) {
    if (props === void 0) props = {};
    const { open: open, onOpenChange: onOpenChange, events: events, dataRef: dataRef, elements: elements } = context;
    const { enabled: enabled = true, visibleOnly: visibleOnly = true } = props;
    const blockFocusRef = $acw62.useRef(false);
    const timeoutRef = $acw62.useRef();
    const keyboardModalityRef = $acw62.useRef(true);
    $acw62.useEffect(()=>{
        if (!enabled) return;
        const win = (0, $238ac70369f38756$export$38b2d434cce3ea22)(elements.domReference);
        // If the reference was focused and the user left the tab/window, and the
        // floating element was not open, the focus should be blocked when they
        // return to the tab/window.
        function onBlur() {
            if (!open && (0, $238ac70369f38756$export$1b3bfaa9684536aa)(elements.domReference) && elements.domReference === (0, $34bc2325b4db944b$export$da980962bd2147a4)((0, $34bc2325b4db944b$export$f65ca476c09acec0)(elements.domReference))) blockFocusRef.current = true;
        }
        function onKeyDown() {
            keyboardModalityRef.current = true;
        }
        win.addEventListener("blur", onBlur);
        win.addEventListener("keydown", onKeyDown, true);
        return ()=>{
            win.removeEventListener("blur", onBlur);
            win.removeEventListener("keydown", onKeyDown, true);
        };
    }, [
        elements.domReference,
        open,
        enabled
    ]);
    $acw62.useEffect(()=>{
        if (!enabled) return;
        function onOpenChange(_ref) {
            let { reason: reason } = _ref;
            if (reason === "reference-press" || reason === "escape-key") blockFocusRef.current = true;
        }
        events.on("openchange", onOpenChange);
        return ()=>{
            events.off("openchange", onOpenChange);
        };
    }, [
        events,
        enabled
    ]);
    $acw62.useEffect(()=>{
        return ()=>{
            clearTimeout(timeoutRef.current);
        };
    }, []);
    const reference = $acw62.useMemo(()=>({
            onPointerDown (event) {
                if ((0, $34bc2325b4db944b$export$29bf1b5f2c56cf63)(event.nativeEvent)) return;
                keyboardModalityRef.current = false;
            },
            onMouseLeave () {
                blockFocusRef.current = false;
            },
            onFocus (event) {
                if (blockFocusRef.current) return;
                const target = (0, $34bc2325b4db944b$export$c22522a4dfa48e9c)(event.nativeEvent);
                if (visibleOnly && (0, $238ac70369f38756$export$45a5e7f76e0caa8d)(target)) try {
                    // Mac Safari unreliably matches `:focus-visible` on the reference
                    // if focus was outside the page initially - use the fallback
                    // instead.
                    if ((0, $34bc2325b4db944b$export$95df08bae54cb4df)() && (0, $34bc2325b4db944b$export$9ac100e40613ea10)()) throw Error();
                    if (!target.matches(":focus-visible")) return;
                } catch (e) {
                    // Old browsers will throw an error when using `:focus-visible`.
                    if (!keyboardModalityRef.current && !(0, $34bc2325b4db944b$export$42ad131c32f0fb8d)(target)) return;
                }
                onOpenChange(true, event.nativeEvent, "focus");
            },
            onBlur (event) {
                blockFocusRef.current = false;
                const relatedTarget = event.relatedTarget;
                const nativeEvent = event.nativeEvent;
                // Hit the non-modal focus management portal guard. Focus will be
                // moved into the floating element immediately after.
                const movedToFocusGuard = (0, $238ac70369f38756$export$45a5e7f76e0caa8d)(relatedTarget) && relatedTarget.hasAttribute($3f69993268aa5b7a$var$createAttribute("focus-guard")) && relatedTarget.getAttribute("data-type") === "outside";
                // Wait for the window blur listener to fire.
                timeoutRef.current = window.setTimeout(()=>{
                    var _dataRef$current$floa;
                    const activeEl = (0, $34bc2325b4db944b$export$da980962bd2147a4)(elements.domReference ? elements.domReference.ownerDocument : document);
                    // Focus left the page, keep it open.
                    if (!relatedTarget && activeEl === elements.domReference) return;
                    // When focusing the reference element (e.g. regular click), then
                    // clicking into the floating element, prevent it from hiding.
                    // Note: it must be focusable, e.g. `tabindex="-1"`.
                    // We can not rely on relatedTarget to point to the correct element
                    // as it will only point to the shadow host of the newly focused element
                    // and not the element that actually has received focus if it is located
                    // inside a shadow root.
                    if ((0, $34bc2325b4db944b$export$2344b14b097df817)((_dataRef$current$floa = dataRef.current.floatingContext) == null ? void 0 : _dataRef$current$floa.refs.floating.current, activeEl) || (0, $34bc2325b4db944b$export$2344b14b097df817)(elements.domReference, activeEl) || movedToFocusGuard) return;
                    onOpenChange(false, nativeEvent, "focus");
                });
            }
        }), [
        dataRef,
        elements.domReference,
        onOpenChange,
        visibleOnly
    ]);
    return $acw62.useMemo(()=>enabled ? {
            reference: reference
        } : {}, [
        enabled,
        reference
    ]);
}
const $3f69993268aa5b7a$var$ACTIVE_KEY = "active";
const $3f69993268aa5b7a$var$SELECTED_KEY = "selected";
function $3f69993268aa5b7a$var$mergeProps(userProps, propsList, elementKey) {
    const map = new Map();
    const isItem = elementKey === "item";
    let domUserProps = userProps;
    if (isItem && userProps) {
        const { [$3f69993268aa5b7a$var$ACTIVE_KEY]: _, [$3f69993268aa5b7a$var$SELECTED_KEY]: __, ...validProps } = userProps;
        domUserProps = validProps;
    }
    return {
        ...elementKey === "floating" && {
            tabIndex: -1,
            [$3f69993268aa5b7a$var$FOCUSABLE_ATTRIBUTE]: ""
        },
        ...domUserProps,
        ...propsList.map((value)=>{
            const propsOrGetProps = value ? value[elementKey] : null;
            if (typeof propsOrGetProps === "function") return userProps ? propsOrGetProps(userProps) : null;
            return propsOrGetProps;
        }).concat(userProps).reduce((acc, props)=>{
            if (!props) return acc;
            Object.entries(props).forEach((_ref)=>{
                let [key, value] = _ref;
                if (isItem && [
                    $3f69993268aa5b7a$var$ACTIVE_KEY,
                    $3f69993268aa5b7a$var$SELECTED_KEY
                ].includes(key)) return;
                if (key.indexOf("on") === 0) {
                    if (!map.has(key)) map.set(key, []);
                    if (typeof value === "function") {
                        var _map$get;
                        (_map$get = map.get(key)) == null || _map$get.push(value);
                        acc[key] = function() {
                            var _map$get2;
                            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
                            return (_map$get2 = map.get(key)) == null ? void 0 : _map$get2.map((fn)=>fn(...args)).find((val)=>val !== undefined);
                        };
                    }
                } else acc[key] = value;
            });
            return acc;
        }, {})
    };
}
/**
 * Merges an array of interaction hooks' props into prop getters, allowing
 * event handler functions to be composed together without overwriting one
 * another.
 * @see https://floating-ui.com/docs/useInteractions
 */ function $3f69993268aa5b7a$export$a519f7794e446ddd(propsList) {
    if (propsList === void 0) propsList = [];
    const referenceDeps = propsList.map((key)=>key == null ? void 0 : key.reference);
    const floatingDeps = propsList.map((key)=>key == null ? void 0 : key.floating);
    const itemDeps = propsList.map((key)=>key == null ? void 0 : key.item);
    const getReferenceProps = $acw62.useCallback((userProps)=>$3f69993268aa5b7a$var$mergeProps(userProps, propsList, "reference"), // eslint-disable-next-line react-hooks/exhaustive-deps
    referenceDeps);
    const getFloatingProps = $acw62.useCallback((userProps)=>$3f69993268aa5b7a$var$mergeProps(userProps, propsList, "floating"), // eslint-disable-next-line react-hooks/exhaustive-deps
    floatingDeps);
    const getItemProps = $acw62.useCallback((userProps)=>$3f69993268aa5b7a$var$mergeProps(userProps, propsList, "item"), // eslint-disable-next-line react-hooks/exhaustive-deps
    itemDeps);
    return $acw62.useMemo(()=>({
            getReferenceProps: getReferenceProps,
            getFloatingProps: getFloatingProps,
            getItemProps: getItemProps
        }), [
        getReferenceProps,
        getFloatingProps,
        getItemProps
    ]);
}
function $3f69993268aa5b7a$var$doSwitch(orientation, vertical, horizontal) {
    switch(orientation){
        case "vertical":
            return vertical;
        case "horizontal":
            return horizontal;
        default:
            return vertical || horizontal;
    }
}
function $3f69993268aa5b7a$var$isMainOrientationKey(key, orientation) {
    const vertical = key === $3f69993268aa5b7a$var$ARROW_UP || key === $3f69993268aa5b7a$var$ARROW_DOWN;
    const horizontal = key === $3f69993268aa5b7a$var$ARROW_LEFT || key === $3f69993268aa5b7a$var$ARROW_RIGHT;
    return $3f69993268aa5b7a$var$doSwitch(orientation, vertical, horizontal);
}
function $3f69993268aa5b7a$var$isMainOrientationToEndKey(key, orientation, rtl) {
    const vertical = key === $3f69993268aa5b7a$var$ARROW_DOWN;
    const horizontal = rtl ? key === $3f69993268aa5b7a$var$ARROW_LEFT : key === $3f69993268aa5b7a$var$ARROW_RIGHT;
    return $3f69993268aa5b7a$var$doSwitch(orientation, vertical, horizontal) || key === "Enter" || key === " " || key === "";
}
function $3f69993268aa5b7a$var$isCrossOrientationOpenKey(key, orientation, rtl) {
    const vertical = rtl ? key === $3f69993268aa5b7a$var$ARROW_LEFT : key === $3f69993268aa5b7a$var$ARROW_RIGHT;
    const horizontal = key === $3f69993268aa5b7a$var$ARROW_DOWN;
    return $3f69993268aa5b7a$var$doSwitch(orientation, vertical, horizontal);
}
function $3f69993268aa5b7a$var$isCrossOrientationCloseKey(key, orientation, rtl) {
    const vertical = rtl ? key === $3f69993268aa5b7a$var$ARROW_RIGHT : key === $3f69993268aa5b7a$var$ARROW_LEFT;
    const horizontal = key === $3f69993268aa5b7a$var$ARROW_UP;
    return $3f69993268aa5b7a$var$doSwitch(orientation, vertical, horizontal);
}
/**
 * Adds arrow key-based navigation of a list of items, either using real DOM
 * focus or virtual focus.
 * @see https://floating-ui.com/docs/useListNavigation
 */ function $3f69993268aa5b7a$export$b5d22cac4ad33f40(context, props) {
    const { open: open, onOpenChange: onOpenChange, elements: elements } = context;
    const { listRef: listRef, activeIndex: activeIndex, onNavigate: unstable_onNavigate = ()=>{}, enabled: enabled = true, selectedIndex: selectedIndex = null, allowEscape: allowEscape = false, loop: loop = false, nested: nested = false, rtl: rtl = false, virtual: virtual = false, focusItemOnOpen: focusItemOnOpen = "auto", focusItemOnHover: focusItemOnHover = true, openOnArrowKeyDown: openOnArrowKeyDown = true, disabledIndices: disabledIndices, orientation: orientation = "vertical", cols: cols = 1, scrollItemIntoView: scrollItemIntoView = true, virtualItemRef: virtualItemRef, itemSizes: itemSizes, dense: dense = false } = props;
    if (allowEscape) {
        if (!loop) $3f69993268aa5b7a$var$warn("`useListNavigation` looping must be enabled to allow escaping.");
        if (!virtual) $3f69993268aa5b7a$var$warn("`useListNavigation` must be virtual to allow escaping.");
    }
    if (orientation === "vertical" && cols > 1) $3f69993268aa5b7a$var$warn("In grid list navigation mode (`cols` > 1), the `orientation` should", 'be either "horizontal" or "both".');
    const floatingFocusElement = $3f69993268aa5b7a$var$getFloatingFocusElement(elements.floating);
    const floatingFocusElementRef = $3f69993268aa5b7a$var$useLatestRef(floatingFocusElement);
    const parentId = $3f69993268aa5b7a$export$165209eae06d3488();
    const tree = $3f69993268aa5b7a$export$db0c2a7c7a2a4f69();
    const onNavigate = $3f69993268aa5b7a$var$useEffectEvent(()=>{
        unstable_onNavigate(indexRef.current === -1 ? null : indexRef.current);
    });
    const typeableComboboxReference = (0, $34bc2325b4db944b$export$259ba5ae38188551)(elements.domReference);
    const focusItemOnOpenRef = $acw62.useRef(focusItemOnOpen);
    const indexRef = $acw62.useRef(selectedIndex != null ? selectedIndex : -1);
    const keyRef = $acw62.useRef(null);
    const isPointerModalityRef = $acw62.useRef(true);
    const previousOnNavigateRef = $acw62.useRef(onNavigate);
    const previousMountedRef = $acw62.useRef(!!elements.floating);
    const previousOpenRef = $acw62.useRef(open);
    const forceSyncFocusRef = $acw62.useRef(false);
    const forceScrollIntoViewRef = $acw62.useRef(false);
    const disabledIndicesRef = $3f69993268aa5b7a$var$useLatestRef(disabledIndices);
    const latestOpenRef = $3f69993268aa5b7a$var$useLatestRef(open);
    const scrollItemIntoViewRef = $3f69993268aa5b7a$var$useLatestRef(scrollItemIntoView);
    const selectedIndexRef = $3f69993268aa5b7a$var$useLatestRef(selectedIndex);
    const [activeId, setActiveId] = $acw62.useState();
    const [virtualId, setVirtualId] = $acw62.useState();
    const focusItem = $3f69993268aa5b7a$var$useEffectEvent(()=>{
        function runFocus(item) {
            if (virtual) {
                setActiveId(item.id);
                tree == null || tree.events.emit("virtualfocus", item);
                if (virtualItemRef) virtualItemRef.current = item;
            } else $3f69993268aa5b7a$var$enqueueFocus(item, {
                sync: forceSyncFocusRef.current,
                preventScroll: true
            });
        }
        const initialItem = listRef.current[indexRef.current];
        if (initialItem) runFocus(initialItem);
        const scheduler = forceSyncFocusRef.current ? (v)=>v() : requestAnimationFrame;
        scheduler(()=>{
            const waitedItem = listRef.current[indexRef.current] || initialItem;
            if (!waitedItem) return;
            if (!initialItem) runFocus(waitedItem);
            const scrollIntoViewOptions = scrollItemIntoViewRef.current;
            const shouldScrollIntoView = scrollIntoViewOptions && item && (forceScrollIntoViewRef.current || !isPointerModalityRef.current);
            if (shouldScrollIntoView) // JSDOM doesn't support `.scrollIntoView()` but it's widely supported
            // by all browsers.
            waitedItem.scrollIntoView == null || waitedItem.scrollIntoView(typeof scrollIntoViewOptions === "boolean" ? {
                block: "nearest",
                inline: "nearest"
            } : scrollIntoViewOptions);
        });
    });
    // Sync `selectedIndex` to be the `activeIndex` upon opening the floating
    // element. Also, reset `activeIndex` upon closing the floating element.
    $3f69993268aa5b7a$var$index(()=>{
        if (!enabled) return;
        if (open && elements.floating) {
            if (focusItemOnOpenRef.current && selectedIndex != null) {
                // Regardless of the pointer modality, we want to ensure the selected
                // item comes into view when the floating element is opened.
                forceScrollIntoViewRef.current = true;
                indexRef.current = selectedIndex;
                onNavigate();
            }
        } else if (previousMountedRef.current) {
            // Since the user can specify `onNavigate` conditionally
            // (onNavigate: open ? setActiveIndex : setSelectedIndex),
            // we store and call the previous function.
            indexRef.current = -1;
            previousOnNavigateRef.current();
        }
    }, [
        enabled,
        open,
        elements.floating,
        selectedIndex,
        onNavigate
    ]);
    // Sync `activeIndex` to be the focused item while the floating element is
    // open.
    $3f69993268aa5b7a$var$index(()=>{
        if (!enabled) return;
        if (!open) return;
        if (!elements.floating) return;
        if (activeIndex == null) {
            forceSyncFocusRef.current = false;
            if (selectedIndexRef.current != null) return;
            // Reset while the floating element was open (e.g. the list changed).
            if (previousMountedRef.current) {
                indexRef.current = -1;
                focusItem();
            }
            // Initial sync.
            if ((!previousOpenRef.current || !previousMountedRef.current) && focusItemOnOpenRef.current && (keyRef.current != null || focusItemOnOpenRef.current === true && keyRef.current == null)) {
                let runs = 0;
                const waitForListPopulated = ()=>{
                    if (listRef.current[0] == null) {
                        // Avoid letting the browser paint if possible on the first try,
                        // otherwise use rAF. Don't try more than twice, since something
                        // is wrong otherwise.
                        if (runs < 2) {
                            const scheduler = runs ? requestAnimationFrame : queueMicrotask;
                            scheduler(waitForListPopulated);
                        }
                        runs++;
                    } else {
                        indexRef.current = keyRef.current == null || $3f69993268aa5b7a$var$isMainOrientationToEndKey(keyRef.current, orientation, rtl) || nested ? $3f69993268aa5b7a$var$getMinIndex(listRef, disabledIndicesRef.current) : $3f69993268aa5b7a$var$getMaxIndex(listRef, disabledIndicesRef.current);
                        keyRef.current = null;
                        onNavigate();
                    }
                };
                waitForListPopulated();
            }
        } else if (!$3f69993268aa5b7a$var$isIndexOutOfBounds(listRef, activeIndex)) {
            indexRef.current = activeIndex;
            focusItem();
            forceScrollIntoViewRef.current = false;
        }
    }, [
        enabled,
        open,
        elements.floating,
        activeIndex,
        selectedIndexRef,
        nested,
        listRef,
        orientation,
        rtl,
        onNavigate,
        focusItem,
        disabledIndicesRef
    ]);
    // Ensure the parent floating element has focus when a nested child closes
    // to allow arrow key navigation to work after the pointer leaves the child.
    $3f69993268aa5b7a$var$index(()=>{
        var _nodes$find;
        if (!enabled || elements.floating || !tree || virtual || !previousMountedRef.current) return;
        const nodes = tree.nodesRef.current;
        const parent = (_nodes$find = nodes.find((node)=>node.id === parentId)) == null || (_nodes$find = _nodes$find.context) == null ? void 0 : _nodes$find.elements.floating;
        const activeEl = (0, $34bc2325b4db944b$export$da980962bd2147a4)((0, $34bc2325b4db944b$export$f65ca476c09acec0)(elements.floating));
        const treeContainsActiveEl = nodes.some((node)=>node.context && (0, $34bc2325b4db944b$export$2344b14b097df817)(node.context.elements.floating, activeEl));
        if (parent && !treeContainsActiveEl && isPointerModalityRef.current) parent.focus({
            preventScroll: true
        });
    }, [
        enabled,
        elements.floating,
        tree,
        parentId,
        virtual
    ]);
    $3f69993268aa5b7a$var$index(()=>{
        if (!enabled) return;
        if (!tree) return;
        if (!virtual) return;
        if (parentId) return;
        function handleVirtualFocus(item) {
            setVirtualId(item.id);
            if (virtualItemRef) virtualItemRef.current = item;
        }
        tree.events.on("virtualfocus", handleVirtualFocus);
        return ()=>{
            tree.events.off("virtualfocus", handleVirtualFocus);
        };
    }, [
        enabled,
        tree,
        virtual,
        parentId,
        virtualItemRef
    ]);
    $3f69993268aa5b7a$var$index(()=>{
        previousOnNavigateRef.current = onNavigate;
        previousOpenRef.current = open;
        previousMountedRef.current = !!elements.floating;
    });
    $3f69993268aa5b7a$var$index(()=>{
        if (!open) keyRef.current = null;
    }, [
        open
    ]);
    const hasActiveIndex = activeIndex != null;
    const item = $acw62.useMemo(()=>{
        function syncCurrentTarget(currentTarget) {
            if (!open) return;
            const index = listRef.current.indexOf(currentTarget);
            if (index !== -1 && indexRef.current !== index) {
                indexRef.current = index;
                onNavigate();
            }
        }
        const props = {
            onFocus (_ref) {
                let { currentTarget: currentTarget } = _ref;
                forceSyncFocusRef.current = true;
                syncCurrentTarget(currentTarget);
            },
            onClick: (_ref2)=>{
                let { currentTarget: currentTarget } = _ref2;
                return currentTarget.focus({
                    preventScroll: true
                });
            },
            // Safari
            ...focusItemOnHover && {
                onMouseMove (_ref3) {
                    let { currentTarget: currentTarget } = _ref3;
                    forceSyncFocusRef.current = true;
                    forceScrollIntoViewRef.current = false;
                    syncCurrentTarget(currentTarget);
                },
                onPointerLeave (_ref4) {
                    let { pointerType: pointerType } = _ref4;
                    if (!isPointerModalityRef.current || pointerType === "touch") return;
                    forceSyncFocusRef.current = true;
                    indexRef.current = -1;
                    onNavigate();
                    if (!virtual) {
                        var _floatingFocusElement;
                        (_floatingFocusElement = floatingFocusElementRef.current) == null || _floatingFocusElement.focus({
                            preventScroll: true
                        });
                    }
                }
            }
        };
        return props;
    }, [
        open,
        floatingFocusElementRef,
        focusItemOnHover,
        listRef,
        onNavigate,
        virtual
    ]);
    const commonOnKeyDown = $3f69993268aa5b7a$var$useEffectEvent((event)=>{
        isPointerModalityRef.current = false;
        forceSyncFocusRef.current = true;
        // When composing a character, Chrome fires ArrowDown twice. Firefox/Safari
        // don't appear to suffer from this. `event.isComposing` is avoided due to
        // Safari not supporting it properly (although it's not needed in the first
        // place for Safari, just avoiding any possible issues).
        if (event.which === 229) return;
        // If the floating element is animating out, ignore navigation. Otherwise,
        // the `activeIndex` gets set to 0 despite not being open so the next time
        // the user ArrowDowns, the first item won't be focused.
        if (!latestOpenRef.current && event.currentTarget === floatingFocusElementRef.current) return;
        if (nested && $3f69993268aa5b7a$var$isCrossOrientationCloseKey(event.key, orientation, rtl)) {
            (0, $34bc2325b4db944b$export$7ae4cd3a66c1e050)(event);
            onOpenChange(false, event.nativeEvent, "list-navigation");
            if ((0, $238ac70369f38756$export$1b3bfaa9684536aa)(elements.domReference)) {
                if (virtual) tree == null || tree.events.emit("virtualfocus", elements.domReference);
                else elements.domReference.focus();
            }
            return;
        }
        const currentIndex = indexRef.current;
        const minIndex = $3f69993268aa5b7a$var$getMinIndex(listRef, disabledIndices);
        const maxIndex = $3f69993268aa5b7a$var$getMaxIndex(listRef, disabledIndices);
        if (!typeableComboboxReference) {
            if (event.key === "Home") {
                (0, $34bc2325b4db944b$export$7ae4cd3a66c1e050)(event);
                indexRef.current = minIndex;
                onNavigate();
            }
            if (event.key === "End") {
                (0, $34bc2325b4db944b$export$7ae4cd3a66c1e050)(event);
                indexRef.current = maxIndex;
                onNavigate();
            }
        }
        // Grid navigation.
        if (cols > 1) {
            const sizes = itemSizes || Array.from({
                length: listRef.current.length
            }, ()=>({
                    width: 1,
                    height: 1
                }));
            // To calculate movements on the grid, we use hypothetical cell indices
            // as if every item was 1x1, then convert back to real indices.
            const cellMap = $3f69993268aa5b7a$var$buildCellMap(sizes, cols, dense);
            const minGridIndex = cellMap.findIndex((index)=>index != null && !$3f69993268aa5b7a$var$isDisabled(listRef.current, index, disabledIndices));
            // last enabled index
            const maxGridIndex = cellMap.reduce((foundIndex, index, cellIndex)=>index != null && !$3f69993268aa5b7a$var$isDisabled(listRef.current, index, disabledIndices) ? cellIndex : foundIndex, -1);
            const index = cellMap[$3f69993268aa5b7a$var$getGridNavigatedIndex({
                current: cellMap.map((itemIndex)=>itemIndex != null ? listRef.current[itemIndex] : null)
            }, {
                event: event,
                orientation: orientation,
                loop: loop,
                rtl: rtl,
                cols: cols,
                // treat undefined (empty grid spaces) as disabled indices so we
                // don't end up in them
                disabledIndices: $3f69993268aa5b7a$var$getCellIndices([
                    ...disabledIndices || listRef.current.map((_, index)=>$3f69993268aa5b7a$var$isDisabled(listRef.current, index) ? index : undefined),
                    undefined
                ], cellMap),
                minIndex: minGridIndex,
                maxIndex: maxGridIndex,
                prevIndex: $3f69993268aa5b7a$var$getCellIndexOfCorner(indexRef.current > maxIndex ? minIndex : indexRef.current, sizes, cellMap, cols, // use a corner matching the edge closest to the direction
                // we're moving in so we don't end up in the same item. Prefer
                // top/left over bottom/right.
                event.key === $3f69993268aa5b7a$var$ARROW_DOWN ? "bl" : event.key === (rtl ? $3f69993268aa5b7a$var$ARROW_LEFT : $3f69993268aa5b7a$var$ARROW_RIGHT) ? "tr" : "tl"),
                stopEvent: true
            })];
            if (index != null) {
                indexRef.current = index;
                onNavigate();
            }
            if (orientation === "both") return;
        }
        if ($3f69993268aa5b7a$var$isMainOrientationKey(event.key, orientation)) {
            (0, $34bc2325b4db944b$export$7ae4cd3a66c1e050)(event);
            // Reset the index if no item is focused.
            if (open && !virtual && (0, $34bc2325b4db944b$export$da980962bd2147a4)(event.currentTarget.ownerDocument) === event.currentTarget) {
                indexRef.current = $3f69993268aa5b7a$var$isMainOrientationToEndKey(event.key, orientation, rtl) ? minIndex : maxIndex;
                onNavigate();
                return;
            }
            if ($3f69993268aa5b7a$var$isMainOrientationToEndKey(event.key, orientation, rtl)) {
                if (loop) indexRef.current = currentIndex >= maxIndex ? allowEscape && currentIndex !== listRef.current.length ? -1 : minIndex : $3f69993268aa5b7a$var$findNonDisabledIndex(listRef, {
                    startingIndex: currentIndex,
                    disabledIndices: disabledIndices
                });
                else indexRef.current = Math.min(maxIndex, $3f69993268aa5b7a$var$findNonDisabledIndex(listRef, {
                    startingIndex: currentIndex,
                    disabledIndices: disabledIndices
                }));
            } else if (loop) indexRef.current = currentIndex <= minIndex ? allowEscape && currentIndex !== -1 ? listRef.current.length : maxIndex : $3f69993268aa5b7a$var$findNonDisabledIndex(listRef, {
                startingIndex: currentIndex,
                decrement: true,
                disabledIndices: disabledIndices
            });
            else indexRef.current = Math.max(minIndex, $3f69993268aa5b7a$var$findNonDisabledIndex(listRef, {
                startingIndex: currentIndex,
                decrement: true,
                disabledIndices: disabledIndices
            }));
            if ($3f69993268aa5b7a$var$isIndexOutOfBounds(listRef, indexRef.current)) indexRef.current = -1;
            onNavigate();
        }
    });
    const ariaActiveDescendantProp = $acw62.useMemo(()=>{
        return virtual && open && hasActiveIndex && {
            "aria-activedescendant": virtualId || activeId
        };
    }, [
        virtual,
        open,
        hasActiveIndex,
        virtualId,
        activeId
    ]);
    const floating = $acw62.useMemo(()=>{
        return {
            "aria-orientation": orientation === "both" ? undefined : orientation,
            ...!typeableComboboxReference ? ariaActiveDescendantProp : {},
            onKeyDown: commonOnKeyDown,
            onPointerMove () {
                isPointerModalityRef.current = true;
            }
        };
    }, [
        ariaActiveDescendantProp,
        commonOnKeyDown,
        orientation,
        typeableComboboxReference
    ]);
    const reference = $acw62.useMemo(()=>{
        function checkVirtualMouse(event) {
            if (focusItemOnOpen === "auto" && (0, $34bc2325b4db944b$export$60278871457622de)(event.nativeEvent)) focusItemOnOpenRef.current = true;
        }
        function checkVirtualPointer(event) {
            // `pointerdown` fires first, reset the state then perform the checks.
            focusItemOnOpenRef.current = focusItemOnOpen;
            if (focusItemOnOpen === "auto" && (0, $34bc2325b4db944b$export$29bf1b5f2c56cf63)(event.nativeEvent)) focusItemOnOpenRef.current = true;
        }
        return {
            ...ariaActiveDescendantProp,
            onKeyDown (event) {
                isPointerModalityRef.current = false;
                const isArrowKey = event.key.startsWith("Arrow");
                const isHomeOrEndKey = [
                    "Home",
                    "End"
                ].includes(event.key);
                const isMoveKey = isArrowKey || isHomeOrEndKey;
                const isCrossOpenKey = $3f69993268aa5b7a$var$isCrossOrientationOpenKey(event.key, orientation, rtl);
                const isCrossCloseKey = $3f69993268aa5b7a$var$isCrossOrientationCloseKey(event.key, orientation, rtl);
                const isMainKey = $3f69993268aa5b7a$var$isMainOrientationKey(event.key, orientation);
                const isNavigationKey = (nested ? isCrossOpenKey : isMainKey) || event.key === "Enter" || event.key.trim() === "";
                if (virtual && open) {
                    const rootNode = tree == null ? void 0 : tree.nodesRef.current.find((node)=>node.parentId == null);
                    const deepestNode = tree && rootNode ? $3f69993268aa5b7a$var$getDeepestNode(tree.nodesRef.current, rootNode.id) : null;
                    if (isMoveKey && deepestNode && virtualItemRef) {
                        const eventObject = new KeyboardEvent("keydown", {
                            key: event.key,
                            bubbles: true
                        });
                        if (isCrossOpenKey || isCrossCloseKey) {
                            var _deepestNode$context, _deepestNode$context2;
                            const isCurrentTarget = ((_deepestNode$context = deepestNode.context) == null ? void 0 : _deepestNode$context.elements.domReference) === event.currentTarget;
                            const dispatchItem = isCrossCloseKey && !isCurrentTarget ? (_deepestNode$context2 = deepestNode.context) == null ? void 0 : _deepestNode$context2.elements.domReference : isCrossOpenKey ? listRef.current.find((item)=>(item == null ? void 0 : item.id) === activeId) : null;
                            if (dispatchItem) {
                                (0, $34bc2325b4db944b$export$7ae4cd3a66c1e050)(event);
                                dispatchItem.dispatchEvent(eventObject);
                                setVirtualId(undefined);
                            }
                        }
                        if ((isMainKey || isHomeOrEndKey) && deepestNode.context) {
                            if (deepestNode.context.open && deepestNode.parentId && event.currentTarget !== deepestNode.context.elements.domReference) {
                                var _deepestNode$context$;
                                (0, $34bc2325b4db944b$export$7ae4cd3a66c1e050)(event);
                                (_deepestNode$context$ = deepestNode.context.elements.domReference) == null || _deepestNode$context$.dispatchEvent(eventObject);
                                return;
                            }
                        }
                    }
                    return commonOnKeyDown(event);
                }
                // If a floating element should not open on arrow key down, avoid
                // setting `activeIndex` while it's closed.
                if (!open && !openOnArrowKeyDown && isArrowKey) return;
                if (isNavigationKey) keyRef.current = nested && isMainKey ? null : event.key;
                if (nested) {
                    if (isCrossOpenKey) {
                        (0, $34bc2325b4db944b$export$7ae4cd3a66c1e050)(event);
                        if (open) {
                            indexRef.current = $3f69993268aa5b7a$var$getMinIndex(listRef, disabledIndicesRef.current);
                            onNavigate();
                        } else onOpenChange(true, event.nativeEvent, "list-navigation");
                    }
                    return;
                }
                if (isMainKey) {
                    if (selectedIndex != null) indexRef.current = selectedIndex;
                    (0, $34bc2325b4db944b$export$7ae4cd3a66c1e050)(event);
                    if (!open && openOnArrowKeyDown) onOpenChange(true, event.nativeEvent, "list-navigation");
                    else commonOnKeyDown(event);
                    if (open) onNavigate();
                }
            },
            onFocus () {
                if (open && !virtual) {
                    indexRef.current = -1;
                    onNavigate();
                }
            },
            onPointerDown: checkVirtualPointer,
            onPointerEnter: checkVirtualPointer,
            onMouseDown: checkVirtualMouse,
            onClick: checkVirtualMouse
        };
    }, [
        activeId,
        ariaActiveDescendantProp,
        commonOnKeyDown,
        disabledIndicesRef,
        focusItemOnOpen,
        listRef,
        nested,
        onNavigate,
        onOpenChange,
        open,
        openOnArrowKeyDown,
        orientation,
        rtl,
        selectedIndex,
        tree,
        virtual,
        virtualItemRef
    ]);
    return $acw62.useMemo(()=>enabled ? {
            reference: reference,
            floating: floating,
            item: item
        } : {}, [
        enabled,
        reference,
        floating,
        item
    ]);
}
const $3f69993268aa5b7a$var$componentRoleToAriaRoleMap = /*#__PURE__*/ new Map([
    [
        "select",
        "listbox"
    ],
    [
        "combobox",
        "listbox"
    ],
    [
        "label",
        false
    ]
]);
/**
 * Adds base screen reader props to the reference and floating elements for a
 * given floating element `role`.
 * @see https://floating-ui.com/docs/useRole
 */ function $3f69993268aa5b7a$export$f66572793fa256a1(context, props) {
    var _componentRoleToAriaR;
    if (props === void 0) props = {};
    const { open: open, floatingId: floatingId } = context;
    const { enabled: enabled = true, role: role = "dialog" } = props;
    const ariaRole = (_componentRoleToAriaR = $3f69993268aa5b7a$var$componentRoleToAriaRoleMap.get(role)) != null ? _componentRoleToAriaR : role;
    const referenceId = $3f69993268aa5b7a$export$f680877a34711e37();
    const parentId = $3f69993268aa5b7a$export$165209eae06d3488();
    const isNested = parentId != null;
    const reference = $acw62.useMemo(()=>{
        if (ariaRole === "tooltip" || role === "label") return {
            ["aria-" + (role === "label" ? "labelledby" : "describedby")]: open ? floatingId : undefined
        };
        return {
            "aria-expanded": open ? "true" : "false",
            "aria-haspopup": ariaRole === "alertdialog" ? "dialog" : ariaRole,
            "aria-controls": open ? floatingId : undefined,
            ...ariaRole === "listbox" && {
                role: "combobox"
            },
            ...ariaRole === "menu" && {
                id: referenceId
            },
            ...ariaRole === "menu" && isNested && {
                role: "menuitem"
            },
            ...role === "select" && {
                "aria-autocomplete": "none"
            },
            ...role === "combobox" && {
                "aria-autocomplete": "list"
            }
        };
    }, [
        ariaRole,
        floatingId,
        isNested,
        open,
        referenceId,
        role
    ]);
    const floating = $acw62.useMemo(()=>{
        const floatingProps = {
            id: floatingId,
            ...ariaRole && {
                role: ariaRole
            }
        };
        if (ariaRole === "tooltip" || role === "label") return floatingProps;
        return {
            ...floatingProps,
            ...ariaRole === "menu" && {
                "aria-labelledby": referenceId
            }
        };
    }, [
        ariaRole,
        floatingId,
        referenceId,
        role
    ]);
    const item = $acw62.useCallback((_ref)=>{
        let { active: active, selected: selected } = _ref;
        const commonProps = {
            role: "option",
            ...active && {
                id: floatingId + "-option"
            }
        };
        // For `menu`, we are unable to tell if the item is a `menuitemradio`
        // or `menuitemcheckbox`. For backwards-compatibility reasons, also
        // avoid defaulting to `menuitem` as it may overwrite custom role props.
        switch(role){
            case "select":
                return {
                    ...commonProps,
                    "aria-selected": active && selected
                };
            case "combobox":
                return {
                    ...commonProps,
                    ...active && {
                        "aria-selected": true
                    }
                };
        }
        return {};
    }, [
        floatingId,
        role
    ]);
    return $acw62.useMemo(()=>enabled ? {
            reference: reference,
            floating: floating,
            item: item
        } : {}, [
        enabled,
        reference,
        floating,
        item
    ]);
}
// Converts a JS style key like `backgroundColor` to a CSS transition-property
// like `background-color`.
const $3f69993268aa5b7a$var$camelCaseToKebabCase = (str)=>str.replace(/[A-Z]+(?![a-z])|[A-Z]/g, ($, ofs)=>(ofs ? "-" : "") + $.toLowerCase());
function $3f69993268aa5b7a$var$execWithArgsOrReturn(valueOrFn, args) {
    return typeof valueOrFn === "function" ? valueOrFn(args) : valueOrFn;
}
function $3f69993268aa5b7a$var$useDelayUnmount(open, durationMs) {
    const [isMounted, setIsMounted] = $acw62.useState(open);
    if (open && !isMounted) setIsMounted(true);
    $acw62.useEffect(()=>{
        if (!open && isMounted) {
            const timeout = setTimeout(()=>setIsMounted(false), durationMs);
            return ()=>clearTimeout(timeout);
        }
    }, [
        open,
        isMounted,
        durationMs
    ]);
    return isMounted;
}
/**
 * Provides a status string to apply CSS transitions to a floating element,
 * correctly handling placement-aware transitions.
 * @see https://floating-ui.com/docs/useTransition#usetransitionstatus
 */ function $3f69993268aa5b7a$export$b2ef21706733f7e5(context, props) {
    if (props === void 0) props = {};
    const { open: open, elements: { floating: floating } } = context;
    const { duration: duration = 250 } = props;
    const isNumberDuration = typeof duration === "number";
    const closeDuration = (isNumberDuration ? duration : duration.close) || 0;
    const [status, setStatus] = $acw62.useState("unmounted");
    const isMounted = $3f69993268aa5b7a$var$useDelayUnmount(open, closeDuration);
    if (!isMounted && status === "close") setStatus("unmounted");
    $3f69993268aa5b7a$var$index(()=>{
        if (!floating) return;
        if (open) {
            setStatus("initial");
            const frame = requestAnimationFrame(()=>{
                setStatus("open");
            });
            return ()=>{
                cancelAnimationFrame(frame);
            };
        }
        setStatus("close");
    }, [
        open,
        floating
    ]);
    return {
        isMounted: isMounted,
        status: status
    };
}
/**
 * Provides styles to apply CSS transitions to a floating element, correctly
 * handling placement-aware transitions. Wrapper around `useTransitionStatus`.
 * @see https://floating-ui.com/docs/useTransition#usetransitionstyles
 */ function $3f69993268aa5b7a$export$769fba13884bc2f4(context, props) {
    if (props === void 0) props = {};
    const { initial: unstable_initial = {
        opacity: 0
    }, open: unstable_open, close: unstable_close, common: unstable_common, duration: duration = 250 } = props;
    const placement = context.placement;
    const side = placement.split("-")[0];
    const fnArgs = $acw62.useMemo(()=>({
            side: side,
            placement: placement
        }), [
        side,
        placement
    ]);
    const isNumberDuration = typeof duration === "number";
    const openDuration = (isNumberDuration ? duration : duration.open) || 0;
    const closeDuration = (isNumberDuration ? duration : duration.close) || 0;
    const [styles, setStyles] = $acw62.useState(()=>({
            ...$3f69993268aa5b7a$var$execWithArgsOrReturn(unstable_common, fnArgs),
            ...$3f69993268aa5b7a$var$execWithArgsOrReturn(unstable_initial, fnArgs)
        }));
    const { isMounted: isMounted, status: status } = $3f69993268aa5b7a$export$b2ef21706733f7e5(context, {
        duration: duration
    });
    const initialRef = $3f69993268aa5b7a$var$useLatestRef(unstable_initial);
    const openRef = $3f69993268aa5b7a$var$useLatestRef(unstable_open);
    const closeRef = $3f69993268aa5b7a$var$useLatestRef(unstable_close);
    const commonRef = $3f69993268aa5b7a$var$useLatestRef(unstable_common);
    $3f69993268aa5b7a$var$index(()=>{
        const initialStyles = $3f69993268aa5b7a$var$execWithArgsOrReturn(initialRef.current, fnArgs);
        const closeStyles = $3f69993268aa5b7a$var$execWithArgsOrReturn(closeRef.current, fnArgs);
        const commonStyles = $3f69993268aa5b7a$var$execWithArgsOrReturn(commonRef.current, fnArgs);
        const openStyles = $3f69993268aa5b7a$var$execWithArgsOrReturn(openRef.current, fnArgs) || Object.keys(initialStyles).reduce((acc, key)=>{
            acc[key] = "";
            return acc;
        }, {});
        if (status === "initial") setStyles((styles)=>({
                transitionProperty: styles.transitionProperty,
                ...commonStyles,
                ...initialStyles
            }));
        if (status === "open") setStyles({
            transitionProperty: Object.keys(openStyles).map($3f69993268aa5b7a$var$camelCaseToKebabCase).join(","),
            transitionDuration: openDuration + "ms",
            ...commonStyles,
            ...openStyles
        });
        if (status === "close") {
            const styles = closeStyles || initialStyles;
            setStyles({
                transitionProperty: Object.keys(styles).map($3f69993268aa5b7a$var$camelCaseToKebabCase).join(","),
                transitionDuration: closeDuration + "ms",
                ...commonStyles,
                ...styles
            });
        }
    }, [
        closeDuration,
        closeRef,
        initialRef,
        openRef,
        commonRef,
        openDuration,
        status,
        fnArgs
    ]);
    return {
        isMounted: isMounted,
        styles: styles
    };
}
/**
 * Provides a matching callback that can be used to focus an item as the user
 * types, often used in tandem with `useListNavigation()`.
 * @see https://floating-ui.com/docs/useTypeahead
 */ function $3f69993268aa5b7a$export$d8d674d50b73ba93(context, props) {
    var _ref;
    const { open: open, dataRef: dataRef } = context;
    const { listRef: listRef, activeIndex: activeIndex, onMatch: unstable_onMatch, onTypingChange: unstable_onTypingChange, enabled: enabled = true, findMatch: findMatch = null, resetMs: resetMs = 750, ignoreKeys: ignoreKeys = [], selectedIndex: selectedIndex = null } = props;
    const timeoutIdRef = $acw62.useRef();
    const stringRef = $acw62.useRef("");
    const prevIndexRef = $acw62.useRef((_ref = selectedIndex != null ? selectedIndex : activeIndex) != null ? _ref : -1);
    const matchIndexRef = $acw62.useRef(null);
    const onMatch = $3f69993268aa5b7a$var$useEffectEvent(unstable_onMatch);
    const onTypingChange = $3f69993268aa5b7a$var$useEffectEvent(unstable_onTypingChange);
    const findMatchRef = $3f69993268aa5b7a$var$useLatestRef(findMatch);
    const ignoreKeysRef = $3f69993268aa5b7a$var$useLatestRef(ignoreKeys);
    $3f69993268aa5b7a$var$index(()=>{
        if (open) {
            clearTimeout(timeoutIdRef.current);
            matchIndexRef.current = null;
            stringRef.current = "";
        }
    }, [
        open
    ]);
    $3f69993268aa5b7a$var$index(()=>{
        // Sync arrow key navigation but not typeahead navigation.
        if (open && stringRef.current === "") {
            var _ref2;
            prevIndexRef.current = (_ref2 = selectedIndex != null ? selectedIndex : activeIndex) != null ? _ref2 : -1;
        }
    }, [
        open,
        selectedIndex,
        activeIndex
    ]);
    const setTypingChange = $3f69993268aa5b7a$var$useEffectEvent((value)=>{
        if (value) {
            if (!dataRef.current.typing) {
                dataRef.current.typing = value;
                onTypingChange(value);
            }
        } else if (dataRef.current.typing) {
            dataRef.current.typing = value;
            onTypingChange(value);
        }
    });
    const onKeyDown = $3f69993268aa5b7a$var$useEffectEvent((event)=>{
        function getMatchingIndex(list, orderedList, string) {
            const str = findMatchRef.current ? findMatchRef.current(orderedList, string) : orderedList.find((text)=>(text == null ? void 0 : text.toLocaleLowerCase().indexOf(string.toLocaleLowerCase())) === 0);
            return str ? list.indexOf(str) : -1;
        }
        const listContent = listRef.current;
        if (stringRef.current.length > 0 && stringRef.current[0] !== " ") {
            if (getMatchingIndex(listContent, listContent, stringRef.current) === -1) setTypingChange(false);
            else if (event.key === " ") (0, $34bc2325b4db944b$export$7ae4cd3a66c1e050)(event);
        }
        if (listContent == null || ignoreKeysRef.current.includes(event.key) || // Character key.
        event.key.length !== 1 || // Modifier key.
        event.ctrlKey || event.metaKey || event.altKey) return;
        if (open && event.key !== " ") {
            (0, $34bc2325b4db944b$export$7ae4cd3a66c1e050)(event);
            setTypingChange(true);
        }
        // Bail out if the list contains a word like "llama" or "aaron". TODO:
        // allow it in this case, too.
        const allowRapidSuccessionOfFirstLetter = listContent.every((text)=>{
            var _text$, _text$2;
            return text ? ((_text$ = text[0]) == null ? void 0 : _text$.toLocaleLowerCase()) !== ((_text$2 = text[1]) == null ? void 0 : _text$2.toLocaleLowerCase()) : true;
        });
        // Allows the user to cycle through items that start with the same letter
        // in rapid succession.
        if (allowRapidSuccessionOfFirstLetter && stringRef.current === event.key) {
            stringRef.current = "";
            prevIndexRef.current = matchIndexRef.current;
        }
        stringRef.current += event.key;
        clearTimeout(timeoutIdRef.current);
        timeoutIdRef.current = setTimeout(()=>{
            stringRef.current = "";
            prevIndexRef.current = matchIndexRef.current;
            setTypingChange(false);
        }, resetMs);
        const prevIndex = prevIndexRef.current;
        const index = getMatchingIndex(listContent, [
            ...listContent.slice((prevIndex || 0) + 1),
            ...listContent.slice(0, (prevIndex || 0) + 1)
        ], stringRef.current);
        if (index !== -1) {
            onMatch(index);
            matchIndexRef.current = index;
        } else if (event.key !== " ") {
            stringRef.current = "";
            setTypingChange(false);
        }
    });
    const reference = $acw62.useMemo(()=>({
            onKeyDown: onKeyDown
        }), [
        onKeyDown
    ]);
    const floating = $acw62.useMemo(()=>{
        return {
            onKeyDown: onKeyDown,
            onKeyUp (event) {
                if (event.key === " ") setTypingChange(false);
            }
        };
    }, [
        onKeyDown,
        setTypingChange
    ]);
    return $acw62.useMemo(()=>enabled ? {
            reference: reference,
            floating: floating
        } : {}, [
        enabled,
        reference,
        floating
    ]);
}
function $3f69993268aa5b7a$var$getArgsWithCustomFloatingHeight(state, height) {
    return {
        ...state,
        rects: {
            ...state.rects,
            floating: {
                ...state.rects.floating,
                height: height
            }
        }
    };
}
/**
 * Positions the floating element such that an inner element inside of it is
 * anchored to the reference element.
 * @see https://floating-ui.com/docs/inner
 * @deprecated
 */ const $3f69993268aa5b7a$export$4ae363f1d88fb658 = (props)=>({
        name: "inner",
        options: props,
        async fn (state) {
            const { listRef: listRef, overflowRef: overflowRef, onFallbackChange: onFallbackChange, offset: innerOffset = 0, index: index = 0, minItemsVisible: minItemsVisible = 4, referenceOverflowThreshold: referenceOverflowThreshold = 0, scrollRef: scrollRef, ...detectOverflowOptions } = (0, $10310cf078d13212$export$fef61f332f2c0afc)(props, state);
            const { rects: rects, elements: { floating: floating } } = state;
            const item = listRef.current[index];
            const scrollEl = (scrollRef == null ? void 0 : scrollRef.current) || floating;
            // Valid combinations:
            // 1. Floating element is the scrollRef and has a border (default)
            // 2. Floating element is not the scrollRef, floating element has a border
            // 3. Floating element is not the scrollRef, scrollRef has a border
            // Floating > {...getFloatingProps()} wrapper > scrollRef > items is not
            // allowed as VoiceOver doesn't work.
            const clientTop = floating.clientTop || scrollEl.clientTop;
            const floatingIsBordered = floating.clientTop !== 0;
            const scrollElIsBordered = scrollEl.clientTop !== 0;
            const floatingIsScrollEl = floating === scrollEl;
            if (!state.placement.startsWith("bottom")) $3f69993268aa5b7a$var$warn('`placement` side must be "bottom" when using the `inner`', "middleware.");
            if (!item) return {};
            const nextArgs = {
                ...state,
                ...await (0, $23a8f689f1d4c3be$export$cc800923e997bb8)(-item.offsetTop - floating.clientTop - rects.reference.height / 2 - item.offsetHeight / 2 - innerOffset).fn(state)
            };
            const overflow = await (0, $973e4da43f2a375d$export$37b6bde19b108ecc)($3f69993268aa5b7a$var$getArgsWithCustomFloatingHeight(nextArgs, scrollEl.scrollHeight + clientTop + floating.clientTop), detectOverflowOptions);
            const refOverflow = await (0, $973e4da43f2a375d$export$37b6bde19b108ecc)(nextArgs, {
                ...detectOverflowOptions,
                elementContext: "reference"
            });
            const diffY = (0, $10310cf078d13212$export$8960430cfd85939f)(0, overflow.top);
            const nextY = nextArgs.y + diffY;
            const isScrollable = scrollEl.scrollHeight > scrollEl.clientHeight;
            const rounder = isScrollable ? (v)=>v : (0, $10310cf078d13212$export$2077e0241d6afd3c);
            const maxHeight = rounder((0, $10310cf078d13212$export$8960430cfd85939f)(0, scrollEl.scrollHeight + (floatingIsBordered && floatingIsScrollEl || scrollElIsBordered ? clientTop * 2 : 0) - diffY - (0, $10310cf078d13212$export$8960430cfd85939f)(0, overflow.bottom)));
            scrollEl.style.maxHeight = maxHeight + "px";
            scrollEl.scrollTop = diffY;
            // There is not enough space, fallback to standard anchored positioning
            if (onFallbackChange) {
                const shouldFallback = scrollEl.offsetHeight < item.offsetHeight * (0, $10310cf078d13212$export$96ec731ed4dcb222)(minItemsVisible, listRef.current.length) - 1 || refOverflow.top >= -referenceOverflowThreshold || refOverflow.bottom >= -referenceOverflowThreshold;
                $1u0KT.flushSync(()=>onFallbackChange(shouldFallback));
            }
            if (overflowRef) overflowRef.current = await (0, $973e4da43f2a375d$export$37b6bde19b108ecc)($3f69993268aa5b7a$var$getArgsWithCustomFloatingHeight({
                ...nextArgs,
                y: nextY
            }, scrollEl.offsetHeight + clientTop + floating.clientTop), detectOverflowOptions);
            return {
                y: nextY
            };
        }
    });
/**
 * Changes the `inner` middleware's `offset` upon a `wheel` event to
 * expand the floating element's height, revealing more list items.
 * @see https://floating-ui.com/docs/inner
 * @deprecated
 */ function $3f69993268aa5b7a$export$3d74b0dda7cc82ff(context, props) {
    const { open: open, elements: elements } = context;
    const { enabled: enabled = true, overflowRef: overflowRef, scrollRef: scrollRef, onChange: unstable_onChange } = props;
    const onChange = $3f69993268aa5b7a$var$useEffectEvent(unstable_onChange);
    const controlledScrollingRef = $acw62.useRef(false);
    const prevScrollTopRef = $acw62.useRef(null);
    const initialOverflowRef = $acw62.useRef(null);
    $acw62.useEffect(()=>{
        if (!enabled) return;
        function onWheel(e) {
            if (e.ctrlKey || !el || overflowRef.current == null) return;
            const dY = e.deltaY;
            const isAtTop = overflowRef.current.top >= -0.5;
            const isAtBottom = overflowRef.current.bottom >= -0.5;
            const remainingScroll = el.scrollHeight - el.clientHeight;
            const sign = dY < 0 ? -1 : 1;
            const method = dY < 0 ? "max" : "min";
            if (el.scrollHeight <= el.clientHeight) return;
            if (!isAtTop && dY > 0 || !isAtBottom && dY < 0) {
                e.preventDefault();
                $1u0KT.flushSync(()=>{
                    onChange((d)=>d + Math[method](dY, remainingScroll * sign));
                });
            } else if (/firefox/i.test((0, $34bc2325b4db944b$export$7935961ef7719cb0)())) // Needed to propagate scrolling during momentum scrolling phase once
            // it gets limited by the boundary. UX improvement, not critical.
            el.scrollTop += dY;
        }
        const el = (scrollRef == null ? void 0 : scrollRef.current) || elements.floating;
        if (open && el) {
            el.addEventListener("wheel", onWheel);
            // Wait for the position to be ready.
            requestAnimationFrame(()=>{
                prevScrollTopRef.current = el.scrollTop;
                if (overflowRef.current != null) initialOverflowRef.current = {
                    ...overflowRef.current
                };
            });
            return ()=>{
                prevScrollTopRef.current = null;
                initialOverflowRef.current = null;
                el.removeEventListener("wheel", onWheel);
            };
        }
    }, [
        enabled,
        open,
        elements.floating,
        overflowRef,
        scrollRef,
        onChange
    ]);
    const floating = $acw62.useMemo(()=>({
            onKeyDown () {
                controlledScrollingRef.current = true;
            },
            onWheel () {
                controlledScrollingRef.current = false;
            },
            onPointerMove () {
                controlledScrollingRef.current = false;
            },
            onScroll () {
                const el = (scrollRef == null ? void 0 : scrollRef.current) || elements.floating;
                if (!overflowRef.current || !el || !controlledScrollingRef.current) return;
                if (prevScrollTopRef.current !== null) {
                    const scrollDiff = el.scrollTop - prevScrollTopRef.current;
                    if (overflowRef.current.bottom < -0.5 && scrollDiff < -1 || overflowRef.current.top < -0.5 && scrollDiff > 1) $1u0KT.flushSync(()=>onChange((d)=>d + scrollDiff));
                }
                // [Firefox] Wait for the height change to have been applied.
                requestAnimationFrame(()=>{
                    prevScrollTopRef.current = el.scrollTop;
                });
            }
        }), [
        elements.floating,
        onChange,
        overflowRef,
        scrollRef
    ]);
    return $acw62.useMemo(()=>enabled ? {
            floating: floating
        } : {}, [
        enabled,
        floating
    ]);
}
function $3f69993268aa5b7a$var$isPointInPolygon(point, polygon) {
    const [x, y] = point;
    let isInside = false;
    const length = polygon.length;
    for(let i = 0, j = length - 1; i < length; j = i++){
        const [xi, yi] = polygon[i] || [
            0,
            0
        ];
        const [xj, yj] = polygon[j] || [
            0,
            0
        ];
        const intersect = yi >= y !== yj >= y && x <= (xj - xi) * (y - yi) / (yj - yi) + xi;
        if (intersect) isInside = !isInside;
    }
    return isInside;
}
function $3f69993268aa5b7a$var$isInside(point, rect) {
    return point[0] >= rect.x && point[0] <= rect.x + rect.width && point[1] >= rect.y && point[1] <= rect.y + rect.height;
}
/**
 * Generates a safe polygon area that the user can traverse without closing the
 * floating element once leaving the reference element.
 * @see https://floating-ui.com/docs/useHover#safepolygon
 */ function $3f69993268aa5b7a$export$7484214ab62358d2(options) {
    if (options === void 0) options = {};
    const { buffer: buffer = 0.5, blockPointerEvents: blockPointerEvents = false, requireIntent: requireIntent = true } = options;
    let timeoutId;
    let hasLanded = false;
    let lastX = null;
    let lastY = null;
    let lastCursorTime = performance.now();
    function getCursorSpeed(x, y) {
        const currentTime = performance.now();
        const elapsedTime = currentTime - lastCursorTime;
        if (lastX === null || lastY === null || elapsedTime === 0) {
            lastX = x;
            lastY = y;
            lastCursorTime = currentTime;
            return null;
        }
        const deltaX = x - lastX;
        const deltaY = y - lastY;
        const distance = Math.sqrt(deltaX * deltaX + deltaY * deltaY);
        const speed = distance / elapsedTime; // px / ms
        lastX = x;
        lastY = y;
        lastCursorTime = currentTime;
        return speed;
    }
    const fn = (_ref)=>{
        let { x: x, y: y, placement: placement, elements: elements, onClose: onClose, nodeId: nodeId, tree: tree } = _ref;
        return function onMouseMove(event) {
            function close() {
                clearTimeout(timeoutId);
                onClose();
            }
            clearTimeout(timeoutId);
            if (!elements.domReference || !elements.floating || placement == null || x == null || y == null) return;
            const { clientX: clientX, clientY: clientY } = event;
            const clientPoint = [
                clientX,
                clientY
            ];
            const target = (0, $34bc2325b4db944b$export$c22522a4dfa48e9c)(event);
            const isLeave = event.type === "mouseleave";
            const isOverFloatingEl = (0, $34bc2325b4db944b$export$2344b14b097df817)(elements.floating, target);
            const isOverReferenceEl = (0, $34bc2325b4db944b$export$2344b14b097df817)(elements.domReference, target);
            const refRect = elements.domReference.getBoundingClientRect();
            const rect = elements.floating.getBoundingClientRect();
            const side = placement.split("-")[0];
            const cursorLeaveFromRight = x > rect.right - rect.width / 2;
            const cursorLeaveFromBottom = y > rect.bottom - rect.height / 2;
            const isOverReferenceRect = $3f69993268aa5b7a$var$isInside(clientPoint, refRect);
            const isFloatingWider = rect.width > refRect.width;
            const isFloatingTaller = rect.height > refRect.height;
            const left = (isFloatingWider ? refRect : rect).left;
            const right = (isFloatingWider ? refRect : rect).right;
            const top = (isFloatingTaller ? refRect : rect).top;
            const bottom = (isFloatingTaller ? refRect : rect).bottom;
            if (isOverFloatingEl) {
                hasLanded = true;
                if (!isLeave) return;
            }
            if (isOverReferenceEl) hasLanded = false;
            if (isOverReferenceEl && !isLeave) {
                hasLanded = true;
                return;
            }
            // Prevent overlapping floating element from being stuck in an open-close
            // loop: https://github.com/floating-ui/floating-ui/issues/1910
            if (isLeave && (0, $238ac70369f38756$export$45a5e7f76e0caa8d)(event.relatedTarget) && (0, $34bc2325b4db944b$export$2344b14b097df817)(elements.floating, event.relatedTarget)) return;
            // If any nested child is open, abort.
            if (tree && $3f69993268aa5b7a$var$getChildren(tree.nodesRef.current, nodeId).some((_ref2)=>{
                let { context: context } = _ref2;
                return context == null ? void 0 : context.open;
            })) return;
            // If the pointer is leaving from the opposite side, the "buffer" logic
            // creates a point where the floating element remains open, but should be
            // ignored.
            // A constant of 1 handles floating point rounding errors.
            if (side === "top" && y >= refRect.bottom - 1 || side === "bottom" && y <= refRect.top + 1 || side === "left" && x >= refRect.right - 1 || side === "right" && x <= refRect.left + 1) return close();
            // Ignore when the cursor is within the rectangular trough between the
            // two elements. Since the triangle is created from the cursor point,
            // which can start beyond the ref element's edge, traversing back and
            // forth from the ref to the floating element can cause it to close. This
            // ensures it always remains open in that case.
            let rectPoly = [];
            switch(side){
                case "top":
                    rectPoly = [
                        [
                            left,
                            refRect.top + 1
                        ],
                        [
                            left,
                            rect.bottom - 1
                        ],
                        [
                            right,
                            rect.bottom - 1
                        ],
                        [
                            right,
                            refRect.top + 1
                        ]
                    ];
                    break;
                case "bottom":
                    rectPoly = [
                        [
                            left,
                            rect.top + 1
                        ],
                        [
                            left,
                            refRect.bottom - 1
                        ],
                        [
                            right,
                            refRect.bottom - 1
                        ],
                        [
                            right,
                            rect.top + 1
                        ]
                    ];
                    break;
                case "left":
                    rectPoly = [
                        [
                            rect.right - 1,
                            bottom
                        ],
                        [
                            rect.right - 1,
                            top
                        ],
                        [
                            refRect.left + 1,
                            top
                        ],
                        [
                            refRect.left + 1,
                            bottom
                        ]
                    ];
                    break;
                case "right":
                    rectPoly = [
                        [
                            refRect.right - 1,
                            bottom
                        ],
                        [
                            refRect.right - 1,
                            top
                        ],
                        [
                            rect.left + 1,
                            top
                        ],
                        [
                            rect.left + 1,
                            bottom
                        ]
                    ];
                    break;
            }
            function getPolygon(_ref3) {
                let [x, y] = _ref3;
                switch(side){
                    case "top":
                        {
                            const cursorPointOne = [
                                isFloatingWider ? x + buffer / 2 : cursorLeaveFromRight ? x + buffer * 4 : x - buffer * 4,
                                y + buffer + 1
                            ];
                            const cursorPointTwo = [
                                isFloatingWider ? x - buffer / 2 : cursorLeaveFromRight ? x + buffer * 4 : x - buffer * 4,
                                y + buffer + 1
                            ];
                            const commonPoints = [
                                [
                                    rect.left,
                                    cursorLeaveFromRight ? rect.bottom - buffer : isFloatingWider ? rect.bottom - buffer : rect.top
                                ],
                                [
                                    rect.right,
                                    cursorLeaveFromRight ? isFloatingWider ? rect.bottom - buffer : rect.top : rect.bottom - buffer
                                ]
                            ];
                            return [
                                cursorPointOne,
                                cursorPointTwo,
                                ...commonPoints
                            ];
                        }
                    case "bottom":
                        {
                            const cursorPointOne = [
                                isFloatingWider ? x + buffer / 2 : cursorLeaveFromRight ? x + buffer * 4 : x - buffer * 4,
                                y - buffer
                            ];
                            const cursorPointTwo = [
                                isFloatingWider ? x - buffer / 2 : cursorLeaveFromRight ? x + buffer * 4 : x - buffer * 4,
                                y - buffer
                            ];
                            const commonPoints = [
                                [
                                    rect.left,
                                    cursorLeaveFromRight ? rect.top + buffer : isFloatingWider ? rect.top + buffer : rect.bottom
                                ],
                                [
                                    rect.right,
                                    cursorLeaveFromRight ? isFloatingWider ? rect.top + buffer : rect.bottom : rect.top + buffer
                                ]
                            ];
                            return [
                                cursorPointOne,
                                cursorPointTwo,
                                ...commonPoints
                            ];
                        }
                    case "left":
                        {
                            const cursorPointOne = [
                                x + buffer + 1,
                                isFloatingTaller ? y + buffer / 2 : cursorLeaveFromBottom ? y + buffer * 4 : y - buffer * 4
                            ];
                            const cursorPointTwo = [
                                x + buffer + 1,
                                isFloatingTaller ? y - buffer / 2 : cursorLeaveFromBottom ? y + buffer * 4 : y - buffer * 4
                            ];
                            const commonPoints = [
                                [
                                    cursorLeaveFromBottom ? rect.right - buffer : isFloatingTaller ? rect.right - buffer : rect.left,
                                    rect.top
                                ],
                                [
                                    cursorLeaveFromBottom ? isFloatingTaller ? rect.right - buffer : rect.left : rect.right - buffer,
                                    rect.bottom
                                ]
                            ];
                            return [
                                ...commonPoints,
                                cursorPointOne,
                                cursorPointTwo
                            ];
                        }
                    case "right":
                        {
                            const cursorPointOne = [
                                x - buffer,
                                isFloatingTaller ? y + buffer / 2 : cursorLeaveFromBottom ? y + buffer * 4 : y - buffer * 4
                            ];
                            const cursorPointTwo = [
                                x - buffer,
                                isFloatingTaller ? y - buffer / 2 : cursorLeaveFromBottom ? y + buffer * 4 : y - buffer * 4
                            ];
                            const commonPoints = [
                                [
                                    cursorLeaveFromBottom ? rect.left + buffer : isFloatingTaller ? rect.left + buffer : rect.right,
                                    rect.top
                                ],
                                [
                                    cursorLeaveFromBottom ? isFloatingTaller ? rect.left + buffer : rect.right : rect.left + buffer,
                                    rect.bottom
                                ]
                            ];
                            return [
                                cursorPointOne,
                                cursorPointTwo,
                                ...commonPoints
                            ];
                        }
                }
            }
            if ($3f69993268aa5b7a$var$isPointInPolygon([
                clientX,
                clientY
            ], rectPoly)) return;
            if (hasLanded && !isOverReferenceRect) return close();
            if (!isLeave && requireIntent) {
                const cursorSpeed = getCursorSpeed(event.clientX, event.clientY);
                const cursorSpeedThreshold = 0.1;
                if (cursorSpeed !== null && cursorSpeed < cursorSpeedThreshold) return close();
            }
            if (!$3f69993268aa5b7a$var$isPointInPolygon([
                clientX,
                clientY
            ], getPolygon([
                x,
                y
            ]))) close();
            else if (!hasLanded && requireIntent) timeoutId = window.setTimeout(close, 40);
        };
    };
    fn.__options = {
        blockPointerEvents: blockPointerEvents
    };
    return fn;
}








var $acw62 = parcelRequire("acw62");

const $abd688ca6d37daab$export$133ffa6fd5c24745 = ({ popoverItems: popoverItems, popoverDate: popoverDate, setSpIdsToBulkChange: setSpIdsToBulkChange, setIsPopupOpen: setIsPopupOpen, spName: spName, onPopoverAction: onPopoverAction, spIdsToBulkChange: spIdsToBulkChange })=>{
    const { t: t } = (0, $3765cebd031b52c0$export$9fc83ad70ead8663)();
    const popupRef = (0, $acw62.useRef)(null);
    (0, $3820618f4f4eb2a5$export$aa79b0abe3dfeaba)(popupRef, ()=>setIsPopupOpen(false));
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        className: "BulkChangePopup",
        ref: popupRef,
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
            className: "BulkChangePopup__container",
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                    className: "BulkChangePopup__title",
                    children: [
                        t("all_jobs.copy_changes_to_more_ogs_on"),
                        " ",
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                            children: popoverDate
                        }),
                        ":"
                    ]
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $86533ea03b238cc7$export$eae70af4b4e3f197), {
                    className: "BulkChangePopup__select",
                    label: t("all_jobs.select_ogs_to_apply"),
                    onChange: (values)=>{
                        const modifiedValues = values.map((itemValue)=>Number(itemValue));
                        setSpIdsToBulkChange(modifiedValues);
                    },
                    options: popoverItems,
                    preselectAll: true
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: "BulkChangePopup__controls",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                            onClick: ()=>setIsPopupOpen(false),
                            className: "BulkChangePopup__secondary",
                            children: t("all_jobs.apply_to_sp_only", {
                                spName: spName
                            })
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                            onClick: ()=>{
                                if (onPopoverAction) onPopoverAction(spIdsToBulkChange);
                                setIsPopupOpen(false);
                            },
                            className: "BulkChangePopup__primary",
                            children: t("all_jobs.bulk_apply")
                        })
                    ]
                })
            ]
        })
    });
};


function $dc4e26e0206e7d2e$export$680ea196effce5f({ value: value, label: label, disabled: disabled, highlighted: highlighted = false, handleChange: handleChange, onPopoverAction: onPopoverAction, popoverItems: popoverItems = [], popoverDate: popoverDate = "", spName: spName = null }) {
    const [spIdsToBulkChange, setSpIdsToBulkChange] = (0, $acw62.useState)([]);
    const [isPopupOpen, setIsPopupOpen] = (0, $acw62.useState)(false);
    const { refs: refs, strategy: strategy, floatingStyles: floatingStyles } = (0, $3f69993268aa5b7a$export$4e02a5c1d08bac65)({
        placement: "left",
        middleware: [
            (0, $23a8f689f1d4c3be$export$cc800923e997bb8)(10),
            (0, $23a8f689f1d4c3be$export$8a83211c878a3f1f)(),
            (0, $23a8f689f1d4c3be$export$fba63a578e423eb)()
        ]
    });
    (0, $acw62.useEffect)(()=>{
        if (popoverItems.length) setSpIdsToBulkChange(popoverItems.map((item)=>item.value));
    }, [
        popoverItems
    ]);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "ScheduleTime",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                ref: refs.setReference,
                style: {
                    display: "inline-block"
                },
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5ce1d5308946b7cc$export$a1af6f79df847fac), {
                    disabled: disabled,
                    label: label,
                    value: value,
                    handleChange: (val)=>{
                        const prevVal = value;
                        handleChange(val);
                        if (prevVal !== val && popoverItems.length > 0) setIsPopupOpen(true);
                    },
                    className: `ScheduleTime__timeInput ${disabled ? "disabled" : ""} ${highlighted ? "highlighted" : ""}`,
                    useDropdownWithInput: true
                })
            }),
            isPopupOpen && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                ref: refs.setFloating,
                style: {
                    ...floatingStyles,
                    position: strategy,
                    top: 0,
                    left: 0,
                    background: "white",
                    borderRadius: "16px",
                    boxShadow: "0px 4px 6px rgba(0, 0, 0, 0.1)",
                    zIndex: 1000
                },
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $abd688ca6d37daab$export$133ffa6fd5c24745), {
                    popoverItems: popoverItems,
                    popoverDate: popoverDate,
                    setSpIdsToBulkChange: setSpIdsToBulkChange,
                    setIsPopupOpen: setIsPopupOpen,
                    spName: spName,
                    onPopoverAction: onPopoverAction,
                    spIdsToBulkChange: spIdsToBulkChange
                })
            })
        ]
    });
}







var $cd031e5bfc73ff3a$export$e35c1996c6f482ad;
(function(StatusType) {
    StatusType[StatusType["shiftCompleted"] = 0] = "shiftCompleted";
    StatusType[StatusType["shiftStarted"] = 1] = "shiftStarted";
    StatusType[StatusType["shiftUpcoming"] = 2] = "shiftUpcoming";
    StatusType[StatusType["spCompleted"] = 3] = "spCompleted";
    StatusType[StatusType["spStarted"] = 4] = "spStarted";
    StatusType[StatusType["spUpcoming"] = 5] = "spUpcoming";
    StatusType[StatusType["spCanceled"] = 6] = "spCanceled";
    StatusType[StatusType["spEmpty"] = 7] = "spEmpty";
    StatusType[StatusType["spPending"] = 8] = "spPending";
    StatusType[StatusType["noStatus"] = 9] = "noStatus";
})($cd031e5bfc73ff3a$export$e35c1996c6f482ad || ($cd031e5bfc73ff3a$export$e35c1996c6f482ad = {}));
function $cd031e5bfc73ff3a$export$9ddbf12b356b47fb(status) {
    switch(status){
        case (0, $d5e0253b28c033d7$export$f7cfb7426aa37f1a).completed:
            return 3;
        case (0, $d5e0253b28c033d7$export$f7cfb7426aa37f1a).started:
            return 4;
        case (0, $d5e0253b28c033d7$export$f7cfb7426aa37f1a).accepted:
            return 5;
        case (0, $d5e0253b28c033d7$export$f7cfb7426aa37f1a).canceled:
            return 6;
        case (0, $d5e0253b28c033d7$export$f7cfb7426aa37f1a).pendingConfirmation:
            return 8;
        case (0, $d5e0253b28c033d7$export$f7cfb7426aa37f1a).irrelevant:
            return 9;
    }
}
function $cd031e5bfc73ff3a$var$getClassnameByStatus(status) {
    switch(status){
        case 0:
            return "completed-shift";
        case 1:
            return "started-shift";
        case 2:
            return "upcoming-shift";
        case 3:
            return "completed-sp";
        case 4:
            return "started-sp";
        case 5:
            return "upcoming-sp";
        case 6:
            return "not-attended-sp";
        case 7:
            return "upcoming-empty";
        case 8:
            return "pending-sp";
        case 9:
            return "";
    }
}
function $cd031e5bfc73ff3a$var$StatusComponent({ status: status, title: title }) {
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        className: `Status ${$cd031e5bfc73ff3a$var$getClassnameByStatus(status)}`,
        onClick: ()=>(0, $c74a0566d4b0fd6d$export$e9db7d6e73593439).track((0, $c74a0566d4b0fd6d$export$5e27155e276f6d1c).TimesheetStatusLabelClicked),
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
            className: "Status__label",
            children: title
        })
    });
}
const $cd031e5bfc73ff3a$export$96e9906d6d93a972 = (0, $aca50e9407ba89c9$export$b6ae1bc530f4c149)($cd031e5bfc73ff3a$var$StatusComponent);






const $4fe3b599a2cc1bc4$export$2ce376c2cc3355c8 = ({ img: img, title: title, disabled: disabled, onClick: onClick })=>{
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: `MenuItem ${disabled ? "disabled" : ""}`,
        onClick: disabled ? ()=>{} : onClick,
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                src: img,
                alt: ""
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $660b2ca422e0e2ae$export$1ff3c3f08ae963c0).Horizontal, {
                width: 15
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                children: title
            })
        ]
    });
};





var $7YFi7 = parcelRequire("7YFi7");







const $47e345bb7713dc45$export$77769cd018193dc9 = ({ modalVisible: modalVisible, onClose: onClose })=>{
    const { t: t } = (0, $3765cebd031b52c0$export$9fc83ad70ead8663)();
    const capacityLabel = t("job_shifts.i_have_capacity");
    const otherLabel = t("job_shifts.other");
    if (!modalVisible) return null;
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $c786671f641538e1$export$446bb0a5366f9068), {
        modalVisible: modalVisible,
        onClose: onClose,
        className: "CancelJobModal",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $660b2ca422e0e2ae$export$1ff3c3f08ae963c0).Vertical, {
                height: 29
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                className: "CancelJobModal__title",
                children: t("job_shifts.cancel_shift")
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $660b2ca422e0e2ae$export$1ff3c3f08ae963c0).Vertical, {
                height: 27
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                className: "CancelJobModal__subtitle",
                children: t("job_shifts.confirmation_question")
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $660b2ca422e0e2ae$export$1ff3c3f08ae963c0).Vertical, {
                height: 27
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7YFi7.Formik), {
                initialValues: {
                    reason: capacityLabel,
                    comment: ""
                },
                onSubmit: (values)=>{
                    // TODO: implement functionality
                    console.log("values", values);
                },
                validationSchema: $cd7706ce94a8dfd1$export$185802fd694ee1f5().shape({
                    reason: $bcc252d93ab3046c$export$185802fd694ee1f5().required()
                }),
                children: (formikProps)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7YFi7.Form), {
                        noValidate: true,
                        className: "CancelJobModal__form",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f2c1b8699595d8c0$export$ef9b1a59e592288f), {
                                label: t("job_shifts.select_reason"),
                                value: formikProps.getFieldProps("reason").value,
                                onChange: (value)=>{
                                    formikProps.setFieldValue("reason", value);
                                },
                                options: [
                                    {
                                        key: capacityLabel,
                                        value: capacityLabel,
                                        label: capacityLabel
                                    },
                                    {
                                        key: otherLabel,
                                        value: otherLabel,
                                        label: otherLabel
                                    }
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $660b2ca422e0e2ae$export$1ff3c3f08ae963c0).Vertical, {
                                height: 20
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                className: "CancelJobModal__textarea-container",
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $79dd68e96d831dee$export$2e2bcd8739ae039), {
                                    formikProps: formikProps,
                                    type: "textarea",
                                    label: t("job_shifts.comment_here"),
                                    formikKey: "comment"
                                })
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $660b2ca422e0e2ae$export$1ff3c3f08ae963c0).Vertical, {
                                height: 50
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $2ab88429e3384d30$export$353f5b6fc5456de1), {
                                type: "submit",
                                title: t("job_shifts.cancel_job"),
                                className: "CancelJobModal__confirm-button"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $660b2ca422e0e2ae$export$1ff3c3f08ae963c0).Vertical, {
                                height: 16
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $2ab88429e3384d30$export$353f5b6fc5456de1), {
                                title: t("job_shifts.cancel"),
                                onClick: onClose
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $660b2ca422e0e2ae$export$1ff3c3f08ae963c0).Vertical, {
                                height: 30
                            })
                        ]
                    })
            })
        ]
    });
};




var $acw62 = parcelRequire("acw62");

var $45fvw = parcelRequire("45fvw");









var $acw62 = parcelRequire("acw62");

var $45fvw = parcelRequire("45fvw");








const $b67af89f29a5c371$var$getFormattedCurrentTime = ()=>{
    return (0, (/*@__PURE__*/$parcel$interopDefault($45fvw)))().format("HH:mm");
};
const $b67af89f29a5c371$export$23005cf6208f2360 = (0, $aca50e9407ba89c9$export$b6ae1bc530f4c149)(({ label: label, modalVisible: modalVisible, onConfirm: onConfirm, onClose: onClose })=>{
    const [selectedTime, setSelectedTime] = (0, $acw62.useState)($b67af89f29a5c371$var$getFormattedCurrentTime());
    const { t: t } = (0, $3765cebd031b52c0$export$9fc83ad70ead8663)();
    if (!modalVisible) return null;
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $c786671f641538e1$export$446bb0a5366f9068), {
        modalVisible: modalVisible,
        onClose: onClose,
        className: "CheckInOutModal",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $660b2ca422e0e2ae$export$1ff3c3f08ae963c0).Vertical, {
                height: 40
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                className: "CheckInOutModal__title",
                children: label
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $660b2ca422e0e2ae$export$1ff3c3f08ae963c0).Vertical, {
                height: 40
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5ce1d5308946b7cc$export$a1af6f79df847fac), {
                label: t("job_cherry_picking.time"),
                value: selectedTime,
                handleChange: setSelectedTime,
                className: "CheckInOutModal__timeInput"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $660b2ca422e0e2ae$export$1ff3c3f08ae963c0).Vertical, {
                height: 44
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $2ab88429e3384d30$export$353f5b6fc5456de1), {
                disabled: selectedTime.length === 0,
                title: t("job_cherry_picking.confirm"),
                onClick: ()=>{
                    const time24Format = (0, $ddf12117b815a7c3$export$725c94c55ade8c95) ? (0, $ddf12117b815a7c3$export$255008033397e701)(selectedTime) : selectedTime;
                    onConfirm(time24Format);
                },
                className: "CheckInOutModal__confirmButton"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $660b2ca422e0e2ae$export$1ff3c3f08ae963c0).Vertical, {
                height: 16
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $2ab88429e3384d30$export$353f5b6fc5456de1), {
                title: t("job_cherry_picking.cancel"),
                onClick: onClose
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $660b2ca422e0e2ae$export$1ff3c3f08ae963c0).Vertical, {
                height: 81
            })
        ]
    });
});




var $7YFi7 = parcelRequire("7YFi7");









var $acw62 = parcelRequire("acw62");


function $92c1765d8747156c$export$48513f6b9f8ce62d(props) {
    const handleChange = (value)=>{
        props.field?.setData(value);
        props.onChange?.(value);
    };
    const ref = /*#__PURE__*/ (0, $acw62.createRef)();
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
        ref: ref,
        type: "checkbox",
        checked: props.value ?? props.field?.value,
        className: "Checkbox",
        onChange: (e)=>handleChange(e.target.checked),
        required: props.required
    });
}
function $92c1765d8747156c$export$94195a47b94ed396(props) {
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4c4587947033fde9$export$a455218a85c89869), {
        errors: props.errors ?? props.field?.errors,
        rightPos: true,
        label: props.label,
        description: props.description,
        required: props.required,
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($92c1765d8747156c$export$48513f6b9f8ce62d, {
            ...props
        })
    });
}





const $3329d6e4568c6bd5$export$dda52c4029d7f032 = (0, $aca50e9407ba89c9$export$b6ae1bc530f4c149)(({ cancelReasons: cancelReasons, shiftId: shiftId, ogrammerName: ogrammerName, modalVisible: modalVisible, onClose: onClose, onSubmit: onSubmit })=>{
    const { t: t } = (0, $3765cebd031b52c0$export$9fc83ad70ead8663)();
    if (!modalVisible) return null;
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $c786671f641538e1$export$446bb0a5366f9068), {
        modalVisible: modalVisible,
        onClose: onClose,
        className: "CancelShiftModal",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $660b2ca422e0e2ae$export$1ff3c3f08ae963c0).Vertical, {
                height: 29
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                className: "CancelShiftModal__title",
                children: t("job_shifts.cancel_shift")
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $660b2ca422e0e2ae$export$1ff3c3f08ae963c0).Vertical, {
                height: 27
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                className: "CancelShiftModal__subtitle",
                children: [
                    "You are about to cancel ",
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                        className: "CancelShiftModal__subtitle-highlighted",
                        children: ogrammerName
                    }),
                    " ",
                    t("job_shifts.for_the_job")
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $660b2ca422e0e2ae$export$1ff3c3f08ae963c0).Vertical, {
                height: 27
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7YFi7.Formik), {
                initialValues: {
                    reason: cancelReasons[0].name,
                    comment: "",
                    blockOgrammer: false,
                    cancelFollowingShifts: false
                },
                onSubmit: (values)=>{
                    onSubmit({
                        id: shiftId,
                        reasonId: cancelReasons.find((reason)=>reason.name === values.reason).id,
                        reasonDetails: values.comment,
                        cancelFollowing: values.cancelFollowingShifts,
                        blockOgrammer: values.blockOgrammer
                    });
                    (0, $c74a0566d4b0fd6d$export$e9db7d6e73593439).track((0, $c74a0566d4b0fd6d$export$5e27155e276f6d1c).TimesheetCancellationConfirmed);
                },
                validationSchema: $cd7706ce94a8dfd1$export$185802fd694ee1f5().shape({
                    reason: $bcc252d93ab3046c$export$185802fd694ee1f5().required()
                }),
                children: (formikProps)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7YFi7.Form), {
                        noValidate: true,
                        className: "CancelShiftModal__form",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f2c1b8699595d8c0$export$ef9b1a59e592288f), {
                                label: "Select A Reason",
                                value: formikProps.getFieldProps("reason").value,
                                onChange: (value)=>{
                                    formikProps.setFieldValue("reason", value);
                                },
                                options: cancelReasons.map((reason)=>({
                                        key: String(reason.id),
                                        value: reason.name,
                                        label: reason.name
                                    }))
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $660b2ca422e0e2ae$export$1ff3c3f08ae963c0).Vertical, {
                                height: 20
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                className: "CancelShiftModal__textarea-container",
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $79dd68e96d831dee$export$2e2bcd8739ae039), {
                                    formikProps: formikProps,
                                    type: "textarea",
                                    label: "Comment here (Optional)",
                                    formikKey: "comment"
                                })
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $660b2ca422e0e2ae$export$1ff3c3f08ae963c0).Vertical, {
                                height: 22
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "CancelShiftModal__row",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $92c1765d8747156c$export$48513f6b9f8ce62d), {
                                        value: formikProps.getFieldProps("blockOgrammer").value,
                                        onChange: (value)=>{
                                            formikProps.setFieldValue("blockOgrammer", value);
                                        }
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                        className: "CancelShiftModal__checkbox-description",
                                        children: t("job_shifts.block_ogrammer")
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $660b2ca422e0e2ae$export$1ff3c3f08ae963c0).Vertical, {
                                height: 15
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "CancelShiftModal__row",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $92c1765d8747156c$export$48513f6b9f8ce62d), {
                                        value: formikProps.getFieldProps("cancelFollowingShifts").value,
                                        onChange: (value)=>{
                                            if (value) (0, $c74a0566d4b0fd6d$export$e9db7d6e73593439).track((0, $c74a0566d4b0fd6d$export$5e27155e276f6d1c).TimesheetCancellationAllShiftsSelected);
                                            formikProps.setFieldValue("cancelFollowingShifts", value);
                                        }
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                        className: "CancelShiftModal__checkbox-description",
                                        children: t("job_shifts.cancel_all_following_shifts")
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $660b2ca422e0e2ae$export$1ff3c3f08ae963c0).Vertical, {
                                height: 50
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $2ab88429e3384d30$export$353f5b6fc5456de1), {
                                type: "submit",
                                title: t("job_shifts.cancel_shift"),
                                className: "CancelShiftModal__confirm-button"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $660b2ca422e0e2ae$export$1ff3c3f08ae963c0).Vertical, {
                                height: 16
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $2ab88429e3384d30$export$353f5b6fc5456de1), {
                                title: t("job_shifts.cancel"),
                                onClick: ()=>{
                                    onClose();
                                    (0, $c74a0566d4b0fd6d$export$e9db7d6e73593439).track((0, $c74a0566d4b0fd6d$export$5e27155e276f6d1c).TimesheetCancellationCancelled);
                                }
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $660b2ca422e0e2ae$export$1ff3c3f08ae963c0).Vertical, {
                                height: 30
                            })
                        ]
                    })
            })
        ]
    });
});




var $acw62 = parcelRequire("acw62");









const $ddf4c9963edeb8c3$export$137c04cfead3749 = (0, $aca50e9407ba89c9$export$b6ae1bc530f4c149)(({ shiftId: shiftId, label: label, modalVisible: modalVisible, onClose: onClose, shiftExtensionDefaultTime: shiftExtensionDefaultTime })=>{
    const [selectedExtension, setSelectedExtension] = (0, $acw62.useState)(shiftExtensionDefaultTime);
    const { extendShift: extendShift, shiftExtensionTimeOptions: shiftExtensionTimeOptions } = (0, $4671947198ddd366$export$6ccbb43953eebf8)().data;
    const { t: t } = (0, $3765cebd031b52c0$export$9fc83ad70ead8663)();
    const [, requestShiftExtension] = (0, $4671947198ddd366$export$609860bf8b0084c)(extendShift, {
        onSuccess: ()=>{
            alert("Shift has been extended");
            onClose();
        },
        onError: (err)=>{
            alert(err.data.message);
        },
        filterError: [
            (0, $9ad33fbf770c55a1$export$9696fcf1798e1cb5).ClientError,
            (0, $9ad33fbf770c55a1$export$9696fcf1798e1cb5).NotFound
        ]
    });
    if (!modalVisible) return null;
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $c786671f641538e1$export$446bb0a5366f9068), {
        modalVisible: modalVisible,
        onClose: onClose,
        className: "ExtendShiftModal",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $660b2ca422e0e2ae$export$1ff3c3f08ae963c0).Vertical, {
                height: 40
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                className: "ExtendShiftModal__title",
                children: label
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $660b2ca422e0e2ae$export$1ff3c3f08ae963c0).Vertical, {
                height: 40
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f2c1b8699595d8c0$export$ef9b1a59e592288f), {
                label: label,
                value: selectedExtension,
                onChange: setSelectedExtension,
                options: shiftExtensionTimeOptions
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $660b2ca422e0e2ae$export$1ff3c3f08ae963c0).Vertical, {
                height: 44
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $2ab88429e3384d30$export$353f5b6fc5456de1), {
                title: t("job_cherry_picking.confirm"),
                onClick: ()=>{
                    requestShiftExtension({
                        id: shiftId,
                        time: selectedExtension
                    });
                },
                className: "ExtendShiftModal__confirm-button"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $660b2ca422e0e2ae$export$1ff3c3f08ae963c0).Vertical, {
                height: 16
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $2ab88429e3384d30$export$353f5b6fc5456de1), {
                title: t("job_cherry_picking.cancel"),
                onClick: onClose
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $660b2ca422e0e2ae$export$1ff3c3f08ae963c0).Vertical, {
                height: 81
            })
        ]
    });
});


var $a199d1fc1be54911$exports = {};
$a199d1fc1be54911$exports = new URL("check-out.801323bb.svg", import.meta.url).toString();


var $9229fdc321b4a73f$exports = {};
$9229fdc321b4a73f$exports = new URL("heart.4b94aa06.svg", import.meta.url).toString();


var $b46da42d7248277f$exports = {};
$b46da42d7248277f$exports = new URL("heart-filled.31f0c813.svg", import.meta.url).toString();


var $02e07a49bc179c15$exports = {};
$02e07a49bc179c15$exports = new URL("message.a170fc04.svg", import.meta.url).toString();


var $d96d8bc0b1675b62$exports = {};
$d96d8bc0b1675b62$exports = new URL("phone.25f2d803.svg", import.meta.url).toString();


var $8a67921872693640$exports = {};
$8a67921872693640$exports = new URL("extend.5d45ba46.svg", import.meta.url).toString();


const $1efca34f4a6ab1b2$export$6c746a5570b8b35c = {
    checkOutImg: (/*@__PURE__*/$parcel$interopDefault($a199d1fc1be54911$exports)),
    heartImg: (/*@__PURE__*/$parcel$interopDefault($9229fdc321b4a73f$exports)),
    heartFilledImg: (/*@__PURE__*/$parcel$interopDefault($b46da42d7248277f$exports)),
    messageImg: (/*@__PURE__*/$parcel$interopDefault($02e07a49bc179c15$exports)),
    phoneImg: (/*@__PURE__*/$parcel$interopDefault($d96d8bc0b1675b62$exports)),
    extendImg: (/*@__PURE__*/$parcel$interopDefault($8a67921872693640$exports))
};


var $85dec660949d3c41$exports = {};
$85dec660949d3c41$exports = new URL("clock.0fb7872e.svg", import.meta.url).toString();


var $39db87f82cb43075$exports = {};
$39db87f82cb43075$exports = new URL("close.5084562c.svg", import.meta.url).toString();


var $5ebc2149cee3464f$exports = {};
$5ebc2149cee3464f$exports = new URL("dropdown-horizontal.083d7007.svg", import.meta.url).toString();


var $217e7512faeba53f$exports = {};
$217e7512faeba53f$exports = new URL("dropdown-vertical.1012894e.svg", import.meta.url).toString();


var $a26a3786695e81be$exports = {};
$a26a3786695e81be$exports = new URL("not-attended.31f98972.svg", import.meta.url).toString();


const $35d53c47138e8457$export$6c746a5570b8b35c = {
    clockImg: (/*@__PURE__*/$parcel$interopDefault($85dec660949d3c41$exports)),
    closeImg: (/*@__PURE__*/$parcel$interopDefault($39db87f82cb43075$exports)),
    dropdownHorizontalImg: (/*@__PURE__*/$parcel$interopDefault($5ebc2149cee3464f$exports)),
    dropdownVerticalImg: (/*@__PURE__*/$parcel$interopDefault($217e7512faeba53f$exports)),
    notAttendedImg: (/*@__PURE__*/$parcel$interopDefault($a26a3786695e81be$exports))
};


var $d0fc1bb354c0eba4$exports = {};
$d0fc1bb354c0eba4$exports = new URL("context.85f13cb1.svg", import.meta.url).toString();




const $f5a824c5466ad856$export$eac491c825cc5ad7 = (0, $aca50e9407ba89c9$export$b6ae1bc530f4c149)(({ jobSchedule: jobSchedule, shift: shift, spShift: spShift, spId: spId })=>{
    const { shiftExtensionDefaultTime: shiftExtensionDefaultTime, checkInOgrammer: checkInOgrammer, checkOutOgrammer: checkOutOgrammer, makeOgrammerFavourite: makeOgrammerFavourite, removeOgrammerFromFavourites: removeOgrammerFromFavourites, cancelReasons: cancelReasons, cancelShift: cancelShift } = (0, $4671947198ddd366$export$6ccbb43953eebf8)().data;
    const [, requestCancelShift] = (0, $4671947198ddd366$export$609860bf8b0084c)(cancelShift, {
        onSuccess: ()=>{
            alert(t("all_jobs.shift_canceled"));
            setCancelModalVisible(false);
            jobSchedule.setOgrammerStatus({
                spId: spId,
                shiftId: shift.shift_id,
                status: (0, $d5e0253b28c033d7$export$f7cfb7426aa37f1a).canceled
            });
        },
        onError: (err)=>{
            alert(err.data.message);
        },
        filterError: [
            (0, $9ad33fbf770c55a1$export$9696fcf1798e1cb5).ClientError,
            (0, $9ad33fbf770c55a1$export$9696fcf1798e1cb5).NotFound
        ]
    });
    const [checkInResult, checkIn] = (0, $4671947198ddd366$export$609860bf8b0084c)((params)=>{
        return checkInOgrammer(params).then(()=>{
            jobSchedule.setOgrammerCheckInTime({
                spId: spId,
                shiftId: shift.shift_id,
                time: (0, (/*@__PURE__*/$parcel$interopDefault($45fvw)))(params.time, "HH:mm").unix()
            });
        });
    }, {
        onSuccess: ()=>{
            alert(t("all_jobs.og_checked_in"));
            setCheckInModalVisible(false);
        },
        onError: (err)=>{
            alert(err.data.message);
        },
        filterError: [
            (0, $9ad33fbf770c55a1$export$9696fcf1798e1cb5).ClientError,
            (0, $9ad33fbf770c55a1$export$9696fcf1798e1cb5).NotFound
        ]
    });
    const [checkOutResult, checkOut] = (0, $4671947198ddd366$export$609860bf8b0084c)((params)=>{
        return checkOutOgrammer(params).then(()=>{
            jobSchedule.setOgrammerCheckOutTime({
                spId: spId,
                shiftId: shift.shift_id,
                time: (0, (/*@__PURE__*/$parcel$interopDefault($45fvw)))(params.time, "HH:mm").unix()
            });
        });
    }, {
        onSuccess: ()=>{
            alert(t("all_jobs.og_checked_out"));
            setCheckOutModalVisible(false);
        },
        onError: (err)=>{
            alert(err.data.message);
        },
        filterError: [
            (0, $9ad33fbf770c55a1$export$9696fcf1798e1cb5).ClientError,
            (0, $9ad33fbf770c55a1$export$9696fcf1798e1cb5).NotFound
        ]
    });
    const [favourResult, favourOgrammer] = (0, $4671947198ddd366$export$609860bf8b0084c)(makeOgrammerFavourite, {
        onSuccess: ()=>jobSchedule.toogleOgrammerFavouriteStatus({
                spId: spId
            }),
        onError: (err)=>{
            alert(err.data.message);
        },
        filterError: [
            (0, $9ad33fbf770c55a1$export$9696fcf1798e1cb5).ClientError,
            (0, $9ad33fbf770c55a1$export$9696fcf1798e1cb5).NotFound
        ]
    });
    const [unfavourResult, unfavourOgrammer] = (0, $4671947198ddd366$export$609860bf8b0084c)(removeOgrammerFromFavourites, {
        onSuccess: ()=>jobSchedule.toogleOgrammerFavouriteStatus({
                spId: spId
            }),
        onError: (err)=>{
            alert(err.data.message);
        },
        filterError: [
            (0, $9ad33fbf770c55a1$export$9696fcf1798e1cb5).ClientError,
            (0, $9ad33fbf770c55a1$export$9696fcf1798e1cb5).NotFound
        ]
    });
    const [checkInModalVisible, setCheckInModalVisible] = (0, $acw62.useState)(false);
    const [checkOutModalVisible, setCheckOutModalVisible] = (0, $acw62.useState)(false);
    const [extendModalVisible, setExtendModalVisible] = (0, $acw62.useState)(false);
    const [cancelModalVisible, setCancelModalVisible] = (0, $acw62.useState)(false);
    const { t: t } = (0, $3765cebd031b52c0$export$9fc83ad70ead8663)();
    const isLessThan12HoursToShift = (0, $acw62.useMemo)(()=>{
        if (!spShift.start_time) return false;
        const currentMomentDate = (0, (/*@__PURE__*/$parcel$interopDefault($45fvw)))();
        const startTimeMomentDate = (0, (/*@__PURE__*/$parcel$interopDefault($45fvw)))(spShift.start_time * 1000);
        const diff = startTimeMomentDate.diff(currentMomentDate);
        const hoursUntilCheckin = (0, (/*@__PURE__*/$parcel$interopDefault($45fvw))).duration(diff).asHours();
        return hoursUntilCheckin < 12;
    }, []);
    const { status: status, client_checkin_time: client_checkin_time, client_checkout_time: client_checkout_time } = shift;
    const sp = jobSchedule.getSp({
        spId: spId
    });
    const { name: name } = sp;
    const getCheckInDisabledStatus = ()=>{
        return Boolean(client_checkin_time) || !isLessThan12HoursToShift || checkInResult.isLoading;
    };
    const getCheckoutDisabledStatus = ()=>{
        return !Boolean(client_checkin_time) || Boolean(client_checkout_time) || !isLessThan12HoursToShift || checkOutResult.isLoading;
    };
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "ShiftTools",
                onMouseOver: ()=>(0, $c74a0566d4b0fd6d$export$e9db7d6e73593439).track((0, $c74a0566d4b0fd6d$export$5e27155e276f6d1c).TimesheetSlotOptionsViewed),
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $04012d5b0475752e$export$e44a253a59704894), {
                    outerComponent: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "ShiftTools__dropdownContainer",
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                            src: (0, (/*@__PURE__*/$parcel$interopDefault($d0fc1bb354c0eba4$exports))),
                            alt: "ogrammer tools"
                        })
                    }),
                    items: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4fe3b599a2cc1bc4$export$2ce376c2cc3355c8), {
                            img: (0, $35d53c47138e8457$export$6c746a5570b8b35c).clockImg,
                            title: t("job_shifts.check_in"),
                            onClick: ()=>{
                                (0, $c74a0566d4b0fd6d$export$e9db7d6e73593439).track((0, $c74a0566d4b0fd6d$export$5e27155e276f6d1c).TimesheetSlotOptionCheckInClicked);
                                setCheckInModalVisible(true);
                            },
                            disabled: getCheckInDisabledStatus()
                        }, "check-in"),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4fe3b599a2cc1bc4$export$2ce376c2cc3355c8), {
                            img: (0, $1efca34f4a6ab1b2$export$6c746a5570b8b35c).checkOutImg,
                            title: t("job_shifts.check_out"),
                            onClick: ()=>{
                                (0, $c74a0566d4b0fd6d$export$e9db7d6e73593439).track((0, $c74a0566d4b0fd6d$export$5e27155e276f6d1c).TimesheetSlotOptionCheckOutClicked);
                                setCheckOutModalVisible(true);
                            },
                            disabled: getCheckoutDisabledStatus()
                        }, "check-out"),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4fe3b599a2cc1bc4$export$2ce376c2cc3355c8), {
                            img: (0, $1efca34f4a6ab1b2$export$6c746a5570b8b35c).extendImg,
                            title: t("job_shifts.extend_shift"),
                            onClick: ()=>{
                                (0, $c74a0566d4b0fd6d$export$e9db7d6e73593439).track((0, $c74a0566d4b0fd6d$export$5e27155e276f6d1c).TimesheetSlotOptionExtendShiftClicked);
                                setExtendModalVisible(true);
                            },
                            disabled: !isLessThan12HoursToShift || Boolean(client_checkout_time) || status.id === (0, $d5e0253b28c033d7$export$f7cfb7426aa37f1a).canceled || status.id === (0, $d5e0253b28c033d7$export$f7cfb7426aa37f1a).completed
                        }, "extend"),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4fe3b599a2cc1bc4$export$2ce376c2cc3355c8), {
                            img: (0, $35d53c47138e8457$export$6c746a5570b8b35c).closeImg,
                            title: t("job_shifts.cancel_shift"),
                            onClick: ()=>{
                                (0, $c74a0566d4b0fd6d$export$e9db7d6e73593439).track((0, $c74a0566d4b0fd6d$export$5e27155e276f6d1c).TimesheetSlotOptionCancelClicked);
                                setCancelModalVisible(true);
                            },
                            disabled: Boolean(client_checkin_time) || Boolean(client_checkout_time) || status.id === (0, $d5e0253b28c033d7$export$f7cfb7426aa37f1a).started || status.id === (0, $d5e0253b28c033d7$export$f7cfb7426aa37f1a).canceled
                        }, "cancel"),
                        ...sp.phone !== null ? [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4fe3b599a2cc1bc4$export$2ce376c2cc3355c8), {
                                img: (0, $1efca34f4a6ab1b2$export$6c746a5570b8b35c).phoneImg,
                                title: t("job_shifts.call"),
                                onClick: ()=>{
                                    (0, $c74a0566d4b0fd6d$export$e9db7d6e73593439).track((0, $c74a0566d4b0fd6d$export$5e27155e276f6d1c).TimesheetSlotOptionPhoneClicked);
                                    window.open(`tel:+${sp.phone}`);
                                },
                                disabled: false
                            }, "call")
                        ] : [],
                        ...sp.phone !== null ? [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4fe3b599a2cc1bc4$export$2ce376c2cc3355c8), {
                                img: (0, $1efca34f4a6ab1b2$export$6c746a5570b8b35c).messageImg,
                                title: t("job_shifts.whatsapp"),
                                onClick: ()=>{
                                    (0, $c74a0566d4b0fd6d$export$e9db7d6e73593439).track((0, $c74a0566d4b0fd6d$export$5e27155e276f6d1c).TimesheetSlotOptionWhatsappClicked);
                                    window.open(`https://wa.me/${sp.phone}`);
                                },
                                disabled: false
                            }, "message")
                        ] : [],
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4fe3b599a2cc1bc4$export$2ce376c2cc3355c8), {
                            img: sp.is_favorite ? (0, $1efca34f4a6ab1b2$export$6c746a5570b8b35c).heartFilledImg : (0, $1efca34f4a6ab1b2$export$6c746a5570b8b35c).heartImg,
                            title: sp.is_favorite ? t("job_shifts.remove_from_favourites") : t("job_shifts.add_to_favourites"),
                            onClick: ()=>{
                                if (sp.is_favorite) unfavourOgrammer({
                                    spId: spId
                                });
                                else favourOgrammer({
                                    spId: spId
                                });
                            },
                            disabled: favourResult.isLoading || unfavourResult.isLoading
                        }, "fav")
                    ]
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b67af89f29a5c371$export$23005cf6208f2360), {
                label: t("job_shifts.check_in"),
                modalVisible: checkInModalVisible,
                onConfirm: (time)=>{
                    checkIn({
                        id: shift.active_shift_id,
                        time: time
                    });
                },
                onClose: ()=>setCheckInModalVisible(false)
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b67af89f29a5c371$export$23005cf6208f2360), {
                label: t("job_shifts.check_out"),
                modalVisible: checkOutModalVisible,
                onConfirm: (time)=>{
                    checkOut({
                        id: shift.active_shift_id,
                        time: time
                    });
                },
                onClose: ()=>setCheckOutModalVisible(false)
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ddf4c9963edeb8c3$export$137c04cfead3749), {
                shiftId: shift.active_shift_id,
                label: t("job_shifts.extra_time"),
                modalVisible: extendModalVisible,
                shiftExtensionDefaultTime: shiftExtensionDefaultTime,
                onClose: ()=>setExtendModalVisible(false)
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $3329d6e4568c6bd5$export$dda52c4029d7f032), {
                cancelReasons: cancelReasons,
                shiftId: shift.active_shift_id,
                ogrammerName: name,
                modalVisible: cancelModalVisible,
                onClose: ()=>setCancelModalVisible(false),
                onSubmit: requestCancelShift
            })
        ]
    });
});
















function $168081dabbe2890c$var$ConfirmationShiftToolsComponent({ shiftId: shiftId }) {
    const { t: t } = (0, $3765cebd031b52c0$export$9fc83ad70ead8663)();
    const { scheduleModificationsAmount: scheduleModificationsAmount } = (0, $4671947198ddd366$export$6ccbb43953eebf8)().data;
    const redirect = (0, $7df35e9df335b1c8$export$602eaf6d5314ce55)();
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7b02d682eb115277$exports.Fragment), {
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
            className: "ConfirmationShiftTools",
            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $04012d5b0475752e$export$e44a253a59704894), {
                outerComponent: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                    className: "ConfirmationShiftTools__dropdownContainer",
                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                        src: (0, (/*@__PURE__*/$parcel$interopDefault($d0fc1bb354c0eba4$exports))),
                        alt: "ogrammer tools"
                    })
                }),
                items: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4fe3b599a2cc1bc4$export$2ce376c2cc3355c8), {
                        img: (0, (/*@__PURE__*/$parcel$interopDefault($85dec660949d3c41$exports))),
                        title: t("all_jobs.manage_shift"),
                        onClick: ()=>{
                            if (scheduleModificationsAmount === 0 || confirm(t("all_jobs.unsaved_changes"))) redirect((0, $0534349ae8731d0b$export$66b32f6f30eb4b4).attendanceShiftsList, {});
                        },
                        disabled: false
                    }, "manage")
                ]
            })
        })
    });
}
const $168081dabbe2890c$export$a95edacd2888d282 = (0, $aca50e9407ba89c9$export$b6ae1bc530f4c149)($168081dabbe2890c$var$ConfirmationShiftToolsComponent);

















function $1ac323d9e693cd30$var$AssignShiftToolsComponent({ jobId: jobId, shiftId: shiftId }) {
    const { t: t } = (0, $3765cebd031b52c0$export$9fc83ad70ead8663)();
    const { scheduleModificationsAmount: scheduleModificationsAmount } = (0, $4671947198ddd366$export$6ccbb43953eebf8)().data;
    const redirect = (0, $7df35e9df335b1c8$export$602eaf6d5314ce55)();
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7b02d682eb115277$exports.Fragment), {
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
            className: "AssignShiftTools",
            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $04012d5b0475752e$export$e44a253a59704894), {
                outerComponent: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                    className: "AssignShiftTools__dropdownContainer",
                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                        src: (0, (/*@__PURE__*/$parcel$interopDefault($d0fc1bb354c0eba4$exports))),
                        alt: "ogrammer tools"
                    })
                }),
                items: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4fe3b599a2cc1bc4$export$2ce376c2cc3355c8), {
                        img: (0, (/*@__PURE__*/$parcel$interopDefault($85dec660949d3c41$exports))),
                        title: t("all_jobs.select_OG"),
                        onClick: ()=>{
                            (0, $c74a0566d4b0fd6d$export$e9db7d6e73593439).track((0, $c74a0566d4b0fd6d$export$5e27155e276f6d1c).TimesheetSlotOptionSPSelectClicked);
                            if (scheduleModificationsAmount === 0 || confirm(t("all_jobs.unsaved_changes"))) redirect((0, $0534349ae8731d0b$export$66b32f6f30eb4b4).jobOGCherryPicker, {
                                jobId: String(jobId),
                                type: (0, $862a04ca6e0d681b$export$27a7f855854fa13d).oneTime,
                                shiftId: String(shiftId)
                            });
                        },
                        disabled: false
                    }, "select-og")
                ]
            })
        })
    });
}
const $1ac323d9e693cd30$export$b7338805ec7a4c5c = (0, $aca50e9407ba89c9$export$b6ae1bc530f4c149)($1ac323d9e693cd30$var$AssignShiftToolsComponent);



function $e7d561636598b847$var$SpTimeComponent({ spId: spId, spShift: spShift, shift: shift, jobSchedule: jobSchedule, spName: spName = null, showEmptySlot: showEmptySlot }) {
    const { t: t } = (0, $3765cebd031b52c0$export$9fc83ad70ead8663)();
    const { startTime: startTime, endTime: endTime } = jobSchedule.getSpTime({
        spId: spId,
        shiftId: shift.id
    });
    const timeModificationAllowed = shift.status === (0, $fc070fb25f7982a6$export$a99e0dd4ead620e).Upcoming || spShift === null;
    const startTimeModificationAllowed = timeModificationAllowed && (spShift?.client_checkin_time ?? null) === null;
    const endTimeModificationAllowed = timeModificationAllowed && (spShift?.client_checkout_time ?? null) === null;
    const highlightAllowed = shift.status === (0, $fc070fb25f7982a6$export$a99e0dd4ead620e).Started || shift.status === (0, $fc070fb25f7982a6$export$a99e0dd4ead620e).Completed;
    const startTimeDate = new Date(startTime * 1000);
    const endTimeDate = new Date(endTime * 1000);
    const { modifyWorkCategoryDateSchedule: modifyWorkCategoryDateSchedule, getSPsByWorkCategoryNameAndDate: getSPsByWorkCategoryNameAndDate } = (0, $4671947198ddd366$export$6ccbb43953eebf8)().data;
    const getUpdatedTime = (value, date)=>{
        const [hours, minutes] = value.split(":");
        const newStartTime = new Date(date);
        newStartTime.setHours(parseInt(hours));
        newStartTime.setMinutes(parseInt(minutes));
        return Math.floor(newStartTime.getTime() / 1000);
    };
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "SpTime",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "SpTime__top",
                children: spShift ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $dc4e26e0206e7d2e$export$680ea196effce5f), {
                            value: startTime ? (0, $ddf12117b815a7c3$export$d944ce49c26cbd64)(startTimeDate) : null,
                            disabled: !startTimeModificationAllowed,
                            highlighted: highlightAllowed && Boolean(startTime),
                            label: t("all_jobs.start"),
                            handleChange: (value)=>{
                                (0, $c74a0566d4b0fd6d$export$e9db7d6e73593439).track((0, $c74a0566d4b0fd6d$export$5e27155e276f6d1c).TimesheetSPStartTimeChanged);
                                jobSchedule.modifySpTime({
                                    spId: spId,
                                    shiftId: shift.id,
                                    startTime: getUpdatedTime(value, startTimeDate)
                                });
                            },
                            onPopoverAction: (itemIds)=>{
                                modifyWorkCategoryDateSchedule({
                                    workCategoryName: jobSchedule.work_category_name,
                                    locationId: jobSchedule.location_id,
                                    date: (0, (/*@__PURE__*/$parcel$interopDefault($45fvw)))(startTimeDate).format("YYYY-MM-DD"),
                                    spIds: itemIds,
                                    startTime: startTime ?? undefined
                                });
                            },
                            popoverItems: getSPsByWorkCategoryNameAndDate({
                                workCategoryName: jobSchedule.work_category_name,
                                locationId: jobSchedule.location_id,
                                date: (0, (/*@__PURE__*/$parcel$interopDefault($45fvw)))(startTimeDate).format("YYYY-MM-DD")
                            }).filter((item)=>item.value !== spId),
                            popoverDate: (0, (/*@__PURE__*/$parcel$interopDefault($45fvw)))(startTimeDate).format("ddd, DD MMM"),
                            spName: spName
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $dc4e26e0206e7d2e$export$680ea196effce5f), {
                            value: endTime ? (0, $ddf12117b815a7c3$export$d944ce49c26cbd64)(endTimeDate) : null,
                            disabled: !endTimeModificationAllowed,
                            highlighted: highlightAllowed && Boolean(endTime),
                            label: t("all_jobs.end"),
                            handleChange: (value)=>{
                                (0, $c74a0566d4b0fd6d$export$e9db7d6e73593439).track((0, $c74a0566d4b0fd6d$export$5e27155e276f6d1c).TimesheetSPEndTimeChanged);
                                jobSchedule.modifySpTime({
                                    spId: spId,
                                    shiftId: shift.id,
                                    endTime: getUpdatedTime(value, endTimeDate)
                                });
                            },
                            onPopoverAction: (itemIds)=>{
                                modifyWorkCategoryDateSchedule({
                                    workCategoryName: jobSchedule.work_category_name,
                                    locationId: jobSchedule.location_id,
                                    date: (0, (/*@__PURE__*/$parcel$interopDefault($45fvw)))(startTimeDate).format("YYYY-MM-DD"),
                                    spIds: itemIds,
                                    endTime: endTime ?? undefined
                                });
                            },
                            popoverItems: getSPsByWorkCategoryNameAndDate({
                                workCategoryName: jobSchedule.work_category_name,
                                locationId: jobSchedule.location_id,
                                date: (0, (/*@__PURE__*/$parcel$interopDefault($45fvw)))(startTimeDate).format("YYYY-MM-DD")
                            }).filter((item)=>item.value !== spId),
                            popoverDate: (0, (/*@__PURE__*/$parcel$interopDefault($45fvw)))(startTimeDate).format("ddd, DD MMM"),
                            spName: spName
                        })
                    ]
                }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7b02d682eb115277$exports.Fragment), {
                    children: showEmptySlot && shift.fulfilled_count < shift.required_quantity && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $dc4e26e0206e7d2e$export$680ea196effce5f), {
                                value: (0, $ddf12117b815a7c3$export$d944ce49c26cbd64)(new Date(shift.start_time * 1000)),
                                label: t("all_jobs.start"),
                                disabled: false,
                                handleChange: (value)=>{
                                    (0, $c74a0566d4b0fd6d$export$e9db7d6e73593439).track((0, $c74a0566d4b0fd6d$export$5e27155e276f6d1c).TimesheetStartTimeBulkChanged);
                                    jobSchedule.modifyActiveShiftsTime({
                                        shiftId: shift.id,
                                        startTime: getUpdatedTime(value, new Date(shift.start_time * 1000))
                                    });
                                }
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $dc4e26e0206e7d2e$export$680ea196effce5f), {
                                value: (0, $ddf12117b815a7c3$export$d944ce49c26cbd64)(new Date(shift.end_time * 1000)),
                                label: t("all_jobs.end"),
                                disabled: false,
                                handleChange: (value)=>{
                                    (0, $c74a0566d4b0fd6d$export$e9db7d6e73593439).track((0, $c74a0566d4b0fd6d$export$5e27155e276f6d1c).TimesheetEndTimeBulkChanged);
                                    jobSchedule.modifyActiveShiftsTime({
                                        shiftId: shift.id,
                                        endTime: getUpdatedTime(value, new Date(shift.end_time * 1000))
                                    });
                                }
                            })
                        ]
                    })
                })
            }),
            spShift ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "SpTime__bottom",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $cd031e5bfc73ff3a$export$96e9906d6d93a972), {
                        status: (0, $cd031e5bfc73ff3a$export$9ddbf12b356b47fb)(spShift.status.id),
                        title: spShift.status.title
                    }),
                    spShift.status.id === (0, $d5e0253b28c033d7$export$f7cfb7426aa37f1a).pendingConfirmation && spShift.is_available_for_confirmation ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $168081dabbe2890c$export$a95edacd2888d282), {
                        shiftId: shift.id
                    }) : shift.status === (0, $fc070fb25f7982a6$export$a99e0dd4ead620e).Started || shift.status === (0, $fc070fb25f7982a6$export$a99e0dd4ead620e).Upcoming ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f5a824c5466ad856$export$eac491c825cc5ad7), {
                        jobSchedule: jobSchedule,
                        shift: spShift,
                        spId: spId,
                        spShift: spShift
                    }) : null
                ]
            }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7b02d682eb115277$exports.Fragment), {
                children: showEmptySlot && shift.fulfilled_count < shift.required_quantity && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: "SpTime__bottom",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $cd031e5bfc73ff3a$export$96e9906d6d93a972), {
                            status: (0, $cd031e5bfc73ff3a$export$e35c1996c6f482ad).spEmpty,
                            title: t("all_jobs.empty_slot", {
                                count: shift.required_quantity - shift.fulfilled_count
                            })
                        }),
                        shift.status === (0, $fc070fb25f7982a6$export$a99e0dd4ead620e).Started || shift.status === (0, $fc070fb25f7982a6$export$a99e0dd4ead620e).Upcoming && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $1ac323d9e693cd30$export$b7338805ec7a4c5c), {
                            jobId: jobSchedule.job_id,
                            shiftId: shift.id
                        })
                    ]
                })
            })
        ]
    });
}
const $e7d561636598b847$export$c6a8a74075aba0bc = (0, $aca50e9407ba89c9$export$b6ae1bc530f4c149)($e7d561636598b847$var$SpTimeComponent);







function $38bf56ec71ba420e$export$356888f0520b9e02({ shift: shift, spShift: spShift }) {
    const { t: t } = (0, $3765cebd031b52c0$export$9fc83ad70ead8663)();
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "SpCanceled",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "SpCanceled__top",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "SpCanceled__top__timeContainer",
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                            className: "SpCanceled__top__timeContainer__label",
                            children: t("all_jobs.start")
                        })
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "SpCanceled__top__timeContainer",
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                            className: "SpCanceled__top__timeContainer__label",
                            children: t("all_jobs.end")
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "SpCanceled__bottom",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $cd031e5bfc73ff3a$export$96e9906d6d93a972), {
                        status: (0, $cd031e5bfc73ff3a$export$9ddbf12b356b47fb)(spShift.status.id),
                        title: spShift.status.title
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $168081dabbe2890c$export$a95edacd2888d282), {
                        shiftId: shift.id
                    })
                ]
            })
        ]
    });
}



function $937222df7f265634$export$74a6b716f2c59623({ jobSchedule: jobSchedule, defaultSchedule: defaultSchedule, spId: spId, shift: shift, dateShift: dateShift, spName: spName = null, showEmptySlot: showEmptySlot = false }) {
    if (!shift) return null;
    const spShift = jobSchedule.getSpShift({
        spId: spId,
        shiftId: shift.id
    }) ?? null;
    const hasSp = dateShift?.sps.has(String(spId)) && spShift;
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        className: "SpCell",
        children: hasSp ? spShift.status.id === (0, $d5e0253b28c033d7$export$f7cfb7426aa37f1a).canceled ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $38bf56ec71ba420e$export$356888f0520b9e02), {
            shift: shift,
            spShift: spShift
        }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e7d561636598b847$export$c6a8a74075aba0bc), {
            jobSchedule: jobSchedule,
            spId: spId,
            shift: shift,
            spShift: spShift,
            spName: spName,
            showEmptySlot: showEmptySlot
        }) : shift.status === (0, $fc070fb25f7982a6$export$a99e0dd4ead620e).Started || shift.status === (0, $fc070fb25f7982a6$export$a99e0dd4ead620e).Upcoming ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e7d561636598b847$export$c6a8a74075aba0bc), {
            jobSchedule: defaultSchedule,
            spId: spId,
            shift: shift,
            spShift: spShift,
            spName: spName,
            showEmptySlot: showEmptySlot
        }) : null
    });
}
const $937222df7f265634$export$2768435e77275f3a = (0, $aca50e9407ba89c9$export$b6ae1bc530f4c149)($937222df7f265634$export$74a6b716f2c59623);















var $acw62 = parcelRequire("acw62");








var $45fvw = parcelRequire("45fvw");


const $df4c0b5b8ada8e08$export$19e09bcf95127a63 = (0, $aca50e9407ba89c9$export$b6ae1bc530f4c149)(({ startDate: startDate, setStartDate: setStartDate, endDate: endDate, setEndDate: setEndDate })=>{
    const { t: t } = (0, $3765cebd031b52c0$export$9fc83ad70ead8663)();
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                className: "Popup__title",
                children: t("order_extension.for_how_long_extend")
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                className: "Popup__subtitle",
                children: t("order_extension.you_can_extend_order")
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "BulkJobsExtension__popup__innerContainer",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $1579b0c3590d1ee8$export$7edc06cf1783b30f), {
                    label: t("order_draft.start_date"),
                    value: startDate ?? "",
                    handleChange: setStartDate,
                    min: (0, (/*@__PURE__*/$parcel$interopDefault($45fvw)))().format("YYYY-MM-DD"),
                    className: "Dates__dateInput"
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $660b2ca422e0e2ae$export$1ff3c3f08ae963c0).Vertical, {
                height: 10
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "BulkJobsExtension__popup__innerContainer",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $1579b0c3590d1ee8$export$7edc06cf1783b30f), {
                    label: t("order_draft.end_date"),
                    value: endDate ?? "",
                    handleChange: setEndDate,
                    min: startDate ?? undefined,
                    className: "Dates__dateInput"
                })
            })
        ]
    });
});











var $45fvw = parcelRequire("45fvw");



const $9f2cdeb50898474a$export$ded2298abc2a0f4 = ({ sp: sp, onClick: onClick, selected: selected })=>{
    const { t: t } = (0, $3765cebd031b52c0$export$9fc83ad70ead8663)();
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        onClick: onClick,
        className: "ExtendedSPItem",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "ExtendedSPItem__body",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                        className: "ExtendedSPItem__body__image",
                        src: String(sp.image)
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "ExtendedSPItem__content",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                className: "ExtendedSPItem__titleContainer",
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                    className: "ExtendedSPItem__title",
                                    children: sp.name
                                })
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $660b2ca422e0e2ae$export$1ff3c3f08ae963c0).Vertical, {
                                height: 5
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                className: "ExtendedSPItem__subtitle",
                                children: [
                                    t("order_extension.current_end_date"),
                                    " ",
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                        children: (0, (/*@__PURE__*/$parcel$interopDefault($45fvw)))(sp.current_end_date, "YYYY-MM-DD").format("MMM DD")
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f224f10e61e1d993$export$48513f6b9f8ce62d), {
                isActive: selected,
                type: "square"
            })
        ]
    }, sp.id);
};


const $c09d4711d73452e5$export$d1fff6d16b23dbdc = ({ spToExtendOptions: spToExtendOptions, selectedSpIds: selectedSpIds, addOrRemoveSP: addOrRemoveSP })=>{
    const { t: t } = (0, $3765cebd031b52c0$export$9fc83ad70ead8663)();
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "SPsSelector",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                className: "Popup__title",
                children: t("order_extension.select_sps")
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                className: "Popup__subtitle",
                children: t("order_extension.select_sps_to_extend")
            }),
            selectedSpIds.length > 0 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7b02d682eb115277$exports.Fragment), {
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                    className: "SPsSelector__addedList",
                    children: spToExtendOptions.filter((sp)=>selectedSpIds.includes(sp.id)).map((sp)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            onClick: ()=>addOrRemoveSP(sp.id),
                            className: "SPsSelector__addedList__item",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                    children: sp.name
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                                    src: (0, (/*@__PURE__*/$parcel$interopDefault($b2aa47be5050cdd8$exports)))
                                })
                            ]
                        }, sp.id))
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "SPsSelector__list",
                children: spToExtendOptions.map((sp)=>{
                    const selected = selectedSpIds.includes(sp.id);
                    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $9f2cdeb50898474a$export$ded2298abc2a0f4), {
                        onClick: ()=>addOrRemoveSP(sp.id),
                        sp: sp,
                        selected: selected
                    }, sp.id);
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $660b2ca422e0e2ae$export$1ff3c3f08ae963c0).Vertical, {
                height: 24
            })
        ]
    });
};





const $1c6781767eebbf51$var$STEP_DATES_SELECTION = 0;
const $1c6781767eebbf51$var$STEP_SPS_SELECTION = 1;
const $1c6781767eebbf51$export$4f120b60e79b54e6 = (0, $a4963babae245ff9$export$f0c7a449e0cfaec7)((0, $aca50e9407ba89c9$export$b6ae1bc530f4c149)(({ isOpen: isOpen, close: close, clearOnClose: clearOnClose, spToExtendOptions: spToExtendOptions, onSuccess: onSuccess = ()=>{} })=>{
    const [step, setStep] = (0, $acw62.useState)($1c6781767eebbf51$var$STEP_DATES_SELECTION);
    const [startDate, setStartDate] = (0, $acw62.useState)(null);
    const [extensionDate, setExtensionDate] = (0, $acw62.useState)(null);
    const [jobsToExtend, setJobsToExtend] = (0, $acw62.useState)([]);
    const redirect = (0, $7df35e9df335b1c8$export$602eaf6d5314ce55)();
    const { bulkExtendJobs: bulkExtendJobs } = (0, $4671947198ddd366$export$6ccbb43953eebf8)().data;
    const [, bulkExtendJobsRequest] = (0, $4671947198ddd366$export$609860bf8b0084c)(({ jobs: jobs })=>bulkExtendJobs({
            jobs: jobs
        }), {
        onSuccess: (orderId)=>{
            redirect((0, $0534349ae8731d0b$export$66b32f6f30eb4b4).extendedOrderDraft, {
                orderId: orderId
            });
        },
        onError: (err)=>{
            (0, $60f27fc97e29822a$export$b410431fab84fa58).error(err.data.message);
        },
        filterError: [
            (0, $9ad33fbf770c55a1$export$9696fcf1798e1cb5).ClientError
        ]
    });
    const getSelectedSpIds = ()=>{
        const result = [];
        jobsToExtend.forEach((job)=>{
            job.invited_sps.forEach((sp)=>{
                if (!result.includes(sp)) result.push(sp);
            });
        });
        return result;
    };
    const addOrRemoveSP = (id)=>{
        const sp = spToExtendOptions.find((item)=>item.id === id);
        if (!sp) return;
        const job = jobsToExtend.find((item)=>item.id === sp.job_id);
        if (!job) {
            const modifiedJobs = [
                ...jobsToExtend,
                {
                    id: sp.job_id,
                    start_date: startDate ?? "",
                    extension_date: extensionDate ?? "",
                    invited_sps: [
                        sp.id
                    ]
                }
            ];
            setJobsToExtend(modifiedJobs);
        } else {
            const modifiedJobs = jobsToExtend.map((item)=>{
                if (item.id !== job.id) return item;
                return {
                    ...item,
                    invited_sps: item.invited_sps.includes(sp.id) ? item.invited_sps.filter((invitedSP)=>invitedSP !== sp.id) : [
                        ...item.invited_sps,
                        sp.id
                    ]
                };
            }).filter((item)=>item.invited_sps.length > 0);
            setJobsToExtend(modifiedJobs);
        }
    };
    const { t: t } = (0, $3765cebd031b52c0$export$9fc83ad70ead8663)();
    const getNextDisabled = ()=>{
        if (step === $1c6781767eebbf51$var$STEP_DATES_SELECTION) return startDate === null || extensionDate === null;
        else return jobsToExtend.length === 0;
    };
    const handleNextPress = ()=>{
        if (step === $1c6781767eebbf51$var$STEP_DATES_SELECTION) setStep($1c6781767eebbf51$var$STEP_SPS_SELECTION);
        else bulkExtendJobsRequest({
            jobs: jobsToExtend
        });
    };
    const handleBackPress = ()=>{
        if (step === $1c6781767eebbf51$var$STEP_SPS_SELECTION) setStep($1c6781767eebbf51$var$STEP_DATES_SELECTION);
    };
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $9c16b10bbbe042e5$export$129a32eedafa97c5), {
        isActive: isOpen,
        content: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: "BulkJobsExtension__popup",
                    children: [
                        step === $1c6781767eebbf51$var$STEP_DATES_SELECTION && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $df4c0b5b8ada8e08$export$19e09bcf95127a63), {
                            startDate: startDate,
                            setStartDate: setStartDate,
                            endDate: extensionDate,
                            setEndDate: setExtensionDate
                        }),
                        step === $1c6781767eebbf51$var$STEP_SPS_SELECTION && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c09d4711d73452e5$export$d1fff6d16b23dbdc), {
                            spToExtendOptions: spToExtendOptions,
                            selectedSpIds: getSelectedSpIds(),
                            addOrRemoveSP: addOrRemoveSP
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $660b2ca422e0e2ae$export$1ff3c3f08ae963c0).Spacer, {}),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $9dfc32a0a996fa14$export$ed8ca599049e8881), {
                    currentStep: step,
                    stepsCount: 2,
                    backDisabled: step === $1c6781767eebbf51$var$STEP_DATES_SELECTION,
                    nextDisabled: getNextDisabled(),
                    handleNextPress: handleNextPress,
                    handleBackPress: handleBackPress,
                    nextButtonLabel: t("page_stepper.next")
                })
            ]
        }),
        close: ()=>{
            close();
            if (clearOnClose) {
                setStep($1c6781767eebbf51$var$STEP_DATES_SELECTION);
                setStartDate(null);
                setExtensionDate(null);
                setJobsToExtend([]);
            }
        }
    });
}));


const $f0086d6b4679393f$export$3b285ac585bbda54 = (0, $aca50e9407ba89c9$export$b6ae1bc530f4c149)(({ workCategorySchedule: workCategorySchedule, firstWeekDate: firstWeekDate, weekDates: weekDates })=>{
    const { t: t } = (0, $3765cebd031b52c0$export$9fc83ad70ead8663)();
    const [collapsed, setCollapsed] = (0, $acw62.useState)(false);
    const [showBulkExtendPopup, setShowBulkExtendPopup] = (0, $acw62.useState)(false);
    const rowsNum = workCategorySchedule.quantity;
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "ScheduleItem__subheader",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                        onClick: ()=>setCollapsed(!collapsed),
                        src: collapsed ? (0, (/*@__PURE__*/$parcel$interopDefault($ad94f1ad0ce40ff8$exports))) : (0, (/*@__PURE__*/$parcel$interopDefault($3f358c88739d96d9$exports))),
                        className: "ScheduleItem__subheader__arrow"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                        className: "ScheduleItem__subheader__title",
                        children: [
                            workCategorySchedule.work_category_name,
                            " (",
                            workCategorySchedule.quantity,
                            ")"
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "ScheduleItem__subheader__dropdownContainer",
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $04012d5b0475752e$export$e44a253a59704894), {
                            outerComponent: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                                    src: (0, (/*@__PURE__*/$parcel$interopDefault($7dbbbb6844d31f11$exports)))
                                })
                            }),
                            items: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $bd25114c2c6a2977$export$2ce376c2cc3355c8), {
                                    img: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                                        src: (0, (/*@__PURE__*/$parcel$interopDefault($c059f3362464885b$exports)))
                                    }),
                                    title: t("Extend the Date"),
                                    onClick: ()=>setShowBulkExtendPopup(true)
                                }, "extend")
                            ]
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $d7d699d270b6e0ff$export$6eb0f7ddcda6131f), {
                collapsed: collapsed,
                maxHeight: 92 * rowsNum + 350,
                children: [
                    workCategorySchedule.assigned_sps.map((spItem, index)=>{
                        return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7b02d682eb115277$exports.Fragment), {
                            children: spItem.original_schedule.map((originalSchedule)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                    className: `ScheduleItem__row ${index % 2 === 0 ? "odd" : ""}`,
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $aedbca7c4de9cfc5$export$d41802dec660cc2b), {
                                            imageUrl: spItem.image,
                                            name: spItem.name,
                                            spId: spItem.sp_id,
                                            jobId: originalSchedule.job_id
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $d138f1021db5629b$export$99889833ab266a29), {
                                            weekDates: weekDates,
                                            firstWeekDate: firstWeekDate,
                                            jobSchedules: spItem.original_schedule.length > 0 ? [
                                                originalSchedule
                                            ] : [
                                                workCategorySchedule.default_schedule
                                            ],
                                            renderCell: ({ jobSchedule: jobSchedule, shift: shift, dateShift: dateShift })=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $937222df7f265634$export$2768435e77275f3a), {
                                                    shift: shift,
                                                    dateShift: dateShift,
                                                    defaultSchedule: workCategorySchedule.default_schedule,
                                                    spId: spItem.sp_id,
                                                    jobSchedule: jobSchedule ?? workCategorySchedule.default_schedule,
                                                    spName: spItem.name,
                                                    showEmptySlot: false
                                                })
                                        })
                                    ]
                                }, index))
                        });
                    }),
                    workCategorySchedule.unfulfilled_schedules.map((unfulfilledSchedule, index)=>{
                        const requiredOGsCount = Math.max(...Array.from(unfulfilledSchedule.shifts.values()).map((shiftItem)=>{
                            return shiftItem.required_quantity - shiftItem.fulfilled_count;
                        }));
                        return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: `ScheduleItem__row ${index % 2 === 0 ? "odd" : ""}`,
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $aedbca7c4de9cfc5$export$d41802dec660cc2b), {
                                    name: `${requiredOGsCount} OGs required`,
                                    applicantsCount: unfulfilledSchedule.applicants_count,
                                    jobId: unfulfilledSchedule.job_id,
                                    isAggregation: true
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $d138f1021db5629b$export$99889833ab266a29), {
                                    weekDates: weekDates,
                                    firstWeekDate: firstWeekDate,
                                    jobSchedules: [
                                        unfulfilledSchedule
                                    ],
                                    renderCell: ({ shift: shift, dateShift: dateShift })=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $937222df7f265634$export$2768435e77275f3a), {
                                            shift: shift,
                                            dateShift: dateShift,
                                            defaultSchedule: workCategorySchedule.default_schedule,
                                            spId: -1,
                                            jobSchedule: unfulfilledSchedule,
                                            showEmptySlot: true
                                        })
                                })
                            ]
                        }, index);
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $1c6781767eebbf51$export$4f120b60e79b54e6), {
                isOpen: showBulkExtendPopup,
                close: ()=>setShowBulkExtendPopup(false),
                clearOnClose: true,
                spToExtendOptions: workCategorySchedule.assigned_sps.map((sp)=>{
                    return {
                        id: sp.sp_id,
                        name: sp.name,
                        image: sp.image,
                        job_id: sp.original_schedule[sp.original_schedule.length - 1].job_id,
                        current_end_date: sp.original_schedule[sp.original_schedule.length - 1].end_date
                    };
                })
            })
        ]
    });
});


function $815a4e1cd11a083f$var$ScheduleItemComponent({ locationSchedule: locationSchedule, firstWeekDate: firstWeekDate, weekDates: weekDates }) {
    const [collapsed, setCollapsed] = (0, $acw62.useState)(false);
    const rowsNum = locationSchedule.work_categories.reduce((sum, item)=>sum + item.quantity, 0);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "ScheduleItem",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "ScheduleItem__header",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                        onClick: ()=>setCollapsed(!collapsed),
                        src: collapsed ? (0, (/*@__PURE__*/$parcel$interopDefault($ad94f1ad0ce40ff8$exports))) : (0, (/*@__PURE__*/$parcel$interopDefault($3f358c88739d96d9$exports))),
                        className: "ScheduleItem__header__arrow"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                        src: (0, (/*@__PURE__*/$parcel$interopDefault($2cf662f6f197957c$exports))),
                        className: "ScheduleItem__header__icon"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                        className: "ScheduleItem__header__title",
                        children: locationSchedule.location_name
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $d7d699d270b6e0ff$export$6eb0f7ddcda6131f), {
                collapsed: collapsed,
                maxHeight: 92 * rowsNum + 350,
                children: locationSchedule.work_categories.map((workCategorySchedule, key)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f0086d6b4679393f$export$3b285ac585bbda54), {
                        workCategorySchedule: workCategorySchedule,
                        firstWeekDate: firstWeekDate,
                        weekDates: weekDates
                    }, key))
            })
        ]
    });
}
const $815a4e1cd11a083f$export$32bdb1b219da874c = (0, $aca50e9407ba89c9$export$b6ae1bc530f4c149)($815a4e1cd11a083f$var$ScheduleItemComponent);








const $c80a53d579021211$var$MIN_ROWS = 8;
function $c80a53d579021211$var$CalendarScheduleComponent({ firstWeekDate: firstWeekDate }) {
    const [orderIdToExtend, setOrderIdToExtend] = (0, $acw62.useState)(null);
    const { getJobsScheduleForWeek: getJobsScheduleForWeek, groupedSchedule: groupedSchedule } = (0, $4671947198ddd366$export$6ccbb43953eebf8)().data;
    const formatedWeekDate = (0, $ddf12117b815a7c3$export$efb113ee57e9edfb)(firstWeekDate);
    const jobsScheduleForWeek = getJobsScheduleForWeek(formatedWeekDate);
    const weekDates = (0, $ddf12117b815a7c3$export$8a5160aad7ff40be)(firstWeekDate);
    const emptyColumns = (0, $acw62.useMemo)(()=>{
        const jobs = jobsScheduleForWeek.length;
        const assignedSps = jobsScheduleForWeek.reduce((spsCount, jobScheduleItem)=>{
            return spsCount + jobScheduleItem.assigned_sps.size;
        }, 0);
        const totalRows = jobs + assignedSps;
        const diff = $c80a53d579021211$var$MIN_ROWS - totalRows;
        const numberOfEmptyColumns = diff > 0 ? diff : 0;
        return new Array(numberOfEmptyColumns).fill(null);
    }, [
        jobsScheduleForWeek
    ]);
    (0, $acw62.useEffect)(()=>{
        const scheduleItem = jobsScheduleForWeek.find((item)=>item.order_id === orderIdToExtend);
        // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
        if (scheduleItem) {
            const order = {
                id: scheduleItem.order_id,
                end_date: scheduleItem.end_date,
                jobs: [
                    {
                        id: scheduleItem.job_id,
                        location_name: scheduleItem.location_name,
                        work_category_name: scheduleItem.work_category_name,
                        quantity: scheduleItem.quantity,
                        start_date: scheduleItem.start_date,
                        end_date: scheduleItem.end_date,
                        min_extension_date: (0, (/*@__PURE__*/$parcel$interopDefault($45fvw)))(scheduleItem.end_date, "YYYY-MM-DD").add(1, "days").format("YYYY-MM-DD")
                    }
                ]
            };
            (0, $d6286036be37a1b2$export$957fdea8025b4555).clear();
            (0, $d6286036be37a1b2$export$957fdea8025b4555).createFromOrderModel(order);
        }
    }, [
        orderIdToExtend
    ]);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "CalendarSchedule",
        children: [
            groupedSchedule.map((locationSchedule)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $815a4e1cd11a083f$export$32bdb1b219da874c), {
                    locationSchedule: locationSchedule,
                    firstWeekDate: firstWeekDate,
                    weekDates: weekDates
                }, locationSchedule.toString())),
            emptyColumns.map((_, index)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                    className: "ScheduleItem",
                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "ScheduleItem__row",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                className: "JobColumn"
                            }),
                            weekDates.map((__, i)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $acw62.Fragment), {
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7f0bcd362b4bc024$export$77aefc78c058cb5d), {}),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c3e48ebea9c34168$export$816b5d811295e6bc), {
                                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7b02d682eb115277$exports.Fragment), {})
                                        })
                                    ]
                                }, i))
                        ]
                    })
                }, index)),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $9c0551f59559aa01$export$c0bfcb316fefc2db), {
                isOpen: orderIdToExtend !== null,
                close: ()=>setOrderIdToExtend(null),
                onSuccess: ()=>(0, $c74a0566d4b0fd6d$export$e9db7d6e73593439).track((0, $c74a0566d4b0fd6d$export$5e27155e276f6d1c).ExtendedOrderFromAllJobs),
                clearOnClose: true
            })
        ]
    });
}
const $c80a53d579021211$export$8d2908c223fc8223 = (0, $aca50e9407ba89c9$export$b6ae1bc530f4c149)($c80a53d579021211$var$CalendarScheduleComponent);











function $37798c4ccfb3c41c$var$CalendarModificationsControlComponent() {
    const { scheduleModificationsAmount: scheduleModificationsAmount, clearScheduleChanges: clearScheduleChanges, applyScheduleChanges: applyScheduleChanges } = (0, $4671947198ddd366$export$6ccbb43953eebf8)().data;
    const [_, requestApplySchedule] = (0, $4671947198ddd366$export$609860bf8b0084c)(applyScheduleChanges, {
        filterError: [
            (0, $9ad33fbf770c55a1$export$9696fcf1798e1cb5).ClientError
        ],
        onSuccess: ()=>{
            (0, $60f27fc97e29822a$export$b410431fab84fa58).success(t("all_jobs.update_success"));
            clearScheduleChanges();
        },
        onError: (err)=>{
            if (err.data.errors) {
                const firstError = Object.values(err.data.errors)[0][0];
                (0, $60f27fc97e29822a$export$b410431fab84fa58).error(firstError);
            } else (0, $60f27fc97e29822a$export$b410431fab84fa58).error(err.data.message);
        }
    });
    const { t: t } = (0, $3765cebd031b52c0$export$9fc83ad70ead8663)();
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "CalendarModificationsControl",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $2ab88429e3384d30$export$353f5b6fc5456de1), {
                onClick: ()=>{
                    (0, $c74a0566d4b0fd6d$export$e9db7d6e73593439).track((0, $c74a0566d4b0fd6d$export$5e27155e276f6d1c).TimesheetCancelClicked);
                    clearScheduleChanges();
                },
                className: "CalendarModificationsControl__cancel",
                children: t("all_jobs.cancel")
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $2ab88429e3384d30$export$353f5b6fc5456de1), {
                className: "CalendarModificationsControl__applyChanges",
                disabled: scheduleModificationsAmount === 0,
                onClick: ()=>{
                    (0, $c74a0566d4b0fd6d$export$e9db7d6e73593439).track((0, $c74a0566d4b0fd6d$export$5e27155e276f6d1c).TimesheetSaveClicked);
                    requestApplySchedule(undefined);
                },
                children: t("all_jobs.save_changes_count", {
                    count: scheduleModificationsAmount
                })
            })
        ]
    });
}
const $37798c4ccfb3c41c$export$7bf59d206a1e73fe = (0, $aca50e9407ba89c9$export$b6ae1bc530f4c149)($37798c4ccfb3c41c$var$CalendarModificationsControlComponent);





function $32202d78aec67470$var$CalendarWrapperComponent({ initialDate: initialDate }) {
    const { clearScheduleData: clearScheduleData, getSchedule: getSchedule, fetchShiftCancelReasons: fetchShiftCancelReasons } = (0, $4671947198ddd366$export$6ccbb43953eebf8)().data;
    const [selectedDate, setSelectedDate] = (0, $acw62.useState)((0, $ddf12117b815a7c3$export$f9258517a71b34d8)(initialDate));
    const [locationIds, setLocationIds] = (0, $acw62.useState)([]);
    const [designationIds, setDesignationIds] = (0, $acw62.useState)([]);
    const { enableQuery: loadSchedule, query: scheduleQuery } = (0, $4671947198ddd366$export$517ca4f7fee4e226)(()=>getSchedule(selectedDate, locationIds, designationIds));
    const { isLoading: cancelReasonsLoading } = (0, $4671947198ddd366$export$dd0a697e1782aedd)(fetchShiftCancelReasons);
    const setCurrentWeek = ()=>{
        setSelectedDate((0, $ddf12117b815a7c3$export$f9258517a71b34d8)(initialDate));
    };
    const selectWeek = (weekDay)=>{
        const initialDayOfWeek = initialDate.getDay();
        // Create a new date based on weekDay
        const adjustedDate = new Date(weekDay);
        // Calculate the difference in days and adjust
        const dayDifference = initialDayOfWeek - adjustedDate.getDay();
        adjustedDate.setDate(adjustedDate.getDate() + dayDifference);
        setSelectedDate((0, $ddf12117b815a7c3$export$f9258517a71b34d8)(adjustedDate));
    };
    (0, $acw62.useEffect)(()=>{
        clearScheduleData();
    }, []);
    (0, $acw62.useEffect)(()=>{
        loadSchedule();
    }, [
        selectedDate,
        locationIds,
        designationIds
    ]);
    const fetchingData = scheduleQuery.isLoading || cancelReasonsLoading;
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "CalendarWrapper",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "CalendarWrapper__calendar",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $6a9f0ca1529bcf13$export$9c75275274db0b56), {
                        month: selectedDate.toLocaleString(navigator.language, {
                            month: "long"
                        }),
                        year: String(selectedDate.getFullYear()),
                        locationIds: locationIds,
                        setLocationIds: setLocationIds,
                        designationIds: designationIds,
                        setDesignationIds: setDesignationIds,
                        onPreviousWeekPress: ()=>{
                            setSelectedDate((0, $ddf12117b815a7c3$export$d5ed68591eccfcf8)(selectedDate, -7));
                        },
                        onNextWeekPress: ()=>{
                            setSelectedDate((0, $ddf12117b815a7c3$export$d5ed68591eccfcf8)(selectedDate, 7));
                        },
                        selectedDate: selectedDate,
                        setSelectedDate: selectWeek,
                        setCurrentWeek: setCurrentWeek
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $dbc13932976f284e$export$adf10f8fbb88fe03), {
                        firstWeekDate: selectedDate
                    }),
                    fetchingData ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $57fb8f45c69e1681$export$2e2bcd8739ae039), {}) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c80a53d579021211$export$8d2908c223fc8223), {
                        firstWeekDate: selectedDate
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "CalendarWrapper__spacer"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $37798c4ccfb3c41c$export$7bf59d206a1e73fe), {})
        ]
    });
}
const $32202d78aec67470$export$83ab9905f75b2566 = (0, $aca50e9407ba89c9$export$b6ae1bc530f4c149)($32202d78aec67470$var$CalendarWrapperComponent);







const $38e1b6ea4bd655b6$export$b47a5602cb458a92 = (0, $a4963babae245ff9$export$f0c7a449e0cfaec7)((0, $aca50e9407ba89c9$export$b6ae1bc530f4c149)((props)=>{
    const { t: t } = (0, $3765cebd031b52c0$export$9fc83ad70ead8663)();
    (0, $acw62.useEffect)(()=>{
        (0, $34dcbefa7de5eb80$export$a1544dad697b423d)("extensionAnnouncementWasShown", true);
    }, []);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "AllJobs",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7ae42b63183f30b4$export$8b251419efc915eb), {
                title: t("all_jobs.title"),
                rightComponent: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $d836dbae630d7085$export$d96d49503bc30c36), {})
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $660b2ca422e0e2ae$export$1ff3c3f08ae963c0).Vertical, {
                height: 30
            }),
            !Boolean((0, $34dcbefa7de5eb80$export$11e63f7b0f3d9900)("extensionAnnouncementWasShown")) && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7a26230deaaf6920$export$944fe0ec49485b21), {
                theme: (0, $7a26230deaaf6920$export$14faa19a0f3bbeb2).Orange,
                title: t("all_jobs.extension_announcement"),
                textStyle: {
                    width: "unset"
                }
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $660b2ca422e0e2ae$export$1ff3c3f08ae963c0).Vertical, {
                height: 10
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $32202d78aec67470$export$83ab9905f75b2566), {
                initialDate: new Date(Date.parse(props.date))
            })
        ]
    });
}));


const $116fbdfde670ce8d$export$8e2c0157413104f5 = {
    AllJobsPage: $38e1b6ea4bd655b6$export$b47a5602cb458a92
};










const $f4383430c435b564$export$7f9c7ed0ad0f4b7b = ({ url: url, title: title, params: params, className: className, icon: icon })=>{
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7df35e9df335b1c8$export$a6c7ac8248d6e38a), {
        route: url,
        params: params ?? {},
        className: "IconButtonLink",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                src: icon,
                alt: "",
                className: "IconButtonLink__icon"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $660b2ca422e0e2ae$export$1ff3c3f08ae963c0).Horizontal, {
                width: 15
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                className: "IconButtonLink__label",
                children: title
            })
        ]
    });
};







var $5cca6149c8cf311e$exports = {};
$5cca6149c8cf311e$exports = new URL("edit-grey-icon.cf349cb3.svg", import.meta.url).toString();






const $4d0e763edbad1b87$var$LocationItem = ({ location: location })=>{
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7df35e9df335b1c8$export$a6c7ac8248d6e38a), {
        route: (0, $0534349ae8731d0b$export$66b32f6f30eb4b4).editLocations,
        params: {
            id: String(location.id)
        },
        className: "LocationItem",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "LocationItem__main",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "LocationItem__nameContainer",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                                className: "LocationItem__locationIcon",
                                src: (0, (/*@__PURE__*/$parcel$interopDefault($95d3187d11b7b718$exports)))
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h3", {
                                className: "LocationItem__name",
                                children: location.name
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                        src: (0, (/*@__PURE__*/$parcel$interopDefault($5cca6149c8cf311e$exports)))
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $660b2ca422e0e2ae$export$1ff3c3f08ae963c0).Vertical, {
                height: 6
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "LocationItem__address",
                children: location.address
            })
        ]
    });
};
var $4d0e763edbad1b87$export$2e2bcd8739ae039 = $4d0e763edbad1b87$var$LocationItem;


var $62602b8f686bd11f$exports = {};
$62602b8f686bd11f$exports = new URL("add-location-icon.b6676541.svg", import.meta.url).toString();




const $b9989c7447d507f1$export$3d0b35ee7b0ceec5 = (0, $a4963babae245ff9$export$f0c7a449e0cfaec7)((0, $aca50e9407ba89c9$export$b6ae1bc530f4c149)(()=>{
    const { locationsDataView: locationsDataView, getLocations: getLocations, getRegions: getRegions } = (0, $4671947198ddd366$export$6ccbb43953eebf8)().data;
    const { isLoading: locationsLoading } = (0, $4671947198ddd366$export$dd0a697e1782aedd)(()=>getLocations({}));
    const { isLoading: regionsLoading } = (0, $4671947198ddd366$export$dd0a697e1782aedd)(getRegions);
    const { t: t } = (0, $3765cebd031b52c0$export$9fc83ad70ead8663)();
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "LocationList",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7ae42b63183f30b4$export$8b251419efc915eb), {
                subTitle: locationsDataView.length ? t("location_list.you_have_n_locations", {
                    locationsCount: locationsDataView.length
                }) : "",
                title: t("location_list.title")
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $660b2ca422e0e2ae$export$1ff3c3f08ae963c0).Vertical, {
                height: 54
            }),
            locationsLoading || regionsLoading ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $57fb8f45c69e1681$export$2e2bcd8739ae039), {}) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "LocationList__list",
                        children: locationsDataView.map((location)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4d0e763edbad1b87$export$2e2bcd8739ae039), {
                                        location: location
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $660b2ca422e0e2ae$export$1ff3c3f08ae963c0).Vertical, {
                                        height: 16
                                    })
                                ]
                            }, location.id))
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $660b2ca422e0e2ae$export$1ff3c3f08ae963c0).Vertical, {
                        height: 31
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f4383430c435b564$export$7f9c7ed0ad0f4b7b), {
                        url: (0, $0534349ae8731d0b$export$66b32f6f30eb4b4).addLocations,
                        title: t("location_list.add_location"),
                        icon: (0, (/*@__PURE__*/$parcel$interopDefault($62602b8f686bd11f$exports)))
                    })
                ]
            })
        ]
    });
}));















const $06f1e58164b61150$var$EditLocationPage = (0, $a4963babae245ff9$export$f0c7a449e0cfaec7)((0, $aca50e9407ba89c9$export$b6ae1bc530f4c149)((props)=>{
    const store = (0, $4671947198ddd366$export$6ccbb43953eebf8)();
    const navigate = (0, $7df35e9df335b1c8$export$602eaf6d5314ce55)();
    const navigateToLocationsList = ()=>navigate((0, $0534349ae8731d0b$export$66b32f6f30eb4b4).locations, {});
    const getLocationQuery = (0, $4671947198ddd366$export$dd0a697e1782aedd)(()=>store.data.getLocation(props.id));
    const [saveResult, save] = (0, $4671947198ddd366$export$609860bf8b0084c)((data)=>store.data.updateLocation(props.id, data), {
        onSuccess: navigateToLocationsList,
        filterError: [
            (0, $9ad33fbf770c55a1$export$9696fcf1798e1cb5).ClientError
        ]
    });
    const [deleteLocationResult, deleteLocation] = (0, $4671947198ddd366$export$609860bf8b0084c)(()=>store.data.deleteLocation(props.id), {
        onSuccess: navigateToLocationsList
    });
    const location = store.data.locations.get(props.id);
    const { t: t } = (0, $3765cebd031b52c0$export$9fc83ad70ead8663)();
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "EditLocationPage",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7ae42b63183f30b4$export$8b251419efc915eb), {
                title: t("edit_location.title"),
                showBack: true
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $660b2ca422e0e2ae$export$1ff3c3f08ae963c0).Vertical, {
                height: 16
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "EditLocationPage__container",
                children: getLocationQuery.isLoading || saveResult.isLoading || deleteLocationResult.isLoading ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $57fb8f45c69e1681$export$2e2bcd8739ae039), {}) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f89478b840ca1510$export$9266547375a7de3d), {
                    onDeleteLocation: ()=>{
                        deleteLocation(props.id);
                    },
                    onSubmit: save,
                    initialValues: {
                        ...location
                    },
                    showSubmit: true,
                    showLocationNameField: true,
                    showAddressDetailsField: true,
                    showImageField: true,
                    showCheckInRestrictionsBlock: true
                })
            })
        ]
    });
}));
var $06f1e58164b61150$export$2e2bcd8739ae039 = $06f1e58164b61150$var$EditLocationPage;


const $fa8370b9eeaef971$export$5f239357e319234c = {
    AddLocationPage: $606c9b8f795454be$export$2e2bcd8739ae039,
    EditLocationPage: $06f1e58164b61150$export$2e2bcd8739ae039,
    LocationListPage: $b9989c7447d507f1$export$3d0b35ee7b0ceec5
};




var $acw62 = parcelRequire("acw62");








var $acw62 = parcelRequire("acw62");







var $66a85520928e8e97$exports = {};
$66a85520928e8e97$exports = new URL("edit-pencil.cf349cb3.svg", import.meta.url).toString();


var $7b5015d63389fc7c$exports = {};
$7b5015d63389fc7c$exports = new URL("avatar-placeholder.bdf280fa.svg", import.meta.url).toString();




const $1023e18b562b50ff$var$getRoleByNumber = (role)=>{
    switch(role){
        case (0, $97fa7686fb8e51ed$export$eb3485a690c2f0b8).Admin:
            return "user_management.role_admin";
        case (0, $97fa7686fb8e51ed$export$eb3485a690c2f0b8).Owner:
            return "user_management.role_owner";
        case (0, $97fa7686fb8e51ed$export$eb3485a690c2f0b8).Manager:
            return "user_management.role_manager";
        case (0, $97fa7686fb8e51ed$export$eb3485a690c2f0b8).Finance:
            return "user_management.role_finance";
    }
};
const $1023e18b562b50ff$export$78e8870b5d8ae469 = (0, $a4963babae245ff9$export$f0c7a449e0cfaec7)((0, $aca50e9407ba89c9$export$b6ae1bc530f4c149)(({ id: id, name: name, imageURL: imageURL, roles: roles, locations: locations })=>{
    const { getLocationNameById: getLocationNameById } = (0, $4671947198ddd366$export$6ccbb43953eebf8)().data;
    const editingAlowed = !roles.includes((0, $97fa7686fb8e51ed$export$eb3485a690c2f0b8).Owner);
    const redirect = (0, $7df35e9df335b1c8$export$602eaf6d5314ce55)();
    const { t: t } = (0, $3765cebd031b52c0$export$9fc83ad70ead8663)();
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        onClick: ()=>{
            if (!editingAlowed) return;
            redirect((0, $0534349ae8731d0b$export$66b32f6f30eb4b4).createUser, {
                id: String(id)
            });
        },
        className: `UserCard ${locations ? "increased" : ""} ${editingAlowed ? "clickable" : ""}`,
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "UserCard__leftContainer",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                        src: imageURL ?? (0, (/*@__PURE__*/$parcel$interopDefault($7b5015d63389fc7c$exports))),
                        alt: "",
                        className: `UserCard__leftContainer__userPhoto ${imageURL ? "" : "placeholder"}`
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $660b2ca422e0e2ae$export$1ff3c3f08ae963c0).Horizontal, {
                        width: 8
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "UserCard__leftContainer__userInfo",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                className: "UserCard__leftContainer__userInfo__name",
                                children: name
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                className: "UserCard__leftContainer__userInfo__locations",
                                children: locations?.map((locationId)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $acw62.Fragment), {
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                className: "UserCard__leftContainer__userInfo__locations__location",
                                                children: getLocationNameById(String(locationId))
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $660b2ca422e0e2ae$export$1ff3c3f08ae963c0).Vertical, {
                                                height: 3
                                            })
                                        ]
                                    }, locationId))
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $660b2ca422e0e2ae$export$1ff3c3f08ae963c0).Horizontal, {
                        width: 8
                    }),
                    roles.map((role, index)=>{
                        const roleName = t($1023e18b562b50ff$var$getRoleByNumber(role));
                        return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $acw62.Fragment), {
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                    className: `UserCard__leftContainer__roleContainer ${roleName}`,
                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                        children: roleName
                                    })
                                }),
                                index !== roles.length - 1 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $660b2ca422e0e2ae$export$1ff3c3f08ae963c0).Horizontal, {
                                    width: 8
                                })
                            ]
                        }, role);
                    })
                ]
            }),
            editingAlowed && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                src: (0, (/*@__PURE__*/$parcel$interopDefault($66a85520928e8e97$exports))),
                alt: "edit user",
                className: "UserCard__editImg"
            })
        ]
    });
}));


var $cfdcfedfb5bbdb8a$exports = {};
$cfdcfedfb5bbdb8a$exports = new URL("new-user.5126790f.svg", import.meta.url).toString();






var $acw62 = parcelRequire("acw62");






var $c1c2ae50b570778f$exports = {};
$c1c2ae50b570778f$exports = new URL("avatar-placeholder.bdf280fa.svg", import.meta.url).toString();



const $25aaa478da3d542e$export$1b5632526000fea3 = (0, $a4963babae245ff9$export$f0c7a449e0cfaec7)((0, $aca50e9407ba89c9$export$b6ae1bc530f4c149)(({ email: email, roles: roles, locations: locations })=>{
    const { getLocationNameById: getLocationNameById } = (0, $4671947198ddd366$export$6ccbb43953eebf8)().data;
    const { t: t } = (0, $3765cebd031b52c0$export$9fc83ad70ead8663)();
    const getRoleByNumber = (role)=>{
        switch(role){
            case (0, $97fa7686fb8e51ed$export$eb3485a690c2f0b8).Admin:
                return t("user_management.role_admin");
            case (0, $97fa7686fb8e51ed$export$eb3485a690c2f0b8).Owner:
                return t("user_management.role_owner");
            case (0, $97fa7686fb8e51ed$export$eb3485a690c2f0b8).Manager:
                return t("user_management.role_manager");
            case (0, $97fa7686fb8e51ed$export$eb3485a690c2f0b8).Finance:
                return t("user_management.role_finance");
        }
    };
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        className: `UserCard ${locations ? "increased" : ""}`,
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
            className: "UserCard__leftContainer",
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                    src: (0, (/*@__PURE__*/$parcel$interopDefault($c1c2ae50b570778f$exports))),
                    alt: "",
                    className: `UserCard__leftContainer__userPhoto`
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $660b2ca422e0e2ae$export$1ff3c3f08ae963c0).Horizontal, {
                    width: 8
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: "UserCard__leftContainer__userInfo",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                            className: "UserCard__leftContainer__userInfo__name",
                            children: email
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                            className: "UserCard__leftContainer__userInfo__locations",
                            children: locations?.map((locationId)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $acw62.Fragment), {
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                            className: "UserCard__leftContainer__userInfo__locations__location",
                                            children: getLocationNameById(String(locationId))
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $660b2ca422e0e2ae$export$1ff3c3f08ae963c0).Vertical, {
                                            height: 3
                                        })
                                    ]
                                }, locationId))
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $660b2ca422e0e2ae$export$1ff3c3f08ae963c0).Horizontal, {
                    width: 8
                }),
                roles.map((role, index)=>{
                    const roleName = getRoleByNumber(role);
                    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $acw62.Fragment), {
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                className: `UserCard__leftContainer__roleContainer ${roleName}`,
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                    children: roleName
                                })
                            }),
                            index !== roles.length - 1 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $660b2ca422e0e2ae$export$1ff3c3f08ae963c0).Horizontal, {
                                width: 8
                            })
                        ]
                    }, role);
                })
            ]
        })
    });
}));




const $f1254ad4f9d44fa8$export$d8b21067e493157a = (0, $a4963babae245ff9$export$f0c7a449e0cfaec7)((0, $aca50e9407ba89c9$export$b6ae1bc530f4c149)(({ showOnlyUnconfirmed: showOnlyUnconfirmed })=>{
    const { pointsOfContact: pointsOfContact, getPointsOfContact: getPointsOfContact, unconfirmedPointsOfContact: unconfirmedPointsOfContact, getUnconfirmedPointsOfContact: getUnconfirmedPointsOfContact, getLocations: getLocations } = (0, $4671947198ddd366$export$6ccbb43953eebf8)().data;
    const { t: t } = (0, $3765cebd031b52c0$export$9fc83ad70ead8663)();
    const redirect = (0, $7df35e9df335b1c8$export$602eaf6d5314ce55)();
    const tabs = [
        {
            title: t("user_management.users_tab_active_users"),
            onClick: ()=>redirect((0, $0534349ae8731d0b$export$66b32f6f30eb4b4).users, {}),
            isActive: !showOnlyUnconfirmed
        },
        {
            title: t("user_management.users_tab_invitations"),
            onClick: ()=>redirect((0, $0534349ae8731d0b$export$66b32f6f30eb4b4).unconfirmedUsers, {}),
            isActive: showOnlyUnconfirmed
        }
    ];
    (0, $4671947198ddd366$export$dd0a697e1782aedd)(()=>getLocations({}));
    const { enableQuery: getPointsOfContactRequest } = (0, $4671947198ddd366$export$517ca4f7fee4e226)(()=>getPointsOfContact({
            locationId: undefined
        }));
    const { enableQuery: getUnconfirmedPointsOfContactRequest } = (0, $4671947198ddd366$export$517ca4f7fee4e226)(()=>getUnconfirmedPointsOfContact({
            locationId: undefined
        }));
    (0, $acw62.useEffect)(()=>{
        if (showOnlyUnconfirmed) getUnconfirmedPointsOfContactRequest();
        else getPointsOfContactRequest();
    }, [
        showOnlyUnconfirmed
    ]);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "UsersList",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7ae42b63183f30b4$export$8b251419efc915eb), {
                title: t("user_management.users")
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $660b2ca422e0e2ae$export$1ff3c3f08ae963c0).Vertical, {
                height: 31
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "UsersList__container",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $1517d97a0e4f4f9f$export$b2539bed5023c21c), {
                        tabs: tabs
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $660b2ca422e0e2ae$export$1ff3c3f08ae963c0).Vertical, {
                        height: 24
                    }),
                    !showOnlyUnconfirmed && pointsOfContact?.map((user, index)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $acw62.Fragment), {
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $1023e18b562b50ff$export$78e8870b5d8ae469), {
                                    id: user.id,
                                    name: `${user.first_name} ${user.last_name}`,
                                    imageURL: user.image,
                                    roles: user.roles,
                                    locations: user.client_locations ?? undefined
                                }),
                                index !== pointsOfContact.length - 1 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $660b2ca422e0e2ae$export$1ff3c3f08ae963c0).Vertical, {
                                    height: 18
                                })
                            ]
                        }, user.id)),
                    showOnlyUnconfirmed && unconfirmedPointsOfContact?.map((user, index)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $acw62.Fragment), {
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $25aaa478da3d542e$export$1b5632526000fea3), {
                                    email: user.email,
                                    roles: user.roles,
                                    locations: user.client_locations ?? undefined
                                }),
                                index !== unconfirmedPointsOfContact.length - 1 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $660b2ca422e0e2ae$export$1ff3c3f08ae963c0).Vertical, {
                                    height: 18
                                })
                            ]
                        }, user.email)),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $660b2ca422e0e2ae$export$1ff3c3f08ae963c0).Vertical, {
                        height: 39
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7df35e9df335b1c8$export$a6c7ac8248d6e38a), {
                        route: (0, $0534349ae8731d0b$export$66b32f6f30eb4b4).createUser,
                        params: {},
                        className: "UsersList__newUserButton",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                                src: (0, (/*@__PURE__*/$parcel$interopDefault($cfdcfedfb5bbdb8a$exports))),
                                alt: "",
                                className: "UsersList__newUserButton__img"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $660b2ca422e0e2ae$export$1ff3c3f08ae963c0).Horizontal, {
                                width: 15
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                className: "UsersList__newUserButton__label",
                                children: t("user_management.add_user")
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $660b2ca422e0e2ae$export$1ff3c3f08ae963c0).Vertical, {
                        height: 5
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7df35e9df335b1c8$export$a6c7ac8248d6e38a), {
                        route: (0, $0534349ae8731d0b$export$66b32f6f30eb4b4).inviteUser,
                        params: {},
                        className: "UsersList__inviteContainer",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                className: "UsersList__inviteContainer__orLabel",
                                children: t("user_management.or")
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                className: "UsersList__inviteContainer__inviteLabel",
                                children: t("user_management.invite_existing_user")
                            })
                        ]
                    })
                ]
            })
        ]
    });
}));









var $7YFi7 = parcelRequire("7YFi7");














const $5eed6219dc03b51c$var$roleOptions = [
    {
        key: String((0, $97fa7686fb8e51ed$export$eb3485a690c2f0b8).Admin),
        label: "Admin",
        value: "Admin"
    },
    {
        key: String((0, $97fa7686fb8e51ed$export$eb3485a690c2f0b8).Manager),
        label: "Manager",
        value: "Manager"
    },
    {
        key: String((0, $97fa7686fb8e51ed$export$eb3485a690c2f0b8).Finance),
        label: "Finance",
        value: "Finance"
    }
];
const $5eed6219dc03b51c$export$26baa3e450ed80b8 = (0, $a4963babae245ff9$export$f0c7a449e0cfaec7)((0, $aca50e9407ba89c9$export$b6ae1bc530f4c149)(({ email: email })=>{
    const { locationsDataView: locationsDataView, getLocations: getLocations, inviteUser: inviteUser } = (0, $4671947198ddd366$export$6ccbb43953eebf8)().data;
    const { isLoading: locationsLoading } = (0, $4671947198ddd366$export$dd0a697e1782aedd)(()=>getLocations({}));
    const redirect = (0, $7df35e9df335b1c8$export$602eaf6d5314ce55)();
    const locationOptions = locationsDataView.length > 0 ? locationsDataView.map((location)=>({
            key: String(location.id),
            label: location.name,
            value: location.name
        })) : null;
    const [requestInviteUserResult, requestInvite] = (0, $4671947198ddd366$export$609860bf8b0084c)(inviteUser, {
        filterError: [
            (0, $9ad33fbf770c55a1$export$9696fcf1798e1cb5).ClientError
        ],
        onSuccess: ()=>{
            (0, $60f27fc97e29822a$export$b410431fab84fa58).success(t("user_management.invitation_alert_text"));
            redirect((0, $0534349ae8731d0b$export$66b32f6f30eb4b4).unconfirmedUsers, {});
        }
    });
    const { t: t } = (0, $3765cebd031b52c0$export$9fc83ad70ead8663)();
    const errors = requestInviteUserResult.error?.data.errors;
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        className: "InviteUser",
        children: locationsLoading || requestInviteUserResult.isLoading ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $57fb8f45c69e1681$export$2e2bcd8739ae039), {}) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7ae42b63183f30b4$export$8b251419efc915eb), {
                    title: t("user_management.invite_user"),
                    showBack: true
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $660b2ca422e0e2ae$export$1ff3c3f08ae963c0).Vertical, {
                    height: 15
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                    className: "InviteUser__container",
                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7YFi7.Formik), {
                        initialValues: {
                            email: email ?? "",
                            role: $5eed6219dc03b51c$var$roleOptions[0].value,
                            location: null
                        },
                        onSubmit: (values)=>{
                            const requestPayload = {
                                email: values.email,
                                "roles[0]": Number($5eed6219dc03b51c$var$roleOptions.find((role)=>role.value === values.role)?.key)
                            };
                            if (values.location) requestPayload["client_locations[0]"] = Number(locationOptions?.find((loc)=>loc.value === values.location)?.key);
                            requestInvite(requestPayload);
                        },
                        validationSchema: $cd7706ce94a8dfd1$export$185802fd694ee1f5().shape({
                            email: $bcc252d93ab3046c$export$185802fd694ee1f5().email(t("validation_messages.email_invalid")).required(t("user_management.enter_email")),
                            role: $bcc252d93ab3046c$export$185802fd694ee1f5().required(t("user_management.choose_role")),
                            location: $bcc252d93ab3046c$export$185802fd694ee1f5().nullable(true).when("role", {
                                is: (0, $97fa7686fb8e51ed$export$eb3485a690c2f0b8).Manager,
                                then: $bcc252d93ab3046c$export$185802fd694ee1f5().required(t("user_management.choose_location")).typeError(t("user_management.choose_location"))
                            })
                        }),
                        children: (formikProps)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7YFi7.Form), {
                                noValidate: true,
                                className: "InviteUser__container__form",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $1067a74e1c3483e2$export$f551688fc98f2e09), {
                                        errors: errors?.email,
                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $79dd68e96d831dee$export$2e2bcd8739ae039), {
                                            formikProps: formikProps,
                                            label: t("user_management.email"),
                                            formikKey: "email"
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $660b2ca422e0e2ae$export$1ff3c3f08ae963c0).Vertical, {
                                        height: 20
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f2c1b8699595d8c0$export$ef9b1a59e592288f), {
                                        label: t("user_management.job_role"),
                                        value: formikProps.getFieldProps("role").value,
                                        onChange: (value)=>{
                                            if (value === "Admin") formikProps.setFieldValue("location", null);
                                            else formikProps.setFieldValue("location", locationOptions?.[0].value);
                                            formikProps.setFieldValue("role", value);
                                        },
                                        options: $5eed6219dc03b51c$var$roleOptions
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $660b2ca422e0e2ae$export$1ff3c3f08ae963c0).Vertical, {
                                        height: 20
                                    }),
                                    formikProps.values.role === "Manager" && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $1067a74e1c3483e2$export$f551688fc98f2e09), {
                                                errors: formikProps.errors.location ?? errors?.client_locations,
                                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f2c1b8699595d8c0$export$ef9b1a59e592288f), {
                                                    label: t("user_management.location"),
                                                    value: formikProps.getFieldProps("location").value,
                                                    onChange: (value)=>{
                                                        formikProps.setFieldValue("location", value);
                                                    },
                                                    options: locationOptions ?? []
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $660b2ca422e0e2ae$export$1ff3c3f08ae963c0).Vertical, {
                                                height: 34
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        className: "InviteUser__container__form__buttons",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $2ab88429e3384d30$export$353f5b6fc5456de1), {
                                                type: "submit",
                                                title: t("user_management.save"),
                                                className: "InviteUser__container__form__buttons__button submit"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $660b2ca422e0e2ae$export$1ff3c3f08ae963c0).Horizontal, {
                                                width: 10
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $2ab88429e3384d30$export$353f5b6fc5456de1), {
                                                title: t("user_management.cancel"),
                                                className: "InviteUser__container__form__buttons__button",
                                                type: "button",
                                                onClick: ()=>window.history.back()
                                            })
                                        ]
                                    })
                                ]
                            })
                    })
                })
            ]
        })
    });
}));


const $96a1879f845e04b4$export$6a9f037beddd9ece = {
    UsersListPage: $f1254ad4f9d44fa8$export$d8b21067e493157a,
    AddUser: $a7218a7e9aa93e43$export$a2fae8d9b81b1013,
    InviteUser: $5eed6219dc03b51c$export$26baa3e450ed80b8
};






var $45fvw = parcelRequire("45fvw");

var $acw62 = parcelRequire("acw62");








var $0b0e3212e74c9b3e$exports = {};
$0b0e3212e74c9b3e$exports = new URL("empty-star.eaece64a.svg", import.meta.url).toString();








const $12290e483a47c3bd$export$ddcca913dfb4fb44 = (0, $a4963babae245ff9$export$f0c7a449e0cfaec7)((0, $aca50e9407ba89c9$export$b6ae1bc530f4c149)(()=>{
    const { t: t } = (0, $3765cebd031b52c0$export$9fc83ad70ead8663)();
    const { getLastRatings: getLastRatings, groupedLastRatings: groupedLastRatings, setSPLastJobRating: setSPLastJobRating, decreasePendingRatingsCount: decreasePendingRatingsCount } = (0, $4671947198ddd366$export$6ccbb43953eebf8)().data;
    const [spRatings, setSPRatings] = (0, $acw62.useState)([]);
    const [shownProfile, setShownProfile] = (0, $acw62.useState)(null);
    const getRating = (spId)=>{
        const rating = spRatings.find((r)=>r.spId === spId);
        return rating ? rating.rating : 0;
    };
    const setRating = (spId, rating, jobId)=>{
        const newRatings = spRatings.filter((r)=>r.spId !== spId);
        newRatings.push({
            spId: spId,
            rating: rating
        });
        setSPRatings(newRatings);
        setSPLastJobRatingRequest({
            spId: spId,
            rating: rating,
            jobId: jobId
        });
    };
    const { isLoading: lastRatingsLoading } = (0, $4671947198ddd366$export$dd0a697e1782aedd)(getLastRatings);
    const [, setSPLastJobRatingRequest] = (0, $4671947198ddd366$export$609860bf8b0084c)(({ spId: spId, rating: rating, jobId: jobId })=>setSPLastJobRating(spId, rating, null, null, jobId), {
        onSuccess: (result)=>{
            (0, $60f27fc97e29822a$export$b410431fab84fa58).success(t("job_rating.rating_submitted"));
            decreasePendingRatingsCount();
            (0, $c74a0566d4b0fd6d$export$e9db7d6e73593439).track((0, $c74a0566d4b0fd6d$export$5e27155e276f6d1c).RatingSetFromRatingsList);
        },
        onError: (err)=>{
            (0, $60f27fc97e29822a$export$b410431fab84fa58).error(err.data.errors?.note[0]);
        },
        filterError: [
            (0, $9ad33fbf770c55a1$export$9696fcf1798e1cb5).ClientError,
            (0, $9ad33fbf770c55a1$export$9696fcf1798e1cb5).NotFound
        ]
    });
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "RatingRequestsList",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7ae42b63183f30b4$export$8b251419efc915eb), {
                title: t("rating_request_list.title")
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $660b2ca422e0e2ae$export$1ff3c3f08ae963c0).Vertical, {
                height: 33
            }),
            lastRatingsLoading && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $57fb8f45c69e1681$export$2e2bcd8739ae039), {}),
            groupedLastRatings.length > 0 ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "RatingRequestsList__infoPanel",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                className: "RatingRequestsList__infoPanel__title",
                                children: t("job_rating.rate_workers")
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                className: "RatingRequestsList__infoPanel__subtitle",
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e04d9533328ca578$export$8d6a9236f2e3f2ce), {
                                    i18nKey: "job_rating.importance_of_rating",
                                    components: {
                                        strong: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {})
                                    }
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "RatingRequestsList__latest",
                        children: groupedLastRatings.map((group, index)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "RatingRequestsList__latest__card",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                        className: "RatingRequestsList__latest__card__title",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                                children: group.designation_name
                                            }),
                                            " (",
                                            group.ratings.length,
                                            ")"
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        className: "RatingRequestsList__latest__card__subtitle",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                                                className: "RatingRequestsList__latest__card__subtitle__img",
                                                src: (0, (/*@__PURE__*/$parcel$interopDefault($cab7dbc8172ddafd$exports)))
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                className: "RatingRequestsList__latest__card__subtitle__text",
                                                children: group.location_name
                                            })
                                        ]
                                    }),
                                    group.ratings.map((rating)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                            className: "RatingRequestsList__latest__card__sp",
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                    className: "RatingRequestsList__latest__card__sp__left",
                                                    onClick: ()=>setShownProfile({
                                                            id: rating.id,
                                                            jobId: rating.job_id,
                                                            name: rating.name
                                                        }),
                                                    children: [
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                                                            className: "RatingRequestsList__latest__card__sp__img",
                                                            src: rating.image_url
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                            className: "RatingRequestsList__latest__card__sp__info",
                                                            children: [
                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                                    className: "RatingRequestsList__latest__card__sp__info__title",
                                                                    children: rating.name
                                                                }),
                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                                    className: "RatingRequestsList__latest__card__sp__info__subtitle",
                                                                    children: t("common.ended_at", {
                                                                        date: (0, (/*@__PURE__*/$parcel$interopDefault($45fvw)))(rating.completed_at, "YYYY-MM-DD").format("MMM DD")
                                                                    })
                                                                })
                                                            ]
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $647b8b1a309a1295$export$2e2bcd8739ae039), {
                                                    rating: getRating(rating.id),
                                                    onRatingChange: (value)=>{
                                                        setRating(rating.id, value, rating.job_id);
                                                    },
                                                    editable: true,
                                                    size: 26,
                                                    emptyIcon: (0, (/*@__PURE__*/$parcel$interopDefault($0b0e3212e74c9b3e$exports))),
                                                    starsGap: 8
                                                })
                                            ]
                                        }, rating.id))
                                ]
                            }, index))
                    })
                ]
            }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7b02d682eb115277$exports.Fragment), {
                children: !lastRatingsLoading && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                    className: "RatingRequestsList__emptyList",
                    children: t("rating_request_list.empty_list")
                })
            }),
            shownProfile && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $9c16b10bbbe042e5$export$129a32eedafa97c5), {
                isActive: Boolean(shownProfile),
                content: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c665f284476b5703$export$2e2bcd8739ae039), {
                    jobId: String(shownProfile.jobId),
                    jobType: (0, $862a04ca6e0d681b$export$27a7f855854fa13d).oneTime,
                    applicantId: shownProfile.id,
                    showHeader: false,
                    showControls: false
                }),
                close: ()=>setShownProfile(null)
            })
        ]
    });
}));




var $acw62 = parcelRequire("acw62");

var $45fvw = parcelRequire("45fvw");


var $7YFi7 = parcelRequire("7YFi7");











var $5d89279f1353e726$exports = {};
$5d89279f1353e726$exports = new URL("empty-star.eaece64a.svg", import.meta.url).toString();




var $acw62 = parcelRequire("acw62");









const $bcc322955388471b$export$b0cc09cfadf17c04 = ({ id: id, title: title, selected: selected, onPress: onPress })=>{
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        onClick: ()=>onPress(id),
        className: `Quality ${selected ? "selected" : ""}`,
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
            className: "Quality__label",
            children: title
        })
    });
};




const $68bd0c7858df06a6$export$a64162838dbd1966 = (0, $a4963babae245ff9$export$f0c7a449e0cfaec7)((0, $aca50e9407ba89c9$export$b6ae1bc530f4c149)(({ name: name, imageURL: imageURL, initialRating: initialRating, rating: rating, comment: comment, criterias: criterias, setFields: setFields, ratingError: ratingError, criteriasError: criteriasError, commentError: commentError })=>{
    const previousRating = (0, $acw62.useRef)(initialRating);
    const initialRatingHasBeenSet = (0, $acw62.useRef)(false);
    const { negativeCriteries: negativeCriteries, positiveCriteries: positiveCriteries } = (0, $4671947198ddd366$export$6ccbb43953eebf8)().data;
    (0, $acw62.useEffect)(()=>{
        if (initialRating !== rating && initialRatingHasBeenSet.current === false) {
            setFields({
                rating: initialRating
            });
            previousRating.current = initialRating;
        }
        if (initialRating !== 0) initialRatingHasBeenSet.current = true;
    // don't react to internal rating changes, only to outside ratings changes (once).
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        initialRating
    ]);
    const { t: t } = (0, $3765cebd031b52c0$export$9fc83ad70ead8663)();
    const criteriaOptions = [
        ...rating > 3 ? positiveCriteries : negativeCriteries,
        {
            id: -1,
            name: "Other",
            type: ""
        }
    ];
    const customCriteriaSelected = Boolean(criterias.has(-1));
    const handleCriteriaPress = (id)=>{
        const newCriterias = new Set(criterias);
        if (criterias.has(id)) newCriterias.delete(id);
        else newCriterias.add(id);
        setFields({
            criterias: newCriterias
        });
    };
    const handleRatingChange = (newRating)=>{
        initialRatingHasBeenSet.current = true;
        previousRating.current = rating;
        // reset chosen qualities and comment if positive rate becomes negative or vice versa
        if (newRating > 3 && rating < 4 || newRating < 4 && rating > 3) setFields({
            rating: newRating,
            criterias: new Set(),
            comment: null
        });
        else setFields({
            rating: newRating
        });
    };
    const error = ratingError ?? criteriasError ?? commentError;
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $1067a74e1c3483e2$export$f551688fc98f2e09), {
        errors: error,
        className: "RateCard",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $660b2ca422e0e2ae$export$1ff3c3f08ae963c0).Vertical, {
                height: 18
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "RateCard__header",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "RateCard__header__leftContainer",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $bdacfb30f3b10618$export$2e2bcd8739ae039), {
                                src: imageURL,
                                alt: "",
                                className: "RateCard__header__leftContainer__photo"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $660b2ca422e0e2ae$export$1ff3c3f08ae963c0).Horizontal, {
                                width: 10
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                className: "RateCard__header__leftContainer__name",
                                children: name
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $647b8b1a309a1295$export$2e2bcd8739ae039), {
                        rating: rating,
                        onRatingChange: handleRatingChange,
                        editable: true,
                        size: 17
                    })
                ]
            }),
            rating !== 0 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $660b2ca422e0e2ae$export$1ff3c3f08ae963c0).Vertical, {
                        height: 14
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "RateCard__qualitiesContainer",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $660b2ca422e0e2ae$export$1ff3c3f08ae963c0).Horizontal, {
                                width: 38
                            }),
                            criteriaOptions.map((criteria, index)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $acw62.Fragment), {
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $bcc322955388471b$export$b0cc09cfadf17c04), {
                                            id: criteria.id,
                                            title: criteria.name,
                                            selected: criterias.has(criteria.id),
                                            onPress: handleCriteriaPress
                                        }),
                                        index !== criteriaOptions.length - 1 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $660b2ca422e0e2ae$export$1ff3c3f08ae963c0).Horizontal, {
                                            width: 6
                                        })
                                    ]
                                }, criteria.id))
                        ]
                    }),
                    customCriteriaSelected && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $660b2ca422e0e2ae$export$1ff3c3f08ae963c0).Vertical, {
                                height: 13
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("textarea", {
                                value: comment,
                                onChange: (ev)=>setFields({
                                        comment: ev.target.value
                                    }),
                                placeholder: t("job_rating.comment"),
                                className: "RateCard__textarea"
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $660b2ca422e0e2ae$export$1ff3c3f08ae963c0).Vertical, {
                height: 18
            })
        ]
    });
}));




const $291b9d4ae889eb81$var$GENERAL_RATE_REQUIRED = (0, $2b1f0855f2f3a952$export$625550452a3fa3ec)("job_rating.provide_overall_rating");
const $291b9d4ae889eb81$var$OGRAMMER_RATE_REQUIRED = (0, $2b1f0855f2f3a952$export$625550452a3fa3ec)("job_rating.provide_og_rating");
const $291b9d4ae889eb81$export$4310724fb661795a = $cd7706ce94a8dfd1$export$185802fd694ee1f5().shape({
    job_rating: $425f4614c2bd74f2$export$185802fd694ee1f5().min(1, $291b9d4ae889eb81$var$GENERAL_RATE_REQUIRED).max(5, $291b9d4ae889eb81$var$GENERAL_RATE_REQUIRED).required($291b9d4ae889eb81$var$GENERAL_RATE_REQUIRED),
    ogrammerRates: $e218604b96487b25$export$185802fd694ee1f5().of($cd7706ce94a8dfd1$export$185802fd694ee1f5().shape({
        comment: $bcc252d93ab3046c$export$185802fd694ee1f5().nullable(true),
        rating: $425f4614c2bd74f2$export$185802fd694ee1f5().min(1, $291b9d4ae889eb81$var$OGRAMMER_RATE_REQUIRED).max(5, $291b9d4ae889eb81$var$OGRAMMER_RATE_REQUIRED).nullable(true).required($291b9d4ae889eb81$var$OGRAMMER_RATE_REQUIRED)
    })).required((0, $2b1f0855f2f3a952$export$625550452a3fa3ec)("job_rating.provide_ogrammers_rating"))
});





const $4a1a959bde865e38$var$getFormattedDate = (dateString)=>{
    return (0, (/*@__PURE__*/$parcel$interopDefault($45fvw)))(dateString, "YYYY-MM-DD").format("DD MMM");
};
const $4a1a959bde865e38$export$33b34fcffb16816b = (0, $a4963babae245ff9$export$f0c7a449e0cfaec7)((0, $aca50e9407ba89c9$export$b6ae1bc530f4c149)(({ id: id })=>{
    const [jobRating, setJobRating] = (0, $acw62.useState)(null);
    const [errors, setErrors] = (0, $acw62.useState)();
    const initialValues = (0, $acw62.useMemo)(()=>{
        if (!jobRating) return null;
        const formValues = {
            job_id: id,
            job_rating: 0,
            ogrammerRates: []
        };
        jobRating.sps.forEach((ogrammer)=>{
            formValues.ogrammerRates.push({
                sp_id: ogrammer.id,
                rating: 0,
                criterias: new Set(),
                comment: null
            });
        });
        return formValues;
    }, [
        jobRating,
        id
    ]);
    const { getRatingRequestDetails: getRatingRequestDetails, getRatingCriteries: getRatingCriteries, submitRating: submitRating } = (0, $4671947198ddd366$export$6ccbb43953eebf8)().data;
    const { isLoading: criteriesLoading } = (0, $4671947198ddd366$export$dd0a697e1782aedd)(getRatingCriteries);
    const { isLoading: ratingDetailsLoading } = (0, $4671947198ddd366$export$dd0a697e1782aedd)(()=>getRatingRequestDetails(id), {
        onSuccess: setJobRating
    });
    const [submitRatingResult, submit] = (0, $4671947198ddd366$export$609860bf8b0084c)(submitRating, {
        filterError: [
            (0, $9ad33fbf770c55a1$export$9696fcf1798e1cb5).ClientError
        ],
        onSuccess: ()=>{
            (0, $60f27fc97e29822a$export$b410431fab84fa58).success(t("job_rating.thank_you_for_submitting"));
            window.history.back();
        },
        onError: (err)=>{
            if (err.data.errors) setErrors([
                ...Object.values(err.data.errors).flat()
            ]);
        }
    });
    const { t: t } = (0, $3765cebd031b52c0$export$9fc83ad70ead8663)();
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7b02d682eb115277$exports.Fragment), {
        children: ratingDetailsLoading || criteriesLoading || initialValues === null ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $57fb8f45c69e1681$export$2e2bcd8739ae039), {}) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7YFi7.Formik), {
            initialValues: initialValues,
            validationSchema: (0, $291b9d4ae889eb81$export$4310724fb661795a),
            onSubmit: (values)=>{
                if (submitRatingResult.isLoading) return;
                submit({
                    ...values,
                    ogrammerRates: [
                        ...values.ogrammerRates.map((ogRate)=>{
                            const criterias = new Set(ogRate.criterias);
                            criterias.delete(-1);
                            (0, $c74a0566d4b0fd6d$export$e9db7d6e73593439).track((0, $c74a0566d4b0fd6d$export$5e27155e276f6d1c).RatingSet, {
                                source: "RatingPage",
                                isChange: false
                            });
                            return {
                                ...ogRate,
                                criterias: criterias
                            };
                        })
                    ]
                });
            },
            children: (formikProps)=>{
                const formDisabled = formikProps.values.job_rating === 0;
                return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7YFi7.Form), {
                    className: "JobRating",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $660b2ca422e0e2ae$export$1ff3c3f08ae963c0).Vertical, {
                            height: 33
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $1067a74e1c3483e2$export$f551688fc98f2e09), {
                            errors: errors,
                            className: "JobRating__container",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                    className: "JobRating__container__title",
                                    children: [
                                        jobRating?.title,
                                        " ",
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                            className: "JobRating__container__title__amount",
                                            children: [
                                                "(",
                                                jobRating?.sp_max_quantity,
                                                ")"
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $660b2ca422e0e2ae$export$1ff3c3f08ae963c0).Vertical, {
                                    height: 12
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                    className: "JobRating__container__row",
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                                            src: (0, (/*@__PURE__*/$parcel$interopDefault($cab7dbc8172ddafd$exports))),
                                            alt: ""
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $660b2ca422e0e2ae$export$1ff3c3f08ae963c0).Horizontal, {
                                            width: 11
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                            className: "JobRating__container__row__label",
                                            children: jobRating?.client_address
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $660b2ca422e0e2ae$export$1ff3c3f08ae963c0).Vertical, {
                                    height: 12
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                    className: "JobRating__container__row",
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                                            src: (0, (/*@__PURE__*/$parcel$interopDefault($bad31fa192b525ae$exports))),
                                            alt: ""
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $660b2ca422e0e2ae$export$1ff3c3f08ae963c0).Horizontal, {
                                            width: 9
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                            className: "RatingCard__row__label",
                                            children: jobRating?.start_date === jobRating?.end_date ? $4a1a959bde865e38$var$getFormattedDate(jobRating?.start_date) : `${$4a1a959bde865e38$var$getFormattedDate(jobRating?.start_date)} - ${$4a1a959bde865e38$var$getFormattedDate(jobRating?.end_date)}`
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $660b2ca422e0e2ae$export$1ff3c3f08ae963c0).Vertical, {
                                    height: 30
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                    className: "JobRating__container__subtitle",
                                    children: t("job_rating.how_was_experience_question")
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $660b2ca422e0e2ae$export$1ff3c3f08ae963c0).Vertical, {
                                    height: 6
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                    className: "JobRating__container__description",
                                    children: t("job_rating.please_rate_team")
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $660b2ca422e0e2ae$export$1ff3c3f08ae963c0).Vertical, {
                                    height: 18
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $1067a74e1c3483e2$export$f551688fc98f2e09), {
                                    errors: formikProps.errors.job_rating,
                                    className: "JobRating__container__overallRatingError",
                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $647b8b1a309a1295$export$2e2bcd8739ae039), {
                                        rating: formikProps.values.job_rating,
                                        editable: true,
                                        onRatingChange: (value)=>{
                                            if (!formikProps.values.job_rating) formikProps.setFieldValue("ogrammerRates", [
                                                ...formikProps.values.ogrammerRates.map((prevRate)=>({
                                                        ...prevRate,
                                                        rating: prevRate.rating ? prevRate.rating : value
                                                    }))
                                            ], false);
                                            formikProps.setFieldValue("job_rating", value, false);
                                        },
                                        size: 40,
                                        emptyIcon: (0, (/*@__PURE__*/$parcel$interopDefault($5d89279f1353e726$exports)))
                                    })
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $660b2ca422e0e2ae$export$1ff3c3f08ae963c0).Vertical, {
                                    height: 38
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                    className: "JobRating__container__subtitle",
                                    children: t("job_rating.tell_us_about_ogs")
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $660b2ca422e0e2ae$export$1ff3c3f08ae963c0).Vertical, {
                                    height: 6
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                    className: "JobRating__container__description",
                                    children: t("job_rating.tell_us_which_stood_out")
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $660b2ca422e0e2ae$export$1ff3c3f08ae963c0).Vertical, {
                                    height: 8
                                }),
                                jobRating?.sps.map((ogrammer, index)=>{
                                    const handleFieldsChange = (fields)=>{
                                        formikProps.setFormikState((prevState)=>{
                                            return {
                                                ...prevState,
                                                values: {
                                                    ...prevState.values,
                                                    ogrammerRates: [
                                                        ...formikProps.values.ogrammerRates.map((ogrammerRate, ogrammerRateIndex)=>{
                                                            if (ogrammerRateIndex !== index) return ogrammerRate;
                                                            return {
                                                                ...ogrammerRate,
                                                                rating: fields.rating ?? ogrammerRate.rating,
                                                                comment: fields.comment ?? ogrammerRate.comment,
                                                                criterias: fields.criterias ?? ogrammerRate.criterias
                                                            };
                                                        })
                                                    ]
                                                }
                                            };
                                        });
                                    };
                                    const ogrammerErrors = formikProps.errors.ogrammerRates?.[index];
                                    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $68bd0c7858df06a6$export$a64162838dbd1966), {
                                        name: ogrammer.full_name,
                                        imageURL: ogrammer.image_url,
                                        initialRating: formikProps.values.job_rating,
                                        rating: formikProps.values.ogrammerRates[index].rating,
                                        comment: formikProps.values.ogrammerRates[index].comment ?? "",
                                        criterias: formikProps.values.ogrammerRates[index].criterias,
                                        ratingError: ogrammerErrors?.rating,
                                        criteriasError: ogrammerErrors?.criterias,
                                        commentError: ogrammerErrors?.comment,
                                        setFields: handleFieldsChange
                                    }, ogrammer.id);
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $660b2ca422e0e2ae$export$1ff3c3f08ae963c0).Vertical, {
                            height: 29
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $2ab88429e3384d30$export$353f5b6fc5456de1), {
                            title: t("job_rating.confirm"),
                            type: "submit",
                            disabled: formDisabled,
                            className: `JobRating__confirmButton ${formDisabled ? "disabled" : ""}`
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $660b2ca422e0e2ae$export$1ff3c3f08ae963c0).Vertical, {
                            height: 29
                        })
                    ]
                });
            }
        })
    });
}));


const $f36ea5c0877e84ac$export$e626a3f00a9c18af = {
    RatingRequestsListPage: $12290e483a47c3bd$export$ddcca913dfb4fb44,
    JobRatingPage: $4a1a959bde865e38$export$33b34fcffb16816b
};




var $acw62 = parcelRequire("acw62");










const $de8c64dc6b41b9b0$export$8b251419efc915eb = ({ title: title, subtitle: subtitle })=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "Header",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                className: "Header__title",
                children: title
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                className: "Header__subtitle",
                children: subtitle
            })
        ]
    });




var $acw62 = parcelRequire("acw62");







var $707a368c28f02f2d$exports = {};
$707a368c28f02f2d$exports = new URL("decrease.423ba4d6.svg", import.meta.url).toString();


var $29eab64d43d8b636$exports = {};
$29eab64d43d8b636$exports = new URL("increase.fe6bc78d.svg", import.meta.url).toString();


const $79c39a0930cadbb0$export$6c746a5570b8b35c = {
    decreaseImg: (/*@__PURE__*/$parcel$interopDefault($707a368c28f02f2d$exports)),
    increaseImg: (/*@__PURE__*/$parcel$interopDefault($29eab64d43d8b636$exports))
};



const $d7f0460fd9a3e121$export$60c215e15c273e51 = ({ value: value = 0, handleValueChange: handleValueChange })=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "CountStepper",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "CountStepper__button",
                onClick: ()=>{
                    if (value === 0) return;
                    handleValueChange(value - 1);
                },
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                    src: (0, $79c39a0930cadbb0$export$6c746a5570b8b35c).decreaseImg,
                    className: "CountStepper__button__decreaseImg"
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                className: `CountStepper__value ${value > 0 ? "active" : ""}`,
                children: value
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "CountStepper__button",
                onClick: ()=>{
                    handleValueChange(value + 1);
                },
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                    src: (0, $79c39a0930cadbb0$export$6c746a5570b8b35c).increaseImg,
                    className: "CountStepper__button__increaseImg"
                })
            })
        ]
    });



const $d93b3fd4cd76aa53$export$2466b7e3d19134ac = (0, $aca50e9407ba89c9$export$b6ae1bc530f4c149)(({ values: values, updateField: updateField })=>{
    const [searchValue, setSearchValue] = (0, $acw62.useState)("");
    const [calculatingList, setCalculatingList] = (0, $acw62.useState)(false);
    const [filteredCategories, setFilteredCategories] = (0, $acw62.useState)([]);
    const { professionList: professionList, getProfessions: getProfessions } = (0, $4671947198ddd366$export$6ccbb43953eebf8)().data;
    const { query: { isLoading: professionsLoading }, enableQuery: loadProfessions } = (0, $4671947198ddd366$export$517ca4f7fee4e226)(()=>getProfessions({}));
    (0, $acw62.useEffect)(()=>{
        if (professionList.length === 0) loadProfessions();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    (0, $acw62.useEffect)(()=>{
        if (professionList.length > 0) setFilteredCategories(professionList);
    }, [
        professionList,
        professionList.length
    ]);
    const filterCategories = (0, $85953efa7e00ce5b$export$2e2bcd8739ae039)((value)=>{
        setFilteredCategories(professionList.filter((item)=>item.name.toLowerCase().includes(value.toLowerCase())));
        setCalculatingList(false);
    }, 500);
    const [calculatingListDebounced] = (0, $28cfa09e9775cf8c$export$2e2bcd8739ae039)(calculatingList, 300);
    const handleSearchChange = (value)=>{
        setCalculatingList(true);
        setSearchValue(value);
        filterCategories(value);
    };
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "WorkCategories",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $660b2ca422e0e2ae$export$1ff3c3f08ae963c0).Vertical, {
                height: 24
            }),
            professionsLoading ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $57fb8f45c69e1681$export$2e2bcd8739ae039), {}) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $db7fb73ce5c45471$export$55d7609a8f1eccd2), {
                        value: searchValue,
                        handleValueChange: handleSearchChange
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $660b2ca422e0e2ae$export$1ff3c3f08ae963c0).Vertical, {
                        height: 16
                    }),
                    calculatingListDebounced ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $57fb8f45c69e1681$export$2e2bcd8739ae039), {}) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "WorkCategories__list",
                        children: filteredCategories.map((profession)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "WorkCategories__list__row",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                        className: "WorkCategories__list__row__title",
                                        children: profession.name
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $d7f0460fd9a3e121$export$60c215e15c273e51), {
                                        value: values.categoriesCount[profession.id],
                                        handleValueChange: (count)=>{
                                            updateField({
                                                ...values.categoriesCount,
                                                [profession.id]: count
                                            });
                                        }
                                    })
                                ]
                            }, profession.id))
                    })
                ]
            })
        ]
    });
});




var $acw62 = parcelRequire("acw62");










var $d778b920f585b024$exports = {};
$d778b920f585b024$exports = new URL("location.f3ca25a3.svg", import.meta.url).toString();



const $5899d288dfbab641$export$18a2be9195644f38 = (0, $aca50e9407ba89c9$export$b6ae1bc530f4c149)(({ values: values, updateField: updateField })=>{
    const { locationsDataView: locationsDataView, getLocations: getLocations, getLocationByName: getLocationByName } = (0, $4671947198ddd366$export$6ccbb43953eebf8)().data;
    const [regionsModalVisible, setRegionsModalVisible] = (0, $acw62.useState)(false);
    const { query: { isLoading: locationsLoading }, enableQuery: loadLocations } = (0, $4671947198ddd366$export$517ca4f7fee4e226)(()=>getLocations({}));
    const locationOptions = locationsDataView.length > 0 ? locationsDataView.map((location)=>({
            key: String(location.id),
            label: location.name,
            value: location.name
        })) : null;
    (0, $acw62.useEffect)(()=>{
        if (locationsDataView.length === 0) loadLocations();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    (0, $acw62.useEffect)(()=>{
        if (!values.location && locationsDataView.length > 0) updateField({
            address: locationsDataView[0].address,
            lat: locationsDataView[0].lat,
            lng: locationsDataView[0].lng
        });
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        locationsDataView,
        locationsDataView.length
    ]);
    const { t: t } = (0, $3765cebd031b52c0$export$9fc83ad70ead8663)();
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "Location",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $660b2ca422e0e2ae$export$1ff3c3f08ae963c0).Vertical, {
                height: 63
            }),
            locationsLoading ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $57fb8f45c69e1681$export$2e2bcd8739ae039), {}) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7b02d682eb115277$exports.Fragment), {
                children: locationOptions !== null && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f2c1b8699595d8c0$export$ef9b1a59e592288f), {
                    label: t("lead_form.location"),
                    value: values.location?.address,
                    onChange: (value)=>{
                        const location = getLocationByName(value);
                        updateField({
                            address: location?.address,
                            lat: location?.lat,
                            lng: location?.lng
                        });
                    },
                    options: locationOptions,
                    className: "Location__locationSelect"
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $660b2ca422e0e2ae$export$1ff3c3f08ae963c0).Vertical, {
                height: 35
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $2ab88429e3384d30$export$353f5b6fc5456de1), {
                onClick: ()=>{
                    setRegionsModalVisible(true);
                },
                className: "Location__addLocationButton",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                        src: (0, (/*@__PURE__*/$parcel$interopDefault($d778b920f585b024$exports))),
                        className: "Location__addLocationButton__img"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                        className: "Location__addLocationButton__title",
                        children: t("lead_form.add_new_location")
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $c786671f641538e1$export$446bb0a5366f9068), {
                modalVisible: regionsModalVisible,
                onClose: ()=>{
                    setRegionsModalVisible(false);
                },
                className: "Location__modal",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                        src: (0, (/*@__PURE__*/$parcel$interopDefault($c8242b1acdd8c5a0$exports))),
                        onClick: ()=>{
                            setRegionsModalVisible(false);
                        },
                        className: "Location__modal__modalCloseImg"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                        className: "Location__modal__modalTitle",
                        children: t("lead_form.add_location")
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $606c9b8f795454be$export$2e2bcd8739ae039), {
                        onSubmit: ()=>{
                            setRegionsModalVisible(false);
                        }
                    })
                ]
            })
        ]
    });
});




var $45fvw = parcelRequire("45fvw");




const $6e85b567760cfccb$var$currentDateFormatted = (0, (/*@__PURE__*/$parcel$interopDefault($45fvw)))(new Date()).format("YYYY-MM-DD");
const $6e85b567760cfccb$export$41c3ac8c866f31c8 = ({ values: values, updateField: updateField })=>{
    const { t: t } = (0, $3765cebd031b52c0$export$9fc83ad70ead8663)();
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "Dates",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $660b2ca422e0e2ae$export$1ff3c3f08ae963c0).Vertical, {
                height: 67
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $1579b0c3590d1ee8$export$7edc06cf1783b30f), {
                label: t("lead_form.start_date"),
                value: values.dates.startDate ?? "",
                handleChange: (startDate)=>{
                    updateField({
                        ...values.dates,
                        startDate: startDate
                    });
                },
                min: $6e85b567760cfccb$var$currentDateFormatted,
                max: values.dates.endDate ?? undefined,
                className: "Dates__dateInput"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $660b2ca422e0e2ae$export$1ff3c3f08ae963c0).Vertical, {
                height: 22
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $1579b0c3590d1ee8$export$7edc06cf1783b30f), {
                label: t("lead_form.end_date"),
                value: values.dates.endDate ?? "",
                handleChange: (endDate)=>{
                    updateField({
                        ...values.dates,
                        endDate: endDate
                    });
                },
                min: values.dates.startDate ?? $6e85b567760cfccb$var$currentDateFormatted,
                className: "Dates__dateInput"
            })
        ]
    });
};







var $acw62 = parcelRequire("acw62");

var $45fvw = parcelRequire("45fvw");



const $c1d7699e4338b9da$export$79013acc461f1fe6 = ({ id: id, label: label, selected: selected, toggleSelection: toggleSelection })=>{
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        onClick: ()=>toggleSelection(id),
        className: `DayItem ${selected ? "active" : ""}`,
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
            children: label
        })
    });
};



function $8e85944d7fa76487$var$getDayLabel(dayLabel) {
    switch(dayLabel){
        case "Mon":
            return "Mo";
        case "Tue":
            return "Tu";
        case "Wed":
            return "We";
        case "Thu":
            return "Th";
        case "Fri":
            return "Fr";
        case "Sat":
            return "Sa";
        case "Sun":
            return "Su";
    }
}
const $8e85944d7fa76487$var$localeWeekdays = (0, (/*@__PURE__*/$parcel$interopDefault($45fvw))).weekdaysShort();
const $8e85944d7fa76487$export$fc3b42934955e4a1 = ({ label: label, selectedDays: selectedDays, setSelectedDays: setSelectedDays })=>{
    const toggleDaySelection = (key)=>{
        if (selectedDays.includes(key)) setSelectedDays(selectedDays.filter((day)=>day !== key));
        else setSelectedDays([
            ...selectedDays,
            key
        ]);
    };
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "DaySelector",
        children: [
            label !== null && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                        className: "DaySelector__label",
                        children: label
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $660b2ca422e0e2ae$export$1ff3c3f08ae963c0).Vertical, {
                        height: 16
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "DaySelector__days-container",
                children: $8e85944d7fa76487$var$localeWeekdays.map((item, index)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $acw62.Fragment), {
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c1d7699e4338b9da$export$79013acc461f1fe6), {
                                id: item,
                                label: $8e85944d7fa76487$var$getDayLabel(item),
                                selected: selectedDays.includes(item),
                                toggleSelection: toggleDaySelection
                            }),
                            index !== $8e85944d7fa76487$var$localeWeekdays.length - 1 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $660b2ca422e0e2ae$export$1ff3c3f08ae963c0).Spacer, {
                                flex: 0.1
                            })
                        ]
                    }, item))
            })
        ]
    });
};



const $0c0f82518a2a572f$export$d3134eff2123aadb = ({ values: values, updateField: updateField })=>{
    const daysSelected = values.days.length;
    const { t: t } = (0, $3765cebd031b52c0$export$9fc83ad70ead8663)();
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "Days",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $660b2ca422e0e2ae$export$1ff3c3f08ae963c0).Vertical, {
                height: 67
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $8e85944d7fa76487$export$fc3b42934955e4a1), {
                label: null,
                selectedDays: values.days,
                setSelectedDays: updateField
            }),
            daysSelected > 0 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $660b2ca422e0e2ae$export$1ff3c3f08ae963c0).Vertical, {
                        height: 18
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                        className: "Days__selectionLabel",
                        children: daysSelected > 1 ? t("lead_form.days_selected", {
                            count: daysSelected
                        }) : t("lead_form.day_selected", {
                            count: daysSelected
                        })
                    })
                ]
            })
        ]
    });
};







const $01ba220ba7f9f1e5$export$680ea196effce5f = ({ values: values, updateField: updateField })=>{
    const { t: t } = (0, $3765cebd031b52c0$export$9fc83ad70ead8663)();
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "Time",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $660b2ca422e0e2ae$export$1ff3c3f08ae963c0).Vertical, {
                height: 67
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5ce1d5308946b7cc$export$a1af6f79df847fac), {
                label: t("lead_form.start_time"),
                value: values.time.startTime ?? "",
                handleChange: (startTime)=>{
                    updateField({
                        ...values.time,
                        startTime: startTime
                    });
                },
                className: "Time__timeInput"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $660b2ca422e0e2ae$export$1ff3c3f08ae963c0).Vertical, {
                height: 22
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5ce1d5308946b7cc$export$a1af6f79df847fac), {
                label: t("lead_form.end_time"),
                value: values.time.endTime ?? "",
                handleChange: (endTime)=>{
                    updateField({
                        ...values.time,
                        endTime: endTime
                    });
                },
                className: "Time__timeInput"
            })
        ]
    });
};






const $da6e7d8dbadfc5f7$export$393edc798c47379d = ({ values: values, updateField: updateField })=>{
    const { t: t } = (0, $3765cebd031b52c0$export$9fc83ad70ead8663)();
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "Description",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $660b2ca422e0e2ae$export$1ff3c3f08ae963c0).Vertical, {
                height: 53
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("textarea", {
                value: values.description ?? "",
                onChange: (ev)=>updateField(ev.target.value),
                placeholder: t("lead_form.describe_job_details"),
                className: "Description__textarea"
            })
        ]
    });
};







const $a56629ddd624591d$export$21f8d1d652eb4709 = ({ values: values, updateField: updateField })=>{
    const { t: t } = (0, $3765cebd031b52c0$export$9fc83ad70ead8663)();
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "ExperienceLevel",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $660b2ca422e0e2ae$export$1ff3c3f08ae963c0).Vertical, {
                height: 54
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "ExperienceLevel__innerContainer",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $2ab88429e3384d30$export$353f5b6fc5456de1), {
                        title: t("job_draft_details.experience_junior"),
                        onClick: ()=>{
                            updateField(1);
                        },
                        className: `ExperienceLevel__innerContainer__button ${values.experienceLevel === 1 ? "active" : ""}`
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $660b2ca422e0e2ae$export$1ff3c3f08ae963c0).Vertical, {
                        height: 10
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $2ab88429e3384d30$export$353f5b6fc5456de1), {
                        title: t("job_draft_details.experience_middle"),
                        onClick: ()=>{
                            updateField(2);
                        },
                        className: `ExperienceLevel__innerContainer__button ${values.experienceLevel === 2 ? "active" : ""}`
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $660b2ca422e0e2ae$export$1ff3c3f08ae963c0).Vertical, {
                        height: 10
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $2ab88429e3384d30$export$353f5b6fc5456de1), {
                        title: t("job_draft_details.experience_senior"),
                        onClick: ()=>{
                            updateField(3);
                        },
                        className: `ExperienceLevel__innerContainer__button ${values.experienceLevel === 3 ? "active" : ""}`
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $660b2ca422e0e2ae$export$1ff3c3f08ae963c0).Vertical, {
                        height: 15
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                        className: "ExperienceLevel__innerContainer__description",
                        children: t("lead_form.experience_label_tips")
                    })
                ]
            })
        ]
    });
};




var $acw62 = parcelRequire("acw62");









const $f78745d64a25ac96$export$3db4614a73ea75e3 = (0, $aca50e9407ba89c9$export$b6ae1bc530f4c149)(({ values: values, updateField: updateField })=>{
    const [searchValue, setSearchValue] = (0, $acw62.useState)("");
    const [calculatingList, setCalculatingList] = (0, $acw62.useState)(false);
    const [filteredLanguages, setFilteredLanguages] = (0, $acw62.useState)([]);
    const { languageList: languageList, getLanguages: getLanguages } = (0, $4671947198ddd366$export$6ccbb43953eebf8)().data;
    const { query: { isLoading: languagesLoading }, enableQuery: loadProfessions } = (0, $4671947198ddd366$export$517ca4f7fee4e226)(getLanguages);
    (0, $acw62.useEffect)(()=>{
        if (languageList.length === 0) loadProfessions();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    (0, $acw62.useEffect)(()=>{
        if (languageList.length > 0) setFilteredLanguages(languageList);
    }, [
        languageList,
        languageList.length
    ]);
    const filterLanguages = (0, $85953efa7e00ce5b$export$2e2bcd8739ae039)((value)=>{
        setFilteredLanguages(languageList.filter((item)=>item.name.toLowerCase().includes(value.toLowerCase())));
        setCalculatingList(false);
    }, 500);
    const [calculatingListDebounced] = (0, $28cfa09e9775cf8c$export$2e2bcd8739ae039)(calculatingList, 300);
    const { t: t } = (0, $3765cebd031b52c0$export$9fc83ad70ead8663)();
    const handleSearchChange = (value)=>{
        setCalculatingList(true);
        setSearchValue(value);
        filterLanguages(value);
    };
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "Language",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $660b2ca422e0e2ae$export$1ff3c3f08ae963c0).Vertical, {
                height: 24
            }),
            languagesLoading ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $57fb8f45c69e1681$export$2e2bcd8739ae039), {}) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $db7fb73ce5c45471$export$55d7609a8f1eccd2), {
                        value: searchValue,
                        handleValueChange: handleSearchChange,
                        placeholder: t("lead_form.select_languages")
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $660b2ca422e0e2ae$export$1ff3c3f08ae963c0).Vertical, {
                        height: 16
                    }),
                    calculatingListDebounced ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $57fb8f45c69e1681$export$2e2bcd8739ae039), {}) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "Language__list",
                        children: filteredLanguages.map((language)=>{
                            const isActive = values.languages.includes(language.id);
                            const toggle = ()=>{
                                updateField(isActive ? values.languages.filter((id)=>id !== language.id) : [
                                    ...values.languages,
                                    language.id
                                ]);
                            };
                            return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "Language__list__row",
                                onClick: toggle,
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                        className: "Language__list__row__title",
                                        children: language.name
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f224f10e61e1d993$export$48513f6b9f8ce62d), {
                                        isActive: isActive,
                                        onChange: toggle
                                    })
                                ]
                            }, language.id);
                        })
                    })
                ]
            })
        ]
    });
});







const $8153c96d073f0b15$export$d549c77c8a078892 = ({ values: values, updateField: updateField })=>{
    const { t: t } = (0, $3765cebd031b52c0$export$9fc83ad70ead8663)();
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "Gender",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $660b2ca422e0e2ae$export$1ff3c3f08ae963c0).Vertical, {
                height: 54
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "Gender__innerContainer",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $2ab88429e3384d30$export$353f5b6fc5456de1), {
                        title: t("lead_form.male"),
                        onClick: ()=>{
                            updateField(1);
                        },
                        className: `Gender__innerContainer__button ${values.gender === 1 ? "active" : ""}`
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $660b2ca422e0e2ae$export$1ff3c3f08ae963c0).Vertical, {
                        height: 10
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $2ab88429e3384d30$export$353f5b6fc5456de1), {
                        title: t("lead_form.female"),
                        onClick: ()=>{
                            updateField(2);
                        },
                        className: `Gender__innerContainer__button ${values.gender === 2 ? "active" : ""}`
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $660b2ca422e0e2ae$export$1ff3c3f08ae963c0).Vertical, {
                        height: 10
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $2ab88429e3384d30$export$353f5b6fc5456de1), {
                        title: t("lead_form.no_preference"),
                        onClick: ()=>{
                            updateField(null);
                        },
                        className: `Gender__innerContainer__button ${values.gender === null ? "active" : ""}`
                    })
                ]
            })
        ]
    });
};





const $10fcddb51c223d53$export$1cbbc5990c2ee230 = [
    {
        title: "What Staff do you need?",
        subtitle: "Find vetted staff for your every need"
    },
    {
        title: "Where do you need the staff?",
        subtitle: "Select the location or the venue for where you need the staff"
    },
    {
        title: "When is the staff needed?",
        subtitle: "Select the date when you require staff"
    },
    {
        title: "How many days per week?",
        subtitle: "Select which days you want the staff to work"
    },
    {
        title: "When is the staff needed?",
        subtitle: "Select the timing for the staff"
    },
    {
        title: "What will they do?",
        subtitle: "Add the job description for the staff (What is expected from the staff)"
    },
    {
        title: "How experienced do you need the staff to be?",
        subtitle: "Select the type of experience you want the staff to have"
    },
    {
        title: "Do you have a language preference?",
        subtitle: "What languages would you like the staff to speak?"
    },
    {
        title: "Do you have a gender preference?",
        subtitle: "Select the staff's preferred gender"
    }
];



const $3c71b5bd598f3597$var$screens = [
    {
        field: "categoriesCount",
        Component: (0, $d93b3fd4cd76aa53$export$2466b7e3d19134ac)
    },
    {
        field: "location",
        Component: (0, $5899d288dfbab641$export$18a2be9195644f38)
    },
    {
        field: "dates",
        Component: (0, $6e85b567760cfccb$export$41c3ac8c866f31c8)
    },
    {
        field: "days",
        Component: (0, $0c0f82518a2a572f$export$d3134eff2123aadb)
    },
    {
        field: "time",
        Component: (0, $01ba220ba7f9f1e5$export$680ea196effce5f)
    },
    {
        field: "description",
        Component: (0, $da6e7d8dbadfc5f7$export$393edc798c47379d)
    },
    {
        field: "experienceLevel",
        Component: (0, $a56629ddd624591d$export$21f8d1d652eb4709)
    },
    {
        field: "languages",
        Component: (0, $f78745d64a25ac96$export$3db4614a73ea75e3)
    },
    {
        field: "gender",
        Component: (0, $8153c96d073f0b15$export$d549c77c8a078892)
    }
];
const $3c71b5bd598f3597$export$f832aaf1089bb739 = (0, $aca50e9407ba89c9$export$b6ae1bc530f4c149)(()=>{
    const { profile: profile, companyDetails: companyDetails, getProfile: getProfile, "get\u0421ompanyDetails": get\u0421ompanyDetails, submitLeadForm: submitLeadForm } = (0, $4671947198ddd366$export$6ccbb43953eebf8)().data;
    const { isLoading: profileLoading } = (0, $4671947198ddd366$export$dd0a697e1782aedd)(getProfile);
    const { isLoading: companyDetailsLoading } = (0, $4671947198ddd366$export$dd0a697e1782aedd)(get\u0421ompanyDetails);
    const [submitResult, submit] = (0, $4671947198ddd366$export$609860bf8b0084c)(submitLeadForm, {
        filterError: [
            (0, $9ad33fbf770c55a1$export$9696fcf1798e1cb5).ClientError
        ],
        onSuccess: ()=>{
            redirect((0, $0534349ae8731d0b$export$66b32f6f30eb4b4).orderCreateSuccess, {});
        },
        onError: (err)=>{
            if (err.data.errors) setErrors(Object.values(err.data.errors).flat());
        }
    });
    const [errors, setErrors] = (0, $acw62.useState)([]);
    const [step, setStep] = (0, $acw62.useState)(0);
    const [formState, setFormState] = (0, $acw62.useState)({
        categoriesCount: {},
        location: null,
        dates: {
            startDate: null,
            endDate: null
        },
        days: [],
        time: {
            startTime: null,
            endTime: null
        },
        description: null,
        experienceLevel: null,
        languages: [],
        gender: null
    });
    const redirect = (0, $7df35e9df335b1c8$export$602eaf6d5314ce55)();
    const { t: t } = (0, $3765cebd031b52c0$export$9fc83ad70ead8663)();
    const getNextStatus = ()=>{
        switch(step){
            case 0:
                return !Boolean(Object.values(formState.categoriesCount).find((item)=>item !== 0));
            case 1:
                return formState.location === null;
            case 2:
                return !formState.dates.startDate || !formState.dates.endDate;
            case 3:
                return formState.days.length === 0;
            case 4:
                return !formState.time.startTime || !formState.time.endTime;
            case 5:
                return formState.description === null || formState.description.length === 0;
            case 6:
                return formState.experienceLevel === null;
            default:
                return false;
        }
    };
    const updateField = (field)=>(fieldState)=>{
            setFormState((prevState)=>({
                    ...prevState,
                    [field]: fieldState
                }));
        };
    const isNextDisabled = getNextStatus();
    const { Component: Component } = $3c71b5bd598f3597$var$screens[step];
    const handleSubmit = ()=>{
        submit({
            company_name: companyDetails?.company_name,
            contact_email: profile?.email,
            contact_name: `${profile?.first_name} ${profile?.last_name}`,
            contact_phone: profile?.phone,
            days: formState.days,
            description: formState.description,
            end_date: formState.dates.endDate,
            end_time: formState.time.endTime,
            start_date: formState.dates.startDate,
            start_time: formState.time.startTime,
            experience: formState.experienceLevel,
            gender: formState.gender,
            language_ids: formState.languages,
            location: {
                address: formState.location?.address,
                lat: formState.location?.lat,
                lng: formState.location?.lng
            },
            categories: formState.categoriesCount
        });
    };
    if (profileLoading || companyDetailsLoading) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $57fb8f45c69e1681$export$2e2bcd8739ae039), {});
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "LeadForm",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $660b2ca422e0e2ae$export$1ff3c3f08ae963c0).Vertical, {
                height: 40
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $de8c64dc6b41b9b0$export$8b251419efc915eb), {
                title: (0, $10fcddb51c223d53$export$1cbbc5990c2ee230)[step].title,
                subtitle: (0, $10fcddb51c223d53$export$1cbbc5990c2ee230)[step].subtitle
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)(Component, {
                values: formState,
                updateField: updateField($3c71b5bd598f3597$var$screens[step].field)
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $660b2ca422e0e2ae$export$1ff3c3f08ae963c0).Spacer, {
                minHeight: 27
            }),
            errors.length > 0 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                className: "LeadForm__errors",
                children: errors.join(", ")
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $9dfc32a0a996fa14$export$ed8ca599049e8881), {
                stepsCount: $3c71b5bd598f3597$var$screens.length,
                currentStep: step,
                handleNextPress: ()=>{
                    if (step === $3c71b5bd598f3597$var$screens.length - 1) handleSubmit();
                    else setStep((prevStep)=>prevStep + 1);
                },
                handleBackPress: ()=>{
                    setStep((prevStep)=>prevStep - 1);
                },
                nextDisabled: isNextDisabled || submitResult.isLoading,
                backDisabled: step === 0,
                nextButtonLabel: step === $3c71b5bd598f3597$var$screens.length - 1 ? t("lead_form.submit") : t("lead_form.next")
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $660b2ca422e0e2ae$export$1ff3c3f08ae963c0).Vertical, {
                height: 40
            })
        ]
    });
});



const $5eadc612f1acf3fc$export$d523e0ec44fa5fa1 = {
    LeadFormPage: $3c71b5bd598f3597$export$f832aaf1089bb739,
    LeadFormSuccessPage: (0, $323a86ff22145402$export$b2775b67f0963f7e)
};




var $acw62 = parcelRequire("acw62");



var $55c266174df4cb4c$exports = {};
$55c266174df4cb4c$exports = new URL("arrow-down.3b294547.svg", import.meta.url).toString();


var $0a896d551171fbd8$exports = {};
$0a896d551171fbd8$exports = new URL("plant.bd7b6d04.svg", import.meta.url).toString();


var $223d98c0aff44c56$exports = {};
$223d98c0aff44c56$exports = new URL("smile.f731184c.svg", import.meta.url).toString();


var $fea383d5dbb46498$exports = {};
$fea383d5dbb46498$exports = new URL("thumb-up.3e0b1402.svg", import.meta.url).toString();


var $f6709e8bdb196260$exports = {};
$f6709e8bdb196260$exports = new URL("home-applicant-review.bbccab08.png", import.meta.url).toString();


var $59117e1203fbc895$exports = {};
$59117e1203fbc895$exports = new URL("home-attendance-review.2573e68e.png", import.meta.url).toString();


var $1f4dc594e8385cc6$exports = {};
$1f4dc594e8385cc6$exports = new URL("home-hire.b302477e.png", import.meta.url).toString();


var $a0e57cd56e6fb9b9$exports = {};
$a0e57cd56e6fb9b9$exports = new URL("home-orders-confirmation.1f982268.png", import.meta.url).toString();


var $063583174c0e93e0$exports = {};
$063583174c0e93e0$exports = new URL("home-rating-requests.1094b19e.png", import.meta.url).toString();


const $68c1141b5a7e24d8$export$6c746a5570b8b35c = {
    arrowDownImg: (/*@__PURE__*/$parcel$interopDefault($55c266174df4cb4c$exports)),
    plantImg: (/*@__PURE__*/$parcel$interopDefault($0a896d551171fbd8$exports)),
    smileImg: (/*@__PURE__*/$parcel$interopDefault($223d98c0aff44c56$exports)),
    thumbUpImg: (/*@__PURE__*/$parcel$interopDefault($fea383d5dbb46498$exports)),
    homeApplicantReviewImg: (/*@__PURE__*/$parcel$interopDefault($f6709e8bdb196260$exports)),
    homeAttendanceReview: (/*@__PURE__*/$parcel$interopDefault($59117e1203fbc895$exports)),
    homeHireImg: (/*@__PURE__*/$parcel$interopDefault($1f4dc594e8385cc6$exports)),
    homeOrdersConfirmationImg: (/*@__PURE__*/$parcel$interopDefault($a0e57cd56e6fb9b9$exports)),
    homeRatingRequstsImg: (/*@__PURE__*/$parcel$interopDefault($063583174c0e93e0$exports))
};




const $3543ad2faa071753$export$84cb1f136c1b68ed = {
    title: (0, $2b1f0855f2f3a952$export$625550452a3fa3ec)("home_onboarding.title"),
    paths: [
        (0, $0534349ae8731d0b$export$66b32f6f30eb4b4).index.path
    ],
    pages: [
        {
            title: null,
            content: [
                {
                    image: {
                        src: (0, $68c1141b5a7e24d8$export$6c746a5570b8b35c).plantImg,
                        className: "HomeOnboarding__plantImg"
                    }
                },
                {
                    description: (0, $2b1f0855f2f3a952$export$625550452a3fa3ec)("home_onboarding.intro_title")
                },
                {
                    description: (0, $2b1f0855f2f3a952$export$625550452a3fa3ec)("home_onboarding.intro_description")
                },
                {
                    image: {
                        src: (0, $68c1141b5a7e24d8$export$6c746a5570b8b35c).smileImg,
                        className: "HomeOnboarding__smileImg"
                    }
                },
                {
                    description: (0, $2b1f0855f2f3a952$export$625550452a3fa3ec)("home_onboarding.intro_footer")
                }
            ]
        },
        {
            title: (0, $2b1f0855f2f3a952$export$625550452a3fa3ec)("home_onboarding.hire_title"),
            content: [
                {
                    image: {
                        src: (0, $68c1141b5a7e24d8$export$6c746a5570b8b35c).homeHireImg,
                        className: "Onboarding__bigImg"
                    }
                },
                {
                    description: (0, $2b1f0855f2f3a952$export$625550452a3fa3ec)("home_onboarding.hire")
                }
            ]
        },
        {
            title: (0, $2b1f0855f2f3a952$export$625550452a3fa3ec)("home_onboarding.attendance_title"),
            content: [
                {
                    image: {
                        src: (0, $68c1141b5a7e24d8$export$6c746a5570b8b35c).homeAttendanceReview,
                        className: "Onboarding__bigImg"
                    }
                },
                {
                    description: (0, $2b1f0855f2f3a952$export$625550452a3fa3ec)("home_onboarding.attendance")
                }
            ]
        },
        {
            title: (0, $2b1f0855f2f3a952$export$625550452a3fa3ec)("home_onboarding.orders_title"),
            content: [
                {
                    image: {
                        src: (0, $68c1141b5a7e24d8$export$6c746a5570b8b35c).homeOrdersConfirmationImg,
                        className: "Onboarding__bigImg"
                    }
                },
                {
                    description: (0, $2b1f0855f2f3a952$export$625550452a3fa3ec)("home_onboarding.orders")
                }
            ]
        },
        {
            title: (0, $2b1f0855f2f3a952$export$625550452a3fa3ec)("home_onboarding.ratings_title"),
            content: [
                {
                    image: {
                        src: (0, $68c1141b5a7e24d8$export$6c746a5570b8b35c).homeRatingRequstsImg,
                        className: "Onboarding__bigImg"
                    }
                },
                {
                    description: (0, $2b1f0855f2f3a952$export$625550452a3fa3ec)("home_onboarding.ratings")
                }
            ]
        },
        {
            title: (0, $2b1f0855f2f3a952$export$625550452a3fa3ec)("home_onboarding.applicants_review_title"),
            content: [
                {
                    image: {
                        src: (0, $68c1141b5a7e24d8$export$6c746a5570b8b35c).homeApplicantReviewImg,
                        className: "Onboarding__bigImg"
                    }
                },
                {
                    description: (0, $2b1f0855f2f3a952$export$625550452a3fa3ec)("home_onboarding.applicants_review")
                }
            ]
        },
        {
            title: null,
            content: [
                {
                    image: {
                        src: (0, $68c1141b5a7e24d8$export$6c746a5570b8b35c).thumbUpImg,
                        className: "HomeOnboarding__thumbUpImg"
                    }
                },
                {
                    description: (0, $2b1f0855f2f3a952$export$625550452a3fa3ec)("home_onboarding.outro")
                },
                {
                    image: {
                        src: (0, $68c1141b5a7e24d8$export$6c746a5570b8b35c).arrowDownImg,
                        className: "HomeOnboarding__arrowDownImg"
                    }
                }
            ]
        }
    ]
};




var $03be1d580d509d94$exports = {};
$03be1d580d509d94$exports = new URL("job-all-shifts-tools.50d89d17.png", import.meta.url).toString();


var $18a80d4a2374b413$exports = {};
$18a80d4a2374b413$exports = new URL("job-single-shift-tools.7dfd7489.png", import.meta.url).toString();


var $e2fe1dec75a0ec8f$exports = {};
$e2fe1dec75a0ec8f$exports = new URL("all-jobs-list.7f8c7e6e.png", import.meta.url).toString();


var $ab5bfd9fc852f9f8$exports = {};
$ab5bfd9fc852f9f8$exports = new URL("change-schedule.1b85d998.png", import.meta.url).toString();


var $46c1cd2fe9062732$exports = {};
$46c1cd2fe9062732$exports = new URL("cancel-shift.47f7f4f5.png", import.meta.url).toString();


const $329db624956967cc$export$6c746a5570b8b35c = {
    jobAllShiftsToolsImg: (/*@__PURE__*/$parcel$interopDefault($03be1d580d509d94$exports)),
    jobSingleShiftTools: (/*@__PURE__*/$parcel$interopDefault($18a80d4a2374b413$exports)),
    allJobsListImg: (/*@__PURE__*/$parcel$interopDefault($e2fe1dec75a0ec8f$exports)),
    changeScheduleImg: (/*@__PURE__*/$parcel$interopDefault($ab5bfd9fc852f9f8$exports)),
    cancelShiftImg: (/*@__PURE__*/$parcel$interopDefault($46c1cd2fe9062732$exports))
};



const $46040176d822cdc2$export$529e9a8625e5bac7 = {
    title: (0, $2b1f0855f2f3a952$export$625550452a3fa3ec)("all_jobs_onboarding.title"),
    paths: [
        (0, $0534349ae8731d0b$export$66b32f6f30eb4b4).allJobs.path
    ],
    pages: [
        {
            title: (0, $2b1f0855f2f3a952$export$625550452a3fa3ec)("all_jobs_onboarding.jobs_list_title"),
            content: [
                {
                    image: {
                        src: (0, $329db624956967cc$export$6c746a5570b8b35c).allJobsListImg,
                        className: "Onboarding__bigImg"
                    }
                },
                {
                    description: (0, $2b1f0855f2f3a952$export$625550452a3fa3ec)("all_jobs_onboarding.jobs_list")
                }
            ]
        },
        {
            title: (0, $2b1f0855f2f3a952$export$625550452a3fa3ec)("all_jobs_onboarding.job_details_title"),
            content: [
                {
                    image: {
                        src: (0, $329db624956967cc$export$6c746a5570b8b35c).jobSingleShiftTools,
                        className: "Onboarding__bigImg"
                    }
                },
                {
                    description: (0, $2b1f0855f2f3a952$export$625550452a3fa3ec)("all_jobs_onboarding.job_details")
                }
            ]
        },
        {
            title: (0, $2b1f0855f2f3a952$export$625550452a3fa3ec)("all_jobs_onboarding.change_schedule_title"),
            content: [
                {
                    image: {
                        src: (0, $329db624956967cc$export$6c746a5570b8b35c).jobAllShiftsToolsImg,
                        className: "Onboarding__bigImg"
                    }
                },
                {
                    description: (0, $2b1f0855f2f3a952$export$625550452a3fa3ec)("all_jobs_onboarding.change_schedule")
                }
            ]
        },
        {
            title: (0, $2b1f0855f2f3a952$export$625550452a3fa3ec)("all_jobs_onboarding.bulk_schedule_change_title"),
            content: [
                {
                    image: {
                        src: (0, $329db624956967cc$export$6c746a5570b8b35c).changeScheduleImg,
                        className: "Onboarding__bigImg"
                    }
                },
                {
                    description: (0, $2b1f0855f2f3a952$export$625550452a3fa3ec)("all_jobs_onboarding.bulk_schedule_change")
                }
            ]
        },
        {
            title: (0, $2b1f0855f2f3a952$export$625550452a3fa3ec)("all_jobs_onboarding.cancel_shift_title"),
            content: [
                {
                    image: {
                        src: (0, $329db624956967cc$export$6c746a5570b8b35c).cancelShiftImg,
                        className: "Onboarding__bigImg"
                    }
                },
                {
                    description: (0, $2b1f0855f2f3a952$export$625550452a3fa3ec)("all_jobs_onboarding.cancel_shift")
                }
            ]
        }
    ]
};




var $a593fc82db44bd4d$exports = {};
$a593fc82db44bd4d$exports = new URL("attendance-details.f1ca4371.png", import.meta.url).toString();


var $cbba520a1ebaf402$exports = {};
$cbba520a1ebaf402$exports = new URL("attendance-status-change.3c4ec1f8.png", import.meta.url).toString();


var $105820b22e66e894$exports = {};
$105820b22e66e894$exports = new URL("attendance-time-change.03b0cbf6.png", import.meta.url).toString();


var $bf29c43840f7f9da$exports = {};
$bf29c43840f7f9da$exports = new URL("confirmation-time.46861081.png", import.meta.url).toString();


var $84fc37f582777702$exports = {};
$84fc37f582777702$exports = new URL("jobs-pending-review.9b0172d6.png", import.meta.url).toString();


var $21c6c074fde567df$exports = {};
$21c6c074fde567df$exports = new URL("not-attended-reason-change.07ebd666.png", import.meta.url).toString();


const $3551e268a2b44e24$export$6c746a5570b8b35c = {
    attendanceDetailsImg: (/*@__PURE__*/$parcel$interopDefault($a593fc82db44bd4d$exports)),
    attendanceStatusChangeImg: (/*@__PURE__*/$parcel$interopDefault($cbba520a1ebaf402$exports)),
    attendanceTimeChangeImg: (/*@__PURE__*/$parcel$interopDefault($105820b22e66e894$exports)),
    confirmationTimeImg: (/*@__PURE__*/$parcel$interopDefault($bf29c43840f7f9da$exports)),
    jobsPendingReviewImg: (/*@__PURE__*/$parcel$interopDefault($84fc37f582777702$exports)),
    notAttendedReasonChangeImg: (/*@__PURE__*/$parcel$interopDefault($21c6c074fde567df$exports))
};



const $6d42b8bc83dcdc39$export$99becf33fb6b8f2c = {
    title: (0, $2b1f0855f2f3a952$export$625550452a3fa3ec)("attendance_review_onboarding.title"),
    paths: [
        (0, $0534349ae8731d0b$export$66b32f6f30eb4b4).attendanceShiftsList.path
    ],
    pages: [
        {
            title: (0, $2b1f0855f2f3a952$export$625550452a3fa3ec)("attendance_review_onboarding.jobs_pending_review_title"),
            content: [
                {
                    image: {
                        src: (0, $3551e268a2b44e24$export$6c746a5570b8b35c).jobsPendingReviewImg,
                        className: "Onboarding__bigImg"
                    }
                },
                {
                    description: (0, $2b1f0855f2f3a952$export$625550452a3fa3ec)("attendance_review_onboarding.jobs_pending_review")
                }
            ]
        },
        {
            title: (0, $2b1f0855f2f3a952$export$625550452a3fa3ec)("attendance_review_onboarding.attendance_details_title"),
            content: [
                {
                    image: {
                        src: (0, $3551e268a2b44e24$export$6c746a5570b8b35c).attendanceDetailsImg,
                        className: "Onboarding__bigImg"
                    }
                },
                {
                    description: (0, $2b1f0855f2f3a952$export$625550452a3fa3ec)("attendance_review_onboarding.attendance_details")
                }
            ]
        },
        {
            title: (0, $2b1f0855f2f3a952$export$625550452a3fa3ec)("attendance_review_onboarding.attendance_status_title"),
            content: [
                {
                    image: {
                        src: (0, $3551e268a2b44e24$export$6c746a5570b8b35c).attendanceStatusChangeImg,
                        className: "Onboarding__bigImg"
                    }
                },
                {
                    description: (0, $2b1f0855f2f3a952$export$625550452a3fa3ec)("attendance_review_onboarding.attendance_status")
                }
            ]
        },
        {
            title: (0, $2b1f0855f2f3a952$export$625550452a3fa3ec)("attendance_review_onboarding.attendance_time_title"),
            content: [
                {
                    image: {
                        src: (0, $3551e268a2b44e24$export$6c746a5570b8b35c).attendanceTimeChangeImg,
                        className: "Onboarding__bigImg"
                    }
                },
                {
                    description: (0, $2b1f0855f2f3a952$export$625550452a3fa3ec)("attendance_review_onboarding.attendance_time")
                }
            ]
        },
        {
            title: (0, $2b1f0855f2f3a952$export$625550452a3fa3ec)("attendance_review_onboarding.not_attended_reason_title"),
            content: [
                {
                    image: {
                        src: (0, $3551e268a2b44e24$export$6c746a5570b8b35c).notAttendedReasonChangeImg,
                        className: "Onboarding__bigImg"
                    }
                },
                {
                    description: (0, $2b1f0855f2f3a952$export$625550452a3fa3ec)("attendance_review_onboarding.not_attended_reason")
                }
            ]
        },
        {
            title: (0, $2b1f0855f2f3a952$export$625550452a3fa3ec)("attendance_review_onboarding.confirmation_time_title"),
            content: [
                {
                    image: {
                        src: (0, $3551e268a2b44e24$export$6c746a5570b8b35c).confirmationTimeImg,
                        className: "Onboarding__bigImg"
                    }
                },
                {
                    description: (0, $2b1f0855f2f3a952$export$625550452a3fa3ec)("attendance_review_onboarding.confirmation_time")
                }
            ]
        }
    ]
};




var $3d41a64c95328a6b$exports = {};
$3d41a64c95328a6b$exports = new URL("orders-pending-confirmation.348d8461.png", import.meta.url).toString();


var $e7ca89777006037e$exports = {};
$e7ca89777006037e$exports = new URL("order-confirmation.4b1e66fb.png", import.meta.url).toString();


var $f73df415352d642b$exports = {};
$f73df415352d642b$exports = new URL("order-amend.814494b2.png", import.meta.url).toString();


const $6f6d15203333eb7c$export$6c746a5570b8b35c = {
    ordersPendingConfirmationImg: (/*@__PURE__*/$parcel$interopDefault($3d41a64c95328a6b$exports)),
    orderConfirmationImg: (/*@__PURE__*/$parcel$interopDefault($e7ca89777006037e$exports)),
    orderAmendImg: (/*@__PURE__*/$parcel$interopDefault($f73df415352d642b$exports))
};



const $57418d185db8696d$export$6a605a132a1ef658 = {
    title: (0, $2b1f0855f2f3a952$export$625550452a3fa3ec)("order_confirmation_onboarding.title"),
    paths: [
        (0, $0534349ae8731d0b$export$66b32f6f30eb4b4).orders.path
    ],
    pages: [
        {
            title: (0, $2b1f0855f2f3a952$export$625550452a3fa3ec)("order_confirmation_onboarding.pending_confirmation_title"),
            content: [
                {
                    image: {
                        src: (0, $6f6d15203333eb7c$export$6c746a5570b8b35c).ordersPendingConfirmationImg,
                        className: "Onboarding__bigImg"
                    }
                },
                {
                    description: (0, $2b1f0855f2f3a952$export$625550452a3fa3ec)("order_confirmation_onboarding.pending_confirmation")
                }
            ]
        },
        {
            title: (0, $2b1f0855f2f3a952$export$625550452a3fa3ec)("order_confirmation_onboarding.order_confirmation_title"),
            content: [
                {
                    image: {
                        src: (0, $6f6d15203333eb7c$export$6c746a5570b8b35c).orderConfirmationImg,
                        className: "Onboarding__bigImg"
                    }
                },
                {
                    description: (0, $2b1f0855f2f3a952$export$625550452a3fa3ec)("order_confirmation_onboarding.order_confirmation")
                }
            ]
        },
        {
            title: (0, $2b1f0855f2f3a952$export$625550452a3fa3ec)("order_confirmation_onboarding.order_amend_title"),
            content: [
                {
                    image: {
                        src: (0, $6f6d15203333eb7c$export$6c746a5570b8b35c).orderAmendImg,
                        className: "Onboarding__bigImg"
                    }
                },
                {
                    description: (0, $2b1f0855f2f3a952$export$625550452a3fa3ec)("order_confirmation_onboarding.order_amend")
                }
            ]
        }
    ]
};




var $9713b0429d72c1ab$exports = {};
$9713b0429d72c1ab$exports = new URL("applicant-details.63f00581.png", import.meta.url).toString();


var $67095979103af6a4$exports = {};
$67095979103af6a4$exports = new URL("jobs-applicants-list.88a50887.png", import.meta.url).toString();


var $b57fcb24916e372a$exports = {};
$b57fcb24916e372a$exports = new URL("jobs-pending-applicants-review.d5bbc2a3.png", import.meta.url).toString();


const $6c3711bb9195b48f$export$6c746a5570b8b35c = {
    applicantDetailsImg: (/*@__PURE__*/$parcel$interopDefault($9713b0429d72c1ab$exports)),
    jobsApplicantsListImg: (/*@__PURE__*/$parcel$interopDefault($67095979103af6a4$exports)),
    jobsPendingApplicantsReviewImg: (/*@__PURE__*/$parcel$interopDefault($b57fcb24916e372a$exports))
};



const $cdb99f460ce4a5b7$export$563c60e0dc564b1b = {
    title: (0, $2b1f0855f2f3a952$export$625550452a3fa3ec)("applicants_review_onboarding.title"),
    paths: [
        (0, $0534349ae8731d0b$export$66b32f6f30eb4b4).applicantsReview.path
    ],
    pages: [
        {
            title: (0, $2b1f0855f2f3a952$export$625550452a3fa3ec)("applicants_review_onboarding.title"),
            content: [
                {
                    image: {
                        src: (0, $6c3711bb9195b48f$export$6c746a5570b8b35c).jobsPendingApplicantsReviewImg,
                        className: "Onboarding__bigImg"
                    }
                },
                {
                    description: (0, $2b1f0855f2f3a952$export$625550452a3fa3ec)("applicants_review_onboarding.pending_applicant_review")
                }
            ]
        },
        {
            title: (0, $2b1f0855f2f3a952$export$625550452a3fa3ec)("applicants_review_onboarding.applicant_list_title"),
            content: [
                {
                    image: {
                        src: (0, $6c3711bb9195b48f$export$6c746a5570b8b35c).jobsApplicantsListImg,
                        className: "Onboarding__bigImg"
                    }
                },
                {
                    description: (0, $2b1f0855f2f3a952$export$625550452a3fa3ec)("applicants_review_onboarding.applicant_list")
                }
            ]
        },
        {
            title: (0, $2b1f0855f2f3a952$export$625550452a3fa3ec)("applicants_review_onboarding.applicant_details_title"),
            content: [
                {
                    image: {
                        src: (0, $6c3711bb9195b48f$export$6c746a5570b8b35c).applicantDetailsImg,
                        className: "Onboarding__bigImg"
                    }
                },
                {
                    description: (0, $2b1f0855f2f3a952$export$625550452a3fa3ec)("applicants_review_onboarding.applicant_details")
                }
            ]
        }
    ]
};




var $6b62b21708f18786$exports = {};
$6b62b21708f18786$exports = new URL("location-details.e57cd41e.png", import.meta.url).toString();


var $035e3d3f228c2307$exports = {};
$035e3d3f228c2307$exports = new URL("locations-list.ec1f0abb.png", import.meta.url).toString();


const $44ffadbb812ae614$export$6c746a5570b8b35c = {
    locationsDetailsImg: (/*@__PURE__*/$parcel$interopDefault($6b62b21708f18786$exports)),
    locationsListImg: (/*@__PURE__*/$parcel$interopDefault($035e3d3f228c2307$exports))
};



const $094910ed706ddead$export$5769ec9e16b0cd07 = {
    title: (0, $2b1f0855f2f3a952$export$625550452a3fa3ec)("locations_onboarding.title"),
    paths: [
        (0, $0534349ae8731d0b$export$66b32f6f30eb4b4).locations.path
    ],
    pages: [
        {
            title: (0, $2b1f0855f2f3a952$export$625550452a3fa3ec)("locations_onboarding.location_list_title"),
            content: [
                {
                    image: {
                        src: (0, $44ffadbb812ae614$export$6c746a5570b8b35c).locationsListImg,
                        className: "Onboarding__bigImg"
                    }
                },
                {
                    description: (0, $2b1f0855f2f3a952$export$625550452a3fa3ec)("locations_onboarding.location_list")
                }
            ]
        },
        {
            title: (0, $2b1f0855f2f3a952$export$625550452a3fa3ec)("locations_onboarding.location_details_title"),
            content: [
                {
                    image: {
                        src: (0, $44ffadbb812ae614$export$6c746a5570b8b35c).locationsDetailsImg,
                        className: "Onboarding__bigImg"
                    }
                },
                {
                    description: (0, $2b1f0855f2f3a952$export$625550452a3fa3ec)("locations_onboarding.location_details")
                }
            ]
        }
    ]
};




var $5cfc37781aad5fe2$exports = {};
$5cfc37781aad5fe2$exports = new URL("user-details.9e809fd3.png", import.meta.url).toString();


var $0b831e8ebdab2273$exports = {};
$0b831e8ebdab2273$exports = new URL("users-list.ef5ea126.png", import.meta.url).toString();


const $f694dd1cf8a07c82$export$6c746a5570b8b35c = {
    userDetailsImg: (/*@__PURE__*/$parcel$interopDefault($5cfc37781aad5fe2$exports)),
    userListImg: (/*@__PURE__*/$parcel$interopDefault($0b831e8ebdab2273$exports))
};



const $697fd0145edb9cb5$export$48dc4bb36076dbcd = {
    title: (0, $2b1f0855f2f3a952$export$625550452a3fa3ec)("users_onboarding.title"),
    paths: [
        (0, $0534349ae8731d0b$export$66b32f6f30eb4b4).users.path
    ],
    pages: [
        {
            title: (0, $2b1f0855f2f3a952$export$625550452a3fa3ec)("users_onboarding.user_list_title"),
            content: [
                {
                    image: {
                        src: (0, $f694dd1cf8a07c82$export$6c746a5570b8b35c).userListImg,
                        className: "Onboarding__bigImg"
                    }
                },
                {
                    description: (0, $2b1f0855f2f3a952$export$625550452a3fa3ec)("users_onboarding.user_list")
                }
            ]
        },
        {
            title: (0, $2b1f0855f2f3a952$export$625550452a3fa3ec)("users_onboarding.user_details_title"),
            content: [
                {
                    image: {
                        src: (0, $f694dd1cf8a07c82$export$6c746a5570b8b35c).userDetailsImg,
                        className: "Onboarding__bigImg"
                    }
                },
                {
                    description: (0, $2b1f0855f2f3a952$export$625550452a3fa3ec)("users_onboarding.user_details")
                }
            ]
        }
    ]
};




var $ee0399bcbe3d0067$exports = {};
$ee0399bcbe3d0067$exports = new URL("job-rating-details.9927b078.png", import.meta.url).toString();


var $46e438e4bc0a9a8c$exports = {};
$46e438e4bc0a9a8c$exports = new URL("jobs-pending-feedback.ab241734.png", import.meta.url).toString();


const $132755da15dfc328$export$6c746a5570b8b35c = {
    jobRatingDetailsImg: (/*@__PURE__*/$parcel$interopDefault($ee0399bcbe3d0067$exports)),
    jobsPendingFeedback: (/*@__PURE__*/$parcel$interopDefault($46e438e4bc0a9a8c$exports))
};



const $d8877e1e15252dc0$export$4d4c1a43861bb029 = {
    title: (0, $2b1f0855f2f3a952$export$625550452a3fa3ec)("rating_requests_onboarding.title"),
    paths: [
        (0, $0534349ae8731d0b$export$66b32f6f30eb4b4).jobRatingRequests.path
    ],
    pages: [
        {
            title: (0, $2b1f0855f2f3a952$export$625550452a3fa3ec)("rating_requests_onboarding.pending_feedback_title"),
            content: [
                {
                    image: {
                        src: (0, $132755da15dfc328$export$6c746a5570b8b35c).jobsPendingFeedback,
                        className: "Onboarding__bigImg"
                    }
                },
                {
                    description: (0, $2b1f0855f2f3a952$export$625550452a3fa3ec)("rating_requests_onboarding.pending_feedback")
                }
            ]
        },
        {
            title: (0, $2b1f0855f2f3a952$export$625550452a3fa3ec)("rating_requests_onboarding.rating_details_title"),
            content: [
                {
                    image: {
                        src: (0, $132755da15dfc328$export$6c746a5570b8b35c).jobRatingDetailsImg,
                        className: "Onboarding__bigImg"
                    }
                },
                {
                    description: (0, $2b1f0855f2f3a952$export$625550452a3fa3ec)("rating_requests_onboarding.rating_details")
                }
            ]
        }
    ]
};






var $94b3727cb6124796$exports = {};
$94b3727cb6124796$exports = new URL("select-designation.1e8ac606.png", import.meta.url).toString();


var $555278f9cb7a5dd6$exports = {};
$555278f9cb7a5dd6$exports = new URL("job-details.a20b9171.png", import.meta.url).toString();


var $e639662dbe9204db$exports = {};
$e639662dbe9204db$exports = new URL("job-duration.9b4b66d2.png", import.meta.url).toString();


var $f52d85cb712cc0b3$exports = {};
$f52d85cb712cc0b3$exports = new URL("scheduling-options.ca3dafb5.png", import.meta.url).toString();


var $a6de2bdc3a769380$exports = {};
$a6de2bdc3a769380$exports = new URL("job-requirements.bed26d4b.png", import.meta.url).toString();


var $1bcdb964eb471514$exports = {};
$1bcdb964eb471514$exports = new URL("shifts-breakdown.a7b19cd8.png", import.meta.url).toString();


var $41c2e32c57edb447$exports = {};
$41c2e32c57edb447$exports = new URL("duplicate-job.5015fe41.png", import.meta.url).toString();


var $7cc9076bdc70abbf$exports = {};
$7cc9076bdc70abbf$exports = new URL("send-for-review.300d4e5d.png", import.meta.url).toString();


const $e3b5cbea4f314662$export$6c746a5570b8b35c = {
    selectDesignationImg: (/*@__PURE__*/$parcel$interopDefault($94b3727cb6124796$exports)),
    jobDetailsImg: (/*@__PURE__*/$parcel$interopDefault($555278f9cb7a5dd6$exports)),
    jobDurationImg: (/*@__PURE__*/$parcel$interopDefault($e639662dbe9204db$exports)),
    schedulingOptionsImg: (/*@__PURE__*/$parcel$interopDefault($f52d85cb712cc0b3$exports)),
    jobRequirementsImg: (/*@__PURE__*/$parcel$interopDefault($a6de2bdc3a769380$exports)),
    shiftsBreakdownImg: (/*@__PURE__*/$parcel$interopDefault($1bcdb964eb471514$exports)),
    duplicateJobImg: (/*@__PURE__*/$parcel$interopDefault($41c2e32c57edb447$exports)),
    sendForReviewImg: (/*@__PURE__*/$parcel$interopDefault($7cc9076bdc70abbf$exports))
};


const $d799c1ed4a2789f1$export$c8eaa75f0d7646d7 = {
    title: (0, $2b1f0855f2f3a952$export$625550452a3fa3ec)("order_creation_onboarding.select_designation_title"),
    content: [
        {
            image: {
                src: (0, $e3b5cbea4f314662$export$6c746a5570b8b35c).selectDesignationImg,
                className: "Onboarding__bigImg"
            }
        },
        {
            description: (0, $2b1f0855f2f3a952$export$625550452a3fa3ec)("order_creation_onboarding.select_designation")
        }
    ]
};




const $c3b746b0071dfe68$export$1090479537291fb8 = {
    title: (0, $2b1f0855f2f3a952$export$625550452a3fa3ec)("order_creation_onboarding.job_details_title"),
    content: [
        {
            image: {
                src: (0, $e3b5cbea4f314662$export$6c746a5570b8b35c).jobDetailsImg,
                className: "Onboarding__bigImg"
            }
        },
        {
            description: (0, $2b1f0855f2f3a952$export$625550452a3fa3ec)("order_creation_onboarding.job_details")
        }
    ]
};




const $c2567988a6c9e6af$export$349e214732ac2d8f = {
    title: (0, $2b1f0855f2f3a952$export$625550452a3fa3ec)("order_creation_onboarding.job_duration_title"),
    content: [
        {
            image: {
                src: (0, $e3b5cbea4f314662$export$6c746a5570b8b35c).jobDurationImg,
                className: "Onboarding__bigImg"
            }
        },
        {
            description: (0, $2b1f0855f2f3a952$export$625550452a3fa3ec)("order_creation_onboarding.job_duration")
        }
    ]
};




const $4d061375c719e4dd$export$e3583afcbfd5d305 = {
    title: (0, $2b1f0855f2f3a952$export$625550452a3fa3ec)("order_creation_onboarding.job_requirements_title"),
    content: [
        {
            image: {
                src: (0, $e3b5cbea4f314662$export$6c746a5570b8b35c).jobRequirementsImg,
                className: "Onboarding__bigImg"
            }
        },
        {
            description: (0, $2b1f0855f2f3a952$export$625550452a3fa3ec)("order_creation_onboarding.job_requirements")
        }
    ]
};




const $735bb5fffcf07a87$export$7b1f28585ccecdc4 = {
    title: (0, $2b1f0855f2f3a952$export$625550452a3fa3ec)("order_creation_onboarding.shifts_breakdown_title"),
    content: [
        {
            image: {
                src: (0, $e3b5cbea4f314662$export$6c746a5570b8b35c).shiftsBreakdownImg,
                className: "Onboarding__bigImg"
            }
        },
        {
            description: (0, $2b1f0855f2f3a952$export$625550452a3fa3ec)("order_creation_onboarding.shifts_breakdown")
        }
    ]
};




const $9d20161f56181ba0$export$1d33ebb8134e39a9 = {
    title: (0, $2b1f0855f2f3a952$export$625550452a3fa3ec)("order_creation_onboarding.duplicate_job_title"),
    content: [
        {
            image: {
                src: (0, $e3b5cbea4f314662$export$6c746a5570b8b35c).duplicateJobImg,
                className: "Onboarding__bigImg"
            }
        },
        {
            description: (0, $2b1f0855f2f3a952$export$625550452a3fa3ec)("order_creation_onboarding.duplicate_job")
        }
    ]
};




const $b5ce9429f7348525$export$310766cbdc5fc578 = {
    title: (0, $2b1f0855f2f3a952$export$625550452a3fa3ec)("order_creation_onboarding.send_for_review_title"),
    content: [
        {
            image: {
                src: (0, $e3b5cbea4f314662$export$6c746a5570b8b35c).sendForReviewImg,
                className: "Onboarding__bigImg"
            }
        },
        {
            description: (0, $2b1f0855f2f3a952$export$625550452a3fa3ec)("order_creation_onboarding.send_for_review")
        }
    ]
};


const $94a4e1d2efdb722a$export$d8ba32514f900f83 = {
    title: (0, $2b1f0855f2f3a952$export$625550452a3fa3ec)("order_creation_onboarding.title"),
    paths: [
        (0, $0534349ae8731d0b$export$66b32f6f30eb4b4).setJobCategory.path,
        (0, $0534349ae8731d0b$export$66b32f6f30eb4b4).jobDraftDetails.path,
        (0, $0534349ae8731d0b$export$66b32f6f30eb4b4).orderDraft.path,
        (0, $0534349ae8731d0b$export$66b32f6f30eb4b4).orderDraftSummary.path,
        (0, $0534349ae8731d0b$export$66b32f6f30eb4b4).orderConfirmation.path
    ],
    pages: [
        (0, $d799c1ed4a2789f1$export$c8eaa75f0d7646d7),
        (0, $c3b746b0071dfe68$export$1090479537291fb8),
        (0, $c2567988a6c9e6af$export$349e214732ac2d8f),
        (0, $4d061375c719e4dd$export$e3583afcbfd5d305),
        (0, $735bb5fffcf07a87$export$7b1f28585ccecdc4),
        (0, $9d20161f56181ba0$export$1d33ebb8134e39a9),
        (0, $b5ce9429f7348525$export$310766cbdc5fc578)
    ]
};





const $cd64d1bd1538cb85$export$77e7182efaefba9b = {
    title: (0, $2b1f0855f2f3a952$export$625550452a3fa3ec)("order_creation_onboarding.title"),
    paths: [
        (0, $0534349ae8731d0b$export$66b32f6f30eb4b4).jobDraftDetails.path
    ],
    pages: [
        (0, $c3b746b0071dfe68$export$1090479537291fb8)
    ]
};







const $6831a714c6dbd3e2$export$4c4c91b6aa7a0f0a = {
    title: (0, $2b1f0855f2f3a952$export$625550452a3fa3ec)("order_creation_onboarding.title"),
    paths: [
        (0, $0534349ae8731d0b$export$66b32f6f30eb4b4).orderDraft.path
    ],
    pages: [
        (0, $735bb5fffcf07a87$export$7b1f28585ccecdc4),
        (0, $9d20161f56181ba0$export$1d33ebb8134e39a9),
        (0, $b5ce9429f7348525$export$310766cbdc5fc578)
    ]
};





const $9dd2fe57fb49452f$export$c7f88e5fb78a0652 = {
    title: (0, $2b1f0855f2f3a952$export$625550452a3fa3ec)("order_creation_onboarding.title"),
    paths: [
        (0, $0534349ae8731d0b$export$66b32f6f30eb4b4).setJobCategory.path
    ],
    pages: [
        (0, $d799c1ed4a2789f1$export$c8eaa75f0d7646d7)
    ]
};




var $8172ef22bdc8eef3$exports = {};
$8172ef22bdc8eef3$exports = new URL("export-invoice.95e9565b.png", import.meta.url).toString();


var $5234333f4bd7509b$exports = {};
$5234333f4bd7509b$exports = new URL("invoice-breakdown.1fa2d251.png", import.meta.url).toString();


var $880f31837202f8ce$exports = {};
$880f31837202f8ce$exports = new URL("invoice-shifts-breakdown.95e9565b.png", import.meta.url).toString();


var $f1b7fada12cccf83$exports = {};
$f1b7fada12cccf83$exports = new URL("invoices-list.8d6912ef.png", import.meta.url).toString();


const $a92048859f13cf41$export$6c746a5570b8b35c = {
    exportInvoiceImg: (/*@__PURE__*/$parcel$interopDefault($8172ef22bdc8eef3$exports)),
    invoiceBreakdownImg: (/*@__PURE__*/$parcel$interopDefault($5234333f4bd7509b$exports)),
    invoiceShiftsBreakdown: (/*@__PURE__*/$parcel$interopDefault($880f31837202f8ce$exports)),
    invoicesListImg: (/*@__PURE__*/$parcel$interopDefault($f1b7fada12cccf83$exports))
};



const $47a7a4c82e3358bc$export$d684db1e332760ff = {
    title: (0, $2b1f0855f2f3a952$export$625550452a3fa3ec)("invoices_onboarding.title"),
    paths: [
        (0, $0534349ae8731d0b$export$66b32f6f30eb4b4).invoices.path
    ],
    pages: [
        {
            title: (0, $2b1f0855f2f3a952$export$625550452a3fa3ec)("invoices_onboarding.invoice_list_title"),
            content: [
                {
                    image: {
                        src: (0, $a92048859f13cf41$export$6c746a5570b8b35c).invoicesListImg,
                        className: "Onboarding__bigImg"
                    }
                },
                {
                    description: (0, $2b1f0855f2f3a952$export$625550452a3fa3ec)("invoices_onboarding.invoice_list")
                }
            ]
        },
        {
            title: (0, $2b1f0855f2f3a952$export$625550452a3fa3ec)("invoices_onboarding.invoice_breakdown_title"),
            content: [
                {
                    image: {
                        src: (0, $a92048859f13cf41$export$6c746a5570b8b35c).invoiceBreakdownImg,
                        className: "Onboarding__bigImg"
                    }
                },
                {
                    description: (0, $2b1f0855f2f3a952$export$625550452a3fa3ec)("invoices_onboarding.invoice_breakdown")
                }
            ]
        },
        {
            title: (0, $2b1f0855f2f3a952$export$625550452a3fa3ec)("invoices_onboarding.shifts_breakdown_title"),
            content: [
                {
                    image: {
                        src: (0, $a92048859f13cf41$export$6c746a5570b8b35c).invoiceShiftsBreakdown,
                        className: "Onboarding__bigImg"
                    }
                },
                {
                    description: (0, $2b1f0855f2f3a952$export$625550452a3fa3ec)("invoices_onboarding.shifts_breakdown")
                }
            ]
        },
        {
            title: (0, $2b1f0855f2f3a952$export$625550452a3fa3ec)("invoices_onboarding.export_invoice_title"),
            content: [
                {
                    image: {
                        src: (0, $a92048859f13cf41$export$6c746a5570b8b35c).exportInvoiceImg,
                        className: "Onboarding__bigImg"
                    }
                },
                {
                    description: (0, $2b1f0855f2f3a952$export$625550452a3fa3ec)("invoices_onboarding.export_invoice")
                }
            ]
        }
    ]
};


const $c378281204cf5582$export$dc710011ee95c626 = [
    (0, $3543ad2faa071753$export$84cb1f136c1b68ed),
    (0, $46040176d822cdc2$export$529e9a8625e5bac7),
    (0, $6d42b8bc83dcdc39$export$99becf33fb6b8f2c),
    (0, $57418d185db8696d$export$6a605a132a1ef658),
    (0, $cdb99f460ce4a5b7$export$563c60e0dc564b1b),
    (0, $094910ed706ddead$export$5769ec9e16b0cd07),
    (0, $697fd0145edb9cb5$export$48dc4bb36076dbcd),
    (0, $d8877e1e15252dc0$export$4d4c1a43861bb029),
    (0, $94a4e1d2efdb722a$export$d8ba32514f900f83),
    (0, $47a7a4c82e3358bc$export$d684db1e332760ff)
];
const $c378281204cf5582$export$1e2d545cbd0ebbbd = [
    (0, $3543ad2faa071753$export$84cb1f136c1b68ed),
    (0, $46040176d822cdc2$export$529e9a8625e5bac7),
    (0, $6d42b8bc83dcdc39$export$99becf33fb6b8f2c),
    (0, $57418d185db8696d$export$6a605a132a1ef658),
    (0, $cdb99f460ce4a5b7$export$563c60e0dc564b1b),
    (0, $094910ed706ddead$export$5769ec9e16b0cd07),
    (0, $697fd0145edb9cb5$export$48dc4bb36076dbcd),
    (0, $d8877e1e15252dc0$export$4d4c1a43861bb029),
    (0, $9dd2fe57fb49452f$export$c7f88e5fb78a0652),
    (0, $cd64d1bd1538cb85$export$77e7182efaefba9b),
    (0, $6831a714c6dbd3e2$export$4c4c91b6aa7a0f0a),
    (0, $47a7a4c82e3358bc$export$d684db1e332760ff)
];




var $acw62 = parcelRequire("acw62");




var $8f0d45c34f99fc23$exports = {};
$8f0d45c34f99fc23$exports = new URL("next.92be073b.svg", import.meta.url).toString();


var $9fd43d8597d0d0ab$exports = {};
$9fd43d8597d0d0ab$exports = new URL("previous.5eefd443.svg", import.meta.url).toString();


var $56750052bbeadf68$exports = {};
$56750052bbeadf68$exports = new URL("checkmark.d5b9d702.svg", import.meta.url).toString();



const $a18b4be2b651b051$export$9b3f1338d79bcd06 = ({ step: step, stepsCount: stepsCount, toNextStep: toNextStep, toPreviousStep: toPreviousStep, close: close })=>{
    if (stepsCount === 1) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        className: "PageStepper justifyEnd",
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($a18b4be2b651b051$var$FinishButton, {
            onClick: close
        })
    });
    if (step === 0) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        className: "PageStepper justifyEnd",
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($a18b4be2b651b051$var$NextButton, {
            onClick: toNextStep
        })
    });
    if (step === stepsCount - 1) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "PageStepper justifySpaceBetween",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($a18b4be2b651b051$var$BackButton, {
                onClick: toPreviousStep
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($a18b4be2b651b051$var$FinishButton, {
                onClick: close
            })
        ]
    });
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "PageStepper justifySpaceBetween",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($a18b4be2b651b051$var$BackButton, {
                onClick: toPreviousStep
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($a18b4be2b651b051$var$NextButton, {
                onClick: toNextStep
            })
        ]
    });
};
const $a18b4be2b651b051$var$NextButton = ({ onClick: onClick })=>{
    const { t: t } = (0, $3765cebd031b52c0$export$9fc83ad70ead8663)();
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        onClick: onClick,
        className: "PageStepper__row",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                className: "PageStepper__row__label",
                children: t("page_stepper.next")
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                src: (0, (/*@__PURE__*/$parcel$interopDefault($8f0d45c34f99fc23$exports))),
                className: "PageStepper__row__nextImg"
            })
        ]
    });
};
const $a18b4be2b651b051$var$BackButton = ({ onClick: onClick })=>{
    const { t: t } = (0, $3765cebd031b52c0$export$9fc83ad70ead8663)();
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        onClick: onClick,
        className: "PageStepper__row",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                src: (0, (/*@__PURE__*/$parcel$interopDefault($9fd43d8597d0d0ab$exports))),
                className: "PageStepper__row__backImg"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                className: "PageStepper__row__label",
                children: t("page_stepper.previous")
            })
        ]
    });
};
const $a18b4be2b651b051$var$FinishButton = ({ onClick: onClick })=>{
    const { t: t } = (0, $3765cebd031b52c0$export$9fc83ad70ead8663)();
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        onClick: onClick,
        className: "PageStepper__row",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                className: "PageStepper__row__label",
                children: t("page_stepper.finish")
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                src: (0, (/*@__PURE__*/$parcel$interopDefault($56750052bbeadf68$exports))),
                className: "PageStepper__row__checkmarkImg"
            })
        ]
    });
};


var $7c06d1519f091934$exports = {};
$7c06d1519f091934$exports = new URL("close.02a930c7.svg", import.meta.url).toString();



const $7bde0bf451328415$export$87b31d889485555c = ({ visible: visible, initialIndex: initialIndex, content: content, onClose: onClose })=>{
    const { t: t } = (0, $3765cebd031b52c0$export$9fc83ad70ead8663)();
    const [pageIndex, setPageIndex] = (0, $acw62.useState)(initialIndex);
    const pageContent = content.pages[pageIndex].content;
    const handleClose = ()=>{
        onClose();
        setPageIndex(0);
    };
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        className: `PageOnboarding ${visible ? "" : "hidden"}`,
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
            className: "PageOnboarding__inner-container",
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $660b2ca422e0e2ae$export$1ff3c3f08ae963c0).Vertical, {
                    height: 30
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    onClick: handleClose,
                    className: "PageOnboarding__inner-container__closeContainer",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                            src: (0, (/*@__PURE__*/$parcel$interopDefault($7c06d1519f091934$exports))),
                            className: "PageOnboarding__inner-container__closeContainer__img"
                        }),
                        pageIndex === 0 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $660b2ca422e0e2ae$export$1ff3c3f08ae963c0).Vertical, {
                                    height: 7.5
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                    className: "PageOnboarding__inner-container__closeContainer__closeLabel",
                                    children: t("onboarding.click_here_to_close")
                                })
                            ]
                        })
                    ]
                }),
                pageContent.map((item, index)=>{
                    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $acw62.Fragment), {
                        children: [
                            item.image && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                                src: item.image.src,
                                className: item.image.className
                            }),
                            item.description && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                className: "PageOnboarding__inner-container__description",
                                children: item.description
                            }),
                            index !== pageContent.length - 1 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $660b2ca422e0e2ae$export$1ff3c3f08ae963c0).Vertical, {
                                height: 10
                            })
                        ]
                    }, index);
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $660b2ca422e0e2ae$export$1ff3c3f08ae963c0).Vertical, {
                    height: 10
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $a18b4be2b651b051$export$9b3f1338d79bcd06), {
                    step: pageIndex,
                    stepsCount: content.pages.length,
                    toNextStep: ()=>setPageIndex((prevPage)=>prevPage + 1),
                    toPreviousStep: ()=>setPageIndex((prevPage)=>prevPage - 1),
                    close: handleClose
                })
            ]
        })
    });
};





var $acw62 = parcelRequire("acw62");

var $83e7cd64f489dfa8$exports = {};
$83e7cd64f489dfa8$exports = new URL("arrow-right.b7935169.svg", import.meta.url).toString();



const $f65d3ee8586f5ada$export$5fe179562f470ba6 = ({ title: title, pages: pages, showSeparator: showSeparator, selectOnboarding: selectOnboarding })=>{
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "KnowledgeCenterItem",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("ul", {
                className: "KnowledgeCenterItem__list",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        onClick: ()=>{
                            selectOnboarding(0);
                        },
                        className: "KnowledgeCenterItem__list__header",
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                            className: "KnowledgeCenterItem__list__header__title",
                            children: title
                        })
                    }),
                    pages.map((page, index)=>{
                        if (page.title === null) return null;
                        return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $acw62.Fragment), {
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                    onClick: (e)=>{
                                        e.stopPropagation();
                                        selectOnboarding(index);
                                    },
                                    className: "KnowledgeCenterItem__list__item",
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                            className: "KnowledgeCenterItem__list__item__label",
                                            children: page.title
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                                            src: (0, (/*@__PURE__*/$parcel$interopDefault($83e7cd64f489dfa8$exports))),
                                            className: "KnowledgeCenterItem__list__item__img"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                    className: "KnowledgeCenterItem__list__separator"
                                })
                            ]
                        }, page.title);
                    })
                ]
            }),
            showSeparator && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $660b2ca422e0e2ae$export$1ff3c3f08ae963c0).Vertical, {
                height: 10
            })
        ]
    });
};






var $acw62 = parcelRequire("acw62");


var $3FXWU = parcelRequire("3FXWU");
const $403c4530571a9d88$export$6fe9f886825fe8 = ()=>{
    const [version, setVersion] = (0, $acw62.useState)(null);
    const { t: t } = (0, $3765cebd031b52c0$export$9fc83ad70ead8663)();
    (0, $acw62.useEffect)(()=>{
        (async ()=>{
            setVersion(await (0, $3FXWU.getCurrentAppVersion)());
        })();
    }, []);
    if (version === null) return null;
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        className: "AppVersion",
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
            className: "AppVersion__title",
            children: t("common.app_version", {
                version: version
            })
        })
    });
};


const $4ffaf610e26cfed2$export$e9b34bfc08bf9d0c = ()=>{
    const [visibleOnboarding, setVisibleOnboarding] = (0, $acw62.useState)(null);
    const [initialIndex, setInitialIndex] = (0, $acw62.useState)(0);
    const { t: t } = (0, $3765cebd031b52c0$export$9fc83ad70ead8663)();
    const onboardingKnowledgeInfo = (0, $acw62.useMemo)(()=>{
        if (!visibleOnboarding) return null;
        return (0, $c378281204cf5582$export$dc710011ee95c626).find((item)=>item.paths.includes(visibleOnboarding));
    }, [
        visibleOnboarding
    ]);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "KnowledgeCenter",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7ae42b63183f30b4$export$8b251419efc915eb), {
                title: t("onboarding.knowledge_center")
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $660b2ca422e0e2ae$export$1ff3c3f08ae963c0).Vertical, {
                height: 30
            }),
            (0, $c378281204cf5582$export$dc710011ee95c626).map((onboarding, index)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $acw62.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f65d3ee8586f5ada$export$5fe179562f470ba6), {
                            pages: onboarding.pages,
                            title: onboarding.title,
                            showSeparator: index !== (0, $c378281204cf5582$export$dc710011ee95c626).length - 1,
                            selectOnboarding: (i)=>{
                                setInitialIndex(i);
                                setVisibleOnboarding(onboarding.paths[0]);
                            }
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $660b2ca422e0e2ae$export$1ff3c3f08ae963c0).Vertical, {
                            height: 25
                        })
                    ]
                }, onboarding.paths[0])),
            onboardingKnowledgeInfo && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7bde0bf451328415$export$87b31d889485555c), {
                visible: visibleOnboarding !== null,
                initialIndex: initialIndex,
                onClose: ()=>setVisibleOnboarding(null),
                content: onboardingKnowledgeInfo
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $660b2ca422e0e2ae$export$1ff3c3f08ae963c0).Vertical, {
                height: 50
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $403c4530571a9d88$export$6fe9f886825fe8), {}),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $660b2ca422e0e2ae$export$1ff3c3f08ae963c0).Vertical, {
                height: 50
            })
        ]
    });
};








function $8dd16f798d987f6d$export$bf160c0e57f3f332(UIComponent) {
    return (0, $aca50e9407ba89c9$export$b6ae1bc530f4c149)(()=>{
        const redirect = (0, $7df35e9df335b1c8$export$602eaf6d5314ce55)();
        const { t: t } = (0, $3765cebd031b52c0$export$9fc83ad70ead8663)();
        const { setWorkCategoryId: setWorkCategoryId } = (0, $4671947198ddd366$export$6ccbb43953eebf8)().data;
        const handleSelection = (workCategoryId)=>{
            setWorkCategoryId(workCategoryId);
            redirect((0, $0534349ae8731d0b$export$66b32f6f30eb4b4).signUpWithOrderForm, {});
        };
        return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)(UIComponent, {
            mainTitle: t("sign_up.create_new_order_title"),
            handleSelection: handleSelection,
            title: t("sign_up.choose_work_category_title"),
            subtitle: t("sign_up.choose_work_category_subtitle")
        });
    });
}






var $acw62 = parcelRequire("acw62");

var $58d0d92ad7147bd9$exports = {};
$58d0d92ad7147bd9$exports = new URL("app-logo-small.964e35be.svg", import.meta.url).toString();




const $1083ac530b881fb8$export$8b251419efc915eb = ({ title: title })=>{
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $acw62.Fragment), {
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $660b2ca422e0e2ae$export$1ff3c3f08ae963c0).Vertical, {
                height: 24
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "SelectCategory__headerContainer",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                        src: (0, (/*@__PURE__*/$parcel$interopDefault($58d0d92ad7147bd9$exports))),
                        className: "SelectCategory__logo"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h1", {
                        className: "SelectCategory__title",
                        children: title
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $96de59b951af76cc$export$eeb15ad990050873), {
                        redirectPath: "start"
                    })
                ]
            })
        ]
    });
};


const $3d0dc9787c327575$export$b91a4489d0067ce1 = ({ handleSelection: handleSelection, mainTitle: mainTitle, title: title, subtitle: subtitle })=>{
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7b02d682eb115277$exports.Fragment), {
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $2378c40a8cf67257$export$72cbc7178e72e13f), {
            handleSelection: handleSelection,
            title: title,
            subtitle: subtitle,
            header: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $1083ac530b881fb8$export$8b251419efc915eb), {
                title: mainTitle
            })
        })
    });
};


const $fc9f9ab61e9cd5b4$export$7ac13f098b58f1e3 = (0, $8dd16f798d987f6d$export$bf160c0e57f3f332)((0, $3d0dc9787c327575$export$b91a4489d0067ce1));






var $acw62 = parcelRequire("acw62");










const $0f260db6b11bfd59$var$STEP_BASIC_DATA_INDEX = 0;
const $0f260db6b11bfd59$var$STEP_CONTACT_DATA_INDEX = 1;
const $0f260db6b11bfd59$var$STEPS_COUNT = 2;
function $0f260db6b11bfd59$export$4522881093742c6b(UIComponent) {
    return (0, $aca50e9407ba89c9$export$b6ae1bc530f4c149)(()=>{
        const [currentStep, setCurrentStep] = (0, $acw62.useState)($0f260db6b11bfd59$var$STEP_BASIC_DATA_INDEX);
        const { signUpWithOrderData: signUpWithOrderData, setFirstName: setFirstName, setLastName: setLastName, setCompanyName: setCompanyName, setPhone: setPhone, setEmail: setEmail, toggleEmailAgreement: toggleEmailAgreement, setIndustry: setIndustry, setEmployeesAmountTier: setEmployeesAmountTier, register: register } = (0, $4671947198ddd366$export$6ccbb43953eebf8)().data;
        const basicDataFormRef = (0, $acw62.useRef)(null);
        const contactDataFormRef = (0, $acw62.useRef)(null);
        const firebaseToken = (0, $7af34371d75563b6$export$5a8e049606f4bc34)();
        const redirect = (0, $7df35e9df335b1c8$export$602eaf6d5314ce55)();
        const { t: t } = (0, $3765cebd031b52c0$export$9fc83ad70ead8663)();
        const { createDraftJob: createDraftJob } = (0, $d6286036be37a1b2$export$6feca3f67f446ef2)();
        const onSignUpSuccess = ()=>{
            if (!signUpWithOrderData.workCategoryId) return;
            (0, $c74a0566d4b0fd6d$export$e9db7d6e73593439).metaConversion("track", "Lead");
            const draftJob = createDraftJob();
            draftJob.category.set(signUpWithOrderData.workCategoryId);
            redirect((0, $0534349ae8731d0b$export$66b32f6f30eb4b4).setJobLocation, {
                draftJobId: draftJob.id,
                stepNumber: "2"
            });
        };
        const handleRegistration = ()=>{
            const isCorporate = (signUpWithOrderData.companyName ?? "").length > 0 ? 1 : 0;
            const submitData = {
                first_name: signUpWithOrderData.firstName ?? "",
                last_name: signUpWithOrderData.lastName ?? "",
                phone: signUpWithOrderData.phone ?? "",
                email: signUpWithOrderData.email ?? "",
                allow_marketing_emails: Number(signUpWithOrderData.allow_marketing_emails),
                is_corporate: isCorporate,
                industry: signUpWithOrderData.industry,
                device_id: (0, $32ef62acd40089c4$export$1da4558c59cbf0b1)(),
                firebase_token: firebaseToken,
                employees_amount_tier: signUpWithOrderData.employeesAmountTier ?? null,
                utm: (0, $bd957970431a3ba0$export$b6ed00066e3625b3)()
            };
            if (isCorporate) submitData.company_name = signUpWithOrderData.companyName ?? "";
            requestSignUp(submitData);
        };
        const handleForm = (formRef, onSuccess)=>{
            formRef.current?.validateForm().then(()=>{
                if (!formRef.current?.isValid) return;
                onSuccess();
            });
        };
        const handleNextPress = ()=>{
            switch(currentStep){
                case $0f260db6b11bfd59$var$STEP_BASIC_DATA_INDEX:
                    handleForm(basicDataFormRef, ()=>setCurrentStep($0f260db6b11bfd59$var$STEP_CONTACT_DATA_INDEX));
                    break;
                case $0f260db6b11bfd59$var$STEP_CONTACT_DATA_INDEX:
                    handleForm(contactDataFormRef, handleRegistration);
                    break;
                default:
                    break;
            }
        };
        const handleBackPress = ()=>{
            switch(currentStep){
                case $0f260db6b11bfd59$var$STEP_BASIC_DATA_INDEX:
                    redirect((0, $0534349ae8731d0b$export$66b32f6f30eb4b4).signUpWithOrder, {});
                    break;
                default:
                    setCurrentStep(currentStep - 1);
                    break;
            }
        };
        const [signUpResult, requestSignUp] = (0, $4671947198ddd366$export$609860bf8b0084c)(register, {
            filterError: [
                (0, $9ad33fbf770c55a1$export$9696fcf1798e1cb5).ClientError
            ],
            onSuccess: onSignUpSuccess,
            onError: ()=>{
                const redirectToBasicForm = signUpResult.error?.data.errors?.company_name ?? signUpResult.error?.data.errors?.first_name ?? signUpResult.error?.data.errors?.last_name;
                if (redirectToBasicForm) setCurrentStep($0f260db6b11bfd59$var$STEP_BASIC_DATA_INDEX);
            }
        });
        const remoteErrors = signUpResult.error?.data.errors;
        const isSubmitting = signUpResult.isLoading;
        return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)(UIComponent, {
            showBasicDataForm: currentStep === $0f260db6b11bfd59$var$STEP_BASIC_DATA_INDEX,
            showContactDataForm: currentStep === $0f260db6b11bfd59$var$STEP_CONTACT_DATA_INDEX,
            isSubmitting: isSubmitting,
            currentStep: currentStep,
            basicDataFormInnerRef: basicDataFormRef,
            firstName: signUpWithOrderData.firstName ?? "",
            lastName: signUpWithOrderData.lastName ?? "",
            companyName: signUpWithOrderData.companyName ?? "",
            handleFirstNameChange: setFirstName,
            handleLastNameChange: setLastName,
            handleCompanyNameChange: setCompanyName,
            handleIndustryChange: setIndustry,
            handleEmployeesAmountTierChange: setEmployeesAmountTier,
            firstNameErrors: remoteErrors?.first_name,
            lastNameErrors: remoteErrors?.last_name,
            companyNameErrors: remoteErrors?.company_name,
            industryErrors: remoteErrors?.industry,
            employeesAmountTierErrors: remoteErrors?.employees_amount_tier,
            phone: signUpWithOrderData.phone ?? "",
            email: signUpWithOrderData.email ?? "",
            industry: signUpWithOrderData.industry,
            employeesAmountTier: signUpWithOrderData.employeesAmountTier,
            allow_marketing_emails: Boolean(signUpWithOrderData.allow_marketing_emails),
            handlePhoneChange: setPhone,
            handleEmailChange: setEmail,
            handleToggleEmailAgreement: toggleEmailAgreement,
            contactDataFormInnerRef: contactDataFormRef,
            phoneErrors: remoteErrors?.phone,
            emailErrors: remoteErrors?.email,
            allow_marketing_emailsErrors: remoteErrors?.allow_marketing_emails,
            stepsCount: $0f260db6b11bfd59$var$STEPS_COUNT,
            nextDisabled: false,
            backDisabled: false,
            nextButtonLabel: t("sign_up.next"),
            handleNextPress: handleNextPress,
            handleBackPress: handleBackPress
        });
    });
}




var $acw62 = parcelRequire("acw62");



var $acw62 = parcelRequire("acw62");


var $7YFi7 = parcelRequire("7YFi7");












const $7ad60b6479904771$export$28d26d3fa69bf2e5 = (0, $aca50e9407ba89c9$export$b6ae1bc530f4c149)(({ firstName: firstName, lastName: lastName, companyName: companyName, industry: industry, employeesAmountTier: employeesAmountTier, handleFirstNameChange: handleFirstNameChange, handleLastNameChange: handleLastNameChange, handleCompanyNameChange: handleCompanyNameChange, handleIndustryChange: handleIndustryChange, handleEmployeesAmountTierChange: handleEmployeesAmountTierChange, innerRef: innerRef, firstNameErrors: firstNameErrors, lastNameErrors: lastNameErrors, companyNameErrors: companyNameErrors, industryErrors: industryErrors, employeesAmountTierErrors: employeesAmountTierErrors })=>{
    const { getIndustries: getIndustries, industriesList: industriesList, getEmployeesAmountTiers: getEmployeesAmountTiers, employeesAmountTierList: employeesAmountTierList } = (0, $4671947198ddd366$export$6ccbb43953eebf8)().data;
    (0, $4671947198ddd366$export$dd0a697e1782aedd)(getIndustries);
    (0, $4671947198ddd366$export$dd0a697e1782aedd)(getEmployeesAmountTiers);
    const { t: t } = (0, $3765cebd031b52c0$export$9fc83ad70ead8663)();
    const allowOnlyCorporate = (0, $73ccb33f5de6f5aa$export$8707029d024490c9)().registration.allowOnlyCorporate;
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7YFi7.Formik), {
        innerRef: innerRef,
        initialValues: {
            firstName: firstName,
            lastName: lastName,
            companyName: companyName,
            industry: industry,
            employeesAmountTier: employeesAmountTier
        },
        validationSchema: $cd7706ce94a8dfd1$export$185802fd694ee1f5().shape({
            firstName: $bcc252d93ab3046c$export$185802fd694ee1f5().required(t("sign_up.first_name_required")),
            lastName: $bcc252d93ab3046c$export$185802fd694ee1f5().required(t("sign_up.last_name_required")),
            ...allowOnlyCorporate ? {
                companyName: $bcc252d93ab3046c$export$185802fd694ee1f5().required(t("sign_up.company_name_required"))
            } : {},
            ...companyName.length > 0 ? {
                industry: $9baedbe56e25b51a$export$185802fd694ee1f5().required(t("sign_up.industry_required"))
            } : {},
            ...companyName.length > 0 ? {
                employeesAmountTier: $9baedbe56e25b51a$export$185802fd694ee1f5().required(t("sign_up.employees_amount_tier_required"))
            } : {}
        }),
        enableReinitialize: true,
        onSubmit: (values)=>{},
        validateOnChange: false,
        children: ({ values: values, setFieldValue: setFieldValue, errors: errors, setFieldTouched: setFieldTouched })=>{
            return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $acw62.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $1083ac530b881fb8$export$8b251419efc915eb), {
                        title: t("sign_up.create_new_order_title")
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $660b2ca422e0e2ae$export$1ff3c3f08ae963c0).Vertical, {
                        height: 45
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                        className: "SignUp__title",
                        children: t("sign_up.contact_details_title")
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $660b2ca422e0e2ae$export$1ff3c3f08ae963c0).Vertical, {
                        height: 1
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                        className: "SignUp__subtitle",
                        children: t("sign_up.contact_details_subtitle")
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $660b2ca422e0e2ae$export$1ff3c3f08ae963c0).Vertical, {
                        height: 27
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "SignUp__row",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $1067a74e1c3483e2$export$f551688fc98f2e09), {
                                errors: errors.firstName ?? firstNameErrors,
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4e342c5928158118$export$f5b8910cec6cf069), {
                                    label: t("sign_up.first_name"),
                                    value: values.firstName,
                                    handleChange: (value)=>{
                                        setFieldValue("firstName", value);
                                        handleFirstNameChange(value);
                                    }
                                })
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $660b2ca422e0e2ae$export$1ff3c3f08ae963c0).Horizontal, {
                                width: 7
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $1067a74e1c3483e2$export$f551688fc98f2e09), {
                                errors: errors.lastName ?? lastNameErrors,
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4e342c5928158118$export$f5b8910cec6cf069), {
                                    label: t("sign_up.last_name"),
                                    value: values.lastName,
                                    handleChange: (value)=>{
                                        setFieldValue("lastName", value);
                                        handleLastNameChange(value);
                                    }
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $660b2ca422e0e2ae$export$1ff3c3f08ae963c0).Vertical, {
                        height: 16
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $1067a74e1c3483e2$export$f551688fc98f2e09), {
                        errors: errors.companyName ?? companyNameErrors,
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4e342c5928158118$export$f5b8910cec6cf069), {
                            label: allowOnlyCorporate ? t("sign_up.company_name") : t("sign_up.company_name_optional"),
                            value: values.companyName,
                            handleChange: (value)=>{
                                setFieldValue("companyName", value);
                                handleCompanyNameChange(value);
                            }
                        })
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $660b2ca422e0e2ae$export$1ff3c3f08ae963c0).Vertical, {
                        height: 16
                    }),
                    companyName.length > 0 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $1067a74e1c3483e2$export$f551688fc98f2e09), {
                        errors: errors.industry ?? industryErrors,
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f2c1b8699595d8c0$export$ef9b1a59e592288f), {
                            label: t("common.industry"),
                            onChange: (value)=>{
                                setFieldValue("industry", value);
                                handleIndustryChange(Number(value));
                            },
                            value: industry,
                            options: industriesList
                        })
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $660b2ca422e0e2ae$export$1ff3c3f08ae963c0).Vertical, {
                        height: 16
                    }),
                    companyName.length > 0 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $1067a74e1c3483e2$export$f551688fc98f2e09), {
                        errors: errors.employeesAmountTier ?? employeesAmountTierErrors,
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f2c1b8699595d8c0$export$ef9b1a59e592288f), {
                            label: t("common.employees_amount_tier"),
                            onChange: (value)=>{
                                setFieldValue("employeesAmountTier", value);
                                handleEmployeesAmountTierChange(Number(value));
                            },
                            value: employeesAmountTier,
                            options: employeesAmountTierList
                        })
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "SignUp__already_registered_container",
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                            className: "SignUp__already_registered_container__text",
                            children: [
                                t("sign_up.already_registered"),
                                " ",
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7df35e9df335b1c8$export$a6c7ac8248d6e38a), {
                                    route: (0, $0534349ae8731d0b$export$66b32f6f30eb4b4).login,
                                    params: {},
                                    className: "SignUp__already_registered_container__link",
                                    children: t("sign_up.sign_in")
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $660b2ca422e0e2ae$export$1ff3c3f08ae963c0).Vertical, {
                        height: 27
                    })
                ]
            });
        }
    });
});





var $acw62 = parcelRequire("acw62");


var $7YFi7 = parcelRequire("7YFi7");









const $7b701705ac97a8e1$export$d8816c1d4175e877 = ({ phone: phone, email: email, allowMarketingEmails: allowMarketingEmails, handlePhoneChange: handlePhoneChange, handleEmailChange: handleEmailChange, handleToggleEmailAgreement: handleToggleEmailAgreement, innerRef: innerRef, phoneErrors: phoneErrors, emailErrors: emailErrors, allowMarketingEmailsErrors: allowMarketingEmailsErrors })=>{
    const { t: t } = (0, $3765cebd031b52c0$export$9fc83ad70ead8663)();
    const [selectedCountry, setSelectedCountry] = (0, $acw62.useState)(null);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7YFi7.Formik), {
        innerRef: innerRef,
        initialValues: {
            phone: phone,
            email: email,
            allow_marketing_emails: allowMarketingEmails
        },
        validationSchema: $cd7706ce94a8dfd1$export$185802fd694ee1f5().shape({
            phone: (0, $bddccaaa89e8fa20$export$2e2bcd8739ae039)(t("sign_up.phone_required"), t("sign_up.phone_invalid"), (0, $c5ed36b134b2d50e$export$847b1abaf17f2c47)[selectedCountry]),
            email: $bcc252d93ab3046c$export$185802fd694ee1f5().email(t("validation_messages.email_invalid")).required(t("sign_up.email_required"))
        }),
        enableReinitialize: true,
        onSubmit: (values)=>{},
        validateOnChange: false,
        children: ({ values: values, setFieldValue: setFieldValue, errors: errors })=>{
            return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $acw62.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $1083ac530b881fb8$export$8b251419efc915eb), {
                        title: t("sign_up.create_new_order_title")
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $660b2ca422e0e2ae$export$1ff3c3f08ae963c0).Vertical, {
                        height: 45
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                        className: "SignUp__title",
                        children: t("sign_up.how_to_reach_title")
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $660b2ca422e0e2ae$export$1ff3c3f08ae963c0).Vertical, {
                        height: 1
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                        className: "SignUp__subtitle",
                        children: t("sign_up.contact_details_subtitle")
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $660b2ca422e0e2ae$export$1ff3c3f08ae963c0).Vertical, {
                        height: 27
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "SignUp__row",
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $1067a74e1c3483e2$export$f551688fc98f2e09), {
                            errors: errors.email ?? emailErrors,
                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4e342c5928158118$export$f5b8910cec6cf069), {
                                label: t("sign_up.email"),
                                value: values.email,
                                type: "email",
                                handleChange: (value)=>{
                                    setFieldValue("email", value);
                                    handleEmailChange(value);
                                }
                            })
                        })
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $660b2ca422e0e2ae$export$1ff3c3f08ae963c0).Vertical, {
                        height: 16
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "SignUp__row",
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $1067a74e1c3483e2$export$f551688fc98f2e09), {
                            errors: errors.phone ?? phoneErrors,
                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7ded17d344b4400d$export$d9c67ff858089902), {
                                phone: phone,
                                handlePhoneChange: handlePhoneChange,
                                setSelectedCountry: setSelectedCountry
                            })
                        })
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $660b2ca422e0e2ae$export$1ff3c3f08ae963c0).Vertical, {
                        height: 16
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "SignUp__row",
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $1067a74e1c3483e2$export$f551688fc98f2e09), {
                            errors: errors.allow_marketing_emails ?? allowMarketingEmailsErrors,
                            className: "SignUp__row",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                    type: "checkbox",
                                    onClick: handleToggleEmailAgreement,
                                    checked: allowMarketingEmails,
                                    className: "SignUp__checkboxContainer__checkbox"
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $660b2ca422e0e2ae$export$1ff3c3f08ae963c0).Horizontal, {
                                    width: 10
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                    className: "SignUp__checkboxContainer__labelContainer",
                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                        className: "SignUp__checkboxContainer__labelContainer__label",
                                        children: t("sign_up.agree_to_emails")
                                    })
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $660b2ca422e0e2ae$export$1ff3c3f08ae963c0).Vertical, {
                        height: 27
                    })
                ]
            });
        }
    });
};




const $52373dec1f875d85$export$afc437beeb4f289f = (props)=>{
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        className: "registerClientForm",
        children: props.isSubmitting ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $57fb8f45c69e1681$export$2e2bcd8739ae039), {}) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $acw62.Fragment), {
            children: [
                props.showBasicDataForm && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7ad60b6479904771$export$28d26d3fa69bf2e5), {
                    innerRef: props.basicDataFormInnerRef,
                    firstName: props.firstName,
                    lastName: props.lastName,
                    companyName: props.companyName,
                    industry: props.industry,
                    employeesAmountTier: props.employeesAmountTier,
                    handleFirstNameChange: props.handleFirstNameChange,
                    handleLastNameChange: props.handleLastNameChange,
                    handleCompanyNameChange: props.handleCompanyNameChange,
                    handleIndustryChange: props.handleIndustryChange,
                    handleEmployeesAmountTierChange: props.handleEmployeesAmountTierChange,
                    firstNameErrors: props.firstNameErrors,
                    lastNameErrors: props.lastNameErrors,
                    companyNameErrors: props.companyNameErrors,
                    industryErrors: props.industryErrors,
                    employeesAmountTierErrors: props.employeesAmountTierErrors
                }),
                props.showContactDataForm && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7b701705ac97a8e1$export$d8816c1d4175e877), {
                    innerRef: props.contactDataFormInnerRef,
                    phone: props.phone,
                    email: props.email,
                    allowMarketingEmails: props.allow_marketing_emails,
                    handlePhoneChange: props.handlePhoneChange,
                    handleEmailChange: props.handleEmailChange,
                    handleToggleEmailAgreement: props.handleToggleEmailAgreement,
                    phoneErrors: props.phoneErrors,
                    emailErrors: props.emailErrors,
                    allowMarketingEmailsErrors: props.allow_marketing_emailsErrors
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $9dfc32a0a996fa14$export$ed8ca599049e8881), {
                    stepsCount: props.stepsCount,
                    currentStep: props.currentStep,
                    nextDisabled: props.nextDisabled,
                    backDisabled: props.backDisabled,
                    nextButtonLabel: props.nextButtonLabel,
                    handleNextPress: props.handleNextPress,
                    handleBackPress: props.handleBackPress
                })
            ]
        })
    });
};


const $110e2ffca61710c0$export$83abec3890673b8c = (0, $0f260db6b11bfd59$export$4522881093742c6b)((0, $52373dec1f875d85$export$afc437beeb4f289f));


const $e8e5567118d21868$export$3178d6f323d850e8 = {
    SelectCategoryPage: (0, $db33374530818377$export$dc075a807a8c61e8)((0, $fc9f9ab61e9cd5b4$export$7ac13f098b58f1e3)),
    RegisterClientPage: (0, $db33374530818377$export$dc075a807a8c61e8)((0, $110e2ffca61710c0$export$83abec3890673b8c))
};











const $3a6017264caf4a0c$export$9e39ad776add7b9f = (0, $aca50e9407ba89c9$export$b6ae1bc530f4c149)(({ clientId: clientId })=>{
    const { confirmClientInvitation: confirmClientInvitation } = (0, $4671947198ddd366$export$6ccbb43953eebf8)().data;
    const redirect = (0, $7df35e9df335b1c8$export$602eaf6d5314ce55)();
    const { t: t } = (0, $3765cebd031b52c0$export$9fc83ad70ead8663)();
    const confirmInvitationResult = (0, $4671947198ddd366$export$dd0a697e1782aedd)(()=>confirmClientInvitation(clientId), {
        filterError: [
            (0, $9ad33fbf770c55a1$export$9696fcf1798e1cb5).ClientError
        ],
        onSuccess: ()=>{
            redirect((0, $0534349ae8731d0b$export$66b32f6f30eb4b4).index, {});
            (0, $60f27fc97e29822a$export$b410431fab84fa58).success(t("user_management.invitation_confirmed"));
        },
        onError: (err)=>{
            redirect((0, $0534349ae8731d0b$export$66b32f6f30eb4b4).index, {});
            (0, $60f27fc97e29822a$export$b410431fab84fa58).error(err.data.message);
        }
    });
    return confirmInvitationResult.isLoading ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $57fb8f45c69e1681$export$2e2bcd8739ae039), {}) : null;
});


const $49c4fe8513f48deb$export$1e944eec5cc50f8e = {
    ConfirmClientInvitationPage: $3a6017264caf4a0c$export$9e39ad776add7b9f
};




var $7bf3b98cbc00db03$exports = {};

(function(global, factory) {
    factory($7bf3b98cbc00db03$exports, (parcelRequire("acw62")));
})($7bf3b98cbc00db03$exports, function(exports1, React) {
    "use strict";
    React = React && Object.prototype.hasOwnProperty.call(React, "default") ? React["default"] : React;
    function ownKeys(object, enumerableOnly) {
        var keys = Object.keys(object);
        if (Object.getOwnPropertySymbols) {
            var symbols = Object.getOwnPropertySymbols(object);
            if (enumerableOnly) symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
            keys.push.apply(keys, symbols);
        }
        return keys;
    }
    function _objectSpread2(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i] != null ? arguments[i] : {};
            if (i % 2) ownKeys(Object(source), true).forEach(function(key) {
                _defineProperty(target, key, source[key]);
            });
            else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
            else ownKeys(Object(source)).forEach(function(key) {
                Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
            });
        }
        return target;
    }
    function _typeof(obj) {
        "@babel/helpers - typeof";
        if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") _typeof = function(obj) {
            return typeof obj;
        };
        else _typeof = function(obj) {
            return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
        };
        return _typeof(obj);
    }
    function _defineProperty(obj, key, value) {
        if (key in obj) Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
        else obj[key] = value;
        return obj;
    }
    function _slicedToArray(arr, i) {
        return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
    }
    function _arrayWithHoles(arr) {
        if (Array.isArray(arr)) return arr;
    }
    function _iterableToArrayLimit(arr, i) {
        var _i = arr && (typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]);
        if (_i == null) return;
        var _arr = [];
        var _n = true;
        var _d = false;
        var _s, _e;
        try {
            for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
                _arr.push(_s.value);
                if (i && _arr.length === i) break;
            }
        } catch (err) {
            _d = true;
            _e = err;
        } finally{
            try {
                if (!_n && _i["return"] != null) _i["return"]();
            } finally{
                if (_d) throw _e;
            }
        }
        return _arr;
    }
    function _unsupportedIterableToArray(o, minLen) {
        if (!o) return;
        if (typeof o === "string") return _arrayLikeToArray(o, minLen);
        var n = Object.prototype.toString.call(o).slice(8, -1);
        if (n === "Object" && o.constructor) n = o.constructor.name;
        if (n === "Map" || n === "Set") return Array.from(o);
        if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
    }
    function _arrayLikeToArray(arr, len) {
        if (len == null || len > arr.length) len = arr.length;
        for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
        return arr2;
    }
    function _nonIterableRest() {
        throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    function createCommonjsModule(fn, module) {
        return module = {
            exports: {}
        }, fn(module, module.exports), module.exports;
    }
    /**
   * Copyright (c) 2013-present, Facebook, Inc.
   *
   * This source code is licensed under the MIT license found in the
   * LICENSE file in the root directory of this source tree.
   */ var ReactPropTypesSecret = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
    var ReactPropTypesSecret_1 = ReactPropTypesSecret;
    function emptyFunction() {}
    function emptyFunctionWithReset() {}
    emptyFunctionWithReset.resetWarningCache = emptyFunction;
    var factoryWithThrowingShims = function() {
        function shim(props, propName, componentName, location, propFullName, secret) {
            if (secret === ReactPropTypesSecret_1) // It is still safe when called from React.
            return;
            var err = new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types");
            err.name = "Invariant Violation";
            throw err;
        }
        shim.isRequired = shim;
        function getShim() {
            return shim;
        }
        // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
        var ReactPropTypes = {
            array: shim,
            bool: shim,
            func: shim,
            number: shim,
            object: shim,
            string: shim,
            symbol: shim,
            any: shim,
            arrayOf: getShim,
            element: shim,
            elementType: shim,
            instanceOf: getShim,
            node: shim,
            objectOf: getShim,
            oneOf: getShim,
            oneOfType: getShim,
            shape: getShim,
            exact: getShim,
            checkPropTypes: emptyFunctionWithReset,
            resetWarningCache: emptyFunction
        };
        ReactPropTypes.PropTypes = ReactPropTypes;
        return ReactPropTypes;
    };
    var propTypes = createCommonjsModule(function(module) {
        // By explicitly using `prop-types` you are opting into new production behavior.
        // http://fb.me/prop-types-in-prod
        module.exports = factoryWithThrowingShims();
    });
    var usePrevious = function usePrevious(value) {
        var ref = React.useRef(value);
        React.useEffect(function() {
            ref.current = value;
        }, [
            value
        ]);
        return ref.current;
    };
    var isUnknownObject = function isUnknownObject(raw) {
        return raw !== null && _typeof(raw) === "object";
    };
    var isPromise = function isPromise(raw) {
        return isUnknownObject(raw) && typeof raw.then === "function";
    }; // We are using types to enforce the `stripe` prop in this lib,
    // but in an untyped integration `stripe` could be anything, so we need
    // to do some sanity validation to prevent type errors.
    var isStripe = function isStripe(raw) {
        return isUnknownObject(raw) && typeof raw.elements === "function" && typeof raw.createToken === "function" && typeof raw.createPaymentMethod === "function" && typeof raw.confirmCardPayment === "function";
    };
    var PLAIN_OBJECT_STR = "[object Object]";
    var isEqual = function isEqual(left, right) {
        if (!isUnknownObject(left) || !isUnknownObject(right)) return left === right;
        var leftArray = Array.isArray(left);
        var rightArray = Array.isArray(right);
        if (leftArray !== rightArray) return false;
        var leftPlainObject = Object.prototype.toString.call(left) === PLAIN_OBJECT_STR;
        var rightPlainObject = Object.prototype.toString.call(right) === PLAIN_OBJECT_STR;
        if (leftPlainObject !== rightPlainObject) return false; // not sure what sort of special object this is (regexp is one option), so
        // fallback to reference check.
        if (!leftPlainObject && !leftArray) return left === right;
        var leftKeys = Object.keys(left);
        var rightKeys = Object.keys(right);
        if (leftKeys.length !== rightKeys.length) return false;
        var keySet = {};
        for(var i = 0; i < leftKeys.length; i += 1)keySet[leftKeys[i]] = true;
        for(var _i = 0; _i < rightKeys.length; _i += 1)keySet[rightKeys[_i]] = true;
        var allKeys = Object.keys(keySet);
        if (allKeys.length !== leftKeys.length) return false;
        var l = left;
        var r = right;
        var pred = function pred(key) {
            return isEqual(l[key], r[key]);
        };
        return allKeys.every(pred);
    };
    var extractAllowedOptionsUpdates = function extractAllowedOptionsUpdates(options, prevOptions, immutableKeys) {
        if (!isUnknownObject(options)) return null;
        return Object.keys(options).reduce(function(newOptions, key) {
            var isUpdated = !isUnknownObject(prevOptions) || !isEqual(options[key], prevOptions[key]);
            if (immutableKeys.includes(key)) {
                if (isUpdated) console.warn("Unsupported prop change: options.".concat(key, " is not a mutable property."));
                return newOptions;
            }
            if (!isUpdated) return newOptions;
            return _objectSpread2(_objectSpread2({}, newOptions || {}), {}, _defineProperty({}, key, options[key]));
        }, null);
    };
    var INVALID_STRIPE_ERROR = "Invalid prop `stripe` supplied to `Elements`. We recommend using the `loadStripe` utility from `@stripe/stripe-js`. See https://stripe.com/docs/stripe-js/react#elements-props-stripe for details."; // We are using types to enforce the `stripe` prop in this lib, but in a real
    // integration `stripe` could be anything, so we need to do some sanity
    // validation to prevent type errors.
    var validateStripe = function validateStripe(maybeStripe) {
        if (maybeStripe === null || isStripe(maybeStripe)) return maybeStripe;
        throw new Error(INVALID_STRIPE_ERROR);
    };
    var parseStripeProp = function parseStripeProp(raw) {
        if (isPromise(raw)) return {
            tag: "async",
            stripePromise: Promise.resolve(raw).then(validateStripe)
        };
        var stripe = validateStripe(raw);
        if (stripe === null) return {
            tag: "empty"
        };
        return {
            tag: "sync",
            stripe: stripe
        };
    };
    var ElementsContext = /*#__PURE__*/ React.createContext(null);
    ElementsContext.displayName = "ElementsContext";
    var parseElementsContext = function parseElementsContext(ctx, useCase) {
        if (!ctx) throw new Error("Could not find Elements context; You need to wrap the part of your app that ".concat(useCase, " in an <Elements> provider."));
        return ctx;
    };
    var CartElementContext = /*#__PURE__*/ React.createContext(null);
    CartElementContext.displayName = "CartElementContext";
    var parseCartElementContext = function parseCartElementContext(ctx, useCase) {
        if (!ctx) throw new Error("Could not find Elements context; You need to wrap the part of your app that ".concat(useCase, " in an <Elements> provider."));
        return ctx;
    };
    /**
   * The `Elements` provider allows you to use [Element components](https://stripe.com/docs/stripe-js/react#element-components) and access the [Stripe object](https://stripe.com/docs/js/initializing) in any nested component.
   * Render an `Elements` provider at the root of your React app so that it is available everywhere you need it.
   *
   * To use the `Elements` provider, call `loadStripe` from `@stripe/stripe-js` with your publishable key.
   * The `loadStripe` function will asynchronously load the Stripe.js script and initialize a `Stripe` object.
   * Pass the returned `Promise` to `Elements`.
   *
   * @docs https://stripe.com/docs/stripe-js/react#elements-provider
   */ var Elements = function Elements(_ref) {
        var rawStripeProp = _ref.stripe, options = _ref.options, children = _ref.children;
        var parsed = React.useMemo(function() {
            return parseStripeProp(rawStripeProp);
        }, [
            rawStripeProp
        ]);
        var _React$useState = React.useState(null), _React$useState2 = _slicedToArray(_React$useState, 2), cart = _React$useState2[0], setCart = _React$useState2[1];
        var _React$useState3 = React.useState(null), _React$useState4 = _slicedToArray(_React$useState3, 2), cartState = _React$useState4[0], setCartState = _React$useState4[1]; // For a sync stripe instance, initialize into context
        var _React$useState5 = React.useState(function() {
            return {
                stripe: parsed.tag === "sync" ? parsed.stripe : null,
                elements: parsed.tag === "sync" ? parsed.stripe.elements(options) : null
            };
        }), _React$useState6 = _slicedToArray(_React$useState5, 2), ctx = _React$useState6[0], setContext = _React$useState6[1];
        React.useEffect(function() {
            var isMounted = true;
            var safeSetContext = function safeSetContext(stripe) {
                setContext(function(ctx) {
                    // no-op if we already have a stripe instance (https://github.com/stripe/react-stripe-js/issues/296)
                    if (ctx.stripe) return ctx;
                    return {
                        stripe: stripe,
                        elements: stripe.elements(options)
                    };
                });
            }; // For an async stripePromise, store it in context once resolved
            if (parsed.tag === "async" && !ctx.stripe) parsed.stripePromise.then(function(stripe) {
                if (stripe && isMounted) // Only update Elements context if the component is still mounted
                // and stripe is not null. We allow stripe to be null to make
                // handling SSR easier.
                safeSetContext(stripe);
            });
            else if (parsed.tag === "sync" && !ctx.stripe) // Or, handle a sync stripe instance going from null -> populated
            safeSetContext(parsed.stripe);
            return function() {
                isMounted = false;
            };
        }, [
            parsed,
            ctx,
            options
        ]); // Warn on changes to stripe prop
        var prevStripe = usePrevious(rawStripeProp);
        React.useEffect(function() {
            if (prevStripe !== null && prevStripe !== rawStripeProp) console.warn("Unsupported prop change on Elements: You cannot change the `stripe` prop after setting it.");
        }, [
            prevStripe,
            rawStripeProp
        ]); // Apply updates to elements when options prop has relevant changes
        var prevOptions = usePrevious(options);
        React.useEffect(function() {
            if (!ctx.elements) return;
            var updates = extractAllowedOptionsUpdates(options, prevOptions, [
                "clientSecret",
                "fonts"
            ]);
            if (updates) ctx.elements.update(updates);
        }, [
            options,
            prevOptions,
            ctx.elements
        ]); // Attach react-stripe-js version to stripe.js instance
        React.useEffect(function() {
            var anyStripe = ctx.stripe;
            if (!anyStripe || !anyStripe._registerWrapper || !anyStripe.registerAppInfo) return;
            anyStripe._registerWrapper({
                name: "react-stripe-js",
                version: "1.16.5"
            });
            anyStripe.registerAppInfo({
                name: "react-stripe-js",
                version: "1.16.5",
                url: "https://stripe.com/docs/stripe-js/react"
            });
        }, [
            ctx.stripe
        ]);
        return /*#__PURE__*/ React.createElement(ElementsContext.Provider, {
            value: ctx
        }, /*#__PURE__*/ React.createElement(CartElementContext.Provider, {
            value: {
                cart: cart,
                setCart: setCart,
                cartState: cartState,
                setCartState: setCartState
            }
        }, children));
    };
    Elements.propTypes = {
        stripe: propTypes.any,
        options: propTypes.object
    };
    var useElementsContextWithUseCase = function useElementsContextWithUseCase(useCaseMessage) {
        var ctx = React.useContext(ElementsContext);
        return parseElementsContext(ctx, useCaseMessage);
    };
    var useCartElementContextWithUseCase = function useCartElementContextWithUseCase(useCaseMessage) {
        var ctx = React.useContext(CartElementContext);
        return parseCartElementContext(ctx, useCaseMessage);
    };
    /**
   * @docs https://stripe.com/docs/stripe-js/react#useelements-hook
   */ var useElements = function useElements() {
        var _useElementsContextWi = useElementsContextWithUseCase("calls useElements()"), elements = _useElementsContextWi.elements;
        return elements;
    };
    /**
   * @docs https://stripe.com/docs/stripe-js/react#usestripe-hook
   */ var useStripe = function useStripe() {
        var _useElementsContextWi2 = useElementsContextWithUseCase("calls useStripe()"), stripe = _useElementsContextWi2.stripe;
        return stripe;
    };
    /**
   * @docs https://stripe.com/docs/payments/checkout/cart-element
   */ var useCartElement = function useCartElement() {
        var _useCartElementContex = useCartElementContextWithUseCase("calls useCartElement()"), cart = _useCartElementContex.cart;
        return cart;
    };
    /**
   * @docs https://stripe.com/docs/payments/checkout/cart-element
   */ var useCartElementState = function useCartElementState() {
        var _useCartElementContex2 = useCartElementContextWithUseCase("calls useCartElementState()"), cartState = _useCartElementContex2.cartState;
        return cartState;
    };
    /**
   * @docs https://stripe.com/docs/stripe-js/react#elements-consumer
   */ var ElementsConsumer = function ElementsConsumer(_ref2) {
        var children = _ref2.children;
        var ctx = useElementsContextWithUseCase("mounts <ElementsConsumer>"); // Assert to satisfy the busted React.FC return type (it should be ReactNode)
        return children(ctx);
    };
    ElementsConsumer.propTypes = {
        children: propTypes.func.isRequired
    };
    var useAttachEvent = function useAttachEvent(element, event, cb) {
        var cbDefined = !!cb;
        var cbRef = React.useRef(cb); // In many integrations the callback prop changes on each render.
        // Using a ref saves us from calling element.on/.off every render.
        React.useEffect(function() {
            cbRef.current = cb;
        }, [
            cb
        ]);
        React.useEffect(function() {
            if (!cbDefined || !element) return function() {};
            var decoratedCb = function decoratedCb() {
                if (cbRef.current) cbRef.current.apply(cbRef, arguments);
            };
            element.on(event, decoratedCb);
            return function() {
                element.off(event, decoratedCb);
            };
        }, [
            cbDefined,
            event,
            element,
            cbRef
        ]);
    };
    var capitalized = function capitalized(str) {
        return str.charAt(0).toUpperCase() + str.slice(1);
    };
    var createElementComponent = function createElementComponent(type, isServer) {
        var displayName = "".concat(capitalized(type), "Element");
        var ClientElement = function ClientElement(_ref) {
            var id = _ref.id, className = _ref.className, _ref$options = _ref.options, options = _ref$options === void 0 ? {} : _ref$options, onBlur = _ref.onBlur, onFocus = _ref.onFocus, onReady = _ref.onReady, onChange = _ref.onChange, onEscape = _ref.onEscape, onClick = _ref.onClick, onLoadError = _ref.onLoadError, onLoaderStart = _ref.onLoaderStart, onNetworksChange = _ref.onNetworksChange, onCheckout = _ref.onCheckout, onLineItemClick = _ref.onLineItemClick, onConfirm = _ref.onConfirm, onCancel = _ref.onCancel, onShippingAddressChange = _ref.onShippingAddressChange, onShippingRateChange = _ref.onShippingRateChange;
            var _useElementsContextWi = useElementsContextWithUseCase("mounts <".concat(displayName, ">")), elements = _useElementsContextWi.elements;
            var _React$useState = React.useState(null), _React$useState2 = _slicedToArray(_React$useState, 2), element = _React$useState2[0], setElement = _React$useState2[1];
            var elementRef = React.useRef(null);
            var domNode = React.useRef(null);
            var _useCartElementContex = useCartElementContextWithUseCase("mounts <".concat(displayName, ">")), setCart = _useCartElementContex.setCart, setCartState = _useCartElementContex.setCartState; // For every event where the merchant provides a callback, call element.on
            // with that callback. If the merchant ever changes the callback, removes
            // the old callback with element.off and then call element.on with the new one.
            useAttachEvent(element, "blur", onBlur);
            useAttachEvent(element, "focus", onFocus);
            useAttachEvent(element, "escape", onEscape);
            useAttachEvent(element, "click", onClick);
            useAttachEvent(element, "loaderror", onLoadError);
            useAttachEvent(element, "loaderstart", onLoaderStart);
            useAttachEvent(element, "networkschange", onNetworksChange);
            useAttachEvent(element, "lineitemclick", onLineItemClick);
            useAttachEvent(element, "confirm", onConfirm);
            useAttachEvent(element, "cancel", onCancel);
            useAttachEvent(element, "shippingaddresschange", onShippingAddressChange);
            useAttachEvent(element, "shippingratechange", onShippingRateChange);
            var readyCallback;
            if (type === "cart") readyCallback = function readyCallback(event) {
                setCartState(event);
                onReady && onReady(event);
            };
            else if (onReady) {
                if (type === "payButton") // Passes through the event, which includes visible PM types
                readyCallback = onReady;
                else // For other Elements, pass through the Element itself.
                readyCallback = function readyCallback() {
                    onReady(element);
                };
            }
            useAttachEvent(element, "ready", readyCallback);
            var changeCallback = type === "cart" ? function(event) {
                setCartState(event);
                onChange && onChange(event);
            } : onChange;
            useAttachEvent(element, "change", changeCallback);
            var checkoutCallback = type === "cart" ? function(event) {
                setCartState(event);
                onCheckout && onCheckout(event);
            } : onCheckout;
            useAttachEvent(element, "checkout", checkoutCallback);
            React.useLayoutEffect(function() {
                if (elementRef.current === null && elements && domNode.current !== null) {
                    var newElement = elements.create(type, options);
                    if (type === "cart" && setCart) // we know that elements.create return value must be of type StripeCartElement if type is 'cart',
                    // we need to cast because typescript is not able to infer which overloaded method is used based off param type
                    setCart(newElement);
                     // Store element in a ref to ensure it's _immediately_ available in cleanup hooks in StrictMode
                    elementRef.current = newElement; // Store element in state to facilitate event listener attachment
                    setElement(newElement);
                    newElement.mount(domNode.current);
                }
            }, [
                elements,
                options,
                setCart
            ]);
            var prevOptions = usePrevious(options);
            React.useEffect(function() {
                if (!elementRef.current) return;
                var updates = extractAllowedOptionsUpdates(options, prevOptions, [
                    "paymentRequest"
                ]);
                if (updates) elementRef.current.update(updates);
            }, [
                options,
                prevOptions
            ]);
            React.useLayoutEffect(function() {
                return function() {
                    if (elementRef.current) {
                        elementRef.current.destroy();
                        elementRef.current = null;
                    }
                };
            }, []);
            return /*#__PURE__*/ React.createElement("div", {
                id: id,
                className: className,
                ref: domNode
            });
        }; // Only render the Element wrapper in a server environment.
        var ServerElement = function ServerElement(props) {
            // Validate that we are in the right context by calling useElementsContextWithUseCase.
            useElementsContextWithUseCase("mounts <".concat(displayName, ">"));
            useCartElementContextWithUseCase("mounts <".concat(displayName, ">"));
            var id = props.id, className = props.className;
            return /*#__PURE__*/ React.createElement("div", {
                id: id,
                className: className
            });
        };
        var Element = isServer ? ServerElement : ClientElement;
        Element.propTypes = {
            id: propTypes.string,
            className: propTypes.string,
            onChange: propTypes.func,
            onBlur: propTypes.func,
            onFocus: propTypes.func,
            onReady: propTypes.func,
            onEscape: propTypes.func,
            onClick: propTypes.func,
            onLoadError: propTypes.func,
            onLoaderStart: propTypes.func,
            onNetworksChange: propTypes.func,
            onCheckout: propTypes.func,
            onLineItemClick: propTypes.func,
            onConfirm: propTypes.func,
            onCancel: propTypes.func,
            onShippingAddressChange: propTypes.func,
            onShippingRateChange: propTypes.func,
            options: propTypes.object
        };
        Element.displayName = displayName;
        Element.__elementType = type;
        return Element;
    };
    var isServer = typeof window === "undefined";
    /**
   * Requires beta access:
   * Contact [Stripe support](https://support.stripe.com/) for more information.
   *
   * @docs https://stripe.com/docs/stripe-js/react#element-components
   */ var AuBankAccountElement = createElementComponent("auBankAccount", isServer);
    /**
   * @docs https://stripe.com/docs/stripe-js/react#element-components
   */ var CardElement = createElementComponent("card", isServer);
    /**
   * @docs https://stripe.com/docs/stripe-js/react#element-components
   */ var CardNumberElement = createElementComponent("cardNumber", isServer);
    /**
   * @docs https://stripe.com/docs/stripe-js/react#element-components
   */ var CardExpiryElement = createElementComponent("cardExpiry", isServer);
    /**
   * @docs https://stripe.com/docs/stripe-js/react#element-components
   */ var CardCvcElement = createElementComponent("cardCvc", isServer);
    /**
   * @docs https://stripe.com/docs/stripe-js/react#element-components
   */ var FpxBankElement = createElementComponent("fpxBank", isServer);
    /**
   * @docs https://stripe.com/docs/stripe-js/react#element-components
   */ var IbanElement = createElementComponent("iban", isServer);
    /**
   * @docs https://stripe.com/docs/stripe-js/react#element-components
   */ var IdealBankElement = createElementComponent("idealBank", isServer);
    /**
   * @docs https://stripe.com/docs/stripe-js/react#element-components
   */ var P24BankElement = createElementComponent("p24Bank", isServer);
    /**
   * @docs https://stripe.com/docs/stripe-js/react#element-components
   */ var EpsBankElement = createElementComponent("epsBank", isServer);
    var PaymentElement = createElementComponent("payment", isServer);
    /**
   * Requires beta access:
   * Contact [Stripe support](https://support.stripe.com/) for more information.
   *
   * @docs https://stripe.com/docs/stripe-js/react#element-components
   */ var PayButtonElement = createElementComponent("payButton", isServer);
    /**
   * @docs https://stripe.com/docs/stripe-js/react#element-components
   */ var PaymentRequestButtonElement = createElementComponent("paymentRequestButton", isServer);
    /**
   * Requires beta access:
   * Contact [Stripe support](https://support.stripe.com/) for more information.
   *
   * @docs https://stripe.com/docs/stripe-js/react#element-components
   */ var LinkAuthenticationElement = createElementComponent("linkAuthentication", isServer);
    /**
   * @docs https://stripe.com/docs/stripe-js/react#element-components
   */ var AddressElement = createElementComponent("address", isServer);
    /**
   * @deprecated
   * Use `AddressElement` instead.
   *
   * @docs https://stripe.com/docs/stripe-js/react#element-components
   */ var ShippingAddressElement = createElementComponent("shippingAddress", isServer);
    /**
   * Requires beta access:
   * Contact [Stripe support](https://support.stripe.com/) for more information.
   *
   * @docs https://stripe.com/docs/elements/cart-element
   */ var CartElement = createElementComponent("cart", isServer);
    /**
   * @docs https://stripe.com/docs/stripe-js/react#element-components
   */ var PaymentMethodMessagingElement = createElementComponent("paymentMethodMessaging", isServer);
    /**
   * @docs https://stripe.com/docs/stripe-js/react#element-components
   */ var AffirmMessageElement = createElementComponent("affirmMessage", isServer);
    /**
   * @docs https://stripe.com/docs/stripe-js/react#element-components
   */ var AfterpayClearpayMessageElement = createElementComponent("afterpayClearpayMessage", isServer);
    exports1.AddressElement = AddressElement;
    exports1.AffirmMessageElement = AffirmMessageElement;
    exports1.AfterpayClearpayMessageElement = AfterpayClearpayMessageElement;
    exports1.AuBankAccountElement = AuBankAccountElement;
    exports1.CardCvcElement = CardCvcElement;
    exports1.CardElement = CardElement;
    exports1.CardExpiryElement = CardExpiryElement;
    exports1.CardNumberElement = CardNumberElement;
    exports1.CartElement = CartElement;
    exports1.Elements = Elements;
    exports1.ElementsConsumer = ElementsConsumer;
    exports1.EpsBankElement = EpsBankElement;
    exports1.FpxBankElement = FpxBankElement;
    exports1.IbanElement = IbanElement;
    exports1.IdealBankElement = IdealBankElement;
    exports1.LinkAuthenticationElement = LinkAuthenticationElement;
    exports1.P24BankElement = P24BankElement;
    exports1.PayButtonElement = PayButtonElement;
    exports1.PaymentElement = PaymentElement;
    exports1.PaymentMethodMessagingElement = PaymentMethodMessagingElement;
    exports1.PaymentRequestButtonElement = PaymentRequestButtonElement;
    exports1.ShippingAddressElement = ShippingAddressElement;
    exports1.useCartElement = useCartElement;
    exports1.useCartElementState = useCartElementState;
    exports1.useElements = useElements;
    exports1.useStripe = useStripe;
    Object.defineProperty(exports1, "__esModule", {
        value: true
    });
});






var $acw62 = parcelRequire("acw62");






var $acw62 = parcelRequire("acw62");
var $26c5d94e8cfa4743$var$V3_URL = "https://js.stripe.com/v3";
var $26c5d94e8cfa4743$var$V3_URL_REGEX = /^https:\/\/js\.stripe\.com\/v3\/?(\?.*)?$/;
var $26c5d94e8cfa4743$var$EXISTING_SCRIPT_MESSAGE = "loadStripe.setLoadParameters was called but an existing Stripe.js script already exists in the document; existing script parameters will be used";
var $26c5d94e8cfa4743$var$findScript = function findScript() {
    var scripts = document.querySelectorAll('script[src^="'.concat($26c5d94e8cfa4743$var$V3_URL, '"]'));
    for(var i = 0; i < scripts.length; i++){
        var script = scripts[i];
        if (!$26c5d94e8cfa4743$var$V3_URL_REGEX.test(script.src)) continue;
        return script;
    }
    return null;
};
var $26c5d94e8cfa4743$var$injectScript = function injectScript(params) {
    var queryString = params && !params.advancedFraudSignals ? "?advancedFraudSignals=false" : "";
    var script = document.createElement("script");
    script.src = "".concat($26c5d94e8cfa4743$var$V3_URL).concat(queryString);
    var headOrBody = document.head || document.body;
    if (!headOrBody) throw new Error("Expected document.body not to be null. Stripe.js requires a <body> element.");
    headOrBody.appendChild(script);
    return script;
};
var $26c5d94e8cfa4743$var$registerWrapper = function registerWrapper(stripe, startTime) {
    if (!stripe || !stripe._registerWrapper) return;
    stripe._registerWrapper({
        name: "stripe-js",
        version: "1.54.2",
        startTime: startTime
    });
};
var $26c5d94e8cfa4743$var$stripePromise = null;
var $26c5d94e8cfa4743$var$loadScript = function loadScript(params) {
    // Ensure that we only attempt to load Stripe.js at most once
    if ($26c5d94e8cfa4743$var$stripePromise !== null) return $26c5d94e8cfa4743$var$stripePromise;
    $26c5d94e8cfa4743$var$stripePromise = new Promise(function(resolve, reject) {
        if (typeof window === "undefined" || typeof document === "undefined") {
            // Resolve to null when imported server side. This makes the module
            // safe to import in an isomorphic code base.
            resolve(null);
            return;
        }
        if (window.Stripe && params) console.warn($26c5d94e8cfa4743$var$EXISTING_SCRIPT_MESSAGE);
        if (window.Stripe) {
            resolve(window.Stripe);
            return;
        }
        try {
            var script = $26c5d94e8cfa4743$var$findScript();
            if (script && params) console.warn($26c5d94e8cfa4743$var$EXISTING_SCRIPT_MESSAGE);
            else if (!script) script = $26c5d94e8cfa4743$var$injectScript(params);
            script.addEventListener("load", function() {
                if (window.Stripe) resolve(window.Stripe);
                else reject(new Error("Stripe.js not available"));
            });
            script.addEventListener("error", function() {
                reject(new Error("Failed to load Stripe.js"));
            });
        } catch (error) {
            reject(error);
            return;
        }
    });
    return $26c5d94e8cfa4743$var$stripePromise;
};
var $26c5d94e8cfa4743$var$initStripe = function initStripe(maybeStripe, args, startTime) {
    if (maybeStripe === null) return null;
    var stripe = maybeStripe.apply(undefined, args);
    $26c5d94e8cfa4743$var$registerWrapper(stripe, startTime);
    return stripe;
}; // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
// own script injection.
var $26c5d94e8cfa4743$var$stripePromise$1 = Promise.resolve().then(function() {
    return $26c5d94e8cfa4743$var$loadScript(null);
});
var $26c5d94e8cfa4743$var$loadCalled = false;
$26c5d94e8cfa4743$var$stripePromise$1["catch"](function(err) {
    if (!$26c5d94e8cfa4743$var$loadCalled) console.warn(err);
});
var $26c5d94e8cfa4743$export$de80f7562c3fd6b1 = function loadStripe() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
    $26c5d94e8cfa4743$var$loadCalled = true;
    var startTime = Date.now();
    return $26c5d94e8cfa4743$var$stripePromise$1.then(function(maybeStripe) {
        return $26c5d94e8cfa4743$var$initStripe(maybeStripe, args, startTime);
    });
};







const $0e6cd841cc250b52$var$getStripePublishableKey = ()=>{
    return (0, $73ccb33f5de6f5aa$export$8707029d024490c9)().stripePublishedKey;
};
function $0e6cd841cc250b52$export$559f48a7f7271adf() {
    return (0, $26c5d94e8cfa4743$export$de80f7562c3fd6b1)($0e6cd841cc250b52$var$getStripePublishableKey(), {
        // @ts-ignore
        locale: (0, $73ccb33f5de6f5aa$export$daa49e131b652e5b).getCurrentLanguage()
    });
}
function $0e6cd841cc250b52$export$b58e02d966cf30be(paymentId) {
    const redirect = (0, $7df35e9df335b1c8$export$602eaf6d5314ce55)();
    const { getPayment: getPayment, currentPayment: currentPayment } = (0, $4671947198ddd366$export$6ccbb43953eebf8)().data;
    const getPaymentQuery = (0, $4671947198ddd366$export$dd0a697e1782aedd)(()=>getPayment(paymentId));
    (0, $acw62.useEffect)(()=>{
        if (currentPayment && (String(currentPayment.status) !== (0, $ace4c335912c9e96$export$999f810846f9d31d).Pending || currentPayment.type_id !== null)) redirect((0, $0534349ae8731d0b$export$66b32f6f30eb4b4).paymentDetails, {
            paymentId: String(paymentId)
        });
    }, [
        currentPayment
    ]);
    return {
        isLoading: getPaymentQuery.isLoading,
        currentPayment: currentPayment
    };
}
function $0e6cd841cc250b52$export$455c462b3eca956b(paymentId) {
    const redirect = (0, $7df35e9df335b1c8$export$602eaf6d5314ce55)();
    const { getPayment: getPayment, currentPayment: currentPayment } = (0, $4671947198ddd366$export$6ccbb43953eebf8)().data;
    const getPaymentQuery = (0, $4671947198ddd366$export$dd0a697e1782aedd)(()=>getPayment(paymentId));
    (0, $acw62.useEffect)(()=>{
        if (currentPayment && String(currentPayment.status) !== (0, $ace4c335912c9e96$export$999f810846f9d31d).Pending) redirect((0, $0534349ae8731d0b$export$66b32f6f30eb4b4).paymentDetails, {
            paymentId: String(paymentId)
        });
    }, [
        currentPayment
    ]);
    return {
        isLoading: getPaymentQuery.isLoading,
        currentPayment: currentPayment
    };
}
function $0e6cd841cc250b52$export$dd09e5139f9499ad(paymentId, paymentMethod) {
    const [paymentIntent, setPaymentIntent] = (0, $acw62.useState)(null);
    const [stripeOptions, setStripeOptions] = (0, $acw62.useState)(null);
    const { initPaymentIntent: initPaymentIntent } = (0, $4671947198ddd366$export$6ccbb43953eebf8)().data;
    (0, $4671947198ddd366$export$dd0a697e1782aedd)(()=>initPaymentIntent(paymentId, paymentMethod), {
        onSuccess: (result)=>{
            setPaymentIntent(result);
            if (paymentMethod === (0, $ace4c335912c9e96$export$34b52ce9cfcb0a39).Card) setStripeOptions({
                clientSecret: result.client_secret
            });
        }
    });
    return {
        paymentIntent: paymentIntent,
        stripeOptions: stripeOptions
    };
}
async function $0e6cd841cc250b52$export$551a373226e35516(stripe, elements, paymentId, shouldSaveCard, processingHandler, errorHandler, paymentOptions) {
    let returnUrl = `${window.location.origin}/payments/${paymentId}/status`;
    if (Boolean(paymentOptions)) returnUrl = `${returnUrl}?paymentOptions=${paymentOptions}`;
    const result = await stripe?.confirmPayment({
        elements: elements,
        confirmParams: {
            return_url: returnUrl,
            ...shouldSaveCard ? {
                save_payment_method: true
            } : {}
        }
    });
    processingHandler(false);
    if (result?.error) errorHandler(String(result.error.message));
}
async function $0e6cd841cc250b52$export$4cb3f1c9fb756d2a(stripe, clientSecret, cardId, paymentId, errorHandler, successHandler, paymentOptions) {
    let returnUrl = `${window.location.origin}/payments/${paymentId}/status`;
    if (Boolean(paymentOptions)) returnUrl = `${returnUrl}?paymentOptions=${paymentOptions}`;
    const result = await stripe?.confirmCardPayment(clientSecret, {
        payment_method: cardId,
        return_url: returnUrl
    });
    if (result?.error) errorHandler(String(result.error.message));
    else successHandler();
}





function $63d9b58a6407a3e8$export$76f2956c583001ce(UIComponent) {
    return (0, $a4963babae245ff9$export$f0c7a449e0cfaec7)((0, $aca50e9407ba89c9$export$b6ae1bc530f4c149)(({ paymentId: paymentId, paymentIntent: paymentIntent, paymentOptions: paymentOptions })=>{
        const [isPaymentFormLoaded, setIsPaymentFormLoaded] = (0, $acw62.useState)(false);
        const [isPaymentFormComplete, setIsPaymentFormComplete] = (0, $acw62.useState)(false);
        const [isPaymentProcessing, setIsPaymentProcessing] = (0, $acw62.useState)(false);
        const [shouldSaveCard, setShouldSaveCard] = (0, $acw62.useState)(true);
        const { t: t } = (0, $3765cebd031b52c0$export$9fc83ad70ead8663)();
        const stripe = (0, $7bf3b98cbc00db03$exports.useStripe)();
        const elements = (0, $7bf3b98cbc00db03$exports.useElements)();
        const redirect = (0, $7df35e9df335b1c8$export$602eaf6d5314ce55)();
        const { processPayment: processPayment, resetPaymentStatus: resetPaymentStatus, resetPayment: resetPayment } = (0, $4671947198ddd366$export$6ccbb43953eebf8)().data;
        const { enableQuery: processPaymentQuery } = (0, $4671947198ddd366$export$517ca4f7fee4e226)(()=>processPayment(paymentId), {
            onSuccess: (result)=>{
                tryToConfirmPayment(true);
            }
        });
        const { enableQuery: resetPaymentStatusQuery } = (0, $4671947198ddd366$export$517ca4f7fee4e226)(()=>resetPaymentStatus(paymentId));
        const { enableQuery: resetPaymentQuery } = (0, $4671947198ddd366$export$517ca4f7fee4e226)(()=>resetPayment(paymentId), {
            onSuccess: (result)=>{
                (0, $60f27fc97e29822a$export$b410431fab84fa58).success(t("payment.card_payment_has_been_canceled"));
                redirect((0, $0534349ae8731d0b$export$66b32f6f30eb4b4).paymentMethodsList, {
                    paymentId: String(paymentId)
                });
            }
        });
        const tryToConfirmPayment = async (resetPaymentOnFailure)=>{
            if (!elements) return;
            const confirmPaymentErrorHandler = (errorMessage)=>{
                if (resetPaymentOnFailure) resetPaymentStatusQuery();
                (0, $60f27fc97e29822a$export$b410431fab84fa58).error(errorMessage);
            };
            await (0, $0e6cd841cc250b52$export$551a373226e35516)(stripe, elements, paymentId, shouldSaveCard, setIsPaymentProcessing, confirmPaymentErrorHandler, paymentOptions);
        };
        const pay = ()=>{
            setIsPaymentProcessing(true);
            processPaymentQuery();
        };
        const getFormHandler = ()=>{
            if (isPaymentProcessing) return ()=>{};
            return isPaymentFormComplete ? pay : ()=>tryToConfirmPayment(false);
        };
        const getPayButtonText = ()=>{
            if (!isPaymentProcessing) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $acw62.Fragment), {
                children: [
                    "Pay",
                    " ",
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("strong", {
                        children: [
                            paymentIntent.currency_code,
                            " ",
                            paymentIntent.amount
                        ]
                    })
                ]
            });
            return t("payment.processing_running");
        };
        return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)(UIComponent, {
            setIsPaymentFormComplete: setIsPaymentFormComplete,
            setIsPaymentFormLoaded: setIsPaymentFormLoaded,
            setShouldSaveCard: setShouldSaveCard,
            shouldSaveCard: shouldSaveCard,
            isPaymentFormLoaded: isPaymentFormLoaded,
            formHandler: getFormHandler(),
            payButtonText: getPayButtonText(),
            resetPayment: resetPaymentQuery
        });
    }));
}




var $acw62 = parcelRequire("acw62");




var $a0fe969fd5d413f1$exports = {};
$a0fe969fd5d413f1$exports = new URL("security.ca9b7a1a.svg", import.meta.url).toString();



const $340cb4ff70a046a4$export$e770a9811c17f99b = ({ setIsPaymentFormComplete: setIsPaymentFormComplete, setIsPaymentFormLoaded: setIsPaymentFormLoaded, setShouldSaveCard: setShouldSaveCard, shouldSaveCard: shouldSaveCard, isPaymentFormLoaded: isPaymentFormLoaded, formHandler: formHandler, payButtonText: payButtonText, resetPayment: resetPayment })=>{
    const { t: t } = (0, $3765cebd031b52c0$export$9fc83ad70ead8663)();
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $acw62.Fragment), {
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "StripeForm",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "StripeForm__form",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7bf3b98cbc00db03$exports.PaymentElement), {
                                options: {
                                    wallets: {
                                        applePay: "never",
                                        googlePay: "never"
                                    }
                                },
                                onChange: (event)=>{
                                    setIsPaymentFormComplete(event.complete);
                                },
                                onReady: (event)=>{
                                    setIsPaymentFormLoaded(true);
                                }
                            }),
                            isPaymentFormLoaded && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "StripeForm__saveCardToggle",
                                onClick: ()=>setShouldSaveCard(!shouldSaveCard),
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                        className: "StripeForm__saveCardToggle__label",
                                        children: t("payment.save_card_for_future")
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $d931e957e209e988$export$bea8ebba691c5813), {
                                        active: shouldSaveCard,
                                        onToggle: ()=>setShouldSaveCard(!shouldSaveCard)
                                    })
                                ]
                            }),
                            isPaymentFormLoaded && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "StripeForm__securityMessage",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                                        src: (0, (/*@__PURE__*/$parcel$interopDefault($a0fe969fd5d413f1$exports)))
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                        className: "StripeForm__securityMessage__text",
                                        children: t("payment.all_transactions_are_secured")
                                    })
                                ]
                            })
                        ]
                    }),
                    isPaymentFormLoaded && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4a1895475c466679$export$c072955bb62eb0e2), {
                        style: {
                            justifyContent: "center"
                        },
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                            className: "PayButton__button",
                            onClick: formHandler,
                            children: payButtonText
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "StripeForm__additionalContent",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                    onClick: resetPayment,
                    className: "StripeForm__cancelButton",
                    children: t("payment.card_payment_cancel_button")
                })
            })
        ]
    });
};


const $98e15cd5733227af$export$e770a9811c17f99b = (0, $63d9b58a6407a3e8$export$76f2956c583001ce)((0, $340cb4ff70a046a4$export$e770a9811c17f99b));








const $181bbcdfd1b03ab5$export$1b67faa03b87f50f = (0, $a4963babae245ff9$export$f0c7a449e0cfaec7)((0, $aca50e9407ba89c9$export$b6ae1bc530f4c149)(({ paymentId: paymentId, paymentOptions: paymentOptions })=>{
    const { t: t } = (0, $3765cebd031b52c0$export$9fc83ad70ead8663)();
    const { isLoading: isLoading } = (0, $0e6cd841cc250b52$export$455c462b3eca956b)(paymentId);
    const { paymentIntent: paymentIntent, stripeOptions: stripeOptions } = (0, $0e6cd841cc250b52$export$dd09e5139f9499ad)(paymentId, (0, $ace4c335912c9e96$export$34b52ce9cfcb0a39).Card);
    const redirect = (0, $7df35e9df335b1c8$export$602eaf6d5314ce55)();
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "PayWithCardPage",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7ae42b63183f30b4$export$8b251419efc915eb), {
                title: t("payment.card_payment"),
                handleBackClick: ()=>redirect((0, $0534349ae8731d0b$export$66b32f6f30eb4b4).paymentDetails, {
                        paymentId: String(paymentId)
                    }),
                showBack: true
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $660b2ca422e0e2ae$export$1ff3c3f08ae963c0).Vertical, {
                height: 35
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "PayWithCardPage__container",
                children: !stripeOptions || !paymentIntent || isLoading ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $57fb8f45c69e1681$export$2e2bcd8739ae039), {}) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7bf3b98cbc00db03$exports.Elements), {
                    stripe: (0, $0e6cd841cc250b52$export$559f48a7f7271adf)(),
                    options: stripeOptions,
                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $98e15cd5733227af$export$e770a9811c17f99b), {
                        paymentId: paymentId,
                        paymentIntent: paymentIntent,
                        paymentOptions: paymentOptions
                    })
                })
            })
        ]
    });
}));




var $acw62 = parcelRequire("acw62");









function $3b6056fcd49caacd$export$b827633935e92857(UIComponent) {
    return (0, $a4963babae245ff9$export$f0c7a449e0cfaec7)((0, $aca50e9407ba89c9$export$b6ae1bc530f4c149)(({ paymentId: paymentId, paymentOptions: paymentOptions })=>{
        const redirect = (0, $7df35e9df335b1c8$export$602eaf6d5314ce55)();
        const { t: t } = (0, $3765cebd031b52c0$export$9fc83ad70ead8663)();
        const { getPayment: getPayment, currentPayment: currentPayment } = (0, $4671947198ddd366$export$6ccbb43953eebf8)().data;
        const getPaymentQuery = (0, $4671947198ddd366$export$dd0a697e1782aedd)(()=>getPayment(paymentId));
        const { query: { isLoading: isRepeatedLoading }, enableQuery: getPaymentRepeatedQuery } = (0, $4671947198ddd366$export$517ca4f7fee4e226)(()=>getPayment(paymentId));
        (0, $acw62.useEffect)(()=>{
            (0, $c74a0566d4b0fd6d$export$e9db7d6e73593439).track((0, $c74a0566d4b0fd6d$export$5e27155e276f6d1c).ViewedPaymentCompleted);
        }, []);
        (0, $acw62.useEffect)(()=>{
            const getPaymentTimeout = setTimeout(()=>{
                getPaymentRepeatedQuery();
            }, 3000);
            return ()=>clearTimeout(getPaymentTimeout);
        }, []);
        const paymentOptionsObject = paymentOptions ? JSON.parse(paymentOptions) : null;
        const nextAction = ()=>{
            if (!paymentOptionsObject?.redirectToRouteAfterSuccess) {
                redirect((0, $0534349ae8731d0b$export$66b32f6f30eb4b4).paymentList, {
                    paymentStatus: String((0, $ace4c335912c9e96$export$999f810846f9d31d).Pending)
                });
                return;
            }
            redirect((0, $0534349ae8731d0b$export$66b32f6f30eb4b4)[paymentOptionsObject.redirectToRouteAfterSuccess], paymentOptionsObject.redirectToRouteAfterSuccessParams);
            return;
        };
        return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)(UIComponent, {
            paymentId: paymentId,
            isCompleted: String(currentPayment?.status) === (0, $ace4c335912c9e96$export$999f810846f9d31d).Completed,
            clientEmail: currentPayment?.client?.email,
            isLoading: getPaymentQuery.isLoading,
            isUpdatingStatus: isRepeatedLoading,
            paymentNumber: currentPayment?.payment_number,
            fulfilledAt: currentPayment?.fulfilled_at,
            paymentMethodTitle: currentPayment ? t((0, $810e278414a1540d$export$95dc18b5b2f97717)[String(currentPayment.type_id ?? (0, $ace4c335912c9e96$export$34b52ce9cfcb0a39).Card)].title) : "",
            amount: `${currentPayment?.currency_code} ${currentPayment?.amount}`,
            status: t((0, $810e278414a1540d$export$842954143681ce02)(String(currentPayment?.status))),
            statusId: Number(currentPayment?.status),
            nextAction: nextAction,
            nextActionTitle: paymentOptionsObject?.redirectToRouteAfterSuccessTitle ?? null
        });
    }));
}




var $45fvw = parcelRequire("45fvw");

var $acw62 = parcelRequire("acw62");



var $c146f52c6fc1dada$exports = {};
$c146f52c6fc1dada$exports = new URL("completed-img.231419b2.svg", import.meta.url).toString();



const $b76dfe241368d054$export$6c45ad59c0113459 = ({ isCompleted: isCompleted, clientEmail: clientEmail, isLoading: isLoading, isUpdatingStatus: isUpdatingStatus, paymentNumber: paymentNumber, fulfilledAt: fulfilledAt, paymentMethodTitle: paymentMethodTitle, amount: amount, status: status, statusId: statusId, nextAction: nextAction, nextActionTitle: nextActionTitle })=>{
    const { t: t } = (0, $3765cebd031b52c0$export$9fc83ad70ead8663)();
    if (isLoading) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $57fb8f45c69e1681$export$2e2bcd8739ae039), {});
    const fulfilledAtString = (0, (/*@__PURE__*/$parcel$interopDefault($45fvw)))(fulfilledAt).format("MMM DD, YYYY | hh:mm:ss A");
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "CardPaymentStatus",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "CardPaymentStatus__content",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                        src: (0, (/*@__PURE__*/$parcel$interopDefault($c146f52c6fc1dada$exports)))
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                        className: "CardPaymentStatus__title",
                        children: isCompleted ? t("payment.payment_completed") : t("payment.payment_processing")
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                        className: "CardPaymentStatus__subtitle",
                        children: isCompleted ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $acw62.Fragment), {
                            children: [
                                t("payment.was_successful"),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("br", {}),
                                t("payment.email_was_sent_to"),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                    className: "CardPaymentStatus__subtitle__email",
                                    children: clientEmail
                                })
                            ]
                        }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $acw62.Fragment), {
                            children: t("payment.can_go_to_payments_list_page")
                        })
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "CardPaymentStatus__data",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "CardPaymentStatus__dataItem",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                        className: "CardPaymentStatus__dataItem__key",
                                        children: t("payment.transaction_id")
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                        className: "CardPaymentStatus__dataItem__value",
                                        children: paymentNumber
                                    })
                                ]
                            }),
                            fulfilledAt && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "CardPaymentStatus__dataItem",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                        className: "CardPaymentStatus__dataItem__key",
                                        children: t("payment.date")
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                        className: "CardPaymentStatus__dataItem__value",
                                        children: fulfilledAtString
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "CardPaymentStatus__dataItem",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                        className: "CardPaymentStatus__dataItem__key",
                                        children: t("payment.payment_method")
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                        className: "CardPaymentStatus__dataItem__value",
                                        children: paymentMethodTitle
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "CardPaymentStatus__dataItem",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                        className: "CardPaymentStatus__dataItem__key",
                                        children: t("payment.amount")
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                        className: "CardPaymentStatus__dataItem__value",
                                        children: amount
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "CardPaymentStatus__dataItem",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                        className: "CardPaymentStatus__dataItem__key",
                                        children: t("payment.status")
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                        className: `CardPaymentStatus__dataItem__value${!isUpdatingStatus && statusId === Number((0, $ace4c335912c9e96$export$999f810846f9d31d).Completed) ? " CardPaymentStatus__dataItem__value--green" : ""}`,
                                        children: isUpdatingStatus ? t("payment.updating_status") : status
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                onClick: nextAction,
                className: "CardPaymentStatus__goToPayments",
                children: nextActionTitle ?? t("payment.go_to_payments_list_page")
            })
        ]
    });
};


const $36921230fc0fdab8$export$6c45ad59c0113459 = (0, $3b6056fcd49caacd$export$b827633935e92857)((0, $b76dfe241368d054$export$6c45ad59c0113459));









var $acw62 = parcelRequire("acw62");









const $125c096eb5afc7d0$export$4d1a757446dca858 = (0, $a4963babae245ff9$export$f0c7a449e0cfaec7)((0, $aca50e9407ba89c9$export$b6ae1bc530f4c149)(({ paymentId: paymentId, cardId: cardId, clientSecret: clientSecret, paymentOptions: paymentOptions })=>{
    const redirect = (0, $7df35e9df335b1c8$export$602eaf6d5314ce55)();
    const stripe = (0, $7bf3b98cbc00db03$exports.useStripe)();
    const { processPayment: processPayment, resetPayment: resetPayment } = (0, $4671947198ddd366$export$6ccbb43953eebf8)().data;
    const { enableQuery: resetPaymentQuery } = (0, $4671947198ddd366$export$517ca4f7fee4e226)(()=>resetPayment(paymentId), {
        onSuccess: (result)=>{
            redirect((0, $0534349ae8731d0b$export$66b32f6f30eb4b4).paymentMethodsList, {
                paymentId: String(paymentId)
            });
        }
    });
    const { enableQuery: processPaymentQuery } = (0, $4671947198ddd366$export$517ca4f7fee4e226)(()=>processPayment(paymentId), {
        onSuccess: (result)=>{
            confirmPayment();
        }
    });
    const confirmPayment = async ()=>{
        await (0, $0e6cd841cc250b52$export$4cb3f1c9fb756d2a)(stripe, clientSecret, cardId, paymentId, (errorMessage)=>{
            resetPaymentQuery();
            (0, $60f27fc97e29822a$export$b410431fab84fa58).error(errorMessage);
        }, ()=>redirect((0, $0534349ae8731d0b$export$66b32f6f30eb4b4).cardPaymentStatus, {
                paymentId: String(paymentId),
                ...paymentOptions ? {
                    paymentOptions: paymentOptions
                } : {}
            }), paymentOptions);
    };
    (0, $acw62.useEffect)(()=>{
        if (Boolean(stripe)) processPaymentQuery();
    }, [
        stripe
    ]);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $57fb8f45c69e1681$export$2e2bcd8739ae039), {});
}));






const $2f3cbce343947f74$export$2f3dbe5e602db2c7 = (0, $a4963babae245ff9$export$f0c7a449e0cfaec7)((0, $aca50e9407ba89c9$export$b6ae1bc530f4c149)(({ paymentId: paymentId, cardId: cardId, paymentOptions: paymentOptions })=>{
    const { t: t } = (0, $3765cebd031b52c0$export$9fc83ad70ead8663)();
    const { isLoading: isLoading } = (0, $0e6cd841cc250b52$export$455c462b3eca956b)(paymentId);
    const { stripeOptions: stripeOptions } = (0, $0e6cd841cc250b52$export$dd09e5139f9499ad)(paymentId, (0, $ace4c335912c9e96$export$34b52ce9cfcb0a39).Card);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "PayWithCardPage",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7ae42b63183f30b4$export$8b251419efc915eb), {
                title: t("payment.card_payment")
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $660b2ca422e0e2ae$export$1ff3c3f08ae963c0).Vertical, {
                height: 35
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "PayWithCardPage__container",
                children: !stripeOptions || isLoading ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $57fb8f45c69e1681$export$2e2bcd8739ae039), {}) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7bf3b98cbc00db03$exports.Elements), {
                    stripe: (0, $0e6cd841cc250b52$export$559f48a7f7271adf)(),
                    options: stripeOptions,
                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $125c096eb5afc7d0$export$4d1a757446dca858), {
                        paymentId: paymentId,
                        cardId: cardId,
                        clientSecret: stripeOptions.clientSecret,
                        paymentOptions: paymentOptions
                    })
                })
            })
        ]
    });
}));


const $c924ab59c2541172$export$fc8cea4daeae7879 = {
    PayWithCardPage: (0, $181bbcdfd1b03ab5$export$1b67faa03b87f50f),
    CardPaymentStatusPage: (0, $36921230fc0fdab8$export$6c45ad59c0113459),
    PayWithSavedCardPage: (0, $2f3cbce343947f74$export$2f3dbe5e602db2c7)
};




var $acw62 = parcelRequire("acw62");










const $2af3d04ce1dddf19$var$getUpdateTypeByStatus = (status)=>{
    switch(status){
        case (0, $ace4c335912c9e96$export$999f810846f9d31d).Pending:
            return (0, $d28b592401b34c77$export$9ff3c61eb01645e4).NewPendingPayment;
        case (0, $ace4c335912c9e96$export$999f810846f9d31d).Processing:
            return (0, $d28b592401b34c77$export$9ff3c61eb01645e4).NewProcessingPayment;
        default:
            return (0, $d28b592401b34c77$export$9ff3c61eb01645e4).NewPaidPayment;
    }
};
function $2af3d04ce1dddf19$export$29ee53e8bda7d546(UIComponent) {
    return (0, $a4963babae245ff9$export$f0c7a449e0cfaec7)((0, $aca50e9407ba89c9$export$b6ae1bc530f4c149)(({ paymentStatus: paymentStatus })=>{
        const { paymentsList: paymentsList, getPaymentsList: getPaymentsList, getUnseenUpdates: getUnseenUpdates, isUpdateSeen: isUpdateSeen, markUpdateAsSeen: markUpdateAsSeen } = (0, $4671947198ddd366$export$6ccbb43953eebf8)().data;
        (0, $4671947198ddd366$export$dd0a697e1782aedd)(getUnseenUpdates);
        const [getPaymentsListMutation, getPaymentsListApiCall] = (0, $4671947198ddd366$export$609860bf8b0084c)(({ status: status, page: page })=>getPaymentsList(status, page));
        const [, markUpdateAsSeenApiCall] = (0, $4671947198ddd366$export$609860bf8b0084c)(({ updateType: updateType })=>markUpdateAsSeen(updateType));
        const redirect = (0, $7df35e9df335b1c8$export$602eaf6d5314ce55)();
        const { t: t } = (0, $3765cebd031b52c0$export$9fc83ad70ead8663)();
        const onPayClick = (0, $2994e7b5ba509fe3$export$b6630b826aa95580)();
        (0, $acw62.useEffect)(()=>{
            getPaymentsListApiCall({
                status: paymentStatus,
                page: 1
            });
            markUpdateAsSeenApiCall({
                updateType: $2af3d04ce1dddf19$var$getUpdateTypeByStatus(paymentStatus)
            });
        }, [
            paymentStatus
        ]);
        const loadMore = (0, $324dc7daf4e64dab$export$5bd4c3b2b0a1aaf1)(()=>getPaymentsListApiCall({
                status: paymentStatus
            }));
        const tabs = [
            {
                title: t("payment.pending"),
                onClick: ()=>redirect((0, $0534349ae8731d0b$export$66b32f6f30eb4b4).paymentList, {
                        paymentStatus: (0, $ace4c335912c9e96$export$999f810846f9d31d).Pending
                    }),
                isActive: (0, $ace4c335912c9e96$export$999f810846f9d31d).Pending === paymentStatus,
                showUpdatesIndicator: !isUpdateSeen((0, $d28b592401b34c77$export$9ff3c61eb01645e4).NewPendingPayment)
            },
            {
                title: t("payment.processing"),
                onClick: ()=>redirect((0, $0534349ae8731d0b$export$66b32f6f30eb4b4).paymentList, {
                        paymentStatus: (0, $ace4c335912c9e96$export$999f810846f9d31d).Processing
                    }),
                isActive: (0, $ace4c335912c9e96$export$999f810846f9d31d).Processing === paymentStatus,
                showUpdatesIndicator: !isUpdateSeen((0, $d28b592401b34c77$export$9ff3c61eb01645e4).NewProcessingPayment)
            },
            {
                title: t("payment.completed"),
                onClick: ()=>redirect((0, $0534349ae8731d0b$export$66b32f6f30eb4b4).paymentList, {
                        paymentStatus: (0, $ace4c335912c9e96$export$999f810846f9d31d).Completed
                    }),
                isActive: (0, $ace4c335912c9e96$export$999f810846f9d31d).Completed === paymentStatus,
                showUpdatesIndicator: !isUpdateSeen((0, $d28b592401b34c77$export$9ff3c61eb01645e4).NewPaidPayment)
            }
        ];
        return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)(UIComponent, {
            loadMore: loadMore,
            tabs: tabs,
            paymentsList: paymentsList,
            isLoading: getPaymentsListMutation.isLoading,
            onPayClick: onPayClick,
            onItemClick: (paymentId)=>redirect((0, $0534349ae8731d0b$export$66b32f6f30eb4b4).paymentDetails, {
                    paymentId: paymentId
                }),
            paymentStatus: paymentStatus
        });
    }));
}




var $acw62 = parcelRequire("acw62");







var $dd8ce04dfee1bd9a$exports = {};
$dd8ce04dfee1bd9a$exports = new URL("payment-icon.897371b2.svg", import.meta.url).toString();




const $fd1057815d7995dd$export$eabf9099b179af62 = (0, $aca50e9407ba89c9$export$b6ae1bc530f4c149)(({ paymentItem: paymentItem, onItemClick: onItemClick, onPayClick: onPayClick })=>{
    const { t: t } = (0, $3765cebd031b52c0$export$9fc83ad70ead8663)();
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "PaymentItem",
        onClick: ()=>onItemClick(String(paymentItem.id)),
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "PaymentItem__content",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "PaymentItem__content__left",
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                            src: (0, (/*@__PURE__*/$parcel$interopDefault($dd8ce04dfee1bd9a$exports)))
                        })
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "PaymentItem__content__right",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "PaymentItem__content__titles",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                        className: "PaymentItem__content__title",
                                        children: paymentItem.payment_number
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                        className: "PaymentItem__content__title",
                                        children: [
                                            paymentItem.currency_code,
                                            " ",
                                            paymentItem.amount
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "PaymentItem__content__details",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                        className: "PaymentItem__content__detailsItem",
                                        children: (0, $810e278414a1540d$export$92521769c5df59ad)(paymentItem.due_date)
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                        className: "PaymentItem__content__detailsItem",
                                        children: "."
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                        className: "PaymentItem__content__detailsItem",
                                        children: [
                                            paymentItem.invoices_count,
                                            " ",
                                            t("payment.invoice")
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                        className: "PaymentItem__content__detailsItem",
                                        children: "."
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                        className: "PaymentItem__content__detailsItem",
                                        style: (0, $810e278414a1540d$export$980585fe0580c9bf)(paymentItem),
                                        children: (0, $810e278414a1540d$export$c993e048c4e2c9b4)(paymentItem, t)
                                    })
                                ]
                            }),
                            paymentItem.type_id !== null && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                className: "PaymentItem__content__payment-method-container",
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                    className: "PaymentItem__content__payment-method",
                                    children: t((0, $810e278414a1540d$export$95dc18b5b2f97717)[String(paymentItem.type_id)].wideTitle)
                                })
                            })
                        ]
                    })
                ]
            }),
            String(paymentItem.status) === (0, $ace4c335912c9e96$export$999f810846f9d31d).Pending && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "PaymentItem__actions",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                    onClick: (event)=>{
                        event.stopPropagation();
                        onPayClick(String(paymentItem.id));
                    },
                    className: "PaymentItem__actions__payButton",
                    children: paymentItem.type_id === Number((0, $ace4c335912c9e96$export$34b52ce9cfcb0a39).Lean) && paymentItem.external_status === (0, $ace4c335912c9e96$export$9bde2038e0377af5).AWAITING_AUTHORIZATION ? t("payment.authorize") : t("payment.pay_now")
                })
            })
        ]
    }, paymentItem.id);
});




function $3c7624d798dd7349$var$getEmptyListText(paymentStatus, t) {
    if (paymentStatus === (0, $ace4c335912c9e96$export$999f810846f9d31d).Pending) return t("payment.empty_pending_list");
    if (paymentStatus === (0, $ace4c335912c9e96$export$999f810846f9d31d).Processing) return t("payment.empty_processing_list");
    return t("payment.empty_completed_list");
}
const $3c7624d798dd7349$export$7c54d215048ac783 = ({ loadMore: loadMore, tabs: tabs, paymentsList: paymentsList, isLoading: isLoading, onItemClick: onItemClick, onPayClick: onPayClick, paymentStatus: paymentStatus })=>{
    const { t: t } = (0, $3765cebd031b52c0$export$9fc83ad70ead8663)();
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "PaymentList",
        onScroll: loadMore,
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7ae42b63183f30b4$export$8b251419efc915eb), {
                title: t("payment.payments")
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $660b2ca422e0e2ae$export$1ff3c3f08ae963c0).Vertical, {
                height: 35
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "PaymentList__container",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $1517d97a0e4f4f9f$export$b2539bed5023c21c), {
                        tabs: tabs
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $660b2ca422e0e2ae$export$1ff3c3f08ae963c0).Vertical, {
                        height: 20
                    }),
                    paymentsList.length > 0 ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $acw62.Fragment), {
                        children: paymentsList.map((paymentListItem)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $fd1057815d7995dd$export$eabf9099b179af62), {
                                paymentItem: paymentListItem,
                                onPayClick: ()=>onPayClick(paymentListItem),
                                onItemClick: onItemClick
                            }, paymentListItem.id))
                    }) : !isLoading && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                        className: "PaymentList__emptyList",
                        children: $3c7624d798dd7349$var$getEmptyListText(paymentStatus, t)
                    }),
                    isLoading && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $57fb8f45c69e1681$export$2e2bcd8739ae039), {})
                ]
            })
        ]
    });
};


const $796005e3ba80072e$export$7c54d215048ac783 = (0, $2af3d04ce1dddf19$export$29ee53e8bda7d546)((0, $3c7624d798dd7349$export$7c54d215048ac783));










function $c3af366fb937be39$export$10e3b864865de396(UIComponent) {
    return (0, $a4963babae245ff9$export$f0c7a449e0cfaec7)((0, $aca50e9407ba89c9$export$b6ae1bc530f4c149)(({ paymentId: paymentId, hideBack: hideBack })=>{
        const { t: t } = (0, $3765cebd031b52c0$export$9fc83ad70ead8663)();
        const { getPayment: getPayment, currentPayment: currentPayment, resetPayment: resetPayment } = (0, $4671947198ddd366$export$6ccbb43953eebf8)().data;
        const getPaymentQuery = (0, $4671947198ddd366$export$dd0a697e1782aedd)(()=>getPayment(paymentId));
        const { enableQuery: getPaymentDelayedQuery } = (0, $4671947198ddd366$export$517ca4f7fee4e226)(()=>getPayment(paymentId));
        const [, resetPaymentRequest] = (0, $4671947198ddd366$export$609860bf8b0084c)(()=>resetPayment(paymentId), {
            onSuccess: (result)=>{
                getPaymentDelayedQuery();
                (0, $60f27fc97e29822a$export$b410431fab84fa58).success("Payment was cancelled");
            }
        });
        const onPayClick = (0, $2994e7b5ba509fe3$export$b6630b826aa95580)();
        const isPending = String(currentPayment?.status) === (0, $ace4c335912c9e96$export$999f810846f9d31d).Pending;
        const isProcessing = String(currentPayment?.status) === (0, $ace4c335912c9e96$export$999f810846f9d31d).Processing;
        const isWireTransfer = currentPayment?.type_id === Number((0, $ace4c335912c9e96$export$34b52ce9cfcb0a39).Wire);
        const isLean = currentPayment?.type_id === Number((0, $ace4c335912c9e96$export$34b52ce9cfcb0a39).Lean);
        const payNowButtonText = currentPayment?.type_id === Number((0, $ace4c335912c9e96$export$34b52ce9cfcb0a39).Lean) && currentPayment.external_status === (0, $ace4c335912c9e96$export$9bde2038e0377af5).AWAITING_AUTHORIZATION ? t("payment.authorize") : t("payment.pay_now");
        if (!currentPayment) return null;
        return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)(UIComponent, {
            paymentId: paymentId,
            hideBack: hideBack,
            isLoading: getPaymentQuery.isLoading,
            currentPayment: currentPayment,
            onMainButtonClick: ()=>onPayClick(currentPayment),
            isWireTransferPending: isPending && isWireTransfer,
            isWireTransferProcessing: isProcessing && isWireTransfer,
            isLeanPaymentAwaitingAuthorization: isPending && isLean && currentPayment.external_status === (0, $ace4c335912c9e96$export$9bde2038e0377af5).AWAITING_AUTHORIZATION,
            payNowEnabled: isPending && !isWireTransfer,
            payNowButtonText: payNowButtonText,
            resetPayment: resetPaymentRequest
        });
    }));
}






var $acw62 = parcelRequire("acw62");

var $06a690742071017e$exports = {};
$06a690742071017e$exports = new URL("title-icon.14fd0349.svg", import.meta.url).toString();







var $e49322666d59597f$exports = {};
$e49322666d59597f$exports = new URL("invoice-icon.dbd1f748.svg", import.meta.url).toString();






const $8cc5bad03e78b41e$export$ba5f874f962e090e = ({ invoice: invoice })=>{
    const { t: t } = (0, $3765cebd031b52c0$export$9fc83ad70ead8663)();
    const redirect = (0, $7df35e9df335b1c8$export$602eaf6d5314ce55)();
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        className: "PaymentDetails__invoice",
        onClick: ()=>redirect((0, $0534349ae8731d0b$export$66b32f6f30eb4b4).invoice, {
                id: String(invoice.id)
            }),
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
            className: "PaymentDetails__invoice__content",
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                    className: "PaymentDetails__invoice__content__left",
                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                        src: (0, (/*@__PURE__*/$parcel$interopDefault($e49322666d59597f$exports)))
                    })
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: "PaymentDetails__invoice__content__right",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: "PaymentDetails__invoice__content__titles",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                    className: "PaymentDetails__invoice__content__title",
                                    children: invoice.invoice_number ?? `INV-${invoice.id}`
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                    className: "PaymentDetails__invoice__content__title",
                                    children: [
                                        invoice.currency_code,
                                        " ",
                                        invoice.amount
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: "PaymentDetails__invoice__content__details",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                    className: "PaymentDetails__invoice__content__detailsItem",
                                    children: (0, $810e278414a1540d$export$92521769c5df59ad)(invoice.due_date)
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                    className: "PaymentDetails__invoice__content__detailsItem",
                                    children: "."
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                    className: "PaymentDetails__invoice__content__detailsItem",
                                    style: (0, $810e278414a1540d$export$cf24e9559eb569c7)(invoice),
                                    children: (0, $a8b6e1b9cac4434c$export$6fdbeaa08f63a468)(invoice, t)
                                })
                            ]
                        })
                    ]
                })
            ]
        })
    });
};







const $02b5ce5939ae68c3$export$af06bded58f8b363 = ({ onClick: onClick, buttonTitle: buttonTitle })=>{
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4a1895475c466679$export$c072955bb62eb0e2), {
        onClick: onClick,
        style: {
            justifyContent: "center"
        },
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
            className: "StickyButton__button",
            onClick: onClick,
            style: {
                background: "#7767E4"
            },
            children: buttonTitle
        })
    });
};






const $441e5c91ae5e6f63$export$2957fc44b3d2481 = ({ color: color })=>{
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M11.9997 4C7.58197 4 4 7.58197 4 11.9997C4 16.4174 7.58197 20 11.9997 20C16.4174 20 20 16.4174 20 11.9997C20 7.58197 16.4174 4 11.9997 4ZM13.665 16.3984C13.2532 16.5609 12.9255 16.6842 12.6796 16.7695C12.4345 16.8549 12.1493 16.8975 11.8249 16.8975C11.3265 16.8975 10.9384 16.7756 10.6621 16.5325C10.3858 16.2894 10.2483 15.9812 10.2483 15.6067C10.2483 15.4611 10.2585 15.3121 10.2788 15.1604C10.2998 15.0087 10.333 14.838 10.3783 14.6463L10.8937 12.8259C10.9391 12.6512 10.9784 12.4852 11.0095 12.3308C11.0407 12.1751 11.0556 12.0322 11.0556 11.9021C11.0556 11.6705 11.0075 11.508 10.912 11.4166C10.8152 11.3251 10.633 11.2804 10.3614 11.2804C10.2287 11.2804 10.0919 11.3001 9.95166 11.3414C9.81283 11.384 9.69228 11.4226 9.5934 11.4606L9.72952 10.8998C10.0668 10.7623 10.3898 10.6445 10.698 10.547C11.0061 10.4481 11.2974 10.3993 11.5716 10.3993C12.0667 10.3993 12.4487 10.5199 12.7175 10.7583C12.9851 10.9973 13.1198 11.3082 13.1198 11.6902C13.1198 11.7694 13.1103 11.9089 13.0921 12.108C13.0738 12.3078 13.0392 12.49 12.9891 12.6573L12.4764 14.4723C12.4345 14.6179 12.3972 14.7845 12.3633 14.9708C12.3302 15.157 12.3139 15.2992 12.3139 15.3947C12.3139 15.6358 12.3674 15.8004 12.4758 15.8877C12.5828 15.9751 12.7704 16.0191 13.0359 16.0191C13.1611 16.0191 13.3013 15.9968 13.4598 15.9534C13.6169 15.9101 13.7307 15.8715 13.8025 15.8383L13.665 16.3984ZM13.5743 9.03128C13.3352 9.25342 13.0474 9.36449 12.7108 9.36449C12.3749 9.36449 12.085 9.25342 11.8439 9.03128C11.6041 8.80914 11.4829 8.53892 11.4829 8.22332C11.4829 7.9084 11.6048 7.6375 11.8439 7.41333C12.085 7.18849 12.3749 7.07674 12.7108 7.07674C13.0474 7.07674 13.3359 7.18849 13.5743 7.41333C13.8133 7.6375 13.9332 7.9084 13.9332 8.22332C13.9332 8.5396 13.8133 8.80914 13.5743 9.03128Z",
            fill: color
        })
    });
};


const $e3fe936ac6ad8ee6$export$6fe46c76a8d9b32b = ()=>{
    const { t: t } = (0, $3765cebd031b52c0$export$9fc83ad70ead8663)();
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "PaymentDetails__alert",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                className: "PaymentDetails__alert__title",
                children: t("payment.please_upload_slip")
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "PaymentDetails__alert__content",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "PaymentDetails__alert__content__icon",
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $441e5c91ae5e6f63$export$2957fc44b3d2481), {
                            color: "#FCB35C"
                        })
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "PaymentDetails__alert__content__texts",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                className: "PaymentDetails__alert__content__title",
                                children: t("payment.bank_slip_info_in_alert")
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                className: "PaymentDetails__alert__content__subtitle",
                                children: t("payment.you_can_upload_slip_now_or_later")
                            })
                        ]
                    })
                ]
            })
        ]
    });
};






const $fa84dbb9029a51a8$export$7d82a45ccdaa49c7 = ({ firstTitle: firstTitle, secondTitle: secondTitle })=>{
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        className: "PaymentDetails__alert PaymentDetails__alert--primary",
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
            className: "PaymentDetails__alert__content",
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                    className: "PaymentDetails__alert__content__icon",
                    style: {
                        marginTop: "2px"
                    },
                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $441e5c91ae5e6f63$export$2957fc44b3d2481), {
                        color: "#4E5D78"
                    })
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: "PaymentDetails__alert__content__texts",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                            className: "PaymentDetails__alert__content__title-primary",
                            children: firstTitle
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                            className: "PaymentDetails__alert__content__subtitle-primary",
                            children: secondTitle
                        })
                    ]
                })
            ]
        })
    });
};


const $3805d5f463a4d8ec$export$59c271ccbde24fa9 = ()=>{
    const { t: t } = (0, $3765cebd031b52c0$export$9fc83ad70ead8663)();
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $fa84dbb9029a51a8$export$7d82a45ccdaa49c7), {
        firstTitle: t("payment.wire_transfer_slip_under_review"),
        secondTitle: t("payment.wire_transfer_out_team_is_checking_slip")
    });
};






function $f8ed1b473fa903af$export$8ddaa0197a58da93(url) {
    const link = document.createElement("a");
    link.href = url;
    link.target = "_blank";
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
}





const $cfdc60bc0f3b6373$export$156c896184e25e6c = ()=>{
    const { t: t } = (0, $3765cebd031b52c0$export$9fc83ad70ead8663)();
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $fa84dbb9029a51a8$export$7d82a45ccdaa49c7), {
        firstTitle: t("payment.payment_awaiting_authorization"),
        secondTitle: t("payment.will_be_paid_after_authorize")
    });
};


const $200b92414b451ee9$export$b1bd3336d32d1d33 = ({ paymentId: paymentId, isLoading: isLoading, currentPayment: currentPayment, onMainButtonClick: onMainButtonClick, isWireTransferPending: isWireTransferPending, isWireTransferProcessing: isWireTransferProcessing, payNowEnabled: payNowEnabled, payNowButtonText: payNowButtonText, isLeanPaymentAwaitingAuthorization: isLeanPaymentAwaitingAuthorization, resetPayment: resetPayment })=>{
    const { t: t } = (0, $3765cebd031b52c0$export$9fc83ad70ead8663)();
    const redirect = (0, $7df35e9df335b1c8$export$602eaf6d5314ce55)();
    const showPaymentMethod = currentPayment?.type_id !== null;
    const contextMenuItems = (0, $acw62.useMemo)(()=>{
        if (!isWireTransferProcessing) return [];
        return [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $bd25114c2c6a2977$export$2ce376c2cc3355c8), {
                title: t("payment.download_slip"),
                img: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                    src: (0, (/*@__PURE__*/$parcel$interopDefault($c3508c9e208f0598$exports)))
                }),
                onClick: ()=>{
                    if (currentPayment?.file) (0, $f8ed1b473fa903af$export$8ddaa0197a58da93)(currentPayment.file);
                }
            }, 1)
        ];
    }, [
        isWireTransferProcessing
    ]);
    const headerContextMenu = !isWireTransferProcessing ? null : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $04012d5b0475752e$export$e44a253a59704894), {
        outerComponent: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
            src: (0, (/*@__PURE__*/$parcel$interopDefault($fad8d8af5e59da33$exports)))
        }),
        items: contextMenuItems
    });
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "PaymentDetails",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7ae42b63183f30b4$export$8b251419efc915eb), {
                title: t("payment.payment_details_title", {
                    paymentId: paymentId
                }),
                showBack: true,
                handleBackClick: ()=>redirect((0, $0534349ae8731d0b$export$66b32f6f30eb4b4).paymentList, {
                        paymentStatus: String((0, $ace4c335912c9e96$export$999f810846f9d31d).Pending)
                    }),
                rightComponent: headerContextMenu
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $660b2ca422e0e2ae$export$1ff3c3f08ae963c0).Vertical, {
                height: 35
            }),
            isLoading ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $57fb8f45c69e1681$export$2e2bcd8739ae039), {}) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "PaymentDetails__container",
                children: [
                    isWireTransferPending && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e3fe936ac6ad8ee6$export$6fe46c76a8d9b32b), {}),
                    isWireTransferProcessing && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $3805d5f463a4d8ec$export$59c271ccbde24fa9), {}),
                    isLeanPaymentAwaitingAuthorization && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $cfdc60bc0f3b6373$export$156c896184e25e6c), {}),
                    isLeanPaymentAwaitingAuthorization && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "PaymentDetails__cancelButtonContainer",
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                            className: "PaymentDetails__cancelButton",
                            onClick: resetPayment,
                            children: "Cancel Initiated Payment"
                        })
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "PaymentDetails__title-container",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                                src: (0, (/*@__PURE__*/$parcel$interopDefault($06a690742071017e$exports)))
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                children: t("payment.details")
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "PaymentDetails__paymentItem",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "PaymentDetails__paymentItem__valueContainer",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                        className: "PaymentDetails__paymentItem__valueContainer__key",
                                        children: t("payment.payment_number")
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                        className: "PaymentDetails__paymentItem__valueContainer__value",
                                        children: currentPayment?.payment_number
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "PaymentDetails__paymentItem__valueContainer",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                        className: "PaymentDetails__paymentItem__valueContainer__key",
                                        children: t("payment.due_date")
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                        className: "PaymentDetails__paymentItem__valueContainer__value",
                                        children: (0, $810e278414a1540d$export$92521769c5df59ad)(String(currentPayment?.due_date))
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "PaymentDetails__paymentItem__valueContainer",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                        className: "PaymentDetails__paymentItem__valueContainer__key",
                                        children: t("payment.amount")
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                        className: "PaymentDetails__paymentItem__valueContainer__value",
                                        children: [
                                            currentPayment?.currency_code,
                                            " ",
                                            currentPayment?.amount
                                        ]
                                    })
                                ]
                            }),
                            showPaymentMethod && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "PaymentDetails__paymentItem__valueContainer",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                        className: "PaymentDetails__paymentItem__valueContainer__key",
                                        children: t("payment.payment_method")
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                        className: "PaymentDetails__paymentItem__valueContainer__value",
                                        children: t((0, $810e278414a1540d$export$95dc18b5b2f97717)[String(currentPayment?.type_id)].title)
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "PaymentDetails__paymentItem__valueContainer",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                        className: "PaymentDetails__paymentItem__valueContainer__key",
                                        children: t("payment.status")
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                        className: "PaymentDetails__paymentItem__valueContainer__value",
                                        children: t((0, $810e278414a1540d$export$842954143681ce02)(String(currentPayment?.status)))
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "PaymentDetails__title-container",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                                src: (0, (/*@__PURE__*/$parcel$interopDefault($06a690742071017e$exports)))
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                children: t("payment.invoices")
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "PaymentDetails__invoices",
                        children: currentPayment?.invoices.map((invoice)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $8cc5bad03e78b41e$export$ba5f874f962e090e), {
                                invoice: invoice
                            }, invoice.id))
                    }),
                    payNowEnabled && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b3926a89bab8b1bc$export$7dfaa78f18820bbf), {
                        amount: `${currentPayment?.currency_code} ${currentPayment?.amount}`,
                        action: onMainButtonClick,
                        actionTitle: payNowButtonText
                    }),
                    isWireTransferPending && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $02b5ce5939ae68c3$export$af06bded58f8b363), {
                        onClick: ()=>{
                            redirect((0, $0534349ae8731d0b$export$66b32f6f30eb4b4).wireTransferUploadSlip, {
                                paymentId: String(paymentId)
                            });
                        },
                        buttonTitle: t("payment.next")
                    })
                ]
            })
        ]
    });
};


const $d46dfe922f74a186$export$b1bd3336d32d1d33 = (0, $c3af366fb937be39$export$10e3b864865de396)((0, $200b92414b451ee9$export$b1bd3336d32d1d33));




var $acw62 = parcelRequire("acw62");





var $45fvw = parcelRequire("45fvw");







function $dc51e603a684ae2a$export$807209090ace1102(UIComponent) {
    return (0, $a4963babae245ff9$export$f0c7a449e0cfaec7)((0, $aca50e9407ba89c9$export$b6ae1bc530f4c149)(({ paymentId: paymentId, paymentOptions: paymentOptions })=>{
        const redirect = (0, $7df35e9df335b1c8$export$602eaf6d5314ce55)();
        const { t: t } = (0, $3765cebd031b52c0$export$9fc83ad70ead8663)();
        const { paymentMethods: paymentMethods, getPaymentMethods: getPaymentMethods, cards: cards, setLeanSetupStatus: setLeanSetupStatus, setLeanSetupCompleted: setLeanSetupCompleted, setLeanSetupStatusUpdatedAt: setLeanSetupStatusUpdatedAt } = (0, $4671947198ddd366$export$6ccbb43953eebf8)().data;
        const { isLoading: isCurrentPaymentLoading, currentPayment: currentPayment } = (0, $0e6cd841cc250b52$export$b58e02d966cf30be)(paymentId);
        const getPaymentMethodsQuery = (0, $4671947198ddd366$export$dd0a697e1782aedd)(()=>getPaymentMethods(paymentId), {
            onSuccess: (result)=>{
                const cardId = result.cards[0]?.id ?? null;
                if (cardId) chooseSavedCard(cardId);
            },
            onError: (err)=>{
                (0, $60f27fc97e29822a$export$b410431fab84fa58).error(err.data.message);
                redirect((0, $0534349ae8731d0b$export$66b32f6f30eb4b4).paymentDetails, {
                    paymentId: String(paymentId)
                });
            },
            filterError: [
                (0, $9ad33fbf770c55a1$export$9696fcf1798e1cb5).ClientError
            ]
        });
        const defaultPaymentMethod = (0, $ace4c335912c9e96$export$34b52ce9cfcb0a39).Card;
        const defaultCardId = paymentMethods?.cards[0]?.id ?? null;
        const [chosenPaymentMethod, setChosenPaymentMethod] = (0, $acw62.useState)(!defaultCardId ? defaultPaymentMethod : null);
        const [chosenSavedCard, setChosenSavedCard] = (0, $acw62.useState)(defaultCardId);
        const { initLeanPayment: initLeanPayment, isLoading: isLeanPayPreparing } = (0, $2994e7b5ba509fe3$export$9324d2d622b917b2)();
        const { connectLean: connectLean } = (0, $2994e7b5ba509fe3$export$6ec841cd447cf192)((responseObject)=>{
            if (responseObject.status === String((0, $ace4c335912c9e96$export$1672d1da93b9da0f).SUCCESS)) {
                if (responseObject.secondary_status === String((0, $ace4c335912c9e96$export$ddddacbee104bbf3).ACTIVE)) {
                    setLeanSetupStatus((0, $ace4c335912c9e96$export$c35a3f1cb87c9eaa).LEAN_SETUP_STATUS_ACTIVE);
                    setLeanSetupStatusUpdatedAt((0, (/*@__PURE__*/$parcel$interopDefault($45fvw)))().format("YYYY-MM-DD"));
                    initLeanPayment(paymentId, currentPayment?.external_id ?? null);
                    (0, $60f27fc97e29822a$export$b410431fab84fa58).success(t("payment.successfully_connected_bank"));
                }
                if (responseObject.secondary_status === String((0, $ace4c335912c9e96$export$ddddacbee104bbf3).PENDING_BENEFICIARY_COOL_OFF)) {
                    setLeanSetupCompleted(1);
                    setLeanSetupStatus((0, $ace4c335912c9e96$export$c35a3f1cb87c9eaa).LEAN_SETUP_STATUS_AWAITING_BENEFICIARY_COOL_OFF);
                    setLeanSetupStatusUpdatedAt((0, (/*@__PURE__*/$parcel$interopDefault($45fvw)))().format("YYYY-MM-DD"));
                    (0, $60f27fc97e29822a$export$b410431fab84fa58).info(t("payment.lean.account_is_being_connected"));
                }
            }
        });
        const isSavedCardChosen = (cardId)=>{
            return chosenSavedCard === cardId;
        };
        const isPaymentMethodChosen = (paymentMethod)=>{
            return chosenSavedCard === null && paymentMethod === chosenPaymentMethod;
        };
        const choosePaymentMethod = (paymentMethod)=>{
            setChosenSavedCard(null);
            setChosenPaymentMethod(paymentMethod);
        };
        const chooseSavedCard = (cardId)=>{
            setChosenPaymentMethod(null);
            setChosenSavedCard(cardId);
        };
        const isAnyPaymentMethodChosen = ()=>{
            return chosenPaymentMethod !== null;
        };
        const isAnySavedCardChosen = ()=>{
            return chosenSavedCard !== null;
        };
        const methods = paymentMethods?.methods.filter((method)=>{
            const methodValue = String(method);
            return (0, $ace4c335912c9e96$export$3f047a646a42be2).includes(methodValue);
        }) ?? [];
        const onPaymentMethodContinue = ()=>{
            const paymentMethodParams = {
                paymentId: String(paymentId),
                ...paymentOptions ? {
                    paymentOptions: paymentOptions
                } : {}
            };
            switch(chosenPaymentMethod){
                case (0, $ace4c335912c9e96$export$34b52ce9cfcb0a39).Card:
                    redirect((0, $0534349ae8731d0b$export$66b32f6f30eb4b4).payWithCard, paymentMethodParams);
                    break;
                case (0, $ace4c335912c9e96$export$34b52ce9cfcb0a39).Lean:
                    if (paymentMethods?.config?.lean_setup_status === Number((0, $ace4c335912c9e96$export$c35a3f1cb87c9eaa).LEAN_SETUP_STATUS_AWAITING_BENEFICIARY_COOL_OFF)) {
                        (0, $60f27fc97e29822a$export$b410431fab84fa58).info(t("payment.lean.account_is_being_connected"));
                        return;
                    }
                    if (paymentMethods?.config?.lean_setup_status === Number((0, $ace4c335912c9e96$export$c35a3f1cb87c9eaa).LEAN_SETUP_STATUS_ACTIVE)) {
                        initLeanPayment(paymentId, currentPayment?.external_id ?? null);
                        return;
                    }
                    connectLean();
                    break;
                case (0, $ace4c335912c9e96$export$34b52ce9cfcb0a39).Wire:
                    redirect((0, $0534349ae8731d0b$export$66b32f6f30eb4b4).wireTransferDetails, {
                        paymentId: String(paymentId)
                    });
                    break;
                default:
                    break;
            }
        };
        const continueText = chosenPaymentMethod === (0, $ace4c335912c9e96$export$34b52ce9cfcb0a39).Lean && !(0, $2994e7b5ba509fe3$export$b3047a41e8ba7963)(paymentMethods?.config?.lean_setup_status) ? t("payment.connect_lean_account") : t("payment.continue");
        return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)(UIComponent, {
            isLoading: getPaymentMethodsQuery.isLoading || isCurrentPaymentLoading,
            cards: cards,
            methods: methods,
            chooseSavedCard: chooseSavedCard,
            isSavedCardChosen: isSavedCardChosen,
            choosePaymentMethod: choosePaymentMethod,
            isPaymentMethodChosen: isPaymentMethodChosen,
            isAnyPaymentMethodChosen: isAnyPaymentMethodChosen(),
            isAnySavedCardChosen: isAnySavedCardChosen(),
            onPaymentMethodContinue: onPaymentMethodContinue,
            isChosenPaymentMethodLoading: isLeanPayPreparing,
            onSavedCardContinue: ()=>redirect((0, $0534349ae8731d0b$export$66b32f6f30eb4b4).payWithSavedCard, {
                    paymentId: String(paymentId),
                    cardId: String(chosenSavedCard),
                    ...paymentOptions ? {
                        paymentOptions: paymentOptions
                    } : {}
                }),
            connectLean: connectLean,
            continueText: continueText,
            leanSetupCompleted: paymentMethods?.config?.lean_setup_status === Number((0, $ace4c335912c9e96$export$c35a3f1cb87c9eaa).LEAN_SETUP_STATUS_ACTIVE),
            leanSetupStatus: paymentMethods?.config?.lean_setup_status ?? null,
            leanStatusUpdatedAt: paymentMethods?.config?.lean_status_updated_at ?? null,
            amount: `${currentPayment?.currency_code} ${currentPayment?.amount}`
        });
    }));
}












var $acw62 = parcelRequire("acw62");

var $3c35a8686c77c925$exports = {};
$3c35a8686c77c925$exports = new URL("mastercard.41a9f627.svg", import.meta.url).toString();


var $e5d060d78185dc65$exports = {};
$e5d060d78185dc65$exports = new URL("visa.98ac5347.svg", import.meta.url).toString();




var $34d172fae60b298a$exports = {};
$34d172fae60b298a$exports = new URL("arrow-right.2ac8476c.svg", import.meta.url).toString();


var $ef34c45dd1595202$exports = {};
$ef34c45dd1595202$exports = new URL("lean_2.aa74f8ad.svg", import.meta.url).toString();


var $d1521d551950aae6$exports = {};
$d1521d551950aae6$exports = new URL("lean.55e920b7.svg", import.meta.url).toString();


var $d74df0b15d97c113$exports = {};
$d74df0b15d97c113$exports = new URL("lean_transparent.f0b37b87.svg", import.meta.url).toString();







const $38e27e10e48f5a38$export$34b52ce9cfcb0a39 = ({ paymentMethod: paymentMethod, isSavedCard: isSavedCard, cardBrand: cardBrand, chooseMethod: chooseMethod, title: title, isMethodChosen: isMethodChosen, connectLean: connectLean, paymentMethodProps: paymentMethodProps })=>{
    const [leanInfoModalVisible, setLeanInfoModalVisible] = (0, $acw62.useState)(false);
    const isLeanPaymentsEnabled = (0, $2994e7b5ba509fe3$export$5798ef4f23d27f5e)();
    const { t: t } = (0, $3765cebd031b52c0$export$9fc83ad70ead8663)();
    const getLogo = ()=>{
        if (!isSavedCard) {
            if (paymentMethod === (0, $ace4c335912c9e96$export$34b52ce9cfcb0a39).Wire) return 0, (/*@__PURE__*/$parcel$interopDefault($68f8e752cefb17e0$exports));
            if (paymentMethod === (0, $ace4c335912c9e96$export$34b52ce9cfcb0a39).Lean) return 0, (/*@__PURE__*/$parcel$interopDefault($ef34c45dd1595202$exports));
            return 0, (/*@__PURE__*/$parcel$interopDefault($adb8167ba548b918$exports));
        }
        if (cardBrand === String((0, $ace4c335912c9e96$export$1e5507a06cab5709).Mastercard)) return 0, (/*@__PURE__*/$parcel$interopDefault($3c35a8686c77c925$exports));
        if (cardBrand === String((0, $ace4c335912c9e96$export$1e5507a06cab5709).Visa)) return 0, (/*@__PURE__*/$parcel$interopDefault($e5d060d78185dc65$exports));
        return 0, (/*@__PURE__*/$parcel$interopDefault($adb8167ba548b918$exports));
    };
    const getLeanStatusSettings = ()=>{
        switch(paymentMethodProps.leanSetupStatus){
            case Number((0, $ace4c335912c9e96$export$c35a3f1cb87c9eaa).LEAN_SETUP_STATUS_ACTIVE):
                return {
                    title: t("payment.lean.setup_status_active"),
                    color: "#5EAA6F"
                };
            case Number((0, $ace4c335912c9e96$export$c35a3f1cb87c9eaa).LEAN_SETUP_STATUS_AWAITING_BENEFICIARY_COOL_OFF):
                return {
                    title: t("payment.lean.setup_status_pending"),
                    color: "#FCB35C"
                };
            default:
                return {
                    title: t("payment.lean.setup_status_not_connected"),
                    color: "#9CA3AF"
                };
        }
    };
    const leanStatusSettings = getLeanStatusSettings();
    if (paymentMethod === String((0, $ace4c335912c9e96$export$34b52ce9cfcb0a39).Lean)) {
        if (!isLeanPaymentsEnabled()) return null;
        return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
            className: "PaymentMethods__method PaymentMethods__leanMethod",
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: "PaymentMethods__method__container",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: "PaymentMethods__method__body",
                            onClick: chooseMethod,
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                    className: "PaymentMethods__method__mainInfo",
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                            className: "PaymentMethods__method__content",
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                    className: "PaymentMethods__method__logoContainer",
                                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                                                        src: getLogo()
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                    className: "PaymentMethods__method__descriptionContainer",
                                                    children: [
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                            className: "PaymentMethods__method__title",
                                                            children: title
                                                        }),
                                                        Boolean(paymentMethodProps.leanSetupStatus) && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                            className: "PaymentMethods__method__leanStatusContainer",
                                                            children: [
                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                                    className: "PaymentMethods__method__leanStatus__date",
                                                                    children: (0, $810e278414a1540d$export$92521769c5df59ad)(paymentMethodProps.leanStatusUpdatedAt)
                                                                }),
                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                                    className: "HorizontalDivider"
                                                                }),
                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                                    className: "PaymentMethods__method__leanStatus__status",
                                                                    style: {
                                                                        color: leanStatusSettings.color
                                                                    },
                                                                    children: leanStatusSettings.title
                                                                })
                                                            ]
                                                        })
                                                    ]
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                            className: "PaymentMethods__methodRadio",
                                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                className: `PaymentMethods__methodRadio__filler${isMethodChosen ? "" : " hidden"}`
                                            })
                                        })
                                    ]
                                }),
                                (0, $2994e7b5ba509fe3$export$b3047a41e8ba7963)(paymentMethodProps.leanSetupStatus) && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                    className: "PaymentMethods__method__actions",
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                            className: "PaymentMethods__method__actions__button--added",
                                            children: "One Account Added"
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                            onClick: connectLean,
                                            className: "PaymentMethods__method__actions__button",
                                            children: t("payment.add_account")
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: "PaymentMethods__method__bottom",
                            onClick: ()=>setLeanInfoModalVisible(true),
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                    className: "PaymentMethods__method__bottom__left",
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                            className: "PaymentMethods__method__leanInfo",
                                            children: [
                                                t("payment.learn_more_about"),
                                                " ",
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                    className: "PaymentMethods__method__leanInfo__link",
                                                    children: t("payment.lean_payment")
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                                            src: (0, (/*@__PURE__*/$parcel$interopDefault($34d172fae60b298a$exports)))
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                    className: "PaymentMethods__method__bottom__right",
                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                                        src: (0, (/*@__PURE__*/$parcel$interopDefault($d1521d551950aae6$exports)))
                                    })
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c786671f641538e1$export$446bb0a5366f9068), {
                    modalVisible: leanInfoModalVisible,
                    onClose: ()=>setLeanInfoModalVisible(false),
                    className: "LeanInfoModal",
                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "LeanInfoModal__container",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "LeanInfoModal__body",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                        className: "LeanInfoModal__body__title-1",
                                        children: t("payment.lean_modal_title_1")
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                        className: "LeanInfoModal__body__title-2",
                                        children: t("payment.lean_modal_title_2")
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                        className: "LeanInfoModal__body__title-3",
                                        children: t("payment.lean_modal_title_3")
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $660b2ca422e0e2ae$export$1ff3c3f08ae963c0).Vertical, {
                                        height: 15
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                        className: "LeanInfoModal__body__title-3",
                                        children: t("payment.lean_modal_title_4")
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                className: "LeanInfoModal__bottom",
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                                    src: (0, (/*@__PURE__*/$parcel$interopDefault($d74df0b15d97c113$exports)))
                                })
                            })
                        ]
                    })
                })
            ]
        });
    }
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "PaymentMethods__method",
        onClick: chooseMethod,
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "PaymentMethods__method__content",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "PaymentMethods__method__logoContainer",
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                            src: getLogo()
                        })
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                        className: "PaymentMethods__method__title",
                        children: title
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "PaymentMethods__methodRadio",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                    className: `PaymentMethods__methodRadio__filler${isMethodChosen ? "" : " hidden"}`
                })
            })
        ]
    });
};




const $93d4a1e580b75514$export$ab218e41b1f3d913 = ({ isLoading: isLoading, cards: cards, methods: methods, chooseSavedCard: chooseSavedCard, isSavedCardChosen: isSavedCardChosen, choosePaymentMethod: choosePaymentMethod, isPaymentMethodChosen: isPaymentMethodChosen, isAnyPaymentMethodChosen: isAnyPaymentMethodChosen, isAnySavedCardChosen: isAnySavedCardChosen, onPaymentMethodContinue: onPaymentMethodContinue, onSavedCardContinue: onSavedCardContinue, amount: amount, isChosenPaymentMethodLoading: isChosenPaymentMethodLoading, connectLean: connectLean, continueText: continueText, leanSetupCompleted: leanSetupCompleted, leanSetupStatus: leanSetupStatus, leanStatusUpdatedAt: leanStatusUpdatedAt })=>{
    const { t: t } = (0, $3765cebd031b52c0$export$9fc83ad70ead8663)();
    const redirect = (0, $7df35e9df335b1c8$export$602eaf6d5314ce55)();
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "PaymentMethods",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7ae42b63183f30b4$export$8b251419efc915eb), {
                title: t("payment.payment_methods"),
                showBack: true,
                handleBackClick: ()=>redirect((0, $0534349ae8731d0b$export$66b32f6f30eb4b4).paymentList, {
                        paymentStatus: String((0, $ace4c335912c9e96$export$999f810846f9d31d).Pending)
                    })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $660b2ca422e0e2ae$export$1ff3c3f08ae963c0).Vertical, {
                height: 35
            }),
            isLoading ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $57fb8f45c69e1681$export$2e2bcd8739ae039), {}) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "PaymentMethods__container",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                        className: "PaymentMethods__title",
                        children: t("payment.select_payment_method")
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "PaymentMethods__methodsList",
                        children: [
                            cards.map((card)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $38e27e10e48f5a38$export$34b52ce9cfcb0a39), {
                                    paymentMethod: (0, $ace4c335912c9e96$export$34b52ce9cfcb0a39).Card,
                                    isSavedCard: true,
                                    chooseMethod: ()=>chooseSavedCard(card.id),
                                    title: `\u{2022}\u{2022}\u{2022}\u{2022} \u{2022}\u{2022}\u{2022}\u{2022} \u{2022}\u{2022}\u{2022}\u{2022} \u{2022}\u{2022}\u{2022}\u{2022} ${card.card_number_last4}`,
                                    cardBrand: card.brand,
                                    paymentMethodProps: {
                                        leanSetupCompleted: leanSetupCompleted,
                                        leanSetupStatus: leanSetupStatus,
                                        leanStatusUpdatedAt: leanStatusUpdatedAt
                                    },
                                    isMethodChosen: isSavedCardChosen(card.id)
                                }, card.id)),
                            methods.map((paymentMethod)=>{
                                const paymentMethodValue = String(paymentMethod);
                                return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $38e27e10e48f5a38$export$34b52ce9cfcb0a39), {
                                    paymentMethod: paymentMethodValue,
                                    isSavedCard: false,
                                    chooseMethod: ()=>choosePaymentMethod(paymentMethodValue),
                                    title: t((0, $810e278414a1540d$export$95dc18b5b2f97717)[paymentMethodValue].description),
                                    connectLean: connectLean,
                                    paymentMethodProps: {
                                        leanSetupCompleted: leanSetupCompleted,
                                        leanSetupStatus: leanSetupStatus,
                                        leanStatusUpdatedAt: leanStatusUpdatedAt
                                    },
                                    isMethodChosen: isPaymentMethodChosen(paymentMethodValue)
                                }, paymentMethod);
                            })
                        ]
                    }),
                    isAnyPaymentMethodChosen && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4a1895475c466679$export$c072955bb62eb0e2), {
                        style: {
                            justifyContent: "center"
                        },
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                            className: "PayButton__button",
                            disabled: isChosenPaymentMethodLoading,
                            onClick: onPaymentMethodContinue,
                            children: isChosenPaymentMethodLoading ? t("payment.loading") : continueText
                        })
                    }),
                    isAnySavedCardChosen && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4a1895475c466679$export$c072955bb62eb0e2), {
                        onClick: onSavedCardContinue,
                        style: {
                            justifyContent: "center"
                        },
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("button", {
                            className: "PayButton__button",
                            onClick: onSavedCardContinue,
                            style: {
                                background: "#7767E4"
                            },
                            children: [
                                t("payment.pay"),
                                " ",
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                    children: amount
                                })
                            ]
                        })
                    })
                ]
            })
        ]
    });
};


const $60387300b684b3b9$export$ab218e41b1f3d913 = (0, $dc51e603a684ae2a$export$807209090ace1102)((0, $93d4a1e580b75514$export$ab218e41b1f3d913));












var $45fvw = parcelRequire("45fvw");


var $acw62 = parcelRequire("acw62");




const $fa3cfe24bf0c06f3$var$months = [
    "calendar.month_january",
    "calendar.month_february",
    "calendar.month_march",
    "calendar.month_april",
    "calendar.month_may",
    "calendar.month_june",
    "calendar.month_july",
    "calendar.month_august",
    "calendar.month_september",
    "calendar.month_october",
    "calendar.month_november",
    "calendar.month_december"
];
const $fa3cfe24bf0c06f3$var$years = [];
for(let year = 2014; year <= Number((0, (/*@__PURE__*/$parcel$interopDefault($45fvw)))().format("YYYY")); year++)$fa3cfe24bf0c06f3$var$years.push({
    key: year,
    value: String(year)
});
const $fa3cfe24bf0c06f3$export$a4f5c8b89d277a8d = ({ showCalendar: showCalendar, setShowCalendar: setShowCalendar, chosenDateRange: chosenDateRange, setChosenDateRange: setChosenDateRange, onSubmit: onSubmit })=>{
    const { t: t } = (0, $3765cebd031b52c0$export$9fc83ad70ead8663)();
    const [chosenMonth, setChosenMonth] = (0, $acw62.useState)(Number((0, (/*@__PURE__*/$parcel$interopDefault($45fvw)))().format("MM")) - 1);
    const [chosenYear, setChosenYear] = (0, $acw62.useState)(Number((0, (/*@__PURE__*/$parcel$interopDefault($45fvw)))().format("YYYY")));
    const [chosenDate, setChosenDate] = (0, $acw62.useState)(new Date());
    (0, $acw62.useEffect)(()=>{
        setChosenDate(new Date(chosenYear, chosenMonth));
    }, [
        chosenMonth,
        chosenYear
    ]);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $c786671f641538e1$export$446bb0a5366f9068), {
        className: "RangerCalendarModal",
        modalVisible: showCalendar,
        onClose: ()=>setShowCalendar(false),
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "Calendar__topActions",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f2c1b8699595d8c0$export$ef9b1a59e592288f), {
                        label: t("calendar.month"),
                        className: "Calendar__topActions__monthSelector",
                        value: chosenMonth,
                        onChange: (value)=>{
                            setChosenMonth(value);
                        },
                        options: $fa3cfe24bf0c06f3$var$months.map((month, index)=>{
                            return {
                                key: String(index),
                                label: t(month),
                                value: index
                            };
                        })
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f2c1b8699595d8c0$export$ef9b1a59e592288f), {
                        label: t("calendar.year"),
                        value: chosenYear,
                        onChange: (value)=>{
                            setChosenYear(value);
                        },
                        options: $fa3cfe24bf0c06f3$var$years.map((year)=>{
                            return {
                                key: String(year.key),
                                label: year.value,
                                value: Number(year.key)
                            };
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5304fe6d5e1a96df$export$2e2bcd8739ae039), {
                activeStartDate: chosenDate,
                onChange: (value)=>{
                    setChosenDateRange([
                        value[0],
                        value[1]
                    ]);
                },
                showNavigation: false,
                showNeighboringMonth: false,
                value: chosenDateRange,
                selectRange: true
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "Calendar__bottomActions",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                        className: "Calendar__cancelButton",
                        onClick: ()=>setShowCalendar(false),
                        children: t("calendar.cancel")
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                        className: "Calendar__setButton",
                        onClick: onSubmit,
                        children: t("calendar.set")
                    })
                ]
            })
        ]
    });
};




var $45fvw = parcelRequire("45fvw");

var $cb1cf7a210b20622$exports = {};
$cb1cf7a210b20622$exports = new URL("calendar-icon.1f6716b0.svg", import.meta.url).toString();


var $c3df0c2e372365e4$exports = {};
$c3df0c2e372365e4$exports = new URL("download-icon.a92ae2ec.svg", import.meta.url).toString();


const $9540f247d6b17e69$export$6566280bbbbc5353 = ({ isLoading: isLoading, setShowCalendar: setShowCalendar, dateFrom: dateFrom, dateTo: dateTo, startBalance: startBalance, endBalance: endBalance, isDownloadingAccountStatement: isDownloadingAccountStatement, downloadAccountStatement: downloadAccountStatement })=>{
    const { t: t } = (0, $3765cebd031b52c0$export$9fc83ad70ead8663)();
    if (isLoading) return null;
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "AccountStatement__HeaderBottom",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "AccountStatement__HeaderBottom__top",
                onClick: ()=>setShowCalendar(true),
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                        className: "AccountStatement__HeaderBottom__datesTitle",
                        children: [
                            t("account_statement.from"),
                            " ",
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                children: (0, (/*@__PURE__*/$parcel$interopDefault($45fvw)))(dateFrom).format("MMM DD")
                            }),
                            " ",
                            t("account_statement.to"),
                            " ",
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                children: (0, (/*@__PURE__*/$parcel$interopDefault($45fvw)))(dateTo).format("MMM DD")
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                        src: (0, (/*@__PURE__*/$parcel$interopDefault($cb1cf7a210b20622$exports)))
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "AccountStatement__HeaderBottom__bottom",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                        className: "AccountStatement__HeaderBottom__amountsTitle",
                        children: [
                            t("account_statement.starts_from"),
                            " ",
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("strong", {
                                children: [
                                    t("account_statement.currency"),
                                    " ",
                                    startBalance
                                ]
                            }),
                            " ",
                            t("account_statement.to"),
                            " ",
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("strong", {
                                children: [
                                    t("account_statement.currency"),
                                    " ",
                                    endBalance
                                ]
                            })
                        ]
                    }),
                    isDownloadingAccountStatement ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                        className: "AccountStatement__HeaderBottom__download__title",
                        children: t("account_statement.downloading")
                    }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "AccountStatement__HeaderBottom__download",
                        onClick: downloadAccountStatement,
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                                src: (0, (/*@__PURE__*/$parcel$interopDefault($c3df0c2e372365e4$exports)))
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                className: "AccountStatement__HeaderBottom__download__title",
                                children: t("account_statement.download")
                            })
                        ]
                    })
                ]
            })
        ]
    });
};




var $acw62 = parcelRequire("acw62");


var $45fvw = parcelRequire("45fvw");
var $8a5d9eb235802c8b$exports = {};
$8a5d9eb235802c8b$exports = new URL("invoice-icon.dbd1f748.svg", import.meta.url).toString();


var $e0fb6b7ea22f0806$exports = {};
$e0fb6b7ea22f0806$exports = new URL("refund-icon.6694da4d.svg", import.meta.url).toString();




function $5231f10c702a6c95$export$cd85898ed19a7eb4(item) {
    if (item.type === (0, $879d9c16c27ed178$export$ac0e44b2a93b443).Invoice) return "INV";
    return "CN";
}




const $a2af41f754358bf6$export$d9369ffb939fccdd = ({ statementItem: statementItem, onStatementItemClick: onStatementItemClick })=>{
    const { t: t } = (0, $3765cebd031b52c0$export$9fc83ad70ead8663)();
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        className: "AccountStatement__invoice",
        onClick: ()=>onStatementItemClick(statementItem.id),
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
            className: "AccountStatement__invoice__content",
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                    className: "AccountStatement__invoice__content__left",
                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                        src: statementItem.type === "invoice" ? (0, (/*@__PURE__*/$parcel$interopDefault($8a5d9eb235802c8b$exports))) : (0, (/*@__PURE__*/$parcel$interopDefault($e0fb6b7ea22f0806$exports)))
                    })
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: "AccountStatement__invoice__content__right",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: "AccountStatement__invoice__content__titles",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                    className: "AccountStatement__invoice__content__title",
                                    children: [
                                        (0, $5231f10c702a6c95$export$cd85898ed19a7eb4)(statementItem),
                                        "-",
                                        statementItem.id
                                    ]
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                    className: "AccountStatement__invoice__content__title",
                                    children: [
                                        statementItem.currency_code,
                                        " ",
                                        statementItem.amount
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: "AccountStatement__invoice__content__details",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                    className: "AccountStatement__invoice__content__detailsItem",
                                    children: (0, (/*@__PURE__*/$parcel$interopDefault($45fvw)))(statementItem.due_date).format("MMM DD, YYYY")
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                    className: "AccountStatement__invoice__content__detailsItem",
                                    children: "."
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                    className: "AccountStatement__invoice__content__detailsItem",
                                    children: statementItem.type === (0, $879d9c16c27ed178$export$ac0e44b2a93b443).Invoice ? t("account_statement.invoice") : t("account_statement.credit_note")
                                }),
                                statementItem.type === (0, $879d9c16c27ed178$export$ac0e44b2a93b443).Invoice && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $acw62.Fragment), {
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                            className: "AccountStatement__invoice__content__detailsItem",
                                            children: "."
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                            className: "AccountStatement__invoice__content__detailsItem",
                                            style: (0, $810e278414a1540d$export$cf24e9559eb569c7)(statementItem),
                                            children: (0, $a8b6e1b9cac4434c$export$6fdbeaa08f63a468)(statementItem, t)
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                })
            ]
        })
    }, statementItem.id);
};


const $67bfe18d39b12376$export$c4014f3abd65f9d7 = (0, $aca50e9407ba89c9$export$b6ae1bc530f4c149)(({ isLoading: isLoading, showCalendar: showCalendar, setShowCalendar: setShowCalendar, dateFrom: dateFrom, dateTo: dateTo, startBalance: startBalance, endBalance: endBalance, isDownloadingAccountStatement: isDownloadingAccountStatement, downloadAccountStatement: downloadAccountStatement, chosenDateRange: chosenDateRange, setChosenDateRange: setChosenDateRange, onSubmitDates: onSubmitDates, statementItems: statementItems, onStatementItemClick: onStatementItemClick })=>{
    const { t: t } = (0, $3765cebd031b52c0$export$9fc83ad70ead8663)();
    if (isLoading) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $57fb8f45c69e1681$export$2e2bcd8739ae039), {});
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "AccountStatement",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $fa3cfe24bf0c06f3$export$a4f5c8b89d277a8d), {
                showCalendar: showCalendar,
                setShowCalendar: setShowCalendar,
                chosenDateRange: chosenDateRange,
                setChosenDateRange: setChosenDateRange,
                onSubmit: onSubmitDates
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7ae42b63183f30b4$export$8b251419efc915eb), {
                title: t("account_statement.account_statement"),
                bottomComponent: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $9540f247d6b17e69$export$6566280bbbbc5353), {
                    isLoading: isLoading,
                    setShowCalendar: setShowCalendar,
                    dateFrom: dateFrom,
                    dateTo: dateTo,
                    startBalance: startBalance,
                    endBalance: endBalance,
                    isDownloadingAccountStatement: isDownloadingAccountStatement,
                    downloadAccountStatement: downloadAccountStatement
                }),
                desktopContainerStyle: {
                    height: "130px"
                },
                mobileContainerStyle: {
                    height: "130px"
                }
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $660b2ca422e0e2ae$export$1ff3c3f08ae963c0).Vertical, {
                height: 100
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "AccountStatement__container",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "AccountStatement__activitiesTitle",
                        children: t("account_statement.recent_activities")
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "AccountStatement__activitiesContainer",
                        children: statementItems.length > 0 ? statementItems.map((item)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $a2af41f754358bf6$export$d9369ffb939fccdd), {
                                statementItem: item,
                                onStatementItemClick: onStatementItemClick
                            }, item.id)) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                            className: "AccountStatement__emptyList",
                            children: t("account_statement.empty_list")
                        })
                    })
                ]
            })
        ]
    });
});




var $acw62 = parcelRequire("acw62");



var $45fvw = parcelRequire("45fvw");





function $5c3eb6c54e13f2e7$export$55acaccd48b6a77d(UIComponent) {
    return (0, $a4963babae245ff9$export$f0c7a449e0cfaec7)((0, $aca50e9407ba89c9$export$b6ae1bc530f4c149)(()=>{
        const { loadAccountStatement: loadAccountStatement, downloadAccountStatementFile: downloadAccountStatementFile, statementItems: statementItems, startBalance: startBalance, endBalance: endBalance, dateFrom: dateFrom, dateTo: dateTo, setDateFrom: setDateFrom, setDateTo: setDateTo } = (0, $4671947198ddd366$export$6ccbb43953eebf8)().data;
        const redirect = (0, $7df35e9df335b1c8$export$602eaf6d5314ce55)();
        const [showCalendar, setShowCalendar] = (0, $acw62.useState)(false);
        const [chosenDateRange, setChosenDateRange] = (0, $acw62.useState)([
            new Date(String(dateFrom)),
            new Date(String(dateTo))
        ]);
        const loadAccountStatementQuery = (0, $4671947198ddd366$export$dd0a697e1782aedd)(()=>loadAccountStatement());
        const { enableQuery: loadAccountStatementDelayedQuery, query: loadAccountStatementDelayedResult } = (0, $4671947198ddd366$export$517ca4f7fee4e226)(()=>loadAccountStatement());
        const { download: saveFile } = (0, $8aadbb076e78b446$export$fdb90e0242959057)();
        const { enableQuery: downloadAccountStatementQuery, query: downloadAccountStatementResult } = (0, $4671947198ddd366$export$517ca4f7fee4e226)(()=>downloadAccountStatementFile(), {
            onSuccess: (file)=>{
                saveFile(file, `account_statement.csv`);
            }
        });
        const setDateFilters = (value)=>{
            const dateFromString = (0, (/*@__PURE__*/$parcel$interopDefault($45fvw)))(value[0]).format("YYYY-MM-DD");
            const dateToString = (0, (/*@__PURE__*/$parcel$interopDefault($45fvw)))(value[1]).format("YYYY-MM-DD");
            setDateFrom(dateFromString);
            setDateTo(dateToString);
        };
        const onSubmitDates = ()=>{
            setDateFilters(chosenDateRange);
            setShowCalendar(false);
            loadAccountStatementDelayedQuery();
        };
        return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)(UIComponent, {
            isLoading: loadAccountStatementQuery.isLoading || loadAccountStatementDelayedResult.isLoading,
            showCalendar: showCalendar,
            setShowCalendar: setShowCalendar,
            dateFrom: dateFrom,
            dateTo: dateTo,
            startBalance: startBalance,
            endBalance: endBalance,
            isDownloadingAccountStatement: downloadAccountStatementResult.isLoading,
            downloadAccountStatement: downloadAccountStatementQuery,
            chosenDateRange: chosenDateRange,
            setChosenDateRange: setChosenDateRange,
            onSubmitDates: onSubmitDates,
            statementItems: statementItems,
            onStatementItemClick: (value)=>redirect((0, $0534349ae8731d0b$export$66b32f6f30eb4b4).invoice, {
                    id: String(value)
                })
        });
    }));
}


const $8a75f1e587809f9d$export$c4014f3abd65f9d7 = (0, $5c3eb6c54e13f2e7$export$55acaccd48b6a77d)((0, $67bfe18d39b12376$export$c4014f3abd65f9d7));














const $5428ea062f1253bb$export$2cdf1b96a9f86d16 = (text, successText)=>{
    navigator.clipboard.writeText(text);
    (0, $60f27fc97e29822a$export$b410431fab84fa58).info(successText, {
        position: "bottom-center",
        autoClose: 1000,
        theme: "dark",
        hideProgressBar: true,
        pauseOnHover: false,
        pauseOnFocusLoss: false,
        closeButton: false
    });
};








const $1286caac98d25de7$export$4bc3d6b85fffdd7c = (0, $a4963babae245ff9$export$f0c7a449e0cfaec7)((0, $aca50e9407ba89c9$export$b6ae1bc530f4c149)(({ paymentId: paymentId })=>{
    const { paymentIntent: paymentIntent } = (0, $0e6cd841cc250b52$export$dd09e5139f9499ad)(paymentId, (0, $ace4c335912c9e96$export$34b52ce9cfcb0a39).Wire);
    const { t: t } = (0, $3765cebd031b52c0$export$9fc83ad70ead8663)();
    if (!paymentIntent) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $57fb8f45c69e1681$export$2e2bcd8739ae039), {});
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "BankAccountDetails__title-container",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                        src: (0, (/*@__PURE__*/$parcel$interopDefault($06a690742071017e$exports)))
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                        children: t("payment.wire_transfer_details")
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "BankAccountDetails__values",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "BankAccountDetails__values__valueContainer",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                className: "BankAccountDetails__values__valueContainer__key",
                                children: t("payment.wire_transfer_amount")
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                className: "BankAccountDetails__values__valueContainer__value",
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("strong", {
                                    children: [
                                        paymentIntent.currency_code,
                                        " ",
                                        paymentIntent.amount
                                    ]
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "BankAccountDetails__values__valueContainer",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                className: "BankAccountDetails__values__valueContainer__key",
                                children: t("payment.wire_transfer_bank_account_name")
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "BankAccountDetails__values__valueContainer__valueBox",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                        className: "BankAccountDetails__values__valueContainer__value",
                                        children: paymentIntent.meta.bank_account_name
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                                        onClick: ()=>(0, $5428ea062f1253bb$export$2cdf1b96a9f86d16)(String(paymentIntent.meta.bank_account_name), t("payment.text_copied")),
                                        className: "BankAccountDetails__values__valueContainer__value__icon",
                                        src: (0, (/*@__PURE__*/$parcel$interopDefault($1792fb439084b800$exports)))
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "BankAccountDetails__values__valueContainer",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                className: "BankAccountDetails__values__valueContainer__key",
                                children: t("payment.wire_transfer_bank_account_bank_name")
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "BankAccountDetails__values__valueContainer__valueBox",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                        className: "BankAccountDetails__values__valueContainer__value",
                                        children: paymentIntent.meta.bank_account_bank_name
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                                        onClick: ()=>(0, $5428ea062f1253bb$export$2cdf1b96a9f86d16)(String(paymentIntent.meta.bank_account_bank_name), t("payment.text_copied")),
                                        className: "BankAccountDetails__values__valueContainer__value__icon",
                                        src: (0, (/*@__PURE__*/$parcel$interopDefault($1792fb439084b800$exports)))
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "BankAccountDetails__values__valueContainer",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                className: "BankAccountDetails__values__valueContainer__key",
                                children: t("payment.wire_transfer_bank_account_number")
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "BankAccountDetails__values__valueContainer__valueBox",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                        className: "BankAccountDetails__values__valueContainer__value",
                                        children: paymentIntent.meta.bank_account_number
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                                        onClick: ()=>(0, $5428ea062f1253bb$export$2cdf1b96a9f86d16)(String(paymentIntent.meta.bank_account_number), t("payment.text_copied")),
                                        className: "BankAccountDetails__values__valueContainer__value__icon",
                                        src: (0, (/*@__PURE__*/$parcel$interopDefault($1792fb439084b800$exports)))
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "BankAccountDetails__values__valueContainer",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                className: "BankAccountDetails__values__valueContainer__key",
                                children: t("payment.wire_transfer_bank_account_iban")
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "BankAccountDetails__values__valueContainer__valueBox",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                        className: "BankAccountDetails__values__valueContainer__value",
                                        children: paymentIntent.meta.bank_account_iban
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                                        onClick: ()=>(0, $5428ea062f1253bb$export$2cdf1b96a9f86d16)(String(paymentIntent.meta.bank_account_iban), t("payment.text_copied")),
                                        className: "BankAccountDetails__values__valueContainer__value__icon",
                                        src: (0, (/*@__PURE__*/$parcel$interopDefault($1792fb439084b800$exports)))
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "BankAccountDetails__values__valueContainer",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                className: "BankAccountDetails__values__valueContainer__key",
                                children: t("payment.wire_transfer_bank_account_bank_address")
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "BankAccountDetails__values__valueContainer__valueBox",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                        className: "BankAccountDetails__values__valueContainer__value",
                                        children: paymentIntent.meta.bank_account_bank_address
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                                        onClick: ()=>(0, $5428ea062f1253bb$export$2cdf1b96a9f86d16)(String(paymentIntent.meta.bank_account_bank_address), t("payment.text_copied")),
                                        className: "BankAccountDetails__values__valueContainer__value__icon",
                                        src: (0, (/*@__PURE__*/$parcel$interopDefault($1792fb439084b800$exports)))
                                    })
                                ]
                            })
                        ]
                    })
                ]
            })
        ]
    });
}));



const $5a0f903662368f3a$export$847a80e3529d33bd = ({ paymentId: paymentId })=>{
    const redirect = (0, $7df35e9df335b1c8$export$602eaf6d5314ce55)();
    const { t: t } = (0, $3765cebd031b52c0$export$9fc83ad70ead8663)();
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "WireTransferDetails",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7ae42b63183f30b4$export$8b251419efc915eb), {
                title: t("payment.checkout"),
                showBack: true
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $660b2ca422e0e2ae$export$1ff3c3f08ae963c0).Vertical, {
                height: 35
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "WireTransferDetails__container",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $1286caac98d25de7$export$4bc3d6b85fffdd7c), {
                        paymentId: paymentId
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7a26230deaaf6920$export$944fe0ec49485b21), {
                        theme: (0, $7a26230deaaf6920$export$14faa19a0f3bbeb2).Blue,
                        withCloseButton: true,
                        title: t("payment.wire_transfer_upload_alert_text"),
                        action: ()=>{},
                        isActionInProgress: false
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $02b5ce5939ae68c3$export$af06bded58f8b363), {
                        onClick: ()=>{
                            redirect((0, $0534349ae8731d0b$export$66b32f6f30eb4b4).wireTransferUploadSlip, {
                                paymentId: String(paymentId)
                            });
                        },
                        buttonTitle: t("payment.continue")
                    })
                ]
            })
        ]
    });
};




var $acw62 = parcelRequire("acw62");








function $7e6f53fd05b0e7bb$export$5c83d9a5399c83cd(UIComponent) {
    return (0, $a4963babae245ff9$export$f0c7a449e0cfaec7)((0, $aca50e9407ba89c9$export$b6ae1bc530f4c149)(({ paymentId: paymentId })=>{
        const { processPayment: processPayment, resetPayment: resetPayment } = (0, $4671947198ddd366$export$6ccbb43953eebf8)().data;
        const [slipFile, setSlipFile] = (0, $acw62.useState)(null);
        const redirect = (0, $7df35e9df335b1c8$export$602eaf6d5314ce55)();
        const { t: t } = (0, $3765cebd031b52c0$export$9fc83ad70ead8663)();
        const { enableQuery: resetPaymentQuery } = (0, $4671947198ddd366$export$517ca4f7fee4e226)(()=>resetPayment(paymentId), {
            onSuccess: (result)=>{
                (0, $60f27fc97e29822a$export$b410431fab84fa58).success(t("payment.wire_transfer_has_been_canceled"));
                redirect((0, $0534349ae8731d0b$export$66b32f6f30eb4b4).paymentMethodsList, {
                    paymentId: String(paymentId)
                });
            }
        });
        const [processPaymentResult, processPaymentRequest] = (0, $4671947198ddd366$export$609860bf8b0084c)(({ file: file })=>processPayment(paymentId, file), {
            onSuccess: (result)=>{
                (0, $60f27fc97e29822a$export$b410431fab84fa58).success(t("payment.wire_transfer_slip_was_uploaded"));
                redirect((0, $0534349ae8731d0b$export$66b32f6f30eb4b4).paymentDetails, {
                    paymentId: String(paymentId),
                    hideBack: 1
                });
            },
            onError: (err)=>{
                const errorMessage = err.data.message;
                const errors = err.data.errors?.slip ?? [];
                const errorText = errors.length > 0 ? errors.join(";") : errorMessage;
                (0, $60f27fc97e29822a$export$b410431fab84fa58).error(errorText);
            },
            filterError: [
                (0, $9ad33fbf770c55a1$export$9696fcf1798e1cb5).ClientError
            ]
        });
        return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)(UIComponent, {
            paymentId: paymentId,
            slipFile: slipFile,
            setSlipFile: setSlipFile,
            resetPaymentQuery: resetPaymentQuery,
            isPaymentProcessing: processPaymentResult.isLoading,
            processPaymentRequest: ()=>{
                if (slipFile) processPaymentRequest({
                    file: slipFile
                });
            },
            onRemindLater: ()=>redirect((0, $0534349ae8731d0b$export$66b32f6f30eb4b4).paymentDetails, {
                    paymentId: String(paymentId),
                    hideBack: 1
                })
        });
    }));
}




var $acw62 = parcelRequire("acw62");






const $4398c63b70e6119a$export$f7d3dfddaa60e71a = ({ paymentId: paymentId, slipFile: slipFile, setSlipFile: setSlipFile, resetPaymentQuery: resetPaymentQuery, isPaymentProcessing: isPaymentProcessing, processPaymentRequest: processPaymentRequest, onRemindLater: onRemindLater })=>{
    const { t: t } = (0, $3765cebd031b52c0$export$9fc83ad70ead8663)();
    const SlipFileInputRef = (0, $acw62.useRef)(null);
    const onSetFile = (event)=>{
        const file = event.target.files?.[0];
        if (!file) return;
        setSlipFile(file);
    };
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "WireTransferUploadSlip",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7ae42b63183f30b4$export$8b251419efc915eb), {
                title: t("payment.payment_details_title", {
                    paymentId: paymentId
                }),
                showBack: true
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $660b2ca422e0e2ae$export$1ff3c3f08ae963c0).Vertical, {
                height: 35
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "WireTransferUploadSlip__container",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "WireTransferUploadSlip__alert",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                className: "WireTransferUploadSlip__alert__title",
                                children: t("payment.please_upload_slip")
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "WireTransferUploadSlip__alert__info",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $441e5c91ae5e6f63$export$2957fc44b3d2481), {
                                        color: "#FCB35C"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                        className: "WireTransferUploadSlip__alert__info__text",
                                        children: t("payment.bank_slip_info_in_alert")
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "WireTransferUploadSlip__uploadContainer",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                className: "WireTransferUploadSlip__uploadContainer__title",
                                children: t("payment.payment_slip")
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                onClick: ()=>SlipFileInputRef.current?.click(),
                                className: "WireTransferUploadSlip__uploadContainer__uploadButton",
                                children: !slipFile ? t("payment.upload_payment_slip") : t("payment.document_selected")
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                type: "file",
                                style: {
                                    display: "none"
                                },
                                ref: SlipFileInputRef,
                                onChange: onSetFile
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "WireTransferUploadSlip__uploadContainer__info",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                        className: "WireTransferUploadSlip__uploadContainer__info__part",
                                        children: t("payment.you_can_upload_slip_now_or_later")
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                        className: "WireTransferUploadSlip__uploadContainer__info__part",
                                        children: t("payment.you_can_select_another_payment_method")
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                onClick: resetPaymentQuery,
                                className: "WireTransferUploadSlip__uploadContainer__cancel",
                                children: t("payment.wire_transfer_cancel_button")
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                className: "WireTransferUploadSlip__bankContainer",
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $1286caac98d25de7$export$4bc3d6b85fffdd7c), {
                                    paymentId: paymentId
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $4a1895475c466679$export$c072955bb62eb0e2), {
                        onClick: ()=>{},
                        style: {
                            justifyContent: "center"
                        },
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                className: "WireTransferUploadSlip__secondaryButton",
                                onClick: onRemindLater,
                                children: t("payment.wire_transfer_remind_later_button")
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                disabled: !slipFile,
                                className: `WireTransferUploadSlip__primaryButton${!slipFile ? " WireTransferUploadSlip__primaryButton--disabled" : ""}`,
                                onClick: ()=>{
                                    if (!slipFile) return;
                                    processPaymentRequest();
                                },
                                children: isPaymentProcessing ? t("payment.wire_transfer_slip_uploading") : t("payment.wire_transfer_i_have_sent_money")
                            })
                        ]
                    })
                ]
            })
        ]
    });
};


const $0719e6fc2a05743f$export$f7d3dfddaa60e71a = (0, $7e6f53fd05b0e7bb$export$5c83d9a5399c83cd)((0, $4398c63b70e6119a$export$f7d3dfddaa60e71a));


const $f4677e926ce5a4db$export$bbb4a7d66325aef1 = {
    WireTransferDetailsPage: (0, $5a0f903662368f3a$export$847a80e3529d33bd),
    WireTransferUploadSlipPage: (0, $0719e6fc2a05743f$export$f7d3dfddaa60e71a)
};












var $f301c8204463871a$exports = {};
$f301c8204463871a$exports = new URL("new-card.eda141b5.svg", import.meta.url).toString();


var $1f2a58c582ca99c6$exports = {};
$1f2a58c582ca99c6$exports = new URL("mastercard.41a9f627.svg", import.meta.url).toString();


var $52ab0e9e65ae447a$exports = {};
$52ab0e9e65ae447a$exports = new URL("visa.98ac5347.svg", import.meta.url).toString();



var $8e77f1bd2e8f6b06$exports = {};
$8e77f1bd2e8f6b06$exports = new URL("dots.5a3ecda8.svg", import.meta.url).toString();


var $64b3330d7482cb49$exports = {};
$64b3330d7482cb49$exports = new URL("remove.e0f7e1e8.svg", import.meta.url).toString();


const $1673da6988a7d158$export$34b52ce9cfcb0a39 = ({ cardBrand: cardBrand, title: title, deleteMethod: deleteMethod })=>{
    const { t: t } = (0, $3765cebd031b52c0$export$9fc83ad70ead8663)();
    const getLogo = ()=>{
        if (cardBrand === String((0, $ace4c335912c9e96$export$1e5507a06cab5709).Mastercard)) return 0, (/*@__PURE__*/$parcel$interopDefault($1f2a58c582ca99c6$exports));
        if (cardBrand === String((0, $ace4c335912c9e96$export$1e5507a06cab5709).Visa)) return 0, (/*@__PURE__*/$parcel$interopDefault($52ab0e9e65ae447a$exports));
        return 0, (/*@__PURE__*/$parcel$interopDefault($f301c8204463871a$exports));
    };
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "SavedPaymentMethods__method",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "SavedPaymentMethods__method__content",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "SavedPaymentMethods__method__logoContainer",
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                            src: getLogo()
                        })
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                        className: "SavedPaymentMethods__method__title",
                        children: title
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $04012d5b0475752e$export$e44a253a59704894), {
                outerComponent: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                    src: (0, (/*@__PURE__*/$parcel$interopDefault($8e77f1bd2e8f6b06$exports)))
                }),
                items: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "SavedPaymentMethods__method__remove",
                        onClick: deleteMethod,
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                                src: (0, (/*@__PURE__*/$parcel$interopDefault($64b3330d7482cb49$exports)))
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                className: "SavedPaymentMethods__method__remove-title",
                                children: t("saved_payment_methods.remove_payment_method")
                            })
                        ]
                    }, "remove")
                ]
            })
        ]
    });
};






const $0d303743695999b6$export$ecef7aea31f2a02e = (0, $aca50e9407ba89c9$export$b6ae1bc530f4c149)(()=>{
    const { getSavedCards: getSavedCards, savedCards: savedCards, deleteSavedCard: deleteSavedCard } = (0, $4671947198ddd366$export$6ccbb43953eebf8)().data;
    const { t: t } = (0, $3765cebd031b52c0$export$9fc83ad70ead8663)();
    const { isLoading: isSavedCardsLoading } = (0, $4671947198ddd366$export$dd0a697e1782aedd)(getSavedCards);
    const [, deleteSavedCardRequest] = (0, $4671947198ddd366$export$609860bf8b0084c)(({ cardId: cardId })=>deleteSavedCard(cardId));
    const onCardDelete = (cardId)=>{
        (0, $60f27fc97e29822a$export$b410431fab84fa58).success(t("saved_payment_methods.method_has_been_deleted"));
        deleteSavedCardRequest({
            cardId: cardId
        });
    };
    const redirect = (0, $7df35e9df335b1c8$export$602eaf6d5314ce55)();
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "SavedPaymentMethods",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7ae42b63183f30b4$export$8b251419efc915eb), {
                title: t("saved_payment_methods.payment_methods"),
                showBack: true
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $660b2ca422e0e2ae$export$1ff3c3f08ae963c0).Vertical, {
                height: 35
            }),
            isSavedCardsLoading ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $57fb8f45c69e1681$export$2e2bcd8739ae039), {}) : savedCards.length > 0 ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "SavedPaymentMethods__container",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                    className: "SavedPaymentMethods__methodsList",
                    children: savedCards.map((savedCard)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $1673da6988a7d158$export$34b52ce9cfcb0a39), {
                            deleteMethod: ()=>onCardDelete(savedCard.id),
                            cardBrand: savedCard.brand,
                            title: `\u{2022}\u{2022}\u{2022}\u{2022} \u{2022}\u{2022}\u{2022}\u{2022} \u{2022}\u{2022}\u{2022}\u{2022} \u{2022}\u{2022}\u{2022}\u{2022} ${savedCard.card_number_last4}`
                        }, savedCard.id))
                })
            }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                className: "SavedPaymentMethods__emptyList",
                children: t("saved_payment_methods.no_payment_methods_added")
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4a1895475c466679$export$c072955bb62eb0e2), {
                style: {
                    justifyContent: "center"
                },
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                    className: "PayButton__button",
                    onClick: ()=>{
                        redirect((0, $0534349ae8731d0b$export$66b32f6f30eb4b4).saveCard, {});
                    },
                    children: t("saved_payment_methods.add_new_card")
                })
            })
        ]
    });
});






var $acw62 = parcelRequire("acw62");








var $acw62 = parcelRequire("acw62");





const $5ef58bd041a94df1$export$58677a75c1e269ed = (0, $aca50e9407ba89c9$export$b6ae1bc530f4c149)(()=>{
    const [isPaymentFormLoaded, setIsPaymentFormLoaded] = (0, $acw62.useState)(false);
    const [isSavingProcessing, setIsSavingProcessing] = (0, $acw62.useState)(false);
    const redirect = (0, $7df35e9df335b1c8$export$602eaf6d5314ce55)();
    const { t: t } = (0, $3765cebd031b52c0$export$9fc83ad70ead8663)();
    const stripe = (0, $7bf3b98cbc00db03$exports.useStripe)();
    const elements = (0, $7bf3b98cbc00db03$exports.useElements)();
    const handleSubmit = async ()=>{
        if (!stripe || !elements) return;
        setIsSavingProcessing(true);
        const result = await stripe.confirmSetup({
            elements: elements,
            redirect: "if_required"
        });
        if (result.error) (0, $60f27fc97e29822a$export$b410431fab84fa58).error(result.error.message);
        else {
            redirect((0, $0534349ae8731d0b$export$66b32f6f30eb4b4).savedPaymentMethods, {});
            (0, $60f27fc97e29822a$export$b410431fab84fa58).success(t("saved_payment_methods.method_has_been_added"));
        }
        setIsSavingProcessing(false);
    };
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "SaveCardForm",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "SaveCardForm__form",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7bf3b98cbc00db03$exports.PaymentElement), {
                        options: {
                            wallets: {
                                applePay: "never",
                                googlePay: "never"
                            }
                        },
                        onReady: (event)=>{
                            setIsPaymentFormLoaded(true);
                        }
                    }),
                    isPaymentFormLoaded && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "StripeForm__securityMessage",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                                src: (0, (/*@__PURE__*/$parcel$interopDefault($a0fe969fd5d413f1$exports)))
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                className: "StripeForm__securityMessage__text",
                                children: t("payment.all_transactions_are_secured")
                            })
                        ]
                    })
                ]
            }),
            isPaymentFormLoaded && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4a1895475c466679$export$c072955bb62eb0e2), {
                style: {
                    justifyContent: "center"
                },
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                    className: "PayButton__button",
                    onClick: ()=>{
                        handleSubmit();
                    },
                    disabled: isSavingProcessing,
                    children: !isSavingProcessing ? t("saved_payment_methods.save_card") : t("saved_payment_methods.saving_progress")
                })
            }),
            (!isPaymentFormLoaded || !elements || !stripe) && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $57fb8f45c69e1681$export$2e2bcd8739ae039), {})
        ]
    });
});






const $75df0970a1cbed02$export$511d4325885f3c6d = (0, $aca50e9407ba89c9$export$b6ae1bc530f4c149)(()=>{
    const { initSetupIntent: initSetupIntent } = (0, $4671947198ddd366$export$6ccbb43953eebf8)().data;
    const [clientSecret, setClientSecret] = (0, $acw62.useState)(null);
    const { t: t } = (0, $3765cebd031b52c0$export$9fc83ad70ead8663)();
    (0, $4671947198ddd366$export$dd0a697e1782aedd)(initSetupIntent, {
        onSuccess: (result)=>{
            setClientSecret(result.client_secret);
        }
    });
    if (!clientSecret) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $57fb8f45c69e1681$export$2e2bcd8739ae039), {});
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "SaveCardPage",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7ae42b63183f30b4$export$8b251419efc915eb), {
                title: t("saved_payment_methods.save_card"),
                showBack: true
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $660b2ca422e0e2ae$export$1ff3c3f08ae963c0).Vertical, {
                height: 35
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "SaveCardPage__container",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7bf3b98cbc00db03$exports.Elements), {
                    stripe: (0, $0e6cd841cc250b52$export$559f48a7f7271adf)(),
                    options: {
                        clientSecret: clientSecret
                    },
                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5ef58bd041a94df1$export$58677a75c1e269ed), {})
                })
            })
        ]
    });
});


const $14cad85e17fb050f$export$21aa143883c5cf14 = {
    PaymentListPage: $796005e3ba80072e$export$7c54d215048ac783,
    StripePaymentStack: $c924ab59c2541172$export$fc8cea4daeae7879,
    PaymentDetailsPage: $d46dfe922f74a186$export$b1bd3336d32d1d33,
    PaymentMethodsPage: $60387300b684b3b9$export$ab218e41b1f3d913,
    AccountStatementPage: $8a75f1e587809f9d$export$c4014f3abd65f9d7,
    WireTransferStack: $f4677e926ce5a4db$export$bbb4a7d66325aef1,
    SavedPaymentMethodsPage: $0d303743695999b6$export$ecef7aea31f2a02e,
    SaveCardPage: $75df0970a1cbed02$export$511d4325885f3c6d
};




var $acw62 = parcelRequire("acw62");






var $acw62 = parcelRequire("acw62");





var $aa04401d7734852c$exports = {};
$aa04401d7734852c$exports = new URL("clip.ab04fb6c.svg", import.meta.url).toString();


var $42b4b079ae342c67$exports = {};
$42b4b079ae342c67$exports = new URL("squares.4dc6b6bb.svg", import.meta.url).toString();



const $2865a45335de4409$export$16547d3e2618134e = ({ link: link })=>{
    const { t: t } = (0, $3765cebd031b52c0$export$9fc83ad70ead8663)();
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "InviteReferralLink",
        onClick: ()=>(0, $5428ea062f1253bb$export$2cdf1b96a9f86d16)(link, t("common.text_copied")),
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                className: "InviteReferralLink__leftImg",
                src: (0, (/*@__PURE__*/$parcel$interopDefault($aa04401d7734852c$exports)))
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                className: "InviteReferralLink__rightImg",
                src: (0, (/*@__PURE__*/$parcel$interopDefault($42b4b079ae342c67$exports)))
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                className: "InviteReferralLink__input",
                type: "text",
                value: link,
                disabled: true
            })
        ]
    });
};



var $02407b9ffd5d8331$exports = {};
$02407b9ffd5d8331$exports = new URL("gear.53e1ebaf.svg", import.meta.url).toString();




const $e1eb0cc1c68afb6d$export$69bc41ee738923ec = ({ icon: icon, text: text, statText: statText })=>{
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "SectionTitle",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                className: "SectionTitle__icon",
                src: icon
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                className: "SectionTitle__text",
                children: text
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                className: "SectionTitle__statText",
                children: statText
            })
        ]
    });
};








var $kLorN = parcelRequire("kLorN");
const $e938c2c6e1869e9d$export$ae0e60e15f2ff4da = ({ apiHost: apiHost })=>{
    const { t: t } = (0, $3765cebd031b52c0$export$9fc83ad70ead8663)();
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "AcceptTcLink",
        onClick: ()=>{
            window.open(`${apiHost}client/profile/sla?type=html&tc_type=${(0, $kLorN.TERMS_AND_CONDITIONS_TYPE_AFFILIATE_CLIENT)}`, "_blank");
        },
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                className: "AcceptTcLink__text",
                children: t("become_affiliate.accept_tc")
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                src: (0, (/*@__PURE__*/$parcel$interopDefault($2d4024423d397f92$exports)))
            })
        ]
    });
};




const $6f4b43f3e1ed5d6d$export$60303ef0a35f2ce8 = (0, $aca50e9407ba89c9$export$b6ae1bc530f4c149)(({ setShowInvitePopup: setShowInvitePopup, invitationLink: invitationLink })=>{
    const { t: t } = (0, $3765cebd031b52c0$export$9fc83ad70ead8663)();
    const { apiHost: apiHost } = (0, $4671947198ddd366$export$6ccbb43953eebf8)().data;
    const [showTcModal, setShowTcModal] = (0, $acw62.useState)(false);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "InviteReferralsContainer",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "InviteReferralsContainer__card",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                        className: "InviteReferralsContainer__top__title",
                        children: t("common_affiliate.invite_your_staff")
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                        className: "InviteReferralsContainer__top__subtitle",
                        children: t("common_affiliate.invite_staff_more_details")
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $2865a45335de4409$export$16547d3e2618134e), {
                        link: invitationLink
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $2c46e9e1f89bee75$export$2b47962e4e24eb4d), {
                        text: t("common_affiliate.invite_now"),
                        action: ()=>setShowInvitePopup(true),
                        additionalStyle: {
                            width: "100%",
                            marginTop: "12px"
                        }
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $660b2ca422e0e2ae$export$1ff3c3f08ae963c0).Vertical, {
                height: 20
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e1eb0cc1c68afb6d$export$69bc41ee738923ec), {
                icon: (0, (/*@__PURE__*/$parcel$interopDefault($02407b9ffd5d8331$exports))),
                text: t("affiliate_instructions.how_it_works")
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $660b2ca422e0e2ae$export$1ff3c3f08ae963c0).Vertical, {
                height: 8
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "InviteReferralsContainer__card InviteReferralsContainer__card--align-left",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "InviteReferralsContainer__instructionStep",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                className: "InviteReferralsContainer__instructionStep__left",
                                children: "1"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "InviteReferralsContainer__instructionStep__right",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                        className: "InviteReferralsContainer__instructionStep__right__title",
                                        children: t("affiliate_instructions.instruction_1_title")
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                        className: "InviteReferralsContainer__instructionStep__right__subtitle",
                                        children: t("affiliate_instructions.instruction_1_subtitle")
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "InviteReferralsContainer__instructionStep",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                className: "InviteReferralsContainer__instructionStep__left",
                                children: "2"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "InviteReferralsContainer__instructionStep__right",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                        className: "InviteReferralsContainer__instructionStep__right__title",
                                        children: [
                                            t("affiliate_instructions.instruction_2_title"),
                                            " ",
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                className: "InviteReferralsContainer__instructionStep__right__title--highlighted",
                                                children: t("common.ogram")
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                        className: "InviteReferralsContainer__instructionStep__right__subtitle",
                                        children: t("affiliate_instructions.instruction_2_subtitle")
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "InviteReferralsContainer__instructionStep",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                className: "InviteReferralsContainer__instructionStep__left",
                                children: "3"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "InviteReferralsContainer__instructionStep__right",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                        className: "InviteReferralsContainer__instructionStep__right__title",
                                        children: t("affiliate_instructions.instruction_3_title")
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                        className: "InviteReferralsContainer__instructionStep__right__subtitle",
                                        children: t("affiliate_instructions.instruction_3_subtitle")
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "InviteReferralsContainer__instructionStep",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                className: "InviteReferralsContainer__instructionStep__left",
                                children: "4"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "InviteReferralsContainer__instructionStep__right",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                        className: "InviteReferralsContainer__instructionStep__right__title",
                                        children: t("affiliate_instructions.instruction_4_title")
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                        className: "InviteReferralsContainer__instructionStep__right__subtitle",
                                        children: t("affiliate_instructions.instruction_4_subtitle")
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "InviteReferralsContainer__acceptTc",
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e938c2c6e1869e9d$export$ae0e60e15f2ff4da), {
                            apiHost: apiHost
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $6c6a436a5a333492$export$80764a139e65d5c0), {
                onContinue: ()=>setShowTcModal(false),
                showModal: showTcModal,
                setShowModal: setShowTcModal
            })
        ]
    });
});








var $9e9818261aab22b9$exports = {};
$9e9818261aab22b9$exports = new URL("staff.b57292e9.svg", import.meta.url).toString();


var $07da83b43f432c3a$exports = {};
$07da83b43f432c3a$exports = new URL("notify.a1347116.svg", import.meta.url).toString();








const $4c29bad7be3b92b6$var$statusesSettings = {
    [(0, $17c96b9e379c43fb$export$232a731a3a0fd0f1).ProfileCreated]: {
        mainColorRGB: [
            186,
            190,
            214
        ],
        title: "common_affiliate.status_profile_created"
    },
    [(0, $17c96b9e379c43fb$export$232a731a3a0fd0f1).Activated]: {
        mainColorRGB: [
            119,
            103,
            228
        ],
        title: "common_affiliate.status_activated"
    },
    [(0, $17c96b9e379c43fb$export$232a731a3a0fd0f1).BookedShifts]: {
        mainColorRGB: [
            112,
            148,
            247
        ],
        title: "common_affiliate.status_booked_shifts"
    },
    [(0, $17c96b9e379c43fb$export$232a731a3a0fd0f1).ShiftsDone]: {
        mainColorRGB: [
            142,
            205,
            156
        ],
        title: "common_affiliate.status_shifts_done"
    }
};
const $4c29bad7be3b92b6$export$2d4bf0f31fa300af = (status)=>{
    return $4c29bad7be3b92b6$var$statusesSettings[status];
};





const $a745ec82e88a3bc5$export$bc7f7edf5f1a8966 = ({ affiliateReferral: affiliateReferral })=>{
    const { t: t } = (0, $3765cebd031b52c0$export$9fc83ad70ead8663)();
    const status = affiliateReferral.status;
    if ([
        (0, $17c96b9e379c43fb$export$232a731a3a0fd0f1).ProfileCreated,
        (0, $17c96b9e379c43fb$export$232a731a3a0fd0f1).Activated
    ].includes(status)) return null;
    if (affiliateReferral.shiftsTotalCount > affiliateReferral.shiftsCompletedCount) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
        className: "AffiliateReferralListItem__top__left__userInfo__shifts",
        children: [
            affiliateReferral.shiftsCompletedCount,
            "/",
            affiliateReferral.shiftsTotalCount,
            " ",
            t("common.shifts")
        ]
    });
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
        className: "AffiliateReferralListItem__top__left__userInfo__shifts",
        children: [
            affiliateReferral.shiftsTotalCount,
            " ",
            t("common.shifts")
        ]
    });
};




const $3ac430952d3b2227$export$54ec01a60f47d33d = ({ affiliateReferral: affiliateReferral })=>{
    const { t: t } = (0, $3765cebd031b52c0$export$9fc83ad70ead8663)();
    const designations = affiliateReferral.designations.join(", ");
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("table", {
        className: "AffiliateReferralListItem__bottom__table",
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("tbody", {
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("tr", {
                    className: "AffiliateReferralListItem__bottom__table__headers",
                    children: [
                        designations && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                            children: t("common_affiliate.designation")
                        }),
                        affiliateReferral.payoutAmount && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                            children: t("common_affiliate.payout")
                        }),
                        affiliateReferral.payoutDate ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                            children: t("common_affiliate.due_date")
                        }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                            children: t("common_affiliate.join_date")
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("tr", {
                    className: "AffiliateReferralListItem__bottom__table__content",
                    children: [
                        designations && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                            children: designations
                        }),
                        affiliateReferral.payoutAmount && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("td", {
                            children: [
                                affiliateReferral.currency,
                                " ",
                                affiliateReferral.payoutAmount
                            ]
                        }),
                        affiliateReferral.payoutDate ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                            children: affiliateReferral.payoutDate
                        }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                            children: affiliateReferral.joinDate
                        })
                    ]
                })
            ]
        })
    });
};


const $b9e5c6d7361611bc$export$e7133959eb907885 = ({ affiliateReferral: affiliateReferral })=>{
    const { t: t } = (0, $3765cebd031b52c0$export$9fc83ad70ead8663)();
    const status = affiliateReferral.status;
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "AffiliateReferralListItem",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "AffiliateReferralListItem__top",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "AffiliateReferralListItem__top__left",
                        children: [
                            affiliateReferral.image && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $bdacfb30f3b10618$export$2e2bcd8739ae039), {
                                className: "AffiliateReferralListItem__top__left__image",
                                src: affiliateReferral.image
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "AffiliateReferralListItem__top__left__userInfo",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                        className: "AffiliateReferralListItem__top__left__userInfo__name",
                                        children: affiliateReferral.fullName
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $a745ec82e88a3bc5$export$bc7f7edf5f1a8966), {
                                        affiliateReferral: affiliateReferral
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "AffiliateReferralListItem__top__right",
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                            className: "AffiliateReferralListItem__top__right__statusLabel",
                            style: {
                                background: `rgba(${(0, $4c29bad7be3b92b6$export$2d4bf0f31fa300af)(status).mainColorRGB.join(", ")}, 0.2)`,
                                color: `rgb(${(0, $4c29bad7be3b92b6$export$2d4bf0f31fa300af)(status).mainColorRGB.join(", ")})`
                            },
                            children: t((0, $4c29bad7be3b92b6$export$2d4bf0f31fa300af)(status).title)
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "AffiliateReferralListItem__bottom",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $3ac430952d3b2227$export$54ec01a60f47d33d), {
                    affiliateReferral: affiliateReferral
                })
            })
        ]
    });
};





const $fdeab0303e0b322c$export$fe82a520fc33e5f4 = (0, $aca50e9407ba89c9$export$b6ae1bc530f4c149)(({ setShowInvitePopup: setShowInvitePopup, affiliateStats: affiliateStats })=>{
    const redirect = (0, $7df35e9df335b1c8$export$602eaf6d5314ce55)();
    const { t: t } = (0, $3765cebd031b52c0$export$9fc83ad70ead8663)();
    const { getAffiliateReferrals: getAffiliateReferrals, affiliateReferralsList: affiliateReferralsList } = (0, $4671947198ddd366$export$6ccbb43953eebf8)().data;
    (0, $4671947198ddd366$export$dd0a697e1782aedd)(getAffiliateReferrals);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "AffiliateDashboardContainer",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e1eb0cc1c68afb6d$export$69bc41ee738923ec), {
                icon: (0, (/*@__PURE__*/$parcel$interopDefault($9e9818261aab22b9$exports))),
                text: "Staff List",
                statText: `${affiliateStats?.referralsCount} ${t("common.ogs")}`
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $660b2ca422e0e2ae$export$1ff3c3f08ae963c0).Vertical, {
                height: 20
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "AffiliateDashboardContainer__card",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "AffiliateDashboardContainer__referralList",
                        children: affiliateReferralsList.map((affiliateReferral)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b9e5c6d7361611bc$export$e7133959eb907885), {
                                affiliateReferral: affiliateReferral
                            }, affiliateReferral.id))
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        onClick: ()=>redirect((0, $0534349ae8731d0b$export$66b32f6f30eb4b4).affiliateReferralsList, {}),
                        className: "AffiliateDashboardContainer__showMore",
                        children: t("common.show_more")
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $660b2ca422e0e2ae$export$1ff3c3f08ae963c0).Vertical, {
                height: 20
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "AffiliateDashboardContainer__card",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    onClick: ()=>setShowInvitePopup(true),
                    className: "AffiliateDashboardContainer__inviteMore",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e1eb0cc1c68afb6d$export$69bc41ee738923ec), {
                            icon: (0, (/*@__PURE__*/$parcel$interopDefault($07da83b43f432c3a$exports))),
                            text: t("common_affiliate.invite_more_staff")
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                            src: (0, (/*@__PURE__*/$parcel$interopDefault($2d4024423d397f92$exports)))
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $660b2ca422e0e2ae$export$1ff3c3f08ae963c0).Vertical, {
                height: 50
            })
        ]
    });
});








class $17bbca1ae98ae4d0$var$AssertionError extends Error {
    constructor(message){
        super(message);
        this.name = "AssertionError";
    }
}
function $17bbca1ae98ae4d0$export$2e2bcd8739ae039(value, message) {
    if (!value) throw new $17bbca1ae98ae4d0$var$AssertionError(message);
}


function $7361523787db9d0d$export$2e2bcd8739ae039(object) {
    const params = Object.entries(object).filter(([, value])=>value !== undefined && value !== null).map(([key, value])=>`${encodeURIComponent(key)}=${encodeURIComponent(String(value))}`);
    return params.length > 0 ? `?${params.join("&")}` : "";
}




var $acw62 = parcelRequire("acw62");


var $acw62 = parcelRequire("acw62");

const $a3c9f33ad8e6c1b8$var$isPromise = (obj)=>Boolean(obj) && (typeof obj === "object" || typeof obj === "function") && typeof obj.then === "function";
const $a3c9f33ad8e6c1b8$var$getBoxPositionOnWindowCenter = (width, height)=>({
        left: window.outerWidth / 2 + (window.screenX || window.screenLeft || 0) - width / 2,
        top: window.outerHeight / 2 + (window.screenY || window.screenTop || 0) - height / 2
    });
const $a3c9f33ad8e6c1b8$var$getBoxPositionOnScreenCenter = (width, height)=>({
        top: (window.screen.height - height) / 2,
        left: (window.screen.width - width) / 2
    });
function $a3c9f33ad8e6c1b8$var$windowOpen(url, { height: height, width: width, ...configRest }, onClose) {
    const config = {
        height: height,
        width: width,
        location: "no",
        toolbar: "no",
        status: "no",
        directories: "no",
        menubar: "no",
        scrollbars: "yes",
        resizable: "no",
        centerscreen: "yes",
        chrome: "yes",
        ...configRest
    };
    const shareDialog = window.open(url, "", Object.keys(config).map((key)=>`${key}=${config[key]}`).join(", "));
    if (onClose) {
        const interval = window.setInterval(()=>{
            try {
                if (shareDialog === null || shareDialog.closed) {
                    window.clearInterval(interval);
                    onClose(shareDialog);
                }
            } catch (e) {
                /* eslint-disable no-console */ console.error(e);
            /* eslint-enable no-console */ }
        }, 1000);
    }
    return shareDialog;
}
var $a3c9f33ad8e6c1b8$export$2e2bcd8739ae039;
$a3c9f33ad8e6c1b8$export$2e2bcd8739ae039 = class ShareButton extends (0, $acw62.Component) {
    static #_ = this.defaultProps = {
        disabledStyle: {
            opacity: 0.6
        },
        openShareDialogOnClick: true,
        resetButtonStyle: true
    };
    render() {
        const { beforeOnClick: beforeOnClick, children: children, className: className, disabled: disabled, disabledStyle: disabledStyle, forwardedRef: forwardedRef, networkLink: networkLink, networkName: networkName, onShareWindowClose: onShareWindowClose, openShareDialogOnClick: openShareDialogOnClick, opts: opts, resetButtonStyle: resetButtonStyle, style: style, url: url, windowHeight: windowHeight, windowPosition: windowPosition, windowWidth: windowWidth, ...rest } = this.props;
        const newClassName = (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))("react-share__ShareButton", {
            "react-share__ShareButton--disabled": Boolean(disabled),
            disabled: Boolean(disabled)
        }, className);
        const newStyle = resetButtonStyle ? {
            backgroundColor: "transparent",
            border: "none",
            padding: 0,
            font: "inherit",
            color: "inherit",
            cursor: "pointer",
            ...style,
            ...disabled && disabledStyle
        } : {
            ...style,
            ...disabled && disabledStyle
        };
        return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
            ...rest,
            "aria-label": rest["aria-label"] ?? networkName,
            className: newClassName,
            onClick: (ev)=>{
                this.handleClick(ev);
            },
            ref: forwardedRef,
            style: newStyle,
            children: children
        });
    }
    constructor(...args){
        super(...args);
        this.openShareDialog = (link)=>{
            const { onShareWindowClose: onShareWindowClose, windowHeight: windowHeight = 400, windowPosition: windowPosition = "windowCenter", windowWidth: windowWidth = 550 } = this.props;
            const windowConfig = {
                height: windowHeight,
                width: windowWidth,
                ...windowPosition === "windowCenter" ? $a3c9f33ad8e6c1b8$var$getBoxPositionOnWindowCenter(windowWidth, windowHeight) : $a3c9f33ad8e6c1b8$var$getBoxPositionOnScreenCenter(windowWidth, windowHeight)
            };
            $a3c9f33ad8e6c1b8$var$windowOpen(link, windowConfig, onShareWindowClose);
        };
        this.handleClick = async (event)=>{
            const { beforeOnClick: beforeOnClick, disabled: disabled, networkLink: networkLink, onClick: onClick, url: url, openShareDialogOnClick: openShareDialogOnClick, opts: opts } = this.props;
            const link = networkLink(url, opts);
            if (disabled) return;
            event.preventDefault();
            if (beforeOnClick) {
                const returnVal = beforeOnClick();
                // @ts-ignore
                if ($a3c9f33ad8e6c1b8$var$isPromise(returnVal)) await returnVal;
            }
            if (openShareDialogOnClick) this.openShareDialog(link);
            if (onClick) onClick(event, link);
        };
    }
};


function $46ae04ad603c63c6$var$createShareButton(networkName, link, optsMap, defaultProps) {
    function CreatedButton(props, ref) {
        const opts = optsMap(props);
        const passedProps = {
            ...props
        };
        // remove keys from passed props that are passed as opts
        const optsKeys = Object.keys(opts);
        optsKeys.forEach((key)=>{
            delete passedProps[key];
        });
        return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $a3c9f33ad8e6c1b8$export$2e2bcd8739ae039), {
            ...defaultProps,
            ...passedProps,
            forwardedRef: ref,
            networkName: networkName,
            networkLink: link,
            opts: optsMap(props)
        });
    }
    CreatedButton.displayName = `ShareButton-${networkName}`;
    return /*#__PURE__*/ (0, $acw62.forwardRef)(CreatedButton);
}
var $46ae04ad603c63c6$export$2e2bcd8739ae039 = $46ae04ad603c63c6$var$createShareButton;


var $19f3578c38a9c813$exports = {};
$19f3578c38a9c813$exports = new URL("linkedin.e51c266b.svg", import.meta.url).toString();


function $f30109d3f955f423$var$linkedinLink(url, { title: title, summary: summary, source: source }) {
    (0, $17bbca1ae98ae4d0$export$2e2bcd8739ae039)(url, "linkedin.url");
    return `https://linkedin.com/shareArticle${(0, $7361523787db9d0d$export$2e2bcd8739ae039)({
        url: url,
        mini: "true",
        title: title,
        summary: summary,
        source: source
    })}`;
}
const $f30109d3f955f423$var$Button = (0, $46ae04ad603c63c6$export$2e2bcd8739ae039)("linkedin", $f30109d3f955f423$var$linkedinLink, ({ title: title, summary: summary, source: source })=>({
        title: title,
        summary: summary,
        source: source
    }), {
    windowWidth: 750,
    windowHeight: 600
});
const $f30109d3f955f423$var$LinkedInShareButton = ({ url: url, title: title })=>{
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($f30109d3f955f423$var$Button, {
        url: url,
        title: title,
        summary: title,
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
            src: (0, (/*@__PURE__*/$parcel$interopDefault($19f3578c38a9c813$exports))),
            style: {
                cursor: "pointer"
            }
        })
    });
};
var $f30109d3f955f423$export$2e2bcd8739ae039 = $f30109d3f955f423$var$LinkedInShareButton;






var $388480664b9eec4d$exports = {};
$388480664b9eec4d$exports = new URL("facebook.7d13ae6c.svg", import.meta.url).toString();


function $eacf21ae05ee43c7$var$facebookLink(url, { quote: quote, hashtag: hashtag }) {
    (0, $17bbca1ae98ae4d0$export$2e2bcd8739ae039)(url, "facebook.url");
    return `https://www.facebook.com/sharer/sharer.php${(0, $7361523787db9d0d$export$2e2bcd8739ae039)({
        u: url,
        quote: quote,
        hashtag: hashtag
    })}`;
}
const $eacf21ae05ee43c7$var$Button = (0, $46ae04ad603c63c6$export$2e2bcd8739ae039)("facebook", $eacf21ae05ee43c7$var$facebookLink, (props)=>({
        quote: props.quote,
        hashtag: props.hashtag
    }), {
    windowWidth: 550,
    windowHeight: 400
});
const $eacf21ae05ee43c7$var$FacebookShareButton = ({ url: url, title: title })=>{
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($eacf21ae05ee43c7$var$Button, {
        url: url,
        quote: title,
        title: title,
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
            src: (0, (/*@__PURE__*/$parcel$interopDefault($388480664b9eec4d$exports))),
            style: {
                cursor: "pointer"
            }
        })
    });
};
var $eacf21ae05ee43c7$export$2e2bcd8739ae039 = $eacf21ae05ee43c7$var$FacebookShareButton;






var $36d0b07e19cf0d1d$exports = {};
$36d0b07e19cf0d1d$exports = new URL("twitter.94182eb5.svg", import.meta.url).toString();


function $a197ef3e281512e8$var$twitterLink(url, { title: title, via: via, hashtags: hashtags = [], related: related = [] }) {
    (0, $17bbca1ae98ae4d0$export$2e2bcd8739ae039)(url, "twitter.url");
    (0, $17bbca1ae98ae4d0$export$2e2bcd8739ae039)(Array.isArray(hashtags), "twitter.hashtags is not an array");
    (0, $17bbca1ae98ae4d0$export$2e2bcd8739ae039)(Array.isArray(related), "twitter.related is not an array");
    return `https://twitter.com/share${(0, $7361523787db9d0d$export$2e2bcd8739ae039)({
        url: url,
        text: title,
        via: via,
        hashtags: hashtags.length > 0 ? hashtags.join(",") : undefined,
        related: related.length > 0 ? related.join(",") : undefined
    })}`;
}
const $a197ef3e281512e8$var$Button = (0, $46ae04ad603c63c6$export$2e2bcd8739ae039)("twitter", $a197ef3e281512e8$var$twitterLink, (props)=>({
        hashtags: props.hashtags,
        title: props.title,
        via: props.via,
        related: props.related
    }), {
    windowWidth: 550,
    windowHeight: 400
});
const $a197ef3e281512e8$var$TwitterShareButton = ({ url: url, title: title })=>{
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($a197ef3e281512e8$var$Button, {
        url: url,
        title: title,
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
            src: (0, (/*@__PURE__*/$parcel$interopDefault($36d0b07e19cf0d1d$exports))),
            style: {
                cursor: "pointer"
            }
        })
    });
};
var $a197ef3e281512e8$export$2e2bcd8739ae039 = $a197ef3e281512e8$var$TwitterShareButton;






var $206439834ad12a43$exports = {};
$206439834ad12a43$exports = new URL("telegram.240866c2.svg", import.meta.url).toString();


function $6eb671ba8492cae9$var$telegramLink(url, { title: title }) {
    (0, $17bbca1ae98ae4d0$export$2e2bcd8739ae039)(url, "telegram.url");
    return `https://telegram.me/share/url${(0, $7361523787db9d0d$export$2e2bcd8739ae039)({
        url: url,
        text: title
    })}`;
}
const $6eb671ba8492cae9$var$Button = (0, $46ae04ad603c63c6$export$2e2bcd8739ae039)("telegram", $6eb671ba8492cae9$var$telegramLink, (props)=>({
        title: props.title
    }), {
    windowWidth: 550,
    windowHeight: 400
});
const $6eb671ba8492cae9$var$TelegramShareButton = ({ url: url, title: title })=>{
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($6eb671ba8492cae9$var$Button, {
        url: url,
        title: title,
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
            src: (0, (/*@__PURE__*/$parcel$interopDefault($206439834ad12a43$exports))),
            style: {
                cursor: "pointer"
            }
        })
    });
};
var $6eb671ba8492cae9$export$2e2bcd8739ae039 = $6eb671ba8492cae9$var$TelegramShareButton;






var $d9ecd2ef75963016$exports = {};
$d9ecd2ef75963016$exports = new URL("whatsapp.05d59bba.svg", import.meta.url).toString();


function $e8555aaea12e0575$var$isMobileOrTablet() {
    return /(android|iphone|ipad|mobile)/i.test(navigator.userAgent);
}
function $e8555aaea12e0575$var$whatsappLink(url, { title: title, separator: separator }) {
    (0, $17bbca1ae98ae4d0$export$2e2bcd8739ae039)(url, "whatsapp.url");
    return `https://${$e8555aaea12e0575$var$isMobileOrTablet() ? "api" : "web"}.whatsapp.com/send${(0, $7361523787db9d0d$export$2e2bcd8739ae039)({
        text: title ? title + separator + url : url
    })}`;
}
const $e8555aaea12e0575$var$Button = (0, $46ae04ad603c63c6$export$2e2bcd8739ae039)("whatsapp", $e8555aaea12e0575$var$whatsappLink, (props)=>({
        title: props.title,
        separator: props.separator ?? " "
    }), {
    windowWidth: 550,
    windowHeight: 400
});
const $e8555aaea12e0575$var$WhatsappShareButton = ({ url: url, title: title })=>{
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($e8555aaea12e0575$var$Button, {
        url: url,
        title: title,
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
            src: (0, (/*@__PURE__*/$parcel$interopDefault($d9ecd2ef75963016$exports))),
            style: {
                cursor: "pointer"
            }
        })
    });
};
var $e8555aaea12e0575$export$2e2bcd8739ae039 = $e8555aaea12e0575$var$WhatsappShareButton;



const $a342463b19e56ebc$export$aee8da5387e1ca5e = ({ showPopup: showPopup, setShowPopup: setShowPopup, invitationLink: invitationLink })=>{
    const { t: t } = (0, $3765cebd031b52c0$export$9fc83ad70ead8663)();
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $9c16b10bbbe042e5$export$129a32eedafa97c5), {
        isActive: showPopup,
        content: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
            className: "InviteReferralPopup",
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                    className: "InviteReferralPopup__title",
                    children: t("common_affiliate.send_invitation")
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                    className: "InviteReferralPopup__subtitle",
                    children: t("common_affiliate.share_link")
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: "InviteReferralPopup__socialShare",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $eacf21ae05ee43c7$export$2e2bcd8739ae039), {
                            url: invitationLink,
                            title: t("common_affiliate.join_ogram")
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f30109d3f955f423$export$2e2bcd8739ae039), {
                            url: invitationLink,
                            title: t("common_affiliate.join_ogram")
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $a197ef3e281512e8$export$2e2bcd8739ae039), {
                            url: invitationLink,
                            title: t("common_affiliate.join_ogram")
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $6eb671ba8492cae9$export$2e2bcd8739ae039), {
                            url: invitationLink,
                            title: t("common_affiliate.join_ogram")
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e8555aaea12e0575$export$2e2bcd8739ae039), {
                            url: invitationLink,
                            title: t("common_affiliate.join_ogram")
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                    className: "InviteReferralPopup__subtitle2",
                    children: t("common_affiliate.copy_and_send_link")
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $660b2ca422e0e2ae$export$1ff3c3f08ae963c0).Vertical, {
                    height: 10
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $2865a45335de4409$export$16547d3e2618134e), {
                    link: invitationLink
                })
            ]
        }),
        close: ()=>setShowPopup(false)
    });
};







const $57bfa4d0b52cf66f$export$132a8f6e4671676c = (0, $aca50e9407ba89c9$export$b6ae1bc530f4c149)(()=>{
    const { companyDetails: companyDetails, markAffiliateTCAsAccepted: markAffiliateTCAsAccepted } = (0, $4671947198ddd366$export$6ccbb43953eebf8)().data;
    const isAffiliateTCAccepted = Boolean(companyDetails?.is_affiliate_tc_accepted);
    if (isAffiliateTCAccepted) return null;
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $cb09c16bc08d7fbd$export$a011eb31e72a119c), {
        showBecomeAffiliateModal: true,
        setShowBecomeAffiliateModal: (value)=>{},
        onSuccess: markAffiliateTCAsAccepted
    });
});


const $9c0ee352ca8665bd$export$fe82a520fc33e5f4 = (0, $aca50e9407ba89c9$export$b6ae1bc530f4c149)(()=>{
    const { t: t } = (0, $3765cebd031b52c0$export$9fc83ad70ead8663)();
    const [showInvitePopup, setShowInvitePopup] = (0, $acw62.useState)(false);
    const { getAffiliateStats: getAffiliateStats, affiliateStats: affiliateStats } = (0, $4671947198ddd366$export$6ccbb43953eebf8)().data;
    (0, $4671947198ddd366$export$dd0a697e1782aedd)(getAffiliateStats);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "AffiliateDashboardPage",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $57bfa4d0b52cf66f$export$132a8f6e4671676c), {}),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7ae42b63183f30b4$export$8b251419efc915eb), {
                title: t("common_affiliate.my_referrals")
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $660b2ca422e0e2ae$export$1ff3c3f08ae963c0).Vertical, {
                height: 28
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "AffiliateDashboardPage__container",
                children: affiliateStats && affiliateStats.referralsCount > 0 ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $fdeab0303e0b322c$export$fe82a520fc33e5f4), {
                    affiliateStats: affiliateStats,
                    setShowInvitePopup: setShowInvitePopup
                }) : // TODO(A): Properly handle absence of link invitationLink={affiliateStats?.invitationLink ?? ''}
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $6f4b43f3e1ed5d6d$export$60303ef0a35f2ce8), {
                    setShowInvitePopup: setShowInvitePopup,
                    invitationLink: affiliateStats?.invitationLink ?? ""
                })
            }),
            affiliateStats && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $a342463b19e56ebc$export$aee8da5387e1ca5e), {
                showPopup: showInvitePopup,
                setShowPopup: setShowInvitePopup,
                invitationLink: affiliateStats.invitationLink
            })
        ]
    });
});






var $acw62 = parcelRequire("acw62");









var $1e12d6a47132a587$exports = {};
$1e12d6a47132a587$exports = new URL("prev.1e4f9374.svg", import.meta.url).toString();


var $a669164cdaa97d84$exports = {};
$a669164cdaa97d84$exports = new URL("next.694c672b.svg", import.meta.url).toString();


const $f5d75ea14ffc8889$export$68f5e1453c188a82 = ({ totalPages: totalPages, currentPage: currentPage, handleNext: handleNext, handlePrev: handlePrev })=>{
    const { t: t } = (0, $3765cebd031b52c0$export$9fc83ad70ead8663)();
    const isPrevDisabled = currentPage === 1;
    const isNextDisabled = currentPage === totalPages;
    const onPrev = ()=>{
        if (!isPrevDisabled) handlePrev();
    };
    const onNext = ()=>{
        if (!isNextDisabled) handleNext();
    };
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "Pagination",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                onClick: onPrev,
                className: "Pagination__left",
                style: isPrevDisabled ? {
                    cursor: "not-allowed"
                } : {},
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                        src: (0, (/*@__PURE__*/$parcel$interopDefault($1e12d6a47132a587$exports)))
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                        children: t("page_stepper.previous")
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "Pagination__middle",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                    className: "Pagination__middle__pages",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                            className: "Pagination__middle__pages__current",
                            children: currentPage
                        }),
                        " ",
                        t("page_stepper.of"),
                        " ",
                        totalPages
                    ]
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                onClick: onNext,
                className: "Pagination__right",
                style: isNextDisabled ? {
                    cursor: "not-allowed"
                } : {},
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                        children: t("page_stepper.next")
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                        src: (0, (/*@__PURE__*/$parcel$interopDefault($a669164cdaa97d84$exports)))
                    })
                ]
            })
        ]
    });
};





const $305d4526022a42d7$export$ea4f29a61823a7c3 = (0, $aca50e9407ba89c9$export$b6ae1bc530f4c149)(()=>{
    const { t: t } = (0, $3765cebd031b52c0$export$9fc83ad70ead8663)();
    const [currentPage, setCurrentPage] = (0, $acw62.useState)(1);
    const { getAffiliateStats: getAffiliateStats, affiliateStats: affiliateStats, getAffiliateReferrals: getAffiliateReferrals, affiliateReferralsList: affiliateReferralsList, affiliateReferralsPagesCount: affiliateReferralsPagesCount, getAffiliateStatuses: getAffiliateStatuses, affiliateReferralStatuses: affiliateReferralStatuses } = (0, $4671947198ddd366$export$6ccbb43953eebf8)().data;
    (0, $4671947198ddd366$export$dd0a697e1782aedd)(getAffiliateStats);
    (0, $4671947198ddd366$export$dd0a697e1782aedd)(getAffiliateStatuses);
    const [getAffiliateReferralsResult, getAffiliateReferralsRequest] = (0, $4671947198ddd366$export$609860bf8b0084c)(({ page: page })=>getAffiliateReferrals(page));
    (0, $acw62.useEffect)(()=>{
        getAffiliateReferralsRequest({
            page: currentPage
        });
    }, []);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "ReferralsListPage",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $57bfa4d0b52cf66f$export$132a8f6e4671676c), {}),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7ae42b63183f30b4$export$8b251419efc915eb), {
                title: t("common_affiliate.referrals_list"),
                showBack: true
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $660b2ca422e0e2ae$export$1ff3c3f08ae963c0).Vertical, {
                height: 28
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "ReferralsListPage__container",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e1eb0cc1c68afb6d$export$69bc41ee738923ec), {
                        icon: (0, (/*@__PURE__*/$parcel$interopDefault($9e9818261aab22b9$exports))),
                        text: t("common_affiliate.my_referrals"),
                        statText: `${affiliateStats?.referralsCount ?? 0} ${t("common.ogs")}`
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $660b2ca422e0e2ae$export$1ff3c3f08ae963c0).Vertical, {
                        height: 20
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "ReferralsListPage__card",
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                            className: "ReferralsListPage__statuses",
                            children: affiliateReferralStatuses.map((status, index)=>{
                                const statusSettings = (0, $4c29bad7be3b92b6$export$2d4bf0f31fa300af)(status.status);
                                return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                    className: "ReferralsListPage__statuses__item",
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                            className: "ReferralsListPage__statuses__item__left",
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                    className: "ReferralsListPage__statuses__item__left__circle",
                                                    style: {
                                                        background: `rgb(${statusSettings.mainColorRGB.join(", ")})`
                                                    }
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                    className: "ReferralsListPage__statuses__item__left__title",
                                                    style: {
                                                        color: `rgb(${statusSettings.mainColorRGB.join(", ")})`
                                                    },
                                                    children: t(statusSettings.title)
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                            className: "ReferralsListPage__statuses__item__right",
                                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                className: "ReferralsListPage__statuses__item__right__title",
                                                children: status.referralsCount
                                            })
                                        })
                                    ]
                                }, index);
                            })
                        })
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $660b2ca422e0e2ae$export$1ff3c3f08ae963c0).Vertical, {
                        height: 20
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "ReferralsListPage__card",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                className: "ReferralsListPage__referralList",
                                children: getAffiliateReferralsResult.isLoading ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $57fb8f45c69e1681$export$2e2bcd8739ae039), {}) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7b02d682eb115277$exports.Fragment), {
                                    children: affiliateReferralsList.map((affiliateReferral)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b9e5c6d7361611bc$export$e7133959eb907885), {
                                            affiliateReferral: affiliateReferral
                                        }, affiliateReferral.id))
                                })
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $660b2ca422e0e2ae$export$1ff3c3f08ae963c0).Vertical, {
                                height: 20
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f5d75ea14ffc8889$export$68f5e1453c188a82), {
                                handleNext: ()=>{
                                    const newPage = currentPage + 1;
                                    setCurrentPage(newPage);
                                    getAffiliateReferralsRequest({
                                        page: newPage
                                    });
                                },
                                handlePrev: ()=>{
                                    const newPage = currentPage - 1;
                                    setCurrentPage(newPage);
                                    getAffiliateReferralsRequest({
                                        page: newPage
                                    });
                                },
                                currentPage: currentPage,
                                totalPages: affiliateReferralsPagesCount
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $660b2ca422e0e2ae$export$1ff3c3f08ae963c0).Vertical, {
                        height: 50
                    })
                ]
            })
        ]
    });
});









const $4a214fbde6e07183$export$372bd802248574f6 = (0, $aca50e9407ba89c9$export$b6ae1bc530f4c149)(()=>{
    const { t: t } = (0, $3765cebd031b52c0$export$9fc83ad70ead8663)();
    const { getAffiliateEarnings: getAffiliateEarnings, affiliateEarnings: affiliateEarnings } = (0, $4671947198ddd366$export$6ccbb43953eebf8)().data;
    (0, $4671947198ddd366$export$dd0a697e1782aedd)(getAffiliateEarnings);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "AffiliateEarningsPage",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $57bfa4d0b52cf66f$export$132a8f6e4671676c), {}),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7ae42b63183f30b4$export$8b251419efc915eb), {
                title: t("common_affiliate.earning_history"),
                showBack: true
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $660b2ca422e0e2ae$export$1ff3c3f08ae963c0).Vertical, {
                height: 28
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "AffiliateEarningsPage__container",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "AffiliateEarningsPage__card",
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: "AffiliateEarningsPage__stats",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                    className: "AffiliateEarningsPage__stats__sum",
                                    children: [
                                        affiliateEarnings?.currency,
                                        " ",
                                        affiliateEarnings?.totalAmount
                                    ]
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                    className: "AffiliateEarningsPage__stats__period",
                                    children: t("common_affiliate.total_earnings")
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $660b2ca422e0e2ae$export$1ff3c3f08ae963c0).Vertical, {
                        height: 20
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "AffiliateEarningsPage__card",
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                            className: "AffiliateEarningsPage__months",
                            children: (affiliateEarnings?.periods ?? []).map((period)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                    className: "AffiliateEarningsPage__months__item",
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                            className: "AffiliateEarningsPage__months__item__left",
                                            children: period.title
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                            className: "AffiliateEarningsPage__months__item__right",
                                            children: [
                                                affiliateEarnings?.currency,
                                                " ",
                                                period.amount
                                            ]
                                        })
                                    ]
                                }, period.title))
                        })
                    })
                ]
            })
        ]
    });
});


const $004b8b009d9026ac$export$a6d247afd1f2f5 = {
    DashboardPage: $9c0ee352ca8665bd$export$fe82a520fc33e5f4,
    ReferralsListPage: $305d4526022a42d7$export$ea4f29a61823a7c3,
    EarningsPage: $4a214fbde6e07183$export$372bd802248574f6
};






var $acw62 = parcelRequire("acw62");






const $7217ece7f91e41f7$export$d43f91ac58cde147 = ({ sortDirection: sortDirection })=>{
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("svg", {
        width: "8",
        height: "16",
        viewBox: "0 0 8 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M7 4L4 1L1 4",
                stroke: sortDirection && sortDirection === "ASC" ? "#6E6E87" : "#BABED6",
                strokeWidth: "2",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M1 12L4 15L7 12",
                stroke: sortDirection && sortDirection === "DESC" ? "#6E6E87" : "#BABED6",
                strokeWidth: "2",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            })
        ]
    });
};




var $acw62 = parcelRequire("acw62");



const $52e5809c84cfd79a$export$51def8c33e56fa36 = ({ isActive: isActive, onClick: onClick })=>{
    if (isActive) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("svg", {
        onClick: onClick,
        xmlns: "http://www.w3.org/2000/svg",
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M9.82828 4.62275C7.98819 2.79242 5.00646 2.79242 3.16637 4.62275C2.22624 5.55789 1.75542 6.93192 1.71757 8.25105C1.67976 9.56899 2.0715 10.9674 3.0316 11.9224C4.28536 13.1695 5.91449 14.588 7.22045 15.6874C7.8754 16.2388 8.45286 16.7132 8.86672 17.0498C9.07371 17.2181 9.2399 17.3521 9.35455 17.4442L9.48657 17.5499L9.52109 17.5775L9.53004 17.5846L9.53239 17.5865L9.53302 17.587L9.5332 17.5871C9.53325 17.5872 9.53329 17.5872 9.99987 17L9.53329 17.5872C9.81018 17.8072 10.2031 17.8039 10.4763 17.5792L9.99987 17C10.4763 17.5792 10.4763 17.5792 10.4764 17.5792L10.4765 17.579L10.4771 17.5785L10.4794 17.5767L10.488 17.5696L10.5213 17.5421L10.6488 17.4365C10.7596 17.3446 10.9203 17.2107 11.1208 17.0425C11.5217 16.7061 12.0818 16.2321 12.7193 15.6811C13.9911 14.5819 15.5832 13.1658 16.8333 11.9224C17.7833 10.9774 18.215 9.59141 18.2151 8.27257C18.2151 6.95372 17.7834 5.5677 16.8334 4.62275C14.9933 2.79242 12.0116 2.79242 10.1715 4.62275L9.99987 4.79343L9.82828 4.62275Z",
            fill: "#F88C99"
        })
    });
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("svg", {
        onClick: onClick,
        xmlns: "http://www.w3.org/2000/svg",
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M3.16637 4.62275C5.00646 2.79242 7.98819 2.79242 9.82828 4.62275L9.99987 4.79343L10.1715 4.62275C12.0116 2.79242 14.9933 2.79242 16.8334 4.62275C17.7834 5.5677 18.2151 6.95372 18.2151 8.27257C18.215 9.59141 17.7833 10.9774 16.8333 11.9224C15.5832 13.1658 13.9911 14.5819 12.7193 15.6811C12.0818 16.2321 11.5217 16.7061 11.1208 17.0425C10.9203 17.2107 10.7596 17.3446 10.6488 17.4365L10.5213 17.5421L10.488 17.5696L10.4794 17.5767L10.4771 17.5785L10.4765 17.579L10.4764 17.5792C10.4763 17.5792 10.4763 17.5792 9.99987 17C9.53329 17.5872 9.53325 17.5872 9.5332 17.5871L9.53302 17.587L9.53239 17.5865L9.53004 17.5846L9.52109 17.5775L9.48657 17.5499L9.35455 17.4442C9.2399 17.3521 9.07371 17.2181 8.86672 17.0498C8.45286 16.7132 7.8754 16.2388 7.22045 15.6874C5.91449 14.588 4.28536 13.1695 3.0316 11.9224C2.0715 10.9674 1.67976 9.56899 1.71757 8.25105C1.75542 6.93192 2.22624 5.55789 3.16637 4.62275ZM9.99987 17L9.53329 17.5872C9.81018 17.8072 10.2031 17.8039 10.4763 17.5792L9.99987 17ZM9.99206 16.0313C10.0433 15.9884 10.0983 15.9424 10.1566 15.8934C10.5532 15.5607 11.1076 15.0915 11.7384 14.5463C13.0033 13.4531 14.5635 12.0645 15.7755 10.8589C16.373 10.2645 16.7151 9.30211 16.7151 8.27255C16.7151 7.24298 16.3731 6.28058 15.7755 5.68622C14.5206 4.43793 12.4843 4.43793 11.2293 5.68622L10.5288 6.38302C10.2362 6.67404 9.76352 6.67404 9.47095 6.38302L8.77044 5.68622C7.51549 4.43793 5.47916 4.43793 4.22421 5.68622C3.61682 6.2904 3.24649 7.26478 3.21696 8.29407C3.18739 9.32454 3.50202 10.2746 4.08944 10.8589C5.29777 12.0608 6.88832 13.447 8.18651 14.54C8.83363 15.0848 9.40438 15.5536 9.81319 15.8861C9.87686 15.9379 9.93659 15.9863 9.99206 16.0313Z",
            fill: "#BABED6"
        })
    });
};





var $i56po = parcelRequire("i56po");
const $7c4dcc15da63a765$var$PastWorkers = (0, $i56po.types).model("PastWorkers", {
    searchFilters: (0, $i56po.types).model({
        searchString: (0, $i56po.types).string,
        locationId: (0, $i56po.types).maybeNull((0, $i56po.types).number),
        designationId: (0, $i56po.types).maybeNull((0, $i56po.types).number),
        isFavorite: (0, $i56po.types).boolean
    })
}).actions((self)=>({
        setSearchString (searchString) {
            self.searchFilters.searchString = searchString;
        },
        setLocationId (locationId) {
            self.searchFilters.locationId = locationId;
        },
        setDesignationId (designationId) {
            self.searchFilters.designationId = designationId;
        },
        setIsFavorite (isFavorite) {
            self.searchFilters.isFavorite = isFavorite;
        },
        reset () {
            self.searchFilters.searchString = "";
            self.searchFilters.locationId = null;
            self.searchFilters.designationId = null;
            self.searchFilters.isFavorite = false;
        }
    })).views((self)=>({
        get activeFiltersCount () {
            return [
                self.searchFilters.locationId,
                self.searchFilters.designationId,
                self.searchFilters.isFavorite
            ].filter((value)=>Boolean(value)).length;
        }
    }));
const $7c4dcc15da63a765$export$8a7f818a713a8cb0 = $7c4dcc15da63a765$var$PastWorkers.create({
    searchFilters: {
        searchString: "",
        locationId: null,
        designationId: null,
        isFavorite: false
    }
});




var $77a4ea3b62033e72$exports = {};
$77a4ea3b62033e72$exports = new URL("star-filled.242b41e7.svg", import.meta.url).toString();


var $56fd33b18ba6f9e9$exports = {};
$56fd33b18ba6f9e9$exports = new URL("star-empty.e0eeea64.svg", import.meta.url).toString();


const $77c0756c654a0212$export$8ba663d22f9191ae = ({ isEditRatingMode: isEditRatingMode, setIsEditRatingMode: setIsEditRatingMode, rating: rating, handleSetRating: handleSetRating })=>{
    const { t: t } = (0, $3765cebd031b52c0$export$9fc83ad70ead8663)();
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        className: "WorkersList__item__rating",
        children: !isEditRatingMode ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: "WorkersList__item__rating__stars",
                    children: [
                        Array.from(Array(rating)).map((_, i)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                                src: (0, (/*@__PURE__*/$parcel$interopDefault($77a4ea3b62033e72$exports)))
                            }, i)),
                        Array.from(Array(5 - rating)).map((_, i)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                                src: (0, (/*@__PURE__*/$parcel$interopDefault($56fd33b18ba6f9e9$exports)))
                            }, i))
                    ]
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: "WorkersList__item__rating__info",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                            className: "WorkersList__item__rating__info__value",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                    children: rating
                                }),
                                "/5"
                            ]
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                            onClick: ()=>setIsEditRatingMode(true),
                            className: "WorkersList__item__rating__info__highlight cursor-pointer",
                            children: t("common.change")
                        })
                    ]
                })
            ]
        }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: "WorkersList__item__rating__stars",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                            onClick: ()=>handleSetRating(1),
                            src: (0, (/*@__PURE__*/$parcel$interopDefault($56fd33b18ba6f9e9$exports))),
                            className: "cursor-pointer"
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                            onClick: ()=>handleSetRating(2),
                            src: (0, (/*@__PURE__*/$parcel$interopDefault($56fd33b18ba6f9e9$exports))),
                            className: "cursor-pointer"
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                            onClick: ()=>handleSetRating(3),
                            src: (0, (/*@__PURE__*/$parcel$interopDefault($56fd33b18ba6f9e9$exports))),
                            className: "cursor-pointer"
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                            onClick: ()=>handleSetRating(4),
                            src: (0, (/*@__PURE__*/$parcel$interopDefault($56fd33b18ba6f9e9$exports))),
                            className: "cursor-pointer"
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                            onClick: ()=>handleSetRating(5),
                            src: (0, (/*@__PURE__*/$parcel$interopDefault($56fd33b18ba6f9e9$exports))),
                            className: "cursor-pointer"
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: "WorkersList__item__rating__info",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                            className: "WorkersList__item__rating__info__highlight cursor-pointer",
                            children: t("staff.how_was_the_worker")
                        }),
                        rating > 0 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                            onClick: ()=>setIsEditRatingMode(false),
                            className: "WorkersList__item__rating__info__cancel cursor-pointer",
                            children: t("common.cancel")
                        })
                    ]
                })
            ]
        })
    });
};





var $7YFi7 = parcelRequire("7YFi7");


var $acw62 = parcelRequire("acw62");

const $a7156574ce15644d$export$13baa3ebe801eedd = ({ setSPNote: setSPNote, sp: sp, className: className, placeholder: placeholder })=>{
    const { t: t } = (0, $3765cebd031b52c0$export$9fc83ad70ead8663)();
    const validationSchema = $cd7706ce94a8dfd1$export$185802fd694ee1f5({
        note: $bcc252d93ab3046c$export$185802fd694ee1f5().max(499, t("staff.note_validation_length"))
    });
    const formik = (0, $7YFi7.useFormik)({
        initialValues: {
            note: String(sp.note)
        },
        validationSchema: validationSchema,
        onSubmit: (values)=>{
            setSPNote({
                spId: sp.id,
                note: values.note
            });
        }
    });
    const handleChange = async (e)=>{
        const { name: name, value: value } = e.target;
        // Validate the new value
        try {
            await validationSchema.validateAt(name, {
                [name]: value
            });
            // If valid, update the value in Formik state
            formik.setFieldValue(name, value, true) // Pass true to trigger validation
            ;
            formik.setFieldTouched(name, true) // Mark field as touched
            ;
            formik.submitForm() // Automatically submit form on change
            ;
        } catch (error) {
            // If invalid, show toast notification
            if (error instanceof $d2e70d35996a7daf$export$2e2bcd8739ae039) (0, $60f27fc97e29822a$export$b410431fab84fa58).error(error.message);
        }
    };
    const handleChangeWrapper = (e)=>{
        handleChange(e).catch((error)=>{
            console.error("Error handling change:", error);
        });
    };
    (0, $acw62.useEffect)(()=>{
        if (formik.errors.note && formik.touched.note) (0, $60f27fc97e29822a$export$b410431fab84fa58).error(formik.errors.note);
    }, [
        formik.errors,
        formik.touched
    ]);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("textarea", {
        className: className,
        placeholder: placeholder,
        name: "note",
        id: "note",
        value: formik.values.note,
        onChange: handleChangeWrapper
    });
};




const $95e21e0055cf38fd$export$8b0036ef4f4ccb34 = (0, $aca50e9407ba89c9$export$b6ae1bc530f4c149)(({ sp: sp, setSPNote: setSPNote, setSPLastJobRating: setSPLastJobRating, toggleIsFavorite: toggleIsFavorite })=>{
    const { t: t } = (0, $3765cebd031b52c0$export$9fc83ad70ead8663)();
    const [isEditRatingMode, setIsEditRatingMode] = (0, $acw62.useState)(sp.client_rating_for_last_job === null);
    const [isProfileShown, setIsProfileShown] = (0, $acw62.useState)(false);
    const changeProfileShown = (value)=>{
        if (value) (0, $c74a0566d4b0fd6d$export$e9db7d6e73593439).track((0, $c74a0566d4b0fd6d$export$5e27155e276f6d1c).PastWorkersProfileOpened);
        setIsProfileShown(value);
    };
    const handleSetRating = (value)=>{
        setSPLastJobRating({
            spId: sp.id,
            rating: value,
            locationId: (0, $7c4dcc15da63a765$export$8a7f818a713a8cb0).searchFilters.locationId,
            workCategoryId: (0, $7c4dcc15da63a765$export$8a7f818a713a8cb0).searchFilters.designationId
        });
        setIsEditRatingMode(false);
    };
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("tr", {
        className: "WorkersList__table__item",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                className: "WorkersList__table__item__main",
                style: {
                    width: "20%"
                },
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: "WorkersList__table__item__expanded",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: "WorkersList__table__item__left",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                                    className: "WorkersList__table__item__info__image",
                                    onClick: ()=>changeProfileShown(true),
                                    src: sp.image_url ?? undefined
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                    className: "WorkersList__table__item__info",
                                    onClick: ()=>changeProfileShown(true),
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                            className: "WorkersList__table__item__info__primary",
                                            children: sp.name
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                            className: "WorkersList__table__item__info__secondary",
                                            children: t("common.id_n", {
                                                id: sp.id
                                            })
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                            className: "WorkersList__table__item__info__icon",
                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $52e5809c84cfd79a$export$51def8c33e56fa36), {
                                isActive: sp.is_favorite,
                                onClick: ()=>toggleIsFavorite({
                                        spId: sp.id
                                    })
                            })
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                style: {
                    width: "13%"
                },
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                    className: "WorkersList__table__item__info",
                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                        className: "WorkersList__table__item__info__primary",
                        children: sp.designations[0]
                    })
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                style: {
                    width: "8%"
                },
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                    className: "WorkersList__table__item__info",
                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                        className: "WorkersList__table__item__info__primary",
                        children: t("staff.n_shifts", {
                            shiftsAmount: sp.shifts_amount_worked_for_client
                        })
                    })
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                style: {
                    width: "8%"
                },
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                    className: "WorkersList__table__item__info",
                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                        className: "WorkersList__table__item__info__primary",
                        children: sp.last_job_end_date
                    })
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                style: {
                    width: "13%"
                },
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                    className: "WorkersList__table__item__info",
                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                        className: "WorkersList__table__item__info__primary",
                        children: sp.locations[0].length > 25 ? `${sp.locations[0].slice(0, 25)}...` : sp.locations[0]
                    })
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                style: {
                    width: "13%"
                },
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                    className: "WorkersList__table__item__expanded",
                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $77c0756c654a0212$export$8ba663d22f9191ae), {
                        isEditRatingMode: isEditRatingMode,
                        setIsEditRatingMode: setIsEditRatingMode,
                        rating: Number(sp.client_rating_for_last_job),
                        handleSetRating: handleSetRating
                    })
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                style: {
                    width: "25%"
                },
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                    className: "WorkersList__table__item__info",
                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $a7156574ce15644d$export$13baa3ebe801eedd), {
                        setSPNote: setSPNote,
                        sp: sp,
                        className: "WorkersList__table__item__info__textarea",
                        placeholder: ""
                    })
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $9c16b10bbbe042e5$export$129a32eedafa97c5), {
                isActive: isProfileShown,
                content: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c665f284476b5703$export$2e2bcd8739ae039), {
                    jobId: String(sp.last_job_id),
                    jobType: (0, $862a04ca6e0d681b$export$27a7f855854fa13d).oneTime,
                    applicantId: sp.id,
                    showHeader: false,
                    showControls: false
                }),
                close: ()=>changeProfileShown(false)
            })
        ]
    });
});





var $acw62 = parcelRequire("acw62");








const $25277b92014a3121$export$d14d08fa0d83d69d = (0, $aca50e9407ba89c9$export$b6ae1bc530f4c149)(({ sp: sp, setSPNote: setSPNote, setSPLastJobRating: setSPLastJobRating, toggleIsFavorite: toggleIsFavorite })=>{
    const { t: t } = (0, $3765cebd031b52c0$export$9fc83ad70ead8663)();
    const [isEditRatingMode, setIsEditRatingMode] = (0, $acw62.useState)(sp.client_rating_for_last_job === null);
    const [isProfileShown, setIsProfileShown] = (0, $acw62.useState)(false);
    const handleSetRating = (value)=>{
        setSPLastJobRating({
            spId: sp.id,
            rating: value,
            locationId: (0, $7c4dcc15da63a765$export$8a7f818a713a8cb0).searchFilters.locationId,
            workCategoryId: (0, $7c4dcc15da63a765$export$8a7f818a713a8cb0).searchFilters.designationId
        });
        setIsEditRatingMode(false);
    };
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "WorkersList__item",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "WorkersList__item__header",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "WorkersList__item__header__left",
                        onClick: ()=>setIsProfileShown(true),
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                                className: "WorkersList__item__header__image",
                                src: sp.image_url ?? undefined
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "WorkersList__item__header__info",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                        className: "WorkersList__item__header__info__minor",
                                        children: t("common.id_n", {
                                            id: sp.id
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                        className: "WorkersList__item__header__info__primary",
                                        children: sp.name
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                        className: "WorkersList__item__header__info__secondary",
                                        children: sp.designations.join(", ")
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "WorkersList__item__header__right",
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                            className: "WorkersList__item__header__actionsContainer",
                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $52e5809c84cfd79a$export$51def8c33e56fa36), {
                                isActive: sp.is_favorite,
                                onClick: ()=>toggleIsFavorite({
                                        spId: sp.id
                                    })
                            })
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "WorkersList__item__body",
                onClick: ()=>setIsProfileShown(true),
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "WorkersList__item__body__row",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "WorkersList__item__body__info",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                        className: "WorkersList__item__body__info__minor",
                                        children: t("staff.hours_worked")
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                        className: "WorkersList__item__body__info__primary",
                                        children: t("staff.n_hours", {
                                            hoursAmount: sp.hours_amount_worked_for_client
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                        className: "WorkersList__item__body__info__minor",
                                        children: t("staff.n_shifts", {
                                            shiftsAmount: sp.shifts_amount_worked_for_client
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "WorkersList__item__body__info",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                        className: "WorkersList__item__body__info__minor",
                                        children: t("staff.last_job")
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                        className: "WorkersList__item__body__info__primary",
                                        children: sp.last_job_end_date
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                        className: "WorkersList__item__body__info__minor",
                                        children: t("common.job_n", {
                                            id: sp.last_job_id
                                        })
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "WorkersList__item__body__row",
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: "WorkersList__item__body__info",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                    className: "WorkersList__item__body__info__minor",
                                    children: t("staff.locations_worked")
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                    className: "WorkersList__item__body__info__primary",
                                    children: sp.locations[0]
                                }),
                                sp.locations.length > 1 ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                    className: "WorkersList__item__body__info__minor",
                                    children: t("staff.plus_n_locations", {
                                        locationsAmount: sp.locations.length - 1
                                    })
                                }) : null
                            ]
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $77c0756c654a0212$export$8ba663d22f9191ae), {
                isEditRatingMode: isEditRatingMode,
                setIsEditRatingMode: setIsEditRatingMode,
                rating: Number(sp.client_rating_for_last_job),
                handleSetRating: handleSetRating
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "WorkersList__item__note",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $a7156574ce15644d$export$13baa3ebe801eedd), {
                    setSPNote: setSPNote,
                    sp: sp,
                    className: "WorkersList__item__info__textarea",
                    placeholder: t("staff.enter_notes_on_worker")
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $9c16b10bbbe042e5$export$129a32eedafa97c5), {
                isActive: isProfileShown,
                content: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c665f284476b5703$export$2e2bcd8739ae039), {
                    jobId: String(sp.last_job_id),
                    jobType: (0, $862a04ca6e0d681b$export$27a7f855854fa13d).oneTime,
                    applicantId: sp.id,
                    showHeader: false,
                    showControls: false
                }),
                close: ()=>setIsProfileShown(false)
            })
        ]
    });
});










const $d83e7e0e0425d2af$export$e4c291d45fea4cd0 = ({ isEnabled: isEnabled, onClick: onClick })=>{
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("svg", {
        onClick: onClick,
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M14.0002 7.99994L10.0002 11.9999L14.0002 15.9999",
            stroke: isEnabled ? "#7767E4" : "#BABED6",
            strokeWidth: "2",
            strokeLinecap: "round",
            strokeLinejoin: "round"
        })
    });
};



const $62c9aae988e30868$export$acad20503ad73ac1 = ({ isEnabled: isEnabled, onClick: onClick })=>{
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("svg", {
        onClick: onClick,
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M10 16L14 12L10 8",
            stroke: isEnabled ? "#7767E4" : "#BABED6",
            strokeWidth: "2",
            strokeLinecap: "round",
            strokeLinejoin: "round"
        })
    });
};


const $8516dc31a825b87b$export$68f5e1453c188a82 = ({ currentPage: currentPage, setCurrentPage: setCurrentPage, fetchPastWorkers: fetchPastWorkers, pastSPsPagesCount: pastSPsPagesCount, isFetching: isFetching })=>{
    const { t: t } = (0, $3765cebd031b52c0$export$9fc83ad70ead8663)();
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "WorkersList__filters__pagination desktop-only",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $d83e7e0e0425d2af$export$e4c291d45fea4cd0), {
                isEnabled: currentPage > 1,
                onClick: ()=>{
                    if (currentPage <= 1 || isFetching) return;
                    const newPage = currentPage - 1;
                    setCurrentPage(newPage);
                    fetchPastWorkers(newPage);
                }
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "WorkersList__filters__pagination__pages",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                        className: "WorkersList__filters__pagination__pageText",
                        children: t("pagination.page")
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "WorkersList__filters__pagination__pageValue",
                        children: currentPage
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                        className: "WorkersList__filters__pagination__pageText",
                        children: [
                            t("pagination.of"),
                            " ",
                            pastSPsPagesCount
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $62c9aae988e30868$export$acad20503ad73ac1), {
                isEnabled: currentPage < pastSPsPagesCount,
                onClick: ()=>{
                    if (currentPage >= pastSPsPagesCount || isFetching) return;
                    const newPage = currentPage + 1;
                    setCurrentPage(newPage);
                    fetchPastWorkers(newPage);
                }
            })
        ]
    });
};



parcelRequire("acw62");

const $85058d04a1239b32$export$78641b01985611f1 = ({ count: count, icon: icon })=>{
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "total",
        children: [
            icon,
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                className: "total__title",
                children: count
            })
        ]
    });
};


var $6601e3620a1f2f1a$exports = {};
$6601e3620a1f2f1a$exports = new URL("users.a89ad9e9.svg", import.meta.url).toString();





const $c56594d36fa62581$export$6f7103c66aa7f4e0 = (0, $aca50e9407ba89c9$export$b6ae1bc530f4c149)(()=>{
    const { t: t } = (0, $3765cebd031b52c0$export$9fc83ad70ead8663)();
    const [showFilters, setShowFilters] = (0, $acw62.useState)(false);
    const [currentPage, setCurrentPage] = (0, $acw62.useState)(1);
    const [sortByFilter, setSortByFilter] = (0, $acw62.useState)((0, $b85cce87524a4e0b$export$555900f8c568d22c));
    const [orderByFilter, setOrderByFilter] = (0, $acw62.useState)("DESC");
    const { getPastSPs: getPastSPs, pastSPsList: pastSPsList, pastSPsPagesCount: pastSPsPagesCount, pastSPsTotalCount: pastSPsTotalCount, pastSPsNextPage: pastSPsNextPage, setSPNote: setSPNote, setSPLastJobRating: setSPLastJobRating, toggleIsFavorite: toggleIsFavorite } = (0, $4671947198ddd366$export$6ccbb43953eebf8)().data;
    const [getPastSPsResult, getPastSPsRequest] = (0, $4671947198ddd366$export$609860bf8b0084c)(({ page: page, sortBy: sortBy, orderBy: orderBy, collect: collect, locationId: locationId, designationId: designationId, isFavorite: isFavorite, searchString: searchString })=>getPastSPs({
            page: page,
            searchString: searchString,
            collect: collect,
            sortBy: sortBy,
            orderBy: orderBy,
            locationId: locationId,
            designationId: designationId,
            isFavorite: isFavorite
        }));
    const fetchPastWorkers = (page, sortBy, orderBy, collect)=>{
        const appliedFilters = [];
        if ((0, $7c4dcc15da63a765$export$8a7f818a713a8cb0).searchFilters.locationId !== null) appliedFilters.push("locationId");
        if ((0, $7c4dcc15da63a765$export$8a7f818a713a8cb0).searchFilters.designationId !== null) appliedFilters.push("designationId");
        if ((0, $7c4dcc15da63a765$export$8a7f818a713a8cb0).searchFilters.isFavorite === true) appliedFilters.push("isFavorite");
        if ((0, $7c4dcc15da63a765$export$8a7f818a713a8cb0).searchFilters.searchString !== "") appliedFilters.push("searchString");
        if (appliedFilters.length > 0) (0, $c74a0566d4b0fd6d$export$e9db7d6e73593439).track((0, $c74a0566d4b0fd6d$export$5e27155e276f6d1c).PastWorkersListFiltersApplied, {
            filters: appliedFilters.join(",")
        });
        if (page !== undefined && page > 1) (0, $c74a0566d4b0fd6d$export$e9db7d6e73593439).track((0, $c74a0566d4b0fd6d$export$5e27155e276f6d1c).PastWorkersListPaginationUsed);
        getPastSPsRequest({
            page: page ?? currentPage,
            sortBy: sortBy ?? sortByFilter,
            orderBy: orderBy ?? orderByFilter,
            collect: collect ?? false,
            locationId: (0, $7c4dcc15da63a765$export$8a7f818a713a8cb0).searchFilters.locationId,
            designationId: (0, $7c4dcc15da63a765$export$8a7f818a713a8cb0).searchFilters.designationId,
            isFavorite: (0, $7c4dcc15da63a765$export$8a7f818a713a8cb0).searchFilters.isFavorite,
            searchString: (0, $7c4dcc15da63a765$export$8a7f818a713a8cb0).searchFilters.searchString
        });
    };
    const [, setSPNoteRequest] = (0, $4671947198ddd366$export$609860bf8b0084c)(({ spId: spId, note: note })=>setSPNote(spId, note), {
        onError: (err)=>{
            (0, $60f27fc97e29822a$export$b410431fab84fa58).error(err.data.message);
        },
        filterError: [
            (0, $9ad33fbf770c55a1$export$9696fcf1798e1cb5).ClientError,
            (0, $9ad33fbf770c55a1$export$9696fcf1798e1cb5).NotFound
        ]
    });
    const [, toggleIsFavoriteRequest] = (0, $4671947198ddd366$export$609860bf8b0084c)(({ spId: spId })=>toggleIsFavorite(spId), {
        onError: (err)=>{
            (0, $60f27fc97e29822a$export$b410431fab84fa58).error(err.data.message);
        },
        filterError: [
            (0, $9ad33fbf770c55a1$export$9696fcf1798e1cb5).ClientError,
            (0, $9ad33fbf770c55a1$export$9696fcf1798e1cb5).NotFound
        ]
    });
    const [, setSPLastJobRatingRequest] = (0, $4671947198ddd366$export$609860bf8b0084c)(({ spId: spId, rating: rating, locationId: locationId, workCategoryId: workCategoryId })=>setSPLastJobRating(spId, rating, locationId, workCategoryId), {
        onSuccess: (result)=>{
            (0, $60f27fc97e29822a$export$b410431fab84fa58).success(t("staff.rating_submitted"));
        },
        onError: (err)=>{
            (0, $60f27fc97e29822a$export$b410431fab84fa58).error(err.data.errors?.note[0]);
        },
        filterError: [
            (0, $9ad33fbf770c55a1$export$9696fcf1798e1cb5).ClientError,
            (0, $9ad33fbf770c55a1$export$9696fcf1798e1cb5).NotFound
        ]
    });
    const setRating = (params)=>{
        (0, $c74a0566d4b0fd6d$export$e9db7d6e73593439).track((0, $c74a0566d4b0fd6d$export$5e27155e276f6d1c).RatingSet, {
            source: "PastWorkersPage",
            isChange: pastSPsList.find((item)=>item.id === params.spId)?.client_rating_for_last_job !== null
        });
        (0, $c74a0566d4b0fd6d$export$e9db7d6e73593439).track((0, $c74a0566d4b0fd6d$export$5e27155e276f6d1c).RatingSetFromPastWorkers);
        setSPLastJobRatingRequest(params);
    };
    const changeIsFavorite = (params)=>{
        const isRemoving = pastSPsList.find((item)=>item.id === params.spId)?.is_favorite ?? false;
        if (isRemoving) (0, $c74a0566d4b0fd6d$export$e9db7d6e73593439).track((0, $c74a0566d4b0fd6d$export$5e27155e276f6d1c).FavoriteRemoved);
        else (0, $c74a0566d4b0fd6d$export$e9db7d6e73593439).track((0, $c74a0566d4b0fd6d$export$5e27155e276f6d1c).FavoriteAdded);
        toggleIsFavoriteRequest(params);
    };
    const handleScroll = (0, $324dc7daf4e64dab$export$5bd4c3b2b0a1aaf1)(()=>{
        if (pastSPsNextPage) fetchPastWorkers(pastSPsNextPage, sortByFilter, orderByFilter, true);
    });
    (0, $acw62.useEffect)(()=>{
        (0, $c74a0566d4b0fd6d$export$e9db7d6e73593439).track((0, $c74a0566d4b0fd6d$export$5e27155e276f6d1c).PastWorkersPageOpened);
        fetchPastWorkers();
    }, []);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "WorkersList",
        onScroll: handleScroll,
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7ae42b63183f30b4$export$8b251419efc915eb), {
                title: t("staff.past_workers")
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $660b2ca422e0e2ae$export$1ff3c3f08ae963c0).Vertical, {
                height: 35
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "WorkersList__container",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: "WorkersList__content",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: "WorkersList__filters",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $85058d04a1239b32$export$78641b01985611f1), {
                                    count: pastSPsTotalCount,
                                    icon: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                                        src: (0, (/*@__PURE__*/$parcel$interopDefault($6601e3620a1f2f1a$exports)))
                                    })
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $db7fb73ce5c45471$export$55d7609a8f1eccd2), {
                                    value: String((0, $7c4dcc15da63a765$export$8a7f818a713a8cb0).searchFilters.searchString),
                                    handleValueChange: (value)=>{
                                        (0, $7c4dcc15da63a765$export$8a7f818a713a8cb0).setSearchString(value);
                                        fetchPastWorkers(1);
                                    },
                                    className: "WorkersList__filters__searchInput desktop-only",
                                    placeholder: t("staff.search_worker_by_id_or_name")
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $1a76ba0c0e8a8aa8$export$16bac73b44412208), {
                                    setShowFilters: setShowFilters,
                                    activeFiltersCount: (0, $7c4dcc15da63a765$export$8a7f818a713a8cb0).activeFiltersCount
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $8516dc31a825b87b$export$68f5e1453c188a82), {
                                    currentPage: currentPage,
                                    setCurrentPage: setCurrentPage,
                                    fetchPastWorkers: (page)=>fetchPastWorkers(page),
                                    pastSPsPagesCount: pastSPsPagesCount,
                                    isFetching: getPastSPsResult.isLoading
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                            className: "WorkersList__filters mobile-only",
                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $db7fb73ce5c45471$export$55d7609a8f1eccd2), {
                                value: String((0, $7c4dcc15da63a765$export$8a7f818a713a8cb0).searchFilters.searchString),
                                handleValueChange: (value)=>{
                                    (0, $7c4dcc15da63a765$export$8a7f818a713a8cb0).setSearchString(value);
                                    fetchPastWorkers(1);
                                },
                                className: "WorkersList__filters__searchInput",
                                placeholder: t("staff.search_worker_by_id_or_name")
                            })
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: "WorkersList__listContainer",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                                    children: [
                                        pastSPsList.length > 0 ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("table", {
                                            className: "WorkersList__table desktop-only",
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("tr", {
                                                    className: "WorkersList__table__head",
                                                    children: [
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                                    children: t("staff.worker_name")
                                                                })
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                                    children: t("staff.last_designation")
                                                                })
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                                    children: t("staff.shifts_worked")
                                                                })
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                                onClick: ()=>{
                                                                    const newSortBy = (0, $b85cce87524a4e0b$export$555900f8c568d22c);
                                                                    let newOrderBy = "DESC";
                                                                    if (sortByFilter === (0, $b85cce87524a4e0b$export$555900f8c568d22c)) newOrderBy = orderByFilter === "ASC" ? "DESC" : "ASC";
                                                                    setSortByFilter(newSortBy);
                                                                    setOrderByFilter(newOrderBy);
                                                                    (0, $c74a0566d4b0fd6d$export$e9db7d6e73593439).track((0, $c74a0566d4b0fd6d$export$5e27155e276f6d1c).PastWorkersListSortUsed, {
                                                                        sort: `${newSortBy} ${newOrderBy}`
                                                                    });
                                                                    fetchPastWorkers(currentPage, newSortBy, newOrderBy);
                                                                },
                                                                className: "WorkersList__table__head__column cursor-pointer",
                                                                children: [
                                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                                        children: t("staff.last_job")
                                                                    }),
                                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7217ece7f91e41f7$export$d43f91ac58cde147), {
                                                                        sortDirection: sortByFilter === (0, $b85cce87524a4e0b$export$555900f8c568d22c) ? orderByFilter : null
                                                                    })
                                                                ]
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                                    children: t("staff.last_location")
                                                                })
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                                onClick: ()=>{
                                                                    const newSortBy = (0, $b85cce87524a4e0b$export$827cdec97a8508ca);
                                                                    let newOrderBy = "DESC";
                                                                    if (sortByFilter === (0, $b85cce87524a4e0b$export$827cdec97a8508ca)) newOrderBy = orderByFilter === "ASC" ? "DESC" : "ASC";
                                                                    setSortByFilter(newSortBy);
                                                                    setOrderByFilter(newOrderBy);
                                                                    (0, $c74a0566d4b0fd6d$export$e9db7d6e73593439).track((0, $c74a0566d4b0fd6d$export$5e27155e276f6d1c).PastWorkersListSortUsed, {
                                                                        sort: `${newSortBy} ${newOrderBy}`
                                                                    });
                                                                    fetchPastWorkers(currentPage, newSortBy, newOrderBy);
                                                                },
                                                                className: "WorkersList__table__head__column cursor-pointer",
                                                                children: [
                                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                                        children: t("staff.your_rating")
                                                                    }),
                                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7217ece7f91e41f7$export$d43f91ac58cde147), {
                                                                        sortDirection: sortByFilter === (0, $b85cce87524a4e0b$export$827cdec97a8508ca) ? orderByFilter : null
                                                                    })
                                                                ]
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                                    children: t("staff.notes")
                                                                })
                                                            })
                                                        })
                                                    ]
                                                }),
                                                pastSPsList.map((sp)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $95e21e0055cf38fd$export$8b0036ef4f4ccb34), {
                                                        sp: sp,
                                                        setSPNote: setSPNoteRequest,
                                                        setSPLastJobRating: setRating,
                                                        toggleIsFavorite: changeIsFavorite
                                                    }, sp.id))
                                            ]
                                        }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7b02d682eb115277$exports.Fragment), {
                                            children: !getPastSPsResult.isLoading && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                className: "WorkersList__emptyList desktop-only",
                                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                    children: t("staff.no_workers_found")
                                                })
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                            className: "WorkersList__items mobile-only",
                                            children: pastSPsList.length > 0 ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7b02d682eb115277$exports.Fragment), {
                                                children: pastSPsList.map((sp)=>{
                                                    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $25277b92014a3121$export$d14d08fa0d83d69d), {
                                                        sp: sp,
                                                        setSPNote: setSPNoteRequest,
                                                        setSPLastJobRating: setRating,
                                                        toggleIsFavorite: changeIsFavorite
                                                    }, sp.id);
                                                })
                                            }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7b02d682eb115277$exports.Fragment), {
                                                children: !getPastSPsResult.isLoading && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                    className: "WorkersList__emptyList mobile-only",
                                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                        children: t("staff.no_workers_found")
                                                    })
                                                })
                                            })
                                        })
                                    ]
                                }),
                                getPastSPsResult.isLoading && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $57fb8f45c69e1681$export$2e2bcd8739ae039), {})
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $a4b7c1ff8b9d775f$export$ac5177ff6a0d9687), {
                fields: [
                    "locationId",
                    "designationId",
                    "isFavorite"
                ],
                isOpen: showFilters,
                close: ()=>setShowFilters(false),
                locationId: (0, $7c4dcc15da63a765$export$8a7f818a713a8cb0).searchFilters.locationId ?? undefined,
                setLocationId: (value)=>(0, $7c4dcc15da63a765$export$8a7f818a713a8cb0).setLocationId(value ?? null),
                designationId: (0, $7c4dcc15da63a765$export$8a7f818a713a8cb0).searchFilters.designationId ?? undefined,
                setDesignationId: (value)=>(0, $7c4dcc15da63a765$export$8a7f818a713a8cb0).setDesignationId(value ?? null),
                isFavorite: (0, $7c4dcc15da63a765$export$8a7f818a713a8cb0).searchFilters.isFavorite,
                setIsFavorite: (value)=>(0, $7c4dcc15da63a765$export$8a7f818a713a8cb0).setIsFavorite(value),
                apply: ()=>{
                    setShowFilters(false);
                    fetchPastWorkers(1);
                },
                reset: ()=>{
                    (0, $7c4dcc15da63a765$export$8a7f818a713a8cb0).reset();
                    setShowFilters(false);
                    fetchPastWorkers(1);
                }
            })
        ]
    });
});







var $45fvw = parcelRequire("45fvw");

var $acw62 = parcelRequire("acw62");
var $a1793699ffe14d34$exports = {};
$a1793699ffe14d34$exports = new URL("calendar.ee93821a.svg", import.meta.url).toString();


var $a4d897a08a14d064$exports = {};
$a4d897a08a14d064$exports = new URL("alert.6a2c307a.svg", import.meta.url).toString();







const $9cbe21b099aa6670$export$830af6106941f2b = (0, $aca50e9407ba89c9$export$b6ae1bc530f4c149)(()=>{
    const { t: t } = (0, $3765cebd031b52c0$export$9fc83ad70ead8663)();
    const { disputesList: disputesList, getDisputes: getDisputes, resolveDispute: resolveDispute, declineDispute: declineDispute } = (0, $4671947198ddd366$export$6ccbb43953eebf8)().data;
    const [, getDisputesListApiCall] = (0, $4671947198ddd366$export$609860bf8b0084c)(({ page: page })=>getDisputes({
            page: page
        }));
    const [, resolveDisputeApiCall] = (0, $4671947198ddd366$export$609860bf8b0084c)(({ id: id })=>resolveDispute({
            id: id
        }));
    const [, declineDisputeApiCall] = (0, $4671947198ddd366$export$609860bf8b0084c)(({ id: id })=>declineDispute({
            id: id
        }));
    (0, $acw62.useEffect)(()=>{
        getDisputesListApiCall({
            page: 1
        });
    }, []);
    const handleScroll = (0, $324dc7daf4e64dab$export$5bd4c3b2b0a1aaf1)(()=>getDisputesListApiCall({}));
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "DisputesList",
        onScroll: handleScroll,
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7ae42b63183f30b4$export$8b251419efc915eb), {
                title: "Disputes"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $660b2ca422e0e2ae$export$1ff3c3f08ae963c0).Vertical, {
                height: 35
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "DisputesList__list",
                children: disputesList.map((dispute)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "DisputesList__disputeItem",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "DisputesList__disputeItem__top",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        className: "DisputesList__disputeItem__top__left",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                className: "DisputesList__disputeItem__top__left__image",
                                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                                                    src: String(dispute.designation_image)
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                className: "DisputesList__disputeItem__top__left__description",
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                        className: "DisputesList__disputeItem__top__left__description__title",
                                                        children: dispute.designation_name
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                        className: "DisputesList__disputeItem__top__left__description__subtitle",
                                                        children: dispute.location
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                        className: "DisputesList__disputeItem__top__right",
                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                            className: "DisputesList__disputeItem__top__right__label",
                                            children: dispute.type === (0, $068089025ba7790f$export$ec4f5d5ed2b8555c) ? t("disputes.overtime") : t("disputes.no_show")
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                className: "DisputesList__disputeItem__info",
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                    className: "DisputesList__disputeItem__info__date",
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                                            src: (0, (/*@__PURE__*/$parcel$interopDefault($a1793699ffe14d34$exports)))
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                            className: "DisputesList__disputeItem__info__date__value",
                                            children: (0, (/*@__PURE__*/$parcel$interopDefault($45fvw))).unix(dispute.shift_start_time).format("D MMMM YYYY")
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "DisputesList__disputeItem__body",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        className: "DisputesList__disputeItem__body__info",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                                                src: String(dispute.sp_image)
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                className: "DisputesList__disputeItem__body__info__title",
                                                children: dispute.sp_name
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        className: "DisputesList__disputeItem__body__attendance",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                className: "DisputesList__disputeItem__body__attendance__title",
                                                children: t("disputes.og_attendance")
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                className: "DisputesList__disputeItem__body__attendance__table",
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                        className: "DisputesList__disputeItem__body__attendance__table__value",
                                                        children: [
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                                className: "DisputesList__disputeItem__body__attendance__table__value__title",
                                                                children: t("disputes.check_in")
                                                            }),
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                                className: "DisputesList__disputeItem__body__attendance__table__value__value",
                                                                children: (0, (/*@__PURE__*/$parcel$interopDefault($45fvw))).unix(Number(dispute.sp_checkin_time)).format("h:mmA")
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                        className: "DisputesList__disputeItem__body__attendance__table__value",
                                                        children: [
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                                className: "DisputesList__disputeItem__body__attendance__table__value__title",
                                                                children: t("disputes.check_out")
                                                            }),
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                                className: "DisputesList__disputeItem__body__attendance__table__value__value",
                                                                children: (0, (/*@__PURE__*/$parcel$interopDefault($45fvw))).unix(Number(dispute.sp_checkout_time)).format("h:mmA")
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                        className: "DisputesList__disputeItem__body__attendance__table__value",
                                                        children: [
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                                className: "DisputesList__disputeItem__body__attendance__table__value__title__container",
                                                                children: [
                                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                                        className: "DisputesList__disputeItem__body__attendance__table__value__title",
                                                                        children: t("disputes.total_hours")
                                                                    }),
                                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                                                                        src: (0, (/*@__PURE__*/$parcel$interopDefault($a4d897a08a14d064$exports)))
                                                                    })
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                                className: "DisputesList__disputeItem__body__attendance__table__value__value highlight-red",
                                                                children: t("disputes.n_hours", {
                                                                    count: Number(dispute.sp_total_hours)
                                                                })
                                                            })
                                                        ]
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    dispute.type === (0, $068089025ba7790f$export$ec4f5d5ed2b8555c) && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $660b2ca422e0e2ae$export$1ff3c3f08ae963c0).Vertical, {
                                                height: 10
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                className: "DisputesList__disputeItem__body__attendance",
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                        className: "DisputesList__disputeItem__body__attendance__title",
                                                        children: t("disputes.your_attendance")
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                        className: "DisputesList__disputeItem__body__attendance__table",
                                                        children: [
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                                className: "DisputesList__disputeItem__body__attendance__table__value",
                                                                children: [
                                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                                        className: "DisputesList__disputeItem__body__attendance__table__value__title",
                                                                        children: t("disputes.check_in")
                                                                    }),
                                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                                        className: "DisputesList__disputeItem__body__attendance__table__value__value",
                                                                        children: (0, (/*@__PURE__*/$parcel$interopDefault($45fvw))).unix(Number(dispute.client_checkin_time)).format("h:mmA")
                                                                    })
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                                className: "DisputesList__disputeItem__body__attendance__table__value",
                                                                children: [
                                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                                        className: "DisputesList__disputeItem__body__attendance__table__value__title",
                                                                        children: t("disputes.check_out")
                                                                    }),
                                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                                        className: "DisputesList__disputeItem__body__attendance__table__value__value",
                                                                        children: (0, (/*@__PURE__*/$parcel$interopDefault($45fvw))).unix(Number(dispute.client_checkout_time)).format("h:mmA")
                                                                    })
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                                className: "DisputesList__disputeItem__body__attendance__table__value",
                                                                children: [
                                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                                        className: "DisputesList__disputeItem__body__attendance__table__value__title__container",
                                                                        children: [
                                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                                                className: "DisputesList__disputeItem__body__attendance__table__value__title",
                                                                                children: t("disputes.total_hours")
                                                                            }),
                                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                                                                                src: (0, (/*@__PURE__*/$parcel$interopDefault($a4d897a08a14d064$exports)))
                                                                            })
                                                                        ]
                                                                    }),
                                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                                        className: "DisputesList__disputeItem__body__attendance__table__value__value highlight-red",
                                                                        children: t("disputes.n_hours", {
                                                                            count: Number(dispute.client_total_hours)
                                                                        })
                                                                    })
                                                                ]
                                                            })
                                                        ]
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $660b2ca422e0e2ae$export$1ff3c3f08ae963c0).Vertical, {
                                        height: 5
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        className: "DisputesList__disputeItem__body__alert",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                                                src: (0, (/*@__PURE__*/$parcel$interopDefault($a4d897a08a14d064$exports)))
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                className: "DisputesList__disputeItem__body__alert__content",
                                                children: [
                                                    dispute.type === (0, $068089025ba7790f$export$ec4f5d5ed2b8555c) ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                        className: "DisputesList__disputeItem__body__alert__text",
                                                        children: t("disputes.og_claims_n_hours_more", {
                                                            count: Number(dispute.sp_total_hours) - Number(dispute.client_total_hours)
                                                        })
                                                    }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                        className: "DisputesList__disputeItem__body__alert__text",
                                                        children: t("disputes.og_claims_show_up")
                                                    }),
                                                    dispute.sp_comment && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                                        className: "DisputesList__disputeItem__body__alert__comment",
                                                        children: [
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                                                className: "DisputesList__disputeItem__body__alert__comment__label",
                                                                children: [
                                                                    t("disputes.og_comment"),
                                                                    ":"
                                                                ]
                                                            }),
                                                            " ",
                                                            dispute.sp_comment
                                                        ]
                                                    }),
                                                    dispute.sp_file && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("a", {
                                                        href: dispute.sp_file,
                                                        target: "_blank",
                                                        rel: "noopener noreferrer",
                                                        className: "DisputesList__disputeItem__body__alert__file",
                                                        children: t("disputes.view_attached_file")
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            }),
                            dispute.status === (0, $068089025ba7790f$export$bb355e251db77a4b) && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "DisputesList__disputeItem__actions",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                        onClick: ()=>{
                                            if (confirm(t("disputes.are_you_sure_to_agree"))) {
                                                resolveDisputeApiCall({
                                                    id: dispute.id
                                                });
                                                (0, $60f27fc97e29822a$export$b410431fab84fa58).success(t("disputes.dispute_resolved"));
                                            }
                                        },
                                        className: "DisputesList__disputeItem__actions__confirm",
                                        children: t("disputes.i_agree")
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                        onClick: ()=>{
                                            if (confirm(t("disputes.are_you_sure_to_decline"))) {
                                                declineDisputeApiCall({
                                                    id: dispute.id
                                                });
                                                (0, $60f27fc97e29822a$export$b410431fab84fa58).success(t("disputes.dispute_declined"));
                                            }
                                        },
                                        className: "DisputesList__disputeItem__actions__reject",
                                        children: t("disputes.i_dont_agree")
                                    })
                                ]
                            }),
                            dispute.status === (0, $068089025ba7790f$export$f4e13e4cb382a08b) && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                className: "DisputesList__disputeItem__actions",
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                    className: "DisputesList__disputeItem__actions__confirm button-disabled",
                                    disabled: true,
                                    children: t("disputes.i_agree")
                                })
                            }),
                            dispute.status === (0, $068089025ba7790f$export$cbef048cd87bfeef) && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                className: "DisputesList__disputeItem__actions",
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                    className: "DisputesList__disputeItem__actions__reject",
                                    children: t("disputes.i_dont_agree")
                                })
                            })
                        ]
                    }, dispute.id))
            })
        ]
    });
});


const $3d0cab1c330ccde2$export$7245ae683f9a8f08 = {
    DisputesListPage: (0, $9cbe21b099aa6670$export$830af6106941f2b)
};


const $9d2af2844f10c458$export$b8a61e5c71402559 = {
    AuthStack: $e0e24e1e278716af$export$7867ff792998e7e4,
    CompleteRegistrationStack: $c2a180471e5e35a3$export$3cc38c065785b1c5,
    HomeStack: $27a686021bcba3a9$export$9fee8767af850feb,
    OrderStack: $c267d5bb6d73c4f3$export$31d56f5faa2670c6,
    ProfileStack: $651a1cb1639ca9ba$export$5382a454bcbe4573,
    ShiftsAttendanceStack: $372643303f22e332$export$34eaa31063f764e9,
    ApplicantsReviewStack: $a957d9f7f544561d$export$3d21776aad85d3f,
    JobsStack: $116fbdfde670ce8d$export$8e2c0157413104f5,
    LocationsStack: $fa8370b9eeaef971$export$5f239357e319234c,
    UsersManagmentStack: $96a1879f845e04b4$export$6a9f037beddd9ece,
    RatingRequestsStack: $f36ea5c0877e84ac$export$e626a3f00a9c18af,
    LeadGenerationStack: $5eadc612f1acf3fc$export$d523e0ec44fa5fa1,
    KnowledgeCenter: $4ffaf610e26cfed2$export$e9b34bfc08bf9d0c,
    SignUpWithOrderStack: $e8e5567118d21868$export$3178d6f323d850e8,
    ConfirmClientInvitationStack: $49c4fe8513f48deb$export$1e944eec5cc50f8e,
    PaymentStack: $14cad85e17fb050f$export$21aa143883c5cf14,
    AffiliateStack: $004b8b009d9026ac$export$a6d247afd1f2f5,
    PastWorkers: $c56594d36fa62581$export$6f7103c66aa7f4e0,
    DisputesStack: $3d0cab1c330ccde2$export$7245ae683f9a8f08
};









var $acw62 = parcelRequire("acw62");


const $1eb7b80ad2b5a7c5$export$46de9ba7af305689 = ()=>{
    const { logged: logged, updateUserLanguage: updateUserLanguage } = (0, $4671947198ddd366$export$6ccbb43953eebf8)().data;
    (0, $acw62.useEffect)(()=>{
        if (logged) callUpdateLanguage((0, $73ccb33f5de6f5aa$export$daa49e131b652e5b).getCurrentLanguage() ?? (0, $73ccb33f5de6f5aa$export$449b009f68cc9554));
    }, [
        logged
    ]);
    const [_, callUpdateLanguage] = (0, $4671947198ddd366$export$609860bf8b0084c)(updateUserLanguage);
};





var $acw62 = parcelRequire("acw62");
var $2be8636d379871d6$var$n, $2be8636d379871d6$var$o, $2be8636d379871d6$var$i = ($2be8636d379871d6$var$n = function(t, e) {
    return $2be8636d379871d6$var$n = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(t, e) {
        t.__proto__ = e;
    } || function(t, e) {
        for(var r in e)e.hasOwnProperty(r) && (t[r] = e[r]);
    }, $2be8636d379871d6$var$n(t, e);
}, function(t, e) {
    function r() {
        this.constructor = t;
    }
    $2be8636d379871d6$var$n(t, e), t.prototype = null === e ? Object.create(e) : (r.prototype = e.prototype, new r());
}), $2be8636d379871d6$var$a = function(t) {
    function e(e) {
        var r, n, o, i = this.constructor, a = t.call(this, e) || this;
        return Object.defineProperty(a, "name", {
            value: i.name,
            enumerable: !1,
            configurable: !0
        }), r = a, n = i.prototype, (o = Object.setPrototypeOf) ? o(r, n) : r.__proto__ = n, function(t, e) {
            void 0 === e && (e = t.constructor);
            var r = Error.captureStackTrace;
            r && r(t, e);
        }(a), a;
    }
    return $2be8636d379871d6$var$i(e, t), e;
}(Error), $2be8636d379871d6$var$u = function() {
    var t = function(e, r) {
        return t = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(t, e) {
            t.__proto__ = e;
        } || function(t, e) {
            for(var r in e)e.hasOwnProperty(r) && (t[r] = e[r]);
        }, t(e, r);
    };
    return function(e, r) {
        function n() {
            this.constructor = e;
        }
        t(e, r), e.prototype = null === r ? Object.create(r) : (n.prototype = r.prototype, new n());
    };
}(), $2be8636d379871d6$var$s = function(t) {
    function e(e) {
        void 0 === e && (e = void 0);
        var r = t.call(this, e) || this;
        return r.message = e, r;
    }
    return $2be8636d379871d6$var$u(e, t), e.prototype.getKind = function() {
        return this.constructor.kind;
    }, e.kind = "Exception", e;
}($2be8636d379871d6$var$a), $2be8636d379871d6$var$c = function() {
    var t = function(e, r) {
        return t = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(t, e) {
            t.__proto__ = e;
        } || function(t, e) {
            for(var r in e)e.hasOwnProperty(r) && (t[r] = e[r]);
        }, t(e, r);
    };
    return function(e, r) {
        function n() {
            this.constructor = e;
        }
        t(e, r), e.prototype = null === r ? Object.create(r) : (n.prototype = r.prototype, new n());
    };
}(), $2be8636d379871d6$var$f = function(t) {
    function e() {
        return null !== t && t.apply(this, arguments) || this;
    }
    return $2be8636d379871d6$var$c(e, t), e.kind = "ArgumentException", e;
}($2be8636d379871d6$var$s), $2be8636d379871d6$var$h = function() {
    var t = function(e, r) {
        return t = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(t, e) {
            t.__proto__ = e;
        } || function(t, e) {
            for(var r in e)e.hasOwnProperty(r) && (t[r] = e[r]);
        }, t(e, r);
    };
    return function(e, r) {
        function n() {
            this.constructor = e;
        }
        t(e, r), e.prototype = null === r ? Object.create(r) : (n.prototype = r.prototype, new n());
    };
}(), $2be8636d379871d6$var$l = function(t) {
    function e() {
        return null !== t && t.apply(this, arguments) || this;
    }
    return $2be8636d379871d6$var$h(e, t), e.kind = "IllegalArgumentException", e;
}($2be8636d379871d6$var$s), $2be8636d379871d6$var$d = function() {
    function t(t) {
        if (this.binarizer = t, null === t) throw new $2be8636d379871d6$var$l("Binarizer must be non-null.");
    }
    return t.prototype.getWidth = function() {
        return this.binarizer.getWidth();
    }, t.prototype.getHeight = function() {
        return this.binarizer.getHeight();
    }, t.prototype.getBlackRow = function(t, e) {
        return this.binarizer.getBlackRow(t, e);
    }, t.prototype.getBlackMatrix = function() {
        return null !== this.matrix && void 0 !== this.matrix || (this.matrix = this.binarizer.getBlackMatrix()), this.matrix;
    }, t.prototype.isCropSupported = function() {
        return this.binarizer.getLuminanceSource().isCropSupported();
    }, t.prototype.crop = function(e, r, n, o) {
        var i = this.binarizer.getLuminanceSource().crop(e, r, n, o);
        return new t(this.binarizer.createBinarizer(i));
    }, t.prototype.isRotateSupported = function() {
        return this.binarizer.getLuminanceSource().isRotateSupported();
    }, t.prototype.rotateCounterClockwise = function() {
        var e = this.binarizer.getLuminanceSource().rotateCounterClockwise();
        return new t(this.binarizer.createBinarizer(e));
    }, t.prototype.rotateCounterClockwise45 = function() {
        var e = this.binarizer.getLuminanceSource().rotateCounterClockwise45();
        return new t(this.binarizer.createBinarizer(e));
    }, t.prototype.toString = function() {
        try {
            return this.getBlackMatrix().toString();
        } catch (t) {
            return "";
        }
    }, t;
}(), $2be8636d379871d6$var$p = function() {
    var t = function(e, r) {
        return t = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(t, e) {
            t.__proto__ = e;
        } || function(t, e) {
            for(var r in e)e.hasOwnProperty(r) && (t[r] = e[r]);
        }, t(e, r);
    };
    return function(e, r) {
        function n() {
            this.constructor = e;
        }
        t(e, r), e.prototype = null === r ? Object.create(r) : (n.prototype = r.prototype, new n());
    };
}(), $2be8636d379871d6$var$g = function(t) {
    function e() {
        return null !== t && t.apply(this, arguments) || this;
    }
    return $2be8636d379871d6$var$p(e, t), e.getChecksumInstance = function() {
        return new e();
    }, e.kind = "ChecksumException", e;
}($2be8636d379871d6$var$s), $2be8636d379871d6$var$y = function() {
    function t(t) {
        this.source = t;
    }
    return t.prototype.getLuminanceSource = function() {
        return this.source;
    }, t.prototype.getWidth = function() {
        return this.source.getWidth();
    }, t.prototype.getHeight = function() {
        return this.source.getHeight();
    }, t;
}(), $2be8636d379871d6$var$w = function() {
    function t() {}
    return t.arraycopy = function(t, e, r, n, o) {
        for(; o--;)r[n++] = t[e++];
    }, t.currentTimeMillis = function() {
        return Date.now();
    }, t;
}(), $2be8636d379871d6$var$_ = function() {
    var t = function(e, r) {
        return t = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(t, e) {
            t.__proto__ = e;
        } || function(t, e) {
            for(var r in e)e.hasOwnProperty(r) && (t[r] = e[r]);
        }, t(e, r);
    };
    return function(e, r) {
        function n() {
            this.constructor = e;
        }
        t(e, r), e.prototype = null === r ? Object.create(r) : (n.prototype = r.prototype, new n());
    };
}(), $2be8636d379871d6$var$v = function(t) {
    function e() {
        return null !== t && t.apply(this, arguments) || this;
    }
    return $2be8636d379871d6$var$_(e, t), e.kind = "IndexOutOfBoundsException", e;
}($2be8636d379871d6$var$s), $2be8636d379871d6$var$m = function() {
    var t = function(e, r) {
        return t = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(t, e) {
            t.__proto__ = e;
        } || function(t, e) {
            for(var r in e)e.hasOwnProperty(r) && (t[r] = e[r]);
        }, t(e, r);
    };
    return function(e, r) {
        function n() {
            this.constructor = e;
        }
        t(e, r), e.prototype = null === r ? Object.create(r) : (n.prototype = r.prototype, new n());
    };
}(), $2be8636d379871d6$var$A = function(t) {
    function e(e, r) {
        void 0 === e && (e = void 0), void 0 === r && (r = void 0);
        var n = t.call(this, r) || this;
        return n.index = e, n.message = r, n;
    }
    return $2be8636d379871d6$var$m(e, t), e.kind = "ArrayIndexOutOfBoundsException", e;
}($2be8636d379871d6$var$v), $2be8636d379871d6$var$E = function(t) {
    var e = "function" == typeof Symbol && Symbol.iterator, r = e && t[e], n = 0;
    if (r) return r.call(t);
    if (t && "number" == typeof t.length) return {
        next: function() {
            return t && n >= t.length && (t = void 0), {
                value: t && t[n++],
                done: !t
            };
        }
    };
    throw new TypeError(e ? "Object is not iterable." : "Symbol.iterator is not defined.");
}, $2be8636d379871d6$var$C = function() {
    function t() {}
    return t.fill = function(t, e) {
        for(var r = 0, n = t.length; r < n; r++)t[r] = e;
    }, t.fillWithin = function(e, r, n, o) {
        t.rangeCheck(e.length, r, n);
        for(var i = r; i < n; i++)e[i] = o;
    }, t.rangeCheck = function(t, e, r) {
        if (e > r) throw new $2be8636d379871d6$var$l("fromIndex(" + e + ") > toIndex(" + r + ")");
        if (e < 0) throw new $2be8636d379871d6$var$A(e);
        if (r > t) throw new $2be8636d379871d6$var$A(r);
    }, t.asList = function() {
        for(var t = [], e = 0; e < arguments.length; e++)t[e] = arguments[e];
        return t;
    }, t.create = function(t, e, r) {
        return Array.from({
            length: t
        }).map(function(t) {
            return Array.from({
                length: e
            }).fill(r);
        });
    }, t.createInt32Array = function(t, e, r) {
        return Array.from({
            length: t
        }).map(function(t) {
            return Int32Array.from({
                length: e
            }).fill(r);
        });
    }, t.equals = function(t, e) {
        if (!t) return !1;
        if (!e) return !1;
        if (!t.length) return !1;
        if (!e.length) return !1;
        if (t.length !== e.length) return !1;
        for(var r = 0, n = t.length; r < n; r++)if (t[r] !== e[r]) return !1;
        return !0;
    }, t.hashCode = function(t) {
        var e, r;
        if (null === t) return 0;
        var n = 1;
        try {
            for(var o = $2be8636d379871d6$var$E(t), i = o.next(); !i.done; i = o.next())n = 31 * n + i.value;
        } catch (t) {
            e = {
                error: t
            };
        } finally{
            try {
                i && !i.done && (r = o.return) && r.call(o);
            } finally{
                if (e) throw e.error;
            }
        }
        return n;
    }, t.fillUint8Array = function(t, e) {
        for(var r = 0; r !== t.length; r++)t[r] = e;
    }, t.copyOf = function(t, e) {
        return t.slice(0, e);
    }, t.copyOfUint8Array = function(t, e) {
        if (t.length <= e) {
            var r = new Uint8Array(e);
            return r.set(t), r;
        }
        return t.slice(0, e);
    }, t.copyOfRange = function(t, e, r) {
        var n = r - e, o = new Int32Array(n);
        return $2be8636d379871d6$var$w.arraycopy(t, e, o, 0, n), o;
    }, t.binarySearch = function(e, r, n) {
        void 0 === n && (n = t.numberComparator);
        for(var o = 0, i = e.length - 1; o <= i;){
            var a = i + o >> 1, u = n(r, e[a]);
            if (u > 0) o = a + 1;
            else {
                if (!(u < 0)) return a;
                i = a - 1;
            }
        }
        return -o - 1;
    }, t.numberComparator = function(t, e) {
        return t - e;
    }, t;
}(), $2be8636d379871d6$var$I = function() {
    function t() {}
    return t.numberOfTrailingZeros = function(t) {
        var e;
        if (0 === t) return 32;
        var r = 31;
        return 0 !== (e = t << 16) && (r -= 16, t = e), 0 !== (e = t << 8) && (r -= 8, t = e), 0 !== (e = t << 4) && (r -= 4, t = e), 0 !== (e = t << 2) && (r -= 2, t = e), r - (t << 1 >>> 31);
    }, t.numberOfLeadingZeros = function(t) {
        if (0 === t) return 32;
        var e = 1;
        return t >>> 16 == 0 && (e += 16, t <<= 16), t >>> 24 == 0 && (e += 8, t <<= 8), t >>> 28 == 0 && (e += 4, t <<= 4), t >>> 30 == 0 && (e += 2, t <<= 2), e -= t >>> 31;
    }, t.toHexString = function(t) {
        return t.toString(16);
    }, t.toBinaryString = function(t) {
        return String(parseInt(String(t), 2));
    }, t.bitCount = function(t) {
        return t = (t = (858993459 & (t -= t >>> 1 & 1431655765)) + (t >>> 2 & 858993459)) + (t >>> 4) & 252645135, t += t >>> 8, 63 & (t += t >>> 16);
    }, t.truncDivision = function(t, e) {
        return Math.trunc(t / e);
    }, t.parseInt = function(t, e) {
        return void 0 === e && (e = void 0), parseInt(t, e);
    }, t.MIN_VALUE_32_BITS = -2147483648, t.MAX_VALUE = Number.MAX_SAFE_INTEGER, t;
}(), $2be8636d379871d6$var$S = function() {
    function t(e, r) {
        void 0 === e ? (this.size = 0, this.bits = new Int32Array(1)) : (this.size = e, this.bits = null == r ? t.makeArray(e) : r);
    }
    return t.prototype.getSize = function() {
        return this.size;
    }, t.prototype.getSizeInBytes = function() {
        return Math.floor((this.size + 7) / 8);
    }, t.prototype.ensureCapacity = function(e) {
        if (e > 32 * this.bits.length) {
            var r = t.makeArray(e);
            $2be8636d379871d6$var$w.arraycopy(this.bits, 0, r, 0, this.bits.length), this.bits = r;
        }
    }, t.prototype.get = function(t) {
        return 0 != (this.bits[Math.floor(t / 32)] & 1 << (31 & t));
    }, t.prototype.set = function(t) {
        this.bits[Math.floor(t / 32)] |= 1 << (31 & t);
    }, t.prototype.flip = function(t) {
        this.bits[Math.floor(t / 32)] ^= 1 << (31 & t);
    }, t.prototype.getNextSet = function(t) {
        var e = this.size;
        if (t >= e) return e;
        var r = this.bits, n = Math.floor(t / 32), o = r[n];
        o &= ~((1 << (31 & t)) - 1);
        for(var i = r.length; 0 === o;){
            if (++n === i) return e;
            o = r[n];
        }
        var a = 32 * n + $2be8636d379871d6$var$I.numberOfTrailingZeros(o);
        return a > e ? e : a;
    }, t.prototype.getNextUnset = function(t) {
        var e = this.size;
        if (t >= e) return e;
        var r = this.bits, n = Math.floor(t / 32), o = ~r[n];
        o &= ~((1 << (31 & t)) - 1);
        for(var i = r.length; 0 === o;){
            if (++n === i) return e;
            o = ~r[n];
        }
        var a = 32 * n + $2be8636d379871d6$var$I.numberOfTrailingZeros(o);
        return a > e ? e : a;
    }, t.prototype.setBulk = function(t, e) {
        this.bits[Math.floor(t / 32)] = e;
    }, t.prototype.setRange = function(t, e) {
        if (e < t || t < 0 || e > this.size) throw new $2be8636d379871d6$var$l();
        if (e !== t) {
            e--;
            for(var r = Math.floor(t / 32), n = Math.floor(e / 32), o = this.bits, i = r; i <= n; i++){
                var a = (2 << (i < n ? 31 : 31 & e)) - (1 << (i > r ? 0 : 31 & t));
                o[i] |= a;
            }
        }
    }, t.prototype.clear = function() {
        for(var t = this.bits.length, e = this.bits, r = 0; r < t; r++)e[r] = 0;
    }, t.prototype.isRange = function(t, e, r) {
        if (e < t || t < 0 || e > this.size) throw new $2be8636d379871d6$var$l();
        if (e === t) return !0;
        e--;
        for(var n = Math.floor(t / 32), o = Math.floor(e / 32), i = this.bits, a = n; a <= o; a++){
            var u = (2 << (a < o ? 31 : 31 & e)) - (1 << (a > n ? 0 : 31 & t)) & 4294967295;
            if ((i[a] & u) !== (r ? u : 0)) return !1;
        }
        return !0;
    }, t.prototype.appendBit = function(t) {
        this.ensureCapacity(this.size + 1), t && (this.bits[Math.floor(this.size / 32)] |= 1 << (31 & this.size)), this.size++;
    }, t.prototype.appendBits = function(t, e) {
        if (e < 0 || e > 32) throw new $2be8636d379871d6$var$l("Num bits must be between 0 and 32");
        this.ensureCapacity(this.size + e);
        for(var r = e; r > 0; r--)this.appendBit(1 == (t >> r - 1 & 1));
    }, t.prototype.appendBitArray = function(t) {
        var e = t.size;
        this.ensureCapacity(this.size + e);
        for(var r = 0; r < e; r++)this.appendBit(t.get(r));
    }, t.prototype.xor = function(t) {
        if (this.size !== t.size) throw new $2be8636d379871d6$var$l("Sizes don't match");
        for(var e = this.bits, r = 0, n = e.length; r < n; r++)e[r] ^= t.bits[r];
    }, t.prototype.toBytes = function(t, e, r, n) {
        for(var o = 0; o < n; o++){
            for(var i = 0, a = 0; a < 8; a++)this.get(t) && (i |= 1 << 7 - a), t++;
            e[r + o] = i;
        }
    }, t.prototype.getBitArray = function() {
        return this.bits;
    }, t.prototype.reverse = function() {
        for(var t = new Int32Array(this.bits.length), e = Math.floor((this.size - 1) / 32), r = e + 1, n = this.bits, o = 0; o < r; o++){
            var i = n[o];
            i = (i = (i = (i = (i = i >> 1 & 1431655765 | (1431655765 & i) << 1) >> 2 & 858993459 | (858993459 & i) << 2) >> 4 & 252645135 | (252645135 & i) << 4) >> 8 & 16711935 | (16711935 & i) << 8) >> 16 & 65535 | (65535 & i) << 16, t[e - o] = i;
        }
        if (this.size !== 32 * r) {
            var a = 32 * r - this.size, u = t[0] >>> a;
            for(o = 1; o < r; o++){
                var s = t[o];
                u |= s << 32 - a, t[o - 1] = u, u = s >>> a;
            }
            t[r - 1] = u;
        }
        this.bits = t;
    }, t.makeArray = function(t) {
        return new Int32Array(Math.floor((t + 31) / 32));
    }, t.prototype.equals = function(e) {
        if (!(e instanceof t)) return !1;
        var r = e;
        return this.size === r.size && $2be8636d379871d6$var$C.equals(this.bits, r.bits);
    }, t.prototype.hashCode = function() {
        return 31 * this.size + $2be8636d379871d6$var$C.hashCode(this.bits);
    }, t.prototype.toString = function() {
        for(var t = "", e = 0, r = this.size; e < r; e++)0 == (7 & e) && (t += " "), t += this.get(e) ? "X" : ".";
        return t;
    }, t.prototype.clone = function() {
        return new t(this.size, this.bits.slice());
    }, t;
}();
!function(t) {
    t[t.OTHER = 0] = "OTHER", t[t.PURE_BARCODE = 1] = "PURE_BARCODE", t[t.POSSIBLE_FORMATS = 2] = "POSSIBLE_FORMATS", t[t.TRY_HARDER = 3] = "TRY_HARDER", t[t.CHARACTER_SET = 4] = "CHARACTER_SET", t[t.ALLOWED_LENGTHS = 5] = "ALLOWED_LENGTHS", t[t.ASSUME_CODE_39_CHECK_DIGIT = 6] = "ASSUME_CODE_39_CHECK_DIGIT", t[t.ASSUME_GS1 = 7] = "ASSUME_GS1", t[t.RETURN_CODABAR_START_END = 8] = "RETURN_CODABAR_START_END", t[t.NEED_RESULT_POINT_CALLBACK = 9] = "NEED_RESULT_POINT_CALLBACK", t[t.ALLOWED_EAN_EXTENSIONS = 10] = "ALLOWED_EAN_EXTENSIONS";
}($2be8636d379871d6$var$o || ($2be8636d379871d6$var$o = {}));
var $2be8636d379871d6$var$O, $2be8636d379871d6$var$T = $2be8636d379871d6$var$o, $2be8636d379871d6$var$b = function() {
    var t = function(e, r) {
        return t = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(t, e) {
            t.__proto__ = e;
        } || function(t, e) {
            for(var r in e)e.hasOwnProperty(r) && (t[r] = e[r]);
        }, t(e, r);
    };
    return function(e, r) {
        function n() {
            this.constructor = e;
        }
        t(e, r), e.prototype = null === r ? Object.create(r) : (n.prototype = r.prototype, new n());
    };
}(), $2be8636d379871d6$var$R = function(t) {
    function e() {
        return null !== t && t.apply(this, arguments) || this;
    }
    return $2be8636d379871d6$var$b(e, t), e.getFormatInstance = function() {
        return new e();
    }, e.kind = "FormatException", e;
}($2be8636d379871d6$var$s), $2be8636d379871d6$var$N = function(t) {
    var e = "function" == typeof Symbol && Symbol.iterator, r = e && t[e], n = 0;
    if (r) return r.call(t);
    if (t && "number" == typeof t.length) return {
        next: function() {
            return t && n >= t.length && (t = void 0), {
                value: t && t[n++],
                done: !t
            };
        }
    };
    throw new TypeError(e ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
!function(t) {
    t[t.Cp437 = 0] = "Cp437", t[t.ISO8859_1 = 1] = "ISO8859_1", t[t.ISO8859_2 = 2] = "ISO8859_2", t[t.ISO8859_3 = 3] = "ISO8859_3", t[t.ISO8859_4 = 4] = "ISO8859_4", t[t.ISO8859_5 = 5] = "ISO8859_5", t[t.ISO8859_6 = 6] = "ISO8859_6", t[t.ISO8859_7 = 7] = "ISO8859_7", t[t.ISO8859_8 = 8] = "ISO8859_8", t[t.ISO8859_9 = 9] = "ISO8859_9", t[t.ISO8859_10 = 10] = "ISO8859_10", t[t.ISO8859_11 = 11] = "ISO8859_11", t[t.ISO8859_13 = 12] = "ISO8859_13", t[t.ISO8859_14 = 13] = "ISO8859_14", t[t.ISO8859_15 = 14] = "ISO8859_15", t[t.ISO8859_16 = 15] = "ISO8859_16", t[t.SJIS = 16] = "SJIS", t[t.Cp1250 = 17] = "Cp1250", t[t.Cp1251 = 18] = "Cp1251", t[t.Cp1252 = 19] = "Cp1252", t[t.Cp1256 = 20] = "Cp1256", t[t.UnicodeBigUnmarked = 21] = "UnicodeBigUnmarked", t[t.UTF8 = 22] = "UTF8", t[t.ASCII = 23] = "ASCII", t[t.Big5 = 24] = "Big5", t[t.GB18030 = 25] = "GB18030", t[t.EUC_KR = 26] = "EUC_KR";
}($2be8636d379871d6$var$O || ($2be8636d379871d6$var$O = {}));
var $2be8636d379871d6$var$D, $2be8636d379871d6$var$P = function() {
    function t(e, r, n) {
        for(var o, i, a = [], u = 3; u < arguments.length; u++)a[u - 3] = arguments[u];
        this.valueIdentifier = e, this.name = n, this.values = "number" == typeof r ? Int32Array.from([
            r
        ]) : r, this.otherEncodingNames = a, t.VALUE_IDENTIFIER_TO_ECI.set(e, this), t.NAME_TO_ECI.set(n, this);
        for(var s = this.values, c = 0, f = s.length; c !== f; c++){
            var h = s[c];
            t.VALUES_TO_ECI.set(h, this);
        }
        try {
            for(var l = $2be8636d379871d6$var$N(a), d = l.next(); !d.done; d = l.next()){
                var p = d.value;
                t.NAME_TO_ECI.set(p, this);
            }
        } catch (t) {
            o = {
                error: t
            };
        } finally{
            try {
                d && !d.done && (i = l.return) && i.call(l);
            } finally{
                if (o) throw o.error;
            }
        }
    }
    return t.prototype.getValueIdentifier = function() {
        return this.valueIdentifier;
    }, t.prototype.getName = function() {
        return this.name;
    }, t.prototype.getValue = function() {
        return this.values[0];
    }, t.getCharacterSetECIByValue = function(e) {
        if (e < 0 || e >= 900) throw new $2be8636d379871d6$var$R("incorect value");
        var r = t.VALUES_TO_ECI.get(e);
        if (void 0 === r) throw new $2be8636d379871d6$var$R("incorect value");
        return r;
    }, t.getCharacterSetECIByName = function(e) {
        var r = t.NAME_TO_ECI.get(e);
        if (void 0 === r) throw new $2be8636d379871d6$var$R("incorect value");
        return r;
    }, t.prototype.equals = function(e) {
        if (!(e instanceof t)) return !1;
        var r = e;
        return this.getName() === r.getName();
    }, t.VALUE_IDENTIFIER_TO_ECI = new Map(), t.VALUES_TO_ECI = new Map(), t.NAME_TO_ECI = new Map(), t.Cp437 = new t($2be8636d379871d6$var$O.Cp437, Int32Array.from([
        0,
        2
    ]), "Cp437"), t.ISO8859_1 = new t($2be8636d379871d6$var$O.ISO8859_1, Int32Array.from([
        1,
        3
    ]), "ISO-8859-1", "ISO88591", "ISO8859_1"), t.ISO8859_2 = new t($2be8636d379871d6$var$O.ISO8859_2, 4, "ISO-8859-2", "ISO88592", "ISO8859_2"), t.ISO8859_3 = new t($2be8636d379871d6$var$O.ISO8859_3, 5, "ISO-8859-3", "ISO88593", "ISO8859_3"), t.ISO8859_4 = new t($2be8636d379871d6$var$O.ISO8859_4, 6, "ISO-8859-4", "ISO88594", "ISO8859_4"), t.ISO8859_5 = new t($2be8636d379871d6$var$O.ISO8859_5, 7, "ISO-8859-5", "ISO88595", "ISO8859_5"), t.ISO8859_6 = new t($2be8636d379871d6$var$O.ISO8859_6, 8, "ISO-8859-6", "ISO88596", "ISO8859_6"), t.ISO8859_7 = new t($2be8636d379871d6$var$O.ISO8859_7, 9, "ISO-8859-7", "ISO88597", "ISO8859_7"), t.ISO8859_8 = new t($2be8636d379871d6$var$O.ISO8859_8, 10, "ISO-8859-8", "ISO88598", "ISO8859_8"), t.ISO8859_9 = new t($2be8636d379871d6$var$O.ISO8859_9, 11, "ISO-8859-9", "ISO88599", "ISO8859_9"), t.ISO8859_10 = new t($2be8636d379871d6$var$O.ISO8859_10, 12, "ISO-8859-10", "ISO885910", "ISO8859_10"), t.ISO8859_11 = new t($2be8636d379871d6$var$O.ISO8859_11, 13, "ISO-8859-11", "ISO885911", "ISO8859_11"), t.ISO8859_13 = new t($2be8636d379871d6$var$O.ISO8859_13, 15, "ISO-8859-13", "ISO885913", "ISO8859_13"), t.ISO8859_14 = new t($2be8636d379871d6$var$O.ISO8859_14, 16, "ISO-8859-14", "ISO885914", "ISO8859_14"), t.ISO8859_15 = new t($2be8636d379871d6$var$O.ISO8859_15, 17, "ISO-8859-15", "ISO885915", "ISO8859_15"), t.ISO8859_16 = new t($2be8636d379871d6$var$O.ISO8859_16, 18, "ISO-8859-16", "ISO885916", "ISO8859_16"), t.SJIS = new t($2be8636d379871d6$var$O.SJIS, 20, "SJIS", "Shift_JIS"), t.Cp1250 = new t($2be8636d379871d6$var$O.Cp1250, 21, "Cp1250", "windows-1250"), t.Cp1251 = new t($2be8636d379871d6$var$O.Cp1251, 22, "Cp1251", "windows-1251"), t.Cp1252 = new t($2be8636d379871d6$var$O.Cp1252, 23, "Cp1252", "windows-1252"), t.Cp1256 = new t($2be8636d379871d6$var$O.Cp1256, 24, "Cp1256", "windows-1256"), t.UnicodeBigUnmarked = new t($2be8636d379871d6$var$O.UnicodeBigUnmarked, 25, "UnicodeBigUnmarked", "UTF-16BE", "UnicodeBig"), t.UTF8 = new t($2be8636d379871d6$var$O.UTF8, 26, "UTF8", "UTF-8"), t.ASCII = new t($2be8636d379871d6$var$O.ASCII, Int32Array.from([
        27,
        170
    ]), "ASCII", "US-ASCII"), t.Big5 = new t($2be8636d379871d6$var$O.Big5, 28, "Big5"), t.GB18030 = new t($2be8636d379871d6$var$O.GB18030, 29, "GB18030", "GB2312", "EUC_CN", "GBK"), t.EUC_KR = new t($2be8636d379871d6$var$O.EUC_KR, 30, "EUC_KR", "EUC-KR"), t;
}(), $2be8636d379871d6$var$M = function() {
    var t = function(e, r) {
        return t = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(t, e) {
            t.__proto__ = e;
        } || function(t, e) {
            for(var r in e)e.hasOwnProperty(r) && (t[r] = e[r]);
        }, t(e, r);
    };
    return function(e, r) {
        function n() {
            this.constructor = e;
        }
        t(e, r), e.prototype = null === r ? Object.create(r) : (n.prototype = r.prototype, new n());
    };
}(), $2be8636d379871d6$var$B = function(t) {
    function e() {
        return null !== t && t.apply(this, arguments) || this;
    }
    return $2be8636d379871d6$var$M(e, t), e.kind = "UnsupportedOperationException", e;
}($2be8636d379871d6$var$s), $2be8636d379871d6$var$L = function() {
    function t() {}
    return t.decode = function(t, e) {
        var r = this.encodingName(e);
        return this.customDecoder ? this.customDecoder(t, r) : "undefined" == typeof TextDecoder || this.shouldDecodeOnFallback(r) ? this.decodeFallback(t, r) : new TextDecoder(r).decode(t);
    }, t.shouldDecodeOnFallback = function(e) {
        return !t.isBrowser() && "ISO-8859-1" === e;
    }, t.encode = function(t, e) {
        var r = this.encodingName(e);
        return this.customEncoder ? this.customEncoder(t, r) : "undefined" == typeof TextEncoder ? this.encodeFallback(t) : new TextEncoder().encode(t);
    }, t.isBrowser = function() {
        return "undefined" != typeof window && "[object Window]" === ({}).toString.call(window);
    }, t.encodingName = function(t) {
        return "string" == typeof t ? t : t.getName();
    }, t.encodingCharacterSet = function(t) {
        return t instanceof $2be8636d379871d6$var$P ? t : $2be8636d379871d6$var$P.getCharacterSetECIByName(t);
    }, t.decodeFallback = function(e, r) {
        var n = this.encodingCharacterSet(r);
        if (t.isDecodeFallbackSupported(n)) {
            for(var o = "", i = 0, a = e.length; i < a; i++){
                var u = e[i].toString(16);
                u.length < 2 && (u = "0" + u), o += "%" + u;
            }
            return decodeURIComponent(o);
        }
        if (n.equals($2be8636d379871d6$var$P.UnicodeBigUnmarked)) return String.fromCharCode.apply(null, new Uint16Array(e.buffer));
        throw new $2be8636d379871d6$var$B("Encoding " + this.encodingName(r) + " not supported by fallback.");
    }, t.isDecodeFallbackSupported = function(t) {
        return t.equals($2be8636d379871d6$var$P.UTF8) || t.equals($2be8636d379871d6$var$P.ISO8859_1) || t.equals($2be8636d379871d6$var$P.ASCII);
    }, t.encodeFallback = function(t) {
        for(var e = btoa(unescape(encodeURIComponent(t))).split(""), r = [], n = 0; n < e.length; n++)r.push(e[n].charCodeAt(0));
        return new Uint8Array(r);
    }, t;
}(), $2be8636d379871d6$var$F = function() {
    function t() {}
    return t.castAsNonUtf8Char = function(t, e) {
        void 0 === e && (e = null);
        var r = e ? e.getName() : this.ISO88591;
        return $2be8636d379871d6$var$L.decode(new Uint8Array([
            t
        ]), r);
    }, t.guessEncoding = function(e, r) {
        if (null != r && void 0 !== r.get($2be8636d379871d6$var$T.CHARACTER_SET)) return r.get($2be8636d379871d6$var$T.CHARACTER_SET).toString();
        for(var n = e.length, o = !0, i = !0, a = !0, u = 0, s = 0, c = 0, f = 0, h = 0, l = 0, d = 0, p = 0, g = 0, y = 0, w = 0, _ = e.length > 3 && 239 === e[0] && 187 === e[1] && 191 === e[2], v = 0; v < n && (o || i || a); v++){
            var m = 255 & e[v];
            a && (u > 0 ? 0 == (128 & m) ? a = !1 : u-- : 0 != (128 & m) && (0 == (64 & m) ? a = !1 : (u++, 0 == (32 & m) ? s++ : (u++, 0 == (16 & m) ? c++ : (u++, 0 == (8 & m) ? f++ : a = !1))))), o && (m > 127 && m < 160 ? o = !1 : m > 159 && (m < 192 || 215 === m || 247 === m) && w++), i && (h > 0 ? m < 64 || 127 === m || m > 252 ? i = !1 : h-- : 128 === m || 160 === m || m > 239 ? i = !1 : m > 160 && m < 224 ? (l++, p = 0, ++d > g && (g = d)) : m > 127 ? (h++, d = 0, ++p > y && (y = p)) : (d = 0, p = 0));
        }
        return a && u > 0 && (a = !1), i && h > 0 && (i = !1), a && (_ || s + c + f > 0) ? t.UTF8 : i && (t.ASSUME_SHIFT_JIS || g >= 3 || y >= 3) ? t.SHIFT_JIS : o && i ? 2 === g && 2 === l || 10 * w >= n ? t.SHIFT_JIS : t.ISO88591 : o ? t.ISO88591 : i ? t.SHIFT_JIS : a ? t.UTF8 : t.PLATFORM_DEFAULT_ENCODING;
    }, t.format = function(t) {
        for(var e = [], r = 1; r < arguments.length; r++)e[r - 1] = arguments[r];
        var n = -1;
        function o(t, r, o, i, a, u) {
            if ("%%" === t) return "%";
            if (void 0 !== e[++n]) {
                t = i ? parseInt(i.substr(1)) : void 0;
                var s, c = a ? parseInt(a.substr(1)) : void 0;
                switch(u){
                    case "s":
                        s = e[n];
                        break;
                    case "c":
                        s = e[n][0];
                        break;
                    case "f":
                        s = parseFloat(e[n]).toFixed(t);
                        break;
                    case "p":
                        s = parseFloat(e[n]).toPrecision(t);
                        break;
                    case "e":
                        s = parseFloat(e[n]).toExponential(t);
                        break;
                    case "x":
                        s = parseInt(e[n]).toString(c || 16);
                        break;
                    case "d":
                        s = parseFloat(parseInt(e[n], c || 10).toPrecision(t)).toFixed(0);
                }
                s = "object" == typeof s ? JSON.stringify(s) : (+s).toString(c);
                for(var f = parseInt(o), h = o && o[0] + "" == "0" ? "0" : " "; s.length < f;)s = void 0 !== r ? s + h : h + s;
                return s;
            }
        }
        var i = /%(-)?(0?[0-9]+)?([.][0-9]+)?([#][0-9]+)?([scfpexd%])/g;
        return t.replace(i, o);
    }, t.getBytes = function(t, e) {
        return $2be8636d379871d6$var$L.encode(t, e);
    }, t.getCharCode = function(t, e) {
        return void 0 === e && (e = 0), t.charCodeAt(e);
    }, t.getCharAt = function(t) {
        return String.fromCharCode(t);
    }, t.SHIFT_JIS = $2be8636d379871d6$var$P.SJIS.getName(), t.GB2312 = "GB2312", t.ISO88591 = $2be8636d379871d6$var$P.ISO8859_1.getName(), t.EUC_JP = "EUC_JP", t.UTF8 = $2be8636d379871d6$var$P.UTF8.getName(), t.PLATFORM_DEFAULT_ENCODING = t.UTF8, t.ASSUME_SHIFT_JIS = !1, t;
}(), $2be8636d379871d6$var$k = function() {
    function t(t) {
        void 0 === t && (t = ""), this.value = t;
    }
    return t.prototype.enableDecoding = function(t) {
        return this.encoding = t, this;
    }, t.prototype.append = function(t) {
        return "string" == typeof t ? this.value += t.toString() : this.encoding ? this.value += $2be8636d379871d6$var$F.castAsNonUtf8Char(t, this.encoding) : this.value += String.fromCharCode(t), this;
    }, t.prototype.appendChars = function(t, e, r) {
        for(var n = e; e < e + r; n++)this.append(t[n]);
        return this;
    }, t.prototype.length = function() {
        return this.value.length;
    }, t.prototype.charAt = function(t) {
        return this.value.charAt(t);
    }, t.prototype.deleteCharAt = function(t) {
        this.value = this.value.substr(0, t) + this.value.substring(t + 1);
    }, t.prototype.setCharAt = function(t, e) {
        this.value = this.value.substr(0, t) + e + this.value.substr(t + 1);
    }, t.prototype.substring = function(t, e) {
        return this.value.substring(t, e);
    }, t.prototype.setLengthToZero = function() {
        this.value = "";
    }, t.prototype.toString = function() {
        return this.value;
    }, t.prototype.insert = function(t, e) {
        this.value = this.value.substr(0, t) + e + this.value.substr(t + e.length);
    }, t;
}(), $2be8636d379871d6$var$x = function() {
    function t(t, e, r, n) {
        if (this.width = t, this.height = e, this.rowSize = r, this.bits = n, null == e && (e = t), this.height = e, t < 1 || e < 1) throw new $2be8636d379871d6$var$l("Both dimensions must be greater than 0");
        null == r && (r = Math.floor((t + 31) / 32)), this.rowSize = r, null == n && (this.bits = new Int32Array(this.rowSize * this.height));
    }
    return t.parseFromBooleanArray = function(e) {
        for(var r = e.length, n = e[0].length, o = new t(n, r), i = 0; i < r; i++)for(var a = e[i], u = 0; u < n; u++)a[u] && o.set(u, i);
        return o;
    }, t.parseFromString = function(e, r, n) {
        if (null === e) throw new $2be8636d379871d6$var$l("stringRepresentation cannot be null");
        for(var o = new Array(e.length), i = 0, a = 0, u = -1, s = 0, c = 0; c < e.length;)if ("\n" === e.charAt(c) || "\r" === e.charAt(c)) {
            if (i > a) {
                if (-1 === u) u = i - a;
                else if (i - a !== u) throw new $2be8636d379871d6$var$l("row lengths do not match");
                a = i, s++;
            }
            c++;
        } else if (e.substring(c, c + r.length) === r) c += r.length, o[i] = !0, i++;
        else {
            if (e.substring(c, c + n.length) !== n) throw new $2be8636d379871d6$var$l("illegal character encountered: " + e.substring(c));
            c += n.length, o[i] = !1, i++;
        }
        if (i > a) {
            if (-1 === u) u = i - a;
            else if (i - a !== u) throw new $2be8636d379871d6$var$l("row lengths do not match");
            s++;
        }
        for(var f = new t(u, s), h = 0; h < i; h++)o[h] && f.set(Math.floor(h % u), Math.floor(h / u));
        return f;
    }, t.prototype.get = function(t, e) {
        var r = e * this.rowSize + Math.floor(t / 32);
        return 0 != (this.bits[r] >>> (31 & t) & 1);
    }, t.prototype.set = function(t, e) {
        var r = e * this.rowSize + Math.floor(t / 32);
        this.bits[r] |= 1 << (31 & t) & 4294967295;
    }, t.prototype.unset = function(t, e) {
        var r = e * this.rowSize + Math.floor(t / 32);
        this.bits[r] &= ~(1 << (31 & t) & 4294967295);
    }, t.prototype.flip = function(t, e) {
        var r = e * this.rowSize + Math.floor(t / 32);
        this.bits[r] ^= 1 << (31 & t) & 4294967295;
    }, t.prototype.xor = function(t) {
        if (this.width !== t.getWidth() || this.height !== t.getHeight() || this.rowSize !== t.getRowSize()) throw new $2be8636d379871d6$var$l("input matrix dimensions do not match");
        for(var e = new $2be8636d379871d6$var$S(Math.floor(this.width / 32) + 1), r = this.rowSize, n = this.bits, o = 0, i = this.height; o < i; o++)for(var a = o * r, u = t.getRow(o, e).getBitArray(), s = 0; s < r; s++)n[a + s] ^= u[s];
    }, t.prototype.clear = function() {
        for(var t = this.bits, e = t.length, r = 0; r < e; r++)t[r] = 0;
    }, t.prototype.setRegion = function(t, e, r, n) {
        if (e < 0 || t < 0) throw new $2be8636d379871d6$var$l("Left and top must be nonnegative");
        if (n < 1 || r < 1) throw new $2be8636d379871d6$var$l("Height and width must be at least 1");
        var o = t + r, i = e + n;
        if (i > this.height || o > this.width) throw new $2be8636d379871d6$var$l("The region must fit inside the matrix");
        for(var a = this.rowSize, u = this.bits, s = e; s < i; s++)for(var c = s * a, f = t; f < o; f++)u[c + Math.floor(f / 32)] |= 1 << (31 & f) & 4294967295;
    }, t.prototype.getRow = function(t, e) {
        null == e || e.getSize() < this.width ? e = new $2be8636d379871d6$var$S(this.width) : e.clear();
        for(var r = this.rowSize, n = this.bits, o = t * r, i = 0; i < r; i++)e.setBulk(32 * i, n[o + i]);
        return e;
    }, t.prototype.setRow = function(t, e) {
        $2be8636d379871d6$var$w.arraycopy(e.getBitArray(), 0, this.bits, t * this.rowSize, this.rowSize);
    }, t.prototype.rotate180 = function() {
        for(var t = this.getWidth(), e = this.getHeight(), r = new $2be8636d379871d6$var$S(t), n = new $2be8636d379871d6$var$S(t), o = 0, i = Math.floor((e + 1) / 2); o < i; o++)r = this.getRow(o, r), n = this.getRow(e - 1 - o, n), r.reverse(), n.reverse(), this.setRow(o, n), this.setRow(e - 1 - o, r);
    }, t.prototype.getEnclosingRectangle = function() {
        for(var t = this.width, e = this.height, r = this.rowSize, n = this.bits, o = t, i = e, a = -1, u = -1, s = 0; s < e; s++)for(var c = 0; c < r; c++){
            var f = n[s * r + c];
            if (0 !== f) {
                if (s < i && (i = s), s > u && (u = s), 32 * c < o) {
                    for(var h = 0; 0 == (f << 31 - h & 4294967295);)h++;
                    32 * c + h < o && (o = 32 * c + h);
                }
                if (32 * c + 31 > a) {
                    for(h = 31; f >>> h == 0;)h--;
                    32 * c + h > a && (a = 32 * c + h);
                }
            }
        }
        return a < o || u < i ? null : Int32Array.from([
            o,
            i,
            a - o + 1,
            u - i + 1
        ]);
    }, t.prototype.getTopLeftOnBit = function() {
        for(var t = this.rowSize, e = this.bits, r = 0; r < e.length && 0 === e[r];)r++;
        if (r === e.length) return null;
        for(var n = r / t, o = r % t * 32, i = e[r], a = 0; 0 == (i << 31 - a & 4294967295);)a++;
        return o += a, Int32Array.from([
            o,
            n
        ]);
    }, t.prototype.getBottomRightOnBit = function() {
        for(var t = this.rowSize, e = this.bits, r = e.length - 1; r >= 0 && 0 === e[r];)r--;
        if (r < 0) return null;
        for(var n = Math.floor(r / t), o = 32 * Math.floor(r % t), i = e[r], a = 31; i >>> a == 0;)a--;
        return o += a, Int32Array.from([
            o,
            n
        ]);
    }, t.prototype.getWidth = function() {
        return this.width;
    }, t.prototype.getHeight = function() {
        return this.height;
    }, t.prototype.getRowSize = function() {
        return this.rowSize;
    }, t.prototype.equals = function(e) {
        if (!(e instanceof t)) return !1;
        var r = e;
        return this.width === r.width && this.height === r.height && this.rowSize === r.rowSize && $2be8636d379871d6$var$C.equals(this.bits, r.bits);
    }, t.prototype.hashCode = function() {
        var t = this.width;
        return t = 31 * (t = 31 * (t = 31 * (t = 31 * t + this.width) + this.height) + this.rowSize) + $2be8636d379871d6$var$C.hashCode(this.bits);
    }, t.prototype.toString = function(t, e, r) {
        return void 0 === t && (t = "X "), void 0 === e && (e = "  "), void 0 === r && (r = "\n"), this.buildToString(t, e, r);
    }, t.prototype.buildToString = function(t, e, r) {
        for(var n = new $2be8636d379871d6$var$k(), o = 0, i = this.height; o < i; o++){
            for(var a = 0, u = this.width; a < u; a++)n.append(this.get(a, o) ? t : e);
            n.append(r);
        }
        return n.toString();
    }, t.prototype.clone = function() {
        return new t(this.width, this.height, this.rowSize, this.bits.slice());
    }, t;
}(), $2be8636d379871d6$var$V = function() {
    var t = function(e, r) {
        return t = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(t, e) {
            t.__proto__ = e;
        } || function(t, e) {
            for(var r in e)e.hasOwnProperty(r) && (t[r] = e[r]);
        }, t(e, r);
    };
    return function(e, r) {
        function n() {
            this.constructor = e;
        }
        t(e, r), e.prototype = null === r ? Object.create(r) : (n.prototype = r.prototype, new n());
    };
}(), $2be8636d379871d6$var$U = function(t) {
    function e() {
        return null !== t && t.apply(this, arguments) || this;
    }
    return $2be8636d379871d6$var$V(e, t), e.getNotFoundInstance = function() {
        return new e();
    }, e.kind = "NotFoundException", e;
}($2be8636d379871d6$var$s), $2be8636d379871d6$var$H = function() {
    var t = function(e, r) {
        return t = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(t, e) {
            t.__proto__ = e;
        } || function(t, e) {
            for(var r in e)e.hasOwnProperty(r) && (t[r] = e[r]);
        }, t(e, r);
    };
    return function(e, r) {
        function n() {
            this.constructor = e;
        }
        t(e, r), e.prototype = null === r ? Object.create(r) : (n.prototype = r.prototype, new n());
    };
}(), $2be8636d379871d6$var$G = function(t) {
    function e(r) {
        var n = t.call(this, r) || this;
        return n.luminances = e.EMPTY, n.buckets = new Int32Array(e.LUMINANCE_BUCKETS), n;
    }
    return $2be8636d379871d6$var$H(e, t), e.prototype.getBlackRow = function(t, r) {
        var n = this.getLuminanceSource(), o = n.getWidth();
        null == r || r.getSize() < o ? r = new $2be8636d379871d6$var$S(o) : r.clear(), this.initArrays(o);
        for(var i = n.getRow(t, this.luminances), a = this.buckets, u = 0; u < o; u++)a[(255 & i[u]) >> e.LUMINANCE_SHIFT]++;
        var s = e.estimateBlackPoint(a);
        if (o < 3) for(u = 0; u < o; u++)(255 & i[u]) < s && r.set(u);
        else {
            var c = 255 & i[0], f = 255 & i[1];
            for(u = 1; u < o - 1; u++){
                var h = 255 & i[u + 1];
                (4 * f - c - h) / 2 < s && r.set(u), c = f, f = h;
            }
        }
        return r;
    }, e.prototype.getBlackMatrix = function() {
        var t = this.getLuminanceSource(), r = t.getWidth(), n = t.getHeight(), o = new $2be8636d379871d6$var$x(r, n);
        this.initArrays(r);
        for(var i = this.buckets, a = 1; a < 5; a++)for(var u = Math.floor(n * a / 5), s = t.getRow(u, this.luminances), c = Math.floor(4 * r / 5), f = Math.floor(r / 5); f < c; f++)i[(255 & s[f]) >> e.LUMINANCE_SHIFT]++;
        var h = e.estimateBlackPoint(i), l = t.getMatrix();
        for(a = 0; a < n; a++){
            var d = a * r;
            for(f = 0; f < r; f++)(255 & l[d + f]) < h && o.set(f, a);
        }
        return o;
    }, e.prototype.createBinarizer = function(t) {
        return new e(t);
    }, e.prototype.initArrays = function(t) {
        this.luminances.length < t && (this.luminances = new Uint8ClampedArray(t));
        for(var r = this.buckets, n = 0; n < e.LUMINANCE_BUCKETS; n++)r[n] = 0;
    }, e.estimateBlackPoint = function(t) {
        for(var r = t.length, n = 0, o = 0, i = 0, a = 0; a < r; a++)t[a] > i && (o = a, i = t[a]), t[a] > n && (n = t[a]);
        var u = 0, s = 0;
        for(a = 0; a < r; a++){
            var c = a - o;
            (d = t[a] * c * c) > s && (u = a, s = d);
        }
        if (o > u) {
            var f = o;
            o = u, u = f;
        }
        if (u - o <= r / 16) throw new $2be8636d379871d6$var$U();
        var h = u - 1, l = -1;
        for(a = u - 1; a > o; a--){
            var d, p = a - o;
            (d = p * p * (u - a) * (n - t[a])) > l && (h = a, l = d);
        }
        return h << e.LUMINANCE_SHIFT;
    }, e.LUMINANCE_BITS = 5, e.LUMINANCE_SHIFT = 8 - e.LUMINANCE_BITS, e.LUMINANCE_BUCKETS = 1 << e.LUMINANCE_BITS, e.EMPTY = Uint8ClampedArray.from([
        0
    ]), e;
}($2be8636d379871d6$var$y), $2be8636d379871d6$var$X = function() {
    var t = function(e, r) {
        return t = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(t, e) {
            t.__proto__ = e;
        } || function(t, e) {
            for(var r in e)e.hasOwnProperty(r) && (t[r] = e[r]);
        }, t(e, r);
    };
    return function(e, r) {
        function n() {
            this.constructor = e;
        }
        t(e, r), e.prototype = null === r ? Object.create(r) : (n.prototype = r.prototype, new n());
    };
}(), $2be8636d379871d6$var$W = function(t) {
    function e(e) {
        var r = t.call(this, e) || this;
        return r.matrix = null, r;
    }
    return $2be8636d379871d6$var$X(e, t), e.prototype.getBlackMatrix = function() {
        if (null !== this.matrix) return this.matrix;
        var r = this.getLuminanceSource(), n = r.getWidth(), o = r.getHeight();
        if (n >= e.MINIMUM_DIMENSION && o >= e.MINIMUM_DIMENSION) {
            var i = r.getMatrix(), a = n >> e.BLOCK_SIZE_POWER;
            0 != (n & e.BLOCK_SIZE_MASK) && a++;
            var u = o >> e.BLOCK_SIZE_POWER;
            0 != (o & e.BLOCK_SIZE_MASK) && u++;
            var s = e.calculateBlackPoints(i, a, u, n, o), c = new $2be8636d379871d6$var$x(n, o);
            e.calculateThresholdForBlock(i, a, u, n, o, s, c), this.matrix = c;
        } else this.matrix = t.prototype.getBlackMatrix.call(this);
        return this.matrix;
    }, e.prototype.createBinarizer = function(t) {
        return new e(t);
    }, e.calculateThresholdForBlock = function(t, r, n, o, i, a, u) {
        for(var s = i - e.BLOCK_SIZE, c = o - e.BLOCK_SIZE, f = 0; f < n; f++){
            var h = f << e.BLOCK_SIZE_POWER;
            h > s && (h = s);
            for(var l = e.cap(f, 2, n - 3), d = 0; d < r; d++){
                var p = d << e.BLOCK_SIZE_POWER;
                p > c && (p = c);
                for(var g = e.cap(d, 2, r - 3), y = 0, w = -2; w <= 2; w++){
                    var _ = a[l + w];
                    y += _[g - 2] + _[g - 1] + _[g] + _[g + 1] + _[g + 2];
                }
                var v = y / 25;
                e.thresholdBlock(t, p, h, v, o, u);
            }
        }
    }, e.cap = function(t, e, r) {
        return t < e ? e : t > r ? r : t;
    }, e.thresholdBlock = function(t, r, n, o, i, a) {
        for(var u = 0, s = n * i + r; u < e.BLOCK_SIZE; u++, s += i)for(var c = 0; c < e.BLOCK_SIZE; c++)(255 & t[s + c]) <= o && a.set(r + c, n + u);
    }, e.calculateBlackPoints = function(t, r, n, o, i) {
        for(var a = i - e.BLOCK_SIZE, u = o - e.BLOCK_SIZE, s = new Array(n), c = 0; c < n; c++){
            s[c] = new Int32Array(r);
            var f = c << e.BLOCK_SIZE_POWER;
            f > a && (f = a);
            for(var h = 0; h < r; h++){
                var l = h << e.BLOCK_SIZE_POWER;
                l > u && (l = u);
                for(var d = 0, p = 255, g = 0, y = 0, w = f * o + l; y < e.BLOCK_SIZE; y++, w += o){
                    for(var _ = 0; _ < e.BLOCK_SIZE; _++){
                        var v = 255 & t[w + _];
                        d += v, v < p && (p = v), v > g && (g = v);
                    }
                    if (g - p > e.MIN_DYNAMIC_RANGE) for(y++, w += o; y < e.BLOCK_SIZE; y++, w += o)for(_ = 0; _ < e.BLOCK_SIZE; _++)d += 255 & t[w + _];
                }
                var m = d >> 2 * e.BLOCK_SIZE_POWER;
                if (g - p <= e.MIN_DYNAMIC_RANGE && (m = p / 2, c > 0 && h > 0)) {
                    var A = (s[c - 1][h] + 2 * s[c][h - 1] + s[c - 1][h - 1]) / 4;
                    p < A && (m = A);
                }
                s[c][h] = m;
            }
        }
        return s;
    }, e.BLOCK_SIZE_POWER = 3, e.BLOCK_SIZE = 1 << e.BLOCK_SIZE_POWER, e.BLOCK_SIZE_MASK = e.BLOCK_SIZE - 1, e.MINIMUM_DIMENSION = 5 * e.BLOCK_SIZE, e.MIN_DYNAMIC_RANGE = 24, e;
}($2be8636d379871d6$var$G), $2be8636d379871d6$var$j = function() {
    function t(t, e) {
        this.width = t, this.height = e;
    }
    return t.prototype.getWidth = function() {
        return this.width;
    }, t.prototype.getHeight = function() {
        return this.height;
    }, t.prototype.isCropSupported = function() {
        return !1;
    }, t.prototype.crop = function(t, e, r, n) {
        throw new $2be8636d379871d6$var$B("This luminance source does not support cropping.");
    }, t.prototype.isRotateSupported = function() {
        return !1;
    }, t.prototype.rotateCounterClockwise = function() {
        throw new $2be8636d379871d6$var$B("This luminance source does not support rotation by 90 degrees.");
    }, t.prototype.rotateCounterClockwise45 = function() {
        throw new $2be8636d379871d6$var$B("This luminance source does not support rotation by 45 degrees.");
    }, t.prototype.toString = function() {
        for(var t = new Uint8ClampedArray(this.width), e = new $2be8636d379871d6$var$k(), r = 0; r < this.height; r++){
            for(var n = this.getRow(r, t), o = 0; o < this.width; o++){
                var i = 255 & n[o], a = void 0;
                a = i < 64 ? "#" : i < 128 ? "+" : i < 192 ? "." : " ", e.append(a);
            }
            e.append("\n");
        }
        return e.toString();
    }, t;
}(), $2be8636d379871d6$var$z = function() {
    var t = function(e, r) {
        return t = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(t, e) {
            t.__proto__ = e;
        } || function(t, e) {
            for(var r in e)e.hasOwnProperty(r) && (t[r] = e[r]);
        }, t(e, r);
    };
    return function(e, r) {
        function n() {
            this.constructor = e;
        }
        t(e, r), e.prototype = null === r ? Object.create(r) : (n.prototype = r.prototype, new n());
    };
}(), $2be8636d379871d6$var$Y = function(t) {
    function e(e) {
        var r = t.call(this, e.getWidth(), e.getHeight()) || this;
        return r.delegate = e, r;
    }
    return $2be8636d379871d6$var$z(e, t), e.prototype.getRow = function(t, e) {
        for(var r = this.delegate.getRow(t, e), n = this.getWidth(), o = 0; o < n; o++)r[o] = 255 - (255 & r[o]);
        return r;
    }, e.prototype.getMatrix = function() {
        for(var t = this.delegate.getMatrix(), e = this.getWidth() * this.getHeight(), r = new Uint8ClampedArray(e), n = 0; n < e; n++)r[n] = 255 - (255 & t[n]);
        return r;
    }, e.prototype.isCropSupported = function() {
        return this.delegate.isCropSupported();
    }, e.prototype.crop = function(t, r, n, o) {
        return new e(this.delegate.crop(t, r, n, o));
    }, e.prototype.isRotateSupported = function() {
        return this.delegate.isRotateSupported();
    }, e.prototype.invert = function() {
        return this.delegate;
    }, e.prototype.rotateCounterClockwise = function() {
        return new e(this.delegate.rotateCounterClockwise());
    }, e.prototype.rotateCounterClockwise45 = function() {
        return new e(this.delegate.rotateCounterClockwise45());
    }, e;
}($2be8636d379871d6$var$j), $2be8636d379871d6$var$Z = function() {
    var t = function(e, r) {
        return t = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(t, e) {
            t.__proto__ = e;
        } || function(t, e) {
            for(var r in e)e.hasOwnProperty(r) && (t[r] = e[r]);
        }, t(e, r);
    };
    return function(e, r) {
        function n() {
            this.constructor = e;
        }
        t(e, r), e.prototype = null === r ? Object.create(r) : (n.prototype = r.prototype, new n());
    };
}(), $2be8636d379871d6$var$K = function(t) {
    function e(r) {
        var n = t.call(this, r.width, r.height) || this;
        return n.canvas = r, n.tempCanvasElement = null, n.buffer = e.makeBufferFromCanvasImageData(r), n;
    }
    return $2be8636d379871d6$var$Z(e, t), e.makeBufferFromCanvasImageData = function(t) {
        var r = t.getContext("2d").getImageData(0, 0, t.width, t.height);
        return e.toGrayscaleBuffer(r.data, t.width, t.height);
    }, e.toGrayscaleBuffer = function(t, e, r) {
        for(var n = new Uint8ClampedArray(e * r), o = 0, i = 0, a = t.length; o < a; o += 4, i++){
            var u = void 0;
            if (0 === t[o + 3]) u = 255;
            else u = 306 * t[o] + 601 * t[o + 1] + 117 * t[o + 2] + 512 >> 10;
            n[i] = u;
        }
        return n;
    }, e.prototype.getRow = function(t, e) {
        if (t < 0 || t >= this.getHeight()) throw new $2be8636d379871d6$var$l("Requested row is outside the image: " + t);
        var r = this.getWidth(), n = t * r;
        return null === e ? e = this.buffer.slice(n, n + r) : (e.length < r && (e = new Uint8ClampedArray(r)), e.set(this.buffer.slice(n, n + r))), e;
    }, e.prototype.getMatrix = function() {
        return this.buffer;
    }, e.prototype.isCropSupported = function() {
        return !0;
    }, e.prototype.crop = function(e, r, n, o) {
        return t.prototype.crop.call(this, e, r, n, o), this;
    }, e.prototype.isRotateSupported = function() {
        return !0;
    }, e.prototype.rotateCounterClockwise = function() {
        return this.rotate(-90), this;
    }, e.prototype.rotateCounterClockwise45 = function() {
        return this.rotate(-45), this;
    }, e.prototype.getTempCanvasElement = function() {
        if (null === this.tempCanvasElement) {
            var t = this.canvas.ownerDocument.createElement("canvas");
            t.width = this.canvas.width, t.height = this.canvas.height, this.tempCanvasElement = t;
        }
        return this.tempCanvasElement;
    }, e.prototype.rotate = function(t) {
        var r = this.getTempCanvasElement(), n = r.getContext("2d"), o = t * e.DEGREE_TO_RADIANS, i = this.canvas.width, a = this.canvas.height, u = Math.ceil(Math.abs(Math.cos(o)) * i + Math.abs(Math.sin(o)) * a), s = Math.ceil(Math.abs(Math.sin(o)) * i + Math.abs(Math.cos(o)) * a);
        return r.width = u, r.height = s, n.translate(u / 2, s / 2), n.rotate(o), n.drawImage(this.canvas, i / -2, a / -2), this.buffer = e.makeBufferFromCanvasImageData(r), this;
    }, e.prototype.invert = function() {
        return new $2be8636d379871d6$var$Y(this);
    }, e.DEGREE_TO_RADIANS = Math.PI / 180, e;
}($2be8636d379871d6$var$j), $2be8636d379871d6$var$q = function() {
    function t(t, e, r) {
        this.deviceId = t, this.label = e, this.kind = "videoinput", this.groupId = r || void 0;
    }
    return t.prototype.toJSON = function() {
        return {
            kind: this.kind,
            groupId: this.groupId,
            deviceId: this.deviceId,
            label: this.label
        };
    }, t;
}(), $2be8636d379871d6$var$Q = function(t, e, r, n) {
    return new (r || (r = Promise))(function(o, i) {
        function a(t) {
            try {
                s(n.next(t));
            } catch (t) {
                i(t);
            }
        }
        function u(t) {
            try {
                s(n.throw(t));
            } catch (t) {
                i(t);
            }
        }
        function s(t) {
            var e;
            t.done ? o(t.value) : (e = t.value, e instanceof r ? e : new r(function(t) {
                t(e);
            })).then(a, u);
        }
        s((n = n.apply(t, e || [])).next());
    });
}, $2be8636d379871d6$var$J = function(t, e) {
    var r, n, o, i, a = {
        label: 0,
        sent: function() {
            if (1 & o[0]) throw o[1];
            return o[1];
        },
        trys: [],
        ops: []
    };
    return i = {
        next: u(0),
        throw: u(1),
        return: u(2)
    }, "function" == typeof Symbol && (i[Symbol.iterator] = function() {
        return this;
    }), i;
    function u(i) {
        return function(u) {
            return function(i) {
                if (r) throw new TypeError("Generator is already executing.");
                for(; a;)try {
                    if (r = 1, n && (o = 2 & i[0] ? n.return : i[0] ? n.throw || ((o = n.return) && o.call(n), 0) : n.next) && !(o = o.call(n, i[1])).done) return o;
                    switch(n = 0, o && (i = [
                        2 & i[0],
                        o.value
                    ]), i[0]){
                        case 0:
                        case 1:
                            o = i;
                            break;
                        case 4:
                            return a.label++, {
                                value: i[1],
                                done: !1
                            };
                        case 5:
                            a.label++, n = i[1], i = [
                                0
                            ];
                            continue;
                        case 7:
                            i = a.ops.pop(), a.trys.pop();
                            continue;
                        default:
                            if (!(o = a.trys, (o = o.length > 0 && o[o.length - 1]) || 6 !== i[0] && 2 !== i[0])) {
                                a = 0;
                                continue;
                            }
                            if (3 === i[0] && (!o || i[1] > o[0] && i[1] < o[3])) {
                                a.label = i[1];
                                break;
                            }
                            if (6 === i[0] && a.label < o[1]) {
                                a.label = o[1], o = i;
                                break;
                            }
                            if (o && a.label < o[2]) {
                                a.label = o[2], a.ops.push(i);
                                break;
                            }
                            o[2] && a.ops.pop(), a.trys.pop();
                            continue;
                    }
                    i = e.call(t, a);
                } catch (t) {
                    i = [
                        6,
                        t
                    ], n = 0;
                } finally{
                    r = o = 0;
                }
                if (5 & i[0]) throw i[1];
                return {
                    value: i[0] ? i[1] : void 0,
                    done: !0
                };
            }([
                i,
                u
            ]);
        };
    }
}, $2be8636d379871d6$var$$ = function(t) {
    var e = "function" == typeof Symbol && Symbol.iterator, r = e && t[e], n = 0;
    if (r) return r.call(t);
    if (t && "number" == typeof t.length) return {
        next: function() {
            return t && n >= t.length && (t = void 0), {
                value: t && t[n++],
                done: !t
            };
        }
    };
    throw new TypeError(e ? "Object is not iterable." : "Symbol.iterator is not defined.");
}, $2be8636d379871d6$var$tt = function() {
    function t(t, e, r) {
        void 0 === e && (e = 500), this.reader = t, this.timeBetweenScansMillis = e, this._hints = r, this._stopContinuousDecode = !1, this._stopAsyncDecode = !1, this._timeBetweenDecodingAttempts = 0;
    }
    return Object.defineProperty(t.prototype, "hasNavigator", {
        get: function() {
            return "undefined" != typeof navigator;
        },
        enumerable: !1,
        configurable: !0
    }), Object.defineProperty(t.prototype, "isMediaDevicesSuported", {
        get: function() {
            return this.hasNavigator && !!navigator.mediaDevices;
        },
        enumerable: !1,
        configurable: !0
    }), Object.defineProperty(t.prototype, "canEnumerateDevices", {
        get: function() {
            return !(!this.isMediaDevicesSuported || !navigator.mediaDevices.enumerateDevices);
        },
        enumerable: !1,
        configurable: !0
    }), Object.defineProperty(t.prototype, "timeBetweenDecodingAttempts", {
        get: function() {
            return this._timeBetweenDecodingAttempts;
        },
        set: function(t) {
            this._timeBetweenDecodingAttempts = t < 0 ? 0 : t;
        },
        enumerable: !1,
        configurable: !0
    }), Object.defineProperty(t.prototype, "hints", {
        get: function() {
            return this._hints;
        },
        set: function(t) {
            this._hints = t || null;
        },
        enumerable: !1,
        configurable: !0
    }), t.prototype.listVideoInputDevices = function() {
        return $2be8636d379871d6$var$Q(this, void 0, void 0, function() {
            var t, e, r, n, o, i, a, u, s, c, f, h;
            return $2be8636d379871d6$var$J(this, function(l) {
                switch(l.label){
                    case 0:
                        if (!this.hasNavigator) throw new Error("Can't enumerate devices, navigator is not present.");
                        if (!this.canEnumerateDevices) throw new Error("Can't enumerate devices, method not supported.");
                        return [
                            4,
                            navigator.mediaDevices.enumerateDevices()
                        ];
                    case 1:
                        t = l.sent(), e = [];
                        try {
                            for(r = $2be8636d379871d6$var$$(t), n = r.next(); !n.done; n = r.next())o = n.value, "videoinput" === (i = "video" === o.kind ? "videoinput" : o.kind) && (a = o.deviceId || o.id, u = o.label || "Video device " + (e.length + 1), s = o.groupId, c = {
                                deviceId: a,
                                label: u,
                                kind: i,
                                groupId: s
                            }, e.push(c));
                        } catch (t) {
                            f = {
                                error: t
                            };
                        } finally{
                            try {
                                n && !n.done && (h = r.return) && h.call(r);
                            } finally{
                                if (f) throw f.error;
                            }
                        }
                        return [
                            2,
                            e
                        ];
                }
            });
        });
    }, t.prototype.getVideoInputDevices = function() {
        return $2be8636d379871d6$var$Q(this, void 0, void 0, function() {
            return $2be8636d379871d6$var$J(this, function(t) {
                switch(t.label){
                    case 0:
                        return [
                            4,
                            this.listVideoInputDevices()
                        ];
                    case 1:
                        return [
                            2,
                            t.sent().map(function(t) {
                                return new $2be8636d379871d6$var$q(t.deviceId, t.label);
                            })
                        ];
                }
            });
        });
    }, t.prototype.findDeviceById = function(t) {
        return $2be8636d379871d6$var$Q(this, void 0, void 0, function() {
            var e;
            return $2be8636d379871d6$var$J(this, function(r) {
                switch(r.label){
                    case 0:
                        return [
                            4,
                            this.listVideoInputDevices()
                        ];
                    case 1:
                        return (e = r.sent()) ? [
                            2,
                            e.find(function(e) {
                                return e.deviceId === t;
                            })
                        ] : [
                            2,
                            null
                        ];
                }
            });
        });
    }, t.prototype.decodeFromInputVideoDevice = function(t, e) {
        return $2be8636d379871d6$var$Q(this, void 0, void 0, function() {
            return $2be8636d379871d6$var$J(this, function(r) {
                switch(r.label){
                    case 0:
                        return [
                            4,
                            this.decodeOnceFromVideoDevice(t, e)
                        ];
                    case 1:
                        return [
                            2,
                            r.sent()
                        ];
                }
            });
        });
    }, t.prototype.decodeOnceFromVideoDevice = function(t, e) {
        return $2be8636d379871d6$var$Q(this, void 0, void 0, function() {
            var r;
            return $2be8636d379871d6$var$J(this, function(n) {
                switch(n.label){
                    case 0:
                        return this.reset(), r = {
                            video: t ? {
                                deviceId: {
                                    exact: t
                                }
                            } : {
                                facingMode: "environment"
                            }
                        }, [
                            4,
                            this.decodeOnceFromConstraints(r, e)
                        ];
                    case 1:
                        return [
                            2,
                            n.sent()
                        ];
                }
            });
        });
    }, t.prototype.decodeOnceFromConstraints = function(t, e) {
        return $2be8636d379871d6$var$Q(this, void 0, void 0, function() {
            var r;
            return $2be8636d379871d6$var$J(this, function(n) {
                switch(n.label){
                    case 0:
                        return [
                            4,
                            navigator.mediaDevices.getUserMedia(t)
                        ];
                    case 1:
                        return r = n.sent(), [
                            4,
                            this.decodeOnceFromStream(r, e)
                        ];
                    case 2:
                        return [
                            2,
                            n.sent()
                        ];
                }
            });
        });
    }, t.prototype.decodeOnceFromStream = function(t, e) {
        return $2be8636d379871d6$var$Q(this, void 0, void 0, function() {
            var r;
            return $2be8636d379871d6$var$J(this, function(n) {
                switch(n.label){
                    case 0:
                        return this.reset(), [
                            4,
                            this.attachStreamToVideo(t, e)
                        ];
                    case 1:
                        return r = n.sent(), [
                            4,
                            this.decodeOnce(r)
                        ];
                    case 2:
                        return [
                            2,
                            n.sent()
                        ];
                }
            });
        });
    }, t.prototype.decodeFromInputVideoDeviceContinuously = function(t, e, r) {
        return $2be8636d379871d6$var$Q(this, void 0, void 0, function() {
            return $2be8636d379871d6$var$J(this, function(n) {
                switch(n.label){
                    case 0:
                        return [
                            4,
                            this.decodeFromVideoDevice(t, e, r)
                        ];
                    case 1:
                        return [
                            2,
                            n.sent()
                        ];
                }
            });
        });
    }, t.prototype.decodeFromVideoDevice = function(t, e, r) {
        return $2be8636d379871d6$var$Q(this, void 0, void 0, function() {
            var n;
            return $2be8636d379871d6$var$J(this, function(o) {
                switch(o.label){
                    case 0:
                        return n = {
                            video: t ? {
                                deviceId: {
                                    exact: t
                                }
                            } : {
                                facingMode: "environment"
                            }
                        }, [
                            4,
                            this.decodeFromConstraints(n, e, r)
                        ];
                    case 1:
                        return [
                            2,
                            o.sent()
                        ];
                }
            });
        });
    }, t.prototype.decodeFromConstraints = function(t, e, r) {
        return $2be8636d379871d6$var$Q(this, void 0, void 0, function() {
            var n;
            return $2be8636d379871d6$var$J(this, function(o) {
                switch(o.label){
                    case 0:
                        return [
                            4,
                            navigator.mediaDevices.getUserMedia(t)
                        ];
                    case 1:
                        return n = o.sent(), [
                            4,
                            this.decodeFromStream(n, e, r)
                        ];
                    case 2:
                        return [
                            2,
                            o.sent()
                        ];
                }
            });
        });
    }, t.prototype.decodeFromStream = function(t, e, r) {
        return $2be8636d379871d6$var$Q(this, void 0, void 0, function() {
            var n;
            return $2be8636d379871d6$var$J(this, function(o) {
                switch(o.label){
                    case 0:
                        return this.reset(), [
                            4,
                            this.attachStreamToVideo(t, e)
                        ];
                    case 1:
                        return n = o.sent(), [
                            4,
                            this.decodeContinuously(n, r)
                        ];
                    case 2:
                        return [
                            2,
                            o.sent()
                        ];
                }
            });
        });
    }, t.prototype.stopAsyncDecode = function() {
        this._stopAsyncDecode = !0;
    }, t.prototype.stopContinuousDecode = function() {
        this._stopContinuousDecode = !0;
    }, t.prototype.attachStreamToVideo = function(t, e) {
        return $2be8636d379871d6$var$Q(this, void 0, void 0, function() {
            var r;
            return $2be8636d379871d6$var$J(this, function(n) {
                switch(n.label){
                    case 0:
                        return r = this.prepareVideoElement(e), this.addVideoSource(r, t), this.videoElement = r, this.stream = t, [
                            4,
                            this.playVideoOnLoadAsync(r)
                        ];
                    case 1:
                        return n.sent(), [
                            2,
                            r
                        ];
                }
            });
        });
    }, t.prototype.playVideoOnLoadAsync = function(t) {
        var e = this;
        return new Promise(function(r, n) {
            return e.playVideoOnLoad(t, function() {
                return r();
            });
        });
    }, t.prototype.playVideoOnLoad = function(t, e) {
        var r = this;
        this.videoEndedListener = function() {
            return r.stopStreams();
        }, this.videoCanPlayListener = function() {
            return r.tryPlayVideo(t);
        }, t.addEventListener("ended", this.videoEndedListener), t.addEventListener("canplay", this.videoCanPlayListener), t.addEventListener("playing", e), this.tryPlayVideo(t);
    }, t.prototype.isVideoPlaying = function(t) {
        return t.currentTime > 0 && !t.paused && !t.ended && t.readyState > 2;
    }, t.prototype.tryPlayVideo = function(t) {
        return $2be8636d379871d6$var$Q(this, void 0, void 0, function() {
            return $2be8636d379871d6$var$J(this, function(e) {
                switch(e.label){
                    case 0:
                        if (this.isVideoPlaying(t)) return console.warn("Trying to play video that is already playing."), [
                            2
                        ];
                        e.label = 1;
                    case 1:
                        return e.trys.push([
                            1,
                            3,
                            ,
                            4
                        ]), [
                            4,
                            t.play()
                        ];
                    case 2:
                        return e.sent(), [
                            3,
                            4
                        ];
                    case 3:
                        return e.sent(), console.warn("It was not possible to play the video."), [
                            3,
                            4
                        ];
                    case 4:
                        return [
                            2
                        ];
                }
            });
        });
    }, t.prototype.getMediaElement = function(t, e) {
        var r = document.getElementById(t);
        if (!r) throw new $2be8636d379871d6$var$f("element with id '" + t + "' not found");
        if (r.nodeName.toLowerCase() !== e.toLowerCase()) throw new $2be8636d379871d6$var$f("element with id '" + t + "' must be an " + e + " element");
        return r;
    }, t.prototype.decodeFromImage = function(t, e) {
        if (!t && !e) throw new $2be8636d379871d6$var$f("either imageElement with a src set or an url must be provided");
        return e && !t ? this.decodeFromImageUrl(e) : this.decodeFromImageElement(t);
    }, t.prototype.decodeFromVideo = function(t, e) {
        if (!t && !e) throw new $2be8636d379871d6$var$f("Either an element with a src set or an URL must be provided");
        return e && !t ? this.decodeFromVideoUrl(e) : this.decodeFromVideoElement(t);
    }, t.prototype.decodeFromVideoContinuously = function(t, e, r) {
        if (void 0 === t && void 0 === e) throw new $2be8636d379871d6$var$f("Either an element with a src set or an URL must be provided");
        return e && !t ? this.decodeFromVideoUrlContinuously(e, r) : this.decodeFromVideoElementContinuously(t, r);
    }, t.prototype.decodeFromImageElement = function(t) {
        if (!t) throw new $2be8636d379871d6$var$f("An image element must be provided.");
        this.reset();
        var e = this.prepareImageElement(t);
        return this.imageElement = e, this.isImageLoaded(e) ? this.decodeOnce(e, !1, !0) : this._decodeOnLoadImage(e);
    }, t.prototype.decodeFromVideoElement = function(t) {
        var e = this._decodeFromVideoElementSetup(t);
        return this._decodeOnLoadVideo(e);
    }, t.prototype.decodeFromVideoElementContinuously = function(t, e) {
        var r = this._decodeFromVideoElementSetup(t);
        return this._decodeOnLoadVideoContinuously(r, e);
    }, t.prototype._decodeFromVideoElementSetup = function(t) {
        if (!t) throw new $2be8636d379871d6$var$f("A video element must be provided.");
        this.reset();
        var e = this.prepareVideoElement(t);
        return this.videoElement = e, e;
    }, t.prototype.decodeFromImageUrl = function(t) {
        if (!t) throw new $2be8636d379871d6$var$f("An URL must be provided.");
        this.reset();
        var e = this.prepareImageElement();
        this.imageElement = e;
        var r = this._decodeOnLoadImage(e);
        return e.src = t, r;
    }, t.prototype.decodeFromVideoUrl = function(t) {
        if (!t) throw new $2be8636d379871d6$var$f("An URL must be provided.");
        this.reset();
        var e = this.prepareVideoElement(), r = this.decodeFromVideoElement(e);
        return e.src = t, r;
    }, t.prototype.decodeFromVideoUrlContinuously = function(t, e) {
        if (!t) throw new $2be8636d379871d6$var$f("An URL must be provided.");
        this.reset();
        var r = this.prepareVideoElement(), n = this.decodeFromVideoElementContinuously(r, e);
        return r.src = t, n;
    }, t.prototype._decodeOnLoadImage = function(t) {
        var e = this;
        return new Promise(function(r, n) {
            e.imageLoadedListener = function() {
                return e.decodeOnce(t, !1, !0).then(r, n);
            }, t.addEventListener("load", e.imageLoadedListener);
        });
    }, t.prototype._decodeOnLoadVideo = function(t) {
        return $2be8636d379871d6$var$Q(this, void 0, void 0, function() {
            return $2be8636d379871d6$var$J(this, function(e) {
                switch(e.label){
                    case 0:
                        return [
                            4,
                            this.playVideoOnLoadAsync(t)
                        ];
                    case 1:
                        return e.sent(), [
                            4,
                            this.decodeOnce(t)
                        ];
                    case 2:
                        return [
                            2,
                            e.sent()
                        ];
                }
            });
        });
    }, t.prototype._decodeOnLoadVideoContinuously = function(t, e) {
        return $2be8636d379871d6$var$Q(this, void 0, void 0, function() {
            return $2be8636d379871d6$var$J(this, function(r) {
                switch(r.label){
                    case 0:
                        return [
                            4,
                            this.playVideoOnLoadAsync(t)
                        ];
                    case 1:
                        return r.sent(), this.decodeContinuously(t, e), [
                            2
                        ];
                }
            });
        });
    }, t.prototype.isImageLoaded = function(t) {
        return !!t.complete && 0 !== t.naturalWidth;
    }, t.prototype.prepareImageElement = function(t) {
        var e;
        return void 0 === t && ((e = document.createElement("img")).width = 200, e.height = 200), "string" == typeof t && (e = this.getMediaElement(t, "img")), t instanceof HTMLImageElement && (e = t), e;
    }, t.prototype.prepareVideoElement = function(t) {
        var e;
        return t || "undefined" == typeof document || ((e = document.createElement("video")).width = 200, e.height = 200), "string" == typeof t && (e = this.getMediaElement(t, "video")), t instanceof HTMLVideoElement && (e = t), e.setAttribute("autoplay", "true"), e.setAttribute("muted", "true"), e.setAttribute("playsinline", "true"), e;
    }, t.prototype.decodeOnce = function(t, e, r) {
        var n = this;
        void 0 === e && (e = !0), void 0 === r && (r = !0), this._stopAsyncDecode = !1;
        var o = function(i, a) {
            if (n._stopAsyncDecode) return a(new $2be8636d379871d6$var$U("Video stream has ended before any code could be detected.")), void (n._stopAsyncDecode = void 0);
            try {
                i(n.decode(t));
            } catch (t) {
                if (e && t instanceof $2be8636d379871d6$var$U || (t instanceof $2be8636d379871d6$var$g || t instanceof $2be8636d379871d6$var$R) && r) return setTimeout(o, n._timeBetweenDecodingAttempts, i, a);
                a(t);
            }
        };
        return new Promise(function(t, e) {
            return o(t, e);
        });
    }, t.prototype.decodeContinuously = function(t, e) {
        var r = this;
        this._stopContinuousDecode = !1;
        var n = function() {
            if (r._stopContinuousDecode) r._stopContinuousDecode = void 0;
            else try {
                var o = r.decode(t);
                e(o, null), setTimeout(n, r.timeBetweenScansMillis);
            } catch (t) {
                e(null, t), (t instanceof $2be8636d379871d6$var$g || t instanceof $2be8636d379871d6$var$R || t instanceof $2be8636d379871d6$var$U) && setTimeout(n, r._timeBetweenDecodingAttempts);
            }
        };
        n();
    }, t.prototype.decode = function(t) {
        var e = this.createBinaryBitmap(t);
        return this.decodeBitmap(e);
    }, t.prototype.createBinaryBitmap = function(t) {
        var e = this.getCaptureCanvasContext(t);
        this.drawImageOnCanvas(e, t);
        var r = this.getCaptureCanvas(t), n = new $2be8636d379871d6$var$K(r), o = new $2be8636d379871d6$var$W(n);
        return new $2be8636d379871d6$var$d(o);
    }, t.prototype.getCaptureCanvasContext = function(t) {
        if (!this.captureCanvasContext) {
            var e = this.getCaptureCanvas(t).getContext("2d");
            this.captureCanvasContext = e;
        }
        return this.captureCanvasContext;
    }, t.prototype.getCaptureCanvas = function(t) {
        if (!this.captureCanvas) {
            var e = this.createCaptureCanvas(t);
            this.captureCanvas = e;
        }
        return this.captureCanvas;
    }, t.prototype.drawImageOnCanvas = function(t, e) {
        t.drawImage(e, 0, 0);
    }, t.prototype.decodeBitmap = function(t) {
        return this.reader.decode(t, this._hints);
    }, t.prototype.createCaptureCanvas = function(t) {
        if ("undefined" == typeof document) return this._destroyCaptureCanvas(), null;
        var e, r, n = document.createElement("canvas");
        return void 0 !== t && (t instanceof HTMLVideoElement ? (e = t.videoWidth, r = t.videoHeight) : t instanceof HTMLImageElement && (e = t.naturalWidth || t.width, r = t.naturalHeight || t.height)), n.style.width = e + "px", n.style.height = r + "px", n.width = e, n.height = r, n;
    }, t.prototype.stopStreams = function() {
        this.stream && (this.stream.getVideoTracks().forEach(function(t) {
            return t.stop();
        }), this.stream = void 0), !1 === this._stopAsyncDecode && this.stopAsyncDecode(), !1 === this._stopContinuousDecode && this.stopContinuousDecode();
    }, t.prototype.reset = function() {
        this.stopStreams(), this._destroyVideoElement(), this._destroyImageElement(), this._destroyCaptureCanvas();
    }, t.prototype._destroyVideoElement = function() {
        this.videoElement && (void 0 !== this.videoEndedListener && this.videoElement.removeEventListener("ended", this.videoEndedListener), void 0 !== this.videoPlayingEventListener && this.videoElement.removeEventListener("playing", this.videoPlayingEventListener), void 0 !== this.videoCanPlayListener && this.videoElement.removeEventListener("loadedmetadata", this.videoCanPlayListener), this.cleanVideoSource(this.videoElement), this.videoElement = void 0);
    }, t.prototype._destroyImageElement = function() {
        this.imageElement && (void 0 !== this.imageLoadedListener && this.imageElement.removeEventListener("load", this.imageLoadedListener), this.imageElement.src = void 0, this.imageElement.removeAttribute("src"), this.imageElement = void 0);
    }, t.prototype._destroyCaptureCanvas = function() {
        this.captureCanvasContext = void 0, this.captureCanvas = void 0;
    }, t.prototype.addVideoSource = function(t, e) {
        try {
            t.srcObject = e;
        } catch (r) {
            t.src = URL.createObjectURL(e);
        }
    }, t.prototype.cleanVideoSource = function(t) {
        try {
            t.srcObject = null;
        } catch (e) {
            t.src = "";
        }
        this.videoElement.removeAttribute("src");
    }, t;
}(), $2be8636d379871d6$var$et = function() {
    function t(t, e, r, n, o, i) {
        void 0 === r && (r = null == e ? 0 : 8 * e.length), void 0 === i && (i = $2be8636d379871d6$var$w.currentTimeMillis()), this.text = t, this.rawBytes = e, this.numBits = r, this.resultPoints = n, this.format = o, this.timestamp = i, this.text = t, this.rawBytes = e, this.numBits = null == r ? null == e ? 0 : 8 * e.length : r, this.resultPoints = n, this.format = o, this.resultMetadata = null, this.timestamp = null == i ? $2be8636d379871d6$var$w.currentTimeMillis() : i;
    }
    return t.prototype.getText = function() {
        return this.text;
    }, t.prototype.getRawBytes = function() {
        return this.rawBytes;
    }, t.prototype.getNumBits = function() {
        return this.numBits;
    }, t.prototype.getResultPoints = function() {
        return this.resultPoints;
    }, t.prototype.getBarcodeFormat = function() {
        return this.format;
    }, t.prototype.getResultMetadata = function() {
        return this.resultMetadata;
    }, t.prototype.putMetadata = function(t, e) {
        null === this.resultMetadata && (this.resultMetadata = new Map()), this.resultMetadata.set(t, e);
    }, t.prototype.putAllMetadata = function(t) {
        null !== t && (null === this.resultMetadata ? this.resultMetadata = t : this.resultMetadata = new Map(t));
    }, t.prototype.addResultPoints = function(t) {
        var e = this.resultPoints;
        if (null === e) this.resultPoints = t;
        else if (null !== t && t.length > 0) {
            var r = new Array(e.length + t.length);
            $2be8636d379871d6$var$w.arraycopy(e, 0, r, 0, e.length), $2be8636d379871d6$var$w.arraycopy(t, 0, r, e.length, t.length), this.resultPoints = r;
        }
    }, t.prototype.getTimestamp = function() {
        return this.timestamp;
    }, t.prototype.toString = function() {
        return this.text;
    }, t;
}();
!function(t) {
    t[t.AZTEC = 0] = "AZTEC", t[t.CODABAR = 1] = "CODABAR", t[t.CODE_39 = 2] = "CODE_39", t[t.CODE_93 = 3] = "CODE_93", t[t.CODE_128 = 4] = "CODE_128", t[t.DATA_MATRIX = 5] = "DATA_MATRIX", t[t.EAN_8 = 6] = "EAN_8", t[t.EAN_13 = 7] = "EAN_13", t[t.ITF = 8] = "ITF", t[t.MAXICODE = 9] = "MAXICODE", t[t.PDF_417 = 10] = "PDF_417", t[t.QR_CODE = 11] = "QR_CODE", t[t.RSS_14 = 12] = "RSS_14", t[t.RSS_EXPANDED = 13] = "RSS_EXPANDED", t[t.UPC_A = 14] = "UPC_A", t[t.UPC_E = 15] = "UPC_E", t[t.UPC_EAN_EXTENSION = 16] = "UPC_EAN_EXTENSION";
}($2be8636d379871d6$var$D || ($2be8636d379871d6$var$D = {}));
var $2be8636d379871d6$var$rt, $2be8636d379871d6$var$nt = $2be8636d379871d6$var$D;
!function(t) {
    t[t.OTHER = 0] = "OTHER", t[t.ORIENTATION = 1] = "ORIENTATION", t[t.BYTE_SEGMENTS = 2] = "BYTE_SEGMENTS", t[t.ERROR_CORRECTION_LEVEL = 3] = "ERROR_CORRECTION_LEVEL", t[t.ISSUE_NUMBER = 4] = "ISSUE_NUMBER", t[t.SUGGESTED_PRICE = 5] = "SUGGESTED_PRICE", t[t.POSSIBLE_COUNTRY = 6] = "POSSIBLE_COUNTRY", t[t.UPC_EAN_EXTENSION = 7] = "UPC_EAN_EXTENSION", t[t.PDF417_EXTRA_METADATA = 8] = "PDF417_EXTRA_METADATA", t[t.STRUCTURED_APPEND_SEQUENCE = 9] = "STRUCTURED_APPEND_SEQUENCE", t[t.STRUCTURED_APPEND_PARITY = 10] = "STRUCTURED_APPEND_PARITY";
}($2be8636d379871d6$var$rt || ($2be8636d379871d6$var$rt = {}));
var $2be8636d379871d6$var$ot, $2be8636d379871d6$var$it = $2be8636d379871d6$var$rt, $2be8636d379871d6$var$at = function() {
    function t(t, e, r, n, o, i) {
        void 0 === o && (o = -1), void 0 === i && (i = -1), this.rawBytes = t, this.text = e, this.byteSegments = r, this.ecLevel = n, this.structuredAppendSequenceNumber = o, this.structuredAppendParity = i, this.numBits = null == t ? 0 : 8 * t.length;
    }
    return t.prototype.getRawBytes = function() {
        return this.rawBytes;
    }, t.prototype.getNumBits = function() {
        return this.numBits;
    }, t.prototype.setNumBits = function(t) {
        this.numBits = t;
    }, t.prototype.getText = function() {
        return this.text;
    }, t.prototype.getByteSegments = function() {
        return this.byteSegments;
    }, t.prototype.getECLevel = function() {
        return this.ecLevel;
    }, t.prototype.getErrorsCorrected = function() {
        return this.errorsCorrected;
    }, t.prototype.setErrorsCorrected = function(t) {
        this.errorsCorrected = t;
    }, t.prototype.getErasures = function() {
        return this.erasures;
    }, t.prototype.setErasures = function(t) {
        this.erasures = t;
    }, t.prototype.getOther = function() {
        return this.other;
    }, t.prototype.setOther = function(t) {
        this.other = t;
    }, t.prototype.hasStructuredAppend = function() {
        return this.structuredAppendParity >= 0 && this.structuredAppendSequenceNumber >= 0;
    }, t.prototype.getStructuredAppendParity = function() {
        return this.structuredAppendParity;
    }, t.prototype.getStructuredAppendSequenceNumber = function() {
        return this.structuredAppendSequenceNumber;
    }, t;
}(), $2be8636d379871d6$var$ut = function() {
    function t() {}
    return t.prototype.exp = function(t) {
        return this.expTable[t];
    }, t.prototype.log = function(t) {
        if (0 === t) throw new $2be8636d379871d6$var$l();
        return this.logTable[t];
    }, t.addOrSubtract = function(t, e) {
        return t ^ e;
    }, t;
}(), $2be8636d379871d6$var$st = function() {
    function t(t, e) {
        if (0 === e.length) throw new $2be8636d379871d6$var$l();
        this.field = t;
        var r = e.length;
        if (r > 1 && 0 === e[0]) {
            for(var n = 1; n < r && 0 === e[n];)n++;
            n === r ? this.coefficients = Int32Array.from([
                0
            ]) : (this.coefficients = new Int32Array(r - n), $2be8636d379871d6$var$w.arraycopy(e, n, this.coefficients, 0, this.coefficients.length));
        } else this.coefficients = e;
    }
    return t.prototype.getCoefficients = function() {
        return this.coefficients;
    }, t.prototype.getDegree = function() {
        return this.coefficients.length - 1;
    }, t.prototype.isZero = function() {
        return 0 === this.coefficients[0];
    }, t.prototype.getCoefficient = function(t) {
        return this.coefficients[this.coefficients.length - 1 - t];
    }, t.prototype.evaluateAt = function(t) {
        if (0 === t) return this.getCoefficient(0);
        var e, r = this.coefficients;
        if (1 === t) {
            e = 0;
            for(var n = 0, o = r.length; n !== o; n++){
                var i = r[n];
                e = $2be8636d379871d6$var$ut.addOrSubtract(e, i);
            }
            return e;
        }
        e = r[0];
        var a = r.length, u = this.field;
        for(n = 1; n < a; n++)e = $2be8636d379871d6$var$ut.addOrSubtract(u.multiply(t, e), r[n]);
        return e;
    }, t.prototype.addOrSubtract = function(e) {
        if (!this.field.equals(e.field)) throw new $2be8636d379871d6$var$l("GenericGFPolys do not have same GenericGF field");
        if (this.isZero()) return e;
        if (e.isZero()) return this;
        var r = this.coefficients, n = e.coefficients;
        if (r.length > n.length) {
            var o = r;
            r = n, n = o;
        }
        var i = new Int32Array(n.length), a = n.length - r.length;
        $2be8636d379871d6$var$w.arraycopy(n, 0, i, 0, a);
        for(var u = a; u < n.length; u++)i[u] = $2be8636d379871d6$var$ut.addOrSubtract(r[u - a], n[u]);
        return new t(this.field, i);
    }, t.prototype.multiply = function(e) {
        if (!this.field.equals(e.field)) throw new $2be8636d379871d6$var$l("GenericGFPolys do not have same GenericGF field");
        if (this.isZero() || e.isZero()) return this.field.getZero();
        for(var r = this.coefficients, n = r.length, o = e.coefficients, i = o.length, a = new Int32Array(n + i - 1), u = this.field, s = 0; s < n; s++)for(var c = r[s], f = 0; f < i; f++)a[s + f] = $2be8636d379871d6$var$ut.addOrSubtract(a[s + f], u.multiply(c, o[f]));
        return new t(u, a);
    }, t.prototype.multiplyScalar = function(e) {
        if (0 === e) return this.field.getZero();
        if (1 === e) return this;
        for(var r = this.coefficients.length, n = this.field, o = new Int32Array(r), i = this.coefficients, a = 0; a < r; a++)o[a] = n.multiply(i[a], e);
        return new t(n, o);
    }, t.prototype.multiplyByMonomial = function(e, r) {
        if (e < 0) throw new $2be8636d379871d6$var$l();
        if (0 === r) return this.field.getZero();
        for(var n = this.coefficients, o = n.length, i = new Int32Array(o + e), a = this.field, u = 0; u < o; u++)i[u] = a.multiply(n[u], r);
        return new t(a, i);
    }, t.prototype.divide = function(t) {
        if (!this.field.equals(t.field)) throw new $2be8636d379871d6$var$l("GenericGFPolys do not have same GenericGF field");
        if (t.isZero()) throw new $2be8636d379871d6$var$l("Divide by 0");
        for(var e = this.field, r = e.getZero(), n = this, o = t.getCoefficient(t.getDegree()), i = e.inverse(o); n.getDegree() >= t.getDegree() && !n.isZero();){
            var a = n.getDegree() - t.getDegree(), u = e.multiply(n.getCoefficient(n.getDegree()), i), s = t.multiplyByMonomial(a, u), c = e.buildMonomial(a, u);
            r = r.addOrSubtract(c), n = n.addOrSubtract(s);
        }
        return [
            r,
            n
        ];
    }, t.prototype.toString = function() {
        for(var t = "", e = this.getDegree(); e >= 0; e--){
            var r = this.getCoefficient(e);
            if (0 !== r) {
                if (r < 0 ? (t += " - ", r = -r) : t.length > 0 && (t += " + "), 0 === e || 1 !== r) {
                    var n = this.field.log(r);
                    0 === n ? t += "1" : 1 === n ? t += "a" : (t += "a^", t += n);
                }
                0 !== e && (1 === e ? t += "x" : (t += "x^", t += e));
            }
        }
        return t;
    }, t;
}(), $2be8636d379871d6$var$ct = function() {
    var t = function(e, r) {
        return t = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(t, e) {
            t.__proto__ = e;
        } || function(t, e) {
            for(var r in e)e.hasOwnProperty(r) && (t[r] = e[r]);
        }, t(e, r);
    };
    return function(e, r) {
        function n() {
            this.constructor = e;
        }
        t(e, r), e.prototype = null === r ? Object.create(r) : (n.prototype = r.prototype, new n());
    };
}(), $2be8636d379871d6$var$ft = function(t) {
    function e() {
        return null !== t && t.apply(this, arguments) || this;
    }
    return $2be8636d379871d6$var$ct(e, t), e.kind = "ArithmeticException", e;
}($2be8636d379871d6$var$s), $2be8636d379871d6$var$ht = function() {
    var t = function(e, r) {
        return t = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(t, e) {
            t.__proto__ = e;
        } || function(t, e) {
            for(var r in e)e.hasOwnProperty(r) && (t[r] = e[r]);
        }, t(e, r);
    };
    return function(e, r) {
        function n() {
            this.constructor = e;
        }
        t(e, r), e.prototype = null === r ? Object.create(r) : (n.prototype = r.prototype, new n());
    };
}(), $2be8636d379871d6$var$lt = function(t) {
    function e(e, r, n) {
        var o = t.call(this) || this;
        o.primitive = e, o.size = r, o.generatorBase = n;
        for(var i = new Int32Array(r), a = 1, u = 0; u < r; u++)i[u] = a, (a *= 2) >= r && (a ^= e, a &= r - 1);
        o.expTable = i;
        var s = new Int32Array(r);
        for(u = 0; u < r - 1; u++)s[i[u]] = u;
        return o.logTable = s, o.zero = new $2be8636d379871d6$var$st(o, Int32Array.from([
            0
        ])), o.one = new $2be8636d379871d6$var$st(o, Int32Array.from([
            1
        ])), o;
    }
    return $2be8636d379871d6$var$ht(e, t), e.prototype.getZero = function() {
        return this.zero;
    }, e.prototype.getOne = function() {
        return this.one;
    }, e.prototype.buildMonomial = function(t, e) {
        if (t < 0) throw new $2be8636d379871d6$var$l();
        if (0 === e) return this.zero;
        var r = new Int32Array(t + 1);
        return r[0] = e, new $2be8636d379871d6$var$st(this, r);
    }, e.prototype.inverse = function(t) {
        if (0 === t) throw new $2be8636d379871d6$var$ft();
        return this.expTable[this.size - this.logTable[t] - 1];
    }, e.prototype.multiply = function(t, e) {
        return 0 === t || 0 === e ? 0 : this.expTable[(this.logTable[t] + this.logTable[e]) % (this.size - 1)];
    }, e.prototype.getSize = function() {
        return this.size;
    }, e.prototype.getGeneratorBase = function() {
        return this.generatorBase;
    }, e.prototype.toString = function() {
        return "GF(0x" + $2be8636d379871d6$var$I.toHexString(this.primitive) + "," + this.size + ")";
    }, e.prototype.equals = function(t) {
        return t === this;
    }, e.AZTEC_DATA_12 = new e(4201, 4096, 1), e.AZTEC_DATA_10 = new e(1033, 1024, 1), e.AZTEC_DATA_6 = new e(67, 64, 1), e.AZTEC_PARAM = new e(19, 16, 1), e.QR_CODE_FIELD_256 = new e(285, 256, 0), e.DATA_MATRIX_FIELD_256 = new e(301, 256, 1), e.AZTEC_DATA_8 = e.DATA_MATRIX_FIELD_256, e.MAXICODE_FIELD_64 = e.AZTEC_DATA_6, e;
}($2be8636d379871d6$var$ut), $2be8636d379871d6$var$dt = function() {
    var t = function(e, r) {
        return t = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(t, e) {
            t.__proto__ = e;
        } || function(t, e) {
            for(var r in e)e.hasOwnProperty(r) && (t[r] = e[r]);
        }, t(e, r);
    };
    return function(e, r) {
        function n() {
            this.constructor = e;
        }
        t(e, r), e.prototype = null === r ? Object.create(r) : (n.prototype = r.prototype, new n());
    };
}(), $2be8636d379871d6$var$pt = function(t) {
    function e() {
        return null !== t && t.apply(this, arguments) || this;
    }
    return $2be8636d379871d6$var$dt(e, t), e.kind = "ReedSolomonException", e;
}($2be8636d379871d6$var$s), $2be8636d379871d6$var$gt = function() {
    var t = function(e, r) {
        return t = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(t, e) {
            t.__proto__ = e;
        } || function(t, e) {
            for(var r in e)e.hasOwnProperty(r) && (t[r] = e[r]);
        }, t(e, r);
    };
    return function(e, r) {
        function n() {
            this.constructor = e;
        }
        t(e, r), e.prototype = null === r ? Object.create(r) : (n.prototype = r.prototype, new n());
    };
}(), $2be8636d379871d6$var$yt = function(t) {
    function e() {
        return null !== t && t.apply(this, arguments) || this;
    }
    return $2be8636d379871d6$var$gt(e, t), e.kind = "IllegalStateException", e;
}($2be8636d379871d6$var$s), $2be8636d379871d6$var$wt = function() {
    function t(t) {
        this.field = t;
    }
    return t.prototype.decode = function(t, e) {
        for(var r = this.field, n = new $2be8636d379871d6$var$st(r, t), o = new Int32Array(e), i = !0, a = 0; a < e; a++){
            var u = n.evaluateAt(r.exp(a + r.getGeneratorBase()));
            o[o.length - 1 - a] = u, 0 !== u && (i = !1);
        }
        if (!i) {
            var s = new $2be8636d379871d6$var$st(r, o), c = this.runEuclideanAlgorithm(r.buildMonomial(e, 1), s, e), f = c[0], h = c[1], l = this.findErrorLocations(f), d = this.findErrorMagnitudes(h, l);
            for(a = 0; a < l.length; a++){
                var p = t.length - 1 - r.log(l[a]);
                if (p < 0) throw new $2be8636d379871d6$var$pt("Bad error location");
                t[p] = $2be8636d379871d6$var$lt.addOrSubtract(t[p], d[a]);
            }
        }
    }, t.prototype.runEuclideanAlgorithm = function(t, e, r) {
        if (t.getDegree() < e.getDegree()) {
            var n = t;
            t = e, e = n;
        }
        for(var o = this.field, i = t, a = e, u = o.getZero(), s = o.getOne(); a.getDegree() >= (r / 2 | 0);){
            var c = i, f = u;
            if (u = s, (i = a).isZero()) throw new $2be8636d379871d6$var$pt("r_{i-1} was zero");
            a = c;
            for(var h = o.getZero(), l = i.getCoefficient(i.getDegree()), d = o.inverse(l); a.getDegree() >= i.getDegree() && !a.isZero();){
                var p = a.getDegree() - i.getDegree(), g = o.multiply(a.getCoefficient(a.getDegree()), d);
                h = h.addOrSubtract(o.buildMonomial(p, g)), a = a.addOrSubtract(i.multiplyByMonomial(p, g));
            }
            if (s = h.multiply(u).addOrSubtract(f), a.getDegree() >= i.getDegree()) throw new $2be8636d379871d6$var$yt("Division algorithm failed to reduce polynomial?");
        }
        var y = s.getCoefficient(0);
        if (0 === y) throw new $2be8636d379871d6$var$pt("sigmaTilde(0) was zero");
        var w = o.inverse(y);
        return [
            s.multiplyScalar(w),
            a.multiplyScalar(w)
        ];
    }, t.prototype.findErrorLocations = function(t) {
        var e = t.getDegree();
        if (1 === e) return Int32Array.from([
            t.getCoefficient(1)
        ]);
        for(var r = new Int32Array(e), n = 0, o = this.field, i = 1; i < o.getSize() && n < e; i++)0 === t.evaluateAt(i) && (r[n] = o.inverse(i), n++);
        if (n !== e) throw new $2be8636d379871d6$var$pt("Error locator degree does not match number of roots");
        return r;
    }, t.prototype.findErrorMagnitudes = function(t, e) {
        for(var r = e.length, n = new Int32Array(r), o = this.field, i = 0; i < r; i++){
            for(var a = o.inverse(e[i]), u = 1, s = 0; s < r; s++)if (i !== s) {
                var c = o.multiply(e[s], a), f = 0 == (1 & c) ? 1 | c : -2 & c;
                u = o.multiply(u, f);
            }
            n[i] = o.multiply(t.evaluateAt(a), o.inverse(u)), 0 !== o.getGeneratorBase() && (n[i] = o.multiply(n[i], a));
        }
        return n;
    }, t;
}();
!function(t) {
    t[t.UPPER = 0] = "UPPER", t[t.LOWER = 1] = "LOWER", t[t.MIXED = 2] = "MIXED", t[t.DIGIT = 3] = "DIGIT", t[t.PUNCT = 4] = "PUNCT", t[t.BINARY = 5] = "BINARY";
}($2be8636d379871d6$var$ot || ($2be8636d379871d6$var$ot = {}));
var $2be8636d379871d6$var$_t = function() {
    function t() {}
    return t.prototype.decode = function(e) {
        this.ddata = e;
        var r = e.getBits(), n = this.extractBits(r), o = this.correctBits(n), i = t.convertBoolArrayToByteArray(o), a = t.getEncodedData(o), u = new $2be8636d379871d6$var$at(i, a, null, null);
        return u.setNumBits(o.length), u;
    }, t.highLevelDecode = function(t) {
        return this.getEncodedData(t);
    }, t.getEncodedData = function(e) {
        for(var r = e.length, n = $2be8636d379871d6$var$ot.UPPER, o = $2be8636d379871d6$var$ot.UPPER, i = "", a = 0; a < r;)if (o === $2be8636d379871d6$var$ot.BINARY) {
            if (r - a < 5) break;
            var u = t.readCode(e, a, 5);
            if (a += 5, 0 === u) {
                if (r - a < 11) break;
                u = t.readCode(e, a, 11) + 31, a += 11;
            }
            for(var s = 0; s < u; s++){
                if (r - a < 8) {
                    a = r;
                    break;
                }
                var c = t.readCode(e, a, 8);
                i += $2be8636d379871d6$var$F.castAsNonUtf8Char(c), a += 8;
            }
            o = n;
        } else {
            var f = o === $2be8636d379871d6$var$ot.DIGIT ? 4 : 5;
            if (r - a < f) break;
            c = t.readCode(e, a, f);
            a += f;
            var h = t.getCharacter(o, c);
            h.startsWith("CTRL_") ? (n = o, o = t.getTable(h.charAt(5)), "L" === h.charAt(6) && (n = o)) : (i += h, o = n);
        }
        return i;
    }, t.getTable = function(t) {
        switch(t){
            case "L":
                return $2be8636d379871d6$var$ot.LOWER;
            case "P":
                return $2be8636d379871d6$var$ot.PUNCT;
            case "M":
                return $2be8636d379871d6$var$ot.MIXED;
            case "D":
                return $2be8636d379871d6$var$ot.DIGIT;
            case "B":
                return $2be8636d379871d6$var$ot.BINARY;
            default:
                return $2be8636d379871d6$var$ot.UPPER;
        }
    }, t.getCharacter = function(e, r) {
        switch(e){
            case $2be8636d379871d6$var$ot.UPPER:
                return t.UPPER_TABLE[r];
            case $2be8636d379871d6$var$ot.LOWER:
                return t.LOWER_TABLE[r];
            case $2be8636d379871d6$var$ot.MIXED:
                return t.MIXED_TABLE[r];
            case $2be8636d379871d6$var$ot.PUNCT:
                return t.PUNCT_TABLE[r];
            case $2be8636d379871d6$var$ot.DIGIT:
                return t.DIGIT_TABLE[r];
            default:
                throw new $2be8636d379871d6$var$yt("Bad table");
        }
    }, t.prototype.correctBits = function(e) {
        var r, n;
        this.ddata.getNbLayers() <= 2 ? (n = 6, r = $2be8636d379871d6$var$lt.AZTEC_DATA_6) : this.ddata.getNbLayers() <= 8 ? (n = 8, r = $2be8636d379871d6$var$lt.AZTEC_DATA_8) : this.ddata.getNbLayers() <= 22 ? (n = 10, r = $2be8636d379871d6$var$lt.AZTEC_DATA_10) : (n = 12, r = $2be8636d379871d6$var$lt.AZTEC_DATA_12);
        var o = this.ddata.getNbDatablocks(), i = e.length / n;
        if (i < o) throw new $2be8636d379871d6$var$R();
        for(var a = e.length % n, u = new Int32Array(i), s = 0; s < i; s++, a += n)u[s] = t.readCode(e, a, n);
        try {
            new $2be8636d379871d6$var$wt(r).decode(u, i - o);
        } catch (t) {
            throw new $2be8636d379871d6$var$R(t);
        }
        var c = (1 << n) - 1, f = 0;
        for(s = 0; s < o; s++){
            if (0 === (d = u[s]) || d === c) throw new $2be8636d379871d6$var$R();
            1 !== d && d !== c - 1 || f++;
        }
        var h = new Array(o * n - f), l = 0;
        for(s = 0; s < o; s++){
            var d;
            if (1 === (d = u[s]) || d === c - 1) h.fill(d > 1, l, l + n - 1), l += n - 1;
            else for(var p = n - 1; p >= 0; --p)h[l++] = 0 != (d & 1 << p);
        }
        return h;
    }, t.prototype.extractBits = function(t) {
        var e = this.ddata.isCompact(), r = this.ddata.getNbLayers(), n = (e ? 11 : 14) + 4 * r, o = new Int32Array(n), i = new Array(this.totalBitsInLayer(r, e));
        if (e) for(var a = 0; a < o.length; a++)o[a] = a;
        else {
            var u = n + 1 + 2 * $2be8636d379871d6$var$I.truncDivision($2be8636d379871d6$var$I.truncDivision(n, 2) - 1, 15), s = n / 2, c = $2be8636d379871d6$var$I.truncDivision(u, 2);
            for(a = 0; a < s; a++){
                var f = a + $2be8636d379871d6$var$I.truncDivision(a, 15);
                o[s - a - 1] = c - f - 1, o[s + a] = c + f + 1;
            }
        }
        a = 0;
        for(var h = 0; a < r; a++){
            for(var l = 4 * (r - a) + (e ? 9 : 12), d = 2 * a, p = n - 1 - d, g = 0; g < l; g++)for(var y = 2 * g, w = 0; w < 2; w++)i[h + y + w] = t.get(o[d + w], o[d + g]), i[h + 2 * l + y + w] = t.get(o[d + g], o[p - w]), i[h + 4 * l + y + w] = t.get(o[p - w], o[p - g]), i[h + 6 * l + y + w] = t.get(o[p - g], o[d + w]);
            h += 8 * l;
        }
        return i;
    }, t.readCode = function(t, e, r) {
        for(var n = 0, o = e; o < e + r; o++)n <<= 1, t[o] && (n |= 1);
        return n;
    }, t.readByte = function(e, r) {
        var n = e.length - r;
        return n >= 8 ? t.readCode(e, r, 8) : t.readCode(e, r, n) << 8 - n;
    }, t.convertBoolArrayToByteArray = function(e) {
        for(var r = new Uint8Array((e.length + 7) / 8), n = 0; n < r.length; n++)r[n] = t.readByte(e, 8 * n);
        return r;
    }, t.prototype.totalBitsInLayer = function(t, e) {
        return ((e ? 88 : 112) + 16 * t) * t;
    }, t.UPPER_TABLE = [
        "CTRL_PS",
        " ",
        "A",
        "B",
        "C",
        "D",
        "E",
        "F",
        "G",
        "H",
        "I",
        "J",
        "K",
        "L",
        "M",
        "N",
        "O",
        "P",
        "Q",
        "R",
        "S",
        "T",
        "U",
        "V",
        "W",
        "X",
        "Y",
        "Z",
        "CTRL_LL",
        "CTRL_ML",
        "CTRL_DL",
        "CTRL_BS"
    ], t.LOWER_TABLE = [
        "CTRL_PS",
        " ",
        "a",
        "b",
        "c",
        "d",
        "e",
        "f",
        "g",
        "h",
        "i",
        "j",
        "k",
        "l",
        "m",
        "n",
        "o",
        "p",
        "q",
        "r",
        "s",
        "t",
        "u",
        "v",
        "w",
        "x",
        "y",
        "z",
        "CTRL_US",
        "CTRL_ML",
        "CTRL_DL",
        "CTRL_BS"
    ], t.MIXED_TABLE = [
        "CTRL_PS",
        " ",
        "\\1",
        "\\2",
        "\\3",
        "\\4",
        "\\5",
        "\\6",
        "\\7",
        "\b",
        "	",
        "\n",
        "\\13",
        "\f",
        "\r",
        "\\33",
        "\\34",
        "\\35",
        "\\36",
        "\\37",
        "@",
        "\\",
        "^",
        "_",
        "`",
        "|",
        "~",
        "\\177",
        "CTRL_LL",
        "CTRL_UL",
        "CTRL_PL",
        "CTRL_BS"
    ], t.PUNCT_TABLE = [
        "",
        "\r",
        "\r\n",
        ". ",
        ", ",
        ": ",
        "!",
        '"',
        "#",
        "$",
        "%",
        "&",
        "'",
        "(",
        ")",
        "*",
        "+",
        ",",
        "-",
        ".",
        "/",
        ":",
        ";",
        "<",
        "=",
        ">",
        "?",
        "[",
        "]",
        "{",
        "}",
        "CTRL_UL"
    ], t.DIGIT_TABLE = [
        "CTRL_PS",
        " ",
        "0",
        "1",
        "2",
        "3",
        "4",
        "5",
        "6",
        "7",
        "8",
        "9",
        ",",
        ".",
        "CTRL_UL",
        "CTRL_US"
    ], t;
}(), $2be8636d379871d6$var$vt = function() {
    function t() {}
    return t.round = function(t) {
        return t <= Number.MIN_SAFE_INTEGER ? Number.MIN_SAFE_INTEGER : t >= Number.MAX_SAFE_INTEGER ? Number.MAX_SAFE_INTEGER : t + (t < 0 ? -0.5 : 0.5) | 0;
    }, t.distance = function(t, e, r, n) {
        var o = t - r, i = e - n;
        return Math.sqrt(o * o + i * i);
    }, t.sum = function(t) {
        for(var e = 0, r = 0, n = t.length; r !== n; r++)e += t[r];
        return e;
    }, t;
}(), $2be8636d379871d6$var$mt = function() {
    function t() {}
    return t.floatToIntBits = function(t) {
        return t;
    }, t.MAX_VALUE = Number.MAX_SAFE_INTEGER, t;
}(), $2be8636d379871d6$var$At = function() {
    function t(t, e) {
        this.x = t, this.y = e;
    }
    return t.prototype.getX = function() {
        return this.x;
    }, t.prototype.getY = function() {
        return this.y;
    }, t.prototype.equals = function(e) {
        if (e instanceof t) {
            var r = e;
            return this.x === r.x && this.y === r.y;
        }
        return !1;
    }, t.prototype.hashCode = function() {
        return 31 * $2be8636d379871d6$var$mt.floatToIntBits(this.x) + $2be8636d379871d6$var$mt.floatToIntBits(this.y);
    }, t.prototype.toString = function() {
        return "(" + this.x + "," + this.y + ")";
    }, t.orderBestPatterns = function(t) {
        var e, r, n, o = this.distance(t[0], t[1]), i = this.distance(t[1], t[2]), a = this.distance(t[0], t[2]);
        if (i >= o && i >= a ? (r = t[0], e = t[1], n = t[2]) : a >= i && a >= o ? (r = t[1], e = t[0], n = t[2]) : (r = t[2], e = t[0], n = t[1]), this.crossProductZ(e, r, n) < 0) {
            var u = e;
            e = n, n = u;
        }
        t[0] = e, t[1] = r, t[2] = n;
    }, t.distance = function(t, e) {
        return $2be8636d379871d6$var$vt.distance(t.x, t.y, e.x, e.y);
    }, t.crossProductZ = function(t, e, r) {
        var n = e.x, o = e.y;
        return (r.x - n) * (t.y - o) - (r.y - o) * (t.x - n);
    }, t;
}(), $2be8636d379871d6$var$Et = function() {
    function t(t, e) {
        this.bits = t, this.points = e;
    }
    return t.prototype.getBits = function() {
        return this.bits;
    }, t.prototype.getPoints = function() {
        return this.points;
    }, t;
}(), $2be8636d379871d6$var$Ct = function() {
    var t = function(e, r) {
        return t = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(t, e) {
            t.__proto__ = e;
        } || function(t, e) {
            for(var r in e)e.hasOwnProperty(r) && (t[r] = e[r]);
        }, t(e, r);
    };
    return function(e, r) {
        function n() {
            this.constructor = e;
        }
        t(e, r), e.prototype = null === r ? Object.create(r) : (n.prototype = r.prototype, new n());
    };
}(), $2be8636d379871d6$var$It = function(t) {
    function e(e, r, n, o, i) {
        var a = t.call(this, e, r) || this;
        return a.compact = n, a.nbDatablocks = o, a.nbLayers = i, a;
    }
    return $2be8636d379871d6$var$Ct(e, t), e.prototype.getNbLayers = function() {
        return this.nbLayers;
    }, e.prototype.getNbDatablocks = function() {
        return this.nbDatablocks;
    }, e.prototype.isCompact = function() {
        return this.compact;
    }, e;
}($2be8636d379871d6$var$Et), $2be8636d379871d6$var$St = function() {
    function t(e, r, n, o) {
        this.image = e, this.height = e.getHeight(), this.width = e.getWidth(), null == r && (r = t.INIT_SIZE), null == n && (n = e.getWidth() / 2 | 0), null == o && (o = e.getHeight() / 2 | 0);
        var i = r / 2 | 0;
        if (this.leftInit = n - i, this.rightInit = n + i, this.upInit = o - i, this.downInit = o + i, this.upInit < 0 || this.leftInit < 0 || this.downInit >= this.height || this.rightInit >= this.width) throw new $2be8636d379871d6$var$U();
    }
    return t.prototype.detect = function() {
        for(var t = this.leftInit, e = this.rightInit, r = this.upInit, n = this.downInit, o = !1, i = !0, a = !1, u = !1, s = !1, c = !1, f = !1, h = this.width, l = this.height; i;){
            i = !1;
            for(var d = !0; (d || !u) && e < h;)(d = this.containsBlackPoint(r, n, e, !1)) ? (e++, i = !0, u = !0) : u || e++;
            if (e >= h) {
                o = !0;
                break;
            }
            for(var p = !0; (p || !s) && n < l;)(p = this.containsBlackPoint(t, e, n, !0)) ? (n++, i = !0, s = !0) : s || n++;
            if (n >= l) {
                o = !0;
                break;
            }
            for(var g = !0; (g || !c) && t >= 0;)(g = this.containsBlackPoint(r, n, t, !1)) ? (t--, i = !0, c = !0) : c || t--;
            if (t < 0) {
                o = !0;
                break;
            }
            for(var y = !0; (y || !f) && r >= 0;)(y = this.containsBlackPoint(t, e, r, !0)) ? (r--, i = !0, f = !0) : f || r--;
            if (r < 0) {
                o = !0;
                break;
            }
            i && (a = !0);
        }
        if (!o && a) {
            for(var w = e - t, _ = null, v = 1; null === _ && v < w; v++)_ = this.getBlackPointOnSegment(t, n - v, t + v, n);
            if (null == _) throw new $2be8636d379871d6$var$U();
            var m = null;
            for(v = 1; null === m && v < w; v++)m = this.getBlackPointOnSegment(t, r + v, t + v, r);
            if (null == m) throw new $2be8636d379871d6$var$U();
            var A = null;
            for(v = 1; null === A && v < w; v++)A = this.getBlackPointOnSegment(e, r + v, e - v, r);
            if (null == A) throw new $2be8636d379871d6$var$U();
            var E = null;
            for(v = 1; null === E && v < w; v++)E = this.getBlackPointOnSegment(e, n - v, e - v, n);
            if (null == E) throw new $2be8636d379871d6$var$U();
            return this.centerEdges(E, _, A, m);
        }
        throw new $2be8636d379871d6$var$U();
    }, t.prototype.getBlackPointOnSegment = function(t, e, r, n) {
        for(var o = $2be8636d379871d6$var$vt.round($2be8636d379871d6$var$vt.distance(t, e, r, n)), i = (r - t) / o, a = (n - e) / o, u = this.image, s = 0; s < o; s++){
            var c = $2be8636d379871d6$var$vt.round(t + s * i), f = $2be8636d379871d6$var$vt.round(e + s * a);
            if (u.get(c, f)) return new $2be8636d379871d6$var$At(c, f);
        }
        return null;
    }, t.prototype.centerEdges = function(e, r, n, o) {
        var i = e.getX(), a = e.getY(), u = r.getX(), s = r.getY(), c = n.getX(), f = n.getY(), h = o.getX(), l = o.getY(), d = t.CORR;
        return i < this.width / 2 ? [
            new $2be8636d379871d6$var$At(h - d, l + d),
            new $2be8636d379871d6$var$At(u + d, s + d),
            new $2be8636d379871d6$var$At(c - d, f - d),
            new $2be8636d379871d6$var$At(i + d, a - d)
        ] : [
            new $2be8636d379871d6$var$At(h + d, l + d),
            new $2be8636d379871d6$var$At(u + d, s - d),
            new $2be8636d379871d6$var$At(c - d, f + d),
            new $2be8636d379871d6$var$At(i - d, a - d)
        ];
    }, t.prototype.containsBlackPoint = function(t, e, r, n) {
        var o = this.image;
        if (n) {
            for(var i = t; i <= e; i++)if (o.get(i, r)) return !0;
        } else for(var a = t; a <= e; a++)if (o.get(r, a)) return !0;
        return !1;
    }, t.INIT_SIZE = 10, t.CORR = 1, t;
}(), $2be8636d379871d6$var$Ot = function() {
    function t() {}
    return t.checkAndNudgePoints = function(t, e) {
        for(var r = t.getWidth(), n = t.getHeight(), o = !0, i = 0; i < e.length && o; i += 2){
            var a = Math.floor(e[i]), u = Math.floor(e[i + 1]);
            if (a < -1 || a > r || u < -1 || u > n) throw new $2be8636d379871d6$var$U();
            o = !1, -1 === a ? (e[i] = 0, o = !0) : a === r && (e[i] = r - 1, o = !0), -1 === u ? (e[i + 1] = 0, o = !0) : u === n && (e[i + 1] = n - 1, o = !0);
        }
        o = !0;
        for(i = e.length - 2; i >= 0 && o; i -= 2){
            a = Math.floor(e[i]), u = Math.floor(e[i + 1]);
            if (a < -1 || a > r || u < -1 || u > n) throw new $2be8636d379871d6$var$U();
            o = !1, -1 === a ? (e[i] = 0, o = !0) : a === r && (e[i] = r - 1, o = !0), -1 === u ? (e[i + 1] = 0, o = !0) : u === n && (e[i + 1] = n - 1, o = !0);
        }
    }, t;
}(), $2be8636d379871d6$var$Tt = function() {
    function t(t, e, r, n, o, i, a, u, s) {
        this.a11 = t, this.a21 = e, this.a31 = r, this.a12 = n, this.a22 = o, this.a32 = i, this.a13 = a, this.a23 = u, this.a33 = s;
    }
    return t.quadrilateralToQuadrilateral = function(e, r, n, o, i, a, u, s, c, f, h, l, d, p, g, y) {
        var w = t.quadrilateralToSquare(e, r, n, o, i, a, u, s);
        return t.squareToQuadrilateral(c, f, h, l, d, p, g, y).times(w);
    }, t.prototype.transformPoints = function(t) {
        for(var e = t.length, r = this.a11, n = this.a12, o = this.a13, i = this.a21, a = this.a22, u = this.a23, s = this.a31, c = this.a32, f = this.a33, h = 0; h < e; h += 2){
            var l = t[h], d = t[h + 1], p = o * l + u * d + f;
            t[h] = (r * l + i * d + s) / p, t[h + 1] = (n * l + a * d + c) / p;
        }
    }, t.prototype.transformPointsWithValues = function(t, e) {
        for(var r = this.a11, n = this.a12, o = this.a13, i = this.a21, a = this.a22, u = this.a23, s = this.a31, c = this.a32, f = this.a33, h = t.length, l = 0; l < h; l++){
            var d = t[l], p = e[l], g = o * d + u * p + f;
            t[l] = (r * d + i * p + s) / g, e[l] = (n * d + a * p + c) / g;
        }
    }, t.squareToQuadrilateral = function(e, r, n, o, i, a, u, s) {
        var c = e - n + i - u, f = r - o + a - s;
        if (0 === c && 0 === f) return new t(n - e, i - n, e, o - r, a - o, r, 0, 0, 1);
        var h = n - i, l = u - i, d = o - a, p = s - a, g = h * p - l * d, y = (c * p - l * f) / g, w = (h * f - c * d) / g;
        return new t(n - e + y * n, u - e + w * u, e, o - r + y * o, s - r + w * s, r, y, w, 1);
    }, t.quadrilateralToSquare = function(e, r, n, o, i, a, u, s) {
        return t.squareToQuadrilateral(e, r, n, o, i, a, u, s).buildAdjoint();
    }, t.prototype.buildAdjoint = function() {
        return new t(this.a22 * this.a33 - this.a23 * this.a32, this.a23 * this.a31 - this.a21 * this.a33, this.a21 * this.a32 - this.a22 * this.a31, this.a13 * this.a32 - this.a12 * this.a33, this.a11 * this.a33 - this.a13 * this.a31, this.a12 * this.a31 - this.a11 * this.a32, this.a12 * this.a23 - this.a13 * this.a22, this.a13 * this.a21 - this.a11 * this.a23, this.a11 * this.a22 - this.a12 * this.a21);
    }, t.prototype.times = function(e) {
        return new t(this.a11 * e.a11 + this.a21 * e.a12 + this.a31 * e.a13, this.a11 * e.a21 + this.a21 * e.a22 + this.a31 * e.a23, this.a11 * e.a31 + this.a21 * e.a32 + this.a31 * e.a33, this.a12 * e.a11 + this.a22 * e.a12 + this.a32 * e.a13, this.a12 * e.a21 + this.a22 * e.a22 + this.a32 * e.a23, this.a12 * e.a31 + this.a22 * e.a32 + this.a32 * e.a33, this.a13 * e.a11 + this.a23 * e.a12 + this.a33 * e.a13, this.a13 * e.a21 + this.a23 * e.a22 + this.a33 * e.a23, this.a13 * e.a31 + this.a23 * e.a32 + this.a33 * e.a33);
    }, t;
}(), $2be8636d379871d6$var$bt = function() {
    var t = function(e, r) {
        return t = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(t, e) {
            t.__proto__ = e;
        } || function(t, e) {
            for(var r in e)e.hasOwnProperty(r) && (t[r] = e[r]);
        }, t(e, r);
    };
    return function(e, r) {
        function n() {
            this.constructor = e;
        }
        t(e, r), e.prototype = null === r ? Object.create(r) : (n.prototype = r.prototype, new n());
    };
}(), $2be8636d379871d6$var$Rt = function(t) {
    function e() {
        return null !== t && t.apply(this, arguments) || this;
    }
    return $2be8636d379871d6$var$bt(e, t), e.prototype.sampleGrid = function(t, e, r, n, o, i, a, u, s, c, f, h, l, d, p, g, y, w, _) {
        var v = $2be8636d379871d6$var$Tt.quadrilateralToQuadrilateral(n, o, i, a, u, s, c, f, h, l, d, p, g, y, w, _);
        return this.sampleGridWithTransform(t, e, r, v);
    }, e.prototype.sampleGridWithTransform = function(t, e, r, n) {
        if (e <= 0 || r <= 0) throw new $2be8636d379871d6$var$U();
        for(var o = new $2be8636d379871d6$var$x(e, r), i = new Float32Array(2 * e), a = 0; a < r; a++){
            for(var u = i.length, s = a + 0.5, c = 0; c < u; c += 2)i[c] = c / 2 + 0.5, i[c + 1] = s;
            n.transformPoints(i), $2be8636d379871d6$var$Ot.checkAndNudgePoints(t, i);
            try {
                for(c = 0; c < u; c += 2)t.get(Math.floor(i[c]), Math.floor(i[c + 1])) && o.set(c / 2, a);
            } catch (t) {
                throw new $2be8636d379871d6$var$U();
            }
        }
        return o;
    }, e;
}($2be8636d379871d6$var$Ot), $2be8636d379871d6$var$Nt = function() {
    function t() {}
    return t.setGridSampler = function(e) {
        t.gridSampler = e;
    }, t.getInstance = function() {
        return t.gridSampler;
    }, t.gridSampler = new $2be8636d379871d6$var$Rt(), t;
}(), $2be8636d379871d6$var$Dt = function() {
    function t(t, e) {
        this.x = t, this.y = e;
    }
    return t.prototype.toResultPoint = function() {
        return new $2be8636d379871d6$var$At(this.getX(), this.getY());
    }, t.prototype.getX = function() {
        return this.x;
    }, t.prototype.getY = function() {
        return this.y;
    }, t;
}(), $2be8636d379871d6$var$Pt = function() {
    function t(t) {
        this.EXPECTED_CORNER_BITS = new Int32Array([
            3808,
            476,
            2107,
            1799
        ]), this.image = t;
    }
    return t.prototype.detect = function() {
        return this.detectMirror(!1);
    }, t.prototype.detectMirror = function(t) {
        var e = this.getMatrixCenter(), r = this.getBullsEyeCorners(e);
        if (t) {
            var n = r[0];
            r[0] = r[2], r[2] = n;
        }
        this.extractParameters(r);
        var o = this.sampleGrid(this.image, r[this.shift % 4], r[(this.shift + 1) % 4], r[(this.shift + 2) % 4], r[(this.shift + 3) % 4]), i = this.getMatrixCornerPoints(r);
        return new $2be8636d379871d6$var$It(o, i, this.compact, this.nbDataBlocks, this.nbLayers);
    }, t.prototype.extractParameters = function(t) {
        if (!(this.isValidPoint(t[0]) && this.isValidPoint(t[1]) && this.isValidPoint(t[2]) && this.isValidPoint(t[3]))) throw new $2be8636d379871d6$var$U();
        var e = 2 * this.nbCenterLayers, r = new Int32Array([
            this.sampleLine(t[0], t[1], e),
            this.sampleLine(t[1], t[2], e),
            this.sampleLine(t[2], t[3], e),
            this.sampleLine(t[3], t[0], e)
        ]);
        this.shift = this.getRotation(r, e);
        for(var n = 0, o = 0; o < 4; o++){
            var i = r[(this.shift + o) % 4];
            this.compact ? (n <<= 7, n += i >> 1 & 127) : (n <<= 10, n += (i >> 2 & 992) + (i >> 1 & 31));
        }
        var a = this.getCorrectedParameterData(n, this.compact);
        this.compact ? (this.nbLayers = 1 + (a >> 6), this.nbDataBlocks = 1 + (63 & a)) : (this.nbLayers = 1 + (a >> 11), this.nbDataBlocks = 1 + (2047 & a));
    }, t.prototype.getRotation = function(t, e) {
        var r = 0;
        t.forEach(function(t, n, o) {
            r = (r << 3) + ((t >> e - 2 << 1) + (1 & t));
        }), r = ((1 & r) << 11) + (r >> 1);
        for(var n = 0; n < 4; n++)if ($2be8636d379871d6$var$I.bitCount(r ^ this.EXPECTED_CORNER_BITS[n]) <= 2) return n;
        throw new $2be8636d379871d6$var$U();
    }, t.prototype.getCorrectedParameterData = function(t, e) {
        var r, n;
        e ? (r = 7, n = 2) : (r = 10, n = 4);
        for(var o = r - n, i = new Int32Array(r), a = r - 1; a >= 0; --a)i[a] = 15 & t, t >>= 4;
        try {
            new $2be8636d379871d6$var$wt($2be8636d379871d6$var$lt.AZTEC_PARAM).decode(i, o);
        } catch (t) {
            throw new $2be8636d379871d6$var$U();
        }
        var u = 0;
        for(a = 0; a < n; a++)u = (u << 4) + i[a];
        return u;
    }, t.prototype.getBullsEyeCorners = function(t) {
        var e = t, r = t, n = t, o = t, i = !0;
        for(this.nbCenterLayers = 1; this.nbCenterLayers < 9; this.nbCenterLayers++){
            var a = this.getFirstDifferent(e, i, 1, -1), u = this.getFirstDifferent(r, i, 1, 1), s = this.getFirstDifferent(n, i, -1, 1), c = this.getFirstDifferent(o, i, -1, -1);
            if (this.nbCenterLayers > 2) {
                var f = this.distancePoint(c, a) * this.nbCenterLayers / (this.distancePoint(o, e) * (this.nbCenterLayers + 2));
                if (f < 0.75 || f > 1.25 || !this.isWhiteOrBlackRectangle(a, u, s, c)) break;
            }
            e = a, r = u, n = s, o = c, i = !i;
        }
        if (5 !== this.nbCenterLayers && 7 !== this.nbCenterLayers) throw new $2be8636d379871d6$var$U();
        this.compact = 5 === this.nbCenterLayers;
        var h = new $2be8636d379871d6$var$At(e.getX() + 0.5, e.getY() - 0.5), l = new $2be8636d379871d6$var$At(r.getX() + 0.5, r.getY() + 0.5), d = new $2be8636d379871d6$var$At(n.getX() - 0.5, n.getY() + 0.5), p = new $2be8636d379871d6$var$At(o.getX() - 0.5, o.getY() - 0.5);
        return this.expandSquare([
            h,
            l,
            d,
            p
        ], 2 * this.nbCenterLayers - 3, 2 * this.nbCenterLayers);
    }, t.prototype.getMatrixCenter = function() {
        var t, e, r, n;
        try {
            t = (s = new $2be8636d379871d6$var$St(this.image).detect())[0], e = s[1], r = s[2], n = s[3];
        } catch (a) {
            var o = this.image.getWidth() / 2, i = this.image.getHeight() / 2;
            t = this.getFirstDifferent(new $2be8636d379871d6$var$Dt(o + 7, i - 7), !1, 1, -1).toResultPoint(), e = this.getFirstDifferent(new $2be8636d379871d6$var$Dt(o + 7, i + 7), !1, 1, 1).toResultPoint(), r = this.getFirstDifferent(new $2be8636d379871d6$var$Dt(o - 7, i + 7), !1, -1, 1).toResultPoint(), n = this.getFirstDifferent(new $2be8636d379871d6$var$Dt(o - 7, i - 7), !1, -1, -1).toResultPoint();
        }
        var a = $2be8636d379871d6$var$vt.round((t.getX() + n.getX() + e.getX() + r.getX()) / 4), u = $2be8636d379871d6$var$vt.round((t.getY() + n.getY() + e.getY() + r.getY()) / 4);
        try {
            var s;
            t = (s = new $2be8636d379871d6$var$St(this.image, 15, a, u).detect())[0], e = s[1], r = s[2], n = s[3];
        } catch (o) {
            t = this.getFirstDifferent(new $2be8636d379871d6$var$Dt(a + 7, u - 7), !1, 1, -1).toResultPoint(), e = this.getFirstDifferent(new $2be8636d379871d6$var$Dt(a + 7, u + 7), !1, 1, 1).toResultPoint(), r = this.getFirstDifferent(new $2be8636d379871d6$var$Dt(a - 7, u + 7), !1, -1, 1).toResultPoint(), n = this.getFirstDifferent(new $2be8636d379871d6$var$Dt(a - 7, u - 7), !1, -1, -1).toResultPoint();
        }
        return a = $2be8636d379871d6$var$vt.round((t.getX() + n.getX() + e.getX() + r.getX()) / 4), u = $2be8636d379871d6$var$vt.round((t.getY() + n.getY() + e.getY() + r.getY()) / 4), new $2be8636d379871d6$var$Dt(a, u);
    }, t.prototype.getMatrixCornerPoints = function(t) {
        return this.expandSquare(t, 2 * this.nbCenterLayers, this.getDimension());
    }, t.prototype.sampleGrid = function(t, e, r, n, o) {
        var i = $2be8636d379871d6$var$Nt.getInstance(), a = this.getDimension(), u = a / 2 - this.nbCenterLayers, s = a / 2 + this.nbCenterLayers;
        return i.sampleGrid(t, a, a, u, u, s, u, s, s, u, s, e.getX(), e.getY(), r.getX(), r.getY(), n.getX(), n.getY(), o.getX(), o.getY());
    }, t.prototype.sampleLine = function(t, e, r) {
        for(var n = 0, o = this.distanceResultPoint(t, e), i = o / r, a = t.getX(), u = t.getY(), s = i * (e.getX() - t.getX()) / o, c = i * (e.getY() - t.getY()) / o, f = 0; f < r; f++)this.image.get($2be8636d379871d6$var$vt.round(a + f * s), $2be8636d379871d6$var$vt.round(u + f * c)) && (n |= 1 << r - f - 1);
        return n;
    }, t.prototype.isWhiteOrBlackRectangle = function(t, e, r, n) {
        t = new $2be8636d379871d6$var$Dt(t.getX() - 3, t.getY() + 3), e = new $2be8636d379871d6$var$Dt(e.getX() - 3, e.getY() - 3), r = new $2be8636d379871d6$var$Dt(r.getX() + 3, r.getY() - 3), n = new $2be8636d379871d6$var$Dt(n.getX() + 3, n.getY() + 3);
        var o = this.getColor(n, t);
        if (0 === o) return !1;
        var i = this.getColor(t, e);
        return i === o && (i = this.getColor(e, r)) === o && (i = this.getColor(r, n)) === o;
    }, t.prototype.getColor = function(t, e) {
        for(var r = this.distancePoint(t, e), n = (e.getX() - t.getX()) / r, o = (e.getY() - t.getY()) / r, i = 0, a = t.getX(), u = t.getY(), s = this.image.get(t.getX(), t.getY()), c = Math.ceil(r), f = 0; f < c; f++)a += n, u += o, this.image.get($2be8636d379871d6$var$vt.round(a), $2be8636d379871d6$var$vt.round(u)) !== s && i++;
        var h = i / r;
        return h > 0.1 && h < 0.9 ? 0 : h <= 0.1 === s ? 1 : -1;
    }, t.prototype.getFirstDifferent = function(t, e, r, n) {
        for(var o = t.getX() + r, i = t.getY() + n; this.isValid(o, i) && this.image.get(o, i) === e;)o += r, i += n;
        for(o -= r, i -= n; this.isValid(o, i) && this.image.get(o, i) === e;)o += r;
        for(o -= r; this.isValid(o, i) && this.image.get(o, i) === e;)i += n;
        return new $2be8636d379871d6$var$Dt(o, i -= n);
    }, t.prototype.expandSquare = function(t, e, r) {
        var n = r / (2 * e), o = t[0].getX() - t[2].getX(), i = t[0].getY() - t[2].getY(), a = (t[0].getX() + t[2].getX()) / 2, u = (t[0].getY() + t[2].getY()) / 2, s = new $2be8636d379871d6$var$At(a + n * o, u + n * i), c = new $2be8636d379871d6$var$At(a - n * o, u - n * i);
        return o = t[1].getX() - t[3].getX(), i = t[1].getY() - t[3].getY(), a = (t[1].getX() + t[3].getX()) / 2, u = (t[1].getY() + t[3].getY()) / 2, [
            s,
            new $2be8636d379871d6$var$At(a + n * o, u + n * i),
            c,
            new $2be8636d379871d6$var$At(a - n * o, u - n * i)
        ];
    }, t.prototype.isValid = function(t, e) {
        return t >= 0 && t < this.image.getWidth() && e > 0 && e < this.image.getHeight();
    }, t.prototype.isValidPoint = function(t) {
        var e = $2be8636d379871d6$var$vt.round(t.getX()), r = $2be8636d379871d6$var$vt.round(t.getY());
        return this.isValid(e, r);
    }, t.prototype.distancePoint = function(t, e) {
        return $2be8636d379871d6$var$vt.distance(t.getX(), t.getY(), e.getX(), e.getY());
    }, t.prototype.distanceResultPoint = function(t, e) {
        return $2be8636d379871d6$var$vt.distance(t.getX(), t.getY(), e.getX(), e.getY());
    }, t.prototype.getDimension = function() {
        return this.compact ? 4 * this.nbLayers + 11 : this.nbLayers <= 4 ? 4 * this.nbLayers + 15 : 4 * this.nbLayers + 2 * ($2be8636d379871d6$var$I.truncDivision(this.nbLayers - 4, 8) + 1) + 15;
    }, t;
}(), $2be8636d379871d6$var$Mt = function() {
    function t() {}
    return t.prototype.decode = function(t, e) {
        void 0 === e && (e = null);
        var r = null, n = new $2be8636d379871d6$var$Pt(t.getBlackMatrix()), o = null, i = null;
        try {
            o = (a = n.detectMirror(!1)).getPoints(), this.reportFoundResultPoints(e, o), i = new $2be8636d379871d6$var$_t().decode(a);
        } catch (t) {
            r = t;
        }
        if (null == i) try {
            var a;
            o = (a = n.detectMirror(!0)).getPoints(), this.reportFoundResultPoints(e, o), i = new $2be8636d379871d6$var$_t().decode(a);
        } catch (t) {
            if (null != r) throw r;
            throw t;
        }
        var u = new $2be8636d379871d6$var$et(i.getText(), i.getRawBytes(), i.getNumBits(), o, $2be8636d379871d6$var$nt.AZTEC, $2be8636d379871d6$var$w.currentTimeMillis()), s = i.getByteSegments();
        null != s && u.putMetadata($2be8636d379871d6$var$it.BYTE_SEGMENTS, s);
        var c = i.getECLevel();
        return null != c && u.putMetadata($2be8636d379871d6$var$it.ERROR_CORRECTION_LEVEL, c), u;
    }, t.prototype.reportFoundResultPoints = function(t, e) {
        if (null != t) {
            var r = t.get($2be8636d379871d6$var$T.NEED_RESULT_POINT_CALLBACK);
            null != r && e.forEach(function(t, e, n) {
                r.foundPossibleResultPoint(t);
            });
        }
    }, t.prototype.reset = function() {}, t;
}(), $2be8636d379871d6$var$Bt = function() {
    var t = function(e, r) {
        return t = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(t, e) {
            t.__proto__ = e;
        } || function(t, e) {
            for(var r in e)e.hasOwnProperty(r) && (t[r] = e[r]);
        }, t(e, r);
    };
    return function(e, r) {
        function n() {
            this.constructor = e;
        }
        t(e, r), e.prototype = null === r ? Object.create(r) : (n.prototype = r.prototype, new n());
    };
}();
!function(t) {
    function e(e) {
        return void 0 === e && (e = 500), t.call(this, new $2be8636d379871d6$var$Mt(), e) || this;
    }
    $2be8636d379871d6$var$Bt(e, t);
}($2be8636d379871d6$var$tt);
var $2be8636d379871d6$var$Lt = function() {
    function t() {}
    return t.prototype.decode = function(t, e) {
        try {
            return this.doDecode(t, e);
        } catch (c) {
            if (e && !0 === e.get($2be8636d379871d6$var$T.TRY_HARDER) && t.isRotateSupported()) {
                var r = t.rotateCounterClockwise(), n = this.doDecode(r, e), o = n.getResultMetadata(), i = 270;
                null !== o && !0 === o.get($2be8636d379871d6$var$it.ORIENTATION) && (i += o.get($2be8636d379871d6$var$it.ORIENTATION) % 360), n.putMetadata($2be8636d379871d6$var$it.ORIENTATION, i);
                var a = n.getResultPoints();
                if (null !== a) for(var u = r.getHeight(), s = 0; s < a.length; s++)a[s] = new $2be8636d379871d6$var$At(u - a[s].getY() - 1, a[s].getX());
                return n;
            }
            throw new $2be8636d379871d6$var$U();
        }
    }, t.prototype.reset = function() {}, t.prototype.doDecode = function(t, e) {
        var r, n = t.getWidth(), o = t.getHeight(), i = new $2be8636d379871d6$var$S(n), a = e && !0 === e.get($2be8636d379871d6$var$T.TRY_HARDER), u = Math.max(1, o >> (a ? 8 : 5));
        r = a ? o : 15;
        for(var s = Math.trunc(o / 2), c = 0; c < r; c++){
            var f = Math.trunc((c + 1) / 2), h = s + u * (0 == (1 & c) ? f : -f);
            if (h < 0 || h >= o) break;
            try {
                i = t.getBlackRow(h, i);
            } catch (t) {
                continue;
            }
            for(var l = function(t) {
                if (1 === t && (i.reverse(), e && !0 === e.get($2be8636d379871d6$var$T.NEED_RESULT_POINT_CALLBACK))) {
                    var r = new Map();
                    e.forEach(function(t, e) {
                        return r.set(e, t);
                    }), r.delete($2be8636d379871d6$var$T.NEED_RESULT_POINT_CALLBACK), e = r;
                }
                try {
                    var o = d.decodeRow(h, i, e);
                    if (1 === t) {
                        o.putMetadata($2be8636d379871d6$var$it.ORIENTATION, 180);
                        var a = o.getResultPoints();
                        null !== a && (a[0] = new $2be8636d379871d6$var$At(n - a[0].getX() - 1, a[0].getY()), a[1] = new $2be8636d379871d6$var$At(n - a[1].getX() - 1, a[1].getY()));
                    }
                    return {
                        value: o
                    };
                } catch (t) {}
            }, d = this, p = 0; p < 2; p++){
                var g = l(p);
                if ("object" == typeof g) return g.value;
            }
        }
        throw new $2be8636d379871d6$var$U();
    }, t.recordPattern = function(t, e, r) {
        for(var n = r.length, o = 0; o < n; o++)r[o] = 0;
        var i = t.getSize();
        if (e >= i) throw new $2be8636d379871d6$var$U();
        for(var a = !t.get(e), u = 0, s = e; s < i;){
            if (t.get(s) !== a) r[u]++;
            else {
                if (++u === n) break;
                r[u] = 1, a = !a;
            }
            s++;
        }
        if (u !== n && (u !== n - 1 || s !== i)) throw new $2be8636d379871d6$var$U();
    }, t.recordPatternInReverse = function(e, r, n) {
        for(var o = n.length, i = e.get(r); r > 0 && o >= 0;)e.get(--r) !== i && (o--, i = !i);
        if (o >= 0) throw new $2be8636d379871d6$var$U();
        t.recordPattern(e, r + 1, n);
    }, t.patternMatchVariance = function(t, e, r) {
        for(var n = t.length, o = 0, i = 0, a = 0; a < n; a++)o += t[a], i += e[a];
        if (o < i) return Number.POSITIVE_INFINITY;
        var u = o / i;
        r *= u;
        for(var s = 0, c = 0; c < n; c++){
            var f = t[c], h = e[c] * u, l = f > h ? f - h : h - f;
            if (l > r) return Number.POSITIVE_INFINITY;
            s += l;
        }
        return s / o;
    }, t;
}(), $2be8636d379871d6$var$Ft = function() {
    var t = function(e, r) {
        return t = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(t, e) {
            t.__proto__ = e;
        } || function(t, e) {
            for(var r in e)e.hasOwnProperty(r) && (t[r] = e[r]);
        }, t(e, r);
    };
    return function(e, r) {
        function n() {
            this.constructor = e;
        }
        t(e, r), e.prototype = null === r ? Object.create(r) : (n.prototype = r.prototype, new n());
    };
}(), $2be8636d379871d6$var$kt = function(t) {
    function e() {
        return null !== t && t.apply(this, arguments) || this;
    }
    return $2be8636d379871d6$var$Ft(e, t), e.findStartPattern = function(t) {
        for(var r = t.getSize(), n = t.getNextSet(0), o = 0, i = Int32Array.from([
            0,
            0,
            0,
            0,
            0,
            0
        ]), a = n, u = !1, s = n; s < r; s++)if (t.get(s) !== u) i[o]++;
        else {
            if (5 === o) {
                for(var c = e.MAX_AVG_VARIANCE, f = -1, h = e.CODE_START_A; h <= e.CODE_START_C; h++){
                    var l = $2be8636d379871d6$var$Lt.patternMatchVariance(i, e.CODE_PATTERNS[h], e.MAX_INDIVIDUAL_VARIANCE);
                    l < c && (c = l, f = h);
                }
                if (f >= 0 && t.isRange(Math.max(0, a - (s - a) / 2), a, !1)) return Int32Array.from([
                    a,
                    s,
                    f
                ]);
                a += i[0] + i[1], (i = i.slice(2, i.length - 1))[o - 1] = 0, i[o] = 0, o--;
            } else o++;
            i[o] = 1, u = !u;
        }
        throw new $2be8636d379871d6$var$U();
    }, e.decodeCode = function(t, r, n) {
        $2be8636d379871d6$var$Lt.recordPattern(t, n, r);
        for(var o = e.MAX_AVG_VARIANCE, i = -1, a = 0; a < e.CODE_PATTERNS.length; a++){
            var u = e.CODE_PATTERNS[a], s = this.patternMatchVariance(r, u, e.MAX_INDIVIDUAL_VARIANCE);
            s < o && (o = s, i = a);
        }
        if (i >= 0) return i;
        throw new $2be8636d379871d6$var$U();
    }, e.prototype.decodeRow = function(t, r, n) {
        var o, i = n && !0 === n.get($2be8636d379871d6$var$T.ASSUME_GS1), a = e.findStartPattern(r), u = a[2], s = 0, c = new Uint8Array(20);
        switch(c[s++] = u, u){
            case e.CODE_START_A:
                o = e.CODE_CODE_A;
                break;
            case e.CODE_START_B:
                o = e.CODE_CODE_B;
                break;
            case e.CODE_START_C:
                o = e.CODE_CODE_C;
                break;
            default:
                throw new $2be8636d379871d6$var$R();
        }
        for(var f = !1, h = !1, l = "", d = a[0], p = a[1], y = Int32Array.from([
            0,
            0,
            0,
            0,
            0,
            0
        ]), w = 0, _ = 0, v = u, m = 0, A = !0, E = !1, C = !1; !f;){
            var I = h;
            switch(h = !1, w = _, _ = e.decodeCode(r, y, p), c[s++] = _, _ !== e.CODE_STOP && (A = !0), _ !== e.CODE_STOP && (v += ++m * _), d = p, p += y.reduce(function(t, e) {
                return t + e;
            }, 0), _){
                case e.CODE_START_A:
                case e.CODE_START_B:
                case e.CODE_START_C:
                    throw new $2be8636d379871d6$var$R();
            }
            switch(o){
                case e.CODE_CODE_A:
                    if (_ < 64) l += C === E ? String.fromCharCode(" ".charCodeAt(0) + _) : String.fromCharCode(" ".charCodeAt(0) + _ + 128), C = !1;
                    else if (_ < 96) l += C === E ? String.fromCharCode(_ - 64) : String.fromCharCode(_ + 64), C = !1;
                    else switch(_ !== e.CODE_STOP && (A = !1), _){
                        case e.CODE_FNC_1:
                            i && (0 === l.length ? l += "]C1" : l += String.fromCharCode(29));
                            break;
                        case e.CODE_FNC_2:
                        case e.CODE_FNC_3:
                            break;
                        case e.CODE_FNC_4_A:
                            !E && C ? (E = !0, C = !1) : E && C ? (E = !1, C = !1) : C = !0;
                            break;
                        case e.CODE_SHIFT:
                            h = !0, o = e.CODE_CODE_B;
                            break;
                        case e.CODE_CODE_B:
                            o = e.CODE_CODE_B;
                            break;
                        case e.CODE_CODE_C:
                            o = e.CODE_CODE_C;
                            break;
                        case e.CODE_STOP:
                            f = !0;
                    }
                    break;
                case e.CODE_CODE_B:
                    if (_ < 96) l += C === E ? String.fromCharCode(" ".charCodeAt(0) + _) : String.fromCharCode(" ".charCodeAt(0) + _ + 128), C = !1;
                    else switch(_ !== e.CODE_STOP && (A = !1), _){
                        case e.CODE_FNC_1:
                            i && (0 === l.length ? l += "]C1" : l += String.fromCharCode(29));
                            break;
                        case e.CODE_FNC_2:
                        case e.CODE_FNC_3:
                            break;
                        case e.CODE_FNC_4_B:
                            !E && C ? (E = !0, C = !1) : E && C ? (E = !1, C = !1) : C = !0;
                            break;
                        case e.CODE_SHIFT:
                            h = !0, o = e.CODE_CODE_A;
                            break;
                        case e.CODE_CODE_A:
                            o = e.CODE_CODE_A;
                            break;
                        case e.CODE_CODE_C:
                            o = e.CODE_CODE_C;
                            break;
                        case e.CODE_STOP:
                            f = !0;
                    }
                    break;
                case e.CODE_CODE_C:
                    if (_ < 100) _ < 10 && (l += "0"), l += _;
                    else switch(_ !== e.CODE_STOP && (A = !1), _){
                        case e.CODE_FNC_1:
                            i && (0 === l.length ? l += "]C1" : l += String.fromCharCode(29));
                            break;
                        case e.CODE_CODE_A:
                            o = e.CODE_CODE_A;
                            break;
                        case e.CODE_CODE_B:
                            o = e.CODE_CODE_B;
                            break;
                        case e.CODE_STOP:
                            f = !0;
                    }
            }
            I && (o = o === e.CODE_CODE_A ? e.CODE_CODE_B : e.CODE_CODE_A);
        }
        var S = p - d;
        if (p = r.getNextUnset(p), !r.isRange(p, Math.min(r.getSize(), p + (p - d) / 2), !1)) throw new $2be8636d379871d6$var$U();
        if ((v -= m * w) % 103 !== w) throw new $2be8636d379871d6$var$g();
        var O = l.length;
        if (0 === O) throw new $2be8636d379871d6$var$U();
        O > 0 && A && (l = o === e.CODE_CODE_C ? l.substring(0, O - 2) : l.substring(0, O - 1));
        for(var b = (a[1] + a[0]) / 2, N = d + S / 2, D = c.length, P = new Uint8Array(D), M = 0; M < D; M++)P[M] = c[M];
        var B = [
            new $2be8636d379871d6$var$At(b, t),
            new $2be8636d379871d6$var$At(N, t)
        ];
        return new $2be8636d379871d6$var$et(l, P, 0, B, $2be8636d379871d6$var$nt.CODE_128, new Date().getTime());
    }, e.CODE_PATTERNS = [
        Int32Array.from([
            2,
            1,
            2,
            2,
            2,
            2
        ]),
        Int32Array.from([
            2,
            2,
            2,
            1,
            2,
            2
        ]),
        Int32Array.from([
            2,
            2,
            2,
            2,
            2,
            1
        ]),
        Int32Array.from([
            1,
            2,
            1,
            2,
            2,
            3
        ]),
        Int32Array.from([
            1,
            2,
            1,
            3,
            2,
            2
        ]),
        Int32Array.from([
            1,
            3,
            1,
            2,
            2,
            2
        ]),
        Int32Array.from([
            1,
            2,
            2,
            2,
            1,
            3
        ]),
        Int32Array.from([
            1,
            2,
            2,
            3,
            1,
            2
        ]),
        Int32Array.from([
            1,
            3,
            2,
            2,
            1,
            2
        ]),
        Int32Array.from([
            2,
            2,
            1,
            2,
            1,
            3
        ]),
        Int32Array.from([
            2,
            2,
            1,
            3,
            1,
            2
        ]),
        Int32Array.from([
            2,
            3,
            1,
            2,
            1,
            2
        ]),
        Int32Array.from([
            1,
            1,
            2,
            2,
            3,
            2
        ]),
        Int32Array.from([
            1,
            2,
            2,
            1,
            3,
            2
        ]),
        Int32Array.from([
            1,
            2,
            2,
            2,
            3,
            1
        ]),
        Int32Array.from([
            1,
            1,
            3,
            2,
            2,
            2
        ]),
        Int32Array.from([
            1,
            2,
            3,
            1,
            2,
            2
        ]),
        Int32Array.from([
            1,
            2,
            3,
            2,
            2,
            1
        ]),
        Int32Array.from([
            2,
            2,
            3,
            2,
            1,
            1
        ]),
        Int32Array.from([
            2,
            2,
            1,
            1,
            3,
            2
        ]),
        Int32Array.from([
            2,
            2,
            1,
            2,
            3,
            1
        ]),
        Int32Array.from([
            2,
            1,
            3,
            2,
            1,
            2
        ]),
        Int32Array.from([
            2,
            2,
            3,
            1,
            1,
            2
        ]),
        Int32Array.from([
            3,
            1,
            2,
            1,
            3,
            1
        ]),
        Int32Array.from([
            3,
            1,
            1,
            2,
            2,
            2
        ]),
        Int32Array.from([
            3,
            2,
            1,
            1,
            2,
            2
        ]),
        Int32Array.from([
            3,
            2,
            1,
            2,
            2,
            1
        ]),
        Int32Array.from([
            3,
            1,
            2,
            2,
            1,
            2
        ]),
        Int32Array.from([
            3,
            2,
            2,
            1,
            1,
            2
        ]),
        Int32Array.from([
            3,
            2,
            2,
            2,
            1,
            1
        ]),
        Int32Array.from([
            2,
            1,
            2,
            1,
            2,
            3
        ]),
        Int32Array.from([
            2,
            1,
            2,
            3,
            2,
            1
        ]),
        Int32Array.from([
            2,
            3,
            2,
            1,
            2,
            1
        ]),
        Int32Array.from([
            1,
            1,
            1,
            3,
            2,
            3
        ]),
        Int32Array.from([
            1,
            3,
            1,
            1,
            2,
            3
        ]),
        Int32Array.from([
            1,
            3,
            1,
            3,
            2,
            1
        ]),
        Int32Array.from([
            1,
            1,
            2,
            3,
            1,
            3
        ]),
        Int32Array.from([
            1,
            3,
            2,
            1,
            1,
            3
        ]),
        Int32Array.from([
            1,
            3,
            2,
            3,
            1,
            1
        ]),
        Int32Array.from([
            2,
            1,
            1,
            3,
            1,
            3
        ]),
        Int32Array.from([
            2,
            3,
            1,
            1,
            1,
            3
        ]),
        Int32Array.from([
            2,
            3,
            1,
            3,
            1,
            1
        ]),
        Int32Array.from([
            1,
            1,
            2,
            1,
            3,
            3
        ]),
        Int32Array.from([
            1,
            1,
            2,
            3,
            3,
            1
        ]),
        Int32Array.from([
            1,
            3,
            2,
            1,
            3,
            1
        ]),
        Int32Array.from([
            1,
            1,
            3,
            1,
            2,
            3
        ]),
        Int32Array.from([
            1,
            1,
            3,
            3,
            2,
            1
        ]),
        Int32Array.from([
            1,
            3,
            3,
            1,
            2,
            1
        ]),
        Int32Array.from([
            3,
            1,
            3,
            1,
            2,
            1
        ]),
        Int32Array.from([
            2,
            1,
            1,
            3,
            3,
            1
        ]),
        Int32Array.from([
            2,
            3,
            1,
            1,
            3,
            1
        ]),
        Int32Array.from([
            2,
            1,
            3,
            1,
            1,
            3
        ]),
        Int32Array.from([
            2,
            1,
            3,
            3,
            1,
            1
        ]),
        Int32Array.from([
            2,
            1,
            3,
            1,
            3,
            1
        ]),
        Int32Array.from([
            3,
            1,
            1,
            1,
            2,
            3
        ]),
        Int32Array.from([
            3,
            1,
            1,
            3,
            2,
            1
        ]),
        Int32Array.from([
            3,
            3,
            1,
            1,
            2,
            1
        ]),
        Int32Array.from([
            3,
            1,
            2,
            1,
            1,
            3
        ]),
        Int32Array.from([
            3,
            1,
            2,
            3,
            1,
            1
        ]),
        Int32Array.from([
            3,
            3,
            2,
            1,
            1,
            1
        ]),
        Int32Array.from([
            3,
            1,
            4,
            1,
            1,
            1
        ]),
        Int32Array.from([
            2,
            2,
            1,
            4,
            1,
            1
        ]),
        Int32Array.from([
            4,
            3,
            1,
            1,
            1,
            1
        ]),
        Int32Array.from([
            1,
            1,
            1,
            2,
            2,
            4
        ]),
        Int32Array.from([
            1,
            1,
            1,
            4,
            2,
            2
        ]),
        Int32Array.from([
            1,
            2,
            1,
            1,
            2,
            4
        ]),
        Int32Array.from([
            1,
            2,
            1,
            4,
            2,
            1
        ]),
        Int32Array.from([
            1,
            4,
            1,
            1,
            2,
            2
        ]),
        Int32Array.from([
            1,
            4,
            1,
            2,
            2,
            1
        ]),
        Int32Array.from([
            1,
            1,
            2,
            2,
            1,
            4
        ]),
        Int32Array.from([
            1,
            1,
            2,
            4,
            1,
            2
        ]),
        Int32Array.from([
            1,
            2,
            2,
            1,
            1,
            4
        ]),
        Int32Array.from([
            1,
            2,
            2,
            4,
            1,
            1
        ]),
        Int32Array.from([
            1,
            4,
            2,
            1,
            1,
            2
        ]),
        Int32Array.from([
            1,
            4,
            2,
            2,
            1,
            1
        ]),
        Int32Array.from([
            2,
            4,
            1,
            2,
            1,
            1
        ]),
        Int32Array.from([
            2,
            2,
            1,
            1,
            1,
            4
        ]),
        Int32Array.from([
            4,
            1,
            3,
            1,
            1,
            1
        ]),
        Int32Array.from([
            2,
            4,
            1,
            1,
            1,
            2
        ]),
        Int32Array.from([
            1,
            3,
            4,
            1,
            1,
            1
        ]),
        Int32Array.from([
            1,
            1,
            1,
            2,
            4,
            2
        ]),
        Int32Array.from([
            1,
            2,
            1,
            1,
            4,
            2
        ]),
        Int32Array.from([
            1,
            2,
            1,
            2,
            4,
            1
        ]),
        Int32Array.from([
            1,
            1,
            4,
            2,
            1,
            2
        ]),
        Int32Array.from([
            1,
            2,
            4,
            1,
            1,
            2
        ]),
        Int32Array.from([
            1,
            2,
            4,
            2,
            1,
            1
        ]),
        Int32Array.from([
            4,
            1,
            1,
            2,
            1,
            2
        ]),
        Int32Array.from([
            4,
            2,
            1,
            1,
            1,
            2
        ]),
        Int32Array.from([
            4,
            2,
            1,
            2,
            1,
            1
        ]),
        Int32Array.from([
            2,
            1,
            2,
            1,
            4,
            1
        ]),
        Int32Array.from([
            2,
            1,
            4,
            1,
            2,
            1
        ]),
        Int32Array.from([
            4,
            1,
            2,
            1,
            2,
            1
        ]),
        Int32Array.from([
            1,
            1,
            1,
            1,
            4,
            3
        ]),
        Int32Array.from([
            1,
            1,
            1,
            3,
            4,
            1
        ]),
        Int32Array.from([
            1,
            3,
            1,
            1,
            4,
            1
        ]),
        Int32Array.from([
            1,
            1,
            4,
            1,
            1,
            3
        ]),
        Int32Array.from([
            1,
            1,
            4,
            3,
            1,
            1
        ]),
        Int32Array.from([
            4,
            1,
            1,
            1,
            1,
            3
        ]),
        Int32Array.from([
            4,
            1,
            1,
            3,
            1,
            1
        ]),
        Int32Array.from([
            1,
            1,
            3,
            1,
            4,
            1
        ]),
        Int32Array.from([
            1,
            1,
            4,
            1,
            3,
            1
        ]),
        Int32Array.from([
            3,
            1,
            1,
            1,
            4,
            1
        ]),
        Int32Array.from([
            4,
            1,
            1,
            1,
            3,
            1
        ]),
        Int32Array.from([
            2,
            1,
            1,
            4,
            1,
            2
        ]),
        Int32Array.from([
            2,
            1,
            1,
            2,
            1,
            4
        ]),
        Int32Array.from([
            2,
            1,
            1,
            2,
            3,
            2
        ]),
        Int32Array.from([
            2,
            3,
            3,
            1,
            1,
            1,
            2
        ])
    ], e.MAX_AVG_VARIANCE = 0.25, e.MAX_INDIVIDUAL_VARIANCE = 0.7, e.CODE_SHIFT = 98, e.CODE_CODE_C = 99, e.CODE_CODE_B = 100, e.CODE_CODE_A = 101, e.CODE_FNC_1 = 102, e.CODE_FNC_2 = 97, e.CODE_FNC_3 = 96, e.CODE_FNC_4_A = 101, e.CODE_FNC_4_B = 100, e.CODE_START_A = 103, e.CODE_START_B = 104, e.CODE_START_C = 105, e.CODE_STOP = 106, e;
}($2be8636d379871d6$var$Lt), $2be8636d379871d6$var$xt = function() {
    var t = function(e, r) {
        return t = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(t, e) {
            t.__proto__ = e;
        } || function(t, e) {
            for(var r in e)e.hasOwnProperty(r) && (t[r] = e[r]);
        }, t(e, r);
    };
    return function(e, r) {
        function n() {
            this.constructor = e;
        }
        t(e, r), e.prototype = null === r ? Object.create(r) : (n.prototype = r.prototype, new n());
    };
}(), $2be8636d379871d6$var$Vt = function(t) {
    var e = "function" == typeof Symbol && Symbol.iterator, r = e && t[e], n = 0;
    if (r) return r.call(t);
    if (t && "number" == typeof t.length) return {
        next: function() {
            return t && n >= t.length && (t = void 0), {
                value: t && t[n++],
                done: !t
            };
        }
    };
    throw new TypeError(e ? "Object is not iterable." : "Symbol.iterator is not defined.");
}, $2be8636d379871d6$var$Ut = function(t) {
    function e(e, r) {
        void 0 === e && (e = !1), void 0 === r && (r = !1);
        var n = t.call(this) || this;
        return n.usingCheckDigit = e, n.extendedMode = r, n.decodeRowResult = "", n.counters = new Int32Array(9), n;
    }
    return $2be8636d379871d6$var$xt(e, t), e.prototype.decodeRow = function(t, r, n) {
        var o, i, a, u, s = this.counters;
        s.fill(0), this.decodeRowResult = "";
        var c, f, h = e.findAsteriskPattern(r, s), l = r.getNextSet(h[1]), d = r.getSize();
        do {
            e.recordPattern(r, l, s);
            var p = e.toNarrowWidePattern(s);
            if (p < 0) throw new $2be8636d379871d6$var$U();
            c = e.patternToChar(p), this.decodeRowResult += c, f = l;
            try {
                for(var y = (o = void 0, $2be8636d379871d6$var$Vt(s)), w = y.next(); !w.done; w = y.next())l += w.value;
            } catch (t) {
                o = {
                    error: t
                };
            } finally{
                try {
                    w && !w.done && (i = y.return) && i.call(y);
                } finally{
                    if (o) throw o.error;
                }
            }
            l = r.getNextSet(l);
        }while ("*" !== c);
        this.decodeRowResult = this.decodeRowResult.substring(0, this.decodeRowResult.length - 1);
        var _, v = 0;
        try {
            for(var m = $2be8636d379871d6$var$Vt(s), A = m.next(); !A.done; A = m.next())v += A.value;
        } catch (t) {
            a = {
                error: t
            };
        } finally{
            try {
                A && !A.done && (u = m.return) && u.call(m);
            } finally{
                if (a) throw a.error;
            }
        }
        if (l !== d && 2 * (l - f - v) < v) throw new $2be8636d379871d6$var$U();
        if (this.usingCheckDigit) {
            for(var E = this.decodeRowResult.length - 1, C = 0, I = 0; I < E; I++)C += e.ALPHABET_STRING.indexOf(this.decodeRowResult.charAt(I));
            if (this.decodeRowResult.charAt(E) !== e.ALPHABET_STRING.charAt(C % 43)) throw new $2be8636d379871d6$var$g();
            this.decodeRowResult = this.decodeRowResult.substring(0, E);
        }
        if (0 === this.decodeRowResult.length) throw new $2be8636d379871d6$var$U();
        _ = this.extendedMode ? e.decodeExtended(this.decodeRowResult) : this.decodeRowResult;
        var S = (h[1] + h[0]) / 2, O = f + v / 2;
        return new $2be8636d379871d6$var$et(_, null, 0, [
            new $2be8636d379871d6$var$At(S, t),
            new $2be8636d379871d6$var$At(O, t)
        ], $2be8636d379871d6$var$nt.CODE_39, new Date().getTime());
    }, e.findAsteriskPattern = function(t, r) {
        for(var n = t.getSize(), o = t.getNextSet(0), i = 0, a = o, u = !1, s = r.length, c = o; c < n; c++)if (t.get(c) !== u) r[i]++;
        else {
            if (i === s - 1) {
                if (this.toNarrowWidePattern(r) === e.ASTERISK_ENCODING && t.isRange(Math.max(0, a - Math.floor((c - a) / 2)), a, !1)) return [
                    a,
                    c
                ];
                a += r[0] + r[1], r.copyWithin(0, 2, 2 + i - 1), r[i - 1] = 0, r[i] = 0, i--;
            } else i++;
            r[i] = 1, u = !u;
        }
        throw new $2be8636d379871d6$var$U();
    }, e.toNarrowWidePattern = function(t) {
        var e, r, n, o = t.length, i = 0;
        do {
            var a = 2147483647;
            try {
                for(var u = (e = void 0, $2be8636d379871d6$var$Vt(t)), s = u.next(); !s.done; s = u.next())(l = s.value) < a && l > i && (a = l);
            } catch (t) {
                e = {
                    error: t
                };
            } finally{
                try {
                    s && !s.done && (r = u.return) && r.call(u);
                } finally{
                    if (e) throw e.error;
                }
            }
            i = a, n = 0;
            for(var c = 0, f = 0, h = 0; h < o; h++)(l = t[h]) > i && (f |= 1 << o - 1 - h, n++, c += l);
            if (3 === n) {
                for(h = 0; h < o && n > 0; h++){
                    var l;
                    if ((l = t[h]) > i && (n--, 2 * l >= c)) return -1;
                }
                return f;
            }
        }while (n > 3);
        return -1;
    }, e.patternToChar = function(t) {
        for(var r = 0; r < e.CHARACTER_ENCODINGS.length; r++)if (e.CHARACTER_ENCODINGS[r] === t) return e.ALPHABET_STRING.charAt(r);
        if (t === e.ASTERISK_ENCODING) return "*";
        throw new $2be8636d379871d6$var$U();
    }, e.decodeExtended = function(t) {
        for(var e = t.length, r = "", n = 0; n < e; n++){
            var o = t.charAt(n);
            if ("+" === o || "$" === o || "%" === o || "/" === o) {
                var i = t.charAt(n + 1), a = "\x00";
                switch(o){
                    case "+":
                        if (!(i >= "A" && i <= "Z")) throw new $2be8636d379871d6$var$R();
                        a = String.fromCharCode(i.charCodeAt(0) + 32);
                        break;
                    case "$":
                        if (!(i >= "A" && i <= "Z")) throw new $2be8636d379871d6$var$R();
                        a = String.fromCharCode(i.charCodeAt(0) - 64);
                        break;
                    case "%":
                        if (i >= "A" && i <= "E") a = String.fromCharCode(i.charCodeAt(0) - 38);
                        else if (i >= "F" && i <= "J") a = String.fromCharCode(i.charCodeAt(0) - 11);
                        else if (i >= "K" && i <= "O") a = String.fromCharCode(i.charCodeAt(0) + 16);
                        else if (i >= "P" && i <= "T") a = String.fromCharCode(i.charCodeAt(0) + 43);
                        else if ("U" === i) a = "\x00";
                        else if ("V" === i) a = "@";
                        else if ("W" === i) a = "`";
                        else {
                            if ("X" !== i && "Y" !== i && "Z" !== i) throw new $2be8636d379871d6$var$R();
                            a = "\x7f";
                        }
                        break;
                    case "/":
                        if (i >= "A" && i <= "O") a = String.fromCharCode(i.charCodeAt(0) - 32);
                        else {
                            if ("Z" !== i) throw new $2be8636d379871d6$var$R();
                            a = ":";
                        }
                }
                r += a, n++;
            } else r += o;
        }
        return r;
    }, e.ALPHABET_STRING = "0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZ-. $/+%", e.CHARACTER_ENCODINGS = [
        52,
        289,
        97,
        352,
        49,
        304,
        112,
        37,
        292,
        100,
        265,
        73,
        328,
        25,
        280,
        88,
        13,
        268,
        76,
        28,
        259,
        67,
        322,
        19,
        274,
        82,
        7,
        262,
        70,
        22,
        385,
        193,
        448,
        145,
        400,
        208,
        133,
        388,
        196,
        168,
        162,
        138,
        42
    ], e.ASTERISK_ENCODING = 148, e;
}($2be8636d379871d6$var$Lt), $2be8636d379871d6$var$Ht = function() {
    var t = function(e, r) {
        return t = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(t, e) {
            t.__proto__ = e;
        } || function(t, e) {
            for(var r in e)e.hasOwnProperty(r) && (t[r] = e[r]);
        }, t(e, r);
    };
    return function(e, r) {
        function n() {
            this.constructor = e;
        }
        t(e, r), e.prototype = null === r ? Object.create(r) : (n.prototype = r.prototype, new n());
    };
}(), $2be8636d379871d6$var$Gt = function(t) {
    var e = "function" == typeof Symbol && Symbol.iterator, r = e && t[e], n = 0;
    if (r) return r.call(t);
    if (t && "number" == typeof t.length) return {
        next: function() {
            return t && n >= t.length && (t = void 0), {
                value: t && t[n++],
                done: !t
            };
        }
    };
    throw new TypeError(e ? "Object is not iterable." : "Symbol.iterator is not defined.");
}, $2be8636d379871d6$var$Xt = function(t) {
    function e() {
        var e = null !== t && t.apply(this, arguments) || this;
        return e.narrowLineWidth = -1, e;
    }
    return $2be8636d379871d6$var$Ht(e, t), e.prototype.decodeRow = function(t, r, n) {
        var o, i, a = this.decodeStart(r), u = this.decodeEnd(r), s = new $2be8636d379871d6$var$k();
        e.decodeMiddle(r, a[1], u[0], s);
        var c = s.toString(), f = null;
        null != n && (f = n.get($2be8636d379871d6$var$T.ALLOWED_LENGTHS)), null == f && (f = e.DEFAULT_ALLOWED_LENGTHS);
        var h = c.length, l = !1, d = 0;
        try {
            for(var p = $2be8636d379871d6$var$Gt(f), g = p.next(); !g.done; g = p.next()){
                var y = g.value;
                if (h === y) {
                    l = !0;
                    break;
                }
                y > d && (d = y);
            }
        } catch (t) {
            o = {
                error: t
            };
        } finally{
            try {
                g && !g.done && (i = p.return) && i.call(p);
            } finally{
                if (o) throw o.error;
            }
        }
        if (!l && h > d && (l = !0), !l) throw new $2be8636d379871d6$var$R();
        var w = [
            new $2be8636d379871d6$var$At(a[1], t),
            new $2be8636d379871d6$var$At(u[0], t)
        ];
        return new $2be8636d379871d6$var$et(c, null, 0, w, $2be8636d379871d6$var$nt.ITF, new Date().getTime());
    }, e.decodeMiddle = function(t, r, n, o) {
        var i = new Int32Array(10), a = new Int32Array(5), u = new Int32Array(5);
        for(i.fill(0), a.fill(0), u.fill(0); r < n;){
            $2be8636d379871d6$var$Lt.recordPattern(t, r, i);
            for(var s = 0; s < 5; s++){
                var c = 2 * s;
                a[s] = i[c], u[s] = i[c + 1];
            }
            var f = e.decodeDigit(a);
            o.append(f.toString()), f = this.decodeDigit(u), o.append(f.toString()), i.forEach(function(t) {
                r += t;
            });
        }
    }, e.prototype.decodeStart = function(t) {
        var r = e.skipWhiteSpace(t), n = e.findGuardPattern(t, r, e.START_PATTERN);
        return this.narrowLineWidth = (n[1] - n[0]) / 4, this.validateQuietZone(t, n[0]), n;
    }, e.prototype.validateQuietZone = function(t, e) {
        var r = 10 * this.narrowLineWidth;
        r = r < e ? r : e;
        for(var n = e - 1; r > 0 && n >= 0 && !t.get(n); n--)r--;
        if (0 !== r) throw new $2be8636d379871d6$var$U();
    }, e.skipWhiteSpace = function(t) {
        var e = t.getSize(), r = t.getNextSet(0);
        if (r === e) throw new $2be8636d379871d6$var$U();
        return r;
    }, e.prototype.decodeEnd = function(t) {
        t.reverse();
        try {
            var r = e.skipWhiteSpace(t), n = void 0;
            try {
                n = e.findGuardPattern(t, r, e.END_PATTERN_REVERSED[0]);
            } catch (o) {
                o instanceof $2be8636d379871d6$var$U && (n = e.findGuardPattern(t, r, e.END_PATTERN_REVERSED[1]));
            }
            this.validateQuietZone(t, n[0]);
            var o = n[0];
            return n[0] = t.getSize() - n[1], n[1] = t.getSize() - o, n;
        } finally{
            t.reverse();
        }
    }, e.findGuardPattern = function(t, r, n) {
        var o = n.length, i = new Int32Array(o), a = t.getSize(), u = !1, s = 0, c = r;
        i.fill(0);
        for(var f = r; f < a; f++)if (t.get(f) !== u) i[s]++;
        else {
            if (s === o - 1) {
                if ($2be8636d379871d6$var$Lt.patternMatchVariance(i, n, e.MAX_INDIVIDUAL_VARIANCE) < e.MAX_AVG_VARIANCE) return [
                    c,
                    f
                ];
                c += i[0] + i[1], $2be8636d379871d6$var$w.arraycopy(i, 2, i, 0, s - 1), i[s - 1] = 0, i[s] = 0, s--;
            } else s++;
            i[s] = 1, u = !u;
        }
        throw new $2be8636d379871d6$var$U();
    }, e.decodeDigit = function(t) {
        for(var r = e.MAX_AVG_VARIANCE, n = -1, o = e.PATTERNS.length, i = 0; i < o; i++){
            var a = e.PATTERNS[i], u = $2be8636d379871d6$var$Lt.patternMatchVariance(t, a, e.MAX_INDIVIDUAL_VARIANCE);
            u < r ? (r = u, n = i) : u === r && (n = -1);
        }
        if (n >= 0) return n % 10;
        throw new $2be8636d379871d6$var$U();
    }, e.PATTERNS = [
        Int32Array.from([
            1,
            1,
            2,
            2,
            1
        ]),
        Int32Array.from([
            2,
            1,
            1,
            1,
            2
        ]),
        Int32Array.from([
            1,
            2,
            1,
            1,
            2
        ]),
        Int32Array.from([
            2,
            2,
            1,
            1,
            1
        ]),
        Int32Array.from([
            1,
            1,
            2,
            1,
            2
        ]),
        Int32Array.from([
            2,
            1,
            2,
            1,
            1
        ]),
        Int32Array.from([
            1,
            2,
            2,
            1,
            1
        ]),
        Int32Array.from([
            1,
            1,
            1,
            2,
            2
        ]),
        Int32Array.from([
            2,
            1,
            1,
            2,
            1
        ]),
        Int32Array.from([
            1,
            2,
            1,
            2,
            1
        ]),
        Int32Array.from([
            1,
            1,
            3,
            3,
            1
        ]),
        Int32Array.from([
            3,
            1,
            1,
            1,
            3
        ]),
        Int32Array.from([
            1,
            3,
            1,
            1,
            3
        ]),
        Int32Array.from([
            3,
            3,
            1,
            1,
            1
        ]),
        Int32Array.from([
            1,
            1,
            3,
            1,
            3
        ]),
        Int32Array.from([
            3,
            1,
            3,
            1,
            1
        ]),
        Int32Array.from([
            1,
            3,
            3,
            1,
            1
        ]),
        Int32Array.from([
            1,
            1,
            1,
            3,
            3
        ]),
        Int32Array.from([
            3,
            1,
            1,
            3,
            1
        ]),
        Int32Array.from([
            1,
            3,
            1,
            3,
            1
        ])
    ], e.MAX_AVG_VARIANCE = 0.38, e.MAX_INDIVIDUAL_VARIANCE = 0.5, e.DEFAULT_ALLOWED_LENGTHS = [
        6,
        8,
        10,
        12,
        14
    ], e.START_PATTERN = Int32Array.from([
        1,
        1,
        1,
        1
    ]), e.END_PATTERN_REVERSED = [
        Int32Array.from([
            1,
            1,
            2
        ]),
        Int32Array.from([
            1,
            1,
            3
        ])
    ], e;
}($2be8636d379871d6$var$Lt), $2be8636d379871d6$var$Wt = function() {
    var t = function(e, r) {
        return t = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(t, e) {
            t.__proto__ = e;
        } || function(t, e) {
            for(var r in e)e.hasOwnProperty(r) && (t[r] = e[r]);
        }, t(e, r);
    };
    return function(e, r) {
        function n() {
            this.constructor = e;
        }
        t(e, r), e.prototype = null === r ? Object.create(r) : (n.prototype = r.prototype, new n());
    };
}(), $2be8636d379871d6$var$jt = function(t) {
    function e() {
        var e = null !== t && t.apply(this, arguments) || this;
        return e.decodeRowStringBuffer = "", e;
    }
    return $2be8636d379871d6$var$Wt(e, t), e.findStartGuardPattern = function(t) {
        for(var r, n = !1, o = 0, i = Int32Array.from([
            0,
            0,
            0
        ]); !n;){
            i = Int32Array.from([
                0,
                0,
                0
            ]);
            var a = (r = e.findGuardPattern(t, o, !1, this.START_END_PATTERN, i))[0], u = a - ((o = r[1]) - a);
            u >= 0 && (n = t.isRange(u, a, !1));
        }
        return r;
    }, e.checkChecksum = function(t) {
        return e.checkStandardUPCEANChecksum(t);
    }, e.checkStandardUPCEANChecksum = function(t) {
        var r = t.length;
        if (0 === r) return !1;
        var n = parseInt(t.charAt(r - 1), 10);
        return e.getStandardUPCEANChecksum(t.substring(0, r - 1)) === n;
    }, e.getStandardUPCEANChecksum = function(t) {
        for(var e = t.length, r = 0, n = e - 1; n >= 0; n -= 2){
            if ((o = t.charAt(n).charCodeAt(0) - "0".charCodeAt(0)) < 0 || o > 9) throw new $2be8636d379871d6$var$R();
            r += o;
        }
        r *= 3;
        for(n = e - 2; n >= 0; n -= 2){
            var o;
            if ((o = t.charAt(n).charCodeAt(0) - "0".charCodeAt(0)) < 0 || o > 9) throw new $2be8636d379871d6$var$R();
            r += o;
        }
        return (1e3 - r) % 10;
    }, e.decodeEnd = function(t, r) {
        return e.findGuardPattern(t, r, !1, e.START_END_PATTERN, new Int32Array(e.START_END_PATTERN.length).fill(0));
    }, e.findGuardPatternWithoutCounters = function(t, e, r, n) {
        return this.findGuardPattern(t, e, r, n, new Int32Array(n.length));
    }, e.findGuardPattern = function(t, r, n, o, i) {
        for(var a = t.getSize(), u = 0, s = r = n ? t.getNextUnset(r) : t.getNextSet(r), c = o.length, f = n, h = r; h < a; h++)if (t.get(h) !== f) i[u]++;
        else {
            if (u === c - 1) {
                if ($2be8636d379871d6$var$Lt.patternMatchVariance(i, o, e.MAX_INDIVIDUAL_VARIANCE) < e.MAX_AVG_VARIANCE) return Int32Array.from([
                    s,
                    h
                ]);
                s += i[0] + i[1];
                for(var l = i.slice(2, i.length - 1), d = 0; d < u - 1; d++)i[d] = l[d];
                i[u - 1] = 0, i[u] = 0, u--;
            } else u++;
            i[u] = 1, f = !f;
        }
        throw new $2be8636d379871d6$var$U();
    }, e.decodeDigit = function(t, r, n, o) {
        this.recordPattern(t, n, r);
        for(var i = this.MAX_AVG_VARIANCE, a = -1, u = o.length, s = 0; s < u; s++){
            var c = o[s], f = $2be8636d379871d6$var$Lt.patternMatchVariance(r, c, e.MAX_INDIVIDUAL_VARIANCE);
            f < i && (i = f, a = s);
        }
        if (a >= 0) return a;
        throw new $2be8636d379871d6$var$U();
    }, e.MAX_AVG_VARIANCE = 0.48, e.MAX_INDIVIDUAL_VARIANCE = 0.7, e.START_END_PATTERN = Int32Array.from([
        1,
        1,
        1
    ]), e.MIDDLE_PATTERN = Int32Array.from([
        1,
        1,
        1,
        1,
        1
    ]), e.END_PATTERN = Int32Array.from([
        1,
        1,
        1,
        1,
        1,
        1
    ]), e.L_PATTERNS = [
        Int32Array.from([
            3,
            2,
            1,
            1
        ]),
        Int32Array.from([
            2,
            2,
            2,
            1
        ]),
        Int32Array.from([
            2,
            1,
            2,
            2
        ]),
        Int32Array.from([
            1,
            4,
            1,
            1
        ]),
        Int32Array.from([
            1,
            1,
            3,
            2
        ]),
        Int32Array.from([
            1,
            2,
            3,
            1
        ]),
        Int32Array.from([
            1,
            1,
            1,
            4
        ]),
        Int32Array.from([
            1,
            3,
            1,
            2
        ]),
        Int32Array.from([
            1,
            2,
            1,
            3
        ]),
        Int32Array.from([
            3,
            1,
            1,
            2
        ])
    ], e;
}($2be8636d379871d6$var$Lt), $2be8636d379871d6$var$zt = function(t) {
    var e = "function" == typeof Symbol && Symbol.iterator, r = e && t[e], n = 0;
    if (r) return r.call(t);
    if (t && "number" == typeof t.length) return {
        next: function() {
            return t && n >= t.length && (t = void 0), {
                value: t && t[n++],
                done: !t
            };
        }
    };
    throw new TypeError(e ? "Object is not iterable." : "Symbol.iterator is not defined.");
}, $2be8636d379871d6$var$Yt = function() {
    function t() {
        this.CHECK_DIGIT_ENCODINGS = [
            24,
            20,
            18,
            17,
            12,
            6,
            3,
            10,
            9,
            5
        ], this.decodeMiddleCounters = Int32Array.from([
            0,
            0,
            0,
            0
        ]), this.decodeRowStringBuffer = "";
    }
    return t.prototype.decodeRow = function(e, r, n) {
        var o = this.decodeRowStringBuffer, i = this.decodeMiddle(r, n, o), a = o.toString(), u = t.parseExtensionString(a), s = [
            new $2be8636d379871d6$var$At((n[0] + n[1]) / 2, e),
            new $2be8636d379871d6$var$At(i, e)
        ], c = new $2be8636d379871d6$var$et(a, null, 0, s, $2be8636d379871d6$var$nt.UPC_EAN_EXTENSION, new Date().getTime());
        return null != u && c.putAllMetadata(u), c;
    }, t.prototype.decodeMiddle = function(e, r, n) {
        var o, i, a = this.decodeMiddleCounters;
        a[0] = 0, a[1] = 0, a[2] = 0, a[3] = 0;
        for(var u = e.getSize(), s = r[1], c = 0, f = 0; f < 5 && s < u; f++){
            var h = $2be8636d379871d6$var$jt.decodeDigit(e, a, s, $2be8636d379871d6$var$jt.L_AND_G_PATTERNS);
            n += String.fromCharCode("0".charCodeAt(0) + h % 10);
            try {
                for(var l = (o = void 0, $2be8636d379871d6$var$zt(a)), d = l.next(); !d.done; d = l.next())s += d.value;
            } catch (t) {
                o = {
                    error: t
                };
            } finally{
                try {
                    d && !d.done && (i = l.return) && i.call(l);
                } finally{
                    if (o) throw o.error;
                }
            }
            h >= 10 && (c |= 1 << 4 - f), 4 !== f && (s = e.getNextSet(s), s = e.getNextUnset(s));
        }
        if (5 !== n.length) throw new $2be8636d379871d6$var$U();
        var p = this.determineCheckDigit(c);
        if (t.extensionChecksum(n.toString()) !== p) throw new $2be8636d379871d6$var$U();
        return s;
    }, t.extensionChecksum = function(t) {
        for(var e = t.length, r = 0, n = e - 2; n >= 0; n -= 2)r += t.charAt(n).charCodeAt(0) - "0".charCodeAt(0);
        r *= 3;
        for(n = e - 1; n >= 0; n -= 2)r += t.charAt(n).charCodeAt(0) - "0".charCodeAt(0);
        return (r *= 3) % 10;
    }, t.prototype.determineCheckDigit = function(t) {
        for(var e = 0; e < 10; e++)if (t === this.CHECK_DIGIT_ENCODINGS[e]) return e;
        throw new $2be8636d379871d6$var$U();
    }, t.parseExtensionString = function(e) {
        if (5 !== e.length) return null;
        var r = t.parseExtension5String(e);
        return null == r ? null : new Map([
            [
                $2be8636d379871d6$var$it.SUGGESTED_PRICE,
                r
            ]
        ]);
    }, t.parseExtension5String = function(t) {
        var e;
        switch(t.charAt(0)){
            case "0":
                e = "\xa3";
                break;
            case "5":
                e = "$";
                break;
            case "9":
                switch(t){
                    case "90000":
                        return null;
                    case "99991":
                        return "0.00";
                    case "99990":
                        return "Used";
                }
                e = "";
                break;
            default:
                e = "";
        }
        var r = parseInt(t.substring(1)), n = r % 100;
        return e + (r / 100).toString() + "." + (n < 10 ? "0" + n : n.toString());
    }, t;
}(), $2be8636d379871d6$var$Zt = function(t) {
    var e = "function" == typeof Symbol && Symbol.iterator, r = e && t[e], n = 0;
    if (r) return r.call(t);
    if (t && "number" == typeof t.length) return {
        next: function() {
            return t && n >= t.length && (t = void 0), {
                value: t && t[n++],
                done: !t
            };
        }
    };
    throw new TypeError(e ? "Object is not iterable." : "Symbol.iterator is not defined.");
}, $2be8636d379871d6$var$Kt = function() {
    function t() {
        this.decodeMiddleCounters = Int32Array.from([
            0,
            0,
            0,
            0
        ]), this.decodeRowStringBuffer = "";
    }
    return t.prototype.decodeRow = function(e, r, n) {
        var o = this.decodeRowStringBuffer, i = this.decodeMiddle(r, n, o), a = o.toString(), u = t.parseExtensionString(a), s = [
            new $2be8636d379871d6$var$At((n[0] + n[1]) / 2, e),
            new $2be8636d379871d6$var$At(i, e)
        ], c = new $2be8636d379871d6$var$et(a, null, 0, s, $2be8636d379871d6$var$nt.UPC_EAN_EXTENSION, new Date().getTime());
        return null != u && c.putAllMetadata(u), c;
    }, t.prototype.decodeMiddle = function(t, e, r) {
        var n, o, i = this.decodeMiddleCounters;
        i[0] = 0, i[1] = 0, i[2] = 0, i[3] = 0;
        for(var a = t.getSize(), u = e[1], s = 0, c = 0; c < 2 && u < a; c++){
            var f = $2be8636d379871d6$var$jt.decodeDigit(t, i, u, $2be8636d379871d6$var$jt.L_AND_G_PATTERNS);
            r += String.fromCharCode("0".charCodeAt(0) + f % 10);
            try {
                for(var h = (n = void 0, $2be8636d379871d6$var$Zt(i)), l = h.next(); !l.done; l = h.next())u += l.value;
            } catch (t) {
                n = {
                    error: t
                };
            } finally{
                try {
                    l && !l.done && (o = h.return) && o.call(h);
                } finally{
                    if (n) throw n.error;
                }
            }
            f >= 10 && (s |= 1 << 1 - c), 1 !== c && (u = t.getNextSet(u), u = t.getNextUnset(u));
        }
        if (2 !== r.length) throw new $2be8636d379871d6$var$U();
        if (parseInt(r.toString()) % 4 !== s) throw new $2be8636d379871d6$var$U();
        return u;
    }, t.parseExtensionString = function(t) {
        return 2 !== t.length ? null : new Map([
            [
                $2be8636d379871d6$var$it.ISSUE_NUMBER,
                parseInt(t)
            ]
        ]);
    }, t;
}(), $2be8636d379871d6$var$qt = function() {
    function t() {}
    return t.decodeRow = function(t, e, r) {
        var n = $2be8636d379871d6$var$jt.findGuardPattern(e, r, !1, this.EXTENSION_START_PATTERN, new Int32Array(this.EXTENSION_START_PATTERN.length).fill(0));
        try {
            return new $2be8636d379871d6$var$Yt().decodeRow(t, e, n);
        } catch (r) {
            return new $2be8636d379871d6$var$Kt().decodeRow(t, e, n);
        }
    }, t.EXTENSION_START_PATTERN = Int32Array.from([
        1,
        1,
        2
    ]), t;
}(), $2be8636d379871d6$var$Qt = function() {
    var t = function(e, r) {
        return t = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(t, e) {
            t.__proto__ = e;
        } || function(t, e) {
            for(var r in e)e.hasOwnProperty(r) && (t[r] = e[r]);
        }, t(e, r);
    };
    return function(e, r) {
        function n() {
            this.constructor = e;
        }
        t(e, r), e.prototype = null === r ? Object.create(r) : (n.prototype = r.prototype, new n());
    };
}(), $2be8636d379871d6$var$Jt = function(t) {
    function e() {
        var r = t.call(this) || this;
        r.decodeRowStringBuffer = "", e.L_AND_G_PATTERNS = e.L_PATTERNS.map(function(t) {
            return Int32Array.from(t);
        });
        for(var n = 10; n < 20; n++){
            for(var o = e.L_PATTERNS[n - 10], i = new Int32Array(o.length), a = 0; a < o.length; a++)i[a] = o[o.length - a - 1];
            e.L_AND_G_PATTERNS[n] = i;
        }
        return r;
    }
    return $2be8636d379871d6$var$Qt(e, t), e.prototype.decodeRow = function(t, r, n) {
        var o = e.findStartGuardPattern(r), i = null == n ? null : n.get($2be8636d379871d6$var$T.NEED_RESULT_POINT_CALLBACK);
        if (null != i) {
            var a = new $2be8636d379871d6$var$At((o[0] + o[1]) / 2, t);
            i.foundPossibleResultPoint(a);
        }
        var u = this.decodeMiddle(r, o, this.decodeRowStringBuffer), s = u.rowOffset, c = u.resultString;
        if (null != i) {
            var f = new $2be8636d379871d6$var$At(s, t);
            i.foundPossibleResultPoint(f);
        }
        var h = e.decodeEnd(r, s);
        if (null != i) {
            var l = new $2be8636d379871d6$var$At((h[0] + h[1]) / 2, t);
            i.foundPossibleResultPoint(l);
        }
        var d = h[1], p = d + (d - h[0]);
        if (p >= r.getSize() || !r.isRange(d, p, !1)) throw new $2be8636d379871d6$var$U();
        var y = c.toString();
        if (y.length < 8) throw new $2be8636d379871d6$var$R();
        if (!e.checkChecksum(y)) throw new $2be8636d379871d6$var$g();
        var w = (o[1] + o[0]) / 2, _ = (h[1] + h[0]) / 2, v = this.getBarcodeFormat(), m = [
            new $2be8636d379871d6$var$At(w, t),
            new $2be8636d379871d6$var$At(_, t)
        ], A = new $2be8636d379871d6$var$et(y, null, 0, m, v, new Date().getTime()), E = 0;
        try {
            var C = $2be8636d379871d6$var$qt.decodeRow(t, r, h[1]);
            A.putMetadata($2be8636d379871d6$var$it.UPC_EAN_EXTENSION, C.getText()), A.putAllMetadata(C.getResultMetadata()), A.addResultPoints(C.getResultPoints()), E = C.getText().length;
        } catch (t) {}
        var I = null == n ? null : n.get($2be8636d379871d6$var$T.ALLOWED_EAN_EXTENSIONS);
        if (null != I) {
            var S = !1;
            for(var O in I)if (E.toString() === O) {
                S = !0;
                break;
            }
            if (!S) throw new $2be8636d379871d6$var$U();
        }
        return v === $2be8636d379871d6$var$nt.EAN_13 || $2be8636d379871d6$var$nt.UPC_A, A;
    }, e.checkChecksum = function(t) {
        return e.checkStandardUPCEANChecksum(t);
    }, e.checkStandardUPCEANChecksum = function(t) {
        var r = t.length;
        if (0 === r) return !1;
        var n = parseInt(t.charAt(r - 1), 10);
        return e.getStandardUPCEANChecksum(t.substring(0, r - 1)) === n;
    }, e.getStandardUPCEANChecksum = function(t) {
        for(var e = t.length, r = 0, n = e - 1; n >= 0; n -= 2){
            if ((o = t.charAt(n).charCodeAt(0) - "0".charCodeAt(0)) < 0 || o > 9) throw new $2be8636d379871d6$var$R();
            r += o;
        }
        r *= 3;
        for(n = e - 2; n >= 0; n -= 2){
            var o;
            if ((o = t.charAt(n).charCodeAt(0) - "0".charCodeAt(0)) < 0 || o > 9) throw new $2be8636d379871d6$var$R();
            r += o;
        }
        return (1e3 - r) % 10;
    }, e.decodeEnd = function(t, r) {
        return e.findGuardPattern(t, r, !1, e.START_END_PATTERN, new Int32Array(e.START_END_PATTERN.length).fill(0));
    }, e;
}($2be8636d379871d6$var$jt), $2be8636d379871d6$var$$t = function() {
    var t = function(e, r) {
        return t = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(t, e) {
            t.__proto__ = e;
        } || function(t, e) {
            for(var r in e)e.hasOwnProperty(r) && (t[r] = e[r]);
        }, t(e, r);
    };
    return function(e, r) {
        function n() {
            this.constructor = e;
        }
        t(e, r), e.prototype = null === r ? Object.create(r) : (n.prototype = r.prototype, new n());
    };
}(), $2be8636d379871d6$var$te = function(t) {
    var e = "function" == typeof Symbol && Symbol.iterator, r = e && t[e], n = 0;
    if (r) return r.call(t);
    if (t && "number" == typeof t.length) return {
        next: function() {
            return t && n >= t.length && (t = void 0), {
                value: t && t[n++],
                done: !t
            };
        }
    };
    throw new TypeError(e ? "Object is not iterable." : "Symbol.iterator is not defined.");
}, $2be8636d379871d6$var$ee = function(t) {
    function e() {
        var e = t.call(this) || this;
        return e.decodeMiddleCounters = Int32Array.from([
            0,
            0,
            0,
            0
        ]), e;
    }
    return $2be8636d379871d6$var$$t(e, t), e.prototype.decodeMiddle = function(t, r, n) {
        var o, i, a, u, s = this.decodeMiddleCounters;
        s[0] = 0, s[1] = 0, s[2] = 0, s[3] = 0;
        for(var c = t.getSize(), f = r[1], h = 0, l = 0; l < 6 && f < c; l++){
            var d = $2be8636d379871d6$var$Jt.decodeDigit(t, s, f, $2be8636d379871d6$var$Jt.L_AND_G_PATTERNS);
            n += String.fromCharCode("0".charCodeAt(0) + d % 10);
            try {
                for(var p = (o = void 0, $2be8636d379871d6$var$te(s)), g = p.next(); !g.done; g = p.next())f += g.value;
            } catch (t) {
                o = {
                    error: t
                };
            } finally{
                try {
                    g && !g.done && (i = p.return) && i.call(p);
                } finally{
                    if (o) throw o.error;
                }
            }
            d >= 10 && (h |= 1 << 5 - l);
        }
        n = e.determineFirstDigit(n, h), f = $2be8636d379871d6$var$Jt.findGuardPattern(t, f, !0, $2be8636d379871d6$var$Jt.MIDDLE_PATTERN, new Int32Array($2be8636d379871d6$var$Jt.MIDDLE_PATTERN.length).fill(0))[1];
        for(l = 0; l < 6 && f < c; l++){
            d = $2be8636d379871d6$var$Jt.decodeDigit(t, s, f, $2be8636d379871d6$var$Jt.L_PATTERNS);
            n += String.fromCharCode("0".charCodeAt(0) + d);
            try {
                for(var y = (a = void 0, $2be8636d379871d6$var$te(s)), w = y.next(); !w.done; w = y.next())f += w.value;
            } catch (t) {
                a = {
                    error: t
                };
            } finally{
                try {
                    w && !w.done && (u = y.return) && u.call(y);
                } finally{
                    if (a) throw a.error;
                }
            }
        }
        return {
            rowOffset: f,
            resultString: n
        };
    }, e.prototype.getBarcodeFormat = function() {
        return $2be8636d379871d6$var$nt.EAN_13;
    }, e.determineFirstDigit = function(t, e) {
        for(var r = 0; r < 10; r++)if (e === this.FIRST_DIGIT_ENCODINGS[r]) return t = String.fromCharCode("0".charCodeAt(0) + r) + t;
        throw new $2be8636d379871d6$var$U();
    }, e.FIRST_DIGIT_ENCODINGS = [
        0,
        11,
        13,
        14,
        19,
        25,
        28,
        21,
        22,
        26
    ], e;
}($2be8636d379871d6$var$Jt), $2be8636d379871d6$var$re = function() {
    var t = function(e, r) {
        return t = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(t, e) {
            t.__proto__ = e;
        } || function(t, e) {
            for(var r in e)e.hasOwnProperty(r) && (t[r] = e[r]);
        }, t(e, r);
    };
    return function(e, r) {
        function n() {
            this.constructor = e;
        }
        t(e, r), e.prototype = null === r ? Object.create(r) : (n.prototype = r.prototype, new n());
    };
}(), $2be8636d379871d6$var$ne = function(t) {
    var e = "function" == typeof Symbol && Symbol.iterator, r = e && t[e], n = 0;
    if (r) return r.call(t);
    if (t && "number" == typeof t.length) return {
        next: function() {
            return t && n >= t.length && (t = void 0), {
                value: t && t[n++],
                done: !t
            };
        }
    };
    throw new TypeError(e ? "Object is not iterable." : "Symbol.iterator is not defined.");
}, $2be8636d379871d6$var$oe = function(t) {
    function e() {
        var e = t.call(this) || this;
        return e.decodeMiddleCounters = Int32Array.from([
            0,
            0,
            0,
            0
        ]), e;
    }
    return $2be8636d379871d6$var$re(e, t), e.prototype.decodeMiddle = function(t, e, r) {
        var n, o, i, a, u = this.decodeMiddleCounters;
        u[0] = 0, u[1] = 0, u[2] = 0, u[3] = 0;
        for(var s = t.getSize(), c = e[1], f = 0; f < 4 && c < s; f++){
            var h = $2be8636d379871d6$var$Jt.decodeDigit(t, u, c, $2be8636d379871d6$var$Jt.L_PATTERNS);
            r += String.fromCharCode("0".charCodeAt(0) + h);
            try {
                for(var l = (n = void 0, $2be8636d379871d6$var$ne(u)), d = l.next(); !d.done; d = l.next())c += d.value;
            } catch (t) {
                n = {
                    error: t
                };
            } finally{
                try {
                    d && !d.done && (o = l.return) && o.call(l);
                } finally{
                    if (n) throw n.error;
                }
            }
        }
        c = $2be8636d379871d6$var$Jt.findGuardPattern(t, c, !0, $2be8636d379871d6$var$Jt.MIDDLE_PATTERN, new Int32Array($2be8636d379871d6$var$Jt.MIDDLE_PATTERN.length).fill(0))[1];
        for(f = 0; f < 4 && c < s; f++){
            h = $2be8636d379871d6$var$Jt.decodeDigit(t, u, c, $2be8636d379871d6$var$Jt.L_PATTERNS);
            r += String.fromCharCode("0".charCodeAt(0) + h);
            try {
                for(var p = (i = void 0, $2be8636d379871d6$var$ne(u)), g = p.next(); !g.done; g = p.next())c += g.value;
            } catch (t) {
                i = {
                    error: t
                };
            } finally{
                try {
                    g && !g.done && (a = p.return) && a.call(p);
                } finally{
                    if (i) throw i.error;
                }
            }
        }
        return {
            rowOffset: c,
            resultString: r
        };
    }, e.prototype.getBarcodeFormat = function() {
        return $2be8636d379871d6$var$nt.EAN_8;
    }, e;
}($2be8636d379871d6$var$Jt), $2be8636d379871d6$var$ie = function() {
    var t = function(e, r) {
        return t = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(t, e) {
            t.__proto__ = e;
        } || function(t, e) {
            for(var r in e)e.hasOwnProperty(r) && (t[r] = e[r]);
        }, t(e, r);
    };
    return function(e, r) {
        function n() {
            this.constructor = e;
        }
        t(e, r), e.prototype = null === r ? Object.create(r) : (n.prototype = r.prototype, new n());
    };
}(), $2be8636d379871d6$var$ae = function(t) {
    function e() {
        var e = null !== t && t.apply(this, arguments) || this;
        return e.ean13Reader = new $2be8636d379871d6$var$ee(), e;
    }
    return $2be8636d379871d6$var$ie(e, t), e.prototype.getBarcodeFormat = function() {
        return $2be8636d379871d6$var$nt.UPC_A;
    }, e.prototype.decode = function(t, e) {
        return this.maybeReturnResult(this.ean13Reader.decode(t));
    }, e.prototype.decodeRow = function(t, e, r) {
        return this.maybeReturnResult(this.ean13Reader.decodeRow(t, e, r));
    }, e.prototype.decodeMiddle = function(t, e, r) {
        return this.ean13Reader.decodeMiddle(t, e, r);
    }, e.prototype.maybeReturnResult = function(t) {
        var e = t.getText();
        if ("0" === e.charAt(0)) {
            var r = new $2be8636d379871d6$var$et(e.substring(1), null, null, t.getResultPoints(), $2be8636d379871d6$var$nt.UPC_A);
            return null != t.getResultMetadata() && r.putAllMetadata(t.getResultMetadata()), r;
        }
        throw new $2be8636d379871d6$var$U();
    }, e.prototype.reset = function() {
        this.ean13Reader.reset();
    }, e;
}($2be8636d379871d6$var$Jt), $2be8636d379871d6$var$ue = function() {
    var t = function(e, r) {
        return t = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(t, e) {
            t.__proto__ = e;
        } || function(t, e) {
            for(var r in e)e.hasOwnProperty(r) && (t[r] = e[r]);
        }, t(e, r);
    };
    return function(e, r) {
        function n() {
            this.constructor = e;
        }
        t(e, r), e.prototype = null === r ? Object.create(r) : (n.prototype = r.prototype, new n());
    };
}(), $2be8636d379871d6$var$se = function(t) {
    var e = "function" == typeof Symbol && Symbol.iterator, r = e && t[e], n = 0;
    if (r) return r.call(t);
    if (t && "number" == typeof t.length) return {
        next: function() {
            return t && n >= t.length && (t = void 0), {
                value: t && t[n++],
                done: !t
            };
        }
    };
    throw new TypeError(e ? "Object is not iterable." : "Symbol.iterator is not defined.");
}, $2be8636d379871d6$var$ce = function(t) {
    function e() {
        var e = t.call(this) || this;
        return e.decodeMiddleCounters = new Int32Array(4), e;
    }
    return $2be8636d379871d6$var$ue(e, t), e.prototype.decodeMiddle = function(t, r, n) {
        var o, i, a = this.decodeMiddleCounters.map(function(t) {
            return t;
        });
        a[0] = 0, a[1] = 0, a[2] = 0, a[3] = 0;
        for(var u = t.getSize(), s = r[1], c = 0, f = 0; f < 6 && s < u; f++){
            var h = e.decodeDigit(t, a, s, e.L_AND_G_PATTERNS);
            n += String.fromCharCode("0".charCodeAt(0) + h % 10);
            try {
                for(var l = (o = void 0, $2be8636d379871d6$var$se(a)), d = l.next(); !d.done; d = l.next())s += d.value;
            } catch (t) {
                o = {
                    error: t
                };
            } finally{
                try {
                    d && !d.done && (i = l.return) && i.call(l);
                } finally{
                    if (o) throw o.error;
                }
            }
            h >= 10 && (c |= 1 << 5 - f);
        }
        return e.determineNumSysAndCheckDigit(new $2be8636d379871d6$var$k(n), c), s;
    }, e.prototype.decodeEnd = function(t, r) {
        return e.findGuardPatternWithoutCounters(t, r, !0, e.MIDDLE_END_PATTERN);
    }, e.prototype.checkChecksum = function(t) {
        return $2be8636d379871d6$var$Jt.checkChecksum(e.convertUPCEtoUPCA(t));
    }, e.determineNumSysAndCheckDigit = function(t, e) {
        for(var r = 0; r <= 1; r++)for(var n = 0; n < 10; n++)if (e === this.NUMSYS_AND_CHECK_DIGIT_PATTERNS[r][n]) return t.insert(0, "0" + r), void t.append("0" + n);
        throw $2be8636d379871d6$var$U.getNotFoundInstance();
    }, e.prototype.getBarcodeFormat = function() {
        return $2be8636d379871d6$var$nt.UPC_E;
    }, e.convertUPCEtoUPCA = function(t) {
        var e = t.slice(1, 7).split("").map(function(t) {
            return t.charCodeAt(0);
        }), r = new $2be8636d379871d6$var$k();
        r.append(t.charAt(0));
        var n = e[5];
        switch(n){
            case 0:
            case 1:
            case 2:
                r.appendChars(e, 0, 2), r.append(n), r.append("0000"), r.appendChars(e, 2, 3);
                break;
            case 3:
                r.appendChars(e, 0, 3), r.append("00000"), r.appendChars(e, 3, 2);
                break;
            case 4:
                r.appendChars(e, 0, 4), r.append("00000"), r.append(e[4]);
                break;
            default:
                r.appendChars(e, 0, 5), r.append("0000"), r.append(n);
        }
        return t.length >= 8 && r.append(t.charAt(7)), r.toString();
    }, e.MIDDLE_END_PATTERN = Int32Array.from([
        1,
        1,
        1,
        1,
        1,
        1
    ]), e.NUMSYS_AND_CHECK_DIGIT_PATTERNS = [
        Int32Array.from([
            56,
            52,
            50,
            49,
            44,
            38,
            35,
            42,
            41,
            37
        ]),
        Int32Array.from([
            7,
            11,
            13,
            14,
            19,
            25,
            28,
            21,
            22,
            1
        ])
    ], e;
}($2be8636d379871d6$var$Jt), $2be8636d379871d6$var$fe = function() {
    var t = function(e, r) {
        return t = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(t, e) {
            t.__proto__ = e;
        } || function(t, e) {
            for(var r in e)e.hasOwnProperty(r) && (t[r] = e[r]);
        }, t(e, r);
    };
    return function(e, r) {
        function n() {
            this.constructor = e;
        }
        t(e, r), e.prototype = null === r ? Object.create(r) : (n.prototype = r.prototype, new n());
    };
}(), $2be8636d379871d6$var$he = function(t) {
    var e = "function" == typeof Symbol && Symbol.iterator, r = e && t[e], n = 0;
    if (r) return r.call(t);
    if (t && "number" == typeof t.length) return {
        next: function() {
            return t && n >= t.length && (t = void 0), {
                value: t && t[n++],
                done: !t
            };
        }
    };
    throw new TypeError(e ? "Object is not iterable." : "Symbol.iterator is not defined.");
}, $2be8636d379871d6$var$le = function(t) {
    function e(e) {
        var r = t.call(this) || this, n = null == e ? null : e.get($2be8636d379871d6$var$T.POSSIBLE_FORMATS), o = [];
        return null != n && (n.indexOf($2be8636d379871d6$var$nt.EAN_13) > -1 ? o.push(new $2be8636d379871d6$var$ee()) : n.indexOf($2be8636d379871d6$var$nt.UPC_A) > -1 && o.push(new $2be8636d379871d6$var$ae()), n.indexOf($2be8636d379871d6$var$nt.EAN_8) > -1 && o.push(new $2be8636d379871d6$var$oe()), n.indexOf($2be8636d379871d6$var$nt.UPC_E) > -1 && o.push(new $2be8636d379871d6$var$ce())), 0 === o.length && (o.push(new $2be8636d379871d6$var$ee()), o.push(new $2be8636d379871d6$var$oe()), o.push(new $2be8636d379871d6$var$ce())), r.readers = o, r;
    }
    return $2be8636d379871d6$var$fe(e, t), e.prototype.decodeRow = function(t, e, r) {
        var n, o;
        try {
            for(var i = $2be8636d379871d6$var$he(this.readers), a = i.next(); !a.done; a = i.next()){
                var u = a.value;
                try {
                    var s = u.decodeRow(t, e, r), c = s.getBarcodeFormat() === $2be8636d379871d6$var$nt.EAN_13 && "0" === s.getText().charAt(0), f = null == r ? null : r.get($2be8636d379871d6$var$T.POSSIBLE_FORMATS), h = null == f || f.includes($2be8636d379871d6$var$nt.UPC_A);
                    if (c && h) {
                        var l = s.getRawBytes(), d = new $2be8636d379871d6$var$et(s.getText().substring(1), l, l.length, s.getResultPoints(), $2be8636d379871d6$var$nt.UPC_A);
                        return d.putAllMetadata(s.getResultMetadata()), d;
                    }
                    return s;
                } catch (t) {}
            }
        } catch (t) {
            n = {
                error: t
            };
        } finally{
            try {
                a && !a.done && (o = i.return) && o.call(i);
            } finally{
                if (n) throw n.error;
            }
        }
        throw new $2be8636d379871d6$var$U();
    }, e.prototype.reset = function() {
        var t, e;
        try {
            for(var r = $2be8636d379871d6$var$he(this.readers), n = r.next(); !n.done; n = r.next())n.value.reset();
        } catch (e) {
            t = {
                error: e
            };
        } finally{
            try {
                n && !n.done && (e = r.return) && e.call(r);
            } finally{
                if (t) throw t.error;
            }
        }
    }, e;
}($2be8636d379871d6$var$Lt), $2be8636d379871d6$var$de = function() {
    var t = function(e, r) {
        return t = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(t, e) {
            t.__proto__ = e;
        } || function(t, e) {
            for(var r in e)e.hasOwnProperty(r) && (t[r] = e[r]);
        }, t(e, r);
    };
    return function(e, r) {
        function n() {
            this.constructor = e;
        }
        t(e, r), e.prototype = null === r ? Object.create(r) : (n.prototype = r.prototype, new n());
    };
}(), $2be8636d379871d6$var$pe = function(t) {
    var e = "function" == typeof Symbol && Symbol.iterator, r = e && t[e], n = 0;
    if (r) return r.call(t);
    if (t && "number" == typeof t.length) return {
        next: function() {
            return t && n >= t.length && (t = void 0), {
                value: t && t[n++],
                done: !t
            };
        }
    };
    throw new TypeError(e ? "Object is not iterable." : "Symbol.iterator is not defined.");
}, $2be8636d379871d6$var$ge = function(t) {
    function e() {
        var e = t.call(this) || this;
        return e.decodeFinderCounters = new Int32Array(4), e.dataCharacterCounters = new Int32Array(8), e.oddRoundingErrors = new Array(4), e.evenRoundingErrors = new Array(4), e.oddCounts = new Array(e.dataCharacterCounters.length / 2), e.evenCounts = new Array(e.dataCharacterCounters.length / 2), e;
    }
    return $2be8636d379871d6$var$de(e, t), e.prototype.getDecodeFinderCounters = function() {
        return this.decodeFinderCounters;
    }, e.prototype.getDataCharacterCounters = function() {
        return this.dataCharacterCounters;
    }, e.prototype.getOddRoundingErrors = function() {
        return this.oddRoundingErrors;
    }, e.prototype.getEvenRoundingErrors = function() {
        return this.evenRoundingErrors;
    }, e.prototype.getOddCounts = function() {
        return this.oddCounts;
    }, e.prototype.getEvenCounts = function() {
        return this.evenCounts;
    }, e.prototype.parseFinderValue = function(t, r) {
        for(var n = 0; n < r.length; n++)if ($2be8636d379871d6$var$Lt.patternMatchVariance(t, r[n], e.MAX_INDIVIDUAL_VARIANCE) < e.MAX_AVG_VARIANCE) return n;
        throw new $2be8636d379871d6$var$U();
    }, e.count = function(t) {
        return $2be8636d379871d6$var$vt.sum(new Int32Array(t));
    }, e.increment = function(t, e) {
        for(var r = 0, n = e[0], o = 1; o < t.length; o++)e[o] > n && (n = e[o], r = o);
        t[r]++;
    }, e.decrement = function(t, e) {
        for(var r = 0, n = e[0], o = 1; o < t.length; o++)e[o] < n && (n = e[o], r = o);
        t[r]--;
    }, e.isFinderPattern = function(t) {
        var r, n, o = t[0] + t[1], i = o / (o + t[2] + t[3]);
        if (i >= e.MIN_FINDER_PATTERN_RATIO && i <= e.MAX_FINDER_PATTERN_RATIO) {
            var a = Number.MAX_SAFE_INTEGER, u = Number.MIN_SAFE_INTEGER;
            try {
                for(var s = $2be8636d379871d6$var$pe(t), c = s.next(); !c.done; c = s.next()){
                    var f = c.value;
                    f > u && (u = f), f < a && (a = f);
                }
            } catch (t) {
                r = {
                    error: t
                };
            } finally{
                try {
                    c && !c.done && (n = s.return) && n.call(s);
                } finally{
                    if (r) throw r.error;
                }
            }
            return u < 10 * a;
        }
        return !1;
    }, e.MAX_AVG_VARIANCE = 0.2, e.MAX_INDIVIDUAL_VARIANCE = 0.45, e.MIN_FINDER_PATTERN_RATIO = 9.5 / 12, e.MAX_FINDER_PATTERN_RATIO = 12.5 / 14, e;
}($2be8636d379871d6$var$Lt), $2be8636d379871d6$var$ye = function() {
    function t(t, e) {
        this.value = t, this.checksumPortion = e;
    }
    return t.prototype.getValue = function() {
        return this.value;
    }, t.prototype.getChecksumPortion = function() {
        return this.checksumPortion;
    }, t.prototype.toString = function() {
        return this.value + "(" + this.checksumPortion + ")";
    }, t.prototype.equals = function(e) {
        if (!(e instanceof t)) return !1;
        var r = e;
        return this.value === r.value && this.checksumPortion === r.checksumPortion;
    }, t.prototype.hashCode = function() {
        return this.value ^ this.checksumPortion;
    }, t;
}(), $2be8636d379871d6$var$we = function() {
    function t(t, e, r, n, o) {
        this.value = t, this.startEnd = e, this.value = t, this.startEnd = e, this.resultPoints = new Array(), this.resultPoints.push(new $2be8636d379871d6$var$At(r, o)), this.resultPoints.push(new $2be8636d379871d6$var$At(n, o));
    }
    return t.prototype.getValue = function() {
        return this.value;
    }, t.prototype.getStartEnd = function() {
        return this.startEnd;
    }, t.prototype.getResultPoints = function() {
        return this.resultPoints;
    }, t.prototype.equals = function(e) {
        if (!(e instanceof t)) return !1;
        var r = e;
        return this.value === r.value;
    }, t.prototype.hashCode = function() {
        return this.value;
    }, t;
}(), $2be8636d379871d6$var$_e = function(t) {
    var e = "function" == typeof Symbol && Symbol.iterator, r = e && t[e], n = 0;
    if (r) return r.call(t);
    if (t && "number" == typeof t.length) return {
        next: function() {
            return t && n >= t.length && (t = void 0), {
                value: t && t[n++],
                done: !t
            };
        }
    };
    throw new TypeError(e ? "Object is not iterable." : "Symbol.iterator is not defined.");
}, $2be8636d379871d6$var$ve = function() {
    function t() {}
    return t.getRSSvalue = function(e, r, n) {
        var o, i, a = 0;
        try {
            for(var u = $2be8636d379871d6$var$_e(e), s = u.next(); !s.done; s = u.next())a += s.value;
        } catch (t) {
            o = {
                error: t
            };
        } finally{
            try {
                s && !s.done && (i = u.return) && i.call(u);
            } finally{
                if (o) throw o.error;
            }
        }
        for(var c = 0, f = 0, h = e.length, l = 0; l < h - 1; l++){
            var d = void 0;
            for(d = 1, f |= 1 << l; d < e[l]; d++, f &= ~(1 << l)){
                var p = t.combins(a - d - 1, h - l - 2);
                if (n && 0 === f && a - d - (h - l - 1) >= h - l - 1 && (p -= t.combins(a - d - (h - l), h - l - 2)), h - l - 1 > 1) {
                    for(var g = 0, y = a - d - (h - l - 2); y > r; y--)g += t.combins(a - d - y - 1, h - l - 3);
                    p -= g * (h - 1 - l);
                } else a - d > r && p--;
                c += p;
            }
            a -= d;
        }
        return c;
    }, t.combins = function(t, e) {
        var r, n;
        t - e > e ? (n = e, r = t - e) : (n = t - e, r = e);
        for(var o = 1, i = 1, a = t; a > r; a--)o *= a, i <= n && (o /= i, i++);
        for(; i <= n;)o /= i, i++;
        return o;
    }, t;
}(), $2be8636d379871d6$var$me = function() {
    function t() {}
    return t.buildBitArray = function(t) {
        var e = 2 * t.length - 1;
        null == t[t.length - 1].getRightChar() && (e -= 1);
        for(var r = new $2be8636d379871d6$var$S(12 * e), n = 0, o = t[0].getRightChar().getValue(), i = 11; i >= 0; --i)0 != (o & 1 << i) && r.set(n), n++;
        for(i = 1; i < t.length; ++i){
            for(var a = t[i], u = a.getLeftChar().getValue(), s = 11; s >= 0; --s)0 != (u & 1 << s) && r.set(n), n++;
            if (null != a.getRightChar()) {
                var c = a.getRightChar().getValue();
                for(s = 11; s >= 0; --s)0 != (c & 1 << s) && r.set(n), n++;
            }
        }
        return r;
    }, t;
}(), $2be8636d379871d6$var$Ae = function() {
    function t(t, e) {
        e ? this.decodedInformation = null : (this.finished = t, this.decodedInformation = e);
    }
    return t.prototype.getDecodedInformation = function() {
        return this.decodedInformation;
    }, t.prototype.isFinished = function() {
        return this.finished;
    }, t;
}(), $2be8636d379871d6$var$Ee = function() {
    function t(t) {
        this.newPosition = t;
    }
    return t.prototype.getNewPosition = function() {
        return this.newPosition;
    }, t;
}(), $2be8636d379871d6$var$Ce = function() {
    var t = function(e, r) {
        return t = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(t, e) {
            t.__proto__ = e;
        } || function(t, e) {
            for(var r in e)e.hasOwnProperty(r) && (t[r] = e[r]);
        }, t(e, r);
    };
    return function(e, r) {
        function n() {
            this.constructor = e;
        }
        t(e, r), e.prototype = null === r ? Object.create(r) : (n.prototype = r.prototype, new n());
    };
}(), $2be8636d379871d6$var$Ie = function(t) {
    function e(e, r) {
        var n = t.call(this, e) || this;
        return n.value = r, n;
    }
    return $2be8636d379871d6$var$Ce(e, t), e.prototype.getValue = function() {
        return this.value;
    }, e.prototype.isFNC1 = function() {
        return this.value === e.FNC1;
    }, e.FNC1 = "$", e;
}($2be8636d379871d6$var$Ee), $2be8636d379871d6$var$Se = function() {
    var t = function(e, r) {
        return t = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(t, e) {
            t.__proto__ = e;
        } || function(t, e) {
            for(var r in e)e.hasOwnProperty(r) && (t[r] = e[r]);
        }, t(e, r);
    };
    return function(e, r) {
        function n() {
            this.constructor = e;
        }
        t(e, r), e.prototype = null === r ? Object.create(r) : (n.prototype = r.prototype, new n());
    };
}(), $2be8636d379871d6$var$Oe = function(t) {
    function e(e, r, n) {
        var o = t.call(this, e) || this;
        return n ? (o.remaining = !0, o.remainingValue = o.remainingValue) : (o.remaining = !1, o.remainingValue = 0), o.newString = r, o;
    }
    return $2be8636d379871d6$var$Se(e, t), e.prototype.getNewString = function() {
        return this.newString;
    }, e.prototype.isRemaining = function() {
        return this.remaining;
    }, e.prototype.getRemainingValue = function() {
        return this.remainingValue;
    }, e;
}($2be8636d379871d6$var$Ee), $2be8636d379871d6$var$Te = function() {
    var t = function(e, r) {
        return t = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(t, e) {
            t.__proto__ = e;
        } || function(t, e) {
            for(var r in e)e.hasOwnProperty(r) && (t[r] = e[r]);
        }, t(e, r);
    };
    return function(e, r) {
        function n() {
            this.constructor = e;
        }
        t(e, r), e.prototype = null === r ? Object.create(r) : (n.prototype = r.prototype, new n());
    };
}(), $2be8636d379871d6$var$be = function(t) {
    function e(e, r, n) {
        var o = t.call(this, e) || this;
        if (r < 0 || r > 10 || n < 0 || n > 10) throw new $2be8636d379871d6$var$R();
        return o.firstDigit = r, o.secondDigit = n, o;
    }
    return $2be8636d379871d6$var$Te(e, t), e.prototype.getFirstDigit = function() {
        return this.firstDigit;
    }, e.prototype.getSecondDigit = function() {
        return this.secondDigit;
    }, e.prototype.getValue = function() {
        return 10 * this.firstDigit + this.secondDigit;
    }, e.prototype.isFirstDigitFNC1 = function() {
        return this.firstDigit === e.FNC1;
    }, e.prototype.isSecondDigitFNC1 = function() {
        return this.secondDigit === e.FNC1;
    }, e.prototype.isAnyFNC1 = function() {
        return this.firstDigit === e.FNC1 || this.secondDigit === e.FNC1;
    }, e.FNC1 = 10, e;
}($2be8636d379871d6$var$Ee), $2be8636d379871d6$var$Re = function(t) {
    var e = "function" == typeof Symbol && Symbol.iterator, r = e && t[e], n = 0;
    if (r) return r.call(t);
    if (t && "number" == typeof t.length) return {
        next: function() {
            return t && n >= t.length && (t = void 0), {
                value: t && t[n++],
                done: !t
            };
        }
    };
    throw new TypeError(e ? "Object is not iterable." : "Symbol.iterator is not defined.");
}, $2be8636d379871d6$var$Ne = function() {
    function t() {}
    return t.parseFieldsInGeneralPurpose = function(e) {
        var r, n, o, i, a, u, s, c;
        if (!e) return null;
        if (e.length < 2) throw new $2be8636d379871d6$var$U();
        var f = e.substring(0, 2);
        try {
            for(var h = $2be8636d379871d6$var$Re(t.TWO_DIGIT_DATA_LENGTH), l = h.next(); !l.done; l = h.next()){
                if ((A = l.value)[0] === f) return A[1] === t.VARIABLE_LENGTH ? t.processVariableAI(2, A[2], e) : t.processFixedAI(2, A[1], e);
            }
        } catch (t) {
            r = {
                error: t
            };
        } finally{
            try {
                l && !l.done && (n = h.return) && n.call(h);
            } finally{
                if (r) throw r.error;
            }
        }
        if (e.length < 3) throw new $2be8636d379871d6$var$U();
        var d = e.substring(0, 3);
        try {
            for(var p = $2be8636d379871d6$var$Re(t.THREE_DIGIT_DATA_LENGTH), g = p.next(); !g.done; g = p.next()){
                if ((A = g.value)[0] === d) return A[1] === t.VARIABLE_LENGTH ? t.processVariableAI(3, A[2], e) : t.processFixedAI(3, A[1], e);
            }
        } catch (t) {
            o = {
                error: t
            };
        } finally{
            try {
                g && !g.done && (i = p.return) && i.call(p);
            } finally{
                if (o) throw o.error;
            }
        }
        try {
            for(var y = $2be8636d379871d6$var$Re(t.THREE_DIGIT_PLUS_DIGIT_DATA_LENGTH), w = y.next(); !w.done; w = y.next()){
                if ((A = w.value)[0] === d) return A[1] === t.VARIABLE_LENGTH ? t.processVariableAI(4, A[2], e) : t.processFixedAI(4, A[1], e);
            }
        } catch (t) {
            a = {
                error: t
            };
        } finally{
            try {
                w && !w.done && (u = y.return) && u.call(y);
            } finally{
                if (a) throw a.error;
            }
        }
        if (e.length < 4) throw new $2be8636d379871d6$var$U();
        var _ = e.substring(0, 4);
        try {
            for(var v = $2be8636d379871d6$var$Re(t.FOUR_DIGIT_DATA_LENGTH), m = v.next(); !m.done; m = v.next()){
                var A;
                if ((A = m.value)[0] === _) return A[1] === t.VARIABLE_LENGTH ? t.processVariableAI(4, A[2], e) : t.processFixedAI(4, A[1], e);
            }
        } catch (t) {
            s = {
                error: t
            };
        } finally{
            try {
                m && !m.done && (c = v.return) && c.call(v);
            } finally{
                if (s) throw s.error;
            }
        }
        throw new $2be8636d379871d6$var$U();
    }, t.processFixedAI = function(e, r, n) {
        if (n.length < e) throw new $2be8636d379871d6$var$U();
        var o = n.substring(0, e);
        if (n.length < e + r) throw new $2be8636d379871d6$var$U();
        var i = n.substring(e, e + r), a = n.substring(e + r), u = "(" + o + ")" + i, s = t.parseFieldsInGeneralPurpose(a);
        return null == s ? u : u + s;
    }, t.processVariableAI = function(e, r, n) {
        var o, i = n.substring(0, e);
        o = n.length < e + r ? n.length : e + r;
        var a = n.substring(e, o), u = n.substring(o), s = "(" + i + ")" + a, c = t.parseFieldsInGeneralPurpose(u);
        return null == c ? s : s + c;
    }, t.VARIABLE_LENGTH = [], t.TWO_DIGIT_DATA_LENGTH = [
        [
            "00",
            18
        ],
        [
            "01",
            14
        ],
        [
            "02",
            14
        ],
        [
            "10",
            t.VARIABLE_LENGTH,
            20
        ],
        [
            "11",
            6
        ],
        [
            "12",
            6
        ],
        [
            "13",
            6
        ],
        [
            "15",
            6
        ],
        [
            "17",
            6
        ],
        [
            "20",
            2
        ],
        [
            "21",
            t.VARIABLE_LENGTH,
            20
        ],
        [
            "22",
            t.VARIABLE_LENGTH,
            29
        ],
        [
            "30",
            t.VARIABLE_LENGTH,
            8
        ],
        [
            "37",
            t.VARIABLE_LENGTH,
            8
        ],
        [
            "90",
            t.VARIABLE_LENGTH,
            30
        ],
        [
            "91",
            t.VARIABLE_LENGTH,
            30
        ],
        [
            "92",
            t.VARIABLE_LENGTH,
            30
        ],
        [
            "93",
            t.VARIABLE_LENGTH,
            30
        ],
        [
            "94",
            t.VARIABLE_LENGTH,
            30
        ],
        [
            "95",
            t.VARIABLE_LENGTH,
            30
        ],
        [
            "96",
            t.VARIABLE_LENGTH,
            30
        ],
        [
            "97",
            t.VARIABLE_LENGTH,
            3
        ],
        [
            "98",
            t.VARIABLE_LENGTH,
            30
        ],
        [
            "99",
            t.VARIABLE_LENGTH,
            30
        ]
    ], t.THREE_DIGIT_DATA_LENGTH = [
        [
            "240",
            t.VARIABLE_LENGTH,
            30
        ],
        [
            "241",
            t.VARIABLE_LENGTH,
            30
        ],
        [
            "242",
            t.VARIABLE_LENGTH,
            6
        ],
        [
            "250",
            t.VARIABLE_LENGTH,
            30
        ],
        [
            "251",
            t.VARIABLE_LENGTH,
            30
        ],
        [
            "253",
            t.VARIABLE_LENGTH,
            17
        ],
        [
            "254",
            t.VARIABLE_LENGTH,
            20
        ],
        [
            "400",
            t.VARIABLE_LENGTH,
            30
        ],
        [
            "401",
            t.VARIABLE_LENGTH,
            30
        ],
        [
            "402",
            17
        ],
        [
            "403",
            t.VARIABLE_LENGTH,
            30
        ],
        [
            "410",
            13
        ],
        [
            "411",
            13
        ],
        [
            "412",
            13
        ],
        [
            "413",
            13
        ],
        [
            "414",
            13
        ],
        [
            "420",
            t.VARIABLE_LENGTH,
            20
        ],
        [
            "421",
            t.VARIABLE_LENGTH,
            15
        ],
        [
            "422",
            3
        ],
        [
            "423",
            t.VARIABLE_LENGTH,
            15
        ],
        [
            "424",
            3
        ],
        [
            "425",
            3
        ],
        [
            "426",
            3
        ]
    ], t.THREE_DIGIT_PLUS_DIGIT_DATA_LENGTH = [
        [
            "310",
            6
        ],
        [
            "311",
            6
        ],
        [
            "312",
            6
        ],
        [
            "313",
            6
        ],
        [
            "314",
            6
        ],
        [
            "315",
            6
        ],
        [
            "316",
            6
        ],
        [
            "320",
            6
        ],
        [
            "321",
            6
        ],
        [
            "322",
            6
        ],
        [
            "323",
            6
        ],
        [
            "324",
            6
        ],
        [
            "325",
            6
        ],
        [
            "326",
            6
        ],
        [
            "327",
            6
        ],
        [
            "328",
            6
        ],
        [
            "329",
            6
        ],
        [
            "330",
            6
        ],
        [
            "331",
            6
        ],
        [
            "332",
            6
        ],
        [
            "333",
            6
        ],
        [
            "334",
            6
        ],
        [
            "335",
            6
        ],
        [
            "336",
            6
        ],
        [
            "340",
            6
        ],
        [
            "341",
            6
        ],
        [
            "342",
            6
        ],
        [
            "343",
            6
        ],
        [
            "344",
            6
        ],
        [
            "345",
            6
        ],
        [
            "346",
            6
        ],
        [
            "347",
            6
        ],
        [
            "348",
            6
        ],
        [
            "349",
            6
        ],
        [
            "350",
            6
        ],
        [
            "351",
            6
        ],
        [
            "352",
            6
        ],
        [
            "353",
            6
        ],
        [
            "354",
            6
        ],
        [
            "355",
            6
        ],
        [
            "356",
            6
        ],
        [
            "357",
            6
        ],
        [
            "360",
            6
        ],
        [
            "361",
            6
        ],
        [
            "362",
            6
        ],
        [
            "363",
            6
        ],
        [
            "364",
            6
        ],
        [
            "365",
            6
        ],
        [
            "366",
            6
        ],
        [
            "367",
            6
        ],
        [
            "368",
            6
        ],
        [
            "369",
            6
        ],
        [
            "390",
            t.VARIABLE_LENGTH,
            15
        ],
        [
            "391",
            t.VARIABLE_LENGTH,
            18
        ],
        [
            "392",
            t.VARIABLE_LENGTH,
            15
        ],
        [
            "393",
            t.VARIABLE_LENGTH,
            18
        ],
        [
            "703",
            t.VARIABLE_LENGTH,
            30
        ]
    ], t.FOUR_DIGIT_DATA_LENGTH = [
        [
            "7001",
            13
        ],
        [
            "7002",
            t.VARIABLE_LENGTH,
            30
        ],
        [
            "7003",
            10
        ],
        [
            "8001",
            14
        ],
        [
            "8002",
            t.VARIABLE_LENGTH,
            20
        ],
        [
            "8003",
            t.VARIABLE_LENGTH,
            30
        ],
        [
            "8004",
            t.VARIABLE_LENGTH,
            30
        ],
        [
            "8005",
            6
        ],
        [
            "8006",
            18
        ],
        [
            "8007",
            t.VARIABLE_LENGTH,
            30
        ],
        [
            "8008",
            t.VARIABLE_LENGTH,
            12
        ],
        [
            "8018",
            18
        ],
        [
            "8020",
            t.VARIABLE_LENGTH,
            25
        ],
        [
            "8100",
            6
        ],
        [
            "8101",
            10
        ],
        [
            "8102",
            2
        ],
        [
            "8110",
            t.VARIABLE_LENGTH,
            70
        ],
        [
            "8200",
            t.VARIABLE_LENGTH,
            70
        ]
    ], t;
}(), $2be8636d379871d6$var$De = function() {
    function t(t) {
        this.buffer = new $2be8636d379871d6$var$k(), this.information = t;
    }
    return t.prototype.decodeAllCodes = function(t, e) {
        for(var r = e, n = null;;){
            var o = this.decodeGeneralPurposeField(r, n), i = $2be8636d379871d6$var$Ne.parseFieldsInGeneralPurpose(o.getNewString());
            if (null != i && t.append(i), n = o.isRemaining() ? "" + o.getRemainingValue() : null, r === o.getNewPosition()) break;
            r = o.getNewPosition();
        }
        return t.toString();
    }, t.prototype.isStillNumeric = function(t) {
        if (t + 7 > this.information.getSize()) return t + 4 <= this.information.getSize();
        for(var e = t; e < t + 3; ++e)if (this.information.get(e)) return !0;
        return this.information.get(t + 3);
    }, t.prototype.decodeNumeric = function(t) {
        if (t + 7 > this.information.getSize()) {
            var e = this.extractNumericValueFromBitArray(t, 4);
            return new $2be8636d379871d6$var$be(this.information.getSize(), 0 === e ? $2be8636d379871d6$var$be.FNC1 : e - 1, $2be8636d379871d6$var$be.FNC1);
        }
        var r = this.extractNumericValueFromBitArray(t, 7);
        return new $2be8636d379871d6$var$be(t + 7, (r - 8) / 11, (r - 8) % 11);
    }, t.prototype.extractNumericValueFromBitArray = function(e, r) {
        return t.extractNumericValueFromBitArray(this.information, e, r);
    }, t.extractNumericValueFromBitArray = function(t, e, r) {
        for(var n = 0, o = 0; o < r; ++o)t.get(e + o) && (n |= 1 << r - o - 1);
        return n;
    }, t.prototype.decodeGeneralPurposeField = function(t, e) {
        this.buffer.setLengthToZero(), null != e && this.buffer.append(e), this.current.setPosition(t);
        var r = this.parseBlocks();
        return null != r && r.isRemaining() ? new $2be8636d379871d6$var$Oe(this.current.getPosition(), this.buffer.toString(), r.getRemainingValue()) : new $2be8636d379871d6$var$Oe(this.current.getPosition(), this.buffer.toString());
    }, t.prototype.parseBlocks = function() {
        var t, e;
        do {
            var r = this.current.getPosition();
            if (t = this.current.isAlpha() ? (e = this.parseAlphaBlock()).isFinished() : this.current.isIsoIec646() ? (e = this.parseIsoIec646Block()).isFinished() : (e = this.parseNumericBlock()).isFinished(), !(r !== this.current.getPosition()) && !t) break;
        }while (!t);
        return e.getDecodedInformation();
    }, t.prototype.parseNumericBlock = function() {
        for(; this.isStillNumeric(this.current.getPosition());){
            var t = this.decodeNumeric(this.current.getPosition());
            if (this.current.setPosition(t.getNewPosition()), t.isFirstDigitFNC1()) {
                var e = void 0;
                return e = t.isSecondDigitFNC1() ? new $2be8636d379871d6$var$Oe(this.current.getPosition(), this.buffer.toString()) : new $2be8636d379871d6$var$Oe(this.current.getPosition(), this.buffer.toString(), t.getSecondDigit()), new $2be8636d379871d6$var$Ae(!0, e);
            }
            if (this.buffer.append(t.getFirstDigit()), t.isSecondDigitFNC1()) {
                e = new $2be8636d379871d6$var$Oe(this.current.getPosition(), this.buffer.toString());
                return new $2be8636d379871d6$var$Ae(!0, e);
            }
            this.buffer.append(t.getSecondDigit());
        }
        return this.isNumericToAlphaNumericLatch(this.current.getPosition()) && (this.current.setAlpha(), this.current.incrementPosition(4)), new $2be8636d379871d6$var$Ae(!1);
    }, t.prototype.parseIsoIec646Block = function() {
        for(; this.isStillIsoIec646(this.current.getPosition());){
            var t = this.decodeIsoIec646(this.current.getPosition());
            if (this.current.setPosition(t.getNewPosition()), t.isFNC1()) {
                var e = new $2be8636d379871d6$var$Oe(this.current.getPosition(), this.buffer.toString());
                return new $2be8636d379871d6$var$Ae(!0, e);
            }
            this.buffer.append(t.getValue());
        }
        return this.isAlphaOr646ToNumericLatch(this.current.getPosition()) ? (this.current.incrementPosition(3), this.current.setNumeric()) : this.isAlphaTo646ToAlphaLatch(this.current.getPosition()) && (this.current.getPosition() + 5 < this.information.getSize() ? this.current.incrementPosition(5) : this.current.setPosition(this.information.getSize()), this.current.setAlpha()), new $2be8636d379871d6$var$Ae(!1);
    }, t.prototype.parseAlphaBlock = function() {
        for(; this.isStillAlpha(this.current.getPosition());){
            var t = this.decodeAlphanumeric(this.current.getPosition());
            if (this.current.setPosition(t.getNewPosition()), t.isFNC1()) {
                var e = new $2be8636d379871d6$var$Oe(this.current.getPosition(), this.buffer.toString());
                return new $2be8636d379871d6$var$Ae(!0, e);
            }
            this.buffer.append(t.getValue());
        }
        return this.isAlphaOr646ToNumericLatch(this.current.getPosition()) ? (this.current.incrementPosition(3), this.current.setNumeric()) : this.isAlphaTo646ToAlphaLatch(this.current.getPosition()) && (this.current.getPosition() + 5 < this.information.getSize() ? this.current.incrementPosition(5) : this.current.setPosition(this.information.getSize()), this.current.setIsoIec646()), new $2be8636d379871d6$var$Ae(!1);
    }, t.prototype.isStillIsoIec646 = function(t) {
        if (t + 5 > this.information.getSize()) return !1;
        var e = this.extractNumericValueFromBitArray(t, 5);
        if (e >= 5 && e < 16) return !0;
        if (t + 7 > this.information.getSize()) return !1;
        var r = this.extractNumericValueFromBitArray(t, 7);
        if (r >= 64 && r < 116) return !0;
        if (t + 8 > this.information.getSize()) return !1;
        var n = this.extractNumericValueFromBitArray(t, 8);
        return n >= 232 && n < 253;
    }, t.prototype.decodeIsoIec646 = function(t) {
        var e = this.extractNumericValueFromBitArray(t, 5);
        if (15 === e) return new $2be8636d379871d6$var$Ie(t + 5, $2be8636d379871d6$var$Ie.FNC1);
        if (e >= 5 && e < 15) return new $2be8636d379871d6$var$Ie(t + 5, "0" + (e - 5));
        var r, n = this.extractNumericValueFromBitArray(t, 7);
        if (n >= 64 && n < 90) return new $2be8636d379871d6$var$Ie(t + 7, "" + (n + 1));
        if (n >= 90 && n < 116) return new $2be8636d379871d6$var$Ie(t + 7, "" + (n + 7));
        switch(this.extractNumericValueFromBitArray(t, 8)){
            case 232:
                r = "!";
                break;
            case 233:
                r = '"';
                break;
            case 234:
                r = "%";
                break;
            case 235:
                r = "&";
                break;
            case 236:
                r = "'";
                break;
            case 237:
                r = "(";
                break;
            case 238:
                r = ")";
                break;
            case 239:
                r = "*";
                break;
            case 240:
                r = "+";
                break;
            case 241:
                r = ",";
                break;
            case 242:
                r = "-";
                break;
            case 243:
                r = ".";
                break;
            case 244:
                r = "/";
                break;
            case 245:
                r = ":";
                break;
            case 246:
                r = ";";
                break;
            case 247:
                r = "<";
                break;
            case 248:
                r = "=";
                break;
            case 249:
                r = ">";
                break;
            case 250:
                r = "?";
                break;
            case 251:
                r = "_";
                break;
            case 252:
                r = " ";
                break;
            default:
                throw new $2be8636d379871d6$var$R();
        }
        return new $2be8636d379871d6$var$Ie(t + 8, r);
    }, t.prototype.isStillAlpha = function(t) {
        if (t + 5 > this.information.getSize()) return !1;
        var e = this.extractNumericValueFromBitArray(t, 5);
        if (e >= 5 && e < 16) return !0;
        if (t + 6 > this.information.getSize()) return !1;
        var r = this.extractNumericValueFromBitArray(t, 6);
        return r >= 16 && r < 63;
    }, t.prototype.decodeAlphanumeric = function(t) {
        var e = this.extractNumericValueFromBitArray(t, 5);
        if (15 === e) return new $2be8636d379871d6$var$Ie(t + 5, $2be8636d379871d6$var$Ie.FNC1);
        if (e >= 5 && e < 15) return new $2be8636d379871d6$var$Ie(t + 5, "0" + (e - 5));
        var r, n = this.extractNumericValueFromBitArray(t, 6);
        if (n >= 32 && n < 58) return new $2be8636d379871d6$var$Ie(t + 6, "" + (n + 33));
        switch(n){
            case 58:
                r = "*";
                break;
            case 59:
                r = ",";
                break;
            case 60:
                r = "-";
                break;
            case 61:
                r = ".";
                break;
            case 62:
                r = "/";
                break;
            default:
                throw new $2be8636d379871d6$var$yt("Decoding invalid alphanumeric value: " + n);
        }
        return new $2be8636d379871d6$var$Ie(t + 6, r);
    }, t.prototype.isAlphaTo646ToAlphaLatch = function(t) {
        if (t + 1 > this.information.getSize()) return !1;
        for(var e = 0; e < 5 && e + t < this.information.getSize(); ++e)if (2 === e) {
            if (!this.information.get(t + 2)) return !1;
        } else if (this.information.get(t + e)) return !1;
        return !0;
    }, t.prototype.isAlphaOr646ToNumericLatch = function(t) {
        if (t + 3 > this.information.getSize()) return !1;
        for(var e = t; e < t + 3; ++e)if (this.information.get(e)) return !1;
        return !0;
    }, t.prototype.isNumericToAlphaNumericLatch = function(t) {
        if (t + 1 > this.information.getSize()) return !1;
        for(var e = 0; e < 4 && e + t < this.information.getSize(); ++e)if (this.information.get(t + e)) return !1;
        return !0;
    }, t;
}(), $2be8636d379871d6$var$Pe = function() {
    function t(t) {
        this.information = t, this.generalDecoder = new $2be8636d379871d6$var$De(t);
    }
    return t.prototype.getInformation = function() {
        return this.information;
    }, t.prototype.getGeneralDecoder = function() {
        return this.generalDecoder;
    }, t;
}(), $2be8636d379871d6$var$Me = function() {
    var t = function(e, r) {
        return t = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(t, e) {
            t.__proto__ = e;
        } || function(t, e) {
            for(var r in e)e.hasOwnProperty(r) && (t[r] = e[r]);
        }, t(e, r);
    };
    return function(e, r) {
        function n() {
            this.constructor = e;
        }
        t(e, r), e.prototype = null === r ? Object.create(r) : (n.prototype = r.prototype, new n());
    };
}(), $2be8636d379871d6$var$Be = function(t) {
    function e(e) {
        return t.call(this, e) || this;
    }
    return $2be8636d379871d6$var$Me(e, t), e.prototype.encodeCompressedGtin = function(t, e) {
        t.append("(01)");
        var r = t.length();
        t.append("9"), this.encodeCompressedGtinWithoutAI(t, e, r);
    }, e.prototype.encodeCompressedGtinWithoutAI = function(t, r, n) {
        for(var o = 0; o < 4; ++o){
            var i = this.getGeneralDecoder().extractNumericValueFromBitArray(r + 10 * o, 10);
            i / 100 == 0 && t.append("0"), i / 10 == 0 && t.append("0"), t.append(i);
        }
        e.appendCheckDigit(t, n);
    }, e.appendCheckDigit = function(t, e) {
        for(var r = 0, n = 0; n < 13; n++){
            var o = t.charAt(n + e).charCodeAt(0) - "0".charCodeAt(0);
            r += 0 == (1 & n) ? 3 * o : o;
        }
        10 === (r = 10 - r % 10) && (r = 0), t.append(r);
    }, e.GTIN_SIZE = 40, e;
}($2be8636d379871d6$var$Pe), $2be8636d379871d6$var$Le = function() {
    var t = function(e, r) {
        return t = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(t, e) {
            t.__proto__ = e;
        } || function(t, e) {
            for(var r in e)e.hasOwnProperty(r) && (t[r] = e[r]);
        }, t(e, r);
    };
    return function(e, r) {
        function n() {
            this.constructor = e;
        }
        t(e, r), e.prototype = null === r ? Object.create(r) : (n.prototype = r.prototype, new n());
    };
}(), $2be8636d379871d6$var$Fe = function(t) {
    function e(e) {
        return t.call(this, e) || this;
    }
    return $2be8636d379871d6$var$Le(e, t), e.prototype.parseInformation = function() {
        var t = new $2be8636d379871d6$var$k();
        t.append("(01)");
        var r = t.length(), n = this.getGeneralDecoder().extractNumericValueFromBitArray(e.HEADER_SIZE, 4);
        return t.append(n), this.encodeCompressedGtinWithoutAI(t, e.HEADER_SIZE + 4, r), this.getGeneralDecoder().decodeAllCodes(t, e.HEADER_SIZE + 44);
    }, e.HEADER_SIZE = 4, e;
}($2be8636d379871d6$var$Be), $2be8636d379871d6$var$ke = function() {
    var t = function(e, r) {
        return t = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(t, e) {
            t.__proto__ = e;
        } || function(t, e) {
            for(var r in e)e.hasOwnProperty(r) && (t[r] = e[r]);
        }, t(e, r);
    };
    return function(e, r) {
        function n() {
            this.constructor = e;
        }
        t(e, r), e.prototype = null === r ? Object.create(r) : (n.prototype = r.prototype, new n());
    };
}(), $2be8636d379871d6$var$xe = function(t) {
    function e(e) {
        return t.call(this, e) || this;
    }
    return $2be8636d379871d6$var$ke(e, t), e.prototype.parseInformation = function() {
        var t = new $2be8636d379871d6$var$k();
        return this.getGeneralDecoder().decodeAllCodes(t, e.HEADER_SIZE);
    }, e.HEADER_SIZE = 5, e;
}($2be8636d379871d6$var$Pe), $2be8636d379871d6$var$Ve = function() {
    var t = function(e, r) {
        return t = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(t, e) {
            t.__proto__ = e;
        } || function(t, e) {
            for(var r in e)e.hasOwnProperty(r) && (t[r] = e[r]);
        }, t(e, r);
    };
    return function(e, r) {
        function n() {
            this.constructor = e;
        }
        t(e, r), e.prototype = null === r ? Object.create(r) : (n.prototype = r.prototype, new n());
    };
}(), $2be8636d379871d6$var$Ue = function(t) {
    function e(e) {
        return t.call(this, e) || this;
    }
    return $2be8636d379871d6$var$Ve(e, t), e.prototype.encodeCompressedWeight = function(t, e, r) {
        var n = this.getGeneralDecoder().extractNumericValueFromBitArray(e, r);
        this.addWeightCode(t, n);
        for(var o = this.checkWeight(n), i = 1e5, a = 0; a < 5; ++a)o / i == 0 && t.append("0"), i /= 10;
        t.append(o);
    }, e;
}($2be8636d379871d6$var$Be), $2be8636d379871d6$var$He = function() {
    var t = function(e, r) {
        return t = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(t, e) {
            t.__proto__ = e;
        } || function(t, e) {
            for(var r in e)e.hasOwnProperty(r) && (t[r] = e[r]);
        }, t(e, r);
    };
    return function(e, r) {
        function n() {
            this.constructor = e;
        }
        t(e, r), e.prototype = null === r ? Object.create(r) : (n.prototype = r.prototype, new n());
    };
}(), $2be8636d379871d6$var$Ge = function(t) {
    function e(e) {
        return t.call(this, e) || this;
    }
    return $2be8636d379871d6$var$He(e, t), e.prototype.parseInformation = function() {
        if (this.getInformation().getSize() != e.HEADER_SIZE + $2be8636d379871d6$var$Ue.GTIN_SIZE + e.WEIGHT_SIZE) throw new $2be8636d379871d6$var$U();
        var t = new $2be8636d379871d6$var$k();
        return this.encodeCompressedGtin(t, e.HEADER_SIZE), this.encodeCompressedWeight(t, e.HEADER_SIZE + $2be8636d379871d6$var$Ue.GTIN_SIZE, e.WEIGHT_SIZE), t.toString();
    }, e.HEADER_SIZE = 5, e.WEIGHT_SIZE = 15, e;
}($2be8636d379871d6$var$Ue), $2be8636d379871d6$var$Xe = function() {
    var t = function(e, r) {
        return t = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(t, e) {
            t.__proto__ = e;
        } || function(t, e) {
            for(var r in e)e.hasOwnProperty(r) && (t[r] = e[r]);
        }, t(e, r);
    };
    return function(e, r) {
        function n() {
            this.constructor = e;
        }
        t(e, r), e.prototype = null === r ? Object.create(r) : (n.prototype = r.prototype, new n());
    };
}(), $2be8636d379871d6$var$We = function(t) {
    function e(e) {
        return t.call(this, e) || this;
    }
    return $2be8636d379871d6$var$Xe(e, t), e.prototype.addWeightCode = function(t, e) {
        t.append("(3103)");
    }, e.prototype.checkWeight = function(t) {
        return t;
    }, e;
}($2be8636d379871d6$var$Ge), $2be8636d379871d6$var$je = function() {
    var t = function(e, r) {
        return t = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(t, e) {
            t.__proto__ = e;
        } || function(t, e) {
            for(var r in e)e.hasOwnProperty(r) && (t[r] = e[r]);
        }, t(e, r);
    };
    return function(e, r) {
        function n() {
            this.constructor = e;
        }
        t(e, r), e.prototype = null === r ? Object.create(r) : (n.prototype = r.prototype, new n());
    };
}(), $2be8636d379871d6$var$ze = function(t) {
    function e(e) {
        return t.call(this, e) || this;
    }
    return $2be8636d379871d6$var$je(e, t), e.prototype.addWeightCode = function(t, e) {
        e < 1e4 ? t.append("(3202)") : t.append("(3203)");
    }, e.prototype.checkWeight = function(t) {
        return t < 1e4 ? t : t - 1e4;
    }, e;
}($2be8636d379871d6$var$Ge), $2be8636d379871d6$var$Ye = function() {
    var t = function(e, r) {
        return t = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(t, e) {
            t.__proto__ = e;
        } || function(t, e) {
            for(var r in e)e.hasOwnProperty(r) && (t[r] = e[r]);
        }, t(e, r);
    };
    return function(e, r) {
        function n() {
            this.constructor = e;
        }
        t(e, r), e.prototype = null === r ? Object.create(r) : (n.prototype = r.prototype, new n());
    };
}(), $2be8636d379871d6$var$Ze = function(t) {
    function e(e) {
        return t.call(this, e) || this;
    }
    return $2be8636d379871d6$var$Ye(e, t), e.prototype.parseInformation = function() {
        if (this.getInformation().getSize() < e.HEADER_SIZE + $2be8636d379871d6$var$Be.GTIN_SIZE) throw new $2be8636d379871d6$var$U();
        var t = new $2be8636d379871d6$var$k();
        this.encodeCompressedGtin(t, e.HEADER_SIZE);
        var r = this.getGeneralDecoder().extractNumericValueFromBitArray(e.HEADER_SIZE + $2be8636d379871d6$var$Be.GTIN_SIZE, e.LAST_DIGIT_SIZE);
        t.append("(392"), t.append(r), t.append(")");
        var n = this.getGeneralDecoder().decodeGeneralPurposeField(e.HEADER_SIZE + $2be8636d379871d6$var$Be.GTIN_SIZE + e.LAST_DIGIT_SIZE, null);
        return t.append(n.getNewString()), t.toString();
    }, e.HEADER_SIZE = 8, e.LAST_DIGIT_SIZE = 2, e;
}($2be8636d379871d6$var$Be), $2be8636d379871d6$var$Ke = function() {
    var t = function(e, r) {
        return t = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(t, e) {
            t.__proto__ = e;
        } || function(t, e) {
            for(var r in e)e.hasOwnProperty(r) && (t[r] = e[r]);
        }, t(e, r);
    };
    return function(e, r) {
        function n() {
            this.constructor = e;
        }
        t(e, r), e.prototype = null === r ? Object.create(r) : (n.prototype = r.prototype, new n());
    };
}(), $2be8636d379871d6$var$qe = function(t) {
    function e(e) {
        return t.call(this, e) || this;
    }
    return $2be8636d379871d6$var$Ke(e, t), e.prototype.parseInformation = function() {
        if (this.getInformation().getSize() < e.HEADER_SIZE + $2be8636d379871d6$var$Be.GTIN_SIZE) throw new $2be8636d379871d6$var$U();
        var t = new $2be8636d379871d6$var$k();
        this.encodeCompressedGtin(t, e.HEADER_SIZE);
        var r = this.getGeneralDecoder().extractNumericValueFromBitArray(e.HEADER_SIZE + $2be8636d379871d6$var$Be.GTIN_SIZE, e.LAST_DIGIT_SIZE);
        t.append("(393"), t.append(r), t.append(")");
        var n = this.getGeneralDecoder().extractNumericValueFromBitArray(e.HEADER_SIZE + $2be8636d379871d6$var$Be.GTIN_SIZE + e.LAST_DIGIT_SIZE, e.FIRST_THREE_DIGITS_SIZE);
        n / 100 == 0 && t.append("0"), n / 10 == 0 && t.append("0"), t.append(n);
        var o = this.getGeneralDecoder().decodeGeneralPurposeField(e.HEADER_SIZE + $2be8636d379871d6$var$Be.GTIN_SIZE + e.LAST_DIGIT_SIZE + e.FIRST_THREE_DIGITS_SIZE, null);
        return t.append(o.getNewString()), t.toString();
    }, e.HEADER_SIZE = 8, e.LAST_DIGIT_SIZE = 2, e.FIRST_THREE_DIGITS_SIZE = 10, e;
}($2be8636d379871d6$var$Be), $2be8636d379871d6$var$Qe = function() {
    var t = function(e, r) {
        return t = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(t, e) {
            t.__proto__ = e;
        } || function(t, e) {
            for(var r in e)e.hasOwnProperty(r) && (t[r] = e[r]);
        }, t(e, r);
    };
    return function(e, r) {
        function n() {
            this.constructor = e;
        }
        t(e, r), e.prototype = null === r ? Object.create(r) : (n.prototype = r.prototype, new n());
    };
}(), $2be8636d379871d6$var$Je = function(t) {
    function e(e, r, n) {
        var o = t.call(this, e) || this;
        return o.dateCode = n, o.firstAIdigits = r, o;
    }
    return $2be8636d379871d6$var$Qe(e, t), e.prototype.parseInformation = function() {
        if (this.getInformation().getSize() != e.HEADER_SIZE + e.GTIN_SIZE + e.WEIGHT_SIZE + e.DATE_SIZE) throw new $2be8636d379871d6$var$U();
        var t = new $2be8636d379871d6$var$k();
        return this.encodeCompressedGtin(t, e.HEADER_SIZE), this.encodeCompressedWeight(t, e.HEADER_SIZE + e.GTIN_SIZE, e.WEIGHT_SIZE), this.encodeCompressedDate(t, e.HEADER_SIZE + e.GTIN_SIZE + e.WEIGHT_SIZE), t.toString();
    }, e.prototype.encodeCompressedDate = function(t, r) {
        var n = this.getGeneralDecoder().extractNumericValueFromBitArray(r, e.DATE_SIZE);
        if (38400 != n) {
            t.append("("), t.append(this.dateCode), t.append(")");
            var o = n % 32, i = (n /= 32) % 12 + 1, a = n /= 12;
            a / 10 == 0 && t.append("0"), t.append(a), i / 10 == 0 && t.append("0"), t.append(i), o / 10 == 0 && t.append("0"), t.append(o);
        }
    }, e.prototype.addWeightCode = function(t, e) {
        t.append("("), t.append(this.firstAIdigits), t.append(e / 1e5), t.append(")");
    }, e.prototype.checkWeight = function(t) {
        return t % 1e5;
    }, e.HEADER_SIZE = 8, e.WEIGHT_SIZE = 20, e.DATE_SIZE = 16, e;
}($2be8636d379871d6$var$Ue);
var $2be8636d379871d6$var$$e = function() {
    function t(t, e, r, n) {
        this.leftchar = t, this.rightchar = e, this.finderpattern = r, this.maybeLast = n;
    }
    return t.prototype.mayBeLast = function() {
        return this.maybeLast;
    }, t.prototype.getLeftChar = function() {
        return this.leftchar;
    }, t.prototype.getRightChar = function() {
        return this.rightchar;
    }, t.prototype.getFinderPattern = function() {
        return this.finderpattern;
    }, t.prototype.mustBeLast = function() {
        return null == this.rightchar;
    }, t.prototype.toString = function() {
        return "[ " + this.leftchar + ", " + this.rightchar + " : " + (null == this.finderpattern ? "null" : this.finderpattern.getValue()) + " ]";
    }, t.equals = function(e, r) {
        return e instanceof t && t.equalsOrNull(e.leftchar, r.leftchar) && t.equalsOrNull(e.rightchar, r.rightchar) && t.equalsOrNull(e.finderpattern, r.finderpattern);
    }, t.equalsOrNull = function(e, r) {
        return null === e ? null === r : t.equals(e, r);
    }, t.prototype.hashCode = function() {
        return this.leftchar.getValue() ^ this.rightchar.getValue() ^ this.finderpattern.getValue();
    }, t;
}(), $2be8636d379871d6$var$tr = function() {
    function t(t, e, r) {
        this.pairs = t, this.rowNumber = e, this.wasReversed = r;
    }
    return t.prototype.getPairs = function() {
        return this.pairs;
    }, t.prototype.getRowNumber = function() {
        return this.rowNumber;
    }, t.prototype.isReversed = function() {
        return this.wasReversed;
    }, t.prototype.isEquivalent = function(t) {
        return this.checkEqualitity(this, t);
    }, t.prototype.toString = function() {
        return "{ " + this.pairs + " }";
    }, t.prototype.equals = function(e, r) {
        return e instanceof t && this.checkEqualitity(e, r) && e.wasReversed === r.wasReversed;
    }, t.prototype.checkEqualitity = function(t, e) {
        var r;
        if (t && e) return t.forEach(function(t, n) {
            e.forEach(function(e) {
                t.getLeftChar().getValue() === e.getLeftChar().getValue() && t.getRightChar().getValue() === e.getRightChar().getValue() && t.getFinderPatter().getValue() === e.getFinderPatter().getValue() && (r = !0);
            });
        }), r;
    }, t;
}(), $2be8636d379871d6$var$er = function() {
    var t = function(e, r) {
        return t = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(t, e) {
            t.__proto__ = e;
        } || function(t, e) {
            for(var r in e)e.hasOwnProperty(r) && (t[r] = e[r]);
        }, t(e, r);
    };
    return function(e, r) {
        function n() {
            this.constructor = e;
        }
        t(e, r), e.prototype = null === r ? Object.create(r) : (n.prototype = r.prototype, new n());
    };
}(), $2be8636d379871d6$var$rr = function(t) {
    var e = "function" == typeof Symbol && Symbol.iterator, r = e && t[e], n = 0;
    if (r) return r.call(t);
    if (t && "number" == typeof t.length) return {
        next: function() {
            return t && n >= t.length && (t = void 0), {
                value: t && t[n++],
                done: !t
            };
        }
    };
    throw new TypeError(e ? "Object is not iterable." : "Symbol.iterator is not defined.");
}, $2be8636d379871d6$var$nr = function(t) {
    function e() {
        var r = null !== t && t.apply(this, arguments) || this;
        return r.pairs = new Array(e.MAX_PAIRS), r.rows = new Array(), r.startEnd = [
            2
        ], r;
    }
    return $2be8636d379871d6$var$er(e, t), e.prototype.decodeRow = function(t, r, n) {
        this.pairs.length = 0, this.startFromEven = !1;
        try {
            return e.constructResult(this.decodeRow2pairs(t, r));
        } catch (t) {}
        return this.pairs.length = 0, this.startFromEven = !0, e.constructResult(this.decodeRow2pairs(t, r));
    }, e.prototype.reset = function() {
        this.pairs.length = 0, this.rows.length = 0;
    }, e.prototype.decodeRow2pairs = function(t, e) {
        for(var r, n = !1; !n;)try {
            this.pairs.push(this.retrieveNextPair(e, this.pairs, t));
        } catch (t) {
            if (t instanceof $2be8636d379871d6$var$U) {
                if (!this.pairs.length) throw new $2be8636d379871d6$var$U();
                n = !0;
            }
        }
        if (this.checkChecksum()) return this.pairs;
        if (r = !!this.rows.length, this.storeRow(t, !1), r) {
            var o = this.checkRowsBoolean(!1);
            if (null != o) return o;
            if (null != (o = this.checkRowsBoolean(!0))) return o;
        }
        throw new $2be8636d379871d6$var$U();
    }, e.prototype.checkRowsBoolean = function(t) {
        if (this.rows.length > 25) return this.rows.length = 0, null;
        this.pairs.length = 0, t && (this.rows = this.rows.reverse());
        var e = null;
        try {
            e = this.checkRows(new Array(), 0);
        } catch (t) {
            console.log(t);
        }
        return t && (this.rows = this.rows.reverse()), e;
    }, e.prototype.checkRows = function(t, r) {
        for(var n, o, i = r; i < this.rows.length; i++){
            var a = this.rows[i];
            this.pairs.length = 0;
            try {
                for(var u = (n = void 0, $2be8636d379871d6$var$rr(t)), s = u.next(); !s.done; s = u.next()){
                    var c = s.value;
                    this.pairs.push(c.getPairs());
                }
            } catch (t) {
                n = {
                    error: t
                };
            } finally{
                try {
                    s && !s.done && (o = u.return) && o.call(u);
                } finally{
                    if (n) throw n.error;
                }
            }
            if (this.pairs.push(a.getPairs()), e.isValidSequence(this.pairs)) {
                if (this.checkChecksum()) return this.pairs;
                var f = new Array(t);
                f.push(a);
                try {
                    return this.checkRows(f, i + 1);
                } catch (t) {
                    console.log(t);
                }
            }
        }
        throw new $2be8636d379871d6$var$U();
    }, e.isValidSequence = function(t) {
        var r, n;
        try {
            for(var o = $2be8636d379871d6$var$rr(e.FINDER_PATTERN_SEQUENCES), i = o.next(); !i.done; i = o.next()){
                var a = i.value;
                if (!(t.length > a.length)) {
                    for(var u = !0, s = 0; s < t.length; s++)if (t[s].getFinderPattern().getValue() != a[s]) {
                        u = !1;
                        break;
                    }
                    if (u) return !0;
                }
            }
        } catch (t) {
            r = {
                error: t
            };
        } finally{
            try {
                i && !i.done && (n = o.return) && n.call(o);
            } finally{
                if (r) throw r.error;
            }
        }
        return !1;
    }, e.prototype.storeRow = function(t, r) {
        for(var n = 0, o = !1, i = !1; n < this.rows.length;){
            var a = this.rows[n];
            if (a.getRowNumber() > t) {
                i = a.isEquivalent(this.pairs);
                break;
            }
            o = a.isEquivalent(this.pairs), n++;
        }
        i || o || e.isPartialRow(this.pairs, this.rows) || (this.rows.push(n, new $2be8636d379871d6$var$tr(this.pairs, t, r)), this.removePartialRows(this.pairs, this.rows));
    }, e.prototype.removePartialRows = function(t, e) {
        var r, n, o, i, a, u;
        try {
            for(var s = $2be8636d379871d6$var$rr(e), c = s.next(); !c.done; c = s.next()){
                var f = c.value;
                if (f.getPairs().length !== t.length) try {
                    for(var h = (o = void 0, $2be8636d379871d6$var$rr(f.getPairs())), l = h.next(); !l.done; l = h.next()){
                        var d = l.value, p = !1;
                        try {
                            for(var g = (a = void 0, $2be8636d379871d6$var$rr(t)), y = g.next(); !y.done; y = g.next()){
                                var w = y.value;
                                if ($2be8636d379871d6$var$$e.equals(d, w)) {
                                    p = !0;
                                    break;
                                }
                            }
                        } catch (t) {
                            a = {
                                error: t
                            };
                        } finally{
                            try {
                                y && !y.done && (u = g.return) && u.call(g);
                            } finally{
                                if (a) throw a.error;
                            }
                        }
                        p;
                    }
                } catch (t) {
                    o = {
                        error: t
                    };
                } finally{
                    try {
                        l && !l.done && (i = h.return) && i.call(h);
                    } finally{
                        if (o) throw o.error;
                    }
                }
            }
        } catch (t) {
            r = {
                error: t
            };
        } finally{
            try {
                c && !c.done && (n = s.return) && n.call(s);
            } finally{
                if (r) throw r.error;
            }
        }
    }, e.isPartialRow = function(t, e) {
        var r, n, o, i, a, u;
        try {
            for(var s = $2be8636d379871d6$var$rr(e), c = s.next(); !c.done; c = s.next()){
                var f = c.value, h = !0;
                try {
                    for(var l = (o = void 0, $2be8636d379871d6$var$rr(t)), d = l.next(); !d.done; d = l.next()){
                        var p = d.value, g = !1;
                        try {
                            for(var y = (a = void 0, $2be8636d379871d6$var$rr(f.getPairs())), w = y.next(); !w.done; w = y.next()){
                                var _ = w.value;
                                if (p.equals(_)) {
                                    g = !0;
                                    break;
                                }
                            }
                        } catch (t) {
                            a = {
                                error: t
                            };
                        } finally{
                            try {
                                w && !w.done && (u = y.return) && u.call(y);
                            } finally{
                                if (a) throw a.error;
                            }
                        }
                        if (!g) {
                            h = !1;
                            break;
                        }
                    }
                } catch (t) {
                    o = {
                        error: t
                    };
                } finally{
                    try {
                        d && !d.done && (i = l.return) && i.call(l);
                    } finally{
                        if (o) throw o.error;
                    }
                }
                if (h) return !0;
            }
        } catch (t) {
            r = {
                error: t
            };
        } finally{
            try {
                c && !c.done && (n = s.return) && n.call(s);
            } finally{
                if (r) throw r.error;
            }
        }
        return !1;
    }, e.prototype.getRows = function() {
        return this.rows;
    }, e.constructResult = function(t) {
        var e = (function(t) {
            try {
                if (t.get(1)) return new $2be8636d379871d6$var$Fe(t);
                if (!t.get(2)) return new $2be8636d379871d6$var$xe(t);
                switch($2be8636d379871d6$var$De.extractNumericValueFromBitArray(t, 1, 4)){
                    case 4:
                        return new $2be8636d379871d6$var$We(t);
                    case 5:
                        return new $2be8636d379871d6$var$ze(t);
                }
                switch($2be8636d379871d6$var$De.extractNumericValueFromBitArray(t, 1, 5)){
                    case 12:
                        return new $2be8636d379871d6$var$Ze(t);
                    case 13:
                        return new $2be8636d379871d6$var$qe(t);
                }
                switch($2be8636d379871d6$var$De.extractNumericValueFromBitArray(t, 1, 7)){
                    case 56:
                        return new $2be8636d379871d6$var$Je(t, "310", "11");
                    case 57:
                        return new $2be8636d379871d6$var$Je(t, "320", "11");
                    case 58:
                        return new $2be8636d379871d6$var$Je(t, "310", "13");
                    case 59:
                        return new $2be8636d379871d6$var$Je(t, "320", "13");
                    case 60:
                        return new $2be8636d379871d6$var$Je(t, "310", "15");
                    case 61:
                        return new $2be8636d379871d6$var$Je(t, "320", "15");
                    case 62:
                        return new $2be8636d379871d6$var$Je(t, "310", "17");
                    case 63:
                        return new $2be8636d379871d6$var$Je(t, "320", "17");
                }
            } catch (e) {
                throw console.log(e), new $2be8636d379871d6$var$yt("unknown decoder: " + t);
            }
        })($2be8636d379871d6$var$me.buildBitArray(t)).parseInformation(), r = t[0].getFinderPattern().getResultPoints(), n = t[t.length - 1].getFinderPattern().getResultPoints(), o = [
            r[0],
            r[1],
            n[0],
            n[1]
        ];
        return new $2be8636d379871d6$var$et(e, null, null, o, $2be8636d379871d6$var$nt.RSS_EXPANDED, null);
    }, e.prototype.checkChecksum = function() {
        var t = this.pairs.get(0), e = t.getLeftChar(), r = t.getRightChar();
        if (null == r) return !1;
        for(var n = r.getChecksumPortion(), o = 2, i = 1; i < this.pairs.size(); ++i){
            var a = this.pairs.get(i);
            n += a.getLeftChar().getChecksumPortion(), o++;
            var u = a.getRightChar();
            null != u && (n += u.getChecksumPortion(), o++);
        }
        return 211 * (o - 4) + (n %= 211) == e.getValue();
    }, e.getNextSecondBar = function(t, e) {
        var r;
        return t.get(e) ? (r = t.getNextUnset(e), r = t.getNextSet(r)) : (r = t.getNextSet(e), r = t.getNextUnset(r)), r;
    }, e.prototype.retrieveNextPair = function(t, r, n) {
        var o, i = r.length % 2 == 0;
        this.startFromEven && (i = !i);
        var a = !0, u = -1;
        do this.findNextPair(t, r, u), null == (o = this.parseFoundFinderPattern(t, n, i)) ? u = e.getNextSecondBar(t, this.startEnd[0]) : a = !1;
        while (a);
        var s, c = this.decodeDataCharacter(t, o, i, !0);
        if (!this.isEmptyPair(r) && r[r.length - 1].mustBeLast()) throw new $2be8636d379871d6$var$U();
        try {
            s = this.decodeDataCharacter(t, o, i, !1);
        } catch (t) {
            s = null, console.log(t);
        }
        return new $2be8636d379871d6$var$$e(c, s, o, !0);
    }, e.prototype.isEmptyPair = function(t) {
        return 0 === t.length;
    }, e.prototype.findNextPair = function(t, r, n) {
        var o = this.getDecodeFinderCounters();
        o[0] = 0, o[1] = 0, o[2] = 0, o[3] = 0;
        var i, a = t.getSize();
        if (n >= 0) i = n;
        else if (this.isEmptyPair(r)) i = 0;
        else i = r[r.length - 1].getFinderPattern().getStartEnd()[1];
        var u = r.length % 2 != 0;
        this.startFromEven && (u = !u);
        for(var s = !1; i < a && (s = !t.get(i));)i++;
        for(var c = 0, f = i, h = i; h < a; h++)if (t.get(h) != s) o[c]++;
        else {
            if (3 == c) {
                if (u && e.reverseCounters(o), e.isFinderPattern(o)) return this.startEnd[0] = f, void (this.startEnd[1] = h);
                u && e.reverseCounters(o), f += o[0] + o[1], o[0] = o[2], o[1] = o[3], o[2] = 0, o[3] = 0, c--;
            } else c++;
            o[c] = 1, s = !s;
        }
        throw new $2be8636d379871d6$var$U();
    }, e.reverseCounters = function(t) {
        for(var e = t.length, r = 0; r < e / 2; ++r){
            var n = t[r];
            t[r] = t[e - r - 1], t[e - r - 1] = n;
        }
    }, e.prototype.parseFoundFinderPattern = function(t, r, n) {
        var o, i, a;
        if (n) {
            for(var u = this.startEnd[0] - 1; u >= 0 && !t.get(u);)u--;
            u++, o = this.startEnd[0] - u, i = u, a = this.startEnd[1];
        } else i = this.startEnd[0], o = (a = t.getNextUnset(this.startEnd[1] + 1)) - this.startEnd[1];
        var s, c = this.getDecodeFinderCounters();
        $2be8636d379871d6$var$w.arraycopy(c, 0, c, 1, c.length - 1), c[0] = o;
        try {
            s = this.parseFinderValue(c, e.FINDER_PATTERNS);
        } catch (t) {
            return null;
        }
        return new $2be8636d379871d6$var$we(s, [
            i,
            a
        ], i, a, r);
    }, e.prototype.decodeDataCharacter = function(t, r, n, o) {
        for(var i = this.getDataCharacterCounters(), a = 0; a < i.length; a++)i[a] = 0;
        if (o) e.recordPatternInReverse(t, r.getStartEnd()[0], i);
        else {
            e.recordPattern(t, r.getStartEnd()[1], i);
            for(var u = 0, s = i.length - 1; u < s; u++, s--){
                var c = i[u];
                i[u] = i[s], i[s] = c;
            }
        }
        var f = $2be8636d379871d6$var$vt.sum(new Int32Array(i)) / 17, h = (r.getStartEnd()[1] - r.getStartEnd()[0]) / 15;
        if (Math.abs(f - h) / h > 0.3) throw new $2be8636d379871d6$var$U();
        var l = this.getOddCounts(), d = this.getEvenCounts(), p = this.getOddRoundingErrors(), g = this.getEvenRoundingErrors();
        for(u = 0; u < i.length; u++){
            var y = 1 * i[u] / f, w = y + 0.5;
            if (w < 1) {
                if (y < 0.3) throw new $2be8636d379871d6$var$U();
                w = 1;
            } else if (w > 8) {
                if (y > 8.7) throw new $2be8636d379871d6$var$U();
                w = 8;
            }
            var _ = u / 2;
            0 == (1 & u) ? (l[_] = w, p[_] = y - w) : (d[_] = w, g[_] = y - w);
        }
        this.adjustOddEvenCounts(17);
        var v = 4 * r.getValue() + (n ? 0 : 2) + (o ? 0 : 1) - 1, m = 0, A = 0;
        for(u = l.length - 1; u >= 0; u--){
            if (e.isNotA1left(r, n, o)) {
                var E = e.WEIGHTS[v][2 * u];
                A += l[u] * E;
            }
            m += l[u];
        }
        var C = 0;
        for(u = d.length - 1; u >= 0; u--)if (e.isNotA1left(r, n, o)) {
            E = e.WEIGHTS[v][2 * u + 1];
            C += d[u] * E;
        }
        var I = A + C;
        if (0 != (1 & m) || m > 13 || m < 4) throw new $2be8636d379871d6$var$U();
        var S = (13 - m) / 2, O = e.SYMBOL_WIDEST[S], T = 9 - O, b = $2be8636d379871d6$var$ve.getRSSvalue(l, O, !0), R = $2be8636d379871d6$var$ve.getRSSvalue(d, T, !1), N = e.EVEN_TOTAL_SUBSET[S], D = e.GSUM[S];
        return new $2be8636d379871d6$var$ye(b * N + R + D, I);
    }, e.isNotA1left = function(t, e, r) {
        return !(0 == t.getValue() && e && r);
    }, e.prototype.adjustOddEvenCounts = function(t) {
        var r = $2be8636d379871d6$var$vt.sum(new Int32Array(this.getOddCounts())), n = $2be8636d379871d6$var$vt.sum(new Int32Array(this.getEvenCounts())), o = !1, i = !1;
        r > 13 ? i = !0 : r < 4 && (o = !0);
        var a = !1, u = !1;
        n > 13 ? u = !0 : n < 4 && (a = !0);
        var s = r + n - t, c = 1 == (1 & r), f = 0 == (1 & n);
        if (1 == s) {
            if (c) {
                if (f) throw new $2be8636d379871d6$var$U();
                i = !0;
            } else {
                if (!f) throw new $2be8636d379871d6$var$U();
                u = !0;
            }
        } else if (-1 == s) {
            if (c) {
                if (f) throw new $2be8636d379871d6$var$U();
                o = !0;
            } else {
                if (!f) throw new $2be8636d379871d6$var$U();
                a = !0;
            }
        } else {
            if (0 != s) throw new $2be8636d379871d6$var$U();
            if (c) {
                if (!f) throw new $2be8636d379871d6$var$U();
                r < n ? (o = !0, u = !0) : (i = !0, a = !0);
            } else if (f) throw new $2be8636d379871d6$var$U();
        }
        if (o) {
            if (i) throw new $2be8636d379871d6$var$U();
            e.increment(this.getOddCounts(), this.getOddRoundingErrors());
        }
        if (i && e.decrement(this.getOddCounts(), this.getOddRoundingErrors()), a) {
            if (u) throw new $2be8636d379871d6$var$U();
            e.increment(this.getEvenCounts(), this.getOddRoundingErrors());
        }
        u && e.decrement(this.getEvenCounts(), this.getEvenRoundingErrors());
    }, e.SYMBOL_WIDEST = [
        7,
        5,
        4,
        3,
        1
    ], e.EVEN_TOTAL_SUBSET = [
        4,
        20,
        52,
        104,
        204
    ], e.GSUM = [
        0,
        348,
        1388,
        2948,
        3988
    ], e.FINDER_PATTERNS = [
        Int32Array.from([
            1,
            8,
            4,
            1
        ]),
        Int32Array.from([
            3,
            6,
            4,
            1
        ]),
        Int32Array.from([
            3,
            4,
            6,
            1
        ]),
        Int32Array.from([
            3,
            2,
            8,
            1
        ]),
        Int32Array.from([
            2,
            6,
            5,
            1
        ]),
        Int32Array.from([
            2,
            2,
            9,
            1
        ])
    ], e.WEIGHTS = [
        [
            1,
            3,
            9,
            27,
            81,
            32,
            96,
            77
        ],
        [
            20,
            60,
            180,
            118,
            143,
            7,
            21,
            63
        ],
        [
            189,
            145,
            13,
            39,
            117,
            140,
            209,
            205
        ],
        [
            193,
            157,
            49,
            147,
            19,
            57,
            171,
            91
        ],
        [
            62,
            186,
            136,
            197,
            169,
            85,
            44,
            132
        ],
        [
            185,
            133,
            188,
            142,
            4,
            12,
            36,
            108
        ],
        [
            113,
            128,
            173,
            97,
            80,
            29,
            87,
            50
        ],
        [
            150,
            28,
            84,
            41,
            123,
            158,
            52,
            156
        ],
        [
            46,
            138,
            203,
            187,
            139,
            206,
            196,
            166
        ],
        [
            76,
            17,
            51,
            153,
            37,
            111,
            122,
            155
        ],
        [
            43,
            129,
            176,
            106,
            107,
            110,
            119,
            146
        ],
        [
            16,
            48,
            144,
            10,
            30,
            90,
            59,
            177
        ],
        [
            109,
            116,
            137,
            200,
            178,
            112,
            125,
            164
        ],
        [
            70,
            210,
            208,
            202,
            184,
            130,
            179,
            115
        ],
        [
            134,
            191,
            151,
            31,
            93,
            68,
            204,
            190
        ],
        [
            148,
            22,
            66,
            198,
            172,
            94,
            71,
            2
        ],
        [
            6,
            18,
            54,
            162,
            64,
            192,
            154,
            40
        ],
        [
            120,
            149,
            25,
            75,
            14,
            42,
            126,
            167
        ],
        [
            79,
            26,
            78,
            23,
            69,
            207,
            199,
            175
        ],
        [
            103,
            98,
            83,
            38,
            114,
            131,
            182,
            124
        ],
        [
            161,
            61,
            183,
            127,
            170,
            88,
            53,
            159
        ],
        [
            55,
            165,
            73,
            8,
            24,
            72,
            5,
            15
        ],
        [
            45,
            135,
            194,
            160,
            58,
            174,
            100,
            89
        ]
    ], e.FINDER_PAT_A = 0, e.FINDER_PAT_B = 1, e.FINDER_PAT_C = 2, e.FINDER_PAT_D = 3, e.FINDER_PAT_E = 4, e.FINDER_PAT_F = 5, e.FINDER_PATTERN_SEQUENCES = [
        [
            e.FINDER_PAT_A,
            e.FINDER_PAT_A
        ],
        [
            e.FINDER_PAT_A,
            e.FINDER_PAT_B,
            e.FINDER_PAT_B
        ],
        [
            e.FINDER_PAT_A,
            e.FINDER_PAT_C,
            e.FINDER_PAT_B,
            e.FINDER_PAT_D
        ],
        [
            e.FINDER_PAT_A,
            e.FINDER_PAT_E,
            e.FINDER_PAT_B,
            e.FINDER_PAT_D,
            e.FINDER_PAT_C
        ],
        [
            e.FINDER_PAT_A,
            e.FINDER_PAT_E,
            e.FINDER_PAT_B,
            e.FINDER_PAT_D,
            e.FINDER_PAT_D,
            e.FINDER_PAT_F
        ],
        [
            e.FINDER_PAT_A,
            e.FINDER_PAT_E,
            e.FINDER_PAT_B,
            e.FINDER_PAT_D,
            e.FINDER_PAT_E,
            e.FINDER_PAT_F,
            e.FINDER_PAT_F
        ],
        [
            e.FINDER_PAT_A,
            e.FINDER_PAT_A,
            e.FINDER_PAT_B,
            e.FINDER_PAT_B,
            e.FINDER_PAT_C,
            e.FINDER_PAT_C,
            e.FINDER_PAT_D,
            e.FINDER_PAT_D
        ],
        [
            e.FINDER_PAT_A,
            e.FINDER_PAT_A,
            e.FINDER_PAT_B,
            e.FINDER_PAT_B,
            e.FINDER_PAT_C,
            e.FINDER_PAT_C,
            e.FINDER_PAT_D,
            e.FINDER_PAT_E,
            e.FINDER_PAT_E
        ],
        [
            e.FINDER_PAT_A,
            e.FINDER_PAT_A,
            e.FINDER_PAT_B,
            e.FINDER_PAT_B,
            e.FINDER_PAT_C,
            e.FINDER_PAT_C,
            e.FINDER_PAT_D,
            e.FINDER_PAT_E,
            e.FINDER_PAT_F,
            e.FINDER_PAT_F
        ],
        [
            e.FINDER_PAT_A,
            e.FINDER_PAT_A,
            e.FINDER_PAT_B,
            e.FINDER_PAT_B,
            e.FINDER_PAT_C,
            e.FINDER_PAT_D,
            e.FINDER_PAT_D,
            e.FINDER_PAT_E,
            e.FINDER_PAT_E,
            e.FINDER_PAT_F,
            e.FINDER_PAT_F
        ]
    ], e.MAX_PAIRS = 11, e;
}($2be8636d379871d6$var$ge), $2be8636d379871d6$var$or = function() {
    var t = function(e, r) {
        return t = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(t, e) {
            t.__proto__ = e;
        } || function(t, e) {
            for(var r in e)e.hasOwnProperty(r) && (t[r] = e[r]);
        }, t(e, r);
    };
    return function(e, r) {
        function n() {
            this.constructor = e;
        }
        t(e, r), e.prototype = null === r ? Object.create(r) : (n.prototype = r.prototype, new n());
    };
}(), $2be8636d379871d6$var$ir = function(t) {
    function e(e, r, n) {
        var o = t.call(this, e, r) || this;
        return o.count = 0, o.finderPattern = n, o;
    }
    return $2be8636d379871d6$var$or(e, t), e.prototype.getFinderPattern = function() {
        return this.finderPattern;
    }, e.prototype.getCount = function() {
        return this.count;
    }, e.prototype.incrementCount = function() {
        this.count++;
    }, e;
}($2be8636d379871d6$var$ye), $2be8636d379871d6$var$ar = function() {
    var t = function(e, r) {
        return t = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(t, e) {
            t.__proto__ = e;
        } || function(t, e) {
            for(var r in e)e.hasOwnProperty(r) && (t[r] = e[r]);
        }, t(e, r);
    };
    return function(e, r) {
        function n() {
            this.constructor = e;
        }
        t(e, r), e.prototype = null === r ? Object.create(r) : (n.prototype = r.prototype, new n());
    };
}(), $2be8636d379871d6$var$ur = function(t) {
    var e = "function" == typeof Symbol && Symbol.iterator, r = e && t[e], n = 0;
    if (r) return r.call(t);
    if (t && "number" == typeof t.length) return {
        next: function() {
            return t && n >= t.length && (t = void 0), {
                value: t && t[n++],
                done: !t
            };
        }
    };
    throw new TypeError(e ? "Object is not iterable." : "Symbol.iterator is not defined.");
}, $2be8636d379871d6$var$sr = function(t) {
    function e() {
        var e = null !== t && t.apply(this, arguments) || this;
        return e.possibleLeftPairs = [], e.possibleRightPairs = [], e;
    }
    return $2be8636d379871d6$var$ar(e, t), e.prototype.decodeRow = function(t, r, n) {
        var o, i, a, u, s = this.decodePair(r, !1, t, n);
        e.addOrTally(this.possibleLeftPairs, s), r.reverse();
        var c = this.decodePair(r, !0, t, n);
        e.addOrTally(this.possibleRightPairs, c), r.reverse();
        try {
            for(var f = $2be8636d379871d6$var$ur(this.possibleLeftPairs), h = f.next(); !h.done; h = f.next()){
                var l = h.value;
                if (l.getCount() > 1) try {
                    for(var d = (a = void 0, $2be8636d379871d6$var$ur(this.possibleRightPairs)), p = d.next(); !p.done; p = d.next()){
                        var g = p.value;
                        if (g.getCount() > 1 && e.checkChecksum(l, g)) return e.constructResult(l, g);
                    }
                } catch (t) {
                    a = {
                        error: t
                    };
                } finally{
                    try {
                        p && !p.done && (u = d.return) && u.call(d);
                    } finally{
                        if (a) throw a.error;
                    }
                }
            }
        } catch (t) {
            o = {
                error: t
            };
        } finally{
            try {
                h && !h.done && (i = f.return) && i.call(f);
            } finally{
                if (o) throw o.error;
            }
        }
        throw new $2be8636d379871d6$var$U();
    }, e.addOrTally = function(t, e) {
        var r, n;
        if (null != e) {
            var o = !1;
            try {
                for(var i = $2be8636d379871d6$var$ur(t), a = i.next(); !a.done; a = i.next()){
                    var u = a.value;
                    if (u.getValue() === e.getValue()) {
                        u.incrementCount(), o = !0;
                        break;
                    }
                }
            } catch (t) {
                r = {
                    error: t
                };
            } finally{
                try {
                    a && !a.done && (n = i.return) && n.call(i);
                } finally{
                    if (r) throw r.error;
                }
            }
            o || t.push(e);
        }
    }, e.prototype.reset = function() {
        this.possibleLeftPairs.length = 0, this.possibleRightPairs.length = 0;
    }, e.constructResult = function(t, e) {
        for(var r = 4537077 * t.getValue() + e.getValue(), n = new String(r).toString(), o = new $2be8636d379871d6$var$k(), i = 13 - n.length; i > 0; i--)o.append("0");
        o.append(n);
        var a = 0;
        for(i = 0; i < 13; i++){
            var u = o.charAt(i).charCodeAt(0) - "0".charCodeAt(0);
            a += 0 == (1 & i) ? 3 * u : u;
        }
        10 === (a = 10 - a % 10) && (a = 0), o.append(a.toString());
        var s = t.getFinderPattern().getResultPoints(), c = e.getFinderPattern().getResultPoints();
        return new $2be8636d379871d6$var$et(o.toString(), null, 0, [
            s[0],
            s[1],
            c[0],
            c[1]
        ], $2be8636d379871d6$var$nt.RSS_14, new Date().getTime());
    }, e.checkChecksum = function(t, e) {
        var r = (t.getChecksumPortion() + 16 * e.getChecksumPortion()) % 79, n = 9 * t.getFinderPattern().getValue() + e.getFinderPattern().getValue();
        return n > 72 && n--, n > 8 && n--, r === n;
    }, e.prototype.decodePair = function(t, e, r, n) {
        try {
            var o = this.findFinderPattern(t, e), i = this.parseFoundFinderPattern(t, r, e, o), a = null == n ? null : n.get($2be8636d379871d6$var$T.NEED_RESULT_POINT_CALLBACK);
            if (null != a) {
                var u = (o[0] + o[1]) / 2;
                e && (u = t.getSize() - 1 - u), a.foundPossibleResultPoint(new $2be8636d379871d6$var$At(u, r));
            }
            var s = this.decodeDataCharacter(t, i, !0), c = this.decodeDataCharacter(t, i, !1);
            return new $2be8636d379871d6$var$ir(1597 * s.getValue() + c.getValue(), s.getChecksumPortion() + 4 * c.getChecksumPortion(), i);
        } catch (t) {
            return null;
        }
    }, e.prototype.decodeDataCharacter = function(t, r, n) {
        for(var o = this.getDataCharacterCounters(), i = 0; i < o.length; i++)o[i] = 0;
        if (n) $2be8636d379871d6$var$Lt.recordPatternInReverse(t, r.getStartEnd()[0], o);
        else {
            $2be8636d379871d6$var$Lt.recordPattern(t, r.getStartEnd()[1] + 1, o);
            for(var a = 0, u = o.length - 1; a < u; a++, u--){
                var s = o[a];
                o[a] = o[u], o[u] = s;
            }
        }
        var c = n ? 16 : 15, f = $2be8636d379871d6$var$vt.sum(new Int32Array(o)) / c, h = this.getOddCounts(), l = this.getEvenCounts(), d = this.getOddRoundingErrors(), p = this.getEvenRoundingErrors();
        for(a = 0; a < o.length; a++){
            var g = o[a] / f, y = Math.floor(g + 0.5);
            y < 1 ? y = 1 : y > 8 && (y = 8);
            var w = Math.floor(a / 2);
            0 == (1 & a) ? (h[w] = y, d[w] = g - y) : (l[w] = y, p[w] = g - y);
        }
        this.adjustOddEvenCounts(n, c);
        var _ = 0, v = 0;
        for(a = h.length - 1; a >= 0; a--)v *= 9, v += h[a], _ += h[a];
        var m = 0, A = 0;
        for(a = l.length - 1; a >= 0; a--)m *= 9, m += l[a], A += l[a];
        var E = v + 3 * m;
        if (n) {
            if (0 != (1 & _) || _ > 12 || _ < 4) throw new $2be8636d379871d6$var$U();
            var C = (12 - _) / 2, I = 9 - (R = e.OUTSIDE_ODD_WIDEST[C]), S = $2be8636d379871d6$var$ve.getRSSvalue(h, R, !1), O = $2be8636d379871d6$var$ve.getRSSvalue(l, I, !0), T = e.OUTSIDE_EVEN_TOTAL_SUBSET[C], b = e.OUTSIDE_GSUM[C];
            return new $2be8636d379871d6$var$ye(S * T + O + b, E);
        }
        if (0 != (1 & A) || A > 10 || A < 4) throw new $2be8636d379871d6$var$U();
        C = (10 - A) / 2, I = 9 - (R = e.INSIDE_ODD_WIDEST[C]), S = $2be8636d379871d6$var$ve.getRSSvalue(h, R, !0), O = $2be8636d379871d6$var$ve.getRSSvalue(l, I, !1);
        var R, N = e.INSIDE_ODD_TOTAL_SUBSET[C];
        b = e.INSIDE_GSUM[C];
        return new $2be8636d379871d6$var$ye(O * N + S + b, E);
    }, e.prototype.findFinderPattern = function(t, e) {
        var r = this.getDecodeFinderCounters();
        r[0] = 0, r[1] = 0, r[2] = 0, r[3] = 0;
        for(var n = t.getSize(), o = !1, i = 0; i < n && e !== (o = !t.get(i));)i++;
        for(var a = 0, u = i, s = i; s < n; s++)if (t.get(s) !== o) r[a]++;
        else {
            if (3 === a) {
                if ($2be8636d379871d6$var$ge.isFinderPattern(r)) return [
                    u,
                    s
                ];
                u += r[0] + r[1], r[0] = r[2], r[1] = r[3], r[2] = 0, r[3] = 0, a--;
            } else a++;
            r[a] = 1, o = !o;
        }
        throw new $2be8636d379871d6$var$U();
    }, e.prototype.parseFoundFinderPattern = function(t, r, n, o) {
        for(var i = t.get(o[0]), a = o[0] - 1; a >= 0 && i !== t.get(a);)a--;
        a++;
        var u = o[0] - a, s = this.getDecodeFinderCounters(), c = new Int32Array(s.length);
        $2be8636d379871d6$var$w.arraycopy(s, 0, c, 1, s.length - 1), c[0] = u;
        var f = this.parseFinderValue(c, e.FINDER_PATTERNS), h = a, l = o[1];
        return n && (h = t.getSize() - 1 - h, l = t.getSize() - 1 - l), new $2be8636d379871d6$var$we(f, [
            a,
            o[1]
        ], h, l, r);
    }, e.prototype.adjustOddEvenCounts = function(t, e) {
        var r = $2be8636d379871d6$var$vt.sum(new Int32Array(this.getOddCounts())), n = $2be8636d379871d6$var$vt.sum(new Int32Array(this.getEvenCounts())), o = !1, i = !1, a = !1, u = !1;
        t ? (r > 12 ? i = !0 : r < 4 && (o = !0), n > 12 ? u = !0 : n < 4 && (a = !0)) : (r > 11 ? i = !0 : r < 5 && (o = !0), n > 10 ? u = !0 : n < 4 && (a = !0));
        var s = r + n - e, c = (1 & r) == (t ? 1 : 0), f = 1 == (1 & n);
        if (1 === s) {
            if (c) {
                if (f) throw new $2be8636d379871d6$var$U();
                i = !0;
            } else {
                if (!f) throw new $2be8636d379871d6$var$U();
                u = !0;
            }
        } else if (-1 === s) {
            if (c) {
                if (f) throw new $2be8636d379871d6$var$U();
                o = !0;
            } else {
                if (!f) throw new $2be8636d379871d6$var$U();
                a = !0;
            }
        } else {
            if (0 !== s) throw new $2be8636d379871d6$var$U();
            if (c) {
                if (!f) throw new $2be8636d379871d6$var$U();
                r < n ? (o = !0, u = !0) : (i = !0, a = !0);
            } else if (f) throw new $2be8636d379871d6$var$U();
        }
        if (o) {
            if (i) throw new $2be8636d379871d6$var$U();
            $2be8636d379871d6$var$ge.increment(this.getOddCounts(), this.getOddRoundingErrors());
        }
        if (i && $2be8636d379871d6$var$ge.decrement(this.getOddCounts(), this.getOddRoundingErrors()), a) {
            if (u) throw new $2be8636d379871d6$var$U();
            $2be8636d379871d6$var$ge.increment(this.getEvenCounts(), this.getOddRoundingErrors());
        }
        u && $2be8636d379871d6$var$ge.decrement(this.getEvenCounts(), this.getEvenRoundingErrors());
    }, e.OUTSIDE_EVEN_TOTAL_SUBSET = [
        1,
        10,
        34,
        70,
        126
    ], e.INSIDE_ODD_TOTAL_SUBSET = [
        4,
        20,
        48,
        81
    ], e.OUTSIDE_GSUM = [
        0,
        161,
        961,
        2015,
        2715
    ], e.INSIDE_GSUM = [
        0,
        336,
        1036,
        1516
    ], e.OUTSIDE_ODD_WIDEST = [
        8,
        6,
        4,
        3,
        1
    ], e.INSIDE_ODD_WIDEST = [
        2,
        4,
        6,
        8
    ], e.FINDER_PATTERNS = [
        Int32Array.from([
            3,
            8,
            2,
            1
        ]),
        Int32Array.from([
            3,
            5,
            5,
            1
        ]),
        Int32Array.from([
            3,
            3,
            7,
            1
        ]),
        Int32Array.from([
            3,
            1,
            9,
            1
        ]),
        Int32Array.from([
            2,
            7,
            4,
            1
        ]),
        Int32Array.from([
            2,
            5,
            6,
            1
        ]),
        Int32Array.from([
            2,
            3,
            8,
            1
        ]),
        Int32Array.from([
            1,
            5,
            7,
            1
        ]),
        Int32Array.from([
            1,
            3,
            9,
            1
        ])
    ], e;
}($2be8636d379871d6$var$ge), $2be8636d379871d6$var$cr = function() {
    var t = function(e, r) {
        return t = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(t, e) {
            t.__proto__ = e;
        } || function(t, e) {
            for(var r in e)e.hasOwnProperty(r) && (t[r] = e[r]);
        }, t(e, r);
    };
    return function(e, r) {
        function n() {
            this.constructor = e;
        }
        t(e, r), e.prototype = null === r ? Object.create(r) : (n.prototype = r.prototype, new n());
    };
}(), $2be8636d379871d6$var$fr = function(t) {
    function e(e) {
        var r = t.call(this) || this;
        r.readers = [];
        var n = e ? e.get($2be8636d379871d6$var$T.POSSIBLE_FORMATS) : null, o = e && void 0 !== e.get($2be8636d379871d6$var$T.ASSUME_CODE_39_CHECK_DIGIT);
        return n && ((n.includes($2be8636d379871d6$var$nt.EAN_13) || n.includes($2be8636d379871d6$var$nt.UPC_A) || n.includes($2be8636d379871d6$var$nt.EAN_8) || n.includes($2be8636d379871d6$var$nt.UPC_E)) && r.readers.push(new $2be8636d379871d6$var$le(e)), n.includes($2be8636d379871d6$var$nt.CODE_39) && r.readers.push(new $2be8636d379871d6$var$Ut(o)), n.includes($2be8636d379871d6$var$nt.CODE_128) && r.readers.push(new $2be8636d379871d6$var$kt()), n.includes($2be8636d379871d6$var$nt.ITF) && r.readers.push(new $2be8636d379871d6$var$Xt()), n.includes($2be8636d379871d6$var$nt.RSS_14) && r.readers.push(new $2be8636d379871d6$var$sr()), n.includes($2be8636d379871d6$var$nt.RSS_EXPANDED) && (console.warn("RSS Expanded reader IS NOT ready for production yet! use at your own risk."), r.readers.push(new $2be8636d379871d6$var$nr()))), 0 === r.readers.length && (r.readers.push(new $2be8636d379871d6$var$le(e)), r.readers.push(new $2be8636d379871d6$var$Ut()), r.readers.push(new $2be8636d379871d6$var$le(e)), r.readers.push(new $2be8636d379871d6$var$kt()), r.readers.push(new $2be8636d379871d6$var$Xt()), r.readers.push(new $2be8636d379871d6$var$sr())), r;
    }
    return $2be8636d379871d6$var$cr(e, t), e.prototype.decodeRow = function(t, e, r) {
        for(var n = 0; n < this.readers.length; n++)try {
            return this.readers[n].decodeRow(t, e, r);
        } catch (t) {}
        throw new $2be8636d379871d6$var$U();
    }, e.prototype.reset = function() {
        this.readers.forEach(function(t) {
            return t.reset();
        });
    }, e;
}($2be8636d379871d6$var$Lt), $2be8636d379871d6$var$hr = function() {
    var t = function(e, r) {
        return t = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(t, e) {
            t.__proto__ = e;
        } || function(t, e) {
            for(var r in e)e.hasOwnProperty(r) && (t[r] = e[r]);
        }, t(e, r);
    };
    return function(e, r) {
        function n() {
            this.constructor = e;
        }
        t(e, r), e.prototype = null === r ? Object.create(r) : (n.prototype = r.prototype, new n());
    };
}();
!function(t) {
    function e(e, r) {
        return void 0 === e && (e = 500), t.call(this, new $2be8636d379871d6$var$fr(r), e, r) || this;
    }
    $2be8636d379871d6$var$hr(e, t);
}($2be8636d379871d6$var$tt);
var $2be8636d379871d6$var$lr, $2be8636d379871d6$var$dr = function(t) {
    var e = "function" == typeof Symbol && Symbol.iterator, r = e && t[e], n = 0;
    if (r) return r.call(t);
    if (t && "number" == typeof t.length) return {
        next: function() {
            return t && n >= t.length && (t = void 0), {
                value: t && t[n++],
                done: !t
            };
        }
    };
    throw new TypeError(e ? "Object is not iterable." : "Symbol.iterator is not defined.");
}, $2be8636d379871d6$var$pr = function() {
    function t(t, e, r) {
        this.ecCodewords = t, this.ecBlocks = [
            e
        ], r && this.ecBlocks.push(r);
    }
    return t.prototype.getECCodewords = function() {
        return this.ecCodewords;
    }, t.prototype.getECBlocks = function() {
        return this.ecBlocks;
    }, t;
}(), $2be8636d379871d6$var$gr = function() {
    function t(t, e) {
        this.count = t, this.dataCodewords = e;
    }
    return t.prototype.getCount = function() {
        return this.count;
    }, t.prototype.getDataCodewords = function() {
        return this.dataCodewords;
    }, t;
}(), $2be8636d379871d6$var$yr = function() {
    function t(t, e, r, n, o, i) {
        var a, u;
        this.versionNumber = t, this.symbolSizeRows = e, this.symbolSizeColumns = r, this.dataRegionSizeRows = n, this.dataRegionSizeColumns = o, this.ecBlocks = i;
        var s = 0, c = i.getECCodewords(), f = i.getECBlocks();
        try {
            for(var h = $2be8636d379871d6$var$dr(f), l = h.next(); !l.done; l = h.next()){
                var d = l.value;
                s += d.getCount() * (d.getDataCodewords() + c);
            }
        } catch (t) {
            a = {
                error: t
            };
        } finally{
            try {
                l && !l.done && (u = h.return) && u.call(h);
            } finally{
                if (a) throw a.error;
            }
        }
        this.totalCodewords = s;
    }
    return t.prototype.getVersionNumber = function() {
        return this.versionNumber;
    }, t.prototype.getSymbolSizeRows = function() {
        return this.symbolSizeRows;
    }, t.prototype.getSymbolSizeColumns = function() {
        return this.symbolSizeColumns;
    }, t.prototype.getDataRegionSizeRows = function() {
        return this.dataRegionSizeRows;
    }, t.prototype.getDataRegionSizeColumns = function() {
        return this.dataRegionSizeColumns;
    }, t.prototype.getTotalCodewords = function() {
        return this.totalCodewords;
    }, t.prototype.getECBlocks = function() {
        return this.ecBlocks;
    }, t.getVersionForDimensions = function(e, r) {
        var n, o;
        if (0 != (1 & e) || 0 != (1 & r)) throw new $2be8636d379871d6$var$R();
        try {
            for(var i = $2be8636d379871d6$var$dr(t.VERSIONS), a = i.next(); !a.done; a = i.next()){
                var u = a.value;
                if (u.symbolSizeRows === e && u.symbolSizeColumns === r) return u;
            }
        } catch (t) {
            n = {
                error: t
            };
        } finally{
            try {
                a && !a.done && (o = i.return) && o.call(i);
            } finally{
                if (n) throw n.error;
            }
        }
        throw new $2be8636d379871d6$var$R();
    }, t.prototype.toString = function() {
        return "" + this.versionNumber;
    }, t.buildVersions = function() {
        return [
            new t(1, 10, 10, 8, 8, new $2be8636d379871d6$var$pr(5, new $2be8636d379871d6$var$gr(1, 3))),
            new t(2, 12, 12, 10, 10, new $2be8636d379871d6$var$pr(7, new $2be8636d379871d6$var$gr(1, 5))),
            new t(3, 14, 14, 12, 12, new $2be8636d379871d6$var$pr(10, new $2be8636d379871d6$var$gr(1, 8))),
            new t(4, 16, 16, 14, 14, new $2be8636d379871d6$var$pr(12, new $2be8636d379871d6$var$gr(1, 12))),
            new t(5, 18, 18, 16, 16, new $2be8636d379871d6$var$pr(14, new $2be8636d379871d6$var$gr(1, 18))),
            new t(6, 20, 20, 18, 18, new $2be8636d379871d6$var$pr(18, new $2be8636d379871d6$var$gr(1, 22))),
            new t(7, 22, 22, 20, 20, new $2be8636d379871d6$var$pr(20, new $2be8636d379871d6$var$gr(1, 30))),
            new t(8, 24, 24, 22, 22, new $2be8636d379871d6$var$pr(24, new $2be8636d379871d6$var$gr(1, 36))),
            new t(9, 26, 26, 24, 24, new $2be8636d379871d6$var$pr(28, new $2be8636d379871d6$var$gr(1, 44))),
            new t(10, 32, 32, 14, 14, new $2be8636d379871d6$var$pr(36, new $2be8636d379871d6$var$gr(1, 62))),
            new t(11, 36, 36, 16, 16, new $2be8636d379871d6$var$pr(42, new $2be8636d379871d6$var$gr(1, 86))),
            new t(12, 40, 40, 18, 18, new $2be8636d379871d6$var$pr(48, new $2be8636d379871d6$var$gr(1, 114))),
            new t(13, 44, 44, 20, 20, new $2be8636d379871d6$var$pr(56, new $2be8636d379871d6$var$gr(1, 144))),
            new t(14, 48, 48, 22, 22, new $2be8636d379871d6$var$pr(68, new $2be8636d379871d6$var$gr(1, 174))),
            new t(15, 52, 52, 24, 24, new $2be8636d379871d6$var$pr(42, new $2be8636d379871d6$var$gr(2, 102))),
            new t(16, 64, 64, 14, 14, new $2be8636d379871d6$var$pr(56, new $2be8636d379871d6$var$gr(2, 140))),
            new t(17, 72, 72, 16, 16, new $2be8636d379871d6$var$pr(36, new $2be8636d379871d6$var$gr(4, 92))),
            new t(18, 80, 80, 18, 18, new $2be8636d379871d6$var$pr(48, new $2be8636d379871d6$var$gr(4, 114))),
            new t(19, 88, 88, 20, 20, new $2be8636d379871d6$var$pr(56, new $2be8636d379871d6$var$gr(4, 144))),
            new t(20, 96, 96, 22, 22, new $2be8636d379871d6$var$pr(68, new $2be8636d379871d6$var$gr(4, 174))),
            new t(21, 104, 104, 24, 24, new $2be8636d379871d6$var$pr(56, new $2be8636d379871d6$var$gr(6, 136))),
            new t(22, 120, 120, 18, 18, new $2be8636d379871d6$var$pr(68, new $2be8636d379871d6$var$gr(6, 175))),
            new t(23, 132, 132, 20, 20, new $2be8636d379871d6$var$pr(62, new $2be8636d379871d6$var$gr(8, 163))),
            new t(24, 144, 144, 22, 22, new $2be8636d379871d6$var$pr(62, new $2be8636d379871d6$var$gr(8, 156), new $2be8636d379871d6$var$gr(2, 155))),
            new t(25, 8, 18, 6, 16, new $2be8636d379871d6$var$pr(7, new $2be8636d379871d6$var$gr(1, 5))),
            new t(26, 8, 32, 6, 14, new $2be8636d379871d6$var$pr(11, new $2be8636d379871d6$var$gr(1, 10))),
            new t(27, 12, 26, 10, 24, new $2be8636d379871d6$var$pr(14, new $2be8636d379871d6$var$gr(1, 16))),
            new t(28, 12, 36, 10, 16, new $2be8636d379871d6$var$pr(18, new $2be8636d379871d6$var$gr(1, 22))),
            new t(29, 16, 36, 14, 16, new $2be8636d379871d6$var$pr(24, new $2be8636d379871d6$var$gr(1, 32))),
            new t(30, 16, 48, 14, 22, new $2be8636d379871d6$var$pr(28, new $2be8636d379871d6$var$gr(1, 49)))
        ];
    }, t.VERSIONS = t.buildVersions(), t;
}(), $2be8636d379871d6$var$wr = function() {
    function t(e) {
        var r = e.getHeight();
        if (r < 8 || r > 144 || 0 != (1 & r)) throw new $2be8636d379871d6$var$R();
        this.version = t.readVersion(e), this.mappingBitMatrix = this.extractDataRegion(e), this.readMappingMatrix = new $2be8636d379871d6$var$x(this.mappingBitMatrix.getWidth(), this.mappingBitMatrix.getHeight());
    }
    return t.prototype.getVersion = function() {
        return this.version;
    }, t.readVersion = function(t) {
        var e = t.getHeight(), r = t.getWidth();
        return $2be8636d379871d6$var$yr.getVersionForDimensions(e, r);
    }, t.prototype.readCodewords = function() {
        var t = new Int8Array(this.version.getTotalCodewords()), e = 0, r = 4, n = 0, o = this.mappingBitMatrix.getHeight(), i = this.mappingBitMatrix.getWidth(), a = !1, u = !1, s = !1, c = !1;
        do if (r !== o || 0 !== n || a) {
            if (r !== o - 2 || 0 !== n || 0 == (3 & i) || u) {
                if (r !== o + 4 || 2 !== n || 0 != (7 & i) || s) {
                    if (r !== o - 2 || 0 !== n || 4 != (7 & i) || c) {
                        do r < o && n >= 0 && !this.readMappingMatrix.get(n, r) && (t[e++] = 255 & this.readUtah(r, n, o, i)), r -= 2, n += 2;
                        while (r >= 0 && n < i);
                        r += 1, n += 3;
                        do r >= 0 && n < i && !this.readMappingMatrix.get(n, r) && (t[e++] = 255 & this.readUtah(r, n, o, i)), r += 2, n -= 2;
                        while (r < o && n >= 0);
                        r += 3, n += 1;
                    } else t[e++] = 255 & this.readCorner4(o, i), r -= 2, n += 2, c = !0;
                } else t[e++] = 255 & this.readCorner3(o, i), r -= 2, n += 2, s = !0;
            } else t[e++] = 255 & this.readCorner2(o, i), r -= 2, n += 2, u = !0;
        } else t[e++] = 255 & this.readCorner1(o, i), r -= 2, n += 2, a = !0;
        while (r < o || n < i);
        if (e !== this.version.getTotalCodewords()) throw new $2be8636d379871d6$var$R();
        return t;
    }, t.prototype.readModule = function(t, e, r, n) {
        return t < 0 && (t += r, e += 4 - (r + 4 & 7)), e < 0 && (e += n, t += 4 - (n + 4 & 7)), this.readMappingMatrix.set(e, t), this.mappingBitMatrix.get(e, t);
    }, t.prototype.readUtah = function(t, e, r, n) {
        var o = 0;
        return this.readModule(t - 2, e - 2, r, n) && (o |= 1), o <<= 1, this.readModule(t - 2, e - 1, r, n) && (o |= 1), o <<= 1, this.readModule(t - 1, e - 2, r, n) && (o |= 1), o <<= 1, this.readModule(t - 1, e - 1, r, n) && (o |= 1), o <<= 1, this.readModule(t - 1, e, r, n) && (o |= 1), o <<= 1, this.readModule(t, e - 2, r, n) && (o |= 1), o <<= 1, this.readModule(t, e - 1, r, n) && (o |= 1), o <<= 1, this.readModule(t, e, r, n) && (o |= 1), o;
    }, t.prototype.readCorner1 = function(t, e) {
        var r = 0;
        return this.readModule(t - 1, 0, t, e) && (r |= 1), r <<= 1, this.readModule(t - 1, 1, t, e) && (r |= 1), r <<= 1, this.readModule(t - 1, 2, t, e) && (r |= 1), r <<= 1, this.readModule(0, e - 2, t, e) && (r |= 1), r <<= 1, this.readModule(0, e - 1, t, e) && (r |= 1), r <<= 1, this.readModule(1, e - 1, t, e) && (r |= 1), r <<= 1, this.readModule(2, e - 1, t, e) && (r |= 1), r <<= 1, this.readModule(3, e - 1, t, e) && (r |= 1), r;
    }, t.prototype.readCorner2 = function(t, e) {
        var r = 0;
        return this.readModule(t - 3, 0, t, e) && (r |= 1), r <<= 1, this.readModule(t - 2, 0, t, e) && (r |= 1), r <<= 1, this.readModule(t - 1, 0, t, e) && (r |= 1), r <<= 1, this.readModule(0, e - 4, t, e) && (r |= 1), r <<= 1, this.readModule(0, e - 3, t, e) && (r |= 1), r <<= 1, this.readModule(0, e - 2, t, e) && (r |= 1), r <<= 1, this.readModule(0, e - 1, t, e) && (r |= 1), r <<= 1, this.readModule(1, e - 1, t, e) && (r |= 1), r;
    }, t.prototype.readCorner3 = function(t, e) {
        var r = 0;
        return this.readModule(t - 1, 0, t, e) && (r |= 1), r <<= 1, this.readModule(t - 1, e - 1, t, e) && (r |= 1), r <<= 1, this.readModule(0, e - 3, t, e) && (r |= 1), r <<= 1, this.readModule(0, e - 2, t, e) && (r |= 1), r <<= 1, this.readModule(0, e - 1, t, e) && (r |= 1), r <<= 1, this.readModule(1, e - 3, t, e) && (r |= 1), r <<= 1, this.readModule(1, e - 2, t, e) && (r |= 1), r <<= 1, this.readModule(1, e - 1, t, e) && (r |= 1), r;
    }, t.prototype.readCorner4 = function(t, e) {
        var r = 0;
        return this.readModule(t - 3, 0, t, e) && (r |= 1), r <<= 1, this.readModule(t - 2, 0, t, e) && (r |= 1), r <<= 1, this.readModule(t - 1, 0, t, e) && (r |= 1), r <<= 1, this.readModule(0, e - 2, t, e) && (r |= 1), r <<= 1, this.readModule(0, e - 1, t, e) && (r |= 1), r <<= 1, this.readModule(1, e - 1, t, e) && (r |= 1), r <<= 1, this.readModule(2, e - 1, t, e) && (r |= 1), r <<= 1, this.readModule(3, e - 1, t, e) && (r |= 1), r;
    }, t.prototype.extractDataRegion = function(t) {
        var e = this.version.getSymbolSizeRows(), r = this.version.getSymbolSizeColumns();
        if (t.getHeight() !== e) throw new $2be8636d379871d6$var$l("Dimension of bitMatrix must match the version size");
        for(var n = this.version.getDataRegionSizeRows(), o = this.version.getDataRegionSizeColumns(), i = e / n | 0, a = r / o | 0, u = new $2be8636d379871d6$var$x(a * o, i * n), s = 0; s < i; ++s)for(var c = s * n, f = 0; f < a; ++f)for(var h = f * o, d = 0; d < n; ++d)for(var p = s * (n + 2) + 1 + d, g = c + d, y = 0; y < o; ++y){
            var w = f * (o + 2) + 1 + y;
            if (t.get(w, p)) {
                var _ = h + y;
                u.set(_, g);
            }
        }
        return u;
    }, t;
}(), $2be8636d379871d6$var$_r = function(t) {
    var e = "function" == typeof Symbol && Symbol.iterator, r = e && t[e], n = 0;
    if (r) return r.call(t);
    if (t && "number" == typeof t.length) return {
        next: function() {
            return t && n >= t.length && (t = void 0), {
                value: t && t[n++],
                done: !t
            };
        }
    };
    throw new TypeError(e ? "Object is not iterable." : "Symbol.iterator is not defined.");
}, $2be8636d379871d6$var$vr = function() {
    function t(t, e) {
        this.numDataCodewords = t, this.codewords = e;
    }
    return t.getDataBlocks = function(e, r) {
        var n, o, i, a, u = r.getECBlocks(), s = 0, c = u.getECBlocks();
        try {
            for(var f = $2be8636d379871d6$var$_r(c), h = f.next(); !h.done; h = f.next())s += (w = h.value).getCount();
        } catch (t) {
            n = {
                error: t
            };
        } finally{
            try {
                h && !h.done && (o = f.return) && o.call(f);
            } finally{
                if (n) throw n.error;
            }
        }
        var d = new Array(s), p = 0;
        try {
            for(var g = $2be8636d379871d6$var$_r(c), y = g.next(); !y.done; y = g.next())for(var w = y.value, _ = 0; _ < w.getCount(); _++){
                var v = w.getDataCodewords(), m = u.getECCodewords() + v;
                d[p++] = new t(v, new Uint8Array(m));
            }
        } catch (t) {
            i = {
                error: t
            };
        } finally{
            try {
                y && !y.done && (a = g.return) && a.call(g);
            } finally{
                if (i) throw i.error;
            }
        }
        var A = d[0].codewords.length - u.getECCodewords(), E = A - 1, C = 0;
        for(_ = 0; _ < E; _++)for(var I = 0; I < p; I++)d[I].codewords[_] = e[C++];
        var S = 24 === r.getVersionNumber(), O = S ? 8 : p;
        for(I = 0; I < O; I++)d[I].codewords[A - 1] = e[C++];
        var T = d[0].codewords.length;
        for(_ = A; _ < T; _++)for(I = 0; I < p; I++){
            var b = S ? (I + 8) % p : I, R = S && b > 7 ? _ - 1 : _;
            d[b].codewords[R] = e[C++];
        }
        if (C !== e.length) throw new $2be8636d379871d6$var$l();
        return d;
    }, t.prototype.getNumDataCodewords = function() {
        return this.numDataCodewords;
    }, t.prototype.getCodewords = function() {
        return this.codewords;
    }, t;
}(), $2be8636d379871d6$var$mr = function() {
    function t(t) {
        this.bytes = t, this.byteOffset = 0, this.bitOffset = 0;
    }
    return t.prototype.getBitOffset = function() {
        return this.bitOffset;
    }, t.prototype.getByteOffset = function() {
        return this.byteOffset;
    }, t.prototype.readBits = function(t) {
        if (t < 1 || t > 32 || t > this.available()) throw new $2be8636d379871d6$var$l("" + t);
        var e = 0, r = this.bitOffset, n = this.byteOffset, o = this.bytes;
        if (r > 0) {
            var i = 8 - r, a = t < i ? t : i, u = 255 >> 8 - a << (s = i - a);
            e = (o[n] & u) >> s, t -= a, 8 === (r += a) && (r = 0, n++);
        }
        if (t > 0) {
            for(; t >= 8;)e = e << 8 | 255 & o[n], n++, t -= 8;
            if (t > 0) {
                var s;
                u = 255 >> (s = 8 - t) << s;
                e = e << t | (o[n] & u) >> s, r += t;
            }
        }
        return this.bitOffset = r, this.byteOffset = n, e;
    }, t.prototype.available = function() {
        return 8 * (this.bytes.length - this.byteOffset) - this.bitOffset;
    }, t;
}();
!function(t) {
    t[t.PAD_ENCODE = 0] = "PAD_ENCODE", t[t.ASCII_ENCODE = 1] = "ASCII_ENCODE", t[t.C40_ENCODE = 2] = "C40_ENCODE", t[t.TEXT_ENCODE = 3] = "TEXT_ENCODE", t[t.ANSIX12_ENCODE = 4] = "ANSIX12_ENCODE", t[t.EDIFACT_ENCODE = 5] = "EDIFACT_ENCODE", t[t.BASE256_ENCODE = 6] = "BASE256_ENCODE";
}($2be8636d379871d6$var$lr || ($2be8636d379871d6$var$lr = {}));
var $2be8636d379871d6$var$Ar, $2be8636d379871d6$var$Er = function() {
    function t() {}
    return t.decode = function(t) {
        var e = new $2be8636d379871d6$var$mr(t), r = new $2be8636d379871d6$var$k(), n = new $2be8636d379871d6$var$k(), o = new Array(), i = $2be8636d379871d6$var$lr.ASCII_ENCODE;
        do if (i === $2be8636d379871d6$var$lr.ASCII_ENCODE) i = this.decodeAsciiSegment(e, r, n);
        else {
            switch(i){
                case $2be8636d379871d6$var$lr.C40_ENCODE:
                    this.decodeC40Segment(e, r);
                    break;
                case $2be8636d379871d6$var$lr.TEXT_ENCODE:
                    this.decodeTextSegment(e, r);
                    break;
                case $2be8636d379871d6$var$lr.ANSIX12_ENCODE:
                    this.decodeAnsiX12Segment(e, r);
                    break;
                case $2be8636d379871d6$var$lr.EDIFACT_ENCODE:
                    this.decodeEdifactSegment(e, r);
                    break;
                case $2be8636d379871d6$var$lr.BASE256_ENCODE:
                    this.decodeBase256Segment(e, r, o);
                    break;
                default:
                    throw new $2be8636d379871d6$var$R();
            }
            i = $2be8636d379871d6$var$lr.ASCII_ENCODE;
        }
        while (i !== $2be8636d379871d6$var$lr.PAD_ENCODE && e.available() > 0);
        return n.length() > 0 && r.append(n.toString()), new $2be8636d379871d6$var$at(t, r.toString(), 0 === o.length ? null : o, null);
    }, t.decodeAsciiSegment = function(t, e, r) {
        var n = !1;
        do {
            var o = t.readBits(8);
            if (0 === o) throw new $2be8636d379871d6$var$R();
            if (o <= 128) return n && (o += 128), e.append(String.fromCharCode(o - 1)), $2be8636d379871d6$var$lr.ASCII_ENCODE;
            if (129 === o) return $2be8636d379871d6$var$lr.PAD_ENCODE;
            if (o <= 229) {
                var i = o - 130;
                i < 10 && e.append("0"), e.append("" + i);
            } else switch(o){
                case 230:
                    return $2be8636d379871d6$var$lr.C40_ENCODE;
                case 231:
                    return $2be8636d379871d6$var$lr.BASE256_ENCODE;
                case 232:
                    e.append(String.fromCharCode(29));
                    break;
                case 233:
                case 234:
                case 241:
                    break;
                case 235:
                    n = !0;
                    break;
                case 236:
                    e.append("[)>\x1e05\x1d"), r.insert(0, "\x1e\x04");
                    break;
                case 237:
                    e.append("[)>\x1e06\x1d"), r.insert(0, "\x1e\x04");
                    break;
                case 238:
                    return $2be8636d379871d6$var$lr.ANSIX12_ENCODE;
                case 239:
                    return $2be8636d379871d6$var$lr.TEXT_ENCODE;
                case 240:
                    return $2be8636d379871d6$var$lr.EDIFACT_ENCODE;
                default:
                    if (254 !== o || 0 !== t.available()) throw new $2be8636d379871d6$var$R();
            }
        }while (t.available() > 0);
        return $2be8636d379871d6$var$lr.ASCII_ENCODE;
    }, t.decodeC40Segment = function(t, e) {
        var r = !1, n = [], o = 0;
        do {
            if (8 === t.available()) return;
            var i = t.readBits(8);
            if (254 === i) return;
            this.parseTwoBytes(i, t.readBits(8), n);
            for(var a = 0; a < 3; a++){
                var u = n[a];
                switch(o){
                    case 0:
                        if (u < 3) o = u + 1;
                        else {
                            if (!(u < this.C40_BASIC_SET_CHARS.length)) throw new $2be8636d379871d6$var$R();
                            var s = this.C40_BASIC_SET_CHARS[u];
                            r ? (e.append(String.fromCharCode(s.charCodeAt(0) + 128)), r = !1) : e.append(s);
                        }
                        break;
                    case 1:
                        r ? (e.append(String.fromCharCode(u + 128)), r = !1) : e.append(String.fromCharCode(u)), o = 0;
                        break;
                    case 2:
                        if (u < this.C40_SHIFT2_SET_CHARS.length) {
                            s = this.C40_SHIFT2_SET_CHARS[u];
                            r ? (e.append(String.fromCharCode(s.charCodeAt(0) + 128)), r = !1) : e.append(s);
                        } else switch(u){
                            case 27:
                                e.append(String.fromCharCode(29));
                                break;
                            case 30:
                                r = !0;
                                break;
                            default:
                                throw new $2be8636d379871d6$var$R();
                        }
                        o = 0;
                        break;
                    case 3:
                        r ? (e.append(String.fromCharCode(u + 224)), r = !1) : e.append(String.fromCharCode(u + 96)), o = 0;
                        break;
                    default:
                        throw new $2be8636d379871d6$var$R();
                }
            }
        }while (t.available() > 0);
    }, t.decodeTextSegment = function(t, e) {
        var r = !1, n = [], o = 0;
        do {
            if (8 === t.available()) return;
            var i = t.readBits(8);
            if (254 === i) return;
            this.parseTwoBytes(i, t.readBits(8), n);
            for(var a = 0; a < 3; a++){
                var u = n[a];
                switch(o){
                    case 0:
                        if (u < 3) o = u + 1;
                        else {
                            if (!(u < this.TEXT_BASIC_SET_CHARS.length)) throw new $2be8636d379871d6$var$R();
                            var s = this.TEXT_BASIC_SET_CHARS[u];
                            r ? (e.append(String.fromCharCode(s.charCodeAt(0) + 128)), r = !1) : e.append(s);
                        }
                        break;
                    case 1:
                        r ? (e.append(String.fromCharCode(u + 128)), r = !1) : e.append(String.fromCharCode(u)), o = 0;
                        break;
                    case 2:
                        if (u < this.TEXT_SHIFT2_SET_CHARS.length) {
                            s = this.TEXT_SHIFT2_SET_CHARS[u];
                            r ? (e.append(String.fromCharCode(s.charCodeAt(0) + 128)), r = !1) : e.append(s);
                        } else switch(u){
                            case 27:
                                e.append(String.fromCharCode(29));
                                break;
                            case 30:
                                r = !0;
                                break;
                            default:
                                throw new $2be8636d379871d6$var$R();
                        }
                        o = 0;
                        break;
                    case 3:
                        if (!(u < this.TEXT_SHIFT3_SET_CHARS.length)) throw new $2be8636d379871d6$var$R();
                        s = this.TEXT_SHIFT3_SET_CHARS[u];
                        r ? (e.append(String.fromCharCode(s.charCodeAt(0) + 128)), r = !1) : e.append(s), o = 0;
                        break;
                    default:
                        throw new $2be8636d379871d6$var$R();
                }
            }
        }while (t.available() > 0);
    }, t.decodeAnsiX12Segment = function(t, e) {
        var r = [];
        do {
            if (8 === t.available()) return;
            var n = t.readBits(8);
            if (254 === n) return;
            this.parseTwoBytes(n, t.readBits(8), r);
            for(var o = 0; o < 3; o++){
                var i = r[o];
                switch(i){
                    case 0:
                        e.append("\r");
                        break;
                    case 1:
                        e.append("*");
                        break;
                    case 2:
                        e.append(">");
                        break;
                    case 3:
                        e.append(" ");
                        break;
                    default:
                        if (i < 14) e.append(String.fromCharCode(i + 44));
                        else {
                            if (!(i < 40)) throw new $2be8636d379871d6$var$R();
                            e.append(String.fromCharCode(i + 51));
                        }
                }
            }
        }while (t.available() > 0);
    }, t.parseTwoBytes = function(t, e, r) {
        var n = (t << 8) + e - 1, o = Math.floor(n / 1600);
        r[0] = o, n -= 1600 * o, o = Math.floor(n / 40), r[1] = o, r[2] = n - 40 * o;
    }, t.decodeEdifactSegment = function(t, e) {
        do {
            if (t.available() <= 16) return;
            for(var r = 0; r < 4; r++){
                var n = t.readBits(6);
                if (31 === n) {
                    var o = 8 - t.getBitOffset();
                    return void (8 !== o && t.readBits(o));
                }
                0 == (32 & n) && (n |= 64), e.append(String.fromCharCode(n));
            }
        }while (t.available() > 0);
    }, t.decodeBase256Segment = function(t, e, r) {
        var n, o = 1 + t.getByteOffset(), i = this.unrandomize255State(t.readBits(8), o++);
        if ((n = 0 === i ? t.available() / 8 | 0 : i < 250 ? i : 250 * (i - 249) + this.unrandomize255State(t.readBits(8), o++)) < 0) throw new $2be8636d379871d6$var$R();
        for(var a = new Uint8Array(n), u = 0; u < n; u++){
            if (t.available() < 8) throw new $2be8636d379871d6$var$R();
            a[u] = this.unrandomize255State(t.readBits(8), o++);
        }
        r.push(a);
        try {
            e.append($2be8636d379871d6$var$L.decode(a, $2be8636d379871d6$var$F.ISO88591));
        } catch (t) {
            throw new $2be8636d379871d6$var$yt("Platform does not support required encoding: " + t.message);
        }
    }, t.unrandomize255State = function(t, e) {
        var r = t - (149 * e % 255 + 1);
        return r >= 0 ? r : r + 256;
    }, t.C40_BASIC_SET_CHARS = [
        "*",
        "*",
        "*",
        " ",
        "0",
        "1",
        "2",
        "3",
        "4",
        "5",
        "6",
        "7",
        "8",
        "9",
        "A",
        "B",
        "C",
        "D",
        "E",
        "F",
        "G",
        "H",
        "I",
        "J",
        "K",
        "L",
        "M",
        "N",
        "O",
        "P",
        "Q",
        "R",
        "S",
        "T",
        "U",
        "V",
        "W",
        "X",
        "Y",
        "Z"
    ], t.C40_SHIFT2_SET_CHARS = [
        "!",
        '"',
        "#",
        "$",
        "%",
        "&",
        "'",
        "(",
        ")",
        "*",
        "+",
        ",",
        "-",
        ".",
        "/",
        ":",
        ";",
        "<",
        "=",
        ">",
        "?",
        "@",
        "[",
        "\\",
        "]",
        "^",
        "_"
    ], t.TEXT_BASIC_SET_CHARS = [
        "*",
        "*",
        "*",
        " ",
        "0",
        "1",
        "2",
        "3",
        "4",
        "5",
        "6",
        "7",
        "8",
        "9",
        "a",
        "b",
        "c",
        "d",
        "e",
        "f",
        "g",
        "h",
        "i",
        "j",
        "k",
        "l",
        "m",
        "n",
        "o",
        "p",
        "q",
        "r",
        "s",
        "t",
        "u",
        "v",
        "w",
        "x",
        "y",
        "z"
    ], t.TEXT_SHIFT2_SET_CHARS = t.C40_SHIFT2_SET_CHARS, t.TEXT_SHIFT3_SET_CHARS = [
        "`",
        "A",
        "B",
        "C",
        "D",
        "E",
        "F",
        "G",
        "H",
        "I",
        "J",
        "K",
        "L",
        "M",
        "N",
        "O",
        "P",
        "Q",
        "R",
        "S",
        "T",
        "U",
        "V",
        "W",
        "X",
        "Y",
        "Z",
        "{",
        "|",
        "}",
        "~",
        String.fromCharCode(127)
    ], t;
}(), $2be8636d379871d6$var$Cr = function(t) {
    var e = "function" == typeof Symbol && Symbol.iterator, r = e && t[e], n = 0;
    if (r) return r.call(t);
    if (t && "number" == typeof t.length) return {
        next: function() {
            return t && n >= t.length && (t = void 0), {
                value: t && t[n++],
                done: !t
            };
        }
    };
    throw new TypeError(e ? "Object is not iterable." : "Symbol.iterator is not defined.");
}, $2be8636d379871d6$var$Ir = function() {
    function t() {
        this.rsDecoder = new $2be8636d379871d6$var$wt($2be8636d379871d6$var$lt.DATA_MATRIX_FIELD_256);
    }
    return t.prototype.decode = function(t) {
        var e, r, n = new $2be8636d379871d6$var$wr(t), o = n.getVersion(), i = n.readCodewords(), a = $2be8636d379871d6$var$vr.getDataBlocks(i, o), u = 0;
        try {
            for(var s = $2be8636d379871d6$var$Cr(a), c = s.next(); !c.done; c = s.next())u += c.value.getNumDataCodewords();
        } catch (t) {
            e = {
                error: t
            };
        } finally{
            try {
                c && !c.done && (r = s.return) && r.call(s);
            } finally{
                if (e) throw e.error;
            }
        }
        for(var f = new Uint8Array(u), h = a.length, l = 0; l < h; l++){
            var d = a[l], p = d.getCodewords(), g = d.getNumDataCodewords();
            this.correctErrors(p, g);
            for(var y = 0; y < g; y++)f[y * h + l] = p[y];
        }
        return $2be8636d379871d6$var$Er.decode(f);
    }, t.prototype.correctErrors = function(t, e) {
        var r = new Int32Array(t);
        try {
            this.rsDecoder.decode(r, t.length - e);
        } catch (t) {
            throw new $2be8636d379871d6$var$g();
        }
        for(var n = 0; n < e; n++)t[n] = r[n];
    }, t;
}(), $2be8636d379871d6$var$Sr = function() {
    function t(t) {
        this.image = t, this.rectangleDetector = new $2be8636d379871d6$var$St(this.image);
    }
    return t.prototype.detect = function() {
        var e = this.rectangleDetector.detect(), r = this.detectSolid1(e);
        if ((r = this.detectSolid2(r))[3] = this.correctTopRight(r), !r[3]) throw new $2be8636d379871d6$var$U();
        var n = (r = this.shiftToModuleCenter(r))[0], o = r[1], i = r[2], a = r[3], u = this.transitionsBetween(n, a) + 1, s = this.transitionsBetween(i, a) + 1;
        1 == (1 & u) && (u += 1), 1 == (1 & s) && (s += 1), 4 * u < 7 * s && 4 * s < 7 * u && (u = s = Math.max(u, s));
        var c = t.sampleGrid(this.image, n, o, i, a, u, s);
        return new $2be8636d379871d6$var$Et(c, [
            n,
            o,
            i,
            a
        ]);
    }, t.shiftPoint = function(t, e, r) {
        var n = (e.getX() - t.getX()) / (r + 1), o = (e.getY() - t.getY()) / (r + 1);
        return new $2be8636d379871d6$var$At(t.getX() + n, t.getY() + o);
    }, t.moveAway = function(t, e, r) {
        var n = t.getX(), o = t.getY();
        return n < e ? n -= 1 : n += 1, o < r ? o -= 1 : o += 1, new $2be8636d379871d6$var$At(n, o);
    }, t.prototype.detectSolid1 = function(t) {
        var e = t[0], r = t[1], n = t[3], o = t[2], i = this.transitionsBetween(e, r), a = this.transitionsBetween(r, n), u = this.transitionsBetween(n, o), s = this.transitionsBetween(o, e), c = i, f = [
            o,
            e,
            r,
            n
        ];
        return c > a && (c = a, f[0] = e, f[1] = r, f[2] = n, f[3] = o), c > u && (c = u, f[0] = r, f[1] = n, f[2] = o, f[3] = e), c > s && (f[0] = n, f[1] = o, f[2] = e, f[3] = r), f;
    }, t.prototype.detectSolid2 = function(e) {
        var r = e[0], n = e[1], o = e[2], i = e[3], a = this.transitionsBetween(r, i), u = t.shiftPoint(n, o, 4 * (a + 1)), s = t.shiftPoint(o, n, 4 * (a + 1));
        return this.transitionsBetween(u, r) < this.transitionsBetween(s, i) ? (e[0] = r, e[1] = n, e[2] = o, e[3] = i) : (e[0] = n, e[1] = o, e[2] = i, e[3] = r), e;
    }, t.prototype.correctTopRight = function(e) {
        var r = e[0], n = e[1], o = e[2], i = e[3], a = this.transitionsBetween(r, i), u = this.transitionsBetween(n, i), s = t.shiftPoint(r, n, 4 * (u + 1)), c = t.shiftPoint(o, n, 4 * (a + 1));
        a = this.transitionsBetween(s, i), u = this.transitionsBetween(c, i);
        var f = new $2be8636d379871d6$var$At(i.getX() + (o.getX() - n.getX()) / (a + 1), i.getY() + (o.getY() - n.getY()) / (a + 1)), h = new $2be8636d379871d6$var$At(i.getX() + (r.getX() - n.getX()) / (u + 1), i.getY() + (r.getY() - n.getY()) / (u + 1));
        return this.isValid(f) ? this.isValid(h) ? this.transitionsBetween(s, f) + this.transitionsBetween(c, f) > this.transitionsBetween(s, h) + this.transitionsBetween(c, h) ? f : h : f : this.isValid(h) ? h : null;
    }, t.prototype.shiftToModuleCenter = function(e) {
        var r = e[0], n = e[1], o = e[2], i = e[3], a = this.transitionsBetween(r, i) + 1, u = this.transitionsBetween(o, i) + 1, s = t.shiftPoint(r, n, 4 * u), c = t.shiftPoint(o, n, 4 * a);
        1 == (1 & (a = this.transitionsBetween(s, i) + 1)) && (a += 1), 1 == (1 & (u = this.transitionsBetween(c, i) + 1)) && (u += 1);
        var f, h, l = (r.getX() + n.getX() + o.getX() + i.getX()) / 4, d = (r.getY() + n.getY() + o.getY() + i.getY()) / 4;
        return r = t.moveAway(r, l, d), n = t.moveAway(n, l, d), o = t.moveAway(o, l, d), i = t.moveAway(i, l, d), s = t.shiftPoint(r, n, 4 * u), s = t.shiftPoint(s, i, 4 * a), f = t.shiftPoint(n, r, 4 * u), f = t.shiftPoint(f, o, 4 * a), c = t.shiftPoint(o, i, 4 * u), c = t.shiftPoint(c, n, 4 * a), h = t.shiftPoint(i, o, 4 * u), [
            s,
            f,
            c,
            h = t.shiftPoint(h, r, 4 * a)
        ];
    }, t.prototype.isValid = function(t) {
        return t.getX() >= 0 && t.getX() < this.image.getWidth() && t.getY() > 0 && t.getY() < this.image.getHeight();
    }, t.sampleGrid = function(t, e, r, n, o, i, a) {
        return $2be8636d379871d6$var$Nt.getInstance().sampleGrid(t, i, a, 0.5, 0.5, i - 0.5, 0.5, i - 0.5, a - 0.5, 0.5, a - 0.5, e.getX(), e.getY(), o.getX(), o.getY(), n.getX(), n.getY(), r.getX(), r.getY());
    }, t.prototype.transitionsBetween = function(t, e) {
        var r = Math.trunc(t.getX()), n = Math.trunc(t.getY()), o = Math.trunc(e.getX()), i = Math.trunc(e.getY()), a = Math.abs(i - n) > Math.abs(o - r);
        if (a) {
            var u = r;
            r = n, n = u, u = o, o = i, i = u;
        }
        for(var s = Math.abs(o - r), c = Math.abs(i - n), f = -s / 2, h = n < i ? 1 : -1, l = r < o ? 1 : -1, d = 0, p = this.image.get(a ? n : r, a ? r : n), g = r, y = n; g !== o; g += l){
            var w = this.image.get(a ? y : g, a ? g : y);
            if (w !== p && (d++, p = w), (f += c) > 0) {
                if (y === i) break;
                y += h, f -= s;
            }
        }
        return d;
    }, t;
}(), $2be8636d379871d6$var$Or = function() {
    function t() {
        this.decoder = new $2be8636d379871d6$var$Ir();
    }
    return t.prototype.decode = function(e, r) {
        var n, o;
        if (void 0 === r && (r = null), null != r && r.has($2be8636d379871d6$var$T.PURE_BARCODE)) {
            var i = t.extractPureBits(e.getBlackMatrix());
            n = this.decoder.decode(i), o = t.NO_POINTS;
        } else {
            var a = new $2be8636d379871d6$var$Sr(e.getBlackMatrix()).detect();
            n = this.decoder.decode(a.getBits()), o = a.getPoints();
        }
        var u = n.getRawBytes(), s = new $2be8636d379871d6$var$et(n.getText(), u, 8 * u.length, o, $2be8636d379871d6$var$nt.DATA_MATRIX, $2be8636d379871d6$var$w.currentTimeMillis()), c = n.getByteSegments();
        null != c && s.putMetadata($2be8636d379871d6$var$it.BYTE_SEGMENTS, c);
        var f = n.getECLevel();
        return null != f && s.putMetadata($2be8636d379871d6$var$it.ERROR_CORRECTION_LEVEL, f), s;
    }, t.prototype.reset = function() {}, t.extractPureBits = function(t) {
        var e = t.getTopLeftOnBit(), r = t.getBottomRightOnBit();
        if (null == e || null == r) throw new $2be8636d379871d6$var$U();
        var n = this.moduleSize(e, t), o = e[1], i = r[1], a = e[0], u = (r[0] - a + 1) / n, s = (i - o + 1) / n;
        if (u <= 0 || s <= 0) throw new $2be8636d379871d6$var$U();
        var c = n / 2;
        o += c, a += c;
        for(var f = new $2be8636d379871d6$var$x(u, s), h = 0; h < s; h++)for(var l = o + h * n, d = 0; d < u; d++)t.get(a + d * n, l) && f.set(d, h);
        return f;
    }, t.moduleSize = function(t, e) {
        for(var r = e.getWidth(), n = t[0], o = t[1]; n < r && e.get(n, o);)n++;
        if (n === r) throw new $2be8636d379871d6$var$U();
        var i = n - t[0];
        if (0 === i) throw new $2be8636d379871d6$var$U();
        return i;
    }, t.NO_POINTS = [], t;
}(), $2be8636d379871d6$var$Tr = function() {
    var t = function(e, r) {
        return t = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(t, e) {
            t.__proto__ = e;
        } || function(t, e) {
            for(var r in e)e.hasOwnProperty(r) && (t[r] = e[r]);
        }, t(e, r);
    };
    return function(e, r) {
        function n() {
            this.constructor = e;
        }
        t(e, r), e.prototype = null === r ? Object.create(r) : (n.prototype = r.prototype, new n());
    };
}();
!function(t) {
    function e(e) {
        return void 0 === e && (e = 500), t.call(this, new $2be8636d379871d6$var$Or(), e) || this;
    }
    $2be8636d379871d6$var$Tr(e, t);
}($2be8636d379871d6$var$tt), function(t) {
    t[t.L = 0] = "L", t[t.M = 1] = "M", t[t.Q = 2] = "Q", t[t.H = 3] = "H";
}($2be8636d379871d6$var$Ar || ($2be8636d379871d6$var$Ar = {}));
var $2be8636d379871d6$var$br, $2be8636d379871d6$var$Rr = function() {
    function t(e, r, n) {
        this.value = e, this.stringValue = r, this.bits = n, t.FOR_BITS.set(n, this), t.FOR_VALUE.set(e, this);
    }
    return t.prototype.getValue = function() {
        return this.value;
    }, t.prototype.getBits = function() {
        return this.bits;
    }, t.fromString = function(e) {
        switch(e){
            case "L":
                return t.L;
            case "M":
                return t.M;
            case "Q":
                return t.Q;
            case "H":
                return t.H;
            default:
                throw new $2be8636d379871d6$var$f(e + "not available");
        }
    }, t.prototype.toString = function() {
        return this.stringValue;
    }, t.prototype.equals = function(e) {
        if (!(e instanceof t)) return !1;
        var r = e;
        return this.value === r.value;
    }, t.forBits = function(e) {
        if (e < 0 || e >= t.FOR_BITS.size) throw new $2be8636d379871d6$var$l();
        return t.FOR_BITS.get(e);
    }, t.FOR_BITS = new Map(), t.FOR_VALUE = new Map(), t.L = new t($2be8636d379871d6$var$Ar.L, "L", 1), t.M = new t($2be8636d379871d6$var$Ar.M, "M", 0), t.Q = new t($2be8636d379871d6$var$Ar.Q, "Q", 3), t.H = new t($2be8636d379871d6$var$Ar.H, "H", 2), t;
}(), $2be8636d379871d6$var$Nr = function(t) {
    var e = "function" == typeof Symbol && Symbol.iterator, r = e && t[e], n = 0;
    if (r) return r.call(t);
    if (t && "number" == typeof t.length) return {
        next: function() {
            return t && n >= t.length && (t = void 0), {
                value: t && t[n++],
                done: !t
            };
        }
    };
    throw new TypeError(e ? "Object is not iterable." : "Symbol.iterator is not defined.");
}, $2be8636d379871d6$var$Dr = function() {
    function t(t) {
        this.errorCorrectionLevel = $2be8636d379871d6$var$Rr.forBits(t >> 3 & 3), this.dataMask = 7 & t;
    }
    return t.numBitsDiffering = function(t, e) {
        return $2be8636d379871d6$var$I.bitCount(t ^ e);
    }, t.decodeFormatInformation = function(e, r) {
        var n = t.doDecodeFormatInformation(e, r);
        return null !== n ? n : t.doDecodeFormatInformation(e ^ t.FORMAT_INFO_MASK_QR, r ^ t.FORMAT_INFO_MASK_QR);
    }, t.doDecodeFormatInformation = function(e, r) {
        var n, o, i = Number.MAX_SAFE_INTEGER, a = 0;
        try {
            for(var u = $2be8636d379871d6$var$Nr(t.FORMAT_INFO_DECODE_LOOKUP), s = u.next(); !s.done; s = u.next()){
                var c = s.value, f = c[0];
                if (f === e || f === r) return new t(c[1]);
                var h = t.numBitsDiffering(e, f);
                h < i && (a = c[1], i = h), e !== r && (h = t.numBitsDiffering(r, f)) < i && (a = c[1], i = h);
            }
        } catch (t) {
            n = {
                error: t
            };
        } finally{
            try {
                s && !s.done && (o = u.return) && o.call(u);
            } finally{
                if (n) throw n.error;
            }
        }
        return i <= 3 ? new t(a) : null;
    }, t.prototype.getErrorCorrectionLevel = function() {
        return this.errorCorrectionLevel;
    }, t.prototype.getDataMask = function() {
        return this.dataMask;
    }, t.prototype.hashCode = function() {
        return this.errorCorrectionLevel.getBits() << 3 | this.dataMask;
    }, t.prototype.equals = function(e) {
        if (!(e instanceof t)) return !1;
        var r = e;
        return this.errorCorrectionLevel === r.errorCorrectionLevel && this.dataMask === r.dataMask;
    }, t.FORMAT_INFO_MASK_QR = 21522, t.FORMAT_INFO_DECODE_LOOKUP = [
        Int32Array.from([
            21522,
            0
        ]),
        Int32Array.from([
            20773,
            1
        ]),
        Int32Array.from([
            24188,
            2
        ]),
        Int32Array.from([
            23371,
            3
        ]),
        Int32Array.from([
            17913,
            4
        ]),
        Int32Array.from([
            16590,
            5
        ]),
        Int32Array.from([
            20375,
            6
        ]),
        Int32Array.from([
            19104,
            7
        ]),
        Int32Array.from([
            30660,
            8
        ]),
        Int32Array.from([
            29427,
            9
        ]),
        Int32Array.from([
            32170,
            10
        ]),
        Int32Array.from([
            30877,
            11
        ]),
        Int32Array.from([
            26159,
            12
        ]),
        Int32Array.from([
            25368,
            13
        ]),
        Int32Array.from([
            27713,
            14
        ]),
        Int32Array.from([
            26998,
            15
        ]),
        Int32Array.from([
            5769,
            16
        ]),
        Int32Array.from([
            5054,
            17
        ]),
        Int32Array.from([
            7399,
            18
        ]),
        Int32Array.from([
            6608,
            19
        ]),
        Int32Array.from([
            1890,
            20
        ]),
        Int32Array.from([
            597,
            21
        ]),
        Int32Array.from([
            3340,
            22
        ]),
        Int32Array.from([
            2107,
            23
        ]),
        Int32Array.from([
            13663,
            24
        ]),
        Int32Array.from([
            12392,
            25
        ]),
        Int32Array.from([
            16177,
            26
        ]),
        Int32Array.from([
            14854,
            27
        ]),
        Int32Array.from([
            9396,
            28
        ]),
        Int32Array.from([
            8579,
            29
        ]),
        Int32Array.from([
            11994,
            30
        ]),
        Int32Array.from([
            11245,
            31
        ])
    ], t;
}(), $2be8636d379871d6$var$Pr = function(t) {
    var e = "function" == typeof Symbol && Symbol.iterator, r = e && t[e], n = 0;
    if (r) return r.call(t);
    if (t && "number" == typeof t.length) return {
        next: function() {
            return t && n >= t.length && (t = void 0), {
                value: t && t[n++],
                done: !t
            };
        }
    };
    throw new TypeError(e ? "Object is not iterable." : "Symbol.iterator is not defined.");
}, $2be8636d379871d6$var$Mr = function() {
    function t(t) {
        for(var e = [], r = 1; r < arguments.length; r++)e[r - 1] = arguments[r];
        this.ecCodewordsPerBlock = t, this.ecBlocks = e;
    }
    return t.prototype.getECCodewordsPerBlock = function() {
        return this.ecCodewordsPerBlock;
    }, t.prototype.getNumBlocks = function() {
        var t, e, r = 0, n = this.ecBlocks;
        try {
            for(var o = $2be8636d379871d6$var$Pr(n), i = o.next(); !i.done; i = o.next())r += i.value.getCount();
        } catch (e) {
            t = {
                error: e
            };
        } finally{
            try {
                i && !i.done && (e = o.return) && e.call(o);
            } finally{
                if (t) throw t.error;
            }
        }
        return r;
    }, t.prototype.getTotalECCodewords = function() {
        return this.ecCodewordsPerBlock * this.getNumBlocks();
    }, t.prototype.getECBlocks = function() {
        return this.ecBlocks;
    }, t;
}(), $2be8636d379871d6$var$Br = function() {
    function t(t, e) {
        this.count = t, this.dataCodewords = e;
    }
    return t.prototype.getCount = function() {
        return this.count;
    }, t.prototype.getDataCodewords = function() {
        return this.dataCodewords;
    }, t;
}(), $2be8636d379871d6$var$Lr = function(t) {
    var e = "function" == typeof Symbol && Symbol.iterator, r = e && t[e], n = 0;
    if (r) return r.call(t);
    if (t && "number" == typeof t.length) return {
        next: function() {
            return t && n >= t.length && (t = void 0), {
                value: t && t[n++],
                done: !t
            };
        }
    };
    throw new TypeError(e ? "Object is not iterable." : "Symbol.iterator is not defined.");
}, $2be8636d379871d6$var$Fr = function() {
    function t(t, e) {
        for(var r, n, o = [], i = 2; i < arguments.length; i++)o[i - 2] = arguments[i];
        this.versionNumber = t, this.alignmentPatternCenters = e, this.ecBlocks = o;
        var a = 0, u = o[0].getECCodewordsPerBlock(), s = o[0].getECBlocks();
        try {
            for(var c = $2be8636d379871d6$var$Lr(s), f = c.next(); !f.done; f = c.next()){
                var h = f.value;
                a += h.getCount() * (h.getDataCodewords() + u);
            }
        } catch (t) {
            r = {
                error: t
            };
        } finally{
            try {
                f && !f.done && (n = c.return) && n.call(c);
            } finally{
                if (r) throw r.error;
            }
        }
        this.totalCodewords = a;
    }
    return t.prototype.getVersionNumber = function() {
        return this.versionNumber;
    }, t.prototype.getAlignmentPatternCenters = function() {
        return this.alignmentPatternCenters;
    }, t.prototype.getTotalCodewords = function() {
        return this.totalCodewords;
    }, t.prototype.getDimensionForVersion = function() {
        return 17 + 4 * this.versionNumber;
    }, t.prototype.getECBlocksForLevel = function(t) {
        return this.ecBlocks[t.getValue()];
    }, t.getProvisionalVersionForDimension = function(t) {
        if (t % 4 != 1) throw new $2be8636d379871d6$var$R();
        try {
            return this.getVersionForNumber((t - 17) / 4);
        } catch (t) {
            throw new $2be8636d379871d6$var$R();
        }
    }, t.getVersionForNumber = function(e) {
        if (e < 1 || e > 40) throw new $2be8636d379871d6$var$l();
        return t.VERSIONS[e - 1];
    }, t.decodeVersionInformation = function(e) {
        for(var r = Number.MAX_SAFE_INTEGER, n = 0, o = 0; o < t.VERSION_DECODE_INFO.length; o++){
            var i = t.VERSION_DECODE_INFO[o];
            if (i === e) return t.getVersionForNumber(o + 7);
            var a = $2be8636d379871d6$var$Dr.numBitsDiffering(e, i);
            a < r && (n = o + 7, r = a);
        }
        return r <= 3 ? t.getVersionForNumber(n) : null;
    }, t.prototype.buildFunctionPattern = function() {
        var t = this.getDimensionForVersion(), e = new $2be8636d379871d6$var$x(t);
        e.setRegion(0, 0, 9, 9), e.setRegion(t - 8, 0, 8, 9), e.setRegion(0, t - 8, 9, 8);
        for(var r = this.alignmentPatternCenters.length, n = 0; n < r; n++)for(var o = this.alignmentPatternCenters[n] - 2, i = 0; i < r; i++)0 === n && (0 === i || i === r - 1) || n === r - 1 && 0 === i || e.setRegion(this.alignmentPatternCenters[i] - 2, o, 5, 5);
        return e.setRegion(6, 9, 1, t - 17), e.setRegion(9, 6, t - 17, 1), this.versionNumber > 6 && (e.setRegion(t - 11, 0, 3, 6), e.setRegion(0, t - 11, 6, 3)), e;
    }, t.prototype.toString = function() {
        return "" + this.versionNumber;
    }, t.VERSION_DECODE_INFO = Int32Array.from([
        31892,
        34236,
        39577,
        42195,
        48118,
        51042,
        55367,
        58893,
        63784,
        68472,
        70749,
        76311,
        79154,
        84390,
        87683,
        92361,
        96236,
        102084,
        102881,
        110507,
        110734,
        117786,
        119615,
        126325,
        127568,
        133589,
        136944,
        141498,
        145311,
        150283,
        152622,
        158308,
        161089,
        167017
    ]), t.VERSIONS = [
        new t(1, new Int32Array(0), new $2be8636d379871d6$var$Mr(7, new $2be8636d379871d6$var$Br(1, 19)), new $2be8636d379871d6$var$Mr(10, new $2be8636d379871d6$var$Br(1, 16)), new $2be8636d379871d6$var$Mr(13, new $2be8636d379871d6$var$Br(1, 13)), new $2be8636d379871d6$var$Mr(17, new $2be8636d379871d6$var$Br(1, 9))),
        new t(2, Int32Array.from([
            6,
            18
        ]), new $2be8636d379871d6$var$Mr(10, new $2be8636d379871d6$var$Br(1, 34)), new $2be8636d379871d6$var$Mr(16, new $2be8636d379871d6$var$Br(1, 28)), new $2be8636d379871d6$var$Mr(22, new $2be8636d379871d6$var$Br(1, 22)), new $2be8636d379871d6$var$Mr(28, new $2be8636d379871d6$var$Br(1, 16))),
        new t(3, Int32Array.from([
            6,
            22
        ]), new $2be8636d379871d6$var$Mr(15, new $2be8636d379871d6$var$Br(1, 55)), new $2be8636d379871d6$var$Mr(26, new $2be8636d379871d6$var$Br(1, 44)), new $2be8636d379871d6$var$Mr(18, new $2be8636d379871d6$var$Br(2, 17)), new $2be8636d379871d6$var$Mr(22, new $2be8636d379871d6$var$Br(2, 13))),
        new t(4, Int32Array.from([
            6,
            26
        ]), new $2be8636d379871d6$var$Mr(20, new $2be8636d379871d6$var$Br(1, 80)), new $2be8636d379871d6$var$Mr(18, new $2be8636d379871d6$var$Br(2, 32)), new $2be8636d379871d6$var$Mr(26, new $2be8636d379871d6$var$Br(2, 24)), new $2be8636d379871d6$var$Mr(16, new $2be8636d379871d6$var$Br(4, 9))),
        new t(5, Int32Array.from([
            6,
            30
        ]), new $2be8636d379871d6$var$Mr(26, new $2be8636d379871d6$var$Br(1, 108)), new $2be8636d379871d6$var$Mr(24, new $2be8636d379871d6$var$Br(2, 43)), new $2be8636d379871d6$var$Mr(18, new $2be8636d379871d6$var$Br(2, 15), new $2be8636d379871d6$var$Br(2, 16)), new $2be8636d379871d6$var$Mr(22, new $2be8636d379871d6$var$Br(2, 11), new $2be8636d379871d6$var$Br(2, 12))),
        new t(6, Int32Array.from([
            6,
            34
        ]), new $2be8636d379871d6$var$Mr(18, new $2be8636d379871d6$var$Br(2, 68)), new $2be8636d379871d6$var$Mr(16, new $2be8636d379871d6$var$Br(4, 27)), new $2be8636d379871d6$var$Mr(24, new $2be8636d379871d6$var$Br(4, 19)), new $2be8636d379871d6$var$Mr(28, new $2be8636d379871d6$var$Br(4, 15))),
        new t(7, Int32Array.from([
            6,
            22,
            38
        ]), new $2be8636d379871d6$var$Mr(20, new $2be8636d379871d6$var$Br(2, 78)), new $2be8636d379871d6$var$Mr(18, new $2be8636d379871d6$var$Br(4, 31)), new $2be8636d379871d6$var$Mr(18, new $2be8636d379871d6$var$Br(2, 14), new $2be8636d379871d6$var$Br(4, 15)), new $2be8636d379871d6$var$Mr(26, new $2be8636d379871d6$var$Br(4, 13), new $2be8636d379871d6$var$Br(1, 14))),
        new t(8, Int32Array.from([
            6,
            24,
            42
        ]), new $2be8636d379871d6$var$Mr(24, new $2be8636d379871d6$var$Br(2, 97)), new $2be8636d379871d6$var$Mr(22, new $2be8636d379871d6$var$Br(2, 38), new $2be8636d379871d6$var$Br(2, 39)), new $2be8636d379871d6$var$Mr(22, new $2be8636d379871d6$var$Br(4, 18), new $2be8636d379871d6$var$Br(2, 19)), new $2be8636d379871d6$var$Mr(26, new $2be8636d379871d6$var$Br(4, 14), new $2be8636d379871d6$var$Br(2, 15))),
        new t(9, Int32Array.from([
            6,
            26,
            46
        ]), new $2be8636d379871d6$var$Mr(30, new $2be8636d379871d6$var$Br(2, 116)), new $2be8636d379871d6$var$Mr(22, new $2be8636d379871d6$var$Br(3, 36), new $2be8636d379871d6$var$Br(2, 37)), new $2be8636d379871d6$var$Mr(20, new $2be8636d379871d6$var$Br(4, 16), new $2be8636d379871d6$var$Br(4, 17)), new $2be8636d379871d6$var$Mr(24, new $2be8636d379871d6$var$Br(4, 12), new $2be8636d379871d6$var$Br(4, 13))),
        new t(10, Int32Array.from([
            6,
            28,
            50
        ]), new $2be8636d379871d6$var$Mr(18, new $2be8636d379871d6$var$Br(2, 68), new $2be8636d379871d6$var$Br(2, 69)), new $2be8636d379871d6$var$Mr(26, new $2be8636d379871d6$var$Br(4, 43), new $2be8636d379871d6$var$Br(1, 44)), new $2be8636d379871d6$var$Mr(24, new $2be8636d379871d6$var$Br(6, 19), new $2be8636d379871d6$var$Br(2, 20)), new $2be8636d379871d6$var$Mr(28, new $2be8636d379871d6$var$Br(6, 15), new $2be8636d379871d6$var$Br(2, 16))),
        new t(11, Int32Array.from([
            6,
            30,
            54
        ]), new $2be8636d379871d6$var$Mr(20, new $2be8636d379871d6$var$Br(4, 81)), new $2be8636d379871d6$var$Mr(30, new $2be8636d379871d6$var$Br(1, 50), new $2be8636d379871d6$var$Br(4, 51)), new $2be8636d379871d6$var$Mr(28, new $2be8636d379871d6$var$Br(4, 22), new $2be8636d379871d6$var$Br(4, 23)), new $2be8636d379871d6$var$Mr(24, new $2be8636d379871d6$var$Br(3, 12), new $2be8636d379871d6$var$Br(8, 13))),
        new t(12, Int32Array.from([
            6,
            32,
            58
        ]), new $2be8636d379871d6$var$Mr(24, new $2be8636d379871d6$var$Br(2, 92), new $2be8636d379871d6$var$Br(2, 93)), new $2be8636d379871d6$var$Mr(22, new $2be8636d379871d6$var$Br(6, 36), new $2be8636d379871d6$var$Br(2, 37)), new $2be8636d379871d6$var$Mr(26, new $2be8636d379871d6$var$Br(4, 20), new $2be8636d379871d6$var$Br(6, 21)), new $2be8636d379871d6$var$Mr(28, new $2be8636d379871d6$var$Br(7, 14), new $2be8636d379871d6$var$Br(4, 15))),
        new t(13, Int32Array.from([
            6,
            34,
            62
        ]), new $2be8636d379871d6$var$Mr(26, new $2be8636d379871d6$var$Br(4, 107)), new $2be8636d379871d6$var$Mr(22, new $2be8636d379871d6$var$Br(8, 37), new $2be8636d379871d6$var$Br(1, 38)), new $2be8636d379871d6$var$Mr(24, new $2be8636d379871d6$var$Br(8, 20), new $2be8636d379871d6$var$Br(4, 21)), new $2be8636d379871d6$var$Mr(22, new $2be8636d379871d6$var$Br(12, 11), new $2be8636d379871d6$var$Br(4, 12))),
        new t(14, Int32Array.from([
            6,
            26,
            46,
            66
        ]), new $2be8636d379871d6$var$Mr(30, new $2be8636d379871d6$var$Br(3, 115), new $2be8636d379871d6$var$Br(1, 116)), new $2be8636d379871d6$var$Mr(24, new $2be8636d379871d6$var$Br(4, 40), new $2be8636d379871d6$var$Br(5, 41)), new $2be8636d379871d6$var$Mr(20, new $2be8636d379871d6$var$Br(11, 16), new $2be8636d379871d6$var$Br(5, 17)), new $2be8636d379871d6$var$Mr(24, new $2be8636d379871d6$var$Br(11, 12), new $2be8636d379871d6$var$Br(5, 13))),
        new t(15, Int32Array.from([
            6,
            26,
            48,
            70
        ]), new $2be8636d379871d6$var$Mr(22, new $2be8636d379871d6$var$Br(5, 87), new $2be8636d379871d6$var$Br(1, 88)), new $2be8636d379871d6$var$Mr(24, new $2be8636d379871d6$var$Br(5, 41), new $2be8636d379871d6$var$Br(5, 42)), new $2be8636d379871d6$var$Mr(30, new $2be8636d379871d6$var$Br(5, 24), new $2be8636d379871d6$var$Br(7, 25)), new $2be8636d379871d6$var$Mr(24, new $2be8636d379871d6$var$Br(11, 12), new $2be8636d379871d6$var$Br(7, 13))),
        new t(16, Int32Array.from([
            6,
            26,
            50,
            74
        ]), new $2be8636d379871d6$var$Mr(24, new $2be8636d379871d6$var$Br(5, 98), new $2be8636d379871d6$var$Br(1, 99)), new $2be8636d379871d6$var$Mr(28, new $2be8636d379871d6$var$Br(7, 45), new $2be8636d379871d6$var$Br(3, 46)), new $2be8636d379871d6$var$Mr(24, new $2be8636d379871d6$var$Br(15, 19), new $2be8636d379871d6$var$Br(2, 20)), new $2be8636d379871d6$var$Mr(30, new $2be8636d379871d6$var$Br(3, 15), new $2be8636d379871d6$var$Br(13, 16))),
        new t(17, Int32Array.from([
            6,
            30,
            54,
            78
        ]), new $2be8636d379871d6$var$Mr(28, new $2be8636d379871d6$var$Br(1, 107), new $2be8636d379871d6$var$Br(5, 108)), new $2be8636d379871d6$var$Mr(28, new $2be8636d379871d6$var$Br(10, 46), new $2be8636d379871d6$var$Br(1, 47)), new $2be8636d379871d6$var$Mr(28, new $2be8636d379871d6$var$Br(1, 22), new $2be8636d379871d6$var$Br(15, 23)), new $2be8636d379871d6$var$Mr(28, new $2be8636d379871d6$var$Br(2, 14), new $2be8636d379871d6$var$Br(17, 15))),
        new t(18, Int32Array.from([
            6,
            30,
            56,
            82
        ]), new $2be8636d379871d6$var$Mr(30, new $2be8636d379871d6$var$Br(5, 120), new $2be8636d379871d6$var$Br(1, 121)), new $2be8636d379871d6$var$Mr(26, new $2be8636d379871d6$var$Br(9, 43), new $2be8636d379871d6$var$Br(4, 44)), new $2be8636d379871d6$var$Mr(28, new $2be8636d379871d6$var$Br(17, 22), new $2be8636d379871d6$var$Br(1, 23)), new $2be8636d379871d6$var$Mr(28, new $2be8636d379871d6$var$Br(2, 14), new $2be8636d379871d6$var$Br(19, 15))),
        new t(19, Int32Array.from([
            6,
            30,
            58,
            86
        ]), new $2be8636d379871d6$var$Mr(28, new $2be8636d379871d6$var$Br(3, 113), new $2be8636d379871d6$var$Br(4, 114)), new $2be8636d379871d6$var$Mr(26, new $2be8636d379871d6$var$Br(3, 44), new $2be8636d379871d6$var$Br(11, 45)), new $2be8636d379871d6$var$Mr(26, new $2be8636d379871d6$var$Br(17, 21), new $2be8636d379871d6$var$Br(4, 22)), new $2be8636d379871d6$var$Mr(26, new $2be8636d379871d6$var$Br(9, 13), new $2be8636d379871d6$var$Br(16, 14))),
        new t(20, Int32Array.from([
            6,
            34,
            62,
            90
        ]), new $2be8636d379871d6$var$Mr(28, new $2be8636d379871d6$var$Br(3, 107), new $2be8636d379871d6$var$Br(5, 108)), new $2be8636d379871d6$var$Mr(26, new $2be8636d379871d6$var$Br(3, 41), new $2be8636d379871d6$var$Br(13, 42)), new $2be8636d379871d6$var$Mr(30, new $2be8636d379871d6$var$Br(15, 24), new $2be8636d379871d6$var$Br(5, 25)), new $2be8636d379871d6$var$Mr(28, new $2be8636d379871d6$var$Br(15, 15), new $2be8636d379871d6$var$Br(10, 16))),
        new t(21, Int32Array.from([
            6,
            28,
            50,
            72,
            94
        ]), new $2be8636d379871d6$var$Mr(28, new $2be8636d379871d6$var$Br(4, 116), new $2be8636d379871d6$var$Br(4, 117)), new $2be8636d379871d6$var$Mr(26, new $2be8636d379871d6$var$Br(17, 42)), new $2be8636d379871d6$var$Mr(28, new $2be8636d379871d6$var$Br(17, 22), new $2be8636d379871d6$var$Br(6, 23)), new $2be8636d379871d6$var$Mr(30, new $2be8636d379871d6$var$Br(19, 16), new $2be8636d379871d6$var$Br(6, 17))),
        new t(22, Int32Array.from([
            6,
            26,
            50,
            74,
            98
        ]), new $2be8636d379871d6$var$Mr(28, new $2be8636d379871d6$var$Br(2, 111), new $2be8636d379871d6$var$Br(7, 112)), new $2be8636d379871d6$var$Mr(28, new $2be8636d379871d6$var$Br(17, 46)), new $2be8636d379871d6$var$Mr(30, new $2be8636d379871d6$var$Br(7, 24), new $2be8636d379871d6$var$Br(16, 25)), new $2be8636d379871d6$var$Mr(24, new $2be8636d379871d6$var$Br(34, 13))),
        new t(23, Int32Array.from([
            6,
            30,
            54,
            78,
            102
        ]), new $2be8636d379871d6$var$Mr(30, new $2be8636d379871d6$var$Br(4, 121), new $2be8636d379871d6$var$Br(5, 122)), new $2be8636d379871d6$var$Mr(28, new $2be8636d379871d6$var$Br(4, 47), new $2be8636d379871d6$var$Br(14, 48)), new $2be8636d379871d6$var$Mr(30, new $2be8636d379871d6$var$Br(11, 24), new $2be8636d379871d6$var$Br(14, 25)), new $2be8636d379871d6$var$Mr(30, new $2be8636d379871d6$var$Br(16, 15), new $2be8636d379871d6$var$Br(14, 16))),
        new t(24, Int32Array.from([
            6,
            28,
            54,
            80,
            106
        ]), new $2be8636d379871d6$var$Mr(30, new $2be8636d379871d6$var$Br(6, 117), new $2be8636d379871d6$var$Br(4, 118)), new $2be8636d379871d6$var$Mr(28, new $2be8636d379871d6$var$Br(6, 45), new $2be8636d379871d6$var$Br(14, 46)), new $2be8636d379871d6$var$Mr(30, new $2be8636d379871d6$var$Br(11, 24), new $2be8636d379871d6$var$Br(16, 25)), new $2be8636d379871d6$var$Mr(30, new $2be8636d379871d6$var$Br(30, 16), new $2be8636d379871d6$var$Br(2, 17))),
        new t(25, Int32Array.from([
            6,
            32,
            58,
            84,
            110
        ]), new $2be8636d379871d6$var$Mr(26, new $2be8636d379871d6$var$Br(8, 106), new $2be8636d379871d6$var$Br(4, 107)), new $2be8636d379871d6$var$Mr(28, new $2be8636d379871d6$var$Br(8, 47), new $2be8636d379871d6$var$Br(13, 48)), new $2be8636d379871d6$var$Mr(30, new $2be8636d379871d6$var$Br(7, 24), new $2be8636d379871d6$var$Br(22, 25)), new $2be8636d379871d6$var$Mr(30, new $2be8636d379871d6$var$Br(22, 15), new $2be8636d379871d6$var$Br(13, 16))),
        new t(26, Int32Array.from([
            6,
            30,
            58,
            86,
            114
        ]), new $2be8636d379871d6$var$Mr(28, new $2be8636d379871d6$var$Br(10, 114), new $2be8636d379871d6$var$Br(2, 115)), new $2be8636d379871d6$var$Mr(28, new $2be8636d379871d6$var$Br(19, 46), new $2be8636d379871d6$var$Br(4, 47)), new $2be8636d379871d6$var$Mr(28, new $2be8636d379871d6$var$Br(28, 22), new $2be8636d379871d6$var$Br(6, 23)), new $2be8636d379871d6$var$Mr(30, new $2be8636d379871d6$var$Br(33, 16), new $2be8636d379871d6$var$Br(4, 17))),
        new t(27, Int32Array.from([
            6,
            34,
            62,
            90,
            118
        ]), new $2be8636d379871d6$var$Mr(30, new $2be8636d379871d6$var$Br(8, 122), new $2be8636d379871d6$var$Br(4, 123)), new $2be8636d379871d6$var$Mr(28, new $2be8636d379871d6$var$Br(22, 45), new $2be8636d379871d6$var$Br(3, 46)), new $2be8636d379871d6$var$Mr(30, new $2be8636d379871d6$var$Br(8, 23), new $2be8636d379871d6$var$Br(26, 24)), new $2be8636d379871d6$var$Mr(30, new $2be8636d379871d6$var$Br(12, 15), new $2be8636d379871d6$var$Br(28, 16))),
        new t(28, Int32Array.from([
            6,
            26,
            50,
            74,
            98,
            122
        ]), new $2be8636d379871d6$var$Mr(30, new $2be8636d379871d6$var$Br(3, 117), new $2be8636d379871d6$var$Br(10, 118)), new $2be8636d379871d6$var$Mr(28, new $2be8636d379871d6$var$Br(3, 45), new $2be8636d379871d6$var$Br(23, 46)), new $2be8636d379871d6$var$Mr(30, new $2be8636d379871d6$var$Br(4, 24), new $2be8636d379871d6$var$Br(31, 25)), new $2be8636d379871d6$var$Mr(30, new $2be8636d379871d6$var$Br(11, 15), new $2be8636d379871d6$var$Br(31, 16))),
        new t(29, Int32Array.from([
            6,
            30,
            54,
            78,
            102,
            126
        ]), new $2be8636d379871d6$var$Mr(30, new $2be8636d379871d6$var$Br(7, 116), new $2be8636d379871d6$var$Br(7, 117)), new $2be8636d379871d6$var$Mr(28, new $2be8636d379871d6$var$Br(21, 45), new $2be8636d379871d6$var$Br(7, 46)), new $2be8636d379871d6$var$Mr(30, new $2be8636d379871d6$var$Br(1, 23), new $2be8636d379871d6$var$Br(37, 24)), new $2be8636d379871d6$var$Mr(30, new $2be8636d379871d6$var$Br(19, 15), new $2be8636d379871d6$var$Br(26, 16))),
        new t(30, Int32Array.from([
            6,
            26,
            52,
            78,
            104,
            130
        ]), new $2be8636d379871d6$var$Mr(30, new $2be8636d379871d6$var$Br(5, 115), new $2be8636d379871d6$var$Br(10, 116)), new $2be8636d379871d6$var$Mr(28, new $2be8636d379871d6$var$Br(19, 47), new $2be8636d379871d6$var$Br(10, 48)), new $2be8636d379871d6$var$Mr(30, new $2be8636d379871d6$var$Br(15, 24), new $2be8636d379871d6$var$Br(25, 25)), new $2be8636d379871d6$var$Mr(30, new $2be8636d379871d6$var$Br(23, 15), new $2be8636d379871d6$var$Br(25, 16))),
        new t(31, Int32Array.from([
            6,
            30,
            56,
            82,
            108,
            134
        ]), new $2be8636d379871d6$var$Mr(30, new $2be8636d379871d6$var$Br(13, 115), new $2be8636d379871d6$var$Br(3, 116)), new $2be8636d379871d6$var$Mr(28, new $2be8636d379871d6$var$Br(2, 46), new $2be8636d379871d6$var$Br(29, 47)), new $2be8636d379871d6$var$Mr(30, new $2be8636d379871d6$var$Br(42, 24), new $2be8636d379871d6$var$Br(1, 25)), new $2be8636d379871d6$var$Mr(30, new $2be8636d379871d6$var$Br(23, 15), new $2be8636d379871d6$var$Br(28, 16))),
        new t(32, Int32Array.from([
            6,
            34,
            60,
            86,
            112,
            138
        ]), new $2be8636d379871d6$var$Mr(30, new $2be8636d379871d6$var$Br(17, 115)), new $2be8636d379871d6$var$Mr(28, new $2be8636d379871d6$var$Br(10, 46), new $2be8636d379871d6$var$Br(23, 47)), new $2be8636d379871d6$var$Mr(30, new $2be8636d379871d6$var$Br(10, 24), new $2be8636d379871d6$var$Br(35, 25)), new $2be8636d379871d6$var$Mr(30, new $2be8636d379871d6$var$Br(19, 15), new $2be8636d379871d6$var$Br(35, 16))),
        new t(33, Int32Array.from([
            6,
            30,
            58,
            86,
            114,
            142
        ]), new $2be8636d379871d6$var$Mr(30, new $2be8636d379871d6$var$Br(17, 115), new $2be8636d379871d6$var$Br(1, 116)), new $2be8636d379871d6$var$Mr(28, new $2be8636d379871d6$var$Br(14, 46), new $2be8636d379871d6$var$Br(21, 47)), new $2be8636d379871d6$var$Mr(30, new $2be8636d379871d6$var$Br(29, 24), new $2be8636d379871d6$var$Br(19, 25)), new $2be8636d379871d6$var$Mr(30, new $2be8636d379871d6$var$Br(11, 15), new $2be8636d379871d6$var$Br(46, 16))),
        new t(34, Int32Array.from([
            6,
            34,
            62,
            90,
            118,
            146
        ]), new $2be8636d379871d6$var$Mr(30, new $2be8636d379871d6$var$Br(13, 115), new $2be8636d379871d6$var$Br(6, 116)), new $2be8636d379871d6$var$Mr(28, new $2be8636d379871d6$var$Br(14, 46), new $2be8636d379871d6$var$Br(23, 47)), new $2be8636d379871d6$var$Mr(30, new $2be8636d379871d6$var$Br(44, 24), new $2be8636d379871d6$var$Br(7, 25)), new $2be8636d379871d6$var$Mr(30, new $2be8636d379871d6$var$Br(59, 16), new $2be8636d379871d6$var$Br(1, 17))),
        new t(35, Int32Array.from([
            6,
            30,
            54,
            78,
            102,
            126,
            150
        ]), new $2be8636d379871d6$var$Mr(30, new $2be8636d379871d6$var$Br(12, 121), new $2be8636d379871d6$var$Br(7, 122)), new $2be8636d379871d6$var$Mr(28, new $2be8636d379871d6$var$Br(12, 47), new $2be8636d379871d6$var$Br(26, 48)), new $2be8636d379871d6$var$Mr(30, new $2be8636d379871d6$var$Br(39, 24), new $2be8636d379871d6$var$Br(14, 25)), new $2be8636d379871d6$var$Mr(30, new $2be8636d379871d6$var$Br(22, 15), new $2be8636d379871d6$var$Br(41, 16))),
        new t(36, Int32Array.from([
            6,
            24,
            50,
            76,
            102,
            128,
            154
        ]), new $2be8636d379871d6$var$Mr(30, new $2be8636d379871d6$var$Br(6, 121), new $2be8636d379871d6$var$Br(14, 122)), new $2be8636d379871d6$var$Mr(28, new $2be8636d379871d6$var$Br(6, 47), new $2be8636d379871d6$var$Br(34, 48)), new $2be8636d379871d6$var$Mr(30, new $2be8636d379871d6$var$Br(46, 24), new $2be8636d379871d6$var$Br(10, 25)), new $2be8636d379871d6$var$Mr(30, new $2be8636d379871d6$var$Br(2, 15), new $2be8636d379871d6$var$Br(64, 16))),
        new t(37, Int32Array.from([
            6,
            28,
            54,
            80,
            106,
            132,
            158
        ]), new $2be8636d379871d6$var$Mr(30, new $2be8636d379871d6$var$Br(17, 122), new $2be8636d379871d6$var$Br(4, 123)), new $2be8636d379871d6$var$Mr(28, new $2be8636d379871d6$var$Br(29, 46), new $2be8636d379871d6$var$Br(14, 47)), new $2be8636d379871d6$var$Mr(30, new $2be8636d379871d6$var$Br(49, 24), new $2be8636d379871d6$var$Br(10, 25)), new $2be8636d379871d6$var$Mr(30, new $2be8636d379871d6$var$Br(24, 15), new $2be8636d379871d6$var$Br(46, 16))),
        new t(38, Int32Array.from([
            6,
            32,
            58,
            84,
            110,
            136,
            162
        ]), new $2be8636d379871d6$var$Mr(30, new $2be8636d379871d6$var$Br(4, 122), new $2be8636d379871d6$var$Br(18, 123)), new $2be8636d379871d6$var$Mr(28, new $2be8636d379871d6$var$Br(13, 46), new $2be8636d379871d6$var$Br(32, 47)), new $2be8636d379871d6$var$Mr(30, new $2be8636d379871d6$var$Br(48, 24), new $2be8636d379871d6$var$Br(14, 25)), new $2be8636d379871d6$var$Mr(30, new $2be8636d379871d6$var$Br(42, 15), new $2be8636d379871d6$var$Br(32, 16))),
        new t(39, Int32Array.from([
            6,
            26,
            54,
            82,
            110,
            138,
            166
        ]), new $2be8636d379871d6$var$Mr(30, new $2be8636d379871d6$var$Br(20, 117), new $2be8636d379871d6$var$Br(4, 118)), new $2be8636d379871d6$var$Mr(28, new $2be8636d379871d6$var$Br(40, 47), new $2be8636d379871d6$var$Br(7, 48)), new $2be8636d379871d6$var$Mr(30, new $2be8636d379871d6$var$Br(43, 24), new $2be8636d379871d6$var$Br(22, 25)), new $2be8636d379871d6$var$Mr(30, new $2be8636d379871d6$var$Br(10, 15), new $2be8636d379871d6$var$Br(67, 16))),
        new t(40, Int32Array.from([
            6,
            30,
            58,
            86,
            114,
            142,
            170
        ]), new $2be8636d379871d6$var$Mr(30, new $2be8636d379871d6$var$Br(19, 118), new $2be8636d379871d6$var$Br(6, 119)), new $2be8636d379871d6$var$Mr(28, new $2be8636d379871d6$var$Br(18, 47), new $2be8636d379871d6$var$Br(31, 48)), new $2be8636d379871d6$var$Mr(30, new $2be8636d379871d6$var$Br(34, 24), new $2be8636d379871d6$var$Br(34, 25)), new $2be8636d379871d6$var$Mr(30, new $2be8636d379871d6$var$Br(20, 15), new $2be8636d379871d6$var$Br(61, 16)))
    ], t;
}();
!function(t) {
    t[t.DATA_MASK_000 = 0] = "DATA_MASK_000", t[t.DATA_MASK_001 = 1] = "DATA_MASK_001", t[t.DATA_MASK_010 = 2] = "DATA_MASK_010", t[t.DATA_MASK_011 = 3] = "DATA_MASK_011", t[t.DATA_MASK_100 = 4] = "DATA_MASK_100", t[t.DATA_MASK_101 = 5] = "DATA_MASK_101", t[t.DATA_MASK_110 = 6] = "DATA_MASK_110", t[t.DATA_MASK_111 = 7] = "DATA_MASK_111";
}($2be8636d379871d6$var$br || ($2be8636d379871d6$var$br = {}));
var $2be8636d379871d6$var$kr, $2be8636d379871d6$var$xr = function() {
    function t(t, e) {
        this.value = t, this.isMasked = e;
    }
    return t.prototype.unmaskBitMatrix = function(t, e) {
        for(var r = 0; r < e; r++)for(var n = 0; n < e; n++)this.isMasked(r, n) && t.flip(n, r);
    }, t.values = new Map([
        [
            $2be8636d379871d6$var$br.DATA_MASK_000,
            new t($2be8636d379871d6$var$br.DATA_MASK_000, function(t, e) {
                return 0 == (t + e & 1);
            })
        ],
        [
            $2be8636d379871d6$var$br.DATA_MASK_001,
            new t($2be8636d379871d6$var$br.DATA_MASK_001, function(t, e) {
                return 0 == (1 & t);
            })
        ],
        [
            $2be8636d379871d6$var$br.DATA_MASK_010,
            new t($2be8636d379871d6$var$br.DATA_MASK_010, function(t, e) {
                return e % 3 == 0;
            })
        ],
        [
            $2be8636d379871d6$var$br.DATA_MASK_011,
            new t($2be8636d379871d6$var$br.DATA_MASK_011, function(t, e) {
                return (t + e) % 3 == 0;
            })
        ],
        [
            $2be8636d379871d6$var$br.DATA_MASK_100,
            new t($2be8636d379871d6$var$br.DATA_MASK_100, function(t, e) {
                return 0 == (Math.floor(t / 2) + Math.floor(e / 3) & 1);
            })
        ],
        [
            $2be8636d379871d6$var$br.DATA_MASK_101,
            new t($2be8636d379871d6$var$br.DATA_MASK_101, function(t, e) {
                return t * e % 6 == 0;
            })
        ],
        [
            $2be8636d379871d6$var$br.DATA_MASK_110,
            new t($2be8636d379871d6$var$br.DATA_MASK_110, function(t, e) {
                return t * e % 6 < 3;
            })
        ],
        [
            $2be8636d379871d6$var$br.DATA_MASK_111,
            new t($2be8636d379871d6$var$br.DATA_MASK_111, function(t, e) {
                return 0 == (t + e + t * e % 3 & 1);
            })
        ]
    ]), t;
}(), $2be8636d379871d6$var$Vr = function() {
    function t(t) {
        var e = t.getHeight();
        if (e < 21 || 1 != (3 & e)) throw new $2be8636d379871d6$var$R();
        this.bitMatrix = t;
    }
    return t.prototype.readFormatInformation = function() {
        if (null !== this.parsedFormatInfo && void 0 !== this.parsedFormatInfo) return this.parsedFormatInfo;
        for(var t = 0, e = 0; e < 6; e++)t = this.copyBit(e, 8, t);
        t = this.copyBit(7, 8, t), t = this.copyBit(8, 8, t), t = this.copyBit(8, 7, t);
        for(var r = 5; r >= 0; r--)t = this.copyBit(8, r, t);
        var n = this.bitMatrix.getHeight(), o = 0, i = n - 7;
        for(r = n - 1; r >= i; r--)o = this.copyBit(8, r, o);
        for(e = n - 8; e < n; e++)o = this.copyBit(e, 8, o);
        if (this.parsedFormatInfo = $2be8636d379871d6$var$Dr.decodeFormatInformation(t, o), null !== this.parsedFormatInfo) return this.parsedFormatInfo;
        throw new $2be8636d379871d6$var$R();
    }, t.prototype.readVersion = function() {
        if (null !== this.parsedVersion && void 0 !== this.parsedVersion) return this.parsedVersion;
        var t = this.bitMatrix.getHeight(), e = Math.floor((t - 17) / 4);
        if (e <= 6) return $2be8636d379871d6$var$Fr.getVersionForNumber(e);
        for(var r = 0, n = t - 11, o = 5; o >= 0; o--)for(var i = t - 9; i >= n; i--)r = this.copyBit(i, o, r);
        var a = $2be8636d379871d6$var$Fr.decodeVersionInformation(r);
        if (null !== a && a.getDimensionForVersion() === t) return this.parsedVersion = a, a;
        r = 0;
        for(i = 5; i >= 0; i--)for(o = t - 9; o >= n; o--)r = this.copyBit(i, o, r);
        if (null !== (a = $2be8636d379871d6$var$Fr.decodeVersionInformation(r)) && a.getDimensionForVersion() === t) return this.parsedVersion = a, a;
        throw new $2be8636d379871d6$var$R();
    }, t.prototype.copyBit = function(t, e, r) {
        return (this.isMirror ? this.bitMatrix.get(e, t) : this.bitMatrix.get(t, e)) ? r << 1 | 1 : r << 1;
    }, t.prototype.readCodewords = function() {
        var t = this.readFormatInformation(), e = this.readVersion(), r = $2be8636d379871d6$var$xr.values.get(t.getDataMask()), n = this.bitMatrix.getHeight();
        r.unmaskBitMatrix(this.bitMatrix, n);
        for(var o = e.buildFunctionPattern(), i = !0, a = new Uint8Array(e.getTotalCodewords()), u = 0, s = 0, c = 0, f = n - 1; f > 0; f -= 2){
            6 === f && f--;
            for(var h = 0; h < n; h++)for(var l = i ? n - 1 - h : h, d = 0; d < 2; d++)o.get(f - d, l) || (c++, s <<= 1, this.bitMatrix.get(f - d, l) && (s |= 1), 8 === c && (a[u++] = s, c = 0, s = 0));
            i = !i;
        }
        if (u !== e.getTotalCodewords()) throw new $2be8636d379871d6$var$R();
        return a;
    }, t.prototype.remask = function() {
        if (null !== this.parsedFormatInfo) {
            var t = $2be8636d379871d6$var$xr.values[this.parsedFormatInfo.getDataMask()], e = this.bitMatrix.getHeight();
            t.unmaskBitMatrix(this.bitMatrix, e);
        }
    }, t.prototype.setMirror = function(t) {
        this.parsedVersion = null, this.parsedFormatInfo = null, this.isMirror = t;
    }, t.prototype.mirror = function() {
        for(var t = this.bitMatrix, e = 0, r = t.getWidth(); e < r; e++)for(var n = e + 1, o = t.getHeight(); n < o; n++)t.get(e, n) !== t.get(n, e) && (t.flip(n, e), t.flip(e, n));
    }, t;
}(), $2be8636d379871d6$var$Ur = function(t) {
    var e = "function" == typeof Symbol && Symbol.iterator, r = e && t[e], n = 0;
    if (r) return r.call(t);
    if (t && "number" == typeof t.length) return {
        next: function() {
            return t && n >= t.length && (t = void 0), {
                value: t && t[n++],
                done: !t
            };
        }
    };
    throw new TypeError(e ? "Object is not iterable." : "Symbol.iterator is not defined.");
}, $2be8636d379871d6$var$Hr = function() {
    function t(t, e) {
        this.numDataCodewords = t, this.codewords = e;
    }
    return t.getDataBlocks = function(e, r, n) {
        var o, i, a, u;
        if (e.length !== r.getTotalCodewords()) throw new $2be8636d379871d6$var$l();
        var s = r.getECBlocksForLevel(n), c = 0, f = s.getECBlocks();
        try {
            for(var h = $2be8636d379871d6$var$Ur(f), d = h.next(); !d.done; d = h.next())c += (_ = d.value).getCount();
        } catch (t) {
            o = {
                error: t
            };
        } finally{
            try {
                d && !d.done && (i = h.return) && i.call(h);
            } finally{
                if (o) throw o.error;
            }
        }
        var p = new Array(c), g = 0;
        try {
            for(var y = $2be8636d379871d6$var$Ur(f), w = y.next(); !w.done; w = y.next())for(var _ = w.value, v = 0; v < _.getCount(); v++){
                var m = _.getDataCodewords(), A = s.getECCodewordsPerBlock() + m;
                p[g++] = new t(m, new Uint8Array(A));
            }
        } catch (t) {
            a = {
                error: t
            };
        } finally{
            try {
                w && !w.done && (u = y.return) && u.call(y);
            } finally{
                if (a) throw a.error;
            }
        }
        for(var E = p[0].codewords.length, C = p.length - 1; C >= 0;){
            if (p[C].codewords.length === E) break;
            C--;
        }
        C++;
        var I = E - s.getECCodewordsPerBlock(), S = 0;
        for(v = 0; v < I; v++)for(var O = 0; O < g; O++)p[O].codewords[v] = e[S++];
        for(O = C; O < g; O++)p[O].codewords[I] = e[S++];
        var T = p[0].codewords.length;
        for(v = I; v < T; v++)for(O = 0; O < g; O++){
            var b = O < C ? v : v + 1;
            p[O].codewords[b] = e[S++];
        }
        return p;
    }, t.prototype.getNumDataCodewords = function() {
        return this.numDataCodewords;
    }, t.prototype.getCodewords = function() {
        return this.codewords;
    }, t;
}();
!function(t) {
    t[t.TERMINATOR = 0] = "TERMINATOR", t[t.NUMERIC = 1] = "NUMERIC", t[t.ALPHANUMERIC = 2] = "ALPHANUMERIC", t[t.STRUCTURED_APPEND = 3] = "STRUCTURED_APPEND", t[t.BYTE = 4] = "BYTE", t[t.ECI = 5] = "ECI", t[t.KANJI = 6] = "KANJI", t[t.FNC1_FIRST_POSITION = 7] = "FNC1_FIRST_POSITION", t[t.FNC1_SECOND_POSITION = 8] = "FNC1_SECOND_POSITION", t[t.HANZI = 9] = "HANZI";
}($2be8636d379871d6$var$kr || ($2be8636d379871d6$var$kr = {}));
var $2be8636d379871d6$var$Gr, $2be8636d379871d6$var$Xr, $2be8636d379871d6$var$Wr = function() {
    function t(e, r, n, o) {
        this.value = e, this.stringValue = r, this.characterCountBitsForVersions = n, this.bits = o, t.FOR_BITS.set(o, this), t.FOR_VALUE.set(e, this);
    }
    return t.forBits = function(e) {
        var r = t.FOR_BITS.get(e);
        if (void 0 === r) throw new $2be8636d379871d6$var$l();
        return r;
    }, t.prototype.getCharacterCountBits = function(t) {
        var e, r = t.getVersionNumber();
        return e = r <= 9 ? 0 : r <= 26 ? 1 : 2, this.characterCountBitsForVersions[e];
    }, t.prototype.getValue = function() {
        return this.value;
    }, t.prototype.getBits = function() {
        return this.bits;
    }, t.prototype.equals = function(e) {
        if (!(e instanceof t)) return !1;
        var r = e;
        return this.value === r.value;
    }, t.prototype.toString = function() {
        return this.stringValue;
    }, t.FOR_BITS = new Map(), t.FOR_VALUE = new Map(), t.TERMINATOR = new t($2be8636d379871d6$var$kr.TERMINATOR, "TERMINATOR", Int32Array.from([
        0,
        0,
        0
    ]), 0), t.NUMERIC = new t($2be8636d379871d6$var$kr.NUMERIC, "NUMERIC", Int32Array.from([
        10,
        12,
        14
    ]), 1), t.ALPHANUMERIC = new t($2be8636d379871d6$var$kr.ALPHANUMERIC, "ALPHANUMERIC", Int32Array.from([
        9,
        11,
        13
    ]), 2), t.STRUCTURED_APPEND = new t($2be8636d379871d6$var$kr.STRUCTURED_APPEND, "STRUCTURED_APPEND", Int32Array.from([
        0,
        0,
        0
    ]), 3), t.BYTE = new t($2be8636d379871d6$var$kr.BYTE, "BYTE", Int32Array.from([
        8,
        16,
        16
    ]), 4), t.ECI = new t($2be8636d379871d6$var$kr.ECI, "ECI", Int32Array.from([
        0,
        0,
        0
    ]), 7), t.KANJI = new t($2be8636d379871d6$var$kr.KANJI, "KANJI", Int32Array.from([
        8,
        10,
        12
    ]), 8), t.FNC1_FIRST_POSITION = new t($2be8636d379871d6$var$kr.FNC1_FIRST_POSITION, "FNC1_FIRST_POSITION", Int32Array.from([
        0,
        0,
        0
    ]), 5), t.FNC1_SECOND_POSITION = new t($2be8636d379871d6$var$kr.FNC1_SECOND_POSITION, "FNC1_SECOND_POSITION", Int32Array.from([
        0,
        0,
        0
    ]), 9), t.HANZI = new t($2be8636d379871d6$var$kr.HANZI, "HANZI", Int32Array.from([
        8,
        10,
        12
    ]), 13), t;
}(), $2be8636d379871d6$var$jr = function() {
    function t() {}
    return t.decode = function(e, r, n, o) {
        var i = new $2be8636d379871d6$var$mr(e), a = new $2be8636d379871d6$var$k(), u = new Array(), s = -1, c = -1;
        try {
            var f = null, h = !1, l = void 0;
            do {
                if (i.available() < 4) l = $2be8636d379871d6$var$Wr.TERMINATOR;
                else {
                    var d = i.readBits(4);
                    l = $2be8636d379871d6$var$Wr.forBits(d);
                }
                switch(l){
                    case $2be8636d379871d6$var$Wr.TERMINATOR:
                        break;
                    case $2be8636d379871d6$var$Wr.FNC1_FIRST_POSITION:
                    case $2be8636d379871d6$var$Wr.FNC1_SECOND_POSITION:
                        h = !0;
                        break;
                    case $2be8636d379871d6$var$Wr.STRUCTURED_APPEND:
                        if (i.available() < 16) throw new $2be8636d379871d6$var$R();
                        s = i.readBits(8), c = i.readBits(8);
                        break;
                    case $2be8636d379871d6$var$Wr.ECI:
                        var p = t.parseECIValue(i);
                        if (null === (f = $2be8636d379871d6$var$P.getCharacterSetECIByValue(p))) throw new $2be8636d379871d6$var$R();
                        break;
                    case $2be8636d379871d6$var$Wr.HANZI:
                        var g = i.readBits(4), y = i.readBits(l.getCharacterCountBits(r));
                        g === t.GB2312_SUBSET && t.decodeHanziSegment(i, a, y);
                        break;
                    default:
                        var w = i.readBits(l.getCharacterCountBits(r));
                        switch(l){
                            case $2be8636d379871d6$var$Wr.NUMERIC:
                                t.decodeNumericSegment(i, a, w);
                                break;
                            case $2be8636d379871d6$var$Wr.ALPHANUMERIC:
                                t.decodeAlphanumericSegment(i, a, w, h);
                                break;
                            case $2be8636d379871d6$var$Wr.BYTE:
                                t.decodeByteSegment(i, a, w, f, u, o);
                                break;
                            case $2be8636d379871d6$var$Wr.KANJI:
                                t.decodeKanjiSegment(i, a, w);
                                break;
                            default:
                                throw new $2be8636d379871d6$var$R();
                        }
                }
            }while (l !== $2be8636d379871d6$var$Wr.TERMINATOR);
        } catch (t) {
            throw new $2be8636d379871d6$var$R();
        }
        return new $2be8636d379871d6$var$at(e, a.toString(), 0 === u.length ? null : u, null === n ? null : n.toString(), s, c);
    }, t.decodeHanziSegment = function(t, e, r) {
        if (13 * r > t.available()) throw new $2be8636d379871d6$var$R();
        for(var n = new Uint8Array(2 * r), o = 0; r > 0;){
            var i = t.readBits(13), a = i / 96 << 8 & 4294967295 | i % 96;
            a += a < 959 ? 41377 : 42657, n[o] = a >> 8 & 255, n[o + 1] = 255 & a, o += 2, r--;
        }
        try {
            e.append($2be8636d379871d6$var$L.decode(n, $2be8636d379871d6$var$F.GB2312));
        } catch (t) {
            throw new $2be8636d379871d6$var$R(t);
        }
    }, t.decodeKanjiSegment = function(t, e, r) {
        if (13 * r > t.available()) throw new $2be8636d379871d6$var$R();
        for(var n = new Uint8Array(2 * r), o = 0; r > 0;){
            var i = t.readBits(13), a = i / 192 << 8 & 4294967295 | i % 192;
            a += a < 7936 ? 33088 : 49472, n[o] = a >> 8, n[o + 1] = a, o += 2, r--;
        }
        try {
            e.append($2be8636d379871d6$var$L.decode(n, $2be8636d379871d6$var$F.SHIFT_JIS));
        } catch (t) {
            throw new $2be8636d379871d6$var$R(t);
        }
    }, t.decodeByteSegment = function(t, e, r, n, o, i) {
        if (8 * r > t.available()) throw new $2be8636d379871d6$var$R();
        for(var a, u = new Uint8Array(r), s = 0; s < r; s++)u[s] = t.readBits(8);
        a = null === n ? $2be8636d379871d6$var$F.guessEncoding(u, i) : n.getName();
        try {
            e.append($2be8636d379871d6$var$L.decode(u, a));
        } catch (t) {
            throw new $2be8636d379871d6$var$R(t);
        }
        o.push(u);
    }, t.toAlphaNumericChar = function(e) {
        if (e >= t.ALPHANUMERIC_CHARS.length) throw new $2be8636d379871d6$var$R();
        return t.ALPHANUMERIC_CHARS[e];
    }, t.decodeAlphanumericSegment = function(e, r, n, o) {
        for(var i = r.length(); n > 1;){
            if (e.available() < 11) throw new $2be8636d379871d6$var$R();
            var a = e.readBits(11);
            r.append(t.toAlphaNumericChar(Math.floor(a / 45))), r.append(t.toAlphaNumericChar(a % 45)), n -= 2;
        }
        if (1 === n) {
            if (e.available() < 6) throw new $2be8636d379871d6$var$R();
            r.append(t.toAlphaNumericChar(e.readBits(6)));
        }
        if (o) for(var u = i; u < r.length(); u++)"%" === r.charAt(u) && (u < r.length() - 1 && "%" === r.charAt(u + 1) ? r.deleteCharAt(u + 1) : r.setCharAt(u, String.fromCharCode(29)));
    }, t.decodeNumericSegment = function(e, r, n) {
        for(; n >= 3;){
            if (e.available() < 10) throw new $2be8636d379871d6$var$R();
            var o = e.readBits(10);
            if (o >= 1e3) throw new $2be8636d379871d6$var$R();
            r.append(t.toAlphaNumericChar(Math.floor(o / 100))), r.append(t.toAlphaNumericChar(Math.floor(o / 10) % 10)), r.append(t.toAlphaNumericChar(o % 10)), n -= 3;
        }
        if (2 === n) {
            if (e.available() < 7) throw new $2be8636d379871d6$var$R();
            var i = e.readBits(7);
            if (i >= 100) throw new $2be8636d379871d6$var$R();
            r.append(t.toAlphaNumericChar(Math.floor(i / 10))), r.append(t.toAlphaNumericChar(i % 10));
        } else if (1 === n) {
            if (e.available() < 4) throw new $2be8636d379871d6$var$R();
            var a = e.readBits(4);
            if (a >= 10) throw new $2be8636d379871d6$var$R();
            r.append(t.toAlphaNumericChar(a));
        }
    }, t.parseECIValue = function(t) {
        var e = t.readBits(8);
        if (0 == (128 & e)) return 127 & e;
        if (128 == (192 & e)) return (63 & e) << 8 & 4294967295 | t.readBits(8);
        if (192 == (224 & e)) return (31 & e) << 16 & 4294967295 | t.readBits(16);
        throw new $2be8636d379871d6$var$R();
    }, t.ALPHANUMERIC_CHARS = "0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZ $%*+-./:", t.GB2312_SUBSET = 1, t;
}(), $2be8636d379871d6$var$zr = function() {
    function t(t) {
        this.mirrored = t;
    }
    return t.prototype.isMirrored = function() {
        return this.mirrored;
    }, t.prototype.applyMirroredCorrection = function(t) {
        if (this.mirrored && null !== t && !(t.length < 3)) {
            var e = t[0];
            t[0] = t[2], t[2] = e;
        }
    }, t;
}(), $2be8636d379871d6$var$Yr = function(t) {
    var e = "function" == typeof Symbol && Symbol.iterator, r = e && t[e], n = 0;
    if (r) return r.call(t);
    if (t && "number" == typeof t.length) return {
        next: function() {
            return t && n >= t.length && (t = void 0), {
                value: t && t[n++],
                done: !t
            };
        }
    };
    throw new TypeError(e ? "Object is not iterable." : "Symbol.iterator is not defined.");
}, $2be8636d379871d6$var$Zr = function() {
    function t() {
        this.rsDecoder = new $2be8636d379871d6$var$wt($2be8636d379871d6$var$lt.QR_CODE_FIELD_256);
    }
    return t.prototype.decodeBooleanArray = function(t, e) {
        return this.decodeBitMatrix($2be8636d379871d6$var$x.parseFromBooleanArray(t), e);
    }, t.prototype.decodeBitMatrix = function(t, e) {
        var r = new $2be8636d379871d6$var$Vr(t), n = null;
        try {
            return this.decodeBitMatrixParser(r, e);
        } catch (t) {
            n = t;
        }
        try {
            r.remask(), r.setMirror(!0), r.readVersion(), r.readFormatInformation(), r.mirror();
            var o = this.decodeBitMatrixParser(r, e);
            return o.setOther(new $2be8636d379871d6$var$zr(!0)), o;
        } catch (t) {
            if (null !== n) throw n;
            throw t;
        }
    }, t.prototype.decodeBitMatrixParser = function(t, e) {
        var r, n, o, i, a = t.readVersion(), u = t.readFormatInformation().getErrorCorrectionLevel(), s = t.readCodewords(), c = $2be8636d379871d6$var$Hr.getDataBlocks(s, a, u), f = 0;
        try {
            for(var h = $2be8636d379871d6$var$Yr(c), l = h.next(); !l.done; l = h.next())f += (w = l.value).getNumDataCodewords();
        } catch (t) {
            r = {
                error: t
            };
        } finally{
            try {
                l && !l.done && (n = h.return) && n.call(h);
            } finally{
                if (r) throw r.error;
            }
        }
        var d = new Uint8Array(f), p = 0;
        try {
            for(var g = $2be8636d379871d6$var$Yr(c), y = g.next(); !y.done; y = g.next()){
                var w, _ = (w = y.value).getCodewords(), v = w.getNumDataCodewords();
                this.correctErrors(_, v);
                for(var m = 0; m < v; m++)d[p++] = _[m];
            }
        } catch (t) {
            o = {
                error: t
            };
        } finally{
            try {
                y && !y.done && (i = g.return) && i.call(g);
            } finally{
                if (o) throw o.error;
            }
        }
        return $2be8636d379871d6$var$jr.decode(d, a, u, e);
    }, t.prototype.correctErrors = function(t, e) {
        var r = new Int32Array(t);
        try {
            this.rsDecoder.decode(r, t.length - e);
        } catch (t) {
            throw new $2be8636d379871d6$var$g();
        }
        for(var n = 0; n < e; n++)t[n] = r[n];
    }, t;
}(), $2be8636d379871d6$var$Kr = function() {
    var t = function(e, r) {
        return t = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(t, e) {
            t.__proto__ = e;
        } || function(t, e) {
            for(var r in e)e.hasOwnProperty(r) && (t[r] = e[r]);
        }, t(e, r);
    };
    return function(e, r) {
        function n() {
            this.constructor = e;
        }
        t(e, r), e.prototype = null === r ? Object.create(r) : (n.prototype = r.prototype, new n());
    };
}(), $2be8636d379871d6$var$qr = function(t) {
    function e(e, r, n) {
        var o = t.call(this, e, r) || this;
        return o.estimatedModuleSize = n, o;
    }
    return $2be8636d379871d6$var$Kr(e, t), e.prototype.aboutEquals = function(t, e, r) {
        if (Math.abs(e - this.getY()) <= t && Math.abs(r - this.getX()) <= t) {
            var n = Math.abs(t - this.estimatedModuleSize);
            return n <= 1 || n <= this.estimatedModuleSize;
        }
        return !1;
    }, e.prototype.combineEstimate = function(t, r, n) {
        return new e((this.getX() + r) / 2, (this.getY() + t) / 2, (this.estimatedModuleSize + n) / 2);
    }, e;
}($2be8636d379871d6$var$At), $2be8636d379871d6$var$Qr = function(t) {
    var e = "function" == typeof Symbol && Symbol.iterator, r = e && t[e], n = 0;
    if (r) return r.call(t);
    if (t && "number" == typeof t.length) return {
        next: function() {
            return t && n >= t.length && (t = void 0), {
                value: t && t[n++],
                done: !t
            };
        }
    };
    throw new TypeError(e ? "Object is not iterable." : "Symbol.iterator is not defined.");
}, $2be8636d379871d6$var$Jr = function() {
    function t(t, e, r, n, o, i, a) {
        this.image = t, this.startX = e, this.startY = r, this.width = n, this.height = o, this.moduleSize = i, this.resultPointCallback = a, this.possibleCenters = [], this.crossCheckStateCount = new Int32Array(3);
    }
    return t.prototype.find = function() {
        for(var t = this.startX, e = this.height, r = t + this.width, n = this.startY + e / 2, o = new Int32Array(3), i = this.image, a = 0; a < e; a++){
            var u = n + (0 == (1 & a) ? Math.floor((a + 1) / 2) : -Math.floor((a + 1) / 2));
            o[0] = 0, o[1] = 0, o[2] = 0;
            for(var s = t; s < r && !i.get(s, u);)s++;
            for(var c = 0; s < r;){
                if (i.get(s, u)) {
                    if (1 === c) o[1]++;
                    else if (2 === c) {
                        var f;
                        if (this.foundPatternCross(o)) {
                            if (null !== (f = this.handlePossibleCenter(o, u, s))) return f;
                        }
                        o[0] = o[2], o[1] = 1, o[2] = 0, c = 1;
                    } else o[++c]++;
                } else 1 === c && c++, o[c]++;
                s++;
            }
            if (this.foundPatternCross(o)) {
                if (null !== (f = this.handlePossibleCenter(o, u, r))) return f;
            }
        }
        if (0 !== this.possibleCenters.length) return this.possibleCenters[0];
        throw new $2be8636d379871d6$var$U();
    }, t.centerFromEnd = function(t, e) {
        return e - t[2] - t[1] / 2;
    }, t.prototype.foundPatternCross = function(t) {
        for(var e = this.moduleSize, r = e / 2, n = 0; n < 3; n++)if (Math.abs(e - t[n]) >= r) return !1;
        return !0;
    }, t.prototype.crossCheckVertical = function(e, r, n, o) {
        var i = this.image, a = i.getHeight(), u = this.crossCheckStateCount;
        u[0] = 0, u[1] = 0, u[2] = 0;
        for(var s = e; s >= 0 && i.get(r, s) && u[1] <= n;)u[1]++, s--;
        if (s < 0 || u[1] > n) return NaN;
        for(; s >= 0 && !i.get(r, s) && u[0] <= n;)u[0]++, s--;
        if (u[0] > n) return NaN;
        for(s = e + 1; s < a && i.get(r, s) && u[1] <= n;)u[1]++, s++;
        if (s === a || u[1] > n) return NaN;
        for(; s < a && !i.get(r, s) && u[2] <= n;)u[2]++, s++;
        if (u[2] > n) return NaN;
        var c = u[0] + u[1] + u[2];
        return 5 * Math.abs(c - o) >= 2 * o ? NaN : this.foundPatternCross(u) ? t.centerFromEnd(u, s) : NaN;
    }, t.prototype.handlePossibleCenter = function(e, r, n) {
        var o, i, a = e[0] + e[1] + e[2], u = t.centerFromEnd(e, n), s = this.crossCheckVertical(r, u, 2 * e[1], a);
        if (!isNaN(s)) {
            var c = (e[0] + e[1] + e[2]) / 3;
            try {
                for(var f = $2be8636d379871d6$var$Qr(this.possibleCenters), h = f.next(); !h.done; h = f.next()){
                    var l = h.value;
                    if (l.aboutEquals(c, s, u)) return l.combineEstimate(s, u, c);
                }
            } catch (t) {
                o = {
                    error: t
                };
            } finally{
                try {
                    h && !h.done && (i = f.return) && i.call(f);
                } finally{
                    if (o) throw o.error;
                }
            }
            var d = new $2be8636d379871d6$var$qr(u, s, c);
            this.possibleCenters.push(d), null !== this.resultPointCallback && void 0 !== this.resultPointCallback && this.resultPointCallback.foundPossibleResultPoint(d);
        }
        return null;
    }, t;
}(), $2be8636d379871d6$var$$r = function() {
    var t = function(e, r) {
        return t = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(t, e) {
            t.__proto__ = e;
        } || function(t, e) {
            for(var r in e)e.hasOwnProperty(r) && (t[r] = e[r]);
        }, t(e, r);
    };
    return function(e, r) {
        function n() {
            this.constructor = e;
        }
        t(e, r), e.prototype = null === r ? Object.create(r) : (n.prototype = r.prototype, new n());
    };
}(), $2be8636d379871d6$var$tn = function(t) {
    function e(e, r, n, o) {
        var i = t.call(this, e, r) || this;
        return i.estimatedModuleSize = n, i.count = o, void 0 === o && (i.count = 1), i;
    }
    return $2be8636d379871d6$var$$r(e, t), e.prototype.getEstimatedModuleSize = function() {
        return this.estimatedModuleSize;
    }, e.prototype.getCount = function() {
        return this.count;
    }, e.prototype.aboutEquals = function(t, e, r) {
        if (Math.abs(e - this.getY()) <= t && Math.abs(r - this.getX()) <= t) {
            var n = Math.abs(t - this.estimatedModuleSize);
            return n <= 1 || n <= this.estimatedModuleSize;
        }
        return !1;
    }, e.prototype.combineEstimate = function(t, r, n) {
        var o = this.count + 1;
        return new e((this.count * this.getX() + r) / o, (this.count * this.getY() + t) / o, (this.count * this.estimatedModuleSize + n) / o, o);
    }, e;
}($2be8636d379871d6$var$At), $2be8636d379871d6$var$en = function() {
    function t(t) {
        this.bottomLeft = t[0], this.topLeft = t[1], this.topRight = t[2];
    }
    return t.prototype.getBottomLeft = function() {
        return this.bottomLeft;
    }, t.prototype.getTopLeft = function() {
        return this.topLeft;
    }, t.prototype.getTopRight = function() {
        return this.topRight;
    }, t;
}(), $2be8636d379871d6$var$rn = function(t) {
    var e = "function" == typeof Symbol && Symbol.iterator, r = e && t[e], n = 0;
    if (r) return r.call(t);
    if (t && "number" == typeof t.length) return {
        next: function() {
            return t && n >= t.length && (t = void 0), {
                value: t && t[n++],
                done: !t
            };
        }
    };
    throw new TypeError(e ? "Object is not iterable." : "Symbol.iterator is not defined.");
}, $2be8636d379871d6$var$nn = function() {
    function t(t, e) {
        this.image = t, this.resultPointCallback = e, this.possibleCenters = [], this.crossCheckStateCount = new Int32Array(5), this.resultPointCallback = e;
    }
    return t.prototype.getImage = function() {
        return this.image;
    }, t.prototype.getPossibleCenters = function() {
        return this.possibleCenters;
    }, t.prototype.find = function(e) {
        var r = null != e && void 0 !== e.get($2be8636d379871d6$var$T.TRY_HARDER), n = null != e && void 0 !== e.get($2be8636d379871d6$var$T.PURE_BARCODE), o = this.image, i = o.getHeight(), a = o.getWidth(), u = Math.floor(3 * i / (4 * t.MAX_MODULES));
        (u < t.MIN_SKIP || r) && (u = t.MIN_SKIP);
        for(var s = !1, c = new Int32Array(5), f = u - 1; f < i && !s; f += u){
            c[0] = 0, c[1] = 0, c[2] = 0, c[3] = 0, c[4] = 0;
            for(var h = 0, l = 0; l < a; l++)if (o.get(l, f)) 1 == (1 & h) && h++, c[h]++;
            else if (0 == (1 & h)) {
                if (4 === h) {
                    if (t.foundPatternCross(c)) {
                        if (!0 !== this.handlePossibleCenter(c, f, l, n)) {
                            c[0] = c[2], c[1] = c[3], c[2] = c[4], c[3] = 1, c[4] = 0, h = 3;
                            continue;
                        }
                        if (u = 2, !0 === this.hasSkipped) s = this.haveMultiplyConfirmedCenters();
                        else {
                            var d = this.findRowSkip();
                            d > c[2] && (f += d - c[2] - u, l = a - 1);
                        }
                        h = 0, c[0] = 0, c[1] = 0, c[2] = 0, c[3] = 0, c[4] = 0;
                    } else c[0] = c[2], c[1] = c[3], c[2] = c[4], c[3] = 1, c[4] = 0, h = 3;
                } else c[++h]++;
            } else c[h]++;
            if (t.foundPatternCross(c)) !0 === this.handlePossibleCenter(c, f, a, n) && (u = c[0], this.hasSkipped && (s = this.haveMultiplyConfirmedCenters()));
        }
        var p = this.selectBestPatterns();
        return $2be8636d379871d6$var$At.orderBestPatterns(p), new $2be8636d379871d6$var$en(p);
    }, t.centerFromEnd = function(t, e) {
        return e - t[4] - t[3] - t[2] / 2;
    }, t.foundPatternCross = function(t) {
        for(var e = 0, r = 0; r < 5; r++){
            var n = t[r];
            if (0 === n) return !1;
            e += n;
        }
        if (e < 7) return !1;
        var o = e / 7, i = o / 2;
        return Math.abs(o - t[0]) < i && Math.abs(o - t[1]) < i && Math.abs(3 * o - t[2]) < 3 * i && Math.abs(o - t[3]) < i && Math.abs(o - t[4]) < i;
    }, t.prototype.getCrossCheckStateCount = function() {
        var t = this.crossCheckStateCount;
        return t[0] = 0, t[1] = 0, t[2] = 0, t[3] = 0, t[4] = 0, t;
    }, t.prototype.crossCheckDiagonal = function(e, r, n, o) {
        for(var i = this.getCrossCheckStateCount(), a = 0, u = this.image; e >= a && r >= a && u.get(r - a, e - a);)i[2]++, a++;
        if (e < a || r < a) return !1;
        for(; e >= a && r >= a && !u.get(r - a, e - a) && i[1] <= n;)i[1]++, a++;
        if (e < a || r < a || i[1] > n) return !1;
        for(; e >= a && r >= a && u.get(r - a, e - a) && i[0] <= n;)i[0]++, a++;
        if (i[0] > n) return !1;
        var s = u.getHeight(), c = u.getWidth();
        for(a = 1; e + a < s && r + a < c && u.get(r + a, e + a);)i[2]++, a++;
        if (e + a >= s || r + a >= c) return !1;
        for(; e + a < s && r + a < c && !u.get(r + a, e + a) && i[3] < n;)i[3]++, a++;
        if (e + a >= s || r + a >= c || i[3] >= n) return !1;
        for(; e + a < s && r + a < c && u.get(r + a, e + a) && i[4] < n;)i[4]++, a++;
        if (i[4] >= n) return !1;
        var f = i[0] + i[1] + i[2] + i[3] + i[4];
        return Math.abs(f - o) < 2 * o && t.foundPatternCross(i);
    }, t.prototype.crossCheckVertical = function(e, r, n, o) {
        for(var i = this.image, a = i.getHeight(), u = this.getCrossCheckStateCount(), s = e; s >= 0 && i.get(r, s);)u[2]++, s--;
        if (s < 0) return NaN;
        for(; s >= 0 && !i.get(r, s) && u[1] <= n;)u[1]++, s--;
        if (s < 0 || u[1] > n) return NaN;
        for(; s >= 0 && i.get(r, s) && u[0] <= n;)u[0]++, s--;
        if (u[0] > n) return NaN;
        for(s = e + 1; s < a && i.get(r, s);)u[2]++, s++;
        if (s === a) return NaN;
        for(; s < a && !i.get(r, s) && u[3] < n;)u[3]++, s++;
        if (s === a || u[3] >= n) return NaN;
        for(; s < a && i.get(r, s) && u[4] < n;)u[4]++, s++;
        if (u[4] >= n) return NaN;
        var c = u[0] + u[1] + u[2] + u[3] + u[4];
        return 5 * Math.abs(c - o) >= 2 * o ? NaN : t.foundPatternCross(u) ? t.centerFromEnd(u, s) : NaN;
    }, t.prototype.crossCheckHorizontal = function(e, r, n, o) {
        for(var i = this.image, a = i.getWidth(), u = this.getCrossCheckStateCount(), s = e; s >= 0 && i.get(s, r);)u[2]++, s--;
        if (s < 0) return NaN;
        for(; s >= 0 && !i.get(s, r) && u[1] <= n;)u[1]++, s--;
        if (s < 0 || u[1] > n) return NaN;
        for(; s >= 0 && i.get(s, r) && u[0] <= n;)u[0]++, s--;
        if (u[0] > n) return NaN;
        for(s = e + 1; s < a && i.get(s, r);)u[2]++, s++;
        if (s === a) return NaN;
        for(; s < a && !i.get(s, r) && u[3] < n;)u[3]++, s++;
        if (s === a || u[3] >= n) return NaN;
        for(; s < a && i.get(s, r) && u[4] < n;)u[4]++, s++;
        if (u[4] >= n) return NaN;
        var c = u[0] + u[1] + u[2] + u[3] + u[4];
        return 5 * Math.abs(c - o) >= o ? NaN : t.foundPatternCross(u) ? t.centerFromEnd(u, s) : NaN;
    }, t.prototype.handlePossibleCenter = function(e, r, n, o) {
        var i = e[0] + e[1] + e[2] + e[3] + e[4], a = t.centerFromEnd(e, n), u = this.crossCheckVertical(r, Math.floor(a), e[2], i);
        if (!isNaN(u) && (a = this.crossCheckHorizontal(Math.floor(a), Math.floor(u), e[2], i), !isNaN(a) && (!o || this.crossCheckDiagonal(Math.floor(u), Math.floor(a), e[2], i)))) {
            for(var s = i / 7, c = !1, f = this.possibleCenters, h = 0, l = f.length; h < l; h++){
                var d = f[h];
                if (d.aboutEquals(s, u, a)) {
                    f[h] = d.combineEstimate(u, a, s), c = !0;
                    break;
                }
            }
            if (!c) {
                var p = new $2be8636d379871d6$var$tn(a, u, s);
                f.push(p), null !== this.resultPointCallback && void 0 !== this.resultPointCallback && this.resultPointCallback.foundPossibleResultPoint(p);
            }
            return !0;
        }
        return !1;
    }, t.prototype.findRowSkip = function() {
        var e, r;
        if (this.possibleCenters.length <= 1) return 0;
        var n = null;
        try {
            for(var o = $2be8636d379871d6$var$rn(this.possibleCenters), i = o.next(); !i.done; i = o.next()){
                var a = i.value;
                if (a.getCount() >= t.CENTER_QUORUM) {
                    if (null != n) return this.hasSkipped = !0, Math.floor((Math.abs(n.getX() - a.getX()) - Math.abs(n.getY() - a.getY())) / 2);
                    n = a;
                }
            }
        } catch (t) {
            e = {
                error: t
            };
        } finally{
            try {
                i && !i.done && (r = o.return) && r.call(o);
            } finally{
                if (e) throw e.error;
            }
        }
        return 0;
    }, t.prototype.haveMultiplyConfirmedCenters = function() {
        var e, r, n, o, i = 0, a = 0, u = this.possibleCenters.length;
        try {
            for(var s = $2be8636d379871d6$var$rn(this.possibleCenters), c = s.next(); !c.done; c = s.next())(p = c.value).getCount() >= t.CENTER_QUORUM && (i++, a += p.getEstimatedModuleSize());
        } catch (t) {
            e = {
                error: t
            };
        } finally{
            try {
                c && !c.done && (r = s.return) && r.call(s);
            } finally{
                if (e) throw e.error;
            }
        }
        if (i < 3) return !1;
        var f = a / u, h = 0;
        try {
            for(var l = $2be8636d379871d6$var$rn(this.possibleCenters), d = l.next(); !d.done; d = l.next()){
                var p = d.value;
                h += Math.abs(p.getEstimatedModuleSize() - f);
            }
        } catch (t) {
            n = {
                error: t
            };
        } finally{
            try {
                d && !d.done && (o = l.return) && o.call(l);
            } finally{
                if (n) throw n.error;
            }
        }
        return h <= 0.05 * a;
    }, t.prototype.selectBestPatterns = function() {
        var t, e, r, n, o = this.possibleCenters.length;
        if (o < 3) throw new $2be8636d379871d6$var$U();
        var i, a = this.possibleCenters;
        if (o > 3) {
            var u = 0, s = 0;
            try {
                for(var c = $2be8636d379871d6$var$rn(this.possibleCenters), f = c.next(); !f.done; f = c.next()){
                    var h = f.value.getEstimatedModuleSize();
                    u += h, s += h * h;
                }
            } catch (e) {
                t = {
                    error: e
                };
            } finally{
                try {
                    f && !f.done && (e = c.return) && e.call(c);
                } finally{
                    if (t) throw t.error;
                }
            }
            i = u / o;
            var l = Math.sqrt(s / o - i * i);
            a.sort(function(t, e) {
                var r = Math.abs(e.getEstimatedModuleSize() - i), n = Math.abs(t.getEstimatedModuleSize() - i);
                return r < n ? -1 : r > n ? 1 : 0;
            });
            for(var d = Math.max(0.2 * i, l), p = 0; p < a.length && a.length > 3; p++){
                var g = a[p];
                Math.abs(g.getEstimatedModuleSize() - i) > d && (a.splice(p, 1), p--);
            }
        }
        if (a.length > 3) {
            u = 0;
            try {
                for(var y = $2be8636d379871d6$var$rn(a), w = y.next(); !w.done; w = y.next())u += w.value.getEstimatedModuleSize();
            } catch (t) {
                r = {
                    error: t
                };
            } finally{
                try {
                    w && !w.done && (n = y.return) && n.call(y);
                } finally{
                    if (r) throw r.error;
                }
            }
            i = u / a.length, a.sort(function(t, e) {
                if (e.getCount() === t.getCount()) {
                    var r = Math.abs(e.getEstimatedModuleSize() - i), n = Math.abs(t.getEstimatedModuleSize() - i);
                    return r < n ? 1 : r > n ? -1 : 0;
                }
                return e.getCount() - t.getCount();
            }), a.splice(3);
        }
        return [
            a[0],
            a[1],
            a[2]
        ];
    }, t.CENTER_QUORUM = 2, t.MIN_SKIP = 3, t.MAX_MODULES = 57, t;
}(), $2be8636d379871d6$var$on = function() {
    function t(t) {
        this.image = t;
    }
    return t.prototype.getImage = function() {
        return this.image;
    }, t.prototype.getResultPointCallback = function() {
        return this.resultPointCallback;
    }, t.prototype.detect = function(t) {
        this.resultPointCallback = null == t ? null : t.get($2be8636d379871d6$var$T.NEED_RESULT_POINT_CALLBACK);
        var e = new $2be8636d379871d6$var$nn(this.image, this.resultPointCallback).find(t);
        return this.processFinderPatternInfo(e);
    }, t.prototype.processFinderPatternInfo = function(e) {
        var r = e.getTopLeft(), n = e.getTopRight(), o = e.getBottomLeft(), i = this.calculateModuleSize(r, n, o);
        if (i < 1) throw new $2be8636d379871d6$var$U("No pattern found in proccess finder.");
        var a = t.computeDimension(r, n, o, i), u = $2be8636d379871d6$var$Fr.getProvisionalVersionForDimension(a), s = u.getDimensionForVersion() - 7, c = null;
        if (u.getAlignmentPatternCenters().length > 0) for(var f = n.getX() - r.getX() + o.getX(), h = n.getY() - r.getY() + o.getY(), l = 1 - 3 / s, d = Math.floor(r.getX() + l * (f - r.getX())), p = Math.floor(r.getY() + l * (h - r.getY())), g = 4; g <= 16; g <<= 1)try {
            c = this.findAlignmentInRegion(i, d, p, g);
            break;
        } catch (t) {
            if (!(t instanceof $2be8636d379871d6$var$U)) throw t;
        }
        var y = t.createTransform(r, n, o, c, a), w = t.sampleGrid(this.image, y, a);
        return new $2be8636d379871d6$var$Et(w, null === c ? [
            o,
            r,
            n
        ] : [
            o,
            r,
            n,
            c
        ]);
    }, t.createTransform = function(t, e, r, n, o) {
        var i, a, u, s, c = o - 3.5;
        return null !== n ? (i = n.getX(), a = n.getY(), s = u = c - 3) : (i = e.getX() - t.getX() + r.getX(), a = e.getY() - t.getY() + r.getY(), u = c, s = c), $2be8636d379871d6$var$Tt.quadrilateralToQuadrilateral(3.5, 3.5, c, 3.5, u, s, 3.5, c, t.getX(), t.getY(), e.getX(), e.getY(), i, a, r.getX(), r.getY());
    }, t.sampleGrid = function(t, e, r) {
        return $2be8636d379871d6$var$Nt.getInstance().sampleGridWithTransform(t, r, r, e);
    }, t.computeDimension = function(t, e, r, n) {
        var o = $2be8636d379871d6$var$vt.round($2be8636d379871d6$var$At.distance(t, e) / n), i = $2be8636d379871d6$var$vt.round($2be8636d379871d6$var$At.distance(t, r) / n), a = Math.floor((o + i) / 2) + 7;
        switch(3 & a){
            case 0:
                a++;
                break;
            case 2:
                a--;
                break;
            case 3:
                throw new $2be8636d379871d6$var$U("Dimensions could be not found.");
        }
        return a;
    }, t.prototype.calculateModuleSize = function(t, e, r) {
        return (this.calculateModuleSizeOneWay(t, e) + this.calculateModuleSizeOneWay(t, r)) / 2;
    }, t.prototype.calculateModuleSizeOneWay = function(t, e) {
        var r = this.sizeOfBlackWhiteBlackRunBothWays(Math.floor(t.getX()), Math.floor(t.getY()), Math.floor(e.getX()), Math.floor(e.getY())), n = this.sizeOfBlackWhiteBlackRunBothWays(Math.floor(e.getX()), Math.floor(e.getY()), Math.floor(t.getX()), Math.floor(t.getY()));
        return isNaN(r) ? n / 7 : isNaN(n) ? r / 7 : (r + n) / 14;
    }, t.prototype.sizeOfBlackWhiteBlackRunBothWays = function(t, e, r, n) {
        var o = this.sizeOfBlackWhiteBlackRun(t, e, r, n), i = 1, a = t - (r - t);
        a < 0 ? (i = t / (t - a), a = 0) : a >= this.image.getWidth() && (i = (this.image.getWidth() - 1 - t) / (a - t), a = this.image.getWidth() - 1);
        var u = Math.floor(e - (n - e) * i);
        return i = 1, u < 0 ? (i = e / (e - u), u = 0) : u >= this.image.getHeight() && (i = (this.image.getHeight() - 1 - e) / (u - e), u = this.image.getHeight() - 1), a = Math.floor(t + (a - t) * i), (o += this.sizeOfBlackWhiteBlackRun(t, e, a, u)) - 1;
    }, t.prototype.sizeOfBlackWhiteBlackRun = function(t, e, r, n) {
        var o = Math.abs(n - e) > Math.abs(r - t);
        if (o) {
            var i = t;
            t = e, e = i, i = r, r = n, n = i;
        }
        for(var a = Math.abs(r - t), u = Math.abs(n - e), s = -a / 2, c = t < r ? 1 : -1, f = e < n ? 1 : -1, h = 0, l = r + c, d = t, p = e; d !== l; d += c){
            var g = o ? p : d, y = o ? d : p;
            if (1 === h === this.image.get(g, y)) {
                if (2 === h) return $2be8636d379871d6$var$vt.distance(d, p, t, e);
                h++;
            }
            if ((s += u) > 0) {
                if (p === n) break;
                p += f, s -= a;
            }
        }
        return 2 === h ? $2be8636d379871d6$var$vt.distance(r + c, n, t, e) : NaN;
    }, t.prototype.findAlignmentInRegion = function(t, e, r, n) {
        var o = Math.floor(n * t), i = Math.max(0, e - o), a = Math.min(this.image.getWidth() - 1, e + o);
        if (a - i < 3 * t) throw new $2be8636d379871d6$var$U("Alignment top exceeds estimated module size.");
        var u = Math.max(0, r - o), s = Math.min(this.image.getHeight() - 1, r + o);
        if (s - u < 3 * t) throw new $2be8636d379871d6$var$U("Alignment bottom exceeds estimated module size.");
        return new $2be8636d379871d6$var$Jr(this.image, i, u, a - i, s - u, t, this.resultPointCallback).find();
    }, t;
}(), $2be8636d379871d6$var$an = function() {
    function t() {
        this.decoder = new $2be8636d379871d6$var$Zr();
    }
    return t.prototype.getDecoder = function() {
        return this.decoder;
    }, t.prototype.decode = function(e, r) {
        var n, o;
        if (null != r && void 0 !== r.get($2be8636d379871d6$var$T.PURE_BARCODE)) {
            var i = t.extractPureBits(e.getBlackMatrix());
            n = this.decoder.decodeBitMatrix(i, r), o = t.NO_POINTS;
        } else {
            var a = new $2be8636d379871d6$var$on(e.getBlackMatrix()).detect(r);
            n = this.decoder.decodeBitMatrix(a.getBits(), r), o = a.getPoints();
        }
        n.getOther() instanceof $2be8636d379871d6$var$zr && n.getOther().applyMirroredCorrection(o);
        var u = new $2be8636d379871d6$var$et(n.getText(), n.getRawBytes(), void 0, o, $2be8636d379871d6$var$nt.QR_CODE, void 0), s = n.getByteSegments();
        null !== s && u.putMetadata($2be8636d379871d6$var$it.BYTE_SEGMENTS, s);
        var c = n.getECLevel();
        return null !== c && u.putMetadata($2be8636d379871d6$var$it.ERROR_CORRECTION_LEVEL, c), n.hasStructuredAppend() && (u.putMetadata($2be8636d379871d6$var$it.STRUCTURED_APPEND_SEQUENCE, n.getStructuredAppendSequenceNumber()), u.putMetadata($2be8636d379871d6$var$it.STRUCTURED_APPEND_PARITY, n.getStructuredAppendParity())), u;
    }, t.prototype.reset = function() {}, t.extractPureBits = function(t) {
        var e = t.getTopLeftOnBit(), r = t.getBottomRightOnBit();
        if (null === e || null === r) throw new $2be8636d379871d6$var$U();
        var n = this.moduleSize(e, t), o = e[1], i = r[1], a = e[0], u = r[0];
        if (a >= u || o >= i) throw new $2be8636d379871d6$var$U();
        if (i - o != u - a && (u = a + (i - o)) >= t.getWidth()) throw new $2be8636d379871d6$var$U();
        var s = Math.round((u - a + 1) / n), c = Math.round((i - o + 1) / n);
        if (s <= 0 || c <= 0) throw new $2be8636d379871d6$var$U();
        if (c !== s) throw new $2be8636d379871d6$var$U();
        var f = Math.floor(n / 2);
        o += f;
        var h = (a += f) + Math.floor((s - 1) * n) - u;
        if (h > 0) {
            if (h > f) throw new $2be8636d379871d6$var$U();
            a -= h;
        }
        var l = o + Math.floor((c - 1) * n) - i;
        if (l > 0) {
            if (l > f) throw new $2be8636d379871d6$var$U();
            o -= l;
        }
        for(var d = new $2be8636d379871d6$var$x(s, c), p = 0; p < c; p++)for(var g = o + Math.floor(p * n), y = 0; y < s; y++)t.get(a + Math.floor(y * n), g) && d.set(y, p);
        return d;
    }, t.moduleSize = function(t, e) {
        for(var r = e.getHeight(), n = e.getWidth(), o = t[0], i = t[1], a = !0, u = 0; o < n && i < r;){
            if (a !== e.get(o, i)) {
                if (5 == ++u) break;
                a = !a;
            }
            o++, i++;
        }
        if (o === n || i === r) throw new $2be8636d379871d6$var$U();
        return (o - t[0]) / 7;
    }, t.NO_POINTS = new Array(), t;
}(), $2be8636d379871d6$var$un = function(t) {
    var e = "function" == typeof Symbol && Symbol.iterator, r = e && t[e], n = 0;
    if (r) return r.call(t);
    if (t && "number" == typeof t.length) return {
        next: function() {
            return t && n >= t.length && (t = void 0), {
                value: t && t[n++],
                done: !t
            };
        }
    };
    throw new TypeError(e ? "Object is not iterable." : "Symbol.iterator is not defined.");
}, $2be8636d379871d6$var$sn = function() {
    function t() {}
    return t.prototype.PDF417Common = function() {}, t.getBitCountSum = function(t) {
        return $2be8636d379871d6$var$vt.sum(t);
    }, t.toIntArray = function(e) {
        var r, n;
        if (null == e || !e.length) return t.EMPTY_INT_ARRAY;
        var o = new Int32Array(e.length), i = 0;
        try {
            for(var a = $2be8636d379871d6$var$un(e), u = a.next(); !u.done; u = a.next()){
                var s = u.value;
                o[i++] = s;
            }
        } catch (t) {
            r = {
                error: t
            };
        } finally{
            try {
                u && !u.done && (n = a.return) && n.call(a);
            } finally{
                if (r) throw r.error;
            }
        }
        return o;
    }, t.getCodeword = function(e) {
        var r = $2be8636d379871d6$var$C.binarySearch(t.SYMBOL_TABLE, 262143 & e);
        return r < 0 ? -1 : (t.CODEWORD_TABLE[r] - 1) % t.NUMBER_OF_CODEWORDS;
    }, t.NUMBER_OF_CODEWORDS = 929, t.MAX_CODEWORDS_IN_BARCODE = t.NUMBER_OF_CODEWORDS - 1, t.MIN_ROWS_IN_BARCODE = 3, t.MAX_ROWS_IN_BARCODE = 90, t.MODULES_IN_CODEWORD = 17, t.MODULES_IN_STOP_PATTERN = 18, t.BARS_IN_MODULE = 8, t.EMPTY_INT_ARRAY = new Int32Array([]), t.SYMBOL_TABLE = Int32Array.from([
        66142,
        66170,
        66206,
        66236,
        66290,
        66292,
        66350,
        66382,
        66396,
        66454,
        66470,
        66476,
        66594,
        66600,
        66614,
        66626,
        66628,
        66632,
        66640,
        66654,
        66662,
        66668,
        66682,
        66690,
        66718,
        66720,
        66748,
        66758,
        66776,
        66798,
        66802,
        66804,
        66820,
        66824,
        66832,
        66846,
        66848,
        66876,
        66880,
        66936,
        66950,
        66956,
        66968,
        66992,
        67006,
        67022,
        67036,
        67042,
        67044,
        67048,
        67062,
        67118,
        67150,
        67164,
        67214,
        67228,
        67256,
        67294,
        67322,
        67350,
        67366,
        67372,
        67398,
        67404,
        67416,
        67438,
        67474,
        67476,
        67490,
        67492,
        67496,
        67510,
        67618,
        67624,
        67650,
        67656,
        67664,
        67678,
        67686,
        67692,
        67706,
        67714,
        67716,
        67728,
        67742,
        67744,
        67772,
        67782,
        67788,
        67800,
        67822,
        67826,
        67828,
        67842,
        67848,
        67870,
        67872,
        67900,
        67904,
        67960,
        67974,
        67992,
        68016,
        68030,
        68046,
        68060,
        68066,
        68068,
        68072,
        68086,
        68104,
        68112,
        68126,
        68128,
        68156,
        68160,
        68216,
        68336,
        68358,
        68364,
        68376,
        68400,
        68414,
        68448,
        68476,
        68494,
        68508,
        68536,
        68546,
        68548,
        68552,
        68560,
        68574,
        68582,
        68588,
        68654,
        68686,
        68700,
        68706,
        68708,
        68712,
        68726,
        68750,
        68764,
        68792,
        68802,
        68804,
        68808,
        68816,
        68830,
        68838,
        68844,
        68858,
        68878,
        68892,
        68920,
        68976,
        68990,
        68994,
        68996,
        69e3,
        69008,
        69022,
        69024,
        69052,
        69062,
        69068,
        69080,
        69102,
        69106,
        69108,
        69142,
        69158,
        69164,
        69190,
        69208,
        69230,
        69254,
        69260,
        69272,
        69296,
        69310,
        69326,
        69340,
        69386,
        69394,
        69396,
        69410,
        69416,
        69430,
        69442,
        69444,
        69448,
        69456,
        69470,
        69478,
        69484,
        69554,
        69556,
        69666,
        69672,
        69698,
        69704,
        69712,
        69726,
        69754,
        69762,
        69764,
        69776,
        69790,
        69792,
        69820,
        69830,
        69836,
        69848,
        69870,
        69874,
        69876,
        69890,
        69918,
        69920,
        69948,
        69952,
        70008,
        70022,
        70040,
        70064,
        70078,
        70094,
        70108,
        70114,
        70116,
        70120,
        70134,
        70152,
        70174,
        70176,
        70264,
        70384,
        70412,
        70448,
        70462,
        70496,
        70524,
        70542,
        70556,
        70584,
        70594,
        70600,
        70608,
        70622,
        70630,
        70636,
        70664,
        70672,
        70686,
        70688,
        70716,
        70720,
        70776,
        70896,
        71136,
        71180,
        71192,
        71216,
        71230,
        71264,
        71292,
        71360,
        71416,
        71452,
        71480,
        71536,
        71550,
        71554,
        71556,
        71560,
        71568,
        71582,
        71584,
        71612,
        71622,
        71628,
        71640,
        71662,
        71726,
        71732,
        71758,
        71772,
        71778,
        71780,
        71784,
        71798,
        71822,
        71836,
        71864,
        71874,
        71880,
        71888,
        71902,
        71910,
        71916,
        71930,
        71950,
        71964,
        71992,
        72048,
        72062,
        72066,
        72068,
        72080,
        72094,
        72096,
        72124,
        72134,
        72140,
        72152,
        72174,
        72178,
        72180,
        72206,
        72220,
        72248,
        72304,
        72318,
        72416,
        72444,
        72456,
        72464,
        72478,
        72480,
        72508,
        72512,
        72568,
        72588,
        72600,
        72624,
        72638,
        72654,
        72668,
        72674,
        72676,
        72680,
        72694,
        72726,
        72742,
        72748,
        72774,
        72780,
        72792,
        72814,
        72838,
        72856,
        72880,
        72894,
        72910,
        72924,
        72930,
        72932,
        72936,
        72950,
        72966,
        72972,
        72984,
        73008,
        73022,
        73056,
        73084,
        73102,
        73116,
        73144,
        73156,
        73160,
        73168,
        73182,
        73190,
        73196,
        73210,
        73226,
        73234,
        73236,
        73250,
        73252,
        73256,
        73270,
        73282,
        73284,
        73296,
        73310,
        73318,
        73324,
        73346,
        73348,
        73352,
        73360,
        73374,
        73376,
        73404,
        73414,
        73420,
        73432,
        73454,
        73498,
        73518,
        73522,
        73524,
        73550,
        73564,
        73570,
        73572,
        73576,
        73590,
        73800,
        73822,
        73858,
        73860,
        73872,
        73886,
        73888,
        73916,
        73944,
        73970,
        73972,
        73992,
        74014,
        74016,
        74044,
        74048,
        74104,
        74118,
        74136,
        74160,
        74174,
        74210,
        74212,
        74216,
        74230,
        74244,
        74256,
        74270,
        74272,
        74360,
        74480,
        74502,
        74508,
        74544,
        74558,
        74592,
        74620,
        74638,
        74652,
        74680,
        74690,
        74696,
        74704,
        74726,
        74732,
        74782,
        74784,
        74812,
        74992,
        75232,
        75288,
        75326,
        75360,
        75388,
        75456,
        75512,
        75576,
        75632,
        75646,
        75650,
        75652,
        75664,
        75678,
        75680,
        75708,
        75718,
        75724,
        75736,
        75758,
        75808,
        75836,
        75840,
        75896,
        76016,
        76256,
        76736,
        76824,
        76848,
        76862,
        76896,
        76924,
        76992,
        77048,
        77296,
        77340,
        77368,
        77424,
        77438,
        77536,
        77564,
        77572,
        77576,
        77584,
        77600,
        77628,
        77632,
        77688,
        77702,
        77708,
        77720,
        77744,
        77758,
        77774,
        77788,
        77870,
        77902,
        77916,
        77922,
        77928,
        77966,
        77980,
        78008,
        78018,
        78024,
        78032,
        78046,
        78060,
        78074,
        78094,
        78136,
        78192,
        78206,
        78210,
        78212,
        78224,
        78238,
        78240,
        78268,
        78278,
        78284,
        78296,
        78322,
        78324,
        78350,
        78364,
        78448,
        78462,
        78560,
        78588,
        78600,
        78622,
        78624,
        78652,
        78656,
        78712,
        78726,
        78744,
        78768,
        78782,
        78798,
        78812,
        78818,
        78820,
        78824,
        78838,
        78862,
        78876,
        78904,
        78960,
        78974,
        79072,
        79100,
        79296,
        79352,
        79368,
        79376,
        79390,
        79392,
        79420,
        79424,
        79480,
        79600,
        79628,
        79640,
        79664,
        79678,
        79712,
        79740,
        79772,
        79800,
        79810,
        79812,
        79816,
        79824,
        79838,
        79846,
        79852,
        79894,
        79910,
        79916,
        79942,
        79948,
        79960,
        79982,
        79988,
        80006,
        80024,
        80048,
        80062,
        80078,
        80092,
        80098,
        80100,
        80104,
        80134,
        80140,
        80176,
        80190,
        80224,
        80252,
        80270,
        80284,
        80312,
        80328,
        80336,
        80350,
        80358,
        80364,
        80378,
        80390,
        80396,
        80408,
        80432,
        80446,
        80480,
        80508,
        80576,
        80632,
        80654,
        80668,
        80696,
        80752,
        80766,
        80776,
        80784,
        80798,
        80800,
        80828,
        80844,
        80856,
        80878,
        80882,
        80884,
        80914,
        80916,
        80930,
        80932,
        80936,
        80950,
        80962,
        80968,
        80976,
        80990,
        80998,
        81004,
        81026,
        81028,
        81040,
        81054,
        81056,
        81084,
        81094,
        81100,
        81112,
        81134,
        81154,
        81156,
        81160,
        81168,
        81182,
        81184,
        81212,
        81216,
        81272,
        81286,
        81292,
        81304,
        81328,
        81342,
        81358,
        81372,
        81380,
        81384,
        81398,
        81434,
        81454,
        81458,
        81460,
        81486,
        81500,
        81506,
        81508,
        81512,
        81526,
        81550,
        81564,
        81592,
        81602,
        81604,
        81608,
        81616,
        81630,
        81638,
        81644,
        81702,
        81708,
        81722,
        81734,
        81740,
        81752,
        81774,
        81778,
        81780,
        82050,
        82078,
        82080,
        82108,
        82180,
        82184,
        82192,
        82206,
        82208,
        82236,
        82240,
        82296,
        82316,
        82328,
        82352,
        82366,
        82402,
        82404,
        82408,
        82440,
        82448,
        82462,
        82464,
        82492,
        82496,
        82552,
        82672,
        82694,
        82700,
        82712,
        82736,
        82750,
        82784,
        82812,
        82830,
        82882,
        82884,
        82888,
        82896,
        82918,
        82924,
        82952,
        82960,
        82974,
        82976,
        83004,
        83008,
        83064,
        83184,
        83424,
        83468,
        83480,
        83504,
        83518,
        83552,
        83580,
        83648,
        83704,
        83740,
        83768,
        83824,
        83838,
        83842,
        83844,
        83848,
        83856,
        83872,
        83900,
        83910,
        83916,
        83928,
        83950,
        83984,
        84e3,
        84028,
        84032,
        84088,
        84208,
        84448,
        84928,
        85040,
        85054,
        85088,
        85116,
        85184,
        85240,
        85488,
        85560,
        85616,
        85630,
        85728,
        85756,
        85764,
        85768,
        85776,
        85790,
        85792,
        85820,
        85824,
        85880,
        85894,
        85900,
        85912,
        85936,
        85966,
        85980,
        86048,
        86080,
        86136,
        86256,
        86496,
        86976,
        88160,
        88188,
        88256,
        88312,
        88560,
        89056,
        89200,
        89214,
        89312,
        89340,
        89536,
        89592,
        89608,
        89616,
        89632,
        89664,
        89720,
        89840,
        89868,
        89880,
        89904,
        89952,
        89980,
        89998,
        90012,
        90040,
        90190,
        90204,
        90254,
        90268,
        90296,
        90306,
        90308,
        90312,
        90334,
        90382,
        90396,
        90424,
        90480,
        90494,
        90500,
        90504,
        90512,
        90526,
        90528,
        90556,
        90566,
        90572,
        90584,
        90610,
        90612,
        90638,
        90652,
        90680,
        90736,
        90750,
        90848,
        90876,
        90884,
        90888,
        90896,
        90910,
        90912,
        90940,
        90944,
        91e3,
        91014,
        91020,
        91032,
        91056,
        91070,
        91086,
        91100,
        91106,
        91108,
        91112,
        91126,
        91150,
        91164,
        91192,
        91248,
        91262,
        91360,
        91388,
        91584,
        91640,
        91664,
        91678,
        91680,
        91708,
        91712,
        91768,
        91888,
        91928,
        91952,
        91966,
        92e3,
        92028,
        92046,
        92060,
        92088,
        92098,
        92100,
        92104,
        92112,
        92126,
        92134,
        92140,
        92188,
        92216,
        92272,
        92384,
        92412,
        92608,
        92664,
        93168,
        93200,
        93214,
        93216,
        93244,
        93248,
        93304,
        93424,
        93664,
        93720,
        93744,
        93758,
        93792,
        93820,
        93888,
        93944,
        93980,
        94008,
        94064,
        94078,
        94084,
        94088,
        94096,
        94110,
        94112,
        94140,
        94150,
        94156,
        94168,
        94246,
        94252,
        94278,
        94284,
        94296,
        94318,
        94342,
        94348,
        94360,
        94384,
        94398,
        94414,
        94428,
        94440,
        94470,
        94476,
        94488,
        94512,
        94526,
        94560,
        94588,
        94606,
        94620,
        94648,
        94658,
        94660,
        94664,
        94672,
        94686,
        94694,
        94700,
        94714,
        94726,
        94732,
        94744,
        94768,
        94782,
        94816,
        94844,
        94912,
        94968,
        94990,
        95004,
        95032,
        95088,
        95102,
        95112,
        95120,
        95134,
        95136,
        95164,
        95180,
        95192,
        95214,
        95218,
        95220,
        95244,
        95256,
        95280,
        95294,
        95328,
        95356,
        95424,
        95480,
        95728,
        95758,
        95772,
        95800,
        95856,
        95870,
        95968,
        95996,
        96008,
        96016,
        96030,
        96032,
        96060,
        96064,
        96120,
        96152,
        96176,
        96190,
        96220,
        96226,
        96228,
        96232,
        96290,
        96292,
        96296,
        96310,
        96322,
        96324,
        96328,
        96336,
        96350,
        96358,
        96364,
        96386,
        96388,
        96392,
        96400,
        96414,
        96416,
        96444,
        96454,
        96460,
        96472,
        96494,
        96498,
        96500,
        96514,
        96516,
        96520,
        96528,
        96542,
        96544,
        96572,
        96576,
        96632,
        96646,
        96652,
        96664,
        96688,
        96702,
        96718,
        96732,
        96738,
        96740,
        96744,
        96758,
        96772,
        96776,
        96784,
        96798,
        96800,
        96828,
        96832,
        96888,
        97008,
        97030,
        97036,
        97048,
        97072,
        97086,
        97120,
        97148,
        97166,
        97180,
        97208,
        97220,
        97224,
        97232,
        97246,
        97254,
        97260,
        97326,
        97330,
        97332,
        97358,
        97372,
        97378,
        97380,
        97384,
        97398,
        97422,
        97436,
        97464,
        97474,
        97476,
        97480,
        97488,
        97502,
        97510,
        97516,
        97550,
        97564,
        97592,
        97648,
        97666,
        97668,
        97672,
        97680,
        97694,
        97696,
        97724,
        97734,
        97740,
        97752,
        97774,
        97830,
        97836,
        97850,
        97862,
        97868,
        97880,
        97902,
        97906,
        97908,
        97926,
        97932,
        97944,
        97968,
        97998,
        98012,
        98018,
        98020,
        98024,
        98038,
        98618,
        98674,
        98676,
        98838,
        98854,
        98874,
        98892,
        98904,
        98926,
        98930,
        98932,
        98968,
        99006,
        99042,
        99044,
        99048,
        99062,
        99166,
        99194,
        99246,
        99286,
        99350,
        99366,
        99372,
        99386,
        99398,
        99416,
        99438,
        99442,
        99444,
        99462,
        99504,
        99518,
        99534,
        99548,
        99554,
        99556,
        99560,
        99574,
        99590,
        99596,
        99608,
        99632,
        99646,
        99680,
        99708,
        99726,
        99740,
        99768,
        99778,
        99780,
        99784,
        99792,
        99806,
        99814,
        99820,
        99834,
        99858,
        99860,
        99874,
        99880,
        99894,
        99906,
        99920,
        99934,
        99962,
        99970,
        99972,
        99976,
        99984,
        99998,
        1e5,
        100028,
        100038,
        100044,
        100056,
        100078,
        100082,
        100084,
        100142,
        100174,
        100188,
        100246,
        100262,
        100268,
        100306,
        100308,
        100390,
        100396,
        100410,
        100422,
        100428,
        100440,
        100462,
        100466,
        100468,
        100486,
        100504,
        100528,
        100542,
        100558,
        100572,
        100578,
        100580,
        100584,
        100598,
        100620,
        100656,
        100670,
        100704,
        100732,
        100750,
        100792,
        100802,
        100808,
        100816,
        100830,
        100838,
        100844,
        100858,
        100888,
        100912,
        100926,
        100960,
        100988,
        101056,
        101112,
        101148,
        101176,
        101232,
        101246,
        101250,
        101252,
        101256,
        101264,
        101278,
        101280,
        101308,
        101318,
        101324,
        101336,
        101358,
        101362,
        101364,
        101410,
        101412,
        101416,
        101430,
        101442,
        101448,
        101456,
        101470,
        101478,
        101498,
        101506,
        101508,
        101520,
        101534,
        101536,
        101564,
        101580,
        101618,
        101620,
        101636,
        101640,
        101648,
        101662,
        101664,
        101692,
        101696,
        101752,
        101766,
        101784,
        101838,
        101858,
        101860,
        101864,
        101934,
        101938,
        101940,
        101966,
        101980,
        101986,
        101988,
        101992,
        102030,
        102044,
        102072,
        102082,
        102084,
        102088,
        102096,
        102138,
        102166,
        102182,
        102188,
        102214,
        102220,
        102232,
        102254,
        102282,
        102290,
        102292,
        102306,
        102308,
        102312,
        102326,
        102444,
        102458,
        102470,
        102476,
        102488,
        102514,
        102516,
        102534,
        102552,
        102576,
        102590,
        102606,
        102620,
        102626,
        102632,
        102646,
        102662,
        102668,
        102704,
        102718,
        102752,
        102780,
        102798,
        102812,
        102840,
        102850,
        102856,
        102864,
        102878,
        102886,
        102892,
        102906,
        102936,
        102974,
        103008,
        103036,
        103104,
        103160,
        103224,
        103280,
        103294,
        103298,
        103300,
        103312,
        103326,
        103328,
        103356,
        103366,
        103372,
        103384,
        103406,
        103410,
        103412,
        103472,
        103486,
        103520,
        103548,
        103616,
        103672,
        103920,
        103992,
        104048,
        104062,
        104160,
        104188,
        104194,
        104196,
        104200,
        104208,
        104224,
        104252,
        104256,
        104312,
        104326,
        104332,
        104344,
        104368,
        104382,
        104398,
        104412,
        104418,
        104420,
        104424,
        104482,
        104484,
        104514,
        104520,
        104528,
        104542,
        104550,
        104570,
        104578,
        104580,
        104592,
        104606,
        104608,
        104636,
        104652,
        104690,
        104692,
        104706,
        104712,
        104734,
        104736,
        104764,
        104768,
        104824,
        104838,
        104856,
        104910,
        104930,
        104932,
        104936,
        104968,
        104976,
        104990,
        104992,
        105020,
        105024,
        105080,
        105200,
        105240,
        105278,
        105312,
        105372,
        105410,
        105412,
        105416,
        105424,
        105446,
        105518,
        105524,
        105550,
        105564,
        105570,
        105572,
        105576,
        105614,
        105628,
        105656,
        105666,
        105672,
        105680,
        105702,
        105722,
        105742,
        105756,
        105784,
        105840,
        105854,
        105858,
        105860,
        105864,
        105872,
        105888,
        105932,
        105970,
        105972,
        106006,
        106022,
        106028,
        106054,
        106060,
        106072,
        106100,
        106118,
        106124,
        106136,
        106160,
        106174,
        106190,
        106210,
        106212,
        106216,
        106250,
        106258,
        106260,
        106274,
        106276,
        106280,
        106306,
        106308,
        106312,
        106320,
        106334,
        106348,
        106394,
        106414,
        106418,
        106420,
        106566,
        106572,
        106610,
        106612,
        106630,
        106636,
        106648,
        106672,
        106686,
        106722,
        106724,
        106728,
        106742,
        106758,
        106764,
        106776,
        106800,
        106814,
        106848,
        106876,
        106894,
        106908,
        106936,
        106946,
        106948,
        106952,
        106960,
        106974,
        106982,
        106988,
        107032,
        107056,
        107070,
        107104,
        107132,
        107200,
        107256,
        107292,
        107320,
        107376,
        107390,
        107394,
        107396,
        107400,
        107408,
        107422,
        107424,
        107452,
        107462,
        107468,
        107480,
        107502,
        107506,
        107508,
        107544,
        107568,
        107582,
        107616,
        107644,
        107712,
        107768,
        108016,
        108060,
        108088,
        108144,
        108158,
        108256,
        108284,
        108290,
        108292,
        108296,
        108304,
        108318,
        108320,
        108348,
        108352,
        108408,
        108422,
        108428,
        108440,
        108464,
        108478,
        108494,
        108508,
        108514,
        108516,
        108520,
        108592,
        108640,
        108668,
        108736,
        108792,
        109040,
        109536,
        109680,
        109694,
        109792,
        109820,
        110016,
        110072,
        110084,
        110088,
        110096,
        110112,
        110140,
        110144,
        110200,
        110320,
        110342,
        110348,
        110360,
        110384,
        110398,
        110432,
        110460,
        110478,
        110492,
        110520,
        110532,
        110536,
        110544,
        110558,
        110658,
        110686,
        110714,
        110722,
        110724,
        110728,
        110736,
        110750,
        110752,
        110780,
        110796,
        110834,
        110836,
        110850,
        110852,
        110856,
        110864,
        110878,
        110880,
        110908,
        110912,
        110968,
        110982,
        111e3,
        111054,
        111074,
        111076,
        111080,
        111108,
        111112,
        111120,
        111134,
        111136,
        111164,
        111168,
        111224,
        111344,
        111372,
        111422,
        111456,
        111516,
        111554,
        111556,
        111560,
        111568,
        111590,
        111632,
        111646,
        111648,
        111676,
        111680,
        111736,
        111856,
        112096,
        112152,
        112224,
        112252,
        112320,
        112440,
        112514,
        112516,
        112520,
        112528,
        112542,
        112544,
        112588,
        112686,
        112718,
        112732,
        112782,
        112796,
        112824,
        112834,
        112836,
        112840,
        112848,
        112870,
        112890,
        112910,
        112924,
        112952,
        113008,
        113022,
        113026,
        113028,
        113032,
        113040,
        113054,
        113056,
        113100,
        113138,
        113140,
        113166,
        113180,
        113208,
        113264,
        113278,
        113376,
        113404,
        113416,
        113424,
        113440,
        113468,
        113472,
        113560,
        113614,
        113634,
        113636,
        113640,
        113686,
        113702,
        113708,
        113734,
        113740,
        113752,
        113778,
        113780,
        113798,
        113804,
        113816,
        113840,
        113854,
        113870,
        113890,
        113892,
        113896,
        113926,
        113932,
        113944,
        113968,
        113982,
        114016,
        114044,
        114076,
        114114,
        114116,
        114120,
        114128,
        114150,
        114170,
        114194,
        114196,
        114210,
        114212,
        114216,
        114242,
        114244,
        114248,
        114256,
        114270,
        114278,
        114306,
        114308,
        114312,
        114320,
        114334,
        114336,
        114364,
        114380,
        114420,
        114458,
        114478,
        114482,
        114484,
        114510,
        114524,
        114530,
        114532,
        114536,
        114842,
        114866,
        114868,
        114970,
        114994,
        114996,
        115042,
        115044,
        115048,
        115062,
        115130,
        115226,
        115250,
        115252,
        115278,
        115292,
        115298,
        115300,
        115304,
        115318,
        115342,
        115394,
        115396,
        115400,
        115408,
        115422,
        115430,
        115436,
        115450,
        115478,
        115494,
        115514,
        115526,
        115532,
        115570,
        115572,
        115738,
        115758,
        115762,
        115764,
        115790,
        115804,
        115810,
        115812,
        115816,
        115830,
        115854,
        115868,
        115896,
        115906,
        115912,
        115920,
        115934,
        115942,
        115948,
        115962,
        115996,
        116024,
        116080,
        116094,
        116098,
        116100,
        116104,
        116112,
        116126,
        116128,
        116156,
        116166,
        116172,
        116184,
        116206,
        116210,
        116212,
        116246,
        116262,
        116268,
        116282,
        116294,
        116300,
        116312,
        116334,
        116338,
        116340,
        116358,
        116364,
        116376,
        116400,
        116414,
        116430,
        116444,
        116450,
        116452,
        116456,
        116498,
        116500,
        116514,
        116520,
        116534,
        116546,
        116548,
        116552,
        116560,
        116574,
        116582,
        116588,
        116602,
        116654,
        116694,
        116714,
        116762,
        116782,
        116786,
        116788,
        116814,
        116828,
        116834,
        116836,
        116840,
        116854,
        116878,
        116892,
        116920,
        116930,
        116936,
        116944,
        116958,
        116966,
        116972,
        116986,
        117006,
        117048,
        117104,
        117118,
        117122,
        117124,
        117136,
        117150,
        117152,
        117180,
        117190,
        117196,
        117208,
        117230,
        117234,
        117236,
        117304,
        117360,
        117374,
        117472,
        117500,
        117506,
        117508,
        117512,
        117520,
        117536,
        117564,
        117568,
        117624,
        117638,
        117644,
        117656,
        117680,
        117694,
        117710,
        117724,
        117730,
        117732,
        117736,
        117750,
        117782,
        117798,
        117804,
        117818,
        117830,
        117848,
        117874,
        117876,
        117894,
        117936,
        117950,
        117966,
        117986,
        117988,
        117992,
        118022,
        118028,
        118040,
        118064,
        118078,
        118112,
        118140,
        118172,
        118210,
        118212,
        118216,
        118224,
        118238,
        118246,
        118266,
        118306,
        118312,
        118338,
        118352,
        118366,
        118374,
        118394,
        118402,
        118404,
        118408,
        118416,
        118430,
        118432,
        118460,
        118476,
        118514,
        118516,
        118574,
        118578,
        118580,
        118606,
        118620,
        118626,
        118628,
        118632,
        118678,
        118694,
        118700,
        118730,
        118738,
        118740,
        118830,
        118834,
        118836,
        118862,
        118876,
        118882,
        118884,
        118888,
        118902,
        118926,
        118940,
        118968,
        118978,
        118980,
        118984,
        118992,
        119006,
        119014,
        119020,
        119034,
        119068,
        119096,
        119152,
        119166,
        119170,
        119172,
        119176,
        119184,
        119198,
        119200,
        119228,
        119238,
        119244,
        119256,
        119278,
        119282,
        119284,
        119324,
        119352,
        119408,
        119422,
        119520,
        119548,
        119554,
        119556,
        119560,
        119568,
        119582,
        119584,
        119612,
        119616,
        119672,
        119686,
        119692,
        119704,
        119728,
        119742,
        119758,
        119772,
        119778,
        119780,
        119784,
        119798,
        119920,
        119934,
        120032,
        120060,
        120256,
        120312,
        120324,
        120328,
        120336,
        120352,
        120384,
        120440,
        120560,
        120582,
        120588,
        120600,
        120624,
        120638,
        120672,
        120700,
        120718,
        120732,
        120760,
        120770,
        120772,
        120776,
        120784,
        120798,
        120806,
        120812,
        120870,
        120876,
        120890,
        120902,
        120908,
        120920,
        120946,
        120948,
        120966,
        120972,
        120984,
        121008,
        121022,
        121038,
        121058,
        121060,
        121064,
        121078,
        121100,
        121112,
        121136,
        121150,
        121184,
        121212,
        121244,
        121282,
        121284,
        121288,
        121296,
        121318,
        121338,
        121356,
        121368,
        121392,
        121406,
        121440,
        121468,
        121536,
        121592,
        121656,
        121730,
        121732,
        121736,
        121744,
        121758,
        121760,
        121804,
        121842,
        121844,
        121890,
        121922,
        121924,
        121928,
        121936,
        121950,
        121958,
        121978,
        121986,
        121988,
        121992,
        122e3,
        122014,
        122016,
        122044,
        122060,
        122098,
        122100,
        122116,
        122120,
        122128,
        122142,
        122144,
        122172,
        122176,
        122232,
        122246,
        122264,
        122318,
        122338,
        122340,
        122344,
        122414,
        122418,
        122420,
        122446,
        122460,
        122466,
        122468,
        122472,
        122510,
        122524,
        122552,
        122562,
        122564,
        122568,
        122576,
        122598,
        122618,
        122646,
        122662,
        122668,
        122694,
        122700,
        122712,
        122738,
        122740,
        122762,
        122770,
        122772,
        122786,
        122788,
        122792,
        123018,
        123026,
        123028,
        123042,
        123044,
        123048,
        123062,
        123098,
        123146,
        123154,
        123156,
        123170,
        123172,
        123176,
        123190,
        123202,
        123204,
        123208,
        123216,
        123238,
        123244,
        123258,
        123290,
        123314,
        123316,
        123402,
        123410,
        123412,
        123426,
        123428,
        123432,
        123446,
        123458,
        123464,
        123472,
        123486,
        123494,
        123500,
        123514,
        123522,
        123524,
        123528,
        123536,
        123552,
        123580,
        123590,
        123596,
        123608,
        123630,
        123634,
        123636,
        123674,
        123698,
        123700,
        123740,
        123746,
        123748,
        123752,
        123834,
        123914,
        123922,
        123924,
        123938,
        123944,
        123958,
        123970,
        123976,
        123984,
        123998,
        124006,
        124012,
        124026,
        124034,
        124036,
        124048,
        124062,
        124064,
        124092,
        124102,
        124108,
        124120,
        124142,
        124146,
        124148,
        124162,
        124164,
        124168,
        124176,
        124190,
        124192,
        124220,
        124224,
        124280,
        124294,
        124300,
        124312,
        124336,
        124350,
        124366,
        124380,
        124386,
        124388,
        124392,
        124406,
        124442,
        124462,
        124466,
        124468,
        124494,
        124508,
        124514,
        124520,
        124558,
        124572,
        124600,
        124610,
        124612,
        124616,
        124624,
        124646,
        124666,
        124694,
        124710,
        124716,
        124730,
        124742,
        124748,
        124760,
        124786,
        124788,
        124818,
        124820,
        124834,
        124836,
        124840,
        124854,
        124946,
        124948,
        124962,
        124964,
        124968,
        124982,
        124994,
        124996,
        125e3,
        125008,
        125022,
        125030,
        125036,
        125050,
        125058,
        125060,
        125064,
        125072,
        125086,
        125088,
        125116,
        125126,
        125132,
        125144,
        125166,
        125170,
        125172,
        125186,
        125188,
        125192,
        125200,
        125216,
        125244,
        125248,
        125304,
        125318,
        125324,
        125336,
        125360,
        125374,
        125390,
        125404,
        125410,
        125412,
        125416,
        125430,
        125444,
        125448,
        125456,
        125472,
        125504,
        125560,
        125680,
        125702,
        125708,
        125720,
        125744,
        125758,
        125792,
        125820,
        125838,
        125852,
        125880,
        125890,
        125892,
        125896,
        125904,
        125918,
        125926,
        125932,
        125978,
        125998,
        126002,
        126004,
        126030,
        126044,
        126050,
        126052,
        126056,
        126094,
        126108,
        126136,
        126146,
        126148,
        126152,
        126160,
        126182,
        126202,
        126222,
        126236,
        126264,
        126320,
        126334,
        126338,
        126340,
        126344,
        126352,
        126366,
        126368,
        126412,
        126450,
        126452,
        126486,
        126502,
        126508,
        126522,
        126534,
        126540,
        126552,
        126574,
        126578,
        126580,
        126598,
        126604,
        126616,
        126640,
        126654,
        126670,
        126684,
        126690,
        126692,
        126696,
        126738,
        126754,
        126756,
        126760,
        126774,
        126786,
        126788,
        126792,
        126800,
        126814,
        126822,
        126828,
        126842,
        126894,
        126898,
        126900,
        126934,
        127126,
        127142,
        127148,
        127162,
        127178,
        127186,
        127188,
        127254,
        127270,
        127276,
        127290,
        127302,
        127308,
        127320,
        127342,
        127346,
        127348,
        127370,
        127378,
        127380,
        127394,
        127396,
        127400,
        127450,
        127510,
        127526,
        127532,
        127546,
        127558,
        127576,
        127598,
        127602,
        127604,
        127622,
        127628,
        127640,
        127664,
        127678,
        127694,
        127708,
        127714,
        127716,
        127720,
        127734,
        127754,
        127762,
        127764,
        127778,
        127784,
        127810,
        127812,
        127816,
        127824,
        127838,
        127846,
        127866,
        127898,
        127918,
        127922,
        127924,
        128022,
        128038,
        128044,
        128058,
        128070,
        128076,
        128088,
        128110,
        128114,
        128116,
        128134,
        128140,
        128152,
        128176,
        128190,
        128206,
        128220,
        128226,
        128228,
        128232,
        128246,
        128262,
        128268,
        128280,
        128304,
        128318,
        128352,
        128380,
        128398,
        128412,
        128440,
        128450,
        128452,
        128456,
        128464,
        128478,
        128486,
        128492,
        128506,
        128522,
        128530,
        128532,
        128546,
        128548,
        128552,
        128566,
        128578,
        128580,
        128584,
        128592,
        128606,
        128614,
        128634,
        128642,
        128644,
        128648,
        128656,
        128670,
        128672,
        128700,
        128716,
        128754,
        128756,
        128794,
        128814,
        128818,
        128820,
        128846,
        128860,
        128866,
        128868,
        128872,
        128886,
        128918,
        128934,
        128940,
        128954,
        128978,
        128980,
        129178,
        129198,
        129202,
        129204,
        129238,
        129258,
        129306,
        129326,
        129330,
        129332,
        129358,
        129372,
        129378,
        129380,
        129384,
        129398,
        129430,
        129446,
        129452,
        129466,
        129482,
        129490,
        129492,
        129562,
        129582,
        129586,
        129588,
        129614,
        129628,
        129634,
        129636,
        129640,
        129654,
        129678,
        129692,
        129720,
        129730,
        129732,
        129736,
        129744,
        129758,
        129766,
        129772,
        129814,
        129830,
        129836,
        129850,
        129862,
        129868,
        129880,
        129902,
        129906,
        129908,
        129930,
        129938,
        129940,
        129954,
        129956,
        129960,
        129974,
        130010
    ]), t.CODEWORD_TABLE = Int32Array.from([
        2627,
        1819,
        2622,
        2621,
        1813,
        1812,
        2729,
        2724,
        2723,
        2779,
        2774,
        2773,
        902,
        896,
        908,
        868,
        865,
        861,
        859,
        2511,
        873,
        871,
        1780,
        835,
        2493,
        825,
        2491,
        842,
        837,
        844,
        1764,
        1762,
        811,
        810,
        809,
        2483,
        807,
        2482,
        806,
        2480,
        815,
        814,
        813,
        812,
        2484,
        817,
        816,
        1745,
        1744,
        1742,
        1746,
        2655,
        2637,
        2635,
        2626,
        2625,
        2623,
        2628,
        1820,
        2752,
        2739,
        2737,
        2728,
        2727,
        2725,
        2730,
        2785,
        2783,
        2778,
        2777,
        2775,
        2780,
        787,
        781,
        747,
        739,
        736,
        2413,
        754,
        752,
        1719,
        692,
        689,
        681,
        2371,
        678,
        2369,
        700,
        697,
        694,
        703,
        1688,
        1686,
        642,
        638,
        2343,
        631,
        2341,
        627,
        2338,
        651,
        646,
        643,
        2345,
        654,
        652,
        1652,
        1650,
        1647,
        1654,
        601,
        599,
        2322,
        596,
        2321,
        594,
        2319,
        2317,
        611,
        610,
        608,
        606,
        2324,
        603,
        2323,
        615,
        614,
        612,
        1617,
        1616,
        1614,
        1612,
        616,
        1619,
        1618,
        2575,
        2538,
        2536,
        905,
        901,
        898,
        909,
        2509,
        2507,
        2504,
        870,
        867,
        864,
        860,
        2512,
        875,
        872,
        1781,
        2490,
        2489,
        2487,
        2485,
        1748,
        836,
        834,
        832,
        830,
        2494,
        827,
        2492,
        843,
        841,
        839,
        845,
        1765,
        1763,
        2701,
        2676,
        2674,
        2653,
        2648,
        2656,
        2634,
        2633,
        2631,
        2629,
        1821,
        2638,
        2636,
        2770,
        2763,
        2761,
        2750,
        2745,
        2753,
        2736,
        2735,
        2733,
        2731,
        1848,
        2740,
        2738,
        2786,
        2784,
        591,
        588,
        576,
        569,
        566,
        2296,
        1590,
        537,
        534,
        526,
        2276,
        522,
        2274,
        545,
        542,
        539,
        548,
        1572,
        1570,
        481,
        2245,
        466,
        2242,
        462,
        2239,
        492,
        485,
        482,
        2249,
        496,
        494,
        1534,
        1531,
        1528,
        1538,
        413,
        2196,
        406,
        2191,
        2188,
        425,
        419,
        2202,
        415,
        2199,
        432,
        430,
        427,
        1472,
        1467,
        1464,
        433,
        1476,
        1474,
        368,
        367,
        2160,
        365,
        2159,
        362,
        2157,
        2155,
        2152,
        378,
        377,
        375,
        2166,
        372,
        2165,
        369,
        2162,
        383,
        381,
        379,
        2168,
        1419,
        1418,
        1416,
        1414,
        385,
        1411,
        384,
        1423,
        1422,
        1420,
        1424,
        2461,
        802,
        2441,
        2439,
        790,
        786,
        783,
        794,
        2409,
        2406,
        2403,
        750,
        742,
        738,
        2414,
        756,
        753,
        1720,
        2367,
        2365,
        2362,
        2359,
        1663,
        693,
        691,
        684,
        2373,
        680,
        2370,
        702,
        699,
        696,
        704,
        1690,
        1687,
        2337,
        2336,
        2334,
        2332,
        1624,
        2329,
        1622,
        640,
        637,
        2344,
        634,
        2342,
        630,
        2340,
        650,
        648,
        645,
        2346,
        655,
        653,
        1653,
        1651,
        1649,
        1655,
        2612,
        2597,
        2595,
        2571,
        2568,
        2565,
        2576,
        2534,
        2529,
        2526,
        1787,
        2540,
        2537,
        907,
        904,
        900,
        910,
        2503,
        2502,
        2500,
        2498,
        1768,
        2495,
        1767,
        2510,
        2508,
        2506,
        869,
        866,
        863,
        2513,
        876,
        874,
        1782,
        2720,
        2713,
        2711,
        2697,
        2694,
        2691,
        2702,
        2672,
        2670,
        2664,
        1828,
        2678,
        2675,
        2647,
        2646,
        2644,
        2642,
        1823,
        2639,
        1822,
        2654,
        2652,
        2650,
        2657,
        2771,
        1855,
        2765,
        2762,
        1850,
        1849,
        2751,
        2749,
        2747,
        2754,
        353,
        2148,
        344,
        342,
        336,
        2142,
        332,
        2140,
        345,
        1375,
        1373,
        306,
        2130,
        299,
        2128,
        295,
        2125,
        319,
        314,
        311,
        2132,
        1354,
        1352,
        1349,
        1356,
        262,
        257,
        2101,
        253,
        2096,
        2093,
        274,
        273,
        267,
        2107,
        263,
        2104,
        280,
        278,
        275,
        1316,
        1311,
        1308,
        1320,
        1318,
        2052,
        202,
        2050,
        2044,
        2040,
        219,
        2063,
        212,
        2060,
        208,
        2055,
        224,
        221,
        2066,
        1260,
        1258,
        1252,
        231,
        1248,
        229,
        1266,
        1264,
        1261,
        1268,
        155,
        1998,
        153,
        1996,
        1994,
        1991,
        1988,
        165,
        164,
        2007,
        162,
        2006,
        159,
        2003,
        2e3,
        172,
        171,
        169,
        2012,
        166,
        2010,
        1186,
        1184,
        1182,
        1179,
        175,
        1176,
        173,
        1192,
        1191,
        1189,
        1187,
        176,
        1194,
        1193,
        2313,
        2307,
        2305,
        592,
        589,
        2294,
        2292,
        2289,
        578,
        572,
        568,
        2297,
        580,
        1591,
        2272,
        2267,
        2264,
        1547,
        538,
        536,
        529,
        2278,
        525,
        2275,
        547,
        544,
        541,
        1574,
        1571,
        2237,
        2235,
        2229,
        1493,
        2225,
        1489,
        478,
        2247,
        470,
        2244,
        465,
        2241,
        493,
        488,
        484,
        2250,
        498,
        495,
        1536,
        1533,
        1530,
        1539,
        2187,
        2186,
        2184,
        2182,
        1432,
        2179,
        1430,
        2176,
        1427,
        414,
        412,
        2197,
        409,
        2195,
        405,
        2193,
        2190,
        426,
        424,
        421,
        2203,
        418,
        2201,
        431,
        429,
        1473,
        1471,
        1469,
        1466,
        434,
        1477,
        1475,
        2478,
        2472,
        2470,
        2459,
        2457,
        2454,
        2462,
        803,
        2437,
        2432,
        2429,
        1726,
        2443,
        2440,
        792,
        789,
        785,
        2401,
        2399,
        2393,
        1702,
        2389,
        1699,
        2411,
        2408,
        2405,
        745,
        741,
        2415,
        758,
        755,
        1721,
        2358,
        2357,
        2355,
        2353,
        1661,
        2350,
        1660,
        2347,
        1657,
        2368,
        2366,
        2364,
        2361,
        1666,
        690,
        687,
        2374,
        683,
        2372,
        701,
        698,
        705,
        1691,
        1689,
        2619,
        2617,
        2610,
        2608,
        2605,
        2613,
        2593,
        2588,
        2585,
        1803,
        2599,
        2596,
        2563,
        2561,
        2555,
        1797,
        2551,
        1795,
        2573,
        2570,
        2567,
        2577,
        2525,
        2524,
        2522,
        2520,
        1786,
        2517,
        1785,
        2514,
        1783,
        2535,
        2533,
        2531,
        2528,
        1788,
        2541,
        2539,
        906,
        903,
        911,
        2721,
        1844,
        2715,
        2712,
        1838,
        1836,
        2699,
        2696,
        2693,
        2703,
        1827,
        1826,
        1824,
        2673,
        2671,
        2669,
        2666,
        1829,
        2679,
        2677,
        1858,
        1857,
        2772,
        1854,
        1853,
        1851,
        1856,
        2766,
        2764,
        143,
        1987,
        139,
        1986,
        135,
        133,
        131,
        1984,
        128,
        1983,
        125,
        1981,
        138,
        137,
        136,
        1985,
        1133,
        1132,
        1130,
        112,
        110,
        1974,
        107,
        1973,
        104,
        1971,
        1969,
        122,
        121,
        119,
        117,
        1977,
        114,
        1976,
        124,
        1115,
        1114,
        1112,
        1110,
        1117,
        1116,
        84,
        83,
        1953,
        81,
        1952,
        78,
        1950,
        1948,
        1945,
        94,
        93,
        91,
        1959,
        88,
        1958,
        85,
        1955,
        99,
        97,
        95,
        1961,
        1086,
        1085,
        1083,
        1081,
        1078,
        100,
        1090,
        1089,
        1087,
        1091,
        49,
        47,
        1917,
        44,
        1915,
        1913,
        1910,
        1907,
        59,
        1926,
        56,
        1925,
        53,
        1922,
        1919,
        66,
        64,
        1931,
        61,
        1929,
        1042,
        1040,
        1038,
        71,
        1035,
        70,
        1032,
        68,
        1048,
        1047,
        1045,
        1043,
        1050,
        1049,
        12,
        10,
        1869,
        1867,
        1864,
        1861,
        21,
        1880,
        19,
        1877,
        1874,
        1871,
        28,
        1888,
        25,
        1886,
        22,
        1883,
        982,
        980,
        977,
        974,
        32,
        30,
        991,
        989,
        987,
        984,
        34,
        995,
        994,
        992,
        2151,
        2150,
        2147,
        2146,
        2144,
        356,
        355,
        354,
        2149,
        2139,
        2138,
        2136,
        2134,
        1359,
        343,
        341,
        338,
        2143,
        335,
        2141,
        348,
        347,
        346,
        1376,
        1374,
        2124,
        2123,
        2121,
        2119,
        1326,
        2116,
        1324,
        310,
        308,
        305,
        2131,
        302,
        2129,
        298,
        2127,
        320,
        318,
        316,
        313,
        2133,
        322,
        321,
        1355,
        1353,
        1351,
        1357,
        2092,
        2091,
        2089,
        2087,
        1276,
        2084,
        1274,
        2081,
        1271,
        259,
        2102,
        256,
        2100,
        252,
        2098,
        2095,
        272,
        269,
        2108,
        266,
        2106,
        281,
        279,
        277,
        1317,
        1315,
        1313,
        1310,
        282,
        1321,
        1319,
        2039,
        2037,
        2035,
        2032,
        1203,
        2029,
        1200,
        1197,
        207,
        2053,
        205,
        2051,
        201,
        2049,
        2046,
        2043,
        220,
        218,
        2064,
        215,
        2062,
        211,
        2059,
        228,
        226,
        223,
        2069,
        1259,
        1257,
        1254,
        232,
        1251,
        230,
        1267,
        1265,
        1263,
        2316,
        2315,
        2312,
        2311,
        2309,
        2314,
        2304,
        2303,
        2301,
        2299,
        1593,
        2308,
        2306,
        590,
        2288,
        2287,
        2285,
        2283,
        1578,
        2280,
        1577,
        2295,
        2293,
        2291,
        579,
        577,
        574,
        571,
        2298,
        582,
        581,
        1592,
        2263,
        2262,
        2260,
        2258,
        1545,
        2255,
        1544,
        2252,
        1541,
        2273,
        2271,
        2269,
        2266,
        1550,
        535,
        532,
        2279,
        528,
        2277,
        546,
        543,
        549,
        1575,
        1573,
        2224,
        2222,
        2220,
        1486,
        2217,
        1485,
        2214,
        1482,
        1479,
        2238,
        2236,
        2234,
        2231,
        1496,
        2228,
        1492,
        480,
        477,
        2248,
        473,
        2246,
        469,
        2243,
        490,
        487,
        2251,
        497,
        1537,
        1535,
        1532,
        2477,
        2476,
        2474,
        2479,
        2469,
        2468,
        2466,
        2464,
        1730,
        2473,
        2471,
        2453,
        2452,
        2450,
        2448,
        1729,
        2445,
        1728,
        2460,
        2458,
        2456,
        2463,
        805,
        804,
        2428,
        2427,
        2425,
        2423,
        1725,
        2420,
        1724,
        2417,
        1722,
        2438,
        2436,
        2434,
        2431,
        1727,
        2444,
        2442,
        793,
        791,
        788,
        795,
        2388,
        2386,
        2384,
        1697,
        2381,
        1696,
        2378,
        1694,
        1692,
        2402,
        2400,
        2398,
        2395,
        1703,
        2392,
        1701,
        2412,
        2410,
        2407,
        751,
        748,
        744,
        2416,
        759,
        757,
        1807,
        2620,
        2618,
        1806,
        1805,
        2611,
        2609,
        2607,
        2614,
        1802,
        1801,
        1799,
        2594,
        2592,
        2590,
        2587,
        1804,
        2600,
        2598,
        1794,
        1793,
        1791,
        1789,
        2564,
        2562,
        2560,
        2557,
        1798,
        2554,
        1796,
        2574,
        2572,
        2569,
        2578,
        1847,
        1846,
        2722,
        1843,
        1842,
        1840,
        1845,
        2716,
        2714,
        1835,
        1834,
        1832,
        1830,
        1839,
        1837,
        2700,
        2698,
        2695,
        2704,
        1817,
        1811,
        1810,
        897,
        862,
        1777,
        829,
        826,
        838,
        1760,
        1758,
        808,
        2481,
        1741,
        1740,
        1738,
        1743,
        2624,
        1818,
        2726,
        2776,
        782,
        740,
        737,
        1715,
        686,
        679,
        695,
        1682,
        1680,
        639,
        628,
        2339,
        647,
        644,
        1645,
        1643,
        1640,
        1648,
        602,
        600,
        597,
        595,
        2320,
        593,
        2318,
        609,
        607,
        604,
        1611,
        1610,
        1608,
        1606,
        613,
        1615,
        1613,
        2328,
        926,
        924,
        892,
        886,
        899,
        857,
        850,
        2505,
        1778,
        824,
        823,
        821,
        819,
        2488,
        818,
        2486,
        833,
        831,
        828,
        840,
        1761,
        1759,
        2649,
        2632,
        2630,
        2746,
        2734,
        2732,
        2782,
        2781,
        570,
        567,
        1587,
        531,
        527,
        523,
        540,
        1566,
        1564,
        476,
        467,
        463,
        2240,
        486,
        483,
        1524,
        1521,
        1518,
        1529,
        411,
        403,
        2192,
        399,
        2189,
        423,
        416,
        1462,
        1457,
        1454,
        428,
        1468,
        1465,
        2210,
        366,
        363,
        2158,
        360,
        2156,
        357,
        2153,
        376,
        373,
        370,
        2163,
        1410,
        1409,
        1407,
        1405,
        382,
        1402,
        380,
        1417,
        1415,
        1412,
        1421,
        2175,
        2174,
        777,
        774,
        771,
        784,
        732,
        725,
        722,
        2404,
        743,
        1716,
        676,
        674,
        668,
        2363,
        665,
        2360,
        685,
        1684,
        1681,
        626,
        624,
        622,
        2335,
        620,
        2333,
        617,
        2330,
        641,
        635,
        649,
        1646,
        1644,
        1642,
        2566,
        928,
        925,
        2530,
        2527,
        894,
        891,
        888,
        2501,
        2499,
        2496,
        858,
        856,
        854,
        851,
        1779,
        2692,
        2668,
        2665,
        2645,
        2643,
        2640,
        2651,
        2768,
        2759,
        2757,
        2744,
        2743,
        2741,
        2748,
        352,
        1382,
        340,
        337,
        333,
        1371,
        1369,
        307,
        300,
        296,
        2126,
        315,
        312,
        1347,
        1342,
        1350,
        261,
        258,
        250,
        2097,
        246,
        2094,
        271,
        268,
        264,
        1306,
        1301,
        1298,
        276,
        1312,
        1309,
        2115,
        203,
        2048,
        195,
        2045,
        191,
        2041,
        213,
        209,
        2056,
        1246,
        1244,
        1238,
        225,
        1234,
        222,
        1256,
        1253,
        1249,
        1262,
        2080,
        2079,
        154,
        1997,
        150,
        1995,
        147,
        1992,
        1989,
        163,
        160,
        2004,
        156,
        2001,
        1175,
        1174,
        1172,
        1170,
        1167,
        170,
        1164,
        167,
        1185,
        1183,
        1180,
        1177,
        174,
        1190,
        1188,
        2025,
        2024,
        2022,
        587,
        586,
        564,
        559,
        556,
        2290,
        573,
        1588,
        520,
        518,
        512,
        2268,
        508,
        2265,
        530,
        1568,
        1565,
        461,
        457,
        2233,
        450,
        2230,
        446,
        2226,
        479,
        471,
        489,
        1526,
        1523,
        1520,
        397,
        395,
        2185,
        392,
        2183,
        389,
        2180,
        2177,
        410,
        2194,
        402,
        422,
        1463,
        1461,
        1459,
        1456,
        1470,
        2455,
        799,
        2433,
        2430,
        779,
        776,
        773,
        2397,
        2394,
        2390,
        734,
        728,
        724,
        746,
        1717,
        2356,
        2354,
        2351,
        2348,
        1658,
        677,
        675,
        673,
        670,
        667,
        688,
        1685,
        1683,
        2606,
        2589,
        2586,
        2559,
        2556,
        2552,
        927,
        2523,
        2521,
        2518,
        2515,
        1784,
        2532,
        895,
        893,
        890,
        2718,
        2709,
        2707,
        2689,
        2687,
        2684,
        2663,
        2662,
        2660,
        2658,
        1825,
        2667,
        2769,
        1852,
        2760,
        2758,
        142,
        141,
        1139,
        1138,
        134,
        132,
        129,
        126,
        1982,
        1129,
        1128,
        1126,
        1131,
        113,
        111,
        108,
        105,
        1972,
        101,
        1970,
        120,
        118,
        115,
        1109,
        1108,
        1106,
        1104,
        123,
        1113,
        1111,
        82,
        79,
        1951,
        75,
        1949,
        72,
        1946,
        92,
        89,
        86,
        1956,
        1077,
        1076,
        1074,
        1072,
        98,
        1069,
        96,
        1084,
        1082,
        1079,
        1088,
        1968,
        1967,
        48,
        45,
        1916,
        42,
        1914,
        39,
        1911,
        1908,
        60,
        57,
        54,
        1923,
        50,
        1920,
        1031,
        1030,
        1028,
        1026,
        67,
        1023,
        65,
        1020,
        62,
        1041,
        1039,
        1036,
        1033,
        69,
        1046,
        1044,
        1944,
        1943,
        1941,
        11,
        9,
        1868,
        7,
        1865,
        1862,
        1859,
        20,
        1878,
        16,
        1875,
        13,
        1872,
        970,
        968,
        966,
        963,
        29,
        960,
        26,
        23,
        983,
        981,
        978,
        975,
        33,
        971,
        31,
        990,
        988,
        985,
        1906,
        1904,
        1902,
        993,
        351,
        2145,
        1383,
        331,
        330,
        328,
        326,
        2137,
        323,
        2135,
        339,
        1372,
        1370,
        294,
        293,
        291,
        289,
        2122,
        286,
        2120,
        283,
        2117,
        309,
        303,
        317,
        1348,
        1346,
        1344,
        245,
        244,
        242,
        2090,
        239,
        2088,
        236,
        2085,
        2082,
        260,
        2099,
        249,
        270,
        1307,
        1305,
        1303,
        1300,
        1314,
        189,
        2038,
        186,
        2036,
        183,
        2033,
        2030,
        2026,
        206,
        198,
        2047,
        194,
        216,
        1247,
        1245,
        1243,
        1240,
        227,
        1237,
        1255,
        2310,
        2302,
        2300,
        2286,
        2284,
        2281,
        565,
        563,
        561,
        558,
        575,
        1589,
        2261,
        2259,
        2256,
        2253,
        1542,
        521,
        519,
        517,
        514,
        2270,
        511,
        533,
        1569,
        1567,
        2223,
        2221,
        2218,
        2215,
        1483,
        2211,
        1480,
        459,
        456,
        453,
        2232,
        449,
        474,
        491,
        1527,
        1525,
        1522,
        2475,
        2467,
        2465,
        2451,
        2449,
        2446,
        801,
        800,
        2426,
        2424,
        2421,
        2418,
        1723,
        2435,
        780,
        778,
        775,
        2387,
        2385,
        2382,
        2379,
        1695,
        2375,
        1693,
        2396,
        735,
        733,
        730,
        727,
        749,
        1718,
        2616,
        2615,
        2604,
        2603,
        2601,
        2584,
        2583,
        2581,
        2579,
        1800,
        2591,
        2550,
        2549,
        2547,
        2545,
        1792,
        2542,
        1790,
        2558,
        929,
        2719,
        1841,
        2710,
        2708,
        1833,
        1831,
        2690,
        2688,
        2686,
        1815,
        1809,
        1808,
        1774,
        1756,
        1754,
        1737,
        1736,
        1734,
        1739,
        1816,
        1711,
        1676,
        1674,
        633,
        629,
        1638,
        1636,
        1633,
        1641,
        598,
        1605,
        1604,
        1602,
        1600,
        605,
        1609,
        1607,
        2327,
        887,
        853,
        1775,
        822,
        820,
        1757,
        1755,
        1584,
        524,
        1560,
        1558,
        468,
        464,
        1514,
        1511,
        1508,
        1519,
        408,
        404,
        400,
        1452,
        1447,
        1444,
        417,
        1458,
        1455,
        2208,
        364,
        361,
        358,
        2154,
        1401,
        1400,
        1398,
        1396,
        374,
        1393,
        371,
        1408,
        1406,
        1403,
        1413,
        2173,
        2172,
        772,
        726,
        723,
        1712,
        672,
        669,
        666,
        682,
        1678,
        1675,
        625,
        623,
        621,
        618,
        2331,
        636,
        632,
        1639,
        1637,
        1635,
        920,
        918,
        884,
        880,
        889,
        849,
        848,
        847,
        846,
        2497,
        855,
        852,
        1776,
        2641,
        2742,
        2787,
        1380,
        334,
        1367,
        1365,
        301,
        297,
        1340,
        1338,
        1335,
        1343,
        255,
        251,
        247,
        1296,
        1291,
        1288,
        265,
        1302,
        1299,
        2113,
        204,
        196,
        192,
        2042,
        1232,
        1230,
        1224,
        214,
        1220,
        210,
        1242,
        1239,
        1235,
        1250,
        2077,
        2075,
        151,
        148,
        1993,
        144,
        1990,
        1163,
        1162,
        1160,
        1158,
        1155,
        161,
        1152,
        157,
        1173,
        1171,
        1168,
        1165,
        168,
        1181,
        1178,
        2021,
        2020,
        2018,
        2023,
        585,
        560,
        557,
        1585,
        516,
        509,
        1562,
        1559,
        458,
        447,
        2227,
        472,
        1516,
        1513,
        1510,
        398,
        396,
        393,
        390,
        2181,
        386,
        2178,
        407,
        1453,
        1451,
        1449,
        1446,
        420,
        1460,
        2209,
        769,
        764,
        720,
        712,
        2391,
        729,
        1713,
        664,
        663,
        661,
        659,
        2352,
        656,
        2349,
        671,
        1679,
        1677,
        2553,
        922,
        919,
        2519,
        2516,
        885,
        883,
        881,
        2685,
        2661,
        2659,
        2767,
        2756,
        2755,
        140,
        1137,
        1136,
        130,
        127,
        1125,
        1124,
        1122,
        1127,
        109,
        106,
        102,
        1103,
        1102,
        1100,
        1098,
        116,
        1107,
        1105,
        1980,
        80,
        76,
        73,
        1947,
        1068,
        1067,
        1065,
        1063,
        90,
        1060,
        87,
        1075,
        1073,
        1070,
        1080,
        1966,
        1965,
        46,
        43,
        40,
        1912,
        36,
        1909,
        1019,
        1018,
        1016,
        1014,
        58,
        1011,
        55,
        1008,
        51,
        1029,
        1027,
        1024,
        1021,
        63,
        1037,
        1034,
        1940,
        1939,
        1937,
        1942,
        8,
        1866,
        4,
        1863,
        1,
        1860,
        956,
        954,
        952,
        949,
        946,
        17,
        14,
        969,
        967,
        964,
        961,
        27,
        957,
        24,
        979,
        976,
        972,
        1901,
        1900,
        1898,
        1896,
        986,
        1905,
        1903,
        350,
        349,
        1381,
        329,
        327,
        324,
        1368,
        1366,
        292,
        290,
        287,
        284,
        2118,
        304,
        1341,
        1339,
        1337,
        1345,
        243,
        240,
        237,
        2086,
        233,
        2083,
        254,
        1297,
        1295,
        1293,
        1290,
        1304,
        2114,
        190,
        187,
        184,
        2034,
        180,
        2031,
        177,
        2027,
        199,
        1233,
        1231,
        1229,
        1226,
        217,
        1223,
        1241,
        2078,
        2076,
        584,
        555,
        554,
        552,
        550,
        2282,
        562,
        1586,
        507,
        506,
        504,
        502,
        2257,
        499,
        2254,
        515,
        1563,
        1561,
        445,
        443,
        441,
        2219,
        438,
        2216,
        435,
        2212,
        460,
        454,
        475,
        1517,
        1515,
        1512,
        2447,
        798,
        797,
        2422,
        2419,
        770,
        768,
        766,
        2383,
        2380,
        2376,
        721,
        719,
        717,
        714,
        731,
        1714,
        2602,
        2582,
        2580,
        2548,
        2546,
        2543,
        923,
        921,
        2717,
        2706,
        2705,
        2683,
        2682,
        2680,
        1771,
        1752,
        1750,
        1733,
        1732,
        1731,
        1735,
        1814,
        1707,
        1670,
        1668,
        1631,
        1629,
        1626,
        1634,
        1599,
        1598,
        1596,
        1594,
        1603,
        1601,
        2326,
        1772,
        1753,
        1751,
        1581,
        1554,
        1552,
        1504,
        1501,
        1498,
        1509,
        1442,
        1437,
        1434,
        401,
        1448,
        1445,
        2206,
        1392,
        1391,
        1389,
        1387,
        1384,
        359,
        1399,
        1397,
        1394,
        1404,
        2171,
        2170,
        1708,
        1672,
        1669,
        619,
        1632,
        1630,
        1628,
        1773,
        1378,
        1363,
        1361,
        1333,
        1328,
        1336,
        1286,
        1281,
        1278,
        248,
        1292,
        1289,
        2111,
        1218,
        1216,
        1210,
        197,
        1206,
        193,
        1228,
        1225,
        1221,
        1236,
        2073,
        2071,
        1151,
        1150,
        1148,
        1146,
        152,
        1143,
        149,
        1140,
        145,
        1161,
        1159,
        1156,
        1153,
        158,
        1169,
        1166,
        2017,
        2016,
        2014,
        2019,
        1582,
        510,
        1556,
        1553,
        452,
        448,
        1506,
        1500,
        394,
        391,
        387,
        1443,
        1441,
        1439,
        1436,
        1450,
        2207,
        765,
        716,
        713,
        1709,
        662,
        660,
        657,
        1673,
        1671,
        916,
        914,
        879,
        878,
        877,
        882,
        1135,
        1134,
        1121,
        1120,
        1118,
        1123,
        1097,
        1096,
        1094,
        1092,
        103,
        1101,
        1099,
        1979,
        1059,
        1058,
        1056,
        1054,
        77,
        1051,
        74,
        1066,
        1064,
        1061,
        1071,
        1964,
        1963,
        1007,
        1006,
        1004,
        1002,
        999,
        41,
        996,
        37,
        1017,
        1015,
        1012,
        1009,
        52,
        1025,
        1022,
        1936,
        1935,
        1933,
        1938,
        942,
        940,
        938,
        935,
        932,
        5,
        2,
        955,
        953,
        950,
        947,
        18,
        943,
        15,
        965,
        962,
        958,
        1895,
        1894,
        1892,
        1890,
        973,
        1899,
        1897,
        1379,
        325,
        1364,
        1362,
        288,
        285,
        1334,
        1332,
        1330,
        241,
        238,
        234,
        1287,
        1285,
        1283,
        1280,
        1294,
        2112,
        188,
        185,
        181,
        178,
        2028,
        1219,
        1217,
        1215,
        1212,
        200,
        1209,
        1227,
        2074,
        2072,
        583,
        553,
        551,
        1583,
        505,
        503,
        500,
        513,
        1557,
        1555,
        444,
        442,
        439,
        436,
        2213,
        455,
        451,
        1507,
        1505,
        1502,
        796,
        763,
        762,
        760,
        767,
        711,
        710,
        708,
        706,
        2377,
        718,
        715,
        1710,
        2544,
        917,
        915,
        2681,
        1627,
        1597,
        1595,
        2325,
        1769,
        1749,
        1747,
        1499,
        1438,
        1435,
        2204,
        1390,
        1388,
        1385,
        1395,
        2169,
        2167,
        1704,
        1665,
        1662,
        1625,
        1623,
        1620,
        1770,
        1329,
        1282,
        1279,
        2109,
        1214,
        1207,
        1222,
        2068,
        2065,
        1149,
        1147,
        1144,
        1141,
        146,
        1157,
        1154,
        2013,
        2011,
        2008,
        2015,
        1579,
        1549,
        1546,
        1495,
        1487,
        1433,
        1431,
        1428,
        1425,
        388,
        1440,
        2205,
        1705,
        658,
        1667,
        1664,
        1119,
        1095,
        1093,
        1978,
        1057,
        1055,
        1052,
        1062,
        1962,
        1960,
        1005,
        1003,
        1e3,
        997,
        38,
        1013,
        1010,
        1932,
        1930,
        1927,
        1934,
        941,
        939,
        936,
        933,
        6,
        930,
        3,
        951,
        948,
        944,
        1889,
        1887,
        1884,
        1881,
        959,
        1893,
        1891,
        35,
        1377,
        1360,
        1358,
        1327,
        1325,
        1322,
        1331,
        1277,
        1275,
        1272,
        1269,
        235,
        1284,
        2110,
        1205,
        1204,
        1201,
        1198,
        182,
        1195,
        179,
        1213,
        2070,
        2067,
        1580,
        501,
        1551,
        1548,
        440,
        437,
        1497,
        1494,
        1490,
        1503,
        761,
        709,
        707,
        1706,
        913,
        912,
        2198,
        1386,
        2164,
        2161,
        1621,
        1766,
        2103,
        1208,
        2058,
        2054,
        1145,
        1142,
        2005,
        2002,
        1999,
        2009,
        1488,
        1429,
        1426,
        2200,
        1698,
        1659,
        1656,
        1975,
        1053,
        1957,
        1954,
        1001,
        998,
        1924,
        1921,
        1918,
        1928,
        937,
        934,
        931,
        1879,
        1876,
        1873,
        1870,
        945,
        1885,
        1882,
        1323,
        1273,
        1270,
        2105,
        1202,
        1199,
        1196,
        1211,
        2061,
        2057,
        1576,
        1543,
        1540,
        1484,
        1481,
        1478,
        1491,
        1700
    ]), t;
}(), $2be8636d379871d6$var$cn = function() {
    function t(t, e) {
        this.bits = t, this.points = e;
    }
    return t.prototype.getBits = function() {
        return this.bits;
    }, t.prototype.getPoints = function() {
        return this.points;
    }, t;
}(), $2be8636d379871d6$var$fn = function(t) {
    var e = "function" == typeof Symbol && Symbol.iterator, r = e && t[e], n = 0;
    if (r) return r.call(t);
    if (t && "number" == typeof t.length) return {
        next: function() {
            return t && n >= t.length && (t = void 0), {
                value: t && t[n++],
                done: !t
            };
        }
    };
    throw new TypeError(e ? "Object is not iterable." : "Symbol.iterator is not defined.");
}, $2be8636d379871d6$var$hn = function() {
    function t() {}
    return t.detectMultiple = function(e, r, n) {
        var o = e.getBlackMatrix(), i = t.detect(n, o);
        return i.length || ((o = o.clone()).rotate180(), i = t.detect(n, o)), new $2be8636d379871d6$var$cn(o, i);
    }, t.detect = function(e, r) {
        for(var n, o, i = new Array(), a = 0, u = 0, s = !1; a < r.getHeight();){
            var c = t.findVertices(r, a, u);
            if (null != c[0] || null != c[3]) {
                if (s = !0, i.push(c), !e) break;
                null != c[2] ? (u = Math.trunc(c[2].getX()), a = Math.trunc(c[2].getY())) : (u = Math.trunc(c[4].getX()), a = Math.trunc(c[4].getY()));
            } else {
                if (!s) break;
                s = !1, u = 0;
                try {
                    for(var f = (n = void 0, $2be8636d379871d6$var$fn(i)), h = f.next(); !h.done; h = f.next()){
                        var l = h.value;
                        null != l[1] && (a = Math.trunc(Math.max(a, l[1].getY()))), null != l[3] && (a = Math.max(a, Math.trunc(l[3].getY())));
                    }
                } catch (t) {
                    n = {
                        error: t
                    };
                } finally{
                    try {
                        h && !h.done && (o = f.return) && o.call(f);
                    } finally{
                        if (n) throw n.error;
                    }
                }
                a += t.ROW_STEP;
            }
        }
        return i;
    }, t.findVertices = function(e, r, n) {
        var o = e.getHeight(), i = e.getWidth(), a = new Array(8);
        return t.copyToResult(a, t.findRowsWithPattern(e, o, i, r, n, t.START_PATTERN), t.INDEXES_START_PATTERN), null != a[4] && (n = Math.trunc(a[4].getX()), r = Math.trunc(a[4].getY())), t.copyToResult(a, t.findRowsWithPattern(e, o, i, r, n, t.STOP_PATTERN), t.INDEXES_STOP_PATTERN), a;
    }, t.copyToResult = function(t, e, r) {
        for(var n = 0; n < r.length; n++)t[r[n]] = e[n];
    }, t.findRowsWithPattern = function(e, r, n, o, i, a) {
        for(var u = new Array(4), s = !1, c = new Int32Array(a.length); o < r; o += t.ROW_STEP)if (null != (d = t.findGuardPattern(e, i, o, n, !1, a, c))) {
            for(; o > 0;){
                if (null == (l = t.findGuardPattern(e, i, --o, n, !1, a, c))) {
                    o++;
                    break;
                }
                d = l;
            }
            u[0] = new $2be8636d379871d6$var$At(d[0], o), u[1] = new $2be8636d379871d6$var$At(d[1], o), s = !0;
            break;
        }
        var f = o + 1;
        if (s) {
            for(var h = 0, l = Int32Array.from([
                Math.trunc(u[0].getX()),
                Math.trunc(u[1].getX())
            ]); f < r; f++){
                var d;
                if (null != (d = t.findGuardPattern(e, l[0], f, n, !1, a, c)) && Math.abs(l[0] - d[0]) < t.MAX_PATTERN_DRIFT && Math.abs(l[1] - d[1]) < t.MAX_PATTERN_DRIFT) l = d, h = 0;
                else {
                    if (h > t.SKIPPED_ROW_COUNT_MAX) break;
                    h++;
                }
            }
            f -= h + 1, u[2] = new $2be8636d379871d6$var$At(l[0], f), u[3] = new $2be8636d379871d6$var$At(l[1], f);
        }
        return f - o < t.BARCODE_MIN_HEIGHT && $2be8636d379871d6$var$C.fill(u, null), u;
    }, t.findGuardPattern = function(e, r, n, o, i, a, u) {
        $2be8636d379871d6$var$C.fillWithin(u, 0, u.length, 0);
        for(var s = r, c = 0; e.get(s, n) && s > 0 && c++ < t.MAX_PIXEL_DRIFT;)s--;
        for(var f = s, h = 0, l = a.length, d = i; f < o; f++)if (e.get(f, n) !== d) u[h]++;
        else {
            if (h === l - 1) {
                if (t.patternMatchVariance(u, a, t.MAX_INDIVIDUAL_VARIANCE) < t.MAX_AVG_VARIANCE) return new Int32Array([
                    s,
                    f
                ]);
                s += u[0] + u[1], $2be8636d379871d6$var$w.arraycopy(u, 2, u, 0, h - 1), u[h - 1] = 0, u[h] = 0, h--;
            } else h++;
            u[h] = 1, d = !d;
        }
        return h === l - 1 && t.patternMatchVariance(u, a, t.MAX_INDIVIDUAL_VARIANCE) < t.MAX_AVG_VARIANCE ? new Int32Array([
            s,
            f - 1
        ]) : null;
    }, t.patternMatchVariance = function(t, e, r) {
        for(var n = t.length, o = 0, i = 0, a = 0; a < n; a++)o += t[a], i += e[a];
        if (o < i) return 1 / 0;
        var u = o / i;
        r *= u;
        for(var s = 0, c = 0; c < n; c++){
            var f = t[c], h = e[c] * u, l = f > h ? f - h : h - f;
            if (l > r) return 1 / 0;
            s += l;
        }
        return s / o;
    }, t.INDEXES_START_PATTERN = Int32Array.from([
        0,
        4,
        1,
        5
    ]), t.INDEXES_STOP_PATTERN = Int32Array.from([
        6,
        2,
        7,
        3
    ]), t.MAX_AVG_VARIANCE = 0.42, t.MAX_INDIVIDUAL_VARIANCE = 0.8, t.START_PATTERN = Int32Array.from([
        8,
        1,
        1,
        1,
        1,
        1,
        1,
        3
    ]), t.STOP_PATTERN = Int32Array.from([
        7,
        1,
        1,
        3,
        1,
        1,
        1,
        2,
        1
    ]), t.MAX_PIXEL_DRIFT = 3, t.MAX_PATTERN_DRIFT = 5, t.SKIPPED_ROW_COUNT_MAX = 25, t.ROW_STEP = 5, t.BARCODE_MIN_HEIGHT = 10, t;
}(), $2be8636d379871d6$var$ln = function(t) {
    var e = "function" == typeof Symbol && Symbol.iterator, r = e && t[e], n = 0;
    if (r) return r.call(t);
    if (t && "number" == typeof t.length) return {
        next: function() {
            return t && n >= t.length && (t = void 0), {
                value: t && t[n++],
                done: !t
            };
        }
    };
    throw new TypeError(e ? "Object is not iterable." : "Symbol.iterator is not defined.");
}, $2be8636d379871d6$var$dn = function() {
    function t(t, e) {
        if (0 === e.length) throw new $2be8636d379871d6$var$l();
        this.field = t;
        var r = e.length;
        if (r > 1 && 0 === e[0]) {
            for(var n = 1; n < r && 0 === e[n];)n++;
            n === r ? this.coefficients = new Int32Array([
                0
            ]) : (this.coefficients = new Int32Array(r - n), $2be8636d379871d6$var$w.arraycopy(e, n, this.coefficients, 0, this.coefficients.length));
        } else this.coefficients = e;
    }
    return t.prototype.getCoefficients = function() {
        return this.coefficients;
    }, t.prototype.getDegree = function() {
        return this.coefficients.length - 1;
    }, t.prototype.isZero = function() {
        return 0 === this.coefficients[0];
    }, t.prototype.getCoefficient = function(t) {
        return this.coefficients[this.coefficients.length - 1 - t];
    }, t.prototype.evaluateAt = function(t) {
        var e, r;
        if (0 === t) return this.getCoefficient(0);
        if (1 === t) {
            var n = 0;
            try {
                for(var o = $2be8636d379871d6$var$ln(this.coefficients), i = o.next(); !i.done; i = o.next()){
                    var a = i.value;
                    n = this.field.add(n, a);
                }
            } catch (t) {
                e = {
                    error: t
                };
            } finally{
                try {
                    i && !i.done && (r = o.return) && r.call(o);
                } finally{
                    if (e) throw e.error;
                }
            }
            return n;
        }
        for(var u = this.coefficients[0], s = this.coefficients.length, c = 1; c < s; c++)u = this.field.add(this.field.multiply(t, u), this.coefficients[c]);
        return u;
    }, t.prototype.add = function(e) {
        if (!this.field.equals(e.field)) throw new $2be8636d379871d6$var$l("ModulusPolys do not have same ModulusGF field");
        if (this.isZero()) return e;
        if (e.isZero()) return this;
        var r = this.coefficients, n = e.coefficients;
        if (r.length > n.length) {
            var o = r;
            r = n, n = o;
        }
        var i = new Int32Array(n.length), a = n.length - r.length;
        $2be8636d379871d6$var$w.arraycopy(n, 0, i, 0, a);
        for(var u = a; u < n.length; u++)i[u] = this.field.add(r[u - a], n[u]);
        return new t(this.field, i);
    }, t.prototype.subtract = function(t) {
        if (!this.field.equals(t.field)) throw new $2be8636d379871d6$var$l("ModulusPolys do not have same ModulusGF field");
        return t.isZero() ? this : this.add(t.negative());
    }, t.prototype.multiply = function(e) {
        return e instanceof t ? this.multiplyOther(e) : this.multiplyScalar(e);
    }, t.prototype.multiplyOther = function(e) {
        if (!this.field.equals(e.field)) throw new $2be8636d379871d6$var$l("ModulusPolys do not have same ModulusGF field");
        if (this.isZero() || e.isZero()) return new t(this.field, new Int32Array([
            0
        ]));
        for(var r = this.coefficients, n = r.length, o = e.coefficients, i = o.length, a = new Int32Array(n + i - 1), u = 0; u < n; u++)for(var s = r[u], c = 0; c < i; c++)a[u + c] = this.field.add(a[u + c], this.field.multiply(s, o[c]));
        return new t(this.field, a);
    }, t.prototype.negative = function() {
        for(var e = this.coefficients.length, r = new Int32Array(e), n = 0; n < e; n++)r[n] = this.field.subtract(0, this.coefficients[n]);
        return new t(this.field, r);
    }, t.prototype.multiplyScalar = function(e) {
        if (0 === e) return new t(this.field, new Int32Array([
            0
        ]));
        if (1 === e) return this;
        for(var r = this.coefficients.length, n = new Int32Array(r), o = 0; o < r; o++)n[o] = this.field.multiply(this.coefficients[o], e);
        return new t(this.field, n);
    }, t.prototype.multiplyByMonomial = function(e, r) {
        if (e < 0) throw new $2be8636d379871d6$var$l();
        if (0 === r) return new t(this.field, new Int32Array([
            0
        ]));
        for(var n = this.coefficients.length, o = new Int32Array(n + e), i = 0; i < n; i++)o[i] = this.field.multiply(this.coefficients[i], r);
        return new t(this.field, o);
    }, t.prototype.toString = function() {
        for(var t = new $2be8636d379871d6$var$k(), e = this.getDegree(); e >= 0; e--){
            var r = this.getCoefficient(e);
            0 !== r && (r < 0 ? (t.append(" - "), r = -r) : t.length() > 0 && t.append(" + "), 0 !== e && 1 === r || t.append(r), 0 !== e && (1 === e ? t.append("x") : (t.append("x^"), t.append(e))));
        }
        return t.toString();
    }, t;
}(), $2be8636d379871d6$var$pn = function() {
    function t() {}
    return t.prototype.add = function(t, e) {
        return (t + e) % this.modulus;
    }, t.prototype.subtract = function(t, e) {
        return (this.modulus + t - e) % this.modulus;
    }, t.prototype.exp = function(t) {
        return this.expTable[t];
    }, t.prototype.log = function(t) {
        if (0 === t) throw new $2be8636d379871d6$var$l();
        return this.logTable[t];
    }, t.prototype.inverse = function(t) {
        if (0 === t) throw new $2be8636d379871d6$var$ft();
        return this.expTable[this.modulus - this.logTable[t] - 1];
    }, t.prototype.multiply = function(t, e) {
        return 0 === t || 0 === e ? 0 : this.expTable[(this.logTable[t] + this.logTable[e]) % (this.modulus - 1)];
    }, t.prototype.getSize = function() {
        return this.modulus;
    }, t.prototype.equals = function(t) {
        return t === this;
    }, t;
}(), $2be8636d379871d6$var$gn = function() {
    var t = function(e, r) {
        return t = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(t, e) {
            t.__proto__ = e;
        } || function(t, e) {
            for(var r in e)e.hasOwnProperty(r) && (t[r] = e[r]);
        }, t(e, r);
    };
    return function(e, r) {
        function n() {
            this.constructor = e;
        }
        t(e, r), e.prototype = null === r ? Object.create(r) : (n.prototype = r.prototype, new n());
    };
}(), $2be8636d379871d6$var$yn = function(t) {
    function e(e, r) {
        var n = t.call(this) || this;
        n.modulus = e, n.expTable = new Int32Array(e), n.logTable = new Int32Array(e);
        for(var o = 1, i = 0; i < e; i++)n.expTable[i] = o, o = o * r % e;
        for(i = 0; i < e - 1; i++)n.logTable[n.expTable[i]] = i;
        return n.zero = new $2be8636d379871d6$var$dn(n, new Int32Array([
            0
        ])), n.one = new $2be8636d379871d6$var$dn(n, new Int32Array([
            1
        ])), n;
    }
    return $2be8636d379871d6$var$gn(e, t), e.prototype.getZero = function() {
        return this.zero;
    }, e.prototype.getOne = function() {
        return this.one;
    }, e.prototype.buildMonomial = function(t, e) {
        if (t < 0) throw new $2be8636d379871d6$var$l();
        if (0 === e) return this.zero;
        var r = new Int32Array(t + 1);
        return r[0] = e, new $2be8636d379871d6$var$dn(this, r);
    }, e.PDF417_GF = new e($2be8636d379871d6$var$sn.NUMBER_OF_CODEWORDS, 3), e;
}($2be8636d379871d6$var$pn), $2be8636d379871d6$var$wn = function(t) {
    var e = "function" == typeof Symbol && Symbol.iterator, r = e && t[e], n = 0;
    if (r) return r.call(t);
    if (t && "number" == typeof t.length) return {
        next: function() {
            return t && n >= t.length && (t = void 0), {
                value: t && t[n++],
                done: !t
            };
        }
    };
    throw new TypeError(e ? "Object is not iterable." : "Symbol.iterator is not defined.");
}, $2be8636d379871d6$var$_n = function() {
    function t() {
        this.field = $2be8636d379871d6$var$yn.PDF417_GF;
    }
    return t.prototype.decode = function(t, e, r) {
        for(var n, o, i = new $2be8636d379871d6$var$dn(this.field, t), a = new Int32Array(e), u = !1, s = e; s > 0; s--){
            var c = i.evaluateAt(this.field.exp(s));
            a[e - s] = c, 0 !== c && (u = !0);
        }
        if (!u) return 0;
        var f = this.field.getOne();
        if (null != r) try {
            for(var h = $2be8636d379871d6$var$wn(r), l = h.next(); !l.done; l = h.next()){
                var d = l.value, p = this.field.exp(t.length - 1 - d), y = new $2be8636d379871d6$var$dn(this.field, new Int32Array([
                    this.field.subtract(0, p),
                    1
                ]));
                f = f.multiply(y);
            }
        } catch (t) {
            n = {
                error: t
            };
        } finally{
            try {
                l && !l.done && (o = h.return) && o.call(h);
            } finally{
                if (n) throw n.error;
            }
        }
        var w = new $2be8636d379871d6$var$dn(this.field, a), _ = this.runEuclideanAlgorithm(this.field.buildMonomial(e, 1), w, e), v = _[0], m = _[1], A = this.findErrorLocations(v), E = this.findErrorMagnitudes(m, v, A);
        for(s = 0; s < A.length; s++){
            var C = t.length - 1 - this.field.log(A[s]);
            if (C < 0) throw $2be8636d379871d6$var$g.getChecksumInstance();
            t[C] = this.field.subtract(t[C], E[s]);
        }
        return A.length;
    }, t.prototype.runEuclideanAlgorithm = function(t, e, r) {
        if (t.getDegree() < e.getDegree()) {
            var n = t;
            t = e, e = n;
        }
        for(var o = t, i = e, a = this.field.getZero(), u = this.field.getOne(); i.getDegree() >= Math.round(r / 2);){
            var s = o, c = a;
            if (a = u, (o = i).isZero()) throw $2be8636d379871d6$var$g.getChecksumInstance();
            i = s;
            for(var f = this.field.getZero(), h = o.getCoefficient(o.getDegree()), l = this.field.inverse(h); i.getDegree() >= o.getDegree() && !i.isZero();){
                var d = i.getDegree() - o.getDegree(), p = this.field.multiply(i.getCoefficient(i.getDegree()), l);
                f = f.add(this.field.buildMonomial(d, p)), i = i.subtract(o.multiplyByMonomial(d, p));
            }
            u = f.multiply(a).subtract(c).negative();
        }
        var y = u.getCoefficient(0);
        if (0 === y) throw $2be8636d379871d6$var$g.getChecksumInstance();
        var w = this.field.inverse(y);
        return [
            u.multiply(w),
            i.multiply(w)
        ];
    }, t.prototype.findErrorLocations = function(t) {
        for(var e = t.getDegree(), r = new Int32Array(e), n = 0, o = 1; o < this.field.getSize() && n < e; o++)0 === t.evaluateAt(o) && (r[n] = this.field.inverse(o), n++);
        if (n !== e) throw $2be8636d379871d6$var$g.getChecksumInstance();
        return r;
    }, t.prototype.findErrorMagnitudes = function(t, e, r) {
        for(var n = e.getDegree(), o = new Int32Array(n), i = 1; i <= n; i++)o[n - i] = this.field.multiply(i, e.getCoefficient(i));
        var a = new $2be8636d379871d6$var$dn(this.field, o), u = r.length, s = new Int32Array(u);
        for(i = 0; i < u; i++){
            var c = this.field.inverse(r[i]), f = this.field.subtract(0, t.evaluateAt(c)), h = this.field.inverse(a.evaluateAt(c));
            s[i] = this.field.multiply(f, h);
        }
        return s;
    }, t;
}(), $2be8636d379871d6$var$vn = function() {
    function t(e, r, n, o, i) {
        e instanceof t ? this.constructor_2(e) : this.constructor_1(e, r, n, o, i);
    }
    return t.prototype.constructor_1 = function(t, e, r, n, o) {
        var i = null == e || null == r, a = null == n || null == o;
        if (i && a) throw new $2be8636d379871d6$var$U();
        i ? (e = new $2be8636d379871d6$var$At(0, n.getY()), r = new $2be8636d379871d6$var$At(0, o.getY())) : a && (n = new $2be8636d379871d6$var$At(t.getWidth() - 1, e.getY()), o = new $2be8636d379871d6$var$At(t.getWidth() - 1, r.getY())), this.image = t, this.topLeft = e, this.bottomLeft = r, this.topRight = n, this.bottomRight = o, this.minX = Math.trunc(Math.min(e.getX(), r.getX())), this.maxX = Math.trunc(Math.max(n.getX(), o.getX())), this.minY = Math.trunc(Math.min(e.getY(), n.getY())), this.maxY = Math.trunc(Math.max(r.getY(), o.getY()));
    }, t.prototype.constructor_2 = function(t) {
        this.image = t.image, this.topLeft = t.getTopLeft(), this.bottomLeft = t.getBottomLeft(), this.topRight = t.getTopRight(), this.bottomRight = t.getBottomRight(), this.minX = t.getMinX(), this.maxX = t.getMaxX(), this.minY = t.getMinY(), this.maxY = t.getMaxY();
    }, t.merge = function(e, r) {
        return null == e ? r : null == r ? e : new t(e.image, e.topLeft, e.bottomLeft, r.topRight, r.bottomRight);
    }, t.prototype.addMissingRows = function(e, r, n) {
        var o = this.topLeft, i = this.bottomLeft, a = this.topRight, u = this.bottomRight;
        if (e > 0) {
            var s = n ? this.topLeft : this.topRight, c = Math.trunc(s.getY() - e);
            c < 0 && (c = 0);
            var f = new $2be8636d379871d6$var$At(s.getX(), c);
            n ? o = f : a = f;
        }
        if (r > 0) {
            var h = n ? this.bottomLeft : this.bottomRight, l = Math.trunc(h.getY() + r);
            l >= this.image.getHeight() && (l = this.image.getHeight() - 1);
            var d = new $2be8636d379871d6$var$At(h.getX(), l);
            n ? i = d : u = d;
        }
        return new t(this.image, o, i, a, u);
    }, t.prototype.getMinX = function() {
        return this.minX;
    }, t.prototype.getMaxX = function() {
        return this.maxX;
    }, t.prototype.getMinY = function() {
        return this.minY;
    }, t.prototype.getMaxY = function() {
        return this.maxY;
    }, t.prototype.getTopLeft = function() {
        return this.topLeft;
    }, t.prototype.getTopRight = function() {
        return this.topRight;
    }, t.prototype.getBottomLeft = function() {
        return this.bottomLeft;
    }, t.prototype.getBottomRight = function() {
        return this.bottomRight;
    }, t;
}(), $2be8636d379871d6$var$mn = function() {
    function t(t, e, r, n) {
        this.columnCount = t, this.errorCorrectionLevel = n, this.rowCountUpperPart = e, this.rowCountLowerPart = r, this.rowCount = e + r;
    }
    return t.prototype.getColumnCount = function() {
        return this.columnCount;
    }, t.prototype.getErrorCorrectionLevel = function() {
        return this.errorCorrectionLevel;
    }, t.prototype.getRowCount = function() {
        return this.rowCount;
    }, t.prototype.getRowCountUpperPart = function() {
        return this.rowCountUpperPart;
    }, t.prototype.getRowCountLowerPart = function() {
        return this.rowCountLowerPart;
    }, t;
}(), $2be8636d379871d6$var$An = function() {
    function t() {
        this.buffer = "";
    }
    return t.form = function(t, e) {
        var r = -1;
        return t.replace(/%(-)?(0?[0-9]+)?([.][0-9]+)?([#][0-9]+)?([scfpexd%])/g, function(t, n, o, i, a, u) {
            if ("%%" === t) return "%";
            if (void 0 !== e[++r]) {
                t = i ? parseInt(i.substr(1)) : void 0;
                var s, c = a ? parseInt(a.substr(1)) : void 0;
                switch(u){
                    case "s":
                        s = e[r];
                        break;
                    case "c":
                        s = e[r][0];
                        break;
                    case "f":
                        s = parseFloat(e[r]).toFixed(t);
                        break;
                    case "p":
                        s = parseFloat(e[r]).toPrecision(t);
                        break;
                    case "e":
                        s = parseFloat(e[r]).toExponential(t);
                        break;
                    case "x":
                        s = parseInt(e[r]).toString(c || 16);
                        break;
                    case "d":
                        s = parseFloat(parseInt(e[r], c || 10).toPrecision(t)).toFixed(0);
                }
                s = "object" == typeof s ? JSON.stringify(s) : (+s).toString(c);
                for(var f = parseInt(o), h = o && o[0] + "" == "0" ? "0" : " "; s.length < f;)s = void 0 !== n ? s + h : h + s;
                return s;
            }
        });
    }, t.prototype.format = function(e) {
        for(var r = [], n = 1; n < arguments.length; n++)r[n - 1] = arguments[n];
        this.buffer += t.form(e, r);
    }, t.prototype.toString = function() {
        return this.buffer;
    }, t;
}(), $2be8636d379871d6$var$En = function(t) {
    var e = "function" == typeof Symbol && Symbol.iterator, r = e && t[e], n = 0;
    if (r) return r.call(t);
    if (t && "number" == typeof t.length) return {
        next: function() {
            return t && n >= t.length && (t = void 0), {
                value: t && t[n++],
                done: !t
            };
        }
    };
    throw new TypeError(e ? "Object is not iterable." : "Symbol.iterator is not defined.");
}, $2be8636d379871d6$var$Cn = function() {
    function t(t) {
        this.boundingBox = new $2be8636d379871d6$var$vn(t), this.codewords = new Array(t.getMaxY() - t.getMinY() + 1);
    }
    return t.prototype.getCodewordNearby = function(e) {
        var r = this.getCodeword(e);
        if (null != r) return r;
        for(var n = 1; n < t.MAX_NEARBY_DISTANCE; n++){
            var o = this.imageRowToCodewordIndex(e) - n;
            if (o >= 0 && null != (r = this.codewords[o])) return r;
            if ((o = this.imageRowToCodewordIndex(e) + n) < this.codewords.length && null != (r = this.codewords[o])) return r;
        }
        return null;
    }, t.prototype.imageRowToCodewordIndex = function(t) {
        return t - this.boundingBox.getMinY();
    }, t.prototype.setCodeword = function(t, e) {
        this.codewords[this.imageRowToCodewordIndex(t)] = e;
    }, t.prototype.getCodeword = function(t) {
        return this.codewords[this.imageRowToCodewordIndex(t)];
    }, t.prototype.getBoundingBox = function() {
        return this.boundingBox;
    }, t.prototype.getCodewords = function() {
        return this.codewords;
    }, t.prototype.toString = function() {
        var t, e, r = new $2be8636d379871d6$var$An(), n = 0;
        try {
            for(var o = $2be8636d379871d6$var$En(this.codewords), i = o.next(); !i.done; i = o.next()){
                var a = i.value;
                null != a ? r.format("%3d: %3d|%3d%n", n++, a.getRowNumber(), a.getValue()) : r.format("%3d:    |   %n", n++);
            }
        } catch (e) {
            t = {
                error: e
            };
        } finally{
            try {
                i && !i.done && (e = o.return) && e.call(o);
            } finally{
                if (t) throw t.error;
            }
        }
        return r.toString();
    }, t.MAX_NEARBY_DISTANCE = 5, t;
}(), $2be8636d379871d6$var$In = function(t) {
    var e = "function" == typeof Symbol && Symbol.iterator, r = e && t[e], n = 0;
    if (r) return r.call(t);
    if (t && "number" == typeof t.length) return {
        next: function() {
            return t && n >= t.length && (t = void 0), {
                value: t && t[n++],
                done: !t
            };
        }
    };
    throw new TypeError(e ? "Object is not iterable." : "Symbol.iterator is not defined.");
}, $2be8636d379871d6$var$Sn = function(t, e) {
    var r = "function" == typeof Symbol && t[Symbol.iterator];
    if (!r) return t;
    var n, o, i = r.call(t), a = [];
    try {
        for(; (void 0 === e || e-- > 0) && !(n = i.next()).done;)a.push(n.value);
    } catch (t) {
        o = {
            error: t
        };
    } finally{
        try {
            n && !n.done && (r = i.return) && r.call(i);
        } finally{
            if (o) throw o.error;
        }
    }
    return a;
}, $2be8636d379871d6$var$On = function() {
    function t() {
        this.values = new Map();
    }
    return t.prototype.setValue = function(t) {
        t = Math.trunc(t);
        var e = this.values.get(t);
        null == e && (e = 0), e++, this.values.set(t, e);
    }, t.prototype.getValue = function() {
        var t, e, r = -1, n = new Array(), o = function(t, e) {
            var o = function() {
                return t;
            }, i = function() {
                return e;
            };
            i() > r ? (r = i(), (n = []).push(o())) : i() === r && n.push(o());
        };
        try {
            for(var i = $2be8636d379871d6$var$In(this.values.entries()), a = i.next(); !a.done; a = i.next()){
                var u = $2be8636d379871d6$var$Sn(a.value, 2);
                o(u[0], u[1]);
            }
        } catch (e) {
            t = {
                error: e
            };
        } finally{
            try {
                a && !a.done && (e = i.return) && e.call(i);
            } finally{
                if (t) throw t.error;
            }
        }
        return $2be8636d379871d6$var$sn.toIntArray(n);
    }, t.prototype.getConfidence = function(t) {
        return this.values.get(t);
    }, t;
}(), $2be8636d379871d6$var$Tn = function() {
    var t = function(e, r) {
        return t = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(t, e) {
            t.__proto__ = e;
        } || function(t, e) {
            for(var r in e)e.hasOwnProperty(r) && (t[r] = e[r]);
        }, t(e, r);
    };
    return function(e, r) {
        function n() {
            this.constructor = e;
        }
        t(e, r), e.prototype = null === r ? Object.create(r) : (n.prototype = r.prototype, new n());
    };
}(), $2be8636d379871d6$var$bn = function(t) {
    var e = "function" == typeof Symbol && Symbol.iterator, r = e && t[e], n = 0;
    if (r) return r.call(t);
    if (t && "number" == typeof t.length) return {
        next: function() {
            return t && n >= t.length && (t = void 0), {
                value: t && t[n++],
                done: !t
            };
        }
    };
    throw new TypeError(e ? "Object is not iterable." : "Symbol.iterator is not defined.");
}, $2be8636d379871d6$var$Rn = function(t) {
    function e(e, r) {
        var n = t.call(this, e) || this;
        return n._isLeft = r, n;
    }
    return $2be8636d379871d6$var$Tn(e, t), e.prototype.setRowNumbers = function() {
        var t, e;
        try {
            for(var r = $2be8636d379871d6$var$bn(this.getCodewords()), n = r.next(); !n.done; n = r.next()){
                var o = n.value;
                null != o && o.setRowNumberAsRowIndicatorColumn();
            }
        } catch (e) {
            t = {
                error: e
            };
        } finally{
            try {
                n && !n.done && (e = r.return) && e.call(r);
            } finally{
                if (t) throw t.error;
            }
        }
    }, e.prototype.adjustCompleteIndicatorColumnRowNumbers = function(t) {
        var e = this.getCodewords();
        this.setRowNumbers(), this.removeIncorrectCodewords(e, t);
        for(var r = this.getBoundingBox(), n = this._isLeft ? r.getTopLeft() : r.getTopRight(), o = this._isLeft ? r.getBottomLeft() : r.getBottomRight(), i = this.imageRowToCodewordIndex(Math.trunc(n.getY())), a = this.imageRowToCodewordIndex(Math.trunc(o.getY())), u = -1, s = 1, c = 0, f = i; f < a; f++)if (null != e[f]) {
            var h = e[f], l = h.getRowNumber() - u;
            if (0 === l) c++;
            else if (1 === l) s = Math.max(s, c), c = 1, u = h.getRowNumber();
            else if (l < 0 || h.getRowNumber() >= t.getRowCount() || l > f) e[f] = null;
            else {
                for(var d = void 0, p = (d = s > 2 ? (s - 2) * l : l) >= f, g = 1; g <= d && !p; g++)p = null != e[f - g];
                p ? e[f] = null : (u = h.getRowNumber(), c = 1);
            }
        }
    }, e.prototype.getRowHeights = function() {
        var t, e, r = this.getBarcodeMetadata();
        if (null == r) return null;
        this.adjustIncompleteIndicatorColumnRowNumbers(r);
        var n = new Int32Array(r.getRowCount());
        try {
            for(var o = $2be8636d379871d6$var$bn(this.getCodewords()), i = o.next(); !i.done; i = o.next()){
                var a = i.value;
                if (null != a) {
                    var u = a.getRowNumber();
                    if (u >= n.length) continue;
                    n[u]++;
                }
            }
        } catch (e) {
            t = {
                error: e
            };
        } finally{
            try {
                i && !i.done && (e = o.return) && e.call(o);
            } finally{
                if (t) throw t.error;
            }
        }
        return n;
    }, e.prototype.adjustIncompleteIndicatorColumnRowNumbers = function(t) {
        for(var e = this.getBoundingBox(), r = this._isLeft ? e.getTopLeft() : e.getTopRight(), n = this._isLeft ? e.getBottomLeft() : e.getBottomRight(), o = this.imageRowToCodewordIndex(Math.trunc(r.getY())), i = this.imageRowToCodewordIndex(Math.trunc(n.getY())), a = this.getCodewords(), u = -1, s = o; s < i; s++)if (null != a[s]) {
            var c = a[s];
            c.setRowNumberAsRowIndicatorColumn();
            var f = c.getRowNumber() - u;
            0 === f || (1 === f ? u = c.getRowNumber() : c.getRowNumber() >= t.getRowCount() ? a[s] = null : u = c.getRowNumber());
        }
    }, e.prototype.getBarcodeMetadata = function() {
        var t, e, r = this.getCodewords(), n = new $2be8636d379871d6$var$On(), o = new $2be8636d379871d6$var$On(), i = new $2be8636d379871d6$var$On(), a = new $2be8636d379871d6$var$On();
        try {
            for(var u = $2be8636d379871d6$var$bn(r), s = u.next(); !s.done; s = u.next()){
                var c = s.value;
                if (null != c) {
                    c.setRowNumberAsRowIndicatorColumn();
                    var f = c.getValue() % 30, h = c.getRowNumber();
                    switch(this._isLeft || (h += 2), h % 3){
                        case 0:
                            o.setValue(3 * f + 1);
                            break;
                        case 1:
                            a.setValue(f / 3), i.setValue(f % 3);
                            break;
                        case 2:
                            n.setValue(f + 1);
                    }
                }
            }
        } catch (e) {
            t = {
                error: e
            };
        } finally{
            try {
                s && !s.done && (e = u.return) && e.call(u);
            } finally{
                if (t) throw t.error;
            }
        }
        if (0 === n.getValue().length || 0 === o.getValue().length || 0 === i.getValue().length || 0 === a.getValue().length || n.getValue()[0] < 1 || o.getValue()[0] + i.getValue()[0] < $2be8636d379871d6$var$sn.MIN_ROWS_IN_BARCODE || o.getValue()[0] + i.getValue()[0] > $2be8636d379871d6$var$sn.MAX_ROWS_IN_BARCODE) return null;
        var l = new $2be8636d379871d6$var$mn(n.getValue()[0], o.getValue()[0], i.getValue()[0], a.getValue()[0]);
        return this.removeIncorrectCodewords(r, l), l;
    }, e.prototype.removeIncorrectCodewords = function(t, e) {
        for(var r = 0; r < t.length; r++){
            var n = t[r];
            if (null != t[r]) {
                var o = n.getValue() % 30, i = n.getRowNumber();
                if (i > e.getRowCount()) t[r] = null;
                else switch(this._isLeft || (i += 2), i % 3){
                    case 0:
                        3 * o + 1 !== e.getRowCountUpperPart() && (t[r] = null);
                        break;
                    case 1:
                        Math.trunc(o / 3) === e.getErrorCorrectionLevel() && o % 3 === e.getRowCountLowerPart() || (t[r] = null);
                        break;
                    case 2:
                        o + 1 !== e.getColumnCount() && (t[r] = null);
                }
            }
        }
    }, e.prototype.isLeft = function() {
        return this._isLeft;
    }, e.prototype.toString = function() {
        return "IsLeft: " + this._isLeft + "\n" + t.prototype.toString.call(this);
    }, e;
}($2be8636d379871d6$var$Cn), $2be8636d379871d6$var$Nn = function(t) {
    var e = "function" == typeof Symbol && Symbol.iterator, r = e && t[e], n = 0;
    if (r) return r.call(t);
    if (t && "number" == typeof t.length) return {
        next: function() {
            return t && n >= t.length && (t = void 0), {
                value: t && t[n++],
                done: !t
            };
        }
    };
    throw new TypeError(e ? "Object is not iterable." : "Symbol.iterator is not defined.");
}, $2be8636d379871d6$var$Dn = function() {
    function t(t, e) {
        this.ADJUST_ROW_NUMBER_SKIP = 2, this.barcodeMetadata = t, this.barcodeColumnCount = t.getColumnCount(), this.boundingBox = e, this.detectionResultColumns = new Array(this.barcodeColumnCount + 2);
    }
    return t.prototype.getDetectionResultColumns = function() {
        this.adjustIndicatorColumnRowNumbers(this.detectionResultColumns[0]), this.adjustIndicatorColumnRowNumbers(this.detectionResultColumns[this.barcodeColumnCount + 1]);
        var t, e = $2be8636d379871d6$var$sn.MAX_CODEWORDS_IN_BARCODE;
        do t = e, e = this.adjustRowNumbersAndGetCount();
        while (e > 0 && e < t);
        return this.detectionResultColumns;
    }, t.prototype.adjustIndicatorColumnRowNumbers = function(t) {
        null != t && t.adjustCompleteIndicatorColumnRowNumbers(this.barcodeMetadata);
    }, t.prototype.adjustRowNumbersAndGetCount = function() {
        var t = this.adjustRowNumbersByRow();
        if (0 === t) return 0;
        for(var e = 1; e < this.barcodeColumnCount + 1; e++)for(var r = this.detectionResultColumns[e].getCodewords(), n = 0; n < r.length; n++)null != r[n] && (r[n].hasValidRowNumber() || this.adjustRowNumbers(e, n, r));
        return t;
    }, t.prototype.adjustRowNumbersByRow = function() {
        return this.adjustRowNumbersFromBothRI(), this.adjustRowNumbersFromLRI() + this.adjustRowNumbersFromRRI();
    }, t.prototype.adjustRowNumbersFromBothRI = function() {
        if (null != this.detectionResultColumns[0] && null != this.detectionResultColumns[this.barcodeColumnCount + 1]) {
            for(var t = this.detectionResultColumns[0].getCodewords(), e = this.detectionResultColumns[this.barcodeColumnCount + 1].getCodewords(), r = 0; r < t.length; r++)if (null != t[r] && null != e[r] && t[r].getRowNumber() === e[r].getRowNumber()) for(var n = 1; n <= this.barcodeColumnCount; n++){
                var o = this.detectionResultColumns[n].getCodewords()[r];
                null != o && (o.setRowNumber(t[r].getRowNumber()), o.hasValidRowNumber() || (this.detectionResultColumns[n].getCodewords()[r] = null));
            }
        }
    }, t.prototype.adjustRowNumbersFromRRI = function() {
        if (null == this.detectionResultColumns[this.barcodeColumnCount + 1]) return 0;
        for(var e = 0, r = this.detectionResultColumns[this.barcodeColumnCount + 1].getCodewords(), n = 0; n < r.length; n++)if (null != r[n]) for(var o = r[n].getRowNumber(), i = 0, a = this.barcodeColumnCount + 1; a > 0 && i < this.ADJUST_ROW_NUMBER_SKIP; a--){
            var u = this.detectionResultColumns[a].getCodewords()[n];
            null != u && (i = t.adjustRowNumberIfValid(o, i, u), u.hasValidRowNumber() || e++);
        }
        return e;
    }, t.prototype.adjustRowNumbersFromLRI = function() {
        if (null == this.detectionResultColumns[0]) return 0;
        for(var e = 0, r = this.detectionResultColumns[0].getCodewords(), n = 0; n < r.length; n++)if (null != r[n]) for(var o = r[n].getRowNumber(), i = 0, a = 1; a < this.barcodeColumnCount + 1 && i < this.ADJUST_ROW_NUMBER_SKIP; a++){
            var u = this.detectionResultColumns[a].getCodewords()[n];
            null != u && (i = t.adjustRowNumberIfValid(o, i, u), u.hasValidRowNumber() || e++);
        }
        return e;
    }, t.adjustRowNumberIfValid = function(t, e, r) {
        return null == r || r.hasValidRowNumber() || (r.isValidRowNumber(t) ? (r.setRowNumber(t), e = 0) : ++e), e;
    }, t.prototype.adjustRowNumbers = function(e, r, n) {
        var o, i, a = n[r], u = this.detectionResultColumns[e - 1].getCodewords(), s = u;
        null != this.detectionResultColumns[e + 1] && (s = this.detectionResultColumns[e + 1].getCodewords());
        var c = new Array(14);
        c[2] = u[r], c[3] = s[r], r > 0 && (c[0] = n[r - 1], c[4] = u[r - 1], c[5] = s[r - 1]), r > 1 && (c[8] = n[r - 2], c[10] = u[r - 2], c[11] = s[r - 2]), r < n.length - 1 && (c[1] = n[r + 1], c[6] = u[r + 1], c[7] = s[r + 1]), r < n.length - 2 && (c[9] = n[r + 2], c[12] = u[r + 2], c[13] = s[r + 2]);
        try {
            for(var f = $2be8636d379871d6$var$Nn(c), h = f.next(); !h.done; h = f.next()){
                var l = h.value;
                if (t.adjustRowNumber(a, l)) return;
            }
        } catch (t) {
            o = {
                error: t
            };
        } finally{
            try {
                h && !h.done && (i = f.return) && i.call(f);
            } finally{
                if (o) throw o.error;
            }
        }
    }, t.adjustRowNumber = function(t, e) {
        return null != e && !(!e.hasValidRowNumber() || e.getBucket() !== t.getBucket()) && (t.setRowNumber(e.getRowNumber()), !0);
    }, t.prototype.getBarcodeColumnCount = function() {
        return this.barcodeColumnCount;
    }, t.prototype.getBarcodeRowCount = function() {
        return this.barcodeMetadata.getRowCount();
    }, t.prototype.getBarcodeECLevel = function() {
        return this.barcodeMetadata.getErrorCorrectionLevel();
    }, t.prototype.setBoundingBox = function(t) {
        this.boundingBox = t;
    }, t.prototype.getBoundingBox = function() {
        return this.boundingBox;
    }, t.prototype.setDetectionResultColumn = function(t, e) {
        this.detectionResultColumns[t] = e;
    }, t.prototype.getDetectionResultColumn = function(t) {
        return this.detectionResultColumns[t];
    }, t.prototype.toString = function() {
        var t = this.detectionResultColumns[0];
        null == t && (t = this.detectionResultColumns[this.barcodeColumnCount + 1]);
        for(var e = new $2be8636d379871d6$var$An(), r = 0; r < t.getCodewords().length; r++){
            e.format("CW %3d:", r);
            for(var n = 0; n < this.barcodeColumnCount + 2; n++)if (null != this.detectionResultColumns[n]) {
                var o = this.detectionResultColumns[n].getCodewords()[r];
                null != o ? e.format(" %3d|%3d", o.getRowNumber(), o.getValue()) : e.format("    |   ");
            } else e.format("    |   ");
            e.format("%n");
        }
        return e.toString();
    }, t;
}(), $2be8636d379871d6$var$Pn = function() {
    function t(e, r, n, o) {
        this.rowNumber = t.BARCODE_ROW_UNKNOWN, this.startX = Math.trunc(e), this.endX = Math.trunc(r), this.bucket = Math.trunc(n), this.value = Math.trunc(o);
    }
    return t.prototype.hasValidRowNumber = function() {
        return this.isValidRowNumber(this.rowNumber);
    }, t.prototype.isValidRowNumber = function(e) {
        return e !== t.BARCODE_ROW_UNKNOWN && this.bucket === e % 3 * 3;
    }, t.prototype.setRowNumberAsRowIndicatorColumn = function() {
        this.rowNumber = Math.trunc(3 * Math.trunc(this.value / 30) + Math.trunc(this.bucket / 3));
    }, t.prototype.getWidth = function() {
        return this.endX - this.startX;
    }, t.prototype.getStartX = function() {
        return this.startX;
    }, t.prototype.getEndX = function() {
        return this.endX;
    }, t.prototype.getBucket = function() {
        return this.bucket;
    }, t.prototype.getValue = function() {
        return this.value;
    }, t.prototype.getRowNumber = function() {
        return this.rowNumber;
    }, t.prototype.setRowNumber = function(t) {
        this.rowNumber = t;
    }, t.prototype.toString = function() {
        return this.rowNumber + "|" + this.value;
    }, t.BARCODE_ROW_UNKNOWN = -1, t;
}(), $2be8636d379871d6$var$Mn = function() {
    function t() {}
    return t.initialize = function() {
        for(var e = 0; e < $2be8636d379871d6$var$sn.SYMBOL_TABLE.length; e++)for(var r = $2be8636d379871d6$var$sn.SYMBOL_TABLE[e], n = 1 & r, o = 0; o < $2be8636d379871d6$var$sn.BARS_IN_MODULE; o++){
            for(var i = 0; (1 & r) === n;)i += 1, r >>= 1;
            n = 1 & r, t.RATIOS_TABLE[e] || (t.RATIOS_TABLE[e] = new Array($2be8636d379871d6$var$sn.BARS_IN_MODULE)), t.RATIOS_TABLE[e][$2be8636d379871d6$var$sn.BARS_IN_MODULE - o - 1] = Math.fround(i / $2be8636d379871d6$var$sn.MODULES_IN_CODEWORD);
        }
        this.bSymbolTableReady = !0;
    }, t.getDecodedValue = function(e) {
        var r = t.getDecodedCodewordValue(t.sampleBitCounts(e));
        return -1 !== r ? r : t.getClosestDecodedValue(e);
    }, t.sampleBitCounts = function(t) {
        for(var e = $2be8636d379871d6$var$vt.sum(t), r = new Int32Array($2be8636d379871d6$var$sn.BARS_IN_MODULE), n = 0, o = 0, i = 0; i < $2be8636d379871d6$var$sn.MODULES_IN_CODEWORD; i++){
            var a = e / (2 * $2be8636d379871d6$var$sn.MODULES_IN_CODEWORD) + i * e / $2be8636d379871d6$var$sn.MODULES_IN_CODEWORD;
            o + t[n] <= a && (o += t[n], n++), r[n]++;
        }
        return r;
    }, t.getDecodedCodewordValue = function(e) {
        var r = t.getBitValue(e);
        return -1 === $2be8636d379871d6$var$sn.getCodeword(r) ? -1 : r;
    }, t.getBitValue = function(t) {
        for(var e = 0, r = 0; r < t.length; r++)for(var n = 0; n < t[r]; n++)e = e << 1 | (r % 2 == 0 ? 1 : 0);
        return Math.trunc(e);
    }, t.getClosestDecodedValue = function(e) {
        var r = $2be8636d379871d6$var$vt.sum(e), n = new Array($2be8636d379871d6$var$sn.BARS_IN_MODULE);
        if (r > 1) for(var o = 0; o < n.length; o++)n[o] = Math.fround(e[o] / r);
        var i = $2be8636d379871d6$var$mt.MAX_VALUE, a = -1;
        this.bSymbolTableReady || t.initialize();
        for(var u = 0; u < t.RATIOS_TABLE.length; u++){
            for(var s = 0, c = t.RATIOS_TABLE[u], f = 0; f < $2be8636d379871d6$var$sn.BARS_IN_MODULE; f++){
                var h = Math.fround(c[f] - n[f]);
                if ((s += Math.fround(h * h)) >= i) break;
            }
            s < i && (i = s, a = $2be8636d379871d6$var$sn.SYMBOL_TABLE[u]);
        }
        return a;
    }, t.bSymbolTableReady = !1, t.RATIOS_TABLE = new Array($2be8636d379871d6$var$sn.SYMBOL_TABLE.length).map(function(t) {
        return new Array($2be8636d379871d6$var$sn.BARS_IN_MODULE);
    }), t;
}(), $2be8636d379871d6$var$Bn = function() {
    function t() {
        this.segmentCount = -1, this.fileSize = -1, this.timestamp = -1, this.checksum = -1;
    }
    return t.prototype.getSegmentIndex = function() {
        return this.segmentIndex;
    }, t.prototype.setSegmentIndex = function(t) {
        this.segmentIndex = t;
    }, t.prototype.getFileId = function() {
        return this.fileId;
    }, t.prototype.setFileId = function(t) {
        this.fileId = t;
    }, t.prototype.getOptionalData = function() {
        return this.optionalData;
    }, t.prototype.setOptionalData = function(t) {
        this.optionalData = t;
    }, t.prototype.isLastSegment = function() {
        return this.lastSegment;
    }, t.prototype.setLastSegment = function(t) {
        this.lastSegment = t;
    }, t.prototype.getSegmentCount = function() {
        return this.segmentCount;
    }, t.prototype.setSegmentCount = function(t) {
        this.segmentCount = t;
    }, t.prototype.getSender = function() {
        return this.sender || null;
    }, t.prototype.setSender = function(t) {
        this.sender = t;
    }, t.prototype.getAddressee = function() {
        return this.addressee || null;
    }, t.prototype.setAddressee = function(t) {
        this.addressee = t;
    }, t.prototype.getFileName = function() {
        return this.fileName;
    }, t.prototype.setFileName = function(t) {
        this.fileName = t;
    }, t.prototype.getFileSize = function() {
        return this.fileSize;
    }, t.prototype.setFileSize = function(t) {
        this.fileSize = t;
    }, t.prototype.getChecksum = function() {
        return this.checksum;
    }, t.prototype.setChecksum = function(t) {
        this.checksum = t;
    }, t.prototype.getTimestamp = function() {
        return this.timestamp;
    }, t.prototype.setTimestamp = function(t) {
        this.timestamp = t;
    }, t;
}(), $2be8636d379871d6$var$Ln = function() {
    function t() {}
    return t.parseLong = function(t, e) {
        return void 0 === e && (e = void 0), parseInt(t, e);
    }, t;
}(), $2be8636d379871d6$var$Fn = function() {
    var t = function(e, r) {
        return t = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(t, e) {
            t.__proto__ = e;
        } || function(t, e) {
            for(var r in e)e.hasOwnProperty(r) && (t[r] = e[r]);
        }, t(e, r);
    };
    return function(e, r) {
        function n() {
            this.constructor = e;
        }
        t(e, r), e.prototype = null === r ? Object.create(r) : (n.prototype = r.prototype, new n());
    };
}(), $2be8636d379871d6$var$kn = function(t) {
    function e() {
        return null !== t && t.apply(this, arguments) || this;
    }
    return $2be8636d379871d6$var$Fn(e, t), e.kind = "NullPointerException", e;
}($2be8636d379871d6$var$s), $2be8636d379871d6$var$xn = function() {
    function t() {}
    return t.prototype.writeBytes = function(t) {
        this.writeBytesOffset(t, 0, t.length);
    }, t.prototype.writeBytesOffset = function(t, e, r) {
        if (null == t) throw new $2be8636d379871d6$var$kn();
        if (e < 0 || e > t.length || r < 0 || e + r > t.length || e + r < 0) throw new $2be8636d379871d6$var$v();
        if (0 !== r) for(var n = 0; n < r; n++)this.write(t[e + n]);
    }, t.prototype.flush = function() {}, t.prototype.close = function() {}, t;
}(), $2be8636d379871d6$var$Vn = function() {
    var t = function(e, r) {
        return t = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(t, e) {
            t.__proto__ = e;
        } || function(t, e) {
            for(var r in e)e.hasOwnProperty(r) && (t[r] = e[r]);
        }, t(e, r);
    };
    return function(e, r) {
        function n() {
            this.constructor = e;
        }
        t(e, r), e.prototype = null === r ? Object.create(r) : (n.prototype = r.prototype, new n());
    };
}(), $2be8636d379871d6$var$Un = function(t) {
    function e() {
        return null !== t && t.apply(this, arguments) || this;
    }
    return $2be8636d379871d6$var$Vn(e, t), e;
}($2be8636d379871d6$var$s), $2be8636d379871d6$var$Hn = function() {
    var t = function(e, r) {
        return t = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(t, e) {
            t.__proto__ = e;
        } || function(t, e) {
            for(var r in e)e.hasOwnProperty(r) && (t[r] = e[r]);
        }, t(e, r);
    };
    return function(e, r) {
        function n() {
            this.constructor = e;
        }
        t(e, r), e.prototype = null === r ? Object.create(r) : (n.prototype = r.prototype, new n());
    };
}(), $2be8636d379871d6$var$Gn = function(t) {
    function e(e) {
        void 0 === e && (e = 32);
        var r = t.call(this) || this;
        if (r.count = 0, e < 0) throw new $2be8636d379871d6$var$l("Negative initial size: " + e);
        return r.buf = new Uint8Array(e), r;
    }
    return $2be8636d379871d6$var$Hn(e, t), e.prototype.ensureCapacity = function(t) {
        t - this.buf.length > 0 && this.grow(t);
    }, e.prototype.grow = function(t) {
        var e = this.buf.length << 1;
        if (e - t < 0 && (e = t), e < 0) {
            if (t < 0) throw new $2be8636d379871d6$var$Un();
            e = $2be8636d379871d6$var$I.MAX_VALUE;
        }
        this.buf = $2be8636d379871d6$var$C.copyOfUint8Array(this.buf, e);
    }, e.prototype.write = function(t) {
        this.ensureCapacity(this.count + 1), this.buf[this.count] = t, this.count += 1;
    }, e.prototype.writeBytesOffset = function(t, e, r) {
        if (e < 0 || e > t.length || r < 0 || e + r - t.length > 0) throw new $2be8636d379871d6$var$v();
        this.ensureCapacity(this.count + r), $2be8636d379871d6$var$w.arraycopy(t, e, this.buf, this.count, r), this.count += r;
    }, e.prototype.writeTo = function(t) {
        t.writeBytesOffset(this.buf, 0, this.count);
    }, e.prototype.reset = function() {
        this.count = 0;
    }, e.prototype.toByteArray = function() {
        return $2be8636d379871d6$var$C.copyOfUint8Array(this.buf, this.count);
    }, e.prototype.size = function() {
        return this.count;
    }, e.prototype.toString = function(t) {
        return t ? "string" == typeof t ? this.toString_string(t) : this.toString_number(t) : this.toString_void();
    }, e.prototype.toString_void = function() {
        return new String(this.buf).toString();
    }, e.prototype.toString_string = function(t) {
        return new String(this.buf).toString();
    }, e.prototype.toString_number = function(t) {
        return new String(this.buf).toString();
    }, e.prototype.close = function() {}, e;
}($2be8636d379871d6$var$xn);
function $2be8636d379871d6$var$Xn() {
    if ("undefined" != typeof window) return window.BigInt || null;
    if ("undefined" != typeof $parcel$global) return $parcel$global.BigInt || null;
    if ("undefined" != typeof self) return self.BigInt || null;
    throw new Error("Can't search globals for BigInt!");
}
function $2be8636d379871d6$var$Wn(t) {
    if (void 0 === $2be8636d379871d6$var$Xr && ($2be8636d379871d6$var$Xr = $2be8636d379871d6$var$Xn()), null === $2be8636d379871d6$var$Xr) throw new Error("BigInt is not supported!");
    return $2be8636d379871d6$var$Xr(t);
}
!function(t) {
    t[t.ALPHA = 0] = "ALPHA", t[t.LOWER = 1] = "LOWER", t[t.MIXED = 2] = "MIXED", t[t.PUNCT = 3] = "PUNCT", t[t.ALPHA_SHIFT = 4] = "ALPHA_SHIFT", t[t.PUNCT_SHIFT = 5] = "PUNCT_SHIFT";
}($2be8636d379871d6$var$Gr || ($2be8636d379871d6$var$Gr = {}));
var $2be8636d379871d6$var$jn = function() {
    function t() {}
    return t.decode = function(e, r) {
        var n = new $2be8636d379871d6$var$k(""), o = $2be8636d379871d6$var$P.ISO8859_1;
        n.enableDecoding(o);
        for(var i = 1, a = e[i++], u = new $2be8636d379871d6$var$Bn(); i < e[0];){
            switch(a){
                case t.TEXT_COMPACTION_MODE_LATCH:
                    i = t.textCompaction(e, i, n);
                    break;
                case t.BYTE_COMPACTION_MODE_LATCH:
                case t.BYTE_COMPACTION_MODE_LATCH_6:
                    i = t.byteCompaction(a, e, o, i, n);
                    break;
                case t.MODE_SHIFT_TO_BYTE_COMPACTION_MODE:
                    n.append(e[i++]);
                    break;
                case t.NUMERIC_COMPACTION_MODE_LATCH:
                    i = t.numericCompaction(e, i, n);
                    break;
                case t.ECI_CHARSET:
                    $2be8636d379871d6$var$P.getCharacterSetECIByValue(e[i++]);
                    break;
                case t.ECI_GENERAL_PURPOSE:
                    i += 2;
                    break;
                case t.ECI_USER_DEFINED:
                    i++;
                    break;
                case t.BEGIN_MACRO_PDF417_CONTROL_BLOCK:
                    i = t.decodeMacroBlock(e, i, u);
                    break;
                case t.BEGIN_MACRO_PDF417_OPTIONAL_FIELD:
                case t.MACRO_PDF417_TERMINATOR:
                    throw new $2be8636d379871d6$var$R();
                default:
                    i--, i = t.textCompaction(e, i, n);
            }
            if (!(i < e.length)) throw $2be8636d379871d6$var$R.getFormatInstance();
            a = e[i++];
        }
        if (0 === n.length()) throw $2be8636d379871d6$var$R.getFormatInstance();
        var s = new $2be8636d379871d6$var$at(null, n.toString(), null, r);
        return s.setOther(u), s;
    }, t.decodeMacroBlock = function(e, r, n) {
        if (r + t.NUMBER_OF_SEQUENCE_CODEWORDS > e[0]) throw $2be8636d379871d6$var$R.getFormatInstance();
        for(var o = new Int32Array(t.NUMBER_OF_SEQUENCE_CODEWORDS), i = 0; i < t.NUMBER_OF_SEQUENCE_CODEWORDS; i++, r++)o[i] = e[r];
        n.setSegmentIndex($2be8636d379871d6$var$I.parseInt(t.decodeBase900toBase10(o, t.NUMBER_OF_SEQUENCE_CODEWORDS)));
        var a = new $2be8636d379871d6$var$k();
        r = t.textCompaction(e, r, a), n.setFileId(a.toString());
        var u = -1;
        for(e[r] === t.BEGIN_MACRO_PDF417_OPTIONAL_FIELD && (u = r + 1); r < e[0];)switch(e[r]){
            case t.BEGIN_MACRO_PDF417_OPTIONAL_FIELD:
                switch(e[++r]){
                    case t.MACRO_PDF417_OPTIONAL_FIELD_FILE_NAME:
                        var s = new $2be8636d379871d6$var$k();
                        r = t.textCompaction(e, r + 1, s), n.setFileName(s.toString());
                        break;
                    case t.MACRO_PDF417_OPTIONAL_FIELD_SENDER:
                        var c = new $2be8636d379871d6$var$k();
                        r = t.textCompaction(e, r + 1, c), n.setSender(c.toString());
                        break;
                    case t.MACRO_PDF417_OPTIONAL_FIELD_ADDRESSEE:
                        var f = new $2be8636d379871d6$var$k();
                        r = t.textCompaction(e, r + 1, f), n.setAddressee(f.toString());
                        break;
                    case t.MACRO_PDF417_OPTIONAL_FIELD_SEGMENT_COUNT:
                        var h = new $2be8636d379871d6$var$k();
                        r = t.numericCompaction(e, r + 1, h), n.setSegmentCount($2be8636d379871d6$var$I.parseInt(h.toString()));
                        break;
                    case t.MACRO_PDF417_OPTIONAL_FIELD_TIME_STAMP:
                        var l = new $2be8636d379871d6$var$k();
                        r = t.numericCompaction(e, r + 1, l), n.setTimestamp($2be8636d379871d6$var$Ln.parseLong(l.toString()));
                        break;
                    case t.MACRO_PDF417_OPTIONAL_FIELD_CHECKSUM:
                        var d = new $2be8636d379871d6$var$k();
                        r = t.numericCompaction(e, r + 1, d), n.setChecksum($2be8636d379871d6$var$I.parseInt(d.toString()));
                        break;
                    case t.MACRO_PDF417_OPTIONAL_FIELD_FILE_SIZE:
                        var p = new $2be8636d379871d6$var$k();
                        r = t.numericCompaction(e, r + 1, p), n.setFileSize($2be8636d379871d6$var$Ln.parseLong(p.toString()));
                        break;
                    default:
                        throw $2be8636d379871d6$var$R.getFormatInstance();
                }
                break;
            case t.MACRO_PDF417_TERMINATOR:
                r++, n.setLastSegment(!0);
                break;
            default:
                throw $2be8636d379871d6$var$R.getFormatInstance();
        }
        if (-1 !== u) {
            var g = r - u;
            n.isLastSegment() && g--, n.setOptionalData($2be8636d379871d6$var$C.copyOfRange(e, u, u + g));
        }
        return r;
    }, t.textCompaction = function(e, r, n) {
        for(var o = new Int32Array(2 * (e[0] - r)), i = new Int32Array(2 * (e[0] - r)), a = 0, u = !1; r < e[0] && !u;){
            var s = e[r++];
            if (s < t.TEXT_COMPACTION_MODE_LATCH) o[a] = s / 30, o[a + 1] = s % 30, a += 2;
            else switch(s){
                case t.TEXT_COMPACTION_MODE_LATCH:
                    o[a++] = t.TEXT_COMPACTION_MODE_LATCH;
                    break;
                case t.BYTE_COMPACTION_MODE_LATCH:
                case t.BYTE_COMPACTION_MODE_LATCH_6:
                case t.NUMERIC_COMPACTION_MODE_LATCH:
                case t.BEGIN_MACRO_PDF417_CONTROL_BLOCK:
                case t.BEGIN_MACRO_PDF417_OPTIONAL_FIELD:
                case t.MACRO_PDF417_TERMINATOR:
                    r--, u = !0;
                    break;
                case t.MODE_SHIFT_TO_BYTE_COMPACTION_MODE:
                    o[a] = t.MODE_SHIFT_TO_BYTE_COMPACTION_MODE, s = e[r++], i[a] = s, a++;
            }
        }
        return t.decodeTextCompaction(o, i, a, n), r;
    }, t.decodeTextCompaction = function(e, r, n, o) {
        for(var i = $2be8636d379871d6$var$Gr.ALPHA, a = $2be8636d379871d6$var$Gr.ALPHA, u = 0; u < n;){
            var s = e[u], c = "";
            switch(i){
                case $2be8636d379871d6$var$Gr.ALPHA:
                    if (s < 26) c = String.fromCharCode(65 + s);
                    else switch(s){
                        case 26:
                            c = " ";
                            break;
                        case t.LL:
                            i = $2be8636d379871d6$var$Gr.LOWER;
                            break;
                        case t.ML:
                            i = $2be8636d379871d6$var$Gr.MIXED;
                            break;
                        case t.PS:
                            a = i, i = $2be8636d379871d6$var$Gr.PUNCT_SHIFT;
                            break;
                        case t.MODE_SHIFT_TO_BYTE_COMPACTION_MODE:
                            o.append(r[u]);
                            break;
                        case t.TEXT_COMPACTION_MODE_LATCH:
                            i = $2be8636d379871d6$var$Gr.ALPHA;
                    }
                    break;
                case $2be8636d379871d6$var$Gr.LOWER:
                    if (s < 26) c = String.fromCharCode(97 + s);
                    else switch(s){
                        case 26:
                            c = " ";
                            break;
                        case t.AS:
                            a = i, i = $2be8636d379871d6$var$Gr.ALPHA_SHIFT;
                            break;
                        case t.ML:
                            i = $2be8636d379871d6$var$Gr.MIXED;
                            break;
                        case t.PS:
                            a = i, i = $2be8636d379871d6$var$Gr.PUNCT_SHIFT;
                            break;
                        case t.MODE_SHIFT_TO_BYTE_COMPACTION_MODE:
                            o.append(r[u]);
                            break;
                        case t.TEXT_COMPACTION_MODE_LATCH:
                            i = $2be8636d379871d6$var$Gr.ALPHA;
                    }
                    break;
                case $2be8636d379871d6$var$Gr.MIXED:
                    if (s < t.PL) c = t.MIXED_CHARS[s];
                    else switch(s){
                        case t.PL:
                            i = $2be8636d379871d6$var$Gr.PUNCT;
                            break;
                        case 26:
                            c = " ";
                            break;
                        case t.LL:
                            i = $2be8636d379871d6$var$Gr.LOWER;
                            break;
                        case t.AL:
                            i = $2be8636d379871d6$var$Gr.ALPHA;
                            break;
                        case t.PS:
                            a = i, i = $2be8636d379871d6$var$Gr.PUNCT_SHIFT;
                            break;
                        case t.MODE_SHIFT_TO_BYTE_COMPACTION_MODE:
                            o.append(r[u]);
                            break;
                        case t.TEXT_COMPACTION_MODE_LATCH:
                            i = $2be8636d379871d6$var$Gr.ALPHA;
                    }
                    break;
                case $2be8636d379871d6$var$Gr.PUNCT:
                    if (s < t.PAL) c = t.PUNCT_CHARS[s];
                    else switch(s){
                        case t.PAL:
                            i = $2be8636d379871d6$var$Gr.ALPHA;
                            break;
                        case t.MODE_SHIFT_TO_BYTE_COMPACTION_MODE:
                            o.append(r[u]);
                            break;
                        case t.TEXT_COMPACTION_MODE_LATCH:
                            i = $2be8636d379871d6$var$Gr.ALPHA;
                    }
                    break;
                case $2be8636d379871d6$var$Gr.ALPHA_SHIFT:
                    if (i = a, s < 26) c = String.fromCharCode(65 + s);
                    else switch(s){
                        case 26:
                            c = " ";
                            break;
                        case t.TEXT_COMPACTION_MODE_LATCH:
                            i = $2be8636d379871d6$var$Gr.ALPHA;
                    }
                    break;
                case $2be8636d379871d6$var$Gr.PUNCT_SHIFT:
                    if (i = a, s < t.PAL) c = t.PUNCT_CHARS[s];
                    else switch(s){
                        case t.PAL:
                            i = $2be8636d379871d6$var$Gr.ALPHA;
                            break;
                        case t.MODE_SHIFT_TO_BYTE_COMPACTION_MODE:
                            o.append(r[u]);
                            break;
                        case t.TEXT_COMPACTION_MODE_LATCH:
                            i = $2be8636d379871d6$var$Gr.ALPHA;
                    }
            }
            "" !== c && o.append(c), u++;
        }
    }, t.byteCompaction = function(e, r, n, o, i) {
        var a = new $2be8636d379871d6$var$Gn(), u = 0, s = 0, c = !1;
        switch(e){
            case t.BYTE_COMPACTION_MODE_LATCH:
                for(var f = new Int32Array(6), h = r[o++]; o < r[0] && !c;)switch(f[u++] = h, s = 900 * s + h, h = r[o++]){
                    case t.TEXT_COMPACTION_MODE_LATCH:
                    case t.BYTE_COMPACTION_MODE_LATCH:
                    case t.NUMERIC_COMPACTION_MODE_LATCH:
                    case t.BYTE_COMPACTION_MODE_LATCH_6:
                    case t.BEGIN_MACRO_PDF417_CONTROL_BLOCK:
                    case t.BEGIN_MACRO_PDF417_OPTIONAL_FIELD:
                    case t.MACRO_PDF417_TERMINATOR:
                        o--, c = !0;
                        break;
                    default:
                        if (u % 5 == 0 && u > 0) {
                            for(var l = 0; l < 6; ++l)a.write(Number($2be8636d379871d6$var$Wn(s) >> $2be8636d379871d6$var$Wn(8 * (5 - l))));
                            s = 0, u = 0;
                        }
                }
                o === r[0] && h < t.TEXT_COMPACTION_MODE_LATCH && (f[u++] = h);
                for(var d = 0; d < u; d++)a.write(f[d]);
                break;
            case t.BYTE_COMPACTION_MODE_LATCH_6:
                for(; o < r[0] && !c;){
                    var p = r[o++];
                    if (p < t.TEXT_COMPACTION_MODE_LATCH) u++, s = 900 * s + p;
                    else switch(p){
                        case t.TEXT_COMPACTION_MODE_LATCH:
                        case t.BYTE_COMPACTION_MODE_LATCH:
                        case t.NUMERIC_COMPACTION_MODE_LATCH:
                        case t.BYTE_COMPACTION_MODE_LATCH_6:
                        case t.BEGIN_MACRO_PDF417_CONTROL_BLOCK:
                        case t.BEGIN_MACRO_PDF417_OPTIONAL_FIELD:
                        case t.MACRO_PDF417_TERMINATOR:
                            o--, c = !0;
                    }
                    if (u % 5 == 0 && u > 0) {
                        for(l = 0; l < 6; ++l)a.write(Number($2be8636d379871d6$var$Wn(s) >> $2be8636d379871d6$var$Wn(8 * (5 - l))));
                        s = 0, u = 0;
                    }
                }
        }
        return i.append($2be8636d379871d6$var$L.decode(a.toByteArray(), n)), o;
    }, t.numericCompaction = function(e, r, n) {
        for(var o = 0, i = !1, a = new Int32Array(t.MAX_NUMERIC_CODEWORDS); r < e[0] && !i;){
            var u = e[r++];
            if (r === e[0] && (i = !0), u < t.TEXT_COMPACTION_MODE_LATCH) a[o] = u, o++;
            else switch(u){
                case t.TEXT_COMPACTION_MODE_LATCH:
                case t.BYTE_COMPACTION_MODE_LATCH:
                case t.BYTE_COMPACTION_MODE_LATCH_6:
                case t.BEGIN_MACRO_PDF417_CONTROL_BLOCK:
                case t.BEGIN_MACRO_PDF417_OPTIONAL_FIELD:
                case t.MACRO_PDF417_TERMINATOR:
                    r--, i = !0;
            }
            (o % t.MAX_NUMERIC_CODEWORDS == 0 || u === t.NUMERIC_COMPACTION_MODE_LATCH || i) && o > 0 && (n.append(t.decodeBase900toBase10(a, o)), o = 0);
        }
        return r;
    }, t.decodeBase900toBase10 = function(e, r) {
        for(var n = $2be8636d379871d6$var$Wn(0), o = 0; o < r; o++)n += t.EXP900[r - o - 1] * $2be8636d379871d6$var$Wn(e[o]);
        var i = n.toString();
        if ("1" !== i.charAt(0)) throw new $2be8636d379871d6$var$R();
        return i.substring(1);
    }, t.TEXT_COMPACTION_MODE_LATCH = 900, t.BYTE_COMPACTION_MODE_LATCH = 901, t.NUMERIC_COMPACTION_MODE_LATCH = 902, t.BYTE_COMPACTION_MODE_LATCH_6 = 924, t.ECI_USER_DEFINED = 925, t.ECI_GENERAL_PURPOSE = 926, t.ECI_CHARSET = 927, t.BEGIN_MACRO_PDF417_CONTROL_BLOCK = 928, t.BEGIN_MACRO_PDF417_OPTIONAL_FIELD = 923, t.MACRO_PDF417_TERMINATOR = 922, t.MODE_SHIFT_TO_BYTE_COMPACTION_MODE = 913, t.MAX_NUMERIC_CODEWORDS = 15, t.MACRO_PDF417_OPTIONAL_FIELD_FILE_NAME = 0, t.MACRO_PDF417_OPTIONAL_FIELD_SEGMENT_COUNT = 1, t.MACRO_PDF417_OPTIONAL_FIELD_TIME_STAMP = 2, t.MACRO_PDF417_OPTIONAL_FIELD_SENDER = 3, t.MACRO_PDF417_OPTIONAL_FIELD_ADDRESSEE = 4, t.MACRO_PDF417_OPTIONAL_FIELD_FILE_SIZE = 5, t.MACRO_PDF417_OPTIONAL_FIELD_CHECKSUM = 6, t.PL = 25, t.LL = 27, t.AS = 27, t.ML = 28, t.AL = 28, t.PS = 29, t.PAL = 29, t.PUNCT_CHARS = ";<>@[\\]_`~!\r	,:\n-.$/\"|*()?{}'", t.MIXED_CHARS = "0123456789&\r	,:#-.$/+%*=^", t.EXP900 = $2be8636d379871d6$var$Xn() ? function() {
        var t = [];
        t[0] = $2be8636d379871d6$var$Wn(1);
        var e = $2be8636d379871d6$var$Wn(900);
        t[1] = e;
        for(var r = 2; r < 16; r++)t[r] = t[r - 1] * e;
        return t;
    }() : [], t.NUMBER_OF_SEQUENCE_CODEWORDS = 2, t;
}(), $2be8636d379871d6$var$zn = function(t) {
    var e = "function" == typeof Symbol && Symbol.iterator, r = e && t[e], n = 0;
    if (r) return r.call(t);
    if (t && "number" == typeof t.length) return {
        next: function() {
            return t && n >= t.length && (t = void 0), {
                value: t && t[n++],
                done: !t
            };
        }
    };
    throw new TypeError(e ? "Object is not iterable." : "Symbol.iterator is not defined.");
}, $2be8636d379871d6$var$Yn = function() {
    function t() {}
    return t.decode = function(e, r, n, o, i, a, u) {
        for(var s, c = new $2be8636d379871d6$var$vn(e, r, n, o, i), f = null, h = null, l = !0;; l = !1){
            if (null != r && (f = t.getRowIndicatorColumn(e, c, r, !0, a, u)), null != o && (h = t.getRowIndicatorColumn(e, c, o, !1, a, u)), null == (s = t.merge(f, h))) throw $2be8636d379871d6$var$U.getNotFoundInstance();
            var d = s.getBoundingBox();
            if (!l || null == d || !(d.getMinY() < c.getMinY() || d.getMaxY() > c.getMaxY())) break;
            c = d;
        }
        s.setBoundingBox(c);
        var p = s.getBarcodeColumnCount() + 1;
        s.setDetectionResultColumn(0, f), s.setDetectionResultColumn(p, h);
        for(var g = null != f, y = 1; y <= p; y++){
            var w = g ? y : p - y;
            if (void 0 === s.getDetectionResultColumn(w)) {
                var _ = void 0;
                _ = 0 === w || w === p ? new $2be8636d379871d6$var$Rn(c, 0 === w) : new $2be8636d379871d6$var$Cn(c), s.setDetectionResultColumn(w, _);
                for(var v = -1, m = v, A = c.getMinY(); A <= c.getMaxY(); A++){
                    if ((v = t.getStartColumn(s, w, A, g)) < 0 || v > c.getMaxX()) {
                        if (-1 === m) continue;
                        v = m;
                    }
                    var E = t.detectCodeword(e, c.getMinX(), c.getMaxX(), g, v, A, a, u);
                    null != E && (_.setCodeword(A, E), m = v, a = Math.min(a, E.getWidth()), u = Math.max(u, E.getWidth()));
                }
            }
        }
        return t.createDecoderResult(s);
    }, t.merge = function(e, r) {
        if (null == e && null == r) return null;
        var n = t.getBarcodeMetadata(e, r);
        if (null == n) return null;
        var o = $2be8636d379871d6$var$vn.merge(t.adjustBoundingBox(e), t.adjustBoundingBox(r));
        return new $2be8636d379871d6$var$Dn(n, o);
    }, t.adjustBoundingBox = function(e) {
        var r, n;
        if (null == e) return null;
        var o = e.getRowHeights();
        if (null == o) return null;
        var i = t.getMax(o), a = 0;
        try {
            for(var u = $2be8636d379871d6$var$zn(o), s = u.next(); !s.done; s = u.next()){
                var c = s.value;
                if (a += i - c, c > 0) break;
            }
        } catch (t) {
            r = {
                error: t
            };
        } finally{
            try {
                s && !s.done && (n = u.return) && n.call(u);
            } finally{
                if (r) throw r.error;
            }
        }
        for(var f = e.getCodewords(), h = 0; a > 0 && null == f[h]; h++)a--;
        var l = 0;
        for(h = o.length - 1; h >= 0 && (l += i - o[h], !(o[h] > 0)); h--);
        for(h = f.length - 1; l > 0 && null == f[h]; h--)l--;
        return e.getBoundingBox().addMissingRows(a, l, e.isLeft());
    }, t.getMax = function(t) {
        var e, r, n = -1;
        try {
            for(var o = $2be8636d379871d6$var$zn(t), i = o.next(); !i.done; i = o.next()){
                var a = i.value;
                n = Math.max(n, a);
            }
        } catch (t) {
            e = {
                error: t
            };
        } finally{
            try {
                i && !i.done && (r = o.return) && r.call(o);
            } finally{
                if (e) throw e.error;
            }
        }
        return n;
    }, t.getBarcodeMetadata = function(t, e) {
        var r, n;
        return null == t || null == (r = t.getBarcodeMetadata()) ? null == e ? null : e.getBarcodeMetadata() : null == e || null == (n = e.getBarcodeMetadata()) ? r : r.getColumnCount() !== n.getColumnCount() && r.getErrorCorrectionLevel() !== n.getErrorCorrectionLevel() && r.getRowCount() !== n.getRowCount() ? null : r;
    }, t.getRowIndicatorColumn = function(e, r, n, o, i, a) {
        for(var u = new $2be8636d379871d6$var$Rn(r, o), s = 0; s < 2; s++)for(var c = 0 === s ? 1 : -1, f = Math.trunc(Math.trunc(n.getX())), h = Math.trunc(Math.trunc(n.getY())); h <= r.getMaxY() && h >= r.getMinY(); h += c){
            var l = t.detectCodeword(e, 0, e.getWidth(), o, f, h, i, a);
            null != l && (u.setCodeword(h, l), f = o ? l.getStartX() : l.getEndX());
        }
        return u;
    }, t.adjustCodewordCount = function(e, r) {
        var n = r[0][1], o = n.getValue(), i = e.getBarcodeColumnCount() * e.getBarcodeRowCount() - t.getNumberOfECCodeWords(e.getBarcodeECLevel());
        if (0 === o.length) {
            if (i < 1 || i > $2be8636d379871d6$var$sn.MAX_CODEWORDS_IN_BARCODE) throw $2be8636d379871d6$var$U.getNotFoundInstance();
            n.setValue(i);
        } else o[0] !== i && n.setValue(i);
    }, t.createDecoderResult = function(e) {
        var r = t.createBarcodeMatrix(e);
        t.adjustCodewordCount(e, r);
        for(var n = new Array(), o = new Int32Array(e.getBarcodeRowCount() * e.getBarcodeColumnCount()), i = [], a = new Array(), u = 0; u < e.getBarcodeRowCount(); u++)for(var s = 0; s < e.getBarcodeColumnCount(); s++){
            var c = r[u][s + 1].getValue(), f = u * e.getBarcodeColumnCount() + s;
            0 === c.length ? n.push(f) : 1 === c.length ? o[f] = c[0] : (a.push(f), i.push(c));
        }
        for(var h = new Array(i.length), l = 0; l < h.length; l++)h[l] = i[l];
        return t.createDecoderResultFromAmbiguousValues(e.getBarcodeECLevel(), o, $2be8636d379871d6$var$sn.toIntArray(n), $2be8636d379871d6$var$sn.toIntArray(a), h);
    }, t.createDecoderResultFromAmbiguousValues = function(e, r, n, o, i) {
        for(var a = new Int32Array(o.length), u = 100; u-- > 0;){
            for(var s = 0; s < a.length; s++)r[o[s]] = i[s][a[s]];
            try {
                return t.decodeCodewords(r, e, n);
            } catch (t) {
                if (!(t instanceof $2be8636d379871d6$var$g)) throw t;
            }
            if (0 === a.length) throw $2be8636d379871d6$var$g.getChecksumInstance();
            for(s = 0; s < a.length; s++){
                if (a[s] < i[s].length - 1) {
                    a[s]++;
                    break;
                }
                if (a[s] = 0, s === a.length - 1) throw $2be8636d379871d6$var$g.getChecksumInstance();
            }
        }
        throw $2be8636d379871d6$var$g.getChecksumInstance();
    }, t.createBarcodeMatrix = function(t) {
        for(var e, r, n, o, i = Array.from({
            length: t.getBarcodeRowCount()
        }, function() {
            return new Array(t.getBarcodeColumnCount() + 2);
        }), a = 0; a < i.length; a++)for(var u = 0; u < i[a].length; u++)i[a][u] = new $2be8636d379871d6$var$On();
        var s = 0;
        try {
            for(var c = $2be8636d379871d6$var$zn(t.getDetectionResultColumns()), f = c.next(); !f.done; f = c.next()){
                var h = f.value;
                if (null != h) try {
                    for(var l = (n = void 0, $2be8636d379871d6$var$zn(h.getCodewords())), d = l.next(); !d.done; d = l.next()){
                        var p = d.value;
                        if (null != p) {
                            var g = p.getRowNumber();
                            if (g >= 0) {
                                if (g >= i.length) continue;
                                i[g][s].setValue(p.getValue());
                            }
                        }
                    }
                } catch (t) {
                    n = {
                        error: t
                    };
                } finally{
                    try {
                        d && !d.done && (o = l.return) && o.call(l);
                    } finally{
                        if (n) throw n.error;
                    }
                }
                s++;
            }
        } catch (t) {
            e = {
                error: t
            };
        } finally{
            try {
                f && !f.done && (r = c.return) && r.call(c);
            } finally{
                if (e) throw e.error;
            }
        }
        return i;
    }, t.isValidBarcodeColumn = function(t, e) {
        return e >= 0 && e <= t.getBarcodeColumnCount() + 1;
    }, t.getStartColumn = function(e, r, n, o) {
        var i, a, u = o ? 1 : -1, s = null;
        if (t.isValidBarcodeColumn(e, r - u) && (s = e.getDetectionResultColumn(r - u).getCodeword(n)), null != s) return o ? s.getEndX() : s.getStartX();
        if (null != (s = e.getDetectionResultColumn(r).getCodewordNearby(n))) return o ? s.getStartX() : s.getEndX();
        if (t.isValidBarcodeColumn(e, r - u) && (s = e.getDetectionResultColumn(r - u).getCodewordNearby(n)), null != s) return o ? s.getEndX() : s.getStartX();
        for(var c = 0; t.isValidBarcodeColumn(e, r - u);){
            r -= u;
            try {
                for(var f = (i = void 0, $2be8636d379871d6$var$zn(e.getDetectionResultColumn(r).getCodewords())), h = f.next(); !h.done; h = f.next()){
                    var l = h.value;
                    if (null != l) return (o ? l.getEndX() : l.getStartX()) + u * c * (l.getEndX() - l.getStartX());
                }
            } catch (t) {
                i = {
                    error: t
                };
            } finally{
                try {
                    h && !h.done && (a = f.return) && a.call(f);
                } finally{
                    if (i) throw i.error;
                }
            }
            c++;
        }
        return o ? e.getBoundingBox().getMinX() : e.getBoundingBox().getMaxX();
    }, t.detectCodeword = function(e, r, n, o, i, a, u, s) {
        i = t.adjustCodewordStartColumn(e, r, n, o, i, a);
        var c, f = t.getModuleBitCount(e, r, n, o, i, a);
        if (null == f) return null;
        var h = $2be8636d379871d6$var$vt.sum(f);
        if (o) c = i + h;
        else {
            for(var l = 0; l < f.length / 2; l++){
                var d = f[l];
                f[l] = f[f.length - 1 - l], f[f.length - 1 - l] = d;
            }
            i = (c = i) - h;
        }
        if (!t.checkCodewordSkew(h, u, s)) return null;
        var p = $2be8636d379871d6$var$Mn.getDecodedValue(f), g = $2be8636d379871d6$var$sn.getCodeword(p);
        return -1 === g ? null : new $2be8636d379871d6$var$Pn(i, c, t.getCodewordBucketNumber(p), g);
    }, t.getModuleBitCount = function(t, e, r, n, o, i) {
        for(var a = o, u = new Int32Array(8), s = 0, c = n ? 1 : -1, f = n; (n ? a < r : a >= e) && s < u.length;)t.get(a, i) === f ? (u[s]++, a += c) : (s++, f = !f);
        return s === u.length || a === (n ? r : e) && s === u.length - 1 ? u : null;
    }, t.getNumberOfECCodeWords = function(t) {
        return 2 << t;
    }, t.adjustCodewordStartColumn = function(e, r, n, o, i, a) {
        for(var u = i, s = o ? -1 : 1, c = 0; c < 2; c++){
            for(; (o ? u >= r : u < n) && o === e.get(u, a);){
                if (Math.abs(i - u) > t.CODEWORD_SKEW_SIZE) return i;
                u += s;
            }
            s = -s, o = !o;
        }
        return u;
    }, t.checkCodewordSkew = function(e, r, n) {
        return r - t.CODEWORD_SKEW_SIZE <= e && e <= n + t.CODEWORD_SKEW_SIZE;
    }, t.decodeCodewords = function(e, r, n) {
        if (0 === e.length) throw $2be8636d379871d6$var$R.getFormatInstance();
        var o = 1 << r + 1, i = t.correctErrors(e, n, o);
        t.verifyCodewordCount(e, o);
        var a = $2be8636d379871d6$var$jn.decode(e, "" + r);
        return a.setErrorsCorrected(i), a.setErasures(n.length), a;
    }, t.correctErrors = function(e, r, n) {
        if (null != r && r.length > n / 2 + t.MAX_ERRORS || n < 0 || n > t.MAX_EC_CODEWORDS) throw $2be8636d379871d6$var$g.getChecksumInstance();
        return t.errorCorrection.decode(e, n, r);
    }, t.verifyCodewordCount = function(t, e) {
        if (t.length < 4) throw $2be8636d379871d6$var$R.getFormatInstance();
        var r = t[0];
        if (r > t.length) throw $2be8636d379871d6$var$R.getFormatInstance();
        if (0 === r) {
            if (!(e < t.length)) throw $2be8636d379871d6$var$R.getFormatInstance();
            t[0] = t.length - e;
        }
    }, t.getBitCountForCodeword = function(t) {
        for(var e = new Int32Array(8), r = 0, n = e.length - 1; !((1 & t) !== r && (r = 1 & t, --n < 0));)e[n]++, t >>= 1;
        return e;
    }, t.getCodewordBucketNumber = function(t) {
        return t instanceof Int32Array ? this.getCodewordBucketNumber_Int32Array(t) : this.getCodewordBucketNumber_number(t);
    }, t.getCodewordBucketNumber_number = function(e) {
        return t.getCodewordBucketNumber(t.getBitCountForCodeword(e));
    }, t.getCodewordBucketNumber_Int32Array = function(t) {
        return (t[0] - t[2] + t[4] - t[6] + 9) % 9;
    }, t.toString = function(t) {
        for(var e = new $2be8636d379871d6$var$An(), r = 0; r < t.length; r++){
            e.format("Row %2d: ", r);
            for(var n = 0; n < t[r].length; n++){
                var o = t[r][n];
                0 === o.getValue().length ? e.format("        ", null) : e.format("%4d(%2d)", o.getValue()[0], o.getConfidence(o.getValue()[0]));
            }
            e.format("%n");
        }
        return e.toString();
    }, t.CODEWORD_SKEW_SIZE = 2, t.MAX_ERRORS = 3, t.MAX_EC_CODEWORDS = 512, t.errorCorrection = new $2be8636d379871d6$var$_n(), t;
}(), $2be8636d379871d6$var$Zn = function(t) {
    var e = "function" == typeof Symbol && Symbol.iterator, r = e && t[e], n = 0;
    if (r) return r.call(t);
    if (t && "number" == typeof t.length) return {
        next: function() {
            return t && n >= t.length && (t = void 0), {
                value: t && t[n++],
                done: !t
            };
        }
    };
    throw new TypeError(e ? "Object is not iterable." : "Symbol.iterator is not defined.");
}, $2be8636d379871d6$var$Kn = function() {
    function t() {}
    return t.prototype.decode = function(e, r) {
        void 0 === r && (r = null);
        var n = t.decode(e, r, !1);
        if (null == n || 0 === n.length || null == n[0]) throw $2be8636d379871d6$var$U.getNotFoundInstance();
        return n[0];
    }, t.prototype.decodeMultiple = function(e, r) {
        void 0 === r && (r = null);
        try {
            return t.decode(e, r, !0);
        } catch (t) {
            if (t instanceof $2be8636d379871d6$var$R || t instanceof $2be8636d379871d6$var$g) throw $2be8636d379871d6$var$U.getNotFoundInstance();
            throw t;
        }
    }, t.decode = function(e, r, n) {
        var o, i, a = new Array(), u = $2be8636d379871d6$var$hn.detectMultiple(e, r, n);
        try {
            for(var s = $2be8636d379871d6$var$Zn(u.getPoints()), c = s.next(); !c.done; c = s.next()){
                var f = c.value, h = $2be8636d379871d6$var$Yn.decode(u.getBits(), f[4], f[5], f[6], f[7], t.getMinCodewordWidth(f), t.getMaxCodewordWidth(f)), l = new $2be8636d379871d6$var$et(h.getText(), h.getRawBytes(), void 0, f, $2be8636d379871d6$var$nt.PDF_417);
                l.putMetadata($2be8636d379871d6$var$it.ERROR_CORRECTION_LEVEL, h.getECLevel());
                var d = h.getOther();
                null != d && l.putMetadata($2be8636d379871d6$var$it.PDF417_EXTRA_METADATA, d), a.push(l);
            }
        } catch (t) {
            o = {
                error: t
            };
        } finally{
            try {
                c && !c.done && (i = s.return) && i.call(s);
            } finally{
                if (o) throw o.error;
            }
        }
        return a.map(function(t) {
            return t;
        });
    }, t.getMaxWidth = function(t, e) {
        return null == t || null == e ? 0 : Math.trunc(Math.abs(t.getX() - e.getX()));
    }, t.getMinWidth = function(t, e) {
        return null == t || null == e ? $2be8636d379871d6$var$I.MAX_VALUE : Math.trunc(Math.abs(t.getX() - e.getX()));
    }, t.getMaxCodewordWidth = function(e) {
        return Math.floor(Math.max(Math.max(t.getMaxWidth(e[0], e[4]), t.getMaxWidth(e[6], e[2]) * $2be8636d379871d6$var$sn.MODULES_IN_CODEWORD / $2be8636d379871d6$var$sn.MODULES_IN_STOP_PATTERN), Math.max(t.getMaxWidth(e[1], e[5]), t.getMaxWidth(e[7], e[3]) * $2be8636d379871d6$var$sn.MODULES_IN_CODEWORD / $2be8636d379871d6$var$sn.MODULES_IN_STOP_PATTERN)));
    }, t.getMinCodewordWidth = function(e) {
        return Math.floor(Math.min(Math.min(t.getMinWidth(e[0], e[4]), t.getMinWidth(e[6], e[2]) * $2be8636d379871d6$var$sn.MODULES_IN_CODEWORD / $2be8636d379871d6$var$sn.MODULES_IN_STOP_PATTERN), Math.min(t.getMinWidth(e[1], e[5]), t.getMinWidth(e[7], e[3]) * $2be8636d379871d6$var$sn.MODULES_IN_CODEWORD / $2be8636d379871d6$var$sn.MODULES_IN_STOP_PATTERN)));
    }, t.prototype.reset = function() {}, t;
}(), $2be8636d379871d6$var$qn = function() {
    var t = function(e, r) {
        return t = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(t, e) {
            t.__proto__ = e;
        } || function(t, e) {
            for(var r in e)e.hasOwnProperty(r) && (t[r] = e[r]);
        }, t(e, r);
    };
    return function(e, r) {
        function n() {
            this.constructor = e;
        }
        t(e, r), e.prototype = null === r ? Object.create(r) : (n.prototype = r.prototype, new n());
    };
}(), $2be8636d379871d6$var$Qn = function(t) {
    function e() {
        return null !== t && t.apply(this, arguments) || this;
    }
    return $2be8636d379871d6$var$qn(e, t), e.kind = "ReaderException", e;
}($2be8636d379871d6$var$s), $2be8636d379871d6$var$Jn = function(t) {
    var e = "function" == typeof Symbol && Symbol.iterator, r = e && t[e], n = 0;
    if (r) return r.call(t);
    if (t && "number" == typeof t.length) return {
        next: function() {
            return t && n >= t.length && (t = void 0), {
                value: t && t[n++],
                done: !t
            };
        }
    };
    throw new TypeError(e ? "Object is not iterable." : "Symbol.iterator is not defined.");
}, $2be8636d379871d6$var$$n = function() {
    function t() {}
    return t.prototype.decode = function(t, e) {
        return this.setHints(e), this.decodeInternal(t);
    }, t.prototype.decodeWithState = function(t) {
        return null !== this.readers && void 0 !== this.readers || this.setHints(null), this.decodeInternal(t);
    }, t.prototype.setHints = function(t) {
        this.hints = t;
        var e = null != t && void 0 !== t.get($2be8636d379871d6$var$T.TRY_HARDER), r = null == t ? null : t.get($2be8636d379871d6$var$T.POSSIBLE_FORMATS), n = new Array();
        if (null != r) {
            var o = r.some(function(t) {
                return t === $2be8636d379871d6$var$nt.UPC_A || t === $2be8636d379871d6$var$nt.UPC_E || t === $2be8636d379871d6$var$nt.EAN_13 || t === $2be8636d379871d6$var$nt.EAN_8 || t === $2be8636d379871d6$var$nt.CODABAR || t === $2be8636d379871d6$var$nt.CODE_39 || t === $2be8636d379871d6$var$nt.CODE_93 || t === $2be8636d379871d6$var$nt.CODE_128 || t === $2be8636d379871d6$var$nt.ITF || t === $2be8636d379871d6$var$nt.RSS_14 || t === $2be8636d379871d6$var$nt.RSS_EXPANDED;
            });
            o && !e && n.push(new $2be8636d379871d6$var$fr(t)), r.includes($2be8636d379871d6$var$nt.QR_CODE) && n.push(new $2be8636d379871d6$var$an()), r.includes($2be8636d379871d6$var$nt.DATA_MATRIX) && n.push(new $2be8636d379871d6$var$Or()), r.includes($2be8636d379871d6$var$nt.AZTEC) && n.push(new $2be8636d379871d6$var$Mt()), r.includes($2be8636d379871d6$var$nt.PDF_417) && n.push(new $2be8636d379871d6$var$Kn()), o && e && n.push(new $2be8636d379871d6$var$fr(t));
        }
        0 === n.length && (e || n.push(new $2be8636d379871d6$var$fr(t)), n.push(new $2be8636d379871d6$var$an()), n.push(new $2be8636d379871d6$var$Or()), n.push(new $2be8636d379871d6$var$Mt()), n.push(new $2be8636d379871d6$var$Kn()), e && n.push(new $2be8636d379871d6$var$fr(t))), this.readers = n;
    }, t.prototype.reset = function() {
        var t, e;
        if (null !== this.readers) try {
            for(var r = $2be8636d379871d6$var$Jn(this.readers), n = r.next(); !n.done; n = r.next())n.value.reset();
        } catch (e) {
            t = {
                error: e
            };
        } finally{
            try {
                n && !n.done && (e = r.return) && e.call(r);
            } finally{
                if (t) throw t.error;
            }
        }
    }, t.prototype.decodeInternal = function(t) {
        var e, r;
        if (null === this.readers) throw new $2be8636d379871d6$var$Qn("No readers where selected, nothing can be read.");
        try {
            for(var n = $2be8636d379871d6$var$Jn(this.readers), o = n.next(); !o.done; o = n.next()){
                var i = o.value;
                try {
                    return i.decode(t, this.hints);
                } catch (t) {
                    if (t instanceof $2be8636d379871d6$var$Qn) continue;
                }
            }
        } catch (t) {
            e = {
                error: t
            };
        } finally{
            try {
                o && !o.done && (r = n.return) && r.call(n);
            } finally{
                if (e) throw e.error;
            }
        }
        throw new $2be8636d379871d6$var$U("No MultiFormat Readers were able to detect the code.");
    }, t;
}(), $2be8636d379871d6$var$to = function() {
    var t = function(e, r) {
        return t = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(t, e) {
            t.__proto__ = e;
        } || function(t, e) {
            for(var r in e)e.hasOwnProperty(r) && (t[r] = e[r]);
        }, t(e, r);
    };
    return function(e, r) {
        function n() {
            this.constructor = e;
        }
        t(e, r), e.prototype = null === r ? Object.create(r) : (n.prototype = r.prototype, new n());
    };
}();
!function(t) {
    function e(e, r) {
        void 0 === e && (e = null), void 0 === r && (r = 500);
        var n = new $2be8636d379871d6$var$$n();
        return n.setHints(e), t.call(this, n, r) || this;
    }
    $2be8636d379871d6$var$to(e, t), e.prototype.decodeBitmap = function(t) {
        return this.reader.decodeWithState(t);
    };
}($2be8636d379871d6$var$tt);
var $2be8636d379871d6$var$eo = function() {
    var t = function(e, r) {
        return t = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(t, e) {
            t.__proto__ = e;
        } || function(t, e) {
            for(var r in e)e.hasOwnProperty(r) && (t[r] = e[r]);
        }, t(e, r);
    };
    return function(e, r) {
        function n() {
            this.constructor = e;
        }
        t(e, r), e.prototype = null === r ? Object.create(r) : (n.prototype = r.prototype, new n());
    };
}();
!function(t) {
    function e(e) {
        return void 0 === e && (e = 500), t.call(this, new $2be8636d379871d6$var$Kn(), e) || this;
    }
    $2be8636d379871d6$var$eo(e, t);
}($2be8636d379871d6$var$tt);
var $2be8636d379871d6$var$ro, $2be8636d379871d6$var$no = function() {
    var t = function(e, r) {
        return t = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(t, e) {
            t.__proto__ = e;
        } || function(t, e) {
            for(var r in e)e.hasOwnProperty(r) && (t[r] = e[r]);
        }, t(e, r);
    };
    return function(e, r) {
        function n() {
            this.constructor = e;
        }
        t(e, r), e.prototype = null === r ? Object.create(r) : (n.prototype = r.prototype, new n());
    };
}();
!function(t) {
    function e(e) {
        return void 0 === e && (e = 500), t.call(this, new $2be8636d379871d6$var$an(), e) || this;
    }
    $2be8636d379871d6$var$no(e, t);
}($2be8636d379871d6$var$tt), function(t) {
    t[t.ERROR_CORRECTION = 0] = "ERROR_CORRECTION", t[t.CHARACTER_SET = 1] = "CHARACTER_SET", t[t.DATA_MATRIX_SHAPE = 2] = "DATA_MATRIX_SHAPE", t[t.MIN_SIZE = 3] = "MIN_SIZE", t[t.MAX_SIZE = 4] = "MAX_SIZE", t[t.MARGIN = 5] = "MARGIN", t[t.PDF417_COMPACT = 6] = "PDF417_COMPACT", t[t.PDF417_COMPACTION = 7] = "PDF417_COMPACTION", t[t.PDF417_DIMENSIONS = 8] = "PDF417_DIMENSIONS", t[t.AZTEC_LAYERS = 9] = "AZTEC_LAYERS", t[t.QR_VERSION = 10] = "QR_VERSION";
}($2be8636d379871d6$var$ro || ($2be8636d379871d6$var$ro = {}));
var $2be8636d379871d6$var$oo = $2be8636d379871d6$var$ro, $2be8636d379871d6$var$io = function() {
    function t(t) {
        this.field = t, this.cachedGenerators = [], this.cachedGenerators.push(new $2be8636d379871d6$var$st(t, Int32Array.from([
            1
        ])));
    }
    return t.prototype.buildGenerator = function(t) {
        var e = this.cachedGenerators;
        if (t >= e.length) for(var r = e[e.length - 1], n = this.field, o = e.length; o <= t; o++){
            var i = r.multiply(new $2be8636d379871d6$var$st(n, Int32Array.from([
                1,
                n.exp(o - 1 + n.getGeneratorBase())
            ])));
            e.push(i), r = i;
        }
        return e[t];
    }, t.prototype.encode = function(t, e) {
        if (0 === e) throw new $2be8636d379871d6$var$l("No error correction bytes");
        var r = t.length - e;
        if (r <= 0) throw new $2be8636d379871d6$var$l("No data bytes provided");
        var n = this.buildGenerator(e), o = new Int32Array(r);
        $2be8636d379871d6$var$w.arraycopy(t, 0, o, 0, r);
        for(var i = new $2be8636d379871d6$var$st(this.field, o), a = (i = i.multiplyByMonomial(e, 1)).divide(n)[1].getCoefficients(), u = e - a.length, s = 0; s < u; s++)t[r + s] = 0;
        $2be8636d379871d6$var$w.arraycopy(a, 0, t, r + u, a.length);
    }, t;
}(), $2be8636d379871d6$var$ao = function() {
    function t() {}
    return t.applyMaskPenaltyRule1 = function(e) {
        return t.applyMaskPenaltyRule1Internal(e, !0) + t.applyMaskPenaltyRule1Internal(e, !1);
    }, t.applyMaskPenaltyRule2 = function(e) {
        for(var r = 0, n = e.getArray(), o = e.getWidth(), i = e.getHeight(), a = 0; a < i - 1; a++)for(var u = n[a], s = 0; s < o - 1; s++){
            var c = u[s];
            c === u[s + 1] && c === n[a + 1][s] && c === n[a + 1][s + 1] && r++;
        }
        return t.N2 * r;
    }, t.applyMaskPenaltyRule3 = function(e) {
        for(var r = 0, n = e.getArray(), o = e.getWidth(), i = e.getHeight(), a = 0; a < i; a++)for(var u = 0; u < o; u++){
            var s = n[a];
            u + 6 < o && 1 === s[u] && 0 === s[u + 1] && 1 === s[u + 2] && 1 === s[u + 3] && 1 === s[u + 4] && 0 === s[u + 5] && 1 === s[u + 6] && (t.isWhiteHorizontal(s, u - 4, u) || t.isWhiteHorizontal(s, u + 7, u + 11)) && r++, a + 6 < i && 1 === n[a][u] && 0 === n[a + 1][u] && 1 === n[a + 2][u] && 1 === n[a + 3][u] && 1 === n[a + 4][u] && 0 === n[a + 5][u] && 1 === n[a + 6][u] && (t.isWhiteVertical(n, u, a - 4, a) || t.isWhiteVertical(n, u, a + 7, a + 11)) && r++;
        }
        return r * t.N3;
    }, t.isWhiteHorizontal = function(t, e, r) {
        e = Math.max(e, 0), r = Math.min(r, t.length);
        for(var n = e; n < r; n++)if (1 === t[n]) return !1;
        return !0;
    }, t.isWhiteVertical = function(t, e, r, n) {
        r = Math.max(r, 0), n = Math.min(n, t.length);
        for(var o = r; o < n; o++)if (1 === t[o][e]) return !1;
        return !0;
    }, t.applyMaskPenaltyRule4 = function(e) {
        for(var r = 0, n = e.getArray(), o = e.getWidth(), i = e.getHeight(), a = 0; a < i; a++)for(var u = n[a], s = 0; s < o; s++)1 === u[s] && r++;
        var c = e.getHeight() * e.getWidth();
        return Math.floor(10 * Math.abs(2 * r - c) / c) * t.N4;
    }, t.getDataMaskBit = function(t, e, r) {
        var n, o;
        switch(t){
            case 0:
                n = r + e & 1;
                break;
            case 1:
                n = 1 & r;
                break;
            case 2:
                n = e % 3;
                break;
            case 3:
                n = (r + e) % 3;
                break;
            case 4:
                n = Math.floor(r / 2) + Math.floor(e / 3) & 1;
                break;
            case 5:
                n = (1 & (o = r * e)) + o % 3;
                break;
            case 6:
                n = (1 & (o = r * e)) + o % 3 & 1;
                break;
            case 7:
                n = (o = r * e) % 3 + (r + e & 1) & 1;
                break;
            default:
                throw new $2be8636d379871d6$var$l("Invalid mask pattern: " + t);
        }
        return 0 === n;
    }, t.applyMaskPenaltyRule1Internal = function(e, r) {
        for(var n = 0, o = r ? e.getHeight() : e.getWidth(), i = r ? e.getWidth() : e.getHeight(), a = e.getArray(), u = 0; u < o; u++){
            for(var s = 0, c = -1, f = 0; f < i; f++){
                var h = r ? a[u][f] : a[f][u];
                h === c ? s++ : (s >= 5 && (n += t.N1 + (s - 5)), s = 1, c = h);
            }
            s >= 5 && (n += t.N1 + (s - 5));
        }
        return n;
    }, t.N1 = 3, t.N2 = 3, t.N3 = 40, t.N4 = 10, t;
}(), $2be8636d379871d6$var$uo = function(t) {
    var e = "function" == typeof Symbol && Symbol.iterator, r = e && t[e], n = 0;
    if (r) return r.call(t);
    if (t && "number" == typeof t.length) return {
        next: function() {
            return t && n >= t.length && (t = void 0), {
                value: t && t[n++],
                done: !t
            };
        }
    };
    throw new TypeError(e ? "Object is not iterable." : "Symbol.iterator is not defined.");
}, $2be8636d379871d6$var$so = function() {
    function t(t, e) {
        this.width = t, this.height = e;
        for(var r = new Array(e), n = 0; n !== e; n++)r[n] = new Uint8Array(t);
        this.bytes = r;
    }
    return t.prototype.getHeight = function() {
        return this.height;
    }, t.prototype.getWidth = function() {
        return this.width;
    }, t.prototype.get = function(t, e) {
        return this.bytes[e][t];
    }, t.prototype.getArray = function() {
        return this.bytes;
    }, t.prototype.setNumber = function(t, e, r) {
        this.bytes[e][t] = r;
    }, t.prototype.setBoolean = function(t, e, r) {
        this.bytes[e][t] = r ? 1 : 0;
    }, t.prototype.clear = function(t) {
        var e, r;
        try {
            for(var n = $2be8636d379871d6$var$uo(this.bytes), o = n.next(); !o.done; o = n.next()){
                var i = o.value;
                $2be8636d379871d6$var$C.fill(i, t);
            }
        } catch (t) {
            e = {
                error: t
            };
        } finally{
            try {
                o && !o.done && (r = n.return) && r.call(n);
            } finally{
                if (e) throw e.error;
            }
        }
    }, t.prototype.equals = function(e) {
        if (!(e instanceof t)) return !1;
        var r = e;
        if (this.width !== r.width) return !1;
        if (this.height !== r.height) return !1;
        for(var n = 0, o = this.height; n < o; ++n)for(var i = this.bytes[n], a = r.bytes[n], u = 0, s = this.width; u < s; ++u)if (i[u] !== a[u]) return !1;
        return !0;
    }, t.prototype.toString = function() {
        for(var t = new $2be8636d379871d6$var$k(), e = 0, r = this.height; e < r; ++e){
            for(var n = this.bytes[e], o = 0, i = this.width; o < i; ++o)switch(n[o]){
                case 0:
                    t.append(" 0");
                    break;
                case 1:
                    t.append(" 1");
                    break;
                default:
                    t.append("  ");
            }
            t.append("\n");
        }
        return t.toString();
    }, t;
}(), $2be8636d379871d6$var$co = function() {
    function t() {
        this.maskPattern = -1;
    }
    return t.prototype.getMode = function() {
        return this.mode;
    }, t.prototype.getECLevel = function() {
        return this.ecLevel;
    }, t.prototype.getVersion = function() {
        return this.version;
    }, t.prototype.getMaskPattern = function() {
        return this.maskPattern;
    }, t.prototype.getMatrix = function() {
        return this.matrix;
    }, t.prototype.toString = function() {
        var t = new $2be8636d379871d6$var$k();
        return t.append("<<\n"), t.append(" mode: "), t.append(this.mode ? this.mode.toString() : "null"), t.append("\n ecLevel: "), t.append(this.ecLevel ? this.ecLevel.toString() : "null"), t.append("\n version: "), t.append(this.version ? this.version.toString() : "null"), t.append("\n maskPattern: "), t.append(this.maskPattern.toString()), this.matrix ? (t.append("\n matrix:\n"), t.append(this.matrix.toString())) : t.append("\n matrix: null\n"), t.append(">>\n"), t.toString();
    }, t.prototype.setMode = function(t) {
        this.mode = t;
    }, t.prototype.setECLevel = function(t) {
        this.ecLevel = t;
    }, t.prototype.setVersion = function(t) {
        this.version = t;
    }, t.prototype.setMaskPattern = function(t) {
        this.maskPattern = t;
    }, t.prototype.setMatrix = function(t) {
        this.matrix = t;
    }, t.isValidMaskPattern = function(e) {
        return e >= 0 && e < t.NUM_MASK_PATTERNS;
    }, t.NUM_MASK_PATTERNS = 8, t;
}(), $2be8636d379871d6$var$fo = function() {
    var t = function(e, r) {
        return t = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(t, e) {
            t.__proto__ = e;
        } || function(t, e) {
            for(var r in e)e.hasOwnProperty(r) && (t[r] = e[r]);
        }, t(e, r);
    };
    return function(e, r) {
        function n() {
            this.constructor = e;
        }
        t(e, r), e.prototype = null === r ? Object.create(r) : (n.prototype = r.prototype, new n());
    };
}(), $2be8636d379871d6$var$ho = function(t) {
    function e() {
        return null !== t && t.apply(this, arguments) || this;
    }
    return $2be8636d379871d6$var$fo(e, t), e.kind = "WriterException", e;
}($2be8636d379871d6$var$s), $2be8636d379871d6$var$lo = function() {
    function t() {}
    return t.clearMatrix = function(t) {
        t.clear(255);
    }, t.buildMatrix = function(e, r, n, o, i) {
        t.clearMatrix(i), t.embedBasicPatterns(n, i), t.embedTypeInfo(r, o, i), t.maybeEmbedVersionInfo(n, i), t.embedDataBits(e, o, i);
    }, t.embedBasicPatterns = function(e, r) {
        t.embedPositionDetectionPatternsAndSeparators(r), t.embedDarkDotAtLeftBottomCorner(r), t.maybeEmbedPositionAdjustmentPatterns(e, r), t.embedTimingPatterns(r);
    }, t.embedTypeInfo = function(e, r, n) {
        var o = new $2be8636d379871d6$var$S();
        t.makeTypeInfoBits(e, r, o);
        for(var i = 0, a = o.getSize(); i < a; ++i){
            var u = o.get(o.getSize() - 1 - i), s = t.TYPE_INFO_COORDINATES[i], c = s[0], f = s[1];
            if (n.setBoolean(c, f, u), i < 8) {
                var h = n.getWidth() - i - 1, l = 8;
                n.setBoolean(h, l, u);
            } else {
                h = 8, l = n.getHeight() - 7 + (i - 8);
                n.setBoolean(h, l, u);
            }
        }
    }, t.maybeEmbedVersionInfo = function(e, r) {
        if (!(e.getVersionNumber() < 7)) {
            var n = new $2be8636d379871d6$var$S();
            t.makeVersionInfoBits(e, n);
            for(var o = 17, i = 0; i < 6; ++i)for(var a = 0; a < 3; ++a){
                var u = n.get(o);
                o--, r.setBoolean(i, r.getHeight() - 11 + a, u), r.setBoolean(r.getHeight() - 11 + a, i, u);
            }
        }
    }, t.embedDataBits = function(e, r, n) {
        for(var o = 0, i = -1, a = n.getWidth() - 1, u = n.getHeight() - 1; a > 0;){
            for(6 === a && (a -= 1); u >= 0 && u < n.getHeight();){
                for(var s = 0; s < 2; ++s){
                    var c = a - s;
                    if (t.isEmpty(n.get(c, u))) {
                        var f = void 0;
                        o < e.getSize() ? (f = e.get(o), ++o) : f = !1, 255 !== r && $2be8636d379871d6$var$ao.getDataMaskBit(r, c, u) && (f = !f), n.setBoolean(c, u, f);
                    }
                }
                u += i;
            }
            u += i = -i, a -= 2;
        }
        if (o !== e.getSize()) throw new $2be8636d379871d6$var$ho("Not all bits consumed: " + o + "/" + e.getSize());
    }, t.findMSBSet = function(t) {
        return 32 - $2be8636d379871d6$var$I.numberOfLeadingZeros(t);
    }, t.calculateBCHCode = function(e, r) {
        if (0 === r) throw new $2be8636d379871d6$var$l("0 polynomial");
        var n = t.findMSBSet(r);
        for(e <<= n - 1; t.findMSBSet(e) >= n;)e ^= r << t.findMSBSet(e) - n;
        return e;
    }, t.makeTypeInfoBits = function(e, r, n) {
        if (!$2be8636d379871d6$var$co.isValidMaskPattern(r)) throw new $2be8636d379871d6$var$ho("Invalid mask pattern");
        var o = e.getBits() << 3 | r;
        n.appendBits(o, 5);
        var i = t.calculateBCHCode(o, t.TYPE_INFO_POLY);
        n.appendBits(i, 10);
        var a = new $2be8636d379871d6$var$S();
        if (a.appendBits(t.TYPE_INFO_MASK_PATTERN, 15), n.xor(a), 15 !== n.getSize()) throw new $2be8636d379871d6$var$ho("should not happen but we got: " + n.getSize());
    }, t.makeVersionInfoBits = function(e, r) {
        r.appendBits(e.getVersionNumber(), 6);
        var n = t.calculateBCHCode(e.getVersionNumber(), t.VERSION_INFO_POLY);
        if (r.appendBits(n, 12), 18 !== r.getSize()) throw new $2be8636d379871d6$var$ho("should not happen but we got: " + r.getSize());
    }, t.isEmpty = function(t) {
        return 255 === t;
    }, t.embedTimingPatterns = function(e) {
        for(var r = 8; r < e.getWidth() - 8; ++r){
            var n = (r + 1) % 2;
            t.isEmpty(e.get(r, 6)) && e.setNumber(r, 6, n), t.isEmpty(e.get(6, r)) && e.setNumber(6, r, n);
        }
    }, t.embedDarkDotAtLeftBottomCorner = function(t) {
        if (0 === t.get(8, t.getHeight() - 8)) throw new $2be8636d379871d6$var$ho();
        t.setNumber(8, t.getHeight() - 8, 1);
    }, t.embedHorizontalSeparationPattern = function(e, r, n) {
        for(var o = 0; o < 8; ++o){
            if (!t.isEmpty(n.get(e + o, r))) throw new $2be8636d379871d6$var$ho();
            n.setNumber(e + o, r, 0);
        }
    }, t.embedVerticalSeparationPattern = function(e, r, n) {
        for(var o = 0; o < 7; ++o){
            if (!t.isEmpty(n.get(e, r + o))) throw new $2be8636d379871d6$var$ho();
            n.setNumber(e, r + o, 0);
        }
    }, t.embedPositionAdjustmentPattern = function(e, r, n) {
        for(var o = 0; o < 5; ++o)for(var i = t.POSITION_ADJUSTMENT_PATTERN[o], a = 0; a < 5; ++a)n.setNumber(e + a, r + o, i[a]);
    }, t.embedPositionDetectionPattern = function(e, r, n) {
        for(var o = 0; o < 7; ++o)for(var i = t.POSITION_DETECTION_PATTERN[o], a = 0; a < 7; ++a)n.setNumber(e + a, r + o, i[a]);
    }, t.embedPositionDetectionPatternsAndSeparators = function(e) {
        var r = t.POSITION_DETECTION_PATTERN[0].length;
        t.embedPositionDetectionPattern(0, 0, e), t.embedPositionDetectionPattern(e.getWidth() - r, 0, e), t.embedPositionDetectionPattern(0, e.getWidth() - r, e);
        t.embedHorizontalSeparationPattern(0, 7, e), t.embedHorizontalSeparationPattern(e.getWidth() - 8, 7, e), t.embedHorizontalSeparationPattern(0, e.getWidth() - 8, e);
        t.embedVerticalSeparationPattern(7, 0, e), t.embedVerticalSeparationPattern(e.getHeight() - 7 - 1, 0, e), t.embedVerticalSeparationPattern(7, e.getHeight() - 7, e);
    }, t.maybeEmbedPositionAdjustmentPatterns = function(e, r) {
        if (!(e.getVersionNumber() < 2)) for(var n = e.getVersionNumber() - 1, o = t.POSITION_ADJUSTMENT_PATTERN_COORDINATE_TABLE[n], i = 0, a = o.length; i !== a; i++){
            var u = o[i];
            if (u >= 0) for(var s = 0; s !== a; s++){
                var c = o[s];
                c >= 0 && t.isEmpty(r.get(c, u)) && t.embedPositionAdjustmentPattern(c - 2, u - 2, r);
            }
        }
    }, t.POSITION_DETECTION_PATTERN = Array.from([
        Int32Array.from([
            1,
            1,
            1,
            1,
            1,
            1,
            1
        ]),
        Int32Array.from([
            1,
            0,
            0,
            0,
            0,
            0,
            1
        ]),
        Int32Array.from([
            1,
            0,
            1,
            1,
            1,
            0,
            1
        ]),
        Int32Array.from([
            1,
            0,
            1,
            1,
            1,
            0,
            1
        ]),
        Int32Array.from([
            1,
            0,
            1,
            1,
            1,
            0,
            1
        ]),
        Int32Array.from([
            1,
            0,
            0,
            0,
            0,
            0,
            1
        ]),
        Int32Array.from([
            1,
            1,
            1,
            1,
            1,
            1,
            1
        ])
    ]), t.POSITION_ADJUSTMENT_PATTERN = Array.from([
        Int32Array.from([
            1,
            1,
            1,
            1,
            1
        ]),
        Int32Array.from([
            1,
            0,
            0,
            0,
            1
        ]),
        Int32Array.from([
            1,
            0,
            1,
            0,
            1
        ]),
        Int32Array.from([
            1,
            0,
            0,
            0,
            1
        ]),
        Int32Array.from([
            1,
            1,
            1,
            1,
            1
        ])
    ]), t.POSITION_ADJUSTMENT_PATTERN_COORDINATE_TABLE = Array.from([
        Int32Array.from([
            -1,
            -1,
            -1,
            -1,
            -1,
            -1,
            -1
        ]),
        Int32Array.from([
            6,
            18,
            -1,
            -1,
            -1,
            -1,
            -1
        ]),
        Int32Array.from([
            6,
            22,
            -1,
            -1,
            -1,
            -1,
            -1
        ]),
        Int32Array.from([
            6,
            26,
            -1,
            -1,
            -1,
            -1,
            -1
        ]),
        Int32Array.from([
            6,
            30,
            -1,
            -1,
            -1,
            -1,
            -1
        ]),
        Int32Array.from([
            6,
            34,
            -1,
            -1,
            -1,
            -1,
            -1
        ]),
        Int32Array.from([
            6,
            22,
            38,
            -1,
            -1,
            -1,
            -1
        ]),
        Int32Array.from([
            6,
            24,
            42,
            -1,
            -1,
            -1,
            -1
        ]),
        Int32Array.from([
            6,
            26,
            46,
            -1,
            -1,
            -1,
            -1
        ]),
        Int32Array.from([
            6,
            28,
            50,
            -1,
            -1,
            -1,
            -1
        ]),
        Int32Array.from([
            6,
            30,
            54,
            -1,
            -1,
            -1,
            -1
        ]),
        Int32Array.from([
            6,
            32,
            58,
            -1,
            -1,
            -1,
            -1
        ]),
        Int32Array.from([
            6,
            34,
            62,
            -1,
            -1,
            -1,
            -1
        ]),
        Int32Array.from([
            6,
            26,
            46,
            66,
            -1,
            -1,
            -1
        ]),
        Int32Array.from([
            6,
            26,
            48,
            70,
            -1,
            -1,
            -1
        ]),
        Int32Array.from([
            6,
            26,
            50,
            74,
            -1,
            -1,
            -1
        ]),
        Int32Array.from([
            6,
            30,
            54,
            78,
            -1,
            -1,
            -1
        ]),
        Int32Array.from([
            6,
            30,
            56,
            82,
            -1,
            -1,
            -1
        ]),
        Int32Array.from([
            6,
            30,
            58,
            86,
            -1,
            -1,
            -1
        ]),
        Int32Array.from([
            6,
            34,
            62,
            90,
            -1,
            -1,
            -1
        ]),
        Int32Array.from([
            6,
            28,
            50,
            72,
            94,
            -1,
            -1
        ]),
        Int32Array.from([
            6,
            26,
            50,
            74,
            98,
            -1,
            -1
        ]),
        Int32Array.from([
            6,
            30,
            54,
            78,
            102,
            -1,
            -1
        ]),
        Int32Array.from([
            6,
            28,
            54,
            80,
            106,
            -1,
            -1
        ]),
        Int32Array.from([
            6,
            32,
            58,
            84,
            110,
            -1,
            -1
        ]),
        Int32Array.from([
            6,
            30,
            58,
            86,
            114,
            -1,
            -1
        ]),
        Int32Array.from([
            6,
            34,
            62,
            90,
            118,
            -1,
            -1
        ]),
        Int32Array.from([
            6,
            26,
            50,
            74,
            98,
            122,
            -1
        ]),
        Int32Array.from([
            6,
            30,
            54,
            78,
            102,
            126,
            -1
        ]),
        Int32Array.from([
            6,
            26,
            52,
            78,
            104,
            130,
            -1
        ]),
        Int32Array.from([
            6,
            30,
            56,
            82,
            108,
            134,
            -1
        ]),
        Int32Array.from([
            6,
            34,
            60,
            86,
            112,
            138,
            -1
        ]),
        Int32Array.from([
            6,
            30,
            58,
            86,
            114,
            142,
            -1
        ]),
        Int32Array.from([
            6,
            34,
            62,
            90,
            118,
            146,
            -1
        ]),
        Int32Array.from([
            6,
            30,
            54,
            78,
            102,
            126,
            150
        ]),
        Int32Array.from([
            6,
            24,
            50,
            76,
            102,
            128,
            154
        ]),
        Int32Array.from([
            6,
            28,
            54,
            80,
            106,
            132,
            158
        ]),
        Int32Array.from([
            6,
            32,
            58,
            84,
            110,
            136,
            162
        ]),
        Int32Array.from([
            6,
            26,
            54,
            82,
            110,
            138,
            166
        ]),
        Int32Array.from([
            6,
            30,
            58,
            86,
            114,
            142,
            170
        ])
    ]), t.TYPE_INFO_COORDINATES = Array.from([
        Int32Array.from([
            8,
            0
        ]),
        Int32Array.from([
            8,
            1
        ]),
        Int32Array.from([
            8,
            2
        ]),
        Int32Array.from([
            8,
            3
        ]),
        Int32Array.from([
            8,
            4
        ]),
        Int32Array.from([
            8,
            5
        ]),
        Int32Array.from([
            8,
            7
        ]),
        Int32Array.from([
            8,
            8
        ]),
        Int32Array.from([
            7,
            8
        ]),
        Int32Array.from([
            5,
            8
        ]),
        Int32Array.from([
            4,
            8
        ]),
        Int32Array.from([
            3,
            8
        ]),
        Int32Array.from([
            2,
            8
        ]),
        Int32Array.from([
            1,
            8
        ]),
        Int32Array.from([
            0,
            8
        ])
    ]), t.VERSION_INFO_POLY = 7973, t.TYPE_INFO_POLY = 1335, t.TYPE_INFO_MASK_PATTERN = 21522, t;
}(), $2be8636d379871d6$var$po = function() {
    function t(t, e) {
        this.dataBytes = t, this.errorCorrectionBytes = e;
    }
    return t.prototype.getDataBytes = function() {
        return this.dataBytes;
    }, t.prototype.getErrorCorrectionBytes = function() {
        return this.errorCorrectionBytes;
    }, t;
}(), $2be8636d379871d6$var$go = function(t) {
    var e = "function" == typeof Symbol && Symbol.iterator, r = e && t[e], n = 0;
    if (r) return r.call(t);
    if (t && "number" == typeof t.length) return {
        next: function() {
            return t && n >= t.length && (t = void 0), {
                value: t && t[n++],
                done: !t
            };
        }
    };
    throw new TypeError(e ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
!function() {
    function t() {}
    t.calculateMaskPenalty = function(t) {
        return $2be8636d379871d6$var$ao.applyMaskPenaltyRule1(t) + $2be8636d379871d6$var$ao.applyMaskPenaltyRule2(t) + $2be8636d379871d6$var$ao.applyMaskPenaltyRule3(t) + $2be8636d379871d6$var$ao.applyMaskPenaltyRule4(t);
    }, t.encode = function(e, r, n) {
        void 0 === n && (n = null);
        var o = t.DEFAULT_BYTE_MODE_ENCODING, i = null !== n && void 0 !== n.get($2be8636d379871d6$var$oo.CHARACTER_SET);
        i && (o = n.get($2be8636d379871d6$var$oo.CHARACTER_SET).toString());
        var a = this.chooseMode(e, o), u = new $2be8636d379871d6$var$S();
        if (a === $2be8636d379871d6$var$Wr.BYTE && (i || t.DEFAULT_BYTE_MODE_ENCODING !== o)) {
            var s = $2be8636d379871d6$var$P.getCharacterSetECIByName(o);
            void 0 !== s && this.appendECI(s, u);
        }
        this.appendModeInfo(a, u);
        var c, f = new $2be8636d379871d6$var$S();
        if (this.appendBytes(e, a, f, o), null !== n && void 0 !== n.get($2be8636d379871d6$var$oo.QR_VERSION)) {
            var h = Number.parseInt(n.get($2be8636d379871d6$var$oo.QR_VERSION).toString(), 10);
            c = $2be8636d379871d6$var$Fr.getVersionForNumber(h);
            var l = this.calculateBitsNeeded(a, u, f, c);
            if (!this.willFit(l, c, r)) throw new $2be8636d379871d6$var$ho("Data too big for requested version");
        } else c = this.recommendVersion(r, a, u, f);
        var d = new $2be8636d379871d6$var$S();
        d.appendBitArray(u);
        var p = a === $2be8636d379871d6$var$Wr.BYTE ? f.getSizeInBytes() : e.length;
        this.appendLengthInfo(p, c, a, d), d.appendBitArray(f);
        var g = c.getECBlocksForLevel(r), y = c.getTotalCodewords() - g.getTotalECCodewords();
        this.terminateBits(y, d);
        var w = this.interleaveWithECBytes(d, c.getTotalCodewords(), y, g.getNumBlocks()), _ = new $2be8636d379871d6$var$co();
        _.setECLevel(r), _.setMode(a), _.setVersion(c);
        var v = c.getDimensionForVersion(), m = new $2be8636d379871d6$var$so(v, v), A = this.chooseMaskPattern(w, r, c, m);
        return _.setMaskPattern(A), $2be8636d379871d6$var$lo.buildMatrix(w, r, c, A, m), _.setMatrix(m), _;
    }, t.recommendVersion = function(t, e, r, n) {
        var o = this.calculateBitsNeeded(e, r, n, $2be8636d379871d6$var$Fr.getVersionForNumber(1)), i = this.chooseVersion(o, t), a = this.calculateBitsNeeded(e, r, n, i);
        return this.chooseVersion(a, t);
    }, t.calculateBitsNeeded = function(t, e, r, n) {
        return e.getSize() + t.getCharacterCountBits(n) + r.getSize();
    }, t.getAlphanumericCode = function(e) {
        return e < t.ALPHANUMERIC_TABLE.length ? t.ALPHANUMERIC_TABLE[e] : -1;
    }, t.chooseMode = function(e, r) {
        if (void 0 === r && (r = null), $2be8636d379871d6$var$P.SJIS.getName() === r && this.isOnlyDoubleByteKanji(e)) return $2be8636d379871d6$var$Wr.KANJI;
        for(var n = !1, o = !1, i = 0, a = e.length; i < a; ++i){
            var u = e.charAt(i);
            if (t.isDigit(u)) n = !0;
            else {
                if (-1 === this.getAlphanumericCode(u.charCodeAt(0))) return $2be8636d379871d6$var$Wr.BYTE;
                o = !0;
            }
        }
        return o ? $2be8636d379871d6$var$Wr.ALPHANUMERIC : n ? $2be8636d379871d6$var$Wr.NUMERIC : $2be8636d379871d6$var$Wr.BYTE;
    }, t.isOnlyDoubleByteKanji = function(t) {
        var e;
        try {
            e = $2be8636d379871d6$var$L.encode(t, $2be8636d379871d6$var$P.SJIS);
        } catch (t) {
            return !1;
        }
        var r = e.length;
        if (r % 2 != 0) return !1;
        for(var n = 0; n < r; n += 2){
            var o = 255 & e[n];
            if ((o < 129 || o > 159) && (o < 224 || o > 235)) return !1;
        }
        return !0;
    }, t.chooseMaskPattern = function(t, e, r, n) {
        for(var o = Number.MAX_SAFE_INTEGER, i = -1, a = 0; a < $2be8636d379871d6$var$co.NUM_MASK_PATTERNS; a++){
            $2be8636d379871d6$var$lo.buildMatrix(t, e, r, a, n);
            var u = this.calculateMaskPenalty(n);
            u < o && (o = u, i = a);
        }
        return i;
    }, t.chooseVersion = function(e, r) {
        for(var n = 1; n <= 40; n++){
            var o = $2be8636d379871d6$var$Fr.getVersionForNumber(n);
            if (t.willFit(e, o, r)) return o;
        }
        throw new $2be8636d379871d6$var$ho("Data too big");
    }, t.willFit = function(t, e, r) {
        return e.getTotalCodewords() - e.getECBlocksForLevel(r).getTotalECCodewords() >= (t + 7) / 8;
    }, t.terminateBits = function(t, e) {
        var r = 8 * t;
        if (e.getSize() > r) throw new $2be8636d379871d6$var$ho("data bits cannot fit in the QR Code" + e.getSize() + " > " + r);
        for(var n = 0; n < 4 && e.getSize() < r; ++n)e.appendBit(!1);
        var o = 7 & e.getSize();
        if (o > 0) for(n = o; n < 8; n++)e.appendBit(!1);
        var i = t - e.getSizeInBytes();
        for(n = 0; n < i; ++n)e.appendBits(0 == (1 & n) ? 236 : 17, 8);
        if (e.getSize() !== r) throw new $2be8636d379871d6$var$ho("Bits size does not equal capacity");
    }, t.getNumDataBytesAndNumECBytesForBlockID = function(t, e, r, n, o, i) {
        if (n >= r) throw new $2be8636d379871d6$var$ho("Block ID too large");
        var a = t % r, u = r - a, s = Math.floor(t / r), c = s + 1, f = Math.floor(e / r), h = f + 1, l = s - f, d = c - h;
        if (l !== d) throw new $2be8636d379871d6$var$ho("EC bytes mismatch");
        if (r !== u + a) throw new $2be8636d379871d6$var$ho("RS blocks mismatch");
        if (t !== (f + l) * u + (h + d) * a) throw new $2be8636d379871d6$var$ho("Total bytes mismatch");
        n < u ? (o[0] = f, i[0] = l) : (o[0] = h, i[0] = d);
    }, t.interleaveWithECBytes = function(e, r, n, o) {
        var i, a, u, s;
        if (e.getSizeInBytes() !== n) throw new $2be8636d379871d6$var$ho("Number of bits and data bytes does not match");
        for(var c = 0, f = 0, h = 0, l = new Array(), d = 0; d < o; ++d){
            var p = new Int32Array(1), g = new Int32Array(1);
            t.getNumDataBytesAndNumECBytesForBlockID(r, n, o, d, p, g);
            var y = p[0], w = new Uint8Array(y);
            e.toBytes(8 * c, w, 0, y);
            var _ = t.generateECBytes(w, g[0]);
            l.push(new $2be8636d379871d6$var$po(w, _)), f = Math.max(f, y), h = Math.max(h, _.length), c += p[0];
        }
        if (n !== c) throw new $2be8636d379871d6$var$ho("Data bytes does not match offset");
        var v = new $2be8636d379871d6$var$S();
        for(d = 0; d < f; ++d)try {
            for(var m = (i = void 0, $2be8636d379871d6$var$go(l)), A = m.next(); !A.done; A = m.next())d < (w = A.value.getDataBytes()).length && v.appendBits(w[d], 8);
        } catch (t) {
            i = {
                error: t
            };
        } finally{
            try {
                A && !A.done && (a = m.return) && a.call(m);
            } finally{
                if (i) throw i.error;
            }
        }
        for(d = 0; d < h; ++d)try {
            for(var E = (u = void 0, $2be8636d379871d6$var$go(l)), C = E.next(); !C.done; C = E.next())d < (_ = C.value.getErrorCorrectionBytes()).length && v.appendBits(_[d], 8);
        } catch (t) {
            u = {
                error: t
            };
        } finally{
            try {
                C && !C.done && (s = E.return) && s.call(E);
            } finally{
                if (u) throw u.error;
            }
        }
        if (r !== v.getSizeInBytes()) throw new $2be8636d379871d6$var$ho("Interleaving error: " + r + " and " + v.getSizeInBytes() + " differ.");
        return v;
    }, t.generateECBytes = function(t, e) {
        for(var r = t.length, n = new Int32Array(r + e), o = 0; o < r; o++)n[o] = 255 & t[o];
        new $2be8636d379871d6$var$io($2be8636d379871d6$var$lt.QR_CODE_FIELD_256).encode(n, e);
        var i = new Uint8Array(e);
        for(o = 0; o < e; o++)i[o] = n[r + o];
        return i;
    }, t.appendModeInfo = function(t, e) {
        e.appendBits(t.getBits(), 4);
    }, t.appendLengthInfo = function(t, e, r, n) {
        var o = r.getCharacterCountBits(e);
        if (t >= 1 << o) throw new $2be8636d379871d6$var$ho(t + " is bigger than " + ((1 << o) - 1));
        n.appendBits(t, o);
    }, t.appendBytes = function(e, r, n, o) {
        switch(r){
            case $2be8636d379871d6$var$Wr.NUMERIC:
                t.appendNumericBytes(e, n);
                break;
            case $2be8636d379871d6$var$Wr.ALPHANUMERIC:
                t.appendAlphanumericBytes(e, n);
                break;
            case $2be8636d379871d6$var$Wr.BYTE:
                t.append8BitBytes(e, n, o);
                break;
            case $2be8636d379871d6$var$Wr.KANJI:
                t.appendKanjiBytes(e, n);
                break;
            default:
                throw new $2be8636d379871d6$var$ho("Invalid mode: " + r);
        }
    }, t.getDigit = function(t) {
        return t.charCodeAt(0) - 48;
    }, t.isDigit = function(e) {
        var r = t.getDigit(e);
        return r >= 0 && r <= 9;
    }, t.appendNumericBytes = function(e, r) {
        for(var n = e.length, o = 0; o < n;){
            var i = t.getDigit(e.charAt(o));
            if (o + 2 < n) {
                var a = t.getDigit(e.charAt(o + 1)), u = t.getDigit(e.charAt(o + 2));
                r.appendBits(100 * i + 10 * a + u, 10), o += 3;
            } else if (o + 1 < n) {
                a = t.getDigit(e.charAt(o + 1));
                r.appendBits(10 * i + a, 7), o += 2;
            } else r.appendBits(i, 4), o++;
        }
    }, t.appendAlphanumericBytes = function(e, r) {
        for(var n = e.length, o = 0; o < n;){
            var i = t.getAlphanumericCode(e.charCodeAt(o));
            if (-1 === i) throw new $2be8636d379871d6$var$ho();
            if (o + 1 < n) {
                var a = t.getAlphanumericCode(e.charCodeAt(o + 1));
                if (-1 === a) throw new $2be8636d379871d6$var$ho();
                r.appendBits(45 * i + a, 11), o += 2;
            } else r.appendBits(i, 6), o++;
        }
    }, t.append8BitBytes = function(t, e, r) {
        var n;
        try {
            n = $2be8636d379871d6$var$L.encode(t, r);
        } catch (t) {
            throw new $2be8636d379871d6$var$ho(t);
        }
        for(var o = 0, i = n.length; o !== i; o++){
            var a = n[o];
            e.appendBits(a, 8);
        }
    }, t.appendKanjiBytes = function(t, e) {
        var r;
        try {
            r = $2be8636d379871d6$var$L.encode(t, $2be8636d379871d6$var$P.SJIS);
        } catch (t) {
            throw new $2be8636d379871d6$var$ho(t);
        }
        for(var n = r.length, o = 0; o < n; o += 2){
            var i = (255 & r[o]) << 8 & 4294967295 | 255 & r[o + 1], a = -1;
            if (i >= 33088 && i <= 40956 ? a = i - 33088 : i >= 57408 && i <= 60351 && (a = i - 49472), -1 === a) throw new $2be8636d379871d6$var$ho("Invalid byte sequence");
            var u = 192 * (a >> 8) + (255 & a);
            e.appendBits(u, 13);
        }
    }, t.appendECI = function(t, e) {
        e.appendBits($2be8636d379871d6$var$Wr.ECI.getBits(), 4), e.appendBits(t.getValue(), 8);
    }, t.ALPHANUMERIC_TABLE = Int32Array.from([
        -1,
        -1,
        -1,
        -1,
        -1,
        -1,
        -1,
        -1,
        -1,
        -1,
        -1,
        -1,
        -1,
        -1,
        -1,
        -1,
        -1,
        -1,
        -1,
        -1,
        -1,
        -1,
        -1,
        -1,
        -1,
        -1,
        -1,
        -1,
        -1,
        -1,
        -1,
        -1,
        36,
        -1,
        -1,
        -1,
        37,
        38,
        -1,
        -1,
        -1,
        -1,
        39,
        40,
        -1,
        41,
        42,
        43,
        0,
        1,
        2,
        3,
        4,
        5,
        6,
        7,
        8,
        9,
        44,
        -1,
        -1,
        -1,
        -1,
        -1,
        -1,
        10,
        11,
        12,
        13,
        14,
        15,
        16,
        17,
        18,
        19,
        20,
        21,
        22,
        23,
        24,
        25,
        26,
        27,
        28,
        29,
        30,
        31,
        32,
        33,
        34,
        35,
        -1,
        -1,
        -1,
        -1,
        -1
    ]), t.DEFAULT_BYTE_MODE_ENCODING = $2be8636d379871d6$var$P.UTF8.getName();
}();
var $2be8636d379871d6$var$yo = function() {
    var t = function(e, r) {
        return t = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(t, e) {
            t.__proto__ = e;
        } || function(t, e) {
            for(var r in e)e.hasOwnProperty(r) && (t[r] = e[r]);
        }, t(e, r);
    };
    return function(e, r) {
        function n() {
            this.constructor = e;
        }
        t(e, r), e.prototype = null === r ? Object.create(r) : (n.prototype = r.prototype, new n());
    };
}();
!function(t) {
    function e(e, r, n, o, i, a, u, s) {
        var c = t.call(this, a, u) || this;
        if (c.yuvData = e, c.dataWidth = r, c.dataHeight = n, c.left = o, c.top = i, o + a > r || i + u > n) throw new $2be8636d379871d6$var$l("Crop rectangle does not fit within image data.");
        return s && c.reverseHorizontal(a, u), c;
    }
    $2be8636d379871d6$var$yo(e, t), e.prototype.getRow = function(t, e) {
        if (t < 0 || t >= this.getHeight()) throw new $2be8636d379871d6$var$l("Requested row is outside the image: " + t);
        var r = this.getWidth();
        (null == e || e.length < r) && (e = new Uint8ClampedArray(r));
        var n = (t + this.top) * this.dataWidth + this.left;
        return $2be8636d379871d6$var$w.arraycopy(this.yuvData, n, e, 0, r), e;
    }, e.prototype.getMatrix = function() {
        var t = this.getWidth(), e = this.getHeight();
        if (t === this.dataWidth && e === this.dataHeight) return this.yuvData;
        var r = t * e, n = new Uint8ClampedArray(r), o = this.top * this.dataWidth + this.left;
        if (t === this.dataWidth) return $2be8636d379871d6$var$w.arraycopy(this.yuvData, o, n, 0, r), n;
        for(var i = 0; i < e; i++){
            var a = i * t;
            $2be8636d379871d6$var$w.arraycopy(this.yuvData, o, n, a, t), o += this.dataWidth;
        }
        return n;
    }, e.prototype.isCropSupported = function() {
        return !0;
    }, e.prototype.crop = function(t, r, n, o) {
        return new e(this.yuvData, this.dataWidth, this.dataHeight, this.left + t, this.top + r, n, o, !1);
    }, e.prototype.renderThumbnail = function() {
        for(var t = this.getWidth() / e.THUMBNAIL_SCALE_FACTOR, r = this.getHeight() / e.THUMBNAIL_SCALE_FACTOR, n = new Int32Array(t * r), o = this.yuvData, i = this.top * this.dataWidth + this.left, a = 0; a < r; a++){
            for(var u = a * t, s = 0; s < t; s++){
                var c = 255 & o[i + s * e.THUMBNAIL_SCALE_FACTOR];
                n[u + s] = 4278190080 | 65793 * c;
            }
            i += this.dataWidth * e.THUMBNAIL_SCALE_FACTOR;
        }
        return n;
    }, e.prototype.getThumbnailWidth = function() {
        return this.getWidth() / e.THUMBNAIL_SCALE_FACTOR;
    }, e.prototype.getThumbnailHeight = function() {
        return this.getHeight() / e.THUMBNAIL_SCALE_FACTOR;
    }, e.prototype.reverseHorizontal = function(t, e) {
        for(var r = this.yuvData, n = 0, o = this.top * this.dataWidth + this.left; n < e; n++, o += this.dataWidth)for(var i = o + t / 2, a = o, u = o + t - 1; a < i; a++, u--){
            var s = r[a];
            r[a] = r[u], r[u] = s;
        }
    }, e.prototype.invert = function() {
        return new $2be8636d379871d6$var$Y(this);
    }, e.THUMBNAIL_SCALE_FACTOR = 2;
}($2be8636d379871d6$var$j);
var $2be8636d379871d6$var$wo = function() {
    var t = function(e, r) {
        return t = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(t, e) {
            t.__proto__ = e;
        } || function(t, e) {
            for(var r in e)e.hasOwnProperty(r) && (t[r] = e[r]);
        }, t(e, r);
    };
    return function(e, r) {
        function n() {
            this.constructor = e;
        }
        t(e, r), e.prototype = null === r ? Object.create(r) : (n.prototype = r.prototype, new n());
    };
}();
!function(t) {
    function e(e, r, n, o, i, a, u) {
        var s = t.call(this, r, n) || this;
        if (s.dataWidth = o, s.dataHeight = i, s.left = a, s.top = u, 4 === e.BYTES_PER_ELEMENT) {
            for(var c = r * n, f = new Uint8ClampedArray(c), h = 0; h < c; h++){
                var d = e[h], p = d >> 16 & 255, g = d >> 7 & 510, y = 255 & d;
                f[h] = (p + g + y) / 4 & 255;
            }
            s.luminances = f;
        } else s.luminances = e;
        if (void 0 === o && (s.dataWidth = r), void 0 === i && (s.dataHeight = n), void 0 === a && (s.left = 0), void 0 === u && (s.top = 0), s.left + r > s.dataWidth || s.top + n > s.dataHeight) throw new $2be8636d379871d6$var$l("Crop rectangle does not fit within image data.");
        return s;
    }
    $2be8636d379871d6$var$wo(e, t), e.prototype.getRow = function(t, e) {
        if (t < 0 || t >= this.getHeight()) throw new $2be8636d379871d6$var$l("Requested row is outside the image: " + t);
        var r = this.getWidth();
        (null == e || e.length < r) && (e = new Uint8ClampedArray(r));
        var n = (t + this.top) * this.dataWidth + this.left;
        return $2be8636d379871d6$var$w.arraycopy(this.luminances, n, e, 0, r), e;
    }, e.prototype.getMatrix = function() {
        var t = this.getWidth(), e = this.getHeight();
        if (t === this.dataWidth && e === this.dataHeight) return this.luminances;
        var r = t * e, n = new Uint8ClampedArray(r), o = this.top * this.dataWidth + this.left;
        if (t === this.dataWidth) return $2be8636d379871d6$var$w.arraycopy(this.luminances, o, n, 0, r), n;
        for(var i = 0; i < e; i++){
            var a = i * t;
            $2be8636d379871d6$var$w.arraycopy(this.luminances, o, n, a, t), o += this.dataWidth;
        }
        return n;
    }, e.prototype.isCropSupported = function() {
        return !0;
    }, e.prototype.crop = function(t, r, n, o) {
        return new e(this.luminances, n, o, this.dataWidth, this.dataHeight, this.left + t, this.top + r);
    }, e.prototype.invert = function() {
        return new $2be8636d379871d6$var$Y(this);
    };
}($2be8636d379871d6$var$j);
var $2be8636d379871d6$var$_o = function() {
    var t = function(e, r) {
        return t = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(t, e) {
            t.__proto__ = e;
        } || function(t, e) {
            for(var r in e)e.hasOwnProperty(r) && (t[r] = e[r]);
        }, t(e, r);
    };
    return function(e, r) {
        function n() {
            this.constructor = e;
        }
        t(e, r), e.prototype = null === r ? Object.create(r) : (n.prototype = r.prototype, new n());
    };
}();
!function(t) {
    function e() {
        return null !== t && t.apply(this, arguments) || this;
    }
    $2be8636d379871d6$var$_o(e, t), e.forName = function(t) {
        return this.getCharacterSetECIByName(t);
    };
}($2be8636d379871d6$var$P);
var $2be8636d379871d6$var$vo = function() {
    function t(t) {
        this.previous = t;
    }
    return t.prototype.getPrevious = function() {
        return this.previous;
    }, t;
}(), $2be8636d379871d6$var$mo = function() {
    var t = function(e, r) {
        return t = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(t, e) {
            t.__proto__ = e;
        } || function(t, e) {
            for(var r in e)e.hasOwnProperty(r) && (t[r] = e[r]);
        }, t(e, r);
    };
    return function(e, r) {
        function n() {
            this.constructor = e;
        }
        t(e, r), e.prototype = null === r ? Object.create(r) : (n.prototype = r.prototype, new n());
    };
}(), $2be8636d379871d6$var$Ao = function(t) {
    function e(e, r, n) {
        var o = t.call(this, e) || this;
        return o.value = r, o.bitCount = n, o;
    }
    return $2be8636d379871d6$var$mo(e, t), e.prototype.appendTo = function(t, e) {
        t.appendBits(this.value, this.bitCount);
    }, e.prototype.add = function(t, r) {
        return new e(this, t, r);
    }, e.prototype.addBinaryShift = function(t, r) {
        return console.warn("addBinaryShift on SimpleToken, this simply returns a copy of this token"), new e(this, t, r);
    }, e.prototype.toString = function() {
        var t = this.value & (1 << this.bitCount) - 1;
        return t |= 1 << this.bitCount, "<" + $2be8636d379871d6$var$I.toBinaryString(t | 1 << this.bitCount).substring(1) + ">";
    }, e;
}($2be8636d379871d6$var$vo), $2be8636d379871d6$var$Eo = function() {
    var t = function(e, r) {
        return t = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(t, e) {
            t.__proto__ = e;
        } || function(t, e) {
            for(var r in e)e.hasOwnProperty(r) && (t[r] = e[r]);
        }, t(e, r);
    };
    return function(e, r) {
        function n() {
            this.constructor = e;
        }
        t(e, r), e.prototype = null === r ? Object.create(r) : (n.prototype = r.prototype, new n());
    };
}();
!function(t) {
    function e(e, r, n) {
        var o = t.call(this, e, 0, 0) || this;
        return o.binaryShiftStart = r, o.binaryShiftByteCount = n, o;
    }
    $2be8636d379871d6$var$Eo(e, t), e.prototype.appendTo = function(t, e) {
        for(var r = 0; r < this.binaryShiftByteCount; r++)(0 === r || 31 === r && this.binaryShiftByteCount <= 62) && (t.appendBits(31, 5), this.binaryShiftByteCount > 62 ? t.appendBits(this.binaryShiftByteCount - 31, 16) : 0 === r ? t.appendBits(Math.min(this.binaryShiftByteCount, 31), 5) : t.appendBits(this.binaryShiftByteCount - 31, 5)), t.appendBits(e[this.binaryShiftStart + r], 8);
    }, e.prototype.addBinaryShift = function(t, r) {
        return new e(this, t, r);
    }, e.prototype.toString = function() {
        return "<" + this.binaryShiftStart + "::" + (this.binaryShiftStart + this.binaryShiftByteCount - 1) + ">";
    };
}($2be8636d379871d6$var$Ao);
new $2be8636d379871d6$var$Ao(null, 0, 0);
var $2be8636d379871d6$var$Co = function(t) {
    var e = "function" == typeof Symbol && Symbol.iterator, r = e && t[e], n = 0;
    if (r) return r.call(t);
    if (t && "number" == typeof t.length) return {
        next: function() {
            return t && n >= t.length && (t = void 0), {
                value: t && t[n++],
                done: !t
            };
        }
    };
    throw new TypeError(e ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
!function(t) {
    var e, r;
    try {
        for(var n = $2be8636d379871d6$var$Co(t), o = n.next(); !o.done; o = n.next()){
            var i = o.value;
            $2be8636d379871d6$var$C.fill(i, -1);
        }
    } catch (t) {
        e = {
            error: t
        };
    } finally{
        try {
            o && !o.done && (r = n.return) && r.call(n);
        } finally{
            if (e) throw e.error;
        }
    }
    t[0][4] = 0, t[1][4] = 0, t[1][0] = 28, t[3][4] = 0, t[2][4] = 0, t[2][0] = 15;
}($2be8636d379871d6$var$C.createInt32Array(6, 6)), function(t) {
    var e = $2be8636d379871d6$var$F.getCharCode(" "), r = $2be8636d379871d6$var$F.getCharCode("."), n = $2be8636d379871d6$var$F.getCharCode(",");
    t[0][e] = 1;
    for(var o = $2be8636d379871d6$var$F.getCharCode("Z"), i = $2be8636d379871d6$var$F.getCharCode("A"), a = i; a <= o; a++)t[0][a] = a - i + 2;
    t[1][e] = 1;
    var u = $2be8636d379871d6$var$F.getCharCode("z"), s = $2be8636d379871d6$var$F.getCharCode("a");
    for(a = s; a <= u; a++)t[1][a] = a - s + 2;
    t[2][e] = 1;
    var c = $2be8636d379871d6$var$F.getCharCode("9"), f = $2be8636d379871d6$var$F.getCharCode("0");
    for(a = f; a <= c; a++)t[2][a] = a - f + 2;
    t[2][n] = 12, t[2][r] = 13;
    for(var h = [
        "\x00",
        " ",
        "\x01",
        "\x02",
        "\x03",
        "\x04",
        "\x05",
        "\x06",
        "\x07",
        "\b",
        "	",
        "\n",
        "\v",
        "\f",
        "\r",
        "\x1b",
        "\x1c",
        "\x1d",
        "\x1e",
        "\x1f",
        "@",
        "\\",
        "^",
        "_",
        "`",
        "|",
        "~",
        "\x7f"
    ], l = 0; l < h.length; l++)t[3][$2be8636d379871d6$var$F.getCharCode(h[l])] = l;
    var d = [
        "\x00",
        "\r",
        "\x00",
        "\x00",
        "\x00",
        "\x00",
        "!",
        "'",
        "#",
        "$",
        "%",
        "&",
        "'",
        "(",
        ")",
        "*",
        "+",
        ",",
        "-",
        ".",
        "/",
        ":",
        ";",
        "<",
        "=",
        ">",
        "?",
        "[",
        "]",
        "{",
        "}"
    ];
    for(l = 0; l < d.length; l++)$2be8636d379871d6$var$F.getCharCode(d[l]) > 0 && (t[4][$2be8636d379871d6$var$F.getCharCode(d[l])] = l);
}($2be8636d379871d6$var$C.createInt32Array(5, 256));
var $2be8636d379871d6$var$Io = function() {
    var t = function(e, r) {
        return t = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(t, e) {
            t.__proto__ = e;
        } || function(t, e) {
            for(var r in e)e.hasOwnProperty(r) && (t[r] = e[r]);
        }, t(e, r);
    };
    return function(e, r) {
        function n() {
            this.constructor = e;
        }
        t(e, r), e.prototype = null === r ? Object.create(r) : (n.prototype = r.prototype, new n());
    };
}(), $2be8636d379871d6$var$So = function(t) {
    function e(r) {
        var n = t.call(this, r.width, r.height) || this;
        return n.canvas = r, n.buffer = e.makeBufferFromCanvasImageData(r), n;
    }
    return $2be8636d379871d6$var$Io(e, t), e.makeBufferFromCanvasImageData = function(t) {
        var r = t.getContext("2d");
        if (!r) throw new Error("Couldn't get canvas context.");
        var n = r.getImageData(0, 0, t.width, t.height);
        return e.toGrayscaleBuffer(n.data, t.width, t.height);
    }, e.toGrayscaleBuffer = function(t, e, r) {
        for(var n = new Uint8ClampedArray(e * r), o = 0, i = 0, a = t.length; o < a; o += 4, i++){
            var u = void 0;
            if (0 === t[o + 3]) u = 255;
            else u = 306 * t[o] + 601 * t[o + 1] + 117 * t[o + 2] + 512 >> 10;
            n[i] = u;
        }
        return n;
    }, e.prototype.getRow = function(t, e) {
        if (t < 0 || t >= this.getHeight()) throw new $2be8636d379871d6$var$l("Requested row is outside the image: " + t);
        var r = this.getWidth(), n = t * r;
        return null === e ? e = this.buffer.slice(n, n + r) : (e.length < r && (e = new Uint8ClampedArray(r)), e.set(this.buffer.slice(n, n + r))), e;
    }, e.prototype.getMatrix = function() {
        return this.buffer;
    }, e.prototype.isCropSupported = function() {
        return !0;
    }, e.prototype.crop = function(e, r, n, o) {
        return t.prototype.crop.call(this, e, r, n, o), this;
    }, e.prototype.isRotateSupported = function() {
        return !0;
    }, e.prototype.rotateCounterClockwise = function() {
        return this.rotate(-90), this;
    }, e.prototype.rotateCounterClockwise45 = function() {
        return this.rotate(-45), this;
    }, e.prototype.invert = function() {
        return new $2be8636d379871d6$var$Y(this);
    }, e.prototype.getTempCanvasElement = function() {
        if (null === this.tempCanvasElement) {
            var t = this.canvas.ownerDocument.createElement("canvas");
            t.width = this.canvas.width, t.height = this.canvas.height, this.tempCanvasElement = t;
        }
        return this.tempCanvasElement;
    }, e.prototype.rotate = function(t) {
        var r = this.getTempCanvasElement();
        if (!r) throw new Error("Could not create a Canvas element.");
        var n = t * e.DEGREE_TO_RADIANS, o = this.canvas.width, i = this.canvas.height, a = Math.ceil(Math.abs(Math.cos(n)) * o + Math.abs(Math.sin(n)) * i), u = Math.ceil(Math.abs(Math.sin(n)) * o + Math.abs(Math.cos(n)) * i);
        r.width = a, r.height = u;
        var s = r.getContext("2d");
        if (!s) throw new Error("Could not create a Convas Context element.");
        return s.translate(a / 2, u / 2), s.rotate(n), s.drawImage(this.canvas, o / -2, i / -2), this.buffer = e.makeBufferFromCanvasImageData(r), this;
    }, e.DEGREE_TO_RADIANS = Math.PI / 180, e;
}($2be8636d379871d6$var$j);
function $2be8636d379871d6$var$Oo() {
    return "undefined" != typeof navigator;
}
function $2be8636d379871d6$var$To() {
    return !!($2be8636d379871d6$var$Oo() && navigator.mediaDevices && navigator.mediaDevices.enumerateDevices);
}
var $2be8636d379871d6$var$bo = function() {
    return $2be8636d379871d6$var$bo = Object.assign || function(t) {
        for(var e, r = 1, n = arguments.length; r < n; r++)for(var o in e = arguments[r])Object.prototype.hasOwnProperty.call(e, o) && (t[o] = e[o]);
        return t;
    }, $2be8636d379871d6$var$bo.apply(this, arguments);
}, $2be8636d379871d6$var$Ro = function(t, e, r, n) {
    return new (r || (r = Promise))(function(o, i) {
        function a(t) {
            try {
                s(n.next(t));
            } catch (t) {
                i(t);
            }
        }
        function u(t) {
            try {
                s(n.throw(t));
            } catch (t) {
                i(t);
            }
        }
        function s(t) {
            var e;
            t.done ? o(t.value) : (e = t.value, e instanceof r ? e : new r(function(t) {
                t(e);
            })).then(a, u);
        }
        s((n = n.apply(t, e || [])).next());
    });
}, $2be8636d379871d6$var$No = function(t, e) {
    var r, n, o, i, a = {
        label: 0,
        sent: function() {
            if (1 & o[0]) throw o[1];
            return o[1];
        },
        trys: [],
        ops: []
    };
    return i = {
        next: u(0),
        throw: u(1),
        return: u(2)
    }, "function" == typeof Symbol && (i[Symbol.iterator] = function() {
        return this;
    }), i;
    function u(i) {
        return function(u) {
            return function(i) {
                if (r) throw new TypeError("Generator is already executing.");
                for(; a;)try {
                    if (r = 1, n && (o = 2 & i[0] ? n.return : i[0] ? n.throw || ((o = n.return) && o.call(n), 0) : n.next) && !(o = o.call(n, i[1])).done) return o;
                    switch(n = 0, o && (i = [
                        2 & i[0],
                        o.value
                    ]), i[0]){
                        case 0:
                        case 1:
                            o = i;
                            break;
                        case 4:
                            return a.label++, {
                                value: i[1],
                                done: !1
                            };
                        case 5:
                            a.label++, n = i[1], i = [
                                0
                            ];
                            continue;
                        case 7:
                            i = a.ops.pop(), a.trys.pop();
                            continue;
                        default:
                            if (!(o = a.trys, (o = o.length > 0 && o[o.length - 1]) || 6 !== i[0] && 2 !== i[0])) {
                                a = 0;
                                continue;
                            }
                            if (3 === i[0] && (!o || i[1] > o[0] && i[1] < o[3])) {
                                a.label = i[1];
                                break;
                            }
                            if (6 === i[0] && a.label < o[1]) {
                                a.label = o[1], o = i;
                                break;
                            }
                            if (o && a.label < o[2]) {
                                a.label = o[2], a.ops.push(i);
                                break;
                            }
                            o[2] && a.ops.pop(), a.trys.pop();
                            continue;
                    }
                    i = e.call(t, a);
                } catch (t) {
                    i = [
                        6,
                        t
                    ], n = 0;
                } finally{
                    r = o = 0;
                }
                if (5 & i[0]) throw i[1];
                return {
                    value: i[0] ? i[1] : void 0,
                    done: !0
                };
            }([
                i,
                u
            ]);
        };
    }
}, $2be8636d379871d6$var$Do = function(t) {
    var e = "function" == typeof Symbol && Symbol.iterator, r = e && t[e], n = 0;
    if (r) return r.call(t);
    if (t && "number" == typeof t.length) return {
        next: function() {
            return t && n >= t.length && (t = void 0), {
                value: t && t[n++],
                done: !t
            };
        }
    };
    throw new TypeError(e ? "Object is not iterable." : "Symbol.iterator is not defined.");
}, $2be8636d379871d6$var$Po = {
    delayBetweenScanAttempts: 500,
    delayBetweenScanSuccess: 500,
    tryPlayVideoTimeout: 5e3
}, $2be8636d379871d6$var$Mo = function() {
    function t(t, e, r) {
        void 0 === e && (e = new Map()), void 0 === r && (r = {}), this.reader = t, this.hints = e, this.options = $2be8636d379871d6$var$bo($2be8636d379871d6$var$bo({}, $2be8636d379871d6$var$Po), r);
    }
    return Object.defineProperty(t.prototype, "possibleFormats", {
        set: function(t) {
            this.hints.set($2be8636d379871d6$var$T.POSSIBLE_FORMATS, t);
        },
        enumerable: !1,
        configurable: !0
    }), t.addVideoSource = function(t, e) {
        try {
            t.srcObject = e;
        } catch (r) {
            t.src = URL.createObjectURL(e);
        }
    }, t.mediaStreamSetTorch = function(t, e) {
        return $2be8636d379871d6$var$Ro(this, void 0, void 0, function() {
            return $2be8636d379871d6$var$No(this, function(r) {
                switch(r.label){
                    case 0:
                        return [
                            4,
                            t.applyConstraints({
                                advanced: [
                                    {
                                        fillLightMode: e ? "flash" : "off",
                                        torch: !!e
                                    }
                                ]
                            })
                        ];
                    case 1:
                        return r.sent(), [
                            2
                        ];
                }
            });
        });
    }, t.mediaStreamIsTorchCompatible = function(e) {
        var r, n, o = e.getVideoTracks();
        try {
            for(var i = $2be8636d379871d6$var$Do(o), a = i.next(); !a.done; a = i.next()){
                var u = a.value;
                if (t.mediaStreamIsTorchCompatibleTrack(u)) return !0;
            }
        } catch (t) {
            r = {
                error: t
            };
        } finally{
            try {
                a && !a.done && (n = i.return) && n.call(i);
            } finally{
                if (r) throw r.error;
            }
        }
        return !1;
    }, t.mediaStreamIsTorchCompatibleTrack = function(t) {
        try {
            return "torch" in t.getCapabilities();
        } catch (t) {
            return console.error(t), console.warn("Your browser may be not fully compatible with WebRTC and/or ImageCapture specs. Torch will not be available."), !1;
        }
    }, t.isVideoPlaying = function(t) {
        return t.currentTime > 0 && !t.paused && t.readyState > 2;
    }, t.getMediaElement = function(t, e) {
        var r = document.getElementById(t);
        if (!r) throw new $2be8636d379871d6$var$f("element with id '" + t + "' not found");
        if (r.nodeName.toLowerCase() !== e.toLowerCase()) throw new $2be8636d379871d6$var$f("element with id '" + t + "' must be an " + e + " element");
        return r;
    }, t.createVideoElement = function(e) {
        if (e instanceof HTMLVideoElement) return e;
        if ("string" == typeof e) return t.getMediaElement(e, "video");
        if (!e && "undefined" != typeof document) {
            var r = document.createElement("video");
            return r.width = 200, r.height = 200, r;
        }
        throw new Error("Couldn't get videoElement from videoSource!");
    }, t.prepareImageElement = function(e) {
        if (e instanceof HTMLImageElement) return e;
        if ("string" == typeof e) return t.getMediaElement(e, "img");
        if (void 0 === e) {
            var r = document.createElement("img");
            return r.width = 200, r.height = 200, r;
        }
        throw new Error("Couldn't get imageElement from imageSource!");
    }, t.prepareVideoElement = function(e) {
        var r = t.createVideoElement(e);
        return r.setAttribute("autoplay", "true"), r.setAttribute("muted", "true"), r.setAttribute("playsinline", "true"), r;
    }, t.isImageLoaded = function(t) {
        return !!t.complete && 0 !== t.naturalWidth;
    }, t.createBinaryBitmapFromCanvas = function(t) {
        var e = new $2be8636d379871d6$var$So(t), r = new $2be8636d379871d6$var$W(e);
        return new $2be8636d379871d6$var$d(r);
    }, t.drawImageOnCanvas = function(t, e) {
        t.drawImage(e, 0, 0);
    }, t.getMediaElementDimensions = function(t) {
        if (t instanceof HTMLVideoElement) return {
            height: t.videoHeight,
            width: t.videoWidth
        };
        if (t instanceof HTMLImageElement) return {
            height: t.naturalHeight || t.height,
            width: t.naturalWidth || t.width
        };
        throw new Error("Couldn't find the Source's dimentions!");
    }, t.createCaptureCanvas = function(e) {
        if (!e) throw new $2be8636d379871d6$var$f("Cannot create a capture canvas without a media element.");
        if ("undefined" == typeof document) throw new Error('The page "Document" is undefined, make sure you\'re running in a browser.');
        var r = document.createElement("canvas"), n = t.getMediaElementDimensions(e), o = n.width, i = n.height;
        return r.style.width = o + "px", r.style.height = i + "px", r.width = o, r.height = i, r;
    }, t.tryPlayVideo = function(e) {
        return $2be8636d379871d6$var$Ro(this, void 0, void 0, function() {
            var r;
            return $2be8636d379871d6$var$No(this, function(n) {
                switch(n.label){
                    case 0:
                        if (null == e ? void 0 : e.ended) return console.error("Trying to play video that has ended."), [
                            2,
                            !1
                        ];
                        if (t.isVideoPlaying(e)) return console.warn("Trying to play video that is already playing."), [
                            2,
                            !0
                        ];
                        n.label = 1;
                    case 1:
                        return n.trys.push([
                            1,
                            3,
                            ,
                            4
                        ]), [
                            4,
                            e.play()
                        ];
                    case 2:
                        return n.sent(), [
                            2,
                            !0
                        ];
                    case 3:
                        return r = n.sent(), console.warn("It was not possible to play the video.", r), [
                            2,
                            !1
                        ];
                    case 4:
                        return [
                            2
                        ];
                }
            });
        });
    }, t.createCanvasFromMediaElement = function(e) {
        var r = t.createCaptureCanvas(e), n = r.getContext("2d");
        if (!n) throw new Error("Couldn't find Canvas 2D Context.");
        return t.drawImageOnCanvas(n, e), r;
    }, t.createBinaryBitmapFromMediaElem = function(e) {
        var r = t.createCanvasFromMediaElement(e);
        return t.createBinaryBitmapFromCanvas(r);
    }, t.destroyImageElement = function(t) {
        t.src = "", t.removeAttribute("src"), t = void 0;
    }, t.listVideoInputDevices = function() {
        return $2be8636d379871d6$var$Ro(this, void 0, void 0, function() {
            var t, e, r, n, o, i, a, u, s, c, f, h;
            return $2be8636d379871d6$var$No(this, function(l) {
                switch(l.label){
                    case 0:
                        if (!$2be8636d379871d6$var$Oo()) throw new Error("Can't enumerate devices, navigator is not present.");
                        if (!$2be8636d379871d6$var$To()) throw new Error("Can't enumerate devices, method not supported.");
                        return [
                            4,
                            navigator.mediaDevices.enumerateDevices()
                        ];
                    case 1:
                        t = l.sent(), e = [];
                        try {
                            for(r = $2be8636d379871d6$var$Do(t), n = r.next(); !n.done; n = r.next())o = n.value, "videoinput" === (i = "video" === o.kind ? "videoinput" : o.kind) && (a = o.deviceId || o.id, u = o.label || "Video device " + (e.length + 1), s = o.groupId, c = {
                                deviceId: a,
                                label: u,
                                kind: i,
                                groupId: s
                            }, e.push(c));
                        } catch (t) {
                            f = {
                                error: t
                            };
                        } finally{
                            try {
                                n && !n.done && (h = r.return) && h.call(r);
                            } finally{
                                if (f) throw f.error;
                            }
                        }
                        return [
                            2,
                            e
                        ];
                }
            });
        });
    }, t.findDeviceById = function(e) {
        return $2be8636d379871d6$var$Ro(this, void 0, void 0, function() {
            var r;
            return $2be8636d379871d6$var$No(this, function(n) {
                switch(n.label){
                    case 0:
                        return [
                            4,
                            t.listVideoInputDevices()
                        ];
                    case 1:
                        return (r = n.sent()) ? [
                            2,
                            r.find(function(t) {
                                return t.deviceId === e;
                            })
                        ] : [
                            2
                        ];
                }
            });
        });
    }, t.cleanVideoSource = function(t) {
        if (t) {
            try {
                t.srcObject = null;
            } catch (e) {
                t.src = "";
            }
            t && t.removeAttribute("src");
        }
    }, t.playVideoOnLoadAsync = function(e, r) {
        return $2be8636d379871d6$var$Ro(this, void 0, void 0, function() {
            return $2be8636d379871d6$var$No(this, function(n) {
                switch(n.label){
                    case 0:
                        return [
                            4,
                            t.tryPlayVideo(e)
                        ];
                    case 1:
                        return n.sent() ? [
                            2,
                            !0
                        ] : [
                            2,
                            new Promise(function(n, o) {
                                var i = setTimeout(function() {
                                    t.isVideoPlaying(e) || (o(!1), e.removeEventListener("canplay", a));
                                }, r), a = function() {
                                    t.tryPlayVideo(e).then(function(t) {
                                        clearTimeout(i), e.removeEventListener("canplay", a), n(t);
                                    });
                                };
                                e.addEventListener("canplay", a);
                            })
                        ];
                }
            });
        });
    }, t.attachStreamToVideo = function(e, r, n) {
        return void 0 === n && (n = 5e3), $2be8636d379871d6$var$Ro(this, void 0, void 0, function() {
            var o;
            return $2be8636d379871d6$var$No(this, function(i) {
                switch(i.label){
                    case 0:
                        return o = t.prepareVideoElement(r), t.addVideoSource(o, e), [
                            4,
                            t.playVideoOnLoadAsync(o, n)
                        ];
                    case 1:
                        return i.sent(), [
                            2,
                            o
                        ];
                }
            });
        });
    }, t._waitImageLoad = function(e) {
        return new Promise(function(r, n) {
            var o = setTimeout(function() {
                t.isImageLoaded(e) || (e.removeEventListener("load", i), n());
            }, 1e4), i = function() {
                clearTimeout(o), e.removeEventListener("load", i), r();
            };
            e.addEventListener("load", i);
        });
    }, t.checkCallbackFnOrThrow = function(t) {
        if (!t) throw new $2be8636d379871d6$var$f("`callbackFn` is a required parameter, you cannot capture results without it.");
    }, t.disposeMediaStream = function(t) {
        t.getVideoTracks().forEach(function(t) {
            return t.stop();
        }), t = void 0;
    }, t.prototype.decode = function(e) {
        var r = t.createCanvasFromMediaElement(e);
        return this.decodeFromCanvas(r);
    }, t.prototype.decodeBitmap = function(t) {
        return this.reader.decode(t, this.hints);
    }, t.prototype.decodeFromCanvas = function(e) {
        var r = t.createBinaryBitmapFromCanvas(e);
        return this.decodeBitmap(r);
    }, t.prototype.decodeFromImageElement = function(e) {
        return $2be8636d379871d6$var$Ro(this, void 0, void 0, function() {
            var r;
            return $2be8636d379871d6$var$No(this, function(n) {
                switch(n.label){
                    case 0:
                        if (!e) throw new $2be8636d379871d6$var$f("An image element must be provided.");
                        return r = t.prepareImageElement(e), [
                            4,
                            this._decodeOnLoadImage(r)
                        ];
                    case 1:
                        return [
                            2,
                            n.sent()
                        ];
                }
            });
        });
    }, t.prototype.decodeFromImageUrl = function(e) {
        return $2be8636d379871d6$var$Ro(this, void 0, void 0, function() {
            var r;
            return $2be8636d379871d6$var$No(this, function(n) {
                switch(n.label){
                    case 0:
                        if (!e) throw new $2be8636d379871d6$var$f("An URL must be provided.");
                        (r = t.prepareImageElement()).src = e, n.label = 1;
                    case 1:
                        return n.trys.push([
                            1,
                            ,
                            3,
                            4
                        ]), [
                            4,
                            this.decodeFromImageElement(r)
                        ];
                    case 2:
                        return [
                            2,
                            n.sent()
                        ];
                    case 3:
                        return t.destroyImageElement(r), [
                            7
                        ];
                    case 4:
                        return [
                            2
                        ];
                }
            });
        });
    }, t.prototype.decodeFromConstraints = function(e, r, n) {
        return $2be8636d379871d6$var$Ro(this, void 0, void 0, function() {
            var o, i;
            return $2be8636d379871d6$var$No(this, function(a) {
                switch(a.label){
                    case 0:
                        return t.checkCallbackFnOrThrow(n), [
                            4,
                            navigator.mediaDevices.getUserMedia(e)
                        ];
                    case 1:
                        o = a.sent(), a.label = 2;
                    case 2:
                        return a.trys.push([
                            2,
                            4,
                            ,
                            5
                        ]), [
                            4,
                            this.decodeFromStream(o, r, n)
                        ];
                    case 3:
                        return [
                            2,
                            a.sent()
                        ];
                    case 4:
                        throw i = a.sent(), t.disposeMediaStream(o), i;
                    case 5:
                        return [
                            2
                        ];
                }
            });
        });
    }, t.prototype.decodeFromStream = function(e, r, n) {
        return $2be8636d379871d6$var$Ro(this, void 0, void 0, function() {
            var o, i, a, u, s, c, f, h, l, d, p = this;
            return $2be8636d379871d6$var$No(this, function(g) {
                switch(g.label){
                    case 0:
                        return t.checkCallbackFnOrThrow(n), o = this.options.tryPlayVideoTimeout, [
                            4,
                            t.attachStreamToVideo(e, r, o)
                        ];
                    case 1:
                        return i = g.sent(), a = function() {
                            var t, r;
                            try {
                                for(var n = $2be8636d379871d6$var$Do(e.getVideoTracks()), o = n.next(); !o.done; o = n.next())o.value.stop();
                            } catch (e) {
                                t = {
                                    error: e
                                };
                            } finally{
                                try {
                                    o && !o.done && (r = n.return) && r.call(n);
                                } finally{
                                    if (t) throw t.error;
                                }
                            }
                            e = void 0;
                        }, u = function() {
                            a(), t.cleanVideoSource(i);
                        }, s = this.scan(i, n, u), c = e.getVideoTracks(), f = $2be8636d379871d6$var$bo($2be8636d379871d6$var$bo({}, s), {
                            stop: function() {
                                s.stop();
                            },
                            streamVideoConstraintsApply: function(t, e) {
                                return $2be8636d379871d6$var$Ro(this, void 0, void 0, function() {
                                    var r, n, o, i, a, u;
                                    return $2be8636d379871d6$var$No(this, function(s) {
                                        switch(s.label){
                                            case 0:
                                                r = e ? c.filter(e) : c, s.label = 1;
                                            case 1:
                                                s.trys.push([
                                                    1,
                                                    6,
                                                    7,
                                                    8
                                                ]), n = $2be8636d379871d6$var$Do(r), o = n.next(), s.label = 2;
                                            case 2:
                                                return o.done ? [
                                                    3,
                                                    5
                                                ] : [
                                                    4,
                                                    o.value.applyConstraints(t)
                                                ];
                                            case 3:
                                                s.sent(), s.label = 4;
                                            case 4:
                                                return o = n.next(), [
                                                    3,
                                                    2
                                                ];
                                            case 5:
                                                return [
                                                    3,
                                                    8
                                                ];
                                            case 6:
                                                return i = s.sent(), a = {
                                                    error: i
                                                }, [
                                                    3,
                                                    8
                                                ];
                                            case 7:
                                                try {
                                                    o && !o.done && (u = n.return) && u.call(n);
                                                } finally{
                                                    if (a) throw a.error;
                                                }
                                                return [
                                                    7
                                                ];
                                            case 8:
                                                return [
                                                    2
                                                ];
                                        }
                                    });
                                });
                            },
                            streamVideoConstraintsGet: function(t) {
                                return c.find(t).getConstraints();
                            },
                            streamVideoSettingsGet: function(t) {
                                return c.find(t).getSettings();
                            },
                            streamVideoCapabilitiesGet: function(t) {
                                return c.find(t).getCapabilities();
                            }
                        }), t.mediaStreamIsTorchCompatible(e) && (h = null == c ? void 0 : c.find(function(e) {
                            return t.mediaStreamIsTorchCompatibleTrack(e);
                        }), l = function(e) {
                            return $2be8636d379871d6$var$Ro(p, void 0, void 0, function() {
                                return $2be8636d379871d6$var$No(this, function(r) {
                                    switch(r.label){
                                        case 0:
                                            return [
                                                4,
                                                t.mediaStreamSetTorch(h, e)
                                            ];
                                        case 1:
                                            return r.sent(), [
                                                2
                                            ];
                                    }
                                });
                            });
                        }, f.switchTorch = l, d = function() {
                            s.stop(), l(!1);
                        }, f.stop = d), [
                            2,
                            f
                        ];
                }
            });
        });
    }, t.prototype.decodeFromVideoDevice = function(e, r, n) {
        return $2be8636d379871d6$var$Ro(this, void 0, void 0, function() {
            var o;
            return $2be8636d379871d6$var$No(this, function(i) {
                switch(i.label){
                    case 0:
                        return t.checkCallbackFnOrThrow(n), o = {
                            video: e ? {
                                deviceId: {
                                    exact: e
                                }
                            } : {
                                facingMode: "environment"
                            }
                        }, [
                            4,
                            this.decodeFromConstraints(o, r, n)
                        ];
                    case 1:
                        return [
                            2,
                            i.sent()
                        ];
                }
            });
        });
    }, t.prototype.decodeFromVideoElement = function(e, r) {
        return $2be8636d379871d6$var$Ro(this, void 0, void 0, function() {
            var n, o;
            return $2be8636d379871d6$var$No(this, function(i) {
                switch(i.label){
                    case 0:
                        if (t.checkCallbackFnOrThrow(r), !e) throw new $2be8636d379871d6$var$f("A video element must be provided.");
                        return n = t.prepareVideoElement(e), o = this.options.tryPlayVideoTimeout, [
                            4,
                            t.playVideoOnLoadAsync(n, o)
                        ];
                    case 1:
                        return i.sent(), [
                            2,
                            this.scan(n, r)
                        ];
                }
            });
        });
    }, t.prototype.decodeFromVideoUrl = function(e, r) {
        return $2be8636d379871d6$var$Ro(this, void 0, void 0, function() {
            var n, o, i;
            return $2be8636d379871d6$var$No(this, function(a) {
                switch(a.label){
                    case 0:
                        if (t.checkCallbackFnOrThrow(r), !e) throw new $2be8636d379871d6$var$f("An URL must be provided.");
                        return (n = t.prepareVideoElement()).src = e, o = function() {
                            t.cleanVideoSource(n);
                        }, i = this.options.tryPlayVideoTimeout, [
                            4,
                            t.playVideoOnLoadAsync(n, i)
                        ];
                    case 1:
                        return a.sent(), [
                            2,
                            this.scan(n, r, o)
                        ];
                }
            });
        });
    }, t.prototype.decodeOnceFromConstraints = function(t, e) {
        return $2be8636d379871d6$var$Ro(this, void 0, void 0, function() {
            var r;
            return $2be8636d379871d6$var$No(this, function(n) {
                switch(n.label){
                    case 0:
                        return [
                            4,
                            navigator.mediaDevices.getUserMedia(t)
                        ];
                    case 1:
                        return r = n.sent(), [
                            4,
                            this.decodeOnceFromStream(r, e)
                        ];
                    case 2:
                        return [
                            2,
                            n.sent()
                        ];
                }
            });
        });
    }, t.prototype.decodeOnceFromStream = function(e, r) {
        return $2be8636d379871d6$var$Ro(this, void 0, void 0, function() {
            var n, o;
            return $2be8636d379871d6$var$No(this, function(i) {
                switch(i.label){
                    case 0:
                        return n = Boolean(r), [
                            4,
                            t.attachStreamToVideo(e, r)
                        ];
                    case 1:
                        o = i.sent(), i.label = 2;
                    case 2:
                        return i.trys.push([
                            2,
                            ,
                            4,
                            5
                        ]), [
                            4,
                            this.scanOneResult(o)
                        ];
                    case 3:
                        return [
                            2,
                            i.sent()
                        ];
                    case 4:
                        return n || t.cleanVideoSource(o), [
                            7
                        ];
                    case 5:
                        return [
                            2
                        ];
                }
            });
        });
    }, t.prototype.decodeOnceFromVideoDevice = function(t, e) {
        return $2be8636d379871d6$var$Ro(this, void 0, void 0, function() {
            var r;
            return $2be8636d379871d6$var$No(this, function(n) {
                switch(n.label){
                    case 0:
                        return r = {
                            video: t ? {
                                deviceId: {
                                    exact: t
                                }
                            } : {
                                facingMode: "environment"
                            }
                        }, [
                            4,
                            this.decodeOnceFromConstraints(r, e)
                        ];
                    case 1:
                        return [
                            2,
                            n.sent()
                        ];
                }
            });
        });
    }, t.prototype.decodeOnceFromVideoElement = function(e) {
        return $2be8636d379871d6$var$Ro(this, void 0, void 0, function() {
            var r, n;
            return $2be8636d379871d6$var$No(this, function(o) {
                switch(o.label){
                    case 0:
                        if (!e) throw new $2be8636d379871d6$var$f("A video element must be provided.");
                        return r = t.prepareVideoElement(e), n = this.options.tryPlayVideoTimeout, [
                            4,
                            t.playVideoOnLoadAsync(r, n)
                        ];
                    case 1:
                        return o.sent(), [
                            4,
                            this.scanOneResult(r)
                        ];
                    case 2:
                        return [
                            2,
                            o.sent()
                        ];
                }
            });
        });
    }, t.prototype.decodeOnceFromVideoUrl = function(e) {
        return $2be8636d379871d6$var$Ro(this, void 0, void 0, function() {
            var r, n;
            return $2be8636d379871d6$var$No(this, function(o) {
                switch(o.label){
                    case 0:
                        if (!e) throw new $2be8636d379871d6$var$f("An URL must be provided.");
                        (r = t.prepareVideoElement()).src = e, n = this.decodeOnceFromVideoElement(r), o.label = 1;
                    case 1:
                        return o.trys.push([
                            1,
                            ,
                            3,
                            4
                        ]), [
                            4,
                            n
                        ];
                    case 2:
                        return [
                            2,
                            o.sent()
                        ];
                    case 3:
                        return t.cleanVideoSource(r), [
                            7
                        ];
                    case 4:
                        return [
                            2
                        ];
                }
            });
        });
    }, t.prototype.scanOneResult = function(t, e, r, n) {
        var o = this;
        return void 0 === e && (e = !0), void 0 === r && (r = !0), void 0 === n && (n = !0), new Promise(function(i, a) {
            o.scan(t, function(t, o, u) {
                if (t) return i(t), void u.stop();
                if (o) {
                    if (o instanceof $2be8636d379871d6$var$U && e) return;
                    if (o instanceof $2be8636d379871d6$var$g && r) return;
                    if (o instanceof $2be8636d379871d6$var$R && n) return;
                    u.stop(), a(o);
                }
            });
        });
    }, t.prototype.scan = function(e, r, n) {
        var o = this;
        t.checkCallbackFnOrThrow(r);
        var i = t.createCaptureCanvas(e), a = i.getContext("2d");
        if (!a) throw new Error("Couldn't create canvas for visual element scan.");
        var u, s = function() {
            a = void 0, i = void 0;
        }, c = !1, f = {
            stop: function() {
                c = !0, clearTimeout(u), s(), n && n();
            }
        }, h = function() {
            if (!c) try {
                t.drawImageOnCanvas(a, e);
                var l = o.decodeFromCanvas(i);
                r(l, void 0, f), u = setTimeout(h, o.options.delayBetweenScanSuccess);
            } catch (t) {
                if (r(void 0, t, f), t instanceof $2be8636d379871d6$var$g || t instanceof $2be8636d379871d6$var$R || t instanceof $2be8636d379871d6$var$U) return void (u = setTimeout(h, o.options.delayBetweenScanAttempts));
                s(), n && n(t);
            }
        };
        return h(), f;
    }, t.prototype._decodeOnLoadImage = function(e) {
        return $2be8636d379871d6$var$Ro(this, void 0, void 0, function() {
            return $2be8636d379871d6$var$No(this, function(r) {
                switch(r.label){
                    case 0:
                        return t.isImageLoaded(e) ? [
                            3,
                            2
                        ] : [
                            4,
                            t._waitImageLoad(e)
                        ];
                    case 1:
                        r.sent(), r.label = 2;
                    case 2:
                        return [
                            2,
                            this.decode(e)
                        ];
                }
            });
        });
    }, t;
}(), $2be8636d379871d6$var$Bo = function() {
    var t = function(e, r) {
        return t = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(t, e) {
            t.__proto__ = e;
        } || function(t, e) {
            for(var r in e)e.hasOwnProperty(r) && (t[r] = e[r]);
        }, t(e, r);
    };
    return function(e, r) {
        function n() {
            this.constructor = e;
        }
        t(e, r), e.prototype = null === r ? Object.create(r) : (n.prototype = r.prototype, new n());
    };
}();
!function(t) {
    function e(e, r) {
        return t.call(this, new $2be8636d379871d6$var$Mt(), e, r) || this;
    }
    $2be8636d379871d6$var$Bo(e, t);
}($2be8636d379871d6$var$Mo);
var $2be8636d379871d6$var$Lo = function() {
    var t = function(e, r) {
        return t = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(t, e) {
            t.__proto__ = e;
        } || function(t, e) {
            for(var r in e)e.hasOwnProperty(r) && (t[r] = e[r]);
        }, t(e, r);
    };
    return function(e, r) {
        function n() {
            this.constructor = e;
        }
        t(e, r), e.prototype = null === r ? Object.create(r) : (n.prototype = r.prototype, new n());
    };
}();
!function(t) {
    function e(e, r) {
        return t.call(this, new $2be8636d379871d6$var$fr(e), e, r) || this;
    }
    $2be8636d379871d6$var$Lo(e, t);
}($2be8636d379871d6$var$Mo);
var $2be8636d379871d6$var$Fo = function() {
    var t = function(e, r) {
        return t = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(t, e) {
            t.__proto__ = e;
        } || function(t, e) {
            for(var r in e)e.hasOwnProperty(r) && (t[r] = e[r]);
        }, t(e, r);
    };
    return function(e, r) {
        function n() {
            this.constructor = e;
        }
        t(e, r), e.prototype = null === r ? Object.create(r) : (n.prototype = r.prototype, new n());
    };
}();
!function(t) {
    function e(e, r) {
        return t.call(this, new $2be8636d379871d6$var$Or(), e, r) || this;
    }
    $2be8636d379871d6$var$Fo(e, t);
}($2be8636d379871d6$var$Mo);
var $2be8636d379871d6$var$ko = function() {
    var t = function(e, r) {
        return t = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(t, e) {
            t.__proto__ = e;
        } || function(t, e) {
            for(var r in e)e.hasOwnProperty(r) && (t[r] = e[r]);
        }, t(e, r);
    };
    return function(e, r) {
        function n() {
            this.constructor = e;
        }
        t(e, r), e.prototype = null === r ? Object.create(r) : (n.prototype = r.prototype, new n());
    };
}();
!function(t) {
    function e(e, r) {
        var n = this, o = new $2be8636d379871d6$var$$n();
        return o.setHints(e), (n = t.call(this, o, e, r) || this).reader = o, n;
    }
    $2be8636d379871d6$var$ko(e, t), Object.defineProperty(e.prototype, "possibleFormats", {
        set: function(t) {
            this.hints.set($2be8636d379871d6$var$T.POSSIBLE_FORMATS, t), this.reader.setHints(this.hints);
        },
        enumerable: !1,
        configurable: !0
    }), e.prototype.decodeBitmap = function(t) {
        return this.reader.decodeWithState(t);
    }, e.prototype.setHints = function(t) {
        this.hints = t, this.reader.setHints(this.hints);
    };
}($2be8636d379871d6$var$Mo);
var $2be8636d379871d6$var$xo = function() {
    var t = function(e, r) {
        return t = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(t, e) {
            t.__proto__ = e;
        } || function(t, e) {
            for(var r in e)e.hasOwnProperty(r) && (t[r] = e[r]);
        }, t(e, r);
    };
    return function(e, r) {
        function n() {
            this.constructor = e;
        }
        t(e, r), e.prototype = null === r ? Object.create(r) : (n.prototype = r.prototype, new n());
    };
}();
!function(t) {
    function e(e, r) {
        return t.call(this, new $2be8636d379871d6$var$Kn(), e, r) || this;
    }
    $2be8636d379871d6$var$xo(e, t);
}($2be8636d379871d6$var$Mo);
var $2be8636d379871d6$var$Vo = function() {
    var t = function(e, r) {
        return t = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(t, e) {
            t.__proto__ = e;
        } || function(t, e) {
            for(var r in e)e.hasOwnProperty(r) && (t[r] = e[r]);
        }, t(e, r);
    };
    return function(e, r) {
        function n() {
            this.constructor = e;
        }
        t(e, r), e.prototype = null === r ? Object.create(r) : (n.prototype = r.prototype, new n());
    };
}(), $2be8636d379871d6$var$Uo = function(t) {
    function e(e, r) {
        return t.call(this, new $2be8636d379871d6$var$an(), e, r) || this;
    }
    return $2be8636d379871d6$var$Vo(e, t), e;
}($2be8636d379871d6$var$Mo), $2be8636d379871d6$var$Ho = function(t, e, r) {
    var n = typeof t === r;
    return n || console.warn('[ReactQrReader]: Expected "'.concat(e, '" to be a of type "').concat(r, '".')), n;
}, $2be8636d379871d6$export$950f6bcb8267c4b = function(t) {
    var n = t.scanDelay, o = t.constraints, i = t.onResult, a = t.videoId, u = (0, $acw62.useRef)(null);
    (0, $acw62.useEffect)(function() {
        var t = new $2be8636d379871d6$var$Uo(null, {
            delayBetweenScanAttempts: n
        });
        if (!function() {
            var t = "undefined" != typeof navigator && !!navigator.mediaDevices;
            return t || console.warn('[ReactQrReader]: MediaDevices API has no support for your browser. You can fix this by running "npm i webrtc-adapter"'), t;
        }() && $2be8636d379871d6$var$Ho(i, "onResult", "function")) i(null, new Error('MediaDevices API has no support for your browser. You can fix this by running "npm i webrtc-adapter"'), t);
        return $2be8636d379871d6$var$Ho(o, "constraints", "object") && t.decodeFromConstraints({
            video: o
        }, a, function(e, r) {
            $2be8636d379871d6$var$Ho(i, "onResult", "function") && i(e, r, t);
        }).then(function(t) {
            return u.current = t;
        }).catch(function(e) {
            $2be8636d379871d6$var$Ho(i, "onResult", "function") && i(null, e, t);
        }), function() {
            var t;
            null === (t = u.current) || void 0 === t || t.stop();
        };
    }, []);
}, $2be8636d379871d6$var$Xo = function() {
    return $2be8636d379871d6$var$Xo = Object.assign || function(t) {
        for(var e, r = 1, n = arguments.length; r < n; r++)for(var o in e = arguments[r])Object.prototype.hasOwnProperty.call(e, o) && (t[o] = e[o]);
        return t;
    }, $2be8636d379871d6$var$Xo.apply(this, arguments);
}, $2be8636d379871d6$var$Wo = {
    container: {
        width: "100%",
        paddingTop: "100%",
        overflow: "hidden",
        position: "relative"
    },
    video: {
        top: 0,
        left: 0,
        width: "100%",
        height: "100%",
        display: "block",
        overflow: "hidden",
        position: "absolute",
        transform: void 0
    }
}, $2be8636d379871d6$export$5d05a7e825dbf285 = function(e) {
    var r = e.videoContainerStyle, n = e.containerStyle, o = e.videoStyle, i = e.constraints, a = e.ViewFinder, u = e.scanDelay, s = e.className, c = e.onResult, f = e.videoId;
    return $2be8636d379871d6$export$950f6bcb8267c4b({
        constraints: i,
        scanDelay: u,
        onResult: c,
        videoId: f
    }), $acw62.createElement("section", {
        className: s,
        style: n
    }, $acw62.createElement("div", {
        style: $2be8636d379871d6$var$Xo($2be8636d379871d6$var$Xo({}, $2be8636d379871d6$var$Wo.container), r)
    }, !!a && $acw62.createElement(a, null), $acw62.createElement("video", {
        muted: !0,
        id: f,
        style: $2be8636d379871d6$var$Xo($2be8636d379871d6$var$Xo($2be8636d379871d6$var$Xo({}, $2be8636d379871d6$var$Wo.video), o), {
            transform: "user" === (null == i ? void 0 : i.facingMode) && "scaleX(-1)"
        })
    })));
};
$2be8636d379871d6$export$5d05a7e825dbf285.displayName = "QrReader", $2be8636d379871d6$export$5d05a7e825dbf285.defaultProps = {
    constraints: {
        facingMode: "user"
    },
    videoId: "video",
    scanDelay: 500
};



var $acw62 = parcelRequire("acw62");


var $ee1cd7c9bd2bb299$exports = {};
$ee1cd7c9bd2bb299$exports = new URL("x.8e2b5bb6.svg", import.meta.url).toString();






var $d5d75498ca92ce32$exports = {};
$d5d75498ca92ce32$exports = new URL("detector_active.a25ff6d4.svg", import.meta.url).toString();


var $569bf59ffb5bc86c$exports = {};
$569bf59ffb5bc86c$exports = new URL("detector.6ed38fbf.svg", import.meta.url).toString();


const $261d330992971658$export$cad6bc48b0b04c72 = ({ isDetectorActive: isDetectorActive })=>{
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        style: {
            width: "128px",
            height: "128px",
            border: "2px solid transparent",
            borderRadius: "20px",
            background: "rgba(255, 255, 255, 0.2)",
            position: "absolute",
            top: "50%",
            left: "50%",
            zIndex: "999999",
            transform: "translate(-50%, -50%)",
            display: "flex",
            justifyContent: "center",
            alignItems: "center"
        },
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
            src: isDetectorActive ? (0, (/*@__PURE__*/$parcel$interopDefault($d5d75498ca92ce32$exports))) : (0, (/*@__PURE__*/$parcel$interopDefault($569bf59ffb5bc86c$exports)))
        })
    });
};




var $5119c094738bfb4c$exports = {};
$5119c094738bfb4c$exports = new URL("camera.9e14a67b.svg", import.meta.url).toString();


var $7748ef4d95b1428c$exports = {};
$7748ef4d95b1428c$exports = new URL("camera_disabled.ea0405a4.svg", import.meta.url).toString();


const $99b5278d51c1c10e$export$e0962960f2fd799d = ({ hasCamera: hasCamera, isCameraAccessDenied: isCameraAccessDenied })=>{
    const { t: t } = (0, $3765cebd031b52c0$export$9fc83ad70ead8663)();
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "QrScanner__cameraPermission",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: `QrScanner__cameraPermission__iconContainer${!hasCamera ? "QrScanner__cameraPermission__iconContainer--disabled" : ""}`,
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                    src: !hasCamera ? (0, (/*@__PURE__*/$parcel$interopDefault($7748ef4d95b1428c$exports))) : (0, (/*@__PURE__*/$parcel$interopDefault($5119c094738bfb4c$exports)))
                })
            }),
            hasCamera && !isCameraAccessDenied && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                        className: "QrScanner__cameraPermission__title",
                        children: t("qr_scan.camera_permission_required")
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                        className: "QrScanner__cameraPermission__subtitle",
                        children: t("qr_scan.enable_permission")
                    })
                ]
            }),
            hasCamera && isCameraAccessDenied && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                        className: "QrScanner__cameraPermission__title QrScanner__cameraPermission__title--disabled",
                        children: t("qr_scan.access_denied")
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                        className: "QrScanner__cameraPermission__subtitle",
                        children: t("qr_scan.enable_permission")
                    })
                ]
            }),
            !hasCamera && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                        className: "QrScanner__cameraPermission__title QrScanner__cameraPermission__title--disabled",
                        children: t("qr_scan.camera_missing_title")
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                        className: "QrScanner__cameraPermission__subtitle",
                        children: t("qr_scan.camera_missing_description")
                    })
                ]
            })
        ]
    });
};





var $a71a9b75c6db2d50$exports = {};
$a71a9b75c6db2d50$exports = new URL("user_card.31629e54.svg", import.meta.url).toString();


const $d713620ca4da4aec$export$f361d4ae234b90f4 = ()=>{
    const { t: t } = (0, $3765cebd031b52c0$export$9fc83ad70ead8663)();
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "QrScanner__info",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                className: "QrScanner__info__title",
                children: t("qr_scan.instruction_title")
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "QrScanner__info__blocks",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "QrScanner__info__block",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "QrScanner__info__block__top",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                                        src: (0, (/*@__PURE__*/$parcel$interopDefault($21cb684f7af51aab$exports)))
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                        className: "QrScanner__info__block__top__title",
                                        children: t("qr_scan.step_1")
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                className: "QrScanner__info__block__bottom",
                                children: t("qr_scan.step_1_text")
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "QrScanner__info__block",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "QrScanner__info__block__top",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                                        src: (0, (/*@__PURE__*/$parcel$interopDefault($a71a9b75c6db2d50$exports)))
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                        className: "QrScanner__info__block__top__title",
                                        children: t("qr_scan.step_2")
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                className: "QrScanner__info__block__bottom",
                                children: t("qr_scan.step_2_text")
                            })
                        ]
                    })
                ]
            })
        ]
    });
};




var $7YFi7 = parcelRequire("7YFi7");




const $1d532c16612e8564$export$ec64e1a1a3cc4313 = ()=>{
    const redirect = (0, $7df35e9df335b1c8$export$602eaf6d5314ce55)();
    const { t: t } = (0, $3765cebd031b52c0$export$9fc83ad70ead8663)();
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "QrScanner__manualInput",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "QrScanner__manualInput__header",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                    className: "QrScanner__manualInput__header__message",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                            className: "QrScanner__manualInput__header__message QrScanner__manualInput__header__message--highlight",
                            children: t("qr_scan.sp_id_form_title_1")
                        }),
                        " ",
                        t("qr_scan.sp_id_form_title_2"),
                        "."
                    ]
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7YFi7.Formik), {
                initialValues: {
                    spId: ""
                },
                onSubmit: ({ spId: spId })=>{
                    redirect((0, $0534349ae8731d0b$export$66b32f6f30eb4b4).attendanceQR, {
                        spId: spId
                    });
                },
                children: (formikProps)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7b02d682eb115277$exports.Fragment), {
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7YFi7.Form), {
                            noValidate: true,
                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "QrScanner__manualInput__form",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $79dd68e96d831dee$export$2e2bcd8739ae039), {
                                        label: t("qr_scan.sp_id_label"),
                                        formikKey: "spId",
                                        formikProps: formikProps,
                                        className: "QrScanner__manualInput__input"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                        type: "submit",
                                        className: "QrScanner__manualInput__submit",
                                        children: t("common.continue")
                                    })
                                ]
                            })
                        })
                    })
            })
        ]
    });
};


const $371f74ad717ec47a$export$646b390d8bcaeffa = ()=>{
    const [hasCamera, setHasCamera] = (0, $acw62.useState)(false);
    const [permissionState, setPermissionState] = (0, $acw62.useState)("prompt");
    const { showQRScanner: showQRScanner, setShowQRScanner: setShowQRScanner } = (0, $acw62.useContext)((0, $392d2c14aa582458$export$9e7c8e903bb56df9));
    const { t: t } = (0, $3765cebd031b52c0$export$9fc83ad70ead8663)();
    const isPermissionGranted = ()=>{
        return permissionState === "granted";
    };
    const handleCameraPermission = async (withOnchange = true)=>{
        // @ts-ignore
        const permissionResult = await navigator.permissions.query({
            name: "camera"
        });
        setPermissionState(permissionResult.state);
        if (withOnchange) permissionResult.onchange = ()=>{
            setPermissionState(permissionResult.state);
        };
    };
    let handleCameraPermissionInterval = null;
    (0, $acw62.useEffect)(()=>{
        if (!showQRScanner) return;
        async function checkCameraAccess() {
            try {
                await handleCameraPermission();
                if (permissionState === "prompt") handleCameraPermissionInterval = setInterval(()=>{
                    handleCameraPermission(false);
                }, 1000);
            } catch (error) {
                // means it Firefox or other browser where we can't get permissions, so for now will
                // render camera relying on previous method (checkForCamera)
                console.error("Error fetching camera permissions:", error);
                setPermissionState("granted");
            }
        }
        async function checkForCamera() {
            try {
                const devices = await navigator.mediaDevices.enumerateDevices();
                const videoInputs = devices.filter((device)=>device.kind === "videoinput");
                const hasVideoInputs = videoInputs.length > 0;
                setHasCamera(hasVideoInputs);
                if (hasVideoInputs) checkCameraAccess();
            } catch (error) {
                console.error("Error checking for camera:", error);
                setHasCamera(false);
            }
        }
        checkForCamera();
        return ()=>{
            if (handleCameraPermissionInterval !== null) clearInterval(handleCameraPermissionInterval);
        };
    }, [
        showQRScanner,
        permissionState
    ]);
    const redirect = (0, $7df35e9df335b1c8$export$602eaf6d5314ce55)();
    const [isDetectorActive, setIsDetectorActive] = (0, $acw62.useState)(false);
    if (!showQRScanner) return null;
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "QrScanner__container",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "QrScanner__content",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "QrScanner__closeContainer",
                        onClick: ()=>setShowQRScanner(false),
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                            src: (0, (/*@__PURE__*/$parcel$interopDefault($ee1cd7c9bd2bb299$exports)))
                        })
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $2be8636d379871d6$export$5d05a7e825dbf285), {
                        onResult: (result, error)=>{
                            if (result) {
                                setIsDetectorActive(true);
                                try {
                                    const url = new URL(result.getText());
                                    const params = new URLSearchParams(url.search);
                                    const spId = params.get("spId");
                                    if (!spId) {
                                        (0, $60f27fc97e29822a$export$b410431fab84fa58).error(t("qr_scan.invalid_qr_code_provided"));
                                        return;
                                    }
                                    setShowQRScanner(false);
                                    redirect((0, $0534349ae8731d0b$export$66b32f6f30eb4b4).attendanceQR, {
                                        spId: spId
                                    });
                                } catch (e) {
                                    (0, $60f27fc97e29822a$export$b410431fab84fa58).error(t("qr_scan.invalid_qr_code_provided"));
                                }
                            } else setIsDetectorActive(false);
                        },
                        constraints: {
                            facingMode: "environment"
                        },
                        containerStyle: {
                            display: isPermissionGranted() ? "flex" : "none",
                            width: "100%",
                            justifyContent: "center"
                        },
                        videoContainerStyle: {
                            display: isPermissionGranted() ? "unset" : "none",
                            width: "100%",
                            paddingTop: "unset",
                            maxWidth: "650px",
                            overflow: "unset"
                        },
                        videoStyle: {
                            display: isPermissionGranted() ? "unset" : "none",
                            width: "100%",
                            height: "unset",
                            position: "unset",
                            maxWidth: "650px"
                        },
                        ViewFinder: ()=>isPermissionGranted() ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $261d330992971658$export$cad6bc48b0b04c72), {
                                isDetectorActive: isDetectorActive
                            }) : null
                    }),
                    !isPermissionGranted() && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $99b5278d51c1c10e$export$e0962960f2fd799d), {
                        hasCamera: hasCamera,
                        isCameraAccessDenied: permissionState === "denied"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $d713620ca4da4aec$export$f361d4ae234b90f4), {}),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $1d532c16612e8564$export$ec64e1a1a3cc4313), {})
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "QrScanner__bottom"
            })
        ]
    });
};





var $bsQZT = parcelRequire("bsQZT");
const $d3cd6208d6fe342f$export$e034111dc0cfe9e7 = (0, $aca50e9407ba89c9$export$b6ae1bc530f4c149)(()=>{
    const [desktopSidebarActive, setDesktopSidebarActive] = (0, $acw62.useState)(true);
    const { logged: logged, getUnseenUpdates: getUnseenUpdates, getConfig: getConfig, getProfile: getProfile } = (0, $4671947198ddd366$export$6ccbb43953eebf8)().data;
    const { enableQuery: getUnseenUpdatesQuery } = (0, $4671947198ddd366$export$517ca4f7fee4e226)(getUnseenUpdates);
    const { enableQuery: getConfigQuery } = (0, $4671947198ddd366$export$517ca4f7fee4e226)(getConfig);
    const { enableQuery: getProfileQuery } = (0, $4671947198ddd366$export$517ca4f7fee4e226)(getProfile, {
        onSuccess: (profile)=>{
            (0, $c74a0566d4b0fd6d$export$e9db7d6e73593439).identifyUser(profile.user_id);
            (0, $c74a0566d4b0fd6d$export$e9db7d6e73593439).assignUserProperties(profile.id, profile.roles, profile.email);
        }
    });
    (0, $acw62.useEffect)(()=>{
        if (logged) {
            getUnseenUpdatesQuery();
            getConfigQuery();
            getProfileQuery();
        }
    }, [
        logged
    ]);
    const redirect = (0, $7df35e9df335b1c8$export$602eaf6d5314ce55)();
    (0, $1eb7b80ad2b5a7c5$export$46de9ba7af305689)();
    const { t: t } = (0, $3765cebd031b52c0$export$9fc83ad70ead8663)();
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        id: "main_layout",
        className: "AppLayout",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                id: "modals"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "AppLayout__desktop",
                        children: logged && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $862384c1dc0db62b$export$1ba59dacbcbf90fe), {
                            active: desktopSidebarActive,
                            setActive: setDesktopSidebarActive
                        })
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("main", {
                        className: "AppLayout__main",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $60f27fc97e29822a$export$f2815235e76a62b9), {
                                style: {
                                    zIndex: "999999"
                                }
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $371f74ad717ec47a$export$646b390d8bcaeffa), {}),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7df35e9df335b1c8$export$e7b0ac011bb776c6), {
                                route: (0, $0534349ae8731d0b$export$66b32f6f30eb4b4).index,
                                children: logged ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $d6286036be37a1b2$export$65f7aeb92040da96), {
                                    value: (0, $d6286036be37a1b2$export$9931f407af1661c3),
                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $9d2af2844f10c458$export$b8a61e5c71402559).HomeStack.HomePage, {
                                        hideLogo: desktopSidebarActive
                                    })
                                }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $9d2af2844f10c458$export$b8a61e5c71402559).AuthStack.LoginPage, {})
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7df35e9df335b1c8$export$e7b0ac011bb776c6), {
                                route: (0, $0534349ae8731d0b$export$66b32f6f30eb4b4).allJobs,
                                children: (params)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4ae5ab5371178941$export$f01b3d7c7bbe3997), {
                                        allowedRoles: [
                                            (0, $97fa7686fb8e51ed$export$eb3485a690c2f0b8).Admin,
                                            (0, $97fa7686fb8e51ed$export$eb3485a690c2f0b8).Owner,
                                            (0, $97fa7686fb8e51ed$export$eb3485a690c2f0b8).Manager
                                        ],
                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $9d2af2844f10c458$export$b8a61e5c71402559).JobsStack.AllJobsPage, {
                                            date: params.date ?? (0, $ddf12117b815a7c3$export$efb113ee57e9edfb)(new Date())
                                        })
                                    })
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7df35e9df335b1c8$export$e7b0ac011bb776c6), {
                                route: (0, $0534349ae8731d0b$export$66b32f6f30eb4b4).pastWorkers,
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4ae5ab5371178941$export$f01b3d7c7bbe3997), {
                                    allowedRoles: [
                                        (0, $97fa7686fb8e51ed$export$eb3485a690c2f0b8).Admin,
                                        (0, $97fa7686fb8e51ed$export$eb3485a690c2f0b8).Owner,
                                        (0, $97fa7686fb8e51ed$export$eb3485a690c2f0b8).Manager
                                    ],
                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $9d2af2844f10c458$export$b8a61e5c71402559).PastWorkers, {})
                                })
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7df35e9df335b1c8$export$e7b0ac011bb776c6), {
                                route: (0, $0534349ae8731d0b$export$66b32f6f30eb4b4).editProfile,
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $4ae5ab5371178941$export$f01b3d7c7bbe3997), {
                                    allowedRoles: [
                                        (0, $97fa7686fb8e51ed$export$eb3485a690c2f0b8).Admin,
                                        (0, $97fa7686fb8e51ed$export$eb3485a690c2f0b8).Owner
                                    ],
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7ae42b63183f30b4$export$8b251419efc915eb), {
                                            title: t("profile_form.title")
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $9d2af2844f10c458$export$b8a61e5c71402559).ProfileStack.ProfileFormPage, {})
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7df35e9df335b1c8$export$e7b0ac011bb776c6), {
                                route: (0, $0534349ae8731d0b$export$66b32f6f30eb4b4).editCompany,
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4ae5ab5371178941$export$f01b3d7c7bbe3997), {
                                    allowedRoles: [
                                        (0, $97fa7686fb8e51ed$export$eb3485a690c2f0b8).Admin,
                                        (0, $97fa7686fb8e51ed$export$eb3485a690c2f0b8).Owner
                                    ],
                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $9d2af2844f10c458$export$b8a61e5c71402559).ProfileStack.CompanyFormPage, {})
                                })
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7df35e9df335b1c8$export$e7b0ac011bb776c6), {
                                route: (0, $0534349ae8731d0b$export$66b32f6f30eb4b4).locations,
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4ae5ab5371178941$export$f01b3d7c7bbe3997), {
                                    allowedRoles: [
                                        (0, $97fa7686fb8e51ed$export$eb3485a690c2f0b8).Admin,
                                        (0, $97fa7686fb8e51ed$export$eb3485a690c2f0b8).Owner,
                                        (0, $97fa7686fb8e51ed$export$eb3485a690c2f0b8).Manager
                                    ],
                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $9d2af2844f10c458$export$b8a61e5c71402559).LocationsStack.LocationListPage, {})
                                })
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7df35e9df335b1c8$export$e7b0ac011bb776c6), {
                                route: (0, $0534349ae8731d0b$export$66b32f6f30eb4b4).addLocations,
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4ae5ab5371178941$export$f01b3d7c7bbe3997), {
                                    allowedRoles: [
                                        (0, $97fa7686fb8e51ed$export$eb3485a690c2f0b8).Admin,
                                        (0, $97fa7686fb8e51ed$export$eb3485a690c2f0b8).Owner,
                                        (0, $97fa7686fb8e51ed$export$eb3485a690c2f0b8).Manager
                                    ],
                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $9d2af2844f10c458$export$b8a61e5c71402559).LocationsStack.AddLocationPage, {
                                        showSubmit: true,
                                        showLocationNameField: true,
                                        showAddressDetailsField: true,
                                        showImageField: true,
                                        showHeader: true,
                                        showCheckInRestrictionsBlock: true
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7df35e9df335b1c8$export$e7b0ac011bb776c6), {
                                route: (0, $0534349ae8731d0b$export$66b32f6f30eb4b4).editLocations,
                                children: (p)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4ae5ab5371178941$export$f01b3d7c7bbe3997), {
                                        allowedRoles: [
                                            (0, $97fa7686fb8e51ed$export$eb3485a690c2f0b8).Admin,
                                            (0, $97fa7686fb8e51ed$export$eb3485a690c2f0b8).Owner,
                                            (0, $97fa7686fb8e51ed$export$eb3485a690c2f0b8).Manager
                                        ],
                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $9d2af2844f10c458$export$b8a61e5c71402559).LocationsStack.EditLocationPage, {
                                            id: p.id
                                        })
                                    })
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7df35e9df335b1c8$export$e7b0ac011bb776c6), {
                                route: (0, $0534349ae8731d0b$export$66b32f6f30eb4b4).attendanceManagers,
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4ae5ab5371178941$export$f01b3d7c7bbe3997), {
                                    allowedRoles: [
                                        (0, $97fa7686fb8e51ed$export$eb3485a690c2f0b8).Admin,
                                        (0, $97fa7686fb8e51ed$export$eb3485a690c2f0b8).Owner
                                    ],
                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $9d2af2844f10c458$export$b8a61e5c71402559).ProfileStack.AttendanceManagerListPage, {})
                                })
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7df35e9df335b1c8$export$e7b0ac011bb776c6), {
                                route: (0, $0534349ae8731d0b$export$66b32f6f30eb4b4).addAttendanceManagers,
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4ae5ab5371178941$export$f01b3d7c7bbe3997), {
                                    allowedRoles: [
                                        (0, $97fa7686fb8e51ed$export$eb3485a690c2f0b8).Admin,
                                        (0, $97fa7686fb8e51ed$export$eb3485a690c2f0b8).Owner
                                    ],
                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $9d2af2844f10c458$export$b8a61e5c71402559).ProfileStack.AddAttendanceManagerFormPage, {})
                                })
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7df35e9df335b1c8$export$e7b0ac011bb776c6), {
                                route: (0, $0534349ae8731d0b$export$66b32f6f30eb4b4).editAttendanceManagers,
                                children: (params)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4ae5ab5371178941$export$f01b3d7c7bbe3997), {
                                        allowedRoles: [
                                            (0, $97fa7686fb8e51ed$export$eb3485a690c2f0b8).Admin,
                                            (0, $97fa7686fb8e51ed$export$eb3485a690c2f0b8).Owner
                                        ],
                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $9d2af2844f10c458$export$b8a61e5c71402559).ProfileStack.EditAttendanceManagerPage, {
                                            id: params.id
                                        })
                                    })
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7df35e9df335b1c8$export$e7b0ac011bb776c6), {
                                route: (0, $0534349ae8731d0b$export$66b32f6f30eb4b4).paymentMethods,
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4ae5ab5371178941$export$f01b3d7c7bbe3997), {
                                    allowedRoles: [
                                        (0, $97fa7686fb8e51ed$export$eb3485a690c2f0b8).Admin,
                                        (0, $97fa7686fb8e51ed$export$eb3485a690c2f0b8).Owner,
                                        (0, $97fa7686fb8e51ed$export$eb3485a690c2f0b8).Finance
                                    ],
                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $9d2af2844f10c458$export$b8a61e5c71402559).ProfileStack.PaymentMethodListPage, {})
                                })
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7df35e9df335b1c8$export$e7b0ac011bb776c6), {
                                route: (0, $0534349ae8731d0b$export$66b32f6f30eb4b4).invoices,
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7b02d682eb115277$exports.Fragment), {
                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $9d2af2844f10c458$export$b8a61e5c71402559).ProfileStack.InvoiceListPage, {})
                                })
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7df35e9df335b1c8$export$e7b0ac011bb776c6), {
                                route: (0, $0534349ae8731d0b$export$66b32f6f30eb4b4).invoice,
                                children: (params)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $9d2af2844f10c458$export$b8a61e5c71402559).ProfileStack.InvoiceDetailsPage, {
                                        id: params.id
                                    })
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7df35e9df335b1c8$export$e7b0ac011bb776c6), {
                                route: (0, $0534349ae8731d0b$export$66b32f6f30eb4b4).invoiceOgrammer,
                                children: (params)=>{
                                    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7ae42b63183f30b4$export$8b251419efc915eb), {
                                                showBack: true,
                                                title: params.name
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $9d2af2844f10c458$export$b8a61e5c71402559).ProfileStack.InvoiceOgrammerPage, {
                                                invoiceItemId: params.invoiceItemId,
                                                ogrammerId: params.ogrammerId,
                                                ogrammerName: params.name
                                            })
                                        ]
                                    });
                                }
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7df35e9df335b1c8$export$e7b0ac011bb776c6), {
                                route: (0, $0534349ae8731d0b$export$66b32f6f30eb4b4).preferences,
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4ae5ab5371178941$export$f01b3d7c7bbe3997), {
                                    allowedRoles: [
                                        (0, $97fa7686fb8e51ed$export$eb3485a690c2f0b8).Admin,
                                        (0, $97fa7686fb8e51ed$export$eb3485a690c2f0b8).Owner
                                    ],
                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $9d2af2844f10c458$export$b8a61e5c71402559).ProfileStack.PreferencesPage, {})
                                })
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7df35e9df335b1c8$export$e7b0ac011bb776c6), {
                                route: (0, $0534349ae8731d0b$export$66b32f6f30eb4b4).applicantsReview,
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4ae5ab5371178941$export$f01b3d7c7bbe3997), {
                                    allowedRoles: [
                                        (0, $97fa7686fb8e51ed$export$eb3485a690c2f0b8).Admin,
                                        (0, $97fa7686fb8e51ed$export$eb3485a690c2f0b8).Owner,
                                        (0, $97fa7686fb8e51ed$export$eb3485a690c2f0b8).Manager
                                    ],
                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $9d2af2844f10c458$export$b8a61e5c71402559).ApplicantsReviewStack.ApplicantsReviewPage, {})
                                })
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7df35e9df335b1c8$export$e7b0ac011bb776c6), {
                                route: (0, $0534349ae8731d0b$export$66b32f6f30eb4b4).jobOGCherryPicker,
                                children: (params)=>{
                                    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4ae5ab5371178941$export$f01b3d7c7bbe3997), {
                                        allowedRoles: [
                                            (0, $97fa7686fb8e51ed$export$eb3485a690c2f0b8).Admin,
                                            (0, $97fa7686fb8e51ed$export$eb3485a690c2f0b8).Owner,
                                            (0, $97fa7686fb8e51ed$export$eb3485a690c2f0b8).Manager
                                        ],
                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $9d2af2844f10c458$export$b8a61e5c71402559).ApplicantsReviewStack.JobCherryPickingPage, {
                                            jobId: params.jobId,
                                            shiftId: params.shiftId,
                                            type: Number(params.type)
                                        })
                                    });
                                }
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7df35e9df335b1c8$export$e7b0ac011bb776c6), {
                                route: (0, $0534349ae8731d0b$export$66b32f6f30eb4b4).applicantDetails,
                                children: (params)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4ae5ab5371178941$export$f01b3d7c7bbe3997), {
                                        allowedRoles: [
                                            (0, $97fa7686fb8e51ed$export$eb3485a690c2f0b8).Admin,
                                            (0, $97fa7686fb8e51ed$export$eb3485a690c2f0b8).Owner,
                                            (0, $97fa7686fb8e51ed$export$eb3485a690c2f0b8).Manager
                                        ],
                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $9d2af2844f10c458$export$b8a61e5c71402559).ApplicantsReviewStack.ApplicantDetailsPage, {
                                            jobId: params.jobId,
                                            jobType: params.type,
                                            applicantId: Number(params.applicantId),
                                            showHeader: true,
                                            showControls: true
                                        })
                                    })
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7df35e9df335b1c8$export$e7b0ac011bb776c6), {
                                route: (0, $0534349ae8731d0b$export$66b32f6f30eb4b4).attendanceShiftsList,
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4ae5ab5371178941$export$f01b3d7c7bbe3997), {
                                    allowedRoles: [
                                        (0, $97fa7686fb8e51ed$export$eb3485a690c2f0b8).Admin,
                                        (0, $97fa7686fb8e51ed$export$eb3485a690c2f0b8).Owner,
                                        (0, $97fa7686fb8e51ed$export$eb3485a690c2f0b8).Manager,
                                        (0, $97fa7686fb8e51ed$export$eb3485a690c2f0b8).Finance
                                    ],
                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $9d2af2844f10c458$export$b8a61e5c71402559).ShiftsAttendanceStack.ShiftListPage, {})
                                })
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7df35e9df335b1c8$export$e7b0ac011bb776c6), {
                                route: (0, $0534349ae8731d0b$export$66b32f6f30eb4b4).attendanceQR,
                                children: (params)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4ae5ab5371178941$export$f01b3d7c7bbe3997), {
                                        allowedRoles: [
                                            (0, $97fa7686fb8e51ed$export$eb3485a690c2f0b8).Admin,
                                            (0, $97fa7686fb8e51ed$export$eb3485a690c2f0b8).Owner,
                                            (0, $97fa7686fb8e51ed$export$eb3485a690c2f0b8).Manager,
                                            (0, $97fa7686fb8e51ed$export$eb3485a690c2f0b8).Finance
                                        ],
                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $9d2af2844f10c458$export$b8a61e5c71402559).ShiftsAttendanceStack.QrAttendancePage, {
                                            spId: Number(params.spId)
                                        }, (0, $3fa3ae484854b431$export$2e2bcd8739ae039)())
                                    })
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7df35e9df335b1c8$export$e7b0ac011bb776c6), {
                                route: (0, $0534349ae8731d0b$export$66b32f6f30eb4b4).users,
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4ae5ab5371178941$export$f01b3d7c7bbe3997), {
                                    allowedRoles: [
                                        (0, $97fa7686fb8e51ed$export$eb3485a690c2f0b8).Admin,
                                        (0, $97fa7686fb8e51ed$export$eb3485a690c2f0b8).Owner
                                    ],
                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $9d2af2844f10c458$export$b8a61e5c71402559).UsersManagmentStack.UsersListPage, {
                                        showOnlyUnconfirmed: false
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7df35e9df335b1c8$export$e7b0ac011bb776c6), {
                                route: (0, $0534349ae8731d0b$export$66b32f6f30eb4b4).unconfirmedUsers,
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4ae5ab5371178941$export$f01b3d7c7bbe3997), {
                                    allowedRoles: [
                                        (0, $97fa7686fb8e51ed$export$eb3485a690c2f0b8).Admin,
                                        (0, $97fa7686fb8e51ed$export$eb3485a690c2f0b8).Owner
                                    ],
                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $9d2af2844f10c458$export$b8a61e5c71402559).UsersManagmentStack.UsersListPage, {
                                        showOnlyUnconfirmed: true
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7df35e9df335b1c8$export$e7b0ac011bb776c6), {
                                route: (0, $0534349ae8731d0b$export$66b32f6f30eb4b4).createUser,
                                children: (params)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4ae5ab5371178941$export$f01b3d7c7bbe3997), {
                                        allowedRoles: [
                                            (0, $97fa7686fb8e51ed$export$eb3485a690c2f0b8).Admin,
                                            (0, $97fa7686fb8e51ed$export$eb3485a690c2f0b8).Owner
                                        ],
                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $9d2af2844f10c458$export$b8a61e5c71402559).UsersManagmentStack.AddUser, {
                                            id: params.id
                                        })
                                    })
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7df35e9df335b1c8$export$e7b0ac011bb776c6), {
                                route: (0, $0534349ae8731d0b$export$66b32f6f30eb4b4).inviteUser,
                                children: (params)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4ae5ab5371178941$export$f01b3d7c7bbe3997), {
                                        allowedRoles: [
                                            (0, $97fa7686fb8e51ed$export$eb3485a690c2f0b8).Admin,
                                            (0, $97fa7686fb8e51ed$export$eb3485a690c2f0b8).Owner
                                        ],
                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $9d2af2844f10c458$export$b8a61e5c71402559).UsersManagmentStack.InviteUser, {
                                            email: params.email
                                        })
                                    })
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7df35e9df335b1c8$export$e7b0ac011bb776c6), {
                                route: (0, $0534349ae8731d0b$export$66b32f6f30eb4b4).completeRegistration,
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $9d2af2844f10c458$export$b8a61e5c71402559).CompleteRegistrationStack.CompleteRegistrationPage, {
                                    navigateToScreenName: "home"
                                })
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7df35e9df335b1c8$export$e7b0ac011bb776c6), {
                                route: (0, $0534349ae8731d0b$export$66b32f6f30eb4b4).signSLA,
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7ae42b63183f30b4$export$8b251419efc915eb), {
                                            title: t("sign_sla.title"),
                                            showBack: true
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $9d2af2844f10c458$export$b8a61e5c71402559).CompleteRegistrationStack.SignSLAPage, {})
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7df35e9df335b1c8$export$e7b0ac011bb776c6), {
                                route: (0, $0534349ae8731d0b$export$66b32f6f30eb4b4).onboardingFinish,
                                children: (p)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $9d2af2844f10c458$export$b8a61e5c71402559).CompleteRegistrationStack.OnboardingFinishedPage, {
                                        navigateToScreenName: p.navigateToScreenName
                                    })
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7df35e9df335b1c8$export$e7b0ac011bb776c6), {
                                route: (0, $0534349ae8731d0b$export$66b32f6f30eb4b4).orders,
                                children: (p)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4ae5ab5371178941$export$f01b3d7c7bbe3997), {
                                        allowedRoles: [
                                            (0, $97fa7686fb8e51ed$export$eb3485a690c2f0b8).Admin,
                                            (0, $97fa7686fb8e51ed$export$eb3485a690c2f0b8).Owner,
                                            (0, $97fa7686fb8e51ed$export$eb3485a690c2f0b8).Manager,
                                            (0, $97fa7686fb8e51ed$export$eb3485a690c2f0b8).Finance
                                        ],
                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $d6286036be37a1b2$export$65f7aeb92040da96), {
                                            value: (0, $d6286036be37a1b2$export$9931f407af1661c3),
                                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $9d2af2844f10c458$export$b8a61e5c71402559).OrderStack.OrdersListPage, {
                                                ordersState: p.ordersState ?? (0, $0f571f43d43ce782$export$819724757aafc79).Unconfirmed
                                            })
                                        })
                                    })
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7df35e9df335b1c8$export$e7b0ac011bb776c6), {
                                route: (0, $0534349ae8731d0b$export$66b32f6f30eb4b4).orderDraft,
                                children: (p)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4ae5ab5371178941$export$f01b3d7c7bbe3997), {
                                        allowedRoles: [
                                            (0, $97fa7686fb8e51ed$export$eb3485a690c2f0b8).Admin,
                                            (0, $97fa7686fb8e51ed$export$eb3485a690c2f0b8).Owner,
                                            (0, $97fa7686fb8e51ed$export$eb3485a690c2f0b8).Manager,
                                            (0, $97fa7686fb8e51ed$export$eb3485a690c2f0b8).Finance
                                        ],
                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $d6286036be37a1b2$export$65f7aeb92040da96), {
                                            value: (0, $d6286036be37a1b2$export$9931f407af1661c3),
                                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $9d2af2844f10c458$export$b8a61e5c71402559).OrderStack.OrderDraftPage, {
                                                orderId: p.orderId,
                                                title: p.title,
                                                isExtension: false
                                            })
                                        })
                                    })
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7df35e9df335b1c8$export$e7b0ac011bb776c6), {
                                route: (0, $0534349ae8731d0b$export$66b32f6f30eb4b4).extendedOrderDraft,
                                children: (p)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4ae5ab5371178941$export$f01b3d7c7bbe3997), {
                                        allowedRoles: [
                                            (0, $97fa7686fb8e51ed$export$eb3485a690c2f0b8).Admin,
                                            (0, $97fa7686fb8e51ed$export$eb3485a690c2f0b8).Owner,
                                            (0, $97fa7686fb8e51ed$export$eb3485a690c2f0b8).Manager,
                                            (0, $97fa7686fb8e51ed$export$eb3485a690c2f0b8).Finance
                                        ],
                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $d6286036be37a1b2$export$65f7aeb92040da96), {
                                            value: (0, $d6286036be37a1b2$export$9931f407af1661c3),
                                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $9d2af2844f10c458$export$b8a61e5c71402559).OrderStack.OrderDraftPage, {
                                                orderId: p.orderId,
                                                title: "Extend Order",
                                                isExtension: true
                                            })
                                        })
                                    })
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7df35e9df335b1c8$export$e7b0ac011bb776c6), {
                                route: (0, $0534349ae8731d0b$export$66b32f6f30eb4b4).orderConfirmation,
                                children: (p)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4ae5ab5371178941$export$f01b3d7c7bbe3997), {
                                        allowedRoles: [
                                            (0, $97fa7686fb8e51ed$export$eb3485a690c2f0b8).Admin,
                                            (0, $97fa7686fb8e51ed$export$eb3485a690c2f0b8).Owner,
                                            (0, $97fa7686fb8e51ed$export$eb3485a690c2f0b8).Manager,
                                            (0, $97fa7686fb8e51ed$export$eb3485a690c2f0b8).Finance
                                        ],
                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $9d2af2844f10c458$export$b8a61e5c71402559).OrderStack.OrderSummaryPage, {
                                            orderId: p.orderId
                                        })
                                    })
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7df35e9df335b1c8$export$e7b0ac011bb776c6), {
                                route: (0, $0534349ae8731d0b$export$66b32f6f30eb4b4).orderDraftSummary,
                                children: (p)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4ae5ab5371178941$export$f01b3d7c7bbe3997), {
                                        allowedRoles: [
                                            (0, $97fa7686fb8e51ed$export$eb3485a690c2f0b8).Admin,
                                            (0, $97fa7686fb8e51ed$export$eb3485a690c2f0b8).Owner,
                                            (0, $97fa7686fb8e51ed$export$eb3485a690c2f0b8).Manager,
                                            (0, $97fa7686fb8e51ed$export$eb3485a690c2f0b8).Finance
                                        ],
                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $9d2af2844f10c458$export$b8a61e5c71402559).OrderStack.OrderDraftSummaryPage, {
                                            orderId: p.orderId,
                                            showAmend: p.showAmend === "true"
                                        })
                                    })
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7df35e9df335b1c8$export$e7b0ac011bb776c6), {
                                route: (0, $0534349ae8731d0b$export$66b32f6f30eb4b4).orderDuplicate,
                                children: (p)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4ae5ab5371178941$export$f01b3d7c7bbe3997), {
                                        allowedRoles: [
                                            (0, $97fa7686fb8e51ed$export$eb3485a690c2f0b8).Admin,
                                            (0, $97fa7686fb8e51ed$export$eb3485a690c2f0b8).Owner,
                                            (0, $97fa7686fb8e51ed$export$eb3485a690c2f0b8).Manager,
                                            (0, $97fa7686fb8e51ed$export$eb3485a690c2f0b8).Finance
                                        ],
                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $9d2af2844f10c458$export$b8a61e5c71402559).OrderStack.OrderDuplicatePage, {
                                            duplicatedOrderId: Number(p.orderId)
                                        })
                                    })
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7df35e9df335b1c8$export$e7b0ac011bb776c6), {
                                route: (0, $0534349ae8731d0b$export$66b32f6f30eb4b4).orderDuplicateChooseJobs,
                                children: (p)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4ae5ab5371178941$export$f01b3d7c7bbe3997), {
                                        allowedRoles: [
                                            (0, $97fa7686fb8e51ed$export$eb3485a690c2f0b8).Admin,
                                            (0, $97fa7686fb8e51ed$export$eb3485a690c2f0b8).Owner,
                                            (0, $97fa7686fb8e51ed$export$eb3485a690c2f0b8).Manager,
                                            (0, $97fa7686fb8e51ed$export$eb3485a690c2f0b8).Finance
                                        ],
                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $9d2af2844f10c458$export$b8a61e5c71402559).OrderStack.OrderDuplicateChooseJobsPage, {
                                            duplicatedOrderId: Number(p.orderId)
                                        })
                                    })
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7df35e9df335b1c8$export$e7b0ac011bb776c6), {
                                route: (0, $0534349ae8731d0b$export$66b32f6f30eb4b4).completeCompanyDetailsForPaymentTerms,
                                children: (p)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $9d2af2844f10c458$export$b8a61e5c71402559).CompleteRegistrationStack.CompleteRegistrationPage, {
                                        navigateToScreenName: "orderDraftSummary",
                                        orderId: p.orderId,
                                        showAmend: p.showAmend
                                    })
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7df35e9df335b1c8$export$e7b0ac011bb776c6), {
                                route: (0, $0534349ae8731d0b$export$66b32f6f30eb4b4).orderCreateSuccess,
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4ae5ab5371178941$export$f01b3d7c7bbe3997), {
                                    allowedRoles: [
                                        (0, $97fa7686fb8e51ed$export$eb3485a690c2f0b8).Admin,
                                        (0, $97fa7686fb8e51ed$export$eb3485a690c2f0b8).Owner,
                                        (0, $97fa7686fb8e51ed$export$eb3485a690c2f0b8).Manager,
                                        (0, $97fa7686fb8e51ed$export$eb3485a690c2f0b8).Finance
                                    ],
                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $9d2af2844f10c458$export$b8a61e5c71402559).OrderStack.OrderConfirmedPage, {})
                                })
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7df35e9df335b1c8$export$e7b0ac011bb776c6), {
                                route: (0, $0534349ae8731d0b$export$66b32f6f30eb4b4).orderRequestSuccess,
                                children: (p)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4ae5ab5371178941$export$f01b3d7c7bbe3997), {
                                        allowedRoles: [
                                            (0, $97fa7686fb8e51ed$export$eb3485a690c2f0b8).Admin,
                                            (0, $97fa7686fb8e51ed$export$eb3485a690c2f0b8).Owner,
                                            (0, $97fa7686fb8e51ed$export$eb3485a690c2f0b8).Manager,
                                            (0, $97fa7686fb8e51ed$export$eb3485a690c2f0b8).Finance
                                        ],
                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $9d2af2844f10c458$export$b8a61e5c71402559).OrderStack.OrderRequestedPage, {
                                            orderId: Number(p.orderId)
                                        })
                                    })
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7df35e9df335b1c8$export$e7b0ac011bb776c6), {
                                route: (0, $0534349ae8731d0b$export$66b32f6f30eb4b4).setJobCategory,
                                children: (p)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4ae5ab5371178941$export$f01b3d7c7bbe3997), {
                                        allowedRoles: [
                                            (0, $97fa7686fb8e51ed$export$eb3485a690c2f0b8).Admin,
                                            (0, $97fa7686fb8e51ed$export$eb3485a690c2f0b8).Owner,
                                            (0, $97fa7686fb8e51ed$export$eb3485a690c2f0b8).Manager,
                                            (0, $97fa7686fb8e51ed$export$eb3485a690c2f0b8).Finance
                                        ],
                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $d6286036be37a1b2$export$65f7aeb92040da96), {
                                            value: (0, $d6286036be37a1b2$export$9931f407af1661c3),
                                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $9d2af2844f10c458$export$b8a61e5c71402559).OrderStack.JobDraftCategoryPage, {
                                                orderId: p.orderId,
                                                draftJobId: p.draftJobId,
                                                stepNumber: p.stepNumber ?? String(1)
                                            })
                                        })
                                    })
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7df35e9df335b1c8$export$e7b0ac011bb776c6), {
                                route: (0, $0534349ae8731d0b$export$66b32f6f30eb4b4).setJobLocation,
                                children: (p)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4ae5ab5371178941$export$f01b3d7c7bbe3997), {
                                        allowedRoles: [
                                            (0, $97fa7686fb8e51ed$export$eb3485a690c2f0b8).Admin,
                                            (0, $97fa7686fb8e51ed$export$eb3485a690c2f0b8).Owner,
                                            (0, $97fa7686fb8e51ed$export$eb3485a690c2f0b8).Manager,
                                            (0, $97fa7686fb8e51ed$export$eb3485a690c2f0b8).Finance
                                        ],
                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $d6286036be37a1b2$export$65f7aeb92040da96), {
                                            value: (0, $d6286036be37a1b2$export$9931f407af1661c3),
                                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $9d2af2844f10c458$export$b8a61e5c71402559).OrderStack.JobDraftLocationPage, {
                                                orderId: p.orderId,
                                                draftJobId: p.draftJobId,
                                                stepNumber: p.stepNumber ? Number(p.stepNumber) : 2,
                                                showStepIndicator: true
                                            })
                                        })
                                    })
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7df35e9df335b1c8$export$e7b0ac011bb776c6), {
                                route: (0, $0534349ae8731d0b$export$66b32f6f30eb4b4).setJobPrice,
                                children: (p)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4ae5ab5371178941$export$f01b3d7c7bbe3997), {
                                        allowedRoles: [
                                            (0, $97fa7686fb8e51ed$export$eb3485a690c2f0b8).Admin,
                                            (0, $97fa7686fb8e51ed$export$eb3485a690c2f0b8).Owner,
                                            (0, $97fa7686fb8e51ed$export$eb3485a690c2f0b8).Manager,
                                            (0, $97fa7686fb8e51ed$export$eb3485a690c2f0b8).Finance
                                        ],
                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $d6286036be37a1b2$export$65f7aeb92040da96), {
                                            value: (0, $d6286036be37a1b2$export$9931f407af1661c3),
                                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $9d2af2844f10c458$export$b8a61e5c71402559).OrderStack.JobDraftPricePage, {
                                                orderId: p.orderId,
                                                draftJobId: p.draftJobId
                                            })
                                        })
                                    })
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7df35e9df335b1c8$export$e7b0ac011bb776c6), {
                                route: (0, $0534349ae8731d0b$export$66b32f6f30eb4b4).jobDraftDetails,
                                children: (p)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4ae5ab5371178941$export$f01b3d7c7bbe3997), {
                                        allowedRoles: [
                                            (0, $97fa7686fb8e51ed$export$eb3485a690c2f0b8).Admin,
                                            (0, $97fa7686fb8e51ed$export$eb3485a690c2f0b8).Owner,
                                            (0, $97fa7686fb8e51ed$export$eb3485a690c2f0b8).Manager,
                                            (0, $97fa7686fb8e51ed$export$eb3485a690c2f0b8).Finance
                                        ],
                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $d6286036be37a1b2$export$65f7aeb92040da96), {
                                            value: (0, $d6286036be37a1b2$export$9931f407af1661c3),
                                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $9d2af2844f10c458$export$b8a61e5c71402559).OrderStack.JobDraftDetailPage, {
                                                orderId: p.orderId,
                                                draftJobId: p.draftJobId,
                                                stepNumber: p.stepNumber,
                                                isExtension: Boolean(Number(p.isExtension))
                                            })
                                        })
                                    })
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7df35e9df335b1c8$export$e7b0ac011bb776c6), {
                                route: (0, $0534349ae8731d0b$export$66b32f6f30eb4b4).jobDraftDetailsPopupField,
                                children: (p)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4ae5ab5371178941$export$f01b3d7c7bbe3997), {
                                        allowedRoles: [
                                            (0, $97fa7686fb8e51ed$export$eb3485a690c2f0b8).Admin,
                                            (0, $97fa7686fb8e51ed$export$eb3485a690c2f0b8).Owner,
                                            (0, $97fa7686fb8e51ed$export$eb3485a690c2f0b8).Manager,
                                            (0, $97fa7686fb8e51ed$export$eb3485a690c2f0b8).Finance
                                        ],
                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $d6286036be37a1b2$export$65f7aeb92040da96), {
                                            value: (0, $d6286036be37a1b2$export$9931f407af1661c3),
                                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $9d2af2844f10c458$export$b8a61e5c71402559).OrderStack.JobDraftDetailPage, {
                                                orderId: p.orderId,
                                                draftJobId: p.draftJobId,
                                                activePopupField: p.popupField,
                                                stepNumber: p.stepNumber,
                                                isExtension: Boolean(Number(p.isExtension))
                                            })
                                        })
                                    })
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7df35e9df335b1c8$export$e7b0ac011bb776c6), {
                                route: (0, $0534349ae8731d0b$export$66b32f6f30eb4b4).signUp,
                                children: (p)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $9d2af2844f10c458$export$b8a61e5c71402559).AuthStack.SignUpPage, {
                                        redirectTo: p.redirect
                                    })
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7df35e9df335b1c8$export$e7b0ac011bb776c6), {
                                route: (0, $0534349ae8731d0b$export$66b32f6f30eb4b4).login,
                                children: (params)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $9d2af2844f10c458$export$b8a61e5c71402559).AuthStack.LoginPage, {
                                        onLogin: ()=>{
                                            if (params.url && !(0, $bsQZT.isLocalDevelopmentEnvironment)()) {
                                                window.location.href = params.url;
                                                return;
                                            }
                                            redirect((0, $0534349ae8731d0b$export$66b32f6f30eb4b4).index, {});
                                        }
                                    })
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7df35e9df335b1c8$export$e7b0ac011bb776c6), {
                                route: (0, $0534349ae8731d0b$export$66b32f6f30eb4b4).forgotPassword,
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $9d2af2844f10c458$export$b8a61e5c71402559).AuthStack.ForgotPasswordPage, {})
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7df35e9df335b1c8$export$e7b0ac011bb776c6), {
                                route: (0, $0534349ae8731d0b$export$66b32f6f30eb4b4).verifyEmail,
                                children: ({ email: email })=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $9d2af2844f10c458$export$b8a61e5c71402559).AuthStack.VerifyEmailPage, {
                                        email: email
                                    })
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7df35e9df335b1c8$export$e7b0ac011bb776c6), {
                                route: (0, $0534349ae8731d0b$export$66b32f6f30eb4b4).resetPassword,
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $9d2af2844f10c458$export$b8a61e5c71402559).AuthStack.ResetPasswordPage, {})
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7df35e9df335b1c8$export$e7b0ac011bb776c6), {
                                route: (0, $0534349ae8731d0b$export$66b32f6f30eb4b4).changePassword,
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $9d2af2844f10c458$export$b8a61e5c71402559).AuthStack.ChangePasswordPage, {})
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7df35e9df335b1c8$export$e7b0ac011bb776c6), {
                                route: (0, $0534349ae8731d0b$export$66b32f6f30eb4b4).jobRatingRequests,
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4ae5ab5371178941$export$f01b3d7c7bbe3997), {
                                    allowedRoles: [
                                        (0, $97fa7686fb8e51ed$export$eb3485a690c2f0b8).Admin,
                                        (0, $97fa7686fb8e51ed$export$eb3485a690c2f0b8).Owner,
                                        (0, $97fa7686fb8e51ed$export$eb3485a690c2f0b8).Manager
                                    ],
                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $9d2af2844f10c458$export$b8a61e5c71402559).RatingRequestsStack.RatingRequestsListPage, {})
                                })
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7df35e9df335b1c8$export$e7b0ac011bb776c6), {
                                route: (0, $0534349ae8731d0b$export$66b32f6f30eb4b4).jobRatingDetails,
                                children: ({ id: id })=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $4ae5ab5371178941$export$f01b3d7c7bbe3997), {
                                        allowedRoles: [
                                            (0, $97fa7686fb8e51ed$export$eb3485a690c2f0b8).Admin,
                                            (0, $97fa7686fb8e51ed$export$eb3485a690c2f0b8).Owner,
                                            (0, $97fa7686fb8e51ed$export$eb3485a690c2f0b8).Manager
                                        ],
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7ae42b63183f30b4$export$8b251419efc915eb), {
                                                title: t("job_rating.title"),
                                                showBack: true
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $9d2af2844f10c458$export$b8a61e5c71402559).RatingRequestsStack.JobRatingPage, {
                                                id: id
                                            })
                                        ]
                                    })
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7df35e9df335b1c8$export$e7b0ac011bb776c6), {
                                route: (0, $0534349ae8731d0b$export$66b32f6f30eb4b4).setPasswordToHire,
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7ae42b63183f30b4$export$8b251419efc915eb), {
                                        title: t("onboarding.create_password")
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $9d2af2844f10c458$export$b8a61e5c71402559).AuthStack.CreatePasswordPage, {
                                        navigateToScreenName: "home"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7df35e9df335b1c8$export$e7b0ac011bb776c6), {
                                route: (0, $0534349ae8731d0b$export$66b32f6f30eb4b4).setCompanyDetailsToHire,
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $9d2af2844f10c458$export$b8a61e5c71402559).CompleteRegistrationStack.CompleteRegistrationPage, {
                                    navigateToScreenName: "home"
                                })
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7df35e9df335b1c8$export$e7b0ac011bb776c6), {
                                route: (0, $0534349ae8731d0b$export$66b32f6f30eb4b4).setPasswordToManageSchedule,
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7ae42b63183f30b4$export$8b251419efc915eb), {
                                        title: t("onboarding.create_password")
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $9d2af2844f10c458$export$b8a61e5c71402559).AuthStack.CreatePasswordPage, {
                                        navigateToScreenName: "all-jobs"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7df35e9df335b1c8$export$e7b0ac011bb776c6), {
                                route: (0, $0534349ae8731d0b$export$66b32f6f30eb4b4).setCompanyDetailsToManageSchedule,
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $9d2af2844f10c458$export$b8a61e5c71402559).CompleteRegistrationStack.CompleteRegistrationPage, {
                                    navigateToScreenName: "all-jobs"
                                })
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7df35e9df335b1c8$export$e7b0ac011bb776c6), {
                                route: (0, $0534349ae8731d0b$export$66b32f6f30eb4b4).knowledgeCenter,
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $9d2af2844f10c458$export$b8a61e5c71402559).KnowledgeCenter, {})
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7df35e9df335b1c8$export$e7b0ac011bb776c6), {
                                route: (0, $0534349ae8731d0b$export$66b32f6f30eb4b4).signUpWithOrder,
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $9d2af2844f10c458$export$b8a61e5c71402559).SignUpWithOrderStack.SelectCategoryPage, {})
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7df35e9df335b1c8$export$e7b0ac011bb776c6), {
                                route: (0, $0534349ae8731d0b$export$66b32f6f30eb4b4).signUpWithOrderForm,
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $d6286036be37a1b2$export$65f7aeb92040da96), {
                                    value: (0, $d6286036be37a1b2$export$9931f407af1661c3),
                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $9d2af2844f10c458$export$b8a61e5c71402559).SignUpWithOrderStack.RegisterClientPage, {})
                                })
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7df35e9df335b1c8$export$e7b0ac011bb776c6), {
                                route: (0, $0534349ae8731d0b$export$66b32f6f30eb4b4).confirmClientInvitation,
                                children: (params)=>{
                                    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $9d2af2844f10c458$export$b8a61e5c71402559).ConfirmClientInvitationStack.ConfirmClientInvitationPage, {
                                        clientId: params.clientId
                                    });
                                }
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7df35e9df335b1c8$export$e7b0ac011bb776c6), {
                                route: (0, $0534349ae8731d0b$export$66b32f6f30eb4b4).paymentList,
                                children: (params)=>{
                                    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4ae5ab5371178941$export$f01b3d7c7bbe3997), {
                                        allowedRoles: [
                                            (0, $97fa7686fb8e51ed$export$eb3485a690c2f0b8).Admin,
                                            (0, $97fa7686fb8e51ed$export$eb3485a690c2f0b8).Owner,
                                            (0, $97fa7686fb8e51ed$export$eb3485a690c2f0b8).Finance
                                        ],
                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $9d2af2844f10c458$export$b8a61e5c71402559).PaymentStack.PaymentListPage, {
                                            paymentStatus: params.paymentStatus ?? (0, $ace4c335912c9e96$export$999f810846f9d31d).Pending
                                        })
                                    });
                                }
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7df35e9df335b1c8$export$e7b0ac011bb776c6), {
                                route: (0, $0534349ae8731d0b$export$66b32f6f30eb4b4).paymentDetails,
                                children: (params)=>{
                                    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4ae5ab5371178941$export$f01b3d7c7bbe3997), {
                                        allowedRoles: [
                                            (0, $97fa7686fb8e51ed$export$eb3485a690c2f0b8).Admin,
                                            (0, $97fa7686fb8e51ed$export$eb3485a690c2f0b8).Owner,
                                            (0, $97fa7686fb8e51ed$export$eb3485a690c2f0b8).Finance
                                        ],
                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $9d2af2844f10c458$export$b8a61e5c71402559).PaymentStack.PaymentDetailsPage, {
                                            paymentId: Number(params.paymentId),
                                            hideBack: params.hideBack
                                        })
                                    });
                                }
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7df35e9df335b1c8$export$e7b0ac011bb776c6), {
                                route: (0, $0534349ae8731d0b$export$66b32f6f30eb4b4).payWithCard,
                                children: (params)=>{
                                    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4ae5ab5371178941$export$f01b3d7c7bbe3997), {
                                        allowedRoles: [
                                            (0, $97fa7686fb8e51ed$export$eb3485a690c2f0b8).Admin,
                                            (0, $97fa7686fb8e51ed$export$eb3485a690c2f0b8).Owner,
                                            (0, $97fa7686fb8e51ed$export$eb3485a690c2f0b8).Finance
                                        ],
                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $9d2af2844f10c458$export$b8a61e5c71402559).PaymentStack.StripePaymentStack.PayWithCardPage, {
                                            paymentId: Number(params.paymentId),
                                            paymentOptions: params.paymentOptions
                                        })
                                    });
                                }
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7df35e9df335b1c8$export$e7b0ac011bb776c6), {
                                route: (0, $0534349ae8731d0b$export$66b32f6f30eb4b4).cardPaymentStatus,
                                children: (params)=>{
                                    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4ae5ab5371178941$export$f01b3d7c7bbe3997), {
                                        allowedRoles: [
                                            (0, $97fa7686fb8e51ed$export$eb3485a690c2f0b8).Admin,
                                            (0, $97fa7686fb8e51ed$export$eb3485a690c2f0b8).Owner,
                                            (0, $97fa7686fb8e51ed$export$eb3485a690c2f0b8).Finance
                                        ],
                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $9d2af2844f10c458$export$b8a61e5c71402559).PaymentStack.StripePaymentStack.CardPaymentStatusPage, {
                                            paymentId: Number(params.paymentId),
                                            paymentOptions: params.paymentOptions
                                        })
                                    });
                                }
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7df35e9df335b1c8$export$e7b0ac011bb776c6), {
                                route: (0, $0534349ae8731d0b$export$66b32f6f30eb4b4).paymentMethodsList,
                                children: (params)=>{
                                    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4ae5ab5371178941$export$f01b3d7c7bbe3997), {
                                        allowedRoles: [
                                            (0, $97fa7686fb8e51ed$export$eb3485a690c2f0b8).Admin,
                                            (0, $97fa7686fb8e51ed$export$eb3485a690c2f0b8).Owner,
                                            (0, $97fa7686fb8e51ed$export$eb3485a690c2f0b8).Finance
                                        ],
                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $9d2af2844f10c458$export$b8a61e5c71402559).PaymentStack.PaymentMethodsPage, {
                                            paymentId: Number(params.paymentId),
                                            paymentOptions: params.paymentOptions
                                        })
                                    });
                                }
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7df35e9df335b1c8$export$e7b0ac011bb776c6), {
                                route: (0, $0534349ae8731d0b$export$66b32f6f30eb4b4).payWithSavedCard,
                                children: (params)=>{
                                    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4ae5ab5371178941$export$f01b3d7c7bbe3997), {
                                        allowedRoles: [
                                            (0, $97fa7686fb8e51ed$export$eb3485a690c2f0b8).Admin,
                                            (0, $97fa7686fb8e51ed$export$eb3485a690c2f0b8).Owner,
                                            (0, $97fa7686fb8e51ed$export$eb3485a690c2f0b8).Finance
                                        ],
                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $9d2af2844f10c458$export$b8a61e5c71402559).PaymentStack.StripePaymentStack.PayWithSavedCardPage, {
                                            paymentId: Number(params.paymentId),
                                            cardId: params.cardId,
                                            paymentOptions: params.paymentOptions
                                        })
                                    });
                                }
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7df35e9df335b1c8$export$e7b0ac011bb776c6), {
                                route: (0, $0534349ae8731d0b$export$66b32f6f30eb4b4).accountStatement,
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4ae5ab5371178941$export$f01b3d7c7bbe3997), {
                                    allowedRoles: [
                                        (0, $97fa7686fb8e51ed$export$eb3485a690c2f0b8).Admin,
                                        (0, $97fa7686fb8e51ed$export$eb3485a690c2f0b8).Owner,
                                        (0, $97fa7686fb8e51ed$export$eb3485a690c2f0b8).Finance
                                    ],
                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $9d2af2844f10c458$export$b8a61e5c71402559).PaymentStack.AccountStatementPage, {})
                                })
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7df35e9df335b1c8$export$e7b0ac011bb776c6), {
                                route: (0, $0534349ae8731d0b$export$66b32f6f30eb4b4).wireTransferDetails,
                                children: (params)=>{
                                    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4ae5ab5371178941$export$f01b3d7c7bbe3997), {
                                        allowedRoles: [
                                            (0, $97fa7686fb8e51ed$export$eb3485a690c2f0b8).Admin,
                                            (0, $97fa7686fb8e51ed$export$eb3485a690c2f0b8).Owner,
                                            (0, $97fa7686fb8e51ed$export$eb3485a690c2f0b8).Finance
                                        ],
                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $9d2af2844f10c458$export$b8a61e5c71402559).PaymentStack.WireTransferStack.WireTransferDetailsPage, {
                                            paymentId: Number(params.paymentId)
                                        })
                                    });
                                }
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7df35e9df335b1c8$export$e7b0ac011bb776c6), {
                                route: (0, $0534349ae8731d0b$export$66b32f6f30eb4b4).wireTransferUploadSlip,
                                children: (params)=>{
                                    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4ae5ab5371178941$export$f01b3d7c7bbe3997), {
                                        allowedRoles: [
                                            (0, $97fa7686fb8e51ed$export$eb3485a690c2f0b8).Admin,
                                            (0, $97fa7686fb8e51ed$export$eb3485a690c2f0b8).Owner,
                                            (0, $97fa7686fb8e51ed$export$eb3485a690c2f0b8).Finance
                                        ],
                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $9d2af2844f10c458$export$b8a61e5c71402559).PaymentStack.WireTransferStack.WireTransferUploadSlipPage, {
                                            paymentId: Number(params.paymentId)
                                        })
                                    });
                                }
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7df35e9df335b1c8$export$e7b0ac011bb776c6), {
                                route: (0, $0534349ae8731d0b$export$66b32f6f30eb4b4).savedPaymentMethods,
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $9d2af2844f10c458$export$b8a61e5c71402559).PaymentStack.SavedPaymentMethodsPage, {})
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7df35e9df335b1c8$export$e7b0ac011bb776c6), {
                                route: (0, $0534349ae8731d0b$export$66b32f6f30eb4b4).saveCard,
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $9d2af2844f10c458$export$b8a61e5c71402559).PaymentStack.SaveCardPage, {})
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7df35e9df335b1c8$export$e7b0ac011bb776c6), {
                                route: (0, $0534349ae8731d0b$export$66b32f6f30eb4b4).affiliateDashboard,
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $9d2af2844f10c458$export$b8a61e5c71402559).AffiliateStack.DashboardPage, {})
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7df35e9df335b1c8$export$e7b0ac011bb776c6), {
                                route: (0, $0534349ae8731d0b$export$66b32f6f30eb4b4).affiliateReferralsList,
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $9d2af2844f10c458$export$b8a61e5c71402559).AffiliateStack.ReferralsListPage, {})
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7df35e9df335b1c8$export$e7b0ac011bb776c6), {
                                route: (0, $0534349ae8731d0b$export$66b32f6f30eb4b4).affiliateEarnings,
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $9d2af2844f10c458$export$b8a61e5c71402559).AffiliateStack.EarningsPage, {})
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7df35e9df335b1c8$export$e7b0ac011bb776c6), {
                                route: (0, $0534349ae8731d0b$export$66b32f6f30eb4b4).disputes,
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $9d2af2844f10c458$export$b8a61e5c71402559).DisputesStack.DisputesListPage, {})
                            })
                        ]
                    })
                ]
            })
        ]
    });
});









const $722e2959724a6a4c$export$a311ea62b3b095e3 = ({ resetError: resetError })=>{
    const { t: t } = (0, $3765cebd031b52c0$export$9fc83ad70ead8663)();
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        className: "TooManyAttempts",
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
            className: "TooManyAttempts__container",
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h2", {
                    className: "TooManyAttempts__modalTitle",
                    children: t("too_many_attempts.title")
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                    children: t("too_many_attempts.description")
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                    onClick: ()=>{
                        resetError();
                        window.history.back();
                    },
                    className: "TooManyAttempts__backButton",
                    children: t("too_many_attempts.ok")
                })
            ]
        })
    });
};





var $d88af97409921e2d$exports = {};
$d88af97409921e2d$exports = new URL("404.32289b14.svg", import.meta.url).toString();



const $64e76f76e5e9cd9c$var$PageNotFound = ({ resetError: resetError })=>{
    const { t: t } = (0, $3765cebd031b52c0$export$9fc83ad70ead8663)();
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        className: "PageNotFound",
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
            className: "PageNotFound__container",
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                    src: (0, (/*@__PURE__*/$parcel$interopDefault($d88af97409921e2d$exports)))
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h2", {
                    className: "PageNotFound__modalTitle",
                    children: t("page_not_found.title")
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                    children: t("page_not_found.description")
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                    onClick: ()=>{
                        resetError();
                        window.history.back();
                    },
                    className: "PageNotFound__backButton",
                    children: t("page_not_found.go_back")
                })
            ]
        })
    });
};
var $64e76f76e5e9cd9c$export$2e2bcd8739ae039 = $64e76f76e5e9cd9c$var$PageNotFound;



var $acw62 = parcelRequire("acw62");










const $07c7f218d0115690$var$NotAuthorizedError = ({ resetError: resetError })=>{
    const navigate = (0, $7df35e9df335b1c8$export$602eaf6d5314ce55)();
    const { logoutLocal: logoutLocal } = (0, $4671947198ddd366$export$6ccbb43953eebf8)().data;
    const { t: t } = (0, $3765cebd031b52c0$export$9fc83ad70ead8663)();
    (0, $acw62.useEffect)(()=>{
        (0, $60f27fc97e29822a$export$b410431fab84fa58).warning(t("not_authorized_error.toast_title"));
        const currentURI = window.location.pathname + window.location.search + window.location.hash;
        logoutLocal();
        resetError();
        navigate((0, $0534349ae8731d0b$export$66b32f6f30eb4b4).login, {
            url: currentURI
        });
        (0, $34dcbefa7de5eb80$export$cd7f480d6b8286c3)((0, $7aceeb47c0737ee6$export$27753d0cccbc03ed));
        (0, $34dcbefa7de5eb80$export$cd7f480d6b8286c3)((0, $d6286036be37a1b2$export$cfb849cb1a33bd13));
        (0, $c74a0566d4b0fd6d$export$e9db7d6e73593439).resetUser();
    }, []);
    return null;
};
var $07c7f218d0115690$export$2e2bcd8739ae039 = $07c7f218d0115690$var$NotAuthorizedError;




var $56d7fb3d289ae2cc$exports = {};
$56d7fb3d289ae2cc$exports = new URL("not-authorized-error.33ff94a7.svg", import.meta.url).toString();



const $625560fee502a445$var$PermissionError = ({ resetError: resetError })=>{
    const { t: t } = (0, $3765cebd031b52c0$export$9fc83ad70ead8663)();
    const handleBack = ()=>{
        window.history.back();
        resetError();
    };
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        className: "PermissionError",
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
            className: "PermissionError__container",
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                    src: (0, (/*@__PURE__*/$parcel$interopDefault($56d7fb3d289ae2cc$exports)))
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h2", {
                    className: "PermissionError__modalTitle",
                    children: t("permission_error.title")
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                    onClick: handleBack,
                    className: "PermissionError__backButton",
                    children: t("permission_error.back")
                })
            ]
        })
    });
};
var $625560fee502a445$export$2e2bcd8739ae039 = $625560fee502a445$var$PermissionError;



const $f1c9cfb277e9691b$export$e926676385687eaf = (0, $8e804a82739c7971$export$6cfc2d1b06699e89)((props)=>{
    const tryAgain = ()=>{
        props.resetError();
    };
    const { t: t } = (0, $3765cebd031b52c0$export$9fc83ad70ead8663)();
    const error = props.error;
    if (error !== null) {
        if (error instanceof (0, $9ad33fbf770c55a1$export$f2e832acab1bdd79)) {
            if (error.type === (0, $9ad33fbf770c55a1$export$9696fcf1798e1cb5).ServerError) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($f1c9cfb277e9691b$var$ErrorView, {
                tryAgain: tryAgain,
                children: t("error_boundary.default.server_error")
            });
            if (error.type === (0, $9ad33fbf770c55a1$export$9696fcf1798e1cb5).ConnectionError) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($f1c9cfb277e9691b$var$ErrorView, {
                tryAgain: tryAgain,
                children: t("error_boundary.default.connection_error")
            });
            if (error.type === (0, $9ad33fbf770c55a1$export$9696fcf1798e1cb5).TooManyRequestsError) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $722e2959724a6a4c$export$a311ea62b3b095e3), {
                resetError: props.resetError
            });
            if (error.type === (0, $9ad33fbf770c55a1$export$9696fcf1798e1cb5).NotFound) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $64e76f76e5e9cd9c$export$2e2bcd8739ae039), {
                resetError: props.resetError
            });
            if (error.type === (0, $9ad33fbf770c55a1$export$9696fcf1798e1cb5).AuthError) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $07c7f218d0115690$export$2e2bcd8739ae039), {
                resetError: props.resetError
            });
            if (error.type === (0, $9ad33fbf770c55a1$export$9696fcf1798e1cb5).PermissionError) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $625560fee502a445$export$2e2bcd8739ae039), {
                resetError: props.resetError
            });
        }
        return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($f1c9cfb277e9691b$var$ErrorView, {
            children: t("error_boundary.default.default_error")
        });
    }
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7b02d682eb115277$exports.Fragment), {
        children: props.children
    });
}, {
    didCatch: (0, $0c0f53a5cea85ce7$export$9e0ff99299d29cce)
});
function $f1c9cfb277e9691b$var$ErrorView(props) {
    const { t: t } = (0, $3765cebd031b52c0$export$9fc83ad70ead8663)();
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        children: [
            props.children,
            props.tryAgain && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                    onClick: props.tryAgain,
                    children: t("error_boundary.default.try_again")
                })
            })
        ]
    });
}



var $bsQZT = parcelRequire("bsQZT");








var $kLorN = parcelRequire("kLorN");



























const $e3e74011bb6888bb$export$57edc697ae8c38e = ({ profileImgURL: profileImgURL, title: title, showBack: showBack, handleBackClick: handleBackClick, subTitle: subTitle, rightComponent: rightComponent, hideLogo: hideLogo, hideQRScanner: hideQRScanner })=>{
    const navigateBack = ()=>window.history.back();
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        className: "MarketDesktopHeaderBox",
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
            className: "MarketDesktopHeaderBox__container",
            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "MarketDesktopHeader",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $660b2ca422e0e2ae$export$1ff3c3f08ae963c0).Vertical, {
                        height: 24
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "MarketDesktopHeader__container",
                        children: (0, $7df35e9df335b1c8$export$e8c52816aa4ad75a)() ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                    className: "MarketDesktopHeader__main-left",
                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                                        src: (0, (/*@__PURE__*/$parcel$interopDefault($3279ad32455be7ff$exports))),
                                        className: `MarketDesktopHeader__logo ${hideLogo ? "hidden" : ""}`
                                    })
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                    className: "MarketDesktopHeader__main-right",
                                    children: [
                                        !hideQRScanner && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $d836dbae630d7085$export$d96d49503bc30c36), {
                                            style: {
                                                marginRight: "50px"
                                            }
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $078111f863688379$export$8a92d876e077621), {}),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $660b2ca422e0e2ae$export$1ff3c3f08ae963c0).Horizontal, {
                                            width: 23
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ee10b48b1a4ae429$export$5b639964e6e432d6), {
                                            imageURL: profileImgURL ?? ""
                                        })
                                    ]
                                })
                            ]
                        }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                            children: [
                                showBack ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                                    className: "MarketDesktopHeader__back",
                                    src: (0, (/*@__PURE__*/$parcel$interopDefault($44d71c4ff22dfd33$exports))),
                                    alt: "go back",
                                    onClick: handleBackClick ?? navigateBack
                                }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                    className: "MarketDesktopHeader__main__separator"
                                }),
                                Boolean(title) && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h1", {
                                            className: "MarketDesktopHeader__title",
                                            children: title
                                        }),
                                        Boolean(subTitle) && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                            className: "MarketMobileHeader__subTitle",
                                            children: subTitle
                                        })
                                    ]
                                }),
                                rightComponent ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                    className: "MarketDesktopHeader__main-right",
                                    children: rightComponent
                                }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                    className: "MarketDesktopHeader__main__separator"
                                })
                            ]
                        })
                    })
                ]
            })
        })
    });
};


var $fb6fcc1d873b59a1$exports = {};
$fb6fcc1d873b59a1$exports = new URL("collaboration.c539cf90.svg", import.meta.url).toString();


var $5fa2977519fcc859$exports = {};
$5fa2977519fcc859$exports = new URL("puzzle.5ac5349e.svg", import.meta.url).toString();


var $c1716abd7a0a2e55$exports = {};
$c1716abd7a0a2e55$exports = new URL("mobile.b1f3b990.svg", import.meta.url).toString();


var $582c8e8c9978546c$exports = {};
$582c8e8c9978546c$exports = new URL("savings.537e32cf.svg", import.meta.url).toString();


var $d5b0be52e1c2a4b0$exports = {};
$d5b0be52e1c2a4b0$exports = new URL("arrow-left.72b0950b.svg", import.meta.url).toString();


var $2ab2814bb2bffd4f$exports = {};
$2ab2814bb2bffd4f$exports = new URL("arrow-right.d0cc8e11.svg", import.meta.url).toString();





const $6b4a2d2701f90d01$var$CAROUSEL_AUTOPLAY_DURATION = 10000;
const $6b4a2d2701f90d01$export$171cf93cb8c45e5d = (0, $aca50e9407ba89c9$export$b6ae1bc530f4c149)(()=>{
    const { getProfile: getProfile, profile: profile, companyDetails: companyDetails, "get\u0421ompanyDetails": get\u0421ompanyDetails } = (0, $4671947198ddd366$export$6ccbb43953eebf8)().data;
    const { isLoading: profileLoading } = (0, $4671947198ddd366$export$dd0a697e1782aedd)(getProfile);
    const { isLoading: isCompanyDetailsLoading } = (0, $4671947198ddd366$export$dd0a697e1782aedd)(get\u0421ompanyDetails);
    const isCorporate = Boolean(companyDetails?.is_corporate);
    const redirect = (0, $7df35e9df335b1c8$export$602eaf6d5314ce55)();
    const { t: t } = (0, $3765cebd031b52c0$export$9fc83ad70ead8663)();
    const carouselSlides = [
        {
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($fb6fcc1d873b59a1$exports))),
            iconWidth: "327px",
            title: t("home.coming_soon.we_are_coming_soon"),
            subtitle: t("home.coming_soon.prepare_for_launch")
        },
        {
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($5fa2977519fcc859$exports))),
            iconWidth: "327px",
            title: t("home.coming_soon.on_demand_staff"),
            subtitle: t("home.coming_soon.find_workers")
        },
        {
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($c1716abd7a0a2e55$exports))),
            iconWidth: "250px",
            title: t("home.coming_soon.short_term_contracts"),
            subtitle: t("home.coming_soon.post_jobs")
        },
        {
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($582c8e8c9978546c$exports))),
            iconWidth: "250px",
            title: t("home.coming_soon.incredible_savings"),
            subtitle: t("home.coming_soon.save_money")
        }
    ];
    if (profileLoading) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $57fb8f45c69e1681$export$2e2bcd8739ae039), {});
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "GrStartPage",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e3e74011bb6888bb$export$57edc697ae8c38e), {
                profileImgURL: profile?.image,
                hideLogo: false,
                hideQRScanner: true
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $660b2ca422e0e2ae$export$1ff3c3f08ae963c0).Vertical, {
                height: 40
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("h1", {
                className: "GrStartPage__title",
                children: [
                    t("home.coming_soon.hello"),
                    ", ",
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                        className: "highlighted",
                        children: profile?.first_name
                    }),
                    "\uD83D\uDC4B"
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $80ed0340bf7aa3fb$export$2e2bcd8739ae039), {
                arrows: true,
                prevArrow: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                    src: (0, (/*@__PURE__*/$parcel$interopDefault($d5b0be52e1c2a4b0$exports)))
                }),
                nextArrow: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                    src: (0, (/*@__PURE__*/$parcel$interopDefault($2ab2814bb2bffd4f$exports)))
                }),
                swipe: true,
                draggable: true,
                autoplay: true,
                autoplaySpeed: $6b4a2d2701f90d01$var$CAROUSEL_AUTOPLAY_DURATION,
                children: carouselSlides.map((slide, index)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "GrStartPage__slide",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                                src: slide.icon,
                                width: slide.iconWidth
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                className: "GrStartPage__slide__title",
                                children: slide.title
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                className: "GrStartPage__slide__subtitle",
                                children: slide.subtitle
                            })
                        ]
                    }, index))
            }),
            !isCompanyDetailsLoading && !isCorporate && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                onClick: ()=>redirect((0, $0534349ae8731d0b$export$66b32f6f30eb4b4).completeRegistration, {}),
                className: "GrStartPage__actionButton",
                children: t("profile_form.register_corporate")
            })
        ]
    });
});




const $e83f55bc0ff8e1ae$export$11b7655053a12984 = (0, $aca50e9407ba89c9$export$b6ae1bc530f4c149)(()=>{
    const { logged: logged } = (0, $4671947198ddd366$export$6ccbb43953eebf8)().data;
    const redirect = (0, $7df35e9df335b1c8$export$602eaf6d5314ce55)();
    (0, $1eb7b80ad2b5a7c5$export$46de9ba7af305689)();
    const { t: t } = (0, $3765cebd031b52c0$export$9fc83ad70ead8663)();
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        id: "main_layout",
        className: "AppLayout",
        style: logged && (0, $7df35e9df335b1c8$export$e8c52816aa4ad75a)() ? {
            background: "#fff"
        } : {},
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                id: "modals"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("main", {
                className: "AppLayout__main",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7df35e9df335b1c8$export$e7b0ac011bb776c6), {
                        route: (0, $0534349ae8731d0b$export$66b32f6f30eb4b4).index,
                        children: logged ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $6b4a2d2701f90d01$export$171cf93cb8c45e5d), {}) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $9d2af2844f10c458$export$b8a61e5c71402559).AuthStack.LoginPage, {
                            onLogin: ()=>redirect((0, $0534349ae8731d0b$export$66b32f6f30eb4b4).index, {})
                        })
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7df35e9df335b1c8$export$e7b0ac011bb776c6), {
                        route: (0, $0534349ae8731d0b$export$66b32f6f30eb4b4).signUp,
                        children: (p)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $9d2af2844f10c458$export$b8a61e5c71402559).AuthStack.SignUpPage, {
                                redirectTo: p.redirect
                            })
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7df35e9df335b1c8$export$e7b0ac011bb776c6), {
                        route: (0, $0534349ae8731d0b$export$66b32f6f30eb4b4).login,
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $9d2af2844f10c458$export$b8a61e5c71402559).AuthStack.LoginPage, {
                            onLogin: ()=>redirect((0, $0534349ae8731d0b$export$66b32f6f30eb4b4).index, {})
                        })
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7df35e9df335b1c8$export$e7b0ac011bb776c6), {
                        route: (0, $0534349ae8731d0b$export$66b32f6f30eb4b4).forgotPassword,
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $9d2af2844f10c458$export$b8a61e5c71402559).AuthStack.ForgotPasswordPage, {})
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7df35e9df335b1c8$export$e7b0ac011bb776c6), {
                        route: (0, $0534349ae8731d0b$export$66b32f6f30eb4b4).resetPassword,
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $9d2af2844f10c458$export$b8a61e5c71402559).AuthStack.ResetPasswordPage, {})
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7df35e9df335b1c8$export$e7b0ac011bb776c6), {
                        route: (0, $0534349ae8731d0b$export$66b32f6f30eb4b4).editProfile,
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $4ae5ab5371178941$export$f01b3d7c7bbe3997), {
                            allowedRoles: [
                                (0, $97fa7686fb8e51ed$export$eb3485a690c2f0b8).Admin,
                                (0, $97fa7686fb8e51ed$export$eb3485a690c2f0b8).Owner
                            ],
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7ae42b63183f30b4$export$8b251419efc915eb), {
                                    title: t("profile_form.title")
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $9d2af2844f10c458$export$b8a61e5c71402559).ProfileStack.ProfileFormPage, {})
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7df35e9df335b1c8$export$e7b0ac011bb776c6), {
                        route: (0, $0534349ae8731d0b$export$66b32f6f30eb4b4).completeRegistration,
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e3e74011bb6888bb$export$57edc697ae8c38e), {
                                    title: t("complete_registration.title"),
                                    hideLogo: false
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $9d2af2844f10c458$export$b8a61e5c71402559).CompleteRegistrationStack.CompleteRegistrationPage, {
                                    navigateToScreenName: "home"
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7df35e9df335b1c8$export$e7b0ac011bb776c6), {
                        route: (0, $0534349ae8731d0b$export$66b32f6f30eb4b4).signSLA,
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e3e74011bb6888bb$export$57edc697ae8c38e), {
                                    title: t("sign_sla.title"),
                                    hideLogo: false,
                                    showBack: true
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $9d2af2844f10c458$export$b8a61e5c71402559).CompleteRegistrationStack.SignSLAPage, {})
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7df35e9df335b1c8$export$e7b0ac011bb776c6), {
                        route: (0, $0534349ae8731d0b$export$66b32f6f30eb4b4).onboardingFinish,
                        children: (p)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $9d2af2844f10c458$export$b8a61e5c71402559).CompleteRegistrationStack.OnboardingFinishedPage, {
                                navigateToScreenName: p.navigateToScreenName
                            })
                    })
                ]
            })
        ]
    });
});



if ((0, (/*@__PURE__*/$parcel$interopDefault($81292b5b491156fc$exports))).defaultStyles.overlay) {
    (0, (/*@__PURE__*/$parcel$interopDefault($81292b5b491156fc$exports))).defaultStyles.overlay.backgroundColor = "rgba(0,0,0, 0.2)";
    (0, (/*@__PURE__*/$parcel$interopDefault($81292b5b491156fc$exports))).defaultStyles.overlay.height = "100%";
    (0, (/*@__PURE__*/$parcel$interopDefault($81292b5b491156fc$exports))).defaultStyles.overlay.overflow = "auto";
    (0, (/*@__PURE__*/$parcel$interopDefault($81292b5b491156fc$exports))).defaultStyles.overlay.paddingTop = "50px";
}
(0, $8aadbb076e78b446$export$5c0c0a0f4bf15c0f)({
    download: (0, $97ceb908306849fc$export$a6a7b3d614e2e0ac).downloadFile
});
const $1c0cc537f6748418$var$firebaseApp = (0, $57d436074e210fb5$export$c55cfd413944906d)((0, $bsQZT.config).FIREBASE_WEB_CONFIG);
(0, $0d15f034d14801d0$export$b0297573c90085aa)($1c0cc537f6748418$var$firebaseApp);
const $1c0cc537f6748418$export$6f57813fe9f31bf9 = (0, $7aceeb47c0737ee6$export$7efad43d6906781a)();
function $1c0cc537f6748418$export$86fbec116b87613f() {
    const [layoutDirection, setLayoutDirection] = (0, $acw62.useState)("ltr");
    (0, $acw62.useEffect)(()=>{
        const language = (0, $73ccb33f5de6f5aa$export$daa49e131b652e5b).getCurrentLanguage();
        (0, (/*@__PURE__*/$parcel$interopDefault($45fvw))).locale(language ?? (0, $73ccb33f5de6f5aa$export$449b009f68cc9554));
        setLayoutDirection((0, $673ff3dfc4a496de$export$2e2bcd8739ae039).dir((0, $673ff3dfc4a496de$export$2e2bcd8739ae039).language));
    }, []);
    (0, $acw62.useEffect)(()=>{
        if (window.matchMedia("(display-mode: standalone)").matches) {
            const appInstallationWasTracked = Boolean((0, $34dcbefa7de5eb80$export$11e63f7b0f3d9900)("appInstallationWasTracked"));
            if (!appInstallationWasTracked) {
                (0, $c74a0566d4b0fd6d$export$e9db7d6e73593439).track((0, $c74a0566d4b0fd6d$export$5e27155e276f6d1c).AppInstalledAsProgressive);
                (0, $34dcbefa7de5eb80$export$a1544dad697b423d)("appInstallationWasTracked", true);
            }
        }
        (0, $bd957970431a3ba0$export$b6ed00066e3625b3)();
    }, []);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $837d879502e60b4b$export$dcef8f9bb9a41431), {
                bodyAttributes: {
                    dir: layoutDirection
                },
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("script", {
                    children: `
(function(w,d,s,l,i){
  w[l] = w[l] || [];
  w[l].push({'gtm.start': new Date().getTime(),event:'gtm.js'});
  var f=d.getElementsByTagName(s)[0], j=d.createElement(s), dl=l!='dataLayer'?'&l='+l:'';
  j.async=true;
  j.src='https://www.googletagmanager.com/gtm.js?id='+i+dl;
  f.parentNode.insertBefore(j,f);
})(window,document,'script','dataLayer','GTM-TH7CQ4HN');`
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4671947198ddd366$export$6087095ff4170ca6), {
                value: $1c0cc537f6748418$export$6f57813fe9f31bf9,
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7df35e9df335b1c8$export$55185c17a0fcbe46), {
                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $acw62.Suspense), {
                        fallback: "Loading",
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4671947198ddd366$export$6087095ff4170ca6), {
                            value: $1c0cc537f6748418$export$6f57813fe9f31bf9,
                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f1c9cfb277e9691b$export$e926676385687eaf), {
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $392d2c14aa582458$export$68e3991a9ee3f43c), {
                                    isRtl: layoutDirection === "rtl",
                                    children: (0, $73ccb33f5de6f5aa$export$1d82b0dbb491a5f4)() ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $d3cd6208d6fe342f$export$e034111dc0cfe9e7), {}) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e83f55bc0ff8e1ae$export$11b7655053a12984), {})
                                })
                            })
                        })
                    })
                })
            })
        ]
    });
}
const $1c0cc537f6748418$var$root = (0, $7e96a608cb33bf79$export$882461b6382ed46c)(window.document.getElementById("root"));
$1c0cc537f6748418$var$root.render(/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($1c0cc537f6748418$export$86fbec116b87613f, {}));
(0, (/*@__PURE__*/$parcel$interopDefault($81292b5b491156fc$exports))).setAppElement("#root");
// to prevent noisy uncaught errors
window.addEventListener("error", (event)=>{
    if (event.error instanceof (0, $9ad33fbf770c55a1$export$f2e832acab1bdd79)) event.preventDefault();
});
var $0065b09a117807d6$exports = {};
$0065b09a117807d6$exports = new URL("sw.b40da156.js", import.meta.url).toString();


if ("serviceWorker" in navigator && !(0, $bsQZT.isLocalDevelopmentEnvironment)()) {
    const s = navigator.serviceWorker // Parcel workaround
    ;
    s.register(new URL($0065b09a117807d6$exports), {
        type: "module"
    }).then((registration)=>{
        return registration.update().then((updateResult)=>{
            fetch((0, $bsQZT.config).API_URL + (0, $kLorN.API_VERSION_URL), {
                method: "POST"
            });
        });
    }).catch((error)=>{
        console.error(`Registration failed with ${error}`);
    });
}


//# sourceMappingURL=index.0b81d5fc.js.map
